
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefd2b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefd2b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("61Ea1", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $4631fd20861f0b24$export$ffb0004e005737fa; });
$parcel$export(module.exports, "jsx", function () { return $4631fd20861f0b24$export$34b9dba7ce09269b; });
$parcel$export(module.exports, "jsxs", function () { return $4631fd20861f0b24$export$25062201e9e25d76; });

var $4TLFw = parcelRequire("4TLFw");

var $kjYAx = parcelRequire("kjYAx");
parcelRequire("jbmdS");
parcelRequire("bMPPJ");
parcelRequire("u6wRM");
parcelRequire("4O5LI");

parcelRequire("3RaBm");
parcelRequire("fvFHh");
parcelRequire("lkbnQ");
parcelRequire("cqJqj");
var $4631fd20861f0b24$export$ffb0004e005737fa = $4TLFw.Fragment;
function $4631fd20861f0b24$export$34b9dba7ce09269b(type, props, key) {
    if (!(0, $kjYAx.h).call(props, "css")) return $4TLFw.jsx(type, props, key);
    return $4TLFw.jsx((0, $kjYAx.E), (0, $kjYAx.c)(type, props), key);
}
function $4631fd20861f0b24$export$25062201e9e25d76(type, props, key) {
    if (!(0, $kjYAx.h).call(props, "css")) return $4TLFw.jsxs(type, props, key);
    return $4TLFw.jsxs((0, $kjYAx.E), (0, $kjYAx.c)(type, props), key);
}

});
parcelRegister("4TLFw", function(module, exports) {
"use strict";

module.exports = (parcelRequire("4QcvU"));

});
parcelRegister("4QcvU", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $3865b9ba1f267862$export$ffb0004e005737fa; }, function (v) { return $3865b9ba1f267862$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $3865b9ba1f267862$export$34b9dba7ce09269b; }, function (v) { return $3865b9ba1f267862$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $3865b9ba1f267862$export$25062201e9e25d76; }, function (v) { return $3865b9ba1f267862$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3865b9ba1f267862$export$ffb0004e005737fa;
var $3865b9ba1f267862$export$34b9dba7ce09269b;
var $3865b9ba1f267862$export$25062201e9e25d76;
"use strict";

var $jbmdS = parcelRequire("jbmdS");
var $3865b9ba1f267862$var$k = Symbol.for("react.element"), $3865b9ba1f267862$var$l = Symbol.for("react.fragment"), $3865b9ba1f267862$var$m = Object.prototype.hasOwnProperty, $3865b9ba1f267862$var$n = $jbmdS.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $3865b9ba1f267862$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $3865b9ba1f267862$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$3865b9ba1f267862$var$m.call(a, b) && !$3865b9ba1f267862$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $3865b9ba1f267862$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $3865b9ba1f267862$var$n.current
    };
}
$3865b9ba1f267862$export$ffb0004e005737fa = $3865b9ba1f267862$var$l;
$3865b9ba1f267862$export$34b9dba7ce09269b = $3865b9ba1f267862$var$q;
$3865b9ba1f267862$export$25062201e9e25d76 = $3865b9ba1f267862$var$q;

});
parcelRegister("jbmdS", function(module, exports) {
"use strict";

module.exports = (parcelRequire("eiGlA"));

});
parcelRegister("eiGlA", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $a6939860b2a3cbb2$export$dca3b0875bd9a954; }, function (v) { return $a6939860b2a3cbb2$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $a6939860b2a3cbb2$export$16fa2f45be04daa8; }, function (v) { return $a6939860b2a3cbb2$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $a6939860b2a3cbb2$export$ffb0004e005737fa; }, function (v) { return $a6939860b2a3cbb2$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $a6939860b2a3cbb2$export$e2c29f18771995cb; }, function (v) { return $a6939860b2a3cbb2$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $a6939860b2a3cbb2$export$221d75b3f55bb0bd; }, function (v) { return $a6939860b2a3cbb2$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $a6939860b2a3cbb2$export$5f8d39834fd61797; }, function (v) { return $a6939860b2a3cbb2$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $a6939860b2a3cbb2$export$74bf444e3cd11ea5; }, function (v) { return $a6939860b2a3cbb2$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $a6939860b2a3cbb2$export$ae55be85d98224ed; }, function (v) { return $a6939860b2a3cbb2$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $a6939860b2a3cbb2$export$3ba232387fd5d6dd; }, function (v) { return $a6939860b2a3cbb2$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $a6939860b2a3cbb2$export$e530037191fcd5d7; }, function (v) { return $a6939860b2a3cbb2$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $a6939860b2a3cbb2$export$fd42f52fd3ae1109; }, function (v) { return $a6939860b2a3cbb2$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $a6939860b2a3cbb2$export$c8a8987d4410bf2d; }, function (v) { return $a6939860b2a3cbb2$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $a6939860b2a3cbb2$export$d38cd72104c1f0e9; }, function (v) { return $a6939860b2a3cbb2$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $a6939860b2a3cbb2$export$7d1e3a5e95ceca43; }, function (v) { return $a6939860b2a3cbb2$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $a6939860b2a3cbb2$export$257a8862b851cb5b; }, function (v) { return $a6939860b2a3cbb2$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $a6939860b2a3cbb2$export$a8257692ac88316c; }, function (v) { return $a6939860b2a3cbb2$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $a6939860b2a3cbb2$export$488013bae63b21da; }, function (v) { return $a6939860b2a3cbb2$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $a6939860b2a3cbb2$export$7c73462e0d25e514; }, function (v) { return $a6939860b2a3cbb2$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $a6939860b2a3cbb2$export$7568632d0d33d16d; }, function (v) { return $a6939860b2a3cbb2$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $a6939860b2a3cbb2$export$88948ce120ea2619; }, function (v) { return $a6939860b2a3cbb2$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $a6939860b2a3cbb2$export$35808ee640e87ca7; }, function (v) { return $a6939860b2a3cbb2$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $a6939860b2a3cbb2$export$fae74005e78b1a27; }, function (v) { return $a6939860b2a3cbb2$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $a6939860b2a3cbb2$export$dc8fbce3eb94dc1e; }, function (v) { return $a6939860b2a3cbb2$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $a6939860b2a3cbb2$export$6a7bc4e911dc01cf; }, function (v) { return $a6939860b2a3cbb2$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $a6939860b2a3cbb2$export$6d9c69b0de29b591; }, function (v) { return $a6939860b2a3cbb2$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $a6939860b2a3cbb2$export$f680877a34711e37; }, function (v) { return $a6939860b2a3cbb2$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $a6939860b2a3cbb2$export$d5a552a76deda3c2; }, function (v) { return $a6939860b2a3cbb2$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $a6939860b2a3cbb2$export$aaabe4eda9ed9969; }, function (v) { return $a6939860b2a3cbb2$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $a6939860b2a3cbb2$export$e5c5a5f917a5871c; }, function (v) { return $a6939860b2a3cbb2$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $a6939860b2a3cbb2$export$1538c33de8887b59; }, function (v) { return $a6939860b2a3cbb2$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $a6939860b2a3cbb2$export$13e3392192263954; }, function (v) { return $a6939860b2a3cbb2$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $a6939860b2a3cbb2$export$b8f5890fc79d6aca; }, function (v) { return $a6939860b2a3cbb2$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $a6939860b2a3cbb2$export$60241385465d0a34; }, function (v) { return $a6939860b2a3cbb2$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $a6939860b2a3cbb2$export$306c0aa65ff9ec16; }, function (v) { return $a6939860b2a3cbb2$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $a6939860b2a3cbb2$export$7b286972b8d8ccbf; }, function (v) { return $a6939860b2a3cbb2$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $a6939860b2a3cbb2$export$83d89fbfd8236492; }, function (v) { return $a6939860b2a3cbb2$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a6939860b2a3cbb2$export$dca3b0875bd9a954;
var $a6939860b2a3cbb2$export$16fa2f45be04daa8;
var $a6939860b2a3cbb2$export$ffb0004e005737fa;
var $a6939860b2a3cbb2$export$e2c29f18771995cb;
var $a6939860b2a3cbb2$export$221d75b3f55bb0bd;
var $a6939860b2a3cbb2$export$5f8d39834fd61797;
var $a6939860b2a3cbb2$export$74bf444e3cd11ea5;
var $a6939860b2a3cbb2$export$ae55be85d98224ed;
var $a6939860b2a3cbb2$export$3ba232387fd5d6dd;
var $a6939860b2a3cbb2$export$e530037191fcd5d7;
var $a6939860b2a3cbb2$export$fd42f52fd3ae1109;
var $a6939860b2a3cbb2$export$c8a8987d4410bf2d;
var $a6939860b2a3cbb2$export$d38cd72104c1f0e9;
var $a6939860b2a3cbb2$export$7d1e3a5e95ceca43;
var $a6939860b2a3cbb2$export$257a8862b851cb5b;
var $a6939860b2a3cbb2$export$a8257692ac88316c;
var $a6939860b2a3cbb2$export$488013bae63b21da;
var $a6939860b2a3cbb2$export$7c73462e0d25e514;
var $a6939860b2a3cbb2$export$7568632d0d33d16d;
var $a6939860b2a3cbb2$export$88948ce120ea2619;
var $a6939860b2a3cbb2$export$35808ee640e87ca7;
var $a6939860b2a3cbb2$export$fae74005e78b1a27;
var $a6939860b2a3cbb2$export$dc8fbce3eb94dc1e;
var $a6939860b2a3cbb2$export$6a7bc4e911dc01cf;
var $a6939860b2a3cbb2$export$6d9c69b0de29b591;
var $a6939860b2a3cbb2$export$f680877a34711e37;
var $a6939860b2a3cbb2$export$d5a552a76deda3c2;
var $a6939860b2a3cbb2$export$aaabe4eda9ed9969;
var $a6939860b2a3cbb2$export$e5c5a5f917a5871c;
var $a6939860b2a3cbb2$export$1538c33de8887b59;
var $a6939860b2a3cbb2$export$13e3392192263954;
var $a6939860b2a3cbb2$export$b8f5890fc79d6aca;
var $a6939860b2a3cbb2$export$60241385465d0a34;
var $a6939860b2a3cbb2$export$306c0aa65ff9ec16;
var $a6939860b2a3cbb2$export$7b286972b8d8ccbf;
var $a6939860b2a3cbb2$export$83d89fbfd8236492;
"use strict";
var $a6939860b2a3cbb2$var$l = Symbol.for("react.element"), $a6939860b2a3cbb2$var$n = Symbol.for("react.portal"), $a6939860b2a3cbb2$var$p = Symbol.for("react.fragment"), $a6939860b2a3cbb2$var$q = Symbol.for("react.strict_mode"), $a6939860b2a3cbb2$var$r = Symbol.for("react.profiler"), $a6939860b2a3cbb2$var$t = Symbol.for("react.provider"), $a6939860b2a3cbb2$var$u = Symbol.for("react.context"), $a6939860b2a3cbb2$var$v = Symbol.for("react.forward_ref"), $a6939860b2a3cbb2$var$w = Symbol.for("react.suspense"), $a6939860b2a3cbb2$var$x = Symbol.for("react.memo"), $a6939860b2a3cbb2$var$y = Symbol.for("react.lazy"), $a6939860b2a3cbb2$var$z = Symbol.iterator;
function $a6939860b2a3cbb2$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $a6939860b2a3cbb2$var$z && a[$a6939860b2a3cbb2$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $a6939860b2a3cbb2$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $a6939860b2a3cbb2$var$C = Object.assign, $a6939860b2a3cbb2$var$D = {};
function $a6939860b2a3cbb2$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $a6939860b2a3cbb2$var$D;
    this.updater = e || $a6939860b2a3cbb2$var$B;
}
$a6939860b2a3cbb2$var$E.prototype.isReactComponent = {};
$a6939860b2a3cbb2$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$a6939860b2a3cbb2$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $a6939860b2a3cbb2$var$F() {}
$a6939860b2a3cbb2$var$F.prototype = $a6939860b2a3cbb2$var$E.prototype;
function $a6939860b2a3cbb2$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $a6939860b2a3cbb2$var$D;
    this.updater = e || $a6939860b2a3cbb2$var$B;
}
var $a6939860b2a3cbb2$var$H = $a6939860b2a3cbb2$var$G.prototype = new $a6939860b2a3cbb2$var$F;
$a6939860b2a3cbb2$var$H.constructor = $a6939860b2a3cbb2$var$G;
$a6939860b2a3cbb2$var$C($a6939860b2a3cbb2$var$H, $a6939860b2a3cbb2$var$E.prototype);
$a6939860b2a3cbb2$var$H.isPureReactComponent = !0;
var $a6939860b2a3cbb2$var$I = Array.isArray, $a6939860b2a3cbb2$var$J = Object.prototype.hasOwnProperty, $a6939860b2a3cbb2$var$K = {
    current: null
}, $a6939860b2a3cbb2$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $a6939860b2a3cbb2$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$a6939860b2a3cbb2$var$J.call(b, d) && !$a6939860b2a3cbb2$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $a6939860b2a3cbb2$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $a6939860b2a3cbb2$var$K.current
    };
}
function $a6939860b2a3cbb2$var$N(a, b) {
    return {
        $$typeof: $a6939860b2a3cbb2$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $a6939860b2a3cbb2$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $a6939860b2a3cbb2$var$l;
}
function $a6939860b2a3cbb2$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $a6939860b2a3cbb2$var$P = /\/+/g;
function $a6939860b2a3cbb2$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $a6939860b2a3cbb2$var$escape("" + a.key) : b.toString(36);
}
function $a6939860b2a3cbb2$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $a6939860b2a3cbb2$var$l:
                case $a6939860b2a3cbb2$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $a6939860b2a3cbb2$var$Q(h, 0) : d, $a6939860b2a3cbb2$var$I(c) ? (e = "", null != a && (e = a.replace($a6939860b2a3cbb2$var$P, "$&/") + "/"), $a6939860b2a3cbb2$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($a6939860b2a3cbb2$var$O(c) && (c = $a6939860b2a3cbb2$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($a6939860b2a3cbb2$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($a6939860b2a3cbb2$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $a6939860b2a3cbb2$var$Q(k, g);
        h += $a6939860b2a3cbb2$var$R(k, b, e, f, c);
    }
    else if (f = $a6939860b2a3cbb2$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $a6939860b2a3cbb2$var$Q(k, g++), h += $a6939860b2a3cbb2$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $a6939860b2a3cbb2$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $a6939860b2a3cbb2$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $a6939860b2a3cbb2$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $a6939860b2a3cbb2$var$U = {
    current: null
}, $a6939860b2a3cbb2$var$V = {
    transition: null
}, $a6939860b2a3cbb2$var$W = {
    ReactCurrentDispatcher: $a6939860b2a3cbb2$var$U,
    ReactCurrentBatchConfig: $a6939860b2a3cbb2$var$V,
    ReactCurrentOwner: $a6939860b2a3cbb2$var$K
};
function $a6939860b2a3cbb2$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$a6939860b2a3cbb2$export$dca3b0875bd9a954 = {
    map: $a6939860b2a3cbb2$var$S,
    forEach: function(a, b, e) {
        $a6939860b2a3cbb2$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $a6939860b2a3cbb2$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $a6939860b2a3cbb2$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$a6939860b2a3cbb2$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$a6939860b2a3cbb2$export$16fa2f45be04daa8 = $a6939860b2a3cbb2$var$E;
$a6939860b2a3cbb2$export$ffb0004e005737fa = $a6939860b2a3cbb2$var$p;
$a6939860b2a3cbb2$export$e2c29f18771995cb = $a6939860b2a3cbb2$var$r;
$a6939860b2a3cbb2$export$221d75b3f55bb0bd = $a6939860b2a3cbb2$var$G;
$a6939860b2a3cbb2$export$5f8d39834fd61797 = $a6939860b2a3cbb2$var$q;
$a6939860b2a3cbb2$export$74bf444e3cd11ea5 = $a6939860b2a3cbb2$var$w;
$a6939860b2a3cbb2$export$ae55be85d98224ed = $a6939860b2a3cbb2$var$W;
$a6939860b2a3cbb2$export$3ba232387fd5d6dd = $a6939860b2a3cbb2$var$X;
$a6939860b2a3cbb2$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $a6939860b2a3cbb2$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $a6939860b2a3cbb2$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$a6939860b2a3cbb2$var$J.call(b, f) && !$a6939860b2a3cbb2$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $a6939860b2a3cbb2$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$a6939860b2a3cbb2$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $a6939860b2a3cbb2$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $a6939860b2a3cbb2$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$a6939860b2a3cbb2$export$c8a8987d4410bf2d = $a6939860b2a3cbb2$var$M;
$a6939860b2a3cbb2$export$d38cd72104c1f0e9 = function(a) {
    var b = $a6939860b2a3cbb2$var$M.bind(null, a);
    b.type = a;
    return b;
};
$a6939860b2a3cbb2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$a6939860b2a3cbb2$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $a6939860b2a3cbb2$var$v,
        render: a
    };
};
$a6939860b2a3cbb2$export$a8257692ac88316c = $a6939860b2a3cbb2$var$O;
$a6939860b2a3cbb2$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $a6939860b2a3cbb2$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $a6939860b2a3cbb2$var$T
    };
};
$a6939860b2a3cbb2$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $a6939860b2a3cbb2$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$a6939860b2a3cbb2$export$7568632d0d33d16d = function(a) {
    var b = $a6939860b2a3cbb2$var$V.transition;
    $a6939860b2a3cbb2$var$V.transition = {};
    try {
        a();
    } finally{
        $a6939860b2a3cbb2$var$V.transition = b;
    }
};
$a6939860b2a3cbb2$export$88948ce120ea2619 = $a6939860b2a3cbb2$var$X;
$a6939860b2a3cbb2$export$35808ee640e87ca7 = function(a, b) {
    return $a6939860b2a3cbb2$var$U.current.useCallback(a, b);
};
$a6939860b2a3cbb2$export$fae74005e78b1a27 = function(a) {
    return $a6939860b2a3cbb2$var$U.current.useContext(a);
};
$a6939860b2a3cbb2$export$dc8fbce3eb94dc1e = function() {};
$a6939860b2a3cbb2$export$6a7bc4e911dc01cf = function(a) {
    return $a6939860b2a3cbb2$var$U.current.useDeferredValue(a);
};
$a6939860b2a3cbb2$export$6d9c69b0de29b591 = function(a, b) {
    return $a6939860b2a3cbb2$var$U.current.useEffect(a, b);
};
$a6939860b2a3cbb2$export$f680877a34711e37 = function() {
    return $a6939860b2a3cbb2$var$U.current.useId();
};
$a6939860b2a3cbb2$export$d5a552a76deda3c2 = function(a, b, e) {
    return $a6939860b2a3cbb2$var$U.current.useImperativeHandle(a, b, e);
};
$a6939860b2a3cbb2$export$aaabe4eda9ed9969 = function(a, b) {
    return $a6939860b2a3cbb2$var$U.current.useInsertionEffect(a, b);
};
$a6939860b2a3cbb2$export$e5c5a5f917a5871c = function(a, b) {
    return $a6939860b2a3cbb2$var$U.current.useLayoutEffect(a, b);
};
$a6939860b2a3cbb2$export$1538c33de8887b59 = function(a, b) {
    return $a6939860b2a3cbb2$var$U.current.useMemo(a, b);
};
$a6939860b2a3cbb2$export$13e3392192263954 = function(a, b, e) {
    return $a6939860b2a3cbb2$var$U.current.useReducer(a, b, e);
};
$a6939860b2a3cbb2$export$b8f5890fc79d6aca = function(a) {
    return $a6939860b2a3cbb2$var$U.current.useRef(a);
};
$a6939860b2a3cbb2$export$60241385465d0a34 = function(a) {
    return $a6939860b2a3cbb2$var$U.current.useState(a);
};
$a6939860b2a3cbb2$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $a6939860b2a3cbb2$var$U.current.useSyncExternalStore(a, b, e);
};
$a6939860b2a3cbb2$export$7b286972b8d8ccbf = function() {
    return $a6939860b2a3cbb2$var$U.current.useTransition();
};
$a6939860b2a3cbb2$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("kjYAx", function(module, exports) {

$parcel$export(module.exports, "a", function () { return $ecb49499532bde1c$export$407448d2b89b1813; });
$parcel$export(module.exports, "i", function () { return $ecb49499532bde1c$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "C", function () { return $ecb49499532bde1c$export$e7094788287c5e9b; });
$parcel$export(module.exports, "w", function () { return $ecb49499532bde1c$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $ecb49499532bde1c$export$971d5caa766a69d7; });
$parcel$export(module.exports, "h", function () { return $ecb49499532bde1c$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "c", function () { return $ecb49499532bde1c$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $ecb49499532bde1c$export$a9c23c6ac3fc3eca; });

var $jbmdS = parcelRequire("jbmdS");

var $bMPPJ = parcelRequire("bMPPJ");

var $7i29i = parcelRequire("7i29i");

var $4O5LI = parcelRequire("4O5LI");

var $Z0sel = parcelRequire("Z0sel");

var $fvFHh = parcelRequire("fvFHh");

var $lkbnQ = parcelRequire("lkbnQ");

var $cqJqj = parcelRequire("cqJqj");
var $ecb49499532bde1c$export$407448d2b89b1813 = false;
var $ecb49499532bde1c$export$23f2a1d2818174ef = typeof document !== "undefined";
/* import { type EmotionCache } from '@emotion/utils' */ var $ecb49499532bde1c$var$EmotionCacheContext = /* #__PURE__ */ $jbmdS.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $bMPPJ.default)({
    key: "css"
}) : null);
var $ecb49499532bde1c$export$e7094788287c5e9b = $ecb49499532bde1c$var$EmotionCacheContext.Provider;
var $ecb49499532bde1c$export$71511d61b312f219 = function useEmotionCache() /*: EmotionCache | null*/ {
    return (0, $jbmdS.useContext)($ecb49499532bde1c$var$EmotionCacheContext);
};
var $ecb49499532bde1c$export$efccba1c4a2ef57b = function withEmotionCache(func) /*: React.AbstractComponent<Props> */ {
    return /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $jbmdS.useContext)($ecb49499532bde1c$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$ecb49499532bde1c$export$23f2a1d2818174ef) $ecb49499532bde1c$export$efccba1c4a2ef57b = function withEmotionCache(func) /*: React.StatelessFunctionalComponent<Props> */ {
    return function(props) {
        var cache = (0, $jbmdS.useContext)($ecb49499532bde1c$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $bMPPJ.default)({
                key: "css"
            });
            return /*#__PURE__*/ $jbmdS.createElement($ecb49499532bde1c$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $ecb49499532bde1c$export$971d5caa766a69d7 = /* #__PURE__ */ $jbmdS.createContext({});
var $ecb49499532bde1c$export$3b14a55fb2447963 = function useTheme() {
    return $jbmdS.useContext($ecb49499532bde1c$export$971d5caa766a69d7);
};
var $ecb49499532bde1c$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $7i29i.default)({}, outerTheme, theme);
};
var $ecb49499532bde1c$var$createCacheWithTheme = /* #__PURE__ */ (0, $4O5LI.default)(function(outerTheme) {
    return (0, $4O5LI.default)(function(theme) {
        return $ecb49499532bde1c$var$getTheme(outerTheme, theme);
    });
});
/*
type ThemeProviderProps = {
  theme: Object | (Object => Object),
  children: React.Node
}
*/ var $ecb49499532bde1c$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $jbmdS.useContext($ecb49499532bde1c$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $ecb49499532bde1c$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $jbmdS.createElement($ecb49499532bde1c$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $ecb49499532bde1c$export$4368d992c4eafac0(Component) /*: React.AbstractComponent<$Diff<Config, { theme: Object }>> */ {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $jbmdS.useContext($ecb49499532bde1c$export$971d5caa766a69d7);
        return /*#__PURE__*/ $jbmdS.createElement(Component, (0, $7i29i.default)({
            theme: theme,
            ref: ref
        }, props));
    };
    var WithTheme = /*#__PURE__*/ $jbmdS.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $Z0sel.default)(WithTheme, Component);
}
var $ecb49499532bde1c$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $ecb49499532bde1c$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $ecb49499532bde1c$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($ecb49499532bde1c$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$ecb49499532bde1c$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $ecb49499532bde1c$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $fvFHh.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $cqJqj.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $fvFHh.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$ecb49499532bde1c$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $jbmdS.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $ecb49499532bde1c$var$Emotion = /* #__PURE__ */ $ecb49499532bde1c$export$efccba1c4a2ef57b(/* <any, any> */ function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$ecb49499532bde1c$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $fvFHh.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $lkbnQ.serializeStyles)(registeredStyles, undefined, $jbmdS.useContext($ecb49499532bde1c$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($ecb49499532bde1c$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $ecb49499532bde1c$var$typePropName && !$ecb49499532bde1c$export$407448d2b89b1813) newProps[key] = props[key];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $jbmdS.createElement($jbmdS.Fragment, null, /*#__PURE__*/ $jbmdS.createElement($ecb49499532bde1c$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $jbmdS.createElement(WrappedComponent, newProps));
});
var $ecb49499532bde1c$export$a9c23c6ac3fc3eca = $ecb49499532bde1c$var$Emotion;

});
parcelRegister("bMPPJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $894c62740fb5c8c3$export$2e2bcd8739ae039; });

var $97ZsF = parcelRequire("97ZsF");

var $dq7te = parcelRequire("dq7te");

var $cAcio = parcelRequire("cAcio");

var $65q85 = parcelRequire("65q85");
var $894c62740fb5c8c3$var$isBrowser = typeof document !== "undefined";
var $894c62740fb5c8c3$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $dq7te.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $dq7te.token)(character)) break;
        (0, $dq7te.next)();
    }
    return (0, $dq7te.slice)(begin, (0, $dq7te.position));
};
var $894c62740fb5c8c3$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $dq7te.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $dq7te.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $894c62740fb5c8c3$var$identifierWithPointTracking((0, $dq7te.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $dq7te.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $dq7te.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $dq7te.from)(character);
    }
    while (character = (0, $dq7te.next)());
    return parsed;
};
var $894c62740fb5c8c3$var$getRules = function getRules(value, points) {
    return (0, $dq7te.dealloc)($894c62740fb5c8c3$var$toRules((0, $dq7te.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $894c62740fb5c8c3$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $894c62740fb5c8c3$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$894c62740fb5c8c3$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $894c62740fb5c8c3$var$fixedElements.set(element, true);
    var points = [];
    var rules = $894c62740fb5c8c3$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $894c62740fb5c8c3$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
/* eslint-disable no-fallthrough */ function $894c62740fb5c8c3$var$prefix(value, length) {
    switch((0, $dq7te.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $dq7te.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $dq7te.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $dq7te.WEBKIT) + value + (0, $dq7te.MOZ) + value + (0, $dq7te.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $dq7te.WEBKIT) + value + (0, $dq7te.MS) + value + value;
        // order
        case 6165:
            return (0, $dq7te.WEBKIT) + value + (0, $dq7te.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $dq7te.WEBKIT) + value + (0, $dq7te.replace)(value, /(\w+).+(:[^]+)/, (0, $dq7te.WEBKIT) + "box-$1$2" + (0, $dq7te.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $dq7te.WEBKIT) + value + (0, $dq7te.MS) + "flex-item-" + (0, $dq7te.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $dq7te.WEBKIT) + value + (0, $dq7te.MS) + "flex-line-pack" + (0, $dq7te.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $dq7te.WEBKIT) + value + (0, $dq7te.MS) + (0, $dq7te.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $dq7te.WEBKIT) + value + (0, $dq7te.MS) + (0, $dq7te.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $dq7te.WEBKIT) + "box-" + (0, $dq7te.replace)(value, "-grow", "") + (0, $dq7te.WEBKIT) + value + (0, $dq7te.MS) + (0, $dq7te.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $dq7te.WEBKIT) + (0, $dq7te.replace)(value, /([^-])(transform)/g, "$1" + (0, $dq7te.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $dq7te.replace)((0, $dq7te.replace)((0, $dq7te.replace)(value, /(zoom-|grab)/, (0, $dq7te.WEBKIT) + "$1"), /(image-set)/, (0, $dq7te.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $dq7te.replace)(value, /(image-set\([^]*)/, (0, $dq7te.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $dq7te.replace)((0, $dq7te.replace)(value, /(.+:)(flex-)?(.*)/, (0, $dq7te.WEBKIT) + "box-pack:$3" + (0, $dq7te.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $dq7te.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $dq7te.replace)(value, /(.+)-inline(.+)/, (0, $dq7te.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $dq7te.strlen)(value) - 1 - length > 6) switch((0, $dq7te.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $dq7te.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $dq7te.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $dq7te.WEBKIT) + "$2-$3" + "$1" + (0, $dq7te.MOZ) + ((0, $dq7te.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $dq7te.indexof)(value, "stretch") ? $894c62740fb5c8c3$var$prefix((0, $dq7te.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $dq7te.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $dq7te.charat)(value, (0, $dq7te.strlen)(value) - 3 - (~(0, $dq7te.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $dq7te.replace)(value, ":", ":" + (0, $dq7te.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $dq7te.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $dq7te.WEBKIT) + ((0, $dq7te.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $dq7te.WEBKIT) + "$2$3" + "$1" + (0, $dq7te.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $dq7te.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $dq7te.WEBKIT) + value + (0, $dq7te.MS) + (0, $dq7te.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $dq7te.WEBKIT) + value + (0, $dq7te.MS) + (0, $dq7te.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $dq7te.WEBKIT) + value + (0, $dq7te.MS) + (0, $dq7te.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $dq7te.WEBKIT) + value + (0, $dq7te.MS) + value + value;
    }
    return value;
}
var $894c62740fb5c8c3$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $dq7te.DECLARATION:
                element["return"] = $894c62740fb5c8c3$var$prefix(element.value, element.length);
                break;
            case 0, $dq7te.KEYFRAMES:
                return (0, $dq7te.serialize)([
                    (0, $dq7te.copy)(element, {
                        value: (0, $dq7te.replace)(element.value, "@", "@" + (0, $dq7te.WEBKIT))
                    })
                ], callback);
            case 0, $dq7te.RULESET:
                if (element.length) return (0, $dq7te.combine)(element.props, function(value) {
                    switch((0, $dq7te.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $dq7te.serialize)([
                                (0, $dq7te.copy)(element, {
                                    props: [
                                        (0, $dq7te.replace)(value, /:(read-\w+)/, ":" + (0, $dq7te.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $dq7te.serialize)([
                                (0, $dq7te.copy)(element, {
                                    props: [
                                        (0, $dq7te.replace)(value, /:(plac\w+)/, ":" + (0, $dq7te.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $dq7te.copy)(element, {
                                    props: [
                                        (0, $dq7te.replace)(value, /:(plac\w+)/, ":" + (0, $dq7te.MOZ) + "$1")
                                    ]
                                }),
                                (0, $dq7te.copy)(element, {
                                    props: [
                                        (0, $dq7te.replace)(value, /:(plac\w+)/, (0, $dq7te.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
/* import type { StylisPlugin } from './types' */ /*
export type Options = {
  nonce?: string,
  stylisPlugins?: StylisPlugin[],
  key: string,
  container?: HTMLElement,
  speedy?: boolean,
  prepend?: boolean,
  insertionPoint?: HTMLElement
}
*/ var $894c62740fb5c8c3$var$getServerStylisCache = $894c62740fb5c8c3$var$isBrowser ? undefined : (0, $cAcio.default)(function() {
    return (0, $65q85.default)(function() {
        var cache = {};
        return function(name) {
            return cache[name];
        };
    });
});
var $894c62740fb5c8c3$var$defaultStylisPlugins = [
    $894c62740fb5c8c3$var$prefixer
];
var $894c62740fb5c8c3$export$2e2bcd8739ae039 = function /*: EmotionCache */ createCache(options) {
    var key = options.key;
    if ($894c62740fb5c8c3$var$isBrowser && key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $894c62740fb5c8c3$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    /* : Node */ var nodesToHydrate = [];
    if ($894c62740fb5c8c3$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
            var attrib = node.getAttribute("data-emotion").split(" ");
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    /*: (
  selector: string,
  serialized: SerializedStyles,
  sheet: StyleSheet,
  shouldCache: boolean
  ) => string | void */ var omnipresentPlugins = [
        $894c62740fb5c8c3$var$compat,
        $894c62740fb5c8c3$var$removeLabel
    ];
    if ($894c62740fb5c8c3$var$isBrowser) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $dq7te.stringify),
            (0, $dq7te.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $dq7te.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $dq7te.serialize)((0, $dq7te.compile)(styles), serializer);
        };
        _insert = function /*: void */ insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $dq7te.stringify)
        ];
        var _serializer = (0, $dq7te.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $dq7te.serialize)((0, $dq7te.compile)(styles), _serializer);
        };
        var serverStylisCache = $894c62740fb5c8c3$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function /*: string */ getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function /*: string | void */ _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $97ZsF.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("97ZsF", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $6a54716ee9e0d5ec$export$9d753cd7ae895cce; });
var $6a54716ee9e0d5ec$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $6a54716ee9e0d5ec$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $6a54716ee9e0d5ec$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $6a54716ee9e0d5ec$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$6a54716ee9e0d5ec$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($6a54716ee9e0d5ec$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $6a54716ee9e0d5ec$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("dq7te", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $c4521a61c2f340ba$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $c4521a61c2f340ba$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $c4521a61c2f340ba$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $c4521a61c2f340ba$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $c4521a61c2f340ba$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $c4521a61c2f340ba$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $c4521a61c2f340ba$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $c4521a61c2f340ba$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $c4521a61c2f340ba$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $c4521a61c2f340ba$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $c4521a61c2f340ba$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $c4521a61c2f340ba$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $c4521a61c2f340ba$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $c4521a61c2f340ba$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $c4521a61c2f340ba$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $c4521a61c2f340ba$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $c4521a61c2f340ba$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $c4521a61c2f340ba$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $c4521a61c2f340ba$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $c4521a61c2f340ba$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $c4521a61c2f340ba$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $c4521a61c2f340ba$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $c4521a61c2f340ba$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $c4521a61c2f340ba$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $c4521a61c2f340ba$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $c4521a61c2f340ba$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $c4521a61c2f340ba$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $c4521a61c2f340ba$export$38bcb760f1d4871c; });
var $c4521a61c2f340ba$export$71ad59f2e432cfe8 = "-ms-";
var $c4521a61c2f340ba$export$2c0f367103c8d01c = "-moz-";
var $c4521a61c2f340ba$export$39dfd62a25e0fe93 = "-webkit-";
var $c4521a61c2f340ba$export$a29989082612d0d9 = "comm";
var $c4521a61c2f340ba$export$aa3a2e812ca8570d = "rule";
var $c4521a61c2f340ba$export$527d108ccf083c2b = "decl";
var $c4521a61c2f340ba$export$d3d35020fa5b54f0 = "@page";
var $c4521a61c2f340ba$export$500415a86c544f73 = "@media";
var $c4521a61c2f340ba$export$a763edbf796b780a = "@import";
var $c4521a61c2f340ba$export$2790aeb8b4e5c826 = "@charset";
var $c4521a61c2f340ba$export$1cc683e23b84b133 = "@viewport";
var $c4521a61c2f340ba$export$9447a5efea57e862 = "@supports";
var $c4521a61c2f340ba$export$ef011b4e114b1fba = "@document";
var $c4521a61c2f340ba$export$6aad947bda0f3f46 = "@namespace";
var $c4521a61c2f340ba$export$b44a8529a35fcb60 = "@keyframes";
var $c4521a61c2f340ba$export$2c16de31893252e6 = "@font-face";
var $c4521a61c2f340ba$export$3d846dd52e150c6f = "@counter-style";
var $c4521a61c2f340ba$export$22314bfbb57653fe = "@font-feature-values";
var $c4521a61c2f340ba$export$d773506282b3cfe6 = "@layer";
var $c4521a61c2f340ba$export$2335f513bbd82c6d = Math.abs;
var $c4521a61c2f340ba$export$6788812c4e6611e6 = String.fromCharCode;
var $c4521a61c2f340ba$export$e6e34fd1f2686227 = Object.assign;
function $c4521a61c2f340ba$export$d6af199866bfb566(e, r) {
    return $c4521a61c2f340ba$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $c4521a61c2f340ba$export$a9db5e087081082d(e, 0)) << 2 ^ $c4521a61c2f340ba$export$a9db5e087081082d(e, 1)) << 2 ^ $c4521a61c2f340ba$export$a9db5e087081082d(e, 2)) << 2 ^ $c4521a61c2f340ba$export$a9db5e087081082d(e, 3) : 0;
}
function $c4521a61c2f340ba$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $c4521a61c2f340ba$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $c4521a61c2f340ba$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $c4521a61c2f340ba$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $c4521a61c2f340ba$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $c4521a61c2f340ba$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $c4521a61c2f340ba$export$36776f635604f274(e) {
    return e.length;
}
function $c4521a61c2f340ba$export$f9084667e487ed46(e) {
    return e.length;
}
function $c4521a61c2f340ba$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $c4521a61c2f340ba$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $c4521a61c2f340ba$export$53f1d5ea8de3d7c = 1;
var $c4521a61c2f340ba$export$4e0c71f277ca26b3 = 1;
var $c4521a61c2f340ba$export$f24224f1c91d8156 = 0;
var $c4521a61c2f340ba$export$5880b8b5730aff45 = 0;
var $c4521a61c2f340ba$export$c0306caf338ac095 = 0;
var $c4521a61c2f340ba$export$30a86d91af8ff6e6 = "";
function $c4521a61c2f340ba$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $c4521a61c2f340ba$export$53f1d5ea8de3d7c,
        column: $c4521a61c2f340ba$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $c4521a61c2f340ba$export$784d13d8ee351f07(e, r) {
    return $c4521a61c2f340ba$export$e6e34fd1f2686227($c4521a61c2f340ba$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $c4521a61c2f340ba$export$eba6f6f03b0a92e7() {
    return $c4521a61c2f340ba$export$c0306caf338ac095;
}
function $c4521a61c2f340ba$export$232faf9add678146() {
    $c4521a61c2f340ba$export$c0306caf338ac095 = $c4521a61c2f340ba$export$5880b8b5730aff45 > 0 ? $c4521a61c2f340ba$export$a9db5e087081082d($c4521a61c2f340ba$export$30a86d91af8ff6e6, --$c4521a61c2f340ba$export$5880b8b5730aff45) : 0;
    if ($c4521a61c2f340ba$export$4e0c71f277ca26b3--, $c4521a61c2f340ba$export$c0306caf338ac095 === 10) $c4521a61c2f340ba$export$4e0c71f277ca26b3 = 1, $c4521a61c2f340ba$export$53f1d5ea8de3d7c--;
    return $c4521a61c2f340ba$export$c0306caf338ac095;
}
function $c4521a61c2f340ba$export$48cfd1e771a65c4f() {
    $c4521a61c2f340ba$export$c0306caf338ac095 = $c4521a61c2f340ba$export$5880b8b5730aff45 < $c4521a61c2f340ba$export$f24224f1c91d8156 ? $c4521a61c2f340ba$export$a9db5e087081082d($c4521a61c2f340ba$export$30a86d91af8ff6e6, $c4521a61c2f340ba$export$5880b8b5730aff45++) : 0;
    if ($c4521a61c2f340ba$export$4e0c71f277ca26b3++, $c4521a61c2f340ba$export$c0306caf338ac095 === 10) $c4521a61c2f340ba$export$4e0c71f277ca26b3 = 1, $c4521a61c2f340ba$export$53f1d5ea8de3d7c++;
    return $c4521a61c2f340ba$export$c0306caf338ac095;
}
function $c4521a61c2f340ba$export$4d3fb11e950abb9e() {
    return $c4521a61c2f340ba$export$a9db5e087081082d($c4521a61c2f340ba$export$30a86d91af8ff6e6, $c4521a61c2f340ba$export$5880b8b5730aff45);
}
function $c4521a61c2f340ba$export$e88cb2efb12ae807() {
    return $c4521a61c2f340ba$export$5880b8b5730aff45;
}
function $c4521a61c2f340ba$export$58adb3bec8346d0f(e, r) {
    return $c4521a61c2f340ba$export$2f35ab04d2335697($c4521a61c2f340ba$export$30a86d91af8ff6e6, e, r);
}
function $c4521a61c2f340ba$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $c4521a61c2f340ba$export$2de70f21292aac9e(e) {
    return $c4521a61c2f340ba$export$53f1d5ea8de3d7c = $c4521a61c2f340ba$export$4e0c71f277ca26b3 = 1, $c4521a61c2f340ba$export$f24224f1c91d8156 = $c4521a61c2f340ba$export$36776f635604f274($c4521a61c2f340ba$export$30a86d91af8ff6e6 = e), $c4521a61c2f340ba$export$5880b8b5730aff45 = 0, [];
}
function $c4521a61c2f340ba$export$45918ac1574455b1(e) {
    return $c4521a61c2f340ba$export$30a86d91af8ff6e6 = "", e;
}
function $c4521a61c2f340ba$export$410ac95b9ec204b8(e) {
    return $c4521a61c2f340ba$export$87c2784dc9fc4ab($c4521a61c2f340ba$export$58adb3bec8346d0f($c4521a61c2f340ba$export$5880b8b5730aff45 - 1, $c4521a61c2f340ba$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $c4521a61c2f340ba$export$660b2ee2d4fb4eff(e) {
    return $c4521a61c2f340ba$export$45918ac1574455b1($c4521a61c2f340ba$export$5f8c09e3ae6f64e1($c4521a61c2f340ba$export$2de70f21292aac9e(e)));
}
function $c4521a61c2f340ba$export$7af1228ff777d175(e) {
    while($c4521a61c2f340ba$export$c0306caf338ac095 = $c4521a61c2f340ba$export$4d3fb11e950abb9e())if ($c4521a61c2f340ba$export$c0306caf338ac095 < 33) $c4521a61c2f340ba$export$48cfd1e771a65c4f();
    else break;
    return $c4521a61c2f340ba$export$9e1725a4cfeada27(e) > 2 || $c4521a61c2f340ba$export$9e1725a4cfeada27($c4521a61c2f340ba$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $c4521a61c2f340ba$export$5f8c09e3ae6f64e1(e) {
    while($c4521a61c2f340ba$export$48cfd1e771a65c4f())switch($c4521a61c2f340ba$export$9e1725a4cfeada27($c4521a61c2f340ba$export$c0306caf338ac095)){
        case 0:
            $c4521a61c2f340ba$export$10d8903dec122b9d($c4521a61c2f340ba$export$c2ab62c7bf24634($c4521a61c2f340ba$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $c4521a61c2f340ba$export$10d8903dec122b9d($c4521a61c2f340ba$export$410ac95b9ec204b8($c4521a61c2f340ba$export$c0306caf338ac095), e);
            break;
        default:
            $c4521a61c2f340ba$export$10d8903dec122b9d($c4521a61c2f340ba$export$6788812c4e6611e6($c4521a61c2f340ba$export$c0306caf338ac095), e);
    }
    return e;
}
function $c4521a61c2f340ba$export$955ba06d119e085e(e, r) {
    while(--r && $c4521a61c2f340ba$export$48cfd1e771a65c4f())if ($c4521a61c2f340ba$export$c0306caf338ac095 < 48 || $c4521a61c2f340ba$export$c0306caf338ac095 > 102 || $c4521a61c2f340ba$export$c0306caf338ac095 > 57 && $c4521a61c2f340ba$export$c0306caf338ac095 < 65 || $c4521a61c2f340ba$export$c0306caf338ac095 > 70 && $c4521a61c2f340ba$export$c0306caf338ac095 < 97) break;
    return $c4521a61c2f340ba$export$58adb3bec8346d0f(e, $c4521a61c2f340ba$export$e88cb2efb12ae807() + (r < 6 && $c4521a61c2f340ba$export$4d3fb11e950abb9e() == 32 && $c4521a61c2f340ba$export$48cfd1e771a65c4f() == 32));
}
function $c4521a61c2f340ba$export$c889f2fcc19dbf12(e) {
    while($c4521a61c2f340ba$export$48cfd1e771a65c4f())switch($c4521a61c2f340ba$export$c0306caf338ac095){
        case e:
            return $c4521a61c2f340ba$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $c4521a61c2f340ba$export$c889f2fcc19dbf12($c4521a61c2f340ba$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $c4521a61c2f340ba$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $c4521a61c2f340ba$export$48cfd1e771a65c4f();
            break;
    }
    return $c4521a61c2f340ba$export$5880b8b5730aff45;
}
function $c4521a61c2f340ba$export$4254d4e2b3745c4c(e, r) {
    while($c4521a61c2f340ba$export$48cfd1e771a65c4f())if (e + $c4521a61c2f340ba$export$c0306caf338ac095 === 57) break;
    else if (e + $c4521a61c2f340ba$export$c0306caf338ac095 === 84 && $c4521a61c2f340ba$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $c4521a61c2f340ba$export$58adb3bec8346d0f(r, $c4521a61c2f340ba$export$5880b8b5730aff45 - 1) + "*" + $c4521a61c2f340ba$export$6788812c4e6611e6(e === 47 ? e : $c4521a61c2f340ba$export$48cfd1e771a65c4f());
}
function $c4521a61c2f340ba$export$c2ab62c7bf24634(e) {
    while(!$c4521a61c2f340ba$export$9e1725a4cfeada27($c4521a61c2f340ba$export$4d3fb11e950abb9e()))$c4521a61c2f340ba$export$48cfd1e771a65c4f();
    return $c4521a61c2f340ba$export$58adb3bec8346d0f(e, $c4521a61c2f340ba$export$5880b8b5730aff45);
}
function $c4521a61c2f340ba$export$ef7acd7185315e22(e) {
    return $c4521a61c2f340ba$export$45918ac1574455b1($c4521a61c2f340ba$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $c4521a61c2f340ba$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $c4521a61c2f340ba$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $c4521a61c2f340ba$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $c4521a61c2f340ba$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($c4521a61c2f340ba$export$f8e21b1e77979a08(j += $c4521a61c2f340ba$export$77ad94ebf1c2b9ed($c4521a61c2f340ba$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $c4521a61c2f340ba$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $c4521a61c2f340ba$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $c4521a61c2f340ba$export$955ba06d119e085e($c4521a61c2f340ba$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($c4521a61c2f340ba$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $c4521a61c2f340ba$export$10d8903dec122b9d($c4521a61c2f340ba$export$4a34f930e789283c($c4521a61c2f340ba$export$4254d4e2b3745c4c($c4521a61c2f340ba$export$48cfd1e771a65c4f(), $c4521a61c2f340ba$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $c4521a61c2f340ba$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $c4521a61c2f340ba$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $c4521a61c2f340ba$export$36776f635604f274(j) - l) $c4521a61c2f340ba$export$10d8903dec122b9d(p > 32 ? $c4521a61c2f340ba$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $c4521a61c2f340ba$export$f8483753829ec8f3($c4521a61c2f340ba$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $c4521a61c2f340ba$export$10d8903dec122b9d(y = $c4521a61c2f340ba$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $c4521a61c2f340ba$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $c4521a61c2f340ba$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $c4521a61c2f340ba$export$98e6a39c04603d36(e, y, y, n && $c4521a61c2f340ba$export$10d8903dec122b9d($c4521a61c2f340ba$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $c4521a61c2f340ba$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $c4521a61c2f340ba$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $c4521a61c2f340ba$export$232faf9add678146() == 125) continue;
            }
            switch(j += $c4521a61c2f340ba$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($c4521a61c2f340ba$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($c4521a61c2f340ba$export$4d3fb11e950abb9e() === 45) j += $c4521a61c2f340ba$export$410ac95b9ec204b8($c4521a61c2f340ba$export$48cfd1e771a65c4f());
                    v = $c4521a61c2f340ba$export$4d3fb11e950abb9e(), o = l = $c4521a61c2f340ba$export$36776f635604f274(g = j += $c4521a61c2f340ba$export$c2ab62c7bf24634($c4521a61c2f340ba$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $c4521a61c2f340ba$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $c4521a61c2f340ba$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $c4521a61c2f340ba$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $c4521a61c2f340ba$export$2f35ab04d2335697(e, v + 1, v = $c4521a61c2f340ba$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $c4521a61c2f340ba$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $c4521a61c2f340ba$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $c4521a61c2f340ba$export$35059013cd4a06db(e, r, a, s === 0 ? $c4521a61c2f340ba$export$aa3a2e812ca8570d : i, f, o, l);
}
function $c4521a61c2f340ba$export$4a34f930e789283c(e, r, a) {
    return $c4521a61c2f340ba$export$35059013cd4a06db(e, r, a, $c4521a61c2f340ba$export$a29989082612d0d9, $c4521a61c2f340ba$export$6788812c4e6611e6($c4521a61c2f340ba$export$eba6f6f03b0a92e7()), $c4521a61c2f340ba$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $c4521a61c2f340ba$export$f8483753829ec8f3(e, r, a, n) {
    return $c4521a61c2f340ba$export$35059013cd4a06db(e, r, a, $c4521a61c2f340ba$export$527d108ccf083c2b, $c4521a61c2f340ba$export$2f35ab04d2335697(e, 0, n), $c4521a61c2f340ba$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $c4521a61c2f340ba$export$82e9f45cca5ba907(n, c, s) {
    switch($c4521a61c2f340ba$export$d6af199866bfb566(n, c)){
        case 5103:
            return $c4521a61c2f340ba$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $c4521a61c2f340ba$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $c4521a61c2f340ba$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $c4521a61c2f340ba$export$39dfd62a25e0fe93 + n + $c4521a61c2f340ba$export$2c0f367103c8d01c + n + $c4521a61c2f340ba$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($c4521a61c2f340ba$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $c4521a61c2f340ba$export$39dfd62a25e0fe93 + n + $c4521a61c2f340ba$export$71ad59f2e432cfe8 + $c4521a61c2f340ba$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $c4521a61c2f340ba$export$39dfd62a25e0fe93 + n + $c4521a61c2f340ba$export$71ad59f2e432cfe8 + $c4521a61c2f340ba$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $c4521a61c2f340ba$export$39dfd62a25e0fe93 + n + $c4521a61c2f340ba$export$71ad59f2e432cfe8 + $c4521a61c2f340ba$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $c4521a61c2f340ba$export$39dfd62a25e0fe93 + n + $c4521a61c2f340ba$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $c4521a61c2f340ba$export$39dfd62a25e0fe93 + n + $c4521a61c2f340ba$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $c4521a61c2f340ba$export$39dfd62a25e0fe93 + n + $c4521a61c2f340ba$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $c4521a61c2f340ba$export$39dfd62a25e0fe93 + "box-$1$2" + $c4521a61c2f340ba$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $c4521a61c2f340ba$export$39dfd62a25e0fe93 + n + $c4521a61c2f340ba$export$71ad59f2e432cfe8 + "flex-item-" + $c4521a61c2f340ba$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$c4521a61c2f340ba$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $c4521a61c2f340ba$export$71ad59f2e432cfe8 + "grid-row-" + $c4521a61c2f340ba$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $c4521a61c2f340ba$export$39dfd62a25e0fe93 + n + $c4521a61c2f340ba$export$71ad59f2e432cfe8 + "flex-line-pack" + $c4521a61c2f340ba$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $c4521a61c2f340ba$export$39dfd62a25e0fe93 + n + $c4521a61c2f340ba$export$71ad59f2e432cfe8 + $c4521a61c2f340ba$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $c4521a61c2f340ba$export$39dfd62a25e0fe93 + n + $c4521a61c2f340ba$export$71ad59f2e432cfe8 + $c4521a61c2f340ba$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $c4521a61c2f340ba$export$39dfd62a25e0fe93 + "box-" + $c4521a61c2f340ba$export$77ad94ebf1c2b9ed(n, "-grow", "") + $c4521a61c2f340ba$export$39dfd62a25e0fe93 + n + $c4521a61c2f340ba$export$71ad59f2e432cfe8 + $c4521a61c2f340ba$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $c4521a61c2f340ba$export$39dfd62a25e0fe93 + $c4521a61c2f340ba$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $c4521a61c2f340ba$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $c4521a61c2f340ba$export$77ad94ebf1c2b9ed($c4521a61c2f340ba$export$77ad94ebf1c2b9ed($c4521a61c2f340ba$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $c4521a61c2f340ba$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $c4521a61c2f340ba$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $c4521a61c2f340ba$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $c4521a61c2f340ba$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $c4521a61c2f340ba$export$77ad94ebf1c2b9ed($c4521a61c2f340ba$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $c4521a61c2f340ba$export$39dfd62a25e0fe93 + "box-pack:$3" + $c4521a61c2f340ba$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $c4521a61c2f340ba$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$c4521a61c2f340ba$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $c4521a61c2f340ba$export$71ad59f2e432cfe8 + "grid-column-align" + $c4521a61c2f340ba$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $c4521a61c2f340ba$export$71ad59f2e432cfe8 + $c4521a61c2f340ba$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $c4521a61c2f340ba$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$c4521a61c2f340ba$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $c4521a61c2f340ba$export$71ad59f2e432cfe8 + $c4521a61c2f340ba$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $c4521a61c2f340ba$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$c4521a61c2f340ba$export$f8e21b1e77979a08(s, "span") ? $c4521a61c2f340ba$export$4659b591c19bdf3d(s, /\d+/) : +$c4521a61c2f340ba$export$4659b591c19bdf3d(s, /\d+/) - +$c4521a61c2f340ba$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $c4521a61c2f340ba$export$71ad59f2e432cfe8 + $c4521a61c2f340ba$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $c4521a61c2f340ba$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $c4521a61c2f340ba$export$71ad59f2e432cfe8 + $c4521a61c2f340ba$export$77ad94ebf1c2b9ed($c4521a61c2f340ba$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $c4521a61c2f340ba$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $c4521a61c2f340ba$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($c4521a61c2f340ba$export$36776f635604f274(n) - 1 - c > 6) switch($c4521a61c2f340ba$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($c4521a61c2f340ba$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $c4521a61c2f340ba$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $c4521a61c2f340ba$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $c4521a61c2f340ba$export$2c0f367103c8d01c + ($c4521a61c2f340ba$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$c4521a61c2f340ba$export$f8e21b1e77979a08(n, "stretch") ? $c4521a61c2f340ba$export$82e9f45cca5ba907($c4521a61c2f340ba$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $c4521a61c2f340ba$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $c4521a61c2f340ba$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $c4521a61c2f340ba$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($c4521a61c2f340ba$export$a9db5e087081082d(n, c + 6) === 121) return $c4521a61c2f340ba$export$77ad94ebf1c2b9ed(n, ":", ":" + $c4521a61c2f340ba$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($c4521a61c2f340ba$export$a9db5e087081082d(n, $c4521a61c2f340ba$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $c4521a61c2f340ba$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $c4521a61c2f340ba$export$39dfd62a25e0fe93 + ($c4521a61c2f340ba$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $c4521a61c2f340ba$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $c4521a61c2f340ba$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $c4521a61c2f340ba$export$77ad94ebf1c2b9ed(n, ":", ":" + $c4521a61c2f340ba$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $c4521a61c2f340ba$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $c4521a61c2f340ba$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $c4521a61c2f340ba$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $c4521a61c2f340ba$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $c4521a61c2f340ba$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $c4521a61c2f340ba$export$a763edbf796b780a:
        case $c4521a61c2f340ba$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $c4521a61c2f340ba$export$a29989082612d0d9:
            return "";
        case $c4521a61c2f340ba$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $c4521a61c2f340ba$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $c4521a61c2f340ba$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $c4521a61c2f340ba$export$36776f635604f274(a = $c4521a61c2f340ba$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $c4521a61c2f340ba$export$5a7767152ae0305f(e) {
    var r = $c4521a61c2f340ba$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $c4521a61c2f340ba$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $c4521a61c2f340ba$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $c4521a61c2f340ba$export$527d108ccf083c2b:
                n.return = $c4521a61c2f340ba$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $c4521a61c2f340ba$export$b44a8529a35fcb60:
                return $c4521a61c2f340ba$export$dfdc1655ccc5b9cb([
                    $c4521a61c2f340ba$export$784d13d8ee351f07(n, {
                        value: $c4521a61c2f340ba$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $c4521a61c2f340ba$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $c4521a61c2f340ba$export$aa3a2e812ca8570d:
                if (n.length) return $c4521a61c2f340ba$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($c4521a61c2f340ba$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $c4521a61c2f340ba$export$dfdc1655ccc5b9cb([
                                $c4521a61c2f340ba$export$784d13d8ee351f07(n, {
                                    props: [
                                        $c4521a61c2f340ba$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $c4521a61c2f340ba$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $c4521a61c2f340ba$export$dfdc1655ccc5b9cb([
                                $c4521a61c2f340ba$export$784d13d8ee351f07(n, {
                                    props: [
                                        $c4521a61c2f340ba$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $c4521a61c2f340ba$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $c4521a61c2f340ba$export$784d13d8ee351f07(n, {
                                    props: [
                                        $c4521a61c2f340ba$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $c4521a61c2f340ba$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $c4521a61c2f340ba$export$784d13d8ee351f07(n, {
                                    props: [
                                        $c4521a61c2f340ba$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $c4521a61c2f340ba$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $c4521a61c2f340ba$export$76a88f7de6507443(e) {
    switch(e.type){
        case $c4521a61c2f340ba$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $c4521a61c2f340ba$export$1be1fc439b849fdf($c4521a61c2f340ba$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($c4521a61c2f340ba$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $c4521a61c2f340ba$export$2f35ab04d2335697(r, 1, $c4521a61c2f340ba$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $c4521a61c2f340ba$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $c4521a61c2f340ba$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $c4521a61c2f340ba$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("cAcio", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $929262779b3b8792$export$2e2bcd8739ae039; });
var $929262779b3b8792$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("65q85", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46e77a77734490d8$export$2e2bcd8739ae039; });
function $46e77a77734490d8$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("7i29i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54ebe19487a173a2$export$2e2bcd8739ae039; });
function $54ebe19487a173a2$export$2e2bcd8739ae039() {
    return $54ebe19487a173a2$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $54ebe19487a173a2$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("4O5LI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38004e77da0dc9e3$export$2e2bcd8739ae039; });
var $38004e77da0dc9e3$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("Z0sel", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b760cd717d5f698$export$2e2bcd8739ae039; });

var $3RaBm = parcelRequire("3RaBm");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $0b760cd717d5f698$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($3RaBm)))(targetComponent, sourceComponent);
};

});
parcelRegister("3RaBm", function(module, exports) {
"use strict";

var $gHHxO = parcelRequire("gHHxO");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $2cee8b9bdab95cb5$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $2cee8b9bdab95cb5$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $2cee8b9bdab95cb5$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $2cee8b9bdab95cb5$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $2cee8b9bdab95cb5$var$TYPE_STATICS = {};
$2cee8b9bdab95cb5$var$TYPE_STATICS[$gHHxO.ForwardRef] = $2cee8b9bdab95cb5$var$FORWARD_REF_STATICS;
$2cee8b9bdab95cb5$var$TYPE_STATICS[$gHHxO.Memo] = $2cee8b9bdab95cb5$var$MEMO_STATICS;
function $2cee8b9bdab95cb5$var$getStatics(component) {
    // React v16.11 and below
    if ($gHHxO.isMemo(component)) return $2cee8b9bdab95cb5$var$MEMO_STATICS;
     // React v16.12 and above
    return $2cee8b9bdab95cb5$var$TYPE_STATICS[component["$$typeof"]] || $2cee8b9bdab95cb5$var$REACT_STATICS;
}
var $2cee8b9bdab95cb5$var$defineProperty = Object.defineProperty;
var $2cee8b9bdab95cb5$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $2cee8b9bdab95cb5$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $2cee8b9bdab95cb5$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $2cee8b9bdab95cb5$var$getPrototypeOf = Object.getPrototypeOf;
var $2cee8b9bdab95cb5$var$objectPrototype = Object.prototype;
function $2cee8b9bdab95cb5$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($2cee8b9bdab95cb5$var$objectPrototype) {
            var inheritedComponent = $2cee8b9bdab95cb5$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $2cee8b9bdab95cb5$var$objectPrototype) $2cee8b9bdab95cb5$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $2cee8b9bdab95cb5$var$getOwnPropertyNames(sourceComponent);
        if ($2cee8b9bdab95cb5$var$getOwnPropertySymbols) keys = keys.concat($2cee8b9bdab95cb5$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $2cee8b9bdab95cb5$var$getStatics(targetComponent);
        var sourceStatics = $2cee8b9bdab95cb5$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$2cee8b9bdab95cb5$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $2cee8b9bdab95cb5$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $2cee8b9bdab95cb5$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $2cee8b9bdab95cb5$var$hoistNonReactStatics;

});
parcelRegister("gHHxO", function(module, exports) {
"use strict";

module.exports = (parcelRequire("l62Pf"));

});
parcelRegister("l62Pf", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $f5bc59a0a5796e95$export$2b8d127b894957b9; }, function (v) { return $f5bc59a0a5796e95$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $f5bc59a0a5796e95$export$cea3a54a6425200c; }, function (v) { return $f5bc59a0a5796e95$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $f5bc59a0a5796e95$export$a7c73072b1a182ae; }, function (v) { return $f5bc59a0a5796e95$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $f5bc59a0a5796e95$export$9f27bc3417b4524d; }, function (v) { return $f5bc59a0a5796e95$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $f5bc59a0a5796e95$export$db77ccec0bb4ccac; }, function (v) { return $f5bc59a0a5796e95$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $f5bc59a0a5796e95$export$8392c0c9d3dcbd35; }, function (v) { return $f5bc59a0a5796e95$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $f5bc59a0a5796e95$export$ffb0004e005737fa; }, function (v) { return $f5bc59a0a5796e95$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $f5bc59a0a5796e95$export$b624eff549462981; }, function (v) { return $f5bc59a0a5796e95$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $f5bc59a0a5796e95$export$7897aa7841a5380c; }, function (v) { return $f5bc59a0a5796e95$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $f5bc59a0a5796e95$export$602eac185826482c; }, function (v) { return $f5bc59a0a5796e95$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $f5bc59a0a5796e95$export$e2c29f18771995cb; }, function (v) { return $f5bc59a0a5796e95$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $f5bc59a0a5796e95$export$5f8d39834fd61797; }, function (v) { return $f5bc59a0a5796e95$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $f5bc59a0a5796e95$export$74bf444e3cd11ea5; }, function (v) { return $f5bc59a0a5796e95$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $f5bc59a0a5796e95$export$92387174baf9b227; }, function (v) { return $f5bc59a0a5796e95$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $f5bc59a0a5796e95$export$ec112efeb987d9c6; }, function (v) { return $f5bc59a0a5796e95$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $f5bc59a0a5796e95$export$b706b080d889d2c9; }, function (v) { return $f5bc59a0a5796e95$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $f5bc59a0a5796e95$export$5be5a87408f70ddc; }, function (v) { return $f5bc59a0a5796e95$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $f5bc59a0a5796e95$export$45a5e7f76e0caa8d; }, function (v) { return $f5bc59a0a5796e95$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $f5bc59a0a5796e95$export$455c2e768291efa6; }, function (v) { return $f5bc59a0a5796e95$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $f5bc59a0a5796e95$export$9522e17588c12572; }, function (v) { return $f5bc59a0a5796e95$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $f5bc59a0a5796e95$export$2110ac352bb060b9; }, function (v) { return $f5bc59a0a5796e95$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $f5bc59a0a5796e95$export$56885ab8b9c456ab; }, function (v) { return $f5bc59a0a5796e95$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $f5bc59a0a5796e95$export$d927fcb6adf8f9de; }, function (v) { return $f5bc59a0a5796e95$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $f5bc59a0a5796e95$export$b82d16f27459e05a; }, function (v) { return $f5bc59a0a5796e95$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $f5bc59a0a5796e95$export$522c17b4f5e123e8; }, function (v) { return $f5bc59a0a5796e95$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $f5bc59a0a5796e95$export$1aabd8a0274ecfd6; }, function (v) { return $f5bc59a0a5796e95$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $f5bc59a0a5796e95$export$9b621391a187a31a; }, function (v) { return $f5bc59a0a5796e95$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $f5bc59a0a5796e95$export$f5bbd400c2f4426f; }, function (v) { return $f5bc59a0a5796e95$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f5bc59a0a5796e95$export$2b8d127b894957b9;
var $f5bc59a0a5796e95$export$cea3a54a6425200c;
var $f5bc59a0a5796e95$export$a7c73072b1a182ae;
var $f5bc59a0a5796e95$export$9f27bc3417b4524d;
var $f5bc59a0a5796e95$export$db77ccec0bb4ccac;
var $f5bc59a0a5796e95$export$8392c0c9d3dcbd35;
var $f5bc59a0a5796e95$export$ffb0004e005737fa;
var $f5bc59a0a5796e95$export$b624eff549462981;
var $f5bc59a0a5796e95$export$7897aa7841a5380c;
var $f5bc59a0a5796e95$export$602eac185826482c;
var $f5bc59a0a5796e95$export$e2c29f18771995cb;
var $f5bc59a0a5796e95$export$5f8d39834fd61797;
var $f5bc59a0a5796e95$export$74bf444e3cd11ea5;
var $f5bc59a0a5796e95$export$92387174baf9b227;
var $f5bc59a0a5796e95$export$ec112efeb987d9c6;
var $f5bc59a0a5796e95$export$b706b080d889d2c9;
var $f5bc59a0a5796e95$export$5be5a87408f70ddc;
var $f5bc59a0a5796e95$export$45a5e7f76e0caa8d;
var $f5bc59a0a5796e95$export$455c2e768291efa6;
var $f5bc59a0a5796e95$export$9522e17588c12572;
var $f5bc59a0a5796e95$export$2110ac352bb060b9;
var $f5bc59a0a5796e95$export$56885ab8b9c456ab;
var $f5bc59a0a5796e95$export$d927fcb6adf8f9de;
var $f5bc59a0a5796e95$export$b82d16f27459e05a;
var $f5bc59a0a5796e95$export$522c17b4f5e123e8;
var $f5bc59a0a5796e95$export$1aabd8a0274ecfd6;
var $f5bc59a0a5796e95$export$9b621391a187a31a;
var $f5bc59a0a5796e95$export$f5bbd400c2f4426f;
"use strict";
var $f5bc59a0a5796e95$var$b = "function" === typeof Symbol && Symbol.for, $f5bc59a0a5796e95$var$c = $f5bc59a0a5796e95$var$b ? Symbol.for("react.element") : 60103, $f5bc59a0a5796e95$var$d = $f5bc59a0a5796e95$var$b ? Symbol.for("react.portal") : 60106, $f5bc59a0a5796e95$var$e = $f5bc59a0a5796e95$var$b ? Symbol.for("react.fragment") : 60107, $f5bc59a0a5796e95$var$f = $f5bc59a0a5796e95$var$b ? Symbol.for("react.strict_mode") : 60108, $f5bc59a0a5796e95$var$g = $f5bc59a0a5796e95$var$b ? Symbol.for("react.profiler") : 60114, $f5bc59a0a5796e95$var$h = $f5bc59a0a5796e95$var$b ? Symbol.for("react.provider") : 60109, $f5bc59a0a5796e95$var$k = $f5bc59a0a5796e95$var$b ? Symbol.for("react.context") : 60110, $f5bc59a0a5796e95$var$l = $f5bc59a0a5796e95$var$b ? Symbol.for("react.async_mode") : 60111, $f5bc59a0a5796e95$var$m = $f5bc59a0a5796e95$var$b ? Symbol.for("react.concurrent_mode") : 60111, $f5bc59a0a5796e95$var$n = $f5bc59a0a5796e95$var$b ? Symbol.for("react.forward_ref") : 60112, $f5bc59a0a5796e95$var$p = $f5bc59a0a5796e95$var$b ? Symbol.for("react.suspense") : 60113, $f5bc59a0a5796e95$var$q = $f5bc59a0a5796e95$var$b ? Symbol.for("react.suspense_list") : 60120, $f5bc59a0a5796e95$var$r = $f5bc59a0a5796e95$var$b ? Symbol.for("react.memo") : 60115, $f5bc59a0a5796e95$var$t = $f5bc59a0a5796e95$var$b ? Symbol.for("react.lazy") : 60116, $f5bc59a0a5796e95$var$v = $f5bc59a0a5796e95$var$b ? Symbol.for("react.block") : 60121, $f5bc59a0a5796e95$var$w = $f5bc59a0a5796e95$var$b ? Symbol.for("react.fundamental") : 60117, $f5bc59a0a5796e95$var$x = $f5bc59a0a5796e95$var$b ? Symbol.for("react.responder") : 60118, $f5bc59a0a5796e95$var$y = $f5bc59a0a5796e95$var$b ? Symbol.for("react.scope") : 60119;
function $f5bc59a0a5796e95$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $f5bc59a0a5796e95$var$c:
                switch(a = a.type, a){
                    case $f5bc59a0a5796e95$var$l:
                    case $f5bc59a0a5796e95$var$m:
                    case $f5bc59a0a5796e95$var$e:
                    case $f5bc59a0a5796e95$var$g:
                    case $f5bc59a0a5796e95$var$f:
                    case $f5bc59a0a5796e95$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $f5bc59a0a5796e95$var$k:
                            case $f5bc59a0a5796e95$var$n:
                            case $f5bc59a0a5796e95$var$t:
                            case $f5bc59a0a5796e95$var$r:
                            case $f5bc59a0a5796e95$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $f5bc59a0a5796e95$var$d:
                return u;
        }
    }
}
function $f5bc59a0a5796e95$var$A(a) {
    return $f5bc59a0a5796e95$var$z(a) === $f5bc59a0a5796e95$var$m;
}
$f5bc59a0a5796e95$export$2b8d127b894957b9 = $f5bc59a0a5796e95$var$l;
$f5bc59a0a5796e95$export$cea3a54a6425200c = $f5bc59a0a5796e95$var$m;
$f5bc59a0a5796e95$export$a7c73072b1a182ae = $f5bc59a0a5796e95$var$k;
$f5bc59a0a5796e95$export$9f27bc3417b4524d = $f5bc59a0a5796e95$var$h;
$f5bc59a0a5796e95$export$db77ccec0bb4ccac = $f5bc59a0a5796e95$var$c;
$f5bc59a0a5796e95$export$8392c0c9d3dcbd35 = $f5bc59a0a5796e95$var$n;
$f5bc59a0a5796e95$export$ffb0004e005737fa = $f5bc59a0a5796e95$var$e;
$f5bc59a0a5796e95$export$b624eff549462981 = $f5bc59a0a5796e95$var$t;
$f5bc59a0a5796e95$export$7897aa7841a5380c = $f5bc59a0a5796e95$var$r;
$f5bc59a0a5796e95$export$602eac185826482c = $f5bc59a0a5796e95$var$d;
$f5bc59a0a5796e95$export$e2c29f18771995cb = $f5bc59a0a5796e95$var$g;
$f5bc59a0a5796e95$export$5f8d39834fd61797 = $f5bc59a0a5796e95$var$f;
$f5bc59a0a5796e95$export$74bf444e3cd11ea5 = $f5bc59a0a5796e95$var$p;
$f5bc59a0a5796e95$export$92387174baf9b227 = function(a) {
    return $f5bc59a0a5796e95$var$A(a) || $f5bc59a0a5796e95$var$z(a) === $f5bc59a0a5796e95$var$l;
};
$f5bc59a0a5796e95$export$ec112efeb987d9c6 = $f5bc59a0a5796e95$var$A;
$f5bc59a0a5796e95$export$b706b080d889d2c9 = function(a) {
    return $f5bc59a0a5796e95$var$z(a) === $f5bc59a0a5796e95$var$k;
};
$f5bc59a0a5796e95$export$5be5a87408f70ddc = function(a) {
    return $f5bc59a0a5796e95$var$z(a) === $f5bc59a0a5796e95$var$h;
};
$f5bc59a0a5796e95$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $f5bc59a0a5796e95$var$c;
};
$f5bc59a0a5796e95$export$455c2e768291efa6 = function(a) {
    return $f5bc59a0a5796e95$var$z(a) === $f5bc59a0a5796e95$var$n;
};
$f5bc59a0a5796e95$export$9522e17588c12572 = function(a) {
    return $f5bc59a0a5796e95$var$z(a) === $f5bc59a0a5796e95$var$e;
};
$f5bc59a0a5796e95$export$2110ac352bb060b9 = function(a) {
    return $f5bc59a0a5796e95$var$z(a) === $f5bc59a0a5796e95$var$t;
};
$f5bc59a0a5796e95$export$56885ab8b9c456ab = function(a) {
    return $f5bc59a0a5796e95$var$z(a) === $f5bc59a0a5796e95$var$r;
};
$f5bc59a0a5796e95$export$d927fcb6adf8f9de = function(a) {
    return $f5bc59a0a5796e95$var$z(a) === $f5bc59a0a5796e95$var$d;
};
$f5bc59a0a5796e95$export$b82d16f27459e05a = function(a) {
    return $f5bc59a0a5796e95$var$z(a) === $f5bc59a0a5796e95$var$g;
};
$f5bc59a0a5796e95$export$522c17b4f5e123e8 = function(a) {
    return $f5bc59a0a5796e95$var$z(a) === $f5bc59a0a5796e95$var$f;
};
$f5bc59a0a5796e95$export$1aabd8a0274ecfd6 = function(a) {
    return $f5bc59a0a5796e95$var$z(a) === $f5bc59a0a5796e95$var$p;
};
$f5bc59a0a5796e95$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $f5bc59a0a5796e95$var$e || a === $f5bc59a0a5796e95$var$m || a === $f5bc59a0a5796e95$var$g || a === $f5bc59a0a5796e95$var$f || a === $f5bc59a0a5796e95$var$p || a === $f5bc59a0a5796e95$var$q || "object" === typeof a && null !== a && (a.$$typeof === $f5bc59a0a5796e95$var$t || a.$$typeof === $f5bc59a0a5796e95$var$r || a.$$typeof === $f5bc59a0a5796e95$var$h || a.$$typeof === $f5bc59a0a5796e95$var$k || a.$$typeof === $f5bc59a0a5796e95$var$n || a.$$typeof === $f5bc59a0a5796e95$var$w || a.$$typeof === $f5bc59a0a5796e95$var$x || a.$$typeof === $f5bc59a0a5796e95$var$y || a.$$typeof === $f5bc59a0a5796e95$var$v);
};
$f5bc59a0a5796e95$export$f5bbd400c2f4426f = $f5bc59a0a5796e95$var$z;

});




parcelRegister("fvFHh", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $b4aa186f09ac437e$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $b4aa186f09ac437e$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $b4aa186f09ac437e$export$6f077d94b33a01aa; });
var $b4aa186f09ac437e$var$isBrowser = typeof document !== "undefined";
function $b4aa186f09ac437e$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $b4aa186f09ac437e$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $b4aa186f09ac437e$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $b4aa186f09ac437e$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $b4aa186f09ac437e$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = "";
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            if (!$b4aa186f09ac437e$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$b4aa186f09ac437e$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("lkbnQ", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $f8644bc4417e0e21$export$6321afa313b251b5; });

var $kfhhC = parcelRequire("kfhhC");

var $dNweh = parcelRequire("dNweh");

var $65q85 = parcelRequire("65q85");
var $f8644bc4417e0e21$var$isDevelopment = false;
var $f8644bc4417e0e21$var$hyphenateRegex = /[A-Z]|^ms/g;
var $f8644bc4417e0e21$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $f8644bc4417e0e21$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $f8644bc4417e0e21$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $f8644bc4417e0e21$var$processStyleName = /* #__PURE__ */ (0, $65q85.default)(function(styleName) {
    return $f8644bc4417e0e21$var$isCustomProperty(styleName) ? styleName : styleName.replace($f8644bc4417e0e21$var$hyphenateRegex, "-$&").toLowerCase();
});
var $f8644bc4417e0e21$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($f8644bc4417e0e21$var$animationRegex, function(match, p1, p2) {
                $f8644bc4417e0e21$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $f8644bc4417e0e21$var$cursor
                };
                return p1;
            });
    }
    if ((0, $dNweh.default)[key] !== 1 && !$f8644bc4417e0e21$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $f8644bc4417e0e21$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $f8644bc4417e0e21$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $f8644bc4417e0e21$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $f8644bc4417e0e21$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $f8644bc4417e0e21$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $f8644bc4417e0e21$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $f8644bc4417e0e21$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $f8644bc4417e0e21$var$cursor;
                var result = interpolation(mergedProps);
                $f8644bc4417e0e21$var$cursor = previousCursor;
                return $f8644bc4417e0e21$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $f8644bc4417e0e21$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $f8644bc4417e0e21$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== "object") {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($f8644bc4417e0e21$var$isProcessableValue(asString)) string += $f8644bc4417e0e21$var$processStyleName(key) + ":" + $f8644bc4417e0e21$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === "NO_COMPONENT_SELECTOR" && $f8644bc4417e0e21$var$isDevelopment) throw new Error($f8644bc4417e0e21$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($f8644bc4417e0e21$var$isProcessableValue(value[_i])) string += $f8644bc4417e0e21$var$processStyleName(key) + ":" + $f8644bc4417e0e21$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $f8644bc4417e0e21$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case "animation":
                    case "animationName":
                        string += $f8644bc4417e0e21$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $f8644bc4417e0e21$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g;
// keyframes are stored on the SerializedStyles object as a linked list
var $f8644bc4417e0e21$var$cursor;
function $f8644bc4417e0e21$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $f8644bc4417e0e21$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $f8644bc4417e0e21$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $f8644bc4417e0e21$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    }
    $f8644bc4417e0e21$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $f8644bc4417e0e21$var$labelPattern.exec(styles)) !== null)identifierName += "-" + match[1];
    var name = (0, $kfhhC.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $f8644bc4417e0e21$var$cursor
    };
}

});
parcelRegister("kfhhC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebd29d7154b769e7$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $ebd29d7154b769e7$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("dNweh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0b8da0b525da682$export$2e2bcd8739ae039; });
var $a0b8da0b525da682$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("cqJqj", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $90cb25e00f304408$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $90cb25e00f304408$export$811a713a7276cb9d; });

var $jbmdS = parcelRequire("jbmdS");
var $90cb25e00f304408$var$isBrowser = typeof document !== "undefined";
var $90cb25e00f304408$var$syncFallback = function syncFallback(create) {
    return create();
};
var $90cb25e00f304408$var$useInsertionEffect = $jbmdS.useInsertionEffect ? $jbmdS.useInsertionEffect : false;
var $90cb25e00f304408$export$db21c7ffa21794e7 = !$90cb25e00f304408$var$isBrowser ? $90cb25e00f304408$var$syncFallback : $90cb25e00f304408$var$useInsertionEffect || $90cb25e00f304408$var$syncFallback;
var $90cb25e00f304408$export$811a713a7276cb9d = $90cb25e00f304408$var$useInsertionEffect || $jbmdS.useLayoutEffect;

});


parcelRegister("u6wRM", function(module, exports) {
function $05a7de0013ca5685$var$_extends() {
    return module.exports = $05a7de0013ca5685$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $05a7de0013ca5685$var$_extends.apply(null, arguments);
}
module.exports = $05a7de0013ca5685$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("jCNM0", function(module, exports) {
"use strict";
function $e4982ce0dd66b3e2$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($e4982ce0dd66b3e2$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$e4982ce0dd66b3e2$var$checkDCE();

module.exports = (parcelRequire("55fGM"));

});
parcelRegister("55fGM", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $3b3996e8d1fa8468$export$ae55be85d98224ed; }, function (v) { return $3b3996e8d1fa8468$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $3b3996e8d1fa8468$export$d39a5bbd09211389; }, function (v) { return $3b3996e8d1fa8468$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $3b3996e8d1fa8468$export$882461b6382ed46c; }, function (v) { return $3b3996e8d1fa8468$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $3b3996e8d1fa8468$export$466bfc07425424d5; }, function (v) { return $3b3996e8d1fa8468$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $3b3996e8d1fa8468$export$cd75ccfd720a3cd4; }, function (v) { return $3b3996e8d1fa8468$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $3b3996e8d1fa8468$export$fa8d919ba61d84db; }, function (v) { return $3b3996e8d1fa8468$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $3b3996e8d1fa8468$export$757ceba2d55c277e; }, function (v) { return $3b3996e8d1fa8468$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $3b3996e8d1fa8468$export$b3890eb0ae9dca99; }, function (v) { return $3b3996e8d1fa8468$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $3b3996e8d1fa8468$export$502457920280e6be; }, function (v) { return $3b3996e8d1fa8468$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $3b3996e8d1fa8468$export$c78a37762a8d58e1; }, function (v) { return $3b3996e8d1fa8468$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $3b3996e8d1fa8468$export$dc54d992c10e8a18; }, function (v) { return $3b3996e8d1fa8468$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $3b3996e8d1fa8468$export$83d89fbfd8236492; }, function (v) { return $3b3996e8d1fa8468$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $3b3996e8d1fa8468$export$ae55be85d98224ed;
var $3b3996e8d1fa8468$export$d39a5bbd09211389;
var $3b3996e8d1fa8468$export$882461b6382ed46c;
var $3b3996e8d1fa8468$export$466bfc07425424d5;
var $3b3996e8d1fa8468$export$cd75ccfd720a3cd4;
var $3b3996e8d1fa8468$export$fa8d919ba61d84db;
var $3b3996e8d1fa8468$export$757ceba2d55c277e;
var $3b3996e8d1fa8468$export$b3890eb0ae9dca99;
var $3b3996e8d1fa8468$export$502457920280e6be;
var $3b3996e8d1fa8468$export$c78a37762a8d58e1;
var $3b3996e8d1fa8468$export$dc54d992c10e8a18;
var $3b3996e8d1fa8468$export$83d89fbfd8236492;
"use strict";

var $jbmdS = parcelRequire("jbmdS");

var $j1S5s = parcelRequire("j1S5s");
function $3b3996e8d1fa8468$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $3b3996e8d1fa8468$var$da = new Set, $3b3996e8d1fa8468$var$ea = {};
function $3b3996e8d1fa8468$var$fa(a, b) {
    $3b3996e8d1fa8468$var$ha(a, b);
    $3b3996e8d1fa8468$var$ha(a + "Capture", b);
}
function $3b3996e8d1fa8468$var$ha(a, b) {
    $3b3996e8d1fa8468$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$3b3996e8d1fa8468$var$da.add(b[a]);
}
var $3b3996e8d1fa8468$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $3b3996e8d1fa8468$var$ja = Object.prototype.hasOwnProperty, $3b3996e8d1fa8468$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $3b3996e8d1fa8468$var$la = {}, $3b3996e8d1fa8468$var$ma = {};
function $3b3996e8d1fa8468$var$oa(a) {
    if ($3b3996e8d1fa8468$var$ja.call($3b3996e8d1fa8468$var$ma, a)) return !0;
    if ($3b3996e8d1fa8468$var$ja.call($3b3996e8d1fa8468$var$la, a)) return !1;
    if ($3b3996e8d1fa8468$var$ka.test(a)) return $3b3996e8d1fa8468$var$ma[a] = !0;
    $3b3996e8d1fa8468$var$la[a] = !0;
    return !1;
}
function $3b3996e8d1fa8468$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $3b3996e8d1fa8468$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $3b3996e8d1fa8468$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $3b3996e8d1fa8468$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $3b3996e8d1fa8468$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $3b3996e8d1fa8468$var$z[a] = new $3b3996e8d1fa8468$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $3b3996e8d1fa8468$var$z[b] = new $3b3996e8d1fa8468$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $3b3996e8d1fa8468$var$z[a] = new $3b3996e8d1fa8468$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $3b3996e8d1fa8468$var$z[a] = new $3b3996e8d1fa8468$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $3b3996e8d1fa8468$var$z[a] = new $3b3996e8d1fa8468$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $3b3996e8d1fa8468$var$z[a] = new $3b3996e8d1fa8468$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $3b3996e8d1fa8468$var$z[a] = new $3b3996e8d1fa8468$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $3b3996e8d1fa8468$var$z[a] = new $3b3996e8d1fa8468$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $3b3996e8d1fa8468$var$z[a] = new $3b3996e8d1fa8468$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $3b3996e8d1fa8468$var$ra = /[\-:]([a-z])/g;
function $3b3996e8d1fa8468$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($3b3996e8d1fa8468$var$ra, $3b3996e8d1fa8468$var$sa);
    $3b3996e8d1fa8468$var$z[b] = new $3b3996e8d1fa8468$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($3b3996e8d1fa8468$var$ra, $3b3996e8d1fa8468$var$sa);
    $3b3996e8d1fa8468$var$z[b] = new $3b3996e8d1fa8468$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($3b3996e8d1fa8468$var$ra, $3b3996e8d1fa8468$var$sa);
    $3b3996e8d1fa8468$var$z[b] = new $3b3996e8d1fa8468$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $3b3996e8d1fa8468$var$z[a] = new $3b3996e8d1fa8468$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$3b3996e8d1fa8468$var$z.xlinkHref = new $3b3996e8d1fa8468$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $3b3996e8d1fa8468$var$z[a] = new $3b3996e8d1fa8468$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $3b3996e8d1fa8468$var$ta(a, b, c, d) {
    var e = $3b3996e8d1fa8468$var$z.hasOwnProperty(b) ? $3b3996e8d1fa8468$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $3b3996e8d1fa8468$var$qa(b, c, e, d) && (c = null), d || null === e ? $3b3996e8d1fa8468$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $3b3996e8d1fa8468$var$ua = $jbmdS.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $3b3996e8d1fa8468$var$va = Symbol.for("react.element"), $3b3996e8d1fa8468$var$wa = Symbol.for("react.portal"), $3b3996e8d1fa8468$var$ya = Symbol.for("react.fragment"), $3b3996e8d1fa8468$var$za = Symbol.for("react.strict_mode"), $3b3996e8d1fa8468$var$Aa = Symbol.for("react.profiler"), $3b3996e8d1fa8468$var$Ba = Symbol.for("react.provider"), $3b3996e8d1fa8468$var$Ca = Symbol.for("react.context"), $3b3996e8d1fa8468$var$Da = Symbol.for("react.forward_ref"), $3b3996e8d1fa8468$var$Ea = Symbol.for("react.suspense"), $3b3996e8d1fa8468$var$Fa = Symbol.for("react.suspense_list"), $3b3996e8d1fa8468$var$Ga = Symbol.for("react.memo"), $3b3996e8d1fa8468$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $3b3996e8d1fa8468$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $3b3996e8d1fa8468$var$Ja = Symbol.iterator;
function $3b3996e8d1fa8468$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $3b3996e8d1fa8468$var$Ja && a[$3b3996e8d1fa8468$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $3b3996e8d1fa8468$var$A = Object.assign, $3b3996e8d1fa8468$var$La;
function $3b3996e8d1fa8468$var$Ma(a) {
    if (void 0 === $3b3996e8d1fa8468$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $3b3996e8d1fa8468$var$La = b && b[1] || "";
    }
    return "\n" + $3b3996e8d1fa8468$var$La + a;
}
var $3b3996e8d1fa8468$var$Na = !1;
function $3b3996e8d1fa8468$var$Oa(a, b) {
    if (!a || $3b3996e8d1fa8468$var$Na) return "";
    $3b3996e8d1fa8468$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $3b3996e8d1fa8468$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $3b3996e8d1fa8468$var$Ma(a) : "";
}
function $3b3996e8d1fa8468$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $3b3996e8d1fa8468$var$Ma(a.type);
        case 16:
            return $3b3996e8d1fa8468$var$Ma("Lazy");
        case 13:
            return $3b3996e8d1fa8468$var$Ma("Suspense");
        case 19:
            return $3b3996e8d1fa8468$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $3b3996e8d1fa8468$var$Oa(a.type, !1), a;
        case 11:
            return a = $3b3996e8d1fa8468$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $3b3996e8d1fa8468$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $3b3996e8d1fa8468$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $3b3996e8d1fa8468$var$ya:
            return "Fragment";
        case $3b3996e8d1fa8468$var$wa:
            return "Portal";
        case $3b3996e8d1fa8468$var$Aa:
            return "Profiler";
        case $3b3996e8d1fa8468$var$za:
            return "StrictMode";
        case $3b3996e8d1fa8468$var$Ea:
            return "Suspense";
        case $3b3996e8d1fa8468$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $3b3996e8d1fa8468$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $3b3996e8d1fa8468$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $3b3996e8d1fa8468$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $3b3996e8d1fa8468$var$Ga:
            return b = a.displayName || null, null !== b ? b : $3b3996e8d1fa8468$var$Qa(a.type) || "Memo";
        case $3b3996e8d1fa8468$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $3b3996e8d1fa8468$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $3b3996e8d1fa8468$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $3b3996e8d1fa8468$var$Qa(b);
        case 8:
            return b === $3b3996e8d1fa8468$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $3b3996e8d1fa8468$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $3b3996e8d1fa8468$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $3b3996e8d1fa8468$var$Ua(a) {
    var b = $3b3996e8d1fa8468$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $3b3996e8d1fa8468$var$Va(a) {
    a._valueTracker || (a._valueTracker = $3b3996e8d1fa8468$var$Ua(a));
}
function $3b3996e8d1fa8468$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $3b3996e8d1fa8468$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $3b3996e8d1fa8468$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $3b3996e8d1fa8468$var$Ya(a, b) {
    var c = b.checked;
    return $3b3996e8d1fa8468$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $3b3996e8d1fa8468$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $3b3996e8d1fa8468$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $3b3996e8d1fa8468$var$ab(a, b) {
    b = b.checked;
    null != b && $3b3996e8d1fa8468$var$ta(a, "checked", b, !1);
}
function $3b3996e8d1fa8468$var$bb(a, b) {
    $3b3996e8d1fa8468$var$ab(a, b);
    var c = $3b3996e8d1fa8468$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $3b3996e8d1fa8468$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $3b3996e8d1fa8468$var$cb(a, b.type, $3b3996e8d1fa8468$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $3b3996e8d1fa8468$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $3b3996e8d1fa8468$var$cb(a, b, c) {
    if ("number" !== b || $3b3996e8d1fa8468$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $3b3996e8d1fa8468$var$eb = Array.isArray;
function $3b3996e8d1fa8468$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $3b3996e8d1fa8468$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $3b3996e8d1fa8468$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($3b3996e8d1fa8468$var$p(91));
    return $3b3996e8d1fa8468$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $3b3996e8d1fa8468$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($3b3996e8d1fa8468$var$p(92));
            if ($3b3996e8d1fa8468$var$eb(c)) {
                if (1 < c.length) throw Error($3b3996e8d1fa8468$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $3b3996e8d1fa8468$var$Sa(c)
    };
}
function $3b3996e8d1fa8468$var$ib(a, b) {
    var c = $3b3996e8d1fa8468$var$Sa(b.value), d = $3b3996e8d1fa8468$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $3b3996e8d1fa8468$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $3b3996e8d1fa8468$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $3b3996e8d1fa8468$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $3b3996e8d1fa8468$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $3b3996e8d1fa8468$var$mb, $3b3996e8d1fa8468$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $3b3996e8d1fa8468$var$mb = $3b3996e8d1fa8468$var$mb || document.createElement("div");
        $3b3996e8d1fa8468$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $3b3996e8d1fa8468$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $3b3996e8d1fa8468$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $3b3996e8d1fa8468$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $3b3996e8d1fa8468$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($3b3996e8d1fa8468$var$pb).forEach(function(a) {
    $3b3996e8d1fa8468$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $3b3996e8d1fa8468$var$pb[b] = $3b3996e8d1fa8468$var$pb[a];
    });
});
function $3b3996e8d1fa8468$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $3b3996e8d1fa8468$var$pb.hasOwnProperty(a) && $3b3996e8d1fa8468$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $3b3996e8d1fa8468$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $3b3996e8d1fa8468$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $3b3996e8d1fa8468$var$tb = $3b3996e8d1fa8468$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $3b3996e8d1fa8468$var$ub(a, b) {
    if (b) {
        if ($3b3996e8d1fa8468$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($3b3996e8d1fa8468$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($3b3996e8d1fa8468$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($3b3996e8d1fa8468$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($3b3996e8d1fa8468$var$p(62));
    }
}
function $3b3996e8d1fa8468$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $3b3996e8d1fa8468$var$wb = null;
function $3b3996e8d1fa8468$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $3b3996e8d1fa8468$var$yb = null, $3b3996e8d1fa8468$var$zb = null, $3b3996e8d1fa8468$var$Ab = null;
function $3b3996e8d1fa8468$var$Bb(a) {
    if (a = $3b3996e8d1fa8468$var$Cb(a)) {
        if ("function" !== typeof $3b3996e8d1fa8468$var$yb) throw Error($3b3996e8d1fa8468$var$p(280));
        var b = a.stateNode;
        b && (b = $3b3996e8d1fa8468$var$Db(b), $3b3996e8d1fa8468$var$yb(a.stateNode, a.type, b));
    }
}
function $3b3996e8d1fa8468$var$Eb(a) {
    $3b3996e8d1fa8468$var$zb ? $3b3996e8d1fa8468$var$Ab ? $3b3996e8d1fa8468$var$Ab.push(a) : $3b3996e8d1fa8468$var$Ab = [
        a
    ] : $3b3996e8d1fa8468$var$zb = a;
}
function $3b3996e8d1fa8468$var$Fb() {
    if ($3b3996e8d1fa8468$var$zb) {
        var a = $3b3996e8d1fa8468$var$zb, b = $3b3996e8d1fa8468$var$Ab;
        $3b3996e8d1fa8468$var$Ab = $3b3996e8d1fa8468$var$zb = null;
        $3b3996e8d1fa8468$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$3b3996e8d1fa8468$var$Bb(b[a]);
    }
}
function $3b3996e8d1fa8468$var$Gb(a, b) {
    return a(b);
}
function $3b3996e8d1fa8468$var$Hb() {}
var $3b3996e8d1fa8468$var$Ib = !1;
function $3b3996e8d1fa8468$var$Jb(a, b, c) {
    if ($3b3996e8d1fa8468$var$Ib) return a(b, c);
    $3b3996e8d1fa8468$var$Ib = !0;
    try {
        return $3b3996e8d1fa8468$var$Gb(a, b, c);
    } finally{
        if ($3b3996e8d1fa8468$var$Ib = !1, null !== $3b3996e8d1fa8468$var$zb || null !== $3b3996e8d1fa8468$var$Ab) $3b3996e8d1fa8468$var$Hb(), $3b3996e8d1fa8468$var$Fb();
    }
}
function $3b3996e8d1fa8468$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $3b3996e8d1fa8468$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($3b3996e8d1fa8468$var$p(231, b, typeof c));
    return c;
}
var $3b3996e8d1fa8468$var$Lb = !1;
if ($3b3996e8d1fa8468$var$ia) try {
    var $3b3996e8d1fa8468$var$Mb = {};
    Object.defineProperty($3b3996e8d1fa8468$var$Mb, "passive", {
        get: function() {
            $3b3996e8d1fa8468$var$Lb = !0;
        }
    });
    window.addEventListener("test", $3b3996e8d1fa8468$var$Mb, $3b3996e8d1fa8468$var$Mb);
    window.removeEventListener("test", $3b3996e8d1fa8468$var$Mb, $3b3996e8d1fa8468$var$Mb);
} catch (a) {
    $3b3996e8d1fa8468$var$Lb = !1;
}
function $3b3996e8d1fa8468$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $3b3996e8d1fa8468$var$Ob = !1, $3b3996e8d1fa8468$var$Pb = null, $3b3996e8d1fa8468$var$Qb = !1, $3b3996e8d1fa8468$var$Rb = null, $3b3996e8d1fa8468$var$Sb = {
    onError: function(a) {
        $3b3996e8d1fa8468$var$Ob = !0;
        $3b3996e8d1fa8468$var$Pb = a;
    }
};
function $3b3996e8d1fa8468$var$Tb(a, b, c, d, e, f, g, h, k) {
    $3b3996e8d1fa8468$var$Ob = !1;
    $3b3996e8d1fa8468$var$Pb = null;
    $3b3996e8d1fa8468$var$Nb.apply($3b3996e8d1fa8468$var$Sb, arguments);
}
function $3b3996e8d1fa8468$var$Ub(a, b, c, d, e, f, g, h, k) {
    $3b3996e8d1fa8468$var$Tb.apply(this, arguments);
    if ($3b3996e8d1fa8468$var$Ob) {
        if ($3b3996e8d1fa8468$var$Ob) {
            var l = $3b3996e8d1fa8468$var$Pb;
            $3b3996e8d1fa8468$var$Ob = !1;
            $3b3996e8d1fa8468$var$Pb = null;
        } else throw Error($3b3996e8d1fa8468$var$p(198));
        $3b3996e8d1fa8468$var$Qb || ($3b3996e8d1fa8468$var$Qb = !0, $3b3996e8d1fa8468$var$Rb = l);
    }
}
function $3b3996e8d1fa8468$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $3b3996e8d1fa8468$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $3b3996e8d1fa8468$var$Xb(a) {
    if ($3b3996e8d1fa8468$var$Vb(a) !== a) throw Error($3b3996e8d1fa8468$var$p(188));
}
function $3b3996e8d1fa8468$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $3b3996e8d1fa8468$var$Vb(a);
        if (null === b) throw Error($3b3996e8d1fa8468$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $3b3996e8d1fa8468$var$Xb(e), a;
                if (f === d) return $3b3996e8d1fa8468$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($3b3996e8d1fa8468$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($3b3996e8d1fa8468$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($3b3996e8d1fa8468$var$p(190));
    }
    if (3 !== c.tag) throw Error($3b3996e8d1fa8468$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $3b3996e8d1fa8468$var$Zb(a) {
    a = $3b3996e8d1fa8468$var$Yb(a);
    return null !== a ? $3b3996e8d1fa8468$var$$b(a) : null;
}
function $3b3996e8d1fa8468$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $3b3996e8d1fa8468$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $3b3996e8d1fa8468$var$ac = $j1S5s.unstable_scheduleCallback, $3b3996e8d1fa8468$var$bc = $j1S5s.unstable_cancelCallback, $3b3996e8d1fa8468$var$cc = $j1S5s.unstable_shouldYield, $3b3996e8d1fa8468$var$dc = $j1S5s.unstable_requestPaint, $3b3996e8d1fa8468$var$B = $j1S5s.unstable_now, $3b3996e8d1fa8468$var$ec = $j1S5s.unstable_getCurrentPriorityLevel, $3b3996e8d1fa8468$var$fc = $j1S5s.unstable_ImmediatePriority, $3b3996e8d1fa8468$var$gc = $j1S5s.unstable_UserBlockingPriority, $3b3996e8d1fa8468$var$hc = $j1S5s.unstable_NormalPriority, $3b3996e8d1fa8468$var$ic = $j1S5s.unstable_LowPriority, $3b3996e8d1fa8468$var$jc = $j1S5s.unstable_IdlePriority, $3b3996e8d1fa8468$var$kc = null, $3b3996e8d1fa8468$var$lc = null;
function $3b3996e8d1fa8468$var$mc(a) {
    if ($3b3996e8d1fa8468$var$lc && "function" === typeof $3b3996e8d1fa8468$var$lc.onCommitFiberRoot) try {
        $3b3996e8d1fa8468$var$lc.onCommitFiberRoot($3b3996e8d1fa8468$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $3b3996e8d1fa8468$var$oc = Math.clz32 ? Math.clz32 : $3b3996e8d1fa8468$var$nc, $3b3996e8d1fa8468$var$pc = Math.log, $3b3996e8d1fa8468$var$qc = Math.LN2;
function $3b3996e8d1fa8468$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($3b3996e8d1fa8468$var$pc(a) / $3b3996e8d1fa8468$var$qc | 0) | 0;
}
var $3b3996e8d1fa8468$var$rc = 64, $3b3996e8d1fa8468$var$sc = 4194304;
function $3b3996e8d1fa8468$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $3b3996e8d1fa8468$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $3b3996e8d1fa8468$var$tc(h) : (f &= g, 0 !== f && (d = $3b3996e8d1fa8468$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $3b3996e8d1fa8468$var$tc(g) : 0 !== f && (d = $3b3996e8d1fa8468$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $3b3996e8d1fa8468$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $3b3996e8d1fa8468$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $3b3996e8d1fa8468$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $3b3996e8d1fa8468$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $3b3996e8d1fa8468$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $3b3996e8d1fa8468$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $3b3996e8d1fa8468$var$yc() {
    var a = $3b3996e8d1fa8468$var$rc;
    $3b3996e8d1fa8468$var$rc <<= 1;
    0 === ($3b3996e8d1fa8468$var$rc & 4194240) && ($3b3996e8d1fa8468$var$rc = 64);
    return a;
}
function $3b3996e8d1fa8468$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $3b3996e8d1fa8468$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $3b3996e8d1fa8468$var$oc(b);
    a[b] = c;
}
function $3b3996e8d1fa8468$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $3b3996e8d1fa8468$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $3b3996e8d1fa8468$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $3b3996e8d1fa8468$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $3b3996e8d1fa8468$var$C = 0;
function $3b3996e8d1fa8468$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $3b3996e8d1fa8468$var$Ec, $3b3996e8d1fa8468$var$Fc, $3b3996e8d1fa8468$var$Gc, $3b3996e8d1fa8468$var$Hc, $3b3996e8d1fa8468$var$Ic, $3b3996e8d1fa8468$var$Jc = !1, $3b3996e8d1fa8468$var$Kc = [], $3b3996e8d1fa8468$var$Lc = null, $3b3996e8d1fa8468$var$Mc = null, $3b3996e8d1fa8468$var$Nc = null, $3b3996e8d1fa8468$var$Oc = new Map, $3b3996e8d1fa8468$var$Pc = new Map, $3b3996e8d1fa8468$var$Qc = [], $3b3996e8d1fa8468$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $3b3996e8d1fa8468$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $3b3996e8d1fa8468$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $3b3996e8d1fa8468$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $3b3996e8d1fa8468$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $3b3996e8d1fa8468$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $3b3996e8d1fa8468$var$Pc.delete(b.pointerId);
    }
}
function $3b3996e8d1fa8468$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $3b3996e8d1fa8468$var$Cb(b), null !== b && $3b3996e8d1fa8468$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $3b3996e8d1fa8468$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $3b3996e8d1fa8468$var$Lc = $3b3996e8d1fa8468$var$Tc($3b3996e8d1fa8468$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $3b3996e8d1fa8468$var$Mc = $3b3996e8d1fa8468$var$Tc($3b3996e8d1fa8468$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $3b3996e8d1fa8468$var$Nc = $3b3996e8d1fa8468$var$Tc($3b3996e8d1fa8468$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $3b3996e8d1fa8468$var$Oc.set(f, $3b3996e8d1fa8468$var$Tc($3b3996e8d1fa8468$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $3b3996e8d1fa8468$var$Pc.set(f, $3b3996e8d1fa8468$var$Tc($3b3996e8d1fa8468$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $3b3996e8d1fa8468$var$Vc(a) {
    var b = $3b3996e8d1fa8468$var$Wc(a.target);
    if (null !== b) {
        var c = $3b3996e8d1fa8468$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $3b3996e8d1fa8468$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $3b3996e8d1fa8468$var$Ic(a.priority, function() {
                        $3b3996e8d1fa8468$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $3b3996e8d1fa8468$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $3b3996e8d1fa8468$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $3b3996e8d1fa8468$var$wb = d;
            c.target.dispatchEvent(d);
            $3b3996e8d1fa8468$var$wb = null;
        } else return b = $3b3996e8d1fa8468$var$Cb(c), null !== b && $3b3996e8d1fa8468$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $3b3996e8d1fa8468$var$Zc(a, b, c) {
    $3b3996e8d1fa8468$var$Xc(a) && c.delete(b);
}
function $3b3996e8d1fa8468$var$$c() {
    $3b3996e8d1fa8468$var$Jc = !1;
    null !== $3b3996e8d1fa8468$var$Lc && $3b3996e8d1fa8468$var$Xc($3b3996e8d1fa8468$var$Lc) && ($3b3996e8d1fa8468$var$Lc = null);
    null !== $3b3996e8d1fa8468$var$Mc && $3b3996e8d1fa8468$var$Xc($3b3996e8d1fa8468$var$Mc) && ($3b3996e8d1fa8468$var$Mc = null);
    null !== $3b3996e8d1fa8468$var$Nc && $3b3996e8d1fa8468$var$Xc($3b3996e8d1fa8468$var$Nc) && ($3b3996e8d1fa8468$var$Nc = null);
    $3b3996e8d1fa8468$var$Oc.forEach($3b3996e8d1fa8468$var$Zc);
    $3b3996e8d1fa8468$var$Pc.forEach($3b3996e8d1fa8468$var$Zc);
}
function $3b3996e8d1fa8468$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $3b3996e8d1fa8468$var$Jc || ($3b3996e8d1fa8468$var$Jc = !0, $j1S5s.unstable_scheduleCallback($j1S5s.unstable_NormalPriority, $3b3996e8d1fa8468$var$$c)));
}
function $3b3996e8d1fa8468$var$bd(a) {
    function b(b) {
        return $3b3996e8d1fa8468$var$ad(b, a);
    }
    if (0 < $3b3996e8d1fa8468$var$Kc.length) {
        $3b3996e8d1fa8468$var$ad($3b3996e8d1fa8468$var$Kc[0], a);
        for(var c = 1; c < $3b3996e8d1fa8468$var$Kc.length; c++){
            var d = $3b3996e8d1fa8468$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $3b3996e8d1fa8468$var$Lc && $3b3996e8d1fa8468$var$ad($3b3996e8d1fa8468$var$Lc, a);
    null !== $3b3996e8d1fa8468$var$Mc && $3b3996e8d1fa8468$var$ad($3b3996e8d1fa8468$var$Mc, a);
    null !== $3b3996e8d1fa8468$var$Nc && $3b3996e8d1fa8468$var$ad($3b3996e8d1fa8468$var$Nc, a);
    $3b3996e8d1fa8468$var$Oc.forEach(b);
    $3b3996e8d1fa8468$var$Pc.forEach(b);
    for(c = 0; c < $3b3996e8d1fa8468$var$Qc.length; c++)d = $3b3996e8d1fa8468$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $3b3996e8d1fa8468$var$Qc.length && (c = $3b3996e8d1fa8468$var$Qc[0], null === c.blockedOn);)$3b3996e8d1fa8468$var$Vc(c), null === c.blockedOn && $3b3996e8d1fa8468$var$Qc.shift();
}
var $3b3996e8d1fa8468$var$cd = $3b3996e8d1fa8468$var$ua.ReactCurrentBatchConfig, $3b3996e8d1fa8468$var$dd = !0;
function $3b3996e8d1fa8468$var$ed(a, b, c, d) {
    var e = $3b3996e8d1fa8468$var$C, f = $3b3996e8d1fa8468$var$cd.transition;
    $3b3996e8d1fa8468$var$cd.transition = null;
    try {
        $3b3996e8d1fa8468$var$C = 1, $3b3996e8d1fa8468$var$fd(a, b, c, d);
    } finally{
        $3b3996e8d1fa8468$var$C = e, $3b3996e8d1fa8468$var$cd.transition = f;
    }
}
function $3b3996e8d1fa8468$var$gd(a, b, c, d) {
    var e = $3b3996e8d1fa8468$var$C, f = $3b3996e8d1fa8468$var$cd.transition;
    $3b3996e8d1fa8468$var$cd.transition = null;
    try {
        $3b3996e8d1fa8468$var$C = 4, $3b3996e8d1fa8468$var$fd(a, b, c, d);
    } finally{
        $3b3996e8d1fa8468$var$C = e, $3b3996e8d1fa8468$var$cd.transition = f;
    }
}
function $3b3996e8d1fa8468$var$fd(a, b, c, d) {
    if ($3b3996e8d1fa8468$var$dd) {
        var e = $3b3996e8d1fa8468$var$Yc(a, b, c, d);
        if (null === e) $3b3996e8d1fa8468$var$hd(a, b, d, $3b3996e8d1fa8468$var$id, c), $3b3996e8d1fa8468$var$Sc(a, d);
        else if ($3b3996e8d1fa8468$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($3b3996e8d1fa8468$var$Sc(a, d), b & 4 && -1 < $3b3996e8d1fa8468$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $3b3996e8d1fa8468$var$Cb(e);
                null !== f && $3b3996e8d1fa8468$var$Ec(f);
                f = $3b3996e8d1fa8468$var$Yc(a, b, c, d);
                null === f && $3b3996e8d1fa8468$var$hd(a, b, d, $3b3996e8d1fa8468$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $3b3996e8d1fa8468$var$hd(a, b, d, null, c);
    }
}
var $3b3996e8d1fa8468$var$id = null;
function $3b3996e8d1fa8468$var$Yc(a, b, c, d) {
    $3b3996e8d1fa8468$var$id = null;
    a = $3b3996e8d1fa8468$var$xb(d);
    a = $3b3996e8d1fa8468$var$Wc(a);
    if (null !== a) {
        if (b = $3b3996e8d1fa8468$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $3b3996e8d1fa8468$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $3b3996e8d1fa8468$var$id = a;
    return null;
}
function $3b3996e8d1fa8468$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($3b3996e8d1fa8468$var$ec()){
                case $3b3996e8d1fa8468$var$fc:
                    return 1;
                case $3b3996e8d1fa8468$var$gc:
                    return 4;
                case $3b3996e8d1fa8468$var$hc:
                case $3b3996e8d1fa8468$var$ic:
                    return 16;
                case $3b3996e8d1fa8468$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $3b3996e8d1fa8468$var$kd = null, $3b3996e8d1fa8468$var$ld = null, $3b3996e8d1fa8468$var$md = null;
function $3b3996e8d1fa8468$var$nd() {
    if ($3b3996e8d1fa8468$var$md) return $3b3996e8d1fa8468$var$md;
    var a, b = $3b3996e8d1fa8468$var$ld, c = b.length, d, e = "value" in $3b3996e8d1fa8468$var$kd ? $3b3996e8d1fa8468$var$kd.value : $3b3996e8d1fa8468$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $3b3996e8d1fa8468$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $3b3996e8d1fa8468$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $3b3996e8d1fa8468$var$pd() {
    return !0;
}
function $3b3996e8d1fa8468$var$qd() {
    return !1;
}
function $3b3996e8d1fa8468$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $3b3996e8d1fa8468$var$pd : $3b3996e8d1fa8468$var$qd;
        this.isPropagationStopped = $3b3996e8d1fa8468$var$qd;
        return this;
    }
    $3b3996e8d1fa8468$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $3b3996e8d1fa8468$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $3b3996e8d1fa8468$var$pd);
        },
        persist: function() {},
        isPersistent: $3b3996e8d1fa8468$var$pd
    });
    return b;
}
var $3b3996e8d1fa8468$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $3b3996e8d1fa8468$var$td = $3b3996e8d1fa8468$var$rd($3b3996e8d1fa8468$var$sd), $3b3996e8d1fa8468$var$ud = $3b3996e8d1fa8468$var$A({}, $3b3996e8d1fa8468$var$sd, {
    view: 0,
    detail: 0
}), $3b3996e8d1fa8468$var$vd = $3b3996e8d1fa8468$var$rd($3b3996e8d1fa8468$var$ud), $3b3996e8d1fa8468$var$wd, $3b3996e8d1fa8468$var$xd, $3b3996e8d1fa8468$var$yd, $3b3996e8d1fa8468$var$Ad = $3b3996e8d1fa8468$var$A({}, $3b3996e8d1fa8468$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $3b3996e8d1fa8468$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $3b3996e8d1fa8468$var$yd && ($3b3996e8d1fa8468$var$yd && "mousemove" === a.type ? ($3b3996e8d1fa8468$var$wd = a.screenX - $3b3996e8d1fa8468$var$yd.screenX, $3b3996e8d1fa8468$var$xd = a.screenY - $3b3996e8d1fa8468$var$yd.screenY) : $3b3996e8d1fa8468$var$xd = $3b3996e8d1fa8468$var$wd = 0, $3b3996e8d1fa8468$var$yd = a);
        return $3b3996e8d1fa8468$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $3b3996e8d1fa8468$var$xd;
    }
}), $3b3996e8d1fa8468$var$Bd = $3b3996e8d1fa8468$var$rd($3b3996e8d1fa8468$var$Ad), $3b3996e8d1fa8468$var$Cd = $3b3996e8d1fa8468$var$A({}, $3b3996e8d1fa8468$var$Ad, {
    dataTransfer: 0
}), $3b3996e8d1fa8468$var$Dd = $3b3996e8d1fa8468$var$rd($3b3996e8d1fa8468$var$Cd), $3b3996e8d1fa8468$var$Ed = $3b3996e8d1fa8468$var$A({}, $3b3996e8d1fa8468$var$ud, {
    relatedTarget: 0
}), $3b3996e8d1fa8468$var$Fd = $3b3996e8d1fa8468$var$rd($3b3996e8d1fa8468$var$Ed), $3b3996e8d1fa8468$var$Gd = $3b3996e8d1fa8468$var$A({}, $3b3996e8d1fa8468$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $3b3996e8d1fa8468$var$Hd = $3b3996e8d1fa8468$var$rd($3b3996e8d1fa8468$var$Gd), $3b3996e8d1fa8468$var$Id = $3b3996e8d1fa8468$var$A({}, $3b3996e8d1fa8468$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $3b3996e8d1fa8468$var$Jd = $3b3996e8d1fa8468$var$rd($3b3996e8d1fa8468$var$Id), $3b3996e8d1fa8468$var$Kd = $3b3996e8d1fa8468$var$A({}, $3b3996e8d1fa8468$var$sd, {
    data: 0
}), $3b3996e8d1fa8468$var$Ld = $3b3996e8d1fa8468$var$rd($3b3996e8d1fa8468$var$Kd), $3b3996e8d1fa8468$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $3b3996e8d1fa8468$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $3b3996e8d1fa8468$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $3b3996e8d1fa8468$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $3b3996e8d1fa8468$var$Od[a]) ? !!b[a] : !1;
}
function $3b3996e8d1fa8468$var$zd() {
    return $3b3996e8d1fa8468$var$Pd;
}
var $3b3996e8d1fa8468$var$Qd = $3b3996e8d1fa8468$var$A({}, $3b3996e8d1fa8468$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $3b3996e8d1fa8468$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $3b3996e8d1fa8468$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $3b3996e8d1fa8468$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $3b3996e8d1fa8468$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $3b3996e8d1fa8468$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $3b3996e8d1fa8468$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $3b3996e8d1fa8468$var$Rd = $3b3996e8d1fa8468$var$rd($3b3996e8d1fa8468$var$Qd), $3b3996e8d1fa8468$var$Sd = $3b3996e8d1fa8468$var$A({}, $3b3996e8d1fa8468$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $3b3996e8d1fa8468$var$Td = $3b3996e8d1fa8468$var$rd($3b3996e8d1fa8468$var$Sd), $3b3996e8d1fa8468$var$Ud = $3b3996e8d1fa8468$var$A({}, $3b3996e8d1fa8468$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $3b3996e8d1fa8468$var$zd
}), $3b3996e8d1fa8468$var$Vd = $3b3996e8d1fa8468$var$rd($3b3996e8d1fa8468$var$Ud), $3b3996e8d1fa8468$var$Wd = $3b3996e8d1fa8468$var$A({}, $3b3996e8d1fa8468$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $3b3996e8d1fa8468$var$Xd = $3b3996e8d1fa8468$var$rd($3b3996e8d1fa8468$var$Wd), $3b3996e8d1fa8468$var$Yd = $3b3996e8d1fa8468$var$A({}, $3b3996e8d1fa8468$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $3b3996e8d1fa8468$var$Zd = $3b3996e8d1fa8468$var$rd($3b3996e8d1fa8468$var$Yd), $3b3996e8d1fa8468$var$$d = [
    9,
    13,
    27,
    32
], $3b3996e8d1fa8468$var$ae = $3b3996e8d1fa8468$var$ia && "CompositionEvent" in window, $3b3996e8d1fa8468$var$be = null;
$3b3996e8d1fa8468$var$ia && "documentMode" in document && ($3b3996e8d1fa8468$var$be = document.documentMode);
var $3b3996e8d1fa8468$var$ce = $3b3996e8d1fa8468$var$ia && "TextEvent" in window && !$3b3996e8d1fa8468$var$be, $3b3996e8d1fa8468$var$de = $3b3996e8d1fa8468$var$ia && (!$3b3996e8d1fa8468$var$ae || $3b3996e8d1fa8468$var$be && 8 < $3b3996e8d1fa8468$var$be && 11 >= $3b3996e8d1fa8468$var$be), $3b3996e8d1fa8468$var$ee = String.fromCharCode(32), $3b3996e8d1fa8468$var$fe = !1;
function $3b3996e8d1fa8468$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $3b3996e8d1fa8468$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $3b3996e8d1fa8468$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $3b3996e8d1fa8468$var$ie = !1;
function $3b3996e8d1fa8468$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $3b3996e8d1fa8468$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $3b3996e8d1fa8468$var$fe = !0;
            return $3b3996e8d1fa8468$var$ee;
        case "textInput":
            return a = b.data, a === $3b3996e8d1fa8468$var$ee && $3b3996e8d1fa8468$var$fe ? null : a;
        default:
            return null;
    }
}
function $3b3996e8d1fa8468$var$ke(a, b) {
    if ($3b3996e8d1fa8468$var$ie) return "compositionend" === a || !$3b3996e8d1fa8468$var$ae && $3b3996e8d1fa8468$var$ge(a, b) ? (a = $3b3996e8d1fa8468$var$nd(), $3b3996e8d1fa8468$var$md = $3b3996e8d1fa8468$var$ld = $3b3996e8d1fa8468$var$kd = null, $3b3996e8d1fa8468$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $3b3996e8d1fa8468$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $3b3996e8d1fa8468$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $3b3996e8d1fa8468$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$3b3996e8d1fa8468$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $3b3996e8d1fa8468$var$ne(a, b, c, d) {
    $3b3996e8d1fa8468$var$Eb(d);
    b = $3b3996e8d1fa8468$var$oe(b, "onChange");
    0 < b.length && (c = new $3b3996e8d1fa8468$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $3b3996e8d1fa8468$var$pe = null, $3b3996e8d1fa8468$var$qe = null;
function $3b3996e8d1fa8468$var$re(a) {
    $3b3996e8d1fa8468$var$se(a, 0);
}
function $3b3996e8d1fa8468$var$te(a) {
    var b = $3b3996e8d1fa8468$var$ue(a);
    if ($3b3996e8d1fa8468$var$Wa(b)) return a;
}
function $3b3996e8d1fa8468$var$ve(a, b) {
    if ("change" === a) return b;
}
var $3b3996e8d1fa8468$var$we = !1;
if ($3b3996e8d1fa8468$var$ia) {
    var $3b3996e8d1fa8468$var$xe;
    if ($3b3996e8d1fa8468$var$ia) {
        var $3b3996e8d1fa8468$var$ye = "oninput" in document;
        if (!$3b3996e8d1fa8468$var$ye) {
            var $3b3996e8d1fa8468$var$ze = document.createElement("div");
            $3b3996e8d1fa8468$var$ze.setAttribute("oninput", "return;");
            $3b3996e8d1fa8468$var$ye = "function" === typeof $3b3996e8d1fa8468$var$ze.oninput;
        }
        $3b3996e8d1fa8468$var$xe = $3b3996e8d1fa8468$var$ye;
    } else $3b3996e8d1fa8468$var$xe = !1;
    $3b3996e8d1fa8468$var$we = $3b3996e8d1fa8468$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $3b3996e8d1fa8468$var$Ae() {
    $3b3996e8d1fa8468$var$pe && ($3b3996e8d1fa8468$var$pe.detachEvent("onpropertychange", $3b3996e8d1fa8468$var$Be), $3b3996e8d1fa8468$var$qe = $3b3996e8d1fa8468$var$pe = null);
}
function $3b3996e8d1fa8468$var$Be(a) {
    if ("value" === a.propertyName && $3b3996e8d1fa8468$var$te($3b3996e8d1fa8468$var$qe)) {
        var b = [];
        $3b3996e8d1fa8468$var$ne(b, $3b3996e8d1fa8468$var$qe, a, $3b3996e8d1fa8468$var$xb(a));
        $3b3996e8d1fa8468$var$Jb($3b3996e8d1fa8468$var$re, b);
    }
}
function $3b3996e8d1fa8468$var$Ce(a, b, c) {
    "focusin" === a ? ($3b3996e8d1fa8468$var$Ae(), $3b3996e8d1fa8468$var$pe = b, $3b3996e8d1fa8468$var$qe = c, $3b3996e8d1fa8468$var$pe.attachEvent("onpropertychange", $3b3996e8d1fa8468$var$Be)) : "focusout" === a && $3b3996e8d1fa8468$var$Ae();
}
function $3b3996e8d1fa8468$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $3b3996e8d1fa8468$var$te($3b3996e8d1fa8468$var$qe);
}
function $3b3996e8d1fa8468$var$Ee(a, b) {
    if ("click" === a) return $3b3996e8d1fa8468$var$te(b);
}
function $3b3996e8d1fa8468$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $3b3996e8d1fa8468$var$te(b);
}
function $3b3996e8d1fa8468$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $3b3996e8d1fa8468$var$He = "function" === typeof Object.is ? Object.is : $3b3996e8d1fa8468$var$Ge;
function $3b3996e8d1fa8468$var$Ie(a, b) {
    if ($3b3996e8d1fa8468$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$3b3996e8d1fa8468$var$ja.call(b, e) || !$3b3996e8d1fa8468$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $3b3996e8d1fa8468$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $3b3996e8d1fa8468$var$Ke(a, b) {
    var c = $3b3996e8d1fa8468$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $3b3996e8d1fa8468$var$Je(c);
    }
}
function $3b3996e8d1fa8468$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $3b3996e8d1fa8468$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $3b3996e8d1fa8468$var$Me() {
    for(var a = window, b = $3b3996e8d1fa8468$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $3b3996e8d1fa8468$var$Xa(a.document);
    }
    return b;
}
function $3b3996e8d1fa8468$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $3b3996e8d1fa8468$var$Oe(a) {
    var b = $3b3996e8d1fa8468$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $3b3996e8d1fa8468$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $3b3996e8d1fa8468$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $3b3996e8d1fa8468$var$Ke(c, f);
                var g = $3b3996e8d1fa8468$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $3b3996e8d1fa8468$var$Pe = $3b3996e8d1fa8468$var$ia && "documentMode" in document && 11 >= document.documentMode, $3b3996e8d1fa8468$var$Qe = null, $3b3996e8d1fa8468$var$Re = null, $3b3996e8d1fa8468$var$Se = null, $3b3996e8d1fa8468$var$Te = !1;
function $3b3996e8d1fa8468$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $3b3996e8d1fa8468$var$Te || null == $3b3996e8d1fa8468$var$Qe || $3b3996e8d1fa8468$var$Qe !== $3b3996e8d1fa8468$var$Xa(d) || (d = $3b3996e8d1fa8468$var$Qe, "selectionStart" in d && $3b3996e8d1fa8468$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $3b3996e8d1fa8468$var$Se && $3b3996e8d1fa8468$var$Ie($3b3996e8d1fa8468$var$Se, d) || ($3b3996e8d1fa8468$var$Se = d, d = $3b3996e8d1fa8468$var$oe($3b3996e8d1fa8468$var$Re, "onSelect"), 0 < d.length && (b = new $3b3996e8d1fa8468$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $3b3996e8d1fa8468$var$Qe)));
}
function $3b3996e8d1fa8468$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $3b3996e8d1fa8468$var$We = {
    animationend: $3b3996e8d1fa8468$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $3b3996e8d1fa8468$var$Ve("Animation", "AnimationIteration"),
    animationstart: $3b3996e8d1fa8468$var$Ve("Animation", "AnimationStart"),
    transitionend: $3b3996e8d1fa8468$var$Ve("Transition", "TransitionEnd")
}, $3b3996e8d1fa8468$var$Xe = {}, $3b3996e8d1fa8468$var$Ye = {};
$3b3996e8d1fa8468$var$ia && ($3b3996e8d1fa8468$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $3b3996e8d1fa8468$var$We.animationend.animation, delete $3b3996e8d1fa8468$var$We.animationiteration.animation, delete $3b3996e8d1fa8468$var$We.animationstart.animation), "TransitionEvent" in window || delete $3b3996e8d1fa8468$var$We.transitionend.transition);
function $3b3996e8d1fa8468$var$Ze(a) {
    if ($3b3996e8d1fa8468$var$Xe[a]) return $3b3996e8d1fa8468$var$Xe[a];
    if (!$3b3996e8d1fa8468$var$We[a]) return a;
    var b = $3b3996e8d1fa8468$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $3b3996e8d1fa8468$var$Ye) return $3b3996e8d1fa8468$var$Xe[a] = b[c];
    return a;
}
var $3b3996e8d1fa8468$var$$e = $3b3996e8d1fa8468$var$Ze("animationend"), $3b3996e8d1fa8468$var$af = $3b3996e8d1fa8468$var$Ze("animationiteration"), $3b3996e8d1fa8468$var$bf = $3b3996e8d1fa8468$var$Ze("animationstart"), $3b3996e8d1fa8468$var$cf = $3b3996e8d1fa8468$var$Ze("transitionend"), $3b3996e8d1fa8468$var$df = new Map, $3b3996e8d1fa8468$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $3b3996e8d1fa8468$var$ff(a, b) {
    $3b3996e8d1fa8468$var$df.set(a, b);
    $3b3996e8d1fa8468$var$fa(b, [
        a
    ]);
}
for(var $3b3996e8d1fa8468$var$gf = 0; $3b3996e8d1fa8468$var$gf < $3b3996e8d1fa8468$var$ef.length; $3b3996e8d1fa8468$var$gf++){
    var $3b3996e8d1fa8468$var$hf = $3b3996e8d1fa8468$var$ef[$3b3996e8d1fa8468$var$gf], $3b3996e8d1fa8468$var$jf = $3b3996e8d1fa8468$var$hf.toLowerCase(), $3b3996e8d1fa8468$var$kf = $3b3996e8d1fa8468$var$hf[0].toUpperCase() + $3b3996e8d1fa8468$var$hf.slice(1);
    $3b3996e8d1fa8468$var$ff($3b3996e8d1fa8468$var$jf, "on" + $3b3996e8d1fa8468$var$kf);
}
$3b3996e8d1fa8468$var$ff($3b3996e8d1fa8468$var$$e, "onAnimationEnd");
$3b3996e8d1fa8468$var$ff($3b3996e8d1fa8468$var$af, "onAnimationIteration");
$3b3996e8d1fa8468$var$ff($3b3996e8d1fa8468$var$bf, "onAnimationStart");
$3b3996e8d1fa8468$var$ff("dblclick", "onDoubleClick");
$3b3996e8d1fa8468$var$ff("focusin", "onFocus");
$3b3996e8d1fa8468$var$ff("focusout", "onBlur");
$3b3996e8d1fa8468$var$ff($3b3996e8d1fa8468$var$cf, "onTransitionEnd");
$3b3996e8d1fa8468$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$3b3996e8d1fa8468$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$3b3996e8d1fa8468$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$3b3996e8d1fa8468$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$3b3996e8d1fa8468$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$3b3996e8d1fa8468$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$3b3996e8d1fa8468$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$3b3996e8d1fa8468$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$3b3996e8d1fa8468$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$3b3996e8d1fa8468$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $3b3996e8d1fa8468$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $3b3996e8d1fa8468$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($3b3996e8d1fa8468$var$lf));
function $3b3996e8d1fa8468$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $3b3996e8d1fa8468$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $3b3996e8d1fa8468$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $3b3996e8d1fa8468$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $3b3996e8d1fa8468$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($3b3996e8d1fa8468$var$Qb) throw a = $3b3996e8d1fa8468$var$Rb, $3b3996e8d1fa8468$var$Qb = !1, $3b3996e8d1fa8468$var$Rb = null, a;
}
function $3b3996e8d1fa8468$var$D(a, b) {
    var c = b[$3b3996e8d1fa8468$var$of];
    void 0 === c && (c = b[$3b3996e8d1fa8468$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($3b3996e8d1fa8468$var$pf(b, a, 2, !1), c.add(d));
}
function $3b3996e8d1fa8468$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $3b3996e8d1fa8468$var$pf(c, a, d, b);
}
var $3b3996e8d1fa8468$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $3b3996e8d1fa8468$var$sf(a) {
    if (!a[$3b3996e8d1fa8468$var$rf]) {
        a[$3b3996e8d1fa8468$var$rf] = !0;
        $3b3996e8d1fa8468$var$da.forEach(function(b) {
            "selectionchange" !== b && ($3b3996e8d1fa8468$var$mf.has(b) || $3b3996e8d1fa8468$var$qf(b, !1, a), $3b3996e8d1fa8468$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$3b3996e8d1fa8468$var$rf] || (b[$3b3996e8d1fa8468$var$rf] = !0, $3b3996e8d1fa8468$var$qf("selectionchange", !1, b));
    }
}
function $3b3996e8d1fa8468$var$pf(a, b, c, d) {
    switch($3b3996e8d1fa8468$var$jd(b)){
        case 1:
            var e = $3b3996e8d1fa8468$var$ed;
            break;
        case 4:
            e = $3b3996e8d1fa8468$var$gd;
            break;
        default:
            e = $3b3996e8d1fa8468$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$3b3996e8d1fa8468$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $3b3996e8d1fa8468$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $3b3996e8d1fa8468$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $3b3996e8d1fa8468$var$Jb(function() {
        var d = f, e = $3b3996e8d1fa8468$var$xb(c), g = [];
        a: {
            var h = $3b3996e8d1fa8468$var$df.get(a);
            if (void 0 !== h) {
                var k = $3b3996e8d1fa8468$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $3b3996e8d1fa8468$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $3b3996e8d1fa8468$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $3b3996e8d1fa8468$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $3b3996e8d1fa8468$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $3b3996e8d1fa8468$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $3b3996e8d1fa8468$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $3b3996e8d1fa8468$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $3b3996e8d1fa8468$var$Vd;
                        break;
                    case $3b3996e8d1fa8468$var$$e:
                    case $3b3996e8d1fa8468$var$af:
                    case $3b3996e8d1fa8468$var$bf:
                        k = $3b3996e8d1fa8468$var$Hd;
                        break;
                    case $3b3996e8d1fa8468$var$cf:
                        k = $3b3996e8d1fa8468$var$Xd;
                        break;
                    case "scroll":
                        k = $3b3996e8d1fa8468$var$vd;
                        break;
                    case "wheel":
                        k = $3b3996e8d1fa8468$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $3b3996e8d1fa8468$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $3b3996e8d1fa8468$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $3b3996e8d1fa8468$var$Kb(w, x), null != F && t.push($3b3996e8d1fa8468$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $3b3996e8d1fa8468$var$wb && (n = c.relatedTarget || c.fromElement) && ($3b3996e8d1fa8468$var$Wc(n) || n[$3b3996e8d1fa8468$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $3b3996e8d1fa8468$var$Wc(n) : null, null !== n && (J = $3b3996e8d1fa8468$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $3b3996e8d1fa8468$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $3b3996e8d1fa8468$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $3b3996e8d1fa8468$var$ue(k);
                        u = null == n ? h : $3b3996e8d1fa8468$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $3b3996e8d1fa8468$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $3b3996e8d1fa8468$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $3b3996e8d1fa8468$var$vf(F))u++;
                            for(; 0 < w - u;)t = $3b3996e8d1fa8468$var$vf(t), w--;
                            for(; 0 < u - w;)x = $3b3996e8d1fa8468$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $3b3996e8d1fa8468$var$vf(t);
                                x = $3b3996e8d1fa8468$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $3b3996e8d1fa8468$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $3b3996e8d1fa8468$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $3b3996e8d1fa8468$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $3b3996e8d1fa8468$var$ve;
                else if ($3b3996e8d1fa8468$var$me(h)) {
                    if ($3b3996e8d1fa8468$var$we) na = $3b3996e8d1fa8468$var$Fe;
                    else {
                        na = $3b3996e8d1fa8468$var$De;
                        var xa = $3b3996e8d1fa8468$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $3b3996e8d1fa8468$var$Ee);
                if (na && (na = na(a, d))) {
                    $3b3996e8d1fa8468$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $3b3996e8d1fa8468$var$cb(h, "number", h.value);
            }
            xa = d ? $3b3996e8d1fa8468$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($3b3996e8d1fa8468$var$me(xa) || "true" === xa.contentEditable) $3b3996e8d1fa8468$var$Qe = xa, $3b3996e8d1fa8468$var$Re = d, $3b3996e8d1fa8468$var$Se = null;
                    break;
                case "focusout":
                    $3b3996e8d1fa8468$var$Se = $3b3996e8d1fa8468$var$Re = $3b3996e8d1fa8468$var$Qe = null;
                    break;
                case "mousedown":
                    $3b3996e8d1fa8468$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $3b3996e8d1fa8468$var$Te = !1;
                    $3b3996e8d1fa8468$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($3b3996e8d1fa8468$var$Pe) break;
                case "keydown":
                case "keyup":
                    $3b3996e8d1fa8468$var$Ue(g, c, e);
            }
            var $a;
            if ($3b3996e8d1fa8468$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $3b3996e8d1fa8468$var$ie ? $3b3996e8d1fa8468$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($3b3996e8d1fa8468$var$de && "ko" !== c.locale && ($3b3996e8d1fa8468$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $3b3996e8d1fa8468$var$ie && ($a = $3b3996e8d1fa8468$var$nd()) : ($3b3996e8d1fa8468$var$kd = e, $3b3996e8d1fa8468$var$ld = "value" in $3b3996e8d1fa8468$var$kd ? $3b3996e8d1fa8468$var$kd.value : $3b3996e8d1fa8468$var$kd.textContent, $3b3996e8d1fa8468$var$ie = !0)), xa = $3b3996e8d1fa8468$var$oe(d, ba), 0 < xa.length && (ba = new $3b3996e8d1fa8468$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $3b3996e8d1fa8468$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $3b3996e8d1fa8468$var$ce ? $3b3996e8d1fa8468$var$je(a, c) : $3b3996e8d1fa8468$var$ke(a, c)) d = $3b3996e8d1fa8468$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $3b3996e8d1fa8468$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $3b3996e8d1fa8468$var$se(g, b);
    });
}
function $3b3996e8d1fa8468$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $3b3996e8d1fa8468$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $3b3996e8d1fa8468$var$Kb(a, c), null != f && d.unshift($3b3996e8d1fa8468$var$tf(a, f, e)), f = $3b3996e8d1fa8468$var$Kb(a, b), null != f && d.push($3b3996e8d1fa8468$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $3b3996e8d1fa8468$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $3b3996e8d1fa8468$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $3b3996e8d1fa8468$var$Kb(c, f), null != k && g.unshift($3b3996e8d1fa8468$var$tf(c, k, h))) : e || (k = $3b3996e8d1fa8468$var$Kb(c, f), null != k && g.push($3b3996e8d1fa8468$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $3b3996e8d1fa8468$var$xf = /\r\n?/g, $3b3996e8d1fa8468$var$yf = /\u0000|\uFFFD/g;
function $3b3996e8d1fa8468$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($3b3996e8d1fa8468$var$xf, "\n").replace($3b3996e8d1fa8468$var$yf, "");
}
function $3b3996e8d1fa8468$var$Af(a, b, c) {
    b = $3b3996e8d1fa8468$var$zf(b);
    if ($3b3996e8d1fa8468$var$zf(a) !== b && c) throw Error($3b3996e8d1fa8468$var$p(425));
}
function $3b3996e8d1fa8468$var$Bf() {}
var $3b3996e8d1fa8468$var$Cf = null, $3b3996e8d1fa8468$var$Df = null;
function $3b3996e8d1fa8468$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $3b3996e8d1fa8468$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $3b3996e8d1fa8468$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $3b3996e8d1fa8468$var$Hf = "function" === typeof Promise ? Promise : void 0, $3b3996e8d1fa8468$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $3b3996e8d1fa8468$var$Hf ? function(a) {
    return $3b3996e8d1fa8468$var$Hf.resolve(null).then(a).catch($3b3996e8d1fa8468$var$If);
} : $3b3996e8d1fa8468$var$Ff;
function $3b3996e8d1fa8468$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $3b3996e8d1fa8468$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $3b3996e8d1fa8468$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $3b3996e8d1fa8468$var$bd(b);
}
function $3b3996e8d1fa8468$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $3b3996e8d1fa8468$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $3b3996e8d1fa8468$var$Nf = Math.random().toString(36).slice(2), $3b3996e8d1fa8468$var$Of = "__reactFiber$" + $3b3996e8d1fa8468$var$Nf, $3b3996e8d1fa8468$var$Pf = "__reactProps$" + $3b3996e8d1fa8468$var$Nf, $3b3996e8d1fa8468$var$uf = "__reactContainer$" + $3b3996e8d1fa8468$var$Nf, $3b3996e8d1fa8468$var$of = "__reactEvents$" + $3b3996e8d1fa8468$var$Nf, $3b3996e8d1fa8468$var$Qf = "__reactListeners$" + $3b3996e8d1fa8468$var$Nf, $3b3996e8d1fa8468$var$Rf = "__reactHandles$" + $3b3996e8d1fa8468$var$Nf;
function $3b3996e8d1fa8468$var$Wc(a) {
    var b = a[$3b3996e8d1fa8468$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$3b3996e8d1fa8468$var$uf] || c[$3b3996e8d1fa8468$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $3b3996e8d1fa8468$var$Mf(a); null !== a;){
                if (c = a[$3b3996e8d1fa8468$var$Of]) return c;
                a = $3b3996e8d1fa8468$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $3b3996e8d1fa8468$var$Cb(a) {
    a = a[$3b3996e8d1fa8468$var$Of] || a[$3b3996e8d1fa8468$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $3b3996e8d1fa8468$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($3b3996e8d1fa8468$var$p(33));
}
function $3b3996e8d1fa8468$var$Db(a) {
    return a[$3b3996e8d1fa8468$var$Pf] || null;
}
var $3b3996e8d1fa8468$var$Sf = [], $3b3996e8d1fa8468$var$Tf = -1;
function $3b3996e8d1fa8468$var$Uf(a) {
    return {
        current: a
    };
}
function $3b3996e8d1fa8468$var$E(a) {
    0 > $3b3996e8d1fa8468$var$Tf || (a.current = $3b3996e8d1fa8468$var$Sf[$3b3996e8d1fa8468$var$Tf], $3b3996e8d1fa8468$var$Sf[$3b3996e8d1fa8468$var$Tf] = null, $3b3996e8d1fa8468$var$Tf--);
}
function $3b3996e8d1fa8468$var$G(a, b) {
    $3b3996e8d1fa8468$var$Tf++;
    $3b3996e8d1fa8468$var$Sf[$3b3996e8d1fa8468$var$Tf] = a.current;
    a.current = b;
}
var $3b3996e8d1fa8468$var$Vf = {}, $3b3996e8d1fa8468$var$H = $3b3996e8d1fa8468$var$Uf($3b3996e8d1fa8468$var$Vf), $3b3996e8d1fa8468$var$Wf = $3b3996e8d1fa8468$var$Uf(!1), $3b3996e8d1fa8468$var$Xf = $3b3996e8d1fa8468$var$Vf;
function $3b3996e8d1fa8468$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $3b3996e8d1fa8468$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $3b3996e8d1fa8468$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $3b3996e8d1fa8468$var$$f() {
    $3b3996e8d1fa8468$var$E($3b3996e8d1fa8468$var$Wf);
    $3b3996e8d1fa8468$var$E($3b3996e8d1fa8468$var$H);
}
function $3b3996e8d1fa8468$var$ag(a, b, c) {
    if ($3b3996e8d1fa8468$var$H.current !== $3b3996e8d1fa8468$var$Vf) throw Error($3b3996e8d1fa8468$var$p(168));
    $3b3996e8d1fa8468$var$G($3b3996e8d1fa8468$var$H, b);
    $3b3996e8d1fa8468$var$G($3b3996e8d1fa8468$var$Wf, c);
}
function $3b3996e8d1fa8468$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($3b3996e8d1fa8468$var$p(108, $3b3996e8d1fa8468$var$Ra(a) || "Unknown", e));
    return $3b3996e8d1fa8468$var$A({}, c, d);
}
function $3b3996e8d1fa8468$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $3b3996e8d1fa8468$var$Vf;
    $3b3996e8d1fa8468$var$Xf = $3b3996e8d1fa8468$var$H.current;
    $3b3996e8d1fa8468$var$G($3b3996e8d1fa8468$var$H, a);
    $3b3996e8d1fa8468$var$G($3b3996e8d1fa8468$var$Wf, $3b3996e8d1fa8468$var$Wf.current);
    return !0;
}
function $3b3996e8d1fa8468$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($3b3996e8d1fa8468$var$p(169));
    c ? (a = $3b3996e8d1fa8468$var$bg(a, b, $3b3996e8d1fa8468$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $3b3996e8d1fa8468$var$E($3b3996e8d1fa8468$var$Wf), $3b3996e8d1fa8468$var$E($3b3996e8d1fa8468$var$H), $3b3996e8d1fa8468$var$G($3b3996e8d1fa8468$var$H, a)) : $3b3996e8d1fa8468$var$E($3b3996e8d1fa8468$var$Wf);
    $3b3996e8d1fa8468$var$G($3b3996e8d1fa8468$var$Wf, c);
}
var $3b3996e8d1fa8468$var$eg = null, $3b3996e8d1fa8468$var$fg = !1, $3b3996e8d1fa8468$var$gg = !1;
function $3b3996e8d1fa8468$var$hg(a) {
    null === $3b3996e8d1fa8468$var$eg ? $3b3996e8d1fa8468$var$eg = [
        a
    ] : $3b3996e8d1fa8468$var$eg.push(a);
}
function $3b3996e8d1fa8468$var$ig(a) {
    $3b3996e8d1fa8468$var$fg = !0;
    $3b3996e8d1fa8468$var$hg(a);
}
function $3b3996e8d1fa8468$var$jg() {
    if (!$3b3996e8d1fa8468$var$gg && null !== $3b3996e8d1fa8468$var$eg) {
        $3b3996e8d1fa8468$var$gg = !0;
        var a = 0, b = $3b3996e8d1fa8468$var$C;
        try {
            var c = $3b3996e8d1fa8468$var$eg;
            for($3b3996e8d1fa8468$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $3b3996e8d1fa8468$var$eg = null;
            $3b3996e8d1fa8468$var$fg = !1;
        } catch (e) {
            throw null !== $3b3996e8d1fa8468$var$eg && ($3b3996e8d1fa8468$var$eg = $3b3996e8d1fa8468$var$eg.slice(a + 1)), $3b3996e8d1fa8468$var$ac($3b3996e8d1fa8468$var$fc, $3b3996e8d1fa8468$var$jg), e;
        } finally{
            $3b3996e8d1fa8468$var$C = b, $3b3996e8d1fa8468$var$gg = !1;
        }
    }
    return null;
}
var $3b3996e8d1fa8468$var$kg = [], $3b3996e8d1fa8468$var$lg = 0, $3b3996e8d1fa8468$var$mg = null, $3b3996e8d1fa8468$var$ng = 0, $3b3996e8d1fa8468$var$og = [], $3b3996e8d1fa8468$var$pg = 0, $3b3996e8d1fa8468$var$qg = null, $3b3996e8d1fa8468$var$rg = 1, $3b3996e8d1fa8468$var$sg = "";
function $3b3996e8d1fa8468$var$tg(a, b) {
    $3b3996e8d1fa8468$var$kg[$3b3996e8d1fa8468$var$lg++] = $3b3996e8d1fa8468$var$ng;
    $3b3996e8d1fa8468$var$kg[$3b3996e8d1fa8468$var$lg++] = $3b3996e8d1fa8468$var$mg;
    $3b3996e8d1fa8468$var$mg = a;
    $3b3996e8d1fa8468$var$ng = b;
}
function $3b3996e8d1fa8468$var$ug(a, b, c) {
    $3b3996e8d1fa8468$var$og[$3b3996e8d1fa8468$var$pg++] = $3b3996e8d1fa8468$var$rg;
    $3b3996e8d1fa8468$var$og[$3b3996e8d1fa8468$var$pg++] = $3b3996e8d1fa8468$var$sg;
    $3b3996e8d1fa8468$var$og[$3b3996e8d1fa8468$var$pg++] = $3b3996e8d1fa8468$var$qg;
    $3b3996e8d1fa8468$var$qg = a;
    var d = $3b3996e8d1fa8468$var$rg;
    a = $3b3996e8d1fa8468$var$sg;
    var e = 32 - $3b3996e8d1fa8468$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $3b3996e8d1fa8468$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $3b3996e8d1fa8468$var$rg = 1 << 32 - $3b3996e8d1fa8468$var$oc(b) + e | c << e | d;
        $3b3996e8d1fa8468$var$sg = f + a;
    } else $3b3996e8d1fa8468$var$rg = 1 << f | c << e | d, $3b3996e8d1fa8468$var$sg = a;
}
function $3b3996e8d1fa8468$var$vg(a) {
    null !== a.return && ($3b3996e8d1fa8468$var$tg(a, 1), $3b3996e8d1fa8468$var$ug(a, 1, 0));
}
function $3b3996e8d1fa8468$var$wg(a) {
    for(; a === $3b3996e8d1fa8468$var$mg;)$3b3996e8d1fa8468$var$mg = $3b3996e8d1fa8468$var$kg[--$3b3996e8d1fa8468$var$lg], $3b3996e8d1fa8468$var$kg[$3b3996e8d1fa8468$var$lg] = null, $3b3996e8d1fa8468$var$ng = $3b3996e8d1fa8468$var$kg[--$3b3996e8d1fa8468$var$lg], $3b3996e8d1fa8468$var$kg[$3b3996e8d1fa8468$var$lg] = null;
    for(; a === $3b3996e8d1fa8468$var$qg;)$3b3996e8d1fa8468$var$qg = $3b3996e8d1fa8468$var$og[--$3b3996e8d1fa8468$var$pg], $3b3996e8d1fa8468$var$og[$3b3996e8d1fa8468$var$pg] = null, $3b3996e8d1fa8468$var$sg = $3b3996e8d1fa8468$var$og[--$3b3996e8d1fa8468$var$pg], $3b3996e8d1fa8468$var$og[$3b3996e8d1fa8468$var$pg] = null, $3b3996e8d1fa8468$var$rg = $3b3996e8d1fa8468$var$og[--$3b3996e8d1fa8468$var$pg], $3b3996e8d1fa8468$var$og[$3b3996e8d1fa8468$var$pg] = null;
}
var $3b3996e8d1fa8468$var$xg = null, $3b3996e8d1fa8468$var$yg = null, $3b3996e8d1fa8468$var$I = !1, $3b3996e8d1fa8468$var$zg = null;
function $3b3996e8d1fa8468$var$Ag(a, b) {
    var c = $3b3996e8d1fa8468$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $3b3996e8d1fa8468$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $3b3996e8d1fa8468$var$xg = a, $3b3996e8d1fa8468$var$yg = $3b3996e8d1fa8468$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $3b3996e8d1fa8468$var$xg = a, $3b3996e8d1fa8468$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $3b3996e8d1fa8468$var$qg ? {
                id: $3b3996e8d1fa8468$var$rg,
                overflow: $3b3996e8d1fa8468$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $3b3996e8d1fa8468$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $3b3996e8d1fa8468$var$xg = a, $3b3996e8d1fa8468$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $3b3996e8d1fa8468$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $3b3996e8d1fa8468$var$Eg(a) {
    if ($3b3996e8d1fa8468$var$I) {
        var b = $3b3996e8d1fa8468$var$yg;
        if (b) {
            var c = b;
            if (!$3b3996e8d1fa8468$var$Cg(a, b)) {
                if ($3b3996e8d1fa8468$var$Dg(a)) throw Error($3b3996e8d1fa8468$var$p(418));
                b = $3b3996e8d1fa8468$var$Lf(c.nextSibling);
                var d = $3b3996e8d1fa8468$var$xg;
                b && $3b3996e8d1fa8468$var$Cg(a, b) ? $3b3996e8d1fa8468$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $3b3996e8d1fa8468$var$I = !1, $3b3996e8d1fa8468$var$xg = a);
            }
        } else {
            if ($3b3996e8d1fa8468$var$Dg(a)) throw Error($3b3996e8d1fa8468$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $3b3996e8d1fa8468$var$I = !1;
            $3b3996e8d1fa8468$var$xg = a;
        }
    }
}
function $3b3996e8d1fa8468$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $3b3996e8d1fa8468$var$xg = a;
}
function $3b3996e8d1fa8468$var$Gg(a) {
    if (a !== $3b3996e8d1fa8468$var$xg) return !1;
    if (!$3b3996e8d1fa8468$var$I) return $3b3996e8d1fa8468$var$Fg(a), $3b3996e8d1fa8468$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$3b3996e8d1fa8468$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $3b3996e8d1fa8468$var$yg)) {
        if ($3b3996e8d1fa8468$var$Dg(a)) throw $3b3996e8d1fa8468$var$Hg(), Error($3b3996e8d1fa8468$var$p(418));
        for(; b;)$3b3996e8d1fa8468$var$Ag(a, b), b = $3b3996e8d1fa8468$var$Lf(b.nextSibling);
    }
    $3b3996e8d1fa8468$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($3b3996e8d1fa8468$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $3b3996e8d1fa8468$var$yg = $3b3996e8d1fa8468$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $3b3996e8d1fa8468$var$yg = null;
        }
    } else $3b3996e8d1fa8468$var$yg = $3b3996e8d1fa8468$var$xg ? $3b3996e8d1fa8468$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $3b3996e8d1fa8468$var$Hg() {
    for(var a = $3b3996e8d1fa8468$var$yg; a;)a = $3b3996e8d1fa8468$var$Lf(a.nextSibling);
}
function $3b3996e8d1fa8468$var$Ig() {
    $3b3996e8d1fa8468$var$yg = $3b3996e8d1fa8468$var$xg = null;
    $3b3996e8d1fa8468$var$I = !1;
}
function $3b3996e8d1fa8468$var$Jg(a) {
    null === $3b3996e8d1fa8468$var$zg ? $3b3996e8d1fa8468$var$zg = [
        a
    ] : $3b3996e8d1fa8468$var$zg.push(a);
}
var $3b3996e8d1fa8468$var$Kg = $3b3996e8d1fa8468$var$ua.ReactCurrentBatchConfig;
function $3b3996e8d1fa8468$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($3b3996e8d1fa8468$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($3b3996e8d1fa8468$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($3b3996e8d1fa8468$var$p(284));
        if (!c._owner) throw Error($3b3996e8d1fa8468$var$p(290, a));
    }
    return a;
}
function $3b3996e8d1fa8468$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($3b3996e8d1fa8468$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $3b3996e8d1fa8468$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $3b3996e8d1fa8468$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $3b3996e8d1fa8468$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $3b3996e8d1fa8468$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $3b3996e8d1fa8468$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $3b3996e8d1fa8468$var$Ha && $3b3996e8d1fa8468$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $3b3996e8d1fa8468$var$Lg(a, b, c), d.return = a, d;
        d = $3b3996e8d1fa8468$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $3b3996e8d1fa8468$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $3b3996e8d1fa8468$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $3b3996e8d1fa8468$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $3b3996e8d1fa8468$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $3b3996e8d1fa8468$var$va:
                    return c = $3b3996e8d1fa8468$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $3b3996e8d1fa8468$var$Lg(a, null, b), c.return = a, c;
                case $3b3996e8d1fa8468$var$wa:
                    return b = $3b3996e8d1fa8468$var$Sg(b, a.mode, c), b.return = a, b;
                case $3b3996e8d1fa8468$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($3b3996e8d1fa8468$var$eb(b) || $3b3996e8d1fa8468$var$Ka(b)) return b = $3b3996e8d1fa8468$var$Tg(b, a.mode, c, null), b.return = a, b;
            $3b3996e8d1fa8468$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $3b3996e8d1fa8468$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $3b3996e8d1fa8468$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $3b3996e8d1fa8468$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($3b3996e8d1fa8468$var$eb(c) || $3b3996e8d1fa8468$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $3b3996e8d1fa8468$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $3b3996e8d1fa8468$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $3b3996e8d1fa8468$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $3b3996e8d1fa8468$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($3b3996e8d1fa8468$var$eb(d) || $3b3996e8d1fa8468$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $3b3996e8d1fa8468$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $3b3996e8d1fa8468$var$I && $3b3996e8d1fa8468$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $3b3996e8d1fa8468$var$I && $3b3996e8d1fa8468$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $3b3996e8d1fa8468$var$I && $3b3996e8d1fa8468$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $3b3996e8d1fa8468$var$Ka(h);
        if ("function" !== typeof l) throw Error($3b3996e8d1fa8468$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($3b3996e8d1fa8468$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $3b3996e8d1fa8468$var$I && $3b3996e8d1fa8468$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $3b3996e8d1fa8468$var$I && $3b3996e8d1fa8468$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $3b3996e8d1fa8468$var$I && $3b3996e8d1fa8468$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $3b3996e8d1fa8468$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $3b3996e8d1fa8468$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $3b3996e8d1fa8468$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $3b3996e8d1fa8468$var$Ha && $3b3996e8d1fa8468$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $3b3996e8d1fa8468$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $3b3996e8d1fa8468$var$ya ? (d = $3b3996e8d1fa8468$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $3b3996e8d1fa8468$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $3b3996e8d1fa8468$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $3b3996e8d1fa8468$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $3b3996e8d1fa8468$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $3b3996e8d1fa8468$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($3b3996e8d1fa8468$var$eb(f)) return n(a, d, f, h);
            if ($3b3996e8d1fa8468$var$Ka(f)) return t(a, d, f, h);
            $3b3996e8d1fa8468$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $3b3996e8d1fa8468$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $3b3996e8d1fa8468$var$Ug = $3b3996e8d1fa8468$var$Og(!0), $3b3996e8d1fa8468$var$Vg = $3b3996e8d1fa8468$var$Og(!1), $3b3996e8d1fa8468$var$Wg = $3b3996e8d1fa8468$var$Uf(null), $3b3996e8d1fa8468$var$Xg = null, $3b3996e8d1fa8468$var$Yg = null, $3b3996e8d1fa8468$var$Zg = null;
function $3b3996e8d1fa8468$var$$g() {
    $3b3996e8d1fa8468$var$Zg = $3b3996e8d1fa8468$var$Yg = $3b3996e8d1fa8468$var$Xg = null;
}
function $3b3996e8d1fa8468$var$ah(a) {
    var b = $3b3996e8d1fa8468$var$Wg.current;
    $3b3996e8d1fa8468$var$E($3b3996e8d1fa8468$var$Wg);
    a._currentValue = b;
}
function $3b3996e8d1fa8468$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $3b3996e8d1fa8468$var$ch(a, b) {
    $3b3996e8d1fa8468$var$Xg = a;
    $3b3996e8d1fa8468$var$Zg = $3b3996e8d1fa8468$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($3b3996e8d1fa8468$var$dh = !0), a.firstContext = null);
}
function $3b3996e8d1fa8468$var$eh(a) {
    var b = a._currentValue;
    if ($3b3996e8d1fa8468$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $3b3996e8d1fa8468$var$Yg) {
            if (null === $3b3996e8d1fa8468$var$Xg) throw Error($3b3996e8d1fa8468$var$p(308));
            $3b3996e8d1fa8468$var$Yg = a;
            $3b3996e8d1fa8468$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $3b3996e8d1fa8468$var$Yg = $3b3996e8d1fa8468$var$Yg.next = a;
    }
    return b;
}
var $3b3996e8d1fa8468$var$fh = null;
function $3b3996e8d1fa8468$var$gh(a) {
    null === $3b3996e8d1fa8468$var$fh ? $3b3996e8d1fa8468$var$fh = [
        a
    ] : $3b3996e8d1fa8468$var$fh.push(a);
}
function $3b3996e8d1fa8468$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $3b3996e8d1fa8468$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $3b3996e8d1fa8468$var$ih(a, d);
}
function $3b3996e8d1fa8468$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $3b3996e8d1fa8468$var$jh = !1;
function $3b3996e8d1fa8468$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $3b3996e8d1fa8468$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $3b3996e8d1fa8468$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $3b3996e8d1fa8468$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($3b3996e8d1fa8468$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $3b3996e8d1fa8468$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $3b3996e8d1fa8468$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $3b3996e8d1fa8468$var$ih(a, c);
}
function $3b3996e8d1fa8468$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $3b3996e8d1fa8468$var$Cc(a, c);
    }
}
function $3b3996e8d1fa8468$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $3b3996e8d1fa8468$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $3b3996e8d1fa8468$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $3b3996e8d1fa8468$var$A({}, q, r);
                            break a;
                        case 2:
                            $3b3996e8d1fa8468$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $3b3996e8d1fa8468$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $3b3996e8d1fa8468$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($3b3996e8d1fa8468$var$p(191, e));
            e.call(d);
        }
    }
}
var $3b3996e8d1fa8468$var$th = {}, $3b3996e8d1fa8468$var$uh = $3b3996e8d1fa8468$var$Uf($3b3996e8d1fa8468$var$th), $3b3996e8d1fa8468$var$vh = $3b3996e8d1fa8468$var$Uf($3b3996e8d1fa8468$var$th), $3b3996e8d1fa8468$var$wh = $3b3996e8d1fa8468$var$Uf($3b3996e8d1fa8468$var$th);
function $3b3996e8d1fa8468$var$xh(a) {
    if (a === $3b3996e8d1fa8468$var$th) throw Error($3b3996e8d1fa8468$var$p(174));
    return a;
}
function $3b3996e8d1fa8468$var$yh(a, b) {
    $3b3996e8d1fa8468$var$G($3b3996e8d1fa8468$var$wh, b);
    $3b3996e8d1fa8468$var$G($3b3996e8d1fa8468$var$vh, a);
    $3b3996e8d1fa8468$var$G($3b3996e8d1fa8468$var$uh, $3b3996e8d1fa8468$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $3b3996e8d1fa8468$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $3b3996e8d1fa8468$var$lb(b, a);
    }
    $3b3996e8d1fa8468$var$E($3b3996e8d1fa8468$var$uh);
    $3b3996e8d1fa8468$var$G($3b3996e8d1fa8468$var$uh, b);
}
function $3b3996e8d1fa8468$var$zh() {
    $3b3996e8d1fa8468$var$E($3b3996e8d1fa8468$var$uh);
    $3b3996e8d1fa8468$var$E($3b3996e8d1fa8468$var$vh);
    $3b3996e8d1fa8468$var$E($3b3996e8d1fa8468$var$wh);
}
function $3b3996e8d1fa8468$var$Ah(a) {
    $3b3996e8d1fa8468$var$xh($3b3996e8d1fa8468$var$wh.current);
    var b = $3b3996e8d1fa8468$var$xh($3b3996e8d1fa8468$var$uh.current);
    var c = $3b3996e8d1fa8468$var$lb(b, a.type);
    b !== c && ($3b3996e8d1fa8468$var$G($3b3996e8d1fa8468$var$vh, a), $3b3996e8d1fa8468$var$G($3b3996e8d1fa8468$var$uh, c));
}
function $3b3996e8d1fa8468$var$Bh(a) {
    $3b3996e8d1fa8468$var$vh.current === a && ($3b3996e8d1fa8468$var$E($3b3996e8d1fa8468$var$uh), $3b3996e8d1fa8468$var$E($3b3996e8d1fa8468$var$vh));
}
var $3b3996e8d1fa8468$var$L = $3b3996e8d1fa8468$var$Uf(0);
function $3b3996e8d1fa8468$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $3b3996e8d1fa8468$var$Dh = [];
function $3b3996e8d1fa8468$var$Eh() {
    for(var a = 0; a < $3b3996e8d1fa8468$var$Dh.length; a++)$3b3996e8d1fa8468$var$Dh[a]._workInProgressVersionPrimary = null;
    $3b3996e8d1fa8468$var$Dh.length = 0;
}
var $3b3996e8d1fa8468$var$Fh = $3b3996e8d1fa8468$var$ua.ReactCurrentDispatcher, $3b3996e8d1fa8468$var$Gh = $3b3996e8d1fa8468$var$ua.ReactCurrentBatchConfig, $3b3996e8d1fa8468$var$Hh = 0, $3b3996e8d1fa8468$var$M = null, $3b3996e8d1fa8468$var$N = null, $3b3996e8d1fa8468$var$O = null, $3b3996e8d1fa8468$var$Ih = !1, $3b3996e8d1fa8468$var$Jh = !1, $3b3996e8d1fa8468$var$Kh = 0, $3b3996e8d1fa8468$var$Lh = 0;
function $3b3996e8d1fa8468$var$P() {
    throw Error($3b3996e8d1fa8468$var$p(321));
}
function $3b3996e8d1fa8468$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$3b3996e8d1fa8468$var$He(a[c], b[c])) return !1;
    return !0;
}
function $3b3996e8d1fa8468$var$Nh(a, b, c, d, e, f) {
    $3b3996e8d1fa8468$var$Hh = f;
    $3b3996e8d1fa8468$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $3b3996e8d1fa8468$var$Fh.current = null === a || null === a.memoizedState ? $3b3996e8d1fa8468$var$Oh : $3b3996e8d1fa8468$var$Ph;
    a = c(d, e);
    if ($3b3996e8d1fa8468$var$Jh) {
        f = 0;
        do {
            $3b3996e8d1fa8468$var$Jh = !1;
            $3b3996e8d1fa8468$var$Kh = 0;
            if (25 <= f) throw Error($3b3996e8d1fa8468$var$p(301));
            f += 1;
            $3b3996e8d1fa8468$var$O = $3b3996e8d1fa8468$var$N = null;
            b.updateQueue = null;
            $3b3996e8d1fa8468$var$Fh.current = $3b3996e8d1fa8468$var$Qh;
            a = c(d, e);
        }while ($3b3996e8d1fa8468$var$Jh);
    }
    $3b3996e8d1fa8468$var$Fh.current = $3b3996e8d1fa8468$var$Rh;
    b = null !== $3b3996e8d1fa8468$var$N && null !== $3b3996e8d1fa8468$var$N.next;
    $3b3996e8d1fa8468$var$Hh = 0;
    $3b3996e8d1fa8468$var$O = $3b3996e8d1fa8468$var$N = $3b3996e8d1fa8468$var$M = null;
    $3b3996e8d1fa8468$var$Ih = !1;
    if (b) throw Error($3b3996e8d1fa8468$var$p(300));
    return a;
}
function $3b3996e8d1fa8468$var$Sh() {
    var a = 0 !== $3b3996e8d1fa8468$var$Kh;
    $3b3996e8d1fa8468$var$Kh = 0;
    return a;
}
function $3b3996e8d1fa8468$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $3b3996e8d1fa8468$var$O ? $3b3996e8d1fa8468$var$M.memoizedState = $3b3996e8d1fa8468$var$O = a : $3b3996e8d1fa8468$var$O = $3b3996e8d1fa8468$var$O.next = a;
    return $3b3996e8d1fa8468$var$O;
}
function $3b3996e8d1fa8468$var$Uh() {
    if (null === $3b3996e8d1fa8468$var$N) {
        var a = $3b3996e8d1fa8468$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $3b3996e8d1fa8468$var$N.next;
    var b = null === $3b3996e8d1fa8468$var$O ? $3b3996e8d1fa8468$var$M.memoizedState : $3b3996e8d1fa8468$var$O.next;
    if (null !== b) $3b3996e8d1fa8468$var$O = b, $3b3996e8d1fa8468$var$N = a;
    else {
        if (null === a) throw Error($3b3996e8d1fa8468$var$p(310));
        $3b3996e8d1fa8468$var$N = a;
        a = {
            memoizedState: $3b3996e8d1fa8468$var$N.memoizedState,
            baseState: $3b3996e8d1fa8468$var$N.baseState,
            baseQueue: $3b3996e8d1fa8468$var$N.baseQueue,
            queue: $3b3996e8d1fa8468$var$N.queue,
            next: null
        };
        null === $3b3996e8d1fa8468$var$O ? $3b3996e8d1fa8468$var$M.memoizedState = $3b3996e8d1fa8468$var$O = a : $3b3996e8d1fa8468$var$O = $3b3996e8d1fa8468$var$O.next = a;
    }
    return $3b3996e8d1fa8468$var$O;
}
function $3b3996e8d1fa8468$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $3b3996e8d1fa8468$var$Wh(a) {
    var b = $3b3996e8d1fa8468$var$Uh(), c = b.queue;
    if (null === c) throw Error($3b3996e8d1fa8468$var$p(311));
    c.lastRenderedReducer = a;
    var d = $3b3996e8d1fa8468$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($3b3996e8d1fa8468$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $3b3996e8d1fa8468$var$M.lanes |= m;
                $3b3996e8d1fa8468$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $3b3996e8d1fa8468$var$He(d, b.memoizedState) || ($3b3996e8d1fa8468$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $3b3996e8d1fa8468$var$M.lanes |= f, $3b3996e8d1fa8468$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $3b3996e8d1fa8468$var$Xh(a) {
    var b = $3b3996e8d1fa8468$var$Uh(), c = b.queue;
    if (null === c) throw Error($3b3996e8d1fa8468$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $3b3996e8d1fa8468$var$He(f, b.memoizedState) || ($3b3996e8d1fa8468$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $3b3996e8d1fa8468$var$Yh() {}
function $3b3996e8d1fa8468$var$Zh(a, b) {
    var c = $3b3996e8d1fa8468$var$M, d = $3b3996e8d1fa8468$var$Uh(), e = b(), f = !$3b3996e8d1fa8468$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $3b3996e8d1fa8468$var$dh = !0);
    d = d.queue;
    $3b3996e8d1fa8468$var$$h($3b3996e8d1fa8468$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $3b3996e8d1fa8468$var$O && $3b3996e8d1fa8468$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $3b3996e8d1fa8468$var$bi(9, $3b3996e8d1fa8468$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $3b3996e8d1fa8468$var$Q) throw Error($3b3996e8d1fa8468$var$p(349));
        0 !== ($3b3996e8d1fa8468$var$Hh & 30) || $3b3996e8d1fa8468$var$di(c, b, e);
    }
    return e;
}
function $3b3996e8d1fa8468$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $3b3996e8d1fa8468$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $3b3996e8d1fa8468$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $3b3996e8d1fa8468$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $3b3996e8d1fa8468$var$ei(b) && $3b3996e8d1fa8468$var$fi(a);
}
function $3b3996e8d1fa8468$var$ai(a, b, c) {
    return c(function() {
        $3b3996e8d1fa8468$var$ei(b) && $3b3996e8d1fa8468$var$fi(a);
    });
}
function $3b3996e8d1fa8468$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$3b3996e8d1fa8468$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $3b3996e8d1fa8468$var$fi(a) {
    var b = $3b3996e8d1fa8468$var$ih(a, 1);
    null !== b && $3b3996e8d1fa8468$var$gi(b, a, 1, -1);
}
function $3b3996e8d1fa8468$var$hi(a) {
    var b = $3b3996e8d1fa8468$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $3b3996e8d1fa8468$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $3b3996e8d1fa8468$var$ii.bind(null, $3b3996e8d1fa8468$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $3b3996e8d1fa8468$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $3b3996e8d1fa8468$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $3b3996e8d1fa8468$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $3b3996e8d1fa8468$var$ji() {
    return $3b3996e8d1fa8468$var$Uh().memoizedState;
}
function $3b3996e8d1fa8468$var$ki(a, b, c, d) {
    var e = $3b3996e8d1fa8468$var$Th();
    $3b3996e8d1fa8468$var$M.flags |= a;
    e.memoizedState = $3b3996e8d1fa8468$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $3b3996e8d1fa8468$var$li(a, b, c, d) {
    var e = $3b3996e8d1fa8468$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $3b3996e8d1fa8468$var$N) {
        var g = $3b3996e8d1fa8468$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $3b3996e8d1fa8468$var$Mh(d, g.deps)) {
            e.memoizedState = $3b3996e8d1fa8468$var$bi(b, c, f, d);
            return;
        }
    }
    $3b3996e8d1fa8468$var$M.flags |= a;
    e.memoizedState = $3b3996e8d1fa8468$var$bi(1 | b, c, f, d);
}
function $3b3996e8d1fa8468$var$mi(a, b) {
    return $3b3996e8d1fa8468$var$ki(8390656, 8, a, b);
}
function $3b3996e8d1fa8468$var$$h(a, b) {
    return $3b3996e8d1fa8468$var$li(2048, 8, a, b);
}
function $3b3996e8d1fa8468$var$ni(a, b) {
    return $3b3996e8d1fa8468$var$li(4, 2, a, b);
}
function $3b3996e8d1fa8468$var$oi(a, b) {
    return $3b3996e8d1fa8468$var$li(4, 4, a, b);
}
function $3b3996e8d1fa8468$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $3b3996e8d1fa8468$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $3b3996e8d1fa8468$var$li(4, 4, $3b3996e8d1fa8468$var$pi.bind(null, b, a), c);
}
function $3b3996e8d1fa8468$var$ri() {}
function $3b3996e8d1fa8468$var$si(a, b) {
    var c = $3b3996e8d1fa8468$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $3b3996e8d1fa8468$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $3b3996e8d1fa8468$var$ti(a, b) {
    var c = $3b3996e8d1fa8468$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $3b3996e8d1fa8468$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $3b3996e8d1fa8468$var$ui(a, b, c) {
    if (0 === ($3b3996e8d1fa8468$var$Hh & 21)) return a.baseState && (a.baseState = !1, $3b3996e8d1fa8468$var$dh = !0), a.memoizedState = c;
    $3b3996e8d1fa8468$var$He(c, b) || (c = $3b3996e8d1fa8468$var$yc(), $3b3996e8d1fa8468$var$M.lanes |= c, $3b3996e8d1fa8468$var$rh |= c, a.baseState = !0);
    return b;
}
function $3b3996e8d1fa8468$var$vi(a, b) {
    var c = $3b3996e8d1fa8468$var$C;
    $3b3996e8d1fa8468$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $3b3996e8d1fa8468$var$Gh.transition;
    $3b3996e8d1fa8468$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $3b3996e8d1fa8468$var$C = c, $3b3996e8d1fa8468$var$Gh.transition = d;
    }
}
function $3b3996e8d1fa8468$var$wi() {
    return $3b3996e8d1fa8468$var$Uh().memoizedState;
}
function $3b3996e8d1fa8468$var$xi(a, b, c) {
    var d = $3b3996e8d1fa8468$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($3b3996e8d1fa8468$var$zi(a)) $3b3996e8d1fa8468$var$Ai(b, c);
    else if (c = $3b3996e8d1fa8468$var$hh(a, b, c, d), null !== c) {
        var e = $3b3996e8d1fa8468$var$R();
        $3b3996e8d1fa8468$var$gi(c, a, d, e);
        $3b3996e8d1fa8468$var$Bi(c, b, d);
    }
}
function $3b3996e8d1fa8468$var$ii(a, b, c) {
    var d = $3b3996e8d1fa8468$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($3b3996e8d1fa8468$var$zi(a)) $3b3996e8d1fa8468$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($3b3996e8d1fa8468$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $3b3996e8d1fa8468$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $3b3996e8d1fa8468$var$hh(a, b, e, d);
        null !== c && (e = $3b3996e8d1fa8468$var$R(), $3b3996e8d1fa8468$var$gi(c, a, d, e), $3b3996e8d1fa8468$var$Bi(c, b, d));
    }
}
function $3b3996e8d1fa8468$var$zi(a) {
    var b = a.alternate;
    return a === $3b3996e8d1fa8468$var$M || null !== b && b === $3b3996e8d1fa8468$var$M;
}
function $3b3996e8d1fa8468$var$Ai(a, b) {
    $3b3996e8d1fa8468$var$Jh = $3b3996e8d1fa8468$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $3b3996e8d1fa8468$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $3b3996e8d1fa8468$var$Cc(a, c);
    }
}
var $3b3996e8d1fa8468$var$Rh = {
    readContext: $3b3996e8d1fa8468$var$eh,
    useCallback: $3b3996e8d1fa8468$var$P,
    useContext: $3b3996e8d1fa8468$var$P,
    useEffect: $3b3996e8d1fa8468$var$P,
    useImperativeHandle: $3b3996e8d1fa8468$var$P,
    useInsertionEffect: $3b3996e8d1fa8468$var$P,
    useLayoutEffect: $3b3996e8d1fa8468$var$P,
    useMemo: $3b3996e8d1fa8468$var$P,
    useReducer: $3b3996e8d1fa8468$var$P,
    useRef: $3b3996e8d1fa8468$var$P,
    useState: $3b3996e8d1fa8468$var$P,
    useDebugValue: $3b3996e8d1fa8468$var$P,
    useDeferredValue: $3b3996e8d1fa8468$var$P,
    useTransition: $3b3996e8d1fa8468$var$P,
    useMutableSource: $3b3996e8d1fa8468$var$P,
    useSyncExternalStore: $3b3996e8d1fa8468$var$P,
    useId: $3b3996e8d1fa8468$var$P,
    unstable_isNewReconciler: !1
}, $3b3996e8d1fa8468$var$Oh = {
    readContext: $3b3996e8d1fa8468$var$eh,
    useCallback: function(a, b) {
        $3b3996e8d1fa8468$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $3b3996e8d1fa8468$var$eh,
    useEffect: $3b3996e8d1fa8468$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $3b3996e8d1fa8468$var$ki(4194308, 4, $3b3996e8d1fa8468$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $3b3996e8d1fa8468$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $3b3996e8d1fa8468$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $3b3996e8d1fa8468$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $3b3996e8d1fa8468$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $3b3996e8d1fa8468$var$xi.bind(null, $3b3996e8d1fa8468$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $3b3996e8d1fa8468$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $3b3996e8d1fa8468$var$hi,
    useDebugValue: $3b3996e8d1fa8468$var$ri,
    useDeferredValue: function(a) {
        return $3b3996e8d1fa8468$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $3b3996e8d1fa8468$var$hi(!1), b = a[0];
        a = $3b3996e8d1fa8468$var$vi.bind(null, a[1]);
        $3b3996e8d1fa8468$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $3b3996e8d1fa8468$var$M, e = $3b3996e8d1fa8468$var$Th();
        if ($3b3996e8d1fa8468$var$I) {
            if (void 0 === c) throw Error($3b3996e8d1fa8468$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $3b3996e8d1fa8468$var$Q) throw Error($3b3996e8d1fa8468$var$p(349));
            0 !== ($3b3996e8d1fa8468$var$Hh & 30) || $3b3996e8d1fa8468$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $3b3996e8d1fa8468$var$mi($3b3996e8d1fa8468$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $3b3996e8d1fa8468$var$bi(9, $3b3996e8d1fa8468$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $3b3996e8d1fa8468$var$Th(), b = $3b3996e8d1fa8468$var$Q.identifierPrefix;
        if ($3b3996e8d1fa8468$var$I) {
            var c = $3b3996e8d1fa8468$var$sg;
            var d = $3b3996e8d1fa8468$var$rg;
            c = (d & ~(1 << 32 - $3b3996e8d1fa8468$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $3b3996e8d1fa8468$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $3b3996e8d1fa8468$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $3b3996e8d1fa8468$var$Ph = {
    readContext: $3b3996e8d1fa8468$var$eh,
    useCallback: $3b3996e8d1fa8468$var$si,
    useContext: $3b3996e8d1fa8468$var$eh,
    useEffect: $3b3996e8d1fa8468$var$$h,
    useImperativeHandle: $3b3996e8d1fa8468$var$qi,
    useInsertionEffect: $3b3996e8d1fa8468$var$ni,
    useLayoutEffect: $3b3996e8d1fa8468$var$oi,
    useMemo: $3b3996e8d1fa8468$var$ti,
    useReducer: $3b3996e8d1fa8468$var$Wh,
    useRef: $3b3996e8d1fa8468$var$ji,
    useState: function() {
        return $3b3996e8d1fa8468$var$Wh($3b3996e8d1fa8468$var$Vh);
    },
    useDebugValue: $3b3996e8d1fa8468$var$ri,
    useDeferredValue: function(a) {
        var b = $3b3996e8d1fa8468$var$Uh();
        return $3b3996e8d1fa8468$var$ui(b, $3b3996e8d1fa8468$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $3b3996e8d1fa8468$var$Wh($3b3996e8d1fa8468$var$Vh)[0], b = $3b3996e8d1fa8468$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $3b3996e8d1fa8468$var$Yh,
    useSyncExternalStore: $3b3996e8d1fa8468$var$Zh,
    useId: $3b3996e8d1fa8468$var$wi,
    unstable_isNewReconciler: !1
}, $3b3996e8d1fa8468$var$Qh = {
    readContext: $3b3996e8d1fa8468$var$eh,
    useCallback: $3b3996e8d1fa8468$var$si,
    useContext: $3b3996e8d1fa8468$var$eh,
    useEffect: $3b3996e8d1fa8468$var$$h,
    useImperativeHandle: $3b3996e8d1fa8468$var$qi,
    useInsertionEffect: $3b3996e8d1fa8468$var$ni,
    useLayoutEffect: $3b3996e8d1fa8468$var$oi,
    useMemo: $3b3996e8d1fa8468$var$ti,
    useReducer: $3b3996e8d1fa8468$var$Xh,
    useRef: $3b3996e8d1fa8468$var$ji,
    useState: function() {
        return $3b3996e8d1fa8468$var$Xh($3b3996e8d1fa8468$var$Vh);
    },
    useDebugValue: $3b3996e8d1fa8468$var$ri,
    useDeferredValue: function(a) {
        var b = $3b3996e8d1fa8468$var$Uh();
        return null === $3b3996e8d1fa8468$var$N ? b.memoizedState = a : $3b3996e8d1fa8468$var$ui(b, $3b3996e8d1fa8468$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $3b3996e8d1fa8468$var$Xh($3b3996e8d1fa8468$var$Vh)[0], b = $3b3996e8d1fa8468$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $3b3996e8d1fa8468$var$Yh,
    useSyncExternalStore: $3b3996e8d1fa8468$var$Zh,
    useId: $3b3996e8d1fa8468$var$wi,
    unstable_isNewReconciler: !1
};
function $3b3996e8d1fa8468$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $3b3996e8d1fa8468$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $3b3996e8d1fa8468$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $3b3996e8d1fa8468$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $3b3996e8d1fa8468$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $3b3996e8d1fa8468$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $3b3996e8d1fa8468$var$R(), e = $3b3996e8d1fa8468$var$yi(a), f = $3b3996e8d1fa8468$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $3b3996e8d1fa8468$var$nh(a, f, e);
        null !== b && ($3b3996e8d1fa8468$var$gi(b, a, e, d), $3b3996e8d1fa8468$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $3b3996e8d1fa8468$var$R(), e = $3b3996e8d1fa8468$var$yi(a), f = $3b3996e8d1fa8468$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $3b3996e8d1fa8468$var$nh(a, f, e);
        null !== b && ($3b3996e8d1fa8468$var$gi(b, a, e, d), $3b3996e8d1fa8468$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $3b3996e8d1fa8468$var$R(), d = $3b3996e8d1fa8468$var$yi(a), e = $3b3996e8d1fa8468$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $3b3996e8d1fa8468$var$nh(a, e, d);
        null !== b && ($3b3996e8d1fa8468$var$gi(b, a, d, c), $3b3996e8d1fa8468$var$oh(b, a, d));
    }
};
function $3b3996e8d1fa8468$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$3b3996e8d1fa8468$var$Ie(c, d) || !$3b3996e8d1fa8468$var$Ie(e, f) : !0;
}
function $3b3996e8d1fa8468$var$Gi(a, b, c) {
    var d = !1, e = $3b3996e8d1fa8468$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $3b3996e8d1fa8468$var$eh(f) : (e = $3b3996e8d1fa8468$var$Zf(b) ? $3b3996e8d1fa8468$var$Xf : $3b3996e8d1fa8468$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $3b3996e8d1fa8468$var$Yf(a, e) : $3b3996e8d1fa8468$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $3b3996e8d1fa8468$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $3b3996e8d1fa8468$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $3b3996e8d1fa8468$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $3b3996e8d1fa8468$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $3b3996e8d1fa8468$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $3b3996e8d1fa8468$var$eh(f) : (f = $3b3996e8d1fa8468$var$Zf(b) ? $3b3996e8d1fa8468$var$Xf : $3b3996e8d1fa8468$var$H.current, e.context = $3b3996e8d1fa8468$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($3b3996e8d1fa8468$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $3b3996e8d1fa8468$var$Ei.enqueueReplaceState(e, e.state, null), $3b3996e8d1fa8468$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $3b3996e8d1fa8468$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $3b3996e8d1fa8468$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $3b3996e8d1fa8468$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $3b3996e8d1fa8468$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $3b3996e8d1fa8468$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $3b3996e8d1fa8468$var$Ni(a, b, c) {
    c = $3b3996e8d1fa8468$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $3b3996e8d1fa8468$var$Oi || ($3b3996e8d1fa8468$var$Oi = !0, $3b3996e8d1fa8468$var$Pi = d);
        $3b3996e8d1fa8468$var$Li(a, b);
    };
    return c;
}
function $3b3996e8d1fa8468$var$Qi(a, b, c) {
    c = $3b3996e8d1fa8468$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $3b3996e8d1fa8468$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $3b3996e8d1fa8468$var$Li(a, b);
        "function" !== typeof d && (null === $3b3996e8d1fa8468$var$Ri ? $3b3996e8d1fa8468$var$Ri = new Set([
            this
        ]) : $3b3996e8d1fa8468$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $3b3996e8d1fa8468$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $3b3996e8d1fa8468$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $3b3996e8d1fa8468$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $3b3996e8d1fa8468$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $3b3996e8d1fa8468$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $3b3996e8d1fa8468$var$mh(-1, 1), b.tag = 2, $3b3996e8d1fa8468$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $3b3996e8d1fa8468$var$Wi = $3b3996e8d1fa8468$var$ua.ReactCurrentOwner, $3b3996e8d1fa8468$var$dh = !1;
function $3b3996e8d1fa8468$var$Xi(a, b, c, d) {
    b.child = null === a ? $3b3996e8d1fa8468$var$Vg(b, null, c, d) : $3b3996e8d1fa8468$var$Ug(b, a.child, c, d);
}
function $3b3996e8d1fa8468$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $3b3996e8d1fa8468$var$ch(b, e);
    d = $3b3996e8d1fa8468$var$Nh(a, b, c, d, f, e);
    c = $3b3996e8d1fa8468$var$Sh();
    if (null !== a && !$3b3996e8d1fa8468$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $3b3996e8d1fa8468$var$Zi(a, b, e);
    $3b3996e8d1fa8468$var$I && c && $3b3996e8d1fa8468$var$vg(b);
    b.flags |= 1;
    $3b3996e8d1fa8468$var$Xi(a, b, d, e);
    return b.child;
}
function $3b3996e8d1fa8468$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$3b3996e8d1fa8468$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $3b3996e8d1fa8468$var$bj(a, b, f, d, e);
        a = $3b3996e8d1fa8468$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $3b3996e8d1fa8468$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $3b3996e8d1fa8468$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $3b3996e8d1fa8468$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $3b3996e8d1fa8468$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($3b3996e8d1fa8468$var$Ie(f, d) && a.ref === b.ref) {
            if ($3b3996e8d1fa8468$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($3b3996e8d1fa8468$var$dh = !0);
            else return b.lanes = a.lanes, $3b3996e8d1fa8468$var$Zi(a, b, e);
        }
    }
    return $3b3996e8d1fa8468$var$cj(a, b, c, d, e);
}
function $3b3996e8d1fa8468$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $3b3996e8d1fa8468$var$G($3b3996e8d1fa8468$var$ej, $3b3996e8d1fa8468$var$fj), $3b3996e8d1fa8468$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $3b3996e8d1fa8468$var$G($3b3996e8d1fa8468$var$ej, $3b3996e8d1fa8468$var$fj), $3b3996e8d1fa8468$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $3b3996e8d1fa8468$var$G($3b3996e8d1fa8468$var$ej, $3b3996e8d1fa8468$var$fj);
            $3b3996e8d1fa8468$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $3b3996e8d1fa8468$var$G($3b3996e8d1fa8468$var$ej, $3b3996e8d1fa8468$var$fj), $3b3996e8d1fa8468$var$fj |= d;
    $3b3996e8d1fa8468$var$Xi(a, b, e, c);
    return b.child;
}
function $3b3996e8d1fa8468$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $3b3996e8d1fa8468$var$cj(a, b, c, d, e) {
    var f = $3b3996e8d1fa8468$var$Zf(c) ? $3b3996e8d1fa8468$var$Xf : $3b3996e8d1fa8468$var$H.current;
    f = $3b3996e8d1fa8468$var$Yf(b, f);
    $3b3996e8d1fa8468$var$ch(b, e);
    c = $3b3996e8d1fa8468$var$Nh(a, b, c, d, f, e);
    d = $3b3996e8d1fa8468$var$Sh();
    if (null !== a && !$3b3996e8d1fa8468$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $3b3996e8d1fa8468$var$Zi(a, b, e);
    $3b3996e8d1fa8468$var$I && d && $3b3996e8d1fa8468$var$vg(b);
    b.flags |= 1;
    $3b3996e8d1fa8468$var$Xi(a, b, c, e);
    return b.child;
}
function $3b3996e8d1fa8468$var$hj(a, b, c, d, e) {
    if ($3b3996e8d1fa8468$var$Zf(c)) {
        var f = !0;
        $3b3996e8d1fa8468$var$cg(b);
    } else f = !1;
    $3b3996e8d1fa8468$var$ch(b, e);
    if (null === b.stateNode) $3b3996e8d1fa8468$var$ij(a, b), $3b3996e8d1fa8468$var$Gi(b, c, d), $3b3996e8d1fa8468$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $3b3996e8d1fa8468$var$eh(l) : (l = $3b3996e8d1fa8468$var$Zf(c) ? $3b3996e8d1fa8468$var$Xf : $3b3996e8d1fa8468$var$H.current, l = $3b3996e8d1fa8468$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $3b3996e8d1fa8468$var$Hi(b, g, d, l);
        $3b3996e8d1fa8468$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $3b3996e8d1fa8468$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $3b3996e8d1fa8468$var$Wf.current || $3b3996e8d1fa8468$var$jh ? ("function" === typeof m && ($3b3996e8d1fa8468$var$Di(b, c, m, d), k = b.memoizedState), (h = $3b3996e8d1fa8468$var$jh || $3b3996e8d1fa8468$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $3b3996e8d1fa8468$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $3b3996e8d1fa8468$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $3b3996e8d1fa8468$var$eh(k) : (k = $3b3996e8d1fa8468$var$Zf(c) ? $3b3996e8d1fa8468$var$Xf : $3b3996e8d1fa8468$var$H.current, k = $3b3996e8d1fa8468$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $3b3996e8d1fa8468$var$Hi(b, g, d, k);
        $3b3996e8d1fa8468$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $3b3996e8d1fa8468$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $3b3996e8d1fa8468$var$Wf.current || $3b3996e8d1fa8468$var$jh ? ("function" === typeof y && ($3b3996e8d1fa8468$var$Di(b, c, y, d), n = b.memoizedState), (l = $3b3996e8d1fa8468$var$jh || $3b3996e8d1fa8468$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $3b3996e8d1fa8468$var$jj(a, b, c, d, f, e);
}
function $3b3996e8d1fa8468$var$jj(a, b, c, d, e, f) {
    $3b3996e8d1fa8468$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $3b3996e8d1fa8468$var$dg(b, c, !1), $3b3996e8d1fa8468$var$Zi(a, b, f);
    d = b.stateNode;
    $3b3996e8d1fa8468$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $3b3996e8d1fa8468$var$Ug(b, a.child, null, f), b.child = $3b3996e8d1fa8468$var$Ug(b, null, h, f)) : $3b3996e8d1fa8468$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $3b3996e8d1fa8468$var$dg(b, c, !0);
    return b.child;
}
function $3b3996e8d1fa8468$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $3b3996e8d1fa8468$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $3b3996e8d1fa8468$var$ag(a, b.context, !1);
    $3b3996e8d1fa8468$var$yh(a, b.containerInfo);
}
function $3b3996e8d1fa8468$var$lj(a, b, c, d, e) {
    $3b3996e8d1fa8468$var$Ig();
    $3b3996e8d1fa8468$var$Jg(e);
    b.flags |= 256;
    $3b3996e8d1fa8468$var$Xi(a, b, c, d);
    return b.child;
}
var $3b3996e8d1fa8468$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $3b3996e8d1fa8468$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $3b3996e8d1fa8468$var$oj(a, b, c) {
    var d = b.pendingProps, e = $3b3996e8d1fa8468$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $3b3996e8d1fa8468$var$G($3b3996e8d1fa8468$var$L, e & 1);
    if (null === a) {
        $3b3996e8d1fa8468$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $3b3996e8d1fa8468$var$pj(g, d, 0, null), a = $3b3996e8d1fa8468$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $3b3996e8d1fa8468$var$nj(c), b.memoizedState = $3b3996e8d1fa8468$var$mj, a) : $3b3996e8d1fa8468$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $3b3996e8d1fa8468$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $3b3996e8d1fa8468$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $3b3996e8d1fa8468$var$Pg(h, f) : (f = $3b3996e8d1fa8468$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $3b3996e8d1fa8468$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $3b3996e8d1fa8468$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $3b3996e8d1fa8468$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $3b3996e8d1fa8468$var$qj(a, b) {
    b = $3b3996e8d1fa8468$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $3b3996e8d1fa8468$var$sj(a, b, c, d) {
    null !== d && $3b3996e8d1fa8468$var$Jg(d);
    $3b3996e8d1fa8468$var$Ug(b, a.child, null, c);
    a = $3b3996e8d1fa8468$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $3b3996e8d1fa8468$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $3b3996e8d1fa8468$var$Ki(Error($3b3996e8d1fa8468$var$p(422))), $3b3996e8d1fa8468$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $3b3996e8d1fa8468$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $3b3996e8d1fa8468$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $3b3996e8d1fa8468$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $3b3996e8d1fa8468$var$nj(g);
        b.memoizedState = $3b3996e8d1fa8468$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $3b3996e8d1fa8468$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($3b3996e8d1fa8468$var$p(419));
        d = $3b3996e8d1fa8468$var$Ki(f, d, void 0);
        return $3b3996e8d1fa8468$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($3b3996e8d1fa8468$var$dh || h) {
        d = $3b3996e8d1fa8468$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $3b3996e8d1fa8468$var$ih(a, e), $3b3996e8d1fa8468$var$gi(d, a, e, -1));
        }
        $3b3996e8d1fa8468$var$tj();
        d = $3b3996e8d1fa8468$var$Ki(Error($3b3996e8d1fa8468$var$p(421)));
        return $3b3996e8d1fa8468$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $3b3996e8d1fa8468$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $3b3996e8d1fa8468$var$yg = $3b3996e8d1fa8468$var$Lf(e.nextSibling);
    $3b3996e8d1fa8468$var$xg = b;
    $3b3996e8d1fa8468$var$I = !0;
    $3b3996e8d1fa8468$var$zg = null;
    null !== a && ($3b3996e8d1fa8468$var$og[$3b3996e8d1fa8468$var$pg++] = $3b3996e8d1fa8468$var$rg, $3b3996e8d1fa8468$var$og[$3b3996e8d1fa8468$var$pg++] = $3b3996e8d1fa8468$var$sg, $3b3996e8d1fa8468$var$og[$3b3996e8d1fa8468$var$pg++] = $3b3996e8d1fa8468$var$qg, $3b3996e8d1fa8468$var$rg = a.id, $3b3996e8d1fa8468$var$sg = a.overflow, $3b3996e8d1fa8468$var$qg = b);
    b = $3b3996e8d1fa8468$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $3b3996e8d1fa8468$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $3b3996e8d1fa8468$var$bh(a.return, b, c);
}
function $3b3996e8d1fa8468$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $3b3996e8d1fa8468$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $3b3996e8d1fa8468$var$Xi(a, b, d.children, c);
    d = $3b3996e8d1fa8468$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $3b3996e8d1fa8468$var$vj(a, c, b);
            else if (19 === a.tag) $3b3996e8d1fa8468$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $3b3996e8d1fa8468$var$G($3b3996e8d1fa8468$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $3b3996e8d1fa8468$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $3b3996e8d1fa8468$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $3b3996e8d1fa8468$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $3b3996e8d1fa8468$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $3b3996e8d1fa8468$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $3b3996e8d1fa8468$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $3b3996e8d1fa8468$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $3b3996e8d1fa8468$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($3b3996e8d1fa8468$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $3b3996e8d1fa8468$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $3b3996e8d1fa8468$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $3b3996e8d1fa8468$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $3b3996e8d1fa8468$var$kj(b);
            $3b3996e8d1fa8468$var$Ig();
            break;
        case 5:
            $3b3996e8d1fa8468$var$Ah(b);
            break;
        case 1:
            $3b3996e8d1fa8468$var$Zf(b.type) && $3b3996e8d1fa8468$var$cg(b);
            break;
        case 4:
            $3b3996e8d1fa8468$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $3b3996e8d1fa8468$var$G($3b3996e8d1fa8468$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $3b3996e8d1fa8468$var$G($3b3996e8d1fa8468$var$L, $3b3996e8d1fa8468$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $3b3996e8d1fa8468$var$oj(a, b, c);
                $3b3996e8d1fa8468$var$G($3b3996e8d1fa8468$var$L, $3b3996e8d1fa8468$var$L.current & 1);
                a = $3b3996e8d1fa8468$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $3b3996e8d1fa8468$var$G($3b3996e8d1fa8468$var$L, $3b3996e8d1fa8468$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $3b3996e8d1fa8468$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $3b3996e8d1fa8468$var$G($3b3996e8d1fa8468$var$L, $3b3996e8d1fa8468$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $3b3996e8d1fa8468$var$dj(a, b, c);
    }
    return $3b3996e8d1fa8468$var$Zi(a, b, c);
}
var $3b3996e8d1fa8468$var$zj, $3b3996e8d1fa8468$var$Aj, $3b3996e8d1fa8468$var$Bj, $3b3996e8d1fa8468$var$Cj;
$3b3996e8d1fa8468$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$3b3996e8d1fa8468$var$Aj = function() {};
$3b3996e8d1fa8468$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $3b3996e8d1fa8468$var$xh($3b3996e8d1fa8468$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $3b3996e8d1fa8468$var$Ya(a, e);
                d = $3b3996e8d1fa8468$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $3b3996e8d1fa8468$var$A({}, e, {
                    value: void 0
                });
                d = $3b3996e8d1fa8468$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $3b3996e8d1fa8468$var$gb(a, e);
                d = $3b3996e8d1fa8468$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $3b3996e8d1fa8468$var$Bf);
        }
        $3b3996e8d1fa8468$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($3b3996e8d1fa8468$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($3b3996e8d1fa8468$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $3b3996e8d1fa8468$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$3b3996e8d1fa8468$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $3b3996e8d1fa8468$var$Dj(a, b) {
    if (!$3b3996e8d1fa8468$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $3b3996e8d1fa8468$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $3b3996e8d1fa8468$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $3b3996e8d1fa8468$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $3b3996e8d1fa8468$var$S(b), null;
        case 1:
            return $3b3996e8d1fa8468$var$Zf(b.type) && $3b3996e8d1fa8468$var$$f(), $3b3996e8d1fa8468$var$S(b), null;
        case 3:
            d = b.stateNode;
            $3b3996e8d1fa8468$var$zh();
            $3b3996e8d1fa8468$var$E($3b3996e8d1fa8468$var$Wf);
            $3b3996e8d1fa8468$var$E($3b3996e8d1fa8468$var$H);
            $3b3996e8d1fa8468$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $3b3996e8d1fa8468$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $3b3996e8d1fa8468$var$zg && ($3b3996e8d1fa8468$var$Fj($3b3996e8d1fa8468$var$zg), $3b3996e8d1fa8468$var$zg = null));
            $3b3996e8d1fa8468$var$Aj(a, b);
            $3b3996e8d1fa8468$var$S(b);
            return null;
        case 5:
            $3b3996e8d1fa8468$var$Bh(b);
            var e = $3b3996e8d1fa8468$var$xh($3b3996e8d1fa8468$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $3b3996e8d1fa8468$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($3b3996e8d1fa8468$var$p(166));
                    $3b3996e8d1fa8468$var$S(b);
                    return null;
                }
                a = $3b3996e8d1fa8468$var$xh($3b3996e8d1fa8468$var$uh.current);
                if ($3b3996e8d1fa8468$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$3b3996e8d1fa8468$var$Of] = b;
                    d[$3b3996e8d1fa8468$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $3b3996e8d1fa8468$var$D("cancel", d);
                            $3b3996e8d1fa8468$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $3b3996e8d1fa8468$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $3b3996e8d1fa8468$var$lf.length; e++)$3b3996e8d1fa8468$var$D($3b3996e8d1fa8468$var$lf[e], d);
                            break;
                        case "source":
                            $3b3996e8d1fa8468$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $3b3996e8d1fa8468$var$D("error", d);
                            $3b3996e8d1fa8468$var$D("load", d);
                            break;
                        case "details":
                            $3b3996e8d1fa8468$var$D("toggle", d);
                            break;
                        case "input":
                            $3b3996e8d1fa8468$var$Za(d, f);
                            $3b3996e8d1fa8468$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $3b3996e8d1fa8468$var$D("invalid", d);
                            break;
                        case "textarea":
                            $3b3996e8d1fa8468$var$hb(d, f), $3b3996e8d1fa8468$var$D("invalid", d);
                    }
                    $3b3996e8d1fa8468$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $3b3996e8d1fa8468$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $3b3996e8d1fa8468$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $3b3996e8d1fa8468$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $3b3996e8d1fa8468$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $3b3996e8d1fa8468$var$Va(d);
                            $3b3996e8d1fa8468$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $3b3996e8d1fa8468$var$Va(d);
                            $3b3996e8d1fa8468$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $3b3996e8d1fa8468$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $3b3996e8d1fa8468$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$3b3996e8d1fa8468$var$Of] = b;
                    a[$3b3996e8d1fa8468$var$Pf] = d;
                    $3b3996e8d1fa8468$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $3b3996e8d1fa8468$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $3b3996e8d1fa8468$var$D("cancel", a);
                                $3b3996e8d1fa8468$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $3b3996e8d1fa8468$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $3b3996e8d1fa8468$var$lf.length; e++)$3b3996e8d1fa8468$var$D($3b3996e8d1fa8468$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $3b3996e8d1fa8468$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $3b3996e8d1fa8468$var$D("error", a);
                                $3b3996e8d1fa8468$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $3b3996e8d1fa8468$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $3b3996e8d1fa8468$var$Za(a, d);
                                e = $3b3996e8d1fa8468$var$Ya(a, d);
                                $3b3996e8d1fa8468$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $3b3996e8d1fa8468$var$A({}, d, {
                                    value: void 0
                                });
                                $3b3996e8d1fa8468$var$D("invalid", a);
                                break;
                            case "textarea":
                                $3b3996e8d1fa8468$var$hb(a, d);
                                e = $3b3996e8d1fa8468$var$gb(a, d);
                                $3b3996e8d1fa8468$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $3b3996e8d1fa8468$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $3b3996e8d1fa8468$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $3b3996e8d1fa8468$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $3b3996e8d1fa8468$var$ob(a, k) : "number" === typeof k && $3b3996e8d1fa8468$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($3b3996e8d1fa8468$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $3b3996e8d1fa8468$var$D("scroll", a) : null != k && $3b3996e8d1fa8468$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $3b3996e8d1fa8468$var$Va(a);
                                $3b3996e8d1fa8468$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $3b3996e8d1fa8468$var$Va(a);
                                $3b3996e8d1fa8468$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $3b3996e8d1fa8468$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $3b3996e8d1fa8468$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $3b3996e8d1fa8468$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $3b3996e8d1fa8468$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $3b3996e8d1fa8468$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $3b3996e8d1fa8468$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($3b3996e8d1fa8468$var$p(166));
                c = $3b3996e8d1fa8468$var$xh($3b3996e8d1fa8468$var$wh.current);
                $3b3996e8d1fa8468$var$xh($3b3996e8d1fa8468$var$uh.current);
                if ($3b3996e8d1fa8468$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$3b3996e8d1fa8468$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $3b3996e8d1fa8468$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $3b3996e8d1fa8468$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $3b3996e8d1fa8468$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$3b3996e8d1fa8468$var$Of] = b, b.stateNode = d;
            }
            $3b3996e8d1fa8468$var$S(b);
            return null;
        case 13:
            $3b3996e8d1fa8468$var$E($3b3996e8d1fa8468$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($3b3996e8d1fa8468$var$I && null !== $3b3996e8d1fa8468$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $3b3996e8d1fa8468$var$Hg(), $3b3996e8d1fa8468$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $3b3996e8d1fa8468$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($3b3996e8d1fa8468$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($3b3996e8d1fa8468$var$p(317));
                        f[$3b3996e8d1fa8468$var$Of] = b;
                    } else $3b3996e8d1fa8468$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $3b3996e8d1fa8468$var$S(b);
                    f = !1;
                } else null !== $3b3996e8d1fa8468$var$zg && ($3b3996e8d1fa8468$var$Fj($3b3996e8d1fa8468$var$zg), $3b3996e8d1fa8468$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($3b3996e8d1fa8468$var$L.current & 1) ? 0 === $3b3996e8d1fa8468$var$T && ($3b3996e8d1fa8468$var$T = 3) : $3b3996e8d1fa8468$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $3b3996e8d1fa8468$var$S(b);
            return null;
        case 4:
            return $3b3996e8d1fa8468$var$zh(), $3b3996e8d1fa8468$var$Aj(a, b), null === a && $3b3996e8d1fa8468$var$sf(b.stateNode.containerInfo), $3b3996e8d1fa8468$var$S(b), null;
        case 10:
            return $3b3996e8d1fa8468$var$ah(b.type._context), $3b3996e8d1fa8468$var$S(b), null;
        case 17:
            return $3b3996e8d1fa8468$var$Zf(b.type) && $3b3996e8d1fa8468$var$$f(), $3b3996e8d1fa8468$var$S(b), null;
        case 19:
            $3b3996e8d1fa8468$var$E($3b3996e8d1fa8468$var$L);
            f = b.memoizedState;
            if (null === f) return $3b3996e8d1fa8468$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $3b3996e8d1fa8468$var$Dj(f, !1);
                else {
                    if (0 !== $3b3996e8d1fa8468$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $3b3996e8d1fa8468$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $3b3996e8d1fa8468$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $3b3996e8d1fa8468$var$G($3b3996e8d1fa8468$var$L, $3b3996e8d1fa8468$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $3b3996e8d1fa8468$var$B() > $3b3996e8d1fa8468$var$Gj && (b.flags |= 128, d = !0, $3b3996e8d1fa8468$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $3b3996e8d1fa8468$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $3b3996e8d1fa8468$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$3b3996e8d1fa8468$var$I) return $3b3996e8d1fa8468$var$S(b), null;
                    } else 2 * $3b3996e8d1fa8468$var$B() - f.renderingStartTime > $3b3996e8d1fa8468$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $3b3996e8d1fa8468$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $3b3996e8d1fa8468$var$B(), b.sibling = null, c = $3b3996e8d1fa8468$var$L.current, $3b3996e8d1fa8468$var$G($3b3996e8d1fa8468$var$L, d ? c & 1 | 2 : c & 1), b;
            $3b3996e8d1fa8468$var$S(b);
            return null;
        case 22:
        case 23:
            return $3b3996e8d1fa8468$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($3b3996e8d1fa8468$var$fj & 1073741824) && ($3b3996e8d1fa8468$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $3b3996e8d1fa8468$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($3b3996e8d1fa8468$var$p(156, b.tag));
}
function $3b3996e8d1fa8468$var$Ij(a, b) {
    $3b3996e8d1fa8468$var$wg(b);
    switch(b.tag){
        case 1:
            return $3b3996e8d1fa8468$var$Zf(b.type) && $3b3996e8d1fa8468$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $3b3996e8d1fa8468$var$zh(), $3b3996e8d1fa8468$var$E($3b3996e8d1fa8468$var$Wf), $3b3996e8d1fa8468$var$E($3b3996e8d1fa8468$var$H), $3b3996e8d1fa8468$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $3b3996e8d1fa8468$var$Bh(b), null;
        case 13:
            $3b3996e8d1fa8468$var$E($3b3996e8d1fa8468$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($3b3996e8d1fa8468$var$p(340));
                $3b3996e8d1fa8468$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $3b3996e8d1fa8468$var$E($3b3996e8d1fa8468$var$L), null;
        case 4:
            return $3b3996e8d1fa8468$var$zh(), null;
        case 10:
            return $3b3996e8d1fa8468$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $3b3996e8d1fa8468$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $3b3996e8d1fa8468$var$Jj = !1, $3b3996e8d1fa8468$var$U = !1, $3b3996e8d1fa8468$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $3b3996e8d1fa8468$var$V = null;
function $3b3996e8d1fa8468$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $3b3996e8d1fa8468$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $3b3996e8d1fa8468$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $3b3996e8d1fa8468$var$W(a, b, d);
    }
}
var $3b3996e8d1fa8468$var$Nj = !1;
function $3b3996e8d1fa8468$var$Oj(a, b) {
    $3b3996e8d1fa8468$var$Cf = $3b3996e8d1fa8468$var$dd;
    a = $3b3996e8d1fa8468$var$Me();
    if ($3b3996e8d1fa8468$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $3b3996e8d1fa8468$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $3b3996e8d1fa8468$var$dd = !1;
    for($3b3996e8d1fa8468$var$V = b; null !== $3b3996e8d1fa8468$var$V;)if (b = $3b3996e8d1fa8468$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $3b3996e8d1fa8468$var$V = a;
    else for(; null !== $3b3996e8d1fa8468$var$V;){
        b = $3b3996e8d1fa8468$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $3b3996e8d1fa8468$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($3b3996e8d1fa8468$var$p(163));
            }
        } catch (F) {
            $3b3996e8d1fa8468$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $3b3996e8d1fa8468$var$V = a;
            break;
        }
        $3b3996e8d1fa8468$var$V = b.return;
    }
    n = $3b3996e8d1fa8468$var$Nj;
    $3b3996e8d1fa8468$var$Nj = !1;
    return n;
}
function $3b3996e8d1fa8468$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $3b3996e8d1fa8468$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $3b3996e8d1fa8468$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $3b3996e8d1fa8468$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $3b3996e8d1fa8468$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $3b3996e8d1fa8468$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$3b3996e8d1fa8468$var$Of], delete b[$3b3996e8d1fa8468$var$Pf], delete b[$3b3996e8d1fa8468$var$of], delete b[$3b3996e8d1fa8468$var$Qf], delete b[$3b3996e8d1fa8468$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $3b3996e8d1fa8468$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $3b3996e8d1fa8468$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $3b3996e8d1fa8468$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $3b3996e8d1fa8468$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $3b3996e8d1fa8468$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($3b3996e8d1fa8468$var$Vj(a, b, c), a = a.sibling; null !== a;)$3b3996e8d1fa8468$var$Vj(a, b, c), a = a.sibling;
}
function $3b3996e8d1fa8468$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($3b3996e8d1fa8468$var$Wj(a, b, c), a = a.sibling; null !== a;)$3b3996e8d1fa8468$var$Wj(a, b, c), a = a.sibling;
}
var $3b3996e8d1fa8468$var$X = null, $3b3996e8d1fa8468$var$Xj = !1;
function $3b3996e8d1fa8468$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$3b3996e8d1fa8468$var$Zj(a, b, c), c = c.sibling;
}
function $3b3996e8d1fa8468$var$Zj(a, b, c) {
    if ($3b3996e8d1fa8468$var$lc && "function" === typeof $3b3996e8d1fa8468$var$lc.onCommitFiberUnmount) try {
        $3b3996e8d1fa8468$var$lc.onCommitFiberUnmount($3b3996e8d1fa8468$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $3b3996e8d1fa8468$var$U || $3b3996e8d1fa8468$var$Lj(c, b);
        case 6:
            var d = $3b3996e8d1fa8468$var$X, e = $3b3996e8d1fa8468$var$Xj;
            $3b3996e8d1fa8468$var$X = null;
            $3b3996e8d1fa8468$var$Yj(a, b, c);
            $3b3996e8d1fa8468$var$X = d;
            $3b3996e8d1fa8468$var$Xj = e;
            null !== $3b3996e8d1fa8468$var$X && ($3b3996e8d1fa8468$var$Xj ? (a = $3b3996e8d1fa8468$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $3b3996e8d1fa8468$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $3b3996e8d1fa8468$var$X && ($3b3996e8d1fa8468$var$Xj ? (a = $3b3996e8d1fa8468$var$X, c = c.stateNode, 8 === a.nodeType ? $3b3996e8d1fa8468$var$Kf(a.parentNode, c) : 1 === a.nodeType && $3b3996e8d1fa8468$var$Kf(a, c), $3b3996e8d1fa8468$var$bd(a)) : $3b3996e8d1fa8468$var$Kf($3b3996e8d1fa8468$var$X, c.stateNode));
            break;
        case 4:
            d = $3b3996e8d1fa8468$var$X;
            e = $3b3996e8d1fa8468$var$Xj;
            $3b3996e8d1fa8468$var$X = c.stateNode.containerInfo;
            $3b3996e8d1fa8468$var$Xj = !0;
            $3b3996e8d1fa8468$var$Yj(a, b, c);
            $3b3996e8d1fa8468$var$X = d;
            $3b3996e8d1fa8468$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$3b3996e8d1fa8468$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $3b3996e8d1fa8468$var$Mj(c, b, g) : 0 !== (f & 4) && $3b3996e8d1fa8468$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $3b3996e8d1fa8468$var$Yj(a, b, c);
            break;
        case 1:
            if (!$3b3996e8d1fa8468$var$U && ($3b3996e8d1fa8468$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $3b3996e8d1fa8468$var$W(c, b, h);
            }
            $3b3996e8d1fa8468$var$Yj(a, b, c);
            break;
        case 21:
            $3b3996e8d1fa8468$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($3b3996e8d1fa8468$var$U = (d = $3b3996e8d1fa8468$var$U) || null !== c.memoizedState, $3b3996e8d1fa8468$var$Yj(a, b, c), $3b3996e8d1fa8468$var$U = d) : $3b3996e8d1fa8468$var$Yj(a, b, c);
            break;
        default:
            $3b3996e8d1fa8468$var$Yj(a, b, c);
    }
}
function $3b3996e8d1fa8468$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $3b3996e8d1fa8468$var$Kj);
        b.forEach(function(b) {
            var d = $3b3996e8d1fa8468$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $3b3996e8d1fa8468$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $3b3996e8d1fa8468$var$X = h.stateNode;
                        $3b3996e8d1fa8468$var$Xj = !1;
                        break a;
                    case 3:
                        $3b3996e8d1fa8468$var$X = h.stateNode.containerInfo;
                        $3b3996e8d1fa8468$var$Xj = !0;
                        break a;
                    case 4:
                        $3b3996e8d1fa8468$var$X = h.stateNode.containerInfo;
                        $3b3996e8d1fa8468$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $3b3996e8d1fa8468$var$X) throw Error($3b3996e8d1fa8468$var$p(160));
            $3b3996e8d1fa8468$var$Zj(f, g, e);
            $3b3996e8d1fa8468$var$X = null;
            $3b3996e8d1fa8468$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $3b3996e8d1fa8468$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$3b3996e8d1fa8468$var$dk(b, a), b = b.sibling;
}
function $3b3996e8d1fa8468$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $3b3996e8d1fa8468$var$ck(b, a);
            $3b3996e8d1fa8468$var$ek(a);
            if (d & 4) {
                try {
                    $3b3996e8d1fa8468$var$Pj(3, a, a.return), $3b3996e8d1fa8468$var$Qj(3, a);
                } catch (t) {
                    $3b3996e8d1fa8468$var$W(a, a.return, t);
                }
                try {
                    $3b3996e8d1fa8468$var$Pj(5, a, a.return);
                } catch (t) {
                    $3b3996e8d1fa8468$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $3b3996e8d1fa8468$var$ck(b, a);
            $3b3996e8d1fa8468$var$ek(a);
            d & 512 && null !== c && $3b3996e8d1fa8468$var$Lj(c, c.return);
            break;
        case 5:
            $3b3996e8d1fa8468$var$ck(b, a);
            $3b3996e8d1fa8468$var$ek(a);
            d & 512 && null !== c && $3b3996e8d1fa8468$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $3b3996e8d1fa8468$var$ob(e, "");
                } catch (t) {
                    $3b3996e8d1fa8468$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $3b3996e8d1fa8468$var$ab(e, f);
                    $3b3996e8d1fa8468$var$vb(h, g);
                    var l = $3b3996e8d1fa8468$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $3b3996e8d1fa8468$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $3b3996e8d1fa8468$var$nb(e, q) : "children" === m ? $3b3996e8d1fa8468$var$ob(e, q) : $3b3996e8d1fa8468$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $3b3996e8d1fa8468$var$bb(e, f);
                            break;
                        case "textarea":
                            $3b3996e8d1fa8468$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $3b3996e8d1fa8468$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $3b3996e8d1fa8468$var$fb(e, !!f.multiple, f.defaultValue, !0) : $3b3996e8d1fa8468$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$3b3996e8d1fa8468$var$Pf] = f;
                } catch (t) {
                    $3b3996e8d1fa8468$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $3b3996e8d1fa8468$var$ck(b, a);
            $3b3996e8d1fa8468$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($3b3996e8d1fa8468$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $3b3996e8d1fa8468$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $3b3996e8d1fa8468$var$ck(b, a);
            $3b3996e8d1fa8468$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $3b3996e8d1fa8468$var$bd(b.containerInfo);
            } catch (t) {
                $3b3996e8d1fa8468$var$W(a, a.return, t);
            }
            break;
        case 4:
            $3b3996e8d1fa8468$var$ck(b, a);
            $3b3996e8d1fa8468$var$ek(a);
            break;
        case 13:
            $3b3996e8d1fa8468$var$ck(b, a);
            $3b3996e8d1fa8468$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($3b3996e8d1fa8468$var$fk = $3b3996e8d1fa8468$var$B()));
            d & 4 && $3b3996e8d1fa8468$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($3b3996e8d1fa8468$var$U = (l = $3b3996e8d1fa8468$var$U) || m, $3b3996e8d1fa8468$var$ck(b, a), $3b3996e8d1fa8468$var$U = l) : $3b3996e8d1fa8468$var$ck(b, a);
            $3b3996e8d1fa8468$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($3b3996e8d1fa8468$var$V = a, m = a.child; null !== m;){
                    for(q = $3b3996e8d1fa8468$var$V = m; null !== $3b3996e8d1fa8468$var$V;){
                        r = $3b3996e8d1fa8468$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $3b3996e8d1fa8468$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $3b3996e8d1fa8468$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $3b3996e8d1fa8468$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $3b3996e8d1fa8468$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $3b3996e8d1fa8468$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $3b3996e8d1fa8468$var$V = y) : $3b3996e8d1fa8468$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $3b3996e8d1fa8468$var$rb("display", g));
                            } catch (t) {
                                $3b3996e8d1fa8468$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $3b3996e8d1fa8468$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $3b3996e8d1fa8468$var$ck(b, a);
            $3b3996e8d1fa8468$var$ek(a);
            d & 4 && $3b3996e8d1fa8468$var$ak(a);
            break;
        case 21:
            break;
        default:
            $3b3996e8d1fa8468$var$ck(b, a), $3b3996e8d1fa8468$var$ek(a);
    }
}
function $3b3996e8d1fa8468$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($3b3996e8d1fa8468$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($3b3996e8d1fa8468$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($3b3996e8d1fa8468$var$ob(e, ""), d.flags &= -33);
                    var f = $3b3996e8d1fa8468$var$Uj(a);
                    $3b3996e8d1fa8468$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $3b3996e8d1fa8468$var$Uj(a);
                    $3b3996e8d1fa8468$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($3b3996e8d1fa8468$var$p(161));
            }
        } catch (k) {
            $3b3996e8d1fa8468$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $3b3996e8d1fa8468$var$hk(a, b, c) {
    $3b3996e8d1fa8468$var$V = a;
    $3b3996e8d1fa8468$var$ik(a, b, c);
}
function $3b3996e8d1fa8468$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $3b3996e8d1fa8468$var$V;){
        var e = $3b3996e8d1fa8468$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $3b3996e8d1fa8468$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $3b3996e8d1fa8468$var$U;
                h = $3b3996e8d1fa8468$var$Jj;
                var l = $3b3996e8d1fa8468$var$U;
                $3b3996e8d1fa8468$var$Jj = g;
                if (($3b3996e8d1fa8468$var$U = k) && !l) for($3b3996e8d1fa8468$var$V = e; null !== $3b3996e8d1fa8468$var$V;)g = $3b3996e8d1fa8468$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $3b3996e8d1fa8468$var$jk(e) : null !== k ? (k.return = g, $3b3996e8d1fa8468$var$V = k) : $3b3996e8d1fa8468$var$jk(e);
                for(; null !== f;)$3b3996e8d1fa8468$var$V = f, $3b3996e8d1fa8468$var$ik(f, b, c), f = f.sibling;
                $3b3996e8d1fa8468$var$V = e;
                $3b3996e8d1fa8468$var$Jj = h;
                $3b3996e8d1fa8468$var$U = l;
            }
            $3b3996e8d1fa8468$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $3b3996e8d1fa8468$var$V = f) : $3b3996e8d1fa8468$var$kk(a, b, c);
    }
}
function $3b3996e8d1fa8468$var$kk(a) {
    for(; null !== $3b3996e8d1fa8468$var$V;){
        var b = $3b3996e8d1fa8468$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $3b3996e8d1fa8468$var$U || $3b3996e8d1fa8468$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$3b3996e8d1fa8468$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $3b3996e8d1fa8468$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $3b3996e8d1fa8468$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $3b3996e8d1fa8468$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $3b3996e8d1fa8468$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($3b3996e8d1fa8468$var$p(163));
                }
                $3b3996e8d1fa8468$var$U || b.flags & 512 && $3b3996e8d1fa8468$var$Rj(b);
            } catch (r) {
                $3b3996e8d1fa8468$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $3b3996e8d1fa8468$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $3b3996e8d1fa8468$var$V = c;
            break;
        }
        $3b3996e8d1fa8468$var$V = b.return;
    }
}
function $3b3996e8d1fa8468$var$gk(a) {
    for(; null !== $3b3996e8d1fa8468$var$V;){
        var b = $3b3996e8d1fa8468$var$V;
        if (b === a) {
            $3b3996e8d1fa8468$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $3b3996e8d1fa8468$var$V = c;
            break;
        }
        $3b3996e8d1fa8468$var$V = b.return;
    }
}
function $3b3996e8d1fa8468$var$jk(a) {
    for(; null !== $3b3996e8d1fa8468$var$V;){
        var b = $3b3996e8d1fa8468$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $3b3996e8d1fa8468$var$Qj(4, b);
                    } catch (k) {
                        $3b3996e8d1fa8468$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $3b3996e8d1fa8468$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $3b3996e8d1fa8468$var$Rj(b);
                    } catch (k) {
                        $3b3996e8d1fa8468$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $3b3996e8d1fa8468$var$Rj(b);
                    } catch (k) {
                        $3b3996e8d1fa8468$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $3b3996e8d1fa8468$var$W(b, b.return, k);
        }
        if (b === a) {
            $3b3996e8d1fa8468$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $3b3996e8d1fa8468$var$V = h;
            break;
        }
        $3b3996e8d1fa8468$var$V = b.return;
    }
}
var $3b3996e8d1fa8468$var$lk = Math.ceil, $3b3996e8d1fa8468$var$mk = $3b3996e8d1fa8468$var$ua.ReactCurrentDispatcher, $3b3996e8d1fa8468$var$nk = $3b3996e8d1fa8468$var$ua.ReactCurrentOwner, $3b3996e8d1fa8468$var$ok = $3b3996e8d1fa8468$var$ua.ReactCurrentBatchConfig, $3b3996e8d1fa8468$var$K = 0, $3b3996e8d1fa8468$var$Q = null, $3b3996e8d1fa8468$var$Y = null, $3b3996e8d1fa8468$var$Z = 0, $3b3996e8d1fa8468$var$fj = 0, $3b3996e8d1fa8468$var$ej = $3b3996e8d1fa8468$var$Uf(0), $3b3996e8d1fa8468$var$T = 0, $3b3996e8d1fa8468$var$pk = null, $3b3996e8d1fa8468$var$rh = 0, $3b3996e8d1fa8468$var$qk = 0, $3b3996e8d1fa8468$var$rk = 0, $3b3996e8d1fa8468$var$sk = null, $3b3996e8d1fa8468$var$tk = null, $3b3996e8d1fa8468$var$fk = 0, $3b3996e8d1fa8468$var$Gj = Infinity, $3b3996e8d1fa8468$var$uk = null, $3b3996e8d1fa8468$var$Oi = !1, $3b3996e8d1fa8468$var$Pi = null, $3b3996e8d1fa8468$var$Ri = null, $3b3996e8d1fa8468$var$vk = !1, $3b3996e8d1fa8468$var$wk = null, $3b3996e8d1fa8468$var$xk = 0, $3b3996e8d1fa8468$var$yk = 0, $3b3996e8d1fa8468$var$zk = null, $3b3996e8d1fa8468$var$Ak = -1, $3b3996e8d1fa8468$var$Bk = 0;
function $3b3996e8d1fa8468$var$R() {
    return 0 !== ($3b3996e8d1fa8468$var$K & 6) ? $3b3996e8d1fa8468$var$B() : -1 !== $3b3996e8d1fa8468$var$Ak ? $3b3996e8d1fa8468$var$Ak : $3b3996e8d1fa8468$var$Ak = $3b3996e8d1fa8468$var$B();
}
function $3b3996e8d1fa8468$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($3b3996e8d1fa8468$var$K & 2) && 0 !== $3b3996e8d1fa8468$var$Z) return $3b3996e8d1fa8468$var$Z & -$3b3996e8d1fa8468$var$Z;
    if (null !== $3b3996e8d1fa8468$var$Kg.transition) return 0 === $3b3996e8d1fa8468$var$Bk && ($3b3996e8d1fa8468$var$Bk = $3b3996e8d1fa8468$var$yc()), $3b3996e8d1fa8468$var$Bk;
    a = $3b3996e8d1fa8468$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $3b3996e8d1fa8468$var$jd(a.type);
    return a;
}
function $3b3996e8d1fa8468$var$gi(a, b, c, d) {
    if (50 < $3b3996e8d1fa8468$var$yk) throw $3b3996e8d1fa8468$var$yk = 0, $3b3996e8d1fa8468$var$zk = null, Error($3b3996e8d1fa8468$var$p(185));
    $3b3996e8d1fa8468$var$Ac(a, c, d);
    if (0 === ($3b3996e8d1fa8468$var$K & 2) || a !== $3b3996e8d1fa8468$var$Q) a === $3b3996e8d1fa8468$var$Q && (0 === ($3b3996e8d1fa8468$var$K & 2) && ($3b3996e8d1fa8468$var$qk |= c), 4 === $3b3996e8d1fa8468$var$T && $3b3996e8d1fa8468$var$Ck(a, $3b3996e8d1fa8468$var$Z)), $3b3996e8d1fa8468$var$Dk(a, d), 1 === c && 0 === $3b3996e8d1fa8468$var$K && 0 === (b.mode & 1) && ($3b3996e8d1fa8468$var$Gj = $3b3996e8d1fa8468$var$B() + 500, $3b3996e8d1fa8468$var$fg && $3b3996e8d1fa8468$var$jg());
}
function $3b3996e8d1fa8468$var$Dk(a, b) {
    var c = a.callbackNode;
    $3b3996e8d1fa8468$var$wc(a, b);
    var d = $3b3996e8d1fa8468$var$uc(a, a === $3b3996e8d1fa8468$var$Q ? $3b3996e8d1fa8468$var$Z : 0);
    if (0 === d) null !== c && $3b3996e8d1fa8468$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $3b3996e8d1fa8468$var$bc(c);
        if (1 === b) 0 === a.tag ? $3b3996e8d1fa8468$var$ig($3b3996e8d1fa8468$var$Ek.bind(null, a)) : $3b3996e8d1fa8468$var$hg($3b3996e8d1fa8468$var$Ek.bind(null, a)), $3b3996e8d1fa8468$var$Jf(function() {
            0 === ($3b3996e8d1fa8468$var$K & 6) && $3b3996e8d1fa8468$var$jg();
        }), c = null;
        else {
            switch($3b3996e8d1fa8468$var$Dc(d)){
                case 1:
                    c = $3b3996e8d1fa8468$var$fc;
                    break;
                case 4:
                    c = $3b3996e8d1fa8468$var$gc;
                    break;
                case 16:
                    c = $3b3996e8d1fa8468$var$hc;
                    break;
                case 536870912:
                    c = $3b3996e8d1fa8468$var$jc;
                    break;
                default:
                    c = $3b3996e8d1fa8468$var$hc;
            }
            c = $3b3996e8d1fa8468$var$Fk(c, $3b3996e8d1fa8468$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $3b3996e8d1fa8468$var$Gk(a, b) {
    $3b3996e8d1fa8468$var$Ak = -1;
    $3b3996e8d1fa8468$var$Bk = 0;
    if (0 !== ($3b3996e8d1fa8468$var$K & 6)) throw Error($3b3996e8d1fa8468$var$p(327));
    var c = a.callbackNode;
    if ($3b3996e8d1fa8468$var$Hk() && a.callbackNode !== c) return null;
    var d = $3b3996e8d1fa8468$var$uc(a, a === $3b3996e8d1fa8468$var$Q ? $3b3996e8d1fa8468$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $3b3996e8d1fa8468$var$Ik(a, d);
    else {
        b = d;
        var e = $3b3996e8d1fa8468$var$K;
        $3b3996e8d1fa8468$var$K |= 2;
        var f = $3b3996e8d1fa8468$var$Jk();
        if ($3b3996e8d1fa8468$var$Q !== a || $3b3996e8d1fa8468$var$Z !== b) $3b3996e8d1fa8468$var$uk = null, $3b3996e8d1fa8468$var$Gj = $3b3996e8d1fa8468$var$B() + 500, $3b3996e8d1fa8468$var$Kk(a, b);
        for(;;)try {
            $3b3996e8d1fa8468$var$Lk();
            break;
        } catch (h) {
            $3b3996e8d1fa8468$var$Mk(a, h);
        }
        $3b3996e8d1fa8468$var$$g();
        $3b3996e8d1fa8468$var$mk.current = f;
        $3b3996e8d1fa8468$var$K = e;
        null !== $3b3996e8d1fa8468$var$Y ? b = 0 : ($3b3996e8d1fa8468$var$Q = null, $3b3996e8d1fa8468$var$Z = 0, b = $3b3996e8d1fa8468$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $3b3996e8d1fa8468$var$xc(a), 0 !== e && (d = e, b = $3b3996e8d1fa8468$var$Nk(a, e)));
        if (1 === b) throw c = $3b3996e8d1fa8468$var$pk, $3b3996e8d1fa8468$var$Kk(a, 0), $3b3996e8d1fa8468$var$Ck(a, d), $3b3996e8d1fa8468$var$Dk(a, $3b3996e8d1fa8468$var$B()), c;
        if (6 === b) $3b3996e8d1fa8468$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$3b3996e8d1fa8468$var$Ok(e) && (b = $3b3996e8d1fa8468$var$Ik(a, d), 2 === b && (f = $3b3996e8d1fa8468$var$xc(a), 0 !== f && (d = f, b = $3b3996e8d1fa8468$var$Nk(a, f))), 1 === b)) throw c = $3b3996e8d1fa8468$var$pk, $3b3996e8d1fa8468$var$Kk(a, 0), $3b3996e8d1fa8468$var$Ck(a, d), $3b3996e8d1fa8468$var$Dk(a, $3b3996e8d1fa8468$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($3b3996e8d1fa8468$var$p(345));
                case 2:
                    $3b3996e8d1fa8468$var$Pk(a, $3b3996e8d1fa8468$var$tk, $3b3996e8d1fa8468$var$uk);
                    break;
                case 3:
                    $3b3996e8d1fa8468$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $3b3996e8d1fa8468$var$fk + 500 - $3b3996e8d1fa8468$var$B(), 10 < b)) {
                        if (0 !== $3b3996e8d1fa8468$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $3b3996e8d1fa8468$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $3b3996e8d1fa8468$var$Ff($3b3996e8d1fa8468$var$Pk.bind(null, a, $3b3996e8d1fa8468$var$tk, $3b3996e8d1fa8468$var$uk), b);
                        break;
                    }
                    $3b3996e8d1fa8468$var$Pk(a, $3b3996e8d1fa8468$var$tk, $3b3996e8d1fa8468$var$uk);
                    break;
                case 4:
                    $3b3996e8d1fa8468$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $3b3996e8d1fa8468$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $3b3996e8d1fa8468$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $3b3996e8d1fa8468$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $3b3996e8d1fa8468$var$Ff($3b3996e8d1fa8468$var$Pk.bind(null, a, $3b3996e8d1fa8468$var$tk, $3b3996e8d1fa8468$var$uk), d);
                        break;
                    }
                    $3b3996e8d1fa8468$var$Pk(a, $3b3996e8d1fa8468$var$tk, $3b3996e8d1fa8468$var$uk);
                    break;
                case 5:
                    $3b3996e8d1fa8468$var$Pk(a, $3b3996e8d1fa8468$var$tk, $3b3996e8d1fa8468$var$uk);
                    break;
                default:
                    throw Error($3b3996e8d1fa8468$var$p(329));
            }
        }
    }
    $3b3996e8d1fa8468$var$Dk(a, $3b3996e8d1fa8468$var$B());
    return a.callbackNode === c ? $3b3996e8d1fa8468$var$Gk.bind(null, a) : null;
}
function $3b3996e8d1fa8468$var$Nk(a, b) {
    var c = $3b3996e8d1fa8468$var$sk;
    a.current.memoizedState.isDehydrated && ($3b3996e8d1fa8468$var$Kk(a, b).flags |= 256);
    a = $3b3996e8d1fa8468$var$Ik(a, b);
    2 !== a && (b = $3b3996e8d1fa8468$var$tk, $3b3996e8d1fa8468$var$tk = c, null !== b && $3b3996e8d1fa8468$var$Fj(b));
    return a;
}
function $3b3996e8d1fa8468$var$Fj(a) {
    null === $3b3996e8d1fa8468$var$tk ? $3b3996e8d1fa8468$var$tk = a : $3b3996e8d1fa8468$var$tk.push.apply($3b3996e8d1fa8468$var$tk, a);
}
function $3b3996e8d1fa8468$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$3b3996e8d1fa8468$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $3b3996e8d1fa8468$var$Ck(a, b) {
    b &= ~$3b3996e8d1fa8468$var$rk;
    b &= ~$3b3996e8d1fa8468$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $3b3996e8d1fa8468$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $3b3996e8d1fa8468$var$Ek(a) {
    if (0 !== ($3b3996e8d1fa8468$var$K & 6)) throw Error($3b3996e8d1fa8468$var$p(327));
    $3b3996e8d1fa8468$var$Hk();
    var b = $3b3996e8d1fa8468$var$uc(a, 0);
    if (0 === (b & 1)) return $3b3996e8d1fa8468$var$Dk(a, $3b3996e8d1fa8468$var$B()), null;
    var c = $3b3996e8d1fa8468$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $3b3996e8d1fa8468$var$xc(a);
        0 !== d && (b = d, c = $3b3996e8d1fa8468$var$Nk(a, d));
    }
    if (1 === c) throw c = $3b3996e8d1fa8468$var$pk, $3b3996e8d1fa8468$var$Kk(a, 0), $3b3996e8d1fa8468$var$Ck(a, b), $3b3996e8d1fa8468$var$Dk(a, $3b3996e8d1fa8468$var$B()), c;
    if (6 === c) throw Error($3b3996e8d1fa8468$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $3b3996e8d1fa8468$var$Pk(a, $3b3996e8d1fa8468$var$tk, $3b3996e8d1fa8468$var$uk);
    $3b3996e8d1fa8468$var$Dk(a, $3b3996e8d1fa8468$var$B());
    return null;
}
function $3b3996e8d1fa8468$var$Qk(a, b) {
    var c = $3b3996e8d1fa8468$var$K;
    $3b3996e8d1fa8468$var$K |= 1;
    try {
        return a(b);
    } finally{
        $3b3996e8d1fa8468$var$K = c, 0 === $3b3996e8d1fa8468$var$K && ($3b3996e8d1fa8468$var$Gj = $3b3996e8d1fa8468$var$B() + 500, $3b3996e8d1fa8468$var$fg && $3b3996e8d1fa8468$var$jg());
    }
}
function $3b3996e8d1fa8468$var$Rk(a) {
    null !== $3b3996e8d1fa8468$var$wk && 0 === $3b3996e8d1fa8468$var$wk.tag && 0 === ($3b3996e8d1fa8468$var$K & 6) && $3b3996e8d1fa8468$var$Hk();
    var b = $3b3996e8d1fa8468$var$K;
    $3b3996e8d1fa8468$var$K |= 1;
    var c = $3b3996e8d1fa8468$var$ok.transition, d = $3b3996e8d1fa8468$var$C;
    try {
        if ($3b3996e8d1fa8468$var$ok.transition = null, $3b3996e8d1fa8468$var$C = 1, a) return a();
    } finally{
        $3b3996e8d1fa8468$var$C = d, $3b3996e8d1fa8468$var$ok.transition = c, $3b3996e8d1fa8468$var$K = b, 0 === ($3b3996e8d1fa8468$var$K & 6) && $3b3996e8d1fa8468$var$jg();
    }
}
function $3b3996e8d1fa8468$var$Hj() {
    $3b3996e8d1fa8468$var$fj = $3b3996e8d1fa8468$var$ej.current;
    $3b3996e8d1fa8468$var$E($3b3996e8d1fa8468$var$ej);
}
function $3b3996e8d1fa8468$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $3b3996e8d1fa8468$var$Gf(c));
    if (null !== $3b3996e8d1fa8468$var$Y) for(c = $3b3996e8d1fa8468$var$Y.return; null !== c;){
        var d = c;
        $3b3996e8d1fa8468$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $3b3996e8d1fa8468$var$$f();
                break;
            case 3:
                $3b3996e8d1fa8468$var$zh();
                $3b3996e8d1fa8468$var$E($3b3996e8d1fa8468$var$Wf);
                $3b3996e8d1fa8468$var$E($3b3996e8d1fa8468$var$H);
                $3b3996e8d1fa8468$var$Eh();
                break;
            case 5:
                $3b3996e8d1fa8468$var$Bh(d);
                break;
            case 4:
                $3b3996e8d1fa8468$var$zh();
                break;
            case 13:
                $3b3996e8d1fa8468$var$E($3b3996e8d1fa8468$var$L);
                break;
            case 19:
                $3b3996e8d1fa8468$var$E($3b3996e8d1fa8468$var$L);
                break;
            case 10:
                $3b3996e8d1fa8468$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $3b3996e8d1fa8468$var$Hj();
        }
        c = c.return;
    }
    $3b3996e8d1fa8468$var$Q = a;
    $3b3996e8d1fa8468$var$Y = a = $3b3996e8d1fa8468$var$Pg(a.current, null);
    $3b3996e8d1fa8468$var$Z = $3b3996e8d1fa8468$var$fj = b;
    $3b3996e8d1fa8468$var$T = 0;
    $3b3996e8d1fa8468$var$pk = null;
    $3b3996e8d1fa8468$var$rk = $3b3996e8d1fa8468$var$qk = $3b3996e8d1fa8468$var$rh = 0;
    $3b3996e8d1fa8468$var$tk = $3b3996e8d1fa8468$var$sk = null;
    if (null !== $3b3996e8d1fa8468$var$fh) {
        for(b = 0; b < $3b3996e8d1fa8468$var$fh.length; b++)if (c = $3b3996e8d1fa8468$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $3b3996e8d1fa8468$var$fh = null;
    }
    return a;
}
function $3b3996e8d1fa8468$var$Mk(a, b) {
    do {
        var c = $3b3996e8d1fa8468$var$Y;
        try {
            $3b3996e8d1fa8468$var$$g();
            $3b3996e8d1fa8468$var$Fh.current = $3b3996e8d1fa8468$var$Rh;
            if ($3b3996e8d1fa8468$var$Ih) {
                for(var d = $3b3996e8d1fa8468$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $3b3996e8d1fa8468$var$Ih = !1;
            }
            $3b3996e8d1fa8468$var$Hh = 0;
            $3b3996e8d1fa8468$var$O = $3b3996e8d1fa8468$var$N = $3b3996e8d1fa8468$var$M = null;
            $3b3996e8d1fa8468$var$Jh = !1;
            $3b3996e8d1fa8468$var$Kh = 0;
            $3b3996e8d1fa8468$var$nk.current = null;
            if (null === c || null === c.return) {
                $3b3996e8d1fa8468$var$T = 1;
                $3b3996e8d1fa8468$var$pk = b;
                $3b3996e8d1fa8468$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $3b3996e8d1fa8468$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $3b3996e8d1fa8468$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $3b3996e8d1fa8468$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $3b3996e8d1fa8468$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $3b3996e8d1fa8468$var$Si(f, l, b);
                            $3b3996e8d1fa8468$var$tj();
                            break a;
                        }
                        k = Error($3b3996e8d1fa8468$var$p(426));
                    }
                } else if ($3b3996e8d1fa8468$var$I && h.mode & 1) {
                    var J = $3b3996e8d1fa8468$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $3b3996e8d1fa8468$var$Vi(J, g, h, f, b);
                        $3b3996e8d1fa8468$var$Jg($3b3996e8d1fa8468$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $3b3996e8d1fa8468$var$Ji(k, h);
                4 !== $3b3996e8d1fa8468$var$T && ($3b3996e8d1fa8468$var$T = 2);
                null === $3b3996e8d1fa8468$var$sk ? $3b3996e8d1fa8468$var$sk = [
                    f
                ] : $3b3996e8d1fa8468$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $3b3996e8d1fa8468$var$Ni(f, k, b);
                            $3b3996e8d1fa8468$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $3b3996e8d1fa8468$var$Ri || !$3b3996e8d1fa8468$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $3b3996e8d1fa8468$var$Qi(f, h, b);
                                $3b3996e8d1fa8468$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $3b3996e8d1fa8468$var$Sk(c);
        } catch (na) {
            b = na;
            $3b3996e8d1fa8468$var$Y === c && null !== c && ($3b3996e8d1fa8468$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $3b3996e8d1fa8468$var$Jk() {
    var a = $3b3996e8d1fa8468$var$mk.current;
    $3b3996e8d1fa8468$var$mk.current = $3b3996e8d1fa8468$var$Rh;
    return null === a ? $3b3996e8d1fa8468$var$Rh : a;
}
function $3b3996e8d1fa8468$var$tj() {
    if (0 === $3b3996e8d1fa8468$var$T || 3 === $3b3996e8d1fa8468$var$T || 2 === $3b3996e8d1fa8468$var$T) $3b3996e8d1fa8468$var$T = 4;
    null === $3b3996e8d1fa8468$var$Q || 0 === ($3b3996e8d1fa8468$var$rh & 268435455) && 0 === ($3b3996e8d1fa8468$var$qk & 268435455) || $3b3996e8d1fa8468$var$Ck($3b3996e8d1fa8468$var$Q, $3b3996e8d1fa8468$var$Z);
}
function $3b3996e8d1fa8468$var$Ik(a, b) {
    var c = $3b3996e8d1fa8468$var$K;
    $3b3996e8d1fa8468$var$K |= 2;
    var d = $3b3996e8d1fa8468$var$Jk();
    if ($3b3996e8d1fa8468$var$Q !== a || $3b3996e8d1fa8468$var$Z !== b) $3b3996e8d1fa8468$var$uk = null, $3b3996e8d1fa8468$var$Kk(a, b);
    for(;;)try {
        $3b3996e8d1fa8468$var$Tk();
        break;
    } catch (e) {
        $3b3996e8d1fa8468$var$Mk(a, e);
    }
    $3b3996e8d1fa8468$var$$g();
    $3b3996e8d1fa8468$var$K = c;
    $3b3996e8d1fa8468$var$mk.current = d;
    if (null !== $3b3996e8d1fa8468$var$Y) throw Error($3b3996e8d1fa8468$var$p(261));
    $3b3996e8d1fa8468$var$Q = null;
    $3b3996e8d1fa8468$var$Z = 0;
    return $3b3996e8d1fa8468$var$T;
}
function $3b3996e8d1fa8468$var$Tk() {
    for(; null !== $3b3996e8d1fa8468$var$Y;)$3b3996e8d1fa8468$var$Uk($3b3996e8d1fa8468$var$Y);
}
function $3b3996e8d1fa8468$var$Lk() {
    for(; null !== $3b3996e8d1fa8468$var$Y && !$3b3996e8d1fa8468$var$cc();)$3b3996e8d1fa8468$var$Uk($3b3996e8d1fa8468$var$Y);
}
function $3b3996e8d1fa8468$var$Uk(a) {
    var b = $3b3996e8d1fa8468$var$Vk(a.alternate, a, $3b3996e8d1fa8468$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $3b3996e8d1fa8468$var$Sk(a) : $3b3996e8d1fa8468$var$Y = b;
    $3b3996e8d1fa8468$var$nk.current = null;
}
function $3b3996e8d1fa8468$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $3b3996e8d1fa8468$var$Ej(c, b, $3b3996e8d1fa8468$var$fj), null !== c) {
                $3b3996e8d1fa8468$var$Y = c;
                return;
            }
        } else {
            c = $3b3996e8d1fa8468$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $3b3996e8d1fa8468$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $3b3996e8d1fa8468$var$T = 6;
                $3b3996e8d1fa8468$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $3b3996e8d1fa8468$var$Y = b;
            return;
        }
        $3b3996e8d1fa8468$var$Y = b = a;
    }while (null !== b);
    0 === $3b3996e8d1fa8468$var$T && ($3b3996e8d1fa8468$var$T = 5);
}
function $3b3996e8d1fa8468$var$Pk(a, b, c) {
    var d = $3b3996e8d1fa8468$var$C, e = $3b3996e8d1fa8468$var$ok.transition;
    try {
        $3b3996e8d1fa8468$var$ok.transition = null, $3b3996e8d1fa8468$var$C = 1, $3b3996e8d1fa8468$var$Wk(a, b, c, d);
    } finally{
        $3b3996e8d1fa8468$var$ok.transition = e, $3b3996e8d1fa8468$var$C = d;
    }
    return null;
}
function $3b3996e8d1fa8468$var$Wk(a, b, c, d) {
    do $3b3996e8d1fa8468$var$Hk();
    while (null !== $3b3996e8d1fa8468$var$wk);
    if (0 !== ($3b3996e8d1fa8468$var$K & 6)) throw Error($3b3996e8d1fa8468$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($3b3996e8d1fa8468$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $3b3996e8d1fa8468$var$Bc(a, f);
    a === $3b3996e8d1fa8468$var$Q && ($3b3996e8d1fa8468$var$Y = $3b3996e8d1fa8468$var$Q = null, $3b3996e8d1fa8468$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $3b3996e8d1fa8468$var$vk || ($3b3996e8d1fa8468$var$vk = !0, $3b3996e8d1fa8468$var$Fk($3b3996e8d1fa8468$var$hc, function() {
        $3b3996e8d1fa8468$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $3b3996e8d1fa8468$var$ok.transition;
        $3b3996e8d1fa8468$var$ok.transition = null;
        var g = $3b3996e8d1fa8468$var$C;
        $3b3996e8d1fa8468$var$C = 1;
        var h = $3b3996e8d1fa8468$var$K;
        $3b3996e8d1fa8468$var$K |= 4;
        $3b3996e8d1fa8468$var$nk.current = null;
        $3b3996e8d1fa8468$var$Oj(a, c);
        $3b3996e8d1fa8468$var$dk(c, a);
        $3b3996e8d1fa8468$var$Oe($3b3996e8d1fa8468$var$Df);
        $3b3996e8d1fa8468$var$dd = !!$3b3996e8d1fa8468$var$Cf;
        $3b3996e8d1fa8468$var$Df = $3b3996e8d1fa8468$var$Cf = null;
        a.current = c;
        $3b3996e8d1fa8468$var$hk(c, a, e);
        $3b3996e8d1fa8468$var$dc();
        $3b3996e8d1fa8468$var$K = h;
        $3b3996e8d1fa8468$var$C = g;
        $3b3996e8d1fa8468$var$ok.transition = f;
    } else a.current = c;
    $3b3996e8d1fa8468$var$vk && ($3b3996e8d1fa8468$var$vk = !1, $3b3996e8d1fa8468$var$wk = a, $3b3996e8d1fa8468$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($3b3996e8d1fa8468$var$Ri = null);
    $3b3996e8d1fa8468$var$mc(c.stateNode, d);
    $3b3996e8d1fa8468$var$Dk(a, $3b3996e8d1fa8468$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($3b3996e8d1fa8468$var$Oi) throw $3b3996e8d1fa8468$var$Oi = !1, a = $3b3996e8d1fa8468$var$Pi, $3b3996e8d1fa8468$var$Pi = null, a;
    0 !== ($3b3996e8d1fa8468$var$xk & 1) && 0 !== a.tag && $3b3996e8d1fa8468$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $3b3996e8d1fa8468$var$zk ? $3b3996e8d1fa8468$var$yk++ : ($3b3996e8d1fa8468$var$yk = 0, $3b3996e8d1fa8468$var$zk = a) : $3b3996e8d1fa8468$var$yk = 0;
    $3b3996e8d1fa8468$var$jg();
    return null;
}
function $3b3996e8d1fa8468$var$Hk() {
    if (null !== $3b3996e8d1fa8468$var$wk) {
        var a = $3b3996e8d1fa8468$var$Dc($3b3996e8d1fa8468$var$xk), b = $3b3996e8d1fa8468$var$ok.transition, c = $3b3996e8d1fa8468$var$C;
        try {
            $3b3996e8d1fa8468$var$ok.transition = null;
            $3b3996e8d1fa8468$var$C = 16 > a ? 16 : a;
            if (null === $3b3996e8d1fa8468$var$wk) var d = !1;
            else {
                a = $3b3996e8d1fa8468$var$wk;
                $3b3996e8d1fa8468$var$wk = null;
                $3b3996e8d1fa8468$var$xk = 0;
                if (0 !== ($3b3996e8d1fa8468$var$K & 6)) throw Error($3b3996e8d1fa8468$var$p(331));
                var e = $3b3996e8d1fa8468$var$K;
                $3b3996e8d1fa8468$var$K |= 4;
                for($3b3996e8d1fa8468$var$V = a.current; null !== $3b3996e8d1fa8468$var$V;){
                    var f = $3b3996e8d1fa8468$var$V, g = f.child;
                    if (0 !== ($3b3996e8d1fa8468$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($3b3996e8d1fa8468$var$V = l; null !== $3b3996e8d1fa8468$var$V;){
                                    var m = $3b3996e8d1fa8468$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $3b3996e8d1fa8468$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $3b3996e8d1fa8468$var$V = q;
                                    else for(; null !== $3b3996e8d1fa8468$var$V;){
                                        m = $3b3996e8d1fa8468$var$V;
                                        var r = m.sibling, y = m.return;
                                        $3b3996e8d1fa8468$var$Sj(m);
                                        if (m === l) {
                                            $3b3996e8d1fa8468$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $3b3996e8d1fa8468$var$V = r;
                                            break;
                                        }
                                        $3b3996e8d1fa8468$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $3b3996e8d1fa8468$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $3b3996e8d1fa8468$var$V = g;
                    else b: for(; null !== $3b3996e8d1fa8468$var$V;){
                        f = $3b3996e8d1fa8468$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $3b3996e8d1fa8468$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $3b3996e8d1fa8468$var$V = x;
                            break b;
                        }
                        $3b3996e8d1fa8468$var$V = f.return;
                    }
                }
                var w = a.current;
                for($3b3996e8d1fa8468$var$V = w; null !== $3b3996e8d1fa8468$var$V;){
                    g = $3b3996e8d1fa8468$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $3b3996e8d1fa8468$var$V = u;
                    else b: for(g = w; null !== $3b3996e8d1fa8468$var$V;){
                        h = $3b3996e8d1fa8468$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $3b3996e8d1fa8468$var$Qj(9, h);
                            }
                        } catch (na) {
                            $3b3996e8d1fa8468$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $3b3996e8d1fa8468$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $3b3996e8d1fa8468$var$V = F;
                            break b;
                        }
                        $3b3996e8d1fa8468$var$V = h.return;
                    }
                }
                $3b3996e8d1fa8468$var$K = e;
                $3b3996e8d1fa8468$var$jg();
                if ($3b3996e8d1fa8468$var$lc && "function" === typeof $3b3996e8d1fa8468$var$lc.onPostCommitFiberRoot) try {
                    $3b3996e8d1fa8468$var$lc.onPostCommitFiberRoot($3b3996e8d1fa8468$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $3b3996e8d1fa8468$var$C = c, $3b3996e8d1fa8468$var$ok.transition = b;
        }
    }
    return !1;
}
function $3b3996e8d1fa8468$var$Xk(a, b, c) {
    b = $3b3996e8d1fa8468$var$Ji(c, b);
    b = $3b3996e8d1fa8468$var$Ni(a, b, 1);
    a = $3b3996e8d1fa8468$var$nh(a, b, 1);
    b = $3b3996e8d1fa8468$var$R();
    null !== a && ($3b3996e8d1fa8468$var$Ac(a, 1, b), $3b3996e8d1fa8468$var$Dk(a, b));
}
function $3b3996e8d1fa8468$var$W(a, b, c) {
    if (3 === a.tag) $3b3996e8d1fa8468$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $3b3996e8d1fa8468$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $3b3996e8d1fa8468$var$Ri || !$3b3996e8d1fa8468$var$Ri.has(d))) {
                a = $3b3996e8d1fa8468$var$Ji(c, a);
                a = $3b3996e8d1fa8468$var$Qi(b, a, 1);
                b = $3b3996e8d1fa8468$var$nh(b, a, 1);
                a = $3b3996e8d1fa8468$var$R();
                null !== b && ($3b3996e8d1fa8468$var$Ac(b, 1, a), $3b3996e8d1fa8468$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $3b3996e8d1fa8468$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $3b3996e8d1fa8468$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $3b3996e8d1fa8468$var$Q === a && ($3b3996e8d1fa8468$var$Z & c) === c && (4 === $3b3996e8d1fa8468$var$T || 3 === $3b3996e8d1fa8468$var$T && ($3b3996e8d1fa8468$var$Z & 130023424) === $3b3996e8d1fa8468$var$Z && 500 > $3b3996e8d1fa8468$var$B() - $3b3996e8d1fa8468$var$fk ? $3b3996e8d1fa8468$var$Kk(a, 0) : $3b3996e8d1fa8468$var$rk |= c);
    $3b3996e8d1fa8468$var$Dk(a, b);
}
function $3b3996e8d1fa8468$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $3b3996e8d1fa8468$var$sc, $3b3996e8d1fa8468$var$sc <<= 1, 0 === ($3b3996e8d1fa8468$var$sc & 130023424) && ($3b3996e8d1fa8468$var$sc = 4194304)));
    var c = $3b3996e8d1fa8468$var$R();
    a = $3b3996e8d1fa8468$var$ih(a, b);
    null !== a && ($3b3996e8d1fa8468$var$Ac(a, b, c), $3b3996e8d1fa8468$var$Dk(a, c));
}
function $3b3996e8d1fa8468$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $3b3996e8d1fa8468$var$Yk(a, c);
}
function $3b3996e8d1fa8468$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($3b3996e8d1fa8468$var$p(314));
    }
    null !== d && d.delete(b);
    $3b3996e8d1fa8468$var$Yk(a, c);
}
var $3b3996e8d1fa8468$var$Vk;
$3b3996e8d1fa8468$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $3b3996e8d1fa8468$var$Wf.current) $3b3996e8d1fa8468$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $3b3996e8d1fa8468$var$dh = !1, $3b3996e8d1fa8468$var$yj(a, b, c);
            $3b3996e8d1fa8468$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $3b3996e8d1fa8468$var$dh = !1, $3b3996e8d1fa8468$var$I && 0 !== (b.flags & 1048576) && $3b3996e8d1fa8468$var$ug(b, $3b3996e8d1fa8468$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $3b3996e8d1fa8468$var$ij(a, b);
            a = b.pendingProps;
            var e = $3b3996e8d1fa8468$var$Yf(b, $3b3996e8d1fa8468$var$H.current);
            $3b3996e8d1fa8468$var$ch(b, c);
            e = $3b3996e8d1fa8468$var$Nh(null, b, d, a, e, c);
            var f = $3b3996e8d1fa8468$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $3b3996e8d1fa8468$var$Zf(d) ? (f = !0, $3b3996e8d1fa8468$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $3b3996e8d1fa8468$var$kh(b), e.updater = $3b3996e8d1fa8468$var$Ei, b.stateNode = e, e._reactInternals = b, $3b3996e8d1fa8468$var$Ii(b, d, a, c), b = $3b3996e8d1fa8468$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $3b3996e8d1fa8468$var$I && f && $3b3996e8d1fa8468$var$vg(b), $3b3996e8d1fa8468$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $3b3996e8d1fa8468$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $3b3996e8d1fa8468$var$Zk(d);
                a = $3b3996e8d1fa8468$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $3b3996e8d1fa8468$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $3b3996e8d1fa8468$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $3b3996e8d1fa8468$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $3b3996e8d1fa8468$var$$i(null, b, d, $3b3996e8d1fa8468$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($3b3996e8d1fa8468$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $3b3996e8d1fa8468$var$Ci(d, e), $3b3996e8d1fa8468$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $3b3996e8d1fa8468$var$Ci(d, e), $3b3996e8d1fa8468$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $3b3996e8d1fa8468$var$kj(b);
                if (null === a) throw Error($3b3996e8d1fa8468$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $3b3996e8d1fa8468$var$lh(a, b);
                $3b3996e8d1fa8468$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $3b3996e8d1fa8468$var$Ji(Error($3b3996e8d1fa8468$var$p(423)), b);
                        b = $3b3996e8d1fa8468$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $3b3996e8d1fa8468$var$Ji(Error($3b3996e8d1fa8468$var$p(424)), b);
                        b = $3b3996e8d1fa8468$var$lj(a, b, d, c, e);
                        break a;
                    } else for($3b3996e8d1fa8468$var$yg = $3b3996e8d1fa8468$var$Lf(b.stateNode.containerInfo.firstChild), $3b3996e8d1fa8468$var$xg = b, $3b3996e8d1fa8468$var$I = !0, $3b3996e8d1fa8468$var$zg = null, c = $3b3996e8d1fa8468$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $3b3996e8d1fa8468$var$Ig();
                    if (d === e) {
                        b = $3b3996e8d1fa8468$var$Zi(a, b, c);
                        break a;
                    }
                    $3b3996e8d1fa8468$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $3b3996e8d1fa8468$var$Ah(b), null === a && $3b3996e8d1fa8468$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $3b3996e8d1fa8468$var$Ef(d, e) ? g = null : null !== f && $3b3996e8d1fa8468$var$Ef(d, f) && (b.flags |= 32), $3b3996e8d1fa8468$var$gj(a, b), $3b3996e8d1fa8468$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $3b3996e8d1fa8468$var$Eg(b), null;
        case 13:
            return $3b3996e8d1fa8468$var$oj(a, b, c);
        case 4:
            return $3b3996e8d1fa8468$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $3b3996e8d1fa8468$var$Ug(b, null, d, c) : $3b3996e8d1fa8468$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $3b3996e8d1fa8468$var$Ci(d, e), $3b3996e8d1fa8468$var$Yi(a, b, d, e, c);
        case 7:
            return $3b3996e8d1fa8468$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $3b3996e8d1fa8468$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $3b3996e8d1fa8468$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $3b3996e8d1fa8468$var$G($3b3996e8d1fa8468$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($3b3996e8d1fa8468$var$He(f.value, g)) {
                        if (f.children === e.children && !$3b3996e8d1fa8468$var$Wf.current) {
                            b = $3b3996e8d1fa8468$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $3b3996e8d1fa8468$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $3b3996e8d1fa8468$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($3b3996e8d1fa8468$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $3b3996e8d1fa8468$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $3b3996e8d1fa8468$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $3b3996e8d1fa8468$var$ch(b, c), e = $3b3996e8d1fa8468$var$eh(e), d = d(e), b.flags |= 1, $3b3996e8d1fa8468$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $3b3996e8d1fa8468$var$Ci(d, b.pendingProps), e = $3b3996e8d1fa8468$var$Ci(d.type, e), $3b3996e8d1fa8468$var$$i(a, b, d, e, c);
        case 15:
            return $3b3996e8d1fa8468$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $3b3996e8d1fa8468$var$Ci(d, e), $3b3996e8d1fa8468$var$ij(a, b), b.tag = 1, $3b3996e8d1fa8468$var$Zf(d) ? (a = !0, $3b3996e8d1fa8468$var$cg(b)) : a = !1, $3b3996e8d1fa8468$var$ch(b, c), $3b3996e8d1fa8468$var$Gi(b, d, e), $3b3996e8d1fa8468$var$Ii(b, d, e, c), $3b3996e8d1fa8468$var$jj(null, b, d, !0, a, c);
        case 19:
            return $3b3996e8d1fa8468$var$xj(a, b, c);
        case 22:
            return $3b3996e8d1fa8468$var$dj(a, b, c);
    }
    throw Error($3b3996e8d1fa8468$var$p(156, b.tag));
};
function $3b3996e8d1fa8468$var$Fk(a, b) {
    return $3b3996e8d1fa8468$var$ac(a, b);
}
function $3b3996e8d1fa8468$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $3b3996e8d1fa8468$var$Bg(a, b, c, d) {
    return new $3b3996e8d1fa8468$var$$k(a, b, c, d);
}
function $3b3996e8d1fa8468$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $3b3996e8d1fa8468$var$Zk(a) {
    if ("function" === typeof a) return $3b3996e8d1fa8468$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $3b3996e8d1fa8468$var$Da) return 11;
        if (a === $3b3996e8d1fa8468$var$Ga) return 14;
    }
    return 2;
}
function $3b3996e8d1fa8468$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $3b3996e8d1fa8468$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $3b3996e8d1fa8468$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $3b3996e8d1fa8468$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $3b3996e8d1fa8468$var$ya:
            return $3b3996e8d1fa8468$var$Tg(c.children, e, f, b);
        case $3b3996e8d1fa8468$var$za:
            g = 8;
            e |= 8;
            break;
        case $3b3996e8d1fa8468$var$Aa:
            return a = $3b3996e8d1fa8468$var$Bg(12, c, b, e | 2), a.elementType = $3b3996e8d1fa8468$var$Aa, a.lanes = f, a;
        case $3b3996e8d1fa8468$var$Ea:
            return a = $3b3996e8d1fa8468$var$Bg(13, c, b, e), a.elementType = $3b3996e8d1fa8468$var$Ea, a.lanes = f, a;
        case $3b3996e8d1fa8468$var$Fa:
            return a = $3b3996e8d1fa8468$var$Bg(19, c, b, e), a.elementType = $3b3996e8d1fa8468$var$Fa, a.lanes = f, a;
        case $3b3996e8d1fa8468$var$Ia:
            return $3b3996e8d1fa8468$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $3b3996e8d1fa8468$var$Ba:
                    g = 10;
                    break a;
                case $3b3996e8d1fa8468$var$Ca:
                    g = 9;
                    break a;
                case $3b3996e8d1fa8468$var$Da:
                    g = 11;
                    break a;
                case $3b3996e8d1fa8468$var$Ga:
                    g = 14;
                    break a;
                case $3b3996e8d1fa8468$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($3b3996e8d1fa8468$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $3b3996e8d1fa8468$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $3b3996e8d1fa8468$var$Tg(a, b, c, d) {
    a = $3b3996e8d1fa8468$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $3b3996e8d1fa8468$var$pj(a, b, c, d) {
    a = $3b3996e8d1fa8468$var$Bg(22, a, d, b);
    a.elementType = $3b3996e8d1fa8468$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $3b3996e8d1fa8468$var$Qg(a, b, c) {
    a = $3b3996e8d1fa8468$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $3b3996e8d1fa8468$var$Sg(a, b, c) {
    b = $3b3996e8d1fa8468$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $3b3996e8d1fa8468$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $3b3996e8d1fa8468$var$zc(0);
    this.expirationTimes = $3b3996e8d1fa8468$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $3b3996e8d1fa8468$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $3b3996e8d1fa8468$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $3b3996e8d1fa8468$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $3b3996e8d1fa8468$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $3b3996e8d1fa8468$var$kh(f);
    return a;
}
function $3b3996e8d1fa8468$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $3b3996e8d1fa8468$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $3b3996e8d1fa8468$var$dl(a) {
    if (!a) return $3b3996e8d1fa8468$var$Vf;
    a = a._reactInternals;
    a: {
        if ($3b3996e8d1fa8468$var$Vb(a) !== a || 1 !== a.tag) throw Error($3b3996e8d1fa8468$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($3b3996e8d1fa8468$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($3b3996e8d1fa8468$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($3b3996e8d1fa8468$var$Zf(c)) return $3b3996e8d1fa8468$var$bg(a, c, b);
    }
    return b;
}
function $3b3996e8d1fa8468$var$el(a, b, c, d, e, f, g, h, k) {
    a = $3b3996e8d1fa8468$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $3b3996e8d1fa8468$var$dl(null);
    c = a.current;
    d = $3b3996e8d1fa8468$var$R();
    e = $3b3996e8d1fa8468$var$yi(c);
    f = $3b3996e8d1fa8468$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $3b3996e8d1fa8468$var$nh(c, f, e);
    a.current.lanes = e;
    $3b3996e8d1fa8468$var$Ac(a, e, d);
    $3b3996e8d1fa8468$var$Dk(a, d);
    return a;
}
function $3b3996e8d1fa8468$var$fl(a, b, c, d) {
    var e = b.current, f = $3b3996e8d1fa8468$var$R(), g = $3b3996e8d1fa8468$var$yi(e);
    c = $3b3996e8d1fa8468$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $3b3996e8d1fa8468$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $3b3996e8d1fa8468$var$nh(e, b, g);
    null !== a && ($3b3996e8d1fa8468$var$gi(a, e, g, f), $3b3996e8d1fa8468$var$oh(a, e, g));
    return g;
}
function $3b3996e8d1fa8468$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $3b3996e8d1fa8468$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $3b3996e8d1fa8468$var$il(a, b) {
    $3b3996e8d1fa8468$var$hl(a, b);
    (a = a.alternate) && $3b3996e8d1fa8468$var$hl(a, b);
}
function $3b3996e8d1fa8468$var$jl() {
    return null;
}
var $3b3996e8d1fa8468$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $3b3996e8d1fa8468$var$ll(a) {
    this._internalRoot = a;
}
$3b3996e8d1fa8468$var$ml.prototype.render = $3b3996e8d1fa8468$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($3b3996e8d1fa8468$var$p(409));
    $3b3996e8d1fa8468$var$fl(a, b, null, null);
};
$3b3996e8d1fa8468$var$ml.prototype.unmount = $3b3996e8d1fa8468$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $3b3996e8d1fa8468$var$Rk(function() {
            $3b3996e8d1fa8468$var$fl(null, a, null, null);
        });
        b[$3b3996e8d1fa8468$var$uf] = null;
    }
};
function $3b3996e8d1fa8468$var$ml(a) {
    this._internalRoot = a;
}
$3b3996e8d1fa8468$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $3b3996e8d1fa8468$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $3b3996e8d1fa8468$var$Qc.length && 0 !== b && b < $3b3996e8d1fa8468$var$Qc[c].priority; c++);
        $3b3996e8d1fa8468$var$Qc.splice(c, 0, a);
        0 === c && $3b3996e8d1fa8468$var$Vc(a);
    }
};
function $3b3996e8d1fa8468$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $3b3996e8d1fa8468$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $3b3996e8d1fa8468$var$pl() {}
function $3b3996e8d1fa8468$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $3b3996e8d1fa8468$var$gl(g);
                f.call(a);
            };
        }
        var g = $3b3996e8d1fa8468$var$el(b, d, a, 0, null, !1, !1, "", $3b3996e8d1fa8468$var$pl);
        a._reactRootContainer = g;
        a[$3b3996e8d1fa8468$var$uf] = g.current;
        $3b3996e8d1fa8468$var$sf(8 === a.nodeType ? a.parentNode : a);
        $3b3996e8d1fa8468$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $3b3996e8d1fa8468$var$gl(k);
            h.call(a);
        };
    }
    var k = $3b3996e8d1fa8468$var$bl(a, 0, !1, null, null, !1, !1, "", $3b3996e8d1fa8468$var$pl);
    a._reactRootContainer = k;
    a[$3b3996e8d1fa8468$var$uf] = k.current;
    $3b3996e8d1fa8468$var$sf(8 === a.nodeType ? a.parentNode : a);
    $3b3996e8d1fa8468$var$Rk(function() {
        $3b3996e8d1fa8468$var$fl(b, k, c, d);
    });
    return k;
}
function $3b3996e8d1fa8468$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $3b3996e8d1fa8468$var$gl(g);
                h.call(a);
            };
        }
        $3b3996e8d1fa8468$var$fl(b, g, a, e);
    } else g = $3b3996e8d1fa8468$var$ql(c, b, a, e, d);
    return $3b3996e8d1fa8468$var$gl(g);
}
$3b3996e8d1fa8468$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $3b3996e8d1fa8468$var$tc(b.pendingLanes);
                0 !== c && ($3b3996e8d1fa8468$var$Cc(b, c | 1), $3b3996e8d1fa8468$var$Dk(b, $3b3996e8d1fa8468$var$B()), 0 === ($3b3996e8d1fa8468$var$K & 6) && ($3b3996e8d1fa8468$var$Gj = $3b3996e8d1fa8468$var$B() + 500, $3b3996e8d1fa8468$var$jg()));
            }
            break;
        case 13:
            $3b3996e8d1fa8468$var$Rk(function() {
                var b = $3b3996e8d1fa8468$var$ih(a, 1);
                if (null !== b) {
                    var c = $3b3996e8d1fa8468$var$R();
                    $3b3996e8d1fa8468$var$gi(b, a, 1, c);
                }
            }), $3b3996e8d1fa8468$var$il(a, 1);
    }
};
$3b3996e8d1fa8468$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $3b3996e8d1fa8468$var$ih(a, 134217728);
        if (null !== b) {
            var c = $3b3996e8d1fa8468$var$R();
            $3b3996e8d1fa8468$var$gi(b, a, 134217728, c);
        }
        $3b3996e8d1fa8468$var$il(a, 134217728);
    }
};
$3b3996e8d1fa8468$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $3b3996e8d1fa8468$var$yi(a), c = $3b3996e8d1fa8468$var$ih(a, b);
        if (null !== c) {
            var d = $3b3996e8d1fa8468$var$R();
            $3b3996e8d1fa8468$var$gi(c, a, b, d);
        }
        $3b3996e8d1fa8468$var$il(a, b);
    }
};
$3b3996e8d1fa8468$var$Hc = function() {
    return $3b3996e8d1fa8468$var$C;
};
$3b3996e8d1fa8468$var$Ic = function(a, b) {
    var c = $3b3996e8d1fa8468$var$C;
    try {
        return $3b3996e8d1fa8468$var$C = a, b();
    } finally{
        $3b3996e8d1fa8468$var$C = c;
    }
};
$3b3996e8d1fa8468$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $3b3996e8d1fa8468$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $3b3996e8d1fa8468$var$Db(d);
                        if (!e) throw Error($3b3996e8d1fa8468$var$p(90));
                        $3b3996e8d1fa8468$var$Wa(d);
                        $3b3996e8d1fa8468$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $3b3996e8d1fa8468$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $3b3996e8d1fa8468$var$fb(a, !!c.multiple, b, !1);
    }
};
$3b3996e8d1fa8468$var$Gb = $3b3996e8d1fa8468$var$Qk;
$3b3996e8d1fa8468$var$Hb = $3b3996e8d1fa8468$var$Rk;
var $3b3996e8d1fa8468$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $3b3996e8d1fa8468$var$Cb,
        $3b3996e8d1fa8468$var$ue,
        $3b3996e8d1fa8468$var$Db,
        $3b3996e8d1fa8468$var$Eb,
        $3b3996e8d1fa8468$var$Fb,
        $3b3996e8d1fa8468$var$Qk
    ]
}, $3b3996e8d1fa8468$var$tl = {
    findFiberByHostInstance: $3b3996e8d1fa8468$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $3b3996e8d1fa8468$var$ul = {
    bundleType: $3b3996e8d1fa8468$var$tl.bundleType,
    version: $3b3996e8d1fa8468$var$tl.version,
    rendererPackageName: $3b3996e8d1fa8468$var$tl.rendererPackageName,
    rendererConfig: $3b3996e8d1fa8468$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $3b3996e8d1fa8468$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $3b3996e8d1fa8468$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $3b3996e8d1fa8468$var$tl.findFiberByHostInstance || $3b3996e8d1fa8468$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $3b3996e8d1fa8468$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$3b3996e8d1fa8468$var$vl.isDisabled && $3b3996e8d1fa8468$var$vl.supportsFiber) try {
        $3b3996e8d1fa8468$var$kc = $3b3996e8d1fa8468$var$vl.inject($3b3996e8d1fa8468$var$ul), $3b3996e8d1fa8468$var$lc = $3b3996e8d1fa8468$var$vl;
    } catch (a) {}
}
$3b3996e8d1fa8468$export$ae55be85d98224ed = $3b3996e8d1fa8468$var$sl;
$3b3996e8d1fa8468$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$3b3996e8d1fa8468$var$nl(b)) throw Error($3b3996e8d1fa8468$var$p(200));
    return $3b3996e8d1fa8468$var$cl(a, b, null, c);
};
$3b3996e8d1fa8468$export$882461b6382ed46c = function(a, b) {
    if (!$3b3996e8d1fa8468$var$nl(a)) throw Error($3b3996e8d1fa8468$var$p(299));
    var c = !1, d = "", e = $3b3996e8d1fa8468$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $3b3996e8d1fa8468$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$3b3996e8d1fa8468$var$uf] = b.current;
    $3b3996e8d1fa8468$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $3b3996e8d1fa8468$var$ll(b);
};
$3b3996e8d1fa8468$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($3b3996e8d1fa8468$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($3b3996e8d1fa8468$var$p(268, a));
    }
    a = $3b3996e8d1fa8468$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$3b3996e8d1fa8468$export$cd75ccfd720a3cd4 = function(a) {
    return $3b3996e8d1fa8468$var$Rk(a);
};
$3b3996e8d1fa8468$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$3b3996e8d1fa8468$var$ol(b)) throw Error($3b3996e8d1fa8468$var$p(200));
    return $3b3996e8d1fa8468$var$rl(null, a, b, !0, c);
};
$3b3996e8d1fa8468$export$757ceba2d55c277e = function(a, b, c) {
    if (!$3b3996e8d1fa8468$var$nl(a)) throw Error($3b3996e8d1fa8468$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $3b3996e8d1fa8468$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $3b3996e8d1fa8468$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$3b3996e8d1fa8468$var$uf] = b.current;
    $3b3996e8d1fa8468$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $3b3996e8d1fa8468$var$ml(b);
};
$3b3996e8d1fa8468$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$3b3996e8d1fa8468$var$ol(b)) throw Error($3b3996e8d1fa8468$var$p(200));
    return $3b3996e8d1fa8468$var$rl(null, a, b, !1, c);
};
$3b3996e8d1fa8468$export$502457920280e6be = function(a) {
    if (!$3b3996e8d1fa8468$var$ol(a)) throw Error($3b3996e8d1fa8468$var$p(40));
    return a._reactRootContainer ? ($3b3996e8d1fa8468$var$Rk(function() {
        $3b3996e8d1fa8468$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$3b3996e8d1fa8468$var$uf] = null;
        });
    }), !0) : !1;
};
$3b3996e8d1fa8468$export$c78a37762a8d58e1 = $3b3996e8d1fa8468$var$Qk;
$3b3996e8d1fa8468$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$3b3996e8d1fa8468$var$ol(c)) throw Error($3b3996e8d1fa8468$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($3b3996e8d1fa8468$var$p(38));
    return $3b3996e8d1fa8468$var$rl(a, b, c, !1, d);
};
$3b3996e8d1fa8468$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("j1S5s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("ijP0m"));

});
parcelRegister("ijP0m", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $d56190d9ba92e836$export$c4744153514ff05d; }, function (v) { return $d56190d9ba92e836$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $d56190d9ba92e836$export$3e506c1ccc9cc1a7; }, function (v) { return $d56190d9ba92e836$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $d56190d9ba92e836$export$e26fe2ed2fa76875; }, function (v) { return $d56190d9ba92e836$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $d56190d9ba92e836$export$502329bbf4b505b1; }, function (v) { return $d56190d9ba92e836$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $d56190d9ba92e836$export$6e3807111c4874c4; }, function (v) { return $d56190d9ba92e836$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $d56190d9ba92e836$export$c27134553091fb3a; }, function (v) { return $d56190d9ba92e836$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $d56190d9ba92e836$export$33ee1acdc04fd2a2; }, function (v) { return $d56190d9ba92e836$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $d56190d9ba92e836$export$b00a404bbd5edef2; }, function (v) { return $d56190d9ba92e836$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $d56190d9ba92e836$export$8352ce38b91d0c62; }, function (v) { return $d56190d9ba92e836$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $d56190d9ba92e836$export$d66a1c1c77bd778b; }, function (v) { return $d56190d9ba92e836$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $d56190d9ba92e836$export$d3dfb8e4810cb555; }, function (v) { return $d56190d9ba92e836$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $d56190d9ba92e836$export$839f9183b0465a69; }, function (v) { return $d56190d9ba92e836$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $d56190d9ba92e836$export$72fdf0e06517287b; }, function (v) { return $d56190d9ba92e836$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $d56190d9ba92e836$export$4b844e58a3e414b4; }, function (v) { return $d56190d9ba92e836$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $d56190d9ba92e836$export$816d2913ae6b83b1; }, function (v) { return $d56190d9ba92e836$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $d56190d9ba92e836$export$61bcfe829111a1d0; }, function (v) { return $d56190d9ba92e836$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $d56190d9ba92e836$export$7ee8c9beb337bc3f; }, function (v) { return $d56190d9ba92e836$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $d56190d9ba92e836$export$b5836b71941fa3ed; }, function (v) { return $d56190d9ba92e836$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $d56190d9ba92e836$export$cf845f2c119da08a; }, function (v) { return $d56190d9ba92e836$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d56190d9ba92e836$export$c4744153514ff05d;
var $d56190d9ba92e836$export$3e506c1ccc9cc1a7;
var $d56190d9ba92e836$export$e26fe2ed2fa76875;
var $d56190d9ba92e836$export$502329bbf4b505b1;
var $d56190d9ba92e836$export$6e3807111c4874c4;
var $d56190d9ba92e836$export$c27134553091fb3a;
var $d56190d9ba92e836$export$33ee1acdc04fd2a2;
var $d56190d9ba92e836$export$b00a404bbd5edef2;
var $d56190d9ba92e836$export$8352ce38b91d0c62;
var $d56190d9ba92e836$export$d66a1c1c77bd778b;
var $d56190d9ba92e836$export$d3dfb8e4810cb555;
var $d56190d9ba92e836$export$839f9183b0465a69;
var $d56190d9ba92e836$export$72fdf0e06517287b;
var $d56190d9ba92e836$export$4b844e58a3e414b4;
var $d56190d9ba92e836$export$816d2913ae6b83b1;
var $d56190d9ba92e836$export$61bcfe829111a1d0;
var $d56190d9ba92e836$export$7ee8c9beb337bc3f;
var $d56190d9ba92e836$export$b5836b71941fa3ed;
var $d56190d9ba92e836$export$cf845f2c119da08a;
"use strict";
function $d56190d9ba92e836$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $d56190d9ba92e836$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $d56190d9ba92e836$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $d56190d9ba92e836$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $d56190d9ba92e836$var$g(C, c)) n < e && 0 > $d56190d9ba92e836$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $d56190d9ba92e836$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $d56190d9ba92e836$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $d56190d9ba92e836$var$l = performance;
    $d56190d9ba92e836$export$c4744153514ff05d = function() {
        return $d56190d9ba92e836$var$l.now();
    };
} else {
    var $d56190d9ba92e836$var$p = Date, $d56190d9ba92e836$var$q = $d56190d9ba92e836$var$p.now();
    $d56190d9ba92e836$export$c4744153514ff05d = function() {
        return $d56190d9ba92e836$var$p.now() - $d56190d9ba92e836$var$q;
    };
}
var $d56190d9ba92e836$var$r = [], $d56190d9ba92e836$var$t = [], $d56190d9ba92e836$var$u = 1, $d56190d9ba92e836$var$v = null, $d56190d9ba92e836$var$y = 3, $d56190d9ba92e836$var$z = !1, $d56190d9ba92e836$var$A = !1, $d56190d9ba92e836$var$B = !1, $d56190d9ba92e836$var$D = "function" === typeof setTimeout ? setTimeout : null, $d56190d9ba92e836$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $d56190d9ba92e836$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $d56190d9ba92e836$var$G(a) {
    for(var b = $d56190d9ba92e836$var$h($d56190d9ba92e836$var$t); null !== b;){
        if (null === b.callback) $d56190d9ba92e836$var$k($d56190d9ba92e836$var$t);
        else if (b.startTime <= a) $d56190d9ba92e836$var$k($d56190d9ba92e836$var$t), b.sortIndex = b.expirationTime, $d56190d9ba92e836$var$f($d56190d9ba92e836$var$r, b);
        else break;
        b = $d56190d9ba92e836$var$h($d56190d9ba92e836$var$t);
    }
}
function $d56190d9ba92e836$var$H(a) {
    $d56190d9ba92e836$var$B = !1;
    $d56190d9ba92e836$var$G(a);
    if (!$d56190d9ba92e836$var$A) {
        if (null !== $d56190d9ba92e836$var$h($d56190d9ba92e836$var$r)) $d56190d9ba92e836$var$A = !0, $d56190d9ba92e836$var$I($d56190d9ba92e836$var$J);
        else {
            var b = $d56190d9ba92e836$var$h($d56190d9ba92e836$var$t);
            null !== b && $d56190d9ba92e836$var$K($d56190d9ba92e836$var$H, b.startTime - a);
        }
    }
}
function $d56190d9ba92e836$var$J(a, b) {
    $d56190d9ba92e836$var$A = !1;
    $d56190d9ba92e836$var$B && ($d56190d9ba92e836$var$B = !1, $d56190d9ba92e836$var$E($d56190d9ba92e836$var$L), $d56190d9ba92e836$var$L = -1);
    $d56190d9ba92e836$var$z = !0;
    var c = $d56190d9ba92e836$var$y;
    try {
        $d56190d9ba92e836$var$G(b);
        for($d56190d9ba92e836$var$v = $d56190d9ba92e836$var$h($d56190d9ba92e836$var$r); null !== $d56190d9ba92e836$var$v && (!($d56190d9ba92e836$var$v.expirationTime > b) || a && !$d56190d9ba92e836$var$M());){
            var d = $d56190d9ba92e836$var$v.callback;
            if ("function" === typeof d) {
                $d56190d9ba92e836$var$v.callback = null;
                $d56190d9ba92e836$var$y = $d56190d9ba92e836$var$v.priorityLevel;
                var e = d($d56190d9ba92e836$var$v.expirationTime <= b);
                b = $d56190d9ba92e836$export$c4744153514ff05d();
                "function" === typeof e ? $d56190d9ba92e836$var$v.callback = e : $d56190d9ba92e836$var$v === $d56190d9ba92e836$var$h($d56190d9ba92e836$var$r) && $d56190d9ba92e836$var$k($d56190d9ba92e836$var$r);
                $d56190d9ba92e836$var$G(b);
            } else $d56190d9ba92e836$var$k($d56190d9ba92e836$var$r);
            $d56190d9ba92e836$var$v = $d56190d9ba92e836$var$h($d56190d9ba92e836$var$r);
        }
        if (null !== $d56190d9ba92e836$var$v) var w = !0;
        else {
            var m = $d56190d9ba92e836$var$h($d56190d9ba92e836$var$t);
            null !== m && $d56190d9ba92e836$var$K($d56190d9ba92e836$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $d56190d9ba92e836$var$v = null, $d56190d9ba92e836$var$y = c, $d56190d9ba92e836$var$z = !1;
    }
}
var $d56190d9ba92e836$var$N = !1, $d56190d9ba92e836$var$O = null, $d56190d9ba92e836$var$L = -1, $d56190d9ba92e836$var$P = 5, $d56190d9ba92e836$var$Q = -1;
function $d56190d9ba92e836$var$M() {
    return $d56190d9ba92e836$export$c4744153514ff05d() - $d56190d9ba92e836$var$Q < $d56190d9ba92e836$var$P ? !1 : !0;
}
function $d56190d9ba92e836$var$R() {
    if (null !== $d56190d9ba92e836$var$O) {
        var a = $d56190d9ba92e836$export$c4744153514ff05d();
        $d56190d9ba92e836$var$Q = a;
        var b = !0;
        try {
            b = $d56190d9ba92e836$var$O(!0, a);
        } finally{
            b ? $d56190d9ba92e836$var$S() : ($d56190d9ba92e836$var$N = !1, $d56190d9ba92e836$var$O = null);
        }
    } else $d56190d9ba92e836$var$N = !1;
}
var $d56190d9ba92e836$var$S;
if ("function" === typeof $d56190d9ba92e836$var$F) $d56190d9ba92e836$var$S = function() {
    $d56190d9ba92e836$var$F($d56190d9ba92e836$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $d56190d9ba92e836$var$T = new MessageChannel, $d56190d9ba92e836$var$U = $d56190d9ba92e836$var$T.port2;
    $d56190d9ba92e836$var$T.port1.onmessage = $d56190d9ba92e836$var$R;
    $d56190d9ba92e836$var$S = function() {
        $d56190d9ba92e836$var$U.postMessage(null);
    };
} else $d56190d9ba92e836$var$S = function() {
    $d56190d9ba92e836$var$D($d56190d9ba92e836$var$R, 0);
};
function $d56190d9ba92e836$var$I(a) {
    $d56190d9ba92e836$var$O = a;
    $d56190d9ba92e836$var$N || ($d56190d9ba92e836$var$N = !0, $d56190d9ba92e836$var$S());
}
function $d56190d9ba92e836$var$K(a, b) {
    $d56190d9ba92e836$var$L = $d56190d9ba92e836$var$D(function() {
        a($d56190d9ba92e836$export$c4744153514ff05d());
    }, b);
}
$d56190d9ba92e836$export$3e506c1ccc9cc1a7 = 5;
$d56190d9ba92e836$export$e26fe2ed2fa76875 = 1;
$d56190d9ba92e836$export$502329bbf4b505b1 = 4;
$d56190d9ba92e836$export$6e3807111c4874c4 = 3;
$d56190d9ba92e836$export$c27134553091fb3a = null;
$d56190d9ba92e836$export$33ee1acdc04fd2a2 = 2;
$d56190d9ba92e836$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$d56190d9ba92e836$export$8352ce38b91d0c62 = function() {
    $d56190d9ba92e836$var$A || $d56190d9ba92e836$var$z || ($d56190d9ba92e836$var$A = !0, $d56190d9ba92e836$var$I($d56190d9ba92e836$var$J));
};
$d56190d9ba92e836$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $d56190d9ba92e836$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$d56190d9ba92e836$export$d3dfb8e4810cb555 = function() {
    return $d56190d9ba92e836$var$y;
};
$d56190d9ba92e836$export$839f9183b0465a69 = function() {
    return $d56190d9ba92e836$var$h($d56190d9ba92e836$var$r);
};
$d56190d9ba92e836$export$72fdf0e06517287b = function(a) {
    switch($d56190d9ba92e836$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $d56190d9ba92e836$var$y;
    }
    var c = $d56190d9ba92e836$var$y;
    $d56190d9ba92e836$var$y = b;
    try {
        return a();
    } finally{
        $d56190d9ba92e836$var$y = c;
    }
};
$d56190d9ba92e836$export$4b844e58a3e414b4 = function() {};
$d56190d9ba92e836$export$816d2913ae6b83b1 = function() {};
$d56190d9ba92e836$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $d56190d9ba92e836$var$y;
    $d56190d9ba92e836$var$y = a;
    try {
        return b();
    } finally{
        $d56190d9ba92e836$var$y = c;
    }
};
$d56190d9ba92e836$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $d56190d9ba92e836$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $d56190d9ba92e836$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $d56190d9ba92e836$var$f($d56190d9ba92e836$var$t, a), null === $d56190d9ba92e836$var$h($d56190d9ba92e836$var$r) && a === $d56190d9ba92e836$var$h($d56190d9ba92e836$var$t) && ($d56190d9ba92e836$var$B ? ($d56190d9ba92e836$var$E($d56190d9ba92e836$var$L), $d56190d9ba92e836$var$L = -1) : $d56190d9ba92e836$var$B = !0, $d56190d9ba92e836$var$K($d56190d9ba92e836$var$H, c - d))) : (a.sortIndex = e, $d56190d9ba92e836$var$f($d56190d9ba92e836$var$r, a), $d56190d9ba92e836$var$A || $d56190d9ba92e836$var$z || ($d56190d9ba92e836$var$A = !0, $d56190d9ba92e836$var$I($d56190d9ba92e836$var$J)));
    return a;
};
$d56190d9ba92e836$export$b5836b71941fa3ed = $d56190d9ba92e836$var$M;
$d56190d9ba92e836$export$cf845f2c119da08a = function(a) {
    var b = $d56190d9ba92e836$var$y;
    return function() {
        var c = $d56190d9ba92e836$var$y;
        $d56190d9ba92e836$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $d56190d9ba92e836$var$y = c;
        }
    };
};

});




parcelRegister("1EEMt", function(module, exports) {

$parcel$export(module.exports, "observer", function () { return $13492912db7fef53$export$b6ae1bc530f4c149; });

var $4JcCM = parcelRequire("4JcCM");

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("fuFv1");
var $5KWYn = parcelRequire("5KWYn");
var $aPVKl = parcelRequire("aPVKl");
var $13492912db7fef53$var$symbolId = 0;
function $13492912db7fef53$var$createSymbol(name) {
    if (typeof Symbol === "function") return Symbol(name);
    var symbol = "__$mobx-react " + name + " (" + $13492912db7fef53$var$symbolId + ")";
    $13492912db7fef53$var$symbolId++;
    return symbol;
}
var $13492912db7fef53$var$createdSymbols = {};
function $13492912db7fef53$var$newSymbol(name) {
    if (!$13492912db7fef53$var$createdSymbols[name]) $13492912db7fef53$var$createdSymbols[name] = $13492912db7fef53$var$createSymbol(name);
    return $13492912db7fef53$var$createdSymbols[name];
}
function $13492912db7fef53$var$shallowEqual(objA, objB) {
    //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if ($13492912db7fef53$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.hasOwnProperty.call(objB, keysA[i]) || !$13492912db7fef53$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
function $13492912db7fef53$var$is(x, y) {
    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
} // based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $13492912db7fef53$var$hoistBlackList = {
    $$typeof: 1,
    render: 1,
    compare: 1,
    type: 1,
    childContextTypes: 1,
    contextType: 1,
    contextTypes: 1,
    defaultProps: 1,
    getDefaultProps: 1,
    getDerivedStateFromError: 1,
    getDerivedStateFromProps: 1,
    mixins: 1,
    displayName: 1,
    propTypes: 1
};
function $13492912db7fef53$var$copyStaticProperties(base, target) {
    var protoProps = Object.getOwnPropertyNames(Object.getPrototypeOf(base));
    Object.getOwnPropertyNames(base).forEach(function(key) {
        if (!$13492912db7fef53$var$hoistBlackList[key] && protoProps.indexOf(key) === -1) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}
/**
 * Helper to set `prop` to `this` as non-enumerable (hidden prop)
 * @param target
 * @param prop
 * @param value
 */ function $13492912db7fef53$var$setHiddenProp(target, prop, value) {
    if (!Object.hasOwnProperty.call(target, prop)) Object.defineProperty(target, prop, {
        enumerable: false,
        configurable: true,
        writable: true,
        value: value
    });
    else target[prop] = value;
}
/**
 * Utilities for patching componentWillUnmount, to make sure @disposeOnUnmount works correctly icm with user defined hooks
 * and the handler provided by mobx-react
 */ var $13492912db7fef53$var$mobxMixins = /*#__PURE__*/ $13492912db7fef53$var$newSymbol("patchMixins");
var $13492912db7fef53$var$mobxPatchedDefinition = /*#__PURE__*/ $13492912db7fef53$var$newSymbol("patchedDefinition");
function $13492912db7fef53$var$getMixins(target, methodName) {
    var mixins = target[$13492912db7fef53$var$mobxMixins] = target[$13492912db7fef53$var$mobxMixins] || {};
    var methodMixins = mixins[methodName] = mixins[methodName] || {};
    methodMixins.locks = methodMixins.locks || 0;
    methodMixins.methods = methodMixins.methods || [];
    return methodMixins;
}
function $13492912db7fef53$var$wrapper(realMethod, mixins) {
    var _this = this;
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    // locks are used to ensure that mixins are invoked only once per invocation, even on recursive calls
    mixins.locks++;
    try {
        var retVal;
        if (realMethod !== undefined && realMethod !== null) retVal = realMethod.apply(this, args);
        return retVal;
    } finally{
        mixins.locks--;
        if (mixins.locks === 0) mixins.methods.forEach(function(mx) {
            mx.apply(_this, args);
        });
    }
}
function $13492912db7fef53$var$wrapFunction(realMethod, mixins) {
    var fn = function fn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        $13492912db7fef53$var$wrapper.call.apply($13492912db7fef53$var$wrapper, [
            this,
            realMethod,
            mixins
        ].concat(args));
    };
    return fn;
}
function $13492912db7fef53$var$patch(target, methodName, mixinMethod) {
    var mixins = $13492912db7fef53$var$getMixins(target, methodName);
    if (mixins.methods.indexOf(mixinMethod) < 0) mixins.methods.push(mixinMethod);
    var oldDefinition = Object.getOwnPropertyDescriptor(target, methodName);
    if (oldDefinition && oldDefinition[$13492912db7fef53$var$mobxPatchedDefinition]) // already patched definition, do not repatch
    return;
    var originalMethod = target[methodName];
    var newDefinition = $13492912db7fef53$var$createDefinition(target, methodName, oldDefinition ? oldDefinition.enumerable : undefined, mixins, originalMethod);
    Object.defineProperty(target, methodName, newDefinition);
}
function $13492912db7fef53$var$createDefinition(target, methodName, enumerable, mixins, originalMethod) {
    var _ref;
    var wrappedFunc = $13492912db7fef53$var$wrapFunction(originalMethod, mixins);
    return _ref = {}, _ref[$13492912db7fef53$var$mobxPatchedDefinition] = true, _ref.get = function get() {
        return wrappedFunc;
    }, _ref.set = function set(value) {
        if (this === target) wrappedFunc = $13492912db7fef53$var$wrapFunction(value, mixins);
        else {
            // when it is an instance of the prototype/a child prototype patch that particular case again separately
            // since we need to store separate values depending on wether it is the actual instance, the prototype, etc
            // e.g. the method for super might not be the same as the method for the prototype which might be not the same
            // as the method for the instance
            var newDefinition = $13492912db7fef53$var$createDefinition(this, methodName, enumerable, mixins, value);
            Object.defineProperty(this, methodName, newDefinition);
        }
    }, _ref.configurable = true, _ref.enumerable = enumerable, _ref;
}
var $13492912db7fef53$var$mobxAdminProperty = (0, $4JcCM.$mobx) || "$mobx"; // BC
var $13492912db7fef53$var$mobxObserverProperty = /*#__PURE__*/ $13492912db7fef53$var$newSymbol("isMobXReactObserver");
var $13492912db7fef53$var$mobxIsUnmounted = /*#__PURE__*/ $13492912db7fef53$var$newSymbol("isUnmounted");
var $13492912db7fef53$var$skipRenderKey = /*#__PURE__*/ $13492912db7fef53$var$newSymbol("skipRender");
var $13492912db7fef53$var$isForcingUpdateKey = /*#__PURE__*/ $13492912db7fef53$var$newSymbol("isForcingUpdate");
function $13492912db7fef53$var$makeClassComponentObserver(componentClass) {
    var target = componentClass.prototype;
    if (componentClass[$13492912db7fef53$var$mobxObserverProperty]) {
        var displayName = $13492912db7fef53$var$getDisplayName(target);
        console.warn("The provided component class (" + displayName + ")\n                has already been declared as an observer component.");
    } else componentClass[$13492912db7fef53$var$mobxObserverProperty] = true;
    if (target.componentWillReact) throw new Error("The componentWillReact life-cycle event is no longer supported");
    if (componentClass["__proto__"] !== (0, $jbmdS.PureComponent)) {
        if (!target.shouldComponentUpdate) target.shouldComponentUpdate = $13492912db7fef53$var$observerSCU;
        else if (target.shouldComponentUpdate !== $13492912db7fef53$var$observerSCU) // n.b. unequal check, instead of existence check, as @observer might be on superclass as well
        throw new Error("It is not allowed to use shouldComponentUpdate in observer based components.");
    } // this.props and this.state are made observable, just to make sure @computed fields that
    // are defined inside the component, and which rely on state or props, re-compute if state or props change
    // (otherwise the computed wouldn't update and become stale on props change, since props are not observable)
    // However, this solution is not without it's own problems: https://github.com/mobxjs/mobx-react/issues?utf8=%E2%9C%93&q=is%3Aissue+label%3Aobservable-props-or-not+
    $13492912db7fef53$var$makeObservableProp(target, "props");
    $13492912db7fef53$var$makeObservableProp(target, "state");
    if (componentClass.contextType) $13492912db7fef53$var$makeObservableProp(target, "context");
    var originalRender = target.render;
    if (typeof originalRender !== "function") {
        var _displayName = $13492912db7fef53$var$getDisplayName(target);
        throw new Error("[mobx-react] class component (" + _displayName + ") is missing `render` method." + "\n`observer` requires `render` being a function defined on prototype." + "\n`render = () => {}` or `render = function() {}` is not supported.");
    }
    target.render = function() {
        this.render = (0, $5KWYn.isUsingStaticRendering)() ? originalRender : $13492912db7fef53$var$createReactiveRender.call(this, originalRender);
        return this.render();
    };
    $13492912db7fef53$var$patch(target, "componentDidMount", function() {
        this[$13492912db7fef53$var$mobxIsUnmounted] = false;
        if (!this.render[$13492912db7fef53$var$mobxAdminProperty]) // Reaction is re-created automatically during render, but a component can re-mount and skip render #3395.
        // To re-create the reaction and re-subscribe to relevant observables we have to force an update.
        (0, $jbmdS.Component).prototype.forceUpdate.call(this);
    });
    $13492912db7fef53$var$patch(target, "componentWillUnmount", function() {
        if ((0, $5KWYn.isUsingStaticRendering)()) return;
        var reaction = this.render[$13492912db7fef53$var$mobxAdminProperty];
        if (reaction) {
            reaction.dispose(); // Forces reaction to be re-created on next render
            this.render[$13492912db7fef53$var$mobxAdminProperty] = null;
        } else {
            // Render may have been hot-swapped and/or overridden by a subclass.
            var _displayName2 = $13492912db7fef53$var$getDisplayName(this);
            console.warn("The reactive render of an observer class component (" + _displayName2 + ")\n                was overridden after MobX attached. This may result in a memory leak if the\n                overridden reactive render was not properly disposed.");
        }
        this[$13492912db7fef53$var$mobxIsUnmounted] = true;
    });
    return componentClass;
} // Generates a friendly name for debugging
function $13492912db7fef53$var$getDisplayName(comp) {
    return comp.displayName || comp.name || comp.constructor && (comp.constructor.displayName || comp.constructor.name) || "<component>";
}
function $13492912db7fef53$var$createReactiveRender(originalRender) {
    var _this = this;
    /**
   * If props are shallowly modified, react will render anyway,
   * so atom.reportChanged() should not result in yet another re-render
   */ $13492912db7fef53$var$setHiddenProp(this, $13492912db7fef53$var$skipRenderKey, false);
    /**
   * forceUpdate will re-assign this.props. We don't want that to cause a loop,
   * so detect these changes
   */ $13492912db7fef53$var$setHiddenProp(this, $13492912db7fef53$var$isForcingUpdateKey, false);
    var initialName = $13492912db7fef53$var$getDisplayName(this);
    var boundOriginalRender = originalRender.bind(this);
    var isRenderingPending = false;
    var createReaction = function createReaction() {
        var reaction = new (0, $4JcCM.Reaction)(initialName + ".render()", function() {
            if (!isRenderingPending) {
                // N.B. Getting here *before mounting* means that a component constructor has side effects (see the relevant test in misc.test.tsx)
                // This unidiomatic React usage but React will correctly warn about this so we continue as usual
                // See #85 / Pull #44
                isRenderingPending = true;
                if (_this[$13492912db7fef53$var$mobxIsUnmounted] !== true) {
                    var hasError = true;
                    try {
                        $13492912db7fef53$var$setHiddenProp(_this, $13492912db7fef53$var$isForcingUpdateKey, true);
                        if (!_this[$13492912db7fef53$var$skipRenderKey]) (0, $jbmdS.Component).prototype.forceUpdate.call(_this);
                        hasError = false;
                    } finally{
                        $13492912db7fef53$var$setHiddenProp(_this, $13492912db7fef53$var$isForcingUpdateKey, false);
                        if (hasError) {
                            reaction.dispose(); // Forces reaction to be re-created on next render
                            _this.render[$13492912db7fef53$var$mobxAdminProperty] = null;
                        }
                    }
                }
            }
        });
        reaction["reactComponent"] = _this;
        return reaction;
    };
    function reactiveRender() {
        var _reactiveRender$mobxA;
        isRenderingPending = false; // Create reaction lazily to support re-mounting #3395
        var reaction = (_reactiveRender$mobxA = reactiveRender[$13492912db7fef53$var$mobxAdminProperty]) != null ? _reactiveRender$mobxA : reactiveRender[$13492912db7fef53$var$mobxAdminProperty] = createReaction();
        var exception = undefined;
        var rendering = undefined;
        reaction.track(function() {
            try {
                // TODO@major
                // Optimization: replace with _allowStateChangesStart/End (not available in mobx@6.0.0)
                rendering = (0, $4JcCM._allowStateChanges)(false, boundOriginalRender);
            } catch (e) {
                exception = e;
            }
        });
        if (exception) throw exception;
        return rendering;
    }
    return reactiveRender;
}
function $13492912db7fef53$var$observerSCU(nextProps, nextState) {
    if ((0, $5KWYn.isUsingStaticRendering)()) console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
     // update on any state changes (as is the default)
    if (this.state !== nextState) return true;
     // update if props are shallowly not equal, inspired by PureRenderMixin
    // we could return just 'false' here, and avoid the `skipRender` checks etc
    // however, it is nicer if lifecycle events are triggered like usually,
    // so we return true here if props are shallowly modified.
    return !$13492912db7fef53$var$shallowEqual(this.props, nextProps);
}
function $13492912db7fef53$var$makeObservableProp(target, propName) {
    var valueHolderKey = $13492912db7fef53$var$newSymbol("reactProp_" + propName + "_valueHolder");
    var atomHolderKey = $13492912db7fef53$var$newSymbol("reactProp_" + propName + "_atomHolder");
    function getAtom() {
        if (!this[atomHolderKey]) $13492912db7fef53$var$setHiddenProp(this, atomHolderKey, (0, $4JcCM.createAtom)("reactive " + propName));
        return this[atomHolderKey];
    }
    Object.defineProperty(target, propName, {
        configurable: true,
        enumerable: true,
        get: function get() {
            var prevReadState = false; // Why this check? BC?
            // @ts-expect-error
            if ((0, $4JcCM._allowStateReadsStart) && (0, $4JcCM._allowStateReadsEnd)) prevReadState = (0, $4JcCM._allowStateReadsStart)(true);
            getAtom.call(this).reportObserved(); // Why this check? BC?
            // @ts-expect-error
            if ((0, $4JcCM._allowStateReadsStart) && (0, $4JcCM._allowStateReadsEnd)) (0, $4JcCM._allowStateReadsEnd)(prevReadState);
            return this[valueHolderKey];
        },
        set: function set(v) {
            if (!this[$13492912db7fef53$var$isForcingUpdateKey] && !$13492912db7fef53$var$shallowEqual(this[valueHolderKey], v)) {
                $13492912db7fef53$var$setHiddenProp(this, valueHolderKey, v);
                $13492912db7fef53$var$setHiddenProp(this, $13492912db7fef53$var$skipRenderKey, true);
                getAtom.call(this).reportChanged();
                $13492912db7fef53$var$setHiddenProp(this, $13492912db7fef53$var$skipRenderKey, false);
            } else $13492912db7fef53$var$setHiddenProp(this, valueHolderKey, v);
        }
    });
}
/**
 * Observer function / decorator
 */ function $13492912db7fef53$export$b6ae1bc530f4c149(component) {
    if (component["isMobxInjector"] === true) console.warn("Mobx observer: You are trying to use `observer` on a component that already has `inject`. Please apply `observer` before applying `inject`");
    if (Object.prototype.isPrototypeOf.call((0, $jbmdS.Component), component) || Object.prototype.isPrototypeOf.call((0, $jbmdS.PureComponent), component)) // Class component
    return $13492912db7fef53$var$makeClassComponentObserver(component);
    else // Function component
    return (0, $aPVKl.observer)(component);
}
function $13492912db7fef53$var$_extends() {
    $13492912db7fef53$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $13492912db7fef53$var$_extends.apply(this, arguments);
}
function $13492912db7fef53$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $13492912db7fef53$var$_excluded = [
    "children"
];
var $13492912db7fef53$export$f07786cea590ef31 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createContext({});
function $13492912db7fef53$export$2881499e37b75b9a(props) {
    var children = props.children, stores = $13492912db7fef53$var$_objectWithoutPropertiesLoose(props, $13492912db7fef53$var$_excluded);
    var parentValue = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useContext($13492912db7fef53$export$f07786cea590ef31);
    var mutableProviderRef = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useRef($13492912db7fef53$var$_extends({}, parentValue, stores));
    var value = mutableProviderRef.current;
    var newValue;
    return (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($13492912db7fef53$export$f07786cea590ef31.Provider, {
        value: value
    }, children);
}
$13492912db7fef53$export$2881499e37b75b9a.displayName = "MobXProvider";
/**
 * Store Injection
 */ function $13492912db7fef53$var$createStoreInjector(grabStoresFn, component, injectNames, makeReactive) {
    // Support forward refs
    var Injector = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).forwardRef(function(props, ref) {
        var newProps = $13492912db7fef53$var$_extends({}, props);
        var context = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useContext($13492912db7fef53$export$f07786cea590ef31);
        Object.assign(newProps, grabStoresFn(context || {}, newProps) || {});
        if (ref) newProps.ref = ref;
        return (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement(component, newProps);
    });
    if (makeReactive) Injector = $13492912db7fef53$export$b6ae1bc530f4c149(Injector);
    Injector["isMobxInjector"] = true; // assigned late to suppress observer warning
    // Static fields from component should be visible on the generated Injector
    $13492912db7fef53$var$copyStaticProperties(component, Injector);
    Injector["wrappedComponent"] = component;
    Injector.displayName = $13492912db7fef53$var$getInjectName(component, injectNames);
    return Injector;
}
function $13492912db7fef53$var$getInjectName(component, injectNames) {
    var displayName;
    var componentName = component.displayName || component.name || component.constructor && component.constructor.name || "Component";
    if (injectNames) displayName = "inject-with-" + injectNames + "(" + componentName + ")";
    else displayName = "inject(" + componentName + ")";
    return displayName;
}
function $13492912db7fef53$var$grabStoresByName(storeNames) {
    return function(baseStores, nextProps) {
        storeNames.forEach(function(storeName) {
            if (storeName in nextProps // prefer props over stores
            ) return;
            if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
            nextProps[storeName] = baseStores[storeName];
        });
        return nextProps;
    };
}
/**
 * higher order component that injects stores to a child.
 * takes either a varargs list of strings, which are stores read from the context,
 * or a function that manually maps the available stores from the context to props:
 * storesToProps(mobxStores, props, context) => newProps
 */ function $13492912db7fef53$export$a976684a0efeb93f() {
    for(var _len = arguments.length, storeNames = new Array(_len), _key = 0; _key < _len; _key++)storeNames[_key] = arguments[_key];
    if (typeof arguments[0] === "function") {
        var grabStoresFn = arguments[0];
        return function(componentClass) {
            return $13492912db7fef53$var$createStoreInjector(grabStoresFn, componentClass, grabStoresFn.name, true);
        };
    } else return function(componentClass) {
        return $13492912db7fef53$var$createStoreInjector($13492912db7fef53$var$grabStoresByName(storeNames), componentClass, storeNames.join("-"), false);
    };
}
var $13492912db7fef53$var$protoStoreKey = /*#__PURE__*/ $13492912db7fef53$var$newSymbol("disposeOnUnmountProto");
var $13492912db7fef53$var$instStoreKey = /*#__PURE__*/ $13492912db7fef53$var$newSymbol("disposeOnUnmountInst");
function $13492912db7fef53$var$runDisposersOnWillUnmount() {
    var _this = this;
    [].concat(this[$13492912db7fef53$var$protoStoreKey] || [], this[$13492912db7fef53$var$instStoreKey] || []).forEach(function(propKeyOrFunction) {
        var prop = typeof propKeyOrFunction === "string" ? _this[propKeyOrFunction] : propKeyOrFunction;
        if (prop !== undefined && prop !== null) {
            if (Array.isArray(prop)) prop.map(function(f) {
                return f();
            });
            else prop();
        }
    });
}
function $13492912db7fef53$export$4e749cb731da87a9(target, propertyKeyOrFunction) {
    if (Array.isArray(propertyKeyOrFunction)) return propertyKeyOrFunction.map(function(fn) {
        return $13492912db7fef53$export$4e749cb731da87a9(target, fn);
    });
    var c = Object.getPrototypeOf(target).constructor;
    var c2 = Object.getPrototypeOf(target.constructor); // Special case for react-hot-loader
    var c3 = Object.getPrototypeOf(Object.getPrototypeOf(target));
    if (!(c === (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).Component || c === (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).PureComponent || c2 === (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).Component || c2 === (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).PureComponent || c3 === (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).Component || c3 === (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).PureComponent)) throw new Error("[mobx-react] disposeOnUnmount only supports direct subclasses of React.Component or React.PureComponent.");
    if (typeof propertyKeyOrFunction !== "string" && typeof propertyKeyOrFunction !== "function" && !Array.isArray(propertyKeyOrFunction)) throw new Error("[mobx-react] disposeOnUnmount only works if the parameter is either a property key or a function.");
     // decorator's target is the prototype, so it doesn't have any instance properties like props
    var isDecorator = typeof propertyKeyOrFunction === "string"; // add property key / function we want run (disposed) to the store
    var componentWasAlreadyModified = !!target[$13492912db7fef53$var$protoStoreKey] || !!target[$13492912db7fef53$var$instStoreKey];
    var store = isDecorator ? target[$13492912db7fef53$var$protoStoreKey] || (target[$13492912db7fef53$var$protoStoreKey] = []) : target[$13492912db7fef53$var$instStoreKey] || (target[$13492912db7fef53$var$instStoreKey] = []);
    store.push(propertyKeyOrFunction); // tweak the component class componentWillUnmount if not done already
    if (!componentWasAlreadyModified) $13492912db7fef53$var$patch(target, "componentWillUnmount", $13492912db7fef53$var$runDisposersOnWillUnmount);
     // return the disposer as is if invoked as a non decorator
    if (typeof propertyKeyOrFunction !== "string") return propertyKeyOrFunction;
}
function $13492912db7fef53$var$createChainableTypeChecker(validator) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        for(var _len = arguments.length, rest = new Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++)rest[_key - 6] = arguments[_key];
        return (0, $4JcCM.untracked)(function() {
            componentName = componentName || "<<anonymous>>";
            propFullName = propFullName || propName;
            if (props[propName] == null) {
                if (isRequired) {
                    var actual = props[propName] === null ? "null" : "undefined";
                    return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
                }
                return null;
            } else // @ts-ignore rest arg is necessary for some React internals - fails tests otherwise
            return validator.apply(void 0, [
                props,
                propName,
                componentName,
                location,
                propFullName
            ].concat(rest));
        });
    }
    var chainedCheckType = checkType.bind(null, false); // Add isRequired to satisfy Requirable
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
} // Copied from React.PropTypes
function $13492912db7fef53$var$isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === "symbol") return true;
     // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue["@@toStringTag"] === "Symbol") return true;
     // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === "function" && propValue instanceof Symbol) return true;
    return false;
} // Copied from React.PropTypes
function $13492912db7fef53$var$getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) return "array";
    if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
    // passes PropTypes.object.
    return "object";
    if ($13492912db7fef53$var$isSymbol(propType, propValue)) return "symbol";
    return propType;
} // This handles more types than `getPropType`. Only used for error messages.
// Copied from React.PropTypes
function $13492912db7fef53$var$getPreciseType(propValue) {
    var propType = $13492912db7fef53$var$getPropType(propValue);
    if (propType === "object") {
        if (propValue instanceof Date) return "date";
        else if (propValue instanceof RegExp) return "regexp";
    }
    return propType;
}
function $13492912db7fef53$var$createObservableTypeCheckerCreator(allowNativeType, mobxType) {
    return $13492912db7fef53$var$createChainableTypeChecker(function(props, propName, componentName, location, propFullName) {
        return (0, $4JcCM.untracked)(function() {
            if (allowNativeType) {
                if ($13492912db7fef53$var$getPropType(props[propName]) === mobxType.toLowerCase()) return null;
            }
            var mobxChecker;
            switch(mobxType){
                case "Array":
                    mobxChecker = (0, $4JcCM.isObservableArray);
                    break;
                case "Object":
                    mobxChecker = (0, $4JcCM.isObservableObject);
                    break;
                case "Map":
                    mobxChecker = (0, $4JcCM.isObservableMap);
                    break;
                default:
                    throw new Error("Unexpected mobxType: " + mobxType);
            }
            var propValue = props[propName];
            if (!mobxChecker(propValue)) {
                var preciseType = $13492912db7fef53$var$getPreciseType(propValue);
                var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
                return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
            }
            return null;
        });
    });
}
function $13492912db7fef53$var$createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
    return $13492912db7fef53$var$createChainableTypeChecker(function(props, propName, componentName, location, propFullName) {
        for(var _len2 = arguments.length, rest = new Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++)rest[_key2 - 5] = arguments[_key2];
        return (0, $4JcCM.untracked)(function() {
            if (typeof typeChecker !== "function") return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
            else {
                var error = $13492912db7fef53$var$createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName, location, propFullName);
                if (error instanceof Error) return error;
                var propValue = props[propName];
                for(var i = 0; i < propValue.length; i++){
                    error = typeChecker.apply(void 0, [
                        propValue,
                        i,
                        componentName,
                        location,
                        propFullName + "[" + i + "]"
                    ].concat(rest));
                    if (error instanceof Error) return error;
                }
                return null;
            }
        });
    });
}
var $13492912db7fef53$var$observableArray = /*#__PURE__*/ $13492912db7fef53$var$createObservableTypeCheckerCreator(false, "Array");
var $13492912db7fef53$var$observableArrayOf = /*#__PURE__*/ $13492912db7fef53$var$createObservableArrayOfTypeChecker.bind(null, false);
var $13492912db7fef53$var$observableMap = /*#__PURE__*/ $13492912db7fef53$var$createObservableTypeCheckerCreator(false, "Map");
var $13492912db7fef53$var$observableObject = /*#__PURE__*/ $13492912db7fef53$var$createObservableTypeCheckerCreator(false, "Object");
var $13492912db7fef53$var$arrayOrObservableArray = /*#__PURE__*/ $13492912db7fef53$var$createObservableTypeCheckerCreator(true, "Array");
var $13492912db7fef53$var$arrayOrObservableArrayOf = /*#__PURE__*/ $13492912db7fef53$var$createObservableArrayOfTypeChecker.bind(null, true);
var $13492912db7fef53$var$objectOrObservableObject = /*#__PURE__*/ $13492912db7fef53$var$createObservableTypeCheckerCreator(true, "Object");
var $13492912db7fef53$export$e0c95a451cd220b7 = {
    observableArray: $13492912db7fef53$var$observableArray,
    observableArrayOf: $13492912db7fef53$var$observableArrayOf,
    observableMap: $13492912db7fef53$var$observableMap,
    observableObject: $13492912db7fef53$var$observableObject,
    arrayOrObservableArray: $13492912db7fef53$var$arrayOrObservableArray,
    arrayOrObservableArrayOf: $13492912db7fef53$var$arrayOrObservableArrayOf,
    objectOrObservableObject: $13492912db7fef53$var$objectOrObservableObject
};
if (!(0, $jbmdS.Component)) throw new Error("mobx-react requires React to be available");
if (!(0, $4JcCM.observable)) throw new Error("mobx-react requires mobx to be available");

});
parcelRegister("4JcCM", function(module, exports) {

$parcel$export(module.exports, "$mobx", function () { return $mobx; });
$parcel$export(module.exports, "createAtom", function () { return createAtom; });
$parcel$export(module.exports, "onBecomeUnobserved", function () { return onBecomeUnobserved; });
$parcel$export(module.exports, "observable", function () { return observable; });
$parcel$export(module.exports, "isAction", function () { return isAction; });
$parcel$export(module.exports, "isObservableObject", function () { return isObservableObject; });
$parcel$export(module.exports, "isObservableArray", function () { return isObservableArray; });
$parcel$export(module.exports, "isObservableMap", function () { return isObservableMap; });
$parcel$export(module.exports, "computed", function () { return computed; });
$parcel$export(module.exports, "ObservableMap", function () { return ObservableMap; });
$parcel$export(module.exports, "extendObservable", function () { return extendObservable; });
$parcel$export(module.exports, "_allowStateReadsStart", function () { return allowStateReadsStart; });
$parcel$export(module.exports, "_allowStateReadsEnd", function () { return allowStateReadsEnd; });
$parcel$export(module.exports, "_allowStateChanges", function () { return allowStateChanges; });
$parcel$export(module.exports, "autorun", function () { return autorun; });
$parcel$export(module.exports, "_isComputingDerivation", function () { return isComputingDerivation; });
$parcel$export(module.exports, "untracked", function () { return untracked; });
$parcel$export(module.exports, "_getGlobalState", function () { return getGlobalState; });
$parcel$export(module.exports, "getDependencyTree", function () { return getDependencyTree; });
$parcel$export(module.exports, "Reaction", function () { return Reaction; });
$parcel$export(module.exports, "action", function () { return action; });
$parcel$export(module.exports, "reaction", function () { return reaction; });
$parcel$export(module.exports, "getAtom", function () { return getAtom; });
$parcel$export(module.exports, "configure", function () { return configure; });
$parcel$export(module.exports, "_getAdministration", function () { return getAdministration; });
$parcel$export(module.exports, "isComputed", function () { return isComputed; });
$parcel$export(module.exports, "isComputedProp", function () { return isComputedProp; });
$parcel$export(module.exports, "keys", function () { return keys; });
$parcel$export(module.exports, "values", function () { return values; });
$parcel$export(module.exports, "entries", function () { return entries; });
$parcel$export(module.exports, "observe", function () { return observe; });
$parcel$export(module.exports, "toJS", function () { return toJS; });
$parcel$export(module.exports, "transaction", function () { return transaction; });
$parcel$export(module.exports, "makeObservable", function () { return makeObservable; });
$parcel$export(module.exports, "runInAction", function () { return runInAction; });
var niceErrors = {
    0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
    1: function _(annotationType, key) {
        return "Cannot apply '" + annotationType + "' to '" + key.toString() + "': Field not found.";
    },
    /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */ 5: "'keys()' can only be used on observable objects, arrays, sets and maps",
    6: "'values()' can only be used on observable objects, arrays, sets and maps",
    7: "'entries()' can only be used on observable objects, arrays and maps",
    8: "'set()' can only be used on observable objects, arrays and maps",
    9: "'remove()' can only be used on observable objects, arrays and maps",
    10: "'has()' can only be used on observable objects, arrays and maps",
    11: "'get()' can only be used on observable objects, arrays and maps",
    12: "Invalid annotation",
    13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    14: "Intercept handlers should return nothing or a change object",
    15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    16: "Modification exception: the internal structure of an observable array was changed.",
    17: function _(index, length) {
        return "[mobx.array] Index out of bounds, " + index + " is larger than " + length;
    },
    18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
    19: function _(other) {
        return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
    },
    20: function _(other) {
        return "Cannot initialize map from " + other;
    },
    21: function _(dataStructure) {
        return "Cannot convert to map from '" + dataStructure + "'";
    },
    22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
    23: "It is not possible to get index atoms from arrays",
    24: function _(thing) {
        return "Cannot obtain administration from " + thing;
    },
    25: function _(property, name) {
        return "the entry '" + property + "' does not exist in the observable map '" + name + "'";
    },
    26: "please specify a property",
    27: function _(property, name) {
        return "no observable property '" + property.toString() + "' found on the observable object '" + name + "'";
    },
    28: function _(thing) {
        return "Cannot obtain atom from " + thing;
    },
    29: "Expecting some object",
    30: "invalid action stack. did you forget to finish an action?",
    31: "missing option for computed: get",
    32: function _(name, derivation) {
        return "Cycle detected in computation " + name + ": " + derivation;
    },
    33: function _(name) {
        return "The setter of computed value '" + name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
    },
    34: function _(name) {
        return "[ComputedValue '" + name + "'] It is not possible to assign a new value to a computed value.";
    },
    35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
    36: "isolateGlobalState should be called before MobX is running any reactions",
    37: function _(method) {
        return "[mobx] `observableArray." + method + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + method + "()` instead";
    },
    38: "'ownKeys()' can only be used on observable objects",
    39: "'defineProperty()' can only be used on observable objects"
};
var errors = {};
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var e;
    throw new Error(typeof error === "number" ? "[MobX] minified error nr: " + error + (args.length ? " " + args.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + error);
}
var mockGlobal = {};
function getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (typeof self !== "undefined") return self;
    return mockGlobal;
}
// We shorten anything used > 5 times
var assign = Object.assign;
var getDescriptor = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var objectPrototype = Object.prototype;
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var hasProxy = typeof Proxy !== "undefined";
var plainObjectString = /*#__PURE__*/ Object.toString();
function assertProxies() {
    if (!hasProxy) die("Proxy not available");
}
function warnAboutProxyRequirement(msg) {}
function getNextId() {
    return ++globalState.mobxGuid;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */ function once(func) {
    var invoked = false;
    return function() {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function noop() {};
function isFunction(fn) {
    return typeof fn === "function";
}
function isStringish(value) {
    var t = typeof value;
    switch(t){
        case "string":
        case "symbol":
        case "number":
            return true;
    }
    return false;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (!isObject(value)) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto == null) return true;
    var protoConstructor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof protoConstructor === "function" && protoConstructor.toString() === plainObjectString;
}
// https://stackoverflow.com/a/37865170
function isGenerator(obj) {
    var constructor = obj == null ? void 0 : obj.constructor;
    if (!constructor) return false;
    if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) return true;
    return false;
}
function addHiddenProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function createInstanceofPredicate(name, theClass) {
    var propName = "isMobX" + name;
    theClass.prototype[propName] = true;
    return function(x) {
        return isObject(x) && x[propName] === true;
    };
}
/**
 * Yields true for both native and observable Map, even across different windows.
 */ function isES6Map(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Map]";
}
/**
 * Makes sure a Map is an instance of non-inherited native or observable Map.
 */ function isPlainES6Map(thing) {
    var mapProto = Object.getPrototypeOf(thing);
    var objectProto = Object.getPrototypeOf(mapProto);
    var nullProto = Object.getPrototypeOf(objectProto);
    return nullProto === null;
}
/**
 * Yields true for both native and observable Set, even across different windows.
 */ function isES6Set(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Set]";
}
var hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols !== "undefined";
/**
 * Returns the following: own enumerable keys and symbols.
 */ function getPlainObjectKeys(object) {
    var keys = Object.keys(object);
    // Not supported in IE, so there are not going to be symbol props anyway...
    if (!hasGetOwnPropertySymbols) return keys;
    var symbols = Object.getOwnPropertySymbols(object);
    if (!symbols.length) return keys;
    return [].concat(keys, symbols.filter(function(s) {
        return objectPrototype.propertyIsEnumerable.call(object, s);
    }));
}
// From Immer utils
// Returns all own keys, including non-enumerable and symbolic
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : hasGetOwnPropertySymbols ? function(obj) {
    return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : /* istanbul ignore next */ Object.getOwnPropertyNames;
function stringifyKey(key) {
    if (typeof key === "string") return key;
    if (typeof key === "symbol") return key.toString();
    return new String(key).toString();
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
function hasProp(target, prop) {
    return objectPrototype.hasOwnProperty.call(target, prop);
}
// From Immer utils
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(target) {
    // Polyfill needed for Hermes and IE, see https://github.com/facebook/hermes/issues/274
    var res = {};
    // Note: without polyfill for ownKeys, symbols won't be picked up
    ownKeys(target).forEach(function(key) {
        res[key] = getDescriptor(target, key);
    });
    return res;
};
function getFlag(flags, mask) {
    return !!(flags & mask);
}
function setFlag(flags, mask, newValue) {
    if (newValue) flags |= mask;
    else flags &= ~mask;
    return flags;
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function _createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
var storedAnnotationsSymbol = /*#__PURE__*/ Symbol("mobx-stored-annotations");
/**
 * Creates a function that acts as
 * - decorator
 * - annotation object
 */ function createDecoratorAnnotation(annotation) {
    function decorator(target, property) {
        if (is20223Decorator(property)) return annotation.decorate_20223_(target, property);
        else storeAnnotation(target, property, annotation);
    }
    return Object.assign(decorator, annotation);
}
/**
 * Stores annotation to prototype,
 * so it can be inspected later by `makeObservable` called from constructor
 */ function storeAnnotation(prototype, key, annotation) {
    if (!hasProp(prototype, storedAnnotationsSymbol)) addHiddenProp(prototype, storedAnnotationsSymbol, _extends({}, prototype[storedAnnotationsSymbol]));
    var fieldName;
    // Cannot re-decorate
    assertNotDecorated(prototype, annotation, key);
    // Ignore override
    if (!isOverride(annotation)) prototype[storedAnnotationsSymbol][key] = annotation;
}
function assertNotDecorated(prototype, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
/**
 * Collects annotations from prototypes and stores them on target (instance)
 */ function collectStoredAnnotations(target) {
    if (!hasProp(target, storedAnnotationsSymbol)) // if (__DEV__ && !target[storedAnnotationsSymbol]) {
    //     die(
    //         `No annotations were passed to makeObservable, but no decorated members have been found either`
    //     )
    // }
    // We need a copy as we will remove annotation from the list once it's applied.
    addHiddenProp(target, storedAnnotationsSymbol, _extends({}, target[storedAnnotationsSymbol]));
    return target[storedAnnotationsSymbol];
}
function is20223Decorator(context) {
    return typeof context == "object" && typeof context["kind"] == "string";
}
function assert20223DecoratorType(context, types) {}
var $mobx = /*#__PURE__*/ Symbol("mobx administration");
var Atom = /*#__PURE__*/ function() {
    /**
   * Create a new atom. For debugging purposes it is recommended to give it a name.
   * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
   */ function Atom(name_) {
        if (name_ === void 0) name_ = "Atom";
        this.name_ = void 0;
        this.flags_ = 0;
        this.observers_ = new Set();
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.NOT_TRACKING_;
        // onBecomeObservedListeners
        this.onBOL = void 0;
        // onBecomeUnobservedListeners
        this.onBUOL = void 0;
        this.name_ = name_;
    }
    // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
    var _proto = Atom.prototype;
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    } /**
   * Invoke this method to notify mobx that your atom has been used somehow.
   * Returns true if there is currently a reactive context.
   */ ;
    _proto.reportObserved = function reportObserved$1() {
        return reportObserved(this);
    } /**
   * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
   */ ;
    _proto.reportChanged = function reportChanged() {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    _proto.toString = function toString() {
        return this.name_;
    };
    return _createClass(Atom, [
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, Atom.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, Atom.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Atom.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Atom.isBeingObservedMask_ = 1;
Atom.isPendingUnobservationMask_ = 2;
Atom.diffValueMask_ = 4;
var isAtom = /*#__PURE__*/ createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) onBecomeObservedHandler = noop;
    if (onBecomeUnobservedHandler === void 0) onBecomeUnobservedHandler = noop;
    var atom = new Atom(name);
    // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== noop) onBecomeObserved(atom, onBecomeObservedHandler);
    if (onBecomeUnobservedHandler !== noop) onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    return atom;
}
function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    if (Object.is) return Object.is(a, b);
    return a === b ? a !== 0 || 1 / a === 1 / b : a !== a && b !== b;
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    "default": defaultComparer,
    shallow: shallowComparer
};
function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v)) return v;
    // something that can be converted and mutated?
    if (Array.isArray(v)) return observable.array(v, {
        name: name
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name
    });
    if (typeof v === "function" && !isAction(v) && !isFlow(v)) {
        if (isGenerator(v)) return flow(v);
        else return autoAction(name, v);
    }
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) return v;
    if (Array.isArray(v)) return observable.array(v, {
        name: name,
        deep: false
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name,
        deep: false
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name,
        deep: false
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name,
        deep: false
    });
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue) {
    if (deepEqual(v, oldValue)) return oldValue;
    return v;
}
var OVERRIDE = "override";
var override = /*#__PURE__*/ createDecoratorAnnotation({
    annotationType_: OVERRIDE,
    make_: make_,
    extend_: extend_,
    decorate_20223_: decorate_20223_
});
function isOverride(annotation) {
    return annotation.annotationType_ === OVERRIDE;
}
function make_(adm, key) {
    return 0 /* MakeResult.Cancel */ ;
}
function extend_(adm, key, descriptor, proxyTrap) {
    die("'" + this.annotationType_ + "' can only be used with 'makeObservable'");
}
function decorate_20223_(desc, context) {
    console.warn("'" + this.annotationType_ + "' cannot be used with decorators - this is a no-op");
}
function createActionAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$1,
        extend_: extend_$1,
        decorate_20223_: decorate_20223_$1
    };
}
function make_$1(adm, key, descriptor, source) {
    var _this$options_;
    // bound
    if ((_this$options_ = this.options_) != null && _this$options_.bound) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    if (isAction(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor, false);
    defineProperty(source, key, actionDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$1(adm, key, descriptor, proxyTrap) {
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor);
    return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function decorate_20223_$1(mthd, context) {
    var kind = context.kind, name = context.name, addInitializer = context.addInitializer;
    var ann = this;
    var _createAction = function _createAction(m) {
        var _ann$options_$name, _ann$options_, _ann$options_$autoAct, _ann$options_2;
        return createAction((_ann$options_$name = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.name) != null ? _ann$options_$name : name.toString(), m, (_ann$options_$autoAct = (_ann$options_2 = ann.options_) == null ? void 0 : _ann$options_2.autoAction) != null ? _ann$options_$autoAct : false);
    };
    if (kind == "field") return function(initMthd) {
        var _ann$options_3;
        var mthd = initMthd;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_ann$options_3 = ann.options_) != null && _ann$options_3.bound) {
            mthd = mthd.bind(this);
            mthd.isMobxAction = true;
        }
        return mthd;
    };
    if (kind == "method") {
        var _this$options_2;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_this$options_2 = this.options_) != null && _this$options_2.bound) addInitializer(function() {
            var self1 = this;
            var bound = self1[name].bind(self1);
            bound.isMobxAction = true;
            self1[name] = bound;
        });
        return mthd;
    }
    die("Cannot apply '" + ann.annotationType_ + "' to '" + String(name) + "' (kind: " + kind + "):" + ("\n'" + ann.annotationType_ + "' can only be used on properties with a function value."));
}
function assertActionDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createActionDescriptor(adm, annotation, key, descriptor, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3, _annotation$options_4, _adm$proxy_2;
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertActionDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) {
        var _adm$proxy_;
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return {
        value: createAction((_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(), value, (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false, // https://github.com/mobxjs/mobx/discussions/3140
        (_annotation$options_4 = annotation.options_) != null && _annotation$options_4.bound ? (_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_ : undefined),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createFlowAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$2,
        extend_: extend_$2,
        decorate_20223_: decorate_20223_$2
    };
}
function make_$2(adm, key, descriptor, source) {
    var _this$options_;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    // bound - must annotate protos to support super.flow()
    if ((_this$options_ = this.options_) != null && _this$options_.bound && (!hasProp(adm.target_, key) || !isFlow(adm.target_[key]))) {
        if (this.extend_(adm, key, descriptor, false) === null) return 0 /* MakeResult.Cancel */ ;
    }
    if (isFlow(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, false, false);
    defineProperty(source, key, flowDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$2(adm, key, descriptor, proxyTrap) {
    var _this$options_2;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.bound);
    return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function decorate_20223_$2(mthd, context) {
    var _this$options_3;
    var name = context.name, addInitializer = context.addInitializer;
    if (!isFlow(mthd)) mthd = flow(mthd);
    if ((_this$options_3 = this.options_) != null && _this$options_3.bound) addInitializer(function() {
        var self1 = this;
        var bound = self1[name].bind(self1);
        bound.isMobXFlow = true;
        self1[name] = bound;
    });
    return mthd;
}
function assertFlowDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createFlowDescriptor(adm, annotation, key, descriptor, bound, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertFlowDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    // In case of flow.bound, the descriptor can be from already annotated prototype
    if (!isFlow(value)) value = flow(value);
    if (bound) {
        var _adm$proxy_;
        // We do not keep original function around, so we bind the existing flow
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
        // This is normally set by `flow`, but `bind` returns new function...
        value.isMobXFlow = true;
    }
    return {
        value: value,
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createComputedAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$3,
        extend_: extend_$3,
        decorate_20223_: decorate_20223_$3
    };
}
function make_$3(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$3(adm, key, descriptor, proxyTrap) {
    assertComputedDescriptor(adm, this, key, descriptor);
    return adm.defineComputedProperty_(key, _extends({}, this.options_, {
        get: descriptor.get,
        set: descriptor.set
    }), proxyTrap);
}
function decorate_20223_$3(get, context) {
    var ann = this;
    var key = context.name, addInitializer = context.addInitializer;
    addInitializer(function() {
        var adm = asObservableObject(this)[$mobx];
        var options = _extends({}, ann.options_, {
            get: get,
            context: this
        });
        options.name || (options.name = "ObservableObject." + key.toString());
        adm.values_.set(key, new ComputedValue(options));
    });
    return function() {
        return this[$mobx].getObservablePropValue_(key);
    };
}
function assertComputedDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var get = _ref2.get;
}
function createObservableAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$4,
        extend_: extend_$4,
        decorate_20223_: decorate_20223_$4
    };
}
function make_$4(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$4(adm, key, descriptor, proxyTrap) {
    var _this$options_$enhanc, _this$options_;
    assertObservableDescriptor(adm, this, key, descriptor);
    return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer) != null ? _this$options_$enhanc : deepEnhancer, proxyTrap);
}
function decorate_20223_$4(desc, context) {
    var ann = this;
    var kind = context.kind, name = context.name;
    // The laziness here is not ideal... It's a workaround to how 2022.3 Decorators are implemented:
    //   `addInitializer` callbacks are executed _before_ any accessors are defined (instead of the ideal-for-us right after each).
    //   This means that, if we were to do our stuff in an `addInitializer`, we'd attempt to read a private slot
    //   before it has been initialized. The runtime doesn't like that and throws a `Cannot read private member
    //   from an object whose class did not declare it` error.
    // TODO: it seems that this will not be required anymore in the final version of the spec
    // See TODO: link
    var initializedObjects = new WeakSet();
    function initializeObservable(target, value) {
        var _ann$options_$enhance, _ann$options_;
        var adm = asObservableObject(target)[$mobx];
        var observable = new ObservableValue(value, (_ann$options_$enhance = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.enhancer) != null ? _ann$options_$enhance : deepEnhancer, "ObservableObject." + name.toString(), false);
        adm.values_.set(name, observable);
        initializedObjects.add(target);
    }
    if (kind == "accessor") return {
        get: function get() {
            if (!initializedObjects.has(this)) initializeObservable(this, desc.get.call(this));
            return this[$mobx].getObservablePropValue_(name);
        },
        set: function set(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return this[$mobx].setObservablePropValue_(name, value);
        },
        init: function init(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return value;
        }
    };
    return;
}
function assertObservableDescriptor(adm, _ref, key, descriptor) {
    var annotationType_ = _ref.annotationType_;
}
var AUTO = "true";
var autoAnnotation = /*#__PURE__*/ createAutoAnnotation();
function createAutoAnnotation(options) {
    return {
        annotationType_: AUTO,
        options_: options,
        make_: make_$5,
        extend_: extend_$5,
        decorate_20223_: decorate_20223_$5
    };
}
function make_$5(adm, key, descriptor, source) {
    var _this$options_3, _this$options_4;
    // getter -> computed
    if (descriptor.get) return computed.make_(adm, key, descriptor, source);
    // lone setter -> action setter
    if (descriptor.set) {
        // TODO make action applicable to setter and delegate to action.make_
        var set = createAction(key.toString(), descriptor.set);
        // own
        if (source === adm.target_) return adm.defineProperty_(key, {
            configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
            set: set
        }) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
        // proto
        defineProperty(source, key, {
            configurable: true,
            set: set
        });
        return 2 /* MakeResult.Continue */ ;
    }
    // function on proto -> autoAction/flow
    if (source !== adm.target_ && typeof descriptor.value === "function") {
        var _this$options_2;
        if (isGenerator(descriptor.value)) {
            var _this$options_;
            var flowAnnotation = (_this$options_ = this.options_) != null && _this$options_.autoBind ? flow.bound : flow;
            return flowAnnotation.make_(adm, key, descriptor, source);
        }
        var actionAnnotation = (_this$options_2 = this.options_) != null && _this$options_2.autoBind ? autoAction.bound : autoAction;
        return actionAnnotation.make_(adm, key, descriptor, source);
    }
    // other -> observable
    // Copy props from proto as well, see test:
    // "decorate should work with Object.create"
    var observableAnnotation = ((_this$options_3 = this.options_) == null ? void 0 : _this$options_3.deep) === false ? observable.ref : observable;
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_4 = this.options_) != null && _this$options_4.autoBind) {
        var _adm$proxy_;
        descriptor.value = descriptor.value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return observableAnnotation.make_(adm, key, descriptor, source);
}
function extend_$5(adm, key, descriptor, proxyTrap) {
    var _this$options_5, _this$options_6;
    // getter -> computed
    if (descriptor.get) return computed.extend_(adm, key, descriptor, proxyTrap);
    // lone setter -> action setter
    if (descriptor.set) // TODO make action applicable to setter and delegate to action.extend_
    return adm.defineProperty_(key, {
        configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
        set: createAction(key.toString(), descriptor.set)
    }, proxyTrap);
    // other -> observable
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_5 = this.options_) != null && _this$options_5.autoBind) {
        var _adm$proxy_2;
        descriptor.value = descriptor.value.bind((_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_);
    }
    var observableAnnotation = ((_this$options_6 = this.options_) == null ? void 0 : _this$options_6.deep) === false ? observable.ref : observable;
    return observableAnnotation.extend_(adm, key, descriptor, proxyTrap);
}
function decorate_20223_$5(desc, context) {
    die("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var OBSERVABLE = "observable";
var OBSERVABLE_REF = "observable.ref";
var OBSERVABLE_SHALLOW = "observable.shallow";
var OBSERVABLE_STRUCT = "observable.struct";
// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function asCreateObservableOptions(thing) {
    return thing || defaultCreateObservableOptions;
}
var observableAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE);
var observableRefAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_REF, {
    enhancer: referenceEnhancer
});
var observableShallowAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_SHALLOW, {
    enhancer: shallowEnhancer
});
var observableStructAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_STRUCT, {
    enhancer: refStructEnhancer
});
var observableDecoratorAnnotation = /*#__PURE__*/ createDecoratorAnnotation(observableAnnotation);
function getEnhancerFromOptions(options) {
    return options.deep === true ? deepEnhancer : options.deep === false ? referenceEnhancer : getEnhancerFromAnnotation(options.defaultDecorator);
}
function getAnnotationFromOptions(options) {
    var _options$defaultDecor;
    return options ? (_options$defaultDecor = options.defaultDecorator) != null ? _options$defaultDecor : createAutoAnnotation(options) : undefined;
}
function getEnhancerFromAnnotation(annotation) {
    var _annotation$options_$, _annotation$options_;
    return !annotation ? deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer) != null ? _annotation$options_$ : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */ function createObservable(v, arg2, arg3) {
    // @observable someProp; (2022.3 Decorators)
    if (is20223Decorator(arg2)) return observableAnnotation.decorate_20223_(v, arg2);
    // @observable someProp;
    if (isStringish(arg2)) {
        storeAnnotation(v, arg2, observableAnnotation);
        return;
    }
    // already observable - ignore
    if (isObservable(v)) return v;
    // plain object
    if (isPlainObject(v)) return observable.object(v, arg2, arg3);
    // Array
    if (Array.isArray(v)) return observable.array(v, arg2);
    // Map
    if (isES6Map(v)) return observable.map(v, arg2);
    // Set
    if (isES6Set(v)) return observable.set(v, arg2);
    // other object - ignore
    if (typeof v === "object" && v !== null) return v;
    // anything else
    return observable.box(v, arg2);
}
assign(createObservable, observableDecoratorAnnotation);
var observableFactories = {
    box: function box(value, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array: function array(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return (globalState.useProxies === false || o.proxy === false ? createLegacyArray : createObservableArray)(initialValues, getEnhancerFromOptions(o), o.name);
    },
    map: function map(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    set: function set(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function object(props, decorators, options) {
        return initObservable(function() {
            return extendObservable(globalState.useProxies === false || (options == null ? void 0 : options.proxy) === false ? asObservableObject({}, options) : asDynamicObservableObject({}, options), props, decorators);
        });
    },
    ref: /*#__PURE__*/ createDecoratorAnnotation(observableRefAnnotation),
    shallow: /*#__PURE__*/ createDecoratorAnnotation(observableShallowAnnotation),
    deep: observableDecoratorAnnotation,
    struct: /*#__PURE__*/ createDecoratorAnnotation(observableStructAnnotation)
};
// eslint-disable-next-line
var observable = /*#__PURE__*/ assign(createObservable, observableFactories);
var COMPUTED = "computed";
var COMPUTED_STRUCT = "computed.struct";
var computedAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED);
var computedStructAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED_STRUCT, {
    equals: comparer.structural
});
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */ var computed = function computed(arg1, arg2) {
    if (is20223Decorator(arg2)) // @computed (2022.3 Decorators)
    return computedAnnotation.decorate_20223_(arg1, arg2);
    if (isStringish(arg2)) // @computed
    return storeAnnotation(arg1, arg2, computedAnnotation);
    if (isPlainObject(arg1)) // @computed({ options })
    return createDecoratorAnnotation(createComputedAnnotation(COMPUTED, arg1));
    var opts = isPlainObject(arg2) ? arg2 : {};
    opts.get = arg1;
    opts.name || (opts.name = arg1.name || ""); /* for generated name */ 
    return new ComputedValue(opts);
};
Object.assign(computed, computedAnnotation);
computed.struct = /*#__PURE__*/ createDecoratorAnnotation(computedStructAnnotation);
var _getDescriptor$config, _getDescriptor;
// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var isFunctionNameConfigurable = (_getDescriptor$config = (_getDescriptor = /*#__PURE__*/ getDescriptor(function() {}, "name")) == null ? void 0 : _getDescriptor.configurable) != null ? _getDescriptor$config : false;
// we can safely recycle this object
var tmpNameDescriptor = {
    value: "action",
    configurable: true,
    writable: false,
    enumerable: false
};
function createAction(actionName, fn, autoAction, ref) {
    if (autoAction === void 0) autoAction = false;
    function res() {
        return executeAction(actionName, autoAction, fn, ref || this, arguments);
    }
    res.isMobxAction = true;
    res.toString = function() {
        return fn.toString();
    };
    if (isFunctionNameConfigurable) {
        tmpNameDescriptor.value = actionName;
        defineProperty(res, "name", tmpNameDescriptor);
    }
    return res;
}
function executeAction(actionName, canRunAsDerivation, fn, scope, args) {
    var runInfo = _startAction(actionName, canRunAsDerivation, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error_ = err;
        throw err;
    } finally{
        _endAction(runInfo);
    }
}
function _startAction(actionName, canRunAsDerivation, // true for autoAction
scope, args) {
    var notifySpy_ = false;
    var startTime_ = 0;
    var flattenedArgs;
    var prevDerivation_ = globalState.trackingDerivation;
    var runAsAction = !canRunAsDerivation || !prevDerivation_;
    startBatch();
    var prevAllowStateChanges_ = globalState.allowStateChanges; // by default preserve previous allow
    if (runAsAction) {
        untrackedStart();
        prevAllowStateChanges_ = allowStateChangesStart(true);
    }
    var prevAllowStateReads_ = allowStateReadsStart(true);
    var runInfo = {
        runAsAction_: runAsAction,
        prevDerivation_: prevDerivation_,
        prevAllowStateChanges_: prevAllowStateChanges_,
        prevAllowStateReads_: prevAllowStateReads_,
        notifySpy_: notifySpy_,
        startTime_: startTime_,
        actionId_: nextActionId++,
        parentActionId_: currentActionId
    };
    currentActionId = runInfo.actionId_;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId_) die(30);
    currentActionId = runInfo.parentActionId_;
    if (runInfo.error_ !== undefined) globalState.suppressReactionErrors = true;
    allowStateChangesEnd(runInfo.prevAllowStateChanges_);
    allowStateReadsEnd(runInfo.prevAllowStateReads_);
    endBatch();
    if (runInfo.runAsAction_) untrackedEnd(runInfo.prevDerivation_);
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    try {
        return func();
    } finally{
        allowStateChangesEnd(prev);
    }
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
var CREATE = "create";
var ObservableValue = /*#__PURE__*/ function(_Atom) {
    function ObservableValue(value, enhancer, name_, notifySpy, equals) {
        var _this;
        if (name_ === void 0) name_ = "ObservableValue";
        if (notifySpy === void 0) notifySpy = true;
        if (equals === void 0) equals = comparer["default"];
        _this = _Atom.call(this, name_) || this;
        _this.enhancer = void 0;
        _this.name_ = void 0;
        _this.equals = void 0;
        _this.hasUnreportedChange_ = false;
        _this.interceptors_ = void 0;
        _this.changeListeners_ = void 0;
        _this.value_ = void 0;
        _this.dehancer = void 0;
        _this.enhancer = enhancer;
        _this.name_ = name_;
        _this.equals = equals;
        _this.value_ = enhancer(value, undefined, name_);
        return _this;
    }
    _inheritsLoose(ObservableValue, _Atom);
    var _proto = ObservableValue.prototype;
    _proto.dehanceValue = function dehanceValue(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.set = function set(newValue) {
        var oldValue = this.value_;
        newValue = this.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            this.setNewValue_(newValue);
        }
    };
    _proto.prepareNewValue_ = function prepareNewValue_(newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: UPDATE,
                newValue: newValue
            });
            if (!change) return globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value_, this.name_);
        return this.equals(this.value_, newValue) ? globalState.UNCHANGED : newValue;
    };
    _proto.setNewValue_ = function setNewValue_(newValue) {
        var oldValue = this.value_;
        this.value_ = newValue;
        this.reportChanged();
        if (hasListeners(this)) notifyListeners(this, {
            type: UPDATE,
            object: this,
            newValue: newValue,
            oldValue: oldValue
        });
    };
    _proto.get = function get() {
        this.reportObserved();
        return this.dehanceValue(this.value_);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately) listener({
            observableKind: "value",
            debugObjectName: this.name_,
            object: this,
            type: UPDATE,
            newValue: this.value_,
            oldValue: undefined
        });
        return registerListener(this, listener);
    };
    _proto.raw = function raw() {
        // used by MST ot get undehanced value
        return this.value_;
    };
    _proto.toJSON = function toJSON() {
        return this.get();
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.value_ + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return ObservableValue;
}(Atom);
var isObservableValue = /*#__PURE__*/ createInstanceofPredicate("ObservableValue", ObservableValue);
/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */ var ComputedValue = /*#__PURE__*/ function() {
    /**
   * Create a new computed value based on a function expression.
   *
   * The `name` property is for debug purposes only.
   *
   * The `equals` property specifies the comparer function to use to determine if a newly produced
   * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
   * compares based on identity comparison (===), and `structuralComparer` deeply compares the structure.
   * Structural comparison can be convenient if you always produce a new aggregated object and
   * don't want to notify observers if it is structurally the same.
   * This is useful for working with vectors, mouse coordinates etc.
   */ function ComputedValue(options) {
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = null;
        // during tracking it's an array with new observed observers
        this.observers_ = new Set();
        this.runId_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
        this.unboundDepsCount_ = 0;
        this.value_ = new CaughtException(null);
        this.name_ = void 0;
        this.triggeredBy_ = void 0;
        this.flags_ = 0;
        this.derivation = void 0;
        // N.B: unminified as it is used by MST
        this.setter_ = void 0;
        this.isTracing_ = TraceMode.NONE;
        this.scope_ = void 0;
        this.equals_ = void 0;
        this.requiresReaction_ = void 0;
        this.keepAlive_ = void 0;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        if (!options.get) die(31);
        this.derivation = options.get;
        this.name_ = options.name || "ComputedValue";
        if (options.set) this.setter_ = createAction("ComputedValue-setter", options.set);
        this.equals_ = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer["default"]);
        this.scope_ = options.context;
        this.requiresReaction_ = options.requiresReaction;
        this.keepAlive_ = !!options.keepAlive;
    }
    var _proto = ComputedValue.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        propagateMaybeChanged(this);
    };
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    /**
   * Returns the current value of this computed value.
   * Will evaluate its computation first if needed.
   */ _proto.get = function get() {
        if (this.isComputing) die(32, this.name_, this.derivation);
        if (globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
        this.observers_.size === 0 && !this.keepAlive_) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead_();
                startBatch(); // See perf test 'computed memoization'
                this.value_ = this.computeValue_(false);
                endBatch();
            }
        } else {
            reportObserved(this);
            if (shouldCompute(this)) {
                var prevTrackingContext = globalState.trackingContext;
                if (this.keepAlive_ && !prevTrackingContext) globalState.trackingContext = this;
                if (this.trackAndCompute()) propagateChangeConfirmed(this);
                globalState.trackingContext = prevTrackingContext;
            }
        }
        var result = this.value_;
        if (isCaughtException(result)) throw result.cause;
        return result;
    };
    _proto.set = function set(value) {
        if (this.setter_) {
            if (this.isRunningSetter) die(33, this.name_);
            this.isRunningSetter = true;
            try {
                this.setter_.call(this.scope_, value);
            } finally{
                this.isRunningSetter = false;
            }
        } else die(34, this.name_);
    };
    _proto.trackAndCompute = function trackAndCompute() {
        // N.B: unminified as it is used by MST
        var oldValue = this.value_;
        var wasSuspended = /* see #1208 */ this.dependenciesState_ === IDerivationState_.NOT_TRACKING_;
        var newValue = this.computeValue_(true);
        var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals_(oldValue, newValue);
        if (changed) this.value_ = newValue;
        return changed;
    };
    _proto.computeValue_ = function computeValue_(track) {
        this.isComputing = true;
        // don't allow state changes during computation
        var prev = allowStateChangesStart(false);
        var res;
        if (track) res = trackDerivedFunction(this, this.derivation, this.scope_);
        else {
            if (globalState.disableErrorBoundaries === true) res = this.derivation.call(this.scope_);
            else try {
                res = this.derivation.call(this.scope_);
            } catch (e) {
                res = new CaughtException(e);
            }
        }
        allowStateChangesEnd(prev);
        this.isComputing = false;
        return res;
    };
    _proto.suspend_ = function suspend_() {
        if (!this.keepAlive_) {
            clearObserving(this);
            this.value_ = undefined; // don't hold on to computed value!
        }
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function() {
            // TODO: why is this in a different place than the spyReport() function? in all other observables it's called in the same place
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    observableKind: "computed",
                    debugObjectName: _this.name_,
                    type: UPDATE,
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    _proto.warnAboutUntrackedRead_ = function warnAboutUntrackedRead_() {
        return;
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.derivation.toString() + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return _createClass(ComputedValue, [
        {
            key: "isComputing",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isComputingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isComputingMask_, newValue);
            }
        },
        {
            key: "isRunningSetter",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isRunningSetterMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isRunningSetterMask_, newValue);
            }
        },
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
ComputedValue.isComputingMask_ = 1;
ComputedValue.isRunningSetterMask_ = 2;
ComputedValue.isBeingObservedMask_ = 4;
ComputedValue.isPendingUnobservationMask_ = 8;
ComputedValue.diffValueMask_ = 16;
var isComputedValue = /*#__PURE__*/ createInstanceofPredicate("ComputedValue", ComputedValue);
var IDerivationState_;
(function(IDerivationState_) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState_[IDerivationState_["NOT_TRACKING_"] = -1] = "NOT_TRACKING_";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState_[IDerivationState_["UP_TO_DATE_"] = 0] = "UP_TO_DATE_";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState_[IDerivationState_["POSSIBLY_STALE_"] = 1] = "POSSIBLY_STALE_";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState_[IDerivationState_["STALE_"] = 2] = "STALE_";
})(IDerivationState_ || (IDerivationState_ = {}));
var TraceMode;
(function(TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = function CaughtException(cause) {
    this.cause = void 0;
    this.cause = cause;
// Empty
};
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */ function shouldCompute(derivation) {
    switch(derivation.dependenciesState_){
        case IDerivationState_.UP_TO_DATE_:
            return false;
        case IDerivationState_.NOT_TRACKING_:
        case IDerivationState_.STALE_:
            return true;
        case IDerivationState_.POSSIBLY_STALE_:
            // state propagation can occur outside of action/reactive context #2195
            var prevAllowStateReads = allowStateReadsStart(true);
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing_, l = obs.length;
            for(var i = 0; i < l; i++){
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) obj.get();
                    else try {
                        obj.get();
                    } catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState_ === IDerivationState_.STALE_) {
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return false;
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers;
    return;
}
function checkIfStateReadsAreAllowed(observable) {}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */ function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true);
    changeDependenciesStateTo0(derivation);
    // Preallocate array; will be trimmed by bindDependencies.
    derivation.newObserving_ = new Array(// Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    derivation.runId_ === 0 ? 100 : derivation.observing_.length);
    derivation.unboundDepsCount_ = 0;
    derivation.runId_ = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    globalState.inBatch++;
    var result;
    if (globalState.disableErrorBoundaries === true) result = f.call(context);
    else try {
        result = f.call(context);
    } catch (e) {
        result = new CaughtException(e);
    }
    globalState.inBatch--;
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    warnAboutDerivationWithoutDependencies(derivation);
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    return;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */ function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing_;
    var observing = derivation.observing_ = derivation.newObserving_;
    var lowestNewObservingDerivationState = IDerivationState_.UP_TO_DATE_;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount_;
    for(var i = 0; i < l; i++){
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState_ > lowestNewObservingDerivationState) lowestNewObservingDerivationState = dep.dependenciesState_;
    }
    observing.length = i0;
    derivation.newObserving_ = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while(l--){
        var _dep = prevObserving[l];
        if (_dep.diffValue === 0) removeObserver(_dep, derivation);
        _dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while(i0--){
        var _dep2 = observing[i0];
        if (_dep2.diffValue === 1) {
            _dep2.diffValue = 0;
            addObserver(_dep2, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState_.UP_TO_DATE_) {
        derivation.dependenciesState_ = lowestNewObservingDerivationState;
        derivation.onBecomeStale_();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing_;
    derivation.observing_ = [];
    var i = obs.length;
    while(i--)removeObserver(obs[i], derivation);
    derivation.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
}
function untracked(action) {
    var prev = untrackedStart();
    try {
        return action();
    } finally{
        untrackedEnd(prev);
    }
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */ function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState_ === IDerivationState_.UP_TO_DATE_) return;
    derivation.dependenciesState_ = IDerivationState_.UP_TO_DATE_;
    var obs = derivation.observing_;
    var i = obs.length;
    while(i--)obs[i].lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
}
/**
 * These values will persist if global state is reset
 */ var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED",
    "useProxies"
];
var MobXGlobals = function MobXGlobals() {
    /**
   * MobXGlobals version.
   * MobX compatiblity with other versions loaded in memory as long as this version matches.
   * It indicates that the global state still stores similar information
   *
   * N.B: this version is unrelated to the package version of MobX, and is only the version of the
   * internal state storage of MobX, and can be the same across many different package versions
   */ this.version = 6;
    /**
   * globally unique token to signal unchanged
   */ this.UNCHANGED = {};
    /**
   * Currently running derivation
   */ this.trackingDerivation = null;
    /**
   * Currently running reaction. This determines if we currently have a reactive context.
   * (Tracking derivation is also set for temporal tracking of computed values inside actions,
   * but trackingReaction can only be set by a form of Reaction)
   */ this.trackingContext = null;
    /**
   * Each time a derivation is tracked, it is assigned a unique run-id
   */ this.runId = 0;
    /**
   * 'guid' for general purpose. Will be persisted amongst resets.
   */ this.mobxGuid = 0;
    /**
   * Are we in a batch block? (and how many of them)
   */ this.inBatch = 0;
    /**
   * Observables that don't have observers anymore, and are about to be
   * suspended, unless somebody else accesses it in the same batch
   *
   * @type {IObservable[]}
   */ this.pendingUnobservations = [];
    /**
   * List of scheduled, not yet executed, reactions.
   */ this.pendingReactions = [];
    /**
   * Are we currently processing reactions?
   */ this.isRunningReactions = false;
    /**
   * Is it allowed to change observables at this point?
   * In general, MobX doesn't allow that when running computations and React.render.
   * To ensure that those functions stay pure.
   */ this.allowStateChanges = false;
    /**
   * Is it allowed to read observables at this point?
   * Used to hold the state needed for `observableRequiresReaction`
   */ this.allowStateReads = true;
    /**
   * If strict mode is enabled, state changes are by default not allowed
   */ this.enforceActions = true;
    /**
   * Spy callbacks
   */ this.spyListeners = [];
    /**
   * Globally attached error handlers that react specifically to errors in reactions
   */ this.globalReactionErrorHandlers = [];
    /**
   * Warn if computed values are accessed outside a reactive context
   */ this.computedRequiresReaction = false;
    /**
   * (Experimental)
   * Warn if you try to create to derivation / reactive context without accessing any observable.
   */ this.reactionRequiresObservable = false;
    /**
   * (Experimental)
   * Warn if observables are accessed outside a reactive context
   */ this.observableRequiresReaction = false;
    /*
   * Don't catch and rethrow exceptions. This is useful for inspecting the state of
   * the stack when an exception occurs while debugging.
   */ this.disableErrorBoundaries = false;
    /*
   * If true, we are already handling an exception in an action. Any errors in reactions should be suppressed, as
   * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
   */ this.suppressReactionErrors = false;
    this.useProxies = true;
    /*
   * print warnings about code that would fail if proxies weren't available
   */ this.verifyProxies = false;
    /**
   * False forces all object's descriptors to
   * writable: true
   * configurable: true
   */ this.safeDescriptors = true;
};
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = /*#__PURE__*/ function() {
    var global1 = /*#__PURE__*/ getGlobal();
    if (global1.__mobxInstanceCount > 0 && !global1.__mobxGlobals) canMergeGlobalState = false;
    if (global1.__mobxGlobals && global1.__mobxGlobals.version !== new MobXGlobals().version) canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        // Because this is a IIFE we need to let isolateCalled a chance to change
        // so we run it after the event loop completed at least 1 iteration
        setTimeout(function() {
            if (!isolateCalled) die(35);
        }, 1);
        return new MobXGlobals();
    } else if (global1.__mobxGlobals) {
        global1.__mobxInstanceCount += 1;
        if (!global1.__mobxGlobals.UNCHANGED) global1.__mobxGlobals.UNCHANGED = {};
         // make merge backward compatible
        return global1.__mobxGlobals;
    } else {
        global1.__mobxInstanceCount = 1;
        return global1.__mobxGlobals = /*#__PURE__*/ new MobXGlobals();
    }
}();
function isolateGlobalState() {
    if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) die(36);
    isolateCalled = true;
    if (canMergeGlobalState) {
        var global1 = getGlobal();
        if (--global1.__mobxInstanceCount === 0) global1.__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */ function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for(var key in defaultGlobals)if (persistentKeys.indexOf(key) === -1) globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}
function hasObservers(observable) {
    return observable.observers_ && observable.observers_.size > 0;
}
function getObservers(observable) {
    return observable.observers_;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers_.add(node);
    if (observable.lowestObserverState_ > node.dependenciesState_) observable.lowestObserverState_ = node.dependenciesState_;
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers_["delete"](node);
    if (observable.observers_.size === 0) // deleting last observer
    queueForUnobservation(observable);
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */ function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for(var i = 0; i < list.length; i++){
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers_.size === 0) {
                if (observable.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved = false;
                    observable.onBUO();
                }
                if (observable instanceof ComputedValue) // computed values are automatically teared down when the last observer leaves
                // this process happens recursively, this computed might be the last observabe of another, etc..
                observable.suspend_();
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
     * Simple optimization, give each derivation run an unique id (runId)
     * Check if last time this observable was accessed the same runId is used
     * if this is the case, the relation is already known
     */ if (derivation.runId_ !== observable.lastAccessedBy_) {
            observable.lastAccessedBy_ = derivation.runId_;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving_[derivation.unboundDepsCount_++] = observable;
            if (!observable.isBeingObserved && globalState.trackingContext) {
                observable.isBeingObserved = true;
                observable.onBO();
            }
        }
        return observable.isBeingObserved;
    } else if (observable.observers_.size === 0 && globalState.inBatch > 0) queueForUnobservation(observable);
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */ // Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) d.onBecomeStale_();
        d.dependenciesState_ = IDerivationState_.STALE_;
    });
// invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.POSSIBLY_STALE_) d.dependenciesState_ = IDerivationState_.STALE_;
        else if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_ // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
    });
// invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState_ !== IDerivationState_.UP_TO_DATE_) return;
    observable.lowestObserverState_ = IDerivationState_.POSSIBLY_STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
            d.dependenciesState_ = IDerivationState_.POSSIBLY_STALE_;
            d.onBecomeStale_();
        }
    });
// invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name_ + "' is invalidated due to a change in: '" + observable.name_ + "'");
    if (derivation.isTracing_ === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name_ + "'\n\nYou are entering this break point because derivation '" + derivation.name_ + "' is being traced and '" + observable.name_ + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + "	".repeat(depth - 1) + tree.name);
    if (tree.dependencies) tree.dependencies.forEach(function(child) {
        return printDepTree(child, lines, depth + 1);
    });
}
var Reaction = /*#__PURE__*/ function() {
    function Reaction(name_, onInvalidate_, errorHandler_, requiresObservable_) {
        if (name_ === void 0) name_ = "Reaction";
        this.name_ = void 0;
        this.onInvalidate_ = void 0;
        this.errorHandler_ = void 0;
        this.requiresObservable_ = void 0;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = [];
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.runId_ = 0;
        this.unboundDepsCount_ = 0;
        this.flags_ = 0;
        this.isTracing_ = TraceMode.NONE;
        this.name_ = name_;
        this.onInvalidate_ = onInvalidate_;
        this.errorHandler_ = errorHandler_;
        this.requiresObservable_ = requiresObservable_;
    }
    var _proto = Reaction.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        this.schedule_();
    };
    _proto.schedule_ = function schedule_() {
        if (!this.isScheduled) {
            this.isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    } /**
   * internal, use schedule() if you intend to kick off a reaction
   */ ;
    _proto.runReaction_ = function runReaction_() {
        if (!this.isDisposed) {
            startBatch();
            this.isScheduled = false;
            var prev = globalState.trackingContext;
            globalState.trackingContext = this;
            if (shouldCompute(this)) {
                this.isTrackPending = true;
                try {
                    this.onInvalidate_();
                } catch (e) {
                    this.reportExceptionInDerivation_(e);
                }
            }
            globalState.trackingContext = prev;
            endBatch();
        }
    };
    _proto.track = function track(fn) {
        if (this.isDisposed) return;
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        this.isRunning = true;
        var prevReaction = globalState.trackingContext; // reactions could create reactions...
        globalState.trackingContext = this;
        var result = trackDerivedFunction(this, fn, undefined);
        globalState.trackingContext = prevReaction;
        this.isRunning = false;
        this.isTrackPending = false;
        if (this.isDisposed) // disposed during last run. Clean up everything that was bound after the dispose call.
        clearObserving(this);
        if (isCaughtException(result)) this.reportExceptionInDerivation_(result.cause);
        endBatch();
    };
    _proto.reportExceptionInDerivation_ = function reportExceptionInDerivation_(error) {
        var _this = this;
        if (this.errorHandler_) {
            this.errorHandler_(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries) throw error;
        var message = "[mobx] uncaught error in '" + this + "'";
        if (!globalState.suppressReactionErrors) console.error(message, error);
         // prettier-ignore
        globalState.globalReactionErrorHandlers.forEach(function(f) {
            return f(error, _this);
        });
    };
    _proto.dispose = function dispose() {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this.isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    _proto.getDisposer_ = function getDisposer_(abortSignal) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2.dispose();
            abortSignal == null || abortSignal.removeEventListener == null || abortSignal.removeEventListener("abort", dispose);
        };
        abortSignal == null || abortSignal.addEventListener == null || abortSignal.addEventListener("abort", dispose);
        dispose[$mobx] = this;
        return dispose;
    };
    _proto.toString = function toString() {
        return "Reaction[" + this.name_ + "]";
    };
    _proto.trace = function trace$1(enterBreakPoint) {
        if (enterBreakPoint === void 0) enterBreakPoint = false;
        trace(this, enterBreakPoint);
    };
    return _createClass(Reaction, [
        {
            key: "isDisposed",
            get: function get() {
                return getFlag(this.flags_, Reaction.isDisposedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isDisposedMask_, newValue);
            }
        },
        {
            key: "isScheduled",
            get: function get() {
                return getFlag(this.flags_, Reaction.isScheduledMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isScheduledMask_, newValue);
            }
        },
        {
            key: "isTrackPending",
            get: function get() {
                return getFlag(this.flags_, Reaction.isTrackPendingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isTrackPendingMask_, newValue);
            }
        },
        {
            key: "isRunning",
            get: function get() {
                return getFlag(this.flags_, Reaction.isRunningMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isRunningMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Reaction.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Reaction.isDisposedMask_ = 1;
Reaction.isScheduledMask_ = 2;
Reaction.isTrackPendingMask_ = 4;
Reaction.isRunningMask_ = 8;
Reaction.diffValueMask_ = 16;
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function() {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */ var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function reactionScheduler(f) {
    return f();
};
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions) return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while(allReactions.length > 0){
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("[mobx] cycle in reaction: " + allReactions[0]);
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for(var i = 0, l = remainingReactions.length; i < l; i++)remainingReactions[i].runReaction_();
    }
    globalState.isRunningReactions = false;
}
var isReaction = /*#__PURE__*/ createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function reactionScheduler(f) {
        return fn(function() {
            return baseScheduler(f);
        });
    };
}
function isSpyEnabled() {
    return false;
}
function spyReport(event) {
    var listeners, i, l;
    return;
}
function spyReportStart(event) {
    var change;
    return;
}
var END_EVENT = {
    type: "report-end",
    spyReportEnd: true
};
function spyReportEnd(change) {
    return;
}
function spy(listener) {
    console.warn("[mobx.spy] Is a no-op in production builds");
    return function() {};
}
var ACTION = "action";
var ACTION_BOUND = "action.bound";
var AUTOACTION = "autoAction";
var AUTOACTION_BOUND = "autoAction.bound";
var DEFAULT_ACTION_NAME = "<unnamed action>";
var actionAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION);
var actionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION_BOUND, {
    bound: true
});
var autoActionAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION, {
    autoAction: true
});
var autoActionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION_BOUND, {
    autoAction: true,
    bound: true
});
function createActionFactory(autoAction) {
    var res = function action(arg1, arg2) {
        // action(fn() {})
        if (isFunction(arg1)) return createAction(arg1.name || DEFAULT_ACTION_NAME, arg1, autoAction);
        // action("name", fn() {})
        if (isFunction(arg2)) return createAction(arg1, arg2, autoAction);
        // @action (2022.3 Decorators)
        if (is20223Decorator(arg2)) return (autoAction ? autoActionAnnotation : actionAnnotation).decorate_20223_(arg1, arg2);
        // @action
        if (isStringish(arg2)) return storeAnnotation(arg1, arg2, autoAction ? autoActionAnnotation : actionAnnotation);
        // action("name") & @action("name")
        if (isStringish(arg1)) return createDecoratorAnnotation(createActionAnnotation(autoAction ? AUTOACTION : ACTION, {
            name: arg1,
            autoAction: autoAction
        }));
    };
    return res;
}
var action = /*#__PURE__*/ createActionFactory(false);
Object.assign(action, actionAnnotation);
var autoAction = /*#__PURE__*/ createActionFactory(true);
Object.assign(autoAction, autoActionAnnotation);
action.bound = /*#__PURE__*/ createDecoratorAnnotation(actionBoundAnnotation);
autoAction.bound = /*#__PURE__*/ createDecoratorAnnotation(autoActionBoundAnnotation);
function runInAction(fn) {
    return executeAction(fn.name || DEFAULT_ACTION_NAME, false, fn, this, undefined);
}
function isAction(thing) {
    return isFunction(thing) && thing.isMobxAction === true;
}
/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */ function autorun(view, opts) {
    var _opts$name, _opts, _opts2, _opts3;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name = (_opts = opts) == null ? void 0 : _opts.name) != null ? _opts$name : "Autorun";
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) // normal autorun
    reaction = new Reaction(name, function() {
        this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
    else {
        var scheduler = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled = false;
        reaction = new Reaction(name, function() {
            if (!isScheduled) {
                isScheduled = true;
                scheduler(function() {
                    isScheduled = false;
                    if (!reaction.isDisposed) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    if (!((_opts2 = opts) != null && (_opts2 = _opts2.signal) != null && _opts2.aborted)) reaction.schedule_();
    return reaction.getDisposer_((_opts3 = opts) == null ? void 0 : _opts3.signal);
}
var run = function run(f) {
    return f();
};
function createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? function(f) {
        return setTimeout(f, opts.delay);
    } : run;
}
function reaction(expression, effect, opts) {
    var _opts$name2, _opts4, _opts5;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name2 = opts.name) != null ? _opts$name2 : "Reaction";
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer["default"];
    var r = new Reaction(name, function() {
        if (firstTime || runSync) reactionRunner();
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false;
        if (r.isDisposed) return;
        var changed = false;
        var oldValue = value;
        r.track(function() {
            var nextValue = allowStateChanges(false, function() {
                return expression(r);
            });
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, oldValue, r);
        else if (!firstTime && changed) effectAction(value, oldValue, r);
        firstTime = false;
    }
    if (!((_opts4 = opts) != null && (_opts4 = _opts4.signal) != null && _opts4.aborted)) r.schedule_();
    return r.getDisposer_((_opts5 = opts) == null ? void 0 : _opts5.signal);
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function() {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}
var ON_BECOME_OBSERVED = "onBO";
var ON_BECOME_UNOBSERVED = "onBUO";
function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = isFunction(arg3) ? arg3 : arg2;
    var listenersKey = hook + "L";
    if (atom[listenersKey]) atom[listenersKey].add(cb);
    else atom[listenersKey] = new Set([
        cb
    ]);
    return function() {
        var hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners["delete"](cb);
            if (hookListeners.size === 0) delete atom[listenersKey];
        }
    };
}
var NEVER = "never";
var ALWAYS = "always";
var OBSERVED = "observed";
// const IF_AVAILABLE = "ifavailable"
function configure(options) {
    if (options.isolateGlobalState === true) isolateGlobalState();
    var useProxies = options.useProxies, enforceActions = options.enforceActions;
    if (useProxies !== undefined) globalState.useProxies = useProxies === ALWAYS ? true : useProxies === NEVER ? false : typeof Proxy !== "undefined";
    if (useProxies === "ifavailable") globalState.verifyProxies = true;
    if (enforceActions !== undefined) {
        var ea = enforceActions === ALWAYS ? ALWAYS : enforceActions === OBSERVED;
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === ALWAYS ? false : true;
    }
    [
        "computedRequiresReaction",
        "reactionRequiresObservable",
        "observableRequiresReaction",
        "disableErrorBoundaries",
        "safeDescriptors"
    ].forEach(function(key) {
        if (key in options) globalState[key] = !!options[key];
    });
    globalState.allowStateReads = !globalState.observableRequiresReaction;
    if (options.reactionScheduler) setReactionScheduler(options.reactionScheduler);
}
function extendObservable(target, properties, annotations, options) {
    // Pull descriptors first, so we don't have to deal with props added by administration ($mobx)
    var descriptors = getOwnPropertyDescriptors(properties);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        ownKeys(descriptors).forEach(function(key) {
            adm.extend_(key, descriptors[key], // must pass "undefined" for { key: undefined }
            !annotations ? true : key in annotations ? annotations[key] : true);
        });
    });
    return target;
}
function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name_
    };
    if (node.observing_ && node.observing_.length > 0) result.dependencies = unique(node.observing_).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name_
    };
    if (hasObservers(node)) result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
    return result;
}
function unique(list) {
    return Array.from(new Set(list));
}
var generatorId = 0;
function FlowCancellationError() {
    this.message = "FLOW_CANCELLED";
}
FlowCancellationError.prototype = /*#__PURE__*/ Object.create(Error.prototype);
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
var flowAnnotation = /*#__PURE__*/ createFlowAnnotation("flow");
var flowBoundAnnotation = /*#__PURE__*/ createFlowAnnotation("flow.bound", {
    bound: true
});
var flow = /*#__PURE__*/ Object.assign(function flow(arg1, arg2) {
    // @flow (2022.3 Decorators)
    if (is20223Decorator(arg2)) return flowAnnotation.decorate_20223_(arg1, arg2);
    // @flow
    if (isStringish(arg2)) return storeAnnotation(arg1, arg2, flowAnnotation);
    var generator = arg1;
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    var res = function res() {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var promise = new Promise(function(resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen["throw"]).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (isFunction(ret == null ? void 0 : ret.then)) {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        promise.cancel = action(name + " - runid: " + runId + " - cancel", function() {
            try {
                if (pendingPromise) cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var _res = gen["return"](undefined);
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(_res.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
    res.isMobXFlow = true;
    return res;
}, flowAnnotation);
flow.bound = /*#__PURE__*/ createDecoratorAnnotation(flowBoundAnnotation);
function cancelPromise(promise) {
    if (isFunction(promise.cancel)) promise.cancel();
}
function flowResult(result) {
    return result; // just tricking TypeScript :)
}
function isFlow(fn) {
    return (fn == null ? void 0 : fn.isMobXFlow) === true;
}
function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) target = getAdministration(thing);
    else if (isObservableObject(thing)) target = getAdministration(thing, propOrHandler);
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function() {
        target.dehancer = undefined;
    };
}
function intercept(thing, propOrHandler, handler) {
    if (isFunction(handler)) return interceptProperty(thing, propOrHandler, handler);
    else return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept_(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept_(handler);
}
function _isComputed(value, property) {
    if (property === undefined) return isComputedValue(value);
    if (isObservableObject(value) === false) return false;
    if (!value[$mobx].values_.has(property)) return false;
    var atom = getAtom(value, property);
    return isComputedValue(atom);
}
function isComputed(value) {
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    return _isComputed(value, propName);
}
function _isObservable(value, property) {
    if (!value) return false;
    if (property !== undefined) {
        if (isObservableObject(value)) return value[$mobx].values_.has(property);
        return false;
    }
    // For first check, see #701
    return isObservableObject(value) || !!value[$mobx] || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    return _isObservable(value, propName);
}
function keys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].keys_();
    if (isObservableMap(obj) || isObservableSet(obj)) return Array.from(obj.keys());
    if (isObservableArray(obj)) return obj.map(function(_, index) {
        return index;
    });
    die(5);
}
function values(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return obj[key];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return obj.get(key);
    });
    if (isObservableSet(obj)) return Array.from(obj.values());
    if (isObservableArray(obj)) return obj.slice();
    die(6);
}
function entries(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj.get(key)
        ];
    });
    if (isObservableSet(obj)) return Array.from(obj.entries());
    if (isObservableArray(obj)) return obj.map(function(key, index) {
        return [
            index,
            key
        ];
    });
    die(7);
}
function set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var _values = key;
        try {
            for(var _key in _values)set(obj, _key, _values[_key]);
        } finally{
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) obj[$mobx].set_(key, value);
    else if (isObservableMap(obj)) obj.set(key, value);
    else if (isObservableSet(obj)) obj.add(key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        if (key < 0) die("Invalid index: '" + key + "'");
        startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        endBatch();
    } else die(8);
}
function remove(obj, key) {
    if (isObservableObject(obj)) obj[$mobx].delete_(key);
    else if (isObservableMap(obj)) obj["delete"](key);
    else if (isObservableSet(obj)) obj["delete"](key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        obj.splice(key, 1);
    } else die(9);
}
function has(obj, key) {
    if (isObservableObject(obj)) return obj[$mobx].has_(key);
    else if (isObservableMap(obj)) return obj.has(key);
    else if (isObservableSet(obj)) return obj.has(key);
    else if (isObservableArray(obj)) return key >= 0 && key < obj.length;
    die(10);
}
function get(obj, key) {
    if (!has(obj, key)) return undefined;
    if (isObservableObject(obj)) return obj[$mobx].get_(key);
    else if (isObservableMap(obj)) return obj.get(key);
    else if (isObservableArray(obj)) return obj[key];
    die(11);
}
function apiDefineProperty(obj, key, descriptor) {
    if (isObservableObject(obj)) return obj[$mobx].defineProperty_(key, descriptor);
    die(39);
}
function apiOwnKeys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].ownKeys_();
    die(38);
}
function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (isFunction(cbOrFire)) return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe_(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe_(listener, fireImmediately);
}
function cache(map, key, value) {
    map.set(key, value);
    return value;
}
function toJSHelper(source, __alreadySeen) {
    if (source == null || typeof source !== "object" || source instanceof Date || !isObservable(source)) return source;
    if (isObservableValue(source) || isComputedValue(source)) return toJSHelper(source.get(), __alreadySeen);
    if (__alreadySeen.has(source)) return __alreadySeen.get(source);
    if (isObservableArray(source)) {
        var res = cache(__alreadySeen, source, new Array(source.length));
        source.forEach(function(value, idx) {
            res[idx] = toJSHelper(value, __alreadySeen);
        });
        return res;
    }
    if (isObservableSet(source)) {
        var _res = cache(__alreadySeen, source, new Set());
        source.forEach(function(value) {
            _res.add(toJSHelper(value, __alreadySeen));
        });
        return _res;
    }
    if (isObservableMap(source)) {
        var _res2 = cache(__alreadySeen, source, new Map());
        source.forEach(function(value, key) {
            _res2.set(key, toJSHelper(value, __alreadySeen));
        });
        return _res2;
    } else {
        // must be observable object
        var _res3 = cache(__alreadySeen, source, {});
        apiOwnKeys(source).forEach(function(key) {
            if (objectPrototype.propertyIsEnumerable.call(source, key)) _res3[key] = toJSHelper(source[key], __alreadySeen);
        });
        return _res3;
    }
}
/**
 * Recursively converts an observable to it's non-observable native counterpart.
 * It does NOT recurse into non-observables, these are left as they are, even if they contain observables.
 * Computed and other non-enumerable properties are completely ignored.
 * Complex scenarios require custom solution, eg implementing `toJSON` or using `serializr` lib.
 */ function toJS(source, options) {
    return toJSHelper(source, new Map());
}
function trace() {
    var enterBreakPoint, _len, args, _key, derivation;
    return;
}
function getAtomFromArgs(args) {
    switch(args.length){
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}
/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */ function transaction(action, thisArg) {
    if (thisArg === void 0) thisArg = undefined;
    startBatch();
    try {
        return action.apply(thisArg);
    } finally{
        endBatch();
    }
}
function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && typeof arg1 === "object") return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        var error = new Error("WHEN_TIMEOUT");
        timeoutHandle = setTimeout(function() {
            if (!disposer[$mobx].isDisposed) {
                disposer();
                if (opts.onError) opts.onError(error);
                else throw error;
            }
        }, opts.timeout);
    }
    opts.name = "When";
    var effectAction = createAction("When-effect", effect);
    // eslint-disable-next-line
    var disposer = autorun(function(r) {
        // predicate should not change state
        var cond = allowStateChanges(false, predicate);
        if (cond) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    var _opts$signal;
    if (opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted) return Object.assign(Promise.reject(new Error("WHEN_ABORTED")), {
        cancel: function cancel() {
            return null;
        }
    });
    var cancel;
    var abort;
    var res = new Promise(function(resolve, reject) {
        var _opts$signal2;
        var disposer = _when(predicate, resolve, _extends({}, opts, {
            onError: reject
        }));
        cancel = function cancel() {
            disposer();
            reject(new Error("WHEN_CANCELLED"));
        };
        abort = function abort() {
            disposer();
            reject(new Error("WHEN_ABORTED"));
        };
        opts == null || (_opts$signal2 = opts.signal) == null || _opts$signal2.addEventListener == null || _opts$signal2.addEventListener("abort", abort);
    })["finally"](function() {
        var _opts$signal3;
        return opts == null || (_opts$signal3 = opts.signal) == null || _opts$signal3.removeEventListener == null ? void 0 : _opts$signal3.removeEventListener("abort", abort);
    });
    res.cancel = cancel;
    return res;
}
function getAdm(target) {
    return target[$mobx];
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
    has: function has(target, name) {
        return getAdm(target).has_(name);
    },
    get: function get(target, name) {
        return getAdm(target).get_(name);
    },
    set: function set(target, name, value) {
        var _getAdm$set_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$set_ = getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
    },
    deleteProperty: function deleteProperty(target, name) {
        var _getAdm$delete_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$delete_ = getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
    },
    defineProperty: function defineProperty(target, name, descriptor) {
        var _getAdm$definePropert;
        // null (intercepted) -> true (success)
        return (_getAdm$definePropert = getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
    },
    ownKeys: function ownKeys(target) {
        return getAdm(target).ownKeys_();
    },
    preventExtensions: function preventExtensions(target) {
        die(13);
    }
};
function asDynamicObservableObject(target, options) {
    var _target$$mobx, _target$$mobx$proxy_;
    assertProxies();
    target = asObservableObject(target, options);
    return (_target$$mobx$proxy_ = (_target$$mobx = target[$mobx]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, objectProxyTraps);
}
function hasInterceptors(interceptable) {
    return interceptable.interceptors_ !== undefined && interceptable.interceptors_.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors_ || (interceptable.interceptors_ = []);
    interceptors.push(handler);
    return once(function() {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        var interceptors = [].concat(interceptable.interceptors_ || []);
        for(var i = 0, l = interceptors.length; i < l; i++){
            change = interceptors[i](change);
            if (change && !change.type) die(14);
            if (!change) break;
        }
        return change;
    } finally{
        untrackedEnd(prevU);
    }
}
function hasListeners(listenable) {
    return listenable.changeListeners_ !== undefined && listenable.changeListeners_.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners_ || (listenable.changeListeners_ = []);
    listeners.push(handler);
    return once(function() {
        var idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners_;
    if (!listeners) return;
    listeners = listeners.slice();
    for(var i = 0, l = listeners.length; i < l; i++)listeners[i](change);
    untrackedEnd(prevU);
}
function makeObservable(target, annotations, options) {
    initObservable(function() {
        var _annotations;
        var adm = asObservableObject(target, options)[$mobx];
        // Default to decorators
        (_annotations = annotations) != null ? _annotations : annotations = collectStoredAnnotations(target);
        // Annotate
        ownKeys(annotations).forEach(function(key) {
            return adm.make_(key, annotations[key]);
        });
    });
    return target;
}
// proto[keysSymbol] = new Set<PropertyKey>()
var keysSymbol = /*#__PURE__*/ Symbol("mobx-keys");
function makeAutoObservable(target, overrides, options) {
    // Optimization: avoid visiting protos
    // Assumes that annotation.make_/.extend_ works the same for plain objects
    if (isPlainObject(target)) return extendObservable(target, target, overrides, options);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        // Optimization: cache keys on proto
        // Assumes makeAutoObservable can be called only once per object and can't be used in subclass
        if (!target[keysSymbol]) {
            var proto = Object.getPrototypeOf(target);
            var keys = new Set([].concat(ownKeys(target), ownKeys(proto)));
            keys["delete"]("constructor");
            keys["delete"]($mobx);
            addHiddenProp(proto, keysSymbol, keys);
        }
        target[keysSymbol].forEach(function(key) {
            return adm.make_(key, // must pass "undefined" for { key: undefined }
            !overrides ? true : key in overrides ? overrides[key] : true);
        });
    });
    return target;
}
var SPLICE = "splice";
var UPDATE = "update";
var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
    get: function get(target, name) {
        var adm = target[$mobx];
        if (name === $mobx) return adm;
        if (name === "length") return adm.getArrayLength_();
        if (typeof name === "string" && !isNaN(name)) return adm.get_(parseInt(name));
        if (hasProp(arrayExtensions, name)) return arrayExtensions[name];
        return target[name];
    },
    set: function set(target, name, value) {
        var adm = target[$mobx];
        if (name === "length") adm.setArrayLength_(value);
        if (typeof name === "symbol" || isNaN(name)) target[name] = value;
        else // numeric string
        adm.set_(parseInt(name), value);
        return true;
    },
    preventExtensions: function preventExtensions() {
        die(15);
    }
};
var ObservableArrayAdministration = /*#__PURE__*/ function() {
    function ObservableArrayAdministration(name, enhancer, owned_, legacyMode_) {
        if (name === void 0) name = "ObservableArray";
        this.owned_ = void 0;
        this.legacyMode_ = void 0;
        this.atom_ = void 0;
        this.values_ = [];
        // this is the prop that gets proxied, so can't replace it!
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.enhancer_ = void 0;
        this.dehancer = void 0;
        this.proxy_ = void 0;
        this.lastKnownLength_ = 0;
        this.owned_ = owned_;
        this.legacyMode_ = legacyMode_;
        this.atom_ = new Atom(name);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, "ObservableArray[..]");
        };
    }
    var _proto = ObservableArrayAdministration.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.dehanceValues_ = function dehanceValues_(values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately === void 0) fireImmediately = false;
        if (fireImmediately) listener({
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: "splice",
            index: 0,
            added: this.values_.slice(),
            addedCount: this.values_.length,
            removed: [],
            removedCount: 0
        });
        return registerListener(this, listener);
    };
    _proto.getArrayLength_ = function getArrayLength_() {
        this.atom_.reportObserved();
        return this.values_.length;
    };
    _proto.setArrayLength_ = function setArrayLength_(newLength) {
        if (typeof newLength !== "number" || isNaN(newLength) || newLength < 0) die("Out of range: " + newLength);
        var currentLength = this.values_.length;
        if (newLength === currentLength) return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for(var i = 0; i < newLength - currentLength; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            this.spliceWithArray_(currentLength, 0, newItems);
        } else this.spliceWithArray_(newLength, currentLength - newLength);
    };
    _proto.updateArrayLength_ = function updateArrayLength_(oldLength, delta) {
        if (oldLength !== this.lastKnownLength_) die(16);
        this.lastKnownLength_ += delta;
        if (this.legacyMode_ && delta > 0) reserveArrayBuffer(oldLength + delta + 1);
    };
    _proto.spliceWithArray_ = function spliceWithArray_(index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        var length = this.values_.length;
        if (index === undefined) index = 0;
        else if (index > length) index = length;
        else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;
        else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_,
                type: SPLICE,
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function(v) {
            return _this.enhancer_(v, undefined);
        });
        if (this.legacyMode_ || false) {
            var lengthDelta = newItems.length - deleteCount;
            this.updateArrayLength_(length, lengthDelta); // checks if internal array wasn't modified
        }
        var res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice_(index, newItems, res);
        return this.dehanceValues_(res);
    };
    _proto.spliceItemsIntoValues_ = function spliceItemsIntoValues_(index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            var _this$values_;
            return (_this$values_ = this.values_).splice.apply(_this$values_, [
                index,
                deleteCount
            ].concat(newItems));
        } else {
            // The items removed by the splice
            var res = this.values_.slice(index, index + deleteCount);
            // The items that that should remain at the end of the array
            var oldItems = this.values_.slice(index + deleteCount);
            // New length is the previous length + addition count - deletion count
            this.values_.length += newItems.length - deleteCount;
            for(var i = 0; i < newItems.length; i++)this.values_[index + i] = newItems[i];
            for(var _i = 0; _i < oldItems.length; _i++)this.values_[index + newItems.length + _i] = oldItems[_i];
            return res;
        }
    };
    _proto.notifyArrayChildUpdate_ = function notifyArrayChildUpdate_(index, newValue, oldValue) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            type: UPDATE,
            debugObjectName: this.atom_.name_,
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null;
        this.atom_.reportChanged();
        if (notify) notifyListeners(this, change);
    };
    _proto.notifyArraySplice_ = function notifyArraySplice_(index, added, removed) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: SPLICE,
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        this.atom_.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) notifyListeners(this, change);
    };
    _proto.get_ = function get_(index) {
        if (this.legacyMode_ && index >= this.values_.length) {
            console.warn("[mobx] Out of bounds read: " + index);
            return undefined;
        }
        this.atom_.reportObserved();
        return this.dehanceValue_(this.values_[index]);
    };
    _proto.set_ = function set_(index, newValue) {
        var values = this.values_;
        if (this.legacyMode_ && index > values.length) // out of bounds
        die(17, index, values.length);
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(this.atom_);
            var oldValue = values[index];
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    type: UPDATE,
                    object: this.proxy_,
                    // since "this" is the real array we need to pass its proxy
                    index: index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = this.enhancer_(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                this.notifyArrayChildUpdate_(index, newValue, oldValue);
            }
        } else {
            // For out of bound index, we don't create an actual sparse array,
            // but rather fill the holes with undefined (same as setArrayLength_).
            // This could be considered a bug.
            var newItems = new Array(index + 1 - values.length);
            for(var i = 0; i < newItems.length - 1; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            newItems[newItems.length - 1] = newValue;
            this.spliceWithArray_(values.length, 0, newItems);
        }
    };
    return ObservableArrayAdministration;
}();
function createObservableArray(initialValues, enhancer, name, owned) {
    if (name === void 0) name = "ObservableArray";
    if (owned === void 0) owned = false;
    assertProxies();
    return initObservable(function() {
        var adm = new ObservableArrayAdministration(name, enhancer, owned, false);
        addHiddenFinalProp(adm.values_, $mobx, adm);
        var proxy = new Proxy(adm.values_, arrayTraps);
        adm.proxy_ = proxy;
        if (initialValues && initialValues.length) adm.spliceWithArray_(0, 0, initialValues);
        return proxy;
    });
}
// eslint-disable-next-line
var arrayExtensions = {
    clear: function clear() {
        return this.splice(0);
    },
    replace: function replace(newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray_(0, adm.values_.length, newItems);
    },
    // Used by JSON.stringify
    toJSON: function toJSON() {
        return this.slice();
    },
    /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */ splice: function splice(index, deleteCount) {
        for(var _len = arguments.length, newItems = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)newItems[_key - 2] = arguments[_key];
        var adm = this[$mobx];
        switch(arguments.length){
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray_(index);
            case 2:
                return adm.spliceWithArray_(index, deleteCount);
        }
        return adm.spliceWithArray_(index, deleteCount, newItems);
    },
    spliceWithArray: function spliceWithArray(index, deleteCount, newItems) {
        return this[$mobx].spliceWithArray_(index, deleteCount, newItems);
    },
    push: function push() {
        var adm = this[$mobx];
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        adm.spliceWithArray_(adm.values_.length, 0, items);
        return adm.values_.length;
    },
    pop: function pop() {
        return this.splice(Math.max(this[$mobx].values_.length - 1, 0), 1)[0];
    },
    shift: function shift() {
        return this.splice(0, 1)[0];
    },
    unshift: function unshift() {
        var adm = this[$mobx];
        for(var _len3 = arguments.length, items = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)items[_key3] = arguments[_key3];
        adm.spliceWithArray_(0, 0, items);
        return adm.values_.length;
    },
    reverse: function reverse() {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        if (globalState.trackingDerivation) die(37, "reverse");
        this.replace(this.slice().reverse());
        return this;
    },
    sort: function sort() {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if (globalState.trackingDerivation) die(37, "sort");
        var copy = this.slice();
        copy.sort.apply(copy, arguments);
        this.replace(copy);
        return this;
    },
    remove: function remove(value) {
        var adm = this[$mobx];
        var idx = adm.dehanceValues_(adm.values_).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    }
};
/**
 * Wrap function from prototype
 * Without this, everything works as well, but this works
 * faster as everything works on unproxied values
 */ addArrayExtension("at", simpleFunc);
addArrayExtension("concat", simpleFunc);
addArrayExtension("flat", simpleFunc);
addArrayExtension("includes", simpleFunc);
addArrayExtension("indexOf", simpleFunc);
addArrayExtension("join", simpleFunc);
addArrayExtension("lastIndexOf", simpleFunc);
addArrayExtension("slice", simpleFunc);
addArrayExtension("toString", simpleFunc);
addArrayExtension("toLocaleString", simpleFunc);
addArrayExtension("toSorted", simpleFunc);
addArrayExtension("toSpliced", simpleFunc);
addArrayExtension("with", simpleFunc);
// map
addArrayExtension("every", mapLikeFunc);
addArrayExtension("filter", mapLikeFunc);
addArrayExtension("find", mapLikeFunc);
addArrayExtension("findIndex", mapLikeFunc);
addArrayExtension("findLast", mapLikeFunc);
addArrayExtension("findLastIndex", mapLikeFunc);
addArrayExtension("flatMap", mapLikeFunc);
addArrayExtension("forEach", mapLikeFunc);
addArrayExtension("map", mapLikeFunc);
addArrayExtension("some", mapLikeFunc);
addArrayExtension("toReversed", mapLikeFunc);
// reduce
addArrayExtension("reduce", reduceLikeFunc);
addArrayExtension("reduceRight", reduceLikeFunc);
function addArrayExtension(funcName, funcFactory) {
    if (typeof Array.prototype[funcName] === "function") arrayExtensions[funcName] = funcFactory(funcName);
}
// Report and delegate to dehanced array
function simpleFunc(funcName) {
    return function() {
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
// Make sure callbacks receive correct array arg #2326
function mapLikeFunc(funcName) {
    return function(callback, thisArg) {
        var _this2 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName](function(element, index) {
            return callback.call(thisArg, element, index, _this2);
        });
    };
}
// Make sure callbacks receive correct array arg #2326
function reduceLikeFunc(funcName) {
    return function() {
        var _this3 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        // #2432 - reduce behavior depends on arguments.length
        var callback = arguments[0];
        arguments[0] = function(accumulator, currentValue, index) {
            return callback(accumulator, currentValue, index, _this3);
        };
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
var isObservableArrayAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}
var ObservableMapMarker = {};
var ADD = "add";
var DELETE = "delete";
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
var ObservableMap = /*#__PURE__*/ function() {
    function ObservableMap(initialData, enhancer_, name_) {
        var _this = this;
        if (enhancer_ === void 0) enhancer_ = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableMap";
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this[$mobx] = ObservableMapMarker;
        this.data_ = void 0;
        this.hasMap_ = void 0;
        // hasMap, not hashMap >-).
        this.keysAtom_ = void 0;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        if (!isFunction(Map)) die(18);
        initObservable(function() {
            _this.keysAtom_ = createAtom("ObservableMap.keys()");
            _this.data_ = new Map();
            _this.hasMap_ = new Map();
            if (initialData) _this.merge(initialData);
        });
    }
    var _proto = ObservableMap.prototype;
    _proto.has_ = function has_(key) {
        return this.data_.has(key);
    };
    _proto.has = function has(key) {
        var _this2 = this;
        if (!globalState.trackingDerivation) return this.has_(key);
        var entry = this.hasMap_.get(key);
        if (!entry) {
            var newEntry = entry = new ObservableValue(this.has_(key), referenceEnhancer, "ObservableMap.key?", false);
            this.hasMap_.set(key, newEntry);
            onBecomeUnobserved(newEntry, function() {
                return _this2.hasMap_["delete"](key);
            });
        }
        return entry.get();
    };
    _proto.set = function set(key, value) {
        var hasKey = this.has_(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? UPDATE : ADD,
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) this.updateValue_(key, value);
        else this.addValue_(key, value);
        return this;
    };
    _proto["delete"] = function _delete(key) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this.has_(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: this.data_.get(key).value_,
                name: key
            } : null;
            transaction(function() {
                var _this3$hasMap_$get;
                _this3.keysAtom_.reportChanged();
                (_this3$hasMap_$get = _this3.hasMap_.get(key)) == null || _this3$hasMap_$get.setNewValue_(false);
                var observable = _this3.data_.get(key);
                observable.setNewValue_(undefined);
                _this3.data_["delete"](key);
            });
            if (notify) notifyListeners(this, _change);
            return true;
        }
        return false;
    };
    _proto.updateValue_ = function updateValue_(key, newValue) {
        var observable = this.data_.get(key);
        newValue = observable.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: UPDATE,
                object: this,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, change);
        }
    };
    _proto.addValue_ = function addValue_(key, newValue) {
        var _this4 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        transaction(function() {
            var _this4$hasMap_$get;
            var observable = new ObservableValue(newValue, _this4.enhancer_, "ObservableMap.key", false);
            _this4.data_.set(key, observable);
            newValue = observable.value_; // value might have been changed
            (_this4$hasMap_$get = _this4.hasMap_.get(key)) == null || _this4$hasMap_$get.setNewValue_(true);
            _this4.keysAtom_.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "map",
            debugObjectName: this.name_,
            type: ADD,
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if (notify) notifyListeners(this, change);
    };
    _proto.get = function get(key) {
        if (this.has(key)) return this.dehanceValue_(this.data_.get(key).get());
        return this.dehanceValue_(undefined);
    };
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.keys = function keys() {
        this.keysAtom_.reportObserved();
        return this.data_.keys();
    };
    _proto.values = function values() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next = keys.next(), done = _keys$next.done, value = _keys$next.value;
                return {
                    done: done,
                    value: done ? undefined : self1.get(value)
                };
            }
        });
    };
    _proto.entries = function entries() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next2 = keys.next(), done = _keys$next2.done, value = _keys$next2.value;
                return {
                    done: done,
                    value: done ? undefined : [
                        value,
                        self1.get(value)
                    ]
                };
            }
        });
    };
    _proto[Symbol.iterator] = function() {
        return this.entries();
    };
    _proto.forEach = function forEach(callback, thisArg) {
        for(var _iterator = _createForOfIteratorHelperLoose(this), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            callback.call(thisArg, value, key, this);
        }
    } /** Merge another object into this object, returns this. */ ;
    _proto.merge = function merge(other) {
        var _this5 = this;
        if (isObservableMap(other)) other = new Map(other);
        transaction(function() {
            if (isPlainObject(other)) getPlainObjectKeys(other).forEach(function(key) {
                return _this5.set(key, other[key]);
            });
            else if (Array.isArray(other)) other.forEach(function(_ref) {
                var key = _ref[0], value = _ref[1];
                return _this5.set(key, value);
            });
            else if (isES6Map(other)) {
                if (!isPlainES6Map(other)) die(19, other);
                other.forEach(function(value, key) {
                    return _this5.set(key, value);
                });
            } else if (other !== null && other !== undefined) die(20, other);
        });
        return this;
    };
    _proto.clear = function clear() {
        var _this6 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator2 = _createForOfIteratorHelperLoose(_this6.keys()), _step2; !(_step2 = _iterator2()).done;){
                    var key = _step2.value;
                    _this6["delete"](key);
                }
            });
        });
    };
    _proto.replace = function replace(values) {
        var _this7 = this;
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        transaction(function() {
            // Convert to map so we can do quick key lookups
            var replacementMap = convertToMap(values);
            var orderedData = new Map();
            // Used for optimization
            var keysReportChangedCalled = false;
            // Delete keys that don't exist in replacement map
            // if the key deletion is prevented by interceptor
            // add entry at the beginning of the result map
            for(var _iterator3 = _createForOfIteratorHelperLoose(_this7.data_.keys()), _step3; !(_step3 = _iterator3()).done;){
                var key = _step3.value;
                // Concurrently iterating/deleting keys
                // iterator should handle this correctly
                if (!replacementMap.has(key)) {
                    var deleted = _this7["delete"](key);
                    // Was the key removed?
                    if (deleted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                    else {
                        // Delete prevented by interceptor
                        var value = _this7.data_.get(key);
                        orderedData.set(key, value);
                    }
                }
            }
            // Merge entries
            for(var _iterator4 = _createForOfIteratorHelperLoose(replacementMap.entries()), _step4; !(_step4 = _iterator4()).done;){
                var _step4$value = _step4.value, _key = _step4$value[0], _value = _step4$value[1];
                // We will want to know whether a new key is added
                var keyExisted = _this7.data_.has(_key);
                // Add or update value
                _this7.set(_key, _value);
                // The addition could have been prevent by interceptor
                if (_this7.data_.has(_key)) {
                    // The update could have been prevented by interceptor
                    // and also we want to preserve existing values
                    // so use value from _data map (instead of replacement map)
                    var _value2 = _this7.data_.get(_key);
                    orderedData.set(_key, _value2);
                    // Was a new key added?
                    if (!keyExisted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                }
            }
            // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (_this7.data_.size !== orderedData.size) // If size differs, keys are definitely modified
                _this7.keysAtom_.reportChanged();
                else {
                    var iter1 = _this7.data_.keys();
                    var iter2 = orderedData.keys();
                    var next1 = iter1.next();
                    var next2 = iter2.next();
                    while(!next1.done){
                        if (next1.value !== next2.value) {
                            _this7.keysAtom_.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            }
            // Use correctly ordered map
            _this7.data_ = orderedData;
        });
        return this;
    };
    _proto.toString = function toString() {
        return "[object ObservableMap]";
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    return _createClass(ObservableMap, [
        {
            key: "size",
            get: function get() {
                this.keysAtom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Map";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableMap = /*#__PURE__*/ createInstanceofPredicate("ObservableMap", ObservableMap);
function makeIterableForMap(iterator) {
    iterator[Symbol.toStringTag] = "MapIterator";
    return makeIterable(iterator);
}
function convertToMap(dataStructure) {
    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) return dataStructure;
    else if (Array.isArray(dataStructure)) return new Map(dataStructure);
    else if (isPlainObject(dataStructure)) {
        var map = new Map();
        for(var key in dataStructure)map.set(key, dataStructure[key]);
        return map;
    } else return die(21, dataStructure);
}
var ObservableSetMarker = {};
var ObservableSet = /*#__PURE__*/ function() {
    function ObservableSet(initialData, enhancer, name_) {
        var _this = this;
        if (enhancer === void 0) enhancer = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableSet";
        this.name_ = void 0;
        this[$mobx] = ObservableSetMarker;
        this.data_ = new Set();
        this.atom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = void 0;
        this.name_ = name_;
        if (!isFunction(Set)) die(22);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, name_);
        };
        initObservable(function() {
            _this.atom_ = createAtom(_this.name_);
            if (initialData) _this.replace(initialData);
        });
    }
    var _proto = ObservableSet.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.clear = function clear() {
        var _this2 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator = _createForOfIteratorHelperLoose(_this2.data_.values()), _step; !(_step = _iterator()).done;){
                    var value = _step.value;
                    _this2["delete"](value);
                }
            });
        });
    };
    _proto.forEach = function forEach(callbackFn, thisArg) {
        for(var _iterator2 = _createForOfIteratorHelperLoose(this), _step2; !(_step2 = _iterator2()).done;){
            var value = _step2.value;
            callbackFn.call(thisArg, value, value, this);
        }
    };
    _proto.add = function add(value) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: ADD,
                object: this,
                newValue: value
            });
            if (!change) return this;
        // ideally, value = change.value would be done here, so that values can be
        // changed by interceptor. Same applies for other Set and Map api's.
        }
        if (!this.has(value)) {
            transaction(function() {
                _this3.data_.add(_this3.enhancer_(value, undefined));
                _this3.atom_.reportChanged();
            });
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: ADD,
                object: this,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, _change);
        }
        return this;
    };
    _proto["delete"] = function _delete(value) {
        var _this4 = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change2 = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: value
            } : null;
            transaction(function() {
                _this4.atom_.reportChanged();
                _this4.data_["delete"](value);
            });
            if (notify) notifyListeners(this, _change2);
            return true;
        }
        return false;
    };
    _proto.has = function has(value) {
        this.atom_.reportObserved();
        return this.data_.has(this.dehanceValue_(value));
    };
    _proto.entries = function entries() {
        var nextIndex = 0;
        var keys = Array.from(this.keys());
        var values = Array.from(this.values());
        return makeIterableForSet({
            next: function next() {
                var index = nextIndex;
                nextIndex += 1;
                return index < values.length ? {
                    value: [
                        keys[index],
                        values[index]
                    ],
                    done: false
                } : {
                    value: undefined,
                    done: true
                };
            }
        });
    };
    _proto.keys = function keys() {
        return this.values();
    };
    _proto.values = function values() {
        this.atom_.reportObserved();
        var self1 = this;
        var nextIndex = 0;
        var observableValues = Array.from(this.data_.values());
        return makeIterableForSet({
            next: function next() {
                return nextIndex < observableValues.length ? {
                    value: self1.dehanceValue_(observableValues[nextIndex++]),
                    done: false
                } : {
                    value: undefined,
                    done: true
                };
            }
        });
    };
    _proto.intersection = function intersection(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.intersection(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.intersection(otherSet);
        }
    };
    _proto.union = function union(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.union(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.union(otherSet);
        }
    };
    _proto.difference = function difference(otherSet) {
        return new Set(this).difference(otherSet);
    };
    _proto.symmetricDifference = function symmetricDifference(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.symmetricDifference(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.symmetricDifference(otherSet);
        }
    };
    _proto.isSubsetOf = function isSubsetOf(otherSet) {
        return new Set(this).isSubsetOf(otherSet);
    };
    _proto.isSupersetOf = function isSupersetOf(otherSet) {
        return new Set(this).isSupersetOf(otherSet);
    };
    _proto.isDisjointFrom = function isDisjointFrom(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.isDisjointFrom(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.isDisjointFrom(otherSet);
        }
    };
    _proto.replace = function replace(other) {
        var _this5 = this;
        if (isObservableSet(other)) other = new Set(other);
        transaction(function() {
            if (Array.isArray(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (isES6Set(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (other !== null && other !== undefined) die("Cannot initialize set from " + other);
        });
        return this;
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    _proto.toString = function toString() {
        return "[object ObservableSet]";
    };
    _proto[Symbol.iterator] = function() {
        return this.values();
    };
    return _createClass(ObservableSet, [
        {
            key: "size",
            get: function get() {
                this.atom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Set";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableSet = /*#__PURE__*/ createInstanceofPredicate("ObservableSet", ObservableSet);
function makeIterableForSet(iterator) {
    iterator[Symbol.toStringTag] = "SetIterator";
    return makeIterable(iterator);
}
var descriptorCache = /*#__PURE__*/ Object.create(null);
var REMOVE = "remove";
var ObservableObjectAdministration = /*#__PURE__*/ function() {
    function ObservableObjectAdministration(target_, values_, name_, // Used anytime annotation is not explicitely provided
    defaultAnnotation_) {
        if (values_ === void 0) values_ = new Map();
        if (defaultAnnotation_ === void 0) defaultAnnotation_ = autoAnnotation;
        this.target_ = void 0;
        this.values_ = void 0;
        this.name_ = void 0;
        this.defaultAnnotation_ = void 0;
        this.keysAtom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.proxy_ = void 0;
        this.isPlainObject_ = void 0;
        this.appliedAnnotations_ = void 0;
        this.pendingKeys_ = void 0;
        this.target_ = target_;
        this.values_ = values_;
        this.name_ = name_;
        this.defaultAnnotation_ = defaultAnnotation_;
        this.keysAtom_ = new Atom("ObservableObject.keys");
        // Optimization: we use this frequently
        this.isPlainObject_ = isPlainObject(this.target_);
    }
    var _proto = ObservableObjectAdministration.prototype;
    _proto.getObservablePropValue_ = function getObservablePropValue_(key) {
        return this.values_.get(key).get();
    };
    _proto.setObservablePropValue_ = function setObservablePropValue_(key, newValue) {
        var observable = this.values_.get(key);
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return true;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: UPDATE,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: newValue
            });
            if (!change) return null;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue_(newValue);
        // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = false;
            var _change = notify || notifySpy ? {
                type: UPDATE,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, _change);
        }
        return true;
    };
    _proto.get_ = function get_(key) {
        if (globalState.trackingDerivation && !hasProp(this.target_, key)) // Key doesn't exist yet, subscribe for it in case it's added later
        this.has_(key);
        return this.target_[key];
    } /**
   * @param {PropertyKey} key
   * @param {any} value
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.set_ = function set_(key, value, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        // Don't use .has(key) - we care about own
        if (hasProp(this.target_, key)) {
            // Existing prop
            if (this.values_.has(key)) // Observable (can be intercepted)
            return this.setObservablePropValue_(key, value);
            else if (proxyTrap) // Non-observable - proxy
            return Reflect.set(this.target_, key, value);
            else {
                // Non-observable
                this.target_[key] = value;
                return true;
            }
        } else // New prop
        return this.extend_(key, {
            value: value,
            enumerable: true,
            writable: true,
            configurable: true
        }, this.defaultAnnotation_, proxyTrap);
    };
    _proto.has_ = function has_(key) {
        if (!globalState.trackingDerivation) // Skip key subscription outside derivation
        return key in this.target_;
        this.pendingKeys_ || (this.pendingKeys_ = new Map());
        var entry = this.pendingKeys_.get(key);
        if (!entry) {
            entry = new ObservableValue(key in this.target_, referenceEnhancer, "ObservableObject.key?", false);
            this.pendingKeys_.set(key, entry);
        }
        return entry.get();
    } /**
   * @param {PropertyKey} key
   * @param {Annotation|boolean} annotation true - use default annotation, false - ignore prop
   */ ;
    _proto.make_ = function make_(key, annotation) {
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return;
        assertAnnotable(this, annotation, key);
        if (!(key in this.target_)) {
            var _this$target_$storedA;
            // Throw on missing key, except for decorators:
            // Decorator annotations are collected from whole prototype chain.
            // When called from super() some props may not exist yet.
            // However we don't have to worry about missing prop,
            // because the decorator must have been applied to something.
            if ((_this$target_$storedA = this.target_[storedAnnotationsSymbol]) != null && _this$target_$storedA[key]) return; // will be annotated by subclass constructor
            else die(1, annotation.annotationType_, this.name_ + "." + key.toString());
        }
        var source = this.target_;
        while(source && source !== objectPrototype){
            var descriptor = getDescriptor(source, key);
            if (descriptor) {
                var outcome = annotation.make_(this, key, descriptor, source);
                if (outcome === 0 /* MakeResult.Cancel */ ) return;
                if (outcome === 1 /* MakeResult.Break */ ) break;
            }
            source = Object.getPrototypeOf(source);
        }
        recordAnnotationApplied(this, annotation, key);
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.extend_ = function extend_(key, descriptor, annotation, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return this.defineProperty_(key, descriptor, proxyTrap);
        assertAnnotable(this, annotation, key);
        var outcome = annotation.extend_(this, key, descriptor, proxyTrap);
        if (outcome) recordAnnotationApplied(this, annotation, key);
        return outcome;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.defineProperty_ = function defineProperty_(key, descriptor, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: descriptor.value
                });
                if (!change) return null;
                var newValue = change.newValue;
                if (descriptor.value !== newValue) descriptor = _extends({}, descriptor, {
                    value: newValue
                });
            }
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            // Notify
            this.notifyPropertyAddition_(key, descriptor.value);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineObservableProperty_ = function defineObservableProperty_(key, value, enhancer, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: value
                });
                if (!change) return null;
                value = change.newValue;
            }
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: true,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            var observable = new ObservableValue(value, enhancer, "ObservableObject.key", false);
            this.values_.set(key, observable);
            // Notify (value possibly changed by ObservableValue)
            this.notifyPropertyAddition_(key, observable.value_);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineComputedProperty_ = function defineComputedProperty_(key, options, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: undefined
                });
                if (!change) return null;
            }
            options.name || (options.name = "ObservableObject.key");
            options.context = this.proxy_ || this.target_;
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: false,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            this.values_.set(key, new ComputedValue(options));
            // Notify
            this.notifyPropertyAddition_(key, undefined);
        } finally{
            endBatch();
        }
        return true;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.delete_ = function delete_(key, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        // No such prop
        if (!hasProp(this.target_, key)) return true;
        // Intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_ || this.target_,
                name: key,
                type: REMOVE
            });
            // Cancelled
            if (!change) return null;
        }
        // Delete
        try {
            var _this$pendingKeys_;
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = false;
            var observable = this.values_.get(key);
            // Value needed for spies/listeners
            var value = undefined;
            // Optimization: don't pull the value unless we will need it
            if (!observable && (notify || notifySpy)) {
                var _getDescriptor;
                value = (_getDescriptor = getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor.value;
            }
            // delete prop (do first, may fail)
            if (proxyTrap) {
                if (!Reflect.deleteProperty(this.target_, key)) return false;
            } else delete this.target_[key];
            // Clear observable
            if (observable) {
                this.values_["delete"](key);
                // for computed, value is undefined
                if (observable instanceof ObservableValue) value = observable.value_;
                // Notify: autorun(() => obj[key]), see #1796
                propagateChanged(observable);
            }
            // Notify "keys/entries/values" observers
            this.keysAtom_.reportChanged();
            // Notify "has" observers
            // "in" as it may still exist in proto
            (_this$pendingKeys_ = this.pendingKeys_) == null || (_this$pendingKeys_ = _this$pendingKeys_.get(key)) == null || _this$pendingKeys_.set(key in this.target_);
            // Notify spies/listeners
            if (notify || notifySpy) {
                var _change2 = {
                    type: REMOVE,
                    observableKind: "object",
                    object: this.proxy_ || this.target_,
                    debugObjectName: this.name_,
                    oldValue: value,
                    name: key
                };
                if (notify) notifyListeners(this, _change2);
            }
        } finally{
            endBatch();
        }
        return true;
    } /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ ;
    _proto.observe_ = function observe_(callback, fireImmediately) {
        return registerListener(this, callback);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.notifyPropertyAddition_ = function notifyPropertyAddition_(key, value) {
        var _this$pendingKeys_2;
        var notify = hasListeners(this);
        var notifySpy = false;
        if (notify || notifySpy) {
            var change = notify || notifySpy ? {
                type: ADD,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, change);
        }
        (_this$pendingKeys_2 = this.pendingKeys_) == null || (_this$pendingKeys_2 = _this$pendingKeys_2.get(key)) == null || _this$pendingKeys_2.set(true);
        // Notify "keys/entries/values" observers
        this.keysAtom_.reportChanged();
    };
    _proto.ownKeys_ = function ownKeys_() {
        this.keysAtom_.reportObserved();
        return ownKeys(this.target_);
    };
    _proto.keys_ = function keys_() {
        // Returns enumerable && own, but unfortunately keysAtom will report on ANY key change.
        // There is no way to distinguish between Object.keys(object) and Reflect.ownKeys(object) - both are handled by ownKeys trap.
        // We can either over-report in Object.keys(object) or under-report in Reflect.ownKeys(object)
        // We choose to over-report in Object.keys(object), because:
        // - typically it's used with simple data objects
        // - when symbolic/non-enumerable keys are relevant Reflect.ownKeys works as expected
        this.keysAtom_.reportObserved();
        return Object.keys(this.target_);
    };
    return ObservableObjectAdministration;
}();
function asObservableObject(target, options) {
    var _options$name;
    if (hasProp(target, $mobx)) return target;
    var name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name : "ObservableObject";
    var adm = new ObservableObjectAdministration(target, new Map(), String(name), getAnnotationFromOptions(options));
    addHiddenProp(target, $mobx, adm);
    return target;
}
var isObservableObjectAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function getCachedObservablePropDescriptor(key) {
    return descriptorCache[key] || (descriptorCache[key] = {
        get: function get() {
            return this[$mobx].getObservablePropValue_(key);
        },
        set: function set(value) {
            return this[$mobx].setObservablePropValue_(key, value);
        }
    });
}
function isObservableObject(thing) {
    if (isObject(thing)) return isObservableObjectAdministration(thing[$mobx]);
    return false;
}
function recordAnnotationApplied(adm, annotation, key) {
    var _adm$target_$storedAn;
    // Remove applied decorator annotation so we don't try to apply it again in subclass constructor
    (_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null || delete _adm$target_$storedAn[key];
}
function assertAnnotable(adm, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
// Bug in safari 9.* (or iOS 9 safari mobile). See #364
var ENTRY_0 = /*#__PURE__*/ createArrayEntryDescriptor(0);
var safariPrototypeSetterInheritanceBug = /*#__PURE__*/ function() {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function set() {
            v = true;
        }
    });
    /*#__PURE__*/ Object.create(p)["0"] = 1;
    return v === false;
}();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */ var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = function StubArray() {};
function inherit(ctor, proto) {
    if (Object.setPrototypeOf) Object.setPrototypeOf(ctor.prototype, proto);
    else if (ctor.prototype.__proto__ !== undefined) ctor.prototype.__proto__ = proto;
    else ctor.prototype = proto;
}
inherit(StubArray, Array.prototype);
// Weex proto freeze protection was here,
// but it is unclear why the hack is need as MobX never changed the prototype
// anyway, so removed it in V6
var LegacyObservableArray = /*#__PURE__*/ function(_StubArray) {
    function LegacyObservableArray(initialValues, enhancer, name, owned) {
        var _this;
        if (name === void 0) name = "ObservableArray";
        if (owned === void 0) owned = false;
        _this = _StubArray.call(this) || this;
        initObservable(function() {
            var adm = new ObservableArrayAdministration(name, enhancer, owned, true);
            adm.proxy_ = _this;
            addHiddenFinalProp(_this, $mobx, adm);
            if (initialValues && initialValues.length) // @ts-ignore
            _this.spliceWithArray(0, 0, initialValues);
            if (safariPrototypeSetterInheritanceBug) // Seems that Safari won't use numeric prototype setter until any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(_this, "0", ENTRY_0);
        });
        return _this;
    }
    _inheritsLoose(LegacyObservableArray, _StubArray);
    var _proto = LegacyObservableArray.prototype;
    _proto.concat = function concat() {
        this[$mobx].atom_.reportObserved();
        for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++)arrays[_key] = arguments[_key];
        return Array.prototype.concat.apply(this.slice(), //@ts-ignore
        arrays.map(function(a) {
            return isObservableArray(a) ? a.slice() : a;
        }));
    };
    _proto[Symbol.iterator] = function() {
        var self1 = this;
        var nextIndex = 0;
        return makeIterable({
            next: function next() {
                return nextIndex < self1.length ? {
                    value: self1[nextIndex++],
                    done: false
                } : {
                    done: true,
                    value: undefined
                };
            }
        });
    };
    return _createClass(LegacyObservableArray, [
        {
            key: "length",
            get: function get() {
                return this[$mobx].getArrayLength_();
            },
            set: function set(newLength) {
                this[$mobx].setArrayLength_(newLength);
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Array";
            }
        }
    ]);
}(StubArray);
Object.entries(arrayExtensions).forEach(function(_ref) {
    var prop = _ref[0], fn = _ref[1];
    if (prop !== "concat") addHiddenProp(LegacyObservableArray.prototype, prop, fn);
});
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: true,
        get: function get() {
            return this[$mobx].get_(index);
        },
        set: function set(value) {
            this[$mobx].set_(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    defineProperty(LegacyObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    if (max > OBSERVABLE_ARRAY_BUFFER_SIZE) {
        for(var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max + 100; index++)createArrayBufferItem(index);
        OBSERVABLE_ARRAY_BUFFER_SIZE = max;
    }
}
reserveArrayBuffer(1000);
function createLegacyArray(initialValues, enhancer, name) {
    return new LegacyObservableArray(initialValues, enhancer, name);
}
function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined) die(23);
            return thing[$mobx].atom_;
        }
        if (isObservableSet(thing)) return thing.atom_;
        if (isObservableMap(thing)) {
            if (property === undefined) return thing.keysAtom_;
            var observable = thing.data_.get(property) || thing.hasMap_.get(property);
            if (!observable) die(25, property, getDebugName(thing));
            return observable;
        }
        if (isObservableObject(thing)) {
            if (!property) return die(26);
            var _observable = thing[$mobx].values_.get(property);
            if (!_observable) die(27, property, getDebugName(thing));
            return _observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    } else if (isFunction(thing)) {
        if (isReaction(thing[$mobx])) // disposer function
        return thing[$mobx];
    }
    die(28);
}
function getAdministration(thing, property) {
    if (!thing) die(29);
    if (property !== undefined) return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    if (isObservableMap(thing) || isObservableSet(thing)) return thing;
    if (thing[$mobx]) return thing[$mobx];
    die(24, thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined) named = getAtom(thing, property);
    else if (isAction(thing)) return thing.name;
    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) named = getAdministration(thing);
    else // valid for arrays as well
    named = getAtom(thing);
    return named.name_;
}
/**
 * Helper function for initializing observable structures, it applies:
 * 1. allowStateChanges so we don't violate enforceActions.
 * 2. untracked so we don't accidentaly subscribe to anything observable accessed during init in case the observable is created inside derivation.
 * 3. batch to avoid state version updates
 */ function initObservable(cb) {
    var derivation = untrackedStart();
    var allowStateChanges = allowStateChangesStart(true);
    startBatch();
    try {
        return cb();
    } finally{
        endBatch();
        allowStateChangesEnd(allowStateChanges);
        untrackedEnd(derivation);
    }
}
var toString = objectPrototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) depth = -1;
    return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object") return false;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch(className){
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) depth++;
            break;
    }
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !(isFunction(aCtor) && aCtor instanceof aCtor && isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    if (depth === 0) return false;
    else if (depth < 0) depth = -1;
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var key;
        length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== length) return false;
        while(length--){
            // Deep compare each member
            key = keys[length];
            if (!(hasProp(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a)) return a.slice();
    if (isES6Map(a) || isObservableMap(a)) return Array.from(a.entries());
    if (isES6Set(a) || isObservableSet(a)) return Array.from(a.entries());
    return a;
}
var _getGlobal$Iterator;
// safely get iterator prototype if available
var maybeIteratorPrototype = ((_getGlobal$Iterator = /*#__PURE__*/ getGlobal().Iterator) == null ? void 0 : _getGlobal$Iterator.prototype) || {};
function makeIterable(iterator) {
    iterator[Symbol.iterator] = getSelf;
    return Object.assign(Object.create(maybeIteratorPrototype), iterator);
}
function getSelf() {
    return this;
}
function isAnnotation(thing) {
    return(// Can be function
    thing instanceof Object && typeof thing.annotationType_ === "string" && isFunction(thing.make_) && isFunction(thing.extend_));
}
/**
 * (c) Michel Weststrate 2015 - 2020
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get a global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */ [
    "Symbol",
    "Map",
    "Set"
].forEach(function(m) {
    var g = getGlobal();
    if (typeof g[m] === "undefined") die("MobX requires global '" + m + "' to be available or polyfilled");
});
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") // See: https://github.com/andykog/mobx-devtools/
__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy: spy,
    extras: {
        getDebugName: getDebugName
    },
    $mobx: $mobx
});

});

parcelRegister("fuFv1", function(module, exports) {

$parcel$export(module.exports, "isUsingStaticRendering", function () { return (parcelRequire("5KWYn")).isUsingStaticRendering; });
$parcel$export(module.exports, "observer", function () { return (parcelRequire("aPVKl")).observer; });
parcelRequire("kowWe");
parcelRequire("5dzXr");
var $jCNM0 = parcelRequire("jCNM0");

var $fLgeL = parcelRequire("fLgeL");
parcelRequire("lDOlD");

var $1lA0g = parcelRequire("1lA0g");

var $5KWYn = parcelRequire("5KWYn");

var $ewa2p = parcelRequire("ewa2p");

var $aPVKl = parcelRequire("aPVKl");

var $7VNBM = parcelRequire("7VNBM");

var $lkFLO = parcelRequire("lkFLO");

var $9VHvY = parcelRequire("9VHvY");

var $cCZ7I = parcelRequire("cCZ7I");
var $b479d946d70b11a0$var$_a;
(0, $fLgeL.observerBatching)((0, $jCNM0.unstable_batchedUpdates));
var $b479d946d70b11a0$export$469d51fb8d268227 = ($b479d946d70b11a0$var$_a = (0, $ewa2p.observerFinalizationRegistry)["finalizeAllImmediately"]) !== null && $b479d946d70b11a0$var$_a !== void 0 ? $b479d946d70b11a0$var$_a : function() {};
function $b479d946d70b11a0$export$b9c7ecd090a87b14(fn, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    return (0, $1lA0g.useObserver)(fn, baseComponentName);
}
function $b479d946d70b11a0$export$7613124ee4202834(enable) {
    (0, $5KWYn.enableStaticRendering)(enable);
}

});
parcelRegister("kowWe", function(module, exports) {

var $4JcCM = parcelRequire("4JcCM");

var $jbmdS = parcelRequire("jbmdS");
if (!(0, $jbmdS.useState)) throw new Error("mobx-react-lite requires React with Hooks support");
if (!(0, $4JcCM.makeObservable)) throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");

});

parcelRegister("5dzXr", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", function () { return (parcelRequire("jCNM0")).unstable_batchedUpdates; });

var $jCNM0 = parcelRequire("jCNM0");

});

parcelRegister("fLgeL", function(module, exports) {

$parcel$export(module.exports, "observerBatching", function () { return $b797d72905d2de3d$export$294943bbc3c74f4f; });

var $4JcCM = parcelRequire("4JcCM");
function $b797d72905d2de3d$export$fb2daceae6f5097a(callback) {
    callback();
}
function $b797d72905d2de3d$export$294943bbc3c74f4f(reactionScheduler) {
    if (!reactionScheduler) reactionScheduler = $b797d72905d2de3d$export$fb2daceae6f5097a;
    (0, $4JcCM.configure)({
        reactionScheduler: reactionScheduler
    });
}
var $b797d72905d2de3d$export$13ce1459b9a04b51 = function() {
    return true;
};

});

parcelRegister("lDOlD", function(module, exports) {
var $fc144b876a92f0af$var$deprecatedMessages = [];
function $fc144b876a92f0af$export$be38475be17599d(msg) {
    if (!$fc144b876a92f0af$var$deprecatedMessages.includes(msg)) {
        $fc144b876a92f0af$var$deprecatedMessages.push(msg);
        console.warn(msg);
    }
}

});

parcelRegister("1lA0g", function(module, exports) {

$parcel$export(module.exports, "useObserver", function () { return $0fb3ae21692e01bb$export$b9c7ecd090a87b14; });

var $4JcCM = parcelRequire("4JcCM");

var $jbmdS = parcelRequire("jbmdS");

var $gxfJQ = parcelRequire("gxfJQ");

var $ewa2p = parcelRequire("ewa2p");

var $5KWYn = parcelRequire("5KWYn");
var $0fb3ae21692e01bb$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $0fb3ae21692e01bb$var$observerComponentNameFor(baseComponentName) {
    return "observer".concat(baseComponentName);
}
/**
 * We use class to make it easier to detect in heap snapshots by name
 */ var $0fb3ae21692e01bb$var$ObjectToBeRetainedByReact = /** @class */ function() {
    function ObjectToBeRetainedByReact() {}
    return ObjectToBeRetainedByReact;
}();
function $0fb3ae21692e01bb$var$objectToBeRetainedByReactFactory() {
    return new $0fb3ae21692e01bb$var$ObjectToBeRetainedByReact();
}
function $0fb3ae21692e01bb$export$b9c7ecd090a87b14(fn, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    if ((0, $5KWYn.isUsingStaticRendering)()) return fn();
    var _a = $0fb3ae21692e01bb$var$__read((0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useState($0fb3ae21692e01bb$var$objectToBeRetainedByReactFactory), 1), objectRetainedByReact = _a[0];
    // Force update, see #2982
    var _b = $0fb3ae21692e01bb$var$__read((0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useState(), 2), setState = _b[1];
    var forceUpdate = function() {
        return setState([]);
    };
    // StrictMode/ConcurrentMode/Suspense may mean that our component is
    // rendered and abandoned multiple times, so we need to track leaked
    // Reactions.
    var admRef = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useRef(null);
    if (!admRef.current) // First render
    admRef.current = {
        reaction: null,
        mounted: false,
        changedBeforeMount: false
    };
    var adm = admRef.current;
    if (!adm.reaction) {
        // First render or component was not committed and reaction was disposed by registry
        adm.reaction = new (0, $4JcCM.Reaction)($0fb3ae21692e01bb$var$observerComponentNameFor(baseComponentName), function() {
            // Observable has changed, meaning we want to re-render
            // BUT if we're a component that hasn't yet got to the useEffect()
            // stage, we might be a component that _started_ to render, but
            // got dropped, and we don't want to make state changes then.
            // (It triggers warnings in StrictMode, for a start.)
            if (adm.mounted) // We have reached useEffect(), so we're mounted, and can trigger an update
            forceUpdate();
            else // We haven't yet reached useEffect(), so we'll need to trigger a re-render
            // when (and if) useEffect() arrives.
            adm.changedBeforeMount = true;
        });
        (0, $ewa2p.observerFinalizationRegistry).register(objectRetainedByReact, adm, adm);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useDebugValue(adm.reaction, (0, $gxfJQ.printDebugValue));
    (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useEffect(function() {
        (0, $ewa2p.observerFinalizationRegistry).unregister(adm);
        adm.mounted = true;
        if (adm.reaction) {
            if (adm.changedBeforeMount) {
                // Got a change before mount, force an update
                adm.changedBeforeMount = false;
                forceUpdate();
            }
        } else {
            // The reaction we set up in our render has been disposed.
            // This can be due to bad timings of renderings, e.g. our
            // component was paused for a _very_ long time, and our
            // reaction got cleaned up
            // Re-create the reaction
            adm.reaction = new (0, $4JcCM.Reaction)($0fb3ae21692e01bb$var$observerComponentNameFor(baseComponentName), function() {
                // We've definitely already been mounted at this point
                forceUpdate();
            });
            forceUpdate();
        }
        return function() {
            adm.reaction.dispose();
            adm.reaction = null;
            adm.mounted = false;
            adm.changedBeforeMount = false;
        };
    }, []);
    // render the original component, but have the
    // reaction track the observables, so that rendering
    // can be invalidated (see above) once a dependency changes
    var rendering;
    var exception;
    adm.reaction.track(function() {
        try {
            rendering = fn();
        } catch (e) {
            exception = e;
        }
    });
    if (exception) throw exception; // re-throw any exceptions caught during rendering
    return rendering;
}

});
parcelRegister("gxfJQ", function(module, exports) {

$parcel$export(module.exports, "printDebugValue", function () { return $c09befbe7fc691d3$export$ef795f1f307682c7; });

var $4JcCM = parcelRequire("4JcCM");
function $c09befbe7fc691d3$export$ef795f1f307682c7(v) {
    return (0, $4JcCM.getDependencyTree)(v);
}

});

parcelRegister("ewa2p", function(module, exports) {

$parcel$export(module.exports, "observerFinalizationRegistry", function () { return $a91bd724ef4b4e7b$export$10e8a12fbfd8583c; });

var $8HnP3 = parcelRequire("8HnP3");
var $a91bd724ef4b4e7b$export$10e8a12fbfd8583c = new (0, $8HnP3.UniversalFinalizationRegistry)(function(adm) {
    var _a;
    (_a = adm.reaction) === null || _a === void 0 || _a.dispose();
    adm.reaction = null;
});

});
parcelRegister("8HnP3", function(module, exports) {

$parcel$export(module.exports, "UniversalFinalizationRegistry", function () { return $6554d18a72cb486a$export$da5d55a244964b51; });
var $6554d18a72cb486a$export$e901ba0ffe10ba41 = 10000;
var $6554d18a72cb486a$export$1ae22ce5a82f26b6 = 10000;
var $6554d18a72cb486a$export$b7a00d372cedeedd = /** @class */ function() {
    function TimerBasedFinalizationRegistry(finalize) {
        var _this = this;
        Object.defineProperty(this, "finalize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: finalize
        });
        Object.defineProperty(this, "registrations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "sweepTimeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Bound so it can be used directly as setTimeout callback.
        Object.defineProperty(this, "sweep", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function(maxAge) {
                if (maxAge === void 0) maxAge = $6554d18a72cb486a$export$e901ba0ffe10ba41;
                // cancel timeout so we can force sweep anytime
                clearTimeout(_this.sweepTimeout);
                _this.sweepTimeout = undefined;
                var now = Date.now();
                _this.registrations.forEach(function(registration, token) {
                    if (now - registration.registeredAt >= maxAge) {
                        _this.finalize(registration.value);
                        _this.registrations.delete(token);
                    }
                });
                if (_this.registrations.size > 0) _this.scheduleSweep();
            }
        });
        // Bound so it can be exported directly as clearTimers test utility.
        Object.defineProperty(this, "finalizeAllImmediately", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function() {
                _this.sweep(0);
            }
        });
    }
    // Token is actually required with this impl
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "register", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(target, value, token) {
            this.registrations.set(token, {
                value: value,
                registeredAt: Date.now()
            });
            this.scheduleSweep();
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "unregister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(token) {
            this.registrations.delete(token);
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "scheduleSweep", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (this.sweepTimeout === undefined) this.sweepTimeout = setTimeout(this.sweep, $6554d18a72cb486a$export$1ae22ce5a82f26b6);
        }
    });
    return TimerBasedFinalizationRegistry;
}();
var $6554d18a72cb486a$export$da5d55a244964b51 = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : $6554d18a72cb486a$export$b7a00d372cedeedd;

});


parcelRegister("5KWYn", function(module, exports) {

$parcel$export(module.exports, "enableStaticRendering", function () { return $430efe696a057069$export$5d52eaa7c0f24c9e; });
$parcel$export(module.exports, "isUsingStaticRendering", function () { return $430efe696a057069$export$55979271896d643e; });
var $430efe696a057069$var$globalIsUsingStaticRendering = false;
function $430efe696a057069$export$5d52eaa7c0f24c9e(enable) {
    $430efe696a057069$var$globalIsUsingStaticRendering = enable;
}
function $430efe696a057069$export$55979271896d643e() {
    return $430efe696a057069$var$globalIsUsingStaticRendering;
}

});


parcelRegister("aPVKl", function(module, exports) {

$parcel$export(module.exports, "observer", function () { return $7e3b760dc01a94be$export$b6ae1bc530f4c149; });

var $jbmdS = parcelRequire("jbmdS");

var $5KWYn = parcelRequire("5KWYn");

var $1lA0g = parcelRequire("1lA0g");
var $7e3b760dc01a94be$var$warnObserverOptionsDeprecated = true;
var $7e3b760dc01a94be$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
// Using react-is had some issues (and operates on elements, not on types), see #608 / #609
var $7e3b760dc01a94be$var$ReactForwardRefSymbol = $7e3b760dc01a94be$var$hasSymbol ? Symbol.for("react.forward_ref") : typeof (0, $jbmdS.forwardRef) === "function" && (0, $jbmdS.forwardRef)(function(props) {
    return null;
})["$$typeof"];
var $7e3b760dc01a94be$var$ReactMemoSymbol = $7e3b760dc01a94be$var$hasSymbol ? Symbol.for("react.memo") : typeof (0, $jbmdS.memo) === "function" && (0, $jbmdS.memo)(function(props) {
    return null;
})["$$typeof"];
function $7e3b760dc01a94be$export$b6ae1bc530f4c149(baseComponent, // TODO remove in next major
options) {
    var _a;
    if ($7e3b760dc01a94be$var$ReactMemoSymbol && baseComponent["$$typeof"] === $7e3b760dc01a94be$var$ReactMemoSymbol) throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
    // The working of observer is explained step by step in this talk: https://www.youtube.com/watch?v=cPF4iBedoF0&feature=youtu.be&t=1307
    if ((0, $5KWYn.isUsingStaticRendering)()) return baseComponent;
    var useForwardRef = (_a = options === null || options === void 0 ? void 0 : options.forwardRef) !== null && _a !== void 0 ? _a : false;
    var render = baseComponent;
    var baseComponentName = baseComponent.displayName || baseComponent.name;
    // If already wrapped with forwardRef, unwrap,
    // so we can patch render and apply memo
    if ($7e3b760dc01a94be$var$ReactForwardRefSymbol && baseComponent["$$typeof"] === $7e3b760dc01a94be$var$ReactForwardRefSymbol) {
        useForwardRef = true;
        render = baseComponent["render"];
        if (typeof render !== "function") throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
    }
    var observerComponent = function(props, ref) {
        return (0, $1lA0g.useObserver)(function() {
            return render(props, ref);
        }, baseComponentName);
    };
    // Don't set `displayName` for anonymous components,
    // so the `displayName` can be customized by user, see #3192.
    if (baseComponentName !== "") observerComponent.displayName = baseComponentName;
    // Support legacy context: `contextTypes` must be applied before `memo`
    if (baseComponent.contextTypes) observerComponent.contextTypes = baseComponent.contextTypes;
    if (useForwardRef) // `forwardRef` must be applied prior `memo`
    // `forwardRef(observer(cmp))` throws:
    // "forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...))"
    observerComponent = (0, $jbmdS.forwardRef)(observerComponent);
    // memo; we are not interested in deep updates
    // in props; we assume that if deep objects are changed,
    // this is in observables, which would have been tracked anyway
    observerComponent = (0, $jbmdS.memo)(observerComponent);
    $7e3b760dc01a94be$var$copyStaticProperties(baseComponent, observerComponent);
    return observerComponent;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $7e3b760dc01a94be$var$hoistBlackList = {
    $$typeof: true,
    render: true,
    compare: true,
    type: true,
    // Don't redefine `displayName`,
    // it's defined as getter-setter pair on `memo` (see #3192).
    displayName: true
};
function $7e3b760dc01a94be$var$copyStaticProperties(base, target) {
    Object.keys(base).forEach(function(key) {
        if (!$7e3b760dc01a94be$var$hoistBlackList[key]) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}

});

parcelRegister("7VNBM", function(module, exports) {

var $1lA0g = parcelRequire("1lA0g");
function $5c6456736d76e13e$export$c1cbdee04e18ea8b(_a) {
    var children = _a.children, render = _a.render;
    var component = children || render;
    if (typeof component !== "function") return null;
    return (0, $1lA0g.useObserver)(component);
}
$5c6456736d76e13e$export$c1cbdee04e18ea8b.displayName = "Observer";
function $5c6456736d76e13e$var$ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    var hasProp = typeof props[key] === "function";
    var hasExtraProp = typeof props[extraKey] === "function";
    if (hasProp && hasExtraProp) return new Error("MobX Observer: Do not use children and render in the same time in`" + componentName);
    if (hasProp || hasExtraProp) return null;
    return new Error("Invalid prop `" + propFullName + "` of type `" + typeof props[key] + "` supplied to" + " `" + componentName + "`, expected `function`.");
}

});

parcelRegister("lkFLO", function(module, exports) {

var $4JcCM = parcelRequire("4JcCM");

var $jbmdS = parcelRequire("jbmdS");
function $f87bddeee7b83203$export$aa207039f277c5f(initializer, annotations) {
    return (0, $jbmdS.useState)(function() {
        return (0, $4JcCM.observable)(initializer(), annotations, {
            autoBind: true
        });
    })[0];
}

});

parcelRegister("9VHvY", function(module, exports) {

var $4JcCM = parcelRequire("4JcCM");

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("lDOlD");

var $cCZ7I = parcelRequire("cCZ7I");
function $73ab310ec05f5a58$export$f5b97ae82d1eeaf3(initializer, current) {
    var source = current && (0, $cCZ7I.useAsObservableSource)(current);
    return (0, $jbmdS.useState)(function() {
        return (0, $4JcCM.observable)(initializer(source), undefined, {
            autoBind: true
        });
    })[0];
}

});
parcelRegister("cCZ7I", function(module, exports) {

$parcel$export(module.exports, "useAsObservableSource", function () { return $9318727f744945c5$export$e0ded3646391939c; });
parcelRequire("lDOlD");

var $4JcCM = parcelRequire("4JcCM");

var $jbmdS = parcelRequire("jbmdS");
var $9318727f744945c5$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $9318727f744945c5$export$e0ded3646391939c(current) {
    var _a = $9318727f744945c5$var$__read((0, $jbmdS.useState)(function() {
        return (0, $4JcCM.observable)(current, {}, {
            deep: false
        });
    }), 1), res = _a[0];
    (0, $4JcCM.runInAction)(function() {
        Object.assign(res, current);
    });
    return res;
}

});




parcelRegister("cjM2a", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", function () { return isNodeEnv; });

var $2vNMs = parcelRequire("2vNMs");

var $2Prz7 = parcelRequire("2Prz7");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $2vNMs.isBrowserBundle)() && Object.prototype.toString.call(typeof $2Prz7 !== "undefined" ? $2Prz7 : 0) === "[object process]";
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ function loadModule(moduleName) {
    let mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        const { cwd } = dynamicRequire(module, "process");
        mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("2vNMs", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", function () { return $1d45176c19d7f260$export$2928c40372e623c0; });
$parcel$export(module.exports, "getSDKSource", function () { return $1d45176c19d7f260$export$8ad33f488b1ab046; });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $1d45176c19d7f260$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $1d45176c19d7f260$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}

});

parcelRegister("2Prz7", function(module, exports) {
// shim for using process in browser
var $20f5ba1ec9340d59$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $20f5ba1ec9340d59$var$cachedSetTimeout;
var $20f5ba1ec9340d59$var$cachedClearTimeout;
function $20f5ba1ec9340d59$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $20f5ba1ec9340d59$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $20f5ba1ec9340d59$var$cachedSetTimeout = setTimeout;
        else $20f5ba1ec9340d59$var$cachedSetTimeout = $20f5ba1ec9340d59$var$defaultSetTimout;
    } catch (e) {
        $20f5ba1ec9340d59$var$cachedSetTimeout = $20f5ba1ec9340d59$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $20f5ba1ec9340d59$var$cachedClearTimeout = clearTimeout;
        else $20f5ba1ec9340d59$var$cachedClearTimeout = $20f5ba1ec9340d59$var$defaultClearTimeout;
    } catch (e) {
        $20f5ba1ec9340d59$var$cachedClearTimeout = $20f5ba1ec9340d59$var$defaultClearTimeout;
    }
})();
function $20f5ba1ec9340d59$var$runTimeout(fun) {
    if ($20f5ba1ec9340d59$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($20f5ba1ec9340d59$var$cachedSetTimeout === $20f5ba1ec9340d59$var$defaultSetTimout || !$20f5ba1ec9340d59$var$cachedSetTimeout) && setTimeout) {
        $20f5ba1ec9340d59$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $20f5ba1ec9340d59$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $20f5ba1ec9340d59$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $20f5ba1ec9340d59$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $20f5ba1ec9340d59$var$runClearTimeout(marker) {
    if ($20f5ba1ec9340d59$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($20f5ba1ec9340d59$var$cachedClearTimeout === $20f5ba1ec9340d59$var$defaultClearTimeout || !$20f5ba1ec9340d59$var$cachedClearTimeout) && clearTimeout) {
        $20f5ba1ec9340d59$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $20f5ba1ec9340d59$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $20f5ba1ec9340d59$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $20f5ba1ec9340d59$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $20f5ba1ec9340d59$var$queue = [];
var $20f5ba1ec9340d59$var$draining = false;
var $20f5ba1ec9340d59$var$currentQueue;
var $20f5ba1ec9340d59$var$queueIndex = -1;
function $20f5ba1ec9340d59$var$cleanUpNextTick() {
    if (!$20f5ba1ec9340d59$var$draining || !$20f5ba1ec9340d59$var$currentQueue) return;
    $20f5ba1ec9340d59$var$draining = false;
    if ($20f5ba1ec9340d59$var$currentQueue.length) $20f5ba1ec9340d59$var$queue = $20f5ba1ec9340d59$var$currentQueue.concat($20f5ba1ec9340d59$var$queue);
    else $20f5ba1ec9340d59$var$queueIndex = -1;
    if ($20f5ba1ec9340d59$var$queue.length) $20f5ba1ec9340d59$var$drainQueue();
}
function $20f5ba1ec9340d59$var$drainQueue() {
    if ($20f5ba1ec9340d59$var$draining) return;
    var timeout = $20f5ba1ec9340d59$var$runTimeout($20f5ba1ec9340d59$var$cleanUpNextTick);
    $20f5ba1ec9340d59$var$draining = true;
    var len = $20f5ba1ec9340d59$var$queue.length;
    while(len){
        $20f5ba1ec9340d59$var$currentQueue = $20f5ba1ec9340d59$var$queue;
        $20f5ba1ec9340d59$var$queue = [];
        while(++$20f5ba1ec9340d59$var$queueIndex < len)if ($20f5ba1ec9340d59$var$currentQueue) $20f5ba1ec9340d59$var$currentQueue[$20f5ba1ec9340d59$var$queueIndex].run();
        $20f5ba1ec9340d59$var$queueIndex = -1;
        len = $20f5ba1ec9340d59$var$queue.length;
    }
    $20f5ba1ec9340d59$var$currentQueue = null;
    $20f5ba1ec9340d59$var$draining = false;
    $20f5ba1ec9340d59$var$runClearTimeout(timeout);
}
$20f5ba1ec9340d59$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $20f5ba1ec9340d59$var$queue.push(new $20f5ba1ec9340d59$var$Item(fun, args));
    if ($20f5ba1ec9340d59$var$queue.length === 1 && !$20f5ba1ec9340d59$var$draining) $20f5ba1ec9340d59$var$runTimeout($20f5ba1ec9340d59$var$drainQueue);
};
// v8 likes predictible objects
function $20f5ba1ec9340d59$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$20f5ba1ec9340d59$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$20f5ba1ec9340d59$var$process.title = "browser";
$20f5ba1ec9340d59$var$process.browser = true;
$20f5ba1ec9340d59$var$process.env = {};
$20f5ba1ec9340d59$var$process.argv = [];
$20f5ba1ec9340d59$var$process.version = ""; // empty string to avoid regexp issues
$20f5ba1ec9340d59$var$process.versions = {};
function $20f5ba1ec9340d59$var$noop() {}
$20f5ba1ec9340d59$var$process.on = $20f5ba1ec9340d59$var$noop;
$20f5ba1ec9340d59$var$process.addListener = $20f5ba1ec9340d59$var$noop;
$20f5ba1ec9340d59$var$process.once = $20f5ba1ec9340d59$var$noop;
$20f5ba1ec9340d59$var$process.off = $20f5ba1ec9340d59$var$noop;
$20f5ba1ec9340d59$var$process.removeListener = $20f5ba1ec9340d59$var$noop;
$20f5ba1ec9340d59$var$process.removeAllListeners = $20f5ba1ec9340d59$var$noop;
$20f5ba1ec9340d59$var$process.emit = $20f5ba1ec9340d59$var$noop;
$20f5ba1ec9340d59$var$process.prependListener = $20f5ba1ec9340d59$var$noop;
$20f5ba1ec9340d59$var$process.prependOnceListener = $20f5ba1ec9340d59$var$noop;
$20f5ba1ec9340d59$var$process.listeners = function(name) {
    return [];
};
$20f5ba1ec9340d59$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$20f5ba1ec9340d59$var$process.cwd = function() {
    return "/";
};
$20f5ba1ec9340d59$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$20f5ba1ec9340d59$var$process.umask = function() {
    return 0;
};

});


parcelRegister("eat5C", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("72ezo", function(module, exports) {

$parcel$export(module.exports, "SuperJSON", function () { return SuperJSON; });
$parcel$export(module.exports, "default", function () { return $51f4058d9bc62191$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "serialize", function () { return serialize; });
$parcel$export(module.exports, "deserialize", function () { return deserialize; });
$parcel$export(module.exports, "stringify", function () { return stringify; });
$parcel$export(module.exports, "parse", function () { return parse; });
$parcel$export(module.exports, "registerClass", function () { return registerClass; });
$parcel$export(module.exports, "registerCustom", function () { return registerCustom; });
$parcel$export(module.exports, "registerSymbol", function () { return registerSymbol; });
$parcel$export(module.exports, "allowErrorProps", function () { return allowErrorProps; });

var $X0a6G = parcelRequire("X0a6G");

var $k3Pq4 = parcelRequire("k3Pq4");

var $8RSV0 = parcelRequire("8RSV0");

var $rcDgX = parcelRequire("rcDgX");

var $cqKim = parcelRequire("cqKim");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var SuperJSON = /** @class */ function() {
    /**
     * @param dedupeReferentialEqualities  If true, SuperJSON will make sure only one instance of referentially equal objects are serialized and the rest are replaced with `null`.
     */ function SuperJSON(_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.dedupe, dedupe = _c === void 0 ? false : _c;
        this.classRegistry = new (0, $X0a6G.ClassRegistry)();
        this.symbolRegistry = new (0, $k3Pq4.Registry)(function(s) {
            var _a;
            return (_a = s.description) !== null && _a !== void 0 ? _a : "";
        });
        this.customTransformerRegistry = new (0, $8RSV0.CustomTransformerRegistry)();
        this.allowedErrorProps = [];
        this.dedupe = dedupe;
    }
    SuperJSON.prototype.serialize = function(object) {
        var identities = new Map();
        var output = (0, $rcDgX.walker)(object, identities, this, this.dedupe);
        var res = {
            json: output.transformedValue
        };
        if (output.annotations) res.meta = __assign(__assign({}, res.meta), {
            values: output.annotations
        });
        var equalityAnnotations = (0, $rcDgX.generateReferentialEqualityAnnotations)(identities, this.dedupe);
        if (equalityAnnotations) res.meta = __assign(__assign({}, res.meta), {
            referentialEqualities: equalityAnnotations
        });
        return res;
    };
    SuperJSON.prototype.deserialize = function(payload) {
        var json = payload.json, meta = payload.meta;
        var result = (0, $cqKim.copy)(json);
        if (meta === null || meta === void 0 ? void 0 : meta.values) result = (0, $rcDgX.applyValueAnnotations)(result, meta.values, this);
        if (meta === null || meta === void 0 ? void 0 : meta.referentialEqualities) result = (0, $rcDgX.applyReferentialEqualityAnnotations)(result, meta.referentialEqualities);
        return result;
    };
    SuperJSON.prototype.stringify = function(object) {
        return JSON.stringify(this.serialize(object));
    };
    SuperJSON.prototype.parse = function(string) {
        return this.deserialize(JSON.parse(string));
    };
    SuperJSON.prototype.registerClass = function(v, options) {
        this.classRegistry.register(v, options);
    };
    SuperJSON.prototype.registerSymbol = function(v, identifier) {
        this.symbolRegistry.register(v, identifier);
    };
    SuperJSON.prototype.registerCustom = function(transformer, name) {
        this.customTransformerRegistry.register(__assign({
            name: name
        }, transformer));
    };
    SuperJSON.prototype.allowErrorProps = function() {
        var _a;
        var props = [];
        for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
        (_a = this.allowedErrorProps).push.apply(_a, __spreadArray([], __read(props)));
    };
    SuperJSON.defaultInstance = new SuperJSON();
    SuperJSON.serialize = SuperJSON.defaultInstance.serialize.bind(SuperJSON.defaultInstance);
    SuperJSON.deserialize = SuperJSON.defaultInstance.deserialize.bind(SuperJSON.defaultInstance);
    SuperJSON.stringify = SuperJSON.defaultInstance.stringify.bind(SuperJSON.defaultInstance);
    SuperJSON.parse = SuperJSON.defaultInstance.parse.bind(SuperJSON.defaultInstance);
    SuperJSON.registerClass = SuperJSON.defaultInstance.registerClass.bind(SuperJSON.defaultInstance);
    SuperJSON.registerSymbol = SuperJSON.defaultInstance.registerSymbol.bind(SuperJSON.defaultInstance);
    SuperJSON.registerCustom = SuperJSON.defaultInstance.registerCustom.bind(SuperJSON.defaultInstance);
    SuperJSON.allowErrorProps = SuperJSON.defaultInstance.allowErrorProps.bind(SuperJSON.defaultInstance);
    return SuperJSON;
}();
var $51f4058d9bc62191$export$2e2bcd8739ae039 = SuperJSON;
var serialize = SuperJSON.serialize;
var deserialize = SuperJSON.deserialize;
var stringify = SuperJSON.stringify;
var parse = SuperJSON.parse;
var registerClass = SuperJSON.registerClass;
var registerCustom = SuperJSON.registerCustom;
var registerSymbol = SuperJSON.registerSymbol;
var allowErrorProps = SuperJSON.allowErrorProps;

});
parcelRegister("X0a6G", function(module, exports) {

$parcel$export(module.exports, "ClassRegistry", function () { return $0b15a2f9c45d74aa$export$52adb1dcdecb659b; });

var $k3Pq4 = parcelRequire("k3Pq4");
var $0b15a2f9c45d74aa$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $0b15a2f9c45d74aa$export$52adb1dcdecb659b = /** @class */ function(_super) {
    $0b15a2f9c45d74aa$var$__extends(ClassRegistry, _super);
    function ClassRegistry() {
        var _this = _super.call(this, function(c) {
            return c.name;
        }) || this;
        _this.classToAllowedProps = new Map();
        return _this;
    }
    ClassRegistry.prototype.register = function(value, options) {
        if (typeof options === "object") {
            if (options.allowProps) this.classToAllowedProps.set(value, options.allowProps);
            _super.prototype.register.call(this, value, options.identifier);
        } else _super.prototype.register.call(this, value, options);
    };
    ClassRegistry.prototype.getAllowedProps = function(value) {
        return this.classToAllowedProps.get(value);
    };
    return ClassRegistry;
}((0, $k3Pq4.Registry));

});
parcelRegister("k3Pq4", function(module, exports) {

$parcel$export(module.exports, "Registry", function () { return $e9abf94e1fed50a2$export$4d9facee29974f3; });

var $6P0K4 = parcelRequire("6P0K4");
var $e9abf94e1fed50a2$export$4d9facee29974f3 = /** @class */ function() {
    function Registry(generateIdentifier) {
        this.generateIdentifier = generateIdentifier;
        this.kv = new (0, $6P0K4.DoubleIndexedKV)();
    }
    Registry.prototype.register = function(value, identifier) {
        if (this.kv.getByValue(value)) return;
        if (!identifier) identifier = this.generateIdentifier(value);
        this.kv.set(identifier, value);
    };
    Registry.prototype.clear = function() {
        this.kv.clear();
    };
    Registry.prototype.getIdentifier = function(value) {
        return this.kv.getByValue(value);
    };
    Registry.prototype.getValue = function(identifier) {
        return this.kv.getByKey(identifier);
    };
    return Registry;
}();

});
parcelRegister("6P0K4", function(module, exports) {

$parcel$export(module.exports, "DoubleIndexedKV", function () { return $4f7814d7297bf97e$export$46277d766079883; });
var $4f7814d7297bf97e$export$46277d766079883 = /** @class */ function() {
    function DoubleIndexedKV() {
        this.keyToValue = new Map();
        this.valueToKey = new Map();
    }
    DoubleIndexedKV.prototype.set = function(key, value) {
        this.keyToValue.set(key, value);
        this.valueToKey.set(value, key);
    };
    DoubleIndexedKV.prototype.getByKey = function(key) {
        return this.keyToValue.get(key);
    };
    DoubleIndexedKV.prototype.getByValue = function(value) {
        return this.valueToKey.get(value);
    };
    DoubleIndexedKV.prototype.clear = function() {
        this.keyToValue.clear();
        this.valueToKey.clear();
    };
    return DoubleIndexedKV;
}();

});



parcelRegister("8RSV0", function(module, exports) {

$parcel$export(module.exports, "CustomTransformerRegistry", function () { return $674ddf9b668c1482$export$375fc3c989563692; });

var $cfHWP = parcelRequire("cfHWP");
var $674ddf9b668c1482$export$375fc3c989563692 = /** @class */ function() {
    function CustomTransformerRegistry() {
        this.transfomers = {};
    }
    CustomTransformerRegistry.prototype.register = function(transformer) {
        this.transfomers[transformer.name] = transformer;
    };
    CustomTransformerRegistry.prototype.findApplicable = function(v) {
        return (0, $cfHWP.find)(this.transfomers, function(transformer) {
            return transformer.isApplicable(v);
        });
    };
    CustomTransformerRegistry.prototype.findByName = function(name) {
        return this.transfomers[name];
    };
    return CustomTransformerRegistry;
}();

});
parcelRegister("cfHWP", function(module, exports) {

$parcel$export(module.exports, "find", function () { return $8eb8f9e5273f4750$export$71aa6c912b956294; });
$parcel$export(module.exports, "forEach", function () { return $8eb8f9e5273f4750$export$4b80e395e36b5a56; });
$parcel$export(module.exports, "includes", function () { return $8eb8f9e5273f4750$export$ee2e0f811dca1807; });
$parcel$export(module.exports, "findArr", function () { return $8eb8f9e5273f4750$export$169650455b10d814; });
var $8eb8f9e5273f4750$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $8eb8f9e5273f4750$var$valuesOfObj(record) {
    if ("values" in Object) // eslint-disable-next-line es5/no-es6-methods
    return Object.values(record);
    var values = [];
    // eslint-disable-next-line no-restricted-syntax
    for(var key in record)if (record.hasOwnProperty(key)) values.push(record[key]);
    return values;
}
function $8eb8f9e5273f4750$export$71aa6c912b956294(record, predicate) {
    var values = $8eb8f9e5273f4750$var$valuesOfObj(record);
    if ("find" in values) // eslint-disable-next-line es5/no-es6-methods
    return values.find(predicate);
    var valuesNotNever = values;
    for(var i = 0; i < valuesNotNever.length; i++){
        var value = valuesNotNever[i];
        if (predicate(value)) return value;
    }
    return undefined;
}
function $8eb8f9e5273f4750$export$4b80e395e36b5a56(record, run) {
    Object.entries(record).forEach(function(_a) {
        var _b = $8eb8f9e5273f4750$var$__read(_a, 2), key = _b[0], value = _b[1];
        return run(value, key);
    });
}
function $8eb8f9e5273f4750$export$ee2e0f811dca1807(arr, value) {
    return arr.indexOf(value) !== -1;
}
function $8eb8f9e5273f4750$export$169650455b10d814(record, predicate) {
    for(var i = 0; i < record.length; i++){
        var value = record[i];
        if (predicate(value)) return value;
    }
    return undefined;
}

});


parcelRegister("rcDgX", function(module, exports) {

$parcel$export(module.exports, "applyValueAnnotations", function () { return $051c52448a5c6ed1$export$fdbee6848e682924; });
$parcel$export(module.exports, "applyReferentialEqualityAnnotations", function () { return $051c52448a5c6ed1$export$2db60f766e3cb5e0; });
$parcel$export(module.exports, "generateReferentialEqualityAnnotations", function () { return $051c52448a5c6ed1$export$df2cc2b2672a42dd; });
$parcel$export(module.exports, "walker", function () { return $051c52448a5c6ed1$export$b8edc0373b60d044; });

var $9vYyq = parcelRequire("9vYyq");

var $6IQrm = parcelRequire("6IQrm");

var $9JBlV = parcelRequire("9JBlV");

var $cfHWP = parcelRequire("cfHWP");

var $bOuJB = parcelRequire("bOuJB");
var $051c52448a5c6ed1$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $051c52448a5c6ed1$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
function $051c52448a5c6ed1$var$traverse(tree, walker, origin) {
    if (origin === void 0) origin = [];
    if (!tree) return;
    if (!(0, $9vYyq.isArray)(tree)) {
        (0, $cfHWP.forEach)(tree, function(subtree, key) {
            return $051c52448a5c6ed1$var$traverse(subtree, walker, $051c52448a5c6ed1$var$__spreadArray($051c52448a5c6ed1$var$__spreadArray([], $051c52448a5c6ed1$var$__read(origin)), $051c52448a5c6ed1$var$__read((0, $6IQrm.parsePath)(key))));
        });
        return;
    }
    var _a = $051c52448a5c6ed1$var$__read(tree, 2), nodeValue = _a[0], children = _a[1];
    if (children) (0, $cfHWP.forEach)(children, function(child, key) {
        $051c52448a5c6ed1$var$traverse(child, walker, $051c52448a5c6ed1$var$__spreadArray($051c52448a5c6ed1$var$__spreadArray([], $051c52448a5c6ed1$var$__read(origin)), $051c52448a5c6ed1$var$__read((0, $6IQrm.parsePath)(key))));
    });
    walker(nodeValue, origin);
}
function $051c52448a5c6ed1$export$fdbee6848e682924(plain, annotations, superJson) {
    $051c52448a5c6ed1$var$traverse(annotations, function(type, path) {
        plain = (0, $bOuJB.setDeep)(plain, path, function(v) {
            return (0, $9JBlV.untransformValue)(v, type, superJson);
        });
    });
    return plain;
}
function $051c52448a5c6ed1$export$2db60f766e3cb5e0(plain, annotations) {
    function apply(identicalPaths, path) {
        var object = (0, $bOuJB.getDeep)(plain, (0, $6IQrm.parsePath)(path));
        identicalPaths.map((0, $6IQrm.parsePath)).forEach(function(identicalObjectPath) {
            plain = (0, $bOuJB.setDeep)(plain, identicalObjectPath, function() {
                return object;
            });
        });
    }
    if ((0, $9vYyq.isArray)(annotations)) {
        var _a = $051c52448a5c6ed1$var$__read(annotations, 2), root = _a[0], other = _a[1];
        root.forEach(function(identicalPath) {
            plain = (0, $bOuJB.setDeep)(plain, (0, $6IQrm.parsePath)(identicalPath), function() {
                return plain;
            });
        });
        if (other) (0, $cfHWP.forEach)(other, apply);
    } else (0, $cfHWP.forEach)(annotations, apply);
    return plain;
}
var $051c52448a5c6ed1$var$isDeep = function(object, superJson) {
    return (0, $9vYyq.isPlainObject)(object) || (0, $9vYyq.isArray)(object) || (0, $9vYyq.isMap)(object) || (0, $9vYyq.isSet)(object) || (0, $9JBlV.isInstanceOfRegisteredClass)(object, superJson);
};
function $051c52448a5c6ed1$var$addIdentity(object, path, identities) {
    var existingSet = identities.get(object);
    if (existingSet) existingSet.push(path);
    else identities.set(object, [
        path
    ]);
}
function $051c52448a5c6ed1$export$df2cc2b2672a42dd(identitites, dedupe) {
    var result = {};
    var rootEqualityPaths = undefined;
    identitites.forEach(function(paths) {
        if (paths.length <= 1) return;
        // if we're not deduping, all of these objects continue existing.
        // putting the shortest path first makes it easier to parse for humans
        // if we're deduping though, only the first entry will still exist, so we can't do this optimisation.
        if (!dedupe) paths = paths.map(function(path) {
            return path.map(String);
        }).sort(function(a, b) {
            return a.length - b.length;
        });
        var _a = $051c52448a5c6ed1$var$__read(paths), representativePath = _a[0], identicalPaths = _a.slice(1);
        if (representativePath.length === 0) rootEqualityPaths = identicalPaths.map((0, $6IQrm.stringifyPath));
        else result[(0, $6IQrm.stringifyPath)(representativePath)] = identicalPaths.map((0, $6IQrm.stringifyPath));
    });
    if (rootEqualityPaths) {
        if ((0, $9vYyq.isEmptyObject)(result)) return [
            rootEqualityPaths
        ];
        else return [
            rootEqualityPaths,
            result
        ];
    } else return (0, $9vYyq.isEmptyObject)(result) ? undefined : result;
}
var $051c52448a5c6ed1$export$b8edc0373b60d044 = function(object, identities, superJson, dedupe, path, objectsInThisPath, seenObjects) {
    var _a;
    if (path === void 0) path = [];
    if (objectsInThisPath === void 0) objectsInThisPath = [];
    if (seenObjects === void 0) seenObjects = new Map();
    var primitive = (0, $9vYyq.isPrimitive)(object);
    if (!primitive) {
        $051c52448a5c6ed1$var$addIdentity(object, path, identities);
        var seen = seenObjects.get(object);
        if (seen) // short-circuit result if we've seen this object before
        return dedupe ? {
            transformedValue: null
        } : seen;
    }
    if (!$051c52448a5c6ed1$var$isDeep(object, superJson)) {
        var transformed_1 = (0, $9JBlV.transformValue)(object, superJson);
        var result_1 = transformed_1 ? {
            transformedValue: transformed_1.value,
            annotations: [
                transformed_1.type
            ]
        } : {
            transformedValue: object
        };
        if (!primitive) seenObjects.set(object, result_1);
        return result_1;
    }
    if ((0, $cfHWP.includes)(objectsInThisPath, object)) // prevent circular references
    return {
        transformedValue: null
    };
    var transformationResult = (0, $9JBlV.transformValue)(object, superJson);
    var transformed = (_a = transformationResult === null || transformationResult === void 0 ? void 0 : transformationResult.value) !== null && _a !== void 0 ? _a : object;
    var transformedValue = (0, $9vYyq.isArray)(transformed) ? [] : {};
    var innerAnnotations = {};
    (0, $cfHWP.forEach)(transformed, function(value, index) {
        var recursiveResult = $051c52448a5c6ed1$export$b8edc0373b60d044(value, identities, superJson, dedupe, $051c52448a5c6ed1$var$__spreadArray($051c52448a5c6ed1$var$__spreadArray([], $051c52448a5c6ed1$var$__read(path)), [
            index
        ]), $051c52448a5c6ed1$var$__spreadArray($051c52448a5c6ed1$var$__spreadArray([], $051c52448a5c6ed1$var$__read(objectsInThisPath)), [
            object
        ]), seenObjects);
        transformedValue[index] = recursiveResult.transformedValue;
        if ((0, $9vYyq.isArray)(recursiveResult.annotations)) innerAnnotations[index] = recursiveResult.annotations;
        else if ((0, $9vYyq.isPlainObject)(recursiveResult.annotations)) (0, $cfHWP.forEach)(recursiveResult.annotations, function(tree, key) {
            innerAnnotations[(0, $6IQrm.escapeKey)(index) + "." + key] = tree;
        });
    });
    var result = (0, $9vYyq.isEmptyObject)(innerAnnotations) ? {
        transformedValue: transformedValue,
        annotations: !!transformationResult ? [
            transformationResult.type
        ] : undefined
    } : {
        transformedValue: transformedValue,
        annotations: !!transformationResult ? [
            transformationResult.type,
            innerAnnotations
        ] : innerAnnotations
    };
    if (!primitive) seenObjects.set(object, result);
    return result;
};

});
parcelRegister("9vYyq", function(module, exports) {

$parcel$export(module.exports, "isUndefined", function () { return $6ed5fb1ca85e80d0$export$fce6876652108ab; });
$parcel$export(module.exports, "isPlainObject", function () { return $6ed5fb1ca85e80d0$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isEmptyObject", function () { return $6ed5fb1ca85e80d0$export$83b788b1a3698c03; });
$parcel$export(module.exports, "isArray", function () { return $6ed5fb1ca85e80d0$export$43bee75e5e14138e; });
$parcel$export(module.exports, "isRegExp", function () { return $6ed5fb1ca85e80d0$export$49841c62b9eff15; });
$parcel$export(module.exports, "isMap", function () { return $6ed5fb1ca85e80d0$export$5c90113a285f2241; });
$parcel$export(module.exports, "isSet", function () { return $6ed5fb1ca85e80d0$export$6750766a7c7ec627; });
$parcel$export(module.exports, "isSymbol", function () { return $6ed5fb1ca85e80d0$export$a244864fd9645c7f; });
$parcel$export(module.exports, "isDate", function () { return $6ed5fb1ca85e80d0$export$871608497c498473; });
$parcel$export(module.exports, "isError", function () { return $6ed5fb1ca85e80d0$export$e6127cc7fe7395c3; });
$parcel$export(module.exports, "isNaNValue", function () { return $6ed5fb1ca85e80d0$export$87fc7a69ba8e466; });
$parcel$export(module.exports, "isPrimitive", function () { return $6ed5fb1ca85e80d0$export$c3825b437cbdea5c; });
$parcel$export(module.exports, "isBigint", function () { return $6ed5fb1ca85e80d0$export$d65ada007028ca1; });
$parcel$export(module.exports, "isInfinite", function () { return $6ed5fb1ca85e80d0$export$9ec5d00ddeb5163c; });
$parcel$export(module.exports, "isTypedArray", function () { return $6ed5fb1ca85e80d0$export$b119cc7e1840e59c; });
$parcel$export(module.exports, "isURL", function () { return $6ed5fb1ca85e80d0$export$bab98af026af71ac; });
var $6ed5fb1ca85e80d0$var$getType = function(payload) {
    return Object.prototype.toString.call(payload).slice(8, -1);
};
var $6ed5fb1ca85e80d0$export$fce6876652108ab = function(payload) {
    return typeof payload === "undefined";
};
var $6ed5fb1ca85e80d0$export$630801d484da15df = function(payload) {
    return payload === null;
};
var $6ed5fb1ca85e80d0$export$53b83ca8eaab0383 = function(payload) {
    if (typeof payload !== "object" || payload === null) return false;
    if (payload === Object.prototype) return false;
    if (Object.getPrototypeOf(payload) === null) return true;
    return Object.getPrototypeOf(payload) === Object.prototype;
};
var $6ed5fb1ca85e80d0$export$83b788b1a3698c03 = function(payload) {
    return $6ed5fb1ca85e80d0$export$53b83ca8eaab0383(payload) && Object.keys(payload).length === 0;
};
var $6ed5fb1ca85e80d0$export$43bee75e5e14138e = function(payload) {
    return Array.isArray(payload);
};
var $6ed5fb1ca85e80d0$export$844ec244b1367d54 = function(payload) {
    return typeof payload === "string";
};
var $6ed5fb1ca85e80d0$export$7e4aa119212bc614 = function(payload) {
    return typeof payload === "number" && !isNaN(payload);
};
var $6ed5fb1ca85e80d0$export$f9ce7b637dfbe238 = function(payload) {
    return typeof payload === "boolean";
};
var $6ed5fb1ca85e80d0$export$49841c62b9eff15 = function(payload) {
    return payload instanceof RegExp;
};
var $6ed5fb1ca85e80d0$export$5c90113a285f2241 = function(payload) {
    return payload instanceof Map;
};
var $6ed5fb1ca85e80d0$export$6750766a7c7ec627 = function(payload) {
    return payload instanceof Set;
};
var $6ed5fb1ca85e80d0$export$a244864fd9645c7f = function(payload) {
    return $6ed5fb1ca85e80d0$var$getType(payload) === "Symbol";
};
var $6ed5fb1ca85e80d0$export$871608497c498473 = function(payload) {
    return payload instanceof Date && !isNaN(payload.valueOf());
};
var $6ed5fb1ca85e80d0$export$e6127cc7fe7395c3 = function(payload) {
    return payload instanceof Error;
};
var $6ed5fb1ca85e80d0$export$87fc7a69ba8e466 = function(payload) {
    return typeof payload === "number" && isNaN(payload);
};
var $6ed5fb1ca85e80d0$export$c3825b437cbdea5c = function(payload) {
    return $6ed5fb1ca85e80d0$export$f9ce7b637dfbe238(payload) || $6ed5fb1ca85e80d0$export$630801d484da15df(payload) || $6ed5fb1ca85e80d0$export$fce6876652108ab(payload) || $6ed5fb1ca85e80d0$export$7e4aa119212bc614(payload) || $6ed5fb1ca85e80d0$export$844ec244b1367d54(payload) || $6ed5fb1ca85e80d0$export$a244864fd9645c7f(payload);
};
var $6ed5fb1ca85e80d0$export$d65ada007028ca1 = function(payload) {
    return typeof payload === "bigint";
};
var $6ed5fb1ca85e80d0$export$9ec5d00ddeb5163c = function(payload) {
    return payload === Infinity || payload === -Infinity;
};
var $6ed5fb1ca85e80d0$export$b119cc7e1840e59c = function(payload) {
    return ArrayBuffer.isView(payload) && !(payload instanceof DataView);
};
var $6ed5fb1ca85e80d0$export$bab98af026af71ac = function(payload) {
    return payload instanceof URL;
};

});

parcelRegister("6IQrm", function(module, exports) {

$parcel$export(module.exports, "escapeKey", function () { return $4e4f87aba933c79e$export$ccb63190d6bf301; });
$parcel$export(module.exports, "stringifyPath", function () { return $4e4f87aba933c79e$export$48725424ff4cd5a6; });
$parcel$export(module.exports, "parsePath", function () { return $4e4f87aba933c79e$export$8ccf933b0513f8d0; });
var $4e4f87aba933c79e$export$ccb63190d6bf301 = function(key) {
    return key.replace(/\./g, "\\.");
};
var $4e4f87aba933c79e$export$48725424ff4cd5a6 = function(path) {
    return path.map(String).map($4e4f87aba933c79e$export$ccb63190d6bf301).join(".");
};
var $4e4f87aba933c79e$export$8ccf933b0513f8d0 = function(string) {
    var result = [];
    var segment = "";
    for(var i = 0; i < string.length; i++){
        var char = string.charAt(i);
        var isEscapedDot = char === "\\" && string.charAt(i + 1) === ".";
        if (isEscapedDot) {
            segment += ".";
            i++;
            continue;
        }
        var isEndOfSegment = char === ".";
        if (isEndOfSegment) {
            result.push(segment);
            segment = "";
            continue;
        }
        segment += char;
    }
    var lastSegment = segment;
    result.push(lastSegment);
    return result;
};

});

parcelRegister("9JBlV", function(module, exports) {

$parcel$export(module.exports, "isInstanceOfRegisteredClass", function () { return $71654a77bd2c519f$export$3541e8ed2472fc86; });
$parcel$export(module.exports, "transformValue", function () { return $71654a77bd2c519f$export$98c150630afe5417; });
$parcel$export(module.exports, "untransformValue", function () { return $71654a77bd2c519f$export$bbc227b1fb21334; });

var $9vYyq = parcelRequire("9vYyq");

var $cfHWP = parcelRequire("cfHWP");
var $71654a77bd2c519f$var$__assign = undefined && undefined.__assign || function() {
    $71654a77bd2c519f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $71654a77bd2c519f$var$__assign.apply(this, arguments);
};
var $71654a77bd2c519f$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $71654a77bd2c519f$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
function $71654a77bd2c519f$var$simpleTransformation(isApplicable, annotation, transform, untransform) {
    return {
        isApplicable: isApplicable,
        annotation: annotation,
        transform: transform,
        untransform: untransform
    };
}
var $71654a77bd2c519f$var$simpleRules = [
    $71654a77bd2c519f$var$simpleTransformation((0, $9vYyq.isUndefined), "undefined", function() {
        return null;
    }, function() {
        return undefined;
    }),
    $71654a77bd2c519f$var$simpleTransformation((0, $9vYyq.isBigint), "bigint", function(v) {
        return v.toString();
    }, function(v) {
        if (typeof BigInt !== "undefined") return BigInt(v);
        console.error("Please add a BigInt polyfill.");
        return v;
    }),
    $71654a77bd2c519f$var$simpleTransformation((0, $9vYyq.isDate), "Date", function(v) {
        return v.toISOString();
    }, function(v) {
        return new Date(v);
    }),
    $71654a77bd2c519f$var$simpleTransformation((0, $9vYyq.isError), "Error", function(v, superJson) {
        var baseError = {
            name: v.name,
            message: v.message
        };
        superJson.allowedErrorProps.forEach(function(prop) {
            baseError[prop] = v[prop];
        });
        return baseError;
    }, function(v, superJson) {
        var e = new Error(v.message);
        e.name = v.name;
        e.stack = v.stack;
        superJson.allowedErrorProps.forEach(function(prop) {
            e[prop] = v[prop];
        });
        return e;
    }),
    $71654a77bd2c519f$var$simpleTransformation((0, $9vYyq.isRegExp), "regexp", function(v) {
        return "" + v;
    }, function(regex) {
        var body = regex.slice(1, regex.lastIndexOf("/"));
        var flags = regex.slice(regex.lastIndexOf("/") + 1);
        return new RegExp(body, flags);
    }),
    $71654a77bd2c519f$var$simpleTransformation((0, $9vYyq.isSet), "set", // (sets only exist in es6+)
    // eslint-disable-next-line es5/no-es6-methods
    function(v) {
        return $71654a77bd2c519f$var$__spreadArray([], $71654a77bd2c519f$var$__read(v.values()));
    }, function(v) {
        return new Set(v);
    }),
    $71654a77bd2c519f$var$simpleTransformation((0, $9vYyq.isMap), "map", function(v) {
        return $71654a77bd2c519f$var$__spreadArray([], $71654a77bd2c519f$var$__read(v.entries()));
    }, function(v) {
        return new Map(v);
    }),
    $71654a77bd2c519f$var$simpleTransformation(function(v) {
        return (0, $9vYyq.isNaNValue)(v) || (0, $9vYyq.isInfinite)(v);
    }, "number", function(v) {
        if ((0, $9vYyq.isNaNValue)(v)) return "NaN";
        if (v > 0) return "Infinity";
        else return "-Infinity";
    }, Number),
    $71654a77bd2c519f$var$simpleTransformation(function(v) {
        return v === 0 && 1 / v === -Infinity;
    }, "number", function() {
        return "-0";
    }, Number),
    $71654a77bd2c519f$var$simpleTransformation((0, $9vYyq.isURL), "URL", function(v) {
        return v.toString();
    }, function(v) {
        return new URL(v);
    })
];
function $71654a77bd2c519f$var$compositeTransformation(isApplicable, annotation, transform, untransform) {
    return {
        isApplicable: isApplicable,
        annotation: annotation,
        transform: transform,
        untransform: untransform
    };
}
var $71654a77bd2c519f$var$symbolRule = $71654a77bd2c519f$var$compositeTransformation(function(s, superJson) {
    if ((0, $9vYyq.isSymbol)(s)) {
        var isRegistered = !!superJson.symbolRegistry.getIdentifier(s);
        return isRegistered;
    }
    return false;
}, function(s, superJson) {
    var identifier = superJson.symbolRegistry.getIdentifier(s);
    return [
        "symbol",
        identifier
    ];
}, function(v) {
    return v.description;
}, function(_, a, superJson) {
    var value = superJson.symbolRegistry.getValue(a[1]);
    if (!value) throw new Error("Trying to deserialize unknown symbol");
    return value;
});
var $71654a77bd2c519f$var$constructorToName = [
    Int8Array,
    Uint8Array,
    Int16Array,
    Uint16Array,
    Int32Array,
    Uint32Array,
    Float32Array,
    Float64Array,
    Uint8ClampedArray
].reduce(function(obj, ctor) {
    obj[ctor.name] = ctor;
    return obj;
}, {});
var $71654a77bd2c519f$var$typedArrayRule = $71654a77bd2c519f$var$compositeTransformation((0, $9vYyq.isTypedArray), function(v) {
    return [
        "typed-array",
        v.constructor.name
    ];
}, function(v) {
    return $71654a77bd2c519f$var$__spreadArray([], $71654a77bd2c519f$var$__read(v));
}, function(v, a) {
    var ctor = $71654a77bd2c519f$var$constructorToName[a[1]];
    if (!ctor) throw new Error("Trying to deserialize unknown typed array");
    return new ctor(v);
});
function $71654a77bd2c519f$export$3541e8ed2472fc86(potentialClass, superJson) {
    if (potentialClass === null || potentialClass === void 0 ? void 0 : potentialClass.constructor) {
        var isRegistered = !!superJson.classRegistry.getIdentifier(potentialClass.constructor);
        return isRegistered;
    }
    return false;
}
var $71654a77bd2c519f$var$classRule = $71654a77bd2c519f$var$compositeTransformation($71654a77bd2c519f$export$3541e8ed2472fc86, function(clazz, superJson) {
    var identifier = superJson.classRegistry.getIdentifier(clazz.constructor);
    return [
        "class",
        identifier
    ];
}, function(clazz, superJson) {
    var allowedProps = superJson.classRegistry.getAllowedProps(clazz.constructor);
    if (!allowedProps) return $71654a77bd2c519f$var$__assign({}, clazz);
    var result = {};
    allowedProps.forEach(function(prop) {
        result[prop] = clazz[prop];
    });
    return result;
}, function(v, a, superJson) {
    var clazz = superJson.classRegistry.getValue(a[1]);
    if (!clazz) throw new Error("Trying to deserialize unknown class - check https://github.com/blitz-js/superjson/issues/116#issuecomment-773996564");
    return Object.assign(Object.create(clazz.prototype), v);
});
var $71654a77bd2c519f$var$customRule = $71654a77bd2c519f$var$compositeTransformation(function(value, superJson) {
    return !!superJson.customTransformerRegistry.findApplicable(value);
}, function(value, superJson) {
    var transformer = superJson.customTransformerRegistry.findApplicable(value);
    return [
        "custom",
        transformer.name
    ];
}, function(value, superJson) {
    var transformer = superJson.customTransformerRegistry.findApplicable(value);
    return transformer.serialize(value);
}, function(v, a, superJson) {
    var transformer = superJson.customTransformerRegistry.findByName(a[1]);
    if (!transformer) throw new Error("Trying to deserialize unknown custom value");
    return transformer.deserialize(v);
});
var $71654a77bd2c519f$var$compositeRules = [
    $71654a77bd2c519f$var$classRule,
    $71654a77bd2c519f$var$symbolRule,
    $71654a77bd2c519f$var$customRule,
    $71654a77bd2c519f$var$typedArrayRule
];
var $71654a77bd2c519f$export$98c150630afe5417 = function(value, superJson) {
    var applicableCompositeRule = (0, $cfHWP.findArr)($71654a77bd2c519f$var$compositeRules, function(rule) {
        return rule.isApplicable(value, superJson);
    });
    if (applicableCompositeRule) return {
        value: applicableCompositeRule.transform(value, superJson),
        type: applicableCompositeRule.annotation(value, superJson)
    };
    var applicableSimpleRule = (0, $cfHWP.findArr)($71654a77bd2c519f$var$simpleRules, function(rule) {
        return rule.isApplicable(value, superJson);
    });
    if (applicableSimpleRule) return {
        value: applicableSimpleRule.transform(value, superJson),
        type: applicableSimpleRule.annotation
    };
    return undefined;
};
var $71654a77bd2c519f$var$simpleRulesByAnnotation = {};
$71654a77bd2c519f$var$simpleRules.forEach(function(rule) {
    $71654a77bd2c519f$var$simpleRulesByAnnotation[rule.annotation] = rule;
});
var $71654a77bd2c519f$export$bbc227b1fb21334 = function(json, type, superJson) {
    if ((0, $9vYyq.isArray)(type)) switch(type[0]){
        case "symbol":
            return $71654a77bd2c519f$var$symbolRule.untransform(json, type, superJson);
        case "class":
            return $71654a77bd2c519f$var$classRule.untransform(json, type, superJson);
        case "custom":
            return $71654a77bd2c519f$var$customRule.untransform(json, type, superJson);
        case "typed-array":
            return $71654a77bd2c519f$var$typedArrayRule.untransform(json, type, superJson);
        default:
            throw new Error("Unknown transformation: " + type);
    }
    else {
        var transformation = $71654a77bd2c519f$var$simpleRulesByAnnotation[type];
        if (!transformation) throw new Error("Unknown transformation: " + type);
        return transformation.untransform(json, superJson);
    }
};

});

parcelRegister("bOuJB", function(module, exports) {

$parcel$export(module.exports, "getDeep", function () { return $899c34730d412311$export$cc083bb740ac7702; });
$parcel$export(module.exports, "setDeep", function () { return $899c34730d412311$export$c615a4d8c3fee905; });

var $9vYyq = parcelRequire("9vYyq");

var $cfHWP = parcelRequire("cfHWP");
var $899c34730d412311$var$getNthKey = function(value, n) {
    var keys = value.keys();
    while(n > 0){
        keys.next();
        n--;
    }
    return keys.next().value;
};
function $899c34730d412311$var$validatePath(path) {
    if ((0, $cfHWP.includes)(path, "__proto__")) throw new Error("__proto__ is not allowed as a property");
    if ((0, $cfHWP.includes)(path, "prototype")) throw new Error("prototype is not allowed as a property");
    if ((0, $cfHWP.includes)(path, "constructor")) throw new Error("constructor is not allowed as a property");
}
var $899c34730d412311$export$cc083bb740ac7702 = function(object, path) {
    $899c34730d412311$var$validatePath(path);
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if ((0, $9vYyq.isSet)(object)) object = $899c34730d412311$var$getNthKey(object, +key);
        else if ((0, $9vYyq.isMap)(object)) {
            var row = +key;
            var type = +path[++i] === 0 ? "key" : "value";
            var keyOfRow = $899c34730d412311$var$getNthKey(object, row);
            switch(type){
                case "key":
                    object = keyOfRow;
                    break;
                case "value":
                    object = object.get(keyOfRow);
                    break;
            }
        } else object = object[key];
    }
    return object;
};
var $899c34730d412311$export$c615a4d8c3fee905 = function(object, path, mapper) {
    $899c34730d412311$var$validatePath(path);
    if (path.length === 0) return mapper(object);
    var parent = object;
    for(var i = 0; i < path.length - 1; i++){
        var key = path[i];
        if ((0, $9vYyq.isArray)(parent)) {
            var index = +key;
            parent = parent[index];
        } else if ((0, $9vYyq.isPlainObject)(parent)) parent = parent[key];
        else if ((0, $9vYyq.isSet)(parent)) {
            var row = +key;
            parent = $899c34730d412311$var$getNthKey(parent, row);
        } else if ((0, $9vYyq.isMap)(parent)) {
            var isEnd = i === path.length - 2;
            if (isEnd) break;
            var row = +key;
            var type = +path[++i] === 0 ? "key" : "value";
            var keyOfRow = $899c34730d412311$var$getNthKey(parent, row);
            switch(type){
                case "key":
                    parent = keyOfRow;
                    break;
                case "value":
                    parent = parent.get(keyOfRow);
                    break;
            }
        }
    }
    var lastKey = path[path.length - 1];
    if ((0, $9vYyq.isArray)(parent)) parent[+lastKey] = mapper(parent[+lastKey]);
    else if ((0, $9vYyq.isPlainObject)(parent)) parent[lastKey] = mapper(parent[lastKey]);
    if ((0, $9vYyq.isSet)(parent)) {
        var oldValue = $899c34730d412311$var$getNthKey(parent, +lastKey);
        var newValue = mapper(oldValue);
        if (oldValue !== newValue) {
            parent["delete"](oldValue);
            parent.add(newValue);
        }
    }
    if ((0, $9vYyq.isMap)(parent)) {
        var row = +path[path.length - 2];
        var keyToRow = $899c34730d412311$var$getNthKey(parent, row);
        var type = +lastKey === 0 ? "key" : "value";
        switch(type){
            case "key":
                var newKey = mapper(keyToRow);
                parent.set(newKey, parent.get(keyToRow));
                if (newKey !== keyToRow) parent["delete"](keyToRow);
                break;
            case "value":
                parent.set(keyToRow, mapper(parent.get(keyToRow)));
                break;
        }
    }
    return object;
};

});


parcelRegister("cqKim", function(module, exports) {

$parcel$export(module.exports, "copy", function () { return $90cbd2fe834f2045$export$784d13d8ee351f07; });

var $HBSOK = parcelRequire("HBSOK");
function $90cbd2fe834f2045$var$assignProp(carry, key, newVal, originalObject, includeNonenumerable) {
    const propType = ({}).propertyIsEnumerable.call(originalObject, key) ? "enumerable" : "nonenumerable";
    if (propType === "enumerable") carry[key] = newVal;
    if (includeNonenumerable && propType === "nonenumerable") Object.defineProperty(carry, key, {
        value: newVal,
        enumerable: false,
        writable: true,
        configurable: true
    });
}
function $90cbd2fe834f2045$export$784d13d8ee351f07(target, options = {}) {
    if ((0, $HBSOK.isArray)(target)) return target.map((item)=>$90cbd2fe834f2045$export$784d13d8ee351f07(item, options));
    if (!(0, $HBSOK.isPlainObject)(target)) return target;
    const props = Object.getOwnPropertyNames(target);
    const symbols = Object.getOwnPropertySymbols(target);
    return [
        ...props,
        ...symbols
    ].reduce((carry, key)=>{
        if ((0, $HBSOK.isArray)(options.props) && !options.props.includes(key)) return carry;
        const val = target[key];
        const newVal = $90cbd2fe834f2045$export$784d13d8ee351f07(val, options);
        $90cbd2fe834f2045$var$assignProp(carry, key, newVal, target, options.nonenumerable);
        return carry;
    }, {});
}

});
parcelRegister("HBSOK", function(module, exports) {

$parcel$export(module.exports, "isArray", function () { return $083167128df52250$export$43bee75e5e14138e; });
$parcel$export(module.exports, "isPlainObject", function () { return $083167128df52250$export$53b83ca8eaab0383; });
function $083167128df52250$export$e2b5c5db9e2009fd(payload) {
    return Object.prototype.toString.call(payload).slice(8, -1);
}
function $083167128df52250$export$ae004ceb3d455f9a(payload) {
    return $083167128df52250$export$e2b5c5db9e2009fd(payload) === "Object";
}
function $083167128df52250$export$43bee75e5e14138e(payload) {
    return $083167128df52250$export$e2b5c5db9e2009fd(payload) === "Array";
}
function $083167128df52250$export$5bcd6e94ed871c88(payload) {
    return $083167128df52250$export$e2b5c5db9e2009fd(payload) === "Blob";
}
function $083167128df52250$export$f9ce7b637dfbe238(payload) {
    return $083167128df52250$export$e2b5c5db9e2009fd(payload) === "Boolean";
}
function $083167128df52250$export$871608497c498473(payload) {
    return $083167128df52250$export$e2b5c5db9e2009fd(payload) === "Date" && !isNaN(payload);
}
function $083167128df52250$export$4c0262a4f954db45(payload) {
    return $083167128df52250$export$43bee75e5e14138e(payload) && payload.length === 0;
}
function $083167128df52250$export$53b83ca8eaab0383(payload) {
    if ($083167128df52250$export$e2b5c5db9e2009fd(payload) !== "Object") return false;
    const prototype = Object.getPrototypeOf(payload);
    return !!prototype && prototype.constructor === Object && prototype === Object.prototype;
}
function $083167128df52250$export$83b788b1a3698c03(payload) {
    return $083167128df52250$export$53b83ca8eaab0383(payload) && Object.keys(payload).length === 0;
}
function $083167128df52250$export$78d1711480f95c3e(payload) {
    return payload === "";
}
function $083167128df52250$export$e6127cc7fe7395c3(payload) {
    return $083167128df52250$export$e2b5c5db9e2009fd(payload) === "Error" || payload instanceof Error;
}
function $083167128df52250$export$be78b3111c50efdd(payload) {
    return $083167128df52250$export$e2b5c5db9e2009fd(payload) === "File";
}
function $083167128df52250$export$8064717326baf93d(payload) {
    return $083167128df52250$export$43bee75e5e14138e(payload) && payload.length > 0;
}
function $083167128df52250$export$36f6b23005e191ac(payload) {
    return $083167128df52250$export$53b83ca8eaab0383(payload) && Object.keys(payload).length > 0;
}
function $083167128df52250$export$844ec244b1367d54(payload) {
    return $083167128df52250$export$e2b5c5db9e2009fd(payload) === "String";
}
function $083167128df52250$export$ab65b4820ba194f1(payload) {
    return $083167128df52250$export$844ec244b1367d54(payload) && payload !== "";
}
function $083167128df52250$export$f6e2535fb5126e54(payload) {
    return typeof payload === "function";
}
function $083167128df52250$export$26b9f946b448f23e(payload, type) {
    if (!(type instanceof Function)) throw new TypeError("Type must be a function");
    if (!Object.prototype.hasOwnProperty.call(type, "prototype")) throw new TypeError("Type is not a class");
    const name = type.name;
    return $083167128df52250$export$e2b5c5db9e2009fd(payload) === name || Boolean(payload && payload.constructor === type);
}
function $083167128df52250$export$49034edbe6b62415(value, classOrClassName) {
    if (typeof classOrClassName === "function") {
        for(let p = value; p; p = Object.getPrototypeOf(p)){
            if ($083167128df52250$export$26b9f946b448f23e(p, classOrClassName)) return true;
        }
        return false;
    } else {
        for(let p = value; p; p = Object.getPrototypeOf(p)){
            if ($083167128df52250$export$e2b5c5db9e2009fd(p) === classOrClassName) return true;
        }
        return false;
    }
}
function $083167128df52250$export$5c90113a285f2241(payload) {
    return $083167128df52250$export$e2b5c5db9e2009fd(payload) === "Map";
}
function $083167128df52250$export$87fc7a69ba8e466(payload) {
    return $083167128df52250$export$e2b5c5db9e2009fd(payload) === "Number" && isNaN(payload);
}
function $083167128df52250$export$7e4aa119212bc614(payload) {
    return $083167128df52250$export$e2b5c5db9e2009fd(payload) === "Number" && !isNaN(payload);
}
function $083167128df52250$export$6dbd64961904ec9a(payload) {
    return $083167128df52250$export$7e4aa119212bc614(payload) && payload < 0;
}
function $083167128df52250$export$630801d484da15df(payload) {
    return $083167128df52250$export$e2b5c5db9e2009fd(payload) === "Null";
}
function $083167128df52250$export$532a90c0e5e8e48c(a, b, c, d, e) {
    return (value)=>a(value) || b(value) || !!c && c(value) || !!d && d(value) || !!e && e(value);
}
function $083167128df52250$export$fce6876652108ab(payload) {
    return $083167128df52250$export$e2b5c5db9e2009fd(payload) === "Undefined";
}
const $083167128df52250$export$bedb7023a7733221 = $083167128df52250$export$532a90c0e5e8e48c($083167128df52250$export$630801d484da15df, $083167128df52250$export$fce6876652108ab);
function $083167128df52250$export$a6cdc56e425d0d0a(payload) {
    return $083167128df52250$export$53b83ca8eaab0383(payload);
}
function $083167128df52250$export$c10d0b04eaa80a43(payload) {
    return $083167128df52250$export$ae004ceb3d455f9a(payload);
}
function $083167128df52250$export$5374bb854d0e41c8(payload) {
    return $083167128df52250$export$7e4aa119212bc614(payload) && payload > 0;
}
function $083167128df52250$export$a244864fd9645c7f(payload) {
    return $083167128df52250$export$e2b5c5db9e2009fd(payload) === "Symbol";
}
function $083167128df52250$export$c3825b437cbdea5c(payload) {
    return $083167128df52250$export$f9ce7b637dfbe238(payload) || $083167128df52250$export$630801d484da15df(payload) || $083167128df52250$export$fce6876652108ab(payload) || $083167128df52250$export$7e4aa119212bc614(payload) || $083167128df52250$export$844ec244b1367d54(payload) || $083167128df52250$export$a244864fd9645c7f(payload);
}
function $083167128df52250$export$4369c812aac99591(payload) {
    return $083167128df52250$export$e2b5c5db9e2009fd(payload) === "Promise";
}
function $083167128df52250$export$49841c62b9eff15(payload) {
    return $083167128df52250$export$e2b5c5db9e2009fd(payload) === "RegExp";
}
function $083167128df52250$export$6750766a7c7ec627(payload) {
    return $083167128df52250$export$e2b5c5db9e2009fd(payload) === "Set";
}
function $083167128df52250$export$45e3ca7880506f6(payload) {
    return $083167128df52250$export$e2b5c5db9e2009fd(payload) === "WeakMap";
}
function $083167128df52250$export$6001bf5c91b8444(payload) {
    return $083167128df52250$export$e2b5c5db9e2009fd(payload) === "WeakSet";
}

});



parcelRegister("htkeB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb84d73eb6f62376$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "StaffCollectionClass", function () { return $cb84d73eb6f62376$export$4569752426dfcdaf; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $gSTGk = parcelRequire("gSTGk");

var $eNcHX = parcelRequire("eNcHX");

var $kb7bz = parcelRequire("kb7bz");

var $4WSZl = parcelRequire("4WSZl");

var $1BTI2 = parcelRequire("1BTI2");

var $5JL5P = parcelRequire("5JL5P");
var $cb84d73eb6f62376$var$_dec, $cb84d73eb6f62376$var$_dec2, $cb84d73eb6f62376$var$_dec3, $cb84d73eb6f62376$var$_class;
function $cb84d73eb6f62376$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $cb84d73eb6f62376$var$StaffCollection = ($cb84d73eb6f62376$var$_dec = (0, $4JcCM.action).bound, $cb84d73eb6f62376$var$_dec2 = (0, $4JcCM.action).bound, $cb84d73eb6f62376$var$_dec3 = (0, $4JcCM.action).bound, $cb84d73eb6f62376$var$_class = class StaffCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "staff",
            modelClass: (0, $gSTGk.default)
        });
        this.addLookup("staffByRoleId", "manyByKey", {
            key: (t)=>t.roleId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("staffByCostCentreId", "manyByKey", {
            key: (t)=>t.costCentreId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("activeStaff", "list", {
            filter: (t)=>!t.isDeleted && !t.deletedAt && !t.isArchived
        });
        this.addLookup("staffByPermissionsId", "manyByKey", {
            key: (t)=>t.permissionsId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("staffByPermissionKey", "manyByKey", {
            key: (t)=>t.permissionKey,
            filter: (t)=>!t.deletedAt
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get staffsById() {
        return this.modelsById;
    }
    get staffs() {
        return this.models;
    }
    get staffById() {
        return this.modelsById;
    }
    get staff() {
        return this.models;
    }
    get staffMembersById() {
        return this.modelsById;
    }
    get staffMembers() {
        return this.models;
    }
    addStaff(data) {
        this.add(data);
    }
    addStaffs(data) {
        this.addMany(data);
    }
    createStaff() {
        var _PermissionCollection, _CostCentreCollection;
        const defaultPermissionsId = (0, $1BTI2.default).organisation.defaultPermissionsId;
        const permissionSettings = ((_PermissionCollection = (0, $5JL5P.default).permissionsById[defaultPermissionsId]) === null || _PermissionCollection === void 0 ? void 0 : _PermissionCollection.settings) || (0, $4WSZl.permissionPresets).timesheet;
        const staff = this.add({
            costCentreId: ((_CostCentreCollection = (0, $eNcHX.default).activeCostCentres.find((cc)=>{
                var _cc$name;
                return cc === null || cc === void 0 ? void 0 : (_cc$name = cc.name) === null || _cc$name === void 0 ? void 0 : _cc$name.toLowerCase().includes("staff");
            })) === null || _CostCentreCollection === void 0 ? void 0 : _CostCentreCollection.id) || (0, $eNcHX.default).activeCostCentres[0].id,
            permissionsId: defaultPermissionsId,
            permissions: permissionSettings
        }, {
            trackUpdates: true
        });
        const rate = (0, $kb7bz.default).add({
            staffId: staff.id,
            date: new Date(2010, 0, 1)
        }, {
            trackUpdates: true
        });
        return staff;
    }
}, $cb84d73eb6f62376$var$_applyDecoratedDescriptor($cb84d73eb6f62376$var$_class.prototype, "addStaff", [
    $cb84d73eb6f62376$var$_dec
], Object.getOwnPropertyDescriptor($cb84d73eb6f62376$var$_class.prototype, "addStaff"), $cb84d73eb6f62376$var$_class.prototype), $cb84d73eb6f62376$var$_applyDecoratedDescriptor($cb84d73eb6f62376$var$_class.prototype, "addStaffs", [
    $cb84d73eb6f62376$var$_dec2
], Object.getOwnPropertyDescriptor($cb84d73eb6f62376$var$_class.prototype, "addStaffs"), $cb84d73eb6f62376$var$_class.prototype), $cb84d73eb6f62376$var$_applyDecoratedDescriptor($cb84d73eb6f62376$var$_class.prototype, "createStaff", [
    $cb84d73eb6f62376$var$_dec3
], Object.getOwnPropertyDescriptor($cb84d73eb6f62376$var$_class.prototype, "createStaff"), $cb84d73eb6f62376$var$_class.prototype), $cb84d73eb6f62376$var$_class);
var $cb84d73eb6f62376$export$2e2bcd8739ae039 = new $cb84d73eb6f62376$var$StaffCollection();
const $cb84d73eb6f62376$export$4569752426dfcdaf = $cb84d73eb6f62376$var$StaffCollection;

});
parcelRegister("htmCK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb86b1bbb3b4b11b$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $gN0TC = parcelRequire("gN0TC");
parcelRequire("eat5C");

parcelRequire("72ezo");


var $dtopU = parcelRequire("dtopU");

var $3PpOX = parcelRequire("3PpOX");
var $cb86b1bbb3b4b11b$var$_dec, $cb86b1bbb3b4b11b$var$_dec2, $cb86b1bbb3b4b11b$var$_dec3, $cb86b1bbb3b4b11b$var$_dec4, $cb86b1bbb3b4b11b$var$_dec5, $cb86b1bbb3b4b11b$var$_dec6, $cb86b1bbb3b4b11b$var$_dec7, $cb86b1bbb3b4b11b$var$_dec8, $cb86b1bbb3b4b11b$var$_dec9, $cb86b1bbb3b4b11b$var$_dec10, $cb86b1bbb3b4b11b$var$_dec11, $cb86b1bbb3b4b11b$var$_class, $cb86b1bbb3b4b11b$var$_descriptor, $cb86b1bbb3b4b11b$var$_descriptor2, $cb86b1bbb3b4b11b$var$_descriptor3, $cb86b1bbb3b4b11b$var$_class2, $cb86b1bbb3b4b11b$var$_descriptor4, $cb86b1bbb3b4b11b$var$_descriptor5, $cb86b1bbb3b4b11b$var$_class3, $cb86b1bbb3b4b11b$var$_descriptor6, $cb86b1bbb3b4b11b$var$_descriptor7, $cb86b1bbb3b4b11b$var$_class4, $cb86b1bbb3b4b11b$var$_descriptor8, $cb86b1bbb3b4b11b$var$_descriptor9, $cb86b1bbb3b4b11b$var$_class5, $cb86b1bbb3b4b11b$var$_descriptor10;
function $cb86b1bbb3b4b11b$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $cb86b1bbb3b4b11b$var$_defineProperty(e, r, t) {
    return (r = $cb86b1bbb3b4b11b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $cb86b1bbb3b4b11b$var$_toPropertyKey(t) {
    var i = $cb86b1bbb3b4b11b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $cb86b1bbb3b4b11b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $cb86b1bbb3b4b11b$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $cb86b1bbb3b4b11b$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
const $cb86b1bbb3b4b11b$var$globalModelLookup = {};
let $cb86b1bbb3b4b11b$var$Collection = ($cb86b1bbb3b4b11b$var$_dec = (0, $4JcCM.action).bound, $cb86b1bbb3b4b11b$var$_dec2 = (0, $4JcCM.action).bound, $cb86b1bbb3b4b11b$var$_dec3 = (0, $4JcCM.action).bound, $cb86b1bbb3b4b11b$var$_dec4 = (0, $4JcCM.action).bound, $cb86b1bbb3b4b11b$var$_dec5 = (0, $4JcCM.action).bound, $cb86b1bbb3b4b11b$var$_dec6 = (0, $4JcCM.action).bound, $cb86b1bbb3b4b11b$var$_dec7 = (0, $4JcCM.action).bound, $cb86b1bbb3b4b11b$var$_dec8 = (0, $4JcCM.action).bound, $cb86b1bbb3b4b11b$var$_dec9 = (0, $4JcCM.action).bound, $cb86b1bbb3b4b11b$var$_dec10 = (0, $4JcCM.action).bound, $cb86b1bbb3b4b11b$var$_dec11 = (0, $4JcCM.action).bound, $cb86b1bbb3b4b11b$var$_class = class Collection {
    constructor({ collection: collection, modelClass: modelClass, getModelId: getModelId, modelCreator: modelCreator, modelUpdater: modelUpdater }){
        var _globalModelLookup$co;
        $cb86b1bbb3b4b11b$var$_initializerDefineProperty(this, "modelsById", $cb86b1bbb3b4b11b$var$_descriptor, this);
        $cb86b1bbb3b4b11b$var$_initializerDefineProperty(this, "models", $cb86b1bbb3b4b11b$var$_descriptor2, this);
        $cb86b1bbb3b4b11b$var$_defineProperty(this, "collection", null);
        $cb86b1bbb3b4b11b$var$_defineProperty(this, "modelClass", null);
        $cb86b1bbb3b4b11b$var$_defineProperty(this, "getModelId", (modelData)=>modelData === null || modelData === void 0 ? void 0 : modelData.id);
        $cb86b1bbb3b4b11b$var$_defineProperty(this, "modelCreator", (m, options)=>m instanceof (0, $3PpOX.default) ? m : new this.modelClass(m, {
                ...options,
                source: "collection"
            }));
        $cb86b1bbb3b4b11b$var$_defineProperty(this, "modelUpdater", (model, newData, options = {})=>model.update(newData, {
                ...options,
                source: "collection"
            }));
        $cb86b1bbb3b4b11b$var$_defineProperty(this, "lookups", new Set());
        $cb86b1bbb3b4b11b$var$_defineProperty(this, "cacheTimestamp", null);
        $cb86b1bbb3b4b11b$var$_initializerDefineProperty(this, "saveState", $cb86b1bbb3b4b11b$var$_descriptor3, this);
        (0, $4JcCM.makeObservable)(this);
        (_globalModelLookup$co = $cb86b1bbb3b4b11b$var$globalModelLookup[collection]) !== null && _globalModelLookup$co !== void 0 ? _globalModelLookup$co : $cb86b1bbb3b4b11b$var$globalModelLookup[collection] = {};
        this.collection = collection;
        this.modelClass = modelClass;
        this.getModelId = getModelId !== null && getModelId !== void 0 ? getModelId : this.getModelId;
        this.modelCreator = modelCreator !== null && modelCreator !== void 0 ? modelCreator : this.modelCreator;
        this.modelUpdater = modelUpdater !== null && modelUpdater !== void 0 ? modelUpdater : this.modelUpdater;
        this.addLookup("modelsToSave", "list", {
            filter: (m)=>{
                return m === null || m === void 0 ? void 0 : m.needsSaving;
            }
        });
        this.addLookup("newUnsavedModels", "list", {
            filter: (m)=>{
                return (m === null || m === void 0 ? void 0 : m.needsSaving) && !m.createdAt;
            }
        });
    }
    get modelType() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($dtopU)))(this.collection, 1);
    }
    get needsSaving() {
        var _this$modelsToSave;
        return ((_this$modelsToSave = this.modelsToSave) === null || _this$modelsToSave === void 0 ? void 0 : _this$modelsToSave.length) > 0;
    }
    get updatedAt() {
        return Math.max(...this.modelsToSave.map((m)=>m.updatedAt));
    }
    addMany(modelDataArray, options) {
        return modelDataArray.map((md)=>this.add(md, options));
    }
    add(modelData, options = {}) {
        const modelId = this.getModelId(modelData);
        if (!modelId || !this.modelsById[modelId]) return this.create(modelId, modelData, options);
        else return this.update(modelId, modelData, options);
    }
    create(modelId, modelData, options) {
        var _modelData$id, _modelId;
        (_modelData$id = modelData.id) !== null && _modelData$id !== void 0 ? _modelData$id : modelData.id = (0, (/*@__PURE__*/$parcel$interopDefault($gN0TC)))();
        (_modelId = modelId) !== null && _modelId !== void 0 ? _modelId : modelId = modelData.id;
        let model;
        if ($cb86b1bbb3b4b11b$var$globalModelLookup[this.collection][modelId]) {
            model = $cb86b1bbb3b4b11b$var$globalModelLookup[this.collection][modelId];
            this.modelUpdater(model, modelData, options);
        } else {
            model = this.modelCreator(modelData, options);
            $cb86b1bbb3b4b11b$var$globalModelLookup[this.collection][modelId] = model;
        }
        this.modelsById[modelId] = model;
        this.models.push(model);
        // this.modelsById = { ...this.modelsById }
        // this.models = [...this.models]
        this.onCreate(modelId);
        return this.modelsById[modelId];
    }
    // update everything here
    update(modelId, modelData, options = {}) {
        this.modelUpdater(this.modelsById[modelId], modelData, options);
        // this.modelsById = { ...this.modelsById }
        // this.models = [...this.models]
        this.onUpdate(modelId);
        return this.modelsById[modelId];
    }
    delete(modelId) {
        const model = this.modelsById[modelId];
        if (model) {
            this.onDelete(modelId);
            delete this.modelsById[modelId];
            this.models = this.models.filter((m)=>m.id !== modelId);
        // this.modelsById = { ...this.modelsById }
        // this.models = [...this.models]
        }
        return model;
    }
    deleteMany(modelIds) {
        modelIds.forEach((modelId)=>{
            this.delete(modelId);
        });
    }
    onCreate(modelId) {
        const model = this.modelsById[modelId];
        [
            ...this.lookups
        ].forEach((propName)=>{
            this[propName].add(model);
        });
    }
    onUpdate(modelId) {
        const model = this.modelsById[modelId];
        [
            ...this.lookups
        ].forEach((propName)=>{
            this[propName].update(model);
        });
    }
    onDelete(modelId) {
        const model = this.modelsById[modelId];
        [
            ...this.lookups
        ].forEach((propName)=>{
            this[propName].delete(model);
        });
    }
    addLookup(propName, type, { map: map, filter: filter, key: key, keys: keys }) {
        const lookupTypes = {
            manyByMany: $cb86b1bbb3b4b11b$var$ManyModelsByManyKeys,
            manyByKey: $cb86b1bbb3b4b11b$var$ManyModelsByKey,
            uniqueByKey: $cb86b1bbb3b4b11b$var$UniqueModelsByKey,
            list: $cb86b1bbb3b4b11b$var$ModelList
        };
        const modelsByKey = new lookupTypes[type]({
            filter: filter,
            map: map,
            key: key,
            keys: keys
        });
        Object.defineProperty(this, `_${propName}`, {
            value: modelsByKey,
            writable: false
        });
        Object.defineProperty(this, propName, {
            get () {
                return this[`_${propName}`].lookup;
            }
        });
        this.lookups.add(`_${propName}`);
    }
    clear() {
        this.modelsById = {};
        this.models = [];
        this.lookups.forEach((propName)=>{
            this[propName].clear();
        });
    }
}, $cb86b1bbb3b4b11b$var$_descriptor = $cb86b1bbb3b4b11b$var$_applyDecoratedDescriptor($cb86b1bbb3b4b11b$var$_class.prototype, "modelsById", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $cb86b1bbb3b4b11b$var$_descriptor2 = $cb86b1bbb3b4b11b$var$_applyDecoratedDescriptor($cb86b1bbb3b4b11b$var$_class.prototype, "models", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $cb86b1bbb3b4b11b$var$_descriptor3 = $cb86b1bbb3b4b11b$var$_applyDecoratedDescriptor($cb86b1bbb3b4b11b$var$_class.prototype, "saveState", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $cb86b1bbb3b4b11b$var$_applyDecoratedDescriptor($cb86b1bbb3b4b11b$var$_class.prototype, "modelType", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($cb86b1bbb3b4b11b$var$_class.prototype, "modelType"), $cb86b1bbb3b4b11b$var$_class.prototype), $cb86b1bbb3b4b11b$var$_applyDecoratedDescriptor($cb86b1bbb3b4b11b$var$_class.prototype, "needsSaving", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($cb86b1bbb3b4b11b$var$_class.prototype, "needsSaving"), $cb86b1bbb3b4b11b$var$_class.prototype), $cb86b1bbb3b4b11b$var$_applyDecoratedDescriptor($cb86b1bbb3b4b11b$var$_class.prototype, "updatedAt", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($cb86b1bbb3b4b11b$var$_class.prototype, "updatedAt"), $cb86b1bbb3b4b11b$var$_class.prototype), $cb86b1bbb3b4b11b$var$_applyDecoratedDescriptor($cb86b1bbb3b4b11b$var$_class.prototype, "addMany", [
    $cb86b1bbb3b4b11b$var$_dec
], Object.getOwnPropertyDescriptor($cb86b1bbb3b4b11b$var$_class.prototype, "addMany"), $cb86b1bbb3b4b11b$var$_class.prototype), $cb86b1bbb3b4b11b$var$_applyDecoratedDescriptor($cb86b1bbb3b4b11b$var$_class.prototype, "add", [
    $cb86b1bbb3b4b11b$var$_dec2
], Object.getOwnPropertyDescriptor($cb86b1bbb3b4b11b$var$_class.prototype, "add"), $cb86b1bbb3b4b11b$var$_class.prototype), $cb86b1bbb3b4b11b$var$_applyDecoratedDescriptor($cb86b1bbb3b4b11b$var$_class.prototype, "create", [
    $cb86b1bbb3b4b11b$var$_dec3
], Object.getOwnPropertyDescriptor($cb86b1bbb3b4b11b$var$_class.prototype, "create"), $cb86b1bbb3b4b11b$var$_class.prototype), $cb86b1bbb3b4b11b$var$_applyDecoratedDescriptor($cb86b1bbb3b4b11b$var$_class.prototype, "update", [
    $cb86b1bbb3b4b11b$var$_dec4
], Object.getOwnPropertyDescriptor($cb86b1bbb3b4b11b$var$_class.prototype, "update"), $cb86b1bbb3b4b11b$var$_class.prototype), $cb86b1bbb3b4b11b$var$_applyDecoratedDescriptor($cb86b1bbb3b4b11b$var$_class.prototype, "delete", [
    $cb86b1bbb3b4b11b$var$_dec5
], Object.getOwnPropertyDescriptor($cb86b1bbb3b4b11b$var$_class.prototype, "delete"), $cb86b1bbb3b4b11b$var$_class.prototype), $cb86b1bbb3b4b11b$var$_applyDecoratedDescriptor($cb86b1bbb3b4b11b$var$_class.prototype, "deleteMany", [
    $cb86b1bbb3b4b11b$var$_dec6
], Object.getOwnPropertyDescriptor($cb86b1bbb3b4b11b$var$_class.prototype, "deleteMany"), $cb86b1bbb3b4b11b$var$_class.prototype), $cb86b1bbb3b4b11b$var$_applyDecoratedDescriptor($cb86b1bbb3b4b11b$var$_class.prototype, "onCreate", [
    $cb86b1bbb3b4b11b$var$_dec7
], Object.getOwnPropertyDescriptor($cb86b1bbb3b4b11b$var$_class.prototype, "onCreate"), $cb86b1bbb3b4b11b$var$_class.prototype), $cb86b1bbb3b4b11b$var$_applyDecoratedDescriptor($cb86b1bbb3b4b11b$var$_class.prototype, "onUpdate", [
    $cb86b1bbb3b4b11b$var$_dec8
], Object.getOwnPropertyDescriptor($cb86b1bbb3b4b11b$var$_class.prototype, "onUpdate"), $cb86b1bbb3b4b11b$var$_class.prototype), $cb86b1bbb3b4b11b$var$_applyDecoratedDescriptor($cb86b1bbb3b4b11b$var$_class.prototype, "onDelete", [
    $cb86b1bbb3b4b11b$var$_dec9
], Object.getOwnPropertyDescriptor($cb86b1bbb3b4b11b$var$_class.prototype, "onDelete"), $cb86b1bbb3b4b11b$var$_class.prototype), $cb86b1bbb3b4b11b$var$_applyDecoratedDescriptor($cb86b1bbb3b4b11b$var$_class.prototype, "addLookup", [
    $cb86b1bbb3b4b11b$var$_dec10
], Object.getOwnPropertyDescriptor($cb86b1bbb3b4b11b$var$_class.prototype, "addLookup"), $cb86b1bbb3b4b11b$var$_class.prototype), $cb86b1bbb3b4b11b$var$_applyDecoratedDescriptor($cb86b1bbb3b4b11b$var$_class.prototype, "clear", [
    $cb86b1bbb3b4b11b$var$_dec11
], Object.getOwnPropertyDescriptor($cb86b1bbb3b4b11b$var$_class.prototype, "clear"), $cb86b1bbb3b4b11b$var$_class.prototype), $cb86b1bbb3b4b11b$var$_class);
let $cb86b1bbb3b4b11b$var$ManyModelsByManyKeys = ($cb86b1bbb3b4b11b$var$_class2 = class ManyModelsByManyKeys {
    constructor({ filter: filter, map: map, keys: keys, getId: getId }){
        $cb86b1bbb3b4b11b$var$_defineProperty(this, "filter", (m)=>true);
        $cb86b1bbb3b4b11b$var$_defineProperty(this, "map", (m)=>m);
        $cb86b1bbb3b4b11b$var$_defineProperty(this, "keys", (m)=>[
                m === null || m === void 0 ? void 0 : m.id
            ]);
        $cb86b1bbb3b4b11b$var$_defineProperty(this, "getId", (m)=>m === null || m === void 0 ? void 0 : m.id);
        $cb86b1bbb3b4b11b$var$_initializerDefineProperty(this, "cachedData", $cb86b1bbb3b4b11b$var$_descriptor4, this);
        $cb86b1bbb3b4b11b$var$_initializerDefineProperty(this, "modelsByKey", $cb86b1bbb3b4b11b$var$_descriptor5, this);
        (0, $4JcCM.makeObservable)(this);
        this.filter = filter !== null && filter !== void 0 ? filter : this.filter;
        this.map = map !== null && map !== void 0 ? map : this.map;
        this.keys = keys !== null && keys !== void 0 ? keys : this.keys;
        this.getId = getId !== null && getId !== void 0 ? getId : this.getId;
    }
    add(model) {
        const modelId = this.getId(model);
        if (this.cachedData[modelId]) this.update(model);
        else if (this.filter(model)) {
            const keys = this.keys(model);
            const mappedModel = this.map(model);
            this.cachedData[modelId] = {
                modelKeys: keys,
                modelMap: mappedModel
            };
            keys.forEach((key)=>{
                var _this$modelsByKey$get;
                this.modelsByKey.set(key, (_this$modelsByKey$get = this.modelsByKey.get(key)) !== null && _this$modelsByKey$get !== void 0 ? _this$modelsByKey$get : new Set());
                this.modelsByKey.get(key).add(mappedModel);
            });
        }
    }
    update(model) {
        this.delete(model);
        this.add(model);
    // NOTE - this really kills performance, don't do it
    // this.cachedData = { ...this.cachedData }
    // this.modelsByKey = new Map(this.modelsByKey)
    }
    updateMany(models) {
        models.forEach((model)=>{
            this.delete(model);
            this.add(model);
        });
    // NOTE - this really kills performance, don't do it
    // this.cachedData = { ...this.cachedData }
    // this.modelsByKey = new Map(this.modelsByKey)
    }
    delete(model) {
        const modelId = this.getId(model);
        const cachedData = this.cachedData[modelId];
        if (cachedData) {
            if (cachedData !== null && cachedData !== void 0 && cachedData.modelKeys) cachedData.modelKeys.forEach((key)=>{
                if (this.modelsByKey.has(key)) this.modelsByKey.get(key).delete(cachedData.modelMap);
            });
            delete this.cachedData[modelId];
        }
    }
    get lookup() {
        return Object.fromEntries([
            ...this.modelsByKey
        ].map(([k, v])=>[
                k,
                [
                    ...v
                ]
            ]));
    }
    get(key) {
        if (this.has(key)) return [
            ...this.modelsByKey.get(key)
        ];
        else return [];
    }
    has(key) {
        return this.modelsByKey.has(key);
    }
    clear() {
        this.cachedData = {};
        this.modelsByKey = new Map();
    }
}, $cb86b1bbb3b4b11b$var$_descriptor4 = $cb86b1bbb3b4b11b$var$_applyDecoratedDescriptor($cb86b1bbb3b4b11b$var$_class2.prototype, "cachedData", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $cb86b1bbb3b4b11b$var$_descriptor5 = $cb86b1bbb3b4b11b$var$_applyDecoratedDescriptor($cb86b1bbb3b4b11b$var$_class2.prototype, "modelsByKey", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Map();
    }
}), $cb86b1bbb3b4b11b$var$_applyDecoratedDescriptor($cb86b1bbb3b4b11b$var$_class2.prototype, "lookup", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($cb86b1bbb3b4b11b$var$_class2.prototype, "lookup"), $cb86b1bbb3b4b11b$var$_class2.prototype), $cb86b1bbb3b4b11b$var$_class2);
let $cb86b1bbb3b4b11b$var$ManyModelsByKey = ($cb86b1bbb3b4b11b$var$_class3 = class ManyModelsByKey {
    constructor({ filter: filter, map: map, key: key, getId: getId }){
        $cb86b1bbb3b4b11b$var$_defineProperty(this, "filter", (m)=>true);
        $cb86b1bbb3b4b11b$var$_defineProperty(this, "map", (m)=>m);
        $cb86b1bbb3b4b11b$var$_defineProperty(this, "key", (m)=>m === null || m === void 0 ? void 0 : m.id);
        $cb86b1bbb3b4b11b$var$_defineProperty(this, "getId", (m)=>m === null || m === void 0 ? void 0 : m.id);
        $cb86b1bbb3b4b11b$var$_initializerDefineProperty(this, "cachedData", $cb86b1bbb3b4b11b$var$_descriptor6, this);
        $cb86b1bbb3b4b11b$var$_initializerDefineProperty(this, "modelsByKey", $cb86b1bbb3b4b11b$var$_descriptor7, this);
        (0, $4JcCM.makeObservable)(this);
        this.filter = filter !== null && filter !== void 0 ? filter : this.filter;
        this.map = map !== null && map !== void 0 ? map : this.map;
        this.key = key !== null && key !== void 0 ? key : this.key;
        this.getId = getId !== null && getId !== void 0 ? getId : this.getId;
    }
    add(model) {
        const modelId = this.getId(model);
        if (this.cachedData[modelId]) this.update(model);
        else if (this.filter(model)) {
            var _this$modelsByKey$get2;
            const key = this.key(model);
            const mappedModel = this.map(model);
            this.cachedData[modelId] = {
                modelKey: key,
                modelMap: mappedModel
            };
            this.modelsByKey.set(key, (_this$modelsByKey$get2 = this.modelsByKey.get(key)) !== null && _this$modelsByKey$get2 !== void 0 ? _this$modelsByKey$get2 : new Set());
            this.modelsByKey.get(key).add(mappedModel);
        }
    }
    update(model) {
        this.delete(model);
        this.add(model);
    // NOTE - this really kills performance, don't do it
    // this.cachedData = { ...this.cachedData }
    // this.modelsByKey = new Map(this.modelsByKey)
    }
    updateMany(models) {
        models.forEach((model)=>{
            this.delete(model);
            this.add(model);
        });
    // NOTE - this really kills performance, don't do it
    // this.cachedData = { ...this.cachedData }
    // this.modelsByKey = new Map(this.modelsByKey)
    }
    delete(model) {
        const modelId = this.getId(model);
        const cachedData = this.cachedData[modelId];
        if (cachedData) {
            if (this.modelsByKey.has(cachedData.modelKey)) this.modelsByKey.get(cachedData.modelKey).delete(cachedData.modelMap);
            delete this.cachedData[modelId];
        }
    }
    get lookup() {
        return Object.fromEntries([
            ...this.modelsByKey
        ].map(([k, v])=>[
                k,
                [
                    ...v
                ]
            ]));
    }
    get(key) {
        if (this.has(key)) return [
            ...this.modelsByKey.get(key)
        ];
        else return [];
    }
    has(key) {
        return this.modelsByKey.has(key);
    }
    clear() {
        this.cachedData = {};
        this.modelsByKey = new Map();
    }
}, $cb86b1bbb3b4b11b$var$_descriptor6 = $cb86b1bbb3b4b11b$var$_applyDecoratedDescriptor($cb86b1bbb3b4b11b$var$_class3.prototype, "cachedData", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $cb86b1bbb3b4b11b$var$_descriptor7 = $cb86b1bbb3b4b11b$var$_applyDecoratedDescriptor($cb86b1bbb3b4b11b$var$_class3.prototype, "modelsByKey", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Map();
    }
}), $cb86b1bbb3b4b11b$var$_applyDecoratedDescriptor($cb86b1bbb3b4b11b$var$_class3.prototype, "lookup", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($cb86b1bbb3b4b11b$var$_class3.prototype, "lookup"), $cb86b1bbb3b4b11b$var$_class3.prototype), $cb86b1bbb3b4b11b$var$_class3);
let $cb86b1bbb3b4b11b$var$UniqueModelsByKey = ($cb86b1bbb3b4b11b$var$_class4 = class UniqueModelsByKey {
    constructor({ filter: filter, map: map, key: key, getId: getId }){
        $cb86b1bbb3b4b11b$var$_defineProperty(this, "filter", (m)=>true);
        $cb86b1bbb3b4b11b$var$_defineProperty(this, "map", (m)=>m);
        $cb86b1bbb3b4b11b$var$_defineProperty(this, "key", (m)=>m === null || m === void 0 ? void 0 : m.id);
        $cb86b1bbb3b4b11b$var$_defineProperty(this, "getId", (m)=>m === null || m === void 0 ? void 0 : m.id);
        $cb86b1bbb3b4b11b$var$_initializerDefineProperty(this, "cachedData", $cb86b1bbb3b4b11b$var$_descriptor8, this);
        $cb86b1bbb3b4b11b$var$_initializerDefineProperty(this, "modelsByKey", $cb86b1bbb3b4b11b$var$_descriptor9, this);
        (0, $4JcCM.makeObservable)(this);
        this.filter = filter !== null && filter !== void 0 ? filter : this.filter;
        this.map = map !== null && map !== void 0 ? map : this.map;
        this.key = key !== null && key !== void 0 ? key : this.key;
        this.getId = getId !== null && getId !== void 0 ? getId : this.getId;
    }
    add(model) {
        const modelId = this.getId(model);
        if (this.cachedData[modelId]) this.update(model);
        else if (this.filter(model)) {
            const key = this.key(model);
            const mappedModel = this.map(model);
            this.cachedData[modelId] = {
                modelKey: key
            };
            this.modelsByKey.set(key, mappedModel);
        }
    }
    update(model) {
        this.delete(model);
        this.add(model);
    // NOTE - this really kills performance, don't do it
    // this.cachedData = { ...this.cachedData }
    // this.modelsByKey = new Map(this.modelsByKey)
    }
    updateMany(models) {
        models.forEach((model)=>{
            this.delete(model);
            this.add(model);
        });
    // NOTE - this really kills performance, don't do it
    // this.cachedData = { ...this.cachedData }
    // this.modelsByKey = new Map(this.modelsByKey)
    }
    delete(model) {
        const modelId = this.getId(model);
        const cachedData = this.cachedData[modelId];
        if (cachedData) {
            if (this.modelsByKey.has(cachedData.modelKey)) this.modelsByKey.delete(cachedData.modelKey);
            delete this.cachedData[modelId];
        }
    }
    get lookup() {
        return Object.fromEntries(this.modelsByKey);
    }
    get(key) {
        if (this.has(key)) return this.modelsByKey.get(key);
        else return undefined;
    }
    has(key) {
        return this.modelsByKey.has(key);
    }
    clear() {
        this.cachedData = {};
        this.modelsByKey = new Map();
    }
}, $cb86b1bbb3b4b11b$var$_descriptor8 = $cb86b1bbb3b4b11b$var$_applyDecoratedDescriptor($cb86b1bbb3b4b11b$var$_class4.prototype, "cachedData", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $cb86b1bbb3b4b11b$var$_descriptor9 = $cb86b1bbb3b4b11b$var$_applyDecoratedDescriptor($cb86b1bbb3b4b11b$var$_class4.prototype, "modelsByKey", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Map();
    }
}), $cb86b1bbb3b4b11b$var$_applyDecoratedDescriptor($cb86b1bbb3b4b11b$var$_class4.prototype, "lookup", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($cb86b1bbb3b4b11b$var$_class4.prototype, "lookup"), $cb86b1bbb3b4b11b$var$_class4.prototype), $cb86b1bbb3b4b11b$var$_class4);
let $cb86b1bbb3b4b11b$var$ModelList = ($cb86b1bbb3b4b11b$var$_class5 = class ModelList {
    constructor({ filter: filter, map: map, key: key, getId: getId }){
        $cb86b1bbb3b4b11b$var$_defineProperty(this, "filter", (m)=>true);
        $cb86b1bbb3b4b11b$var$_defineProperty(this, "map", (m)=>m);
        $cb86b1bbb3b4b11b$var$_defineProperty(this, "getId", (m)=>m === null || m === void 0 ? void 0 : m.id);
        $cb86b1bbb3b4b11b$var$_initializerDefineProperty(this, "models", $cb86b1bbb3b4b11b$var$_descriptor10, this);
        (0, $4JcCM.makeObservable)(this);
        this.filter = filter !== null && filter !== void 0 ? filter : this.filter;
        this.map = map !== null && map !== void 0 ? map : this.map;
        this.getId = getId !== null && getId !== void 0 ? getId : this.getId;
    }
    add(model) {
        const modelId = this.getId(model);
        if (this.models.get(modelId)) this.update(model);
        else if (this.filter(model)) {
            const mappedModel = this.map(model);
            this.models.set(modelId, mappedModel);
        }
    }
    update(model) {
        this.delete(model);
        this.add(model);
    // NOTE - this really kills performance, don't do it
    // this.models = new Map(this.models)
    }
    updateMany(models) {
        models.forEach((model)=>{
            this.delete(model);
            this.add(model);
        });
    // NOTE - this really kills performance, don't do it
    // this.models = new Map(this.models)
    }
    delete(model) {
        const modelId = this.getId(model);
        if (this.models.has(modelId)) this.models.delete(modelId);
    }
    get lookup() {
        return [
            ...this.models.values()
        ];
    }
    has(model) {
        const modelId = this.getId(model);
        return this.models.has(modelId);
    }
    get(model) {
        const modelId = this.getId(model);
        return this.models.get(modelId);
    }
    clear() {
        this.models = new Map();
    }
}, $cb86b1bbb3b4b11b$var$_descriptor10 = $cb86b1bbb3b4b11b$var$_applyDecoratedDescriptor($cb86b1bbb3b4b11b$var$_class5.prototype, "models", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Map();
    }
}), $cb86b1bbb3b4b11b$var$_applyDecoratedDescriptor($cb86b1bbb3b4b11b$var$_class5.prototype, "lookup", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($cb86b1bbb3b4b11b$var$_class5.prototype, "lookup"), $cb86b1bbb3b4b11b$var$_class5.prototype), $cb86b1bbb3b4b11b$var$_class5);
var $cb86b1bbb3b4b11b$export$2e2bcd8739ae039 = $cb86b1bbb3b4b11b$var$Collection;

});
parcelRegister("gN0TC", function(module, exports) {
/**
 * cuid.js
 * Collision-resistant UID generator for browsers and node.
 * Sequential for fast db lookups and recency sorting.
 * Safe for element IDs and server-side lookups.
 *
 * Extracted from CLCTR
 *
 * Copyright (c) Eric Elliott 2012
 * MIT License
 */ 
var $9e978 = parcelRequire("9e978");

var $68sr6 = parcelRequire("68sr6");

var $36PgE = parcelRequire("36PgE");
var $c391eae79039a565$var$c = 0, $c391eae79039a565$var$blockSize = 4, $c391eae79039a565$var$base = 36, $c391eae79039a565$var$discreteValues = Math.pow($c391eae79039a565$var$base, $c391eae79039a565$var$blockSize);
function $c391eae79039a565$var$randomBlock() {
    return $68sr6(($36PgE() * $c391eae79039a565$var$discreteValues << 0).toString($c391eae79039a565$var$base), $c391eae79039a565$var$blockSize);
}
function $c391eae79039a565$var$safeCounter() {
    $c391eae79039a565$var$c = $c391eae79039a565$var$c < $c391eae79039a565$var$discreteValues ? $c391eae79039a565$var$c : 0;
    $c391eae79039a565$var$c++; // this is not subliminal
    return $c391eae79039a565$var$c - 1;
}
function $c391eae79039a565$var$cuid() {
    // Starting with a lowercase letter makes
    // it HTML element ID friendly.
    var letter = "c", // timestamp
    // warning: this exposes the exact date and time
    // that the uid was created.
    timestamp = new Date().getTime().toString($c391eae79039a565$var$base), // Prevent same-machine collisions.
    counter = $68sr6($c391eae79039a565$var$safeCounter().toString($c391eae79039a565$var$base), $c391eae79039a565$var$blockSize), // A few chars to generate distinct ids for different
    // clients (so different computers are far less
    // likely to generate the same id)
    print = $9e978(), // Grab some more chars from Math.random()
    random = $c391eae79039a565$var$randomBlock() + $c391eae79039a565$var$randomBlock();
    return letter + timestamp + counter + print + random;
}
$c391eae79039a565$var$cuid.slug = function slug() {
    var date = new Date().getTime().toString(36), counter = $c391eae79039a565$var$safeCounter().toString(36).slice(-4), print = $9e978().slice(0, 1) + $9e978().slice(-1), random = $c391eae79039a565$var$randomBlock().slice(-2);
    return date.slice(-2) + counter + print + random;
};
$c391eae79039a565$var$cuid.isCuid = function isCuid(stringToCheck) {
    if (typeof stringToCheck !== "string") return false;
    if (stringToCheck.startsWith("c")) return true;
    return false;
};
$c391eae79039a565$var$cuid.isSlug = function isSlug(stringToCheck) {
    if (typeof stringToCheck !== "string") return false;
    var stringLength = stringToCheck.length;
    if (stringLength >= 7 && stringLength <= 10) return true;
    return false;
};
$c391eae79039a565$var$cuid.fingerprint = $9e978;
module.exports = $c391eae79039a565$var$cuid;

});
parcelRegister("9e978", function(module, exports) {

var $68sr6 = parcelRequire("68sr6");
var $6b7c7dbccbce7354$var$env = typeof window === "object" ? window : self;
var $6b7c7dbccbce7354$var$globalCount = Object.keys($6b7c7dbccbce7354$var$env).length;
var $6b7c7dbccbce7354$var$mimeTypesLength = navigator.mimeTypes ? navigator.mimeTypes.length : 0;
var $6b7c7dbccbce7354$var$clientId = $68sr6(($6b7c7dbccbce7354$var$mimeTypesLength + navigator.userAgent.length).toString(36) + $6b7c7dbccbce7354$var$globalCount.toString(36), 4);
module.exports = function fingerprint() {
    return $6b7c7dbccbce7354$var$clientId;
};

});
parcelRegister("68sr6", function(module, exports) {
module.exports = function pad(num, size) {
    var s = "000000000" + num;
    return s.substr(s.length - size);
};

});


parcelRegister("36PgE", function(module, exports) {
var $2439b34ac8d04e80$var$getRandomValue;
var $2439b34ac8d04e80$var$crypto = typeof window !== "undefined" && (window.crypto || window.msCrypto) || typeof self !== "undefined" && self.crypto;
if ($2439b34ac8d04e80$var$crypto) {
    var $2439b34ac8d04e80$var$lim = Math.pow(2, 32) - 1;
    $2439b34ac8d04e80$var$getRandomValue = function() {
        return Math.abs($2439b34ac8d04e80$var$crypto.getRandomValues(new Uint32Array(1))[0] / $2439b34ac8d04e80$var$lim);
    };
} else $2439b34ac8d04e80$var$getRandomValue = Math.random;
module.exports = $2439b34ac8d04e80$var$getRandomValue;

});


parcelRegister("dtopU", function(module, exports) {
/* global define */ (function(root, pluralize) {
    // Node.
    module.exports = pluralize();
})(module.exports, function() {
    // Rule storage - pluralize and singularize need to be run sequentially,
    // while other rules can be optimized using an object for instant lookups.
    var pluralRules = [];
    var singularRules = [];
    var uncountables = {};
    var irregularPlurals = {};
    var irregularSingles = {};
    /**
   * Sanitize a pluralization rule to a usable regular expression.
   *
   * @param  {(RegExp|string)} rule
   * @return {RegExp}
   */ function sanitizeRule(rule) {
        if (typeof rule === "string") return new RegExp("^" + rule + "$", "i");
        return rule;
    }
    /**
   * Pass in a word token to produce a function that can replicate the case on
   * another word.
   *
   * @param  {string}   word
   * @param  {string}   token
   * @return {Function}
   */ function restoreCase(word, token) {
        // Tokens are an exact match.
        if (word === token) return token;
        // Lower cased words. E.g. "hello".
        if (word === word.toLowerCase()) return token.toLowerCase();
        // Upper cased words. E.g. "WHISKY".
        if (word === word.toUpperCase()) return token.toUpperCase();
        // Title cased words. E.g. "Title".
        if (word[0] === word[0].toUpperCase()) return token.charAt(0).toUpperCase() + token.substr(1).toLowerCase();
        // Lower cased words. E.g. "test".
        return token.toLowerCase();
    }
    /**
   * Interpolate a regexp string.
   *
   * @param  {string} str
   * @param  {Array}  args
   * @return {string}
   */ function interpolate(str, args) {
        return str.replace(/\$(\d{1,2})/g, function(match, index) {
            return args[index] || "";
        });
    }
    /**
   * Replace a word using a rule.
   *
   * @param  {string} word
   * @param  {Array}  rule
   * @return {string}
   */ function replace(word, rule) {
        return word.replace(rule[0], function(match, index) {
            var result = interpolate(rule[1], arguments);
            if (match === "") return restoreCase(word[index - 1], result);
            return restoreCase(match, result);
        });
    }
    /**
   * Sanitize a word by passing in the word and sanitization rules.
   *
   * @param  {string}   token
   * @param  {string}   word
   * @param  {Array}    rules
   * @return {string}
   */ function sanitizeWord(token, word, rules) {
        // Empty string or doesn't need fixing.
        if (!token.length || uncountables.hasOwnProperty(token)) return word;
        var len = rules.length;
        // Iterate over the sanitization rules and use the first one to match.
        while(len--){
            var rule = rules[len];
            if (rule[0].test(word)) return replace(word, rule);
        }
        return word;
    }
    /**
   * Replace a word with the updated word.
   *
   * @param  {Object}   replaceMap
   * @param  {Object}   keepMap
   * @param  {Array}    rules
   * @return {Function}
   */ function replaceWord(replaceMap, keepMap, rules) {
        return function(word) {
            // Get the correct token and case restoration functions.
            var token = word.toLowerCase();
            // Check against the keep object map.
            if (keepMap.hasOwnProperty(token)) return restoreCase(word, token);
            // Check against the replacement map for a direct word replacement.
            if (replaceMap.hasOwnProperty(token)) return restoreCase(word, replaceMap[token]);
            // Run all the rules against the word.
            return sanitizeWord(token, word, rules);
        };
    }
    /**
   * Check if a word is part of the map.
   */ function checkWord(replaceMap, keepMap, rules, bool) {
        return function(word) {
            var token = word.toLowerCase();
            if (keepMap.hasOwnProperty(token)) return true;
            if (replaceMap.hasOwnProperty(token)) return false;
            return sanitizeWord(token, token, rules) === token;
        };
    }
    /**
   * Pluralize or singularize a word based on the passed in count.
   *
   * @param  {string}  word      The word to pluralize
   * @param  {number}  count     How many of the word exist
   * @param  {boolean} inclusive Whether to prefix with the number (e.g. 3 ducks)
   * @return {string}
   */ function pluralize(word, count, inclusive) {
        var pluralized = count === 1 ? pluralize.singular(word) : pluralize.plural(word);
        return (inclusive ? count + " " : "") + pluralized;
    }
    /**
   * Pluralize a word.
   *
   * @type {Function}
   */ pluralize.plural = replaceWord(irregularSingles, irregularPlurals, pluralRules);
    /**
   * Check if a word is plural.
   *
   * @type {Function}
   */ pluralize.isPlural = checkWord(irregularSingles, irregularPlurals, pluralRules);
    /**
   * Singularize a word.
   *
   * @type {Function}
   */ pluralize.singular = replaceWord(irregularPlurals, irregularSingles, singularRules);
    /**
   * Check if a word is singular.
   *
   * @type {Function}
   */ pluralize.isSingular = checkWord(irregularPlurals, irregularSingles, singularRules);
    /**
   * Add a pluralization rule to the collection.
   *
   * @param {(string|RegExp)} rule
   * @param {string}          replacement
   */ pluralize.addPluralRule = function(rule, replacement) {
        pluralRules.push([
            sanitizeRule(rule),
            replacement
        ]);
    };
    /**
   * Add a singularization rule to the collection.
   *
   * @param {(string|RegExp)} rule
   * @param {string}          replacement
   */ pluralize.addSingularRule = function(rule, replacement) {
        singularRules.push([
            sanitizeRule(rule),
            replacement
        ]);
    };
    /**
   * Add an uncountable word rule.
   *
   * @param {(string|RegExp)} word
   */ pluralize.addUncountableRule = function(word) {
        if (typeof word === "string") {
            uncountables[word.toLowerCase()] = true;
            return;
        }
        // Set singular and plural references for the word.
        pluralize.addPluralRule(word, "$0");
        pluralize.addSingularRule(word, "$0");
    };
    /**
   * Add an irregular word definition.
   *
   * @param {string} single
   * @param {string} plural
   */ pluralize.addIrregularRule = function(single, plural) {
        plural = plural.toLowerCase();
        single = single.toLowerCase();
        irregularSingles[single] = plural;
        irregularPlurals[plural] = single;
    };
    /**
   * Irregular rules.
   */ [
        // Pronouns.
        [
            "I",
            "we"
        ],
        [
            "me",
            "us"
        ],
        [
            "he",
            "they"
        ],
        [
            "she",
            "they"
        ],
        [
            "them",
            "them"
        ],
        [
            "myself",
            "ourselves"
        ],
        [
            "yourself",
            "yourselves"
        ],
        [
            "itself",
            "themselves"
        ],
        [
            "herself",
            "themselves"
        ],
        [
            "himself",
            "themselves"
        ],
        [
            "themself",
            "themselves"
        ],
        [
            "is",
            "are"
        ],
        [
            "was",
            "were"
        ],
        [
            "has",
            "have"
        ],
        [
            "this",
            "these"
        ],
        [
            "that",
            "those"
        ],
        // Words ending in with a consonant and `o`.
        [
            "echo",
            "echoes"
        ],
        [
            "dingo",
            "dingoes"
        ],
        [
            "volcano",
            "volcanoes"
        ],
        [
            "tornado",
            "tornadoes"
        ],
        [
            "torpedo",
            "torpedoes"
        ],
        // Ends with `us`.
        [
            "genus",
            "genera"
        ],
        [
            "viscus",
            "viscera"
        ],
        // Ends with `ma`.
        [
            "stigma",
            "stigmata"
        ],
        [
            "stoma",
            "stomata"
        ],
        [
            "dogma",
            "dogmata"
        ],
        [
            "lemma",
            "lemmata"
        ],
        [
            "schema",
            "schemata"
        ],
        [
            "anathema",
            "anathemata"
        ],
        // Other irregular rules.
        [
            "ox",
            "oxen"
        ],
        [
            "axe",
            "axes"
        ],
        [
            "die",
            "dice"
        ],
        [
            "yes",
            "yeses"
        ],
        [
            "foot",
            "feet"
        ],
        [
            "eave",
            "eaves"
        ],
        [
            "goose",
            "geese"
        ],
        [
            "tooth",
            "teeth"
        ],
        [
            "quiz",
            "quizzes"
        ],
        [
            "human",
            "humans"
        ],
        [
            "proof",
            "proofs"
        ],
        [
            "carve",
            "carves"
        ],
        [
            "valve",
            "valves"
        ],
        [
            "looey",
            "looies"
        ],
        [
            "thief",
            "thieves"
        ],
        [
            "groove",
            "grooves"
        ],
        [
            "pickaxe",
            "pickaxes"
        ],
        [
            "passerby",
            "passersby"
        ]
    ].forEach(function(rule) {
        return pluralize.addIrregularRule(rule[0], rule[1]);
    });
    /**
   * Pluralization rules.
   */ [
        [
            /s?$/i,
            "s"
        ],
        [
            /[^\u0000-\u007F]$/i,
            "$0"
        ],
        [
            /([^aeiou]ese)$/i,
            "$1"
        ],
        [
            /(ax|test)is$/i,
            "$1es"
        ],
        [
            /(alias|[^aou]us|t[lm]as|gas|ris)$/i,
            "$1es"
        ],
        [
            /(e[mn]u)s?$/i,
            "$1s"
        ],
        [
            /([^l]ias|[aeiou]las|[ejzr]as|[iu]am)$/i,
            "$1"
        ],
        [
            /(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i,
            "$1i"
        ],
        [
            /(alumn|alg|vertebr)(?:a|ae)$/i,
            "$1ae"
        ],
        [
            /(seraph|cherub)(?:im)?$/i,
            "$1im"
        ],
        [
            /(her|at|gr)o$/i,
            "$1oes"
        ],
        [
            /(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i,
            "$1a"
        ],
        [
            /(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i,
            "$1a"
        ],
        [
            /sis$/i,
            "ses"
        ],
        [
            /(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i,
            "$1$2ves"
        ],
        [
            /([^aeiouy]|qu)y$/i,
            "$1ies"
        ],
        [
            /([^ch][ieo][ln])ey$/i,
            "$1ies"
        ],
        [
            /(x|ch|ss|sh|zz)$/i,
            "$1es"
        ],
        [
            /(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i,
            "$1ices"
        ],
        [
            /\b((?:tit)?m|l)(?:ice|ouse)$/i,
            "$1ice"
        ],
        [
            /(pe)(?:rson|ople)$/i,
            "$1ople"
        ],
        [
            /(child)(?:ren)?$/i,
            "$1ren"
        ],
        [
            /eaux$/i,
            "$0"
        ],
        [
            /m[ae]n$/i,
            "men"
        ],
        [
            "thou",
            "you"
        ]
    ].forEach(function(rule) {
        return pluralize.addPluralRule(rule[0], rule[1]);
    });
    /**
   * Singularization rules.
   */ [
        [
            /s$/i,
            ""
        ],
        [
            /(ss)$/i,
            "$1"
        ],
        [
            /(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i,
            "$1fe"
        ],
        [
            /(ar|(?:wo|[ae])l|[eo][ao])ves$/i,
            "$1f"
        ],
        [
            /ies$/i,
            "y"
        ],
        [
            /\b([pl]|zomb|(?:neck|cross)?t|coll|faer|food|gen|goon|group|lass|talk|goal|cut)ies$/i,
            "$1ie"
        ],
        [
            /\b(mon|smil)ies$/i,
            "$1ey"
        ],
        [
            /\b((?:tit)?m|l)ice$/i,
            "$1ouse"
        ],
        [
            /(seraph|cherub)im$/i,
            "$1"
        ],
        [
            /(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|t[lm]as|gas|(?:her|at|gr)o|[aeiou]ris)(?:es)?$/i,
            "$1"
        ],
        [
            /(analy|diagno|parenthe|progno|synop|the|empha|cri|ne)(?:sis|ses)$/i,
            "$1sis"
        ],
        [
            /(movie|twelve|abuse|e[mn]u)s$/i,
            "$1"
        ],
        [
            /(test)(?:is|es)$/i,
            "$1is"
        ],
        [
            /(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i,
            "$1us"
        ],
        [
            /(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i,
            "$1um"
        ],
        [
            /(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i,
            "$1on"
        ],
        [
            /(alumn|alg|vertebr)ae$/i,
            "$1a"
        ],
        [
            /(cod|mur|sil|vert|ind)ices$/i,
            "$1ex"
        ],
        [
            /(matr|append)ices$/i,
            "$1ix"
        ],
        [
            /(pe)(rson|ople)$/i,
            "$1rson"
        ],
        [
            /(child)ren$/i,
            "$1"
        ],
        [
            /(eau)x?$/i,
            "$1"
        ],
        [
            /men$/i,
            "man"
        ]
    ].forEach(function(rule) {
        return pluralize.addSingularRule(rule[0], rule[1]);
    });
    /**
   * Uncountable rules.
   */ [
        // Singular words with no plurals.
        "adulthood",
        "advice",
        "agenda",
        "aid",
        "aircraft",
        "alcohol",
        "ammo",
        "analytics",
        "anime",
        "athletics",
        "audio",
        "bison",
        "blood",
        "bream",
        "buffalo",
        "butter",
        "carp",
        "cash",
        "chassis",
        "chess",
        "clothing",
        "cod",
        "commerce",
        "cooperation",
        "corps",
        "debris",
        "diabetes",
        "digestion",
        "elk",
        "energy",
        "equipment",
        "excretion",
        "expertise",
        "firmware",
        "flounder",
        "fun",
        "gallows",
        "garbage",
        "graffiti",
        "hardware",
        "headquarters",
        "health",
        "herpes",
        "highjinks",
        "homework",
        "housework",
        "information",
        "jeans",
        "justice",
        "kudos",
        "labour",
        "literature",
        "machinery",
        "mackerel",
        "mail",
        "media",
        "mews",
        "moose",
        "music",
        "mud",
        "manga",
        "news",
        "only",
        "personnel",
        "pike",
        "plankton",
        "pliers",
        "police",
        "pollution",
        "premises",
        "rain",
        "research",
        "rice",
        "salmon",
        "scissors",
        "series",
        "sewage",
        "shambles",
        "shrimp",
        "software",
        "species",
        "staff",
        "swine",
        "tennis",
        "traffic",
        "transportation",
        "trout",
        "tuna",
        "wealth",
        "welfare",
        "whiting",
        "wildebeest",
        "wildlife",
        "you",
        /pok[eé]mon$/i,
        // Regexes.
        /[^aeiou]ese$/i,
        /deer$/i,
        /fish$/i,
        /measles$/i,
        /o[iu]s$/i,
        /pox$/i,
        /sheep$/i
    ].forEach(pluralize.addUncountableRule);
    return pluralize;
});

});

parcelRegister("3PpOX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c9a2a07c197495b$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $gN0TC = parcelRequire("gN0TC");
parcelRequire("eat5C");


var $72ezo = parcelRequire("72ezo");

var $4hBm1 = parcelRequire("4hBm1");

var $fopU6 = parcelRequire("fopU6");
var $2c9a2a07c197495b$var$_dec, $2c9a2a07c197495b$var$_dec2, $2c9a2a07c197495b$var$_dec3, $2c9a2a07c197495b$var$_dec4, $2c9a2a07c197495b$var$_dec5, $2c9a2a07c197495b$var$_dec6, $2c9a2a07c197495b$var$_class, $2c9a2a07c197495b$var$_descriptor, $2c9a2a07c197495b$var$_descriptor2, $2c9a2a07c197495b$var$_descriptor3, $2c9a2a07c197495b$var$_descriptor4, $2c9a2a07c197495b$var$_descriptor5, $2c9a2a07c197495b$var$_descriptor6, $2c9a2a07c197495b$var$_descriptor7, $2c9a2a07c197495b$var$_descriptor8, $2c9a2a07c197495b$var$_descriptor9;
function $2c9a2a07c197495b$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $2c9a2a07c197495b$var$_defineProperty(e, r, t) {
    return (r = $2c9a2a07c197495b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $2c9a2a07c197495b$var$_toPropertyKey(t) {
    var i = $2c9a2a07c197495b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $2c9a2a07c197495b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $2c9a2a07c197495b$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $2c9a2a07c197495b$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $2c9a2a07c197495b$var$Model = ($2c9a2a07c197495b$var$_dec = (0, $4JcCM.action).bound, $2c9a2a07c197495b$var$_dec2 = (0, $4JcCM.action).bound, $2c9a2a07c197495b$var$_dec3 = (0, $4JcCM.action).bound, $2c9a2a07c197495b$var$_dec4 = (0, $4JcCM.action).bound, $2c9a2a07c197495b$var$_dec5 = (0, $4JcCM.action).bound, $2c9a2a07c197495b$var$_dec6 = (0, $4JcCM.action).bound, $2c9a2a07c197495b$var$_class = class Model {
    constructor(){
        $2c9a2a07c197495b$var$_initializerDefineProperty(this, "id", $2c9a2a07c197495b$var$_descriptor, this);
        $2c9a2a07c197495b$var$_initializerDefineProperty(this, "savedAt", $2c9a2a07c197495b$var$_descriptor2, this);
        $2c9a2a07c197495b$var$_initializerDefineProperty(this, "updatedAt", $2c9a2a07c197495b$var$_descriptor3, this);
        $2c9a2a07c197495b$var$_initializerDefineProperty(this, "deletedAt", $2c9a2a07c197495b$var$_descriptor4, this);
        $2c9a2a07c197495b$var$_initializerDefineProperty(this, "updateHistory", $2c9a2a07c197495b$var$_descriptor5, this);
        $2c9a2a07c197495b$var$_initializerDefineProperty(this, "initialized", $2c9a2a07c197495b$var$_descriptor6, this);
        $2c9a2a07c197495b$var$_initializerDefineProperty(this, "history", $2c9a2a07c197495b$var$_descriptor7, this);
        $2c9a2a07c197495b$var$_initializerDefineProperty(this, "detached", $2c9a2a07c197495b$var$_descriptor8, this);
        $2c9a2a07c197495b$var$_initializerDefineProperty(this, "failedToSave", $2c9a2a07c197495b$var$_descriptor9, this);
        $2c9a2a07c197495b$var$_defineProperty(this, "collection", null);
        $2c9a2a07c197495b$var$_defineProperty(this, "createdAt", null);
        $2c9a2a07c197495b$var$_defineProperty(this, "deletedAt", null);
        $2c9a2a07c197495b$var$_defineProperty(this, "initiatedAt", new Date());
        (0, $4JcCM.makeObservable)(this);
    }
    init(data, options = {}) {
        var _data$id, _options$detached;
        data = data instanceof Model ? data.serialize() : data;
        this.id = (_data$id = data.id) !== null && _data$id !== void 0 ? _data$id : this.id;
        this.savedAt = !options.trackUpdates ? this.updatedAt : null;
        this.detached = (_options$detached = options.detached) !== null && _options$detached !== void 0 ? _options$detached : false;
        this.update(data, {
            trackUpdates: false,
            source: "self",
            ...options
        });
        this.initialized = true;
    }
    get modelType() {
        return this.collection.modelType;
    }
    update(data, { trackUpdates: trackUpdates = true, savedAt: savedAt, source: source } = {}) {
        data = data instanceof Model ? data.serialize() : data;
        if (savedAt) {
            this.savedAt = savedAt;
            this.createdAt || (this.createdAt = new Date());
            //TODO this is bad
            for (const ts of this.updateHistory.keys())if (ts < savedAt) this.updateHistory.delete(ts);
        }
        for (const [key, value] of Object.entries(data))if (trackUpdates || source !== "collection" && source !== "self" || !this.updatedProps.has(key)) this.changeProp(key, value, {
            trackUpdates: trackUpdates
        });
        if (!this.detached && source !== "collection" && source !== "self" && this.collection.onUpdate) this.collection.onUpdate(this.id);
        if (!this.createdAt && this.deletedAt) this.collection.delete(this.id);
    }
    changeProp(prop, val, { trackUpdates: trackUpdates = true } = {}) {
        if (prop === "history") {
            this.history = val.map((e)=>new (0, $fopU6.default)(this, e));
            return;
        }
        if ((prop.toLowerCase().includes("date") || prop.endsWith("At")) && val && !(val instanceof Date)) val = isNaN(new Date(val)) ? (0, $4hBm1.parse)(val, "yyyy-MM-dd", new Date()) : (0, $4hBm1.startOfDay)(new Date(val));
        // Check if the property is not present in the current instance and add it as an observable
        if (!this.hasOwnProperty(prop) && !(0, $4JcCM.isComputedProp)(this, prop)) (0, $4JcCM.extendObservable)(this, {
            [prop]: val
        });
        else this[((0, $4JcCM.isComputedProp)(this, prop) ? "_" : "") + prop] = val;
        if (trackUpdates) {
            this.updatedAt = new Date();
            if (!this.updateHistory.has(this.updatedAt)) this.updateHistory.set(this.updatedAt, []);
            this.updateHistory.get(this.updatedAt).push(prop);
        }
    }
    get updatedProps() {
        return new Set([
            ...this.updateHistory.values()
        ].flat().filter((prop)=>![
                "collection",
                "detached",
                "failedToSave",
                "initiatedAt"
            ].includes(prop)));
    }
    get latestUpdatedTime() {
        return [
            ...this.updateHistory.keys()
        ].sort().reverse()[0];
    }
    serialize() {
        let serialized = (0, $72ezo.default).serialize(Object.fromEntries((0, $4JcCM.entries)(this).filter((e)=>![
                "savedAt",
                "updateHistory",
                "initialized"
            ].includes(e[0])).map((e)=>{
            if (e[0].includes("Id") && e[1] == null) {
                var _this$e$0$replace;
                return [
                    e[0],
                    (_this$e$0$replace = this[e[0].replace("Id", "")]) === null || _this$e$0$replace === void 0 ? void 0 : _this$e$0$replace.id
                ];
            }
            return e;
        }))).json;
        if (!this.createdAt) serialized.createdAt = (0, $4hBm1.format)(this.initiatedAt, "yyyy-MM-dd HH:mm:ss");
        return serialized;
    }
    // Properties that should never be serialized - can be overridden by subclasses
    get excludeFromSerialization() {
        return [
            "tableStore",
            // UI table state - causes circular references
            "searchFilter",
            // Temporary UI search state
            "queryKey",
            // Computed/cached value for change detection
            "_rows",
            // Internal table state
            "_columns",
            // Internal table state
            "collection",
            // Model relationship - can cause circular refs
            "store",
            // Store reference - can cause circular refs
            "parent",
            // Parent reference - can cause circular refs
            "debouncedSetQueryKey",
            // Function reference
            "updateHistory",
            // Internal tracking
            "history",
            // Can be large and contains circular refs
            "initialized",
            // Internal state
            "detached",
            // Internal state
            "failedToSave" // Internal state
        ];
    }
    serializeUpdates() {
        const excludeSet = new Set(this.excludeFromSerialization);
        let serialized = (0, $72ezo.default).serialize(Object.fromEntries([
            [
                "id",
                this.id
            ],
            ...[
                ...this.updatedProps
            ].filter((prop)=>!excludeSet.has(prop)) // Filter out excluded properties
            .map((up)=>[
                    up,
                    this[up] instanceof Date ? !isNaN(this[up].getTime()) ? (0, $4hBm1.format)(this[up], "yyyy-MM-dd") : null : this[up]
                ]).map((e)=>{
                if (e[0].includes("Id") && e[1] == null) {
                    var _this$e$0$replace2;
                    return [
                        e[0],
                        (_this$e$0$replace2 = this[e[0].replace("Id", "")]) === null || _this$e$0$replace2 === void 0 ? void 0 : _this$e$0$replace2.id
                    ];
                }
                return e;
            })
        ])).json;
        if (!this.createdAt) serialized.createdAt = (0, $4hBm1.format)(this.initiatedAt, "yyyy-MM-dd HH:mm:ss");
        return serialized;
    }
    get needsSaving() {
        return Boolean(this.updatedProps.size && this.latestUpdatedTime > this.savedAt);
    }
    clone(newData, options = {}) {
        const newId = (0, (/*@__PURE__*/$parcel$interopDefault($gN0TC)))();
        const data = {
            ...this.serialize(),
            ...newData,
            id: newId
        };
        if (!options.detached) return this.collection.add(data, options);
        else return new this.constructor(data, options);
    }
    attach() {
        if (this.detached) {
            this.collection.add(this);
            this.detached = false;
        }
    }
}, $2c9a2a07c197495b$var$_descriptor = $2c9a2a07c197495b$var$_applyDecoratedDescriptor($2c9a2a07c197495b$var$_class.prototype, "id", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($gN0TC)))();
    }
}), $2c9a2a07c197495b$var$_descriptor2 = $2c9a2a07c197495b$var$_applyDecoratedDescriptor($2c9a2a07c197495b$var$_class.prototype, "savedAt", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $2c9a2a07c197495b$var$_descriptor3 = $2c9a2a07c197495b$var$_applyDecoratedDescriptor($2c9a2a07c197495b$var$_class.prototype, "updatedAt", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Date();
    }
}), $2c9a2a07c197495b$var$_descriptor4 = $2c9a2a07c197495b$var$_applyDecoratedDescriptor($2c9a2a07c197495b$var$_class.prototype, "deletedAt", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $2c9a2a07c197495b$var$_descriptor5 = $2c9a2a07c197495b$var$_applyDecoratedDescriptor($2c9a2a07c197495b$var$_class.prototype, "updateHistory", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Map();
    }
}), $2c9a2a07c197495b$var$_descriptor6 = $2c9a2a07c197495b$var$_applyDecoratedDescriptor($2c9a2a07c197495b$var$_class.prototype, "initialized", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $2c9a2a07c197495b$var$_descriptor7 = $2c9a2a07c197495b$var$_applyDecoratedDescriptor($2c9a2a07c197495b$var$_class.prototype, "history", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $2c9a2a07c197495b$var$_descriptor8 = $2c9a2a07c197495b$var$_applyDecoratedDescriptor($2c9a2a07c197495b$var$_class.prototype, "detached", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $2c9a2a07c197495b$var$_descriptor9 = $2c9a2a07c197495b$var$_applyDecoratedDescriptor($2c9a2a07c197495b$var$_class.prototype, "failedToSave", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $2c9a2a07c197495b$var$_applyDecoratedDescriptor($2c9a2a07c197495b$var$_class.prototype, "init", [
    $2c9a2a07c197495b$var$_dec
], Object.getOwnPropertyDescriptor($2c9a2a07c197495b$var$_class.prototype, "init"), $2c9a2a07c197495b$var$_class.prototype), $2c9a2a07c197495b$var$_applyDecoratedDescriptor($2c9a2a07c197495b$var$_class.prototype, "modelType", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($2c9a2a07c197495b$var$_class.prototype, "modelType"), $2c9a2a07c197495b$var$_class.prototype), $2c9a2a07c197495b$var$_applyDecoratedDescriptor($2c9a2a07c197495b$var$_class.prototype, "update", [
    $2c9a2a07c197495b$var$_dec2
], Object.getOwnPropertyDescriptor($2c9a2a07c197495b$var$_class.prototype, "update"), $2c9a2a07c197495b$var$_class.prototype), $2c9a2a07c197495b$var$_applyDecoratedDescriptor($2c9a2a07c197495b$var$_class.prototype, "changeProp", [
    $2c9a2a07c197495b$var$_dec3
], Object.getOwnPropertyDescriptor($2c9a2a07c197495b$var$_class.prototype, "changeProp"), $2c9a2a07c197495b$var$_class.prototype), $2c9a2a07c197495b$var$_applyDecoratedDescriptor($2c9a2a07c197495b$var$_class.prototype, "updatedProps", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($2c9a2a07c197495b$var$_class.prototype, "updatedProps"), $2c9a2a07c197495b$var$_class.prototype), $2c9a2a07c197495b$var$_applyDecoratedDescriptor($2c9a2a07c197495b$var$_class.prototype, "latestUpdatedTime", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($2c9a2a07c197495b$var$_class.prototype, "latestUpdatedTime"), $2c9a2a07c197495b$var$_class.prototype), $2c9a2a07c197495b$var$_applyDecoratedDescriptor($2c9a2a07c197495b$var$_class.prototype, "serialize", [
    $2c9a2a07c197495b$var$_dec4
], Object.getOwnPropertyDescriptor($2c9a2a07c197495b$var$_class.prototype, "serialize"), $2c9a2a07c197495b$var$_class.prototype), $2c9a2a07c197495b$var$_applyDecoratedDescriptor($2c9a2a07c197495b$var$_class.prototype, "needsSaving", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($2c9a2a07c197495b$var$_class.prototype, "needsSaving"), $2c9a2a07c197495b$var$_class.prototype), $2c9a2a07c197495b$var$_applyDecoratedDescriptor($2c9a2a07c197495b$var$_class.prototype, "clone", [
    $2c9a2a07c197495b$var$_dec5
], Object.getOwnPropertyDescriptor($2c9a2a07c197495b$var$_class.prototype, "clone"), $2c9a2a07c197495b$var$_class.prototype), $2c9a2a07c197495b$var$_applyDecoratedDescriptor($2c9a2a07c197495b$var$_class.prototype, "attach", [
    $2c9a2a07c197495b$var$_dec6
], Object.getOwnPropertyDescriptor($2c9a2a07c197495b$var$_class.prototype, "attach"), $2c9a2a07c197495b$var$_class.prototype), $2c9a2a07c197495b$var$_class);
var $2c9a2a07c197495b$export$2e2bcd8739ae039 = $2c9a2a07c197495b$var$Model;

});
parcelRegister("4hBm1", function(module, exports) {
"use strict";

var $5nIwf = parcelRequire("5nIwf");
Object.keys($5nIwf).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5nIwf[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5nIwf[key];
        }
    });
});

var $cWl2g = parcelRequire("cWl2g");
Object.keys($cWl2g).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cWl2g[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cWl2g[key];
        }
    });
});

var $qX1g7 = parcelRequire("qX1g7");
Object.keys($qX1g7).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $qX1g7[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $qX1g7[key];
        }
    });
});

var $lTL64 = parcelRequire("lTL64");
Object.keys($lTL64).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lTL64[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lTL64[key];
        }
    });
});

var $b4qzk = parcelRequire("b4qzk");
Object.keys($b4qzk).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $b4qzk[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b4qzk[key];
        }
    });
});

var $cqs47 = parcelRequire("cqs47");
Object.keys($cqs47).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cqs47[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cqs47[key];
        }
    });
});

var $h7zV9 = parcelRequire("h7zV9");
Object.keys($h7zV9).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $h7zV9[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $h7zV9[key];
        }
    });
});

var $cp3zA = parcelRequire("cp3zA");
Object.keys($cp3zA).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cp3zA[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cp3zA[key];
        }
    });
});

var $7pM9n = parcelRequire("7pM9n");
Object.keys($7pM9n).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7pM9n[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7pM9n[key];
        }
    });
});

var $boFoj = parcelRequire("boFoj");
Object.keys($boFoj).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $boFoj[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $boFoj[key];
        }
    });
});

var $6T9jK = parcelRequire("6T9jK");
Object.keys($6T9jK).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6T9jK[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6T9jK[key];
        }
    });
});

var $1afNH = parcelRequire("1afNH");
Object.keys($1afNH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1afNH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1afNH[key];
        }
    });
});

var $dIV2o = parcelRequire("dIV2o");
Object.keys($dIV2o).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dIV2o[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dIV2o[key];
        }
    });
});

var $03Tlq = parcelRequire("03Tlq");
Object.keys($03Tlq).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $03Tlq[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $03Tlq[key];
        }
    });
});

var $9mtbp = parcelRequire("9mtbp");
Object.keys($9mtbp).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9mtbp[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9mtbp[key];
        }
    });
});

var $ic8Ws = parcelRequire("ic8Ws");
Object.keys($ic8Ws).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ic8Ws[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ic8Ws[key];
        }
    });
});

var $3SXyf = parcelRequire("3SXyf");
Object.keys($3SXyf).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3SXyf[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3SXyf[key];
        }
    });
});

var $4rMqp = parcelRequire("4rMqp");
Object.keys($4rMqp).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4rMqp[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4rMqp[key];
        }
    });
});

var $909bC = parcelRequire("909bC");
Object.keys($909bC).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $909bC[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $909bC[key];
        }
    });
});

var $hubi5 = parcelRequire("hubi5");
Object.keys($hubi5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hubi5[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hubi5[key];
        }
    });
});

var $giA6z = parcelRequire("giA6z");
Object.keys($giA6z).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $giA6z[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $giA6z[key];
        }
    });
});

var $8pZAP = parcelRequire("8pZAP");
Object.keys($8pZAP).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8pZAP[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8pZAP[key];
        }
    });
});

var $ctsEq = parcelRequire("ctsEq");
Object.keys($ctsEq).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ctsEq[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ctsEq[key];
        }
    });
});

var $1CHw4 = parcelRequire("1CHw4");
Object.keys($1CHw4).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1CHw4[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1CHw4[key];
        }
    });
});

var $b8myz = parcelRequire("b8myz");
Object.keys($b8myz).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $b8myz[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b8myz[key];
        }
    });
});

var $ecPWs = parcelRequire("ecPWs");
Object.keys($ecPWs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ecPWs[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ecPWs[key];
        }
    });
});

var $4Ccub = parcelRequire("4Ccub");
Object.keys($4Ccub).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4Ccub[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4Ccub[key];
        }
    });
});

var $7pWjY = parcelRequire("7pWjY");
Object.keys($7pWjY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7pWjY[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7pWjY[key];
        }
    });
});

var $dQFcH = parcelRequire("dQFcH");
Object.keys($dQFcH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dQFcH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dQFcH[key];
        }
    });
});

var $h7pQw = parcelRequire("h7pQw");
Object.keys($h7pQw).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $h7pQw[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $h7pQw[key];
        }
    });
});

var $2ORBN = parcelRequire("2ORBN");
Object.keys($2ORBN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2ORBN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2ORBN[key];
        }
    });
});

var $kFLdB = parcelRequire("kFLdB");
Object.keys($kFLdB).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kFLdB[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kFLdB[key];
        }
    });
});

var $46Qms = parcelRequire("46Qms");
Object.keys($46Qms).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $46Qms[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $46Qms[key];
        }
    });
});

var $5luLe = parcelRequire("5luLe");
Object.keys($5luLe).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5luLe[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5luLe[key];
        }
    });
});

var $6GN1F = parcelRequire("6GN1F");
Object.keys($6GN1F).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6GN1F[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6GN1F[key];
        }
    });
});

var $l9Hdw = parcelRequire("l9Hdw");
Object.keys($l9Hdw).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $l9Hdw[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $l9Hdw[key];
        }
    });
});

var $cTY1w = parcelRequire("cTY1w");
Object.keys($cTY1w).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cTY1w[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cTY1w[key];
        }
    });
});

var $3B2JB = parcelRequire("3B2JB");
Object.keys($3B2JB).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3B2JB[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3B2JB[key];
        }
    });
});

var $f6fMN = parcelRequire("f6fMN");
Object.keys($f6fMN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $f6fMN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $f6fMN[key];
        }
    });
});

var $64nK0 = parcelRequire("64nK0");
Object.keys($64nK0).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $64nK0[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $64nK0[key];
        }
    });
});

var $b2bJT = parcelRequire("b2bJT");
Object.keys($b2bJT).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $b2bJT[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b2bJT[key];
        }
    });
});

var $e6hcg = parcelRequire("e6hcg");
Object.keys($e6hcg).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $e6hcg[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $e6hcg[key];
        }
    });
});

var $5N5lh = parcelRequire("5N5lh");
Object.keys($5N5lh).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5N5lh[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5N5lh[key];
        }
    });
});

var $bRY2p = parcelRequire("bRY2p");
Object.keys($bRY2p).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bRY2p[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bRY2p[key];
        }
    });
});

var $doqTC = parcelRequire("doqTC");
Object.keys($doqTC).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $doqTC[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $doqTC[key];
        }
    });
});

var $8VtqC = parcelRequire("8VtqC");
Object.keys($8VtqC).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8VtqC[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8VtqC[key];
        }
    });
});

var $251R7 = parcelRequire("251R7");
Object.keys($251R7).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $251R7[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $251R7[key];
        }
    });
});

var $LOK4f = parcelRequire("LOK4f");
Object.keys($LOK4f).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $LOK4f[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $LOK4f[key];
        }
    });
});

var $iXq1H = parcelRequire("iXq1H");
Object.keys($iXq1H).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iXq1H[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iXq1H[key];
        }
    });
});

var $6Fi1I = parcelRequire("6Fi1I");
Object.keys($6Fi1I).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6Fi1I[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6Fi1I[key];
        }
    });
});

var $d6Bdx = parcelRequire("d6Bdx");
Object.keys($d6Bdx).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $d6Bdx[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d6Bdx[key];
        }
    });
});

var $jaOcI = parcelRequire("jaOcI");
Object.keys($jaOcI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jaOcI[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jaOcI[key];
        }
    });
});

var $5EHXL = parcelRequire("5EHXL");
Object.keys($5EHXL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5EHXL[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5EHXL[key];
        }
    });
});

var $dUv6m = parcelRequire("dUv6m");
Object.keys($dUv6m).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dUv6m[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dUv6m[key];
        }
    });
});

var $eQU1v = parcelRequire("eQU1v");
Object.keys($eQU1v).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eQU1v[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eQU1v[key];
        }
    });
});

var $jrtnH = parcelRequire("jrtnH");
Object.keys($jrtnH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jrtnH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jrtnH[key];
        }
    });
});

var $3VuY5 = parcelRequire("3VuY5");
Object.keys($3VuY5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3VuY5[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3VuY5[key];
        }
    });
});

var $8c1Nz = parcelRequire("8c1Nz");
Object.keys($8c1Nz).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8c1Nz[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8c1Nz[key];
        }
    });
});

var $dLvMH = parcelRequire("dLvMH");
Object.keys($dLvMH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dLvMH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dLvMH[key];
        }
    });
});

var $1dT5W = parcelRequire("1dT5W");
Object.keys($1dT5W).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1dT5W[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1dT5W[key];
        }
    });
});

var $kBOpH = parcelRequire("kBOpH");
Object.keys($kBOpH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kBOpH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kBOpH[key];
        }
    });
});

var $jVy78 = parcelRequire("jVy78");
Object.keys($jVy78).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jVy78[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jVy78[key];
        }
    });
});

var $4Aqkh = parcelRequire("4Aqkh");
Object.keys($4Aqkh).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4Aqkh[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4Aqkh[key];
        }
    });
});

var $jnWO3 = parcelRequire("jnWO3");
Object.keys($jnWO3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jnWO3[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jnWO3[key];
        }
    });
});

var $jJcxl = parcelRequire("jJcxl");
Object.keys($jJcxl).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jJcxl[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jJcxl[key];
        }
    });
});

var $cPvSy = parcelRequire("cPvSy");
Object.keys($cPvSy).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cPvSy[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cPvSy[key];
        }
    });
});

var $37NBl = parcelRequire("37NBl");
Object.keys($37NBl).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $37NBl[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $37NBl[key];
        }
    });
});

var $gP6I8 = parcelRequire("gP6I8");
Object.keys($gP6I8).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gP6I8[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gP6I8[key];
        }
    });
});

var $kQSmd = parcelRequire("kQSmd");
Object.keys($kQSmd).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kQSmd[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kQSmd[key];
        }
    });
});

var $7Xr3B = parcelRequire("7Xr3B");
Object.keys($7Xr3B).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7Xr3B[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7Xr3B[key];
        }
    });
});

var $hqDGb = parcelRequire("hqDGb");
Object.keys($hqDGb).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hqDGb[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hqDGb[key];
        }
    });
});

var $my1Oj = parcelRequire("my1Oj");
Object.keys($my1Oj).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $my1Oj[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $my1Oj[key];
        }
    });
});

var $bAugd = parcelRequire("bAugd");
Object.keys($bAugd).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bAugd[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bAugd[key];
        }
    });
});

var $5VYHl = parcelRequire("5VYHl");
Object.keys($5VYHl).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5VYHl[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5VYHl[key];
        }
    });
});

var $aIT4W = parcelRequire("aIT4W");
Object.keys($aIT4W).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aIT4W[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aIT4W[key];
        }
    });
});

var $a1Z0s = parcelRequire("a1Z0s");
Object.keys($a1Z0s).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $a1Z0s[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $a1Z0s[key];
        }
    });
});

var $3y9me = parcelRequire("3y9me");
Object.keys($3y9me).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3y9me[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3y9me[key];
        }
    });
});

var $zkIQr = parcelRequire("zkIQr");
Object.keys($zkIQr).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $zkIQr[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $zkIQr[key];
        }
    });
});

var $fgg0C = parcelRequire("fgg0C");
Object.keys($fgg0C).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fgg0C[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fgg0C[key];
        }
    });
});

var $4bDiJ = parcelRequire("4bDiJ");
Object.keys($4bDiJ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4bDiJ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4bDiJ[key];
        }
    });
});

var $02Gfq = parcelRequire("02Gfq");
Object.keys($02Gfq).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $02Gfq[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $02Gfq[key];
        }
    });
});

var $9bUFZ = parcelRequire("9bUFZ");
Object.keys($9bUFZ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9bUFZ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9bUFZ[key];
        }
    });
});

var $j7GAC = parcelRequire("j7GAC");
Object.keys($j7GAC).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $j7GAC[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $j7GAC[key];
        }
    });
});

var $cVs37 = parcelRequire("cVs37");
Object.keys($cVs37).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cVs37[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cVs37[key];
        }
    });
});

var $eE1JP = parcelRequire("eE1JP");
Object.keys($eE1JP).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eE1JP[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eE1JP[key];
        }
    });
});

var $cuHcL = parcelRequire("cuHcL");
Object.keys($cuHcL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cuHcL[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cuHcL[key];
        }
    });
});

var $4j6Nm = parcelRequire("4j6Nm");
Object.keys($4j6Nm).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4j6Nm[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4j6Nm[key];
        }
    });
});

var $d6ILE = parcelRequire("d6ILE");
Object.keys($d6ILE).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $d6ILE[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d6ILE[key];
        }
    });
});

var $7I8wB = parcelRequire("7I8wB");
Object.keys($7I8wB).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7I8wB[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7I8wB[key];
        }
    });
});

var $4qrOP = parcelRequire("4qrOP");
Object.keys($4qrOP).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4qrOP[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4qrOP[key];
        }
    });
});

var $c52MN = parcelRequire("c52MN");
Object.keys($c52MN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $c52MN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $c52MN[key];
        }
    });
});

var $3ljvc = parcelRequire("3ljvc");
Object.keys($3ljvc).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3ljvc[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3ljvc[key];
        }
    });
});

var $aVDAA = parcelRequire("aVDAA");
Object.keys($aVDAA).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aVDAA[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aVDAA[key];
        }
    });
});

var $14cI0 = parcelRequire("14cI0");
Object.keys($14cI0).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $14cI0[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $14cI0[key];
        }
    });
});

var $iXT0v = parcelRequire("iXT0v");
Object.keys($iXT0v).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iXT0v[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iXT0v[key];
        }
    });
});

var $5eEAU = parcelRequire("5eEAU");
Object.keys($5eEAU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5eEAU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5eEAU[key];
        }
    });
});

var $5SW4K = parcelRequire("5SW4K");
Object.keys($5SW4K).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5SW4K[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5SW4K[key];
        }
    });
});

var $7zFKO = parcelRequire("7zFKO");
Object.keys($7zFKO).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7zFKO[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7zFKO[key];
        }
    });
});

var $bIuXj = parcelRequire("bIuXj");
Object.keys($bIuXj).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bIuXj[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bIuXj[key];
        }
    });
});

var $1zhi2 = parcelRequire("1zhi2");
Object.keys($1zhi2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1zhi2[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1zhi2[key];
        }
    });
});

var $b1qKz = parcelRequire("b1qKz");
Object.keys($b1qKz).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $b1qKz[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b1qKz[key];
        }
    });
});

var $1eSL9 = parcelRequire("1eSL9");
Object.keys($1eSL9).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1eSL9[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1eSL9[key];
        }
    });
});

var $i9Pv6 = parcelRequire("i9Pv6");
Object.keys($i9Pv6).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $i9Pv6[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $i9Pv6[key];
        }
    });
});

var $hx11D = parcelRequire("hx11D");
Object.keys($hx11D).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hx11D[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hx11D[key];
        }
    });
});

var $fsLNk = parcelRequire("fsLNk");
Object.keys($fsLNk).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fsLNk[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fsLNk[key];
        }
    });
});

var $eCLGc = parcelRequire("eCLGc");
Object.keys($eCLGc).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eCLGc[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eCLGc[key];
        }
    });
});

var $hX9VQ = parcelRequire("hX9VQ");
Object.keys($hX9VQ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hX9VQ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hX9VQ[key];
        }
    });
});

var $3nqVd = parcelRequire("3nqVd");
Object.keys($3nqVd).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3nqVd[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3nqVd[key];
        }
    });
});

var $6GQne = parcelRequire("6GQne");
Object.keys($6GQne).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6GQne[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6GQne[key];
        }
    });
});

var $4GY2F = parcelRequire("4GY2F");
Object.keys($4GY2F).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4GY2F[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4GY2F[key];
        }
    });
});

var $ho7Sg = parcelRequire("ho7Sg");
Object.keys($ho7Sg).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ho7Sg[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ho7Sg[key];
        }
    });
});

var $2Wb8M = parcelRequire("2Wb8M");
Object.keys($2Wb8M).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2Wb8M[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2Wb8M[key];
        }
    });
});

var $4EZlQ = parcelRequire("4EZlQ");
Object.keys($4EZlQ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4EZlQ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4EZlQ[key];
        }
    });
});

var $dvSdP = parcelRequire("dvSdP");
Object.keys($dvSdP).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dvSdP[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dvSdP[key];
        }
    });
});

var $i88NH = parcelRequire("i88NH");
Object.keys($i88NH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $i88NH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $i88NH[key];
        }
    });
});

var $fiRVK = parcelRequire("fiRVK");
Object.keys($fiRVK).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fiRVK[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fiRVK[key];
        }
    });
});

var $4qcp8 = parcelRequire("4qcp8");
Object.keys($4qcp8).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4qcp8[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4qcp8[key];
        }
    });
});

var $8VWnL = parcelRequire("8VWnL");
Object.keys($8VWnL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8VWnL[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8VWnL[key];
        }
    });
});

var $6tLS8 = parcelRequire("6tLS8");
Object.keys($6tLS8).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6tLS8[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6tLS8[key];
        }
    });
});

var $i7g4S = parcelRequire("i7g4S");
Object.keys($i7g4S).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $i7g4S[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $i7g4S[key];
        }
    });
});

var $ld6jB = parcelRequire("ld6jB");
Object.keys($ld6jB).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ld6jB[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ld6jB[key];
        }
    });
});

var $8doT3 = parcelRequire("8doT3");
Object.keys($8doT3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8doT3[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8doT3[key];
        }
    });
});

var $dFpNK = parcelRequire("dFpNK");
Object.keys($dFpNK).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dFpNK[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dFpNK[key];
        }
    });
});

var $1exmu = parcelRequire("1exmu");
Object.keys($1exmu).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1exmu[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1exmu[key];
        }
    });
});

var $jCNPh = parcelRequire("jCNPh");
Object.keys($jCNPh).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jCNPh[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jCNPh[key];
        }
    });
});

var $cwBMW = parcelRequire("cwBMW");
Object.keys($cwBMW).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cwBMW[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cwBMW[key];
        }
    });
});

var $4pr1S = parcelRequire("4pr1S");
Object.keys($4pr1S).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4pr1S[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4pr1S[key];
        }
    });
});

var $gx9VE = parcelRequire("gx9VE");
Object.keys($gx9VE).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gx9VE[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gx9VE[key];
        }
    });
});

var $4jSGi = parcelRequire("4jSGi");
Object.keys($4jSGi).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4jSGi[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4jSGi[key];
        }
    });
});

var $9VRW1 = parcelRequire("9VRW1");
Object.keys($9VRW1).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9VRW1[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9VRW1[key];
        }
    });
});

var $hyKzc = parcelRequire("hyKzc");
Object.keys($hyKzc).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hyKzc[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hyKzc[key];
        }
    });
});

var $1npC7 = parcelRequire("1npC7");
Object.keys($1npC7).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1npC7[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1npC7[key];
        }
    });
});

var $OEy34 = parcelRequire("OEy34");
Object.keys($OEy34).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $OEy34[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $OEy34[key];
        }
    });
});

var $gIvfF = parcelRequire("gIvfF");
Object.keys($gIvfF).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gIvfF[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gIvfF[key];
        }
    });
});

var $hPus8 = parcelRequire("hPus8");
Object.keys($hPus8).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hPus8[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hPus8[key];
        }
    });
});

var $jncO1 = parcelRequire("jncO1");
Object.keys($jncO1).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jncO1[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jncO1[key];
        }
    });
});

var $5U3M4 = parcelRequire("5U3M4");
Object.keys($5U3M4).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5U3M4[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5U3M4[key];
        }
    });
});

var $43TYt = parcelRequire("43TYt");
Object.keys($43TYt).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $43TYt[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $43TYt[key];
        }
    });
});

var $8k7NC = parcelRequire("8k7NC");
Object.keys($8k7NC).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8k7NC[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8k7NC[key];
        }
    });
});

var $ihXEc = parcelRequire("ihXEc");
Object.keys($ihXEc).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ihXEc[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ihXEc[key];
        }
    });
});

var $94Glt = parcelRequire("94Glt");
Object.keys($94Glt).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $94Glt[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $94Glt[key];
        }
    });
});

var $3Eg36 = parcelRequire("3Eg36");
Object.keys($3Eg36).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3Eg36[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3Eg36[key];
        }
    });
});

var $4xZrr = parcelRequire("4xZrr");
Object.keys($4xZrr).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4xZrr[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4xZrr[key];
        }
    });
});

var $9VZNf = parcelRequire("9VZNf");
Object.keys($9VZNf).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9VZNf[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9VZNf[key];
        }
    });
});

var $lDdYI = parcelRequire("lDdYI");
Object.keys($lDdYI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lDdYI[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lDdYI[key];
        }
    });
});

var $drHAt = parcelRequire("drHAt");
Object.keys($drHAt).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $drHAt[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $drHAt[key];
        }
    });
});

var $dIS7R = parcelRequire("dIS7R");
Object.keys($dIS7R).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dIS7R[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dIS7R[key];
        }
    });
});

var $2DtTD = parcelRequire("2DtTD");
Object.keys($2DtTD).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2DtTD[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2DtTD[key];
        }
    });
});

var $8mUkU = parcelRequire("8mUkU");
Object.keys($8mUkU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8mUkU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8mUkU[key];
        }
    });
});

var $1O99w = parcelRequire("1O99w");
Object.keys($1O99w).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1O99w[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1O99w[key];
        }
    });
});

var $h8Hsd = parcelRequire("h8Hsd");
Object.keys($h8Hsd).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $h8Hsd[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $h8Hsd[key];
        }
    });
});

var $84I7M = parcelRequire("84I7M");
Object.keys($84I7M).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $84I7M[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $84I7M[key];
        }
    });
});

var $3usol = parcelRequire("3usol");
Object.keys($3usol).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3usol[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3usol[key];
        }
    });
});

var $cDG7a = parcelRequire("cDG7a");
Object.keys($cDG7a).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cDG7a[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cDG7a[key];
        }
    });
});

var $33724 = parcelRequire("33724");
Object.keys($33724).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $33724[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $33724[key];
        }
    });
});

var $5YHSk = parcelRequire("5YHSk");
Object.keys($5YHSk).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5YHSk[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5YHSk[key];
        }
    });
});

var $6HfQO = parcelRequire("6HfQO");
Object.keys($6HfQO).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6HfQO[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6HfQO[key];
        }
    });
});

var $8rtOP = parcelRequire("8rtOP");
Object.keys($8rtOP).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8rtOP[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8rtOP[key];
        }
    });
});

var $bFERN = parcelRequire("bFERN");
Object.keys($bFERN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bFERN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bFERN[key];
        }
    });
});

var $dDMwg = parcelRequire("dDMwg");
Object.keys($dDMwg).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dDMwg[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dDMwg[key];
        }
    });
});

var $dcq9l = parcelRequire("dcq9l");
Object.keys($dcq9l).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dcq9l[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dcq9l[key];
        }
    });
});

var $fOBHv = parcelRequire("fOBHv");
Object.keys($fOBHv).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fOBHv[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fOBHv[key];
        }
    });
});

var $hfmry = parcelRequire("hfmry");
Object.keys($hfmry).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hfmry[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hfmry[key];
        }
    });
});

var $jB17I = parcelRequire("jB17I");
Object.keys($jB17I).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jB17I[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jB17I[key];
        }
    });
});

var $52uDc = parcelRequire("52uDc");
Object.keys($52uDc).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $52uDc[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $52uDc[key];
        }
    });
});

var $3RjiA = parcelRequire("3RjiA");
Object.keys($3RjiA).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3RjiA[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3RjiA[key];
        }
    });
});

var $avqZU = parcelRequire("avqZU");
Object.keys($avqZU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $avqZU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $avqZU[key];
        }
    });
});

var $gF4ZB = parcelRequire("gF4ZB");
Object.keys($gF4ZB).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gF4ZB[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gF4ZB[key];
        }
    });
});

var $3uPKg = parcelRequire("3uPKg");
Object.keys($3uPKg).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3uPKg[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3uPKg[key];
        }
    });
});

var $hEDXf = parcelRequire("hEDXf");
Object.keys($hEDXf).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hEDXf[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hEDXf[key];
        }
    });
});

var $4aX8d = parcelRequire("4aX8d");
Object.keys($4aX8d).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4aX8d[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4aX8d[key];
        }
    });
});

var $fGOFZ = parcelRequire("fGOFZ");
Object.keys($fGOFZ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fGOFZ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fGOFZ[key];
        }
    });
});

var $t4QMX = parcelRequire("t4QMX");
Object.keys($t4QMX).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $t4QMX[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $t4QMX[key];
        }
    });
});

var $8B15i = parcelRequire("8B15i");
Object.keys($8B15i).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8B15i[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8B15i[key];
        }
    });
});

var $64vb2 = parcelRequire("64vb2");
Object.keys($64vb2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $64vb2[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $64vb2[key];
        }
    });
});

var $3sVkc = parcelRequire("3sVkc");
Object.keys($3sVkc).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3sVkc[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3sVkc[key];
        }
    });
});

var $4Z831 = parcelRequire("4Z831");
Object.keys($4Z831).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4Z831[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4Z831[key];
        }
    });
});

var $7TnYs = parcelRequire("7TnYs");
Object.keys($7TnYs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7TnYs[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7TnYs[key];
        }
    });
});

var $joJia = parcelRequire("joJia");
Object.keys($joJia).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $joJia[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $joJia[key];
        }
    });
});

var $aOkIn = parcelRequire("aOkIn");
Object.keys($aOkIn).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aOkIn[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aOkIn[key];
        }
    });
});

var $kp1Yf = parcelRequire("kp1Yf");
Object.keys($kp1Yf).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kp1Yf[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kp1Yf[key];
        }
    });
});

var $1Gn5j = parcelRequire("1Gn5j");
Object.keys($1Gn5j).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1Gn5j[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1Gn5j[key];
        }
    });
});

var $hDpza = parcelRequire("hDpza");
Object.keys($hDpza).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hDpza[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hDpza[key];
        }
    });
});

var $fTn29 = parcelRequire("fTn29");
Object.keys($fTn29).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fTn29[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fTn29[key];
        }
    });
});

var $auSWR = parcelRequire("auSWR");
Object.keys($auSWR).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $auSWR[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $auSWR[key];
        }
    });
});

var $ec7I5 = parcelRequire("ec7I5");
Object.keys($ec7I5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ec7I5[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ec7I5[key];
        }
    });
});

var $fzt5u = parcelRequire("fzt5u");
Object.keys($fzt5u).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fzt5u[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fzt5u[key];
        }
    });
});

var $gIpHn = parcelRequire("gIpHn");
Object.keys($gIpHn).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gIpHn[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gIpHn[key];
        }
    });
});

var $IcDAL = parcelRequire("IcDAL");
Object.keys($IcDAL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $IcDAL[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $IcDAL[key];
        }
    });
});

var $dFjae = parcelRequire("dFjae");
Object.keys($dFjae).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dFjae[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dFjae[key];
        }
    });
});

var $dzIQO = parcelRequire("dzIQO");
Object.keys($dzIQO).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dzIQO[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dzIQO[key];
        }
    });
});

var $2tXml = parcelRequire("2tXml");
Object.keys($2tXml).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2tXml[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2tXml[key];
        }
    });
});

var $2PZsO = parcelRequire("2PZsO");
Object.keys($2PZsO).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2PZsO[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2PZsO[key];
        }
    });
});

var $a0smh = parcelRequire("a0smh");
Object.keys($a0smh).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $a0smh[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $a0smh[key];
        }
    });
});

var $8sieT = parcelRequire("8sieT");
Object.keys($8sieT).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8sieT[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8sieT[key];
        }
    });
});

var $krIdQ = parcelRequire("krIdQ");
Object.keys($krIdQ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $krIdQ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $krIdQ[key];
        }
    });
});

var $7JF2D = parcelRequire("7JF2D");
Object.keys($7JF2D).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7JF2D[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7JF2D[key];
        }
    });
});

var $9EUl3 = parcelRequire("9EUl3");
Object.keys($9EUl3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9EUl3[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9EUl3[key];
        }
    });
});

var $cCrt0 = parcelRequire("cCrt0");
Object.keys($cCrt0).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cCrt0[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cCrt0[key];
        }
    });
});

var $gtcKN = parcelRequire("gtcKN");
Object.keys($gtcKN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gtcKN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gtcKN[key];
        }
    });
});

var $i4JoG = parcelRequire("i4JoG");
Object.keys($i4JoG).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $i4JoG[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $i4JoG[key];
        }
    });
});

var $k8ViH = parcelRequire("k8ViH");
Object.keys($k8ViH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $k8ViH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $k8ViH[key];
        }
    });
});

var $hRDyc = parcelRequire("hRDyc");
Object.keys($hRDyc).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hRDyc[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hRDyc[key];
        }
    });
});

var $fRN46 = parcelRequire("fRN46");
Object.keys($fRN46).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fRN46[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fRN46[key];
        }
    });
});

var $aGrbt = parcelRequire("aGrbt");
Object.keys($aGrbt).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aGrbt[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aGrbt[key];
        }
    });
});

var $gt7Pi = parcelRequire("gt7Pi");
Object.keys($gt7Pi).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gt7Pi[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gt7Pi[key];
        }
    });
});

var $6gk9p = parcelRequire("6gk9p");
Object.keys($6gk9p).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6gk9p[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6gk9p[key];
        }
    });
});

var $htHLT = parcelRequire("htHLT");
Object.keys($htHLT).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $htHLT[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $htHLT[key];
        }
    });
});

var $ltIzu = parcelRequire("ltIzu");
Object.keys($ltIzu).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ltIzu[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ltIzu[key];
        }
    });
});

var $5sOYC = parcelRequire("5sOYC");
Object.keys($5sOYC).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5sOYC[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5sOYC[key];
        }
    });
});

var $4n3cB = parcelRequire("4n3cB");
Object.keys($4n3cB).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4n3cB[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4n3cB[key];
        }
    });
});

var $4KAWB = parcelRequire("4KAWB");
Object.keys($4KAWB).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4KAWB[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4KAWB[key];
        }
    });
});

var $klJi0 = parcelRequire("klJi0");
Object.keys($klJi0).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $klJi0[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $klJi0[key];
        }
    });
});

var $4QlNi = parcelRequire("4QlNi");
Object.keys($4QlNi).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4QlNi[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4QlNi[key];
        }
    });
});

var $abFh3 = parcelRequire("abFh3");
Object.keys($abFh3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $abFh3[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $abFh3[key];
        }
    });
});

var $01IXW = parcelRequire("01IXW");
Object.keys($01IXW).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $01IXW[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $01IXW[key];
        }
    });
});

var $aK6Tu = parcelRequire("aK6Tu");
Object.keys($aK6Tu).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aK6Tu[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aK6Tu[key];
        }
    });
});

var $jKKUM = parcelRequire("jKKUM");
Object.keys($jKKUM).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jKKUM[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jKKUM[key];
        }
    });
});

var $akZ7E = parcelRequire("akZ7E");
Object.keys($akZ7E).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $akZ7E[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $akZ7E[key];
        }
    });
});

var $bPqKl = parcelRequire("bPqKl");
Object.keys($bPqKl).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bPqKl[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bPqKl[key];
        }
    });
});

var $lFyAe = parcelRequire("lFyAe");
Object.keys($lFyAe).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lFyAe[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lFyAe[key];
        }
    });
});

var $eE71H = parcelRequire("eE71H");
Object.keys($eE71H).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eE71H[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eE71H[key];
        }
    });
});

var $i0iIq = parcelRequire("i0iIq");
Object.keys($i0iIq).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $i0iIq[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $i0iIq[key];
        }
    });
});

var $79XR6 = parcelRequire("79XR6");
Object.keys($79XR6).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $79XR6[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $79XR6[key];
        }
    });
});

var $1gSjC = parcelRequire("1gSjC");
Object.keys($1gSjC).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1gSjC[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1gSjC[key];
        }
    });
});

var $1samY = parcelRequire("1samY");
Object.keys($1samY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1samY[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1samY[key];
        }
    });
});

var $4W4ZT = parcelRequire("4W4ZT");
Object.keys($4W4ZT).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4W4ZT[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4W4ZT[key];
        }
    });
});

var $iLRNz = parcelRequire("iLRNz");
Object.keys($iLRNz).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iLRNz[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iLRNz[key];
        }
    });
});

var $80qQC = parcelRequire("80qQC");
Object.keys($80qQC).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $80qQC[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $80qQC[key];
        }
    });
});

var $5ZlCI = parcelRequire("5ZlCI");
Object.keys($5ZlCI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5ZlCI[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5ZlCI[key];
        }
    });
});

var $cgiOl = parcelRequire("cgiOl");
Object.keys($cgiOl).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cgiOl[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cgiOl[key];
        }
    });
});

var $5Ie3a = parcelRequire("5Ie3a");
Object.keys($5Ie3a).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5Ie3a[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5Ie3a[key];
        }
    });
});

var $kpBOo = parcelRequire("kpBOo");
Object.keys($kpBOo).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kpBOo[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kpBOo[key];
        }
    });
});

var $cAnAD = parcelRequire("cAnAD");
Object.keys($cAnAD).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cAnAD[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cAnAD[key];
        }
    });
});

var $jIANP = parcelRequire("jIANP");
Object.keys($jIANP).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jIANP[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jIANP[key];
        }
    });
});

var $3GXJQ = parcelRequire("3GXJQ");
Object.keys($3GXJQ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3GXJQ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3GXJQ[key];
        }
    });
});

var $aI2Hd = parcelRequire("aI2Hd");
Object.keys($aI2Hd).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aI2Hd[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aI2Hd[key];
        }
    });
});

var $5OqIL = parcelRequire("5OqIL");
Object.keys($5OqIL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5OqIL[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5OqIL[key];
        }
    });
});

var $frPfZ = parcelRequire("frPfZ");
Object.keys($frPfZ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $frPfZ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $frPfZ[key];
        }
    });
});

var $eimnm = parcelRequire("eimnm");
Object.keys($eimnm).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eimnm[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eimnm[key];
        }
    });
});

var $lUiMa = parcelRequire("lUiMa");
Object.keys($lUiMa).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lUiMa[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lUiMa[key];
        }
    });
});

var $2jJKo = parcelRequire("2jJKo");
Object.keys($2jJKo).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2jJKo[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2jJKo[key];
        }
    });
});

var $iK4so = parcelRequire("iK4so");
Object.keys($iK4so).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iK4so[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iK4so[key];
        }
    });
});

var $4cORp = parcelRequire("4cORp");
Object.keys($4cORp).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4cORp[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4cORp[key];
        }
    });
});

var $irYsc = parcelRequire("irYsc");
Object.keys($irYsc).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $irYsc[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $irYsc[key];
        }
    });
});

});
parcelRegister("5nIwf", function(module, exports) {

$parcel$export(module.exports, "add", function () { return $3eb1a2540995cd53$export$e16d8520af44a096; }, function (v) { return $3eb1a2540995cd53$export$e16d8520af44a096 = v; });
var $3eb1a2540995cd53$export$e16d8520af44a096;
"use strict";
$3eb1a2540995cd53$export$e16d8520af44a096 = $3eb1a2540995cd53$var$add;

var $qX1g7 = parcelRequire("qX1g7");

var $cp3zA = parcelRequire("cp3zA");

var $909bC = parcelRequire("909bC");

var $eimnm = parcelRequire("eimnm");
/**
 * @name add
 * @category Common Helpers
 * @summary Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @description
 * Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be added.
 *
 * | Key            | Description                        |
 * |----------------|------------------------------------|
 * | years          | Amount of years to be added        |
 * | months         | Amount of months to be added       |
 * | weeks          | Amount of weeks to be added        |
 * | days           | Amount of days to be added         |
 * | hours          | Amount of hours to be added        |
 * | minutes        | Amount of minutes to be added      |
 * | seconds        | Amount of seconds to be added      |
 *
 * All values default to 0
 *
 * @returns The new date with the seconds added
 *
 * @example
 * // Add the following duration to 1 September 2014, 10:19:50
 * const result = add(new Date(2014, 8, 1, 10, 19, 50), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,\\-7
 *   minutes: 9,
 *   seconds: 30,
 * })
 * //=> Thu Jun 15 2017 15:29:20
 */ function $3eb1a2540995cd53$var$add(date, duration) {
    const { years: years = 0, months: months = 0, weeks: weeks = 0, days: days = 0, hours: hours = 0, minutes: minutes = 0, seconds: seconds = 0 } = duration;
    // Add years and months
    const _date = (0, $eimnm.toDate)(date);
    const dateWithMonths = months || years ? (0, $cp3zA.addMonths)(_date, months + years * 12) : _date;
    // Add weeks and days
    const dateWithDays = days || weeks ? (0, $qX1g7.addDays)(dateWithMonths, days + weeks * 7) : dateWithMonths;
    // Add days, hours, minutes and seconds
    const minutesToAdd = minutes + hours * 60;
    const secondsToAdd = seconds + minutesToAdd * 60;
    const msToAdd = secondsToAdd * 1000;
    const finalDate = (0, $909bC.constructFrom)(date, dateWithDays.getTime() + msToAdd);
    return finalDate;
}

});
parcelRegister("qX1g7", function(module, exports) {

$parcel$export(module.exports, "addDays", function () { return $051035d3bf28850e$export$dd412b56f1e4d8aa; }, function (v) { return $051035d3bf28850e$export$dd412b56f1e4d8aa = v; });
var $051035d3bf28850e$export$dd412b56f1e4d8aa;
"use strict";
$051035d3bf28850e$export$dd412b56f1e4d8aa = $051035d3bf28850e$var$addDays;

var $eimnm = parcelRequire("eimnm");

var $909bC = parcelRequire("909bC");
/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be added.
 *
 * @returns The new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */ function $051035d3bf28850e$var$addDays(date, amount) {
    const _date = (0, $eimnm.toDate)(date);
    if (isNaN(amount)) return (0, $909bC.constructFrom)(date, NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}

});
parcelRegister("eimnm", function(module, exports) {

$parcel$export(module.exports, "toDate", function () { return $a6841a7ab545bb2f$export$e67a095c620b86fe; }, function (v) { return $a6841a7ab545bb2f$export$e67a095c620b86fe = v; });
var $a6841a7ab545bb2f$export$e67a095c620b86fe;
"use strict";
$a6841a7ab545bb2f$export$e67a095c620b86fe = $a6841a7ab545bb2f$var$toDate;
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $a6841a7ab545bb2f$var$toDate(argument) {
    const argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
    else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") // TODO: Can we get rid of as?
    return new Date(argument);
    else // TODO: Can we get rid of as?
    return new Date(NaN);
}

});

parcelRegister("909bC", function(module, exports) {

$parcel$export(module.exports, "constructFrom", function () { return $68db3d5da96f91b2$export$ead8a1812b171991; }, function (v) { return $68db3d5da96f91b2$export$ead8a1812b171991 = v; });
var $68db3d5da96f91b2$export$ead8a1812b171991;
"use strict";
$68db3d5da96f91b2$export$ead8a1812b171991 = $68db3d5da96f91b2$var$constructFrom;
/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from 'date-fns'
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use contrustor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   )
 * }
 */ function $68db3d5da96f91b2$var$constructFrom(date, value) {
    if (date instanceof Date) return new date.constructor(value);
    else return new Date(value);
}

});


parcelRegister("cp3zA", function(module, exports) {

$parcel$export(module.exports, "addMonths", function () { return $907a975e3e0dd2ba$export$17c93e242b2d3a22; }, function (v) { return $907a975e3e0dd2ba$export$17c93e242b2d3a22 = v; });
var $907a975e3e0dd2ba$export$17c93e242b2d3a22;
"use strict";
$907a975e3e0dd2ba$export$17c93e242b2d3a22 = $907a975e3e0dd2ba$var$addMonths;

var $eimnm = parcelRequire("eimnm");

var $909bC = parcelRequire("909bC");
/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be added.
 *
 * @returns The new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 *
 * // Add one month to 30 January 2023:
 * const result = addMonths(new Date(2023, 0, 30), 1)
 * //=> Tue Feb 28 2023 00:00:00
 */ function $907a975e3e0dd2ba$var$addMonths(date, amount) {
    const _date = (0, $eimnm.toDate)(date);
    if (isNaN(amount)) return (0, $909bC.constructFrom)(date, NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
    const dayOfMonth = _date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    const endOfDesiredMonth = (0, $909bC.constructFrom)(date, _date.getTime());
    endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
    const daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        _date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return _date;
    }
}

});


parcelRegister("cWl2g", function(module, exports) {

$parcel$export(module.exports, "addBusinessDays", function () { return $96bb38084a607949$export$f087b9ada3136ae9; }, function (v) { return $96bb38084a607949$export$f087b9ada3136ae9 = v; });
var $96bb38084a607949$export$f087b9ada3136ae9;
"use strict";
$96bb38084a607949$export$f087b9ada3136ae9 = $96bb38084a607949$var$addBusinessDays;

var $909bC = parcelRequire("909bC");

var $1npC7 = parcelRequire("1npC7");

var $OEy34 = parcelRequire("OEy34");

var $2DtTD = parcelRequire("2DtTD");

var $eimnm = parcelRequire("eimnm");
/**
 * @name addBusinessDays
 * @category Date Extension Helpers
 * @summary Add the specified number of business days (mon - fri) to the given date.
 *
 * @description
 * Add the specified number of business days (mon - fri) to the given date, ignoring weekends.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of business days to be added.
 *
 * @returns The new date with the business days added
 *
 * @example
 * // Add 10 business days to 1 September 2014:
 * const result = addBusinessDays(new Date(2014, 8, 1), 10)
 * //=> Mon Sep 15 2014 00:00:00 (skipped weekend days)
 */ function $96bb38084a607949$var$addBusinessDays(date, amount) {
    const _date = (0, $eimnm.toDate)(date);
    const startedOnWeekend = (0, $2DtTD.isWeekend)(_date);
    if (isNaN(amount)) return (0, $909bC.constructFrom)(date, NaN);
    const hours = _date.getHours();
    const sign = amount < 0 ? -1 : 1;
    const fullWeeks = Math.trunc(amount / 5);
    _date.setDate(_date.getDate() + fullWeeks * 7);
    // Get remaining days not part of a full week
    let restDays = Math.abs(amount % 5);
    // Loops over remaining days
    while(restDays > 0){
        _date.setDate(_date.getDate() + sign);
        if (!(0, $2DtTD.isWeekend)(_date)) restDays -= 1;
    }
    // If the date is a weekend day and we reduce a dividable of
    // 5 from it, we land on a weekend date.
    // To counter this, we add days accordingly to land on the next business day
    if (startedOnWeekend && (0, $2DtTD.isWeekend)(_date) && amount !== 0) {
        // If we're reducing days, we want to add days until we land on a weekday
        // If we're adding days we want to reduce days until we land on a weekday
        if ((0, $1npC7.isSaturday)(_date)) _date.setDate(_date.getDate() + (sign < 0 ? 2 : -1));
        if ((0, $OEy34.isSunday)(_date)) _date.setDate(_date.getDate() + (sign < 0 ? 1 : -2));
    }
    // Restore hours to avoid DST lag
    _date.setHours(hours);
    return _date;
}

});
parcelRegister("1npC7", function(module, exports) {

$parcel$export(module.exports, "isSaturday", function () { return $100bcec8c62c6620$export$def9f260655b3a76; }, function (v) { return $100bcec8c62c6620$export$def9f260655b3a76 = v; });
var $100bcec8c62c6620$export$def9f260655b3a76;
"use strict";
$100bcec8c62c6620$export$def9f260655b3a76 = $100bcec8c62c6620$var$isSaturday;

var $eimnm = parcelRequire("eimnm");
/**
 * @name isSaturday
 * @category Weekday Helpers
 * @summary Is the given date Saturday?
 *
 * @description
 * Is the given date Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Saturday
 *
 * @example
 * // Is 27 September 2014 Saturday?
 * const result = isSaturday(new Date(2014, 8, 27))
 * //=> true
 */ function $100bcec8c62c6620$var$isSaturday(date) {
    return (0, $eimnm.toDate)(date).getDay() === 6;
}

});

parcelRegister("OEy34", function(module, exports) {

$parcel$export(module.exports, "isSunday", function () { return $09841fa5fba982c4$export$70f720dfc6028987; }, function (v) { return $09841fa5fba982c4$export$70f720dfc6028987 = v; });
var $09841fa5fba982c4$export$70f720dfc6028987;
"use strict";
$09841fa5fba982c4$export$70f720dfc6028987 = $09841fa5fba982c4$var$isSunday;

var $eimnm = parcelRequire("eimnm");
/**
 * @name isSunday
 * @category Weekday Helpers
 * @summary Is the given date Sunday?
 *
 * @description
 * Is the given date Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Sunday
 *
 * @example
 * // Is 21 September 2014 Sunday?
 * const result = isSunday(new Date(2014, 8, 21))
 * //=> true
 */ function $09841fa5fba982c4$var$isSunday(date) {
    return (0, $eimnm.toDate)(date).getDay() === 0;
}

});

parcelRegister("2DtTD", function(module, exports) {

$parcel$export(module.exports, "isWeekend", function () { return $1eb66a14734352c7$export$618d60ea299da42; }, function (v) { return $1eb66a14734352c7$export$618d60ea299da42 = v; });
var $1eb66a14734352c7$export$618d60ea299da42;
"use strict";
$1eb66a14734352c7$export$618d60ea299da42 = $1eb66a14734352c7$var$isWeekend;

var $eimnm = parcelRequire("eimnm");
/**
 * @name isWeekend
 * @category Weekday Helpers
 * @summary Does the given date fall on a weekend?
 *
 * @description
 * Does the given date fall on a weekend?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date falls on a weekend
 *
 * @example
 * // Does 5 October 2014 fall on a weekend?
 * const result = isWeekend(new Date(2014, 9, 5))
 * //=> true
 */ function $1eb66a14734352c7$var$isWeekend(date) {
    const day = (0, $eimnm.toDate)(date).getDay();
    return day === 0 || day === 6;
}

});


parcelRegister("lTL64", function(module, exports) {

$parcel$export(module.exports, "addHours", function () { return $ff13447ff04f2cb7$export$4a4306ad4fa0e5e6; }, function (v) { return $ff13447ff04f2cb7$export$4a4306ad4fa0e5e6 = v; });
var $ff13447ff04f2cb7$export$4a4306ad4fa0e5e6;
"use strict";
$ff13447ff04f2cb7$export$4a4306ad4fa0e5e6 = $ff13447ff04f2cb7$var$addHours;

var $cqs47 = parcelRequire("cqs47");

var $lILKk = parcelRequire("lILKk");
/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of hours to be added.
 *
 * @returns The new date with the hours added
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */ function $ff13447ff04f2cb7$var$addHours(date, amount) {
    return (0, $cqs47.addMilliseconds)(date, amount * $lILKk.millisecondsInHour);
}

});
parcelRegister("cqs47", function(module, exports) {

$parcel$export(module.exports, "addMilliseconds", function () { return $90bdaef8da954c3f$export$baf757aaf0c95c94; }, function (v) { return $90bdaef8da954c3f$export$baf757aaf0c95c94 = v; });
var $90bdaef8da954c3f$export$baf757aaf0c95c94;
"use strict";
$90bdaef8da954c3f$export$baf757aaf0c95c94 = $90bdaef8da954c3f$var$addMilliseconds;

var $eimnm = parcelRequire("eimnm");

var $909bC = parcelRequire("909bC");
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of milliseconds to be added.
 *
 * @returns The new date with the milliseconds added
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function $90bdaef8da954c3f$var$addMilliseconds(date, amount) {
    const timestamp = +(0, $eimnm.toDate)(date);
    return (0, $909bC.constructFrom)(date, timestamp + amount);
}

});

parcelRegister("lILKk", function(module, exports) {

$parcel$export(module.exports, "secondsInYear", function () { return $fd02be769b975a17$export$7271e9e3478110d1; }, function (v) { return $fd02be769b975a17$export$7271e9e3478110d1 = v; });
$parcel$export(module.exports, "secondsInWeek", function () { return $fd02be769b975a17$export$34804a017b31e2fe; }, function (v) { return $fd02be769b975a17$export$34804a017b31e2fe = v; });
$parcel$export(module.exports, "secondsInQuarter", function () { return $fd02be769b975a17$export$be1dccf2de902d31; }, function (v) { return $fd02be769b975a17$export$be1dccf2de902d31 = v; });
$parcel$export(module.exports, "secondsInMonth", function () { return $fd02be769b975a17$export$8e6600bbdee7dabb; }, function (v) { return $fd02be769b975a17$export$8e6600bbdee7dabb = v; });
$parcel$export(module.exports, "secondsInMinute", function () { return $fd02be769b975a17$export$a77c1a7ebebe2a5a; }, function (v) { return $fd02be769b975a17$export$a77c1a7ebebe2a5a = v; });
$parcel$export(module.exports, "secondsInHour", function () { return $fd02be769b975a17$export$698aec755e92c695; }, function (v) { return $fd02be769b975a17$export$698aec755e92c695 = v; });
$parcel$export(module.exports, "secondsInDay", function () { return $fd02be769b975a17$export$815a9362476d2fe3; }, function (v) { return $fd02be769b975a17$export$815a9362476d2fe3 = v; });
$parcel$export(module.exports, "quartersInYear", function () { return $fd02be769b975a17$export$4db7641526e3241f; }, function (v) { return $fd02be769b975a17$export$4db7641526e3241f = v; });
$parcel$export(module.exports, "monthsInYear", function () { return $fd02be769b975a17$export$80d7e435f744f319; }, function (v) { return $fd02be769b975a17$export$80d7e435f744f319 = v; });
$parcel$export(module.exports, "monthsInQuarter", function () { return $fd02be769b975a17$export$3c58128db900d44e; }, function (v) { return $fd02be769b975a17$export$3c58128db900d44e = v; });
$parcel$export(module.exports, "minutesInYear", function () { return $fd02be769b975a17$export$3633035e63cee86a; }, function (v) { return $fd02be769b975a17$export$3633035e63cee86a = v; });
$parcel$export(module.exports, "minutesInMonth", function () { return $fd02be769b975a17$export$ab7da2ccd1075c38; }, function (v) { return $fd02be769b975a17$export$ab7da2ccd1075c38 = v; });
$parcel$export(module.exports, "minutesInHour", function () { return $fd02be769b975a17$export$f2f5ae5a8e2d8f9f; }, function (v) { return $fd02be769b975a17$export$f2f5ae5a8e2d8f9f = v; });
$parcel$export(module.exports, "minutesInDay", function () { return $fd02be769b975a17$export$2423174df8cd3cd2; }, function (v) { return $fd02be769b975a17$export$2423174df8cd3cd2 = v; });
$parcel$export(module.exports, "millisecondsInWeek", function () { return $fd02be769b975a17$export$4fad13613e88edc8; }, function (v) { return $fd02be769b975a17$export$4fad13613e88edc8 = v; });
$parcel$export(module.exports, "millisecondsInSecond", function () { return $fd02be769b975a17$export$397c2d5776aa9055; }, function (v) { return $fd02be769b975a17$export$397c2d5776aa9055 = v; });
$parcel$export(module.exports, "millisecondsInMinute", function () { return $fd02be769b975a17$export$91246f0b9bd9beff; }, function (v) { return $fd02be769b975a17$export$91246f0b9bd9beff = v; });
$parcel$export(module.exports, "millisecondsInHour", function () { return $fd02be769b975a17$export$7f72910d6dfd237a; }, function (v) { return $fd02be769b975a17$export$7f72910d6dfd237a = v; });
$parcel$export(module.exports, "millisecondsInDay", function () { return $fd02be769b975a17$export$b76b1809a2898f9a; }, function (v) { return $fd02be769b975a17$export$b76b1809a2898f9a = v; });
$parcel$export(module.exports, "daysInYear", function () { return $fd02be769b975a17$export$3913210603d8e9ae; }, function (v) { return $fd02be769b975a17$export$3913210603d8e9ae = v; });
$parcel$export(module.exports, "daysInWeek", function () { return $fd02be769b975a17$export$dfd9b671c89acc8e; }, function (v) { return $fd02be769b975a17$export$dfd9b671c89acc8e = v; });
var $fd02be769b975a17$export$7271e9e3478110d1;
var $fd02be769b975a17$export$34804a017b31e2fe;
var $fd02be769b975a17$export$be1dccf2de902d31;
var $fd02be769b975a17$export$8e6600bbdee7dabb;
var $fd02be769b975a17$export$a77c1a7ebebe2a5a;
var $fd02be769b975a17$export$698aec755e92c695;
var $fd02be769b975a17$export$815a9362476d2fe3;
var $fd02be769b975a17$export$4db7641526e3241f;
var $fd02be769b975a17$export$80d7e435f744f319;
var $fd02be769b975a17$export$3c58128db900d44e;
var $fd02be769b975a17$export$3633035e63cee86a;
var $fd02be769b975a17$export$ab7da2ccd1075c38;
var $fd02be769b975a17$export$f2f5ae5a8e2d8f9f;
var $fd02be769b975a17$export$2423174df8cd3cd2;
var $fd02be769b975a17$export$4dec998e48f9c246;
var $fd02be769b975a17$export$4fad13613e88edc8;
var $fd02be769b975a17$export$397c2d5776aa9055;
var $fd02be769b975a17$export$91246f0b9bd9beff;
var $fd02be769b975a17$export$7f72910d6dfd237a;
var $fd02be769b975a17$export$b76b1809a2898f9a;
var $fd02be769b975a17$export$81caae6e1cc7a622;
var $fd02be769b975a17$export$3913210603d8e9ae;
var $fd02be769b975a17$export$dfd9b671c89acc8e;
"use strict";
$fd02be769b975a17$export$7271e9e3478110d1 = $fd02be769b975a17$export$34804a017b31e2fe = $fd02be769b975a17$export$be1dccf2de902d31 = $fd02be769b975a17$export$8e6600bbdee7dabb = $fd02be769b975a17$export$a77c1a7ebebe2a5a = $fd02be769b975a17$export$698aec755e92c695 = $fd02be769b975a17$export$815a9362476d2fe3 = $fd02be769b975a17$export$4db7641526e3241f = $fd02be769b975a17$export$80d7e435f744f319 = $fd02be769b975a17$export$3c58128db900d44e = $fd02be769b975a17$export$3633035e63cee86a = $fd02be769b975a17$export$ab7da2ccd1075c38 = $fd02be769b975a17$export$f2f5ae5a8e2d8f9f = $fd02be769b975a17$export$2423174df8cd3cd2 = $fd02be769b975a17$export$4dec998e48f9c246 = $fd02be769b975a17$export$4fad13613e88edc8 = $fd02be769b975a17$export$397c2d5776aa9055 = $fd02be769b975a17$export$91246f0b9bd9beff = $fd02be769b975a17$export$7f72910d6dfd237a = $fd02be769b975a17$export$b76b1809a2898f9a = $fd02be769b975a17$export$81caae6e1cc7a622 = $fd02be769b975a17$export$3913210603d8e9ae = $fd02be769b975a17$export$dfd9b671c89acc8e = void 0; /**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ 
/**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $fd02be769b975a17$var$daysInWeek = $fd02be769b975a17$export$dfd9b671c89acc8e = 7;
/**
 * @constant
 * @name daysInYear
 * @summary Days in 1 year.
 *
 * @description
 * How many days in a year.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 */ const $fd02be769b975a17$var$daysInYear = $fd02be769b975a17$export$3913210603d8e9ae = 365.2425;
/**
 * @constant
 * @name maxTime
 * @summary Maximum allowed time.
 *
 * @example
 * import { maxTime } from "date-fns/constants";
 *
 * const isValid = 8640000000000001 <= maxTime;
 * //=> false
 *
 * new Date(8640000000000001);
 * //=> Invalid Date
 */ const $fd02be769b975a17$var$maxTime = $fd02be769b975a17$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
/**
 * @constant
 * @name minTime
 * @summary Minimum allowed time.
 *
 * @example
 * import { minTime } from "date-fns/constants";
 *
 * const isValid = -8640000000000001 >= minTime;
 * //=> false
 *
 * new Date(-8640000000000001)
 * //=> Invalid Date
 */ const $fd02be769b975a17$var$minTime = $fd02be769b975a17$export$4dec998e48f9c246 = -$fd02be769b975a17$var$maxTime;
/**
 * @constant
 * @name millisecondsInWeek
 * @summary Milliseconds in 1 week.
 */ const $fd02be769b975a17$var$millisecondsInWeek = $fd02be769b975a17$export$4fad13613e88edc8 = 604800000;
/**
 * @constant
 * @name millisecondsInDay
 * @summary Milliseconds in 1 day.
 */ const $fd02be769b975a17$var$millisecondsInDay = $fd02be769b975a17$export$b76b1809a2898f9a = 86400000;
/**
 * @constant
 * @name millisecondsInMinute
 * @summary Milliseconds in 1 minute
 */ const $fd02be769b975a17$var$millisecondsInMinute = $fd02be769b975a17$export$91246f0b9bd9beff = 60000;
/**
 * @constant
 * @name millisecondsInHour
 * @summary Milliseconds in 1 hour
 */ const $fd02be769b975a17$var$millisecondsInHour = $fd02be769b975a17$export$7f72910d6dfd237a = 3600000;
/**
 * @constant
 * @name millisecondsInSecond
 * @summary Milliseconds in 1 second
 */ const $fd02be769b975a17$var$millisecondsInSecond = $fd02be769b975a17$export$397c2d5776aa9055 = 1000;
/**
 * @constant
 * @name minutesInYear
 * @summary Minutes in 1 year.
 */ const $fd02be769b975a17$var$minutesInYear = $fd02be769b975a17$export$3633035e63cee86a = 525600;
/**
 * @constant
 * @name minutesInMonth
 * @summary Minutes in 1 month.
 */ const $fd02be769b975a17$var$minutesInMonth = $fd02be769b975a17$export$ab7da2ccd1075c38 = 43200;
/**
 * @constant
 * @name minutesInDay
 * @summary Minutes in 1 day.
 */ const $fd02be769b975a17$var$minutesInDay = $fd02be769b975a17$export$2423174df8cd3cd2 = 1440;
/**
 * @constant
 * @name minutesInHour
 * @summary Minutes in 1 hour.
 */ const $fd02be769b975a17$var$minutesInHour = $fd02be769b975a17$export$f2f5ae5a8e2d8f9f = 60;
/**
 * @constant
 * @name monthsInQuarter
 * @summary Months in 1 quarter.
 */ const $fd02be769b975a17$var$monthsInQuarter = $fd02be769b975a17$export$3c58128db900d44e = 3;
/**
 * @constant
 * @name monthsInYear
 * @summary Months in 1 year.
 */ const $fd02be769b975a17$var$monthsInYear = $fd02be769b975a17$export$80d7e435f744f319 = 12;
/**
 * @constant
 * @name quartersInYear
 * @summary Quarters in 1 year
 */ const $fd02be769b975a17$var$quartersInYear = $fd02be769b975a17$export$4db7641526e3241f = 4;
/**
 * @constant
 * @name secondsInHour
 * @summary Seconds in 1 hour.
 */ const $fd02be769b975a17$var$secondsInHour = $fd02be769b975a17$export$698aec755e92c695 = 3600;
/**
 * @constant
 * @name secondsInMinute
 * @summary Seconds in 1 minute.
 */ const $fd02be769b975a17$var$secondsInMinute = $fd02be769b975a17$export$a77c1a7ebebe2a5a = 60;
/**
 * @constant
 * @name secondsInDay
 * @summary Seconds in 1 day.
 */ const $fd02be769b975a17$var$secondsInDay = $fd02be769b975a17$export$815a9362476d2fe3 = $fd02be769b975a17$var$secondsInHour * 24;
/**
 * @constant
 * @name secondsInWeek
 * @summary Seconds in 1 week.
 */ const $fd02be769b975a17$var$secondsInWeek = $fd02be769b975a17$export$34804a017b31e2fe = $fd02be769b975a17$var$secondsInDay * 7;
/**
 * @constant
 * @name secondsInYear
 * @summary Seconds in 1 year.
 */ const $fd02be769b975a17$var$secondsInYear = $fd02be769b975a17$export$7271e9e3478110d1 = $fd02be769b975a17$var$secondsInDay * $fd02be769b975a17$var$daysInYear;
/**
 * @constant
 * @name secondsInMonth
 * @summary Seconds in 1 month
 */ const $fd02be769b975a17$var$secondsInMonth = $fd02be769b975a17$export$8e6600bbdee7dabb = $fd02be769b975a17$var$secondsInYear / 12;
/**
 * @constant
 * @name secondsInQuarter
 * @summary Seconds in 1 quarter.
 */ const $fd02be769b975a17$var$secondsInQuarter = $fd02be769b975a17$export$be1dccf2de902d31 = $fd02be769b975a17$var$secondsInMonth * 3;

});


parcelRegister("b4qzk", function(module, exports) {

$parcel$export(module.exports, "addISOWeekYears", function () { return $80f4ad6d9de5f5f4$export$c8240694da10d5f; }, function (v) { return $80f4ad6d9de5f5f4$export$c8240694da10d5f = v; });
var $80f4ad6d9de5f5f4$export$c8240694da10d5f;
"use strict";
$80f4ad6d9de5f5f4$export$c8240694da10d5f = $80f4ad6d9de5f5f4$var$addISOWeekYears;

var $4j6Nm = parcelRequire("4j6Nm");

var $fRN46 = parcelRequire("fRN46");
/**
 * @name addISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Add the specified number of ISO week-numbering years to the given date.
 *
 * @description
 * Add the specified number of ISO week-numbering years to the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of ISO week-numbering years to be added.
 *
 * @returns The new date with the ISO week-numbering years added
 *
 * @example
 * // Add 5 ISO week-numbering years to 2 July 2010:
 * const result = addISOWeekYears(new Date(2010, 6, 2), 5)
 * //=> Fri Jn 26 2015 00:00:00
 */ function $80f4ad6d9de5f5f4$var$addISOWeekYears(date, amount) {
    return (0, $fRN46.setISOWeekYear)(date, (0, $4j6Nm.getISOWeekYear)(date) + amount);
}

});
parcelRegister("4j6Nm", function(module, exports) {

$parcel$export(module.exports, "getISOWeekYear", function () { return $322e352a0c60ad25$export$3dbc52535f6f8fcc; }, function (v) { return $322e352a0c60ad25$export$3dbc52535f6f8fcc = v; });
var $322e352a0c60ad25$export$3dbc52535f6f8fcc;
"use strict";
$322e352a0c60ad25$export$3dbc52535f6f8fcc = $322e352a0c60ad25$var$getISOWeekYear;

var $909bC = parcelRequire("909bC");

var $01IXW = parcelRequire("01IXW");

var $eimnm = parcelRequire("eimnm");
/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */ function $322e352a0c60ad25$var$getISOWeekYear(date) {
    const _date = (0, $eimnm.toDate)(date);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $909bC.constructFrom)(date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $01IXW.startOfISOWeek)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $909bC.constructFrom)(date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $01IXW.startOfISOWeek)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});
parcelRegister("01IXW", function(module, exports) {

$parcel$export(module.exports, "startOfISOWeek", function () { return $0052f95e1ba67ab7$export$6173213f95a4431e; }, function (v) { return $0052f95e1ba67ab7$export$6173213f95a4431e = v; });
var $0052f95e1ba67ab7$export$6173213f95a4431e;
"use strict";
$0052f95e1ba67ab7$export$6173213f95a4431e = $0052f95e1ba67ab7$var$startOfISOWeek;

var $79XR6 = parcelRequire("79XR6");
/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ function $0052f95e1ba67ab7$var$startOfISOWeek(date) {
    return (0, $79XR6.startOfWeek)(date, {
        weekStartsOn: 1
    });
}

});
parcelRegister("79XR6", function(module, exports) {

$parcel$export(module.exports, "startOfWeek", function () { return $0158624911d8ca42$export$42c81a444fbfb5d4; }, function (v) { return $0158624911d8ca42$export$42c81a444fbfb5d4 = v; });
var $0158624911d8ca42$export$42c81a444fbfb5d4;
"use strict";
$0158624911d8ca42$export$42c81a444fbfb5d4 = $0158624911d8ca42$var$startOfWeek;

var $eimnm = parcelRequire("eimnm");

var $hIOa6 = parcelRequire("hIOa6");
/**
 * The {@link startOfWeek} function options.
 */ /**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */ function $0158624911d8ca42$var$startOfWeek(date, options) {
    const defaultOptions = (0, $hIOa6.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $eimnm.toDate)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});
parcelRegister("hIOa6", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", function () { return $ce6d74d57ae73bac$export$430a3269e24b912e; }, function (v) { return $ce6d74d57ae73bac$export$430a3269e24b912e = v; });
$parcel$export(module.exports, "setDefaultOptions", function () { return $ce6d74d57ae73bac$export$95365be1b0704abc; }, function (v) { return $ce6d74d57ae73bac$export$95365be1b0704abc = v; });
var $ce6d74d57ae73bac$export$430a3269e24b912e;
var $ce6d74d57ae73bac$export$95365be1b0704abc;
"use strict";
$ce6d74d57ae73bac$export$430a3269e24b912e = $ce6d74d57ae73bac$var$getDefaultOptions;
$ce6d74d57ae73bac$export$95365be1b0704abc = $ce6d74d57ae73bac$var$setDefaultOptions;
let $ce6d74d57ae73bac$var$defaultOptions = {};
function $ce6d74d57ae73bac$var$getDefaultOptions() {
    return $ce6d74d57ae73bac$var$defaultOptions;
}
function $ce6d74d57ae73bac$var$setDefaultOptions(newOptions) {
    $ce6d74d57ae73bac$var$defaultOptions = newOptions;
}

});




parcelRegister("fRN46", function(module, exports) {

$parcel$export(module.exports, "setISOWeekYear", function () { return $b8d1dd919d135ca9$export$814397aabf10ab77; }, function (v) { return $b8d1dd919d135ca9$export$814397aabf10ab77 = v; });
var $b8d1dd919d135ca9$export$814397aabf10ab77;
"use strict";
$b8d1dd919d135ca9$export$814397aabf10ab77 = $b8d1dd919d135ca9$var$setISOWeekYear;

var $909bC = parcelRequire("909bC");

var $ctsEq = parcelRequire("ctsEq");

var $aK6Tu = parcelRequire("aK6Tu");

var $eimnm = parcelRequire("eimnm");
/**
 * @name setISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Set the ISO week-numbering year to the given date.
 *
 * @description
 * Set the ISO week-numbering year to the given date,
 * saving the week number and the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param weekYear - The ISO week-numbering year of the new date
 *
 * @returns The new date with the ISO week-numbering year set
 *
 * @example
 * // Set ISO week-numbering year 2007 to 29 December 2008:
 * const result = setISOWeekYear(new Date(2008, 11, 29), 2007)
 * //=> Mon Jan 01 2007 00:00:00
 */ function $b8d1dd919d135ca9$var$setISOWeekYear(date, weekYear) {
    let _date = (0, $eimnm.toDate)(date);
    const diff = (0, $ctsEq.differenceInCalendarDays)(_date, (0, $aK6Tu.startOfISOWeekYear)(_date));
    const fourthOfJanuary = (0, $909bC.constructFrom)(date, 0);
    fourthOfJanuary.setFullYear(weekYear, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    _date = (0, $aK6Tu.startOfISOWeekYear)(fourthOfJanuary);
    _date.setDate(_date.getDate() + diff);
    return _date;
}

});
parcelRegister("ctsEq", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarDays", function () { return $914e6afb0cd110c9$export$4a02e9c37dab4871; }, function (v) { return $914e6afb0cd110c9$export$4a02e9c37dab4871 = v; });
var $914e6afb0cd110c9$export$4a02e9c37dab4871;
"use strict";
$914e6afb0cd110c9$export$4a02e9c37dab4871 = $914e6afb0cd110c9$var$differenceInCalendarDays;

var $lILKk = parcelRequire("lILKk");

var $klJi0 = parcelRequire("klJi0");

var $i6arj = parcelRequire("i6arj");
/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */ function $914e6afb0cd110c9$var$differenceInCalendarDays(dateLeft, dateRight) {
    const startOfDayLeft = (0, $klJi0.startOfDay)(dateLeft);
    const startOfDayRight = (0, $klJi0.startOfDay)(dateRight);
    const timestampLeft = +startOfDayLeft - (0, $i6arj.getTimezoneOffsetInMilliseconds)(startOfDayLeft);
    const timestampRight = +startOfDayRight - (0, $i6arj.getTimezoneOffsetInMilliseconds)(startOfDayRight);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / $lILKk.millisecondsInDay);
}

});
parcelRegister("klJi0", function(module, exports) {

$parcel$export(module.exports, "startOfDay", function () { return $ed08e65c3b32cfef$export$63fa379ae8a9ba2; }, function (v) { return $ed08e65c3b32cfef$export$63fa379ae8a9ba2 = v; });
var $ed08e65c3b32cfef$export$63fa379ae8a9ba2;
"use strict";
$ed08e65c3b32cfef$export$63fa379ae8a9ba2 = $ed08e65c3b32cfef$var$startOfDay;

var $eimnm = parcelRequire("eimnm");
/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */ function $ed08e65c3b32cfef$var$startOfDay(date) {
    const _date = (0, $eimnm.toDate)(date);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("i6arj", function(module, exports) {

$parcel$export(module.exports, "getTimezoneOffsetInMilliseconds", function () { return $d2d0e2943a286553$export$113002b5eff6e430; }, function (v) { return $d2d0e2943a286553$export$113002b5eff6e430 = v; });
var $d2d0e2943a286553$export$113002b5eff6e430;
"use strict";
$d2d0e2943a286553$export$113002b5eff6e430 = $d2d0e2943a286553$var$getTimezoneOffsetInMilliseconds;

var $eimnm = parcelRequire("eimnm");
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $d2d0e2943a286553$var$getTimezoneOffsetInMilliseconds(date) {
    const _date = (0, $eimnm.toDate)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}

});


parcelRegister("aK6Tu", function(module, exports) {

$parcel$export(module.exports, "startOfISOWeekYear", function () { return $7d238c4a29c1f9dd$export$236bdfa374eb69a9; }, function (v) { return $7d238c4a29c1f9dd$export$236bdfa374eb69a9 = v; });
var $7d238c4a29c1f9dd$export$236bdfa374eb69a9;
"use strict";
$7d238c4a29c1f9dd$export$236bdfa374eb69a9 = $7d238c4a29c1f9dd$var$startOfISOWeekYear;

var $4j6Nm = parcelRequire("4j6Nm");

var $01IXW = parcelRequire("01IXW");

var $909bC = parcelRequire("909bC");
/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week-numbering year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */ function $7d238c4a29c1f9dd$var$startOfISOWeekYear(date) {
    const year = (0, $4j6Nm.getISOWeekYear)(date);
    const fourthOfJanuary = (0, $909bC.constructFrom)(date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $01IXW.startOfISOWeek)(fourthOfJanuary);
}

});



parcelRegister("h7zV9", function(module, exports) {

$parcel$export(module.exports, "addMinutes", function () { return $c76ef43ec9e52310$export$2287e3d29250119e; }, function (v) { return $c76ef43ec9e52310$export$2287e3d29250119e = v; });
var $c76ef43ec9e52310$export$2287e3d29250119e;
"use strict";
$c76ef43ec9e52310$export$2287e3d29250119e = $c76ef43ec9e52310$var$addMinutes;

var $cqs47 = parcelRequire("cqs47");

var $lILKk = parcelRequire("lILKk");
/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be added.
 *
 * @returns The new date with the minutes added
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */ function $c76ef43ec9e52310$var$addMinutes(date, amount) {
    return (0, $cqs47.addMilliseconds)(date, amount * $lILKk.millisecondsInMinute);
}

});

parcelRegister("7pM9n", function(module, exports) {

$parcel$export(module.exports, "addQuarters", function () { return $566037d75d37f3a6$export$c252a41d0fbed2ce; }, function (v) { return $566037d75d37f3a6$export$c252a41d0fbed2ce = v; });
var $566037d75d37f3a6$export$c252a41d0fbed2ce;
"use strict";
$566037d75d37f3a6$export$c252a41d0fbed2ce = $566037d75d37f3a6$var$addQuarters;

var $cp3zA = parcelRequire("cp3zA");
/**
 * @name addQuarters
 * @category Quarter Helpers
 * @summary Add the specified number of year quarters to the given date.
 *
 * @description
 * Add the specified number of year quarters to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of quarters to be added.
 *
 * @returns The new date with the quarters added
 *
 * @example
 * // Add 1 quarter to 1 September 2014:
 * const result = addQuarters(new Date(2014, 8, 1), 1)
 * //=> Mon Dec 01 2014 00:00:00
 */ function $566037d75d37f3a6$var$addQuarters(date, amount) {
    const months = amount * 3;
    return (0, $cp3zA.addMonths)(date, months);
}

});

parcelRegister("boFoj", function(module, exports) {

$parcel$export(module.exports, "addSeconds", function () { return $84c20b002740889c$export$3cb31b0df13be68; }, function (v) { return $84c20b002740889c$export$3cb31b0df13be68 = v; });
var $84c20b002740889c$export$3cb31b0df13be68;
"use strict";
$84c20b002740889c$export$3cb31b0df13be68 = $84c20b002740889c$var$addSeconds;

var $cqs47 = parcelRequire("cqs47");
/**
 * @name addSeconds
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of seconds to be added.
 *
 * @returns The new date with the seconds added
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * const result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */ function $84c20b002740889c$var$addSeconds(date, amount) {
    return (0, $cqs47.addMilliseconds)(date, amount * 1000);
}

});

parcelRegister("6T9jK", function(module, exports) {

$parcel$export(module.exports, "addWeeks", function () { return $503f1b5f14fcaf60$export$ef501a2bb4f3ee6b; }, function (v) { return $503f1b5f14fcaf60$export$ef501a2bb4f3ee6b = v; });
var $503f1b5f14fcaf60$export$ef501a2bb4f3ee6b;
"use strict";
$503f1b5f14fcaf60$export$ef501a2bb4f3ee6b = $503f1b5f14fcaf60$var$addWeeks;

var $qX1g7 = parcelRequire("qX1g7");
/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be added.
 *
 * @returns The new date with the weeks added
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */ function $503f1b5f14fcaf60$var$addWeeks(date, amount) {
    const days = amount * 7;
    return (0, $qX1g7.addDays)(date, days);
}

});

parcelRegister("1afNH", function(module, exports) {

$parcel$export(module.exports, "addYears", function () { return $0d92fb47acdcffd8$export$3d83eec43f4ea476; }, function (v) { return $0d92fb47acdcffd8$export$3d83eec43f4ea476 = v; });
var $0d92fb47acdcffd8$export$3d83eec43f4ea476;
"use strict";
$0d92fb47acdcffd8$export$3d83eec43f4ea476 = $0d92fb47acdcffd8$var$addYears;

var $cp3zA = parcelRequire("cp3zA");
/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be added.
 *
 * @returns The new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */ function $0d92fb47acdcffd8$var$addYears(date, amount) {
    return (0, $cp3zA.addMonths)(date, amount * 12);
}

});

parcelRegister("dIV2o", function(module, exports) {

$parcel$export(module.exports, "areIntervalsOverlapping", function () { return $9fdba0ea75e2e8e3$export$2bf3385645436101; }, function (v) { return $9fdba0ea75e2e8e3$export$2bf3385645436101 = v; });
var $9fdba0ea75e2e8e3$export$2bf3385645436101;
"use strict";
$9fdba0ea75e2e8e3$export$2bf3385645436101 = $9fdba0ea75e2e8e3$var$areIntervalsOverlapping;

var $eimnm = parcelRequire("eimnm");
/**
 * The {@link areIntervalsOverlapping} function options.
 */ /**
 * @name areIntervalsOverlapping
 * @category Interval Helpers
 * @summary Is the given time interval overlapping with another time interval?
 *
 * @description
 * Is the given time interval overlapping with another time interval? Adjacent intervals do not count as overlapping unless `inclusive` is set to `true`.
 *
 * @param intervalLeft - The first interval to compare.
 * @param intervalRight - The second interval to compare.
 * @param options - The object with options
 *
 * @returns Whether the time intervals are overlapping
 *
 * @example
 * // For overlapping time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
 * )
 * //=> true
 *
 * @example
 * // For non-overlapping time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
 * )
 * //=> false
 *
 * @example
 * // For adjacent time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 30) }
 * )
 * //=> false
 *
 * @example
 * // Using the inclusive option:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) }
 * )
 * //=> false
 *
 * @example
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) },
 *   { inclusive: true }
 * )
 * //=> true
 */ function $9fdba0ea75e2e8e3$var$areIntervalsOverlapping(intervalLeft, intervalRight, options) {
    const [leftStartTime, leftEndTime] = [
        +(0, $eimnm.toDate)(intervalLeft.start),
        +(0, $eimnm.toDate)(intervalLeft.end)
    ].sort((a, b)=>a - b);
    const [rightStartTime, rightEndTime] = [
        +(0, $eimnm.toDate)(intervalRight.start),
        +(0, $eimnm.toDate)(intervalRight.end)
    ].sort((a, b)=>a - b);
    if (options?.inclusive) return leftStartTime <= rightEndTime && rightStartTime <= leftEndTime;
    return leftStartTime < rightEndTime && rightStartTime < leftEndTime;
}

});

parcelRegister("03Tlq", function(module, exports) {

$parcel$export(module.exports, "clamp", function () { return $00bb3637aa8a69fa$export$7d15b64cf5a3a4c4; }, function (v) { return $00bb3637aa8a69fa$export$7d15b64cf5a3a4c4 = v; });
var $00bb3637aa8a69fa$export$7d15b64cf5a3a4c4;
"use strict";
$00bb3637aa8a69fa$export$7d15b64cf5a3a4c4 = $00bb3637aa8a69fa$var$clamp;

var $bFERN = parcelRequire("bFERN");

var $jB17I = parcelRequire("jB17I");
/**
 * @name clamp
 * @category Interval Helpers
 * @summary Return a date bounded by the start and the end of the given interval
 *
 * @description
 * Clamps a date to the lower bound with the start of the interval and the upper
 * bound with the end of the interval.
 *
 * - When the date is less than the start of the interval, the start is returned.
 * - When the date is greater than the end of the interval, the end is returned.
 * - Otherwise the date is returned.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be bounded
 * @param interval - The interval to bound to
 *
 * @returns The date bounded by the start and the end of the interval
 *
 * @example
 * // What is Mar, 21, 2021 bounded to an interval starting at Mar, 22, 2021 and ending at Apr, 01, 2021
 * const result = clamp(new Date(2021, 2, 21), {
 *   start: new Date(2021, 2, 22),
 *   end: new Date(2021, 3, 1),
 * })
 * //=> Mon Mar 22 2021 00:00:00
 */ function $00bb3637aa8a69fa$var$clamp(date, interval) {
    return (0, $jB17I.min)([
        (0, $bFERN.max)([
            date,
            interval.start
        ]),
        interval.end
    ]);
}

});
parcelRegister("bFERN", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $87f3394c4cac624b$export$8960430cfd85939f; }, function (v) { return $87f3394c4cac624b$export$8960430cfd85939f = v; });
var $87f3394c4cac624b$export$8960430cfd85939f;
"use strict";
$87f3394c4cac624b$export$8960430cfd85939f = $87f3394c4cac624b$var$max;

var $eimnm = parcelRequire("eimnm");
/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The latest of the dates
 *
 * @example
 * // Which of these dates is the latest?
 * const result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */ function $87f3394c4cac624b$var$max(dates) {
    let result;
    dates.forEach(function(dirtyDate) {
        const currentDate = (0, $eimnm.toDate)(dirtyDate);
        if (result === undefined || result < currentDate || isNaN(Number(currentDate))) result = currentDate;
    });
    return result || new Date(NaN);
}

});

parcelRegister("jB17I", function(module, exports) {

$parcel$export(module.exports, "min", function () { return $e442581b78e7de3f$export$96ec731ed4dcb222; }, function (v) { return $e442581b78e7de3f$export$96ec731ed4dcb222 = v; });
var $e442581b78e7de3f$export$96ec731ed4dcb222;
"use strict";
$e442581b78e7de3f$export$96ec731ed4dcb222 = $e442581b78e7de3f$var$min;

var $eimnm = parcelRequire("eimnm");
/**
 * @name min
 * @category Common Helpers
 * @summary Returns the earliest of the given dates.
 *
 * @description
 * Returns the earliest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The earliest of the dates
 *
 * @example
 * // Which of these dates is the earliest?
 * const result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */ function $e442581b78e7de3f$var$min(dates) {
    let result;
    dates.forEach((dirtyDate)=>{
        const date = (0, $eimnm.toDate)(dirtyDate);
        if (!result || result > date || isNaN(+date)) result = date;
    });
    return result || new Date(NaN);
}

});


parcelRegister("9mtbp", function(module, exports) {

$parcel$export(module.exports, "closestIndexTo", function () { return $6d0cce41b204b86d$export$42127b72a9d091c7; }, function (v) { return $6d0cce41b204b86d$export$42127b72a9d091c7 = v; });
var $6d0cce41b204b86d$export$42127b72a9d091c7;
"use strict";
$6d0cce41b204b86d$export$42127b72a9d091c7 = $6d0cce41b204b86d$var$closestIndexTo;

var $eimnm = parcelRequire("eimnm");
/**
 * @name closestIndexTo
 * @category Common Helpers
 * @summary Return an index of the closest date from the array comparing to the given date.
 *
 * @description
 * Return an index of the closest date from the array comparing to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateToCompare - The date to compare with
 * @param dates - The array to search
 *
 * @returns An index of the date closest to the given date or undefined if no valid value is given
 *
 * @example
 * // Which date is closer to 6 September 2015?
 * const dateToCompare = new Date(2015, 8, 6)
 * const datesArray = [
 *   new Date(2015, 0, 1),
 *   new Date(2016, 0, 1),
 *   new Date(2017, 0, 1)
 * ]
 * const result = closestIndexTo(dateToCompare, datesArray)
 * //=> 1
 */ function $6d0cce41b204b86d$var$closestIndexTo(dateToCompare, dates) {
    const date = (0, $eimnm.toDate)(dateToCompare);
    if (isNaN(Number(date))) return NaN;
    const timeToCompare = date.getTime();
    let result;
    let minDistance;
    dates.forEach(function(dirtyDate, index) {
        const currentDate = (0, $eimnm.toDate)(dirtyDate);
        if (isNaN(Number(currentDate))) {
            result = NaN;
            minDistance = NaN;
            return;
        }
        const distance = Math.abs(timeToCompare - currentDate.getTime());
        if (result == null || distance < minDistance) {
            result = index;
            minDistance = distance;
        }
    });
    return result;
}

});

parcelRegister("ic8Ws", function(module, exports) {

$parcel$export(module.exports, "closestTo", function () { return $d3f048a36a5693fd$export$73858b464497125a; }, function (v) { return $d3f048a36a5693fd$export$73858b464497125a = v; });
var $d3f048a36a5693fd$export$73858b464497125a;
"use strict";
$d3f048a36a5693fd$export$73858b464497125a = $d3f048a36a5693fd$var$closestTo;

var $909bC = parcelRequire("909bC");

var $eimnm = parcelRequire("eimnm");
/**
 * @name closestTo
 * @category Common Helpers
 * @summary Return a date from the array closest to the given date.
 *
 * @description
 * Return a date from the array closest to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateToCompare - The date to compare with
 * @param dates - The array to search
 *
 * @returns The date from the array closest to the given date or undefined if no valid value is given
 *
 * @example
 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
 * const dateToCompare = new Date(2015, 8, 6)
 * const result = closestTo(dateToCompare, [
 *   new Date(2000, 0, 1),
 *   new Date(2030, 0, 1)
 * ])
 * //=> Tue Jan 01 2030 00:00:00
 */ function $d3f048a36a5693fd$var$closestTo(dateToCompare, dates) {
    const date = (0, $eimnm.toDate)(dateToCompare);
    if (isNaN(Number(date))) return (0, $909bC.constructFrom)(dateToCompare, NaN);
    const timeToCompare = date.getTime();
    let result;
    let minDistance;
    dates.forEach((dirtyDate)=>{
        const currentDate = (0, $eimnm.toDate)(dirtyDate);
        if (isNaN(Number(currentDate))) {
            result = (0, $909bC.constructFrom)(dateToCompare, NaN);
            minDistance = NaN;
            return;
        }
        const distance = Math.abs(timeToCompare - currentDate.getTime());
        if (result == null || distance < minDistance) {
            result = currentDate;
            minDistance = distance;
        }
    });
    return result;
}

});

parcelRegister("3SXyf", function(module, exports) {

$parcel$export(module.exports, "compareAsc", function () { return $2d449bea3139e070$export$fe114145ae75d197; }, function (v) { return $2d449bea3139e070$export$fe114145ae75d197 = v; });
var $2d449bea3139e070$export$fe114145ae75d197;
"use strict";
$2d449bea3139e070$export$fe114145ae75d197 = $2d449bea3139e070$var$compareAsc;

var $eimnm = parcelRequire("eimnm");
/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */ function $2d449bea3139e070$var$compareAsc(dateLeft, dateRight) {
    const _dateLeft = (0, $eimnm.toDate)(dateLeft);
    const _dateRight = (0, $eimnm.toDate)(dateRight);
    const diff = _dateLeft.getTime() - _dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

});

parcelRegister("4rMqp", function(module, exports) {

$parcel$export(module.exports, "compareDesc", function () { return $33cf3f391837dc5c$export$ed84005ac9356f7a; }, function (v) { return $33cf3f391837dc5c$export$ed84005ac9356f7a = v; });
var $33cf3f391837dc5c$export$ed84005ac9356f7a;
"use strict";
$33cf3f391837dc5c$export$ed84005ac9356f7a = $33cf3f391837dc5c$var$compareDesc;

var $eimnm = parcelRequire("eimnm");
/**
 * @name compareDesc
 * @category Common Helpers
 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return -1 if the first date is after the second,
 * 1 if the first date is before the second or 0 if dates are equal.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
 * const result = compareDesc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> 1
 *
 * @example
 * // Sort the array of dates in reverse chronological order:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareDesc)
 * //=> [
 * //   Sun Jul 02 1995 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Wed Feb 11 1987 00:00:00
 * // ]
 */ function $33cf3f391837dc5c$var$compareDesc(dateLeft, dateRight) {
    const _dateLeft = (0, $eimnm.toDate)(dateLeft);
    const _dateRight = (0, $eimnm.toDate)(dateRight);
    const diff = _dateLeft.getTime() - _dateRight.getTime();
    if (diff > 0) return -1;
    else if (diff < 0) return 1;
    else return diff;
}

});

parcelRegister("hubi5", function(module, exports) {

$parcel$export(module.exports, "constructNow", function () { return $cbadff22350de077$export$18c3c6510fb97afc; }, function (v) { return $cbadff22350de077$export$18c3c6510fb97afc = v; });
var $cbadff22350de077$export$18c3c6510fb97afc;
"use strict";
$cbadff22350de077$export$18c3c6510fb97afc = $cbadff22350de077$var$constructNow;

var $909bC = parcelRequire("909bC");
/**
 * @name constructNow
 * @category Generic Helpers
 * @summary Constructs a new current date using the passed value constructor.
 * @pure false
 *
 * @description
 * The function constructs a new current date using the constructor from
 * the reference date. It helps to build generic functions that accept date
 * extensions and use the current date.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 *
 * @returns Current date initialized using the given date constructor
 *
 * @example
 * import { constructNow, isSameDay } from 'date-fns'
 *
 * function isToday<DateType extends Date>(
 *   date: DateType | number | string,
 * ): boolean {
 *   // If we were to use `new Date()` directly, the function would  behave
 *   // differently in different timezones and return false for the same date.
 *   return isSameDay(date, constructNow(date));
 * }
 */ function $cbadff22350de077$var$constructNow(date) {
    return (0, $909bC.constructFrom)(date, Date.now());
}

});

parcelRegister("giA6z", function(module, exports) {

$parcel$export(module.exports, "daysToWeeks", function () { return $bdda557b9de53486$export$66d8b66cbb6006a8; }, function (v) { return $bdda557b9de53486$export$66d8b66cbb6006a8 = v; });
var $bdda557b9de53486$export$66d8b66cbb6006a8;
"use strict";
$bdda557b9de53486$export$66d8b66cbb6006a8 = $bdda557b9de53486$var$daysToWeeks;

var $lILKk = parcelRequire("lILKk");
/**
 * @name daysToWeeks
 * @category Conversion Helpers
 * @summary Convert days to weeks.
 *
 * @description
 * Convert a number of days to a full number of weeks.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param days - The number of days to be converted
 *
 * @returns The number of days converted in weeks
 *
 * @example
 * // Convert 14 days to weeks:
 * const result = daysToWeeks(14)
 * //=> 2
 *
 * @example
 * // It uses trunc rounding:
 * const result = daysToWeeks(13)
 * //=> 1
 */ function $bdda557b9de53486$var$daysToWeeks(days) {
    const weeks = days / $lILKk.daysInWeek;
    const result = Math.trunc(weeks);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});

parcelRegister("8pZAP", function(module, exports) {

$parcel$export(module.exports, "differenceInBusinessDays", function () { return $62106f9d61d8b729$export$f30d3269a6c53cb9; }, function (v) { return $62106f9d61d8b729$export$f30d3269a6c53cb9 = v; });
var $62106f9d61d8b729$export$f30d3269a6c53cb9;
"use strict";
$62106f9d61d8b729$export$f30d3269a6c53cb9 = $62106f9d61d8b729$var$differenceInBusinessDays;

var $qX1g7 = parcelRequire("qX1g7");

var $ctsEq = parcelRequire("ctsEq");

var $8doT3 = parcelRequire("8doT3");

var $drHAt = parcelRequire("drHAt");

var $2DtTD = parcelRequire("2DtTD");

var $eimnm = parcelRequire("eimnm");
/**
 * @name differenceInBusinessDays
 * @category Day Helpers
 * @summary Get the number of business days between the given dates.
 *
 * @description
 * Get the number of business day periods between the given dates.
 * Business days being days that arent in the weekend.
 * Like `differenceInCalendarDays`, the function removes the times from
 * the dates before calculating the difference.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of business days
 *
 * @example
 * // How many business days are between
 * // 10 January 2014 and 20 July 2014?
 * const result = differenceInBusinessDays(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 0, 10)
 * )
 * //=> 136
 *
 * // How many business days are between
 * // 30 November 2021 and 1 November 2021?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 30),
 *   new Date(2021, 10, 1)
 * )
 * //=> 21
 *
 * // How many business days are between
 * // 1 November 2021 and 1 December 2021?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 1),
 *   new Date(2021, 11, 1)
 * )
 * //=> -22
 *
 * // How many business days are between
 * // 1 November 2021 and 1 November 2021 ?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 1),
 *   new Date(2021, 10, 1)
 * )
 * //=> 0
 */ function $62106f9d61d8b729$var$differenceInBusinessDays(dateLeft, dateRight) {
    const _dateLeft = (0, $eimnm.toDate)(dateLeft);
    let _dateRight = (0, $eimnm.toDate)(dateRight);
    if (!(0, $drHAt.isValid)(_dateLeft) || !(0, $drHAt.isValid)(_dateRight)) return NaN;
    const calendarDifference = (0, $ctsEq.differenceInCalendarDays)(_dateLeft, _dateRight);
    const sign = calendarDifference < 0 ? -1 : 1;
    const weeks = Math.trunc(calendarDifference / 7);
    let result = weeks * 5;
    _dateRight = (0, $qX1g7.addDays)(_dateRight, weeks * 7);
    // the loop below will run at most 6 times to account for the remaining days that don't makeup a full week
    while(!(0, $8doT3.isSameDay)(_dateLeft, _dateRight)){
        // sign is used to account for both negative and positive differences
        result += (0, $2DtTD.isWeekend)(_dateRight) ? 0 : sign;
        _dateRight = (0, $qX1g7.addDays)(_dateRight, sign);
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("8doT3", function(module, exports) {

$parcel$export(module.exports, "isSameDay", function () { return $5fb2d7a73e106516$export$ea39ec197993aef0; }, function (v) { return $5fb2d7a73e106516$export$ea39ec197993aef0 = v; });
var $5fb2d7a73e106516$export$ea39ec197993aef0;
"use strict";
$5fb2d7a73e106516$export$ea39ec197993aef0 = $5fb2d7a73e106516$var$isSameDay;

var $klJi0 = parcelRequire("klJi0");
/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same day (and year and month)
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */ function $5fb2d7a73e106516$var$isSameDay(dateLeft, dateRight) {
    const dateLeftStartOfDay = (0, $klJi0.startOfDay)(dateLeft);
    const dateRightStartOfDay = (0, $klJi0.startOfDay)(dateRight);
    return +dateLeftStartOfDay === +dateRightStartOfDay;
}

});

parcelRegister("drHAt", function(module, exports) {

$parcel$export(module.exports, "isValid", function () { return $9c9f9b834fd60585$export$1ea939691cdc45b8; }, function (v) { return $9c9f9b834fd60585$export$1ea939691cdc45b8 = v; });
var $9c9f9b834fd60585$export$1ea939691cdc45b8;
"use strict";
$9c9f9b834fd60585$export$1ea939691cdc45b8 = $9c9f9b834fd60585$var$isValid;

var $ho7Sg = parcelRequire("ho7Sg");

var $eimnm = parcelRequire("eimnm");
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate](https://date-fns.org/docs/toDate)
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is valid
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */ function $9c9f9b834fd60585$var$isValid(date) {
    if (!(0, $ho7Sg.isDate)(date) && typeof date !== "number") return false;
    const _date = (0, $eimnm.toDate)(date);
    return !isNaN(Number(_date));
}

});
parcelRegister("ho7Sg", function(module, exports) {

$parcel$export(module.exports, "isDate", function () { return $ca8ac9394411df94$export$871608497c498473; }, function (v) { return $ca8ac9394411df94$export$871608497c498473 = v; });
var $ca8ac9394411df94$export$871608497c498473;
"use strict";
$ca8ac9394411df94$export$871608497c498473 = $ca8ac9394411df94$var$isDate; /**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ 
function $ca8ac9394411df94$var$isDate(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}

});



parcelRegister("1CHw4", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarISOWeekYears", function () { return $12eb187e1fab1f65$export$7f8a73dc2e50a070; }, function (v) { return $12eb187e1fab1f65$export$7f8a73dc2e50a070 = v; });
var $12eb187e1fab1f65$export$7f8a73dc2e50a070;
"use strict";
$12eb187e1fab1f65$export$7f8a73dc2e50a070 = $12eb187e1fab1f65$var$differenceInCalendarISOWeekYears;

var $4j6Nm = parcelRequire("4j6Nm");
/**
 * @name differenceInCalendarISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of calendar ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of calendar ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar ISO week-numbering years
 *
 * @example
 * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
 * const result = differenceInCalendarISOWeekYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 2
 */ function $12eb187e1fab1f65$var$differenceInCalendarISOWeekYears(dateLeft, dateRight) {
    return (0, $4j6Nm.getISOWeekYear)(dateLeft) - (0, $4j6Nm.getISOWeekYear)(dateRight);
}

});

parcelRegister("b8myz", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarISOWeeks", function () { return $021783e05d35d83a$export$28df1cb58b17e450; }, function (v) { return $021783e05d35d83a$export$28df1cb58b17e450 = v; });
var $021783e05d35d83a$export$28df1cb58b17e450;
"use strict";
$021783e05d35d83a$export$28df1cb58b17e450 = $021783e05d35d83a$var$differenceInCalendarISOWeeks;

var $lILKk = parcelRequire("lILKk");

var $01IXW = parcelRequire("01IXW");

var $i6arj = parcelRequire("i6arj");
/**
 * @name differenceInCalendarISOWeeks
 * @category ISO Week Helpers
 * @summary Get the number of calendar ISO weeks between the given dates.
 *
 * @description
 * Get the number of calendar ISO weeks between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar ISO weeks
 *
 * @example
 * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
 * const result = differenceInCalendarISOWeeks(
 *   new Date(2014, 6, 21),
 *   new Date(2014, 6, 6)
 * )
 * //=> 3
 */ function $021783e05d35d83a$var$differenceInCalendarISOWeeks(dateLeft, dateRight) {
    const startOfISOWeekLeft = (0, $01IXW.startOfISOWeek)(dateLeft);
    const startOfISOWeekRight = (0, $01IXW.startOfISOWeek)(dateRight);
    const timestampLeft = +startOfISOWeekLeft - (0, $i6arj.getTimezoneOffsetInMilliseconds)(startOfISOWeekLeft);
    const timestampRight = +startOfISOWeekRight - (0, $i6arj.getTimezoneOffsetInMilliseconds)(startOfISOWeekRight);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / $lILKk.millisecondsInWeek);
}

});

parcelRegister("ecPWs", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarMonths", function () { return $a57a7a42125e0329$export$489984ac7c996389; }, function (v) { return $a57a7a42125e0329$export$489984ac7c996389 = v; });
var $a57a7a42125e0329$export$489984ac7c996389;
"use strict";
$a57a7a42125e0329$export$489984ac7c996389 = $a57a7a42125e0329$var$differenceInCalendarMonths;

var $eimnm = parcelRequire("eimnm");
/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */ function $a57a7a42125e0329$var$differenceInCalendarMonths(dateLeft, dateRight) {
    const _dateLeft = (0, $eimnm.toDate)(dateLeft);
    const _dateRight = (0, $eimnm.toDate)(dateRight);
    const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
    const monthDiff = _dateLeft.getMonth() - _dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

});

parcelRegister("4Ccub", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarQuarters", function () { return $35c465701284a816$export$f62ae9fb13958c7a; }, function (v) { return $35c465701284a816$export$f62ae9fb13958c7a = v; });
var $35c465701284a816$export$f62ae9fb13958c7a;
"use strict";
$35c465701284a816$export$f62ae9fb13958c7a = $35c465701284a816$var$differenceInCalendarQuarters;

var $aVDAA = parcelRequire("aVDAA");

var $eimnm = parcelRequire("eimnm");
/**
 * @name differenceInCalendarQuarters
 * @category Quarter Helpers
 * @summary Get the number of calendar quarters between the given dates.
 *
 * @description
 * Get the number of calendar quarters between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date

 * @returns The number of calendar quarters
 *
 * @example
 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInCalendarQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 3
 */ function $35c465701284a816$var$differenceInCalendarQuarters(dateLeft, dateRight) {
    const _dateLeft = (0, $eimnm.toDate)(dateLeft);
    const _dateRight = (0, $eimnm.toDate)(dateRight);
    const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
    const quarterDiff = (0, $aVDAA.getQuarter)(_dateLeft) - (0, $aVDAA.getQuarter)(_dateRight);
    return yearDiff * 4 + quarterDiff;
}

});
parcelRegister("aVDAA", function(module, exports) {

$parcel$export(module.exports, "getQuarter", function () { return $7f4defd0639d7aaf$export$de90a4bb31c25221; }, function (v) { return $7f4defd0639d7aaf$export$de90a4bb31c25221 = v; });
var $7f4defd0639d7aaf$export$de90a4bb31c25221;
"use strict";
$7f4defd0639d7aaf$export$de90a4bb31c25221 = $7f4defd0639d7aaf$var$getQuarter;

var $eimnm = parcelRequire("eimnm");
/**
 * @name getQuarter
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The quarter
 *
 * @example
 * // Which quarter is 2 July 2014?
 * const result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */ function $7f4defd0639d7aaf$var$getQuarter(date) {
    const _date = (0, $eimnm.toDate)(date);
    const quarter = Math.trunc(_date.getMonth() / 3) + 1;
    return quarter;
}

});


parcelRegister("7pWjY", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarWeeks", function () { return $56681b906a08484c$export$6ed034ce62348e4; }, function (v) { return $56681b906a08484c$export$6ed034ce62348e4 = v; });
var $56681b906a08484c$export$6ed034ce62348e4;
"use strict";
$56681b906a08484c$export$6ed034ce62348e4 = $56681b906a08484c$var$differenceInCalendarWeeks;

var $lILKk = parcelRequire("lILKk");

var $79XR6 = parcelRequire("79XR6");

var $i6arj = parcelRequire("i6arj");
/**
 * The {@link differenceInCalendarWeeks} function options.
 */ /**
 * @name differenceInCalendarWeeks
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of calendar weeks
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   { weekStartsOn: 1 }
 * )
 * //=> 2
 */ function $56681b906a08484c$var$differenceInCalendarWeeks(dateLeft, dateRight, options) {
    const startOfWeekLeft = (0, $79XR6.startOfWeek)(dateLeft, options);
    const startOfWeekRight = (0, $79XR6.startOfWeek)(dateRight, options);
    const timestampLeft = +startOfWeekLeft - (0, $i6arj.getTimezoneOffsetInMilliseconds)(startOfWeekLeft);
    const timestampRight = +startOfWeekRight - (0, $i6arj.getTimezoneOffsetInMilliseconds)(startOfWeekRight);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a days is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / $lILKk.millisecondsInWeek);
}

});

parcelRegister("dQFcH", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarYears", function () { return $a15017e3ae5446d9$export$c06dce8b38891685; }, function (v) { return $a15017e3ae5446d9$export$c06dce8b38891685 = v; });
var $a15017e3ae5446d9$export$c06dce8b38891685;
"use strict";
$a15017e3ae5446d9$export$c06dce8b38891685 = $a15017e3ae5446d9$var$differenceInCalendarYears;

var $eimnm = parcelRequire("eimnm");
/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date

 * @returns The number of calendar years
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */ function $a15017e3ae5446d9$var$differenceInCalendarYears(dateLeft, dateRight) {
    const _dateLeft = (0, $eimnm.toDate)(dateLeft);
    const _dateRight = (0, $eimnm.toDate)(dateRight);
    return _dateLeft.getFullYear() - _dateRight.getFullYear();
}

});

parcelRegister("h7pQw", function(module, exports) {

$parcel$export(module.exports, "differenceInDays", function () { return $c76723a045224e6f$export$86415ebf4eb36b8c; }, function (v) { return $c76723a045224e6f$export$86415ebf4eb36b8c = v; });
var $c76723a045224e6f$export$86415ebf4eb36b8c;
"use strict";
$c76723a045224e6f$export$86415ebf4eb36b8c = $c76723a045224e6f$var$differenceInDays;

var $ctsEq = parcelRequire("ctsEq");

var $eimnm = parcelRequire("eimnm");
/**
 * @name differenceInDays
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full day periods between two dates. Fractional days are
 * truncated towards zero.
 *
 * One "full day" is the distance between a local time in one day to the same
 * local time on the next or previous day. A full day can sometimes be less than
 * or more than 24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 24-hour periods, use this instead:
 * `Math.trunc(differenceInHours(dateLeft, dateRight)/24)|0`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full days according to the local timezone
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 0
 *
 * @example
 * // How many full days are between
 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 92 days, even in
 * // time zones where DST starts and the
 * // period has only 92*24-1 hours.
 * const result = differenceInDays(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 1)
 * )
 * //=> 92
 */ function $c76723a045224e6f$var$differenceInDays(dateLeft, dateRight) {
    const _dateLeft = (0, $eimnm.toDate)(dateLeft);
    const _dateRight = (0, $eimnm.toDate)(dateRight);
    const sign = $c76723a045224e6f$var$compareLocalAsc(_dateLeft, _dateRight);
    const difference = Math.abs((0, $ctsEq.differenceInCalendarDays)(_dateLeft, _dateRight));
    _dateLeft.setDate(_dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastDayNotFull = Number($c76723a045224e6f$var$compareLocalAsc(_dateLeft, _dateRight) === -sign);
    const result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
// Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $c76723a045224e6f$var$compareLocalAsc(dateLeft, dateRight) {
    const diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

});

parcelRegister("2ORBN", function(module, exports) {

$parcel$export(module.exports, "differenceInHours", function () { return $20d9d5d133a38890$export$5436ca250d4d6872; }, function (v) { return $20d9d5d133a38890$export$5436ca250d4d6872 = v; });
var $20d9d5d133a38890$export$5436ca250d4d6872;
"use strict";
$20d9d5d133a38890$export$5436ca250d4d6872 = $20d9d5d133a38890$var$differenceInHours;

var $fosqj = parcelRequire("fosqj");

var $lILKk = parcelRequire("lILKk");

var $46Qms = parcelRequire("46Qms");
/**
 * The {@link differenceInHours} function options.
 */ /**
 * @name differenceInHours
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of hours
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * const result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */ function $20d9d5d133a38890$var$differenceInHours(dateLeft, dateRight, options) {
    const diff = (0, $46Qms.differenceInMilliseconds)(dateLeft, dateRight) / $lILKk.millisecondsInHour;
    return (0, $fosqj.getRoundingMethod)(options?.roundingMethod)(diff);
}

});
parcelRegister("fosqj", function(module, exports) {

$parcel$export(module.exports, "getRoundingMethod", function () { return $b34f2533d0486594$export$b6474a47258c1211; }, function (v) { return $b34f2533d0486594$export$b6474a47258c1211 = v; });
var $b34f2533d0486594$export$b6474a47258c1211;
"use strict";
$b34f2533d0486594$export$b6474a47258c1211 = $b34f2533d0486594$var$getRoundingMethod;
function $b34f2533d0486594$var$getRoundingMethod(method) {
    return (number)=>{
        const round = method ? Math[method] : Math.trunc;
        const result = round(number);
        // Prevent negative zero
        return result === 0 ? 0 : result;
    };
}

});

parcelRegister("46Qms", function(module, exports) {

$parcel$export(module.exports, "differenceInMilliseconds", function () { return $2fe056cfc2f89059$export$7be94d13716b4bf6; }, function (v) { return $2fe056cfc2f89059$export$7be94d13716b4bf6 = v; });
var $2fe056cfc2f89059$export$7be94d13716b4bf6;
"use strict";
$2fe056cfc2f89059$export$7be94d13716b4bf6 = $2fe056cfc2f89059$var$differenceInMilliseconds;

var $eimnm = parcelRequire("eimnm");
/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of milliseconds
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * const result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */ function $2fe056cfc2f89059$var$differenceInMilliseconds(dateLeft, dateRight) {
    return +(0, $eimnm.toDate)(dateLeft) - +(0, $eimnm.toDate)(dateRight);
}

});


parcelRegister("kFLdB", function(module, exports) {

$parcel$export(module.exports, "differenceInISOWeekYears", function () { return $f0cc439915784a23$export$bf7bde0b3bf8913a; }, function (v) { return $f0cc439915784a23$export$bf7bde0b3bf8913a = v; });
var $f0cc439915784a23$export$bf7bde0b3bf8913a;
"use strict";
$f0cc439915784a23$export$bf7bde0b3bf8913a = $f0cc439915784a23$var$differenceInISOWeekYears;

var $3SXyf = parcelRequire("3SXyf");

var $1CHw4 = parcelRequire("1CHw4");

var $5Ie3a = parcelRequire("5Ie3a");

var $eimnm = parcelRequire("eimnm");
/**
 * @name differenceInISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of full ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of full ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full ISO week-numbering years
 *
 * @example
 * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
 * const result = differenceInISOWeekYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 1
 */ function $f0cc439915784a23$var$differenceInISOWeekYears(dateLeft, dateRight) {
    let _dateLeft = (0, $eimnm.toDate)(dateLeft);
    const _dateRight = (0, $eimnm.toDate)(dateRight);
    const sign = (0, $3SXyf.compareAsc)(_dateLeft, _dateRight);
    const difference = Math.abs((0, $1CHw4.differenceInCalendarISOWeekYears)(_dateLeft, _dateRight));
    _dateLeft = (0, $5Ie3a.subISOWeekYears)(_dateLeft, sign * difference);
    // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
    // if last calendar ISO year is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastISOWeekYearNotFull = Number((0, $3SXyf.compareAsc)(_dateLeft, _dateRight) === -sign);
    const result = sign * (difference - isLastISOWeekYearNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("5Ie3a", function(module, exports) {

$parcel$export(module.exports, "subISOWeekYears", function () { return $428bf5e187dace5d$export$4f7d47b952f4a0aa; }, function (v) { return $428bf5e187dace5d$export$4f7d47b952f4a0aa = v; });
var $428bf5e187dace5d$export$4f7d47b952f4a0aa;
"use strict";
$428bf5e187dace5d$export$4f7d47b952f4a0aa = $428bf5e187dace5d$var$subISOWeekYears;

var $b4qzk = parcelRequire("b4qzk");
/**
 * @name subISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Subtract the specified number of ISO week-numbering years from the given date.
 *
 * @description
 * Subtract the specified number of ISO week-numbering years from the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of ISO week-numbering years to be subtracted.
 *
 * @returns The new date with the ISO week-numbering years subtracted
 *
 * @example
 * // Subtract 5 ISO week-numbering years from 1 September 2014:
 * const result = subISOWeekYears(new Date(2014, 8, 1), 5)
 * //=> Mon Aug 31 2009 00:00:00
 */ function $428bf5e187dace5d$var$subISOWeekYears(date, amount) {
    return (0, $b4qzk.addISOWeekYears)(date, -amount);
}

});


parcelRegister("5luLe", function(module, exports) {

$parcel$export(module.exports, "differenceInMinutes", function () { return $3e46c65d026befdc$export$d904251335be481a; }, function (v) { return $3e46c65d026befdc$export$d904251335be481a = v; });
var $3e46c65d026befdc$export$d904251335be481a;
"use strict";
$3e46c65d026befdc$export$d904251335be481a = $3e46c65d026befdc$var$differenceInMinutes;

var $fosqj = parcelRequire("fosqj");

var $lILKk = parcelRequire("lILKk");

var $46Qms = parcelRequire("46Qms");
/**
 * The {@link differenceInMinutes} function options.
 */ /**
 * @name differenceInMinutes
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the signed number of full (rounded towards 0) minutes between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of minutes
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * const result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 *
 * @example
 * // How many minutes are between 10:01:59 and 10:00:00
 * const result = differenceInMinutes(
 *   new Date(2000, 0, 1, 10, 0, 0),
 *   new Date(2000, 0, 1, 10, 1, 59)
 * )
 * //=> -1
 */ function $3e46c65d026befdc$var$differenceInMinutes(dateLeft, dateRight, options) {
    const diff = (0, $46Qms.differenceInMilliseconds)(dateLeft, dateRight) / $lILKk.millisecondsInMinute;
    return (0, $fosqj.getRoundingMethod)(options?.roundingMethod)(diff);
}

});

parcelRegister("6GN1F", function(module, exports) {

$parcel$export(module.exports, "differenceInMonths", function () { return $4decb1d69f0a2431$export$fc1ed482c2861792; }, function (v) { return $4decb1d69f0a2431$export$fc1ed482c2861792 = v; });
var $4decb1d69f0a2431$export$fc1ed482c2861792;
"use strict";
$4decb1d69f0a2431$export$fc1ed482c2861792 = $4decb1d69f0a2431$var$differenceInMonths;

var $3SXyf = parcelRequire("3SXyf");

var $ecPWs = parcelRequire("ecPWs");

var $4qcp8 = parcelRequire("4qcp8");

var $eimnm = parcelRequire("eimnm");
/**
 * @name differenceInMonths
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates using trunc as a default rounding method.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full months
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
 * //=> 7
 */ function $4decb1d69f0a2431$var$differenceInMonths(dateLeft, dateRight) {
    const _dateLeft = (0, $eimnm.toDate)(dateLeft);
    const _dateRight = (0, $eimnm.toDate)(dateRight);
    const sign = (0, $3SXyf.compareAsc)(_dateLeft, _dateRight);
    const difference = Math.abs((0, $ecPWs.differenceInCalendarMonths)(_dateLeft, _dateRight));
    let result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (_dateLeft.getMonth() === 1 && _dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        _dateLeft.setDate(30);
        _dateLeft.setMonth(_dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        let isLastMonthNotFull = (0, $3SXyf.compareAsc)(_dateLeft, _dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $4qcp8.isLastDayOfMonth)((0, $eimnm.toDate)(dateLeft)) && difference === 1 && (0, $3SXyf.compareAsc)(dateLeft, _dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("4qcp8", function(module, exports) {

$parcel$export(module.exports, "isLastDayOfMonth", function () { return $338336631265867b$export$c817d0312007ea5e; }, function (v) { return $338336631265867b$export$c817d0312007ea5e = v; });
var $338336631265867b$export$c817d0312007ea5e;
"use strict";
$338336631265867b$export$c817d0312007ea5e = $338336631265867b$var$isLastDayOfMonth;

var $6Fi1I = parcelRequire("6Fi1I");

var $jrtnH = parcelRequire("jrtnH");

var $eimnm = parcelRequire("eimnm");
/**
 * @name isLastDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check

 * @returns The date is the last day of a month
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * const result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */ function $338336631265867b$var$isLastDayOfMonth(date) {
    const _date = (0, $eimnm.toDate)(date);
    return +(0, $6Fi1I.endOfDay)(_date) === +(0, $jrtnH.endOfMonth)(_date);
}

});
parcelRegister("6Fi1I", function(module, exports) {

$parcel$export(module.exports, "endOfDay", function () { return $4da48e2675aed667$export$eb9a03f0e9aa6cea; }, function (v) { return $4da48e2675aed667$export$eb9a03f0e9aa6cea = v; });
var $4da48e2675aed667$export$eb9a03f0e9aa6cea;
"use strict";
$4da48e2675aed667$export$eb9a03f0e9aa6cea = $4da48e2675aed667$var$endOfDay;

var $eimnm = parcelRequire("eimnm");
/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a day
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */ function $4da48e2675aed667$var$endOfDay(date) {
    const _date = (0, $eimnm.toDate)(date);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRegister("jrtnH", function(module, exports) {

$parcel$export(module.exports, "endOfMonth", function () { return $e277546e059abe3e$export$a2258d9c4118825c; }, function (v) { return $e277546e059abe3e$export$a2258d9c4118825c = v; });
var $e277546e059abe3e$export$a2258d9c4118825c;
"use strict";
$e277546e059abe3e$export$a2258d9c4118825c = $e277546e059abe3e$var$endOfMonth;

var $eimnm = parcelRequire("eimnm");
/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a month
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */ function $e277546e059abe3e$var$endOfMonth(date) {
    const _date = (0, $eimnm.toDate)(date);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});



parcelRegister("l9Hdw", function(module, exports) {

$parcel$export(module.exports, "differenceInQuarters", function () { return $f66bf63eb2a0dbc2$export$74b5c4055a405552; }, function (v) { return $f66bf63eb2a0dbc2$export$74b5c4055a405552 = v; });
var $f66bf63eb2a0dbc2$export$74b5c4055a405552;
"use strict";
$f66bf63eb2a0dbc2$export$74b5c4055a405552 = $f66bf63eb2a0dbc2$var$differenceInQuarters;

var $fosqj = parcelRequire("fosqj");

var $6GN1F = parcelRequire("6GN1F");
/**
 * The {@link differenceInQuarters} function options.
 */ /**
 * @name differenceInQuarters
 * @category Quarter Helpers
 * @summary Get the number of quarters between the given dates.
 *
 * @description
 * Get the number of quarters between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of full quarters
 *
 * @example
 * // How many full quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInQuarters(new Date(2014, 6, 2), new Date(2013, 11, 31))
 * //=> 2
 */ function $f66bf63eb2a0dbc2$var$differenceInQuarters(dateLeft, dateRight, options) {
    const diff = (0, $6GN1F.differenceInMonths)(dateLeft, dateRight) / 3;
    return (0, $fosqj.getRoundingMethod)(options?.roundingMethod)(diff);
}

});

parcelRegister("cTY1w", function(module, exports) {

$parcel$export(module.exports, "differenceInSeconds", function () { return $96492e89750fc262$export$c1889aec51783710; }, function (v) { return $96492e89750fc262$export$c1889aec51783710 = v; });
var $96492e89750fc262$export$c1889aec51783710;
"use strict";
$96492e89750fc262$export$c1889aec51783710 = $96492e89750fc262$var$differenceInSeconds;

var $fosqj = parcelRequire("fosqj");

var $46Qms = parcelRequire("46Qms");
/**
 * The {@link differenceInSeconds} function options.
 */ /**
 * @name differenceInSeconds
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of seconds
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * const result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */ function $96492e89750fc262$var$differenceInSeconds(dateLeft, dateRight, options) {
    const diff = (0, $46Qms.differenceInMilliseconds)(dateLeft, dateRight) / 1000;
    return (0, $fosqj.getRoundingMethod)(options?.roundingMethod)(diff);
}

});

parcelRegister("3B2JB", function(module, exports) {

$parcel$export(module.exports, "differenceInWeeks", function () { return $29e6f2d1c7e8a584$export$b5147a91dc40ddb7; }, function (v) { return $29e6f2d1c7e8a584$export$b5147a91dc40ddb7 = v; });
var $29e6f2d1c7e8a584$export$b5147a91dc40ddb7;
"use strict";
$29e6f2d1c7e8a584$export$b5147a91dc40ddb7 = $29e6f2d1c7e8a584$var$differenceInWeeks;

var $fosqj = parcelRequire("fosqj");

var $h7pQw = parcelRequire("h7pQw");
/**
 * The {@link differenceInWeeks} function options.
 */ /**
 * @name differenceInWeeks
 * @category Week Helpers
 * @summary Get the number of full weeks between the given dates.
 *
 * @description
 * Get the number of full weeks between two dates. Fractional weeks are
 * truncated towards zero by default.
 *
 * One "full week" is the distance between a local time in one day to the same
 * local time 7 days earlier or later. A full week can sometimes be less than
 * or more than 7*24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 7*24-hour periods, use this instead:
 * `Math.trunc(differenceInHours(dateLeft, dateRight)/(7*24))|0`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options
 *
 * @returns The number of full weeks
 *
 * @example
 * // How many full weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInWeeks(new Date(2014, 6, 20), new Date(2014, 6, 5))
 * //=> 2
 *
 * @example
 * // How many full weeks are between
 * // 1 March 2020 0:00 and 6 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 8 weeks (54 days),
 * // even if DST starts and the period has
 * // only 54*24-1 hours.
 * const result = differenceInWeeks(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 6)
 * )
 * //=> 8
 */ function $29e6f2d1c7e8a584$var$differenceInWeeks(dateLeft, dateRight, options) {
    const diff = (0, $h7pQw.differenceInDays)(dateLeft, dateRight) / 7;
    return (0, $fosqj.getRoundingMethod)(options?.roundingMethod)(diff);
}

});

parcelRegister("f6fMN", function(module, exports) {

$parcel$export(module.exports, "differenceInYears", function () { return $afe3a950dfd17b25$export$ed6bf486f68899ca; }, function (v) { return $afe3a950dfd17b25$export$ed6bf486f68899ca = v; });
var $afe3a950dfd17b25$export$ed6bf486f68899ca;
"use strict";
$afe3a950dfd17b25$export$ed6bf486f68899ca = $afe3a950dfd17b25$var$differenceInYears;

var $3SXyf = parcelRequire("3SXyf");

var $dQFcH = parcelRequire("dQFcH");

var $eimnm = parcelRequire("eimnm");
/**
 * @name differenceInYears
 * @category Year Helpers
 * @summary Get the number of full years between the given dates.
 *
 * @description
 * Get the number of full years between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full years
 *
 * @example
 * // How many full years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInYears(new Date(2015, 1, 11), new Date(2013, 11, 31))
 * //=> 1
 */ function $afe3a950dfd17b25$var$differenceInYears(dateLeft, dateRight) {
    const _dateLeft = (0, $eimnm.toDate)(dateLeft);
    const _dateRight = (0, $eimnm.toDate)(dateRight);
    const sign = (0, $3SXyf.compareAsc)(_dateLeft, _dateRight);
    const difference = Math.abs((0, $dQFcH.differenceInCalendarYears)(_dateLeft, _dateRight));
    // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    _dateLeft.setFullYear(1584);
    _dateRight.setFullYear(1584);
    // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastYearNotFull = (0, $3SXyf.compareAsc)(_dateLeft, _dateRight) === -sign;
    const result = sign * (difference - +isLastYearNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});

parcelRegister("64nK0", function(module, exports) {

$parcel$export(module.exports, "eachDayOfInterval", function () { return $46b5884421607d80$export$7a337e5923c7ceb5; }, function (v) { return $46b5884421607d80$export$7a337e5923c7ceb5 = v; });
var $46b5884421607d80$export$7a337e5923c7ceb5;
"use strict";
$46b5884421607d80$export$7a337e5923c7ceb5 = $46b5884421607d80$var$eachDayOfInterval;

var $eimnm = parcelRequire("eimnm");
/**
 * The {@link eachDayOfInterval} function options.
 */ /**
 * @name eachDayOfInterval
 * @category Interval Helpers
 * @summary Return the array of dates within the specified time interval.
 *
 * @description
 * Return the array of dates within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of days from the day of the interval start to the day of the interval end
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * const result = eachDayOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 9, 10)
 * })
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */ function $46b5884421607d80$var$eachDayOfInterval(interval, options) {
    const startDate = (0, $eimnm.toDate)(interval.start);
    const endDate = (0, $eimnm.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    const currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $eimnm.toDate)(currentDate));
        currentDate.setDate(currentDate.getDate() + step);
        currentDate.setHours(0, 0, 0, 0);
    }
    return reversed ? dates.reverse() : dates;
}

});

parcelRegister("b2bJT", function(module, exports) {

$parcel$export(module.exports, "eachHourOfInterval", function () { return $8088fcc422227a79$export$bb4f48fee90ea86e; }, function (v) { return $8088fcc422227a79$export$bb4f48fee90ea86e = v; });
var $8088fcc422227a79$export$bb4f48fee90ea86e;
"use strict";
$8088fcc422227a79$export$bb4f48fee90ea86e = $8088fcc422227a79$var$eachHourOfInterval;

var $lTL64 = parcelRequire("lTL64");

var $eimnm = parcelRequire("eimnm");
/**
 * The {@link eachHourOfInterval} function options.
 */ /**
 * @name eachHourOfInterval
 * @category Interval Helpers
 * @summary Return the array of hours within the specified time interval.
 *
 * @description
 * Return the array of hours within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of hours from the hour of the interval start to the hour of the interval end
 *
 * @example
 * // Each hour between 6 October 2014, 12:00 and 6 October 2014, 15:00
 * const result = eachHourOfInterval({
 *   start: new Date(2014, 9, 6, 12),
 *   end: new Date(2014, 9, 6, 15)
 * })
 * //=> [
 * //   Mon Oct 06 2014 12:00:00,
 * //   Mon Oct 06 2014 13:00:00,
 * //   Mon Oct 06 2014 14:00:00,
 * //   Mon Oct 06 2014 15:00:00
 * // ]
 */ function $8088fcc422227a79$var$eachHourOfInterval(interval, options) {
    const startDate = (0, $eimnm.toDate)(interval.start);
    const endDate = (0, $eimnm.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    let currentDate = reversed ? endDate : startDate;
    currentDate.setMinutes(0, 0, 0);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $eimnm.toDate)(currentDate));
        currentDate = (0, $lTL64.addHours)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}

});

parcelRegister("e6hcg", function(module, exports) {

$parcel$export(module.exports, "eachMinuteOfInterval", function () { return $a43ef72d5b924f04$export$82e17d693ce9eb6c; }, function (v) { return $a43ef72d5b924f04$export$82e17d693ce9eb6c = v; });
var $a43ef72d5b924f04$export$82e17d693ce9eb6c;
"use strict";
$a43ef72d5b924f04$export$82e17d693ce9eb6c = $a43ef72d5b924f04$var$eachMinuteOfInterval;

var $h7zV9 = parcelRequire("h7zV9");

var $jKKUM = parcelRequire("jKKUM");

var $eimnm = parcelRequire("eimnm");
/**
 * The {@link eachMinuteOfInterval} function options.
 */ /**
 * @name eachMinuteOfInterval
 * @category Interval Helpers
 * @summary Return the array of minutes within the specified time interval.
 *
 * @description
 * Returns the array of minutes within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of minutes from the minute of the interval start to the minute of the interval end
 *
 * @example
 * // Each minute between 14 October 2020, 13:00 and 14 October 2020, 13:03
 * const result = eachMinuteOfInterval({
 *   start: new Date(2014, 9, 14, 13),
 *   end: new Date(2014, 9, 14, 13, 3)
 * })
 * //=> [
 * //   Wed Oct 14 2014 13:00:00,
 * //   Wed Oct 14 2014 13:01:00,
 * //   Wed Oct 14 2014 13:02:00,
 * //   Wed Oct 14 2014 13:03:00
 * // ]
 */ function $a43ef72d5b924f04$var$eachMinuteOfInterval(interval, options) {
    const startDate = (0, $jKKUM.startOfMinute)((0, $eimnm.toDate)(interval.start));
    const endDate = (0, $eimnm.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    let currentDate = reversed ? endDate : startDate;
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $eimnm.toDate)(currentDate));
        currentDate = (0, $h7zV9.addMinutes)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}

});
parcelRegister("jKKUM", function(module, exports) {

$parcel$export(module.exports, "startOfMinute", function () { return $e616b47d85b51d03$export$c66440458c6aa793; }, function (v) { return $e616b47d85b51d03$export$c66440458c6aa793 = v; });
var $e616b47d85b51d03$export$c66440458c6aa793;
"use strict";
$e616b47d85b51d03$export$c66440458c6aa793 = $e616b47d85b51d03$var$startOfMinute;

var $eimnm = parcelRequire("eimnm");
/**
 * @name startOfMinute
 * @category Minute Helpers
 * @summary Return the start of a minute for the given date.
 *
 * @description
 * Return the start of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a minute
 *
 * @example
 * // The start of a minute for 1 December 2014 22:15:45.400:
 * const result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:00
 */ function $e616b47d85b51d03$var$startOfMinute(date) {
    const _date = (0, $eimnm.toDate)(date);
    _date.setSeconds(0, 0);
    return _date;
}

});


parcelRegister("5N5lh", function(module, exports) {

$parcel$export(module.exports, "eachMonthOfInterval", function () { return $4375ac3b4425790b$export$1c9322f2d2a5eed3; }, function (v) { return $4375ac3b4425790b$export$1c9322f2d2a5eed3 = v; });
var $4375ac3b4425790b$export$1c9322f2d2a5eed3;
"use strict";
$4375ac3b4425790b$export$1c9322f2d2a5eed3 = $4375ac3b4425790b$var$eachMonthOfInterval;

var $eimnm = parcelRequire("eimnm");
/**
 * The {@link eachMonthOfInterval} function options.
 */ /**
 * @name eachMonthOfInterval
 * @category Interval Helpers
 * @summary Return the array of months within the specified time interval.
 *
 * @description
 * Return the array of months within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval
 *
 * @returns The array with starts of months from the month of the interval start to the month of the interval end
 *
 * @example
 * // Each month between 6 February 2014 and 10 August 2014:
 * const result = eachMonthOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2014, 7, 10)
 * })
 * //=> [
 * //   Sat Feb 01 2014 00:00:00,
 * //   Sat Mar 01 2014 00:00:00,
 * //   Tue Apr 01 2014 00:00:00,
 * //   Thu May 01 2014 00:00:00,
 * //   Sun Jun 01 2014 00:00:00,
 * //   Tue Jul 01 2014 00:00:00,
 * //   Fri Aug 01 2014 00:00:00
 * // ]
 */ function $4375ac3b4425790b$var$eachMonthOfInterval(interval, options) {
    const startDate = (0, $eimnm.toDate)(interval.start);
    const endDate = (0, $eimnm.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    const currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    currentDate.setDate(1);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $eimnm.toDate)(currentDate));
        currentDate.setMonth(currentDate.getMonth() + step);
    }
    return reversed ? dates.reverse() : dates;
}

});

parcelRegister("bRY2p", function(module, exports) {

$parcel$export(module.exports, "eachQuarterOfInterval", function () { return $8a43373abc8011af$export$96790a0abfab0078; }, function (v) { return $8a43373abc8011af$export$96790a0abfab0078 = v; });
var $8a43373abc8011af$export$96790a0abfab0078;
"use strict";
$8a43373abc8011af$export$96790a0abfab0078 = $8a43373abc8011af$var$eachQuarterOfInterval;

var $7pM9n = parcelRequire("7pM9n");

var $bPqKl = parcelRequire("bPqKl");

var $eimnm = parcelRequire("eimnm");
/**
 * The {@link eachQuarterOfInterval} function options.
 */ /**
 * @name eachQuarterOfInterval
 * @category Interval Helpers
 * @summary Return the array of quarters within the specified time interval.
 *
 * @description
 * Return the array of quarters within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval
 *
 * @returns The array with starts of quarters from the quarter of the interval start to the quarter of the interval end
 *
 * @example
 * // Each quarter within interval 6 February 2014 - 10 August 2014:
 * const result = eachQuarterOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2014, 7, 10)
 * })
 * //=> [
 * //   Wed Jan 01 2014 00:00:00,
 * //   Tue Apr 01 2014 00:00:00,
 * //   Tue Jul 01 2014 00:00:00,
 * // ]
 */ function $8a43373abc8011af$var$eachQuarterOfInterval(interval, options) {
    const startDate = (0, $eimnm.toDate)(interval.start);
    const endDate = (0, $eimnm.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +(0, $bPqKl.startOfQuarter)(startDate) : +(0, $bPqKl.startOfQuarter)(endDate);
    let currentDate = reversed ? (0, $bPqKl.startOfQuarter)(endDate) : (0, $bPqKl.startOfQuarter)(startDate);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $eimnm.toDate)(currentDate));
        currentDate = (0, $7pM9n.addQuarters)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}

});
parcelRegister("bPqKl", function(module, exports) {

$parcel$export(module.exports, "startOfQuarter", function () { return $0238ec3365dbb886$export$69be7267a042ecb3; }, function (v) { return $0238ec3365dbb886$export$69be7267a042ecb3 = v; });
var $0238ec3365dbb886$export$69be7267a042ecb3;
"use strict";
$0238ec3365dbb886$export$69be7267a042ecb3 = $0238ec3365dbb886$var$startOfQuarter;

var $eimnm = parcelRequire("eimnm");
/**
 * @name startOfQuarter
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a quarter
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */ function $0238ec3365dbb886$var$startOfQuarter(date) {
    const _date = (0, $eimnm.toDate)(date);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3;
    _date.setMonth(month, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});


parcelRegister("doqTC", function(module, exports) {

$parcel$export(module.exports, "eachWeekOfInterval", function () { return $9c0261468499d67b$export$d31a8caec75fa456; }, function (v) { return $9c0261468499d67b$export$d31a8caec75fa456 = v; });
var $9c0261468499d67b$export$d31a8caec75fa456;
"use strict";
$9c0261468499d67b$export$d31a8caec75fa456 = $9c0261468499d67b$var$eachWeekOfInterval;

var $6T9jK = parcelRequire("6T9jK");

var $79XR6 = parcelRequire("79XR6");

var $eimnm = parcelRequire("eimnm");
/**
 * The {@link eachWeekOfInterval} function options.
 */ /**
 * @name eachWeekOfInterval
 * @category Interval Helpers
 * @summary Return the array of weeks within the specified time interval.
 *
 * @description
 * Return the array of weeks within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of weeks from the week of the interval start to the week of the interval end
 *
 * @example
 * // Each week within interval 6 October 2014 - 23 November 2014:
 * const result = eachWeekOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 10, 23)
 * })
 * //=> [
 * //   Sun Oct 05 2014 00:00:00,
 * //   Sun Oct 12 2014 00:00:00,
 * //   Sun Oct 19 2014 00:00:00,
 * //   Sun Oct 26 2014 00:00:00,
 * //   Sun Nov 02 2014 00:00:00,
 * //   Sun Nov 09 2014 00:00:00,
 * //   Sun Nov 16 2014 00:00:00,
 * //   Sun Nov 23 2014 00:00:00
 * // ]
 */ function $9c0261468499d67b$var$eachWeekOfInterval(interval, options) {
    const startDate = (0, $eimnm.toDate)(interval.start);
    const endDate = (0, $eimnm.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const startDateWeek = reversed ? (0, $79XR6.startOfWeek)(endDate, options) : (0, $79XR6.startOfWeek)(startDate, options);
    const endDateWeek = reversed ? (0, $79XR6.startOfWeek)(startDate, options) : (0, $79XR6.startOfWeek)(endDate, options);
    // Some timezones switch DST at midnight, making start of day unreliable in these timezones, 3pm is a safe bet
    startDateWeek.setHours(15);
    endDateWeek.setHours(15);
    const endTime = +endDateWeek.getTime();
    let currentDate = startDateWeek;
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        currentDate.setHours(0);
        dates.push((0, $eimnm.toDate)(currentDate));
        currentDate = (0, $6T9jK.addWeeks)(currentDate, step);
        currentDate.setHours(15);
    }
    return reversed ? dates.reverse() : dates;
}

});

parcelRegister("8VtqC", function(module, exports) {

$parcel$export(module.exports, "eachWeekendOfInterval", function () { return $67fa797255ff85aa$export$a2ae85dd849354a8; }, function (v) { return $67fa797255ff85aa$export$a2ae85dd849354a8 = v; });
var $67fa797255ff85aa$export$a2ae85dd849354a8;
"use strict";
$67fa797255ff85aa$export$a2ae85dd849354a8 = $67fa797255ff85aa$var$eachWeekendOfInterval;

var $64nK0 = parcelRequire("64nK0");

var $2DtTD = parcelRequire("2DtTD");
/**
 * @name eachWeekendOfInterval
 * @category Interval Helpers
 * @summary List all the Saturdays and Sundays in the given date interval.
 *
 * @description
 * Get all the Saturdays and Sundays in the given date interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The given interval
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the given date interval
 * const result = eachWeekendOfInterval({
 *   start: new Date(2018, 8, 17),
 *   end: new Date(2018, 8, 30)
 * })
 * //=> [
 * //   Sat Sep 22 2018 00:00:00,
 * //   Sun Sep 23 2018 00:00:00,
 * //   Sat Sep 29 2018 00:00:00,
 * //   Sun Sep 30 2018 00:00:00
 * // ]
 */ function $67fa797255ff85aa$var$eachWeekendOfInterval(interval) {
    const dateInterval = (0, $64nK0.eachDayOfInterval)(interval);
    const weekends = [];
    let index = 0;
    while(index < dateInterval.length){
        const date = dateInterval[index++];
        if ((0, $2DtTD.isWeekend)(date)) weekends.push(date);
    }
    return weekends;
}

});

parcelRegister("251R7", function(module, exports) {

$parcel$export(module.exports, "eachWeekendOfMonth", function () { return $183d7ce524fe90d5$export$f9a185d0ad232d17; }, function (v) { return $183d7ce524fe90d5$export$f9a185d0ad232d17 = v; });
var $183d7ce524fe90d5$export$f9a185d0ad232d17;
"use strict";
$183d7ce524fe90d5$export$f9a185d0ad232d17 = $183d7ce524fe90d5$var$eachWeekendOfMonth;

var $8VtqC = parcelRequire("8VtqC");

var $jrtnH = parcelRequire("jrtnH");

var $akZ7E = parcelRequire("akZ7E");
/**
 * @name eachWeekendOfMonth
 * @category Month Helpers
 * @summary List all the Saturdays and Sundays in the given month.
 *
 * @description
 * Get all the Saturdays and Sundays in the given month.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given month
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the given month
 * const result = eachWeekendOfMonth(new Date(2022, 1, 1))
 * //=> [
 * //   Sat Feb 05 2022 00:00:00,
 * //   Sun Feb 06 2022 00:00:00,
 * //   Sat Feb 12 2022 00:00:00,
 * //   Sun Feb 13 2022 00:00:00,
 * //   Sat Feb 19 2022 00:00:00,
 * //   Sun Feb 20 2022 00:00:00,
 * //   Sat Feb 26 2022 00:00:00,
 * //   Sun Feb 27 2022 00:00:00
 * // ]
 */ function $183d7ce524fe90d5$var$eachWeekendOfMonth(date) {
    const start = (0, $akZ7E.startOfMonth)(date);
    const end = (0, $jrtnH.endOfMonth)(date);
    return (0, $8VtqC.eachWeekendOfInterval)({
        start: start,
        end: end
    });
}

});
parcelRegister("akZ7E", function(module, exports) {

$parcel$export(module.exports, "startOfMonth", function () { return $786b2f460cd3045f$export$a5a3b454ada2268e; }, function (v) { return $786b2f460cd3045f$export$a5a3b454ada2268e = v; });
var $786b2f460cd3045f$export$a5a3b454ada2268e;
"use strict";
$786b2f460cd3045f$export$a5a3b454ada2268e = $786b2f460cd3045f$var$startOfMonth;

var $eimnm = parcelRequire("eimnm");
/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ function $786b2f460cd3045f$var$startOfMonth(date) {
    const _date = (0, $eimnm.toDate)(date);
    _date.setDate(1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});


parcelRegister("LOK4f", function(module, exports) {

$parcel$export(module.exports, "eachWeekendOfYear", function () { return $08fbc035d776bbc1$export$d4a9e5efc1ddceb9; }, function (v) { return $08fbc035d776bbc1$export$d4a9e5efc1ddceb9 = v; });
var $08fbc035d776bbc1$export$d4a9e5efc1ddceb9;
"use strict";
$08fbc035d776bbc1$export$d4a9e5efc1ddceb9 = $08fbc035d776bbc1$var$eachWeekendOfYear;

var $8VtqC = parcelRequire("8VtqC");

var $jVy78 = parcelRequire("jVy78");

var $1samY = parcelRequire("1samY");
/**
 * @name eachWeekendOfYear
 * @category Year Helpers
 * @summary List all the Saturdays and Sundays in the year.
 *
 * @description
 * Get all the Saturdays and Sundays in the year.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given year
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the year
 * const result = eachWeekendOfYear(new Date(2020, 1, 1))
 * //=> [
 * //   Sat Jan 03 2020 00:00:00,
 * //   Sun Jan 04 2020 00:00:00,
 * //   ...
 * //   Sun Dec 27 2020 00:00:00
 * // ]
 * ]
 */ function $08fbc035d776bbc1$var$eachWeekendOfYear(date) {
    const start = (0, $1samY.startOfYear)(date);
    const end = (0, $jVy78.endOfYear)(date);
    return (0, $8VtqC.eachWeekendOfInterval)({
        start: start,
        end: end
    });
}

});
parcelRegister("jVy78", function(module, exports) {

$parcel$export(module.exports, "endOfYear", function () { return $e81dcd8ade9c1c09$export$8b7aa55c66d5569e; }, function (v) { return $e81dcd8ade9c1c09$export$8b7aa55c66d5569e = v; });
var $e81dcd8ade9c1c09$export$8b7aa55c66d5569e;
"use strict";
$e81dcd8ade9c1c09$export$8b7aa55c66d5569e = $e81dcd8ade9c1c09$var$endOfYear;

var $eimnm = parcelRequire("eimnm");
/**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a year
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * const result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */ function $e81dcd8ade9c1c09$var$endOfYear(date) {
    const _date = (0, $eimnm.toDate)(date);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRegister("1samY", function(module, exports) {

$parcel$export(module.exports, "startOfYear", function () { return $10f073239f06a23a$export$f91e89d3d0406102; }, function (v) { return $10f073239f06a23a$export$f91e89d3d0406102 = v; });
var $10f073239f06a23a$export$f91e89d3d0406102;
"use strict";
$10f073239f06a23a$export$f91e89d3d0406102 = $10f073239f06a23a$var$startOfYear;

var $eimnm = parcelRequire("eimnm");

var $909bC = parcelRequire("909bC");
/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */ function $10f073239f06a23a$var$startOfYear(date) {
    const cleanDate = (0, $eimnm.toDate)(date);
    const _date = (0, $909bC.constructFrom)(date, 0);
    _date.setFullYear(cleanDate.getFullYear(), 0, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});


parcelRegister("iXq1H", function(module, exports) {

$parcel$export(module.exports, "eachYearOfInterval", function () { return $dcd1ecfb0a869d8b$export$9b7f165f0a71d2a5; }, function (v) { return $dcd1ecfb0a869d8b$export$9b7f165f0a71d2a5 = v; });
var $dcd1ecfb0a869d8b$export$9b7f165f0a71d2a5;
"use strict";
$dcd1ecfb0a869d8b$export$9b7f165f0a71d2a5 = $dcd1ecfb0a869d8b$var$eachYearOfInterval;

var $eimnm = parcelRequire("eimnm");
/**
 * The {@link eachYearOfInterval} function options.
 */ /**
 * @name eachYearOfInterval
 * @category Interval Helpers
 * @summary Return the array of yearly timestamps within the specified time interval.
 *
 * @description
 * Return the array of yearly timestamps within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 *
 * @returns The array with starts of yearly timestamps from the month of the interval start to the month of the interval end
 *
 * @example
 * // Each year between 6 February 2014 and 10 August 2017:
 * const result = eachYearOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2017, 7, 10)
 * })
 * //=> [
 * //   Wed Jan 01 2014 00:00:00,
 * //   Thu Jan 01 2015 00:00:00,
 * //   Fri Jan 01 2016 00:00:00,
 * //   Sun Jan 01 2017 00:00:00
 * // ]
 */ function $dcd1ecfb0a869d8b$var$eachYearOfInterval(interval, options) {
    const startDate = (0, $eimnm.toDate)(interval.start);
    const endDate = (0, $eimnm.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    const currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    currentDate.setMonth(0, 1);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $eimnm.toDate)(currentDate));
        currentDate.setFullYear(currentDate.getFullYear() + step);
    }
    return reversed ? dates.reverse() : dates;
}

});

parcelRegister("d6Bdx", function(module, exports) {

$parcel$export(module.exports, "endOfDecade", function () { return $98a8b4842af2bb19$export$b922ac31d5bbe7a6; }, function (v) { return $98a8b4842af2bb19$export$b922ac31d5bbe7a6 = v; });
var $98a8b4842af2bb19$export$b922ac31d5bbe7a6;
"use strict";
$98a8b4842af2bb19$export$b922ac31d5bbe7a6 = $98a8b4842af2bb19$var$endOfDecade;

var $eimnm = parcelRequire("eimnm");
/**
 * @name endOfDecade
 * @category Decade Helpers
 * @summary Return the end of a decade for the given date.
 *
 * @description
 * Return the end of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a decade
 *
 * @example
 * // The end of a decade for 12 May 1984 00:00:00:
 * const result = endOfDecade(new Date(1984, 4, 12, 00, 00, 00))
 * //=> Dec 31 1989 23:59:59.999
 */ function $98a8b4842af2bb19$var$endOfDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $eimnm.toDate)(date);
    const year = _date.getFullYear();
    const decade = 9 + Math.floor(year / 10) * 10;
    _date.setFullYear(decade, 11, 31);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRegister("jaOcI", function(module, exports) {

$parcel$export(module.exports, "endOfHour", function () { return $df55e4f6937e52f4$export$95ae95d2176c5f0; }, function (v) { return $df55e4f6937e52f4$export$95ae95d2176c5f0 = v; });
var $df55e4f6937e52f4$export$95ae95d2176c5f0;
"use strict";
$df55e4f6937e52f4$export$95ae95d2176c5f0 = $df55e4f6937e52f4$var$endOfHour;

var $eimnm = parcelRequire("eimnm");
/**
 * @name endOfHour
 * @category Hour Helpers
 * @summary Return the end of an hour for the given date.
 *
 * @description
 * Return the end of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an hour
 *
 * @example
 * // The end of an hour for 2 September 2014 11:55:00:
 * const result = endOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:59:59.999
 */ function $df55e4f6937e52f4$var$endOfHour(date) {
    const _date = (0, $eimnm.toDate)(date);
    _date.setMinutes(59, 59, 999);
    return _date;
}

});

parcelRegister("5EHXL", function(module, exports) {

$parcel$export(module.exports, "endOfISOWeek", function () { return $41e2ca4f53ee3ae9$export$186cd934f32084be; }, function (v) { return $41e2ca4f53ee3ae9$export$186cd934f32084be = v; });
var $41e2ca4f53ee3ae9$export$186cd934f32084be;
"use strict";
$41e2ca4f53ee3ae9$export$186cd934f32084be = $41e2ca4f53ee3ae9$var$endOfISOWeek;

var $kBOpH = parcelRequire("kBOpH");
/**
 * @name endOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * const result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */ function $41e2ca4f53ee3ae9$var$endOfISOWeek(date) {
    return (0, $kBOpH.endOfWeek)(date, {
        weekStartsOn: 1
    });
}

});
parcelRegister("kBOpH", function(module, exports) {

$parcel$export(module.exports, "endOfWeek", function () { return $f00e5e694fb15273$export$ef8b6d9133084f4e; }, function (v) { return $f00e5e694fb15273$export$ef8b6d9133084f4e = v; });
var $f00e5e694fb15273$export$ef8b6d9133084f4e;
"use strict";
$f00e5e694fb15273$export$ef8b6d9133084f4e = $f00e5e694fb15273$var$endOfWeek;

var $eimnm = parcelRequire("eimnm");

var $hIOa6 = parcelRequire("hIOa6");
/**
 * The {@link endOfWeek} function options.
 */ /**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The end of a week
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */ function $f00e5e694fb15273$var$endOfWeek(date, options) {
    const defaultOptions = (0, $hIOa6.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $eimnm.toDate)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setDate(_date.getDate() + diff);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});


parcelRegister("dUv6m", function(module, exports) {

$parcel$export(module.exports, "endOfISOWeekYear", function () { return $a208a1769e27ced3$export$73068f3824c9c1d; }, function (v) { return $a208a1769e27ced3$export$73068f3824c9c1d = v; });
var $a208a1769e27ced3$export$73068f3824c9c1d;
"use strict";
$a208a1769e27ced3$export$73068f3824c9c1d = $a208a1769e27ced3$var$endOfISOWeekYear;

var $4j6Nm = parcelRequire("4j6Nm");

var $01IXW = parcelRequire("01IXW");

var $909bC = parcelRequire("909bC");
/**
 * @name endOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the end of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the end of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week-numbering year
 *
 * @example
 * // The end of an ISO week-numbering year for 2 July 2005:
 * const result = endOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 23:59:59.999
 */ function $a208a1769e27ced3$var$endOfISOWeekYear(date) {
    const year = (0, $4j6Nm.getISOWeekYear)(date);
    const fourthOfJanuaryOfNextYear = (0, $909bC.constructFrom)(date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const _date = (0, $01IXW.startOfISOWeek)(fourthOfJanuaryOfNextYear);
    _date.setMilliseconds(_date.getMilliseconds() - 1);
    return _date;
}

});

parcelRegister("eQU1v", function(module, exports) {

$parcel$export(module.exports, "endOfMinute", function () { return $ad01610f30d26157$export$a06a772fc63bff07; }, function (v) { return $ad01610f30d26157$export$a06a772fc63bff07 = v; });
var $ad01610f30d26157$export$a06a772fc63bff07;
"use strict";
$ad01610f30d26157$export$a06a772fc63bff07 = $ad01610f30d26157$var$endOfMinute;

var $eimnm = parcelRequire("eimnm");
/**
 * @name endOfMinute
 * @category Minute Helpers
 * @summary Return the end of a minute for the given date.
 *
 * @description
 * Return the end of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a minute
 *
 * @example
 * // The end of a minute for 1 December 2014 22:15:45.400:
 * const result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:59.999
 */ function $ad01610f30d26157$var$endOfMinute(date) {
    const _date = (0, $eimnm.toDate)(date);
    _date.setSeconds(59, 999);
    return _date;
}

});

parcelRegister("3VuY5", function(module, exports) {

$parcel$export(module.exports, "endOfQuarter", function () { return $2dbeb79bed323ead$export$5f53493861eef879; }, function (v) { return $2dbeb79bed323ead$export$5f53493861eef879 = v; });
var $2dbeb79bed323ead$export$5f53493861eef879;
"use strict";
$2dbeb79bed323ead$export$5f53493861eef879 = $2dbeb79bed323ead$var$endOfQuarter;

var $eimnm = parcelRequire("eimnm");
/**
 * @name endOfQuarter
 * @category Quarter Helpers
 * @summary Return the end of a year quarter for the given date.
 *
 * @description
 * Return the end of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a quarter
 *
 * @example
 * // The end of a quarter for 2 September 2014 11:55:00:
 * const result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */ function $2dbeb79bed323ead$var$endOfQuarter(date) {
    const _date = (0, $eimnm.toDate)(date);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3 + 3;
    _date.setMonth(month, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRegister("8c1Nz", function(module, exports) {

$parcel$export(module.exports, "endOfSecond", function () { return $5f70d6e04eff7092$export$ef560ab2fa7b52a2; }, function (v) { return $5f70d6e04eff7092$export$ef560ab2fa7b52a2 = v; });
var $5f70d6e04eff7092$export$ef560ab2fa7b52a2;
"use strict";
$5f70d6e04eff7092$export$ef560ab2fa7b52a2 = $5f70d6e04eff7092$var$endOfSecond;

var $eimnm = parcelRequire("eimnm");
/**
 * @name endOfSecond
 * @category Second Helpers
 * @summary Return the end of a second for the given date.
 *
 * @description
 * Return the end of a second for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a second
 *
 * @example
 * // The end of a second for 1 December 2014 22:15:45.400:
 * const result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.999
 */ function $5f70d6e04eff7092$var$endOfSecond(date) {
    const _date = (0, $eimnm.toDate)(date);
    _date.setMilliseconds(999);
    return _date;
}

});

parcelRegister("dLvMH", function(module, exports) {

$parcel$export(module.exports, "endOfToday", function () { return $a05851e52f194ef9$export$1b7031a80bd92a6e; }, function (v) { return $a05851e52f194ef9$export$1b7031a80bd92a6e = v; });
var $a05851e52f194ef9$export$1b7031a80bd92a6e;
"use strict";
$a05851e52f194ef9$export$1b7031a80bd92a6e = $a05851e52f194ef9$var$endOfToday;

var $6Fi1I = parcelRequire("6Fi1I");
/**
 * @name endOfToday
 * @category Day Helpers
 * @summary Return the end of today.
 * @pure false
 *
 * @description
 * Return the end of today.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of today
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfToday()
 * //=> Mon Oct 6 2014 23:59:59.999
 */ function $a05851e52f194ef9$var$endOfToday() {
    return (0, $6Fi1I.endOfDay)(Date.now());
}

});

parcelRegister("1dT5W", function(module, exports) {

$parcel$export(module.exports, "endOfTomorrow", function () { return $0e41be09742a4f1d$export$d788ac27ae2a54ea; }, function (v) { return $0e41be09742a4f1d$export$d788ac27ae2a54ea = v; });
var $0e41be09742a4f1d$export$d788ac27ae2a54ea;
"use strict";
$0e41be09742a4f1d$export$d788ac27ae2a54ea = $0e41be09742a4f1d$var$endOfTomorrow; /**
 * @name endOfTomorrow
 * @category Day Helpers
 * @summary Return the end of tomorrow.
 * @pure false
 *
 * @description
 * Return the end of tomorrow.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfTomorrow()
 * //=> Tue Oct 7 2014 23:59:59.999
 */ 
function $0e41be09742a4f1d$var$endOfTomorrow() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day + 1);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("4Aqkh", function(module, exports) {

$parcel$export(module.exports, "endOfYesterday", function () { return $356ef2045e6c04d6$export$45190faf1024f97a; }, function (v) { return $356ef2045e6c04d6$export$45190faf1024f97a = v; });
var $356ef2045e6c04d6$export$45190faf1024f97a;
"use strict";
$356ef2045e6c04d6$export$45190faf1024f97a = $356ef2045e6c04d6$var$endOfYesterday; /**
 * @name endOfYesterday
 * @category Day Helpers
 * @summary Return the end of yesterday.
 * @pure false
 *
 * @description
 * Return the end of yesterday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfYesterday()
 * //=> Sun Oct 5 2014 23:59:59.999
 */ 
function $356ef2045e6c04d6$var$endOfYesterday() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day - 1);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("jnWO3", function(module, exports) {
"use strict";
module.exports.format = module.exports.formatDate = $e1cdc802830b6232$var$format;
Object.defineProperty(module.exports, "formatters", {
    enumerable: true,
    get: function() {
        return $6QfAm.formatters;
    }
});
Object.defineProperty(module.exports, "longFormatters", {
    enumerable: true,
    get: function() {
        return $dBwuJ.longFormatters;
    }
});

var $aQ9aQ = parcelRequire("aQ9aQ");

var $hIOa6 = parcelRequire("hIOa6");

var $6QfAm = parcelRequire("6QfAm");

var $dBwuJ = parcelRequire("dBwuJ");

var $a5cgw = parcelRequire("a5cgw");

var $drHAt = parcelRequire("drHAt");

var $eimnm = parcelRequire("eimnm");
// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $e1cdc802830b6232$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $e1cdc802830b6232$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $e1cdc802830b6232$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $e1cdc802830b6232$var$doubleQuoteRegExp = /''/g;
const $e1cdc802830b6232$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * The {@link format} function options.
 */ /**
 * @name format
 * @alias formatDate
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear](https://date-fns.org/docs/getISOWeekYear)
 *    and [getWeekYear](https://date-fns.org/docs/getWeekYear)).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 * @param options - An object with options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function $e1cdc802830b6232$var$format(date, formatStr, options) {
    const defaultOptions = (0, $hIOa6.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $aQ9aQ.defaultLocale;
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, $eimnm.toDate)(date);
    if (!(0, $drHAt.isValid)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($e1cdc802830b6232$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = $dBwuJ.longFormatters[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($e1cdc802830b6232$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $e1cdc802830b6232$var$cleanEscapedString(substring)
        };
        if ($6QfAm.formatters[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($e1cdc802830b6232$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, $a5cgw.isProtectedWeekYearToken)(token) || !options?.useAdditionalDayOfYearTokens && (0, $a5cgw.isProtectedDayOfYearToken)(token)) (0, $a5cgw.warnOrThrowProtectedError)(token, formatStr, String(date));
        const formatter = $6QfAm.formatters[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $e1cdc802830b6232$var$cleanEscapedString(input) {
    const matched = input.match($e1cdc802830b6232$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($e1cdc802830b6232$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("aQ9aQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "defaultLocale", {
    enumerable: true,
    get: function() {
        return $kRuMi.enUS;
    }
});

var $kRuMi = parcelRequire("kRuMi");

});
parcelRegister("kRuMi", function(module, exports) {

$parcel$export(module.exports, "enUS", function () { return $f300a1bd249c8b77$export$137380d9ce54f7f; }, function (v) { return $f300a1bd249c8b77$export$137380d9ce54f7f = v; });
var $f300a1bd249c8b77$export$137380d9ce54f7f;
"use strict";
$f300a1bd249c8b77$export$137380d9ce54f7f = void 0;

var $lSIny = parcelRequire("lSIny");

var $6LiX2 = parcelRequire("6LiX2");

var $afvyp = parcelRequire("afvyp");

var $fSY2H = parcelRequire("fSY2H");

var $2cOek = parcelRequire("2cOek");
/**
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp](https://github.com/kossnocorp)
 * @author Lesha Koss [@leshakoss](https://github.com/leshakoss)
 */ const $f300a1bd249c8b77$var$enUS = $f300a1bd249c8b77$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: $lSIny.formatDistance,
    formatLong: $6LiX2.formatLong,
    formatRelative: $afvyp.formatRelative,
    localize: $fSY2H.localize,
    match: $2cOek.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("lSIny", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $fee110d60efc9263$export$2c14ff85d6318973; }, function (v) { return $fee110d60efc9263$export$2c14ff85d6318973 = v; });
var $fee110d60efc9263$export$2c14ff85d6318973;
"use strict";
$fee110d60efc9263$export$2c14ff85d6318973 = void 0;
const $fee110d60efc9263$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $fee110d60efc9263$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $fee110d60efc9263$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
$fee110d60efc9263$export$2c14ff85d6318973 = $fee110d60efc9263$var$formatDistance;

});

parcelRegister("6LiX2", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $4ec5d531bd49f04a$export$cbf60ecb96cbb82f; }, function (v) { return $4ec5d531bd49f04a$export$cbf60ecb96cbb82f = v; });
var $4ec5d531bd49f04a$export$cbf60ecb96cbb82f;
"use strict";
$4ec5d531bd49f04a$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $4ec5d531bd49f04a$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $4ec5d531bd49f04a$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $4ec5d531bd49f04a$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $4ec5d531bd49f04a$var$formatLong = $4ec5d531bd49f04a$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $4ec5d531bd49f04a$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $4ec5d531bd49f04a$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $4ec5d531bd49f04a$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});
parcelRegister("2jgV2", function(module, exports) {

$parcel$export(module.exports, "buildFormatLongFn", function () { return $1aea7ada5f565a65$export$38e44e97ce4dbb7d; }, function (v) { return $1aea7ada5f565a65$export$38e44e97ce4dbb7d = v; });
var $1aea7ada5f565a65$export$38e44e97ce4dbb7d;
"use strict";
$1aea7ada5f565a65$export$38e44e97ce4dbb7d = $1aea7ada5f565a65$var$buildFormatLongFn;
function $1aea7ada5f565a65$var$buildFormatLongFn(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("afvyp", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $7763c80d095b93f3$export$8fbbfd65594f46a0; }, function (v) { return $7763c80d095b93f3$export$8fbbfd65594f46a0 = v; });
var $7763c80d095b93f3$export$8fbbfd65594f46a0;
"use strict";
$7763c80d095b93f3$export$8fbbfd65594f46a0 = void 0;
const $7763c80d095b93f3$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $7763c80d095b93f3$var$formatRelative = (token, _date, _baseDate, _options)=>$7763c80d095b93f3$var$formatRelativeLocale[token];
$7763c80d095b93f3$export$8fbbfd65594f46a0 = $7763c80d095b93f3$var$formatRelative;

});

parcelRegister("fSY2H", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $b90a795e64812891$export$b3bd0bc58e36cd63; }, function (v) { return $b90a795e64812891$export$b3bd0bc58e36cd63 = v; });
var $b90a795e64812891$export$b3bd0bc58e36cd63;
"use strict";
$b90a795e64812891$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $b90a795e64812891$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $b90a795e64812891$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $b90a795e64812891$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $b90a795e64812891$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $b90a795e64812891$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $b90a795e64812891$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $b90a795e64812891$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $b90a795e64812891$var$localize = $b90a795e64812891$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $b90a795e64812891$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $b90a795e64812891$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $b90a795e64812891$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $b90a795e64812891$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $b90a795e64812891$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $b90a795e64812891$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $b90a795e64812891$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});
parcelRegister("4Zr7l", function(module, exports) {

$parcel$export(module.exports, "buildLocalizeFn", function () { return $3a21e4e81ccfceaa$export$63596d6ee8878b25; }, function (v) { return $3a21e4e81ccfceaa$export$63596d6ee8878b25 = v; });
var $3a21e4e81ccfceaa$export$63596d6ee8878b25;
"use strict";
$3a21e4e81ccfceaa$export$63596d6ee8878b25 = $3a21e4e81ccfceaa$var$buildLocalizeFn; /* eslint-disable no-unused-vars */ 
/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $3a21e4e81ccfceaa$var$buildLocalizeFn(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("2cOek", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $19b3aa6a7cb29a3c$export$4659b591c19bdf3d; }, function (v) { return $19b3aa6a7cb29a3c$export$4659b591c19bdf3d = v; });
var $19b3aa6a7cb29a3c$export$4659b591c19bdf3d;
"use strict";
$19b3aa6a7cb29a3c$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $19b3aa6a7cb29a3c$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $19b3aa6a7cb29a3c$var$parseOrdinalNumberPattern = /\d+/i;
const $19b3aa6a7cb29a3c$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $19b3aa6a7cb29a3c$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $19b3aa6a7cb29a3c$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $19b3aa6a7cb29a3c$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $19b3aa6a7cb29a3c$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $19b3aa6a7cb29a3c$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $19b3aa6a7cb29a3c$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $19b3aa6a7cb29a3c$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $19b3aa6a7cb29a3c$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $19b3aa6a7cb29a3c$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $19b3aa6a7cb29a3c$var$match = $19b3aa6a7cb29a3c$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $19b3aa6a7cb29a3c$var$matchOrdinalNumberPattern,
        parsePattern: $19b3aa6a7cb29a3c$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $19b3aa6a7cb29a3c$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $19b3aa6a7cb29a3c$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $19b3aa6a7cb29a3c$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $19b3aa6a7cb29a3c$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $19b3aa6a7cb29a3c$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $19b3aa6a7cb29a3c$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $19b3aa6a7cb29a3c$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $19b3aa6a7cb29a3c$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $19b3aa6a7cb29a3c$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $19b3aa6a7cb29a3c$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});
parcelRegister("kQYK9", function(module, exports) {

$parcel$export(module.exports, "buildMatchFn", function () { return $f2e7c8588a9187dc$export$1430a0f35710914d; }, function (v) { return $f2e7c8588a9187dc$export$1430a0f35710914d = v; });
var $f2e7c8588a9187dc$export$1430a0f35710914d;
"use strict";
$f2e7c8588a9187dc$export$1430a0f35710914d = $f2e7c8588a9187dc$var$buildMatchFn;
function $f2e7c8588a9187dc$var$buildMatchFn(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $f2e7c8588a9187dc$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $f2e7c8588a9187dc$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $f2e7c8588a9187dc$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $f2e7c8588a9187dc$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("8RZeP", function(module, exports) {

$parcel$export(module.exports, "buildMatchPatternFn", function () { return $6752c691873d86a7$export$fdaf2fd6d7edde95; }, function (v) { return $6752c691873d86a7$export$fdaf2fd6d7edde95 = v; });
var $6752c691873d86a7$export$fdaf2fd6d7edde95;
"use strict";
$6752c691873d86a7$export$fdaf2fd6d7edde95 = $6752c691873d86a7$var$buildMatchPatternFn;
function $6752c691873d86a7$var$buildMatchPatternFn(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});




parcelRegister("6QfAm", function(module, exports) {

$parcel$export(module.exports, "formatters", function () { return $4fb3b05bd6a090e8$export$fe98a034cfb96d55; }, function (v) { return $4fb3b05bd6a090e8$export$fe98a034cfb96d55 = v; });
var $4fb3b05bd6a090e8$export$fe98a034cfb96d55;
"use strict";
$4fb3b05bd6a090e8$export$fe98a034cfb96d55 = void 0;

var $fgg0C = parcelRequire("fgg0C");

var $cuHcL = parcelRequire("cuHcL");

var $4j6Nm = parcelRequire("4j6Nm");

var $5SW4K = parcelRequire("5SW4K");

var $bIuXj = parcelRequire("bIuXj");

var $cC1Wj = parcelRequire("cC1Wj");

var $kcZsG = parcelRequire("kcZsG");
const $4fb3b05bd6a090e8$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ const $4fb3b05bd6a090e8$var$formatters = $4fb3b05bd6a090e8$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return $kcZsG.lightFormatters.y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $bIuXj.getWeekYear)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $cC1Wj.addLeadingZeros)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $cC1Wj.addLeadingZeros)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $4j6Nm.getISOWeekYear)(date);
        // Padding
        return (0, $cC1Wj.addLeadingZeros)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $cC1Wj.addLeadingZeros)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $cC1Wj.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $cC1Wj.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return $kcZsG.lightFormatters.M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $cC1Wj.addLeadingZeros)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $5SW4K.getWeek)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $cC1Wj.addLeadingZeros)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $cuHcL.getISOWeek)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $cC1Wj.addLeadingZeros)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return $kcZsG.lightFormatters.d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $fgg0C.getDayOfYear)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $cC1Wj.addLeadingZeros)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $cC1Wj.addLeadingZeros)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $cC1Wj.addLeadingZeros)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $cC1Wj.addLeadingZeros)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $4fb3b05bd6a090e8$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $4fb3b05bd6a090e8$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $4fb3b05bd6a090e8$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $4fb3b05bd6a090e8$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $4fb3b05bd6a090e8$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $4fb3b05bd6a090e8$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return $kcZsG.lightFormatters.h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return $kcZsG.lightFormatters.H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $cC1Wj.addLeadingZeros)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $cC1Wj.addLeadingZeros)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return $kcZsG.lightFormatters.m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return $kcZsG.lightFormatters.s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return $kcZsG.lightFormatters.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $4fb3b05bd6a090e8$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $4fb3b05bd6a090e8$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $4fb3b05bd6a090e8$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $4fb3b05bd6a090e8$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $4fb3b05bd6a090e8$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $4fb3b05bd6a090e8$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $4fb3b05bd6a090e8$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $4fb3b05bd6a090e8$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $4fb3b05bd6a090e8$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $4fb3b05bd6a090e8$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(date.getTime() / 1000);
        return (0, $cC1Wj.addLeadingZeros)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        const timestamp = date.getTime();
        return (0, $cC1Wj.addLeadingZeros)(timestamp, token.length);
    }
};
function $4fb3b05bd6a090e8$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $cC1Wj.addLeadingZeros)(minutes, 2);
}
function $4fb3b05bd6a090e8$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $cC1Wj.addLeadingZeros)(Math.abs(offset) / 60, 2);
    }
    return $4fb3b05bd6a090e8$var$formatTimezone(offset, delimiter);
}
function $4fb3b05bd6a090e8$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $cC1Wj.addLeadingZeros)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $cC1Wj.addLeadingZeros)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}

});
parcelRegister("fgg0C", function(module, exports) {

$parcel$export(module.exports, "getDayOfYear", function () { return $b1c4c4b12870d8e9$export$d3b42cd8452deec; }, function (v) { return $b1c4c4b12870d8e9$export$d3b42cd8452deec = v; });
var $b1c4c4b12870d8e9$export$d3b42cd8452deec;
"use strict";
$b1c4c4b12870d8e9$export$d3b42cd8452deec = $b1c4c4b12870d8e9$var$getDayOfYear;

var $ctsEq = parcelRequire("ctsEq");

var $1samY = parcelRequire("1samY");

var $eimnm = parcelRequire("eimnm");
/**
 * @name getDayOfYear
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * const result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */ function $b1c4c4b12870d8e9$var$getDayOfYear(date) {
    const _date = (0, $eimnm.toDate)(date);
    const diff = (0, $ctsEq.differenceInCalendarDays)(_date, (0, $1samY.startOfYear)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}

});

parcelRegister("cuHcL", function(module, exports) {

$parcel$export(module.exports, "getISOWeek", function () { return $9189ccf345cc37bb$export$7cabdc5698b63e2f; }, function (v) { return $9189ccf345cc37bb$export$7cabdc5698b63e2f = v; });
var $9189ccf345cc37bb$export$7cabdc5698b63e2f;
"use strict";
$9189ccf345cc37bb$export$7cabdc5698b63e2f = $9189ccf345cc37bb$var$getISOWeek;

var $lILKk = parcelRequire("lILKk");

var $01IXW = parcelRequire("01IXW");

var $aK6Tu = parcelRequire("aK6Tu");

var $eimnm = parcelRequire("eimnm");
/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */ function $9189ccf345cc37bb$var$getISOWeek(date) {
    const _date = (0, $eimnm.toDate)(date);
    const diff = +(0, $01IXW.startOfISOWeek)(_date) - +(0, $aK6Tu.startOfISOWeekYear)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / $lILKk.millisecondsInWeek) + 1;
}

});

parcelRegister("5SW4K", function(module, exports) {

$parcel$export(module.exports, "getWeek", function () { return $448f0b79b708bdc3$export$efe19b760242b2fc; }, function (v) { return $448f0b79b708bdc3$export$efe19b760242b2fc = v; });
var $448f0b79b708bdc3$export$efe19b760242b2fc;
"use strict";
$448f0b79b708bdc3$export$efe19b760242b2fc = $448f0b79b708bdc3$var$getWeek;

var $lILKk = parcelRequire("lILKk");

var $79XR6 = parcelRequire("79XR6");

var $1gSjC = parcelRequire("1gSjC");

var $eimnm = parcelRequire("eimnm");
/**
 * The {@link getWeek} function options.
 */ /**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The week
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */ function $448f0b79b708bdc3$var$getWeek(date, options) {
    const _date = (0, $eimnm.toDate)(date);
    const diff = +(0, $79XR6.startOfWeek)(_date, options) - +(0, $1gSjC.startOfWeekYear)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / $lILKk.millisecondsInWeek) + 1;
}

});
parcelRegister("1gSjC", function(module, exports) {

$parcel$export(module.exports, "startOfWeekYear", function () { return $0ed16af6f8860a7f$export$bb7b45bb8e74da0f; }, function (v) { return $0ed16af6f8860a7f$export$bb7b45bb8e74da0f = v; });
var $0ed16af6f8860a7f$export$bb7b45bb8e74da0f;
"use strict";
$0ed16af6f8860a7f$export$bb7b45bb8e74da0f = $0ed16af6f8860a7f$var$startOfWeekYear;

var $909bC = parcelRequire("909bC");

var $bIuXj = parcelRequire("bIuXj");

var $79XR6 = parcelRequire("79XR6");

var $hIOa6 = parcelRequire("hIOa6");
/**
 * The {@link startOfWeekYear} function options.
 */ /**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week-numbering year
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */ function $0ed16af6f8860a7f$var$startOfWeekYear(date, options) {
    const defaultOptions = (0, $hIOa6.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $bIuXj.getWeekYear)(date, options);
    const firstWeek = (0, $909bC.constructFrom)(date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $79XR6.startOfWeek)(firstWeek, options);
    return _date;
}

});
parcelRegister("bIuXj", function(module, exports) {

$parcel$export(module.exports, "getWeekYear", function () { return $887bd0eed927f16b$export$12d572480ceb6e58; }, function (v) { return $887bd0eed927f16b$export$12d572480ceb6e58 = v; });
var $887bd0eed927f16b$export$12d572480ceb6e58;
"use strict";
$887bd0eed927f16b$export$12d572480ceb6e58 = $887bd0eed927f16b$var$getWeekYear;

var $909bC = parcelRequire("909bC");

var $79XR6 = parcelRequire("79XR6");

var $eimnm = parcelRequire("eimnm");

var $hIOa6 = parcelRequire("hIOa6");
/**
 * The {@link getWeekYear} function options.
 */ /**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The local week-numbering year
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */ function $887bd0eed927f16b$var$getWeekYear(date, options) {
    const _date = (0, $eimnm.toDate)(date);
    const year = _date.getFullYear();
    const defaultOptions = (0, $hIOa6.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $909bC.constructFrom)(date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $79XR6.startOfWeek)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $909bC.constructFrom)(date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $79XR6.startOfWeek)(firstWeekOfThisYear, options);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("cC1Wj", function(module, exports) {

$parcel$export(module.exports, "addLeadingZeros", function () { return $92ea89cb1222341c$export$c8306e720e213c0f; }, function (v) { return $92ea89cb1222341c$export$c8306e720e213c0f = v; });
var $92ea89cb1222341c$export$c8306e720e213c0f;
"use strict";
$92ea89cb1222341c$export$c8306e720e213c0f = $92ea89cb1222341c$var$addLeadingZeros;
function $92ea89cb1222341c$var$addLeadingZeros(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}

});

parcelRegister("kcZsG", function(module, exports) {

$parcel$export(module.exports, "lightFormatters", function () { return $eb649aa8fcc507e7$export$b0d4b338e1516f13; }, function (v) { return $eb649aa8fcc507e7$export$b0d4b338e1516f13 = v; });
var $eb649aa8fcc507e7$export$b0d4b338e1516f13;
"use strict";
$eb649aa8fcc507e7$export$b0d4b338e1516f13 = void 0;

var $cC1Wj = parcelRequire("cC1Wj");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ const $eb649aa8fcc507e7$var$lightFormatters = $eb649aa8fcc507e7$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $cC1Wj.addLeadingZeros)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $cC1Wj.addLeadingZeros)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $cC1Wj.addLeadingZeros)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $cC1Wj.addLeadingZeros)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $cC1Wj.addLeadingZeros)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $cC1Wj.addLeadingZeros)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $cC1Wj.addLeadingZeros)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $cC1Wj.addLeadingZeros)(fractionalSeconds, token.length);
    }
};

});


parcelRegister("dBwuJ", function(module, exports) {

$parcel$export(module.exports, "longFormatters", function () { return $9e77efcdb2ce4e7f$export$70cc8fd02856fd58; }, function (v) { return $9e77efcdb2ce4e7f$export$70cc8fd02856fd58 = v; });
var $9e77efcdb2ce4e7f$export$70cc8fd02856fd58;
"use strict";
$9e77efcdb2ce4e7f$export$70cc8fd02856fd58 = void 0;
const $9e77efcdb2ce4e7f$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $9e77efcdb2ce4e7f$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $9e77efcdb2ce4e7f$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $9e77efcdb2ce4e7f$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $9e77efcdb2ce4e7f$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $9e77efcdb2ce4e7f$var$timeLongFormatter(timePattern, formatLong));
};
const $9e77efcdb2ce4e7f$var$longFormatters = $9e77efcdb2ce4e7f$export$70cc8fd02856fd58 = {
    p: $9e77efcdb2ce4e7f$var$timeLongFormatter,
    P: $9e77efcdb2ce4e7f$var$dateTimeLongFormatter
};

});

parcelRegister("a5cgw", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", function () { return $7573e2ab0a48fb94$export$c6cc36aa33304772; }, function (v) { return $7573e2ab0a48fb94$export$c6cc36aa33304772 = v; });
$parcel$export(module.exports, "isProtectedWeekYearToken", function () { return $7573e2ab0a48fb94$export$c6b49d6dceb604a1; }, function (v) { return $7573e2ab0a48fb94$export$c6b49d6dceb604a1 = v; });
$parcel$export(module.exports, "warnOrThrowProtectedError", function () { return $7573e2ab0a48fb94$export$f5f38f90ecaaf879; }, function (v) { return $7573e2ab0a48fb94$export$f5f38f90ecaaf879 = v; });
var $7573e2ab0a48fb94$export$c6cc36aa33304772;
var $7573e2ab0a48fb94$export$c6b49d6dceb604a1;
var $7573e2ab0a48fb94$export$f5f38f90ecaaf879;
"use strict";
$7573e2ab0a48fb94$export$c6cc36aa33304772 = $7573e2ab0a48fb94$var$isProtectedDayOfYearToken;
$7573e2ab0a48fb94$export$c6b49d6dceb604a1 = $7573e2ab0a48fb94$var$isProtectedWeekYearToken;
$7573e2ab0a48fb94$export$f5f38f90ecaaf879 = $7573e2ab0a48fb94$var$warnOrThrowProtectedError;
const $7573e2ab0a48fb94$var$dayOfYearTokenRE = /^D+$/;
const $7573e2ab0a48fb94$var$weekYearTokenRE = /^Y+$/;
const $7573e2ab0a48fb94$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $7573e2ab0a48fb94$var$isProtectedDayOfYearToken(token) {
    return $7573e2ab0a48fb94$var$dayOfYearTokenRE.test(token);
}
function $7573e2ab0a48fb94$var$isProtectedWeekYearToken(token) {
    return $7573e2ab0a48fb94$var$weekYearTokenRE.test(token);
}
function $7573e2ab0a48fb94$var$warnOrThrowProtectedError(token, format, input) {
    const _message = $7573e2ab0a48fb94$var$message(token, format, input);
    console.warn(_message);
    if ($7573e2ab0a48fb94$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $7573e2ab0a48fb94$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}

});


parcelRegister("jJcxl", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $e5cbf1d334a3d523$export$2c14ff85d6318973; }, function (v) { return $e5cbf1d334a3d523$export$2c14ff85d6318973 = v; });
var $e5cbf1d334a3d523$export$2c14ff85d6318973;
"use strict";
$e5cbf1d334a3d523$export$2c14ff85d6318973 = $e5cbf1d334a3d523$var$formatDistance;

var $3SXyf = parcelRequire("3SXyf");

var $lILKk = parcelRequire("lILKk");

var $6GN1F = parcelRequire("6GN1F");

var $cTY1w = parcelRequire("cTY1w");

var $eimnm = parcelRequire("eimnm");

var $aQ9aQ = parcelRequire("aQ9aQ");

var $hIOa6 = parcelRequire("hIOa6");

var $i6arj = parcelRequire("i6arj");
/**
 * The {@link formatDistance} function options.
 */ /**
 * @name formatDistance
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words.
 *
 * | Distance between dates                                            | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance between dates | Result               |
 * |------------------------|----------------------|
 * | 0 secs ... 5 secs      | less than 5 seconds  |
 * | 5 secs ... 10 secs     | less than 10 seconds |
 * | 10 secs ... 20 secs    | less than 20 seconds |
 * | 20 secs ... 40 secs    | half a minute        |
 * | 40 secs ... 60 secs    | less than a minute   |
 * | 60 secs ... 90 secs    | 1 minute             |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistance(new Date(2014, 6, 2), new Date(2015, 0, 1))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00, including seconds?
 * const result = formatDistance(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 *   { includeSeconds: true }
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistance(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> 'about 1 year ago'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistance(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> 'pli ol 1 jaro'
 */ function $e5cbf1d334a3d523$var$formatDistance(date, baseDate, options) {
    const defaultOptions = (0, $hIOa6.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $aQ9aQ.defaultLocale;
    const minutesInAlmostTwoDays = 2520;
    const comparison = (0, $3SXyf.compareAsc)(date, baseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    const localizeOptions = Object.assign({}, options, {
        addSuffix: options?.addSuffix,
        comparison: comparison
    });
    let dateLeft;
    let dateRight;
    if (comparison > 0) {
        dateLeft = (0, $eimnm.toDate)(baseDate);
        dateRight = (0, $eimnm.toDate)(date);
    } else {
        dateLeft = (0, $eimnm.toDate)(date);
        dateRight = (0, $eimnm.toDate)(baseDate);
    }
    const seconds = (0, $cTY1w.differenceInSeconds)(dateRight, dateLeft);
    const offsetInSeconds = ((0, $i6arj.getTimezoneOffsetInMilliseconds)(dateRight) - (0, $i6arj.getTimezoneOffsetInMilliseconds)(dateLeft)) / 1000;
    const minutes = Math.round((seconds - offsetInSeconds) / 60);
    let months;
    // 0 up to 2 mins
    if (minutes < 2) {
        if (options?.includeSeconds) {
            if (seconds < 5) return locale.formatDistance("lessThanXSeconds", 5, localizeOptions);
            else if (seconds < 10) return locale.formatDistance("lessThanXSeconds", 10, localizeOptions);
            else if (seconds < 20) return locale.formatDistance("lessThanXSeconds", 20, localizeOptions);
            else if (seconds < 40) return locale.formatDistance("halfAMinute", 0, localizeOptions);
            else if (seconds < 60) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", 1, localizeOptions);
        } else {
            if (minutes === 0) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", minutes, localizeOptions);
        }
    } else if (minutes < 45) return locale.formatDistance("xMinutes", minutes, localizeOptions);
    else if (minutes < 90) return locale.formatDistance("aboutXHours", 1, localizeOptions);
    else if (minutes < $lILKk.minutesInDay) {
        const hours = Math.round(minutes / 60);
        return locale.formatDistance("aboutXHours", hours, localizeOptions);
    // 1 day up to 1.75 days
    } else if (minutes < minutesInAlmostTwoDays) return locale.formatDistance("xDays", 1, localizeOptions);
    else if (minutes < $lILKk.minutesInMonth) {
        const days = Math.round(minutes / $lILKk.minutesInDay);
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 month up to 2 months
    } else if (minutes < $lILKk.minutesInMonth * 2) {
        months = Math.round(minutes / $lILKk.minutesInMonth);
        return locale.formatDistance("aboutXMonths", months, localizeOptions);
    }
    months = (0, $6GN1F.differenceInMonths)(dateRight, dateLeft);
    // 2 months up to 12 months
    if (months < 12) {
        const nearestMonth = Math.round(minutes / $lILKk.minutesInMonth);
        return locale.formatDistance("xMonths", nearestMonth, localizeOptions);
    // 1 year up to max Date
    } else {
        const monthsSinceStartOfYear = months % 12;
        const years = Math.trunc(months / 12);
        // N years up to 1 years 3 months
        if (monthsSinceStartOfYear < 3) return locale.formatDistance("aboutXYears", years, localizeOptions);
        else if (monthsSinceStartOfYear < 9) return locale.formatDistance("overXYears", years, localizeOptions);
        else return locale.formatDistance("almostXYears", years + 1, localizeOptions);
    }
}

});

parcelRegister("cPvSy", function(module, exports) {

$parcel$export(module.exports, "formatDistanceStrict", function () { return $9572f9f59d7100a2$export$e4be225b8ee0a759; }, function (v) { return $9572f9f59d7100a2$export$e4be225b8ee0a759 = v; });
var $9572f9f59d7100a2$export$e4be225b8ee0a759;
"use strict";
$9572f9f59d7100a2$export$e4be225b8ee0a759 = $9572f9f59d7100a2$var$formatDistanceStrict;

var $aQ9aQ = parcelRequire("aQ9aQ");

var $hIOa6 = parcelRequire("hIOa6");

var $fosqj = parcelRequire("fosqj");

var $i6arj = parcelRequire("i6arj");

var $3SXyf = parcelRequire("3SXyf");

var $lILKk = parcelRequire("lILKk");

var $eimnm = parcelRequire("eimnm");
/**
 * The {@link formatDistanceStrict} function options.
 */ /**
 * The unit used to format the distance in {@link formatDistanceStrict}.
 */ /**
 * @name formatDistanceStrict
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.unit` must be 'second', 'minute', 'hour', 'day', 'month' or 'year'
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistanceStrict(new Date(2014, 6, 2), new Date(2015, 0, 2))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00?
 * const result = formatDistanceStrict(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistanceStrict(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> '1 year ago'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, in minutes?
 * const result = formatDistanceStrict(new Date(2016, 0, 1), new Date(2015, 0, 1), {
 *   unit: 'minute'
 * })
 * //=> '525600 minutes'
 *
 * @example
 * // What is the distance from 1 January 2015
 * // to 28 January 2015, in months, rounded up?
 * const result = formatDistanceStrict(new Date(2015, 0, 28), new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistanceStrict(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> '1 jaro'
 */ function $9572f9f59d7100a2$var$formatDistanceStrict(date, baseDate, options) {
    const defaultOptions = (0, $hIOa6.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $aQ9aQ.defaultLocale;
    const comparison = (0, $3SXyf.compareAsc)(date, baseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    const localizeOptions = Object.assign({}, options, {
        addSuffix: options?.addSuffix,
        comparison: comparison
    });
    let dateLeft;
    let dateRight;
    if (comparison > 0) {
        dateLeft = (0, $eimnm.toDate)(baseDate);
        dateRight = (0, $eimnm.toDate)(date);
    } else {
        dateLeft = (0, $eimnm.toDate)(date);
        dateRight = (0, $eimnm.toDate)(baseDate);
    }
    const roundingMethod = (0, $fosqj.getRoundingMethod)(options?.roundingMethod ?? "round");
    const milliseconds = dateRight.getTime() - dateLeft.getTime();
    const minutes = milliseconds / $lILKk.millisecondsInMinute;
    const timezoneOffset = (0, $i6arj.getTimezoneOffsetInMilliseconds)(dateRight) - (0, $i6arj.getTimezoneOffsetInMilliseconds)(dateLeft);
    // Use DST-normalized difference in minutes for years, months and days;
    // use regular difference in minutes for hours, minutes and seconds.
    const dstNormalizedMinutes = (milliseconds - timezoneOffset) / $lILKk.millisecondsInMinute;
    const defaultUnit = options?.unit;
    let unit;
    if (!defaultUnit) {
        if (minutes < 1) unit = "second";
        else if (minutes < 60) unit = "minute";
        else if (minutes < $lILKk.minutesInDay) unit = "hour";
        else if (dstNormalizedMinutes < $lILKk.minutesInMonth) unit = "day";
        else if (dstNormalizedMinutes < $lILKk.minutesInYear) unit = "month";
        else unit = "year";
    } else unit = defaultUnit;
    // 0 up to 60 seconds
    if (unit === "second") {
        const seconds = roundingMethod(milliseconds / 1000);
        return locale.formatDistance("xSeconds", seconds, localizeOptions);
    // 1 up to 60 mins
    } else if (unit === "minute") {
        const roundedMinutes = roundingMethod(minutes);
        return locale.formatDistance("xMinutes", roundedMinutes, localizeOptions);
    // 1 up to 24 hours
    } else if (unit === "hour") {
        const hours = roundingMethod(minutes / 60);
        return locale.formatDistance("xHours", hours, localizeOptions);
    // 1 up to 30 days
    } else if (unit === "day") {
        const days = roundingMethod(dstNormalizedMinutes / $lILKk.minutesInDay);
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 up to 12 months
    } else if (unit === "month") {
        const months = roundingMethod(dstNormalizedMinutes / $lILKk.minutesInMonth);
        return months === 12 && defaultUnit !== "month" ? locale.formatDistance("xYears", 1, localizeOptions) : locale.formatDistance("xMonths", months, localizeOptions);
    // 1 year up to max Date
    } else {
        const years = roundingMethod(dstNormalizedMinutes / $lILKk.minutesInYear);
        return locale.formatDistance("xYears", years, localizeOptions);
    }
}

});

parcelRegister("37NBl", function(module, exports) {

$parcel$export(module.exports, "formatDistanceToNow", function () { return $2468805321661e7b$export$d130c20a256f8817; }, function (v) { return $2468805321661e7b$export$d130c20a256f8817 = v; });
var $2468805321661e7b$export$d130c20a256f8817;
"use strict";
$2468805321661e7b$export$d130c20a256f8817 = $2468805321661e7b$var$formatDistanceToNow;

var $hubi5 = parcelRequire("hubi5");

var $jJcxl = parcelRequire("jJcxl");
/**
 * The {@link formatDistanceToNow} function options.
 */ /**
 * @name formatDistanceToNow
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given date and now in words.
 *
 * | Distance to now                                                   | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance to now     | Result               |
 * |---------------------|----------------------|
 * | 0 secs ... 5 secs   | less than 5 seconds  |
 * | 5 secs ... 10 secs  | less than 10 seconds |
 * | 10 secs ... 20 secs | less than 20 seconds |
 * | 20 secs ... 40 secs | half a minute        |
 * | 40 secs ... 60 secs | less than a minute   |
 * | 60 secs ... 90 secs | 1 minute             |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - The object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNow(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNow(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNow(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in about 1 year'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 August 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNow(
 *   new Date(2016, 7, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */ function $2468805321661e7b$var$formatDistanceToNow(date, options) {
    return (0, $jJcxl.formatDistance)(date, (0, $hubi5.constructNow)(date), options);
}

});

parcelRegister("gP6I8", function(module, exports) {

$parcel$export(module.exports, "formatDistanceToNowStrict", function () { return $c3f69d640dfb28da$export$d0e02d4eb1ad1e32; }, function (v) { return $c3f69d640dfb28da$export$d0e02d4eb1ad1e32 = v; });
var $c3f69d640dfb28da$export$d0e02d4eb1ad1e32;
"use strict";
$c3f69d640dfb28da$export$d0e02d4eb1ad1e32 = $c3f69d640dfb28da$var$formatDistanceToNowStrict;

var $cPvSy = parcelRequire("cPvSy");

var $hubi5 = parcelRequire("hubi5");
/**
 * The {@link formatDistanceToNowStrict} function options.
 */ /**
 * @name formatDistanceToNowStrict
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNowStrict(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNowStrict(
 *   new Date(2015, 0, 1, 0, 0, 15)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in 1 year'
 *
 * @example
 * // If today is 28 January 2015,
 * // what is the distance to 1 January 2015, in months, rounded up??
 * const result = formatDistanceToNowStrict(new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> '1 jaro'
 */ function $c3f69d640dfb28da$var$formatDistanceToNowStrict(date, options) {
    return (0, $cPvSy.formatDistanceStrict)(date, (0, $hubi5.constructNow)(date), options);
}

});

parcelRegister("kQSmd", function(module, exports) {

$parcel$export(module.exports, "formatDuration", function () { return $f2e2d438744638d5$export$bc733b0c5cbb3e8a; }, function (v) { return $f2e2d438744638d5$export$bc733b0c5cbb3e8a = v; });
var $f2e2d438744638d5$export$bc733b0c5cbb3e8a;
"use strict";
$f2e2d438744638d5$export$bc733b0c5cbb3e8a = $f2e2d438744638d5$var$formatDuration;

var $aQ9aQ = parcelRequire("aQ9aQ");

var $hIOa6 = parcelRequire("hIOa6");
/**
 * The {@link formatDuration} function options.
 */ const $f2e2d438744638d5$var$defaultFormat = [
    "years",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds"
];
/**
 * @name formatDuration
 * @category Common Helpers
 * @summary Formats a duration in human-readable format
 *
 * @description
 * Return human-readable duration string i.e. "9 months 2 days"
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param duration - The duration to format
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @example
 * // Format full duration
 * formatDuration({
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> '2 years 9 months 1 week 7 days 5 hours 9 minutes 30 seconds'
 *
 * @example
 * // Format partial duration
 * formatDuration({ months: 9, days: 2 })
 * //=> '9 months 2 days'
 *
 * @example
 * // Customize the format
 * formatDuration(
 *   {
 *     years: 2,
 *     months: 9,
 *     weeks: 1,
 *     days: 7,
 *     hours: 5,
 *     minutes: 9,
 *     seconds: 30
 *   },
 *   { format: ['months', 'weeks'] }
 * ) === '9 months 1 week'
 *
 * @example
 * // Customize the zeros presence
 * formatDuration({ years: 0, months: 9 })
 * //=> '9 months'
 * formatDuration({ years: 0, months: 9 }, { zero: true })
 * //=> '0 years 9 months'
 *
 * @example
 * // Customize the delimiter
 * formatDuration({ years: 2, months: 9, weeks: 3 }, { delimiter: ', ' })
 * //=> '2 years, 9 months, 3 weeks'
 */ function $f2e2d438744638d5$var$formatDuration(duration, options) {
    const defaultOptions = (0, $hIOa6.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $aQ9aQ.defaultLocale;
    const format = options?.format ?? $f2e2d438744638d5$var$defaultFormat;
    const zero = options?.zero ?? false;
    const delimiter = options?.delimiter ?? " ";
    if (!locale.formatDistance) return "";
    const result = format.reduce((acc, unit)=>{
        const token = `x${unit.replace(/(^.)/, (m)=>m.toUpperCase())}`;
        const value = duration[unit];
        if (value !== undefined && (zero || duration[unit])) return acc.concat(locale.formatDistance(token, value));
        return acc;
    }, []).join(delimiter);
    return result;
}

});

parcelRegister("7Xr3B", function(module, exports) {

$parcel$export(module.exports, "formatISO", function () { return $5cb308125122c355$export$3c826ac3ab9da76c; }, function (v) { return $5cb308125122c355$export$3c826ac3ab9da76c = v; });
var $5cb308125122c355$export$3c826ac3ab9da76c;
"use strict";
$5cb308125122c355$export$3c826ac3ab9da76c = $5cb308125122c355$var$formatISO;

var $eimnm = parcelRequire("eimnm");

var $cC1Wj = parcelRequire("cC1Wj");
/**
 * The {@link formatISO} function options.
 */ /**
 * @name formatISO
 * @category Common Helpers
 * @summary Format the date according to the ISO 8601 standard (https://support.sas.com/documentation/cdl/en/lrdict/64316/HTML/default/viewer.htm#a003169814.htm).
 *
 * @description
 * Return the formatted date string in ISO 8601 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string (in loca.l time zone)
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601, short format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918T190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, date only:
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, time only (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52Z'
 */ function $5cb308125122c355$var$formatISO(date, options) {
    const _date = (0, $eimnm.toDate)(date);
    if (isNaN(_date.getTime())) throw new RangeError("Invalid time value");
    const format = options?.format ?? "extended";
    const representation = options?.representation ?? "complete";
    let result = "";
    let tzOffset = "";
    const dateDelimiter = format === "extended" ? "-" : "";
    const timeDelimiter = format === "extended" ? ":" : "";
    // Representation is either 'date' or 'complete'
    if (representation !== "time") {
        const day = (0, $cC1Wj.addLeadingZeros)(_date.getDate(), 2);
        const month = (0, $cC1Wj.addLeadingZeros)(_date.getMonth() + 1, 2);
        const year = (0, $cC1Wj.addLeadingZeros)(_date.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = `${year}${dateDelimiter}${month}${dateDelimiter}${day}`;
    }
    // Representation is either 'time' or 'complete'
    if (representation !== "date") {
        // Add the timezone.
        const offset = _date.getTimezoneOffset();
        if (offset !== 0) {
            const absoluteOffset = Math.abs(offset);
            const hourOffset = (0, $cC1Wj.addLeadingZeros)(Math.trunc(absoluteOffset / 60), 2);
            const minuteOffset = (0, $cC1Wj.addLeadingZeros)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            const sign = offset < 0 ? "+" : "-";
            tzOffset = `${sign}${hourOffset}:${minuteOffset}`;
        } else tzOffset = "Z";
        const hour = (0, $cC1Wj.addLeadingZeros)(_date.getHours(), 2);
        const minute = (0, $cC1Wj.addLeadingZeros)(_date.getMinutes(), 2);
        const second = (0, $cC1Wj.addLeadingZeros)(_date.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        const separator = result === "" ? "" : "T";
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        const time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = `${result}${separator}${time}${tzOffset}`;
    }
    return result;
}

});

parcelRegister("hqDGb", function(module, exports) {

$parcel$export(module.exports, "formatISO9075", function () { return $cb03a4e3892bae27$export$a673944250043fa4; }, function (v) { return $cb03a4e3892bae27$export$a673944250043fa4 = v; });
var $cb03a4e3892bae27$export$a673944250043fa4;
"use strict";
$cb03a4e3892bae27$export$a673944250043fa4 = $cb03a4e3892bae27$var$formatISO9075;

var $drHAt = parcelRequire("drHAt");

var $eimnm = parcelRequire("eimnm");

var $cC1Wj = parcelRequire("cC1Wj");
/**
 * The {@link formatISO9075} function options.
 */ /**
 * @name formatISO9075
 * @category Common Helpers
 * @summary Format the date according to the ISO 9075 standard (https://dev.mysql.com/doc/refman/5.7/en/date-and-time-functions.html#function_get-format).
 *
 * @description
 * Return the formatted date string in ISO 9075 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18 19:00:52'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075, short format:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918 190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format, date only:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format, time only:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52'
 */ function $cb03a4e3892bae27$var$formatISO9075(date, options) {
    const _date = (0, $eimnm.toDate)(date);
    if (!(0, $drHAt.isValid)(_date)) throw new RangeError("Invalid time value");
    const format = options?.format ?? "extended";
    const representation = options?.representation ?? "complete";
    let result = "";
    const dateDelimiter = format === "extended" ? "-" : "";
    const timeDelimiter = format === "extended" ? ":" : "";
    // Representation is either 'date' or 'complete'
    if (representation !== "time") {
        const day = (0, $cC1Wj.addLeadingZeros)(_date.getDate(), 2);
        const month = (0, $cC1Wj.addLeadingZeros)(_date.getMonth() + 1, 2);
        const year = (0, $cC1Wj.addLeadingZeros)(_date.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = `${year}${dateDelimiter}${month}${dateDelimiter}${day}`;
    }
    // Representation is either 'time' or 'complete'
    if (representation !== "date") {
        const hour = (0, $cC1Wj.addLeadingZeros)(_date.getHours(), 2);
        const minute = (0, $cC1Wj.addLeadingZeros)(_date.getMinutes(), 2);
        const second = (0, $cC1Wj.addLeadingZeros)(_date.getSeconds(), 2);
        // If there's also date, separate it with time with a space
        const separator = result === "" ? "" : " ";
        // HHmmss or HH:mm:ss.
        result = `${result}${separator}${hour}${timeDelimiter}${minute}${timeDelimiter}${second}`;
    }
    return result;
}

});

parcelRegister("my1Oj", function(module, exports) {

$parcel$export(module.exports, "formatISODuration", function () { return $043c737af8361464$export$437c31ab743f6b26; }, function (v) { return $043c737af8361464$export$437c31ab743f6b26 = v; });
var $043c737af8361464$export$437c31ab743f6b26;
"use strict";
$043c737af8361464$export$437c31ab743f6b26 = $043c737af8361464$var$formatISODuration;
/**
 * @name formatISODuration
 * @category Common Helpers
 * @summary Format a duration object according as ISO 8601 duration string
 *
 * @description
 * Format a duration object according to the ISO 8601 duration standard (https://www.digi.com/resources/documentation/digidocs//90001488-13/reference/r_iso_8601_duration_format.htm)
 *
 * @param duration - The duration to format
 *
 * @returns The ISO 8601 duration string
 *
 * @example
 * // Format the given duration as ISO 8601 string
 * const result = formatISODuration({
 *   years: 39,
 *   months: 2,
 *   days: 20,
 *   hours: 7,
 *   minutes: 5,
 *   seconds: 0
 * })
 * //=> 'P39Y2M20DT0H0M0S'
 */ function $043c737af8361464$var$formatISODuration(duration) {
    const { years: years = 0, months: months = 0, days: days = 0, hours: hours = 0, minutes: minutes = 0, seconds: seconds = 0 } = duration;
    return `P${years}Y${months}M${days}DT${hours}H${minutes}M${seconds}S`;
}

});

parcelRegister("bAugd", function(module, exports) {

$parcel$export(module.exports, "formatRFC3339", function () { return $86fa87a122689f87$export$6d441bffeec6bd6c; }, function (v) { return $86fa87a122689f87$export$6d441bffeec6bd6c = v; });
var $86fa87a122689f87$export$6d441bffeec6bd6c;
"use strict";
$86fa87a122689f87$export$6d441bffeec6bd6c = $86fa87a122689f87$var$formatRFC3339;

var $drHAt = parcelRequire("drHAt");

var $eimnm = parcelRequire("eimnm");

var $cC1Wj = parcelRequire("cC1Wj");
/**
 * The {@link formatRFC3339} function options.
 */ /**
 * @name formatRFC3339
 * @category Common Helpers
 * @summary Format the date according to the RFC 3339 standard (https://tools.ietf.org/html/rfc3339#section-5.6).
 *
 * @description
 * Return the formatted date string in RFC 3339 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in RFC 3339 format:
 * formatRFC3339(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in RFC 3339 format, 3 digits of second fraction
 * formatRFC3339(new Date(2019, 8, 18, 19, 0, 52, 234), {
 *   fractionDigits: 3
 * })
 * //=> '2019-09-18T19:00:52.234Z'
 */ function $86fa87a122689f87$var$formatRFC3339(date, options) {
    const _date = (0, $eimnm.toDate)(date);
    if (!(0, $drHAt.isValid)(_date)) throw new RangeError("Invalid time value");
    const fractionDigits = options?.fractionDigits ?? 0;
    const day = (0, $cC1Wj.addLeadingZeros)(_date.getDate(), 2);
    const month = (0, $cC1Wj.addLeadingZeros)(_date.getMonth() + 1, 2);
    const year = _date.getFullYear();
    const hour = (0, $cC1Wj.addLeadingZeros)(_date.getHours(), 2);
    const minute = (0, $cC1Wj.addLeadingZeros)(_date.getMinutes(), 2);
    const second = (0, $cC1Wj.addLeadingZeros)(_date.getSeconds(), 2);
    let fractionalSecond = "";
    if (fractionDigits > 0) {
        const milliseconds = _date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, fractionDigits - 3));
        fractionalSecond = "." + (0, $cC1Wj.addLeadingZeros)(fractionalSeconds, fractionDigits);
    }
    let offset = "";
    const tzOffset = _date.getTimezoneOffset();
    if (tzOffset !== 0) {
        const absoluteOffset = Math.abs(tzOffset);
        const hourOffset = (0, $cC1Wj.addLeadingZeros)(Math.trunc(absoluteOffset / 60), 2);
        const minuteOffset = (0, $cC1Wj.addLeadingZeros)(absoluteOffset % 60, 2);
        // If less than 0, the sign is +, because it is ahead of time.
        const sign = tzOffset < 0 ? "+" : "-";
        offset = `${sign}${hourOffset}:${minuteOffset}`;
    } else offset = "Z";
    return `${year}-${month}-${day}T${hour}:${minute}:${second}${fractionalSecond}${offset}`;
}

});

parcelRegister("5VYHl", function(module, exports) {

$parcel$export(module.exports, "formatRFC7231", function () { return $45215c017851e92a$export$7add2e4539ce658a; }, function (v) { return $45215c017851e92a$export$7add2e4539ce658a = v; });
var $45215c017851e92a$export$7add2e4539ce658a;
"use strict";
$45215c017851e92a$export$7add2e4539ce658a = $45215c017851e92a$var$formatRFC7231;

var $drHAt = parcelRequire("drHAt");

var $eimnm = parcelRequire("eimnm");

var $cC1Wj = parcelRequire("cC1Wj");
const $45215c017851e92a$var$days = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
const $45215c017851e92a$var$months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
/**
 * @name formatRFC7231
 * @category Common Helpers
 * @summary Format the date according to the RFC 7231 standard (https://tools.ietf.org/html/rfc7231#section-7.1.1.1).
 *
 * @description
 * Return the formatted date string in RFC 7231 format.
 * The result will always be in UTC timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in RFC 7231 format:
 * const result = formatRFC7231(new Date(2019, 8, 18, 19, 0, 52))
 * //=> 'Wed, 18 Sep 2019 19:00:52 GMT'
 */ function $45215c017851e92a$var$formatRFC7231(date) {
    const _date = (0, $eimnm.toDate)(date);
    if (!(0, $drHAt.isValid)(_date)) throw new RangeError("Invalid time value");
    const dayName = $45215c017851e92a$var$days[_date.getUTCDay()];
    const dayOfMonth = (0, $cC1Wj.addLeadingZeros)(_date.getUTCDate(), 2);
    const monthName = $45215c017851e92a$var$months[_date.getUTCMonth()];
    const year = _date.getUTCFullYear();
    const hour = (0, $cC1Wj.addLeadingZeros)(_date.getUTCHours(), 2);
    const minute = (0, $cC1Wj.addLeadingZeros)(_date.getUTCMinutes(), 2);
    const second = (0, $cC1Wj.addLeadingZeros)(_date.getUTCSeconds(), 2);
    // Result variables.
    return `${dayName}, ${dayOfMonth} ${monthName} ${year} ${hour}:${minute}:${second} GMT`;
}

});

parcelRegister("aIT4W", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $7ce8bceb32cec7fa$export$8fbbfd65594f46a0; }, function (v) { return $7ce8bceb32cec7fa$export$8fbbfd65594f46a0 = v; });
var $7ce8bceb32cec7fa$export$8fbbfd65594f46a0;
"use strict";
$7ce8bceb32cec7fa$export$8fbbfd65594f46a0 = $7ce8bceb32cec7fa$var$formatRelative;

var $ctsEq = parcelRequire("ctsEq");

var $jnWO3 = parcelRequire("jnWO3");

var $eimnm = parcelRequire("eimnm");

var $aQ9aQ = parcelRequire("aQ9aQ");

var $hIOa6 = parcelRequire("hIOa6");
/**
 * The {@link formatRelative} function options.
 */ /**
 * @name formatRelative
 * @category Common Helpers
 * @summary Represent the date in words relative to the given base date.
 *
 * @description
 * Represent the date in words relative to the given base date.
 *
 * | Distance to the base date | Result                    |
 * |---------------------------|---------------------------|
 * | Previous 6 days           | last Sunday at 04:30 AM   |
 * | Last day                  | yesterday at 04:30 AM     |
 * | Same day                  | today at 04:30 AM         |
 * | Next day                  | tomorrow at 04:30 AM      |
 * | Next 6 days               | Sunday at 04:30 AM        |
 * | Other                     | 12/31/2017                |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The date in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws `options.locale` must contain `formatRelative` property
 *
 * @example
 * // Represent the date of 6 days ago in words relative to the given base date. In this example, today is Wednesday
 * const result = formatRelative(subDays(new Date(), 6), new Date())
 * //=> "last Thursday at 12:45 AM"
 */ function $7ce8bceb32cec7fa$var$formatRelative(date, baseDate, options) {
    const _date = (0, $eimnm.toDate)(date);
    const _baseDate = (0, $eimnm.toDate)(baseDate);
    const defaultOptions = (0, $hIOa6.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $aQ9aQ.defaultLocale;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const diff = (0, $ctsEq.differenceInCalendarDays)(_date, _baseDate);
    if (isNaN(diff)) throw new RangeError("Invalid time value");
    let token;
    if (diff < -6) token = "other";
    else if (diff < -1) token = "lastWeek";
    else if (diff < 0) token = "yesterday";
    else if (diff < 1) token = "today";
    else if (diff < 2) token = "tomorrow";
    else if (diff < 7) token = "nextWeek";
    else token = "other";
    const formatStr = locale.formatRelative(token, _date, _baseDate, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
    return (0, $jnWO3.format)(_date, formatStr, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
}

});

parcelRegister("a1Z0s", function(module, exports) {

$parcel$export(module.exports, "fromUnixTime", function () { return $74d951f9d6588f15$export$3664df8597731ed4; }, function (v) { return $74d951f9d6588f15$export$3664df8597731ed4 = v; });
var $74d951f9d6588f15$export$3664df8597731ed4;
"use strict";
$74d951f9d6588f15$export$3664df8597731ed4 = $74d951f9d6588f15$var$fromUnixTime;

var $eimnm = parcelRequire("eimnm");
/**
 * @name fromUnixTime
 * @category Timestamp Helpers
 * @summary Create a date from a Unix timestamp.
 *
 * @description
 * Create a date from a Unix timestamp (in seconds). Decimal values will be discarded.
 *
 * @param unixTime - The given Unix timestamp (in seconds)
 *
 * @returns The date
 *
 * @example
 * // Create the date 29 February 2012 11:45:05:
 * const result = fromUnixTime(1330515905)
 * //=> Wed Feb 29 2012 11:45:05
 */ function $74d951f9d6588f15$var$fromUnixTime(unixTime) {
    return (0, $eimnm.toDate)(unixTime * 1000);
}

});

parcelRegister("3y9me", function(module, exports) {

$parcel$export(module.exports, "getDate", function () { return $295bce48fbbd6b9b$export$aa350b96d91cd94; }, function (v) { return $295bce48fbbd6b9b$export$aa350b96d91cd94 = v; });
var $295bce48fbbd6b9b$export$aa350b96d91cd94;
"use strict";
$295bce48fbbd6b9b$export$aa350b96d91cd94 = $295bce48fbbd6b9b$var$getDate;

var $eimnm = parcelRequire("eimnm");
/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of month
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * const result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */ function $295bce48fbbd6b9b$var$getDate(date) {
    const _date = (0, $eimnm.toDate)(date);
    const dayOfMonth = _date.getDate();
    return dayOfMonth;
}

});

parcelRegister("zkIQr", function(module, exports) {

$parcel$export(module.exports, "getDay", function () { return $06a35804711fb31c$export$1b64bc9c5306ed54; }, function (v) { return $06a35804711fb31c$export$1b64bc9c5306ed54 = v; });
var $06a35804711fb31c$export$1b64bc9c5306ed54;
"use strict";
$06a35804711fb31c$export$1b64bc9c5306ed54 = $06a35804711fb31c$var$getDay;

var $eimnm = parcelRequire("eimnm");
/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of week, 0 represents Sunday
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */ function $06a35804711fb31c$var$getDay(date) {
    const _date = (0, $eimnm.toDate)(date);
    const day = _date.getDay();
    return day;
}

});

parcelRegister("4bDiJ", function(module, exports) {

$parcel$export(module.exports, "getDaysInMonth", function () { return $30c6ace2b5d9f326$export$f645ddd439eb259d; }, function (v) { return $30c6ace2b5d9f326$export$f645ddd439eb259d = v; });
var $30c6ace2b5d9f326$export$f645ddd439eb259d;
"use strict";
$30c6ace2b5d9f326$export$f645ddd439eb259d = $30c6ace2b5d9f326$var$getDaysInMonth;

var $eimnm = parcelRequire("eimnm");

var $909bC = parcelRequire("909bC");
/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */ function $30c6ace2b5d9f326$var$getDaysInMonth(date) {
    const _date = (0, $eimnm.toDate)(date);
    const year = _date.getFullYear();
    const monthIndex = _date.getMonth();
    const lastDayOfMonth = (0, $909bC.constructFrom)(date, 0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}

});

parcelRegister("02Gfq", function(module, exports) {

$parcel$export(module.exports, "getDaysInYear", function () { return $0080f592485caea6$export$63a4a9fc49e3550e; }, function (v) { return $0080f592485caea6$export$63a4a9fc49e3550e = v; });
var $0080f592485caea6$export$63a4a9fc49e3550e;
"use strict";
$0080f592485caea6$export$63a4a9fc49e3550e = $0080f592485caea6$var$getDaysInYear;

var $8VWnL = parcelRequire("8VWnL");

var $eimnm = parcelRequire("eimnm");
/**
 * @name getDaysInYear
 * @category Year Helpers
 * @summary Get the number of days in a year of the given date.
 *
 * @description
 * Get the number of days in a year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of days in a year
 *
 * @example
 * // How many days are in 2012?
 * const result = getDaysInYear(new Date(2012, 0, 1))
 * //=> 366
 */ function $0080f592485caea6$var$getDaysInYear(date) {
    const _date = (0, $eimnm.toDate)(date);
    if (String(new Date(_date)) === "Invalid Date") return NaN;
    return (0, $8VWnL.isLeapYear)(_date) ? 366 : 365;
}

});
parcelRegister("8VWnL", function(module, exports) {

$parcel$export(module.exports, "isLeapYear", function () { return $6810ef18119162fe$export$553d7fa8e3805fc0; }, function (v) { return $6810ef18119162fe$export$553d7fa8e3805fc0 = v; });
var $6810ef18119162fe$export$553d7fa8e3805fc0;
"use strict";
$6810ef18119162fe$export$553d7fa8e3805fc0 = $6810ef18119162fe$var$isLeapYear;

var $eimnm = parcelRequire("eimnm");
/**
 * @name isLeapYear
 * @category Year Helpers
 * @summary Is the given date in the leap year?
 *
 * @description
 * Is the given date in the leap year?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the leap year
 *
 * @example
 * // Is 1 September 2012 in the leap year?
 * const result = isLeapYear(new Date(2012, 8, 1))
 * //=> true
 */ function $6810ef18119162fe$var$isLeapYear(date) {
    const _date = (0, $eimnm.toDate)(date);
    const year = _date.getFullYear();
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

});


parcelRegister("9bUFZ", function(module, exports) {

$parcel$export(module.exports, "getDecade", function () { return $6b111ad978a0e4e0$export$5bc0f4decfc52b64; }, function (v) { return $6b111ad978a0e4e0$export$5bc0f4decfc52b64 = v; });
var $6b111ad978a0e4e0$export$5bc0f4decfc52b64;
"use strict";
$6b111ad978a0e4e0$export$5bc0f4decfc52b64 = $6b111ad978a0e4e0$var$getDecade;

var $eimnm = parcelRequire("eimnm");
/**
 * @name getDecade
 * @category Decade Helpers
 * @summary Get the decade of the given date.
 *
 * @description
 * Get the decade of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The year of decade
 *
 * @example
 * // Which decade belongs 27 November 1942?
 * const result = getDecade(new Date(1942, 10, 27))
 * //=> 1940
 */ function $6b111ad978a0e4e0$var$getDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $eimnm.toDate)(date);
    const year = _date.getFullYear();
    const decade = Math.floor(year / 10) * 10;
    return decade;
}

});

parcelRegister("j7GAC", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", function () { return $debfb52d71ac437e$export$430a3269e24b912e; }, function (v) { return $debfb52d71ac437e$export$430a3269e24b912e = v; });
var $debfb52d71ac437e$export$430a3269e24b912e;
"use strict";
$debfb52d71ac437e$export$430a3269e24b912e = $debfb52d71ac437e$var$getDefaultOptions;

var $hIOa6 = parcelRequire("hIOa6");
/**
 * @name getDefaultOptions
 * @category Common Helpers
 * @summary Get default options.
 * @pure false
 *
 * @description
 * Returns an object that contains defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * You can change these with [setDefaultOptions](https://date-fns.org/docs/setDefaultOptions).
 *
 * @returns The default options
 *
 * @example
 * const result = getDefaultOptions()
 * //=> {}
 *
 * @example
 * setDefaultOptions({ weekStarsOn: 1, firstWeekContainsDate: 4 })
 * const result = getDefaultOptions()
 * //=> { weekStarsOn: 1, firstWeekContainsDate: 4 }
 */ function $debfb52d71ac437e$var$getDefaultOptions() {
    return Object.assign({}, (0, $hIOa6.getDefaultOptions)());
}

});

parcelRegister("cVs37", function(module, exports) {

$parcel$export(module.exports, "getHours", function () { return $969090e91c4886f1$export$257b40f71c07d58f; }, function (v) { return $969090e91c4886f1$export$257b40f71c07d58f = v; });
var $969090e91c4886f1$export$257b40f71c07d58f;
"use strict";
$969090e91c4886f1$export$257b40f71c07d58f = $969090e91c4886f1$var$getHours;

var $eimnm = parcelRequire("eimnm");
/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The hours
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */ function $969090e91c4886f1$var$getHours(date) {
    const _date = (0, $eimnm.toDate)(date);
    const hours = _date.getHours();
    return hours;
}

});

parcelRegister("eE1JP", function(module, exports) {

$parcel$export(module.exports, "getISODay", function () { return $aa962645a7c6e034$export$c514f4c1a8ed5e9e; }, function (v) { return $aa962645a7c6e034$export$c514f4c1a8ed5e9e = v; });
var $aa962645a7c6e034$export$c514f4c1a8ed5e9e;
"use strict";
$aa962645a7c6e034$export$c514f4c1a8ed5e9e = $aa962645a7c6e034$var$getISODay;

var $eimnm = parcelRequire("eimnm");
/**
 * @name getISODay
 * @category Weekday Helpers
 * @summary Get the day of the ISO week of the given date.
 *
 * @description
 * Get the day of the ISO week of the given date,
 * which is 7 for Sunday, 1 for Monday etc.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of ISO week
 *
 * @example
 * // Which day of the ISO week is 26 February 2012?
 * const result = getISODay(new Date(2012, 1, 26))
 * //=> 7
 */ function $aa962645a7c6e034$var$getISODay(date) {
    const _date = (0, $eimnm.toDate)(date);
    let day = _date.getDay();
    if (day === 0) day = 7;
    return day;
}

});

parcelRegister("d6ILE", function(module, exports) {

$parcel$export(module.exports, "getISOWeeksInYear", function () { return $98ae8fc854d0873a$export$822983242a16750f; }, function (v) { return $98ae8fc854d0873a$export$822983242a16750f = v; });
var $98ae8fc854d0873a$export$822983242a16750f;
"use strict";
$98ae8fc854d0873a$export$822983242a16750f = $98ae8fc854d0873a$var$getISOWeeksInYear;

var $6T9jK = parcelRequire("6T9jK");

var $lILKk = parcelRequire("lILKk");

var $aK6Tu = parcelRequire("aK6Tu");
/**
 * @name getISOWeeksInYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * @description
 * Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of ISO weeks in a year
 *
 * @example
 * // How many weeks are in ISO week-numbering year 2015?
 * const result = getISOWeeksInYear(new Date(2015, 1, 11))
 * //=> 53
 */ function $98ae8fc854d0873a$var$getISOWeeksInYear(date) {
    const thisYear = (0, $aK6Tu.startOfISOWeekYear)(date);
    const nextYear = (0, $aK6Tu.startOfISOWeekYear)((0, $6T9jK.addWeeks)(thisYear, 60));
    const diff = +nextYear - +thisYear;
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / $lILKk.millisecondsInWeek);
}

});

parcelRegister("7I8wB", function(module, exports) {

$parcel$export(module.exports, "getMilliseconds", function () { return $59d341508b91292f$export$b8e4380f312797af; }, function (v) { return $59d341508b91292f$export$b8e4380f312797af = v; });
var $59d341508b91292f$export$b8e4380f312797af;
"use strict";
$59d341508b91292f$export$b8e4380f312797af = $59d341508b91292f$var$getMilliseconds;

var $eimnm = parcelRequire("eimnm");
/**
 * @name getMilliseconds
 * @category Millisecond Helpers
 * @summary Get the milliseconds of the given date.
 *
 * @description
 * Get the milliseconds of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The milliseconds
 *
 * @example
 * // Get the milliseconds of 29 February 2012 11:45:05.123:
 * const result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 123
 */ function $59d341508b91292f$var$getMilliseconds(date) {
    const _date = (0, $eimnm.toDate)(date);
    const milliseconds = _date.getMilliseconds();
    return milliseconds;
}

});

parcelRegister("4qrOP", function(module, exports) {

$parcel$export(module.exports, "getMinutes", function () { return $338f2b5951d3e8e7$export$b7f1bc3ea3ac4145; }, function (v) { return $338f2b5951d3e8e7$export$b7f1bc3ea3ac4145 = v; });
var $338f2b5951d3e8e7$export$b7f1bc3ea3ac4145;
"use strict";
$338f2b5951d3e8e7$export$b7f1bc3ea3ac4145 = $338f2b5951d3e8e7$var$getMinutes;

var $eimnm = parcelRequire("eimnm");
/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The minutes
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */ function $338f2b5951d3e8e7$var$getMinutes(date) {
    const _date = (0, $eimnm.toDate)(date);
    const minutes = _date.getMinutes();
    return minutes;
}

});

parcelRegister("c52MN", function(module, exports) {

$parcel$export(module.exports, "getMonth", function () { return $8cb81ce8354277c9$export$6ce1b5acc29cb53b; }, function (v) { return $8cb81ce8354277c9$export$6ce1b5acc29cb53b = v; });
var $8cb81ce8354277c9$export$6ce1b5acc29cb53b;
"use strict";
$8cb81ce8354277c9$export$6ce1b5acc29cb53b = $8cb81ce8354277c9$var$getMonth;

var $eimnm = parcelRequire("eimnm");
/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The month index (0-11)
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */ function $8cb81ce8354277c9$var$getMonth(date) {
    const _date = (0, $eimnm.toDate)(date);
    const month = _date.getMonth();
    return month;
}

});

parcelRegister("3ljvc", function(module, exports) {

$parcel$export(module.exports, "getOverlappingDaysInIntervals", function () { return $26f2760570683115$export$baae148532bd1d46; }, function (v) { return $26f2760570683115$export$baae148532bd1d46 = v; });
var $26f2760570683115$export$baae148532bd1d46;
"use strict";
$26f2760570683115$export$baae148532bd1d46 = $26f2760570683115$var$getOverlappingDaysInIntervals;

var $i6arj = parcelRequire("i6arj");

var $lILKk = parcelRequire("lILKk");

var $eimnm = parcelRequire("eimnm");
/**
 * @name getOverlappingDaysInIntervals
 * @category Interval Helpers
 * @summary Get the number of days that overlap in two time intervals
 *
 * @description
 * Get the number of days that overlap in two time intervals. It uses the time
 * between dates to calculate the number of days, rounding it up to include
 * partial days.
 *
 * Two equal 0-length intervals will result in 0. Two equal 1ms intervals will
 * result in 1.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param intervalLeft - The first interval to compare.
 * @param intervalRight - The second interval to compare.
 *
 * @returns The number of days that overlap in two time intervals
 *
 * @example
 * // For overlapping time intervals adds 1 for each started overlapping day:
 * getOverlappingDaysInIntervals(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
 * )
 * //=> 3
 *
 * @example
 * // For non-overlapping time intervals returns 0:
 * getOverlappingDaysInIntervals(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
 * )
 * //=> 0
 */ function $26f2760570683115$var$getOverlappingDaysInIntervals(intervalLeft, intervalRight) {
    const [leftStart, leftEnd] = [
        +(0, $eimnm.toDate)(intervalLeft.start),
        +(0, $eimnm.toDate)(intervalLeft.end)
    ].sort((a, b)=>a - b);
    const [rightStart, rightEnd] = [
        +(0, $eimnm.toDate)(intervalRight.start),
        +(0, $eimnm.toDate)(intervalRight.end)
    ].sort((a, b)=>a - b);
    // Prevent NaN result if intervals don't overlap at all.
    const isOverlapping = leftStart < rightEnd && rightStart < leftEnd;
    if (!isOverlapping) return 0;
    // Remove the timezone offset to negate the DST effect on calculations.
    const overlapLeft = rightStart < leftStart ? leftStart : rightStart;
    const left = overlapLeft - (0, $i6arj.getTimezoneOffsetInMilliseconds)(overlapLeft);
    const overlapRight = rightEnd > leftEnd ? leftEnd : rightEnd;
    const right = overlapRight - (0, $i6arj.getTimezoneOffsetInMilliseconds)(overlapRight);
    // Ceil the number to include partial days too.
    return Math.ceil((right - left) / $lILKk.millisecondsInDay);
}

});

parcelRegister("14cI0", function(module, exports) {

$parcel$export(module.exports, "getSeconds", function () { return $0c7005dce7e12a8d$export$5e9417507ff28427; }, function (v) { return $0c7005dce7e12a8d$export$5e9417507ff28427 = v; });
var $0c7005dce7e12a8d$export$5e9417507ff28427;
"use strict";
$0c7005dce7e12a8d$export$5e9417507ff28427 = $0c7005dce7e12a8d$var$getSeconds;

var $eimnm = parcelRequire("eimnm");
/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The seconds
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */ function $0c7005dce7e12a8d$var$getSeconds(date) {
    const _date = (0, $eimnm.toDate)(date);
    const seconds = _date.getSeconds();
    return seconds;
}

});

parcelRegister("iXT0v", function(module, exports) {

$parcel$export(module.exports, "getTime", function () { return $dce867f08874e2f4$export$1428f42a7de81803; }, function (v) { return $dce867f08874e2f4$export$1428f42a7de81803 = v; });
var $dce867f08874e2f4$export$1428f42a7de81803;
"use strict";
$dce867f08874e2f4$export$1428f42a7de81803 = $dce867f08874e2f4$var$getTime;

var $eimnm = parcelRequire("eimnm");
/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */ function $dce867f08874e2f4$var$getTime(date) {
    const _date = (0, $eimnm.toDate)(date);
    const timestamp = _date.getTime();
    return timestamp;
}

});

parcelRegister("5eEAU", function(module, exports) {

$parcel$export(module.exports, "getUnixTime", function () { return $3cfdbfc0dbd335e1$export$1f77c0008d16313; }, function (v) { return $3cfdbfc0dbd335e1$export$1f77c0008d16313 = v; });
var $3cfdbfc0dbd335e1$export$1f77c0008d16313;
"use strict";
$3cfdbfc0dbd335e1$export$1f77c0008d16313 = $3cfdbfc0dbd335e1$var$getUnixTime;

var $eimnm = parcelRequire("eimnm");
/**
 * @name getUnixTime
 * @category Timestamp Helpers
 * @summary Get the seconds timestamp of the given date.
 *
 * @description
 * Get the seconds timestamp of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05 CET:
 * const result = getUnixTime(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 1330512305
 */ function $3cfdbfc0dbd335e1$var$getUnixTime(date) {
    return Math.trunc(+(0, $eimnm.toDate)(date) / 1000);
}

});

parcelRegister("7zFKO", function(module, exports) {

$parcel$export(module.exports, "getWeekOfMonth", function () { return $583c30c30e06b7c8$export$59fb9b85a4d8d027; }, function (v) { return $583c30c30e06b7c8$export$59fb9b85a4d8d027 = v; });
var $583c30c30e06b7c8$export$59fb9b85a4d8d027;
"use strict";
$583c30c30e06b7c8$export$59fb9b85a4d8d027 = $583c30c30e06b7c8$var$getWeekOfMonth;

var $3y9me = parcelRequire("3y9me");

var $zkIQr = parcelRequire("zkIQr");

var $akZ7E = parcelRequire("akZ7E");

var $hIOa6 = parcelRequire("hIOa6");
/**
 * The {@link getWeekOfMonth} function options.
 */ /**
 * @name getWeekOfMonth
 * @category Week Helpers
 * @summary Get the week of the month of the given date.
 *
 * @description
 * Get the week of the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The week of month
 *
 * @example
 * // Which week of the month is 9 November 2017?
 * const result = getWeekOfMonth(new Date(2017, 10, 9))
 * //=> 2
 */ function $583c30c30e06b7c8$var$getWeekOfMonth(date, options) {
    const defaultOptions = (0, $hIOa6.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const currentDayOfMonth = (0, $3y9me.getDate)(date);
    if (isNaN(currentDayOfMonth)) return NaN;
    const startWeekDay = (0, $zkIQr.getDay)((0, $akZ7E.startOfMonth)(date));
    let lastDayOfFirstWeek = weekStartsOn - startWeekDay;
    if (lastDayOfFirstWeek <= 0) lastDayOfFirstWeek += 7;
    const remainingDaysAfterFirstWeek = currentDayOfMonth - lastDayOfFirstWeek;
    return Math.ceil(remainingDaysAfterFirstWeek / 7) + 1;
}

});

parcelRegister("1zhi2", function(module, exports) {

$parcel$export(module.exports, "getWeeksInMonth", function () { return $124678bfb1a4786d$export$ccc1b2479e7dd654; }, function (v) { return $124678bfb1a4786d$export$ccc1b2479e7dd654 = v; });
var $124678bfb1a4786d$export$ccc1b2479e7dd654;
"use strict";
$124678bfb1a4786d$export$ccc1b2479e7dd654 = $124678bfb1a4786d$var$getWeeksInMonth;

var $7pWjY = parcelRequire("7pWjY");

var $cDG7a = parcelRequire("cDG7a");

var $akZ7E = parcelRequire("akZ7E");
/**
 * The {@link getWeeksInMonth} function options.
 */ /**
 * @name getWeeksInMonth
 * @category Week Helpers
 * @summary Get the number of calendar weeks a month spans.
 *
 * @description
 * Get the number of calendar weeks the month in the given date spans.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The number of calendar weeks
 *
 * @example
 * // How many calendar weeks does February 2015 span?
 * const result = getWeeksInMonth(new Date(2015, 1, 8))
 * //=> 4
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks does July 2017 span?
 * const result = getWeeksInMonth(new Date(2017, 6, 5), { weekStartsOn: 1 })
 * //=> 6
 */ function $124678bfb1a4786d$var$getWeeksInMonth(date, options) {
    return (0, $7pWjY.differenceInCalendarWeeks)((0, $cDG7a.lastDayOfMonth)(date), (0, $akZ7E.startOfMonth)(date), options) + 1;
}

});
parcelRegister("cDG7a", function(module, exports) {

$parcel$export(module.exports, "lastDayOfMonth", function () { return $9339cb9ff45bb957$export$36818250d6c87922; }, function (v) { return $9339cb9ff45bb957$export$36818250d6c87922 = v; });
var $9339cb9ff45bb957$export$36818250d6c87922;
"use strict";
$9339cb9ff45bb957$export$36818250d6c87922 = $9339cb9ff45bb957$var$lastDayOfMonth;

var $eimnm = parcelRequire("eimnm");
/**
 * @name lastDayOfMonth
 * @category Month Helpers
 * @summary Return the last day of a month for the given date.
 *
 * @description
 * Return the last day of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a month
 *
 * @example
 * // The last day of a month for 2 September 2014 11:55:00:
 * const result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */ function $9339cb9ff45bb957$var$lastDayOfMonth(date) {
    const _date = (0, $eimnm.toDate)(date);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});


parcelRegister("b1qKz", function(module, exports) {

$parcel$export(module.exports, "getYear", function () { return $806489b39099a3ca$export$5846dc2d57a5c860; }, function (v) { return $806489b39099a3ca$export$5846dc2d57a5c860 = v; });
var $806489b39099a3ca$export$5846dc2d57a5c860;
"use strict";
$806489b39099a3ca$export$5846dc2d57a5c860 = $806489b39099a3ca$var$getYear;

var $eimnm = parcelRequire("eimnm");
/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The year
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */ function $806489b39099a3ca$var$getYear(date) {
    return (0, $eimnm.toDate)(date).getFullYear();
}

});

parcelRegister("1eSL9", function(module, exports) {

$parcel$export(module.exports, "hoursToMilliseconds", function () { return $0e71935919fc5c65$export$5b42ab7a22898b69; }, function (v) { return $0e71935919fc5c65$export$5b42ab7a22898b69 = v; });
var $0e71935919fc5c65$export$5b42ab7a22898b69;
"use strict";
$0e71935919fc5c65$export$5b42ab7a22898b69 = $0e71935919fc5c65$var$hoursToMilliseconds;

var $lILKk = parcelRequire("lILKk");
/**
 * @name hoursToMilliseconds
 * @category  Conversion Helpers
 * @summary Convert hours to milliseconds.
 *
 * @description
 * Convert a number of hours to a full number of milliseconds.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - number of hours to be converted
 *
 * @returns The number of hours converted to milliseconds
 *
 * @example
 * // Convert 2 hours to milliseconds:
 * const result = hoursToMilliseconds(2)
 * //=> 7200000
 */ function $0e71935919fc5c65$var$hoursToMilliseconds(hours) {
    return Math.trunc(hours * $lILKk.millisecondsInHour);
}

});

parcelRegister("i9Pv6", function(module, exports) {

$parcel$export(module.exports, "hoursToMinutes", function () { return $d381043acf02630c$export$83bfc73cdf89a4d8; }, function (v) { return $d381043acf02630c$export$83bfc73cdf89a4d8 = v; });
var $d381043acf02630c$export$83bfc73cdf89a4d8;
"use strict";
$d381043acf02630c$export$83bfc73cdf89a4d8 = $d381043acf02630c$var$hoursToMinutes;

var $lILKk = parcelRequire("lILKk");
/**
 * @name hoursToMinutes
 * @category Conversion Helpers
 * @summary Convert hours to minutes.
 *
 * @description
 * Convert a number of hours to a full number of minutes.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - number of hours to be converted
 *
 * @returns The number of hours converted in minutes
 *
 * @example
 * // Convert 2 hours to minutes:
 * const result = hoursToMinutes(2)
 * //=> 120
 */ function $d381043acf02630c$var$hoursToMinutes(hours) {
    return Math.trunc(hours * $lILKk.minutesInHour);
}

});

parcelRegister("hx11D", function(module, exports) {

$parcel$export(module.exports, "hoursToSeconds", function () { return $cc365059e1eadf88$export$59b1396ccbd5a4e1; }, function (v) { return $cc365059e1eadf88$export$59b1396ccbd5a4e1 = v; });
var $cc365059e1eadf88$export$59b1396ccbd5a4e1;
"use strict";
$cc365059e1eadf88$export$59b1396ccbd5a4e1 = $cc365059e1eadf88$var$hoursToSeconds;

var $lILKk = parcelRequire("lILKk");
/**
 * @name hoursToSeconds
 * @category Conversion Helpers
 * @summary Convert hours to seconds.
 *
 * @description
 * Convert a number of hours to a full number of seconds.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - The number of hours to be converted
 *
 * @returns The number of hours converted in seconds
 *
 * @example
 * // Convert 2 hours to seconds:
 * const result = hoursToSeconds(2)
 * //=> 7200
 */ function $cc365059e1eadf88$var$hoursToSeconds(hours) {
    return Math.trunc(hours * $lILKk.secondsInHour);
}

});

parcelRegister("fsLNk", function(module, exports) {

$parcel$export(module.exports, "interval", function () { return $b41e8b8d24f68f0e$export$3174cdbf0a0cbc84; }, function (v) { return $b41e8b8d24f68f0e$export$3174cdbf0a0cbc84 = v; });
var $b41e8b8d24f68f0e$export$3174cdbf0a0cbc84;
"use strict";
$b41e8b8d24f68f0e$export$3174cdbf0a0cbc84 = $b41e8b8d24f68f0e$var$interval;

var $eimnm = parcelRequire("eimnm");
/**
 * The {@link interval} function options.
 */ /**
 * @name interval
 * @category Interval Helpers
 * @summary Creates an interval object and validates its values.
 *
 * @description
 * Creates a normalized interval object and validates its values. If the interval is invalid, an exception is thrown.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param start - The start of the interval.
 * @param end - The end of the interval.
 * @param options - The options object.
 *
 * @throws `Start date is invalid` when `start` is invalid.
 * @throws `End date is invalid` when `end` is invalid.
 * @throws `End date must be after start date` when end is before `start` and `options.assertPositive` is true.
 *
 * @returns The normalized and validated interval object.
 */ function $b41e8b8d24f68f0e$var$interval(start, end, options) {
    const _start = (0, $eimnm.toDate)(start);
    if (isNaN(+_start)) throw new TypeError("Start date is invalid");
    const _end = (0, $eimnm.toDate)(end);
    if (isNaN(+_end)) throw new TypeError("End date is invalid");
    if (options?.assertPositive && +_start > +_end) throw new TypeError("End date must be after start date");
    return {
        start: _start,
        end: _end
    };
}

});

parcelRegister("eCLGc", function(module, exports) {

$parcel$export(module.exports, "intervalToDuration", function () { return $aa599980bba1733f$export$7b6c9a626316863; }, function (v) { return $aa599980bba1733f$export$7b6c9a626316863 = v; });
var $aa599980bba1733f$export$7b6c9a626316863;
"use strict";
$aa599980bba1733f$export$7b6c9a626316863 = $aa599980bba1733f$var$intervalToDuration;

var $5nIwf = parcelRequire("5nIwf");

var $h7pQw = parcelRequire("h7pQw");

var $2ORBN = parcelRequire("2ORBN");

var $5luLe = parcelRequire("5luLe");

var $6GN1F = parcelRequire("6GN1F");

var $cTY1w = parcelRequire("cTY1w");

var $f6fMN = parcelRequire("f6fMN");

var $eimnm = parcelRequire("eimnm");
/**
 * @name intervalToDuration
 * @category Common Helpers
 * @summary Convert interval to duration
 *
 * @description
 * Convert a interval object to a duration object.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval to convert to duration
 *
 * @returns The duration object
 *
 * @example
 * // Get the duration between January 15, 1929 and April 4, 1968.
 * intervalToDuration({
 *   start: new Date(1929, 0, 15, 12, 0, 0),
 *   end: new Date(1968, 3, 4, 19, 5, 0)
 * })
 * // => { years: 39, months: 2, days: 20, hours: 7, minutes: 5, seconds: 0 }
 */ function $aa599980bba1733f$var$intervalToDuration(interval) {
    const start = (0, $eimnm.toDate)(interval.start);
    const end = (0, $eimnm.toDate)(interval.end);
    const duration = {};
    const years = (0, $f6fMN.differenceInYears)(end, start);
    if (years) duration.years = years;
    const remainingMonths = (0, $5nIwf.add)(start, {
        years: duration.years
    });
    const months = (0, $6GN1F.differenceInMonths)(end, remainingMonths);
    if (months) duration.months = months;
    const remainingDays = (0, $5nIwf.add)(remainingMonths, {
        months: duration.months
    });
    const days = (0, $h7pQw.differenceInDays)(end, remainingDays);
    if (days) duration.days = days;
    const remainingHours = (0, $5nIwf.add)(remainingDays, {
        days: duration.days
    });
    const hours = (0, $2ORBN.differenceInHours)(end, remainingHours);
    if (hours) duration.hours = hours;
    const remainingMinutes = (0, $5nIwf.add)(remainingHours, {
        hours: duration.hours
    });
    const minutes = (0, $5luLe.differenceInMinutes)(end, remainingMinutes);
    if (minutes) duration.minutes = minutes;
    const remainingSeconds = (0, $5nIwf.add)(remainingMinutes, {
        minutes: duration.minutes
    });
    const seconds = (0, $cTY1w.differenceInSeconds)(end, remainingSeconds);
    if (seconds) duration.seconds = seconds;
    return duration;
}

});

parcelRegister("hX9VQ", function(module, exports) {

$parcel$export(module.exports, "intlFormat", function () { return $d11fa6a16a39cfac$export$f58f1234eed71f82; }, function (v) { return $d11fa6a16a39cfac$export$f58f1234eed71f82 = v; });
var $d11fa6a16a39cfac$export$f58f1234eed71f82;
"use strict";
$d11fa6a16a39cfac$export$f58f1234eed71f82 = $d11fa6a16a39cfac$var$intlFormat;

var $eimnm = parcelRequire("eimnm");
/**
 * The locale string (see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).
 */ /**
 * The format options (see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#options)
 */ /**
 * The locale options.
 */ /**
 * @name intlFormat
 * @category Common Helpers
 * @summary Format the date with Intl.DateTimeFormat (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat).
 *
 * @description
 * Return the formatted date string in the given format.
 * The method uses [`Intl.DateTimeFormat`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat) inside.
 * formatOptions are the same as [`Intl.DateTimeFormat` options](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat#using_options)
 *
 * > ⚠️ Please note that before Node version 13.0.0, only the locale data for en-US is available by default.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in middle-endian format:
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456))
 * //=> 10/4/2019
 */ /**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param localeOptions - An object with locale
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in Korean.
 * // Convert the date with locale's options.
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   locale: 'ko-KR',
 * })
 * //=> 2019. 10. 4.
 */ /**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param formatOptions - The format options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019.
 * // Convert the date with format's options.
 * const result = intlFormat.default(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   year: 'numeric',
 *   month: 'numeric',
 *   day: 'numeric',
 *   hour: 'numeric',
 * })
 * //=> 10/4/2019, 12 PM
 */ /**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param formatOptions - The format options
 * @param localeOptions - An object with locale
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in German.
 * // Convert the date with format's options and locale's options.
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   weekday: 'long',
 *   year: 'numeric',
 *   month: 'long',
 *   day: 'numeric',
 * }, {
 *   locale: 'de-DE',
 * })
 * //=> Freitag, 4. Oktober 2019
 */ function $d11fa6a16a39cfac$var$intlFormat(date, formatOrLocale, localeOptions) {
    let formatOptions;
    if ($d11fa6a16a39cfac$var$isFormatOptions(formatOrLocale)) formatOptions = formatOrLocale;
    else localeOptions = formatOrLocale;
    return new Intl.DateTimeFormat(localeOptions?.locale, formatOptions).format((0, $eimnm.toDate)(date));
}
function $d11fa6a16a39cfac$var$isFormatOptions(opts) {
    return opts !== undefined && !("locale" in opts);
}

});

parcelRegister("3nqVd", function(module, exports) {

$parcel$export(module.exports, "intlFormatDistance", function () { return $2758673562b92e9d$export$a110a4020280fd5; }, function (v) { return $2758673562b92e9d$export$a110a4020280fd5 = v; });
var $2758673562b92e9d$export$a110a4020280fd5;
"use strict";
$2758673562b92e9d$export$a110a4020280fd5 = $2758673562b92e9d$var$intlFormatDistance;

var $lILKk = parcelRequire("lILKk");

var $ctsEq = parcelRequire("ctsEq");

var $ecPWs = parcelRequire("ecPWs");

var $4Ccub = parcelRequire("4Ccub");

var $7pWjY = parcelRequire("7pWjY");

var $dQFcH = parcelRequire("dQFcH");

var $2ORBN = parcelRequire("2ORBN");

var $5luLe = parcelRequire("5luLe");

var $cTY1w = parcelRequire("cTY1w");

var $eimnm = parcelRequire("eimnm");
/**
 * The {@link intlFormatDistance} function options.
 */ /**
 * The unit used to format the distance in {@link intlFormatDistance}.
 */ /**
 * @name intlFormatDistance
 * @category Common Helpers
 * @summary Formats distance between two dates in a human-readable format
 * @description
 * The function calculates the difference between two dates and formats it as a human-readable string.
 *
 * The function will pick the most appropriate unit depending on the distance between dates. For example, if the distance is a few hours, it might return `x hours`. If the distance is a few months, it might return `x months`.
 *
 * You can also specify a unit to force using it regardless of the distance to get a result like `123456 hours`.
 *
 * See the table below for the unit picking logic:
 *
 * | Distance between dates | Result (past)  | Result (future) |
 * | ---------------------- | -------------- | --------------- |
 * | 0 seconds              | now            | now             |
 * | 1-59 seconds           | X seconds ago  | in X seconds    |
 * | 1-59 minutes           | X minutes ago  | in X minutes    |
 * | 1-23 hours             | X hours ago    | in X hours      |
 * | 1 day                  | yesterday      | tomorrow        |
 * | 2-6 days               | X days ago     | in X days       |
 * | 7 days                 | last week      | next week       |
 * | 8 days-1 month         | X weeks ago    | in X weeks      |
 * | 1 month                | last month     | next month      |
 * | 2-3 months             | X months ago   | in X months     |
 * | 1 quarter              | last quarter   | next quarter    |
 * | 2-3 quarters           | X quarters ago | in X quarters   |
 * | 1 year                 | last year      | next year       |
 * | 2+ years               | X years ago    | in X years      |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with.
 * @param options - An object with options.
 * See MDN for details [Locale identification and negotiation](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locale_identification_and_negotiation)
 * The narrow one could be similar to the short one for some locales.
 *
 * @returns The distance in words according to language-sensitive relative time formatting.
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.unit` must not be invalid Unit
 * @throws `options.locale` must not be invalid locale
 * @throws `options.localeMatcher` must not be invalid localeMatcher
 * @throws `options.numeric` must not be invalid numeric
 * @throws `options.style` must not be invalid style
 *
 * @example
 * // What is the distance between the dates when the fist date is after the second?
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0)
 * )
 * //=> 'in 1 hour'
 *
 * // What is the distance between the dates when the fist date is before the second?
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0)
 * )
 * //=> '1 hour ago'
 *
 * @example
 * // Use the unit option to force the function to output the result in quarters. Without setting it, the example would return "next year"
 * intlFormatDistance(
 *   new Date(1987, 6, 4, 10, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   { unit: 'quarter' }
 * )
 * //=> 'in 5 quarters'
 *
 * @example
 * // Use the locale option to get the result in Spanish. Without setting it, the example would return "in 1 hour".
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   { locale: 'es' }
 * )
 * //=> 'dentro de 1 hora'
 *
 * @example
 * // Use the numeric option to force the function to use numeric values. Without setting it, the example would return "tomorrow".
 * intlFormatDistance(
 *   new Date(1986, 3, 5, 11, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   { numeric: 'always' }
 * )
 * //=> 'in 1 day'
 *
 * @example
 * // Use the style option to force the function to use short values. Without setting it, the example would return "in 2 years".
 * intlFormatDistance(
 *   new Date(1988, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   { style: 'short' }
 * )
 * //=> 'in 2 yr'
 */ function $2758673562b92e9d$var$intlFormatDistance(date, baseDate, options) {
    let value = 0;
    let unit;
    const dateLeft = (0, $eimnm.toDate)(date);
    const dateRight = (0, $eimnm.toDate)(baseDate);
    if (!options?.unit) {
        // Get the unit based on diffInSeconds calculations if no unit is specified
        const diffInSeconds = (0, $cTY1w.differenceInSeconds)(dateLeft, dateRight); // The smallest unit
        if (Math.abs(diffInSeconds) < $lILKk.secondsInMinute) {
            value = (0, $cTY1w.differenceInSeconds)(dateLeft, dateRight);
            unit = "second";
        } else if (Math.abs(diffInSeconds) < $lILKk.secondsInHour) {
            value = (0, $5luLe.differenceInMinutes)(dateLeft, dateRight);
            unit = "minute";
        } else if (Math.abs(diffInSeconds) < $lILKk.secondsInDay && Math.abs((0, $ctsEq.differenceInCalendarDays)(dateLeft, dateRight)) < 1) {
            value = (0, $2ORBN.differenceInHours)(dateLeft, dateRight);
            unit = "hour";
        } else if (Math.abs(diffInSeconds) < $lILKk.secondsInWeek && (value = (0, $ctsEq.differenceInCalendarDays)(dateLeft, dateRight)) && Math.abs(value) < 7) unit = "day";
        else if (Math.abs(diffInSeconds) < $lILKk.secondsInMonth) {
            value = (0, $7pWjY.differenceInCalendarWeeks)(dateLeft, dateRight);
            unit = "week";
        } else if (Math.abs(diffInSeconds) < $lILKk.secondsInQuarter) {
            value = (0, $ecPWs.differenceInCalendarMonths)(dateLeft, dateRight);
            unit = "month";
        } else if (Math.abs(diffInSeconds) < $lILKk.secondsInYear) {
            if ((0, $4Ccub.differenceInCalendarQuarters)(dateLeft, dateRight) < 4) {
                // To filter out cases that are less than a year but match 4 quarters
                value = (0, $4Ccub.differenceInCalendarQuarters)(dateLeft, dateRight);
                unit = "quarter";
            } else {
                value = (0, $dQFcH.differenceInCalendarYears)(dateLeft, dateRight);
                unit = "year";
            }
        } else {
            value = (0, $dQFcH.differenceInCalendarYears)(dateLeft, dateRight);
            unit = "year";
        }
    } else {
        // Get the value if unit is specified
        unit = options?.unit;
        if (unit === "second") value = (0, $cTY1w.differenceInSeconds)(dateLeft, dateRight);
        else if (unit === "minute") value = (0, $5luLe.differenceInMinutes)(dateLeft, dateRight);
        else if (unit === "hour") value = (0, $2ORBN.differenceInHours)(dateLeft, dateRight);
        else if (unit === "day") value = (0, $ctsEq.differenceInCalendarDays)(dateLeft, dateRight);
        else if (unit === "week") value = (0, $7pWjY.differenceInCalendarWeeks)(dateLeft, dateRight);
        else if (unit === "month") value = (0, $ecPWs.differenceInCalendarMonths)(dateLeft, dateRight);
        else if (unit === "quarter") value = (0, $4Ccub.differenceInCalendarQuarters)(dateLeft, dateRight);
        else if (unit === "year") value = (0, $dQFcH.differenceInCalendarYears)(dateLeft, dateRight);
    }
    const rtf = new Intl.RelativeTimeFormat(options?.locale, {
        localeMatcher: options?.localeMatcher,
        numeric: options?.numeric || "auto",
        style: options?.style
    });
    return rtf.format(value, unit);
}

});

parcelRegister("6GQne", function(module, exports) {

$parcel$export(module.exports, "isAfter", function () { return $4def4aa3837366cc$export$e4de839670987035; }, function (v) { return $4def4aa3837366cc$export$e4de839670987035 = v; });
var $4def4aa3837366cc$export$e4de839670987035;
"use strict";
$4def4aa3837366cc$export$e4de839670987035 = $4def4aa3837366cc$var$isAfter;

var $eimnm = parcelRequire("eimnm");
/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be after the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is after the second date
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */ function $4def4aa3837366cc$var$isAfter(date, dateToCompare) {
    const _date = (0, $eimnm.toDate)(date);
    const _dateToCompare = (0, $eimnm.toDate)(dateToCompare);
    return _date.getTime() > _dateToCompare.getTime();
}

});

parcelRegister("4GY2F", function(module, exports) {

$parcel$export(module.exports, "isBefore", function () { return $36a9a8c8250b6ec0$export$5c007e10c6929c95; }, function (v) { return $36a9a8c8250b6ec0$export$5c007e10c6929c95 = v; });
var $36a9a8c8250b6ec0$export$5c007e10c6929c95;
"use strict";
$36a9a8c8250b6ec0$export$5c007e10c6929c95 = $36a9a8c8250b6ec0$var$isBefore;

var $eimnm = parcelRequire("eimnm");
/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be before the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */ function $36a9a8c8250b6ec0$var$isBefore(date, dateToCompare) {
    const _date = (0, $eimnm.toDate)(date);
    const _dateToCompare = (0, $eimnm.toDate)(dateToCompare);
    return +_date < +_dateToCompare;
}

});

parcelRegister("2Wb8M", function(module, exports) {

$parcel$export(module.exports, "isEqual", function () { return $2239a3dad8bc4fd8$export$248d38f6296296c5; }, function (v) { return $2239a3dad8bc4fd8$export$248d38f6296296c5 = v; });
var $2239a3dad8bc4fd8$export$248d38f6296296c5;
"use strict";
$2239a3dad8bc4fd8$export$248d38f6296296c5 = $2239a3dad8bc4fd8$var$isEqual;

var $eimnm = parcelRequire("eimnm");
/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The dates are equal
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * const result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */ function $2239a3dad8bc4fd8$var$isEqual(leftDate, rightDate) {
    const _dateLeft = (0, $eimnm.toDate)(leftDate);
    const _dateRight = (0, $eimnm.toDate)(rightDate);
    return +_dateLeft === +_dateRight;
}

});

parcelRegister("4EZlQ", function(module, exports) {

$parcel$export(module.exports, "isExists", function () { return $364a7cedef5de2b0$export$127519e0edcdc58b; }, function (v) { return $364a7cedef5de2b0$export$127519e0edcdc58b = v; });
var $364a7cedef5de2b0$export$127519e0edcdc58b;
"use strict";
$364a7cedef5de2b0$export$127519e0edcdc58b = $364a7cedef5de2b0$var$isExists; /**
 * @name isExists
 * @category Common Helpers
 * @summary Is the given date exists?
 *
 * @description
 * Checks if the given arguments convert to an existing date.
 *
 * @param year - The year of the date to check
 * @param month - The month of the date to check
 * @param day - The day of the date to check
 *
 * @returns `true` if the date exists
 *
 * @example
 * // For the valid date:
 * const result = isExists(2018, 0, 31)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isExists(2018, 1, 31)
 * //=> false
 */ 
function $364a7cedef5de2b0$var$isExists(year, month, day) {
    const date = new Date(year, month, day);
    return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day;
}

});

parcelRegister("dvSdP", function(module, exports) {

$parcel$export(module.exports, "isFirstDayOfMonth", function () { return $9d683affb5de548d$export$2716a425049f51dd; }, function (v) { return $9d683affb5de548d$export$2716a425049f51dd = v; });
var $9d683affb5de548d$export$2716a425049f51dd;
"use strict";
$9d683affb5de548d$export$2716a425049f51dd = $9d683affb5de548d$var$isFirstDayOfMonth;

var $eimnm = parcelRequire("eimnm");
/**
 * @name isFirstDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the first day of a month?
 *
 * @description
 * Is the given date the first day of a month?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check

 * @returns The date is the first day of a month
 *
 * @example
 * // Is 1 September 2014 the first day of a month?
 * const result = isFirstDayOfMonth(new Date(2014, 8, 1))
 * //=> true
 */ function $9d683affb5de548d$var$isFirstDayOfMonth(date) {
    return (0, $eimnm.toDate)(date).getDate() === 1;
}

});

parcelRegister("i88NH", function(module, exports) {

$parcel$export(module.exports, "isFriday", function () { return $d32fccfa22173a64$export$3b7d89f127884993; }, function (v) { return $d32fccfa22173a64$export$3b7d89f127884993 = v; });
var $d32fccfa22173a64$export$3b7d89f127884993;
"use strict";
$d32fccfa22173a64$export$3b7d89f127884993 = $d32fccfa22173a64$var$isFriday;

var $eimnm = parcelRequire("eimnm");
/**
 * @name isFriday
 * @category Weekday Helpers
 * @summary Is the given date Friday?
 *
 * @description
 * Is the given date Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Friday
 *
 * @example
 * // Is 26 September 2014 Friday?
 * const result = isFriday(new Date(2014, 8, 26))
 * //=> true
 */ function $d32fccfa22173a64$var$isFriday(date) {
    return (0, $eimnm.toDate)(date).getDay() === 5;
}

});

parcelRegister("fiRVK", function(module, exports) {

$parcel$export(module.exports, "isFuture", function () { return $b2425eecd5bd25ba$export$2baac2df6018cd7; }, function (v) { return $b2425eecd5bd25ba$export$2baac2df6018cd7 = v; });
var $b2425eecd5bd25ba$export$2baac2df6018cd7;
"use strict";
$b2425eecd5bd25ba$export$2baac2df6018cd7 = $b2425eecd5bd25ba$var$isFuture;

var $eimnm = parcelRequire("eimnm");
/**
 * @name isFuture
 * @category Common Helpers
 * @summary Is the given date in the future?
 * @pure false
 *
 * @description
 * Is the given date in the future?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the future
 *
 * @example
 * // If today is 6 October 2014, is 31 December 2014 in the future?
 * const result = isFuture(new Date(2014, 11, 31))
 * //=> true
 */ function $b2425eecd5bd25ba$var$isFuture(date) {
    return +(0, $eimnm.toDate)(date) > Date.now();
}

});

parcelRegister("6tLS8", function(module, exports) {

$parcel$export(module.exports, "isMatch", function () { return $4b7a95eeaba0b89d$export$b74c33566721f70f; }, function (v) { return $4b7a95eeaba0b89d$export$b74c33566721f70f = v; });
var $4b7a95eeaba0b89d$export$b74c33566721f70f;
"use strict";
$4b7a95eeaba0b89d$export$b74c33566721f70f = $4b7a95eeaba0b89d$var$isMatch;

var $drHAt = parcelRequire("drHAt");

var $7TnYs = parcelRequire("7TnYs");
/**
 * The {@link isMatch} function options.
 */ /**
 * @name isMatch
 * @category Common Helpers
 * @summary validates the date string against given formats
 *
 * @description
 * Return the true if given date is string correct against the given format else
 * will return false.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * isMatch('23 AM', 'HH a')
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Su            | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `isMatch` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `isMatch` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `isMatch` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `isMatch('50', 'yy') //=> true`
 *
 *    `isMatch('75', 'yy') //=> true`
 *
 *    while `uu` will use the year as is:
 *
 *    `isMatch('50', 'uu') //=> true`
 *
 *    `isMatch('75', 'uu') //=> true`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear](https://date-fns.org/docs/setISOWeekYear)
 *    and [setWeekYear](https://date-fns.org/docs/setWeekYear)).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be checked in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are matched (e.g. when matching string 'January 1st' without a year),
 * the values will be taken from today's using `new Date()` date which works as a context of parsing.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateStr - The date string to verify
 * @param format - The string of tokens
 * @param options - An object with options.
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @returns Is format string a match for date string?
 *
 * @throws `options.locale` must contain `match` property
 * @throws use `yyyy` instead of `YYYY` for formatting years; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Match 11 February 2014 from middle-endian format:
 * const result = isMatch('02/11/2014', 'MM/dd/yyyy')
 * //=> true
 *
 * @example
 * // Match 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * const result = isMatch('28-a de februaro', "do 'de' MMMM", {
 *   locale: eo
 * })
 * //=> true
 */ function $4b7a95eeaba0b89d$var$isMatch(dateStr, formatStr, options) {
    return (0, $drHAt.isValid)((0, $7TnYs.parse)(dateStr, formatStr, new Date(), options));
}

});
parcelRegister("7TnYs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "longFormatters", {
    enumerable: true,
    get: function() {
        return $dBwuJ.longFormatters;
    }
});
module.exports.parse = $5bf0443ce0bed133$var$parse;
Object.defineProperty(module.exports, "parsers", {
    enumerable: true,
    get: function() {
        return $lK9Yr.parsers;
    }
});

var $909bC = parcelRequire("909bC");

var $j7GAC = parcelRequire("j7GAC");

var $aQ9aQ = parcelRequire("aQ9aQ");

var $eimnm = parcelRequire("eimnm");

var $dBwuJ = parcelRequire("dBwuJ");

var $a5cgw = parcelRequire("a5cgw");

var $lK9Yr = parcelRequire("lK9Yr");

var $emYk0 = parcelRequire("emYk0");
// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
/**
 * The {@link parse} function options.
 */ // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $5bf0443ce0bed133$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $5bf0443ce0bed133$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $5bf0443ce0bed133$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $5bf0443ce0bed133$var$doubleQuoteRegExp = /''/g;
const $5bf0443ce0bed133$var$notWhitespaceRegExp = /\S/;
const $5bf0443ce0bed133$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear](https://date-fns.org/docs/setISOWeekYear)
 *    and [setWeekYear](https://date-fns.org/docs/setWeekYear)).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateStr - The string to parse
 * @param formatStr - The string of tokens
 * @param referenceDate - defines values missing from the parsed dateString
 * @param options - An object with options.
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @returns The parsed date
 *
 * @throws `options.locale` must contain `match` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */ function $5bf0443ce0bed133$var$parse(dateStr, formatStr, referenceDate, options) {
    const defaultOptions = (0, $j7GAC.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $aQ9aQ.defaultLocale;
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    if (formatStr === "") {
        if (dateStr === "") return (0, $eimnm.toDate)(referenceDate);
        else return (0, $909bC.constructFrom)(referenceDate, NaN);
    }
    const subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    const setters = [
        new $emYk0.DateToSystemTimezoneSetter()
    ];
    const tokens = formatStr.match($5bf0443ce0bed133$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter in $dBwuJ.longFormatters) {
            const longFormatter = $dBwuJ.longFormatters[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($5bf0443ce0bed133$var$formattingTokensRegExp);
    const usedTokens = [];
    for (let token of tokens){
        if (!options?.useAdditionalWeekYearTokens && (0, $a5cgw.isProtectedWeekYearToken)(token)) (0, $a5cgw.warnOrThrowProtectedError)(token, formatStr, dateStr);
        if (!options?.useAdditionalDayOfYearTokens && (0, $a5cgw.isProtectedDayOfYearToken)(token)) (0, $a5cgw.warnOrThrowProtectedError)(token, formatStr, dateStr);
        const firstCharacter = token[0];
        const parser = $lK9Yr.parsers[firstCharacter];
        if (parser) {
            const { incompatibleTokens: incompatibleTokens } = parser;
            if (Array.isArray(incompatibleTokens)) {
                const incompatibleToken = usedTokens.find((usedToken)=>incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter);
                if (incompatibleToken) throw new RangeError(`The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token}\` at the same time`);
            } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError(`The format string mustn't contain \`${token}\` and any other token at the same time`);
            usedTokens.push({
                token: firstCharacter,
                fullToken: token
            });
            const parseResult = parser.run(dateStr, token, locale.match, subFnOptions);
            if (!parseResult) return (0, $909bC.constructFrom)(referenceDate, NaN);
            setters.push(parseResult.setter);
            dateStr = parseResult.rest;
        } else {
            if (firstCharacter.match($5bf0443ce0bed133$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
            // Replace two single quote characters with one single quote character
            if (token === "''") token = "'";
            else if (firstCharacter === "'") token = $5bf0443ce0bed133$var$cleanEscapedString(token);
            // Cut token from string, or, if string doesn't match the token, return Invalid Date
            if (dateStr.indexOf(token) === 0) dateStr = dateStr.slice(token.length);
            else return (0, $909bC.constructFrom)(referenceDate, NaN);
        }
    }
    // Check if the remaining input contains something other than whitespace
    if (dateStr.length > 0 && $5bf0443ce0bed133$var$notWhitespaceRegExp.test(dateStr)) return (0, $909bC.constructFrom)(referenceDate, NaN);
    const uniquePrioritySetters = setters.map((setter)=>setter.priority).sort((a, b)=>b - a).filter((priority, index, array)=>array.indexOf(priority) === index).map((priority)=>setters.filter((setter)=>setter.priority === priority).sort((a, b)=>b.subPriority - a.subPriority)).map((setterArray)=>setterArray[0]);
    let date = (0, $eimnm.toDate)(referenceDate);
    if (isNaN(date.getTime())) return (0, $909bC.constructFrom)(referenceDate, NaN);
    const flags = {};
    for (const setter of uniquePrioritySetters){
        if (!setter.validate(date, subFnOptions)) return (0, $909bC.constructFrom)(referenceDate, NaN);
        const result = setter.set(date, flags, subFnOptions);
        // Result is tuple (date, flags)
        if (Array.isArray(result)) {
            date = result[0];
            Object.assign(flags, result[1]);
        // Result is date
        } else date = result;
    }
    return (0, $909bC.constructFrom)(referenceDate, date);
}
function $5bf0443ce0bed133$var$cleanEscapedString(input) {
    return input.match($5bf0443ce0bed133$var$escapedStringRegExp)[1].replace($5bf0443ce0bed133$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("lK9Yr", function(module, exports) {

$parcel$export(module.exports, "parsers", function () { return $fd45a1792c512948$export$19131010e7fd8373; }, function (v) { return $fd45a1792c512948$export$19131010e7fd8373 = v; });
var $fd45a1792c512948$export$19131010e7fd8373;
"use strict";
$fd45a1792c512948$export$19131010e7fd8373 = void 0;

var $5wQqK = parcelRequire("5wQqK");

var $9NVpd = parcelRequire("9NVpd");

var $aK1bs = parcelRequire("aK1bs");

var $3OIve = parcelRequire("3OIve");

var $eOD1U = parcelRequire("eOD1U");

var $koOnw = parcelRequire("koOnw");

var $cEEJp = parcelRequire("cEEJp");

var $kCb6y = parcelRequire("kCb6y");

var $eclaJ = parcelRequire("eclaJ");

var $gQcTP = parcelRequire("gQcTP");

var $1fPqk = parcelRequire("1fPqk");

var $lLlbK = parcelRequire("lLlbK");

var $bvvkX = parcelRequire("bvvkX");

var $fOQp1 = parcelRequire("fOQp1");

var $ear8U = parcelRequire("ear8U");

var $gSu4U = parcelRequire("gSu4U");

var $j1Hqr = parcelRequire("j1Hqr");

var $ab3Ac = parcelRequire("ab3Ac");

var $jPBDa = parcelRequire("jPBDa");

var $a7bmN = parcelRequire("a7bmN");

var $6Awpb = parcelRequire("6Awpb");

var $bgXYf = parcelRequire("bgXYf");

var $8jYvi = parcelRequire("8jYvi");

var $eyo5t = parcelRequire("eyo5t");

var $emehK = parcelRequire("emehK");

var $5tBgd = parcelRequire("5tBgd");

var $5c8fa = parcelRequire("5c8fa");

var $jaqG5 = parcelRequire("jaqG5");

var $8NYk8 = parcelRequire("8NYk8");

var $4Bk8s = parcelRequire("4Bk8s");

var $1S3i2 = parcelRequire("1S3i2");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any -- It's ok, we want any here
const $fd45a1792c512948$var$parsers = $fd45a1792c512948$export$19131010e7fd8373 = {
    G: new $5wQqK.EraParser(),
    y: new $9NVpd.YearParser(),
    Y: new $aK1bs.LocalWeekYearParser(),
    R: new $3OIve.ISOWeekYearParser(),
    u: new $eOD1U.ExtendedYearParser(),
    Q: new $koOnw.QuarterParser(),
    q: new $cEEJp.StandAloneQuarterParser(),
    M: new $kCb6y.MonthParser(),
    L: new $eclaJ.StandAloneMonthParser(),
    w: new $gQcTP.LocalWeekParser(),
    I: new $1fPqk.ISOWeekParser(),
    d: new $lLlbK.DateParser(),
    D: new $bvvkX.DayOfYearParser(),
    E: new $fOQp1.DayParser(),
    e: new $ear8U.LocalDayParser(),
    c: new $gSu4U.StandAloneLocalDayParser(),
    i: new $j1Hqr.ISODayParser(),
    a: new $ab3Ac.AMPMParser(),
    b: new $jPBDa.AMPMMidnightParser(),
    B: new $a7bmN.DayPeriodParser(),
    h: new $6Awpb.Hour1to12Parser(),
    H: new $bgXYf.Hour0to23Parser(),
    K: new $8jYvi.Hour0To11Parser(),
    k: new $eyo5t.Hour1To24Parser(),
    m: new $emehK.MinuteParser(),
    s: new $5tBgd.SecondParser(),
    S: new $5c8fa.FractionOfSecondParser(),
    X: new $jaqG5.ISOTimezoneWithZParser(),
    x: new $8NYk8.ISOTimezoneParser(),
    t: new $4Bk8s.TimestampSecondsParser(),
    T: new $1S3i2.TimestampMillisecondsParser()
};

});
parcelRegister("5wQqK", function(module, exports) {

$parcel$export(module.exports, "EraParser", function () { return $40689c8395b1aa08$export$8e5a1d3f85a9688; }, function (v) { return $40689c8395b1aa08$export$8e5a1d3f85a9688 = v; });
var $40689c8395b1aa08$export$8e5a1d3f85a9688;
"use strict";
$40689c8395b1aa08$export$8e5a1d3f85a9688 = void 0;

var $3YLlM = parcelRequire("3YLlM");
class $40689c8395b1aa08$var$EraParser extends $3YLlM.Parser {
    priority = 140;
    parse(dateString, token, match) {
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
            // A, B
            case "GGGGG":
                return match.era(dateString, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return match.era(dateString, {
                    width: "wide"
                }) || match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
        }
    }
    set(date, flags, value) {
        flags.era = value;
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "R",
        "u",
        "t",
        "T"
    ];
}
$40689c8395b1aa08$export$8e5a1d3f85a9688 = $40689c8395b1aa08$var$EraParser;

});
parcelRegister("3YLlM", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $2e5bb47eb197b944$export$7acfa6ed01010e37; }, function (v) { return $2e5bb47eb197b944$export$7acfa6ed01010e37 = v; });
var $2e5bb47eb197b944$export$7acfa6ed01010e37;
"use strict";
$2e5bb47eb197b944$export$7acfa6ed01010e37 = void 0;

var $emYk0 = parcelRequire("emYk0");
class $2e5bb47eb197b944$var$Parser {
    run(dateString, token, match, options) {
        const result = this.parse(dateString, token, match, options);
        if (!result) return null;
        return {
            setter: new $emYk0.ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
            rest: result.rest
        };
    }
    validate(_utcDate, _value, _options) {
        return true;
    }
}
$2e5bb47eb197b944$export$7acfa6ed01010e37 = $2e5bb47eb197b944$var$Parser;

});
parcelRegister("emYk0", function(module, exports) {

$parcel$export(module.exports, "ValueSetter", function () { return $a761e95e89406793$export$9a09e32dd4990fd5; }, function (v) { return $a761e95e89406793$export$9a09e32dd4990fd5 = v; });
$parcel$export(module.exports, "DateToSystemTimezoneSetter", function () { return $a761e95e89406793$export$5aaf7ff7f09ea4ee; }, function (v) { return $a761e95e89406793$export$5aaf7ff7f09ea4ee = v; });
var $a761e95e89406793$export$9a09e32dd4990fd5;
var $a761e95e89406793$export$81d53e3678089a6;
var $a761e95e89406793$export$5aaf7ff7f09ea4ee;
"use strict";
$a761e95e89406793$export$9a09e32dd4990fd5 = $a761e95e89406793$export$81d53e3678089a6 = $a761e95e89406793$export$5aaf7ff7f09ea4ee = void 0;

var $lUiMa = parcelRequire("lUiMa");

var $909bC = parcelRequire("909bC");
const $a761e95e89406793$var$TIMEZONE_UNIT_PRIORITY = 10;
class $a761e95e89406793$var$Setter {
    subPriority = 0;
    validate(_utcDate, _options) {
        return true;
    }
}
$a761e95e89406793$export$81d53e3678089a6 = $a761e95e89406793$var$Setter;
class $a761e95e89406793$var$ValueSetter extends $a761e95e89406793$var$Setter {
    constructor(value, validateValue, setValue, priority, subPriority){
        super();
        this.value = value;
        this.validateValue = validateValue;
        this.setValue = setValue;
        this.priority = priority;
        if (subPriority) this.subPriority = subPriority;
    }
    validate(date, options) {
        return this.validateValue(date, this.value, options);
    }
    set(date, flags, options) {
        return this.setValue(date, flags, this.value, options);
    }
}
$a761e95e89406793$export$9a09e32dd4990fd5 = $a761e95e89406793$var$ValueSetter;
class $a761e95e89406793$var$DateToSystemTimezoneSetter extends $a761e95e89406793$var$Setter {
    priority = $a761e95e89406793$var$TIMEZONE_UNIT_PRIORITY;
    subPriority = -1;
    set(date, flags) {
        if (flags.timestampIsSet) return date;
        return (0, $909bC.constructFrom)(date, (0, $lUiMa.transpose)(date, Date));
    }
}
$a761e95e89406793$export$5aaf7ff7f09ea4ee = $a761e95e89406793$var$DateToSystemTimezoneSetter;

});
parcelRegister("lUiMa", function(module, exports) {

$parcel$export(module.exports, "transpose", function () { return $ff2d646d46f474b3$export$9cb09a71b7d66923; }, function (v) { return $ff2d646d46f474b3$export$9cb09a71b7d66923 = v; });
var $ff2d646d46f474b3$export$9cb09a71b7d66923;
"use strict";
$ff2d646d46f474b3$export$9cb09a71b7d66923 = $ff2d646d46f474b3$var$transpose;

var $909bC = parcelRequire("909bC");
/**
 * @name transpose
 * @category Generic Helpers
 * @summary Transpose the date to the given constructor.
 *
 * @description
 * The function transposes the date to the given constructor. It helps you
 * to transpose the date in the system time zone to say `UTCDate` or any other
 * date extension.
 *
 * @typeParam DateInputType - The input `Date` type derived from the passed argument.
 * @typeParam DateOutputType - The output `Date` type derived from the passed constructor.
 *
 * @param fromDate - The date to use values from
 * @param constructor - The date constructor to use
 *
 * @returns Date transposed to the given constructor
 *
 * @example
 * // Create July 10, 2022 00:00 in locale time zone
 * const date = new Date(2022, 6, 10)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0800 (Singapore Standard Time)'
 *
 * @example
 * // Transpose the date to July 10, 2022 00:00 in UTC
 * transpose(date, UTCDate)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0000 (Coordinated Universal Time)'
 */ function $ff2d646d46f474b3$var$transpose(fromDate, constructor) {
    const date = constructor instanceof Date ? (0, $909bC.constructFrom)(constructor, 0) : new constructor(0);
    date.setFullYear(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
    date.setHours(fromDate.getHours(), fromDate.getMinutes(), fromDate.getSeconds(), fromDate.getMilliseconds());
    return date;
}

});




parcelRegister("9NVpd", function(module, exports) {

$parcel$export(module.exports, "YearParser", function () { return $7235384096bcdec5$export$48d352de7cd4a988; }, function (v) { return $7235384096bcdec5$export$48d352de7cd4a988 = v; });
var $7235384096bcdec5$export$48d352de7cd4a988;
"use strict";
$7235384096bcdec5$export$48d352de7cd4a988 = void 0;

var $3YLlM = parcelRequire("3YLlM");

var $96NIh = parcelRequire("96NIh");
// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
// |----------|-------|----|-------|-------|-------|
// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
class $7235384096bcdec5$var$YearParser extends $3YLlM.Parser {
    priority = 130;
    incompatibleTokens = [
        "Y",
        "R",
        "u",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "yy"
            });
        switch(token){
            case "y":
                return (0, $96NIh.mapValue)((0, $96NIh.parseNDigits)(4, dateString), valueCallback);
            case "yo":
                return (0, $96NIh.mapValue)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $96NIh.mapValue)((0, $96NIh.parseNDigits)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value) {
        const currentYear = date.getFullYear();
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $96NIh.normalizeTwoDigitYear)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, 1);
            date.setHours(0, 0, 0, 0);
            return date;
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}
$7235384096bcdec5$export$48d352de7cd4a988 = $7235384096bcdec5$var$YearParser;

});
parcelRegister("96NIh", function(module, exports) {

$parcel$export(module.exports, "dayPeriodEnumToHours", function () { return $6a1b3c9c3debeb1f$export$fb506d2676e7f207; }, function (v) { return $6a1b3c9c3debeb1f$export$fb506d2676e7f207 = v; });
$parcel$export(module.exports, "isLeapYearIndex", function () { return $6a1b3c9c3debeb1f$export$3d50627710b84d75; }, function (v) { return $6a1b3c9c3debeb1f$export$3d50627710b84d75 = v; });
$parcel$export(module.exports, "mapValue", function () { return $6a1b3c9c3debeb1f$export$4f84e3a82c7b538; }, function (v) { return $6a1b3c9c3debeb1f$export$4f84e3a82c7b538 = v; });
$parcel$export(module.exports, "normalizeTwoDigitYear", function () { return $6a1b3c9c3debeb1f$export$29126f735cbf69f7; }, function (v) { return $6a1b3c9c3debeb1f$export$29126f735cbf69f7 = v; });
$parcel$export(module.exports, "parseAnyDigitsSigned", function () { return $6a1b3c9c3debeb1f$export$d931c43c4608a164; }, function (v) { return $6a1b3c9c3debeb1f$export$d931c43c4608a164 = v; });
$parcel$export(module.exports, "parseNDigits", function () { return $6a1b3c9c3debeb1f$export$513bb01536146ab6; }, function (v) { return $6a1b3c9c3debeb1f$export$513bb01536146ab6 = v; });
$parcel$export(module.exports, "parseNDigitsSigned", function () { return $6a1b3c9c3debeb1f$export$2c9307b2e29c533c; }, function (v) { return $6a1b3c9c3debeb1f$export$2c9307b2e29c533c = v; });
$parcel$export(module.exports, "parseNumericPattern", function () { return $6a1b3c9c3debeb1f$export$cc7cc9e2a3ff9388; }, function (v) { return $6a1b3c9c3debeb1f$export$cc7cc9e2a3ff9388 = v; });
$parcel$export(module.exports, "parseTimezonePattern", function () { return $6a1b3c9c3debeb1f$export$6497f4c0ecdfba8e; }, function (v) { return $6a1b3c9c3debeb1f$export$6497f4c0ecdfba8e = v; });
var $6a1b3c9c3debeb1f$export$fb506d2676e7f207;
var $6a1b3c9c3debeb1f$export$3d50627710b84d75;
var $6a1b3c9c3debeb1f$export$4f84e3a82c7b538;
var $6a1b3c9c3debeb1f$export$29126f735cbf69f7;
var $6a1b3c9c3debeb1f$export$d931c43c4608a164;
var $6a1b3c9c3debeb1f$export$513bb01536146ab6;
var $6a1b3c9c3debeb1f$export$2c9307b2e29c533c;
var $6a1b3c9c3debeb1f$export$cc7cc9e2a3ff9388;
var $6a1b3c9c3debeb1f$export$6497f4c0ecdfba8e;
"use strict";
$6a1b3c9c3debeb1f$export$fb506d2676e7f207 = $6a1b3c9c3debeb1f$var$dayPeriodEnumToHours;
$6a1b3c9c3debeb1f$export$3d50627710b84d75 = $6a1b3c9c3debeb1f$var$isLeapYearIndex;
$6a1b3c9c3debeb1f$export$4f84e3a82c7b538 = $6a1b3c9c3debeb1f$var$mapValue;
$6a1b3c9c3debeb1f$export$29126f735cbf69f7 = $6a1b3c9c3debeb1f$var$normalizeTwoDigitYear;
$6a1b3c9c3debeb1f$export$d931c43c4608a164 = $6a1b3c9c3debeb1f$var$parseAnyDigitsSigned;
$6a1b3c9c3debeb1f$export$513bb01536146ab6 = $6a1b3c9c3debeb1f$var$parseNDigits;
$6a1b3c9c3debeb1f$export$2c9307b2e29c533c = $6a1b3c9c3debeb1f$var$parseNDigitsSigned;
$6a1b3c9c3debeb1f$export$cc7cc9e2a3ff9388 = $6a1b3c9c3debeb1f$var$parseNumericPattern;
$6a1b3c9c3debeb1f$export$6497f4c0ecdfba8e = $6a1b3c9c3debeb1f$var$parseTimezonePattern;

var $lILKk = parcelRequire("lILKk");

var $EodCH = parcelRequire("EodCH");
function $6a1b3c9c3debeb1f$var$mapValue(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $6a1b3c9c3debeb1f$var$parseNumericPattern(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $6a1b3c9c3debeb1f$var$parseTimezonePattern(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    const sign = matchResult[1] === "+" ? 1 : -1;
    const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * $lILKk.millisecondsInHour + minutes * $lILKk.millisecondsInMinute + seconds * $lILKk.millisecondsInSecond),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $6a1b3c9c3debeb1f$var$parseAnyDigitsSigned(dateString) {
    return $6a1b3c9c3debeb1f$var$parseNumericPattern($EodCH.numericPatterns.anyDigitsSigned, dateString);
}
function $6a1b3c9c3debeb1f$var$parseNDigits(n, dateString) {
    switch(n){
        case 1:
            return $6a1b3c9c3debeb1f$var$parseNumericPattern($EodCH.numericPatterns.singleDigit, dateString);
        case 2:
            return $6a1b3c9c3debeb1f$var$parseNumericPattern($EodCH.numericPatterns.twoDigits, dateString);
        case 3:
            return $6a1b3c9c3debeb1f$var$parseNumericPattern($EodCH.numericPatterns.threeDigits, dateString);
        case 4:
            return $6a1b3c9c3debeb1f$var$parseNumericPattern($EodCH.numericPatterns.fourDigits, dateString);
        default:
            return $6a1b3c9c3debeb1f$var$parseNumericPattern(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $6a1b3c9c3debeb1f$var$parseNDigitsSigned(n, dateString) {
    switch(n){
        case 1:
            return $6a1b3c9c3debeb1f$var$parseNumericPattern($EodCH.numericPatterns.singleDigitSigned, dateString);
        case 2:
            return $6a1b3c9c3debeb1f$var$parseNumericPattern($EodCH.numericPatterns.twoDigitsSigned, dateString);
        case 3:
            return $6a1b3c9c3debeb1f$var$parseNumericPattern($EodCH.numericPatterns.threeDigitsSigned, dateString);
        case 4:
            return $6a1b3c9c3debeb1f$var$parseNumericPattern($EodCH.numericPatterns.fourDigitsSigned, dateString);
        default:
            return $6a1b3c9c3debeb1f$var$parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $6a1b3c9c3debeb1f$var$dayPeriodEnumToHours(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $6a1b3c9c3debeb1f$var$normalizeTwoDigitYear(twoDigitYear, currentYear) {
    const isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    let result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        const rangeEnd = absCurrentYear + 50;
        const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
        const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $6a1b3c9c3debeb1f$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

});
parcelRegister("EodCH", function(module, exports) {

$parcel$export(module.exports, "timezonePatterns", function () { return $079685e073db8b8d$export$a7ee192b982af9c1; }, function (v) { return $079685e073db8b8d$export$a7ee192b982af9c1 = v; });
$parcel$export(module.exports, "numericPatterns", function () { return $079685e073db8b8d$export$c123ee06d9da8480; }, function (v) { return $079685e073db8b8d$export$c123ee06d9da8480 = v; });
var $079685e073db8b8d$export$a7ee192b982af9c1;
var $079685e073db8b8d$export$c123ee06d9da8480;
"use strict";
$079685e073db8b8d$export$a7ee192b982af9c1 = $079685e073db8b8d$export$c123ee06d9da8480 = void 0;
const $079685e073db8b8d$var$numericPatterns = $079685e073db8b8d$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    date: /^(3[0-1]|[0-2]?\d)/,
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    week: /^(5[0-3]|[0-4]?\d)/,
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    hour11h: /^(1[0-1]|0?\d)/,
    hour12h: /^(1[0-2]|0?\d)/,
    minute: /^[0-5]?\d/,
    second: /^[0-5]?\d/,
    singleDigit: /^\d/,
    twoDigits: /^\d{1,2}/,
    threeDigits: /^\d{1,3}/,
    fourDigits: /^\d{1,4}/,
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    twoDigitsSigned: /^-?\d{1,2}/,
    threeDigitsSigned: /^-?\d{1,3}/,
    fourDigitsSigned: /^-?\d{1,4}/
};
const $079685e073db8b8d$var$timezonePatterns = $079685e073db8b8d$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

});



parcelRegister("aK1bs", function(module, exports) {

$parcel$export(module.exports, "LocalWeekYearParser", function () { return $7d1f1e503d534351$export$b8ef38dfcf05d5db; }, function (v) { return $7d1f1e503d534351$export$b8ef38dfcf05d5db = v; });
var $7d1f1e503d534351$export$b8ef38dfcf05d5db;
"use strict";
$7d1f1e503d534351$export$b8ef38dfcf05d5db = void 0;

var $bIuXj = parcelRequire("bIuXj");

var $79XR6 = parcelRequire("79XR6");

var $3YLlM = parcelRequire("3YLlM");

var $96NIh = parcelRequire("96NIh");
// Local week-numbering year
class $7d1f1e503d534351$var$LocalWeekYearParser extends $3YLlM.Parser {
    priority = 130;
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "YY"
            });
        switch(token){
            case "Y":
                return (0, $96NIh.mapValue)((0, $96NIh.parseNDigits)(4, dateString), valueCallback);
            case "Yo":
                return (0, $96NIh.mapValue)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $96NIh.mapValue)((0, $96NIh.parseNDigits)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value, options) {
        const currentYear = (0, $bIuXj.getWeekYear)(date, options);
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $96NIh.normalizeTwoDigitYear)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
            date.setHours(0, 0, 0, 0);
            return (0, $79XR6.startOfWeek)(date, options);
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, options.firstWeekContainsDate);
        date.setHours(0, 0, 0, 0);
        return (0, $79XR6.startOfWeek)(date, options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}
$7d1f1e503d534351$export$b8ef38dfcf05d5db = $7d1f1e503d534351$var$LocalWeekYearParser;

});

parcelRegister("3OIve", function(module, exports) {

$parcel$export(module.exports, "ISOWeekYearParser", function () { return $2c788fec2ea2f194$export$951d1df011fde06f; }, function (v) { return $2c788fec2ea2f194$export$951d1df011fde06f = v; });
var $2c788fec2ea2f194$export$951d1df011fde06f;
"use strict";
$2c788fec2ea2f194$export$951d1df011fde06f = void 0;

var $01IXW = parcelRequire("01IXW");

var $909bC = parcelRequire("909bC");

var $3YLlM = parcelRequire("3YLlM");

var $96NIh = parcelRequire("96NIh");
// ISO week-numbering year
class $2c788fec2ea2f194$var$ISOWeekYearParser extends $3YLlM.Parser {
    priority = 130;
    parse(dateString, token) {
        if (token === "R") return (0, $96NIh.parseNDigitsSigned)(4, dateString);
        return (0, $96NIh.parseNDigitsSigned)(token.length, dateString);
    }
    set(date, _flags, value) {
        const firstWeekOfYear = (0, $909bC.constructFrom)(date, 0);
        firstWeekOfYear.setFullYear(value, 0, 4);
        firstWeekOfYear.setHours(0, 0, 0, 0);
        return (0, $01IXW.startOfISOWeek)(firstWeekOfYear);
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}
$2c788fec2ea2f194$export$951d1df011fde06f = $2c788fec2ea2f194$var$ISOWeekYearParser;

});

parcelRegister("eOD1U", function(module, exports) {

$parcel$export(module.exports, "ExtendedYearParser", function () { return $ac9402b1dce556e9$export$bad9d2ea38e8f1a; }, function (v) { return $ac9402b1dce556e9$export$bad9d2ea38e8f1a = v; });
var $ac9402b1dce556e9$export$bad9d2ea38e8f1a;
"use strict";
$ac9402b1dce556e9$export$bad9d2ea38e8f1a = void 0;

var $3YLlM = parcelRequire("3YLlM");

var $96NIh = parcelRequire("96NIh");
class $ac9402b1dce556e9$var$ExtendedYearParser extends $3YLlM.Parser {
    priority = 130;
    parse(dateString, token) {
        if (token === "u") return (0, $96NIh.parseNDigitsSigned)(4, dateString);
        return (0, $96NIh.parseNDigitsSigned)(token.length, dateString);
    }
    set(date, _flags, value) {
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "R",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$ac9402b1dce556e9$export$bad9d2ea38e8f1a = $ac9402b1dce556e9$var$ExtendedYearParser;

});

parcelRegister("koOnw", function(module, exports) {

$parcel$export(module.exports, "QuarterParser", function () { return $ed9d20a11539188d$export$5cb0f701186dde1d; }, function (v) { return $ed9d20a11539188d$export$5cb0f701186dde1d = v; });
var $ed9d20a11539188d$export$5cb0f701186dde1d;
"use strict";
$ed9d20a11539188d$export$5cb0f701186dde1d = void 0;

var $3YLlM = parcelRequire("3YLlM");

var $96NIh = parcelRequire("96NIh");
class $ed9d20a11539188d$var$QuarterParser extends $3YLlM.Parser {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "Q":
            case "QQ":
                return (0, $96NIh.parseNDigits)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$ed9d20a11539188d$export$5cb0f701186dde1d = $ed9d20a11539188d$var$QuarterParser;

});

parcelRegister("cEEJp", function(module, exports) {

$parcel$export(module.exports, "StandAloneQuarterParser", function () { return $9368d0e5a56d9d79$export$300c0c2990e20e6d; }, function (v) { return $9368d0e5a56d9d79$export$300c0c2990e20e6d = v; });
var $9368d0e5a56d9d79$export$300c0c2990e20e6d;
"use strict";
$9368d0e5a56d9d79$export$300c0c2990e20e6d = void 0;

var $3YLlM = parcelRequire("3YLlM");

var $96NIh = parcelRequire("96NIh");
class $9368d0e5a56d9d79$var$StandAloneQuarterParser extends $3YLlM.Parser {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "q":
            case "qq":
                return (0, $96NIh.parseNDigits)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$9368d0e5a56d9d79$export$300c0c2990e20e6d = $9368d0e5a56d9d79$var$StandAloneQuarterParser;

});

parcelRegister("kCb6y", function(module, exports) {

$parcel$export(module.exports, "MonthParser", function () { return $f01ff86f3b02631c$export$400dd8b40ef138a3; }, function (v) { return $f01ff86f3b02631c$export$400dd8b40ef138a3 = v; });
var $f01ff86f3b02631c$export$400dd8b40ef138a3;
"use strict";
$f01ff86f3b02631c$export$400dd8b40ef138a3 = void 0;

var $EodCH = parcelRequire("EodCH");

var $3YLlM = parcelRequire("3YLlM");

var $96NIh = parcelRequire("96NIh");
class $f01ff86f3b02631c$var$MonthParser extends $3YLlM.Parser {
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "L",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "M":
                return (0, $96NIh.mapValue)((0, $96NIh.parseNumericPattern)($EodCH.numericPatterns.month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "MM":
                return (0, $96NIh.mapValue)((0, $96NIh.parseNDigits)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return (0, $96NIh.mapValue)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "MMM":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}
$f01ff86f3b02631c$export$400dd8b40ef138a3 = $f01ff86f3b02631c$var$MonthParser;

});

parcelRegister("eclaJ", function(module, exports) {

$parcel$export(module.exports, "StandAloneMonthParser", function () { return $a5629bfe5dcc314c$export$1d7eaa53eaa5deba; }, function (v) { return $a5629bfe5dcc314c$export$1d7eaa53eaa5deba = v; });
var $a5629bfe5dcc314c$export$1d7eaa53eaa5deba;
"use strict";
$a5629bfe5dcc314c$export$1d7eaa53eaa5deba = void 0;

var $EodCH = parcelRequire("EodCH");

var $3YLlM = parcelRequire("3YLlM");

var $96NIh = parcelRequire("96NIh");
class $a5629bfe5dcc314c$var$StandAloneMonthParser extends $3YLlM.Parser {
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return (0, $96NIh.mapValue)((0, $96NIh.parseNumericPattern)($EodCH.numericPatterns.month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "LL":
                return (0, $96NIh.mapValue)((0, $96NIh.parseNDigits)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return (0, $96NIh.mapValue)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "LLL":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$a5629bfe5dcc314c$export$1d7eaa53eaa5deba = $a5629bfe5dcc314c$var$StandAloneMonthParser;

});

parcelRegister("gQcTP", function(module, exports) {

$parcel$export(module.exports, "LocalWeekParser", function () { return $c42b82375d24cb44$export$c4005ffc174e07c0; }, function (v) { return $c42b82375d24cb44$export$c4005ffc174e07c0 = v; });
var $c42b82375d24cb44$export$c4005ffc174e07c0;
"use strict";
$c42b82375d24cb44$export$c4005ffc174e07c0 = void 0;

var $5sOYC = parcelRequire("5sOYC");

var $79XR6 = parcelRequire("79XR6");

var $EodCH = parcelRequire("EodCH");

var $3YLlM = parcelRequire("3YLlM");

var $96NIh = parcelRequire("96NIh");
// Local week of year
class $c42b82375d24cb44$var$LocalWeekParser extends $3YLlM.Parser {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "w":
                return (0, $96NIh.parseNumericPattern)($EodCH.numericPatterns.week, dateString);
            case "wo":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $96NIh.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value, options) {
        return (0, $79XR6.startOfWeek)((0, $5sOYC.setWeek)(date, value, options), options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}
$c42b82375d24cb44$export$c4005ffc174e07c0 = $c42b82375d24cb44$var$LocalWeekParser;

});
parcelRegister("5sOYC", function(module, exports) {

$parcel$export(module.exports, "setWeek", function () { return $3fa71c322df26604$export$4b3066ce4afafd88; }, function (v) { return $3fa71c322df26604$export$4b3066ce4afafd88 = v; });
var $3fa71c322df26604$export$4b3066ce4afafd88;
"use strict";
$3fa71c322df26604$export$4b3066ce4afafd88 = $3fa71c322df26604$var$setWeek;

var $5SW4K = parcelRequire("5SW4K");

var $eimnm = parcelRequire("eimnm");
/**
 * The {@link setWeek} function options.
 */ /**
 * @name setWeek
 * @category Week Helpers
 * @summary Set the local week to the given date.
 *
 * @description
 * Set the local week to the given date, saving the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The week of the new date
 * @param options - An object with options
 *
 * @returns The new date with the local week set
 *
 * @example
 * // Set the 1st week to 2 January 2005 with default options:
 * const result = setWeek(new Date(2005, 0, 2), 1)
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // Set the 1st week to 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January:
 * const result = setWeek(new Date(2005, 0, 2), 1, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sun Jan 4 2004 00:00:00
 */ function $3fa71c322df26604$var$setWeek(date, week, options) {
    const _date = (0, $eimnm.toDate)(date);
    const diff = (0, $5SW4K.getWeek)(_date, options) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}

});


parcelRegister("1fPqk", function(module, exports) {

$parcel$export(module.exports, "ISOWeekParser", function () { return $0e9f14cfda12baec$export$6fc8dbedd560a6af; }, function (v) { return $0e9f14cfda12baec$export$6fc8dbedd560a6af = v; });
var $0e9f14cfda12baec$export$6fc8dbedd560a6af;
"use strict";
$0e9f14cfda12baec$export$6fc8dbedd560a6af = void 0;

var $hRDyc = parcelRequire("hRDyc");

var $01IXW = parcelRequire("01IXW");

var $EodCH = parcelRequire("EodCH");

var $3YLlM = parcelRequire("3YLlM");

var $96NIh = parcelRequire("96NIh");
// ISO week of year
class $0e9f14cfda12baec$var$ISOWeekParser extends $3YLlM.Parser {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "I":
                return (0, $96NIh.parseNumericPattern)($EodCH.numericPatterns.week, dateString);
            case "Io":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $96NIh.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value) {
        return (0, $01IXW.startOfISOWeek)((0, $hRDyc.setISOWeek)(date, value));
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}
$0e9f14cfda12baec$export$6fc8dbedd560a6af = $0e9f14cfda12baec$var$ISOWeekParser;

});
parcelRegister("hRDyc", function(module, exports) {

$parcel$export(module.exports, "setISOWeek", function () { return $d01610d32cf4f4fa$export$6542bebf6be94082; }, function (v) { return $d01610d32cf4f4fa$export$6542bebf6be94082 = v; });
var $d01610d32cf4f4fa$export$6542bebf6be94082;
"use strict";
$d01610d32cf4f4fa$export$6542bebf6be94082 = $d01610d32cf4f4fa$var$setISOWeek;

var $cuHcL = parcelRequire("cuHcL");

var $eimnm = parcelRequire("eimnm");
/**
 * @name setISOWeek
 * @category ISO Week Helpers
 * @summary Set the ISO week to the given date.
 *
 * @description
 * Set the ISO week to the given date, saving the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The ISO week of the new date
 *
 * @returns The new date with the ISO week set
 *
 * @example
 * // Set the 53rd ISO week to 7 August 2004:
 * const result = setISOWeek(new Date(2004, 7, 7), 53)
 * //=> Sat Jan 01 2005 00:00:00
 */ function $d01610d32cf4f4fa$var$setISOWeek(date, week) {
    const _date = (0, $eimnm.toDate)(date);
    const diff = (0, $cuHcL.getISOWeek)(_date) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}

});


parcelRegister("lLlbK", function(module, exports) {

$parcel$export(module.exports, "DateParser", function () { return $fd7e6c571a9f2e41$export$e8d4b28a20981dd2; }, function (v) { return $fd7e6c571a9f2e41$export$e8d4b28a20981dd2 = v; });
var $fd7e6c571a9f2e41$export$e8d4b28a20981dd2;
"use strict";
$fd7e6c571a9f2e41$export$e8d4b28a20981dd2 = void 0;

var $EodCH = parcelRequire("EodCH");

var $3YLlM = parcelRequire("3YLlM");

var $96NIh = parcelRequire("96NIh");
const $fd7e6c571a9f2e41$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $fd7e6c571a9f2e41$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
// Day of the month
class $fd7e6c571a9f2e41$var$DateParser extends $3YLlM.Parser {
    priority = 90;
    subPriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "d":
                return (0, $96NIh.parseNumericPattern)($EodCH.numericPatterns.date, dateString);
            case "do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $96NIh.parseNDigits)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $96NIh.isLeapYearIndex)(year);
        const month = date.getMonth();
        if (isLeapYear) return value >= 1 && value <= $fd7e6c571a9f2e41$var$DAYS_IN_MONTH_LEAP_YEAR[month];
        else return value >= 1 && value <= $fd7e6c571a9f2e41$var$DAYS_IN_MONTH[month];
    }
    set(date, _flags, value) {
        date.setDate(value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$fd7e6c571a9f2e41$export$e8d4b28a20981dd2 = $fd7e6c571a9f2e41$var$DateParser;

});

parcelRegister("bvvkX", function(module, exports) {

$parcel$export(module.exports, "DayOfYearParser", function () { return $860ae5dd9e5902e5$export$6cfe0d613455f615; }, function (v) { return $860ae5dd9e5902e5$export$6cfe0d613455f615 = v; });
var $860ae5dd9e5902e5$export$6cfe0d613455f615;
"use strict";
$860ae5dd9e5902e5$export$6cfe0d613455f615 = void 0;

var $EodCH = parcelRequire("EodCH");

var $3YLlM = parcelRequire("3YLlM");

var $96NIh = parcelRequire("96NIh");
class $860ae5dd9e5902e5$var$DayOfYearParser extends $3YLlM.Parser {
    priority = 90;
    subpriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "D":
            case "DD":
                return (0, $96NIh.parseNumericPattern)($EodCH.numericPatterns.dayOfYear, dateString);
            case "Do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $96NIh.parseNDigits)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $96NIh.isLeapYearIndex)(year);
        if (isLeapYear) return value >= 1 && value <= 366;
        else return value >= 1 && value <= 365;
    }
    set(date, _flags, value) {
        date.setMonth(0, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "E",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$860ae5dd9e5902e5$export$6cfe0d613455f615 = $860ae5dd9e5902e5$var$DayOfYearParser;

});

parcelRegister("fOQp1", function(module, exports) {

$parcel$export(module.exports, "DayParser", function () { return $b8442c9b33a27c3f$export$1b03c8b76262f7bd; }, function (v) { return $b8442c9b33a27c3f$export$1b03c8b76262f7bd = v; });
var $b8442c9b33a27c3f$export$1b03c8b76262f7bd;
"use strict";
$b8442c9b33a27c3f$export$1b03c8b76262f7bd = void 0;

var $9EUl3 = parcelRequire("9EUl3");

var $3YLlM = parcelRequire("3YLlM");
// Day of week
class $b8442c9b33a27c3f$var$DayParser extends $3YLlM.Parser {
    priority = 90;
    parse(dateString, token, match) {
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $9EUl3.setDay)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$b8442c9b33a27c3f$export$1b03c8b76262f7bd = $b8442c9b33a27c3f$var$DayParser;

});
parcelRegister("9EUl3", function(module, exports) {

$parcel$export(module.exports, "setDay", function () { return $70838d2882074aab$export$b04fdcda82decc6c; }, function (v) { return $70838d2882074aab$export$b04fdcda82decc6c = v; });
var $70838d2882074aab$export$b04fdcda82decc6c;
"use strict";
$70838d2882074aab$export$b04fdcda82decc6c = $70838d2882074aab$var$setDay;

var $qX1g7 = parcelRequire("qX1g7");

var $eimnm = parcelRequire("eimnm");

var $hIOa6 = parcelRequire("hIOa6");
/**
 * The {@link setDay} function options.
 */ /**
 * @name setDay
 * @category Weekday Helpers
 * @summary Set the day of the week to the given date.
 *
 * @description
 * Set the day of the week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the week of the new date
 * @param options - An object with options.
 *
 * @returns The new date with the day of the week set
 *
 * @example
 * // Set week day to Sunday, with the default weekStartsOn of Sunday:
 * const result = setDay(new Date(2014, 8, 1), 0)
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Set week day to Sunday, with a weekStartsOn of Monday:
 * const result = setDay(new Date(2014, 8, 1), 0, { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */ function $70838d2882074aab$var$setDay(date, day, options) {
    const defaultOptions = (0, $hIOa6.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $eimnm.toDate)(date);
    const currentDay = _date.getDay();
    const remainder = day % 7;
    const dayIndex = (remainder + 7) % 7;
    const delta = 7 - weekStartsOn;
    const diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
    return (0, $qX1g7.addDays)(_date, diff);
}

});


parcelRegister("ear8U", function(module, exports) {

$parcel$export(module.exports, "LocalDayParser", function () { return $a5070dd1fbd169b2$export$44d1c127ab42c480; }, function (v) { return $a5070dd1fbd169b2$export$44d1c127ab42c480 = v; });
var $a5070dd1fbd169b2$export$44d1c127ab42c480;
"use strict";
$a5070dd1fbd169b2$export$44d1c127ab42c480 = void 0;

var $9EUl3 = parcelRequire("9EUl3");

var $3YLlM = parcelRequire("3YLlM");

var $96NIh = parcelRequire("96NIh");
// Local day of week
class $a5070dd1fbd169b2$var$LocalDayParser extends $3YLlM.Parser {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "e":
            case "ee":
                return (0, $96NIh.mapValue)((0, $96NIh.parseNDigits)(token.length, dateString), valueCallback);
            // 3rd
            case "eo":
                return (0, $96NIh.mapValue)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "eee":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $9EUl3.setDay)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "c",
        "t",
        "T"
    ];
}
$a5070dd1fbd169b2$export$44d1c127ab42c480 = $a5070dd1fbd169b2$var$LocalDayParser;

});

parcelRegister("gSu4U", function(module, exports) {

$parcel$export(module.exports, "StandAloneLocalDayParser", function () { return $c49905662691d673$export$e447a647caaaec1d; }, function (v) { return $c49905662691d673$export$e447a647caaaec1d = v; });
var $c49905662691d673$export$e447a647caaaec1d;
"use strict";
$c49905662691d673$export$e447a647caaaec1d = void 0;

var $9EUl3 = parcelRequire("9EUl3");

var $3YLlM = parcelRequire("3YLlM");

var $96NIh = parcelRequire("96NIh");
// Stand-alone local day of week
class $c49905662691d673$var$StandAloneLocalDayParser extends $3YLlM.Parser {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "c":
            case "cc":
                return (0, $96NIh.mapValue)((0, $96NIh.parseNDigits)(token.length, dateString), valueCallback);
            // 3rd
            case "co":
                return (0, $96NIh.mapValue)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "ccc":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $9EUl3.setDay)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "e",
        "t",
        "T"
    ];
}
$c49905662691d673$export$e447a647caaaec1d = $c49905662691d673$var$StandAloneLocalDayParser;

});

parcelRegister("j1Hqr", function(module, exports) {

$parcel$export(module.exports, "ISODayParser", function () { return $dd9fcbb732974b27$export$693fb1e525095b2a; }, function (v) { return $dd9fcbb732974b27$export$693fb1e525095b2a = v; });
var $dd9fcbb732974b27$export$693fb1e525095b2a;
"use strict";
$dd9fcbb732974b27$export$693fb1e525095b2a = void 0;

var $k8ViH = parcelRequire("k8ViH");

var $3YLlM = parcelRequire("3YLlM");

var $96NIh = parcelRequire("96NIh");
// ISO day of week
class $dd9fcbb732974b27$var$ISODayParser extends $3YLlM.Parser {
    priority = 90;
    parse(dateString, token, match) {
        const valueCallback = (value)=>{
            if (value === 0) return 7;
            return value;
        };
        switch(token){
            // 2
            case "i":
            case "ii":
                return (0, $96NIh.parseNDigits)(token.length, dateString);
            // 2nd
            case "io":
                return match.ordinalNumber(dateString, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return (0, $96NIh.mapValue)(match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // T
            case "iiiii":
                return (0, $96NIh.mapValue)(match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tu
            case "iiiiii":
                return (0, $96NIh.mapValue)(match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tuesday
            case "iiii":
            default:
                return (0, $96NIh.mapValue)(match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 7;
    }
    set(date, _flags, value) {
        date = (0, $k8ViH.setISODay)(date, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "E",
        "e",
        "c",
        "t",
        "T"
    ];
}
$dd9fcbb732974b27$export$693fb1e525095b2a = $dd9fcbb732974b27$var$ISODayParser;

});
parcelRegister("k8ViH", function(module, exports) {

$parcel$export(module.exports, "setISODay", function () { return $eaa100af12df7bee$export$1fd9df65adb0d1aa; }, function (v) { return $eaa100af12df7bee$export$1fd9df65adb0d1aa = v; });
var $eaa100af12df7bee$export$1fd9df65adb0d1aa;
"use strict";
$eaa100af12df7bee$export$1fd9df65adb0d1aa = $eaa100af12df7bee$var$setISODay;

var $qX1g7 = parcelRequire("qX1g7");

var $eE1JP = parcelRequire("eE1JP");

var $eimnm = parcelRequire("eimnm");
/**
 * @name setISODay
 * @category Weekday Helpers
 * @summary Set the day of the ISO week to the given date.
 *
 * @description
 * Set the day of the ISO week to the given date.
 * ISO week starts with Monday.
 * 7 is the index of Sunday, 1 is the index of Monday etc.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the ISO week of the new date
 *
 * @returns The new date with the day of the ISO week set
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * const result = setISODay(new Date(2014, 8, 1), 7)
 * //=> Sun Sep 07 2014 00:00:00
 */ function $eaa100af12df7bee$var$setISODay(date, day) {
    const _date = (0, $eimnm.toDate)(date);
    const currentDay = (0, $eE1JP.getISODay)(_date);
    const diff = day - currentDay;
    return (0, $qX1g7.addDays)(_date, diff);
}

});


parcelRegister("ab3Ac", function(module, exports) {

$parcel$export(module.exports, "AMPMParser", function () { return $768db5ee472943c4$export$8d1e08492351df91; }, function (v) { return $768db5ee472943c4$export$8d1e08492351df91 = v; });
var $768db5ee472943c4$export$8d1e08492351df91;
"use strict";
$768db5ee472943c4$export$8d1e08492351df91 = void 0;

var $3YLlM = parcelRequire("3YLlM");

var $96NIh = parcelRequire("96NIh");
class $768db5ee472943c4$var$AMPMParser extends $3YLlM.Parser {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "a":
            case "aa":
            case "aaa":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaaa":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $96NIh.dayPeriodEnumToHours)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "b",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}
$768db5ee472943c4$export$8d1e08492351df91 = $768db5ee472943c4$var$AMPMParser;

});

parcelRegister("jPBDa", function(module, exports) {

$parcel$export(module.exports, "AMPMMidnightParser", function () { return $e6fff86b9dc1ccb8$export$73ca2bd0a17d273; }, function (v) { return $e6fff86b9dc1ccb8$export$73ca2bd0a17d273 = v; });
var $e6fff86b9dc1ccb8$export$73ca2bd0a17d273;
"use strict";
$e6fff86b9dc1ccb8$export$73ca2bd0a17d273 = void 0;

var $3YLlM = parcelRequire("3YLlM");

var $96NIh = parcelRequire("96NIh");
class $e6fff86b9dc1ccb8$var$AMPMMidnightParser extends $3YLlM.Parser {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "b":
            case "bb":
            case "bbb":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbbb":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $96NIh.dayPeriodEnumToHours)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}
$e6fff86b9dc1ccb8$export$73ca2bd0a17d273 = $e6fff86b9dc1ccb8$var$AMPMMidnightParser;

});

parcelRegister("a7bmN", function(module, exports) {

$parcel$export(module.exports, "DayPeriodParser", function () { return $75d36006adcf75d4$export$bb9212adf05373db; }, function (v) { return $75d36006adcf75d4$export$bb9212adf05373db = v; });
var $75d36006adcf75d4$export$bb9212adf05373db;
"use strict";
$75d36006adcf75d4$export$bb9212adf05373db = void 0;

var $3YLlM = parcelRequire("3YLlM");

var $96NIh = parcelRequire("96NIh");
// in the morning, in the afternoon, in the evening, at night
class $75d36006adcf75d4$var$DayPeriodParser extends $3YLlM.Parser {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBBB":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $96NIh.dayPeriodEnumToHours)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "t",
        "T"
    ];
}
$75d36006adcf75d4$export$bb9212adf05373db = $75d36006adcf75d4$var$DayPeriodParser;

});

parcelRegister("6Awpb", function(module, exports) {

$parcel$export(module.exports, "Hour1to12Parser", function () { return $4cbf3dd95e21c662$export$8a04050a727a1756; }, function (v) { return $4cbf3dd95e21c662$export$8a04050a727a1756 = v; });
var $4cbf3dd95e21c662$export$8a04050a727a1756;
"use strict";
$4cbf3dd95e21c662$export$8a04050a727a1756 = void 0;

var $EodCH = parcelRequire("EodCH");

var $3YLlM = parcelRequire("3YLlM");

var $96NIh = parcelRequire("96NIh");
class $4cbf3dd95e21c662$var$Hour1to12Parser extends $3YLlM.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "h":
                return (0, $96NIh.parseNumericPattern)($EodCH.numericPatterns.hour12h, dateString);
            case "ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $96NIh.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 12;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else if (!isPM && value === 12) date.setHours(0, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "H",
        "K",
        "k",
        "t",
        "T"
    ];
}
$4cbf3dd95e21c662$export$8a04050a727a1756 = $4cbf3dd95e21c662$var$Hour1to12Parser;

});

parcelRegister("bgXYf", function(module, exports) {

$parcel$export(module.exports, "Hour0to23Parser", function () { return $834fb542f6227b69$export$e56f4dea2c3e56dd; }, function (v) { return $834fb542f6227b69$export$e56f4dea2c3e56dd = v; });
var $834fb542f6227b69$export$e56f4dea2c3e56dd;
"use strict";
$834fb542f6227b69$export$e56f4dea2c3e56dd = void 0;

var $EodCH = parcelRequire("EodCH");

var $3YLlM = parcelRequire("3YLlM");

var $96NIh = parcelRequire("96NIh");
class $834fb542f6227b69$var$Hour0to23Parser extends $3YLlM.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "H":
                return (0, $96NIh.parseNumericPattern)($EodCH.numericPatterns.hour23h, dateString);
            case "Ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $96NIh.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 23;
    }
    set(date, _flags, value) {
        date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "K",
        "k",
        "t",
        "T"
    ];
}
$834fb542f6227b69$export$e56f4dea2c3e56dd = $834fb542f6227b69$var$Hour0to23Parser;

});

parcelRegister("8jYvi", function(module, exports) {

$parcel$export(module.exports, "Hour0To11Parser", function () { return $60ef07e13baf486d$export$cbbe855312f87d77; }, function (v) { return $60ef07e13baf486d$export$cbbe855312f87d77 = v; });
var $60ef07e13baf486d$export$cbbe855312f87d77;
"use strict";
$60ef07e13baf486d$export$cbbe855312f87d77 = void 0;

var $EodCH = parcelRequire("EodCH");

var $3YLlM = parcelRequire("3YLlM");

var $96NIh = parcelRequire("96NIh");
class $60ef07e13baf486d$var$Hour0To11Parser extends $3YLlM.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "K":
                return (0, $96NIh.parseNumericPattern)($EodCH.numericPatterns.hour11h, dateString);
            case "Ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $96NIh.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "h",
        "H",
        "k",
        "t",
        "T"
    ];
}
$60ef07e13baf486d$export$cbbe855312f87d77 = $60ef07e13baf486d$var$Hour0To11Parser;

});

parcelRegister("eyo5t", function(module, exports) {

$parcel$export(module.exports, "Hour1To24Parser", function () { return $a986ece81d75adda$export$6008046d2b34b6a5; }, function (v) { return $a986ece81d75adda$export$6008046d2b34b6a5 = v; });
var $a986ece81d75adda$export$6008046d2b34b6a5;
"use strict";
$a986ece81d75adda$export$6008046d2b34b6a5 = void 0;

var $EodCH = parcelRequire("EodCH");

var $3YLlM = parcelRequire("3YLlM");

var $96NIh = parcelRequire("96NIh");
class $a986ece81d75adda$var$Hour1To24Parser extends $3YLlM.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "k":
                return (0, $96NIh.parseNumericPattern)($EodCH.numericPatterns.hour24h, dateString);
            case "ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $96NIh.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 24;
    }
    set(date, _flags, value) {
        const hours = value <= 24 ? value % 24 : value;
        date.setHours(hours, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "H",
        "K",
        "t",
        "T"
    ];
}
$a986ece81d75adda$export$6008046d2b34b6a5 = $a986ece81d75adda$var$Hour1To24Parser;

});

parcelRegister("emehK", function(module, exports) {

$parcel$export(module.exports, "MinuteParser", function () { return $a73e3381df685104$export$2b52670d9e2be53; }, function (v) { return $a73e3381df685104$export$2b52670d9e2be53 = v; });
var $a73e3381df685104$export$2b52670d9e2be53;
"use strict";
$a73e3381df685104$export$2b52670d9e2be53 = void 0;

var $EodCH = parcelRequire("EodCH");

var $3YLlM = parcelRequire("3YLlM");

var $96NIh = parcelRequire("96NIh");
class $a73e3381df685104$var$MinuteParser extends $3YLlM.Parser {
    priority = 60;
    parse(dateString, token, match) {
        switch(token){
            case "m":
                return (0, $96NIh.parseNumericPattern)($EodCH.numericPatterns.minute, dateString);
            case "mo":
                return match.ordinalNumber(dateString, {
                    unit: "minute"
                });
            default:
                return (0, $96NIh.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setMinutes(value, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
$a73e3381df685104$export$2b52670d9e2be53 = $a73e3381df685104$var$MinuteParser;

});

parcelRegister("5tBgd", function(module, exports) {

$parcel$export(module.exports, "SecondParser", function () { return $3fcc9054203ba784$export$94d46d540cf1366a; }, function (v) { return $3fcc9054203ba784$export$94d46d540cf1366a = v; });
var $3fcc9054203ba784$export$94d46d540cf1366a;
"use strict";
$3fcc9054203ba784$export$94d46d540cf1366a = void 0;

var $EodCH = parcelRequire("EodCH");

var $3YLlM = parcelRequire("3YLlM");

var $96NIh = parcelRequire("96NIh");
class $3fcc9054203ba784$var$SecondParser extends $3YLlM.Parser {
    priority = 50;
    parse(dateString, token, match) {
        switch(token){
            case "s":
                return (0, $96NIh.parseNumericPattern)($EodCH.numericPatterns.second, dateString);
            case "so":
                return match.ordinalNumber(dateString, {
                    unit: "second"
                });
            default:
                return (0, $96NIh.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setSeconds(value, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
$3fcc9054203ba784$export$94d46d540cf1366a = $3fcc9054203ba784$var$SecondParser;

});

parcelRegister("5c8fa", function(module, exports) {

$parcel$export(module.exports, "FractionOfSecondParser", function () { return $3c8477c0f614074a$export$b8e6f8b2d70893b1; }, function (v) { return $3c8477c0f614074a$export$b8e6f8b2d70893b1 = v; });
var $3c8477c0f614074a$export$b8e6f8b2d70893b1;
"use strict";
$3c8477c0f614074a$export$b8e6f8b2d70893b1 = void 0;

var $3YLlM = parcelRequire("3YLlM");

var $96NIh = parcelRequire("96NIh");
class $3c8477c0f614074a$var$FractionOfSecondParser extends $3YLlM.Parser {
    priority = 30;
    parse(dateString, token) {
        const valueCallback = (value)=>Math.trunc(value * Math.pow(10, -token.length + 3));
        return (0, $96NIh.mapValue)((0, $96NIh.parseNDigits)(token.length, dateString), valueCallback);
    }
    set(date, _flags, value) {
        date.setMilliseconds(value);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
$3c8477c0f614074a$export$b8e6f8b2d70893b1 = $3c8477c0f614074a$var$FractionOfSecondParser;

});

parcelRegister("jaqG5", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneWithZParser", function () { return $df43a52131b64454$export$104d901d49fea29b; }, function (v) { return $df43a52131b64454$export$104d901d49fea29b = v; });
var $df43a52131b64454$export$104d901d49fea29b;
"use strict";
$df43a52131b64454$export$104d901d49fea29b = void 0;

var $909bC = parcelRequire("909bC");

var $i6arj = parcelRequire("i6arj");

var $EodCH = parcelRequire("EodCH");

var $3YLlM = parcelRequire("3YLlM");

var $96NIh = parcelRequire("96NIh");
// Timezone (ISO-8601. +00:00 is `'Z'`)
class $df43a52131b64454$var$ISOTimezoneWithZParser extends $3YLlM.Parser {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "X":
                return (0, $96NIh.parseTimezonePattern)($EodCH.timezonePatterns.basicOptionalMinutes, dateString);
            case "XX":
                return (0, $96NIh.parseTimezonePattern)($EodCH.timezonePatterns.basic, dateString);
            case "XXXX":
                return (0, $96NIh.parseTimezonePattern)($EodCH.timezonePatterns.basicOptionalSeconds, dateString);
            case "XXXXX":
                return (0, $96NIh.parseTimezonePattern)($EodCH.timezonePatterns.extendedOptionalSeconds, dateString);
            case "XXX":
            default:
                return (0, $96NIh.parseTimezonePattern)($EodCH.timezonePatterns.extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $909bC.constructFrom)(date, date.getTime() - (0, $i6arj.getTimezoneOffsetInMilliseconds)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "x"
    ];
}
$df43a52131b64454$export$104d901d49fea29b = $df43a52131b64454$var$ISOTimezoneWithZParser;

});

parcelRegister("8NYk8", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneParser", function () { return $6691b1599947393f$export$12910e5204b52b9; }, function (v) { return $6691b1599947393f$export$12910e5204b52b9 = v; });
var $6691b1599947393f$export$12910e5204b52b9;
"use strict";
$6691b1599947393f$export$12910e5204b52b9 = void 0;

var $909bC = parcelRequire("909bC");

var $i6arj = parcelRequire("i6arj");

var $EodCH = parcelRequire("EodCH");

var $3YLlM = parcelRequire("3YLlM");

var $96NIh = parcelRequire("96NIh");
// Timezone (ISO-8601)
class $6691b1599947393f$var$ISOTimezoneParser extends $3YLlM.Parser {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "x":
                return (0, $96NIh.parseTimezonePattern)($EodCH.timezonePatterns.basicOptionalMinutes, dateString);
            case "xx":
                return (0, $96NIh.parseTimezonePattern)($EodCH.timezonePatterns.basic, dateString);
            case "xxxx":
                return (0, $96NIh.parseTimezonePattern)($EodCH.timezonePatterns.basicOptionalSeconds, dateString);
            case "xxxxx":
                return (0, $96NIh.parseTimezonePattern)($EodCH.timezonePatterns.extendedOptionalSeconds, dateString);
            case "xxx":
            default:
                return (0, $96NIh.parseTimezonePattern)($EodCH.timezonePatterns.extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $909bC.constructFrom)(date, date.getTime() - (0, $i6arj.getTimezoneOffsetInMilliseconds)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "X"
    ];
}
$6691b1599947393f$export$12910e5204b52b9 = $6691b1599947393f$var$ISOTimezoneParser;

});

parcelRegister("4Bk8s", function(module, exports) {

$parcel$export(module.exports, "TimestampSecondsParser", function () { return $359a3c95cad8b4f7$export$2cd8bf877a05e96; }, function (v) { return $359a3c95cad8b4f7$export$2cd8bf877a05e96 = v; });
var $359a3c95cad8b4f7$export$2cd8bf877a05e96;
"use strict";
$359a3c95cad8b4f7$export$2cd8bf877a05e96 = void 0;

var $909bC = parcelRequire("909bC");

var $3YLlM = parcelRequire("3YLlM");

var $96NIh = parcelRequire("96NIh");
class $359a3c95cad8b4f7$var$TimestampSecondsParser extends $3YLlM.Parser {
    priority = 40;
    parse(dateString) {
        return (0, $96NIh.parseAnyDigitsSigned)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $909bC.constructFrom)(date, value * 1000),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}
$359a3c95cad8b4f7$export$2cd8bf877a05e96 = $359a3c95cad8b4f7$var$TimestampSecondsParser;

});

parcelRegister("1S3i2", function(module, exports) {

$parcel$export(module.exports, "TimestampMillisecondsParser", function () { return $15cd62e7ec437b52$export$6d8f69c6906d6368; }, function (v) { return $15cd62e7ec437b52$export$6d8f69c6906d6368 = v; });
var $15cd62e7ec437b52$export$6d8f69c6906d6368;
"use strict";
$15cd62e7ec437b52$export$6d8f69c6906d6368 = void 0;

var $909bC = parcelRequire("909bC");

var $3YLlM = parcelRequire("3YLlM");

var $96NIh = parcelRequire("96NIh");
class $15cd62e7ec437b52$var$TimestampMillisecondsParser extends $3YLlM.Parser {
    priority = 20;
    parse(dateString) {
        return (0, $96NIh.parseAnyDigitsSigned)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $909bC.constructFrom)(date, value),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}
$15cd62e7ec437b52$export$6d8f69c6906d6368 = $15cd62e7ec437b52$var$TimestampMillisecondsParser;

});




parcelRegister("i7g4S", function(module, exports) {

$parcel$export(module.exports, "isMonday", function () { return $d3055a2064b6e802$export$9573fe9b7c9ac3f5; }, function (v) { return $d3055a2064b6e802$export$9573fe9b7c9ac3f5 = v; });
var $d3055a2064b6e802$export$9573fe9b7c9ac3f5;
"use strict";
$d3055a2064b6e802$export$9573fe9b7c9ac3f5 = $d3055a2064b6e802$var$isMonday;

var $eimnm = parcelRequire("eimnm");
/**
 * @name isMonday
 * @category Weekday Helpers
 * @summary Is the given date Monday?
 *
 * @description
 * Is the given date Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Monday
 *
 * @example
 * // Is 22 September 2014 Monday?
 * const result = isMonday(new Date(2014, 8, 22))
 * //=> true
 */ function $d3055a2064b6e802$var$isMonday(date) {
    return (0, $eimnm.toDate)(date).getDay() === 1;
}

});

parcelRegister("ld6jB", function(module, exports) {

$parcel$export(module.exports, "isPast", function () { return $f70fb5ed35e4afdf$export$fc5014aa3db48558; }, function (v) { return $f70fb5ed35e4afdf$export$fc5014aa3db48558 = v; });
var $f70fb5ed35e4afdf$export$fc5014aa3db48558;
"use strict";
$f70fb5ed35e4afdf$export$fc5014aa3db48558 = $f70fb5ed35e4afdf$var$isPast;

var $eimnm = parcelRequire("eimnm");
/**
 * @name isPast
 * @category Common Helpers
 * @summary Is the given date in the past?
 * @pure false
 *
 * @description
 * Is the given date in the past?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the past
 *
 * @example
 * // If today is 6 October 2014, is 2 July 2014 in the past?
 * const result = isPast(new Date(2014, 6, 2))
 * //=> true
 */ function $f70fb5ed35e4afdf$var$isPast(date) {
    return +(0, $eimnm.toDate)(date) < Date.now();
}

});

parcelRegister("dFpNK", function(module, exports) {

$parcel$export(module.exports, "isSameHour", function () { return $9f331e5726c7435d$export$f9f3a94a0371013; }, function (v) { return $9f331e5726c7435d$export$f9f3a94a0371013 = v; });
var $9f331e5726c7435d$export$f9f3a94a0371013;
"use strict";
$9f331e5726c7435d$export$f9f3a94a0371013 = $9f331e5726c7435d$var$isSameHour;

var $abFh3 = parcelRequire("abFh3");
/**
 * @name isSameHour
 * @category Hour Helpers
 * @summary Are the given dates in the same hour (and same day)?
 *
 * @description
 * Are the given dates in the same hour (and same day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same hour (and same day)
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 6, 30))
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 5 September 06:00:00 in the same hour?
 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 5, 6, 0))
 * //=> false
 */ function $9f331e5726c7435d$var$isSameHour(dateLeft, dateRight) {
    const dateLeftStartOfHour = (0, $abFh3.startOfHour)(dateLeft);
    const dateRightStartOfHour = (0, $abFh3.startOfHour)(dateRight);
    return +dateLeftStartOfHour === +dateRightStartOfHour;
}

});
parcelRegister("abFh3", function(module, exports) {

$parcel$export(module.exports, "startOfHour", function () { return $76aaf2a5d6c948d0$export$24f91f68e7c9d9d5; }, function (v) { return $76aaf2a5d6c948d0$export$24f91f68e7c9d9d5 = v; });
var $76aaf2a5d6c948d0$export$24f91f68e7c9d9d5;
"use strict";
$76aaf2a5d6c948d0$export$24f91f68e7c9d9d5 = $76aaf2a5d6c948d0$var$startOfHour;

var $eimnm = parcelRequire("eimnm");
/**
 * @name startOfHour
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an hour
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * const result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */ function $76aaf2a5d6c948d0$var$startOfHour(date) {
    const _date = (0, $eimnm.toDate)(date);
    _date.setMinutes(0, 0, 0);
    return _date;
}

});


parcelRegister("1exmu", function(module, exports) {

$parcel$export(module.exports, "isSameISOWeek", function () { return $0e60fa38e9d97095$export$1c6e74e3c7b27764; }, function (v) { return $0e60fa38e9d97095$export$1c6e74e3c7b27764 = v; });
var $0e60fa38e9d97095$export$1c6e74e3c7b27764;
"use strict";
$0e60fa38e9d97095$export$1c6e74e3c7b27764 = $0e60fa38e9d97095$var$isSameISOWeek;

var $9VRW1 = parcelRequire("9VRW1");
/**
 * @name isSameISOWeek
 * @category ISO Week Helpers
 * @summary Are the given dates in the same ISO week (and year)?
 *
 * @description
 * Are the given dates in the same ISO week (and year)?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same ISO week (and year)
 *
 * @example
 * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
 * const result = isSameISOWeek(new Date(2014, 8, 1), new Date(2014, 8, 7))
 * //=> true
 *
 * @example
 * // Are 1 September 2014 and 1 September 2015 in the same ISO week?
 * const result = isSameISOWeek(new Date(2014, 8, 1), new Date(2015, 8, 1))
 * //=> false
 */ function $0e60fa38e9d97095$var$isSameISOWeek(dateLeft, dateRight) {
    return (0, $9VRW1.isSameWeek)(dateLeft, dateRight, {
        weekStartsOn: 1
    });
}

});
parcelRegister("9VRW1", function(module, exports) {

$parcel$export(module.exports, "isSameWeek", function () { return $73b34649c9801d98$export$6ea683876c36b8d2; }, function (v) { return $73b34649c9801d98$export$6ea683876c36b8d2 = v; });
var $73b34649c9801d98$export$6ea683876c36b8d2;
"use strict";
$73b34649c9801d98$export$6ea683876c36b8d2 = $73b34649c9801d98$var$isSameWeek;

var $79XR6 = parcelRequire("79XR6");
/**
 * The {@link isSameWeek} function options.
 */ /**
 * @name isSameWeek
 * @category Week Helpers
 * @summary Are the given dates in the same week (and month and year)?
 *
 * @description
 * Are the given dates in the same week (and month and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 * @param options - An object with options
 *
 * @returns The dates are in the same week (and month and year)
 *
 * @example
 * // Are 31 August 2014 and 4 September 2014 in the same week?
 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4))
 * //=> true
 *
 * @example
 * // If week starts with Monday,
 * // are 31 August 2014 and 4 September 2014 in the same week?
 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4), {
 *   weekStartsOn: 1
 * })
 * //=> false
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same week?
 * const result = isSameWeek(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */ function $73b34649c9801d98$var$isSameWeek(dateLeft, dateRight, options) {
    const dateLeftStartOfWeek = (0, $79XR6.startOfWeek)(dateLeft, options);
    const dateRightStartOfWeek = (0, $79XR6.startOfWeek)(dateRight, options);
    return +dateLeftStartOfWeek === +dateRightStartOfWeek;
}

});


parcelRegister("jCNPh", function(module, exports) {

$parcel$export(module.exports, "isSameISOWeekYear", function () { return $e49837587ddbc8b7$export$5f55dbf38a1aee81; }, function (v) { return $e49837587ddbc8b7$export$5f55dbf38a1aee81 = v; });
var $e49837587ddbc8b7$export$5f55dbf38a1aee81;
"use strict";
$e49837587ddbc8b7$export$5f55dbf38a1aee81 = $e49837587ddbc8b7$var$isSameISOWeekYear;

var $aK6Tu = parcelRequire("aK6Tu");
/**
 * @name isSameISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Are the given dates in the same ISO week-numbering year?
 *
 * @description
 * Are the given dates in the same ISO week-numbering year?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same ISO week-numbering year
 *
 * @example
 * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
 * const result = isSameISOWeekYear(new Date(2003, 11, 29), new Date(2005, 0, 2))
 * //=> true
 */ function $e49837587ddbc8b7$var$isSameISOWeekYear(dateLeft, dateRight) {
    const dateLeftStartOfYear = (0, $aK6Tu.startOfISOWeekYear)(dateLeft);
    const dateRightStartOfYear = (0, $aK6Tu.startOfISOWeekYear)(dateRight);
    return +dateLeftStartOfYear === +dateRightStartOfYear;
}

});

parcelRegister("cwBMW", function(module, exports) {

$parcel$export(module.exports, "isSameMinute", function () { return $91e5c92775a9fced$export$5d274bf63c8705cb; }, function (v) { return $91e5c92775a9fced$export$5d274bf63c8705cb = v; });
var $91e5c92775a9fced$export$5d274bf63c8705cb;
"use strict";
$91e5c92775a9fced$export$5d274bf63c8705cb = $91e5c92775a9fced$var$isSameMinute;

var $jKKUM = parcelRequire("jKKUM");
/**
 * @name isSameMinute
 * @category Minute Helpers
 * @summary Are the given dates in the same minute (and hour and day)?
 *
 * @description
 * Are the given dates in the same minute (and hour and day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same minute (and hour and day)
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15 in the same minute?
 * const result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 4, 6, 30, 15)
 * )
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 5 September 2014 06:30:00 in the same minute?
 * const result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 5, 6, 30)
 * )
 * //=> false
 */ function $91e5c92775a9fced$var$isSameMinute(dateLeft, dateRight) {
    const dateLeftStartOfMinute = (0, $jKKUM.startOfMinute)(dateLeft);
    const dateRightStartOfMinute = (0, $jKKUM.startOfMinute)(dateRight);
    return +dateLeftStartOfMinute === +dateRightStartOfMinute;
}

});

parcelRegister("4pr1S", function(module, exports) {

$parcel$export(module.exports, "isSameMonth", function () { return $335e76b015c44cbe$export$a18c89cbd24170ff; }, function (v) { return $335e76b015c44cbe$export$a18c89cbd24170ff = v; });
var $335e76b015c44cbe$export$a18c89cbd24170ff;
"use strict";
$335e76b015c44cbe$export$a18c89cbd24170ff = $335e76b015c44cbe$var$isSameMonth;

var $eimnm = parcelRequire("eimnm");
/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same month (and year)
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */ function $335e76b015c44cbe$var$isSameMonth(dateLeft, dateRight) {
    const _dateLeft = (0, $eimnm.toDate)(dateLeft);
    const _dateRight = (0, $eimnm.toDate)(dateRight);
    return _dateLeft.getFullYear() === _dateRight.getFullYear() && _dateLeft.getMonth() === _dateRight.getMonth();
}

});

parcelRegister("gx9VE", function(module, exports) {

$parcel$export(module.exports, "isSameQuarter", function () { return $c0976e0facbd42fa$export$5c60e4190867161c; }, function (v) { return $c0976e0facbd42fa$export$5c60e4190867161c = v; });
var $c0976e0facbd42fa$export$5c60e4190867161c;
"use strict";
$c0976e0facbd42fa$export$5c60e4190867161c = $c0976e0facbd42fa$var$isSameQuarter;

var $bPqKl = parcelRequire("bPqKl");
/**
 * @name isSameQuarter
 * @category Quarter Helpers
 * @summary Are the given dates in the same quarter (and year)?
 *
 * @description
 * Are the given dates in the same quarter (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same quarter (and year)
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
 * //=> true
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */ function $c0976e0facbd42fa$var$isSameQuarter(dateLeft, dateRight) {
    const dateLeftStartOfQuarter = (0, $bPqKl.startOfQuarter)(dateLeft);
    const dateRightStartOfQuarter = (0, $bPqKl.startOfQuarter)(dateRight);
    return +dateLeftStartOfQuarter === +dateRightStartOfQuarter;
}

});

parcelRegister("4jSGi", function(module, exports) {

$parcel$export(module.exports, "isSameSecond", function () { return $32535a4f4132b446$export$b88fbcfe038f3498; }, function (v) { return $32535a4f4132b446$export$b88fbcfe038f3498 = v; });
var $32535a4f4132b446$export$b88fbcfe038f3498;
"use strict";
$32535a4f4132b446$export$b88fbcfe038f3498 = $32535a4f4132b446$var$isSameSecond;

var $lFyAe = parcelRequire("lFyAe");
/**
 * @name isSameSecond
 * @category Second Helpers
 * @summary Are the given dates in the same second (and hour and day)?
 *
 * @description
 * Are the given dates in the same second (and hour and day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same second (and hour and day)
 *
 * @example
 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 30, 15),
 *   new Date(2014, 8, 4, 6, 30, 15, 500)
 * )
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:00:15.000 and 4 September 2014 06:01.15.000 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 4, 6, 1, 15)
 * )
 * //=> false
 *
 * @example
 * // Are 4 September 2014 06:00:15.000 and 5 September 2014 06:00.15.000 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 5, 6, 0, 15)
 * )
 * //=> false
 */ function $32535a4f4132b446$var$isSameSecond(dateLeft, dateRight) {
    const dateLeftStartOfSecond = (0, $lFyAe.startOfSecond)(dateLeft);
    const dateRightStartOfSecond = (0, $lFyAe.startOfSecond)(dateRight);
    return +dateLeftStartOfSecond === +dateRightStartOfSecond;
}

});
parcelRegister("lFyAe", function(module, exports) {

$parcel$export(module.exports, "startOfSecond", function () { return $fc6840d663feb7a0$export$66c51f9715fdbff5; }, function (v) { return $fc6840d663feb7a0$export$66c51f9715fdbff5 = v; });
var $fc6840d663feb7a0$export$66c51f9715fdbff5;
"use strict";
$fc6840d663feb7a0$export$66c51f9715fdbff5 = $fc6840d663feb7a0$var$startOfSecond;

var $eimnm = parcelRequire("eimnm");
/**
 * @name startOfSecond
 * @category Second Helpers
 * @summary Return the start of a second for the given date.
 *
 * @description
 * Return the start of a second for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a second
 *
 * @example
 * // The start of a second for 1 December 2014 22:15:45.400:
 * const result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.000
 */ function $fc6840d663feb7a0$var$startOfSecond(date) {
    const _date = (0, $eimnm.toDate)(date);
    _date.setMilliseconds(0);
    return _date;
}

});


parcelRegister("hyKzc", function(module, exports) {

$parcel$export(module.exports, "isSameYear", function () { return $cc89bbce026a4c3c$export$5841f9eb9773f25f; }, function (v) { return $cc89bbce026a4c3c$export$5841f9eb9773f25f = v; });
var $cc89bbce026a4c3c$export$5841f9eb9773f25f;
"use strict";
$cc89bbce026a4c3c$export$5841f9eb9773f25f = $cc89bbce026a4c3c$var$isSameYear;

var $eimnm = parcelRequire("eimnm");
/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same year
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */ function $cc89bbce026a4c3c$var$isSameYear(dateLeft, dateRight) {
    const _dateLeft = (0, $eimnm.toDate)(dateLeft);
    const _dateRight = (0, $eimnm.toDate)(dateRight);
    return _dateLeft.getFullYear() === _dateRight.getFullYear();
}

});

parcelRegister("gIvfF", function(module, exports) {

$parcel$export(module.exports, "isThisHour", function () { return $c2b8ff57a84630a8$export$5d41bdc7172839b9; }, function (v) { return $c2b8ff57a84630a8$export$5d41bdc7172839b9 = v; });
var $c2b8ff57a84630a8$export$5d41bdc7172839b9;
"use strict";
$c2b8ff57a84630a8$export$5d41bdc7172839b9 = $c2b8ff57a84630a8$var$isThisHour;

var $hubi5 = parcelRequire("hubi5");

var $dFpNK = parcelRequire("dFpNK");
/**
 * @name isThisHour
 * @category Hour Helpers
 * @summary Is the given date in the same hour as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same hour as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this hour
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:00:00 in this hour?
 * const result = isThisHour(new Date(2014, 8, 25, 18))
 * //=> true
 */ function $c2b8ff57a84630a8$var$isThisHour(date) {
    return (0, $dFpNK.isSameHour)(date, (0, $hubi5.constructNow)(date));
}

});

parcelRegister("hPus8", function(module, exports) {

$parcel$export(module.exports, "isThisISOWeek", function () { return $cfaed25c23a9d8ed$export$4e987896c721f753; }, function (v) { return $cfaed25c23a9d8ed$export$4e987896c721f753 = v; });
var $cfaed25c23a9d8ed$export$4e987896c721f753;
"use strict";
$cfaed25c23a9d8ed$export$4e987896c721f753 = $cfaed25c23a9d8ed$var$isThisISOWeek;

var $hubi5 = parcelRequire("hubi5");

var $1exmu = parcelRequire("1exmu");
/**
 * @name isThisISOWeek
 * @category ISO Week Helpers
 * @summary Is the given date in the same ISO week as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same ISO week as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this ISO week
 *
 * @example
 * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
 * const result = isThisISOWeek(new Date(2014, 8, 22))
 * //=> true
 */ function $cfaed25c23a9d8ed$var$isThisISOWeek(date) {
    return (0, $1exmu.isSameISOWeek)(date, (0, $hubi5.constructNow)(date));
}

});

parcelRegister("jncO1", function(module, exports) {

$parcel$export(module.exports, "isThisMinute", function () { return $e1aa1941b3c9fcc5$export$fa55b7d29d8d957a; }, function (v) { return $e1aa1941b3c9fcc5$export$fa55b7d29d8d957a = v; });
var $e1aa1941b3c9fcc5$export$fa55b7d29d8d957a;
"use strict";
$e1aa1941b3c9fcc5$export$fa55b7d29d8d957a = $e1aa1941b3c9fcc5$var$isThisMinute;

var $hubi5 = parcelRequire("hubi5");

var $cwBMW = parcelRequire("cwBMW");
/**
 * @name isThisMinute
 * @category Minute Helpers
 * @summary Is the given date in the same minute as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same minute as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this minute
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:00 in this minute?
 * const result = isThisMinute(new Date(2014, 8, 25, 18, 30))
 * //=> true
 */ function $e1aa1941b3c9fcc5$var$isThisMinute(date) {
    return (0, $cwBMW.isSameMinute)(date, (0, $hubi5.constructNow)(date));
}

});

parcelRegister("5U3M4", function(module, exports) {

$parcel$export(module.exports, "isThisMonth", function () { return $44c51c3999ebf913$export$173f1e1d92847276; }, function (v) { return $44c51c3999ebf913$export$173f1e1d92847276 = v; });
var $44c51c3999ebf913$export$173f1e1d92847276;
"use strict";
$44c51c3999ebf913$export$173f1e1d92847276 = $44c51c3999ebf913$var$isThisMonth;

var $hubi5 = parcelRequire("hubi5");

var $4pr1S = parcelRequire("4pr1S");
/**
 * @name isThisMonth
 * @category Month Helpers
 * @summary Is the given date in the same month as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same month as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this month
 *
 * @example
 * // If today is 25 September 2014, is 15 September 2014 in this month?
 * const result = isThisMonth(new Date(2014, 8, 15))
 * //=> true
 */ function $44c51c3999ebf913$var$isThisMonth(date) {
    return (0, $4pr1S.isSameMonth)(date, (0, $hubi5.constructNow)(date));
}

});

parcelRegister("43TYt", function(module, exports) {

$parcel$export(module.exports, "isThisQuarter", function () { return $2f52dc903f6e7c3b$export$3d88fd18ab599ccc; }, function (v) { return $2f52dc903f6e7c3b$export$3d88fd18ab599ccc = v; });
var $2f52dc903f6e7c3b$export$3d88fd18ab599ccc;
"use strict";
$2f52dc903f6e7c3b$export$3d88fd18ab599ccc = $2f52dc903f6e7c3b$var$isThisQuarter;

var $hubi5 = parcelRequire("hubi5");

var $gx9VE = parcelRequire("gx9VE");
/**
 * @name isThisQuarter
 * @category Quarter Helpers
 * @summary Is the given date in the same quarter as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same quarter as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this quarter
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this quarter?
 * const result = isThisQuarter(new Date(2014, 6, 2))
 * //=> true
 */ function $2f52dc903f6e7c3b$var$isThisQuarter(date) {
    return (0, $gx9VE.isSameQuarter)(date, (0, $hubi5.constructNow)(date));
}

});

parcelRegister("8k7NC", function(module, exports) {

$parcel$export(module.exports, "isThisSecond", function () { return $60f63dc16c726c13$export$8d7059b5bca087e6; }, function (v) { return $60f63dc16c726c13$export$8d7059b5bca087e6 = v; });
var $60f63dc16c726c13$export$8d7059b5bca087e6;
"use strict";
$60f63dc16c726c13$export$8d7059b5bca087e6 = $60f63dc16c726c13$var$isThisSecond;

var $hubi5 = parcelRequire("hubi5");

var $4jSGi = parcelRequire("4jSGi");
/**
 * @name isThisSecond
 * @category Second Helpers
 * @summary Is the given date in the same second as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same second as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this second
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:15.000 in this second?
 * const result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
 * //=> true
 */ function $60f63dc16c726c13$var$isThisSecond(date) {
    return (0, $4jSGi.isSameSecond)(date, (0, $hubi5.constructNow)(date));
}

});

parcelRegister("ihXEc", function(module, exports) {

$parcel$export(module.exports, "isThisWeek", function () { return $d508153d08d22482$export$cfe4b66a69cdd8a; }, function (v) { return $d508153d08d22482$export$cfe4b66a69cdd8a = v; });
var $d508153d08d22482$export$cfe4b66a69cdd8a;
"use strict";
$d508153d08d22482$export$cfe4b66a69cdd8a = $d508153d08d22482$var$isThisWeek;

var $hubi5 = parcelRequire("hubi5");

var $9VRW1 = parcelRequire("9VRW1");
/**
 * The {@link isThisWeek} function options.
 */ /**
 * @name isThisWeek
 * @category Week Helpers
 * @summary Is the given date in the same week as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same week as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param options - The object with options
 *
 * @returns The date is in this week
 *
 * @example
 * // If today is 25 September 2014, is 21 September 2014 in this week?
 * const result = isThisWeek(new Date(2014, 8, 21))
 * //=> true
 *
 * @example
 * // If today is 25 September 2014 and week starts with Monday
 * // is 21 September 2014 in this week?
 * const result = isThisWeek(new Date(2014, 8, 21), { weekStartsOn: 1 })
 * //=> false
 */ function $d508153d08d22482$var$isThisWeek(date, options) {
    return (0, $9VRW1.isSameWeek)(date, (0, $hubi5.constructNow)(date), options);
}

});

parcelRegister("94Glt", function(module, exports) {

$parcel$export(module.exports, "isThisYear", function () { return $69b555ab22401f15$export$a28c94941893a5ac; }, function (v) { return $69b555ab22401f15$export$a28c94941893a5ac = v; });
var $69b555ab22401f15$export$a28c94941893a5ac;
"use strict";
$69b555ab22401f15$export$a28c94941893a5ac = $69b555ab22401f15$var$isThisYear;

var $hubi5 = parcelRequire("hubi5");

var $hyKzc = parcelRequire("hyKzc");
/**
 * @name isThisYear
 * @category Year Helpers
 * @summary Is the given date in the same year as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same year as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this year
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this year?
 * const result = isThisYear(new Date(2014, 6, 2))
 * //=> true
 */ function $69b555ab22401f15$var$isThisYear(date) {
    return (0, $hyKzc.isSameYear)(date, (0, $hubi5.constructNow)(date));
}

});

parcelRegister("3Eg36", function(module, exports) {

$parcel$export(module.exports, "isThursday", function () { return $2a818e83f51fc816$export$c8e7c906983ea347; }, function (v) { return $2a818e83f51fc816$export$c8e7c906983ea347 = v; });
var $2a818e83f51fc816$export$c8e7c906983ea347;
"use strict";
$2a818e83f51fc816$export$c8e7c906983ea347 = $2a818e83f51fc816$var$isThursday;

var $eimnm = parcelRequire("eimnm");
/**
 * @name isThursday
 * @category Weekday Helpers
 * @summary Is the given date Thursday?
 *
 * @description
 * Is the given date Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Thursday
 *
 * @example
 * // Is 25 September 2014 Thursday?
 * const result = isThursday(new Date(2014, 8, 25))
 * //=> true
 */ function $2a818e83f51fc816$var$isThursday(date) {
    return (0, $eimnm.toDate)(date).getDay() === 4;
}

});

parcelRegister("4xZrr", function(module, exports) {

$parcel$export(module.exports, "isToday", function () { return $34f9e78656a56b14$export$629b0a497aa65267; }, function (v) { return $34f9e78656a56b14$export$629b0a497aa65267 = v; });
var $34f9e78656a56b14$export$629b0a497aa65267;
"use strict";
$34f9e78656a56b14$export$629b0a497aa65267 = $34f9e78656a56b14$var$isToday;

var $hubi5 = parcelRequire("hubi5");

var $8doT3 = parcelRequire("8doT3");
/**
 * @name isToday
 * @category Day Helpers
 * @summary Is the given date today?
 * @pure false
 *
 * @description
 * Is the given date today?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is today
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * const result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */ function $34f9e78656a56b14$var$isToday(date) {
    return (0, $8doT3.isSameDay)(date, (0, $hubi5.constructNow)(date));
}

});

parcelRegister("9VZNf", function(module, exports) {

$parcel$export(module.exports, "isTomorrow", function () { return $73b95ec9d7708ad6$export$d6365ba92f0647f1; }, function (v) { return $73b95ec9d7708ad6$export$d6365ba92f0647f1 = v; });
var $73b95ec9d7708ad6$export$d6365ba92f0647f1;
"use strict";
$73b95ec9d7708ad6$export$d6365ba92f0647f1 = $73b95ec9d7708ad6$var$isTomorrow;

var $qX1g7 = parcelRequire("qX1g7");

var $hubi5 = parcelRequire("hubi5");

var $8doT3 = parcelRequire("8doT3");
/**
 * @name isTomorrow
 * @category Day Helpers
 * @summary Is the given date tomorrow?
 * @pure false
 *
 * @description
 * Is the given date tomorrow?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is tomorrow
 *
 * @example
 * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
 * const result = isTomorrow(new Date(2014, 9, 7, 14, 0))
 * //=> true
 */ function $73b95ec9d7708ad6$var$isTomorrow(date) {
    return (0, $8doT3.isSameDay)(date, (0, $qX1g7.addDays)((0, $hubi5.constructNow)(date), 1));
}

});

parcelRegister("lDdYI", function(module, exports) {

$parcel$export(module.exports, "isTuesday", function () { return $fbf81549e9ebd233$export$90d50b8f209f5ac3; }, function (v) { return $fbf81549e9ebd233$export$90d50b8f209f5ac3 = v; });
var $fbf81549e9ebd233$export$90d50b8f209f5ac3;
"use strict";
$fbf81549e9ebd233$export$90d50b8f209f5ac3 = $fbf81549e9ebd233$var$isTuesday;

var $eimnm = parcelRequire("eimnm");
/**
 * @name isTuesday
 * @category Weekday Helpers
 * @summary Is the given date Tuesday?
 *
 * @description
 * Is the given date Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Tuesday
 *
 * @example
 * // Is 23 September 2014 Tuesday?
 * const result = isTuesday(new Date(2014, 8, 23))
 * //=> true
 */ function $fbf81549e9ebd233$var$isTuesday(date) {
    return (0, $eimnm.toDate)(date).getDay() === 2;
}

});

parcelRegister("dIS7R", function(module, exports) {

$parcel$export(module.exports, "isWednesday", function () { return $029405a7e740958c$export$ec9de642cdd62944; }, function (v) { return $029405a7e740958c$export$ec9de642cdd62944 = v; });
var $029405a7e740958c$export$ec9de642cdd62944;
"use strict";
$029405a7e740958c$export$ec9de642cdd62944 = $029405a7e740958c$var$isWednesday;

var $eimnm = parcelRequire("eimnm");
/**
 * @name isWednesday
 * @category Weekday Helpers
 * @summary Is the given date Wednesday?
 *
 * @description
 * Is the given date Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Wednesday
 *
 * @example
 * // Is 24 September 2014 Wednesday?
 * const result = isWednesday(new Date(2014, 8, 24))
 * //=> true
 */ function $029405a7e740958c$var$isWednesday(date) {
    return (0, $eimnm.toDate)(date).getDay() === 3;
}

});

parcelRegister("8mUkU", function(module, exports) {

$parcel$export(module.exports, "isWithinInterval", function () { return $617c13fe03cf5c58$export$d7deef7a3738e19d; }, function (v) { return $617c13fe03cf5c58$export$d7deef7a3738e19d = v; });
var $617c13fe03cf5c58$export$d7deef7a3738e19d;
"use strict";
$617c13fe03cf5c58$export$d7deef7a3738e19d = $617c13fe03cf5c58$var$isWithinInterval;

var $eimnm = parcelRequire("eimnm");
/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param interval - The interval to check
 *
 * @returns The date is within the interval
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date })
 * // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end })
 * // => true
 */ function $617c13fe03cf5c58$var$isWithinInterval(date, interval) {
    const time = +(0, $eimnm.toDate)(date);
    const [startTime, endTime] = [
        +(0, $eimnm.toDate)(interval.start),
        +(0, $eimnm.toDate)(interval.end)
    ].sort((a, b)=>a - b);
    return time >= startTime && time <= endTime;
}

});

parcelRegister("1O99w", function(module, exports) {

$parcel$export(module.exports, "isYesterday", function () { return $15118f74c0026f70$export$221990270ebfe867; }, function (v) { return $15118f74c0026f70$export$221990270ebfe867 = v; });
var $15118f74c0026f70$export$221990270ebfe867;
"use strict";
$15118f74c0026f70$export$221990270ebfe867 = $15118f74c0026f70$var$isYesterday;

var $hubi5 = parcelRequire("hubi5");

var $8doT3 = parcelRequire("8doT3");

var $5ZlCI = parcelRequire("5ZlCI");
/**
 * @name isYesterday
 * @category Day Helpers
 * @summary Is the given date yesterday?
 * @pure false
 *
 * @description
 * Is the given date yesterday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is yesterday
 *
 * @example
 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
 * const result = isYesterday(new Date(2014, 9, 5, 14, 0))
 * //=> true
 */ function $15118f74c0026f70$var$isYesterday(date) {
    return (0, $8doT3.isSameDay)(date, (0, $5ZlCI.subDays)((0, $hubi5.constructNow)(date), 1));
}

});
parcelRegister("5ZlCI", function(module, exports) {

$parcel$export(module.exports, "subDays", function () { return $45c36c34a697a1ac$export$70823084e2deb1ea; }, function (v) { return $45c36c34a697a1ac$export$70823084e2deb1ea = v; });
var $45c36c34a697a1ac$export$70823084e2deb1ea;
"use strict";
$45c36c34a697a1ac$export$70823084e2deb1ea = $45c36c34a697a1ac$var$subDays;

var $qX1g7 = parcelRequire("qX1g7");
/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be subtracted.
 *
 * @returns The new date with the days subtracted
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */ function $45c36c34a697a1ac$var$subDays(date, amount) {
    return (0, $qX1g7.addDays)(date, -amount);
}

});


parcelRegister("h8Hsd", function(module, exports) {

$parcel$export(module.exports, "lastDayOfDecade", function () { return $c7a4e41dd80fae06$export$2aaf6241f57dd605; }, function (v) { return $c7a4e41dd80fae06$export$2aaf6241f57dd605 = v; });
var $c7a4e41dd80fae06$export$2aaf6241f57dd605;
"use strict";
$c7a4e41dd80fae06$export$2aaf6241f57dd605 = $c7a4e41dd80fae06$var$lastDayOfDecade;

var $eimnm = parcelRequire("eimnm");
/**
 * @name lastDayOfDecade
 * @category Decade Helpers
 * @summary Return the last day of a decade for the given date.
 *
 * @description
 * Return the last day of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a decade
 *
 * @example
 * // The last day of a decade for 21 December 2012 21:12:00:
 * const result = lastDayOfDecade(new Date(2012, 11, 21, 21, 12, 00))
 * //=> Wed Dec 31 2019 00:00:00
 */ function $c7a4e41dd80fae06$var$lastDayOfDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $eimnm.toDate)(date);
    const year = _date.getFullYear();
    const decade = 9 + Math.floor(year / 10) * 10;
    _date.setFullYear(decade + 1, 0, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("84I7M", function(module, exports) {

$parcel$export(module.exports, "lastDayOfISOWeek", function () { return $5e10ecaca933fd50$export$b08a8fc26ae6d94b; }, function (v) { return $5e10ecaca933fd50$export$b08a8fc26ae6d94b = v; });
var $5e10ecaca933fd50$export$b08a8fc26ae6d94b;
"use strict";
$5e10ecaca933fd50$export$b08a8fc26ae6d94b = $5e10ecaca933fd50$var$lastDayOfISOWeek;

var $5YHSk = parcelRequire("5YHSk");
/**
 * @name lastDayOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the last day of an ISO week for the given date.
 *
 * @description
 * Return the last day of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of an ISO week
 *
 * @example
 * // The last day of an ISO week for 2 September 2014 11:55:00:
 * const result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 00:00:00
 */ function $5e10ecaca933fd50$var$lastDayOfISOWeek(date) {
    return (0, $5YHSk.lastDayOfWeek)(date, {
        weekStartsOn: 1
    });
}

});
parcelRegister("5YHSk", function(module, exports) {

$parcel$export(module.exports, "lastDayOfWeek", function () { return $45a49715ac7b6060$export$b73502c35a293b0a; }, function (v) { return $45a49715ac7b6060$export$b73502c35a293b0a = v; });
var $45a49715ac7b6060$export$b73502c35a293b0a;
"use strict";
$45a49715ac7b6060$export$b73502c35a293b0a = $45a49715ac7b6060$var$lastDayOfWeek;

var $eimnm = parcelRequire("eimnm");

var $hIOa6 = parcelRequire("hIOa6");
/**
 * The {@link lastDayOfWeek} function options.
 */ /**
 * @name lastDayOfWeek
 * @category Week Helpers
 * @summary Return the last day of a week for the given date.
 *
 * @description
 * Return the last day of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The last day of a week
 *
 * @example
 * // The last day of a week for 2 September 2014 11:55:00:
 * const result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
 * const result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */ function $45a49715ac7b6060$var$lastDayOfWeek(date, options) {
    const defaultOptions = (0, $hIOa6.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $eimnm.toDate)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setHours(0, 0, 0, 0);
    _date.setDate(_date.getDate() + diff);
    return _date;
}

});


parcelRegister("3usol", function(module, exports) {

$parcel$export(module.exports, "lastDayOfISOWeekYear", function () { return $28aa3268b1b89709$export$1810bada8cd02ee1; }, function (v) { return $28aa3268b1b89709$export$1810bada8cd02ee1 = v; });
var $28aa3268b1b89709$export$1810bada8cd02ee1;
"use strict";
$28aa3268b1b89709$export$1810bada8cd02ee1 = $28aa3268b1b89709$var$lastDayOfISOWeekYear;

var $4j6Nm = parcelRequire("4j6Nm");

var $01IXW = parcelRequire("01IXW");

var $909bC = parcelRequire("909bC");
/**
 * @name lastDayOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the last day of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the last day of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week-numbering year
 *
 * @example
 * // The last day of an ISO week-numbering year for 2 July 2005:
 * const result = lastDayOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 00:00:00
 */ function $28aa3268b1b89709$var$lastDayOfISOWeekYear(date) {
    const year = (0, $4j6Nm.getISOWeekYear)(date);
    const fourthOfJanuary = (0, $909bC.constructFrom)(date, 0);
    fourthOfJanuary.setFullYear(year + 1, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    const _date = (0, $01IXW.startOfISOWeek)(fourthOfJanuary);
    _date.setDate(_date.getDate() - 1);
    return _date;
}

});

parcelRegister("33724", function(module, exports) {

$parcel$export(module.exports, "lastDayOfQuarter", function () { return $23871b61dca89abb$export$8693c04228304c7; }, function (v) { return $23871b61dca89abb$export$8693c04228304c7 = v; });
var $23871b61dca89abb$export$8693c04228304c7;
"use strict";
$23871b61dca89abb$export$8693c04228304c7 = $23871b61dca89abb$var$lastDayOfQuarter;

var $eimnm = parcelRequire("eimnm");
/**
 * @name lastDayOfQuarter
 * @category Quarter Helpers
 * @summary Return the last day of a year quarter for the given date.
 *
 * @description
 * Return the last day of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a quarter
 *
 * @example
 * // The last day of a quarter for 2 September 2014 11:55:00:
 * const result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */ function $23871b61dca89abb$var$lastDayOfQuarter(date) {
    const _date = (0, $eimnm.toDate)(date);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3 + 3;
    _date.setMonth(month, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("6HfQO", function(module, exports) {

$parcel$export(module.exports, "lastDayOfYear", function () { return $4e030de08c244235$export$323f7bc07b828bed; }, function (v) { return $4e030de08c244235$export$323f7bc07b828bed = v; });
var $4e030de08c244235$export$323f7bc07b828bed;
"use strict";
$4e030de08c244235$export$323f7bc07b828bed = $4e030de08c244235$var$lastDayOfYear;

var $eimnm = parcelRequire("eimnm");
/**
 * @name lastDayOfYear
 * @category Year Helpers
 * @summary Return the last day of a year for the given date.
 *
 * @description
 * Return the last day of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a year
 *
 * @example
 * // The last day of a year for 2 September 2014 11:55:00:
 * const result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 00:00:00
 */ function $4e030de08c244235$var$lastDayOfYear(date) {
    const _date = (0, $eimnm.toDate)(date);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("8rtOP", function(module, exports) {
"use strict";
module.exports.lightFormat = $6257f9be4c4f8513$var$lightFormat;
Object.defineProperty(module.exports, "lightFormatters", {
    enumerable: true,
    get: function() {
        return $kcZsG.lightFormatters;
    }
});

var $drHAt = parcelRequire("drHAt");

var $eimnm = parcelRequire("eimnm");

var $kcZsG = parcelRequire("kcZsG");
// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
// This RegExp consists of three parts separated by `|`:
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $6257f9be4c4f8513$var$formattingTokensRegExp = /(\w)\1*|''|'(''|[^'])+('|$)|./g;
const $6257f9be4c4f8513$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $6257f9be4c4f8513$var$doubleQuoteRegExp = /''/g;
const $6257f9be4c4f8513$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @private
 */ /**
 * @name lightFormat
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. Unlike `format`,
 * `lightFormat` doesn't use locales and outputs date using the most popular tokens.
 *
 * > ⚠️ Please note that the `lightFormat` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   |
 * |---------------------------------|---------|-----------------------------------|
 * | AM, PM                          | a..aaa  | AM, PM                            |
 * |                                 | aaaa    | a.m., p.m.                        |
 * |                                 | aaaaa   | a, p                              |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 |
 * |                                 | yy      | 44, 01, 00, 17                    |
 * |                                 | yyy     | 044, 001, 000, 017                |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |
 * |                                 | MM      | 01, 02, ..., 12                   |
 * | Day of month                    | d       | 1, 2, ..., 31                     |
 * |                                 | dd      | 01, 02, ..., 31                   |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |
 * |                                 | hh      | 01, 02, ..., 11, 12               |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |
 * |                                 | HH      | 00, 01, 02, ..., 23               |
 * | Minute                          | m       | 0, 1, ..., 59                     |
 * |                                 | mm      | 00, 01, ..., 59                   |
 * | Second                          | s       | 0, 1, ..., 59                     |
 * |                                 | ss      | 00, 01, ..., 59                   |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |
 * |                                 | SS      | 00, 01, ..., 99                   |
 * |                                 | SSS     | 000, 001, ..., 999                |
 * |                                 | SSSS    | ...                               |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 *
 * @returns The formatted date string
 *
 * @throws `Invalid time value` if the date is invalid
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * const result = lightFormat(new Date(2014, 1, 11), 'yyyy-MM-dd')
 * //=> '2014-02-11'
 */ function $6257f9be4c4f8513$var$lightFormat(date, formatStr) {
    const _date = (0, $eimnm.toDate)(date);
    if (!(0, $drHAt.isValid)(_date)) throw new RangeError("Invalid time value");
    const tokens = formatStr.match($6257f9be4c4f8513$var$formattingTokensRegExp);
    // The only case when formattingTokensRegExp doesn't match the string is when it's empty
    if (!tokens) return "";
    const result = tokens.map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return $6257f9be4c4f8513$var$cleanEscapedString(substring);
        const formatter = $kcZsG.lightFormatters[firstCharacter];
        if (formatter) return formatter(_date, substring);
        if (firstCharacter.match($6257f9be4c4f8513$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $6257f9be4c4f8513$var$cleanEscapedString(input) {
    const matches = input.match($6257f9be4c4f8513$var$escapedStringRegExp);
    if (!matches) return input;
    return matches[1].replace($6257f9be4c4f8513$var$doubleQuoteRegExp, "'");
}

});

parcelRegister("dDMwg", function(module, exports) {

$parcel$export(module.exports, "milliseconds", function () { return $9ee48dd10de1c704$export$9a27fac83d67afd3; }, function (v) { return $9ee48dd10de1c704$export$9a27fac83d67afd3 = v; });
var $9ee48dd10de1c704$export$9a27fac83d67afd3;
"use strict";
$9ee48dd10de1c704$export$9a27fac83d67afd3 = $9ee48dd10de1c704$var$milliseconds;

var $lILKk = parcelRequire("lILKk");
/**
 * @name milliseconds
 * @category Millisecond Helpers
 * @summary
 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
 *
 * @description
 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 *
 * One month is a year divided by 12.
 *
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be added.
 *
 * @returns The milliseconds
 *
 * @example
 * // 1 year in milliseconds
 * milliseconds({ years: 1 })
 * //=> 31556952000
 *
 * // 3 months in milliseconds
 * milliseconds({ months: 3 })
 * //=> 7889238000
 */ function $9ee48dd10de1c704$var$milliseconds({ years: years, months: months, weeks: weeks, days: days, hours: hours, minutes: minutes, seconds: seconds }) {
    let totalDays = 0;
    if (years) totalDays += years * $lILKk.daysInYear;
    if (months) totalDays += months * ($lILKk.daysInYear / 12);
    if (weeks) totalDays += weeks * 7;
    if (days) totalDays += days;
    let totalSeconds = totalDays * 86400;
    if (hours) totalSeconds += hours * 3600;
    if (minutes) totalSeconds += minutes * 60;
    if (seconds) totalSeconds += seconds;
    return Math.trunc(totalSeconds * 1000);
}

});

parcelRegister("dcq9l", function(module, exports) {

$parcel$export(module.exports, "millisecondsToHours", function () { return $99c0ae2815f6ef5a$export$689a412b29fa9ed5; }, function (v) { return $99c0ae2815f6ef5a$export$689a412b29fa9ed5 = v; });
var $99c0ae2815f6ef5a$export$689a412b29fa9ed5;
"use strict";
$99c0ae2815f6ef5a$export$689a412b29fa9ed5 = $99c0ae2815f6ef5a$var$millisecondsToHours;

var $lILKk = parcelRequire("lILKk");
/**
 * @name millisecondsToHours
 * @category Conversion Helpers
 * @summary Convert milliseconds to hours.
 *
 * @description
 * Convert a number of milliseconds to a full number of hours.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in hours
 *
 * @example
 * // Convert 7200000 milliseconds to hours:
 * const result = millisecondsToHours(7200000)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToHours(7199999)
 * //=> 1
 */ function $99c0ae2815f6ef5a$var$millisecondsToHours(milliseconds) {
    const hours = milliseconds / $lILKk.millisecondsInHour;
    return Math.trunc(hours);
}

});

parcelRegister("fOBHv", function(module, exports) {

$parcel$export(module.exports, "millisecondsToMinutes", function () { return $b838c5146c256568$export$a5f974e81e48cfc0; }, function (v) { return $b838c5146c256568$export$a5f974e81e48cfc0 = v; });
var $b838c5146c256568$export$a5f974e81e48cfc0;
"use strict";
$b838c5146c256568$export$a5f974e81e48cfc0 = $b838c5146c256568$var$millisecondsToMinutes;

var $lILKk = parcelRequire("lILKk");
/**
 * @name millisecondsToMinutes
 * @category Conversion Helpers
 * @summary Convert milliseconds to minutes.
 *
 * @description
 * Convert a number of milliseconds to a full number of minutes.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in minutes
 *
 * @example
 * // Convert 60000 milliseconds to minutes:
 * const result = millisecondsToMinutes(60000)
 * //=> 1
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToMinutes(119999)
 * //=> 1
 */ function $b838c5146c256568$var$millisecondsToMinutes(milliseconds) {
    const minutes = milliseconds / $lILKk.millisecondsInMinute;
    return Math.trunc(minutes);
}

});

parcelRegister("hfmry", function(module, exports) {

$parcel$export(module.exports, "millisecondsToSeconds", function () { return $c8e53f3075c5c537$export$f64c3bfbc58eec0f; }, function (v) { return $c8e53f3075c5c537$export$f64c3bfbc58eec0f = v; });
var $c8e53f3075c5c537$export$f64c3bfbc58eec0f;
"use strict";
$c8e53f3075c5c537$export$f64c3bfbc58eec0f = $c8e53f3075c5c537$var$millisecondsToSeconds;

var $lILKk = parcelRequire("lILKk");
/**
 * @name millisecondsToSeconds
 * @category Conversion Helpers
 * @summary Convert milliseconds to seconds.
 *
 * @description
 * Convert a number of milliseconds to a full number of seconds.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in seconds
 *
 * @example
 * // Convert 1000 miliseconds to seconds:
 * const result = millisecondsToSeconds(1000)
 * //=> 1
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToSeconds(1999)
 * //=> 1
 */ function $c8e53f3075c5c537$var$millisecondsToSeconds(milliseconds) {
    const seconds = milliseconds / $lILKk.millisecondsInSecond;
    return Math.trunc(seconds);
}

});

parcelRegister("52uDc", function(module, exports) {

$parcel$export(module.exports, "minutesToHours", function () { return $3ab4e66123950c50$export$815164eb42530ae7; }, function (v) { return $3ab4e66123950c50$export$815164eb42530ae7 = v; });
var $3ab4e66123950c50$export$815164eb42530ae7;
"use strict";
$3ab4e66123950c50$export$815164eb42530ae7 = $3ab4e66123950c50$var$minutesToHours;

var $lILKk = parcelRequire("lILKk");
/**
 * @name minutesToHours
 * @category Conversion Helpers
 * @summary Convert minutes to hours.
 *
 * @description
 * Convert a number of minutes to a full number of hours.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in hours
 *
 * @example
 * // Convert 140 minutes to hours:
 * const result = minutesToHours(120)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = minutesToHours(179)
 * //=> 2
 */ function $3ab4e66123950c50$var$minutesToHours(minutes) {
    const hours = minutes / $lILKk.minutesInHour;
    return Math.trunc(hours);
}

});

parcelRegister("3RjiA", function(module, exports) {

$parcel$export(module.exports, "minutesToMilliseconds", function () { return $2cf54ab203fd936a$export$f6b9795ef9056e3d; }, function (v) { return $2cf54ab203fd936a$export$f6b9795ef9056e3d = v; });
var $2cf54ab203fd936a$export$f6b9795ef9056e3d;
"use strict";
$2cf54ab203fd936a$export$f6b9795ef9056e3d = $2cf54ab203fd936a$var$minutesToMilliseconds;

var $lILKk = parcelRequire("lILKk");
/**
 * @name minutesToMilliseconds
 * @category Conversion Helpers
 * @summary Convert minutes to milliseconds.
 *
 * @description
 * Convert a number of minutes to a full number of milliseconds.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in milliseconds
 *
 * @example
 * // Convert 2 minutes to milliseconds
 * const result = minutesToMilliseconds(2)
 * //=> 120000
 */ function $2cf54ab203fd936a$var$minutesToMilliseconds(minutes) {
    return Math.trunc(minutes * $lILKk.millisecondsInMinute);
}

});

parcelRegister("avqZU", function(module, exports) {

$parcel$export(module.exports, "minutesToSeconds", function () { return $7a61bdcc0bf8b7a1$export$81ded4628c655103; }, function (v) { return $7a61bdcc0bf8b7a1$export$81ded4628c655103 = v; });
var $7a61bdcc0bf8b7a1$export$81ded4628c655103;
"use strict";
$7a61bdcc0bf8b7a1$export$81ded4628c655103 = $7a61bdcc0bf8b7a1$var$minutesToSeconds;

var $lILKk = parcelRequire("lILKk");
/**
 * @name minutesToSeconds
 * @category Conversion Helpers
 * @summary Convert minutes to seconds.
 *
 * @description
 * Convert a number of minutes to a full number of seconds.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in seconds
 *
 * @example
 * // Convert 2 minutes to seconds
 * const result = minutesToSeconds(2)
 * //=> 120
 */ function $7a61bdcc0bf8b7a1$var$minutesToSeconds(minutes) {
    return Math.trunc(minutes * $lILKk.secondsInMinute);
}

});

parcelRegister("gF4ZB", function(module, exports) {

$parcel$export(module.exports, "monthsToQuarters", function () { return $c21459200f483e84$export$1932fa2a2068c849; }, function (v) { return $c21459200f483e84$export$1932fa2a2068c849 = v; });
var $c21459200f483e84$export$1932fa2a2068c849;
"use strict";
$c21459200f483e84$export$1932fa2a2068c849 = $c21459200f483e84$var$monthsToQuarters;

var $lILKk = parcelRequire("lILKk");
/**
 * @name monthsToQuarters
 * @category Conversion Helpers
 * @summary Convert number of months to quarters.
 *
 * @description
 * Convert a number of months to a full number of quarters.
 *
 * @param months - The number of months to be converted.
 *
 * @returns The number of months converted in quarters
 *
 * @example
 * // Convert 6 months to quarters:
 * const result = monthsToQuarters(6)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = monthsToQuarters(7)
 * //=> 2
 */ function $c21459200f483e84$var$monthsToQuarters(months) {
    const quarters = months / $lILKk.monthsInQuarter;
    return Math.trunc(quarters);
}

});

parcelRegister("3uPKg", function(module, exports) {

$parcel$export(module.exports, "monthsToYears", function () { return $28bc4ff25a9b00e1$export$7489026ed27fc925; }, function (v) { return $28bc4ff25a9b00e1$export$7489026ed27fc925 = v; });
var $28bc4ff25a9b00e1$export$7489026ed27fc925;
"use strict";
$28bc4ff25a9b00e1$export$7489026ed27fc925 = $28bc4ff25a9b00e1$var$monthsToYears;

var $lILKk = parcelRequire("lILKk");
/**
 * @name monthsToYears
 * @category Conversion Helpers
 * @summary Convert number of months to years.
 *
 * @description
 * Convert a number of months to a full number of years.
 *
 * @param months - The number of months to be converted
 *
 * @returns The number of months converted in years
 *
 * @example
 * // Convert 36 months to years:
 * const result = monthsToYears(36)
 * //=> 3
 *
 * // It uses floor rounding:
 * const result = monthsToYears(40)
 * //=> 3
 */ function $28bc4ff25a9b00e1$var$monthsToYears(months) {
    const years = months / $lILKk.monthsInYear;
    return Math.trunc(years);
}

});

parcelRegister("hEDXf", function(module, exports) {

$parcel$export(module.exports, "nextDay", function () { return $cda52a3a1a73ba28$export$992728922317ffc8; }, function (v) { return $cda52a3a1a73ba28$export$992728922317ffc8 = v; });
var $cda52a3a1a73ba28$export$992728922317ffc8;
"use strict";
$cda52a3a1a73ba28$export$992728922317ffc8 = $cda52a3a1a73ba28$var$nextDay;

var $qX1g7 = parcelRequire("qX1g7");

var $zkIQr = parcelRequire("zkIQr");
/**
 * @name nextDay
 * @category Weekday Helpers
 * @summary When is the next day of the week?
 *
 * @description
 * When is the next day of the week? 0-6 the day of the week, 0 represents Sunday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param day - day of the week
 *
 * @returns The date is the next day of week
 *
 * @example
 * // When is the next Monday after Mar, 20, 2020?
 * const result = nextDay(new Date(2020, 2, 20), 1)
 * //=> Mon Mar 23 2020 00:00:00
 *
 * @example
 * // When is the next Tuesday after Mar, 21, 2020?
 * const result = nextDay(new Date(2020, 2, 21), 2)
 * //=> Tue Mar 24 2020 00:00:00
 */ function $cda52a3a1a73ba28$var$nextDay(date, day) {
    let delta = day - (0, $zkIQr.getDay)(date);
    if (delta <= 0) delta += 7;
    return (0, $qX1g7.addDays)(date, delta);
}

});

parcelRegister("4aX8d", function(module, exports) {

$parcel$export(module.exports, "nextFriday", function () { return $30a5f6e2ea921891$export$21d76934fce76327; }, function (v) { return $30a5f6e2ea921891$export$21d76934fce76327 = v; });
var $30a5f6e2ea921891$export$21d76934fce76327;
"use strict";
$30a5f6e2ea921891$export$21d76934fce76327 = $30a5f6e2ea921891$var$nextFriday;

var $hEDXf = parcelRequire("hEDXf");
/**
 * @name nextFriday
 * @category Weekday Helpers
 * @summary When is the next Friday?
 *
 * @description
 * When is the next Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Friday
 *
 * @example
 * // When is the next Friday after Mar, 22, 2020?
 * const result = nextFriday(new Date(2020, 2, 22))
 * //=> Fri Mar 27 2020 00:00:00
 */ function $30a5f6e2ea921891$var$nextFriday(date) {
    return (0, $hEDXf.nextDay)(date, 5);
}

});

parcelRegister("fGOFZ", function(module, exports) {

$parcel$export(module.exports, "nextMonday", function () { return $b6c21680ad692f6a$export$a20373bb0df6efdd; }, function (v) { return $b6c21680ad692f6a$export$a20373bb0df6efdd = v; });
var $b6c21680ad692f6a$export$a20373bb0df6efdd;
"use strict";
$b6c21680ad692f6a$export$a20373bb0df6efdd = $b6c21680ad692f6a$var$nextMonday;

var $hEDXf = parcelRequire("hEDXf");
/**
 * @name nextMonday
 * @category Weekday Helpers
 * @summary When is the next Monday?
 *
 * @description
 * When is the next Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Monday
 *
 * @example
 * // When is the next Monday after Mar, 22, 2020?
 * const result = nextMonday(new Date(2020, 2, 22))
 * //=> Mon Mar 23 2020 00:00:00
 */ function $b6c21680ad692f6a$var$nextMonday(date) {
    return (0, $hEDXf.nextDay)(date, 1);
}

});

parcelRegister("t4QMX", function(module, exports) {

$parcel$export(module.exports, "nextSaturday", function () { return $057678be20379bf4$export$c52f069246f7b032; }, function (v) { return $057678be20379bf4$export$c52f069246f7b032 = v; });
var $057678be20379bf4$export$c52f069246f7b032;
"use strict";
$057678be20379bf4$export$c52f069246f7b032 = $057678be20379bf4$var$nextSaturday;

var $hEDXf = parcelRequire("hEDXf");
/**
 * @name nextSaturday
 * @category Weekday Helpers
 * @summary When is the next Saturday?
 *
 * @description
 * When is the next Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Saturday
 *
 * @example
 * // When is the next Saturday after Mar, 22, 2020?
 * const result = nextSaturday(new Date(2020, 2, 22))
 * //=> Sat Mar 28 2020 00:00:00
 */ function $057678be20379bf4$var$nextSaturday(date) {
    return (0, $hEDXf.nextDay)(date, 6);
}

});

parcelRegister("8B15i", function(module, exports) {

$parcel$export(module.exports, "nextSunday", function () { return $64229ec88c2b09b2$export$a30adaa3ef47f854; }, function (v) { return $64229ec88c2b09b2$export$a30adaa3ef47f854 = v; });
var $64229ec88c2b09b2$export$a30adaa3ef47f854;
"use strict";
$64229ec88c2b09b2$export$a30adaa3ef47f854 = $64229ec88c2b09b2$var$nextSunday;

var $hEDXf = parcelRequire("hEDXf");
/**
 * @name nextSunday
 * @category Weekday Helpers
 * @summary When is the next Sunday?
 *
 * @description
 * When is the next Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Sunday
 *
 * @example
 * // When is the next Sunday after Mar, 22, 2020?
 * const result = nextSunday(new Date(2020, 2, 22))
 * //=> Sun Mar 29 2020 00:00:00
 */ function $64229ec88c2b09b2$var$nextSunday(date) {
    return (0, $hEDXf.nextDay)(date, 0);
}

});

parcelRegister("64vb2", function(module, exports) {

$parcel$export(module.exports, "nextThursday", function () { return $46bb4ce5c2b755e9$export$36d9a8523a98d5a4; }, function (v) { return $46bb4ce5c2b755e9$export$36d9a8523a98d5a4 = v; });
var $46bb4ce5c2b755e9$export$36d9a8523a98d5a4;
"use strict";
$46bb4ce5c2b755e9$export$36d9a8523a98d5a4 = $46bb4ce5c2b755e9$var$nextThursday;

var $hEDXf = parcelRequire("hEDXf");
/**
 * @name nextThursday
 * @category Weekday Helpers
 * @summary When is the next Thursday?
 *
 * @description
 * When is the next Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Thursday
 *
 * @example
 * // When is the next Thursday after Mar, 22, 2020?
 * const result = nextThursday(new Date(2020, 2, 22))
 * //=> Thur Mar 26 2020 00:00:00
 */ function $46bb4ce5c2b755e9$var$nextThursday(date) {
    return (0, $hEDXf.nextDay)(date, 4);
}

});

parcelRegister("3sVkc", function(module, exports) {

$parcel$export(module.exports, "nextTuesday", function () { return $2860741dce967a5c$export$391d63ff7dc2f668; }, function (v) { return $2860741dce967a5c$export$391d63ff7dc2f668 = v; });
var $2860741dce967a5c$export$391d63ff7dc2f668;
"use strict";
$2860741dce967a5c$export$391d63ff7dc2f668 = $2860741dce967a5c$var$nextTuesday;

var $hEDXf = parcelRequire("hEDXf");
/**
 * @name nextTuesday
 * @category Weekday Helpers
 * @summary When is the next Tuesday?
 *
 * @description
 * When is the next Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Tuesday
 *
 * @example
 * // When is the next Tuesday after Mar, 22, 2020?
 * const result = nextTuesday(new Date(2020, 2, 22))
 * //=> Tue Mar 24 2020 00:00:00
 */ function $2860741dce967a5c$var$nextTuesday(date) {
    return (0, $hEDXf.nextDay)(date, 2);
}

});

parcelRegister("4Z831", function(module, exports) {

$parcel$export(module.exports, "nextWednesday", function () { return $3a131a06def36b9f$export$7a895c1ff204304e; }, function (v) { return $3a131a06def36b9f$export$7a895c1ff204304e = v; });
var $3a131a06def36b9f$export$7a895c1ff204304e;
"use strict";
$3a131a06def36b9f$export$7a895c1ff204304e = $3a131a06def36b9f$var$nextWednesday;

var $hEDXf = parcelRequire("hEDXf");
/**
 * @name nextWednesday
 * @category Weekday Helpers
 * @summary When is the next Wednesday?
 *
 * @description
 * When is the next Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Wednesday
 *
 * @example
 * // When is the next Wednesday after Mar, 22, 2020?
 * const result = nextWednesday(new Date(2020, 2, 22))
 * //=> Wed Mar 25 2020 00:00:00
 */ function $3a131a06def36b9f$var$nextWednesday(date) {
    return (0, $hEDXf.nextDay)(date, 3);
}

});

parcelRegister("joJia", function(module, exports) {

$parcel$export(module.exports, "parseISO", function () { return $e1f3643ebc0c77d4$export$4393d2ccbbedb219; }, function (v) { return $e1f3643ebc0c77d4$export$4393d2ccbbedb219 = v; });
var $e1f3643ebc0c77d4$export$4393d2ccbbedb219;
"use strict";
$e1f3643ebc0c77d4$export$4393d2ccbbedb219 = $e1f3643ebc0c77d4$var$parseISO;

var $lILKk = parcelRequire("lILKk");
/**
 * The {@link parseISO} function options.
 */ /**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 * @param options - An object with options
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */ function $e1f3643ebc0c77d4$var$parseISO(argument, options) {
    const additionalDigits = options?.additionalDigits ?? 2;
    const dateStrings = $e1f3643ebc0c77d4$var$splitDateString(argument);
    let date;
    if (dateStrings.date) {
        const parseYearResult = $e1f3643ebc0c77d4$var$parseYear(dateStrings.date, additionalDigits);
        date = $e1f3643ebc0c77d4$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    const timestamp = date.getTime();
    let time = 0;
    let offset;
    if (dateStrings.time) {
        time = $e1f3643ebc0c77d4$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $e1f3643ebc0c77d4$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        const dirtyDate = new Date(timestamp + time);
        // JS parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        const result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
const $e1f3643ebc0c77d4$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
const $e1f3643ebc0c77d4$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
const $e1f3643ebc0c77d4$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
const $e1f3643ebc0c77d4$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $e1f3643ebc0c77d4$var$splitDateString(dateString) {
    const dateStrings = {};
    const array = dateString.split($e1f3643ebc0c77d4$var$patterns.dateTimeDelimiter);
    let timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($e1f3643ebc0c77d4$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($e1f3643ebc0c77d4$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        const token = $e1f3643ebc0c77d4$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $e1f3643ebc0c77d4$var$parseYear(dateString, additionalDigits) {
    const regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    const captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    const year = captures[1] ? parseInt(captures[1]) : null;
    const century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $e1f3643ebc0c77d4$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    const captures = dateString.match($e1f3643ebc0c77d4$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    const isWeekDate = !!captures[4];
    const dayOfYear = $e1f3643ebc0c77d4$var$parseDateUnit(captures[1]);
    const month = $e1f3643ebc0c77d4$var$parseDateUnit(captures[2]) - 1;
    const day = $e1f3643ebc0c77d4$var$parseDateUnit(captures[3]);
    const week = $e1f3643ebc0c77d4$var$parseDateUnit(captures[4]);
    const dayOfWeek = $e1f3643ebc0c77d4$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$e1f3643ebc0c77d4$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $e1f3643ebc0c77d4$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        const date = new Date(0);
        if (!$e1f3643ebc0c77d4$var$validateDate(year, month, day) || !$e1f3643ebc0c77d4$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $e1f3643ebc0c77d4$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $e1f3643ebc0c77d4$var$parseTime(timeString) {
    const captures = timeString.match($e1f3643ebc0c77d4$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    const hours = $e1f3643ebc0c77d4$var$parseTimeUnit(captures[1]);
    const minutes = $e1f3643ebc0c77d4$var$parseTimeUnit(captures[2]);
    const seconds = $e1f3643ebc0c77d4$var$parseTimeUnit(captures[3]);
    if (!$e1f3643ebc0c77d4$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * $lILKk.millisecondsInHour + minutes * $lILKk.millisecondsInMinute + seconds * 1000;
}
function $e1f3643ebc0c77d4$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $e1f3643ebc0c77d4$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    const captures = timezoneString.match($e1f3643ebc0c77d4$var$timezoneRegex);
    if (!captures) return 0;
    const sign = captures[1] === "+" ? -1 : 1;
    const hours = parseInt(captures[2]);
    const minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$e1f3643ebc0c77d4$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * $lILKk.millisecondsInHour + minutes * $lILKk.millisecondsInMinute);
}
function $e1f3643ebc0c77d4$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    const date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    const fourthOfJanuaryDay = date.getUTCDay() || 7;
    const diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
const $e1f3643ebc0c77d4$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $e1f3643ebc0c77d4$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $e1f3643ebc0c77d4$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($e1f3643ebc0c77d4$var$daysInMonths[month] || ($e1f3643ebc0c77d4$var$isLeapYearIndex(year) ? 29 : 28));
}
function $e1f3643ebc0c77d4$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($e1f3643ebc0c77d4$var$isLeapYearIndex(year) ? 366 : 365);
}
function $e1f3643ebc0c77d4$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $e1f3643ebc0c77d4$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $e1f3643ebc0c77d4$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("aOkIn", function(module, exports) {

$parcel$export(module.exports, "parseJSON", function () { return $7deea467f0400360$export$27924e57e9afff7f; }, function (v) { return $7deea467f0400360$export$27924e57e9afff7f = v; });
var $7deea467f0400360$export$27924e57e9afff7f;
"use strict";
$7deea467f0400360$export$27924e57e9afff7f = $7deea467f0400360$var$parseJSON; /**
 * @name parseJSON
 * @category Common Helpers
 * @summary Parse a JSON date string
 *
 * @description
 * Converts a complete ISO date string in UTC time, the typical format for transmitting
 * a date in JSON, to a JavaScript `Date` instance.
 *
 * This is a minimal implementation for converting dates retrieved from a JSON API to
 * a `Date` instance which can be used with other functions in the `date-fns` library.
 * The following formats are supported:
 *
 * - `2000-03-15T05:20:10.123Z`: The output of `.toISOString()` and `JSON.stringify(new Date())`
 * - `2000-03-15T05:20:10Z`: Without milliseconds
 * - `2000-03-15T05:20:10+00:00`: With a zero offset, the default JSON encoded format in some other languages
 * - `2000-03-15T05:20:10+05:45`: With a positive or negative offset, the default JSON encoded format in some other languages
 * - `2000-03-15T05:20:10+0000`: With a zero offset without a colon
 * - `2000-03-15T05:20:10`: Without a trailing 'Z' symbol
 * - `2000-03-15T05:20:10.1234567`: Up to 7 digits in milliseconds field. Only first 3 are taken into account since JS does not allow fractional milliseconds
 * - `2000-03-15 05:20:10`: With a space instead of a 'T' separator for APIs returning a SQL date without reformatting
 *
 * For convenience and ease of use these other input types are also supported
 * via [toDate](https://date-fns.org/docs/toDate):
 *
 * - A `Date` instance will be cloned
 * - A `number` will be treated as a timestamp
 *
 * Any other input type or invalid date strings will return an `Invalid Date`.
 *
 * @param dateStr - A fully formed ISO8601 date string to convert
 *
 * @returns The parsed date in the local time zone
 */ 
function $7deea467f0400360$var$parseJSON(dateStr) {
    const parts = dateStr.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/);
    if (parts) // Group 8 matches the sign
    return new Date(Date.UTC(+parts[1], +parts[2] - 1, +parts[3], +parts[4] - (+parts[9] || 0) * (parts[8] == "-" ? -1 : 1), +parts[5] - (+parts[10] || 0) * (parts[8] == "-" ? -1 : 1), +parts[6], +((parts[7] || "0") + "00").substring(0, 3)));
    return new Date(NaN);
}

});

parcelRegister("kp1Yf", function(module, exports) {

$parcel$export(module.exports, "previousDay", function () { return $eda7abcfc7f3c5ca$export$4caccb62df4eacc0; }, function (v) { return $eda7abcfc7f3c5ca$export$4caccb62df4eacc0 = v; });
var $eda7abcfc7f3c5ca$export$4caccb62df4eacc0;
"use strict";
$eda7abcfc7f3c5ca$export$4caccb62df4eacc0 = $eda7abcfc7f3c5ca$var$previousDay;

var $zkIQr = parcelRequire("zkIQr");

var $5ZlCI = parcelRequire("5ZlCI");
/**
 * @name previousDay
 * @category Weekday Helpers
 * @summary When is the previous day of the week?
 *
 * @description
 * When is the previous day of the week? 0-6 the day of the week, 0 represents Sunday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param day - The day of the week
 *
 * @returns The date is the previous day of week
 *
 * @example
 * // When is the previous Monday before Mar, 20, 2020?
 * const result = previousDay(new Date(2020, 2, 20), 1)
 * //=> Mon Mar 16 2020 00:00:00
 *
 * @example
 * // When is the previous Tuesday before Mar, 21, 2020?
 * const result = previousDay(new Date(2020, 2, 21), 2)
 * //=> Tue Mar 17 2020 00:00:00
 */ function $eda7abcfc7f3c5ca$var$previousDay(date, day) {
    let delta = (0, $zkIQr.getDay)(date) - day;
    if (delta <= 0) delta += 7;
    return (0, $5ZlCI.subDays)(date, delta);
}

});

parcelRegister("1Gn5j", function(module, exports) {

$parcel$export(module.exports, "previousFriday", function () { return $139b9ed729577719$export$32d52646c338c11d; }, function (v) { return $139b9ed729577719$export$32d52646c338c11d = v; });
var $139b9ed729577719$export$32d52646c338c11d;
"use strict";
$139b9ed729577719$export$32d52646c338c11d = $139b9ed729577719$var$previousFriday;

var $kp1Yf = parcelRequire("kp1Yf");
/**
 * @name previousFriday
 * @category Weekday Helpers
 * @summary When is the previous Friday?
 *
 * @description
 * When is the previous Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Friday
 *
 * @example
 * // When is the previous Friday before Jun, 19, 2021?
 * const result = previousFriday(new Date(2021, 5, 19))
 * //=> Fri June 18 2021 00:00:00
 */ function $139b9ed729577719$var$previousFriday(date) {
    return (0, $kp1Yf.previousDay)(date, 5);
}

});

parcelRegister("hDpza", function(module, exports) {

$parcel$export(module.exports, "previousMonday", function () { return $cd69e917eedd3a45$export$398437ab6f45c582; }, function (v) { return $cd69e917eedd3a45$export$398437ab6f45c582 = v; });
var $cd69e917eedd3a45$export$398437ab6f45c582;
"use strict";
$cd69e917eedd3a45$export$398437ab6f45c582 = $cd69e917eedd3a45$var$previousMonday;

var $kp1Yf = parcelRequire("kp1Yf");
/**
 * @name previousMonday
 * @category Weekday Helpers
 * @summary When is the previous Monday?
 *
 * @description
 * When is the previous Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Monday
 *
 * @example
 * // When is the previous Monday before Jun, 18, 2021?
 * const result = previousMonday(new Date(2021, 5, 18))
 * //=> Mon June 14 2021 00:00:00
 */ function $cd69e917eedd3a45$var$previousMonday(date) {
    return (0, $kp1Yf.previousDay)(date, 1);
}

});

parcelRegister("fTn29", function(module, exports) {

$parcel$export(module.exports, "previousSaturday", function () { return $b91ddc1a0c6ec187$export$36767a7e6101ecb0; }, function (v) { return $b91ddc1a0c6ec187$export$36767a7e6101ecb0 = v; });
var $b91ddc1a0c6ec187$export$36767a7e6101ecb0;
"use strict";
$b91ddc1a0c6ec187$export$36767a7e6101ecb0 = $b91ddc1a0c6ec187$var$previousSaturday;

var $kp1Yf = parcelRequire("kp1Yf");
/**
 * @name previousSaturday
 * @category Weekday Helpers
 * @summary When is the previous Saturday?
 *
 * @description
 * When is the previous Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Saturday
 *
 * @example
 * // When is the previous Saturday before Jun, 20, 2021?
 * const result = previousSaturday(new Date(2021, 5, 20))
 * //=> Sat June 19 2021 00:00:00
 */ function $b91ddc1a0c6ec187$var$previousSaturday(date) {
    return (0, $kp1Yf.previousDay)(date, 6);
}

});

parcelRegister("auSWR", function(module, exports) {

$parcel$export(module.exports, "previousSunday", function () { return $7a475455ad40221e$export$7d3d7d8fc5e81fd4; }, function (v) { return $7a475455ad40221e$export$7d3d7d8fc5e81fd4 = v; });
var $7a475455ad40221e$export$7d3d7d8fc5e81fd4;
"use strict";
$7a475455ad40221e$export$7d3d7d8fc5e81fd4 = $7a475455ad40221e$var$previousSunday;

var $kp1Yf = parcelRequire("kp1Yf");
/**
 * @name previousSunday
 * @category Weekday Helpers
 * @summary When is the previous Sunday?
 *
 * @description
 * When is the previous Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Sunday
 *
 * @example
 * // When is the previous Sunday before Jun, 21, 2021?
 * const result = previousSunday(new Date(2021, 5, 21))
 * //=> Sun June 20 2021 00:00:00
 */ function $7a475455ad40221e$var$previousSunday(date) {
    return (0, $kp1Yf.previousDay)(date, 0);
}

});

parcelRegister("ec7I5", function(module, exports) {

$parcel$export(module.exports, "previousThursday", function () { return $a5582abb1e378cff$export$1975b5b1f6b0e34e; }, function (v) { return $a5582abb1e378cff$export$1975b5b1f6b0e34e = v; });
var $a5582abb1e378cff$export$1975b5b1f6b0e34e;
"use strict";
$a5582abb1e378cff$export$1975b5b1f6b0e34e = $a5582abb1e378cff$var$previousThursday;

var $kp1Yf = parcelRequire("kp1Yf");
/**
 * @name previousThursday
 * @category Weekday Helpers
 * @summary When is the previous Thursday?
 *
 * @description
 * When is the previous Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Thursday
 *
 * @example
 * // When is the previous Thursday before Jun, 18, 2021?
 * const result = previousThursday(new Date(2021, 5, 18))
 * //=> Thu June 17 2021 00:00:00
 */ function $a5582abb1e378cff$var$previousThursday(date) {
    return (0, $kp1Yf.previousDay)(date, 4);
}

});

parcelRegister("fzt5u", function(module, exports) {

$parcel$export(module.exports, "previousTuesday", function () { return $b560b017219e3d4d$export$a034a75f093bcfaf; }, function (v) { return $b560b017219e3d4d$export$a034a75f093bcfaf = v; });
var $b560b017219e3d4d$export$a034a75f093bcfaf;
"use strict";
$b560b017219e3d4d$export$a034a75f093bcfaf = $b560b017219e3d4d$var$previousTuesday;

var $kp1Yf = parcelRequire("kp1Yf");
/**
 * @name previousTuesday
 * @category Weekday Helpers
 * @summary When is the previous Tuesday?
 *
 * @description
 * When is the previous Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Tuesday
 *
 * @example
 * // When is the previous Tuesday before Jun, 18, 2021?
 * const result = previousTuesday(new Date(2021, 5, 18))
 * //=> Tue June 15 2021 00:00:00
 */ function $b560b017219e3d4d$var$previousTuesday(date) {
    return (0, $kp1Yf.previousDay)(date, 2);
}

});

parcelRegister("gIpHn", function(module, exports) {

$parcel$export(module.exports, "previousWednesday", function () { return $c2b4b0a0b2cf39de$export$26334f591e4ce672; }, function (v) { return $c2b4b0a0b2cf39de$export$26334f591e4ce672 = v; });
var $c2b4b0a0b2cf39de$export$26334f591e4ce672;
"use strict";
$c2b4b0a0b2cf39de$export$26334f591e4ce672 = $c2b4b0a0b2cf39de$var$previousWednesday;

var $kp1Yf = parcelRequire("kp1Yf");
/**
 * @name previousWednesday
 * @category Weekday Helpers
 * @summary When is the previous Wednesday?
 *
 * @description
 * When is the previous Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Wednesday
 *
 * @example
 * // When is the previous Wednesday before Jun, 18, 2021?
 * const result = previousWednesday(new Date(2021, 5, 18))
 * //=> Wed June 16 2021 00:00:00
 */ function $c2b4b0a0b2cf39de$var$previousWednesday(date) {
    return (0, $kp1Yf.previousDay)(date, 3);
}

});

parcelRegister("IcDAL", function(module, exports) {

$parcel$export(module.exports, "quartersToMonths", function () { return $084de9bc6921f4f4$export$a29d19ce21d74c57; }, function (v) { return $084de9bc6921f4f4$export$a29d19ce21d74c57 = v; });
var $084de9bc6921f4f4$export$a29d19ce21d74c57;
"use strict";
$084de9bc6921f4f4$export$a29d19ce21d74c57 = $084de9bc6921f4f4$var$quartersToMonths;

var $lILKk = parcelRequire("lILKk");
/**
 * @name quartersToMonths
 * @category Conversion Helpers
 * @summary Convert number of quarters to months.
 *
 * @description
 * Convert a number of quarters to a full number of months.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param quarters - The number of quarters to be converted
 *
 * @returns The number of quarters converted in months
 *
 * @example
 * // Convert 2 quarters to months
 * const result = quartersToMonths(2)
 * //=> 6
 */ function $084de9bc6921f4f4$var$quartersToMonths(quarters) {
    return Math.trunc(quarters * $lILKk.monthsInQuarter);
}

});

parcelRegister("dFjae", function(module, exports) {

$parcel$export(module.exports, "quartersToYears", function () { return $9f2df84ba79d32a5$export$c309fa8f184b4648; }, function (v) { return $9f2df84ba79d32a5$export$c309fa8f184b4648 = v; });
var $9f2df84ba79d32a5$export$c309fa8f184b4648;
"use strict";
$9f2df84ba79d32a5$export$c309fa8f184b4648 = $9f2df84ba79d32a5$var$quartersToYears;

var $lILKk = parcelRequire("lILKk");
/**
 * @name quartersToYears
 * @category Conversion Helpers
 * @summary Convert number of quarters to years.
 *
 * @description
 * Convert a number of quarters to a full number of years.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param quarters - The number of quarters to be converted
 *
 * @returns The number of quarters converted in years
 *
 * @example
 * // Convert 8 quarters to years
 * const result = quartersToYears(8)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = quartersToYears(11)
 * //=> 2
 */ function $9f2df84ba79d32a5$var$quartersToYears(quarters) {
    const years = quarters / $lILKk.quartersInYear;
    return Math.trunc(years);
}

});

parcelRegister("dzIQO", function(module, exports) {

$parcel$export(module.exports, "roundToNearestHours", function () { return $9e2155ae4e853975$export$a8b87649ebc0e3c2; }, function (v) { return $9e2155ae4e853975$export$a8b87649ebc0e3c2 = v; });
var $9e2155ae4e853975$export$a8b87649ebc0e3c2;
"use strict";
$9e2155ae4e853975$export$a8b87649ebc0e3c2 = $9e2155ae4e853975$var$roundToNearestHours;

var $fosqj = parcelRequire("fosqj");

var $909bC = parcelRequire("909bC");

var $eimnm = parcelRequire("eimnm");
/**
 * The {@link roundToNearestHours} function options.
 */ /**
 * @name roundToNearestHours
 * @category Hour Helpers
 * @summary Rounds the given date to the nearest hour
 *
 * @description
 * Rounds the given date to the nearest hour (or number of hours).
 * Rounds up when the given date is exactly between the nearest round hours.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to round
 * @param options - An object with options.
 *
 * @returns The new date rounded to the closest hour
 *
 * @example
 * // Round 10 July 2014 12:34:56 to nearest hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56))
 * //=> Thu Jul 10 2014 13:00:00
 *
 * @example
 * // Round 10 July 2014 12:34:56 to nearest half hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { nearestTo: 6 })
 * //=> Thu Jul 10 2014 12:00:00

 * @example
 * // Round 10 July 2014 12:34:56 to nearest half hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { nearestTo: 8 })
 * //=> Thu Jul 10 2014 16:00:00

* @example
 * // Floor (rounds down) 10 July 2014 12:34:56 to nearest hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 1, 23, 45), { roundingMethod: 'ceil' })
 * //=> Thu Jul 10 2014 02:00:00
 *
 * @example
 * // Ceil (rounds up) 10 July 2014 12:34:56 to nearest quarter hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { roundingMethod: 'floor', nearestTo: 8 })
 * //=> Thu Jul 10 2014 08:00:00
 */ function $9e2155ae4e853975$var$roundToNearestHours(date, options) {
    const nearestTo = options?.nearestTo ?? 1;
    if (nearestTo < 1 || nearestTo > 12) return (0, $909bC.constructFrom)(date, NaN);
    const _date = (0, $eimnm.toDate)(date);
    const fractionalMinutes = _date.getMinutes() / 60;
    const fractionalSeconds = _date.getSeconds() / 60 / 60;
    const fractionalMilliseconds = _date.getMilliseconds() / 1000 / 60 / 60;
    const hours = _date.getHours() + fractionalMinutes + fractionalSeconds + fractionalMilliseconds;
    // Unlike the `differenceIn*` functions, the default rounding behavior is `round` and not 'trunc'
    const method = options?.roundingMethod ?? "round";
    const roundingMethod = (0, $fosqj.getRoundingMethod)(method);
    // nearestTo option does not care daylight savings time
    const roundedHours = roundingMethod(hours / nearestTo) * nearestTo;
    const result = (0, $909bC.constructFrom)(date, _date);
    result.setHours(roundedHours, 0, 0, 0);
    return result;
}

});

parcelRegister("2tXml", function(module, exports) {

$parcel$export(module.exports, "roundToNearestMinutes", function () { return $1cec55bc6efff4dc$export$d97410bb8cd0dff; }, function (v) { return $1cec55bc6efff4dc$export$d97410bb8cd0dff = v; });
var $1cec55bc6efff4dc$export$d97410bb8cd0dff;
"use strict";
$1cec55bc6efff4dc$export$d97410bb8cd0dff = $1cec55bc6efff4dc$var$roundToNearestMinutes;

var $fosqj = parcelRequire("fosqj");

var $909bC = parcelRequire("909bC");

var $eimnm = parcelRequire("eimnm");
/**
 * The {@link roundToNearestMinutes} function options.
 */ /**
 * @name roundToNearestMinutes
 * @category Minute Helpers
 * @summary Rounds the given date to the nearest minute
 *
 * @description
 * Rounds the given date to the nearest minute (or number of minutes).
 * Rounds up when the given date is exactly between the nearest round minutes.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to round
 * @param options - An object with options.
 *
 * @returns The new date rounded to the closest minute
 *
 * @example
 * // Round 10 July 2014 12:12:34 to nearest minute:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34))
 * //=> Thu Jul 10 2014 12:13:00
 *
 * @example
 * // Round 10 July 2014 12:12:34 to nearest quarter hour:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { nearestTo: 15 })
 * //=> Thu Jul 10 2014 12:15:00
 *
 * @example
 * // Floor (rounds down) 10 July 2014 12:12:34 to nearest minute:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { roundingMethod: 'floor' })
 * //=> Thu Jul 10 2014 12:12:00
 *
 * @example
 * // Ceil (rounds up) 10 July 2014 12:12:34 to nearest half hour:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { roundingMethod: 'ceil', nearestTo: 30 })
 * //=> Thu Jul 10 2014 12:30:00
 */ function $1cec55bc6efff4dc$var$roundToNearestMinutes(date, options) {
    const nearestTo = options?.nearestTo ?? 1;
    if (nearestTo < 1 || nearestTo > 30) return (0, $909bC.constructFrom)(date, NaN);
    const _date = (0, $eimnm.toDate)(date);
    const fractionalSeconds = _date.getSeconds() / 60;
    const fractionalMilliseconds = _date.getMilliseconds() / 1000 / 60;
    const minutes = _date.getMinutes() + fractionalSeconds + fractionalMilliseconds;
    // Unlike the `differenceIn*` functions, the default rounding behavior is `round` and not 'trunc'
    const method = options?.roundingMethod ?? "round";
    const roundingMethod = (0, $fosqj.getRoundingMethod)(method);
    const roundedMinutes = roundingMethod(minutes / nearestTo) * nearestTo;
    const result = (0, $909bC.constructFrom)(date, _date);
    result.setMinutes(roundedMinutes, 0, 0);
    return result;
}

});

parcelRegister("2PZsO", function(module, exports) {

$parcel$export(module.exports, "secondsToHours", function () { return $211005971836ff15$export$47d555ff5354096f; }, function (v) { return $211005971836ff15$export$47d555ff5354096f = v; });
var $211005971836ff15$export$47d555ff5354096f;
"use strict";
$211005971836ff15$export$47d555ff5354096f = $211005971836ff15$var$secondsToHours;

var $lILKk = parcelRequire("lILKk");
/**
 * @name secondsToHours
 * @category Conversion Helpers
 * @summary Convert seconds to hours.
 *
 * @description
 * Convert a number of seconds to a full number of hours.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in hours
 *
 * @example
 * // Convert 7200 seconds into hours
 * const result = secondsToHours(7200)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = secondsToHours(7199)
 * //=> 1
 */ function $211005971836ff15$var$secondsToHours(seconds) {
    const hours = seconds / $lILKk.secondsInHour;
    return Math.trunc(hours);
}

});

parcelRegister("a0smh", function(module, exports) {

$parcel$export(module.exports, "secondsToMilliseconds", function () { return $748fe6d68ae3cf97$export$fc3e7e8557f8c8c7; }, function (v) { return $748fe6d68ae3cf97$export$fc3e7e8557f8c8c7 = v; });
var $748fe6d68ae3cf97$export$fc3e7e8557f8c8c7;
"use strict";
$748fe6d68ae3cf97$export$fc3e7e8557f8c8c7 = $748fe6d68ae3cf97$var$secondsToMilliseconds;

var $lILKk = parcelRequire("lILKk");
/**
 * @name secondsToMilliseconds
 * @category Conversion Helpers
 * @summary Convert seconds to milliseconds.
 *
 * @description
 * Convert a number of seconds to a full number of milliseconds.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in milliseconds
 *
 * @example
 * // Convert 2 seconds into milliseconds
 * const result = secondsToMilliseconds(2)
 * //=> 2000
 */ function $748fe6d68ae3cf97$var$secondsToMilliseconds(seconds) {
    return seconds * $lILKk.millisecondsInSecond;
}

});

parcelRegister("8sieT", function(module, exports) {

$parcel$export(module.exports, "secondsToMinutes", function () { return $627f163091973fbc$export$ed657adb62398e99; }, function (v) { return $627f163091973fbc$export$ed657adb62398e99 = v; });
var $627f163091973fbc$export$ed657adb62398e99;
"use strict";
$627f163091973fbc$export$ed657adb62398e99 = $627f163091973fbc$var$secondsToMinutes;

var $lILKk = parcelRequire("lILKk");
/**
 * @name secondsToMinutes
 * @category Conversion Helpers
 * @summary Convert seconds to minutes.
 *
 * @description
 * Convert a number of seconds to a full number of minutes.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in minutes
 *
 * @example
 * // Convert 120 seconds into minutes
 * const result = secondsToMinutes(120)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = secondsToMinutes(119)
 * //=> 1
 */ function $627f163091973fbc$var$secondsToMinutes(seconds) {
    const minutes = seconds / $lILKk.secondsInMinute;
    return Math.trunc(minutes);
}

});

parcelRegister("krIdQ", function(module, exports) {

$parcel$export(module.exports, "set", function () { return $ee28a1e18ccc6dbb$export$adaa4cf7ef1b65be; }, function (v) { return $ee28a1e18ccc6dbb$export$adaa4cf7ef1b65be = v; });
var $ee28a1e18ccc6dbb$export$adaa4cf7ef1b65be;
"use strict";
$ee28a1e18ccc6dbb$export$adaa4cf7ef1b65be = $ee28a1e18ccc6dbb$var$set;

var $909bC = parcelRequire("909bC");

var $6gk9p = parcelRequire("6gk9p");

var $eimnm = parcelRequire("eimnm");
/**
 * @name set
 * @category Common Helpers
 * @summary Set date values to a given date.
 *
 * @description
 * Set date values to a given date.
 *
 * Sets time values to date from object `values`.
 * A value is not set if it is undefined or null or doesn't exist in `values`.
 *
 * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
 * to use native `Date#setX` methods. If you use this function, you may not want to include the
 * other `setX` functions that date-fns provides if you are concerned about the bundle size.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param values - The date values to be set
 *
 * @returns The new date with options set
 *
 * @example
 * // Transform 1 September 2014 into 20 October 2015 in a single line:
 * const result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
 * //=> Tue Oct 20 2015 00:00:00
 *
 * @example
 * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
 * const result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
 * //=> Mon Sep 01 2014 12:23:45
 */ function $ee28a1e18ccc6dbb$var$set(date, values) {
    let _date = (0, $eimnm.toDate)(date);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+_date)) return (0, $909bC.constructFrom)(date, NaN);
    if (values.year != null) _date.setFullYear(values.year);
    if (values.month != null) _date = (0, $6gk9p.setMonth)(_date, values.month);
    if (values.date != null) _date.setDate(values.date);
    if (values.hours != null) _date.setHours(values.hours);
    if (values.minutes != null) _date.setMinutes(values.minutes);
    if (values.seconds != null) _date.setSeconds(values.seconds);
    if (values.milliseconds != null) _date.setMilliseconds(values.milliseconds);
    return _date;
}

});
parcelRegister("6gk9p", function(module, exports) {

$parcel$export(module.exports, "setMonth", function () { return $48f3de36d0e066b8$export$63264690f8e36790; }, function (v) { return $48f3de36d0e066b8$export$63264690f8e36790 = v; });
var $48f3de36d0e066b8$export$63264690f8e36790;
"use strict";
$48f3de36d0e066b8$export$63264690f8e36790 = $48f3de36d0e066b8$var$setMonth;

var $909bC = parcelRequire("909bC");

var $4bDiJ = parcelRequire("4bDiJ");

var $eimnm = parcelRequire("eimnm");
/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param month - The month index to set (0-11)
 *
 * @returns The new date with the month set
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */ function $48f3de36d0e066b8$var$setMonth(date, month) {
    const _date = (0, $eimnm.toDate)(date);
    const year = _date.getFullYear();
    const day = _date.getDate();
    const dateWithDesiredMonth = (0, $909bC.constructFrom)(date, 0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    const daysInMonth = (0, $4bDiJ.getDaysInMonth)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    _date.setMonth(month, Math.min(day, daysInMonth));
    return _date;
}

});


parcelRegister("7JF2D", function(module, exports) {

$parcel$export(module.exports, "setDate", function () { return $5a1c9255d40788d7$export$566174fa40823587; }, function (v) { return $5a1c9255d40788d7$export$566174fa40823587 = v; });
var $5a1c9255d40788d7$export$566174fa40823587;
"use strict";
$5a1c9255d40788d7$export$566174fa40823587 = $5a1c9255d40788d7$var$setDate;

var $eimnm = parcelRequire("eimnm");
/**
 * @name setDate
 * @category Day Helpers
 * @summary Set the day of the month to the given date.
 *
 * @description
 * Set the day of the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param dayOfMonth - The day of the month of the new date
 *
 * @returns The new date with the day of the month set
 *
 * @example
 * // Set the 30th day of the month to 1 September 2014:
 * const result = setDate(new Date(2014, 8, 1), 30)
 * //=> Tue Sep 30 2014 00:00:00
 */ function $5a1c9255d40788d7$var$setDate(date, dayOfMonth) {
    const _date = (0, $eimnm.toDate)(date);
    _date.setDate(dayOfMonth);
    return _date;
}

});

parcelRegister("cCrt0", function(module, exports) {

$parcel$export(module.exports, "setDayOfYear", function () { return $92fe56ff19d3c7a1$export$2af590ffc7e7d7c5; }, function (v) { return $92fe56ff19d3c7a1$export$2af590ffc7e7d7c5 = v; });
var $92fe56ff19d3c7a1$export$2af590ffc7e7d7c5;
"use strict";
$92fe56ff19d3c7a1$export$2af590ffc7e7d7c5 = $92fe56ff19d3c7a1$var$setDayOfYear;

var $eimnm = parcelRequire("eimnm");
/**
 * @name setDayOfYear
 * @category Day Helpers
 * @summary Set the day of the year to the given date.
 *
 * @description
 * Set the day of the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param dayOfYear - The day of the year of the new date
 *
 * @returns The new date with the day of the year set
 *
 * @example
 * // Set the 2nd day of the year to 2 July 2014:
 * const result = setDayOfYear(new Date(2014, 6, 2), 2)
 * //=> Thu Jan 02 2014 00:00:00
 */ function $92fe56ff19d3c7a1$var$setDayOfYear(date, dayOfYear) {
    const _date = (0, $eimnm.toDate)(date);
    _date.setMonth(0);
    _date.setDate(dayOfYear);
    return _date;
}

});

parcelRegister("gtcKN", function(module, exports) {

$parcel$export(module.exports, "setDefaultOptions", function () { return $bfd93f63bb1bb34d$export$95365be1b0704abc; }, function (v) { return $bfd93f63bb1bb34d$export$95365be1b0704abc = v; });
var $bfd93f63bb1bb34d$export$95365be1b0704abc;
"use strict";
$bfd93f63bb1bb34d$export$95365be1b0704abc = $bfd93f63bb1bb34d$var$setDefaultOptions;

var $hIOa6 = parcelRequire("hIOa6");
/**
 * @name setDefaultOptions
 * @category Common Helpers
 * @summary Set default options including locale.
 * @pure false
 *
 * @description
 * Sets the defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * @param options - An object with options
 *
 * @example
 * // Set global locale:
 * import { es } from 'date-fns/locale'
 * setDefaultOptions({ locale: es })
 * const result = format(new Date(2014, 8, 2), 'PPPP')
 * //=> 'martes, 2 de septiembre de 2014'
 *
 * @example
 * // Start of the week for 2 September 2014:
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Start of the week for 2 September 2014,
 * // when we set that week starts on Monday by default:
 * setDefaultOptions({ weekStartsOn: 1 })
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Mon Sep 01 2014 00:00:00
 *
 * @example
 * // Manually set options take priority over default options:
 * setDefaultOptions({ weekStartsOn: 1 })
 * const result = startOfWeek(new Date(2014, 8, 2), { weekStartsOn: 0 })
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Remove the option by setting it to `undefined`:
 * setDefaultOptions({ weekStartsOn: 1 })
 * setDefaultOptions({ weekStartsOn: undefined })
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Sun Aug 31 2014 00:00:00
 */ function $bfd93f63bb1bb34d$var$setDefaultOptions(options) {
    const result = {};
    const defaultOptions = (0, $hIOa6.getDefaultOptions)();
    for(const property in defaultOptions)if (Object.prototype.hasOwnProperty.call(defaultOptions, property)) // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
    result[property] = defaultOptions[property];
    for(const property in options)if (Object.prototype.hasOwnProperty.call(options, property)) {
        if (options[property] === undefined) // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        delete result[property];
        else // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        result[property] = options[property];
    }
    (0, $hIOa6.setDefaultOptions)(result);
}

});

parcelRegister("i4JoG", function(module, exports) {

$parcel$export(module.exports, "setHours", function () { return $d28bd0a331931fea$export$f86b797a4659b781; }, function (v) { return $d28bd0a331931fea$export$f86b797a4659b781 = v; });
var $d28bd0a331931fea$export$f86b797a4659b781;
"use strict";
$d28bd0a331931fea$export$f86b797a4659b781 = $d28bd0a331931fea$var$setHours;

var $eimnm = parcelRequire("eimnm");
/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param hours - The hours of the new date
 *
 * @returns The new date with the hours set
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * const result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */ function $d28bd0a331931fea$var$setHours(date, hours) {
    const _date = (0, $eimnm.toDate)(date);
    _date.setHours(hours);
    return _date;
}

});

parcelRegister("aGrbt", function(module, exports) {

$parcel$export(module.exports, "setMilliseconds", function () { return $7c72e9cc5ef1cb7f$export$de5664029b35e06d; }, function (v) { return $7c72e9cc5ef1cb7f$export$de5664029b35e06d = v; });
var $7c72e9cc5ef1cb7f$export$de5664029b35e06d;
"use strict";
$7c72e9cc5ef1cb7f$export$de5664029b35e06d = $7c72e9cc5ef1cb7f$var$setMilliseconds;

var $eimnm = parcelRequire("eimnm");
/**
 * @name setMilliseconds
 * @category Millisecond Helpers
 * @summary Set the milliseconds to the given date.
 *
 * @description
 * Set the milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param milliseconds - The milliseconds of the new date
 *
 * @returns The new date with the milliseconds set
 *
 * @example
 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
 * const result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
 * //=> Mon Sep 01 2014 11:30:40.300
 */ function $7c72e9cc5ef1cb7f$var$setMilliseconds(date, milliseconds) {
    const _date = (0, $eimnm.toDate)(date);
    _date.setMilliseconds(milliseconds);
    return _date;
}

});

parcelRegister("gt7Pi", function(module, exports) {

$parcel$export(module.exports, "setMinutes", function () { return $bfd56cf348e0413f$export$ad569bf1c79ea89d; }, function (v) { return $bfd56cf348e0413f$export$ad569bf1c79ea89d = v; });
var $bfd56cf348e0413f$export$ad569bf1c79ea89d;
"use strict";
$bfd56cf348e0413f$export$ad569bf1c79ea89d = $bfd56cf348e0413f$var$setMinutes;

var $eimnm = parcelRequire("eimnm");
/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param minutes - The minutes of the new date
 *
 * @returns The new date with the minutes set
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */ function $bfd56cf348e0413f$var$setMinutes(date, minutes) {
    const _date = (0, $eimnm.toDate)(date);
    _date.setMinutes(minutes);
    return _date;
}

});

parcelRegister("htHLT", function(module, exports) {

$parcel$export(module.exports, "setQuarter", function () { return $cb9719332e51a7a9$export$8924d1de7efe1755; }, function (v) { return $cb9719332e51a7a9$export$8924d1de7efe1755 = v; });
var $cb9719332e51a7a9$export$8924d1de7efe1755;
"use strict";
$cb9719332e51a7a9$export$8924d1de7efe1755 = $cb9719332e51a7a9$var$setQuarter;

var $6gk9p = parcelRequire("6gk9p");

var $eimnm = parcelRequire("eimnm");
/**
 * @name setQuarter
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param quarter - The quarter of the new date
 *
 * @returns The new date with the quarter set
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * const result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */ function $cb9719332e51a7a9$var$setQuarter(date, quarter) {
    const _date = (0, $eimnm.toDate)(date);
    const oldQuarter = Math.trunc(_date.getMonth() / 3) + 1;
    const diff = quarter - oldQuarter;
    return (0, $6gk9p.setMonth)(_date, _date.getMonth() + diff * 3);
}

});

parcelRegister("ltIzu", function(module, exports) {

$parcel$export(module.exports, "setSeconds", function () { return $fa2ee15726a372f3$export$aec44746644cbf43; }, function (v) { return $fa2ee15726a372f3$export$aec44746644cbf43 = v; });
var $fa2ee15726a372f3$export$aec44746644cbf43;
"use strict";
$fa2ee15726a372f3$export$aec44746644cbf43 = $fa2ee15726a372f3$var$setSeconds;

var $eimnm = parcelRequire("eimnm");
/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param seconds - The seconds of the new date
 *
 * @returns The new date with the seconds set
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */ function $fa2ee15726a372f3$var$setSeconds(date, seconds) {
    const _date = (0, $eimnm.toDate)(date);
    _date.setSeconds(seconds);
    return _date;
}

});

parcelRegister("4n3cB", function(module, exports) {

$parcel$export(module.exports, "setWeekYear", function () { return $32ebcb4f31de99d1$export$4340968d5939835e; }, function (v) { return $32ebcb4f31de99d1$export$4340968d5939835e = v; });
var $32ebcb4f31de99d1$export$4340968d5939835e;
"use strict";
$32ebcb4f31de99d1$export$4340968d5939835e = $32ebcb4f31de99d1$var$setWeekYear;

var $909bC = parcelRequire("909bC");

var $ctsEq = parcelRequire("ctsEq");

var $1gSjC = parcelRequire("1gSjC");

var $eimnm = parcelRequire("eimnm");

var $hIOa6 = parcelRequire("hIOa6");
/**
 * The {@link setWeekYear} function options.
 */ /**
 * @name setWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Set the local week-numbering year to the given date.
 *
 * @description
 * Set the local week-numbering year to the given date,
 * saving the week number and the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param weekYear - The local week-numbering year of the new date
 * @param options - An object with options
 *
 * @returns The new date with the local week-numbering year set
 *
 * @example
 * // Set the local week-numbering year 2004 to 2 January 2010 with default options:
 * const result = setWeekYear(new Date(2010, 0, 2), 2004)
 * //=> Sat Jan 03 2004 00:00:00
 *
 * @example
 * // Set the local week-numbering year 2004 to 2 January 2010,
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = setWeekYear(new Date(2010, 0, 2), 2004, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sat Jan 01 2005 00:00:00
 */ function $32ebcb4f31de99d1$var$setWeekYear(date, weekYear, options) {
    const defaultOptions = (0, $hIOa6.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    let _date = (0, $eimnm.toDate)(date);
    const diff = (0, $ctsEq.differenceInCalendarDays)(_date, (0, $1gSjC.startOfWeekYear)(_date, options));
    const firstWeek = (0, $909bC.constructFrom)(date, 0);
    firstWeek.setFullYear(weekYear, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    _date = (0, $1gSjC.startOfWeekYear)(firstWeek, options);
    _date.setDate(_date.getDate() + diff);
    return _date;
}

});

parcelRegister("4KAWB", function(module, exports) {

$parcel$export(module.exports, "setYear", function () { return $37581dac9c4660cf$export$a8408b6c5639cab7; }, function (v) { return $37581dac9c4660cf$export$a8408b6c5639cab7 = v; });
var $37581dac9c4660cf$export$a8408b6c5639cab7;
"use strict";
$37581dac9c4660cf$export$a8408b6c5639cab7 = $37581dac9c4660cf$var$setYear;

var $909bC = parcelRequire("909bC");

var $eimnm = parcelRequire("eimnm");
/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param year - The year of the new date
 *
 * @returns The new date with the year set
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */ function $37581dac9c4660cf$var$setYear(date, year) {
    const _date = (0, $eimnm.toDate)(date);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+_date)) return (0, $909bC.constructFrom)(date, NaN);
    _date.setFullYear(year);
    return _date;
}

});

parcelRegister("4QlNi", function(module, exports) {

$parcel$export(module.exports, "startOfDecade", function () { return $386cec9d4c31ef03$export$730492981c634308; }, function (v) { return $386cec9d4c31ef03$export$730492981c634308 = v; });
var $386cec9d4c31ef03$export$730492981c634308;
"use strict";
$386cec9d4c31ef03$export$730492981c634308 = $386cec9d4c31ef03$var$startOfDecade;

var $eimnm = parcelRequire("eimnm");
/**
 * @name startOfDecade
 * @category Decade Helpers
 * @summary Return the start of a decade for the given date.
 *
 * @description
 * Return the start of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a decade
 *
 * @example
 * // The start of a decade for 21 October 2015 00:00:00:
 * const result = startOfDecade(new Date(2015, 9, 21, 00, 00, 00))
 * //=> Jan 01 2010 00:00:00
 */ function $386cec9d4c31ef03$var$startOfDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $eimnm.toDate)(date);
    const year = _date.getFullYear();
    const decade = Math.floor(year / 10) * 10;
    _date.setFullYear(decade, 0, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("eE71H", function(module, exports) {

$parcel$export(module.exports, "startOfToday", function () { return $aa9a406ddaec1032$export$444d742fd5a45a57; }, function (v) { return $aa9a406ddaec1032$export$444d742fd5a45a57 = v; });
var $aa9a406ddaec1032$export$444d742fd5a45a57;
"use strict";
$aa9a406ddaec1032$export$444d742fd5a45a57 = $aa9a406ddaec1032$var$startOfToday;

var $klJi0 = parcelRequire("klJi0");
/**
 * @name startOfToday
 * @category Day Helpers
 * @summary Return the start of today.
 * @pure false
 *
 * @description
 * Return the start of today.
 *
 * @returns The start of today
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfToday()
 * //=> Mon Oct 6 2014 00:00:00
 */ function $aa9a406ddaec1032$var$startOfToday() {
    return (0, $klJi0.startOfDay)(Date.now());
}

});

parcelRegister("i0iIq", function(module, exports) {

$parcel$export(module.exports, "startOfTomorrow", function () { return $d1b6be94785a97b7$export$7e8566c79d5bee07; }, function (v) { return $d1b6be94785a97b7$export$7e8566c79d5bee07 = v; });
var $d1b6be94785a97b7$export$7e8566c79d5bee07;
"use strict";
$d1b6be94785a97b7$export$7e8566c79d5bee07 = $d1b6be94785a97b7$var$startOfTomorrow; /**
 * @name startOfTomorrow
 * @category Day Helpers
 * @summary Return the start of tomorrow.
 * @pure false
 *
 * @description
 * Return the start of tomorrow.
 *
 * @returns The start of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfTomorrow()
 * //=> Tue Oct 7 2014 00:00:00
 */ 
function $d1b6be94785a97b7$var$startOfTomorrow() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day + 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("4W4ZT", function(module, exports) {

$parcel$export(module.exports, "startOfYesterday", function () { return $39807492504d791d$export$23a16f3c6d143ce9; }, function (v) { return $39807492504d791d$export$23a16f3c6d143ce9 = v; });
var $39807492504d791d$export$23a16f3c6d143ce9;
"use strict";
$39807492504d791d$export$23a16f3c6d143ce9 = $39807492504d791d$var$startOfYesterday; /**
 * @name startOfYesterday
 * @category Day Helpers
 * @summary Return the start of yesterday.
 * @pure false
 *
 * @description
 * Return the start of yesterday.
 *
 * @returns The start of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfYesterday()
 * //=> Sun Oct 5 2014 00:00:00
 */ 
function $39807492504d791d$var$startOfYesterday() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day - 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("iLRNz", function(module, exports) {

$parcel$export(module.exports, "sub", function () { return $daa65907df3df622$export$f93b5905241a7cca; }, function (v) { return $daa65907df3df622$export$f93b5905241a7cca = v; });
var $daa65907df3df622$export$f93b5905241a7cca;
"use strict";
$daa65907df3df622$export$f93b5905241a7cca = $daa65907df3df622$var$sub;

var $5ZlCI = parcelRequire("5ZlCI");

var $jIANP = parcelRequire("jIANP");

var $909bC = parcelRequire("909bC");
/**
 * @name sub
 * @category Common Helpers
 * @summary Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @description
 * Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be subtracted
 *
 * | Key     | Description                        |
 * |---------|------------------------------------|
 * | years   | Amount of years to be subtracted   |
 * | months  | Amount of months to be subtracted  |
 * | weeks   | Amount of weeks to be subtracted   |
 * | days    | Amount of days to be subtracted    |
 * | hours   | Amount of hours to be subtracted   |
 * | minutes | Amount of minutes to be subtracted |
 * | seconds | Amount of seconds to be subtracted |
 *
 * All values default to 0
 *
 * @returns The new date with the seconds subtracted
 *
 * @example
 * // Subtract the following duration from 15 June 2017 15:29:20
 * const result = sub(new Date(2017, 5, 15, 15, 29, 20), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> Mon Sep 1 2014 10:19:50
 */ function $daa65907df3df622$var$sub(date, duration) {
    const { years: years = 0, months: months = 0, weeks: weeks = 0, days: days = 0, hours: hours = 0, minutes: minutes = 0, seconds: seconds = 0 } = duration;
    // Subtract years and months
    const dateWithoutMonths = (0, $jIANP.subMonths)(date, months + years * 12);
    // Subtract weeks and days
    const dateWithoutDays = (0, $5ZlCI.subDays)(dateWithoutMonths, days + weeks * 7);
    // Subtract hours, minutes and seconds
    const minutestoSub = minutes + hours * 60;
    const secondstoSub = seconds + minutestoSub * 60;
    const mstoSub = secondstoSub * 1000;
    const finalDate = (0, $909bC.constructFrom)(date, dateWithoutDays.getTime() - mstoSub);
    return finalDate;
}

});
parcelRegister("jIANP", function(module, exports) {

$parcel$export(module.exports, "subMonths", function () { return $e5aeaca0bcc14069$export$73d1c15a21f9fae5; }, function (v) { return $e5aeaca0bcc14069$export$73d1c15a21f9fae5 = v; });
var $e5aeaca0bcc14069$export$73d1c15a21f9fae5;
"use strict";
$e5aeaca0bcc14069$export$73d1c15a21f9fae5 = $e5aeaca0bcc14069$var$subMonths;

var $cp3zA = parcelRequire("cp3zA");
/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be subtracted.
 *
 * @returns The new date with the months subtracted
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */ function $e5aeaca0bcc14069$var$subMonths(date, amount) {
    return (0, $cp3zA.addMonths)(date, -amount);
}

});


parcelRegister("80qQC", function(module, exports) {

$parcel$export(module.exports, "subBusinessDays", function () { return $5d43263ac7e86179$export$e5cc51ae28664a93; }, function (v) { return $5d43263ac7e86179$export$e5cc51ae28664a93 = v; });
var $5d43263ac7e86179$export$e5cc51ae28664a93;
"use strict";
$5d43263ac7e86179$export$e5cc51ae28664a93 = $5d43263ac7e86179$var$subBusinessDays;

var $cWl2g = parcelRequire("cWl2g");
/**
 * @name subBusinessDays
 * @category Day Helpers
 * @summary Substract the specified number of business days (mon - fri) to the given date.
 *
 * @description
 * Substract the specified number of business days (mon - fri) to the given date, ignoring weekends.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of business days to be subtracted.
 *
 * @returns The new date with the business days subtracted
 *
 * @example
 * // Substract 10 business days from 1 September 2014:
 * const result = subBusinessDays(new Date(2014, 8, 1), 10)
 * //=> Mon Aug 18 2014 00:00:00 (skipped weekend days)
 */ function $5d43263ac7e86179$var$subBusinessDays(date, amount) {
    return (0, $cWl2g.addBusinessDays)(date, -amount);
}

});

parcelRegister("cgiOl", function(module, exports) {

$parcel$export(module.exports, "subHours", function () { return $8ed5921d57212a8d$export$5e9fa51cd5bb1e71; }, function (v) { return $8ed5921d57212a8d$export$5e9fa51cd5bb1e71 = v; });
var $8ed5921d57212a8d$export$5e9fa51cd5bb1e71;
"use strict";
$8ed5921d57212a8d$export$5e9fa51cd5bb1e71 = $8ed5921d57212a8d$var$subHours;

var $lTL64 = parcelRequire("lTL64");
/**
 * @name subHours
 * @category Hour Helpers
 * @summary Subtract the specified number of hours from the given date.
 *
 * @description
 * Subtract the specified number of hours from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of hours to be subtracted.
 *
 * @returns The new date with the hours subtracted
 *
 * @example
 * // Subtract 2 hours from 11 July 2014 01:00:00:
 * const result = subHours(new Date(2014, 6, 11, 1, 0), 2)
 * //=> Thu Jul 10 2014 23:00:00
 */ function $8ed5921d57212a8d$var$subHours(date, amount) {
    return (0, $lTL64.addHours)(date, -amount);
}

});

parcelRegister("kpBOo", function(module, exports) {

$parcel$export(module.exports, "subMilliseconds", function () { return $edc3790ea6af0a7a$export$5abaf57ab8e91640; }, function (v) { return $edc3790ea6af0a7a$export$5abaf57ab8e91640 = v; });
var $edc3790ea6af0a7a$export$5abaf57ab8e91640;
"use strict";
$edc3790ea6af0a7a$export$5abaf57ab8e91640 = $edc3790ea6af0a7a$var$subMilliseconds;

var $cqs47 = parcelRequire("cqs47");
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of milliseconds to be subtracted.
 *
 * @returns The new date with the milliseconds subtracted
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */ function $edc3790ea6af0a7a$var$subMilliseconds(date, amount) {
    return (0, $cqs47.addMilliseconds)(date, -amount);
}

});

parcelRegister("cAnAD", function(module, exports) {

$parcel$export(module.exports, "subMinutes", function () { return $929b254a0b23b4b7$export$e12a970efb73fce5; }, function (v) { return $929b254a0b23b4b7$export$e12a970efb73fce5 = v; });
var $929b254a0b23b4b7$export$e12a970efb73fce5;
"use strict";
$929b254a0b23b4b7$export$e12a970efb73fce5 = $929b254a0b23b4b7$var$subMinutes;

var $h7zV9 = parcelRequire("h7zV9");
/**
 * @name subMinutes
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be subtracted.
 *
 * @returns The new date with the minutes subtracted
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * const result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */ function $929b254a0b23b4b7$var$subMinutes(date, amount) {
    return (0, $h7zV9.addMinutes)(date, -amount);
}

});

parcelRegister("3GXJQ", function(module, exports) {

$parcel$export(module.exports, "subQuarters", function () { return $2b03a22977d1f0b2$export$a31bfeeeee80cce6; }, function (v) { return $2b03a22977d1f0b2$export$a31bfeeeee80cce6 = v; });
var $2b03a22977d1f0b2$export$a31bfeeeee80cce6;
"use strict";
$2b03a22977d1f0b2$export$a31bfeeeee80cce6 = $2b03a22977d1f0b2$var$subQuarters;

var $7pM9n = parcelRequire("7pM9n");
/**
 * @name subQuarters
 * @category Quarter Helpers
 * @summary Subtract the specified number of year quarters from the given date.
 *
 * @description
 * Subtract the specified number of year quarters from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of quarters to be subtracted.
 *
 * @returns The new date with the quarters subtracted
 *
 * @example
 * // Subtract 3 quarters from 1 September 2014:
 * const result = subQuarters(new Date(2014, 8, 1), 3)
 * //=> Sun Dec 01 2013 00:00:00
 */ function $2b03a22977d1f0b2$var$subQuarters(date, amount) {
    return (0, $7pM9n.addQuarters)(date, -amount);
}

});

parcelRegister("aI2Hd", function(module, exports) {

$parcel$export(module.exports, "subSeconds", function () { return $7cc01ad1362349c2$export$e95d8ad9981db689; }, function (v) { return $7cc01ad1362349c2$export$e95d8ad9981db689 = v; });
var $7cc01ad1362349c2$export$e95d8ad9981db689;
"use strict";
$7cc01ad1362349c2$export$e95d8ad9981db689 = $7cc01ad1362349c2$var$subSeconds;

var $boFoj = parcelRequire("boFoj");
/**
 * @name subSeconds
 * @category Second Helpers
 * @summary Subtract the specified number of seconds from the given date.
 *
 * @description
 * Subtract the specified number of seconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of seconds to be subtracted.
 *
 * @returns The new date with the seconds subtracted
 *
 * @example
 * // Subtract 30 seconds from 10 July 2014 12:45:00:
 * const result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:44:30
 */ function $7cc01ad1362349c2$var$subSeconds(date, amount) {
    return (0, $boFoj.addSeconds)(date, -amount);
}

});

parcelRegister("5OqIL", function(module, exports) {

$parcel$export(module.exports, "subWeeks", function () { return $43b6597906aa9cf8$export$b4d8ae6376193efb; }, function (v) { return $43b6597906aa9cf8$export$b4d8ae6376193efb = v; });
var $43b6597906aa9cf8$export$b4d8ae6376193efb;
"use strict";
$43b6597906aa9cf8$export$b4d8ae6376193efb = $43b6597906aa9cf8$var$subWeeks;

var $6T9jK = parcelRequire("6T9jK");
/**
 * @name subWeeks
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be subtracted.
 *
 * @returns The new date with the weeks subtracted
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * const result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */ function $43b6597906aa9cf8$var$subWeeks(date, amount) {
    return (0, $6T9jK.addWeeks)(date, -amount);
}

});

parcelRegister("frPfZ", function(module, exports) {

$parcel$export(module.exports, "subYears", function () { return $b3f1232dc2869296$export$14867687ff6c92e2; }, function (v) { return $b3f1232dc2869296$export$14867687ff6c92e2 = v; });
var $b3f1232dc2869296$export$14867687ff6c92e2;
"use strict";
$b3f1232dc2869296$export$14867687ff6c92e2 = $b3f1232dc2869296$var$subYears;

var $1afNH = parcelRequire("1afNH");
/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be subtracted.
 *
 * @returns The new date with the years subtracted
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * const result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */ function $b3f1232dc2869296$var$subYears(date, amount) {
    return (0, $1afNH.addYears)(date, -amount);
}

});

parcelRegister("2jJKo", function(module, exports) {

$parcel$export(module.exports, "weeksToDays", function () { return $1b00d791fdfe3bc0$export$b696b6eeb89501ad; }, function (v) { return $1b00d791fdfe3bc0$export$b696b6eeb89501ad = v; });
var $1b00d791fdfe3bc0$export$b696b6eeb89501ad;
"use strict";
$1b00d791fdfe3bc0$export$b696b6eeb89501ad = $1b00d791fdfe3bc0$var$weeksToDays;

var $lILKk = parcelRequire("lILKk");
/**
 * @name weeksToDays
 * @category Conversion Helpers
 * @summary Convert weeks to days.
 *
 * @description
 * Convert a number of weeks to a full number of days.
 *
 * @param weeks - The number of weeks to be converted
 *
 * @returns The number of weeks converted in days
 *
 * @example
 * // Convert 2 weeks into days
 * const result = weeksToDays(2)
 * //=> 14
 */ function $1b00d791fdfe3bc0$var$weeksToDays(weeks) {
    return Math.trunc(weeks * $lILKk.daysInWeek);
}

});

parcelRegister("iK4so", function(module, exports) {

$parcel$export(module.exports, "yearsToDays", function () { return $da4ffaf2308b8d55$export$862cb7b6e45c3b17; }, function (v) { return $da4ffaf2308b8d55$export$862cb7b6e45c3b17 = v; });
var $da4ffaf2308b8d55$export$862cb7b6e45c3b17;
"use strict";
$da4ffaf2308b8d55$export$862cb7b6e45c3b17 = $da4ffaf2308b8d55$var$yearsToDays;

var $lILKk = parcelRequire("lILKk");
/**
 * @name yearsToDays
 * @category Conversion Helpers
 * @summary Convert years to days.
 *
 * @description
 * Convert a number of years to a full number of days.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in days
 *
 * @example
 * // Convert 2 years into days
 * const result = yearsToDays(2)
 * //=> 730
 */ function $da4ffaf2308b8d55$var$yearsToDays(years) {
    return Math.trunc(years * $lILKk.daysInYear);
}

});

parcelRegister("4cORp", function(module, exports) {

$parcel$export(module.exports, "yearsToMonths", function () { return $30ffbc3bc56661ec$export$894abb0747b9a00; }, function (v) { return $30ffbc3bc56661ec$export$894abb0747b9a00 = v; });
var $30ffbc3bc56661ec$export$894abb0747b9a00;
"use strict";
$30ffbc3bc56661ec$export$894abb0747b9a00 = $30ffbc3bc56661ec$var$yearsToMonths;

var $lILKk = parcelRequire("lILKk");
/**
 * @name yearsToMonths
 * @category Conversion Helpers
 * @summary Convert years to months.
 *
 * @description
 * Convert a number of years to a full number of months.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in months
 *
 * @example
 * // Convert 2 years into months
 * const result = yearsToMonths(2)
 * //=> 24
 */ function $30ffbc3bc56661ec$var$yearsToMonths(years) {
    return Math.trunc(years * $lILKk.monthsInYear);
}

});

parcelRegister("irYsc", function(module, exports) {

$parcel$export(module.exports, "yearsToQuarters", function () { return $d6e9a47f8a4bf3ff$export$ab26576e5e7379d7; }, function (v) { return $d6e9a47f8a4bf3ff$export$ab26576e5e7379d7 = v; });
var $d6e9a47f8a4bf3ff$export$ab26576e5e7379d7;
"use strict";
$d6e9a47f8a4bf3ff$export$ab26576e5e7379d7 = $d6e9a47f8a4bf3ff$var$yearsToQuarters;

var $lILKk = parcelRequire("lILKk");
/**
 * @name yearsToQuarters
 * @category Conversion Helpers
 * @summary Convert years to quarters.
 *
 * @description
 * Convert a number of years to a full number of quarters.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in quarters
 *
 * @example
 * // Convert 2 years to quarters
 * const result = yearsToQuarters(2)
 * //=> 8
 */ function $d6e9a47f8a4bf3ff$var$yearsToQuarters(years) {
    return Math.trunc(years * $lILKk.quartersInYear);
}

});


parcelRegister("fopU6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b34d30dbca1f70ee$export$2e2bcd8739ae039; });

var $ikffN = parcelRequire("ikffN");
function $b34d30dbca1f70ee$var$_defineProperty(e, r, t) {
    return (r = $b34d30dbca1f70ee$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $b34d30dbca1f70ee$var$_toPropertyKey(t) {
    var i = $b34d30dbca1f70ee$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $b34d30dbca1f70ee$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

class $b34d30dbca1f70ee$var$HistoryEvent {
    constructor(parentModel, event){
        $b34d30dbca1f70ee$var$_defineProperty(this, "model", null);
        $b34d30dbca1f70ee$var$_defineProperty(this, "timestamp", null);
        $b34d30dbca1f70ee$var$_defineProperty(this, "userId", null);
        $b34d30dbca1f70ee$var$_defineProperty(this, "field", null);
        $b34d30dbca1f70ee$var$_defineProperty(this, "value", null);
        this.model = parentModel;
        this.timestamp = event.timestamp;
        this.userId = event.userId;
        this.field = event.field;
        this.value = event.value;
    }
    get modelLabel() {
        return this.model.title;
    }
    get date() {
        return new Date(this.timestamp);
    }
    get user() {
        const StaffCollection = (parcelRequire("htkeB")).default;
        return StaffCollection.staffsById[this.userId];
    }
    get fieldLabel() {
        return (0, $ikffN.capitalCase)(this.field);
    }
}
var $b34d30dbca1f70ee$export$2e2bcd8739ae039 = $b34d30dbca1f70ee$var$HistoryEvent;

});
parcelRegister("ikffN", function(module, exports) {

$parcel$export(module.exports, "capitalCase", function () { return $d575ed5494b0263b$export$7fed55d4315c6715; });

var $53oVd = parcelRequire("53oVd");

var $grTX0 = parcelRequire("grTX0");

var $g7Kj9 = parcelRequire("g7Kj9");
function $d575ed5494b0263b$export$2a6bd1f4c244c979(input) {
    return (0, $g7Kj9.upperCaseFirst)(input.toLowerCase());
}
function $d575ed5494b0263b$export$7fed55d4315c6715(input, options) {
    if (options === void 0) options = {};
    return (0, $grTX0.noCase)(input, (0, $53oVd.__assign)({
        delimiter: " ",
        transform: $d575ed5494b0263b$export$2a6bd1f4c244c979
    }, options));
}

});
parcelRegister("53oVd", function(module, exports) {

$parcel$export(module.exports, "__assign", function () { return $3ae0907ebea4b968$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $3ae0907ebea4b968$export$3c9a16f847548506; });
$parcel$export(module.exports, "__spreadArray", function () { return $3ae0907ebea4b968$export$1216008129fb82ed; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $3ae0907ebea4b968$var$extendStatics = function(d, b) {
    $3ae0907ebea4b968$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $3ae0907ebea4b968$var$extendStatics(d, b);
};
function $3ae0907ebea4b968$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $3ae0907ebea4b968$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $3ae0907ebea4b968$export$18ce0697a983be9b = function() {
    $3ae0907ebea4b968$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3ae0907ebea4b968$export$18ce0697a983be9b.apply(this, arguments);
};
function $3ae0907ebea4b968$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $3ae0907ebea4b968$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $3ae0907ebea4b968$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $3ae0907ebea4b968$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $3ae0907ebea4b968$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $3ae0907ebea4b968$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $3ae0907ebea4b968$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $3ae0907ebea4b968$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $3ae0907ebea4b968$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $3ae0907ebea4b968$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $3ae0907ebea4b968$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $3ae0907ebea4b968$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $3ae0907ebea4b968$export$45d3717a4c69092e(o, m, p);
}
function $3ae0907ebea4b968$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $3ae0907ebea4b968$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $3ae0907ebea4b968$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($3ae0907ebea4b968$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $3ae0907ebea4b968$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $3ae0907ebea4b968$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $3ae0907ebea4b968$export$10c90e4f7922046c(v) {
    return this instanceof $3ae0907ebea4b968$export$10c90e4f7922046c ? (this.v = v, this) : new $3ae0907ebea4b968$export$10c90e4f7922046c(v);
}
function $3ae0907ebea4b968$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $3ae0907ebea4b968$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $3ae0907ebea4b968$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $3ae0907ebea4b968$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $3ae0907ebea4b968$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $3ae0907ebea4b968$export$19a8beecd37a4c45 === "function" ? $3ae0907ebea4b968$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $3ae0907ebea4b968$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $3ae0907ebea4b968$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $3ae0907ebea4b968$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3ae0907ebea4b968$export$45d3717a4c69092e(result, mod, k);
    }
    $3ae0907ebea4b968$var$__setModuleDefault(result, mod);
    return result;
}
function $3ae0907ebea4b968$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $3ae0907ebea4b968$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $3ae0907ebea4b968$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $3ae0907ebea4b968$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $3ae0907ebea4b968$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $3ae0907ebea4b968$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $3ae0907ebea4b968$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $3ae0907ebea4b968$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $3ae0907ebea4b968$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $3ae0907ebea4b968$export$2e2bcd8739ae039 = {
    __extends: $3ae0907ebea4b968$export$a8ba968b8961cb8a,
    __assign: $3ae0907ebea4b968$export$18ce0697a983be9b,
    __rest: $3ae0907ebea4b968$export$3c9a16f847548506,
    __decorate: $3ae0907ebea4b968$export$29e00dfd3077644b,
    __param: $3ae0907ebea4b968$export$d5ad3fd78186038f,
    __esDecorate: $3ae0907ebea4b968$export$3a84e1ae4e97e9b0,
    __runInitializers: $3ae0907ebea4b968$export$d831c04e792af3d,
    __propKey: $3ae0907ebea4b968$export$6a2a36740a146cb8,
    __setFunctionName: $3ae0907ebea4b968$export$d1a06452d3489bc7,
    __metadata: $3ae0907ebea4b968$export$f1db080c865becb9,
    __awaiter: $3ae0907ebea4b968$export$1050f835b63b671e,
    __generator: $3ae0907ebea4b968$export$67ebef60e6f28a6,
    __createBinding: $3ae0907ebea4b968$export$45d3717a4c69092e,
    __exportStar: $3ae0907ebea4b968$export$f33643c0debef087,
    __values: $3ae0907ebea4b968$export$19a8beecd37a4c45,
    __read: $3ae0907ebea4b968$export$8d051b38c9118094,
    __spread: $3ae0907ebea4b968$export$afc72e2116322959,
    __spreadArrays: $3ae0907ebea4b968$export$6388937ca91ccae8,
    __spreadArray: $3ae0907ebea4b968$export$1216008129fb82ed,
    __await: $3ae0907ebea4b968$export$10c90e4f7922046c,
    __asyncGenerator: $3ae0907ebea4b968$export$e427f37a30a4de9b,
    __asyncDelegator: $3ae0907ebea4b968$export$bbd80228419bb833,
    __asyncValues: $3ae0907ebea4b968$export$e3b29a3d6162315f,
    __makeTemplateObject: $3ae0907ebea4b968$export$4fb47efe1390b86f,
    __importStar: $3ae0907ebea4b968$export$c21735bcef00d192,
    __importDefault: $3ae0907ebea4b968$export$da59b14a69baef04,
    __classPrivateFieldGet: $3ae0907ebea4b968$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $3ae0907ebea4b968$export$d40a35129aaff81f,
    __classPrivateFieldIn: $3ae0907ebea4b968$export$81fdc39f203e4e04,
    __addDisposableResource: $3ae0907ebea4b968$export$88ac25d8e944e405,
    __disposeResources: $3ae0907ebea4b968$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $3ae0907ebea4b968$export$889dfb5d17574b0b
};

});

parcelRegister("grTX0", function(module, exports) {

$parcel$export(module.exports, "noCase", function () { return $bf9a919b3f07813e$export$a596972587f860c8; });

var $lP9Fx = parcelRequire("lP9Fx");
// Support camel case ("camelCase" -> "camel Case" and "CAMELCase" -> "CAMEL Case").
var $bf9a919b3f07813e$var$DEFAULT_SPLIT_REGEXP = [
    /([a-z0-9])([A-Z])/g,
    /([A-Z])([A-Z][a-z])/g
];
// Remove all non-word characters.
var $bf9a919b3f07813e$var$DEFAULT_STRIP_REGEXP = /[^A-Z0-9]+/gi;
function $bf9a919b3f07813e$export$a596972587f860c8(input, options) {
    if (options === void 0) options = {};
    var _a = options.splitRegexp, splitRegexp = _a === void 0 ? $bf9a919b3f07813e$var$DEFAULT_SPLIT_REGEXP : _a, _b = options.stripRegexp, stripRegexp = _b === void 0 ? $bf9a919b3f07813e$var$DEFAULT_STRIP_REGEXP : _b, _c = options.transform, transform = _c === void 0 ? (0, $lP9Fx.lowerCase) : _c, _d = options.delimiter, delimiter = _d === void 0 ? " " : _d;
    var result = $bf9a919b3f07813e$var$replace($bf9a919b3f07813e$var$replace(input, splitRegexp, "$1\0$2"), stripRegexp, "\0");
    var start = 0;
    var end = result.length;
    // Trim the delimiter from around the output string.
    while(result.charAt(start) === "\0")start++;
    while(result.charAt(end - 1) === "\0")end--;
    // Transform each token independently.
    return result.slice(start, end).split("\0").map(transform).join(delimiter);
}
/**
 * Replace `re` in the input string with the replacement value.
 */ function $bf9a919b3f07813e$var$replace(input, re, value) {
    if (re instanceof RegExp) return input.replace(re, value);
    return re.reduce(function(input, re) {
        return input.replace(re, value);
    }, input);
}

});
parcelRegister("lP9Fx", function(module, exports) {

$parcel$export(module.exports, "lowerCase", function () { return $fe35dc75b8542313$export$61d6efbc6547e8eb; });
/**
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 */ var $fe35dc75b8542313$var$SUPPORTED_LOCALE = {
    tr: {
        regexp: /\u0130|\u0049|\u0049\u0307/g,
        map: {
            \u0130: "i",
            I: "\u0131",
            I\u0307: "i"
        }
    },
    az: {
        regexp: /\u0130/g,
        map: {
            \u0130: "i",
            I: "\u0131",
            I\u0307: "i"
        }
    },
    lt: {
        regexp: /\u0049|\u004A|\u012E|\u00CC|\u00CD|\u0128/g,
        map: {
            I: "i\u0307",
            J: "j\u0307",
            \u012E: "\u012F\u0307",
            "\xcc": "i\u0307\u0300",
            "\xcd": "i\u0307\u0301",
            \u0128: "i\u0307\u0303"
        }
    }
};
function $fe35dc75b8542313$export$206cd6ecad4fcdde(str, locale) {
    var lang = $fe35dc75b8542313$var$SUPPORTED_LOCALE[locale.toLowerCase()];
    if (lang) return $fe35dc75b8542313$export$61d6efbc6547e8eb(str.replace(lang.regexp, function(m) {
        return lang.map[m];
    }));
    return $fe35dc75b8542313$export$61d6efbc6547e8eb(str);
}
function $fe35dc75b8542313$export$61d6efbc6547e8eb(str) {
    return str.toLowerCase();
}

});


parcelRegister("g7Kj9", function(module, exports) {

$parcel$export(module.exports, "upperCaseFirst", function () { return $bbd13890198bb6a2$export$688230ca06b60d9d; });
/**
 * Upper case the first character of an input string.
 */ function $bbd13890198bb6a2$export$688230ca06b60d9d(input) {
    return input.charAt(0).toUpperCase() + input.substr(1);
}

});





parcelRegister("gSTGk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4ace1bc21eb5f0b$export$2e2bcd8739ae039; });

var $8lBDl = parcelRequire("8lBDl");

var $4JcCM = parcelRequire("4JcCM");

var $eat5C = parcelRequire("eat5C");

var $37AD0 = parcelRequire("37AD0");

var $MRmcQ = parcelRequire("MRmcQ");

var $eNcHX = parcelRequire("eNcHX");

var $9VnJj = parcelRequire("9VnJj");

var $gJT7h = parcelRequire("gJT7h");

var $bxXv3 = parcelRequire("bxXv3");

var $htkeB = parcelRequire("htkeB");

var $kb7bz = parcelRequire("kb7bz");

var $QiMYe = parcelRequire("QiMYe");

var $3PpOX = parcelRequire("3PpOX");

var $hSUCJ = parcelRequire("hSUCJ");
parcelRequire("dtlWt");
parcelRequire("4WSZl");

var $jg8jZ = parcelRequire("jg8jZ");

var $8kZ1o = parcelRequire("8kZ1o");

var $62nmb = parcelRequire("62nmb");

var $gN0TC = parcelRequire("gN0TC");

var $4hBm1 = parcelRequire("4hBm1");

var $bKg2i = parcelRequire("bKg2i");
var $c4ace1bc21eb5f0b$var$_class, $c4ace1bc21eb5f0b$var$_descriptor, $c4ace1bc21eb5f0b$var$_descriptor2, $c4ace1bc21eb5f0b$var$_descriptor3, $c4ace1bc21eb5f0b$var$_descriptor4, $c4ace1bc21eb5f0b$var$_descriptor5, $c4ace1bc21eb5f0b$var$_descriptor6, $c4ace1bc21eb5f0b$var$_descriptor7, $c4ace1bc21eb5f0b$var$_descriptor8, $c4ace1bc21eb5f0b$var$_descriptor9, $c4ace1bc21eb5f0b$var$_descriptor10, $c4ace1bc21eb5f0b$var$_descriptor11, $c4ace1bc21eb5f0b$var$_descriptor12, $c4ace1bc21eb5f0b$var$_descriptor13, $c4ace1bc21eb5f0b$var$_descriptor14, $c4ace1bc21eb5f0b$var$_descriptor15, $c4ace1bc21eb5f0b$var$_descriptor16, $c4ace1bc21eb5f0b$var$_descriptor17, $c4ace1bc21eb5f0b$var$_descriptor18, $c4ace1bc21eb5f0b$var$_descriptor19;
function $c4ace1bc21eb5f0b$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $c4ace1bc21eb5f0b$var$_defineProperty(e, r, t) {
    return (r = $c4ace1bc21eb5f0b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $c4ace1bc21eb5f0b$var$_toPropertyKey(t) {
    var i = $c4ace1bc21eb5f0b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $c4ace1bc21eb5f0b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $c4ace1bc21eb5f0b$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $c4ace1bc21eb5f0b$var$StaffModel = ($c4ace1bc21eb5f0b$var$_class = class StaffModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $c4ace1bc21eb5f0b$var$_initializerDefineProperty(this, "firstName", $c4ace1bc21eb5f0b$var$_descriptor, this);
        $c4ace1bc21eb5f0b$var$_initializerDefineProperty(this, "lastName", $c4ace1bc21eb5f0b$var$_descriptor2, this);
        $c4ace1bc21eb5f0b$var$_initializerDefineProperty(this, "email", $c4ace1bc21eb5f0b$var$_descriptor3, this);
        $c4ace1bc21eb5f0b$var$_initializerDefineProperty(this, "roleId", $c4ace1bc21eb5f0b$var$_descriptor4, this);
        $c4ace1bc21eb5f0b$var$_initializerDefineProperty(this, "isArchived", $c4ace1bc21eb5f0b$var$_descriptor5, this);
        $c4ace1bc21eb5f0b$var$_initializerDefineProperty(this, "isDeleted", $c4ace1bc21eb5f0b$var$_descriptor6, this);
        $c4ace1bc21eb5f0b$var$_initializerDefineProperty(this, "inheritPayRate", $c4ace1bc21eb5f0b$var$_descriptor7, this);
        $c4ace1bc21eb5f0b$var$_initializerDefineProperty(this, "inheritOvertimeRate", $c4ace1bc21eb5f0b$var$_descriptor8, this);
        $c4ace1bc21eb5f0b$var$_initializerDefineProperty(this, "inheritCostRate", $c4ace1bc21eb5f0b$var$_descriptor9, this);
        $c4ace1bc21eb5f0b$var$_initializerDefineProperty(this, "inheritChargeOutRate", $c4ace1bc21eb5f0b$var$_descriptor10, this);
        $c4ace1bc21eb5f0b$var$_initializerDefineProperty(this, "country", $c4ace1bc21eb5f0b$var$_descriptor11, this);
        $c4ace1bc21eb5f0b$var$_initializerDefineProperty(this, "permissions", $c4ace1bc21eb5f0b$var$_descriptor12, this);
        $c4ace1bc21eb5f0b$var$_initializerDefineProperty(this, "billingLevelOverride", $c4ace1bc21eb5f0b$var$_descriptor13, this);
        $c4ace1bc21eb5f0b$var$_initializerDefineProperty(this, "costCentreId", $c4ace1bc21eb5f0b$var$_descriptor14, this);
        $c4ace1bc21eb5f0b$var$_initializerDefineProperty(this, "staffType", $c4ace1bc21eb5f0b$var$_descriptor15, this);
        $c4ace1bc21eb5f0b$var$_initializerDefineProperty(this, "hasLogin", $c4ace1bc21eb5f0b$var$_descriptor16, this);
        $c4ace1bc21eb5f0b$var$_initializerDefineProperty(this, "workosId", $c4ace1bc21eb5f0b$var$_descriptor17, this);
        $c4ace1bc21eb5f0b$var$_initializerDefineProperty(this, "workosInviteId", $c4ace1bc21eb5f0b$var$_descriptor18, this);
        $c4ace1bc21eb5f0b$var$_initializerDefineProperty(this, "permissionsId", $c4ace1bc21eb5f0b$var$_descriptor19, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $htkeB.default);
        this.init(data, options);
    }
    update(data, options) {
        var _data$permissions;
        if (data !== null && data !== void 0 && (_data$permissions = data.permissions) !== null && _data$permissions !== void 0 && _data$permissions.projects) data.permissions.projects = data.permissions.projects.map((p)=>({
                ...p,
                id: p.id || p.uuid || (0, (/*@__PURE__*/$parcel$interopDefault($gN0TC)))()
            }));
        super.update(data, options);
    }
    get role() {
        return (0, $bxXv3.default).modelsById[this.roleId];
    }
    get costCentre() {
        return (0, $eNcHX.default).modelsById[this.costCentreId];
    }
    get allocations() {
        return (0, $jg8jZ.default).allocationsByStaffId[this.id] || [];
    }
    get dailyAllocations() {
        return (0, $9VnJj.default).dailyAllocationsByStaffId[this.id] || [];
    }
    get ownerOf() {
        return (0, $gJT7h.default).projectsByOwnerId[this.id];
    }
    get rates() {
        return (0, $kb7bz.default).ratesByStaffId[this.id] || [];
    }
    get payRate() {
        return this.getRateAtDate("pay", new Date());
    }
    get overtimeRate() {
        return this.getRateAtDate("overtime", new Date());
    }
    get costRate() {
        return this.getRateAtDate("cost", new Date());
    }
    get chargeOutRate() {
        return this.getRateAtDate("chargeOut", new Date());
    }
    get availability() {
        return this.getAvailabilityAtDate(new Date());
    }
    get minRateDate() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).min(this.rates.map((r)=>r.date));
    }
    get staffAndRoleRates() {
        var _this$role;
        return [
            ...this.rates,
            ...((_this$role = this.role) === null || _this$role === void 0 ? void 0 : _this$role.rates) || []
        ];
    }
    get timeEntries() {
        return (0, $QiMYe.default).timeEntriesByStaffId[this.id];
    }
    get fullName() {
        if (!this.firstName && !this.lastName) return "New Staff Member";
        return [
            this.firstName,
            this.lastName
        ].filter(Boolean).join(" ");
    }
    get budgets() {
        return (0, $hSUCJ.default).budgetsByStaffId[this.id] || [];
    }
    get permissionKey() {
        return (0, $bKg2i.getPermissionKey)(this.permissions);
    }
    inheritRateType(rateType) {
        return this["inherit" + (0, $8lBDl.pascalCase)(rateType) + "Rate"];
    }
    getRateInDateRange(rateType, dateRange) {
        if (this.role && this.inheritRateType(rateType)) return this.role.getRateInDateRange(rateType, dateRange);
        return (0, $MRmcQ.default)(this.rates, rateType, dateRange);
    }
    getRateAtDate(rateType, date) {
        if (this.role && this.inheritRateType(rateType)) return this.role.getRateAtDate(rateType, date);
        return (0, $37AD0.default)(this.rates, rateType, date);
    }
    getAvailabilityInDateRange(dateRange) {
        return (0, $MRmcQ.default)(this.rates, "availability", dateRange);
    }
    getAvailabilityAtDate(date) {
        return (0, $37AD0.default)(this.rates, "availability", date);
    }
    getAvailableHoursInDateRange(dateRange) {
        const dailyAvailableHours = this.getAvailabilityInDateRange(dateRange) / 60 / 5;
        const weekdaysInDateRange = (0, $4hBm1.differenceInBusinessDays)(dateRange[1], dateRange[0]);
        //TODO holidays
        return dailyAvailableHours * weekdaysInDateRange;
    }
    hoursInDateRange(dateRange) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.allocations.filter((a)=>a.date >= dateRange[0] && a.date <= dateRange[1]).map((a)=>a.hours));
    }
    get billingLevel() {
        if (this.billingLevelOverride) return this.billingLevelOverride;
        if (!this.hasLogin || this.isArchived || this.deletedAt || !this.email || this.email === "") return "none";
        if ((0, $8kZ1o.canSeeSalaries)(this) || (0, $8kZ1o.canSeeOperationalExpenses)(this) || (0, $8kZ1o.canViewBilling)(this) || (0, $8kZ1o.canViewSettings)(this)) return "admin";
        return "standard";
    }
}, $c4ace1bc21eb5f0b$var$_descriptor = $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "firstName", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c4ace1bc21eb5f0b$var$_descriptor2 = $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "lastName", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c4ace1bc21eb5f0b$var$_descriptor3 = $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "email", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c4ace1bc21eb5f0b$var$_descriptor4 = $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "roleId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c4ace1bc21eb5f0b$var$_descriptor5 = $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "isArchived", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c4ace1bc21eb5f0b$var$_descriptor6 = $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "isDeleted", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c4ace1bc21eb5f0b$var$_descriptor7 = $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "inheritPayRate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c4ace1bc21eb5f0b$var$_descriptor8 = $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "inheritOvertimeRate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c4ace1bc21eb5f0b$var$_descriptor9 = $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "inheritCostRate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c4ace1bc21eb5f0b$var$_descriptor10 = $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "inheritChargeOutRate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c4ace1bc21eb5f0b$var$_descriptor11 = $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "country", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c4ace1bc21eb5f0b$var$_descriptor12 = $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "permissions", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c4ace1bc21eb5f0b$var$_descriptor13 = $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "billingLevelOverride", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c4ace1bc21eb5f0b$var$_descriptor14 = $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "costCentreId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c4ace1bc21eb5f0b$var$_descriptor15 = $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "staffType", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c4ace1bc21eb5f0b$var$_descriptor16 = $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "hasLogin", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c4ace1bc21eb5f0b$var$_descriptor17 = $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "workosId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c4ace1bc21eb5f0b$var$_descriptor18 = $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "workosInviteId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c4ace1bc21eb5f0b$var$_descriptor19 = $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "permissionsId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "role", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "role"), $c4ace1bc21eb5f0b$var$_class.prototype), $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "costCentre", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "costCentre"), $c4ace1bc21eb5f0b$var$_class.prototype), $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "allocations", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "allocations"), $c4ace1bc21eb5f0b$var$_class.prototype), $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "dailyAllocations", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "dailyAllocations"), $c4ace1bc21eb5f0b$var$_class.prototype), $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "ownerOf", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "ownerOf"), $c4ace1bc21eb5f0b$var$_class.prototype), $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "rates", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "rates"), $c4ace1bc21eb5f0b$var$_class.prototype), $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "payRate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "payRate"), $c4ace1bc21eb5f0b$var$_class.prototype), $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "overtimeRate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "overtimeRate"), $c4ace1bc21eb5f0b$var$_class.prototype), $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "costRate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "costRate"), $c4ace1bc21eb5f0b$var$_class.prototype), $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "chargeOutRate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "chargeOutRate"), $c4ace1bc21eb5f0b$var$_class.prototype), $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "availability", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "availability"), $c4ace1bc21eb5f0b$var$_class.prototype), $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "minRateDate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "minRateDate"), $c4ace1bc21eb5f0b$var$_class.prototype), $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "staffAndRoleRates", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "staffAndRoleRates"), $c4ace1bc21eb5f0b$var$_class.prototype), $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "timeEntries", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "timeEntries"), $c4ace1bc21eb5f0b$var$_class.prototype), $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "fullName", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "fullName"), $c4ace1bc21eb5f0b$var$_class.prototype), $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "budgets", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "budgets"), $c4ace1bc21eb5f0b$var$_class.prototype), $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "permissionKey", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "permissionKey"), $c4ace1bc21eb5f0b$var$_class.prototype), $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "inheritRateType", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "inheritRateType"), $c4ace1bc21eb5f0b$var$_class.prototype), $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "getRateInDateRange", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "getRateInDateRange"), $c4ace1bc21eb5f0b$var$_class.prototype), $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "getRateAtDate", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "getRateAtDate"), $c4ace1bc21eb5f0b$var$_class.prototype), $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "getAvailabilityInDateRange", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "getAvailabilityInDateRange"), $c4ace1bc21eb5f0b$var$_class.prototype), $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "getAvailabilityAtDate", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "getAvailabilityAtDate"), $c4ace1bc21eb5f0b$var$_class.prototype), $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "getAvailableHoursInDateRange", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "getAvailableHoursInDateRange"), $c4ace1bc21eb5f0b$var$_class.prototype), $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "hoursInDateRange", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "hoursInDateRange"), $c4ace1bc21eb5f0b$var$_class.prototype), $c4ace1bc21eb5f0b$var$_applyDecoratedDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "billingLevel", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c4ace1bc21eb5f0b$var$_class.prototype, "billingLevel"), $c4ace1bc21eb5f0b$var$_class.prototype), $c4ace1bc21eb5f0b$var$_class);
var $c4ace1bc21eb5f0b$export$2e2bcd8739ae039 = $c4ace1bc21eb5f0b$var$StaffModel;

});
parcelRegister("8lBDl", function(module, exports) {

$parcel$export(module.exports, "pascalCase", function () { return $613d7a21bb62ad4d$export$26c6f48841fe1a8a; });

var $53oVd = parcelRequire("53oVd");

var $grTX0 = parcelRequire("grTX0");
function $613d7a21bb62ad4d$export$66a4dfea2695736(input, index) {
    var firstChar = input.charAt(0);
    var lowerChars = input.substr(1).toLowerCase();
    if (index > 0 && firstChar >= "0" && firstChar <= "9") return "_" + firstChar + lowerChars;
    return "" + firstChar.toUpperCase() + lowerChars;
}
function $613d7a21bb62ad4d$export$c27cf446dc44c0b9(input) {
    return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
}
function $613d7a21bb62ad4d$export$26c6f48841fe1a8a(input, options) {
    if (options === void 0) options = {};
    return (0, $grTX0.noCase)(input, (0, $53oVd.__assign)({
        delimiter: "",
        transform: $613d7a21bb62ad4d$export$66a4dfea2695736
    }, options));
}

});

parcelRegister("37AD0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $245e7024d3a6ba8d$export$2e2bcd8739ae039; });
parcelRequire("h999z");
parcelRequire("BqJ1K");
var $245e7024d3a6ba8d$export$2e2bcd8739ae039 = (rates, rateType, date)=>{
    var _date, _rates, _rates$0$rateName;
    (_date = date) !== null && _date !== void 0 ? _date : date = new Date();
    if (!((_rates = rates) !== null && _rates !== void 0 && _rates.length) || !rateType) return 0;
    rates = rates.filter((r)=>r.date <= date).sort((a, b)=>b.date - a.date);
    const rateName = rateType === "availability" ? "weeklyAvailability" : rateType + "Rate";
    if (!rates.length) return 0;
    return (_rates$0$rateName = rates[0][rateName]) !== null && _rates$0$rateName !== void 0 ? _rates$0$rateName : 0;
};

});
parcelRegister("h999z", function(module, exports) {

$parcel$export(module.exports, "spanSetFromPointSet", function () { return $c7ba609cf132bd96$export$47ee317d48ba68d9; });
$parcel$export(module.exports, "combineSpanSets", function () { return $c7ba609cf132bd96$export$d44f65ac6fd569ea; });
// [{point: single point, span: between points, value}]
function $c7ba609cf132bd96$export$47ee317d48ba68d9(pointValues, defaultBefore) {
    //[{point: single point, value}]
    const spans = [
        {
            span: [
                -Infinity,
                pointValues[0].point
            ],
            value: defaultBefore !== undefined ? defaultBefore : 0
        }
    ];
    pointValues.forEach((pv, i)=>{
        spans.push({
            span: [
                pointValues[i].point,
                i !== pointValues.length - 1 ? pointValues[i + 1].point : Infinity
            ],
            value: pointValues[i].value || 0
        });
    });
    return spans;
}
function $c7ba609cf132bd96$export$f1ca819cd34389e5(spanValues) {
    const points = [];
    spanValues.forEach((sv, i)=>{
        if (!i) return;
        points.push({
            point: sv.span[0],
            value: sv.value || 0
        });
    });
}
function $c7ba609cf132bd96$export$f64c1935cce05e02(pointSet, point, defaultValue) {
    var _pointSet$filter$sort;
    return ((_pointSet$filter$sort = pointSet.filter((p)=>p.point <= point).sort((a, b)=>b.point - a.point)) === null || _pointSet$filter$sort === void 0 ? void 0 : _pointSet$filter$sort[0].value) || defaultValue;
}
function $c7ba609cf132bd96$export$7ca312b2137cde80(spanSet, point, defaultValue) {
    var _spanSet$filter$sort, _spanSet$filter$sort$;
    return ((_spanSet$filter$sort = spanSet.filter((sv)=>sv.span[0] <= point && sv.span[1] >= point).sort((a, b)=>b.span[0] - a.span[0])) === null || _spanSet$filter$sort === void 0 ? void 0 : (_spanSet$filter$sort$ = _spanSet$filter$sort[0]) === null || _spanSet$filter$sort$ === void 0 ? void 0 : _spanSet$filter$sort$.value) || defaultValue;
}
function $c7ba609cf132bd96$export$11802662041ecda0(spanSet, multiplyFunc = (v, r)=>v * r, addFunc = (l, r)=>l + r) {
    const totalLength = $c7ba609cf132bd96$var$lengthFromSpan($c7ba609cf132bd96$var$spanFromSpanSet(spanSet));
    let avgValue;
    spanSet.forEach((sv, i)=>{
        const length = $c7ba609cf132bd96$var$lengthFromSpan(sv.span);
        const lengthRatio = length / totalLength;
        const adjustedValue = multiplyFunc(sv.value, lengthRatio);
        if (!i) avgValue = adjustedValue;
        else avgValue = addFunc(avgValue, adjustedValue);
    });
    return avgValue;
}
function $c7ba609cf132bd96$export$c84214f0ca3dd761(pointSet, clamp) {
    let clampedPointSet = [
        ...pointSet.filter((p)=>p.point >= clamp[0] && p.point <= clamp[1]).sort((a, b)=>a.point - b.point)
    ];
    if (clampedPointSet[0].point > clamp[0]) clampedPointSet.unshift({
        point: clamp[0],
        value: $c7ba609cf132bd96$export$f64c1935cce05e02([
            ...pointSet
        ], clamp[0]) || 0
    });
    return clampedPointSet;
}
function $c7ba609cf132bd96$export$80711da03ba4e645(spanSet, span, clamp) {
    const newSpanSet = [];
    spanSet.forEach((sv)=>{
        if (sv.span[1] >= span[0] && sv.span[0] <= span[1]) newSpanSet.push({
            span: [
                clamp && sv.span[0] < clamp[0] ? clamp[0] : sv.span[0],
                clamp && sv.span[1] > clamp[1] ? clamp[1] : sv.span[1]
            ],
            value: sv.value || 0
        });
    });
    return newSpanSet.sort((a, b)=>a.span[0] - b.span[0]);
}
function $c7ba609cf132bd96$var$lengthFromSpan(span) {
    return span[1] - span[0];
}
// function averageSpanSetValueBetweenSpan(
//     spanSet,
//     span,
//     defaultBefore,
//     defaultAfter
// ) {
//     let spansForCalc = spanSetBetweenSpan(spanSet, span, span).sort(
//         (a, b) => a.span[0] - b.span[0]
//     )
//     if (spansForCalc[0].span[0] >= span[0]) {
//         spansForCalc.unshift({
//             span: [span[0], spanSet[0].span[0]],
//             value: defaultBefore !== undefined ? defaultBefore : null,
//         })
//     }
//     spansForCalc = spansForCalc.sort((a, b) => b.span[1] - a.span[1])
//     if (spansForCalc[spansForCalc.length - 1].span[1] <= span[1]) {
//         spansForCalc.push({
//             span: [spanSet[0].span[1], span[1]],
//             value: defaultAfter !== undefined ? defaultAfter : null,
//         })
//     }
//     const totalLength = lengthFromSpan(span)
//     let value = 0
//     spansForCalc.forEach((sv) => {
//         const length = lengthFromSpan(sv.span)
//         const ratio = length / totalLength
//         value += ratio * sv.svalue
//     })
//     return value
// }
function $c7ba609cf132bd96$var$pointsFromSpanSet(spanSet) {
    const points = new Set();
    spanSet.forEach((sv)=>{
        var _sv$span, _sv$span2;
        if (!((_sv$span = sv.span) !== null && _sv$span !== void 0 && _sv$span[0] && (_sv$span2 = sv.span) !== null && _sv$span2 !== void 0 && _sv$span2[1])) return;
        points.add(sv.span[0]);
        points.add(sv.span[1]);
    });
    return [
        ...points
    ];
}
function $c7ba609cf132bd96$var$spanFromSpanSet(spanSet) {
    let span = null;
    spanSet.forEach((sv, i)=>{
        var _sv$span3, _sv$span4;
        if (!((_sv$span3 = sv.span) !== null && _sv$span3 !== void 0 && _sv$span3[0] && (_sv$span4 = sv.span) !== null && _sv$span4 !== void 0 && _sv$span4[1])) return;
        if (!i) span = [
            ...sv.span
        ];
        else {
            if (span[0] > sv.span[0]) span[0] = sv.span[0];
            if (span[1] < sv.span[1]) span[1] = sv.span[1];
        }
    });
    return span;
}
function $c7ba609cf132bd96$var$splitSpanSetAtPoints(spanSet, points, defaultBefore, defaultAfter) {
    const newSpanSet = [];
    const allPoints = [
        ...new Set([
            ...points,
            ...$c7ba609cf132bd96$var$pointsFromSpanSet(spanSet)
        ])
    ].sort((a, b)=>a - b);
    let spanSetSpan = $c7ba609cf132bd96$var$spanFromSpanSet(spanSet) || [
        Infinity,
        -Infinity
    ];
    let spanIndex = 0;
    allPoints.forEach((p, i)=>{
        const p2 = points[i + 1];
        if (i !== allPoints.length - 1) {
            while(p >= spanSetSpan[0] && p2 <= spanSetSpan[1] && !(p >= spanSet[spanIndex].span[0] && p2 <= spanSet[spanIndex].span[1]) && spanIndex < spanSet.length)spanIndex++;
            newSpanSet.push({
                span: [
                    p,
                    p2
                ],
                value: p < spanSetSpan[0] ? defaultBefore : p >= spanSetSpan[1] ? defaultAfter : spanSet[spanIndex].value
            });
        }
    });
    return newSpanSet;
}
function $c7ba609cf132bd96$export$d44f65ac6fd569ea(spanSets, combineFunc = (v)=>v, defaultBefore, defaultAfter, clamp) {
    spanSets = spanSets.filter((ss)=>ss.length);
    const uniquePoints = $c7ba609cf132bd96$var$uniquePointsFromSpanSets(spanSets, clamp);
    const splitSpanSets = spanSets.map((ss)=>$c7ba609cf132bd96$var$splitSpanSetAtPoints(ss, uniquePoints, defaultBefore, defaultAfter));
    const combinedSet = [];
    const firstSet = splitSpanSets[0];
    firstSet === null || firstSet === void 0 || firstSet.forEach((sss, i)=>{
        combinedSet.push({
            span: sss.span,
            value: combineFunc(...splitSpanSets.map((ss)=>ss[i].value)) || 0
        });
    });
    return combinedSet;
}
function $c7ba609cf132bd96$var$uniquePointsFromSpanSets(spanSets, clamp) {
    const uniquePoints = new Set();
    if (clamp) {
        uniquePoints.add(clamp[0]);
        uniquePoints.add(clamp[1]);
    }
    spanSets.flat().forEach((sv)=>{
        var _sv$span5, _sv$span6;
        if (!((_sv$span5 = sv.span) !== null && _sv$span5 !== void 0 && _sv$span5[0] && (_sv$span6 = sv.span) !== null && _sv$span6 !== void 0 && _sv$span6[1])) return;
        if (!clamp) {
            uniquePoints.add(sv.span[0]);
            uniquePoints.add(sv.span[1]);
        } else {
            if (sv.span[0] >= clamp[0] && sv.span[0] <= clamp[1]) uniquePoints.add(sv.span[0]);
            if (sv.span[1] >= clamp[0] && sv.span[1] <= clamp[1]) uniquePoints.add(sv.span[1]);
        }
    });
    return [
        ...uniquePoints
    ].sort((a, b)=>a - b);
}

});

parcelRegister("BqJ1K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07082fe489e6e8f2$export$2e2bcd8739ae039; });

var $h999z = parcelRequire("h999z");
var $07082fe489e6e8f2$export$2e2bcd8739ae039 = (rates = [], rateType, beforeIntialValue)=>{
    const rateName = rateType === "availability" ? "weeklyAvailability" : rateType + "Rate";
    if (!rates || !rates.length) return [];
    return (0, $h999z.spanSetFromPointSet)(rates.map((rate)=>({
            point: rate.date.getTime(),
            value: rate[rateName] || 0
        })), beforeIntialValue);
};

});


parcelRegister("MRmcQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $092ddf6e4886d96b$export$2e2bcd8739ae039; });

var $37AD0 = parcelRequire("37AD0");

var $eat5C = parcelRequire("eat5C");

var $4hBm1 = parcelRequire("4hBm1");
var $092ddf6e4886d96b$export$2e2bcd8739ae039 = (rates, rateType, dateRange)=>{
    var _2, _dateRange$_, _3, _dateRange$_2, _dateRange$, _dateRange$2;
    const now = new Date();
    (_dateRange$_ = dateRange[_2 = 0]) !== null && _dateRange$_ !== void 0 ? _dateRange$_ : dateRange[_2] = now;
    (_dateRange$_2 = dateRange[_3 = 1]) !== null && _dateRange$_2 !== void 0 ? _dateRange$_2 : dateRange[_3] = now;
    if (((_dateRange$ = dateRange[0]) === null || _dateRange$ === void 0 ? void 0 : _dateRange$.getTime()) === ((_dateRange$2 = dateRange[1]) === null || _dateRange$2 === void 0 ? void 0 : _dateRange$2.getTime())) return (0, $37AD0.default)(rates, rateType, dateRange[0]);
    const businessDays = $092ddf6e4886d96b$var$getBusinessDaysBetweenDates(...dateRange);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).mean(businessDays.map((d)=>{
        return (0, $37AD0.default)(rates, rateType, d) || 0;
    }));
};
const $092ddf6e4886d96b$var$getBusinessDaysBetweenDates = (startDate, endDate)=>{
    const start = new Date(startDate);
    const end = new Date(endDate);
    const businessDays = [];
    let currentDate = start;
    while(currentDate <= end){
        const day = currentDate.getDay();
        if (![
            0,
            6
        ].includes(day)) businessDays.push(currentDate);
        currentDate = (0, $4hBm1.addDays)(currentDate, 1);
    }
    return businessDays;
};

});

parcelRegister("eNcHX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac4f7fda68f562c4$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "CostCentreCollectionClass", function () { return $ac4f7fda68f562c4$export$a7f00764127270a0; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $9uBY4 = parcelRequire("9uBY4");
var $ac4f7fda68f562c4$var$_dec, $ac4f7fda68f562c4$var$_dec2, $ac4f7fda68f562c4$var$_class;
function $ac4f7fda68f562c4$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $ac4f7fda68f562c4$var$CostCentreCollection = ($ac4f7fda68f562c4$var$_dec = (0, $4JcCM.action).bound, $ac4f7fda68f562c4$var$_dec2 = (0, $4JcCM.action).bound, $ac4f7fda68f562c4$var$_class = class CostCentreCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "costCentres",
            modelClass: (0, $9uBY4.default)
        });
        this.addLookup("activeCostCentres", "list", {
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("activeBillableCostCentres", "list", {
            filter: (t)=>!t.deletedAt && t.isBillable
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get costCentresById() {
        return this.modelsById;
    }
    get costCentres() {
        return this.models;
    }
    addCostCentre(data) {
        this.add(data);
    }
    addCostCentres(data) {
        this.addMany(data);
    }
}, $ac4f7fda68f562c4$var$_applyDecoratedDescriptor($ac4f7fda68f562c4$var$_class.prototype, "addCostCentre", [
    $ac4f7fda68f562c4$var$_dec
], Object.getOwnPropertyDescriptor($ac4f7fda68f562c4$var$_class.prototype, "addCostCentre"), $ac4f7fda68f562c4$var$_class.prototype), $ac4f7fda68f562c4$var$_applyDecoratedDescriptor($ac4f7fda68f562c4$var$_class.prototype, "addCostCentres", [
    $ac4f7fda68f562c4$var$_dec2
], Object.getOwnPropertyDescriptor($ac4f7fda68f562c4$var$_class.prototype, "addCostCentres"), $ac4f7fda68f562c4$var$_class.prototype), $ac4f7fda68f562c4$var$_class);
var $ac4f7fda68f562c4$export$2e2bcd8739ae039 = new $ac4f7fda68f562c4$var$CostCentreCollection();
const $ac4f7fda68f562c4$export$a7f00764127270a0 = $ac4f7fda68f562c4$var$CostCentreCollection;

});
parcelRegister("9uBY4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e945e03687e46f4$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $eNcHX = parcelRequire("eNcHX");

var $1UDCR = parcelRequire("1UDCR");

var $gJT7h = parcelRequire("gJT7h");

var $htkeB = parcelRequire("htkeB");

var $3PpOX = parcelRequire("3PpOX");
var $6e945e03687e46f4$var$_class, $6e945e03687e46f4$var$_descriptor, $6e945e03687e46f4$var$_descriptor2;
function $6e945e03687e46f4$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $6e945e03687e46f4$var$_defineProperty(e, r, t) {
    return (r = $6e945e03687e46f4$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $6e945e03687e46f4$var$_toPropertyKey(t) {
    var i = $6e945e03687e46f4$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $6e945e03687e46f4$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $6e945e03687e46f4$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $6e945e03687e46f4$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $6e945e03687e46f4$var$CostCentreModel = ($6e945e03687e46f4$var$_class = class CostCentreModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $6e945e03687e46f4$var$_initializerDefineProperty(this, "name", $6e945e03687e46f4$var$_descriptor, this);
        $6e945e03687e46f4$var$_initializerDefineProperty(this, "isBillable", $6e945e03687e46f4$var$_descriptor2, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $eNcHX.default);
        this.init(data, options);
    }
    get overheadExpenses() {
        return (0, $1UDCR.default).overheadExpensesByCostCentreId[this.costCentreId];
    }
    get projects() {
        return (0, $gJT7h.default).allocationsByCostCentreId[this.id];
    }
    get staff() {
        return (0, $htkeB.default).staffByCostCentreId[this.id];
    }
}, $6e945e03687e46f4$var$_descriptor = $6e945e03687e46f4$var$_applyDecoratedDescriptor($6e945e03687e46f4$var$_class.prototype, "name", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $6e945e03687e46f4$var$_descriptor2 = $6e945e03687e46f4$var$_applyDecoratedDescriptor($6e945e03687e46f4$var$_class.prototype, "isBillable", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $6e945e03687e46f4$var$_applyDecoratedDescriptor($6e945e03687e46f4$var$_class.prototype, "overheadExpenses", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6e945e03687e46f4$var$_class.prototype, "overheadExpenses"), $6e945e03687e46f4$var$_class.prototype), $6e945e03687e46f4$var$_applyDecoratedDescriptor($6e945e03687e46f4$var$_class.prototype, "projects", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6e945e03687e46f4$var$_class.prototype, "projects"), $6e945e03687e46f4$var$_class.prototype), $6e945e03687e46f4$var$_applyDecoratedDescriptor($6e945e03687e46f4$var$_class.prototype, "staff", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6e945e03687e46f4$var$_class.prototype, "staff"), $6e945e03687e46f4$var$_class.prototype), $6e945e03687e46f4$var$_class);
var $6e945e03687e46f4$export$2e2bcd8739ae039 = $6e945e03687e46f4$var$CostCentreModel;

});
parcelRegister("1UDCR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1649c247096b0be4$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "OverheadExpenseCollectionClass", function () { return $1649c247096b0be4$export$b7dce7aaac249110; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $kpv78 = parcelRequire("kpv78");
var $1649c247096b0be4$var$_dec, $1649c247096b0be4$var$_dec2, $1649c247096b0be4$var$_class;
function $1649c247096b0be4$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $1649c247096b0be4$var$OverheadExpenseCollection = ($1649c247096b0be4$var$_dec = (0, $4JcCM.action).bound, $1649c247096b0be4$var$_dec2 = (0, $4JcCM.action).bound, $1649c247096b0be4$var$_class = class OverheadExpenseCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "overheadExpenses",
            modelClass: (0, $kpv78.default)
        });
        this.addLookup("overheadExpensesByCostCentreId", "manyByKey", {
            key: (t)=>t.costCentreId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("activeOverheads", "list", {
            filter: (t)=>!t.deletedAt
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get overheadExpensesById() {
        return this.modelsById;
    }
    get overheadExpenses() {
        return this.models;
    }
    addOverheadExpense(data) {
        this.add(data);
    }
    addOverheadExpenses(data) {
        this.addMany(data);
    }
}, $1649c247096b0be4$var$_applyDecoratedDescriptor($1649c247096b0be4$var$_class.prototype, "addOverheadExpense", [
    $1649c247096b0be4$var$_dec
], Object.getOwnPropertyDescriptor($1649c247096b0be4$var$_class.prototype, "addOverheadExpense"), $1649c247096b0be4$var$_class.prototype), $1649c247096b0be4$var$_applyDecoratedDescriptor($1649c247096b0be4$var$_class.prototype, "addOverheadExpenses", [
    $1649c247096b0be4$var$_dec2
], Object.getOwnPropertyDescriptor($1649c247096b0be4$var$_class.prototype, "addOverheadExpenses"), $1649c247096b0be4$var$_class.prototype), $1649c247096b0be4$var$_class);
var $1649c247096b0be4$export$2e2bcd8739ae039 = new $1649c247096b0be4$var$OverheadExpenseCollection();
const $1649c247096b0be4$export$b7dce7aaac249110 = $1649c247096b0be4$var$OverheadExpenseCollection;

});
parcelRegister("kpv78", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $edbe470932852044$export$2e2bcd8739ae039; });

var $4hBm1 = parcelRequire("4hBm1");

var $4JcCM = parcelRequire("4JcCM");

var $eNcHX = parcelRequire("eNcHX");

var $1UDCR = parcelRequire("1UDCR");

var $3PpOX = parcelRequire("3PpOX");
var $edbe470932852044$var$_class, $edbe470932852044$var$_descriptor, $edbe470932852044$var$_descriptor2, $edbe470932852044$var$_descriptor3, $edbe470932852044$var$_descriptor4, $edbe470932852044$var$_descriptor5, $edbe470932852044$var$_descriptor6, $edbe470932852044$var$_descriptor7, $edbe470932852044$var$_descriptor8;
function $edbe470932852044$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $edbe470932852044$var$_defineProperty(e, r, t) {
    return (r = $edbe470932852044$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $edbe470932852044$var$_toPropertyKey(t) {
    var i = $edbe470932852044$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $edbe470932852044$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $edbe470932852044$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $edbe470932852044$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $edbe470932852044$var$OverheadExpenseModel = ($edbe470932852044$var$_class = class OverheadExpenseModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $edbe470932852044$var$_initializerDefineProperty(this, "name", $edbe470932852044$var$_descriptor, this);
        $edbe470932852044$var$_initializerDefineProperty(this, "value", $edbe470932852044$var$_descriptor2, this);
        $edbe470932852044$var$_initializerDefineProperty(this, "startDate", $edbe470932852044$var$_descriptor3, this);
        $edbe470932852044$var$_initializerDefineProperty(this, "endDate", $edbe470932852044$var$_descriptor4, this);
        $edbe470932852044$var$_initializerDefineProperty(this, "hasRepeat", $edbe470932852044$var$_descriptor5, this);
        $edbe470932852044$var$_initializerDefineProperty(this, "repeatQuantity", $edbe470932852044$var$_descriptor6, this);
        $edbe470932852044$var$_initializerDefineProperty(this, "repeatUnit", $edbe470932852044$var$_descriptor7, this);
        $edbe470932852044$var$_initializerDefineProperty(this, "costCentreId", $edbe470932852044$var$_descriptor8, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $1UDCR.default);
        this.init(data, options);
    }
    get costCentre() {
        return (0, $eNcHX.default).modelsById[this.costCentreId];
    }
    valueInDateRange(startDate, endDate) {
        if (!this.startDate) return 0;
        if (this.startDate > endDate) return 0;
        if (this.endDate && this.endDate < startDate) return 0;
        const adjustedEndDate = this.endDate && this.endDate <= endDate ? this.endDate : endDate;
        if (!this.hasRepeat || !this.repeatQuantity) {
            if (this.startDate >= startDate && this.startDate <= adjustedEndDate) return this.value;
            return 0;
        }
        const differenceLookup = {
            days: (0, $4hBm1.differenceInDays),
            weeks: (0, $4hBm1.differenceInWeeks),
            months: (0, $4hBm1.differenceInMonths),
            years: (0, $4hBm1.differenceInYears)
        };
        const addLookup = {
            days: (0, $4hBm1.addDays),
            weeks: (0, $4hBm1.addWeeks),
            months: (0, $4hBm1.addMonths),
            years: (0, $4hBm1.addYears)
        };
        const currentRepeatUnitDifference = differenceLookup[this.repeatUnit];
        const currentRepeatUnitAdd = addLookup[this.repeatUnit];
        const diff = currentRepeatUnitDifference((0, $4hBm1.addDays)(endDate, 1), startDate);
        const startDiff = currentRepeatUnitDifference(startDate, this.startDate);
        if (diff < 0) return 0;
        let numRepeatsInRange = 0;
        let currentRepeatDate = this.startDate;
        while(currentRepeatDate <= adjustedEndDate){
            if (currentRepeatDate >= startDate) numRepeatsInRange++;
            currentRepeatDate = currentRepeatUnitAdd(currentRepeatDate, this.repeatQuantity);
        }
        return numRepeatsInRange * this.value;
    }
}, $edbe470932852044$var$_descriptor = $edbe470932852044$var$_applyDecoratedDescriptor($edbe470932852044$var$_class.prototype, "name", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $edbe470932852044$var$_descriptor2 = $edbe470932852044$var$_applyDecoratedDescriptor($edbe470932852044$var$_class.prototype, "value", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $edbe470932852044$var$_descriptor3 = $edbe470932852044$var$_applyDecoratedDescriptor($edbe470932852044$var$_class.prototype, "startDate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $edbe470932852044$var$_descriptor4 = $edbe470932852044$var$_applyDecoratedDescriptor($edbe470932852044$var$_class.prototype, "endDate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $edbe470932852044$var$_descriptor5 = $edbe470932852044$var$_applyDecoratedDescriptor($edbe470932852044$var$_class.prototype, "hasRepeat", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $edbe470932852044$var$_descriptor6 = $edbe470932852044$var$_applyDecoratedDescriptor($edbe470932852044$var$_class.prototype, "repeatQuantity", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $edbe470932852044$var$_descriptor7 = $edbe470932852044$var$_applyDecoratedDescriptor($edbe470932852044$var$_class.prototype, "repeatUnit", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $edbe470932852044$var$_descriptor8 = $edbe470932852044$var$_applyDecoratedDescriptor($edbe470932852044$var$_class.prototype, "costCentreId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $edbe470932852044$var$_applyDecoratedDescriptor($edbe470932852044$var$_class.prototype, "costCentre", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($edbe470932852044$var$_class.prototype, "costCentre"), $edbe470932852044$var$_class.prototype), $edbe470932852044$var$_class);
var $edbe470932852044$export$2e2bcd8739ae039 = $edbe470932852044$var$OverheadExpenseModel;

});


parcelRegister("gJT7h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2fb9a4944f61187$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "ProjectCollectionClass", function () { return $c2fb9a4944f61187$export$ca2e4d934c5013d7; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $tJMOs = parcelRequire("tJMOs");

var $eNcHX = parcelRequire("eNcHX");

var $XoImS = parcelRequire("XoImS");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");
var $c2fb9a4944f61187$var$_dec, $c2fb9a4944f61187$var$_dec2, $c2fb9a4944f61187$var$_dec3, $c2fb9a4944f61187$var$_class;
function $c2fb9a4944f61187$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $c2fb9a4944f61187$var$ProjectCollection = ($c2fb9a4944f61187$var$_dec = (0, $4JcCM.action).bound, $c2fb9a4944f61187$var$_dec2 = (0, $4JcCM.action).bound, $c2fb9a4944f61187$var$_dec3 = (0, $4JcCM.action).bound, $c2fb9a4944f61187$var$_class = class ProjectCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "projects",
            modelClass: (0, $tJMOs.default)
        });
        this.addLookup("projectsByOwnerId", "manyByKey", {
            key: (t)=>t.ownerId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("projectsByContactId", "manyByKey", {
            key: (t)=>t.contactId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("projectsByPrimaryContactId", "manyByKey", {
            key: (t)=>t.primaryContactId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("projectsByCostCentreId", "manyByKey", {
            key: (t)=>t.costCentre,
            filter: (t)=>!t.deletedAt
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get projectsById() {
        return this.modelsById;
    }
    get projects() {
        return this.models;
    }
    addProject(data) {
        return this.add(data);
    }
    addProjects(data) {
        return this.addMany(data);
    }
    createProject() {
        // Find the first allowed cost centre from the available options
        const costCentreId = [
            ...(0, $eNcHX.default).activeBillableCostCentres,
            ...(0, $eNcHX.default).activeCostCentres,
            ...(0, $eNcHX.default).costCentres
        ].find((cc)=>(0, $8kZ1o.canEditProject)((0, $1BTI2.default).user, {
                id: "",
                ownerId: (0, $1BTI2.default).user.id,
                costCentreId: cc.id
            })).id;
        const project = this.add({
            name: "New Project",
            costCentreId: costCentreId,
            milestoneType: "monthly"
        }, {
            trackUpdates: true
        });
        const phase = (0, $XoImS.default).createPhase(project.id);
        const rootPhase = (0, $XoImS.default).createRootPhase(project.id);
        project.update({
            rootPhaseId: rootPhase.id
        });
        return project;
    }
}, $c2fb9a4944f61187$var$_applyDecoratedDescriptor($c2fb9a4944f61187$var$_class.prototype, "addProject", [
    $c2fb9a4944f61187$var$_dec
], Object.getOwnPropertyDescriptor($c2fb9a4944f61187$var$_class.prototype, "addProject"), $c2fb9a4944f61187$var$_class.prototype), $c2fb9a4944f61187$var$_applyDecoratedDescriptor($c2fb9a4944f61187$var$_class.prototype, "addProjects", [
    $c2fb9a4944f61187$var$_dec2
], Object.getOwnPropertyDescriptor($c2fb9a4944f61187$var$_class.prototype, "addProjects"), $c2fb9a4944f61187$var$_class.prototype), $c2fb9a4944f61187$var$_applyDecoratedDescriptor($c2fb9a4944f61187$var$_class.prototype, "createProject", [
    $c2fb9a4944f61187$var$_dec3
], Object.getOwnPropertyDescriptor($c2fb9a4944f61187$var$_class.prototype, "createProject"), $c2fb9a4944f61187$var$_class.prototype), $c2fb9a4944f61187$var$_class);
var $c2fb9a4944f61187$export$2e2bcd8739ae039 = new $c2fb9a4944f61187$var$ProjectCollection();
const $c2fb9a4944f61187$export$ca2e4d934c5013d7 = $c2fb9a4944f61187$var$ProjectCollection;

});
parcelRegister("tJMOs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $059639c0fe4f4885$export$2e2bcd8739ae039; });

var $7CaHe = parcelRequire("7CaHe");

var $eat5C = parcelRequire("eat5C");

var $4JcCM = parcelRequire("4JcCM");

var $62nmb = parcelRequire("62nmb");

var $bhvQG = parcelRequire("bhvQG");

var $eNcHX = parcelRequire("eNcHX");

var $9VnJj = parcelRequire("9VnJj");

var $cxnwP = parcelRequire("cxnwP");

var $XoImS = parcelRequire("XoImS");

var $cfp1m = parcelRequire("cfp1m");

var $avf6p = parcelRequire("avf6p");

var $htkeB = parcelRequire("htkeB");

var $QiMYe = parcelRequire("QiMYe");

var $3PpOX = parcelRequire("3PpOX");
parcelRequire("dtopU");

var $gJT7h = parcelRequire("gJT7h");

var $jc1Yz = parcelRequire("jc1Yz");

var $gkMXq = parcelRequire("gkMXq");

var $3cqhz = parcelRequire("3cqhz");

var $jYjJH = parcelRequire("jYjJH");

var $4tYKG = parcelRequire("4tYKG");

var $kRqe9 = parcelRequire("kRqe9");

var $64hVI = parcelRequire("64hVI");

var $hSUCJ = parcelRequire("hSUCJ");

var $keGWP = parcelRequire("keGWP");

var $d4jhX = parcelRequire("d4jhX");

var $jg8jZ = parcelRequire("jg8jZ");

var $4hBm1 = parcelRequire("4hBm1");


var $6fNfM = parcelRequire("6fNfM");

var $liJtZ = parcelRequire("liJtZ");
var $059639c0fe4f4885$var$_dec, $059639c0fe4f4885$var$_dec2, $059639c0fe4f4885$var$_dec3, $059639c0fe4f4885$var$_class, $059639c0fe4f4885$var$_descriptor, $059639c0fe4f4885$var$_descriptor2, $059639c0fe4f4885$var$_descriptor3, $059639c0fe4f4885$var$_descriptor4, $059639c0fe4f4885$var$_descriptor5, $059639c0fe4f4885$var$_descriptor6, $059639c0fe4f4885$var$_descriptor7, $059639c0fe4f4885$var$_descriptor8, $059639c0fe4f4885$var$_descriptor9, $059639c0fe4f4885$var$_descriptor10, $059639c0fe4f4885$var$_descriptor11, $059639c0fe4f4885$var$_descriptor12, $059639c0fe4f4885$var$_descriptor13, $059639c0fe4f4885$var$_descriptor14, $059639c0fe4f4885$var$_descriptor15, $059639c0fe4f4885$var$_descriptor16;
function $059639c0fe4f4885$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $059639c0fe4f4885$var$_defineProperty(e, r, t) {
    return (r = $059639c0fe4f4885$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $059639c0fe4f4885$var$_toPropertyKey(t) {
    var i = $059639c0fe4f4885$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $059639c0fe4f4885$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $059639c0fe4f4885$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $059639c0fe4f4885$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $059639c0fe4f4885$var$ProjectModel = ($059639c0fe4f4885$var$_dec = (0, $4JcCM.action).bound, $059639c0fe4f4885$var$_dec2 = (0, $4JcCM.action).bound, $059639c0fe4f4885$var$_dec3 = (0, $4JcCM.action).bound, $059639c0fe4f4885$var$_class = class ProjectModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $059639c0fe4f4885$var$_initializerDefineProperty(this, "jobNumber", $059639c0fe4f4885$var$_descriptor, this);
        $059639c0fe4f4885$var$_initializerDefineProperty(this, "name", $059639c0fe4f4885$var$_descriptor2, this);
        $059639c0fe4f4885$var$_initializerDefineProperty(this, "ownerId", $059639c0fe4f4885$var$_descriptor3, this);
        $059639c0fe4f4885$var$_initializerDefineProperty(this, "contactId", $059639c0fe4f4885$var$_descriptor4, this);
        $059639c0fe4f4885$var$_initializerDefineProperty(this, "primaryContactId", $059639c0fe4f4885$var$_descriptor5, this);
        $059639c0fe4f4885$var$_initializerDefineProperty(this, "costCentreId", $059639c0fe4f4885$var$_descriptor6, this);
        $059639c0fe4f4885$var$_initializerDefineProperty(this, "rootPhaseId", $059639c0fe4f4885$var$_descriptor7, this);
        $059639c0fe4f4885$var$_initializerDefineProperty(this, "milestoneType", $059639c0fe4f4885$var$_descriptor8, this);
        $059639c0fe4f4885$var$_initializerDefineProperty(this, "address", $059639c0fe4f4885$var$_descriptor9, this);
        $059639c0fe4f4885$var$_initializerDefineProperty(this, "invoiceRef", $059639c0fe4f4885$var$_descriptor10, this);
        $059639c0fe4f4885$var$_initializerDefineProperty(this, "invoiceOpen", $059639c0fe4f4885$var$_descriptor11, this);
        $059639c0fe4f4885$var$_initializerDefineProperty(this, "invoiceClose", $059639c0fe4f4885$var$_descriptor12, this);
        $059639c0fe4f4885$var$_initializerDefineProperty(this, "durationUnit", $059639c0fe4f4885$var$_descriptor13, this);
        $059639c0fe4f4885$var$_initializerDefineProperty(this, "feeData", $059639c0fe4f4885$var$_descriptor14, this);
        $059639c0fe4f4885$var$_initializerDefineProperty(this, "_startDate", $059639c0fe4f4885$var$_descriptor15, this);
        $059639c0fe4f4885$var$_initializerDefineProperty(this, "_endDate", $059639c0fe4f4885$var$_descriptor16, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $gJT7h.default);
        this.init(data, options);
    }
    get title() {
        return this.jobNumber && this.name ? `${this.jobNumber}: ${this.name}` : this.name || this.jobNumber;
    }
    get owner() {
        return (0, $htkeB.default).modelsById[this.ownerId];
    }
    get contact() {
        return (0, $bhvQG.default).modelsById[this.contactId];
    }
    get primaryContact() {
        return (0, $bhvQG.default).modelsById[this.primaryContactId];
    }
    get costCentre() {
        return (0, $eNcHX.default).modelsById[this.costCentreId];
    }
    get allocations() {
        return (0, $jg8jZ.default).allocationsByProjectId[this.id] || [];
    }
    get dailyAllocations() {
        return (0, $9VnJj.default).dailyAllocationsByProjectId[this.id] || [];
    }
    get rootPhase() {
        return (0, $XoImS.default).modelsById[this.rootPhaseId] || this.phases.find((ph)=>ph === null || ph === void 0 ? void 0 : ph.isRootPhase) || {
            id: this.rootPhaseId
        };
    }
    get phases() {
        return ((0, $XoImS.default).phasesByProjectId[this.id] || []).sort((0, $6fNfM.default));
    }
    get expenses() {
        return (0, $cfp1m.default).expensesByProjectId[this.id] || [];
    }
    get expenseAllocations() {
        return (0, $d4jhX.default).expenseAllocationsByProjectId[this.id] || [];
    }
    get rates() {
        return (0, $avf6p.default).ratesByProjectId[this.id] || [];
    }
    get ratesWithOutPhases() {
        return this.rates.filter((r)=>!r.phaseId || r.phase === this.rootPhase);
    }
    get timeEntries() {
        return (0, $QiMYe.default).timeEntriesByProjectId[this.id] || [];
    }
    get invoiceLineItems() {
        return (0, $kRqe9.default).lineItemsByProjectId[this.id] || [];
    }
    get revenueTargets() {
        return (0, $64hVI.default).revenueTargetsByProjectId[this.id] || [];
    }
    get status() {
        return this._status || (0, $3cqhz.statusByPriority)[(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).min(this.phases.map((ph)=>(0, $3cqhz.statusPriorities)[ph.status]))] || "archived";
    }
    get phaseStatuses() {
        return this.phases.map((ph)=>ph.status);
    }
    get startDate() {
        return this._startDate || (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).min(this.phases.filter((ph)=>!(ph !== null && ph !== void 0 && ph.deletedAt) && !(ph !== null && ph !== void 0 && ph.isRootPhase)).map((ph)=>ph.startDate));
    }
    get endDate() {
        return this._endDate || (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).max(this.phases.filter((ph)=>!(ph !== null && ph !== void 0 && ph.deletedAt) && !(ph !== null && ph !== void 0 && ph.isRootPhase)).map((ph)=>ph.endDate));
    }
    get fee() {
        return this._fee || (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.phases.filter((ph)=>!(ph !== null && ph !== void 0 && ph.deletedAt) && !(ph !== null && ph !== void 0 && ph.isRootPhase)).map((ph)=>ph.fee));
    }
    get expenseBudget() {
        return this._expenseBudget || (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.phases.filter((ph)=>!(ph !== null && ph !== void 0 && ph.deletedAt) && !(ph !== null && ph !== void 0 && ph.isRootPhase)).map((ph)=>ph.expenseBudget));
    }
    get hoursBudget() {
        return this._hoursBudget || (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.phases.filter((ph)=>!(ph !== null && ph !== void 0 && ph.deletedAt) && !(ph !== null && ph !== void 0 && ph.isRootPhase)).map((ph)=>ph.hoursBudget)) || 0;
    }
    get percentLikelihood() {
        return this._percentLikelihood || (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.phases.filter((ph)=>!(ph !== null && ph !== void 0 && ph.deletedAt) && !(ph !== null && ph !== void 0 && ph.isRootPhase)).map((ph)=>ph.feeAdjustedByLikelihood)) / this.fee;
    }
    getAggregateInvoiceLineItems(group) {
        return (0, $4tYKG.default).getGroupCollection(group).lineItemsByProjectId[this.id] || [];
    }
    getAggregateTimeEntries(group) {
        return (0, $jYjJH.default).getGroupCollection(group).timeEntriesByProjectId[this.id] || [];
    }
    get invoices() {
        return (0, $cxnwP.default).invoicesByProjectId[this.id] || [];
    }
    get notes() {
        return (0, $jc1Yz.default).notesByProjectId[this.id] || [];
    }
    get milestones() {
        return (0, $liJtZ.default).milestonesByProjectId[this.id] || [];
    }
    get changeLog() {
        return (0, $gkMXq.default).changeLogItemsByProjectId[this.id] || [];
    }
    get duration() {
        return (0, $7CaHe.unitsBetween)(this.startDate, this.endDate, this.durationUnit);
    }
    get feeAdjustedByLikelihood() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.phases.map((ph)=>ph.feeAdjustedByLikelihood));
    }
    get budgets() {
        return (0, $hSUCJ.default).budgetsByProjectId[this.id] || [];
    }
    get hoursFromBudgets() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.budgets.map((b)=>b.hours));
    }
    get costFromBudgets() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.budgets.map((b)=>b.cost));
    }
    get costRate() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).mean(this.budgets.map((b)=>b.costRate));
    }
    get chargeOutRate() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).mean(this.budgets.map((b)=>b.chargeOutRate));
    }
    get tasks() {
        return (0, $keGWP.default).tasksByProjectId[this.id] || [];
    }
    updatePhaseValues(data) {
        this.phases.filter((ph)=>!(ph !== null && ph !== void 0 && ph.deletedAt) && !(ph !== null && ph !== void 0 && ph.isRootPhase)).forEach((ph)=>ph.update(data));
    }
    scaleValueAcrossPhases(prop, value) {
        const total = this[prop];
        const multiplier = total ? value / total : 0;
        const numPhases = this.phases.length;
        this.phases.filter((ph)=>!(ph !== null && ph !== void 0 && ph.deletedAt) && !(ph !== null && ph !== void 0 && ph.isRootPhase)).forEach((ph)=>{
            const data = {};
            data[prop] = multiplier ? ph[prop] * multiplier : value / numPhases;
            ph.update(data);
        });
    // this.update({ [prop]: value })
    }
    scaleDatesAcrossPhases({ startDate: startDate, endDate: endDate, duration: duration }) {
        const newStartDate = startDate !== null && startDate !== void 0 ? startDate : this.startDate;
        const newEndDate = endDate || (duration ? (0, $7CaHe.addUnitToDate)(newStartDate, duration.unit, duration.value) : this.endDate);
        if (newEndDate && newStartDate && this.startDate && this.endDate && this.endDate - this.startDate) {
            const newDuration = (0, $4hBm1.startOfDay)(newEndDate) - (0, $4hBm1.startOfDay)(newStartDate);
            const oldDuration = (0, $4hBm1.startOfDay)(this.endDate) - (0, $4hBm1.startOfDay)(this.startDate);
            const multiplier = this.startDate && this.endDate ? newDuration / oldDuration : 0;
            const cachedStartDate = (0, $4hBm1.startOfDay)(this.startDate);
            this.phases.filter((ph)=>!(ph !== null && ph !== void 0 && ph.deletedAt) && !(ph !== null && ph !== void 0 && ph.isRootPhase)).forEach((ph)=>{
                const data = {};
                if (ph.startDate && ph.endDate) {
                    const distanceToStart = (0, $4hBm1.startOfDay)(ph.startDate) - cachedStartDate;
                    const newDistanceToStart = distanceToStart * multiplier;
                    const distanceToEnd = (0, $4hBm1.startOfDay)(ph.endDate) - cachedStartDate;
                    const newDistanceToEnd = distanceToEnd * multiplier;
                    data.startDate = (0, $4hBm1.addMilliseconds)((0, $4hBm1.startOfDay)(newStartDate), newDistanceToStart);
                    data.endDate = (0, $4hBm1.addMilliseconds)((0, $4hBm1.startOfDay)(newStartDate), newDistanceToEnd);
                    ph.update(data);
                }
            });
        } else this.phases.filter((ph)=>!(ph !== null && ph !== void 0 && ph.deletedAt) && !(ph !== null && ph !== void 0 && ph.isRootPhase)).forEach((ph)=>{
            const data = {};
            if (newStartDate) data.startDate = newStartDate;
            if (newEndDate) data.endDate = newEndDate;
            ph.update(data);
        });
        this.update({
            _startDate: newStartDate,
            _endDate: newEndDate
        });
    }
}, $059639c0fe4f4885$var$_descriptor = $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "jobNumber", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $059639c0fe4f4885$var$_descriptor2 = $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "name", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $059639c0fe4f4885$var$_descriptor3 = $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "ownerId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $059639c0fe4f4885$var$_descriptor4 = $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "contactId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $059639c0fe4f4885$var$_descriptor5 = $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "primaryContactId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $059639c0fe4f4885$var$_descriptor6 = $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "costCentreId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $059639c0fe4f4885$var$_descriptor7 = $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "rootPhaseId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $059639c0fe4f4885$var$_descriptor8 = $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "milestoneType", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $059639c0fe4f4885$var$_descriptor9 = $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "address", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $059639c0fe4f4885$var$_descriptor10 = $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "invoiceRef", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $059639c0fe4f4885$var$_descriptor11 = $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "invoiceOpen", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $059639c0fe4f4885$var$_descriptor12 = $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "invoiceClose", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $059639c0fe4f4885$var$_descriptor13 = $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "durationUnit", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "weeks";
    }
}), $059639c0fe4f4885$var$_descriptor14 = $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "feeData", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $059639c0fe4f4885$var$_descriptor15 = $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "_startDate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $059639c0fe4f4885$var$_descriptor16 = $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "_endDate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "title", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "title"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "owner", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "owner"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "contact", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "contact"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "primaryContact", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "primaryContact"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "costCentre", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "costCentre"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "allocations", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "allocations"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "dailyAllocations", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "dailyAllocations"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "rootPhase", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "rootPhase"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "phases", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "phases"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "expenses", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "expenses"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "expenseAllocations", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "expenseAllocations"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "rates", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "rates"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "ratesWithOutPhases", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "ratesWithOutPhases"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "timeEntries", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "timeEntries"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "invoiceLineItems", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "invoiceLineItems"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "revenueTargets", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "revenueTargets"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "status", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "status"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "phaseStatuses", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "phaseStatuses"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "startDate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "startDate"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "endDate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "endDate"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "fee", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "fee"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "expenseBudget", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "expenseBudget"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "hoursBudget", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "hoursBudget"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "percentLikelihood", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "percentLikelihood"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "getAggregateInvoiceLineItems", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "getAggregateInvoiceLineItems"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "getAggregateTimeEntries", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "getAggregateTimeEntries"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "invoices", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "invoices"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "notes", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "notes"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "milestones", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "milestones"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "changeLog", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "changeLog"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "duration", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "duration"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "feeAdjustedByLikelihood", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "feeAdjustedByLikelihood"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "budgets", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "budgets"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "hoursFromBudgets", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "hoursFromBudgets"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "costFromBudgets", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "costFromBudgets"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "costRate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "costRate"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "chargeOutRate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "chargeOutRate"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "tasks", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "tasks"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "updatePhaseValues", [
    $059639c0fe4f4885$var$_dec
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "updatePhaseValues"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "scaleValueAcrossPhases", [
    $059639c0fe4f4885$var$_dec2
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "scaleValueAcrossPhases"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_applyDecoratedDescriptor($059639c0fe4f4885$var$_class.prototype, "scaleDatesAcrossPhases", [
    $059639c0fe4f4885$var$_dec3
], Object.getOwnPropertyDescriptor($059639c0fe4f4885$var$_class.prototype, "scaleDatesAcrossPhases"), $059639c0fe4f4885$var$_class.prototype), $059639c0fe4f4885$var$_class);
var $059639c0fe4f4885$export$2e2bcd8739ae039 = $059639c0fe4f4885$var$ProjectModel;

});
parcelRegister("7CaHe", function(module, exports) {

$parcel$export(module.exports, "addDurationToDate", function () { return $58b46115d06468a1$export$b0b9186f096842bc; });
$parcel$export(module.exports, "subDurationFromDate", function () { return $58b46115d06468a1$export$2acccb27f7c18e8b; });
$parcel$export(module.exports, "addUnitToDate", function () { return $58b46115d06468a1$export$e67f4f35bc7fad1f; });
$parcel$export(module.exports, "durationBetween", function () { return $58b46115d06468a1$export$dac0301a751c64f9; });
$parcel$export(module.exports, "unitsBetween", function () { return $58b46115d06468a1$export$ff74dd385b40196b; });
$parcel$export(module.exports, "durationToUnit", function () { return $58b46115d06468a1$export$84baba02af9b54f1; });
$parcel$export(module.exports, "simplifyDuration", function () { return $58b46115d06468a1$export$85335542364f2c3c; });
$parcel$export(module.exports, "addDurations", function () { return $58b46115d06468a1$export$d90cff250d80b8d5; });
$parcel$export(module.exports, "subDurations", function () { return $58b46115d06468a1$export$ab7d8420641701da; });
$parcel$export(module.exports, "multiplyDurationBy", function () { return $58b46115d06468a1$export$4bb9989206c0c95a; });
$parcel$export(module.exports, "divideDurationBy", function () { return $58b46115d06468a1$export$b6d8ac47fbe34e37; });
$parcel$export(module.exports, "multiplyDurations", function () { return $58b46115d06468a1$export$5ca73923d010dd6; });
$parcel$export(module.exports, "divideDurations", function () { return $58b46115d06468a1$export$45e93477efb4ac86; });
$parcel$export(module.exports, "dividePowerDurationByDuration", function () { return $58b46115d06468a1$export$51e7136ebb73df6d; });
$parcel$export(module.exports, "simplifyRate", function () { return $58b46115d06468a1$export$95db8b86ccd412e; });
$parcel$export(module.exports, "ratePerUnit", function () { return $58b46115d06468a1$export$12664029541be726; });
$parcel$export(module.exports, "addRates", function () { return $58b46115d06468a1$export$98a0ed8290b61472; });
$parcel$export(module.exports, "subRates", function () { return $58b46115d06468a1$export$e58bd1b2c8c49236; });
$parcel$export(module.exports, "divideRates", function () { return $58b46115d06468a1$export$ff03227f9dcbe87b; });
$parcel$export(module.exports, "multiplyRateBy", function () { return $58b46115d06468a1$export$f666dc173acbafa6; });
$parcel$export(module.exports, "divideRateBy", function () { return $58b46115d06468a1$export$de24eaed3792859a; });
$parcel$export(module.exports, "multiplyRateByDuration", function () { return $58b46115d06468a1$export$a85789518397f9c7; });
$parcel$export(module.exports, "divideNumberByRate", function () { return $58b46115d06468a1$export$b270334d34e4cd72; });
const $58b46115d06468a1$export$a2dedfdebd31dc15 = (date)=>{
    return date ? new Date(date.getTime ? date.getTime() : date) : date;
};
const $58b46115d06468a1$export$dc59854f87f8c633 = ()=>new Date(1970, 0, 1);
const $58b46115d06468a1$export$18bceafa8e89d4f1 = (...args)=>{
    let date;
    for (const arg of args){
        date = new Date(arg && arg.getTime ? arg.getTime() : arg);
        if (date instanceof Date && date.getTime()) break;
    }
    if (!(date instanceof Date) || !date.getTime()) date = $58b46115d06468a1$export$dc59854f87f8c633();
    return date;
};
const $58b46115d06468a1$var$millisecondsMs = 1;
const $58b46115d06468a1$var$secondsMs = 1000;
const $58b46115d06468a1$var$minutesMs = $58b46115d06468a1$var$secondsMs * 60;
const $58b46115d06468a1$var$hoursMs = $58b46115d06468a1$var$minutesMs * 60;
const $58b46115d06468a1$var$daysMs = $58b46115d06468a1$var$hoursMs * 24;
const $58b46115d06468a1$var$weeksMs = $58b46115d06468a1$var$daysMs * 7;
const $58b46115d06468a1$var$yearsMs = $58b46115d06468a1$var$daysMs * 365.25;
const $58b46115d06468a1$var$monthsMs = $58b46115d06468a1$var$yearsMs / 12;
const $58b46115d06468a1$export$777ea3b65ea6cd37 = {
    milliseconds: $58b46115d06468a1$var$millisecondsMs,
    seconds: $58b46115d06468a1$var$secondsMs,
    minutes: $58b46115d06468a1$var$minutesMs,
    hours: $58b46115d06468a1$var$hoursMs,
    days: $58b46115d06468a1$var$daysMs,
    weeks: $58b46115d06468a1$var$weeksMs,
    months: $58b46115d06468a1$var$monthsMs,
    years: $58b46115d06468a1$var$yearsMs
};
const $58b46115d06468a1$export$7f410c9d36db5855 = [
    "milliseconds",
    "seconds",
    "minutes",
    "hours",
    "days",
    "months",
    "years"
];
const $58b46115d06468a1$export$5af1a5e21a4153cd = [
    "milliseconds",
    "seconds",
    "minutes",
    "hours"
];
const $58b46115d06468a1$export$c0d5be433dca6a61 = {
    milliseconds: (date)=>date.getMilliseconds(),
    seconds: (date)=>date.getSeconds(),
    minutes: (date)=>date.getMinutes(),
    hours: (date)=>date.getHours(),
    days: (date)=>date.getDate(),
    months: (date)=>date.getMonth(),
    years: (date)=>date.getFullYear()
};
const $58b46115d06468a1$export$ddd519109d59f0c0 = {
    milliseconds: (date, val)=>$58b46115d06468a1$export$18bceafa8e89d4f1(date.setMilliseconds(val)),
    seconds: (date, val)=>$58b46115d06468a1$export$18bceafa8e89d4f1(date.setSeconds(val)),
    minutes: (date, val)=>$58b46115d06468a1$export$18bceafa8e89d4f1(date.setMinutes(val)),
    hours: (date, val)=>$58b46115d06468a1$export$18bceafa8e89d4f1(date.setHours(val)),
    days: (date, val)=>$58b46115d06468a1$export$18bceafa8e89d4f1(date.setDate(val)),
    months: (date, val)=>$58b46115d06468a1$export$18bceafa8e89d4f1(date.setMonth(val)),
    years: (date, val)=>$58b46115d06468a1$export$18bceafa8e89d4f1(date.setFullYear(val))
};
const $58b46115d06468a1$export$b8af2f8c53d557f5 = {
    milliseconds: null,
    seconds: "milliseconds",
    minutes: "seconds",
    hours: "minutes",
    days: "hours",
    months: "days",
    years: "months"
};
const $58b46115d06468a1$export$a9b3c5dc6730b3ca = {
    milliseconds: "seconds",
    seconds: "minutes",
    minutes: "hours",
    hours: "days",
    days: "months",
    months: "years",
    years: null
};
const $58b46115d06468a1$export$cdc30aac289e199f = {
    milliseconds: (date)=>date.getMilliseconds() === $58b46115d06468a1$export$156b9d843f318f59.milliseconds(date) - 1,
    seconds: (date)=>date.getSeconds() === $58b46115d06468a1$export$156b9d843f318f59.seconds(date) - 1,
    minutes: (date)=>date.getMinutes() === $58b46115d06468a1$export$156b9d843f318f59.minutes(date) - 1,
    hours: (date)=>date.getHours() === $58b46115d06468a1$export$156b9d843f318f59.hours(date) - 1,
    days: (date)=>date.getDate() === $58b46115d06468a1$export$156b9d843f318f59.days(date),
    months: (date)=>date.getMonth() === $58b46115d06468a1$export$156b9d843f318f59.months(date) - 1,
    years: (date)=>false
};
const $58b46115d06468a1$export$156b9d843f318f59 = {
    milliseconds: (date)=>1000,
    seconds: (date)=>60,
    minutes: (date)=>60,
    hours: (date)=>$58b46115d06468a1$export$312b4fb286fbf746(date),
    days: (date)=>$58b46115d06468a1$export$4169ecd548fbc13a(date),
    months: (date)=>12,
    years: (date)=>Infinity
};
const $58b46115d06468a1$export$91484f0a85192b80 = {
    milliseconds: 0,
    seconds: 0,
    minutes: 0,
    hours: 0,
    days: 1,
    months: 0,
    years: 1
};
const $58b46115d06468a1$export$312b4fb286fbf746 = (date)=>{
    const startOfDay = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const dayAfter = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1);
    return (dayAfter - startOfDay) / $58b46115d06468a1$var$hoursMs;
};
const $58b46115d06468a1$export$4169ecd548fbc13a = (date)=>{
    // next month -1 day
    return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
};
const $58b46115d06468a1$export$fad1291dbb043924 = (startDate, endDate, unit)=>{
    startDate = $58b46115d06468a1$export$18bceafa8e89d4f1(startDate);
    endDate = $58b46115d06468a1$export$18bceafa8e89d4f1(endDate);
    // if a date is at the end of a month and can screw up future calculations
    // as the length of an month can vary - same with day length
    const adjustDay = !unit || unit === "months";
    const adjustHour = !unit || unit === "days";
    // if date is the end of the month we can move backwards 3 days
    // as every month has at least 28 days
    // note: we need to move the date backwards not forwards
    // as 31 Jan -> 28/29 Feb (01 Jan-01 Feb) would end up being 1 month long
    // and will break when adding a duration to a date, ie. 31 Jan + 1 month = 02 March
    let addHours = (adjustDay && $58b46115d06468a1$export$cdc30aac289e199f["days"](startDate) ? -75 : 0) + // 25 hours to account for dst
    (adjustHour && $58b46115d06468a1$export$cdc30aac289e199f["hours"](startDate) ? -2 : 0);
    if (addHours) {
        startDate = new Date(startDate.getTime() + addHours * $58b46115d06468a1$export$777ea3b65ea6cd37["hours"]);
        endDate = new Date(endDate.getTime() + addHours * $58b46115d06468a1$export$777ea3b65ea6cd37["hours"]);
    }
    return {
        startDate: startDate,
        endDate: endDate
    };
};
const $58b46115d06468a1$export$92ef078ca7486c9 = (startDate, endDate, unit)=>{
    startDate = $58b46115d06468a1$export$18bceafa8e89d4f1(startDate);
    endDate = $58b46115d06468a1$export$18bceafa8e89d4f1(endDate);
    let fullUnitEndDate = $58b46115d06468a1$export$a2dedfdebd31dc15(endDate);
    // to make the end date whole units distance away from the start
    // we make all smaller values equal to the start value
    let childUnit = $58b46115d06468a1$export$b8af2f8c53d557f5[unit];
    while(childUnit){
        // end of month/day can a problem here if not adjusted prior
        fullUnitEndDate = $58b46115d06468a1$export$ddd519109d59f0c0[childUnit](fullUnitEndDate, $58b46115d06468a1$export$c0d5be433dca6a61[childUnit](startDate));
        childUnit = $58b46115d06468a1$export$b8af2f8c53d557f5[childUnit];
    }
    // if the endDate unit in the opposite direction to the date direction
    // we will have accidently moved the dates outside the original range
    // and need to adjust by +/- 1 unit to move it back withing the range
    const direction = Math.sign(endDate - startDate) || 1;
    const newDirection = Math.sign(fullUnitEndDate - endDate);
    if (newDirection && direction == newDirection) fullUnitEndDate = $58b46115d06468a1$export$ddd519109d59f0c0[unit](fullUnitEndDate, $58b46115d06468a1$export$c0d5be433dca6a61[unit](endDate) - direction);
    return fullUnitEndDate;
};
const $58b46115d06468a1$export$e2712fcf05dd337f = (duration)=>{
    const days = duration.days;
    duration.weeks = Math.trunc(days / 7);
    duration.days = days - duration.weeks * 7;
    return duration;
};
const $58b46115d06468a1$export$1c9cfa9873a168c2 = (duration)=>{
    return $58b46115d06468a1$export$bf567c9b3ce5f8ca({
        ...$58b46115d06468a1$export$95fc0d6fa0606c9f,
        ...duration
    });
};
const $58b46115d06468a1$export$bf567c9b3ce5f8ca = (duration)=>{
    if (duration.dateRef || "dateRef" in duration) Object.defineProperty(duration, "dateRef", {
        enumerable: false,
        value: duration.dateRef
    });
    return duration;
};
const $58b46115d06468a1$export$2b6d965b96c60588 = (duration)=>$58b46115d06468a1$export$bf567c9b3ce5f8ca({
        ...duration
    });
const $58b46115d06468a1$export$95fc0d6fa0606c9f = $58b46115d06468a1$export$bf567c9b3ce5f8ca({
    dateRef: null,
    milliseconds: 0,
    seconds: 0,
    minutes: 0,
    hours: 0,
    days: 0,
    weeks: 0,
    months: 0,
    years: 0
});
const $58b46115d06468a1$export$b0b9186f096842bc = (date, duration)=>{
    date = $58b46115d06468a1$export$18bceafa8e89d4f1(date);
    duration = $58b46115d06468a1$export$1c9cfa9873a168c2(duration);
    const months = duration.years * 12 + duration.months;
    const partialMonths = months % 1;
    const days = duration.weeks * 7 + duration.days;
    const partialDays = days % 1;
    const partialHours = duration.hours % 1;
    const partialMinutes = duration.minutes % 1;
    const partialSeconds = duration.seconds % 1;
    // set date, month, year will always round to lowest integer
    // so we need to add the milliseconds for partial months
    date.setMonth(date.getMonth() + duration.years * 12 + duration.months);
    date.setDate(date.getDate() + duration.weeks * 7 + duration.days);
    date.setHours(date.getHours() + duration.hours, date.getMinutes() + duration.minutes, date.getSeconds() + duration.seconds, date.getMilliseconds() + duration.milliseconds + partialSeconds * $58b46115d06468a1$export$777ea3b65ea6cd37["seconds"] + partialMinutes * $58b46115d06468a1$export$777ea3b65ea6cd37["minutes"] + partialHours * $58b46115d06468a1$export$777ea3b65ea6cd37["hours"] + partialDays * $58b46115d06468a1$export$777ea3b65ea6cd37["days"] + partialMonths * $58b46115d06468a1$export$777ea3b65ea6cd37["months"]);
    return date;
};
const $58b46115d06468a1$export$2acccb27f7c18e8b = (date, duration)=>{
    date = $58b46115d06468a1$export$18bceafa8e89d4f1(date);
    duration = $58b46115d06468a1$export$1c9cfa9873a168c2(duration);
    const months = duration.years * 12 + duration.months;
    const partialMonths = months % 1;
    const days = duration.weeks * 7 + duration.days;
    const partialDays = days % 1;
    const partialHours = duration.hours % 1;
    const partialMinutes = duration.minutes % 1;
    const partialSeconds = duration.seconds % 1;
    // set date, month, year will always round to lowest integer
    // so we need to add the milliseconds for partial months
    date.setMonth(date.getMonth() - duration.years * 12 - duration.months);
    date.setDate(date.getDate() - duration.weeks * 7 - duration.days);
    date.setHours(date.getHours() - duration.hours, date.getMinutes() - duration.minutes, date.getSeconds() - duration.seconds, date.getMilliseconds() - duration.milliseconds - partialSeconds * $58b46115d06468a1$export$777ea3b65ea6cd37["seconds"] - partialMinutes * $58b46115d06468a1$export$777ea3b65ea6cd37["minutes"] - partialHours * $58b46115d06468a1$export$777ea3b65ea6cd37["hours"] - partialDays * $58b46115d06468a1$export$777ea3b65ea6cd37["days"] - partialMonths * $58b46115d06468a1$export$777ea3b65ea6cd37["months"]);
    return date;
};
const $58b46115d06468a1$export$e67f4f35bc7fad1f = (date, unit, value)=>{
    let duration = {};
    duration[unit] = value;
    return $58b46115d06468a1$export$b0b9186f096842bc(date, duration);
};
const $58b46115d06468a1$export$9056ed762f6403cc = (date, unit, value)=>{
    let duration = {};
    duration[unit] = value;
    return $58b46115d06468a1$export$2acccb27f7c18e8b(date, duration);
};
const $58b46115d06468a1$export$1afec20c5ef2a9c5 = (_startDate, _endDate, unit, multiple = 1)=>{
    _startDate = $58b46115d06468a1$export$18bceafa8e89d4f1(_startDate);
    _endDate = $58b46115d06468a1$export$18bceafa8e89d4f1(_endDate);
    if (unit === "weeks") {
        unit = "days";
        multiple = 7;
    }
    const multiUnit = $58b46115d06468a1$export$777ea3b65ea6cd37[unit] * multiple;
    // everything below is unecessary work for standard units of time
    if ($58b46115d06468a1$export$5af1a5e21a4153cd.includes(unit)) return Math.trunc((_endDate - _startDate) / multiUnit);
    let { startDate: startDate, endDate: endDate } = $58b46115d06468a1$export$fad1291dbb043924(_startDate, _endDate, unit);
    // move the end date to be whole units away from the start date
    const fullUnitEndDate = $58b46115d06468a1$export$92ef078ca7486c9(startDate, endDate, unit);
    // although units like days and months can have inconsistant values
    // we know the end date is whole units away from the start
    // and variance in those values are never large enough to cause issue
    // so we can just round the average value
    const fullUnitMs = fullUnitEndDate - startDate;
    let fullUnits = Math.round(fullUnitMs / $58b46115d06468a1$export$777ea3b65ea6cd37[unit]);
    fullUnits = Math.trunc(fullUnits * $58b46115d06468a1$export$777ea3b65ea6cd37[unit] / multiUnit);
    return fullUnits;
};
const $58b46115d06468a1$export$dac0301a751c64f9 = (_startDate, _endDate)=>{
    _startDate = $58b46115d06468a1$export$18bceafa8e89d4f1(_startDate);
    _endDate = $58b46115d06468a1$export$18bceafa8e89d4f1(_endDate);
    let { startDate: startDate, endDate: endDate } = $58b46115d06468a1$export$fad1291dbb043924(_startDate, _endDate);
    let duration = {
        ...$58b46115d06468a1$export$95fc0d6fa0606c9f
    };
    duration.dateRef = $58b46115d06468a1$export$a2dedfdebd31dc15(_startDate);
    const units = [
        ...$58b46115d06468a1$export$7f410c9d36db5855
    ].reverse();
    units.forEach((unit)=>{
        duration[unit] = $58b46115d06468a1$export$1afec20c5ef2a9c5(startDate, endDate, unit);
        startDate = $58b46115d06468a1$export$ddd519109d59f0c0[unit](startDate, $58b46115d06468a1$export$c0d5be433dca6a61[unit](startDate) + duration[unit]);
    });
    duration = $58b46115d06468a1$export$e2712fcf05dd337f(duration);
    return duration;
};
const $58b46115d06468a1$export$9e69f402df51415c = (duration, dateRef)=>{
    let startDate = $58b46115d06468a1$export$18bceafa8e89d4f1(dateRef, duration.dateRef);
    let endDate = $58b46115d06468a1$export$b0b9186f096842bc(startDate, duration);
    return $58b46115d06468a1$export$dac0301a751c64f9(startDate, endDate);
};
const $58b46115d06468a1$export$ff74dd385b40196b = (startDate, endDate, unit, multiple = 1)=>{
    if (unit === "weeks") {
        unit = "days";
        multiple = 7;
    }
    startDate = $58b46115d06468a1$export$18bceafa8e89d4f1(startDate);
    endDate = $58b46115d06468a1$export$18bceafa8e89d4f1(endDate);
    const multiUnit = $58b46115d06468a1$export$777ea3b65ea6cd37[unit] * multiple;
    const fullUnits = $58b46115d06468a1$export$1afec20c5ef2a9c5(startDate, endDate, unit, multiple);
    const fullUnitMs = fullUnits * multiUnit;
    const partialUnitMs = endDate - startDate - fullUnitMs;
    const partialUnits = partialUnitMs / multiUnit;
    return fullUnits + partialUnits;
};
const $58b46115d06468a1$export$84baba02af9b54f1 = (duration, unit, multiple = 1, dateRef)=>{
    let startDate = $58b46115d06468a1$export$18bceafa8e89d4f1(dateRef, duration.dateRef);
    startDate = $58b46115d06468a1$export$a2dedfdebd31dc15(startDate);
    let endDate = $58b46115d06468a1$export$b0b9186f096842bc(startDate, duration);
    return $58b46115d06468a1$export$ff74dd385b40196b(startDate, endDate, unit, multiple);
};
const $58b46115d06468a1$export$d1b23051d75c72d = (_startDate, _endDate)=>{
    _startDate = $58b46115d06468a1$export$18bceafa8e89d4f1(_startDate);
    _endDate = $58b46115d06468a1$export$18bceafa8e89d4f1(_endDate);
    let duration = {};
    duration.dateRef = $58b46115d06468a1$export$a2dedfdebd31dc15(_startDate);
    let smallestUnit = null;
    let parentUnit = $58b46115d06468a1$export$a9b3c5dc6730b3ca["milliseconds"];
    let unitVal = 0;
    while(parentUnit){
        const units = $58b46115d06468a1$export$ff74dd385b40196b(_startDate, _endDate, parentUnit);
        if (units && units % 1 === 0) {
            smallestUnit = parentUnit;
            unitVal = units;
            parentUnit = $58b46115d06468a1$export$a9b3c5dc6730b3ca[parentUnit];
        } else {
            parentUnit = null;
            break;
        }
    }
    // set to milliseconds if no results
    smallestUnit = smallestUnit || "milliseconds";
    unitVal = unitVal || _endDate - _startDate;
    // check weeks
    if (smallestUnit === "days" && unitVal % 7 === 0) {
        smallestUnit = "weeks";
        unitVal = unitVal / 7;
    }
    duration[smallestUnit] = unitVal;
    return $58b46115d06468a1$export$bf567c9b3ce5f8ca(duration);
};
const $58b46115d06468a1$export$85335542364f2c3c = (duration, dateRef)=>{
    let startDate = $58b46115d06468a1$export$18bceafa8e89d4f1(dateRef, duration.dateRef);
    let endDate = $58b46115d06468a1$export$b0b9186f096842bc(startDate, duration);
    return $58b46115d06468a1$export$d1b23051d75c72d(startDate, endDate);
};
const $58b46115d06468a1$export$e0bda707f0133070 = (duration1, duration2)=>{
    duration1 = $58b46115d06468a1$export$85335542364f2c3c(duration1);
    duration2 = $58b46115d06468a1$export$85335542364f2c3c(duration2);
    const duration1Unit = Object.keys(duration1)[0];
    const duration2Unit = Object.keys(duration2)[0];
    const duration2Amount = $58b46115d06468a1$export$84baba02af9b54f1(duration2, duration1Unit);
    let newDuration2 = {};
    newDuration2[duration1Unit] = duration2Amount;
    return [
        duration1,
        newDuration2
    ];
};
const $58b46115d06468a1$export$d90cff250d80b8d5 = (leftDuration, rightDuration)=>{
    leftDuration = $58b46115d06468a1$export$1c9cfa9873a168c2(leftDuration);
    rightDuration = $58b46115d06468a1$export$1c9cfa9873a168c2(rightDuration);
    Object.keys(leftDuration).forEach((unit)=>leftDuration[unit] += rightDuration[unit]);
    leftDuration.dateRef = leftDuration.dateRef || rightDuration.dateRef && $58b46115d06468a1$export$2acccb27f7c18e8b(rightDuration.dateRef, rightDuration);
    return $58b46115d06468a1$export$9e69f402df51415c(leftDuration);
};
const $58b46115d06468a1$export$ab7d8420641701da = (leftDuration, rightDuration)=>{
    leftDuration = $58b46115d06468a1$export$1c9cfa9873a168c2(leftDuration);
    rightDuration = $58b46115d06468a1$export$1c9cfa9873a168c2(rightDuration);
    Object.keys(leftDuration).forEach((unit)=>leftDuration[unit] -= rightDuration[unit]);
    leftDuration.dateRef = leftDuration.dateRef || rightDuration.dateRef && $58b46115d06468a1$export$b0b9186f096842bc(rightDuration.dateRef, rightDuration);
    return $58b46115d06468a1$export$9e69f402df51415c(leftDuration);
};
const $58b46115d06468a1$export$4bb9989206c0c95a = (duration, multiplier)=>{
    duration = $58b46115d06468a1$export$2b6d965b96c60588(duration);
    Object.keys(duration).forEach((unit)=>duration[unit] *= multiplier);
    return $58b46115d06468a1$export$9e69f402df51415c(duration);
};
const $58b46115d06468a1$export$b6d8ac47fbe34e37 = (duration, divider)=>{
    duration = $58b46115d06468a1$export$2b6d965b96c60588(duration);
    Object.keys(duration).forEach((unit)=>duration[unit] /= divider);
    return $58b46115d06468a1$export$9e69f402df51415c(duration);
};
const $58b46115d06468a1$export$d87c1c5f4a8ec3d9 = (duration, transformer = (unit, val)=>val)=>{
    duration = $58b46115d06468a1$export$2b6d965b96c60588(duration);
    Object.keys(duration).forEach((unit)=>duration[unit] = transformer(unit, duration[unit]));
    return $58b46115d06468a1$export$9e69f402df51415c(duration);
};
const $58b46115d06468a1$export$5ca73923d010dd6 = (leftDuration, rightDuration)=>{
    const [lDuration, rDuration] = $58b46115d06468a1$export$e0bda707f0133070(leftDuration, rightDuration);
    const unit = Object.keys(lDuration)[0];
    const amount = lDuration[unit] *= rDuration[unit];
    let duration = {};
    duration[unit] = amount;
    // powerDuration
    return {
        duration: duration,
        power: 2
    };
};
const $58b46115d06468a1$export$45e93477efb4ac86 = (leftDuration, rightDuration)=>{
    const [lDuration, rDuration] = $58b46115d06468a1$export$e0bda707f0133070(leftDuration, rightDuration);
    const unit = Object.keys(lDuration)[0];
    return lDuration[unit] / rDuration[unit];
};
const $58b46115d06468a1$export$51e7136ebb73df6d = (powerDuration, duration)=>{
    const powerDurationVal = $58b46115d06468a1$export$2b6d965b96c60588(powerDuration.duration);
    const unit = Object.keys(powerDurationVal)[0];
    const divider = $58b46115d06468a1$export$84baba02af9b54f1(duration, unit);
    const amount = powerDurationVal[unit] / divider;
    let newDuration = {};
    newDuration[unit] = amount;
    const power = powerDuration.power - 1;
    if (power === 1) return newDuration;
    else if (power === 0) return amount;
    else return {
        duration: newDuration,
        power: 2
    };
};
const $58b46115d06468a1$export$3f7975928575e3ba = (rate)=>({
        amount: rate.amount,
        per: $58b46115d06468a1$export$2b6d965b96c60588(rate.per)
    });
const $58b46115d06468a1$export$2244e9cd1ae0b12 = $58b46115d06468a1$export$3f7975928575e3ba({
    amount: 1,
    per: {
        hours: 1
    }
});
const $58b46115d06468a1$export$95db8b86ccd412e = (rate)=>{
    rate = $58b46115d06468a1$export$3f7975928575e3ba(rate);
    rate.per = $58b46115d06468a1$export$85335542364f2c3c(rate.per);
    const durationUnit = Object.keys(rate.per)[0];
    const durationAmount = Object.values(rate.per)[0];
    rate.amount /= durationAmount;
    rate.per[durationUnit] = 1;
    return rate;
};
const $58b46115d06468a1$export$2d12575a603cb209 = (rate1, rate2)=>{
    rate1 = $58b46115d06468a1$export$95db8b86ccd412e(rate1);
    rate2 = $58b46115d06468a1$export$95db8b86ccd412e(rate2);
    const rate1Unit = Object.keys(rate1.per)[0];
    const rate2Divider = $58b46115d06468a1$export$84baba02af9b54f1(rate2.per, rate1Unit);
    rate2.amount /= rate2Divider;
    rate2.per = rate1.per;
    return [
        rate1,
        rate2
    ];
};
const $58b46115d06468a1$export$12664029541be726 = (rate, unit)=>{
    rate = $58b46115d06468a1$export$95db8b86ccd412e(rate);
    const divider = $58b46115d06468a1$export$84baba02af9b54f1(rate.per, unit);
    rate.amount /= divider;
    let duration = {};
    duration[unit] = 1;
    rate.per = duration;
    return rate;
};
const $58b46115d06468a1$export$98a0ed8290b61472 = (leftRate, rightRate)=>{
    const [lRate, rRate] = $58b46115d06468a1$export$2d12575a603cb209(leftRate, rightRate);
    lRate.amount += rRate.amount;
    return lRate;
};
const $58b46115d06468a1$export$e58bd1b2c8c49236 = (leftRate, rightRate)=>{
    const [lRate, rRate] = $58b46115d06468a1$export$2d12575a603cb209(leftRate, rightRate);
    lRate.amount -= rRate.amount;
    return lRate;
};
const $58b46115d06468a1$export$ff03227f9dcbe87b = (leftRate, rightRate)=>{
    const [lRate, rRate] = $58b46115d06468a1$export$2d12575a603cb209(leftRate, rightRate);
    const diff = lRate.amount / rRate.amount;
    return diff;
};
const $58b46115d06468a1$export$f666dc173acbafa6 = (rate, multiplier)=>{
    rate = $58b46115d06468a1$export$3f7975928575e3ba(rate);
    rate.amount *= multiplier;
    return rate;
};
const $58b46115d06468a1$export$de24eaed3792859a = (rate, divider)=>{
    rate = $58b46115d06468a1$export$3f7975928575e3ba(rate);
    rate.amount /= divider;
    return rate;
};
const $58b46115d06468a1$export$a85789518397f9c7 = (rate, duration)=>{
    rate = $58b46115d06468a1$export$95db8b86ccd412e(rate);
    duration = $58b46115d06468a1$export$85335542364f2c3c(duration);
    let amount = rate.amount / $58b46115d06468a1$export$777ea3b65ea6cd37[Object.keys(rate.per)[0]];
    amount *= $58b46115d06468a1$export$777ea3b65ea6cd37[Object.keys(duration)[0]];
    amount *= Object.values(duration)[0];
    return amount;
};
const $58b46115d06468a1$export$b270334d34e4cd72 = (number, rate)=>{
    rate = $58b46115d06468a1$export$95db8b86ccd412e(rate);
    number /= rate.amount;
    const unit = Object.keys(rate.per)[0];
    let duration = {};
    duration[unit] = number;
    return duration;
};
const $58b46115d06468a1$export$20c62bd0d1d0a26e = (number, duration)=>{
    return $58b46115d06468a1$export$3f7975928575e3ba({
        amount: number,
        duration: duration
    });
};
const $58b46115d06468a1$export$e60d4db9f4b84ec2 = (date, unit, multiple = 1)=>{
    date = $58b46115d06468a1$export$18bceafa8e89d4f1(date);
    let childUnit = $58b46115d06468a1$export$b8af2f8c53d557f5[unit];
    date = $58b46115d06468a1$export$ddd519109d59f0c0[unit](date, Math.round($58b46115d06468a1$export$c0d5be433dca6a61[unit](date) / multiple) * multiple);
    while(childUnit){
        date = $58b46115d06468a1$export$ddd519109d59f0c0[childUnit](date, $58b46115d06468a1$export$91484f0a85192b80[childUnit]);
        childUnit = $58b46115d06468a1$export$b8af2f8c53d557f5[childUnit];
    }
    return date;
};
const $58b46115d06468a1$export$8da934faffadeb57 = (date, unit, multiple = 1)=>{
    date = $58b46115d06468a1$export$18bceafa8e89d4f1(date);
    date = $58b46115d06468a1$export$ddd519109d59f0c0[unit](date, Math.ceil($58b46115d06468a1$export$c0d5be433dca6a61[unit](date) / multiple) * multiple);
    let childUnit = $58b46115d06468a1$export$b8af2f8c53d557f5[unit];
    while(childUnit){
        date = $58b46115d06468a1$export$ddd519109d59f0c0[childUnit](date, $58b46115d06468a1$export$91484f0a85192b80[childUnit]);
        childUnit = $58b46115d06468a1$export$b8af2f8c53d557f5[childUnit];
    }
    return date;
};
const $58b46115d06468a1$export$d0913359021b586f = (date, unit, multiple = 1)=>{
    date = $58b46115d06468a1$export$18bceafa8e89d4f1(date);
    date = $58b46115d06468a1$export$ddd519109d59f0c0[unit](date, Math.floor($58b46115d06468a1$export$c0d5be433dca6a61[unit](date) / multiple) * multiple);
    let childUnit = $58b46115d06468a1$export$b8af2f8c53d557f5[unit];
    while(childUnit){
        date = $58b46115d06468a1$export$ddd519109d59f0c0[childUnit](date, $58b46115d06468a1$export$91484f0a85192b80[childUnit]);
        childUnit = $58b46115d06468a1$export$b8af2f8c53d557f5[childUnit];
    }
    return date;
};
const $58b46115d06468a1$export$d8301f5de55672c9 = (date)=>{
    date = $58b46115d06468a1$export$18bceafa8e89d4f1(date);
    let time = $58b46115d06468a1$export$bf567c9b3ce5f8ca({
        dateRef: date
    });
    time.milliseconds = date.getMilliseconds();
    time.seconds = date.getSeconds();
    time.minutes = date.getMinutes();
    time.hours = date.getHours();
    return time;
};
const $58b46115d06468a1$export$764ba8036fcce0e3 = (duration)=>{
    if (duration.milliseconds) return "milliseconds";
    if (duration.seconds) return "seconds";
    if (duration.minutes) return "minutes";
    if (duration.hours) return "hours";
};
const $58b46115d06468a1$export$92e65f3ca6530903 = (date = $58b46115d06468a1$export$dc59854f87f8c633())=>{
    return $58b46115d06468a1$export$764ba8036fcce0e3($58b46115d06468a1$export$d8301f5de55672c9(date));
};
const $58b46115d06468a1$export$8a67e5f02235bd2c = (startDate, endDate, unit)=>{
    startDate = $58b46115d06468a1$export$18bceafa8e89d4f1(startDate);
    endDate = $58b46115d06468a1$export$18bceafa8e89d4f1(endDate);
    let unitGetter = $58b46115d06468a1$export$c0d5be433dca6a61[unit];
    return unitGetter(startDate) < unitGetter(endDate);
};
const $58b46115d06468a1$export$5dc2f18373ae7329 = (startDate, endDate, unit)=>{
    startDate = $58b46115d06468a1$export$18bceafa8e89d4f1(startDate);
    endDate = $58b46115d06468a1$export$18bceafa8e89d4f1(endDate);
    let unitGetter = $58b46115d06468a1$export$c0d5be433dca6a61[unit];
    return unitGetter(startDate) <= unitGetter(endDate);
};
const $58b46115d06468a1$export$512696a08ac73d4d = (startDate, endDate, unit)=>{
    startDate = $58b46115d06468a1$export$18bceafa8e89d4f1(startDate);
    endDate = $58b46115d06468a1$export$18bceafa8e89d4f1(endDate);
    let unitGetter = $58b46115d06468a1$export$c0d5be433dca6a61[unit];
    return unitGetter(startDate) === unitGetter(endDate);
};
const $58b46115d06468a1$export$6e6463d72f3ccf14 = (startDate, endDate, unit)=>{
    startDate = $58b46115d06468a1$export$18bceafa8e89d4f1(startDate);
    endDate = $58b46115d06468a1$export$18bceafa8e89d4f1(endDate);
    let unitGetter = $58b46115d06468a1$export$c0d5be433dca6a61[unit];
    return unitGetter(startDate) > unitGetter(endDate);
};
const $58b46115d06468a1$export$eac74d983cdc83ae = (startDate, endDate, unit)=>{
    startDate = $58b46115d06468a1$export$18bceafa8e89d4f1(startDate);
    endDate = $58b46115d06468a1$export$18bceafa8e89d4f1(endDate);
    let unitGetter = $58b46115d06468a1$export$c0d5be433dca6a61[unit];
    return unitGetter(startDate) >= unitGetter(endDate);
};

});

parcelRegister("62nmb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $46550c2c72035b3f$var$constants;
(function(constants) {
    constants.typeOfFunction = "function";
    constants.boolTrue = true;
})($46550c2c72035b3f$var$constants || ($46550c2c72035b3f$var$constants = {}));
function $46550c2c72035b3f$var$bind(target, propertyKey, descriptor) {
    if (!descriptor || typeof descriptor.value !== $46550c2c72035b3f$var$constants.typeOfFunction) throw new TypeError("Only methods can be decorated with @bind. <" + propertyKey + "> is not a method!");
    return {
        configurable: $46550c2c72035b3f$var$constants.boolTrue,
        get: function() {
            var bound = descriptor.value.bind(this);
            // Credits to https://github.com/andreypopp/autobind-decorator for memoizing the result of bind against a symbol on the instance.
            Object.defineProperty(this, propertyKey, {
                value: bound,
                configurable: $46550c2c72035b3f$var$constants.boolTrue,
                writable: $46550c2c72035b3f$var$constants.boolTrue
            });
            return bound;
        }
    };
}
module.exports.bind = $46550c2c72035b3f$var$bind;
module.exports.default = $46550c2c72035b3f$var$bind;

});

parcelRegister("bhvQG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8369fcb882280a16$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "ContactCollectionClass", function () { return $8369fcb882280a16$export$d0c905c7685a030c; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $8NSNz = parcelRequire("8NSNz");
var $8369fcb882280a16$var$_dec, $8369fcb882280a16$var$_dec2, $8369fcb882280a16$var$_dec3, $8369fcb882280a16$var$_class;
function $8369fcb882280a16$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $8369fcb882280a16$var$ContactCollection = ($8369fcb882280a16$var$_dec = (0, $4JcCM.action).bound, $8369fcb882280a16$var$_dec2 = (0, $4JcCM.action).bound, $8369fcb882280a16$var$_dec3 = (0, $4JcCM.action).bound, $8369fcb882280a16$var$_class = class ContactCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "contacts",
            modelClass: (0, $8NSNz.default)
        });
        this.addLookup("contactsByAccountingSystemId", "uniqueByKey", {
            key: (t)=>t.accountingSystemContactId,
            filter: (t)=>!t.deletedAt
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get contactsById() {
        return this.modelsById;
    }
    get contacts() {
        return this.models;
    }
    addContact(data) {
        this.add(data);
    }
    addContacts(data) {
        this.addMany(data);
    }
    createContact(options) {
        const contact = this.add({
            trackUpdates: true,
            ...options
        });
        return contact;
    }
}, $8369fcb882280a16$var$_applyDecoratedDescriptor($8369fcb882280a16$var$_class.prototype, "addContact", [
    $8369fcb882280a16$var$_dec
], Object.getOwnPropertyDescriptor($8369fcb882280a16$var$_class.prototype, "addContact"), $8369fcb882280a16$var$_class.prototype), $8369fcb882280a16$var$_applyDecoratedDescriptor($8369fcb882280a16$var$_class.prototype, "addContacts", [
    $8369fcb882280a16$var$_dec2
], Object.getOwnPropertyDescriptor($8369fcb882280a16$var$_class.prototype, "addContacts"), $8369fcb882280a16$var$_class.prototype), $8369fcb882280a16$var$_applyDecoratedDescriptor($8369fcb882280a16$var$_class.prototype, "createContact", [
    $8369fcb882280a16$var$_dec3
], Object.getOwnPropertyDescriptor($8369fcb882280a16$var$_class.prototype, "createContact"), $8369fcb882280a16$var$_class.prototype), $8369fcb882280a16$var$_class);
var $8369fcb882280a16$export$2e2bcd8739ae039 = new $8369fcb882280a16$var$ContactCollection();
const $8369fcb882280a16$export$d0c905c7685a030c = $8369fcb882280a16$var$ContactCollection;

});
parcelRegister("8NSNz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $668d68293c09b4a5$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $bhvQG = parcelRequire("bhvQG");

var $cxnwP = parcelRequire("cxnwP");

var $gJT7h = parcelRequire("gJT7h");

var $3PpOX = parcelRequire("3PpOX");
var $668d68293c09b4a5$var$_class, $668d68293c09b4a5$var$_descriptor, $668d68293c09b4a5$var$_descriptor2, $668d68293c09b4a5$var$_descriptor3, $668d68293c09b4a5$var$_descriptor4, $668d68293c09b4a5$var$_descriptor5, $668d68293c09b4a5$var$_descriptor6, $668d68293c09b4a5$var$_descriptor7, $668d68293c09b4a5$var$_descriptor8;
function $668d68293c09b4a5$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $668d68293c09b4a5$var$_defineProperty(e, r, t) {
    return (r = $668d68293c09b4a5$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $668d68293c09b4a5$var$_toPropertyKey(t) {
    var i = $668d68293c09b4a5$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $668d68293c09b4a5$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $668d68293c09b4a5$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $668d68293c09b4a5$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $668d68293c09b4a5$var$ContactModel = ($668d68293c09b4a5$var$_class = class ContactModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $668d68293c09b4a5$var$_initializerDefineProperty(this, "firstName", $668d68293c09b4a5$var$_descriptor, this);
        $668d68293c09b4a5$var$_initializerDefineProperty(this, "lastName", $668d68293c09b4a5$var$_descriptor2, this);
        $668d68293c09b4a5$var$_initializerDefineProperty(this, "organisationName", $668d68293c09b4a5$var$_descriptor3, this);
        $668d68293c09b4a5$var$_initializerDefineProperty(this, "address", $668d68293c09b4a5$var$_descriptor4, this);
        $668d68293c09b4a5$var$_initializerDefineProperty(this, "email", $668d68293c09b4a5$var$_descriptor5, this);
        $668d68293c09b4a5$var$_initializerDefineProperty(this, "phone", $668d68293c09b4a5$var$_descriptor6, this);
        $668d68293c09b4a5$var$_initializerDefineProperty(this, "accountingSystemId", $668d68293c09b4a5$var$_descriptor7, this);
        $668d68293c09b4a5$var$_initializerDefineProperty(this, "accountingSystemContactId", $668d68293c09b4a5$var$_descriptor8, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $bhvQG.default);
        this.init(data, options);
    }
    get projects() {
        return [
            ...(0, $gJT7h.default).projectsByContactId[this.id] || [],
            ...(0, $gJT7h.default).projectsByPrimaryContactId[this.id] || []
        ];
    }
    get invoices() {
        return (0, $cxnwP.default).invoicesByContactId[this.id] || [];
    }
    get fullName() {
        return [
            this.firstName,
            this.lastName
        ].join(" ");
    }
    get label() {
        return this.fullName ? this.organisationName ? `${this.fullName} (${this.organisationName})` : this.fullName : this.organisationName;
    }
}, $668d68293c09b4a5$var$_descriptor = $668d68293c09b4a5$var$_applyDecoratedDescriptor($668d68293c09b4a5$var$_class.prototype, "firstName", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $668d68293c09b4a5$var$_descriptor2 = $668d68293c09b4a5$var$_applyDecoratedDescriptor($668d68293c09b4a5$var$_class.prototype, "lastName", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $668d68293c09b4a5$var$_descriptor3 = $668d68293c09b4a5$var$_applyDecoratedDescriptor($668d68293c09b4a5$var$_class.prototype, "organisationName", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $668d68293c09b4a5$var$_descriptor4 = $668d68293c09b4a5$var$_applyDecoratedDescriptor($668d68293c09b4a5$var$_class.prototype, "address", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $668d68293c09b4a5$var$_descriptor5 = $668d68293c09b4a5$var$_applyDecoratedDescriptor($668d68293c09b4a5$var$_class.prototype, "email", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $668d68293c09b4a5$var$_descriptor6 = $668d68293c09b4a5$var$_applyDecoratedDescriptor($668d68293c09b4a5$var$_class.prototype, "phone", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $668d68293c09b4a5$var$_descriptor7 = $668d68293c09b4a5$var$_applyDecoratedDescriptor($668d68293c09b4a5$var$_class.prototype, "accountingSystemId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $668d68293c09b4a5$var$_descriptor8 = $668d68293c09b4a5$var$_applyDecoratedDescriptor($668d68293c09b4a5$var$_class.prototype, "accountingSystemContactId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $668d68293c09b4a5$var$_applyDecoratedDescriptor($668d68293c09b4a5$var$_class.prototype, "projects", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($668d68293c09b4a5$var$_class.prototype, "projects"), $668d68293c09b4a5$var$_class.prototype), $668d68293c09b4a5$var$_applyDecoratedDescriptor($668d68293c09b4a5$var$_class.prototype, "invoices", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($668d68293c09b4a5$var$_class.prototype, "invoices"), $668d68293c09b4a5$var$_class.prototype), $668d68293c09b4a5$var$_applyDecoratedDescriptor($668d68293c09b4a5$var$_class.prototype, "fullName", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($668d68293c09b4a5$var$_class.prototype, "fullName"), $668d68293c09b4a5$var$_class.prototype), $668d68293c09b4a5$var$_applyDecoratedDescriptor($668d68293c09b4a5$var$_class.prototype, "label", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($668d68293c09b4a5$var$_class.prototype, "label"), $668d68293c09b4a5$var$_class.prototype), $668d68293c09b4a5$var$_class);
var $668d68293c09b4a5$export$2e2bcd8739ae039 = $668d68293c09b4a5$var$ContactModel;

});
parcelRegister("cxnwP", function(module, exports) {

$parcel$export(module.exports, "getInvoiceNumber", function () { return $920ad15f7f0eef14$export$f9e355a1ea4ccc4a; });
$parcel$export(module.exports, "default", function () { return $920ad15f7f0eef14$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "InvoiceCollectionClass", function () { return $920ad15f7f0eef14$export$76f5f32d2c9b7f2f; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $495IZ = parcelRequire("495IZ");

var $4hBm1 = parcelRequire("4hBm1");

var $1BTI2 = parcelRequire("1BTI2");
parcelRequire("eat5C");

var $kRqe9 = parcelRequire("kRqe9");

var $8kZ1o = parcelRequire("8kZ1o");

var $3h7sC = parcelRequire("3h7sC");
var $920ad15f7f0eef14$var$_dec, $920ad15f7f0eef14$var$_dec2, $920ad15f7f0eef14$var$_dec3, $920ad15f7f0eef14$var$_class;
function $920ad15f7f0eef14$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}

var $kScV6 = parcelRequire("kScV6");
var $920ad15f7f0eef14$require$Formula = $kScV6.default;
function $920ad15f7f0eef14$export$f9e355a1ea4ccc4a(project) {
    const thisYear = new Date().getFullYear();
    const invoiceRefFormula = new $920ad15f7f0eef14$require$Formula({
        ref: "inv0",
        prop: "description",
        formula: ((0, $1BTI2.default).organisation.settings.invoice.invoiceCode || `format(invNum, "0000")`).replace("$project.invNum", (0, $1BTI2.default).organisation.settings.invoice.invNumProj[project.id] || 0).replace("invNumYear", (0, $1BTI2.default).organisation.settings.invoice.invNumYear[String(thisYear)] || 0).replace("invNum", (0, $1BTI2.default).organisation.settings.invoice.invNum || 0).replace(/\$project/g, `#"pr${project.id}"`)
    });
    return invoiceRefFormula.value;
}
function $920ad15f7f0eef14$export$ab87f9ada3f597e7(project) {
    var _SessionStore$organis, _SessionStore$organis2, _SessionStore$organis3, _SessionStore$organis5, _SessionStore$organis6;
    const thisYear = new Date().getFullYear();
    const invCode = (0, $1BTI2.default).organisation.settings.invoice.invoiceCode || 'format(invNum, "0000")';
    const updateInvNumProj = invCode.includes("$project.invNum");
    const updateInvNumYear = invCode.includes("invNumYear");
    if (!((_SessionStore$organis = (0, $1BTI2.default).organisation.settings.invoice) !== null && _SessionStore$organis !== void 0 && _SessionStore$organis.invNum)) (0, $1BTI2.default).organisation.updateInvoiceSettings({
        invNum: (0, $1BTI2.default).organisation.invNum || 0
    });
    if (updateInvNumProj && !((_SessionStore$organis2 = (0, $1BTI2.default).organisation.settings.invoice) !== null && _SessionStore$organis2 !== void 0 && (_SessionStore$organis3 = _SessionStore$organis2.invNumProj) !== null && _SessionStore$organis3 !== void 0 && _SessionStore$organis3[project.id])) {
        var _SessionStore$organis4;
        (0, $1BTI2.default).organisation.updateInvoiceSettings({
            invNumProj: {
                ...((_SessionStore$organis4 = (0, $1BTI2.default).organisation.settings.invoice) === null || _SessionStore$organis4 === void 0 ? void 0 : _SessionStore$organis4.invNumProj) || {},
                [project.id]: (0, $1BTI2.default).organisation.invNumProj || 0
            }
        });
    }
    if (updateInvNumYear && !((_SessionStore$organis5 = (0, $1BTI2.default).organisation.settings.invoice) !== null && _SessionStore$organis5 !== void 0 && (_SessionStore$organis6 = _SessionStore$organis5.invNumYear) !== null && _SessionStore$organis6 !== void 0 && _SessionStore$organis6[String(thisYear)])) {
        var _SessionStore$organis7;
        (0, $1BTI2.default).organisation.updateInvoiceSettings({
            invNumYear: {
                ...((_SessionStore$organis7 = (0, $1BTI2.default).organisation.settings.invoice) === null || _SessionStore$organis7 === void 0 ? void 0 : _SessionStore$organis7.invNumYear) || {},
                [String(thisYear)]: (0, $1BTI2.default).organisation.invNumYear || 0
            }
        });
    }
    (0, $1BTI2.default).organisation.incrementInvoiceNumber(project.id);
    return $920ad15f7f0eef14$export$f9e355a1ea4ccc4a(project);
}
let $920ad15f7f0eef14$var$InvoiceCollection = ($920ad15f7f0eef14$var$_dec = (0, $4JcCM.action).bound, $920ad15f7f0eef14$var$_dec2 = (0, $4JcCM.action).bound, $920ad15f7f0eef14$var$_dec3 = (0, $4JcCM.action).bound, $920ad15f7f0eef14$var$_class = class InvoiceCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "invoices",
            modelClass: (0, $495IZ.default)
        });
        this.addLookup("invoicesByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("invoicesByContactId", "manyByKey", {
            key: (t)=>t.contactId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("invoicesByOldId", "uniqueByKey", {
            key: (t)=>t.oldId,
            filter: (t)=>!t.deletedAt
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get invoicesById() {
        return this.modelsById;
    }
    get invoices() {
        return this.models.filter((i)=>!i.deletedAt);
    }
    addInvoice(data) {
        this.add(data);
    }
    addInvoices(data) {
        this.addMany(data);
    }
    async createInvoice(project, startDate, endDate) {
        var _SessionStore$organis8, _SessionStore$organis9, _SessionStore$organis10, _SessionStore$organis11;
        let invoiceRef = $920ad15f7f0eef14$export$ab87f9ada3f597e7(project);
        let attempts = 0;
        const maxAttempts = 100; // Prevent infinite loop
        // Keep trying until we find a unique invoice number
        while(attempts < maxAttempts)try {
            const result = await (0, $3h7sC.trpc).invoice.checkDuplicateInvoiceRef.query({
                ref: invoiceRef,
                projectId: project.id
            });
            if (!result.isDuplicate) break; // Found a unique number
            // Increment and try again
            (0, $1BTI2.default).organisation.incrementInvoiceNumber(project.id);
            invoiceRef = $920ad15f7f0eef14$export$f9e355a1ea4ccc4a(project);
            attempts++;
        } catch (error) {
            console.error("Error checking duplicate invoice ref:", error);
            break; // Proceed with current number on error
        }
        if (attempts >= maxAttempts) console.error("Could not find unique invoice number after", maxAttempts, "attempts");
        const invoice = this.add({
            ref: invoiceRef,
            projectId: project.id,
            contactId: project === null || project === void 0 ? void 0 : project.contactId,
            startDate: startDate,
            endDate: endDate,
            issueDate: new Date(),
            dueDate: (0, $4hBm1.addDays)(new Date(), (0, $1BTI2.default).organisation.settings.invoice.numDaysBetweenIssueDateAndDueDate),
            taxRatePercent: (_SessionStore$organis8 = (_SessionStore$organis9 = (0, $1BTI2.default).organisation.accountingSystemSettings) === null || _SessionStore$organis9 === void 0 ? void 0 : (_SessionStore$organis10 = _SessionStore$organis9.settings) === null || _SessionStore$organis10 === void 0 ? void 0 : (_SessionStore$organis11 = _SessionStore$organis10.taxOnTaxType) === null || _SessionStore$organis11 === void 0 ? void 0 : _SessionStore$organis11.rate) !== null && _SessionStore$organis8 !== void 0 ? _SessionStore$organis8 : 10,
            accountingSystemId: (0, $1BTI2.default).organisation.accountingSystem,
            cachedData: {
                project: {
                    name: project.name,
                    jobNumber: project.jobNumber
                },
                phases: Object.fromEntries(project.phases.map((ph)=>[
                        ph.id,
                        {
                            name: ph.name,
                            jobNumber: ph.jobNumber,
                            fee: ph.fee,
                            previousBilled: ph.previouslyBilled
                        }
                    ])),
                expenses: Object.fromEntries(project.expenses.map((e)=>[
                        e.id,
                        {
                            name: e.name,
                            cost: e.cost,
                            previousBilled: e.previouslyBilled
                        }
                    ]))
            }
        }, {
            trackUpdates: true
        });
        project.phases.filter((ph)=>!(ph !== null && ph !== void 0 && ph.isRootPhase)).forEach((ph)=>{
            const ili = (0, $kRqe9.default).add({
                invoiceId: invoice.id,
                projectId: project.id,
                contactId: invoice.contactId,
                phaseId: ph.id,
                billingType: "agreedFee",
                lineItemType: "progress",
                unitCost: ph.fee,
                description: "[phase] ([phaseprogress] completion)",
                isTaxed: true
            }, {
                trackUpdates: true
            });
        });
        project.expenses.forEach((pe)=>{
            if (!(0, $8kZ1o.canViewExpenseTracking)()) {
                if (pe.billable && pe.endDate && pe.endDate <= endDate && pe.cost - pe.previouslyBilled > 0) (0, $kRqe9.default).add({
                    invoiceId: invoice.id,
                    projectId: project.id,
                    contactId: invoice.contactId,
                    phaseId: pe.phaseId || project.rootPhase.id,
                    billingType: "reimbursement",
                    lineItemType: "expense",
                    description: pe.name,
                    unitQuantity: 1,
                    unitCost: pe.cost - pe.previouslyBilled,
                    expenseId: pe.id,
                    isTaxed: true
                }, {
                    trackUpdates: true
                });
            } else if (pe.billable && pe.expenseItems.length > 0) pe.expenseItems.forEach((pei)=>{
                (0, $kRqe9.default).add({
                    invoiceId: invoice.id,
                    projectId: project.id,
                    contactId: invoice.contactId,
                    phaseId: pe.phaseId || project.rootPhase.id,
                    billingType: "reimbursement",
                    lineItemType: "expense",
                    description: pe.name,
                    unitQuantity: 1,
                    unitCost: pei.cost,
                    expenseId: pe.id,
                    expenseItemIds: [
                        pei.id
                    ],
                    isTaxed: true
                }, {
                    trackUpdates: true
                });
                pei.update({
                    beenInvoiced: true
                });
            });
        });
        return invoice;
    }
}, $920ad15f7f0eef14$var$_applyDecoratedDescriptor($920ad15f7f0eef14$var$_class.prototype, "addInvoice", [
    $920ad15f7f0eef14$var$_dec
], Object.getOwnPropertyDescriptor($920ad15f7f0eef14$var$_class.prototype, "addInvoice"), $920ad15f7f0eef14$var$_class.prototype), $920ad15f7f0eef14$var$_applyDecoratedDescriptor($920ad15f7f0eef14$var$_class.prototype, "addInvoices", [
    $920ad15f7f0eef14$var$_dec2
], Object.getOwnPropertyDescriptor($920ad15f7f0eef14$var$_class.prototype, "addInvoices"), $920ad15f7f0eef14$var$_class.prototype), $920ad15f7f0eef14$var$_applyDecoratedDescriptor($920ad15f7f0eef14$var$_class.prototype, "createInvoice", [
    $920ad15f7f0eef14$var$_dec3
], Object.getOwnPropertyDescriptor($920ad15f7f0eef14$var$_class.prototype, "createInvoice"), $920ad15f7f0eef14$var$_class.prototype), $920ad15f7f0eef14$var$_class);
var $920ad15f7f0eef14$export$2e2bcd8739ae039 = new $920ad15f7f0eef14$var$InvoiceCollection();
const $920ad15f7f0eef14$export$76f5f32d2c9b7f2f = $920ad15f7f0eef14$var$InvoiceCollection;

});
parcelRegister("495IZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $304c71770945b7b7$export$2e2bcd8739ae039; });
parcelRequire("gN0TC");

var $4JcCM = parcelRequire("4JcCM");

var $eat5C = parcelRequire("eat5C");

var $bhvQG = parcelRequire("bhvQG");

var $cxnwP = parcelRequire("cxnwP");

var $kRqe9 = parcelRequire("kRqe9");

var $gJT7h = parcelRequire("gJT7h");

var $3PpOX = parcelRequire("3PpOX");

var $XoImS = parcelRequire("XoImS");

var $6fNfM = parcelRequire("6fNfM");
var $304c71770945b7b7$var$_dec, $304c71770945b7b7$var$_class, $304c71770945b7b7$var$_descriptor, $304c71770945b7b7$var$_descriptor2, $304c71770945b7b7$var$_descriptor3, $304c71770945b7b7$var$_descriptor4, $304c71770945b7b7$var$_descriptor5, $304c71770945b7b7$var$_descriptor6, $304c71770945b7b7$var$_descriptor7, $304c71770945b7b7$var$_descriptor8, $304c71770945b7b7$var$_descriptor9, $304c71770945b7b7$var$_descriptor10, $304c71770945b7b7$var$_descriptor11, $304c71770945b7b7$var$_descriptor12, $304c71770945b7b7$var$_descriptor13, $304c71770945b7b7$var$_descriptor14, $304c71770945b7b7$var$_descriptor15, $304c71770945b7b7$var$_descriptor16, $304c71770945b7b7$var$_descriptor17, $304c71770945b7b7$var$_descriptor18, $304c71770945b7b7$var$_descriptor19, $304c71770945b7b7$var$_descriptor20;
function $304c71770945b7b7$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $304c71770945b7b7$var$_defineProperty(e, r, t) {
    return (r = $304c71770945b7b7$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $304c71770945b7b7$var$_toPropertyKey(t) {
    var i = $304c71770945b7b7$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $304c71770945b7b7$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $304c71770945b7b7$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $304c71770945b7b7$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $304c71770945b7b7$var$InvoiceModel = ($304c71770945b7b7$var$_dec = (0, $4JcCM.action).bound, $304c71770945b7b7$var$_class = class InvoiceModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $304c71770945b7b7$var$_defineProperty(this, "oldId", null);
        $304c71770945b7b7$var$_initializerDefineProperty(this, "ref", $304c71770945b7b7$var$_descriptor, this);
        $304c71770945b7b7$var$_initializerDefineProperty(this, "dueDate", $304c71770945b7b7$var$_descriptor2, this);
        $304c71770945b7b7$var$_initializerDefineProperty(this, "startDate", $304c71770945b7b7$var$_descriptor3, this);
        $304c71770945b7b7$var$_initializerDefineProperty(this, "endDate", $304c71770945b7b7$var$_descriptor4, this);
        $304c71770945b7b7$var$_initializerDefineProperty(this, "issueDate", $304c71770945b7b7$var$_descriptor5, this);
        $304c71770945b7b7$var$_initializerDefineProperty(this, "projectId", $304c71770945b7b7$var$_descriptor6, this);
        $304c71770945b7b7$var$_initializerDefineProperty(this, "contactId", $304c71770945b7b7$var$_descriptor7, this);
        $304c71770945b7b7$var$_initializerDefineProperty(this, "taxRatePercent", $304c71770945b7b7$var$_descriptor8, this);
        $304c71770945b7b7$var$_initializerDefineProperty(this, "accountingSystemId", $304c71770945b7b7$var$_descriptor9, this);
        $304c71770945b7b7$var$_initializerDefineProperty(this, "accountingSystemInvoiceId", $304c71770945b7b7$var$_descriptor10, this);
        $304c71770945b7b7$var$_initializerDefineProperty(this, "cachedData", $304c71770945b7b7$var$_descriptor11, this);
        $304c71770945b7b7$var$_initializerDefineProperty(this, "projectStatus", $304c71770945b7b7$var$_descriptor12, this);
        $304c71770945b7b7$var$_initializerDefineProperty(this, "totalAmount", $304c71770945b7b7$var$_descriptor13, this);
        $304c71770945b7b7$var$_initializerDefineProperty(this, "totalTax", $304c71770945b7b7$var$_descriptor14, this);
        $304c71770945b7b7$var$_initializerDefineProperty(this, "agreedAmount", $304c71770945b7b7$var$_descriptor15, this);
        $304c71770945b7b7$var$_initializerDefineProperty(this, "agreedTax", $304c71770945b7b7$var$_descriptor16, this);
        $304c71770945b7b7$var$_initializerDefineProperty(this, "variationAmount", $304c71770945b7b7$var$_descriptor17, this);
        $304c71770945b7b7$var$_initializerDefineProperty(this, "variationTax", $304c71770945b7b7$var$_descriptor18, this);
        $304c71770945b7b7$var$_initializerDefineProperty(this, "reimbursementAmount", $304c71770945b7b7$var$_descriptor19, this);
        $304c71770945b7b7$var$_initializerDefineProperty(this, "reimbursementTax", $304c71770945b7b7$var$_descriptor20, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $cxnwP.default);
        this.init(data, options);
    }
    get project() {
        return (0, $gJT7h.default).projectsById[this.projectId];
    }
    get phases() {
        const phases = this.phaseIds.map((id)=>(0, $XoImS.default).phasesById[id] || this.cachedData.phases[id] || this.project.rootPhase).sort((0, $6fNfM.default));
        return [
            ...new Set(phases)
        ];
    }
    get phaseIds() {
        return Object.keys(this.lineItemsByPhaseId);
    }
    get expenses() {
        return this.project.expenses;
    }
    get contact() {
        return (0, $bhvQG.default).contactsById[this.contactId];
    }
    get lineItems() {
        return (0, $kRqe9.default).lineItemsByInvoiceId[this.id] || [];
    }
    get timeEntries() {
        return this.lineItems.map((li)=>li.timeEntries).flat() || [];
    }
    get lineItemsByPhaseId() {
        let lineItemsByPhaseId = {
            [this.project.rootPhase.id]: []
        };
        this.project.phases.forEach((ph)=>{
            lineItemsByPhaseId[ph.id] = [];
        });
        this.lineItems.forEach((li)=>{
            const id = Boolean((0, $XoImS.default).phasesById[li.phaseId] || this.cachedData.phases[li.phaseId]) ? li.phaseId : this.project.rootPhase.id;
            if (!lineItemsByPhaseId[id]) lineItemsByPhaseId[id] = [];
            lineItemsByPhaseId[id].push(li);
        });
        return lineItemsByPhaseId;
    }
    get lineItemsByExpenseId() {
        let lineItemsByExpenseId = {};
        this.expenses.forEach((ex)=>{
            lineItemsByExpenseId[ex.id] = [];
        });
        this.lineItems.forEach((li)=>lineItemsByExpenseId[li.expenseId].push(li));
        return lineItemsByExpenseId;
    }
    get amount() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.lineItems.map((li)=>li.amount));
    }
    get tax() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.lineItems.map((li)=>li.tax));
    }
    get phasesWithRevenue() {
        return [
            ...new Set(this.lineItems.filter((li)=>li.amount).map((li)=>li.phase))
        ];
    }
    updateCachedData() {
        this.update({
            cachedData: {
                project: {
                    name: this.project.title,
                    jobNumber: this.project.jobNumber
                },
                phases: Object.fromEntries(this.phases.map((ph)=>[
                        ph.id,
                        {
                            name: ph.title,
                            jobNumber: ph.jobNumber,
                            fee: ph.fee,
                            //loaded on InvoicePage
                            previousBilled: ph.previousBilled || 0
                        }
                    ])),
                expenses: Object.fromEntries(this.expenses.map((e)=>[
                        e.id,
                        {
                            name: e.name,
                            cost: e.cost,
                            //loaded on InvoicePage
                            previousBilled: e.previousBilled || 0
                        }
                    ]))
            }
        });
        this.lineItems.forEach((li)=>{
            if (li.lineItemType === "progress" && li.billingType === "agreedFee") li.update({
                unitQuantity: li.phase.fee ? li.amount / (li.phase.fee || 0) : 0,
                unitCost: li.phase.fee || 0
            });
        });
    }
}, $304c71770945b7b7$var$_descriptor = $304c71770945b7b7$var$_applyDecoratedDescriptor($304c71770945b7b7$var$_class.prototype, "ref", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $304c71770945b7b7$var$_descriptor2 = $304c71770945b7b7$var$_applyDecoratedDescriptor($304c71770945b7b7$var$_class.prototype, "dueDate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $304c71770945b7b7$var$_descriptor3 = $304c71770945b7b7$var$_applyDecoratedDescriptor($304c71770945b7b7$var$_class.prototype, "startDate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $304c71770945b7b7$var$_descriptor4 = $304c71770945b7b7$var$_applyDecoratedDescriptor($304c71770945b7b7$var$_class.prototype, "endDate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $304c71770945b7b7$var$_descriptor5 = $304c71770945b7b7$var$_applyDecoratedDescriptor($304c71770945b7b7$var$_class.prototype, "issueDate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $304c71770945b7b7$var$_descriptor6 = $304c71770945b7b7$var$_applyDecoratedDescriptor($304c71770945b7b7$var$_class.prototype, "projectId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $304c71770945b7b7$var$_descriptor7 = $304c71770945b7b7$var$_applyDecoratedDescriptor($304c71770945b7b7$var$_class.prototype, "contactId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $304c71770945b7b7$var$_descriptor8 = $304c71770945b7b7$var$_applyDecoratedDescriptor($304c71770945b7b7$var$_class.prototype, "taxRatePercent", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $304c71770945b7b7$var$_descriptor9 = $304c71770945b7b7$var$_applyDecoratedDescriptor($304c71770945b7b7$var$_class.prototype, "accountingSystemId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $304c71770945b7b7$var$_descriptor10 = $304c71770945b7b7$var$_applyDecoratedDescriptor($304c71770945b7b7$var$_class.prototype, "accountingSystemInvoiceId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $304c71770945b7b7$var$_descriptor11 = $304c71770945b7b7$var$_applyDecoratedDescriptor($304c71770945b7b7$var$_class.prototype, "cachedData", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $304c71770945b7b7$var$_descriptor12 = $304c71770945b7b7$var$_applyDecoratedDescriptor($304c71770945b7b7$var$_class.prototype, "projectStatus", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $304c71770945b7b7$var$_descriptor13 = $304c71770945b7b7$var$_applyDecoratedDescriptor($304c71770945b7b7$var$_class.prototype, "totalAmount", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $304c71770945b7b7$var$_descriptor14 = $304c71770945b7b7$var$_applyDecoratedDescriptor($304c71770945b7b7$var$_class.prototype, "totalTax", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $304c71770945b7b7$var$_descriptor15 = $304c71770945b7b7$var$_applyDecoratedDescriptor($304c71770945b7b7$var$_class.prototype, "agreedAmount", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $304c71770945b7b7$var$_descriptor16 = $304c71770945b7b7$var$_applyDecoratedDescriptor($304c71770945b7b7$var$_class.prototype, "agreedTax", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $304c71770945b7b7$var$_descriptor17 = $304c71770945b7b7$var$_applyDecoratedDescriptor($304c71770945b7b7$var$_class.prototype, "variationAmount", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $304c71770945b7b7$var$_descriptor18 = $304c71770945b7b7$var$_applyDecoratedDescriptor($304c71770945b7b7$var$_class.prototype, "variationTax", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $304c71770945b7b7$var$_descriptor19 = $304c71770945b7b7$var$_applyDecoratedDescriptor($304c71770945b7b7$var$_class.prototype, "reimbursementAmount", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $304c71770945b7b7$var$_descriptor20 = $304c71770945b7b7$var$_applyDecoratedDescriptor($304c71770945b7b7$var$_class.prototype, "reimbursementTax", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $304c71770945b7b7$var$_applyDecoratedDescriptor($304c71770945b7b7$var$_class.prototype, "project", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($304c71770945b7b7$var$_class.prototype, "project"), $304c71770945b7b7$var$_class.prototype), $304c71770945b7b7$var$_applyDecoratedDescriptor($304c71770945b7b7$var$_class.prototype, "phases", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($304c71770945b7b7$var$_class.prototype, "phases"), $304c71770945b7b7$var$_class.prototype), $304c71770945b7b7$var$_applyDecoratedDescriptor($304c71770945b7b7$var$_class.prototype, "phaseIds", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($304c71770945b7b7$var$_class.prototype, "phaseIds"), $304c71770945b7b7$var$_class.prototype), $304c71770945b7b7$var$_applyDecoratedDescriptor($304c71770945b7b7$var$_class.prototype, "expenses", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($304c71770945b7b7$var$_class.prototype, "expenses"), $304c71770945b7b7$var$_class.prototype), $304c71770945b7b7$var$_applyDecoratedDescriptor($304c71770945b7b7$var$_class.prototype, "contact", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($304c71770945b7b7$var$_class.prototype, "contact"), $304c71770945b7b7$var$_class.prototype), $304c71770945b7b7$var$_applyDecoratedDescriptor($304c71770945b7b7$var$_class.prototype, "lineItems", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($304c71770945b7b7$var$_class.prototype, "lineItems"), $304c71770945b7b7$var$_class.prototype), $304c71770945b7b7$var$_applyDecoratedDescriptor($304c71770945b7b7$var$_class.prototype, "timeEntries", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($304c71770945b7b7$var$_class.prototype, "timeEntries"), $304c71770945b7b7$var$_class.prototype), $304c71770945b7b7$var$_applyDecoratedDescriptor($304c71770945b7b7$var$_class.prototype, "lineItemsByPhaseId", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($304c71770945b7b7$var$_class.prototype, "lineItemsByPhaseId"), $304c71770945b7b7$var$_class.prototype), $304c71770945b7b7$var$_applyDecoratedDescriptor($304c71770945b7b7$var$_class.prototype, "lineItemsByExpenseId", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($304c71770945b7b7$var$_class.prototype, "lineItemsByExpenseId"), $304c71770945b7b7$var$_class.prototype), $304c71770945b7b7$var$_applyDecoratedDescriptor($304c71770945b7b7$var$_class.prototype, "amount", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($304c71770945b7b7$var$_class.prototype, "amount"), $304c71770945b7b7$var$_class.prototype), $304c71770945b7b7$var$_applyDecoratedDescriptor($304c71770945b7b7$var$_class.prototype, "tax", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($304c71770945b7b7$var$_class.prototype, "tax"), $304c71770945b7b7$var$_class.prototype), $304c71770945b7b7$var$_applyDecoratedDescriptor($304c71770945b7b7$var$_class.prototype, "phasesWithRevenue", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($304c71770945b7b7$var$_class.prototype, "phasesWithRevenue"), $304c71770945b7b7$var$_class.prototype), $304c71770945b7b7$var$_applyDecoratedDescriptor($304c71770945b7b7$var$_class.prototype, "updateCachedData", [
    $304c71770945b7b7$var$_dec
], Object.getOwnPropertyDescriptor($304c71770945b7b7$var$_class.prototype, "updateCachedData"), $304c71770945b7b7$var$_class.prototype), $304c71770945b7b7$var$_class);
var $304c71770945b7b7$export$2e2bcd8739ae039 = $304c71770945b7b7$var$InvoiceModel;

});
parcelRegister("kRqe9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2fd1a11edfadeda$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "InvoiceLineItemCollectionClass", function () { return $f2fd1a11edfadeda$export$9f646c9fdc054650; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $drjRi = parcelRequire("drjRi");
var $f2fd1a11edfadeda$var$_dec, $f2fd1a11edfadeda$var$_dec2, $f2fd1a11edfadeda$var$_class;
function $f2fd1a11edfadeda$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $f2fd1a11edfadeda$var$InvoiceLineItemCollection = ($f2fd1a11edfadeda$var$_dec = (0, $4JcCM.action).bound, $f2fd1a11edfadeda$var$_dec2 = (0, $4JcCM.action).bound, $f2fd1a11edfadeda$var$_class = class InvoiceLineItemCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "invoiceLineItems",
            modelClass: (0, $drjRi.default)
        });
        this.addLookup("lineItemsByInvoiceId", "manyByKey", {
            key: (t)=>t.invoiceId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("lineItemsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("lineItemsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("lineItemsByContactId", "manyByKey", {
            key: (t)=>t.contactId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("lineItemsByExpenseId", "manyByKey", {
            key: (t)=>t.expenseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("lineItemsByInvoicePhaseId", "manyByKey", {
            key: (t)=>"i" + t.invoiceId + "ph" + (t.phaseId ? t.phaseId : "undefined"),
            filter: (t)=>!t.deletedAt
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get invoiceLineItemsById() {
        return this.modelsById;
    }
    get invoiceLineItems() {
        return this.models;
    }
    addInvoiceLineItem(data) {
        this.add(data);
    }
    addInvoiceLineItems(data) {
        this.addMany(data);
    }
}, $f2fd1a11edfadeda$var$_applyDecoratedDescriptor($f2fd1a11edfadeda$var$_class.prototype, "addInvoiceLineItem", [
    $f2fd1a11edfadeda$var$_dec
], Object.getOwnPropertyDescriptor($f2fd1a11edfadeda$var$_class.prototype, "addInvoiceLineItem"), $f2fd1a11edfadeda$var$_class.prototype), $f2fd1a11edfadeda$var$_applyDecoratedDescriptor($f2fd1a11edfadeda$var$_class.prototype, "addInvoiceLineItems", [
    $f2fd1a11edfadeda$var$_dec2
], Object.getOwnPropertyDescriptor($f2fd1a11edfadeda$var$_class.prototype, "addInvoiceLineItems"), $f2fd1a11edfadeda$var$_class.prototype), $f2fd1a11edfadeda$var$_class);
var $f2fd1a11edfadeda$export$2e2bcd8739ae039 = new $f2fd1a11edfadeda$var$InvoiceLineItemCollection();
const $f2fd1a11edfadeda$export$9f646c9fdc054650 = $f2fd1a11edfadeda$var$InvoiceLineItemCollection;

});
parcelRegister("drjRi", function(module, exports) {

$parcel$export(module.exports, "getDescriptionCodeText", function () { return $9c8d337626aa536d$export$b5ac1d9e94403947; });
$parcel$export(module.exports, "default", function () { return $9c8d337626aa536d$export$2e2bcd8739ae039; });
parcelRequire("lCpBr");

var $4JcCM = parcelRequire("4JcCM");

var $eat5C = parcelRequire("eat5C");
parcelRequire("afJLg");

var $12o9H = parcelRequire("12o9H");

var $cwjKY = parcelRequire("cwjKY");

var $gjxeM = parcelRequire("gjxeM");

var $bhvQG = parcelRequire("bhvQG");

var $cxnwP = parcelRequire("cxnwP");

var $kRqe9 = parcelRequire("kRqe9");

var $XoImS = parcelRequire("XoImS");

var $gJT7h = parcelRequire("gJT7h");

var $cfp1m = parcelRequire("cfp1m");

var $htkeB = parcelRequire("htkeB");

var $QiMYe = parcelRequire("QiMYe");

var $3PpOX = parcelRequire("3PpOX");


var $evRPQ = parcelRequire("evRPQ");
var $9c8d337626aa536d$var$_class, $9c8d337626aa536d$var$_descriptor, $9c8d337626aa536d$var$_descriptor2, $9c8d337626aa536d$var$_descriptor3, $9c8d337626aa536d$var$_descriptor4, $9c8d337626aa536d$var$_descriptor5, $9c8d337626aa536d$var$_descriptor6, $9c8d337626aa536d$var$_descriptor7, $9c8d337626aa536d$var$_descriptor8, $9c8d337626aa536d$var$_descriptor9, $9c8d337626aa536d$var$_descriptor10, $9c8d337626aa536d$var$_descriptor11, $9c8d337626aa536d$var$_descriptor12, $9c8d337626aa536d$var$_descriptor13, $9c8d337626aa536d$var$_descriptor14;
function $9c8d337626aa536d$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $9c8d337626aa536d$var$_defineProperty(e, r, t) {
    return (r = $9c8d337626aa536d$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $9c8d337626aa536d$var$_toPropertyKey(t) {
    var i = $9c8d337626aa536d$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $9c8d337626aa536d$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $9c8d337626aa536d$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $9c8d337626aa536d$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $9c8d337626aa536d$var$InvoiceLineItemModel = ($9c8d337626aa536d$var$_class = class InvoiceLineItemModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $9c8d337626aa536d$var$_initializerDefineProperty(this, "projectId", $9c8d337626aa536d$var$_descriptor, this);
        $9c8d337626aa536d$var$_initializerDefineProperty(this, "contactId", $9c8d337626aa536d$var$_descriptor2, this);
        $9c8d337626aa536d$var$_initializerDefineProperty(this, "invoiceId", $9c8d337626aa536d$var$_descriptor3, this);
        $9c8d337626aa536d$var$_initializerDefineProperty(this, "phaseId", $9c8d337626aa536d$var$_descriptor4, this);
        $9c8d337626aa536d$var$_initializerDefineProperty(this, "billingType", $9c8d337626aa536d$var$_descriptor5, this);
        $9c8d337626aa536d$var$_initializerDefineProperty(this, "lineItemType", $9c8d337626aa536d$var$_descriptor6, this);
        $9c8d337626aa536d$var$_initializerDefineProperty(this, "description", $9c8d337626aa536d$var$_descriptor7, this);
        $9c8d337626aa536d$var$_initializerDefineProperty(this, "unitCost", $9c8d337626aa536d$var$_descriptor8, this);
        $9c8d337626aa536d$var$_initializerDefineProperty(this, "unitQuantity", $9c8d337626aa536d$var$_descriptor9, this);
        $9c8d337626aa536d$var$_initializerDefineProperty(this, "isTaxed", $9c8d337626aa536d$var$_descriptor10, this);
        $9c8d337626aa536d$var$_initializerDefineProperty(this, "staffIds", $9c8d337626aa536d$var$_descriptor11, this);
        $9c8d337626aa536d$var$_initializerDefineProperty(this, "timesheetIds", $9c8d337626aa536d$var$_descriptor12, this);
        $9c8d337626aa536d$var$_initializerDefineProperty(this, "expenseId", $9c8d337626aa536d$var$_descriptor13, this);
        $9c8d337626aa536d$var$_initializerDefineProperty(this, "expenseItemIds", $9c8d337626aa536d$var$_descriptor14, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $kRqe9.default);
        this.init(data, options);
    }
    get invoice() {
        return (0, $cxnwP.default).invoicesById[this.invoiceId];
    }
    get project() {
        return (0, $gJT7h.default).projectsById[this.projectId];
    }
    get phase() {
        return (0, $XoImS.default).phasesById[this.phaseId];
    }
    get contact() {
        return (0, $bhvQG.default).contactsById[this.contactId];
    }
    get expense() {
        return (0, $cfp1m.default).projectExpensesById[this.expenseId];
    }
    get timeEntries() {
        return (this.timesheetIds || []).map((tsi)=>(0, $QiMYe.default).timeEntriesById[tsi]);
    }
    get expenseItems() {
        return (this.expenseItemIds || []).map((eii)=>(0, $evRPQ.default).projectExpenseItemsById[eii]);
    }
    get staff() {
        return (this.staffIds || []).map((si)=>(0, $htkeB.default).staffsById[si]);
    }
    get taxRate() {
        var _this$invoice;
        return (((_this$invoice = this.invoice) === null || _this$invoice === void 0 ? void 0 : _this$invoice.taxRatePercent) || 0) / 100;
    }
    get amount() {
        return this.unitQuantity * this.unitCost || 0;
    }
    get tax() {
        return this.isTaxed ? this.amount * this.taxRate : 0;
    }
    get issueDate() {
        var _this$invoice2;
        return (_this$invoice2 = this.invoice) === null || _this$invoice2 === void 0 ? void 0 : _this$invoice2.issueDate;
    }
    get dueDate() {
        var _this$invoice3;
        return (_this$invoice3 = this.invoice) === null || _this$invoice3 === void 0 ? void 0 : _this$invoice3.dueDate;
    }
    get startDate() {
        var _this$invoice4;
        return (_this$invoice4 = this.invoice) === null || _this$invoice4 === void 0 ? void 0 : _this$invoice4.startDate;
    }
    get endDate() {
        var _this$invoice5;
        return (_this$invoice5 = this.invoice) === null || _this$invoice5 === void 0 ? void 0 : _this$invoice5.endDate;
    }
    get timeEntryStartDate() {
        return this.timeEntries.length ? (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).min(this.timeEntries.map((te)=>te === null || te === void 0 ? void 0 : te.date)) : -Infinity;
    }
    get formattedDescription() {
        let description = this.description || "";
        Object.keys($9c8d337626aa536d$export$b5ac1d9e94403947).forEach((code)=>{
            var _getDescriptionCodeTe;
            description = description.replaceAll(`[${code}]`, ((_getDescriptionCodeTe = $9c8d337626aa536d$export$b5ac1d9e94403947[code]) === null || _getDescriptionCodeTe === void 0 ? void 0 : _getDescriptionCodeTe.call($9c8d337626aa536d$export$b5ac1d9e94403947, this)) || "");
        });
        return description;
    }
}, $9c8d337626aa536d$var$_descriptor = $9c8d337626aa536d$var$_applyDecoratedDescriptor($9c8d337626aa536d$var$_class.prototype, "projectId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $9c8d337626aa536d$var$_descriptor2 = $9c8d337626aa536d$var$_applyDecoratedDescriptor($9c8d337626aa536d$var$_class.prototype, "contactId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $9c8d337626aa536d$var$_descriptor3 = $9c8d337626aa536d$var$_applyDecoratedDescriptor($9c8d337626aa536d$var$_class.prototype, "invoiceId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $9c8d337626aa536d$var$_descriptor4 = $9c8d337626aa536d$var$_applyDecoratedDescriptor($9c8d337626aa536d$var$_class.prototype, "phaseId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $9c8d337626aa536d$var$_descriptor5 = $9c8d337626aa536d$var$_applyDecoratedDescriptor($9c8d337626aa536d$var$_class.prototype, "billingType", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $9c8d337626aa536d$var$_descriptor6 = $9c8d337626aa536d$var$_applyDecoratedDescriptor($9c8d337626aa536d$var$_class.prototype, "lineItemType", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $9c8d337626aa536d$var$_descriptor7 = $9c8d337626aa536d$var$_applyDecoratedDescriptor($9c8d337626aa536d$var$_class.prototype, "description", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "";
    }
}), $9c8d337626aa536d$var$_descriptor8 = $9c8d337626aa536d$var$_applyDecoratedDescriptor($9c8d337626aa536d$var$_class.prototype, "unitCost", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $9c8d337626aa536d$var$_descriptor9 = $9c8d337626aa536d$var$_applyDecoratedDescriptor($9c8d337626aa536d$var$_class.prototype, "unitQuantity", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $9c8d337626aa536d$var$_descriptor10 = $9c8d337626aa536d$var$_applyDecoratedDescriptor($9c8d337626aa536d$var$_class.prototype, "isTaxed", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return true;
    }
}), $9c8d337626aa536d$var$_descriptor11 = $9c8d337626aa536d$var$_applyDecoratedDescriptor($9c8d337626aa536d$var$_class.prototype, "staffIds", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $9c8d337626aa536d$var$_descriptor12 = $9c8d337626aa536d$var$_applyDecoratedDescriptor($9c8d337626aa536d$var$_class.prototype, "timesheetIds", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $9c8d337626aa536d$var$_descriptor13 = $9c8d337626aa536d$var$_applyDecoratedDescriptor($9c8d337626aa536d$var$_class.prototype, "expenseId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $9c8d337626aa536d$var$_descriptor14 = $9c8d337626aa536d$var$_applyDecoratedDescriptor($9c8d337626aa536d$var$_class.prototype, "expenseItemIds", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $9c8d337626aa536d$var$_applyDecoratedDescriptor($9c8d337626aa536d$var$_class.prototype, "invoice", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($9c8d337626aa536d$var$_class.prototype, "invoice"), $9c8d337626aa536d$var$_class.prototype), $9c8d337626aa536d$var$_applyDecoratedDescriptor($9c8d337626aa536d$var$_class.prototype, "project", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($9c8d337626aa536d$var$_class.prototype, "project"), $9c8d337626aa536d$var$_class.prototype), $9c8d337626aa536d$var$_applyDecoratedDescriptor($9c8d337626aa536d$var$_class.prototype, "phase", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($9c8d337626aa536d$var$_class.prototype, "phase"), $9c8d337626aa536d$var$_class.prototype), $9c8d337626aa536d$var$_applyDecoratedDescriptor($9c8d337626aa536d$var$_class.prototype, "contact", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($9c8d337626aa536d$var$_class.prototype, "contact"), $9c8d337626aa536d$var$_class.prototype), $9c8d337626aa536d$var$_applyDecoratedDescriptor($9c8d337626aa536d$var$_class.prototype, "expense", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($9c8d337626aa536d$var$_class.prototype, "expense"), $9c8d337626aa536d$var$_class.prototype), $9c8d337626aa536d$var$_applyDecoratedDescriptor($9c8d337626aa536d$var$_class.prototype, "timeEntries", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($9c8d337626aa536d$var$_class.prototype, "timeEntries"), $9c8d337626aa536d$var$_class.prototype), $9c8d337626aa536d$var$_applyDecoratedDescriptor($9c8d337626aa536d$var$_class.prototype, "expenseItems", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($9c8d337626aa536d$var$_class.prototype, "expenseItems"), $9c8d337626aa536d$var$_class.prototype), $9c8d337626aa536d$var$_applyDecoratedDescriptor($9c8d337626aa536d$var$_class.prototype, "staff", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($9c8d337626aa536d$var$_class.prototype, "staff"), $9c8d337626aa536d$var$_class.prototype), $9c8d337626aa536d$var$_applyDecoratedDescriptor($9c8d337626aa536d$var$_class.prototype, "taxRate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($9c8d337626aa536d$var$_class.prototype, "taxRate"), $9c8d337626aa536d$var$_class.prototype), $9c8d337626aa536d$var$_applyDecoratedDescriptor($9c8d337626aa536d$var$_class.prototype, "amount", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($9c8d337626aa536d$var$_class.prototype, "amount"), $9c8d337626aa536d$var$_class.prototype), $9c8d337626aa536d$var$_applyDecoratedDescriptor($9c8d337626aa536d$var$_class.prototype, "tax", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($9c8d337626aa536d$var$_class.prototype, "tax"), $9c8d337626aa536d$var$_class.prototype), $9c8d337626aa536d$var$_applyDecoratedDescriptor($9c8d337626aa536d$var$_class.prototype, "issueDate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($9c8d337626aa536d$var$_class.prototype, "issueDate"), $9c8d337626aa536d$var$_class.prototype), $9c8d337626aa536d$var$_applyDecoratedDescriptor($9c8d337626aa536d$var$_class.prototype, "dueDate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($9c8d337626aa536d$var$_class.prototype, "dueDate"), $9c8d337626aa536d$var$_class.prototype), $9c8d337626aa536d$var$_applyDecoratedDescriptor($9c8d337626aa536d$var$_class.prototype, "startDate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($9c8d337626aa536d$var$_class.prototype, "startDate"), $9c8d337626aa536d$var$_class.prototype), $9c8d337626aa536d$var$_applyDecoratedDescriptor($9c8d337626aa536d$var$_class.prototype, "endDate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($9c8d337626aa536d$var$_class.prototype, "endDate"), $9c8d337626aa536d$var$_class.prototype), $9c8d337626aa536d$var$_applyDecoratedDescriptor($9c8d337626aa536d$var$_class.prototype, "timeEntryStartDate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($9c8d337626aa536d$var$_class.prototype, "timeEntryStartDate"), $9c8d337626aa536d$var$_class.prototype), $9c8d337626aa536d$var$_applyDecoratedDescriptor($9c8d337626aa536d$var$_class.prototype, "formattedDescription", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($9c8d337626aa536d$var$_class.prototype, "formattedDescription"), $9c8d337626aa536d$var$_class.prototype), $9c8d337626aa536d$var$_class);
var $9c8d337626aa536d$export$2e2bcd8739ae039 = $9c8d337626aa536d$var$InvoiceLineItemModel;
const $9c8d337626aa536d$export$b5ac1d9e94403947 = {
    project: (li)=>$9c8d337626aa536d$export$f7c2451ac6791f35.project(li),
    projectcode: (li)=>$9c8d337626aa536d$export$f7c2451ac6791f35.projectcode(li),
    phase: (li)=>$9c8d337626aa536d$export$f7c2451ac6791f35.phase(li),
    phasecode: (li)=>$9c8d337626aa536d$export$f7c2451ac6791f35.phasecode(li),
    phasefee: (li)=>(0, $12o9H.FormatCurrency)($9c8d337626aa536d$export$f7c2451ac6791f35.phasefee(li)),
    phaseprogress: (li)=>(0, $gjxeM.FormatPercent)($9c8d337626aa536d$export$f7c2451ac6791f35.phaseprogress(li)),
    remainingprogress: (li)=>(0, $gjxeM.FormatPercent)($9c8d337626aa536d$export$f7c2451ac6791f35.remainingprogress(li)),
    previousprogress: (li)=>(0, $gjxeM.FormatPercent)($9c8d337626aa536d$export$f7c2451ac6791f35.previousprogress(li)),
    currentbilled: (li)=>(0, $12o9H.FormatCurrency)($9c8d337626aa536d$export$f7c2451ac6791f35.currentbilled(li)),
    previousbilled: (li)=>(0, $12o9H.FormatCurrency)($9c8d337626aa536d$export$f7c2451ac6791f35.previousbilled(li)),
    todatebilled: (li)=>(0, $12o9H.FormatCurrency)($9c8d337626aa536d$export$f7c2451ac6791f35.todatebilled(li)),
    remainingbilled: (li)=>(0, $12o9H.FormatCurrency)($9c8d337626aa536d$export$f7c2451ac6791f35.remainingbilled(li)),
    quantity: (li)=>li.lineItemType.toLowerCase().includes("progress") ? (0, $gjxeM.FormatPercent)($9c8d337626aa536d$export$f7c2451ac6791f35.quantity(li)) : (0, $cwjKY.FormatNumber)($9c8d337626aa536d$export$f7c2451ac6791f35.quantity(li)),
    hours: (li)=>(0, $cwjKY.FormatNumber)($9c8d337626aa536d$export$f7c2451ac6791f35.hours(li)),
    staff: (li)=>$9c8d337626aa536d$export$f7c2451ac6791f35.staff(li),
    // date: (li) => format(getDescriptionCodeValue.date(li), 'dd/MM/yyyy'),
    expensename: (li)=>$9c8d337626aa536d$export$f7c2451ac6791f35.expensename(li),
    expensetotal: (li)=>(0, $12o9H.FormatCurrency)($9c8d337626aa536d$export$f7c2451ac6791f35.expensetotal(li)),
    expenseprevious: (li)=>(0, $12o9H.FormatCurrency)($9c8d337626aa536d$export$f7c2451ac6791f35.expenseprevious(li)),
    expensecurrent: (li)=>(0, $12o9H.FormatCurrency)($9c8d337626aa536d$export$f7c2451ac6791f35.expensecurrent(li)),
    expensetodate: (li)=>(0, $12o9H.FormatCurrency)($9c8d337626aa536d$export$f7c2451ac6791f35.expensetodate(li)),
    expenseremaining: (li)=>(0, $12o9H.FormatCurrency)($9c8d337626aa536d$export$f7c2451ac6791f35.expenseremaining(li)),
    expenseprogress: (li)=>(0, $gjxeM.FormatPercent)($9c8d337626aa536d$export$f7c2451ac6791f35.expenseprogress(li)),
    expensepreviousprogress: (li)=>(0, $gjxeM.FormatPercent)($9c8d337626aa536d$export$f7c2451ac6791f35.expensepreviousprogress(li)),
    expenseremainingprogress: (li)=>(0, $gjxeM.FormatPercent)($9c8d337626aa536d$export$f7c2451ac6791f35.expenseremainingprogress(li))
};
const $9c8d337626aa536d$export$f7c2451ac6791f35 = {
    project: (li)=>{
        var _li$invoice, _li$invoice$cachedDat, _li$invoice$cachedDat2;
        return li === null || li === void 0 ? void 0 : (_li$invoice = li.invoice) === null || _li$invoice === void 0 ? void 0 : (_li$invoice$cachedDat = _li$invoice.cachedData) === null || _li$invoice$cachedDat === void 0 ? void 0 : (_li$invoice$cachedDat2 = _li$invoice$cachedDat.project) === null || _li$invoice$cachedDat2 === void 0 ? void 0 : _li$invoice$cachedDat2.name;
    },
    projectcode: (li)=>{
        var _li$invoice2, _li$invoice2$cachedDa, _li$invoice2$cachedDa2;
        return li === null || li === void 0 ? void 0 : (_li$invoice2 = li.invoice) === null || _li$invoice2 === void 0 ? void 0 : (_li$invoice2$cachedDa = _li$invoice2.cachedData) === null || _li$invoice2$cachedDa === void 0 ? void 0 : (_li$invoice2$cachedDa2 = _li$invoice2$cachedDa.project) === null || _li$invoice2$cachedDa2 === void 0 ? void 0 : _li$invoice2$cachedDa2.jobNumber;
    },
    phase: (li)=>{
        var _li$invoice3, _li$invoice3$cachedDa, _li$invoice3$cachedDa2;
        return li === null || li === void 0 ? void 0 : (_li$invoice3 = li.invoice) === null || _li$invoice3 === void 0 ? void 0 : (_li$invoice3$cachedDa = _li$invoice3.cachedData) === null || _li$invoice3$cachedDa === void 0 ? void 0 : (_li$invoice3$cachedDa2 = _li$invoice3$cachedDa.phases[li.phaseId]) === null || _li$invoice3$cachedDa2 === void 0 ? void 0 : _li$invoice3$cachedDa2.name;
    },
    phasecode: (li)=>{
        var _li$invoice4, _li$invoice4$cachedDa, _li$invoice4$cachedDa2;
        return li === null || li === void 0 ? void 0 : (_li$invoice4 = li.invoice) === null || _li$invoice4 === void 0 ? void 0 : (_li$invoice4$cachedDa = _li$invoice4.cachedData) === null || _li$invoice4$cachedDa === void 0 ? void 0 : (_li$invoice4$cachedDa2 = _li$invoice4$cachedDa.phases[li.phaseId]) === null || _li$invoice4$cachedDa2 === void 0 ? void 0 : _li$invoice4$cachedDa2.jobNumber;
    },
    phasefee: (li)=>{
        var _li$invoice5, _li$invoice5$cachedDa, _li$invoice5$cachedDa2;
        return (li === null || li === void 0 ? void 0 : (_li$invoice5 = li.invoice) === null || _li$invoice5 === void 0 ? void 0 : (_li$invoice5$cachedDa = _li$invoice5.cachedData) === null || _li$invoice5$cachedDa === void 0 ? void 0 : (_li$invoice5$cachedDa2 = _li$invoice5$cachedDa.phases[li.phaseId]) === null || _li$invoice5$cachedDa2 === void 0 ? void 0 : _li$invoice5$cachedDa2.fee) || 0;
    },
    phaseprogress: (li)=>$9c8d337626aa536d$export$f7c2451ac6791f35.todatebilled(li) / $9c8d337626aa536d$export$f7c2451ac6791f35.phasefee(li) || 0,
    remainingprogress: (li)=>1 - $9c8d337626aa536d$export$f7c2451ac6791f35.phaseprogress(li) || 0,
    previousprogress: (li)=>$9c8d337626aa536d$export$f7c2451ac6791f35.previousbilled(li) / $9c8d337626aa536d$export$f7c2451ac6791f35.phasefee(li) || 0,
    currentbilled: (li)=>{
        var _li$invoice6;
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum((((_li$invoice6 = li.invoice) === null || _li$invoice6 === void 0 ? void 0 : _li$invoice6.lineItems) || []).filter((li2)=>li2.billingType === "agreedFee" && li2.phase === li.phase).map((li2)=>li2.amount)) || 0;
    },
    previousbilled: (li)=>{
        var _li$invoice7, _li$invoice7$cachedDa, _li$invoice7$cachedDa2;
        return (li === null || li === void 0 ? void 0 : (_li$invoice7 = li.invoice) === null || _li$invoice7 === void 0 ? void 0 : (_li$invoice7$cachedDa = _li$invoice7.cachedData) === null || _li$invoice7$cachedDa === void 0 ? void 0 : (_li$invoice7$cachedDa2 = _li$invoice7$cachedDa.phases[li.phaseId]) === null || _li$invoice7$cachedDa2 === void 0 ? void 0 : _li$invoice7$cachedDa2.previousBilled) || 0;
    },
    todatebilled: (li)=>$9c8d337626aa536d$export$f7c2451ac6791f35.previousbilled(li) + $9c8d337626aa536d$export$f7c2451ac6791f35.currentbilled(li),
    remainingbilled: (li)=>$9c8d337626aa536d$export$f7c2451ac6791f35.phasefee(li) - $9c8d337626aa536d$export$f7c2451ac6791f35.todatebilled(li),
    quantity: (li)=>li.unitQuantity,
    hours: (li)=>li.unitQuantity,
    staff: function(li) {
        return li.staff.map((st)=>st.fullName).join(", ");
    },
    // date: function (li) {
    //     return li.timeEntries[0].date
    // },
    expensename: (li)=>{
        var _li$invoice8, _li$invoice8$cachedDa, _li$invoice8$cachedDa2;
        return li === null || li === void 0 ? void 0 : (_li$invoice8 = li.invoice) === null || _li$invoice8 === void 0 ? void 0 : (_li$invoice8$cachedDa = _li$invoice8.cachedData) === null || _li$invoice8$cachedDa === void 0 ? void 0 : (_li$invoice8$cachedDa2 = _li$invoice8$cachedDa.expenses[li.expenseId]) === null || _li$invoice8$cachedDa2 === void 0 ? void 0 : _li$invoice8$cachedDa2.name;
    },
    expensetotal: (li)=>{
        var _li$invoice9, _li$invoice9$cachedDa, _li$invoice9$cachedDa2;
        return (li === null || li === void 0 ? void 0 : (_li$invoice9 = li.invoice) === null || _li$invoice9 === void 0 ? void 0 : (_li$invoice9$cachedDa = _li$invoice9.cachedData) === null || _li$invoice9$cachedDa === void 0 ? void 0 : (_li$invoice9$cachedDa2 = _li$invoice9$cachedDa.expenses[li.expenseId]) === null || _li$invoice9$cachedDa2 === void 0 ? void 0 : _li$invoice9$cachedDa2.cost) || 0;
    },
    expenseprevious: (li)=>{
        var _li$invoice10, _li$invoice10$cachedD, _li$invoice10$cachedD2;
        return (li === null || li === void 0 ? void 0 : (_li$invoice10 = li.invoice) === null || _li$invoice10 === void 0 ? void 0 : (_li$invoice10$cachedD = _li$invoice10.cachedData) === null || _li$invoice10$cachedD === void 0 ? void 0 : (_li$invoice10$cachedD2 = _li$invoice10$cachedD.expenses[li.expenseId]) === null || _li$invoice10$cachedD2 === void 0 ? void 0 : _li$invoice10$cachedD2.previousBilled) || 0;
    },
    expensecurrent: (li)=>{
        var _li$invoice11;
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum((((_li$invoice11 = li.invoice) === null || _li$invoice11 === void 0 ? void 0 : _li$invoice11.lineItems) || []).filter((li2)=>li2.expense === li.expense).map((li2)=>li2.amount)) || 0;
    },
    expensetodate: (li)=>$9c8d337626aa536d$export$f7c2451ac6791f35.expenseprevious(li) + $9c8d337626aa536d$export$f7c2451ac6791f35.expensecurrent(li),
    expenseremaining: (li)=>$9c8d337626aa536d$export$f7c2451ac6791f35.expensetotal(li) - $9c8d337626aa536d$export$f7c2451ac6791f35.expensetodate(li),
    expenseprogress: (li)=>{
        return $9c8d337626aa536d$export$f7c2451ac6791f35.expensetodate(li) / $9c8d337626aa536d$export$f7c2451ac6791f35.expensetotal(li);
    },
    expensepreviousprogress: (li)=>{
        return $9c8d337626aa536d$export$f7c2451ac6791f35.expenseprevious(li) / $9c8d337626aa536d$export$f7c2451ac6791f35.expensetotal(li);
    },
    expenseremainingprogress: (li)=>1 - $9c8d337626aa536d$export$f7c2451ac6791f35.expenseprogress(li)
};

});
parcelRegister("lCpBr", function(module, exports) {
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : module.exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});

parcelRegister("afJLg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $776ecd5997a6523b$export$2e2bcd8739ae039; });
var $776ecd5997a6523b$export$2e2bcd8739ae039 = ({ day: day, month: month, year: year }, context)=>{
    return {
        type: "date",
        value: new Date(year, month - 1, day).getTime(),
        primitive: true
    };
};

});

parcelRegister("12o9H", function(module, exports) {

$parcel$export(module.exports, "FormatCurrency", function () { return $0c18b7226807c85a$export$86025f4579c41922; });

var $d0JnH = parcelRequire("d0JnH");


var $8KnSr = parcelRequire("8KnSr");

var $3arU6 = parcelRequire("3arU6");

var $1BTI2 = parcelRequire("1BTI2");

var $aTUKb = parcelRequire("aTUKb");
const $0c18b7226807c85a$export$86025f4579c41922 = (value, { decimals: decimals = 2, currency: currency = (0, (/*@__PURE__*/$parcel$interopDefault($8KnSr))).getCurrency((0, (/*@__PURE__*/$parcel$interopDefault($3arU6))).findCountryLocales((0, $aTUKb.constantCase)(((0, $1BTI2.default) === null || (0, $1BTI2.default) === void 0 ? void 0 : (0, $1BTI2.default).organisationCountry) || "us"))[0]), compact: compact = false } = {})=>{
    if ([
        null,
        undefined,
        ""
    ].includes(value)) return value;
    const formatter = new (0, $d0JnH.NumberFormatter)((0, (/*@__PURE__*/$parcel$interopDefault($3arU6))).findCountryLocales((0, $aTUKb.constantCase)(((0, $1BTI2.default) === null || (0, $1BTI2.default) === void 0 ? void 0 : (0, $1BTI2.default).organisationCountry) || "us"))[0], {
        style: "currency",
        currency: currency || "USD",
        maximumFractionDigits: decimals,
        notation: compact ? "compact" : "standard"
    });
    return formatter.format(value);
};

});
parcelRegister("d0JnH", function(module, exports) {

$parcel$export(module.exports, "NumberFormatter", function () { return $978e7a35314266d3$export$cc77c4ff7e8673c5; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $978e7a35314266d3$var$$488c6ddbf4ef74c2$var$formatterCache = new Map();
let $978e7a35314266d3$var$$488c6ddbf4ef74c2$var$supportsSignDisplay = false;
try {
    // @ts-ignore
    $978e7a35314266d3$var$$488c6ddbf4ef74c2$var$supportsSignDisplay = new Intl.NumberFormat("de-DE", {
        signDisplay: "exceptZero"
    }).resolvedOptions().signDisplay === "exceptZero";
// eslint-disable-next-line no-empty
} catch (e) {}
let $978e7a35314266d3$var$$488c6ddbf4ef74c2$var$supportsUnit = false;
try {
    // @ts-ignore
    $978e7a35314266d3$var$$488c6ddbf4ef74c2$var$supportsUnit = new Intl.NumberFormat("de-DE", {
        style: "unit",
        unit: "degree"
    }).resolvedOptions().style === "unit";
// eslint-disable-next-line no-empty
} catch (e) {}
// Polyfill for units since Safari doesn't support them yet. See https://bugs.webkit.org/show_bug.cgi?id=215438.
// Currently only polyfilling the unit degree in narrow format for ColorSlider in our supported locales.
// Values were determined by switching to each locale manually in Chrome.
const $978e7a35314266d3$var$$488c6ddbf4ef74c2$var$UNITS = {
    degree: {
        narrow: {
            default: "\xb0",
            "ja-JP": " \u5EA6",
            "zh-TW": "\u5EA6",
            "sl-SI": " \xb0"
        }
    }
};
class $978e7a35314266d3$export$cc77c4ff7e8673c5 {
    /** Formats a number value as a string, according to the locale and options provided to the constructor. */ format(value) {
        let res = "";
        if (!$978e7a35314266d3$var$$488c6ddbf4ef74c2$var$supportsSignDisplay && this.options.signDisplay != null) res = $978e7a35314266d3$export$711b50b3c525e0f2(this.numberFormatter, this.options.signDisplay, value);
        else res = this.numberFormatter.format(value);
        if (this.options.style === "unit" && !$978e7a35314266d3$var$$488c6ddbf4ef74c2$var$supportsUnit) {
            var _UNITS_unit;
            let { unit: unit, unitDisplay: unitDisplay = "short", locale: locale } = this.resolvedOptions();
            if (!unit) return res;
            let values = (_UNITS_unit = $978e7a35314266d3$var$$488c6ddbf4ef74c2$var$UNITS[unit]) === null || _UNITS_unit === void 0 ? void 0 : _UNITS_unit[unitDisplay];
            res += values[locale] || values.default;
        }
        return res;
    }
    /** Formats a number to an array of parts such as separators, digits, punctuation, and more. */ formatToParts(value) {
        // TODO: implement signDisplay for formatToParts
        // @ts-ignore
        return this.numberFormatter.formatToParts(value);
    }
    /** Formats a number range as a string. */ formatRange(start, end) {
        // @ts-ignore
        if (typeof this.numberFormatter.formatRange === "function") return this.numberFormatter.formatRange(start, end);
        if (end < start) throw new RangeError("End date must be >= start date");
        // Very basic fallback for old browsers.
        return `${this.format(start)} \u{2013} ${this.format(end)}`;
    }
    /** Formats a number range as an array of parts. */ formatRangeToParts(start, end) {
        // @ts-ignore
        if (typeof this.numberFormatter.formatRangeToParts === "function") return this.numberFormatter.formatRangeToParts(start, end);
        if (end < start) throw new RangeError("End date must be >= start date");
        let startParts = this.numberFormatter.formatToParts(start);
        let endParts = this.numberFormatter.formatToParts(end);
        return [
            ...startParts.map((p)=>({
                    ...p,
                    source: "startRange"
                })),
            {
                type: "literal",
                value: " \u2013 ",
                source: "shared"
            },
            ...endParts.map((p)=>({
                    ...p,
                    source: "endRange"
                }))
        ];
    }
    /** Returns the resolved formatting options based on the values passed to the constructor. */ resolvedOptions() {
        let options = this.numberFormatter.resolvedOptions();
        if (!$978e7a35314266d3$var$$488c6ddbf4ef74c2$var$supportsSignDisplay && this.options.signDisplay != null) options = {
            ...options,
            signDisplay: this.options.signDisplay
        };
        if (!$978e7a35314266d3$var$$488c6ddbf4ef74c2$var$supportsUnit && this.options.style === "unit") options = {
            ...options,
            style: "unit",
            unit: this.options.unit,
            unitDisplay: this.options.unitDisplay
        };
        return options;
    }
    constructor(locale, options = {}){
        this.numberFormatter = $978e7a35314266d3$var$$488c6ddbf4ef74c2$var$getCachedNumberFormatter(locale, options);
        this.options = options;
    }
}
function $978e7a35314266d3$var$$488c6ddbf4ef74c2$var$getCachedNumberFormatter(locale, options = {}) {
    let { numberingSystem: numberingSystem } = options;
    if (numberingSystem && locale.includes("-nu-")) {
        if (!locale.includes("-u-")) locale += "-u-";
        locale += `-nu-${numberingSystem}`;
    }
    if (options.style === "unit" && !$978e7a35314266d3$var$$488c6ddbf4ef74c2$var$supportsUnit) {
        var _UNITS_unit;
        let { unit: unit, unitDisplay: unitDisplay = "short" } = options;
        if (!unit) throw new Error('unit option must be provided with style: "unit"');
        if (!((_UNITS_unit = $978e7a35314266d3$var$$488c6ddbf4ef74c2$var$UNITS[unit]) === null || _UNITS_unit === void 0 ? void 0 : _UNITS_unit[unitDisplay])) throw new Error(`Unsupported unit ${unit} with unitDisplay = ${unitDisplay}`);
        options = {
            ...options,
            style: "decimal"
        };
    }
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : "");
    if ($978e7a35314266d3$var$$488c6ddbf4ef74c2$var$formatterCache.has(cacheKey)) return $978e7a35314266d3$var$$488c6ddbf4ef74c2$var$formatterCache.get(cacheKey);
    let numberFormatter = new Intl.NumberFormat(locale, options);
    $978e7a35314266d3$var$$488c6ddbf4ef74c2$var$formatterCache.set(cacheKey, numberFormatter);
    return numberFormatter;
}
function $978e7a35314266d3$export$711b50b3c525e0f2(numberFormat, signDisplay, num) {
    if (signDisplay === "auto") return numberFormat.format(num);
    else if (signDisplay === "never") return numberFormat.format(Math.abs(num));
    else {
        let needsPositiveSign = false;
        if (signDisplay === "always") needsPositiveSign = num > 0 || Object.is(num, 0);
        else if (signDisplay === "exceptZero") {
            if (Object.is(num, -0) || Object.is(num, 0)) num = Math.abs(num);
            else needsPositiveSign = num > 0;
        }
        if (needsPositiveSign) {
            let negative = numberFormat.format(-num);
            let noSign = numberFormat.format(num);
            // ignore RTL/LTR marker character
            let minus = negative.replace(noSign, "").replace(/\u200e|\u061C/, "");
            if ([
                ...minus
            ].length !== 1) console.warn("@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case");
            let positive = negative.replace(noSign, "!!!").replace(minus, "+").replace("!!!", noSign);
            return positive;
        } else return numberFormat.format(num);
    }
}

});

parcelRegister("8KnSr", function(module, exports) {

$parcel$export(module.exports, "getCurrency", function () { return $65e524158508a4af$export$f07e486b45756574; }, function (v) { return $65e524158508a4af$export$f07e486b45756574 = v; });
$parcel$export(module.exports, "getLocales", function () { return $65e524158508a4af$export$63967f17cb506053; }, function (v) { return $65e524158508a4af$export$63967f17cb506053 = v; });
var $65e524158508a4af$export$f07e486b45756574;
var $65e524158508a4af$export$63967f17cb506053;

var $kJZts = parcelRequire("kJZts");
var $65e524158508a4af$var$getCountryCode = function(localeString) {
    var components = localeString.split("_");
    if (components.length == 2) return components.pop();
    components = localeString.split("-");
    if (components.length == 2) return components.pop();
    return localeString;
};
$65e524158508a4af$export$f07e486b45756574 = function(locale) {
    var countryCode1 = $65e524158508a4af$var$getCountryCode(locale).toUpperCase();
    if (countryCode1 in $kJZts) return $kJZts[countryCode1];
    return null;
};
$65e524158508a4af$export$63967f17cb506053 = function(currencyCode) {
    currencyCode = currencyCode.toUpperCase();
    var locales = [];
    for(countryCode in $kJZts)if ($kJZts[countryCode] === currencyCode) locales.push(countryCode);
    return locales;
};

});
parcelRegister("kJZts", function(module, exports) {
// Generated using ShowCurrencies.java
var $f197b21a629b2c6e$var$map = {
    AD: "EUR",
    AE: "AED",
    AF: "AFN",
    AG: "XCD",
    AI: "XCD",
    AL: "ALL",
    AM: "AMD",
    AN: "ANG",
    AO: "AOA",
    AR: "ARS",
    AS: "USD",
    AT: "EUR",
    AU: "AUD",
    AW: "AWG",
    AX: "EUR",
    AZ: "AZN",
    BA: "BAM",
    BB: "BBD",
    BD: "BDT",
    BE: "EUR",
    BF: "XOF",
    BG: "BGN",
    BH: "BHD",
    BI: "BIF",
    BJ: "XOF",
    BL: "EUR",
    BM: "BMD",
    BN: "BND",
    BO: "BOB",
    BQ: "USD",
    BR: "BRL",
    BS: "BSD",
    BT: "BTN",
    BV: "NOK",
    BW: "BWP",
    BY: "BYR",
    BZ: "BZD",
    CA: "CAD",
    CC: "AUD",
    CD: "CDF",
    CF: "XAF",
    CG: "XAF",
    CH: "CHF",
    CI: "XOF",
    CK: "NZD",
    CL: "CLP",
    CM: "XAF",
    CN: "CNY",
    CO: "COP",
    CR: "CRC",
    CU: "CUP",
    CV: "CVE",
    CW: "ANG",
    CX: "AUD",
    CY: "EUR",
    CZ: "CZK",
    DE: "EUR",
    DJ: "DJF",
    DK: "DKK",
    DM: "XCD",
    DO: "DOP",
    DZ: "DZD",
    EC: "USD",
    EE: "EUR",
    EG: "EGP",
    EH: "MAD",
    ER: "ERN",
    ES: "EUR",
    ET: "ETB",
    FI: "EUR",
    FJ: "FJD",
    FK: "FKP",
    FM: "USD",
    FO: "DKK",
    FR: "EUR",
    GA: "XAF",
    GB: "GBP",
    GD: "XCD",
    GE: "GEL",
    GF: "EUR",
    GG: "GBP",
    GH: "GHS",
    GI: "GIP",
    GL: "DKK",
    GM: "GMD",
    GN: "GNF",
    GP: "EUR",
    GQ: "XAF",
    GR: "EUR",
    GS: "GBP",
    GT: "GTQ",
    GU: "USD",
    GW: "XOF",
    GY: "GYD",
    HK: "HKD",
    HM: "AUD",
    HN: "HNL",
    HR: "HRK",
    HT: "HTG",
    HU: "HUF",
    ID: "IDR",
    IE: "EUR",
    IL: "ILS",
    IM: "GBP",
    IN: "INR",
    IO: "USD",
    IQ: "IQD",
    IR: "IRR",
    IS: "ISK",
    IT: "EUR",
    JE: "GBP",
    JM: "JMD",
    JO: "JOD",
    JP: "JPY",
    KE: "KES",
    KG: "KGS",
    KH: "KHR",
    KI: "AUD",
    KM: "KMF",
    KN: "XCD",
    KP: "KPW",
    KR: "KRW",
    KW: "KWD",
    KY: "KYD",
    KZ: "KZT",
    LA: "LAK",
    LB: "LBP",
    LC: "XCD",
    LI: "CHF",
    LK: "LKR",
    LR: "LRD",
    LS: "LSL",
    LT: "LTL",
    LU: "EUR",
    LV: "LVL",
    LY: "LYD",
    MA: "MAD",
    MC: "EUR",
    MD: "MDL",
    ME: "EUR",
    MF: "EUR",
    MG: "MGA",
    MH: "USD",
    MK: "MKD",
    ML: "XOF",
    MM: "MMK",
    MN: "MNT",
    MO: "MOP",
    MP: "USD",
    MQ: "EUR",
    MR: "MRO",
    MS: "XCD",
    MT: "EUR",
    MU: "MUR",
    MV: "MVR",
    MW: "MWK",
    MX: "MXN",
    MY: "MYR",
    MZ: "MZN",
    NA: "NAD",
    NC: "XPF",
    NE: "XOF",
    NF: "AUD",
    NG: "NGN",
    NI: "NIO",
    NL: "EUR",
    NO: "NOK",
    NP: "NPR",
    NR: "AUD",
    NU: "NZD",
    NZ: "NZD",
    OM: "OMR",
    PA: "PAB",
    PE: "PEN",
    PF: "XPF",
    PG: "PGK",
    PH: "PHP",
    PK: "PKR",
    PL: "PLN",
    PM: "EUR",
    PN: "NZD",
    PR: "USD",
    PS: "ILS",
    PT: "EUR",
    PW: "USD",
    PY: "PYG",
    QA: "QAR",
    RE: "EUR",
    RO: "RON",
    RS: "RSD",
    RU: "RUB",
    RW: "RWF",
    SA: "SAR",
    SB: "SBD",
    SC: "SCR",
    SD: "SDG",
    SE: "SEK",
    SG: "SGD",
    SH: "SHP",
    SI: "EUR",
    SJ: "NOK",
    SK: "EUR",
    SL: "SLL",
    SM: "EUR",
    SN: "XOF",
    SO: "SOS",
    SR: "SRD",
    ST: "STD",
    SV: "SVC",
    SX: "ANG",
    SY: "SYP",
    SZ: "SZL",
    TC: "USD",
    TD: "XAF",
    TF: "EUR",
    TG: "XOF",
    TH: "THB",
    TJ: "TJS",
    TK: "NZD",
    TL: "USD",
    TM: "TMT",
    TN: "TND",
    TO: "TOP",
    TR: "TRY",
    TT: "TTD",
    TV: "AUD",
    TW: "TWD",
    TZ: "TZS",
    UA: "UAH",
    UG: "UGX",
    UM: "USD",
    US: "USD",
    UY: "UYU",
    UZ: "UZS",
    VA: "EUR",
    VC: "XCD",
    VE: "VEF",
    VG: "USD",
    VI: "USD",
    VN: "VND",
    VU: "VUV",
    WF: "XPF",
    WS: "WST",
    YE: "YER",
    YT: "EUR",
    ZA: "ZAR",
    ZM: "ZMK",
    ZW: "ZWL"
};
module.exports = $f197b21a629b2c6e$var$map;

});


parcelRegister("3arU6", function(module, exports) {

var $jKFgG = parcelRequire("jKFgG");
/**
 * Takes a locale code and checks if exists in the data dictionary
 * @param {string} localeCode - Language code (e.g. "en-GB")
 * @return {boolean}
 */ const $24e7f363f33eb5a7$var$validateLocaleCode = (localeCode)=>{
    return $jKFgG.findIndex((l)=>l.code === localeCode) !== -1;
};
/**
 * Takes a language code and checks if exists in the data dictionary
 * @param {string} languageCode - Language code (e.g. "en")
 * @return {boolean}
 */ const $24e7f363f33eb5a7$var$validateLanguageCode = (languageCode)=>{
    return $jKFgG.findIndex((l)=>l.langCode === languageCode) !== -1;
};
/**
 * Takes a country code and returns the list of languages valid for it
 * @param {string} countryCode - Country code (e.g. "PT")
 * @return {string[]} Languages list
 */ const $24e7f363f33eb5a7$var$findCountryLanguages = (countryCode)=>{
    const countryEntries = $jKFgG.filter((l)=>l.countryCode === countryCode);
    const langSet = new Set();
    countryEntries.forEach((e, i)=>langSet.add(countryEntries[i].langCode));
    return Array.from(langSet);
};
/**
 * Takes a country code and returns the list of locales valid for it
 * @param {string} countryCode - Country code (e.g. "PT")
 * @return {string[]} Locales list
 */ const $24e7f363f33eb5a7$var$findCountryLocales = (countryCode)=>{
    const countryEntries = $jKFgG.filter((l)=>l.countryCode === countryCode);
    const localeSet = new Set();
    countryEntries.forEach((e, i)=>localeSet.add(countryEntries[i].code));
    return Array.from(localeSet);
};
/**
 * Returns a list with a map of all existing locale codes and the respective country+language
 * @return {Object} Locales list in the form of a map: ['pt-PT'] => 'Portuguese (PT)'
 */ const $24e7f363f33eb5a7$var$locales = ()=>{
    const map = {};
    for (const l of $jKFgG)map[l.code] = `${l.language} (${l.countryCode})`;
    return map;
};
/**
 * Returns the country name for a given locale code
 * @param {string} localeCode - Locale code (e.g. "en-GB")
 * @return {string} Country name or undefined if not found
 */ const $24e7f363f33eb5a7$var$getCountryByLocale = (localeCode)=>{
    const entry = $jKFgG.find((l)=>l.code === localeCode);
    return entry?.country;
};
module.exports = {
    locales: $24e7f363f33eb5a7$var$locales,
    validateLocaleCode: $24e7f363f33eb5a7$var$validateLocaleCode,
    validateLanguageCode: $24e7f363f33eb5a7$var$validateLanguageCode,
    findCountryLanguages: $24e7f363f33eb5a7$var$findCountryLanguages,
    findCountryLocales: $24e7f363f33eb5a7$var$findCountryLocales,
    getCountryByLocale: $24e7f363f33eb5a7$var$getCountryByLocale
};

});
parcelRegister("jKFgG", function(module, exports) {
module.exports = JSON.parse('[{"code":"af-NA","langCode":"af","countryCode":"NA","country":"Namibia","language":"Afrikaans"},{"code":"af-ZA","langCode":"af","countryCode":"ZA","country":"South Africa","language":"Afrikaans"},{"code":"ak-GH","langCode":"ak","countryCode":"GH","country":"Ghana","language":"Akan"},{"code":"am-ET","langCode":"am","countryCode":"ET","country":"Ethiopia","language":"Amharic"},{"code":"ar-AE","langCode":"ar","countryCode":"AE","country":"United Arab Emirates","language":"Arabic"},{"code":"ar-BH","langCode":"ar","countryCode":"BH","country":"Bahrain","language":"Arabic"},{"code":"ar-DJ","langCode":"ar","countryCode":"DJ","country":"Djibouti","language":"Arabic"},{"code":"ar-DZ","langCode":"ar","countryCode":"DZ","country":"Algeria","language":"Arabic"},{"code":"ar-EG","langCode":"ar","countryCode":"EG","country":"Egypt","language":"Arabic"},{"code":"ar-EH","langCode":"ar","countryCode":"EH","country":"Western Sahara","language":"Arabic"},{"code":"ar-ER","langCode":"ar","countryCode":"ER","country":"Eritrea","language":"Arabic"},{"code":"ar-IL","langCode":"ar","countryCode":"IL","country":"Israel","language":"Arabic"},{"code":"ar-IQ","langCode":"ar","countryCode":"IQ","country":"Iraq","language":"Arabic"},{"code":"ar-JO","langCode":"ar","countryCode":"JO","country":"Jordan","language":"Arabic"},{"code":"ar-KM","langCode":"ar","countryCode":"KM","country":"Comoros","language":"Arabic"},{"code":"ar-KW","langCode":"ar","countryCode":"KW","country":"Kuwait","language":"Arabic"},{"code":"ar-LB","langCode":"ar","countryCode":"LB","country":"Lebanon","language":"Arabic"},{"code":"ar-LY","langCode":"ar","countryCode":"LY","country":"Libya","language":"Arabic"},{"code":"ar-MA","langCode":"ar","countryCode":"MA","country":"Morocco","language":"Arabic"},{"code":"ar-MR","langCode":"ar","countryCode":"MR","country":"Mauritania","language":"Arabic"},{"code":"ar-OM","langCode":"ar","countryCode":"OM","country":"Oman","language":"Arabic"},{"code":"ar-PS","langCode":"ar","countryCode":"PS","country":"Palestine, State of","language":"Arabic"},{"code":"ar-QA","langCode":"ar","countryCode":"QA","country":"Qatar","language":"Arabic"},{"code":"ar-SA","langCode":"ar","countryCode":"SA","country":"Saudi Arabia","language":"Arabic"},{"code":"ar-SD","langCode":"ar","countryCode":"SD","country":"Sudan","language":"Arabic"},{"code":"ar-SO","langCode":"ar","countryCode":"SO","country":"Somalia","language":"Arabic"},{"code":"ar-SS","langCode":"ar","countryCode":"SS","country":"South Sudan","language":"Arabic"},{"code":"ar-SY","langCode":"ar","countryCode":"SY","country":"Syrian Arab Republic","language":"Arabic"},{"code":"ar-TD","langCode":"ar","countryCode":"TD","country":"Chad","language":"Arabic"},{"code":"ar-TN","langCode":"ar","countryCode":"TN","country":"Tunisia","language":"Arabic"},{"code":"ar-YE","langCode":"ar","countryCode":"YE","country":"Yemen","language":"Arabic"},{"code":"as-IN","langCode":"as","countryCode":"IN","country":"India","language":"Assamese"},{"code":"az-Cyrl-AZ","langCode":"az","countryCode":"AZ","country":"Azerbaijan","language":"Azerbaijani"},{"code":"az-Latn-AZ","langCode":"az","countryCode":"AZ","country":"Azerbaijan","language":"Azerbaijani"},{"code":"be-BY","langCode":"be","countryCode":"BY","country":"Belarus","language":"Belarusian"},{"code":"bg-BG","langCode":"bg","countryCode":"BG","country":"Bulgaria","language":"Bulgarian"},{"code":"bm-ML","langCode":"bm","countryCode":"ML","country":"Mali","language":"Bambara"},{"code":"bn-BD","langCode":"bn","countryCode":"BD","country":"Bangladesh","language":"Bengali"},{"code":"bn-IN","langCode":"bn","countryCode":"IN","country":"India","language":"Bengali"},{"code":"bo-CN","langCode":"bo","countryCode":"CN","country":"China","language":"Tibetan"},{"code":"bo-IN","langCode":"bo","countryCode":"IN","country":"India","language":"Tibetan"},{"code":"br-FR","langCode":"br","countryCode":"FR","country":"France","language":"Breton"},{"code":"bs-Cyrl-BA","langCode":"bs","countryCode":"BA","country":"Bosnia and Herzegovina","language":"Bosnian"},{"code":"bs-Latn-BA","langCode":"bs","countryCode":"BA","country":"Bosnia and Herzegovina","language":"Bosnian"},{"code":"ca-AD","langCode":"ca","countryCode":"AD","country":"Andorra","language":"Catalan; Valencian"},{"code":"ca-ES","langCode":"ca","countryCode":"ES","country":"Spain","language":"Catalan; Valencian"},{"code":"ca-ES-VALENCIA","langCode":"ca","countryCode":"ES","country":"Spain","language":"Catalan; Valencian"},{"code":"ca-FR","langCode":"ca","countryCode":"FR","country":"France","language":"Catalan; Valencian"},{"code":"ca-IT","langCode":"ca","countryCode":"IT","country":"Italy","language":"Catalan; Valencian"},{"code":"ce-RU","langCode":"ce","countryCode":"RU","country":"Russian Federation","language":"Chechen"},{"code":"cs-CZ","langCode":"cs","countryCode":"CZ","country":"Czech Republic","language":"Czech"},{"code":"cu-RU","langCode":"cu","countryCode":"RU","country":"Russian Federation","language":"Church Slavic; Old Slavonic; Church Slavonic; Old Bulgarian; Old Church Slavonic"},{"code":"cy-GB","langCode":"cy","countryCode":"GB","country":"United Kingdom","language":"Welsh"},{"code":"da-DK","langCode":"da","countryCode":"DK","country":"Denmark","language":"Danish"},{"code":"da-GL","langCode":"da","countryCode":"GL","country":"Greenland","language":"Danish"},{"code":"de-AT","langCode":"de","countryCode":"AT","country":"Austria","language":"German"},{"code":"de-BE","langCode":"de","countryCode":"BE","country":"Belgium","language":"German"},{"code":"de-CH","langCode":"de","countryCode":"CH","country":"Switzerland","language":"German"},{"code":"de-DE","langCode":"de","countryCode":"DE","country":"Germany","language":"German"},{"code":"de-IT","langCode":"de","countryCode":"IT","country":"Italy","language":"German"},{"code":"de-LI","langCode":"de","countryCode":"LI","country":"Liechtenstein","language":"German"},{"code":"de-LU","langCode":"de","countryCode":"LU","country":"Luxembourg","language":"German"},{"code":"dz-BT","langCode":"dz","countryCode":"BT","country":"Bhutan","language":"Dzongkha"},{"code":"ee-GH","langCode":"ee","countryCode":"GH","country":"Ghana","language":"Ewe"},{"code":"ee-TG","langCode":"ee","countryCode":"TG","country":"Togo","language":"Ewe"},{"code":"el-CY","langCode":"el","countryCode":"CY","country":"Cyprus","language":"Greek, Modern (1453-)"},{"code":"el-GR","langCode":"el","countryCode":"GR","country":"Greece","language":"Greek, Modern (1453-)"},{"code":"en-AG","langCode":"en","countryCode":"AG","country":"Antigua and Barbuda","language":"English"},{"code":"en-AI","langCode":"en","countryCode":"AI","country":"Anguilla","language":"English"},{"code":"en-AS","langCode":"en","countryCode":"AS","country":"American Samoa","language":"English"},{"code":"en-AT","langCode":"en","countryCode":"AT","country":"Austria","language":"English"},{"code":"en-AU","langCode":"en","countryCode":"AU","country":"Australia","language":"English"},{"code":"en-BB","langCode":"en","countryCode":"BB","country":"Barbados","language":"English"},{"code":"en-BE","langCode":"en","countryCode":"BE","country":"Belgium","language":"English"},{"code":"en-BI","langCode":"en","countryCode":"BI","country":"Burundi","language":"English"},{"code":"en-BM","langCode":"en","countryCode":"BM","country":"Bermuda","language":"English"},{"code":"en-BS","langCode":"en","countryCode":"BS","country":"Bahamas","language":"English"},{"code":"en-BW","langCode":"en","countryCode":"BW","country":"Botswana","language":"English"},{"code":"en-BZ","langCode":"en","countryCode":"BZ","country":"Belize","language":"English"},{"code":"en-CA","langCode":"en","countryCode":"CA","country":"Canada","language":"English"},{"code":"en-CC","langCode":"en","countryCode":"CC","country":"Cocos (Keeling) Islands","language":"English"},{"code":"en-CH","langCode":"en","countryCode":"CH","country":"Switzerland","language":"English"},{"code":"en-CK","langCode":"en","countryCode":"CK","country":"Cook Islands","language":"English"},{"code":"en-CM","langCode":"en","countryCode":"CM","country":"Cameroon","language":"English"},{"code":"en-CX","langCode":"en","countryCode":"CX","country":"Christmas Island","language":"English"},{"code":"en-CY","langCode":"en","countryCode":"CY","country":"Cyprus","language":"English"},{"code":"en-DE","langCode":"en","countryCode":"DE","country":"Germany","language":"English"},{"code":"en-DK","langCode":"en","countryCode":"DK","country":"Denmark","language":"English"},{"code":"en-DM","langCode":"en","countryCode":"DM","country":"Dominica","language":"English"},{"code":"en-ER","langCode":"en","countryCode":"ER","country":"Eritrea","language":"English"},{"code":"en-FI","langCode":"en","countryCode":"FI","country":"Finland","language":"English"},{"code":"en-FJ","langCode":"en","countryCode":"FJ","country":"Fiji","language":"English"},{"code":"en-FK","langCode":"en","countryCode":"FK","country":"Falkland Islands (Malvinas)","language":"English"},{"code":"en-FM","langCode":"en","countryCode":"FM","country":"Micronesia, Federated States of","language":"English"},{"code":"en-GB","langCode":"en","countryCode":"GB","country":"United Kingdom","language":"English"},{"code":"en-GD","langCode":"en","countryCode":"GD","country":"Grenada","language":"English"},{"code":"en-GG","langCode":"en","countryCode":"GG","country":"Guernsey","language":"English"},{"code":"en-GH","langCode":"en","countryCode":"GH","country":"Ghana","language":"English"},{"code":"en-GI","langCode":"en","countryCode":"GI","country":"Gibraltar","language":"English"},{"code":"en-GM","langCode":"en","countryCode":"GM","country":"Gambia","language":"English"},{"code":"en-GU","langCode":"en","countryCode":"GU","country":"Guam","language":"English"},{"code":"en-GY","langCode":"en","countryCode":"GY","country":"Guyana","language":"English"},{"code":"en-HK","langCode":"en","countryCode":"HK","country":"Hong Kong","language":"English"},{"code":"en-IE","langCode":"en","countryCode":"IE","country":"Ireland","language":"English"},{"code":"en-IL","langCode":"en","countryCode":"IL","country":"Israel","language":"English"},{"code":"en-IM","langCode":"en","countryCode":"IM","country":"Isle of Man","language":"English"},{"code":"en-IN","langCode":"en","countryCode":"IN","country":"India","language":"English"},{"code":"en-IO","langCode":"en","countryCode":"IO","country":"British Indian Ocean Territory","language":"English"},{"code":"en-JE","langCode":"en","countryCode":"JE","country":"Jersey","language":"English"},{"code":"en-JM","langCode":"en","countryCode":"JM","country":"Jamaica","language":"English"},{"code":"en-KE","langCode":"en","countryCode":"KE","country":"Kenya","language":"English"},{"code":"en-KI","langCode":"en","countryCode":"KI","country":"Kiribati","language":"English"},{"code":"en-KN","langCode":"en","countryCode":"KN","country":"Saint Kitts and Nevis","language":"English"},{"code":"en-KY","langCode":"en","countryCode":"KY","country":"Cayman Islands","language":"English"},{"code":"en-LC","langCode":"en","countryCode":"LC","country":"Saint Lucia","language":"English"},{"code":"en-LR","langCode":"en","countryCode":"LR","country":"Liberia","language":"English"},{"code":"en-LS","langCode":"en","countryCode":"LS","country":"Lesotho","language":"English"},{"code":"en-MG","langCode":"en","countryCode":"MG","country":"Madagascar","language":"English"},{"code":"en-MH","langCode":"en","countryCode":"MH","country":"Marshall Islands","language":"English"},{"code":"en-MO","langCode":"en","countryCode":"MO","country":"Macao","language":"English"},{"code":"en-MP","langCode":"en","countryCode":"MP","country":"Northern Mariana Islands","language":"English"},{"code":"en-MS","langCode":"en","countryCode":"MS","country":"Montserrat","language":"English"},{"code":"en-MT","langCode":"en","countryCode":"MT","country":"Malta","language":"English"},{"code":"en-MU","langCode":"en","countryCode":"MU","country":"Mauritius","language":"English"},{"code":"en-MW","langCode":"en","countryCode":"MW","country":"Malawi","language":"English"},{"code":"en-MY","langCode":"en","countryCode":"MY","country":"Malaysia","language":"English"},{"code":"en-NA","langCode":"en","countryCode":"NA","country":"Namibia","language":"English"},{"code":"en-NF","langCode":"en","countryCode":"NF","country":"Norfolk Island","language":"English"},{"code":"en-NG","langCode":"en","countryCode":"NG","country":"Nigeria","language":"English"},{"code":"en-NL","langCode":"en","countryCode":"NL","country":"Netherlands","language":"English"},{"code":"en-NR","langCode":"en","countryCode":"NR","country":"Nauru","language":"English"},{"code":"en-NU","langCode":"en","countryCode":"NU","country":"Niue","language":"English"},{"code":"en-NZ","langCode":"en","countryCode":"NZ","country":"New Zealand","language":"English"},{"code":"en-PG","langCode":"en","countryCode":"PG","country":"Papua New Guinea","language":"English"},{"code":"en-PH","langCode":"en","countryCode":"PH","country":"Philippines","language":"English"},{"code":"en-PK","langCode":"en","countryCode":"PK","country":"Pakistan","language":"English"},{"code":"en-PN","langCode":"en","countryCode":"PN","country":"Pitcairn","language":"English"},{"code":"en-PR","langCode":"en","countryCode":"PR","country":"Puerto Rico","language":"English"},{"code":"en-PW","langCode":"en","countryCode":"PW","country":"Palau","language":"English"},{"code":"en-RW","langCode":"en","countryCode":"RW","country":"Rwanda","language":"English"},{"code":"en-SB","langCode":"en","countryCode":"SB","country":"Solomon Islands","language":"English"},{"code":"en-SC","langCode":"en","countryCode":"SC","country":"Seychelles","language":"English"},{"code":"en-SD","langCode":"en","countryCode":"SD","country":"Sudan","language":"English"},{"code":"en-SE","langCode":"en","countryCode":"SE","country":"Sweden","language":"English"},{"code":"en-SG","langCode":"en","countryCode":"SG","country":"Singapore","language":"English"},{"code":"en-SH","langCode":"en","countryCode":"SH","country":"Saint Helena, Ascension and Tristan da Cunha","language":"English"},{"code":"en-SI","langCode":"en","countryCode":"SI","country":"Slovenia","language":"English"},{"code":"en-SL","langCode":"en","countryCode":"SL","country":"Sierra Leone","language":"English"},{"code":"en-SS","langCode":"en","countryCode":"SS","country":"South Sudan","language":"English"},{"code":"en-SX","langCode":"en","countryCode":"SX","country":"Sint Maarten (Dutch part)","language":"English"},{"code":"en-SZ","langCode":"en","countryCode":"SZ","country":"Swaziland","language":"English"},{"code":"en-TC","langCode":"en","countryCode":"TC","country":"Turks and Caicos Islands","language":"English"},{"code":"en-TK","langCode":"en","countryCode":"TK","country":"Tokelau","language":"English"},{"code":"en-TO","langCode":"en","countryCode":"TO","country":"Tonga","language":"English"},{"code":"en-TT","langCode":"en","countryCode":"TT","country":"Trinidad and Tobago","language":"English"},{"code":"en-TV","langCode":"en","countryCode":"TV","country":"Tuvalu","language":"English"},{"code":"en-TZ","langCode":"en","countryCode":"TZ","country":"Tanzania, United Republic of","language":"English"},{"code":"en-UG","langCode":"en","countryCode":"UG","country":"Uganda","language":"English"},{"code":"en-UM","langCode":"en","countryCode":"UM","country":"United States Minor Outlying Islands","language":"English"},{"code":"en-US","langCode":"en","countryCode":"US","country":"United States","language":"English"},{"code":"en-VC","langCode":"en","countryCode":"VC","country":"Saint Vincent and the Grenadines","language":"English"},{"code":"en-VG","langCode":"en","countryCode":"VG","country":"Virgin Islands, British","language":"English"},{"code":"en-VI","langCode":"en","countryCode":"VI","country":"Virgin Islands, U.S.","language":"English"},{"code":"en-VU","langCode":"en","countryCode":"VU","country":"Vanuatu","language":"English"},{"code":"en-WS","langCode":"en","countryCode":"WS","country":"Samoa","language":"English"},{"code":"en-ZA","langCode":"en","countryCode":"ZA","country":"South Africa","language":"English"},{"code":"en-ZM","langCode":"en","countryCode":"ZM","country":"Zambia","language":"English"},{"code":"en-ZW","langCode":"en","countryCode":"ZW","country":"Zimbabwe","language":"English"},{"code":"es-AR","langCode":"es","countryCode":"AR","country":"Argentina","language":"Spanish; Castilian"},{"code":"es-BO","langCode":"es","countryCode":"BO","country":"Bolivia, Plurinational State of","language":"Spanish; Castilian"},{"code":"es-BR","langCode":"es","countryCode":"BR","country":"Brazil","language":"Spanish; Castilian"},{"code":"es-BZ","langCode":"es","countryCode":"BZ","country":"Belize","language":"Spanish; Castilian"},{"code":"es-CL","langCode":"es","countryCode":"CL","country":"Chile","language":"Spanish; Castilian"},{"code":"es-CO","langCode":"es","countryCode":"CO","country":"Colombia","language":"Spanish; Castilian"},{"code":"es-CR","langCode":"es","countryCode":"CR","country":"Costa Rica","language":"Spanish; Castilian"},{"code":"es-CU","langCode":"es","countryCode":"CU","country":"Cuba","language":"Spanish; Castilian"},{"code":"es-DO","langCode":"es","countryCode":"DO","country":"Dominican Republic","language":"Spanish; Castilian"},{"code":"es-EC","langCode":"es","countryCode":"EC","country":"Ecuador","language":"Spanish; Castilian"},{"code":"es-ES","langCode":"es","countryCode":"ES","country":"Spain","language":"Spanish; Castilian"},{"code":"es-GQ","langCode":"es","countryCode":"GQ","country":"Equatorial Guinea","language":"Spanish; Castilian"},{"code":"es-GT","langCode":"es","countryCode":"GT","country":"Guatemala","language":"Spanish; Castilian"},{"code":"es-HN","langCode":"es","countryCode":"HN","country":"Honduras","language":"Spanish; Castilian"},{"code":"es-MX","langCode":"es","countryCode":"MX","country":"Mexico","language":"Spanish; Castilian"},{"code":"es-NI","langCode":"es","countryCode":"NI","country":"Nicaragua","language":"Spanish; Castilian"},{"code":"es-PA","langCode":"es","countryCode":"PA","country":"Panama","language":"Spanish; Castilian"},{"code":"es-PE","langCode":"es","countryCode":"PE","country":"Peru","language":"Spanish; Castilian"},{"code":"es-PH","langCode":"es","countryCode":"PH","country":"Philippines","language":"Spanish; Castilian"},{"code":"es-PR","langCode":"es","countryCode":"PR","country":"Puerto Rico","language":"Spanish; Castilian"},{"code":"es-PY","langCode":"es","countryCode":"PY","country":"Paraguay","language":"Spanish; Castilian"},{"code":"es-SV","langCode":"es","countryCode":"SV","country":"El Salvador","language":"Spanish; Castilian"},{"code":"es-US","langCode":"es","countryCode":"US","country":"United States","language":"Spanish; Castilian"},{"code":"es-UY","langCode":"es","countryCode":"UY","country":"Uruguay","language":"Spanish; Castilian"},{"code":"es-VE","langCode":"es","countryCode":"VE","country":"Venezuela, Bolivarian Republic of","language":"Spanish; Castilian"},{"code":"et-EE","langCode":"et","countryCode":"EE","country":"Estonia","language":"Estonian"},{"code":"eu-ES","langCode":"eu","countryCode":"ES","country":"Spain","language":"Basque"},{"code":"fa-AF","langCode":"fa","countryCode":"AF","country":"Afghanistan","language":"Persian"},{"code":"fa-IR","langCode":"fa","countryCode":"IR","country":"Iran, Islamic Republic of","language":"Persian"},{"code":"ff-Latn-BF","langCode":"ff","countryCode":"BF","country":"Burkina Faso","language":"Fulah"},{"code":"ff-Latn-CM","langCode":"ff","countryCode":"CM","country":"Cameroon","language":"Fulah"},{"code":"ff-Latn-GH","langCode":"ff","countryCode":"GH","country":"Ghana","language":"Fulah"},{"code":"ff-Latn-GM","langCode":"ff","countryCode":"GM","country":"Gambia","language":"Fulah"},{"code":"ff-Latn-GN","langCode":"ff","countryCode":"GN","country":"Guinea","language":"Fulah"},{"code":"ff-Latn-GW","langCode":"ff","countryCode":"GW","country":"Guinea-Bissau","language":"Fulah"},{"code":"ff-Latn-LR","langCode":"ff","countryCode":"LR","country":"Liberia","language":"Fulah"},{"code":"ff-Latn-MR","langCode":"ff","countryCode":"MR","country":"Mauritania","language":"Fulah"},{"code":"ff-Latn-NE","langCode":"ff","countryCode":"NE","country":"Niger","language":"Fulah"},{"code":"ff-Latn-NG","langCode":"ff","countryCode":"NG","country":"Nigeria","language":"Fulah"},{"code":"ff-Latn-SL","langCode":"ff","countryCode":"SL","country":"Sierra Leone","language":"Fulah"},{"code":"ff-Latn-SN","langCode":"ff","countryCode":"SN","country":"Senegal","language":"Fulah"},{"code":"fi-FI","langCode":"fi","countryCode":"FI","country":"Finland","language":"Finnish"},{"code":"fo-DK","langCode":"fo","countryCode":"DK","country":"Denmark","language":"Faroese"},{"code":"fo-FO","langCode":"fo","countryCode":"FO","country":"Faroe Islands","language":"Faroese"},{"code":"fr-BE","langCode":"fr","countryCode":"BE","country":"Belgium","language":"French"},{"code":"fr-BF","langCode":"fr","countryCode":"BF","country":"Burkina Faso","language":"French"},{"code":"fr-BI","langCode":"fr","countryCode":"BI","country":"Burundi","language":"French"},{"code":"fr-BJ","langCode":"fr","countryCode":"BJ","country":"Benin","language":"French"},{"code":"fr-BL","langCode":"fr","countryCode":"BL","country":"Saint Barth\xe9lemy","language":"French"},{"code":"fr-CA","langCode":"fr","countryCode":"CA","country":"Canada","language":"French"},{"code":"fr-CD","langCode":"fr","countryCode":"CD","country":"Congo, the Democratic Republic of the","language":"French"},{"code":"fr-CF","langCode":"fr","countryCode":"CF","country":"Central African Republic","language":"French"},{"code":"fr-CG","langCode":"fr","countryCode":"CG","country":"Congo","language":"French"},{"code":"fr-CH","langCode":"fr","countryCode":"CH","country":"Switzerland","language":"French"},{"code":"fr-CI","langCode":"fr","countryCode":"CI","country":"C\xf4te d\'Ivoire","language":"French"},{"code":"fr-CM","langCode":"fr","countryCode":"CM","country":"Cameroon","language":"French"},{"code":"fr-DJ","langCode":"fr","countryCode":"DJ","country":"Djibouti","language":"French"},{"code":"fr-DZ","langCode":"fr","countryCode":"DZ","country":"Algeria","language":"French"},{"code":"fr-FR","langCode":"fr","countryCode":"FR","country":"France","language":"French"},{"code":"fr-GA","langCode":"fr","countryCode":"GA","country":"Gabon","language":"French"},{"code":"fr-GF","langCode":"fr","countryCode":"GF","country":"French Guiana","language":"French"},{"code":"fr-GN","langCode":"fr","countryCode":"GN","country":"Guinea","language":"French"},{"code":"fr-GP","langCode":"fr","countryCode":"GP","country":"Guadeloupe","language":"French"},{"code":"fr-GQ","langCode":"fr","countryCode":"GQ","country":"Equatorial Guinea","language":"French"},{"code":"fr-HT","langCode":"fr","countryCode":"HT","country":"Haiti","language":"French"},{"code":"fr-KM","langCode":"fr","countryCode":"KM","country":"Comoros","language":"French"},{"code":"fr-LU","langCode":"fr","countryCode":"LU","country":"Luxembourg","language":"French"},{"code":"fr-MA","langCode":"fr","countryCode":"MA","country":"Morocco","language":"French"},{"code":"fr-MC","langCode":"fr","countryCode":"MC","country":"Monaco","language":"French"},{"code":"fr-MF","langCode":"fr","countryCode":"MF","country":"Saint Martin (French part)","language":"French"},{"code":"fr-MG","langCode":"fr","countryCode":"MG","country":"Madagascar","language":"French"},{"code":"fr-ML","langCode":"fr","countryCode":"ML","country":"Mali","language":"French"},{"code":"fr-MQ","langCode":"fr","countryCode":"MQ","country":"Martinique","language":"French"},{"code":"fr-MR","langCode":"fr","countryCode":"MR","country":"Mauritania","language":"French"},{"code":"fr-MU","langCode":"fr","countryCode":"MU","country":"Mauritius","language":"French"},{"code":"fr-NC","langCode":"fr","countryCode":"NC","country":"New Caledonia","language":"French"},{"code":"fr-NE","langCode":"fr","countryCode":"NE","country":"Niger","language":"French"},{"code":"fr-PF","langCode":"fr","countryCode":"PF","country":"French Polynesia","language":"French"},{"code":"fr-PM","langCode":"fr","countryCode":"PM","country":"Saint Pierre and Miquelon","language":"French"},{"code":"fr-RE","langCode":"fr","countryCode":"RE","country":"R\xe9union","language":"French"},{"code":"fr-RW","langCode":"fr","countryCode":"RW","country":"Rwanda","language":"French"},{"code":"fr-SC","langCode":"fr","countryCode":"SC","country":"Seychelles","language":"French"},{"code":"fr-SN","langCode":"fr","countryCode":"SN","country":"Senegal","language":"French"},{"code":"fr-SY","langCode":"fr","countryCode":"SY","country":"Syrian Arab Republic","language":"French"},{"code":"fr-TD","langCode":"fr","countryCode":"TD","country":"Chad","language":"French"},{"code":"fr-TG","langCode":"fr","countryCode":"TG","country":"Togo","language":"French"},{"code":"fr-TN","langCode":"fr","countryCode":"TN","country":"Tunisia","language":"French"},{"code":"fr-VU","langCode":"fr","countryCode":"VU","country":"Vanuatu","language":"French"},{"code":"fr-WF","langCode":"fr","countryCode":"WF","country":"Wallis and Futuna","language":"French"},{"code":"fr-YT","langCode":"fr","countryCode":"YT","country":"Mayotte","language":"French"},{"code":"fy-NL","langCode":"fy","countryCode":"NL","country":"Netherlands","language":"Western Frisian"},{"code":"ga-IE","langCode":"ga","countryCode":"IE","country":"Ireland","language":"Irish"},{"code":"gd-GB","langCode":"gd","countryCode":"GB","country":"United Kingdom","language":"Gaelic; Scottish Gaelic"},{"code":"gl-ES","langCode":"gl","countryCode":"ES","country":"Spain","language":"Galician"},{"code":"gu-IN","langCode":"gu","countryCode":"IN","country":"India","language":"Gujarati"},{"code":"gv-IM","langCode":"gv","countryCode":"IM","country":"Isle of Man","language":"Manx"},{"code":"ha-GH","langCode":"ha","countryCode":"GH","country":"Ghana","language":"Hausa"},{"code":"ha-NE","langCode":"ha","countryCode":"NE","country":"Niger","language":"Hausa"},{"code":"ha-NG","langCode":"ha","countryCode":"NG","country":"Nigeria","language":"Hausa"},{"code":"he-IL","langCode":"he","countryCode":"IL","country":"Israel","language":"Hebrew"},{"code":"hi-IN","langCode":"hi","countryCode":"IN","country":"India","language":"Hindi"},{"code":"hr-BA","langCode":"hr","countryCode":"BA","country":"Bosnia and Herzegovina","language":"Croatian"},{"code":"hr-HR","langCode":"hr","countryCode":"HR","country":"Croatia","language":"Croatian"},{"code":"hu-HU","langCode":"hu","countryCode":"HU","country":"Hungary","language":"Hungarian"},{"code":"hy-AM","langCode":"hy","countryCode":"AM","country":"Armenia","language":"Armenian"},{"code":"id-ID","langCode":"id","countryCode":"ID","country":"Indonesia","language":"Indonesian"},{"code":"ig-NG","langCode":"ig","countryCode":"NG","country":"Nigeria","language":"Igbo"},{"code":"ii-CN","langCode":"ii","countryCode":"CN","country":"China","language":"Sichuan Yi; Nuosu"},{"code":"is-IS","langCode":"is","countryCode":"IS","country":"Iceland","language":"Icelandic"},{"code":"it-CH","langCode":"it","countryCode":"CH","country":"Switzerland","language":"Italian"},{"code":"it-IT","langCode":"it","countryCode":"IT","country":"Italy","language":"Italian"},{"code":"it-SM","langCode":"it","countryCode":"SM","country":"San Marino","language":"Italian"},{"code":"it-VA","langCode":"it","countryCode":"VA","country":"Holy See (Vatican City State)","language":"Italian"},{"code":"ja-JP","langCode":"ja","countryCode":"JP","country":"Japan","language":"Japanese"},{"code":"jv-ID","langCode":"jv","countryCode":"ID","country":"Indonesia","language":"Javanese"},{"code":"ka-GE","langCode":"ka","countryCode":"GE","country":"Georgia","language":"Georgian"},{"code":"ki-KE","langCode":"ki","countryCode":"KE","country":"Kenya","language":"Kikuyu; Gikuyu"},{"code":"kk-KZ","langCode":"kk","countryCode":"KZ","country":"Kazakhstan","language":"Kazakh"},{"code":"kl-GL","langCode":"kl","countryCode":"GL","country":"Greenland","language":"Kalaallisut; Greenlandic"},{"code":"km-KH","langCode":"km","countryCode":"KH","country":"Cambodia","language":"Central Khmer"},{"code":"kn-IN","langCode":"kn","countryCode":"IN","country":"India","language":"Kannada"},{"code":"ko-KP","langCode":"ko","countryCode":"KP","country":"Korea, Democratic People\'s Republic of","language":"Korean"},{"code":"ko-KR","langCode":"ko","countryCode":"KR","country":"Korea, Republic of","language":"Korean"},{"code":"ks-IN","langCode":"ks","countryCode":"IN","country":"India","language":"Kashmiri"},{"code":"ku-TR","langCode":"ku","countryCode":"TR","country":"Turkey","language":"Kurdish"},{"code":"kw-GB","langCode":"kw","countryCode":"GB","country":"United Kingdom","language":"Cornish"},{"code":"ky-KG","langCode":"ky","countryCode":"KG","country":"Kyrgyzstan","language":"Kirghiz; Kyrgyz"},{"code":"lb-LU","langCode":"lb","countryCode":"LU","country":"Luxembourg","language":"Luxembourgish; Letzeburgesch"},{"code":"lg-UG","langCode":"lg","countryCode":"UG","country":"Uganda","language":"Ganda"},{"code":"ln-AO","langCode":"ln","countryCode":"AO","country":"Angola","language":"Lingala"},{"code":"ln-CD","langCode":"ln","countryCode":"CD","country":"Congo, the Democratic Republic of the","language":"Lingala"},{"code":"ln-CF","langCode":"ln","countryCode":"CF","country":"Central African Republic","language":"Lingala"},{"code":"ln-CG","langCode":"ln","countryCode":"CG","country":"Congo","language":"Lingala"},{"code":"lo-LA","langCode":"lo","countryCode":"LA","country":"Lao People\'s Democratic Republic","language":"Lao"},{"code":"lt-LT","langCode":"lt","countryCode":"LT","country":"Lithuania","language":"Lithuanian"},{"code":"lu-CD","langCode":"lu","countryCode":"CD","country":"Congo, the Democratic Republic of the","language":"Luba-Katanga"},{"code":"lv-LV","langCode":"lv","countryCode":"LV","country":"Latvia","language":"Latvian"},{"code":"mg-MG","langCode":"mg","countryCode":"MG","country":"Madagascar","language":"Malagasy"},{"code":"mi-NZ","langCode":"mi","countryCode":"NZ","country":"New Zealand","language":"Maori"},{"code":"mk-MK","langCode":"mk","countryCode":"MK","country":"Macedonia, the Former Yugoslav Republic of","language":"Macedonian"},{"code":"ml-IN","langCode":"ml","countryCode":"IN","country":"India","language":"Malayalam"},{"code":"mn-MN","langCode":"mn","countryCode":"MN","country":"Mongolia","language":"Mongolian"},{"code":"mr-IN","langCode":"mr","countryCode":"IN","country":"India","language":"Marathi"},{"code":"ms-BN","langCode":"ms","countryCode":"BN","country":"Brunei Darussalam","language":"Malay"},{"code":"ms-MY","langCode":"ms","countryCode":"MY","country":"Malaysia","language":"Malay"},{"code":"ms-SG","langCode":"ms","countryCode":"SG","country":"Singapore","language":"Malay"},{"code":"mt-MT","langCode":"mt","countryCode":"MT","country":"Malta","language":"Maltese"},{"code":"my-MM","langCode":"my","countryCode":"MM","country":"Myanmar","language":"Burmese"},{"code":"nb-NO","langCode":"nb","countryCode":"NO","country":"Norway","language":"Bokm\xe5l, Norwegian; Norwegian Bokm\xe5l"},{"code":"nb-SJ","langCode":"nb","countryCode":"SJ","country":"Svalbard and Jan Mayen","language":"Bokm\xe5l, Norwegian; Norwegian Bokm\xe5l"},{"code":"nd-ZW","langCode":"nd","countryCode":"ZW","country":"Zimbabwe","language":"Ndebele, North; North Ndebele"},{"code":"ne-IN","langCode":"ne","countryCode":"IN","country":"India","language":"Nepali"},{"code":"ne-NP","langCode":"ne","countryCode":"NP","country":"Nepal","language":"Nepali"},{"code":"nl-AW","langCode":"nl","countryCode":"AW","country":"Aruba","language":"Dutch; Flemish"},{"code":"nl-BE","langCode":"nl","countryCode":"BE","country":"Belgium","language":"Dutch; Flemish"},{"code":"nl-BQ","langCode":"nl","countryCode":"BQ","country":"Bonaire, Sint Eustatius and Saba","language":"Dutch; Flemish"},{"code":"nl-CW","langCode":"nl","countryCode":"CW","country":"Cura\xe7ao","language":"Dutch; Flemish"},{"code":"nl-NL","langCode":"nl","countryCode":"NL","country":"Netherlands","language":"Dutch; Flemish"},{"code":"nl-SR","langCode":"nl","countryCode":"SR","country":"Suriname","language":"Dutch; Flemish"},{"code":"nl-SX","langCode":"nl","countryCode":"SX","country":"Sint Maarten (Dutch part)","language":"Dutch; Flemish"},{"code":"nn-NO","langCode":"nn","countryCode":"NO","country":"Norway","language":"Norwegian Nynorsk; Nynorsk, Norwegian"},{"code":"om-ET","langCode":"om","countryCode":"ET","country":"Ethiopia","language":"Oromo"},{"code":"om-KE","langCode":"om","countryCode":"KE","country":"Kenya","language":"Oromo"},{"code":"or-IN","langCode":"or","countryCode":"IN","country":"India","language":"Oriya"},{"code":"os-GE","langCode":"os","countryCode":"GE","country":"Georgia","language":"Ossetian; Ossetic"},{"code":"os-RU","langCode":"os","countryCode":"RU","country":"Russian Federation","language":"Ossetian; Ossetic"},{"code":"pa-Arab-PK","langCode":"pa","countryCode":"PK","country":"Pakistan","language":"Panjabi; Punjabi"},{"code":"pa-Guru-IN","langCode":"pa","countryCode":"IN","country":"India","language":"Panjabi; Punjabi"},{"code":"pl-PL","langCode":"pl","countryCode":"PL","country":"Poland","language":"Polish"},{"code":"ps-AF","langCode":"ps","countryCode":"AF","country":"Afghanistan","language":"Pushto; Pashto"},{"code":"pt-AO","langCode":"pt","countryCode":"AO","country":"Angola","language":"Portuguese"},{"code":"pt-BR","langCode":"pt","countryCode":"BR","country":"Brazil","language":"Portuguese"},{"code":"pt-CH","langCode":"pt","countryCode":"CH","country":"Switzerland","language":"Portuguese"},{"code":"pt-CV","langCode":"pt","countryCode":"CV","country":"Cape Verde","language":"Portuguese"},{"code":"pt-GQ","langCode":"pt","countryCode":"GQ","country":"Equatorial Guinea","language":"Portuguese"},{"code":"pt-GW","langCode":"pt","countryCode":"GW","country":"Guinea-Bissau","language":"Portuguese"},{"code":"pt-LU","langCode":"pt","countryCode":"LU","country":"Luxembourg","language":"Portuguese"},{"code":"pt-MO","langCode":"pt","countryCode":"MO","country":"Macao","language":"Portuguese"},{"code":"pt-MZ","langCode":"pt","countryCode":"MZ","country":"Mozambique","language":"Portuguese"},{"code":"pt-PT","langCode":"pt","countryCode":"PT","country":"Portugal","language":"Portuguese"},{"code":"pt-ST","langCode":"pt","countryCode":"ST","country":"Sao Tome and Principe","language":"Portuguese"},{"code":"pt-TL","langCode":"pt","countryCode":"TL","country":"Timor-Leste","language":"Portuguese"},{"code":"qu-BO","langCode":"qu","countryCode":"BO","country":"Bolivia, Plurinational State of","language":"Quechua"},{"code":"qu-EC","langCode":"qu","countryCode":"EC","country":"Ecuador","language":"Quechua"},{"code":"qu-PE","langCode":"qu","countryCode":"PE","country":"Peru","language":"Quechua"},{"code":"rm-CH","langCode":"rm","countryCode":"CH","country":"Switzerland","language":"Romansh"},{"code":"rn-BI","langCode":"rn","countryCode":"BI","country":"Burundi","language":"Rundi"},{"code":"ro-MD","langCode":"ro","countryCode":"MD","country":"Moldova, Republic of","language":"Romanian; Moldavian; Moldovan"},{"code":"ro-RO","langCode":"ro","countryCode":"RO","country":"Romania","language":"Romanian; Moldavian; Moldovan"},{"code":"ru-BY","langCode":"ru","countryCode":"BY","country":"Belarus","language":"Russian"},{"code":"ru-KG","langCode":"ru","countryCode":"KG","country":"Kyrgyzstan","language":"Russian"},{"code":"ru-KZ","langCode":"ru","countryCode":"KZ","country":"Kazakhstan","language":"Russian"},{"code":"ru-MD","langCode":"ru","countryCode":"MD","country":"Moldova, Republic of","language":"Russian"},{"code":"ru-RU","langCode":"ru","countryCode":"RU","country":"Russian Federation","language":"Russian"},{"code":"ru-UA","langCode":"ru","countryCode":"UA","country":"Ukraine","language":"Russian"},{"code":"rw-RW","langCode":"rw","countryCode":"RW","country":"Rwanda","language":"Kinyarwanda"},{"code":"sd-PK","langCode":"sd","countryCode":"PK","country":"Pakistan","language":"Sindhi"},{"code":"se-FI","langCode":"se","countryCode":"FI","country":"Finland","language":"Northern Sami"},{"code":"se-NO","langCode":"se","countryCode":"NO","country":"Norway","language":"Northern Sami"},{"code":"se-SE","langCode":"se","countryCode":"SE","country":"Sweden","language":"Northern Sami"},{"code":"sg-CF","langCode":"sg","countryCode":"CF","country":"Central African Republic","language":"Sango"},{"code":"si-LK","langCode":"si","countryCode":"LK","country":"Sri Lanka","language":"Sinhala; Sinhalese"},{"code":"sk-SK","langCode":"sk","countryCode":"SK","country":"Slovakia","language":"Slovak"},{"code":"sl-SI","langCode":"sl","countryCode":"SI","country":"Slovenia","language":"Slovenian"},{"code":"sn-ZW","langCode":"sn","countryCode":"ZW","country":"Zimbabwe","language":"Shona"},{"code":"so-DJ","langCode":"so","countryCode":"DJ","country":"Djibouti","language":"Somali"},{"code":"so-ET","langCode":"so","countryCode":"ET","country":"Ethiopia","language":"Somali"},{"code":"so-KE","langCode":"so","countryCode":"KE","country":"Kenya","language":"Somali"},{"code":"so-SO","langCode":"so","countryCode":"SO","country":"Somalia","language":"Somali"},{"code":"sq-AL","langCode":"sq","countryCode":"AL","country":"Albania","language":"Albanian"},{"code":"sq-MK","langCode":"sq","countryCode":"MK","country":"Macedonia, the Former Yugoslav Republic of","language":"Albanian"},{"code":"sr-Cyrl-BA","langCode":"sr","countryCode":"BA","country":"Bosnia and Herzegovina","language":"Serbian"},{"code":"sr-Cyrl-ME","langCode":"sr","countryCode":"ME","country":"Montenegro","language":"Serbian"},{"code":"sr-Cyrl-RS","langCode":"sr","countryCode":"RS","country":"Serbia","language":"Serbian"},{"code":"sr-Latn-BA","langCode":"sr","countryCode":"BA","country":"Bosnia and Herzegovina","language":"Serbian"},{"code":"sr-Latn-ME","langCode":"sr","countryCode":"ME","country":"Montenegro","language":"Serbian"},{"code":"sr-Latn-RS","langCode":"sr","countryCode":"RS","country":"Serbia","language":"Serbian"},{"code":"sv-AX","langCode":"sv","countryCode":"AX","country":"\xc5land Islands","language":"Swedish"},{"code":"sv-FI","langCode":"sv","countryCode":"FI","country":"Finland","language":"Swedish"},{"code":"sv-SE","langCode":"sv","countryCode":"SE","country":"Sweden","language":"Swedish"},{"code":"sw-CD","langCode":"sw","countryCode":"CD","country":"Congo, the Democratic Republic of the","language":"Swahili"},{"code":"sw-KE","langCode":"sw","countryCode":"KE","country":"Kenya","language":"Swahili"},{"code":"sw-TZ","langCode":"sw","countryCode":"TZ","country":"Tanzania, United Republic of","language":"Swahili"},{"code":"sw-UG","langCode":"sw","countryCode":"UG","country":"Uganda","language":"Swahili"},{"code":"ta-IN","langCode":"ta","countryCode":"IN","country":"India","language":"Tamil"},{"code":"ta-LK","langCode":"ta","countryCode":"LK","country":"Sri Lanka","language":"Tamil"},{"code":"ta-MY","langCode":"ta","countryCode":"MY","country":"Malaysia","language":"Tamil"},{"code":"ta-SG","langCode":"ta","countryCode":"SG","country":"Singapore","language":"Tamil"},{"code":"te-IN","langCode":"te","countryCode":"IN","country":"India","language":"Telugu"},{"code":"tg-TJ","langCode":"tg","countryCode":"TJ","country":"Tajikistan","language":"Tajik"},{"code":"th-TH","langCode":"th","countryCode":"TH","country":"Thailand","language":"Thai"},{"code":"ti-ER","langCode":"ti","countryCode":"ER","country":"Eritrea","language":"Tigrinya"},{"code":"ti-ET","langCode":"ti","countryCode":"ET","country":"Ethiopia","language":"Tigrinya"},{"code":"tk-TM","langCode":"tk","countryCode":"TM","country":"Turkmenistan","language":"Turkmen"},{"code":"to-TO","langCode":"to","countryCode":"TO","country":"Tonga","language":"Tonga (Tonga Islands)"},{"code":"tr-CY","langCode":"tr","countryCode":"CY","country":"Cyprus","language":"Turkish"},{"code":"tr-TR","langCode":"tr","countryCode":"TR","country":"Turkey","language":"Turkish"},{"code":"tt-RU","langCode":"tt","countryCode":"RU","country":"Russian Federation","language":"Tatar"},{"code":"ug-CN","langCode":"ug","countryCode":"CN","country":"China","language":"Uighur; Uyghur"},{"code":"uk-UA","langCode":"uk","countryCode":"UA","country":"Ukraine","language":"Ukrainian"},{"code":"ur-IN","langCode":"ur","countryCode":"IN","country":"India","language":"Urdu"},{"code":"ur-PK","langCode":"ur","countryCode":"PK","country":"Pakistan","language":"Urdu"},{"code":"uz-Arab-AF","langCode":"uz","countryCode":"AF","country":"Afghanistan","language":"Uzbek"},{"code":"uz-Cyrl-UZ","langCode":"uz","countryCode":"UZ","country":"Uzbekistan","language":"Uzbek"},{"code":"uz-Latn-UZ","langCode":"uz","countryCode":"UZ","country":"Uzbekistan","language":"Uzbek"},{"code":"vi-VN","langCode":"vi","countryCode":"VN","country":"Viet Nam","language":"Vietnamese"},{"code":"wo-SN","langCode":"wo","countryCode":"SN","country":"Senegal","language":"Wolof"},{"code":"xh-ZA","langCode":"xh","countryCode":"ZA","country":"South Africa","language":"Xhosa"},{"code":"yo-BJ","langCode":"yo","countryCode":"BJ","country":"Benin","language":"Yoruba"},{"code":"yo-NG","langCode":"yo","countryCode":"NG","country":"Nigeria","language":"Yoruba"},{"code":"zh-Hans-CN","langCode":"zh","countryCode":"CN","country":"China","language":"Chinese"},{"code":"zh-Hans-HK","langCode":"zh","countryCode":"HK","country":"Hong Kong","language":"Chinese"},{"code":"zh-Hans-MO","langCode":"zh","countryCode":"MO","country":"Macao","language":"Chinese"},{"code":"zh-Hans-SG","langCode":"zh","countryCode":"SG","country":"Singapore","language":"Chinese"},{"code":"zh-Hant-HK","langCode":"zh","countryCode":"HK","country":"Hong Kong","language":"Chinese"},{"code":"zh-Hant-MO","langCode":"zh","countryCode":"MO","country":"Macao","language":"Chinese"},{"code":"zh-Hant-TW","langCode":"zh","countryCode":"TW","country":"Taiwan, Province of China","language":"Chinese"},{"code":"zu-ZA","langCode":"zu","countryCode":"ZA","country":"South Africa","language":"Zulu"}]');

});


parcelRegister("1BTI2", function(module, exports) {

$parcel$export(module.exports, "settingDefaults", function () { return $12c475d52ba2dd6b$export$6e121e085e95ad99; });
$parcel$export(module.exports, "default", function () { return $12c475d52ba2dd6b$export$2e2bcd8739ae039; });

var $4hBm1 = parcelRequire("4hBm1");

var $7Fn0s = parcelRequire("7Fn0s");
parcelRequire("eat5C");

var $4JcCM = parcelRequire("4JcCM");
parcelRequire("dtopU");
parcelRequire("eBwNQ");

var $3PAB5 = parcelRequire("3PAB5");

var $htkeB = parcelRequire("htkeB");

var $i0HPj = parcelRequire("i0HPj");

var $8kZ1o = parcelRequire("8kZ1o");

var $iKbxs = parcelRequire("iKbxs");

var $3H03w = parcelRequire("3H03w");

var $8aL9y = parcelRequire("8aL9y");

var $4sWia = parcelRequire("4sWia");

var $iOQGT = parcelRequire("iOQGT");

var $6Q5sp = parcelRequire("6Q5sp");
var $12c475d52ba2dd6b$var$_dec, $12c475d52ba2dd6b$var$_dec2, $12c475d52ba2dd6b$var$_dec3, $12c475d52ba2dd6b$var$_dec4, $12c475d52ba2dd6b$var$_dec5, $12c475d52ba2dd6b$var$_dec6, $12c475d52ba2dd6b$var$_dec7, $12c475d52ba2dd6b$var$_dec8, $12c475d52ba2dd6b$var$_dec9, $12c475d52ba2dd6b$var$_dec10, $12c475d52ba2dd6b$var$_dec11, $12c475d52ba2dd6b$var$_dec12, $12c475d52ba2dd6b$var$_dec13, $12c475d52ba2dd6b$var$_dec14, $12c475d52ba2dd6b$var$_class, $12c475d52ba2dd6b$var$_descriptor, $12c475d52ba2dd6b$var$_descriptor2, $12c475d52ba2dd6b$var$_descriptor3, $12c475d52ba2dd6b$var$_descriptor4, $12c475d52ba2dd6b$var$_descriptor5, $12c475d52ba2dd6b$var$_descriptor6, $12c475d52ba2dd6b$var$_descriptor7, $12c475d52ba2dd6b$var$_descriptor8, $12c475d52ba2dd6b$var$_descriptor9, $12c475d52ba2dd6b$var$_descriptor10, $12c475d52ba2dd6b$var$_descriptor11, $12c475d52ba2dd6b$var$_descriptor12, $12c475d52ba2dd6b$var$_descriptor13, $12c475d52ba2dd6b$var$_descriptor14, $12c475d52ba2dd6b$var$_descriptor15, $12c475d52ba2dd6b$var$_descriptor16;
function $12c475d52ba2dd6b$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $12c475d52ba2dd6b$var$_defineProperty(e, r, t) {
    return (r = $12c475d52ba2dd6b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $12c475d52ba2dd6b$var$_toPropertyKey(t) {
    var i = $12c475d52ba2dd6b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $12c475d52ba2dd6b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $12c475d52ba2dd6b$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $12c475d52ba2dd6b$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}

let $12c475d52ba2dd6b$var$SessionStore = ($12c475d52ba2dd6b$var$_dec = (0, $4JcCM.action).bound, $12c475d52ba2dd6b$var$_dec2 = (0, $4JcCM.action).bound, $12c475d52ba2dd6b$var$_dec3 = (0, $4JcCM.action).bound, $12c475d52ba2dd6b$var$_dec4 = (0, $4JcCM.action).bound, $12c475d52ba2dd6b$var$_dec5 = (0, $4JcCM.action).bound, $12c475d52ba2dd6b$var$_dec6 = (0, $4JcCM.action).bound, $12c475d52ba2dd6b$var$_dec7 = (0, $4JcCM.action).bound, $12c475d52ba2dd6b$var$_dec8 = (0, $4JcCM.action).bound, $12c475d52ba2dd6b$var$_dec9 = (0, $4JcCM.action).bound, $12c475d52ba2dd6b$var$_dec10 = (0, $4JcCM.action).bound, $12c475d52ba2dd6b$var$_dec11 = (0, $4JcCM.action).bound, $12c475d52ba2dd6b$var$_dec12 = (0, $4JcCM.action).bound, $12c475d52ba2dd6b$var$_dec13 = (0, $4JcCM.action).bound, $12c475d52ba2dd6b$var$_dec14 = (0, $4JcCM.action).bound, $12c475d52ba2dd6b$var$_class = class SessionStore {
    setMigratedToV2(migrated) {
        this.migratedToV2 = migrated;
    }
    constructor(props){
        $12c475d52ba2dd6b$var$_initializerDefineProperty(this, "profilePictureUrl", $12c475d52ba2dd6b$var$_descriptor, this);
        $12c475d52ba2dd6b$var$_initializerDefineProperty(this, "emailVerified", $12c475d52ba2dd6b$var$_descriptor2, this);
        // @observable expires = null
        $12c475d52ba2dd6b$var$_initializerDefineProperty(this, "userId", $12c475d52ba2dd6b$var$_descriptor3, this);
        $12c475d52ba2dd6b$var$_initializerDefineProperty(this, "userPermissions", $12c475d52ba2dd6b$var$_descriptor4, this);
        $12c475d52ba2dd6b$var$_initializerDefineProperty(this, "userEmail", $12c475d52ba2dd6b$var$_descriptor5, this);
        $12c475d52ba2dd6b$var$_initializerDefineProperty(this, "userFirstName", $12c475d52ba2dd6b$var$_descriptor6, this);
        $12c475d52ba2dd6b$var$_initializerDefineProperty(this, "userLastName", $12c475d52ba2dd6b$var$_descriptor7, this);
        $12c475d52ba2dd6b$var$_initializerDefineProperty(this, "userCreatedAt", $12c475d52ba2dd6b$var$_descriptor8, this);
        $12c475d52ba2dd6b$var$_initializerDefineProperty(this, "organisationId", $12c475d52ba2dd6b$var$_descriptor9, this);
        $12c475d52ba2dd6b$var$_initializerDefineProperty(this, "organisationName", $12c475d52ba2dd6b$var$_descriptor10, this);
        $12c475d52ba2dd6b$var$_initializerDefineProperty(this, "organisationCountry", $12c475d52ba2dd6b$var$_descriptor11, this);
        $12c475d52ba2dd6b$var$_initializerDefineProperty(this, "state", $12c475d52ba2dd6b$var$_descriptor12, this);
        //authenticated, checkingAuth, loggingIn
        $12c475d52ba2dd6b$var$_initializerDefineProperty(this, "accounting", $12c475d52ba2dd6b$var$_descriptor13, this);
        $12c475d52ba2dd6b$var$_initializerDefineProperty(this, "initialized", $12c475d52ba2dd6b$var$_descriptor14, this);
        $12c475d52ba2dd6b$var$_initializerDefineProperty(this, "updateAvailable", $12c475d52ba2dd6b$var$_descriptor15, this);
        $12c475d52ba2dd6b$var$_initializerDefineProperty(this, "migratedToV2", $12c475d52ba2dd6b$var$_descriptor16, this);
        (0, $4JcCM.makeObservable)(this);
        this.initialize();
    }
    async initialize() {
        await this.checkAuthentication();
        this.initialized = true;
    }
    get authenticated() {
        return this.state === "authenticated" && // this.expires && //TODO: handle with workos
        this.userId //&&
        ;
    }
    async login({ email: email, password: password, token: token } = {}) {
        this.state = "loggingIn";
        try {
            if (email) {
                const response = await (0, $iOQGT.makeRequest)({
                    path: "https://api.coincraft.co/api/v1.5/user/login",
                    method: "post",
                    data: {
                        email: email,
                        password: password
                    }
                });
                return await this.saveLoginResponse(response);
            } else return await this.saveLoginResponse({
                data: token
            });
        } catch (error) {
            $iKbxs.captureException(error);
            (0, $3H03w.default).captureException(error);
            console.error(error);
            this.state = "unauthenticated";
            throw error;
        }
    }
    async signup({} = {}) {
        this.state = "loggingIn";
        try {
            const response = await (0, $iOQGT.makeRequest)({
                path: "/auth/sign-up",
                method: "POST",
                baseURL: "https://server2.coincraft.co",
                data: {},
                maxRetries: 1 //only one retry is enough
            });
            return await this.saveLoginResponse(response);
        } catch (error) {
            $iKbxs.captureException(error);
            (0, $3H03w.default).captureException(error);
            console.error(error);
            this.state = "unauthenticated";
            throw error;
        }
    }
    async saveLoginResponse(response) {
        //TODO for ryan: you can use WorkOs attributes to implement more logic later
        const { data: data } = response;
        //WorkOs attributes:
        this.emailVerified = data.emailVerified;
        this.profilePictureUrl = data.profilePictureUrl;
        // DB attributes
        this.userId = response.data.userId;
        this.userPermissions = response.data.userPermissions;
        this.userEmail = response.data.userEmail;
        this.userFirstName = response.data.userFirstName;
        this.userLastName = response.data.userLastName;
        this.userCreatedAt = response.data.userCreatedAt;
        this.organisationId = response.data.organisationId;
        this.organisationName = response.data.organisationName;
        this.organisationCountry = response.data.organisationCountry;
        // this.expires = add(new Date(), {
        //     days: 13,
        //     hours: 23,
        //     minutes: 50,
        // })
        await this.saveSession();
        this.createModels();
        return response;
    }
    async impersonate(email) {
        this.state = "loggingIn";
        const self = this;
        if (!(0, $8kZ1o.hasImpersonationPermission)(this.user)) throw new Error("You do not have permission to impersonate");
        return (0, $iOQGT.makeRequest)({
            path: "https://api.coincraft.co/api/v1.5/user/impersonate",
            method: "post",
            data: {
                email: email
            }
        }).then(async (response)=>{
            await this.clearCache();
            await this.saveLoginResponse(response);
        }).catch(function(error) {
            $iKbxs.captureException(error);
            (0, $3H03w.default).captureException(error);
            console.error(error);
            self.state = "unauthenticated";
            throw error;
        });
    }
    register(email, password) {
        this.state = "loggingIn";
        const self = this;
        return (0, $iOQGT.makeRequest)({
            path: "https://api.coincraft.co/api/v1.5/user/register",
            method: "post",
            data: {
                email: email,
                password: password
            }
        }).then(this.saveLoginResponse).catch(function(error) {
            $iKbxs.captureException(error);
            (0, $3H03w.default).captureException(error);
            console.error(error);
            self.state = "unauthenticated";
            throw error;
        });
    }
    async logout() {
        if ((0, $8kZ1o.usingNewLogin)()) try {
            const { data: data } = await (0, $iOQGT.makeRequest)({
                baseURL: "https://server2.coincraft.co",
                path: "/auth/logout",
                method: "DELETE",
                maxRetries: 1
            });
            if (!data.redirectTo) console.error("Failed to logout");
            await (0, $6Q5sp.router).navigate({
                to: "/login"
            });
            await this.clearCache();
            window.location.href = data.redirectTo;
        } catch (error) {
            console.error("Logout failed:", error);
            await (0, $6Q5sp.router).navigate({
                to: "/login"
            });
            await this.clearCache();
        }
        else {
            await (0, $6Q5sp.router).navigate({
                to: "/login"
            });
            await this.clearCache();
        }
    }
    async saveSession(callback) {
        const session = {
            emailVerified: this.emailVerified,
            profilePictureUrl: this.profilePictureUrl,
            userId: this.userId,
            userPermissions: (0, $4JcCM.toJS)(this.userPermissions),
            userEmail: this.userEmail,
            userFirstName: this.userFirstName,
            userLastName: this.userLastName,
            userCreatedAt: this.userCreatedAt,
            organisationId: this.organisationId,
            organisationName: this.organisationName,
            organisationCountry: this.organisationCountry,
            // expires: this.expires && formatISO(this.expires),
            accounting: {
                expires: this.accounting.expires && (0, $4hBm1.formatISO)(this.accounting.expires),
                system: this.accounting.system
            }
        };
        await (0, (/*@__PURE__*/$parcel$interopDefault($7Fn0s))).setItem("session", session).then(()=>{
            this.state = "authenticated";
            callback && callback(session);
            return session;
        });
    }
    async clearCache() {
        const { collections: collections, aggregateCollections: aggregateCollections } = (parcelRequire("7Vift"));
        await this.deleteSession();
        this.state = "unauthenticated";
        this.userId = null;
        this.userPermissions = null;
        this.userEmail = null;
        this.userFirstName = null;
        this.userLastName = null;
        this.userCreatedAt = null;
        this.organisationId = null;
        this.organisationName = null;
        this.organisationCountry = null;
        this.accounting = {};
        collections.forEach((collection)=>{
            collection.clear();
        });
        aggregateCollections.forEach((aggregate)=>{
            aggregate.clear();
        });
    }
    async deleteSession() {
        await (0, (/*@__PURE__*/$parcel$interopDefault($7Fn0s))).removeItem("session");
    }
    async checkAuthentication(callback) {
        this.state = "checkingAuth";
        const session = await (0, (/*@__PURE__*/$parcel$interopDefault($7Fn0s))).getItem("session");
        if (!session) this.state = "unauthenticated";
        else {
            this.state = "authenticated";
            this.emailVerified = session.emailVerified;
            this.profilePictureUrl = session.profilePictureUrl;
            this.userId = session.userId;
            this.emailVerified = session.emailVerified;
            this.userPermissions = session.userPermissions;
            this.userEmail = session.userEmail;
            this.userFirstName = session.userFirstName;
            this.userLastName = session.userLastName;
            this.userCreatedAt = session.userCreatedAt;
            this.organisationId = session.organisationId;
            this.organisationName = session.organisationName;
            this.organisationCountry = session.organisationCountry || "au";
            // this.expires = session.expires && parseISO(session.expires)
            this.accounting.expires = session.accounting.expires && (0, $4hBm1.parseISO)(session.accounting.expires);
            this.accounting.system = session.accounting.system;
            this.resetAccountingTimeout();
            this.createModels();
        }
        callback && callback();
    }
    createModels() {
        const user = this.createUserModel();
        const org = this.createOrganisationModel();
        // if (process.env.REACT_APP_ENV === 'production') {
        $iKbxs.setUser({
            email: user.email
        });
        $iKbxs.setTag("name", user.fullName);
        $iKbxs.setTag("organisation", this.organisationName);
        (0, $3H03w.default).identify(user.email, // Replace 'distinct_id' with your user's unique identifier
        {
            email: user.email,
            name: user.fullName,
            organisation: this.organisationName
        } // optional: set additional user properties
        );
        (0, $3H03w.default).group("organisation", this.organisationId, {
            name: this.organisationName
        });
        // }
        window.Intercom("boot", {
            app_id: "k6prha3t",
            user_id: user.id,
            email: user.email,
            name: user.fullName,
            company: {
                name: this.organisationName,
                id: this.organisationId
            },
            created_at: this.userCreatedAt
        });
    }
    createUserModel() {
        const user = (0, $htkeB.default).add({
            id: this.userId,
            permissions: this.userPermissions,
            email: this.userEmail,
            firstName: this.userFirstName,
            lastName: this.userLastName
        }, {
            trackUpdates: false
        });
        return user;
    }
    createOrganisationModel() {
        const organisation = (0, $3PAB5.default).add({
            id: this.organisationId,
            name: this.organisationName,
            country: this.organisationCountry
        }, {
            trackUpdates: false
        });
        return organisation;
    }
    async resetAccountingTimeout() {
        if (this.accounting.expires > new Date()) setTimeout(()=>{
            this.accounting.expires = null;
        }, this.accounting.expires - new Date());
    }
    async saveAccountingExpires(expires) {
        var _this$organisation;
        this.accounting.expires = expires;
        this.accounting.system = (_this$organisation = this.organisation) === null || _this$organisation === void 0 ? void 0 : _this$organisation.accountingSystem;
        await this.saveSession();
        this.resetAccountingTimeout();
    }
    get accountingConnected() {
        var _this$organisation2;
        return this.accounting.system === ((_this$organisation2 = this.organisation) === null || _this$organisation2 === void 0 ? void 0 : _this$organisation2.accountingSystem) && this.accounting.expires && this.accounting.expires > new Date();
    }
    get user() {
        return (0, $htkeB.default).staffsById[this.userId];
    }
    get organisation() {
        return [
            ...(0, $3PAB5.default).organisations
        ][0];
    }
    get subscription() {
        return [
            ...(0, $i0HPj.default).models
        ][0];
    }
    get settings() {
        var _this$organisation3;
        return {
            ...$12c475d52ba2dd6b$export$6e121e085e95ad99,
            ...((_this$organisation3 = this.organisation) === null || _this$organisation3 === void 0 ? void 0 : _this$organisation3.settings) || {}
        };
    }
    async checkIfUpdateIsAvailable() {
        const version = await (0, $4sWia.getVersion)();
        if (version === (0, $8aL9y.version)) this.updateAvailable = false;
        else // wait 45 secs for client to build
        setTimeout(()=>{
            this.updateAvailable = true;
        }, 45000);
    }
}, $12c475d52ba2dd6b$var$_descriptor = $12c475d52ba2dd6b$var$_applyDecoratedDescriptor($12c475d52ba2dd6b$var$_class.prototype, "profilePictureUrl", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
}), $12c475d52ba2dd6b$var$_descriptor2 = $12c475d52ba2dd6b$var$_applyDecoratedDescriptor($12c475d52ba2dd6b$var$_class.prototype, "emailVerified", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
}), $12c475d52ba2dd6b$var$_descriptor3 = $12c475d52ba2dd6b$var$_applyDecoratedDescriptor($12c475d52ba2dd6b$var$_class.prototype, "userId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $12c475d52ba2dd6b$var$_descriptor4 = $12c475d52ba2dd6b$var$_applyDecoratedDescriptor($12c475d52ba2dd6b$var$_class.prototype, "userPermissions", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $12c475d52ba2dd6b$var$_descriptor5 = $12c475d52ba2dd6b$var$_applyDecoratedDescriptor($12c475d52ba2dd6b$var$_class.prototype, "userEmail", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $12c475d52ba2dd6b$var$_descriptor6 = $12c475d52ba2dd6b$var$_applyDecoratedDescriptor($12c475d52ba2dd6b$var$_class.prototype, "userFirstName", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $12c475d52ba2dd6b$var$_descriptor7 = $12c475d52ba2dd6b$var$_applyDecoratedDescriptor($12c475d52ba2dd6b$var$_class.prototype, "userLastName", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $12c475d52ba2dd6b$var$_descriptor8 = $12c475d52ba2dd6b$var$_applyDecoratedDescriptor($12c475d52ba2dd6b$var$_class.prototype, "userCreatedAt", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $12c475d52ba2dd6b$var$_descriptor9 = $12c475d52ba2dd6b$var$_applyDecoratedDescriptor($12c475d52ba2dd6b$var$_class.prototype, "organisationId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $12c475d52ba2dd6b$var$_descriptor10 = $12c475d52ba2dd6b$var$_applyDecoratedDescriptor($12c475d52ba2dd6b$var$_class.prototype, "organisationName", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $12c475d52ba2dd6b$var$_descriptor11 = $12c475d52ba2dd6b$var$_applyDecoratedDescriptor($12c475d52ba2dd6b$var$_class.prototype, "organisationCountry", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $12c475d52ba2dd6b$var$_descriptor12 = $12c475d52ba2dd6b$var$_applyDecoratedDescriptor($12c475d52ba2dd6b$var$_class.prototype, "state", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "unauthenticated";
    }
}), $12c475d52ba2dd6b$var$_descriptor13 = $12c475d52ba2dd6b$var$_applyDecoratedDescriptor($12c475d52ba2dd6b$var$_class.prototype, "accounting", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $12c475d52ba2dd6b$var$_descriptor14 = $12c475d52ba2dd6b$var$_applyDecoratedDescriptor($12c475d52ba2dd6b$var$_class.prototype, "initialized", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $12c475d52ba2dd6b$var$_descriptor15 = $12c475d52ba2dd6b$var$_applyDecoratedDescriptor($12c475d52ba2dd6b$var$_class.prototype, "updateAvailable", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $12c475d52ba2dd6b$var$_descriptor16 = $12c475d52ba2dd6b$var$_applyDecoratedDescriptor($12c475d52ba2dd6b$var$_class.prototype, "migratedToV2", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $12c475d52ba2dd6b$var$_applyDecoratedDescriptor($12c475d52ba2dd6b$var$_class.prototype, "setMigratedToV2", [
    $12c475d52ba2dd6b$var$_dec
], Object.getOwnPropertyDescriptor($12c475d52ba2dd6b$var$_class.prototype, "setMigratedToV2"), $12c475d52ba2dd6b$var$_class.prototype), $12c475d52ba2dd6b$var$_applyDecoratedDescriptor($12c475d52ba2dd6b$var$_class.prototype, "initialize", [
    $12c475d52ba2dd6b$var$_dec2
], Object.getOwnPropertyDescriptor($12c475d52ba2dd6b$var$_class.prototype, "initialize"), $12c475d52ba2dd6b$var$_class.prototype), $12c475d52ba2dd6b$var$_applyDecoratedDescriptor($12c475d52ba2dd6b$var$_class.prototype, "authenticated", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($12c475d52ba2dd6b$var$_class.prototype, "authenticated"), $12c475d52ba2dd6b$var$_class.prototype), $12c475d52ba2dd6b$var$_applyDecoratedDescriptor($12c475d52ba2dd6b$var$_class.prototype, "login", [
    $12c475d52ba2dd6b$var$_dec3
], Object.getOwnPropertyDescriptor($12c475d52ba2dd6b$var$_class.prototype, "login"), $12c475d52ba2dd6b$var$_class.prototype), $12c475d52ba2dd6b$var$_applyDecoratedDescriptor($12c475d52ba2dd6b$var$_class.prototype, "signup", [
    $12c475d52ba2dd6b$var$_dec4
], Object.getOwnPropertyDescriptor($12c475d52ba2dd6b$var$_class.prototype, "signup"), $12c475d52ba2dd6b$var$_class.prototype), $12c475d52ba2dd6b$var$_applyDecoratedDescriptor($12c475d52ba2dd6b$var$_class.prototype, "saveLoginResponse", [
    $12c475d52ba2dd6b$var$_dec5
], Object.getOwnPropertyDescriptor($12c475d52ba2dd6b$var$_class.prototype, "saveLoginResponse"), $12c475d52ba2dd6b$var$_class.prototype), $12c475d52ba2dd6b$var$_applyDecoratedDescriptor($12c475d52ba2dd6b$var$_class.prototype, "impersonate", [
    $12c475d52ba2dd6b$var$_dec6
], Object.getOwnPropertyDescriptor($12c475d52ba2dd6b$var$_class.prototype, "impersonate"), $12c475d52ba2dd6b$var$_class.prototype), $12c475d52ba2dd6b$var$_applyDecoratedDescriptor($12c475d52ba2dd6b$var$_class.prototype, "register", [
    $12c475d52ba2dd6b$var$_dec7
], Object.getOwnPropertyDescriptor($12c475d52ba2dd6b$var$_class.prototype, "register"), $12c475d52ba2dd6b$var$_class.prototype), $12c475d52ba2dd6b$var$_applyDecoratedDescriptor($12c475d52ba2dd6b$var$_class.prototype, "logout", [
    $12c475d52ba2dd6b$var$_dec8
], Object.getOwnPropertyDescriptor($12c475d52ba2dd6b$var$_class.prototype, "logout"), $12c475d52ba2dd6b$var$_class.prototype), $12c475d52ba2dd6b$var$_applyDecoratedDescriptor($12c475d52ba2dd6b$var$_class.prototype, "saveSession", [
    $12c475d52ba2dd6b$var$_dec9
], Object.getOwnPropertyDescriptor($12c475d52ba2dd6b$var$_class.prototype, "saveSession"), $12c475d52ba2dd6b$var$_class.prototype), $12c475d52ba2dd6b$var$_applyDecoratedDescriptor($12c475d52ba2dd6b$var$_class.prototype, "clearCache", [
    $12c475d52ba2dd6b$var$_dec10
], Object.getOwnPropertyDescriptor($12c475d52ba2dd6b$var$_class.prototype, "clearCache"), $12c475d52ba2dd6b$var$_class.prototype), $12c475d52ba2dd6b$var$_applyDecoratedDescriptor($12c475d52ba2dd6b$var$_class.prototype, "deleteSession", [
    $12c475d52ba2dd6b$var$_dec11
], Object.getOwnPropertyDescriptor($12c475d52ba2dd6b$var$_class.prototype, "deleteSession"), $12c475d52ba2dd6b$var$_class.prototype), $12c475d52ba2dd6b$var$_applyDecoratedDescriptor($12c475d52ba2dd6b$var$_class.prototype, "checkAuthentication", [
    $12c475d52ba2dd6b$var$_dec12
], Object.getOwnPropertyDescriptor($12c475d52ba2dd6b$var$_class.prototype, "checkAuthentication"), $12c475d52ba2dd6b$var$_class.prototype), $12c475d52ba2dd6b$var$_applyDecoratedDescriptor($12c475d52ba2dd6b$var$_class.prototype, "resetAccountingTimeout", [
    $12c475d52ba2dd6b$var$_dec13
], Object.getOwnPropertyDescriptor($12c475d52ba2dd6b$var$_class.prototype, "resetAccountingTimeout"), $12c475d52ba2dd6b$var$_class.prototype), $12c475d52ba2dd6b$var$_applyDecoratedDescriptor($12c475d52ba2dd6b$var$_class.prototype, "saveAccountingExpires", [
    $12c475d52ba2dd6b$var$_dec14
], Object.getOwnPropertyDescriptor($12c475d52ba2dd6b$var$_class.prototype, "saveAccountingExpires"), $12c475d52ba2dd6b$var$_class.prototype), $12c475d52ba2dd6b$var$_applyDecoratedDescriptor($12c475d52ba2dd6b$var$_class.prototype, "accountingConnected", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($12c475d52ba2dd6b$var$_class.prototype, "accountingConnected"), $12c475d52ba2dd6b$var$_class.prototype), $12c475d52ba2dd6b$var$_applyDecoratedDescriptor($12c475d52ba2dd6b$var$_class.prototype, "user", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($12c475d52ba2dd6b$var$_class.prototype, "user"), $12c475d52ba2dd6b$var$_class.prototype), $12c475d52ba2dd6b$var$_applyDecoratedDescriptor($12c475d52ba2dd6b$var$_class.prototype, "organisation", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($12c475d52ba2dd6b$var$_class.prototype, "organisation"), $12c475d52ba2dd6b$var$_class.prototype), $12c475d52ba2dd6b$var$_applyDecoratedDescriptor($12c475d52ba2dd6b$var$_class.prototype, "subscription", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($12c475d52ba2dd6b$var$_class.prototype, "subscription"), $12c475d52ba2dd6b$var$_class.prototype), $12c475d52ba2dd6b$var$_applyDecoratedDescriptor($12c475d52ba2dd6b$var$_class.prototype, "settings", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($12c475d52ba2dd6b$var$_class.prototype, "settings"), $12c475d52ba2dd6b$var$_class.prototype), $12c475d52ba2dd6b$var$_applyDecoratedDescriptor($12c475d52ba2dd6b$var$_class.prototype, "checkIfUpdateIsAvailable", [
    (0, $4JcCM.action)
], Object.getOwnPropertyDescriptor($12c475d52ba2dd6b$var$_class.prototype, "checkIfUpdateIsAvailable"), $12c475d52ba2dd6b$var$_class.prototype), $12c475d52ba2dd6b$var$_class);
var $12c475d52ba2dd6b$export$2e2bcd8739ae039 = new $12c475d52ba2dd6b$var$SessionStore();
const $12c475d52ba2dd6b$export$6e121e085e95ad99 = {
    sortPhasesBy: "startDate",
    allowNoPhase: true,
    useTasks: true,
    allowAfterPhaseEnd: true,
    timeEntryAllocations: [
        "noAllocations",
        "budgets",
        "allocations"
    ],
    timeEntryStatus: [
        "active",
        "prospective",
        "onHold",
        "archived"
    ],
    timeEntryFlags: [
        "billable",
        "variation",
        "overtime"
    ],
    autoPopulate: [],
    // ["budgets", "allocations"]
    updateHoursFromRevenue: false,
    updateRevenueFromHours: false,
    autoUpdateRevenue: {
        action: "ask",
        // "automatic", "never"
        adjustOnLoad: false,
        budget: "remaining",
        start: "now",
        end: "endDate"
    },
    autoUpdateHours: {
        action: "ask",
        // "automatic", "never"
        adjustOnLoad: false,
        budget: "remaining",
        start: "now",
        end: "endDate"
    },
    reportInvoiceDateType: "issueDate",
    savingInvoices: [
        "markTimeInvoiced"
    ] // "lockTime", "automatic"
};

});
parcelRegister("7Fn0s", function(module, exports) {
/*!
    localForage -- Offline Storage, Improved
    Version 1.10.0
    https://localforage.github.io/localForage
    (c) 2013-2017 Mozilla, Apache License 2.0
*/ (function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = undefined;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(e) {
                    var n = t[o][1][e];
                    return s(n ? n : e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = undefined;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(_dereq_, module1, exports) {
                (function(global1) {
                    "use strict";
                    var Mutation = global1.MutationObserver || global1.WebKitMutationObserver;
                    var scheduleDrain;
                    if (Mutation) {
                        var called = 0;
                        var observer = new Mutation(nextTick);
                        var element = global1.document.createTextNode("");
                        observer.observe(element, {
                            characterData: true
                        });
                        scheduleDrain = function() {
                            element.data = called = ++called % 2;
                        };
                    } else if (!global1.setImmediate && typeof global1.MessageChannel !== "undefined") {
                        var channel = new global1.MessageChannel();
                        channel.port1.onmessage = nextTick;
                        scheduleDrain = function() {
                            channel.port2.postMessage(0);
                        };
                    } else if ("document" in global1 && "onreadystatechange" in global1.document.createElement("script")) scheduleDrain = function() {
                        // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
                        // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
                        var scriptEl = global1.document.createElement("script");
                        scriptEl.onreadystatechange = function() {
                            nextTick();
                            scriptEl.onreadystatechange = null;
                            scriptEl.parentNode.removeChild(scriptEl);
                            scriptEl = null;
                        };
                        global1.document.documentElement.appendChild(scriptEl);
                    };
                    else scheduleDrain = function() {
                        setTimeout(nextTick, 0);
                    };
                    var draining;
                    var queue = [];
                    //named nextTick for less confusing stack traces
                    function nextTick() {
                        draining = true;
                        var i, oldQueue;
                        var len = queue.length;
                        while(len){
                            oldQueue = queue;
                            queue = [];
                            i = -1;
                            while(++i < len)oldQueue[i]();
                            len = queue.length;
                        }
                        draining = false;
                    }
                    module1.exports = immediate;
                    function immediate(task) {
                        if (queue.push(task) === 1 && !draining) scheduleDrain();
                    }
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {}
        ],
        2: [
            function(_dereq_, module1, exports) {
                "use strict";
                var immediate = _dereq_(1);
                /* istanbul ignore next */ function INTERNAL() {}
                var handlers = {};
                var REJECTED = [
                    "REJECTED"
                ];
                var FULFILLED = [
                    "FULFILLED"
                ];
                var PENDING = [
                    "PENDING"
                ];
                module1.exports = Promise1;
                function Promise1(resolver) {
                    if (typeof resolver !== "function") throw new TypeError("resolver must be a function");
                    this.state = PENDING;
                    this.queue = [];
                    this.outcome = void 0;
                    if (resolver !== INTERNAL) safelyResolveThenable(this, resolver);
                }
                Promise1.prototype["catch"] = function(onRejected) {
                    return this.then(null, onRejected);
                };
                Promise1.prototype.then = function(onFulfilled, onRejected) {
                    if (typeof onFulfilled !== "function" && this.state === FULFILLED || typeof onRejected !== "function" && this.state === REJECTED) return this;
                    var promise = new this.constructor(INTERNAL);
                    if (this.state !== PENDING) {
                        var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
                        unwrap(promise, resolver, this.outcome);
                    } else this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
                    return promise;
                };
                function QueueItem(promise, onFulfilled, onRejected) {
                    this.promise = promise;
                    if (typeof onFulfilled === "function") {
                        this.onFulfilled = onFulfilled;
                        this.callFulfilled = this.otherCallFulfilled;
                    }
                    if (typeof onRejected === "function") {
                        this.onRejected = onRejected;
                        this.callRejected = this.otherCallRejected;
                    }
                }
                QueueItem.prototype.callFulfilled = function(value) {
                    handlers.resolve(this.promise, value);
                };
                QueueItem.prototype.otherCallFulfilled = function(value) {
                    unwrap(this.promise, this.onFulfilled, value);
                };
                QueueItem.prototype.callRejected = function(value) {
                    handlers.reject(this.promise, value);
                };
                QueueItem.prototype.otherCallRejected = function(value) {
                    unwrap(this.promise, this.onRejected, value);
                };
                function unwrap(promise, func, value) {
                    immediate(function() {
                        var returnValue;
                        try {
                            returnValue = func(value);
                        } catch (e) {
                            return handlers.reject(promise, e);
                        }
                        if (returnValue === promise) handlers.reject(promise, new TypeError("Cannot resolve promise with itself"));
                        else handlers.resolve(promise, returnValue);
                    });
                }
                handlers.resolve = function(self1, value) {
                    var result = tryCatch(getThen, value);
                    if (result.status === "error") return handlers.reject(self1, result.value);
                    var thenable = result.value;
                    if (thenable) safelyResolveThenable(self1, thenable);
                    else {
                        self1.state = FULFILLED;
                        self1.outcome = value;
                        var i = -1;
                        var len = self1.queue.length;
                        while(++i < len)self1.queue[i].callFulfilled(value);
                    }
                    return self1;
                };
                handlers.reject = function(self1, error) {
                    self1.state = REJECTED;
                    self1.outcome = error;
                    var i = -1;
                    var len = self1.queue.length;
                    while(++i < len)self1.queue[i].callRejected(error);
                    return self1;
                };
                function getThen(obj) {
                    // Make sure we only access the accessor once as required by the spec
                    var then = obj && obj.then;
                    if (obj && (typeof obj === "object" || typeof obj === "function") && typeof then === "function") return function appyThen() {
                        then.apply(obj, arguments);
                    };
                }
                function safelyResolveThenable(self1, thenable) {
                    // Either fulfill, reject or reject with error
                    var called = false;
                    function onError(value) {
                        if (called) return;
                        called = true;
                        handlers.reject(self1, value);
                    }
                    function onSuccess(value) {
                        if (called) return;
                        called = true;
                        handlers.resolve(self1, value);
                    }
                    function tryToUnwrap() {
                        thenable(onSuccess, onError);
                    }
                    var result = tryCatch(tryToUnwrap);
                    if (result.status === "error") onError(result.value);
                }
                function tryCatch(func, value) {
                    var out = {};
                    try {
                        out.value = func(value);
                        out.status = "success";
                    } catch (e) {
                        out.status = "error";
                        out.value = e;
                    }
                    return out;
                }
                Promise1.resolve = resolve;
                function resolve(value) {
                    if (value instanceof this) return value;
                    return handlers.resolve(new this(INTERNAL), value);
                }
                Promise1.reject = reject;
                function reject(reason) {
                    var promise = new this(INTERNAL);
                    return handlers.reject(promise, reason);
                }
                Promise1.all = all;
                function all(iterable) {
                    var self1 = this;
                    if (Object.prototype.toString.call(iterable) !== "[object Array]") return this.reject(new TypeError("must be an array"));
                    var len = iterable.length;
                    var called = false;
                    if (!len) return this.resolve([]);
                    var values = new Array(len);
                    var resolved = 0;
                    var i = -1;
                    var promise = new this(INTERNAL);
                    while(++i < len)allResolver(iterable[i], i);
                    return promise;
                    function allResolver(value, i) {
                        self1.resolve(value).then(resolveFromAll, function(error) {
                            if (!called) {
                                called = true;
                                handlers.reject(promise, error);
                            }
                        });
                        function resolveFromAll(outValue) {
                            values[i] = outValue;
                            if (++resolved === len && !called) {
                                called = true;
                                handlers.resolve(promise, values);
                            }
                        }
                    }
                }
                Promise1.race = race;
                function race(iterable) {
                    var self1 = this;
                    if (Object.prototype.toString.call(iterable) !== "[object Array]") return this.reject(new TypeError("must be an array"));
                    var len = iterable.length;
                    var called = false;
                    if (!len) return this.resolve([]);
                    var i = -1;
                    var promise = new this(INTERNAL);
                    while(++i < len)resolver(iterable[i]);
                    return promise;
                    function resolver(value) {
                        self1.resolve(value).then(function(response) {
                            if (!called) {
                                called = true;
                                handlers.resolve(promise, response);
                            }
                        }, function(error) {
                            if (!called) {
                                called = true;
                                handlers.reject(promise, error);
                            }
                        });
                    }
                }
            },
            {
                "1": 1
            }
        ],
        3: [
            function(_dereq_, module1, exports) {
                (function(global1) {
                    "use strict";
                    if (typeof global1.Promise !== "function") global1.Promise = _dereq_(2);
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {
                "2": 2
            }
        ],
        4: [
            function(_dereq_, module1, exports) {
                "use strict";
                var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function getIDB() {
                    /* global indexedDB,webkitIndexedDB,mozIndexedDB,OIndexedDB,msIndexedDB */ try {
                        if (typeof indexedDB !== "undefined") return indexedDB;
                        if (typeof webkitIndexedDB !== "undefined") return webkitIndexedDB;
                        if (typeof mozIndexedDB !== "undefined") return mozIndexedDB;
                        if (typeof OIndexedDB !== "undefined") return OIndexedDB;
                        if (typeof msIndexedDB !== "undefined") return msIndexedDB;
                    } catch (e) {
                        return;
                    }
                }
                var idb = getIDB();
                function isIndexedDBValid() {
                    try {
                        // Initialize IndexedDB; fall back to vendor-prefixed versions
                        // if needed.
                        if (!idb || !idb.open) return false;
                        // We mimic PouchDB here;
                        //
                        // We test for openDatabase because IE Mobile identifies itself
                        // as Safari. Oh the lulz...
                        var isSafari = typeof openDatabase !== "undefined" && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);
                        var hasFetch = typeof fetch === "function" && fetch.toString().indexOf("[native code") !== -1;
                        // Safari <10.1 does not meet our requirements for IDB support
                        // (see: https://github.com/pouchdb/pouchdb/issues/5572).
                        // Safari 10.1 shipped with fetch, we can use that to detect it.
                        // Note: this creates issues with `window.fetch` polyfills and
                        // overrides; see:
                        // https://github.com/localForage/localForage/issues/856
                        return (!isSafari || hasFetch) && typeof indexedDB !== "undefined" && // some outdated implementations of IDB that appear on Samsung
                        // and HTC Android devices <4.4 are missing IDBKeyRange
                        // See: https://github.com/mozilla/localForage/issues/128
                        // See: https://github.com/mozilla/localForage/issues/272
                        typeof IDBKeyRange !== "undefined";
                    } catch (e) {
                        return false;
                    }
                }
                // Abstracts constructing a Blob object, so it also works in older
                // browsers that don't support the native Blob constructor. (i.e.
                // old QtWebKit versions, at least).
                // Abstracts constructing a Blob object, so it also works in older
                // browsers that don't support the native Blob constructor. (i.e.
                // old QtWebKit versions, at least).
                function createBlob(parts, properties) {
                    /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */ parts = parts || [];
                    properties = properties || {};
                    try {
                        return new Blob(parts, properties);
                    } catch (e) {
                        if (e.name !== "TypeError") throw e;
                        var Builder = typeof BlobBuilder !== "undefined" ? BlobBuilder : typeof MSBlobBuilder !== "undefined" ? MSBlobBuilder : typeof MozBlobBuilder !== "undefined" ? MozBlobBuilder : WebKitBlobBuilder;
                        var builder = new Builder();
                        for(var i = 0; i < parts.length; i += 1)builder.append(parts[i]);
                        return builder.getBlob(properties.type);
                    }
                }
                // This is CommonJS because lie is an external dependency, so Rollup
                // can just ignore it.
                if (typeof Promise === "undefined") // In the "nopromises" build this will just throw if you don't have
                // a global promise object, but it would throw anyway later.
                _dereq_(3);
                var Promise$1 = Promise;
                function executeCallback(promise, callback) {
                    if (callback) promise.then(function(result) {
                        callback(null, result);
                    }, function(error) {
                        callback(error);
                    });
                }
                function executeTwoCallbacks(promise, callback, errorCallback) {
                    if (typeof callback === "function") promise.then(callback);
                    if (typeof errorCallback === "function") promise["catch"](errorCallback);
                }
                function normalizeKey(key) {
                    // Cast the key to a string, as that's all we can set as a key.
                    if (typeof key !== "string") {
                        console.warn(key + " used as a key, but it is not a string.");
                        key = String(key);
                    }
                    return key;
                }
                function getCallback() {
                    if (arguments.length && typeof arguments[arguments.length - 1] === "function") return arguments[arguments.length - 1];
                }
                // Some code originally from async_storage.js in
                // [Gaia](https://github.com/mozilla-b2g/gaia).
                var DETECT_BLOB_SUPPORT_STORE = "local-forage-detect-blob-support";
                var supportsBlobs = void 0;
                var dbContexts = {};
                var toString = Object.prototype.toString;
                // Transaction Modes
                var READ_ONLY = "readonly";
                var READ_WRITE = "readwrite";
                // Transform a binary string to an array buffer, because otherwise
                // weird stuff happens when you try to work with the binary string directly.
                // It is known.
                // From http://stackoverflow.com/questions/14967647/ (continues on next line)
                // encode-decode-image-with-base64-breaks-image (2013-04-21)
                function _binStringToArrayBuffer(bin) {
                    var length = bin.length;
                    var buf = new ArrayBuffer(length);
                    var arr = new Uint8Array(buf);
                    for(var i = 0; i < length; i++)arr[i] = bin.charCodeAt(i);
                    return buf;
                }
                //
                // Blobs are not supported in all versions of IndexedDB, notably
                // Chrome <37 and Android <5. In those versions, storing a blob will throw.
                //
                // Various other blob bugs exist in Chrome v37-42 (inclusive).
                // Detecting them is expensive and confusing to users, and Chrome 37-42
                // is at very low usage worldwide, so we do a hacky userAgent check instead.
                //
                // content-type bug: https://code.google.com/p/chromium/issues/detail?id=408120
                // 404 bug: https://code.google.com/p/chromium/issues/detail?id=447916
                // FileReader bug: https://code.google.com/p/chromium/issues/detail?id=447836
                //
                // Code borrowed from PouchDB. See:
                // https://github.com/pouchdb/pouchdb/blob/master/packages/node_modules/pouchdb-adapter-idb/src/blobSupport.js
                //
                function _checkBlobSupportWithoutCaching(idb) {
                    return new Promise$1(function(resolve) {
                        var txn = idb.transaction(DETECT_BLOB_SUPPORT_STORE, READ_WRITE);
                        var blob = createBlob([
                            ""
                        ]);
                        txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, "key");
                        txn.onabort = function(e) {
                            // If the transaction aborts now its due to not being able to
                            // write to the database, likely due to the disk being full
                            e.preventDefault();
                            e.stopPropagation();
                            resolve(false);
                        };
                        txn.oncomplete = function() {
                            var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
                            var matchedEdge = navigator.userAgent.match(/Edge\//);
                            // MS Edge pretends to be Chrome 42:
                            // https://msdn.microsoft.com/en-us/library/hh869301%28v=vs.85%29.aspx
                            resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
                        };
                    })["catch"](function() {
                        return false; // error, so assume unsupported
                    });
                }
                function _checkBlobSupport(idb) {
                    if (typeof supportsBlobs === "boolean") return Promise$1.resolve(supportsBlobs);
                    return _checkBlobSupportWithoutCaching(idb).then(function(value) {
                        supportsBlobs = value;
                        return supportsBlobs;
                    });
                }
                function _deferReadiness(dbInfo) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Create a deferred object representing the current database operation.
                    var deferredOperation = {};
                    deferredOperation.promise = new Promise$1(function(resolve, reject) {
                        deferredOperation.resolve = resolve;
                        deferredOperation.reject = reject;
                    });
                    // Enqueue the deferred operation.
                    dbContext.deferredOperations.push(deferredOperation);
                    // Chain its promise to the database readiness.
                    if (!dbContext.dbReady) dbContext.dbReady = deferredOperation.promise;
                    else dbContext.dbReady = dbContext.dbReady.then(function() {
                        return deferredOperation.promise;
                    });
                }
                function _advanceReadiness(dbInfo) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Dequeue a deferred operation.
                    var deferredOperation = dbContext.deferredOperations.pop();
                    // Resolve its promise (which is part of the database readiness
                    // chain of promises).
                    if (deferredOperation) {
                        deferredOperation.resolve();
                        return deferredOperation.promise;
                    }
                }
                function _rejectReadiness(dbInfo, err) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Dequeue a deferred operation.
                    var deferredOperation = dbContext.deferredOperations.pop();
                    // Reject its promise (which is part of the database readiness
                    // chain of promises).
                    if (deferredOperation) {
                        deferredOperation.reject(err);
                        return deferredOperation.promise;
                    }
                }
                function _getConnection(dbInfo, upgradeNeeded) {
                    return new Promise$1(function(resolve, reject) {
                        dbContexts[dbInfo.name] = dbContexts[dbInfo.name] || createDbContext();
                        if (dbInfo.db) {
                            if (upgradeNeeded) {
                                _deferReadiness(dbInfo);
                                dbInfo.db.close();
                            } else return resolve(dbInfo.db);
                        }
                        var dbArgs = [
                            dbInfo.name
                        ];
                        if (upgradeNeeded) dbArgs.push(dbInfo.version);
                        var openreq = idb.open.apply(idb, dbArgs);
                        if (upgradeNeeded) openreq.onupgradeneeded = function(e) {
                            var db = openreq.result;
                            try {
                                db.createObjectStore(dbInfo.storeName);
                                if (e.oldVersion <= 1) // Added when support for blob shims was added
                                db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
                            } catch (ex) {
                                if (ex.name === "ConstraintError") console.warn('The database "' + dbInfo.name + '"' + " has been upgraded from version " + e.oldVersion + " to version " + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
                                else throw ex;
                            }
                        };
                        openreq.onerror = function(e) {
                            e.preventDefault();
                            reject(openreq.error);
                        };
                        openreq.onsuccess = function() {
                            var db = openreq.result;
                            db.onversionchange = function(e) {
                                // Triggered when the database is modified (e.g. adding an objectStore) or
                                // deleted (even when initiated by other sessions in different tabs).
                                // Closing the connection here prevents those operations from being blocked.
                                // If the database is accessed again later by this instance, the connection
                                // will be reopened or the database recreated as needed.
                                e.target.close();
                            };
                            resolve(db);
                            _advanceReadiness(dbInfo);
                        };
                    });
                }
                function _getOriginalConnection(dbInfo) {
                    return _getConnection(dbInfo, false);
                }
                function _getUpgradedConnection(dbInfo) {
                    return _getConnection(dbInfo, true);
                }
                function _isUpgradeNeeded(dbInfo, defaultVersion) {
                    if (!dbInfo.db) return true;
                    var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
                    var isDowngrade = dbInfo.version < dbInfo.db.version;
                    var isUpgrade = dbInfo.version > dbInfo.db.version;
                    if (isDowngrade) {
                        // If the version is not the default one
                        // then warn for impossible downgrade.
                        if (dbInfo.version !== defaultVersion) console.warn('The database "' + dbInfo.name + '"' + " can't be downgraded from version " + dbInfo.db.version + " to version " + dbInfo.version + ".");
                        // Align the versions to prevent errors.
                        dbInfo.version = dbInfo.db.version;
                    }
                    if (isUpgrade || isNewStore) {
                        // If the store is new then increment the version (if needed).
                        // This will trigger an "upgradeneeded" event which is required
                        // for creating a store.
                        if (isNewStore) {
                            var incVersion = dbInfo.db.version + 1;
                            if (incVersion > dbInfo.version) dbInfo.version = incVersion;
                        }
                        return true;
                    }
                    return false;
                }
                // encode a blob for indexeddb engines that don't support blobs
                function _encodeBlob(blob) {
                    return new Promise$1(function(resolve, reject) {
                        var reader = new FileReader();
                        reader.onerror = reject;
                        reader.onloadend = function(e) {
                            var base64 = btoa(e.target.result || "");
                            resolve({
                                __local_forage_encoded_blob: true,
                                data: base64,
                                type: blob.type
                            });
                        };
                        reader.readAsBinaryString(blob);
                    });
                }
                // decode an encoded blob
                function _decodeBlob(encodedBlob) {
                    var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
                    return createBlob([
                        arrayBuff
                    ], {
                        type: encodedBlob.type
                    });
                }
                // is this one of our fancy encoded blobs?
                function _isEncodedBlob(value) {
                    return value && value.__local_forage_encoded_blob;
                }
                // Specialize the default `ready()` function by making it dependent
                // on the current database operations. Thus, the driver will be actually
                // ready when it's been initialized (default) *and* there are no pending
                // operations on the database (initiated by some other instances).
                function _fullyReady(callback) {
                    var self1 = this;
                    var promise = self1._initReady().then(function() {
                        var dbContext = dbContexts[self1._dbInfo.name];
                        if (dbContext && dbContext.dbReady) return dbContext.dbReady;
                    });
                    executeTwoCallbacks(promise, callback, callback);
                    return promise;
                }
                // Try to establish a new db connection to replace the
                // current one which is broken (i.e. experiencing
                // InvalidStateError while creating a transaction).
                function _tryReconnect(dbInfo) {
                    _deferReadiness(dbInfo);
                    var dbContext = dbContexts[dbInfo.name];
                    var forages = dbContext.forages;
                    for(var i = 0; i < forages.length; i++){
                        var forage = forages[i];
                        if (forage._dbInfo.db) {
                            forage._dbInfo.db.close();
                            forage._dbInfo.db = null;
                        }
                    }
                    dbInfo.db = null;
                    return _getOriginalConnection(dbInfo).then(function(db) {
                        dbInfo.db = db;
                        if (_isUpgradeNeeded(dbInfo)) // Reopen the database for upgrading.
                        return _getUpgradedConnection(dbInfo);
                        return db;
                    }).then(function(db) {
                        // store the latest db reference
                        // in case the db was upgraded
                        dbInfo.db = dbContext.db = db;
                        for(var i = 0; i < forages.length; i++)forages[i]._dbInfo.db = db;
                    })["catch"](function(err) {
                        _rejectReadiness(dbInfo, err);
                        throw err;
                    });
                }
                // FF doesn't like Promises (micro-tasks) and IDDB store operations,
                // so we have to do it with callbacks
                function createTransaction(dbInfo, mode, callback, retries) {
                    if (retries === undefined) retries = 1;
                    try {
                        var tx = dbInfo.db.transaction(dbInfo.storeName, mode);
                        callback(null, tx);
                    } catch (err) {
                        if (retries > 0 && (!dbInfo.db || err.name === "InvalidStateError" || err.name === "NotFoundError")) return Promise$1.resolve().then(function() {
                            if (!dbInfo.db || err.name === "NotFoundError" && !dbInfo.db.objectStoreNames.contains(dbInfo.storeName) && dbInfo.version <= dbInfo.db.version) {
                                // increase the db version, to create the new ObjectStore
                                if (dbInfo.db) dbInfo.version = dbInfo.db.version + 1;
                                // Reopen the database for upgrading.
                                return _getUpgradedConnection(dbInfo);
                            }
                        }).then(function() {
                            return _tryReconnect(dbInfo).then(function() {
                                createTransaction(dbInfo, mode, callback, retries - 1);
                            });
                        })["catch"](callback);
                        callback(err);
                    }
                }
                function createDbContext() {
                    return {
                        // Running localForages sharing a database.
                        forages: [],
                        // Shared database.
                        db: null,
                        // Database readiness (promise).
                        dbReady: null,
                        // Deferred operations on the database.
                        deferredOperations: []
                    };
                }
                // Open the IndexedDB database (automatically creates one if one didn't
                // previously exist), using any options set in the config.
                function _initStorage(options) {
                    var self1 = this;
                    var dbInfo = {
                        db: null
                    };
                    if (options) for(var i in options)dbInfo[i] = options[i];
                    // Get the current context of the database;
                    var dbContext = dbContexts[dbInfo.name];
                    // ...or create a new context.
                    if (!dbContext) {
                        dbContext = createDbContext();
                        // Register the new context in the global container.
                        dbContexts[dbInfo.name] = dbContext;
                    }
                    // Register itself as a running localForage in the current context.
                    dbContext.forages.push(self1);
                    // Replace the default `ready()` function with the specialized one.
                    if (!self1._initReady) {
                        self1._initReady = self1.ready;
                        self1.ready = _fullyReady;
                    }
                    // Create an array of initialization states of the related localForages.
                    var initPromises = [];
                    function ignoreErrors() {
                        // Don't handle errors here,
                        // just makes sure related localForages aren't pending.
                        return Promise$1.resolve();
                    }
                    for(var j = 0; j < dbContext.forages.length; j++){
                        var forage = dbContext.forages[j];
                        if (forage !== self1) // Don't wait for itself...
                        initPromises.push(forage._initReady()["catch"](ignoreErrors));
                    }
                    // Take a snapshot of the related localForages.
                    var forages = dbContext.forages.slice(0);
                    // Initialize the connection process only when
                    // all the related localForages aren't pending.
                    return Promise$1.all(initPromises).then(function() {
                        dbInfo.db = dbContext.db;
                        // Get the connection or open a new one without upgrade.
                        return _getOriginalConnection(dbInfo);
                    }).then(function(db) {
                        dbInfo.db = db;
                        if (_isUpgradeNeeded(dbInfo, self1._defaultConfig.version)) // Reopen the database for upgrading.
                        return _getUpgradedConnection(dbInfo);
                        return db;
                    }).then(function(db) {
                        dbInfo.db = dbContext.db = db;
                        self1._dbInfo = dbInfo;
                        // Share the final connection amongst related localForages.
                        for(var k = 0; k < forages.length; k++){
                            var forage = forages[k];
                            if (forage !== self1) {
                                // Self is already up-to-date.
                                forage._dbInfo.db = dbInfo.db;
                                forage._dbInfo.version = dbInfo.version;
                            }
                        }
                    });
                }
                function getItem(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.get(key);
                                    req.onsuccess = function() {
                                        var value = req.result;
                                        if (value === undefined) value = null;
                                        if (_isEncodedBlob(value)) value = _decodeBlob(value);
                                        resolve(value);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Iterate over all items stored in database.
                function iterate(iterator, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.openCursor();
                                    var iterationNumber = 1;
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (cursor) {
                                            var value = cursor.value;
                                            if (_isEncodedBlob(value)) value = _decodeBlob(value);
                                            var result = iterator(value, cursor.key, iterationNumber++);
                                            // when the iterator callback returns any
                                            // (non-`undefined`) value, then we stop
                                            // the iteration immediately
                                            if (result !== void 0) resolve(result);
                                            else cursor["continue"]();
                                        } else resolve();
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function setItem(key, value, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        var dbInfo;
                        self1.ready().then(function() {
                            dbInfo = self1._dbInfo;
                            if (toString.call(value) === "[object Blob]") return _checkBlobSupport(dbInfo.db).then(function(blobSupport) {
                                if (blobSupport) return value;
                                return _encodeBlob(value);
                            });
                            return value;
                        }).then(function(value) {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    // The reason we don't _save_ null is because IE 10 does
                                    // not support saving the `null` type in IndexedDB. How
                                    // ironic, given the bug below!
                                    // See: https://github.com/mozilla/localForage/issues/161
                                    if (value === null) value = undefined;
                                    var req = store.put(value, key);
                                    transaction.oncomplete = function() {
                                        // Cast to undefined so the value passed to
                                        // callback/promise is the same as what one would get out
                                        // of `getItem()` later. This leads to some weirdness
                                        // (setItem('foo', undefined) will return `null`), but
                                        // it's not my fault localStorage is our baseline and that
                                        // it's weird.
                                        if (value === undefined) value = null;
                                        resolve(value);
                                    };
                                    transaction.onabort = transaction.onerror = function() {
                                        var err = req.error ? req.error : req.transaction.error;
                                        reject(err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function removeItem(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    // We use a Grunt task to make this safe for IE and some
                                    // versions of Android (including those used by Cordova).
                                    // Normally IE won't like `.delete()` and will insist on
                                    // using `['delete']()`, but we have a build step that
                                    // fixes this for us now.
                                    var req = store["delete"](key);
                                    transaction.oncomplete = function() {
                                        resolve();
                                    };
                                    transaction.onerror = function() {
                                        reject(req.error);
                                    };
                                    // The request will be also be aborted if we've exceeded our storage
                                    // space.
                                    transaction.onabort = function() {
                                        var err = req.error ? req.error : req.transaction.error;
                                        reject(err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function clear(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.clear();
                                    transaction.oncomplete = function() {
                                        resolve();
                                    };
                                    transaction.onabort = transaction.onerror = function() {
                                        var err = req.error ? req.error : req.transaction.error;
                                        reject(err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function length(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.count();
                                    req.onsuccess = function() {
                                        resolve(req.result);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function key(n, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        if (n < 0) {
                            resolve(null);
                            return;
                        }
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var advanced = false;
                                    var req = store.openKeyCursor();
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (!cursor) {
                                            // this means there weren't enough keys
                                            resolve(null);
                                            return;
                                        }
                                        if (n === 0) // We have the first key, return it if that's what they
                                        // wanted.
                                        resolve(cursor.key);
                                        else if (!advanced) {
                                            // Otherwise, ask the cursor to skip ahead n
                                            // records.
                                            advanced = true;
                                            cursor.advance(n);
                                        } else // When we get here, we've got the nth key.
                                        resolve(cursor.key);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.openKeyCursor();
                                    var keys = [];
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (!cursor) {
                                            resolve(keys);
                                            return;
                                        }
                                        keys.push(cursor.key);
                                        cursor["continue"]();
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function dropInstance(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    var currentConfig = this.config();
                    options = typeof options !== "function" && options || {};
                    if (!options.name) {
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject("Invalid arguments");
                    else {
                        var isCurrentDb = options.name === currentConfig.name && self1._dbInfo.db;
                        var dbPromise = isCurrentDb ? Promise$1.resolve(self1._dbInfo.db) : _getOriginalConnection(options).then(function(db) {
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            dbContext.db = db;
                            for(var i = 0; i < forages.length; i++)forages[i]._dbInfo.db = db;
                            return db;
                        });
                        if (!options.storeName) promise = dbPromise.then(function(db) {
                            _deferReadiness(options);
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            db.close();
                            for(var i = 0; i < forages.length; i++){
                                var forage = forages[i];
                                forage._dbInfo.db = null;
                            }
                            var dropDBPromise = new Promise$1(function(resolve, reject) {
                                var req = idb.deleteDatabase(options.name);
                                req.onerror = function() {
                                    var db = req.result;
                                    if (db) db.close();
                                    reject(req.error);
                                };
                                req.onblocked = function() {
                                    // Closing all open connections in onversionchange handler should prevent this situation, but if
                                    // we do get here, it just means the request remains pending - eventually it will succeed or error
                                    console.warn('dropInstance blocked for database "' + options.name + '" until all open connections are closed');
                                };
                                req.onsuccess = function() {
                                    var db = req.result;
                                    if (db) db.close();
                                    resolve(db);
                                };
                            });
                            return dropDBPromise.then(function(db) {
                                dbContext.db = db;
                                for(var i = 0; i < forages.length; i++){
                                    var _forage = forages[i];
                                    _advanceReadiness(_forage._dbInfo);
                                }
                            })["catch"](function(err) {
                                (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function() {});
                                throw err;
                            });
                        });
                        else promise = dbPromise.then(function(db) {
                            if (!db.objectStoreNames.contains(options.storeName)) return;
                            var newVersion = db.version + 1;
                            _deferReadiness(options);
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            db.close();
                            for(var i = 0; i < forages.length; i++){
                                var forage = forages[i];
                                forage._dbInfo.db = null;
                                forage._dbInfo.version = newVersion;
                            }
                            var dropObjectPromise = new Promise$1(function(resolve, reject) {
                                var req = idb.open(options.name, newVersion);
                                req.onerror = function(err) {
                                    var db = req.result;
                                    db.close();
                                    reject(err);
                                };
                                req.onupgradeneeded = function() {
                                    var db = req.result;
                                    db.deleteObjectStore(options.storeName);
                                };
                                req.onsuccess = function() {
                                    var db = req.result;
                                    db.close();
                                    resolve(db);
                                };
                            });
                            return dropObjectPromise.then(function(db) {
                                dbContext.db = db;
                                for(var j = 0; j < forages.length; j++){
                                    var _forage2 = forages[j];
                                    _forage2._dbInfo.db = db;
                                    _advanceReadiness(_forage2._dbInfo);
                                }
                            })["catch"](function(err) {
                                (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function() {});
                                throw err;
                            });
                        });
                    }
                    executeCallback(promise, callback);
                    return promise;
                }
                var asyncStorage = {
                    _driver: "asyncStorage",
                    _initStorage: _initStorage,
                    _support: isIndexedDBValid(),
                    iterate: iterate,
                    getItem: getItem,
                    setItem: setItem,
                    removeItem: removeItem,
                    clear: clear,
                    length: length,
                    key: key,
                    keys: keys,
                    dropInstance: dropInstance
                };
                function isWebSQLValid() {
                    return typeof openDatabase === "function";
                }
                // Sadly, the best way to save binary data in WebSQL/localStorage is serializing
                // it to Base64, so this is how we store it to prevent very strange errors with less
                // verbose ways of binary <-> string data storage.
                var BASE_CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
                var BLOB_TYPE_PREFIX = "~~local_forage_type~";
                var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;
                var SERIALIZED_MARKER = "__lfsc__:";
                var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;
                // OMG the serializations!
                var TYPE_ARRAYBUFFER = "arbf";
                var TYPE_BLOB = "blob";
                var TYPE_INT8ARRAY = "si08";
                var TYPE_UINT8ARRAY = "ui08";
                var TYPE_UINT8CLAMPEDARRAY = "uic8";
                var TYPE_INT16ARRAY = "si16";
                var TYPE_INT32ARRAY = "si32";
                var TYPE_UINT16ARRAY = "ur16";
                var TYPE_UINT32ARRAY = "ui32";
                var TYPE_FLOAT32ARRAY = "fl32";
                var TYPE_FLOAT64ARRAY = "fl64";
                var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;
                var toString$1 = Object.prototype.toString;
                function stringToBuffer(serializedString) {
                    // Fill the string into a ArrayBuffer.
                    var bufferLength = serializedString.length * 0.75;
                    var len = serializedString.length;
                    var i;
                    var p = 0;
                    var encoded1, encoded2, encoded3, encoded4;
                    if (serializedString[serializedString.length - 1] === "=") {
                        bufferLength--;
                        if (serializedString[serializedString.length - 2] === "=") bufferLength--;
                    }
                    var buffer = new ArrayBuffer(bufferLength);
                    var bytes = new Uint8Array(buffer);
                    for(i = 0; i < len; i += 4){
                        encoded1 = BASE_CHARS.indexOf(serializedString[i]);
                        encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
                        encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
                        encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);
                        /*jslint bitwise: true */ bytes[p++] = encoded1 << 2 | encoded2 >> 4;
                        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
                        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
                    }
                    return buffer;
                }
                // Converts a buffer to a string to store, serialized, in the backend
                // storage library.
                function bufferToString(buffer) {
                    // base64-arraybuffer
                    var bytes = new Uint8Array(buffer);
                    var base64String = "";
                    var i;
                    for(i = 0; i < bytes.length; i += 3){
                        /*jslint bitwise: true */ base64String += BASE_CHARS[bytes[i] >> 2];
                        base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
                        base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
                        base64String += BASE_CHARS[bytes[i + 2] & 63];
                    }
                    if (bytes.length % 3 === 2) base64String = base64String.substring(0, base64String.length - 1) + "=";
                    else if (bytes.length % 3 === 1) base64String = base64String.substring(0, base64String.length - 2) + "==";
                    return base64String;
                }
                // Serialize a value, afterwards executing a callback (which usually
                // instructs the `setItem()` callback/promise to be executed). This is how
                // we store binary data with localStorage.
                function serialize(value, callback) {
                    var valueType = "";
                    if (value) valueType = toString$1.call(value);
                    // Cannot use `value instanceof ArrayBuffer` or such here, as these
                    // checks fail when running the tests using casper.js...
                    //
                    // TODO: See why those tests fail and use a better solution.
                    if (value && (valueType === "[object ArrayBuffer]" || value.buffer && toString$1.call(value.buffer) === "[object ArrayBuffer]")) {
                        // Convert binary arrays to a string and prefix the string with
                        // a special marker.
                        var buffer;
                        var marker = SERIALIZED_MARKER;
                        if (value instanceof ArrayBuffer) {
                            buffer = value;
                            marker += TYPE_ARRAYBUFFER;
                        } else {
                            buffer = value.buffer;
                            if (valueType === "[object Int8Array]") marker += TYPE_INT8ARRAY;
                            else if (valueType === "[object Uint8Array]") marker += TYPE_UINT8ARRAY;
                            else if (valueType === "[object Uint8ClampedArray]") marker += TYPE_UINT8CLAMPEDARRAY;
                            else if (valueType === "[object Int16Array]") marker += TYPE_INT16ARRAY;
                            else if (valueType === "[object Uint16Array]") marker += TYPE_UINT16ARRAY;
                            else if (valueType === "[object Int32Array]") marker += TYPE_INT32ARRAY;
                            else if (valueType === "[object Uint32Array]") marker += TYPE_UINT32ARRAY;
                            else if (valueType === "[object Float32Array]") marker += TYPE_FLOAT32ARRAY;
                            else if (valueType === "[object Float64Array]") marker += TYPE_FLOAT64ARRAY;
                            else callback(new Error("Failed to get type for BinaryArray"));
                        }
                        callback(marker + bufferToString(buffer));
                    } else if (valueType === "[object Blob]") {
                        // Conver the blob to a binaryArray and then to a string.
                        var fileReader = new FileReader();
                        fileReader.onload = function() {
                            // Backwards-compatible prefix for the blob type.
                            var str = BLOB_TYPE_PREFIX + value.type + "~" + bufferToString(this.result);
                            callback(SERIALIZED_MARKER + TYPE_BLOB + str);
                        };
                        fileReader.readAsArrayBuffer(value);
                    } else try {
                        callback(JSON.stringify(value));
                    } catch (e) {
                        console.error("Couldn't convert value into a JSON string: ", value);
                        callback(null, e);
                    }
                }
                // Deserialize data we've inserted into a value column/field. We place
                // special markers into our strings to mark them as encoded; this isn't
                // as nice as a meta field, but it's the only sane thing we can do whilst
                // keeping localStorage support intact.
                //
                // Oftentimes this will just deserialize JSON content, but if we have a
                // special marker (SERIALIZED_MARKER, defined above), we will extract
                // some kind of arraybuffer/binary data/typed array out of the string.
                function deserialize(value) {
                    // If we haven't marked this string as being specially serialized (i.e.
                    // something other than serialized JSON), we can just return it and be
                    // done with it.
                    if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) return JSON.parse(value);
                    // The following code deals with deserializing some kind of Blob or
                    // TypedArray. First we separate out the type of data we're dealing
                    // with from the data itself.
                    var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
                    var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);
                    var blobType;
                    // Backwards-compatible blob type serialization strategy.
                    // DBs created with older versions of localForage will simply not have the blob type.
                    if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
                        var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
                        blobType = matcher[1];
                        serializedString = serializedString.substring(matcher[0].length);
                    }
                    var buffer = stringToBuffer(serializedString);
                    // Return the right type based on the code/type set during
                    // serialization.
                    switch(type){
                        case TYPE_ARRAYBUFFER:
                            return buffer;
                        case TYPE_BLOB:
                            return createBlob([
                                buffer
                            ], {
                                type: blobType
                            });
                        case TYPE_INT8ARRAY:
                            return new Int8Array(buffer);
                        case TYPE_UINT8ARRAY:
                            return new Uint8Array(buffer);
                        case TYPE_UINT8CLAMPEDARRAY:
                            return new Uint8ClampedArray(buffer);
                        case TYPE_INT16ARRAY:
                            return new Int16Array(buffer);
                        case TYPE_UINT16ARRAY:
                            return new Uint16Array(buffer);
                        case TYPE_INT32ARRAY:
                            return new Int32Array(buffer);
                        case TYPE_UINT32ARRAY:
                            return new Uint32Array(buffer);
                        case TYPE_FLOAT32ARRAY:
                            return new Float32Array(buffer);
                        case TYPE_FLOAT64ARRAY:
                            return new Float64Array(buffer);
                        default:
                            throw new Error("Unkown type: " + type);
                    }
                }
                var localforageSerializer = {
                    serialize: serialize,
                    deserialize: deserialize,
                    stringToBuffer: stringToBuffer,
                    bufferToString: bufferToString
                };
                /*
 * Includes code from:
 *
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */ function createDbTable(t, dbInfo, callback, errorCallback) {
                    t.executeSql("CREATE TABLE IF NOT EXISTS " + dbInfo.storeName + " " + "(id INTEGER PRIMARY KEY, key unique, value)", [], callback, errorCallback);
                }
                // Open the WebSQL database (automatically creates one if one didn't
                // previously exist), using any options set in the config.
                function _initStorage$1(options) {
                    var self1 = this;
                    var dbInfo = {
                        db: null
                    };
                    if (options) for(var i in options)dbInfo[i] = typeof options[i] !== "string" ? options[i].toString() : options[i];
                    var dbInfoPromise = new Promise$1(function(resolve, reject) {
                        // Open the database; the openDatabase API will automatically
                        // create it for us if it doesn't exist.
                        try {
                            dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
                        } catch (e) {
                            return reject(e);
                        }
                        // Create our key/value table if it doesn't exist.
                        dbInfo.db.transaction(function(t) {
                            createDbTable(t, dbInfo, function() {
                                self1._dbInfo = dbInfo;
                                resolve();
                            }, function(t, error) {
                                reject(error);
                            });
                        }, reject);
                    });
                    dbInfo.serializer = localforageSerializer;
                    return dbInfoPromise;
                }
                function tryExecuteSql(t, dbInfo, sqlStatement, args, callback, errorCallback) {
                    t.executeSql(sqlStatement, args, callback, function(t, error) {
                        if (error.code === error.SYNTAX_ERR) t.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name = ?", [
                            dbInfo.storeName
                        ], function(t, results) {
                            if (!results.rows.length) // if the table is missing (was deleted)
                            // re-create it table and retry
                            createDbTable(t, dbInfo, function() {
                                t.executeSql(sqlStatement, args, callback, errorCallback);
                            }, errorCallback);
                            else errorCallback(t, error);
                        }, errorCallback);
                        else errorCallback(t, error);
                    }, errorCallback);
                }
                function getItem$1(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "SELECT * FROM " + dbInfo.storeName + " WHERE key = ? LIMIT 1", [
                                    key
                                ], function(t, results) {
                                    var result = results.rows.length ? results.rows.item(0).value : null;
                                    // Check to see if this is serialized content we need to
                                    // unpack.
                                    if (result) result = dbInfo.serializer.deserialize(result);
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function iterate$1(iterator, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "SELECT * FROM " + dbInfo.storeName, [], function(t, results) {
                                    var rows = results.rows;
                                    var length = rows.length;
                                    for(var i = 0; i < length; i++){
                                        var item = rows.item(i);
                                        var result = item.value;
                                        // Check to see if this is serialized content
                                        // we need to unpack.
                                        if (result) result = dbInfo.serializer.deserialize(result);
                                        result = iterator(result, item.key, i + 1);
                                        // void(0) prevents problems with redefinition
                                        // of `undefined`.
                                        if (result !== void 0) {
                                            resolve(result);
                                            return;
                                        }
                                    }
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function _setItem(key, value, callback, retriesLeft) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            // The localStorage API doesn't return undefined values in an
                            // "expected" way, so undefined is always cast to null in all
                            // drivers. See: https://github.com/mozilla/localForage/pull/42
                            if (value === undefined) value = null;
                            // Save the original value to pass to the callback.
                            var originalValue = value;
                            var dbInfo = self1._dbInfo;
                            dbInfo.serializer.serialize(value, function(value, error) {
                                if (error) reject(error);
                                else dbInfo.db.transaction(function(t) {
                                    tryExecuteSql(t, dbInfo, "INSERT OR REPLACE INTO " + dbInfo.storeName + " " + "(key, value) VALUES (?, ?)", [
                                        key,
                                        value
                                    ], function() {
                                        resolve(originalValue);
                                    }, function(t, error) {
                                        reject(error);
                                    });
                                }, function(sqlError) {
                                    // The transaction failed; check
                                    // to see if it's a quota error.
                                    if (sqlError.code === sqlError.QUOTA_ERR) {
                                        // We reject the callback outright for now, but
                                        // it's worth trying to re-run the transaction.
                                        // Even if the user accepts the prompt to use
                                        // more storage on Safari, this error will
                                        // be called.
                                        //
                                        // Try to re-run the transaction.
                                        if (retriesLeft > 0) {
                                            resolve(_setItem.apply(self1, [
                                                key,
                                                originalValue,
                                                callback,
                                                retriesLeft - 1
                                            ]));
                                            return;
                                        }
                                        reject(sqlError);
                                    }
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function setItem$1(key, value, callback) {
                    return _setItem.apply(this, [
                        key,
                        value,
                        callback,
                        1
                    ]);
                }
                function removeItem$1(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "DELETE FROM " + dbInfo.storeName + " WHERE key = ?", [
                                    key
                                ], function() {
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Deletes every item in the table.
                // TODO: Find out if this resets the AUTO_INCREMENT number.
                function clear$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "DELETE FROM " + dbInfo.storeName, [], function() {
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Does a simple `COUNT(key)` to get the number of items stored in
                // localForage.
                function length$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                // Ahhh, SQL makes this one soooooo easy.
                                tryExecuteSql(t, dbInfo, "SELECT COUNT(key) as c FROM " + dbInfo.storeName, [], function(t, results) {
                                    var result = results.rows.item(0).c;
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Return the key located at key index X; essentially gets the key from a
                // `WHERE id = ?`. This is the most efficient way I can think to implement
                // this rarely-used (in my experience) part of the API, but it can seem
                // inconsistent, because we do `INSERT OR REPLACE INTO` on `setItem()`, so
                // the ID of each key will change every time it's updated. Perhaps a stored
                // procedure for the `setItem()` SQL would solve this problem?
                // TODO: Don't change ID on `setItem()`.
                function key$1(n, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "SELECT key FROM " + dbInfo.storeName + " WHERE id = ? LIMIT 1", [
                                    n + 1
                                ], function(t, results) {
                                    var result = results.rows.length ? results.rows.item(0).key : null;
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "SELECT key FROM " + dbInfo.storeName, [], function(t, results) {
                                    var keys = [];
                                    for(var i = 0; i < results.rows.length; i++)keys.push(results.rows.item(i).key);
                                    resolve(keys);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // https://www.w3.org/TR/webdatabase/#databases
                // > There is no way to enumerate or delete the databases available for an origin from this API.
                function getAllStoreNames(db) {
                    return new Promise$1(function(resolve, reject) {
                        db.transaction(function(t) {
                            t.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function(t, results) {
                                var storeNames = [];
                                for(var i = 0; i < results.rows.length; i++)storeNames.push(results.rows.item(i).name);
                                resolve({
                                    db: db,
                                    storeNames: storeNames
                                });
                            }, function(t, error) {
                                reject(error);
                            });
                        }, function(sqlError) {
                            reject(sqlError);
                        });
                    });
                }
                function dropInstance$1(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    var currentConfig = this.config();
                    options = typeof options !== "function" && options || {};
                    if (!options.name) {
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject("Invalid arguments");
                    else promise = new Promise$1(function(resolve) {
                        var db;
                        if (options.name === currentConfig.name) // use the db reference of the current instance
                        db = self1._dbInfo.db;
                        else db = openDatabase(options.name, "", "", 0);
                        if (!options.storeName) // drop all database tables
                        resolve(getAllStoreNames(db));
                        else resolve({
                            db: db,
                            storeNames: [
                                options.storeName
                            ]
                        });
                    }).then(function(operationInfo) {
                        return new Promise$1(function(resolve, reject) {
                            operationInfo.db.transaction(function(t) {
                                function dropTable(storeName) {
                                    return new Promise$1(function(resolve, reject) {
                                        t.executeSql("DROP TABLE IF EXISTS " + storeName, [], function() {
                                            resolve();
                                        }, function(t, error) {
                                            reject(error);
                                        });
                                    });
                                }
                                var operations = [];
                                for(var i = 0, len = operationInfo.storeNames.length; i < len; i++)operations.push(dropTable(operationInfo.storeNames[i]));
                                Promise$1.all(operations).then(function() {
                                    resolve();
                                })["catch"](function(e) {
                                    reject(e);
                                });
                            }, function(sqlError) {
                                reject(sqlError);
                            });
                        });
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                var webSQLStorage = {
                    _driver: "webSQLStorage",
                    _initStorage: _initStorage$1,
                    _support: isWebSQLValid(),
                    iterate: iterate$1,
                    getItem: getItem$1,
                    setItem: setItem$1,
                    removeItem: removeItem$1,
                    clear: clear$1,
                    length: length$1,
                    key: key$1,
                    keys: keys$1,
                    dropInstance: dropInstance$1
                };
                function isLocalStorageValid() {
                    try {
                        return typeof localStorage !== "undefined" && "setItem" in localStorage && // in IE8 typeof localStorage.setItem === 'object'
                        !!localStorage.setItem;
                    } catch (e) {
                        return false;
                    }
                }
                function _getKeyPrefix(options, defaultConfig) {
                    var keyPrefix = options.name + "/";
                    if (options.storeName !== defaultConfig.storeName) keyPrefix += options.storeName + "/";
                    return keyPrefix;
                }
                // Check if localStorage throws when saving an item
                function checkIfLocalStorageThrows() {
                    var localStorageTestKey = "_localforage_support_test";
                    try {
                        localStorage.setItem(localStorageTestKey, true);
                        localStorage.removeItem(localStorageTestKey);
                        return false;
                    } catch (e) {
                        return true;
                    }
                }
                // Check if localStorage is usable and allows to save an item
                // This method checks if localStorage is usable in Safari Private Browsing
                // mode, or in any other case where the available quota for localStorage
                // is 0 and there wasn't any saved items yet.
                function _isLocalStorageUsable() {
                    return !checkIfLocalStorageThrows() || localStorage.length > 0;
                }
                // Config the localStorage backend, using options set in the config.
                function _initStorage$2(options) {
                    var self1 = this;
                    var dbInfo = {};
                    if (options) for(var i in options)dbInfo[i] = options[i];
                    dbInfo.keyPrefix = _getKeyPrefix(options, self1._defaultConfig);
                    if (!_isLocalStorageUsable()) return Promise$1.reject();
                    self1._dbInfo = dbInfo;
                    dbInfo.serializer = localforageSerializer;
                    return Promise$1.resolve();
                }
                // Remove all keys from the datastore, effectively destroying all data in
                // the app's key/value store!
                function clear$2(callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var keyPrefix = self1._dbInfo.keyPrefix;
                        for(var i = localStorage.length - 1; i >= 0; i--){
                            var key = localStorage.key(i);
                            if (key.indexOf(keyPrefix) === 0) localStorage.removeItem(key);
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Retrieve an item from the store. Unlike the original async_storage
                // library in Gaia, we don't modify return values at all. If a key's value
                // is `undefined`, we pass that value to the callback function.
                function getItem$2(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var result = localStorage.getItem(dbInfo.keyPrefix + key);
                        // If a result was found, parse it from the serialized
                        // string into a JS object. If result isn't truthy, the key
                        // is likely undefined and we'll pass it straight to the
                        // callback.
                        if (result) result = dbInfo.serializer.deserialize(result);
                        return result;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Iterate over all items in the store.
                function iterate$2(iterator, callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var keyPrefix = dbInfo.keyPrefix;
                        var keyPrefixLength = keyPrefix.length;
                        var length = localStorage.length;
                        // We use a dedicated iterator instead of the `i` variable below
                        // so other keys we fetch in localStorage aren't counted in
                        // the `iterationNumber` argument passed to the `iterate()`
                        // callback.
                        //
                        // See: github.com/mozilla/localForage/pull/435#discussion_r38061530
                        var iterationNumber = 1;
                        for(var i = 0; i < length; i++){
                            var key = localStorage.key(i);
                            if (key.indexOf(keyPrefix) !== 0) continue;
                            var value = localStorage.getItem(key);
                            // If a result was found, parse it from the serialized
                            // string into a JS object. If result isn't truthy, the
                            // key is likely undefined and we'll pass it straight
                            // to the iterator.
                            if (value) value = dbInfo.serializer.deserialize(value);
                            value = iterator(value, key.substring(keyPrefixLength), iterationNumber++);
                            if (value !== void 0) return value;
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Same as localStorage's key() method, except takes a callback.
                function key$2(n, callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var result;
                        try {
                            result = localStorage.key(n);
                        } catch (error) {
                            result = null;
                        }
                        // Remove the prefix from the key, if a key is found.
                        if (result) result = result.substring(dbInfo.keyPrefix.length);
                        return result;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys$2(callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var length = localStorage.length;
                        var keys = [];
                        for(var i = 0; i < length; i++){
                            var itemKey = localStorage.key(i);
                            if (itemKey.indexOf(dbInfo.keyPrefix) === 0) keys.push(itemKey.substring(dbInfo.keyPrefix.length));
                        }
                        return keys;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Supply the number of keys in the datastore to the callback function.
                function length$2(callback) {
                    var self1 = this;
                    var promise = self1.keys().then(function(keys) {
                        return keys.length;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Remove an item from the store, nice and simple.
                function removeItem$2(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        localStorage.removeItem(dbInfo.keyPrefix + key);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Set a key's value and run an optional callback once the value is set.
                // Unlike Gaia's implementation, the callback function is passed the value,
                // in case you want to operate on that value only after you're sure it
                // saved, or something like that.
                function setItem$2(key, value, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        // Convert undefined values to null.
                        // https://github.com/mozilla/localForage/pull/42
                        if (value === undefined) value = null;
                        // Save the original value to pass to the callback.
                        var originalValue = value;
                        return new Promise$1(function(resolve, reject) {
                            var dbInfo = self1._dbInfo;
                            dbInfo.serializer.serialize(value, function(value, error) {
                                if (error) reject(error);
                                else try {
                                    localStorage.setItem(dbInfo.keyPrefix + key, value);
                                    resolve(originalValue);
                                } catch (e) {
                                    // localStorage capacity exceeded.
                                    // TODO: Make this a specific error/event.
                                    if (e.name === "QuotaExceededError" || e.name === "NS_ERROR_DOM_QUOTA_REACHED") reject(e);
                                    reject(e);
                                }
                            });
                        });
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function dropInstance$2(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    options = typeof options !== "function" && options || {};
                    if (!options.name) {
                        var currentConfig = this.config();
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject("Invalid arguments");
                    else promise = new Promise$1(function(resolve) {
                        if (!options.storeName) resolve(options.name + "/");
                        else resolve(_getKeyPrefix(options, self1._defaultConfig));
                    }).then(function(keyPrefix) {
                        for(var i = localStorage.length - 1; i >= 0; i--){
                            var key = localStorage.key(i);
                            if (key.indexOf(keyPrefix) === 0) localStorage.removeItem(key);
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                var localStorageWrapper = {
                    _driver: "localStorageWrapper",
                    _initStorage: _initStorage$2,
                    _support: isLocalStorageValid(),
                    iterate: iterate$2,
                    getItem: getItem$2,
                    setItem: setItem$2,
                    removeItem: removeItem$2,
                    clear: clear$2,
                    length: length$2,
                    key: key$2,
                    keys: keys$2,
                    dropInstance: dropInstance$2
                };
                var sameValue = function sameValue(x, y) {
                    return x === y || typeof x === "number" && typeof y === "number" && isNaN(x) && isNaN(y);
                };
                var includes = function includes(array, searchElement) {
                    var len = array.length;
                    var i = 0;
                    while(i < len){
                        if (sameValue(array[i], searchElement)) return true;
                        i++;
                    }
                    return false;
                };
                var isArray = Array.isArray || function(arg) {
                    return Object.prototype.toString.call(arg) === "[object Array]";
                };
                // Drivers are stored here when `defineDriver()` is called.
                // They are shared across all instances of localForage.
                var DefinedDrivers = {};
                var DriverSupport = {};
                var DefaultDrivers = {
                    INDEXEDDB: asyncStorage,
                    WEBSQL: webSQLStorage,
                    LOCALSTORAGE: localStorageWrapper
                };
                var DefaultDriverOrder = [
                    DefaultDrivers.INDEXEDDB._driver,
                    DefaultDrivers.WEBSQL._driver,
                    DefaultDrivers.LOCALSTORAGE._driver
                ];
                var OptionalDriverMethods = [
                    "dropInstance"
                ];
                var LibraryMethods = [
                    "clear",
                    "getItem",
                    "iterate",
                    "key",
                    "keys",
                    "length",
                    "removeItem",
                    "setItem"
                ].concat(OptionalDriverMethods);
                var DefaultConfig = {
                    description: "",
                    driver: DefaultDriverOrder.slice(),
                    name: "localforage",
                    // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
                    // we can use without a prompt.
                    size: 4980736,
                    storeName: "keyvaluepairs",
                    version: 1.0
                };
                function callWhenReady(localForageInstance, libraryMethod) {
                    localForageInstance[libraryMethod] = function() {
                        var _args = arguments;
                        return localForageInstance.ready().then(function() {
                            return localForageInstance[libraryMethod].apply(localForageInstance, _args);
                        });
                    };
                }
                function extend() {
                    for(var i = 1; i < arguments.length; i++){
                        var arg = arguments[i];
                        if (arg) {
                            for(var _key in arg)if (arg.hasOwnProperty(_key)) {
                                if (isArray(arg[_key])) arguments[0][_key] = arg[_key].slice();
                                else arguments[0][_key] = arg[_key];
                            }
                        }
                    }
                    return arguments[0];
                }
                var LocalForage = function() {
                    function LocalForage(options) {
                        _classCallCheck(this, LocalForage);
                        for(var driverTypeKey in DefaultDrivers)if (DefaultDrivers.hasOwnProperty(driverTypeKey)) {
                            var driver = DefaultDrivers[driverTypeKey];
                            var driverName = driver._driver;
                            this[driverTypeKey] = driverName;
                            if (!DefinedDrivers[driverName]) // we don't need to wait for the promise,
                            // since the default drivers can be defined
                            // in a blocking manner
                            this.defineDriver(driver);
                        }
                        this._defaultConfig = extend({}, DefaultConfig);
                        this._config = extend({}, this._defaultConfig, options);
                        this._driverSet = null;
                        this._initDriver = null;
                        this._ready = false;
                        this._dbInfo = null;
                        this._wrapLibraryMethodsWithReady();
                        this.setDriver(this._config.driver)["catch"](function() {});
                    }
                    // Set any config values for localForage; can be called anytime before
                    // the first API call (e.g. `getItem`, `setItem`).
                    // We loop through options so we don't overwrite existing config
                    // values.
                    LocalForage.prototype.config = function config(options) {
                        // If the options argument is an object, we use it to set values.
                        // Otherwise, we return either a specified config value or all
                        // config values.
                        if ((typeof options === "undefined" ? "undefined" : _typeof(options)) === "object") {
                            // If localforage is ready and fully initialized, we can't set
                            // any new configuration values. Instead, we return an error.
                            if (this._ready) return new Error("Can't call config() after localforage has been used.");
                            for(var i in options){
                                if (i === "storeName") options[i] = options[i].replace(/\W/g, "_");
                                if (i === "version" && typeof options[i] !== "number") return new Error("Database version must be a number.");
                                this._config[i] = options[i];
                            }
                            // after all config options are set and
                            // the driver option is used, try setting it
                            if ("driver" in options && options.driver) return this.setDriver(this._config.driver);
                            return true;
                        } else if (typeof options === "string") return this._config[options];
                        else return this._config;
                    };
                    // Used to define a custom driver, shared across all instances of
                    // localForage.
                    LocalForage.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
                        var promise = new Promise$1(function(resolve, reject) {
                            try {
                                var driverName = driverObject._driver;
                                var complianceError = new Error("Custom driver not compliant; see https://mozilla.github.io/localForage/#definedriver");
                                // A driver name should be defined and not overlap with the
                                // library-defined, default drivers.
                                if (!driverObject._driver) {
                                    reject(complianceError);
                                    return;
                                }
                                var driverMethods = LibraryMethods.concat("_initStorage");
                                for(var i = 0, len = driverMethods.length; i < len; i++){
                                    var driverMethodName = driverMethods[i];
                                    // when the property is there,
                                    // it should be a method even when optional
                                    var isRequired = !includes(OptionalDriverMethods, driverMethodName);
                                    if ((isRequired || driverObject[driverMethodName]) && typeof driverObject[driverMethodName] !== "function") {
                                        reject(complianceError);
                                        return;
                                    }
                                }
                                var configureMissingMethods = function configureMissingMethods() {
                                    var methodNotImplementedFactory = function methodNotImplementedFactory(methodName) {
                                        return function() {
                                            var error = new Error("Method " + methodName + " is not implemented by the current driver");
                                            var promise = Promise$1.reject(error);
                                            executeCallback(promise, arguments[arguments.length - 1]);
                                            return promise;
                                        };
                                    };
                                    for(var _i = 0, _len = OptionalDriverMethods.length; _i < _len; _i++){
                                        var optionalDriverMethod = OptionalDriverMethods[_i];
                                        if (!driverObject[optionalDriverMethod]) driverObject[optionalDriverMethod] = methodNotImplementedFactory(optionalDriverMethod);
                                    }
                                };
                                configureMissingMethods();
                                var setDriverSupport = function setDriverSupport(support) {
                                    if (DefinedDrivers[driverName]) console.info("Redefining LocalForage driver: " + driverName);
                                    DefinedDrivers[driverName] = driverObject;
                                    DriverSupport[driverName] = support;
                                    // don't use a then, so that we can define
                                    // drivers that have simple _support methods
                                    // in a blocking manner
                                    resolve();
                                };
                                if ("_support" in driverObject) {
                                    if (driverObject._support && typeof driverObject._support === "function") driverObject._support().then(setDriverSupport, reject);
                                    else setDriverSupport(!!driverObject._support);
                                } else setDriverSupport(true);
                            } catch (e) {
                                reject(e);
                            }
                        });
                        executeTwoCallbacks(promise, callback, errorCallback);
                        return promise;
                    };
                    LocalForage.prototype.driver = function driver() {
                        return this._driver || null;
                    };
                    LocalForage.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
                        var getDriverPromise = DefinedDrivers[driverName] ? Promise$1.resolve(DefinedDrivers[driverName]) : Promise$1.reject(new Error("Driver not found."));
                        executeTwoCallbacks(getDriverPromise, callback, errorCallback);
                        return getDriverPromise;
                    };
                    LocalForage.prototype.getSerializer = function getSerializer(callback) {
                        var serializerPromise = Promise$1.resolve(localforageSerializer);
                        executeTwoCallbacks(serializerPromise, callback);
                        return serializerPromise;
                    };
                    LocalForage.prototype.ready = function ready(callback) {
                        var self1 = this;
                        var promise = self1._driverSet.then(function() {
                            if (self1._ready === null) self1._ready = self1._initDriver();
                            return self1._ready;
                        });
                        executeTwoCallbacks(promise, callback, callback);
                        return promise;
                    };
                    LocalForage.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
                        var self1 = this;
                        if (!isArray(drivers)) drivers = [
                            drivers
                        ];
                        var supportedDrivers = this._getSupportedDrivers(drivers);
                        function setDriverToConfig() {
                            self1._config.driver = self1.driver();
                        }
                        function extendSelfWithDriver(driver) {
                            self1._extend(driver);
                            setDriverToConfig();
                            self1._ready = self1._initStorage(self1._config);
                            return self1._ready;
                        }
                        function initDriver(supportedDrivers) {
                            return function() {
                                var currentDriverIndex = 0;
                                function driverPromiseLoop() {
                                    while(currentDriverIndex < supportedDrivers.length){
                                        var driverName = supportedDrivers[currentDriverIndex];
                                        currentDriverIndex++;
                                        self1._dbInfo = null;
                                        self1._ready = null;
                                        return self1.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
                                    }
                                    setDriverToConfig();
                                    var error = new Error("No available storage method found.");
                                    self1._driverSet = Promise$1.reject(error);
                                    return self1._driverSet;
                                }
                                return driverPromiseLoop();
                            };
                        }
                        // There might be a driver initialization in progress
                        // so wait for it to finish in order to avoid a possible
                        // race condition to set _dbInfo
                        var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function() {
                            return Promise$1.resolve();
                        }) : Promise$1.resolve();
                        this._driverSet = oldDriverSetDone.then(function() {
                            var driverName = supportedDrivers[0];
                            self1._dbInfo = null;
                            self1._ready = null;
                            return self1.getDriver(driverName).then(function(driver) {
                                self1._driver = driver._driver;
                                setDriverToConfig();
                                self1._wrapLibraryMethodsWithReady();
                                self1._initDriver = initDriver(supportedDrivers);
                            });
                        })["catch"](function() {
                            setDriverToConfig();
                            var error = new Error("No available storage method found.");
                            self1._driverSet = Promise$1.reject(error);
                            return self1._driverSet;
                        });
                        executeTwoCallbacks(this._driverSet, callback, errorCallback);
                        return this._driverSet;
                    };
                    LocalForage.prototype.supports = function supports(driverName) {
                        return !!DriverSupport[driverName];
                    };
                    LocalForage.prototype._extend = function _extend(libraryMethodsAndProperties) {
                        extend(this, libraryMethodsAndProperties);
                    };
                    LocalForage.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
                        var supportedDrivers = [];
                        for(var i = 0, len = drivers.length; i < len; i++){
                            var driverName = drivers[i];
                            if (this.supports(driverName)) supportedDrivers.push(driverName);
                        }
                        return supportedDrivers;
                    };
                    LocalForage.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
                        // Add a stub for each driver API method that delays the call to the
                        // corresponding driver method until localForage is ready. These stubs
                        // will be replaced by the driver methods as soon as the driver is
                        // loaded, so there is no performance impact.
                        for(var i = 0, len = LibraryMethods.length; i < len; i++)callWhenReady(this, LibraryMethods[i]);
                    };
                    LocalForage.prototype.createInstance = function createInstance(options) {
                        return new LocalForage(options);
                    };
                    return LocalForage;
                }();
                // The actual localForage object that we expose as a module or via a
                // global. It's extended by pulling in one of our other libraries.
                var localforage_js = new LocalForage();
                module1.exports = localforage_js;
            },
            {
                "3": 3
            }
        ]
    }, {}, [
        4
    ])(4);
});

});

parcelRegister("eBwNQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("eQdr1")).default; });
// ESM Exports
// ===========
// This module is the package entry point for ES module users. In other words,
// it is the module they are interfacing with when they import from the whole
// package instead of from a submodule, like this:
//
// ```js
// import { map } from 'underscore';
// ```
//
// The difference with `./index-default`, which is the package entry point for
// CommonJS, AMD and UMD users, is purely technical. In ES modules, named and
// default exports are considered to be siblings, so when you have a default
// export, its properties are not automatically available as named exports. For
// this reason, we re-export the named exports in addition to providing the same
// default export as in `./index-default`.

var $eQdr1 = parcelRequire("eQdr1");

var $iYtcb = parcelRequire("iYtcb");
$parcel$exportWildcard(module.exports, $iYtcb);

});
parcelRegister("eQdr1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ace057e7d83b11a1$export$2e2bcd8739ae039; });
// Default Export
// ==============
// In this module, we mix our bundled exports into the `_` object and export
// the result. This is analogous to setting `module.exports = _` in CommonJS.
// Hence, this module is also the entry point of our UMD bundle and the package
// entry point for CommonJS and AMD users. In other words, this is (the source
// of) the module you are interfacing with when you do any of the following:
//
// ```js
// // CommonJS
// var _ = require('underscore');
//
// // AMD
// define(['underscore'], function(_) {...});
//
// // UMD in the browser
// // _ is available as a global variable
// ```
parcelRequire("iYtcb");
var $2ta8m = parcelRequire("2ta8m");
var $iYtcb = parcelRequire("iYtcb");
// Add all of the Underscore functions to the wrapper object.
var $ace057e7d83b11a1$var$_ = (0, $2ta8m.default)($iYtcb);
// Legacy Node.js API.
$ace057e7d83b11a1$var$_._ = $ace057e7d83b11a1$var$_;
var // Export the Underscore API.
$ace057e7d83b11a1$export$2e2bcd8739ae039 = $ace057e7d83b11a1$var$_;

});
parcelRegister("iYtcb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "VERSION", function () { return (parcelRequire("5KeSn")).VERSION; });
$parcel$export(module.exports, "restArguments", function () { return (parcelRequire("8TlO7")).default; });
$parcel$export(module.exports, "isObject", function () { return (parcelRequire("6XIA0")).default; });
$parcel$export(module.exports, "isNull", function () { return (parcelRequire("k9Xx9")).default; });
$parcel$export(module.exports, "isUndefined", function () { return (parcelRequire("3Z7qj")).default; });
$parcel$export(module.exports, "isBoolean", function () { return (parcelRequire("im0Um")).default; });
$parcel$export(module.exports, "isElement", function () { return (parcelRequire("f94bL")).default; });
$parcel$export(module.exports, "isString", function () { return (parcelRequire("aqb1L")).default; });
$parcel$export(module.exports, "isNumber", function () { return (parcelRequire("2BziU")).default; });
$parcel$export(module.exports, "isDate", function () { return (parcelRequire("Edrdr")).default; });
$parcel$export(module.exports, "isRegExp", function () { return (parcelRequire("3QKZR")).default; });
$parcel$export(module.exports, "isError", function () { return (parcelRequire("8jxbI")).default; });
$parcel$export(module.exports, "isSymbol", function () { return (parcelRequire("deISq")).default; });
$parcel$export(module.exports, "isArrayBuffer", function () { return (parcelRequire("aDaCs")).default; });
$parcel$export(module.exports, "isDataView", function () { return (parcelRequire("7o1Uc")).default; });
$parcel$export(module.exports, "isArray", function () { return (parcelRequire("Xm84r")).default; });
$parcel$export(module.exports, "isFunction", function () { return (parcelRequire("kjJKW")).default; });
$parcel$export(module.exports, "isArguments", function () { return (parcelRequire("6ayCB")).default; });
$parcel$export(module.exports, "isFinite", function () { return (parcelRequire("cq31A")).default; });
$parcel$export(module.exports, "isNaN", function () { return (parcelRequire("cM3PS")).default; });
$parcel$export(module.exports, "isTypedArray", function () { return (parcelRequire("jdigr")).default; });
$parcel$export(module.exports, "isEmpty", function () { return (parcelRequire("dMukD")).default; });
$parcel$export(module.exports, "isMatch", function () { return (parcelRequire("h6EGc")).default; });
$parcel$export(module.exports, "isEqual", function () { return (parcelRequire("6X1WT")).default; });
$parcel$export(module.exports, "isMap", function () { return (parcelRequire("8zgy2")).default; });
$parcel$export(module.exports, "isWeakMap", function () { return (parcelRequire("6UTCX")).default; });
$parcel$export(module.exports, "isSet", function () { return (parcelRequire("4JnNS")).default; });
$parcel$export(module.exports, "isWeakSet", function () { return (parcelRequire("kBtPk")).default; });
$parcel$export(module.exports, "keys", function () { return (parcelRequire("1zKwG")).default; });
$parcel$export(module.exports, "allKeys", function () { return (parcelRequire("etFkK")).default; });
$parcel$export(module.exports, "values", function () { return (parcelRequire("iFTFB")).default; });
$parcel$export(module.exports, "pairs", function () { return (parcelRequire("bOJwb")).default; });
$parcel$export(module.exports, "invert", function () { return (parcelRequire("bhxHW")).default; });
$parcel$export(module.exports, "functions", function () { return (parcelRequire("bPMbE")).default; });
$parcel$export(module.exports, "methods", function () { return (parcelRequire("bPMbE")).default; });
$parcel$export(module.exports, "extend", function () { return (parcelRequire("1QL2S")).default; });
$parcel$export(module.exports, "extendOwn", function () { return (parcelRequire("8SVbN")).default; });
$parcel$export(module.exports, "assign", function () { return (parcelRequire("8SVbN")).default; });
$parcel$export(module.exports, "defaults", function () { return (parcelRequire("1td8m")).default; });
$parcel$export(module.exports, "create", function () { return (parcelRequire("l3YM2")).default; });
$parcel$export(module.exports, "clone", function () { return (parcelRequire("6wkBh")).default; });
$parcel$export(module.exports, "tap", function () { return (parcelRequire("jHs5V")).default; });
$parcel$export(module.exports, "get", function () { return (parcelRequire("2ZYMz")).default; });
$parcel$export(module.exports, "has", function () { return (parcelRequire("kriVr")).default; });
$parcel$export(module.exports, "mapObject", function () { return (parcelRequire("9A40z")).default; });
$parcel$export(module.exports, "identity", function () { return (parcelRequire("ij1x5")).default; });
$parcel$export(module.exports, "constant", function () { return (parcelRequire("599Q4")).default; });
$parcel$export(module.exports, "noop", function () { return (parcelRequire("evJbb")).default; });
$parcel$export(module.exports, "toPath", function () { return (parcelRequire("leUcU")).default; });
$parcel$export(module.exports, "property", function () { return (parcelRequire("eJHpe")).default; });
$parcel$export(module.exports, "propertyOf", function () { return (parcelRequire("8eSnW")).default; });
$parcel$export(module.exports, "matcher", function () { return (parcelRequire("hHQBy")).default; });
$parcel$export(module.exports, "matches", function () { return (parcelRequire("hHQBy")).default; });
$parcel$export(module.exports, "times", function () { return (parcelRequire("eTRPP")).default; });
$parcel$export(module.exports, "random", function () { return (parcelRequire("hUFLW")).default; });
$parcel$export(module.exports, "now", function () { return (parcelRequire("3GTqQ")).default; });
$parcel$export(module.exports, "escape", function () { return (parcelRequire("ia0zu")).default; });
$parcel$export(module.exports, "unescape", function () { return (parcelRequire("1lKme")).default; });
$parcel$export(module.exports, "templateSettings", function () { return (parcelRequire("3KOuU")).default; });
$parcel$export(module.exports, "template", function () { return (parcelRequire("6YDyV")).default; });
$parcel$export(module.exports, "result", function () { return (parcelRequire("cmzDU")).default; });
$parcel$export(module.exports, "uniqueId", function () { return (parcelRequire("3yItJ")).default; });
$parcel$export(module.exports, "chain", function () { return (parcelRequire("bYKQN")).default; });
$parcel$export(module.exports, "iteratee", function () { return (parcelRequire("9s0gR")).default; });
$parcel$export(module.exports, "partial", function () { return (parcelRequire("kVosQ")).default; });
$parcel$export(module.exports, "bind", function () { return (parcelRequire("bavbx")).default; });
$parcel$export(module.exports, "bindAll", function () { return (parcelRequire("2hK4S")).default; });
$parcel$export(module.exports, "memoize", function () { return (parcelRequire("dUAVF")).default; });
$parcel$export(module.exports, "delay", function () { return (parcelRequire("co9Dj")).default; });
$parcel$export(module.exports, "defer", function () { return (parcelRequire("2yhZb")).default; });
$parcel$export(module.exports, "throttle", function () { return (parcelRequire("3THiL")).default; });
$parcel$export(module.exports, "debounce", function () { return (parcelRequire("djXe0")).default; });
$parcel$export(module.exports, "wrap", function () { return (parcelRequire("5cS8P")).default; });
$parcel$export(module.exports, "negate", function () { return (parcelRequire("ieCTN")).default; });
$parcel$export(module.exports, "compose", function () { return (parcelRequire("829FO")).default; });
$parcel$export(module.exports, "after", function () { return (parcelRequire("cBSIx")).default; });
$parcel$export(module.exports, "before", function () { return (parcelRequire("b0Xuc")).default; });
$parcel$export(module.exports, "once", function () { return (parcelRequire("4a26e")).default; });
$parcel$export(module.exports, "findKey", function () { return (parcelRequire("cBH4D")).default; });
$parcel$export(module.exports, "findIndex", function () { return (parcelRequire("d15Zo")).default; });
$parcel$export(module.exports, "findLastIndex", function () { return (parcelRequire("5MrLm")).default; });
$parcel$export(module.exports, "sortedIndex", function () { return (parcelRequire("2wd0A")).default; });
$parcel$export(module.exports, "indexOf", function () { return (parcelRequire("h9aLf")).default; });
$parcel$export(module.exports, "lastIndexOf", function () { return (parcelRequire("iTqrX")).default; });
$parcel$export(module.exports, "find", function () { return (parcelRequire("7ayue")).default; });
$parcel$export(module.exports, "detect", function () { return (parcelRequire("7ayue")).default; });
$parcel$export(module.exports, "findWhere", function () { return (parcelRequire("duO4b")).default; });
$parcel$export(module.exports, "each", function () { return (parcelRequire("kQFPC")).default; });
$parcel$export(module.exports, "forEach", function () { return (parcelRequire("kQFPC")).default; });
$parcel$export(module.exports, "map", function () { return (parcelRequire("cFwSY")).default; });
$parcel$export(module.exports, "collect", function () { return (parcelRequire("cFwSY")).default; });
$parcel$export(module.exports, "reduce", function () { return (parcelRequire("fVJXz")).default; });
$parcel$export(module.exports, "foldl", function () { return (parcelRequire("fVJXz")).default; });
$parcel$export(module.exports, "inject", function () { return (parcelRequire("fVJXz")).default; });
$parcel$export(module.exports, "reduceRight", function () { return (parcelRequire("k63yi")).default; });
$parcel$export(module.exports, "foldr", function () { return (parcelRequire("k63yi")).default; });
$parcel$export(module.exports, "filter", function () { return (parcelRequire("aUKYr")).default; });
$parcel$export(module.exports, "select", function () { return (parcelRequire("aUKYr")).default; });
$parcel$export(module.exports, "reject", function () { return (parcelRequire("dOatp")).default; });
$parcel$export(module.exports, "every", function () { return (parcelRequire("kbolk")).default; });
$parcel$export(module.exports, "all", function () { return (parcelRequire("kbolk")).default; });
$parcel$export(module.exports, "some", function () { return (parcelRequire("6kYAr")).default; });
$parcel$export(module.exports, "any", function () { return (parcelRequire("6kYAr")).default; });
$parcel$export(module.exports, "contains", function () { return (parcelRequire("3YEvF")).default; });
$parcel$export(module.exports, "includes", function () { return (parcelRequire("3YEvF")).default; });
$parcel$export(module.exports, "include", function () { return (parcelRequire("3YEvF")).default; });
$parcel$export(module.exports, "invoke", function () { return (parcelRequire("1ZREC")).default; });
$parcel$export(module.exports, "pluck", function () { return (parcelRequire("1RCtE")).default; });
$parcel$export(module.exports, "where", function () { return (parcelRequire("8SOrD")).default; });
$parcel$export(module.exports, "max", function () { return (parcelRequire("8QPB7")).default; });
$parcel$export(module.exports, "min", function () { return (parcelRequire("6Cfc8")).default; });
$parcel$export(module.exports, "shuffle", function () { return (parcelRequire("3maiM")).default; });
$parcel$export(module.exports, "sample", function () { return (parcelRequire("2zH6x")).default; });
$parcel$export(module.exports, "sortBy", function () { return (parcelRequire("izwKy")).default; });
$parcel$export(module.exports, "groupBy", function () { return (parcelRequire("5lFy2")).default; });
$parcel$export(module.exports, "indexBy", function () { return (parcelRequire("emt8q")).default; });
$parcel$export(module.exports, "countBy", function () { return (parcelRequire("4xqB9")).default; });
$parcel$export(module.exports, "partition", function () { return (parcelRequire("deiC4")).default; });
$parcel$export(module.exports, "toArray", function () { return (parcelRequire("9EoGr")).default; });
$parcel$export(module.exports, "size", function () { return (parcelRequire("ec5Ki")).default; });
$parcel$export(module.exports, "pick", function () { return (parcelRequire("lsaWo")).default; });
$parcel$export(module.exports, "omit", function () { return (parcelRequire("adWEn")).default; });
$parcel$export(module.exports, "first", function () { return (parcelRequire("kAIok")).default; });
$parcel$export(module.exports, "head", function () { return (parcelRequire("kAIok")).default; });
$parcel$export(module.exports, "take", function () { return (parcelRequire("kAIok")).default; });
$parcel$export(module.exports, "initial", function () { return (parcelRequire("6UB42")).default; });
$parcel$export(module.exports, "last", function () { return (parcelRequire("cbjL2")).default; });
$parcel$export(module.exports, "rest", function () { return (parcelRequire("cNTA9")).default; });
$parcel$export(module.exports, "tail", function () { return (parcelRequire("cNTA9")).default; });
$parcel$export(module.exports, "drop", function () { return (parcelRequire("cNTA9")).default; });
$parcel$export(module.exports, "compact", function () { return (parcelRequire("gbwCl")).default; });
$parcel$export(module.exports, "flatten", function () { return (parcelRequire("fJVwF")).default; });
$parcel$export(module.exports, "without", function () { return (parcelRequire("7AzB2")).default; });
$parcel$export(module.exports, "uniq", function () { return (parcelRequire("4QOES")).default; });
$parcel$export(module.exports, "unique", function () { return (parcelRequire("4QOES")).default; });
$parcel$export(module.exports, "union", function () { return (parcelRequire("e3v1E")).default; });
$parcel$export(module.exports, "intersection", function () { return (parcelRequire("jBZcO")).default; });
$parcel$export(module.exports, "difference", function () { return (parcelRequire("4p1j6")).default; });
$parcel$export(module.exports, "unzip", function () { return (parcelRequire("j50f9")).default; });
$parcel$export(module.exports, "transpose", function () { return (parcelRequire("j50f9")).default; });
$parcel$export(module.exports, "zip", function () { return (parcelRequire("1Pr39")).default; });
$parcel$export(module.exports, "object", function () { return (parcelRequire("7CkIw")).default; });
$parcel$export(module.exports, "range", function () { return (parcelRequire("e0VLE")).default; });
$parcel$export(module.exports, "chunk", function () { return (parcelRequire("l0iKy")).default; });
$parcel$export(module.exports, "mixin", function () { return (parcelRequire("2ta8m")).default; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("h9p7q")).default; });
// Named Exports
// =============
//     Underscore.js 1.13.7
//     https://underscorejs.org
//     (c) 2009-2024 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.
// Baseline setup.

var $5KeSn = parcelRequire("5KeSn");

var $8TlO7 = parcelRequire("8TlO7");

var $6XIA0 = parcelRequire("6XIA0");

var $k9Xx9 = parcelRequire("k9Xx9");

var $3Z7qj = parcelRequire("3Z7qj");

var $im0Um = parcelRequire("im0Um");

var $f94bL = parcelRequire("f94bL");

var $aqb1L = parcelRequire("aqb1L");

var $2BziU = parcelRequire("2BziU");

var $Edrdr = parcelRequire("Edrdr");

var $3QKZR = parcelRequire("3QKZR");

var $8jxbI = parcelRequire("8jxbI");

var $deISq = parcelRequire("deISq");

var $aDaCs = parcelRequire("aDaCs");

var $7o1Uc = parcelRequire("7o1Uc");

var $Xm84r = parcelRequire("Xm84r");

var $kjJKW = parcelRequire("kjJKW");

var $6ayCB = parcelRequire("6ayCB");

var $cq31A = parcelRequire("cq31A");

var $cM3PS = parcelRequire("cM3PS");

var $jdigr = parcelRequire("jdigr");

var $dMukD = parcelRequire("dMukD");

var $h6EGc = parcelRequire("h6EGc");

var $6X1WT = parcelRequire("6X1WT");

var $8zgy2 = parcelRequire("8zgy2");

var $6UTCX = parcelRequire("6UTCX");

var $4JnNS = parcelRequire("4JnNS");

var $kBtPk = parcelRequire("kBtPk");

var $1zKwG = parcelRequire("1zKwG");

var $etFkK = parcelRequire("etFkK");

var $iFTFB = parcelRequire("iFTFB");

var $bOJwb = parcelRequire("bOJwb");

var $bhxHW = parcelRequire("bhxHW");

var $bPMbE = parcelRequire("bPMbE");

var $1QL2S = parcelRequire("1QL2S");

var $8SVbN = parcelRequire("8SVbN");

var $1td8m = parcelRequire("1td8m");

var $l3YM2 = parcelRequire("l3YM2");

var $6wkBh = parcelRequire("6wkBh");

var $jHs5V = parcelRequire("jHs5V");

var $2ZYMz = parcelRequire("2ZYMz");

var $kriVr = parcelRequire("kriVr");

var $9A40z = parcelRequire("9A40z");

var $ij1x5 = parcelRequire("ij1x5");

var $599Q4 = parcelRequire("599Q4");

var $evJbb = parcelRequire("evJbb");

var $leUcU = parcelRequire("leUcU");

var $eJHpe = parcelRequire("eJHpe");

var $8eSnW = parcelRequire("8eSnW");

var $hHQBy = parcelRequire("hHQBy");

var $eTRPP = parcelRequire("eTRPP");

var $hUFLW = parcelRequire("hUFLW");

var $3GTqQ = parcelRequire("3GTqQ");

var $ia0zu = parcelRequire("ia0zu");

var $1lKme = parcelRequire("1lKme");

var $3KOuU = parcelRequire("3KOuU");

var $6YDyV = parcelRequire("6YDyV");

var $cmzDU = parcelRequire("cmzDU");

var $3yItJ = parcelRequire("3yItJ");

var $bYKQN = parcelRequire("bYKQN");

var $9s0gR = parcelRequire("9s0gR");

var $kVosQ = parcelRequire("kVosQ");

var $bavbx = parcelRequire("bavbx");

var $2hK4S = parcelRequire("2hK4S");

var $dUAVF = parcelRequire("dUAVF");

var $co9Dj = parcelRequire("co9Dj");

var $2yhZb = parcelRequire("2yhZb");

var $3THiL = parcelRequire("3THiL");

var $djXe0 = parcelRequire("djXe0");

var $5cS8P = parcelRequire("5cS8P");

var $ieCTN = parcelRequire("ieCTN");

var $829FO = parcelRequire("829FO");

var $cBSIx = parcelRequire("cBSIx");

var $b0Xuc = parcelRequire("b0Xuc");

var $4a26e = parcelRequire("4a26e");

var $cBH4D = parcelRequire("cBH4D");

var $d15Zo = parcelRequire("d15Zo");

var $5MrLm = parcelRequire("5MrLm");

var $2wd0A = parcelRequire("2wd0A");

var $h9aLf = parcelRequire("h9aLf");

var $iTqrX = parcelRequire("iTqrX");

var $7ayue = parcelRequire("7ayue");

var $duO4b = parcelRequire("duO4b");

var $kQFPC = parcelRequire("kQFPC");

var $cFwSY = parcelRequire("cFwSY");

var $fVJXz = parcelRequire("fVJXz");

var $k63yi = parcelRequire("k63yi");

var $aUKYr = parcelRequire("aUKYr");

var $dOatp = parcelRequire("dOatp");

var $kbolk = parcelRequire("kbolk");

var $6kYAr = parcelRequire("6kYAr");

var $3YEvF = parcelRequire("3YEvF");

var $1ZREC = parcelRequire("1ZREC");

var $1RCtE = parcelRequire("1RCtE");

var $8SOrD = parcelRequire("8SOrD");

var $8QPB7 = parcelRequire("8QPB7");

var $6Cfc8 = parcelRequire("6Cfc8");

var $3maiM = parcelRequire("3maiM");

var $2zH6x = parcelRequire("2zH6x");

var $izwKy = parcelRequire("izwKy");

var $5lFy2 = parcelRequire("5lFy2");

var $emt8q = parcelRequire("emt8q");

var $4xqB9 = parcelRequire("4xqB9");

var $deiC4 = parcelRequire("deiC4");

var $9EoGr = parcelRequire("9EoGr");

var $ec5Ki = parcelRequire("ec5Ki");

var $lsaWo = parcelRequire("lsaWo");

var $adWEn = parcelRequire("adWEn");

var $kAIok = parcelRequire("kAIok");

var $6UB42 = parcelRequire("6UB42");

var $cbjL2 = parcelRequire("cbjL2");

var $cNTA9 = parcelRequire("cNTA9");

var $gbwCl = parcelRequire("gbwCl");

var $fJVwF = parcelRequire("fJVwF");

var $7AzB2 = parcelRequire("7AzB2");

var $4QOES = parcelRequire("4QOES");

var $e3v1E = parcelRequire("e3v1E");

var $jBZcO = parcelRequire("jBZcO");

var $4p1j6 = parcelRequire("4p1j6");

var $j50f9 = parcelRequire("j50f9");

var $1Pr39 = parcelRequire("1Pr39");

var $7CkIw = parcelRequire("7CkIw");

var $e0VLE = parcelRequire("e0VLE");

var $l0iKy = parcelRequire("l0iKy");

var $2ta8m = parcelRequire("2ta8m");

var $h9p7q = parcelRequire("h9p7q");

});
parcelRegister("5KeSn", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $42ecc9b0b1c81e92$export$a4ad2735b021c132; });
$parcel$export(module.exports, "root", function () { return $42ecc9b0b1c81e92$export$e8e78c978b129247; });
$parcel$export(module.exports, "ArrayProto", function () { return $42ecc9b0b1c81e92$export$aabeece9448a227a; });
$parcel$export(module.exports, "ObjProto", function () { return $42ecc9b0b1c81e92$export$e77bb59b5e655b3d; });
$parcel$export(module.exports, "SymbolProto", function () { return $42ecc9b0b1c81e92$export$e229dcb397ceea81; });
$parcel$export(module.exports, "push", function () { return $42ecc9b0b1c81e92$export$4cbf152802aa238; });
$parcel$export(module.exports, "slice", function () { return $42ecc9b0b1c81e92$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "toString", function () { return $42ecc9b0b1c81e92$export$f84e8e69fd4488a5; });
$parcel$export(module.exports, "hasOwnProperty", function () { return $42ecc9b0b1c81e92$export$5a15a386532a5ea4; });
$parcel$export(module.exports, "supportsArrayBuffer", function () { return $42ecc9b0b1c81e92$export$20eaf89d899ede58; });
$parcel$export(module.exports, "supportsDataView", function () { return $42ecc9b0b1c81e92$export$a2e478ad34dac33e; });
$parcel$export(module.exports, "nativeIsArray", function () { return $42ecc9b0b1c81e92$export$552cf9b635cef256; });
$parcel$export(module.exports, "nativeKeys", function () { return $42ecc9b0b1c81e92$export$e676cf06d7fd2114; });
$parcel$export(module.exports, "nativeCreate", function () { return $42ecc9b0b1c81e92$export$5b53dc95b548c58c; });
$parcel$export(module.exports, "nativeIsView", function () { return $42ecc9b0b1c81e92$export$35fc70fc5e80d5a7; });
$parcel$export(module.exports, "_isNaN", function () { return $42ecc9b0b1c81e92$export$a739ba33a90be0a1; });
$parcel$export(module.exports, "_isFinite", function () { return $42ecc9b0b1c81e92$export$8b48b92f6c9d5ad; });
$parcel$export(module.exports, "hasEnumBug", function () { return $42ecc9b0b1c81e92$export$7dcea4d27900b116; });
$parcel$export(module.exports, "nonEnumerableProps", function () { return $42ecc9b0b1c81e92$export$f8fa596d5e31cb19; });
$parcel$export(module.exports, "MAX_ARRAY_INDEX", function () { return $42ecc9b0b1c81e92$export$63b3abc5cd28bc48; });
// Current version.
var $42ecc9b0b1c81e92$export$a4ad2735b021c132 = "1.13.7";
var $42ecc9b0b1c81e92$export$e8e78c978b129247 = typeof self == "object" && self.self === self && self || typeof $parcel$global == "object" && $parcel$global.global === $parcel$global && $parcel$global || Function("return this")() || {};
var $42ecc9b0b1c81e92$export$aabeece9448a227a = Array.prototype, $42ecc9b0b1c81e92$export$e77bb59b5e655b3d = Object.prototype;
var $42ecc9b0b1c81e92$export$e229dcb397ceea81 = typeof Symbol !== "undefined" ? Symbol.prototype : null;
var $42ecc9b0b1c81e92$export$4cbf152802aa238 = $42ecc9b0b1c81e92$export$aabeece9448a227a.push, $42ecc9b0b1c81e92$export$58adb3bec8346d0f = $42ecc9b0b1c81e92$export$aabeece9448a227a.slice, $42ecc9b0b1c81e92$export$f84e8e69fd4488a5 = $42ecc9b0b1c81e92$export$e77bb59b5e655b3d.toString, $42ecc9b0b1c81e92$export$5a15a386532a5ea4 = $42ecc9b0b1c81e92$export$e77bb59b5e655b3d.hasOwnProperty;
var $42ecc9b0b1c81e92$export$20eaf89d899ede58 = typeof ArrayBuffer !== "undefined", $42ecc9b0b1c81e92$export$a2e478ad34dac33e = typeof DataView !== "undefined";
var $42ecc9b0b1c81e92$export$552cf9b635cef256 = Array.isArray, $42ecc9b0b1c81e92$export$e676cf06d7fd2114 = Object.keys, $42ecc9b0b1c81e92$export$5b53dc95b548c58c = Object.create, $42ecc9b0b1c81e92$export$35fc70fc5e80d5a7 = $42ecc9b0b1c81e92$export$20eaf89d899ede58 && ArrayBuffer.isView;
var $42ecc9b0b1c81e92$export$a739ba33a90be0a1 = isNaN, $42ecc9b0b1c81e92$export$8b48b92f6c9d5ad = isFinite;
var $42ecc9b0b1c81e92$export$7dcea4d27900b116 = !({
    toString: null
}).propertyIsEnumerable("toString");
var $42ecc9b0b1c81e92$export$f8fa596d5e31cb19 = [
    "valueOf",
    "isPrototypeOf",
    "toString",
    "propertyIsEnumerable",
    "hasOwnProperty",
    "toLocaleString"
];
var $42ecc9b0b1c81e92$export$63b3abc5cd28bc48 = Math.pow(2, 53) - 1;

});

parcelRegister("8TlO7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $679460454e343720$export$2e2bcd8739ae039; });
// Some functions take a variable number of arguments, or a few expected
// arguments at the beginning and then a variable number of values to operate
// on. This helper accumulates all remaining arguments past the function’s
// argument length (or an explicit `startIndex`), into an array that becomes
// the last argument. Similar to ES6’s "rest parameter".
function $679460454e343720$export$2e2bcd8739ae039(func, startIndex) {
    startIndex = startIndex == null ? func.length - 1 : +startIndex;
    return function() {
        var length = Math.max(arguments.length - startIndex, 0), rest = Array(length), index = 0;
        for(; index < length; index++)rest[index] = arguments[index + startIndex];
        switch(startIndex){
            case 0:
                return func.call(this, rest);
            case 1:
                return func.call(this, arguments[0], rest);
            case 2:
                return func.call(this, arguments[0], arguments[1], rest);
        }
        var args = Array(startIndex + 1);
        for(index = 0; index < startIndex; index++)args[index] = arguments[index];
        args[startIndex] = rest;
        return func.apply(this, args);
    };
}

});

parcelRegister("6XIA0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $511ad55a21dca799$export$2e2bcd8739ae039; });
// Is a given variable an object?
function $511ad55a21dca799$export$2e2bcd8739ae039(obj) {
    var type = typeof obj;
    return type === "function" || type === "object" && !!obj;
}

});

parcelRegister("k9Xx9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ead2d40e294832aa$export$2e2bcd8739ae039; });
// Is a given value equal to null?
function $ead2d40e294832aa$export$2e2bcd8739ae039(obj) {
    return obj === null;
}

});

parcelRegister("3Z7qj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e6cd3b9b0cf072d$export$2e2bcd8739ae039; });
// Is a given variable undefined?
function $2e6cd3b9b0cf072d$export$2e2bcd8739ae039(obj) {
    return obj === void 0;
}

});

parcelRegister("im0Um", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5cafc62b27f3c3b$export$2e2bcd8739ae039; });

var $5KeSn = parcelRequire("5KeSn");
function $d5cafc62b27f3c3b$export$2e2bcd8739ae039(obj) {
    return obj === true || obj === false || (0, $5KeSn.toString).call(obj) === "[object Boolean]";
}

});

parcelRegister("f94bL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b06af210aec23623$export$2e2bcd8739ae039; });
// Is a given value a DOM element?
function $b06af210aec23623$export$2e2bcd8739ae039(obj) {
    return !!(obj && obj.nodeType === 1);
}

});

parcelRegister("aqb1L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7964e2e86c7a5542$export$2e2bcd8739ae039; });

var $82c6s = parcelRequire("82c6s");
var $7964e2e86c7a5542$export$2e2bcd8739ae039 = (0, $82c6s.default)("String");

});
parcelRegister("82c6s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01827331bdc2953c$export$2e2bcd8739ae039; });

var $5KeSn = parcelRequire("5KeSn");
function $01827331bdc2953c$export$2e2bcd8739ae039(name) {
    var tag = "[object " + name + "]";
    return function(obj) {
        return (0, $5KeSn.toString).call(obj) === tag;
    };
}

});


parcelRegister("2BziU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e5a6c1ce294b741$export$2e2bcd8739ae039; });

var $82c6s = parcelRequire("82c6s");
var $1e5a6c1ce294b741$export$2e2bcd8739ae039 = (0, $82c6s.default)("Number");

});

parcelRegister("Edrdr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $078e290a8cbd46f3$export$2e2bcd8739ae039; });

var $82c6s = parcelRequire("82c6s");
var $078e290a8cbd46f3$export$2e2bcd8739ae039 = (0, $82c6s.default)("Date");

});

parcelRegister("3QKZR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2cdaaf045bb1cc69$export$2e2bcd8739ae039; });

var $82c6s = parcelRequire("82c6s");
var $2cdaaf045bb1cc69$export$2e2bcd8739ae039 = (0, $82c6s.default)("RegExp");

});

parcelRegister("8jxbI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60d9d788434bf4bf$export$2e2bcd8739ae039; });

var $82c6s = parcelRequire("82c6s");
var $60d9d788434bf4bf$export$2e2bcd8739ae039 = (0, $82c6s.default)("Error");

});

parcelRegister("deISq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a2f64c21fc22488$export$2e2bcd8739ae039; });

var $82c6s = parcelRequire("82c6s");
var $9a2f64c21fc22488$export$2e2bcd8739ae039 = (0, $82c6s.default)("Symbol");

});

parcelRegister("aDaCs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7bd5c8a922396728$export$2e2bcd8739ae039; });

var $82c6s = parcelRequire("82c6s");
var $7bd5c8a922396728$export$2e2bcd8739ae039 = (0, $82c6s.default)("ArrayBuffer");

});

parcelRegister("7o1Uc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $560c40a9fae39c5c$export$2e2bcd8739ae039; });

var $82c6s = parcelRequire("82c6s");

var $kjJKW = parcelRequire("kjJKW");

var $aDaCs = parcelRequire("aDaCs");

var $5ByTL = parcelRequire("5ByTL");
var $560c40a9fae39c5c$var$isDataView = (0, $82c6s.default)("DataView");
// In IE 10 - Edge 13, we need a different heuristic
// to determine whether an object is a `DataView`.
// Also, in cases where the native `DataView` is
// overridden we can't rely on the tag itself.
function $560c40a9fae39c5c$var$alternateIsDataView(obj) {
    return obj != null && (0, $kjJKW.default)(obj.getInt8) && (0, $aDaCs.default)(obj.buffer);
}
var $560c40a9fae39c5c$export$2e2bcd8739ae039 = (0, $5ByTL.hasDataViewBug) ? $560c40a9fae39c5c$var$alternateIsDataView : $560c40a9fae39c5c$var$isDataView;

});
parcelRegister("kjJKW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eca9132f334065ac$export$2e2bcd8739ae039; });

var $82c6s = parcelRequire("82c6s");

var $5KeSn = parcelRequire("5KeSn");
var $eca9132f334065ac$var$isFunction = (0, $82c6s.default)("Function");
// Optimize `isFunction` if appropriate. Work around some `typeof` bugs in old
// v8, IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
var $eca9132f334065ac$var$nodelist = (0, $5KeSn.root).document && (0, $5KeSn.root).document.childNodes;
if (typeof /./ != "function" && typeof Int8Array != "object" && typeof $eca9132f334065ac$var$nodelist != "function") $eca9132f334065ac$var$isFunction = function(obj) {
    return typeof obj == "function" || false;
};
var $eca9132f334065ac$export$2e2bcd8739ae039 = $eca9132f334065ac$var$isFunction;

});

parcelRegister("5ByTL", function(module, exports) {

$parcel$export(module.exports, "hasDataViewBug", function () { return $414b7a89fc9c9112$export$29b9ed4126fa90ab; });
$parcel$export(module.exports, "isIE11", function () { return $414b7a89fc9c9112$export$f7bad96d83325a34; });

var $5KeSn = parcelRequire("5KeSn");

var $65yDP = parcelRequire("65yDP");
var $414b7a89fc9c9112$export$29b9ed4126fa90ab = (0, $5KeSn.supportsDataView) && (!/\[native code\]/.test(String(DataView)) || (0, $65yDP.default)(new DataView(new ArrayBuffer(8)))), $414b7a89fc9c9112$export$f7bad96d83325a34 = typeof Map !== "undefined" && (0, $65yDP.default)(new Map);

});
parcelRegister("65yDP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46ee14c8d35ab288$export$2e2bcd8739ae039; });

var $82c6s = parcelRequire("82c6s");
var $46ee14c8d35ab288$export$2e2bcd8739ae039 = (0, $82c6s.default)("Object");

});



parcelRegister("Xm84r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b26ad321c56f559$export$2e2bcd8739ae039; });

var $5KeSn = parcelRequire("5KeSn");

var $82c6s = parcelRequire("82c6s");
var // Is a given value an array?
// Delegates to ECMA5's native `Array.isArray`.
$0b26ad321c56f559$export$2e2bcd8739ae039 = (0, $5KeSn.nativeIsArray) || (0, $82c6s.default)("Array");

});

parcelRegister("6ayCB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47de88671a86db0d$export$2e2bcd8739ae039; });

var $82c6s = parcelRequire("82c6s");

var $6AQqY = parcelRequire("6AQqY");
var $47de88671a86db0d$var$isArguments = (0, $82c6s.default)("Arguments");
// Define a fallback version of the method in browsers (ahem, IE < 9), where
// there isn't any inspectable "Arguments" type.
(function() {
    if (!$47de88671a86db0d$var$isArguments(arguments)) $47de88671a86db0d$var$isArguments = function(obj) {
        return (0, $6AQqY.default)(obj, "callee");
    };
})();
var $47de88671a86db0d$export$2e2bcd8739ae039 = $47de88671a86db0d$var$isArguments;

});
parcelRegister("6AQqY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ccec729c025a430$export$2e2bcd8739ae039; });

var $5KeSn = parcelRequire("5KeSn");
function $4ccec729c025a430$export$2e2bcd8739ae039(obj, key) {
    return obj != null && (0, $5KeSn.hasOwnProperty).call(obj, key);
}

});


parcelRegister("cq31A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $90aa4262e058ce70$export$2e2bcd8739ae039; });

var $5KeSn = parcelRequire("5KeSn");

var $deISq = parcelRequire("deISq");
function $90aa4262e058ce70$export$2e2bcd8739ae039(obj) {
    return !(0, $deISq.default)(obj) && (0, $5KeSn._isFinite)(obj) && !isNaN(parseFloat(obj));
}

});

parcelRegister("cM3PS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94ccf16a672c39c9$export$2e2bcd8739ae039; });

var $5KeSn = parcelRequire("5KeSn");

var $2BziU = parcelRequire("2BziU");
function $94ccf16a672c39c9$export$2e2bcd8739ae039(obj) {
    return (0, $2BziU.default)(obj) && (0, $5KeSn._isNaN)(obj);
}

});

parcelRegister("jdigr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dfcd6618afa5d266$export$2e2bcd8739ae039; });

var $5KeSn = parcelRequire("5KeSn");

var $7o1Uc = parcelRequire("7o1Uc");

var $599Q4 = parcelRequire("599Q4");

var $9GxUJ = parcelRequire("9GxUJ");
// Is a given value a typed array?
var $dfcd6618afa5d266$var$typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
function $dfcd6618afa5d266$var$isTypedArray(obj) {
    // `ArrayBuffer.isView` is the most future-proof, so use it when available.
    // Otherwise, fall back on the above regular expression.
    return (0, $5KeSn.nativeIsView) ? (0, $5KeSn.nativeIsView)(obj) && !(0, $7o1Uc.default)(obj) : (0, $9GxUJ.default)(obj) && $dfcd6618afa5d266$var$typedArrayPattern.test((0, $5KeSn.toString).call(obj));
}
var $dfcd6618afa5d266$export$2e2bcd8739ae039 = (0, $5KeSn.supportsArrayBuffer) ? $dfcd6618afa5d266$var$isTypedArray : (0, $599Q4.default)(false);

});
parcelRegister("599Q4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3bf56ccb7e5732eb$export$2e2bcd8739ae039; });
// Predicate-generating function. Often useful outside of Underscore.
function $3bf56ccb7e5732eb$export$2e2bcd8739ae039(value) {
    return function() {
        return value;
    };
}

});

parcelRegister("9GxUJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70d257f15d94c51c$export$2e2bcd8739ae039; });

var $kqkmV = parcelRequire("kqkmV");

var $4h9ZD = parcelRequire("4h9ZD");
var // Internal helper to determine whether we should spend extensive checks against
// `ArrayBuffer` et al.
$70d257f15d94c51c$export$2e2bcd8739ae039 = (0, $kqkmV.default)((0, $4h9ZD.default));

});
parcelRegister("kqkmV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ede6092c3eb47fea$export$2e2bcd8739ae039; });

var $5KeSn = parcelRequire("5KeSn");
function $ede6092c3eb47fea$export$2e2bcd8739ae039(getSizeProperty) {
    return function(collection) {
        var sizeProperty = getSizeProperty(collection);
        return typeof sizeProperty == "number" && sizeProperty >= 0 && sizeProperty <= (0, $5KeSn.MAX_ARRAY_INDEX);
    };
}

});

parcelRegister("4h9ZD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31d08062101da4b9$export$2e2bcd8739ae039; });

var $lvTvY = parcelRequire("lvTvY");
var // Internal helper to obtain the `byteLength` property of an object.
$31d08062101da4b9$export$2e2bcd8739ae039 = (0, $lvTvY.default)("byteLength");

});
parcelRegister("lvTvY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa978e478164df9c$export$2e2bcd8739ae039; });
// Internal helper to generate a function to obtain property `key` from `obj`.
function $fa978e478164df9c$export$2e2bcd8739ae039(key) {
    return function(obj) {
        return obj == null ? void 0 : obj[key];
    };
}

});




parcelRegister("dMukD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a087494cf5b0d39b$export$2e2bcd8739ae039; });

var $9baV7 = parcelRequire("9baV7");

var $Xm84r = parcelRequire("Xm84r");

var $aqb1L = parcelRequire("aqb1L");

var $6ayCB = parcelRequire("6ayCB");

var $1zKwG = parcelRequire("1zKwG");
function $a087494cf5b0d39b$export$2e2bcd8739ae039(obj) {
    if (obj == null) return true;
    // Skip the more expensive `toString`-based type checks if `obj` has no
    // `.length`.
    var length = (0, $9baV7.default)(obj);
    if (typeof length == "number" && ((0, $Xm84r.default)(obj) || (0, $aqb1L.default)(obj) || (0, $6ayCB.default)(obj))) return length === 0;
    return (0, $9baV7.default)((0, $1zKwG.default)(obj)) === 0;
}

});
parcelRegister("9baV7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6aed9ca95f374570$export$2e2bcd8739ae039; });

var $lvTvY = parcelRequire("lvTvY");
var // Internal helper to obtain the `length` property of an object.
$6aed9ca95f374570$export$2e2bcd8739ae039 = (0, $lvTvY.default)("length");

});

parcelRegister("1zKwG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $125d2673bb477a55$export$2e2bcd8739ae039; });

var $6XIA0 = parcelRequire("6XIA0");

var $5KeSn = parcelRequire("5KeSn");

var $6AQqY = parcelRequire("6AQqY");

var $cIquN = parcelRequire("cIquN");
function $125d2673bb477a55$export$2e2bcd8739ae039(obj) {
    if (!(0, $6XIA0.default)(obj)) return [];
    if (0, $5KeSn.nativeKeys) return (0, $5KeSn.nativeKeys)(obj);
    var keys = [];
    for(var key in obj)if ((0, $6AQqY.default)(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (0, $5KeSn.hasEnumBug) (0, $cIquN.default)(obj, keys);
    return keys;
}

});
parcelRegister("cIquN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $941e25955e40a5a7$export$2e2bcd8739ae039; });

var $5KeSn = parcelRequire("5KeSn");

var $kjJKW = parcelRequire("kjJKW");

var $6AQqY = parcelRequire("6AQqY");
// Internal helper to create a simple lookup structure.
// `collectNonEnumProps` used to depend on `_.contains`, but this led to
// circular imports. `emulatedSet` is a one-off solution that only works for
// arrays of strings.
function $941e25955e40a5a7$var$emulatedSet(keys) {
    var hash = {};
    for(var l = keys.length, i = 0; i < l; ++i)hash[keys[i]] = true;
    return {
        contains: function(key) {
            return hash[key] === true;
        },
        push: function(key) {
            hash[key] = true;
            return keys.push(key);
        }
    };
}
function $941e25955e40a5a7$export$2e2bcd8739ae039(obj, keys) {
    keys = $941e25955e40a5a7$var$emulatedSet(keys);
    var nonEnumIdx = (0, $5KeSn.nonEnumerableProps).length;
    var constructor = obj.constructor;
    var proto = (0, $kjJKW.default)(constructor) && constructor.prototype || (0, $5KeSn.ObjProto);
    // Constructor is a special case.
    var prop = "constructor";
    if ((0, $6AQqY.default)(obj, prop) && !keys.contains(prop)) keys.push(prop);
    while(nonEnumIdx--){
        prop = (0, $5KeSn.nonEnumerableProps)[nonEnumIdx];
        if (prop in obj && obj[prop] !== proto[prop] && !keys.contains(prop)) keys.push(prop);
    }
}

});



parcelRegister("h6EGc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7428d588332f848$export$2e2bcd8739ae039; });

var $1zKwG = parcelRequire("1zKwG");
function $c7428d588332f848$export$2e2bcd8739ae039(object, attrs) {
    var _keys = (0, $1zKwG.default)(attrs), length = _keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for(var i = 0; i < length; i++){
        var key = _keys[i];
        if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
}

});

parcelRegister("6X1WT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50f9c3ca5600fd49$export$2e2bcd8739ae039; });

var $7BHIQ = parcelRequire("7BHIQ");

var $5KeSn = parcelRequire("5KeSn");

var $4h9ZD = parcelRequire("4h9ZD");

var $jdigr = parcelRequire("jdigr");

var $kjJKW = parcelRequire("kjJKW");

var $5ByTL = parcelRequire("5ByTL");

var $7o1Uc = parcelRequire("7o1Uc");

var $1zKwG = parcelRequire("1zKwG");

var $6AQqY = parcelRequire("6AQqY");

var $klAza = parcelRequire("klAza");
// We use this string twice, so give it a name for minification.
var $50f9c3ca5600fd49$var$tagDataView = "[object DataView]";
// Internal recursive comparison function for `_.isEqual`.
function $50f9c3ca5600fd49$var$eq(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](https://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object") return false;
    return $50f9c3ca5600fd49$var$deepEq(a, b, aStack, bStack);
}
// Internal recursive comparison function for `_.isEqual`.
function $50f9c3ca5600fd49$var$deepEq(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    if (a instanceof (0, $7BHIQ.default)) a = a._wrapped;
    if (b instanceof (0, $7BHIQ.default)) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = (0, $5KeSn.toString).call(a);
    if (className !== (0, $5KeSn.toString).call(b)) return false;
    // Work around a bug in IE 10 - Edge 13.
    if ((0, $5ByTL.hasDataViewBug) && className == "[object Object]" && (0, $7o1Uc.default)(a)) {
        if (!(0, $7o1Uc.default)(b)) return false;
        className = $50f9c3ca5600fd49$var$tagDataView;
    }
    switch(className){
        // These types are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return (0, $5KeSn.SymbolProto).valueOf.call(a) === (0, $5KeSn.SymbolProto).valueOf.call(b);
        case "[object ArrayBuffer]":
        case $50f9c3ca5600fd49$var$tagDataView:
            // Coerce to typed array so we can fall through.
            return $50f9c3ca5600fd49$var$deepEq((0, $klAza.default)(a), (0, $klAza.default)(b), aStack, bStack);
    }
    var areArrays = className === "[object Array]";
    if (!areArrays && (0, $jdigr.default)(a)) {
        var byteLength = (0, $4h9ZD.default)(a);
        if (byteLength !== (0, $4h9ZD.default)(b)) return false;
        if (a.buffer === b.buffer && a.byteOffset === b.byteOffset) return true;
        areArrays = true;
    }
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !((0, $kjJKW.default)(aCtor) && aCtor instanceof aCtor && (0, $kjJKW.default)(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!$50f9c3ca5600fd49$var$eq(a[length], b[length], aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var _keys = (0, $1zKwG.default)(a), key;
        length = _keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if ((0, $1zKwG.default)(b).length !== length) return false;
        while(length--){
            // Deep compare each member
            key = _keys[length];
            if (!((0, $6AQqY.default)(b, key) && $50f9c3ca5600fd49$var$eq(a[key], b[key], aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function $50f9c3ca5600fd49$export$2e2bcd8739ae039(a, b) {
    return $50f9c3ca5600fd49$var$eq(a, b);
}

});
parcelRegister("7BHIQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $589de76cc04afa5b$export$2e2bcd8739ae039; });

var $5KeSn = parcelRequire("5KeSn");
function $589de76cc04afa5b$export$2e2bcd8739ae039(obj) {
    if (obj instanceof $589de76cc04afa5b$export$2e2bcd8739ae039) return obj;
    if (!(this instanceof $589de76cc04afa5b$export$2e2bcd8739ae039)) return new $589de76cc04afa5b$export$2e2bcd8739ae039(obj);
    this._wrapped = obj;
}
$589de76cc04afa5b$export$2e2bcd8739ae039.VERSION = (0, $5KeSn.VERSION);
// Extracts the result from a wrapped and chained object.
$589de76cc04afa5b$export$2e2bcd8739ae039.prototype.value = function() {
    return this._wrapped;
};
// Provide unwrapping proxies for some methods used in engine operations
// such as arithmetic and JSON stringification.
$589de76cc04afa5b$export$2e2bcd8739ae039.prototype.valueOf = $589de76cc04afa5b$export$2e2bcd8739ae039.prototype.toJSON = $589de76cc04afa5b$export$2e2bcd8739ae039.prototype.value;
$589de76cc04afa5b$export$2e2bcd8739ae039.prototype.toString = function() {
    return String(this._wrapped);
};

});

parcelRegister("klAza", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed0222164c6de989$export$2e2bcd8739ae039; });

var $4h9ZD = parcelRequire("4h9ZD");
function $ed0222164c6de989$export$2e2bcd8739ae039(bufferSource) {
    return new Uint8Array(bufferSource.buffer || bufferSource, bufferSource.byteOffset || 0, (0, $4h9ZD.default)(bufferSource));
}

});


parcelRegister("8zgy2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63ce6db32d45c660$export$2e2bcd8739ae039; });

var $82c6s = parcelRequire("82c6s");

var $5ByTL = parcelRequire("5ByTL");

var $gf77Y = parcelRequire("gf77Y");
var $63ce6db32d45c660$export$2e2bcd8739ae039 = (0, $5ByTL.isIE11) ? (0, $gf77Y.ie11fingerprint)((0, $gf77Y.mapMethods)) : (0, $82c6s.default)("Map");

});
parcelRegister("gf77Y", function(module, exports) {

$parcel$export(module.exports, "ie11fingerprint", function () { return $bd339373dbc905f5$export$15230eca1f400e40; });
$parcel$export(module.exports, "weakMapMethods", function () { return $bd339373dbc905f5$export$2f74b890a72cf48; });
$parcel$export(module.exports, "mapMethods", function () { return $bd339373dbc905f5$export$de9acb94190bb764; });
$parcel$export(module.exports, "setMethods", function () { return $bd339373dbc905f5$export$60e14a5e2a057f78; });

var $9baV7 = parcelRequire("9baV7");

var $kjJKW = parcelRequire("kjJKW");

var $etFkK = parcelRequire("etFkK");
function $bd339373dbc905f5$export$15230eca1f400e40(methods) {
    var length = (0, $9baV7.default)(methods);
    return function(obj) {
        if (obj == null) return false;
        // `Map`, `WeakMap` and `Set` have no enumerable keys.
        var keys = (0, $etFkK.default)(obj);
        if ((0, $9baV7.default)(keys)) return false;
        for(var i = 0; i < length; i++){
            if (!(0, $kjJKW.default)(obj[methods[i]])) return false;
        }
        // If we are testing against `WeakMap`, we need to ensure that
        // `obj` doesn't have a `forEach` method in order to distinguish
        // it from a regular `Map`.
        return methods !== $bd339373dbc905f5$export$2f74b890a72cf48 || !(0, $kjJKW.default)(obj[$bd339373dbc905f5$var$forEachName]);
    };
}
// In the interest of compact minification, we write
// each string in the fingerprints only once.
var $bd339373dbc905f5$var$forEachName = "forEach", $bd339373dbc905f5$var$hasName = "has", $bd339373dbc905f5$var$commonInit = [
    "clear",
    "delete"
], $bd339373dbc905f5$var$mapTail = [
    "get",
    $bd339373dbc905f5$var$hasName,
    "set"
];
var $bd339373dbc905f5$export$de9acb94190bb764 = $bd339373dbc905f5$var$commonInit.concat($bd339373dbc905f5$var$forEachName, $bd339373dbc905f5$var$mapTail), $bd339373dbc905f5$export$2f74b890a72cf48 = $bd339373dbc905f5$var$commonInit.concat($bd339373dbc905f5$var$mapTail), $bd339373dbc905f5$export$60e14a5e2a057f78 = [
    "add"
].concat($bd339373dbc905f5$var$commonInit, $bd339373dbc905f5$var$forEachName, $bd339373dbc905f5$var$hasName);

});
parcelRegister("etFkK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8a3d61ab146ac1f$export$2e2bcd8739ae039; });

var $6XIA0 = parcelRequire("6XIA0");

var $5KeSn = parcelRequire("5KeSn");

var $cIquN = parcelRequire("cIquN");
function $a8a3d61ab146ac1f$export$2e2bcd8739ae039(obj) {
    if (!(0, $6XIA0.default)(obj)) return [];
    var keys = [];
    for(var key in obj)keys.push(key);
    // Ahem, IE < 9.
    if (0, $5KeSn.hasEnumBug) (0, $cIquN.default)(obj, keys);
    return keys;
}

});



parcelRegister("6UTCX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50931f76a42b7237$export$2e2bcd8739ae039; });

var $82c6s = parcelRequire("82c6s");

var $5ByTL = parcelRequire("5ByTL");

var $gf77Y = parcelRequire("gf77Y");
var $50931f76a42b7237$export$2e2bcd8739ae039 = (0, $5ByTL.isIE11) ? (0, $gf77Y.ie11fingerprint)((0, $gf77Y.weakMapMethods)) : (0, $82c6s.default)("WeakMap");

});

parcelRegister("4JnNS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $371dd444f33c89de$export$2e2bcd8739ae039; });

var $82c6s = parcelRequire("82c6s");

var $5ByTL = parcelRequire("5ByTL");

var $gf77Y = parcelRequire("gf77Y");
var $371dd444f33c89de$export$2e2bcd8739ae039 = (0, $5ByTL.isIE11) ? (0, $gf77Y.ie11fingerprint)((0, $gf77Y.setMethods)) : (0, $82c6s.default)("Set");

});

parcelRegister("kBtPk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $effe665cc592e76b$export$2e2bcd8739ae039; });

var $82c6s = parcelRequire("82c6s");
var $effe665cc592e76b$export$2e2bcd8739ae039 = (0, $82c6s.default)("WeakSet");

});

parcelRegister("iFTFB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9873d3628434679$export$2e2bcd8739ae039; });

var $1zKwG = parcelRequire("1zKwG");
function $d9873d3628434679$export$2e2bcd8739ae039(obj) {
    var _keys = (0, $1zKwG.default)(obj);
    var length = _keys.length;
    var values = Array(length);
    for(var i = 0; i < length; i++)values[i] = obj[_keys[i]];
    return values;
}

});

parcelRegister("bOJwb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89a7ac2b2ce63e17$export$2e2bcd8739ae039; });

var $1zKwG = parcelRequire("1zKwG");
function $89a7ac2b2ce63e17$export$2e2bcd8739ae039(obj) {
    var _keys = (0, $1zKwG.default)(obj);
    var length = _keys.length;
    var pairs = Array(length);
    for(var i = 0; i < length; i++)pairs[i] = [
        _keys[i],
        obj[_keys[i]]
    ];
    return pairs;
}

});

parcelRegister("bhxHW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $836b6de9ebe30413$export$2e2bcd8739ae039; });

var $1zKwG = parcelRequire("1zKwG");
function $836b6de9ebe30413$export$2e2bcd8739ae039(obj) {
    var result = {};
    var _keys = (0, $1zKwG.default)(obj);
    for(var i = 0, length = _keys.length; i < length; i++)result[obj[_keys[i]]] = _keys[i];
    return result;
}

});

parcelRegister("bPMbE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89d9d60cc4186d29$export$2e2bcd8739ae039; });

var $kjJKW = parcelRequire("kjJKW");
function $89d9d60cc4186d29$export$2e2bcd8739ae039(obj) {
    var names = [];
    for(var key in obj)if ((0, $kjJKW.default)(obj[key])) names.push(key);
    return names.sort();
}

});

parcelRegister("1QL2S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $158f240357d35ea9$export$2e2bcd8739ae039; });

var $9FDKy = parcelRequire("9FDKy");

var $etFkK = parcelRequire("etFkK");
var // Extend a given object with all the properties in passed-in object(s).
$158f240357d35ea9$export$2e2bcd8739ae039 = (0, $9FDKy.default)((0, $etFkK.default));

});
parcelRegister("9FDKy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70a6c6e261fcb92c$export$2e2bcd8739ae039; });
// An internal function for creating assigner functions.
function $70a6c6e261fcb92c$export$2e2bcd8739ae039(keysFunc, defaults) {
    return function(obj) {
        var length = arguments.length;
        if (defaults) obj = Object(obj);
        if (length < 2 || obj == null) return obj;
        for(var index = 1; index < length; index++){
            var source = arguments[index], keys = keysFunc(source), l = keys.length;
            for(var i = 0; i < l; i++){
                var key = keys[i];
                if (!defaults || obj[key] === void 0) obj[key] = source[key];
            }
        }
        return obj;
    };
}

});


parcelRegister("8SVbN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $677fba7cefd2f153$export$2e2bcd8739ae039; });

var $9FDKy = parcelRequire("9FDKy");

var $1zKwG = parcelRequire("1zKwG");
var // Assigns a given object with all the own properties in the passed-in
// object(s).
// (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
$677fba7cefd2f153$export$2e2bcd8739ae039 = (0, $9FDKy.default)((0, $1zKwG.default));

});

parcelRegister("1td8m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1122b003083b8b8a$export$2e2bcd8739ae039; });

var $9FDKy = parcelRequire("9FDKy");

var $etFkK = parcelRequire("etFkK");
var // Fill in a given object with default properties.
$1122b003083b8b8a$export$2e2bcd8739ae039 = (0, $9FDKy.default)((0, $etFkK.default), true);

});

parcelRegister("l3YM2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5590531772deb59$export$2e2bcd8739ae039; });

var $kw0dU = parcelRequire("kw0dU");

var $8SVbN = parcelRequire("8SVbN");
function $f5590531772deb59$export$2e2bcd8739ae039(prototype, props) {
    var result = (0, $kw0dU.default)(prototype);
    if (props) (0, $8SVbN.default)(result, props);
    return result;
}

});
parcelRegister("kw0dU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eef6f826dec4d97a$export$2e2bcd8739ae039; });

var $6XIA0 = parcelRequire("6XIA0");

var $5KeSn = parcelRequire("5KeSn");
// Create a naked function reference for surrogate-prototype-swapping.
function $eef6f826dec4d97a$var$ctor() {
    return function() {};
}
function $eef6f826dec4d97a$export$2e2bcd8739ae039(prototype) {
    if (!(0, $6XIA0.default)(prototype)) return {};
    if (0, $5KeSn.nativeCreate) return (0, $5KeSn.nativeCreate)(prototype);
    var Ctor = $eef6f826dec4d97a$var$ctor();
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
}

});


parcelRegister("6wkBh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4bf5b6029ecc4345$export$2e2bcd8739ae039; });

var $6XIA0 = parcelRequire("6XIA0");

var $Xm84r = parcelRequire("Xm84r");

var $1QL2S = parcelRequire("1QL2S");
function $4bf5b6029ecc4345$export$2e2bcd8739ae039(obj) {
    if (!(0, $6XIA0.default)(obj)) return obj;
    return (0, $Xm84r.default)(obj) ? obj.slice() : (0, $1QL2S.default)({}, obj);
}

});

parcelRegister("jHs5V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e577d373cdc4a639$export$2e2bcd8739ae039; });
// Invokes `interceptor` with the `obj` and then returns `obj`.
// The primary purpose of this method is to "tap into" a method chain, in
// order to perform operations on intermediate results within the chain.
function $e577d373cdc4a639$export$2e2bcd8739ae039(obj, interceptor) {
    interceptor(obj);
    return obj;
}

});

parcelRegister("2ZYMz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22f06d645001241b$export$2e2bcd8739ae039; });

var $iY4WY = parcelRequire("iY4WY");

var $g7Ctc = parcelRequire("g7Ctc");

var $3Z7qj = parcelRequire("3Z7qj");
function $22f06d645001241b$export$2e2bcd8739ae039(object, path, defaultValue) {
    var value = (0, $g7Ctc.default)(object, (0, $iY4WY.default)(path));
    return (0, $3Z7qj.default)(value) ? defaultValue : value;
}

});
parcelRegister("iY4WY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcf1ab9dad266f46$export$2e2bcd8739ae039; });

var $7BHIQ = parcelRequire("7BHIQ");
parcelRequire("leUcU");
function $dcf1ab9dad266f46$export$2e2bcd8739ae039(path) {
    return (0, $7BHIQ.default).toPath(path);
}

});
parcelRegister("leUcU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f766815940bc6a5e$export$2e2bcd8739ae039; });

var $7BHIQ = parcelRequire("7BHIQ");

var $Xm84r = parcelRequire("Xm84r");
function $f766815940bc6a5e$export$2e2bcd8739ae039(path) {
    return (0, $Xm84r.default)(path) ? path : [
        path
    ];
}
(0, $7BHIQ.default).toPath = $f766815940bc6a5e$export$2e2bcd8739ae039;

});


parcelRegister("g7Ctc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bbcb2421d6ca4766$export$2e2bcd8739ae039; });
// Internal function to obtain a nested property in `obj` along `path`.
function $bbcb2421d6ca4766$export$2e2bcd8739ae039(obj, path) {
    var length = path.length;
    for(var i = 0; i < length; i++){
        if (obj == null) return void 0;
        obj = obj[path[i]];
    }
    return length ? obj : void 0;
}

});


parcelRegister("kriVr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee150278fdfcc209$export$2e2bcd8739ae039; });

var $6AQqY = parcelRequire("6AQqY");

var $iY4WY = parcelRequire("iY4WY");
function $ee150278fdfcc209$export$2e2bcd8739ae039(obj, path) {
    path = (0, $iY4WY.default)(path);
    var length = path.length;
    for(var i = 0; i < length; i++){
        var key = path[i];
        if (!(0, $6AQqY.default)(obj, key)) return false;
        obj = obj[key];
    }
    return !!length;
}

});

parcelRegister("9A40z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f9a95d0fa36e530$export$2e2bcd8739ae039; });

var $dxEEe = parcelRequire("dxEEe");

var $1zKwG = parcelRequire("1zKwG");
function $6f9a95d0fa36e530$export$2e2bcd8739ae039(obj, iteratee, context) {
    iteratee = (0, $dxEEe.default)(iteratee, context);
    var _keys = (0, $1zKwG.default)(obj), length = _keys.length, results = {};
    for(var index = 0; index < length; index++){
        var currentKey = _keys[index];
        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
}

});
parcelRegister("dxEEe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9dbde33c1b58e8da$export$2e2bcd8739ae039; });

var $7BHIQ = parcelRequire("7BHIQ");

var $fhlhq = parcelRequire("fhlhq");

var $9s0gR = parcelRequire("9s0gR");
function $9dbde33c1b58e8da$export$2e2bcd8739ae039(value, context, argCount) {
    if ((0, $7BHIQ.default).iteratee !== (0, $9s0gR.default)) return (0, $7BHIQ.default).iteratee(value, context);
    return (0, $fhlhq.default)(value, context, argCount);
}

});
parcelRegister("fhlhq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1f8f34f7bcca023$export$2e2bcd8739ae039; });

var $ij1x5 = parcelRequire("ij1x5");

var $kjJKW = parcelRequire("kjJKW");

var $6XIA0 = parcelRequire("6XIA0");

var $Xm84r = parcelRequire("Xm84r");

var $hHQBy = parcelRequire("hHQBy");

var $eJHpe = parcelRequire("eJHpe");

var $jOp1r = parcelRequire("jOp1r");
function $b1f8f34f7bcca023$export$2e2bcd8739ae039(value, context, argCount) {
    if (value == null) return 0, $ij1x5.default;
    if ((0, $kjJKW.default)(value)) return (0, $jOp1r.default)(value, context, argCount);
    if ((0, $6XIA0.default)(value) && !(0, $Xm84r.default)(value)) return (0, $hHQBy.default)(value);
    return (0, $eJHpe.default)(value);
}

});
parcelRegister("ij1x5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d53b30b41171a5e2$export$2e2bcd8739ae039; });
// Keep the identity function around for default iteratees.
function $d53b30b41171a5e2$export$2e2bcd8739ae039(value) {
    return value;
}

});

parcelRegister("hHQBy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce3f4206b36dd930$export$2e2bcd8739ae039; });

var $8SVbN = parcelRequire("8SVbN");

var $h6EGc = parcelRequire("h6EGc");
function $ce3f4206b36dd930$export$2e2bcd8739ae039(attrs) {
    attrs = (0, $8SVbN.default)({}, attrs);
    return function(obj) {
        return (0, $h6EGc.default)(obj, attrs);
    };
}

});

parcelRegister("eJHpe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aba6f031f20b8fae$export$2e2bcd8739ae039; });

var $g7Ctc = parcelRequire("g7Ctc");

var $iY4WY = parcelRequire("iY4WY");
function $aba6f031f20b8fae$export$2e2bcd8739ae039(path) {
    path = (0, $iY4WY.default)(path);
    return function(obj) {
        return (0, $g7Ctc.default)(obj, path);
    };
}

});

parcelRegister("jOp1r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6c618befa1330e5$export$2e2bcd8739ae039; });
// Internal function that returns an efficient (for current engines) version
// of the passed-in callback, to be repeatedly applied in other Underscore
// functions.
function $e6c618befa1330e5$export$2e2bcd8739ae039(func, context, argCount) {
    if (context === void 0) return func;
    switch(argCount == null ? 3 : argCount){
        case 1:
            return function(value) {
                return func.call(context, value);
            };
        // The 2-argument case is omitted because we’re not using it.
        case 3:
            return function(value, index, collection) {
                return func.call(context, value, index, collection);
            };
        case 4:
            return function(accumulator, value, index, collection) {
                return func.call(context, accumulator, value, index, collection);
            };
    }
    return function() {
        return func.apply(context, arguments);
    };
}

});


parcelRegister("9s0gR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e16f05c4486053e$export$2e2bcd8739ae039; });

var $7BHIQ = parcelRequire("7BHIQ");

var $fhlhq = parcelRequire("fhlhq");
function $6e16f05c4486053e$export$2e2bcd8739ae039(value, context) {
    return (0, $fhlhq.default)(value, context, Infinity);
}
(0, $7BHIQ.default).iteratee = $6e16f05c4486053e$export$2e2bcd8739ae039;

});



parcelRegister("evJbb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9070199fdc11371$export$2e2bcd8739ae039; });
// Predicate-generating function. Often useful outside of Underscore.
function $a9070199fdc11371$export$2e2bcd8739ae039() {}

});

parcelRegister("8eSnW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ff9d146eaab10fc$export$2e2bcd8739ae039; });

var $evJbb = parcelRequire("evJbb");

var $2ZYMz = parcelRequire("2ZYMz");
function $5ff9d146eaab10fc$export$2e2bcd8739ae039(obj) {
    if (obj == null) return 0, $evJbb.default;
    return function(path) {
        return (0, $2ZYMz.default)(obj, path);
    };
}

});

parcelRegister("eTRPP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad8ff63b5d69e671$export$2e2bcd8739ae039; });

var $jOp1r = parcelRequire("jOp1r");
function $ad8ff63b5d69e671$export$2e2bcd8739ae039(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = (0, $jOp1r.default)(iteratee, context, 1);
    for(var i = 0; i < n; i++)accum[i] = iteratee(i);
    return accum;
}

});

parcelRegister("hUFLW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $035d8cac62b78b7d$export$2e2bcd8739ae039; });
// Return a random integer between `min` and `max` (inclusive).
function $035d8cac62b78b7d$export$2e2bcd8739ae039(min, max) {
    if (max == null) {
        max = min;
        min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
}

});

parcelRegister("3GTqQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b004af9a9d6ded6$export$2e2bcd8739ae039; });
// A (possibly faster) way to get the current timestamp as an integer.
var $2b004af9a9d6ded6$export$2e2bcd8739ae039 = Date.now || function() {
    return new Date().getTime();
};

});

parcelRegister("ia0zu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3899a9e88d4f3f4$export$2e2bcd8739ae039; });

var $gUgiS = parcelRequire("gUgiS");

var $7d2HV = parcelRequire("7d2HV");
var // Function for escaping strings to HTML interpolation.
$d3899a9e88d4f3f4$export$2e2bcd8739ae039 = (0, $gUgiS.default)((0, $7d2HV.default));

});
parcelRegister("gUgiS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4ee85d0eaa0dec3$export$2e2bcd8739ae039; });

var $1zKwG = parcelRequire("1zKwG");
function $c4ee85d0eaa0dec3$export$2e2bcd8739ae039(map) {
    var escaper = function(match) {
        return map[match];
    };
    // Regexes for identifying a key that needs to be escaped.
    var source = "(?:" + (0, $1zKwG.default)(map).join("|") + ")";
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, "g");
    return function(string) {
        string = string == null ? "" : "" + string;
        return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
}

});

parcelRegister("7d2HV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53fbd8f294cd50ad$export$2e2bcd8739ae039; });
// Internal list of HTML entities for escaping.
var $53fbd8f294cd50ad$export$2e2bcd8739ae039 = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#x27;",
    "`": "&#x60;"
};

});


parcelRegister("1lKme", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0fbbb64369e2ea4e$export$2e2bcd8739ae039; });

var $gUgiS = parcelRequire("gUgiS");

var $bVsmK = parcelRequire("bVsmK");
var // Function for unescaping strings from HTML interpolation.
$0fbbb64369e2ea4e$export$2e2bcd8739ae039 = (0, $gUgiS.default)((0, $bVsmK.default));

});
parcelRegister("bVsmK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $023d98dcb3e65b18$export$2e2bcd8739ae039; });

var $bhxHW = parcelRequire("bhxHW");

var $7d2HV = parcelRequire("7d2HV");
var // Internal list of HTML entities for unescaping.
$023d98dcb3e65b18$export$2e2bcd8739ae039 = (0, $bhxHW.default)((0, $7d2HV.default));

});


parcelRegister("3KOuU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2bbcd6bb19c7e0f5$export$2e2bcd8739ae039; });

var $7BHIQ = parcelRequire("7BHIQ");
var // By default, Underscore uses ERB-style template delimiters. Change the
// following template settings to use alternative delimiters.
$2bbcd6bb19c7e0f5$export$2e2bcd8739ae039 = (0, $7BHIQ.default).templateSettings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
};

});

parcelRegister("6YDyV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $514708ee5e7dda18$export$2e2bcd8739ae039; });

var $1td8m = parcelRequire("1td8m");

var $7BHIQ = parcelRequire("7BHIQ");
parcelRequire("3KOuU");
// When customizing `_.templateSettings`, if you don't want to define an
// interpolation, evaluation or escaping regex, we need one that is
// guaranteed not to match.
var $514708ee5e7dda18$var$noMatch = /(.)^/;
// Certain characters need to be escaped so that they can be put into a
// string literal.
var $514708ee5e7dda18$var$escapes = {
    "'": "'",
    "\\": "\\",
    "\r": "r",
    "\n": "n",
    "\u2028": "u2028",
    "\u2029": "u2029"
};
var $514708ee5e7dda18$var$escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;
function $514708ee5e7dda18$var$escapeChar(match) {
    return "\\" + $514708ee5e7dda18$var$escapes[match];
}
// In order to prevent third-party code injection through
// `_.templateSettings.variable`, we test it against the following regular
// expression. It is intentionally a bit more liberal than just matching valid
// identifiers, but still prevents possible loopholes through defaults or
// destructuring assignment.
var $514708ee5e7dda18$var$bareIdentifier = /^\s*(\w|\$)+\s*$/;
function $514708ee5e7dda18$export$2e2bcd8739ae039(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = (0, $1td8m.default)({}, settings, (0, $7BHIQ.default).templateSettings);
    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
        (settings.escape || $514708ee5e7dda18$var$noMatch).source,
        (settings.interpolate || $514708ee5e7dda18$var$noMatch).source,
        (settings.evaluate || $514708ee5e7dda18$var$noMatch).source
    ].join("|") + "|$", "g");
    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
        source += text.slice(index, offset).replace($514708ee5e7dda18$var$escapeRegExp, $514708ee5e7dda18$var$escapeChar);
        index = offset + match.length;
        if (escape) source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
        else if (interpolate) source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
        else if (evaluate) source += "';\n" + evaluate + "\n__p+='";
        // Adobe VMs need the match returned to produce the correct offset.
        return match;
    });
    source += "';\n";
    var argument = settings.variable;
    if (argument) {
        // Insure against third-party code injection. (CVE-2021-23358)
        if (!$514708ee5e7dda18$var$bareIdentifier.test(argument)) throw new Error("variable is not a bare identifier: " + argument);
    } else {
        // If a variable is not specified, place data values in local scope.
        source = "with(obj||{}){\n" + source + "}\n";
        argument = "obj";
    }
    source = "var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" + source + "return __p;\n";
    var render;
    try {
        render = new Function(argument, "_", source);
    } catch (e) {
        e.source = source;
        throw e;
    }
    var template = function(data) {
        return render.call(this, data, (0, $7BHIQ.default));
    };
    // Provide the compiled source as a convenience for precompilation.
    template.source = "function(" + argument + "){\n" + source + "}";
    return template;
}

});

parcelRegister("cmzDU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $90033001b0a44141$export$2e2bcd8739ae039; });

var $kjJKW = parcelRequire("kjJKW");

var $iY4WY = parcelRequire("iY4WY");
function $90033001b0a44141$export$2e2bcd8739ae039(obj, path, fallback) {
    path = (0, $iY4WY.default)(path);
    var length = path.length;
    if (!length) return (0, $kjJKW.default)(fallback) ? fallback.call(obj) : fallback;
    for(var i = 0; i < length; i++){
        var prop = obj == null ? void 0 : obj[path[i]];
        if (prop === void 0) {
            prop = fallback;
            i = length; // Ensure we don't continue iterating.
        }
        obj = (0, $kjJKW.default)(prop) ? prop.call(obj) : prop;
    }
    return obj;
}

});

parcelRegister("3yItJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29770c94cee3796e$export$2e2bcd8739ae039; });
// Generate a unique integer id (unique within the entire client session).
// Useful for temporary DOM ids.
var $29770c94cee3796e$var$idCounter = 0;
function $29770c94cee3796e$export$2e2bcd8739ae039(prefix) {
    var id = ++$29770c94cee3796e$var$idCounter + "";
    return prefix ? prefix + id : id;
}

});

parcelRegister("bYKQN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b89a3d690684d7c$export$2e2bcd8739ae039; });

var $7BHIQ = parcelRequire("7BHIQ");
function $8b89a3d690684d7c$export$2e2bcd8739ae039(obj) {
    var instance = (0, $7BHIQ.default)(obj);
    instance._chain = true;
    return instance;
}

});

parcelRegister("kVosQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3bc1ba0ee7f72fb$export$2e2bcd8739ae039; });

var $8TlO7 = parcelRequire("8TlO7");

var $btxWF = parcelRequire("btxWF");

var $7BHIQ = parcelRequire("7BHIQ");
// Partially apply a function by creating a version that has had some of its
// arguments pre-filled, without changing its dynamic `this` context. `_` acts
// as a placeholder by default, allowing any combination of arguments to be
// pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
var $f3bc1ba0ee7f72fb$var$partial = (0, $8TlO7.default)(function(func, boundArgs) {
    var placeholder = $f3bc1ba0ee7f72fb$var$partial.placeholder;
    var bound = function() {
        var position = 0, length = boundArgs.length;
        var args = Array(length);
        for(var i = 0; i < length; i++)args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
        while(position < arguments.length)args.push(arguments[position++]);
        return (0, $btxWF.default)(func, bound, this, this, args);
    };
    return bound;
});
$f3bc1ba0ee7f72fb$var$partial.placeholder = (0, $7BHIQ.default);
var $f3bc1ba0ee7f72fb$export$2e2bcd8739ae039 = $f3bc1ba0ee7f72fb$var$partial;

});
parcelRegister("btxWF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85acbbf9e12b5482$export$2e2bcd8739ae039; });

var $kw0dU = parcelRequire("kw0dU");

var $6XIA0 = parcelRequire("6XIA0");
function $85acbbf9e12b5482$export$2e2bcd8739ae039(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = (0, $kw0dU.default)(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if ((0, $6XIA0.default)(result)) return result;
    return self;
}

});


parcelRegister("bavbx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8218d191953e3590$export$2e2bcd8739ae039; });

var $8TlO7 = parcelRequire("8TlO7");

var $kjJKW = parcelRequire("kjJKW");

var $btxWF = parcelRequire("btxWF");
var // Create a function bound to a given object (assigning `this`, and arguments,
// optionally).
$8218d191953e3590$export$2e2bcd8739ae039 = (0, $8TlO7.default)(function(func, context, args) {
    if (!(0, $kjJKW.default)(func)) throw new TypeError("Bind must be called on a function");
    var bound = (0, $8TlO7.default)(function(callArgs) {
        return (0, $btxWF.default)(func, bound, context, this, args.concat(callArgs));
    });
    return bound;
});

});

parcelRegister("2hK4S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1aa0e9582b564698$export$2e2bcd8739ae039; });

var $8TlO7 = parcelRequire("8TlO7");

var $ggEB2 = parcelRequire("ggEB2");

var $bavbx = parcelRequire("bavbx");
var // Bind a number of an object's methods to that object. Remaining arguments
// are the method names to be bound. Useful for ensuring that all callbacks
// defined on an object belong to it.
$1aa0e9582b564698$export$2e2bcd8739ae039 = (0, $8TlO7.default)(function(obj, keys) {
    keys = (0, $ggEB2.default)(keys, false, false);
    var index = keys.length;
    if (index < 1) throw new Error("bindAll must be passed function names");
    while(index--){
        var key = keys[index];
        obj[key] = (0, $bavbx.default)(obj[key], obj);
    }
    return obj;
});

});
parcelRegister("ggEB2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd7da194d34db7ae$export$2e2bcd8739ae039; });

var $9baV7 = parcelRequire("9baV7");

var $7IB4D = parcelRequire("7IB4D");

var $Xm84r = parcelRequire("Xm84r");

var $6ayCB = parcelRequire("6ayCB");
function $bd7da194d34db7ae$export$2e2bcd8739ae039(input, depth, strict, output) {
    output = output || [];
    if (!depth && depth !== 0) depth = Infinity;
    else if (depth <= 0) return output.concat(input);
    var idx = output.length;
    for(var i = 0, length = (0, $9baV7.default)(input); i < length; i++){
        var value = input[i];
        if ((0, $7IB4D.default)(value) && ((0, $Xm84r.default)(value) || (0, $6ayCB.default)(value))) {
            // Flatten current level of array or arguments object.
            if (depth > 1) {
                $bd7da194d34db7ae$export$2e2bcd8739ae039(value, depth - 1, strict, output);
                idx = output.length;
            } else {
                var j = 0, len = value.length;
                while(j < len)output[idx++] = value[j++];
            }
        } else if (!strict) output[idx++] = value;
    }
    return output;
}

});
parcelRegister("7IB4D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01733f96e9e815bb$export$2e2bcd8739ae039; });

var $kqkmV = parcelRequire("kqkmV");

var $9baV7 = parcelRequire("9baV7");
var // Internal helper for collection methods to determine whether a collection
// should be iterated as an array or as an object.
// Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
// Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
$01733f96e9e815bb$export$2e2bcd8739ae039 = (0, $kqkmV.default)((0, $9baV7.default));

});



parcelRegister("dUAVF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a20d26ab1191a0a9$export$2e2bcd8739ae039; });

var $6AQqY = parcelRequire("6AQqY");
function $a20d26ab1191a0a9$export$2e2bcd8739ae039(func, hasher) {
    var memoize = function(key) {
        var cache = memoize.cache;
        var address = "" + (hasher ? hasher.apply(this, arguments) : key);
        if (!(0, $6AQqY.default)(cache, address)) cache[address] = func.apply(this, arguments);
        return cache[address];
    };
    memoize.cache = {};
    return memoize;
}

});

parcelRegister("co9Dj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $904f32d7322299ea$export$2e2bcd8739ae039; });

var $8TlO7 = parcelRequire("8TlO7");
var // Delays a function for the given number of milliseconds, and then calls
// it with the arguments supplied.
$904f32d7322299ea$export$2e2bcd8739ae039 = (0, $8TlO7.default)(function(func, wait, args) {
    return setTimeout(function() {
        return func.apply(null, args);
    }, wait);
});

});

parcelRegister("2yhZb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1dbcb55b76d4b432$export$2e2bcd8739ae039; });

var $kVosQ = parcelRequire("kVosQ");

var $co9Dj = parcelRequire("co9Dj");

var $7BHIQ = parcelRequire("7BHIQ");
var // Defers a function, scheduling it to run after the current call stack has
// cleared.
$1dbcb55b76d4b432$export$2e2bcd8739ae039 = (0, $kVosQ.default)((0, $co9Dj.default), (0, $7BHIQ.default), 1);

});

parcelRegister("3THiL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d6818f832768db3$export$2e2bcd8739ae039; });

var $3GTqQ = parcelRequire("3GTqQ");
function $2d6818f832768db3$export$2e2bcd8739ae039(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
        previous = options.leading === false ? 0 : (0, $3GTqQ.default)();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
    };
    var throttled = function() {
        var _now = (0, $3GTqQ.default)();
        if (!previous && options.leading === false) previous = _now;
        var remaining = wait - (_now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = _now;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(later, remaining);
        return result;
    };
    throttled.cancel = function() {
        clearTimeout(timeout);
        previous = 0;
        timeout = context = args = null;
    };
    return throttled;
}

});

parcelRegister("djXe0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b2afd8d418db86c$export$2e2bcd8739ae039; });

var $8TlO7 = parcelRequire("8TlO7");

var $3GTqQ = parcelRequire("3GTqQ");
function $9b2afd8d418db86c$export$2e2bcd8739ae039(func, wait, immediate) {
    var timeout, previous, args, result, context;
    var later = function() {
        var passed = (0, $3GTqQ.default)() - previous;
        if (wait > passed) timeout = setTimeout(later, wait - passed);
        else {
            timeout = null;
            if (!immediate) result = func.apply(context, args);
            // This check is needed because `func` can recursively invoke `debounced`.
            if (!timeout) args = context = null;
        }
    };
    var debounced = (0, $8TlO7.default)(function(_args) {
        context = this;
        args = _args;
        previous = (0, $3GTqQ.default)();
        if (!timeout) {
            timeout = setTimeout(later, wait);
            if (immediate) result = func.apply(context, args);
        }
        return result;
    });
    debounced.cancel = function() {
        clearTimeout(timeout);
        timeout = args = context = null;
    };
    return debounced;
}

});

parcelRegister("5cS8P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ca8121e38f14fdb$export$2e2bcd8739ae039; });

var $kVosQ = parcelRequire("kVosQ");
function $3ca8121e38f14fdb$export$2e2bcd8739ae039(func, wrapper) {
    return (0, $kVosQ.default)(wrapper, func);
}

});

parcelRegister("ieCTN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d467b54ec92b3c90$export$2e2bcd8739ae039; });
// Returns a negated version of the passed-in predicate.
function $d467b54ec92b3c90$export$2e2bcd8739ae039(predicate) {
    return function() {
        return !predicate.apply(this, arguments);
    };
}

});

parcelRegister("829FO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d9603968eb707b2$export$2e2bcd8739ae039; });
// Returns a function that is the composition of a list of functions, each
// consuming the return value of the function that follows.
function $5d9603968eb707b2$export$2e2bcd8739ae039() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
        var i = start;
        var result = args[start].apply(this, arguments);
        while(i--)result = args[i].call(this, result);
        return result;
    };
}

});

parcelRegister("cBSIx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92e362758dc10554$export$2e2bcd8739ae039; });
// Returns a function that will only be executed on and after the Nth call.
function $92e362758dc10554$export$2e2bcd8739ae039(times, func) {
    return function() {
        if (--times < 1) return func.apply(this, arguments);
    };
}

});

parcelRegister("b0Xuc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $804dd6782e1909a7$export$2e2bcd8739ae039; });
// Returns a function that will only be executed up to (but not including) the
// Nth call.
function $804dd6782e1909a7$export$2e2bcd8739ae039(times, func) {
    var memo;
    return function() {
        if (--times > 0) memo = func.apply(this, arguments);
        if (times <= 1) func = null;
        return memo;
    };
}

});

parcelRegister("4a26e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3079b9827064d253$export$2e2bcd8739ae039; });

var $kVosQ = parcelRequire("kVosQ");

var $b0Xuc = parcelRequire("b0Xuc");
var // Returns a function that will be executed at most one time, no matter how
// often you call it. Useful for lazy initialization.
$3079b9827064d253$export$2e2bcd8739ae039 = (0, $kVosQ.default)((0, $b0Xuc.default), 2);

});

parcelRegister("cBH4D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92da5a434175cc04$export$2e2bcd8739ae039; });

var $dxEEe = parcelRequire("dxEEe");

var $1zKwG = parcelRequire("1zKwG");
function $92da5a434175cc04$export$2e2bcd8739ae039(obj, predicate, context) {
    predicate = (0, $dxEEe.default)(predicate, context);
    var _keys = (0, $1zKwG.default)(obj), key;
    for(var i = 0, length = _keys.length; i < length; i++){
        key = _keys[i];
        if (predicate(obj[key], key, obj)) return key;
    }
}

});

parcelRegister("d15Zo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97a003ad8a0d2c0f$export$2e2bcd8739ae039; });

var $a8A9w = parcelRequire("a8A9w");
var // Returns the first index on an array-like that passes a truth test.
$97a003ad8a0d2c0f$export$2e2bcd8739ae039 = (0, $a8A9w.default)(1);

});
parcelRegister("a8A9w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7616b1e2bc627292$export$2e2bcd8739ae039; });

var $dxEEe = parcelRequire("dxEEe");

var $9baV7 = parcelRequire("9baV7");
function $7616b1e2bc627292$export$2e2bcd8739ae039(dir) {
    return function(array, predicate, context) {
        predicate = (0, $dxEEe.default)(predicate, context);
        var length = (0, $9baV7.default)(array);
        var index = dir > 0 ? 0 : length - 1;
        for(; index >= 0 && index < length; index += dir){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    };
}

});


parcelRegister("5MrLm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4356f89415915a74$export$2e2bcd8739ae039; });

var $a8A9w = parcelRequire("a8A9w");
var // Returns the last index on an array-like that passes a truth test.
$4356f89415915a74$export$2e2bcd8739ae039 = (0, $a8A9w.default)(-1);

});

parcelRegister("2wd0A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d58a9214446428a$export$2e2bcd8739ae039; });

var $dxEEe = parcelRequire("dxEEe");

var $9baV7 = parcelRequire("9baV7");
function $1d58a9214446428a$export$2e2bcd8739ae039(array, obj, iteratee, context) {
    iteratee = (0, $dxEEe.default)(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = (0, $9baV7.default)(array);
    while(low < high){
        var mid = Math.floor((low + high) / 2);
        if (iteratee(array[mid]) < value) low = mid + 1;
        else high = mid;
    }
    return low;
}

});

parcelRegister("h9aLf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7bb9fd4e70b30ea$export$2e2bcd8739ae039; });

var $2wd0A = parcelRequire("2wd0A");

var $d15Zo = parcelRequire("d15Zo");

var $2SWmg = parcelRequire("2SWmg");
var // Return the position of the first occurrence of an item in an array,
// or -1 if the item is not included in the array.
// If the array is large and already in sort order, pass `true`
// for **isSorted** to use binary search.
$c7bb9fd4e70b30ea$export$2e2bcd8739ae039 = (0, $2SWmg.default)(1, (0, $d15Zo.default), (0, $2wd0A.default));

});
parcelRegister("2SWmg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $219de499ce1b6aca$export$2e2bcd8739ae039; });

var $9baV7 = parcelRequire("9baV7");

var $5KeSn = parcelRequire("5KeSn");

var $cM3PS = parcelRequire("cM3PS");
function $219de499ce1b6aca$export$2e2bcd8739ae039(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
        var i = 0, length = (0, $9baV7.default)(array);
        if (typeof idx == "number") {
            if (dir > 0) i = idx >= 0 ? idx : Math.max(idx + length, i);
            else length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        } else if (sortedIndex && idx && length) {
            idx = sortedIndex(array, item);
            return array[idx] === item ? idx : -1;
        }
        if (item !== item) {
            idx = predicateFind((0, $5KeSn.slice).call(array, i, length), (0, $cM3PS.default));
            return idx >= 0 ? idx + i : -1;
        }
        for(idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir){
            if (array[idx] === item) return idx;
        }
        return -1;
    };
}

});


parcelRegister("iTqrX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc11e16ef1da1203$export$2e2bcd8739ae039; });

var $5MrLm = parcelRequire("5MrLm");

var $2SWmg = parcelRequire("2SWmg");
var // Return the position of the last occurrence of an item in an array,
// or -1 if the item is not included in the array.
$dc11e16ef1da1203$export$2e2bcd8739ae039 = (0, $2SWmg.default)(-1, (0, $5MrLm.default));

});

parcelRegister("7ayue", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $538437e00e8f7b04$export$2e2bcd8739ae039; });

var $7IB4D = parcelRequire("7IB4D");

var $d15Zo = parcelRequire("d15Zo");

var $cBH4D = parcelRequire("cBH4D");
function $538437e00e8f7b04$export$2e2bcd8739ae039(obj, predicate, context) {
    var keyFinder = (0, $7IB4D.default)(obj) ? (0, $d15Zo.default) : (0, $cBH4D.default);
    var key = keyFinder(obj, predicate, context);
    if (key !== void 0 && key !== -1) return obj[key];
}

});

parcelRegister("duO4b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d34e9e0e4788300$export$2e2bcd8739ae039; });

var $7ayue = parcelRequire("7ayue");

var $hHQBy = parcelRequire("hHQBy");
function $9d34e9e0e4788300$export$2e2bcd8739ae039(obj, attrs) {
    return (0, $7ayue.default)(obj, (0, $hHQBy.default)(attrs));
}

});

parcelRegister("kQFPC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2d91cd73b446802$export$2e2bcd8739ae039; });

var $jOp1r = parcelRequire("jOp1r");

var $7IB4D = parcelRequire("7IB4D");

var $1zKwG = parcelRequire("1zKwG");
function $f2d91cd73b446802$export$2e2bcd8739ae039(obj, iteratee, context) {
    iteratee = (0, $jOp1r.default)(iteratee, context);
    var i, length;
    if ((0, $7IB4D.default)(obj)) for(i = 0, length = obj.length; i < length; i++)iteratee(obj[i], i, obj);
    else {
        var _keys = (0, $1zKwG.default)(obj);
        for(i = 0, length = _keys.length; i < length; i++)iteratee(obj[_keys[i]], _keys[i], obj);
    }
    return obj;
}

});

parcelRegister("cFwSY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9392d2c2d163fd75$export$2e2bcd8739ae039; });

var $dxEEe = parcelRequire("dxEEe");

var $7IB4D = parcelRequire("7IB4D");

var $1zKwG = parcelRequire("1zKwG");
function $9392d2c2d163fd75$export$2e2bcd8739ae039(obj, iteratee, context) {
    iteratee = (0, $dxEEe.default)(iteratee, context);
    var _keys = !(0, $7IB4D.default)(obj) && (0, $1zKwG.default)(obj), length = (_keys || obj).length, results = Array(length);
    for(var index = 0; index < length; index++){
        var currentKey = _keys ? _keys[index] : index;
        results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
}

});

parcelRegister("fVJXz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b98fd48a6014ec76$export$2e2bcd8739ae039; });

var $kLFLo = parcelRequire("kLFLo");
var // **Reduce** builds up a single result from a list of values, aka `inject`,
// or `foldl`.
$b98fd48a6014ec76$export$2e2bcd8739ae039 = (0, $kLFLo.default)(1);

});
parcelRegister("kLFLo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1e897c00b6457c2$export$2e2bcd8739ae039; });

var $7IB4D = parcelRequire("7IB4D");

var $1zKwG = parcelRequire("1zKwG");

var $jOp1r = parcelRequire("jOp1r");
function $f1e897c00b6457c2$export$2e2bcd8739ae039(dir) {
    // Wrap code that reassigns argument variables in a separate function than
    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
    var reducer = function(obj, iteratee, memo, initial) {
        var _keys = !(0, $7IB4D.default)(obj) && (0, $1zKwG.default)(obj), length = (_keys || obj).length, index = dir > 0 ? 0 : length - 1;
        if (!initial) {
            memo = obj[_keys ? _keys[index] : index];
            index += dir;
        }
        for(; index >= 0 && index < length; index += dir){
            var currentKey = _keys ? _keys[index] : index;
            memo = iteratee(memo, obj[currentKey], currentKey, obj);
        }
        return memo;
    };
    return function(obj, iteratee, memo, context) {
        var initial = arguments.length >= 3;
        return reducer(obj, (0, $jOp1r.default)(iteratee, context, 4), memo, initial);
    };
}

});


parcelRegister("k63yi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea171f909fb25d07$export$2e2bcd8739ae039; });

var $kLFLo = parcelRequire("kLFLo");
var // The right-associative version of reduce, also known as `foldr`.
$ea171f909fb25d07$export$2e2bcd8739ae039 = (0, $kLFLo.default)(-1);

});

parcelRegister("aUKYr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f23925a895d136f$export$2e2bcd8739ae039; });

var $dxEEe = parcelRequire("dxEEe");

var $kQFPC = parcelRequire("kQFPC");
function $7f23925a895d136f$export$2e2bcd8739ae039(obj, predicate, context) {
    var results = [];
    predicate = (0, $dxEEe.default)(predicate, context);
    (0, $kQFPC.default)(obj, function(value, index, list) {
        if (predicate(value, index, list)) results.push(value);
    });
    return results;
}

});

parcelRegister("dOatp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0d811aefdd9130c$export$2e2bcd8739ae039; });

var $aUKYr = parcelRequire("aUKYr");

var $ieCTN = parcelRequire("ieCTN");

var $dxEEe = parcelRequire("dxEEe");
function $a0d811aefdd9130c$export$2e2bcd8739ae039(obj, predicate, context) {
    return (0, $aUKYr.default)(obj, (0, $ieCTN.default)((0, $dxEEe.default)(predicate)), context);
}

});

parcelRegister("kbolk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb17b7bc46aebf49$export$2e2bcd8739ae039; });

var $dxEEe = parcelRequire("dxEEe");

var $7IB4D = parcelRequire("7IB4D");

var $1zKwG = parcelRequire("1zKwG");
function $eb17b7bc46aebf49$export$2e2bcd8739ae039(obj, predicate, context) {
    predicate = (0, $dxEEe.default)(predicate, context);
    var _keys = !(0, $7IB4D.default)(obj) && (0, $1zKwG.default)(obj), length = (_keys || obj).length;
    for(var index = 0; index < length; index++){
        var currentKey = _keys ? _keys[index] : index;
        if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
}

});

parcelRegister("6kYAr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49d39b97e3b1b0bb$export$2e2bcd8739ae039; });

var $dxEEe = parcelRequire("dxEEe");

var $7IB4D = parcelRequire("7IB4D");

var $1zKwG = parcelRequire("1zKwG");
function $49d39b97e3b1b0bb$export$2e2bcd8739ae039(obj, predicate, context) {
    predicate = (0, $dxEEe.default)(predicate, context);
    var _keys = !(0, $7IB4D.default)(obj) && (0, $1zKwG.default)(obj), length = (_keys || obj).length;
    for(var index = 0; index < length; index++){
        var currentKey = _keys ? _keys[index] : index;
        if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
}

});

parcelRegister("3YEvF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e56661410883ab2$export$2e2bcd8739ae039; });

var $7IB4D = parcelRequire("7IB4D");

var $iFTFB = parcelRequire("iFTFB");

var $h9aLf = parcelRequire("h9aLf");
function $2e56661410883ab2$export$2e2bcd8739ae039(obj, item, fromIndex, guard) {
    if (!(0, $7IB4D.default)(obj)) obj = (0, $iFTFB.default)(obj);
    if (typeof fromIndex != "number" || guard) fromIndex = 0;
    return (0, $h9aLf.default)(obj, item, fromIndex) >= 0;
}

});

parcelRegister("1ZREC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17451b8830d0fbe8$export$2e2bcd8739ae039; });

var $8TlO7 = parcelRequire("8TlO7");

var $kjJKW = parcelRequire("kjJKW");

var $cFwSY = parcelRequire("cFwSY");

var $g7Ctc = parcelRequire("g7Ctc");

var $iY4WY = parcelRequire("iY4WY");
var // Invoke a method (with arguments) on every item in a collection.
$17451b8830d0fbe8$export$2e2bcd8739ae039 = (0, $8TlO7.default)(function(obj, path, args) {
    var contextPath, func;
    if ((0, $kjJKW.default)(path)) func = path;
    else {
        path = (0, $iY4WY.default)(path);
        contextPath = path.slice(0, -1);
        path = path[path.length - 1];
    }
    return (0, $cFwSY.default)(obj, function(context) {
        var method = func;
        if (!method) {
            if (contextPath && contextPath.length) context = (0, $g7Ctc.default)(context, contextPath);
            if (context == null) return void 0;
            method = context[path];
        }
        return method == null ? method : method.apply(context, args);
    });
});

});

parcelRegister("1RCtE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15b89677da45c9ce$export$2e2bcd8739ae039; });

var $cFwSY = parcelRequire("cFwSY");

var $eJHpe = parcelRequire("eJHpe");
function $15b89677da45c9ce$export$2e2bcd8739ae039(obj, key) {
    return (0, $cFwSY.default)(obj, (0, $eJHpe.default)(key));
}

});

parcelRegister("8SOrD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $677a7f2c4172e9af$export$2e2bcd8739ae039; });

var $aUKYr = parcelRequire("aUKYr");

var $hHQBy = parcelRequire("hHQBy");
function $677a7f2c4172e9af$export$2e2bcd8739ae039(obj, attrs) {
    return (0, $aUKYr.default)(obj, (0, $hHQBy.default)(attrs));
}

});

parcelRegister("8QPB7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $671b344f90780069$export$2e2bcd8739ae039; });

var $7IB4D = parcelRequire("7IB4D");

var $iFTFB = parcelRequire("iFTFB");

var $dxEEe = parcelRequire("dxEEe");

var $kQFPC = parcelRequire("kQFPC");
function $671b344f90780069$export$2e2bcd8739ae039(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity, value, computed;
    if (iteratee == null || typeof iteratee == "number" && typeof obj[0] != "object" && obj != null) {
        obj = (0, $7IB4D.default)(obj) ? obj : (0, $iFTFB.default)(obj);
        for(var i = 0, length = obj.length; i < length; i++){
            value = obj[i];
            if (value != null && value > result) result = value;
        }
    } else {
        iteratee = (0, $dxEEe.default)(iteratee, context);
        (0, $kQFPC.default)(obj, function(v, index, list) {
            computed = iteratee(v, index, list);
            if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
                result = v;
                lastComputed = computed;
            }
        });
    }
    return result;
}

});

parcelRegister("6Cfc8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d12140e5e8c7c62$export$2e2bcd8739ae039; });

var $7IB4D = parcelRequire("7IB4D");

var $iFTFB = parcelRequire("iFTFB");

var $dxEEe = parcelRequire("dxEEe");

var $kQFPC = parcelRequire("kQFPC");
function $4d12140e5e8c7c62$export$2e2bcd8739ae039(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity, value, computed;
    if (iteratee == null || typeof iteratee == "number" && typeof obj[0] != "object" && obj != null) {
        obj = (0, $7IB4D.default)(obj) ? obj : (0, $iFTFB.default)(obj);
        for(var i = 0, length = obj.length; i < length; i++){
            value = obj[i];
            if (value != null && value < result) result = value;
        }
    } else {
        iteratee = (0, $dxEEe.default)(iteratee, context);
        (0, $kQFPC.default)(obj, function(v, index, list) {
            computed = iteratee(v, index, list);
            if (computed < lastComputed || computed === Infinity && result === Infinity) {
                result = v;
                lastComputed = computed;
            }
        });
    }
    return result;
}

});

parcelRegister("3maiM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $271b6ae7ddcef9c8$export$2e2bcd8739ae039; });

var $2zH6x = parcelRequire("2zH6x");
function $271b6ae7ddcef9c8$export$2e2bcd8739ae039(obj) {
    return (0, $2zH6x.default)(obj, Infinity);
}

});
parcelRegister("2zH6x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e004949ce74e6e5$export$2e2bcd8739ae039; });

var $7IB4D = parcelRequire("7IB4D");

var $iFTFB = parcelRequire("iFTFB");

var $9baV7 = parcelRequire("9baV7");

var $hUFLW = parcelRequire("hUFLW");

var $9EoGr = parcelRequire("9EoGr");
function $1e004949ce74e6e5$export$2e2bcd8739ae039(obj, n, guard) {
    if (n == null || guard) {
        if (!(0, $7IB4D.default)(obj)) obj = (0, $iFTFB.default)(obj);
        return obj[(0, $hUFLW.default)(obj.length - 1)];
    }
    var sample = (0, $9EoGr.default)(obj);
    var length = (0, $9baV7.default)(sample);
    n = Math.max(Math.min(n, length), 0);
    var last = length - 1;
    for(var index = 0; index < n; index++){
        var rand = (0, $hUFLW.default)(index, last);
        var temp = sample[index];
        sample[index] = sample[rand];
        sample[rand] = temp;
    }
    return sample.slice(0, n);
}

});
parcelRegister("9EoGr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $706aff1e061cbc65$export$2e2bcd8739ae039; });

var $Xm84r = parcelRequire("Xm84r");

var $5KeSn = parcelRequire("5KeSn");

var $aqb1L = parcelRequire("aqb1L");

var $7IB4D = parcelRequire("7IB4D");

var $cFwSY = parcelRequire("cFwSY");

var $ij1x5 = parcelRequire("ij1x5");

var $iFTFB = parcelRequire("iFTFB");
// Safely create a real, live array from anything iterable.
var $706aff1e061cbc65$var$reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
function $706aff1e061cbc65$export$2e2bcd8739ae039(obj) {
    if (!obj) return [];
    if ((0, $Xm84r.default)(obj)) return (0, $5KeSn.slice).call(obj);
    if ((0, $aqb1L.default)(obj)) // Keep surrogate pair characters together.
    return obj.match($706aff1e061cbc65$var$reStrSymbol);
    if ((0, $7IB4D.default)(obj)) return (0, $cFwSY.default)(obj, (0, $ij1x5.default));
    return (0, $iFTFB.default)(obj);
}

});



parcelRegister("izwKy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d854e6547de28e9c$export$2e2bcd8739ae039; });

var $dxEEe = parcelRequire("dxEEe");

var $1RCtE = parcelRequire("1RCtE");

var $cFwSY = parcelRequire("cFwSY");
function $d854e6547de28e9c$export$2e2bcd8739ae039(obj, iteratee, context) {
    var index = 0;
    iteratee = (0, $dxEEe.default)(iteratee, context);
    return (0, $1RCtE.default)((0, $cFwSY.default)(obj, function(value, key, list) {
        return {
            value: value,
            index: index++,
            criteria: iteratee(value, key, list)
        };
    }).sort(function(left, right) {
        var a = left.criteria;
        var b = right.criteria;
        if (a !== b) {
            if (a > b || a === void 0) return 1;
            if (a < b || b === void 0) return -1;
        }
        return left.index - right.index;
    }), "value");
}

});

parcelRegister("5lFy2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e4f2477f6f0bce3$export$2e2bcd8739ae039; });

var $jgA2a = parcelRequire("jgA2a");

var $6AQqY = parcelRequire("6AQqY");
var // Groups the object's values by a criterion. Pass either a string attribute
// to group by, or a function that returns the criterion.
$3e4f2477f6f0bce3$export$2e2bcd8739ae039 = (0, $jgA2a.default)(function(result, value, key) {
    if ((0, $6AQqY.default)(result, key)) result[key].push(value);
    else result[key] = [
        value
    ];
});

});
parcelRegister("jgA2a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e06b7686bf34c5ee$export$2e2bcd8739ae039; });

var $dxEEe = parcelRequire("dxEEe");

var $kQFPC = parcelRequire("kQFPC");
function $e06b7686bf34c5ee$export$2e2bcd8739ae039(behavior, partition) {
    return function(obj, iteratee, context) {
        var result = partition ? [
            [],
            []
        ] : {};
        iteratee = (0, $dxEEe.default)(iteratee, context);
        (0, $kQFPC.default)(obj, function(value, index) {
            var key = iteratee(value, index, obj);
            behavior(result, value, key);
        });
        return result;
    };
}

});


parcelRegister("emt8q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a749b852b1186a9a$export$2e2bcd8739ae039; });

var $jgA2a = parcelRequire("jgA2a");
var // Indexes the object's values by a criterion, similar to `_.groupBy`, but for
// when you know that your index values will be unique.
$a749b852b1186a9a$export$2e2bcd8739ae039 = (0, $jgA2a.default)(function(result, value, key) {
    result[key] = value;
});

});

parcelRegister("4xqB9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34dee055b3e60ca7$export$2e2bcd8739ae039; });

var $jgA2a = parcelRequire("jgA2a");

var $6AQqY = parcelRequire("6AQqY");
var // Counts instances of an object that group by a certain criterion. Pass
// either a string attribute to count by, or a function that returns the
// criterion.
$34dee055b3e60ca7$export$2e2bcd8739ae039 = (0, $jgA2a.default)(function(result, value, key) {
    if ((0, $6AQqY.default)(result, key)) result[key]++;
    else result[key] = 1;
});

});

parcelRegister("deiC4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a1b054f10afb62e$export$2e2bcd8739ae039; });

var $jgA2a = parcelRequire("jgA2a");
var // Split a collection into two arrays: one whose elements all pass the given
// truth test, and one whose elements all do not pass the truth test.
$9a1b054f10afb62e$export$2e2bcd8739ae039 = (0, $jgA2a.default)(function(result, value, pass) {
    result[pass ? 0 : 1].push(value);
}, true);

});

parcelRegister("ec5Ki", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a556a4aeb0687deb$export$2e2bcd8739ae039; });

var $7IB4D = parcelRequire("7IB4D");

var $1zKwG = parcelRequire("1zKwG");
function $a556a4aeb0687deb$export$2e2bcd8739ae039(obj) {
    if (obj == null) return 0;
    return (0, $7IB4D.default)(obj) ? obj.length : (0, $1zKwG.default)(obj).length;
}

});

parcelRegister("lsaWo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9e4b31b4d7d0f52$export$2e2bcd8739ae039; });

var $8TlO7 = parcelRequire("8TlO7");

var $kjJKW = parcelRequire("kjJKW");

var $jOp1r = parcelRequire("jOp1r");

var $etFkK = parcelRequire("etFkK");

var $fOghB = parcelRequire("fOghB");

var $ggEB2 = parcelRequire("ggEB2");
var // Return a copy of the object only containing the allowed properties.
$f9e4b31b4d7d0f52$export$2e2bcd8739ae039 = (0, $8TlO7.default)(function(obj, keys) {
    var result = {}, iteratee = keys[0];
    if (obj == null) return result;
    if ((0, $kjJKW.default)(iteratee)) {
        if (keys.length > 1) iteratee = (0, $jOp1r.default)(iteratee, keys[1]);
        keys = (0, $etFkK.default)(obj);
    } else {
        iteratee = (0, $fOghB.default);
        keys = (0, $ggEB2.default)(keys, false, false);
        obj = Object(obj);
    }
    for(var i = 0, length = keys.length; i < length; i++){
        var key = keys[i];
        var value = obj[key];
        if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
});

});
parcelRegister("fOghB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b82827f32f0b3b86$export$2e2bcd8739ae039; });
// Internal `_.pick` helper function to determine whether `key` is an enumerable
// property name of `obj`.
function $b82827f32f0b3b86$export$2e2bcd8739ae039(value, key, obj) {
    return key in obj;
}

});


parcelRegister("adWEn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77189cf879ef7846$export$2e2bcd8739ae039; });

var $8TlO7 = parcelRequire("8TlO7");

var $kjJKW = parcelRequire("kjJKW");

var $ieCTN = parcelRequire("ieCTN");

var $cFwSY = parcelRequire("cFwSY");

var $ggEB2 = parcelRequire("ggEB2");

var $3YEvF = parcelRequire("3YEvF");

var $lsaWo = parcelRequire("lsaWo");
var // Return a copy of the object without the disallowed properties.
$77189cf879ef7846$export$2e2bcd8739ae039 = (0, $8TlO7.default)(function(obj, keys) {
    var iteratee = keys[0], context;
    if ((0, $kjJKW.default)(iteratee)) {
        iteratee = (0, $ieCTN.default)(iteratee);
        if (keys.length > 1) context = keys[1];
    } else {
        keys = (0, $cFwSY.default)((0, $ggEB2.default)(keys, false, false), String);
        iteratee = function(value, key) {
            return !(0, $3YEvF.default)(keys, key);
        };
    }
    return (0, $lsaWo.default)(obj, iteratee, context);
});

});

parcelRegister("kAIok", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $efd99aa0ce4ee3bc$export$2e2bcd8739ae039; });

var $6UB42 = parcelRequire("6UB42");
function $efd99aa0ce4ee3bc$export$2e2bcd8739ae039(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[0];
    return (0, $6UB42.default)(array, array.length - n);
}

});
parcelRegister("6UB42", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5084b9383622ba84$export$2e2bcd8739ae039; });

var $5KeSn = parcelRequire("5KeSn");
function $5084b9383622ba84$export$2e2bcd8739ae039(array, n, guard) {
    return (0, $5KeSn.slice).call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
}

});


parcelRegister("cbjL2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8de5d695443446a4$export$2e2bcd8739ae039; });

var $cNTA9 = parcelRequire("cNTA9");
function $8de5d695443446a4$export$2e2bcd8739ae039(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[array.length - 1];
    return (0, $cNTA9.default)(array, Math.max(0, array.length - n));
}

});
parcelRegister("cNTA9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95252d1b95c378ad$export$2e2bcd8739ae039; });

var $5KeSn = parcelRequire("5KeSn");
function $95252d1b95c378ad$export$2e2bcd8739ae039(array, n, guard) {
    return (0, $5KeSn.slice).call(array, n == null || guard ? 1 : n);
}

});


parcelRegister("gbwCl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc86f98d33309847$export$2e2bcd8739ae039; });

var $aUKYr = parcelRequire("aUKYr");
function $bc86f98d33309847$export$2e2bcd8739ae039(array) {
    return (0, $aUKYr.default)(array, Boolean);
}

});

parcelRegister("fJVwF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b757ae6b89270cb2$export$2e2bcd8739ae039; });

var $ggEB2 = parcelRequire("ggEB2");
function $b757ae6b89270cb2$export$2e2bcd8739ae039(array, depth) {
    return (0, $ggEB2.default)(array, depth, false);
}

});

parcelRegister("7AzB2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $586781e26e6cad08$export$2e2bcd8739ae039; });

var $8TlO7 = parcelRequire("8TlO7");

var $4p1j6 = parcelRequire("4p1j6");
var // Return a version of the array that does not contain the specified value(s).
$586781e26e6cad08$export$2e2bcd8739ae039 = (0, $8TlO7.default)(function(array, otherArrays) {
    return (0, $4p1j6.default)(array, otherArrays);
});

});
parcelRegister("4p1j6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $334a82c5581f7b31$export$2e2bcd8739ae039; });

var $8TlO7 = parcelRequire("8TlO7");

var $ggEB2 = parcelRequire("ggEB2");

var $aUKYr = parcelRequire("aUKYr");

var $3YEvF = parcelRequire("3YEvF");
var // Take the difference between one array and a number of other arrays.
// Only the elements present in just the first array will remain.
$334a82c5581f7b31$export$2e2bcd8739ae039 = (0, $8TlO7.default)(function(array, rest) {
    rest = (0, $ggEB2.default)(rest, true, true);
    return (0, $aUKYr.default)(array, function(value) {
        return !(0, $3YEvF.default)(rest, value);
    });
});

});


parcelRegister("4QOES", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3883507111f0ccef$export$2e2bcd8739ae039; });

var $im0Um = parcelRequire("im0Um");

var $dxEEe = parcelRequire("dxEEe");

var $9baV7 = parcelRequire("9baV7");

var $3YEvF = parcelRequire("3YEvF");
function $3883507111f0ccef$export$2e2bcd8739ae039(array, isSorted, iteratee, context) {
    if (!(0, $im0Um.default)(isSorted)) {
        context = iteratee;
        iteratee = isSorted;
        isSorted = false;
    }
    if (iteratee != null) iteratee = (0, $dxEEe.default)(iteratee, context);
    var result = [];
    var seen = [];
    for(var i = 0, length = (0, $9baV7.default)(array); i < length; i++){
        var value = array[i], computed = iteratee ? iteratee(value, i, array) : value;
        if (isSorted && !iteratee) {
            if (!i || seen !== computed) result.push(value);
            seen = computed;
        } else if (iteratee) {
            if (!(0, $3YEvF.default)(seen, computed)) {
                seen.push(computed);
                result.push(value);
            }
        } else if (!(0, $3YEvF.default)(result, value)) result.push(value);
    }
    return result;
}

});

parcelRegister("e3v1E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3b9698c8e3a9ccf$export$2e2bcd8739ae039; });

var $8TlO7 = parcelRequire("8TlO7");

var $4QOES = parcelRequire("4QOES");

var $ggEB2 = parcelRequire("ggEB2");
var // Produce an array that contains the union: each distinct element from all of
// the passed-in arrays.
$a3b9698c8e3a9ccf$export$2e2bcd8739ae039 = (0, $8TlO7.default)(function(arrays) {
    return (0, $4QOES.default)((0, $ggEB2.default)(arrays, true, true));
});

});

parcelRegister("jBZcO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e470f32c7cc5100d$export$2e2bcd8739ae039; });

var $9baV7 = parcelRequire("9baV7");

var $3YEvF = parcelRequire("3YEvF");
function $e470f32c7cc5100d$export$2e2bcd8739ae039(array) {
    var result = [];
    var argsLength = arguments.length;
    for(var i = 0, length = (0, $9baV7.default)(array); i < length; i++){
        var item = array[i];
        if ((0, $3YEvF.default)(result, item)) continue;
        var j;
        for(j = 1; j < argsLength; j++){
            if (!(0, $3YEvF.default)(arguments[j], item)) break;
        }
        if (j === argsLength) result.push(item);
    }
    return result;
}

});

parcelRegister("j50f9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de3eac447b11e75b$export$2e2bcd8739ae039; });

var $8QPB7 = parcelRequire("8QPB7");

var $9baV7 = parcelRequire("9baV7");

var $1RCtE = parcelRequire("1RCtE");
function $de3eac447b11e75b$export$2e2bcd8739ae039(array) {
    var length = array && (0, $8QPB7.default)(array, (0, $9baV7.default)).length || 0;
    var result = Array(length);
    for(var index = 0; index < length; index++)result[index] = (0, $1RCtE.default)(array, index);
    return result;
}

});

parcelRegister("1Pr39", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $154f896359a97a38$export$2e2bcd8739ae039; });

var $8TlO7 = parcelRequire("8TlO7");

var $j50f9 = parcelRequire("j50f9");
var // Zip together multiple lists into a single array -- elements that share
// an index go together.
$154f896359a97a38$export$2e2bcd8739ae039 = (0, $8TlO7.default)((0, $j50f9.default));

});

parcelRegister("7CkIw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58bc270240349a7b$export$2e2bcd8739ae039; });

var $9baV7 = parcelRequire("9baV7");
function $58bc270240349a7b$export$2e2bcd8739ae039(list, values) {
    var result = {};
    for(var i = 0, length = (0, $9baV7.default)(list); i < length; i++)if (values) result[list[i]] = values[i];
    else result[list[i][0]] = list[i][1];
    return result;
}

});

parcelRegister("e0VLE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a33de034295cc304$export$2e2bcd8739ae039; });
// Generate an integer Array containing an arithmetic progression. A port of
// the native Python `range()` function. See
// [the Python documentation](https://docs.python.org/library/functions.html#range).
function $a33de034295cc304$export$2e2bcd8739ae039(start, stop, step) {
    if (stop == null) {
        stop = start || 0;
        start = 0;
    }
    if (!step) step = stop < start ? -1 : 1;
    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);
    for(var idx = 0; idx < length; idx++, start += step)range[idx] = start;
    return range;
}

});

parcelRegister("l0iKy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4a824641602ac50$export$2e2bcd8739ae039; });

var $5KeSn = parcelRequire("5KeSn");
function $f4a824641602ac50$export$2e2bcd8739ae039(array, count) {
    if (count == null || count < 1) return [];
    var result = [];
    var i = 0, length = array.length;
    while(i < length)result.push((0, $5KeSn.slice).call(array, i, i += count));
    return result;
}

});

parcelRegister("2ta8m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1cc62693d118c422$export$2e2bcd8739ae039; });

var $7BHIQ = parcelRequire("7BHIQ");

var $kQFPC = parcelRequire("kQFPC");

var $bPMbE = parcelRequire("bPMbE");

var $5KeSn = parcelRequire("5KeSn");

var $gzGb9 = parcelRequire("gzGb9");
function $1cc62693d118c422$export$2e2bcd8739ae039(obj) {
    (0, $kQFPC.default)((0, $bPMbE.default)(obj), function(name) {
        var func = (0, $7BHIQ.default)[name] = obj[name];
        (0, $7BHIQ.default).prototype[name] = function() {
            var args = [
                this._wrapped
            ];
            (0, $5KeSn.push).apply(args, arguments);
            return (0, $gzGb9.default)(this, func.apply((0, $7BHIQ.default), args));
        };
    });
    return 0, $7BHIQ.default;
}

});
parcelRegister("gzGb9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c110a211795436d7$export$2e2bcd8739ae039; });

var $7BHIQ = parcelRequire("7BHIQ");
function $c110a211795436d7$export$2e2bcd8739ae039(instance, obj) {
    return instance._chain ? (0, $7BHIQ.default)(obj).chain() : obj;
}

});


parcelRegister("h9p7q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7c6c2f9df137cdf$export$2e2bcd8739ae039; });

var $7BHIQ = parcelRequire("7BHIQ");

var $kQFPC = parcelRequire("kQFPC");

var $5KeSn = parcelRequire("5KeSn");

var $gzGb9 = parcelRequire("gzGb9");
// Add all mutator `Array` functions to the wrapper.
(0, $kQFPC.default)([
    "pop",
    "push",
    "reverse",
    "shift",
    "sort",
    "splice",
    "unshift"
], function(name) {
    var method = (0, $5KeSn.ArrayProto)[name];
    (0, $7BHIQ.default).prototype[name] = function() {
        var obj = this._wrapped;
        if (obj != null) {
            method.apply(obj, arguments);
            if ((name === "shift" || name === "splice") && obj.length === 0) delete obj[0];
        }
        return (0, $gzGb9.default)(this, obj);
    };
});
// Add all accessor `Array` functions to the wrapper.
(0, $kQFPC.default)([
    "concat",
    "join",
    "slice"
], function(name) {
    var method = (0, $5KeSn.ArrayProto)[name];
    (0, $7BHIQ.default).prototype[name] = function() {
        var obj = this._wrapped;
        if (obj != null) obj = method.apply(obj, arguments);
        return (0, $gzGb9.default)(this, obj);
    };
});
var $c7c6c2f9df137cdf$export$2e2bcd8739ae039 = (0, $7BHIQ.default);

});




parcelRegister("3PAB5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ca285f4ec087461$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "OrganisationCollectionClass", function () { return $2ca285f4ec087461$export$296d1b1c962329c4; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $fcXCK = parcelRequire("fcXCK");
var $2ca285f4ec087461$var$_dec, $2ca285f4ec087461$var$_dec2, $2ca285f4ec087461$var$_class;
function $2ca285f4ec087461$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $2ca285f4ec087461$var$OrganisationCollection = ($2ca285f4ec087461$var$_dec = (0, $4JcCM.action).bound, $2ca285f4ec087461$var$_dec2 = (0, $4JcCM.action).bound, $2ca285f4ec087461$var$_class = class OrganisationCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "organisations",
            modelClass: (0, $fcXCK.default)
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get organisationsById() {
        return this.modelsById;
    }
    get organisations() {
        return this.models;
    }
    addOrganisation(data) {
        this.add(data);
    }
    addOrganisations(data) {
        this.addMany(data);
    }
}, $2ca285f4ec087461$var$_applyDecoratedDescriptor($2ca285f4ec087461$var$_class.prototype, "addOrganisation", [
    $2ca285f4ec087461$var$_dec
], Object.getOwnPropertyDescriptor($2ca285f4ec087461$var$_class.prototype, "addOrganisation"), $2ca285f4ec087461$var$_class.prototype), $2ca285f4ec087461$var$_applyDecoratedDescriptor($2ca285f4ec087461$var$_class.prototype, "addOrganisations", [
    $2ca285f4ec087461$var$_dec2
], Object.getOwnPropertyDescriptor($2ca285f4ec087461$var$_class.prototype, "addOrganisations"), $2ca285f4ec087461$var$_class.prototype), $2ca285f4ec087461$var$_class);
var $2ca285f4ec087461$export$2e2bcd8739ae039 = new $2ca285f4ec087461$var$OrganisationCollection();
const $2ca285f4ec087461$export$296d1b1c962329c4 = $2ca285f4ec087461$var$OrganisationCollection;

});
parcelRegister("fcXCK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1263a127c17d566$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $9U4Mw = parcelRequire("9U4Mw");

var $hn9pE = parcelRequire("hn9pE");

var $g6lcW = parcelRequire("g6lcW");

var $kp6ni = parcelRequire("kp6ni");

var $2J8OV = parcelRequire("2J8OV");

var $lUJ9H = parcelRequire("lUJ9H");

var $gIG4O = parcelRequire("gIG4O");

var $3PAB5 = parcelRequire("3PAB5");

var $h6zQv = parcelRequire("h6zQv");

var $4iwZm = parcelRequire("4iwZm");

var $1k348 = parcelRequire("1k348");

var $8Ef5K = parcelRequire("8Ef5K");

var $3PpOX = parcelRequire("3PpOX");

var $96Qvl = parcelRequire("96Qvl");

var $3ArO6 = parcelRequire("3ArO6");

var $i0u26 = parcelRequire("i0u26");

var $htkeB = parcelRequire("htkeB");

var $gN0TC = parcelRequire("gN0TC");
var $b1263a127c17d566$var$_dec, $b1263a127c17d566$var$_dec2, $b1263a127c17d566$var$_dec3, $b1263a127c17d566$var$_dec4, $b1263a127c17d566$var$_dec5, $b1263a127c17d566$var$_class, $b1263a127c17d566$var$_descriptor, $b1263a127c17d566$var$_descriptor2, $b1263a127c17d566$var$_descriptor3, $b1263a127c17d566$var$_descriptor4, $b1263a127c17d566$var$_descriptor5, $b1263a127c17d566$var$_descriptor6, $b1263a127c17d566$var$_descriptor7, $b1263a127c17d566$var$_descriptor8, $b1263a127c17d566$var$_descriptor9, $b1263a127c17d566$var$_descriptor10, $b1263a127c17d566$var$_descriptor11, $b1263a127c17d566$var$_descriptor12, $b1263a127c17d566$var$_descriptor13, $b1263a127c17d566$var$_descriptor14, $b1263a127c17d566$var$_descriptor15;
function $b1263a127c17d566$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $b1263a127c17d566$var$_defineProperty(e, r, t) {
    return (r = $b1263a127c17d566$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $b1263a127c17d566$var$_toPropertyKey(t) {
    var i = $b1263a127c17d566$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $b1263a127c17d566$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $b1263a127c17d566$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $b1263a127c17d566$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $b1263a127c17d566$var$OrganisationModel = ($b1263a127c17d566$var$_dec = (0, $4JcCM.action).bound, $b1263a127c17d566$var$_dec2 = (0, $4JcCM.action).bound, $b1263a127c17d566$var$_dec3 = (0, $4JcCM.action).bound, $b1263a127c17d566$var$_dec4 = (0, $4JcCM.action).bound, $b1263a127c17d566$var$_dec5 = (0, $4JcCM.action).bound, $b1263a127c17d566$var$_class = class OrganisationModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $b1263a127c17d566$var$_initializerDefineProperty(this, "accountingSystem", $b1263a127c17d566$var$_descriptor, this);
        $b1263a127c17d566$var$_initializerDefineProperty(this, "settings", $b1263a127c17d566$var$_descriptor2, this);
        $b1263a127c17d566$var$_initializerDefineProperty(this, "defaultRevenueForecastReportId", $b1263a127c17d566$var$_descriptor3, this);
        $b1263a127c17d566$var$_initializerDefineProperty(this, "defaultResourceScheduleReportId", $b1263a127c17d566$var$_descriptor4, this);
        $b1263a127c17d566$var$_initializerDefineProperty(this, "defaultProjectReportId", $b1263a127c17d566$var$_descriptor5, this);
        $b1263a127c17d566$var$_initializerDefineProperty(this, "defaultStaffReportId", $b1263a127c17d566$var$_descriptor6, this);
        $b1263a127c17d566$var$_initializerDefineProperty(this, "defaultTimeReportId", $b1263a127c17d566$var$_descriptor7, this);
        $b1263a127c17d566$var$_initializerDefineProperty(this, "defaultInvoiceReportId", $b1263a127c17d566$var$_descriptor8, this);
        $b1263a127c17d566$var$_initializerDefineProperty(this, "defaultContactReportId", $b1263a127c17d566$var$_descriptor9, this);
        $b1263a127c17d566$var$_initializerDefineProperty(this, "defaultExpenseReportId", $b1263a127c17d566$var$_descriptor10, this);
        $b1263a127c17d566$var$_initializerDefineProperty(this, "defaultPermissionsId", $b1263a127c17d566$var$_descriptor11, this);
        $b1263a127c17d566$var$_initializerDefineProperty(this, "creatorStaffMemberId", $b1263a127c17d566$var$_descriptor12, this);
        $b1263a127c17d566$var$_initializerDefineProperty(this, "migratedAt", $b1263a127c17d566$var$_descriptor13, this);
        $b1263a127c17d566$var$_initializerDefineProperty(this, "country", $b1263a127c17d566$var$_descriptor14, this);
        $b1263a127c17d566$var$_initializerDefineProperty(this, "invoiceTemplates", $b1263a127c17d566$var$_descriptor15, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $3PAB5.default);
        this.init(data, options);
    }
    get defaultInvoiceTemplate() {
        var _this$settings, _this$settings$invoic, _this$invoiceTemplate, _this$invoiceTemplate2, _this$invoiceTemplate3, _this$settings2, _this$settings2$invoi, _this$settings2$invoi2, _this$invoiceTemplate4;
        const id = Object.keys(this.invoiceTemplates || {})[0] || Object.keys(((_this$settings = this.settings) === null || _this$settings === void 0 ? void 0 : (_this$settings$invoic = _this$settings.invoice) === null || _this$settings$invoic === void 0 ? void 0 : _this$settings$invoic.templates) || {})[0] || (0, (/*@__PURE__*/$parcel$interopDefault($gN0TC)))();
        (_this$invoiceTemplate = this.invoiceTemplates) !== null && _this$invoiceTemplate !== void 0 ? _this$invoiceTemplate : this.invoiceTemplates = {};
        (_this$invoiceTemplate3 = (_this$invoiceTemplate2 = this.invoiceTemplates)[id]) !== null && _this$invoiceTemplate3 !== void 0 ? _this$invoiceTemplate3 : _this$invoiceTemplate2[id] = new (0, $8Ef5K.default)(this, ((_this$settings2 = this.settings) === null || _this$settings2 === void 0 ? void 0 : (_this$settings2$invoi = _this$settings2.invoice) === null || _this$settings2$invoi === void 0 ? void 0 : (_this$settings2$invoi2 = _this$settings2$invoi.templates) === null || _this$settings2$invoi2 === void 0 ? void 0 : _this$settings2$invoi2[id]) || {});
        return (_this$invoiceTemplate4 = this.invoiceTemplates) === null || _this$invoiceTemplate4 === void 0 ? void 0 : _this$invoiceTemplate4[id];
    }
    get defaultProjectReport() {
        return (0, $h6zQv.default).reportsById[this.defaultProjectReportId] || new (0, $96Qvl.default)({
            ...(0, $hn9pE.default),
            systemReport: true
        }, {
            detached: true
        });
    }
    get defaultStaffReport() {
        return (0, $h6zQv.default).reportsById[this.defaultStaffReportId] || new (0, $96Qvl.default)({
            ...(0, $2J8OV.default),
            systemReport: true
        }, {
            detached: true
        });
    }
    get defaultInvoiceReport() {
        return (0, $h6zQv.default).reportsById[this.defaultInvoiceReportId] || new (0, $96Qvl.default)({
            ...(0, $9U4Mw.default),
            systemReport: true
        }, {
            detached: true
        });
    }
    get defaultTimeReport() {
        return (0, $h6zQv.default).reportsById[this.defaultTimeReportId] || new (0, $96Qvl.default)({
            ...(0, $lUJ9H.default),
            systemReport: true
        }, {
            detached: true
        });
    }
    get defaultExpenseReport() {
        return (0, $h6zQv.default).reportsById[this.defaultExpenseReportId] || new (0, $96Qvl.default)({
            ...(0, $gIG4O.default),
            systemReport: true
        }, {
            detached: true
        });
    }
    get defaultRevenueForecastReport() {
        return (0, $1k348.default).revenueForecastReportsById[this.defaultRevenueForecastReportId] || new (0, $i0u26.default)({
            ...(0, $kp6ni.default),
            filters: {
                ...(0, $kp6ni.default).filters,
                invoiceData: (this.settings.reportInvoiceDateType || "issueDate").replace("issueDate", "issuedOn")
            },
            systemReport: true
        }, {
            detached: true
        });
    }
    get defaultResourceScheduleReport() {
        return this.defaultResourceScheduleReportId && (0, $4iwZm.default).resourceSchedulesById[this.defaultResourceScheduleReportId] ? (0, $4iwZm.default).resourceSchedulesById[this.defaultResourceScheduleReportId] : new (0, $3ArO6.default)({
            ...(0, $g6lcW.default),
            systemReport: true
        }, {
            detached: true
        });
    }
    get accountingSystemSettings() {
        var _this$settings3, _this$settings3$accou, _this$settings4;
        (_this$settings3$accou = (_this$settings3 = this.settings).accountingSystemSettings) !== null && _this$settings3$accou !== void 0 ? _this$settings3$accou : _this$settings3.accountingSystemSettings = {};
        return (_this$settings4 = this.settings) === null || _this$settings4 === void 0 ? void 0 : _this$settings4.accountingSystemSettings[this.accountingSystem];
    }
    updateInvoiceTemplate(templateData) {
        var _settings$invoice, _settings$invoice2, _settings$invoice2$te;
        const settings = {
            ...this.settings
        };
        (_settings$invoice = settings.invoice) !== null && _settings$invoice !== void 0 ? _settings$invoice : settings.invoice = {};
        (_settings$invoice2$te = (_settings$invoice2 = settings.invoice).templates) !== null && _settings$invoice2$te !== void 0 ? _settings$invoice2$te : _settings$invoice2.templates = {};
        settings.invoice.templates[templateData.id] = templateData;
        this.update({
            settings: settings
        });
    }
    updateInvoiceSettings(invoiceSettings) {
        var _settings$invoice3;
        const settings = {
            ...this.settings
        };
        (_settings$invoice3 = settings.invoice) !== null && _settings$invoice3 !== void 0 ? _settings$invoice3 : settings.invoice = {};
        settings.invoice = {
            ...settings.invoice,
            ...invoiceSettings
        };
        this.update({
            settings: settings
        });
    }
    incrementInvoiceNumber(projectId) {
        var _this$settings$invoic2, _this$settings$invoic3, _this$settings$invoic4, _this$settings$invoic5, _this$settings$invoic6, _this$settings$invoic7, _this$settings$invoic8;
        const thisYear = new Date().getFullYear();
        this.updateInvoiceSettings({
            invNum: (((_this$settings$invoic2 = this.settings.invoice) === null || _this$settings$invoic2 === void 0 ? void 0 : _this$settings$invoic2.invNum) || 0) + 1,
            invNumProj: {
                ...((_this$settings$invoic3 = this.settings.invoice) === null || _this$settings$invoic3 === void 0 ? void 0 : _this$settings$invoic3.invNumProj) || {},
                [projectId]: (((_this$settings$invoic4 = this.settings.invoice) === null || _this$settings$invoic4 === void 0 ? void 0 : (_this$settings$invoic5 = _this$settings$invoic4.invNumProj) === null || _this$settings$invoic5 === void 0 ? void 0 : _this$settings$invoic5[projectId]) || 0) + 1
            },
            invNumYear: {
                ...((_this$settings$invoic6 = this.settings.invoice) === null || _this$settings$invoic6 === void 0 ? void 0 : _this$settings$invoic6.invNumYear) || {},
                [thisYear]: (((_this$settings$invoic7 = this.settings.invoice) === null || _this$settings$invoic7 === void 0 ? void 0 : (_this$settings$invoic8 = _this$settings$invoic7.invNumYear) === null || _this$settings$invoic8 === void 0 ? void 0 : _this$settings$invoic8[thisYear]) || 0) + 1
            }
        });
    }
    decrementInvoiceNumber(projectId) {
        var _this$settings$invoic9, _this$settings$invoic10, _this$settings$invoic11, _this$settings$invoic12, _this$settings$invoic13, _this$settings$invoic14, _this$settings$invoic15;
        const thisYear = new Date().getFullYear();
        this.updateInvoiceSettings({
            invNum: (((_this$settings$invoic9 = this.settings.invoice) === null || _this$settings$invoic9 === void 0 ? void 0 : _this$settings$invoic9.invNum) || 0) - 1,
            invNumProj: {
                ...((_this$settings$invoic10 = this.settings.invoice) === null || _this$settings$invoic10 === void 0 ? void 0 : _this$settings$invoic10.invNumProj) || {},
                [projectId]: (((_this$settings$invoic11 = this.settings.invoice) === null || _this$settings$invoic11 === void 0 ? void 0 : (_this$settings$invoic12 = _this$settings$invoic11.invNumProj) === null || _this$settings$invoic12 === void 0 ? void 0 : _this$settings$invoic12[projectId]) || 0) - 1
            },
            invNumYear: {
                ...((_this$settings$invoic13 = this.settings.invoice) === null || _this$settings$invoic13 === void 0 ? void 0 : _this$settings$invoic13.invNumYear) || {},
                [String(thisYear)]: (((_this$settings$invoic14 = this.settings.invoice) === null || _this$settings$invoic14 === void 0 ? void 0 : (_this$settings$invoic15 = _this$settings$invoic14.invNumYear) === null || _this$settings$invoic15 === void 0 ? void 0 : _this$settings$invoic15[String(thisYear)]) || 0) - 1
            }
        });
    }
    updateAccountingSystemSettings(accountingSystemSettings) {
        var _settings$accountingS, _settings$accountingS2, _this$accountingSyste, _settings$accountingS3;
        const settings = {
            ...this.settings
        };
        (_settings$accountingS = settings.accountingSystemSettings) !== null && _settings$accountingS !== void 0 ? _settings$accountingS : settings.accountingSystemSettings = {};
        (_settings$accountingS3 = (_settings$accountingS2 = settings.accountingSystemSettings)[_this$accountingSyste = this.accountingSystem]) !== null && _settings$accountingS3 !== void 0 ? _settings$accountingS3 : _settings$accountingS2[_this$accountingSyste] = {};
        settings.accountingSystemSettings[this.accountingSystem] = {
            ...settings.accountingSystemSettings[this.accountingSystem],
            ...accountingSystemSettings
        };
        this.update({
            settings: settings
        });
    }
    get creatorStaff() {
        return (0, $htkeB.default).staffsById[this.creatorStaffMemberId];
    }
}, $b1263a127c17d566$var$_descriptor = $b1263a127c17d566$var$_applyDecoratedDescriptor($b1263a127c17d566$var$_class.prototype, "accountingSystem", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $b1263a127c17d566$var$_descriptor2 = $b1263a127c17d566$var$_applyDecoratedDescriptor($b1263a127c17d566$var$_class.prototype, "settings", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $b1263a127c17d566$var$_descriptor3 = $b1263a127c17d566$var$_applyDecoratedDescriptor($b1263a127c17d566$var$_class.prototype, "defaultRevenueForecastReportId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $b1263a127c17d566$var$_descriptor4 = $b1263a127c17d566$var$_applyDecoratedDescriptor($b1263a127c17d566$var$_class.prototype, "defaultResourceScheduleReportId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $b1263a127c17d566$var$_descriptor5 = $b1263a127c17d566$var$_applyDecoratedDescriptor($b1263a127c17d566$var$_class.prototype, "defaultProjectReportId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $b1263a127c17d566$var$_descriptor6 = $b1263a127c17d566$var$_applyDecoratedDescriptor($b1263a127c17d566$var$_class.prototype, "defaultStaffReportId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $b1263a127c17d566$var$_descriptor7 = $b1263a127c17d566$var$_applyDecoratedDescriptor($b1263a127c17d566$var$_class.prototype, "defaultTimeReportId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $b1263a127c17d566$var$_descriptor8 = $b1263a127c17d566$var$_applyDecoratedDescriptor($b1263a127c17d566$var$_class.prototype, "defaultInvoiceReportId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $b1263a127c17d566$var$_descriptor9 = $b1263a127c17d566$var$_applyDecoratedDescriptor($b1263a127c17d566$var$_class.prototype, "defaultContactReportId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $b1263a127c17d566$var$_descriptor10 = $b1263a127c17d566$var$_applyDecoratedDescriptor($b1263a127c17d566$var$_class.prototype, "defaultExpenseReportId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $b1263a127c17d566$var$_descriptor11 = $b1263a127c17d566$var$_applyDecoratedDescriptor($b1263a127c17d566$var$_class.prototype, "defaultPermissionsId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $b1263a127c17d566$var$_descriptor12 = $b1263a127c17d566$var$_applyDecoratedDescriptor($b1263a127c17d566$var$_class.prototype, "creatorStaffMemberId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $b1263a127c17d566$var$_descriptor13 = $b1263a127c17d566$var$_applyDecoratedDescriptor($b1263a127c17d566$var$_class.prototype, "migratedAt", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $b1263a127c17d566$var$_descriptor14 = $b1263a127c17d566$var$_applyDecoratedDescriptor($b1263a127c17d566$var$_class.prototype, "country", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $b1263a127c17d566$var$_descriptor15 = $b1263a127c17d566$var$_applyDecoratedDescriptor($b1263a127c17d566$var$_class.prototype, "invoiceTemplates", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $b1263a127c17d566$var$_applyDecoratedDescriptor($b1263a127c17d566$var$_class.prototype, "defaultInvoiceTemplate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($b1263a127c17d566$var$_class.prototype, "defaultInvoiceTemplate"), $b1263a127c17d566$var$_class.prototype), $b1263a127c17d566$var$_applyDecoratedDescriptor($b1263a127c17d566$var$_class.prototype, "defaultProjectReport", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($b1263a127c17d566$var$_class.prototype, "defaultProjectReport"), $b1263a127c17d566$var$_class.prototype), $b1263a127c17d566$var$_applyDecoratedDescriptor($b1263a127c17d566$var$_class.prototype, "defaultStaffReport", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($b1263a127c17d566$var$_class.prototype, "defaultStaffReport"), $b1263a127c17d566$var$_class.prototype), $b1263a127c17d566$var$_applyDecoratedDescriptor($b1263a127c17d566$var$_class.prototype, "defaultInvoiceReport", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($b1263a127c17d566$var$_class.prototype, "defaultInvoiceReport"), $b1263a127c17d566$var$_class.prototype), $b1263a127c17d566$var$_applyDecoratedDescriptor($b1263a127c17d566$var$_class.prototype, "defaultTimeReport", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($b1263a127c17d566$var$_class.prototype, "defaultTimeReport"), $b1263a127c17d566$var$_class.prototype), $b1263a127c17d566$var$_applyDecoratedDescriptor($b1263a127c17d566$var$_class.prototype, "defaultExpenseReport", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($b1263a127c17d566$var$_class.prototype, "defaultExpenseReport"), $b1263a127c17d566$var$_class.prototype), $b1263a127c17d566$var$_applyDecoratedDescriptor($b1263a127c17d566$var$_class.prototype, "defaultRevenueForecastReport", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($b1263a127c17d566$var$_class.prototype, "defaultRevenueForecastReport"), $b1263a127c17d566$var$_class.prototype), $b1263a127c17d566$var$_applyDecoratedDescriptor($b1263a127c17d566$var$_class.prototype, "defaultResourceScheduleReport", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($b1263a127c17d566$var$_class.prototype, "defaultResourceScheduleReport"), $b1263a127c17d566$var$_class.prototype), $b1263a127c17d566$var$_applyDecoratedDescriptor($b1263a127c17d566$var$_class.prototype, "accountingSystemSettings", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($b1263a127c17d566$var$_class.prototype, "accountingSystemSettings"), $b1263a127c17d566$var$_class.prototype), $b1263a127c17d566$var$_applyDecoratedDescriptor($b1263a127c17d566$var$_class.prototype, "updateInvoiceTemplate", [
    $b1263a127c17d566$var$_dec
], Object.getOwnPropertyDescriptor($b1263a127c17d566$var$_class.prototype, "updateInvoiceTemplate"), $b1263a127c17d566$var$_class.prototype), $b1263a127c17d566$var$_applyDecoratedDescriptor($b1263a127c17d566$var$_class.prototype, "updateInvoiceSettings", [
    $b1263a127c17d566$var$_dec2
], Object.getOwnPropertyDescriptor($b1263a127c17d566$var$_class.prototype, "updateInvoiceSettings"), $b1263a127c17d566$var$_class.prototype), $b1263a127c17d566$var$_applyDecoratedDescriptor($b1263a127c17d566$var$_class.prototype, "incrementInvoiceNumber", [
    $b1263a127c17d566$var$_dec3
], Object.getOwnPropertyDescriptor($b1263a127c17d566$var$_class.prototype, "incrementInvoiceNumber"), $b1263a127c17d566$var$_class.prototype), $b1263a127c17d566$var$_applyDecoratedDescriptor($b1263a127c17d566$var$_class.prototype, "decrementInvoiceNumber", [
    $b1263a127c17d566$var$_dec4
], Object.getOwnPropertyDescriptor($b1263a127c17d566$var$_class.prototype, "decrementInvoiceNumber"), $b1263a127c17d566$var$_class.prototype), $b1263a127c17d566$var$_applyDecoratedDescriptor($b1263a127c17d566$var$_class.prototype, "updateAccountingSystemSettings", [
    $b1263a127c17d566$var$_dec5
], Object.getOwnPropertyDescriptor($b1263a127c17d566$var$_class.prototype, "updateAccountingSystemSettings"), $b1263a127c17d566$var$_class.prototype), $b1263a127c17d566$var$_applyDecoratedDescriptor($b1263a127c17d566$var$_class.prototype, "creatorStaff", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($b1263a127c17d566$var$_class.prototype, "creatorStaff"), $b1263a127c17d566$var$_class.prototype), $b1263a127c17d566$var$_class);
var $b1263a127c17d566$export$2e2bcd8739ae039 = $b1263a127c17d566$var$OrganisationModel;

});
parcelRegister("9U4Mw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $735d0d890186af45$export$2e2bcd8739ae039; });
var $735d0d890186af45$export$2e2bcd8739ae039 = {
    name: "New Report",
    type: "invoice",
    columns: [
        "description",
        "project",
        "issuedOn",
        "amountIncTax",
        "synced"
    ],
    filters: [
        {
            column: "projectStatus",
            operator: "in",
            value: [
                "active"
            ],
            group: "project"
        }
    ],
    defaultGroup: "invoice",
    groupBy: [],
    sortBy: [
        [
            "issuedOn",
            "desc"
        ]
    ],
    options: {
        dateRange: "allTime"
    }
};

});

parcelRegister("hn9pE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca5be2ce0b3930eb$export$2e2bcd8739ae039; });
var $ca5be2ce0b3930eb$export$2e2bcd8739ae039 = {
    name: "New Report",
    type: "project",
    columns: [
        "name",
        "actualVsBudgetedHours",
        "actualVsBudgetedExpenses",
        "revenueVsFee",
        "profit",
        "profitMargin"
    ],
    filters: [
        {
            column: "status",
            operator: "!in",
            value: [
                "archived"
            ],
            group: "project"
        }
    ],
    // defaultGroup: 'phase',
    // groupBy: ['project'],
    // sortBy: [['name', 'asc']],
    options: {
        dateRange: "allTime"
    }
};

});

parcelRegister("g6lcW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb8da84e93ffb92f$export$2e2bcd8739ae039; });
var $bb8da84e93ffb92f$export$2e2bcd8739ae039 = {
    name: "New Report",
    filters: {
        costCentres: [],
        futureRows: false,
        groups: [
            "role",
            "staff",
            "project",
            "phase"
        ],
        hoursData: "actualsProjected",
        percentData: "utilisation",
        phaseStatus: false,
        projectOwners: [],
        projectStatus: [],
        projects: [],
        roles: [],
        staff: [],
        totalData: "budgetUse",
        period: "month",
        activePhases: false
    }
};

});

parcelRegister("kp6ni", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $edab1658ce156285$export$2e2bcd8739ae039; });
var $edab1658ce156285$export$2e2bcd8739ae039 = {
    name: "New Report",
    filters: {
        costCentres: [],
        expenses: [],
        invoiceData: "issuedOn",
        projectStatus: [],
        projects: [],
        revenueData: "actualsProjected",
        staff: [],
        projectOwners: [],
        totalData: "revenueTotalFee",
        profitDataType: "margin",
        contractorExpense: "availableHours",
        showExpenses: true,
        statusGroup: "phase"
    }
};

});

parcelRegister("2J8OV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1fc6a045bd4a80e6$export$2e2bcd8739ae039; });
var $1fc6a045bd4a80e6$export$2e2bcd8739ae039 = {
    name: "New Report",
    type: "staffMember",
    columns: [
        "name",
        "email",
        "recordedHours"
    ],
    filters: [
        {
            column: "isActive",
            operator: "=",
            value: true
        }
    ],
    defaultGroup: "staff",
    groupBy: [],
    sortBy: [
        [
            "name",
            "asc"
        ]
    ],
    options: {
        dateRange: "thisWeek"
    }
};

});

parcelRegister("lUJ9H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff41dae011521a6a$export$2e2bcd8739ae039; });
var $ff41dae011521a6a$export$2e2bcd8739ae039 = {
    name: "New Report",
    type: "timesheet",
    columns: [
        "staffMember",
        "project",
        "projectPhase",
        "date",
        "task",
        "numMinutes",
        "cost",
        "chargeOut",
        "notes"
    ],
    filters: [
        {
            column: "project",
            operator: "in",
            value: []
        },
        {
            column: "staffMember",
            operator: "in",
            value: []
        }
    ],
    groupBy: [
        "project",
        "projectPhase"
    ],
    sortBy: [
        [
            "label",
            "asc"
        ]
    ],
    options: {
        dateRange: "thisMonth"
    }
};

});

parcelRegister("gIG4O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2c164ef3d4dc575$export$2e2bcd8739ae039; });
var $c2c164ef3d4dc575$export$2e2bcd8739ae039 = {
    name: "New Report",
    type: "expense",
    columns: [
        "project",
        "projectPhase",
        "expenseName",
        "staffMember",
        "date",
        "recordedExpense",
        "invoicedExpense",
        "plannedExpense",
        "notes"
    ],
    filters: [
        {
            column: "project",
            operator: "in",
            value: []
        }
    ],
    groupBy: [
        "project",
        "projectPhase",
        "expenseName"
    ],
    sortBy: [
        [
            "label",
            "asc"
        ]
    ],
    options: {
        dateRange: "thisMonth"
    }
};

});

parcelRegister("h6zQv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c73ecd7282c4a52f$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "ReportCollectionClass", function () { return $c73ecd7282c4a52f$export$9080ccc27301240c; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $96Qvl = parcelRequire("96Qvl");
var $c73ecd7282c4a52f$var$_dec, $c73ecd7282c4a52f$var$_dec2, $c73ecd7282c4a52f$var$_class;
function $c73ecd7282c4a52f$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $c73ecd7282c4a52f$var$ReportCollection = ($c73ecd7282c4a52f$var$_dec = (0, $4JcCM.action).bound, $c73ecd7282c4a52f$var$_dec2 = (0, $4JcCM.action).bound, $c73ecd7282c4a52f$var$_class = class ReportCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "reports",
            modelClass: (0, $96Qvl.default)
        });
        this.addLookup("reportsByType", "manyByKey", {
            key: (t)=>t.type,
            filter: (t)=>!t.deletedAt
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get reportsById() {
        return this.modelsById;
    }
    get reports() {
        return this.models;
    }
    addReport(data) {
        this.add(data);
    }
    addReports(data) {
        this.addMany(data);
    }
}, $c73ecd7282c4a52f$var$_applyDecoratedDescriptor($c73ecd7282c4a52f$var$_class.prototype, "addReport", [
    $c73ecd7282c4a52f$var$_dec
], Object.getOwnPropertyDescriptor($c73ecd7282c4a52f$var$_class.prototype, "addReport"), $c73ecd7282c4a52f$var$_class.prototype), $c73ecd7282c4a52f$var$_applyDecoratedDescriptor($c73ecd7282c4a52f$var$_class.prototype, "addReports", [
    $c73ecd7282c4a52f$var$_dec2
], Object.getOwnPropertyDescriptor($c73ecd7282c4a52f$var$_class.prototype, "addReports"), $c73ecd7282c4a52f$var$_class.prototype), $c73ecd7282c4a52f$var$_class);
var $c73ecd7282c4a52f$export$2e2bcd8739ae039 = new $c73ecd7282c4a52f$var$ReportCollection();
const $c73ecd7282c4a52f$export$9080ccc27301240c = $c73ecd7282c4a52f$var$ReportCollection;

});
parcelRegister("96Qvl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a1d66e554b4aa79$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $cnmvx = parcelRequire("cnmvx");

var $9Gpjo = parcelRequire("9Gpjo");

var $h6zQv = parcelRequire("h6zQv");

var $3PpOX = parcelRequire("3PpOX");

var $cV8g5 = parcelRequire("cV8g5");

var $6mjwz = parcelRequire("6mjwz");

var $hdshG = parcelRequire("hdshG");

var $495xp = parcelRequire("495xp");

var $lvlQM = parcelRequire("lvlQM");
parcelRequire("XoImS");

var $hn9pE = parcelRequire("hn9pE");

var $eat5C = parcelRequire("eat5C");

var $1BTI2 = parcelRequire("1BTI2");

var $5M65g = parcelRequire("5M65g");

var $lUJ9H = parcelRequire("lUJ9H");

var $2J8OV = parcelRequire("2J8OV");

var $9U4Mw = parcelRequire("9U4Mw");

var $QiMYe = parcelRequire("QiMYe");

var $gJT7h = parcelRequire("gJT7h");
parcelRequire("eBwNQ");
var $Xm84r = parcelRequire("Xm84r");

var $62nmb = parcelRequire("62nmb");

var $gIG4O = parcelRequire("gIG4O");

var $lq6jw = parcelRequire("lq6jw");
var $6a1d66e554b4aa79$var$_dec, $6a1d66e554b4aa79$var$_dec2, $6a1d66e554b4aa79$var$_dec3, $6a1d66e554b4aa79$var$_dec4, $6a1d66e554b4aa79$var$_dec5, $6a1d66e554b4aa79$var$_dec6, $6a1d66e554b4aa79$var$_dec7, $6a1d66e554b4aa79$var$_dec8, $6a1d66e554b4aa79$var$_dec9, $6a1d66e554b4aa79$var$_class, $6a1d66e554b4aa79$var$_descriptor, $6a1d66e554b4aa79$var$_descriptor2, $6a1d66e554b4aa79$var$_descriptor3, $6a1d66e554b4aa79$var$_descriptor4, $6a1d66e554b4aa79$var$_descriptor5, $6a1d66e554b4aa79$var$_descriptor6, $6a1d66e554b4aa79$var$_descriptor7, $6a1d66e554b4aa79$var$_descriptor8, $6a1d66e554b4aa79$var$_descriptor9, $6a1d66e554b4aa79$var$_descriptor10;
function $6a1d66e554b4aa79$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $6a1d66e554b4aa79$var$_defineProperty(e, r, t) {
    return (r = $6a1d66e554b4aa79$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $6a1d66e554b4aa79$var$_toPropertyKey(t) {
    var i = $6a1d66e554b4aa79$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $6a1d66e554b4aa79$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $6a1d66e554b4aa79$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $6a1d66e554b4aa79$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
const $6a1d66e554b4aa79$var$reportDefaults = {
    project: (0, $hn9pE.default),
    staff: (0, $2J8OV.default),
    invoice: (0, $9U4Mw.default),
    timesheet: (0, $lUJ9H.default),
    expense: (0, $gIG4O.default)
};
let $6a1d66e554b4aa79$var$ReportModel = ($6a1d66e554b4aa79$var$_dec = (0, $4JcCM.action).bound, $6a1d66e554b4aa79$var$_dec2 = (0, $4JcCM.action).bound, $6a1d66e554b4aa79$var$_dec3 = (0, $4JcCM.action).bound, $6a1d66e554b4aa79$var$_dec4 = (0, $4JcCM.action).bound, $6a1d66e554b4aa79$var$_dec5 = (0, $4JcCM.action).bound, $6a1d66e554b4aa79$var$_dec6 = (0, $4JcCM.action).bound, $6a1d66e554b4aa79$var$_dec7 = (0, $4JcCM.action).bound, $6a1d66e554b4aa79$var$_dec8 = (0, $4JcCM.action).bound, $6a1d66e554b4aa79$var$_dec9 = (0, $4JcCM.action).bound, $6a1d66e554b4aa79$var$_class = class ReportModel extends (0, $3PpOX.default) {
    constructor(data, options){
        var _data$options, _data$options2, _data$options3;
        super();
        $6a1d66e554b4aa79$var$_initializerDefineProperty(this, "name", $6a1d66e554b4aa79$var$_descriptor, this);
        $6a1d66e554b4aa79$var$_initializerDefineProperty(this, "type", $6a1d66e554b4aa79$var$_descriptor2, this);
        $6a1d66e554b4aa79$var$_initializerDefineProperty(this, "columns", $6a1d66e554b4aa79$var$_descriptor3, this);
        $6a1d66e554b4aa79$var$_initializerDefineProperty(this, "filters", $6a1d66e554b4aa79$var$_descriptor4, this);
        $6a1d66e554b4aa79$var$_initializerDefineProperty(this, "groupBy", $6a1d66e554b4aa79$var$_descriptor5, this);
        $6a1d66e554b4aa79$var$_initializerDefineProperty(this, "sortBy", $6a1d66e554b4aa79$var$_descriptor6, this);
        $6a1d66e554b4aa79$var$_initializerDefineProperty(this, "options", $6a1d66e554b4aa79$var$_descriptor7, this);
        $6a1d66e554b4aa79$var$_initializerDefineProperty(this, "searchFilter", $6a1d66e554b4aa79$var$_descriptor8, this);
        $6a1d66e554b4aa79$var$_initializerDefineProperty(this, "queryKey", $6a1d66e554b4aa79$var$_descriptor9, this);
        $6a1d66e554b4aa79$var$_initializerDefineProperty(this, "systemReport", $6a1d66e554b4aa79$var$_descriptor10, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $h6zQv.default);
        if (data.filters) {
            var _data$filters;
            data.filters = (_data$filters = data.filters) === null || _data$filters === void 0 ? void 0 : _data$filters.map((f)=>{
                if ((f.column.toLowerCase().includes("date") || f.column.toLowerCase().includes("time")) && (0, $Xm84r.default)(f.value) && !(f.value[0] instanceof Date)) return {
                    ...f,
                    value: f.value.map((d)=>d ? new Date(d) : d)
                };
                else if ((f.column.toLowerCase().includes("date") || f.column.toLowerCase().includes("time")) && [
                    "=",
                    "!=",
                    ">",
                    "<"
                ].includes(f.operator) && f.value && !(f.value instanceof Date)) return {
                    ...f,
                    value: new Date(f.value)
                };
                return f;
            });
        }
        if ((_data$options = data.options) !== null && _data$options !== void 0 && _data$options.dateRange && (0, $Xm84r.default)((_data$options2 = data.options) === null || _data$options2 === void 0 ? void 0 : _data$options2.dateRange) && !(((_data$options3 = data.options) === null || _data$options3 === void 0 ? void 0 : _data$options3.dateRange[0]) instanceof Date)) data.options.dateRange = data.options.dateRange.map((d)=>new Date(d));
        this.init({
            ...$6a1d66e554b4aa79$var$reportDefaults[data.type],
            ...(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).omitBy(data, (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).isNull)
        }, options);
        this.tableStore = new (0, $hdshG.default)();
        this.searchFilter = "";
        this.setQueryKey();
    }
    update(data, options, ignoreQueryKey = false) {
        var _data$options4, _data$options5, _data$options6;
        if (data.filters) {
            var _data$filters2;
            data.filters = (_data$filters2 = data.filters) === null || _data$filters2 === void 0 ? void 0 : _data$filters2.map((f)=>{
                if ((f.column.toLowerCase().includes("date") || f.column.toLowerCase().includes("time")) && (0, $Xm84r.default)(f.value) && !(f.value[0] instanceof Date)) return {
                    ...f,
                    value: f.value.map((d)=>d ? new Date(d) : null)
                };
                else if ((f.column.toLowerCase().includes("date") || f.column.toLowerCase().includes("time")) && [
                    "=",
                    "!=",
                    ">",
                    "<"
                ].includes(f.operator) && f.value && !(f.value instanceof Date)) return {
                    ...f,
                    value: new Date(f.value)
                };
                return f;
            });
        }
        if ((_data$options4 = data.options) !== null && _data$options4 !== void 0 && _data$options4.dateRange && (0, $Xm84r.default)((_data$options5 = data.options) === null || _data$options5 === void 0 ? void 0 : _data$options5.dateRange) && !(((_data$options6 = data.options) === null || _data$options6 === void 0 ? void 0 : _data$options6.dateRange[0]) instanceof Date)) data.options.dateRange = data.options.dateRange.map((d)=>new Date(d));
        const update = super.update(data, options);
        // this.debouncedSetQueryKey()
        if (!ignoreQueryKey) this.setQueryKey();
        return update;
    }
    get tableColumns() {
        return [
            ...this.columns.map((c)=>({
                    ...this.columnOptionsById[c],
                    visible: true
                })),
            ...(this.groupBy || []).filter((c)=>!this.columns.includes(c)).map((c)=>({
                    ...this.columnOptionsById[c],
                    visible: false
                })),
            ...(this.filters || []).filter((f)=>!this.columns.includes(f.column)).map((f)=>({
                    ...this.columnOptionsById[f.column],
                    visible: false
                }))
        ].filter((c)=>!c.permissions || c.permissions());
    }
    addFilter() {
        const defaultCol = Object.values(this.columnOptionsById)[0];
        const defaultOperator = (0, $cnmvx.operatorDefaults)[defaultCol.type];
        const isRangeOperator = defaultOperator.includes("between");
        const defaultValue = isRangeOperator ? (0, $cnmvx.rangeValueDefaults)[defaultCol.type] : (0, $cnmvx.singleValueDefaults)[defaultCol.type];
        this.filters.push({
            column: defaultCol.id,
            operator: defaultOperator,
            value: defaultValue,
            group: "project"
        });
        this.update({
            filters: this.filters
        }, {}, true);
    }
    updateFilter(filter, prop, value) {
        filter[prop] = value;
        if (prop === "column") {
            const columnType = this.columnOptionsById[value].type;
            filter.operator = (0, $cnmvx.operatorDefaults)[columnType];
            // Use appropriate default value based on operator and column type
            const isRangeOperator = filter.operator.includes("between");
            filter.value = isRangeOperator ? (0, $cnmvx.rangeValueDefaults)[columnType] : (0, $cnmvx.singleValueDefaults)[columnType];
        }
        this.update({
            filters: this.filters
        }, {}, true);
    }
    removeFilter(filter) {
        this.filters = this.filters.filter((f)=>f !== filter);
        this.update({
            filters: this.filters
        }, {}, true);
    }
    updateOptions(prop, value) {
        this.options[prop] = value;
        this.update({
            options: this.options
        }, {}, true);
    }
    updateColumns(columnIds) {
        this.update({
            columns: columnIds
        }, {}, true);
        this.tableStore.updateColumns(this.tableColumns);
    }
    get columnOptionsById() {
        if (this.type === "project") return (0, $9Gpjo.ProjectReportColumns)(this);
        if (this.type === "staffMember") return (0, $495xp.StaffReportColumns)(this);
        if (this.type === "invoice") return (0, $lvlQM.InvoiceReportColumns)(this);
        if (this.type === "timesheet") return (0, $5M65g.TimeReportColumns)(this);
        if (this.type === "expense") return (0, $lq6jw.ExpenseReportColumns)(this);
    }
    get rows() {
        if (this.type === "project") return (0, $gJT7h.default).projects.filter((pr)=>{
            var _pr$title, _pr$title$toLowerCase, _pr$title$toLowerCase2, _pr$title$toLowerCase3;
            return !pr.deletedAt && ((_pr$title = pr.title) === null || _pr$title === void 0 ? void 0 : (_pr$title$toLowerCase = _pr$title.toLowerCase) === null || _pr$title$toLowerCase === void 0 ? void 0 : (_pr$title$toLowerCase2 = _pr$title$toLowerCase.call(_pr$title)) === null || _pr$title$toLowerCase2 === void 0 ? void 0 : (_pr$title$toLowerCase3 = _pr$title$toLowerCase2.includes) === null || _pr$title$toLowerCase3 === void 0 ? void 0 : _pr$title$toLowerCase3.call(_pr$title$toLowerCase2, this.searchFilter.toLowerCase()));
        });
        if (this.type === "staffMember") return [];
        if (this.type === "invoice") return [];
        if (this.type === "timesheet") return (0, $QiMYe.default).timeEntries;
        if (this.type === "expense") return [];
    }
    updateSearchFilter(val) {
        this.searchFilter = val;
    // this.tableStore.updateRows(this.rows)
    }
    downloadCSV({ columns: columns, rows: rows } = {}) {
        (0, (/*@__PURE__*/$parcel$interopDefault($cV8g5)))((0, (/*@__PURE__*/$parcel$interopDefault($6mjwz))).unparse(this.tableStore.getCsvData({
            columns: columns,
            rows: rows
        })), `${this.name}.csv`, "text/csv");
    }
    makeDefault() {
        if (this.type === "project") (0, $1BTI2.default).organisation.update({
            defaultProjectReportId: this.id
        });
        if (this.type === "staffMember") (0, $1BTI2.default).organisation.update({
            defaultStaffReportId: this.id
        });
        if (this.type === "invoice") (0, $1BTI2.default).organisation.update({
            defaultInvoiceReportId: this.id
        });
        if (this.type === "timesheet") (0, $1BTI2.default).organisation.update({
            defaultTimeReportId: this.id
        });
        if (this.type === "expense") (0, $1BTI2.default).organisation.update({
            defaultExpenseReportId: this.id
        });
    }
    removeDefault() {
        if (this.type === "project" && this.id === (0, $1BTI2.default).organisation.defaultProjectReportId) (0, $1BTI2.default).organisation.update({
            defaultProjectReportId: null
        });
        if (this.type === "staffMember" && this.id === (0, $1BTI2.default).organisation.defaultStaffReportId) (0, $1BTI2.default).organisation.update({
            defaultStaffReportId: null
        });
        if (this.type === "invoice" && this.id === (0, $1BTI2.default).organisation.defaultInvoiceReportId) (0, $1BTI2.default).organisation.update({
            defaultInvoiceReportId: null
        });
        if (this.type === "timesheet" && this.id === (0, $1BTI2.default).organisation.defaultTimeReportId) (0, $1BTI2.default).organisation.update({
            defaultTimeReportId: null
        });
        if (this.type === "expense" && this.id === (0, $1BTI2.default).organisation.defaultExpenseReportId) (0, $1BTI2.default).organisation.update({
            defaultExpenseReportId: null
        });
    }
    get dateRange() {
        var _dateStringLookup$thi, _this$options, _this$options2, _this$options3;
        return ((_dateStringLookup$thi = (0, $cnmvx.dateStringLookup)[(_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.dateRange]) === null || _dateStringLookup$thi === void 0 ? void 0 : _dateStringLookup$thi.call((0, $cnmvx.dateStringLookup), (_this$options2 = this.options) === null || _this$options2 === void 0 ? void 0 : _this$options2.fortnightType)) || ((_this$options3 = this.options) === null || _this$options3 === void 0 ? void 0 : _this$options3.dateRange);
    }
    get needsUpdate() {
        return this.queryKey !== this.makeQueryKey();
    }
    setQueryKey() {
        this.queryKey = this.makeQueryKey();
    }
    makeQueryKey() {
        return JSON.stringify({
            columns: [
                ...this.columns
            ].sort((a, b)=>a.localeCompare(b)),
            filters: [
                ...this.filters
            ].map((f)=>{
                var _f$value;
                return {
                    ...f,
                    value: (0, $Xm84r.default)(f.value) ? f.value.map((v)=>(v === null || v === void 0 ? void 0 : v.id) || v) : ((_f$value = f.value) === null || _f$value === void 0 ? void 0 : _f$value.id) || f.value
                };
            }).sort((a, b)=>a.column.localeCompare(b.column)),
            groupBy: [
                ...this.groupBy || []
            ],
            dateRange: this.options.dateRange,
            fortnightType: this.options.fortnightType
        });
    }
}, $6a1d66e554b4aa79$var$_descriptor = $6a1d66e554b4aa79$var$_applyDecoratedDescriptor($6a1d66e554b4aa79$var$_class.prototype, "name", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $6a1d66e554b4aa79$var$_descriptor2 = $6a1d66e554b4aa79$var$_applyDecoratedDescriptor($6a1d66e554b4aa79$var$_class.prototype, "type", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $6a1d66e554b4aa79$var$_descriptor3 = $6a1d66e554b4aa79$var$_applyDecoratedDescriptor($6a1d66e554b4aa79$var$_class.prototype, "columns", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $6a1d66e554b4aa79$var$_descriptor4 = $6a1d66e554b4aa79$var$_applyDecoratedDescriptor($6a1d66e554b4aa79$var$_class.prototype, "filters", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $6a1d66e554b4aa79$var$_descriptor5 = $6a1d66e554b4aa79$var$_applyDecoratedDescriptor($6a1d66e554b4aa79$var$_class.prototype, "groupBy", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $6a1d66e554b4aa79$var$_descriptor6 = $6a1d66e554b4aa79$var$_applyDecoratedDescriptor($6a1d66e554b4aa79$var$_class.prototype, "sortBy", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $6a1d66e554b4aa79$var$_descriptor7 = $6a1d66e554b4aa79$var$_applyDecoratedDescriptor($6a1d66e554b4aa79$var$_class.prototype, "options", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $6a1d66e554b4aa79$var$_descriptor8 = $6a1d66e554b4aa79$var$_applyDecoratedDescriptor($6a1d66e554b4aa79$var$_class.prototype, "searchFilter", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "";
    }
}), $6a1d66e554b4aa79$var$_descriptor9 = $6a1d66e554b4aa79$var$_applyDecoratedDescriptor($6a1d66e554b4aa79$var$_class.prototype, "queryKey", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $6a1d66e554b4aa79$var$_descriptor10 = $6a1d66e554b4aa79$var$_applyDecoratedDescriptor($6a1d66e554b4aa79$var$_class.prototype, "systemReport", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $6a1d66e554b4aa79$var$_applyDecoratedDescriptor($6a1d66e554b4aa79$var$_class.prototype, "tableColumns", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6a1d66e554b4aa79$var$_class.prototype, "tableColumns"), $6a1d66e554b4aa79$var$_class.prototype), $6a1d66e554b4aa79$var$_applyDecoratedDescriptor($6a1d66e554b4aa79$var$_class.prototype, "addFilter", [
    $6a1d66e554b4aa79$var$_dec
], Object.getOwnPropertyDescriptor($6a1d66e554b4aa79$var$_class.prototype, "addFilter"), $6a1d66e554b4aa79$var$_class.prototype), $6a1d66e554b4aa79$var$_applyDecoratedDescriptor($6a1d66e554b4aa79$var$_class.prototype, "updateFilter", [
    $6a1d66e554b4aa79$var$_dec2
], Object.getOwnPropertyDescriptor($6a1d66e554b4aa79$var$_class.prototype, "updateFilter"), $6a1d66e554b4aa79$var$_class.prototype), $6a1d66e554b4aa79$var$_applyDecoratedDescriptor($6a1d66e554b4aa79$var$_class.prototype, "removeFilter", [
    $6a1d66e554b4aa79$var$_dec3
], Object.getOwnPropertyDescriptor($6a1d66e554b4aa79$var$_class.prototype, "removeFilter"), $6a1d66e554b4aa79$var$_class.prototype), $6a1d66e554b4aa79$var$_applyDecoratedDescriptor($6a1d66e554b4aa79$var$_class.prototype, "updateOptions", [
    $6a1d66e554b4aa79$var$_dec4
], Object.getOwnPropertyDescriptor($6a1d66e554b4aa79$var$_class.prototype, "updateOptions"), $6a1d66e554b4aa79$var$_class.prototype), $6a1d66e554b4aa79$var$_applyDecoratedDescriptor($6a1d66e554b4aa79$var$_class.prototype, "updateColumns", [
    $6a1d66e554b4aa79$var$_dec5
], Object.getOwnPropertyDescriptor($6a1d66e554b4aa79$var$_class.prototype, "updateColumns"), $6a1d66e554b4aa79$var$_class.prototype), $6a1d66e554b4aa79$var$_applyDecoratedDescriptor($6a1d66e554b4aa79$var$_class.prototype, "columnOptionsById", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6a1d66e554b4aa79$var$_class.prototype, "columnOptionsById"), $6a1d66e554b4aa79$var$_class.prototype), $6a1d66e554b4aa79$var$_applyDecoratedDescriptor($6a1d66e554b4aa79$var$_class.prototype, "rows", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6a1d66e554b4aa79$var$_class.prototype, "rows"), $6a1d66e554b4aa79$var$_class.prototype), $6a1d66e554b4aa79$var$_applyDecoratedDescriptor($6a1d66e554b4aa79$var$_class.prototype, "updateSearchFilter", [
    $6a1d66e554b4aa79$var$_dec6
], Object.getOwnPropertyDescriptor($6a1d66e554b4aa79$var$_class.prototype, "updateSearchFilter"), $6a1d66e554b4aa79$var$_class.prototype), $6a1d66e554b4aa79$var$_applyDecoratedDescriptor($6a1d66e554b4aa79$var$_class.prototype, "downloadCSV", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($6a1d66e554b4aa79$var$_class.prototype, "downloadCSV"), $6a1d66e554b4aa79$var$_class.prototype), $6a1d66e554b4aa79$var$_applyDecoratedDescriptor($6a1d66e554b4aa79$var$_class.prototype, "makeDefault", [
    $6a1d66e554b4aa79$var$_dec7
], Object.getOwnPropertyDescriptor($6a1d66e554b4aa79$var$_class.prototype, "makeDefault"), $6a1d66e554b4aa79$var$_class.prototype), $6a1d66e554b4aa79$var$_applyDecoratedDescriptor($6a1d66e554b4aa79$var$_class.prototype, "removeDefault", [
    $6a1d66e554b4aa79$var$_dec8
], Object.getOwnPropertyDescriptor($6a1d66e554b4aa79$var$_class.prototype, "removeDefault"), $6a1d66e554b4aa79$var$_class.prototype), $6a1d66e554b4aa79$var$_applyDecoratedDescriptor($6a1d66e554b4aa79$var$_class.prototype, "dateRange", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6a1d66e554b4aa79$var$_class.prototype, "dateRange"), $6a1d66e554b4aa79$var$_class.prototype), $6a1d66e554b4aa79$var$_applyDecoratedDescriptor($6a1d66e554b4aa79$var$_class.prototype, "needsUpdate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6a1d66e554b4aa79$var$_class.prototype, "needsUpdate"), $6a1d66e554b4aa79$var$_class.prototype), $6a1d66e554b4aa79$var$_applyDecoratedDescriptor($6a1d66e554b4aa79$var$_class.prototype, "setQueryKey", [
    $6a1d66e554b4aa79$var$_dec9
], Object.getOwnPropertyDescriptor($6a1d66e554b4aa79$var$_class.prototype, "setQueryKey"), $6a1d66e554b4aa79$var$_class.prototype), $6a1d66e554b4aa79$var$_class);
var $6a1d66e554b4aa79$export$2e2bcd8739ae039 = $6a1d66e554b4aa79$var$ReportModel;

});
parcelRegister("cnmvx", function(module, exports) {

$parcel$export(module.exports, "dateStringLookup", function () { return $9029178e2b7ffcfc$export$e7f9d68bfe6bbb2a; });
$parcel$export(module.exports, "default", function () { return $9029178e2b7ffcfc$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "dateStringLabels", function () { return $9029178e2b7ffcfc$export$8aef1cf919683bdb; });
$parcel$export(module.exports, "operatorLabels", function () { return $9029178e2b7ffcfc$export$9e1cab28bb3963b7; });
$parcel$export(module.exports, "operatorDefaults", function () { return $9029178e2b7ffcfc$export$8b85e3c190a133a; });
$parcel$export(module.exports, "singleValueDefaults", function () { return $9029178e2b7ffcfc$export$8b6b946ca4accbfd; });
$parcel$export(module.exports, "rangeValueDefaults", function () { return $9029178e2b7ffcfc$export$b6277177b9e7dbdc; });

var $4hBm1 = parcelRequire("4hBm1");
parcelRequire("dtopU");
parcelRequire("eat5C");
parcelRequire("8mgS6");
parcelRequire("7CaHe");

var $78RoM = parcelRequire("78RoM");
const $9029178e2b7ffcfc$var$transformForEquality = (type, func)=>(...params)=>{
        const newParams = [];
        params.forEach((p)=>{
            if (type === "date" && typeof p === "string") p = $9029178e2b7ffcfc$export$e7f9d68bfe6bbb2a[p]();
            if (p instanceof Array) p = p.map((pi)=>(0, $78RoM.default)[type](pi));
            else p = (0, $78RoM.default)[type](p);
            newParams.push(p);
        });
        return func(...newParams);
    };
var $9029178e2b7ffcfc$export$2e2bcd8739ae039 = {
    boolean: {
        "=": $9029178e2b7ffcfc$var$transformForEquality("boolean", (a, b)=>a === b)
    },
    text: {
        "=": $9029178e2b7ffcfc$var$transformForEquality("text", (a, b)=>a === b),
        contains: $9029178e2b7ffcfc$var$transformForEquality("text", (a, b)=>a.includes(b)),
        starts: $9029178e2b7ffcfc$var$transformForEquality("text", (a, b)=>a.startsWith(b)),
        ends: $9029178e2b7ffcfc$var$transformForEquality("text", (a, b)=>a.endsWith(b)),
        in: $9029178e2b7ffcfc$var$transformForEquality("text", (a, b)=>new Set(b.map((bi)=>bi)).has(a))
    },
    number: {
        "=": $9029178e2b7ffcfc$var$transformForEquality("number", (a, b)=>a === b),
        ">": $9029178e2b7ffcfc$var$transformForEquality("number", (a, b)=>a > b),
        ">=": $9029178e2b7ffcfc$var$transformForEquality("number", (a, b)=>a >= b),
        "<": $9029178e2b7ffcfc$var$transformForEquality("number", (a, b)=>a < b),
        "<=": $9029178e2b7ffcfc$var$transformForEquality("number", (a, b)=>a <= b),
        between: $9029178e2b7ffcfc$var$transformForEquality("number", (a, b)=>a >= b[0] && a <= b[1]),
        in: $9029178e2b7ffcfc$var$transformForEquality("number", (a, b)=>new Set(b).has(a))
    },
    currency: {
        "=": $9029178e2b7ffcfc$var$transformForEquality("currency", (a, b)=>a === b),
        ">": $9029178e2b7ffcfc$var$transformForEquality("currency", (a, b)=>a > b),
        ">=": $9029178e2b7ffcfc$var$transformForEquality("currency", (a, b)=>a >= b),
        "<": $9029178e2b7ffcfc$var$transformForEquality("currency", (a, b)=>a < b),
        "<=": $9029178e2b7ffcfc$var$transformForEquality("currency", (a, b)=>a <= b),
        between: $9029178e2b7ffcfc$var$transformForEquality("currency", (a, b)=>a >= b[0] && a <= b[1]),
        in: $9029178e2b7ffcfc$var$transformForEquality("currency", (a, b)=>new Set(b).has(a))
    },
    percent: {
        "=": $9029178e2b7ffcfc$var$transformForEquality("percent", (a, b)=>a === b),
        ">": $9029178e2b7ffcfc$var$transformForEquality("percent", (a, b)=>a > b),
        ">=": $9029178e2b7ffcfc$var$transformForEquality("percent", (a, b)=>a >= b),
        "<": $9029178e2b7ffcfc$var$transformForEquality("percent", (a, b)=>a < b),
        "<=": $9029178e2b7ffcfc$var$transformForEquality("percent", (a, b)=>a <= b),
        between: $9029178e2b7ffcfc$var$transformForEquality("percent", (a, b)=>a >= b[0] && a <= b[1]),
        in: $9029178e2b7ffcfc$var$transformForEquality("percent", (a, b)=>new Set(b).has(a))
    },
    durationMinutes: {
        "=": $9029178e2b7ffcfc$var$transformForEquality("number", (a, b)=>a === b),
        ">": $9029178e2b7ffcfc$var$transformForEquality("number", (a, b)=>a > b),
        ">=": $9029178e2b7ffcfc$var$transformForEquality("number", (a, b)=>a >= b),
        "<": $9029178e2b7ffcfc$var$transformForEquality("number", (a, b)=>a < b),
        "<=": $9029178e2b7ffcfc$var$transformForEquality("number", (a, b)=>a <= b),
        between: $9029178e2b7ffcfc$var$transformForEquality("number", (a, b)=>a >= b[0] && a <= b[1]),
        in: $9029178e2b7ffcfc$var$transformForEquality("number", (a, b)=>new Set(b).has(a))
    },
    date: {
        "=": $9029178e2b7ffcfc$var$transformForEquality("date", (a, b)=>{
            if (b instanceof Array) b = b[0];
            return a === b;
        }),
        ">": $9029178e2b7ffcfc$var$transformForEquality("date", (a, b)=>{
            if (b instanceof Array) b = b[1];
            return a > b;
        }),
        ">=": $9029178e2b7ffcfc$var$transformForEquality("date", (a, b)=>{
            if (b instanceof Array) b = b[1];
            return a >= b;
        }),
        "<": $9029178e2b7ffcfc$var$transformForEquality("date", (a, b)=>{
            if (b instanceof Array) b = b[0];
            return a < b;
        }),
        "<=": $9029178e2b7ffcfc$var$transformForEquality("date", (a, b)=>{
            if (b instanceof Array) b = b[0];
            return a <= b;
        }),
        between: $9029178e2b7ffcfc$var$transformForEquality("date", (a, b)=>{
            return a >= b[0] && a <= b[1];
        }),
        in: $9029178e2b7ffcfc$var$transformForEquality("date", (a, b)=>new Set(b).has(a))
    },
    duration: {
        "=": $9029178e2b7ffcfc$var$transformForEquality("duration", (a, b)=>a === b),
        ">": $9029178e2b7ffcfc$var$transformForEquality("duration", (a, b)=>a > b),
        ">=": $9029178e2b7ffcfc$var$transformForEquality("duration", (a, b)=>a >= b),
        "<": $9029178e2b7ffcfc$var$transformForEquality("duration", (a, b)=>a < b),
        "<=": $9029178e2b7ffcfc$var$transformForEquality("duration", (a, b)=>a <= b),
        between: $9029178e2b7ffcfc$var$transformForEquality("duration", (a, b)=>a >= b[0] && a <= b[1]),
        in: $9029178e2b7ffcfc$var$transformForEquality("duration", (a, b)=>new Set(b).has(a))
    },
    progress: {
        "=": $9029178e2b7ffcfc$var$transformForEquality("progress", (a, b)=>a === b),
        ">": $9029178e2b7ffcfc$var$transformForEquality("progress", (a, b)=>a > b),
        ">=": $9029178e2b7ffcfc$var$transformForEquality("progress", (a, b)=>a >= b),
        "<": $9029178e2b7ffcfc$var$transformForEquality("progress", (a, b)=>a < b),
        "<=": $9029178e2b7ffcfc$var$transformForEquality("progress", (a, b)=>a <= b),
        between: $9029178e2b7ffcfc$var$transformForEquality("progress", (a, b)=>a >= b[0] && a <= b[1]),
        in: $9029178e2b7ffcfc$var$transformForEquality("progress", (a, b)=>new Set(b).has(a))
    },
    project: {
        in: $9029178e2b7ffcfc$var$transformForEquality("project", (a, b)=>new Set(b).has(a))
    },
    phase: {
        in: $9029178e2b7ffcfc$var$transformForEquality("phase", (a, b)=>new Set(b).has(a))
    },
    costCentre: {
        in: $9029178e2b7ffcfc$var$transformForEquality("costCentre", (a, b)=>new Set(b).has(a))
    },
    contact: {
        in: $9029178e2b7ffcfc$var$transformForEquality("contact", (a, b)=>new Set(b).has(a))
    },
    staff: {
        in: $9029178e2b7ffcfc$var$transformForEquality("staff", (a, b)=>new Set(b).has(a))
    },
    staffMember: {
        in: $9029178e2b7ffcfc$var$transformForEquality("staffMember", (a, b)=>new Set(b).has(a))
    },
    role: {
        in: $9029178e2b7ffcfc$var$transformForEquality("role", (a, b)=>new Set(b).has(a))
    },
    status: {
        in: $9029178e2b7ffcfc$var$transformForEquality("status", (a, b)=>new Set(b).has(a))
    }
};
const $9029178e2b7ffcfc$export$e7f9d68bfe6bbb2a = {
    allTime: ()=>[
            -Infinity,
            Infinity
        ],
    today: ()=>[
            (0, $4hBm1.startOfDay)(new Date()),
            (0, $4hBm1.endOfDay)(new Date())
        ],
    thisWeek: ()=>[
            (0, $4hBm1.startOfWeek)(new Date(), {
                weekStartsOn: 1
            }),
            (0, $4hBm1.endOfWeek)(new Date(), {
                weekStartsOn: 1
            })
        ],
    thisFortnight: (fortnightType = "a")=>{
        const currentDate = new Date();
        const currentWeek = (0, $4hBm1.getWeek)(currentDate);
        const isEvenWeek = currentWeek % 2 === 0;
        // If type 'a' and it's an even week or type 'b' and it's an odd week, return current to next week
        if (fortnightType === "a" && isEvenWeek || fortnightType === "b" && !isEvenWeek) return [
            (0, $4hBm1.startOfWeek)(currentDate, {
                weekStartsOn: 1
            }),
            (0, $4hBm1.endOfWeek)((0, $4hBm1.add)(currentDate, {
                weeks: 1
            }), {
                weekStartsOn: 1
            })
        ];
        else // Otherwise, return last week to current week
        return [
            (0, $4hBm1.startOfWeek)((0, $4hBm1.sub)(currentDate, {
                weeks: 1
            }), {
                weekStartsOn: 1
            }),
            (0, $4hBm1.endOfWeek)(currentDate, {
                weekStartsOn: 1
            })
        ];
    },
    thisMonth: ()=>[
            (0, $4hBm1.startOfMonth)(new Date()),
            (0, $4hBm1.endOfMonth)(new Date())
        ],
    thisQuarter: ()=>[
            (0, $4hBm1.startOfQuarter)(new Date()),
            (0, $4hBm1.endOfQuarter)(new Date())
        ],
    thisYear: ()=>[
            (0, $4hBm1.startOfYear)(new Date()),
            (0, $4hBm1.endOfYear)(new Date())
        ],
    yesterday: ()=>[
            (0, $4hBm1.startOfDay)((0, $4hBm1.sub)(new Date(), {
                days: 1
            })),
            (0, $4hBm1.endOfDay)((0, $4hBm1.sub)(new Date(), {
                days: 1
            }))
        ],
    lastWeek: ()=>[
            (0, $4hBm1.startOfWeek)((0, $4hBm1.sub)(new Date(), {
                weeks: 1
            }), {
                weekStartsOn: 1
            }),
            (0, $4hBm1.endOfWeek)((0, $4hBm1.sub)(new Date(), {
                weeks: 1
            }), {
                weekStartsOn: 1
            })
        ],
    lastFortnight: (fortnightType = "a")=>(0, $4hBm1.getWeek)((0, $4hBm1.sub)(new Date(), {
            weeks: 2
        })) % (fortnightType === "a" ? 2 : 1) ? [
            (0, $4hBm1.startOfWeek)((0, $4hBm1.sub)(new Date(), {
                weeks: 3
            }), {
                weekStartsOn: 1
            }),
            (0, $4hBm1.endOfWeek)((0, $4hBm1.sub)(new Date(), {
                weeks: 2
            }), {
                weekStartsOn: 1
            })
        ] : [
            (0, $4hBm1.startOfWeek)((0, $4hBm1.sub)(new Date(), {
                weeks: 2
            }), {
                weekStartsOn: 1
            }),
            (0, $4hBm1.endOfWeek)((0, $4hBm1.sub)(new Date(), {
                weeks: 1
            }), {
                weekStartsOn: 1
            })
        ],
    lastMonth: ()=>[
            (0, $4hBm1.startOfMonth)((0, $4hBm1.sub)(new Date(), {
                months: 1
            })),
            (0, $4hBm1.endOfMonth)((0, $4hBm1.sub)(new Date(), {
                months: 1
            }))
        ],
    lastQuarter: ()=>[
            (0, $4hBm1.startOfQuarter)((0, $4hBm1.sub)(new Date(), {
                months: 3
            })),
            (0, $4hBm1.endOfQuarter)((0, $4hBm1.sub)(new Date(), {
                months: 3
            }))
        ],
    lastYear: ()=>[
            (0, $4hBm1.startOfYear)((0, $4hBm1.sub)(new Date(), {
                years: 1
            })),
            (0, $4hBm1.endOfYear)((0, $4hBm1.sub)(new Date(), {
                years: 1
            }))
        ],
    tomorrow: ()=>[
            (0, $4hBm1.startOfDay)((0, $4hBm1.add)(new Date(), {
                days: 1
            })),
            (0, $4hBm1.endOfDay)((0, $4hBm1.add)(new Date(), {
                days: 1
            }))
        ],
    nextWeek: ()=>[
            (0, $4hBm1.startOfWeek)((0, $4hBm1.add)(new Date(), {
                weeks: 1
            }), {
                weekStartsOn: 1
            }),
            (0, $4hBm1.endOfWeek)((0, $4hBm1.add)(new Date(), {
                weeks: 1
            }), {
                weekStartsOn: 1
            })
        ],
    nextFortnight: (fortnightType = "a")=>(0, $4hBm1.getWeek)((0, $4hBm1.add)(new Date(), {
            weeks: 2
        })) % (fortnightType === "a" ? 2 : 1) ? [
            (0, $4hBm1.startOfWeek)((0, $4hBm1.add)(new Date(), {
                weeks: 1
            }), {
                weekStartsOn: 1
            }),
            (0, $4hBm1.endOfWeek)((0, $4hBm1.add)(new Date(), {
                weeks: 2
            }), {
                weekStartsOn: 1
            })
        ] : [
            (0, $4hBm1.startOfWeek)((0, $4hBm1.add)(new Date(), {
                weeks: 2
            }), {
                weekStartsOn: 1
            }),
            (0, $4hBm1.endOfWeek)((0, $4hBm1.add)(new Date(), {
                weeks: 3
            }), {
                weekStartsOn: 1
            })
        ],
    nextMonth: ()=>[
            (0, $4hBm1.startOfMonth)((0, $4hBm1.add)(new Date(), {
                months: 1
            })),
            (0, $4hBm1.endOfMonth)((0, $4hBm1.add)(new Date(), {
                months: 1
            }))
        ],
    nextQuarter: ()=>[
            (0, $4hBm1.startOfQuarter)((0, $4hBm1.add)(new Date(), {
                months: 3
            })),
            (0, $4hBm1.endOfQuarter)((0, $4hBm1.add)(new Date(), {
                months: 3
            }))
        ],
    nextYear: ()=>[
            (0, $4hBm1.startOfYear)((0, $4hBm1.add)(new Date(), {
                years: 1
            })),
            (0, $4hBm1.endOfYear)((0, $4hBm1.add)(new Date(), {
                years: 1
            }))
        ],
    inLastWeek: ()=>[
            (0, $4hBm1.sub)(new Date(), {
                weeks: 1
            }),
            new Date()
        ],
    inLastMonth: ()=>[
            (0, $4hBm1.sub)(new Date(), {
                months: 1
            }),
            new Date()
        ],
    inLastQuarter: ()=>[
            (0, $4hBm1.sub)(new Date(), {
                months: 3
            }),
            new Date()
        ],
    inLastYear: ()=>[
            (0, $4hBm1.sub)(new Date(), {
                years: 1
            }),
            new Date()
        ],
    inNextWeek: ()=>[
            new Date(),
            (0, $4hBm1.add)(new Date(), {
                weeks: 1
            })
        ],
    inNextMonth: ()=>[
            new Date(),
            (0, $4hBm1.add)(new Date(), {
                months: 1
            })
        ],
    inNextQuarter: ()=>[
            new Date(),
            (0, $4hBm1.add)(new Date(), {
                months: 3
            })
        ],
    inNextYear: ()=>[
            new Date(),
            (0, $4hBm1.add)(new Date(), {
                years: 1
            })
        ]
};
const $9029178e2b7ffcfc$export$8aef1cf919683bdb = {
    custom: "custom",
    allTime: "all time",
    today: "today",
    thisWeek: "this week",
    thisFortnight: "this fortnight",
    thisMonth: "this month",
    thisQuarter: "this quarter",
    thisYear: "this year",
    yesterday: "yesterday",
    lastWeek: "last week",
    lastFortnight: "last fortnight",
    lastMonth: "last month",
    lastQuarter: "last quarter",
    lastYear: "last year",
    tomorrow: "tomorrow",
    nextWeek: "next week",
    nextMonth: "next month",
    nextQuarter: "next quarter",
    nextYear: "next year",
    inLastWeek: "the week prior to now",
    inLastMonth: "the month prior to now",
    inLastQuarter: "the quarter prior to now",
    inLastYear: "the year prior to now",
    inNextWeek: "one week from now",
    inNextMonth: "one month from now",
    inNextQuarter: "one quarter from now",
    inNextYear: "one year from now"
};
const $9029178e2b7ffcfc$export$9e1cab28bb3963b7 = {
    boolean: {
        "=": "is equal to"
    },
    text: {
        "=": "is equal to",
        "!=": "isn't equal to",
        contains: "contains",
        "!contains": "doesn't contain",
        starts: "starts with",
        "!starts": "doesn't start with",
        ends: "ends with",
        "!ends": "doesn't end with"
    },
    number: {
        "=": "is equal to",
        "!=": "isn't equal to",
        ">": "is greater than",
        // '>=': 'is greater than or equal to',
        "<": "is less than",
        // '<=': 'is less than or equal to',
        between: "is between",
        "!between": "isn't between"
    },
    currency: {
        "=": "is equal to",
        "!=": "isn't equal to",
        ">": "is greater than",
        "<": "is less than",
        between: "is between",
        "!between": "isn't between"
    },
    percent: {
        "=": "is equal to",
        "!=": "isn't equal to",
        ">": "is greater than",
        "<": "is less than",
        between: "is between"
    },
    date: {
        "=": "occurs on",
        "!=": "didn't occur on",
        ">": "occurs after",
        "<": "occurs before",
        between: "occurred during",
        "!between": "didn't occur during"
    },
    time: {
        "=": "occurs on",
        "!=": "didn't occur on",
        ">": "occurs after",
        "<": "occurs before",
        between: "occurred during",
        "!between": "didn't occur during"
    },
    duration: {
        "=": "is equal to",
        "!=": "isn't equal to",
        ">": "is greater than",
        "<": "is less than",
        between: "is between",
        "!between": "isn't between"
    },
    progress: {
        "=": "is equal to",
        "!=": "isn't equal to",
        ">": "is greater than",
        "<": "is less than",
        between: "is between",
        "!between": "isn't between"
    },
    progressBar: {
        "=": "is equal to",
        "!=": "isn't equal to",
        ">": "is greater than",
        "<": "is less than",
        between: "is between",
        "!between": "isn't between"
    },
    project: {
        in: "is any of",
        "!in": "isn't any of"
    },
    phase: {
        in: "is any of",
        "!in": "isn't any of"
    },
    costCentre: {
        in: "is any of",
        "!in": "isn't any of"
    },
    contact: {
        in: "is any of",
        "!in": "isn't any of"
    },
    staff: {
        in: "is any of",
        "!in": "isn't any of"
    },
    staffMember: {
        in: "is any of",
        "!in": "isn't any of"
    },
    staffs: {
        in: "is any of",
        "!in": "isn't any of"
    },
    staffMembers: {
        in: "is any of",
        "!in": "isn't any of"
    },
    role: {
        in: "is any of",
        "!in": "isn't any of"
    },
    status: {
        in: "is any of",
        "!in": "isn't any of"
    }
};
const $9029178e2b7ffcfc$export$8b85e3c190a133a = {
    boolean: "=",
    text: "contains",
    number: ">",
    currency: ">",
    percent: ">",
    date: "between",
    time: "between",
    duration: ">",
    progress: ">",
    progressBar: ">",
    project: "in",
    phase: "in",
    costCentre: "in",
    contact: "in",
    staff: "in",
    staffMember: "in",
    staffs: "in",
    staffMembers: "in",
    role: "in",
    status: "in"
};
const $9029178e2b7ffcfc$export$8b6b946ca4accbfd = {
    boolean: false,
    text: "",
    number: 0,
    currency: 0,
    percent: 0,
    date: new Date(),
    time: new Date(),
    duration: 0,
    progress: 0,
    progressBar: 0,
    project: [],
    phase: [],
    costCentre: [],
    contact: [],
    staff: [],
    staffMember: [],
    staffs: [],
    staffMembers: [],
    role: [],
    status: []
};
const $9029178e2b7ffcfc$export$b6277177b9e7dbdc = {
    number: [
        0,
        0
    ],
    currency: [
        0,
        0
    ],
    percent: [
        0,
        0
    ],
    date: "thisMonth",
    time: [
        new Date(),
        new Date()
    ],
    duration: [
        0,
        0
    ],
    progress: [
        0,
        0
    ],
    progressBar: [
        0,
        0
    ]
};

});
parcelRegister("8mgS6", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: "date",
        dates: "date",
        date: "date",
        d: "day",
        days: "day",
        day: "day",
        e: "weekday",
        weekdays: "weekday",
        weekday: "weekday",
        E: "isoWeekday",
        isoweekdays: "isoWeekday",
        isoweekday: "isoWeekday",
        DDD: "dayOfYear",
        dayofyears: "dayOfYear",
        dayofyear: "dayOfYear",
        h: "hour",
        hours: "hour",
        hour: "hour",
        ms: "millisecond",
        milliseconds: "millisecond",
        millisecond: "millisecond",
        m: "minute",
        minutes: "minute",
        minute: "minute",
        M: "month",
        months: "month",
        month: "month",
        Q: "quarter",
        quarters: "quarter",
        quarter: "quarter",
        s: "second",
        seconds: "second",
        second: "second",
        gg: "weekYear",
        weekyears: "weekYear",
        weekyear: "weekYear",
        GG: "isoWeekYear",
        isoweekyears: "isoWeekYear",
        isoweekyear: "isoWeekYear",
        w: "week",
        weeks: "week",
        week: "week",
        W: "isoWeek",
        isoweeks: "isoWeek",
        isoweek: "isoWeek",
        y: "year",
        years: "year",
        year: "year"
    };
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case "Seconds":
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case "Minutes":
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case "Hours":
                return isUTC ? d.getUTCHours() : d.getHours();
            case "Date":
                return isUTC ? d.getUTCDate() : d.getDate();
            case "Day":
                return isUTC ? d.getUTCDay() : d.getDay();
            case "Month":
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case "FullYear":
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case "Seconds":
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case "Minutes":
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case "Hours":
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case "Date":
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case "FullYear":
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken("M", match1to2, match1to2NoLeadingZero);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ""));
            longP = regexEscape(this.months(mom, ""));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // PARSING
    addRegexToken("w", match1to2, match1to2NoLeadingZero);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2, match1to2NoLeadingZero);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, "Day");
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2, match1to2HasZero);
    addRegexToken("h", match1to2, match1to2NoLeadingZero);
    addRegexToken("k", match1to2, match1to2NoLeadingZero);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match("^[^/\\\\]*$"));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // PARSING
    addRegexToken("D", match1to2, match1to2NoLeadingZero);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // PARSING
    addRegexToken("m", match1to2, match1to2HasZero);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // PARSING
    addRegexToken("s", match1to2, match1to2HasZero);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y"), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.30.1";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});

parcelRegister("78RoM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5332b3a2f25acfe0$export$2e2bcd8739ae039; });

var $7CaHe = parcelRequire("7CaHe");

var $3cqhz = parcelRequire("3cqhz");
var $5332b3a2f25acfe0$export$2e2bcd8739ae039 = {
    boolean: (value)=>value !== null && value !== void 0 ? value : false,
    text: (value)=>value ? String(value).toLowerCase() : "",
    number: (value)=>value !== null && value !== void 0 ? value : null,
    currency: (value)=>value !== null && value !== void 0 ? value : null,
    percent: (value)=>value !== null && value !== void 0 ? value : null,
    durationMinutes: (value)=>value !== null && value !== void 0 ? value : null,
    date: (value)=>value instanceof Date && !isNaN(value) ? value.getTime() : null,
    time: (value)=>value instanceof Date && !isNaN(value) ? value.getTime() : null,
    duration: (value)=>value !== null && value !== void 0 && value.value && value !== null && value !== void 0 && value.unit ? (0, $7CaHe.durationToUnit)(value, "milliseconds") : null,
    progress: (value)=>value !== null && value !== void 0 && value.denominator ? value.numerator / value.denominator : null,
    progressBar: (value)=>value !== null && value !== void 0 && value.denominator ? value.numerator / value.denominator : null,
    project: (value)=>{
        var _value$id;
        return (_value$id = value === null || value === void 0 ? void 0 : value.id) !== null && _value$id !== void 0 ? _value$id : "";
    },
    phase: (value)=>{
        var _value$id2;
        return (_value$id2 = value === null || value === void 0 ? void 0 : value.id) !== null && _value$id2 !== void 0 ? _value$id2 : "";
    },
    costCentre: (value)=>{
        var _value$id3;
        return (_value$id3 = value === null || value === void 0 ? void 0 : value.id) !== null && _value$id3 !== void 0 ? _value$id3 : "";
    },
    contact: (value)=>{
        var _value$id4;
        return (_value$id4 = value === null || value === void 0 ? void 0 : value.id) !== null && _value$id4 !== void 0 ? _value$id4 : "";
    },
    staff: (value)=>{
        var _value$id5;
        return (_value$id5 = value === null || value === void 0 ? void 0 : value.id) !== null && _value$id5 !== void 0 ? _value$id5 : "";
    },
    staffMember: (value)=>{
        var _value$id6;
        return (_value$id6 = value === null || value === void 0 ? void 0 : value.id) !== null && _value$id6 !== void 0 ? _value$id6 : "";
    },
    role: (value)=>{
        var _value$id7;
        return (_value$id7 = value === null || value === void 0 ? void 0 : value.id) !== null && _value$id7 !== void 0 ? _value$id7 : "";
    },
    status: (value)=>{
        var _statusPriorities$val;
        return (_statusPriorities$val = (0, $3cqhz.statusPriorities)[value]) !== null && _statusPriorities$val !== void 0 ? _statusPriorities$val : null;
    }
};

});
parcelRegister("3cqhz", function(module, exports) {

$parcel$export(module.exports, "statusPriorities", function () { return $2546e1396e8c8e4a$export$3b40b9f7a19a5b8a; });
$parcel$export(module.exports, "statusByPriority", function () { return $2546e1396e8c8e4a$export$b3919c364c9db11f; });
const $2546e1396e8c8e4a$export$3b40b9f7a19a5b8a = {
    active: 1,
    onHold: 2,
    prospective: 3,
    archived: 4
};
const $2546e1396e8c8e4a$export$b3919c364c9db11f = {
    1: "active",
    2: "onHold",
    3: "prospective",
    4: "archived"
};

});



parcelRegister("9Gpjo", function(module, exports) {

$parcel$export(module.exports, "ProjectReportColumns", function () { return $70cbabb69a0dbd53$export$87b7940e8d176c5c; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("eat5C");
parcelRequire("jbmdS");

var $azaaH = parcelRequire("azaaH");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");


var $kqlQp = parcelRequire("kqlQp");

var $gJT7h = parcelRequire("gJT7h");
const $70cbabb69a0dbd53$export$87b7940e8d176c5c = (report)=>({
        name: {
            id: "name",
            label: "Name",
            type: "text",
            width: 26,
            value: (row)=>row.name,
            component: ({ value: value, group: group, stores: stores })=>{
                var _row$rowObject$childr;
                const { row: row, table: table } = stores;
                if (row.group === "totals") return "Total";
                return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    style: {
                        paddingLeft: `${1 * row.groupLevel}rem`
                    },
                    children: (_row$rowObject$childr = row.rowObject.children) !== null && _row$rowObject$childr !== void 0 && _row$rowObject$childr.length ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqlQp.Link), {
                        to: `/projects/${row.rowObject.projectId}`,
                        children: value
                    }) : value
                });
            }
        },
        project: {
            id: "project",
            label: "Project",
            type: "project",
            width: 26,
            value: (row)=>row.project,
            format: (name)=>{
                return name;
            }
        },
        jobCode: {
            id: "jobCode",
            label: "Job code",
            type: "text",
            width: 13,
            value: (row)=>row.jobCode
        },
        startDate: {
            id: "startDate",
            label: "Start date",
            type: "date",
            width: 13,
            aggregate: "min",
            value: (row)=>{
                return row.startDate ? new Date(row.startDate) : null;
            },
            permissions: (row)=>(0, $8kZ1o.canViewProjectDates)((0, $1BTI2.default).user, (0, $gJT7h.default).projectsById[row === null || row === void 0 ? void 0 : row.projectId])
        },
        endDate: {
            id: "endDate",
            label: "End date",
            type: "date",
            width: 13,
            aggregate: "max",
            value: (row)=>{
                return row.endDate ? new Date(row.endDate) : null;
            },
            permissions: (row)=>(0, $8kZ1o.canViewProjectDates)((0, $1BTI2.default).user, (0, $gJT7h.default).projectsById[row === null || row === void 0 ? void 0 : row.projectId])
        },
        fee: {
            id: "fee",
            label: "Fee",
            type: "currency",
            width: 13,
            value: (row)=>row.fee,
            permissions: (row)=>(0, $8kZ1o.canViewProjectFees)((0, $1BTI2.default).user, (0, $gJT7h.default).projectsById[row === null || row === void 0 ? void 0 : row.projectId])
        },
        expenseBudget: {
            id: "expenseBudget",
            label: "Expense Budget",
            type: "currency",
            width: 13,
            value: (row)=>row.expenseBudget,
            permissions: (row)=>(0, $8kZ1o.canViewProjectExpenseBudgets)((0, $1BTI2.default).user, (0, $gJT7h.default).projectsById[row === null || row === void 0 ? void 0 : row.projectId])
        },
        costCentre: {
            id: "costCentre",
            label: "Cost centre",
            type: "costCentre",
            width: 13,
            value: (row)=>row.costCentre,
            format: (name)=>{
                return name;
            },
            permissions: (row)=>(0, $8kZ1o.canViewCostCentres)((0, $1BTI2.default).user)
        },
        contact: {
            id: "contact",
            label: "Contact",
            type: "contact",
            width: 13,
            value: (row)=>row.contact,
            format: (name)=>{
                return name;
            },
            permissions: (row)=>(0, $8kZ1o.canViewContacts)((0, $1BTI2.default).user)
        },
        invoiceContact: {
            id: "invoiceContact",
            label: "Primary Contact",
            type: "contact",
            width: 13,
            value: (row)=>row.invoiceContact,
            format: (name)=>{
                return name;
            },
            permissions: (row)=>(0, $8kZ1o.canViewContacts)((0, $1BTI2.default).user) && (0, $8kZ1o.canViewPrimaryContact)()
        },
        owner: {
            id: "owner",
            label: "Project Owner",
            type: "staffMember",
            width: 15,
            value: (row)=>row.owner,
            format: (name)=>{
                return name;
            }
        },
        status: {
            id: "status",
            label: "Status",
            type: "status",
            width: 13,
            value: (row)=>row.status
        },
        remainingFee: {
            id: "remainingFee",
            label: "Remaining fee",
            type: "currency",
            width: 13,
            value: (row)=>row.remainingFee,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).fee.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).revenue.permissions(row)
        },
        remainingExpenseProjectBudget: {
            id: "remainingExpenseProjectBudget",
            label: "Remaining Expense Budget",
            type: "currency",
            width: 13,
            value: (row)=>row.remainingExpenseProjectBudget,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).expenseBudget.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).expenses.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).projectExpenses.permissions(row)
        },
        latestEvent: {
            id: "latestEvent",
            label: "Latest Event",
            type: "date",
            width: 13,
            value: (row)=>{
                return row.latestEvent ? new Date(row.latestEvent) : null;
            }
        },
        latestNote: {
            id: "latestNote",
            label: "Latest Note",
            type: "text",
            width: 35,
            value: (row)=>row.latestNote,
            permissions: (row)=>(0, $8kZ1o.canViewProjectNotes)((0, $1BTI2.default).user, (0, $gJT7h.default).projectsById[row === null || row === void 0 ? void 0 : row.projectId])
        },
        currentPhases: {
            id: "currentPhases",
            label: "Current Phases",
            type: "text",
            width: 13,
            value: (row)=>row.currentPhases
        },
        activePhases: {
            id: "activePhases",
            label: "Active Phases",
            type: "text",
            width: 13,
            value: (row)=>row.activePhases
        },
        prospectivePhases: {
            id: "prospectivePhases",
            label: "Prospective Phases",
            type: "text",
            width: 13,
            value: (row)=>row.prospectivePhases
        },
        staffMembers: {
            id: "staffMembers",
            label: "Staff members assigned",
            type: "staffs",
            width: 13,
            value: (row)=>row.staffMembers
        },
        progress: {
            id: "progress",
            label: "Progress",
            type: "percent",
            aggregate: "avg",
            width: 13,
            value: (row)=>row.progress,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).revenue.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).fee.permissions(row)
        },
        revenue: {
            id: "revenue",
            label: "Revenue",
            type: "currency",
            width: 13,
            value: (row)=>row.revenue,
            permissions: (row)=>(0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, (0, $gJT7h.default).projectsById[row === null || row === void 0 ? void 0 : row.projectId])
        },
        revenueWithVariations: {
            id: "revenueWithVariations",
            label: "Revenue (Variations)",
            type: "currency",
            width: 13,
            value: (row)=>row.revenueWithVariations,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).revenue.permissions(row)
        },
        revenueWithVariationsReimbursements: {
            id: "revenueWithVariationsReimbursements",
            label: "Revenue (Variations + Reimbursements)",
            type: "currency",
            width: 13,
            value: (row)=>row.revenueWithVariationsReimbursements,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).revenue.permissions(row)
        },
        recordedHours: {
            id: "recordedHours",
            label: "Recorded Hours",
            type: "number",
            width: 13,
            value: (row)=>row.recordedHours
        },
        recordedHoursVariation: {
            id: "recordedHoursVariation",
            label: "Recorded Hours (Variation)",
            type: "number",
            width: 13,
            value: (row)=>row.recordedHoursVariation
        },
        hoursBudgeted: {
            id: "hoursBudgeted",
            label: "Hours budgeted",
            type: "number",
            width: 13,
            value: (row)=>row.hoursBudgeted
        },
        hoursAllocated: {
            id: "hoursAllocated",
            label: "Hours allocated",
            type: "number",
            width: 13,
            value: (row)=>row.hoursAllocated,
            permissions: (row)=>(0, $8kZ1o.canViewStaffAllocations)((0, $1BTI2.default).user, (0, $gJT7h.default).projectsById[row === null || row === void 0 ? void 0 : row.projectId])
        },
        expenses: {
            id: "expenses",
            label: "Expenses (cost)",
            type: "currency",
            width: 13,
            value: (row)=>row.expenses,
            permissions: (row)=>(0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, (0, $gJT7h.default).projectsById[row === null || row === void 0 ? void 0 : row.projectId])
        },
        projectExpenses: {
            id: "projectExpenses",
            label: "Project Expenses",
            type: "currency",
            width: 13,
            value: (row)=>row.projectExpenses,
            permissions: (row)=>(0, $8kZ1o.canViewProjectExpenses)((0, $1BTI2.default).user, (0, $gJT7h.default).projectsById[row === null || row === void 0 ? void 0 : row.projectId])
        },
        billableProjectExpenses: {
            id: "billableProjectExpenses",
            label: "Billable Project Expenses",
            type: "currency",
            width: 13,
            value: (row)=>row.billableProjectExpenses,
            permissions: (row)=>(0, $8kZ1o.canViewProjectExpenses)((0, $1BTI2.default).user, (0, $gJT7h.default).projectsById[row === null || row === void 0 ? void 0 : row.projectId])
        },
        allProjectExpenses: {
            id: "allProjectExpenses",
            label: "All Project Expenses",
            type: "currency",
            width: 13,
            value: (row)=>row.allProjectExpenses,
            permissions: (row)=>(0, $8kZ1o.canViewProjectExpenses)((0, $1BTI2.default).user, (0, $gJT7h.default).projectsById[row === null || row === void 0 ? void 0 : row.projectId])
        },
        expensesVariation: {
            id: "expensesVariation",
            label: "Expenses (cost) + Variation Cost",
            type: "currency",
            width: 13,
            value: (row)=>row.expensesVariation,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).expenses.permissions(row)
        },
        expensesVariationProject: {
            id: "expensesVariationProject",
            label: "Expenses (cost) + Variation Cost + Project Expenses",
            type: "currency",
            width: 13,
            value: (row)=>row.expensesVariationProject,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).expenses.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).projectExpenses.permissions(row)
        },
        expensesProject: {
            id: "expensesProject",
            label: "Expenses (cost) + Project Expenses",
            type: "currency",
            width: 13,
            value: (row)=>row.expensesProject,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).expenses.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).projectExpenses.permissions(row)
        },
        labourExpense: {
            id: "labourExpense",
            label: "Labour expense",
            type: "currency",
            width: 13,
            value: (row)=>row.labourExpense,
            permissions: (row)=>(0, $8kZ1o.canViewProjectStaffPay)((0, $1BTI2.default).user, (0, $gJT7h.default).projectsById[row === null || row === void 0 ? void 0 : row.projectId])
        },
        labourExpenseVariation: {
            id: "labourExpenseVariation",
            label: "Labour expense (incl. variations)",
            type: "currency",
            width: 13,
            value: (row)=>row.labourExpenseVariation,
            permissions: (row)=>(0, $8kZ1o.canViewProjectStaffPay)((0, $1BTI2.default).user, (0, $gJT7h.default).projectsById[row === null || row === void 0 ? void 0 : row.projectId])
        },
        chargeOut: {
            id: "chargeOut",
            label: "Charge-out",
            type: "currency",
            width: 13,
            value: (row)=>row.chargeOut,
            permissions: (row)=>(0, $8kZ1o.canViewProjectStaffChargeOut)((0, $1BTI2.default).user, (0, $gJT7h.default).projectsById[row === null || row === void 0 ? void 0 : row.projectId])
        },
        chargeOutVariation: {
            id: "chargeOutVariation",
            label: "Charge-out (Variations)",
            type: "currency",
            width: 13,
            value: (row)=>row.chargeOutVariation,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).chargeOut.permissions(row)
        },
        chargeOutVariationProject: {
            id: "chargeOutVariationProject",
            label: "Charge-out (Variations + Project)",
            type: "currency",
            width: 13,
            value: (row)=>row.chargeOutVariationProject,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).chargeOut.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).projectExpenses.permissions(row)
        },
        actualVsBudgetedHours: {
            id: "actualVsBudgetedHours",
            label: "Actual / Budgeted Hours",
            type: "progressBar",
            width: 24,
            value: (row)=>row.actualVsBudgetedHours
        },
        actualVsBudgetedHoursVariation: {
            id: "actualVsBudgetedHoursVariation",
            label: "Actual (Variation) / Budgeted Hours",
            type: "progressBar",
            width: 24,
            value: (row)=>row.actualVsBudgetedHoursVariation
        },
        actualProjectVsBudgetedExpenses: {
            id: "actualProjectVsBudgetedExpenses",
            label: "Actual (Cost + Project) / Budgeted Expenses",
            type: "progressBar",
            format: (v)=>(0, $azaaH.default).currency(v, {
                    decimals: 0
                }),
            width: 24,
            value: (row)=>row.actualProjectVsBudgetedExpenses,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).expensesProject.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).expenseBudget.permissions(row)
        },
        actualVsBudgetedExpenses: {
            id: "actualVsBudgetedExpenses",
            label: "Actual (Cost) / Budgeted Expenses",
            type: "progressBar",
            format: (v)=>(0, $azaaH.default).currency(v, {
                    decimals: 0
                }),
            width: 24,
            value: (row)=>row.actualVsBudgetedExpenses,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).expenses.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).expenseBudget.permissions(row)
        },
        actualVariationVsBudgetedExpenses: {
            id: "actualVariationVsBudgetedExpenses",
            label: "Actual (Cost) / Budgeted Expenses",
            type: "progressBar",
            format: (v)=>(0, $azaaH.default).currency(v, {
                    decimals: 0
                }),
            width: 24,
            value: (row)=>row.actualVariationVsBudgetedExpenses,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).expensesVariation.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).expenseBudget.permissions(row)
        },
        actualVariationProjectVsBudgetedExpenses: {
            id: "actualVariationProjectVsBudgetedExpenses",
            label: "Actual (Cost + Variation + Project) / Budgeted Expenses",
            type: "progressBar",
            format: (v)=>(0, $azaaH.default).currency(v, {
                    decimals: 0
                }),
            width: 24,
            value: (row)=>row.actualVariationProjectVsBudgetedExpenses,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).expensesVariationProject.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).expenseBudget.permissions(row)
        },
        revenueVsFee: {
            id: "revenueVsFee",
            label: "Revenue / Fee",
            type: "progressBar",
            width: 24,
            value: (row)=>row.revenueVsFee,
            format: (v)=>(0, $azaaH.default).currency(v, {
                    decimals: 0
                }),
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).fee.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).revenue.permissions(row)
        },
        revenueVariationVsFee: {
            id: "revenueVariationVsFee",
            label: "Revenue (Variations) / Fee",
            type: "progressBar",
            width: 24,
            value: (row)=>row.revenueVariationVsFee,
            format: (v)=>(0, $azaaH.default).currency(v, {
                    decimals: 0
                }),
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).fee.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).revenue.permissions(row)
        },
        revenueVsChargeOut: {
            id: "revenueVsChargeOut",
            label: "Revenue / Charge Out",
            type: "progressBar",
            width: 24,
            value: (row)=>row.revenueVsChargeOut,
            format: (v)=>(0, $azaaH.default).currency(v, {
                    decimals: 0
                }),
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).fee.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).chargeOut.permissions(row)
        },
        percentRevenueVsFee: {
            id: "percentRevenueVsFee",
            label: "Percent Revenue / Fee",
            type: "percent",
            aggregate: "avg",
            width: 13,
            value: (row)=>row.percentRevenueVsFee,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).fee.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).revenue.permissions(row)
        },
        costProjectVsFee: {
            id: "costProjectVsFee",
            label: "Expenses (Cost + Project) / Fee",
            type: "progressBar",
            width: 24,
            value: (row)=>row.costProjectVsFee,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).expensesProject.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).fee.permissions(row),
            format: (v)=>(0, $azaaH.default).currency(v, {
                    decimals: 0
                })
        },
        costVsFee: {
            id: "costVsFee",
            label: "Expense (cost) / Fee",
            type: "progressBar",
            width: 24,
            value: (row)=>row.costVsFee,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).expenses.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).fee.permissions(row),
            format: (v)=>(0, $azaaH.default).currency(v, {
                    decimals: 0
                })
        },
        payVsFee: {
            id: "payVsFee",
            label: "Expense (labour) / Fee",
            type: "progressBar",
            width: 24,
            value: (row)=>row.payVsFee,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).labourExpense.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).fee.permissions(row),
            format: (v)=>(0, $azaaH.default).currency(v, {
                    decimals: 0
                })
        },
        chargeOutVsFee: {
            id: "chargeOutVsFee",
            label: "Charge Out / Fee",
            type: "progressBar",
            width: 24,
            value: (row)=>row.chargeOutVsFee,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).chargeOut.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).fee.permissions(row),
            format: (v)=>(0, $azaaH.default).currency(v, {
                    decimals: 0
                })
        },
        chargeOutVariationVsFee: {
            id: "chargeOutVariationVsFee",
            label: "Charge Out (Variations) / Fee",
            type: "progressBar",
            width: 24,
            value: (row)=>row.chargeOutVariationVsFee,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).chargeOutVariation.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).fee.permissions(row),
            format: (v)=>(0, $azaaH.default).currency(v, {
                    decimals: 0
                })
        },
        percentOfTotalHours: {
            id: "percentOfTotalHours",
            label: "Percentage of total hours",
            type: "percent",
            width: 13,
            value: (row)=>row.percentOfTotalHours
        },
        percentOfTotalRevenue: {
            id: "percentOfTotalRevenue",
            label: "Percentage of total revenue",
            type: "percent",
            width: 13,
            value: (row)=>row.percentOfTotalRevenue,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).revenue.permissions(row)
        },
        percentOfTotalExpenses: {
            id: "percentOfTotalExpenses",
            label: "Percentage of total expenses (cost)",
            type: "percent",
            width: 13,
            value: (row)=>row.percentOfTotalExpenses,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).expensesProject.permissions(row)
        },
        percentOfTotalExpensesLabour: {
            id: "percentOfTotalExpensesLabour",
            label: "Percentage of total expenses (labour)",
            type: "percent",
            width: 13,
            value: (row)=>row.percentOfTotalExpensesLabour,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).labourExpense.permissions(row)
        },
        profit: {
            id: "profit",
            label: "Profit (cost + project expenses)",
            type: "currency",
            width: 13,
            value: (row)=>row.profit,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).revenue.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).expensesProject.permissions(row)
        },
        profitCost: {
            id: "profitCost",
            label: "Profit (cost)",
            type: "currency",
            width: 13,
            value: (row)=>row.profitCost,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).revenue.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).expenses.permissions(row)
        },
        profitLabour: {
            id: "profitLabour",
            label: "Profit (labour)",
            type: "currency",
            width: 13,
            value: (row)=>row.profitLabour,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).revenue.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).labourExpense.permissions(row)
        },
        profitFee: {
            id: "profitFee",
            label: "Profit (fee)",
            type: "currency",
            width: 13,
            value: (row)=>row.profitFee,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).fee.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).expensesProject.permissions(row)
        },
        profitFeeVariation: {
            id: "profitFeeVariation",
            label: "Profit (fee, variation & project expenses)",
            type: "currency",
            width: 13,
            value: (row)=>row.profitFeeVariation,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).fee.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).expensesVariationProject.permissions(row)
        },
        profitCostVariationProject: {
            id: "profitCostVariationProject",
            label: "Profit (cost, variation & project expenses)",
            type: "currency",
            width: 13,
            value: (row)=>row.profitCostVariationProject,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).revenueWithVariationsReimbursements.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).expensesVariationProject.permissions(row)
        },
        profitMargin: {
            id: "profitMargin",
            label: "Profit margin (cost + project expenses)",
            type: "percent",
            aggregate: "avg",
            width: 13,
            value: (row)=>row.profitMargin,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).profit.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).revenue.permissions(row)
        },
        profitMarginCost: {
            id: "profitMarginCost",
            label: "Profit margin (cost)",
            type: "percent",
            aggregate: "avg",
            width: 13,
            value: (row)=>row.profitMarginCost,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).profitCost.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).revenue.permissions(row)
        },
        profitMarginLabour: {
            id: "profitMarginLabour",
            label: "Profit margin (labour)",
            type: "percent",
            aggregate: "avg",
            width: 13,
            value: (row)=>row.profitMarginLabour,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).profitLabour.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).revenue.permissions(row)
        },
        profitMarginFee: {
            id: "profitMarginFee",
            label: "Profit margin (fee)",
            type: "percent",
            width: 13,
            value: (row)=>row.profitMarginFee,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).profitFee.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).fee.permissions(row)
        },
        profitMarginFeeVariation: {
            id: "profitMarginFeeVariation",
            label: "Profit margin (fee, variation & project expenses)",
            type: "percent",
            width: 13,
            value: (row)=>row.profitMarginFeeVariation,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).profitFeeVariation.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).fee.permissions(row)
        },
        netMultiplier: {
            id: "netMultiplier",
            label: "Net Multiplier",
            type: "number",
            width: 13,
            aggregate: "avg",
            value: (row)=>row.netMultiplier,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).revenue.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).expensesProject.permissions(row)
        },
        markup: {
            id: "markup",
            label: "Markup (cost + project expenses)",
            type: "percent",
            aggregate: "avg",
            width: 13,
            value: (row)=>row.markup,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).profit.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).expensesProject.permissions(row)
        },
        markupCost: {
            id: "markupCost",
            label: "Markup (cost)",
            type: "percent",
            aggregate: "avg",
            width: 13,
            value: (row)=>row.markupCost,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).profitCost.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).expenses.permissions(row)
        },
        markupLabour: {
            id: "markupLabour",
            label: "Markup (labour)",
            type: "percent",
            aggregate: "avg",
            width: 13,
            value: (row)=>row.markupLabour,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).profitLabour.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).labourExpense.permissions(row)
        },
        revenuePerHour: {
            id: "revenuePerHour",
            label: "Revenue per hour",
            type: "currency",
            width: 13,
            value: (row)=>row.revenuePerHour,
            aggregate: "avg",
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).revenue.permissions(row)
        },
        revenueVariationPerHour: {
            id: "revenueVariationPerHour",
            label: "Revenue per hour (variations)",
            type: "currency",
            width: 13,
            value: (row)=>row.revenueVariationPerHour,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).revenueWithVariations.permissions(row)
        },
        revenueVariationReimbursementPerHour: {
            id: "revenueVariationReimbursementPerHour",
            label: "Revenue per hour (variations + reimbursements)",
            type: "currency",
            width: 13,
            value: (row)=>row.revenueVariationReimbursementPerHour,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).revenueWithVariationsReimbursements.permissions(row)
        },
        completionDate: {
            id: "completionDate",
            label: "Completion date",
            type: "date",
            width: 13,
            value: (row)=>{
                return row.completionDate ? new Date(row.completionDate) : null;
            },
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).fee.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).revenue.permissions(row)
        },
        latestInvoicedPhases: {
            id: "latestInvoicedPhases",
            label: "Latest Invoiced Phases",
            type: "text",
            width: 15,
            value: (row)=>row.latestInvoicedPhases,
            permissions: (row)=>(0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, row)
        },
        latestRevenueDate: {
            id: "latestRevenueDate",
            label: "Latest Revenue Date",
            type: "date",
            width: 13,
            value: (row)=>{
                return row.latestRevenueDate ? new Date(row.latestRevenueDate) : null;
            },
            permissions: (row)=>(0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, row)
        },
        latestRevenueAmount: {
            id: "latestRevenueAmount",
            label: "Latest Revenue Amount",
            type: "currency",
            width: 13,
            value: (row)=>{
                return row.latestRevenueAmount;
            },
            permissions: (row)=>(0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, row)
        },
        latestTimeEntryDate: {
            id: "latestTimeEntryDate",
            label: "Latest Time Entry Date",
            type: "date",
            width: 13,
            value: (row)=>{
                return row.latestTimeEntryDate ? new Date(row.latestTimeEntryDate) : null;
            }
        },
        latestTimeEntryDateInRange: {
            id: "latestTimeEntryDateInRange",
            label: "Latest Time Entry Date In Range",
            type: "date",
            width: 13,
            value: (row)=>{
                return row.latestTimeEntryDateInRange ? new Date(row.latestTimeEntryDateInRange) : null;
            }
        },
        projectedHours: {
            id: "projectedHours",
            label: "Projected Hours",
            type: "number",
            width: 13,
            value: (row)=>row.projectedHours,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).futureHours.permissions(row)
        },
        futureHours: {
            id: "futureHours",
            label: "Future Hours",
            type: "number",
            width: 13,
            value: (row)=>row.futureHours,
            permissions: (row)=>(0, $8kZ1o.canViewStaffAllocations)((0, $1BTI2.default).user, (0, $gJT7h.default).projectsById[row === null || row === void 0 ? void 0 : row.projectId])
        },
        futureLabour: {
            id: "futureLabour",
            label: "Future Labour Expense",
            type: "currency",
            width: 13,
            value: (row)=>row.futureLabour,
            permissions: (row)=>(0, $8kZ1o.canViewStaffAllocations)((0, $1BTI2.default).user, (0, $gJT7h.default).projectsById[row === null || row === void 0 ? void 0 : row.projectId]) && (0, $8kZ1o.canViewProjectStaffPay)((0, $1BTI2.default).user, (0, $gJT7h.default).projectsById[row === null || row === void 0 ? void 0 : row.projectId])
        },
        futureCost: {
            id: "futureCost",
            label: "Future Expense",
            type: "currency",
            width: 13,
            value: (row)=>row.futureCost,
            permissions: (row)=>(0, $8kZ1o.canViewStaffAllocations)((0, $1BTI2.default).user, (0, $gJT7h.default).projectsById[row === null || row === void 0 ? void 0 : row.projectId])
        },
        futureChargeOut: {
            id: "futureChargeOut",
            label: "Future Charge Out",
            type: "currency",
            width: 13,
            value: (row)=>row.futureChargeOut,
            permissions: (row)=>(0, $8kZ1o.canViewStaffAllocations)((0, $1BTI2.default).user, (0, $gJT7h.default).projectsById[row === null || row === void 0 ? void 0 : row.projectId]) && (0, $8kZ1o.canViewProjectStaffChargeOut)((0, $1BTI2.default).user, (0, $gJT7h.default).projectsById[row === null || row === void 0 ? void 0 : row.projectId])
        },
        futureRevenue: {
            id: "futureRevenue",
            label: "Future Revenue",
            type: "currency",
            width: 13,
            value: (row)=>row.futureRevenue,
            permissions: (row)=>(0, $8kZ1o.canViewRevenueTargets)((0, $1BTI2.default).user, (0, $gJT7h.default).projectsById[row === null || row === void 0 ? void 0 : row.projectId])
        },
        futureWeeklyCost: {
            id: "futureWeeklyCost",
            label: "Future Weekly Expense",
            type: "currency",
            width: 13,
            value: (row)=>row.futureWeeklyCost,
            permissions: (row)=>{
                var _ProjectReportColumns, _ProjectReportColumns2, _ProjectReportColumns3, _ProjectReportColumns4;
                return ((_ProjectReportColumns = $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).futureCost) === null || _ProjectReportColumns === void 0 ? void 0 : (_ProjectReportColumns2 = _ProjectReportColumns.permissions) === null || _ProjectReportColumns2 === void 0 ? void 0 : _ProjectReportColumns2.call(_ProjectReportColumns, row)) && ((_ProjectReportColumns3 = $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).expenses) === null || _ProjectReportColumns3 === void 0 ? void 0 : (_ProjectReportColumns4 = _ProjectReportColumns3.permissions) === null || _ProjectReportColumns4 === void 0 ? void 0 : _ProjectReportColumns4.call(_ProjectReportColumns3, row));
            }
        },
        projectedRevenue: {
            id: "projectedRevenue",
            label: "Projected Revenue",
            type: "currency",
            width: 13,
            value: (row)=>row.projectedRevenue,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).revenue.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).futureRevenue.permissions(row)
        },
        projectedExpense: {
            id: "projectedExpense",
            label: "Projected Expense (Cost)",
            type: "currency",
            width: 13,
            value: (row)=>row.projectedExpense,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).futureCost.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).expenses.permissions(row)
        },
        projectedLabourExpense: {
            id: "projectedLabourExpense",
            label: "Projected Labour Expense",
            type: "currency",
            width: 13,
            value: (row)=>row.projectedLabourExpense,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).futureLabour.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).labourExpense.permissions(row)
        },
        projectedChargeOut: {
            id: "projectedChargeOut",
            label: "Projected Charge Out",
            type: "currency",
            width: 13,
            value: (row)=>row.projectedChargeOut,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).futureChargeOut.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).chargeOut.permissions(row)
        },
        projectedProfit: {
            id: "projectedProfit",
            label: "Projected Profit",
            type: "currency",
            width: 13,
            value: (row)=>row.projectedProfit,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).projectedRevenue.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).projectedExpense.permissions(row)
        },
        projectedProfitMargin: {
            id: "projectedProfitMargin",
            label: "Projected Profit Margin",
            type: "percent",
            aggregate: "avg",
            width: 13,
            value: (row)=>row.projectedProfitMargin,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).projectedProfit.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).projectedRevenue.permissions(row)
        },
        futureWeeklyHours: {
            id: "futureWeeklyHours",
            label: "Future Weekly Hours",
            type: "number",
            width: 13,
            value: (row)=>row.futureWeeklyHours,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).futureHours.permissions(row)
        },
        projectedWeeklyHours: {
            id: "projectedWeeklyHours",
            label: "Projected Weekly Hours",
            type: "number",
            width: 13,
            value: (row)=>row.projectedWeeklyHours,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).futureHours.permissions(row)
        },
        projectedWeeklyExpense: {
            id: "projectedWeeklyExpense",
            label: "Projected Weekly Expense",
            type: "currency",
            width: 13,
            value: (row)=>row.projectedWeeklyExpense,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).futureCost.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).expenses.permissions(row)
        },
        projectedWeeklyProfit: {
            id: "projectedWeeklyProfit",
            label: "Projected Weekly Profit",
            type: "currency",
            width: 13,
            value: (row)=>row.projectedWeeklyProfit,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).projectedRevenue.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).projectedWeeklyExpense.permissions(row)
        },
        projectedWeeklyProfitMargin: {
            id: "projectedWeeklyProfitMargin",
            label: "Projected Weekly Profit Margin",
            type: "percent",
            width: 13,
            value: (row)=>row.projectedWeeklyProfitMargin,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).projectedWeeklyProfit.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).projectedRevenue.permissions(row)
        },
        profitVariationProject: {
            id: "profitVariationProject",
            label: "Profit (Cost + Variation + Project)",
            type: "currency",
            width: 13,
            value: (row)=>row.profitVariationProject,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).revenueWithVariations.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).expensesVariationProject.permissions(row)
        },
        profitMarginVariationProject: {
            id: "profitMarginVariationProject",
            label: "Profit Margin (Cost + Variation + Project)",
            type: "percent",
            aggregate: "avg",
            width: 13,
            value: (row)=>row.profitMarginVariationProject,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).profitVariationProject.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).revenueWithVariations.permissions(row)
        },
        markupVariationProject: {
            id: "markupVariationProject",
            label: "Markup (Cost + Variation + Project)",
            type: "percent",
            aggregate: "avg",
            width: 13,
            value: (row)=>row.markupVariationProject,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).profitVariationProject.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).expensesVariationProject.permissions(row)
        },
        chargeOutVsRevenueVariation: {
            id: "chargeOutVsRevenueVariation",
            label: "Charge Out / Revenue (Variation)",
            type: "progressBar",
            format: (v)=>(0, $azaaH.default).currency(v, {
                    decimals: 0
                }),
            width: 24,
            value: (row)=>row.chargeOutVsRevenueVariation,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).chargeOutVariation.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).revenueWithVariations.permissions(row)
        },
        expenseVsRevenueVariation: {
            id: "expenseVsRevenueVariation",
            label: "Expenses / Revenue (Variation)",
            type: "progressBar",
            format: (v)=>(0, $azaaH.default).currency(v, {
                    decimals: 0
                }),
            width: 24,
            value: (row)=>row.expenseVsRevenueVariation,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).expensesVariation.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).revenueWithVariations.permissions(row)
        },
        expenseVsRevenueVariationProject: {
            id: "expenseVsRevenueVariationProject",
            label: "Expenses / Revenue (Cost + Variation + Project)",
            type: "progressBar",
            format: (v)=>(0, $azaaH.default).currency(v, {
                    decimals: 0
                }),
            width: 24,
            value: (row)=>row.expenseVsRevenueVariationProject,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).expensesVariationProject.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).revenueWithVariations.permissions(row)
        },
        revenueVsExpenseVariationProject: {
            id: "revenueVsExpenseVariationProject",
            label: "Revenue / Expenses (Cost + Variation + Project)",
            type: "progressBar",
            format: (v)=>(0, $azaaH.default).currency(v, {
                    decimals: 0
                }),
            width: 24,
            value: (row)=>row.revenueVsExpenseVariationProject,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).revenueWithVariations.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).expensesVariationProject.permissions(row)
        },
        profitVsRevenueVariationProject: {
            id: "profitVsRevenueVariationProject",
            label: "Profit / Revenue (Cost + Variation + Project)",
            type: "progressBar",
            format: (v)=>(0, $azaaH.default).currency(v, {
                    decimals: 0
                }),
            width: 24,
            value: (row)=>row.profitVsRevenueVariationProject,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).profitVariationProject.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).revenueWithVariations.permissions(row)
        },
        profitVsExpenseVariationProject: {
            id: "profitVsExpenseVariationProject",
            label: "Profit / Expenses (Cost + Variation + Project)",
            type: "progressBar",
            format: (v)=>(0, $azaaH.default).currency(v, {
                    decimals: 0
                }),
            width: 24,
            value: (row)=>row.profitVsExpenseVariationProject,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).profitVariationProject.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).expensesVariationProject.permissions(row)
        },
        serviceFee: {
            id: "serviceFee",
            label: "Service Fee",
            type: "currency",
            width: 13,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).fee.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).projectExpenses.permissions(row),
            value: (row)=>row.serviceFee
        },
        serviceProfit: {
            id: "serviceProfit",
            label: "Service Profit",
            type: "currency",
            width: 13,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).serviceFee.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).expenses.permissions(row),
            value: (row)=>row.serviceProfit
        },
        serviceProfitMargin: {
            id: "serviceProfitMargin",
            label: "Service Profit Margin",
            type: "percent",
            aggregate: "avg",
            width: 13,
            permissions: (row)=>$70cbabb69a0dbd53$export$87b7940e8d176c5c(report).serviceProfit.permissions(row) && $70cbabb69a0dbd53$export$87b7940e8d176c5c(report).serviceFee.permissions(row),
            value: (row)=>row.serviceProfitMargin
        }
    });

});
parcelRegister("azaaH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b15101e1f64a43b$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "FormatMinutes", function () { return $7b15101e1f64a43b$export$63cfb4fd6bb06acc; });

var $ikffN = parcelRequire("ikffN");

var $4hBm1 = parcelRequire("4hBm1");

var $dtopU = parcelRequire("dtopU");

var $12o9H = parcelRequire("12o9H");

var $cwjKY = parcelRequire("cwjKY");

var $gjxeM = parcelRequire("gjxeM");

var $fJ4T4 = parcelRequire("fJ4T4");

var $i0shw = parcelRequire("i0shw");
var $7b15101e1f64a43b$export$2e2bcd8739ae039 = {
    boolean: (value, { fallbackValue: fallbackValue } = {})=>value != null ? (0, $ikffN.capitalCase)(String(Boolean(value))) : fallbackValue,
    text: (value, { fallbackValue: fallbackValue } = {})=>value ? String(value) : fallbackValue,
    number: (value, { decimals: decimals = 2, fallbackValue: fallbackValue } = {})=>{
        var _FormatNumber;
        return isFinite(value) ? (_FormatNumber = (0, $cwjKY.FormatNumber)(value, {
            decimals: decimals
        })) !== null && _FormatNumber !== void 0 ? _FormatNumber : fallbackValue : fallbackValue;
    },
    currency: (value, { decimals: decimals = 2, fallbackValue: fallbackValue } = {})=>{
        var _FormatCurrency;
        return isFinite(value) ? (_FormatCurrency = (0, $12o9H.FormatCurrency)(value, {
            decimals: decimals
        })) !== null && _FormatCurrency !== void 0 ? _FormatCurrency : fallbackValue : fallbackValue;
    },
    percent: (value, { decimals: decimals = 0, fallbackValue: fallbackValue } = {})=>{
        var _FormatPercent;
        return isFinite(value) ? (_FormatPercent = (0, $gjxeM.FormatPercent)(value, {
            decimals: decimals
        })) !== null && _FormatPercent !== void 0 ? _FormatPercent : fallbackValue : fallbackValue;
    },
    date: (value, { fallbackValue: fallbackValue } = {})=>value instanceof Date && !isNaN(value) ? (0, $fJ4T4.FormatDate)(value) : fallbackValue,
    time: (value, { fallbackValue: fallbackValue } = {})=>value instanceof Date && !isNaN(value) ? (0, $i0shw.FormatTime)(value) : fallbackValue,
    duration: (value, { decimals: decimals = 2, fallbackValue: fallbackValue } = {})=>value !== null && value !== void 0 && value.value && value !== null && value !== void 0 && value.unit ? `${(0, $cwjKY.FormatNumber)(value.value, {
            decimals: decimals
        })} ${(0, (/*@__PURE__*/$parcel$interopDefault($dtopU)))(value.unit, (0, $cwjKY.FormatNumber)(value.value, {
            decimals: decimals
        }))}` : fallbackValue,
    progress: (value, { decimals: decimals = 0, fallbackValue: fallbackValue } = {})=>{
        var _FormatNumber2;
        return isFinite(value) ? (_FormatNumber2 = (0, $cwjKY.FormatNumber)(value, {
            decimals: 0
        })) !== null && _FormatNumber2 !== void 0 ? _FormatNumber2 : fallbackValue : fallbackValue;
    },
    progressBar: (value, { decimals: decimals = 0, fallbackValue: fallbackValue } = {})=>{
        var _FormatNumber3;
        return isFinite(value) ? (_FormatNumber3 = (0, $cwjKY.FormatNumber)(value, {
            decimals: 0
        })) !== null && _FormatNumber3 !== void 0 ? _FormatNumber3 : fallbackValue : fallbackValue;
    },
    project: (value, { fallbackValue: fallbackValue } = {})=>{
        var _ref, _value$title;
        return (_ref = (_value$title = value === null || value === void 0 ? void 0 : value.title) !== null && _value$title !== void 0 ? _value$title : fallbackValue) !== null && _ref !== void 0 ? _ref : "";
    },
    phase: (value, { fallbackValue: fallbackValue } = {})=>{
        var _ref2, _value$title2;
        return (_ref2 = (_value$title2 = value === null || value === void 0 ? void 0 : value.title) !== null && _value$title2 !== void 0 ? _value$title2 : fallbackValue) !== null && _ref2 !== void 0 ? _ref2 : "";
    },
    task: (value, { fallbackValue: fallbackValue } = {})=>{
        var _value$name;
        return (_value$name = value === null || value === void 0 ? void 0 : value.name) !== null && _value$name !== void 0 ? _value$name : fallbackValue;
    },
    costCentre: (value, { fallbackValue: fallbackValue } = {})=>{
        var _ref3, _value$name2;
        return (_ref3 = (_value$name2 = value === null || value === void 0 ? void 0 : value.name) !== null && _value$name2 !== void 0 ? _value$name2 : fallbackValue) !== null && _ref3 !== void 0 ? _ref3 : "";
    },
    contact: (value, { fallbackValue: fallbackValue } = {})=>{
        var _ref4, _value$label;
        return (_ref4 = (_value$label = value === null || value === void 0 ? void 0 : value.label) !== null && _value$label !== void 0 ? _value$label : fallbackValue) !== null && _ref4 !== void 0 ? _ref4 : "";
    },
    staff: (value, { fallbackValue: fallbackValue } = {})=>{
        var _ref5, _value$fullName;
        return (_ref5 = (_value$fullName = value === null || value === void 0 ? void 0 : value.fullName) !== null && _value$fullName !== void 0 ? _value$fullName : fallbackValue) !== null && _ref5 !== void 0 ? _ref5 : "";
    },
    staffMember: (value, { fallbackValue: fallbackValue } = {})=>{
        var _ref6, _value$fullName2;
        return (_ref6 = (_value$fullName2 = value === null || value === void 0 ? void 0 : value.fullName) !== null && _value$fullName2 !== void 0 ? _value$fullName2 : fallbackValue) !== null && _ref6 !== void 0 ? _ref6 : "";
    },
    role: (value, { fallbackValue: fallbackValue } = {})=>{
        var _ref7, _value$name3;
        return (_ref7 = (_value$name3 = value === null || value === void 0 ? void 0 : value.name) !== null && _value$name3 !== void 0 ? _value$name3 : fallbackValue) !== null && _ref7 !== void 0 ? _ref7 : "";
    },
    status: (value, { fallbackValue: fallbackValue } = {})=>{
        var _ref8, _ref9;
        return (_ref8 = (_ref9 = value && (0, $ikffN.capitalCase)(value)) !== null && _ref9 !== void 0 ? _ref9 : fallbackValue) !== null && _ref8 !== void 0 ? _ref8 : "";
    },
    custom: (value, { fallbackValue: fallbackValue } = {})=>value !== null && value !== void 0 ? value : fallbackValue,
    durationMinutes: (value, { fallbackValue: fallbackValue } = {})=>{
        var _FormatMinutes;
        return isFinite(value) ? (_FormatMinutes = $7b15101e1f64a43b$export$63cfb4fd6bb06acc(value)) !== null && _FormatMinutes !== void 0 ? _FormatMinutes : fallbackValue : fallbackValue;
    },
    month: (value, { fallbackValue: fallbackValue } = {})=>value ? (0, $4hBm1.format)(value, "MMMM yyyy") : fallbackValue
};
function $7b15101e1f64a43b$export$63cfb4fd6bb06acc(totalMinutes) {
    let hours = Math.floor(totalMinutes / 60);
    let minutes = totalMinutes % 60;
    return hours + ":" + (minutes < 10 ? "0" : "") + minutes;
}

});
parcelRegister("cwjKY", function(module, exports) {

$parcel$export(module.exports, "FormatNumber", function () { return $91d7cc744fe43069$export$9ef92266399f225b; });

var $d0JnH = parcelRequire("d0JnH");


var $3arU6 = parcelRequire("3arU6");

var $1BTI2 = parcelRequire("1BTI2");

var $aTUKb = parcelRequire("aTUKb");
const $91d7cc744fe43069$export$9ef92266399f225b = (value, { decimals: decimals = 2, compact: compact = false } = {})=>{
    if ([
        null,
        undefined,
        ""
    ].includes(value)) return value;
    const formatter = new (0, $d0JnH.NumberFormatter)((0, (/*@__PURE__*/$parcel$interopDefault($3arU6))).findCountryLocales((0, $aTUKb.constantCase)(((0, $1BTI2.default) === null || (0, $1BTI2.default) === void 0 ? void 0 : (0, $1BTI2.default).organisationCountry) || "us"))[0], {
        style: "decimal",
        maximumFractionDigits: decimals,
        notation: compact ? "compact" : "standard"
    });
    return formatter.format(value);
};

});
parcelRegister("aTUKb", function(module, exports) {

$parcel$export(module.exports, "constantCase", function () { return $7efb0e9aeab0a3ef$export$f44cdeb23aa06bbd; });

var $53oVd = parcelRequire("53oVd");

var $grTX0 = parcelRequire("grTX0");

var $aDJxR = parcelRequire("aDJxR");
function $7efb0e9aeab0a3ef$export$f44cdeb23aa06bbd(input, options) {
    if (options === void 0) options = {};
    return (0, $grTX0.noCase)(input, (0, $53oVd.__assign)({
        delimiter: "_",
        transform: (0, $aDJxR.upperCase)
    }, options));
}

});
parcelRegister("aDJxR", function(module, exports) {

$parcel$export(module.exports, "upperCase", function () { return $7bf0e034452bbaf6$export$5b4b56d38b0b3c58; });
/**
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 */ var $7bf0e034452bbaf6$var$SUPPORTED_LOCALE = {
    tr: {
        regexp: /[\u0069]/g,
        map: {
            i: "\u0130"
        }
    },
    az: {
        regexp: /[\u0069]/g,
        map: {
            i: "\u0130"
        }
    },
    lt: {
        regexp: /[\u0069\u006A\u012F]\u0307|\u0069\u0307[\u0300\u0301\u0303]/g,
        map: {
            i\u0307: "I",
            j\u0307: "J",
            \u012F\u0307: "\u012E",
            i\u0307\u0300: "\xcc",
            i\u0307\u0301: "\xcd",
            i\u0307\u0303: "\u0128"
        }
    }
};
function $7bf0e034452bbaf6$export$41a02e171a5184fc(str, locale) {
    var lang = $7bf0e034452bbaf6$var$SUPPORTED_LOCALE[locale.toLowerCase()];
    if (lang) return $7bf0e034452bbaf6$export$5b4b56d38b0b3c58(str.replace(lang.regexp, function(m) {
        return lang.map[m];
    }));
    return $7bf0e034452bbaf6$export$5b4b56d38b0b3c58(str);
}
function $7bf0e034452bbaf6$export$5b4b56d38b0b3c58(str) {
    return str.toUpperCase();
}

});



parcelRegister("gjxeM", function(module, exports) {

$parcel$export(module.exports, "FormatPercent", function () { return $be0833ef2a98b73a$export$a733555cebd89e96; });

var $d0JnH = parcelRequire("d0JnH");


var $3arU6 = parcelRequire("3arU6");

var $1BTI2 = parcelRequire("1BTI2");

var $aTUKb = parcelRequire("aTUKb");
const $be0833ef2a98b73a$export$a733555cebd89e96 = (value, { decimals: decimals = 2 } = {})=>{
    const formatter = new (0, $d0JnH.NumberFormatter)((0, (/*@__PURE__*/$parcel$interopDefault($3arU6))).findCountryLocales((0, $aTUKb.constantCase)(((0, $1BTI2.default) === null || (0, $1BTI2.default) === void 0 ? void 0 : (0, $1BTI2.default).organisationCountry) || "us"))[0], {
        style: "percent",
        maximumFractionDigits: decimals
    });
    return formatter.format(value);
};

});

parcelRegister("fJ4T4", function(module, exports) {

$parcel$export(module.exports, "FormatDate", function () { return $b72ed978ef9486e1$export$68962dbd27cd2e36; });

var $1TwJM = parcelRequire("1TwJM");


var $3arU6 = parcelRequire("3arU6");

var $1BTI2 = parcelRequire("1BTI2");

var $aTUKb = parcelRequire("aTUKb");
const $b72ed978ef9486e1$export$68962dbd27cd2e36 = (value, options = {
    year: "numeric",
    month: "short",
    day: "2-digit"
})=>{
    const formatter = new (0, $1TwJM.DateFormatter)((0, (/*@__PURE__*/$parcel$interopDefault($3arU6))).findCountryLocales((0, $aTUKb.constantCase)(((0, $1BTI2.default) === null || (0, $1BTI2.default) === void 0 ? void 0 : (0, $1BTI2.default).organisationCountry) || "us"))[0], options);
    return formatter.format(value);
};

});
parcelRegister("1TwJM", function(module, exports) {

$parcel$export(module.exports, "DateFormatter", function () { return $161452757929ad69$export$ad991b66133851cf; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $161452757929ad69$var$$fb18d541ea1ad717$var$formatterCache = new Map();
class $161452757929ad69$export$ad991b66133851cf {
    /** Formats a date as a string according to the locale and format options passed to the constructor. */ format(value) {
        return this.formatter.format(value);
    }
    /** Formats a date to an array of parts such as separators, numbers, punctuation, and more. */ formatToParts(value) {
        return this.formatter.formatToParts(value);
    }
    /** Formats a date range as a string. */ formatRange(start, end) {
        // @ts-ignore
        if (typeof this.formatter.formatRange === "function") return this.formatter.formatRange(start, end);
        if (end < start) throw new RangeError("End date must be >= start date");
        // Very basic fallback for old browsers.
        return `${this.formatter.format(start)} \u{2013} ${this.formatter.format(end)}`;
    }
    /** Formats a date range as an array of parts. */ formatRangeToParts(start, end) {
        // @ts-ignore
        if (typeof this.formatter.formatRangeToParts === "function") return this.formatter.formatRangeToParts(start, end);
        if (end < start) throw new RangeError("End date must be >= start date");
        let startParts = this.formatter.formatToParts(start);
        let endParts = this.formatter.formatToParts(end);
        return [
            ...startParts.map((p)=>({
                    ...p,
                    source: "startRange"
                })),
            {
                type: "literal",
                value: " \u2013 ",
                source: "shared"
            },
            ...endParts.map((p)=>({
                    ...p,
                    source: "endRange"
                }))
        ];
    }
    /** Returns the resolved formatting options based on the values passed to the constructor. */ resolvedOptions() {
        let resolvedOptions = this.formatter.resolvedOptions();
        if ($161452757929ad69$var$$fb18d541ea1ad717$var$hasBuggyResolvedHourCycle()) {
            if (!this.resolvedHourCycle) this.resolvedHourCycle = $161452757929ad69$var$$fb18d541ea1ad717$var$getResolvedHourCycle(resolvedOptions.locale, this.options);
            resolvedOptions.hourCycle = this.resolvedHourCycle;
            resolvedOptions.hour12 = this.resolvedHourCycle === "h11" || this.resolvedHourCycle === "h12";
        }
        // Safari uses a different name for the Ethiopic (Amete Alem) calendar.
        // https://bugs.webkit.org/show_bug.cgi?id=241564
        if (resolvedOptions.calendar === "ethiopic-amete-alem") resolvedOptions.calendar = "ethioaa";
        return resolvedOptions;
    }
    constructor(locale, options = {}){
        this.formatter = $161452757929ad69$var$$fb18d541ea1ad717$var$getCachedDateFormatter(locale, options);
        this.options = options;
    }
}
// There are multiple bugs involving the hour12 and hourCycle options in various browser engines.
//   - Chrome [1] (and the ECMA 402 spec [2]) resolve hour12: false in English and other locales to h24 (24:00 - 23:59)
//     rather than h23 (00:00 - 23:59). Same can happen with hour12: true in French, which Chrome resolves to h11 (00:00 - 11:59)
//     rather than h12 (12:00 - 11:59).
//   - WebKit returns an incorrect hourCycle resolved option in the French locale due to incorrect parsing of 'h' literal
//     in the resolved pattern. It also formats incorrectly when specifying the hourCycle option for the same reason. [3]
// [1] https://bugs.chromium.org/p/chromium/issues/detail?id=1045791
// [2] https://github.com/tc39/ecma402/issues/402
// [3] https://bugs.webkit.org/show_bug.cgi?id=229313
// https://github.com/unicode-org/cldr/blob/018b55eff7ceb389c7e3fc44e2f657eae3b10b38/common/supplemental/supplementalData.xml#L4774-L4802
const $161452757929ad69$var$$fb18d541ea1ad717$var$hour12Preferences = {
    true: {
        // Only Japanese uses the h11 style for 12 hour time. All others use h12.
        ja: "h11"
    },
    false: {}
};
function $161452757929ad69$var$$fb18d541ea1ad717$var$getCachedDateFormatter(locale, options = {}) {
    // Work around buggy hour12 behavior in Chrome / ECMA 402 spec by using hourCycle instead.
    // Only apply the workaround if the issue is detected, because the hourCycle option is buggy in Safari.
    if (typeof options.hour12 === "boolean" && $161452757929ad69$var$$fb18d541ea1ad717$var$hasBuggyHour12Behavior()) {
        options = {
            ...options
        };
        let pref = $161452757929ad69$var$$fb18d541ea1ad717$var$hour12Preferences[String(options.hour12)][locale.split("-")[0]];
        let defaultHourCycle = options.hour12 ? "h12" : "h23";
        options.hourCycle = pref !== null && pref !== void 0 ? pref : defaultHourCycle;
        delete options.hour12;
    }
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : "");
    if ($161452757929ad69$var$$fb18d541ea1ad717$var$formatterCache.has(cacheKey)) return $161452757929ad69$var$$fb18d541ea1ad717$var$formatterCache.get(cacheKey);
    let numberFormatter = new Intl.DateTimeFormat(locale, options);
    $161452757929ad69$var$$fb18d541ea1ad717$var$formatterCache.set(cacheKey, numberFormatter);
    return numberFormatter;
}
let $161452757929ad69$var$$fb18d541ea1ad717$var$_hasBuggyHour12Behavior = null;
function $161452757929ad69$var$$fb18d541ea1ad717$var$hasBuggyHour12Behavior() {
    if ($161452757929ad69$var$$fb18d541ea1ad717$var$_hasBuggyHour12Behavior == null) $161452757929ad69$var$$fb18d541ea1ad717$var$_hasBuggyHour12Behavior = new Intl.DateTimeFormat("en-US", {
        hour: "numeric",
        hour12: false
    }).format(new Date(2020, 2, 3, 0)) === "24";
    return $161452757929ad69$var$$fb18d541ea1ad717$var$_hasBuggyHour12Behavior;
}
let $161452757929ad69$var$$fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle = null;
function $161452757929ad69$var$$fb18d541ea1ad717$var$hasBuggyResolvedHourCycle() {
    if ($161452757929ad69$var$$fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle == null) $161452757929ad69$var$$fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle = new Intl.DateTimeFormat("fr", {
        hour: "numeric",
        hour12: false
    }).resolvedOptions().hourCycle === "h12";
    return $161452757929ad69$var$$fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle;
}
function $161452757929ad69$var$$fb18d541ea1ad717$var$getResolvedHourCycle(locale, options) {
    if (!options.timeStyle && !options.hour) return undefined;
    // Work around buggy results in resolved hourCycle and hour12 options in WebKit.
    // Format the minimum possible hour and maximum possible hour in a day and parse the results.
    locale = locale.replace(/(-u-)?-nu-[a-zA-Z0-9]+/, "");
    locale += (locale.includes("-u-") ? "" : "-u") + "-nu-latn";
    let formatter = $161452757929ad69$var$$fb18d541ea1ad717$var$getCachedDateFormatter(locale, {
        ...options,
        timeZone: undefined // use local timezone
    });
    let min = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 0)).find((p)=>p.type === "hour").value, 10);
    let max = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 23)).find((p)=>p.type === "hour").value, 10);
    if (min === 0 && max === 23) return "h23";
    if (min === 24 && max === 23) return "h24";
    if (min === 0 && max === 11) return "h11";
    if (min === 12 && max === 11) return "h12";
    throw new Error("Unexpected hour cycle result");
}

});


parcelRegister("i0shw", function(module, exports) {

$parcel$export(module.exports, "FormatTime", function () { return $d1be2a3e0c6003f4$export$eb8fb74f0f7821e5; });

var $1TwJM = parcelRequire("1TwJM");


var $3arU6 = parcelRequire("3arU6");

var $1BTI2 = parcelRequire("1BTI2");

var $aTUKb = parcelRequire("aTUKb");
const $d1be2a3e0c6003f4$export$eb8fb74f0f7821e5 = (value, options = {
    hour: "2-digit",
    minute: "2-digit"
})=>{
    const formatter = new (0, $1TwJM.DateFormatter)((0, (/*@__PURE__*/$parcel$interopDefault($3arU6))).findCountryLocales((0, $aTUKb.constantCase)(((0, $1BTI2.default) === null || (0, $1BTI2.default) === void 0 ? void 0 : (0, $1BTI2.default).organisationCountry) || "us"))[0], options);
    return formatter.format(value);
};

});


parcelRegister("8kZ1o", function(module, exports) {

$parcel$export(module.exports, "hasImpersonationPermission", function () { return $611f869662ca58b1$export$6f77fbdf0d049e52; });
$parcel$export(module.exports, "canViewRoute", function () { return $611f869662ca58b1$export$a7cfc0d056598f1a; });
$parcel$export(module.exports, "canEditStaffAllocations", function () { return $611f869662ca58b1$export$9f63c899c144898f; });
$parcel$export(module.exports, "canViewProjectDetails", function () { return $611f869662ca58b1$export$cc02642ec7a15a0f; });
$parcel$export(module.exports, "canViewStaffAllocations", function () { return $611f869662ca58b1$export$69f4631efc1ce0fb; });
$parcel$export(module.exports, "canViewRevenueTargets", function () { return $611f869662ca58b1$export$5e89d543db4cb3c5; });
$parcel$export(module.exports, "canViewProjectInvoices", function () { return $611f869662ca58b1$export$8f145ea2aacc93bf; });
$parcel$export(module.exports, "canViewProjectExpenses", function () { return $611f869662ca58b1$export$9c6c3596a649013; });
$parcel$export(module.exports, "canViewProjectNotes", function () { return $611f869662ca58b1$export$f207a5f01ef17f14; });
$parcel$export(module.exports, "canEditProject", function () { return $611f869662ca58b1$export$19b300001556ce8d; });
$parcel$export(module.exports, "canViewProjectDates", function () { return $611f869662ca58b1$export$bd20d6788db57eed; });
$parcel$export(module.exports, "canViewProjectMilestones", function () { return $611f869662ca58b1$export$f519c71ba3d94458; });
$parcel$export(module.exports, "canViewStaffPayRate", function () { return $611f869662ca58b1$export$5727cd4b0ac96bb; });
$parcel$export(module.exports, "canViewStaffOvertimeRate", function () { return $611f869662ca58b1$export$36053682c9f8417f; });
$parcel$export(module.exports, "canViewStaffCostRate", function () { return $611f869662ca58b1$export$882b0cfdd762e78f; });
$parcel$export(module.exports, "canViewStaffChargeOutRate", function () { return $611f869662ca58b1$export$847c46638ce2c07a; });
$parcel$export(module.exports, "canViewExpenseTracking", function () { return $611f869662ca58b1$export$f911643f217cf522; });
$parcel$export(module.exports, "canEditRevenueTargets", function () { return $611f869662ca58b1$export$c38e22253b6bdfca; });
$parcel$export(module.exports, "canCreateProjects", function () { return $611f869662ca58b1$export$d4bf0e1fad882bfb; });
$parcel$export(module.exports, "canDeleteProject", function () { return $611f869662ca58b1$export$1097df0e51697619; });
$parcel$export(module.exports, "canEditProjectDates", function () { return $611f869662ca58b1$export$f4f8e93cd5b4a159; });
$parcel$export(module.exports, "canViewProjectFees", function () { return $611f869662ca58b1$export$5fe03513be1856a7; });
$parcel$export(module.exports, "canEditProjectFees", function () { return $611f869662ca58b1$export$39d988ece7dc9a7d; });
$parcel$export(module.exports, "canViewProjectExpenseBudgets", function () { return $611f869662ca58b1$export$46f00131111270ab; });
$parcel$export(module.exports, "canEditProjectExpenseBudgets", function () { return $611f869662ca58b1$export$6ce3923959b7bb56; });
$parcel$export(module.exports, "canEditProjectHoursBudgets", function () { return $611f869662ca58b1$export$b658ba1314280429; });
$parcel$export(module.exports, "canEditProjectInvoices", function () { return $611f869662ca58b1$export$b1b0b4bc6fec8224; });
$parcel$export(module.exports, "canCreateInvoices", function () { return $611f869662ca58b1$export$1b40dcd5759fa411; });
$parcel$export(module.exports, "canCreateInvoiceForProject", function () { return $611f869662ca58b1$export$43d2d38a5f43dbc; });
$parcel$export(module.exports, "canEditPhasesAndTasks", function () { return $611f869662ca58b1$export$7bb6d9646f4fd295; });
$parcel$export(module.exports, "canViewProjectStaffCost", function () { return $611f869662ca58b1$export$a057c023c394fd31; });
$parcel$export(module.exports, "canViewProjectStaffPay", function () { return $611f869662ca58b1$export$de83c01b76125c5d; });
$parcel$export(module.exports, "canEditProjectExpenses", function () { return $611f869662ca58b1$export$a42562e3b1090135; });
$parcel$export(module.exports, "canViewProjectStaffChargeOut", function () { return $611f869662ca58b1$export$60230a5d360a4fdb; });
$parcel$export(module.exports, "canEditStaffTime", function () { return $611f869662ca58b1$export$73d683bc2e914dd; });
$parcel$export(module.exports, "canViewCostCentres", function () { return $611f869662ca58b1$export$9ffec46adf74da80; });
$parcel$export(module.exports, "canEditCostCentres", function () { return $611f869662ca58b1$export$4cecdb0b0a83c076; });
$parcel$export(module.exports, "canViewContacts", function () { return $611f869662ca58b1$export$b816aa6ca12c6e7b; });
$parcel$export(module.exports, "canEditContacts", function () { return $611f869662ca58b1$export$886cadb798aad341; });
$parcel$export(module.exports, "canEditProjectNotes", function () { return $611f869662ca58b1$export$ae297a467f99d59; });
$parcel$export(module.exports, "canViewProjectStaffBudgets", function () { return $611f869662ca58b1$export$194284b4117aee2; });
$parcel$export(module.exports, "canEditProjectStaffBudgets", function () { return $611f869662ca58b1$export$f51d1fe47ad4aa30; });
$parcel$export(module.exports, "canEditStaffPayRate", function () { return $611f869662ca58b1$export$ed6bb8a5e2dde9b9; });
$parcel$export(module.exports, "canEditStaffOvertimeRate", function () { return $611f869662ca58b1$export$ae91a06e096f1c10; });
$parcel$export(module.exports, "canEditStaffCostRate", function () { return $611f869662ca58b1$export$2b0aa2266a0f8f25; });
$parcel$export(module.exports, "canEditStaffChargeOutRate", function () { return $611f869662ca58b1$export$c691d75d00a24f08; });
$parcel$export(module.exports, "canEditProjectRates", function () { return $611f869662ca58b1$export$e70f89ed763983b4; });
$parcel$export(module.exports, "canViewBilling", function () { return $611f869662ca58b1$export$bc10a6113304fa74; });
$parcel$export(module.exports, "canEditStaff", function () { return $611f869662ca58b1$export$848edbb71a33d6c2; });
$parcel$export(module.exports, "canCreateStaff", function () { return $611f869662ca58b1$export$cecf2bb38f56c7a4; });
$parcel$export(module.exports, "canDeleteStaff", function () { return $611f869662ca58b1$export$f20eb6b6dac3a588; });
$parcel$export(module.exports, "canViewRoles", function () { return $611f869662ca58b1$export$2f6dbf1f3b950bea; });
$parcel$export(module.exports, "canEditRoles", function () { return $611f869662ca58b1$export$a1b94807289cedb8; });
$parcel$export(module.exports, "canCreateRoles", function () { return $611f869662ca58b1$export$d1e0f83b12dad567; });
$parcel$export(module.exports, "canDeleteRoles", function () { return $611f869662ca58b1$export$e99a38b330e9c059; });
$parcel$export(module.exports, "canViewSettings", function () { return $611f869662ca58b1$export$b5ae555d76db988c; });
$parcel$export(module.exports, "canViewInvoiceSettings", function () { return $611f869662ca58b1$export$b65bc3aa18e9a466; });
$parcel$export(module.exports, "canEditInvoiceSettings", function () { return $611f869662ca58b1$export$fc71573f563e2f1; });
$parcel$export(module.exports, "canEnterTimeAgainstProject", function () { return $611f869662ca58b1$export$2d7ec97db174a3c7; });
$parcel$export(module.exports, "canEnterTimeAgainstPhase", function () { return $611f869662ca58b1$export$fc41a823d5177566; });
$parcel$export(module.exports, "canEditOverheadExpenses", function () { return $611f869662ca58b1$export$7c52463c7a2b7d32; });
$parcel$export(module.exports, "canEditHolidays", function () { return $611f869662ca58b1$export$9b42e1ed207bfe25; });
$parcel$export(module.exports, "canViewRevenueForecastStaffExpenses", function () { return $611f869662ca58b1$export$219bf7e74cf65303; });
$parcel$export(module.exports, "canViewRevenueForecastOperationalExpenses", function () { return $611f869662ca58b1$export$afe4fe727220541a; });
$parcel$export(module.exports, "getQueryPermissionFilters", function () { return $611f869662ca58b1$export$fa54d6a70ae90fb7; });
$parcel$export(module.exports, "hasPermissionsForAllProjects", function () { return $611f869662ca58b1$export$fcd0e7be0d7a4a3f; });
$parcel$export(module.exports, "getAllPermissionProjectIds", function () { return $611f869662ca58b1$export$f4113ed376ae8577; });
$parcel$export(module.exports, "getAllPermissionCostCentreIds", function () { return $611f869662ca58b1$export$e3d4037aaab465e6; });
$parcel$export(module.exports, "addProjectPermission", function () { return $611f869662ca58b1$export$bb52a0a65cf7bc6b; });
$parcel$export(module.exports, "updateProjectPermission", function () { return $611f869662ca58b1$export$ce80826071748789; });
$parcel$export(module.exports, "updateProjectPermissionFilter", function () { return $611f869662ca58b1$export$8feda8b7284fa718; });
$parcel$export(module.exports, "deleteProjectPermission", function () { return $611f869662ca58b1$export$ef31ce88c1fee5b0; });
$parcel$export(module.exports, "updateStaffPermission", function () { return $611f869662ca58b1$export$33db88f807cae7c1; });
$parcel$export(module.exports, "canSeeFeesAndRevenue", function () { return $611f869662ca58b1$export$eefe297550f20bb2; });
$parcel$export(module.exports, "canSeeExpenses", function () { return $611f869662ca58b1$export$fe8739235582650e; });
$parcel$export(module.exports, "canSeeSalaries", function () { return $611f869662ca58b1$export$f348984146c42cee; });
$parcel$export(module.exports, "canSeeOperationalExpenses", function () { return $611f869662ca58b1$export$a6beca1da1575bb4; });
$parcel$export(module.exports, "canLogTimeAgainstNoPhase", function () { return $611f869662ca58b1$export$298056a9e410a562; });
$parcel$export(module.exports, "canLogTimeAgainstTasks", function () { return $611f869662ca58b1$export$ae00bd829f4f51c3; });
$parcel$export(module.exports, "canUseTimeEntryFlag", function () { return $611f869662ca58b1$export$6d898cd8a81518a6; });
$parcel$export(module.exports, "canViewFlexi", function () { return $611f869662ca58b1$export$741c52c76726b6fe; });
$parcel$export(module.exports, "canViewRemote", function () { return $611f869662ca58b1$export$3ea5cb739ea9922e; });
$parcel$export(module.exports, "autoPopulatePhaseInTimesheets", function () { return $611f869662ca58b1$export$754fb65b80d0b166; });
$parcel$export(module.exports, "shouldAutoPopulatePhasesInTimesheets", function () { return $611f869662ca58b1$export$db55a6395ac2c723; });
$parcel$export(module.exports, "shouldUpdateHoursFromRevenue", function () { return $611f869662ca58b1$export$b6ecaf9caa6603fc; });
$parcel$export(module.exports, "shouldUpdateRevenueFromHours", function () { return $611f869662ca58b1$export$b0d064f7a5278359; });
$parcel$export(module.exports, "shouldOpenUpdateForecastModalForRevenue", function () { return $611f869662ca58b1$export$63c9e18cc2dd731d; });
$parcel$export(module.exports, "shouldOpenUpdateForecastModalForResources", function () { return $611f869662ca58b1$export$f15ada9bfde93846; });
$parcel$export(module.exports, "neverAdjustForecasts", function () { return $611f869662ca58b1$export$c4d9e36c28fcff4e; });
$parcel$export(module.exports, "alwaysUpdateRevenue", function () { return $611f869662ca58b1$export$90049e1983ff85d2; });
$parcel$export(module.exports, "alwaysUpdateHours", function () { return $611f869662ca58b1$export$70810266846e0824; });
$parcel$export(module.exports, "canEditSuppliers", function () { return $611f869662ca58b1$export$2b8901aeafeaed5; });
$parcel$export(module.exports, "canEditStaffExpenses", function () { return $611f869662ca58b1$export$684d952a6bbd86e5; });
$parcel$export(module.exports, "canTrackExpenseAgainstProject", function () { return $611f869662ca58b1$export$36048df8dd0b8e59; });
$parcel$export(module.exports, "canTrackExpenseAgainstPhase", function () { return $611f869662ca58b1$export$ab2972ba6f2d8d3b; });
$parcel$export(module.exports, "canTrackExpenseAgainstGeneral", function () { return $611f869662ca58b1$export$a6558916f5c85935; });
$parcel$export(module.exports, "getDefaultTasks", function () { return $611f869662ca58b1$export$e7c4ca5af7e08d26; });
$parcel$export(module.exports, "hideBudgetProgress", function () { return $611f869662ca58b1$export$d23957846b5a6609; });
$parcel$export(module.exports, "canViewPrimaryContact", function () { return $611f869662ca58b1$export$7e8ab8886625eb0e; });
$parcel$export(module.exports, "migratedToV2", function () { return $611f869662ca58b1$export$f7763d8e62d354af; });
$parcel$export(module.exports, "usingNewLogin", function () { return $611f869662ca58b1$export$af9f94b5d4f62e2; });
$parcel$export(module.exports, "canEditProjectMilestones", function () { return $611f869662ca58b1$export$edbdc77cc54cdaf1; });


var $gAnn6 = parcelRequire("gAnn6");

var $jE5CX = parcelRequire("jE5CX");

var $1BTI2 = parcelRequire("1BTI2");

var $gJT7h = parcelRequire("gJT7h");

var $4WSZl = parcelRequire("4WSZl");

var $gN0TC = parcelRequire("gN0TC");
parcelRequire("3H03w");
parcelRequire("6Q5sp");
const $611f869662ca58b1$var$isDevOrTest = false;
const $611f869662ca58b1$export$b325ec6732b039cf = (staff, permissions = {}, options = {
    anyProject: false
})=>{
    const staffPermissions = (staff === null || staff === void 0 ? void 0 : staff.permissions) || {};
    for(const key in permissions){
        const value = permissions[key];
        if (key.includes("project")) {
            const projectPermissions = staffPermissions.projects || [
                {
                    filter: {
                        type: "all"
                    },
                    permissions: {}
                }
            ];
            const projectIdPermissions = projectPermissions.filter((p)=>p.filter.type === "project");
            const projectOwnerPermissions = projectPermissions.filter((p)=>p.filter.type === "owner");
            const costCentreIdPermissions = projectPermissions.filter((p)=>p.filter.type === "costCentre");
            const allProjectsPermissions = projectPermissions.filter((p)=>p.filter.type === "all");
            let projectPermissionFound = null;
            // First check if we have a matching permission for a specific project
            for (const projPermission of projectIdPermissions)if (options.anyProject || projPermission.filter.values.includes(options.projectId)) {
                if (typeof value === "boolean" ? (projPermission.permissions[key] || false) === value : (0, $gAnn6.permissionLevels).indexOf(projPermission.permissions[key] || "hidden") >= (0, $gAnn6.permissionLevels).indexOf(value)) {
                    projectPermissionFound = true;
                    break;
                } else if (!options.anyProject) {
                    projectPermissionFound = false;
                    break;
                }
            }
            // If we didn't find a matching permission for a specific project, check if we have a matching permission for a project owner
            if (projectPermissionFound === null) {
                for (const projPermission of projectOwnerPermissions)if (options.anyProject || options.ownerId === staff.id) {
                    if (typeof value === "boolean" ? (projPermission.permissions[key] || false) === value : (0, $gAnn6.permissionLevels).indexOf(projPermission.permissions[key] || "hidden") >= (0, $gAnn6.permissionLevels).indexOf(value)) {
                        projectPermissionFound = true;
                        break;
                    } else if (!options.anyProject) {
                        projectPermissionFound = false;
                        break;
                    }
                }
            }
            // If we didn't find a matching permission for a project owner, check if we have a matching permission for a cost centre
            if (projectPermissionFound === null) {
                for (const projPermission of costCentreIdPermissions)if (options.anyProject || projPermission.filter.values.includes(options.costCentreId)) {
                    if (typeof value === "boolean" ? (projPermission.permissions[key] || false) === value : (0, $gAnn6.permissionLevels).indexOf(projPermission.permissions[key] || "hidden") >= (0, $gAnn6.permissionLevels).indexOf(value)) {
                        projectPermissionFound = true;
                        break;
                    } else if (!options.anyProject) {
                        projectPermissionFound = false;
                        break;
                    }
                }
            }
            // If we didn't find a matching permission for a cost centre, check if we have a matching permission for any project
            if (projectPermissionFound === null) {
                for (const projPermission of allProjectsPermissions)if (typeof value === "boolean" ? (projPermission.permissions[key] || false) === value : (0, $gAnn6.permissionLevels).indexOf(projPermission.permissions[key] || "hidden") >= (0, $gAnn6.permissionLevels).indexOf(value)) {
                    projectPermissionFound = true;
                    break;
                }
            }
            // If we didn't find a matching permission for a project, return false
            if (!projectPermissionFound) return false;
        } else if (typeof value === "boolean") {
            if ((staffPermissions[key] || false) !== value) return false;
        } else if (typeof value === "string") {
            if ((0, $gAnn6.permissionLevels).indexOf(staffPermissions[key] || "hidden") < (0, $gAnn6.permissionLevels).indexOf(value)) return false;
        } else return false;
    }
    return true;
};
const $611f869662ca58b1$export$d35c4215f2c4d736 = (staff, project, permissions)=>{
    if (!permissions.projectPermissions && Object.keys(permissions).some((key)=>key !== "projectTimesheets")) permissions.projectPermissions = "view";
    if (project) return $611f869662ca58b1$export$b325ec6732b039cf(staff, permissions, {
        projectId: project.id,
        costCentreId: project.costCentreId,
        ownerId: project.ownerId
    });
    else return $611f869662ca58b1$export$7ddc7bfb8586ceeb(staff, permissions);
};
const $611f869662ca58b1$export$7ddc7bfb8586ceeb = (staff, permissions)=>{
    return $611f869662ca58b1$export$b325ec6732b039cf(staff, permissions, {
        anyProject: true
    });
};
const $611f869662ca58b1$export$6f77fbdf0d049e52 = (staff)=>{
    return (staff === null || staff === void 0 ? void 0 : staff.email) === "ryan@coincraft.co";
};
const $611f869662ca58b1$export$a7cfc0d056598f1a = (staff, routeId, params = {})=>{
    let project;
    switch(routeId){
        case "revenueForecast":
            return !$611f869662ca58b1$export$571b4d93ee7e01ff() && $611f869662ca58b1$export$b325ec6732b039cf(staff, {
                canViewRevenueForecast: true
            });
        case "revenueForecast2":
            return !$611f869662ca58b1$export$571b4d93ee7e01ff() && $611f869662ca58b1$export$ae3e9dcce9ba1003() && $611f869662ca58b1$export$b325ec6732b039cf(staff, {
                canViewRevenueForecast: true
            });
        case "resourceSchedule":
            return !$611f869662ca58b1$export$571b4d93ee7e01ff() && $611f869662ca58b1$export$b325ec6732b039cf(staff, {
                canViewResourceSchedule: true
            });
        case "weeklyPlanning":
            return !$611f869662ca58b1$export$571b4d93ee7e01ff() && $611f869662ca58b1$export$b325ec6732b039cf(staff, {
                canViewWeeklyPlanner: true
            }) && $611f869662ca58b1$export$9f63c899c144898f(staff);
        case "projectList":
            return !$611f869662ca58b1$export$571b4d93ee7e01ff() && $611f869662ca58b1$export$7ddc7bfb8586ceeb(staff, {
                projectPermissions: "view"
            });
        case "createProject":
            return !$611f869662ca58b1$export$571b4d93ee7e01ff() && $611f869662ca58b1$export$7ddc7bfb8586ceeb(staff, {
                projectPermissions: "admin"
            });
        case "project":
            project = (0, $gJT7h.default).projectsById[params.id];
            if (project) return !$611f869662ca58b1$export$571b4d93ee7e01ff() && $611f869662ca58b1$export$cc02642ec7a15a0f(staff, project);
            else return !$611f869662ca58b1$export$571b4d93ee7e01ff() && $611f869662ca58b1$export$7ddc7bfb8586ceeb(staff, {
                projectPermissions: "view"
            });
        case "project-details":
            project = (0, $gJT7h.default).projectsById[params.id];
            return !$611f869662ca58b1$export$571b4d93ee7e01ff() && $611f869662ca58b1$export$cc02642ec7a15a0f(staff, project);
        case "project-forecasts":
            project = (0, $gJT7h.default).projectsById[params.id];
            return !$611f869662ca58b1$export$571b4d93ee7e01ff() && ($611f869662ca58b1$export$69f4631efc1ce0fb(staff, project) || $611f869662ca58b1$export$5e89d543db4cb3c5(staff, project));
        case "project-tasks":
            project = (0, $gJT7h.default).projectsById[params.id];
            return !$611f869662ca58b1$export$571b4d93ee7e01ff() && $611f869662ca58b1$export$e261a1ab88e099a0(staff, project);
        case "project-changelog":
            project = (0, $gJT7h.default).projectsById[params.id];
            return !$611f869662ca58b1$export$571b4d93ee7e01ff() && ($611f869662ca58b1$export$8f145ea2aacc93bf(staff, project) || $611f869662ca58b1$export$9c6c3596a649013(staff, project));
        case "project-rates":
            project = (0, $gJT7h.default).projectsById[params.id];
            return !$611f869662ca58b1$export$571b4d93ee7e01ff() && $611f869662ca58b1$export$5717ab0d892ffe61(staff, project);
        case "project-notes":
            project = (0, $gJT7h.default).projectsById[params.id];
            return !$611f869662ca58b1$export$571b4d93ee7e01ff() && $611f869662ca58b1$export$f207a5f01ef17f14(staff, project);
        case "project-history":
            project = (0, $gJT7h.default).projectsById[params.id];
            return !$611f869662ca58b1$export$571b4d93ee7e01ff() && $611f869662ca58b1$export$19b300001556ce8d(staff, project);
        case "project-status":
            project = (0, $gJT7h.default).projectsById[params.id];
            return !$611f869662ca58b1$export$571b4d93ee7e01ff() && $611f869662ca58b1$export$bd20d6788db57eed(staff, project);
        case "project-milestones":
            project = (0, $gJT7h.default).projectsById[params.id];
            return !$611f869662ca58b1$export$571b4d93ee7e01ff() && $611f869662ca58b1$export$f519c71ba3d94458(staff, project) && $611f869662ca58b1$export$19b300001556ce8d(staff, project);
        case "staffList":
            return !$611f869662ca58b1$export$571b4d93ee7e01ff() && $611f869662ca58b1$export$b325ec6732b039cf(staff, {
                staffPermissions: "view"
            });
        case "staff":
            return !$611f869662ca58b1$export$571b4d93ee7e01ff() && $611f869662ca58b1$export$b325ec6732b039cf(staff, {
                staffPermissions: "view"
            });
        case "staff-details":
            return !$611f869662ca58b1$export$571b4d93ee7e01ff() && $611f869662ca58b1$export$35823a773372cb18(staff);
        case "staff-rates":
            return !$611f869662ca58b1$export$571b4d93ee7e01ff() && ($611f869662ca58b1$export$5727cd4b0ac96bb(staff) || $611f869662ca58b1$export$36053682c9f8417f(staff) || $611f869662ca58b1$export$882b0cfdd762e78f(staff) || $611f869662ca58b1$export$847c46638ce2c07a(staff));
        case "staff-permissions":
            return !$611f869662ca58b1$export$571b4d93ee7e01ff() && $611f869662ca58b1$export$b325ec6732b039cf(staff, {
                staffPermissions: "admin"
            });
        case "staffRoleList":
            return !$611f869662ca58b1$export$571b4d93ee7e01ff() && $611f869662ca58b1$export$b325ec6732b039cf(staff, {
                rolePermissions: "view"
            });
        case "staffRole":
            return !$611f869662ca58b1$export$571b4d93ee7e01ff() && $611f869662ca58b1$export$b325ec6732b039cf(staff, {
                rolePermissions: "view"
            });
        case "createStaff":
            return !$611f869662ca58b1$export$571b4d93ee7e01ff() && $611f869662ca58b1$export$b325ec6732b039cf(staff, {
                staffPermissions: "admin"
            });
        case "invoiceList":
            return !$611f869662ca58b1$export$571b4d93ee7e01ff() && $611f869662ca58b1$export$7ddc7bfb8586ceeb(staff, {
                projectInvoices: "view"
            });
        case "invoicePdf":
            return !$611f869662ca58b1$export$571b4d93ee7e01ff() && $611f869662ca58b1$export$7ddc7bfb8586ceeb(staff, {
                projectInvoices: "view"
            });
        case "invoice":
            return !$611f869662ca58b1$export$571b4d93ee7e01ff() && $611f869662ca58b1$export$7ddc7bfb8586ceeb(staff, {
                projectInvoices: "view"
            });
        case "invoiceTemplates":
            return !$611f869662ca58b1$export$571b4d93ee7e01ff() && $611f869662ca58b1$export$7ddc7bfb8586ceeb(staff, {
                projectInvoices: "admin"
            });
        case "invoiceSettings":
            return !$611f869662ca58b1$export$571b4d93ee7e01ff() && $611f869662ca58b1$export$b325ec6732b039cf(staff, {
                invoiceSettings: "edit"
            });
        case "createInvoice":
            return !$611f869662ca58b1$export$571b4d93ee7e01ff() && $611f869662ca58b1$export$7ddc7bfb8586ceeb(staff, {
                projectInvoices: "admin"
            });
        case "timesheets":
            return !$611f869662ca58b1$export$571b4d93ee7e01ff() && $611f869662ca58b1$export$7ddc7bfb8586ceeb(staff, {
                projectTimesheets: true
            });
        case "timesheets-daily":
            return !$611f869662ca58b1$export$571b4d93ee7e01ff();
        case "timesheets-weekly":
            return !$611f869662ca58b1$export$571b4d93ee7e01ff();
        case "timesheetCalendar":
            return !$611f869662ca58b1$export$571b4d93ee7e01ff() && $611f869662ca58b1$export$7ddc7bfb8586ceeb(staff, {
                projectTimesheets: true
            });
        case "timesheetReports":
            return !$611f869662ca58b1$export$571b4d93ee7e01ff() && $611f869662ca58b1$export$7ddc7bfb8586ceeb(staff, {
                projectTimesheets: true
            });
        case "overheadExpenses":
            return !$611f869662ca58b1$export$571b4d93ee7e01ff() && $611f869662ca58b1$export$b325ec6732b039cf(staff, {
                operationalExpenses: "edit"
            });
        case "costCentres":
            return !$611f869662ca58b1$export$571b4d93ee7e01ff() && $611f869662ca58b1$export$b325ec6732b039cf(staff, {
                costCentres: "edit"
            });
        case "organisationHolidays":
            return !$611f869662ca58b1$export$571b4d93ee7e01ff() && $611f869662ca58b1$export$b325ec6732b039cf(staff, {
                holidays: "edit"
            });
        case "contacts":
            return !$611f869662ca58b1$export$571b4d93ee7e01ff() && $611f869662ca58b1$export$b325ec6732b039cf(staff, {
                contacts: "view"
            });
        case "contact":
            return !$611f869662ca58b1$export$571b4d93ee7e01ff() && $611f869662ca58b1$export$b325ec6732b039cf(staff, {
                contacts: "view"
            });
        case "settings":
            return !$611f869662ca58b1$export$571b4d93ee7e01ff() && $611f869662ca58b1$export$b325ec6732b039cf(staff, {
                organisationSettings: "edit"
            });
        case "trackExpenses":
            return $611f869662ca58b1$export$f911643f217cf522();
        case "expenseReports":
            return $611f869662ca58b1$export$f911643f217cf522();
        case "suppliers":
            return $611f869662ca58b1$export$f911643f217cf522();
        case "login":
            return true;
        case "register":
            return true;
        case "registerDetails":
            return true;
        case "invite":
            return true;
        case "activateAccount":
            return true;
        case "forgottenPassword":
            return true;
        case "resetPassword":
            return true;
        case "accountingAuth":
            return true;
        case "billing":
            return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
                billing: "edit"
            });
        case "impersonate":
            return $611f869662ca58b1$export$6f77fbdf0d049e52(staff);
        case "migrate":
            return true;
        case "feedbackAuth":
            return true;
        default:
            return false;
    }
};
const $611f869662ca58b1$export$5e89d543db4cb3c5 = (staff, project)=>{
    return $611f869662ca58b1$export$d35c4215f2c4d736(staff, project, {
        projectForecastedRevenue: "view"
    });
};
const $611f869662ca58b1$export$c38e22253b6bdfca = (staff, project)=>{
    return $611f869662ca58b1$export$d35c4215f2c4d736(staff, project, {
        projectForecastedRevenue: "edit"
    });
};
const $611f869662ca58b1$export$69f4631efc1ce0fb = (staff, project)=>{
    return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
        canViewAllResourcing: true
    }) || $611f869662ca58b1$export$d35c4215f2c4d736(staff, project, {
        projectForecastedHours: "view"
    });
};
const $611f869662ca58b1$export$9f63c899c144898f = (staff, project)=>{
    return $611f869662ca58b1$export$d35c4215f2c4d736(staff, project, {
        projectForecastedHours: "edit"
    });
};
const $611f869662ca58b1$export$cc02642ec7a15a0f = (staff, project)=>{
    return $611f869662ca58b1$export$d35c4215f2c4d736(staff, project, {
        projectPermissions: "view"
    });
};
const $611f869662ca58b1$export$d4bf0e1fad882bfb = (staff)=>{
    return $611f869662ca58b1$export$7ddc7bfb8586ceeb(staff, {
        projectPermissions: "admin"
    });
};
const $611f869662ca58b1$export$1097df0e51697619 = (staff, project)=>{
    return $611f869662ca58b1$export$d35c4215f2c4d736(staff, project, {
        projectPermissions: "admin"
    });
};
const $611f869662ca58b1$export$19b300001556ce8d = (staff, project)=>{
    return $611f869662ca58b1$export$d35c4215f2c4d736(staff, project, {
        projectPermissions: "edit"
    });
};
const $611f869662ca58b1$export$bd20d6788db57eed = (staff, project)=>{
    return $611f869662ca58b1$export$d35c4215f2c4d736(staff, project, {
        projectDates: "view"
    });
};
const $611f869662ca58b1$export$f4f8e93cd5b4a159 = (staff, project)=>{
    return $611f869662ca58b1$export$d35c4215f2c4d736(staff, project, {
        projectDates: "edit"
    });
};
const $611f869662ca58b1$export$5fe03513be1856a7 = (staff, project)=>{
    return $611f869662ca58b1$export$d35c4215f2c4d736(staff, project, {
        projectFees: "view"
    });
};
const $611f869662ca58b1$export$39d988ece7dc9a7d = (staff, project)=>{
    return $611f869662ca58b1$export$d35c4215f2c4d736(staff, project, {
        projectFees: "edit"
    });
};
const $611f869662ca58b1$export$46f00131111270ab = (staff, project)=>{
    return $611f869662ca58b1$export$d35c4215f2c4d736(staff, project, {
        projectExpenseBudgets: "view"
    });
};
const $611f869662ca58b1$export$6ce3923959b7bb56 = (staff, project)=>{
    return $611f869662ca58b1$export$d35c4215f2c4d736(staff, project, {
        projectExpenseBudgets: "edit"
    });
};
const $611f869662ca58b1$export$b658ba1314280429 = (staff, project)=>{
    return $611f869662ca58b1$export$d35c4215f2c4d736(staff, project, {
        projectHoursBudgets: "edit"
    });
};
const $611f869662ca58b1$export$8f145ea2aacc93bf = (staff, project)=>{
    return $611f869662ca58b1$export$d35c4215f2c4d736(staff, project, {
        projectInvoices: "view"
    });
};
const $611f869662ca58b1$export$b1b0b4bc6fec8224 = (staff, project)=>{
    return $611f869662ca58b1$export$d35c4215f2c4d736(staff, project, {
        projectInvoices: "edit"
    });
};
const $611f869662ca58b1$export$1b40dcd5759fa411 = (staff)=>{
    return $611f869662ca58b1$export$7ddc7bfb8586ceeb(staff, {
        projectInvoices: "admin"
    });
};
const $611f869662ca58b1$export$43d2d38a5f43dbc = (staff, project)=>{
    return $611f869662ca58b1$export$d35c4215f2c4d736(staff, project, {
        projectInvoices: "admin"
    });
};
const $611f869662ca58b1$export$7bb6d9646f4fd295 = (staff, project)=>{
    return $611f869662ca58b1$export$d35c4215f2c4d736(staff, project, {
        projectPhasesTasks: "admin"
    });
};
const $611f869662ca58b1$export$e261a1ab88e099a0 = (staff, project)=>{
    return $611f869662ca58b1$export$d35c4215f2c4d736(staff, project, {
        projectPhasesTasks: "view"
    });
};
const $611f869662ca58b1$export$a057c023c394fd31 = (staff, project)=>{
    return $611f869662ca58b1$export$d35c4215f2c4d736(staff, project, {
        projectExpenses: "view"
    }) && $611f869662ca58b1$export$882b0cfdd762e78f(staff);
};
const $611f869662ca58b1$export$de83c01b76125c5d = (staff, project)=>{
    return $611f869662ca58b1$export$d35c4215f2c4d736(staff, project, {
        projectExpenses: "view"
    }) && $611f869662ca58b1$export$5727cd4b0ac96bb(staff);
};
const $611f869662ca58b1$export$9c6c3596a649013 = (staff, project)=>{
    return $611f869662ca58b1$export$d35c4215f2c4d736(staff, project, {
        projectExpenses: "view"
    });
};
const $611f869662ca58b1$export$a42562e3b1090135 = (staff, project)=>{
    return $611f869662ca58b1$export$d35c4215f2c4d736(staff, project, {
        projectExpenses: "edit"
    });
};
const $611f869662ca58b1$export$60230a5d360a4fdb = (staff, project)=>{
    return $611f869662ca58b1$export$d35c4215f2c4d736(staff, project, {
        projectFees: "view"
    }) && $611f869662ca58b1$export$847c46638ce2c07a(staff);
};
const $611f869662ca58b1$export$73d683bc2e914dd = (staff)=>{
    return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
        editStaffTime: true
    });
};
const $611f869662ca58b1$export$9ffec46adf74da80 = (staff)=>{
    return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
        costCentres: "view"
    });
};
const $611f869662ca58b1$export$4cecdb0b0a83c076 = (staff)=>{
    return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
        costCentres: "edit"
    });
};
const $611f869662ca58b1$export$b816aa6ca12c6e7b = (staff)=>{
    return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
        contacts: "view"
    });
};
const $611f869662ca58b1$export$886cadb798aad341 = (staff)=>{
    return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
        contacts: "edit"
    });
};
const $611f869662ca58b1$export$f207a5f01ef17f14 = (staff, project)=>{
    return $611f869662ca58b1$export$d35c4215f2c4d736(staff, project, {
        projectNotes: "view"
    });
};
const $611f869662ca58b1$export$ae297a467f99d59 = (staff, project)=>{
    return $611f869662ca58b1$export$d35c4215f2c4d736(staff, project, {
        projectNotes: "edit"
    });
};
const $611f869662ca58b1$export$194284b4117aee2 = (staff, project)=>{
    return $611f869662ca58b1$export$d35c4215f2c4d736(staff, project, {
        projectStaffBudgets: "view"
    });
};
const $611f869662ca58b1$export$f51d1fe47ad4aa30 = (staff, project)=>{
    return $611f869662ca58b1$export$d35c4215f2c4d736(staff, project, {
        projectStaffBudgets: "edit"
    });
};
const $611f869662ca58b1$export$5727cd4b0ac96bb = (staff)=>{
    return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
        staffPermissions: "view",
        payRate: "view"
    });
};
const $611f869662ca58b1$export$36053682c9f8417f = (staff)=>{
    return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
        staffPermissions: "view",
        overtimeRate: "view"
    });
};
const $611f869662ca58b1$export$882b0cfdd762e78f = (staff)=>{
    return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
        staffPermissions: "view",
        costRate: "view"
    });
};
const $611f869662ca58b1$export$847c46638ce2c07a = (staff)=>{
    return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
        staffPermissions: "view",
        chargeOutRate: "view"
    });
};
const $611f869662ca58b1$export$ed6bb8a5e2dde9b9 = (staff)=>{
    return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
        staffPermissions: "view",
        payRate: "edit"
    });
};
const $611f869662ca58b1$export$ae91a06e096f1c10 = (staff)=>{
    return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
        staffPermissions: "view",
        overtimeRate: "edit"
    });
};
const $611f869662ca58b1$export$2b0aa2266a0f8f25 = (staff)=>{
    return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
        staffPermissions: "view",
        costRate: "edit"
    });
};
const $611f869662ca58b1$export$c691d75d00a24f08 = (staff)=>{
    return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
        staffPermissions: "view",
        chargeOutRate: "edit"
    });
};
const $611f869662ca58b1$export$5717ab0d892ffe61 = (staff, project)=>{
    return $611f869662ca58b1$export$d35c4215f2c4d736(staff, project, {
        projectRates: "view"
    });
};
const $611f869662ca58b1$export$e70f89ed763983b4 = (staff, project)=>{
    return $611f869662ca58b1$export$d35c4215f2c4d736(staff, project, {
        projectRates: "edit"
    });
};
const $611f869662ca58b1$export$bc10a6113304fa74 = (staff)=>{
    return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
        billing: "edit"
    });
};
const $611f869662ca58b1$export$35823a773372cb18 = (staff)=>{
    return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
        staffPermissions: "view"
    });
};
const $611f869662ca58b1$export$848edbb71a33d6c2 = (staff)=>{
    return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
        staffPermissions: "edit"
    });
};
const $611f869662ca58b1$export$cecf2bb38f56c7a4 = (staff)=>{
    return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
        staffPermissions: "admin"
    });
};
const $611f869662ca58b1$export$f20eb6b6dac3a588 = (staff)=>{
    return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
        staffPermissions: "admin"
    });
};
const $611f869662ca58b1$export$2f6dbf1f3b950bea = (staff)=>{
    return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
        rolePermissions: "view"
    });
};
const $611f869662ca58b1$export$a1b94807289cedb8 = (staff)=>{
    return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
        rolePermissions: "edit"
    });
};
const $611f869662ca58b1$export$d1e0f83b12dad567 = (staff)=>{
    return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
        rolePermissions: "admin"
    });
};
const $611f869662ca58b1$export$e99a38b330e9c059 = (staff)=>{
    return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
        rolePermissions: "admin"
    });
};
const $611f869662ca58b1$export$b5ae555d76db988c = (staff)=>{
    return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
        organisationSettings: "view"
    });
};
const $611f869662ca58b1$export$b65bc3aa18e9a466 = (staff)=>{
    return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
        invoiceSettings: "view"
    });
};
const $611f869662ca58b1$export$fc71573f563e2f1 = (staff)=>{
    return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
        invoiceSettings: "edit"
    });
};
const $611f869662ca58b1$export$2d7ec97db174a3c7 = (staff, project, adminException = true)=>{
    return $611f869662ca58b1$export$d35c4215f2c4d736(staff, project, {
        projectTimesheets: true
    }) && $611f869662ca58b1$export$fc41a823d5177566(staff, project, adminException);
};
const $611f869662ca58b1$export$99ebb2f31597d0f8 = (staff)=>{
    return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
        operationalExpenses: "view"
    });
};
const $611f869662ca58b1$export$7c52463c7a2b7d32 = (staff)=>{
    return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
        operationalExpenses: "edit"
    });
};
const $611f869662ca58b1$export$1642bc81c5636cc = (staff)=>{
    return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
        holidays: "view"
    });
};
const $611f869662ca58b1$export$9b42e1ed207bfe25 = (staff)=>{
    return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
        holidays: "edit"
    });
};
const $611f869662ca58b1$export$e254e84d1c0876a0 = (staff)=>{
    return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
        canViewRevenueForecast: true
    });
};
const $611f869662ca58b1$export$219bf7e74cf65303 = (staff)=>{
    return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
        canViewStaffExpenses: true
    });
};
const $611f869662ca58b1$export$afe4fe727220541a = (staff)=>{
    return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
        canViewOperationalExpenses: true
    });
};
const $611f869662ca58b1$export$8696db803b573170 = (staff)=>{
    return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
        canViewResourceSchedule: true
    });
};
const $611f869662ca58b1$export$fea69f48c361f13f = (staff)=>{
    return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
        canViewWeeklyPlanner: true
    });
};
const $611f869662ca58b1$export$fa54d6a70ae90fb7 = (collection, staff, strict = false)=>{
    switch(collection){
        case "budgetedHours":
            return $611f869662ca58b1$export$cea5882ee84b1ee7(staff, strict ? {
                projectPermissions: "view"
            } : {
                projectTimesheets: true
            }, "project.");
        case "changeLogItems":
            return $611f869662ca58b1$export$cea5882ee84b1ee7(staff, {
                projectPermissions: "view",
                projectInvoices: "view"
            }, "project.");
        case "contacts":
            return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
                contacts: "view"
            }) ? [] : [
                `id in ${(0, $jE5CX.qf)([])}`
            ];
        case "costCentres":
            return [];
        case "dailyAllocations":
            return $611f869662ca58b1$export$cea5882ee84b1ee7(staff, strict ? {
                projectStaffBudgets: "view",
                projectForecastedHours: "view"
            } : {
                projectTimesheets: true
            }, "project.");
        case "allocations":
            return $611f869662ca58b1$export$cea5882ee84b1ee7(staff, strict ? {
                projectPermissions: "view"
            } : {
                projectTimesheets: true
            }, "project.");
        case "invoices":
            return $611f869662ca58b1$export$cea5882ee84b1ee7(staff, {
                projectPermissions: "view",
                projectInvoices: "view"
            }, "project.");
        case "invoiceDescriptionTemplates":
            return $611f869662ca58b1$export$7ddc7bfb8586ceeb(staff, {
                projectInvoices: "view"
            }) ? [] : [
                `id in ${(0, $jE5CX.qf)([])}`
            ];
        case "invoiceLineItems":
            return $611f869662ca58b1$export$cea5882ee84b1ee7(staff, {
                projectPermissions: "view",
                projectInvoices: "view"
            }, "project.");
        case "organisation":
            return [];
        case "organisationHolidays":
            return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
                holidays: "view"
            }) ? [] : [
                `id in ${(0, $jE5CX.qf)([])}`
            ];
        case "organisationSubscriptions":
            return [];
        case "overheadExpenses":
            return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
                operationalExpenses: "view"
            }) ? [] : [
                `id in ${(0, $jE5CX.qf)([])}`
            ];
        case "phases":
            return $611f869662ca58b1$export$cea5882ee84b1ee7(staff, strict ? {
                projectPermissions: "view"
            } : {
                projectTimesheets: true
            }, "project.");
        case "projects":
            return $611f869662ca58b1$export$cea5882ee84b1ee7(staff, strict ? {
                projectPermissions: "view"
            } : {
                projectTimesheets: true
            });
        case "projectExpenseAllocations":
            return $611f869662ca58b1$export$cea5882ee84b1ee7(staff, {
                projectPermissions: "view",
                projectExpenses: "view"
            }, "project.");
        case "projectExpenses":
            return $611f869662ca58b1$export$cea5882ee84b1ee7(staff, {
                projectPermissions: "view",
                projectExpenses: "view"
            }, "project.");
        case "projectNotes":
            return $611f869662ca58b1$export$cea5882ee84b1ee7(staff, {
                projectPermissions: "view",
                projectNotes: "view"
            }, "project.");
        case "projectRates":
            return $611f869662ca58b1$export$cea5882ee84b1ee7(staff, {
                projectPermissions: "view",
                projectRates: "view"
            }, "project.");
        case "reports":
            return [];
        case "resourceScheduleReports":
            return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
                canViewResourceSchedule: true
            }) ? [] : [
                `id in ${(0, $jE5CX.qf)([])}`
            ];
        case "revenueForecastReports":
            return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
                canViewRevenueForecast: true
            }) ? [] : [
                `id in ${(0, $jE5CX.qf)([])}`
            ];
        case "revenueTargets":
            return $611f869662ca58b1$export$cea5882ee84b1ee7(staff, {
                projectPermissions: "view",
                projectForecastedRevenue: "view"
            }, "project.");
        case "roles":
            return [];
        case "roleRates":
            return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
                payRate: "view"
            }) || $611f869662ca58b1$export$b325ec6732b039cf(staff, {
                overtimeRate: "view"
            }) || $611f869662ca58b1$export$b325ec6732b039cf(staff, {
                costRate: "view"
            }) || $611f869662ca58b1$export$b325ec6732b039cf(staff, {
                chargeOutRate: "view"
            }) ? [] : [
                `id in ${(0, $jE5CX.qf)([])}`
            ];
        case "staff":
            return [];
        case "staffRates":
            return $611f869662ca58b1$export$b325ec6732b039cf(staff, {
                payRate: "view"
            }) || $611f869662ca58b1$export$b325ec6732b039cf(staff, {
                overtimeRate: "view"
            }) || $611f869662ca58b1$export$b325ec6732b039cf(staff, {
                costRate: "view"
            }) || $611f869662ca58b1$export$b325ec6732b039cf(staff, {
                chargeOutRate: "view"
            }) ? [] : [
                `id in ${(0, $jE5CX.qf)([])}`
            ];
        case "tasks":
            return $611f869662ca58b1$export$cea5882ee84b1ee7(staff, strict ? {
                projectPermissions: "view"
            } : {
                projectTimesheets: true
            }, "project.");
        case "timeEntries":
            return [
                ...$611f869662ca58b1$export$cea5882ee84b1ee7(staff, // strict
                //     ? { projectPermissions: 'view' }
                {
                    projectTimesheets: true
                }, "project.", {
                    projectStaffTimesheets: true
                }),
                ...strict && !$611f869662ca58b1$export$194284b4117aee2(staff) ? [
                    `staffId == ${(0, $jE5CX.qf)(staff.id)}`
                ] : []
            ];
        case "revenueRows":
            return $611f869662ca58b1$export$cea5882ee84b1ee7(staff, {
                projectForecastedRevenue: "view",
                projectInvoices: "view"
            }, "project.");
        case "monthlyRevenueCells":
            return $611f869662ca58b1$export$cea5882ee84b1ee7(staff, {
                projectForecastedRevenue: "view",
                projectInvoices: "view"
            }, "project.");
        case "resourceRows":
            return $611f869662ca58b1$export$cea5882ee84b1ee7(staff, {
                projectStaffBudgets: "view",
                projectForecastedHours: "view"
            }, "project.");
        case "monthlyResourceCells":
            return $611f869662ca58b1$export$cea5882ee84b1ee7(staff, {
                projectStaffBudgets: "view",
                projectForecastedHours: "view"
            }, "project.");
        default:
            return [];
    }
};
const $611f869662ca58b1$export$cea5882ee84b1ee7 = (staff, permissions = {
    projectPermissions: "view"
}, prefix = "", staffPermissions = null)=>{
    const viewAllProjects = $611f869662ca58b1$export$b325ec6732b039cf(staff, permissions);
    const viewCostCentreIdsSelf = [];
    const viewCostCentreIdsOtherStaff = [];
    const hiddenCostCentreIds = [];
    const viewOwnerIdsSelf = [];
    const viewOwnerIdsOtherStaff = [];
    const hiddenOwnerIds = [];
    const viewProjectIdsSelf = [];
    const viewProjectIdsOtherStaff = [];
    const hiddenProjectIds = [];
    staff.permissions.projects.forEach((p)=>{
        if (p.filter.type === "costCentre") {
            if (Object.entries(permissions).every(([key, value])=>p.permissions[key] === value || (0, $gAnn6.permissionLevels).indexOf(p.permissions[key]) >= (0, $gAnn6.permissionLevels).indexOf(value))) {
                if (!staffPermissions || Object.entries(staffPermissions).every(([key, value])=>p.permissions[key] === value || (0, $gAnn6.permissionLevels).indexOf(p.permissions[key]) >= (0, $gAnn6.permissionLevels).indexOf(value))) viewCostCentreIdsOtherStaff.push(...p.filter.values);
                else viewCostCentreIdsSelf.push(...p.filter.values);
            } else hiddenCostCentreIds.push(...p.filter.values);
        } else if (p.filter.type === "owner") {
            if (Object.entries(permissions).every(([key, value])=>p.permissions[key] === value || (0, $gAnn6.permissionLevels).indexOf(p.permissions[key]) >= (0, $gAnn6.permissionLevels).indexOf(value))) {
                if (!staffPermissions || Object.entries(staffPermissions).every(([key, value])=>p.permissions[key] === value || (0, $gAnn6.permissionLevels).indexOf(p.permissions[key]) >= (0, $gAnn6.permissionLevels).indexOf(value))) viewOwnerIdsOtherStaff.push(staff.id);
                else viewOwnerIdsSelf.push(staff.id);
            } else hiddenOwnerIds.push(staff.id);
        } else if (p.filter.type === "project") {
            if (Object.entries(permissions).every(([key, value])=>p.permissions[key] === value || (0, $gAnn6.permissionLevels).indexOf(p.permissions[key]) >= (0, $gAnn6.permissionLevels).indexOf(value))) {
                if (!staffPermissions || Object.entries(staffPermissions).every(([key, value])=>p.permissions[key] === value || (0, $gAnn6.permissionLevels).indexOf(p.permissions[key]) >= (0, $gAnn6.permissionLevels).indexOf(value))) viewProjectIdsOtherStaff.push(...p.filter.values);
                else viewProjectIdsSelf.push(...p.filter.values);
            } else hiddenProjectIds.push(...p.filter.values);
        }
    });
    let filters = [];
    if (viewAllProjects) {
        // Basic case: Exclude hidden projects
        if (hiddenProjectIds.length) filters.push(`not(${prefix}id in (${(0, $jE5CX.qf)(hiddenProjectIds)}))`);
        if (hiddenOwnerIds.length) filters.push(`not(${prefix}ownerId in (${(0, $jE5CX.qf)(hiddenOwnerIds)}))`);
        // More complex case: Exclude hidden cost centres, but include any explicit project IDs
        if (hiddenCostCentreIds.length) {
            if (viewProjectIdsOtherStaff.length) filters.push(`(not(${prefix}costCentreId in (${(0, $jE5CX.qf)(hiddenCostCentreIds)})) or ${prefix}id in (${(0, $jE5CX.qf)(viewProjectIdsOtherStaff)}))`);
            else if (viewProjectIdsSelf.length) filters.push(`(not(${prefix}costCentreId in (${(0, $jE5CX.qf)(hiddenCostCentreIds)})) or (${prefix}id in (${(0, $jE5CX.qf)(viewProjectIdsOtherStaff)}) and staffId == ${(0, $jE5CX.qf)(staff.id)})`);
            else filters.push(`not(${prefix}costCentreId in (${(0, $jE5CX.qf)(hiddenCostCentreIds)}))`);
        } else if (viewProjectIdsOtherStaff.length && filters.length) filters.push(`${prefix}id in (${(0, $jE5CX.qf)(viewProjectIdsOtherStaff)})`);
        else if (viewProjectIdsSelf.length && filters.length) filters.push(`(${prefix}id in (${(0, $jE5CX.qf)(viewProjectIdsSelf)}) and staffId == ${(0, $jE5CX.qf)(staff.id)})`);
    } else if (viewCostCentreIdsSelf.length || viewCostCentreIdsOtherStaff.length || viewProjectIdsSelf.length || viewProjectIdsOtherStaff.length || viewOwnerIdsSelf.length || viewOwnerIdsOtherStaff.length) {
        // Only include projects/cost centres explicitly allowed
        const explicitViewFilters = [];
        if (viewCostCentreIdsOtherStaff.length) explicitViewFilters.push(`${prefix}costCentreId IN (${(0, $jE5CX.qf)(viewCostCentreIdsOtherStaff)})`);
        if (viewOwnerIdsOtherStaff.length) explicitViewFilters.push(`${prefix}ownerId IN (${(0, $jE5CX.qf)(viewOwnerIdsOtherStaff)})`);
        if (viewProjectIdsOtherStaff.length) explicitViewFilters.push(`${prefix}id IN (${(0, $jE5CX.qf)(viewProjectIdsOtherStaff)})`);
        if (viewOwnerIdsSelf.length) explicitViewFilters.push(`(${prefix}ownerId IN (${(0, $jE5CX.qf)(viewOwnerIdsSelf)}) and staffId == ${(0, $jE5CX.qf)(staff.id)})`);
        if (viewCostCentreIdsSelf.length) explicitViewFilters.push(`(${prefix}costCentreId IN (${(0, $jE5CX.qf)(viewCostCentreIdsSelf)}) and staffId == ${(0, $jE5CX.qf)(staff.id)})`);
        if (viewProjectIdsSelf.length) explicitViewFilters.push(`(${prefix}id IN (${(0, $jE5CX.qf)(viewProjectIdsSelf)}) and staffId == ${(0, $jE5CX.qf)(staff.id)})`);
        filters.push(`(${explicitViewFilters.join(" OR ")})`);
    } else // If there are no explicitly allowed projects or cost centers, the user shouldn't be able to see any project.
    filters.push(`${prefix}id in ${(0, $jE5CX.qf)([])}`); // This is a false condition in SQL, which will result in no rows being returned.
    return filters;
};
const $611f869662ca58b1$export$fcd0e7be0d7a4a3f = (staffPermissions)=>{
    return staffPermissions.projects.some((p)=>p.filter.type === "all");
};
const $611f869662ca58b1$export$f4113ed376ae8577 = (staffPermissions)=>{
    return staffPermissions.projects.filter((p)=>p.filter.type === "project").flatMap((p)=>p.filter.values);
};
const $611f869662ca58b1$export$e3d4037aaab465e6 = (staffPermissions)=>{
    return staffPermissions.projects.filter((p)=>p.filter.type === "costCentre").flatMap((p)=>p.filter.values);
};
const $611f869662ca58b1$export$bb52a0a65cf7bc6b = (staff)=>{
    staff.permissions.projects.push({
        filter: !$611f869662ca58b1$export$fcd0e7be0d7a4a3f(staff.permissions) ? {
            type: "all"
        } : {
            type: "project",
            values: []
        },
        id: (0, (/*@__PURE__*/$parcel$interopDefault($gN0TC)))(),
        permissions: {
            ...(0, $4WSZl.permissionPresets).timesheet.projects[0].permissions
        }
    });
    staff.update({
        permissions: {
            ...staff.permissions
        }
    });
};
const $611f869662ca58b1$export$ce80826071748789 = (staff, id, permissions)=>{
    const projectPermission = staff.permissions.projects.find((p)=>p.id === id);
    if (projectPermission) projectPermission.permissions = {
        ...projectPermission.permissions,
        ...permissions
    };
    staff.update({
        permissions: {
            ...staff.permissions
        }
    });
};
const $611f869662ca58b1$export$8feda8b7284fa718 = (staff, id, filter)=>{
    const projectPermission = staff.permissions.projects.find((p)=>p.id === id);
    if (projectPermission) projectPermission.filter = filter !== null && filter !== void 0 ? filter : projectPermission.filter;
    staff.update({
        permissions: {
            ...staff.permissions
        }
    });
};
const $611f869662ca58b1$export$ef31ce88c1fee5b0 = (staff, id)=>{
    staff.permissions.projects = staff.permissions.projects.filter((p)=>p.id !== id);
    staff.update({
        permissions: {
            ...staff.permissions
        }
    });
};
const $611f869662ca58b1$export$33db88f807cae7c1 = (staff, permissions)=>{
    staff.update({
        permissions: {
            ...staff.permissions,
            ...permissions
        }
    });
};
const $611f869662ca58b1$export$eefe297550f20bb2 = (staff)=>{
    return $611f869662ca58b1$export$5fe03513be1856a7(staff) || $611f869662ca58b1$export$5e89d543db4cb3c5(staff) || $611f869662ca58b1$export$8f145ea2aacc93bf(staff) || $611f869662ca58b1$export$847c46638ce2c07a(staff);
};
const $611f869662ca58b1$export$fe8739235582650e = (staff)=>{
    return $611f869662ca58b1$export$9c6c3596a649013(staff) || $611f869662ca58b1$export$46f00131111270ab(staff) || $611f869662ca58b1$export$882b0cfdd762e78f(staff);
};
const $611f869662ca58b1$export$f348984146c42cee = (staff)=>{
    return $611f869662ca58b1$export$5727cd4b0ac96bb(staff) || $611f869662ca58b1$export$36053682c9f8417f(staff);
};
const $611f869662ca58b1$export$a6beca1da1575bb4 = (staff)=>{
    return $611f869662ca58b1$export$99ebb2f31597d0f8(staff);
};
const $611f869662ca58b1$export$298056a9e410a562 = ()=>{
    var _SessionStore$setting;
    return (_SessionStore$setting = (0, $1BTI2.default).settings) === null || _SessionStore$setting === void 0 ? void 0 : _SessionStore$setting.allowNoPhase;
};
const $611f869662ca58b1$export$ae00bd829f4f51c3 = ()=>{
    var _SessionStore$setting2;
    return (_SessionStore$setting2 = (0, $1BTI2.default).settings) === null || _SessionStore$setting2 === void 0 ? void 0 : _SessionStore$setting2.useTasks;
};
const $611f869662ca58b1$export$63578e0659ccd39a = (phase)=>{
    var _SessionStore$setting3;
    return ((_SessionStore$setting3 = (0, $1BTI2.default).settings) === null || _SessionStore$setting3 === void 0 ? void 0 : _SessionStore$setting3.allowAfterPhaseEnd) || !phase.endDate || phase.endDate >= new Date();
};
const $611f869662ca58b1$export$e180c6df64ecea80 = (phase)=>{
    var _SessionStore$setting4;
    return (_SessionStore$setting4 = (0, $1BTI2.default).settings) === null || _SessionStore$setting4 === void 0 ? void 0 : _SessionStore$setting4.timeEntryStatus.includes(phase.status);
};
const $611f869662ca58b1$export$6d898cd8a81518a6 = (flag)=>{
    var _SessionStore$setting7;
    if (flag === "flexi") {
        var _SessionStore$setting5;
        return $611f869662ca58b1$export$741c52c76726b6fe() && ((_SessionStore$setting5 = (0, $1BTI2.default).settings) === null || _SessionStore$setting5 === void 0 ? void 0 : _SessionStore$setting5.timeEntryFlags.includes(flag));
    }
    if (flag === "remote") {
        var _SessionStore$setting6;
        return $611f869662ca58b1$export$3ea5cb739ea9922e() && ((_SessionStore$setting6 = (0, $1BTI2.default).settings) === null || _SessionStore$setting6 === void 0 ? void 0 : _SessionStore$setting6.timeEntryFlags.includes(flag));
    }
    return (_SessionStore$setting7 = (0, $1BTI2.default).settings) === null || _SessionStore$setting7 === void 0 ? void 0 : _SessionStore$setting7.timeEntryFlags.includes(flag);
};
const $611f869662ca58b1$var$phaseHasStaffBudgetedHours = (staff, phase)=>{
    return (phase.budgetedStaffIds || []).includes(staff.id);
};
const $611f869662ca58b1$var$phaseHasStaffAllocatedHours = (staff, phase)=>{
    return (phase.monthlyAllocatedStaffIds || []).includes(staff.id);
};
const $611f869662ca58b1$export$6111c66e9970d03f = (staff, phase)=>{
    var _SessionStore$setting8, _SessionStore$setting9, _SessionStore$setting10;
    return ((_SessionStore$setting8 = (0, $1BTI2.default).settings) === null || _SessionStore$setting8 === void 0 ? void 0 : _SessionStore$setting8.timeEntryAllocations.includes("noAllocations")) || ((_SessionStore$setting9 = (0, $1BTI2.default).settings) === null || _SessionStore$setting9 === void 0 ? void 0 : _SessionStore$setting9.timeEntryAllocations.includes("budgets")) && $611f869662ca58b1$var$phaseHasStaffBudgetedHours(staff, phase) || ((_SessionStore$setting10 = (0, $1BTI2.default).settings) === null || _SessionStore$setting10 === void 0 ? void 0 : _SessionStore$setting10.timeEntryAllocations.includes("allocations")) && $611f869662ca58b1$var$phaseHasStaffAllocatedHours(staff, phase);
};
const $611f869662ca58b1$export$fc41a823d5177566 = (staff, phase, adminException = true)=>{
    return adminException && $611f869662ca58b1$export$3f1b5bfd8135b6c(staff) || !(phase !== null && phase !== void 0 && phase.isRootPhase) && $611f869662ca58b1$export$63578e0659ccd39a(phase) && $611f869662ca58b1$export$e180c6df64ecea80(phase) && $611f869662ca58b1$export$6111c66e9970d03f(staff, phase) || $611f869662ca58b1$export$298056a9e410a562() && (phase === null || phase === void 0 ? void 0 : phase.isRootPhase);
};
const $611f869662ca58b1$export$fc970ed23da99565 = (staff)=>{
    return $611f869662ca58b1$export$f348984146c42cee(staff) || $611f869662ca58b1$export$a6beca1da1575bb4(staff) || $611f869662ca58b1$export$bc10a6113304fa74(staff) || $611f869662ca58b1$export$b5ae555d76db988c(staff);
};
const $611f869662ca58b1$export$3f1b5bfd8135b6c = (staff)=>{
    return $611f869662ca58b1$export$f348984146c42cee(staff) && $611f869662ca58b1$export$a6beca1da1575bb4(staff) && $611f869662ca58b1$export$bc10a6113304fa74(staff) && $611f869662ca58b1$export$b5ae555d76db988c(staff);
};
const $611f869662ca58b1$export$754fb65b80d0b166 = (staff, phase)=>{
    var _SessionStore$setting11, _SessionStore$setting12;
    return ((_SessionStore$setting11 = (0, $1BTI2.default).settings) === null || _SessionStore$setting11 === void 0 ? void 0 : _SessionStore$setting11.autoPopulate.includes("budgets")) && $611f869662ca58b1$var$phaseHasStaffBudgetedHours(staff, phase) || ((_SessionStore$setting12 = (0, $1BTI2.default).settings) === null || _SessionStore$setting12 === void 0 ? void 0 : _SessionStore$setting12.autoPopulate.includes("allocations")) && $611f869662ca58b1$var$phaseHasStaffAllocatedHours(staff, phase);
};
const $611f869662ca58b1$export$db55a6395ac2c723 = ()=>{
    var _SessionStore$setting13, _SessionStore$setting14;
    return ((_SessionStore$setting13 = (0, $1BTI2.default).settings) === null || _SessionStore$setting13 === void 0 ? void 0 : _SessionStore$setting13.autoPopulate.includes("budgets")) || ((_SessionStore$setting14 = (0, $1BTI2.default).settings) === null || _SessionStore$setting14 === void 0 ? void 0 : _SessionStore$setting14.autoPopulate.includes("allocations"));
};
const $611f869662ca58b1$export$b6ecaf9caa6603fc = ()=>{
    var _SessionStore$setting15;
    return (_SessionStore$setting15 = (0, $1BTI2.default).settings) === null || _SessionStore$setting15 === void 0 ? void 0 : _SessionStore$setting15.updateHoursFromRevenue;
};
const $611f869662ca58b1$export$b0d064f7a5278359 = ()=>{
    var _SessionStore$setting16;
    return (_SessionStore$setting16 = (0, $1BTI2.default).settings) === null || _SessionStore$setting16 === void 0 ? void 0 : _SessionStore$setting16.updateRevenueFromHours;
};
const $611f869662ca58b1$export$b23d26f35bff73e6 = ()=>{
    return (0, $1BTI2.default).settings.autoUpdateRevenue.action === "ask" || (0, $1BTI2.default).settings.autoUpdateHours.action === "ask";
};
const $611f869662ca58b1$export$63c9e18cc2dd731d = ()=>{
    return (0, $1BTI2.default).settings.autoUpdateRevenue.action === "ask";
};
const $611f869662ca58b1$export$f15ada9bfde93846 = ()=>{
    return (0, $1BTI2.default).settings.autoUpdateHours.action === "ask";
};
const $611f869662ca58b1$export$c4d9e36c28fcff4e = ()=>{
    return $611f869662ca58b1$export$53d5bdd39f278bc8() && $611f869662ca58b1$export$4b11df8037968d99();
};
const $611f869662ca58b1$export$90049e1983ff85d2 = ()=>{
    return (0, $1BTI2.default).settings.autoUpdateRevenue.action === "automatic";
};
const $611f869662ca58b1$export$70810266846e0824 = ()=>{
    return (0, $1BTI2.default).settings.autoUpdateHours.action === "automatic";
};
const $611f869662ca58b1$export$4b11df8037968d99 = ()=>{
    return (0, $1BTI2.default).settings.autoUpdateRevenue.action === "never";
};
const $611f869662ca58b1$export$53d5bdd39f278bc8 = ()=>{
    return (0, $1BTI2.default).settings.autoUpdateHours.action === "never";
};
const $611f869662ca58b1$export$34cd61822c26e285 = ()=>{
    return (0, $1BTI2.default).settings.autoUpdateRevenue.adjustOnLoad === true;
};
const $611f869662ca58b1$export$5edceaf3fd6e4e07 = ()=>{
    return (0, $1BTI2.default).settings.autoUpdateHours.adjustOnLoad === true;
};
const $611f869662ca58b1$export$7381a62a33d52327 = ()=>{
    return !(0, $1BTI2.default).settings.savingInvoices.includes("automatic");
};
const $611f869662ca58b1$export$f911643f217cf522 = ()=>{
    var _SessionStore$organis;
    if ($611f869662ca58b1$var$isDevOrTest) return true;
    return [
        "f6fb558a-31eb-42cf-82fd-bd44d39207eb",
        "6ec3e97e-8778-4cfc-866e-710f7bd497ad",
        "b3a487aa-de6d-4d7d-b065-f8042ade67e8",
        "886a20ba-bfd9-4479-b7d7-04b73bcb7314",
        "6f24b71a-6ec5-47d5-a2cc-818a6811c1b3",
        "c2b38a3b-ae2e-4589-8e9b-6778d57f154e",
        "b215f30c-5e5c-44af-ba3c-e5d2fd55fd62"
    ].includes((_SessionStore$organis = (0, $1BTI2.default).organisation) === null || _SessionStore$organis === void 0 ? void 0 : _SessionStore$organis.id);
};
const $611f869662ca58b1$export$52ef023427ec0160 = ()=>{
    return true;
};
const $611f869662ca58b1$export$2b8901aeafeaed5 = ()=>{
    return true;
};
const $611f869662ca58b1$export$684d952a6bbd86e5 = ()=>{
    return true;
};
const $611f869662ca58b1$export$36048df8dd0b8e59 = ()=>{
    return true;
};
const $611f869662ca58b1$export$ab2972ba6f2d8d3b = ()=>{
    return true;
};
const $611f869662ca58b1$export$a6558916f5c85935 = ()=>{
    return true;
};
const $611f869662ca58b1$export$e7c4ca5af7e08d26 = ()=>{
    var _SessionStore$organis2;
    if (((_SessionStore$organis2 = (0, $1BTI2.default).organisation) === null || _SessionStore$organis2 === void 0 ? void 0 : _SessionStore$organis2.id) === "7d729342-8401-4c32-82c8-d6b156469fdc") return [
        {
            name: "Additional services",
            isBillable: true,
            isVariation: true
        },
        {
            name: "Non-billable",
            isBillable: false,
            isVariation: false
        },
        {
            name: "STUDIO Review",
            isBillable: false,
            isVariation: false
        }
    ];
    else return [];
};
const $611f869662ca58b1$export$d23957846b5a6609 = ()=>{
    var _SessionStore$organis3;
    return [
        "7d729342-8401-4c32-82c8-d6b156469fdc"
    ].includes((_SessionStore$organis3 = (0, $1BTI2.default).organisation) === null || _SessionStore$organis3 === void 0 ? void 0 : _SessionStore$organis3.id);
};
const $611f869662ca58b1$export$7e8ab8886625eb0e = ()=>{
    var _SessionStore$organis4;
    if ($611f869662ca58b1$var$isDevOrTest) return true;
    return [
        "f6fb558a-31eb-42cf-82fd-bd44d39207eb",
        "97a4070d-0bc0-4a1a-b907-b4e3f612a70c",
        "9d7b8c8f-ada1-4ae7-a3ed-d79d538077b4"
    ].includes((_SessionStore$organis4 = (0, $1BTI2.default).organisation) === null || _SessionStore$organis4 === void 0 ? void 0 : _SessionStore$organis4.id);
};
const $611f869662ca58b1$export$3ea5cb739ea9922e = ()=>{
    var _SessionStore$organis5;
    if ($611f869662ca58b1$var$isDevOrTest) return true;
    return [
        "f6fb558a-31eb-42cf-82fd-bd44d39207eb",
        "7d9cd6d4-d57c-4210-a9a0-3a9c37263ff2",
        "6b603c7e-48b2-4184-8ad7-33b748be6ccc"
    ].includes((_SessionStore$organis5 = (0, $1BTI2.default).organisation) === null || _SessionStore$organis5 === void 0 ? void 0 : _SessionStore$organis5.id);
};
const $611f869662ca58b1$export$741c52c76726b6fe = ()=>{
    var _SessionStore$organis6;
    if ($611f869662ca58b1$var$isDevOrTest) return true;
    return [
        "f6fb558a-31eb-42cf-82fd-bd44d39207eb",
        "7d9cd6d4-d57c-4210-a9a0-3a9c37263ff2"
    ].includes((_SessionStore$organis6 = (0, $1BTI2.default).organisation) === null || _SessionStore$organis6 === void 0 ? void 0 : _SessionStore$organis6.id);
};
const $611f869662ca58b1$export$571b4d93ee7e01ff = ()=>{
    var _SessionStore$subscri;
    return (_SessionStore$subscri = (0, $1BTI2.default).subscription) === null || _SessionStore$subscri === void 0 ? void 0 : _SessionStore$subscri.isAccountLocked;
};
const $611f869662ca58b1$export$f7763d8e62d354af = ()=>{
    return (0, $1BTI2.default).migratedToV2;
};
const $611f869662ca58b1$export$af9f94b5d4f62e2 = ()=>{
    var _clerk$session;
    return false;
};
const $611f869662ca58b1$export$f519c71ba3d94458 = ()=>{
    var _SessionStore$organis7;
    if ($611f869662ca58b1$var$isDevOrTest) return true;
    return [
        "f6fb558a-31eb-42cf-82fd-bd44d39207eb",
        "100c8fc8-7518-4e15-b4dd-94812cc30e44"
    ].includes((_SessionStore$organis7 = (0, $1BTI2.default).organisation) === null || _SessionStore$organis7 === void 0 ? void 0 : _SessionStore$organis7.id);
};
const $611f869662ca58b1$export$ae3e9dcce9ba1003 = ()=>{
    var _SessionStore$organis8;
    if ($611f869662ca58b1$var$isDevOrTest) return true;
    return [
        "f6fb558a-31eb-42cf-82fd-bd44d39207eb",
        "7d729342-8401-4c32-82c8-d6b156469fdc",
        "97a4070d-0bc0-4a1a-b907-b4e3f612a70c",
        "6140ac14-e84e-4356-bed3-4fc48b00dc49",
        "91b50e84-ca39-40b0-ac71-44ea271548fa",
        "36f5ac4b-429e-483c-b647-df7add83ed68"
    ].includes((_SessionStore$organis8 = (0, $1BTI2.default).organisation) === null || _SessionStore$organis8 === void 0 ? void 0 : _SessionStore$organis8.id);
};
const $611f869662ca58b1$export$edbdc77cc54cdaf1 = (staff, project)=>{
    return $611f869662ca58b1$export$f519c71ba3d94458() && $611f869662ca58b1$export$19b300001556ce8d(staff, project);
};

});
parcelRegister("gAnn6", function(module, exports) {

$parcel$export(module.exports, "permissionStructure", function () { return $c132234548487832$export$934d5cf97a7eb061; });
$parcel$export(module.exports, "permissionLevels", function () { return $c132234548487832$export$1905b608ab6396f9; });
const $c132234548487832$export$934d5cf97a7eb061 = [
    {
        label: "Forecasts",
        permissions: [
            {
                label: "Can View Revenue Forecast",
                type: "switch",
                key: "canViewRevenueForecast"
            },
            {
                label: "Can View Staff Expenses",
                type: "switch",
                key: "canViewStaffExpenses",
                display: (permissions)=>permissions.canViewRevenueForecast
            },
            {
                label: "Can View Operational Expenses",
                type: "switch",
                key: "canViewOperationalExpenses",
                display: (permissions)=>permissions.canViewRevenueForecast
            },
            {
                label: "Can View Resource Schedule",
                type: "switch",
                key: "canViewResourceSchedule"
            },
            {
                label: "Can View All Resourcing",
                type: "switch",
                key: "canViewAllResourcing",
                display: (permissions)=>permissions.canViewResourceSchedule
            },
            {
                label: "Can View Weekly Planner",
                type: "switch",
                key: "canViewWeeklyPlanner"
            }
        ]
    },
    {
        label: "Projects",
        permissions: [
            {
                label: "Project Permissions",
                type: "radio",
                options: [
                    "hidden",
                    "view",
                    "edit",
                    "admin"
                ],
                key: "projectPermissions"
            },
            {
                label: "Fees",
                type: "radio",
                options: [
                    "hidden",
                    "view",
                    "edit"
                ],
                key: "projectFees",
                display: (permissions)=>permissions.projectPermissions && permissions.projectPermissions !== "hidden"
            },
            {
                label: "Expense Budgets",
                type: "radio",
                options: [
                    "hidden",
                    "view",
                    "edit"
                ],
                key: "projectExpenseBudgets",
                display: (permissions)=>permissions.projectPermissions && permissions.projectPermissions !== "hidden"
            },
            {
                label: "Hours Budgets",
                type: "radio",
                options: [
                    "view",
                    "edit"
                ],
                key: "projectHoursBudgets",
                display: (permissions)=>permissions.projectPermissions && permissions.projectPermissions !== "hidden"
            },
            {
                label: "Staff Budgets",
                type: "radio",
                options: [
                    "view",
                    "admin"
                ],
                key: "projectStaffBudgets",
                display: (permissions)=>permissions.projectPermissions && permissions.projectPermissions !== "hidden"
            },
            {
                label: "Project Dates",
                type: "radio",
                options: [
                    "view",
                    "edit"
                ],
                key: "projectDates",
                display: (permissions)=>permissions.projectPermissions && permissions.projectPermissions !== "hidden"
            },
            {
                label: "Phases & Tasks",
                type: "radio",
                options: [
                    "view",
                    "admin"
                ],
                key: "projectPhasesTasks",
                display: (permissions)=>permissions.projectPermissions && permissions.projectPermissions !== "hidden"
            },
            {
                label: "Project Expenses",
                type: "radio",
                options: [
                    "hidden",
                    "view",
                    "admin"
                ],
                key: "projectExpenses",
                display: (permissions)=>permissions.projectPermissions && permissions.projectPermissions !== "hidden"
            },
            {
                label: "Forecasted Revenue",
                type: "radio",
                options: [
                    "hidden",
                    "view",
                    "edit"
                ],
                key: "projectForecastedRevenue",
                display: (permissions)=>permissions.projectPermissions && permissions.projectPermissions !== "hidden"
            },
            {
                label: "Forecasted Hours",
                type: "radio",
                options: [
                    "view",
                    "edit"
                ],
                key: "projectForecastedHours",
                display: (permissions)=>permissions.projectPermissions && permissions.projectPermissions !== "hidden"
            },
            {
                label: "Invoices",
                type: "radio",
                options: [
                    "hidden",
                    "view",
                    "admin"
                ],
                key: "projectInvoices",
                display: (permissions)=>permissions.projectPermissions && permissions.projectPermissions !== "hidden"
            },
            {
                label: "Project Rates",
                type: "radio",
                options: [
                    "hidden",
                    "view",
                    "admin"
                ],
                key: "projectRates",
                display: (permissions)=>permissions.projectPermissions && permissions.projectPermissions !== "hidden"
            },
            {
                label: "Project Notes",
                type: "radio",
                options: [
                    "hidden",
                    "view",
                    "admin"
                ],
                key: "projectNotes",
                display: (permissions)=>permissions.projectPermissions && permissions.projectPermissions !== "hidden"
            },
            {
                label: "Can View Other Staff Timesheets",
                type: "switch",
                key: "projectStaffTimesheets",
                display: (permissions)=>permissions.projectPermissions && permissions.projectPermissions !== "hidden"
            },
            {
                label: "Can Record Time",
                type: "switch",
                key: "projectTimesheets"
            }
        ]
    },
    {
        label: "Staff & Roles",
        permissions: [
            {
                label: "Staff",
                type: "radio",
                options: [
                    "hidden",
                    "view",
                    "edit",
                    "admin"
                ],
                key: "staffPermissions"
            },
            {
                label: "Roles",
                type: "radio",
                options: [
                    "hidden",
                    "view",
                    "edit",
                    "admin"
                ],
                key: "rolePermissions"
            },
            {
                label: "Can Edit Timesheets",
                type: "switch",
                key: "editStaffTime",
                display: (permissions)=>permissions.staffPermissions && permissions.staffPermissions !== "hidden" || permissions.rolePermissions && permissions.rolePermissions !== "hidden"
            },
            {
                label: "Pay Rate",
                type: "radio",
                options: [
                    "hidden",
                    "view",
                    "admin"
                ],
                key: "payRate",
                display: (permissions)=>permissions.staffPermissions && permissions.staffPermissions !== "hidden" || permissions.rolePermissions && permissions.rolePermissions !== "hidden"
            },
            {
                label: "Overtime Rate",
                type: "radio",
                options: [
                    "hidden",
                    "view",
                    "admin"
                ],
                key: "overtimeRate",
                display: (permissions)=>permissions.staffPermissions && permissions.staffPermissions !== "hidden" || permissions.rolePermissions && permissions.rolePermissions !== "hidden"
            },
            {
                label: "Cost Rate",
                type: "radio",
                options: [
                    "hidden",
                    "view",
                    "admin"
                ],
                key: "costRate",
                display: (permissions)=>permissions.staffPermissions && permissions.staffPermissions !== "hidden" || permissions.rolePermissions && permissions.rolePermissions !== "hidden"
            },
            {
                label: "Charge Out Rate",
                type: "radio",
                options: [
                    "hidden",
                    "view",
                    "admin"
                ],
                key: "chargeOutRate",
                display: (permissions)=>permissions.staffPermissions && permissions.staffPermissions !== "hidden" || permissions.rolePermissions && permissions.rolePermissions !== "hidden"
            }
        ]
    },
    {
        label: "Organisation",
        permissions: [
            {
                label: "Contacts",
                type: "radio",
                options: [
                    "view",
                    "admin"
                ],
                key: "contacts"
            },
            {
                label: "Cost Centres",
                type: "radio",
                options: [
                    "view",
                    "admin"
                ],
                key: "costCentres"
            },
            {
                label: "Operational Expenses",
                type: "radio",
                options: [
                    "hidden",
                    "view",
                    "admin"
                ],
                key: "operationalExpenses"
            },
            {
                label: "Holidays",
                type: "radio",
                options: [
                    "hidden",
                    "view",
                    "admin"
                ],
                key: "holidays"
            },
            {
                label: "Invoice Settings",
                type: "radio",
                options: [
                    "hidden",
                    "edit"
                ],
                key: "invoiceSettings"
            },
            {
                label: "Organisation Settings",
                type: "radio",
                options: [
                    "hidden",
                    "edit"
                ],
                key: "organisationSettings"
            },
            {
                label: "Billing",
                type: "radio",
                options: [
                    "hidden",
                    "edit"
                ],
                key: "billing"
            }
        ]
    }
];
const $c132234548487832$export$1905b608ab6396f9 = [
    "hidden",
    "view",
    "edit",
    "admin"
];

});

parcelRegister("jE5CX", function(module, exports) {

$parcel$export(module.exports, "qf", function () { return $e4d61e3eb10875d0$export$d4dbd713fa707644; });

var $4hBm1 = parcelRequire("4hBm1");
function $e4d61e3eb10875d0$export$d4dbd713fa707644(value) {
    if (typeof value === "number") return String(value);
    if (value instanceof Date) return `'${(0, $4hBm1.formatISO)(value, {
        representation: "date"
    })}'`;
    if (typeof value === "boolean") return value ? "true" : "false";
    if (typeof value === "string") return `"${value}"`;
    if (Array.isArray(value)) return `[${value.map((v)=>$e4d61e3eb10875d0$export$d4dbd713fa707644(v)).join(",")}]`;
    if (value === null || value === undefined) return "null";
    return null;
}
function $e4d61e3eb10875d0$export$599928430721e45a(field) {
    return `(${field} != null ? ${field} : 0)`;
}
function $e4d61e3eb10875d0$export$ae563cffb2e58965(value, modelName) {
    modelName = modelName ? `${modelName}.` : "";
    return `${modelName}id == ${$e4d61e3eb10875d0$export$d4dbd713fa707644(String(value))}`;
}

});

parcelRegister("4WSZl", function(module, exports) {

$parcel$export(module.exports, "permissionPresets", function () { return $39a73bc236db6585$export$807e1b0b524050b6; });
const $39a73bc236db6585$export$807e1b0b524050b6 = {
    masterAdmin: {
        canViewRevenueForecast: true,
        canViewStaffExpenses: true,
        canViewOperationalExpenses: true,
        canViewResourceSchedule: true,
        canViewWeeklyPlanner: true,
        projects: [
            {
                filter: {
                    type: "all"
                },
                permissions: {
                    projectPermissions: "admin",
                    projectFees: "edit",
                    projectExpenseBudgets: "edit",
                    projectHoursBudgets: "edit",
                    projectStaffBudgets: "admin",
                    projectDates: "edit",
                    projectPhasesTasks: "admin",
                    projectExpenses: "admin",
                    projectForecastedRevenue: "edit",
                    projectForecastedHours: "edit",
                    projectInvoices: "admin",
                    projectRates: "admin",
                    projectNotes: "admin",
                    projectStaffTimesheets: true,
                    projectTimesheets: true
                }
            }
        ],
        staffPermissions: "admin",
        rolePermissions: "admin",
        editStaffTime: true,
        payRate: "admin",
        overtimeRate: "admin",
        costRate: "admin",
        chargeOutRate: "admin",
        contacts: "admin",
        costCentres: "admin",
        operationalExpenses: "admin",
        holidays: "admin",
        invoiceSettings: "edit",
        organisationSettings: "edit",
        billing: "edit"
    },
    limitedAdmin: {
        canViewRevenueForecast: true,
        canViewStaffExpenses: true,
        canViewOperationalExpenses: true,
        canViewResourceSchedule: true,
        canViewWeeklyPlanner: true,
        projects: [
            {
                filter: {
                    type: "all"
                },
                permissions: {
                    projectPermissions: "admin",
                    projectFees: "edit",
                    projectExpenseBudgets: "edit",
                    projectHoursBudgets: "edit",
                    projectStaffBudgets: "admin",
                    projectDates: "edit",
                    projectPhasesTasks: "admin",
                    projectExpenses: "admin",
                    projectForecastedRevenue: "edit",
                    projectForecastedHours: "edit",
                    projectInvoices: "admin",
                    projectRates: "admin",
                    projectNotes: "admin",
                    projectStaffTimesheets: true,
                    projectTimesheets: true
                }
            }
        ],
        staffPermissions: "view",
        rolePermissions: "view",
        editStaffTime: true,
        payRate: "view",
        overtimeRate: "view",
        costRate: "view",
        chargeOutRate: "view",
        contacts: "admin",
        costCentres: "hidden",
        operationalExpenses: "hidden",
        holidays: "view",
        invoiceSettings: "hidden",
        organisationSettings: "hidden",
        billing: "hidden"
    },
    projectManager: {
        canViewRevenueForecast: true,
        canViewStaffExpenses: false,
        canViewOperationalExpenses: false,
        canViewResourceSchedule: true,
        canViewWeeklyPlanner: true,
        projects: [
            {
                filter: {
                    type: "all"
                },
                permissions: {
                    projectPermissions: "edit",
                    projectFees: "view",
                    projectExpenseBudgets: "view",
                    projectHoursBudgets: "view",
                    projectStaffBudgets: "admin",
                    projectDates: "edit",
                    projectPhasesTasks: "view",
                    projectExpenses: "admin",
                    projectForecastedRevenue: "edit",
                    projectForecastedHours: "edit",
                    projectInvoices: "view",
                    projectRates: "view",
                    projectNotes: "admin",
                    projectStaffTimesheets: true,
                    projectTimesheets: true
                }
            }
        ],
        staffPermissions: "hidden",
        rolePermissions: "hidden",
        editStaffTime: false,
        payRate: "hidden",
        overtimeRate: "hidden",
        costRate: "view",
        chargeOutRate: "view",
        contacts: "view",
        costCentres: "view",
        operationalExpenses: "hidden",
        holidays: "view",
        invoiceSettings: "hidden",
        organisationSettings: "hidden",
        billing: "hidden"
    },
    viewer: {
        canViewRevenueForecast: true,
        canViewStaffExpenses: false,
        canViewOperationalExpenses: false,
        canViewResourceSchedule: true,
        canViewWeeklyPlanner: true,
        projects: [
            {
                filter: {
                    type: "all"
                },
                permissions: {
                    projectPermissions: "view",
                    projectFees: "view",
                    projectExpenseBudgets: "view",
                    projectHoursBudgets: "view",
                    projectStaffBudgets: "view",
                    projectDates: "view",
                    projectPhasesTasks: "view",
                    projectExpenses: "view",
                    projectForecastedRevenue: "view",
                    projectForecastedHours: "view",
                    projectInvoices: "view",
                    projectRates: "hidden",
                    projectNotes: "view",
                    projectStaffTimesheets: false,
                    projectTimesheets: true
                }
            }
        ],
        staffPermissions: "hidden",
        rolePermissions: "hidden",
        editStaffTime: false,
        payRate: "hidden",
        overtimeRate: "hidden",
        costRate: "view",
        chargeOutRate: "view",
        contacts: "view",
        costCentres: "view",
        operationalExpenses: "hidden",
        holidays: "view",
        invoiceSettings: "hidden",
        organisationSettings: "hidden",
        billing: "hidden"
    },
    timesheet: {
        canViewRevenueForecast: false,
        canViewStaffExpenses: false,
        canViewOperationalExpenses: false,
        canViewResourceSchedule: false,
        canViewWeeklyPlanner: false,
        projects: [
            {
                filter: {
                    type: "all"
                },
                permissions: {
                    projectPermissions: "hidden",
                    projectFees: "hidden",
                    projectExpenseBudgets: "hidden",
                    projectHoursBudgets: "hidden",
                    projectStaffBudgets: "hidden",
                    projectDates: "hidden",
                    projectPhasesTasks: "hidden",
                    projectExpenses: "hidden",
                    projectForecastedRevenue: "hidden",
                    projectForecastedHours: "hidden",
                    projectInvoices: "hidden",
                    projectRates: "hidden",
                    projectNotes: "hidden",
                    projectStaffTimesheets: false,
                    projectTimesheets: true
                }
            }
        ],
        staffPermissions: "hidden",
        rolePermissions: "hidden",
        editStaffTime: false,
        payRate: "hidden",
        overtimeRate: "hidden",
        costRate: "hidden",
        chargeOutRate: "hidden",
        contacts: "hidden",
        costCentres: "hidden",
        operationalExpenses: "hidden",
        holidays: "hidden",
        invoiceSettings: "hidden",
        organisationSettings: "hidden",
        billing: "hidden"
    }
};

});

parcelRegister("3H03w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b056e5321c0aa1d$export$2e2bcd8739ae039; });
var $2b056e5321c0aa1d$export$6a00d17b5aff0af, $2b056e5321c0aa1d$var$i = "undefined" != typeof window ? window : void 0, $2b056e5321c0aa1d$var$e = "undefined" != typeof globalThis ? globalThis : $2b056e5321c0aa1d$var$i, $2b056e5321c0aa1d$var$r = Array.prototype, $2b056e5321c0aa1d$var$s = $2b056e5321c0aa1d$var$r.forEach, $2b056e5321c0aa1d$var$n = $2b056e5321c0aa1d$var$r.indexOf, $2b056e5321c0aa1d$var$o = null == $2b056e5321c0aa1d$var$e ? void 0 : $2b056e5321c0aa1d$var$e.navigator, $2b056e5321c0aa1d$var$a = null == $2b056e5321c0aa1d$var$e ? void 0 : $2b056e5321c0aa1d$var$e.document, $2b056e5321c0aa1d$var$l = null == $2b056e5321c0aa1d$var$e ? void 0 : $2b056e5321c0aa1d$var$e.location, $2b056e5321c0aa1d$var$h = null == $2b056e5321c0aa1d$var$e ? void 0 : $2b056e5321c0aa1d$var$e.fetch, $2b056e5321c0aa1d$var$u = null != $2b056e5321c0aa1d$var$e && $2b056e5321c0aa1d$var$e.XMLHttpRequest && "withCredentials" in new $2b056e5321c0aa1d$var$e.XMLHttpRequest ? $2b056e5321c0aa1d$var$e.XMLHttpRequest : void 0, $2b056e5321c0aa1d$var$d = null == $2b056e5321c0aa1d$var$e ? void 0 : $2b056e5321c0aa1d$var$e.AbortController, $2b056e5321c0aa1d$var$v = null == $2b056e5321c0aa1d$var$o ? void 0 : $2b056e5321c0aa1d$var$o.userAgent, $2b056e5321c0aa1d$var$c = null != $2b056e5321c0aa1d$var$i ? $2b056e5321c0aa1d$var$i : {}, $2b056e5321c0aa1d$var$f = {
    DEBUG: !1,
    LIB_VERSION: "1.239.0"
}, $2b056e5321c0aa1d$export$7bea938663611d9 = "$copy_autocapture", $2b056e5321c0aa1d$export$fbd163209a0ff4bf = [
    "$snapshot",
    "$pageview",
    "$pageleave",
    "$set",
    "survey dismissed",
    "survey sent",
    "survey shown",
    "$identify",
    "$groupidentify",
    "$create_alias",
    "$$client_ingestion_warning",
    "$web_experiment_applied",
    "$feature_enrollment_update",
    "$feature_flag_called"
];
!function(t) {
    t.GZipJS = "gzip-js", t.Base64 = "base64";
}($2b056e5321c0aa1d$export$6a00d17b5aff0af || ($2b056e5321c0aa1d$export$6a00d17b5aff0af = {}));
var $2b056e5321c0aa1d$export$9dd8f6ec3b5e6004 = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
function $2b056e5321c0aa1d$var$m(t, i) {
    return -1 !== t.indexOf(i);
}
var $2b056e5321c0aa1d$var$b = function(t) {
    return t.trim();
}, $2b056e5321c0aa1d$var$w = function(t) {
    return t.replace(/^\$/, "");
};
var $2b056e5321c0aa1d$var$y = Array.isArray, $2b056e5321c0aa1d$var$S = Object.prototype, $2b056e5321c0aa1d$var$$ = $2b056e5321c0aa1d$var$S.hasOwnProperty, $2b056e5321c0aa1d$var$k = $2b056e5321c0aa1d$var$S.toString, $2b056e5321c0aa1d$var$x = $2b056e5321c0aa1d$var$y || function(t) {
    return "[object Array]" === $2b056e5321c0aa1d$var$k.call(t);
}, $2b056e5321c0aa1d$var$E = (t)=>"function" == typeof t, $2b056e5321c0aa1d$var$I = (t)=>t === Object(t) && !$2b056e5321c0aa1d$var$x(t), $2b056e5321c0aa1d$var$P = (t)=>{
    if ($2b056e5321c0aa1d$var$I(t)) {
        for(var i in t)if ($2b056e5321c0aa1d$var$$.call(t, i)) return !1;
        return !0;
    }
    return !1;
}, $2b056e5321c0aa1d$var$R = (t)=>void 0 === t, $2b056e5321c0aa1d$var$T = (t)=>"[object String]" == $2b056e5321c0aa1d$var$k.call(t), $2b056e5321c0aa1d$var$M = (t)=>$2b056e5321c0aa1d$var$T(t) && 0 === t.trim().length, $2b056e5321c0aa1d$var$C = (t)=>null === t, $2b056e5321c0aa1d$var$O = (t)=>$2b056e5321c0aa1d$var$R(t) || $2b056e5321c0aa1d$var$C(t), $2b056e5321c0aa1d$var$F = (t)=>"[object Number]" == $2b056e5321c0aa1d$var$k.call(t), $2b056e5321c0aa1d$var$A = (t)=>"[object Boolean]" === $2b056e5321c0aa1d$var$k.call(t), $2b056e5321c0aa1d$var$D = (t)=>t instanceof FormData, $2b056e5321c0aa1d$var$j = (t)=>$2b056e5321c0aa1d$var$m($2b056e5321c0aa1d$export$fbd163209a0ff4bf, t), $2b056e5321c0aa1d$var$L = (t)=>{
    var e = {
        t: function(e) {
            if ($2b056e5321c0aa1d$var$i && ($2b056e5321c0aa1d$var$f.DEBUG || $2b056e5321c0aa1d$var$c.POSTHOG_DEBUG) && !$2b056e5321c0aa1d$var$R($2b056e5321c0aa1d$var$i.console) && $2b056e5321c0aa1d$var$i.console) {
                for(var r = ("__rrweb_original__" in $2b056e5321c0aa1d$var$i.console[e]) ? $2b056e5321c0aa1d$var$i.console[e].__rrweb_original__ : $2b056e5321c0aa1d$var$i.console[e], s = arguments.length, n = new Array(s > 1 ? s - 1 : 0), o = 1; o < s; o++)n[o - 1] = arguments[o];
                r(t, ...n);
            }
        },
        info: function() {
            for(var t = arguments.length, i = new Array(t), r = 0; r < t; r++)i[r] = arguments[r];
            e.t("log", ...i);
        },
        warn: function() {
            for(var t = arguments.length, i = new Array(t), r = 0; r < t; r++)i[r] = arguments[r];
            e.t("warn", ...i);
        },
        error: function() {
            for(var t = arguments.length, i = new Array(t), r = 0; r < t; r++)i[r] = arguments[r];
            e.t("error", ...i);
        },
        critical: function() {
            for(var i = arguments.length, e = new Array(i), r = 0; r < i; r++)e[r] = arguments[r];
            console.error(t, ...e);
        },
        uninitializedWarning: (t)=>{
            e.error("You must initialize PostHog before calling " + t);
        },
        createLogger: (i)=>$2b056e5321c0aa1d$var$L(t + " " + i)
    };
    return e;
}, $2b056e5321c0aa1d$var$N = $2b056e5321c0aa1d$var$L("[PostHog.js]"), $2b056e5321c0aa1d$var$z = $2b056e5321c0aa1d$var$N.createLogger, $2b056e5321c0aa1d$var$U = $2b056e5321c0aa1d$var$z("[ExternalScriptsLoader]"), $2b056e5321c0aa1d$var$q = (t, i, e)=>{
    if (t.config.disable_external_dependency_loading) return $2b056e5321c0aa1d$var$U.warn(i + " was requested but loading of external scripts is disabled."), e("Loading of external scripts is disabled");
    var r = null == $2b056e5321c0aa1d$var$a ? void 0 : $2b056e5321c0aa1d$var$a.querySelectorAll("script");
    if (r) {
        for(var s = 0; s < r.length; s++)if (r[s].src === i) return e();
    }
    var n = ()=>{
        if (!$2b056e5321c0aa1d$var$a) return e("document not found");
        var r = $2b056e5321c0aa1d$var$a.createElement("script");
        if (r.type = "text/javascript", r.crossOrigin = "anonymous", r.src = i, r.onload = (t)=>e(void 0, t), r.onerror = (t)=>e(t), t.config.prepare_external_dependency_script && (r = t.config.prepare_external_dependency_script(r)), !r) return e("prepare_external_dependency_script returned null");
        var s, n = $2b056e5321c0aa1d$var$a.querySelectorAll("body > script");
        n.length > 0 ? null == (s = n[0].parentNode) || s.insertBefore(r, n[0]) : $2b056e5321c0aa1d$var$a.body.appendChild(r);
    };
    null != $2b056e5321c0aa1d$var$a && $2b056e5321c0aa1d$var$a.body ? n() : null == $2b056e5321c0aa1d$var$a || $2b056e5321c0aa1d$var$a.addEventListener("DOMContentLoaded", n);
};
function $2b056e5321c0aa1d$var$B() {
    return $2b056e5321c0aa1d$var$B = Object.assign ? Object.assign.bind() : function(t) {
        for(var i = 1; i < arguments.length; i++){
            var e = arguments[i];
            for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
        }
        return t;
    }, $2b056e5321c0aa1d$var$B.apply(this, arguments);
}
function $2b056e5321c0aa1d$var$H(t, i) {
    if (null == t) return {};
    var e, r, s = {}, n = Object.keys(t);
    for(r = 0; r < n.length; r++)e = n[r], i.indexOf(e) >= 0 || (s[e] = t[e]);
    return s;
}
$2b056e5321c0aa1d$var$c.__PosthogExtensions__ = $2b056e5321c0aa1d$var$c.__PosthogExtensions__ || {}, $2b056e5321c0aa1d$var$c.__PosthogExtensions__.loadExternalDependency = (t, i, e)=>{
    var r = "/static/" + i + ".js?v=" + t.version;
    if ("remote-config" === i && (r = "/array/" + t.config.token + "/config.js"), "toolbar" === i) {
        var s = 3e5;
        r = r + "&t=" + Math.floor(Date.now() / s) * s;
    }
    var n = t.requestRouter.endpointFor("assets", r);
    $2b056e5321c0aa1d$var$q(t, n, e);
}, $2b056e5321c0aa1d$var$c.__PosthogExtensions__.loadSiteApp = (t, i, e)=>{
    var r = t.requestRouter.endpointFor("api", i);
    $2b056e5321c0aa1d$var$q(t, r, e);
};
var $2b056e5321c0aa1d$var$W = {};
function $2b056e5321c0aa1d$var$G(t, i, e) {
    if ($2b056e5321c0aa1d$var$x(t)) {
        if ($2b056e5321c0aa1d$var$s && t.forEach === $2b056e5321c0aa1d$var$s) t.forEach(i, e);
        else if ("length" in t && t.length === +t.length) {
            for(var r = 0, n = t.length; r < n; r++)if (r in t && i.call(e, t[r], r) === $2b056e5321c0aa1d$var$W) return;
        }
    }
}
function $2b056e5321c0aa1d$var$J(t, i, e) {
    if (!$2b056e5321c0aa1d$var$O(t)) {
        if ($2b056e5321c0aa1d$var$x(t)) return $2b056e5321c0aa1d$var$G(t, i, e);
        if ($2b056e5321c0aa1d$var$D(t)) {
            for (var r of t.entries())if (i.call(e, r[1], r[0]) === $2b056e5321c0aa1d$var$W) return;
        } else for(var s in t)if ($2b056e5321c0aa1d$var$$.call(t, s) && i.call(e, t[s], s) === $2b056e5321c0aa1d$var$W) return;
    }
}
var $2b056e5321c0aa1d$var$V = function(t) {
    for(var i = arguments.length, e = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++)e[r - 1] = arguments[r];
    return $2b056e5321c0aa1d$var$G(e, function(i) {
        for(var e in i)void 0 !== i[e] && (t[e] = i[e]);
    }), t;
}, $2b056e5321c0aa1d$var$K = function(t) {
    for(var i = arguments.length, e = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++)e[r - 1] = arguments[r];
    return $2b056e5321c0aa1d$var$G(e, function(i) {
        $2b056e5321c0aa1d$var$G(i, function(i) {
            t.push(i);
        });
    }), t;
};
function $2b056e5321c0aa1d$var$Y(t) {
    for(var i = Object.keys(t), e = i.length, r = new Array(e); e--;)r[e] = [
        i[e],
        t[i[e]]
    ];
    return r;
}
var $2b056e5321c0aa1d$var$X = function(t) {
    try {
        return t();
    } catch (t) {
        return;
    }
}, $2b056e5321c0aa1d$var$Q = function(t) {
    return function() {
        try {
            for(var i = arguments.length, e = new Array(i), r = 0; r < i; r++)e[r] = arguments[r];
            return t.apply(this, e);
        } catch (t) {
            $2b056e5321c0aa1d$var$N.critical("Implementation error. Please turn on debug mode and open a ticket on https://app.posthog.com/home#panel=support%3Asupport%3A."), $2b056e5321c0aa1d$var$N.critical(t);
        }
    };
}, $2b056e5321c0aa1d$var$Z = function(t) {
    var i = {};
    return $2b056e5321c0aa1d$var$J(t, function(t, e) {
        ($2b056e5321c0aa1d$var$T(t) && t.length > 0 || $2b056e5321c0aa1d$var$F(t)) && (i[e] = t);
    }), i;
};
function $2b056e5321c0aa1d$var$tt(t, i) {
    var e, r, s;
    return e = t, r = (t)=>$2b056e5321c0aa1d$var$T(t) && !$2b056e5321c0aa1d$var$C(i) ? t.slice(0, i) : t, s = new Set, function t(i, e) {
        var n;
        return i !== Object(i) ? r ? r(i, e) : i : s.has(i) ? void 0 : (s.add(i), $2b056e5321c0aa1d$var$x(i) ? (n = [], $2b056e5321c0aa1d$var$G(i, (i)=>{
            n.push(t(i));
        })) : (n = {}, $2b056e5321c0aa1d$var$J(i, (i, e)=>{
            s.has(i) || (n[e] = t(i, e));
        })), n);
    }(e);
}
var $2b056e5321c0aa1d$var$it = [
    "herokuapp.com",
    "vercel.app",
    "netlify.app"
];
function $2b056e5321c0aa1d$var$et(t) {
    var i = null == t ? void 0 : t.hostname;
    if (!$2b056e5321c0aa1d$var$T(i)) return !1;
    var e = i.split(".").slice(-2).join(".");
    for (var r of $2b056e5321c0aa1d$var$it)if (e === r) return !1;
    return !0;
}
function $2b056e5321c0aa1d$var$rt(t, i) {
    for(var e = 0; e < t.length; e++)if (i(t[e])) return t[e];
}
function $2b056e5321c0aa1d$var$st(t, i, e, r) {
    var { capture: s = !1, passive: n = !0 } = null != r ? r : {};
    null == t || t.addEventListener(i, e, {
        capture: s,
        passive: n
    });
}
var $2b056e5321c0aa1d$var$nt = "$people_distinct_id", $2b056e5321c0aa1d$var$ot = "__alias", $2b056e5321c0aa1d$var$at = "__timers", $2b056e5321c0aa1d$var$lt = "$autocapture_disabled_server_side", $2b056e5321c0aa1d$var$ht = "$heatmaps_enabled_server_side", $2b056e5321c0aa1d$var$ut = "$exception_capture_enabled_server_side", $2b056e5321c0aa1d$var$dt = "$web_vitals_enabled_server_side", $2b056e5321c0aa1d$var$vt = "$dead_clicks_enabled_server_side", $2b056e5321c0aa1d$var$ct = "$web_vitals_allowed_metrics", $2b056e5321c0aa1d$var$ft = "$session_recording_enabled_server_side", $2b056e5321c0aa1d$var$pt = "$console_log_recording_enabled_server_side", $2b056e5321c0aa1d$var$gt = "$session_recording_network_payload_capture", $2b056e5321c0aa1d$var$_t = "$session_recording_masking", $2b056e5321c0aa1d$var$mt = "$session_recording_canvas_recording", $2b056e5321c0aa1d$var$bt = "$replay_sample_rate", $2b056e5321c0aa1d$var$wt = "$replay_minimum_duration", $2b056e5321c0aa1d$var$yt = "$replay_script_config", $2b056e5321c0aa1d$var$St = "$sesid", $2b056e5321c0aa1d$var$$t = "$session_is_sampled", $2b056e5321c0aa1d$var$kt = "$session_recording_url_trigger_activated_session", $2b056e5321c0aa1d$var$xt = "$session_recording_event_trigger_activated_session", $2b056e5321c0aa1d$var$Et = "$enabled_feature_flags", $2b056e5321c0aa1d$var$It = "$early_access_features", $2b056e5321c0aa1d$var$Pt = "$feature_flag_details", $2b056e5321c0aa1d$var$Rt = "$stored_person_properties", $2b056e5321c0aa1d$var$Tt = "$stored_group_properties", $2b056e5321c0aa1d$var$Mt = "$surveys", $2b056e5321c0aa1d$var$Ct = "$surveys_activated", $2b056e5321c0aa1d$var$Ot = "$flag_call_reported", $2b056e5321c0aa1d$var$Ft = "$user_state", $2b056e5321c0aa1d$var$At = "$client_session_props", $2b056e5321c0aa1d$var$Dt = "$capture_rate_limit", $2b056e5321c0aa1d$var$jt = "$initial_campaign_params", $2b056e5321c0aa1d$var$Lt = "$initial_referrer_info", $2b056e5321c0aa1d$var$Nt = "$initial_person_info", $2b056e5321c0aa1d$var$zt = "$epp", $2b056e5321c0aa1d$var$Ut = "__POSTHOG_TOOLBAR__", $2b056e5321c0aa1d$var$qt = "$posthog_cookieless", $2b056e5321c0aa1d$var$Bt = [
    $2b056e5321c0aa1d$var$nt,
    $2b056e5321c0aa1d$var$ot,
    "__cmpns",
    $2b056e5321c0aa1d$var$at,
    $2b056e5321c0aa1d$var$ft,
    $2b056e5321c0aa1d$var$ht,
    $2b056e5321c0aa1d$var$St,
    $2b056e5321c0aa1d$var$Et,
    $2b056e5321c0aa1d$var$Ft,
    $2b056e5321c0aa1d$var$It,
    $2b056e5321c0aa1d$var$Pt,
    $2b056e5321c0aa1d$var$Tt,
    $2b056e5321c0aa1d$var$Rt,
    $2b056e5321c0aa1d$var$Mt,
    $2b056e5321c0aa1d$var$Ot,
    $2b056e5321c0aa1d$var$At,
    $2b056e5321c0aa1d$var$Dt,
    $2b056e5321c0aa1d$var$jt,
    $2b056e5321c0aa1d$var$Lt,
    $2b056e5321c0aa1d$var$zt
];
function $2b056e5321c0aa1d$var$Ht(t) {
    return t instanceof Element && (t.id === $2b056e5321c0aa1d$var$Ut || !(null == t.closest || !t.closest(".toolbar-global-fade-container")));
}
function $2b056e5321c0aa1d$var$Wt(t) {
    return !!t && 1 === t.nodeType;
}
function $2b056e5321c0aa1d$var$Gt(t, i) {
    return !!t && !!t.tagName && t.tagName.toLowerCase() === i.toLowerCase();
}
function $2b056e5321c0aa1d$var$Jt(t) {
    return !!t && 3 === t.nodeType;
}
function $2b056e5321c0aa1d$var$Vt(t) {
    return !!t && 11 === t.nodeType;
}
function $2b056e5321c0aa1d$var$Kt(t) {
    return t ? $2b056e5321c0aa1d$var$b(t).split(/\s+/) : [];
}
function $2b056e5321c0aa1d$var$Yt(t) {
    var e = null == $2b056e5321c0aa1d$var$i ? void 0 : $2b056e5321c0aa1d$var$i.location.href;
    return !!(e && t && t.some((t)=>e.match(t)));
}
function $2b056e5321c0aa1d$var$Xt(t) {
    var i = "";
    switch(typeof t.className){
        case "string":
            i = t.className;
            break;
        case "object":
            i = (t.className && "baseVal" in t.className ? t.className.baseVal : null) || t.getAttribute("class") || "";
            break;
        default:
            i = "";
    }
    return $2b056e5321c0aa1d$var$Kt(i);
}
function $2b056e5321c0aa1d$var$Qt(t) {
    return $2b056e5321c0aa1d$var$O(t) ? null : $2b056e5321c0aa1d$var$b(t).split(/(\s+)/).filter((t)=>$2b056e5321c0aa1d$var$vi(t)).join("").replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255);
}
function $2b056e5321c0aa1d$var$Zt(t) {
    var i = "";
    return $2b056e5321c0aa1d$var$si(t) && !$2b056e5321c0aa1d$var$ni(t) && t.childNodes && t.childNodes.length && $2b056e5321c0aa1d$var$J(t.childNodes, function(t) {
        var e;
        $2b056e5321c0aa1d$var$Jt(t) && t.textContent && (i += null !== (e = $2b056e5321c0aa1d$var$Qt(t.textContent)) && void 0 !== e ? e : "");
    }), $2b056e5321c0aa1d$var$b(i);
}
function $2b056e5321c0aa1d$var$ti(t) {
    var i;
    return $2b056e5321c0aa1d$var$R(t.target) ? t.srcElement || null : null != (i = t.target) && i.shadowRoot ? t.composedPath()[0] || null : t.target || null;
}
var $2b056e5321c0aa1d$var$ii = [
    "a",
    "button",
    "form",
    "input",
    "select",
    "textarea",
    "label"
];
function $2b056e5321c0aa1d$var$ei(t) {
    var i = t.parentNode;
    return !(!i || !$2b056e5321c0aa1d$var$Wt(i)) && i;
}
function $2b056e5321c0aa1d$var$ri(t, e, r, s, n) {
    var o, a, l;
    if (void 0 === r && (r = void 0), !$2b056e5321c0aa1d$var$i || !t || $2b056e5321c0aa1d$var$Gt(t, "html") || !$2b056e5321c0aa1d$var$Wt(t)) return !1;
    if (null != (o = r) && o.url_allowlist && !$2b056e5321c0aa1d$var$Yt(r.url_allowlist)) return !1;
    if (null != (a = r) && a.url_ignorelist && $2b056e5321c0aa1d$var$Yt(r.url_ignorelist)) return !1;
    if (null != (l = r) && l.dom_event_allowlist) {
        var h = r.dom_event_allowlist;
        if (h && !h.some((t)=>e.type === t)) return !1;
    }
    for(var u = !1, d = [
        t
    ], v = !0, c = t; c.parentNode && !$2b056e5321c0aa1d$var$Gt(c, "body");)if ($2b056e5321c0aa1d$var$Vt(c.parentNode)) d.push(c.parentNode.host), c = c.parentNode.host;
    else {
        if (!(v = $2b056e5321c0aa1d$var$ei(c))) break;
        if (s || $2b056e5321c0aa1d$var$ii.indexOf(v.tagName.toLowerCase()) > -1) u = !0;
        else {
            var f = $2b056e5321c0aa1d$var$i.getComputedStyle(v);
            f && "pointer" === f.getPropertyValue("cursor") && (u = !0);
        }
        d.push(v), c = v;
    }
    if (!function(t, i) {
        var e = null == i ? void 0 : i.element_allowlist;
        if ($2b056e5321c0aa1d$var$R(e)) return !0;
        var r = function(t) {
            if (e.some((i)=>t.tagName.toLowerCase() === i)) return {
                v: !0
            };
        };
        for (var s of t){
            var n = r(s);
            if ("object" == typeof n) return n.v;
        }
        return !1;
    }(d, r)) return !1;
    if (!function(t, i) {
        var e = null == i ? void 0 : i.css_selector_allowlist;
        if ($2b056e5321c0aa1d$var$R(e)) return !0;
        var r = function(t) {
            if (e.some((i)=>t.matches(i))) return {
                v: !0
            };
        };
        for (var s of t){
            var n = r(s);
            if ("object" == typeof n) return n.v;
        }
        return !1;
    }(d, r)) return !1;
    var p = $2b056e5321c0aa1d$var$i.getComputedStyle(t);
    if (p && "pointer" === p.getPropertyValue("cursor") && "click" === e.type) return !0;
    var g = t.tagName.toLowerCase();
    switch(g){
        case "html":
            return !1;
        case "form":
            return (n || [
                "submit"
            ]).indexOf(e.type) >= 0;
        case "input":
        case "select":
        case "textarea":
            return (n || [
                "change",
                "click"
            ]).indexOf(e.type) >= 0;
        default:
            return u ? (n || [
                "click"
            ]).indexOf(e.type) >= 0 : (n || [
                "click"
            ]).indexOf(e.type) >= 0 && ($2b056e5321c0aa1d$var$ii.indexOf(g) > -1 || "true" === t.getAttribute("contenteditable"));
    }
}
function $2b056e5321c0aa1d$var$si(t) {
    for(var i = t; i.parentNode && !$2b056e5321c0aa1d$var$Gt(i, "body"); i = i.parentNode){
        var e = $2b056e5321c0aa1d$var$Xt(i);
        if ($2b056e5321c0aa1d$var$m(e, "ph-sensitive") || $2b056e5321c0aa1d$var$m(e, "ph-no-capture")) return !1;
    }
    if ($2b056e5321c0aa1d$var$m($2b056e5321c0aa1d$var$Xt(t), "ph-include")) return !0;
    var r = t.type || "";
    if ($2b056e5321c0aa1d$var$T(r)) switch(r.toLowerCase()){
        case "hidden":
        case "password":
            return !1;
    }
    var s = t.name || t.id || "";
    if ($2b056e5321c0aa1d$var$T(s)) {
        if (/^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i.test(s.replace(/[^a-zA-Z0-9]/g, ""))) return !1;
    }
    return !0;
}
function $2b056e5321c0aa1d$var$ni(t) {
    return !!($2b056e5321c0aa1d$var$Gt(t, "input") && ![
        "button",
        "checkbox",
        "submit",
        "reset"
    ].includes(t.type) || $2b056e5321c0aa1d$var$Gt(t, "select") || $2b056e5321c0aa1d$var$Gt(t, "textarea") || "true" === t.getAttribute("contenteditable"));
}
var $2b056e5321c0aa1d$var$oi = "(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11})", $2b056e5321c0aa1d$var$ai = new RegExp("^(?:" + $2b056e5321c0aa1d$var$oi + ")$"), $2b056e5321c0aa1d$var$li = new RegExp($2b056e5321c0aa1d$var$oi), $2b056e5321c0aa1d$var$hi = "\\d{3}-?\\d{2}-?\\d{4}", $2b056e5321c0aa1d$var$ui = new RegExp("^(" + $2b056e5321c0aa1d$var$hi + ")$"), $2b056e5321c0aa1d$var$di = new RegExp("(" + $2b056e5321c0aa1d$var$hi + ")");
function $2b056e5321c0aa1d$var$vi(t, i) {
    if (void 0 === i && (i = !0), $2b056e5321c0aa1d$var$O(t)) return !1;
    if ($2b056e5321c0aa1d$var$T(t)) {
        if (t = $2b056e5321c0aa1d$var$b(t), (i ? $2b056e5321c0aa1d$var$ai : $2b056e5321c0aa1d$var$li).test((t || "").replace(/[- ]/g, ""))) return !1;
        if ((i ? $2b056e5321c0aa1d$var$ui : $2b056e5321c0aa1d$var$di).test(t)) return !1;
    }
    return !0;
}
function $2b056e5321c0aa1d$var$ci(t) {
    var i = $2b056e5321c0aa1d$var$Zt(t);
    return $2b056e5321c0aa1d$var$vi(i = (i + " " + $2b056e5321c0aa1d$var$fi(t)).trim()) ? i : "";
}
function $2b056e5321c0aa1d$var$fi(t) {
    var i = "";
    return t && t.childNodes && t.childNodes.length && $2b056e5321c0aa1d$var$J(t.childNodes, function(t) {
        var e;
        if (t && "span" === (null == (e = t.tagName) ? void 0 : e.toLowerCase())) try {
            var r = $2b056e5321c0aa1d$var$Zt(t);
            i = (i + " " + r).trim(), t.childNodes && t.childNodes.length && (i = (i + " " + $2b056e5321c0aa1d$var$fi(t)).trim());
        } catch (t) {
            $2b056e5321c0aa1d$var$N.error("[AutoCapture]", t);
        }
    }), i;
}
function $2b056e5321c0aa1d$var$pi(t) {
    return function(t) {
        var i = t.map((t)=>{
            var i, e, r = "";
            if (t.tag_name && (r += t.tag_name), t.attr_class) for (var s of (t.attr_class.sort(), t.attr_class))r += "." + s.replace(/"/g, "");
            var n = $2b056e5321c0aa1d$var$B({}, t.text ? {
                text: t.text
            } : {}, {
                "nth-child": null !== (i = t.nth_child) && void 0 !== i ? i : 0,
                "nth-of-type": null !== (e = t.nth_of_type) && void 0 !== e ? e : 0
            }, t.href ? {
                href: t.href
            } : {}, t.attr_id ? {
                attr_id: t.attr_id
            } : {}, t.attributes), o = {};
            return $2b056e5321c0aa1d$var$Y(n).sort((t, i)=>{
                var [e] = t, [r] = i;
                return e.localeCompare(r);
            }).forEach((t)=>{
                var [i, e] = t;
                return o[$2b056e5321c0aa1d$var$gi(i.toString())] = $2b056e5321c0aa1d$var$gi(e.toString());
            }), r += ":", r += $2b056e5321c0aa1d$var$Y(n).map((t)=>{
                var [i, e] = t;
                return i + '="' + e + '"';
            }).join("");
        });
        return i.join(";");
    }(function(t) {
        return t.map((t)=>{
            var i, e, r = {
                text: null == (i = t.$el_text) ? void 0 : i.slice(0, 400),
                tag_name: t.tag_name,
                href: null == (e = t.attr__href) ? void 0 : e.slice(0, 2048),
                attr_class: $2b056e5321c0aa1d$var$_i(t),
                attr_id: t.attr__id,
                nth_child: t.nth_child,
                nth_of_type: t.nth_of_type,
                attributes: {}
            };
            return $2b056e5321c0aa1d$var$Y(t).filter((t)=>{
                var [i] = t;
                return 0 === i.indexOf("attr__");
            }).forEach((t)=>{
                var [i, e] = t;
                return r.attributes[i] = e;
            }), r;
        });
    }(t));
}
function $2b056e5321c0aa1d$var$gi(t) {
    return t.replace(/"|\\"/g, '\\"');
}
function $2b056e5321c0aa1d$var$_i(t) {
    var i = t.attr__class;
    return i ? $2b056e5321c0aa1d$var$x(i) ? i : $2b056e5321c0aa1d$var$Kt(i) : void 0;
}
class $2b056e5321c0aa1d$var$mi {
    constructor(){
        this.clicks = [];
    }
    isRageClick(t, i, e) {
        var r = this.clicks[this.clicks.length - 1];
        if (r && Math.abs(t - r.x) + Math.abs(i - r.y) < 30 && e - r.timestamp < 1e3) {
            if (this.clicks.push({
                x: t,
                y: i,
                timestamp: e
            }), 3 === this.clicks.length) return !0;
        } else this.clicks = [
            {
                x: t,
                y: i,
                timestamp: e
            }
        ];
        return !1;
    }
}
var $2b056e5321c0aa1d$var$bi = [
    "localhost",
    "127.0.0.1"
], $2b056e5321c0aa1d$var$wi = (t)=>{
    var i = null == $2b056e5321c0aa1d$var$a ? void 0 : $2b056e5321c0aa1d$var$a.createElement("a");
    return $2b056e5321c0aa1d$var$R(i) ? null : (i.href = t, i);
}, $2b056e5321c0aa1d$var$yi = function(t, i) {
    var e, r;
    void 0 === i && (i = "&");
    var s = [];
    return $2b056e5321c0aa1d$var$J(t, function(t, i) {
        $2b056e5321c0aa1d$var$R(t) || $2b056e5321c0aa1d$var$R(i) || "undefined" === i || (e = encodeURIComponent(((t)=>t instanceof File)(t) ? t.name : t.toString()), r = encodeURIComponent(i), s[s.length] = r + "=" + e);
    }), s.join(i);
}, $2b056e5321c0aa1d$var$Si = function(t, i) {
    for(var e, r = ((t.split("#")[0] || "").split(/\?(.*)/)[1] || "").replace(/^\?+/g, "").split("&"), s = 0; s < r.length; s++){
        var n = r[s].split("=");
        if (n[0] === i) {
            e = n;
            break;
        }
    }
    if (!$2b056e5321c0aa1d$var$x(e) || e.length < 2) return "";
    var o = e[1];
    try {
        o = decodeURIComponent(o);
    } catch (t) {
        $2b056e5321c0aa1d$var$N.error("Skipping decoding for malformed query param: " + o);
    }
    return o.replace(/\+/g, " ");
}, $2b056e5321c0aa1d$var$$i = function(t, i, e) {
    if (!t || !i || !i.length) return t;
    for(var r = t.split("#"), s = r[0] || "", n = r[1], o = s.split("?"), a = o[1], l = o[0], h = (a || "").split("&"), u = [], d = 0; d < h.length; d++){
        var v = h[d].split("=");
        $2b056e5321c0aa1d$var$x(v) && (i.includes(v[0]) ? u.push(v[0] + "=" + e) : u.push(h[d]));
    }
    var c = l;
    return null != a && (c += "?" + u.join("&")), null != n && (c += "#" + n), c;
}, $2b056e5321c0aa1d$var$ki = function(t, i) {
    var e = t.match(new RegExp(i + "=([^&]*)"));
    return e ? e[1] : null;
}, $2b056e5321c0aa1d$var$xi = $2b056e5321c0aa1d$var$z("[AutoCapture]");
function $2b056e5321c0aa1d$var$Ei(t, i) {
    return i.length > t ? i.slice(0, t) + "..." : i;
}
function $2b056e5321c0aa1d$var$Ii(t) {
    if (t.previousElementSibling) return t.previousElementSibling;
    var i = t;
    do i = i.previousSibling;
    while (i && !$2b056e5321c0aa1d$var$Wt(i));
    return i;
}
function $2b056e5321c0aa1d$var$Pi(t, i, e, r) {
    var s = t.tagName.toLowerCase(), n = {
        tag_name: s
    };
    $2b056e5321c0aa1d$var$ii.indexOf(s) > -1 && !e && ("a" === s.toLowerCase() || "button" === s.toLowerCase() ? n.$el_text = $2b056e5321c0aa1d$var$Ei(1024, $2b056e5321c0aa1d$var$ci(t)) : n.$el_text = $2b056e5321c0aa1d$var$Ei(1024, $2b056e5321c0aa1d$var$Zt(t)));
    var o = $2b056e5321c0aa1d$var$Xt(t);
    o.length > 0 && (n.classes = o.filter(function(t) {
        return "" !== t;
    })), $2b056e5321c0aa1d$var$J(t.attributes, function(e) {
        var s;
        if ((!$2b056e5321c0aa1d$var$ni(t) || -1 !== [
            "name",
            "id",
            "class",
            "aria-label"
        ].indexOf(e.name)) && (null == r || !r.includes(e.name)) && !i && $2b056e5321c0aa1d$var$vi(e.value) && (s = e.name, !$2b056e5321c0aa1d$var$T(s) || "_ngcontent" !== s.substring(0, 10) && "_nghost" !== s.substring(0, 7))) {
            var o = e.value;
            "class" === e.name && (o = $2b056e5321c0aa1d$var$Kt(o).join(" ")), n["attr__" + e.name] = $2b056e5321c0aa1d$var$Ei(1024, o);
        }
    });
    for(var a = 1, l = 1, h = t; h = $2b056e5321c0aa1d$var$Ii(h);)a++, h.tagName === t.tagName && l++;
    return n.nth_child = a, n.nth_of_type = l, n;
}
function $2b056e5321c0aa1d$var$Ri(t, e) {
    for(var r, s, { e: n, maskAllElementAttributes: o, maskAllText: a, elementAttributeIgnoreList: l, elementsChainAsString: h } = e, u = [
        t
    ], d = t; d.parentNode && !$2b056e5321c0aa1d$var$Gt(d, "body");)$2b056e5321c0aa1d$var$Vt(d.parentNode) ? (u.push(d.parentNode.host), d = d.parentNode.host) : (u.push(d.parentNode), d = d.parentNode);
    var v, c = [], f = {}, p = !1, g = !1;
    if ($2b056e5321c0aa1d$var$J(u, (t)=>{
        var i = $2b056e5321c0aa1d$var$si(t);
        "a" === t.tagName.toLowerCase() && (p = t.getAttribute("href"), p = i && p && $2b056e5321c0aa1d$var$vi(p) && p), $2b056e5321c0aa1d$var$m($2b056e5321c0aa1d$var$Xt(t), "ph-no-capture") && (g = !0), c.push($2b056e5321c0aa1d$var$Pi(t, o, a, l));
        var e = function(t) {
            if (!$2b056e5321c0aa1d$var$si(t)) return {};
            var i = {};
            return $2b056e5321c0aa1d$var$J(t.attributes, function(t) {
                if (t.name && 0 === t.name.indexOf("data-ph-capture-attribute")) {
                    var e = t.name.replace("data-ph-capture-attribute-", ""), r = t.value;
                    e && r && $2b056e5321c0aa1d$var$vi(r) && (i[e] = r);
                }
            }), i;
        }(t);
        $2b056e5321c0aa1d$var$V(f, e);
    }), g) return {
        props: {},
        explicitNoCapture: g
    };
    if (a || ("a" === t.tagName.toLowerCase() || "button" === t.tagName.toLowerCase() ? c[0].$el_text = $2b056e5321c0aa1d$var$ci(t) : c[0].$el_text = $2b056e5321c0aa1d$var$Zt(t)), p) {
        var _, b;
        c[0].attr__href = p;
        var w = null == (_ = $2b056e5321c0aa1d$var$wi(p)) ? void 0 : _.host, y = null == $2b056e5321c0aa1d$var$i || null == (b = $2b056e5321c0aa1d$var$i.location) ? void 0 : b.host;
        w && y && w !== y && (v = p);
    }
    return {
        props: $2b056e5321c0aa1d$var$V({
            $event_type: n.type,
            $ce_version: 1
        }, h ? {} : {
            $elements: c
        }, {
            $elements_chain: $2b056e5321c0aa1d$var$pi(c)
        }, null != (r = c[0]) && r.$el_text ? {
            $el_text: null == (s = c[0]) ? void 0 : s.$el_text
        } : {}, v && "click" === n.type ? {
            $external_click_url: v
        } : {}, f)
    };
}
class $2b056e5321c0aa1d$var$Ti {
    constructor(t){
        this.i = !1, this.o = null, this.rageclicks = new $2b056e5321c0aa1d$var$mi, this.h = !1, this.instance = t, this.m = null;
    }
    get S() {
        var t, i, e = $2b056e5321c0aa1d$var$I(this.instance.config.autocapture) ? this.instance.config.autocapture : {};
        return e.url_allowlist = null == (t = e.url_allowlist) ? void 0 : t.map((t)=>new RegExp(t)), e.url_ignorelist = null == (i = e.url_ignorelist) ? void 0 : i.map((t)=>new RegExp(t)), e;
    }
    $() {
        if (this.isBrowserSupported()) {
            if ($2b056e5321c0aa1d$var$i && $2b056e5321c0aa1d$var$a) {
                var t = (t)=>{
                    t = t || (null == $2b056e5321c0aa1d$var$i ? void 0 : $2b056e5321c0aa1d$var$i.event);
                    try {
                        this.k(t);
                    } catch (t) {
                        $2b056e5321c0aa1d$var$xi.error("Failed to capture event", t);
                    }
                };
                if ($2b056e5321c0aa1d$var$st($2b056e5321c0aa1d$var$a, "submit", t, {
                    capture: !0
                }), $2b056e5321c0aa1d$var$st($2b056e5321c0aa1d$var$a, "change", t, {
                    capture: !0
                }), $2b056e5321c0aa1d$var$st($2b056e5321c0aa1d$var$a, "click", t, {
                    capture: !0
                }), this.S.capture_copied_text) {
                    var e = (t)=>{
                        t = t || (null == $2b056e5321c0aa1d$var$i ? void 0 : $2b056e5321c0aa1d$var$i.event), this.k(t, $2b056e5321c0aa1d$export$7bea938663611d9);
                    };
                    $2b056e5321c0aa1d$var$st($2b056e5321c0aa1d$var$a, "copy", e, {
                        capture: !0
                    }), $2b056e5321c0aa1d$var$st($2b056e5321c0aa1d$var$a, "cut", e, {
                        capture: !0
                    });
                }
            }
        } else $2b056e5321c0aa1d$var$xi.info("Disabling Automatic Event Collection because this browser is not supported");
    }
    startIfEnabled() {
        this.isEnabled && !this.i && (this.$(), this.i = !0);
    }
    onRemoteConfig(t) {
        t.elementsChainAsString && (this.h = t.elementsChainAsString), this.instance.persistence && this.instance.persistence.register({
            [$2b056e5321c0aa1d$var$lt]: !!t.autocapture_opt_out
        }), this.o = !!t.autocapture_opt_out, this.startIfEnabled();
    }
    setElementSelectors(t) {
        this.m = t;
    }
    getElementSelectors(t) {
        var i, e = [];
        return null == (i = this.m) || i.forEach((i)=>{
            var r = null == $2b056e5321c0aa1d$var$a ? void 0 : $2b056e5321c0aa1d$var$a.querySelectorAll(i);
            null == r || r.forEach((r)=>{
                t === r && e.push(i);
            });
        }), e;
    }
    get isEnabled() {
        var t, i, e = null == (t = this.instance.persistence) ? void 0 : t.props[$2b056e5321c0aa1d$var$lt], r = this.o;
        if ($2b056e5321c0aa1d$var$C(r) && !$2b056e5321c0aa1d$var$A(e) && !this.instance.config.advanced_disable_decide) return !1;
        var s = null !== (i = this.o) && void 0 !== i ? i : !!e;
        return !!this.instance.config.autocapture && !s;
    }
    k(t, e) {
        if (void 0 === e && (e = "$autocapture"), this.isEnabled) {
            var r, s = $2b056e5321c0aa1d$var$ti(t);
            if ($2b056e5321c0aa1d$var$Jt(s) && (s = s.parentNode || null), "$autocapture" === e && "click" === t.type && t instanceof MouseEvent) this.instance.config.rageclick && null != (r = this.rageclicks) && r.isRageClick(t.clientX, t.clientY, (new Date).getTime()) && this.k(t, "$rageclick");
            var n = e === $2b056e5321c0aa1d$export$7bea938663611d9;
            if (s && $2b056e5321c0aa1d$var$ri(s, t, this.S, n, n ? [
                "copy",
                "cut"
            ] : void 0)) {
                var { props: o, explicitNoCapture: a } = $2b056e5321c0aa1d$var$Ri(s, {
                    e: t,
                    maskAllElementAttributes: this.instance.config.mask_all_element_attributes,
                    maskAllText: this.instance.config.mask_all_text,
                    elementAttributeIgnoreList: this.S.element_attribute_ignorelist,
                    elementsChainAsString: this.h
                });
                if (a) return !1;
                var l = this.getElementSelectors(s);
                if (l && l.length > 0 && (o.$element_selectors = l), e === $2b056e5321c0aa1d$export$7bea938663611d9) {
                    var h, u = $2b056e5321c0aa1d$var$Qt(null == $2b056e5321c0aa1d$var$i || null == (h = $2b056e5321c0aa1d$var$i.getSelection()) ? void 0 : h.toString()), d = t.type || "clipboard";
                    if (!u) return !1;
                    o.$selected_content = u, o.$copy_type = d;
                }
                return this.instance.capture(e, o), !0;
            }
        }
    }
    isBrowserSupported() {
        return $2b056e5321c0aa1d$var$E(null == $2b056e5321c0aa1d$var$a ? void 0 : $2b056e5321c0aa1d$var$a.querySelectorAll);
    }
}
Math.trunc || (Math.trunc = function(t) {
    return t < 0 ? Math.ceil(t) : Math.floor(t);
}), Number.isInteger || (Number.isInteger = function(t) {
    return $2b056e5321c0aa1d$var$F(t) && isFinite(t) && Math.floor(t) === t;
});
var $2b056e5321c0aa1d$var$Mi = "0123456789abcdef";
class $2b056e5321c0aa1d$var$Ci {
    constructor(t){
        if (this.bytes = t, 16 !== t.length) throw new TypeError("not 128-bit length");
    }
    static fromFieldsV7(t, i, e, r) {
        if (!Number.isInteger(t) || !Number.isInteger(i) || !Number.isInteger(e) || !Number.isInteger(r) || t < 0 || i < 0 || e < 0 || r < 0 || t > 0xffffffffffff || i > 4095 || e > 1073741823 || r > 4294967295) throw new RangeError("invalid field value");
        var s = new Uint8Array(16);
        return s[0] = t / Math.pow(2, 40), s[1] = t / Math.pow(2, 32), s[2] = t / Math.pow(2, 24), s[3] = t / Math.pow(2, 16), s[4] = t / Math.pow(2, 8), s[5] = t, s[6] = 112 | i >>> 8, s[7] = i, s[8] = 128 | e >>> 24, s[9] = e >>> 16, s[10] = e >>> 8, s[11] = e, s[12] = r >>> 24, s[13] = r >>> 16, s[14] = r >>> 8, s[15] = r, new $2b056e5321c0aa1d$var$Ci(s);
    }
    toString() {
        for(var t = "", i = 0; i < this.bytes.length; i++)t = t + $2b056e5321c0aa1d$var$Mi.charAt(this.bytes[i] >>> 4) + $2b056e5321c0aa1d$var$Mi.charAt(15 & this.bytes[i]), 3 !== i && 5 !== i && 7 !== i && 9 !== i || (t += "-");
        if (36 !== t.length) throw new Error("Invalid UUIDv7 was generated");
        return t;
    }
    clone() {
        return new $2b056e5321c0aa1d$var$Ci(this.bytes.slice(0));
    }
    equals(t) {
        return 0 === this.compareTo(t);
    }
    compareTo(t) {
        for(var i = 0; i < 16; i++){
            var e = this.bytes[i] - t.bytes[i];
            if (0 !== e) return Math.sign(e);
        }
        return 0;
    }
}
class $2b056e5321c0aa1d$var$Oi {
    constructor(){
        this.I = 0, this.P = 0, this.R = new $2b056e5321c0aa1d$var$Di;
    }
    generate() {
        var t = this.generateOrAbort();
        if ($2b056e5321c0aa1d$var$R(t)) {
            this.I = 0;
            var i = this.generateOrAbort();
            if ($2b056e5321c0aa1d$var$R(i)) throw new Error("Could not generate UUID after timestamp reset");
            return i;
        }
        return t;
    }
    generateOrAbort() {
        var t = Date.now();
        if (t > this.I) this.I = t, this.T();
        else {
            if (!(t + 1e4 > this.I)) return;
            this.P++, this.P > 4398046511103 && (this.I++, this.T());
        }
        return $2b056e5321c0aa1d$var$Ci.fromFieldsV7(this.I, Math.trunc(this.P / Math.pow(2, 30)), this.P & Math.pow(2, 30) - 1, this.R.nextUint32());
    }
    T() {
        this.P = 1024 * this.R.nextUint32() + (1023 & this.R.nextUint32());
    }
}
var $2b056e5321c0aa1d$var$Fi, $2b056e5321c0aa1d$var$Ai = (t)=>{
    if ("undefined" != typeof UUIDV7_DENY_WEAK_RNG && UUIDV7_DENY_WEAK_RNG) throw new Error("no cryptographically strong RNG available");
    for(var i = 0; i < t.length; i++)t[i] = 65536 * Math.trunc(65536 * Math.random()) + Math.trunc(65536 * Math.random());
    return t;
};
$2b056e5321c0aa1d$var$i && !$2b056e5321c0aa1d$var$R($2b056e5321c0aa1d$var$i.crypto) && crypto.getRandomValues && ($2b056e5321c0aa1d$var$Ai = (t)=>crypto.getRandomValues(t));
class $2b056e5321c0aa1d$var$Di {
    constructor(){
        this.M = new Uint32Array(8), this.C = 1 / 0;
    }
    nextUint32() {
        return this.C >= this.M.length && ($2b056e5321c0aa1d$var$Ai(this.M), this.C = 0), this.M[this.C++];
    }
}
var $2b056e5321c0aa1d$var$ji = ()=>$2b056e5321c0aa1d$var$Li().toString(), $2b056e5321c0aa1d$var$Li = ()=>($2b056e5321c0aa1d$var$Fi || ($2b056e5321c0aa1d$var$Fi = new $2b056e5321c0aa1d$var$Oi)).generate(), $2b056e5321c0aa1d$var$Ni = "Thu, 01 Jan 1970 00:00:00 GMT", $2b056e5321c0aa1d$var$zi = "";
var $2b056e5321c0aa1d$var$Ui = /[a-z0-9][a-z0-9-]+\.[a-z]{2,}$/i;
function $2b056e5321c0aa1d$var$qi(t, i) {
    if (i) {
        var e = function(t, i) {
            if (void 0 === i && (i = $2b056e5321c0aa1d$var$a), $2b056e5321c0aa1d$var$zi) return $2b056e5321c0aa1d$var$zi;
            if (!i) return "";
            if ([
                "localhost",
                "127.0.0.1"
            ].includes(t)) return "";
            for(var e = t.split("."), r = Math.min(e.length, 8), s = "dmn_chk_" + $2b056e5321c0aa1d$var$ji(), n = new RegExp("(^|;)\\s*" + s + "=1"); !$2b056e5321c0aa1d$var$zi && r--;){
                var o = e.slice(r).join("."), l = s + "=1;domain=." + o;
                i.cookie = l, n.test(i.cookie) && (i.cookie = l + ";expires=" + $2b056e5321c0aa1d$var$Ni, $2b056e5321c0aa1d$var$zi = o);
            }
            return $2b056e5321c0aa1d$var$zi;
        }(t);
        if (!e) {
            var r = ((t)=>{
                var i = t.match($2b056e5321c0aa1d$var$Ui);
                return i ? i[0] : "";
            })(t);
            r !== e && $2b056e5321c0aa1d$var$N.info("Warning: cookie subdomain discovery mismatch", r, e), e = r;
        }
        return e ? "; domain=." + e : "";
    }
    return "";
}
var $2b056e5321c0aa1d$var$Bi, $2b056e5321c0aa1d$var$Hi = {
    O: ()=>!!$2b056e5321c0aa1d$var$a,
    F: function(t) {
        $2b056e5321c0aa1d$var$N.error("cookieStore error: " + t);
    },
    A: function(t) {
        if ($2b056e5321c0aa1d$var$a) {
            try {
                for(var i = t + "=", e = $2b056e5321c0aa1d$var$a.cookie.split(";").filter((t)=>t.length), r = 0; r < e.length; r++){
                    for(var s = e[r]; " " == s.charAt(0);)s = s.substring(1, s.length);
                    if (0 === s.indexOf(i)) return decodeURIComponent(s.substring(i.length, s.length));
                }
            } catch (t) {}
            return null;
        }
    },
    D: function(t) {
        var i;
        try {
            i = JSON.parse($2b056e5321c0aa1d$var$Hi.A(t)) || {};
        } catch (t) {}
        return i;
    },
    j: function(t, i, e, r, s) {
        if ($2b056e5321c0aa1d$var$a) try {
            var n = "", o = "", l = $2b056e5321c0aa1d$var$qi($2b056e5321c0aa1d$var$a.location.hostname, r);
            if (e) {
                var h = new Date;
                h.setTime(h.getTime() + 24 * e * 3600000), n = "; expires=" + h.toUTCString();
            }
            s && (o = "; secure");
            var u = t + "=" + encodeURIComponent(JSON.stringify(i)) + n + "; SameSite=Lax; path=/" + l + o;
            return u.length > 3686.4 && $2b056e5321c0aa1d$var$N.warn("cookieStore warning: large cookie, len=" + u.length), $2b056e5321c0aa1d$var$a.cookie = u, u;
        } catch (t) {
            return;
        }
    },
    L: function(t, i) {
        try {
            $2b056e5321c0aa1d$var$Hi.j(t, "", -1, i);
        } catch (t) {
            return;
        }
    }
}, $2b056e5321c0aa1d$var$Wi = null, $2b056e5321c0aa1d$var$Gi = {
    O: function() {
        if (!$2b056e5321c0aa1d$var$C($2b056e5321c0aa1d$var$Wi)) return $2b056e5321c0aa1d$var$Wi;
        var t = !0;
        if ($2b056e5321c0aa1d$var$R($2b056e5321c0aa1d$var$i)) t = !1;
        else try {
            var e = "__mplssupport__";
            $2b056e5321c0aa1d$var$Gi.j(e, "xyz"), '"xyz"' !== $2b056e5321c0aa1d$var$Gi.A(e) && (t = !1), $2b056e5321c0aa1d$var$Gi.L(e);
        } catch (i) {
            t = !1;
        }
        return t || $2b056e5321c0aa1d$var$N.error("localStorage unsupported; falling back to cookie store"), $2b056e5321c0aa1d$var$Wi = t, t;
    },
    F: function(t) {
        $2b056e5321c0aa1d$var$N.error("localStorage error: " + t);
    },
    A: function(t) {
        try {
            return null == $2b056e5321c0aa1d$var$i ? void 0 : $2b056e5321c0aa1d$var$i.localStorage.getItem(t);
        } catch (t) {
            $2b056e5321c0aa1d$var$Gi.F(t);
        }
        return null;
    },
    D: function(t) {
        try {
            return JSON.parse($2b056e5321c0aa1d$var$Gi.A(t)) || {};
        } catch (t) {}
        return null;
    },
    j: function(t, e) {
        try {
            null == $2b056e5321c0aa1d$var$i || $2b056e5321c0aa1d$var$i.localStorage.setItem(t, JSON.stringify(e));
        } catch (t) {
            $2b056e5321c0aa1d$var$Gi.F(t);
        }
    },
    L: function(t) {
        try {
            null == $2b056e5321c0aa1d$var$i || $2b056e5321c0aa1d$var$i.localStorage.removeItem(t);
        } catch (t) {
            $2b056e5321c0aa1d$var$Gi.F(t);
        }
    }
}, $2b056e5321c0aa1d$var$Ji = [
    "distinct_id",
    $2b056e5321c0aa1d$var$St,
    $2b056e5321c0aa1d$var$$t,
    $2b056e5321c0aa1d$var$zt,
    $2b056e5321c0aa1d$var$Nt
], $2b056e5321c0aa1d$var$Vi = $2b056e5321c0aa1d$var$B({}, $2b056e5321c0aa1d$var$Gi, {
    D: function(t) {
        try {
            var i = {};
            try {
                i = $2b056e5321c0aa1d$var$Hi.D(t) || {};
            } catch (t) {}
            var e = $2b056e5321c0aa1d$var$V(i, JSON.parse($2b056e5321c0aa1d$var$Gi.A(t) || "{}"));
            return $2b056e5321c0aa1d$var$Gi.j(t, e), e;
        } catch (t) {}
        return null;
    },
    j: function(t, i, e, r, s, n) {
        try {
            $2b056e5321c0aa1d$var$Gi.j(t, i, void 0, void 0, n);
            var o = {};
            $2b056e5321c0aa1d$var$Ji.forEach((t)=>{
                i[t] && (o[t] = i[t]);
            }), Object.keys(o).length && $2b056e5321c0aa1d$var$Hi.j(t, o, e, r, s, n);
        } catch (t) {
            $2b056e5321c0aa1d$var$Gi.F(t);
        }
    },
    L: function(t, e) {
        try {
            null == $2b056e5321c0aa1d$var$i || $2b056e5321c0aa1d$var$i.localStorage.removeItem(t), $2b056e5321c0aa1d$var$Hi.L(t, e);
        } catch (t) {
            $2b056e5321c0aa1d$var$Gi.F(t);
        }
    }
}), $2b056e5321c0aa1d$var$Ki = {}, $2b056e5321c0aa1d$var$Yi = {
    O: function() {
        return !0;
    },
    F: function(t) {
        $2b056e5321c0aa1d$var$N.error("memoryStorage error: " + t);
    },
    A: function(t) {
        return $2b056e5321c0aa1d$var$Ki[t] || null;
    },
    D: function(t) {
        return $2b056e5321c0aa1d$var$Ki[t] || null;
    },
    j: function(t, i) {
        $2b056e5321c0aa1d$var$Ki[t] = i;
    },
    L: function(t) {
        delete $2b056e5321c0aa1d$var$Ki[t];
    }
}, $2b056e5321c0aa1d$var$Xi = null, $2b056e5321c0aa1d$var$Qi = {
    O: function() {
        if (!$2b056e5321c0aa1d$var$C($2b056e5321c0aa1d$var$Xi)) return $2b056e5321c0aa1d$var$Xi;
        if ($2b056e5321c0aa1d$var$Xi = !0, $2b056e5321c0aa1d$var$R($2b056e5321c0aa1d$var$i)) $2b056e5321c0aa1d$var$Xi = !1;
        else try {
            var t = "__support__";
            $2b056e5321c0aa1d$var$Qi.j(t, "xyz"), '"xyz"' !== $2b056e5321c0aa1d$var$Qi.A(t) && ($2b056e5321c0aa1d$var$Xi = !1), $2b056e5321c0aa1d$var$Qi.L(t);
        } catch (t) {
            $2b056e5321c0aa1d$var$Xi = !1;
        }
        return $2b056e5321c0aa1d$var$Xi;
    },
    F: function(t) {
        $2b056e5321c0aa1d$var$N.error("sessionStorage error: ", t);
    },
    A: function(t) {
        try {
            return null == $2b056e5321c0aa1d$var$i ? void 0 : $2b056e5321c0aa1d$var$i.sessionStorage.getItem(t);
        } catch (t) {
            $2b056e5321c0aa1d$var$Qi.F(t);
        }
        return null;
    },
    D: function(t) {
        try {
            return JSON.parse($2b056e5321c0aa1d$var$Qi.A(t)) || null;
        } catch (t) {}
        return null;
    },
    j: function(t, e) {
        try {
            null == $2b056e5321c0aa1d$var$i || $2b056e5321c0aa1d$var$i.sessionStorage.setItem(t, JSON.stringify(e));
        } catch (t) {
            $2b056e5321c0aa1d$var$Qi.F(t);
        }
    },
    L: function(t) {
        try {
            null == $2b056e5321c0aa1d$var$i || $2b056e5321c0aa1d$var$i.sessionStorage.removeItem(t);
        } catch (t) {
            $2b056e5321c0aa1d$var$Qi.F(t);
        }
    }
};
!function(t) {
    t[t.PENDING = -1] = "PENDING", t[t.DENIED = 0] = "DENIED", t[t.GRANTED = 1] = "GRANTED";
}($2b056e5321c0aa1d$var$Bi || ($2b056e5321c0aa1d$var$Bi = {}));
class $2b056e5321c0aa1d$var$Zi {
    constructor(t){
        this.N = t;
    }
    get S() {
        return this.N.config;
    }
    get consent() {
        return this.U() ? $2b056e5321c0aa1d$var$Bi.DENIED : this.q;
    }
    isOptedOut() {
        return this.consent === $2b056e5321c0aa1d$var$Bi.DENIED || this.consent === $2b056e5321c0aa1d$var$Bi.PENDING && this.S.opt_out_capturing_by_default;
    }
    isOptedIn() {
        return !this.isOptedOut();
    }
    optInOut(t) {
        this.B.j(this.H, t ? 1 : 0, this.S.cookie_expiration, this.S.cross_subdomain_cookie, this.S.secure_cookie);
    }
    reset() {
        this.B.L(this.H, this.S.cross_subdomain_cookie);
    }
    get H() {
        var { token: t, opt_out_capturing_cookie_prefix: i } = this.N.config;
        return (i || "__ph_opt_in_out_") + t;
    }
    get q() {
        var t = this.B.A(this.H);
        return "1" === t ? $2b056e5321c0aa1d$var$Bi.GRANTED : "0" === t ? $2b056e5321c0aa1d$var$Bi.DENIED : $2b056e5321c0aa1d$var$Bi.PENDING;
    }
    get B() {
        if (!this.W) {
            var t = this.S.opt_out_capturing_persistence_type;
            this.W = "localStorage" === t ? $2b056e5321c0aa1d$var$Gi : $2b056e5321c0aa1d$var$Hi;
            var i = "localStorage" === t ? $2b056e5321c0aa1d$var$Hi : $2b056e5321c0aa1d$var$Gi;
            i.A(this.H) && (this.W.A(this.H) || this.optInOut("1" === i.A(this.H)), i.L(this.H, this.S.cross_subdomain_cookie));
        }
        return this.W;
    }
    U() {
        return !!this.S.respect_dnt && !!$2b056e5321c0aa1d$var$rt([
            null == $2b056e5321c0aa1d$var$o ? void 0 : $2b056e5321c0aa1d$var$o.doNotTrack,
            null == $2b056e5321c0aa1d$var$o ? void 0 : $2b056e5321c0aa1d$var$o.msDoNotTrack,
            $2b056e5321c0aa1d$var$c.doNotTrack
        ], (t)=>$2b056e5321c0aa1d$var$m([
                !0,
                1,
                "1",
                "yes"
            ], t));
    }
}
var $2b056e5321c0aa1d$var$te = $2b056e5321c0aa1d$var$z("[Dead Clicks]"), $2b056e5321c0aa1d$var$ie = ()=>!0, $2b056e5321c0aa1d$var$ee = (t)=>{
    var i, e = !(null == (i = t.instance.persistence) || !i.get_property($2b056e5321c0aa1d$var$vt)), r = t.instance.config.capture_dead_clicks;
    return $2b056e5321c0aa1d$var$A(r) ? r : e;
};
class $2b056e5321c0aa1d$var$re {
    get lazyLoadedDeadClicksAutocapture() {
        return this.G;
    }
    constructor(t, i, e){
        this.instance = t, this.isEnabled = i, this.onCapture = e, this.startIfEnabled();
    }
    onRemoteConfig(t) {
        this.instance.persistence && this.instance.persistence.register({
            [$2b056e5321c0aa1d$var$vt]: null == t ? void 0 : t.captureDeadClicks
        }), this.startIfEnabled();
    }
    startIfEnabled() {
        this.isEnabled(this) && this.J(()=>{
            this.V();
        });
    }
    J(t) {
        var i, e;
        null != (i = $2b056e5321c0aa1d$var$c.__PosthogExtensions__) && i.initDeadClicksAutocapture && t(), null == (e = $2b056e5321c0aa1d$var$c.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this.instance, "dead-clicks-autocapture", (i)=>{
            i ? $2b056e5321c0aa1d$var$te.error("failed to load script", i) : t();
        });
    }
    V() {
        var t;
        if ($2b056e5321c0aa1d$var$a) {
            if (!this.G && null != (t = $2b056e5321c0aa1d$var$c.__PosthogExtensions__) && t.initDeadClicksAutocapture) {
                var i = $2b056e5321c0aa1d$var$I(this.instance.config.capture_dead_clicks) ? this.instance.config.capture_dead_clicks : {};
                i.__onCapture = this.onCapture, this.G = $2b056e5321c0aa1d$var$c.__PosthogExtensions__.initDeadClicksAutocapture(this.instance, i), this.G.start($2b056e5321c0aa1d$var$a), $2b056e5321c0aa1d$var$te.info("starting...");
            }
        } else $2b056e5321c0aa1d$var$te.error("`document` not found. Cannot start.");
    }
    stop() {
        this.G && (this.G.stop(), this.G = void 0, $2b056e5321c0aa1d$var$te.info("stopping..."));
    }
}
var $2b056e5321c0aa1d$var$se = $2b056e5321c0aa1d$var$z("[ExceptionAutocapture]");
class $2b056e5321c0aa1d$var$ne {
    constructor(t){
        var e;
        this.K = ()=>{
            var t;
            if ($2b056e5321c0aa1d$var$i && this.isEnabled && null != (t = $2b056e5321c0aa1d$var$c.__PosthogExtensions__) && t.errorWrappingFunctions) {
                var e = $2b056e5321c0aa1d$var$c.__PosthogExtensions__.errorWrappingFunctions.wrapOnError, r = $2b056e5321c0aa1d$var$c.__PosthogExtensions__.errorWrappingFunctions.wrapUnhandledRejection, s = $2b056e5321c0aa1d$var$c.__PosthogExtensions__.errorWrappingFunctions.wrapConsoleError;
                try {
                    !this.Y && this.config.capture_unhandled_errors && (this.Y = e(this.captureException.bind(this))), !this.X && this.config.capture_unhandled_rejections && (this.X = r(this.captureException.bind(this))), !this.Z && this.config.capture_console_errors && (this.Z = s(this.captureException.bind(this)));
                } catch (t) {
                    $2b056e5321c0aa1d$var$se.error("failed to start", t), this.tt();
                }
            }
        }, this.instance = t, this.remoteEnabled = !(null == (e = this.instance.persistence) || !e.props[$2b056e5321c0aa1d$var$ut]), this.config = this.it(), this.startIfEnabled();
    }
    it() {
        var t = this.instance.config.capture_exceptions, i = {
            capture_unhandled_errors: !1,
            capture_unhandled_rejections: !1,
            capture_console_errors: !1
        };
        return $2b056e5321c0aa1d$var$I(t) ? i = $2b056e5321c0aa1d$var$B({}, i, t) : ($2b056e5321c0aa1d$var$R(t) ? this.remoteEnabled : t) && (i = $2b056e5321c0aa1d$var$B({}, i, {
            capture_unhandled_errors: !0,
            capture_unhandled_rejections: !0
        })), i;
    }
    get isEnabled() {
        return this.config.capture_console_errors || this.config.capture_unhandled_errors || this.config.capture_unhandled_rejections;
    }
    startIfEnabled() {
        this.isEnabled && ($2b056e5321c0aa1d$var$se.info("enabled"), this.J(this.K));
    }
    J(t) {
        var i, e;
        null != (i = $2b056e5321c0aa1d$var$c.__PosthogExtensions__) && i.errorWrappingFunctions && t(), null == (e = $2b056e5321c0aa1d$var$c.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this.instance, "exception-autocapture", (i)=>{
            if (i) return $2b056e5321c0aa1d$var$se.error("failed to load script", i);
            t();
        });
    }
    tt() {
        var t, i, e;
        null == (t = this.Y) || t.call(this), this.Y = void 0, null == (i = this.X) || i.call(this), this.X = void 0, null == (e = this.Z) || e.call(this), this.Z = void 0;
    }
    onRemoteConfig(t) {
        var i = t.autocaptureExceptions;
        this.remoteEnabled = !!i || !1, this.config = this.it(), this.instance.persistence && this.instance.persistence.register({
            [$2b056e5321c0aa1d$var$ut]: this.remoteEnabled
        }), this.startIfEnabled();
    }
    captureException(t) {
        var i = this.instance.requestRouter.endpointFor("ui");
        t.$exception_personURL = i + "/project/" + this.instance.config.token + "/person/" + this.instance.get_distinct_id(), this.instance.exceptions.sendExceptionEvent(t);
    }
}
function $2b056e5321c0aa1d$var$oe(t) {
    return !$2b056e5321c0aa1d$var$R(Event) && $2b056e5321c0aa1d$var$ae(t, Event);
}
function $2b056e5321c0aa1d$var$ae(t, i) {
    try {
        return t instanceof i;
    } catch (t) {
        return !1;
    }
}
function $2b056e5321c0aa1d$var$le(t) {
    switch(Object.prototype.toString.call(t)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object DOMError]":
            return !0;
        default:
            return $2b056e5321c0aa1d$var$ae(t, Error);
    }
}
function $2b056e5321c0aa1d$var$he(t, i) {
    return Object.prototype.toString.call(t) === "[object " + i + "]";
}
function $2b056e5321c0aa1d$var$ue(t) {
    return $2b056e5321c0aa1d$var$he(t, "DOMError");
}
var $2b056e5321c0aa1d$var$de = /\(error: (.*)\)/, $2b056e5321c0aa1d$var$ve = 50, $2b056e5321c0aa1d$var$ce = "?";
function $2b056e5321c0aa1d$var$fe(t, i, e, r) {
    var s = {
        platform: "web:javascript",
        filename: t,
        function: "<anonymous>" === i ? $2b056e5321c0aa1d$var$ce : i,
        in_app: !0
    };
    return $2b056e5321c0aa1d$var$R(e) || (s.lineno = e), $2b056e5321c0aa1d$var$R(r) || (s.colno = r), s;
}
var $2b056e5321c0aa1d$var$pe = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i, $2b056e5321c0aa1d$var$ge = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, $2b056e5321c0aa1d$var$_e = /\((\S*)(?::(\d+))(?::(\d+))\)/, $2b056e5321c0aa1d$var$me = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i, $2b056e5321c0aa1d$var$be = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, $2b056e5321c0aa1d$var$we = function() {
    for(var t = arguments.length, i = new Array(t), e = 0; e < t; e++)i[e] = arguments[e];
    var r = i.sort((t, i)=>t[0] - i[0]).map((t)=>t[1]);
    return function(t, i) {
        void 0 === i && (i = 0);
        for(var e = [], s = t.split("\n"), n = i; n < s.length; n++){
            var o = s[n];
            if (!(o.length > 1024)) {
                var a = $2b056e5321c0aa1d$var$de.test(o) ? o.replace($2b056e5321c0aa1d$var$de, "$1") : o;
                if (!a.match(/\S*Error: /)) {
                    for (var l of r){
                        var h = l(a);
                        if (h) {
                            e.push(h);
                            break;
                        }
                    }
                    if (e.length >= $2b056e5321c0aa1d$var$ve) break;
                }
            }
        }
        return function(t) {
            if (!t.length) return [];
            var i = Array.from(t);
            return i.reverse(), i.slice(0, $2b056e5321c0aa1d$var$ve).map((t)=>$2b056e5321c0aa1d$var$B({}, t, {
                    filename: t.filename || $2b056e5321c0aa1d$var$ye(i).filename,
                    function: t.function || $2b056e5321c0aa1d$var$ce
                }));
        }(e);
    };
}(...[
    [
        30,
        (t)=>{
            var i = $2b056e5321c0aa1d$var$pe.exec(t);
            if (i) {
                var [, e, r, s] = i;
                return $2b056e5321c0aa1d$var$fe(e, $2b056e5321c0aa1d$var$ce, +r, +s);
            }
            var n = $2b056e5321c0aa1d$var$ge.exec(t);
            if (n) {
                if (n[2] && 0 === n[2].indexOf("eval")) {
                    var o = $2b056e5321c0aa1d$var$_e.exec(n[2]);
                    o && (n[2] = o[1], n[3] = o[2], n[4] = o[3]);
                }
                var [a, l] = $2b056e5321c0aa1d$var$xe(n[1] || $2b056e5321c0aa1d$var$ce, n[2]);
                return $2b056e5321c0aa1d$var$fe(l, a, n[3] ? +n[3] : void 0, n[4] ? +n[4] : void 0);
            }
        }
    ],
    [
        50,
        (t)=>{
            var i = $2b056e5321c0aa1d$var$me.exec(t);
            if (i) {
                if (i[3] && i[3].indexOf(" > eval") > -1) {
                    var e = $2b056e5321c0aa1d$var$be.exec(i[3]);
                    e && (i[1] = i[1] || "eval", i[3] = e[1], i[4] = e[2], i[5] = "");
                }
                var r = i[3], s = i[1] || $2b056e5321c0aa1d$var$ce;
                return [s, r] = $2b056e5321c0aa1d$var$xe(s, r), $2b056e5321c0aa1d$var$fe(r, s, i[4] ? +i[4] : void 0, i[5] ? +i[5] : void 0);
            }
        }
    ]
]);
function $2b056e5321c0aa1d$var$ye(t) {
    return t[t.length - 1] || {};
}
var $2b056e5321c0aa1d$var$Se, $2b056e5321c0aa1d$var$$e, $2b056e5321c0aa1d$var$ke, $2b056e5321c0aa1d$var$xe = (t, i)=>{
    var e = -1 !== t.indexOf("safari-extension"), r = -1 !== t.indexOf("safari-web-extension");
    return e || r ? [
        -1 !== t.indexOf("@") ? t.split("@")[0] : $2b056e5321c0aa1d$var$ce,
        e ? "safari-extension:" + i : "safari-web-extension:" + i
    ] : [
        t,
        i
    ];
};
var $2b056e5321c0aa1d$var$Ee = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
function $2b056e5321c0aa1d$var$Ie(t, i) {
    void 0 === i && (i = 0);
    var e = t.stacktrace || t.stack || "", r = function(t) {
        if (t && $2b056e5321c0aa1d$var$Pe.test(t.message)) return 1;
        return 0;
    }(t);
    try {
        var s = $2b056e5321c0aa1d$var$we, n = function(t, i) {
            var e = function(t) {
                var i = globalThis._posthogChunkIds;
                if (!i) return {};
                var e = Object.keys(i);
                return $2b056e5321c0aa1d$var$ke && e.length === $2b056e5321c0aa1d$var$$e || ($2b056e5321c0aa1d$var$$e = e.length, $2b056e5321c0aa1d$var$ke = e.reduce((e, r)=>{
                    $2b056e5321c0aa1d$var$Se || ($2b056e5321c0aa1d$var$Se = {});
                    var s = $2b056e5321c0aa1d$var$Se[r];
                    if (s) e[s[0]] = s[1];
                    else for(var n = t(r), o = n.length - 1; o >= 0; o--){
                        var a = n[o], l = null == a ? void 0 : a.filename, h = i[r];
                        if (l && h) {
                            e[l] = h, $2b056e5321c0aa1d$var$Se[r] = [
                                l,
                                h
                            ];
                            break;
                        }
                    }
                    return e;
                }, {})), $2b056e5321c0aa1d$var$ke;
            }(i);
            return t.forEach((t)=>{
                t.filename && (t.chunk_id = e[t.filename]);
            }), t;
        }(s(e, r), s);
        return n.slice(0, n.length - i);
    } catch (t) {}
    return [];
}
var $2b056e5321c0aa1d$var$Pe = /Minified React error #\d+;/i;
function $2b056e5321c0aa1d$var$Re(t, i) {
    var e, r, s = $2b056e5321c0aa1d$var$Ie(t), n = null === (e = null == i ? void 0 : i.handled) || void 0 === e || e, o = null !== (r = null == i ? void 0 : i.synthetic) && void 0 !== r && r;
    return {
        type: null != i && i.overrideExceptionType ? i.overrideExceptionType : t.name,
        value: function(t) {
            var i = t.message;
            if (i.error && "string" == typeof i.error.message) return String(i.error.message);
            return String(i);
        }(t),
        stacktrace: {
            frames: s,
            type: "raw"
        },
        mechanism: {
            handled: n,
            synthetic: o
        }
    };
}
function $2b056e5321c0aa1d$var$Te(t, i) {
    var e = $2b056e5321c0aa1d$var$Re(t, i);
    return t.cause && $2b056e5321c0aa1d$var$le(t.cause) && t.cause !== t ? [
        e,
        ...$2b056e5321c0aa1d$var$Te(t.cause, {
            handled: null == i ? void 0 : i.handled,
            synthetic: null == i ? void 0 : i.synthetic
        })
    ] : [
        e
    ];
}
function $2b056e5321c0aa1d$var$Me(t, i) {
    return {
        $exception_list: $2b056e5321c0aa1d$var$Te(t, i),
        $exception_level: "error"
    };
}
function $2b056e5321c0aa1d$var$Ce(t, i) {
    var e, r, s, n = null === (e = null == i ? void 0 : i.handled) || void 0 === e || e, o = null === (r = null == i ? void 0 : i.synthetic) || void 0 === r || r, a = {
        type: null != i && i.overrideExceptionType ? i.overrideExceptionType : null !== (s = null == i ? void 0 : i.defaultExceptionType) && void 0 !== s ? s : "Error",
        value: t || (null == i ? void 0 : i.defaultExceptionMessage),
        mechanism: {
            handled: n,
            synthetic: o
        }
    };
    if (null != i && i.syntheticException) {
        var l = $2b056e5321c0aa1d$var$Ie(i.syntheticException, 1);
        l.length && (a.stacktrace = {
            frames: l,
            type: "raw"
        });
    }
    return {
        $exception_list: [
            a
        ],
        $exception_level: "error"
    };
}
function $2b056e5321c0aa1d$var$Oe(t) {
    return $2b056e5321c0aa1d$var$T(t) && !$2b056e5321c0aa1d$var$M(t) && $2b056e5321c0aa1d$export$9dd8f6ec3b5e6004.indexOf(t) >= 0;
}
function $2b056e5321c0aa1d$var$Fe(t, i) {
    var e, r, s = null === (e = null == i ? void 0 : i.handled) || void 0 === e || e, n = null === (r = null == i ? void 0 : i.synthetic) || void 0 === r || r, o = null != i && i.overrideExceptionType ? i.overrideExceptionType : $2b056e5321c0aa1d$var$oe(t) ? t.constructor.name : "Error", a = "Non-Error 'exception' captured with keys: " + function(t, i) {
        void 0 === i && (i = 40);
        var e = Object.keys(t);
        if (e.sort(), !e.length) return "[object has no keys]";
        for(var r = e.length; r > 0; r--){
            var s = e.slice(0, r).join(", ");
            if (!(s.length > i)) return r === e.length || s.length <= i ? s : s.slice(0, i) + "...";
        }
        return "";
    }(t), l = {
        type: o,
        value: a,
        mechanism: {
            handled: s,
            synthetic: n
        }
    };
    if (null != i && i.syntheticException) {
        var h = $2b056e5321c0aa1d$var$Ie(null == i ? void 0 : i.syntheticException, 1);
        h.length && (l.stacktrace = {
            frames: h,
            type: "raw"
        });
    }
    return {
        $exception_list: [
            l
        ],
        $exception_level: $2b056e5321c0aa1d$var$Oe(t.level) ? t.level : "error"
    };
}
function $2b056e5321c0aa1d$var$Ae(t, i) {
    var { error: e, event: r } = t, s = {
        $exception_list: []
    }, n = e || r;
    if ($2b056e5321c0aa1d$var$ue(n) || function(t) {
        return $2b056e5321c0aa1d$var$he(t, "DOMException");
    }(n)) {
        var o = n;
        if (function(t) {
            return "stack" in t;
        }(n)) s = $2b056e5321c0aa1d$var$Me(n, i);
        else {
            var a = o.name || ($2b056e5321c0aa1d$var$ue(o) ? "DOMError" : "DOMException"), l = o.message ? a + ": " + o.message : a;
            s = $2b056e5321c0aa1d$var$Ce(l, $2b056e5321c0aa1d$var$B({}, i, {
                overrideExceptionType: $2b056e5321c0aa1d$var$ue(o) ? "DOMError" : "DOMException",
                defaultExceptionMessage: l
            }));
        }
        return "code" in o && (s.$exception_DOMException_code = "" + o.code), s;
    }
    if (function(t) {
        return $2b056e5321c0aa1d$var$he(t, "ErrorEvent");
    }(n) && n.error) return $2b056e5321c0aa1d$var$Me(n.error, i);
    if ($2b056e5321c0aa1d$var$le(n)) return $2b056e5321c0aa1d$var$Me(n, i);
    if (function(t) {
        return $2b056e5321c0aa1d$var$he(t, "Object");
    }(n) || $2b056e5321c0aa1d$var$oe(n)) return $2b056e5321c0aa1d$var$Fe(n, i);
    if ($2b056e5321c0aa1d$var$R(e) && $2b056e5321c0aa1d$var$T(r)) {
        var h = "Error", u = r, d = r.match($2b056e5321c0aa1d$var$Ee);
        return d && (h = d[1], u = d[2]), $2b056e5321c0aa1d$var$Ce(u, $2b056e5321c0aa1d$var$B({}, i, {
            overrideExceptionType: h,
            defaultExceptionMessage: u
        }));
    }
    return $2b056e5321c0aa1d$var$Ce(n, i);
}
function $2b056e5321c0aa1d$var$De(t, i, e) {
    try {
        if (!(i in t)) return ()=>{};
        var r = t[i], s = e(r);
        return $2b056e5321c0aa1d$var$E(s) && (s.prototype = s.prototype || {}, Object.defineProperties(s, {
            __posthog_wrapped__: {
                enumerable: !1,
                value: !0
            }
        })), t[i] = s, ()=>{
            t[i] = r;
        };
    } catch (t) {
        return ()=>{};
    }
}
class $2b056e5321c0aa1d$var$je {
    constructor(t){
        var e;
        this.N = t, this.et = (null == $2b056e5321c0aa1d$var$i || null == (e = $2b056e5321c0aa1d$var$i.location) ? void 0 : e.pathname) || "";
    }
    get isEnabled() {
        return "history_change" === this.N.config.capture_pageview;
    }
    startIfEnabled() {
        this.isEnabled && ($2b056e5321c0aa1d$var$N.info("History API monitoring enabled, starting..."), this.monitorHistoryChanges());
    }
    stop() {
        this.rt && this.rt(), this.rt = void 0, $2b056e5321c0aa1d$var$N.info("History API monitoring stopped");
    }
    monitorHistoryChanges() {
        var t, e;
        if ($2b056e5321c0aa1d$var$i && $2b056e5321c0aa1d$var$i.history) {
            var r = this;
            null != (t = $2b056e5321c0aa1d$var$i.history.pushState) && t.__posthog_wrapped__ || $2b056e5321c0aa1d$var$De($2b056e5321c0aa1d$var$i.history, "pushState", (t)=>function(i, e, s) {
                    t.call(this, i, e, s), r.st("pushState");
                }), null != (e = $2b056e5321c0aa1d$var$i.history.replaceState) && e.__posthog_wrapped__ || $2b056e5321c0aa1d$var$De($2b056e5321c0aa1d$var$i.history, "replaceState", (t)=>function(i, e, s) {
                    t.call(this, i, e, s), r.st("replaceState");
                }), this.nt();
        }
    }
    st(t) {
        try {
            var e, r = null == $2b056e5321c0aa1d$var$i || null == (e = $2b056e5321c0aa1d$var$i.location) ? void 0 : e.pathname;
            if (!r) return;
            r !== this.et && this.isEnabled && this.N.capture("$pageview", {
                navigation_type: t
            }), this.et = r;
        } catch (i) {
            $2b056e5321c0aa1d$var$N.error("Error capturing " + t + " pageview", i);
        }
    }
    nt() {
        if (!this.rt) {
            var t = ()=>{
                this.st("popstate");
            };
            $2b056e5321c0aa1d$var$st($2b056e5321c0aa1d$var$i, "popstate", t), this.rt = ()=>{
                $2b056e5321c0aa1d$var$i && $2b056e5321c0aa1d$var$i.removeEventListener("popstate", t);
            };
        }
    }
}
function $2b056e5321c0aa1d$var$Le(t) {
    var i, e;
    return (null == (i = JSON.stringify(t, (e = [], function(t, i) {
        if ($2b056e5321c0aa1d$var$I(i)) {
            for(; e.length > 0 && e[e.length - 1] !== this;)e.pop();
            return e.includes(i) ? "[Circular]" : (e.push(i), i);
        }
        return i;
    }))) ? void 0 : i.length) || 0;
}
function $2b056e5321c0aa1d$var$Ne(t, i) {
    if (void 0 === i && (i = 6606028.8), t.size >= i && t.data.length > 1) {
        var e = Math.floor(t.data.length / 2), r = t.data.slice(0, e), s = t.data.slice(e);
        return [
            $2b056e5321c0aa1d$var$Ne({
                size: $2b056e5321c0aa1d$var$Le(r),
                data: r,
                sessionId: t.sessionId,
                windowId: t.windowId
            }),
            $2b056e5321c0aa1d$var$Ne({
                size: $2b056e5321c0aa1d$var$Le(s),
                data: s,
                sessionId: t.sessionId,
                windowId: t.windowId
            })
        ].flatMap((t)=>t);
    }
    return [
        t
    ];
}
var $2b056e5321c0aa1d$var$ze = ((t)=>(t[t.DomContentLoaded = 0] = "DomContentLoaded", t[t.Load = 1] = "Load", t[t.FullSnapshot = 2] = "FullSnapshot", t[t.IncrementalSnapshot = 3] = "IncrementalSnapshot", t[t.Meta = 4] = "Meta", t[t.Custom = 5] = "Custom", t[t.Plugin = 6] = "Plugin", t))($2b056e5321c0aa1d$var$ze || {}), $2b056e5321c0aa1d$var$Ue = ((t)=>(t[t.Mutation = 0] = "Mutation", t[t.MouseMove = 1] = "MouseMove", t[t.MouseInteraction = 2] = "MouseInteraction", t[t.Scroll = 3] = "Scroll", t[t.ViewportResize = 4] = "ViewportResize", t[t.Input = 5] = "Input", t[t.TouchMove = 6] = "TouchMove", t[t.MediaInteraction = 7] = "MediaInteraction", t[t.StyleSheetRule = 8] = "StyleSheetRule", t[t.CanvasMutation = 9] = "CanvasMutation", t[t.Font = 10] = "Font", t[t.Log = 11] = "Log", t[t.Drag = 12] = "Drag", t[t.StyleDeclaration = 13] = "StyleDeclaration", t[t.Selection = 14] = "Selection", t[t.AdoptedStyleSheet = 15] = "AdoptedStyleSheet", t[t.CustomElement = 16] = "CustomElement", t))($2b056e5321c0aa1d$var$Ue || {}), $2b056e5321c0aa1d$var$qe = "[SessionRecording]", $2b056e5321c0aa1d$var$Be = "redacted", $2b056e5321c0aa1d$var$He = {
    initiatorTypes: [
        "audio",
        "beacon",
        "body",
        "css",
        "early-hint",
        "embed",
        "fetch",
        "frame",
        "iframe",
        "icon",
        "image",
        "img",
        "input",
        "link",
        "navigation",
        "object",
        "ping",
        "script",
        "track",
        "video",
        "xmlhttprequest"
    ],
    maskRequestFn: (t)=>t,
    recordHeaders: !1,
    recordBody: !1,
    recordInitialRequests: !1,
    recordPerformance: !1,
    performanceEntryTypeToObserve: [
        "first-input",
        "navigation",
        "paint",
        "resource"
    ],
    payloadSizeLimitBytes: 1e6,
    payloadHostDenyList: [
        ".lr-ingest.io",
        ".ingest.sentry.io",
        ".clarity.ms",
        "analytics.google.com"
    ]
}, $2b056e5321c0aa1d$var$We = [
    "authorization",
    "x-forwarded-for",
    "authorization",
    "cookie",
    "set-cookie",
    "x-api-key",
    "x-real-ip",
    "remote-addr",
    "forwarded",
    "proxy-authorization",
    "x-csrf-token",
    "x-csrftoken",
    "x-xsrf-token"
], $2b056e5321c0aa1d$var$Ge = [
    "password",
    "secret",
    "passwd",
    "api_key",
    "apikey",
    "auth",
    "credentials",
    "mysql_pwd",
    "privatekey",
    "private_key",
    "token"
], $2b056e5321c0aa1d$var$Je = [
    "/s/",
    "/e/",
    "/i/"
];
function $2b056e5321c0aa1d$var$Ve(t, i, e, r) {
    if ($2b056e5321c0aa1d$var$O(t)) return t;
    var s = (null == i ? void 0 : i["content-length"]) || function(t) {
        return new Blob([
            t
        ]).size;
    }(t);
    return $2b056e5321c0aa1d$var$T(s) && (s = parseInt(s)), s > e ? $2b056e5321c0aa1d$var$qe + " " + r + " body too large to record (" + s + " bytes)" : t;
}
function $2b056e5321c0aa1d$var$Ke(t, i) {
    if ($2b056e5321c0aa1d$var$O(t)) return t;
    var e = t;
    return $2b056e5321c0aa1d$var$vi(e, !1) || (e = $2b056e5321c0aa1d$var$qe + " " + i + " body " + $2b056e5321c0aa1d$var$Be), $2b056e5321c0aa1d$var$J($2b056e5321c0aa1d$var$Ge, (t)=>{
        var r, s;
        null != (r = e) && r.length && -1 !== (null == (s = e) ? void 0 : s.indexOf(t)) && (e = $2b056e5321c0aa1d$var$qe + " " + i + " body " + $2b056e5321c0aa1d$var$Be + " as might contain: " + t);
    }), e;
}
var $2b056e5321c0aa1d$var$Ye = (t, i)=>{
    var e, r, s, n = {
        payloadSizeLimitBytes: $2b056e5321c0aa1d$var$He.payloadSizeLimitBytes,
        performanceEntryTypeToObserve: [
            ...$2b056e5321c0aa1d$var$He.performanceEntryTypeToObserve
        ],
        payloadHostDenyList: [
            ...i.payloadHostDenyList || [],
            ...$2b056e5321c0aa1d$var$He.payloadHostDenyList
        ]
    }, o = !1 !== t.session_recording.recordHeaders && i.recordHeaders, a = !1 !== t.session_recording.recordBody && i.recordBody, l = !1 !== t.capture_performance && i.recordPerformance, h = (e = n, s = Math.min(1e6, null !== (r = e.payloadSizeLimitBytes) && void 0 !== r ? r : 1e6), (t)=>(null != t && t.requestBody && (t.requestBody = $2b056e5321c0aa1d$var$Ve(t.requestBody, t.requestHeaders, s, "Request")), null != t && t.responseBody && (t.responseBody = $2b056e5321c0aa1d$var$Ve(t.responseBody, t.responseHeaders, s, "Response")), t)), u = (i)=>{
        var e, r;
        return h(((t, i)=>{
            var e, r = $2b056e5321c0aa1d$var$wi(t.name), s = 0 === i.indexOf("http") ? null == (e = $2b056e5321c0aa1d$var$wi(i)) ? void 0 : e.pathname : i;
            "/" === s && (s = "");
            var n = null == r ? void 0 : r.pathname.replace(s || "", "");
            if (!(r && n && $2b056e5321c0aa1d$var$Je.some((t)=>0 === n.indexOf(t)))) return t;
        })((r = (e = i).requestHeaders, $2b056e5321c0aa1d$var$O(r) || $2b056e5321c0aa1d$var$J(Object.keys(null != r ? r : {}), (t)=>{
            $2b056e5321c0aa1d$var$We.includes(t.toLowerCase()) && (r[t] = $2b056e5321c0aa1d$var$Be);
        }), e), t.api_host));
    }, d = $2b056e5321c0aa1d$var$E(t.session_recording.maskNetworkRequestFn);
    return d && $2b056e5321c0aa1d$var$E(t.session_recording.maskCapturedNetworkRequestFn) && $2b056e5321c0aa1d$var$N.warn("Both `maskNetworkRequestFn` and `maskCapturedNetworkRequestFn` are defined. `maskNetworkRequestFn` will be ignored."), d && (t.session_recording.maskCapturedNetworkRequestFn = (i)=>{
        var e = t.session_recording.maskNetworkRequestFn({
            url: i.name
        });
        return $2b056e5321c0aa1d$var$B({}, i, {
            name: null == e ? void 0 : e.url
        });
    }), n.maskRequestFn = $2b056e5321c0aa1d$var$E(t.session_recording.maskCapturedNetworkRequestFn) ? (i)=>{
        var e, r = u(i);
        return r && null !== (e = null == t.session_recording.maskCapturedNetworkRequestFn ? void 0 : t.session_recording.maskCapturedNetworkRequestFn(r)) && void 0 !== e ? e : void 0;
    } : (t)=>(function(t) {
            if (!$2b056e5321c0aa1d$var$R(t)) return t.requestBody = $2b056e5321c0aa1d$var$Ke(t.requestBody, "Request"), t.responseBody = $2b056e5321c0aa1d$var$Ke(t.responseBody, "Response"), t;
        })(u(t)), $2b056e5321c0aa1d$var$B({}, $2b056e5321c0aa1d$var$He, n, {
        recordHeaders: o,
        recordBody: a,
        recordPerformance: l,
        recordInitialRequests: l
    });
};
function $2b056e5321c0aa1d$var$Xe(t, i, e, r, s) {
    return i > e && ($2b056e5321c0aa1d$var$N.warn("min cannot be greater than max."), i = e), $2b056e5321c0aa1d$var$F(t) ? t > e ? (r && $2b056e5321c0aa1d$var$N.warn(r + " cannot be  greater than max: " + e + ". Using max value instead."), e) : t < i ? (r && $2b056e5321c0aa1d$var$N.warn(r + " cannot be less than min: " + i + ". Using min value instead."), i) : t : (r && $2b056e5321c0aa1d$var$N.warn(r + " must be a number. using max or fallback. max: " + e + ", fallback: " + s), $2b056e5321c0aa1d$var$Xe(s || e, i, e, r));
}
class $2b056e5321c0aa1d$var$Qe {
    constructor(t, i){
        var e, r;
        void 0 === i && (i = {}), this.ot = 100, this.lt = 10, this.ht = {}, this.ut = {}, this.dt = ()=>{
            Object.keys(this.ht).forEach((t)=>{
                this.ht[t] = this.ht[t] + this.lt, this.ht[t] >= this.ot && delete this.ht[t];
            });
        }, this.vt = (t)=>{
            var i = this._rrweb.mirror.getNode(t);
            if ("svg" !== (null == i ? void 0 : i.nodeName) && i instanceof Element) {
                var e = i.closest("svg");
                if (e) return [
                    this._rrweb.mirror.getId(e),
                    e
                ];
            }
            return [
                t,
                i
            ];
        }, this.ct = (t)=>{
            var i, e, r, s, n, o, a, l;
            return (null !== (i = null == (e = t.removes) ? void 0 : e.length) && void 0 !== i ? i : 0) + (null !== (r = null == (s = t.attributes) ? void 0 : s.length) && void 0 !== r ? r : 0) + (null !== (n = null == (o = t.texts) ? void 0 : o.length) && void 0 !== n ? n : 0) + (null !== (a = null == (l = t.adds) ? void 0 : l.length) && void 0 !== a ? a : 0);
        }, this.throttleMutations = (t)=>{
            if (3 !== t.type || 0 !== t.data.source) return t;
            var i = t.data, e = this.ct(i);
            i.attributes && (i.attributes = i.attributes.filter((t)=>{
                var i, e, r, [s, n] = this.vt(t.id);
                if (0 === this.ht[s]) return !1;
                (this.ht[s] = null !== (i = this.ht[s]) && void 0 !== i ? i : this.ot, this.ht[s] = Math.max(this.ht[s] - 1, 0), 0 === this.ht[s]) && (this.ut[s] || (this.ut[s] = !0, null == (e = (r = this.ft).onBlockedNode) || e.call(r, s, n)));
                return t;
            }));
            var r = this.ct(i);
            return 0 !== r || e === r ? t : void 0;
        }, this._rrweb = t, this.ft = i, this.lt = $2b056e5321c0aa1d$var$Xe(null !== (e = this.ft.refillRate) && void 0 !== e ? e : this.lt, 0, 100, "mutation throttling refill rate"), this.ot = $2b056e5321c0aa1d$var$Xe(null !== (r = this.ft.bucketSize) && void 0 !== r ? r : this.ot, 0, 100, "mutation throttling bucket size"), setInterval(()=>{
            this.dt();
        }, 1e3);
    }
}
var $2b056e5321c0aa1d$var$Ze = Uint8Array, $2b056e5321c0aa1d$var$tr = Uint16Array, $2b056e5321c0aa1d$var$ir = Uint32Array, $2b056e5321c0aa1d$var$er = new $2b056e5321c0aa1d$var$Ze([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    0,
    0,
    0
]), $2b056e5321c0aa1d$var$rr = new $2b056e5321c0aa1d$var$Ze([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    0,
    0
]), $2b056e5321c0aa1d$var$sr = new $2b056e5321c0aa1d$var$Ze([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]), $2b056e5321c0aa1d$var$nr = function(t, i) {
    for(var e = new $2b056e5321c0aa1d$var$tr(31), r = 0; r < 31; ++r)e[r] = i += 1 << t[r - 1];
    var s = new $2b056e5321c0aa1d$var$ir(e[30]);
    for(r = 1; r < 30; ++r)for(var n = e[r]; n < e[r + 1]; ++n)s[n] = n - e[r] << 5 | r;
    return [
        e,
        s
    ];
}, $2b056e5321c0aa1d$var$or = $2b056e5321c0aa1d$var$nr($2b056e5321c0aa1d$var$er, 2), $2b056e5321c0aa1d$var$ar = $2b056e5321c0aa1d$var$or[0], $2b056e5321c0aa1d$var$lr = $2b056e5321c0aa1d$var$or[1];
$2b056e5321c0aa1d$var$ar[28] = 258, $2b056e5321c0aa1d$var$lr[258] = 28;
for(var $2b056e5321c0aa1d$var$hr = $2b056e5321c0aa1d$var$nr($2b056e5321c0aa1d$var$rr, 0)[1], $2b056e5321c0aa1d$var$ur = new $2b056e5321c0aa1d$var$tr(32768), $2b056e5321c0aa1d$var$dr = 0; $2b056e5321c0aa1d$var$dr < 32768; ++$2b056e5321c0aa1d$var$dr){
    var $2b056e5321c0aa1d$var$vr = (43690 & $2b056e5321c0aa1d$var$dr) >>> 1 | (21845 & $2b056e5321c0aa1d$var$dr) << 1;
    $2b056e5321c0aa1d$var$vr = (61680 & ($2b056e5321c0aa1d$var$vr = (52428 & $2b056e5321c0aa1d$var$vr) >>> 2 | (13107 & $2b056e5321c0aa1d$var$vr) << 2)) >>> 4 | (3855 & $2b056e5321c0aa1d$var$vr) << 4, $2b056e5321c0aa1d$var$ur[$2b056e5321c0aa1d$var$dr] = ((65280 & $2b056e5321c0aa1d$var$vr) >>> 8 | (255 & $2b056e5321c0aa1d$var$vr) << 8) >>> 1;
}
var $2b056e5321c0aa1d$var$cr = function(t, i, e) {
    for(var r = t.length, s = 0, n = new $2b056e5321c0aa1d$var$tr(i); s < r; ++s)++n[t[s] - 1];
    var o, a = new $2b056e5321c0aa1d$var$tr(i);
    for(s = 0; s < i; ++s)a[s] = a[s - 1] + n[s - 1] << 1;
    if (e) {
        o = new $2b056e5321c0aa1d$var$tr(1 << i);
        var l = 15 - i;
        for(s = 0; s < r; ++s)if (t[s]) for(var h = s << 4 | t[s], u = i - t[s], d = a[t[s] - 1]++ << u, v = d | (1 << u) - 1; d <= v; ++d)o[$2b056e5321c0aa1d$var$ur[d] >>> l] = h;
    } else for(o = new $2b056e5321c0aa1d$var$tr(r), s = 0; s < r; ++s)o[s] = $2b056e5321c0aa1d$var$ur[a[t[s] - 1]++] >>> 15 - t[s];
    return o;
}, $2b056e5321c0aa1d$var$fr = new $2b056e5321c0aa1d$var$Ze(288);
for($2b056e5321c0aa1d$var$dr = 0; $2b056e5321c0aa1d$var$dr < 144; ++$2b056e5321c0aa1d$var$dr)$2b056e5321c0aa1d$var$fr[$2b056e5321c0aa1d$var$dr] = 8;
for($2b056e5321c0aa1d$var$dr = 144; $2b056e5321c0aa1d$var$dr < 256; ++$2b056e5321c0aa1d$var$dr)$2b056e5321c0aa1d$var$fr[$2b056e5321c0aa1d$var$dr] = 9;
for($2b056e5321c0aa1d$var$dr = 256; $2b056e5321c0aa1d$var$dr < 280; ++$2b056e5321c0aa1d$var$dr)$2b056e5321c0aa1d$var$fr[$2b056e5321c0aa1d$var$dr] = 7;
for($2b056e5321c0aa1d$var$dr = 280; $2b056e5321c0aa1d$var$dr < 288; ++$2b056e5321c0aa1d$var$dr)$2b056e5321c0aa1d$var$fr[$2b056e5321c0aa1d$var$dr] = 8;
var $2b056e5321c0aa1d$var$pr = new $2b056e5321c0aa1d$var$Ze(32);
for($2b056e5321c0aa1d$var$dr = 0; $2b056e5321c0aa1d$var$dr < 32; ++$2b056e5321c0aa1d$var$dr)$2b056e5321c0aa1d$var$pr[$2b056e5321c0aa1d$var$dr] = 5;
var $2b056e5321c0aa1d$var$gr = $2b056e5321c0aa1d$var$cr($2b056e5321c0aa1d$var$fr, 9, 0), $2b056e5321c0aa1d$var$_r = $2b056e5321c0aa1d$var$cr($2b056e5321c0aa1d$var$pr, 5, 0), $2b056e5321c0aa1d$var$mr = function(t) {
    return (t / 8 >> 0) + (7 & t && 1);
}, $2b056e5321c0aa1d$var$br = function(t, i, e) {
    (null == e || e > t.length) && (e = t.length);
    var r = new (t instanceof $2b056e5321c0aa1d$var$tr ? $2b056e5321c0aa1d$var$tr : t instanceof $2b056e5321c0aa1d$var$ir ? $2b056e5321c0aa1d$var$ir : $2b056e5321c0aa1d$var$Ze)(e - i);
    return r.set(t.subarray(i, e)), r;
}, $2b056e5321c0aa1d$var$wr = function(t, i, e) {
    e <<= 7 & i;
    var r = i / 8 >> 0;
    t[r] |= e, t[r + 1] |= e >>> 8;
}, $2b056e5321c0aa1d$var$yr = function(t, i, e) {
    e <<= 7 & i;
    var r = i / 8 >> 0;
    t[r] |= e, t[r + 1] |= e >>> 8, t[r + 2] |= e >>> 16;
}, $2b056e5321c0aa1d$var$Sr = function(t, i) {
    for(var e = [], r = 0; r < t.length; ++r)t[r] && e.push({
        s: r,
        f: t[r]
    });
    var s = e.length, n = e.slice();
    if (!s) return [
        new $2b056e5321c0aa1d$var$Ze(0),
        0
    ];
    if (1 == s) {
        var o = new $2b056e5321c0aa1d$var$Ze(e[0].s + 1);
        return o[e[0].s] = 1, [
            o,
            1
        ];
    }
    e.sort(function(t, i) {
        return t.f - i.f;
    }), e.push({
        s: -1,
        f: 25001
    });
    var a = e[0], l = e[1], h = 0, u = 1, d = 2;
    for(e[0] = {
        s: -1,
        f: a.f + l.f,
        l: a,
        r: l
    }; u != s - 1;)a = e[e[h].f < e[d].f ? h++ : d++], l = e[h != u && e[h].f < e[d].f ? h++ : d++], e[u++] = {
        s: -1,
        f: a.f + l.f,
        l: a,
        r: l
    };
    var v = n[0].s;
    for(r = 1; r < s; ++r)n[r].s > v && (v = n[r].s);
    var c = new $2b056e5321c0aa1d$var$tr(v + 1), f = $2b056e5321c0aa1d$var$$r(e[u - 1], c, 0);
    if (f > i) {
        r = 0;
        var p = 0, g = f - i, _ = 1 << g;
        for(n.sort(function(t, i) {
            return c[i.s] - c[t.s] || t.f - i.f;
        }); r < s; ++r){
            var m = n[r].s;
            if (!(c[m] > i)) break;
            p += _ - (1 << f - c[m]), c[m] = i;
        }
        for(p >>>= g; p > 0;){
            var b = n[r].s;
            c[b] < i ? p -= 1 << i - c[b]++ - 1 : ++r;
        }
        for(; r >= 0 && p; --r){
            var w = n[r].s;
            c[w] == i && (--c[w], ++p);
        }
        f = i;
    }
    return [
        new $2b056e5321c0aa1d$var$Ze(c),
        f
    ];
}, $2b056e5321c0aa1d$var$$r = function(t, i, e) {
    return -1 == t.s ? Math.max($2b056e5321c0aa1d$var$$r(t.l, i, e + 1), $2b056e5321c0aa1d$var$$r(t.r, i, e + 1)) : i[t.s] = e;
}, $2b056e5321c0aa1d$var$kr = function(t) {
    for(var i = t.length; i && !t[--i];);
    for(var e = new $2b056e5321c0aa1d$var$tr(++i), r = 0, s = t[0], n = 1, o = function(t) {
        e[r++] = t;
    }, a = 1; a <= i; ++a)if (t[a] == s && a != i) ++n;
    else {
        if (!s && n > 2) {
            for(; n > 138; n -= 138)o(32754);
            n > 2 && (o(n > 10 ? n - 11 << 5 | 28690 : n - 3 << 5 | 12305), n = 0);
        } else if (n > 3) {
            for(o(s), --n; n > 6; n -= 6)o(8304);
            n > 2 && (o(n - 3 << 5 | 8208), n = 0);
        }
        for(; n--;)o(s);
        n = 1, s = t[a];
    }
    return [
        e.subarray(0, r),
        i
    ];
}, $2b056e5321c0aa1d$var$xr = function(t, i) {
    for(var e = 0, r = 0; r < i.length; ++r)e += t[r] * i[r];
    return e;
}, $2b056e5321c0aa1d$var$Er = function(t, i, e) {
    var r = e.length, s = $2b056e5321c0aa1d$var$mr(i + 2);
    t[s] = 255 & r, t[s + 1] = r >>> 8, t[s + 2] = 255 ^ t[s], t[s + 3] = 255 ^ t[s + 1];
    for(var n = 0; n < r; ++n)t[s + n + 4] = e[n];
    return 8 * (s + 4 + r);
}, $2b056e5321c0aa1d$var$Ir = function(t, i, e, r, s, n, o, a, l, h, u) {
    $2b056e5321c0aa1d$var$wr(i, u++, e), ++s[256];
    for(var d = $2b056e5321c0aa1d$var$Sr(s, 15), v = d[0], c = d[1], f = $2b056e5321c0aa1d$var$Sr(n, 15), p = f[0], g = f[1], _ = $2b056e5321c0aa1d$var$kr(v), m = _[0], b = _[1], w = $2b056e5321c0aa1d$var$kr(p), y = w[0], S = w[1], $ = new $2b056e5321c0aa1d$var$tr(19), k = 0; k < m.length; ++k)$[31 & m[k]]++;
    for(k = 0; k < y.length; ++k)$[31 & y[k]]++;
    for(var x = $2b056e5321c0aa1d$var$Sr($, 7), E = x[0], I = x[1], P = 19; P > 4 && !E[$2b056e5321c0aa1d$var$sr[P - 1]]; --P);
    var R, T, M, C, O = h + 5 << 3, F = $2b056e5321c0aa1d$var$xr(s, $2b056e5321c0aa1d$var$fr) + $2b056e5321c0aa1d$var$xr(n, $2b056e5321c0aa1d$var$pr) + o, A = $2b056e5321c0aa1d$var$xr(s, v) + $2b056e5321c0aa1d$var$xr(n, p) + o + 14 + 3 * P + $2b056e5321c0aa1d$var$xr($, E) + (2 * $[16] + 3 * $[17] + 7 * $[18]);
    if (O <= F && O <= A) return $2b056e5321c0aa1d$var$Er(i, u, t.subarray(l, l + h));
    if ($2b056e5321c0aa1d$var$wr(i, u, 1 + (A < F)), u += 2, A < F) {
        R = $2b056e5321c0aa1d$var$cr(v, c, 0), T = v, M = $2b056e5321c0aa1d$var$cr(p, g, 0), C = p;
        var D = $2b056e5321c0aa1d$var$cr(E, I, 0);
        $2b056e5321c0aa1d$var$wr(i, u, b - 257), $2b056e5321c0aa1d$var$wr(i, u + 5, S - 1), $2b056e5321c0aa1d$var$wr(i, u + 10, P - 4), u += 14;
        for(k = 0; k < P; ++k)$2b056e5321c0aa1d$var$wr(i, u + 3 * k, E[$2b056e5321c0aa1d$var$sr[k]]);
        u += 3 * P;
        for(var j = [
            m,
            y
        ], L = 0; L < 2; ++L){
            var N = j[L];
            for(k = 0; k < N.length; ++k){
                var z = 31 & N[k];
                $2b056e5321c0aa1d$var$wr(i, u, D[z]), u += E[z], z > 15 && ($2b056e5321c0aa1d$var$wr(i, u, N[k] >>> 5 & 127), u += N[k] >>> 12);
            }
        }
    } else R = $2b056e5321c0aa1d$var$gr, T = $2b056e5321c0aa1d$var$fr, M = $2b056e5321c0aa1d$var$_r, C = $2b056e5321c0aa1d$var$pr;
    for(k = 0; k < a; ++k)if (r[k] > 255) {
        z = r[k] >>> 18 & 31;
        $2b056e5321c0aa1d$var$yr(i, u, R[z + 257]), u += T[z + 257], z > 7 && ($2b056e5321c0aa1d$var$wr(i, u, r[k] >>> 23 & 31), u += $2b056e5321c0aa1d$var$er[z]);
        var U = 31 & r[k];
        $2b056e5321c0aa1d$var$yr(i, u, M[U]), u += C[U], U > 3 && ($2b056e5321c0aa1d$var$yr(i, u, r[k] >>> 5 & 8191), u += $2b056e5321c0aa1d$var$rr[U]);
    } else $2b056e5321c0aa1d$var$yr(i, u, R[r[k]]), u += T[r[k]];
    return $2b056e5321c0aa1d$var$yr(i, u, R[256]), u + T[256];
}, $2b056e5321c0aa1d$var$Pr = new $2b056e5321c0aa1d$var$ir([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]), $2b056e5321c0aa1d$var$Rr = function() {
    for(var t = new $2b056e5321c0aa1d$var$ir(256), i = 0; i < 256; ++i){
        for(var e = i, r = 9; --r;)e = (1 & e && 3988292384) ^ e >>> 1;
        t[i] = e;
    }
    return t;
}(), $2b056e5321c0aa1d$var$Tr = function() {
    var t = 4294967295;
    return {
        p: function(i) {
            for(var e = t, r = 0; r < i.length; ++r)e = $2b056e5321c0aa1d$var$Rr[255 & e ^ i[r]] ^ e >>> 8;
            t = e;
        },
        d: function() {
            return 4294967295 ^ t;
        }
    };
}, $2b056e5321c0aa1d$var$Mr = function(t, i, e, r, s) {
    return function(t, i, e, r, s, n) {
        var o = t.length, a = new $2b056e5321c0aa1d$var$Ze(r + o + 5 * (1 + Math.floor(o / 7e3)) + s), l = a.subarray(r, a.length - s), h = 0;
        if (!i || o < 8) for(var u = 0; u <= o; u += 65535){
            var d = u + 65535;
            d < o ? h = $2b056e5321c0aa1d$var$Er(l, h, t.subarray(u, d)) : (l[u] = n, h = $2b056e5321c0aa1d$var$Er(l, h, t.subarray(u, o)));
        }
        else {
            for(var v = $2b056e5321c0aa1d$var$Pr[i - 1], c = v >>> 13, f = 8191 & v, p = (1 << e) - 1, g = new $2b056e5321c0aa1d$var$tr(32768), _ = new $2b056e5321c0aa1d$var$tr(p + 1), m = Math.ceil(e / 3), b = 2 * m, w = function(i) {
                return (t[i] ^ t[i + 1] << m ^ t[i + 2] << b) & p;
            }, y = new $2b056e5321c0aa1d$var$ir(25e3), S = new $2b056e5321c0aa1d$var$tr(288), $ = new $2b056e5321c0aa1d$var$tr(32), k = 0, x = 0, E = (u = 0, 0), I = 0, P = 0; u < o; ++u){
                var R = w(u), T = 32767 & u, M = _[R];
                if (g[T] = M, _[R] = T, I <= u) {
                    var C = o - u;
                    if ((k > 7e3 || E > 24576) && C > 423) {
                        h = $2b056e5321c0aa1d$var$Ir(t, l, 0, y, S, $, x, E, P, u - P, h), E = k = x = 0, P = u;
                        for(var O = 0; O < 286; ++O)S[O] = 0;
                        for(O = 0; O < 30; ++O)$[O] = 0;
                    }
                    var F = 2, A = 0, D = f, j = T - M & 32767;
                    if (C > 2 && R == w(u - j)) for(var L = Math.min(c, C) - 1, N = Math.min(32767, u), z = Math.min(258, C); j <= N && --D && T != M;){
                        if (t[u + F] == t[u + F - j]) {
                            for(var U = 0; U < z && t[u + U] == t[u + U - j]; ++U);
                            if (U > F) {
                                if (F = U, A = j, U > L) break;
                                var q = Math.min(j, U - 2), B = 0;
                                for(O = 0; O < q; ++O){
                                    var H = u - j + O + 32768 & 32767, W = H - g[H] + 32768 & 32767;
                                    W > B && (B = W, M = H);
                                }
                            }
                        }
                        j += (T = M) - (M = g[T]) + 32768 & 32767;
                    }
                    if (A) {
                        y[E++] = 268435456 | $2b056e5321c0aa1d$var$lr[F] << 18 | $2b056e5321c0aa1d$var$hr[A];
                        var G = 31 & $2b056e5321c0aa1d$var$lr[F], J = 31 & $2b056e5321c0aa1d$var$hr[A];
                        x += $2b056e5321c0aa1d$var$er[G] + $2b056e5321c0aa1d$var$rr[J], ++S[257 + G], ++$[J], I = u + F, ++k;
                    } else y[E++] = t[u], ++S[t[u]];
                }
            }
            h = $2b056e5321c0aa1d$var$Ir(t, l, n, y, S, $, x, E, P, u - P, h);
        }
        return $2b056e5321c0aa1d$var$br(a, 0, r + $2b056e5321c0aa1d$var$mr(h) + s);
    }(t, null == i.level ? 6 : i.level, null == i.mem ? Math.ceil(1.5 * Math.max(8, Math.min(13, Math.log(t.length)))) : 12 + i.mem, e, r, !s);
}, $2b056e5321c0aa1d$var$Cr = function(t, i, e) {
    for(; e; ++i)t[i] = e, e >>>= 8;
}, $2b056e5321c0aa1d$var$Or = function(t, i) {
    var e = i.filename;
    if (t[0] = 31, t[1] = 139, t[2] = 8, t[8] = i.level < 2 ? 4 : 9 == i.level ? 2 : 0, t[9] = 3, 0 != i.mtime && $2b056e5321c0aa1d$var$Cr(t, 4, Math.floor(new Date(i.mtime || Date.now()) / 1e3)), e) {
        t[3] = 8;
        for(var r = 0; r <= e.length; ++r)t[r + 10] = e.charCodeAt(r);
    }
}, $2b056e5321c0aa1d$var$Fr = function(t) {
    return 10 + (t.filename && t.filename.length + 1 || 0);
};
function $2b056e5321c0aa1d$var$Ar(t, i) {
    void 0 === i && (i = {});
    var e = $2b056e5321c0aa1d$var$Tr(), r = t.length;
    e.p(t);
    var s = $2b056e5321c0aa1d$var$Mr(t, i, $2b056e5321c0aa1d$var$Fr(i), 8), n = s.length;
    return $2b056e5321c0aa1d$var$Or(s, i), $2b056e5321c0aa1d$var$Cr(s, n - 8, e.d()), $2b056e5321c0aa1d$var$Cr(s, n - 4, r), s;
}
function $2b056e5321c0aa1d$var$Dr(t, i) {
    var e = t.length;
    if ("undefined" != typeof TextEncoder) return (new TextEncoder).encode(t);
    for(var r = new $2b056e5321c0aa1d$var$Ze(t.length + (t.length >>> 1)), s = 0, n = function(t) {
        r[s++] = t;
    }, o = 0; o < e; ++o){
        if (s + 5 > r.length) {
            var a = new $2b056e5321c0aa1d$var$Ze(s + 8 + (e - o << 1));
            a.set(r), r = a;
        }
        var l = t.charCodeAt(o);
        l < 128 || i ? n(l) : l < 2048 ? (n(192 | l >>> 6), n(128 | 63 & l)) : l > 55295 && l < 57344 ? (n(240 | (l = 65536 + (1047552 & l) | 1023 & t.charCodeAt(++o)) >>> 18), n(128 | l >>> 12 & 63), n(128 | l >>> 6 & 63), n(128 | 63 & l)) : (n(224 | l >>> 12), n(128 | l >>> 6 & 63), n(128 | 63 & l));
    }
    return $2b056e5321c0aa1d$var$br(r, 0, s);
}
function $2b056e5321c0aa1d$var$jr(t, i) {
    return function(t) {
        for(var i = 0, e = 0; e < t.length; e++)i = (i << 5) - i + t.charCodeAt(e), i |= 0;
        return Math.abs(i);
    }(t) % 100 < $2b056e5321c0aa1d$var$Xe(100 * i, 0, 100);
}
var $2b056e5321c0aa1d$var$Lr = "disabled", $2b056e5321c0aa1d$var$Nr = "sampled", $2b056e5321c0aa1d$var$zr = "active", $2b056e5321c0aa1d$var$Ur = "buffering", $2b056e5321c0aa1d$var$qr = "paused", $2b056e5321c0aa1d$var$Br = "trigger", $2b056e5321c0aa1d$var$Hr = $2b056e5321c0aa1d$var$Br + "_activated", $2b056e5321c0aa1d$var$Wr = $2b056e5321c0aa1d$var$Br + "_pending", $2b056e5321c0aa1d$var$Gr = $2b056e5321c0aa1d$var$Br + "_" + $2b056e5321c0aa1d$var$Lr;
function $2b056e5321c0aa1d$var$Jr(t, i) {
    return i.some((i)=>"regex" === i.matching && new RegExp(i.url).test(t));
}
class $2b056e5321c0aa1d$var$Vr {
    constructor(t){
        this.gt = t;
    }
    triggerStatus(t) {
        var i = this.gt.map((i)=>i.triggerStatus(t));
        return i.includes($2b056e5321c0aa1d$var$Hr) ? $2b056e5321c0aa1d$var$Hr : i.includes($2b056e5321c0aa1d$var$Wr) ? $2b056e5321c0aa1d$var$Wr : $2b056e5321c0aa1d$var$Gr;
    }
    stop() {
        this.gt.forEach((t)=>t.stop());
    }
}
class $2b056e5321c0aa1d$var$Kr {
    constructor(t){
        this.gt = t;
    }
    triggerStatus(t) {
        var i = new Set;
        for (var e of this.gt)i.add(e.triggerStatus(t));
        switch(i.delete($2b056e5321c0aa1d$var$Gr), i.size){
            case 0:
                return $2b056e5321c0aa1d$var$Gr;
            case 1:
                return Array.from(i)[0];
            default:
                return $2b056e5321c0aa1d$var$Wr;
        }
    }
    stop() {
        this.gt.forEach((t)=>t.stop());
    }
}
class $2b056e5321c0aa1d$var$Yr {
    triggerStatus() {
        return $2b056e5321c0aa1d$var$Wr;
    }
    stop() {}
}
class $2b056e5321c0aa1d$var$Xr {
    constructor(t){
        this._t = [], this.bt = [], this.urlBlocked = !1, this.N = t;
    }
    onRemoteConfig(t) {
        var i, e;
        this._t = (null == (i = t.sessionRecording) ? void 0 : i.urlTriggers) || [], this.bt = (null == (e = t.sessionRecording) ? void 0 : e.urlBlocklist) || [];
    }
    wt(t) {
        var i;
        return 0 === this._t.length ? $2b056e5321c0aa1d$var$Gr : (null == (i = this.N) ? void 0 : i.get_property($2b056e5321c0aa1d$var$kt)) === t ? $2b056e5321c0aa1d$var$Hr : $2b056e5321c0aa1d$var$Wr;
    }
    triggerStatus(t) {
        var i = this.wt(t), e = i === $2b056e5321c0aa1d$var$Hr ? $2b056e5321c0aa1d$var$Hr : i === $2b056e5321c0aa1d$var$Wr ? $2b056e5321c0aa1d$var$Wr : $2b056e5321c0aa1d$var$Gr;
        return this.N.register_for_session({
            $sdk_debug_replay_url_trigger_status: e
        }), e;
    }
    checkUrlTriggerConditions(t, e, r) {
        if (void 0 !== $2b056e5321c0aa1d$var$i && $2b056e5321c0aa1d$var$i.location.href) {
            var s = $2b056e5321c0aa1d$var$i.location.href, n = this.urlBlocked, o = $2b056e5321c0aa1d$var$Jr(s, this.bt);
            n && o || (o && !n ? t() : !o && n && e(), $2b056e5321c0aa1d$var$Jr(s, this._t) && r("url"));
        }
    }
    stop() {}
}
class $2b056e5321c0aa1d$var$Qr {
    constructor(t){
        this.linkedFlag = null, this.linkedFlagSeen = !1, this.yt = ()=>{}, this.N = t;
    }
    triggerStatus() {
        var t = $2b056e5321c0aa1d$var$Wr;
        return $2b056e5321c0aa1d$var$O(this.linkedFlag) && (t = $2b056e5321c0aa1d$var$Gr), this.linkedFlagSeen && (t = $2b056e5321c0aa1d$var$Hr), this.N.register_for_session({
            $sdk_debug_replay_linked_flag_trigger_status: t
        }), t;
    }
    onRemoteConfig(t, i) {
        var e;
        if (this.linkedFlag = (null == (e = t.sessionRecording) ? void 0 : e.linkedFlag) || null, !$2b056e5321c0aa1d$var$O(this.linkedFlag) && !this.linkedFlagSeen) {
            var r = $2b056e5321c0aa1d$var$T(this.linkedFlag) ? this.linkedFlag : this.linkedFlag.flag, s = $2b056e5321c0aa1d$var$T(this.linkedFlag) ? null : this.linkedFlag.variant;
            this.yt = this.N.onFeatureFlags((t, e)=>{
                var n = $2b056e5321c0aa1d$var$I(e) && r in e, o = s ? e[r] === s : n;
                o && i(r, s), this.linkedFlagSeen = o;
            });
        }
    }
    stop() {
        this.yt();
    }
}
class $2b056e5321c0aa1d$var$Zr {
    constructor(t){
        this.St = [], this.N = t;
    }
    onRemoteConfig(t) {
        var i;
        this.St = (null == (i = t.sessionRecording) ? void 0 : i.eventTriggers) || [];
    }
    $t(t) {
        var i;
        return 0 === this.St.length ? $2b056e5321c0aa1d$var$Gr : (null == (i = this.N) ? void 0 : i.get_property($2b056e5321c0aa1d$var$xt)) === t ? $2b056e5321c0aa1d$var$Hr : $2b056e5321c0aa1d$var$Wr;
    }
    triggerStatus(t) {
        var i = this.$t(t), e = i === $2b056e5321c0aa1d$var$Hr ? $2b056e5321c0aa1d$var$Hr : i === $2b056e5321c0aa1d$var$Wr ? $2b056e5321c0aa1d$var$Wr : $2b056e5321c0aa1d$var$Gr;
        return this.N.register_for_session({
            $sdk_debug_replay_event_trigger_status: e
        }), e;
    }
    stop() {}
}
function $2b056e5321c0aa1d$var$ts(t) {
    return t.isRecordingEnabled ? $2b056e5321c0aa1d$var$Ur : $2b056e5321c0aa1d$var$Lr;
}
function $2b056e5321c0aa1d$var$is(t) {
    if (!t.receivedDecide) return $2b056e5321c0aa1d$var$Ur;
    if (!t.isRecordingEnabled) return $2b056e5321c0aa1d$var$Lr;
    if (t.urlTriggerMatching.urlBlocked) return $2b056e5321c0aa1d$var$qr;
    var i = !0 === t.isSampled, e = new $2b056e5321c0aa1d$var$Vr([
        t.eventTriggerMatching,
        t.urlTriggerMatching,
        t.linkedFlagMatching
    ]).triggerStatus(t.sessionId);
    return i ? $2b056e5321c0aa1d$var$Nr : e === $2b056e5321c0aa1d$var$Hr ? $2b056e5321c0aa1d$var$zr : e === $2b056e5321c0aa1d$var$Wr ? $2b056e5321c0aa1d$var$Ur : !1 === t.isSampled ? $2b056e5321c0aa1d$var$Lr : $2b056e5321c0aa1d$var$zr;
}
function $2b056e5321c0aa1d$var$es(t) {
    if (!t.receivedDecide) return $2b056e5321c0aa1d$var$Ur;
    if (!t.isRecordingEnabled) return $2b056e5321c0aa1d$var$Lr;
    if (t.urlTriggerMatching.urlBlocked) return $2b056e5321c0aa1d$var$qr;
    var i = new $2b056e5321c0aa1d$var$Kr([
        t.eventTriggerMatching,
        t.urlTriggerMatching,
        t.linkedFlagMatching
    ]).triggerStatus(t.sessionId), e = i !== $2b056e5321c0aa1d$var$Gr, r = $2b056e5321c0aa1d$var$A(t.isSampled);
    return e && i === $2b056e5321c0aa1d$var$Wr ? $2b056e5321c0aa1d$var$Ur : e && i === $2b056e5321c0aa1d$var$Gr || r && !t.isSampled ? $2b056e5321c0aa1d$var$Lr : !0 === t.isSampled ? $2b056e5321c0aa1d$var$Nr : $2b056e5321c0aa1d$var$zr;
}
var $2b056e5321c0aa1d$var$rs = "[SessionRecording]", $2b056e5321c0aa1d$var$ss = $2b056e5321c0aa1d$var$z($2b056e5321c0aa1d$var$rs);
function $2b056e5321c0aa1d$var$ns() {
    var t, i;
    return null == $2b056e5321c0aa1d$var$c || null == (t = $2b056e5321c0aa1d$var$c.__PosthogExtensions__) || null == (i = t.rrweb) ? void 0 : i.record;
}
var $2b056e5321c0aa1d$var$os = 3e5, $2b056e5321c0aa1d$var$as = [
    $2b056e5321c0aa1d$var$Ue.MouseMove,
    $2b056e5321c0aa1d$var$Ue.MouseInteraction,
    $2b056e5321c0aa1d$var$Ue.Scroll,
    $2b056e5321c0aa1d$var$Ue.ViewportResize,
    $2b056e5321c0aa1d$var$Ue.Input,
    $2b056e5321c0aa1d$var$Ue.TouchMove,
    $2b056e5321c0aa1d$var$Ue.MediaInteraction,
    $2b056e5321c0aa1d$var$Ue.Drag
], $2b056e5321c0aa1d$var$ls = (t)=>({
        rrwebMethod: t,
        enqueuedAt: Date.now(),
        attempt: 1
    });
function $2b056e5321c0aa1d$var$hs(t) {
    return function(t, i) {
        for(var e = "", r = 0; r < t.length;){
            var s = t[r++];
            s < 128 || i ? e += String.fromCharCode(s) : s < 224 ? e += String.fromCharCode((31 & s) << 6 | 63 & t[r++]) : s < 240 ? e += String.fromCharCode((15 & s) << 12 | (63 & t[r++]) << 6 | 63 & t[r++]) : (s = ((15 & s) << 18 | (63 & t[r++]) << 12 | (63 & t[r++]) << 6 | 63 & t[r++]) - 65536, e += String.fromCharCode(55296 | s >> 10, 56320 | 1023 & s));
        }
        return e;
    }($2b056e5321c0aa1d$var$Ar($2b056e5321c0aa1d$var$Dr(JSON.stringify(t))), !0);
}
function $2b056e5321c0aa1d$var$us(t) {
    return t.type === $2b056e5321c0aa1d$var$ze.Custom && "sessionIdle" === t.data.tag;
}
class $2b056e5321c0aa1d$var$ds {
    get sessionId() {
        return this.kt;
    }
    get xt() {
        return this.N.config.session_recording.session_idle_threshold_ms || 3e5;
    }
    get started() {
        return this.Et;
    }
    get It() {
        if (!this.N.sessionManager) throw new Error($2b056e5321c0aa1d$var$rs + " must be started with a valid sessionManager.");
        return this.N.sessionManager;
    }
    get Pt() {
        var t, i;
        return this.Rt.triggerStatus(this.sessionId) === $2b056e5321c0aa1d$var$Wr ? 6e4 : null !== (t = null == (i = this.N.config.session_recording) ? void 0 : i.full_snapshot_interval_millis) && void 0 !== t ? t : $2b056e5321c0aa1d$var$os;
    }
    get Tt() {
        var t = this.N.get_property($2b056e5321c0aa1d$var$$t);
        return $2b056e5321c0aa1d$var$A(t) ? t : null;
    }
    get Mt() {
        var t, i, e = null == (t = this.M) ? void 0 : t.data[(null == (i = this.M) ? void 0 : i.data.length) - 1], { sessionStartTimestamp: r } = this.It.checkAndGetSessionAndWindowId(!0);
        return e ? e.timestamp - r : null;
    }
    get Ct() {
        var t = !!this.N.get_property($2b056e5321c0aa1d$var$ft), e = !this.N.config.disable_session_recording;
        return $2b056e5321c0aa1d$var$i && t && e;
    }
    get Ot() {
        var t = !!this.N.get_property($2b056e5321c0aa1d$var$pt), i = this.N.config.enable_recording_console_log;
        return null != i ? i : t;
    }
    get Ft() {
        var t, i, e, r, s, n, o = this.N.config.session_recording.captureCanvas, a = this.N.get_property($2b056e5321c0aa1d$var$mt), l = null !== (t = null !== (i = null == o ? void 0 : o.recordCanvas) && void 0 !== i ? i : null == a ? void 0 : a.enabled) && void 0 !== t && t, h = null !== (e = null !== (r = null == o ? void 0 : o.canvasFps) && void 0 !== r ? r : null == a ? void 0 : a.fps) && void 0 !== e ? e : 4, u = null !== (s = null !== (n = null == o ? void 0 : o.canvasQuality) && void 0 !== n ? n : null == a ? void 0 : a.quality) && void 0 !== s ? s : .4;
        if ("string" == typeof u) {
            var d = parseFloat(u);
            u = isNaN(d) ? .4 : d;
        }
        return {
            enabled: l,
            fps: $2b056e5321c0aa1d$var$Xe(h, 0, 12, "canvas recording fps", 4),
            quality: $2b056e5321c0aa1d$var$Xe(u, 0, 1, "canvas recording quality", .4)
        };
    }
    get At() {
        var t, i, e = this.N.get_property($2b056e5321c0aa1d$var$gt), r = {
            recordHeaders: null == (t = this.N.config.session_recording) ? void 0 : t.recordHeaders,
            recordBody: null == (i = this.N.config.session_recording) ? void 0 : i.recordBody
        }, s = (null == r ? void 0 : r.recordHeaders) || (null == e ? void 0 : e.recordHeaders), n = (null == r ? void 0 : r.recordBody) || (null == e ? void 0 : e.recordBody), o = $2b056e5321c0aa1d$var$I(this.N.config.capture_performance) ? this.N.config.capture_performance.network_timing : this.N.config.capture_performance, a = !!($2b056e5321c0aa1d$var$A(o) ? o : null == e ? void 0 : e.capturePerformance);
        return s || n || a ? {
            recordHeaders: s,
            recordBody: n,
            recordPerformance: a
        } : void 0;
    }
    get Dt() {
        var t, i, e, r, s, n, o = this.N.get_property($2b056e5321c0aa1d$var$_t), a = {
            maskAllInputs: null == (t = this.N.config.session_recording) ? void 0 : t.maskAllInputs,
            maskTextSelector: null == (i = this.N.config.session_recording) ? void 0 : i.maskTextSelector,
            blockSelector: null == (e = this.N.config.session_recording) ? void 0 : e.blockSelector
        }, l = null !== (r = null == a ? void 0 : a.maskAllInputs) && void 0 !== r ? r : null == o ? void 0 : o.maskAllInputs, h = null !== (s = null == a ? void 0 : a.maskTextSelector) && void 0 !== s ? s : null == o ? void 0 : o.maskTextSelector, u = null !== (n = null == a ? void 0 : a.blockSelector) && void 0 !== n ? n : null == o ? void 0 : o.blockSelector;
        return $2b056e5321c0aa1d$var$R(l) && $2b056e5321c0aa1d$var$R(h) && $2b056e5321c0aa1d$var$R(u) ? void 0 : {
            maskAllInputs: null == l || l,
            maskTextSelector: h,
            blockSelector: u
        };
    }
    get jt() {
        var t = this.N.get_property($2b056e5321c0aa1d$var$bt);
        return $2b056e5321c0aa1d$var$F(t) ? t : null;
    }
    get Lt() {
        var t = this.N.get_property($2b056e5321c0aa1d$var$wt);
        return $2b056e5321c0aa1d$var$F(t) ? t : null;
    }
    get status() {
        return this.Nt ? this.zt({
            receivedDecide: this.Nt,
            isRecordingEnabled: this.Ct,
            isSampled: this.Tt,
            urlTriggerMatching: this.Ut,
            eventTriggerMatching: this.qt,
            linkedFlagMatching: this.Bt,
            sessionId: this.sessionId
        }) : $2b056e5321c0aa1d$var$Ur;
    }
    constructor(t){
        if (this.zt = $2b056e5321c0aa1d$var$ts, this.Nt = !1, this.Ht = [], this.Wt = "unknown", this.Gt = Date.now(), this.Rt = new $2b056e5321c0aa1d$var$Yr, this.Jt = void 0, this.Vt = void 0, this.Kt = void 0, this.Yt = void 0, this.Xt = void 0, this._forceAllowLocalhostNetworkCapture = !1, this.Qt = ()=>{
            this.Zt();
        }, this.ti = ()=>{
            this.ii("browser offline", {});
        }, this.ei = ()=>{
            this.ii("browser online", {});
        }, this.ri = ()=>{
            if (null != $2b056e5321c0aa1d$var$a && $2b056e5321c0aa1d$var$a.visibilityState) {
                var t = "window " + $2b056e5321c0aa1d$var$a.visibilityState;
                this.ii(t, {});
            }
        }, this.N = t, this.Et = !1, this.si = "/s/", this.ni = void 0, this.Nt = !1, !this.N.sessionManager) throw $2b056e5321c0aa1d$var$ss.error("started without valid sessionManager"), new Error($2b056e5321c0aa1d$var$rs + " started without valid sessionManager. This is a bug.");
        if (this.N.config.__preview_experimental_cookieless_mode) throw new Error($2b056e5321c0aa1d$var$rs + " cannot be used with __preview_experimental_cookieless_mode.");
        this.Bt = new $2b056e5321c0aa1d$var$Qr(this.N), this.Ut = new $2b056e5321c0aa1d$var$Xr(this.N), this.qt = new $2b056e5321c0aa1d$var$Zr(this.N);
        var { sessionId: i, windowId: e } = this.It.checkAndGetSessionAndWindowId();
        this.kt = i, this.oi = e, this.M = this.ai(), this.xt >= this.It.sessionTimeoutMs && $2b056e5321c0aa1d$var$ss.warn("session_idle_threshold_ms (" + this.xt + ") is greater than the session timeout (" + this.It.sessionTimeoutMs + "). Session will never be detected as idle");
    }
    startIfEnabledOrStop(t) {
        this.Ct ? (this.li(t), $2b056e5321c0aa1d$var$st($2b056e5321c0aa1d$var$i, "beforeunload", this.Qt), $2b056e5321c0aa1d$var$st($2b056e5321c0aa1d$var$i, "offline", this.ti), $2b056e5321c0aa1d$var$st($2b056e5321c0aa1d$var$i, "online", this.ei), $2b056e5321c0aa1d$var$st($2b056e5321c0aa1d$var$i, "visibilitychange", this.ri), this.hi(), this.ui(), $2b056e5321c0aa1d$var$O(this.Jt) && (this.Jt = this.N.on("eventCaptured", (t)=>{
            try {
                if ("$pageview" === t.event) {
                    var i = null != t && t.properties.$current_url ? this.di(null == t ? void 0 : t.properties.$current_url) : "";
                    if (!i) return;
                    this.ii("$pageview", {
                        href: i
                    });
                }
            } catch (t) {
                $2b056e5321c0aa1d$var$ss.error("Could not add $pageview to rrweb session", t);
            }
        })), this.Vt || (this.Vt = this.It.onSessionId((t, i, e)=>{
            var r, s, n, o;
            e && (this.ii("$session_id_change", {
                sessionId: t,
                windowId: i,
                changeReason: e
            }), null == (r = this.N) || null == (s = r.persistence) || s.unregister($2b056e5321c0aa1d$var$xt), null == (n = this.N) || null == (o = n.persistence) || o.unregister($2b056e5321c0aa1d$var$kt));
        }))) : this.stopRecording();
    }
    stopRecording() {
        var t, e, r, s;
        this.Et && this.ni && (this.ni(), this.ni = void 0, this.Et = !1, null == $2b056e5321c0aa1d$var$i || $2b056e5321c0aa1d$var$i.removeEventListener("beforeunload", this.Qt), null == $2b056e5321c0aa1d$var$i || $2b056e5321c0aa1d$var$i.removeEventListener("offline", this.ti), null == $2b056e5321c0aa1d$var$i || $2b056e5321c0aa1d$var$i.removeEventListener("online", this.ei), null == $2b056e5321c0aa1d$var$i || $2b056e5321c0aa1d$var$i.removeEventListener("visibilitychange", this.ri), this.ai(), clearInterval(this.vi), null == (t = this.Jt) || t.call(this), this.Jt = void 0, null == (e = this.Xt) || e.call(this), this.Xt = void 0, null == (r = this.Vt) || r.call(this), this.Vt = void 0, null == (s = this.Yt) || s.call(this), this.Yt = void 0, this.qt.stop(), this.Ut.stop(), this.Bt.stop(), $2b056e5321c0aa1d$var$ss.info("stopped"));
    }
    ci() {
        var t;
        null == (t = this.N.persistence) || t.unregister($2b056e5321c0aa1d$var$$t);
    }
    fi(t) {
        var i, e = this.kt !== t, r = this.jt;
        if ($2b056e5321c0aa1d$var$F(r)) {
            var s = this.Tt, n = e || !$2b056e5321c0aa1d$var$A(s), o = n ? $2b056e5321c0aa1d$var$jr(t, r) : s;
            n && (o ? this.pi($2b056e5321c0aa1d$var$Nr) : $2b056e5321c0aa1d$var$ss.warn("Sample rate (" + r + ") has determined that this sessionId (" + t + ") will not be sent to the server."), this.ii("samplingDecisionMade", {
                sampleRate: r,
                isSampled: o
            })), null == (i = this.N.persistence) || i.register({
                [$2b056e5321c0aa1d$var$$t]: o
            });
        } else this.ci();
    }
    onRemoteConfig(t) {
        var i, e, r, s;
        (this.ii("$remote_config_received", t), this.gi(t), null != (i = t.sessionRecording) && i.endpoint) && (this.si = null == (s = t.sessionRecording) ? void 0 : s.endpoint);
        this.hi(), "any" === (null == (e = t.sessionRecording) ? void 0 : e.triggerMatchType) ? (this.zt = $2b056e5321c0aa1d$var$is, this.Rt = new $2b056e5321c0aa1d$var$Vr([
            this.qt,
            this.Ut
        ])) : (this.zt = $2b056e5321c0aa1d$var$es, this.Rt = new $2b056e5321c0aa1d$var$Kr([
            this.qt,
            this.Ut
        ])), this.N.register_for_session({
            $sdk_debug_replay_remote_trigger_matching_config: null == (r = t.sessionRecording) ? void 0 : r.triggerMatchType
        }), this.Ut.onRemoteConfig(t), this.qt.onRemoteConfig(t), this.Bt.onRemoteConfig(t, (t, i)=>{
            this.pi("linked_flag_matched", {
                flag: t,
                variant: i
            });
        }), this.Nt = !0, this.startIfEnabledOrStop();
    }
    hi() {
        $2b056e5321c0aa1d$var$F(this.jt) && $2b056e5321c0aa1d$var$O(this.Yt) && (this.Yt = this.It.onSessionId((t)=>{
            this.fi(t);
        }));
    }
    gi(t) {
        if (this.N.persistence) {
            var i, e = this.N.persistence, r = ()=>{
                var i, r, s, n, o, a, l, h, u, d = null == (i = t.sessionRecording) ? void 0 : i.sampleRate, v = $2b056e5321c0aa1d$var$O(d) ? null : parseFloat(d);
                $2b056e5321c0aa1d$var$O(v) && this.ci();
                var c = null == (r = t.sessionRecording) ? void 0 : r.minimumDurationMilliseconds;
                e.register({
                    [$2b056e5321c0aa1d$var$ft]: !!t.sessionRecording,
                    [$2b056e5321c0aa1d$var$pt]: null == (s = t.sessionRecording) ? void 0 : s.consoleLogRecordingEnabled,
                    [$2b056e5321c0aa1d$var$gt]: $2b056e5321c0aa1d$var$B({
                        capturePerformance: t.capturePerformance
                    }, null == (n = t.sessionRecording) ? void 0 : n.networkPayloadCapture),
                    [$2b056e5321c0aa1d$var$_t]: null == (o = t.sessionRecording) ? void 0 : o.masking,
                    [$2b056e5321c0aa1d$var$mt]: {
                        enabled: null == (a = t.sessionRecording) ? void 0 : a.recordCanvas,
                        fps: null == (l = t.sessionRecording) ? void 0 : l.canvasFps,
                        quality: null == (h = t.sessionRecording) ? void 0 : h.canvasQuality
                    },
                    [$2b056e5321c0aa1d$var$bt]: v,
                    [$2b056e5321c0aa1d$var$wt]: $2b056e5321c0aa1d$var$R(c) ? null : c,
                    [$2b056e5321c0aa1d$var$yt]: null == (u = t.sessionRecording) ? void 0 : u.scriptConfig
                });
            };
            r(), null == (i = this.Kt) || i.call(this), this.Kt = this.It.onSessionId(r);
        }
    }
    log(t, i) {
        var e;
        void 0 === i && (i = "log"), null == (e = this.N.sessionRecording) || e.onRRwebEmit({
            type: 6,
            data: {
                plugin: "rrweb/console@1",
                payload: {
                    level: i,
                    trace: [],
                    payload: [
                        JSON.stringify(t)
                    ]
                }
            },
            timestamp: Date.now()
        });
    }
    li(t) {
        if (!$2b056e5321c0aa1d$var$R(Object.assign) && !$2b056e5321c0aa1d$var$R(Array.from) && !(this.Et || this.N.config.disable_session_recording || this.N.consent.isOptedOut())) {
            var i;
            if (this.Et = !0, this.It.checkAndGetSessionAndWindowId(), $2b056e5321c0aa1d$var$ns()) this.mi();
            else null == (i = $2b056e5321c0aa1d$var$c.__PosthogExtensions__) || null == i.loadExternalDependency || i.loadExternalDependency(this.N, this.bi, (t)=>{
                if (t) return $2b056e5321c0aa1d$var$ss.error("could not load recorder", t);
                this.mi();
            });
            $2b056e5321c0aa1d$var$ss.info("starting"), this.status === $2b056e5321c0aa1d$var$zr && this.pi(t || "recording_initialized");
        }
    }
    get bi() {
        var t, i, e;
        return (null == (t = this.N) || null == (i = t.persistence) || null == (e = i.get_property($2b056e5321c0aa1d$var$yt)) ? void 0 : e.script) || "recorder";
    }
    wi(t) {
        var i;
        return 3 === t.type && -1 !== $2b056e5321c0aa1d$var$as.indexOf(null == (i = t.data) ? void 0 : i.source);
    }
    yi(t) {
        var i = this.wi(t);
        i || this.Wt || t.timestamp - this.Gt > this.xt && (this.Wt = !0, clearInterval(this.vi), this.ii("sessionIdle", {
            eventTimestamp: t.timestamp,
            lastActivityTimestamp: this.Gt,
            threshold: this.xt,
            bufferLength: this.M.data.length,
            bufferSize: this.M.size
        }), this.Zt());
        var e = !1;
        if (i && (this.Gt = t.timestamp, this.Wt)) {
            var r = "unknown" === this.Wt;
            this.Wt = !1, r || (this.ii("sessionNoLongerIdle", {
                reason: "user activity",
                type: t.type
            }), e = !0);
        }
        if (!this.Wt) {
            var { windowId: s, sessionId: n } = this.It.checkAndGetSessionAndWindowId(!i, t.timestamp), o = this.kt !== n, a = this.oi !== s;
            this.oi = s, this.kt = n, o || a ? (this.stopRecording(), this.startIfEnabledOrStop("session_id_changed")) : e && this.Si();
        }
    }
    $i(t) {
        try {
            return t.rrwebMethod(), !0;
        } catch (i) {
            return this.Ht.length < 10 ? this.Ht.push({
                enqueuedAt: t.enqueuedAt || Date.now(),
                attempt: t.attempt++,
                rrwebMethod: t.rrwebMethod
            }) : $2b056e5321c0aa1d$var$ss.warn("could not emit queued rrweb event.", i, t), !1;
        }
    }
    ii(t, i) {
        return this.$i($2b056e5321c0aa1d$var$ls(()=>$2b056e5321c0aa1d$var$ns().addCustomEvent(t, i)));
    }
    ki() {
        return this.$i($2b056e5321c0aa1d$var$ls(()=>$2b056e5321c0aa1d$var$ns().takeFullSnapshot()));
    }
    mi() {
        var t, i, e, r, s = {
            blockClass: "ph-no-capture",
            blockSelector: void 0,
            ignoreClass: "ph-ignore-input",
            maskTextClass: "ph-mask",
            maskTextSelector: void 0,
            maskTextFn: void 0,
            maskAllInputs: !0,
            maskInputOptions: {
                password: !0
            },
            maskInputFn: void 0,
            slimDOMOptions: {},
            collectFonts: !1,
            inlineStylesheet: !0,
            recordCrossOriginIframes: !1
        }, n = this.N.config.session_recording;
        for (var [o, a] of Object.entries(n || {}))o in s && ("maskInputOptions" === o ? s.maskInputOptions = $2b056e5321c0aa1d$var$B({
            password: !0
        }, a) : s[o] = a);
        (this.Ft && this.Ft.enabled && (s.recordCanvas = !0, s.sampling = {
            canvas: this.Ft.fps
        }, s.dataURLOptions = {
            type: "image/webp",
            quality: this.Ft.quality
        }), this.Dt) && (s.maskAllInputs = null === (i = this.Dt.maskAllInputs) || void 0 === i || i, s.maskTextSelector = null !== (e = this.Dt.maskTextSelector) && void 0 !== e ? e : void 0, s.blockSelector = null !== (r = this.Dt.blockSelector) && void 0 !== r ? r : void 0);
        var l = $2b056e5321c0aa1d$var$ns();
        if (l) {
            this.xi = null !== (t = this.xi) && void 0 !== t ? t : new $2b056e5321c0aa1d$var$Qe(l, {
                refillRate: this.N.config.session_recording.__mutationRateLimiterRefillRate,
                bucketSize: this.N.config.session_recording.__mutationRateLimiterBucketSize,
                onBlockedNode: (t, i)=>{
                    var e = "Too many mutations on node '" + t + "'. Rate limiting. This could be due to SVG animations or something similar";
                    $2b056e5321c0aa1d$var$ss.info(e, {
                        node: i
                    }), this.log($2b056e5321c0aa1d$var$rs + " " + e, "warn");
                }
            });
            var h = this.Ei();
            this.ni = l($2b056e5321c0aa1d$var$B({
                emit: (t)=>{
                    this.onRRwebEmit(t);
                },
                plugins: h
            }, s)), this.Gt = Date.now(), this.Wt = $2b056e5321c0aa1d$var$A(this.Wt) ? this.Wt : "unknown", this.ii("$session_options", {
                sessionRecordingOptions: s,
                activePlugins: h.map((t)=>null == t ? void 0 : t.name)
            }), this.ii("$posthog_config", {
                config: this.N.config
            });
        } else $2b056e5321c0aa1d$var$ss.error("onScriptLoaded was called but rrwebRecord is not available. This indicates something has gone wrong.");
    }
    Si() {
        if (this.vi && clearInterval(this.vi), !0 !== this.Wt) {
            var t = this.Pt;
            t && (this.vi = setInterval(()=>{
                this.ki();
            }, t));
        }
    }
    Ei() {
        var t, i, e, r, s = [], n = null == (t = $2b056e5321c0aa1d$var$c.__PosthogExtensions__) || null == (i = t.rrwebPlugins) ? void 0 : i.getRecordConsolePlugin;
        n && this.Ot && s.push(n());
        var o = null == (e = $2b056e5321c0aa1d$var$c.__PosthogExtensions__) || null == (r = e.rrwebPlugins) ? void 0 : r.getRecordNetworkPlugin;
        this.At && $2b056e5321c0aa1d$var$E(o) && (!$2b056e5321c0aa1d$var$bi.includes(location.hostname) || this._forceAllowLocalhostNetworkCapture ? s.push(o($2b056e5321c0aa1d$var$Ye(this.N.config, this.At))) : $2b056e5321c0aa1d$var$ss.info("NetworkCapture not started because we are on localhost."));
        return s;
    }
    onRRwebEmit(t) {
        var i;
        if (this.Ii(), t && $2b056e5321c0aa1d$var$I(t)) {
            if (t.type === $2b056e5321c0aa1d$var$ze.Meta) {
                var e = this.di(t.data.href);
                if (this.Pi = e, !e) return;
                t.data.href = e;
            } else this.Ri();
            if (this.Ut.checkUrlTriggerConditions(()=>this.Ti(), ()=>this.Mi(), (t)=>this.Ci(t)), !this.Ut.urlBlocked || (r = t).type === $2b056e5321c0aa1d$var$ze.Custom && "recording paused" === r.data.tag) {
                var r;
                t.type === $2b056e5321c0aa1d$var$ze.FullSnapshot && this.Si(), t.type === $2b056e5321c0aa1d$var$ze.FullSnapshot && this.Nt && this.Rt.triggerStatus(this.sessionId) === $2b056e5321c0aa1d$var$Wr && this.ai();
                var s = this.xi ? this.xi.throttleMutations(t) : t;
                if (s) {
                    var n = function(t) {
                        var i = t;
                        if (i && $2b056e5321c0aa1d$var$I(i) && 6 === i.type && $2b056e5321c0aa1d$var$I(i.data) && "rrweb/console@1" === i.data.plugin) {
                            i.data.payload.payload.length > 10 && (i.data.payload.payload = i.data.payload.payload.slice(0, 10), i.data.payload.payload.push("...[truncated]"));
                            for(var e = [], r = 0; r < i.data.payload.payload.length; r++)i.data.payload.payload[r] && i.data.payload.payload[r].length > 2e3 ? e.push(i.data.payload.payload[r].slice(0, 2e3) + "...[truncated]") : e.push(i.data.payload.payload[r]);
                            return i.data.payload.payload = e, t;
                        }
                        return t;
                    }(s);
                    if (this.yi(n), !0 !== this.Wt || $2b056e5321c0aa1d$var$us(n)) {
                        if ($2b056e5321c0aa1d$var$us(n)) {
                            var o = n.data.payload;
                            if (o) {
                                var a = o.lastActivityTimestamp, l = o.threshold;
                                n.timestamp = a + l;
                            }
                        }
                        var h = null === (i = this.N.config.session_recording.compress_events) || void 0 === i || i ? function(t) {
                            if ($2b056e5321c0aa1d$var$Le(t) < 1024) return t;
                            try {
                                if (t.type === $2b056e5321c0aa1d$var$ze.FullSnapshot) return $2b056e5321c0aa1d$var$B({}, t, {
                                    data: $2b056e5321c0aa1d$var$hs(t.data),
                                    cv: "2024-10"
                                });
                                if (t.type === $2b056e5321c0aa1d$var$ze.IncrementalSnapshot && t.data.source === $2b056e5321c0aa1d$var$Ue.Mutation) return $2b056e5321c0aa1d$var$B({}, t, {
                                    cv: "2024-10",
                                    data: $2b056e5321c0aa1d$var$B({}, t.data, {
                                        texts: $2b056e5321c0aa1d$var$hs(t.data.texts),
                                        attributes: $2b056e5321c0aa1d$var$hs(t.data.attributes),
                                        removes: $2b056e5321c0aa1d$var$hs(t.data.removes),
                                        adds: $2b056e5321c0aa1d$var$hs(t.data.adds)
                                    })
                                });
                                if (t.type === $2b056e5321c0aa1d$var$ze.IncrementalSnapshot && t.data.source === $2b056e5321c0aa1d$var$Ue.StyleSheetRule) return $2b056e5321c0aa1d$var$B({}, t, {
                                    cv: "2024-10",
                                    data: $2b056e5321c0aa1d$var$B({}, t.data, {
                                        adds: t.data.adds ? $2b056e5321c0aa1d$var$hs(t.data.adds) : void 0,
                                        removes: t.data.removes ? $2b056e5321c0aa1d$var$hs(t.data.removes) : void 0
                                    })
                                });
                            } catch (t) {
                                $2b056e5321c0aa1d$var$ss.error("could not compress event - will use uncompressed event", t);
                            }
                            return t;
                        }(n) : n, u = {
                            $snapshot_bytes: $2b056e5321c0aa1d$var$Le(h),
                            $snapshot_data: h,
                            $session_id: this.kt,
                            $window_id: this.oi
                        };
                        this.status !== $2b056e5321c0aa1d$var$Lr ? this.Oi(u) : this.ai();
                    }
                }
            }
        }
    }
    Ri() {
        if (!this.N.config.capture_pageview && $2b056e5321c0aa1d$var$i) {
            var t = this.di($2b056e5321c0aa1d$var$i.location.href);
            this.Pi !== t && (this.ii("$url_changed", {
                href: t
            }), this.Pi = t);
        }
    }
    Ii() {
        if (this.Ht.length) {
            var t = [
                ...this.Ht
            ];
            this.Ht = [], t.forEach((t)=>{
                Date.now() - t.enqueuedAt <= 2e3 && this.$i(t);
            });
        }
    }
    di(t) {
        var i = this.N.config.session_recording;
        if (i.maskNetworkRequestFn) {
            var e, r = {
                url: t
            };
            return null == (e = r = i.maskNetworkRequestFn(r)) ? void 0 : e.url;
        }
        return t;
    }
    ai() {
        return this.M = {
            size: 0,
            data: [],
            sessionId: this.kt,
            windowId: this.oi
        }, this.M;
    }
    Zt() {
        this.Fi && (clearTimeout(this.Fi), this.Fi = void 0);
        var t = this.Lt, i = this.Mt, e = $2b056e5321c0aa1d$var$F(i) && i >= 0, r = $2b056e5321c0aa1d$var$F(t) && e && i < t;
        if (this.status === $2b056e5321c0aa1d$var$Ur || this.status === $2b056e5321c0aa1d$var$qr || this.status === $2b056e5321c0aa1d$var$Lr || r) return this.Fi = setTimeout(()=>{
            this.Zt();
        }, 2e3), this.M;
        this.M.data.length > 0 && $2b056e5321c0aa1d$var$Ne(this.M).forEach((t)=>{
            this.Ai({
                $snapshot_bytes: t.size,
                $snapshot_data: t.data,
                $session_id: t.sessionId,
                $window_id: t.windowId,
                $lib: "web",
                $lib_version: $2b056e5321c0aa1d$var$f.LIB_VERSION
            });
        });
        return this.ai();
    }
    Oi(t) {
        var i, e = 2 + ((null == (i = this.M) ? void 0 : i.data.length) || 0);
        !this.Wt && (this.M.size + t.$snapshot_bytes + e > 943718.4 || this.M.sessionId !== this.kt) && (this.M = this.Zt()), this.M.size += t.$snapshot_bytes, this.M.data.push(t.$snapshot_data), this.Fi || this.Wt || (this.Fi = setTimeout(()=>{
            this.Zt();
        }, 2e3));
    }
    Ai(t) {
        this.N.capture("$snapshot", t, {
            _url: this.N.requestRouter.endpointFor("api", this.si),
            _noTruncate: !0,
            _batchKey: "recordings",
            skip_client_rate_limiting: !0
        });
    }
    Ci(t) {
        var i, e;
        this.Rt.triggerStatus(this.sessionId) === $2b056e5321c0aa1d$var$Wr && (null == (i = this.N) || null == (e = i.persistence) || e.register({
            ["url" === t ? $2b056e5321c0aa1d$var$kt : $2b056e5321c0aa1d$var$xt]: this.kt
        }), this.Zt(), this.pi(t + "_trigger_matched"));
    }
    Ti() {
        this.Ut.urlBlocked || (this.Ut.urlBlocked = !0, clearInterval(this.vi), $2b056e5321c0aa1d$var$ss.info("recording paused due to URL blocker"), this.ii("recording paused", {
            reason: "url blocker"
        }));
    }
    Mi() {
        this.Ut.urlBlocked && (this.Ut.urlBlocked = !1, this.ki(), this.Si(), this.ii("recording resumed", {
            reason: "left blocked url"
        }), $2b056e5321c0aa1d$var$ss.info("recording resumed"));
    }
    ui() {
        0 !== this.qt.St.length && $2b056e5321c0aa1d$var$O(this.Xt) && (this.Xt = this.N.on("eventCaptured", (t)=>{
            try {
                this.qt.St.includes(t.event) && this.Ci("event");
            } catch (t) {
                $2b056e5321c0aa1d$var$ss.error("Could not activate event trigger", t);
            }
        }));
    }
    overrideLinkedFlag() {
        this.Bt.linkedFlagSeen = !0, this.ki(), this.pi("linked_flag_overridden");
    }
    overrideSampling() {
        var t;
        null == (t = this.N.persistence) || t.register({
            [$2b056e5321c0aa1d$var$$t]: !0
        }), this.ki(), this.pi("sampling_overridden");
    }
    overrideTrigger(t) {
        this.Ci(t);
    }
    pi(t, i) {
        this.N.register_for_session({
            $session_recording_start_reason: t
        }), $2b056e5321c0aa1d$var$ss.info(t.replace("_", " "), i), $2b056e5321c0aa1d$var$m([
            "recording_initialized",
            "session_id_changed"
        ], t) || this.ii(t, i);
    }
    get sdkDebugProperties() {
        var { sessionStartTimestamp: t } = this.It.checkAndGetSessionAndWindowId(!0);
        return {
            $recording_status: this.status,
            $sdk_debug_replay_internal_buffer_length: this.M.data.length,
            $sdk_debug_replay_internal_buffer_size: this.M.size,
            $sdk_debug_current_session_duration: this.Mt,
            $sdk_debug_session_start: t
        };
    }
}
var $2b056e5321c0aa1d$var$vs = $2b056e5321c0aa1d$var$z("[SegmentIntegration]");
function $2b056e5321c0aa1d$var$cs(t, i) {
    var e = t.config.segment;
    if (!e) return i();
    !function(t, i) {
        var e = t.config.segment;
        if (!e) return i();
        var r = (e)=>{
            var r = ()=>e.anonymousId() || $2b056e5321c0aa1d$var$ji();
            t.config.get_device_id = r, e.id() && (t.register({
                distinct_id: e.id(),
                $device_id: r()
            }), t.persistence.set_property($2b056e5321c0aa1d$var$Ft, "identified")), i();
        }, s = e.user();
        "then" in s && $2b056e5321c0aa1d$var$E(s.then) ? s.then((t)=>r(t)) : r(s);
    }(t, ()=>{
        e.register(((t)=>{
            Promise && Promise.resolve || $2b056e5321c0aa1d$var$vs.warn("This browser does not have Promise support, and can not use the segment integration");
            var i = (i, e)=>{
                var r;
                if (!e) return i;
                i.event.userId || i.event.anonymousId === t.get_distinct_id() || ($2b056e5321c0aa1d$var$vs.info("No userId set, resetting PostHog"), t.reset()), i.event.userId && i.event.userId !== t.get_distinct_id() && ($2b056e5321c0aa1d$var$vs.info("UserId set, identifying with PostHog"), t.identify(i.event.userId));
                var s = t.Di(e, null !== (r = i.event.properties) && void 0 !== r ? r : {}, new Date);
                return i.event.properties = Object.assign({}, s, i.event.properties), i;
            };
            return {
                name: "PostHog JS",
                type: "enrichment",
                version: "1.0.0",
                isLoaded: ()=>!0,
                load: ()=>Promise.resolve(),
                track: (t)=>i(t, t.event.event),
                page: (t)=>i(t, "$pageview"),
                identify: (t)=>i(t, "$identify"),
                screen: (t)=>i(t, "$screen")
            };
        })(t)).then(()=>{
            i();
        });
    });
}
var $2b056e5321c0aa1d$var$fs = "posthog-js";
function $2b056e5321c0aa1d$var$ps(t, i) {
    var { organization: e, projectId: r, prefix: s, severityAllowList: n = [
        "error"
    ] } = void 0 === i ? {} : i;
    return (i)=>{
        var o, a, l, h, u;
        if (!("*" === n || n.includes(i.level)) || !t.__loaded) return i;
        i.tags || (i.tags = {});
        var d = t.requestRouter.endpointFor("ui", "/project/" + t.config.token + "/person/" + t.get_distinct_id());
        i.tags["PostHog Person URL"] = d, t.sessionRecordingStarted() && (i.tags["PostHog Recording URL"] = t.get_session_replay_url({
            withTimestamp: !0
        }));
        var v = (null == (o = i.exception) ? void 0 : o.values) || [], c = v.map((t)=>$2b056e5321c0aa1d$var$B({}, t, {
                stacktrace: t.stacktrace ? $2b056e5321c0aa1d$var$B({}, t.stacktrace, {
                    type: "raw",
                    frames: (t.stacktrace.frames || []).map((t)=>$2b056e5321c0aa1d$var$B({}, t, {
                            platform: "web:javascript"
                        }))
                }) : void 0
            })), f = {
            $exception_message: (null == (a = v[0]) ? void 0 : a.value) || i.message,
            $exception_type: null == (l = v[0]) ? void 0 : l.type,
            $exception_personURL: d,
            $exception_level: i.level,
            $exception_list: c,
            $sentry_event_id: i.event_id,
            $sentry_exception: i.exception,
            $sentry_exception_message: (null == (h = v[0]) ? void 0 : h.value) || i.message,
            $sentry_exception_type: null == (u = v[0]) ? void 0 : u.type,
            $sentry_tags: i.tags
        };
        return e && r && (f.$sentry_url = (s || "https://sentry.io/organizations/") + e + "/issues/?project=" + r + "&query=" + i.event_id), t.exceptions.sendExceptionEvent(f), i;
    };
}
class $2b056e5321c0aa1d$var$gs {
    constructor(t, i, e, r, s){
        this.name = $2b056e5321c0aa1d$var$fs, this.setupOnce = function(n) {
            n($2b056e5321c0aa1d$var$ps(t, {
                organization: i,
                projectId: e,
                prefix: r,
                severityAllowList: s
            }));
        };
    }
}
var $2b056e5321c0aa1d$var$_s, $2b056e5321c0aa1d$var$ms = null != $2b056e5321c0aa1d$var$i && $2b056e5321c0aa1d$var$i.location ? $2b056e5321c0aa1d$var$ki($2b056e5321c0aa1d$var$i.location.hash, "__posthog") || $2b056e5321c0aa1d$var$ki(location.hash, "state") : null, $2b056e5321c0aa1d$var$bs = "_postHogToolbarParams", $2b056e5321c0aa1d$var$ws = $2b056e5321c0aa1d$var$z("[Toolbar]");
!function(t) {
    t[t.UNINITIALIZED = 0] = "UNINITIALIZED", t[t.LOADING = 1] = "LOADING", t[t.LOADED = 2] = "LOADED";
}($2b056e5321c0aa1d$var$_s || ($2b056e5321c0aa1d$var$_s = {}));
class $2b056e5321c0aa1d$var$ys {
    constructor(t){
        this.instance = t;
    }
    ji(t) {
        $2b056e5321c0aa1d$var$c.ph_toolbar_state = t;
    }
    Li() {
        var t;
        return null !== (t = $2b056e5321c0aa1d$var$c.ph_toolbar_state) && void 0 !== t ? t : $2b056e5321c0aa1d$var$_s.UNINITIALIZED;
    }
    maybeLoadToolbar(t, e, r) {
        var s, n;
        if (void 0 === t && (t = void 0), void 0 === e && (e = void 0), void 0 === r && (r = void 0), !$2b056e5321c0aa1d$var$i || !$2b056e5321c0aa1d$var$a) return !1;
        t = null !== (s = t) && void 0 !== s ? s : $2b056e5321c0aa1d$var$i.location, r = null !== (n = r) && void 0 !== n ? n : $2b056e5321c0aa1d$var$i.history;
        try {
            if (!e) {
                try {
                    $2b056e5321c0aa1d$var$i.localStorage.setItem("test", "test"), $2b056e5321c0aa1d$var$i.localStorage.removeItem("test");
                } catch (t) {
                    return !1;
                }
                e = null == $2b056e5321c0aa1d$var$i ? void 0 : $2b056e5321c0aa1d$var$i.localStorage;
            }
            var o, l = $2b056e5321c0aa1d$var$ms || $2b056e5321c0aa1d$var$ki(t.hash, "__posthog") || $2b056e5321c0aa1d$var$ki(t.hash, "state"), h = l ? $2b056e5321c0aa1d$var$X(()=>JSON.parse(atob(decodeURIComponent(l)))) || $2b056e5321c0aa1d$var$X(()=>JSON.parse(decodeURIComponent(l))) : null;
            return h && "ph_authorize" === h.action ? ((o = h).source = "url", o && Object.keys(o).length > 0 && (h.desiredHash ? t.hash = h.desiredHash : r ? r.replaceState(r.state, "", t.pathname + t.search) : t.hash = "")) : ((o = JSON.parse(e.getItem($2b056e5321c0aa1d$var$bs) || "{}")).source = "localstorage", delete o.userIntent), !(!o.token || this.instance.config.token !== o.token) && (this.loadToolbar(o), !0);
        } catch (t) {
            return !1;
        }
    }
    Ni(t) {
        var i = $2b056e5321c0aa1d$var$c.ph_load_toolbar || $2b056e5321c0aa1d$var$c.ph_load_editor;
        !$2b056e5321c0aa1d$var$O(i) && $2b056e5321c0aa1d$var$E(i) ? i(t, this.instance) : $2b056e5321c0aa1d$var$ws.warn("No toolbar load function found");
    }
    loadToolbar(t) {
        var e = !(null == $2b056e5321c0aa1d$var$a || !$2b056e5321c0aa1d$var$a.getElementById($2b056e5321c0aa1d$var$Ut));
        if (!$2b056e5321c0aa1d$var$i || e) return !1;
        var r = "custom" === this.instance.requestRouter.region && this.instance.config.advanced_disable_toolbar_metrics, s = $2b056e5321c0aa1d$var$B({
            token: this.instance.config.token
        }, t, {
            apiURL: this.instance.requestRouter.endpointFor("ui")
        }, r ? {
            instrument: !1
        } : {});
        if ($2b056e5321c0aa1d$var$i.localStorage.setItem($2b056e5321c0aa1d$var$bs, JSON.stringify($2b056e5321c0aa1d$var$B({}, s, {
            source: void 0
        }))), this.Li() === $2b056e5321c0aa1d$var$_s.LOADED) this.Ni(s);
        else if (this.Li() === $2b056e5321c0aa1d$var$_s.UNINITIALIZED) {
            var n;
            this.ji($2b056e5321c0aa1d$var$_s.LOADING), null == (n = $2b056e5321c0aa1d$var$c.__PosthogExtensions__) || null == n.loadExternalDependency || n.loadExternalDependency(this.instance, "toolbar", (t)=>{
                if (t) return $2b056e5321c0aa1d$var$ws.error("[Toolbar] Failed to load", t), void this.ji($2b056e5321c0aa1d$var$_s.UNINITIALIZED);
                this.ji($2b056e5321c0aa1d$var$_s.LOADED), this.Ni(s);
            }), $2b056e5321c0aa1d$var$st($2b056e5321c0aa1d$var$i, "turbolinks:load", ()=>{
                this.ji($2b056e5321c0aa1d$var$_s.UNINITIALIZED), this.loadToolbar(s);
            });
        }
        return !0;
    }
    zi(t) {
        return this.loadToolbar(t);
    }
    maybeLoadEditor(t, i, e) {
        return void 0 === t && (t = void 0), void 0 === i && (i = void 0), void 0 === e && (e = void 0), this.maybeLoadToolbar(t, i, e);
    }
}
var $2b056e5321c0aa1d$var$Ss = $2b056e5321c0aa1d$var$z("[TracingHeaders]");
class $2b056e5321c0aa1d$var$$s {
    constructor(t){
        this.Ui = void 0, this.qi = void 0, this.K = ()=>{
            var t, i, e, r;
            $2b056e5321c0aa1d$var$R(this.Ui) && (null == (t = $2b056e5321c0aa1d$var$c.__PosthogExtensions__) || null == (i = t.tracingHeadersPatchFns) || i._patchXHR(this.N.sessionManager));
            $2b056e5321c0aa1d$var$R(this.qi) && (null == (e = $2b056e5321c0aa1d$var$c.__PosthogExtensions__) || null == (r = e.tracingHeadersPatchFns) || r._patchFetch(this.N.sessionManager));
        }, this.N = t;
    }
    J(t) {
        var i, e;
        null != (i = $2b056e5321c0aa1d$var$c.__PosthogExtensions__) && i.tracingHeadersPatchFns && t(), null == (e = $2b056e5321c0aa1d$var$c.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this.N, "tracing-headers", (i)=>{
            if (i) return $2b056e5321c0aa1d$var$Ss.error("failed to load script", i);
            t();
        });
    }
    startIfEnabledOrStop() {
        var t, i;
        this.N.config.__add_tracing_headers ? this.J(this.K) : (null == (t = this.Ui) || t.call(this), null == (i = this.qi) || i.call(this), this.Ui = void 0, this.qi = void 0);
    }
}
var $2b056e5321c0aa1d$var$ks = $2b056e5321c0aa1d$var$z("[Web Vitals]"), $2b056e5321c0aa1d$var$xs = 9e5;
class $2b056e5321c0aa1d$var$Es {
    constructor(t){
        var i;
        this.Bi = !1, this.i = !1, this.M = {
            url: void 0,
            metrics: [],
            firstMetricTimestamp: void 0
        }, this.Hi = ()=>{
            clearTimeout(this.Wi), 0 !== this.M.metrics.length && (this.N.capture("$web_vitals", this.M.metrics.reduce((t, i)=>$2b056e5321c0aa1d$var$B({}, t, {
                    ["$web_vitals_" + i.name + "_event"]: $2b056e5321c0aa1d$var$B({}, i),
                    ["$web_vitals_" + i.name + "_value"]: i.value
                }), {})), this.M = {
                url: void 0,
                metrics: [],
                firstMetricTimestamp: void 0
            });
        }, this.Gi = (t)=>{
            var i, e = null == (i = this.N.sessionManager) ? void 0 : i.checkAndGetSessionAndWindowId(!0);
            if ($2b056e5321c0aa1d$var$R(e)) $2b056e5321c0aa1d$var$ks.error("Could not read session ID. Dropping metrics!");
            else {
                this.M = this.M || {
                    url: void 0,
                    metrics: [],
                    firstMetricTimestamp: void 0
                };
                var r = this.Ji();
                if (!$2b056e5321c0aa1d$var$R(r)) {
                    if ($2b056e5321c0aa1d$var$O(null == t ? void 0 : t.name) || $2b056e5321c0aa1d$var$O(null == t ? void 0 : t.value)) $2b056e5321c0aa1d$var$ks.error("Invalid metric received", t);
                    else if (this.Vi && t.value >= this.Vi) $2b056e5321c0aa1d$var$ks.error("Ignoring metric with value >= " + this.Vi, t);
                    else this.M.url !== r && (this.Hi(), this.Wi = setTimeout(this.Hi, this.flushToCaptureTimeoutMs)), $2b056e5321c0aa1d$var$R(this.M.url) && (this.M.url = r), this.M.firstMetricTimestamp = $2b056e5321c0aa1d$var$R(this.M.firstMetricTimestamp) ? Date.now() : this.M.firstMetricTimestamp, t.attribution && t.attribution.interactionTargetElement && (t.attribution.interactionTargetElement = void 0), this.M.metrics.push($2b056e5321c0aa1d$var$B({}, t, {
                        $current_url: r,
                        $session_id: e.sessionId,
                        $window_id: e.windowId,
                        timestamp: Date.now()
                    })), this.M.metrics.length === this.allowedMetrics.length && this.Hi();
                }
            }
        }, this.K = ()=>{
            var t, i, e, r, s = $2b056e5321c0aa1d$var$c.__PosthogExtensions__;
            $2b056e5321c0aa1d$var$R(s) || $2b056e5321c0aa1d$var$R(s.postHogWebVitalsCallbacks) || ({ onLCP: t, onCLS: i, onFCP: e, onINP: r } = s.postHogWebVitalsCallbacks), t && i && e && r ? (this.allowedMetrics.indexOf("LCP") > -1 && t(this.Gi.bind(this)), this.allowedMetrics.indexOf("CLS") > -1 && i(this.Gi.bind(this)), this.allowedMetrics.indexOf("FCP") > -1 && e(this.Gi.bind(this)), this.allowedMetrics.indexOf("INP") > -1 && r(this.Gi.bind(this)), this.i = !0) : $2b056e5321c0aa1d$var$ks.error("web vitals callbacks not loaded - not starting");
        }, this.N = t, this.Bi = !(null == (i = this.N.persistence) || !i.props[$2b056e5321c0aa1d$var$dt]), this.startIfEnabled();
    }
    get allowedMetrics() {
        var t, i, e = $2b056e5321c0aa1d$var$I(this.N.config.capture_performance) ? null == (t = this.N.config.capture_performance) ? void 0 : t.web_vitals_allowed_metrics : void 0;
        return $2b056e5321c0aa1d$var$R(e) ? (null == (i = this.N.persistence) ? void 0 : i.props[$2b056e5321c0aa1d$var$ct]) || [
            "CLS",
            "FCP",
            "INP",
            "LCP"
        ] : e;
    }
    get flushToCaptureTimeoutMs() {
        return ($2b056e5321c0aa1d$var$I(this.N.config.capture_performance) ? this.N.config.capture_performance.web_vitals_delayed_flush_ms : void 0) || 5e3;
    }
    get Vi() {
        var t = $2b056e5321c0aa1d$var$I(this.N.config.capture_performance) && $2b056e5321c0aa1d$var$F(this.N.config.capture_performance.__web_vitals_max_value) ? this.N.config.capture_performance.__web_vitals_max_value : $2b056e5321c0aa1d$var$xs;
        return 0 < t && t <= 6e4 ? $2b056e5321c0aa1d$var$xs : t;
    }
    get isEnabled() {
        var t = null == $2b056e5321c0aa1d$var$l ? void 0 : $2b056e5321c0aa1d$var$l.protocol;
        if ("http:" !== t && "https:" !== t) return $2b056e5321c0aa1d$var$ks.info("Web Vitals are disabled on non-http/https protocols"), !1;
        var i = $2b056e5321c0aa1d$var$I(this.N.config.capture_performance) ? this.N.config.capture_performance.web_vitals : $2b056e5321c0aa1d$var$A(this.N.config.capture_performance) ? this.N.config.capture_performance : void 0;
        return $2b056e5321c0aa1d$var$A(i) ? i : this.Bi;
    }
    startIfEnabled() {
        this.isEnabled && !this.i && ($2b056e5321c0aa1d$var$ks.info("enabled, starting..."), this.J(this.K));
    }
    onRemoteConfig(t) {
        var i = $2b056e5321c0aa1d$var$I(t.capturePerformance) && !!t.capturePerformance.web_vitals, e = $2b056e5321c0aa1d$var$I(t.capturePerformance) ? t.capturePerformance.web_vitals_allowed_metrics : void 0;
        this.N.persistence && (this.N.persistence.register({
            [$2b056e5321c0aa1d$var$dt]: i
        }), this.N.persistence.register({
            [$2b056e5321c0aa1d$var$ct]: e
        })), this.Bi = i, this.startIfEnabled();
    }
    J(t) {
        var i, e;
        null != (i = $2b056e5321c0aa1d$var$c.__PosthogExtensions__) && i.postHogWebVitalsCallbacks && t(), null == (e = $2b056e5321c0aa1d$var$c.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this.N, "web-vitals", (i)=>{
            i ? $2b056e5321c0aa1d$var$ks.error("failed to load script", i) : t();
        });
    }
    Ji() {
        var t = $2b056e5321c0aa1d$var$i ? $2b056e5321c0aa1d$var$i.location.href : void 0;
        return t || $2b056e5321c0aa1d$var$ks.error("Could not determine current URL"), t;
    }
}
var $2b056e5321c0aa1d$var$Is = $2b056e5321c0aa1d$var$z("[Heatmaps]");
function $2b056e5321c0aa1d$var$Ps(t) {
    return $2b056e5321c0aa1d$var$I(t) && "clientX" in t && "clientY" in t && $2b056e5321c0aa1d$var$F(t.clientX) && $2b056e5321c0aa1d$var$F(t.clientY);
}
class $2b056e5321c0aa1d$var$Rs {
    constructor(t){
        var i;
        this.rageclicks = new $2b056e5321c0aa1d$var$mi, this.Bi = !1, this.i = !1, this.Ki = null, this.instance = t, this.Bi = !(null == (i = this.instance.persistence) || !i.props[$2b056e5321c0aa1d$var$ht]);
    }
    get flushIntervalMilliseconds() {
        var t = 5e3;
        return $2b056e5321c0aa1d$var$I(this.instance.config.capture_heatmaps) && this.instance.config.capture_heatmaps.flush_interval_milliseconds && (t = this.instance.config.capture_heatmaps.flush_interval_milliseconds), t;
    }
    get isEnabled() {
        return $2b056e5321c0aa1d$var$R(this.instance.config.capture_heatmaps) ? $2b056e5321c0aa1d$var$R(this.instance.config.enable_heatmaps) ? this.Bi : this.instance.config.enable_heatmaps : !1 !== this.instance.config.capture_heatmaps;
    }
    startIfEnabled() {
        if (this.isEnabled) {
            if (this.i) return;
            $2b056e5321c0aa1d$var$Is.info("starting..."), this.Yi(), this.Ki = setInterval(this.Xi.bind(this), this.flushIntervalMilliseconds);
        } else {
            var t, i;
            clearInterval(null !== (t = this.Ki) && void 0 !== t ? t : void 0), null == (i = this.Qi) || i.stop(), this.getAndClearBuffer();
        }
    }
    onRemoteConfig(t) {
        var i = !!t.heatmaps;
        this.instance.persistence && this.instance.persistence.register({
            [$2b056e5321c0aa1d$var$ht]: i
        }), this.Bi = i, this.startIfEnabled();
    }
    getAndClearBuffer() {
        var t = this.M;
        return this.M = void 0, t;
    }
    Zi(t) {
        this.te(t.originalEvent, "deadclick");
    }
    Yi() {
        $2b056e5321c0aa1d$var$i && $2b056e5321c0aa1d$var$a && ($2b056e5321c0aa1d$var$st($2b056e5321c0aa1d$var$i, "beforeunload", this.Xi.bind(this)), $2b056e5321c0aa1d$var$st($2b056e5321c0aa1d$var$a, "click", (t)=>this.te(t || (null == $2b056e5321c0aa1d$var$i ? void 0 : $2b056e5321c0aa1d$var$i.event)), {
            capture: !0
        }), $2b056e5321c0aa1d$var$st($2b056e5321c0aa1d$var$a, "mousemove", (t)=>this.ie(t || (null == $2b056e5321c0aa1d$var$i ? void 0 : $2b056e5321c0aa1d$var$i.event)), {
            capture: !0
        }), this.Qi = new $2b056e5321c0aa1d$var$re(this.instance, $2b056e5321c0aa1d$var$ie, this.Zi.bind(this)), this.Qi.startIfEnabled(), this.i = !0);
    }
    ee(t, e) {
        var r = this.instance.scrollManager.scrollY(), s = this.instance.scrollManager.scrollX(), n = this.instance.scrollManager.scrollElement(), o = function(t, e, r) {
            for(var s = t; s && $2b056e5321c0aa1d$var$Wt(s) && !$2b056e5321c0aa1d$var$Gt(s, "body");){
                if (s === r) return !1;
                if ($2b056e5321c0aa1d$var$m(e, null == $2b056e5321c0aa1d$var$i ? void 0 : $2b056e5321c0aa1d$var$i.getComputedStyle(s).position)) return !0;
                s = $2b056e5321c0aa1d$var$ei(s);
            }
            return !1;
        }($2b056e5321c0aa1d$var$ti(t), [
            "fixed",
            "sticky"
        ], n);
        return {
            x: t.clientX + (o ? 0 : s),
            y: t.clientY + (o ? 0 : r),
            target_fixed: o,
            type: e
        };
    }
    te(t, i) {
        var e;
        if (void 0 === i && (i = "click"), !$2b056e5321c0aa1d$var$Ht(t.target) && $2b056e5321c0aa1d$var$Ps(t)) {
            var r = this.ee(t, i);
            null != (e = this.rageclicks) && e.isRageClick(t.clientX, t.clientY, (new Date).getTime()) && this.re($2b056e5321c0aa1d$var$B({}, r, {
                type: "rageclick"
            })), this.re(r);
        }
    }
    ie(t) {
        !$2b056e5321c0aa1d$var$Ht(t.target) && $2b056e5321c0aa1d$var$Ps(t) && (clearTimeout(this.se), this.se = setTimeout(()=>{
            this.re(this.ee(t, "mousemove"));
        }, 500));
    }
    re(t) {
        if ($2b056e5321c0aa1d$var$i) {
            var e = $2b056e5321c0aa1d$var$i.location.href;
            this.M = this.M || {}, this.M[e] || (this.M[e] = []), this.M[e].push(t);
        }
    }
    Xi() {
        this.M && !$2b056e5321c0aa1d$var$P(this.M) && this.instance.capture("$$heatmap", {
            $heatmap_data: this.getAndClearBuffer()
        });
    }
}
class $2b056e5321c0aa1d$var$Ts {
    constructor(t){
        this.N = t;
    }
    doPageView(t, e) {
        var r, s = this.ne(t, e);
        return this.oe = {
            pathname: null !== (r = null == $2b056e5321c0aa1d$var$i ? void 0 : $2b056e5321c0aa1d$var$i.location.pathname) && void 0 !== r ? r : "",
            pageViewId: e,
            timestamp: t
        }, this.N.scrollManager.resetContext(), s;
    }
    doPageLeave(t) {
        var i;
        return this.ne(t, null == (i = this.oe) ? void 0 : i.pageViewId);
    }
    doEvent() {
        var t;
        return {
            $pageview_id: null == (t = this.oe) ? void 0 : t.pageViewId
        };
    }
    ne(t, i) {
        var e = this.oe;
        if (!e) return {
            $pageview_id: i
        };
        var r = {
            $pageview_id: i,
            $prev_pageview_id: e.pageViewId
        }, s = this.N.scrollManager.getContext();
        if (s && !this.N.config.disable_scroll_properties) {
            var { maxScrollHeight: n, lastScrollY: o, maxScrollY: a, maxContentHeight: l, lastContentY: h, maxContentY: u } = s;
            if (!($2b056e5321c0aa1d$var$R(n) || $2b056e5321c0aa1d$var$R(o) || $2b056e5321c0aa1d$var$R(a) || $2b056e5321c0aa1d$var$R(l) || $2b056e5321c0aa1d$var$R(h) || $2b056e5321c0aa1d$var$R(u))) {
                n = Math.ceil(n), o = Math.ceil(o), a = Math.ceil(a), l = Math.ceil(l), h = Math.ceil(h), u = Math.ceil(u);
                var d = n <= 1 ? 1 : $2b056e5321c0aa1d$var$Xe(o / n, 0, 1), v = n <= 1 ? 1 : $2b056e5321c0aa1d$var$Xe(a / n, 0, 1), c = l <= 1 ? 1 : $2b056e5321c0aa1d$var$Xe(h / l, 0, 1), f = l <= 1 ? 1 : $2b056e5321c0aa1d$var$Xe(u / l, 0, 1);
                r = $2b056e5321c0aa1d$var$V(r, {
                    $prev_pageview_last_scroll: o,
                    $prev_pageview_last_scroll_percentage: d,
                    $prev_pageview_max_scroll: a,
                    $prev_pageview_max_scroll_percentage: v,
                    $prev_pageview_last_content: h,
                    $prev_pageview_last_content_percentage: c,
                    $prev_pageview_max_content: u,
                    $prev_pageview_max_content_percentage: f
                });
            }
        }
        return e.pathname && (r.$prev_pageview_pathname = e.pathname), e.timestamp && (r.$prev_pageview_duration = (t.getTime() - e.timestamp.getTime()) / 1e3), r;
    }
}
class $2b056e5321c0aa1d$var$Ms {
    constructor(t){
        this.N = t;
    }
    sendExceptionEvent(t) {
        this.N.capture("$exception", t, {
            _noTruncate: !0,
            _batchKey: "exceptionEvent"
        });
    }
}
var $2b056e5321c0aa1d$var$Cs = "Mobile", $2b056e5321c0aa1d$var$Os = "iOS", $2b056e5321c0aa1d$var$Fs = "Android", $2b056e5321c0aa1d$var$As = "Tablet", $2b056e5321c0aa1d$var$Ds = $2b056e5321c0aa1d$var$Fs + " " + $2b056e5321c0aa1d$var$As, $2b056e5321c0aa1d$var$js = "iPad", $2b056e5321c0aa1d$var$Ls = "Apple", $2b056e5321c0aa1d$var$Ns = $2b056e5321c0aa1d$var$Ls + " Watch", $2b056e5321c0aa1d$var$zs = "Safari", $2b056e5321c0aa1d$var$Us = "BlackBerry", $2b056e5321c0aa1d$var$qs = "Samsung", $2b056e5321c0aa1d$var$Bs = $2b056e5321c0aa1d$var$qs + "Browser", $2b056e5321c0aa1d$var$Hs = $2b056e5321c0aa1d$var$qs + " Internet", $2b056e5321c0aa1d$var$Ws = "Chrome", $2b056e5321c0aa1d$var$Gs = $2b056e5321c0aa1d$var$Ws + " OS", $2b056e5321c0aa1d$var$Js = $2b056e5321c0aa1d$var$Ws + " " + $2b056e5321c0aa1d$var$Os, $2b056e5321c0aa1d$var$Vs = "Internet Explorer", $2b056e5321c0aa1d$var$Ks = $2b056e5321c0aa1d$var$Vs + " " + $2b056e5321c0aa1d$var$Cs, $2b056e5321c0aa1d$var$Ys = "Opera", $2b056e5321c0aa1d$var$Xs = $2b056e5321c0aa1d$var$Ys + " Mini", $2b056e5321c0aa1d$var$Qs = "Edge", $2b056e5321c0aa1d$var$Zs = "Microsoft " + $2b056e5321c0aa1d$var$Qs, $2b056e5321c0aa1d$var$tn = "Firefox", $2b056e5321c0aa1d$var$en = $2b056e5321c0aa1d$var$tn + " " + $2b056e5321c0aa1d$var$Os, $2b056e5321c0aa1d$var$rn = "Nintendo", $2b056e5321c0aa1d$var$sn = "PlayStation", $2b056e5321c0aa1d$var$nn = "Xbox", $2b056e5321c0aa1d$var$on = $2b056e5321c0aa1d$var$Fs + " " + $2b056e5321c0aa1d$var$Cs, $2b056e5321c0aa1d$var$an = $2b056e5321c0aa1d$var$Cs + " " + $2b056e5321c0aa1d$var$zs, $2b056e5321c0aa1d$var$ln = "Windows", $2b056e5321c0aa1d$var$hn = $2b056e5321c0aa1d$var$ln + " Phone", $2b056e5321c0aa1d$var$un = "Nokia", $2b056e5321c0aa1d$var$dn = "Ouya", $2b056e5321c0aa1d$var$vn = "Generic", $2b056e5321c0aa1d$var$cn = $2b056e5321c0aa1d$var$vn + " " + $2b056e5321c0aa1d$var$Cs.toLowerCase(), $2b056e5321c0aa1d$var$fn = $2b056e5321c0aa1d$var$vn + " " + $2b056e5321c0aa1d$var$As.toLowerCase(), $2b056e5321c0aa1d$var$pn = "Konqueror", $2b056e5321c0aa1d$var$gn = "(\\d+(\\.\\d+)?)", $2b056e5321c0aa1d$var$_n = new RegExp("Version/" + $2b056e5321c0aa1d$var$gn), $2b056e5321c0aa1d$var$mn = new RegExp($2b056e5321c0aa1d$var$nn, "i"), $2b056e5321c0aa1d$var$bn = new RegExp($2b056e5321c0aa1d$var$sn + " \\w+", "i"), $2b056e5321c0aa1d$var$wn = new RegExp($2b056e5321c0aa1d$var$rn + " \\w+", "i"), $2b056e5321c0aa1d$var$yn = new RegExp($2b056e5321c0aa1d$var$Us + "|PlayBook|BB10", "i"), $2b056e5321c0aa1d$var$Sn = {
    "NT3.51": "NT 3.11",
    "NT4.0": "NT 4.0",
    "5.0": "2000",
    5.1: "XP",
    5.2: "XP",
    "6.0": "Vista",
    6.1: "7",
    6.2: "8",
    6.3: "8.1",
    6.4: "10",
    "10.0": "10"
};
var $2b056e5321c0aa1d$var$$n = (t, i)=>i && $2b056e5321c0aa1d$var$m(i, $2b056e5321c0aa1d$var$Ls) || function(t) {
        return $2b056e5321c0aa1d$var$m(t, $2b056e5321c0aa1d$var$zs) && !$2b056e5321c0aa1d$var$m(t, $2b056e5321c0aa1d$var$Ws) && !$2b056e5321c0aa1d$var$m(t, $2b056e5321c0aa1d$var$Fs);
    }(t), $2b056e5321c0aa1d$var$kn = function(t, i) {
    return i = i || "", $2b056e5321c0aa1d$var$m(t, " OPR/") && $2b056e5321c0aa1d$var$m(t, "Mini") ? $2b056e5321c0aa1d$var$Xs : $2b056e5321c0aa1d$var$m(t, " OPR/") ? $2b056e5321c0aa1d$var$Ys : $2b056e5321c0aa1d$var$yn.test(t) ? $2b056e5321c0aa1d$var$Us : $2b056e5321c0aa1d$var$m(t, "IE" + $2b056e5321c0aa1d$var$Cs) || $2b056e5321c0aa1d$var$m(t, "WPDesktop") ? $2b056e5321c0aa1d$var$Ks : $2b056e5321c0aa1d$var$m(t, $2b056e5321c0aa1d$var$Bs) ? $2b056e5321c0aa1d$var$Hs : $2b056e5321c0aa1d$var$m(t, $2b056e5321c0aa1d$var$Qs) || $2b056e5321c0aa1d$var$m(t, "Edg/") ? $2b056e5321c0aa1d$var$Zs : $2b056e5321c0aa1d$var$m(t, "FBIOS") ? "Facebook " + $2b056e5321c0aa1d$var$Cs : $2b056e5321c0aa1d$var$m(t, "UCWEB") || $2b056e5321c0aa1d$var$m(t, "UCBrowser") ? "UC Browser" : $2b056e5321c0aa1d$var$m(t, "CriOS") ? $2b056e5321c0aa1d$var$Js : $2b056e5321c0aa1d$var$m(t, "CrMo") || $2b056e5321c0aa1d$var$m(t, $2b056e5321c0aa1d$var$Ws) ? $2b056e5321c0aa1d$var$Ws : $2b056e5321c0aa1d$var$m(t, $2b056e5321c0aa1d$var$Fs) && $2b056e5321c0aa1d$var$m(t, $2b056e5321c0aa1d$var$zs) ? $2b056e5321c0aa1d$var$on : $2b056e5321c0aa1d$var$m(t, "FxiOS") ? $2b056e5321c0aa1d$var$en : $2b056e5321c0aa1d$var$m(t.toLowerCase(), $2b056e5321c0aa1d$var$pn.toLowerCase()) ? $2b056e5321c0aa1d$var$pn : $2b056e5321c0aa1d$var$$n(t, i) ? $2b056e5321c0aa1d$var$m(t, $2b056e5321c0aa1d$var$Cs) ? $2b056e5321c0aa1d$var$an : $2b056e5321c0aa1d$var$zs : $2b056e5321c0aa1d$var$m(t, $2b056e5321c0aa1d$var$tn) ? $2b056e5321c0aa1d$var$tn : $2b056e5321c0aa1d$var$m(t, "MSIE") || $2b056e5321c0aa1d$var$m(t, "Trident/") ? $2b056e5321c0aa1d$var$Vs : $2b056e5321c0aa1d$var$m(t, "Gecko") ? $2b056e5321c0aa1d$var$tn : "";
}, $2b056e5321c0aa1d$var$xn = {
    [$2b056e5321c0aa1d$var$Ks]: [
        new RegExp("rv:" + $2b056e5321c0aa1d$var$gn)
    ],
    [$2b056e5321c0aa1d$var$Zs]: [
        new RegExp($2b056e5321c0aa1d$var$Qs + "?\\/" + $2b056e5321c0aa1d$var$gn)
    ],
    [$2b056e5321c0aa1d$var$Ws]: [
        new RegExp("(" + $2b056e5321c0aa1d$var$Ws + "|CrMo)\\/" + $2b056e5321c0aa1d$var$gn)
    ],
    [$2b056e5321c0aa1d$var$Js]: [
        new RegExp("CriOS\\/" + $2b056e5321c0aa1d$var$gn)
    ],
    "UC Browser": [
        new RegExp("(UCBrowser|UCWEB)\\/" + $2b056e5321c0aa1d$var$gn)
    ],
    [$2b056e5321c0aa1d$var$zs]: [
        $2b056e5321c0aa1d$var$_n
    ],
    [$2b056e5321c0aa1d$var$an]: [
        $2b056e5321c0aa1d$var$_n
    ],
    [$2b056e5321c0aa1d$var$Ys]: [
        new RegExp("(Opera|OPR)\\/" + $2b056e5321c0aa1d$var$gn)
    ],
    [$2b056e5321c0aa1d$var$tn]: [
        new RegExp($2b056e5321c0aa1d$var$tn + "\\/" + $2b056e5321c0aa1d$var$gn)
    ],
    [$2b056e5321c0aa1d$var$en]: [
        new RegExp("FxiOS\\/" + $2b056e5321c0aa1d$var$gn)
    ],
    [$2b056e5321c0aa1d$var$pn]: [
        new RegExp("Konqueror[:/]?" + $2b056e5321c0aa1d$var$gn, "i")
    ],
    [$2b056e5321c0aa1d$var$Us]: [
        new RegExp($2b056e5321c0aa1d$var$Us + " " + $2b056e5321c0aa1d$var$gn),
        $2b056e5321c0aa1d$var$_n
    ],
    [$2b056e5321c0aa1d$var$on]: [
        new RegExp("android\\s" + $2b056e5321c0aa1d$var$gn, "i")
    ],
    [$2b056e5321c0aa1d$var$Hs]: [
        new RegExp($2b056e5321c0aa1d$var$Bs + "\\/" + $2b056e5321c0aa1d$var$gn)
    ],
    [$2b056e5321c0aa1d$var$Vs]: [
        new RegExp("(rv:|MSIE )" + $2b056e5321c0aa1d$var$gn)
    ],
    Mozilla: [
        new RegExp("rv:" + $2b056e5321c0aa1d$var$gn)
    ]
}, $2b056e5321c0aa1d$var$En = function(t, i) {
    var e = $2b056e5321c0aa1d$var$kn(t, i), r = $2b056e5321c0aa1d$var$xn[e];
    if ($2b056e5321c0aa1d$var$R(r)) return null;
    for(var s = 0; s < r.length; s++){
        var n = r[s], o = t.match(n);
        if (o) return parseFloat(o[o.length - 2]);
    }
    return null;
}, $2b056e5321c0aa1d$var$In = [
    [
        new RegExp($2b056e5321c0aa1d$var$nn + "; " + $2b056e5321c0aa1d$var$nn + " (.*?)[);]", "i"),
        (t)=>[
                $2b056e5321c0aa1d$var$nn,
                t && t[1] || ""
            ]
    ],
    [
        new RegExp($2b056e5321c0aa1d$var$rn, "i"),
        [
            $2b056e5321c0aa1d$var$rn,
            ""
        ]
    ],
    [
        new RegExp($2b056e5321c0aa1d$var$sn, "i"),
        [
            $2b056e5321c0aa1d$var$sn,
            ""
        ]
    ],
    [
        $2b056e5321c0aa1d$var$yn,
        [
            $2b056e5321c0aa1d$var$Us,
            ""
        ]
    ],
    [
        new RegExp($2b056e5321c0aa1d$var$ln, "i"),
        (t, i)=>{
            if (/Phone/.test(i) || /WPDesktop/.test(i)) return [
                $2b056e5321c0aa1d$var$hn,
                ""
            ];
            if (new RegExp($2b056e5321c0aa1d$var$Cs).test(i) && !/IEMobile\b/.test(i)) return [
                $2b056e5321c0aa1d$var$ln + " " + $2b056e5321c0aa1d$var$Cs,
                ""
            ];
            var e = /Windows NT ([0-9.]+)/i.exec(i);
            if (e && e[1]) {
                var r = e[1], s = $2b056e5321c0aa1d$var$Sn[r] || "";
                return /arm/i.test(i) && (s = "RT"), [
                    $2b056e5321c0aa1d$var$ln,
                    s
                ];
            }
            return [
                $2b056e5321c0aa1d$var$ln,
                ""
            ];
        }
    ],
    [
        /((iPhone|iPad|iPod).*?OS (\d+)_(\d+)_?(\d+)?|iPhone)/,
        (t)=>{
            if (t && t[3]) {
                var i = [
                    t[3],
                    t[4],
                    t[5] || "0"
                ];
                return [
                    $2b056e5321c0aa1d$var$Os,
                    i.join(".")
                ];
            }
            return [
                $2b056e5321c0aa1d$var$Os,
                ""
            ];
        }
    ],
    [
        /(watch.*\/(\d+\.\d+\.\d+)|watch os,(\d+\.\d+),)/i,
        (t)=>{
            var i = "";
            return t && t.length >= 3 && (i = $2b056e5321c0aa1d$var$R(t[2]) ? t[3] : t[2]), [
                "watchOS",
                i
            ];
        }
    ],
    [
        new RegExp("(" + $2b056e5321c0aa1d$var$Fs + " (\\d+)\\.(\\d+)\\.?(\\d+)?|" + $2b056e5321c0aa1d$var$Fs + ")", "i"),
        (t)=>{
            if (t && t[2]) {
                var i = [
                    t[2],
                    t[3],
                    t[4] || "0"
                ];
                return [
                    $2b056e5321c0aa1d$var$Fs,
                    i.join(".")
                ];
            }
            return [
                $2b056e5321c0aa1d$var$Fs,
                ""
            ];
        }
    ],
    [
        /Mac OS X (\d+)[_.](\d+)[_.]?(\d+)?/i,
        (t)=>{
            var i = [
                "Mac OS X",
                ""
            ];
            if (t && t[1]) {
                var e = [
                    t[1],
                    t[2],
                    t[3] || "0"
                ];
                i[1] = e.join(".");
            }
            return i;
        }
    ],
    [
        /Mac/i,
        [
            "Mac OS X",
            ""
        ]
    ],
    [
        /CrOS/,
        [
            $2b056e5321c0aa1d$var$Gs,
            ""
        ]
    ],
    [
        /Linux|debian/i,
        [
            "Linux",
            ""
        ]
    ]
], $2b056e5321c0aa1d$var$Pn = function(t) {
    return $2b056e5321c0aa1d$var$wn.test(t) ? $2b056e5321c0aa1d$var$rn : $2b056e5321c0aa1d$var$bn.test(t) ? $2b056e5321c0aa1d$var$sn : $2b056e5321c0aa1d$var$mn.test(t) ? $2b056e5321c0aa1d$var$nn : new RegExp($2b056e5321c0aa1d$var$dn, "i").test(t) ? $2b056e5321c0aa1d$var$dn : new RegExp("(" + $2b056e5321c0aa1d$var$hn + "|WPDesktop)", "i").test(t) ? $2b056e5321c0aa1d$var$hn : /iPad/.test(t) ? $2b056e5321c0aa1d$var$js : /iPod/.test(t) ? "iPod Touch" : /iPhone/.test(t) ? "iPhone" : /(watch)(?: ?os[,/]|\d,\d\/)[\d.]+/i.test(t) ? $2b056e5321c0aa1d$var$Ns : $2b056e5321c0aa1d$var$yn.test(t) ? $2b056e5321c0aa1d$var$Us : /(kobo)\s(ereader|touch)/i.test(t) ? "Kobo" : new RegExp($2b056e5321c0aa1d$var$un, "i").test(t) ? $2b056e5321c0aa1d$var$un : /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i.test(t) || /(kf[a-z]+)( bui|\)).+silk\//i.test(t) ? "Kindle Fire" : /(Android|ZTE)/i.test(t) ? !new RegExp($2b056e5321c0aa1d$var$Cs).test(t) || /(9138B|TB782B|Nexus [97]|pixel c|HUAWEISHT|BTV|noble nook|smart ultra 6)/i.test(t) ? /pixel[\daxl ]{1,6}/i.test(t) && !/pixel c/i.test(t) || /(huaweimed-al00|tah-|APA|SM-G92|i980|zte|U304AA)/i.test(t) || /lmy47v/i.test(t) && !/QTAQZ3/i.test(t) ? $2b056e5321c0aa1d$var$Fs : $2b056e5321c0aa1d$var$Ds : $2b056e5321c0aa1d$var$Fs : new RegExp("(pda|" + $2b056e5321c0aa1d$var$Cs + ")", "i").test(t) ? $2b056e5321c0aa1d$var$cn : new RegExp($2b056e5321c0aa1d$var$As, "i").test(t) && !new RegExp($2b056e5321c0aa1d$var$As + " pc", "i").test(t) ? $2b056e5321c0aa1d$var$fn : "";
}, $2b056e5321c0aa1d$var$Rn = "https?://(.*)", $2b056e5321c0aa1d$var$Tn = [
    "gclid",
    "gclsrc",
    "dclid",
    "gbraid",
    "wbraid",
    "fbclid",
    "msclkid",
    "twclid",
    "li_fat_id",
    "igshid",
    "ttclid",
    "rdt_cid",
    "epik",
    "qclid",
    "sccid",
    "irclid",
    "_kx"
], $2b056e5321c0aa1d$var$Mn = $2b056e5321c0aa1d$var$K([
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "gad_source",
    "mc_cid"
], $2b056e5321c0aa1d$var$Tn), $2b056e5321c0aa1d$var$Cn = "<masked>";
function $2b056e5321c0aa1d$var$On(t, i, e) {
    if (!$2b056e5321c0aa1d$var$a) return {};
    var r = i ? $2b056e5321c0aa1d$var$K([], $2b056e5321c0aa1d$var$Tn, e || []) : [];
    return $2b056e5321c0aa1d$var$Fn($2b056e5321c0aa1d$var$$i($2b056e5321c0aa1d$var$a.URL, r, $2b056e5321c0aa1d$var$Cn), t);
}
function $2b056e5321c0aa1d$var$Fn(t, i) {
    var e = $2b056e5321c0aa1d$var$Mn.concat(i || []), r = {};
    return $2b056e5321c0aa1d$var$J(e, function(i) {
        var e = $2b056e5321c0aa1d$var$Si(t, i);
        r[i] = e || null;
    }), r;
}
function $2b056e5321c0aa1d$var$An(t) {
    var i = function(t) {
        return t ? 0 === t.search($2b056e5321c0aa1d$var$Rn + "google.([^/?]*)") ? "google" : 0 === t.search($2b056e5321c0aa1d$var$Rn + "bing.com") ? "bing" : 0 === t.search($2b056e5321c0aa1d$var$Rn + "yahoo.com") ? "yahoo" : 0 === t.search($2b056e5321c0aa1d$var$Rn + "duckduckgo.com") ? "duckduckgo" : null : null;
    }(t), e = "yahoo" != i ? "q" : "p", r = {};
    if (!$2b056e5321c0aa1d$var$C(i)) {
        r.$search_engine = i;
        var s = $2b056e5321c0aa1d$var$a ? $2b056e5321c0aa1d$var$Si($2b056e5321c0aa1d$var$a.referrer, e) : "";
        s.length && (r.ph_keyword = s);
    }
    return r;
}
function $2b056e5321c0aa1d$var$Dn() {
    return navigator.language || navigator.userLanguage;
}
function $2b056e5321c0aa1d$var$jn() {
    return (null == $2b056e5321c0aa1d$var$a ? void 0 : $2b056e5321c0aa1d$var$a.referrer) || "$direct";
}
function $2b056e5321c0aa1d$var$Ln(t, i) {
    var e = t ? $2b056e5321c0aa1d$var$K([], $2b056e5321c0aa1d$var$Tn, i || []) : [], r = null == $2b056e5321c0aa1d$var$l ? void 0 : $2b056e5321c0aa1d$var$l.href.substring(0, 1e3);
    return {
        r: $2b056e5321c0aa1d$var$jn().substring(0, 1e3),
        u: r ? $2b056e5321c0aa1d$var$$i(r, e, $2b056e5321c0aa1d$var$Cn) : void 0
    };
}
function $2b056e5321c0aa1d$var$Nn(t) {
    var i, { r: e, u: r } = t, s = {
        $referrer: e,
        $referring_domain: null == e ? void 0 : "$direct" == e ? "$direct" : null == (i = $2b056e5321c0aa1d$var$wi(e)) ? void 0 : i.host
    };
    if (r) {
        s.$current_url = r;
        var n = $2b056e5321c0aa1d$var$wi(r);
        s.$host = null == n ? void 0 : n.host, s.$pathname = null == n ? void 0 : n.pathname;
        var o = $2b056e5321c0aa1d$var$Fn(r);
        $2b056e5321c0aa1d$var$V(s, o);
    }
    if (e) {
        var a = $2b056e5321c0aa1d$var$An(e);
        $2b056e5321c0aa1d$var$V(s, a);
    }
    return s;
}
function $2b056e5321c0aa1d$var$zn() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (t) {
        return;
    }
}
function $2b056e5321c0aa1d$var$Un() {
    try {
        return (new Date).getTimezoneOffset();
    } catch (t) {
        return;
    }
}
function $2b056e5321c0aa1d$var$qn(t, e) {
    if (!$2b056e5321c0aa1d$var$v) return {};
    var r, s, n, o = t ? $2b056e5321c0aa1d$var$K([], $2b056e5321c0aa1d$var$Tn, e || []) : [], [a, h] = function(t) {
        for(var i = 0; i < $2b056e5321c0aa1d$var$In.length; i++){
            var [e, r] = $2b056e5321c0aa1d$var$In[i], s = e.exec(t), n = s && ($2b056e5321c0aa1d$var$E(r) ? r(s, t) : r);
            if (n) return n;
        }
        return [
            "",
            ""
        ];
    }($2b056e5321c0aa1d$var$v);
    return $2b056e5321c0aa1d$var$V($2b056e5321c0aa1d$var$Z({
        $os: a,
        $os_version: h,
        $browser: $2b056e5321c0aa1d$var$kn($2b056e5321c0aa1d$var$v, navigator.vendor),
        $device: $2b056e5321c0aa1d$var$Pn($2b056e5321c0aa1d$var$v),
        $device_type: (s = $2b056e5321c0aa1d$var$v, n = $2b056e5321c0aa1d$var$Pn(s), n === $2b056e5321c0aa1d$var$js || n === $2b056e5321c0aa1d$var$Ds || "Kobo" === n || "Kindle Fire" === n || n === $2b056e5321c0aa1d$var$fn ? $2b056e5321c0aa1d$var$As : n === $2b056e5321c0aa1d$var$rn || n === $2b056e5321c0aa1d$var$nn || n === $2b056e5321c0aa1d$var$sn || n === $2b056e5321c0aa1d$var$dn ? "Console" : n === $2b056e5321c0aa1d$var$Ns ? "Wearable" : n ? $2b056e5321c0aa1d$var$Cs : "Desktop"),
        $timezone: $2b056e5321c0aa1d$var$zn(),
        $timezone_offset: $2b056e5321c0aa1d$var$Un()
    }), {
        $current_url: $2b056e5321c0aa1d$var$$i(null == $2b056e5321c0aa1d$var$l ? void 0 : $2b056e5321c0aa1d$var$l.href, o, $2b056e5321c0aa1d$var$Cn),
        $host: null == $2b056e5321c0aa1d$var$l ? void 0 : $2b056e5321c0aa1d$var$l.host,
        $pathname: null == $2b056e5321c0aa1d$var$l ? void 0 : $2b056e5321c0aa1d$var$l.pathname,
        $raw_user_agent: $2b056e5321c0aa1d$var$v.length > 1e3 ? $2b056e5321c0aa1d$var$v.substring(0, 997) + "..." : $2b056e5321c0aa1d$var$v,
        $browser_version: $2b056e5321c0aa1d$var$En($2b056e5321c0aa1d$var$v, navigator.vendor),
        $browser_language: $2b056e5321c0aa1d$var$Dn(),
        $browser_language_prefix: (r = $2b056e5321c0aa1d$var$Dn(), "string" == typeof r ? r.split("-")[0] : void 0),
        $screen_height: null == $2b056e5321c0aa1d$var$i ? void 0 : $2b056e5321c0aa1d$var$i.screen.height,
        $screen_width: null == $2b056e5321c0aa1d$var$i ? void 0 : $2b056e5321c0aa1d$var$i.screen.width,
        $viewport_height: null == $2b056e5321c0aa1d$var$i ? void 0 : $2b056e5321c0aa1d$var$i.innerHeight,
        $viewport_width: null == $2b056e5321c0aa1d$var$i ? void 0 : $2b056e5321c0aa1d$var$i.innerWidth,
        $lib: "web",
        $lib_version: $2b056e5321c0aa1d$var$f.LIB_VERSION,
        $insert_id: Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10),
        $time: Date.now() / 1e3
    });
}
var $2b056e5321c0aa1d$var$Bn, $2b056e5321c0aa1d$var$Hn = $2b056e5321c0aa1d$var$z("[FeatureFlags]"), $2b056e5321c0aa1d$var$Wn = "$active_feature_flags", $2b056e5321c0aa1d$var$Gn = "$override_feature_flags", $2b056e5321c0aa1d$var$Jn = "$feature_flag_payloads", $2b056e5321c0aa1d$var$Vn = "$override_feature_flag_payloads", $2b056e5321c0aa1d$var$Kn = "$feature_flag_request_id", $2b056e5321c0aa1d$var$Yn = (t)=>{
    var i = {};
    for (var [e, r] of $2b056e5321c0aa1d$var$Y(t || {}))r && (i[e] = r);
    return i;
}, $2b056e5321c0aa1d$var$Xn = (t)=>{
    var i = t.flags;
    return i ? (t.featureFlags = Object.fromEntries(Object.keys(i).map((t)=>{
        var e;
        return [
            t,
            null !== (e = i[t].variant) && void 0 !== e ? e : i[t].enabled
        ];
    })), t.featureFlagPayloads = Object.fromEntries(Object.keys(i).filter((t)=>i[t].enabled).filter((t)=>{
        var e;
        return null == (e = i[t].metadata) ? void 0 : e.payload;
    }).map((t)=>{
        var e;
        return [
            t,
            null == (e = i[t].metadata) ? void 0 : e.payload
        ];
    }))) : $2b056e5321c0aa1d$var$Hn.warn("Using an older version of the feature flags endpoint. Please upgrade your PostHog server to the latest version"), t;
};
!function(t) {
    t.FeatureFlags = "feature_flags", t.Recordings = "recordings";
}($2b056e5321c0aa1d$var$Bn || ($2b056e5321c0aa1d$var$Bn = {}));
class $2b056e5321c0aa1d$var$Qn {
    constructor(t){
        this.ae = !1, this.le = !1, this.he = !1, this.ue = !1, this.de = !1, this.ve = !1, this.ce = !1, this.N = t, this.featureFlagEventHandlers = [];
    }
    decide() {
        if (this.N.config.__preview_remote_config) this.ve = !0;
        else {
            var t = !this.fe && (this.N.config.advanced_disable_feature_flags || this.N.config.advanced_disable_feature_flags_on_first_load);
            this.pe({
                disableFlags: t
            });
        }
    }
    get hasLoadedFlags() {
        return this.le;
    }
    getFlags() {
        return Object.keys(this.getFlagVariants());
    }
    getFlagsWithDetails() {
        var t = this.N.get_property($2b056e5321c0aa1d$var$Pt), i = this.N.get_property($2b056e5321c0aa1d$var$Gn), e = this.N.get_property($2b056e5321c0aa1d$var$Vn);
        if (!e && !i) return t || {};
        var r = $2b056e5321c0aa1d$var$V({}, t || {}), s = [
            ...new Set([
                ...Object.keys(e || {}),
                ...Object.keys(i || {})
            ])
        ];
        for (var n of s){
            var o, a, l = r[n], h = null == i ? void 0 : i[n], u = $2b056e5321c0aa1d$var$R(h) ? null !== (o = null == l ? void 0 : l.enabled) && void 0 !== o && o : !!h, d = $2b056e5321c0aa1d$var$R(h) ? l.variant : "string" == typeof h ? h : void 0, v = null == e ? void 0 : e[n], c = $2b056e5321c0aa1d$var$B({}, l, {
                enabled: u,
                variant: u ? null != d ? d : null == l ? void 0 : l.variant : void 0
            });
            if (u !== (null == l ? void 0 : l.enabled) && (c.original_enabled = null == l ? void 0 : l.enabled), d !== (null == l ? void 0 : l.variant) && (c.original_variant = null == l ? void 0 : l.variant), v) c.metadata = $2b056e5321c0aa1d$var$B({}, null == l ? void 0 : l.metadata, {
                payload: v,
                original_payload: null == l || null == (a = l.metadata) ? void 0 : a.payload
            });
            r[n] = c;
        }
        return this.ae || ($2b056e5321c0aa1d$var$Hn.warn(" Overriding feature flag details!", {
            flagDetails: t,
            overriddenPayloads: e,
            finalDetails: r
        }), this.ae = !0), r;
    }
    getFlagVariants() {
        var t = this.N.get_property($2b056e5321c0aa1d$var$Et), i = this.N.get_property($2b056e5321c0aa1d$var$Gn);
        if (!i) return t || {};
        for(var e = $2b056e5321c0aa1d$var$V({}, t), r = Object.keys(i), s = 0; s < r.length; s++)e[r[s]] = i[r[s]];
        return this.ae || ($2b056e5321c0aa1d$var$Hn.warn(" Overriding feature flags!", {
            enabledFlags: t,
            overriddenFlags: i,
            finalFlags: e
        }), this.ae = !0), e;
    }
    getFlagPayloads() {
        var t = this.N.get_property($2b056e5321c0aa1d$var$Jn), i = this.N.get_property($2b056e5321c0aa1d$var$Vn);
        if (!i) return t || {};
        for(var e = $2b056e5321c0aa1d$var$V({}, t || {}), r = Object.keys(i), s = 0; s < r.length; s++)e[r[s]] = i[r[s]];
        return this.ae || ($2b056e5321c0aa1d$var$Hn.warn(" Overriding feature flag payloads!", {
            flagPayloads: t,
            overriddenPayloads: i,
            finalPayloads: e
        }), this.ae = !0), e;
    }
    reloadFeatureFlags() {
        this.ue || this.N.config.advanced_disable_feature_flags || this.fe || (this.fe = setTimeout(()=>{
            this.pe();
        }, 5));
    }
    ge() {
        clearTimeout(this.fe), this.fe = void 0;
    }
    ensureFlagsLoaded() {
        this.le || this.he || this.fe || this.reloadFeatureFlags();
    }
    setAnonymousDistinctId(t) {
        this.$anon_distinct_id = t;
    }
    setReloadingPaused(t) {
        this.ue = t;
    }
    pe(i) {
        var e;
        if (this.ge(), !this.N.config.advanced_disable_decide) {
            if (this.he) this.de = !0;
            else {
                var r = {
                    token: this.N.config.token,
                    distinct_id: this.N.get_distinct_id(),
                    groups: this.N.getGroups(),
                    $anon_distinct_id: this.$anon_distinct_id,
                    person_properties: $2b056e5321c0aa1d$var$B({}, (null == (e = this.N.persistence) ? void 0 : e.get_initial_props()) || {}, this.N.get_property($2b056e5321c0aa1d$var$Rt) || {}),
                    group_properties: this.N.get_property($2b056e5321c0aa1d$var$Tt)
                };
                (null != i && i.disableFlags || this.N.config.advanced_disable_feature_flags) && (r.disable_flags = !0);
                var s = this.N.config.__preview_flags_v2 && this.N.config.__preview_remote_config;
                s && (r.timezone = $2b056e5321c0aa1d$var$zn()), this.he = !0, this.N._e({
                    method: "POST",
                    url: this.N.requestRouter.endpointFor("api", s ? "/flags/?v=2" : "/decide/?v=4"),
                    data: r,
                    compression: this.N.config.disable_compression ? void 0 : $2b056e5321c0aa1d$export$6a00d17b5aff0af.Base64,
                    timeout: this.N.config.feature_flag_request_timeout_ms,
                    callback: (t)=>{
                        var i, e, s, n = !0;
                        (200 === t.statusCode && (this.de || (this.$anon_distinct_id = void 0), n = !1), this.he = !1, this.ve) || (this.ve = !0, this.N.me(null !== (s = t.json) && void 0 !== s ? s : {}));
                        r.disable_flags && !this.de || (this.ce = !n, t.json && null != (i = t.json.quotaLimited) && i.includes($2b056e5321c0aa1d$var$Bn.FeatureFlags) ? $2b056e5321c0aa1d$var$Hn.warn("You have hit your feature flags quota limit, and will not be able to load feature flags until the quota is reset.  Please visit https://posthog.com/docs/billing/limits-alerts to learn more.") : (this.receivedFeatureFlags(null !== (e = t.json) && void 0 !== e ? e : {}, n), this.de && (this.de = !1, this.pe())));
                    }
                });
            }
        }
    }
    getFeatureFlag(t, i) {
        if (void 0 === i && (i = {}), this.le || this.getFlags() && this.getFlags().length > 0) {
            var e = this.getFlagVariants()[t], r = "" + e, s = this.N.get_property($2b056e5321c0aa1d$var$Kn) || void 0, n = this.N.get_property($2b056e5321c0aa1d$var$Ot) || {};
            if ((i.send_event || !("send_event" in i)) && (!(t in n) || !n[t].includes(r))) {
                var o, a, l, h, u, d, v, c, f, p, g;
                $2b056e5321c0aa1d$var$x(n[t]) ? n[t].push(r) : n[t] = [
                    r
                ], null == (o = this.N.persistence) || o.register({
                    [$2b056e5321c0aa1d$var$Ot]: n
                });
                var _ = this.getFeatureFlagDetails(t), m = {
                    $feature_flag: t,
                    $feature_flag_response: e,
                    $feature_flag_payload: this.getFeatureFlagPayload(t) || null,
                    $feature_flag_request_id: s,
                    $feature_flag_bootstrapped_response: (null == (a = this.N.config.bootstrap) || null == (l = a.featureFlags) ? void 0 : l[t]) || null,
                    $feature_flag_bootstrapped_payload: (null == (h = this.N.config.bootstrap) || null == (u = h.featureFlagPayloads) ? void 0 : u[t]) || null,
                    $used_bootstrap_value: !this.ce
                };
                $2b056e5321c0aa1d$var$R(null == _ || null == (d = _.metadata) ? void 0 : d.version) || (m.$feature_flag_version = _.metadata.version);
                var b, w = null !== (v = null == _ || null == (c = _.reason) ? void 0 : c.description) && void 0 !== v ? v : null == _ || null == (f = _.reason) ? void 0 : f.code;
                if (w && (m.$feature_flag_reason = w), null != _ && null != (p = _.metadata) && p.id && (m.$feature_flag_id = _.metadata.id), $2b056e5321c0aa1d$var$R(null == _ ? void 0 : _.original_variant) && $2b056e5321c0aa1d$var$R(null == _ ? void 0 : _.original_enabled) || (m.$feature_flag_original_response = $2b056e5321c0aa1d$var$R(_.original_variant) ? _.original_enabled : _.original_variant), null != _ && null != (g = _.metadata) && g.original_payload) m.$feature_flag_original_payload = null == _ || null == (b = _.metadata) ? void 0 : b.original_payload;
                this.N.capture("$feature_flag_called", m);
            }
            return e;
        }
        $2b056e5321c0aa1d$var$Hn.warn('getFeatureFlag for key "' + t + "\" failed. Feature flags didn't load in time.");
    }
    getFeatureFlagDetails(t) {
        return this.getFlagsWithDetails()[t];
    }
    getFeatureFlagPayload(t) {
        return this.getFlagPayloads()[t];
    }
    getRemoteConfigPayload(i, e) {
        var r = this.N.config.token;
        this.N._e({
            method: "POST",
            url: this.N.requestRouter.endpointFor("api", "/decide/?v=4"),
            data: {
                distinct_id: this.N.get_distinct_id(),
                token: r
            },
            compression: this.N.config.disable_compression ? void 0 : $2b056e5321c0aa1d$export$6a00d17b5aff0af.Base64,
            timeout: this.N.config.feature_flag_request_timeout_ms,
            callback: (t)=>{
                var r, s = null == (r = t.json) ? void 0 : r.featureFlagPayloads;
                e((null == s ? void 0 : s[i]) || void 0);
            }
        });
    }
    isFeatureEnabled(t, i) {
        if (void 0 === i && (i = {}), this.le || this.getFlags() && this.getFlags().length > 0) return !!this.getFeatureFlag(t, i);
        $2b056e5321c0aa1d$var$Hn.warn('isFeatureEnabled for key "' + t + "\" failed. Feature flags didn't load in time.");
    }
    addFeatureFlagsHandler(t) {
        this.featureFlagEventHandlers.push(t);
    }
    removeFeatureFlagsHandler(t) {
        this.featureFlagEventHandlers = this.featureFlagEventHandlers.filter((i)=>i !== t);
    }
    receivedFeatureFlags(t, i) {
        if (this.N.persistence) {
            this.le = !0;
            var e = this.getFlagVariants(), r = this.getFlagPayloads(), s = this.getFlagsWithDetails();
            !function(t, i, e, r, s) {
                void 0 === e && (e = {}), void 0 === r && (r = {}), void 0 === s && (s = {});
                var n = $2b056e5321c0aa1d$var$Xn(t), o = n.flags, a = n.featureFlags, l = n.featureFlagPayloads;
                if (a) {
                    var h = t.requestId;
                    if ($2b056e5321c0aa1d$var$x(a)) {
                        $2b056e5321c0aa1d$var$Hn.warn("v1 of the feature flags endpoint is deprecated. Please use the latest version.");
                        var u = {};
                        if (a) for(var d = 0; d < a.length; d++)u[a[d]] = !0;
                        i && i.register({
                            [$2b056e5321c0aa1d$var$Wn]: a,
                            [$2b056e5321c0aa1d$var$Et]: u
                        });
                    } else {
                        var v = a, c = l, f = o;
                        t.errorsWhileComputingFlags && (v = $2b056e5321c0aa1d$var$B({}, e, v), c = $2b056e5321c0aa1d$var$B({}, r, c), f = $2b056e5321c0aa1d$var$B({}, s, f)), i && i.register($2b056e5321c0aa1d$var$B({
                            [$2b056e5321c0aa1d$var$Wn]: Object.keys($2b056e5321c0aa1d$var$Yn(v)),
                            [$2b056e5321c0aa1d$var$Et]: v || {},
                            [$2b056e5321c0aa1d$var$Jn]: c || {},
                            [$2b056e5321c0aa1d$var$Pt]: f || {}
                        }, h ? {
                            [$2b056e5321c0aa1d$var$Kn]: h
                        } : {}));
                    }
                }
            }(t, this.N.persistence, e, r, s), this.be(i);
        }
    }
    override(t, i) {
        void 0 === i && (i = !1), $2b056e5321c0aa1d$var$Hn.warn("override is deprecated. Please use overrideFeatureFlags instead."), this.overrideFeatureFlags({
            flags: t,
            suppressWarning: i
        });
    }
    overrideFeatureFlags(t) {
        if (!this.N.__loaded || !this.N.persistence) return $2b056e5321c0aa1d$var$Hn.uninitializedWarning("posthog.featureFlags.overrideFeatureFlags");
        if (!1 === t) return this.N.persistence.unregister($2b056e5321c0aa1d$var$Gn), this.N.persistence.unregister($2b056e5321c0aa1d$var$Vn), void this.be();
        if (t && "object" == typeof t && ("flags" in t || "payloads" in t)) {
            var i, e = t;
            if (this.ae = Boolean(null !== (i = e.suppressWarning) && void 0 !== i && i), "flags" in e) {
                if (!1 === e.flags) this.N.persistence.unregister($2b056e5321c0aa1d$var$Gn);
                else if (e.flags) {
                    if ($2b056e5321c0aa1d$var$x(e.flags)) {
                        for(var r = {}, s = 0; s < e.flags.length; s++)r[e.flags[s]] = !0;
                        this.N.persistence.register({
                            [$2b056e5321c0aa1d$var$Gn]: r
                        });
                    } else this.N.persistence.register({
                        [$2b056e5321c0aa1d$var$Gn]: e.flags
                    });
                }
            }
            return "payloads" in e && (!1 === e.payloads ? this.N.persistence.unregister($2b056e5321c0aa1d$var$Vn) : e.payloads && this.N.persistence.register({
                [$2b056e5321c0aa1d$var$Vn]: e.payloads
            })), void this.be();
        }
        this.be();
    }
    onFeatureFlags(t) {
        if (this.addFeatureFlagsHandler(t), this.le) {
            var { flags: i, flagVariants: e } = this.we();
            t(i, e);
        }
        return ()=>this.removeFeatureFlagsHandler(t);
    }
    updateEarlyAccessFeatureEnrollment(t, i) {
        var e, r = (this.N.get_property($2b056e5321c0aa1d$var$It) || []).find((i)=>i.flagKey === t), s = {
            ["$feature_enrollment/" + t]: i
        }, n = {
            $feature_flag: t,
            $feature_enrollment: i,
            $set: s
        };
        r && (n.$early_access_feature_name = r.name), this.N.capture("$feature_enrollment_update", n), this.setPersonPropertiesForFlags(s, !1);
        var o = $2b056e5321c0aa1d$var$B({}, this.getFlagVariants(), {
            [t]: i
        });
        null == (e = this.N.persistence) || e.register({
            [$2b056e5321c0aa1d$var$Wn]: Object.keys($2b056e5321c0aa1d$var$Yn(o)),
            [$2b056e5321c0aa1d$var$Et]: o
        }), this.be();
    }
    getEarlyAccessFeatures(t, i, e) {
        void 0 === i && (i = !1);
        var r = this.N.get_property($2b056e5321c0aa1d$var$It), s = e ? "&" + e.map((t)=>"stage=" + t).join("&") : "";
        if (r && !i) return t(r);
        this.N._e({
            url: this.N.requestRouter.endpointFor("api", "/api/early_access_features/?token=" + this.N.config.token + s),
            method: "GET",
            callback: (i)=>{
                var e;
                if (i.json) {
                    var r = i.json.earlyAccessFeatures;
                    return null == (e = this.N.persistence) || e.register({
                        [$2b056e5321c0aa1d$var$It]: r
                    }), t(r);
                }
            }
        });
    }
    we() {
        var t = this.getFlags(), i = this.getFlagVariants();
        return {
            flags: t.filter((t)=>i[t]),
            flagVariants: Object.keys(i).filter((t)=>i[t]).reduce((t, e)=>(t[e] = i[e], t), {})
        };
    }
    be(t) {
        var { flags: i, flagVariants: e } = this.we();
        this.featureFlagEventHandlers.forEach((r)=>r(i, e, {
                errorsLoading: t
            }));
    }
    setPersonPropertiesForFlags(t, i) {
        void 0 === i && (i = !0);
        var e = this.N.get_property($2b056e5321c0aa1d$var$Rt) || {};
        this.N.register({
            [$2b056e5321c0aa1d$var$Rt]: $2b056e5321c0aa1d$var$B({}, e, t)
        }), i && this.N.reloadFeatureFlags();
    }
    resetPersonPropertiesForFlags() {
        this.N.unregister($2b056e5321c0aa1d$var$Rt);
    }
    setGroupPropertiesForFlags(t, i) {
        void 0 === i && (i = !0);
        var e = this.N.get_property($2b056e5321c0aa1d$var$Tt) || {};
        0 !== Object.keys(e).length && Object.keys(e).forEach((i)=>{
            e[i] = $2b056e5321c0aa1d$var$B({}, e[i], t[i]), delete t[i];
        }), this.N.register({
            [$2b056e5321c0aa1d$var$Tt]: $2b056e5321c0aa1d$var$B({}, e, t)
        }), i && this.N.reloadFeatureFlags();
    }
    resetGroupPropertiesForFlags(t) {
        if (t) {
            var i = this.N.get_property($2b056e5321c0aa1d$var$Tt) || {};
            this.N.register({
                [$2b056e5321c0aa1d$var$Tt]: $2b056e5321c0aa1d$var$B({}, i, {
                    [t]: {}
                })
            });
        } else this.N.unregister($2b056e5321c0aa1d$var$Tt);
    }
}
var $2b056e5321c0aa1d$var$Zn = [
    "cookie",
    "localstorage",
    "localstorage+cookie",
    "sessionstorage",
    "memory"
];
class $2b056e5321c0aa1d$var$to {
    constructor(t){
        this.S = t, this.props = {}, this.ye = !1, this.Se = ((t)=>{
            var i = "";
            return t.token && (i = t.token.replace(/\+/g, "PL").replace(/\//g, "SL").replace(/=/g, "EQ")), t.persistence_name ? "ph_" + t.persistence_name : "ph_" + i + "_posthog";
        })(t), this.B = this.$e(t), this.load(), t.debug && $2b056e5321c0aa1d$var$N.info("Persistence loaded", t.persistence, $2b056e5321c0aa1d$var$B({}, this.props)), this.update_config(t, t), this.save();
    }
    $e(t) {
        -1 === $2b056e5321c0aa1d$var$Zn.indexOf(t.persistence.toLowerCase()) && ($2b056e5321c0aa1d$var$N.critical("Unknown persistence type " + t.persistence + "; falling back to localStorage+cookie"), t.persistence = "localStorage+cookie");
        var i = t.persistence.toLowerCase();
        return "localstorage" === i && $2b056e5321c0aa1d$var$Gi.O() ? $2b056e5321c0aa1d$var$Gi : "localstorage+cookie" === i && $2b056e5321c0aa1d$var$Vi.O() ? $2b056e5321c0aa1d$var$Vi : "sessionstorage" === i && $2b056e5321c0aa1d$var$Qi.O() ? $2b056e5321c0aa1d$var$Qi : "memory" === i ? $2b056e5321c0aa1d$var$Yi : "cookie" === i ? $2b056e5321c0aa1d$var$Hi : $2b056e5321c0aa1d$var$Vi.O() ? $2b056e5321c0aa1d$var$Vi : $2b056e5321c0aa1d$var$Hi;
    }
    properties() {
        var t = {};
        return $2b056e5321c0aa1d$var$J(this.props, function(i, e) {
            if (e === $2b056e5321c0aa1d$var$Et && $2b056e5321c0aa1d$var$I(i)) for(var r = Object.keys(i), s = 0; s < r.length; s++)t["$feature/" + r[s]] = i[r[s]];
            else a = e, l = !1, ($2b056e5321c0aa1d$var$C(o = $2b056e5321c0aa1d$var$Bt) ? l : $2b056e5321c0aa1d$var$n && o.indexOf === $2b056e5321c0aa1d$var$n ? -1 != o.indexOf(a) : ($2b056e5321c0aa1d$var$J(o, function(t) {
                if (l || (l = t === a)) return $2b056e5321c0aa1d$var$W;
            }), l)) || (t[e] = i);
            var o, a, l;
        }), t;
    }
    load() {
        if (!this.ke) {
            var t = this.B.D(this.Se);
            t && (this.props = $2b056e5321c0aa1d$var$V({}, t));
        }
    }
    save() {
        this.ke || this.B.j(this.Se, this.props, this.xe, this.Ee, this.Ie, this.S.debug);
    }
    remove() {
        this.B.L(this.Se, !1), this.B.L(this.Se, !0);
    }
    clear() {
        this.remove(), this.props = {};
    }
    register_once(t, i, e) {
        if ($2b056e5321c0aa1d$var$I(t)) {
            $2b056e5321c0aa1d$var$R(i) && (i = "None"), this.xe = $2b056e5321c0aa1d$var$R(e) ? this.Pe : e;
            var r = !1;
            if ($2b056e5321c0aa1d$var$J(t, (t, e)=>{
                this.props.hasOwnProperty(e) && this.props[e] !== i || (this.props[e] = t, r = !0);
            }), r) return this.save(), !0;
        }
        return !1;
    }
    register(t, i) {
        if ($2b056e5321c0aa1d$var$I(t)) {
            this.xe = $2b056e5321c0aa1d$var$R(i) ? this.Pe : i;
            var e = !1;
            if ($2b056e5321c0aa1d$var$J(t, (i, r)=>{
                t.hasOwnProperty(r) && this.props[r] !== i && (this.props[r] = i, e = !0);
            }), e) return this.save(), !0;
        }
        return !1;
    }
    unregister(t) {
        t in this.props && (delete this.props[t], this.save());
    }
    update_campaign_params() {
        if (!this.ye) {
            var t = $2b056e5321c0aa1d$var$On(this.S.custom_campaign_params, this.S.mask_personal_data_properties, this.S.custom_personal_data_properties);
            $2b056e5321c0aa1d$var$P($2b056e5321c0aa1d$var$Z(t)) || this.register(t), this.ye = !0;
        }
    }
    update_search_keyword() {
        var t;
        this.register((t = null == $2b056e5321c0aa1d$var$a ? void 0 : $2b056e5321c0aa1d$var$a.referrer) ? $2b056e5321c0aa1d$var$An(t) : {});
    }
    update_referrer_info() {
        var t;
        this.register_once({
            $referrer: $2b056e5321c0aa1d$var$jn(),
            $referring_domain: null != $2b056e5321c0aa1d$var$a && $2b056e5321c0aa1d$var$a.referrer && (null == (t = $2b056e5321c0aa1d$var$wi($2b056e5321c0aa1d$var$a.referrer)) ? void 0 : t.host) || "$direct"
        }, void 0);
    }
    set_initial_person_info() {
        this.props[$2b056e5321c0aa1d$var$jt] || this.props[$2b056e5321c0aa1d$var$Lt] || this.register_once({
            [$2b056e5321c0aa1d$var$Nt]: $2b056e5321c0aa1d$var$Ln(this.S.mask_personal_data_properties, this.S.custom_personal_data_properties)
        }, void 0);
    }
    get_initial_props() {
        var t = {};
        $2b056e5321c0aa1d$var$J([
            $2b056e5321c0aa1d$var$Lt,
            $2b056e5321c0aa1d$var$jt
        ], (i)=>{
            var e = this.props[i];
            e && $2b056e5321c0aa1d$var$J(e, function(i, e) {
                t["$initial_" + $2b056e5321c0aa1d$var$w(e)] = i;
            });
        });
        var i, e, r = this.props[$2b056e5321c0aa1d$var$Nt];
        if (r) {
            var s = (i = $2b056e5321c0aa1d$var$Nn(r), e = {}, $2b056e5321c0aa1d$var$J(i, function(t, i) {
                e["$initial_" + $2b056e5321c0aa1d$var$w(i)] = t;
            }), e);
            $2b056e5321c0aa1d$var$V(t, s);
        }
        return t;
    }
    safe_merge(t) {
        return $2b056e5321c0aa1d$var$J(this.props, function(i, e) {
            e in t || (t[e] = i);
        }), t;
    }
    update_config(t, i) {
        if (this.Pe = this.xe = t.cookie_expiration, this.set_disabled(t.disable_persistence), this.set_cross_subdomain(t.cross_subdomain_cookie), this.set_secure(t.secure_cookie), t.persistence !== i.persistence) {
            var e = this.$e(t), r = this.props;
            this.clear(), this.B = e, this.props = r, this.save();
        }
    }
    set_disabled(t) {
        this.ke = t, this.ke ? this.remove() : this.save();
    }
    set_cross_subdomain(t) {
        t !== this.Ee && (this.Ee = t, this.remove(), this.save());
    }
    set_secure(t) {
        t !== this.Ie && (this.Ie = t, this.remove(), this.save());
    }
    set_event_timer(t, i) {
        var e = this.props[$2b056e5321c0aa1d$var$at] || {};
        e[t] = i, this.props[$2b056e5321c0aa1d$var$at] = e, this.save();
    }
    remove_event_timer(t) {
        var i = (this.props[$2b056e5321c0aa1d$var$at] || {})[t];
        return $2b056e5321c0aa1d$var$R(i) || (delete this.props[$2b056e5321c0aa1d$var$at][t], this.save()), i;
    }
    get_property(t) {
        return this.props[t];
    }
    set_property(t, i) {
        this.props[t] = i, this.save();
    }
}
class $2b056e5321c0aa1d$var$io {
    constructor(){
        this.Re = {}, this.Re = {};
    }
    on(t, i) {
        return this.Re[t] || (this.Re[t] = []), this.Re[t].push(i), ()=>{
            this.Re[t] = this.Re[t].filter((t)=>t !== i);
        };
    }
    emit(t, i) {
        for (var e of this.Re[t] || [])e(i);
        for (var r of this.Re["*"] || [])r(t, i);
    }
}
var $2b056e5321c0aa1d$var$eo = function(t, i) {
    if (!function(t) {
        try {
            new RegExp(t);
        } catch (t) {
            return !1;
        }
        return !0;
    }(i)) return !1;
    try {
        return new RegExp(i).test(t);
    } catch (t) {
        return !1;
    }
};
class $2b056e5321c0aa1d$var$ro {
    constructor(t){
        this.Te = new $2b056e5321c0aa1d$var$io, this.Me = (t, i)=>this.Ce(t, i) && this.Oe(t, i) && this.Fe(t, i), this.Ce = (t, i)=>null == i || !i.event || (null == t ? void 0 : t.event) === (null == i ? void 0 : i.event), this.N = t, this.Ae = new Set, this.De = new Set;
    }
    init() {
        var t;
        if (!$2b056e5321c0aa1d$var$R(null == (t = this.N) ? void 0 : t.je)) {
            var i;
            null == (i = this.N) || i.je((t, i)=>{
                this.on(t, i);
            });
        }
    }
    register(t) {
        var i, e;
        if (!$2b056e5321c0aa1d$var$R(null == (i = this.N) ? void 0 : i.je) && (t.forEach((t)=>{
            var i, e;
            null == (i = this.De) || i.add(t), null == (e = t.steps) || e.forEach((t)=>{
                var i;
                null == (i = this.Ae) || i.add((null == t ? void 0 : t.event) || "");
            });
        }), null != (e = this.N) && e.autocapture)) {
            var r, s = new Set;
            t.forEach((t)=>{
                var i;
                null == (i = t.steps) || i.forEach((t)=>{
                    null != t && t.selector && s.add(null == t ? void 0 : t.selector);
                });
            }), null == (r = this.N) || r.autocapture.setElementSelectors(s);
        }
    }
    on(t, i) {
        var e;
        null != i && 0 != t.length && (this.Ae.has(t) || this.Ae.has(null == i ? void 0 : i.event)) && this.De && (null == (e = this.De) ? void 0 : e.size) > 0 && this.De.forEach((t)=>{
            this.Le(i, t) && this.Te.emit("actionCaptured", t.name);
        });
    }
    Ne(t) {
        this.onAction("actionCaptured", (i)=>t(i));
    }
    Le(t, i) {
        if (null == (null == i ? void 0 : i.steps)) return !1;
        for (var e of i.steps)if (this.Me(t, e)) return !0;
        return !1;
    }
    onAction(t, i) {
        return this.Te.on(t, i);
    }
    Oe(t, i) {
        if (null != i && i.url) {
            var e, r = null == t || null == (e = t.properties) ? void 0 : e.$current_url;
            if (!r || "string" != typeof r) return !1;
            if (!$2b056e5321c0aa1d$var$ro.ze(r, null == i ? void 0 : i.url, (null == i ? void 0 : i.url_matching) || "contains")) return !1;
        }
        return !0;
    }
    static ze(t, e, r) {
        switch(r){
            case "regex":
                return !!$2b056e5321c0aa1d$var$i && $2b056e5321c0aa1d$var$eo(t, e);
            case "exact":
                return e === t;
            case "contains":
                var s = $2b056e5321c0aa1d$var$ro.Ue(e).replace(/_/g, ".").replace(/%/g, ".*");
                return $2b056e5321c0aa1d$var$eo(t, s);
            default:
                return !1;
        }
    }
    static Ue(t) {
        return t.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
    }
    Fe(t, i) {
        if ((null != i && i.href || null != i && i.tag_name || null != i && i.text) && !this.qe(t).some((t)=>!(null != i && i.href && !$2b056e5321c0aa1d$var$ro.ze(t.href || "", null == i ? void 0 : i.href, (null == i ? void 0 : i.href_matching) || "exact")) && (null == i || !i.tag_name || t.tag_name === (null == i ? void 0 : i.tag_name)) && !(null != i && i.text && !$2b056e5321c0aa1d$var$ro.ze(t.text || "", null == i ? void 0 : i.text, (null == i ? void 0 : i.text_matching) || "exact") && !$2b056e5321c0aa1d$var$ro.ze(t.$el_text || "", null == i ? void 0 : i.text, (null == i ? void 0 : i.text_matching) || "exact")))) return !1;
        if (null != i && i.selector) {
            var e, r = null == t || null == (e = t.properties) ? void 0 : e.$element_selectors;
            if (!r) return !1;
            if (!r.includes(null == i ? void 0 : i.selector)) return !1;
        }
        return !0;
    }
    qe(t) {
        return null == (null == t ? void 0 : t.properties.$elements) ? [] : null == t ? void 0 : t.properties.$elements;
    }
}
var $2b056e5321c0aa1d$var$so = $2b056e5321c0aa1d$var$z("[Surveys]");
class $2b056e5321c0aa1d$var$no {
    constructor(t){
        this.N = t, this.Be = new Map, this.He = new Map;
    }
    register(t) {
        var i;
        $2b056e5321c0aa1d$var$R(null == (i = this.N) ? void 0 : i.je) || (this.We(t), this.Ge(t));
    }
    Ge(t) {
        var i = t.filter((t)=>{
            var i, e, r, s;
            return (null == (i = t.conditions) ? void 0 : i.actions) && (null == (e = t.conditions) || null == (r = e.actions) || null == (s = r.values) ? void 0 : s.length) > 0;
        });
        if (0 !== i.length) {
            if (null == this.Je) {
                this.Je = new $2b056e5321c0aa1d$var$ro(this.N), this.Je.init();
                this.Je.Ne((t)=>{
                    this.onAction(t);
                });
            }
            i.forEach((t)=>{
                var i, e, r, s, n, o, a, l, h, u;
                t.conditions && null != (i = t.conditions) && i.actions && null != (e = t.conditions) && null != (r = e.actions) && r.values && (null == (s = t.conditions) || null == (n = s.actions) || null == (o = n.values) ? void 0 : o.length) > 0 && (null == (a = this.Je) || a.register(t.conditions.actions.values), null == (l = t.conditions) || null == (h = l.actions) || null == (u = h.values) || u.forEach((i)=>{
                    if (i && i.name) {
                        var e = this.He.get(i.name);
                        e && e.push(t.id), this.He.set(i.name, e || [
                            t.id
                        ]);
                    }
                }));
            });
        }
    }
    We(t) {
        var i;
        if (0 !== t.filter((t)=>{
            var i, e, r, s;
            return (null == (i = t.conditions) ? void 0 : i.events) && (null == (e = t.conditions) || null == (r = e.events) || null == (s = r.values) ? void 0 : s.length) > 0;
        }).length) null == (i = this.N) || i.je((t, i)=>{
            this.onEvent(t, i);
        }), t.forEach((t)=>{
            var i, e, r;
            null == (i = t.conditions) || null == (e = i.events) || null == (r = e.values) || r.forEach((i)=>{
                if (i && i.name) {
                    var e = this.Be.get(i.name);
                    e && e.push(t.id), this.Be.set(i.name, e || [
                        t.id
                    ]);
                }
            });
        });
    }
    onEvent(t, i) {
        var e, r, s = (null == (e = this.N) || null == (r = e.persistence) ? void 0 : r.props[$2b056e5321c0aa1d$var$Ct]) || [];
        if ("survey shown" === t && i && s.length > 0) {
            var n;
            $2b056e5321c0aa1d$var$so.info("survey event matched, removing survey from activated surveys", {
                event: t,
                eventPayload: i,
                existingActivatedSurveys: s
            });
            var o = null == i || null == (n = i.properties) ? void 0 : n.$survey_id;
            if (o) {
                var a = s.indexOf(o);
                a >= 0 && (s.splice(a, 1), this.Ve(s));
            }
        } else this.Be.has(t) && ($2b056e5321c0aa1d$var$so.info("survey event matched, updating activated surveys", {
            event: t,
            surveys: this.Be.get(t)
        }), this.Ve(s.concat(this.Be.get(t) || [])));
    }
    onAction(t) {
        var i, e, r = (null == (i = this.N) || null == (e = i.persistence) ? void 0 : e.props[$2b056e5321c0aa1d$var$Ct]) || [];
        this.He.has(t) && this.Ve(r.concat(this.He.get(t) || []));
    }
    Ve(t) {
        var i, e;
        null == (i = this.N) || null == (e = i.persistence) || e.register({
            [$2b056e5321c0aa1d$var$Ct]: [
                ...new Set(t)
            ]
        });
    }
    getSurveys() {
        var t, i, e = null == (t = this.N) || null == (i = t.persistence) ? void 0 : i.props[$2b056e5321c0aa1d$var$Ct];
        return e || [];
    }
    getEventToSurveys() {
        return this.Be;
    }
    Ke() {
        return this.Je;
    }
}
class $2b056e5321c0aa1d$var$oo {
    constructor(t){
        this.Ye = null, this.Xe = !1, this.Qe = !1, this.Ze = [], this.N = t, this.tr = null;
    }
    onRemoteConfig(t) {
        var i = t.surveys;
        if ($2b056e5321c0aa1d$var$O(i)) return $2b056e5321c0aa1d$var$so.warn("Decide not loaded yet. Not loading surveys.");
        var e = $2b056e5321c0aa1d$var$x(i);
        this.ir = e ? i.length > 0 : i, $2b056e5321c0aa1d$var$so.info("decide response received, hasSurveys: " + this.ir), this.ir && this.loadIfEnabled();
    }
    reset() {
        localStorage.removeItem("lastSeenSurveyDate");
        for(var t = [], i = 0; i < localStorage.length; i++){
            var e = localStorage.key(i);
            null != e && e.startsWith("seenSurvey_") && t.push(e);
        }
        t.forEach((t)=>localStorage.removeItem(t));
    }
    loadIfEnabled() {
        if (!this.Ye) {
            if (this.Qe) $2b056e5321c0aa1d$var$so.info("Already initializing surveys, skipping...");
            else if (this.N.config.disable_surveys) $2b056e5321c0aa1d$var$so.info("Disabled. Not loading surveys.");
            else if (this.ir) {
                var t = null == $2b056e5321c0aa1d$var$c ? void 0 : $2b056e5321c0aa1d$var$c.__PosthogExtensions__;
                if (t) {
                    this.Qe = !0;
                    try {
                        var i = t.generateSurveys;
                        if (i) return void this.er(i);
                        var e = t.loadExternalDependency;
                        if (!e) return void this.rr("PostHog loadExternalDependency extension not found.");
                        e(this.N, "surveys", (i)=>{
                            i || !t.generateSurveys ? this.rr("Could not load surveys script", i) : this.er(t.generateSurveys);
                        });
                    } catch (t) {
                        throw this.rr("Error initializing surveys", t), t;
                    } finally{
                        this.Qe = !1;
                    }
                } else $2b056e5321c0aa1d$var$so.error("PostHog Extensions not found.");
            } else $2b056e5321c0aa1d$var$so.info("No surveys to load.");
        }
    }
    er(t) {
        this.Ye = t(this.N), this.tr = new $2b056e5321c0aa1d$var$no(this.N), $2b056e5321c0aa1d$var$so.info("Surveys loaded successfully"), this.sr({
            isLoaded: !0
        });
    }
    rr(t, i) {
        $2b056e5321c0aa1d$var$so.error(t, i), this.sr({
            isLoaded: !1,
            error: t
        });
    }
    onSurveysLoaded(t) {
        return this.Ze.push(t), this.Ye && this.sr({
            isLoaded: !0
        }), ()=>{
            this.Ze = this.Ze.filter((i)=>i !== t);
        };
    }
    getSurveys(t, i) {
        if (void 0 === i && (i = !1), this.N.config.disable_surveys) return $2b056e5321c0aa1d$var$so.info("Disabled. Not loading surveys."), t([]);
        var e = this.N.get_property($2b056e5321c0aa1d$var$Mt);
        if (e && !i) return t(e, {
            isLoaded: !0
        });
        if (this.Xe) return t([], {
            isLoaded: !1,
            error: "Surveys are already being loaded"
        });
        try {
            this.Xe = !0, this.N._e({
                url: this.N.requestRouter.endpointFor("api", "/api/surveys/?token=" + this.N.config.token),
                method: "GET",
                timeout: this.N.config.surveys_request_timeout_ms,
                callback: (i)=>{
                    var e;
                    this.Xe = !1;
                    var r = i.statusCode;
                    if (200 !== r || !i.json) {
                        var s = "Surveys API could not be loaded, status: " + r;
                        return $2b056e5321c0aa1d$var$so.error(s), t([], {
                            isLoaded: !1,
                            error: s
                        });
                    }
                    var n, o = i.json.surveys || [], a = o.filter((t)=>(function(t) {
                            return !(!t.start_date || t.end_date);
                        })(t) && (function(t) {
                            var i, e, r;
                            return !(null == (i = t.conditions) || null == (e = i.events) || null == (r = e.values) || !r.length);
                        }(t) || function(t) {
                            var i, e, r;
                            return !(null == (i = t.conditions) || null == (e = i.actions) || null == (r = e.values) || !r.length);
                        }(t)));
                    a.length > 0 && (null == (n = this.tr) || n.register(a));
                    return null == (e = this.N.persistence) || e.register({
                        [$2b056e5321c0aa1d$var$Mt]: o
                    }), t(o, {
                        isLoaded: !0
                    });
                }
            });
        } catch (t) {
            throw this.Xe = !1, t;
        }
    }
    sr(t) {
        for (var i of this.Ze)try {
            t.isLoaded ? this.getSurveys(i) : i([], t);
        } catch (t) {
            $2b056e5321c0aa1d$var$so.error("Error in survey callback", t);
        }
    }
    getActiveMatchingSurveys(t, i) {
        if (void 0 === i && (i = !1), !$2b056e5321c0aa1d$var$O(this.Ye)) return this.Ye.getActiveMatchingSurveys(t, i);
        $2b056e5321c0aa1d$var$so.warn("init was not called");
    }
    nr(t) {
        var i = null;
        return this.getSurveys((e)=>{
            var r;
            i = null !== (r = e.find((i)=>i.id === t)) && void 0 !== r ? r : null;
        }), i;
    }
    ar(t) {
        if ($2b056e5321c0aa1d$var$O(this.Ye)) return {
            eligible: !1,
            reason: "SDK is not enabled or survey functionality is not yet loaded"
        };
        var i = "string" == typeof t ? this.nr(t) : t;
        return i ? this.Ye.checkSurveyEligibility(i) : {
            eligible: !1,
            reason: "Survey not found"
        };
    }
    canRenderSurvey(t) {
        if (!$2b056e5321c0aa1d$var$O(this.Ye)) return $2b056e5321c0aa1d$var$so.warn("init was not called"), {
            visible: !1,
            disabledReason: "SDK is not enabled or survey functionality is not yet loaded"
        };
        var i = this.ar(t);
        return {
            visible: i.eligible,
            disabledReason: i.reason
        };
    }
    canRenderSurveyAsync(t, i) {
        return $2b056e5321c0aa1d$var$O(this.Ye) ? ($2b056e5321c0aa1d$var$so.warn("init was not called"), Promise.resolve({
            visible: !1,
            disabledReason: "SDK is not enabled or survey functionality is not yet loaded"
        })) : new Promise((e)=>{
            this.getSurveys((i)=>{
                var r, s = null !== (r = i.find((i)=>i.id === t)) && void 0 !== r ? r : null;
                if (s) {
                    var n = this.ar(s);
                    e({
                        visible: n.eligible,
                        disabledReason: n.reason
                    });
                } else e({
                    visible: !1,
                    disabledReason: "Survey not found"
                });
            }, i);
        });
    }
    renderSurvey(t, i) {
        if ($2b056e5321c0aa1d$var$O(this.Ye)) $2b056e5321c0aa1d$var$so.warn("init was not called");
        else {
            var e = this.nr(t), r = null == $2b056e5321c0aa1d$var$a ? void 0 : $2b056e5321c0aa1d$var$a.querySelector(i);
            e ? r ? this.Ye.renderSurvey(e, r) : $2b056e5321c0aa1d$var$so.warn("Survey element not found") : $2b056e5321c0aa1d$var$so.warn("Survey not found");
        }
    }
}
var $2b056e5321c0aa1d$var$ao = $2b056e5321c0aa1d$var$z("[RateLimiter]");
class $2b056e5321c0aa1d$var$lo {
    constructor(t){
        var i, e;
        this.serverLimits = {}, this.lastEventRateLimited = !1, this.checkForLimiting = (t)=>{
            var i = t.text;
            if (i && i.length) try {
                (JSON.parse(i).quota_limited || []).forEach((t)=>{
                    $2b056e5321c0aa1d$var$ao.info((t || "events") + " is quota limited."), this.serverLimits[t] = (new Date).getTime() + 6e4;
                });
            } catch (t) {
                return void $2b056e5321c0aa1d$var$ao.warn('could not rate limit - continuing. Error: "' + (null == t ? void 0 : t.message) + '"', {
                    text: i
                });
            }
        }, this.instance = t, this.captureEventsPerSecond = (null == (i = t.config.rate_limiting) ? void 0 : i.events_per_second) || 10, this.captureEventsBurstLimit = Math.max((null == (e = t.config.rate_limiting) ? void 0 : e.events_burst_limit) || 10 * this.captureEventsPerSecond, this.captureEventsPerSecond), this.lastEventRateLimited = this.clientRateLimitContext(!0).isRateLimited;
    }
    clientRateLimitContext(t) {
        var i, e, r;
        void 0 === t && (t = !1);
        var s = (new Date).getTime(), n = null !== (i = null == (e = this.instance.persistence) ? void 0 : e.get_property($2b056e5321c0aa1d$var$Dt)) && void 0 !== i ? i : {
            tokens: this.captureEventsBurstLimit,
            last: s
        };
        n.tokens += (s - n.last) / 1e3 * this.captureEventsPerSecond, n.last = s, n.tokens > this.captureEventsBurstLimit && (n.tokens = this.captureEventsBurstLimit);
        var o = n.tokens < 1;
        return o || t || (n.tokens = Math.max(0, n.tokens - 1)), !o || this.lastEventRateLimited || t || this.instance.capture("$$client_ingestion_warning", {
            $$client_ingestion_warning_message: "posthog-js client rate limited. Config is set to " + this.captureEventsPerSecond + " events per second and " + this.captureEventsBurstLimit + " events burst limit."
        }, {
            skip_client_rate_limiting: !0
        }), this.lastEventRateLimited = o, null == (r = this.instance.persistence) || r.set_property($2b056e5321c0aa1d$var$Dt, n), {
            isRateLimited: o,
            remainingTokens: n.tokens
        };
    }
    isServerRateLimited(t) {
        var i = this.serverLimits[t || "events"] || !1;
        return !1 !== i && (new Date).getTime() < i;
    }
}
var $2b056e5321c0aa1d$var$ho = $2b056e5321c0aa1d$var$z("[RemoteConfig]");
class $2b056e5321c0aa1d$var$uo {
    constructor(t){
        this.N = t;
    }
    get remoteConfig() {
        var t, i;
        return null == (t = $2b056e5321c0aa1d$var$c._POSTHOG_REMOTE_CONFIG) || null == (i = t[this.N.config.token]) ? void 0 : i.config;
    }
    lr(t) {
        var i, e;
        null != (i = $2b056e5321c0aa1d$var$c.__PosthogExtensions__) && i.loadExternalDependency ? null == (e = $2b056e5321c0aa1d$var$c.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this.N, "remote-config", ()=>t(this.remoteConfig)) : ($2b056e5321c0aa1d$var$ho.error("PostHog Extensions not found. Cannot load remote config."), t());
    }
    hr(t) {
        this.N._e({
            method: "GET",
            url: this.N.requestRouter.endpointFor("assets", "/array/" + this.N.config.token + "/config"),
            callback: (i)=>{
                t(i.json);
            }
        });
    }
    load() {
        try {
            if (this.remoteConfig) return $2b056e5321c0aa1d$var$ho.info("Using preloaded remote config", this.remoteConfig), void this.me(this.remoteConfig);
            if (this.N.config.advanced_disable_decide) return void $2b056e5321c0aa1d$var$ho.warn("Remote config is disabled. Falling back to local config.");
            this.lr((t)=>{
                if (!t) return $2b056e5321c0aa1d$var$ho.info("No config found after loading remote JS config. Falling back to JSON."), void this.hr((t)=>{
                    this.me(t);
                });
                this.me(t);
            });
        } catch (t) {
            $2b056e5321c0aa1d$var$ho.error("Error loading remote config", t);
        }
    }
    me(t) {
        t ? this.N.config.__preview_remote_config ? (this.N.me(t), !1 !== t.hasFeatureFlags && this.N.featureFlags.ensureFlagsLoaded()) : $2b056e5321c0aa1d$var$ho.info("__preview_remote_config is disabled. Logging config instead", t) : $2b056e5321c0aa1d$var$ho.error("Failed to fetch remote config from PostHog.");
    }
}
var $2b056e5321c0aa1d$var$vo = function(t) {
    var i, e, r, s, n = "";
    for(i = e = 0, r = (t = (t + "").replace(/\r\n/g, "\n").replace(/\r/g, "\n")).length, s = 0; s < r; s++){
        var o = t.charCodeAt(s), a = null;
        o < 128 ? e++ : a = o > 127 && o < 2048 ? String.fromCharCode(o >> 6 | 192, 63 & o | 128) : String.fromCharCode(o >> 12 | 224, o >> 6 & 63 | 128, 63 & o | 128), $2b056e5321c0aa1d$var$C(a) || (e > i && (n += t.substring(i, e)), n += a, i = e = s + 1);
    }
    return e > i && (n += t.substring(i, t.length)), n;
}, $2b056e5321c0aa1d$var$co = !!$2b056e5321c0aa1d$var$u || !!$2b056e5321c0aa1d$var$h, $2b056e5321c0aa1d$var$fo = "text/plain", $2b056e5321c0aa1d$var$po = (t, i)=>{
    var [e, r] = t.split("?"), s = $2b056e5321c0aa1d$var$B({}, i);
    null == r || r.split("&").forEach((t)=>{
        var [i] = t.split("=");
        delete s[i];
    });
    var n = $2b056e5321c0aa1d$var$yi(s);
    return e + "?" + (n = n ? (r ? r + "&" : "") + n : r);
}, $2b056e5321c0aa1d$var$go = (t, i)=>JSON.stringify(t, (t, i)=>"bigint" == typeof i ? i.toString() : i, i), $2b056e5321c0aa1d$var$_o = (i)=>{
    var { data: e, compression: r } = i;
    if (e) {
        if (r === $2b056e5321c0aa1d$export$6a00d17b5aff0af.GZipJS) {
            var s = $2b056e5321c0aa1d$var$Ar($2b056e5321c0aa1d$var$Dr($2b056e5321c0aa1d$var$go(e)), {
                mtime: 0
            }), n = new Blob([
                s
            ], {
                type: $2b056e5321c0aa1d$var$fo
            });
            return {
                contentType: $2b056e5321c0aa1d$var$fo,
                body: n,
                estimatedSize: n.size
            };
        }
        if (r === $2b056e5321c0aa1d$export$6a00d17b5aff0af.Base64) {
            var o = function(t) {
                var i, e, r, s, n, o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", a = 0, l = 0, h = "", u = [];
                if (!t) return t;
                t = $2b056e5321c0aa1d$var$vo(t);
                do i = (n = t.charCodeAt(a++) << 16 | t.charCodeAt(a++) << 8 | t.charCodeAt(a++)) >> 18 & 63, e = n >> 12 & 63, r = n >> 6 & 63, s = 63 & n, u[l++] = o.charAt(i) + o.charAt(e) + o.charAt(r) + o.charAt(s);
                while (a < t.length);
                switch(h = u.join(""), t.length % 3){
                    case 1:
                        h = h.slice(0, -2) + "==";
                        break;
                    case 2:
                        h = h.slice(0, -1) + "=";
                }
                return h;
            }($2b056e5321c0aa1d$var$go(e)), a = ((t)=>"data=" + encodeURIComponent("string" == typeof t ? t : $2b056e5321c0aa1d$var$go(t)))(o);
            return {
                contentType: "application/x-www-form-urlencoded",
                body: a,
                estimatedSize: new Blob([
                    a
                ]).size
            };
        }
        var l = $2b056e5321c0aa1d$var$go(e);
        return {
            contentType: "application/json",
            body: l,
            estimatedSize: new Blob([
                l
            ]).size
        };
    }
}, $2b056e5321c0aa1d$var$mo = [];
$2b056e5321c0aa1d$var$h && $2b056e5321c0aa1d$var$mo.push({
    transport: "fetch",
    method: (t)=>{
        var i, e, { contentType: r, body: s, estimatedSize: n } = null !== (i = $2b056e5321c0aa1d$var$_o(t)) && void 0 !== i ? i : {}, o = new Headers;
        $2b056e5321c0aa1d$var$J(t.headers, function(t, i) {
            o.append(i, t);
        }), r && o.append("Content-Type", r);
        var a = t.url, l = null;
        if ($2b056e5321c0aa1d$var$d) {
            var u = new $2b056e5321c0aa1d$var$d;
            l = {
                signal: u.signal,
                timeout: setTimeout(()=>u.abort(), t.timeout)
            };
        }
        $2b056e5321c0aa1d$var$h(a, $2b056e5321c0aa1d$var$B({
            method: (null == t ? void 0 : t.method) || "GET",
            headers: o,
            keepalive: "POST" === t.method && (n || 0) < 52428.8,
            body: s,
            signal: null == (e = l) ? void 0 : e.signal
        }, t.fetchOptions)).then((i)=>i.text().then((e)=>{
                var r = {
                    statusCode: i.status,
                    text: e
                };
                if (200 === i.status) try {
                    r.json = JSON.parse(e);
                } catch (t) {
                    $2b056e5321c0aa1d$var$N.error(t);
                }
                null == t.callback || t.callback(r);
            })).catch((i)=>{
            $2b056e5321c0aa1d$var$N.error(i), null == t.callback || t.callback({
                statusCode: 0,
                text: i
            });
        }).finally(()=>l ? clearTimeout(l.timeout) : null);
    }
}), $2b056e5321c0aa1d$var$u && $2b056e5321c0aa1d$var$mo.push({
    transport: "XHR",
    method: (t)=>{
        var i, e = new $2b056e5321c0aa1d$var$u;
        e.open(t.method || "GET", t.url, !0);
        var { contentType: r, body: s } = null !== (i = $2b056e5321c0aa1d$var$_o(t)) && void 0 !== i ? i : {};
        $2b056e5321c0aa1d$var$J(t.headers, function(t, i) {
            e.setRequestHeader(i, t);
        }), r && e.setRequestHeader("Content-Type", r), t.timeout && (e.timeout = t.timeout), e.withCredentials = !0, e.onreadystatechange = ()=>{
            if (4 === e.readyState) {
                var i = {
                    statusCode: e.status,
                    text: e.responseText
                };
                if (200 === e.status) try {
                    i.json = JSON.parse(e.responseText);
                } catch (t) {}
                null == t.callback || t.callback(i);
            }
        }, e.send(s);
    }
}), null != $2b056e5321c0aa1d$var$o && $2b056e5321c0aa1d$var$o.sendBeacon && $2b056e5321c0aa1d$var$mo.push({
    transport: "sendBeacon",
    method: (t)=>{
        var i = $2b056e5321c0aa1d$var$po(t.url, {
            beacon: "1"
        });
        try {
            var e, { contentType: r, body: s } = null !== (e = $2b056e5321c0aa1d$var$_o(t)) && void 0 !== e ? e : {}, n = "string" == typeof s ? new Blob([
                s
            ], {
                type: r
            }) : s;
            $2b056e5321c0aa1d$var$o.sendBeacon(i, n);
        } catch (t) {}
    }
});
var $2b056e5321c0aa1d$var$bo = 3e3;
class $2b056e5321c0aa1d$var$wo {
    constructor(t, i){
        this.ur = !0, this.dr = [], this.vr = $2b056e5321c0aa1d$var$Xe((null == i ? void 0 : i.flush_interval_ms) || $2b056e5321c0aa1d$var$bo, 250, 5e3, "flush interval", $2b056e5321c0aa1d$var$bo), this.cr = t;
    }
    enqueue(t) {
        this.dr.push(t), this.pr || this.gr();
    }
    unload() {
        this._r();
        var t = this.dr.length > 0 ? this.mr() : {}, i = Object.values(t);
        [
            ...i.filter((t)=>0 === t.url.indexOf("/e")),
            ...i.filter((t)=>0 !== t.url.indexOf("/e"))
        ].map((t)=>{
            this.cr($2b056e5321c0aa1d$var$B({}, t, {
                transport: "sendBeacon"
            }));
        });
    }
    enable() {
        this.ur = !1, this.gr();
    }
    gr() {
        var t = this;
        this.ur || (this.pr = setTimeout(()=>{
            if (this._r(), this.dr.length > 0) {
                var i = this.mr(), e = function(e) {
                    var r = i[e], s = (new Date).getTime();
                    r.data && $2b056e5321c0aa1d$var$x(r.data) && $2b056e5321c0aa1d$var$J(r.data, (t)=>{
                        t.offset = Math.abs(t.timestamp - s), delete t.timestamp;
                    }), t.cr(r);
                };
                for(var r in i)e(r);
            }
        }, this.vr));
    }
    _r() {
        clearTimeout(this.pr), this.pr = void 0;
    }
    mr() {
        var t = {};
        return $2b056e5321c0aa1d$var$J(this.dr, (i)=>{
            var e, r = i, s = (r ? r.batchKey : null) || r.url;
            $2b056e5321c0aa1d$var$R(t[s]) && (t[s] = $2b056e5321c0aa1d$var$B({}, r, {
                data: []
            })), null == (e = t[s].data) || e.push(r.data);
        }), this.dr = [], t;
    }
}
var $2b056e5321c0aa1d$var$yo = [
    "retriesPerformedSoFar"
];
class $2b056e5321c0aa1d$var$So {
    constructor(t){
        this.br = !1, this.wr = 3e3, this.dr = [], this.N = t, this.dr = [], this.yr = !0, !$2b056e5321c0aa1d$var$R($2b056e5321c0aa1d$var$i) && "onLine" in $2b056e5321c0aa1d$var$i.navigator && (this.yr = $2b056e5321c0aa1d$var$i.navigator.onLine, $2b056e5321c0aa1d$var$st($2b056e5321c0aa1d$var$i, "online", ()=>{
            this.yr = !0, this.Xi();
        }), $2b056e5321c0aa1d$var$st($2b056e5321c0aa1d$var$i, "offline", ()=>{
            this.yr = !1;
        }));
    }
    get length() {
        return this.dr.length;
    }
    retriableRequest(t) {
        var { retriesPerformedSoFar: i } = t, e = $2b056e5321c0aa1d$var$H(t, $2b056e5321c0aa1d$var$yo);
        $2b056e5321c0aa1d$var$F(i) && i > 0 && (e.url = $2b056e5321c0aa1d$var$po(e.url, {
            retry_count: i
        })), this.N._e($2b056e5321c0aa1d$var$B({}, e, {
            callback: (t)=>{
                200 !== t.statusCode && (t.statusCode < 400 || t.statusCode >= 500) && (null != i ? i : 0) < 10 ? this.Sr($2b056e5321c0aa1d$var$B({
                    retriesPerformedSoFar: i
                }, e)) : null == e.callback || e.callback(t);
            }
        }));
    }
    Sr(t) {
        var i = t.retriesPerformedSoFar || 0;
        t.retriesPerformedSoFar = i + 1;
        var e = function(t) {
            var i = 3e3 * Math.pow(2, t), e = i / 2, r = Math.min(18e5, i), s = (Math.random() - .5) * (r - e);
            return Math.ceil(r + s);
        }(i), r = Date.now() + e;
        this.dr.push({
            retryAt: r,
            requestOptions: t
        });
        var s = "Enqueued failed request for retry in " + e;
        navigator.onLine || (s += " (Browser is offline)"), $2b056e5321c0aa1d$var$N.warn(s), this.br || (this.br = !0, this.$r());
    }
    $r() {
        this.kr && clearTimeout(this.kr), this.kr = setTimeout(()=>{
            this.yr && this.dr.length > 0 && this.Xi(), this.$r();
        }, this.wr);
    }
    Xi() {
        var t = Date.now(), i = [], e = this.dr.filter((e)=>e.retryAt < t || (i.push(e), !1));
        if (this.dr = i, e.length > 0) for (var { requestOptions: r } of e)this.retriableRequest(r);
    }
    unload() {
        for (var { requestOptions: t } of (this.kr && (clearTimeout(this.kr), this.kr = void 0), this.dr))try {
            this.N._e($2b056e5321c0aa1d$var$B({}, t, {
                transport: "sendBeacon"
            }));
        } catch (t) {
            $2b056e5321c0aa1d$var$N.error(t);
        }
        this.dr = [];
    }
}
class $2b056e5321c0aa1d$var$$o {
    constructor(t){
        this.Er = ()=>{
            var t, i, e, r;
            this.Ir || (this.Ir = {});
            var s = this.scrollElement(), n = this.scrollY(), o = s ? Math.max(0, s.scrollHeight - s.clientHeight) : 0, a = n + ((null == s ? void 0 : s.clientHeight) || 0), l = (null == s ? void 0 : s.scrollHeight) || 0;
            this.Ir.lastScrollY = Math.ceil(n), this.Ir.maxScrollY = Math.max(n, null !== (t = this.Ir.maxScrollY) && void 0 !== t ? t : 0), this.Ir.maxScrollHeight = Math.max(o, null !== (i = this.Ir.maxScrollHeight) && void 0 !== i ? i : 0), this.Ir.lastContentY = a, this.Ir.maxContentY = Math.max(a, null !== (e = this.Ir.maxContentY) && void 0 !== e ? e : 0), this.Ir.maxContentHeight = Math.max(l, null !== (r = this.Ir.maxContentHeight) && void 0 !== r ? r : 0);
        }, this.N = t;
    }
    getContext() {
        return this.Ir;
    }
    resetContext() {
        var t = this.Ir;
        return setTimeout(this.Er, 0), t;
    }
    startMeasuringScrollPosition() {
        $2b056e5321c0aa1d$var$st($2b056e5321c0aa1d$var$i, "scroll", this.Er, {
            capture: !0
        }), $2b056e5321c0aa1d$var$st($2b056e5321c0aa1d$var$i, "scrollend", this.Er, {
            capture: !0
        }), $2b056e5321c0aa1d$var$st($2b056e5321c0aa1d$var$i, "resize", this.Er);
    }
    scrollElement() {
        if (!this.N.config.scroll_root_selector) return null == $2b056e5321c0aa1d$var$i ? void 0 : $2b056e5321c0aa1d$var$i.document.documentElement;
        var t = $2b056e5321c0aa1d$var$x(this.N.config.scroll_root_selector) ? this.N.config.scroll_root_selector : [
            this.N.config.scroll_root_selector
        ];
        for (var e of t){
            var r = null == $2b056e5321c0aa1d$var$i ? void 0 : $2b056e5321c0aa1d$var$i.document.querySelector(e);
            if (r) return r;
        }
    }
    scrollY() {
        if (this.N.config.scroll_root_selector) {
            var t = this.scrollElement();
            return t && t.scrollTop || 0;
        }
        return $2b056e5321c0aa1d$var$i && ($2b056e5321c0aa1d$var$i.scrollY || $2b056e5321c0aa1d$var$i.pageYOffset || $2b056e5321c0aa1d$var$i.document.documentElement.scrollTop) || 0;
    }
    scrollX() {
        if (this.N.config.scroll_root_selector) {
            var t = this.scrollElement();
            return t && t.scrollLeft || 0;
        }
        return $2b056e5321c0aa1d$var$i && ($2b056e5321c0aa1d$var$i.scrollX || $2b056e5321c0aa1d$var$i.pageXOffset || $2b056e5321c0aa1d$var$i.document.documentElement.scrollLeft) || 0;
    }
}
var $2b056e5321c0aa1d$var$ko = (t)=>$2b056e5321c0aa1d$var$Ln(null == t ? void 0 : t.config.mask_personal_data_properties, null == t ? void 0 : t.config.custom_personal_data_properties);
class $2b056e5321c0aa1d$var$xo {
    constructor(t, i, e, r){
        this.Pr = (t)=>{
            var i = this.Rr();
            if (!i || i.sessionId !== t) {
                var e = {
                    sessionId: t,
                    props: this.Tr(this.N)
                };
                this.Mr.register({
                    [$2b056e5321c0aa1d$var$At]: e
                });
            }
        }, this.N = t, this.Cr = i, this.Mr = e, this.Tr = r || $2b056e5321c0aa1d$var$ko, this.Cr.onSessionId(this.Pr);
    }
    Rr() {
        return this.Mr.props[$2b056e5321c0aa1d$var$At];
    }
    getSetOnceProps() {
        var t, i = null == (t = this.Rr()) ? void 0 : t.props;
        return i ? "r" in i ? $2b056e5321c0aa1d$var$Nn(i) : {
            $referring_domain: i.referringDomain,
            $pathname: i.initialPathName,
            utm_source: i.utm_source,
            utm_campaign: i.utm_campaign,
            utm_medium: i.utm_medium,
            utm_content: i.utm_content,
            utm_term: i.utm_term
        } : {};
    }
    getSessionProps() {
        var t = {};
        return $2b056e5321c0aa1d$var$J($2b056e5321c0aa1d$var$Z(this.getSetOnceProps()), (i, e)=>{
            "$current_url" === e && (e = "url"), t["$session_entry_" + $2b056e5321c0aa1d$var$w(e)] = i;
        }), t;
    }
}
var $2b056e5321c0aa1d$var$Eo = $2b056e5321c0aa1d$var$z("[SessionId]");
class $2b056e5321c0aa1d$var$Io {
    constructor(t, i, e){
        var r;
        if (this.Or = [], !t.persistence) throw new Error("SessionIdManager requires a PostHogPersistence instance");
        if (t.config.__preview_experimental_cookieless_mode) throw new Error("SessionIdManager cannot be used with __preview_experimental_cookieless_mode");
        this.S = t.config, this.Mr = t.persistence, this.oi = void 0, this.kt = void 0, this._sessionStartTimestamp = null, this._sessionActivityTimestamp = null, this.Fr = i || $2b056e5321c0aa1d$var$ji, this.Ar = e || $2b056e5321c0aa1d$var$ji;
        var s = this.S.persistence_name || this.S.token, n = this.S.session_idle_timeout_seconds || 1800;
        if (this._sessionTimeoutMs = 1e3 * $2b056e5321c0aa1d$var$Xe(n, 60, 36e3, "session_idle_timeout_seconds", 1800), t.register({
            $configured_session_timeout_ms: this._sessionTimeoutMs
        }), this.Dr(), this.jr = "ph_" + s + "_window_id", this.Lr = "ph_" + s + "_primary_window_exists", this.Nr()) {
            var o = $2b056e5321c0aa1d$var$Qi.D(this.jr), a = $2b056e5321c0aa1d$var$Qi.D(this.Lr);
            o && !a ? this.oi = o : $2b056e5321c0aa1d$var$Qi.L(this.jr), $2b056e5321c0aa1d$var$Qi.j(this.Lr, !0);
        }
        if (null != (r = this.S.bootstrap) && r.sessionID) try {
            var l = ((t)=>{
                var i = t.replace(/-/g, "");
                if (32 !== i.length) throw new Error("Not a valid UUID");
                if ("7" !== i[12]) throw new Error("Not a UUIDv7");
                return parseInt(i.substring(0, 12), 16);
            })(this.S.bootstrap.sessionID);
            this.zr(this.S.bootstrap.sessionID, (new Date).getTime(), l);
        } catch (t) {
            $2b056e5321c0aa1d$var$Eo.error("Invalid sessionID in bootstrap", t);
        }
        this.Ur();
    }
    get sessionTimeoutMs() {
        return this._sessionTimeoutMs;
    }
    onSessionId(t) {
        return $2b056e5321c0aa1d$var$R(this.Or) && (this.Or = []), this.Or.push(t), this.kt && t(this.kt, this.oi), ()=>{
            this.Or = this.Or.filter((i)=>i !== t);
        };
    }
    Nr() {
        return "memory" !== this.S.persistence && !this.Mr.ke && $2b056e5321c0aa1d$var$Qi.O();
    }
    qr(t) {
        t !== this.oi && (this.oi = t, this.Nr() && $2b056e5321c0aa1d$var$Qi.j(this.jr, t));
    }
    Br() {
        return this.oi ? this.oi : this.Nr() ? $2b056e5321c0aa1d$var$Qi.D(this.jr) : null;
    }
    zr(t, i, e) {
        t === this.kt && i === this._sessionActivityTimestamp && e === this._sessionStartTimestamp || (this._sessionStartTimestamp = e, this._sessionActivityTimestamp = i, this.kt = t, this.Mr.register({
            [$2b056e5321c0aa1d$var$St]: [
                i,
                t,
                e
            ]
        }));
    }
    Hr() {
        if (this.kt && this._sessionActivityTimestamp && this._sessionStartTimestamp) return [
            this._sessionActivityTimestamp,
            this.kt,
            this._sessionStartTimestamp
        ];
        var t = this.Mr.props[$2b056e5321c0aa1d$var$St];
        return $2b056e5321c0aa1d$var$x(t) && 2 === t.length && t.push(t[0]), t || [
            0,
            null,
            0
        ];
    }
    resetSessionId() {
        this.zr(null, null, null);
    }
    Ur() {
        $2b056e5321c0aa1d$var$st($2b056e5321c0aa1d$var$i, "beforeunload", ()=>{
            this.Nr() && $2b056e5321c0aa1d$var$Qi.L(this.Lr);
        }, {
            capture: !1
        });
    }
    checkAndGetSessionAndWindowId(t, i) {
        if (void 0 === t && (t = !1), void 0 === i && (i = null), this.S.__preview_experimental_cookieless_mode) throw new Error("checkAndGetSessionAndWindowId should not be called in __preview_experimental_cookieless_mode");
        var e = i || (new Date).getTime(), [r, s, n] = this.Hr(), o = this.Br(), a = $2b056e5321c0aa1d$var$F(n) && n > 0 && Math.abs(e - n) > 864e5, l = !1, h = !s, u = !t && Math.abs(e - r) > this.sessionTimeoutMs;
        h || u || a ? (s = this.Fr(), o = this.Ar(), $2b056e5321c0aa1d$var$Eo.info("new session ID generated", {
            sessionId: s,
            windowId: o,
            changeReason: {
                noSessionId: h,
                activityTimeout: u,
                sessionPastMaximumLength: a
            }
        }), n = e, l = !0) : o || (o = this.Ar(), l = !0);
        var d = 0 === r || !t || a ? e : r, v = 0 === n ? (new Date).getTime() : n;
        return this.qr(o), this.zr(s, d, v), t || this.Dr(), l && this.Or.forEach((t)=>t(s, o, l ? {
                noSessionId: h,
                activityTimeout: u,
                sessionPastMaximumLength: a
            } : void 0)), {
            sessionId: s,
            windowId: o,
            sessionStartTimestamp: v,
            changeReason: l ? {
                noSessionId: h,
                activityTimeout: u,
                sessionPastMaximumLength: a
            } : void 0,
            lastActivityTimestamp: r
        };
    }
    Dr() {
        clearTimeout(this.Wr), this.Wr = setTimeout(()=>{
            this.resetSessionId();
        }, 1.1 * this.sessionTimeoutMs);
    }
}
var $2b056e5321c0aa1d$var$Po = [
    "$set_once",
    "$set"
], $2b056e5321c0aa1d$var$Ro = $2b056e5321c0aa1d$var$z("[SiteApps]");
class $2b056e5321c0aa1d$var$To {
    constructor(t){
        this.N = t, this.Gr = [], this.apps = {};
    }
    get isEnabled() {
        return !!this.N.config.opt_in_site_apps;
    }
    Jr(t, i) {
        if (i) {
            var e = this.globalsForEvent(i);
            this.Gr.push(e), this.Gr.length > 1e3 && (this.Gr = this.Gr.slice(10));
        }
    }
    get siteAppLoaders() {
        var t, i;
        return null == (t = $2b056e5321c0aa1d$var$c._POSTHOG_REMOTE_CONFIG) || null == (i = t[this.N.config.token]) ? void 0 : i.siteApps;
    }
    init() {
        if (this.isEnabled) {
            var t = this.N.je(this.Jr.bind(this));
            this.Vr = ()=>{
                t(), this.Gr = [], this.Vr = void 0;
            };
        }
    }
    globalsForEvent(t) {
        var i, e, r, s, n, o, a;
        if (!t) throw new Error("Event payload is required");
        var l = {}, h = this.N.get_property("$groups") || [], u = this.N.get_property("$stored_group_properties") || {};
        for (var [d, v] of Object.entries(u))l[d] = {
            id: h[d],
            type: d,
            properties: v
        };
        var { $set_once: c, $set: f } = t;
        return {
            event: $2b056e5321c0aa1d$var$B({}, $2b056e5321c0aa1d$var$H(t, $2b056e5321c0aa1d$var$Po), {
                properties: $2b056e5321c0aa1d$var$B({}, t.properties, f ? {
                    $set: $2b056e5321c0aa1d$var$B({}, null !== (i = null == (e = t.properties) ? void 0 : e.$set) && void 0 !== i ? i : {}, f)
                } : {}, c ? {
                    $set_once: $2b056e5321c0aa1d$var$B({}, null !== (r = null == (s = t.properties) ? void 0 : s.$set_once) && void 0 !== r ? r : {}, c)
                } : {}),
                elements_chain: null !== (n = null == (o = t.properties) ? void 0 : o.$elements_chain) && void 0 !== n ? n : "",
                distinct_id: null == (a = t.properties) ? void 0 : a.distinct_id
            }),
            person: {
                properties: this.N.get_property("$stored_person_properties")
            },
            groups: l
        };
    }
    setupSiteApp(t) {
        var i = this.apps[t.id], e = ()=>{
            var e;
            (!i.errored && this.Gr.length && ($2b056e5321c0aa1d$var$Ro.info("Processing " + this.Gr.length + " events for site app with id " + t.id), this.Gr.forEach((t)=>null == i.processEvent ? void 0 : i.processEvent(t)), i.processedBuffer = !0), Object.values(this.apps).every((t)=>t.processedBuffer || t.errored)) && (null == (e = this.Vr) || e.call(this));
        }, r = !1, s = (s)=>{
            i.errored = !s, i.loaded = !0, $2b056e5321c0aa1d$var$Ro.info("Site app with id " + t.id + " " + (s ? "loaded" : "errored")), r && e();
        };
        try {
            var { processEvent: n } = t.init({
                posthog: this.N,
                callback: (t)=>{
                    s(t);
                }
            });
            n && (i.processEvent = n), r = !0;
        } catch (i) {
            $2b056e5321c0aa1d$var$Ro.error("Error while initializing PostHog app with config id " + t.id, i), s(!1);
        }
        if (r && i.loaded) try {
            e();
        } catch (e) {
            $2b056e5321c0aa1d$var$Ro.error("Error while processing buffered events PostHog app with config id " + t.id, e), i.errored = !0;
        }
    }
    Kr() {
        var t = this.siteAppLoaders || [];
        for (var i of t)this.apps[i.id] = {
            id: i.id,
            loaded: !1,
            errored: !1,
            processedBuffer: !1
        };
        for (var e of t)this.setupSiteApp(e);
    }
    Yr(t) {
        if (0 !== Object.keys(this.apps).length) {
            var i = this.globalsForEvent(t);
            for (var e of Object.values(this.apps))try {
                null == e.processEvent || e.processEvent(i);
            } catch (i) {
                $2b056e5321c0aa1d$var$Ro.error("Error while processing event " + t.event + " for site app " + e.id, i);
            }
        }
    }
    onRemoteConfig(t) {
        var i, e, r, s = this;
        if (null != (i = this.siteAppLoaders) && i.length) return this.isEnabled ? (this.Kr(), void this.N.on("eventCaptured", (t)=>this.Yr(t))) : void $2b056e5321c0aa1d$var$Ro.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
        if (null == (e = this.Vr) || e.call(this), null != (r = t.siteApps) && r.length) {
            if (this.isEnabled) {
                var n = function(t, i) {
                    var e;
                    $2b056e5321c0aa1d$var$c["__$$ph_site_app_" + t] = s.N, null == (e = $2b056e5321c0aa1d$var$c.__PosthogExtensions__) || null == e.loadSiteApp || e.loadSiteApp(s.N, i, (i)=>{
                        if (i) return $2b056e5321c0aa1d$var$Ro.error("Error while initializing PostHog app with config id " + t, i);
                    });
                };
                for (var { id: o, url: a } of t.siteApps)n(o, a);
            } else $2b056e5321c0aa1d$var$Ro.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
        }
    }
}
var $2b056e5321c0aa1d$var$Mo, $2b056e5321c0aa1d$var$Co = [
    "amazonbot",
    "amazonproductbot",
    "app.hypefactors.com",
    "applebot",
    "archive.org_bot",
    "awariobot",
    "backlinksextendedbot",
    "baiduspider",
    "bingbot",
    "bingpreview",
    "chrome-lighthouse",
    "dataforseobot",
    "deepscan",
    "duckduckbot",
    "facebookexternal",
    "facebookcatalog",
    "http://yandex.com/bots",
    "hubspot",
    "ia_archiver",
    "linkedinbot",
    "meta-externalagent",
    "mj12bot",
    "msnbot",
    "nessus",
    "petalbot",
    "pinterest",
    "prerender",
    "rogerbot",
    "screaming frog",
    "sebot-wa",
    "sitebulb",
    "slackbot",
    "slurp",
    "trendictionbot",
    "turnitin",
    "twitterbot",
    "vercelbot",
    "yahoo! slurp",
    "yandexbot",
    "zoombot",
    "bot.htm",
    "bot.php",
    "(bot;",
    "bot/",
    "crawler",
    "ahrefsbot",
    "ahrefssiteaudit",
    "semrushbot",
    "siteauditbot",
    "splitsignalbot",
    "gptbot",
    "oai-searchbot",
    "chatgpt-user",
    "perplexitybot",
    "better uptime bot",
    "sentryuptimebot",
    "uptimerobot",
    "headlesschrome",
    "cypress",
    "google-hoteladsverifier",
    "adsbot-google",
    "apis-google",
    "duplexweb-google",
    "feedfetcher-google",
    "google favicon",
    "google web preview",
    "google-read-aloud",
    "googlebot",
    "googleweblight",
    "mediapartners-google",
    "storebot-google",
    "bytespider"
], $2b056e5321c0aa1d$var$Oo = function(t, i) {
    if (!t) return !1;
    var e = t.toLowerCase();
    return $2b056e5321c0aa1d$var$Co.concat(i || []).some((t)=>{
        var i = t.toLowerCase();
        return -1 !== e.indexOf(i);
    });
}, $2b056e5321c0aa1d$var$Fo = function(t, i) {
    if (!t) return !1;
    var e = t.userAgent;
    if (e && $2b056e5321c0aa1d$var$Oo(e, i)) return !0;
    try {
        var r = null == t ? void 0 : t.userAgentData;
        if (null != r && r.brands && r.brands.some((t)=>$2b056e5321c0aa1d$var$Oo(null == t ? void 0 : t.brand, i))) return !0;
    } catch (t) {}
    return !!t.webdriver;
};
function $2b056e5321c0aa1d$var$Ao(t, i, e) {
    return $2b056e5321c0aa1d$var$go({
        distinct_id: t,
        userPropertiesToSet: i,
        userPropertiesToSetOnce: e
    });
}
!function(t) {
    t.US = "us", t.EU = "eu", t.CUSTOM = "custom";
}($2b056e5321c0aa1d$var$Mo || ($2b056e5321c0aa1d$var$Mo = {}));
var $2b056e5321c0aa1d$var$Do = "i.posthog.com";
class $2b056e5321c0aa1d$var$jo {
    constructor(t){
        this.Xr = {}, this.instance = t;
    }
    get apiHost() {
        var t = this.instance.config.api_host.trim().replace(/\/$/, "");
        return "https://app.posthog.com" === t ? "https://us.i.posthog.com" : t;
    }
    get uiHost() {
        var t, i = null == (t = this.instance.config.ui_host) ? void 0 : t.replace(/\/$/, "");
        return i || (i = this.apiHost.replace("." + $2b056e5321c0aa1d$var$Do, ".posthog.com")), "https://app.posthog.com" === i ? "https://us.posthog.com" : i;
    }
    get region() {
        return this.Xr[this.apiHost] || (/https:\/\/(app|us|us-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? this.Xr[this.apiHost] = $2b056e5321c0aa1d$var$Mo.US : /https:\/\/(eu|eu-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? this.Xr[this.apiHost] = $2b056e5321c0aa1d$var$Mo.EU : this.Xr[this.apiHost] = $2b056e5321c0aa1d$var$Mo.CUSTOM), this.Xr[this.apiHost];
    }
    endpointFor(t, i) {
        if (void 0 === i && (i = ""), i && (i = "/" === i[0] ? i : "/" + i), "ui" === t) return this.uiHost + i;
        if (this.region === $2b056e5321c0aa1d$var$Mo.CUSTOM) return this.apiHost + i;
        var e = $2b056e5321c0aa1d$var$Do + i;
        switch(t){
            case "assets":
                return "https://" + this.region + "-assets." + e;
            case "api":
                return "https://" + this.region + "." + e;
        }
    }
}
var $2b056e5321c0aa1d$var$Lo = {
    icontains: (t, e)=>!!$2b056e5321c0aa1d$var$i && e.href.toLowerCase().indexOf(t.toLowerCase()) > -1,
    not_icontains: (t, e)=>!!$2b056e5321c0aa1d$var$i && -1 === e.href.toLowerCase().indexOf(t.toLowerCase()),
    regex: (t, e)=>!!$2b056e5321c0aa1d$var$i && $2b056e5321c0aa1d$var$eo(e.href, t),
    not_regex: (t, e)=>!!$2b056e5321c0aa1d$var$i && !$2b056e5321c0aa1d$var$eo(e.href, t),
    exact: (t, i)=>i.href === t,
    is_not: (t, i)=>i.href !== t
};
class $2b056e5321c0aa1d$var$No {
    constructor(t){
        var i = this;
        this.getWebExperimentsAndEvaluateDisplayLogic = function(t) {
            void 0 === t && (t = !1), i.getWebExperiments((t)=>{
                $2b056e5321c0aa1d$var$No.Qr("retrieved web experiments from the server"), i.Zr = new Map, t.forEach((t)=>{
                    if (t.feature_flag_key) {
                        var e;
                        if (i.Zr) $2b056e5321c0aa1d$var$No.Qr("setting flag key ", t.feature_flag_key, " to web experiment ", t), null == (e = i.Zr) || e.set(t.feature_flag_key, t);
                        var r = i.N.getFeatureFlag(t.feature_flag_key);
                        $2b056e5321c0aa1d$var$T(r) && t.variants[r] && i.ts(t.name, r, t.variants[r].transforms);
                    } else if (t.variants) for(var s in t.variants){
                        var n = t.variants[s];
                        $2b056e5321c0aa1d$var$No.es(n) && i.ts(t.name, s, n.transforms);
                    }
                });
            }, t);
        }, this.N = t, this.N.onFeatureFlags((t)=>{
            this.onFeatureFlags(t);
        });
    }
    onFeatureFlags(t) {
        if (this._is_bot()) $2b056e5321c0aa1d$var$No.Qr("Refusing to render web experiment since the viewer is a likely bot");
        else if (!this.N.config.disable_web_experiments) {
            if ($2b056e5321c0aa1d$var$O(this.Zr)) return this.Zr = new Map, this.loadIfEnabled(), void this.previewWebExperiment();
            $2b056e5321c0aa1d$var$No.Qr("applying feature flags", t), t.forEach((t)=>{
                var i;
                if (this.Zr && null != (i = this.Zr) && i.has(t)) {
                    var e, r = this.N.getFeatureFlag(t), s = null == (e = this.Zr) ? void 0 : e.get(t);
                    r && null != s && s.variants[r] && this.ts(s.name, r, s.variants[r].transforms);
                }
            });
        }
    }
    previewWebExperiment() {
        var t = $2b056e5321c0aa1d$var$No.getWindowLocation();
        if (null != t && t.search) {
            var i = $2b056e5321c0aa1d$var$Si(null == t ? void 0 : t.search, "__experiment_id"), e = $2b056e5321c0aa1d$var$Si(null == t ? void 0 : t.search, "__experiment_variant");
            i && e && ($2b056e5321c0aa1d$var$No.Qr("previewing web experiments " + i + " && " + e), this.getWebExperiments((t)=>{
                this.rs(parseInt(i), e, t);
            }, !1, !0));
        }
    }
    loadIfEnabled() {
        this.N.config.disable_web_experiments || this.getWebExperimentsAndEvaluateDisplayLogic();
    }
    getWebExperiments(t, i, e) {
        if (this.N.config.disable_web_experiments && !e) return t([]);
        var r = this.N.get_property("$web_experiments");
        if (r && !i) return t(r);
        this.N._e({
            url: this.N.requestRouter.endpointFor("api", "/api/web_experiments/?token=" + this.N.config.token),
            method: "GET",
            callback: (i)=>{
                if (200 !== i.statusCode || !i.json) return t([]);
                var e = i.json.experiments || [];
                return t(e);
            }
        });
    }
    rs(t, i, e) {
        var r = e.filter((i)=>i.id === t);
        r && r.length > 0 && ($2b056e5321c0aa1d$var$No.Qr("Previewing web experiment [" + r[0].name + "] with variant [" + i + "]"), this.ts(r[0].name, i, r[0].variants[i].transforms));
    }
    static es(t) {
        return !$2b056e5321c0aa1d$var$O(t.conditions) && $2b056e5321c0aa1d$var$No.ss(t) && $2b056e5321c0aa1d$var$No.ns(t);
    }
    static ss(t) {
        var i;
        if ($2b056e5321c0aa1d$var$O(t.conditions) || $2b056e5321c0aa1d$var$O(null == (i = t.conditions) ? void 0 : i.url)) return !0;
        var e, r, s, n = $2b056e5321c0aa1d$var$No.getWindowLocation();
        return !!n && (null == (e = t.conditions) || !e.url || $2b056e5321c0aa1d$var$Lo[null !== (r = null == (s = t.conditions) ? void 0 : s.urlMatchType) && void 0 !== r ? r : "icontains"](t.conditions.url, n));
    }
    static getWindowLocation() {
        return null == $2b056e5321c0aa1d$var$i ? void 0 : $2b056e5321c0aa1d$var$i.location;
    }
    static ns(t) {
        var i;
        if ($2b056e5321c0aa1d$var$O(t.conditions) || $2b056e5321c0aa1d$var$O(null == (i = t.conditions) ? void 0 : i.utm)) return !0;
        var e = $2b056e5321c0aa1d$var$On();
        if (e.utm_source) {
            var r, s, n, o, a, l, h, u, d, v, c, f, p, g, _, m, b = null == (r = t.conditions) || null == (s = r.utm) || !s.utm_campaign || (null == (n = t.conditions) || null == (o = n.utm) ? void 0 : o.utm_campaign) == e.utm_campaign, w = null == (a = t.conditions) || null == (l = a.utm) || !l.utm_source || (null == (h = t.conditions) || null == (u = h.utm) ? void 0 : u.utm_source) == e.utm_source, y = null == (d = t.conditions) || null == (v = d.utm) || !v.utm_medium || (null == (c = t.conditions) || null == (f = c.utm) ? void 0 : f.utm_medium) == e.utm_medium, S = null == (p = t.conditions) || null == (g = p.utm) || !g.utm_term || (null == (_ = t.conditions) || null == (m = _.utm) ? void 0 : m.utm_term) == e.utm_term;
            return b && y && S && w;
        }
        return !1;
    }
    static Qr(t) {
        for(var i = arguments.length, e = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++)e[r - 1] = arguments[r];
        $2b056e5321c0aa1d$var$N.info("[WebExperiments] " + t, e);
    }
    ts(t, i, e) {
        this._is_bot() ? $2b056e5321c0aa1d$var$No.Qr("Refusing to render web experiment since the viewer is a likely bot") : "control" !== i ? e.forEach((e)=>{
            if (e.selector) {
                var r;
                $2b056e5321c0aa1d$var$No.Qr("applying transform of variant " + i + " for experiment " + t + " ", e);
                var s = null == (r = document) ? void 0 : r.querySelectorAll(e.selector);
                null == s || s.forEach((t)=>{
                    var i = t;
                    e.html && (i.innerHTML = e.html), e.css && i.setAttribute("style", e.css);
                });
            }
        }) : $2b056e5321c0aa1d$var$No.Qr("Control variants leave the page unmodified.");
    }
    _is_bot() {
        return $2b056e5321c0aa1d$var$o && this.N ? $2b056e5321c0aa1d$var$Fo($2b056e5321c0aa1d$var$o, this.N.config.custom_blocked_useragents) : void 0;
    }
}
var $2b056e5321c0aa1d$var$zo = {}, $2b056e5321c0aa1d$var$Uo = ()=>{}, $2b056e5321c0aa1d$var$qo = "posthog", $2b056e5321c0aa1d$var$Bo = !$2b056e5321c0aa1d$var$co && -1 === (null == $2b056e5321c0aa1d$var$v ? void 0 : $2b056e5321c0aa1d$var$v.indexOf("MSIE")) && -1 === (null == $2b056e5321c0aa1d$var$v ? void 0 : $2b056e5321c0aa1d$var$v.indexOf("Mozilla")), $2b056e5321c0aa1d$var$Ho = ()=>{
    var t;
    return {
        api_host: "https://us.i.posthog.com",
        ui_host: null,
        token: "",
        autocapture: !0,
        rageclick: !0,
        cross_subdomain_cookie: $2b056e5321c0aa1d$var$et(null == $2b056e5321c0aa1d$var$a ? void 0 : $2b056e5321c0aa1d$var$a.location),
        persistence: "localStorage+cookie",
        persistence_name: "",
        loaded: $2b056e5321c0aa1d$var$Uo,
        save_campaign_params: !0,
        custom_campaign_params: [],
        custom_blocked_useragents: [],
        save_referrer: !0,
        capture_pageview: !0,
        capture_pageleave: "if_capture_pageview",
        debug: $2b056e5321c0aa1d$var$l && $2b056e5321c0aa1d$var$T(null == $2b056e5321c0aa1d$var$l ? void 0 : $2b056e5321c0aa1d$var$l.search) && -1 !== $2b056e5321c0aa1d$var$l.search.indexOf("__posthog_debug=true") || !1,
        cookie_expiration: 365,
        upgrade: !1,
        disable_session_recording: !1,
        disable_persistence: !1,
        disable_web_experiments: !0,
        disable_surveys: !1,
        disable_external_dependency_loading: !1,
        enable_recording_console_log: void 0,
        secure_cookie: "https:" === (null == $2b056e5321c0aa1d$var$i || null == (t = $2b056e5321c0aa1d$var$i.location) ? void 0 : t.protocol),
        ip: !0,
        opt_out_capturing_by_default: !1,
        opt_out_persistence_by_default: !1,
        opt_out_useragent_filter: !1,
        opt_out_capturing_persistence_type: "localStorage",
        opt_out_capturing_cookie_prefix: null,
        opt_in_site_apps: !1,
        property_denylist: [],
        respect_dnt: !1,
        sanitize_properties: null,
        request_headers: {},
        request_batching: !0,
        properties_string_max_length: 65535,
        session_recording: {},
        mask_all_element_attributes: !1,
        mask_all_text: !1,
        mask_personal_data_properties: !1,
        custom_personal_data_properties: [],
        advanced_disable_decide: !1,
        advanced_disable_feature_flags: !1,
        advanced_disable_feature_flags_on_first_load: !1,
        advanced_disable_toolbar_metrics: !1,
        feature_flag_request_timeout_ms: 3e3,
        surveys_request_timeout_ms: 1e4,
        on_request_error: (t)=>{
            var i = "Bad HTTP status: " + t.statusCode + " " + t.text;
            $2b056e5321c0aa1d$var$N.error(i);
        },
        get_device_id: (t)=>t,
        capture_performance: void 0,
        name: "posthog",
        bootstrap: {},
        disable_compression: !1,
        session_idle_timeout_seconds: 1800,
        person_profiles: "identified_only",
        before_send: void 0,
        request_queue_config: {
            flush_interval_ms: $2b056e5321c0aa1d$var$bo
        },
        _onCapture: $2b056e5321c0aa1d$var$Uo
    };
}, $2b056e5321c0aa1d$var$Wo = (t)=>{
    var i = {};
    $2b056e5321c0aa1d$var$R(t.process_person) || (i.person_profiles = t.process_person), $2b056e5321c0aa1d$var$R(t.xhr_headers) || (i.request_headers = t.xhr_headers), $2b056e5321c0aa1d$var$R(t.cookie_name) || (i.persistence_name = t.cookie_name), $2b056e5321c0aa1d$var$R(t.disable_cookie) || (i.disable_persistence = t.disable_cookie), $2b056e5321c0aa1d$var$R(t.store_google) || (i.save_campaign_params = t.store_google), $2b056e5321c0aa1d$var$R(t.verbose) || (i.debug = t.verbose);
    var e = $2b056e5321c0aa1d$var$V({}, i, t);
    return $2b056e5321c0aa1d$var$x(t.property_blacklist) && ($2b056e5321c0aa1d$var$R(t.property_denylist) ? e.property_denylist = t.property_blacklist : $2b056e5321c0aa1d$var$x(t.property_denylist) ? e.property_denylist = [
        ...t.property_blacklist,
        ...t.property_denylist
    ] : $2b056e5321c0aa1d$var$N.error("Invalid value for property_denylist config: " + t.property_denylist)), e;
};
class $2b056e5321c0aa1d$var$Go {
    constructor(){
        this.__forceAllowLocalhost = !1;
    }
    get os() {
        return this.__forceAllowLocalhost;
    }
    set os(t) {
        $2b056e5321c0aa1d$var$N.error("WebPerformanceObserver is deprecated and has no impact on network capture. Use `_forceAllowLocalhostNetworkCapture` on `posthog.sessionRecording`"), this.__forceAllowLocalhost = t;
    }
}
class $2b056e5321c0aa1d$export$a9d6b9cbf49b8241 {
    get decideEndpointWasHit() {
        var t, i;
        return null !== (t = null == (i = this.featureFlags) ? void 0 : i.hasLoadedFlags) && void 0 !== t && t;
    }
    constructor(){
        this.webPerformance = new $2b056e5321c0aa1d$var$Go, this.ls = !1, this.version = $2b056e5321c0aa1d$var$f.LIB_VERSION, this.hs = new $2b056e5321c0aa1d$var$io, this.config = $2b056e5321c0aa1d$var$Ho(), this.SentryIntegration = $2b056e5321c0aa1d$var$gs, this.sentryIntegration = (t)=>(function(t, i) {
                var e = $2b056e5321c0aa1d$var$ps(t, i);
                return {
                    name: $2b056e5321c0aa1d$var$fs,
                    processEvent: (t)=>e(t)
                };
            })(this, t), this.__request_queue = [], this.__loaded = !1, this.analyticsDefaultEndpoint = "/e/", this.us = !1, this.ds = null, this.vs = null, this.cs = null, this.featureFlags = new $2b056e5321c0aa1d$var$Qn(this), this.toolbar = new $2b056e5321c0aa1d$var$ys(this), this.scrollManager = new $2b056e5321c0aa1d$var$$o(this), this.pageViewManager = new $2b056e5321c0aa1d$var$Ts(this), this.surveys = new $2b056e5321c0aa1d$var$oo(this), this.experiments = new $2b056e5321c0aa1d$var$No(this), this.exceptions = new $2b056e5321c0aa1d$var$Ms(this), this.rateLimiter = new $2b056e5321c0aa1d$var$lo(this), this.requestRouter = new $2b056e5321c0aa1d$var$jo(this), this.consent = new $2b056e5321c0aa1d$var$Zi(this), this.people = {
            set: (t, i, e)=>{
                var r = $2b056e5321c0aa1d$var$T(t) ? {
                    [t]: i
                } : t;
                this.setPersonProperties(r), null == e || e({});
            },
            set_once: (t, i, e)=>{
                var r = $2b056e5321c0aa1d$var$T(t) ? {
                    [t]: i
                } : t;
                this.setPersonProperties(void 0, r), null == e || e({});
            }
        }, this.on("eventCaptured", (t)=>$2b056e5321c0aa1d$var$N.info('send "' + (null == t ? void 0 : t.event) + '"', t));
    }
    init(t, i, e) {
        if (e && e !== $2b056e5321c0aa1d$var$qo) {
            var r, s = null !== (r = $2b056e5321c0aa1d$var$zo[e]) && void 0 !== r ? r : new $2b056e5321c0aa1d$export$a9d6b9cbf49b8241;
            return s._init(t, i, e), $2b056e5321c0aa1d$var$zo[e] = s, $2b056e5321c0aa1d$var$zo[$2b056e5321c0aa1d$var$qo][e] = s, s;
        }
        return this._init(t, i, e);
    }
    _init(e, r, s) {
        var n, o;
        if (void 0 === r && (r = {}), $2b056e5321c0aa1d$var$R(e) || $2b056e5321c0aa1d$var$M(e)) return $2b056e5321c0aa1d$var$N.critical("PostHog was initialized without a token. This likely indicates a misconfiguration. Please check the first argument passed to posthog.init()"), this;
        if (this.__loaded) return $2b056e5321c0aa1d$var$N.warn("You have already initialized PostHog! Re-initializing is a no-op"), this;
        this.__loaded = !0, this.config = {}, this.fs = [], r.person_profiles && (this.vs = r.person_profiles), this.set_config($2b056e5321c0aa1d$var$V({}, $2b056e5321c0aa1d$var$Ho(), $2b056e5321c0aa1d$var$Wo(r), {
            name: s,
            token: e
        })), this.config.on_xhr_error && $2b056e5321c0aa1d$var$N.error("on_xhr_error is deprecated. Use on_request_error instead"), this.compression = r.disable_compression ? void 0 : $2b056e5321c0aa1d$export$6a00d17b5aff0af.GZipJS, this.persistence = new $2b056e5321c0aa1d$var$to(this.config), this.sessionPersistence = "sessionStorage" === this.config.persistence || "memory" === this.config.persistence ? this.persistence : new $2b056e5321c0aa1d$var$to($2b056e5321c0aa1d$var$B({}, this.config, {
            persistence: "sessionStorage"
        }));
        var a = $2b056e5321c0aa1d$var$B({}, this.persistence.props), l = $2b056e5321c0aa1d$var$B({}, this.sessionPersistence.props);
        if (this.ps = new $2b056e5321c0aa1d$var$wo((t)=>this.gs(t), this.config.request_queue_config), this._s = new $2b056e5321c0aa1d$var$So(this), this.__request_queue = [], this.config.__preview_experimental_cookieless_mode || (this.sessionManager = new $2b056e5321c0aa1d$var$Io(this), this.sessionPropsManager = new $2b056e5321c0aa1d$var$xo(this, this.sessionManager, this.persistence)), new $2b056e5321c0aa1d$var$$s(this).startIfEnabledOrStop(), this.siteApps = new $2b056e5321c0aa1d$var$To(this), null == (n = this.siteApps) || n.init(), this.config.__preview_experimental_cookieless_mode || (this.sessionRecording = new $2b056e5321c0aa1d$var$ds(this), this.sessionRecording.startIfEnabledOrStop()), this.config.disable_scroll_properties || this.scrollManager.startMeasuringScrollPosition(), this.autocapture = new $2b056e5321c0aa1d$var$Ti(this), this.autocapture.startIfEnabled(), this.surveys.loadIfEnabled(), this.heatmaps = new $2b056e5321c0aa1d$var$Rs(this), this.heatmaps.startIfEnabled(), this.webVitalsAutocapture = new $2b056e5321c0aa1d$var$Es(this), this.exceptionObserver = new $2b056e5321c0aa1d$var$ne(this), this.exceptionObserver.startIfEnabled(), this.deadClicksAutocapture = new $2b056e5321c0aa1d$var$re(this, $2b056e5321c0aa1d$var$ee), this.deadClicksAutocapture.startIfEnabled(), this.historyAutocapture = new $2b056e5321c0aa1d$var$je(this), this.historyAutocapture.startIfEnabled(), $2b056e5321c0aa1d$var$f.DEBUG = $2b056e5321c0aa1d$var$f.DEBUG || this.config.debug, $2b056e5321c0aa1d$var$f.DEBUG && $2b056e5321c0aa1d$var$N.info("Starting in debug mode", {
            this: this,
            config: r,
            thisC: $2b056e5321c0aa1d$var$B({}, this.config),
            p: a,
            s: l
        }), this.bs(), void 0 !== (null == (o = r.bootstrap) ? void 0 : o.distinctID)) {
            var h, u, d = this.config.get_device_id($2b056e5321c0aa1d$var$ji()), v = null != (h = r.bootstrap) && h.isIdentifiedID ? d : r.bootstrap.distinctID;
            this.persistence.set_property($2b056e5321c0aa1d$var$Ft, null != (u = r.bootstrap) && u.isIdentifiedID ? "identified" : "anonymous"), this.register({
                distinct_id: r.bootstrap.distinctID,
                $device_id: v
            });
        }
        if (this.ws()) {
            var c, p, g = Object.keys((null == (c = r.bootstrap) ? void 0 : c.featureFlags) || {}).filter((t)=>{
                var i, e;
                return !(null == (i = r.bootstrap) || null == (e = i.featureFlags) || !e[t]);
            }).reduce((t, i)=>{
                var e, s;
                return t[i] = (null == (e = r.bootstrap) || null == (s = e.featureFlags) ? void 0 : s[i]) || !1, t;
            }, {}), _ = Object.keys((null == (p = r.bootstrap) ? void 0 : p.featureFlagPayloads) || {}).filter((t)=>g[t]).reduce((t, i)=>{
                var e, s, n, o;
                null != (e = r.bootstrap) && null != (s = e.featureFlagPayloads) && s[i] && (t[i] = null == (n = r.bootstrap) || null == (o = n.featureFlagPayloads) ? void 0 : o[i]);
                return t;
            }, {});
            this.featureFlags.receivedFeatureFlags({
                featureFlags: g,
                featureFlagPayloads: _
            });
        }
        if (this.config.__preview_experimental_cookieless_mode) this.register_once({
            distinct_id: $2b056e5321c0aa1d$var$qt,
            $device_id: null
        }, "");
        else if (!this.get_distinct_id()) {
            var m = this.config.get_device_id($2b056e5321c0aa1d$var$ji());
            this.register_once({
                distinct_id: m,
                $device_id: m
            }, ""), this.persistence.set_property($2b056e5321c0aa1d$var$Ft, "anonymous");
        }
        return $2b056e5321c0aa1d$var$st($2b056e5321c0aa1d$var$i, "onpagehide" in self ? "pagehide" : "unload", this._handle_unload.bind(this), {
            passive: !1
        }), this.toolbar.maybeLoadToolbar(), r.segment ? $2b056e5321c0aa1d$var$cs(this, ()=>this.ys()) : this.ys(), $2b056e5321c0aa1d$var$E(this.config._onCapture) && this.config._onCapture !== $2b056e5321c0aa1d$var$Uo && ($2b056e5321c0aa1d$var$N.warn("onCapture is deprecated. Please use `before_send` instead"), this.on("eventCaptured", (t)=>this.config._onCapture(t.event, t))), this;
    }
    me(i) {
        var e, r, s, n, o, l, h, u;
        if (!$2b056e5321c0aa1d$var$a || !$2b056e5321c0aa1d$var$a.body) return $2b056e5321c0aa1d$var$N.info("document not ready yet, trying again in 500 milliseconds..."), void setTimeout(()=>{
            this.me(i);
        }, 500);
        this.compression = void 0, i.supportedCompression && !this.config.disable_compression && (this.compression = $2b056e5321c0aa1d$var$m(i.supportedCompression, $2b056e5321c0aa1d$export$6a00d17b5aff0af.GZipJS) ? $2b056e5321c0aa1d$export$6a00d17b5aff0af.GZipJS : $2b056e5321c0aa1d$var$m(i.supportedCompression, $2b056e5321c0aa1d$export$6a00d17b5aff0af.Base64) ? $2b056e5321c0aa1d$export$6a00d17b5aff0af.Base64 : void 0), null != (e = i.analytics) && e.endpoint && (this.analyticsDefaultEndpoint = i.analytics.endpoint), this.set_config({
            person_profiles: this.vs ? this.vs : "identified_only"
        }), null == (r = this.siteApps) || r.onRemoteConfig(i), null == (s = this.sessionRecording) || s.onRemoteConfig(i), null == (n = this.autocapture) || n.onRemoteConfig(i), null == (o = this.heatmaps) || o.onRemoteConfig(i), this.surveys.onRemoteConfig(i), null == (l = this.webVitalsAutocapture) || l.onRemoteConfig(i), null == (h = this.exceptionObserver) || h.onRemoteConfig(i), null == (u = this.deadClicksAutocapture) || u.onRemoteConfig(i);
    }
    ys() {
        try {
            this.config.loaded(this);
        } catch (t) {
            $2b056e5321c0aa1d$var$N.critical("`loaded` function failed", t);
        }
        this.Ss(), this.config.capture_pageview && setTimeout(()=>{
            this.consent.isOptedIn() && this.$s();
        }, 1), new $2b056e5321c0aa1d$var$uo(this).load(), this.featureFlags.decide();
    }
    Ss() {
        var t;
        this.has_opted_out_capturing() || this.config.request_batching && (null == (t = this.ps) || t.enable());
    }
    _dom_loaded() {
        this.has_opted_out_capturing() || $2b056e5321c0aa1d$var$G(this.__request_queue, (t)=>this.gs(t)), this.__request_queue = [], this.Ss();
    }
    _handle_unload() {
        var t, i;
        this.config.request_batching ? (this.ks() && this.capture("$pageleave"), null == (t = this.ps) || t.unload(), null == (i = this._s) || i.unload()) : this.ks() && this.capture("$pageleave", null, {
            transport: "sendBeacon"
        });
    }
    _e(t) {
        this.__loaded && ($2b056e5321c0aa1d$var$Bo ? this.__request_queue.push(t) : this.rateLimiter.isServerRateLimited(t.batchKey) || (t.transport = t.transport || this.config.api_transport, t.url = $2b056e5321c0aa1d$var$po(t.url, {
            ip: this.config.ip ? 1 : 0
        }), t.headers = $2b056e5321c0aa1d$var$B({}, this.config.request_headers), t.compression = "best-available" === t.compression ? this.compression : t.compression, t.fetchOptions = t.fetchOptions || this.config.fetch_options, ((t)=>{
            var i, e, r, s = $2b056e5321c0aa1d$var$B({}, t);
            s.timeout = s.timeout || 6e4, s.url = $2b056e5321c0aa1d$var$po(s.url, {
                _: (new Date).getTime().toString(),
                ver: $2b056e5321c0aa1d$var$f.LIB_VERSION,
                compression: s.compression
            });
            var n = null !== (i = s.transport) && void 0 !== i ? i : "fetch", o = null !== (e = null == (r = $2b056e5321c0aa1d$var$rt($2b056e5321c0aa1d$var$mo, (t)=>t.transport === n)) ? void 0 : r.method) && void 0 !== e ? e : $2b056e5321c0aa1d$var$mo[0].method;
            if (!o) throw new Error("No available transport method");
            o(s);
        })($2b056e5321c0aa1d$var$B({}, t, {
            callback: (i)=>{
                var e, r;
                (this.rateLimiter.checkForLimiting(i), i.statusCode >= 400) && (null == (e = (r = this.config).on_request_error) || e.call(r, i));
                null == t.callback || t.callback(i);
            }
        }))));
    }
    gs(t) {
        this._s ? this._s.retriableRequest(t) : this._e(t);
    }
    _execute_array(t) {
        var i, e = [], r = [], s = [];
        $2b056e5321c0aa1d$var$G(t, (t)=>{
            t && (i = t[0], $2b056e5321c0aa1d$var$x(i) ? s.push(t) : $2b056e5321c0aa1d$var$E(t) ? t.call(this) : $2b056e5321c0aa1d$var$x(t) && "alias" === i ? e.push(t) : $2b056e5321c0aa1d$var$x(t) && -1 !== i.indexOf("capture") && $2b056e5321c0aa1d$var$E(this[i]) ? s.push(t) : r.push(t));
        });
        var n = function(t, i) {
            $2b056e5321c0aa1d$var$G(t, function(t) {
                if ($2b056e5321c0aa1d$var$x(t[0])) {
                    var e = i;
                    $2b056e5321c0aa1d$var$J(t, function(t) {
                        e = e[t[0]].apply(e, t.slice(1));
                    });
                } else this[t[0]].apply(this, t.slice(1));
            }, i);
        };
        n(e, this), n(r, this), n(s, this);
    }
    ws() {
        var t, i;
        return (null == (t = this.config.bootstrap) ? void 0 : t.featureFlags) && Object.keys(null == (i = this.config.bootstrap) ? void 0 : i.featureFlags).length > 0 || !1;
    }
    push(t) {
        this._execute_array([
            t
        ]);
    }
    capture(t, i, e) {
        var r;
        if (this.__loaded && this.persistence && this.sessionPersistence && this.ps) {
            if (!this.consent.isOptedOut()) {
                if (!$2b056e5321c0aa1d$var$R(t) && $2b056e5321c0aa1d$var$T(t)) {
                    if (this.config.opt_out_useragent_filter || !this._is_bot()) {
                        var s = null != e && e.skip_client_rate_limiting ? void 0 : this.rateLimiter.clientRateLimitContext();
                        if (null == s || !s.isRateLimited) {
                            null != i && i.$current_url && !$2b056e5321c0aa1d$var$T(null == i ? void 0 : i.$current_url) && ($2b056e5321c0aa1d$var$N.error("Invalid `$current_url` property provided to `posthog.capture`. Input must be a string. Ignoring provided value."), null == i || delete i.$current_url), this.sessionPersistence.update_search_keyword(), this.config.save_campaign_params && this.sessionPersistence.update_campaign_params(), this.config.save_referrer && this.sessionPersistence.update_referrer_info(), (this.config.save_campaign_params || this.config.save_referrer) && this.persistence.set_initial_person_info();
                            var n = new Date, o = (null == e ? void 0 : e.timestamp) || n, a = $2b056e5321c0aa1d$var$ji(), l = {
                                uuid: a,
                                event: t,
                                properties: this.Di(t, i || {}, o, a)
                            };
                            s && (l.properties.$lib_rate_limit_remaining_tokens = s.remainingTokens), (null == e ? void 0 : e.$set) && (l.$set = null == e ? void 0 : e.$set);
                            var h = this.xs(null == e ? void 0 : e.$set_once);
                            h && (l.$set_once = h), (l = $2b056e5321c0aa1d$var$tt(l, null != e && e._noTruncate ? null : this.config.properties_string_max_length)).timestamp = o, $2b056e5321c0aa1d$var$R(null == e ? void 0 : e.timestamp) || (l.properties.$event_time_override_provided = !0, l.properties.$event_time_override_system_time = n);
                            var u = $2b056e5321c0aa1d$var$B({}, l.properties.$set, l.$set);
                            if ($2b056e5321c0aa1d$var$P(u) || this.setPersonPropertiesForFlags(u), !$2b056e5321c0aa1d$var$O(this.config.before_send)) {
                                var d = this.Es(l);
                                if (!d) return;
                                l = d;
                            }
                            this.hs.emit("eventCaptured", l);
                            var v = {
                                method: "POST",
                                url: null !== (r = null == e ? void 0 : e._url) && void 0 !== r ? r : this.requestRouter.endpointFor("api", this.analyticsDefaultEndpoint),
                                data: l,
                                compression: "best-available",
                                batchKey: null == e ? void 0 : e._batchKey
                            };
                            return !this.config.request_batching || e && (null == e || !e._batchKey) || null != e && e.send_instantly ? this.gs(v) : this.ps.enqueue(v), l;
                        }
                        $2b056e5321c0aa1d$var$N.critical("This capture call is ignored due to client rate limiting.");
                    }
                } else $2b056e5321c0aa1d$var$N.error("No event name provided to posthog.capture");
            }
        } else $2b056e5321c0aa1d$var$N.uninitializedWarning("posthog.capture");
    }
    je(t) {
        return this.on("eventCaptured", (i)=>t(i.event, i));
    }
    Di(t, i, e, r) {
        if (e = e || new Date, !this.persistence || !this.sessionPersistence) return i;
        var s = this.persistence.remove_event_timer(t), n = $2b056e5321c0aa1d$var$B({}, i);
        if (n.token = this.config.token, this.config.__preview_experimental_cookieless_mode && (n.$cookieless_mode = !0), "$snapshot" === t) {
            var o = $2b056e5321c0aa1d$var$B({}, this.persistence.properties(), this.sessionPersistence.properties());
            return n.distinct_id = o.distinct_id, (!$2b056e5321c0aa1d$var$T(n.distinct_id) && !$2b056e5321c0aa1d$var$F(n.distinct_id) || $2b056e5321c0aa1d$var$M(n.distinct_id)) && $2b056e5321c0aa1d$var$N.error("Invalid distinct_id for replay event. This indicates a bug in your implementation"), n;
        }
        var l, h = $2b056e5321c0aa1d$var$qn(this.config.mask_personal_data_properties, this.config.custom_personal_data_properties);
        if (this.sessionManager) {
            var { sessionId: u, windowId: d } = this.sessionManager.checkAndGetSessionAndWindowId();
            n.$session_id = u, n.$window_id = d;
        }
        this.sessionPropsManager && $2b056e5321c0aa1d$var$V(n, this.sessionPropsManager.getSessionProps());
        try {
            var c;
            this.sessionRecording && $2b056e5321c0aa1d$var$V(n, this.sessionRecording.sdkDebugProperties), n.$sdk_debug_retry_queue_size = null == (c = this._s) ? void 0 : c.length;
        } catch (t) {
            n.$sdk_debug_error_capturing_properties = String(t);
        }
        if (this.requestRouter.region === $2b056e5321c0aa1d$var$Mo.CUSTOM && (n.$lib_custom_api_host = this.config.api_host), l = "$pageview" === t ? this.pageViewManager.doPageView(e, r) : "$pageleave" === t ? this.pageViewManager.doPageLeave(e) : this.pageViewManager.doEvent(), n = $2b056e5321c0aa1d$var$V(n, l), "$pageview" === t && $2b056e5321c0aa1d$var$a && (n.title = $2b056e5321c0aa1d$var$a.title), !$2b056e5321c0aa1d$var$R(s)) {
            var f = e.getTime() - s;
            n.$duration = parseFloat((f / 1e3).toFixed(3));
        }
        $2b056e5321c0aa1d$var$v && this.config.opt_out_useragent_filter && (n.$browser_type = this._is_bot() ? "bot" : "browser"), (n = $2b056e5321c0aa1d$var$V({}, h, this.persistence.properties(), this.sessionPersistence.properties(), n)).$is_identified = this._isIdentified(), $2b056e5321c0aa1d$var$x(this.config.property_denylist) ? $2b056e5321c0aa1d$var$J(this.config.property_denylist, function(t) {
            delete n[t];
        }) : $2b056e5321c0aa1d$var$N.error("Invalid value for property_denylist config: " + this.config.property_denylist + " or property_blacklist config: " + this.config.property_blacklist);
        var p = this.config.sanitize_properties;
        p && ($2b056e5321c0aa1d$var$N.error("sanitize_properties is deprecated. Use before_send instead"), n = p(n, t));
        var g = this.Is();
        return n.$process_person_profile = g, g && this.Ps("_calculate_event_properties"), n;
    }
    xs(t) {
        var i;
        if (!this.persistence || !this.Is()) return t;
        if (this.ls) return t;
        var e = this.persistence.get_initial_props(), r = null == (i = this.sessionPropsManager) ? void 0 : i.getSetOnceProps(), s = $2b056e5321c0aa1d$var$V({}, e, r || {}, t || {}), n = this.config.sanitize_properties;
        return n && ($2b056e5321c0aa1d$var$N.error("sanitize_properties is deprecated. Use before_send instead"), s = n(s, "$set_once")), this.ls = !0, $2b056e5321c0aa1d$var$P(s) ? void 0 : s;
    }
    register(t, i) {
        var e;
        null == (e = this.persistence) || e.register(t, i);
    }
    register_once(t, i, e) {
        var r;
        null == (r = this.persistence) || r.register_once(t, i, e);
    }
    register_for_session(t) {
        var i;
        null == (i = this.sessionPersistence) || i.register(t);
    }
    unregister(t) {
        var i;
        null == (i = this.persistence) || i.unregister(t);
    }
    unregister_for_session(t) {
        var i;
        null == (i = this.sessionPersistence) || i.unregister(t);
    }
    Rs(t, i) {
        this.register({
            [t]: i
        });
    }
    getFeatureFlag(t, i) {
        return this.featureFlags.getFeatureFlag(t, i);
    }
    getFeatureFlagPayload(t) {
        var i = this.featureFlags.getFeatureFlagPayload(t);
        try {
            return JSON.parse(i);
        } catch (t) {
            return i;
        }
    }
    isFeatureEnabled(t, i) {
        return this.featureFlags.isFeatureEnabled(t, i);
    }
    reloadFeatureFlags() {
        this.featureFlags.reloadFeatureFlags();
    }
    updateEarlyAccessFeatureEnrollment(t, i) {
        this.featureFlags.updateEarlyAccessFeatureEnrollment(t, i);
    }
    getEarlyAccessFeatures(t, i, e) {
        return void 0 === i && (i = !1), this.featureFlags.getEarlyAccessFeatures(t, i, e);
    }
    on(t, i) {
        return this.hs.on(t, i);
    }
    onFeatureFlags(t) {
        return this.featureFlags.onFeatureFlags(t);
    }
    onSurveysLoaded(t) {
        return this.surveys.onSurveysLoaded(t);
    }
    onSessionId(t) {
        var i, e;
        return null !== (i = null == (e = this.sessionManager) ? void 0 : e.onSessionId(t)) && void 0 !== i ? i : ()=>{};
    }
    getSurveys(t, i) {
        void 0 === i && (i = !1), this.surveys.getSurveys(t, i);
    }
    getActiveMatchingSurveys(t, i) {
        void 0 === i && (i = !1), this.surveys.getActiveMatchingSurveys(t, i);
    }
    renderSurvey(t, i) {
        this.surveys.renderSurvey(t, i);
    }
    canRenderSurvey(t) {
        return this.surveys.canRenderSurvey(t);
    }
    canRenderSurveyAsync(t, i) {
        return void 0 === i && (i = !1), this.surveys.canRenderSurveyAsync(t, i);
    }
    identify(t, i, e) {
        if (!this.__loaded || !this.persistence) return $2b056e5321c0aa1d$var$N.uninitializedWarning("posthog.identify");
        if ($2b056e5321c0aa1d$var$F(t) && (t = t.toString(), $2b056e5321c0aa1d$var$N.warn("The first argument to posthog.identify was a number, but it should be a string. It has been converted to a string.")), t) {
            if ([
                "distinct_id",
                "distinctid"
            ].includes(t.toLowerCase())) $2b056e5321c0aa1d$var$N.critical('The string "' + t + '" was set in posthog.identify which indicates an error. This ID should be unique to the user and not a hardcoded string.');
            else if (this.Ps("posthog.identify")) {
                var r = this.get_distinct_id();
                if (this.register({
                    $user_id: t
                }), !this.get_property("$device_id")) {
                    var s = r;
                    this.register_once({
                        $had_persisted_distinct_id: !0,
                        $device_id: s
                    }, "");
                }
                t !== r && t !== this.get_property($2b056e5321c0aa1d$var$ot) && (this.unregister($2b056e5321c0aa1d$var$ot), this.register({
                    distinct_id: t
                }));
                var n = "anonymous" === (this.persistence.get_property($2b056e5321c0aa1d$var$Ft) || "anonymous");
                t !== r && n ? (this.persistence.set_property($2b056e5321c0aa1d$var$Ft, "identified"), this.setPersonPropertiesForFlags($2b056e5321c0aa1d$var$B({}, e || {}, i || {}), !1), this.capture("$identify", {
                    distinct_id: t,
                    $anon_distinct_id: r
                }, {
                    $set: i || {},
                    $set_once: e || {}
                }), this.cs = $2b056e5321c0aa1d$var$Ao(t, i, e), this.featureFlags.setAnonymousDistinctId(r)) : (i || e) && this.setPersonProperties(i, e), t !== r && (this.reloadFeatureFlags(), this.unregister($2b056e5321c0aa1d$var$Ot));
            }
        } else $2b056e5321c0aa1d$var$N.error("Unique user id has not been set in posthog.identify");
    }
    setPersonProperties(t, i) {
        if ((t || i) && this.Ps("posthog.setPersonProperties")) {
            var e = $2b056e5321c0aa1d$var$Ao(this.get_distinct_id(), t, i);
            this.cs !== e ? (this.setPersonPropertiesForFlags($2b056e5321c0aa1d$var$B({}, i || {}, t || {})), this.capture("$set", {
                $set: t || {},
                $set_once: i || {}
            }), this.cs = e) : $2b056e5321c0aa1d$var$N.info("A duplicate setPersonProperties call was made with the same properties. It has been ignored.");
        }
    }
    group(t, i, e) {
        if (t && i) {
            if (this.Ps("posthog.group")) {
                var r = this.getGroups();
                r[t] !== i && this.resetGroupPropertiesForFlags(t), this.register({
                    $groups: $2b056e5321c0aa1d$var$B({}, r, {
                        [t]: i
                    })
                }), e && (this.capture("$groupidentify", {
                    $group_type: t,
                    $group_key: i,
                    $group_set: e
                }), this.setGroupPropertiesForFlags({
                    [t]: e
                })), r[t] === i || e || this.reloadFeatureFlags();
            }
        } else $2b056e5321c0aa1d$var$N.error("posthog.group requires a group type and group key");
    }
    resetGroups() {
        this.register({
            $groups: {}
        }), this.resetGroupPropertiesForFlags(), this.reloadFeatureFlags();
    }
    setPersonPropertiesForFlags(t, i) {
        void 0 === i && (i = !0), this.featureFlags.setPersonPropertiesForFlags(t, i);
    }
    resetPersonPropertiesForFlags() {
        this.featureFlags.resetPersonPropertiesForFlags();
    }
    setGroupPropertiesForFlags(t, i) {
        void 0 === i && (i = !0), this.Ps("posthog.setGroupPropertiesForFlags") && this.featureFlags.setGroupPropertiesForFlags(t, i);
    }
    resetGroupPropertiesForFlags(t) {
        this.featureFlags.resetGroupPropertiesForFlags(t);
    }
    reset(t) {
        var i, e, r, s;
        if ($2b056e5321c0aa1d$var$N.info("reset"), !this.__loaded) return $2b056e5321c0aa1d$var$N.uninitializedWarning("posthog.reset");
        var n = this.get_property("$device_id");
        if (this.consent.reset(), null == (i = this.persistence) || i.clear(), null == (e = this.sessionPersistence) || e.clear(), this.surveys.reset(), null == (r = this.persistence) || r.set_property($2b056e5321c0aa1d$var$Ft, "anonymous"), null == (s = this.sessionManager) || s.resetSessionId(), this.cs = null, this.config.__preview_experimental_cookieless_mode) this.register_once({
            distinct_id: $2b056e5321c0aa1d$var$qt,
            $device_id: null
        }, "");
        else {
            var o = this.config.get_device_id($2b056e5321c0aa1d$var$ji());
            this.register_once({
                distinct_id: o,
                $device_id: t ? o : n
            }, "");
        }
        this.register({
            $last_posthog_reset: (new Date).toISOString()
        }, 1);
    }
    get_distinct_id() {
        return this.get_property("distinct_id");
    }
    getGroups() {
        return this.get_property("$groups") || {};
    }
    get_session_id() {
        var t, i;
        return null !== (t = null == (i = this.sessionManager) ? void 0 : i.checkAndGetSessionAndWindowId(!0).sessionId) && void 0 !== t ? t : "";
    }
    get_session_replay_url(t) {
        if (!this.sessionManager) return "";
        var { sessionId: i, sessionStartTimestamp: e } = this.sessionManager.checkAndGetSessionAndWindowId(!0), r = this.requestRouter.endpointFor("ui", "/project/" + this.config.token + "/replay/" + i);
        if (null != t && t.withTimestamp && e) {
            var s, n = null !== (s = t.timestampLookBack) && void 0 !== s ? s : 10;
            if (!e) return r;
            r += "?t=" + Math.max(Math.floor(((new Date).getTime() - e) / 1e3) - n, 0);
        }
        return r;
    }
    alias(t, i) {
        return t === this.get_property($2b056e5321c0aa1d$var$nt) ? ($2b056e5321c0aa1d$var$N.critical("Attempting to create alias for existing People user - aborting."), -2) : this.Ps("posthog.alias") ? ($2b056e5321c0aa1d$var$R(i) && (i = this.get_distinct_id()), t !== i ? (this.Rs($2b056e5321c0aa1d$var$ot, t), this.capture("$create_alias", {
            alias: t,
            distinct_id: i
        })) : ($2b056e5321c0aa1d$var$N.warn("alias matches current distinct_id - skipping api call."), this.identify(t), -1)) : void 0;
    }
    set_config(t) {
        var i, e, r, s, n = $2b056e5321c0aa1d$var$B({}, this.config);
        $2b056e5321c0aa1d$var$I(t) && ($2b056e5321c0aa1d$var$V(this.config, $2b056e5321c0aa1d$var$Wo(t)), null == (i = this.persistence) || i.update_config(this.config, n), this.sessionPersistence = "sessionStorage" === this.config.persistence || "memory" === this.config.persistence ? this.persistence : new $2b056e5321c0aa1d$var$to($2b056e5321c0aa1d$var$B({}, this.config, {
            persistence: "sessionStorage"
        })), $2b056e5321c0aa1d$var$Gi.O() && "true" === $2b056e5321c0aa1d$var$Gi.A("ph_debug") && (this.config.debug = !0), this.config.debug && ($2b056e5321c0aa1d$var$f.DEBUG = !0, $2b056e5321c0aa1d$var$N.info("set_config", JSON.stringify({
            config: t,
            oldConfig: n,
            newConfig: $2b056e5321c0aa1d$var$B({}, this.config)
        }, null, 2))), null == (e = this.sessionRecording) || e.startIfEnabledOrStop(), null == (r = this.autocapture) || r.startIfEnabled(), null == (s = this.heatmaps) || s.startIfEnabled(), this.surveys.loadIfEnabled(), this.bs());
    }
    startSessionRecording(t) {
        var i = !0 === t, e = {
            sampling: i || !(null == t || !t.sampling),
            linked_flag: i || !(null == t || !t.linked_flag),
            url_trigger: i || !(null == t || !t.url_trigger),
            event_trigger: i || !(null == t || !t.event_trigger)
        };
        if (Object.values(e).some(Boolean)) {
            var r, s, n, o, a;
            if (null == (r = this.sessionManager) || r.checkAndGetSessionAndWindowId(), e.sampling) null == (s = this.sessionRecording) || s.overrideSampling();
            if (e.linked_flag) null == (n = this.sessionRecording) || n.overrideLinkedFlag();
            if (e.url_trigger) null == (o = this.sessionRecording) || o.overrideTrigger("url");
            if (e.event_trigger) null == (a = this.sessionRecording) || a.overrideTrigger("event");
        }
        this.set_config({
            disable_session_recording: !1
        });
    }
    stopSessionRecording() {
        this.set_config({
            disable_session_recording: !0
        });
    }
    sessionRecordingStarted() {
        var t;
        return !(null == (t = this.sessionRecording) || !t.started);
    }
    captureException(t, i) {
        var e = new Error("PostHog syntheticException");
        this.exceptions.sendExceptionEvent($2b056e5321c0aa1d$var$B({}, $2b056e5321c0aa1d$var$Ae(((t)=>t instanceof Error)(t) ? {
            error: t,
            event: t.message
        } : {
            event: t
        }, {
            syntheticException: e
        }), i));
    }
    loadToolbar(t) {
        return this.toolbar.loadToolbar(t);
    }
    get_property(t) {
        var i;
        return null == (i = this.persistence) ? void 0 : i.props[t];
    }
    getSessionProperty(t) {
        var i;
        return null == (i = this.sessionPersistence) ? void 0 : i.props[t];
    }
    toString() {
        var t, i = null !== (t = this.config.name) && void 0 !== t ? t : $2b056e5321c0aa1d$var$qo;
        return i !== $2b056e5321c0aa1d$var$qo && (i = $2b056e5321c0aa1d$var$qo + "." + i), i;
    }
    _isIdentified() {
        var t, i;
        return "identified" === (null == (t = this.persistence) ? void 0 : t.get_property($2b056e5321c0aa1d$var$Ft)) || "identified" === (null == (i = this.sessionPersistence) ? void 0 : i.get_property($2b056e5321c0aa1d$var$Ft));
    }
    Is() {
        var t, i, e, r;
        return !("never" === this.config.person_profiles || "identified_only" === this.config.person_profiles && !this._isIdentified() && $2b056e5321c0aa1d$var$P(this.getGroups()) && (null == (t = this.persistence) || null == (i = t.props) || !i[$2b056e5321c0aa1d$var$ot]) && (null == (e = this.persistence) || null == (r = e.props) || !r[$2b056e5321c0aa1d$var$zt]));
    }
    ks() {
        return !0 === this.config.capture_pageleave || "if_capture_pageview" === this.config.capture_pageleave && (!0 === this.config.capture_pageview || "history_change" === this.config.capture_pageview);
    }
    createPersonProfile() {
        this.Is() || this.Ps("posthog.createPersonProfile") && this.setPersonProperties({}, {});
    }
    Ps(t) {
        return "never" === this.config.person_profiles ? ($2b056e5321c0aa1d$var$N.error(t + ' was called, but process_person is set to "never". This call will be ignored.'), !1) : (this.Rs($2b056e5321c0aa1d$var$zt, !0), !0);
    }
    bs() {
        var t, i, e, r, s = this.consent.isOptedOut(), n = this.config.opt_out_persistence_by_default, o = this.config.disable_persistence || s && !!n;
        (null == (t = this.persistence) ? void 0 : t.ke) !== o && (null == (e = this.persistence) || e.set_disabled(o));
        (null == (i = this.sessionPersistence) ? void 0 : i.ke) !== o && (null == (r = this.sessionPersistence) || r.set_disabled(o));
    }
    opt_in_capturing(t) {
        var i;
        (this.consent.optInOut(!0), this.bs(), $2b056e5321c0aa1d$var$R(null == t ? void 0 : t.captureEventName) || null != t && t.captureEventName) && this.capture(null !== (i = null == t ? void 0 : t.captureEventName) && void 0 !== i ? i : "$opt_in", null == t ? void 0 : t.captureProperties, {
            send_instantly: !0
        });
        this.config.capture_pageview && this.$s();
    }
    opt_out_capturing() {
        this.consent.optInOut(!1), this.bs();
    }
    has_opted_in_capturing() {
        return this.consent.isOptedIn();
    }
    has_opted_out_capturing() {
        return this.consent.isOptedOut();
    }
    clear_opt_in_out_capturing() {
        this.consent.reset(), this.bs();
    }
    _is_bot() {
        return $2b056e5321c0aa1d$var$o ? $2b056e5321c0aa1d$var$Fo($2b056e5321c0aa1d$var$o, this.config.custom_blocked_useragents) : void 0;
    }
    $s() {
        $2b056e5321c0aa1d$var$a && ("visible" === $2b056e5321c0aa1d$var$a.visibilityState ? this.us || (this.us = !0, this.capture("$pageview", {
            title: $2b056e5321c0aa1d$var$a.title
        }, {
            send_instantly: !0
        }), this.ds && ($2b056e5321c0aa1d$var$a.removeEventListener("visibilitychange", this.ds), this.ds = null)) : this.ds || (this.ds = this.$s.bind(this), $2b056e5321c0aa1d$var$st($2b056e5321c0aa1d$var$a, "visibilitychange", this.ds)));
    }
    debug(t) {
        !1 === t ? (null == $2b056e5321c0aa1d$var$i || $2b056e5321c0aa1d$var$i.console.log("You've disabled debug mode."), localStorage && localStorage.removeItem("ph_debug"), this.set_config({
            debug: !1
        })) : (null == $2b056e5321c0aa1d$var$i || $2b056e5321c0aa1d$var$i.console.log("You're now in debug mode. All calls to PostHog will be logged in your console.\nYou can disable this with `posthog.debug(false)`."), localStorage && localStorage.setItem("ph_debug", "true"), this.set_config({
            debug: !0
        }));
    }
    Es(t) {
        if ($2b056e5321c0aa1d$var$O(this.config.before_send)) return t;
        var i = $2b056e5321c0aa1d$var$x(this.config.before_send) ? this.config.before_send : [
            this.config.before_send
        ], e = t;
        for (var r of i){
            if (e = r(e), $2b056e5321c0aa1d$var$O(e)) {
                var s = "Event '" + t.event + "' was rejected in beforeSend function";
                return $2b056e5321c0aa1d$var$j(t.event) ? $2b056e5321c0aa1d$var$N.warn(s + ". This can cause unexpected behavior.") : $2b056e5321c0aa1d$var$N.info(s), null;
            }
            e.properties && !$2b056e5321c0aa1d$var$P(e.properties) || $2b056e5321c0aa1d$var$N.warn("Event '" + t.event + "' has no properties after beforeSend function, this is likely an error.");
        }
        return e;
    }
    getPageViewId() {
        var t;
        return null == (t = this.pageViewManager.oe) ? void 0 : t.pageViewId;
    }
    captureTraceFeedback(t, i) {
        this.capture("$ai_feedback", {
            $ai_trace_id: String(t),
            $ai_feedback_text: i
        });
    }
    captureTraceMetric(t, i, e) {
        this.capture("$ai_metric", {
            $ai_trace_id: String(t),
            $ai_metric_name: i,
            $ai_metric_value: String(e)
        });
    }
}
!function(t, i) {
    for(var e = 0; e < i.length; e++)t.prototype[i[e]] = $2b056e5321c0aa1d$var$Q(t.prototype[i[e]]);
}($2b056e5321c0aa1d$export$a9d6b9cbf49b8241, [
    "identify"
]);
var $2b056e5321c0aa1d$export$87f1e68f1b904cbb, $2b056e5321c0aa1d$export$8c0ce98316e43193, $2b056e5321c0aa1d$export$22779822dd24228f, $2b056e5321c0aa1d$export$9c2ac61661d417f8, $2b056e5321c0aa1d$export$bbed2da3bd3bb001, $2b056e5321c0aa1d$export$407ee791fe918359;
!function(t) {
    t.Button = "button", t.Tab = "tab", t.Selector = "selector";
}($2b056e5321c0aa1d$export$87f1e68f1b904cbb || ($2b056e5321c0aa1d$export$87f1e68f1b904cbb = {})), function(t) {
    t.Left = "left", t.Center = "center", t.Right = "right", t.NextToTrigger = "next_to_trigger";
}($2b056e5321c0aa1d$export$8c0ce98316e43193 || ($2b056e5321c0aa1d$export$8c0ce98316e43193 = {})), function(t) {
    t.Popover = "popover", t.API = "api", t.Widget = "widget";
}($2b056e5321c0aa1d$export$22779822dd24228f || ($2b056e5321c0aa1d$export$22779822dd24228f = {})), function(t) {
    t.Open = "open", t.MultipleChoice = "multiple_choice", t.SingleChoice = "single_choice", t.Rating = "rating", t.Link = "link";
}($2b056e5321c0aa1d$export$9c2ac61661d417f8 || ($2b056e5321c0aa1d$export$9c2ac61661d417f8 = {})), function(t) {
    t.NextQuestion = "next_question", t.End = "end", t.ResponseBased = "response_based", t.SpecificQuestion = "specific_question";
}($2b056e5321c0aa1d$export$bbed2da3bd3bb001 || ($2b056e5321c0aa1d$export$bbed2da3bd3bb001 = {})), function(t) {
    t.Once = "once", t.Recurring = "recurring", t.Always = "always";
}($2b056e5321c0aa1d$export$407ee791fe918359 || ($2b056e5321c0aa1d$export$407ee791fe918359 = {}));
var $2b056e5321c0aa1d$var$ta, $2b056e5321c0aa1d$export$2e2bcd8739ae039 = ($2b056e5321c0aa1d$var$ta = $2b056e5321c0aa1d$var$zo[$2b056e5321c0aa1d$var$qo] = new $2b056e5321c0aa1d$export$a9d6b9cbf49b8241, function() {
    function t() {
        t.done || (t.done = !0, $2b056e5321c0aa1d$var$Bo = !1, $2b056e5321c0aa1d$var$J($2b056e5321c0aa1d$var$zo, function(t) {
            t._dom_loaded();
        }));
    }
    null != $2b056e5321c0aa1d$var$a && $2b056e5321c0aa1d$var$a.addEventListener ? "complete" === $2b056e5321c0aa1d$var$a.readyState ? t() : $2b056e5321c0aa1d$var$st($2b056e5321c0aa1d$var$a, "DOMContentLoaded", t, {
        capture: !1
    }) : $2b056e5321c0aa1d$var$i && $2b056e5321c0aa1d$var$N.error("Browser doesn't support `document.addEventListener` so PostHog couldn't be initialized");
}(), $2b056e5321c0aa1d$var$ta);

});

parcelRegister("6Q5sp", function(module, exports) {

$parcel$export(module.exports, "clerk", function () { return $4fabd51b3ae527e7$export$be02bcab68e87782; });
$parcel$export(module.exports, "router", function () { return $4fabd51b3ae527e7$export$5375cda95f0b0eb4; });
$parcel$export(module.exports, "queryClient", function () { return $4fabd51b3ae527e7$export$7c07b633a151f9c5; });
$parcel$export(module.exports, "default", function () { return $4fabd51b3ae527e7$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $1EEMt = parcelRequire("1EEMt");



var $hTGEL = parcelRequire("hTGEL");
var $9d62S = parcelRequire("9d62S");

var $4iw5i = parcelRequire("4iw5i");


var $3JBRd = parcelRequire("3JBRd");
var $eanBT = parcelRequire("eanBT");
var $dvGJn = parcelRequire("dvGJn");
var $eSb8L = parcelRequire("eSb8L");

var $3H03w = parcelRequire("3H03w");

var $asW9w = parcelRequire("asW9w");

var $7t3ot = parcelRequire("7t3ot");

var $1BTI2 = parcelRequire("1BTI2");

var $74u5y = parcelRequire("74u5y");

var $dasFg = parcelRequire("dasFg");
var $1ccU6 = parcelRequire("1ccU6");

var $fLsc3 = parcelRequire("fLsc3");

var $3h7sC = parcelRequire("3h7sC");

var $hzmaq = parcelRequire("hzmaq");
parcelRequire("8kZ1o");
let $4fabd51b3ae527e7$export$be02bcab68e87782;
async function $4fabd51b3ae527e7$var$getActiveOrganization(clerkClient) {
    var _memberships$data$;
    const memberships = await clerkClient.user.getOrganizationMemberships();
    const firstOrg = (_memberships$data$ = memberships.data[0]) === null || _memberships$data$ === void 0 ? void 0 : _memberships$data$.organization;
    return firstOrg;
}
async function $4fabd51b3ae527e7$var$getOrganizationFromInvites(clerkClient) {
    var _invites$data$;
    const invites = await clerkClient.user.getOrganizationInvitations();
    await Promise.all(invites.data.map((invitation)=>invitation.accept()));
    const firstOrg = (_invites$data$ = invites.data[0]) === null || _invites$data$ === void 0 ? void 0 : _invites$data$.organization;
    return firstOrg;
}
async function $4fabd51b3ae527e7$var$getOrganization(clerkClient) {
    const [activeOrg, inviteOrg] = await Promise.all([
        $4fabd51b3ae527e7$var$getActiveOrganization(clerkClient),
        $4fabd51b3ae527e7$var$getOrganizationFromInvites(clerkClient)
    ]);
    const org = activeOrg || inviteOrg;
    clerkClient.setActive({
        organization: org === null || org === void 0 ? void 0 : org.id
    });
    return org;
}
const $4fabd51b3ae527e7$var$ClerkRouterWrapper = ({ children: children })=>{
    var _clerkClient$user, _clerkClient$organiza;
    const [context, setContext] = (0, $jbmdS.useState)({});
    const clerkClient = (0, $hzmaq.useClerk)();
    (0, $jbmdS.useEffect)(()=>{
        if (!(clerkClient !== null && clerkClient !== void 0 && clerkClient.loaded)) return;
        const updateContext = async ()=>{
            const user = clerkClient.user;
            let org = clerkClient.organization;
            if (user && !org) org = await $4fabd51b3ae527e7$var$getOrganization(clerkClient);
            setContext({
                loaded: clerkClient.loaded,
                isAuthenticated: user && org,
                user: user || undefined,
                organization: org || undefined
            });
        };
        updateContext();
        // Set the exported clerk instance
        $4fabd51b3ae527e7$export$be02bcab68e87782 = clerkClient || $4fabd51b3ae527e7$export$be02bcab68e87782;
    }, [
        clerkClient.loaded,
        (_clerkClient$user = clerkClient.user) === null || _clerkClient$user === void 0 ? void 0 : _clerkClient$user.id,
        (_clerkClient$organiza = clerkClient.organization) === null || _clerkClient$organiza === void 0 ? void 0 : _clerkClient$organiza.id
    ]);
    (0, $jbmdS.useEffect)(()=>{
        if (context !== null && context !== void 0 && context.loaded) $4fabd51b3ae527e7$export$5375cda95f0b0eb4.load();
    }, [
        context === null || context === void 0 ? void 0 : context.loaded
    ]);
    if (!(clerkClient !== null && clerkClient !== void 0 && clerkClient.loaded)) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $4iw5i.default), {});
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).cloneElement(children, {
        context: context
    });
};
const $4fabd51b3ae527e7$export$7c07b633a151f9c5 = new (0, $hTGEL.QueryClient)({
    defaultOptions: {
        queries: {
            useErrorBoundary: true,
            suspense: true,
            staleTime: 60000,
            //60 * 1000, //5 * 60 * 1000, // 5 minutes
            refetchOnWindowFocus: false,
            // default: true
            retry: (failureCount, error)=>{
                // Check if the error is a timeout
                if (error.code === "ECONNABORTED" || error.message.includes("timeout")) throw error;
                // You can add more conditions for other types of errors
                // For example, retry a maximum of 3 times for other errors
                return failureCount < 3;
            }
        }
    }
});
const $4fabd51b3ae527e7$export$5375cda95f0b0eb4 = (0, $dasFg.createRouter)({
    routeTree: $fLsc3.routeTree,
    defaultNotFoundComponent: ()=>{
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $74u5y.default), {});
    },
    context: {
        queryClient: $4fabd51b3ae527e7$export$7c07b633a151f9c5,
        trpc: (0, $3h7sC.trpc),
        clerk: $4fabd51b3ae527e7$export$be02bcab68e87782
    }
});
const $4fabd51b3ae527e7$var$isDev = false;
// note we're using posthog locally for feature flags
// if (process.env.REACT_APP_ENV === 'production') {
(0, $3H03w.default).init("phc_Burb304xExjYSqj20cLeUVWCO2DfMIZqELYlfzC89i6", {
    api_host: $4fabd51b3ae527e7$var$isDev ? "https://app.posthog.com" : "https://hog.coincraft.co",
    ui_host: "https://app.posthog.com",
    session_recording: {
        maskAllInputs: false
    }
});
// }
$eanBT.init({
    environment: "production",
    dsn: "https://e261b4f9137de175f786e96b25b0972f@o4505989495390208.ingest.sentry.io/4505989627707392",
    integrations: [
        new $3JBRd.BrowserTracing({
            // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
            tracePropagationTargets: [
                "localhost",
                "https://launch.coincraft.co",
                "https://mobile.coincraft.co",
                "https://api.coincraft.co",
                "https://server.coincraft.co",
                "https://server2.coincraft.co",
                "https://staging-client.coincraft.co",
                "https://staging-flask.coincraft.co",
                "https://staging-node.coincraft.co",
                "https://staging-mobile.coincraft.co"
            ]
        }),
        new $dvGJn.InternalReplay({
            maskAllText: false,
            maskAllInputs: false
        }),
        new (0, $3H03w.default).SentryIntegration((0, $3H03w.default), "https://coincraft.sentry.io/", "4505989627707392")
    ],
    attachStacktrace: true,
    autoSessionTracking: true,
    sampleRate: 1,
    // Performance Monitoring
    enableTracing: true,
    tracesSampleRate: 0.1,
    // Capture 100% of the transactions, reduce in production!
    // Session Replay
    replaysSessionSampleRate: 0,
    // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});
// }
const $4fabd51b3ae527e7$var$App = (0, $1EEMt.observer)(()=>{
    const visibilityState = (0, $7t3ot.default)();
    (0, $jbmdS.useEffect)(()=>{
        (0, $1BTI2.default).checkIfUpdateIsAvailable();
    }, [
        visibilityState
    ]);
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $asW9w.PostHogProvider), {
        client: (0, $3H03w.default),
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $9d62S.QueryClientProvider), {
            client: $4fabd51b3ae527e7$export$7c07b633a151f9c5,
            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jbmdS.Suspense), {
                fallback: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $4iw5i.default), {}),
                children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    className: "coincraft-page-layout flex-col size-full flex absolute",
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $1ccU6.RouterProvider), {
                        router: $4fabd51b3ae527e7$export$5375cda95f0b0eb4
                    })
                })
            })
        })
    });
});
var $4fabd51b3ae527e7$export$2e2bcd8739ae039 = $eSb8L.withProfiler($4fabd51b3ae527e7$var$App);

});
parcelRegister("hTGEL", function(module, exports) {

$parcel$export(module.exports, "QueryClient", function () { return $d078a96fb190630f$export$405d0624ed55a03f; });

var $dI9XE = parcelRequire("dI9XE");

var $eecJ5 = parcelRequire("eecJ5");

var $kPenA = parcelRequire("kPenA");

var $6IjPu = parcelRequire("6IjPu");

var $e4FZG = parcelRequire("e4FZG");

var $7jCK0 = parcelRequire("7jCK0");

var $leQEp = parcelRequire("leQEp");

var $EKvie = parcelRequire("EKvie");
// CLASS
class $d078a96fb190630f$export$405d0624ed55a03f {
    constructor(config = {}){
        this.queryCache = config.queryCache || new (0, $eecJ5.QueryCache)();
        this.mutationCache = config.mutationCache || new (0, $kPenA.MutationCache)();
        this.logger = config.logger || (0, $EKvie.defaultLogger);
        this.defaultOptions = config.defaultOptions || {};
        this.queryDefaults = [];
        this.mutationDefaults = [];
        this.mountCount = 0;
    }
    mount() {
        this.mountCount++;
        if (this.mountCount !== 1) return;
        this.unsubscribeFocus = (0, $6IjPu.focusManager).subscribe(()=>{
            if ((0, $6IjPu.focusManager).isFocused()) {
                this.resumePausedMutations();
                this.queryCache.onFocus();
            }
        });
        this.unsubscribeOnline = (0, $e4FZG.onlineManager).subscribe(()=>{
            if ((0, $e4FZG.onlineManager).isOnline()) {
                this.resumePausedMutations();
                this.queryCache.onOnline();
            }
        });
    }
    unmount() {
        var _this$unsubscribeFocu, _this$unsubscribeOnli;
        this.mountCount--;
        if (this.mountCount !== 0) return;
        (_this$unsubscribeFocu = this.unsubscribeFocus) == null || _this$unsubscribeFocu.call(this);
        this.unsubscribeFocus = undefined;
        (_this$unsubscribeOnli = this.unsubscribeOnline) == null || _this$unsubscribeOnli.call(this);
        this.unsubscribeOnline = undefined;
    }
    isFetching(arg1, arg2) {
        const [filters] = (0, $dI9XE.parseFilterArgs)(arg1, arg2);
        filters.fetchStatus = "fetching";
        return this.queryCache.findAll(filters).length;
    }
    isMutating(filters) {
        return this.mutationCache.findAll({
            ...filters,
            fetching: true
        }).length;
    }
    getQueryData(queryKey, filters) {
        var _this$queryCache$find;
        return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    }
    ensureQueryData(arg1, arg2, arg3) {
        const parsedOptions = (0, $dI9XE.parseQueryArgs)(arg1, arg2, arg3);
        const cachedData = this.getQueryData(parsedOptions.queryKey);
        return cachedData ? Promise.resolve(cachedData) : this.fetchQuery(parsedOptions);
    }
    getQueriesData(queryKeyOrFilters) {
        return this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const query = this.queryCache.find(queryKey);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $dI9XE.functionalUpdate)(updater, prevData);
        if (typeof data === "undefined") return undefined;
        const parsedOptions = (0, $dI9XE.parseQueryArgs)(queryKey);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions);
        return this.queryCache.build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(queryKeyOrFilters, updater, options) {
        return (0, $7jCK0.notifyManager).batch(()=>this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey, filters) {
        var _this$queryCache$find2;
        return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    }
    removeQueries(arg1, arg2) {
        const [filters] = (0, $dI9XE.parseFilterArgs)(arg1, arg2);
        const queryCache = this.queryCache;
        (0, $7jCK0.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $dI9XE.parseFilterArgs)(arg1, arg2, arg3);
        const queryCache = this.queryCache;
        const refetchFilters = {
            type: "active",
            ...filters
        };
        return (0, $7jCK0.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    cancelQueries(arg1, arg2, arg3) {
        const [filters, cancelOptions = {}] = (0, $dI9XE.parseFilterArgs)(arg1, arg2, arg3);
        if (typeof cancelOptions.revert === "undefined") cancelOptions.revert = true;
        const promises = (0, $7jCK0.notifyManager).batch(()=>this.queryCache.findAll(filters).map((query)=>query.cancel(cancelOptions)));
        return Promise.all(promises).then((0, $dI9XE.noop)).catch((0, $dI9XE.noop));
    }
    invalidateQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $dI9XE.parseFilterArgs)(arg1, arg2, arg3);
        return (0, $7jCK0.notifyManager).batch(()=>{
            var _ref, _filters$refetchType;
            this.queryCache.findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === "none") return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: (_ref = (_filters$refetchType = filters.refetchType) != null ? _filters$refetchType : filters.type) != null ? _ref : "active"
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    refetchQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $dI9XE.parseFilterArgs)(arg1, arg2, arg3);
        const promises = (0, $7jCK0.notifyManager).batch(()=>this.queryCache.findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                var _options$cancelRefetc;
                return query.fetch(undefined, {
                    ...options,
                    cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
                    meta: {
                        refetchPage: filters.refetchPage
                    }
                });
            }));
        let promise = Promise.all(promises).then((0, $dI9XE.noop));
        if (!(options != null && options.throwOnError)) promise = promise.catch((0, $dI9XE.noop));
        return promise;
    }
    fetchQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $dI9XE.parseQueryArgs)(arg1, arg2, arg3);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
        if (typeof defaultedOptions.retry === "undefined") defaultedOptions.retry = false;
        const query = this.queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(arg1, arg2, arg3) {
        return this.fetchQuery(arg1, arg2, arg3).then((0, $dI9XE.noop)).catch((0, $dI9XE.noop));
    }
    fetchInfiniteQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $dI9XE.parseQueryArgs)(arg1, arg2, arg3);
        parsedOptions.behavior = (0, $leQEp.infiniteQueryBehavior)();
        return this.fetchQuery(parsedOptions);
    }
    prefetchInfiniteQuery(arg1, arg2, arg3) {
        return this.fetchInfiniteQuery(arg1, arg2, arg3).then((0, $dI9XE.noop)).catch((0, $dI9XE.noop));
    }
    resumePausedMutations() {
        return this.mutationCache.resumePausedMutations();
    }
    getQueryCache() {
        return this.queryCache;
    }
    getMutationCache() {
        return this.mutationCache;
    }
    getLogger() {
        return this.logger;
    }
    getDefaultOptions() {
        return this.defaultOptions;
    }
    setDefaultOptions(options) {
        this.defaultOptions = options;
    }
    setQueryDefaults(queryKey, options) {
        const result = this.queryDefaults.find((x)=>(0, $dI9XE.hashQueryKey)(queryKey) === (0, $dI9XE.hashQueryKey)(x.queryKey));
        if (result) result.defaultOptions = options;
        else this.queryDefaults.push({
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        if (!queryKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.queryDefaults.find((x)=>(0, $dI9XE.partialMatchKey)(queryKey, x.queryKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    setMutationDefaults(mutationKey, options) {
        const result = this.mutationDefaults.find((x)=>(0, $dI9XE.hashQueryKey)(mutationKey) === (0, $dI9XE.hashQueryKey)(x.mutationKey));
        if (result) result.defaultOptions = options;
        else this.mutationDefaults.push({
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        if (!mutationKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.mutationDefaults.find((x)=>(0, $dI9XE.partialMatchKey)(mutationKey, x.mutationKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    defaultQueryOptions(options) {
        if (options != null && options._defaulted) return options;
        const defaultedOptions = {
            ...this.defaultOptions.queries,
            ...this.getQueryDefaults(options == null ? void 0 : options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash && defaultedOptions.queryKey) defaultedOptions.queryHash = (0, $dI9XE.hashQueryKeyByOptions)(defaultedOptions.queryKey, defaultedOptions);
         // dependent default values
        if (typeof defaultedOptions.refetchOnReconnect === "undefined") defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (typeof defaultedOptions.useErrorBoundary === "undefined") defaultedOptions.useErrorBoundary = !!defaultedOptions.suspense;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options != null && options._defaulted) return options;
        return {
            ...this.defaultOptions.mutations,
            ...this.getMutationDefaults(options == null ? void 0 : options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        this.queryCache.clear();
        this.mutationCache.clear();
    }
}

});
parcelRegister("dI9XE", function(module, exports) {

$parcel$export(module.exports, "isServer", function () { return $9fb71c7a87afb910$export$6acf61af03e62db; });
$parcel$export(module.exports, "noop", function () { return $9fb71c7a87afb910$export$8793edee2d425525; });
$parcel$export(module.exports, "functionalUpdate", function () { return $9fb71c7a87afb910$export$7f095f455ad5af3f; });
$parcel$export(module.exports, "isValidTimeout", function () { return $9fb71c7a87afb910$export$e539f754e934e270; });
$parcel$export(module.exports, "difference", function () { return $9fb71c7a87afb910$export$acaf96a27438246b; });
$parcel$export(module.exports, "replaceAt", function () { return $9fb71c7a87afb910$export$224e3b7078227b8a; });
$parcel$export(module.exports, "timeUntilStale", function () { return $9fb71c7a87afb910$export$811b83d62bcf47f0; });
$parcel$export(module.exports, "parseQueryArgs", function () { return $9fb71c7a87afb910$export$8a11fbc2c8ea08fd; });
$parcel$export(module.exports, "parseFilterArgs", function () { return $9fb71c7a87afb910$export$18e8f4b987e6c111; });
$parcel$export(module.exports, "matchQuery", function () { return $9fb71c7a87afb910$export$c5d1efe363797780; });
$parcel$export(module.exports, "hashQueryKeyByOptions", function () { return $9fb71c7a87afb910$export$cc90ca97bc0d73fd; });
$parcel$export(module.exports, "partialMatchKey", function () { return $9fb71c7a87afb910$export$2f07189bb9fa26a7; });
$parcel$export(module.exports, "matchMutation", function () { return $9fb71c7a87afb910$export$a1ea5fb559f63ae3; });
$parcel$export(module.exports, "hashQueryKey", function () { return $9fb71c7a87afb910$export$5fcb678681417b54; });
$parcel$export(module.exports, "shallowEqualObjects", function () { return $9fb71c7a87afb910$export$3e67810a3f0e9f1c; });
$parcel$export(module.exports, "sleep", function () { return $9fb71c7a87afb910$export$e772c8ff12451969; });
$parcel$export(module.exports, "scheduleMicrotask", function () { return $9fb71c7a87afb910$export$4304cb76768ca134; });
$parcel$export(module.exports, "getAbortController", function () { return $9fb71c7a87afb910$export$382ca5d13a8f252c; });
$parcel$export(module.exports, "replaceData", function () { return $9fb71c7a87afb910$export$17619bac5b909b23; });
// TYPES
// UTILS
const $9fb71c7a87afb910$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in window;
function $9fb71c7a87afb910$export$8793edee2d425525() {
    return undefined;
}
function $9fb71c7a87afb910$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $9fb71c7a87afb910$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $9fb71c7a87afb910$export$acaf96a27438246b(array1, array2) {
    return array1.filter((x)=>!array2.includes(x));
}
function $9fb71c7a87afb910$export$224e3b7078227b8a(array, index, value) {
    const copy = array.slice(0);
    copy[index] = value;
    return copy;
}
function $9fb71c7a87afb910$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $9fb71c7a87afb910$export$8a11fbc2c8ea08fd(arg1, arg2, arg3) {
    if (!$9fb71c7a87afb910$export$aaae5295ec3351c9(arg1)) return arg1;
    if (typeof arg2 === "function") return {
        ...arg3,
        queryKey: arg1,
        queryFn: arg2
    };
    return {
        ...arg2,
        queryKey: arg1
    };
}
function $9fb71c7a87afb910$export$b646c531ea475334(arg1, arg2, arg3) {
    if ($9fb71c7a87afb910$export$aaae5295ec3351c9(arg1)) {
        if (typeof arg2 === "function") return {
            ...arg3,
            mutationKey: arg1,
            mutationFn: arg2
        };
        return {
            ...arg2,
            mutationKey: arg1
        };
    }
    if (typeof arg1 === "function") return {
        ...arg2,
        mutationFn: arg1
    };
    return {
        ...arg1
    };
}
function $9fb71c7a87afb910$export$18e8f4b987e6c111(arg1, arg2, arg3) {
    return $9fb71c7a87afb910$export$aaae5295ec3351c9(arg1) ? [
        {
            ...arg2,
            queryKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $9fb71c7a87afb910$export$42387eeaac09cf54(arg1, arg2, arg3) {
    return $9fb71c7a87afb910$export$aaae5295ec3351c9(arg1) ? [
        {
            ...arg2,
            mutationKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $9fb71c7a87afb910$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if ($9fb71c7a87afb910$export$aaae5295ec3351c9(queryKey)) {
        if (exact) {
            if (query.queryHash !== $9fb71c7a87afb910$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$9fb71c7a87afb910$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (typeof fetchStatus !== "undefined" && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $9fb71c7a87afb910$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, fetching: fetching, predicate: predicate, mutationKey: mutationKey } = filters;
    if ($9fb71c7a87afb910$export$aaae5295ec3351c9(mutationKey)) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($9fb71c7a87afb910$export$5fcb678681417b54(mutation.options.mutationKey) !== $9fb71c7a87afb910$export$5fcb678681417b54(mutationKey)) return false;
        } else if (!$9fb71c7a87afb910$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (typeof fetching === "boolean" && mutation.state.status === "loading" !== fetching) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $9fb71c7a87afb910$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $9fb71c7a87afb910$export$5fcb678681417b54;
    return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 * Hashes the value into a stable hash.
 */ function $9fb71c7a87afb910$export$5fcb678681417b54(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$9fb71c7a87afb910$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
/**
 * Checks if key `b` partially matches with key `a`.
 */ function $9fb71c7a87afb910$export$2f07189bb9fa26a7(a, b) {
    return $9fb71c7a87afb910$export$3bc9138b70293839(a, b);
}
/**
 * Checks if `b` partially matches with `a`.
 */ function $9fb71c7a87afb910$export$3bc9138b70293839(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some((key)=>!$9fb71c7a87afb910$export$3bc9138b70293839(a[key], b[key]));
    return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */ function $9fb71c7a87afb910$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $9fb71c7a87afb910$export$7a8558113332b71e(a) && $9fb71c7a87afb910$export$7a8558113332b71e(b);
    if (array || $9fb71c7a87afb910$export$53b83ca8eaab0383(a) && $9fb71c7a87afb910$export$53b83ca8eaab0383(b)) {
        const aSize = array ? a.length : Object.keys(a).length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            copy[key] = $9fb71c7a87afb910$export$77a71fc411098696(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */ function $9fb71c7a87afb910$export$3e67810a3f0e9f1c(a, b) {
    if (a && !b || b && !a) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $9fb71c7a87afb910$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
} // Copied from: https://github.com/jonschlinkert/is-plain-object
function $9fb71c7a87afb910$export$53b83ca8eaab0383(o) {
    if (!$9fb71c7a87afb910$var$hasObjectPrototype(o)) return false;
     // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor === "undefined") return true;
     // If has modified prototype
    const prot = ctor.prototype;
    if (!$9fb71c7a87afb910$var$hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
     // Most likely a plain Object
    return true;
}
function $9fb71c7a87afb910$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $9fb71c7a87afb910$export$aaae5295ec3351c9(value) {
    return Array.isArray(value);
}
function $9fb71c7a87afb910$export$e6127cc7fe7395c3(value) {
    return value instanceof Error;
}
function $9fb71c7a87afb910$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */ function $9fb71c7a87afb910$export$4304cb76768ca134(callback) {
    $9fb71c7a87afb910$export$e772c8ff12451969(0).then(callback);
}
function $9fb71c7a87afb910$export$382ca5d13a8f252c() {
    if (typeof AbortController === "function") return new AbortController();
    return;
}
function $9fb71c7a87afb910$export$17619bac5b909b23(prevData, data, options) {
    // Use prev data if an isDataEqual function is defined and returns `true`
    if (options.isDataEqual != null && options.isDataEqual(prevData, data)) return prevData;
    else if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) // Structurally share data between prev and new data if needed
    return $9fb71c7a87afb910$export$77a71fc411098696(prevData, data);
    return data;
}

});

parcelRegister("eecJ5", function(module, exports) {

$parcel$export(module.exports, "QueryCache", function () { return $a5bc3ea7f8d28ec7$export$5dde0cd941da8468; });

var $dI9XE = parcelRequire("dI9XE");

var $clQe5 = parcelRequire("clQe5");

var $7jCK0 = parcelRequire("7jCK0");

var $dcJMr = parcelRequire("dcJMr");
// CLASS
class $a5bc3ea7f8d28ec7$export$5dde0cd941da8468 extends (0, $dcJMr.Subscribable) {
    constructor(config){
        super();
        this.config = config || {};
        this.queries = [];
        this.queriesMap = {};
    }
    build(client, options, state) {
        var _options$queryHash;
        const queryKey = options.queryKey;
        const queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, $dI9XE.hashQueryKeyByOptions)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $clQe5.Query)({
                cache: this,
                logger: client.getLogger(),
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!this.queriesMap[query.queryHash]) {
            this.queriesMap[query.queryHash] = query;
            this.queries.push(query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = this.queriesMap[query.queryHash];
        if (queryInMap) {
            query.destroy();
            this.queries = this.queries.filter((x)=>x !== query);
            if (queryInMap === query) delete this.queriesMap[query.queryHash];
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $7jCK0.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return this.queriesMap[queryHash];
    }
    getAll() {
        return this.queries;
    }
    find(arg1, arg2) {
        const [filters] = (0, $dI9XE.parseFilterArgs)(arg1, arg2);
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.queries.find((query)=>(0, $dI9XE.matchQuery)(filters, query));
    }
    findAll(arg1, arg2) {
        const [filters] = (0, $dI9XE.parseFilterArgs)(arg1, arg2);
        return Object.keys(filters).length > 0 ? this.queries.filter((query)=>(0, $dI9XE.matchQuery)(filters, query)) : this.queries;
    }
    notify(event) {
        (0, $7jCK0.notifyManager).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $7jCK0.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $7jCK0.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                query.onOnline();
            });
        });
    }
}

});
parcelRegister("clQe5", function(module, exports) {

$parcel$export(module.exports, "Query", function () { return $8fdff5431fa0a404$export$62297b13309008b2; });

var $dI9XE = parcelRequire("dI9XE");

var $EKvie = parcelRequire("EKvie");

var $7jCK0 = parcelRequire("7jCK0");

var $4ntlP = parcelRequire("4ntlP");

var $bBYvm = parcelRequire("bBYvm");
// CLASS
class $8fdff5431fa0a404$export$62297b13309008b2 extends (0, $bBYvm.Removable) {
    constructor(config){
        super();
        this.abortSignalConsumed = false;
        this.defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.cache = config.cache;
        this.logger = config.logger || (0, $EKvie.defaultLogger);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.initialState = config.state || $8fdff5431fa0a404$var$getDefaultState(this.options);
        this.state = this.initialState;
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") this.cache.remove(this);
    }
    setData(newData, options) {
        const data = (0, $dI9XE.replaceData)(this.state.data, newData, this.options); // Set data and mark it as cached
        this.dispatch({
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        this.dispatch({
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _this$retryer;
        const promise = this.promise;
        (_this$retryer = this.retryer) == null || _this$retryer.cancel(options);
        return promise ? promise.then((0, $dI9XE.noop)).catch((0, $dI9XE.noop)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState(this.initialState);
    }
    isActive() {
        return this.observers.some((observer)=>observer.options.enabled !== false);
    }
    isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
    }
    isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((observer)=>observer.getCurrentResult().isStale);
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, $dI9XE.timeUntilStale)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _this$retryer2;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer2 = this.retryer) == null || _this$retryer2.continue();
    }
    onOnline() {
        var _this$retryer3;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer3 = this.retryer) == null || _this$retryer3.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the query from being garbage collected
            this.clearGcTimeout();
            this.cache.notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                // If the transport layer does not support cancellation
                // we'll let the query continue so the result can be cached
                if (this.retryer) {
                    if (this.abortSignalConsumed) this.retryer.cancel({
                        revert: true
                    });
                    else this.retryer.cancelRetry();
                }
                this.scheduleGc();
            }
            this.cache.notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) this.dispatch({
            type: "invalidate"
        });
    }
    fetch(options, fetchOptions) {
        var _this$options$behavio, _context$fetchOptions;
        if (this.state.fetchStatus !== "idle") {
            if (this.state.dataUpdatedAt && fetchOptions != null && fetchOptions.cancelRefetch) // Silently cancel current fetch if the user wants to cancel refetches
            this.cancel({
                silent: true
            });
            else if (this.promise) {
                var _this$retryer4;
                // make sure that retries that were potentially cancelled due to unmounts can continue
                (_this$retryer4 = this.retryer) == null || _this$retryer4.continueRetry(); // Return current promise if we are already fetching
                return this.promise;
            }
        } // Update config if passed, otherwise the config from the last execution is used
        if (options) this.setOptions(options);
         // Use the options from the first observer with a query function if no function is found.
        // This can happen when the query is hydrated or created with setQueryData.
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = (0, $dI9XE.getAbortController)(); // Create query function context
        const queryFnContext = {
            queryKey: this.queryKey,
            pageParam: undefined,
            meta: this.meta
        }; // Adds an enumerable signal property to the object that
        // which sets abortSignalConsumed to true when the signal
        // is read.
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    if (abortController) {
                        this.abortSignalConsumed = true;
                        return abortController.signal;
                    }
                    return undefined;
                }
            });
        };
        addSignalProperty(queryFnContext); // Create fetch function
        const fetchFn = ()=>{
            if (!this.options.queryFn) return Promise.reject("Missing queryFn for queryKey '" + this.options.queryHash + "'");
            this.abortSignalConsumed = false;
            return this.options.queryFn(queryFnContext);
        }; // Trigger behavior hook
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        (_this$options$behavio = this.options.behavior) == null || _this$options$behavio.onFetch(context); // Store state in case the current fetch needs to be reverted
        this.revertState = this.state; // Set to fetching state if not already in it
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            this.dispatch({
                type: "fetch",
                meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
            });
        }
        const onError = (error)=>{
            // Optimistically update state if needed
            if (!((0, $4ntlP.isCancelledError)(error) && error.silent)) this.dispatch({
                type: "error",
                error: error
            });
            if (!(0, $4ntlP.isCancelledError)(error)) {
                var _this$cache$config$on, _this$cache$config, _this$cache$config$on2, _this$cache$config2;
                // Notify cache callback
                (_this$cache$config$on = (_this$cache$config = this.cache.config).onError) == null || _this$cache$config$on.call(_this$cache$config, error, this);
                (_this$cache$config$on2 = (_this$cache$config2 = this.cache.config).onSettled) == null || _this$cache$config$on2.call(_this$cache$config2, this.state.data, error, this);
            }
            if (!this.isFetchingOptimistic) // Schedule query gc after fetching
            this.scheduleGc();
            this.isFetchingOptimistic = false;
        }; // Try to fetch the data
        this.retryer = (0, $4ntlP.createRetryer)({
            fn: context.fetchFn,
            abort: abortController == null ? void 0 : abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _this$cache$config$on3, _this$cache$config3, _this$cache$config$on4, _this$cache$config4;
                if (typeof data === "undefined") {
                    onError(new Error(this.queryHash + " data is undefined"));
                    return;
                }
                this.setData(data); // Notify cache callback
                (_this$cache$config$on3 = (_this$cache$config3 = this.cache.config).onSuccess) == null || _this$cache$config$on3.call(_this$cache$config3, data, this);
                (_this$cache$config$on4 = (_this$cache$config4 = this.cache.config).onSettled) == null || _this$cache$config$on4.call(_this$cache$config4, data, this.state.error, this);
                if (!this.isFetchingOptimistic) // Schedule query gc after fetching
                this.scheduleGc();
                this.isFetchingOptimistic = false;
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                this.dispatch({
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.dispatch({
                    type: "pause"
                });
            },
            onContinue: ()=>{
                this.dispatch({
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode
        });
        this.promise = this.retryer.promise;
        return this.promise;
    }
    dispatch(action) {
        const reducer = (state)=>{
            var _action$meta, _action$dataUpdatedAt;
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        fetchFailureCount: action.failureCount,
                        fetchFailureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        fetchStatus: "paused"
                    };
                case "continue":
                    return {
                        ...state,
                        fetchStatus: "fetching"
                    };
                case "fetch":
                    return {
                        ...state,
                        fetchFailureCount: 0,
                        fetchFailureReason: null,
                        fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
                        fetchStatus: (0, $4ntlP.canFetch)(this.options.networkMode) ? "fetching" : "paused",
                        ...!state.dataUpdatedAt && {
                            error: null,
                            status: "loading"
                        }
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        dataUpdateCount: state.dataUpdateCount + 1,
                        dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
                        error: null,
                        isInvalidated: false,
                        status: "success",
                        ...!action.manual && {
                            fetchStatus: "idle",
                            fetchFailureCount: 0,
                            fetchFailureReason: null
                        }
                    };
                case "error":
                    const error = action.error;
                    if ((0, $4ntlP.isCancelledError)(error) && error.revert && this.revertState) return {
                        ...this.revertState,
                        fetchStatus: "idle"
                    };
                    return {
                        ...state,
                        error: error,
                        errorUpdateCount: state.errorUpdateCount + 1,
                        errorUpdatedAt: Date.now(),
                        fetchFailureCount: state.fetchFailureCount + 1,
                        fetchFailureReason: error,
                        fetchStatus: "idle",
                        status: "error"
                    };
                case "invalidate":
                    return {
                        ...state,
                        isInvalidated: true
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $7jCK0.notifyManager).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onQueryUpdate(action);
            });
            this.cache.notify({
                query: this,
                type: "updated",
                action: action
            });
        });
    }
}
function $8fdff5431fa0a404$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = typeof data !== "undefined";
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "loading",
        fetchStatus: "idle"
    };
}

});
parcelRegister("EKvie", function(module, exports) {

$parcel$export(module.exports, "defaultLogger", function () { return $07a7cf3694f900ba$export$1cf3d545f2d4635c; });
const $07a7cf3694f900ba$export$1cf3d545f2d4635c = console;

});

parcelRegister("7jCK0", function(module, exports) {

$parcel$export(module.exports, "notifyManager", function () { return $55385be5b7f557ed$export$520687f44db6e1ab; });

var $dI9XE = parcelRequire("dI9XE");
function $55385be5b7f557ed$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    const batch = (callback)=>{
        let result;
        transactions++;
        try {
            result = callback();
        } finally{
            transactions--;
            if (!transactions) flush();
        }
        return result;
    };
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else (0, $dI9XE.scheduleMicrotask)(()=>{
            notifyFn(callback);
        });
    };
    /**
   * All calls to the wrapped function will be batched.
   */ const batchCalls = (callback)=>{
        return (...args)=>{
            schedule(()=>{
                callback(...args);
            });
        };
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) (0, $dI9XE.scheduleMicrotask)(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */ const setNotifyFunction = (fn)=>{
        notifyFn = fn;
    };
    /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */ const setBatchNotifyFunction = (fn)=>{
        batchNotifyFn = fn;
    };
    return {
        batch: batch,
        batchCalls: batchCalls,
        schedule: schedule,
        setNotifyFunction: setNotifyFunction,
        setBatchNotifyFunction: setBatchNotifyFunction
    };
} // SINGLETON
const $55385be5b7f557ed$export$520687f44db6e1ab = $55385be5b7f557ed$export$316a8efd03cd1458();

});

parcelRegister("4ntlP", function(module, exports) {

$parcel$export(module.exports, "canFetch", function () { return $330013edada9bc14$export$61b92f63f30245cf; });
$parcel$export(module.exports, "isCancelledError", function () { return $330013edada9bc14$export$986cc6445c1d323; });
$parcel$export(module.exports, "createRetryer", function () { return $330013edada9bc14$export$2cbd00fe8a2c8d85; });

var $6IjPu = parcelRequire("6IjPu");

var $e4FZG = parcelRequire("e4FZG");

var $dI9XE = parcelRequire("dI9XE");
function $330013edada9bc14$var$defaultRetryDelay(failureCount) {
    return Math.min(1000 * 2 ** failureCount, 30000);
}
function $330013edada9bc14$export$61b92f63f30245cf(networkMode) {
    return (networkMode != null ? networkMode : "online") === "online" ? (0, $e4FZG.onlineManager).isOnline() : true;
}
class $330013edada9bc14$export$a8430ed4188f35a9 {
    constructor(options){
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
}
function $330013edada9bc14$export$986cc6445c1d323(value) {
    return value instanceof $330013edada9bc14$export$a8430ed4188f35a9;
}
function $330013edada9bc14$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((outerResolve, outerReject)=>{
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    const cancel = (cancelOptions)=>{
        if (!isResolved) {
            reject(new $330013edada9bc14$export$a8430ed4188f35a9(cancelOptions));
            config.abort == null || config.abort();
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const shouldPause = ()=>!(0, $6IjPu.focusManager).isFocused() || config.networkMode !== "always" && !(0, $e4FZG.onlineManager).isOnline();
    const resolve = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onSuccess == null || config.onSuccess(value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onError == null || config.onError(value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            continueFn = (value)=>{
                const canContinue = isResolved || !shouldPause();
                if (canContinue) continueResolve(value);
                return canContinue;
            };
            config.onPause == null || config.onPause();
        }).then(()=>{
            continueFn = undefined;
            if (!isResolved) config.onContinue == null || config.onContinue();
        });
    }; // Create loop function
    const run = ()=>{
        // Do nothing if already resolved
        if (isResolved) return;
        let promiseOrValue; // Execute query
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _config$retry, _config$retryDelay;
            // Stop if the fetch is already resolved
            if (isResolved) return;
             // Do we need to retry the request?
            const retry = (_config$retry = config.retry) != null ? _config$retry : 3;
            const retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : $330013edada9bc14$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                // We are done if the query does not need to be retried
                reject(error);
                return;
            }
            failureCount++; // Notify on fail
            config.onFail == null || config.onFail(failureCount, error); // Delay
            (0, $dI9XE.sleep)(delay) // Pause if the document is not visible or when the device is offline
            .then(()=>{
                if (shouldPause()) return pause();
                return;
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    }; // Start loop
    if ($330013edada9bc14$export$61b92f63f30245cf(config.networkMode)) run();
    else pause().then(run);
    return {
        promise: promise,
        cancel: cancel,
        continue: ()=>{
            const didContinue = continueFn == null ? void 0 : continueFn();
            return didContinue ? promise : Promise.resolve();
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry
    };
}

});
parcelRegister("6IjPu", function(module, exports) {

$parcel$export(module.exports, "focusManager", function () { return $4e363bd9320ff41e$export$6bf54661be5b02cf; });

var $dcJMr = parcelRequire("dcJMr");

var $dI9XE = parcelRequire("dI9XE");
class $4e363bd9320ff41e$export$86f1af424b2ca4de extends (0, $dcJMr.Subscribable) {
    constructor(){
        super();
        this.setup = (onFocus)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $dI9XE.isServer) && window.addEventListener) {
                const listener = ()=>onFocus(); // Listen to visibillitychange and focus
                window.addEventListener("visibilitychange", listener, false);
                window.addEventListener("focus", listener, false);
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener("visibilitychange", listener);
                    window.removeEventListener("focus", listener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        });
    }
    setFocused(focused) {
        const changed = this.focused !== focused;
        if (changed) {
            this.focused = focused;
            this.onFocus();
        }
    }
    onFocus() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isFocused() {
        if (typeof this.focused === "boolean") return this.focused;
         // document global can be unavailable in react native
        if (typeof document === "undefined") return true;
        return [
            undefined,
            "visible",
            "prerender"
        ].includes(document.visibilityState);
    }
}
const $4e363bd9320ff41e$export$6bf54661be5b02cf = new $4e363bd9320ff41e$export$86f1af424b2ca4de();

});
parcelRegister("dcJMr", function(module, exports) {

$parcel$export(module.exports, "Subscribable", function () { return $99cfe8603232428d$export$d26086b469ecdbcc; });
class $99cfe8603232428d$export$d26086b469ecdbcc {
    constructor(){
        this.listeners = new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        const identity = {
            listener: listener
        };
        this.listeners.add(identity);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(identity);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
}

});


parcelRegister("e4FZG", function(module, exports) {

$parcel$export(module.exports, "onlineManager", function () { return $a3f203896fcb6b75$export$b113e788b2dd3fdc; });

var $dcJMr = parcelRequire("dcJMr");

var $dI9XE = parcelRequire("dI9XE");
const $a3f203896fcb6b75$var$onlineEvents = [
    "online",
    "offline"
];
class $a3f203896fcb6b75$export$58774fb55d5ff7fc extends (0, $dcJMr.Subscribable) {
    constructor(){
        super();
        this.setup = (onOnline)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $dI9XE.isServer) && window.addEventListener) {
                const listener = ()=>onOnline(); // Listen to online
                $a3f203896fcb6b75$var$onlineEvents.forEach((event)=>{
                    window.addEventListener(event, listener, false);
                });
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    $a3f203896fcb6b75$var$onlineEvents.forEach((event)=>{
                        window.removeEventListener(event, listener);
                    });
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((online)=>{
            if (typeof online === "boolean") this.setOnline(online);
            else this.onOnline();
        });
    }
    setOnline(online) {
        const changed = this.online !== online;
        if (changed) {
            this.online = online;
            this.onOnline();
        }
    }
    onOnline() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isOnline() {
        if (typeof this.online === "boolean") return this.online;
        if (typeof navigator === "undefined" || typeof navigator.onLine === "undefined") return true;
        return navigator.onLine;
    }
}
const $a3f203896fcb6b75$export$b113e788b2dd3fdc = new $a3f203896fcb6b75$export$58774fb55d5ff7fc();

});


parcelRegister("bBYvm", function(module, exports) {

$parcel$export(module.exports, "Removable", function () { return $87421566422aff21$export$e09608847fcc8c59; });

var $dI9XE = parcelRequire("dI9XE");
class $87421566422aff21$export$e09608847fcc8c59 {
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $dI9XE.isValidTimeout)(this.cacheTime)) this.gcTimeout = setTimeout(()=>{
            this.optionalRemove();
        }, this.cacheTime);
    }
    updateCacheTime(newCacheTime) {
        // Default to 5 minutes (Infinity for server-side) if no cache time is set
        this.cacheTime = Math.max(this.cacheTime || 0, newCacheTime != null ? newCacheTime : (0, $dI9XE.isServer) ? Infinity : 300000);
    }
    clearGcTimeout() {
        if (this.gcTimeout) {
            clearTimeout(this.gcTimeout);
            this.gcTimeout = undefined;
        }
    }
}

});



parcelRegister("kPenA", function(module, exports) {

$parcel$export(module.exports, "MutationCache", function () { return $f293b9850d7c33a0$export$1fcfd9a244434844; });

var $7jCK0 = parcelRequire("7jCK0");

var $jNpHv = parcelRequire("jNpHv");

var $dI9XE = parcelRequire("dI9XE");

var $dcJMr = parcelRequire("dcJMr");
// CLASS
class $f293b9850d7c33a0$export$1fcfd9a244434844 extends (0, $dcJMr.Subscribable) {
    constructor(config){
        super();
        this.config = config || {};
        this.mutations = [];
        this.mutationId = 0;
    }
    build(client, options, state) {
        const mutation = new (0, $jNpHv.Mutation)({
            mutationCache: this,
            logger: client.getLogger(),
            mutationId: ++this.mutationId,
            options: client.defaultMutationOptions(options),
            state: state,
            defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        this.mutations.push(mutation);
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        this.mutations = this.mutations.filter((x)=>x !== mutation);
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    clear() {
        (0, $7jCK0.notifyManager).batch(()=>{
            this.mutations.forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return this.mutations;
    }
    find(filters) {
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.mutations.find((mutation)=>(0, $dI9XE.matchMutation)(filters, mutation));
    }
    findAll(filters) {
        return this.mutations.filter((mutation)=>(0, $dI9XE.matchMutation)(filters, mutation));
    }
    notify(event) {
        (0, $7jCK0.notifyManager).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        var _this$resuming;
        this.resuming = ((_this$resuming = this.resuming) != null ? _this$resuming : Promise.resolve()).then(()=>{
            const pausedMutations = this.mutations.filter((x)=>x.state.isPaused);
            return (0, $7jCK0.notifyManager).batch(()=>pausedMutations.reduce((promise, mutation)=>promise.then(()=>mutation.continue().catch((0, $dI9XE.noop))), Promise.resolve()));
        }).then(()=>{
            this.resuming = undefined;
        });
        return this.resuming;
    }
}

});
parcelRegister("jNpHv", function(module, exports) {

$parcel$export(module.exports, "Mutation", function () { return $e69687916c424941$export$17b8b19c814bcf56; });

var $EKvie = parcelRequire("EKvie");

var $7jCK0 = parcelRequire("7jCK0");

var $bBYvm = parcelRequire("bBYvm");

var $4ntlP = parcelRequire("4ntlP");
// CLASS
class $e69687916c424941$export$17b8b19c814bcf56 extends (0, $bBYvm.Removable) {
    constructor(config){
        super();
        this.defaultOptions = config.defaultOptions;
        this.mutationId = config.mutationId;
        this.mutationCache = config.mutationCache;
        this.logger = config.logger || (0, $EKvie.defaultLogger);
        this.observers = [];
        this.state = config.state || $e69687916c424941$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    get meta() {
        return this.options.meta;
    }
    setState(state) {
        this.dispatch({
            type: "setState",
            state: state
        });
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the mutation from being garbage collected
            this.clearGcTimeout();
            this.mutationCache.notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        this.observers = this.observers.filter((x)=>x !== observer);
        this.scheduleGc();
        this.mutationCache.notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!this.observers.length) {
            if (this.state.status === "loading") this.scheduleGc();
            else this.mutationCache.remove(this);
        }
    }
    continue() {
        var _this$retryer$continu, _this$retryer;
        return (_this$retryer$continu = (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.continue()) != null ? _this$retryer$continu : this.execute();
    }
    async execute() {
        const executeMutation = ()=>{
            var _this$options$retry;
            this.retryer = (0, $4ntlP.createRetryer)({
                fn: ()=>{
                    if (!this.options.mutationFn) return Promise.reject("No mutationFn found");
                    return this.options.mutationFn(this.state.variables);
                },
                onFail: (failureCount, error)=>{
                    this.dispatch({
                        type: "failed",
                        failureCount: failureCount,
                        error: error
                    });
                },
                onPause: ()=>{
                    this.dispatch({
                        type: "pause"
                    });
                },
                onContinue: ()=>{
                    this.dispatch({
                        type: "continue"
                    });
                },
                retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
                retryDelay: this.options.retryDelay,
                networkMode: this.options.networkMode
            });
            return this.retryer.promise;
        };
        const restored = this.state.status === "loading";
        try {
            var _this$mutationCache$c3, _this$mutationCache$c4, _this$options$onSucce, _this$options2, _this$mutationCache$c5, _this$mutationCache$c6, _this$options$onSettl, _this$options3;
            if (!restored) {
                var _this$mutationCache$c, _this$mutationCache$c2, _this$options$onMutat, _this$options;
                this.dispatch({
                    type: "loading",
                    variables: this.options.variables
                }); // Notify cache callback
                await ((_this$mutationCache$c = (_this$mutationCache$c2 = this.mutationCache.config).onMutate) == null ? void 0 : _this$mutationCache$c.call(_this$mutationCache$c2, this.state.variables, this));
                const context = await ((_this$options$onMutat = (_this$options = this.options).onMutate) == null ? void 0 : _this$options$onMutat.call(_this$options, this.state.variables));
                if (context !== this.state.context) this.dispatch({
                    type: "loading",
                    context: context,
                    variables: this.state.variables
                });
            }
            const data = await executeMutation(); // Notify cache callback
            await ((_this$mutationCache$c3 = (_this$mutationCache$c4 = this.mutationCache.config).onSuccess) == null ? void 0 : _this$mutationCache$c3.call(_this$mutationCache$c4, data, this.state.variables, this.state.context, this));
            await ((_this$options$onSucce = (_this$options2 = this.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options2, data, this.state.variables, this.state.context)); // Notify cache callback
            await ((_this$mutationCache$c5 = (_this$mutationCache$c6 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c5.call(_this$mutationCache$c6, data, null, this.state.variables, this.state.context, this));
            await ((_this$options$onSettl = (_this$options3 = this.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options3, data, null, this.state.variables, this.state.context));
            this.dispatch({
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                var _this$mutationCache$c7, _this$mutationCache$c8, _this$options$onError, _this$options4, _this$mutationCache$c9, _this$mutationCache$c10, _this$options$onSettl2, _this$options5;
                // Notify cache callback
                await ((_this$mutationCache$c7 = (_this$mutationCache$c8 = this.mutationCache.config).onError) == null ? void 0 : _this$mutationCache$c7.call(_this$mutationCache$c8, error, this.state.variables, this.state.context, this));
                await ((_this$options$onError = (_this$options4 = this.options).onError) == null ? void 0 : _this$options$onError.call(_this$options4, error, this.state.variables, this.state.context)); // Notify cache callback
                await ((_this$mutationCache$c9 = (_this$mutationCache$c10 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c9.call(_this$mutationCache$c10, undefined, error, this.state.variables, this.state.context, this));
                await ((_this$options$onSettl2 = (_this$options5 = this.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options5, undefined, error, this.state.variables, this.state.context));
                throw error;
            } finally{
                this.dispatch({
                    type: "error",
                    error: error
                });
            }
        }
    }
    dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        failureCount: action.failureCount,
                        failureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        isPaused: true
                    };
                case "continue":
                    return {
                        ...state,
                        isPaused: false
                    };
                case "loading":
                    return {
                        ...state,
                        context: action.context,
                        data: undefined,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        isPaused: !(0, $4ntlP.canFetch)(this.options.networkMode),
                        status: "loading",
                        variables: action.variables
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        status: "success",
                        isPaused: false
                    };
                case "error":
                    return {
                        ...state,
                        data: undefined,
                        error: action.error,
                        failureCount: state.failureCount + 1,
                        failureReason: action.error,
                        isPaused: false,
                        status: "error"
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $7jCK0.notifyManager).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onMutationUpdate(action);
            });
            this.mutationCache.notify({
                mutation: this,
                type: "updated",
                action: action
            });
        });
    }
}
function $e69687916c424941$export$a1659b54bac3252a() {
    return {
        context: undefined,
        data: undefined,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: undefined
    };
}

});


parcelRegister("leQEp", function(module, exports) {

$parcel$export(module.exports, "infiniteQueryBehavior", function () { return $f763bf1e8088e7eb$export$84470d1367601e8d; });
function $f763bf1e8088e7eb$export$84470d1367601e8d() {
    return {
        onFetch: (context)=>{
            context.fetchFn = ()=>{
                var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
                const refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
                const fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
                const pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
                const isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === "forward";
                const isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === "backward";
                const oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
                const oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
                let newPageParams = oldPageParams;
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            var _context$signal;
                            if ((_context$signal = context.signal) != null && _context$signal.aborted) cancelled = true;
                            else {
                                var _context$signal2;
                                (_context$signal2 = context.signal) == null || _context$signal2.addEventListener("abort", ()=>{
                                    cancelled = true;
                                });
                            }
                            return context.signal;
                        }
                    });
                }; // Get query function
                const queryFn = context.options.queryFn || (()=>Promise.reject("Missing queryFn for queryKey '" + context.options.queryHash + "'"));
                const buildNewPages = (pages, param, page, previous)=>{
                    newPageParams = previous ? [
                        param,
                        ...newPageParams
                    ] : [
                        ...newPageParams,
                        param
                    ];
                    return previous ? [
                        page,
                        ...pages
                    ] : [
                        ...pages,
                        page
                    ];
                }; // Create function to fetch a page
                const fetchPage = (pages, manual, param, previous)=>{
                    if (cancelled) return Promise.reject("Cancelled");
                    if (typeof param === "undefined" && !manual && pages.length) return Promise.resolve(pages);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const queryFnResult = queryFn(queryFnContext);
                    const promise = Promise.resolve(queryFnResult).then((page)=>buildNewPages(pages, param, page, previous));
                    return promise;
                };
                let promise; // Fetch first page?
                if (!oldPages.length) promise = fetchPage([]);
                else if (isFetchingNextPage) {
                    const manual = typeof pageParam !== "undefined";
                    const param = manual ? pageParam : $f763bf1e8088e7eb$export$1186159d57de7255(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param);
                } else if (isFetchingPreviousPage) {
                    const manual = typeof pageParam !== "undefined";
                    const param = manual ? pageParam : $f763bf1e8088e7eb$export$48efda17d8ac7ac7(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param, true);
                } else {
                    newPageParams = [];
                    const manual = typeof context.options.getNextPageParam === "undefined";
                    const shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
                    promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
                    for(let i = 1; i < oldPages.length; i++)promise = promise.then((pages)=>{
                        const shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                        if (shouldFetchNextPage) {
                            const param = manual ? oldPageParams[i] : $f763bf1e8088e7eb$export$1186159d57de7255(context.options, pages);
                            return fetchPage(pages, manual, param);
                        }
                        return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                    });
                }
                const finalPromise = promise.then((pages)=>({
                        pages: pages,
                        pageParams: newPageParams
                    }));
                return finalPromise;
            };
        }
    };
}
function $f763bf1e8088e7eb$export$1186159d57de7255(options, pages) {
    return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function $f763bf1e8088e7eb$export$48efda17d8ac7ac7(options, pages) {
    return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */ function $f763bf1e8088e7eb$export$b9c88add8b8b5e6a(options, pages) {
    if (options.getNextPageParam && Array.isArray(pages)) {
        const nextPageParam = $f763bf1e8088e7eb$export$1186159d57de7255(options, pages);
        return typeof nextPageParam !== "undefined" && nextPageParam !== null && nextPageParam !== false;
    }
    return;
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */ function $f763bf1e8088e7eb$export$db1663b730a8e6e4(options, pages) {
    if (options.getPreviousPageParam && Array.isArray(pages)) {
        const previousPageParam = $f763bf1e8088e7eb$export$48efda17d8ac7ac7(options, pages);
        return typeof previousPageParam !== "undefined" && previousPageParam !== null && previousPageParam !== false;
    }
    return;
}

});


parcelRegister("9d62S", function(module, exports) {

$parcel$export(module.exports, "useQueryClient", function () { return $6b4a046f51726ecd$export$22e77b9572c4fded; });
$parcel$export(module.exports, "QueryClientProvider", function () { return $6b4a046f51726ecd$export$45604f0cc8ae667b; });

var $jbmdS = parcelRequire("jbmdS");
"use client";
const $6b4a046f51726ecd$export$2fba198b5b2e37fa = /*#__PURE__*/ $jbmdS.createContext(undefined);
const $6b4a046f51726ecd$var$QueryClientSharingContext = /*#__PURE__*/ $jbmdS.createContext(false); // If we are given a context, we will use it.
// Otherwise, if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function $6b4a046f51726ecd$var$getQueryClientContext(context, contextSharing) {
    if (context) return context;
    if (contextSharing && typeof window !== "undefined") {
        if (!window.ReactQueryClientContext) window.ReactQueryClientContext = $6b4a046f51726ecd$export$2fba198b5b2e37fa;
        return window.ReactQueryClientContext;
    }
    return $6b4a046f51726ecd$export$2fba198b5b2e37fa;
}
const $6b4a046f51726ecd$export$22e77b9572c4fded = ({ context: context } = {})=>{
    const queryClient = $jbmdS.useContext($6b4a046f51726ecd$var$getQueryClientContext(context, $jbmdS.useContext($6b4a046f51726ecd$var$QueryClientSharingContext)));
    if (!queryClient) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return queryClient;
};
const $6b4a046f51726ecd$export$45604f0cc8ae667b = ({ client: client, children: children, context: context, contextSharing: contextSharing = false })=>{
    $jbmdS.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    const Context = $6b4a046f51726ecd$var$getQueryClientContext(context, contextSharing);
    return /*#__PURE__*/ $jbmdS.createElement($6b4a046f51726ecd$var$QueryClientSharingContext.Provider, {
        value: !context && contextSharing
    }, /*#__PURE__*/ $jbmdS.createElement(Context.Provider, {
        value: client
    }, children));
};

});

parcelRegister("4iw5i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3211bb260e9418ca$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("jbmdS");
var $3211bb260e9418ca$export$2e2bcd8739ae039 = ({ text: text })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "flex items-center justify-center w-full h-full",
        children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            className: "bg-transparent text-center self-center py-[4em] px-[6.5em] opacity-90",
            children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                        className: "fa fa-circle-o-notch fa-spin fa-3x fa-fw coincraft-gold text-gold",
                        style: {
                            marginRight: 0
                        }
                    }),
                    text ? /*#__PURE__*/ (0, $61Ea1.jsx)("h5", {
                        className: "mt-[0.75em] mb-0 text-[#333]",
                        children: text
                    }) : null
                ]
            })
        })
    });
};

});

parcelRegister("3JBRd", function(module, exports) {

$parcel$export(module.exports, "BrowserTracing", function () { return $2b82f0be21eb4ada$export$46d3bbd0375f5fa4; });

var $b9TvW = parcelRequire("b9TvW");
var $bdACW = parcelRequire("bdACW");
var $iKbxs = parcelRequire("iKbxs");
var $9t32t = parcelRequire("9t32t");
var $hgFRV = parcelRequire("hgFRV");

var $db3mB = parcelRequire("db3mB");
var $7Dams = parcelRequire("7Dams");
var $MppwO = parcelRequire("MppwO");

var $036vc = parcelRequire("036vc");

var $2BFvn = parcelRequire("2BFvn");

var $hqqce = parcelRequire("hqqce");

var $dysLL = parcelRequire("dysLL");

var $3zkrT = parcelRequire("3zkrT");

var $bRSNm = parcelRequire("bRSNm");

var $a4mdh = parcelRequire("a4mdh");
const $2b82f0be21eb4ada$export$bbd2089f30bd3708 = "BrowserTracing";
/** Options for Browser Tracing integration */ const $2b82f0be21eb4ada$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $hgFRV.TRACING_DEFAULTS),
    markBackgroundTransactions: true,
    routingInstrumentation: (0, $bRSNm.instrumentRoutingWithDefaults),
    startTransactionOnLocationChange: true,
    startTransactionOnPageLoad: true,
    enableLongTask: true,
    enableInp: false,
    interactionsSampleRate: 1,
    _experiments: {},
    ...(0, $3zkrT.defaultRequestInstrumentationOptions)
};
/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */ const $2b82f0be21eb4ada$var$MAX_INTERACTIONS = 10;
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * @deprecated Use `browserTracingIntegration()` instead.
 */ class $2b82f0be21eb4ada$export$46d3bbd0375f5fa4 {
    // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
    // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
    // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
    // integrations.
    /** Browser Tracing integration options */ /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    constructor(_options){
        this.name = $2b82f0be21eb4ada$export$bbd2089f30bd3708;
        this._hasSetTracePropagationTargets = false;
        (0, $b9TvW.addTracingExtensions)();
        if (0, $036vc.DEBUG_BUILD) this._hasSetTracePropagationTargets = !!(_options && // eslint-disable-next-line deprecation/deprecation
        (_options.tracePropagationTargets || _options.tracingOrigins));
        this.options = {
            ...$2b82f0be21eb4ada$var$DEFAULT_BROWSER_TRACING_OPTIONS,
            ..._options
        };
        // Special case: enableLongTask can be set in _experiments
        // TODO (v8): Remove this in v8
        if (this.options._experiments.enableLongTask !== undefined) this.options.enableLongTask = this.options._experiments.enableLongTask;
        // TODO (v8): remove this block after tracingOrigins is removed
        // Set tracePropagationTargets to tracingOrigins if specified by the user
        // In case both are specified, tracePropagationTargets takes precedence
        // eslint-disable-next-line deprecation/deprecation
        if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
        this.options.tracePropagationTargets = _options.tracingOrigins;
        this._collectWebVitals = (0, $dysLL.startTrackingWebVitals)();
        /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */ this._interactionIdToRouteNameMapping = {};
        if (this.options.enableInp) (0, $dysLL.startTrackingINP)(this._interactionIdToRouteNameMapping, this.options.interactionsSampleRate);
        if (this.options.enableLongTask) (0, $dysLL.startTrackingLongTasks)();
        if (this.options._experiments.enableInteractions) (0, $dysLL.startTrackingInteractions)();
        this._latestRoute = {
            name: undefined,
            context: undefined
        };
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        this._getCurrentHub = getCurrentHub;
        const hub = getCurrentHub();
        // eslint-disable-next-line deprecation/deprecation
        const client = hub.getClient();
        const clientOptions = client && client.getOptions();
        const { routingInstrumentation: instrumentRouting, startTransactionOnLocationChange: startTransactionOnLocationChange, startTransactionOnPageLoad: startTransactionOnPageLoad, markBackgroundTransactions: markBackgroundTransactions, traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, _experiments: _experiments } = this.options;
        const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
        // There are three ways to configure tracePropagationTargets:
        // 1. via top level client option `tracePropagationTargets`
        // 2. via BrowserTracing option `tracePropagationTargets`
        // 3. via BrowserTracing option `tracingOrigins` (deprecated)
        //
        // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
        // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
        // This is done as it minimizes bundle size (we don't have to have undefined checks).
        //
        // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
        // eslint-disable-next-line deprecation/deprecation
        const tracePropagationTargets = clientOptionsTracePropagationTargets || this.options.tracePropagationTargets;
        if ((0, $036vc.DEBUG_BUILD) && this._hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) (0, $7Dams.logger).warn("[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.");
        instrumentRouting((context)=>{
            const transaction = this._createRouteTransaction(context);
            this.options._experiments.onStartRouteTransaction && this.options._experiments.onStartRouteTransaction(transaction, context, getCurrentHub);
            return transaction;
        }, startTransactionOnPageLoad, startTransactionOnLocationChange);
        if (markBackgroundTransactions) (0, $2BFvn.registerBackgroundTabDetection)();
        if (_experiments.enableInteractions) this._registerInteractionListener();
        if (this.options.enableInp) this._registerInpInteractionListener();
        (0, $3zkrT.instrumentOutgoingRequests)({
            traceFetch: traceFetch,
            traceXHR: traceXHR,
            tracePropagationTargets: tracePropagationTargets,
            shouldCreateSpanForRequest: shouldCreateSpanForRequest,
            enableHTTPTimings: enableHTTPTimings
        });
    }
    /** Create routing idle transaction. */ _createRouteTransaction(context) {
        if (!this._getCurrentHub) {
            (0, $036vc.DEBUG_BUILD) && (0, $7Dams.logger).warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
            return undefined;
        }
        const hub = this._getCurrentHub();
        const { beforeNavigate: beforeNavigate, idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
        const isPageloadTransaction = context.op === "pageload";
        let expandedContext;
        if (isPageloadTransaction) {
            const sentryTrace = isPageloadTransaction ? $2b82f0be21eb4ada$export$f147b32b03c9cf11("sentry-trace") : "";
            const baggage = isPageloadTransaction ? $2b82f0be21eb4ada$export$f147b32b03c9cf11("baggage") : undefined;
            const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = (0, $MppwO.propagationContextFromHeaders)(sentryTrace, baggage);
            expandedContext = {
                traceId: traceId,
                parentSpanId: parentSpanId,
                parentSampled: sampled,
                ...context,
                metadata: {
                    // eslint-disable-next-line deprecation/deprecation
                    ...context.metadata,
                    dynamicSamplingContext: dsc
                },
                trimEnd: true
            };
        } else expandedContext = {
            trimEnd: true,
            ...context
        };
        const modifiedContext = typeof beforeNavigate === "function" ? beforeNavigate(expandedContext) : expandedContext;
        // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
        // from being sent to Sentry).
        const finalContext = modifiedContext === undefined ? {
            ...expandedContext,
            sampled: false
        } : modifiedContext;
        // If `beforeNavigate` set a custom name, record that fact
        // eslint-disable-next-line deprecation/deprecation
        finalContext.metadata = finalContext.name !== expandedContext.name ? {
            ...finalContext.metadata,
            source: "custom"
        } : finalContext.metadata;
        this._latestRoute.name = finalContext.name;
        this._latestRoute.context = finalContext;
        // eslint-disable-next-line deprecation/deprecation
        if (finalContext.sampled === false) (0, $036vc.DEBUG_BUILD) && (0, $7Dams.logger).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (0, $036vc.DEBUG_BUILD) && (0, $7Dams.logger).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        const { location: location } = (0, $a4mdh.WINDOW);
        const idleTransaction = (0, $b9TvW.startIdleTransaction)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval, isPageloadTransaction);
        if (isPageloadTransaction) {
            if ((0, $a4mdh.WINDOW).document) {
                (0, $a4mdh.WINDOW).document.addEventListener("readystatechange", ()=>{
                    if ([
                        "interactive",
                        "complete"
                    ].includes((0, $a4mdh.WINDOW).document.readyState)) idleTransaction.sendAutoFinishSignal();
                });
                if ([
                    "interactive",
                    "complete"
                ].includes((0, $a4mdh.WINDOW).document.readyState)) idleTransaction.sendAutoFinishSignal();
            }
        }
        idleTransaction.registerBeforeFinishCallback((transaction)=>{
            this._collectWebVitals();
            (0, $dysLL.addPerformanceEntries)(transaction);
        });
        return idleTransaction;
    }
    /** Start listener for interaction transactions */ _registerInteractionListener() {
        let inflightInteractionTransaction;
        const registerInteractionTransaction = ()=>{
            const { idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
            const op = "ui.action.click";
            // eslint-disable-next-line deprecation/deprecation
            const currentTransaction = (0, $bdACW.getActiveTransaction)();
            if (currentTransaction && currentTransaction.op && [
                "navigation",
                "pageload"
            ].includes(currentTransaction.op)) {
                (0, $036vc.DEBUG_BUILD) && (0, $7Dams.logger).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
                return undefined;
            }
            if (inflightInteractionTransaction) {
                inflightInteractionTransaction.setFinishReason("interactionInterrupted");
                inflightInteractionTransaction.end();
                inflightInteractionTransaction = undefined;
            }
            if (!this._getCurrentHub) {
                (0, $036vc.DEBUG_BUILD) && (0, $7Dams.logger).warn(`[Tracing] Did not create ${op} transaction because _getCurrentHub is invalid.`);
                return undefined;
            }
            if (!this._latestRoute.name) {
                (0, $036vc.DEBUG_BUILD) && (0, $7Dams.logger).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
                return undefined;
            }
            const hub = this._getCurrentHub();
            const { location: location } = (0, $a4mdh.WINDOW);
            const context = {
                name: this._latestRoute.name,
                op: op,
                trimEnd: true,
                data: {
                    [(0, $9t32t.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: this._latestRoute.context ? $2b82f0be21eb4ada$var$getSource(this._latestRoute.context) : "url"
                }
            };
            inflightInteractionTransaction = (0, $b9TvW.startIdleTransaction)(hub, context, idleTimeout, finalTimeout, true, {
                location: location
            }, heartbeatInterval);
        };
        [
            "click"
        ].forEach((type)=>{
            if ((0, $a4mdh.WINDOW).document) addEventListener(type, registerInteractionTransaction, {
                once: false,
                capture: true
            });
        });
    }
    /** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */ _registerInpInteractionListener() {
        const handleEntries = ({ entries: entries })=>{
            const client = (0, $iKbxs.getClient)();
            // We need to get the replay, user, and activeTransaction from the current scope
            // so that we can associate replay id, profile id, and a user display to the span
            const replay = client !== undefined && client.getIntegrationByName !== undefined ? client.getIntegrationByName("Replay") : undefined;
            const replayId = replay !== undefined ? replay.getReplayId() : undefined;
            // eslint-disable-next-line deprecation/deprecation
            const activeTransaction = (0, $bdACW.getActiveTransaction)();
            const currentScope = (0, $iKbxs.getCurrentScope)();
            const user = currentScope !== undefined ? currentScope.getUser() : undefined;
            entries.forEach((entry)=>{
                if ($2b82f0be21eb4ada$var$isPerformanceEventTiming(entry)) {
                    const interactionId = entry.interactionId;
                    if (interactionId === undefined) return;
                    const existingInteraction = this._interactionIdToRouteNameMapping[interactionId];
                    const duration = entry.duration;
                    const startTime = entry.startTime;
                    const keys = Object.keys(this._interactionIdToRouteNameMapping);
                    const minInteractionId = keys.length > 0 ? keys.reduce((a, b)=>{
                        return this._interactionIdToRouteNameMapping[a].duration < this._interactionIdToRouteNameMapping[b].duration ? a : b;
                    }) : undefined;
                    // For a first input event to be considered, we must check that an interaction event does not already exist with the same duration and start time.
                    // This is also checked in the web-vitals library.
                    if (entry.entryType === "first-input") {
                        const matchingEntry = keys.map((key)=>this._interactionIdToRouteNameMapping[key]).some((interaction)=>{
                            return interaction.duration === duration && interaction.startTime === startTime;
                        });
                        if (matchingEntry) return;
                    }
                    // Interactions with an id of 0 and are not first-input are not valid.
                    if (!interactionId) return;
                    // If the interaction already exists, we want to use the duration of the longest entry, since that is what the INP metric uses.
                    if (existingInteraction) existingInteraction.duration = Math.max(existingInteraction.duration, duration);
                    else if (keys.length < $2b82f0be21eb4ada$var$MAX_INTERACTIONS || minInteractionId === undefined || duration > this._interactionIdToRouteNameMapping[minInteractionId].duration) {
                        // If the interaction does not exist, we want to add it to the mapping if there is space, or if the duration is longer than the shortest entry.
                        const routeName = this._latestRoute.name;
                        const parentContext = this._latestRoute.context;
                        if (routeName && parentContext) {
                            if (minInteractionId && Object.keys(this._interactionIdToRouteNameMapping).length >= $2b82f0be21eb4ada$var$MAX_INTERACTIONS) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                            delete this._interactionIdToRouteNameMapping[minInteractionId];
                            this._interactionIdToRouteNameMapping[interactionId] = {
                                routeName: routeName,
                                duration: duration,
                                parentContext: parentContext,
                                user: user,
                                activeTransaction: activeTransaction,
                                replayId: replayId,
                                startTime: startTime
                            };
                        }
                    }
                }
            });
        };
        (0, $hqqce.addPerformanceInstrumentationHandler)("event", handleEntries);
        (0, $hqqce.addPerformanceInstrumentationHandler)("first-input", handleEntries);
    }
}
/** Returns the value of a meta tag */ function $2b82f0be21eb4ada$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $db3mB.getDomElement)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute("content") : undefined;
}
function $2b82f0be21eb4ada$var$getSource(context) {
    const sourceFromAttributes = context.attributes && context.attributes[0, $9t32t.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromData = context.data && context.data[0, $9t32t.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromMetadata = context.metadata && context.metadata.source;
    return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}
function $2b82f0be21eb4ada$var$isPerformanceEventTiming(entry) {
    return "duration" in entry;
}

});
parcelRegister("b9TvW", function(module, exports) {

$parcel$export(module.exports, "startIdleTransaction", function () { return $81fb98edfd86dcc7$export$479dbd817e392a4f; });
$parcel$export(module.exports, "addTracingExtensions", function () { return $81fb98edfd86dcc7$export$653d0ef2bad9cdf9; });

var $7Dams = parcelRequire("7Dams");

var $3JSHc = parcelRequire("3JSHc");

var $aFDsf = parcelRequire("aFDsf");

var $IueXx = parcelRequire("IueXx");

var $gdEM4 = parcelRequire("gdEM4");

var $hgFRV = parcelRequire("hgFRV");

var $ecEes = parcelRequire("ecEes");

var $eodfD = parcelRequire("eodfD");
/** Returns all trace headers that are currently on the top scope. */ // eslint-disable-next-line deprecation/deprecation
function $81fb98edfd86dcc7$var$traceHeaders() {
    // eslint-disable-next-line deprecation/deprecation
    const scope = this.getScope();
    // eslint-disable-next-line deprecation/deprecation
    const span = scope.getSpan();
    return span ? {
        "sentry-trace": (0, $IueXx.spanToTraceHeader)(span)
    } : {};
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function $81fb98edfd86dcc7$var$_startTransaction(// eslint-disable-next-line deprecation/deprecation
transactionContext, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    const client = this.getClient();
    const options = client && client.getOptions() || {};
    const configInstrumenter = options.instrumenter || "sentry";
    const transactionInstrumenter = transactionContext.instrumenter || "sentry";
    if (configInstrumenter !== transactionInstrumenter) {
        (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).error(`A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`);
        // eslint-disable-next-line deprecation/deprecation
        transactionContext.sampled = false;
    }
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $eodfD.Transaction)(transactionContext, this);
    transaction = (0, $ecEes.sampleTransaction)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Create new idle transaction.
 */ function $81fb98edfd86dcc7$export$479dbd817e392a4f(// eslint-disable-next-line deprecation/deprecation
hub, transactionContext, idleTimeout, finalTimeout, onScope, customSamplingContext, heartbeatInterval, delayAutoFinishUntilSignal = false) {
    // eslint-disable-next-line deprecation/deprecation
    const client = hub.getClient();
    const options = client && client.getOptions() || {};
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $hgFRV.IdleTransaction)(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope, delayAutoFinishUntilSignal);
    transaction = (0, $ecEes.sampleTransaction)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Adds tracing extensions to the global hub.
 */ function $81fb98edfd86dcc7$export$653d0ef2bad9cdf9() {
    const carrier = (0, $aFDsf.getMainCarrier)();
    if (!carrier.__SENTRY__) return;
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) carrier.__SENTRY__.extensions.startTransaction = $81fb98edfd86dcc7$var$_startTransaction;
    if (!carrier.__SENTRY__.extensions.traceHeaders) carrier.__SENTRY__.extensions.traceHeaders = $81fb98edfd86dcc7$var$traceHeaders;
    (0, $gdEM4.registerErrorInstrumentation)();
}

});
parcelRegister("7Dams", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", function () { return $58e43672120c13dd$export$2a2b1d2252a69ecb; });
$parcel$export(module.exports, "originalConsoleMethods", function () { return $58e43672120c13dd$export$77c4ce905194557b; });
$parcel$export(module.exports, "consoleSandbox", function () { return $58e43672120c13dd$export$cda52e2a8927a2ca; });
$parcel$export(module.exports, "logger", function () { return $58e43672120c13dd$export$af88d00dbe7f521; });

var $15pqG = parcelRequire("15pqG");

var $ehoTA = parcelRequire("ehoTA");
/** Prefix for logging strings */ const $58e43672120c13dd$var$PREFIX = "Sentry Logger ";
const $58e43672120c13dd$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $58e43672120c13dd$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $58e43672120c13dd$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $ehoTA.GLOBAL_OBJ))) return callback();
    const console = (0, $ehoTA.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($58e43672120c13dd$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $58e43672120c13dd$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $58e43672120c13dd$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $15pqG.DEBUG_BUILD) $58e43672120c13dd$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $58e43672120c13dd$export$cda52e2a8927a2ca(()=>{
                (0, $ehoTA.GLOBAL_OBJ).console[name](`${$58e43672120c13dd$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $58e43672120c13dd$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $58e43672120c13dd$export$af88d00dbe7f521 = $58e43672120c13dd$var$makeLogger();

});
parcelRegister("15pqG", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $0ca9fbcbdf577597$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $0ca9fbcbdf577597$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});

parcelRegister("ehoTA", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_OBJ", function () { return $a655f6fbc5523a0d$export$f1a6cdb1459e81d1; });
$parcel$export(module.exports, "getGlobalObject", function () { return $a655f6fbc5523a0d$export$256479dc0cea61c4; });
$parcel$export(module.exports, "getGlobalSingleton", function () { return $a655f6fbc5523a0d$export$7e223ec222791509; });
/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $a655f6fbc5523a0d$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $a655f6fbc5523a0d$export$f1a6cdb1459e81d1 = typeof globalThis == "object" && $a655f6fbc5523a0d$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == "object" && $a655f6fbc5523a0d$var$isGlobalObj(window) || typeof self == "object" && $a655f6fbc5523a0d$var$isGlobalObj(self) || typeof $parcel$global == "object" && $a655f6fbc5523a0d$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $a655f6fbc5523a0d$export$256479dc0cea61c4() {
    return $a655f6fbc5523a0d$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $a655f6fbc5523a0d$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $a655f6fbc5523a0d$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});


parcelRegister("3JSHc", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $2b900082cda59498$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $2b900082cda59498$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});

parcelRegister("aFDsf", function(module, exports) {

$parcel$export(module.exports, "getMainCarrier", function () { return $7c4c56930898d3e7$export$19eade501500c6c1; });
$parcel$export(module.exports, "getCurrentHub", function () { return $7c4c56930898d3e7$export$a07cdf6544bbd7c; });
$parcel$export(module.exports, "getIsolationScope", function () { return $7c4c56930898d3e7$export$68f3af03034c9e90; });
$parcel$export(module.exports, "runWithAsyncContext", function () { return $7c4c56930898d3e7$export$70d775fb1f267027; });

var $7Dams = parcelRequire("7Dams");
var $bA8KD = parcelRequire("bA8KD");
var $ehoTA = parcelRequire("ehoTA");
var $l3GNb = parcelRequire("l3GNb");
var $4zH9l = parcelRequire("4zH9l");

var $5QjIW = parcelRequire("5QjIW");

var $3JSHc = parcelRequire("3JSHc");

var $gi5Ft = parcelRequire("gi5Ft");

var $lGtB9 = parcelRequire("lGtB9");

var $dUT9Y = parcelRequire("dUT9Y");
/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $7c4c56930898d3e7$export$24a86ef7798177e4 = parseFloat((0, $dUT9Y.SDK_VERSION));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $7c4c56930898d3e7$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */ // eslint-disable-next-line deprecation/deprecation
class $7c4c56930898d3e7$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */ constructor(client, scope, isolationScope, _version = $7c4c56930898d3e7$export$24a86ef7798177e4){
        this._version = _version;
        let assignedScope;
        if (!scope) {
            assignedScope = new (0, $gi5Ft.Scope)();
            assignedScope.setClient(client);
        } else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new (0, $gi5Ft.Scope)();
            assignedIsolationScope.setClient(client);
        } else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) // eslint-disable-next-line deprecation/deprecation
        this.bindClient(client);
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ bindClient(client) {
        // eslint-disable-next-line deprecation/deprecation
        const top = this.getStackTop();
        top.client = client;
        top.scope.setClient(client);
        // eslint-disable-next-line deprecation/deprecation
        if (client && client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
        client.setupIntegrations();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ pushScope() {
        // We want to clone the content of prev scope
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.getScope().clone();
        // eslint-disable-next-line deprecation/deprecation
        this.getStack().push({
            // eslint-disable-next-line deprecation/deprecation
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ popScope() {
        // eslint-disable-next-line deprecation/deprecation
        if (this.getStack().length <= 1) return false;
        // eslint-disable-next-line deprecation/deprecation
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ withScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        }
        if ((0, $l3GNb.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            return res;
        }, (e)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        });
        // eslint-disable-next-line deprecation/deprecation
        this.popScope();
        return maybePromiseResult;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ getClient() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ getScope() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().scope;
    }
    /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $4zH9l.uuid4)();
        const syntheticException = new Error("Sentry syntheticException");
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $4zH9l.uuid4)();
        const syntheticException = new Error(message);
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $4zH9l.uuid4)();
        if (!event.type) this._lastEventId = eventId;
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureEvent(event, {
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ addBreadcrumb(breadcrumb, hint) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $7c4c56930898d3e7$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $bA8KD.dateTimestampInSeconds)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $7Dams.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
        // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
        // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
        // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
        // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
        // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
        // the event processing pipeline.
        // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ setUser(user) {
        // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setUser(user);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setUser(user);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ setTags(tags) {
        // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTags(tags);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTags(tags);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ setExtras(extras) {
        // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtras(extras);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ setTag(key, value) {
        // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTag(key, value);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ setExtra(key, extra) {
        // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtra(key, extra);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setContext(name, context);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ configureScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    run(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const oldHub = $7c4c56930898d3e7$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            // eslint-disable-next-line deprecation/deprecation
            $7c4c56930898d3e7$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ getIntegration(integration) {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        if (!client) return null;
        try {
            // eslint-disable-next-line deprecation/deprecation
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod("startTransaction", context, customSamplingContext);
        if ((0, $3JSHc.DEBUG_BUILD) && !result) {
            // eslint-disable-next-line deprecation/deprecation
            const client = this.getClient();
            if (!client) (0, $7Dams.logger).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else (0, $7Dams.logger).warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ traceHeaders() {
        return this._callExtensionMethod("traceHeaders");
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) // eslint-disable-next-line deprecation/deprecation
        return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ endSession() {
        // eslint-disable-next-line deprecation/deprecation
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $lGtB9.closeSession)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ startSession(context) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $5QjIW.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $ehoTA.GLOBAL_OBJ).navigator || {};
        const session = (0, $lGtB9.makeSession)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === "ok") (0, $lGtB9.updateSession)(currentSession, {
            status: "exited"
        });
        // eslint-disable-next-line deprecation/deprecation
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ shouldSendDefaultPii() {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $7c4c56930898d3e7$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") return sentry.extensions[method].apply(this, args);
        (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $7c4c56930898d3e7$export$19eade501500c6c1() {
    (0, $ehoTA.GLOBAL_OBJ).__SENTRY__ = (0, $ehoTA.GLOBAL_OBJ).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $ehoTA.GLOBAL_OBJ;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $7c4c56930898d3e7$export$4188a14ad302d1bc(hub) {
    const registry = $7c4c56930898d3e7$export$19eade501500c6c1();
    const oldHub = $7c4c56930898d3e7$export$bfa8a924a84a76b7(registry);
    $7c4c56930898d3e7$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $7c4c56930898d3e7$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $7c4c56930898d3e7$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $7c4c56930898d3e7$var$getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function $7c4c56930898d3e7$export$68f3af03034c9e90() {
    // eslint-disable-next-line deprecation/deprecation
    return $7c4c56930898d3e7$export$a07cdf6544bbd7c().getIsolationScope();
}
// eslint-disable-next-line deprecation/deprecation
function $7c4c56930898d3e7$var$getGlobalHub(registry = $7c4c56930898d3e7$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$7c4c56930898d3e7$var$hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    $7c4c56930898d3e7$export$bfa8a924a84a76b7(registry).isOlderThan($7c4c56930898d3e7$export$24a86ef7798177e4)) // eslint-disable-next-line deprecation/deprecation
    $7c4c56930898d3e7$export$849f05434e95d2f2(registry, new $7c4c56930898d3e7$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $7c4c56930898d3e7$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ // eslint-disable-next-line deprecation/deprecation
function $7c4c56930898d3e7$export$236689a79f5aa020(carrier, parent = $7c4c56930898d3e7$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$7c4c56930898d3e7$var$hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    $7c4c56930898d3e7$export$bfa8a924a84a76b7(carrier).isOlderThan($7c4c56930898d3e7$export$24a86ef7798177e4)) {
        // eslint-disable-next-line deprecation/deprecation
        const client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        const scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        const isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        $7c4c56930898d3e7$export$849f05434e95d2f2(carrier, new $7c4c56930898d3e7$export$8c41bb232f1008b1(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $7c4c56930898d3e7$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $7c4c56930898d3e7$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $7c4c56930898d3e7$export$70d775fb1f267027(callback, options = {}) {
    const registry = $7c4c56930898d3e7$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $7c4c56930898d3e7$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ // eslint-disable-next-line deprecation/deprecation
function $7c4c56930898d3e7$export$bfa8a924a84a76b7(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $ehoTA.getGlobalSingleton)("hub", ()=>new $7c4c56930898d3e7$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ // eslint-disable-next-line deprecation/deprecation
function $7c4c56930898d3e7$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("bA8KD", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", function () { return $86e9d848a9270b8b$export$7740643b9eeaf0c4; });
$parcel$export(module.exports, "timestampInSeconds", function () { return $86e9d848a9270b8b$export$ee52dced521e3e18; });
$parcel$export(module.exports, "browserPerformanceTimeOrigin", function () { return $86e9d848a9270b8b$export$baf075a948ffc0bf; });

var $ehoTA = parcelRequire("ehoTA");
const $86e9d848a9270b8b$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $86e9d848a9270b8b$export$7740643b9eeaf0c4() {
    return Date.now() / $86e9d848a9270b8b$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $86e9d848a9270b8b$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $ehoTA.GLOBAL_OBJ);
    if (!performance || !performance.now) return $86e9d848a9270b8b$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $86e9d848a9270b8b$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $86e9d848a9270b8b$export$ee52dced521e3e18 = $86e9d848a9270b8b$var$createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const $86e9d848a9270b8b$export$c5907b5a8838db13 = $86e9d848a9270b8b$export$ee52dced521e3e18;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $86e9d848a9270b8b$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $86e9d848a9270b8b$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $ehoTA.GLOBAL_OBJ);
    if (!performance || !performance.now) {
        $86e9d848a9270b8b$export$f9f8cce55af5194c = "none";
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $86e9d848a9270b8b$export$f9f8cce55af5194c = "timeOrigin";
            return performance.timeOrigin;
        } else {
            $86e9d848a9270b8b$export$f9f8cce55af5194c = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $86e9d848a9270b8b$export$f9f8cce55af5194c = "dateNow";
    return dateNow;
})();

});

parcelRegister("l3GNb", function(module, exports) {

$parcel$export(module.exports, "isError", function () { return $f54b127280e51230$export$e6127cc7fe7395c3; });
$parcel$export(module.exports, "isInstanceOf", function () { return $f54b127280e51230$export$49034edbe6b62415; });
$parcel$export(module.exports, "isErrorEvent", function () { return $f54b127280e51230$export$9f9636d330b71954; });
$parcel$export(module.exports, "isDOMError", function () { return $f54b127280e51230$export$ef9e2056653f0c8e; });
$parcel$export(module.exports, "isDOMException", function () { return $f54b127280e51230$export$12e869b2a583f783; });
$parcel$export(module.exports, "isString", function () { return $f54b127280e51230$export$844ec244b1367d54; });
$parcel$export(module.exports, "isParameterizedString", function () { return $f54b127280e51230$export$dbcbffa59149b824; });
$parcel$export(module.exports, "isPrimitive", function () { return $f54b127280e51230$export$c3825b437cbdea5c; });
$parcel$export(module.exports, "isPlainObject", function () { return $f54b127280e51230$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isEvent", function () { return $f54b127280e51230$export$9671ea99bd126ace; });
$parcel$export(module.exports, "isElement", function () { return $f54b127280e51230$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isRegExp", function () { return $f54b127280e51230$export$49841c62b9eff15; });
$parcel$export(module.exports, "isThenable", function () { return $f54b127280e51230$export$f5b060c2914b97c8; });
$parcel$export(module.exports, "isSyntheticEvent", function () { return $f54b127280e51230$export$bc2894c7158efbac; });
$parcel$export(module.exports, "isNaN", function () { return $f54b127280e51230$export$c9f5652083b8129d; });
$parcel$export(module.exports, "isVueViewModel", function () { return $f54b127280e51230$export$7916fad0ebc23f48; });
// eslint-disable-next-line @typescript-eslint/unbound-method
const $f54b127280e51230$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $f54b127280e51230$export$e6127cc7fe7395c3(wat) {
    switch($f54b127280e51230$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return $f54b127280e51230$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $f54b127280e51230$var$isBuiltin(wat, className) {
    return $f54b127280e51230$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $f54b127280e51230$export$9f9636d330b71954(wat) {
    return $f54b127280e51230$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $f54b127280e51230$export$ef9e2056653f0c8e(wat) {
    return $f54b127280e51230$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $f54b127280e51230$export$12e869b2a583f783(wat) {
    return $f54b127280e51230$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $f54b127280e51230$export$844ec244b1367d54(wat) {
    return $f54b127280e51230$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $f54b127280e51230$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $f54b127280e51230$export$c3825b437cbdea5c(wat) {
    return wat === null || $f54b127280e51230$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $f54b127280e51230$export$53b83ca8eaab0383(wat) {
    return $f54b127280e51230$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $f54b127280e51230$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $f54b127280e51230$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $f54b127280e51230$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $f54b127280e51230$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $f54b127280e51230$export$49841c62b9eff15(wat) {
    return $f54b127280e51230$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $f54b127280e51230$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $f54b127280e51230$export$bc2894c7158efbac(wat) {
    return $f54b127280e51230$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $f54b127280e51230$export$c9f5652083b8129d(wat) {
    return typeof wat === "number" && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $f54b127280e51230$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $f54b127280e51230$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}

});

parcelRegister("4zH9l", function(module, exports) {

$parcel$export(module.exports, "uuid4", function () { return $354be6efd8904b90$export$19f53698e68b2496; });
$parcel$export(module.exports, "getEventDescription", function () { return $354be6efd8904b90$export$4157119e2b157127; });
$parcel$export(module.exports, "addExceptionTypeValue", function () { return $354be6efd8904b90$export$f26508487bf83ee7; });
$parcel$export(module.exports, "addExceptionMechanism", function () { return $354be6efd8904b90$export$c69a9a0313b03bb1; });
$parcel$export(module.exports, "checkOrSetAlreadyCaught", function () { return $354be6efd8904b90$export$6de4ffac6a2f1098; });
$parcel$export(module.exports, "arrayify", function () { return $354be6efd8904b90$export$3131421a7d01b4fb; });

var $8WMel = parcelRequire("8WMel");

var $bqiXE = parcelRequire("bqiXE");

var $ehoTA = parcelRequire("ehoTA");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $354be6efd8904b90$export$19f53698e68b2496() {
    const gbl = (0, $ehoTA.GLOBAL_OBJ);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $354be6efd8904b90$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $354be6efd8904b90$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $354be6efd8904b90$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $354be6efd8904b90$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $354be6efd8904b90$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $354be6efd8904b90$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $354be6efd8904b90$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $354be6efd8904b90$export$d364f2020ab30578(input) {
    const match = input.match($354be6efd8904b90$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $354be6efd8904b90$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $bqiXE.snipLine)(line, 0));
    frame.context_line = (0, $bqiXE.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $bqiXE.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $354be6efd8904b90$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $8WMel.addNonEnumerableProperty)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $354be6efd8904b90$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}

});
parcelRegister("8WMel", function(module, exports) {

$parcel$export(module.exports, "fill", function () { return $683927139876e530$export$9563e054e6f787fb; });
$parcel$export(module.exports, "markFunctionWrapped", function () { return $683927139876e530$export$5c1499e2e5d010ae; });
$parcel$export(module.exports, "addNonEnumerableProperty", function () { return $683927139876e530$export$e73679ffaf56810e; });
$parcel$export(module.exports, "getOriginalFunction", function () { return $683927139876e530$export$e6cc1e135e2092e5; });
$parcel$export(module.exports, "urlEncode", function () { return $683927139876e530$export$9ef804feabbcbaf1; });
$parcel$export(module.exports, "convertToPlainObject", function () { return $683927139876e530$export$62ff257738bf57f5; });
$parcel$export(module.exports, "extractExceptionKeysForMessage", function () { return $683927139876e530$export$b0244d5063c0b61b; });
$parcel$export(module.exports, "dropUndefinedKeys", function () { return $683927139876e530$export$d25f2688db1bb433; });

var $db3mB = parcelRequire("db3mB");

var $15pqG = parcelRequire("15pqG");

var $l3GNb = parcelRequire("l3GNb");

var $7Dams = parcelRequire("7Dams");

var $bqiXE = parcelRequire("bqiXE");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $683927139876e530$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $683927139876e530$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $683927139876e530$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $15pqG.DEBUG_BUILD) && (0, $7Dams.logger).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $683927139876e530$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $683927139876e530$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $683927139876e530$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $683927139876e530$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $683927139876e530$export$62ff257738bf57f5(value) {
    if ((0, $l3GNb.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$683927139876e530$var$getOwnProperties(value)
    };
    else if ((0, $l3GNb.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $683927139876e530$var$serializeEventTarget(value.target),
            currentTarget: $683927139876e530$var$serializeEventTarget(value.currentTarget),
            ...$683927139876e530$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $l3GNb.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $683927139876e530$var$serializeEventTarget(target) {
    try {
        return (0, $l3GNb.isElement)(target) ? (0, $db3mB.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $683927139876e530$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $683927139876e530$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($683927139876e530$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return "[object has no keys]";
    if (keys[0].length >= maxLength) return (0, $bqiXE.truncate)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $bqiXE.truncate)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $683927139876e530$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $683927139876e530$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $683927139876e530$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($683927139876e530$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== "undefined") returnValue[key] = $683927139876e530$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($683927139876e530$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $683927139876e530$var$isPojo(input) {
    if (!(0, $l3GNb.isPlainObject)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === "Object";
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $683927139876e530$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $l3GNb.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("db3mB", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", function () { return $997ee96382669d76$export$5647df6b7814ac86; });
$parcel$export(module.exports, "getLocationHref", function () { return $997ee96382669d76$export$1cfafeee2987818b; });
$parcel$export(module.exports, "getDomElement", function () { return $997ee96382669d76$export$c660c1f3ab49225c; });
$parcel$export(module.exports, "getComponentName", function () { return $997ee96382669d76$export$26727cfcc4d7e0fc; });

var $l3GNb = parcelRequire("l3GNb");

var $ehoTA = parcelRequire("ehoTA");
// eslint-disable-next-line deprecation/deprecation
const $997ee96382669d76$var$WINDOW = (0, $ehoTA.getGlobalObject)();
const $997ee96382669d76$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $997ee96382669d76$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $997ee96382669d76$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $997ee96382669d76$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $997ee96382669d76$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if ($997ee96382669d76$var$WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if (elem instanceof HTMLElement && elem.dataset && elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $l3GNb.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $997ee96382669d76$export$1cfafeee2987818b() {
    try {
        return $997ee96382669d76$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $997ee96382669d76$export$c660c1f3ab49225c(selector) {
    if ($997ee96382669d76$var$WINDOW.document && $997ee96382669d76$var$WINDOW.document.querySelector) return $997ee96382669d76$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $997ee96382669d76$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$997ee96382669d76$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement && currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
        currentElem = currentElem.parentNode;
    }
    return null;
}

});

parcelRegister("bqiXE", function(module, exports) {

$parcel$export(module.exports, "truncate", function () { return $8510d4b15e645b12$export$6a506b36fdea397d; });
$parcel$export(module.exports, "snipLine", function () { return $8510d4b15e645b12$export$4215662d762d6f9d; });
$parcel$export(module.exports, "safeJoin", function () { return $8510d4b15e645b12$export$465e9d514283d4fd; });
$parcel$export(module.exports, "stringMatchesSomePattern", function () { return $8510d4b15e645b12$export$a7a5ec66062ea5d; });

var $l3GNb = parcelRequire("l3GNb");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $8510d4b15e645b12$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $8510d4b15e645b12$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $8510d4b15e645b12$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $l3GNb.isVueViewModel)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $8510d4b15e645b12$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $l3GNb.isString)(value)) return false;
    if ((0, $l3GNb.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $l3GNb.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $8510d4b15e645b12$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$8510d4b15e645b12$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}

});



parcelRegister("5QjIW", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", function () { return $44111bda48521154$export$849dbeeeda01ae98; });
const $44111bda48521154$export$849dbeeeda01ae98 = "production";

});

parcelRegister("gi5Ft", function(module, exports) {

$parcel$export(module.exports, "Scope", function () { return $bdc2b955f23815e1$export$775b6bb06e53a214; });
$parcel$export(module.exports, "getGlobalScope", function () { return $bdc2b955f23815e1$export$aa55d5ab8e05984f; });

var $bA8KD = parcelRequire("bA8KD");
var $l3GNb = parcelRequire("l3GNb");
var $7Dams = parcelRequire("7Dams");
var $4zH9l = parcelRequire("4zH9l");

var $7jAkK = parcelRequire("7jAkK");

var $lGtB9 = parcelRequire("lGtB9");

var $vNUiA = parcelRequire("vNUiA");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $bdc2b955f23815e1$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ let $bdc2b955f23815e1$var$globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $bdc2b955f23815e1$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /**
   * Transaction Name
   */ /** Span */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $bdc2b955f23815e1$var$generatePropagationContext();
    }
    /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ static clone(scope) {
        return scope ? scope.clone() : new $bdc2b955f23815e1$export$775b6bb06e53a214();
    }
    /**
   * Clone this scope instance.
   */ clone() {
        const newScope = new $bdc2b955f23815e1$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._span = this._span;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        return newScope;
    }
    /** Update the client on the scope. */ setClient(client) {
        this._client = client;
    }
    /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ getClient() {
        return this._client;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            segment: undefined,
            username: undefined
        };
        if (this._session) (0, $lGtB9.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope for future events.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ getSpan() {
        return this._span;
    }
    /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this._span;
        // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
        // Also, this method will be removed anyway.
        // eslint-disable-next-line deprecation/deprecation
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        if (scopeToMerge instanceof $bdc2b955f23815e1$export$775b6bb06e53a214) {
            const scopeData = scopeToMerge.getScopeData();
            this._tags = {
                ...this._tags,
                ...scopeData.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeData.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeData.contexts
            };
            if (scopeData.user && Object.keys(scopeData.user).length) this._user = scopeData.user;
            if (scopeData.level) this._level = scopeData.level;
            if (scopeData.fingerprint.length) this._fingerprint = scopeData.fingerprint;
            if (scopeToMerge.getRequestSession()) this._requestSession = scopeToMerge.getRequestSession();
            if (scopeData.propagationContext) this._propagationContext = scopeData.propagationContext;
        } else if ((0, $l3GNb.isPlainObject)(scopeToMerge)) {
            const scopeContext = captureContext;
            this._tags = {
                ...this._tags,
                ...scopeContext.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeContext.contexts
            };
            if (scopeContext.user) this._user = scopeContext.user;
            if (scopeContext.level) this._level = scopeContext.level;
            if (scopeContext.fingerprint) this._fingerprint = scopeContext.fingerprint;
            if (scopeContext.requestSession) this._requestSession = scopeContext.requestSession;
            if (scopeContext.propagationContext) this._propagationContext = scopeContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $bdc2b955f23815e1$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $bdc2b955f23815e1$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $bA8KD.dateTimestampInSeconds)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ getAttachments() {
        const data = this.getScopeData();
        return data.attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        const { _breadcrumbs: _breadcrumbs, _attachments: _attachments, _contexts: _contexts, _tags: _tags, _extra: _extra, _user: _user, _level: _level, _fingerprint: _fingerprint, _eventProcessors: _eventProcessors, _propagationContext: _propagationContext, _sdkProcessingMetadata: _sdkProcessingMetadata, _transactionName: _transactionName, _span: _span } = this;
        return {
            breadcrumbs: _breadcrumbs,
            attachments: _attachments,
            contexts: _contexts,
            tags: _tags,
            extra: _extra,
            user: _user,
            level: _level,
            fingerprint: _fingerprint || [],
            eventProcessors: _eventProcessors,
            propagationContext: _propagationContext,
            sdkProcessingMetadata: _sdkProcessingMetadata,
            transactionName: _transactionName,
            span: _span
        };
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ applyToEvent(event, hint = {}, additionalEventProcessors = []) {
        (0, $vNUiA.applyScopeDataToEvent)(event, this.getScopeData());
        // TODO (v8): Update this order to be: Global > Client > Scope
        const eventProcessors = [
            ...additionalEventProcessors,
            // eslint-disable-next-line deprecation/deprecation
            ...(0, $7jAkK.getGlobalEventProcessors)(),
            ...this._eventProcessors
        ];
        return (0, $7jAkK.notifyEventProcessors)(eventProcessors, event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $4zH9l.uuid4)();
        if (!this._client) {
            (0, $7Dams.logger).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $4zH9l.uuid4)();
        if (!this._client) {
            (0, $7Dams.logger).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $4zH9l.uuid4)();
        if (!this._client) {
            (0, $7Dams.logger).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $bdc2b955f23815e1$export$aa55d5ab8e05984f() {
    if (!$bdc2b955f23815e1$var$globalScope) $bdc2b955f23815e1$var$globalScope = new $bdc2b955f23815e1$export$775b6bb06e53a214();
    return $bdc2b955f23815e1$var$globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function $bdc2b955f23815e1$export$c83048efd17527d6(scope) {
    $bdc2b955f23815e1$var$globalScope = scope;
}
function $bdc2b955f23815e1$var$generatePropagationContext() {
    return {
        traceId: (0, $4zH9l.uuid4)(),
        spanId: (0, $4zH9l.uuid4)().substring(16)
    };
}

});
parcelRegister("7jAkK", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventProcessors", function () { return $55367dd8fb831d5d$export$3c4238858b85e8ac; });
$parcel$export(module.exports, "addGlobalEventProcessor", function () { return $55367dd8fb831d5d$export$8e4e25f54d456511; });
$parcel$export(module.exports, "notifyEventProcessors", function () { return $55367dd8fb831d5d$export$bf2a096c3e883e79; });

var $ehoTA = parcelRequire("ehoTA");
var $l3GNb = parcelRequire("l3GNb");
var $7Dams = parcelRequire("7Dams");
var $goLCC = parcelRequire("goLCC");

var $3JSHc = parcelRequire("3JSHc");
/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function $55367dd8fb831d5d$export$3c4238858b85e8ac() {
    return (0, $ehoTA.getGlobalSingleton)("globalEventProcessors", ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function $55367dd8fb831d5d$export$8e4e25f54d456511(callback) {
    // eslint-disable-next-line deprecation/deprecation
    $55367dd8fb831d5d$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $55367dd8fb831d5d$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $goLCC.SyncPromise)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== "function") resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $3JSHc.DEBUG_BUILD) && processor.id && result === null && (0, $7Dams.logger).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $l3GNb.isThenable)(result)) result.then((final)=>$55367dd8fb831d5d$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $55367dd8fb831d5d$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}

});
parcelRegister("goLCC", function(module, exports) {

$parcel$export(module.exports, "resolvedSyncPromise", function () { return $bf03d3f086a39559$export$1fda8aa4d135f8aa; });
$parcel$export(module.exports, "SyncPromise", function () { return $bf03d3f086a39559$export$6f292d4960313241; });
$parcel$export(module.exports, "rejectedSyncPromise", function () { return $bf03d3f086a39559$export$78e43115b553f358; });

var $l3GNb = parcelRequire("l3GNb");
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $bf03d3f086a39559$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($bf03d3f086a39559$var$States || ($bf03d3f086a39559$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $bf03d3f086a39559$export$1fda8aa4d135f8aa(value) {
    return new $bf03d3f086a39559$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $bf03d3f086a39559$export$78e43115b553f358(reason) {
    return new $bf03d3f086a39559$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $bf03d3f086a39559$export$6f292d4960313241 {
    constructor(executor){
        $bf03d3f086a39559$export$6f292d4960313241.prototype.__init.call(this);
        $bf03d3f086a39559$export$6f292d4960313241.prototype.__init2.call(this);
        $bf03d3f086a39559$export$6f292d4960313241.prototype.__init3.call(this);
        $bf03d3f086a39559$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $bf03d3f086a39559$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $bf03d3f086a39559$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $bf03d3f086a39559$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($bf03d3f086a39559$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($bf03d3f086a39559$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $bf03d3f086a39559$var$States.PENDING) return;
            if ((0, $l3GNb.isThenable)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $bf03d3f086a39559$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $bf03d3f086a39559$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $bf03d3f086a39559$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}

});


parcelRegister("lGtB9", function(module, exports) {

$parcel$export(module.exports, "makeSession", function () { return $0412e934e4da65ea$export$14a186326edbb264; });
$parcel$export(module.exports, "updateSession", function () { return $0412e934e4da65ea$export$531818e825e774db; });
$parcel$export(module.exports, "closeSession", function () { return $0412e934e4da65ea$export$56521d9ba90f62ee; });

var $8WMel = parcelRequire("8WMel");
var $bA8KD = parcelRequire("bA8KD");
var $4zH9l = parcelRequire("4zH9l");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $0412e934e4da65ea$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $bA8KD.timestampInSeconds)();
    const session = {
        sid: (0, $4zH9l.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$0412e934e4da65ea$var$sessionToJSON(session)
    };
    if (context) $0412e934e4da65ea$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $0412e934e4da65ea$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $bA8KD.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $4zH9l.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $0412e934e4da65ea$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $0412e934e4da65ea$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $0412e934e4da65ea$var$sessionToJSON(session) {
    return (0, $8WMel.dropUndefinedKeys)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}

});

parcelRegister("vNUiA", function(module, exports) {

$parcel$export(module.exports, "applyScopeDataToEvent", function () { return $05f99bdd68c01a92$export$43988bc651a80216; });
$parcel$export(module.exports, "mergeScopeData", function () { return $05f99bdd68c01a92$export$25ac7e259a513db4; });

var $4zH9l = parcelRequire("4zH9l");
var $8WMel = parcelRequire("8WMel");

var $8XBHU = parcelRequire("8XBHU");

var $fDnGa = parcelRequire("fDnGa");

var $IueXx = parcelRequire("IueXx");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $05f99bdd68c01a92$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $05f99bdd68c01a92$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $05f99bdd68c01a92$var$applySpanToEvent(event, span);
    $05f99bdd68c01a92$var$applyFingerprintToEvent(event, fingerprint);
    $05f99bdd68c01a92$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $05f99bdd68c01a92$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $05f99bdd68c01a92$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName, span: span } = mergeData;
    $05f99bdd68c01a92$export$b1a120a2871faa46(data, "extra", extra);
    $05f99bdd68c01a92$export$b1a120a2871faa46(data, "tags", tags);
    $05f99bdd68c01a92$export$b1a120a2871faa46(data, "user", user);
    $05f99bdd68c01a92$export$b1a120a2871faa46(data, "contexts", contexts);
    $05f99bdd68c01a92$export$b1a120a2871faa46(data, "sdkProcessingMetadata", sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $05f99bdd68c01a92$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $05f99bdd68c01a92$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName } = data;
    const cleanedExtra = (0, $8WMel.dropUndefinedKeys)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $8WMel.dropUndefinedKeys)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $8WMel.dropUndefinedKeys)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $8WMel.dropUndefinedKeys)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName) event.transaction = transactionName;
}
function $05f99bdd68c01a92$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $05f99bdd68c01a92$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $05f99bdd68c01a92$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $IueXx.spanToTraceContext)(span),
        ...event.contexts
    };
    const rootSpan = (0, $fDnGa.getRootSpan)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = {
            dynamicSamplingContext: (0, $8XBHU.getDynamicSamplingContextFromSpan)(span),
            ...event.sdkProcessingMetadata
        };
        const transactionName = (0, $IueXx.spanToJSON)(rootSpan).description;
        if (transactionName) event.tags = {
            transaction: transactionName,
            ...event.tags
        };
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $05f99bdd68c01a92$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $4zH9l.arrayify)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}

});
parcelRegister("8XBHU", function(module, exports) {

$parcel$export(module.exports, "getDynamicSamplingContextFromClient", function () { return $68611542e660689b$export$366bad00d6815eed; });
$parcel$export(module.exports, "getDynamicSamplingContextFromSpan", function () { return $68611542e660689b$export$a117f995597e25df; });

var $8WMel = parcelRequire("8WMel");

var $5QjIW = parcelRequire("5QjIW");

var $iKbxs = parcelRequire("iKbxs");

var $fDnGa = parcelRequire("fDnGa");

var $IueXx = parcelRequire("IueXx");
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $68611542e660689b$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $8WMel.dropUndefinedKeys)({
        environment: options.environment || (0, $5QjIW.DEFAULT_ENVIRONMENT),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $68611542e660689b$export$a117f995597e25df(span) {
    const client = (0, $iKbxs.getClient)();
    if (!client) return {};
    // passing emit=false here to only emit later once the DSC is actually populated
    const dsc = $68611542e660689b$export$366bad00d6815eed((0, $IueXx.spanToJSON)(span).trace_id || "", client, (0, $iKbxs.getCurrentScope)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    const txn = (0, $fDnGa.getRootSpan)(span);
    if (!txn) return dsc;
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) return v7FrozenDsc;
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    const { sampleRate: maybeSampleRate, source: source } = txn.metadata;
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const jsonSpan = (0, $IueXx.spanToJSON)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== "url") dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $IueXx.spanIsSampled)(txn));
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}

});
parcelRegister("iKbxs", function(module, exports) {

$parcel$export(module.exports, "captureException", function () { return $da55793264fec0ab$export$f5282963edea4a68; });
$parcel$export(module.exports, "captureEvent", function () { return $da55793264fec0ab$export$1462b974fdcf6ba2; });
$parcel$export(module.exports, "addBreadcrumb", function () { return $da55793264fec0ab$export$efda9a273d7a036d; });
$parcel$export(module.exports, "setContext", function () { return $da55793264fec0ab$export$2f04de43fe27971a; });
$parcel$export(module.exports, "setTag", function () { return $da55793264fec0ab$export$a37d07ee78eb4569; });
$parcel$export(module.exports, "setUser", function () { return $da55793264fec0ab$export$8b6bb3dd62a01be2; });
$parcel$export(module.exports, "withScope", function () { return $da55793264fec0ab$export$ec58d9285c204497; });
$parcel$export(module.exports, "withActiveSpan", function () { return $da55793264fec0ab$export$e57ac09b143d92a2; });
$parcel$export(module.exports, "getCurrentScope", function () { return $da55793264fec0ab$export$c7be4b0125a10cba; });
$parcel$export(module.exports, "getClient", function () { return $da55793264fec0ab$export$6bb76d6eba7e258c; });
$parcel$export(module.exports, "startSession", function () { return $da55793264fec0ab$export$c0d84948cecf78d8; });
$parcel$export(module.exports, "captureSession", function () { return $da55793264fec0ab$export$667e7b4d445d566b; });

var $ehoTA = parcelRequire("ehoTA");
var $l3GNb = parcelRequire("l3GNb");
var $7Dams = parcelRequire("7Dams");
var $bA8KD = parcelRequire("bA8KD");
var $4zH9l = parcelRequire("4zH9l");

var $5QjIW = parcelRequire("5QjIW");

var $3JSHc = parcelRequire("3JSHc");

var $aFDsf = parcelRequire("aFDsf");

var $lGtB9 = parcelRequire("lGtB9");

var $1M1wc = parcelRequire("1M1wc");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $da55793264fec0ab$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $aFDsf.getCurrentHub)().captureException(exception, (0, $1M1wc.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $da55793264fec0ab$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === "string" ? captureContext : undefined;
    const context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0, $aFDsf.getCurrentHub)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $da55793264fec0ab$export$1462b974fdcf6ba2(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $aFDsf.getCurrentHub)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ // eslint-disable-next-line deprecation/deprecation
function $da55793264fec0ab$export$99d44f04437e9cb8(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $aFDsf.getCurrentHub)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ // eslint-disable-next-line deprecation/deprecation
function $da55793264fec0ab$export$efda9a273d7a036d(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $aFDsf.getCurrentHub)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function $da55793264fec0ab$export$2f04de43fe27971a(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $aFDsf.getCurrentHub)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $da55793264fec0ab$export$bb4922da0dd51b92(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $aFDsf.getCurrentHub)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line deprecation/deprecation
function $da55793264fec0ab$export$8e8e7789d42ed61d(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $aFDsf.getCurrentHub)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $da55793264fec0ab$export$74a8fb34822092e6(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $aFDsf.getCurrentHub)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ // eslint-disable-next-line deprecation/deprecation
function $da55793264fec0ab$export$a37d07ee78eb4569(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $aFDsf.getCurrentHub)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ // eslint-disable-next-line deprecation/deprecation
function $da55793264fec0ab$export$8b6bb3dd62a01be2(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $aFDsf.getCurrentHub)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $da55793264fec0ab$export$ec58d9285c204497(...rest) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $aFDsf.getCurrentHub)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(callback);
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(()=>{
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function $da55793264fec0ab$export$9a4fed82c350c2bd(callback) {
    return (0, $aFDsf.runWithAsyncContext)(()=>{
        return callback((0, $aFDsf.getIsolationScope)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $da55793264fec0ab$export$e57ac09b143d92a2(span, callback) {
    return $da55793264fec0ab$export$ec58d9285c204497((scope)=>{
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function $da55793264fec0ab$export$e262da7ae6480481(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $aFDsf.getCurrentHub)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $da55793264fec0ab$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = $da55793264fec0ab$export$c7be4b0125a10cba();
    const client = $da55793264fec0ab$export$6bb76d6eba7e258c();
    if (!client) (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $4zH9l.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $da55793264fec0ab$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $da55793264fec0ab$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: "in_progress"
    }, upsertMonitorConfig);
    const now = (0, $bA8KD.timestampInSeconds)();
    function finishCheckIn(status) {
        $da55793264fec0ab$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $bA8KD.timestampInSeconds)() - now
        });
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn("error");
        throw e;
    }
    if ((0, $l3GNb.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishCheckIn("ok");
    }, ()=>{
        finishCheckIn("error");
    });
    else finishCheckIn("ok");
    return maybePromiseResult;
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $da55793264fec0ab$export$4909b86c8034bf73(timeout) {
    const client = $da55793264fec0ab$export$6bb76d6eba7e258c();
    if (client) return client.flush(timeout);
    (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $da55793264fec0ab$export$8360e631d277ea4d(timeout) {
    const client = $da55793264fec0ab$export$6bb76d6eba7e258c();
    if (client) return client.close(timeout);
    (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function $da55793264fec0ab$export$5d4e9fd7fac8e617() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $aFDsf.getCurrentHub)().lastEventId();
}
/**
 * Get the currently active client.
 */ function $da55793264fec0ab$export$6bb76d6eba7e258c() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $aFDsf.getCurrentHub)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $da55793264fec0ab$export$3f95c6f800b78024() {
    return !!$da55793264fec0ab$export$6bb76d6eba7e258c();
}
/**
 * Get the currently active scope.
 */ function $da55793264fec0ab$export$c7be4b0125a10cba() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $aFDsf.getCurrentHub)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $da55793264fec0ab$export$c0d84948cecf78d8(context) {
    const client = $da55793264fec0ab$export$6bb76d6eba7e258c();
    const isolationScope = (0, $aFDsf.getIsolationScope)();
    const currentScope = $da55793264fec0ab$export$c7be4b0125a10cba();
    const { release: release, environment: environment = (0, $5QjIW.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $ehoTA.GLOBAL_OBJ).navigator || {};
    const session = (0, $lGtB9.makeSession)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === "ok") (0, $lGtB9.updateSession)(currentSession, {
        status: "exited"
    });
    $da55793264fec0ab$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $da55793264fec0ab$export$17a5be43989a0bc1() {
    const isolationScope = (0, $aFDsf.getIsolationScope)();
    const currentScope = $da55793264fec0ab$export$c7be4b0125a10cba();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $lGtB9.closeSession)(session);
    $da55793264fec0ab$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $da55793264fec0ab$var$_sendSessionUpdate() {
    const isolationScope = (0, $aFDsf.getIsolationScope)();
    const currentScope = $da55793264fec0ab$export$c7be4b0125a10cba();
    const client = $da55793264fec0ab$export$6bb76d6eba7e258c();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $da55793264fec0ab$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $da55793264fec0ab$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $da55793264fec0ab$var$_sendSessionUpdate();
}

});
parcelRegister("1M1wc", function(module, exports) {

$parcel$export(module.exports, "prepareEvent", function () { return $14ab73a8c3e1b9b5$export$2d67fb380bd11267; });
$parcel$export(module.exports, "parseEventHintOrCaptureContext", function () { return $14ab73a8c3e1b9b5$export$76b5f966996d1653; });

var $4zH9l = parcelRequire("4zH9l");
var $bA8KD = parcelRequire("bA8KD");
var $ehoTA = parcelRequire("ehoTA");
var $6l9XD = parcelRequire("6l9XD");
var $bqiXE = parcelRequire("bqiXE");

var $5QjIW = parcelRequire("5QjIW");

var $7jAkK = parcelRequire("7jAkK");

var $gi5Ft = parcelRequire("gi5Ft");

var $vNUiA = parcelRequire("vNUiA");

var $IueXx = parcelRequire("IueXx");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $14ab73a8c3e1b9b5$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $4zH9l.uuid4)(),
        timestamp: event.timestamp || (0, $bA8KD.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $14ab73a8c3e1b9b5$var$applyClientOptions(prepared, options);
    $14ab73a8c3e1b9b5$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $14ab73a8c3e1b9b5$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $14ab73a8c3e1b9b5$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $4zH9l.addExceptionMechanism)(prepared, hint.mechanism);
    const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $gi5Ft.getGlobalScope)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $vNUiA.mergeScopeData)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $vNUiA.mergeScopeData)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $vNUiA.applyScopeDataToEvent)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
        ...clientEventProcessors,
        // eslint-disable-next-line deprecation/deprecation
        ...(0, $7jAkK.getGlobalEventProcessors)(),
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $7jAkK.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $14ab73a8c3e1b9b5$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $14ab73a8c3e1b9b5$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $14ab73a8c3e1b9b5$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!("environment" in event)) event.environment = "environment" in options ? environment : (0, $5QjIW.DEFAULT_ENVIRONMENT);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $bqiXE.truncate)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $bqiXE.truncate)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $bqiXE.truncate)(request.url, maxValueLength);
}
const $14ab73a8c3e1b9b5$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $14ab73a8c3e1b9b5$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $ehoTA.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $14ab73a8c3e1b9b5$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $14ab73a8c3e1b9b5$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $14ab73a8c3e1b9b5$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $14ab73a8c3e1b9b5$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $14ab73a8c3e1b9b5$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $6l9XD.normalize)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $6l9XD.normalize)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $6l9XD.normalize)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $6l9XD.normalize)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $6l9XD.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        const data = (0, $IueXx.spanToJSON)(span).data;
        if (data) // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0, $6l9XD.normalize)(data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
function $14ab73a8c3e1b9b5$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $gi5Ft.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $14ab73a8c3e1b9b5$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($14ab73a8c3e1b9b5$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($14ab73a8c3e1b9b5$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $14ab73a8c3e1b9b5$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $gi5Ft.Scope) || typeof hint === "function";
}
const $14ab73a8c3e1b9b5$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "requestSession",
    "propagationContext"
];
function $14ab73a8c3e1b9b5$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$14ab73a8c3e1b9b5$var$captureContextKeys.includes(key));
}

});
parcelRegister("6l9XD", function(module, exports) {

$parcel$export(module.exports, "normalize", function () { return $49dc6e448b1cf64c$export$a3295358bff77e; });
$parcel$export(module.exports, "normalizeToSize", function () { return $49dc6e448b1cf64c$export$23fbbb20bed71033; });

var $l3GNb = parcelRequire("l3GNb");

var $7k8mg = parcelRequire("7k8mg");

var $8WMel = parcelRequire("8WMel");

var $kmiJQ = parcelRequire("kmiJQ");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $49dc6e448b1cf64c$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $49dc6e448b1cf64c$export$588732934346abbf("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $49dc6e448b1cf64c$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $49dc6e448b1cf64c$export$a3295358bff77e(object, depth);
    if ($49dc6e448b1cf64c$var$jsonSize(normalized) > maxSize) return $49dc6e448b1cf64c$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $49dc6e448b1cf64c$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $7k8mg.memoBuilder)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "number",
        "boolean",
        "string"
    ].includes(typeof value) && !(0, $l3GNb.isNaN)(value)) return value;
    const stringified = $49dc6e448b1cf64c$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $49dc6e448b1cf64c$export$588732934346abbf("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $8WMel.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $49dc6e448b1cf64c$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $49dc6e448b1cf64c$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, $l3GNb.isVueViewModel)(value)) return "[VueViewModel]";
        // React's SyntheticEvent thingy
        if ((0, $l3GNb.isSyntheticEvent)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && value !== value) return "[NaN]";
        if (typeof value === "function") return `[Function: ${(0, $kmiJQ.getFunctionName)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $49dc6e448b1cf64c$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $49dc6e448b1cf64c$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $49dc6e448b1cf64c$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $49dc6e448b1cf64c$var$jsonSize(value) {
    return $49dc6e448b1cf64c$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $49dc6e448b1cf64c$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, "/")// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "") // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}

});
parcelRegister("7k8mg", function(module, exports) {

$parcel$export(module.exports, "memoBuilder", function () { return $5550e26353da6e9d$export$8115b0b78e956ab3; });
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $5550e26353da6e9d$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === "function";
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});

parcelRegister("kmiJQ", function(module, exports) {

$parcel$export(module.exports, "createStackParser", function () { return $ed2465ce3c82d54a$export$a5739666fb2d03d4; });
$parcel$export(module.exports, "stackParserFromStackParserOptions", function () { return $ed2465ce3c82d54a$export$1d5cf88b347146d4; });
$parcel$export(module.exports, "getFunctionName", function () { return $ed2465ce3c82d54a$export$aad197c7121a6651; });

var $1POzQ = parcelRequire("1POzQ");
const $ed2465ce3c82d54a$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $ed2465ce3c82d54a$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $ed2465ce3c82d54a$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $ed2465ce3c82d54a$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $ed2465ce3c82d54a$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($ed2465ce3c82d54a$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $ed2465ce3c82d54a$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $ed2465ce3c82d54a$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $ed2465ce3c82d54a$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $ed2465ce3c82d54a$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $ed2465ce3c82d54a$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($ed2465ce3c82d54a$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($ed2465ce3c82d54a$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    }
    return localStack.slice(0, $ed2465ce3c82d54a$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || "?"
        }));
}
const $ed2465ce3c82d54a$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $ed2465ce3c82d54a$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $ed2465ce3c82d54a$var$defaultFunctionName;
        return fn.name || $ed2465ce3c82d54a$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $ed2465ce3c82d54a$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $ed2465ce3c82d54a$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $1POzQ.node)(getModule)
    ];
}

});
parcelRegister("1POzQ", function(module, exports) {

$parcel$export(module.exports, "node", function () { return $1561c96847c64972$export$35059013cd4a06db; });
/**
 * Does this filename look like it's part of the app code?
 */ function $1561c96847c64972$export$1de92f38f4de99a8(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith("/") && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith(".") && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes("node_modules/");
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $1561c96847c64972$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf(".");
                if (functionName[methodStart - 1] === ".") methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf(".Module");
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === "<anonymous>") {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || "<anonymous>";
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith("file://") ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === "native";
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename && filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $1561c96847c64972$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}

});



parcelRegister("IueXx", function(module, exports) {

$parcel$export(module.exports, "TRACE_FLAG_NONE", function () { return $085b9143e34bb5cc$export$208d5b368507fb8b; });
$parcel$export(module.exports, "TRACE_FLAG_SAMPLED", function () { return $085b9143e34bb5cc$export$eb571cd9b5d98de8; });
$parcel$export(module.exports, "spanToTraceContext", function () { return $085b9143e34bb5cc$export$46c6fbd1d265ebf0; });
$parcel$export(module.exports, "spanToJSON", function () { return $085b9143e34bb5cc$export$92d8c23565496537; });
$parcel$export(module.exports, "spanToTraceHeader", function () { return $085b9143e34bb5cc$export$7e9f8ae9e4a328ab; });
$parcel$export(module.exports, "spanIsSampled", function () { return $085b9143e34bb5cc$export$5caecac1caaf3a71; });
$parcel$export(module.exports, "spanTimeInputToSeconds", function () { return $085b9143e34bb5cc$export$3f7581298f56c6d7; });

var $8WMel = parcelRequire("8WMel");
var $MppwO = parcelRequire("MppwO");
var $bA8KD = parcelRequire("bA8KD");
// These are aligned with OpenTelemetry trace flags
const $085b9143e34bb5cc$export$208d5b368507fb8b = 0x0;
const $085b9143e34bb5cc$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function $085b9143e34bb5cc$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, tags: tags, origin: origin } = $085b9143e34bb5cc$export$92d8c23565496537(span);
    return (0, $8WMel.dropUndefinedKeys)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $085b9143e34bb5cc$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $085b9143e34bb5cc$export$5caecac1caaf3a71(span);
    return (0, $MppwO.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $085b9143e34bb5cc$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $085b9143e34bb5cc$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $085b9143e34bb5cc$var$ensureTimestampInSeconds(input.getTime());
    return (0, $bA8KD.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $085b9143e34bb5cc$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function $085b9143e34bb5cc$export$92d8c23565496537(span) {
    if ($085b9143e34bb5cc$var$spanIsSpanClass(span)) return span.getSpanJSON();
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === "function") // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $085b9143e34bb5cc$var$spanIsSpanClass(span) {
    return typeof span.getSpanJSON === "function";
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $085b9143e34bb5cc$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & $085b9143e34bb5cc$export$eb571cd9b5d98de8);
}

});
parcelRegister("MppwO", function(module, exports) {

$parcel$export(module.exports, "extractTraceparentData", function () { return $091831daabdde9b7$export$8e9a29865c0a1226; });
$parcel$export(module.exports, "tracingContextFromHeaders", function () { return $091831daabdde9b7$export$ca5c066532785b6e; });
$parcel$export(module.exports, "propagationContextFromHeaders", function () { return $091831daabdde9b7$export$261f383d16a93e39; });
$parcel$export(module.exports, "generateSentryTraceHeader", function () { return $091831daabdde9b7$export$f35d907436da45cf; });

var $2HmZY = parcelRequire("2HmZY");

var $4zH9l = parcelRequire("4zH9l");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $091831daabdde9b7$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $091831daabdde9b7$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($091831daabdde9b7$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function $091831daabdde9b7$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $091831daabdde9b7$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $2HmZY.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceparentData: traceparentData,
        dynamicSamplingContext: undefined,
        propagationContext: {
            traceId: traceId || (0, $4zH9l.uuid4)(),
            spanId: (0, $4zH9l.uuid4)().substring(16)
        }
    };
    else return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext || {},
        propagationContext: {
            traceId: traceId || (0, $4zH9l.uuid4)(),
            parentSpanId: parentSpanId || (0, $4zH9l.uuid4)().substring(16),
            spanId: (0, $4zH9l.uuid4)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        }
    };
}
/**
 * Create a propagation context from incoming headers.
 */ function $091831daabdde9b7$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $091831daabdde9b7$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $2HmZY.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $4zH9l.uuid4)(),
        spanId: (0, $4zH9l.uuid4)().substring(16)
    };
    else return {
        traceId: traceId || (0, $4zH9l.uuid4)(),
        parentSpanId: parentSpanId || (0, $4zH9l.uuid4)().substring(16),
        spanId: (0, $4zH9l.uuid4)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $091831daabdde9b7$export$f35d907436da45cf(traceId = (0, $4zH9l.uuid4)(), spanId = (0, $4zH9l.uuid4)().substring(16), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}

});
parcelRegister("2HmZY", function(module, exports) {

$parcel$export(module.exports, "BAGGAGE_HEADER_NAME", function () { return $1f716ff5cddfa3dd$export$9ca9946bd449ac06; });
$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", function () { return $1f716ff5cddfa3dd$export$5b96ee2c8421f107; });
$parcel$export(module.exports, "dynamicSamplingContextToSentryBaggageHeader", function () { return $1f716ff5cddfa3dd$export$56766feef403f365; });

var $15pqG = parcelRequire("15pqG");

var $l3GNb = parcelRequire("l3GNb");

var $7Dams = parcelRequire("7Dams");
const $1f716ff5cddfa3dd$export$9ca9946bd449ac06 = "baggage";
const $1f716ff5cddfa3dd$export$6e69537d67fa20f = "sentry-";
const $1f716ff5cddfa3dd$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $1f716ff5cddfa3dd$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $1f716ff5cddfa3dd$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $l3GNb.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $1f716ff5cddfa3dd$var$baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $1f716ff5cddfa3dd$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($1f716ff5cddfa3dd$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($1f716ff5cddfa3dd$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $1f716ff5cddfa3dd$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$1f716ff5cddfa3dd$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $1f716ff5cddfa3dd$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $1f716ff5cddfa3dd$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>baggageEntry.split("=").map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $1f716ff5cddfa3dd$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $1f716ff5cddfa3dd$export$bdd844ddb2def819) {
            (0, $15pqG.DEBUG_BUILD) && (0, $7Dams.logger).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}

});





parcelRegister("fDnGa", function(module, exports) {

$parcel$export(module.exports, "getRootSpan", function () { return $b61cddaffc4413a6$export$c4c6a79b1260ca1b; });
/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ function $b61cddaffc4413a6$export$c4c6a79b1260ca1b(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}

});




parcelRegister("dUT9Y", function(module, exports) {

$parcel$export(module.exports, "SDK_VERSION", function () { return $a21b4ae8bf30d6c4$export$31499a9cd224b78c; });
const $a21b4ae8bf30d6c4$export$31499a9cd224b78c = "7.119.2";

});


parcelRegister("gdEM4", function(module, exports) {

$parcel$export(module.exports, "registerErrorInstrumentation", function () { return $bced7d259ac89b9f$export$637857c1d87b640c; });

var $dDzKl = parcelRequire("dDzKl");
var $4CL9G = parcelRequire("4CL9G");
var $7Dams = parcelRequire("7Dams");

var $3JSHc = parcelRequire("3JSHc");

var $bdACW = parcelRequire("bdACW");
let $bced7d259ac89b9f$var$errorsInstrumented = false;
/**
 * Configures global error listeners
 */ function $bced7d259ac89b9f$export$637857c1d87b640c() {
    if ($bced7d259ac89b9f$var$errorsInstrumented) return;
    $bced7d259ac89b9f$var$errorsInstrumented = true;
    (0, $dDzKl.addGlobalErrorInstrumentationHandler)($bced7d259ac89b9f$var$errorCallback);
    (0, $4CL9G.addGlobalUnhandledRejectionInstrumentationHandler)($bced7d259ac89b9f$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function $bced7d259ac89b9f$var$errorCallback() {
    // eslint-disable-next-line deprecation/deprecation
    const activeTransaction = (0, $bdACW.getActiveTransaction)();
    if (activeTransaction) {
        const status = "internal_error";
        (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).log(`[Tracing] Transaction: ${status} -> Global error occured`);
        activeTransaction.setStatus(status);
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$bced7d259ac89b9f$var$errorCallback.tag = "sentry_tracingErrorCallback";

});
parcelRegister("dDzKl", function(module, exports) {

$parcel$export(module.exports, "addGlobalErrorInstrumentationHandler", function () { return $9edaa56109667654$export$55b5c3ba2194f0c6; });

var $ehoTA = parcelRequire("ehoTA");

var $czuIS = parcelRequire("czuIS");
let $9edaa56109667654$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $9edaa56109667654$export$55b5c3ba2194f0c6(handler) {
    const type = "error";
    (0, $czuIS.addHandler)(type, handler);
    (0, $czuIS.maybeInstrument)(type, $9edaa56109667654$var$instrumentError);
}
function $9edaa56109667654$var$instrumentError() {
    $9edaa56109667654$var$_oldOnErrorHandler = (0, $ehoTA.GLOBAL_OBJ).onerror;
    (0, $ehoTA.GLOBAL_OBJ).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $czuIS.triggerHandlers)("error", handlerData);
        if ($9edaa56109667654$var$_oldOnErrorHandler && !$9edaa56109667654$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $9edaa56109667654$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $ehoTA.GLOBAL_OBJ).onerror.__SENTRY_INSTRUMENTED__ = true;
}

});
parcelRegister("czuIS", function(module, exports) {

$parcel$export(module.exports, "addHandler", function () { return $927095ce79acfd4c$export$a4e09611e30da72e; });
$parcel$export(module.exports, "maybeInstrument", function () { return $927095ce79acfd4c$export$e18d6c5462c01368; });
$parcel$export(module.exports, "triggerHandlers", function () { return $927095ce79acfd4c$export$b18c893e424d3127; });

var $15pqG = parcelRequire("15pqG");

var $7Dams = parcelRequire("7Dams");

var $kmiJQ = parcelRequire("kmiJQ");
// We keep the handlers globally
const $927095ce79acfd4c$var$handlers = {};
const $927095ce79acfd4c$var$instrumented = {};
/** Add a handler function. */ function $927095ce79acfd4c$export$a4e09611e30da72e(type, handler) {
    $927095ce79acfd4c$var$handlers[type] = $927095ce79acfd4c$var$handlers[type] || [];
    $927095ce79acfd4c$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $927095ce79acfd4c$export$b17eab759a1cb5fe() {
    Object.keys($927095ce79acfd4c$var$handlers).forEach((key)=>{
        $927095ce79acfd4c$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $927095ce79acfd4c$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$927095ce79acfd4c$var$instrumented[type]) {
        instrumentFn();
        $927095ce79acfd4c$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $927095ce79acfd4c$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $927095ce79acfd4c$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $15pqG.DEBUG_BUILD) && (0, $7Dams.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $kmiJQ.getFunctionName)(handler)}\nError:`, e);
    }
}

});


parcelRegister("4CL9G", function(module, exports) {

$parcel$export(module.exports, "addGlobalUnhandledRejectionInstrumentationHandler", function () { return $35df4a1097762a79$export$8bf4fc6858821a4e; });

var $ehoTA = parcelRequire("ehoTA");

var $czuIS = parcelRequire("czuIS");
let $35df4a1097762a79$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $35df4a1097762a79$export$8bf4fc6858821a4e(handler) {
    const type = "unhandledrejection";
    (0, $czuIS.addHandler)(type, handler);
    (0, $czuIS.maybeInstrument)(type, $35df4a1097762a79$var$instrumentUnhandledRejection);
}
function $35df4a1097762a79$var$instrumentUnhandledRejection() {
    $35df4a1097762a79$var$_oldOnUnhandledRejectionHandler = (0, $ehoTA.GLOBAL_OBJ).onunhandledrejection;
    (0, $ehoTA.GLOBAL_OBJ).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $czuIS.triggerHandlers)("unhandledrejection", handlerData);
        if ($35df4a1097762a79$var$_oldOnUnhandledRejectionHandler && !$35df4a1097762a79$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $35df4a1097762a79$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $ehoTA.GLOBAL_OBJ).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}

});

parcelRegister("bdACW", function(module, exports) {

$parcel$export(module.exports, "getActiveTransaction", function () { return $82ad51ff681da486$export$a7feb32fdd923295; });

var $MppwO = parcelRequire("MppwO");

var $aFDsf = parcelRequire("aFDsf");
/**
 * Grabs active transaction off scope.
 *
 * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $82ad51ff681da486$export$a7feb32fdd923295(maybeHub) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = maybeHub || (0, $aFDsf.getCurrentHub)();
    // eslint-disable-next-line deprecation/deprecation
    const scope = hub.getScope();
    // eslint-disable-next-line deprecation/deprecation
    return scope.getTransaction();
}
/**
 * The `extractTraceparentData` function and `TRACEPARENT_REGEXP` constant used
 * to be declared in this file. It was later moved into `@sentry/utils` as part of a
 * move to remove `@sentry/tracing` dependencies from `@sentry/node` (`extractTraceparentData`
 * is the only tracing function used by `@sentry/node`).
 *
 * These exports are kept here for backwards compatability's sake.
 *
 * See https://github.com/getsentry/sentry-javascript/issues/4642 for more details.
 *
 * @deprecated Import this function from `@sentry/utils` instead
 */ const $82ad51ff681da486$export$8e9a29865c0a1226 = (0, $MppwO.extractTraceparentData);

});


parcelRegister("hgFRV", function(module, exports) {

$parcel$export(module.exports, "TRACING_DEFAULTS", function () { return $c924688ae6bbf462$export$809a2b7987fd5306; });
$parcel$export(module.exports, "IdleTransaction", function () { return $c924688ae6bbf462$export$b279e6bd7040371f; });

var $7Dams = parcelRequire("7Dams");
var $bA8KD = parcelRequire("bA8KD");

var $3JSHc = parcelRequire("3JSHc");

var $IueXx = parcelRequire("IueXx");

var $8O7MK = parcelRequire("8O7MK");

var $eodfD = parcelRequire("eodfD");
const $c924688ae6bbf462$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    heartbeatInterval: 5000
};
const $c924688ae6bbf462$var$FINISH_REASON_TAG = "finishReason";
const $c924688ae6bbf462$var$IDLE_TRANSACTION_FINISH_REASONS = [
    "heartbeatFailed",
    "idleTimeout",
    "documentHidden",
    "finalTimeout",
    "externalFinish",
    "cancelled"
];
/**
 * @inheritDoc
 */ class $c924688ae6bbf462$export$370d6113c18ba86c extends (0, $8O7MK.SpanRecorder) {
    constructor(_pushActivity, _popActivity, transactionSpanId, maxlen){
        super(maxlen);
        this._pushActivity = _pushActivity;
        this._popActivity = _popActivity;
        this.transactionSpanId = transactionSpanId;
    }
    /**
   * @inheritDoc
   */ add(span) {
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanContext().spanId !== this.transactionSpanId) {
            // We patch span.end() to pop an activity after setting an endTimestamp.
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const originalEnd = span.end;
            span.end = (...rest)=>{
                this._popActivity(span.spanContext().spanId);
                return originalEnd.apply(span, rest);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if ((0, $IueXx.spanToJSON)(span).timestamp === undefined) this._pushActivity(span.spanContext().spanId);
        }
        super.add(span);
    }
}
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ class $c924688ae6bbf462$export$b279e6bd7040371f extends (0, $eodfD.Transaction) {
    // Activities store a list of active spans
    // Track state of activities in previous heartbeat
    // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
    // We should not use heartbeat if we finished a transaction
    // Idle timeout was canceled and we should finish the transaction with the last span end.
    /**
   * Timer that tracks Transaction idleTimeout
   */ /**
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ constructor(transactionContext, // eslint-disable-next-line deprecation/deprecation
    _idleHub, /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */ _idleTimeout = $c924688ae6bbf462$export$809a2b7987fd5306.idleTimeout, /**
     * The final value in ms that a transaction cannot exceed
     */ _finalTimeout = $c924688ae6bbf462$export$809a2b7987fd5306.finalTimeout, _heartbeatInterval = $c924688ae6bbf462$export$809a2b7987fd5306.heartbeatInterval, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope = false, /**
     * When set to `true`, will disable the idle timeout (`_idleTimeout` option) and heartbeat mechanisms (`_heartbeatInterval`
     * option) until the `sendAutoFinishSignal()` method is called. The final timeout mechanism (`_finalTimeout` option)
     * will not be affected by this option, meaning the transaction will definitely be finished when the final timeout is
     * reached, no matter what this option is configured to.
     *
     * Defaults to `false`.
     */ delayAutoFinishUntilSignal = false){
        super(transactionContext, _idleHub);
        this._idleHub = _idleHub;
        this._idleTimeout = _idleTimeout;
        this._finalTimeout = _finalTimeout;
        this._heartbeatInterval = _heartbeatInterval;
        this._onScope = _onScope;
        this.activities = {};
        this._heartbeatCounter = 0;
        this._finished = false;
        this._idleTimeoutCanceledPermanently = false;
        this._beforeFinishCallbacks = [];
        this._finishReason = $c924688ae6bbf462$var$IDLE_TRANSACTION_FINISH_REASONS[4];
        this._autoFinishAllowed = !delayAutoFinishUntilSignal;
        if (_onScope) {
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).log(`Setting idle transaction on scope. Span ID: ${this.spanContext().spanId}`);
            // eslint-disable-next-line deprecation/deprecation
            _idleHub.getScope().setSpan(this);
        }
        if (!delayAutoFinishUntilSignal) this._restartIdleTimeout();
        setTimeout(()=>{
            if (!this._finished) {
                this.setStatus("deadline_exceeded");
                this._finishReason = $c924688ae6bbf462$var$IDLE_TRANSACTION_FINISH_REASONS[3];
                this.end();
            }
        }, this._finalTimeout);
    }
    /** {@inheritDoc} */ end(endTimestamp) {
        const endTimestampInS = (0, $IueXx.spanTimeInputToSeconds)(endTimestamp);
        this._finished = true;
        this.activities = {};
        // eslint-disable-next-line deprecation/deprecation
        if (this.op === "ui.action.click") this.setAttribute($c924688ae6bbf462$var$FINISH_REASON_TAG, this._finishReason);
        // eslint-disable-next-line deprecation/deprecation
        if (this.spanRecorder) {
            (0, $3JSHc.DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
            (0, $7Dams.logger).log("[Tracing] finishing IdleTransaction", new Date(endTimestampInS * 1000).toISOString(), this.op);
            for (const callback of this._beforeFinishCallbacks)callback(this, endTimestampInS);
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder.spans = this.spanRecorder.spans.filter((span)=>{
                // If we are dealing with the transaction itself, we just return it
                if (span.spanContext().spanId === this.spanContext().spanId) return true;
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!(0, $IueXx.spanToJSON)(span).timestamp) {
                    span.setStatus("cancelled");
                    span.end(endTimestampInS);
                    (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).log("[Tracing] cancelling span since transaction ended early", JSON.stringify(span, undefined, 2));
                }
                const { start_timestamp: startTime, timestamp: endTime } = (0, $IueXx.spanToJSON)(span);
                const spanStartedBeforeTransactionFinish = startTime && startTime < endTimestampInS;
                // Add a delta with idle timeout so that we prevent false positives
                const timeoutWithMarginOfError = (this._finalTimeout + this._idleTimeout) / 1000;
                const spanEndedBeforeFinalTimeout = endTime && startTime && endTime - startTime < timeoutWithMarginOfError;
                if (0, $3JSHc.DEBUG_BUILD) {
                    const stringifiedSpan = JSON.stringify(span, undefined, 2);
                    if (!spanStartedBeforeTransactionFinish) (0, $7Dams.logger).log("[Tracing] discarding Span since it happened after Transaction was finished", stringifiedSpan);
                    else if (!spanEndedBeforeFinalTimeout) (0, $7Dams.logger).log("[Tracing] discarding Span since it finished after Transaction final timeout", stringifiedSpan);
                }
                return spanStartedBeforeTransactionFinish && spanEndedBeforeFinalTimeout;
            });
            (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).log("[Tracing] flushing IdleTransaction");
        } else (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).log("[Tracing] No active IdleTransaction");
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) {
            // eslint-disable-next-line deprecation/deprecation
            const scope = this._idleHub.getScope();
            // eslint-disable-next-line deprecation/deprecation
            if (scope.getTransaction() === this) // eslint-disable-next-line deprecation/deprecation
            scope.setSpan(undefined);
        }
        return super.end(endTimestamp);
    }
    /**
   * Register a callback function that gets executed before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */ registerBeforeFinishCallback(callback) {
        this._beforeFinishCallbacks.push(callback);
    }
    /**
   * @inheritDoc
   */ initSpanRecorder(maxlen) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) {
            const pushActivity = (id)=>{
                if (this._finished) return;
                this._pushActivity(id);
            };
            const popActivity = (id)=>{
                if (this._finished) return;
                this._popActivity(id);
            };
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder = new $c924688ae6bbf462$export$370d6113c18ba86c(pushActivity, popActivity, this.spanContext().spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).log("Starting heartbeat");
            this._pingHeartbeat();
        }
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */ cancelIdleTimeout(endTimestamp, { restartOnChildSpanChange: restartOnChildSpanChange } = {
        restartOnChildSpanChange: true
    }) {
        this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
        if (this._idleTimeoutID) {
            clearTimeout(this._idleTimeoutID);
            this._idleTimeoutID = undefined;
            if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
                this._finishReason = $c924688ae6bbf462$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                this.end(endTimestamp);
            }
        }
    }
    /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */ setFinishReason(reason) {
        this._finishReason = reason;
    }
    /**
   * Permits the IdleTransaction to automatically end itself via the idle timeout and heartbeat mechanisms when the `delayAutoFinishUntilSignal` option was set to `true`.
   */ sendAutoFinishSignal() {
        if (!this._autoFinishAllowed) {
            (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).log("[Tracing] Received finish signal for idle transaction.");
            this._restartIdleTimeout();
            this._autoFinishAllowed = true;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ _restartIdleTimeout(endTimestamp) {
        this.cancelIdleTimeout();
        this._idleTimeoutID = setTimeout(()=>{
            if (!this._finished && Object.keys(this.activities).length === 0) {
                this._finishReason = $c924688ae6bbf462$var$IDLE_TRANSACTION_FINISH_REASONS[1];
                this.end(endTimestamp);
            }
        }, this._idleTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ _pushActivity(spanId) {
        this.cancelIdleTimeout(undefined, {
            restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently
        });
        (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).log(`[Tracing] pushActivity: ${spanId}`);
        this.activities[spanId] = true;
        (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).log("[Tracing] new activities count", Object.keys(this.activities).length);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ _popActivity(spanId) {
        if (this.activities[spanId]) {
            (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).log(`[Tracing] popActivity ${spanId}`);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).log("[Tracing] new activities count", Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            const endTimestamp = (0, $bA8KD.timestampInSeconds)();
            if (this._idleTimeoutCanceledPermanently) {
                if (this._autoFinishAllowed) {
                    this._finishReason = $c924688ae6bbf462$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                    this.end(endTimestamp);
                }
            } else // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampInSeconds is in seconds, timeout is in ms
            this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
        }
    }
    /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */ _beat() {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) return;
        const heartbeatString = Object.keys(this.activities).join("");
        if (heartbeatString === this._prevHeartbeatString) this._heartbeatCounter++;
        else this._heartbeatCounter = 1;
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            if (this._autoFinishAllowed) {
                (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).log("[Tracing] Transaction finished because of no change for 3 heart beats");
                this.setStatus("deadline_exceeded");
                this._finishReason = $c924688ae6bbf462$var$IDLE_TRANSACTION_FINISH_REASONS[0];
                this.end();
            }
        } else this._pingHeartbeat();
    }
    /**
   * Pings the heartbeat
   */ _pingHeartbeat() {
        (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
        setTimeout(()=>{
            this._beat();
        }, this._heartbeatInterval);
    }
}

});
parcelRegister("8O7MK", function(module, exports) {

$parcel$export(module.exports, "SpanRecorder", function () { return $6699083cbd7f9b34$export$10c95c129cd0d4fe; });
$parcel$export(module.exports, "Span", function () { return $6699083cbd7f9b34$export$5f1714a13ed34c01; });

var $8WMel = parcelRequire("8WMel");
var $7Dams = parcelRequire("7Dams");
var $bA8KD = parcelRequire("bA8KD");
var $4zH9l = parcelRequire("4zH9l");

var $3JSHc = parcelRequire("3JSHc");

var $9wNdm = parcelRequire("9wNdm");

var $9t32t = parcelRequire("9t32t");

var $fDnGa = parcelRequire("fDnGa");

var $IueXx = parcelRequire("IueXx");

var $3AudM = parcelRequire("3AudM");
/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ class $6699083cbd7f9b34$export$10c95c129cd0d4fe {
    constructor(maxlen = 1000){
        this._maxlen = maxlen;
        this.spans = [];
    }
    /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */ add(span) {
        if (this.spans.length > this._maxlen) // eslint-disable-next-line deprecation/deprecation
        span.spanRecorder = undefined;
        else this.spans.push(span);
    }
}
/**
 * Span contains all data about a span
 */ class $6699083cbd7f9b34$export$5f1714a13ed34c01 {
    /**
   * Tags for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ /**
   * Data for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    /**
   * List of spans that were finalized
   *
   * @deprecated This property will no longer be public. Span recording will be handled internally.
   */ /**
   * @inheritDoc
   * @deprecated Use top level `Sentry.getRootSpan()` instead
   */ /**
   * The instrumenter that created this span.
   *
   * TODO (v8): This can probably be replaced by an `instanceOf` check of the span class.
   *            the instrumenter can only be sentry or otel so we can check the span instance
   *            to verify which one it is and remove this field entirely.
   *
   * @deprecated This field will be removed.
   */ /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $4zH9l.uuid4)();
        this._spanId = spanContext.spanId || (0, $4zH9l.uuid4)().substring(16);
        this._startTime = spanContext.startTimestamp || (0, $bA8KD.timestampInSeconds)();
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags ? {
            ...spanContext.tags
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data ? {
            ...spanContext.data
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.instrumenter = spanContext.instrumenter || "sentry";
        this._attributes = {};
        this.setAttributes({
            [(0, $9t32t.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: spanContext.origin || "manual",
            [(0, $9t32t.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: spanContext.op,
            ...spanContext.attributes
        });
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.status) this._status = spanContext.status;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        if (spanContext.exclusiveTime !== undefined) this._exclusiveTime = spanContext.exclusiveTime;
        this._measurements = spanContext.measurements ? {
            ...spanContext.measurements
        } : {};
    }
    // This rule conflicts with another eslint rule :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * An alias for `description` of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name || "";
    }
    /**
   * Update the name of the span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set name(name) {
        this.updateName(name);
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get description() {
        return this._name;
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set description(description) {
        this._name = description;
    }
    /**
   * The ID of the trace.
   * @deprecated Use `spanContext().traceId` instead.
   */ get traceId() {
        return this._traceId;
    }
    /**
   * The ID of the trace.
   * @deprecated You cannot update the traceId of a span after span creation.
   */ set traceId(traceId) {
        this._traceId = traceId;
    }
    /**
   * The ID of the span.
   * @deprecated Use `spanContext().spanId` instead.
   */ get spanId() {
        return this._spanId;
    }
    /**
   * The ID of the span.
   * @deprecated You cannot update the spanId of a span after span creation.
   */ set spanId(spanId) {
        this._spanId = spanId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `startSpan` functions instead.
   */ set parentSpanId(string) {
        this._parentSpanId = string;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).parent_span_id` instead.
   */ get parentSpanId() {
        return this._parentSpanId;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated Use `isRecording()` instead.
   */ get sampled() {
        return this._sampled;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated You cannot update the sampling decision of a span after span creation.
   */ set sampled(sampled) {
        this._sampled = sampled;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ get attributes() {
        return this._attributes;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `setAttributes()` instead.
   */ set attributes(attributes) {
        this._attributes = attributes;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated Use `spanToJSON()` instead.
   */ get startTimestamp() {
        return this._startTime;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated In v8, you will not be able to update the span start time after creation.
   */ set startTimestamp(startTime) {
        this._startTime = startTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Use `spanToJSON()` instead.
   */ get endTimestamp() {
        return this._endTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Set the end time via `span.end()` instead.
   */ set endTimestamp(endTime) {
        this._endTime = endTime;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `spanToJSON().status` instead to get the status.
   */ get status() {
        return this._status;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `.setStatus()` instead to set or update the status.
   */ set status(status) {
        this._status = status;
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `spanToJSON().op` to read the op instead.
   */ get op() {
        return this._attributes[0, $9t32t.SEMANTIC_ATTRIBUTE_SENTRY_OP];
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `startSpan()` functions to set or `span.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_OP, 'op')
   *             to update the span instead.
   */ set op(op) {
        this.setAttribute((0, $9t32t.SEMANTIC_ATTRIBUTE_SENTRY_OP), op);
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `spanToJSON().origin` to read the origin instead.
   */ get origin() {
        return this._attributes[0, $9t32t.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN];
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `startSpan()` functions to set the origin instead.
   */ set origin(origin) {
        this.setAttribute((0, $9t32t.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), origin);
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $IueXx.TRACE_FLAG_SAMPLED) : (0, $IueXx.TRACE_FLAG_NONE)
        };
    }
    /**
   * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
   * Also the `sampled` decision will be inherited.
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startChild(spanContext) {
        const childSpan = new $6699083cbd7f9b34$export$5f1714a13ed34c01({
            ...spanContext,
            parentSpanId: this._spanId,
            sampled: this._sampled,
            traceId: this._traceId
        });
        // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder = this.spanRecorder;
        // eslint-disable-next-line deprecation/deprecation
        if (childSpan.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder.add(childSpan);
        const rootSpan = (0, $fDnGa.getRootSpan)(this);
        // TODO: still set span.transaction here until we have a more permanent solution
        // Probably similarly to the weakmap we hold in node-experimental
        // eslint-disable-next-line deprecation/deprecation
        childSpan.transaction = rootSpan;
        if ((0, $3JSHc.DEBUG_BUILD) && rootSpan) {
            const opStr = spanContext && spanContext.op || "< unknown op >";
            const nameStr = (0, $IueXx.spanToJSON)(childSpan).description || "< unknown name >";
            const idStr = rootSpan.spanContext().spanId;
            const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
            (0, $7Dams.logger).log(logMessage);
            this._logMessage = logMessage;
        }
        return childSpan;
    }
    /**
   * Sets the tag attribute on the current span.
   *
   * Can also be used to unset a tag, by passing `undefined`.
   *
   * @param key Tag key
   * @param value Tag value
   * @deprecated Use `setAttribute()` instead.
   */ setTag(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.tags = {
            ...this.tags,
            [key]: value
        };
        return this;
    }
    /**
   * Sets the data attribute on the current span
   * @param key Data key
   * @param value Data value
   * @deprecated Use `setAttribute()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setData(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = {
            ...this.data,
            [key]: value
        };
        return this;
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use top-level `setHttpStatus()` instead.
   */ setHttpStatus(httpStatus) {
        (0, $3AudM.setHttpStatus)(this, httpStatus);
        return this;
    }
    /**
   * @inheritdoc
   *
   * @deprecated Use `.updateName()` instead.
   */ setName(name) {
        this.updateName(name);
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).status === 'ok'` instead.
   */ isSuccess() {
        return this._status === "ok";
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `.end()` instead.
   */ finish(endTimestamp) {
        return this.end(endTimestamp);
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        const rootSpan = (0, $fDnGa.getRootSpan)(this);
        if ((0, $3JSHc.DEBUG_BUILD) && // Don't call this for transactions
        rootSpan && rootSpan.spanContext().spanId !== this._spanId) {
            const logMessage = this._logMessage;
            if (logMessage) (0, $7Dams.logger).log(logMessage.replace("Starting", "Finishing"));
        }
        this._endTime = (0, $IueXx.spanTimeInputToSeconds)(endTimestamp);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceHeader()` instead.
   */ toTraceparent() {
        return (0, $IueXx.spanToTraceHeader)(this);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON()` or access the fields directly instead.
   */ toContext() {
        return (0, $8WMel.dropUndefinedKeys)({
            data: this._getData(),
            description: this._name,
            endTimestamp: this._endTime,
            // eslint-disable-next-line deprecation/deprecation
            op: this.op,
            parentSpanId: this._parentSpanId,
            sampled: this._sampled,
            spanId: this._spanId,
            startTimestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            traceId: this._traceId
        });
    }
    /**
   * @inheritDoc
   *
   * @deprecated Update the fields directly instead.
   */ updateWithContext(spanContext) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data || {};
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        this._endTime = spanContext.endTimestamp;
        // eslint-disable-next-line deprecation/deprecation
        this.op = spanContext.op;
        this._parentSpanId = spanContext.parentSpanId;
        this._sampled = spanContext.sampled;
        this._spanId = spanContext.spanId || this._spanId;
        this._startTime = spanContext.startTimestamp || this._startTime;
        this._status = spanContext.status;
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags || {};
        this._traceId = spanContext.traceId || this._traceId;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceContext()` util function instead.
   */ getTraceContext() {
        return (0, $IueXx.spanToTraceContext)(this);
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return (0, $8WMel.dropUndefinedKeys)({
            data: this._getData(),
            description: this._name,
            op: this._attributes[0, $9t32t.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $9t32t.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            _metrics_summary: (0, $9wNdm.getMetricSummaryJsonForSpan)(this),
            profile_id: this._attributes[0, $9t32t.SEMANTIC_ATTRIBUTE_PROFILE_ID],
            exclusive_time: this._exclusiveTime,
            measurements: Object.keys(this._measurements).length > 0 ? this._measurements : undefined
        });
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * Convert the object to JSON.
   * @deprecated Use `spanToJSON(span)` instead.
   */ toJSON() {
        return this.getSpanJSON();
    }
    /**
   * Get the merged data for this span.
   * For now, this combines `data` and `attributes` together,
   * until eventually we can ingest `attributes` directly.
   */ _getData() {
        // eslint-disable-next-line deprecation/deprecation
        const { data: data, _attributes: attributes } = this;
        const hasData = Object.keys(data).length > 0;
        const hasAttributes = Object.keys(attributes).length > 0;
        if (!hasData && !hasAttributes) return undefined;
        if (hasData && hasAttributes) return {
            ...data,
            ...attributes
        };
        return hasData ? data : attributes;
    }
}

});
parcelRegister("9wNdm", function(module, exports) {

$parcel$export(module.exports, "getMetricSummaryJsonForSpan", function () { return $6efd472c67eb61b7$export$2e7205e45c58797d; });

var $8WMel = parcelRequire("8WMel");




var $egrOp = parcelRequire("egrOp");
/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ let $6efd472c67eb61b7$var$SPAN_METRIC_SUMMARY;
function $6efd472c67eb61b7$var$getMetricStorageForSpan(span) {
    return $6efd472c67eb61b7$var$SPAN_METRIC_SUMMARY ? $6efd472c67eb61b7$var$SPAN_METRIC_SUMMARY.get(span) : undefined;
}
/**
 * Fetches the metric summary if it exists for the passed span
 */ function $6efd472c67eb61b7$export$2e7205e45c58797d(span) {
    const storage = $6efd472c67eb61b7$var$getMetricStorageForSpan(span);
    if (!storage) return undefined;
    const output = {};
    for (const [, [exportKey, summary]] of storage){
        if (!output[exportKey]) output[exportKey] = [];
        output[exportKey].push((0, $8WMel.dropUndefinedKeys)(summary));
    }
    return output;
}
/**
 * Updates the metric summary on the currently active span
 */ function $6efd472c67eb61b7$export$aefd1a302602f922(metricType, sanitizedName, value, unit, tags, bucketKey) {
    const span = (0, $egrOp.getActiveSpan)();
    if (span) {
        const storage = $6efd472c67eb61b7$var$getMetricStorageForSpan(span) || new Map();
        const exportKey = `${metricType}:${sanitizedName}@${unit}`;
        const bucketItem = storage.get(bucketKey);
        if (bucketItem) {
            const [, summary] = bucketItem;
            storage.set(bucketKey, [
                exportKey,
                {
                    min: Math.min(summary.min, value),
                    max: Math.max(summary.max, value),
                    count: summary.count += 1,
                    sum: summary.sum += value,
                    tags: summary.tags
                }
            ]);
        } else storage.set(bucketKey, [
            exportKey,
            {
                min: value,
                max: value,
                count: 1,
                sum: value,
                tags: tags
            }
        ]);
        if (!$6efd472c67eb61b7$var$SPAN_METRIC_SUMMARY) $6efd472c67eb61b7$var$SPAN_METRIC_SUMMARY = new WeakMap();
        $6efd472c67eb61b7$var$SPAN_METRIC_SUMMARY.set(span, storage);
    }
}

});
parcelRegister("egrOp", function(module, exports) {

$parcel$export(module.exports, "startInactiveSpan", function () { return $a6282232495d4b3a$export$63dbba021a6b4047; });
$parcel$export(module.exports, "getActiveSpan", function () { return $a6282232495d4b3a$export$1be426a8e585c83e; });
$parcel$export(module.exports, "getCapturedScopesOnSpan", function () { return $a6282232495d4b3a$export$c08fbc656a245d03; });

var $8WMel = parcelRequire("8WMel");
var $7Dams = parcelRequire("7Dams");
var $MppwO = parcelRequire("MppwO");

var $3JSHc = parcelRequire("3JSHc");

var $aFDsf = parcelRequire("aFDsf");

var $IueXx = parcelRequire("IueXx");



var $8XBHU = parcelRequire("8XBHU");

var $iKbxs = parcelRequire("iKbxs");

var $j35A6 = parcelRequire("j35A6");

var $kRhVl = parcelRequire("kRhVl");
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 *
 * This function is meant to be used internally and may break at any time. Use at your own risk.
 *
 * @internal
 * @private
 *
 * @deprecated Use `startSpan` instead.
 */ function $a6282232495d4b3a$export$357889f174732d38(context, callback, // eslint-disable-next-line @typescript-eslint/no-empty-function
onError = ()=>{}, // eslint-disable-next-line @typescript-eslint/no-empty-function
afterFinish = ()=>{}) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $aFDsf.getCurrentHub)();
    const scope = (0, $iKbxs.getCurrentScope)();
    // eslint-disable-next-line deprecation/deprecation
    const parentSpan = scope.getSpan();
    const spanContext = $a6282232495d4b3a$var$normalizeContext(context);
    const activeSpan = $a6282232495d4b3a$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: false,
        scope: scope
    });
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(activeSpan);
    return (0, $j35A6.handleCallbackErrors)(()=>callback(activeSpan), (error)=>{
        activeSpan && activeSpan.setStatus("internal_error");
        onError(error, activeSpan);
    }, ()=>{
        activeSpan && activeSpan.end();
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(parentSpan);
        afterFinish();
    });
}
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $a6282232495d4b3a$export$a1bd95187356f372(context, callback) {
    const spanContext = $a6282232495d4b3a$var$normalizeContext(context);
    return (0, $aFDsf.runWithAsyncContext)(()=>{
        return (0, $iKbxs.withScope)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $aFDsf.getCurrentHub)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $a6282232495d4b3a$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            return (0, $j35A6.handleCallbackErrors)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet
                if (activeSpan) {
                    const { status: status } = (0, $IueXx.spanToJSON)(activeSpan);
                    if (!status || status === "ok") activeSpan.setStatus("internal_error");
                }
            }, ()=>activeSpan && activeSpan.end());
        });
    });
}
/**
 * @deprecated Use {@link startSpan} instead.
 */ const $a6282232495d4b3a$export$cb9e396e6b90b703 = $a6282232495d4b3a$export$a1bd95187356f372;
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $a6282232495d4b3a$export$c10292ad04b92aea(context, callback) {
    const spanContext = $a6282232495d4b3a$var$normalizeContext(context);
    return (0, $aFDsf.runWithAsyncContext)(()=>{
        return (0, $iKbxs.withScope)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $aFDsf.getCurrentHub)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $a6282232495d4b3a$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            function finishAndSetSpan() {
                activeSpan && activeSpan.end();
            }
            return (0, $j35A6.handleCallbackErrors)(()=>callback(activeSpan, finishAndSetSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                if (activeSpan && activeSpan.isRecording()) {
                    const { status: status } = (0, $IueXx.spanToJSON)(activeSpan);
                    if (!status || status === "ok") activeSpan.setStatus("internal_error");
                }
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate` or `tracesSampler`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $a6282232495d4b3a$export$63dbba021a6b4047(context) {
    if (!(0, $kRhVl.hasTracingEnabled)()) return undefined;
    const spanContext = $a6282232495d4b3a$var$normalizeContext(context);
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $aFDsf.getCurrentHub)();
    const parentSpan = context.scope ? context.scope.getSpan() : $a6282232495d4b3a$export$1be426a8e585c83e();
    const shouldSkipSpan = context.onlyIfParent && !parentSpan;
    if (shouldSkipSpan) return undefined;
    const scope = context.scope || (0, $iKbxs.getCurrentScope)();
    // Even though we don't actually want to make this span active on the current scope,
    // we need to make it active on a temporary scope that we use for event processing
    // as otherwise, it won't pick the correct span for the event when processing it
    const temporaryScope = scope.clone();
    return $a6282232495d4b3a$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: context.forceTransaction,
        scope: temporaryScope
    });
}
/**
 * Returns the currently active span.
 */ function $a6282232495d4b3a$export$1be426a8e585c83e() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $iKbxs.getCurrentScope)().getSpan();
}
const $a6282232495d4b3a$export$d2ee9b39b25437b3 = ({ sentryTrace: sentryTrace, baggage: baggage }, callback)=>{
    // TODO(v8): Change this function so it doesn't do anything besides setting the propagation context on the current scope:
    /*
    return withScope((scope) => {
      const propagationContext = propagationContextFromHeaders(sentryTrace, baggage);
      scope.setPropagationContext(propagationContext);
      return callback();
    })
  */ const currentScope = (0, $iKbxs.getCurrentScope)();
    // eslint-disable-next-line deprecation/deprecation
    const { traceparentData: traceparentData, dynamicSamplingContext: dynamicSamplingContext, propagationContext: propagationContext } = (0, $MppwO.tracingContextFromHeaders)(sentryTrace, baggage);
    currentScope.setPropagationContext(propagationContext);
    if ((0, $3JSHc.DEBUG_BUILD) && traceparentData) (0, $7Dams.logger).log(`[Tracing] Continuing trace ${traceparentData.traceId}.`);
    const transactionContext = {
        ...traceparentData,
        metadata: (0, $8WMel.dropUndefinedKeys)({
            dynamicSamplingContext: dynamicSamplingContext
        })
    };
    if (!callback) return transactionContext;
    return (0, $aFDsf.runWithAsyncContext)(()=>{
        return callback(transactionContext);
    });
};
function $a6282232495d4b3a$var$createChildSpanOrTransaction(// eslint-disable-next-line deprecation/deprecation
hub, { parentSpan: parentSpan, spanContext: spanContext, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $kRhVl.hasTracingEnabled)()) return undefined;
    const isolationScope = (0, $aFDsf.getIsolationScope)();
    let span;
    if (parentSpan && !forceTransaction) // eslint-disable-next-line deprecation/deprecation
    span = parentSpan.startChild(spanContext);
    else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $8XBHU.getDynamicSamplingContextFromSpan)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const sampled = (0, $IueXx.spanIsSampled)(parentSpan);
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    }
    // We always set this as active span on the scope
    // In the case of this being an inactive span, we ensure to pass a detached scope in here in the first place
    // But by having this here, we can ensure that the lookup through `getCapturedScopesOnSpan` results in the correct scope & span combo
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(span);
    $a6282232495d4b3a$var$setCapturedScopesOnSpan(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to TransactionContext.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 *
 * Eventually the StartSpanOptions will be more aligned with OpenTelemetry.
 */ function $a6282232495d4b3a$var$normalizeContext(context) {
    if (context.startTime) {
        const ctx = {
            ...context
        };
        ctx.startTimestamp = (0, $IueXx.spanTimeInputToSeconds)(context.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return context;
}
const $a6282232495d4b3a$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $a6282232495d4b3a$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
function $a6282232495d4b3a$var$setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        (0, $8WMel.addNonEnumerableProperty)(span, $a6282232495d4b3a$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $8WMel.addNonEnumerableProperty)(span, $a6282232495d4b3a$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $a6282232495d4b3a$export$c08fbc656a245d03(span) {
    return {
        scope: span[$a6282232495d4b3a$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$a6282232495d4b3a$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}

});
parcelRegister("j35A6", function(module, exports) {

$parcel$export(module.exports, "handleCallbackErrors", function () { return $dde2a0766922e8b0$export$18ce21a8b7efd7e9; });

var $l3GNb = parcelRequire("l3GNb");
/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $dde2a0766922e8b0$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $dde2a0766922e8b0$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $dde2a0766922e8b0$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $l3GNb.isThenable)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}

});

parcelRegister("kRhVl", function(module, exports) {

$parcel$export(module.exports, "hasTracingEnabled", function () { return $f2f6a93075ff0e0f$export$5008da00b1b6dee6; });

var $iKbxs = parcelRequire("iKbxs");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $f2f6a93075ff0e0f$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const client = (0, $iKbxs.getClient)();
    const options = maybeOptions || client && client.getOptions();
    return !!options && (options.enableTracing || "tracesSampleRate" in options || "tracesSampler" in options);
}

});



parcelRegister("9t32t", function(module, exports) {

$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", function () { return $6e492df33d3f9555$export$d7a7d984b0791405; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", function () { return $6e492df33d3f9555$export$ccfe0a40627cc34b; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", function () { return $6e492df33d3f9555$export$1a413bd9a88fdb09; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", function () { return $6e492df33d3f9555$export$cca8dd30f57f805e; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_PROFILE_ID", function () { return $6e492df33d3f9555$export$1efec95406bbe327; });
/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $6e492df33d3f9555$export$d7a7d984b0791405 = "sentry.source";
/**
 * Use this attribute to represent the sample rate used for a span.
 */ const $6e492df33d3f9555$export$ccfe0a40627cc34b = "sentry.sample_rate";
/**
 * Use this attribute to represent the operation of a span.
 */ const $6e492df33d3f9555$export$1a413bd9a88fdb09 = "sentry.op";
/**
 * Use this attribute to represent the origin of a span.
 */ const $6e492df33d3f9555$export$cca8dd30f57f805e = "sentry.origin";
/**
 * The id of the profile that this span occured in.
 */ const $6e492df33d3f9555$export$1efec95406bbe327 = "profile_id";

});

parcelRegister("3AudM", function(module, exports) {

$parcel$export(module.exports, "setHttpStatus", function () { return $29cc2d3a61360cb0$export$2ad6630ec8164254; });
/** The status of an Span.
 *
 * @deprecated Use string literals - if you require type casting, cast to SpanStatusType type
 */ var $29cc2d3a61360cb0$export$beb8e6a823e89c5d;
(function(SpanStatus) {
    /** The operation completed successfully. */ const Ok = "ok";
    SpanStatus["Ok"] = Ok;
    /** Deadline expired before operation could complete. */ const DeadlineExceeded = "deadline_exceeded";
    SpanStatus["DeadlineExceeded"] = DeadlineExceeded;
    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */ const Unauthenticated = "unauthenticated";
    SpanStatus["Unauthenticated"] = Unauthenticated;
    /** 403 Forbidden */ const PermissionDenied = "permission_denied";
    SpanStatus["PermissionDenied"] = PermissionDenied;
    /** 404 Not Found. Some requested entity (file or directory) was not found. */ const NotFound = "not_found";
    SpanStatus["NotFound"] = NotFound;
    /** 429 Too Many Requests */ const ResourceExhausted = "resource_exhausted";
    SpanStatus["ResourceExhausted"] = ResourceExhausted;
    /** Client specified an invalid argument. 4xx. */ const InvalidArgument = "invalid_argument";
    SpanStatus["InvalidArgument"] = InvalidArgument;
    /** 501 Not Implemented */ const Unimplemented = "unimplemented";
    SpanStatus["Unimplemented"] = Unimplemented;
    /** 503 Service Unavailable */ const Unavailable = "unavailable";
    SpanStatus["Unavailable"] = Unavailable;
    /** Other/generic 5xx. */ const InternalError = "internal_error";
    SpanStatus["InternalError"] = InternalError;
    /** Unknown. Any non-standard HTTP status code. */ const UnknownError = "unknown_error";
    SpanStatus["UnknownError"] = UnknownError;
    /** The operation was cancelled (typically by the user). */ const Cancelled = "cancelled";
    SpanStatus["Cancelled"] = Cancelled;
    /** Already exists (409) */ const AlreadyExists = "already_exists";
    SpanStatus["AlreadyExists"] = AlreadyExists;
    /** Operation was rejected because the system is not in a state required for the operation's */ const FailedPrecondition = "failed_precondition";
    SpanStatus["FailedPrecondition"] = FailedPrecondition;
    /** The operation was aborted, typically due to a concurrency issue. */ const Aborted = "aborted";
    SpanStatus["Aborted"] = Aborted;
    /** Operation was attempted past the valid range. */ const OutOfRange = "out_of_range";
    SpanStatus["OutOfRange"] = OutOfRange;
    /** Unrecoverable data loss or corruption */ const DataLoss = "data_loss";
    SpanStatus["DataLoss"] = DataLoss;
})($29cc2d3a61360cb0$export$beb8e6a823e89c5d || ($29cc2d3a61360cb0$export$beb8e6a823e89c5d = {}));
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ function $29cc2d3a61360cb0$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return "ok";
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return "unauthenticated";
        case 403:
            return "permission_denied";
        case 404:
            return "not_found";
        case 409:
            return "already_exists";
        case 413:
            return "failed_precondition";
        case 429:
            return "resource_exhausted";
        default:
            return "invalid_argument";
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return "unimplemented";
        case 503:
            return "unavailable";
        case 504:
            return "deadline_exceeded";
        default:
            return "internal_error";
    }
    return "unknown_error";
}
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @deprecated Use {@link spanStatusFromHttpCode} instead.
 * This export will be removed in v8 as the signature contains a typo.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ const $29cc2d3a61360cb0$export$ac65c70d78fcdb55 = $29cc2d3a61360cb0$export$5fd4dc48a2131589;
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $29cc2d3a61360cb0$export$2ad6630ec8164254(span, httpStatus) {
    // TODO (v8): Remove these calls
    // Relay does not require us to send the status code as a tag
    // For now, just because users might expect it to land as a tag we keep sending it.
    // Same with data.
    // In v8, we replace both, simply with
    // span.setAttribute('http.response.status_code', httpStatus);
    // eslint-disable-next-line deprecation/deprecation
    span.setTag("http.status_code", String(httpStatus));
    // eslint-disable-next-line deprecation/deprecation
    span.setData("http.response.status_code", httpStatus);
    const spanStatus = $29cc2d3a61360cb0$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus !== "unknown_error") span.setStatus(spanStatus);
}

});


parcelRegister("eodfD", function(module, exports) {

$parcel$export(module.exports, "Transaction", function () { return $a79d96029f9ce4a5$export$febc5573c75cefb0; });

var $8WMel = parcelRequire("8WMel");
var $7Dams = parcelRequire("7Dams");

var $3JSHc = parcelRequire("3JSHc");

var $aFDsf = parcelRequire("aFDsf");

var $9wNdm = parcelRequire("9wNdm");

var $9t32t = parcelRequire("9t32t");

var $IueXx = parcelRequire("IueXx");

var $8XBHU = parcelRequire("8XBHU");

var $8O7MK = parcelRequire("8O7MK");

var $egrOp = parcelRequire("egrOp");
/** JSDoc */ class $a79d96029f9ce4a5$export$febc5573c75cefb0 extends (0, $8O7MK.Span) {
    /**
   * The reference to the current hub.
   */ // eslint-disable-next-line deprecation/deprecation
    // DO NOT yet remove this property, it is used in a hack for v7 backwards compatibility.
    /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   *
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ // eslint-disable-next-line deprecation/deprecation
    constructor(transactionContext, hub){
        super(transactionContext);
        this._contexts = {};
        // eslint-disable-next-line deprecation/deprecation
        this._hub = hub || (0, $aFDsf.getCurrentHub)();
        this._name = transactionContext.name || "";
        this._metadata = {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.metadata
        };
        this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        // TODO (v8): Replace this with another way to set the root span
        // eslint-disable-next-line deprecation/deprecation
        this.transaction = this;
        // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
        // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
        const incomingDynamicSamplingContext = this._metadata.dynamicSamplingContext;
        if (incomingDynamicSamplingContext) // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
        this._frozenDynamicSamplingContext = {
            ...incomingDynamicSamplingContext
        };
    }
    // This sadly conflicts with the getter/setter ordering :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * Getter for `name` property.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name;
    }
    /**
   * Setter for `name` property, which also sets `source` as custom.
   * @deprecated Use `updateName()` and `setMetadata()` instead.
   */ set name(newName) {
        // eslint-disable-next-line deprecation/deprecation
        this.setName(newName);
    }
    /**
   * Get the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ get metadata() {
        // We merge attributes in for backwards compatibility
        return {
            // Defaults
            // eslint-disable-next-line deprecation/deprecation
            source: "custom",
            spanMetadata: {},
            // Legacy metadata
            ...this._metadata,
            // From attributes
            ...this._attributes[0, $9t32t.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] && {
                source: this._attributes[0, $9t32t.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]
            },
            ...this._attributes[0, $9t32t.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] && {
                sampleRate: this._attributes[0, $9t32t.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE]
            }
        };
    }
    /**
   * Update the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ set metadata(metadata) {
        this._metadata = metadata;
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /**
   * Setter for `name` property, which also sets `source` on the metadata.
   *
   * @deprecated Use `.updateName()` and `.setAttribute()` instead.
   */ setName(name, source = "custom") {
        this._name = name;
        this.setAttribute((0, $9t32t.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), source);
    }
    /** @inheritdoc */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */ initSpanRecorder(maxlen = 1000) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder = new (0, $8O7MK.SpanRecorder)(maxlen);
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Set the context of a transaction event.
   * @deprecated Use either `.setAttribute()`, or set the context on the scope before creating the transaction.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top-level `setMeasurement()` instead.
   */ setMeasurement(name, value, unit = "") {
        this._measurements[name] = {
            value: value,
            unit: unit
        };
    }
    /**
   * Store metadata on this transaction.
   * @deprecated Use attributes or store data on the scope instead.
   */ setMetadata(newMetadata) {
        this._metadata = {
            ...this._metadata,
            ...newMetadata
        };
    }
    /**
   * @inheritDoc
   */ end(endTimestamp) {
        const timestampInS = (0, $IueXx.spanTimeInputToSeconds)(endTimestamp);
        const transaction = this._finishTransaction(timestampInS);
        if (!transaction) return undefined;
        // eslint-disable-next-line deprecation/deprecation
        return this._hub.captureEvent(transaction);
    }
    /**
   * @inheritDoc
   */ toContext() {
        // eslint-disable-next-line deprecation/deprecation
        const spanContext = super.toContext();
        return (0, $8WMel.dropUndefinedKeys)({
            ...spanContext,
            name: this._name,
            trimEnd: this._trimEnd
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(transactionContext) {
        // eslint-disable-next-line deprecation/deprecation
        super.updateWithContext(transactionContext);
        this._name = transactionContext.name || "";
        this._trimEnd = transactionContext.trimEnd;
        return this;
    }
    /**
   * @inheritdoc
   *
   * @experimental
   *
   * @deprecated Use top-level `getDynamicSamplingContextFromSpan` instead.
   */ getDynamicSamplingContext() {
        return (0, $8XBHU.getDynamicSamplingContextFromSpan)(this);
    }
    /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */ // eslint-disable-next-line deprecation/deprecation
    setHub(hub) {
        this._hub = hub;
    }
    /**
   * Get the profile id of the transaction.
   */ getProfileId() {
        if (this._contexts !== undefined && this._contexts["profile"] !== undefined) return this._contexts["profile"].profile_id;
        return undefined;
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _finishTransaction(endTimestamp) {
        // This transaction is already finished, so we should not flush it again.
        if (this._endTime !== undefined) return undefined;
        if (!this._name) {
            (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        // just sets the end timestamp
        super.end(endTimestamp);
        // eslint-disable-next-line deprecation/deprecation
        const client = this._hub.getClient();
        if (client && client.emit) client.emit("finishTransaction", this);
        if (this._sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).log("[Tracing] Discarding transaction because its trace was not chosen to be sampled.");
            if (client) client.recordDroppedEvent("sample_rate", "transaction");
            return undefined;
        }
        // eslint-disable-next-line deprecation/deprecation
        const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter((span)=>span !== this && (0, $IueXx.spanToJSON)(span).timestamp) : [];
        if (this._trimEnd && finishedSpans.length > 0) {
            const endTimes = finishedSpans.map((span)=>(0, $IueXx.spanToJSON)(span).timestamp).filter(Boolean);
            this._endTime = endTimes.reduce((prev, current)=>{
                return prev > current ? prev : current;
            });
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $egrOp.getCapturedScopesOnSpan)(this);
        // eslint-disable-next-line deprecation/deprecation
        const { metadata: metadata } = this;
        // eslint-disable-next-line deprecation/deprecation
        const { source: source } = metadata;
        const transaction = {
            contexts: {
                ...this._contexts,
                // We don't want to override trace context
                trace: (0, $IueXx.spanToTraceContext)(this)
            },
            // TODO: Pass spans serialized via `spanToJSON()` here instead in v8.
            spans: finishedSpans,
            start_timestamp: this._startTime,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                ...metadata,
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                ...(0, $8WMel.dropUndefinedKeys)({
                    dynamicSamplingContext: (0, $8XBHU.getDynamicSamplingContextFromSpan)(this)
                })
            },
            _metrics_summary: (0, $9wNdm.getMetricSummaryJsonForSpan)(this),
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).log("[Measurements] Adding measurements to transaction", JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        // eslint-disable-next-line deprecation/deprecation
        (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).log(`[Tracing] Finishing ${this.op} transaction: ${this._name}.`);
        return transaction;
    }
}

});


parcelRegister("ecEes", function(module, exports) {

$parcel$export(module.exports, "sampleTransaction", function () { return $a57164f154e54e66$export$b3258c3993bc9b71; });
$parcel$export(module.exports, "isValidSampleRate", function () { return $a57164f154e54e66$export$2603c8d332a51c42; });

var $l3GNb = parcelRequire("l3GNb");
var $7Dams = parcelRequire("7Dams");

var $3JSHc = parcelRequire("3JSHc");

var $9t32t = parcelRequire("9t32t");

var $kRhVl = parcelRequire("kRhVl");

var $IueXx = parcelRequire("IueXx");
/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * This method muttes the given `transaction` and will set the `sampled` value on it.
 * It returns the same transaction, for convenience.
 */ function $a57164f154e54e66$export$b3258c3993bc9b71(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $kRhVl.hasTracingEnabled)(options)) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    // eslint-disable-next-line deprecation/deprecation
    if (transaction.sampled !== undefined) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.setAttribute((0, $9t32t.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), Number(transaction.sampled));
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setAttribute((0, $9t32t.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), Number(sampleRate));
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        transaction.setAttribute((0, $9t32t.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), Number(sampleRate));
    } else {
        // When `enableTracing === true`, we use a sample rate of 100%
        sampleRate = 1;
        transaction.setAttribute((0, $9t32t.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), sampleRate);
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$a57164f154e54e66$export$2603c8d332a51c42(sampleRate)) {
        (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).warn("[Tracing] Discarding transaction because of invalid sample rate.");
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    // eslint-disable-next-line deprecation/deprecation
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    // eslint-disable-next-line deprecation/deprecation
    if (!transaction.sampled) {
        (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return transaction;
    }
    (0, $3JSHc.DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
    (0, $7Dams.logger).log(`[Tracing] starting ${transaction.op} transaction - ${(0, $IueXx.spanToJSON)(transaction).description}`);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $a57164f154e54e66$export$2603c8d332a51c42(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0, $l3GNb.isNaN)(rate) || !(typeof rate === "number" || typeof rate === "boolean")) {
        (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}

});


parcelRegister("036vc", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $00955322472ada9b$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $00955322472ada9b$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});

parcelRegister("2BFvn", function(module, exports) {

$parcel$export(module.exports, "registerBackgroundTabDetection", function () { return $1e5f3b84326c7003$export$6f18f55521af71a1; });

var $bdACW = parcelRequire("bdACW");
var $IueXx = parcelRequire("IueXx");

var $7Dams = parcelRequire("7Dams");

var $036vc = parcelRequire("036vc");

var $a4mdh = parcelRequire("a4mdh");
/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $1e5f3b84326c7003$export$6f18f55521af71a1() {
    if ((0, $a4mdh.WINDOW).document) (0, $a4mdh.WINDOW).document.addEventListener("visibilitychange", ()=>{
        // eslint-disable-next-line deprecation/deprecation
        const activeTransaction = (0, $bdACW.getActiveTransaction)();
        if ((0, $a4mdh.WINDOW).document.hidden && activeTransaction) {
            const statusType = "cancelled";
            const { op: op, status: status } = (0, $IueXx.spanToJSON)(activeTransaction);
            (0, $036vc.DEBUG_BUILD) && (0, $7Dams.logger).log(`[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) activeTransaction.setStatus(statusType);
            // TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            activeTransaction.setTag("visibilitychange", "document.hidden");
            activeTransaction.end();
        }
    });
    else (0, $036vc.DEBUG_BUILD) && (0, $7Dams.logger).warn("[Tracing] Could not set up background tab detection due to lack of global document");
}

});
parcelRegister("a4mdh", function(module, exports) {

$parcel$export(module.exports, "WINDOW", function () { return $754b822ce7b4e37d$export$56d8a8a25bd48b81; });

var $ehoTA = parcelRequire("ehoTA");
const $754b822ce7b4e37d$export$56d8a8a25bd48b81 = (0, $ehoTA.GLOBAL_OBJ);

});


parcelRegister("hqqce", function(module, exports) {

$parcel$export(module.exports, "addClsInstrumentationHandler", function () { return $caf92f65a6444fd8$export$861b82818b37ba5b; });
$parcel$export(module.exports, "addLcpInstrumentationHandler", function () { return $caf92f65a6444fd8$export$3fd4b53331200102; });
$parcel$export(module.exports, "addTtfbInstrumentationHandler", function () { return $caf92f65a6444fd8$export$699d9529c099a797; });
$parcel$export(module.exports, "addFidInstrumentationHandler", function () { return $caf92f65a6444fd8$export$2707d7471c0b918f; });
$parcel$export(module.exports, "addInpInstrumentationHandler", function () { return $caf92f65a6444fd8$export$da3b76aa2022cbd7; });
$parcel$export(module.exports, "addPerformanceInstrumentationHandler", function () { return $caf92f65a6444fd8$export$69816c1a049f8db6; });

var $kmiJQ = parcelRequire("kmiJQ");
var $7Dams = parcelRequire("7Dams");

var $036vc = parcelRequire("036vc");

var $eBlWG = parcelRequire("eBlWG");

var $2setH = parcelRequire("2setH");

var $hPZLa = parcelRequire("hPZLa");

var $fG9c5 = parcelRequire("fG9c5");

var $6AjPt = parcelRequire("6AjPt");

var $ijfgC = parcelRequire("ijfgC");
const $caf92f65a6444fd8$var$handlers = {};
const $caf92f65a6444fd8$var$instrumented = {};
let $caf92f65a6444fd8$var$_previousCls;
let $caf92f65a6444fd8$var$_previousFid;
let $caf92f65a6444fd8$var$_previousLcp;
let $caf92f65a6444fd8$var$_previousTtfb;
let $caf92f65a6444fd8$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $caf92f65a6444fd8$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $caf92f65a6444fd8$var$addMetricObserver("cls", callback, $caf92f65a6444fd8$var$instrumentCls, $caf92f65a6444fd8$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $caf92f65a6444fd8$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $caf92f65a6444fd8$var$addMetricObserver("lcp", callback, $caf92f65a6444fd8$var$instrumentLcp, $caf92f65a6444fd8$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 */ function $caf92f65a6444fd8$export$699d9529c099a797(callback) {
    return $caf92f65a6444fd8$var$addMetricObserver("ttfb", callback, $caf92f65a6444fd8$var$instrumentTtfb, $caf92f65a6444fd8$var$_previousTtfb);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $caf92f65a6444fd8$export$2707d7471c0b918f(callback) {
    return $caf92f65a6444fd8$var$addMetricObserver("fid", callback, $caf92f65a6444fd8$var$instrumentFid, $caf92f65a6444fd8$var$_previousFid);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $caf92f65a6444fd8$export$da3b76aa2022cbd7(callback) {
    return $caf92f65a6444fd8$var$addMetricObserver("inp", callback, $caf92f65a6444fd8$var$instrumentInp, $caf92f65a6444fd8$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $caf92f65a6444fd8$export$69816c1a049f8db6(type, callback) {
    $caf92f65a6444fd8$var$addHandler(type, callback);
    if (!$caf92f65a6444fd8$var$instrumented[type]) {
        $caf92f65a6444fd8$var$instrumentPerformanceObserver(type);
        $caf92f65a6444fd8$var$instrumented[type] = true;
    }
    return $caf92f65a6444fd8$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $caf92f65a6444fd8$var$triggerHandlers(type, data) {
    const typeHandlers = $caf92f65a6444fd8$var$handlers[type];
    if (!typeHandlers || !typeHandlers.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $036vc.DEBUG_BUILD) && (0, $7Dams.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $kmiJQ.getFunctionName)(handler)}\nError:`, e);
    }
}
function $caf92f65a6444fd8$var$instrumentCls() {
    return (0, $eBlWG.onCLS)((metric)=>{
        $caf92f65a6444fd8$var$triggerHandlers("cls", {
            metric: metric
        });
        $caf92f65a6444fd8$var$_previousCls = metric;
    }, {
        reportAllChanges: true
    });
}
function $caf92f65a6444fd8$var$instrumentFid() {
    return (0, $2setH.onFID)((metric)=>{
        $caf92f65a6444fd8$var$triggerHandlers("fid", {
            metric: metric
        });
        $caf92f65a6444fd8$var$_previousFid = metric;
    });
}
function $caf92f65a6444fd8$var$instrumentLcp() {
    return (0, $fG9c5.onLCP)((metric)=>{
        $caf92f65a6444fd8$var$triggerHandlers("lcp", {
            metric: metric
        });
        $caf92f65a6444fd8$var$_previousLcp = metric;
    });
}
function $caf92f65a6444fd8$var$instrumentTtfb() {
    return (0, $ijfgC.onTTFB)((metric)=>{
        $caf92f65a6444fd8$var$triggerHandlers("ttfb", {
            metric: metric
        });
        $caf92f65a6444fd8$var$_previousTtfb = metric;
    });
}
function $caf92f65a6444fd8$var$instrumentInp() {
    return (0, $hPZLa.onINP)((metric)=>{
        $caf92f65a6444fd8$var$triggerHandlers("inp", {
            metric: metric
        });
        $caf92f65a6444fd8$var$_previousInp = metric;
    });
}
function $caf92f65a6444fd8$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $caf92f65a6444fd8$var$addHandler(type, callback);
    let stopListening;
    if (!$caf92f65a6444fd8$var$instrumented[type]) {
        stopListening = instrumentFn();
        $caf92f65a6444fd8$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $caf92f65a6444fd8$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $caf92f65a6444fd8$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === "event") options.durationThreshold = 0;
    (0, $6AjPt.observe)(type, (entries)=>{
        $caf92f65a6444fd8$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $caf92f65a6444fd8$var$addHandler(type, handler) {
    $caf92f65a6444fd8$var$handlers[type] = $caf92f65a6444fd8$var$handlers[type] || [];
    $caf92f65a6444fd8$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $caf92f65a6444fd8$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $caf92f65a6444fd8$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}

});
parcelRegister("eBlWG", function(module, exports) {

$parcel$export(module.exports, "onCLS", function () { return $aa158b53ebb09657$export$a7873055838e5ad8; });

var $dCq8P = parcelRequire("dCq8P");

var $87pq7 = parcelRequire("87pq7");

var $6AjPt = parcelRequire("6AjPt");

var $aVtvA = parcelRequire("aVtvA");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $aa158b53ebb09657$export$a7873055838e5ad8 = (onReport, options = {})=>{
    const metric = (0, $87pq7.initMetric)("CLS", 0);
    let report;
    let sessionValue = 0;
    let sessionEntries = [];
    // const handleEntries = (entries: Metric['entries']) => {
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            // Only count layout shifts without recent user input.
            if (!entry.hadRecentInput) {
                const firstSessionEntry = sessionEntries[0];
                const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                // If the entry occurred less than 1 second after the previous entry and
                // less than 5 seconds after the first entry in the session, include the
                // entry in the current session. Otherwise, start a new session.
                if (sessionValue && sessionEntries.length !== 0 && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                    sessionValue += entry.value;
                    sessionEntries.push(entry);
                } else {
                    sessionValue = entry.value;
                    sessionEntries = [
                        entry
                    ];
                }
                // If the current session value is larger than the current CLS value,
                // update CLS and the entries contributing to it.
                if (sessionValue > metric.value) {
                    metric.value = sessionValue;
                    metric.entries = sessionEntries;
                    if (report) report();
                }
            }
        });
    };
    const po = (0, $6AjPt.observe)("layout-shift", handleEntries);
    if (po) {
        report = (0, $dCq8P.bindReporter)(onReport, metric, options.reportAllChanges);
        const stopListening = ()=>{
            handleEntries(po.takeRecords());
            report(true);
        };
        (0, $aVtvA.onHidden)(stopListening);
        return stopListening;
    }
    return;
};

});
parcelRegister("dCq8P", function(module, exports) {

$parcel$export(module.exports, "bindReporter", function () { return $9ea31a19866b66e9$export$17679dccdd551979; });
const $9ea31a19866b66e9$export$17679dccdd551979 = (callback, metric, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    callback(metric);
                }
            }
        }
    };
};

});

parcelRegister("87pq7", function(module, exports) {

$parcel$export(module.exports, "initMetric", function () { return $5e92b21a080dd7b4$export$3c29b44508a0612b; });

var $a4mdh = parcelRequire("a4mdh");

var $3DHH7 = parcelRequire("3DHH7");

var $b0k0y = parcelRequire("b0k0y");

var $9LCSz = parcelRequire("9LCSz");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5e92b21a080dd7b4$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $9LCSz.getNavigationEntry)();
    let navigationType = "navigate";
    if (navEntry) {
        if ((0, $a4mdh.WINDOW).document && (0, $a4mdh.WINDOW).document.prerendering || (0, $b0k0y.getActivationStart)() > 0) navigationType = "prerender";
        else navigationType = navEntry.type.replace(/_/g, "-");
    }
    return {
        name: name,
        value: typeof value === "undefined" ? -1 : value,
        rating: "good",
        delta: 0,
        entries: [],
        id: (0, $3DHH7.generateUniqueID)(),
        navigationType: navigationType
    };
};

});
parcelRegister("3DHH7", function(module, exports) {

$parcel$export(module.exports, "generateUniqueID", function () { return $2a66e86bb1c9ba83$export$407ea409d1f3b539; });
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $2a66e86bb1c9ba83$export$407ea409d1f3b539 = ()=>{
    return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};

});

parcelRegister("b0k0y", function(module, exports) {

$parcel$export(module.exports, "getActivationStart", function () { return $802f36f12d57a365$export$d3e828b3c7b5b845; });

var $9LCSz = parcelRequire("9LCSz");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $802f36f12d57a365$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $9LCSz.getNavigationEntry)();
    return navEntry && navEntry.activationStart || 0;
};

});
parcelRegister("9LCSz", function(module, exports) {

$parcel$export(module.exports, "getNavigationEntry", function () { return $71c6a96f2ae2ff60$export$6431553786c94949; });

var $a4mdh = parcelRequire("a4mdh");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $71c6a96f2ae2ff60$var$getNavigationEntryFromPerformanceTiming = ()=>{
    // eslint-disable-next-line deprecation/deprecation
    const timing = (0, $a4mdh.WINDOW).performance.timing;
    // eslint-disable-next-line deprecation/deprecation
    const type = (0, $a4mdh.WINDOW).performance.navigation.type;
    const navigationEntry = {
        entryType: "navigation",
        startTime: 0,
        type: type == 2 ? "back_forward" : type === 1 ? "reload" : "navigate"
    };
    for(const key in timing)if (key !== "navigationStart" && key !== "toJSON") // eslint-disable-next-line deprecation/deprecation
    navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
    return navigationEntry;
};
const $71c6a96f2ae2ff60$export$6431553786c94949 = ()=>{
    if ((0, $a4mdh.WINDOW).__WEB_VITALS_POLYFILL__) return (0, $a4mdh.WINDOW).performance && (performance.getEntriesByType && performance.getEntriesByType("navigation")[0] || $71c6a96f2ae2ff60$var$getNavigationEntryFromPerformanceTiming());
    else return (0, $a4mdh.WINDOW).performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
};

});



parcelRegister("6AjPt", function(module, exports) {

$parcel$export(module.exports, "observe", function () { return $4cb57c8f57c7e846$export$d1203567a167490e; });
/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $4cb57c8f57c7e846$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                callback(list.getEntries());
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};

});

parcelRegister("aVtvA", function(module, exports) {

$parcel$export(module.exports, "onHidden", function () { return $7f461e066bf92cf9$export$91ec2be6fdd8f1b4; });

var $a4mdh = parcelRequire("a4mdh");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $7f461e066bf92cf9$export$91ec2be6fdd8f1b4 = (cb, once)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === "pagehide" || (0, $a4mdh.WINDOW).document.visibilityState === "hidden") {
            cb(event);
            if (once) {
                removeEventListener("visibilitychange", onHiddenOrPageHide, true);
                removeEventListener("pagehide", onHiddenOrPageHide, true);
            }
        }
    };
    if ((0, $a4mdh.WINDOW).document) {
        addEventListener("visibilitychange", onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener("pagehide", onHiddenOrPageHide, true);
    }
};

});


parcelRegister("2setH", function(module, exports) {

$parcel$export(module.exports, "onFID", function () { return $1c996d4e18951886$export$39705a25c49af873; });

var $dCq8P = parcelRequire("dCq8P");

var $7JQ9J = parcelRequire("7JQ9J");

var $87pq7 = parcelRequire("87pq7");

var $6AjPt = parcelRequire("6AjPt");

var $aVtvA = parcelRequire("aVtvA");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $1c996d4e18951886$export$39705a25c49af873 = (onReport)=>{
    const visibilityWatcher = (0, $7JQ9J.getVisibilityWatcher)();
    const metric = (0, $87pq7.initMetric)("FID");
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntry = (entry)=>{
        // Only report if the page wasn't hidden prior to the first input.
        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    const handleEntries = (entries)=>{
        entries.forEach(handleEntry);
    };
    const po = (0, $6AjPt.observe)("first-input", handleEntries);
    report = (0, $dCq8P.bindReporter)(onReport, metric);
    if (po) (0, $aVtvA.onHidden)(()=>{
        handleEntries(po.takeRecords());
        po.disconnect();
    }, true);
};

});
parcelRegister("7JQ9J", function(module, exports) {

$parcel$export(module.exports, "getVisibilityWatcher", function () { return $5a2531736a4df007$export$443f86b2c77012c4; });

var $a4mdh = parcelRequire("a4mdh");

var $aVtvA = parcelRequire("aVtvA");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $5a2531736a4df007$var$firstHiddenTime = -1;
const $5a2531736a4df007$var$initHiddenTime = ()=>{
    // If the document is hidden and not prerendering, assume it was always
    // hidden and the page was loaded in the background.
    if ((0, $a4mdh.WINDOW).document && (0, $a4mdh.WINDOW).document.visibilityState) $5a2531736a4df007$var$firstHiddenTime = (0, $a4mdh.WINDOW).document.visibilityState === "hidden" && !(0, $a4mdh.WINDOW).document.prerendering ? 0 : Infinity;
};
const $5a2531736a4df007$var$trackChanges = ()=>{
    // Update the time if/when the document becomes hidden.
    (0, $aVtvA.onHidden)(({ timeStamp: timeStamp })=>{
        $5a2531736a4df007$var$firstHiddenTime = timeStamp;
    }, true);
};
const $5a2531736a4df007$export$443f86b2c77012c4 = ()=>{
    if ($5a2531736a4df007$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $5a2531736a4df007$var$initHiddenTime();
        $5a2531736a4df007$var$trackChanges();
    }
    return {
        get firstHiddenTime () {
            return $5a2531736a4df007$var$firstHiddenTime;
        }
    };
};

});


parcelRegister("hPZLa", function(module, exports) {

$parcel$export(module.exports, "onINP", function () { return $cfc71b43e1a7c5e2$export$7df4b36ecaed99e1; });

var $dCq8P = parcelRequire("dCq8P");

var $87pq7 = parcelRequire("87pq7");

var $6AjPt = parcelRequire("6AjPt");

var $aVtvA = parcelRequire("aVtvA");

var $aLKN5 = parcelRequire("aLKN5");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $cfc71b43e1a7c5e2$var$getInteractionCountForNavigation = ()=>{
    return (0, $aLKN5.getInteractionCount)();
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $cfc71b43e1a7c5e2$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
// A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is as most MAX_INTERACTIONS_TO_CONSIDER long.
const $cfc71b43e1a7c5e2$var$longestInteractionList = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const $cfc71b43e1a7c5e2$var$longestInteractionMap = {};
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ const $cfc71b43e1a7c5e2$var$processEntry = (entry)=>{
    // The least-long of the 10 longest interactions.
    const minLongestInteraction = $cfc71b43e1a7c5e2$var$longestInteractionList[$cfc71b43e1a7c5e2$var$longestInteractionList.length - 1];
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const existingInteraction = $cfc71b43e1a7c5e2$var$longestInteractionMap[entry.interactionId];
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || $cfc71b43e1a7c5e2$var$longestInteractionList.length < $cfc71b43e1a7c5e2$var$MAX_INTERACTIONS_TO_CONSIDER || entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            existingInteraction.entries.push(entry);
            existingInteraction.latency = Math.max(existingInteraction.latency, entry.duration);
        } else {
            const interaction = {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            $cfc71b43e1a7c5e2$var$longestInteractionMap[interaction.id] = interaction;
            $cfc71b43e1a7c5e2$var$longestInteractionList.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        $cfc71b43e1a7c5e2$var$longestInteractionList.sort((a, b)=>b.latency - a.latency);
        $cfc71b43e1a7c5e2$var$longestInteractionList.splice($cfc71b43e1a7c5e2$var$MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>{
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete $cfc71b43e1a7c5e2$var$longestInteractionMap[i.id];
        });
    }
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ const $cfc71b43e1a7c5e2$var$estimateP98LongestInteraction = ()=>{
    const candidateInteractionIndex = Math.min($cfc71b43e1a7c5e2$var$longestInteractionList.length - 1, Math.floor($cfc71b43e1a7c5e2$var$getInteractionCountForNavigation() / 50));
    return $cfc71b43e1a7c5e2$var$longestInteractionList[candidateInteractionIndex];
};
/**
 * Calculates the [INP](https://web.dev/responsiveness/) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/inp/#what-is-a-good-inp-score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $cfc71b43e1a7c5e2$export$7df4b36ecaed99e1 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/inp/#what's-a-%22good%22-inp-value
    // const thresholds = [200, 500];
    // TODO(philipwalton): remove once the polyfill is no longer needed.
    (0, $aLKN5.initInteractionCountPolyfill)();
    const metric = (0, $87pq7.initMetric)("INP");
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            if (entry.interactionId) $cfc71b43e1a7c5e2$var$processEntry(entry);
            // Entries of type `first-input` don't currently have an `interactionId`,
            // so to consider them in INP we have to first check that an existing
            // entry doesn't match the `duration` and `startTime`.
            // Note that this logic assumes that `event` entries are dispatched
            // before `first-input` entries. This is true in Chrome but it is not
            // true in Firefox; however, Firefox doesn't support interactionId, so
            // it's not an issue at the moment.
            // TODO(philipwalton): remove once crbug.com/1325826 is fixed.
            if (entry.entryType === "first-input") {
                const noMatchingEntry = !$cfc71b43e1a7c5e2$var$longestInteractionList.some((interaction)=>{
                    return interaction.entries.some((prevEntry)=>{
                        return entry.duration === prevEntry.duration && entry.startTime === prevEntry.startTime;
                    });
                });
                if (noMatchingEntry) $cfc71b43e1a7c5e2$var$processEntry(entry);
            }
        });
        const inp = $cfc71b43e1a7c5e2$var$estimateP98LongestInteraction();
        if (inp && inp.latency !== metric.value) {
            metric.value = inp.latency;
            metric.entries = inp.entries;
            report();
        }
    };
    const po = (0, $6AjPt.observe)("event", handleEntries, {
        // Event Timing entries have their durations rounded to the nearest 8ms,
        // so a duration of 40ms would be any event that spans 2.5 or more frames
        // at 60Hz. This threshold is chosen to strike a balance between usefulness
        // and performance. Running this callback for any interaction that spans
        // just one or two frames is likely not worth the insight that could be
        // gained.
        durationThreshold: opts.durationThreshold || 40
    });
    report = (0, $dCq8P.bindReporter)(onReport, metric, opts.reportAllChanges);
    if (po) {
        // Also observe entries of type `first-input`. This is useful in cases
        // where the first interaction is less than the `durationThreshold`.
        po.observe({
            type: "first-input",
            buffered: true
        });
        (0, $aVtvA.onHidden)(()=>{
            handleEntries(po.takeRecords());
            // If the interaction count shows that there were interactions but
            // none were captured by the PerformanceObserver, report a latency of 0.
            if (metric.value < 0 && $cfc71b43e1a7c5e2$var$getInteractionCountForNavigation() > 0) {
                metric.value = 0;
                metric.entries = [];
            }
            report(true);
        });
    }
};

});
parcelRegister("aLKN5", function(module, exports) {

$parcel$export(module.exports, "getInteractionCount", function () { return $7d7296d7eabbfe65$export$8a962f2683a476d1; });
$parcel$export(module.exports, "initInteractionCountPolyfill", function () { return $7d7296d7eabbfe65$export$67d90cda6b78a2eb; });

var $6AjPt = parcelRequire("6AjPt");
let $7d7296d7eabbfe65$var$interactionCountEstimate = 0;
let $7d7296d7eabbfe65$var$minKnownInteractionId = Infinity;
let $7d7296d7eabbfe65$var$maxKnownInteractionId = 0;
const $7d7296d7eabbfe65$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $7d7296d7eabbfe65$var$minKnownInteractionId = Math.min($7d7296d7eabbfe65$var$minKnownInteractionId, e.interactionId);
            $7d7296d7eabbfe65$var$maxKnownInteractionId = Math.max($7d7296d7eabbfe65$var$maxKnownInteractionId, e.interactionId);
            $7d7296d7eabbfe65$var$interactionCountEstimate = $7d7296d7eabbfe65$var$maxKnownInteractionId ? ($7d7296d7eabbfe65$var$maxKnownInteractionId - $7d7296d7eabbfe65$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $7d7296d7eabbfe65$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $7d7296d7eabbfe65$export$8a962f2683a476d1 = ()=>{
    return $7d7296d7eabbfe65$var$po ? $7d7296d7eabbfe65$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $7d7296d7eabbfe65$export$67d90cda6b78a2eb = ()=>{
    if ("interactionCount" in performance || $7d7296d7eabbfe65$var$po) return;
    $7d7296d7eabbfe65$var$po = (0, $6AjPt.observe)("event", $7d7296d7eabbfe65$var$updateEstimate, {
        type: "event",
        buffered: true,
        durationThreshold: 0
    });
};

});


parcelRegister("fG9c5", function(module, exports) {

$parcel$export(module.exports, "onLCP", function () { return $b6a1e8f8adcf1360$export$947b1626ab8d5632; });

var $a4mdh = parcelRequire("a4mdh");

var $dCq8P = parcelRequire("dCq8P");

var $b0k0y = parcelRequire("b0k0y");

var $7JQ9J = parcelRequire("7JQ9J");

var $87pq7 = parcelRequire("87pq7");

var $6AjPt = parcelRequire("6AjPt");

var $aVtvA = parcelRequire("aVtvA");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b6a1e8f8adcf1360$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */ const $b6a1e8f8adcf1360$export$947b1626ab8d5632 = (onReport)=>{
    const visibilityWatcher = (0, $7JQ9J.getVisibilityWatcher)();
    const metric = (0, $87pq7.initMetric)("LCP");
    let report;
    const handleEntries = (entries)=>{
        const lastEntry = entries[entries.length - 1];
        if (lastEntry) {
            // The startTime attribute returns the value of the renderTime if it is
            // not 0, and the value of the loadTime otherwise. The activationStart
            // reference is used because LCP should be relative to page activation
            // rather than navigation start if the page was prerendered.
            const value = Math.max(lastEntry.startTime - (0, $b0k0y.getActivationStart)(), 0);
            // Only report if the page wasn't hidden prior to LCP.
            if (value < visibilityWatcher.firstHiddenTime) {
                metric.value = value;
                metric.entries = [
                    lastEntry
                ];
                report();
            }
        }
    };
    const po = (0, $6AjPt.observe)("largest-contentful-paint", handleEntries);
    if (po) {
        report = (0, $dCq8P.bindReporter)(onReport, metric);
        const stopListening = ()=>{
            if (!$b6a1e8f8adcf1360$var$reportedMetricIDs[metric.id]) {
                handleEntries(po.takeRecords());
                po.disconnect();
                $b6a1e8f8adcf1360$var$reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        [
            "keydown",
            "click"
        ].forEach((type)=>{
            if ((0, $a4mdh.WINDOW).document) addEventListener(type, stopListening, {
                once: true,
                capture: true
            });
        });
        (0, $aVtvA.onHidden)(stopListening, true);
        return stopListening;
    }
    return;
};

});

parcelRegister("ijfgC", function(module, exports) {

$parcel$export(module.exports, "onTTFB", function () { return $d545d813b1e5553f$export$33a01e6c5f2c7e33; });

var $a4mdh = parcelRequire("a4mdh");

var $dCq8P = parcelRequire("dCq8P");

var $b0k0y = parcelRequire("b0k0y");

var $9LCSz = parcelRequire("9LCSz");

var $87pq7 = parcelRequire("87pq7");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ const $d545d813b1e5553f$var$whenReady = (callback)=>{
    if (!(0, $a4mdh.WINDOW).document) return;
    if ((0, $a4mdh.WINDOW).document.prerendering) addEventListener("prerenderingchange", ()=>$d545d813b1e5553f$var$whenReady(callback), true);
    else if ((0, $a4mdh.WINDOW).document.readyState !== "complete") addEventListener("load", ()=>$d545d813b1e5553f$var$whenReady(callback), true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
};
/**
 * Calculates the [TTFB](https://web.dev/time-to-first-byte/) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ const $d545d813b1e5553f$export$33a01e6c5f2c7e33 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/ttfb/#what-is-a-good-ttfb-score
    // const thresholds = [800, 1800];
    const metric = (0, $87pq7.initMetric)("TTFB");
    const report = (0, $dCq8P.bindReporter)(onReport, metric, opts.reportAllChanges);
    $d545d813b1e5553f$var$whenReady(()=>{
        const navEntry = (0, $9LCSz.getNavigationEntry)();
        if (navEntry) {
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(navEntry.responseStart - (0, $b0k0y.getActivationStart)(), 0);
            // In some cases the value reported is negative or is larger
            // than the current page time. Ignore these cases:
            // https://github.com/GoogleChrome/web-vitals/issues/137
            // https://github.com/GoogleChrome/web-vitals/issues/162
            if (metric.value < 0 || metric.value > performance.now()) return;
            metric.entries = [
                navEntry
            ];
            report(true);
        }
    });
};

});


parcelRegister("dysLL", function(module, exports) {

$parcel$export(module.exports, "startTrackingWebVitals", function () { return $9de4c45c9158ba4b$export$7c69f0412d101b88; });
$parcel$export(module.exports, "startTrackingLongTasks", function () { return $9de4c45c9158ba4b$export$f396d19077034ad2; });
$parcel$export(module.exports, "startTrackingInteractions", function () { return $9de4c45c9158ba4b$export$e27543e0976315e4; });
$parcel$export(module.exports, "startTrackingINP", function () { return $9de4c45c9158ba4b$export$f17d06681a4744a3; });
$parcel$export(module.exports, "addPerformanceEntries", function () { return $9de4c45c9158ba4b$export$5f8fa6b3467a7443; });

var $j52lb = parcelRequire("j52lb");
var $bdACW = parcelRequire("bdACW");
var $iKbxs = parcelRequire("iKbxs");
var $kRhVl = parcelRequire("kRhVl");
var $ecEes = parcelRequire("ecEes");
var $8Pp2K = parcelRequire("8Pp2K");
var $8O7MK = parcelRequire("8O7MK");
var $IueXx = parcelRequire("IueXx");

var $bA8KD = parcelRequire("bA8KD");
var $db3mB = parcelRequire("db3mB");
var $7Dams = parcelRequire("7Dams");
var $dBGHn = parcelRequire("dBGHn");

var $036vc = parcelRequire("036vc");

var $hqqce = parcelRequire("hqqce");

var $a4mdh = parcelRequire("a4mdh");

var $7JQ9J = parcelRequire("7JQ9J");

var $5MRjr = parcelRequire("5MRjr");

var $9LCSz = parcelRequire("9LCSz");
const $9de4c45c9158ba4b$var$MAX_INT_AS_BYTES = 2147483647;
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $9de4c45c9158ba4b$var$msToSec(time) {
    return time / 1000;
}
function $9de4c45c9158ba4b$var$getBrowserPerformanceAPI() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $a4mdh.WINDOW) && (0, $a4mdh.WINDOW).addEventListener && (0, $a4mdh.WINDOW).performance;
}
let $9de4c45c9158ba4b$var$_performanceCursor = 0;
let $9de4c45c9158ba4b$var$_measurements = {};
let $9de4c45c9158ba4b$var$_lcpEntry;
let $9de4c45c9158ba4b$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function $9de4c45c9158ba4b$export$7c69f0412d101b88() {
    const performance = $9de4c45c9158ba4b$var$getBrowserPerformanceAPI();
    if (performance && (0, $bA8KD.browserPerformanceTimeOrigin)) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $a4mdh.WINDOW).performance.mark("sentry-tracing-init");
        const fidCallback = $9de4c45c9158ba4b$var$_trackFID();
        const clsCallback = $9de4c45c9158ba4b$var$_trackCLS();
        const lcpCallback = $9de4c45c9158ba4b$var$_trackLCP();
        const ttfbCallback = $9de4c45c9158ba4b$var$_trackTtfb();
        return ()=>{
            fidCallback();
            clsCallback();
            lcpCallback();
            ttfbCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $9de4c45c9158ba4b$export$f396d19077034ad2() {
    (0, $hqqce.addPerformanceInstrumentationHandler)("longtask", ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $bdACW.getActiveTransaction)();
            if (!transaction) return;
            const startTime = $9de4c45c9158ba4b$var$msToSec((0, $bA8KD.browserPerformanceTimeOrigin) + entry.startTime);
            const duration = $9de4c45c9158ba4b$var$msToSec(entry.duration);
            // eslint-disable-next-line deprecation/deprecation
            transaction.startChild({
                description: "Main UI thread blocked",
                op: "ui.long-task",
                origin: "auto.ui.browser.metrics",
                startTimestamp: startTime,
                endTimestamp: startTime + duration
            });
        }
    });
}
/**
 * Start tracking interaction events.
 */ function $9de4c45c9158ba4b$export$e27543e0976315e4() {
    (0, $hqqce.addPerformanceInstrumentationHandler)("event", ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $bdACW.getActiveTransaction)();
            if (!transaction) return;
            if (entry.name === "click") {
                const startTime = $9de4c45c9158ba4b$var$msToSec((0, $bA8KD.browserPerformanceTimeOrigin) + entry.startTime);
                const duration = $9de4c45c9158ba4b$var$msToSec(entry.duration);
                const span = {
                    description: (0, $db3mB.htmlTreeAsString)(entry.target),
                    op: `ui.interaction.${entry.name}`,
                    origin: "auto.ui.browser.metrics",
                    startTimestamp: startTime,
                    endTimestamp: startTime + duration
                };
                const componentName = (0, $db3mB.getComponentName)(entry.target);
                if (componentName) span.attributes = {
                    "ui.component_name": componentName
                };
                // eslint-disable-next-line deprecation/deprecation
                transaction.startChild(span);
            }
        }
    });
}
/**
 * Start tracking INP webvital events.
 */ function $9de4c45c9158ba4b$export$f17d06681a4744a3(interactionIdtoRouteNameMapping, interactionsSampleRate) {
    const performance = $9de4c45c9158ba4b$var$getBrowserPerformanceAPI();
    if (performance && (0, $bA8KD.browserPerformanceTimeOrigin)) {
        const inpCallback = $9de4c45c9158ba4b$var$_trackINP(interactionIdtoRouteNameMapping, interactionsSampleRate);
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
/** Starts tracking the Cumulative Layout Shift on the current page. */ function $9de4c45c9158ba4b$var$_trackCLS() {
    return (0, $hqqce.addClsInstrumentationHandler)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $036vc.DEBUG_BUILD) && (0, $7Dams.logger).log("[Measurements] Adding CLS");
        $9de4c45c9158ba4b$var$_measurements["cls"] = {
            value: metric.value,
            unit: ""
        };
        $9de4c45c9158ba4b$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $9de4c45c9158ba4b$var$_trackLCP() {
    return (0, $hqqce.addLcpInstrumentationHandler)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $036vc.DEBUG_BUILD) && (0, $7Dams.logger).log("[Measurements] Adding LCP");
        $9de4c45c9158ba4b$var$_measurements["lcp"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $9de4c45c9158ba4b$var$_lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function $9de4c45c9158ba4b$var$_trackFID() {
    return (0, $hqqce.addFidInstrumentationHandler)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        const timeOrigin = $9de4c45c9158ba4b$var$msToSec((0, $bA8KD.browserPerformanceTimeOrigin));
        const startTime = $9de4c45c9158ba4b$var$msToSec(entry.startTime);
        (0, $036vc.DEBUG_BUILD) && (0, $7Dams.logger).log("[Measurements] Adding FID");
        $9de4c45c9158ba4b$var$_measurements["fid"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $9de4c45c9158ba4b$var$_measurements["mark.fid"] = {
            value: timeOrigin + startTime,
            unit: "second"
        };
    });
}
function $9de4c45c9158ba4b$var$_trackTtfb() {
    return (0, $hqqce.addTtfbInstrumentationHandler)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $036vc.DEBUG_BUILD) && (0, $7Dams.logger).log("[Measurements] Adding TTFB");
        $9de4c45c9158ba4b$var$_measurements["ttfb"] = {
            value: metric.value,
            unit: "millisecond"
        };
    });
}
const $9de4c45c9158ba4b$var$INP_ENTRY_MAP = {
    click: "click",
    pointerdown: "click",
    pointerup: "click",
    mousedown: "click",
    mouseup: "click",
    touchstart: "click",
    touchend: "click",
    mouseover: "hover",
    mouseout: "hover",
    mouseenter: "hover",
    mouseleave: "hover",
    pointerover: "hover",
    pointerout: "hover",
    pointerenter: "hover",
    pointerleave: "hover",
    dragstart: "drag",
    dragend: "drag",
    drag: "drag",
    dragenter: "drag",
    dragleave: "drag",
    dragover: "drag",
    drop: "drag",
    keydown: "press",
    keyup: "press",
    keypress: "press",
    input: "press"
};
/** Starts tracking the Interaction to Next Paint on the current page. */ function $9de4c45c9158ba4b$var$_trackINP(interactionIdToRouteNameMapping, interactionsSampleRate) {
    return (0, $hqqce.addInpInstrumentationHandler)(({ metric: metric })=>{
        if (metric.value === undefined) return;
        const entry = metric.entries.find((entry)=>entry.duration === metric.value && $9de4c45c9158ba4b$var$INP_ENTRY_MAP[entry.name] !== undefined);
        const client = (0, $iKbxs.getClient)();
        if (!entry || !client) return;
        const interactionType = $9de4c45c9158ba4b$var$INP_ENTRY_MAP[entry.name];
        const options = client.getOptions();
        /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = $9de4c45c9158ba4b$var$msToSec((0, $bA8KD.browserPerformanceTimeOrigin) + entry.startTime);
        const duration = $9de4c45c9158ba4b$var$msToSec(metric.value);
        const interaction = entry.interactionId !== undefined ? interactionIdToRouteNameMapping[entry.interactionId] : undefined;
        if (interaction === undefined) return;
        const { routeName: routeName, parentContext: parentContext, activeTransaction: activeTransaction, user: user, replayId: replayId } = interaction;
        const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
        // eslint-disable-next-line deprecation/deprecation
        const profileId = activeTransaction !== undefined ? activeTransaction.getProfileId() : undefined;
        const span = new (0, $8O7MK.Span)({
            startTimestamp: startTime,
            endTimestamp: startTime + duration,
            op: `ui.interaction.${interactionType}`,
            name: (0, $db3mB.htmlTreeAsString)(entry.target),
            attributes: {
                release: options.release,
                environment: options.environment,
                transaction: routeName,
                ...userDisplay !== undefined && userDisplay !== "" ? {
                    user: userDisplay
                } : {},
                ...profileId !== undefined ? {
                    profile_id: profileId
                } : {},
                ...replayId !== undefined ? {
                    replay_id: replayId
                } : {}
            },
            exclusiveTime: metric.value,
            measurements: {
                inp: {
                    value: metric.value,
                    unit: "millisecond"
                }
            }
        });
        /** Check to see if the span should be sampled */ const sampleRate = $9de4c45c9158ba4b$var$getSampleRate(parentContext, options, interactionsSampleRate);
        if (!sampleRate) return;
        if (Math.random() < sampleRate) {
            const envelope = span ? (0, $j52lb.createSpanEnvelope)([
                span
            ], client.getDsn()) : undefined;
            const transport = client && client.getTransport();
            if (transport && envelope) transport.send(envelope).then(null, (reason)=>{
                (0, $036vc.DEBUG_BUILD) && (0, $7Dams.logger).error("Error while sending interaction:", reason);
            });
            return;
        }
    });
}
/** Add performance related spans to a transaction */ function $9de4c45c9158ba4b$export$5f8fa6b3467a7443(transaction) {
    const performance = $9de4c45c9158ba4b$var$getBrowserPerformanceAPI();
    if (!performance || !(0, $a4mdh.WINDOW).performance.getEntries || !(0, $bA8KD.browserPerformanceTimeOrigin)) // Gatekeeper if performance API not available
    return;
    (0, $036vc.DEBUG_BUILD) && (0, $7Dams.logger).log("[Tracing] Adding & adjusting spans using Performance API");
    const timeOrigin = $9de4c45c9158ba4b$var$msToSec((0, $bA8KD.browserPerformanceTimeOrigin));
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $IueXx.spanToJSON)(transaction);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice($9de4c45c9158ba4b$var$_performanceCursor).forEach((entry)=>{
        const startTime = $9de4c45c9158ba4b$var$msToSec(entry.startTime);
        const duration = $9de4c45c9158ba4b$var$msToSec(entry.duration);
        // eslint-disable-next-line deprecation/deprecation
        if (transaction.op === "navigation" && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case "navigation":
                $9de4c45c9158ba4b$var$_addNavigationSpans(transaction, entry, timeOrigin);
                break;
            case "mark":
            case "paint":
            case "measure":
                {
                    $9de4c45c9158ba4b$export$bc93b84e4d45912d(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $7JQ9J.getVisibilityWatcher)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === "first-paint" && shouldRecord) {
                        (0, $036vc.DEBUG_BUILD) && (0, $7Dams.logger).log("[Measurements] Adding FP");
                        $9de4c45c9158ba4b$var$_measurements["fp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    if (entry.name === "first-contentful-paint" && shouldRecord) {
                        (0, $036vc.DEBUG_BUILD) && (0, $7Dams.logger).log("[Measurements] Adding FCP");
                        $9de4c45c9158ba4b$var$_measurements["fcp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    break;
                }
            case "resource":
                $9de4c45c9158ba4b$export$c82fe1a70634f317(transaction, entry, entry.name, startTime, duration, timeOrigin);
                break;
        }
    });
    $9de4c45c9158ba4b$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $9de4c45c9158ba4b$var$_trackNavigator(transaction);
    // Measurements are only available for pageload transactions
    if (op === "pageload") {
        $9de4c45c9158ba4b$var$_addTtfbRequestTimeToMeasurements($9de4c45c9158ba4b$var$_measurements);
        [
            "fcp",
            "fp",
            "lcp"
        ].forEach((name)=>{
            if (!$9de4c45c9158ba4b$var$_measurements[name] || !transactionStartTime || timeOrigin >= transactionStartTime) return;
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
            // to be adjusted to be relative to transaction.startTimestamp.
            const oldValue = $9de4c45c9158ba4b$var$_measurements[name].value;
            const measurementTimestamp = timeOrigin + $9de4c45c9158ba4b$var$msToSec(oldValue);
            // normalizedValue should be in milliseconds
            const normalizedValue = Math.abs((measurementTimestamp - transactionStartTime) * 1000);
            const delta = normalizedValue - oldValue;
            (0, $036vc.DEBUG_BUILD) && (0, $7Dams.logger).log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
            $9de4c45c9158ba4b$var$_measurements[name].value = normalizedValue;
        });
        const fidMark = $9de4c45c9158ba4b$var$_measurements["mark.fid"];
        if (fidMark && $9de4c45c9158ba4b$var$_measurements["fid"]) {
            // create span for FID
            (0, $5MRjr._startChild)(transaction, {
                description: "first input delay",
                endTimestamp: fidMark.value + $9de4c45c9158ba4b$var$msToSec($9de4c45c9158ba4b$var$_measurements["fid"].value),
                op: "ui.action",
                origin: "auto.ui.browser.metrics",
                startTimestamp: fidMark.value
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $9de4c45c9158ba4b$var$_measurements["mark.fid"];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        if (!("fcp" in $9de4c45c9158ba4b$var$_measurements)) delete $9de4c45c9158ba4b$var$_measurements.cls;
        Object.keys($9de4c45c9158ba4b$var$_measurements).forEach((measurementName)=>{
            (0, $8Pp2K.setMeasurement)(measurementName, $9de4c45c9158ba4b$var$_measurements[measurementName].value, $9de4c45c9158ba4b$var$_measurements[measurementName].unit);
        });
        $9de4c45c9158ba4b$var$_tagMetricInfo(transaction);
    }
    $9de4c45c9158ba4b$var$_lcpEntry = undefined;
    $9de4c45c9158ba4b$var$_clsEntry = undefined;
    $9de4c45c9158ba4b$var$_measurements = {};
}
/** Create measure related spans */ function $9de4c45c9158ba4b$export$bc93b84e4d45912d(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    const measureStartTimestamp = timeOrigin + startTime;
    const measureEndTimestamp = measureStartTimestamp + duration;
    (0, $5MRjr._startChild)(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        origin: "auto.resource.browser.metrics",
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9de4c45c9158ba4b$var$_addNavigationSpans(transaction, entry, timeOrigin) {
    [
        "unloadEvent",
        "redirect",
        "domContentLoadedEvent",
        "loadEvent",
        "connect"
    ].forEach((event)=>{
        $9de4c45c9158ba4b$var$_addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    $9de4c45c9158ba4b$var$_addPerformanceNavigationTiming(transaction, entry, "secureConnection", timeOrigin, "TLS/SSL", "connectEnd");
    $9de4c45c9158ba4b$var$_addPerformanceNavigationTiming(transaction, entry, "fetch", timeOrigin, "cache", "domainLookupStart");
    $9de4c45c9158ba4b$var$_addPerformanceNavigationTiming(transaction, entry, "domainLookup", timeOrigin, "DNS");
    $9de4c45c9158ba4b$var$_addRequest(transaction, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $9de4c45c9158ba4b$var$_addPerformanceNavigationTiming(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, description, eventEnd) {
    const end = eventEnd ? entry[eventEnd] : entry[`${event}End`];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $5MRjr._startChild)(transaction, {
        op: "browser",
        origin: "auto.browser.browser.metrics",
        description: description || event,
        startTimestamp: timeOrigin + $9de4c45c9158ba4b$var$msToSec(start),
        endTimestamp: timeOrigin + $9de4c45c9158ba4b$var$msToSec(end)
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9de4c45c9158ba4b$var$_addRequest(transaction, entry, timeOrigin) {
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire transaction if it contained faulty spans.
        (0, $5MRjr._startChild)(transaction, {
            op: "browser",
            origin: "auto.browser.browser.metrics",
            description: "request",
            startTimestamp: timeOrigin + $9de4c45c9158ba4b$var$msToSec(entry.requestStart),
            endTimestamp: timeOrigin + $9de4c45c9158ba4b$var$msToSec(entry.responseEnd)
        });
        (0, $5MRjr._startChild)(transaction, {
            op: "browser",
            origin: "auto.browser.browser.metrics",
            description: "response",
            startTimestamp: timeOrigin + $9de4c45c9158ba4b$var$msToSec(entry.responseStart),
            endTimestamp: timeOrigin + $9de4c45c9158ba4b$var$msToSec(entry.responseEnd)
        });
    }
}
/** Create resource-related spans */ function $9de4c45c9158ba4b$export$c82fe1a70634f317(transaction, entry, resourceUrl, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") return;
    const parsedUrl = (0, $dBGHn.parseUrl)(resourceUrl);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = {};
    $9de4c45c9158ba4b$var$setResourceEntrySizeData(data, entry, "transferSize", "http.response_transfer_size");
    $9de4c45c9158ba4b$var$setResourceEntrySizeData(data, entry, "encodedBodySize", "http.response_content_length");
    $9de4c45c9158ba4b$var$setResourceEntrySizeData(data, entry, "decodedBodySize", "http.decoded_response_content_length");
    if ("renderBlockingStatus" in entry) data["resource.render_blocking_status"] = entry.renderBlockingStatus;
    if (parsedUrl.protocol) data["url.scheme"] = parsedUrl.protocol.split(":").pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) data["server.address"] = parsedUrl.host;
    data["url.same_origin"] = resourceUrl.includes((0, $a4mdh.WINDOW).location.origin);
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $5MRjr._startChild)(transaction, {
        description: resourceUrl.replace((0, $a4mdh.WINDOW).location.origin, ""),
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : "resource.other",
        origin: "auto.resource.browser.metrics",
        startTimestamp: startTimestamp,
        data: data
    });
}
/**
 * Capture the information of the user agent.
 */ function $9de4c45c9158ba4b$var$_trackNavigator(transaction) {
    const navigator = (0, $a4mdh.WINDOW).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("effectiveConnectionType", connection.effectiveType);
        if (connection.type) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("connectionType", connection.type);
        if ((0, $5MRjr.isMeasurementValue)(connection.rtt)) $9de4c45c9158ba4b$var$_measurements["connection.rtt"] = {
            value: connection.rtt,
            unit: "millisecond"
        };
    }
    if ((0, $5MRjr.isMeasurementValue)(navigator.deviceMemory)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag("deviceMemory", `${navigator.deviceMemory} GB`);
    if ((0, $5MRjr.isMeasurementValue)(navigator.hardwareConcurrency)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag("hardwareConcurrency", String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to transaction to allow debugging */ function $9de4c45c9158ba4b$var$_tagMetricInfo(transaction) {
    if ($9de4c45c9158ba4b$var$_lcpEntry) {
        (0, $036vc.DEBUG_BUILD) && (0, $7Dams.logger).log("[Measurements] Adding LCP Data");
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($9de4c45c9158ba4b$var$_lcpEntry.element) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.element", (0, $db3mB.htmlTreeAsString)($9de4c45c9158ba4b$var$_lcpEntry.element));
        if ($9de4c45c9158ba4b$var$_lcpEntry.id) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.id", $9de4c45c9158ba4b$var$_lcpEntry.id);
        if ($9de4c45c9158ba4b$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.url", $9de4c45c9158ba4b$var$_lcpEntry.url.trim().slice(0, 200));
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.size", $9de4c45c9158ba4b$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($9de4c45c9158ba4b$var$_clsEntry && $9de4c45c9158ba4b$var$_clsEntry.sources) {
        (0, $036vc.DEBUG_BUILD) && (0, $7Dams.logger).log("[Measurements] Adding CLS Data");
        $9de4c45c9158ba4b$var$_clsEntry.sources.forEach((source, index)=>// TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setTag(`cls.source.${index + 1}`, (0, $db3mB.htmlTreeAsString)(source.node)));
    }
}
function $9de4c45c9158ba4b$var$setResourceEntrySizeData(data, entry, key, dataKey) {
    const entryVal = entry[key];
    if (entryVal != null && entryVal < $9de4c45c9158ba4b$var$MAX_INT_AS_BYTES) data[dataKey] = entryVal;
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function $9de4c45c9158ba4b$var$_addTtfbRequestTimeToMeasurements(_measurements) {
    const navEntry = (0, $9LCSz.getNavigationEntry)();
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) {
        (0, $036vc.DEBUG_BUILD) && (0, $7Dams.logger).log("[Measurements] Adding TTFB Request Time");
        _measurements["ttfb.requestTime"] = {
            value: responseStart - requestStart,
            unit: "millisecond"
        };
    }
}
/** Taken from @sentry/core sampling.ts */ function $9de4c45c9158ba4b$var$getSampleRate(transactionContext, options, interactionsSampleRate) {
    if (!(0, $kRhVl.hasTracingEnabled)(options)) return false;
    let sampleRate;
    if (transactionContext !== undefined && typeof options.tracesSampler === "function") sampleRate = options.tracesSampler({
        transactionContext: transactionContext,
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        location: (0, $a4mdh.WINDOW).location
    });
    else if (transactionContext !== undefined && transactionContext.sampled !== undefined) sampleRate = transactionContext.sampled;
    else if (typeof options.tracesSampleRate !== "undefined") sampleRate = options.tracesSampleRate;
    else sampleRate = 1;
    if (!(0, $ecEes.isValidSampleRate)(sampleRate)) {
        (0, $036vc.DEBUG_BUILD) && (0, $7Dams.logger).warn("[Tracing] Discarding interaction span because of invalid sample rate.");
        return false;
    }
    if (sampleRate === true) return interactionsSampleRate;
    else if (sampleRate === false) return 0;
    return sampleRate * interactionsSampleRate;
}

});
parcelRegister("j52lb", function(module, exports) {

$parcel$export(module.exports, "createSpanEnvelope", function () { return $de404cc6037be750$export$19a0081d4b39d77; });

var $dp1Mp = parcelRequire("dp1Mp");
var $52ZCk = parcelRequire("52ZCk");
/**
 * Create envelope from Span item.
 */ function $de404cc6037be750$export$19a0081d4b39d77(spans, dsn) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (dsn) headers.dsn = (0, $52ZCk.dsnToString)(dsn);
    const items = spans.map($de404cc6037be750$var$createSpanItem);
    return (0, $dp1Mp.createEnvelope)(headers, items);
}
function $de404cc6037be750$var$createSpanItem(span) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        span
    ];
}

});
parcelRegister("dp1Mp", function(module, exports) {

$parcel$export(module.exports, "createEnvelope", function () { return $9c1efd99ce3d073d$export$f93f7f385160c44e; });
$parcel$export(module.exports, "addItemToEnvelope", function () { return $9c1efd99ce3d073d$export$d650323442802f6f; });
$parcel$export(module.exports, "forEachEnvelopeItem", function () { return $9c1efd99ce3d073d$export$c56c55acf0136fd3; });
$parcel$export(module.exports, "serializeEnvelope", function () { return $9c1efd99ce3d073d$export$32f9b428425aac85; });
$parcel$export(module.exports, "createAttachmentEnvelopeItem", function () { return $9c1efd99ce3d073d$export$d8fc80952cc31fa4; });
$parcel$export(module.exports, "envelopeItemTypeToDataCategory", function () { return $9c1efd99ce3d073d$export$b11169581eeaf237; });
$parcel$export(module.exports, "getSdkMetadataForEnvelopeHeader", function () { return $9c1efd99ce3d073d$export$d369f3b2758f6743; });
$parcel$export(module.exports, "createEventEnvelopeHeaders", function () { return $9c1efd99ce3d073d$export$92b6093782fe661b; });

var $52ZCk = parcelRequire("52ZCk");

var $6l9XD = parcelRequire("6l9XD");

var $8WMel = parcelRequire("8WMel");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $9c1efd99ce3d073d$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $9c1efd99ce3d073d$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $9c1efd99ce3d073d$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $9c1efd99ce3d073d$export$604a45d95a155e2b(envelope, types) {
    return $9c1efd99ce3d073d$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8.
 */ function $9c1efd99ce3d073d$var$encodeUTF8(input, textEncoder) {
    const utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $9c1efd99ce3d073d$export$32f9b428425aac85(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $9c1efd99ce3d073d$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === "string" ? $9c1efd99ce3d073d$var$encodeUTF8(next, textEncoder) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $6l9XD.normalize)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $9c1efd99ce3d073d$var$concatBuffers(parts);
}
function $9c1efd99ce3d073d$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $9c1efd99ce3d073d$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    let buffer = typeof env === "string" ? textEncoder.encode(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $9c1efd99ce3d073d$export$d8fc80952cc31fa4(attachment, textEncoder) {
    const buffer = typeof attachment.data === "string" ? $9c1efd99ce3d073d$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $8WMel.dropUndefinedKeys)({
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $9c1efd99ce3d073d$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    feedback: "feedback",
    span: "span",
    statsd: "metric_bucket"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $9c1efd99ce3d073d$export$b11169581eeaf237(type) {
    return $9c1efd99ce3d073d$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $9c1efd99ce3d073d$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $9c1efd99ce3d073d$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $52ZCk.dsnToString)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $8WMel.dropUndefinedKeys)({
                ...dynamicSamplingContext
            })
        }
    };
}

});
parcelRegister("52ZCk", function(module, exports) {

$parcel$export(module.exports, "dsnToString", function () { return $3accef8e3fddaf1b$export$44d472fbb931a776; });
$parcel$export(module.exports, "makeDsn", function () { return $3accef8e3fddaf1b$export$128827c3562ec0cb; });

var $15pqG = parcelRequire("15pqG");

var $7Dams = parcelRequire("7Dams");
/** Regular expression used to parse a Dsn. */ const $3accef8e3fddaf1b$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $3accef8e3fddaf1b$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $3accef8e3fddaf1b$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $3accef8e3fddaf1b$export$b892860177f70a30(str) {
    const match = $3accef8e3fddaf1b$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $7Dams.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = "", host, port = "", lastPath] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $3accef8e3fddaf1b$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $3accef8e3fddaf1b$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $3accef8e3fddaf1b$var$validateDsn(dsn) {
    if (!(0, $15pqG.DEBUG_BUILD)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $7Dams.logger).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $7Dams.logger).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$3accef8e3fddaf1b$var$isValidProtocol(protocol)) {
        (0, $7Dams.logger).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $7Dams.logger).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $3accef8e3fddaf1b$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $3accef8e3fddaf1b$export$b892860177f70a30(from) : $3accef8e3fddaf1b$var$dsnFromComponents(from);
    if (!components || !$3accef8e3fddaf1b$var$validateDsn(components)) return undefined;
    return components;
}

});



parcelRegister("8Pp2K", function(module, exports) {

$parcel$export(module.exports, "setMeasurement", function () { return $66d68341c49b03f9$export$7cc31b475d33a706; });

var $bdACW = parcelRequire("bdACW");
/**
 * Adds a measurement to the current active transaction.
 */ function $66d68341c49b03f9$export$7cc31b475d33a706(name, value, unit) {
    // eslint-disable-next-line deprecation/deprecation
    const transaction = (0, $bdACW.getActiveTransaction)();
    if (transaction) // eslint-disable-next-line deprecation/deprecation
    transaction.setMeasurement(name, value, unit);
}

});

parcelRegister("dBGHn", function(module, exports) {

$parcel$export(module.exports, "parseUrl", function () { return $9e7fda199ce03557$export$7a5253c0f62e0150; });
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $9e7fda199ce03557$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $9e7fda199ce03557$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $9e7fda199ce03557$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ",").length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $9e7fda199ce03557$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, "[filtered]:[filtered]@")// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}

});

parcelRegister("5MRjr", function(module, exports) {

$parcel$export(module.exports, "isMeasurementValue", function () { return $436aca388b220f94$export$27169ccae1b439e3; });
$parcel$export(module.exports, "_startChild", function () { return $436aca388b220f94$export$8bd469e1f37aa721; });
/**
 * Checks if a given value is a valid measurement value.
 */ function $436aca388b220f94$export$27169ccae1b439e3(value) {
    return typeof value === "number" && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 *
 * Note: this will not be possible anymore in v8,
 * unless we do some special handling for browser here...
 */ function $436aca388b220f94$export$8bd469e1f37aa721(transaction, { startTimestamp: startTimestamp, ...ctx }) {
    // eslint-disable-next-line deprecation/deprecation
    if (startTimestamp && transaction.startTimestamp > startTimestamp) // eslint-disable-next-line deprecation/deprecation
    transaction.startTimestamp = startTimestamp;
    // eslint-disable-next-line deprecation/deprecation
    return transaction.startChild({
        startTimestamp: startTimestamp,
        ...ctx
    });
}

});


parcelRegister("3zkrT", function(module, exports) {

$parcel$export(module.exports, "defaultRequestInstrumentationOptions", function () { return $299480b636ad636e$export$cc17fb3c0bc95cd7; });
$parcel$export(module.exports, "instrumentOutgoingRequests", function () { return $299480b636ad636e$export$864489cb3478db3e; });

var $iKbxs = parcelRequire("iKbxs");
var $8XBHU = parcelRequire("8XBHU");
var $aFDsf = parcelRequire("aFDsf");
var $kRhVl = parcelRequire("kRhVl");
var $9t32t = parcelRequire("9t32t");
var $3AudM = parcelRequire("3AudM");
var $IueXx = parcelRequire("IueXx");
var $egrOp = parcelRequire("egrOp");

var $4V7kV = parcelRequire("4V7kV");
var $dk3nq = parcelRequire("dk3nq");
var $2HmZY = parcelRequire("2HmZY");
var $bA8KD = parcelRequire("bA8KD");
var $MppwO = parcelRequire("MppwO");
var $dBGHn = parcelRequire("dBGHn");
var $bqiXE = parcelRequire("bqiXE");

var $45OPh = parcelRequire("45OPh");

var $hqqce = parcelRequire("hqqce");

var $a4mdh = parcelRequire("a4mdh");
/* eslint-disable max-lines */ const $299480b636ad636e$export$15bd0305d05ad07b = [
    "localhost",
    /^\/(?!\/)/
];
/** Options for Request Instrumentation */ const $299480b636ad636e$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    // TODO (v8): Remove this property
    tracingOrigins: $299480b636ad636e$export$15bd0305d05ad07b,
    tracePropagationTargets: $299480b636ad636e$export$15bd0305d05ad07b
};
/** Registers span creators for xhr and fetch requests  */ function $299480b636ad636e$export$864489cb3478db3e(_options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, tracePropagationTargets: // eslint-disable-next-line deprecation/deprecation
    tracePropagationTargets, tracingOrigins: // eslint-disable-next-line deprecation/deprecation
    tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings } = {
        traceFetch: $299480b636ad636e$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $299480b636ad636e$export$cc17fb3c0bc95cd7.traceXHR,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === "function" ? shouldCreateSpanForRequest : (_)=>true;
    // TODO(v8) Remove tracingOrigins here
    // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
    // and we don't want to break the API. We can remove it in v8.
    const shouldAttachHeadersWithTargets = (url)=>$299480b636ad636e$export$c260386ab3f0b3dd(url, tracePropagationTargets || tracingOrigins);
    const spans = {};
    if (traceFetch) (0, $4V7kV.addFetchInstrumentationHandler)((handlerData)=>{
        const createdSpan = (0, $45OPh.instrumentFetchRequest)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        // We cannot use `window.location` in the generic fetch instrumentation,
        // but we need it for reliable `server.address` attribute.
        // so we extend this in here
        if (createdSpan) {
            const fullUrl = $299480b636ad636e$var$getFullURL(handlerData.fetchData.url);
            const host = fullUrl ? (0, $dBGHn.parseUrl)(fullUrl).host : undefined;
            createdSpan.setAttributes({
                "http.url": fullUrl,
                "server.address": host
            });
        }
        if (enableHTTPTimings && createdSpan) $299480b636ad636e$var$addHTTPTimings(createdSpan);
    });
    if (traceXHR) (0, $dk3nq.addXhrInstrumentationHandler)((handlerData)=>{
        const createdSpan = $299480b636ad636e$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $299480b636ad636e$var$addHTTPTimings(createdSpan);
    });
}
function $299480b636ad636e$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === "resource" && "initiatorType" in entry && typeof entry.nextHopProtocol === "string" && (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest");
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $299480b636ad636e$var$addHTTPTimings(span) {
    const { url: url } = (0, $IueXx.spanToJSON)(span).data || {};
    if (!url || typeof url !== "string") return;
    const cleanup = (0, $hqqce.addPerformanceInstrumentationHandler)("resource", ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ($299480b636ad636e$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = $299480b636ad636e$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setAttribute(...data));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $299480b636ad636e$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = "unknown";
    let version = "unknown";
    let _name = "";
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === "/") {
            [name, version] = nextHopProtocol.split("/");
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === "h" ? "http" : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
function $299480b636ad636e$var$getAbsoluteTime(time = 0) {
    return (((0, $bA8KD.browserPerformanceTimeOrigin) || performance.timeOrigin) + time) / 1000;
}
function $299480b636ad636e$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = $299480b636ad636e$export$57c6f824442f9fe1(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        "network.protocol.version",
        version
    ], [
        "network.protocol.name",
        name
    ]);
    if (!(0, $bA8KD.browserPerformanceTimeOrigin)) return timingSpanData;
    return [
        ...timingSpanData,
        [
            "http.request.redirect_start",
            $299480b636ad636e$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            "http.request.fetch_start",
            $299480b636ad636e$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            "http.request.domain_lookup_start",
            $299480b636ad636e$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            "http.request.domain_lookup_end",
            $299480b636ad636e$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            "http.request.connect_start",
            $299480b636ad636e$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            "http.request.secure_connection_start",
            $299480b636ad636e$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            "http.request.connection_end",
            $299480b636ad636e$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            "http.request.request_start",
            $299480b636ad636e$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            "http.request.response_start",
            $299480b636ad636e$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            "http.request.response_end",
            $299480b636ad636e$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */ function $299480b636ad636e$export$c260386ab3f0b3dd(url, tracePropagationTargets) {
    return (0, $bqiXE.stringMatchesSomePattern)(url, tracePropagationTargets || $299480b636ad636e$export$15bd0305d05ad07b);
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ // eslint-disable-next-line complexity
function $299480b636ad636e$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr && xhr[0, $dk3nq.SENTRY_XHR_DATA_KEY];
    if (!(0, $kRhVl.hasTracingEnabled)() || !xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, $3AudM.setHttpStatus)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $iKbxs.getCurrentScope)();
    const isolationScope = (0, $aFDsf.getIsolationScope)();
    const fullUrl = $299480b636ad636e$var$getFullURL(sentryXhrData.url);
    const host = fullUrl ? (0, $dBGHn.parseUrl)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, $egrOp.startInactiveSpan)({
        name: `${sentryXhrData.method} ${sentryXhrData.url}`,
        onlyIfParent: true,
        attributes: {
            type: "xhr",
            "http.method": sentryXhrData.method,
            "http.url": fullUrl,
            url: sentryXhrData.url,
            "server.address": host,
            [(0, $9t32t.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.http.browser"
        },
        op: "http.client"
    }) : undefined;
    if (span) {
        xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
        spans[xhr.__sentry_xhr_span_id__] = span;
    }
    const client = (0, $iKbxs.getClient)();
    if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url) && client) {
        const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        const sentryTraceHeader = span ? (0, $IueXx.spanToTraceHeader)(span) : (0, $MppwO.generateSentryTraceHeader)(traceId, spanId, sampled);
        const sentryBaggageHeader = (0, $2HmZY.dynamicSamplingContextToSentryBaggageHeader)(dsc || (span ? (0, $8XBHU.getDynamicSamplingContextFromSpan)(span) : (0, $8XBHU.getDynamicSamplingContextFromClient)(traceId, client, scope)));
        $299480b636ad636e$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
    }
    return span;
}
function $299480b636ad636e$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader((0, $2HmZY.BAGGAGE_HEADER_NAME), sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}
function $299480b636ad636e$var$getFullURL(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        const parsed = new URL(url, (0, $a4mdh.WINDOW).location.origin);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}

});
parcelRegister("4V7kV", function(module, exports) {

$parcel$export(module.exports, "addFetchInstrumentationHandler", function () { return $39522d2b68b79963$export$f75d3c772c923df0; });

var $8WMel = parcelRequire("8WMel");

var $f6Wg7 = parcelRequire("f6Wg7");

var $ehoTA = parcelRequire("ehoTA");

var $czuIS = parcelRequire("czuIS");
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $39522d2b68b79963$export$f75d3c772c923df0(handler) {
    const type = "fetch";
    (0, $czuIS.addHandler)(type, handler);
    (0, $czuIS.maybeInstrument)(type, $39522d2b68b79963$var$instrumentFetch);
}
function $39522d2b68b79963$var$instrumentFetch() {
    if (!(0, $f6Wg7.supportsNativeFetch)()) return;
    (0, $8WMel.fill)((0, $ehoTA.GLOBAL_OBJ), "fetch", function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $39522d2b68b79963$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            (0, $czuIS.triggerHandlers)("fetch", {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $ehoTA.GLOBAL_OBJ), args).then((response)=>{
                const finishedHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                };
                (0, $czuIS.triggerHandlers)("fetch", finishedHandlerData);
                return response;
            }, (error)=>{
                const erroredHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                };
                (0, $czuIS.triggerHandlers)("fetch", erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $39522d2b68b79963$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $39522d2b68b79963$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($39522d2b68b79963$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $39522d2b68b79963$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $39522d2b68b79963$var$getUrlFromResource(url),
            method: $39522d2b68b79963$var$hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $39522d2b68b79963$var$getUrlFromResource(arg),
        method: $39522d2b68b79963$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}

});
parcelRegister("f6Wg7", function(module, exports) {

$parcel$export(module.exports, "supportsFetch", function () { return $b0049b9761478d2b$export$edf3cb81fd7d2a3e; });
$parcel$export(module.exports, "isNativeFetch", function () { return $b0049b9761478d2b$export$18cf36ed71d733e7; });
$parcel$export(module.exports, "supportsNativeFetch", function () { return $b0049b9761478d2b$export$c82d238e23c40b21; });

var $15pqG = parcelRequire("15pqG");

var $7Dams = parcelRequire("7Dams");

var $ehoTA = parcelRequire("ehoTA");
// eslint-disable-next-line deprecation/deprecation
const $b0049b9761478d2b$var$WINDOW = (0, $ehoTA.getGlobalObject)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $b0049b9761478d2b$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $b0049b9761478d2b$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $b0049b9761478d2b$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $b0049b9761478d2b$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in $b0049b9761478d2b$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $b0049b9761478d2b$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $b0049b9761478d2b$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$b0049b9761478d2b$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($b0049b9761478d2b$export$18cf36ed71d733e7($b0049b9761478d2b$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $b0049b9761478d2b$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $b0049b9761478d2b$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $15pqG.DEBUG_BUILD) && (0, $7Dams.logger).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $b0049b9761478d2b$export$531055a6c684a70a() {
    return "ReportingObserver" in $b0049b9761478d2b$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $b0049b9761478d2b$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$b0049b9761478d2b$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}

});


parcelRegister("dk3nq", function(module, exports) {

$parcel$export(module.exports, "SENTRY_XHR_DATA_KEY", function () { return $9b2fc32e888db2fd$export$55b6bb1e45c6cf59; });
$parcel$export(module.exports, "addXhrInstrumentationHandler", function () { return $9b2fc32e888db2fd$export$26ace48dd54c9aea; });

var $l3GNb = parcelRequire("l3GNb");

var $8WMel = parcelRequire("8WMel");

var $ehoTA = parcelRequire("ehoTA");

var $czuIS = parcelRequire("czuIS");
const $9b2fc32e888db2fd$var$WINDOW = (0, $ehoTA.GLOBAL_OBJ);
const $9b2fc32e888db2fd$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $9b2fc32e888db2fd$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $czuIS.addHandler)(type, handler);
    (0, $czuIS.maybeInstrument)(type, $9b2fc32e888db2fd$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $9b2fc32e888db2fd$export$c67d533bf77cbf54() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!$9b2fc32e888db2fd$var$WINDOW.XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $8WMel.fill)(xhrproto, "open", function(originalOpen) {
        return function(...args) {
            const startTimestamp = Date.now();
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $l3GNb.isString)(args[0]) ? args[0].toUpperCase() : undefined;
            const url = $9b2fc32e888db2fd$var$parseUrl(args[1]);
            if (!method || !url) return originalOpen.apply(this, args);
            this[$9b2fc32e888db2fd$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === "POST" && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$9b2fc32e888db2fd$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        args: [
                            method,
                            url
                        ],
                        endTimestamp: Date.now(),
                        startTimestamp: startTimestamp,
                        xhr: this
                    };
                    (0, $czuIS.triggerHandlers)("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in this && typeof this.onreadystatechange === "function") (0, $8WMel.fill)(this, "onreadystatechange", function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener("readystatechange", onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $8WMel.fill)(this, "setRequestHeader", function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$9b2fc32e888db2fd$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $l3GNb.isString)(header) && (0, $l3GNb.isString)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $8WMel.fill)(xhrproto, "send", function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$9b2fc32e888db2fd$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(this, args);
            if (args[0] !== undefined) sentryXhrData.body = args[0];
            const handlerData = {
                args: [
                    sentryXhrData.method,
                    sentryXhrData.url
                ],
                startTimestamp: Date.now(),
                xhr: this
            };
            (0, $czuIS.triggerHandlers)("xhr", handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function $9b2fc32e888db2fd$var$parseUrl(url) {
    if ((0, $l3GNb.isString)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}

});

parcelRegister("45OPh", function(module, exports) {

$parcel$export(module.exports, "instrumentFetchRequest", function () { return $2faf0e111db129e5$export$6d73c62358c655be; });

var $iKbxs = parcelRequire("iKbxs");
var $8XBHU = parcelRequire("8XBHU");
var $aFDsf = parcelRequire("aFDsf");
var $kRhVl = parcelRequire("kRhVl");
var $9t32t = parcelRequire("9t32t");
var $3AudM = parcelRequire("3AudM");
var $IueXx = parcelRequire("IueXx");
var $egrOp = parcelRequire("egrOp");

var $2HmZY = parcelRequire("2HmZY");
var $MppwO = parcelRequire("MppwO");
var $l3GNb = parcelRequire("l3GNb");
var $dBGHn = parcelRequire("dBGHn");
/**
 * Create and track fetch request spans for usage in combination with `addInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $2faf0e111db129e5$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOrigin = "auto.http.browser") {
    if (!(0, $kRhVl.hasTracingEnabled)() || !handlerData.fetchData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            $2faf0e111db129e5$var$endSpan(span, handlerData);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $iKbxs.getCurrentScope)();
    const client = (0, $iKbxs.getClient)();
    const { method: method, url: url } = handlerData.fetchData;
    const fullUrl = $2faf0e111db129e5$var$getFullURL(url);
    const host = fullUrl ? (0, $dBGHn.parseUrl)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, $egrOp.startInactiveSpan)({
        name: `${method} ${url}`,
        onlyIfParent: true,
        attributes: {
            url: url,
            type: "fetch",
            "http.method": method,
            "http.url": fullUrl,
            "server.address": host,
            [(0, $9t32t.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: spanOrigin
        },
        op: "http.client"
    }) : undefined;
    if (span) {
        handlerData.fetchData.__span = span.spanContext().spanId;
        spans[span.spanContext().spanId] = span;
    }
    if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
        const request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const options = handlerData.args[1];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        options.headers = $2faf0e111db129e5$export$6717acf674206871(request, client, scope, options, span);
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function $2faf0e111db129e5$export$6717acf674206871(request, client, scope, options, requestSpan) {
    // eslint-disable-next-line deprecation/deprecation
    const span = requestSpan || scope.getSpan();
    const isolationScope = (0, $aFDsf.getIsolationScope)();
    const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
        ...isolationScope.getPropagationContext(),
        ...scope.getPropagationContext()
    };
    const sentryTraceHeader = span ? (0, $IueXx.spanToTraceHeader)(span) : (0, $MppwO.generateSentryTraceHeader)(traceId, spanId, sampled);
    const sentryBaggageHeader = (0, $2HmZY.dynamicSamplingContextToSentryBaggageHeader)(dsc || (span ? (0, $8XBHU.getDynamicSamplingContextFromSpan)(span) : (0, $8XBHU.getDynamicSamplingContextFromClient)(traceId, client, scope)));
    const headers = options.headers || (typeof Request !== "undefined" && (0, $l3GNb.isInstanceOf)(request, Request) ? request.headers : undefined);
    if (!headers) return {
        "sentry-trace": sentryTraceHeader,
        baggage: sentryBaggageHeader
    };
    else if (typeof Headers !== "undefined" && (0, $l3GNb.isInstanceOf)(headers, Headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.append("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // If the same header is appended multiple times the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.append((0, $2HmZY.BAGGAGE_HEADER_NAME), sentryBaggageHeader);
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers,
            [
                "sentry-trace",
                sentryTraceHeader
            ]
        ];
        if (sentryBaggageHeader) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            (0, $2HmZY.BAGGAGE_HEADER_NAME),
            sentryBaggageHeader
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = "baggage" in headers ? headers.baggage : undefined;
        const newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders.push(...existingBaggageHeader);
        else if (existingBaggageHeader) newBaggageHeaders.push(existingBaggageHeader);
        if (sentryBaggageHeader) newBaggageHeaders.push(sentryBaggageHeader);
        return {
            ...headers,
            "sentry-trace": sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(",") : undefined
        };
    }
}
function $2faf0e111db129e5$var$getFullURL(url) {
    try {
        const parsed = new URL(url);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}
function $2faf0e111db129e5$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        (0, $3AudM.setHttpStatus)(span, handlerData.response.status);
        const contentLength = handlerData.response && handlerData.response.headers && handlerData.response.headers.get("content-length");
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute("http.response_content_length", contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus("internal_error");
    span.end();
}

});


parcelRegister("bRSNm", function(module, exports) {

$parcel$export(module.exports, "instrumentRoutingWithDefaults", function () { return $8a3f261d087cbc29$export$86649cc09fe75143; });

var $bU1Fh = parcelRequire("bU1Fh");
var $bA8KD = parcelRequire("bA8KD");
var $7Dams = parcelRequire("7Dams");

var $036vc = parcelRequire("036vc");

var $a4mdh = parcelRequire("a4mdh");
/**
 * Default function implementing pageload and navigation transactions
 */ function $8a3f261d087cbc29$export$86649cc09fe75143(customStartTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true) {
    if (!(0, $a4mdh.WINDOW) || !(0, $a4mdh.WINDOW).location) {
        (0, $036vc.DEBUG_BUILD) && (0, $7Dams.logger).warn("Could not initialize routing instrumentation due to invalid location");
        return;
    }
    let startingUrl = (0, $a4mdh.WINDOW).location.href;
    let activeTransaction;
    if (startTransactionOnPageLoad) activeTransaction = customStartTransaction({
        name: (0, $a4mdh.WINDOW).location.pathname,
        // pageload should always start at timeOrigin (and needs to be in s, not ms)
        startTimestamp: (0, $bA8KD.browserPerformanceTimeOrigin) ? (0, $bA8KD.browserPerformanceTimeOrigin) / 1000 : undefined,
        op: "pageload",
        origin: "auto.pageload.browser",
        metadata: {
            source: "url"
        }
    });
    if (startTransactionOnLocationChange) (0, $bU1Fh.addHistoryInstrumentationHandler)(({ to: to, from: from })=>{
        /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
            startingUrl = undefined;
            return;
        }
        if (from !== to) {
            startingUrl = undefined;
            if (activeTransaction) {
                (0, $036vc.DEBUG_BUILD) && (0, $7Dams.logger).log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
                // If there's an open transaction on the scope, we need to finish it before creating an new one.
                activeTransaction.end();
            }
            activeTransaction = customStartTransaction({
                name: (0, $a4mdh.WINDOW).location.pathname,
                op: "navigation",
                origin: "auto.navigation.browser",
                metadata: {
                    source: "url"
                }
            });
        }
    });
}

});
parcelRegister("bU1Fh", function(module, exports) {

$parcel$export(module.exports, "addHistoryInstrumentationHandler", function () { return $8aa637434a3d3208$export$3f18c56c58114e75; });

var $8WMel = parcelRequire("8WMel");



var $ehoTA = parcelRequire("ehoTA");

var $eFEoM = parcelRequire("eFEoM");

var $czuIS = parcelRequire("czuIS");
const $8aa637434a3d3208$var$WINDOW = (0, $ehoTA.GLOBAL_OBJ);
let $8aa637434a3d3208$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $8aa637434a3d3208$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $czuIS.addHandler)(type, handler);
    (0, $czuIS.maybeInstrument)(type, $8aa637434a3d3208$var$instrumentHistory);
}
function $8aa637434a3d3208$var$instrumentHistory() {
    if (!(0, $eFEoM.supportsHistory)()) return;
    const oldOnPopState = $8aa637434a3d3208$var$WINDOW.onpopstate;
    $8aa637434a3d3208$var$WINDOW.onpopstate = function(...args) {
        const to = $8aa637434a3d3208$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $8aa637434a3d3208$var$lastHref;
        $8aa637434a3d3208$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $czuIS.triggerHandlers)("history", handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $8aa637434a3d3208$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $8aa637434a3d3208$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $czuIS.triggerHandlers)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $8WMel.fill)($8aa637434a3d3208$var$WINDOW.history, "pushState", historyReplacementFunction);
    (0, $8WMel.fill)($8aa637434a3d3208$var$WINDOW.history, "replaceState", historyReplacementFunction);
}

});
parcelRegister("eFEoM", function(module, exports) {

$parcel$export(module.exports, "supportsHistory", function () { return $aae43b5e353b3b3a$export$67fc34576016d6ec; });

var $ehoTA = parcelRequire("ehoTA");
// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const $aae43b5e353b3b3a$var$WINDOW = (0, $ehoTA.getGlobalObject)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $aae43b5e353b3b3a$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chromeVar = $aae43b5e353b3b3a$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = "history" in $aae43b5e353b3b3a$var$WINDOW && !!$aae43b5e353b3b3a$var$WINDOW.history.pushState && !!$aae43b5e353b3b3a$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

});




parcelRegister("eanBT", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $a504505a2b798f97$export$2cd8252107eb640b; });

var $zfJQE = parcelRequire("zfJQE");

var $9Y7uG = parcelRequire("9Y7uG");
/**
 * Inits the React SDK
 */ function $a504505a2b798f97$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $9Y7uG.applySdkMetadata)(opts, "react");
    (0, $zfJQE.init)(opts);
}

});
parcelRegister("zfJQE", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $069f7a55c6810703$export$2cd8252107eb640b; });

var $iKbxs = parcelRequire("iKbxs");
var $3H5zf = parcelRequire("3H5zf");
var $aFDsf = parcelRequire("aFDsf");
var $gN6dC = parcelRequire("gN6dC");
var $9f8dI = parcelRequire("9f8dI");
var $effBf = parcelRequire("effBf");
var $k1DIH = parcelRequire("k1DIH");

var $bU1Fh = parcelRequire("bU1Fh");
var $7Dams = parcelRequire("7Dams");
var $kmiJQ = parcelRequire("kmiJQ");
var $f6Wg7 = parcelRequire("f6Wg7");

var $k9ztZ = parcelRequire("k9ztZ");

var $h51OY = parcelRequire("h51OY");

var $6aflr = parcelRequire("6aflr");

var $45MnA = parcelRequire("45MnA");

var $2OPSd = parcelRequire("2OPSd");

var $lBMxU = parcelRequire("lBMxU");

var $kikKe = parcelRequire("kikKe");

var $6zc8S = parcelRequire("6zc8S");

var $dEVRC = parcelRequire("dEVRC");

var $c4XeL = parcelRequire("c4XeL");

var $704I4 = parcelRequire("704I4");

var $hnLUt = parcelRequire("hnLUt");
/** @deprecated Use `getDefaultIntegrations(options)` instead. */ const $069f7a55c6810703$export$5ef831fccfce35e5 = [
    (0, $effBf.inboundFiltersIntegration)(),
    (0, $3H5zf.functionToStringIntegration)(),
    (0, $dEVRC.browserApiErrorsIntegration)(),
    (0, $45MnA.breadcrumbsIntegration)(),
    (0, $lBMxU.globalHandlersIntegration)(),
    (0, $6zc8S.linkedErrorsIntegration)(),
    (0, $2OPSd.dedupeIntegration)(),
    (0, $kikKe.httpContextIntegration)()
];
/** Get the default integrations for the browser SDK. */ function $069f7a55c6810703$export$5783b2920b1d62b9(_options) {
    // We return a copy of the defaultIntegrations here to avoid mutating this
    return [
        // eslint-disable-next-line deprecation/deprecation
        ...$069f7a55c6810703$export$5ef831fccfce35e5
    ];
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $069f7a55c6810703$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $069f7a55c6810703$export$5783b2920b1d62b9();
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === "string") options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $6aflr.WINDOW).SENTRY_RELEASE && (0, $6aflr.WINDOW).SENTRY_RELEASE.id) options.release = (0, $6aflr.WINDOW).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $kmiJQ.stackParserFromStackParserOptions)(options.stackParser || (0, $c4XeL.defaultStackParser)),
        integrations: (0, $gN6dC.getIntegrationsToSetup)(options),
        transport: options.transport || ((0, $f6Wg7.supportsFetch)() ? (0, $704I4.makeFetchTransport) : (0, $hnLUt.makeXHRTransport))
    };
    (0, $k1DIH.initAndBind)((0, $k9ztZ.BrowserClient), clientOptions);
    if (options.autoSessionTracking) $069f7a55c6810703$var$startSessionTracking();
}
const $069f7a55c6810703$export$3a8fd680da42627b = (// eslint-disable-next-line deprecation/deprecation
options = {}, // eslint-disable-next-line deprecation/deprecation
hub = (0, $aFDsf.getCurrentHub)())=>{
    // doesn't work without a document (React Native)
    if (!(0, $6aflr.WINDOW).document) {
        (0, $h51OY.DEBUG_BUILD) && (0, $7Dams.logger).error("Global document not defined in showReportDialog call");
        return;
    }
    // eslint-disable-next-line deprecation/deprecation
    const { client: client, scope: scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (0, $h51OY.DEBUG_BUILD) && (0, $7Dams.logger).error("DSN not configured for showReportDialog call");
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) // eslint-disable-next-line deprecation/deprecation
    options.eventId = hub.lastEventId();
    const script = (0, $6aflr.WINDOW).document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = (0, $9f8dI.getReportDialogEndpoint)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === "__sentry_reportdialog_closed__") try {
                onClose();
            } finally{
                (0, $6aflr.WINDOW).removeEventListener("message", reportDialogClosedMessageHandler);
            }
        };
        (0, $6aflr.WINDOW).addEventListener("message", reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $6aflr.WINDOW).document.head || (0, $6aflr.WINDOW).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $h51OY.DEBUG_BUILD) && (0, $7Dams.logger).error("Not injecting report dialog. No injection point found in HTML");
};
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $069f7a55c6810703$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $069f7a55c6810703$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $069f7a55c6810703$export$4997ffc0176396a6(fn) {
    return (0, $6aflr.wrap)(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $069f7a55c6810703$var$startSessionTracking() {
    if (typeof (0, $6aflr.WINDOW).document === "undefined") {
        (0, $h51OY.DEBUG_BUILD) && (0, $7Dams.logger).warn("Session tracking in non-browser environment with @sentry/browser is not supported.");
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $iKbxs.startSession)({
        ignoreDuration: true
    });
    (0, $iKbxs.captureSession)();
    // We want to create a session for every navigation as well
    (0, $bU1Fh.addHistoryInstrumentationHandler)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $iKbxs.startSession)({
                ignoreDuration: true
            });
            (0, $iKbxs.captureSession)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $069f7a55c6810703$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $iKbxs.getClient)();
    if (client) client.captureUserFeedback(feedback);
}

});
parcelRegister("3H5zf", function(module, exports) {

$parcel$export(module.exports, "functionToStringIntegration", function () { return $2b09b4d258553dba$export$7918117e9202e4fb; });
$parcel$export(module.exports, "FunctionToString", function () { return $2b09b4d258553dba$export$da4704525c20ae79; });

var $8WMel = parcelRequire("8WMel");

var $iKbxs = parcelRequire("iKbxs");

var $gN6dC = parcelRequire("gN6dC");
let $2b09b4d258553dba$var$originalFunctionToString;
const $2b09b4d258553dba$var$INTEGRATION_NAME = "FunctionToString";
const $2b09b4d258553dba$var$SETUP_CLIENTS = new WeakMap();
const $2b09b4d258553dba$var$_functionToStringIntegration = ()=>{
    return {
        name: $2b09b4d258553dba$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $2b09b4d258553dba$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $8WMel.getOriginalFunction)(this);
                    const context = $2b09b4d258553dba$var$SETUP_CLIENTS.has((0, $iKbxs.getClient)()) && originalFunction !== undefined ? originalFunction : this;
                    return $2b09b4d258553dba$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $2b09b4d258553dba$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $2b09b4d258553dba$export$7918117e9202e4fb = (0, $gN6dC.defineIntegration)($2b09b4d258553dba$var$_functionToStringIntegration);
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * @deprecated Use `functionToStringIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $2b09b4d258553dba$export$da4704525c20ae79 = (0, $gN6dC.convertIntegrationFnToClass)($2b09b4d258553dba$var$INTEGRATION_NAME, $2b09b4d258553dba$export$7918117e9202e4fb);

});
parcelRegister("gN6dC", function(module, exports) {

$parcel$export(module.exports, "getIntegrationsToSetup", function () { return $c3960bdc9987cc32$export$68bc4c01ab8ae766; });
$parcel$export(module.exports, "setupIntegrations", function () { return $c3960bdc9987cc32$export$51abed9797baa598; });
$parcel$export(module.exports, "setupIntegration", function () { return $c3960bdc9987cc32$export$e7390a03b70a6f2f; });
$parcel$export(module.exports, "afterSetupIntegrations", function () { return $c3960bdc9987cc32$export$35abcfd71227c6ca; });
$parcel$export(module.exports, "convertIntegrationFnToClass", function () { return $c3960bdc9987cc32$export$afa219bf23651160; });
$parcel$export(module.exports, "defineIntegration", function () { return $c3960bdc9987cc32$export$2323046b9414659f; });

var $4zH9l = parcelRequire("4zH9l");
var $7Dams = parcelRequire("7Dams");

var $3JSHc = parcelRequire("3JSHc");

var $7jAkK = parcelRequire("7jAkK");

var $iKbxs = parcelRequire("iKbxs");

var $aFDsf = parcelRequire("aFDsf");
const $c3960bdc9987cc32$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $c3960bdc9987cc32$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $c3960bdc9987cc32$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") integrations = (0, $4zH9l.arrayify)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $c3960bdc9987cc32$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $c3960bdc9987cc32$var$findIndex(finalIntegrations, (integration)=>integration.name === "Debug");
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $c3960bdc9987cc32$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $c3960bdc9987cc32$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $c3960bdc9987cc32$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $c3960bdc9987cc32$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($c3960bdc9987cc32$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        // eslint-disable-next-line deprecation/deprecation
        integration.setupOnce((0, $7jAkK.addGlobalEventProcessor), (0, $aFDsf.getCurrentHub));
        $c3960bdc9987cc32$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (client.on && typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (client.addEventProcessor && typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current hub's client. */ function $c3960bdc9987cc32$export$2d8f5188773bcddd(integration) {
    const client = (0, $iKbxs.getClient)();
    if (!client || !client.addIntegration) {
        (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $c3960bdc9987cc32$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}
/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */ function $c3960bdc9987cc32$export$afa219bf23651160(name, fn) {
    return Object.assign(function ConvertedIntegration(...args) {
        return fn(...args);
    }, {
        id: name
    });
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $c3960bdc9987cc32$export$2323046b9414659f(fn) {
    return fn;
}

});


parcelRegister("9f8dI", function(module, exports) {

$parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", function () { return $6babe41d840c9055$export$9964600bfe84e6a3; });
$parcel$export(module.exports, "getReportDialogEndpoint", function () { return $6babe41d840c9055$export$671c7ed8e40a7a57; });

var $52ZCk = parcelRequire("52ZCk");
var $8WMel = parcelRequire("8WMel");
const $6babe41d840c9055$var$SENTRY_API_VERSION = "7";
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $6babe41d840c9055$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $6babe41d840c9055$var$_getIngestEndpoint(dsn) {
    return `${$6babe41d840c9055$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $6babe41d840c9055$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $8WMel.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $6babe41d840c9055$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $6babe41d840c9055$export$9964600bfe84e6a3(dsn, // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
// options: ClientOptions = {} as ClientOptions,
tunnelOrOptions = {}) {
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    const tunnel = typeof tunnelOrOptions === "string" ? tunnelOrOptions : tunnelOrOptions.tunnel;
    const sdkInfo = typeof tunnelOrOptions === "string" || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${$6babe41d840c9055$var$_getIngestEndpoint(dsn)}?${$6babe41d840c9055$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $6babe41d840c9055$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $52ZCk.makeDsn)(dsnLike);
    if (!dsn) return "";
    const endpoint = `${$6babe41d840c9055$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $52ZCk.dsnToString)(dsn)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}

});

parcelRegister("effBf", function(module, exports) {

$parcel$export(module.exports, "inboundFiltersIntegration", function () { return $a5ee9132a24bfe63$export$cb3c5c2ceb9818ba; });
$parcel$export(module.exports, "InboundFilters", function () { return $a5ee9132a24bfe63$export$2ffbb5359dcc6be4; });

var $4zH9l = parcelRequire("4zH9l");
var $7Dams = parcelRequire("7Dams");
var $bqiXE = parcelRequire("bqiXE");

var $3JSHc = parcelRequire("3JSHc");

var $gN6dC = parcelRequire("gN6dC");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $a5ee9132a24bfe63$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/
];
const $a5ee9132a24bfe63$var$DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*\/healthcheck$/,
    /^.*\/healthy$/,
    /^.*\/live$/,
    /^.*\/ready$/,
    /^.*\/heartbeat$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
/** Options for the InboundFilters integration */ const $a5ee9132a24bfe63$var$INTEGRATION_NAME = "InboundFilters";
const $a5ee9132a24bfe63$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $a5ee9132a24bfe63$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $a5ee9132a24bfe63$var$_mergeOptions(options, clientOptions);
            return $a5ee9132a24bfe63$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $a5ee9132a24bfe63$export$cb3c5c2ceb9818ba = (0, $gN6dC.defineIntegration)($a5ee9132a24bfe63$var$_inboundFiltersIntegration);
/**
 * Inbound filters configurable by the user.
 * @deprecated Use `inboundFiltersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $a5ee9132a24bfe63$export$2ffbb5359dcc6be4 = (0, $gN6dC.convertIntegrationFnToClass)($a5ee9132a24bfe63$var$INTEGRATION_NAME, $a5ee9132a24bfe63$export$cb3c5c2ceb9818ba);
function $a5ee9132a24bfe63$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $a5ee9132a24bfe63$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || [],
            ...internalOptions.disableTransactionDefaults ? [] : $a5ee9132a24bfe63$var$DEFAULT_IGNORE_TRANSACTIONS
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $a5ee9132a24bfe63$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $a5ee9132a24bfe63$var$_isSentryError(event)) {
        (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $4zH9l.getEventDescription)(event)}`);
        return true;
    }
    if ($a5ee9132a24bfe63$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $4zH9l.getEventDescription)(event)}`);
        return true;
    }
    if ($a5ee9132a24bfe63$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $4zH9l.getEventDescription)(event)}`);
        return true;
    }
    if ($a5ee9132a24bfe63$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $4zH9l.getEventDescription)(event)}.\nUrl: ${$a5ee9132a24bfe63$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$a5ee9132a24bfe63$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $4zH9l.getEventDescription)(event)}.\nUrl: ${$a5ee9132a24bfe63$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $a5ee9132a24bfe63$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $a5ee9132a24bfe63$var$_getPossibleEventMessages(event).some((message)=>(0, $bqiXE.stringMatchesSomePattern)(message, ignoreErrors));
}
function $a5ee9132a24bfe63$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== "transaction" || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $bqiXE.stringMatchesSomePattern)(name, ignoreTransactions) : false;
}
function $a5ee9132a24bfe63$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $a5ee9132a24bfe63$var$_getEventFilterUrl(event);
    return !url ? false : (0, $bqiXE.stringMatchesSomePattern)(url, denyUrls);
}
function $a5ee9132a24bfe63$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $a5ee9132a24bfe63$var$_getEventFilterUrl(event);
    return !url ? true : (0, $bqiXE.stringMatchesSomePattern)(url, allowUrls);
}
function $a5ee9132a24bfe63$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    if ((0, $3JSHc.DEBUG_BUILD) && possibleMessages.length === 0) (0, $7Dams.logger).error(`Could not extract message for event ${(0, $4zH9l.getEventDescription)(event)}`);
    return possibleMessages;
}
function $a5ee9132a24bfe63$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === "SentryError";
    } catch (e) {
    // ignore
    }
    return false;
}
function $a5ee9132a24bfe63$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $a5ee9132a24bfe63$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $a5ee9132a24bfe63$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).error(`Cannot extract url for event ${(0, $4zH9l.getEventDescription)(event)}`);
        return null;
    }
}

});

parcelRegister("k1DIH", function(module, exports) {

$parcel$export(module.exports, "initAndBind", function () { return $e942b630fbdceafb$export$5333c3f1c58d9bc1; });

var $7Dams = parcelRequire("7Dams");

var $3JSHc = parcelRequire("3JSHc");

var $iKbxs = parcelRequire("iKbxs");

var $aFDsf = parcelRequire("aFDsf");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $e942b630fbdceafb$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $3JSHc.DEBUG_BUILD) (0, $7Dams.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $7Dams.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = (0, $iKbxs.getCurrentScope)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $e942b630fbdceafb$export$ecb76f41d43c0e43(client);
    $e942b630fbdceafb$var$initializeClient(client);
}
/**
 * Make the given client the current client.
 */ function $e942b630fbdceafb$export$ecb76f41d43c0e43(client) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $aFDsf.getCurrentHub)();
    // eslint-disable-next-line deprecation/deprecation
    const top = hub.getStackTop();
    top.client = client;
    top.scope.setClient(client);
}
/**
 * Initialize the client for the current scope.
 * Make sure to call this after `setCurrentClient()`.
 */ function $e942b630fbdceafb$var$initializeClient(client) {
    if (client.init) client.init();
    else if (client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
    client.setupIntegrations();
}

});

parcelRegister("k9ztZ", function(module, exports) {

$parcel$export(module.exports, "BrowserClient", function () { return $eac02c07102789fc$export$1df9218a526d318d; });

var $9Y7uG = parcelRequire("9Y7uG");
var $kp047 = parcelRequire("kp047");

var $as2fz = parcelRequire("as2fz");
var $52ZCk = parcelRequire("52ZCk");
var $2vNMs = parcelRequire("2vNMs");
var $7Dams = parcelRequire("7Dams");

var $h51OY = parcelRequire("h51OY");

var $f7o7A = parcelRequire("f7o7A");

var $6aflr = parcelRequire("6aflr");

var $7reY3 = parcelRequire("7reY3");
/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $eac02c07102789fc$export$1df9218a526d318d extends (0, $kp047.BaseClient) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $6aflr.WINDOW).SENTRY_SDK_SOURCE || (0, $2vNMs.getSDKSource)();
        (0, $9Y7uG.applySdkMetadata)(options, "browser", [
            "browser"
        ], sdkSource);
        super(options);
        if (options.sendClientReports && (0, $6aflr.WINDOW).document) (0, $6aflr.WINDOW).document.addEventListener("visibilitychange", ()=>{
            if ((0, $6aflr.WINDOW).document.visibilityState === "hidden") this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $f7o7A.eventFromException)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = "info", hint) {
        return (0, $f7o7A.eventFromMessage)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $h51OY.DEBUG_BUILD) && (0, $7Dams.logger).warn("SDK not enabled, will not capture user feedback.");
            return;
        }
        const envelope = (0, $7reY3.createUserFeedbackEnvelope)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $h51OY.DEBUG_BUILD) && (0, $7Dams.logger).log("No outcomes to send");
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $h51OY.DEBUG_BUILD) && (0, $7Dams.logger).log("No dsn provided, will not send outcomes");
            return;
        }
        (0, $h51OY.DEBUG_BUILD) && (0, $7Dams.logger).log("Sending outcomes:", outcomes);
        const envelope = (0, $as2fz.createClientReportEnvelope)(outcomes, this._options.tunnel && (0, $52ZCk.dsnToString)(this._dsn));
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
}

});
parcelRegister("9Y7uG", function(module, exports) {

$parcel$export(module.exports, "applySdkMetadata", function () { return $741f87cb5c97c040$export$b9f95b027256052c; });

var $dUT9Y = parcelRequire("dUT9Y");
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $741f87cb5c97c040$export$b9f95b027256052c(options, name, names = [
    name
], source = "npm") {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $dUT9Y.SDK_VERSION)
            })),
        version: (0, $dUT9Y.SDK_VERSION)
    };
    options._metadata = metadata;
}

});

parcelRegister("kp047", function(module, exports) {

$parcel$export(module.exports, "BaseClient", function () { return $eda6316fedd64d65$export$4f22f74eddb7716a; });
$parcel$export(module.exports, "addEventProcessor", function () { return $eda6316fedd64d65$export$9aac0b9f77928fbf; });

var $dp1Mp = parcelRequire("dp1Mp");
var $4zH9l = parcelRequire("4zH9l");
var $l3GNb = parcelRequire("l3GNb");
var $7Dams = parcelRequire("7Dams");
var $52ZCk = parcelRequire("52ZCk");
var $goLCC = parcelRequire("goLCC");
var $3nRVL = parcelRequire("3nRVL");

var $9f8dI = parcelRequire("9f8dI");

var $3JSHc = parcelRequire("3JSHc");

var $gUsOI = parcelRequire("gUsOI");

var $iKbxs = parcelRequire("iKbxs");

var $aFDsf = parcelRequire("aFDsf");

var $gN6dC = parcelRequire("gN6dC");

var $2PGM7 = parcelRequire("2PGM7");

var $lGtB9 = parcelRequire("lGtB9");

var $8XBHU = parcelRequire("8XBHU");

var $1M1wc = parcelRequire("1M1wc");
const $eda6316fedd64d65$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $eda6316fedd64d65$export$4f22f74eddb7716a {
    /**
   * A reference to a metrics aggregator
   *
   * @experimental Note this is alpha API. It may experience breaking changes in the future.
   */ /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Indicates whether this client's integrations have been set up. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $52ZCk.makeDsn)(options.dsn);
        else (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = (0, $9f8dI.getEnvelopeEndpointWithUrlEncodedAuth)(this._dsn, options);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint, scope) {
        // ensure we haven't captured this very object before
        if ((0, $4zH9l.checkOrSetAlreadyCaught)(exception)) {
            (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).log($eda6316fedd64d65$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this.eventFromException(exception, hint).then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint, scope) {
        let eventId = hint && hint.event_id;
        const eventMessage = (0, $l3GNb.isParameterizedString)(message) ? message : String(message);
        const promisedEvent = (0, $l3GNb.isPrimitive)(message) ? this.eventFromMessage(eventMessage, level, hint) : this.eventFromException(message, hint);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $4zH9l.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).log($eda6316fedd64d65$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hint, capturedSpanScope || scope).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === "string")) (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).warn("Discarded session because of missing or non-string release");
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $lGtB9.updateSession)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            if (this.metricsAggregator) this.metricsAggregator.flush();
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $goLCC.resolvedSyncPromise)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            if (this.metricsAggregator) this.metricsAggregator.close();
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */ setupIntegrations(forceInitialize) {
        if (forceInitialize && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) this._setupIntegrations();
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled()) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegrationById(integrationId) {
        return this.getIntegrationByName(integrationId);
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegration(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $gN6dC.setupIntegration)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $gN6dC.afterSetupIntegrations)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        let env = (0, $gUsOI.createEventEnvelope)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $dp1Mp.addItemToEnvelope)(env, (0, $dp1Mp.createAttachmentEnvelopeItem)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
        const promise = this._sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $gUsOI.createSessionEnvelope)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, eventOrCount) {
        if (this._options.sendClientReports) {
            // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
            // If event is passed as third argument, we assume this is a count of 1
            const count = typeof eventOrCount === "number" ? eventOrCount : 1;
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ""}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /**
   * @inheritDoc
   */ captureAggregateMetrics(metricBucketItems) {
        (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).log(`Flushing aggregated metrics, number of metrics: ${metricBucketItems.length}`);
        const metricsEnvelope = (0, $2PGM7.createMetricEnvelope)(metricBucketItems, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(metricsEnvelope);
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-expect-error We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $gN6dC.setupIntegrations)(this, integrations);
        (0, $gN6dC.afterSetupIntegrations)(this, integrations);
        // TODO v8: We don't need this flag anymore
        this._integrationsInitialized = true;
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $lGtB9.updateSession)(session, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $goLCC.SyncPromise)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, scope, isolationScope = (0, $aFDsf.getIsolationScope)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        return (0, $1M1wc.prepareEvent)(options, event, hint, scope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            const propagationContext = {
                ...isolationScope.getPropagationContext(),
                ...scope ? scope.getPropagationContext() : undefined
            };
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: {
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    },
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $8XBHU.getDynamicSamplingContextFromClient)(trace_id, this, scope);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $3JSHc.DEBUG_BUILD) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === "log") (0, $7Dams.logger).log(sentryError.message);
                else (0, $7Dams.logger).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, scope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $eda6316fedd64d65$var$isTransactionEvent(event);
        const isError = $eda6316fedd64d65$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (isError && typeof sampleRate === "number" && Math.random() > sampleRate) {
            this.recordDroppedEvent("sample_rate", "error", event);
            return (0, $goLCC.rejectedSyncPromise)(new (0, $3nRVL.SentryError)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, "log"));
        }
        const dataCategory = eventType === "replay_event" ? "replay" : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, scope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory, event);
                throw new (0, $3nRVL.SentryError)("An event processor returned `null`, will not send event.", "log");
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $eda6316fedd64d65$var$processBeforeSend(options, prepared, hint);
            return $eda6316fedd64d65$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory, event);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent("before_send", "span", spanCount);
                }
                throw new (0, $3nRVL.SentryError)(`${beforeSendLabel} returned \`null\`, will not send event.`, "log");
            }
            const session = scope && scope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent("before_send", "span", droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $3nRVL.SentryError)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $3nRVL.SentryError)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * @inheritdoc
   */ _sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).error("Error while sending event:", reason);
        });
        else (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).error("Transport disabled");
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $eda6316fedd64d65$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $l3GNb.isThenable)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $l3GNb.isPlainObject)(event) && event !== null) throw new (0, $3nRVL.SentryError)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $3nRVL.SentryError)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $l3GNb.isPlainObject)(beforeSendResult) && beforeSendResult !== null) throw new (0, $3nRVL.SentryError)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $eda6316fedd64d65$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction } = options;
    if ($eda6316fedd64d65$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($eda6316fedd64d65$var$isTransactionEvent(event) && beforeSendTransaction) {
        if (event.spans) {
            // We store the # of spans before processing in SDK metadata,
            // so we can compare it afterwards to determine how many spans were dropped
            const spanCountBefore = event.spans.length;
            event.sdkProcessingMetadata = {
                ...event.sdkProcessingMetadata,
                spanCountBeforeProcessing: spanCountBefore
            };
        }
        return beforeSendTransaction(event, hint);
    }
    return event;
}
function $eda6316fedd64d65$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $eda6316fedd64d65$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */ function $eda6316fedd64d65$export$9aac0b9f77928fbf(callback) {
    const client = (0, $iKbxs.getClient)();
    if (!client || !client.addEventProcessor) return;
    client.addEventProcessor(callback);
}

});
parcelRegister("3nRVL", function(module, exports) {

$parcel$export(module.exports, "SentryError", function () { return $276d5a99ec5685d3$export$5949942ba2a7c0e2; });
/** An error emitted by Sentry SDKs and related utilities. */ class $276d5a99ec5685d3$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}

});

parcelRegister("gUsOI", function(module, exports) {

$parcel$export(module.exports, "createSessionEnvelope", function () { return $c4f83ac1106f5162$export$124b03c077baa2f3; });
$parcel$export(module.exports, "createEventEnvelope", function () { return $c4f83ac1106f5162$export$c31057337a18010f; });

var $dp1Mp = parcelRequire("dp1Mp");
var $52ZCk = parcelRequire("52ZCk");
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $c4f83ac1106f5162$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $c4f83ac1106f5162$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $dp1Mp.getSdkMetadataForEnvelopeHeader)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $52ZCk.dsnToString)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $dp1Mp.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $c4f83ac1106f5162$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $dp1Mp.getSdkMetadataForEnvelopeHeader)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $c4f83ac1106f5162$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $dp1Mp.createEventEnvelopeHeaders)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $dp1Mp.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}

});

parcelRegister("2PGM7", function(module, exports) {

$parcel$export(module.exports, "createMetricEnvelope", function () { return $21018672d4637ee9$export$f23eb96e33154901; });

var $dp1Mp = parcelRequire("dp1Mp");
var $52ZCk = parcelRequire("52ZCk");

var $1snMp = parcelRequire("1snMp");
/**
 * Create envelope from a metric aggregate.
 */ function $21018672d4637ee9$export$f23eb96e33154901(metricBucketItems, dsn, metadata, tunnel) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata && metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && dsn) headers.dsn = (0, $52ZCk.dsnToString)(dsn);
    const item = $21018672d4637ee9$var$createMetricEnvelopeItem(metricBucketItems);
    return (0, $dp1Mp.createEnvelope)(headers, [
        item
    ]);
}
function $21018672d4637ee9$var$createMetricEnvelopeItem(metricBucketItems) {
    const payload = (0, $1snMp.serializeMetricBuckets)(metricBucketItems);
    const metricHeaders = {
        type: "statsd",
        length: payload.length
    };
    return [
        metricHeaders,
        payload
    ];
}

});
parcelRegister("1snMp", function(module, exports) {

$parcel$export(module.exports, "serializeMetricBuckets", function () { return $10fada2769a32151$export$66decd709db01dc8; });

var $8WMel = parcelRequire("8WMel");
/**
 * Generate bucket key from metric properties.
 */ function $10fada2769a32151$export$b8bd8c4dffa5aa2d(metricType, name, unit, tags) {
    const stringifiedTags = Object.entries((0, $8WMel.dropUndefinedKeys)(tags)).sort((a, b)=>a[0].localeCompare(b[0]));
    return `${metricType}${name}${unit}${stringifiedTags}`;
}
/* eslint-disable no-bitwise */ /**
 * Simple hash function for strings.
 */ function $10fada2769a32151$export$b211ce59c0ea1cfb(s) {
    let rv = 0;
    for(let i = 0; i < s.length; i++){
        const c = s.charCodeAt(i);
        rv = (rv << 5) - rv + c;
        rv &= rv;
    }
    return rv >>> 0;
}
/* eslint-enable no-bitwise */ /**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */ function $10fada2769a32151$export$66decd709db01dc8(metricBucketItems) {
    let out = "";
    for (const item of metricBucketItems){
        const tagEntries = Object.entries(item.tags);
        const maybeTags = tagEntries.length > 0 ? `|#${tagEntries.map(([key, value])=>`${key}:${value}`).join(",")}` : "";
        out += `${item.name}@${item.unit}:${item.metric}|${item.metricType}${maybeTags}|T${item.timestamp}\n`;
    }
    return out;
}
/** Sanitizes units */ function $10fada2769a32151$export$2d8c9911396bbf5f(unit) {
    return unit.replace(/[^\w]+/gi, "_");
}
/** Sanitizes metric keys */ function $10fada2769a32151$export$d3b3167f2ebbcecc(key) {
    return key.replace(/[^\w\-.]+/gi, "_");
}
function $10fada2769a32151$var$sanitizeTagKey(key) {
    return key.replace(/[^\w\-./]+/gi, "");
}
const $10fada2769a32151$var$tagValueReplacements = [
    [
        "\n",
        "\\n"
    ],
    [
        "\r",
        "\\r"
    ],
    [
        "	",
        "\\t"
    ],
    [
        "\\",
        "\\\\"
    ],
    [
        "|",
        "\\u{7c}"
    ],
    [
        ",",
        "\\u{2c}"
    ]
];
function $10fada2769a32151$var$getCharOrReplacement(input) {
    for (const [search, replacement] of $10fada2769a32151$var$tagValueReplacements){
        if (input === search) return replacement;
    }
    return input;
}
function $10fada2769a32151$var$sanitizeTagValue(value) {
    return [
        ...value
    ].reduce((acc, char)=>acc + $10fada2769a32151$var$getCharOrReplacement(char), "");
}
/**
 * Sanitizes tags.
 */ function $10fada2769a32151$export$ae49af12dbdf2477(unsanitizedTags) {
    const tags = {};
    for(const key in unsanitizedTags)if (Object.prototype.hasOwnProperty.call(unsanitizedTags, key)) {
        const sanitizedKey = $10fada2769a32151$var$sanitizeTagKey(key);
        tags[sanitizedKey] = $10fada2769a32151$var$sanitizeTagValue(String(unsanitizedTags[key]));
    }
    return tags;
}

});



parcelRegister("as2fz", function(module, exports) {

$parcel$export(module.exports, "createClientReportEnvelope", function () { return $79be43bca4c3446a$export$f3b9ed77c03eeb00; });

var $dp1Mp = parcelRequire("dp1Mp");

var $bA8KD = parcelRequire("bA8KD");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $79be43bca4c3446a$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $bA8KD.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $dp1Mp.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

});

parcelRegister("h51OY", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $c6f450ee08741fdd$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $c6f450ee08741fdd$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});

parcelRegister("f7o7A", function(module, exports) {

$parcel$export(module.exports, "exceptionFromError", function () { return $b01a3874c53fe9a2$export$a6c2d27607295951; });
$parcel$export(module.exports, "eventFromException", function () { return $b01a3874c53fe9a2$export$ea3ec7e569b823fc; });
$parcel$export(module.exports, "eventFromUnknownInput", function () { return $b01a3874c53fe9a2$export$9dd56ed1ef0c3420; });
$parcel$export(module.exports, "eventFromMessage", function () { return $b01a3874c53fe9a2$export$5425b53185d13d6c; });

var $iKbxs = parcelRequire("iKbxs");

var $4zH9l = parcelRequire("4zH9l");
var $8WMel = parcelRequire("8WMel");
var $l3GNb = parcelRequire("l3GNb");
var $6l9XD = parcelRequire("6l9XD");
var $goLCC = parcelRequire("goLCC");
/**
 * This function creates an exception from a JavaScript Error
 */ function $b01a3874c53fe9a2$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $b01a3874c53fe9a2$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $b01a3874c53fe9a2$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
/**
 * @hidden
 */ function $b01a3874c53fe9a2$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $iKbxs.getClient)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $l3GNb.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $b01a3874c53fe9a2$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, $6l9XD.normalizeToSize)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $b01a3874c53fe9a2$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $b01a3874c53fe9a2$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $b01a3874c53fe9a2$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $b01a3874c53fe9a2$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || "";
    const popSize = $b01a3874c53fe9a2$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $b01a3874c53fe9a2$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $b01a3874c53fe9a2$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === "number") return ex.framesToPop;
        if ($b01a3874c53fe9a2$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $b01a3874c53fe9a2$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $b01a3874c53fe9a2$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $b01a3874c53fe9a2$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $4zH9l.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = "error";
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $goLCC.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $b01a3874c53fe9a2$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = "info", hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $b01a3874c53fe9a2$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $goLCC.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function $b01a3874c53fe9a2$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $l3GNb.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $b01a3874c53fe9a2$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $l3GNb.isDOMError)(exception) || (0, $l3GNb.isDOMException)(exception)) {
        const domException = exception;
        if ("stack" in exception) event = $b01a3874c53fe9a2$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $l3GNb.isDOMError)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $b01a3874c53fe9a2$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $4zH9l.addExceptionTypeValue)(event, message);
        }
        if ("code" in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $l3GNb.isError)(exception)) // we have a real Error object, do nothing
    return $b01a3874c53fe9a2$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $l3GNb.isPlainObject)(exception) || (0, $l3GNb.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $b01a3874c53fe9a2$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $4zH9l.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $b01a3874c53fe9a2$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $4zH9l.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, $4zH9l.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $b01a3874c53fe9a2$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $b01a3874c53fe9a2$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $l3GNb.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $b01a3874c53fe9a2$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $8WMel.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $l3GNb.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $l3GNb.isEvent)(exception)) {
        const className = $b01a3874c53fe9a2$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $b01a3874c53fe9a2$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}

});

parcelRegister("6aflr", function(module, exports) {

$parcel$export(module.exports, "WINDOW", function () { return $47cf94655021cb09$export$56d8a8a25bd48b81; });
$parcel$export(module.exports, "shouldIgnoreOnError", function () { return $47cf94655021cb09$export$b79738ab10c590b2; });
$parcel$export(module.exports, "wrap", function () { return $47cf94655021cb09$export$4997ffc0176396a6; });


var $iKbxs = parcelRequire("iKbxs");

var $4zH9l = parcelRequire("4zH9l");
var $8WMel = parcelRequire("8WMel");
var $ehoTA = parcelRequire("ehoTA");
const $47cf94655021cb09$export$56d8a8a25bd48b81 = (0, $ehoTA.GLOBAL_OBJ);
let $47cf94655021cb09$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $47cf94655021cb09$export$b79738ab10c590b2() {
    return $47cf94655021cb09$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $47cf94655021cb09$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $47cf94655021cb09$var$ignoreOnError++;
    setTimeout(()=>{
        $47cf94655021cb09$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $47cf94655021cb09$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== "function") return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === "function") return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $8WMel.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === "function") before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$47cf94655021cb09$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $47cf94655021cb09$export$1265a142ff5ba165();
            (0, $iKbxs.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $4zH9l.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $4zH9l.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $iKbxs.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $8WMel.markFunctionWrapped)(sentryWrapped, fn);
    (0, $8WMel.addNonEnumerableProperty)(fn, "__sentry_wrapped__", sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}

});

parcelRegister("7reY3", function(module, exports) {

$parcel$export(module.exports, "createUserFeedbackEnvelope", function () { return $56a6aa4206033516$export$24a4dfcb686ee5bf; });

var $dp1Mp = parcelRequire("dp1Mp");
var $52ZCk = parcelRequire("52ZCk");
/**
 * Creates an envelope from a user feedback.
 */ function $56a6aa4206033516$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $52ZCk.dsnToString)(dsn)
        }
    };
    const item = $56a6aa4206033516$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $dp1Mp.createEnvelope)(headers, [
        item
    ]);
}
function $56a6aa4206033516$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: "user_report"
    };
    return [
        feedbackHeaders,
        feedback
    ];
}

});


parcelRegister("45MnA", function(module, exports) {

$parcel$export(module.exports, "breadcrumbsIntegration", function () { return $2fad282ea967d3b7$export$c079d904b326663a; });

var $iKbxs = parcelRequire("iKbxs");
var $gN6dC = parcelRequire("gN6dC");

var $gPoCM = parcelRequire("gPoCM");
var $kd8lN = parcelRequire("kd8lN");
var $4V7kV = parcelRequire("4V7kV");
var $bU1Fh = parcelRequire("bU1Fh");
var $dk3nq = parcelRequire("dk3nq");
var $db3mB = parcelRequire("db3mB");
var $4zH9l = parcelRequire("4zH9l");
var $7Dams = parcelRequire("7Dams");
var $dBGHn = parcelRequire("dBGHn");
var $bqiXE = parcelRequire("bqiXE");
var $dSesE = parcelRequire("dSesE");

var $h51OY = parcelRequire("h51OY");

var $6aflr = parcelRequire("6aflr");
/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $2fad282ea967d3b7$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $2fad282ea967d3b7$var$INTEGRATION_NAME = "Breadcrumbs";
const $2fad282ea967d3b7$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $2fad282ea967d3b7$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (_options.console) (0, $kd8lN.addConsoleInstrumentationHandler)($2fad282ea967d3b7$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $gPoCM.addClickKeypressInstrumentationHandler)($2fad282ea967d3b7$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $dk3nq.addXhrInstrumentationHandler)($2fad282ea967d3b7$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $4V7kV.addFetchInstrumentationHandler)($2fad282ea967d3b7$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $bU1Fh.addHistoryInstrumentationHandler)($2fad282ea967d3b7$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry && client.on) client.on("beforeSendEvent", $2fad282ea967d3b7$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $2fad282ea967d3b7$export$c079d904b326663a = (0, $gN6dC.defineIntegration)($2fad282ea967d3b7$var$_breadcrumbsIntegration);
/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $2fad282ea967d3b7$export$2dc68d50d56fbbd = (0, $gN6dC.convertIntegrationFnToClass)($2fad282ea967d3b7$var$INTEGRATION_NAME, $2fad282ea967d3b7$export$c079d904b326663a);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $2fad282ea967d3b7$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $iKbxs.getClient)() !== client) return;
        (0, $iKbxs.addBreadcrumb)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $4zH9l.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $2fad282ea967d3b7$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $iKbxs.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $2fad282ea967d3b7$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $h51OY.DEBUG_BUILD) && (0, $7Dams.logger).warn(`\`dom.maxStringLength\` cannot exceed ${$2fad282ea967d3b7$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$2fad282ea967d3b7$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $2fad282ea967d3b7$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $2fad282ea967d3b7$var$_isEvent(event) ? event.target : event;
            target = (0, $db3mB.htmlTreeAsString)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $db3mB.getComponentName)(element);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $iKbxs.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $2fad282ea967d3b7$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $iKbxs.getClient)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $dSesE.severityLevelFromString)(handlerData.level),
            message: (0, $bqiXE.safeJoin)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $bqiXE.safeJoin)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $iKbxs.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $2fad282ea967d3b7$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $iKbxs.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $dk3nq.SENTRY_XHR_DATA_KEY];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $iKbxs.addBreadcrumb)({
            category: "xhr",
            data: data,
            type: "http"
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $2fad282ea967d3b7$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $iKbxs.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $iKbxs.addBreadcrumb)({
                category: "fetch",
                data: data,
                level: "error",
                type: "http"
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $iKbxs.addBreadcrumb)({
                category: "fetch",
                data: data,
                type: "http"
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $2fad282ea967d3b7$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $iKbxs.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $dBGHn.parseUrl)((0, $6aflr.WINDOW).location.href);
        let parsedFrom = from ? (0, $dBGHn.parseUrl)(from) : undefined;
        const parsedTo = (0, $dBGHn.parseUrl)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $iKbxs.addBreadcrumb)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $2fad282ea967d3b7$var$_isEvent(event) {
    return !!event && !!event.target;
}

});
parcelRegister("gPoCM", function(module, exports) {

$parcel$export(module.exports, "addClickKeypressInstrumentationHandler", function () { return $c40482b1106c879a$export$5aeffd3db2cf9df7; });

var $4zH9l = parcelRequire("4zH9l");

var $8WMel = parcelRequire("8WMel");

var $ehoTA = parcelRequire("ehoTA");

var $czuIS = parcelRequire("czuIS");
const $c40482b1106c879a$var$WINDOW = (0, $ehoTA.GLOBAL_OBJ);
const $c40482b1106c879a$var$DEBOUNCE_DURATION = 1000;
let $c40482b1106c879a$var$debounceTimerID;
let $c40482b1106c879a$var$lastCapturedEventType;
let $c40482b1106c879a$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $c40482b1106c879a$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $czuIS.addHandler)(type, handler);
    (0, $czuIS.maybeInstrument)(type, $c40482b1106c879a$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $c40482b1106c879a$export$3014bbf0af0e1d4a() {
    if (!$c40482b1106c879a$var$WINDOW.document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $czuIS.triggerHandlers).bind(null, "dom");
    const globalDOMEventHandler = $c40482b1106c879a$var$makeDOMEventHandler(triggerDOMHandler, true);
    $c40482b1106c879a$var$WINDOW.document.addEventListener("click", globalDOMEventHandler, false);
    $c40482b1106c879a$var$WINDOW.document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $c40482b1106c879a$var$WINDOW[target] && $c40482b1106c879a$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        (0, $8WMel.fill)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $c40482b1106c879a$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $8WMel.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $c40482b1106c879a$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $c40482b1106c879a$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $c40482b1106c879a$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $c40482b1106c879a$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== "keypress") return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $c40482b1106c879a$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event["_sentryCaptured"]) return;
        const target = $c40482b1106c879a$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($c40482b1106c879a$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $8WMel.addNonEnumerableProperty)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $8WMel.addNonEnumerableProperty)(target, "_sentryId", (0, $4zH9l.uuid4)());
        const name = event.type === "keypress" ? "input" : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$c40482b1106c879a$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $c40482b1106c879a$var$lastCapturedEventType = event.type;
            $c40482b1106c879a$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($c40482b1106c879a$var$debounceTimerID);
        $c40482b1106c879a$var$debounceTimerID = $c40482b1106c879a$var$WINDOW.setTimeout(()=>{
            $c40482b1106c879a$var$lastCapturedEventTargetId = undefined;
            $c40482b1106c879a$var$lastCapturedEventType = undefined;
        }, $c40482b1106c879a$var$DEBOUNCE_DURATION);
    };
}
function $c40482b1106c879a$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}

});

parcelRegister("kd8lN", function(module, exports) {

$parcel$export(module.exports, "addConsoleInstrumentationHandler", function () { return $eb6b7fc6b6e29ac9$export$1d6e0d073f9e6723; });

var $7Dams = parcelRequire("7Dams");

var $8WMel = parcelRequire("8WMel");

var $ehoTA = parcelRequire("ehoTA");

var $czuIS = parcelRequire("czuIS");
/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $eb6b7fc6b6e29ac9$export$1d6e0d073f9e6723(handler) {
    const type = "console";
    (0, $czuIS.addHandler)(type, handler);
    (0, $czuIS.maybeInstrument)(type, $eb6b7fc6b6e29ac9$var$instrumentConsole);
}
function $eb6b7fc6b6e29ac9$var$instrumentConsole() {
    if (!("console" in (0, $ehoTA.GLOBAL_OBJ))) return;
    (0, $7Dams.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in (0, $ehoTA.GLOBAL_OBJ).console)) return;
        (0, $8WMel.fill)((0, $ehoTA.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, $7Dams.originalConsoleMethods)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $czuIS.triggerHandlers)("console", handlerData);
                const log = (0, $7Dams.originalConsoleMethods)[level];
                log && log.apply((0, $ehoTA.GLOBAL_OBJ).console, args);
            };
        });
    });
}

});

parcelRegister("dSesE", function(module, exports) {

$parcel$export(module.exports, "severityLevelFromString", function () { return $a19b892d8671b57e$export$d771ef054122c30a; });
// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $a19b892d8671b57e$export$411d0ffdba845b6c = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $a19b892d8671b57e$export$e01cef29b4327697(level) {
    return $a19b892d8671b57e$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $a19b892d8671b57e$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : $a19b892d8671b57e$export$411d0ffdba845b6c.includes(level) ? level : "log";
}

});


parcelRegister("2OPSd", function(module, exports) {

$parcel$export(module.exports, "dedupeIntegration", function () { return $20d87d42c59a698f$export$6d39aa44cd0c7567; });

var $gN6dC = parcelRequire("gN6dC");

var $7Dams = parcelRequire("7Dams");

var $h51OY = parcelRequire("h51OY");
const $20d87d42c59a698f$var$INTEGRATION_NAME = "Dedupe";
const $20d87d42c59a698f$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $20d87d42c59a698f$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($20d87d42c59a698f$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, $h51OY.DEBUG_BUILD) && (0, $7Dams.logger).warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
const $20d87d42c59a698f$export$6d39aa44cd0c7567 = (0, $gN6dC.defineIntegration)($20d87d42c59a698f$var$_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $20d87d42c59a698f$export$688d98c249d31ad3 = (0, $gN6dC.convertIntegrationFnToClass)($20d87d42c59a698f$var$INTEGRATION_NAME, $20d87d42c59a698f$export$6d39aa44cd0c7567);
function $20d87d42c59a698f$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($20d87d42c59a698f$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($20d87d42c59a698f$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $20d87d42c59a698f$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$20d87d42c59a698f$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$20d87d42c59a698f$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $20d87d42c59a698f$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $20d87d42c59a698f$var$_getExceptionFromEvent(previousEvent);
    const currentException = $20d87d42c59a698f$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$20d87d42c59a698f$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$20d87d42c59a698f$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $20d87d42c59a698f$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $20d87d42c59a698f$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $20d87d42c59a698f$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $20d87d42c59a698f$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
function $20d87d42c59a698f$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $20d87d42c59a698f$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}

});

parcelRegister("lBMxU", function(module, exports) {

$parcel$export(module.exports, "globalHandlersIntegration", function () { return $fbb2b5de3d936ebc$export$66acc70e8cf2b71a; });

var $iKbxs = parcelRequire("iKbxs");
var $gN6dC = parcelRequire("gN6dC");

var $dDzKl = parcelRequire("dDzKl");
var $4CL9G = parcelRequire("4CL9G");
var $db3mB = parcelRequire("db3mB");
var $l3GNb = parcelRequire("l3GNb");
var $7Dams = parcelRequire("7Dams");

var $h51OY = parcelRequire("h51OY");

var $f7o7A = parcelRequire("f7o7A");

var $6aflr = parcelRequire("6aflr");
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ const $fbb2b5de3d936ebc$var$INTEGRATION_NAME = "GlobalHandlers";
const $fbb2b5de3d936ebc$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $fbb2b5de3d936ebc$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $fbb2b5de3d936ebc$var$_installGlobalOnErrorHandler(client);
                $fbb2b5de3d936ebc$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $fbb2b5de3d936ebc$var$_installGlobalOnUnhandledRejectionHandler(client);
                $fbb2b5de3d936ebc$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $fbb2b5de3d936ebc$export$66acc70e8cf2b71a = (0, $gN6dC.defineIntegration)($fbb2b5de3d936ebc$var$_globalHandlersIntegration);
/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $fbb2b5de3d936ebc$export$204155decbc90e5a = (0, $gN6dC.convertIntegrationFnToClass)($fbb2b5de3d936ebc$var$INTEGRATION_NAME, $fbb2b5de3d936ebc$export$66acc70e8cf2b71a);
function $fbb2b5de3d936ebc$var$_installGlobalOnErrorHandler(client) {
    (0, $dDzKl.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $fbb2b5de3d936ebc$var$getOptions();
        if ((0, $iKbxs.getClient)() !== client || (0, $6aflr.shouldIgnoreOnError)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = error === undefined && (0, $l3GNb.isString)(msg) ? $fbb2b5de3d936ebc$var$_eventFromIncompleteOnError(msg, url, line, column) : $fbb2b5de3d936ebc$var$_enhanceEventWithInitialFrame((0, $f7o7A.eventFromUnknownInput)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $iKbxs.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onerror"
            }
        });
    });
}
function $fbb2b5de3d936ebc$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $4CL9G.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $fbb2b5de3d936ebc$var$getOptions();
        if ((0, $iKbxs.getClient)() !== client || (0, $6aflr.shouldIgnoreOnError)()) return;
        const error = $fbb2b5de3d936ebc$var$_getUnhandledRejectionError(e);
        const event = (0, $l3GNb.isPrimitive)(error) ? $fbb2b5de3d936ebc$var$_eventFromRejectionWithPrimitive(error) : (0, $f7o7A.eventFromUnknownInput)(stackParser, error, undefined, attachStacktrace, true);
        event.level = "error";
        (0, $iKbxs.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onunhandledrejection"
            }
        });
    });
}
function $fbb2b5de3d936ebc$var$_getUnhandledRejectionError(error) {
    if ((0, $l3GNb.isPrimitive)(error)) return error;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const e = error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ("reason" in e) return e.reason;
        else if ("detail" in e && "reason" in e.detail) return e.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $fbb2b5de3d936ebc$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $fbb2b5de3d936ebc$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $l3GNb.isErrorEvent)(msg) ? msg.message : msg;
    let name = "Error";
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $fbb2b5de3d936ebc$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $fbb2b5de3d936ebc$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $l3GNb.isString)(url) && url.length > 0 ? url : (0, $db3mB.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: "?",
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $fbb2b5de3d936ebc$var$globalHandlerLog(type) {
    (0, $h51OY.DEBUG_BUILD) && (0, $7Dams.logger).log(`Global Handler attached: ${type}`);
}
function $fbb2b5de3d936ebc$var$getOptions() {
    const client = (0, $iKbxs.getClient)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}

});

parcelRegister("kikKe", function(module, exports) {

$parcel$export(module.exports, "httpContextIntegration", function () { return $ec65948ec7e80fe9$export$1378794447170364; });

var $gN6dC = parcelRequire("gN6dC");

var $6aflr = parcelRequire("6aflr");
const $ec65948ec7e80fe9$var$INTEGRATION_NAME = "HttpContext";
const $ec65948ec7e80fe9$var$_httpContextIntegration = ()=>{
    return {
        name: $ec65948ec7e80fe9$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $6aflr.WINDOW).navigator && !(0, $6aflr.WINDOW).location && !(0, $6aflr.WINDOW).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $6aflr.WINDOW).location && (0, $6aflr.WINDOW).location.href;
            const { referrer: referrer } = (0, $6aflr.WINDOW).document || {};
            const { userAgent: userAgent } = (0, $6aflr.WINDOW).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    "User-Agent": userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
};
const $ec65948ec7e80fe9$export$1378794447170364 = (0, $gN6dC.defineIntegration)($ec65948ec7e80fe9$var$_httpContextIntegration);
/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $ec65948ec7e80fe9$export$5d2ee9a544b09a94 = (0, $gN6dC.convertIntegrationFnToClass)($ec65948ec7e80fe9$var$INTEGRATION_NAME, $ec65948ec7e80fe9$export$1378794447170364);

});

parcelRegister("6zc8S", function(module, exports) {

$parcel$export(module.exports, "linkedErrorsIntegration", function () { return $4c7f6e1e7a721862$export$ebabb00eb7f3a395; });

var $gN6dC = parcelRequire("gN6dC");

var $JnKZK = parcelRequire("JnKZK");

var $f7o7A = parcelRequire("f7o7A");
const $4c7f6e1e7a721862$var$DEFAULT_KEY = "cause";
const $4c7f6e1e7a721862$var$DEFAULT_LIMIT = 5;
const $4c7f6e1e7a721862$var$INTEGRATION_NAME = "LinkedErrors";
const $4c7f6e1e7a721862$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $4c7f6e1e7a721862$var$DEFAULT_LIMIT;
    const key = options.key || $4c7f6e1e7a721862$var$DEFAULT_KEY;
    return {
        name: $4c7f6e1e7a721862$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $JnKZK.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $f7o7A.exceptionFromError), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $4c7f6e1e7a721862$export$ebabb00eb7f3a395 = (0, $gN6dC.defineIntegration)($4c7f6e1e7a721862$var$_linkedErrorsIntegration);
/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $4c7f6e1e7a721862$export$8d1e60aaf616fb4f = (0, $gN6dC.convertIntegrationFnToClass)($4c7f6e1e7a721862$var$INTEGRATION_NAME, $4c7f6e1e7a721862$export$ebabb00eb7f3a395);

});
parcelRegister("JnKZK", function(module, exports) {

$parcel$export(module.exports, "applyAggregateErrorsToEvent", function () { return $0886a1b9cd7baf4a$export$b91c38ed7d8ae9b2; });

var $l3GNb = parcelRequire("l3GNb");

var $bqiXE = parcelRequire("bqiXE");
/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $0886a1b9cd7baf4a$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $l3GNb.isInstanceOf)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $0886a1b9cd7baf4a$var$truncateAggregateExceptions($0886a1b9cd7baf4a$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $0886a1b9cd7baf4a$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $l3GNb.isInstanceOf)(error[key], Error)) {
        $0886a1b9cd7baf4a$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $0886a1b9cd7baf4a$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $0886a1b9cd7baf4a$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $l3GNb.isInstanceOf)(childError, Error)) {
            $0886a1b9cd7baf4a$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $0886a1b9cd7baf4a$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $0886a1b9cd7baf4a$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $0886a1b9cd7baf4a$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === "AggregateError" && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $0886a1b9cd7baf4a$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $0886a1b9cd7baf4a$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $bqiXE.truncate)(exception.value, maxValueLength);
        return exception;
    });
}

});


parcelRegister("dEVRC", function(module, exports) {

$parcel$export(module.exports, "browserApiErrorsIntegration", function () { return $9f1be55090e87044$export$59bfe9f1c76150e; });

var $gN6dC = parcelRequire("gN6dC");

var $8WMel = parcelRequire("8WMel");
var $kmiJQ = parcelRequire("kmiJQ");

var $6aflr = parcelRequire("6aflr");
const $9f1be55090e87044$var$DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "BroadcastChannel",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "SharedWorker",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
const $9f1be55090e87044$var$INTEGRATION_NAME = "TryCatch";
const $9f1be55090e87044$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $9f1be55090e87044$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $8WMel.fill)((0, $6aflr.WINDOW), "setTimeout", $9f1be55090e87044$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $8WMel.fill)((0, $6aflr.WINDOW), "setInterval", $9f1be55090e87044$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $8WMel.fill)((0, $6aflr.WINDOW), "requestAnimationFrame", $9f1be55090e87044$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $6aflr.WINDOW)) (0, $8WMel.fill)(XMLHttpRequest.prototype, "send", $9f1be55090e87044$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $9f1be55090e87044$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($9f1be55090e87044$var$_wrapEventTarget);
            }
        }
    };
};
const $9f1be55090e87044$export$59bfe9f1c76150e = (0, $gN6dC.defineIntegration)($9f1be55090e87044$var$_browserApiErrorsIntegration);
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $9f1be55090e87044$export$f1a018517668e6d3 = (0, $gN6dC.convertIntegrationFnToClass)($9f1be55090e87044$var$INTEGRATION_NAME, $9f1be55090e87044$export$59bfe9f1c76150e);
function $9f1be55090e87044$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $6aflr.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $kmiJQ.getFunctionName)(original)
                },
                handled: false,
                type: "instrument"
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9f1be55090e87044$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $6aflr.wrap)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0, $kmiJQ.getFunctionName)(original)
                    },
                    handled: false,
                    type: "instrument"
                }
            })
        ]);
    };
}
function $9f1be55090e87044$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $8WMel.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $kmiJQ.getFunctionName)(original)
                        },
                        handled: false,
                        type: "instrument"
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $8WMel.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $kmiJQ.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $6aflr.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $9f1be55090e87044$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $6aflr.WINDOW);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
    (0, $8WMel.fill)(proto, "addEventListener", function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === "function") // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $6aflr.wrap)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: "handleEvent",
                            handler: (0, $kmiJQ.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $6aflr.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0, $kmiJQ.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                }),
                options
            ]);
        };
    });
    (0, $8WMel.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}

});

parcelRegister("c4XeL", function(module, exports) {

$parcel$export(module.exports, "defaultStackParser", function () { return $8cb3cf02441a923a$export$2b2b997d81bf3907; });

var $kmiJQ = parcelRequire("kmiJQ");
// global reference to slice
const $8cb3cf02441a923a$var$UNKNOWN_FUNCTION = "?";
const $8cb3cf02441a923a$var$OPERA10_PRIORITY = 10;
const $8cb3cf02441a923a$var$OPERA11_PRIORITY = 20;
const $8cb3cf02441a923a$var$CHROME_PRIORITY = 30;
const $8cb3cf02441a923a$var$WINJS_PRIORITY = 40;
const $8cb3cf02441a923a$var$GECKO_PRIORITY = 50;
function $8cb3cf02441a923a$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $8cb3cf02441a923a$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $8cb3cf02441a923a$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $8cb3cf02441a923a$var$chromeStackParserFn = (line)=>{
    const parts = $8cb3cf02441a923a$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
        if (isEval) {
            const subMatch = $8cb3cf02441a923a$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $8cb3cf02441a923a$var$extractSafariExtensionDetails(parts[1] || $8cb3cf02441a923a$var$UNKNOWN_FUNCTION, parts[2]);
        return $8cb3cf02441a923a$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $8cb3cf02441a923a$export$263a749fff749872 = [
    $8cb3cf02441a923a$var$CHROME_PRIORITY,
    $8cb3cf02441a923a$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $8cb3cf02441a923a$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $8cb3cf02441a923a$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $8cb3cf02441a923a$var$gecko = (line)=>{
    const parts = $8cb3cf02441a923a$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $8cb3cf02441a923a$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ""; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $8cb3cf02441a923a$var$UNKNOWN_FUNCTION;
        [func, filename] = $8cb3cf02441a923a$var$extractSafariExtensionDetails(func, filename);
        return $8cb3cf02441a923a$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $8cb3cf02441a923a$export$cdba47a5dd2804d = [
    $8cb3cf02441a923a$var$GECKO_PRIORITY,
    $8cb3cf02441a923a$var$gecko
];
const $8cb3cf02441a923a$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $8cb3cf02441a923a$var$winjs = (line)=>{
    const parts = $8cb3cf02441a923a$var$winjsRegex.exec(line);
    return parts ? $8cb3cf02441a923a$var$createFrame(parts[2], parts[1] || $8cb3cf02441a923a$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $8cb3cf02441a923a$export$179460296da408e8 = [
    $8cb3cf02441a923a$var$WINJS_PRIORITY,
    $8cb3cf02441a923a$var$winjs
];
const $8cb3cf02441a923a$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $8cb3cf02441a923a$var$opera10 = (line)=>{
    const parts = $8cb3cf02441a923a$var$opera10Regex.exec(line);
    return parts ? $8cb3cf02441a923a$var$createFrame(parts[2], parts[3] || $8cb3cf02441a923a$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $8cb3cf02441a923a$export$f892b52c880ffc7a = [
    $8cb3cf02441a923a$var$OPERA10_PRIORITY,
    $8cb3cf02441a923a$var$opera10
];
const $8cb3cf02441a923a$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $8cb3cf02441a923a$var$opera11 = (line)=>{
    const parts = $8cb3cf02441a923a$var$opera11Regex.exec(line);
    return parts ? $8cb3cf02441a923a$var$createFrame(parts[5], parts[3] || parts[4] || $8cb3cf02441a923a$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $8cb3cf02441a923a$export$af11af13f09fb0dc = [
    $8cb3cf02441a923a$var$OPERA11_PRIORITY,
    $8cb3cf02441a923a$var$opera11
];
const $8cb3cf02441a923a$export$7197c0fe6554c079 = [
    $8cb3cf02441a923a$export$263a749fff749872,
    $8cb3cf02441a923a$export$cdba47a5dd2804d,
    $8cb3cf02441a923a$export$179460296da408e8
];
const $8cb3cf02441a923a$export$2b2b997d81bf3907 = (0, $kmiJQ.createStackParser)(...$8cb3cf02441a923a$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $8cb3cf02441a923a$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : $8cb3cf02441a923a$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};

});

parcelRegister("704I4", function(module, exports) {

$parcel$export(module.exports, "makeFetchTransport", function () { return $518c2fc8e8b382f5$export$b2311068c46d7cc8; });

var $8kfOy = parcelRequire("8kfOy");

var $goLCC = parcelRequire("goLCC");

var $8Hueg = parcelRequire("8Hueg");
/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $518c2fc8e8b382f5$export$b2311068c46d7cc8(options, nativeFetch = (0, $8Hueg.getNativeFetchImplementation)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                        "retry-after": response.headers.get("Retry-After")
                    }
                };
            });
        } catch (e) {
            (0, $8Hueg.clearCachedFetchImplementation)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $goLCC.rejectedSyncPromise)(e);
        }
    }
    return (0, $8kfOy.createTransport)(options, makeRequest);
}

});
parcelRegister("8kfOy", function(module, exports) {

$parcel$export(module.exports, "createTransport", function () { return $60fc75688cc6f0ea$export$d09f50d9ab7f7b69; });

var $dp1Mp = parcelRequire("dp1Mp");
var $6mJ4l = parcelRequire("6mJ4l");
var $7Dams = parcelRequire("7Dams");
var $2NH4F = parcelRequire("2NH4F");
var $goLCC = parcelRequire("goLCC");
var $3nRVL = parcelRequire("3nRVL");

var $3JSHc = parcelRequire("3JSHc");
const $60fc75688cc6f0ea$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $60fc75688cc6f0ea$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $2NH4F.makePromiseBuffer)(options.bufferSize || $60fc75688cc6f0ea$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $dp1Mp.forEachEnvelopeItem)(envelope, (item, type)=>{
            const dataCategory = (0, $dp1Mp.envelopeItemTypeToDataCategory)(type);
            if ((0, $6mJ4l.isRateLimited)(rateLimits, dataCategory)) {
                const event = $60fc75688cc6f0ea$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent("ratelimit_backoff", dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $goLCC.resolvedSyncPromise)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $dp1Mp.createEnvelope)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $dp1Mp.forEachEnvelopeItem)(filteredEnvelope, (item, type)=>{
                const event = $60fc75688cc6f0ea$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $dp1Mp.envelopeItemTypeToDataCategory)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $dp1Mp.serializeEnvelope)(filteredEnvelope, options.textEncoder)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $6mJ4l.updateRateLimits)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $3nRVL.SentryError)) {
                (0, $3JSHc.DEBUG_BUILD) && (0, $7Dams.logger).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return (0, $goLCC.resolvedSyncPromise)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function $60fc75688cc6f0ea$var$getEventForEnvelopeItem(item, type) {
    if (type !== "event" && type !== "transaction") return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}

});
parcelRegister("6mJ4l", function(module, exports) {

$parcel$export(module.exports, "isRateLimited", function () { return $4a27c1ea65313a6e$export$6c91fec22056810a; });
$parcel$export(module.exports, "updateRateLimits", function () { return $4a27c1ea65313a6e$export$699aff705e0d49d4; });
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $4a27c1ea65313a6e$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $4a27c1ea65313a6e$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $4a27c1ea65313a6e$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $4a27c1ea65313a6e$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $4a27c1ea65313a6e$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $4a27c1ea65313a6e$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $4a27c1ea65313a6e$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers["x-sentry-rate-limits"];
    const retryAfterHeader = headers && headers["retry-after"];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $4a27c1ea65313a6e$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}

});

parcelRegister("2NH4F", function(module, exports) {

$parcel$export(module.exports, "makePromiseBuffer", function () { return $20a1920349b051ad$export$85a4f67f852183e6; });

var $3nRVL = parcelRequire("3nRVL");

var $goLCC = parcelRequire("goLCC");
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $20a1920349b051ad$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $goLCC.rejectedSyncPromise)(new (0, $3nRVL.SentryError)("Not adding Promise because buffer limit was reached."));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $goLCC.SyncPromise)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $goLCC.resolvedSyncPromise)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

});


parcelRegister("8Hueg", function(module, exports) {

$parcel$export(module.exports, "getNativeFetchImplementation", function () { return $6559c9c2106e8e08$export$8be2119ce08e3379; });
$parcel$export(module.exports, "clearCachedFetchImplementation", function () { return $6559c9c2106e8e08$export$d499686d2dd738c6; });

var $f6Wg7 = parcelRequire("f6Wg7");
var $7Dams = parcelRequire("7Dams");

var $h51OY = parcelRequire("h51OY");

var $6aflr = parcelRequire("6aflr");
let $6559c9c2106e8e08$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $6559c9c2106e8e08$export$8be2119ce08e3379() {
    if ($6559c9c2106e8e08$var$cachedFetchImpl) return $6559c9c2106e8e08$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $f6Wg7.isNativeFetch)((0, $6aflr.WINDOW).fetch)) return $6559c9c2106e8e08$var$cachedFetchImpl = (0, $6aflr.WINDOW).fetch.bind((0, $6aflr.WINDOW));
    const document = (0, $6aflr.WINDOW).document;
    let fetchImpl = (0, $6aflr.WINDOW).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $h51OY.DEBUG_BUILD) && (0, $7Dams.logger).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", e);
    }
    return $6559c9c2106e8e08$var$cachedFetchImpl = fetchImpl.bind((0, $6aflr.WINDOW));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $6559c9c2106e8e08$export$d499686d2dd738c6() {
    $6559c9c2106e8e08$var$cachedFetchImpl = undefined;
}

});


parcelRegister("hnLUt", function(module, exports) {

$parcel$export(module.exports, "makeXHRTransport", function () { return $03440737e35f499b$export$5e1441cee30d5a39; });

var $8kfOy = parcelRequire("8kfOy");

var $goLCC = parcelRequire("goLCC");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $03440737e35f499b$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $03440737e35f499b$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $goLCC.SyncPromise)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $03440737e35f499b$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        "x-sentry-rate-limits": xhr.getResponseHeader("X-Sentry-Rate-Limits"),
                        "retry-after": xhr.getResponseHeader("Retry-After")
                    }
                });
            };
            xhr.open("POST", options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $8kfOy.createTransport)(options, makeRequest);
}

});



parcelRegister("dvGJn", function(module, exports) {

$parcel$export(module.exports, "InternalReplay", function () { return $9d5f51142a9a79a0$export$6b59b88de1ff9cb7; });

var $a5Gjy = parcelRequire("a5Gjy");
var $avffj = parcelRequire("avffj");
var $gPoCM = parcelRequire("gPoCM");
var $4V7kV = parcelRequire("4V7kV");
var $bU1Fh = parcelRequire("bU1Fh");
var $dk3nq = parcelRequire("dk3nq");
var $bA8KD = parcelRequire("bA8KD");
var $7Dams = parcelRequire("7Dams");
var $dp1Mp = parcelRequire("dp1Mp");
var $8WMel = parcelRequire("8WMel");
var $ehoTA = parcelRequire("ehoTA");
var $db3mB = parcelRequire("db3mB");
var $lbaFw = parcelRequire("lbaFw");
var $6mJ4l = parcelRequire("6mJ4l");
var $6l9XD = parcelRequire("6l9XD");
var $bqiXE = parcelRequire("bqiXE");
var $4zH9l = parcelRequire("4zH9l");

var $iKbxs = parcelRequire("iKbxs");
var $kp047 = parcelRequire("kp047");
var $aFDsf = parcelRequire("aFDsf");
var $8ZS5a = parcelRequire("8ZS5a");
var $1M1wc = parcelRequire("1M1wc");
var $9t32t = parcelRequire("9t32t");
var $IueXx = parcelRequire("IueXx");

var $hqqce = parcelRequire("hqqce");
// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and replay packages should `@sentry/browser` import
// from `@sentry/replay` in the future
const $9d5f51142a9a79a0$var$WINDOW = (0, $ehoTA.GLOBAL_OBJ);
const $9d5f51142a9a79a0$var$REPLAY_SESSION_KEY = "sentryReplaySession";
const $9d5f51142a9a79a0$var$REPLAY_EVENT_NAME = "replay_event";
const $9d5f51142a9a79a0$var$UNABLE_TO_SEND_REPLAY = "Unable to send Replay";
// The idle limit for a session after which recording is paused.
const $9d5f51142a9a79a0$var$SESSION_IDLE_PAUSE_DURATION = 300000; // 5 minutes in ms
// The idle limit for a session after which the session expires.
const $9d5f51142a9a79a0$var$SESSION_IDLE_EXPIRE_DURATION = 900000; // 15 minutes in ms
/** Default flush delays */ const $9d5f51142a9a79a0$var$DEFAULT_FLUSH_MIN_DELAY = 5000;
// XXX: Temp fix for our debounce logic where `maxWait` would never occur if it
// was the same as `wait`
const $9d5f51142a9a79a0$var$DEFAULT_FLUSH_MAX_DELAY = 5500;
/* How long to wait for error checkouts */ const $9d5f51142a9a79a0$var$BUFFER_CHECKOUT_TIME = 60000;
const $9d5f51142a9a79a0$var$RETRY_BASE_INTERVAL = 5000;
const $9d5f51142a9a79a0$var$RETRY_MAX_COUNT = 3;
/* The max (uncompressed) size in bytes of a network body. Any body larger than this will be truncated. */ const $9d5f51142a9a79a0$var$NETWORK_BODY_MAX_SIZE = 150000;
/* The max size of a single console arg that is captured. Any arg larger than this will be truncated. */ const $9d5f51142a9a79a0$var$CONSOLE_ARG_MAX_SIZE = 5000;
/* Min. time to wait before we consider something a slow click. */ const $9d5f51142a9a79a0$var$SLOW_CLICK_THRESHOLD = 3000;
/* For scroll actions after a click, we only look for a very short time period to detect programmatic scrolling. */ const $9d5f51142a9a79a0$var$SLOW_CLICK_SCROLL_TIMEOUT = 300;
/** When encountering a total segment size exceeding this size, stop the replay (as we cannot properly ingest it). */ const $9d5f51142a9a79a0$var$REPLAY_MAX_EVENT_BUFFER_SIZE = 20000000; // ~20MB
/** Replays must be min. 5s long before we send them. */ const $9d5f51142a9a79a0$var$MIN_REPLAY_DURATION = 4999;
/* The max. allowed value that the minReplayDuration can be set to. */ const $9d5f51142a9a79a0$var$MIN_REPLAY_DURATION_LIMIT = 15000;
/** The max. length of a replay. */ const $9d5f51142a9a79a0$var$MAX_REPLAY_DURATION = 3600000; // 60 minutes in ms;
function $9d5f51142a9a79a0$var$_nullishCoalesce$1(lhs, rhsFn) {
    if (lhs != null) return lhs;
    else return rhsFn();
}
function $9d5f51142a9a79a0$var$_optionalChain$5(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
var $9d5f51142a9a79a0$var$NodeType$1;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($9d5f51142a9a79a0$var$NodeType$1 || ($9d5f51142a9a79a0$var$NodeType$1 = {}));
function $9d5f51142a9a79a0$var$isElement$1(n) {
    return n.nodeType === n.ELEMENT_NODE;
}
function $9d5f51142a9a79a0$var$isShadowRoot(n) {
    const host = $9d5f51142a9a79a0$var$_optionalChain$5([
        n,
        "optionalAccess",
        (_)=>_.host
    ]);
    return Boolean($9d5f51142a9a79a0$var$_optionalChain$5([
        host,
        "optionalAccess",
        (_2)=>_2.shadowRoot
    ]) === n);
}
function $9d5f51142a9a79a0$var$isNativeShadowDom(shadowRoot) {
    return Object.prototype.toString.call(shadowRoot) === "[object ShadowRoot]";
}
function $9d5f51142a9a79a0$var$fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(" background-clip: text;") && !cssText.includes(" -webkit-background-clip: text;")) cssText = cssText.replace(" background-clip: text;", " -webkit-background-clip: text; background-clip: text;");
    return cssText;
}
function $9d5f51142a9a79a0$var$escapeImportStatement(rule) {
    const { cssText: cssText } = rule;
    if (cssText.split('"').length < 3) return cssText;
    const statement = [
        "@import",
        `url(${JSON.stringify(rule.href)})`
    ];
    if (rule.layerName === "") statement.push(`layer`);
    else if (rule.layerName) statement.push(`layer(${rule.layerName})`);
    if (rule.supportsText) statement.push(`supports(${rule.supportsText})`);
    if (rule.media.length) statement.push(rule.media.mediaText);
    return statement.join(" ") + ";";
}
function $9d5f51142a9a79a0$var$stringifyStylesheet(s) {
    try {
        const rules = s.rules || s.cssRules;
        return rules ? $9d5f51142a9a79a0$var$fixBrowserCompatibilityIssuesInCSS(Array.from(rules, $9d5f51142a9a79a0$var$stringifyRule).join("")) : null;
    } catch (error) {
        return null;
    }
}
function $9d5f51142a9a79a0$var$stringifyRule(rule) {
    let importStringified;
    if ($9d5f51142a9a79a0$var$isCSSImportRule(rule)) try {
        importStringified = $9d5f51142a9a79a0$var$stringifyStylesheet(rule.styleSheet) || $9d5f51142a9a79a0$var$escapeImportStatement(rule);
    } catch (error) {}
    else if ($9d5f51142a9a79a0$var$isCSSStyleRule(rule) && rule.selectorText.includes(":")) return $9d5f51142a9a79a0$var$fixSafariColons(rule.cssText);
    return importStringified || rule.cssText;
}
function $9d5f51142a9a79a0$var$fixSafariColons(cssStringified) {
    const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, "$1\\$2");
}
function $9d5f51142a9a79a0$var$isCSSImportRule(rule) {
    return "styleSheet" in rule;
}
function $9d5f51142a9a79a0$var$isCSSStyleRule(rule) {
    return "selectorText" in rule;
}
class $9d5f51142a9a79a0$var$Mirror {
    constructor(){
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
    getId(n) {
        if (!n) return -1;
        const id = $9d5f51142a9a79a0$var$_optionalChain$5([
            this,
            "access",
            (_3)=>_3.getMeta,
            "call",
            (_4)=>_4(n),
            "optionalAccess",
            (_5)=>_5.id
        ]);
        return $9d5f51142a9a79a0$var$_nullishCoalesce$1(id, ()=>-1);
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n) {
        return this.nodeMetaMap.get(n) || null;
    }
    removeNodeFromMap(n) {
        const id = this.getId(n);
        this.idNodeMap.delete(id);
        if (n.childNodes) n.childNodes.forEach((childNode)=>this.removeNodeFromMap(childNode));
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node) {
        return this.nodeMetaMap.has(node);
    }
    add(n, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n);
        this.nodeMetaMap.set(n, meta);
    }
    replace(id, n) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n, meta);
        }
        this.idNodeMap.set(id, n);
    }
    reset() {
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
}
function $9d5f51142a9a79a0$var$createMirror() {
    return new $9d5f51142a9a79a0$var$Mirror();
}
function $9d5f51142a9a79a0$var$shouldMaskInput({ maskInputOptions: maskInputOptions, tagName: tagName, type: type }) {
    if (tagName === "OPTION") tagName = "SELECT";
    return Boolean(maskInputOptions[tagName.toLowerCase()] || type && maskInputOptions[type] || type === "password" || tagName === "INPUT" && !type && maskInputOptions["text"]);
}
function $9d5f51142a9a79a0$var$maskInputValue({ isMasked: isMasked, element: element, value: value, maskInputFn: maskInputFn }) {
    let text = value || "";
    if (!isMasked) return text;
    if (maskInputFn) text = maskInputFn(text, element);
    return "*".repeat(text.length);
}
function $9d5f51142a9a79a0$var$toLowerCase(str) {
    return str.toLowerCase();
}
function $9d5f51142a9a79a0$var$toUpperCase(str) {
    return str.toUpperCase();
}
const $9d5f51142a9a79a0$var$ORIGINAL_ATTRIBUTE_NAME = "__rrweb_original__";
function $9d5f51142a9a79a0$var$is2DCanvasBlank(canvas) {
    const ctx = canvas.getContext("2d");
    if (!ctx) return true;
    const chunkSize = 50;
    for(let x = 0; x < canvas.width; x += chunkSize)for(let y = 0; y < canvas.height; y += chunkSize){
        const getImageData = ctx.getImageData;
        const originalGetImageData = $9d5f51142a9a79a0$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$9d5f51142a9a79a0$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        const pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some((pixel)=>pixel !== 0)) return false;
    }
    return true;
}
function $9d5f51142a9a79a0$var$getInputType(element) {
    const type = element.type;
    return element.hasAttribute("data-rr-is-password") ? "password" : type ? $9d5f51142a9a79a0$var$toLowerCase(type) : null;
}
function $9d5f51142a9a79a0$var$getInputValue(el, tagName, type) {
    if (tagName === "INPUT" && (type === "radio" || type === "checkbox")) return el.getAttribute("value") || "";
    return el.value;
}
let $9d5f51142a9a79a0$var$_id = 1;
const $9d5f51142a9a79a0$var$tagNameRegex = new RegExp("[^a-z0-9-_:]");
const $9d5f51142a9a79a0$var$IGNORED_NODE = -2;
function $9d5f51142a9a79a0$var$genId() {
    return $9d5f51142a9a79a0$var$_id++;
}
function $9d5f51142a9a79a0$var$getValidTagName(element) {
    if (element instanceof HTMLFormElement) return "form";
    const processedTagName = $9d5f51142a9a79a0$var$toLowerCase(element.tagName);
    if ($9d5f51142a9a79a0$var$tagNameRegex.test(processedTagName)) return "div";
    return processedTagName;
}
function $9d5f51142a9a79a0$var$extractOrigin(url) {
    let origin = "";
    if (url.indexOf("//") > -1) origin = url.split("/").slice(0, 3).join("/");
    else origin = url.split("/")[0];
    origin = origin.split("?")[0];
    return origin;
}
let $9d5f51142a9a79a0$var$canvasService;
let $9d5f51142a9a79a0$var$canvasCtx;
const $9d5f51142a9a79a0$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const $9d5f51142a9a79a0$var$URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
const $9d5f51142a9a79a0$var$URL_WWW_MATCH = /^www\..*/i;
const $9d5f51142a9a79a0$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $9d5f51142a9a79a0$var$absoluteToStylesheet(cssText, href) {
    return (cssText || "").replace($9d5f51142a9a79a0$var$URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3)=>{
        const filePath = path1 || path2 || path3;
        const maybeQuote = quote1 || quote2 || "";
        if (!filePath) return origin;
        if ($9d5f51142a9a79a0$var$URL_PROTOCOL_MATCH.test(filePath) || $9d5f51142a9a79a0$var$URL_WWW_MATCH.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if ($9d5f51142a9a79a0$var$DATA_URI.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if (filePath[0] === "/") return `url(${maybeQuote}${$9d5f51142a9a79a0$var$extractOrigin(href) + filePath}${maybeQuote})`;
        const stack = href.split("/");
        const parts = filePath.split("/");
        stack.pop();
        for (const part of parts){
            if (part === ".") continue;
            else if (part === "..") stack.pop();
            else stack.push(part);
        }
        return `url(${maybeQuote}${stack.join("/")}${maybeQuote})`;
    });
}
const $9d5f51142a9a79a0$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const $9d5f51142a9a79a0$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $9d5f51142a9a79a0$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === "") return attributeValue;
    let pos = 0;
    function collectCharacters(regEx) {
        let chars;
        const match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars = match[0];
            pos += chars.length;
            return chars;
        }
        return "";
    }
    const output = [];
    while(true){
        collectCharacters($9d5f51142a9a79a0$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        let url = collectCharacters($9d5f51142a9a79a0$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ",") {
            url = $9d5f51142a9a79a0$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            let descriptorsStr = "";
            url = $9d5f51142a9a79a0$var$absoluteToDoc(doc, url);
            let inParens = false;
            while(true){
                const c = attributeValue.charAt(pos);
                if (c === "") {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c === ",") {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c === "(") inParens = true;
                } else if (c === ")") inParens = false;
                descriptorsStr += c;
                pos += 1;
            }
        }
    }
    return output.join(", ");
}
function $9d5f51142a9a79a0$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === "") return attributeValue;
    const a = doc.createElement("a");
    a.href = attributeValue;
    return a.href;
}
function $9d5f51142a9a79a0$var$isSVGElement(el) {
    return Boolean(el.tagName === "svg" || el.ownerSVGElement);
}
function $9d5f51142a9a79a0$var$getHref() {
    const a = document.createElement("a");
    a.href = "";
    return a.href;
}
function $9d5f51142a9a79a0$var$transformAttribute(doc, tagName, name, value, element, maskAttributeFn) {
    if (!value) return value;
    if (name === "src" || name === "href" && !(tagName === "use" && value[0] === "#")) return $9d5f51142a9a79a0$var$absoluteToDoc(doc, value);
    else if (name === "xlink:href" && value[0] !== "#") return $9d5f51142a9a79a0$var$absoluteToDoc(doc, value);
    else if (name === "background" && (tagName === "table" || tagName === "td" || tagName === "th")) return $9d5f51142a9a79a0$var$absoluteToDoc(doc, value);
    else if (name === "srcset") return $9d5f51142a9a79a0$var$getAbsoluteSrcsetString(doc, value);
    else if (name === "style") return $9d5f51142a9a79a0$var$absoluteToStylesheet(value, $9d5f51142a9a79a0$var$getHref());
    else if (tagName === "object" && name === "data") return $9d5f51142a9a79a0$var$absoluteToDoc(doc, value);
    if (typeof maskAttributeFn === "function") return maskAttributeFn(name, value, element);
    return value;
}
function $9d5f51142a9a79a0$var$ignoreAttribute(tagName, name, _value) {
    return (tagName === "video" || tagName === "audio") && name === "autoplay";
}
function $9d5f51142a9a79a0$var$_isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
    try {
        if (unblockSelector && element.matches(unblockSelector)) return false;
        if (typeof blockClass === "string") {
            if (element.classList.contains(blockClass)) return true;
        } else for(let eIndex = element.classList.length; eIndex--;){
            const className = element.classList[eIndex];
            if (blockClass.test(className)) return true;
        }
        if (blockSelector) return element.matches(blockSelector);
    } catch (e) {}
    return false;
}
function $9d5f51142a9a79a0$var$elementClassMatchesRegex(el, regex) {
    for(let eIndex = el.classList.length; eIndex--;){
        const className = el.classList[eIndex];
        if (regex.test(className)) return true;
    }
    return false;
}
function $9d5f51142a9a79a0$var$distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
    if (!node) return -1;
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return $9d5f51142a9a79a0$var$distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function $9d5f51142a9a79a0$var$createMatchPredicate(className, selector) {
    return (node)=>{
        const el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === "string") {
                    if (el.matches(`.${className}`)) return true;
                } else if ($9d5f51142a9a79a0$var$elementClassMatchesRegex(el, className)) return true;
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch (e2) {
            return false;
        }
    };
}
function $9d5f51142a9a79a0$var$needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText) {
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        if (el === null) return false;
        if (el.tagName === "INPUT") {
            const autocomplete = el.getAttribute("autocomplete");
            const disallowedAutocompleteValues = [
                "current-password",
                "new-password",
                "cc-number",
                "cc-exp",
                "cc-exp-month",
                "cc-exp-year",
                "cc-csc"
            ];
            if (disallowedAutocompleteValues.includes(autocomplete)) return true;
        }
        let maskDistance = -1;
        let unmaskDistance = -1;
        if (maskAllText) {
            unmaskDistance = $9d5f51142a9a79a0$var$distanceToMatch(el, $9d5f51142a9a79a0$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector));
            if (unmaskDistance < 0) return true;
            maskDistance = $9d5f51142a9a79a0$var$distanceToMatch(el, $9d5f51142a9a79a0$var$createMatchPredicate(maskTextClass, maskTextSelector), unmaskDistance >= 0 ? unmaskDistance : Infinity);
        } else {
            maskDistance = $9d5f51142a9a79a0$var$distanceToMatch(el, $9d5f51142a9a79a0$var$createMatchPredicate(maskTextClass, maskTextSelector));
            if (maskDistance < 0) return false;
            unmaskDistance = $9d5f51142a9a79a0$var$distanceToMatch(el, $9d5f51142a9a79a0$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector), maskDistance >= 0 ? maskDistance : Infinity);
        }
        return maskDistance >= 0 ? unmaskDistance >= 0 ? maskDistance <= unmaskDistance : true : unmaskDistance >= 0 ? false : !!maskAllText;
    } catch (e) {}
    return !!maskAllText;
}
function $9d5f51142a9a79a0$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    const win = iframeEl.contentWindow;
    if (!win) return;
    let fired = false;
    let readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== "complete") {
        const timer = setTimeout(()=>{
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener("load", ()=>{
            clearTimeout(timer);
            fired = true;
            listener();
        });
        return;
    }
    const blankUrl = "about:blank";
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === "") {
        setTimeout(listener, 0);
        return iframeEl.addEventListener("load", listener);
    }
    iframeEl.addEventListener("load", listener);
}
function $9d5f51142a9a79a0$var$onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    let fired = false;
    let styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        return;
    }
    if (styleSheetLoaded) return;
    const timer = setTimeout(()=>{
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener("load", ()=>{
        clearTimeout(timer);
        fired = true;
        listener();
    });
}
function $9d5f51142a9a79a0$var$serializeNode(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskAttributeFn: maskAttributeFn, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskTextFn: maskTextFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false } = options;
    const rootId = $9d5f51142a9a79a0$var$getRootId(doc, mirror);
    switch(n.nodeType){
        case n.DOCUMENT_NODE:
            if (n.compatMode !== "CSS1Compat") return {
                type: $9d5f51142a9a79a0$var$NodeType$1.Document,
                childNodes: [],
                compatMode: n.compatMode
            };
            else return {
                type: $9d5f51142a9a79a0$var$NodeType$1.Document,
                childNodes: []
            };
        case n.DOCUMENT_TYPE_NODE:
            return {
                type: $9d5f51142a9a79a0$var$NodeType$1.DocumentType,
                name: n.name,
                publicId: n.publicId,
                systemId: n.systemId,
                rootId: rootId
            };
        case n.ELEMENT_NODE:
            return $9d5f51142a9a79a0$var$serializeElementNode(n, {
                doc: doc,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                inlineStylesheet: inlineStylesheet,
                maskAttributeFn: maskAttributeFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                keepIframeSrcFn: keepIframeSrcFn,
                newlyAddedElement: newlyAddedElement,
                rootId: rootId,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector
            });
        case n.TEXT_NODE:
            return $9d5f51142a9a79a0$var$serializeTextNode(n, {
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskTextFn: maskTextFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                rootId: rootId
            });
        case n.CDATA_SECTION_NODE:
            return {
                type: $9d5f51142a9a79a0$var$NodeType$1.CDATA,
                textContent: "",
                rootId: rootId
            };
        case n.COMMENT_NODE:
            return {
                type: $9d5f51142a9a79a0$var$NodeType$1.Comment,
                textContent: n.textContent || "",
                rootId: rootId
            };
        default:
            return false;
    }
}
function $9d5f51142a9a79a0$var$getRootId(doc, mirror) {
    if (!mirror.hasNode(doc)) return undefined;
    const docId = mirror.getId(doc);
    return docId === 1 ? undefined : docId;
}
function $9d5f51142a9a79a0$var$serializeTextNode(n, options) {
    const { maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, maskTextFn: maskTextFn, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, rootId: rootId } = options;
    const parentTagName = n.parentNode && n.parentNode.tagName;
    let textContent = n.textContent;
    const isStyle = parentTagName === "STYLE" ? true : undefined;
    const isScript = parentTagName === "SCRIPT" ? true : undefined;
    const isTextarea = parentTagName === "TEXTAREA" ? true : undefined;
    if (isStyle && textContent) {
        try {
            if (n.nextSibling || n.previousSibling) ;
            else if ($9d5f51142a9a79a0$var$_optionalChain$5([
                n,
                "access",
                (_6)=>_6.parentNode,
                "access",
                (_7)=>_7.sheet,
                "optionalAccess",
                (_8)=>_8.cssRules
            ])) textContent = $9d5f51142a9a79a0$var$stringifyStylesheet(n.parentNode.sheet);
        } catch (err) {
            console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n);
        }
        textContent = $9d5f51142a9a79a0$var$absoluteToStylesheet(textContent, $9d5f51142a9a79a0$var$getHref());
    }
    if (isScript) textContent = "SCRIPT_PLACEHOLDER";
    const forceMask = $9d5f51142a9a79a0$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText);
    if (!isStyle && !isScript && !isTextarea && textContent && forceMask) textContent = maskTextFn ? maskTextFn(textContent, n.parentElement) : textContent.replace(/[\S]/g, "*");
    if (isTextarea && textContent && (maskInputOptions.textarea || forceMask)) textContent = maskInputFn ? maskInputFn(textContent, n.parentNode) : textContent.replace(/[\S]/g, "*");
    if (parentTagName === "OPTION" && textContent) {
        const isInputMasked = $9d5f51142a9a79a0$var$shouldMaskInput({
            type: null,
            tagName: parentTagName,
            maskInputOptions: maskInputOptions
        });
        textContent = $9d5f51142a9a79a0$var$maskInputValue({
            isMasked: $9d5f51142a9a79a0$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked),
            element: n,
            value: textContent,
            maskInputFn: maskInputFn
        });
    }
    return {
        type: $9d5f51142a9a79a0$var$NodeType$1.Text,
        textContent: textContent || "",
        isStyle: isStyle,
        rootId: rootId
    };
}
function $9d5f51142a9a79a0$var$serializeElementNode(n, options) {
    const { doc: doc, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false, rootId: rootId, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector } = options;
    const needBlock = $9d5f51142a9a79a0$var$_isBlockedElement(n, blockClass, blockSelector, unblockSelector);
    const tagName = $9d5f51142a9a79a0$var$getValidTagName(n);
    let attributes = {};
    const len = n.attributes.length;
    for(let i = 0; i < len; i++){
        const attr = n.attributes[i];
        if (attr.name && !$9d5f51142a9a79a0$var$ignoreAttribute(tagName, attr.name, attr.value)) attributes[attr.name] = $9d5f51142a9a79a0$var$transformAttribute(doc, tagName, $9d5f51142a9a79a0$var$toLowerCase(attr.name), attr.value, n, maskAttributeFn);
    }
    if (tagName === "link" && inlineStylesheet) {
        const stylesheet = Array.from(doc.styleSheets).find((s)=>{
            return s.href === n.href;
        });
        let cssText = null;
        if (stylesheet) cssText = $9d5f51142a9a79a0$var$stringifyStylesheet(stylesheet);
        if (cssText) {
            delete attributes.rel;
            delete attributes.href;
            attributes._cssText = $9d5f51142a9a79a0$var$absoluteToStylesheet(cssText, stylesheet.href);
        }
    }
    if (tagName === "style" && n.sheet && !(n.innerText || n.textContent || "").trim().length) {
        const cssText = $9d5f51142a9a79a0$var$stringifyStylesheet(n.sheet);
        if (cssText) attributes._cssText = $9d5f51142a9a79a0$var$absoluteToStylesheet(cssText, $9d5f51142a9a79a0$var$getHref());
    }
    if (tagName === "input" || tagName === "textarea" || tagName === "select" || tagName === "option") {
        const el = n;
        const type = $9d5f51142a9a79a0$var$getInputType(el);
        const value = $9d5f51142a9a79a0$var$getInputValue(el, $9d5f51142a9a79a0$var$toUpperCase(tagName), type);
        const checked = el.checked;
        if (type !== "submit" && type !== "button" && value) {
            const forceMask = $9d5f51142a9a79a0$var$needMaskingText(el, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, $9d5f51142a9a79a0$var$shouldMaskInput({
                type: type,
                tagName: $9d5f51142a9a79a0$var$toUpperCase(tagName),
                maskInputOptions: maskInputOptions
            }));
            attributes.value = $9d5f51142a9a79a0$var$maskInputValue({
                isMasked: forceMask,
                element: el,
                value: value,
                maskInputFn: maskInputFn
            });
        }
        if (checked) attributes.checked = checked;
    }
    if (tagName === "option") {
        if (n.selected && !maskInputOptions["select"]) attributes.selected = true;
        else delete attributes.selected;
    }
    if (tagName === "canvas" && recordCanvas) {
        if (n.__context === "2d") {
            if (!$9d5f51142a9a79a0$var$is2DCanvasBlank(n)) attributes.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
        } else if (!("__context" in n)) {
            const canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            const blankCanvas = document.createElement("canvas");
            blankCanvas.width = n.width;
            blankCanvas.height = n.height;
            const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) attributes.rr_dataURL = canvasDataURL;
        }
    }
    if (tagName === "img" && inlineImages) {
        if (!$9d5f51142a9a79a0$var$canvasService) {
            $9d5f51142a9a79a0$var$canvasService = doc.createElement("canvas");
            $9d5f51142a9a79a0$var$canvasCtx = $9d5f51142a9a79a0$var$canvasService.getContext("2d");
        }
        const image = n;
        const oldValue = image.crossOrigin;
        image.crossOrigin = "anonymous";
        const recordInlineImage = ()=>{
            image.removeEventListener("load", recordInlineImage);
            try {
                $9d5f51142a9a79a0$var$canvasService.width = image.naturalWidth;
                $9d5f51142a9a79a0$var$canvasService.height = image.naturalHeight;
                $9d5f51142a9a79a0$var$canvasCtx.drawImage(image, 0, 0);
                attributes.rr_dataURL = $9d5f51142a9a79a0$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                console.warn(`Cannot inline img src=${image.currentSrc}! Error: ${err}`);
            }
            oldValue ? attributes.crossOrigin = oldValue : image.removeAttribute("crossorigin");
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener("load", recordInlineImage);
    }
    if (tagName === "audio" || tagName === "video") {
        attributes.rr_mediaState = n.paused ? "paused" : "played";
        attributes.rr_mediaCurrentTime = n.currentTime;
    }
    if (!newlyAddedElement) {
        if (n.scrollLeft) attributes.rr_scrollLeft = n.scrollLeft;
        if (n.scrollTop) attributes.rr_scrollTop = n.scrollTop;
    }
    if (needBlock) {
        const { width: width, height: height } = n.getBoundingClientRect();
        attributes = {
            class: attributes.class,
            rr_width: `${width}px`,
            rr_height: `${height}px`
        };
    }
    if (tagName === "iframe" && !keepIframeSrcFn(attributes.src)) {
        if (!n.contentDocument) attributes.rr_src = attributes.src;
        delete attributes.src;
    }
    let isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e) {}
    return {
        type: $9d5f51142a9a79a0$var$NodeType$1.Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: [],
        isSVG: $9d5f51142a9a79a0$var$isSVGElement(n) || undefined,
        needBlock: needBlock,
        rootId: rootId,
        isCustom: isCustomElement
    };
}
function $9d5f51142a9a79a0$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === undefined || maybeAttr === null) return "";
    else return maybeAttr.toLowerCase();
}
function $9d5f51142a9a79a0$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $9d5f51142a9a79a0$var$NodeType$1.Comment) return true;
    else if (sn.type === $9d5f51142a9a79a0$var$NodeType$1.Element) {
        if (slimDOMOptions.script && (sn.tagName === "script" || sn.tagName === "link" && (sn.attributes.rel === "preload" || sn.attributes.rel === "modulepreload") && sn.attributes.as === "script" || sn.tagName === "link" && sn.attributes.rel === "prefetch" && typeof sn.attributes.href === "string" && sn.attributes.href.endsWith(".js"))) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === "link" && sn.attributes.rel === "shortcut icon" || sn.tagName === "meta" && ($9d5f51142a9a79a0$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $9d5f51142a9a79a0$var$lowerIfExists(sn.attributes.name) === "application-name" || $9d5f51142a9a79a0$var$lowerIfExists(sn.attributes.rel) === "icon" || $9d5f51142a9a79a0$var$lowerIfExists(sn.attributes.rel) === "apple-touch-icon" || $9d5f51142a9a79a0$var$lowerIfExists(sn.attributes.rel) === "shortcut icon"))) return true;
        else if (sn.tagName === "meta") {
            if (slimDOMOptions.headMetaDescKeywords && $9d5f51142a9a79a0$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($9d5f51142a9a79a0$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || $9d5f51142a9a79a0$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $9d5f51142a9a79a0$var$lowerIfExists(sn.attributes.name) === "pinterest")) return true;
            else if (slimDOMOptions.headMetaRobots && ($9d5f51142a9a79a0$var$lowerIfExists(sn.attributes.name) === "robots" || $9d5f51142a9a79a0$var$lowerIfExists(sn.attributes.name) === "googlebot" || $9d5f51142a9a79a0$var$lowerIfExists(sn.attributes.name) === "bingbot")) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes["http-equiv"] !== undefined) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($9d5f51142a9a79a0$var$lowerIfExists(sn.attributes.name) === "author" || $9d5f51142a9a79a0$var$lowerIfExists(sn.attributes.name) === "generator" || $9d5f51142a9a79a0$var$lowerIfExists(sn.attributes.name) === "framework" || $9d5f51142a9a79a0$var$lowerIfExists(sn.attributes.name) === "publisher" || $9d5f51142a9a79a0$var$lowerIfExists(sn.attributes.name) === "progid" || $9d5f51142a9a79a0$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $9d5f51142a9a79a0$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($9d5f51142a9a79a0$var$lowerIfExists(sn.attributes.name) === "google-site-verification" || $9d5f51142a9a79a0$var$lowerIfExists(sn.attributes.name) === "yandex-verification" || $9d5f51142a9a79a0$var$lowerIfExists(sn.attributes.name) === "csrf-token" || $9d5f51142a9a79a0$var$lowerIfExists(sn.attributes.name) === "p:domain_verify" || $9d5f51142a9a79a0$var$lowerIfExists(sn.attributes.name) === "verify-v1" || $9d5f51142a9a79a0$var$lowerIfExists(sn.attributes.name) === "verification" || $9d5f51142a9a79a0$var$lowerIfExists(sn.attributes.name) === "shopify-checkout-api-token")) return true;
        }
    }
    return false;
}
function $9d5f51142a9a79a0$var$serializeNodeWithId(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, skipChild: skipChild = false, inlineStylesheet: inlineStylesheet = true, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOMOptions: slimDOMOptions, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout = 5000, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout = 5000, keepIframeSrcFn: keepIframeSrcFn = ()=>false, newlyAddedElement: newlyAddedElement = false } = options;
    let { preserveWhiteSpace: preserveWhiteSpace = true } = options;
    const _serializedNode = $9d5f51142a9a79a0$var$serializeNode(n, {
        doc: doc,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskAllText: maskAllText,
        unblockSelector: unblockSelector,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: newlyAddedElement
    });
    if (!_serializedNode) {
        console.warn(n, "not serialized");
        return null;
    }
    let id;
    if (mirror.hasNode(n)) id = mirror.getId(n);
    else if ($9d5f51142a9a79a0$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $9d5f51142a9a79a0$var$NodeType$1.Text && !_serializedNode.isStyle && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, "").length) id = $9d5f51142a9a79a0$var$IGNORED_NODE;
    else id = $9d5f51142a9a79a0$var$genId();
    const serializedNode = Object.assign(_serializedNode, {
        id: id
    });
    mirror.add(n, serializedNode);
    if (id === $9d5f51142a9a79a0$var$IGNORED_NODE) return null;
    if (onSerialize) onSerialize(n);
    let recordChild = !skipChild;
    if (serializedNode.type === $9d5f51142a9a79a0$var$NodeType$1.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        const shadowRoot = n.shadowRoot;
        if (shadowRoot && $9d5f51142a9a79a0$var$isNativeShadowDom(shadowRoot)) serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === $9d5f51142a9a79a0$var$NodeType$1.Document || serializedNode.type === $9d5f51142a9a79a0$var$NodeType$1.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode.type === $9d5f51142a9a79a0$var$NodeType$1.Element && serializedNode.tagName === "head") preserveWhiteSpace = false;
        const bypassOptions = {
            doc: doc,
            mirror: mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskAllText: maskAllText,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            onStylesheetLoad: onStylesheetLoad,
            stylesheetLoadTimeout: stylesheetLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn
        };
        for (const childN of Array.from(n.childNodes)){
            const serializedChildNode = $9d5f51142a9a79a0$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) serializedNode.childNodes.push(serializedChildNode);
        }
        if ($9d5f51142a9a79a0$var$isElement$1(n) && n.shadowRoot) for (const childN of Array.from(n.shadowRoot.childNodes)){
            const serializedChildNode = $9d5f51142a9a79a0$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) {
                $9d5f51142a9a79a0$var$isNativeShadowDom(n.shadowRoot) && (serializedChildNode.isShadow = true);
                serializedNode.childNodes.push(serializedChildNode);
            }
        }
    }
    if (n.parentNode && $9d5f51142a9a79a0$var$isShadowRoot(n.parentNode) && $9d5f51142a9a79a0$var$isNativeShadowDom(n.parentNode)) serializedNode.isShadow = true;
    if (serializedNode.type === $9d5f51142a9a79a0$var$NodeType$1.Element && serializedNode.tagName === "iframe") $9d5f51142a9a79a0$var$onceIframeLoaded(n, ()=>{
        const iframeDoc = n.contentDocument;
        if (iframeDoc && onIframeLoad) {
            const serializedIframeNode = $9d5f51142a9a79a0$var$serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedIframeNode) onIframeLoad(n, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    if (serializedNode.type === $9d5f51142a9a79a0$var$NodeType$1.Element && serializedNode.tagName === "link" && serializedNode.attributes.rel === "stylesheet") $9d5f51142a9a79a0$var$onceStylesheetLoaded(n, ()=>{
        if (onStylesheetLoad) {
            const serializedLinkNode = $9d5f51142a9a79a0$var$serializeNodeWithId(n, {
                doc: doc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedLinkNode) onStylesheetLoad(n, serializedLinkNode);
        }
    }, stylesheetLoadTimeout);
    return serializedNode;
}
function $9d5f51142a9a79a0$var$snapshot(n, options) {
    const { mirror: mirror = new $9d5f51142a9a79a0$var$Mirror(), blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = "rr-mask", unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, maskAllInputs: maskAllInputs = false, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOM: slimDOM = false, dataURLOptions: dataURLOptions, preserveWhiteSpace: preserveWhiteSpace, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout, keepIframeSrcFn: keepIframeSrcFn = ()=>false } = options || {};
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true
    } : maskAllInputs === false ? {} : maskAllInputs;
    const slimDOMOptions = slimDOM === true || slimDOM === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === "all",
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return $9d5f51142a9a79a0$var$serializeNodeWithId(n, {
        doc: n,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maskAllText: maskAllText,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        skipChild: false,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        preserveWhiteSpace: preserveWhiteSpace,
        onSerialize: onSerialize,
        onIframeLoad: onIframeLoad,
        iframeLoadTimeout: iframeLoadTimeout,
        onStylesheetLoad: onStylesheetLoad,
        stylesheetLoadTimeout: stylesheetLoadTimeout,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: false
    });
}
function $9d5f51142a9a79a0$var$_optionalChain$4(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function $9d5f51142a9a79a0$var$on(type, fn, target = document) {
    const options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return ()=>target.removeEventListener(type, fn, options);
}
const $9d5f51142a9a79a0$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let $9d5f51142a9a79a0$var$_mirror = {
    map: {},
    getId () {
        console.error($9d5f51142a9a79a0$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error($9d5f51142a9a79a0$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error($9d5f51142a9a79a0$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error($9d5f51142a9a79a0$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error($9d5f51142a9a79a0$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) $9d5f51142a9a79a0$var$_mirror = new Proxy($9d5f51142a9a79a0$var$_mirror, {
    get (target, prop, receiver) {
        if (prop === "map") console.error($9d5f51142a9a79a0$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $9d5f51142a9a79a0$var$throttle$1(func, wait, options = {}) {
    let timeout = null;
    let previous = 0;
    return function(...args) {
        const now = Date.now();
        if (!previous && options.leading === false) previous = now;
        const remaining = wait - (now - previous);
        const context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                $9d5f51142a9a79a0$var$clearTimeout$1(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = $9d5f51142a9a79a0$var$setTimeout$1(()=>{
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $9d5f51142a9a79a0$var$hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            $9d5f51142a9a79a0$var$setTimeout$1(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>$9d5f51142a9a79a0$var$hookSetter(target, key, original || {}, true);
}
function $9d5f51142a9a79a0$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch (e2) {
        return ()=>{};
    }
}
let $9d5f51142a9a79a0$var$nowTimestamp = Date.now;
if (!/[1-9][0-9]{12}/.test(Date.now().toString())) $9d5f51142a9a79a0$var$nowTimestamp = ()=>new Date().getTime();
function $9d5f51142a9a79a0$var$getWindowScroll(win) {
    const doc = win.document;
    return {
        left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== undefined ? win.pageXOffset : $9d5f51142a9a79a0$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_)=>_.documentElement,
            "access",
            (_2)=>_2.scrollLeft
        ]) || $9d5f51142a9a79a0$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_3)=>_3.body,
            "optionalAccess",
            (_4)=>_4.parentElement,
            "optionalAccess",
            (_5)=>_5.scrollLeft
        ]) || $9d5f51142a9a79a0$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_6)=>_6.body,
            "optionalAccess",
            (_7)=>_7.scrollLeft
        ]) || 0,
        top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== undefined ? win.pageYOffset : $9d5f51142a9a79a0$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_8)=>_8.documentElement,
            "access",
            (_9)=>_9.scrollTop
        ]) || $9d5f51142a9a79a0$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_10)=>_10.body,
            "optionalAccess",
            (_11)=>_11.parentElement,
            "optionalAccess",
            (_12)=>_12.scrollTop
        ]) || $9d5f51142a9a79a0$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_13)=>_13.body,
            "optionalAccess",
            (_14)=>_14.scrollTop
        ]) || 0
    };
}
function $9d5f51142a9a79a0$var$getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $9d5f51142a9a79a0$var$getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $9d5f51142a9a79a0$var$closestElementOfNode(node) {
    if (!node) return null;
    const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
    return el;
}
function $9d5f51142a9a79a0$var$isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) return false;
    const el = $9d5f51142a9a79a0$var$closestElementOfNode(node);
    if (!el) return false;
    const blockedPredicate = $9d5f51142a9a79a0$var$createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        const isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    const blockDistance = $9d5f51142a9a79a0$var$distanceToMatch(el, blockedPredicate);
    let unblockDistance = -1;
    if (blockDistance < 0) return false;
    if (unblockSelector) unblockDistance = $9d5f51142a9a79a0$var$distanceToMatch(el, $9d5f51142a9a79a0$var$createMatchPredicate(null, unblockSelector));
    if (blockDistance > -1 && unblockDistance < 0) return true;
    return blockDistance < unblockDistance;
}
function $9d5f51142a9a79a0$var$isSerialized(n, mirror) {
    return mirror.getId(n) !== -1;
}
function $9d5f51142a9a79a0$var$isIgnored(n, mirror) {
    return mirror.getId(n) === $9d5f51142a9a79a0$var$IGNORED_NODE;
}
function $9d5f51142a9a79a0$var$isAncestorRemoved(target, mirror) {
    if ($9d5f51142a9a79a0$var$isShadowRoot(target)) return false;
    const id = mirror.getId(target);
    if (!mirror.has(id)) return true;
    if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) return false;
    if (!target.parentNode) return true;
    return $9d5f51142a9a79a0$var$isAncestorRemoved(target.parentNode, mirror);
}
function $9d5f51142a9a79a0$var$legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function $9d5f51142a9a79a0$var$polyfill(win = window) {
    if ("NodeList" in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ("DOMTokenList" in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
    if (!Node.prototype.contains) Node.prototype.contains = (...args)=>{
        let node = args[0];
        if (!(0 in args)) throw new TypeError("1 argument is required");
        do {
            if (this === node) return true;
        }while (node = node && node.parentNode);
        return false;
    };
}
function $9d5f51142a9a79a0$var$isSerializedIframe(n, mirror) {
    return Boolean(n.nodeName === "IFRAME" && mirror.getMeta(n));
}
function $9d5f51142a9a79a0$var$isSerializedStylesheet(n, mirror) {
    return Boolean(n.nodeName === "LINK" && n.nodeType === n.ELEMENT_NODE && n.getAttribute && n.getAttribute("rel") === "stylesheet" && mirror.getMeta(n));
}
function $9d5f51142a9a79a0$var$hasShadowRoot(n) {
    return Boolean($9d5f51142a9a79a0$var$_optionalChain$4([
        n,
        "optionalAccess",
        (_18)=>_18.shadowRoot
    ]));
}
class $9d5f51142a9a79a0$var$StyleSheetMirror {
    constructor(){
        this.id = 1;
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
    }
    getId(stylesheet) {
        return (0, $a5Gjy._nullishCoalesce)(this.styleIDMap.get(stylesheet), ()=>-1);
    }
    has(stylesheet) {
        return this.styleIDMap.has(stylesheet);
    }
    add(stylesheet, id) {
        if (this.has(stylesheet)) return this.getId(stylesheet);
        let newId;
        if (id === undefined) newId = this.id++;
        else newId = id;
        this.styleIDMap.set(stylesheet, newId);
        this.idStyleMap.set(newId, stylesheet);
        return newId;
    }
    getStyle(id) {
        return this.idStyleMap.get(id) || null;
    }
    reset() {
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
        this.id = 1;
    }
    generateId() {
        return this.id++;
    }
}
function $9d5f51142a9a79a0$var$getShadowHost(n) {
    let shadowHost = null;
    if ($9d5f51142a9a79a0$var$_optionalChain$4([
        n,
        "access",
        (_19)=>_19.getRootNode,
        "optionalCall",
        (_20)=>_20(),
        "optionalAccess",
        (_21)=>_21.nodeType
    ]) === Node.DOCUMENT_FRAGMENT_NODE && n.getRootNode().host) shadowHost = n.getRootNode().host;
    return shadowHost;
}
function $9d5f51142a9a79a0$var$getRootShadowHost(n) {
    let rootShadowHost = n;
    let shadowHost;
    while(shadowHost = $9d5f51142a9a79a0$var$getShadowHost(rootShadowHost))rootShadowHost = shadowHost;
    return rootShadowHost;
}
function $9d5f51142a9a79a0$var$shadowHostInDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    const shadowHost = $9d5f51142a9a79a0$var$getRootShadowHost(n);
    return doc.contains(shadowHost);
}
function $9d5f51142a9a79a0$var$inDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    return doc.contains(n) || $9d5f51142a9a79a0$var$shadowHostInDom(n);
}
const $9d5f51142a9a79a0$var$cachedImplementations = {};
function $9d5f51142a9a79a0$var$getImplementation(name) {
    const cached = $9d5f51142a9a79a0$var$cachedImplementations[name];
    if (cached) return cached;
    const document1 = window.document;
    let impl = window[name];
    if (document1 && typeof document1.createElement === "function") try {
        const sandbox = document1.createElement("iframe");
        sandbox.hidden = true;
        document1.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document1.head.removeChild(sandbox);
    } catch (e) {}
    return $9d5f51142a9a79a0$var$cachedImplementations[name] = impl.bind(window);
}
function $9d5f51142a9a79a0$var$onRequestAnimationFrame(...rest) {
    return $9d5f51142a9a79a0$var$getImplementation("requestAnimationFrame")(...rest);
}
function $9d5f51142a9a79a0$var$setTimeout$1(...rest) {
    return $9d5f51142a9a79a0$var$getImplementation("setTimeout")(...rest);
}
function $9d5f51142a9a79a0$var$clearTimeout$1(...rest) {
    return $9d5f51142a9a79a0$var$getImplementation("clearTimeout")(...rest);
}
var $9d5f51142a9a79a0$var$EventType = /* @__PURE__ */ ((EventType2)=>{
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
})($9d5f51142a9a79a0$var$EventType || {});
var $9d5f51142a9a79a0$var$IncrementalSource = /* @__PURE__ */ ((IncrementalSource2)=>{
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
})($9d5f51142a9a79a0$var$IncrementalSource || {});
var $9d5f51142a9a79a0$var$MouseInteractions = /* @__PURE__ */ ((MouseInteractions2)=>{
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
})($9d5f51142a9a79a0$var$MouseInteractions || {});
var $9d5f51142a9a79a0$var$PointerTypes = /* @__PURE__ */ ((PointerTypes2)=>{
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
})($9d5f51142a9a79a0$var$PointerTypes || {});
function $9d5f51142a9a79a0$var$_optionalChain$3(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function $9d5f51142a9a79a0$var$isNodeInLinkedList(n) {
    return "__ln" in n;
}
class $9d5f51142a9a79a0$var$DoubleLinkedList {
    constructor(){
        this.length = 0;
        this.head = null;
        this.tail = null;
    }
    get(position) {
        if (position >= this.length) throw new Error("Position outside of list range");
        let current = this.head;
        for(let index = 0; index < position; index++)current = $9d5f51142a9a79a0$var$_optionalChain$3([
            current,
            "optionalAccess",
            (_)=>_.next
        ]) || null;
        return current;
    }
    addNode(n) {
        const node = {
            value: n,
            previous: null,
            next: null
        };
        n.__ln = node;
        if (n.previousSibling && $9d5f51142a9a79a0$var$isNodeInLinkedList(n.previousSibling)) {
            const current = n.previousSibling.__ln.next;
            node.next = current;
            node.previous = n.previousSibling.__ln;
            n.previousSibling.__ln.next = node;
            if (current) current.previous = node;
        } else if (n.nextSibling && $9d5f51142a9a79a0$var$isNodeInLinkedList(n.nextSibling) && n.nextSibling.__ln.previous) {
            const current = n.nextSibling.__ln.previous;
            node.previous = current;
            node.next = n.nextSibling.__ln;
            n.nextSibling.__ln.previous = node;
            if (current) current.next = node;
        } else {
            if (this.head) this.head.previous = node;
            node.next = this.head;
            this.head = node;
        }
        if (node.next === null) this.tail = node;
        this.length++;
    }
    removeNode(n) {
        const current = n.__ln;
        if (!this.head) return;
        if (!current.previous) {
            this.head = current.next;
            if (this.head) this.head.previous = null;
            else this.tail = null;
        } else {
            current.previous.next = current.next;
            if (current.next) current.next.previous = current.previous;
            else this.tail = current.previous;
        }
        if (n.__ln) delete n.__ln;
        this.length--;
    }
}
const $9d5f51142a9a79a0$var$moveKey = (id, parentId)=>`${id}@${parentId}`;
class $9d5f51142a9a79a0$var$MutationBuffer {
    constructor(){
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.attributeMap = new WeakMap();
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = new Set();
        this.movedSet = new Set();
        this.droppedSet = new Set();
        this.processMutations = (mutations)=>{
            mutations.forEach(this.processMutation);
            this.emit();
        };
        this.emit = ()=>{
            if (this.frozen || this.locked) return;
            const adds = [];
            const addedIds = new Set();
            const addList = new $9d5f51142a9a79a0$var$DoubleLinkedList();
            const getNextId = (n)=>{
                let ns = n;
                let nextId = $9d5f51142a9a79a0$var$IGNORED_NODE;
                while(nextId === $9d5f51142a9a79a0$var$IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && this.mirror.getId(ns);
                }
                return nextId;
            };
            const pushAdd = (n)=>{
                if (!n.parentNode || !$9d5f51142a9a79a0$var$inDom(n)) return;
                const parentId = $9d5f51142a9a79a0$var$isShadowRoot(n.parentNode) ? this.mirror.getId($9d5f51142a9a79a0$var$getShadowHost(n)) : this.mirror.getId(n.parentNode);
                const nextId = getNextId(n);
                if (parentId === -1 || nextId === -1) return addList.addNode(n);
                const sn = $9d5f51142a9a79a0$var$serializeNodeWithId(n, {
                    doc: this.doc,
                    mirror: this.mirror,
                    blockClass: this.blockClass,
                    blockSelector: this.blockSelector,
                    maskAllText: this.maskAllText,
                    unblockSelector: this.unblockSelector,
                    maskTextClass: this.maskTextClass,
                    unmaskTextClass: this.unmaskTextClass,
                    maskTextSelector: this.maskTextSelector,
                    unmaskTextSelector: this.unmaskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: this.inlineStylesheet,
                    maskInputOptions: this.maskInputOptions,
                    maskAttributeFn: this.maskAttributeFn,
                    maskTextFn: this.maskTextFn,
                    maskInputFn: this.maskInputFn,
                    slimDOMOptions: this.slimDOMOptions,
                    dataURLOptions: this.dataURLOptions,
                    recordCanvas: this.recordCanvas,
                    inlineImages: this.inlineImages,
                    onSerialize: (currentN)=>{
                        if ($9d5f51142a9a79a0$var$isSerializedIframe(currentN, this.mirror)) this.iframeManager.addIframe(currentN);
                        if ($9d5f51142a9a79a0$var$isSerializedStylesheet(currentN, this.mirror)) this.stylesheetManager.trackLinkElement(currentN);
                        if ($9d5f51142a9a79a0$var$hasShadowRoot(n)) this.shadowDomManager.addShadowRoot(n.shadowRoot, this.doc);
                    },
                    onIframeLoad: (iframe, childSn)=>{
                        this.iframeManager.attachIframe(iframe, childSn);
                        this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: (link, childSn)=>{
                        this.stylesheetManager.attachLinkElement(link, childSn);
                    }
                });
                if (sn) {
                    adds.push({
                        parentId: parentId,
                        nextId: nextId,
                        node: sn
                    });
                    addedIds.add(sn.id);
                }
            };
            while(this.mapRemoves.length)this.mirror.removeNodeFromMap(this.mapRemoves.shift());
            for (const n of this.movedSet){
                if ($9d5f51142a9a79a0$var$isParentRemoved(this.removes, n, this.mirror) && !this.movedSet.has(n.parentNode)) continue;
                pushAdd(n);
            }
            for (const n of this.addedSet){
                if (!$9d5f51142a9a79a0$var$isAncestorInSet(this.droppedSet, n) && !$9d5f51142a9a79a0$var$isParentRemoved(this.removes, n, this.mirror)) pushAdd(n);
                else if ($9d5f51142a9a79a0$var$isAncestorInSet(this.movedSet, n)) pushAdd(n);
                else this.droppedSet.add(n);
            }
            let candidate = null;
            while(addList.length){
                let node = null;
                if (candidate) {
                    const parentId = this.mirror.getId(candidate.value.parentNode);
                    const nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node = candidate;
                }
                if (!node) {
                    let tailNode = addList.tail;
                    while(tailNode){
                        const _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            const parentId = this.mirror.getId(_node.value.parentNode);
                            const nextId = getNextId(_node.value);
                            if (nextId === -1) continue;
                            else if (parentId !== -1) {
                                node = _node;
                                break;
                            } else {
                                const unhandledNode = _node.value;
                                if (unhandledNode.parentNode && unhandledNode.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    const shadowHost = unhandledNode.parentNode.host;
                                    const parentId = this.mirror.getId(shadowHost);
                                    if (parentId !== -1) {
                                        node = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            const payload = {
                texts: this.texts.map((text)=>({
                        id: this.mirror.getId(text.node),
                        value: text.value
                    })).filter((text)=>!addedIds.has(text.id)).filter((text)=>this.mirror.has(text.id)),
                attributes: this.attributes.map((attribute)=>{
                    const { attributes: attributes } = attribute;
                    if (typeof attributes.style === "string") {
                        const diffAsStr = JSON.stringify(attribute.styleDiff);
                        const unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split("var(").length === attributes.style.split("var(").length) attributes.style = attribute.styleDiff;
                        }
                    }
                    return {
                        id: this.mirror.getId(attribute.node),
                        attributes: attributes
                    };
                }).filter((attribute)=>!addedIds.has(attribute.id)).filter((attribute)=>this.mirror.has(attribute.id)),
                removes: this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            this.texts = [];
            this.attributes = [];
            this.attributeMap = new WeakMap();
            this.removes = [];
            this.addedSet = new Set();
            this.movedSet = new Set();
            this.droppedSet = new Set();
            this.movedMap = {};
            this.mutationCb(payload);
        };
        this.processMutation = (m)=>{
            if ($9d5f51142a9a79a0$var$isIgnored(m.target, this.mirror)) return;
            switch(m.type){
                case "characterData":
                    {
                        const value = m.target.textContent;
                        if (!$9d5f51142a9a79a0$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) && value !== m.oldValue) this.texts.push({
                            value: $9d5f51142a9a79a0$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, this.maskAllText) && value ? this.maskTextFn ? this.maskTextFn(value, $9d5f51142a9a79a0$var$closestElementOfNode(m.target)) : value.replace(/[\S]/g, "*") : value,
                            node: m.target
                        });
                        break;
                    }
                case "attributes":
                    {
                        const target = m.target;
                        let attributeName = m.attributeName;
                        let value = m.target.getAttribute(attributeName);
                        if (attributeName === "value") {
                            const type = $9d5f51142a9a79a0$var$getInputType(target);
                            const tagName = target.tagName;
                            value = $9d5f51142a9a79a0$var$getInputValue(target, tagName, type);
                            const isInputMasked = $9d5f51142a9a79a0$var$shouldMaskInput({
                                maskInputOptions: this.maskInputOptions,
                                tagName: tagName,
                                type: type
                            });
                            const forceMask = $9d5f51142a9a79a0$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, isInputMasked);
                            value = $9d5f51142a9a79a0$var$maskInputValue({
                                isMasked: forceMask,
                                element: target,
                                value: value,
                                maskInputFn: this.maskInputFn
                            });
                        }
                        if ($9d5f51142a9a79a0$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || value === m.oldValue) return;
                        let item = this.attributeMap.get(m.target);
                        if (target.tagName === "IFRAME" && attributeName === "src" && !this.keepIframeSrcFn(value)) {
                            if (!target.contentDocument) attributeName = "rr_src";
                            else return;
                        }
                        if (!item) {
                            item = {
                                node: m.target,
                                attributes: {},
                                styleDiff: {},
                                _unchangedStyles: {}
                            };
                            this.attributes.push(item);
                            this.attributeMap.set(m.target, item);
                        }
                        if (attributeName === "type" && target.tagName === "INPUT" && (m.oldValue || "").toLowerCase() === "password") target.setAttribute("data-rr-is-password", "true");
                        if (!$9d5f51142a9a79a0$var$ignoreAttribute(target.tagName, attributeName)) {
                            item.attributes[attributeName] = $9d5f51142a9a79a0$var$transformAttribute(this.doc, $9d5f51142a9a79a0$var$toLowerCase(target.tagName), $9d5f51142a9a79a0$var$toLowerCase(attributeName), value, target, this.maskAttributeFn);
                            if (attributeName === "style") {
                                if (!this.unattachedDoc) try {
                                    this.unattachedDoc = document.implementation.createHTMLDocument();
                                } catch (e) {
                                    this.unattachedDoc = this.doc;
                                }
                                const old = this.unattachedDoc.createElement("span");
                                if (m.oldValue) old.setAttribute("style", m.oldValue);
                                for (const pname of Array.from(target.style)){
                                    const newValue = target.style.getPropertyValue(pname);
                                    const newPriority = target.style.getPropertyPriority(pname);
                                    if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                                        if (newPriority === "") item.styleDiff[pname] = newValue;
                                        else item.styleDiff[pname] = [
                                            newValue,
                                            newPriority
                                        ];
                                    } else item._unchangedStyles[pname] = [
                                        newValue,
                                        newPriority
                                    ];
                                }
                                for (const pname of Array.from(old.style))if (target.style.getPropertyValue(pname) === "") item.styleDiff[pname] = false;
                            }
                        }
                        break;
                    }
                case "childList":
                    if ($9d5f51142a9a79a0$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, true)) return;
                    m.addedNodes.forEach((n)=>this.genAdds(n, m.target));
                    m.removedNodes.forEach((n)=>{
                        const nodeId = this.mirror.getId(n);
                        const parentId = $9d5f51142a9a79a0$var$isShadowRoot(m.target) ? this.mirror.getId(m.target.host) : this.mirror.getId(m.target);
                        if ($9d5f51142a9a79a0$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || $9d5f51142a9a79a0$var$isIgnored(n, this.mirror) || !$9d5f51142a9a79a0$var$isSerialized(n, this.mirror)) return;
                        if (this.addedSet.has(n)) {
                            $9d5f51142a9a79a0$var$deepDelete(this.addedSet, n);
                            this.droppedSet.add(n);
                        } else if (this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ($9d5f51142a9a79a0$var$isAncestorRemoved(m.target, this.mirror)) ;
                        else if (this.movedSet.has(n) && this.movedMap[$9d5f51142a9a79a0$var$moveKey(nodeId, parentId)]) $9d5f51142a9a79a0$var$deepDelete(this.movedSet, n);
                        else this.removes.push({
                            parentId: parentId,
                            id: nodeId,
                            isShadow: $9d5f51142a9a79a0$var$isShadowRoot(m.target) && $9d5f51142a9a79a0$var$isNativeShadowDom(m.target) ? true : undefined
                        });
                        this.mapRemoves.push(n);
                    });
                    break;
            }
        };
        this.genAdds = (n, target)=>{
            if (this.processedNodeManager.inOtherBuffer(n, this)) return;
            if (this.addedSet.has(n) || this.movedSet.has(n)) return;
            if (this.mirror.hasNode(n)) {
                if ($9d5f51142a9a79a0$var$isIgnored(n, this.mirror)) return;
                this.movedSet.add(n);
                let targetId = null;
                if (target && this.mirror.hasNode(target)) targetId = this.mirror.getId(target);
                if (targetId && targetId !== -1) this.movedMap[$9d5f51142a9a79a0$var$moveKey(this.mirror.getId(n), targetId)] = true;
            } else {
                this.addedSet.add(n);
                this.droppedSet.delete(n);
            }
            if (!$9d5f51142a9a79a0$var$isBlocked(n, this.blockClass, this.blockSelector, this.unblockSelector, false)) {
                n.childNodes.forEach((childN)=>this.genAdds(childN));
                if ($9d5f51142a9a79a0$var$hasShadowRoot(n)) n.shadowRoot.childNodes.forEach((childN)=>{
                    this.processedNodeManager.add(childN, this);
                    this.genAdds(childN, n);
                });
            }
        };
    }
    init(options) {
        [
            "mutationCb",
            "blockClass",
            "blockSelector",
            "unblockSelector",
            "maskAllText",
            "maskTextClass",
            "unmaskTextClass",
            "maskTextSelector",
            "unmaskTextSelector",
            "inlineStylesheet",
            "maskInputOptions",
            "maskAttributeFn",
            "maskTextFn",
            "maskInputFn",
            "keepIframeSrcFn",
            "recordCanvas",
            "inlineImages",
            "slimDOMOptions",
            "dataURLOptions",
            "doc",
            "mirror",
            "iframeManager",
            "stylesheetManager",
            "shadowDomManager",
            "canvasManager",
            "processedNodeManager"
        ].forEach((key)=>{
            this[key] = options[key];
        });
    }
    freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    }
    unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    }
    isFrozen() {
        return this.frozen;
    }
    lock() {
        this.locked = true;
        this.canvasManager.lock();
    }
    unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    }
    reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    }
}
function $9d5f51142a9a79a0$var$deepDelete(addsSet, n) {
    addsSet.delete(n);
    n.childNodes.forEach((childN)=>$9d5f51142a9a79a0$var$deepDelete(addsSet, childN));
}
function $9d5f51142a9a79a0$var$isParentRemoved(removes, n, mirror) {
    if (removes.length === 0) return false;
    return $9d5f51142a9a79a0$var$_isParentRemoved(removes, n, mirror);
}
function $9d5f51142a9a79a0$var$_isParentRemoved(removes, n, mirror) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    const parentId = mirror.getId(parentNode);
    if (removes.some((r)=>r.id === parentId)) return true;
    return $9d5f51142a9a79a0$var$_isParentRemoved(removes, parentNode, mirror);
}
function $9d5f51142a9a79a0$var$isAncestorInSet(set, n) {
    if (set.size === 0) return false;
    return $9d5f51142a9a79a0$var$_isAncestorInSet(set, n);
}
function $9d5f51142a9a79a0$var$_isAncestorInSet(set, n) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    if (set.has(parentNode)) return true;
    return $9d5f51142a9a79a0$var$_isAncestorInSet(set, parentNode);
}
let $9d5f51142a9a79a0$var$errorHandler;
function $9d5f51142a9a79a0$var$registerErrorHandler(handler) {
    $9d5f51142a9a79a0$var$errorHandler = handler;
}
function $9d5f51142a9a79a0$var$unregisterErrorHandler() {
    $9d5f51142a9a79a0$var$errorHandler = undefined;
}
const $9d5f51142a9a79a0$var$callbackWrapper = (cb)=>{
    if (!$9d5f51142a9a79a0$var$errorHandler) return cb;
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            if ($9d5f51142a9a79a0$var$errorHandler && $9d5f51142a9a79a0$var$errorHandler(error) === true) return ()=>{};
            throw error;
        }
    };
    return rrwebWrapped;
};
function $9d5f51142a9a79a0$var$_optionalChain$2(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
const $9d5f51142a9a79a0$var$mutationBuffers = [];
function $9d5f51142a9a79a0$var$getEventTarget(event) {
    try {
        if ("composedPath" in event) {
            const path = event.composedPath();
            if (path.length) return path[0];
        } else if ("path" in event && event.path.length) return event.path[0];
    } catch (e2) {}
    return event && event.target;
}
function $9d5f51142a9a79a0$var$initMutationObserver(options, rootEl) {
    const mutationBuffer = new $9d5f51142a9a79a0$var$MutationBuffer();
    $9d5f51142a9a79a0$var$mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    let mutationObserverCtor = window.MutationObserver || window.__rrMutationObserver;
    const angularZoneSymbol = $9d5f51142a9a79a0$var$_optionalChain$2([
        window,
        "optionalAccess",
        (_)=>_.Zone,
        "optionalAccess",
        (_2)=>_2.__symbol__,
        "optionalCall",
        (_3)=>_3("MutationObserver")
    ]);
    if (angularZoneSymbol && window[angularZoneSymbol]) mutationObserverCtor = window[angularZoneSymbol];
    const observer = new mutationObserverCtor($9d5f51142a9a79a0$var$callbackWrapper((mutations)=>{
        if (options.onMutation && options.onMutation(mutations) === false) return;
        mutationBuffer.processMutations.bind(mutationBuffer)(mutations);
    }));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $9d5f51142a9a79a0$var$initMoveObserver({ mousemoveCb: mousemoveCb, sampling: sampling, doc: doc, mirror: mirror }) {
    if (sampling.mousemove === false) return ()=>{};
    const threshold = typeof sampling.mousemove === "number" ? sampling.mousemove : 50;
    const callbackThreshold = typeof sampling.mousemoveCallback === "number" ? sampling.mousemoveCallback : 500;
    let positions = [];
    let timeBaseline;
    const wrappedCb = $9d5f51142a9a79a0$var$throttle$1($9d5f51142a9a79a0$var$callbackWrapper((source)=>{
        const totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map((p)=>{
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    const updatePosition = $9d5f51142a9a79a0$var$callbackWrapper($9d5f51142a9a79a0$var$throttle$1($9d5f51142a9a79a0$var$callbackWrapper((evt)=>{
        const target = $9d5f51142a9a79a0$var$getEventTarget(evt);
        const { clientX: clientX, clientY: clientY } = $9d5f51142a9a79a0$var$legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt;
        if (!timeBaseline) timeBaseline = $9d5f51142a9a79a0$var$nowTimestamp();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror.getId(target),
            timeOffset: $9d5f51142a9a79a0$var$nowTimestamp() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== "undefined" && evt instanceof DragEvent ? $9d5f51142a9a79a0$var$IncrementalSource.Drag : evt instanceof MouseEvent ? $9d5f51142a9a79a0$var$IncrementalSource.MouseMove : $9d5f51142a9a79a0$var$IncrementalSource.TouchMove);
    }), threshold, {
        trailing: false
    }));
    const handlers = [
        $9d5f51142a9a79a0$var$on("mousemove", updatePosition, doc),
        $9d5f51142a9a79a0$var$on("touchmove", updatePosition, doc),
        $9d5f51142a9a79a0$var$on("drag", updatePosition, doc)
    ];
    return $9d5f51142a9a79a0$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $9d5f51142a9a79a0$var$initMouseInteractionObserver({ mouseInteractionCb: mouseInteractionCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    if (sampling.mouseInteraction === false) return ()=>{};
    const disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === undefined ? {} : sampling.mouseInteraction;
    const handlers = [];
    let currentPointerType = null;
    const getHandler = (eventKey)=>{
        return (event)=>{
            const target = $9d5f51142a9a79a0$var$getEventTarget(event);
            if ($9d5f51142a9a79a0$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            let pointerType = null;
            let thisEventKey = eventKey;
            if ("pointerType" in event) {
                switch(event.pointerType){
                    case "mouse":
                        pointerType = $9d5f51142a9a79a0$var$PointerTypes.Mouse;
                        break;
                    case "touch":
                        pointerType = $9d5f51142a9a79a0$var$PointerTypes.Touch;
                        break;
                    case "pen":
                        pointerType = $9d5f51142a9a79a0$var$PointerTypes.Pen;
                        break;
                }
                if (pointerType === $9d5f51142a9a79a0$var$PointerTypes.Touch) {
                    if ($9d5f51142a9a79a0$var$MouseInteractions[eventKey] === $9d5f51142a9a79a0$var$MouseInteractions.MouseDown) thisEventKey = "TouchStart";
                    else if ($9d5f51142a9a79a0$var$MouseInteractions[eventKey] === $9d5f51142a9a79a0$var$MouseInteractions.MouseUp) thisEventKey = "TouchEnd";
                } else $9d5f51142a9a79a0$var$PointerTypes.Pen;
            } else if ($9d5f51142a9a79a0$var$legacy_isTouchEvent(event)) pointerType = $9d5f51142a9a79a0$var$PointerTypes.Touch;
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if (thisEventKey.startsWith("Touch") && pointerType === $9d5f51142a9a79a0$var$PointerTypes.Touch || thisEventKey.startsWith("Mouse") && pointerType === $9d5f51142a9a79a0$var$PointerTypes.Mouse) pointerType = null;
            } else if ($9d5f51142a9a79a0$var$MouseInteractions[eventKey] === $9d5f51142a9a79a0$var$MouseInteractions.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            const e = $9d5f51142a9a79a0$var$legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e) return;
            const id = mirror.getId(target);
            const { clientX: clientX, clientY: clientY } = e;
            $9d5f51142a9a79a0$var$callbackWrapper(mouseInteractionCb)({
                type: $9d5f51142a9a79a0$var$MouseInteractions[thisEventKey],
                id: id,
                x: clientX,
                y: clientY,
                ...pointerType !== null && {
                    pointerType: pointerType
                }
            });
        };
    };
    Object.keys($9d5f51142a9a79a0$var$MouseInteractions).filter((key)=>Number.isNaN(Number(key)) && !key.endsWith("_Departed") && disableMap[key] !== false).forEach((eventKey)=>{
        let eventName = $9d5f51142a9a79a0$var$toLowerCase(eventKey);
        const handler = getHandler(eventKey);
        if (window.PointerEvent) switch($9d5f51142a9a79a0$var$MouseInteractions[eventKey]){
            case $9d5f51142a9a79a0$var$MouseInteractions.MouseDown:
            case $9d5f51142a9a79a0$var$MouseInteractions.MouseUp:
                eventName = eventName.replace("mouse", "pointer");
                break;
            case $9d5f51142a9a79a0$var$MouseInteractions.TouchStart:
            case $9d5f51142a9a79a0$var$MouseInteractions.TouchEnd:
                return;
        }
        handlers.push($9d5f51142a9a79a0$var$on(eventName, handler, doc));
    });
    return $9d5f51142a9a79a0$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $9d5f51142a9a79a0$var$initScrollObserver({ scrollCb: scrollCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    const updatePosition = $9d5f51142a9a79a0$var$callbackWrapper($9d5f51142a9a79a0$var$throttle$1($9d5f51142a9a79a0$var$callbackWrapper((evt)=>{
        const target = $9d5f51142a9a79a0$var$getEventTarget(evt);
        if (!target || $9d5f51142a9a79a0$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const id = mirror.getId(target);
        if (target === doc && doc.defaultView) {
            const scrollLeftTop = $9d5f51142a9a79a0$var$getWindowScroll(doc.defaultView);
            scrollCb({
                id: id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top
            });
        } else scrollCb({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }), sampling.scroll || 100));
    return $9d5f51142a9a79a0$var$on("scroll", updatePosition, doc);
}
function $9d5f51142a9a79a0$var$initViewportResizeObserver({ viewportResizeCb: viewportResizeCb }, { win: win }) {
    let lastH = -1;
    let lastW = -1;
    const updateDimension = $9d5f51142a9a79a0$var$callbackWrapper($9d5f51142a9a79a0$var$throttle$1($9d5f51142a9a79a0$var$callbackWrapper(()=>{
        const height = $9d5f51142a9a79a0$var$getWindowHeight();
        const width = $9d5f51142a9a79a0$var$getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return $9d5f51142a9a79a0$var$on("resize", updateDimension, win);
}
const $9d5f51142a9a79a0$var$INPUT_TAGS = [
    "INPUT",
    "TEXTAREA",
    "SELECT"
];
const $9d5f51142a9a79a0$var$lastInputValueMap = new WeakMap();
function $9d5f51142a9a79a0$var$initInputObserver({ inputCb: inputCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, ignoreClass: ignoreClass, ignoreSelector: ignoreSelector, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, sampling: sampling, userTriggeredOnInput: userTriggeredOnInput, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector }) {
    function eventHandler(event) {
        let target = $9d5f51142a9a79a0$var$getEventTarget(event);
        const userTriggered = event.isTrusted;
        const tagName = target && $9d5f51142a9a79a0$var$toUpperCase(target.tagName);
        if (tagName === "OPTION") target = target.parentElement;
        if (!target || !tagName || $9d5f51142a9a79a0$var$INPUT_TAGS.indexOf(tagName) < 0 || $9d5f51142a9a79a0$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const el = target;
        if (el.classList.contains(ignoreClass) || ignoreSelector && el.matches(ignoreSelector)) return;
        const type = $9d5f51142a9a79a0$var$getInputType(target);
        let text = $9d5f51142a9a79a0$var$getInputValue(el, tagName, type);
        let isChecked = false;
        const isInputMasked = $9d5f51142a9a79a0$var$shouldMaskInput({
            maskInputOptions: maskInputOptions,
            tagName: tagName,
            type: type
        });
        const forceMask = $9d5f51142a9a79a0$var$needMaskingText(target, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked);
        if (type === "radio" || type === "checkbox") isChecked = target.checked;
        text = $9d5f51142a9a79a0$var$maskInputValue({
            isMasked: forceMask,
            element: target,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, userTriggeredOnInput ? {
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        } : {
            text: text,
            isChecked: isChecked
        });
        const name = target.name;
        if (type === "radio" && name && isChecked) doc.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach((el)=>{
            if (el !== target) {
                const text = $9d5f51142a9a79a0$var$maskInputValue({
                    isMasked: forceMask,
                    element: el,
                    value: $9d5f51142a9a79a0$var$getInputValue(el, tagName, type),
                    maskInputFn: maskInputFn
                });
                cbWithDedup(el, userTriggeredOnInput ? {
                    text: text,
                    isChecked: !isChecked,
                    userTriggered: false
                } : {
                    text: text,
                    isChecked: !isChecked
                });
            }
        });
    }
    function cbWithDedup(target, v) {
        const lastInputValue = $9d5f51142a9a79a0$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v.text || lastInputValue.isChecked !== v.isChecked) {
            $9d5f51142a9a79a0$var$lastInputValueMap.set(target, v);
            const id = mirror.getId(target);
            $9d5f51142a9a79a0$var$callbackWrapper(inputCb)({
                ...v,
                id: id
            });
        }
    }
    const events = sampling.input === "last" ? [
        "change"
    ] : [
        "input",
        "change"
    ];
    const handlers = events.map((eventName)=>$9d5f51142a9a79a0$var$on(eventName, $9d5f51142a9a79a0$var$callbackWrapper(eventHandler), doc));
    const currentWindow = doc.defaultView;
    if (!currentWindow) return ()=>{
        handlers.forEach((h)=>h());
    };
    const propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, "value");
    const hookProperties = [
        [
            currentWindow.HTMLInputElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLInputElement.prototype,
            "checked"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLTextAreaElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "selectedIndex"
        ],
        [
            currentWindow.HTMLOptionElement.prototype,
            "selected"
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) handlers.push(...hookProperties.map((p)=>$9d5f51142a9a79a0$var$hookSetter(p[0], p[1], {
            set () {
                $9d5f51142a9a79a0$var$callbackWrapper(eventHandler)({
                    target: this,
                    isTrusted: false
                });
            }
        }, false, currentWindow)));
    return $9d5f51142a9a79a0$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $9d5f51142a9a79a0$var$getNestedCSSRulePositions(rule) {
    const positions = [];
    function recurse(childRule, pos) {
        if ($9d5f51142a9a79a0$var$hasNestedCSSRule("CSSGroupingRule") && childRule.parentRule instanceof CSSGroupingRule || $9d5f51142a9a79a0$var$hasNestedCSSRule("CSSMediaRule") && childRule.parentRule instanceof CSSMediaRule || $9d5f51142a9a79a0$var$hasNestedCSSRule("CSSSupportsRule") && childRule.parentRule instanceof CSSSupportsRule || $9d5f51142a9a79a0$var$hasNestedCSSRule("CSSConditionRule") && childRule.parentRule instanceof CSSConditionRule) {
            const rules = Array.from(childRule.parentRule.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        } else if (childRule.parentStyleSheet) {
            const rules = Array.from(childRule.parentStyleSheet.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function $9d5f51142a9a79a0$var$getIdAndStyleId(sheet, mirror, styleMirror) {
    let id, styleId;
    if (!sheet) return {};
    if (sheet.ownerNode) id = mirror.getId(sheet.ownerNode);
    else styleId = styleMirror.getId(sheet);
    return {
        styleId: styleId,
        id: id
    };
}
function $9d5f51142a9a79a0$var$initStyleSheetObserver({ styleSheetRuleCb: styleSheetRuleCb, mirror: mirror, stylesheetManager: stylesheetManager }, { win: win }) {
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return ()=>{};
    const insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: $9d5f51142a9a79a0$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [rule, index] = argumentsList;
            const { id: id, styleId: styleId } = $9d5f51142a9a79a0$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                adds: [
                    {
                        rule: rule,
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: $9d5f51142a9a79a0$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [index] = argumentsList;
            const { id: id, styleId: styleId } = $9d5f51142a9a79a0$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                removes: [
                    {
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    let replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: $9d5f51142a9a79a0$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $9d5f51142a9a79a0$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replace: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    let replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: $9d5f51142a9a79a0$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $9d5f51142a9a79a0$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replaceSync: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    const supportedNestedCSSRuleTypes = {};
    if ($9d5f51142a9a79a0$var$canMonkeyPatchNestedCSSRule("CSSGroupingRule")) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($9d5f51142a9a79a0$var$canMonkeyPatchNestedCSSRule("CSSMediaRule")) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($9d5f51142a9a79a0$var$canMonkeyPatchNestedCSSRule("CSSConditionRule")) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($9d5f51142a9a79a0$var$canMonkeyPatchNestedCSSRule("CSSSupportsRule")) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    const unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
        unmodifiedFunctions[typeKey] = {
            insertRule: type.prototype.insertRule,
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: $9d5f51142a9a79a0$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [rule, index] = argumentsList;
                const { id: id, styleId: styleId } = $9d5f51142a9a79a0$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    adds: [
                        {
                            rule: rule,
                            index: [
                                ...$9d5f51142a9a79a0$var$getNestedCSSRulePositions(thisArg),
                                index || 0
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: $9d5f51142a9a79a0$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [index] = argumentsList;
                const { id: id, styleId: styleId } = $9d5f51142a9a79a0$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    removes: [
                        {
                            index: [
                                ...$9d5f51142a9a79a0$var$getNestedCSSRulePositions(thisArg),
                                index
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return $9d5f51142a9a79a0$var$callbackWrapper(()=>{
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function $9d5f51142a9a79a0$var$initAdoptedStyleSheetObserver({ mirror: mirror, stylesheetManager: stylesheetManager }, host) {
    let hostId = null;
    if (host.nodeName === "#document") hostId = mirror.getId(host);
    else hostId = mirror.getId(host.host);
    const patchTarget = host.nodeName === "#document" ? $9d5f51142a9a79a0$var$_optionalChain$2([
        host,
        "access",
        (_4)=>_4.defaultView,
        "optionalAccess",
        (_5)=>_5.Document
    ]) : $9d5f51142a9a79a0$var$_optionalChain$2([
        host,
        "access",
        (_6)=>_6.ownerDocument,
        "optionalAccess",
        (_7)=>_7.defaultView,
        "optionalAccess",
        (_8)=>_8.ShadowRoot
    ]);
    const originalPropertyDescriptor = $9d5f51142a9a79a0$var$_optionalChain$2([
        patchTarget,
        "optionalAccess",
        (_9)=>_9.prototype
    ]) ? Object.getOwnPropertyDescriptor($9d5f51142a9a79a0$var$_optionalChain$2([
        patchTarget,
        "optionalAccess",
        (_10)=>_10.prototype
    ]), "adoptedStyleSheets") : undefined;
    if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return ()=>{};
    Object.defineProperty(host, "adoptedStyleSheets", {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get () {
            return $9d5f51142a9a79a0$var$_optionalChain$2([
                originalPropertyDescriptor,
                "access",
                (_11)=>_11.get,
                "optionalAccess",
                (_12)=>_12.call,
                "call",
                (_13)=>_13(this)
            ]);
        },
        set (sheets) {
            const result = $9d5f51142a9a79a0$var$_optionalChain$2([
                originalPropertyDescriptor,
                "access",
                (_14)=>_14.set,
                "optionalAccess",
                (_15)=>_15.call,
                "call",
                (_16)=>_16(this, sheets)
            ]);
            if (hostId !== null && hostId !== -1) try {
                stylesheetManager.adoptStyleSheets(sheets, hostId);
            } catch (e) {}
            return result;
        }
    });
    return $9d5f51142a9a79a0$var$callbackWrapper(()=>{
        Object.defineProperty(host, "adoptedStyleSheets", {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            get: originalPropertyDescriptor.get,
            set: originalPropertyDescriptor.set
        });
    });
}
function $9d5f51142a9a79a0$var$initStyleDeclarationObserver({ styleDeclarationCb: styleDeclarationCb, mirror: mirror, ignoreCSSAttributes: ignoreCSSAttributes, stylesheetManager: stylesheetManager }, { win: win }) {
    const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: $9d5f51142a9a79a0$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property, value, priority] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return setProperty.apply(thisArg, [
                property,
                value,
                priority
            ]);
            const { id: id, styleId: styleId } = $9d5f51142a9a79a0$var$getIdAndStyleId($9d5f51142a9a79a0$var$_optionalChain$2([
                thisArg,
                "access",
                (_17)=>_17.parentRule,
                "optionalAccess",
                (_18)=>_18.parentStyleSheet
            ]), mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                index: $9d5f51142a9a79a0$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: $9d5f51142a9a79a0$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return removeProperty.apply(thisArg, [
                property
            ]);
            const { id: id, styleId: styleId } = $9d5f51142a9a79a0$var$getIdAndStyleId($9d5f51142a9a79a0$var$_optionalChain$2([
                thisArg,
                "access",
                (_19)=>_19.parentRule,
                "optionalAccess",
                (_20)=>_20.parentStyleSheet
            ]), mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                remove: {
                    property: property
                },
                index: $9d5f51142a9a79a0$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return $9d5f51142a9a79a0$var$callbackWrapper(()=>{
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function $9d5f51142a9a79a0$var$initMediaInteractionObserver({ mediaInteractionCb: mediaInteractionCb, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, mirror: mirror, sampling: sampling, doc: doc }) {
    const handler = $9d5f51142a9a79a0$var$callbackWrapper((type)=>$9d5f51142a9a79a0$var$throttle$1($9d5f51142a9a79a0$var$callbackWrapper((event)=>{
            const target = $9d5f51142a9a79a0$var$getEventTarget(event);
            if (!target || $9d5f51142a9a79a0$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            const { currentTime: currentTime, volume: volume, muted: muted, playbackRate: playbackRate } = target;
            mediaInteractionCb({
                type: type,
                id: mirror.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted,
                playbackRate: playbackRate
            });
        }), sampling.media || 500));
    const handlers = [
        $9d5f51142a9a79a0$var$on("play", handler(0), doc),
        $9d5f51142a9a79a0$var$on("pause", handler(1), doc),
        $9d5f51142a9a79a0$var$on("seeked", handler(2), doc),
        $9d5f51142a9a79a0$var$on("volumechange", handler(3), doc),
        $9d5f51142a9a79a0$var$on("ratechange", handler(4), doc)
    ];
    return $9d5f51142a9a79a0$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $9d5f51142a9a79a0$var$initFontObserver({ fontCb: fontCb, doc: doc }) {
    const win = doc.defaultView;
    if (!win) return ()=>{};
    const handlers = [];
    const fontMap = new WeakMap();
    const originalFontFace = win.FontFace;
    win.FontFace = function FontFace(family, source, descriptors) {
        const fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== "string",
            descriptors: descriptors,
            fontSource: typeof source === "string" ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    const restoreHandler = $9d5f51142a9a79a0$var$patch(doc.fonts, "add", function(original) {
        return function(fontFace) {
            $9d5f51142a9a79a0$var$setTimeout$1($9d5f51142a9a79a0$var$callbackWrapper(()=>{
                const p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }), 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(()=>{
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return $9d5f51142a9a79a0$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $9d5f51142a9a79a0$var$initSelectionObserver(param) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, selectionCb: selectionCb } = param;
    let collapsed = true;
    const updateSelection = $9d5f51142a9a79a0$var$callbackWrapper(()=>{
        const selection = doc.getSelection();
        if (!selection || collapsed && $9d5f51142a9a79a0$var$_optionalChain$2([
            selection,
            "optionalAccess",
            (_21)=>_21.isCollapsed
        ])) return;
        collapsed = selection.isCollapsed || false;
        const ranges = [];
        const count = selection.rangeCount || 0;
        for(let i = 0; i < count; i++){
            const range = selection.getRangeAt(i);
            const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
            const blocked = $9d5f51142a9a79a0$var$isBlocked(startContainer, blockClass, blockSelector, unblockSelector, true) || $9d5f51142a9a79a0$var$isBlocked(endContainer, blockClass, blockSelector, unblockSelector, true);
            if (blocked) continue;
            ranges.push({
                start: mirror.getId(startContainer),
                startOffset: startOffset,
                end: mirror.getId(endContainer),
                endOffset: endOffset
            });
        }
        selectionCb({
            ranges: ranges
        });
    });
    updateSelection();
    return $9d5f51142a9a79a0$var$on("selectionchange", updateSelection);
}
function $9d5f51142a9a79a0$var$initCustomElementObserver({ doc: doc, customElementCb: customElementCb }) {
    const win = doc.defaultView;
    if (!win || !win.customElements) return ()=>{};
    const restoreHandler = $9d5f51142a9a79a0$var$patch(win.customElements, "define", function(original) {
        return function(name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name: name
                    }
                });
            } catch (e) {}
            return original.apply(this, [
                name,
                constructor,
                options
            ]);
        };
    });
    return restoreHandler;
}
function $9d5f51142a9a79a0$var$initObservers(o, _hooks = {}) {
    const currentWindow = o.doc.defaultView;
    if (!currentWindow) return ()=>{};
    const mutationObserver = $9d5f51142a9a79a0$var$initMutationObserver(o, o.doc);
    const mousemoveHandler = $9d5f51142a9a79a0$var$initMoveObserver(o);
    const mouseInteractionHandler = $9d5f51142a9a79a0$var$initMouseInteractionObserver(o);
    const scrollHandler = $9d5f51142a9a79a0$var$initScrollObserver(o);
    const viewportResizeHandler = $9d5f51142a9a79a0$var$initViewportResizeObserver(o, {
        win: currentWindow
    });
    const inputHandler = $9d5f51142a9a79a0$var$initInputObserver(o);
    const mediaInteractionHandler = $9d5f51142a9a79a0$var$initMediaInteractionObserver(o);
    const styleSheetObserver = $9d5f51142a9a79a0$var$initStyleSheetObserver(o, {
        win: currentWindow
    });
    const adoptedStyleSheetObserver = $9d5f51142a9a79a0$var$initAdoptedStyleSheetObserver(o, o.doc);
    const styleDeclarationObserver = $9d5f51142a9a79a0$var$initStyleDeclarationObserver(o, {
        win: currentWindow
    });
    const fontObserver = o.collectFonts ? $9d5f51142a9a79a0$var$initFontObserver(o) : ()=>{};
    const selectionObserver = $9d5f51142a9a79a0$var$initSelectionObserver(o);
    const customElementObserver = $9d5f51142a9a79a0$var$initCustomElementObserver(o);
    const pluginHandlers = [];
    for (const plugin of o.plugins)pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
    return $9d5f51142a9a79a0$var$callbackWrapper(()=>{
        $9d5f51142a9a79a0$var$mutationBuffers.forEach((b)=>b.reset());
        mutationObserver.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach((h)=>h());
    });
}
function $9d5f51142a9a79a0$var$hasNestedCSSRule(prop) {
    return typeof window[prop] !== "undefined";
}
function $9d5f51142a9a79a0$var$canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== "undefined" && window[prop].prototype && "insertRule" in window[prop].prototype && "deleteRule" in window[prop].prototype);
}
class $9d5f51142a9a79a0$var$CrossOriginIframeMirror {
    constructor(generateIdFn){
        this.generateIdFn = generateIdFn;
        this.iframeIdToRemoteIdMap = new WeakMap();
        this.iframeRemoteIdToIdMap = new WeakMap();
    }
    getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
        const idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
        let id = idToRemoteIdMap.get(remoteId);
        if (!id) {
            id = this.generateIdFn();
            idToRemoteIdMap.set(remoteId, id);
            remoteIdToIdMap.set(id, remoteId);
        }
        return id;
    }
    getIds(iframe, remoteId) {
        const idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return remoteId.map((id)=>this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap));
    }
    getRemoteId(iframe, id, map) {
        const remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
        if (typeof id !== "number") return id;
        const remoteId = remoteIdToIdMap.get(id);
        if (!remoteId) return -1;
        return remoteId;
    }
    getRemoteIds(iframe, ids) {
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return ids.map((id)=>this.getRemoteId(iframe, id, remoteIdToIdMap));
    }
    reset(iframe) {
        if (!iframe) {
            this.iframeIdToRemoteIdMap = new WeakMap();
            this.iframeRemoteIdToIdMap = new WeakMap();
            return;
        }
        this.iframeIdToRemoteIdMap.delete(iframe);
        this.iframeRemoteIdToIdMap.delete(iframe);
    }
    getIdToRemoteIdMap(iframe) {
        let idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
        if (!idToRemoteIdMap) {
            idToRemoteIdMap = new Map();
            this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
        }
        return idToRemoteIdMap;
    }
    getRemoteIdToIdMap(iframe) {
        let remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
        if (!remoteIdToIdMap) {
            remoteIdToIdMap = new Map();
            this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
        }
        return remoteIdToIdMap;
    }
}
function $9d5f51142a9a79a0$var$_optionalChain$1(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
class $9d5f51142a9a79a0$var$IframeManagerNoop {
    constructor(){
        this.crossOriginIframeMirror = new $9d5f51142a9a79a0$var$CrossOriginIframeMirror($9d5f51142a9a79a0$var$genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
    }
    addIframe() {}
    addLoadListener() {}
    attachIframe() {}
}
class $9d5f51142a9a79a0$var$IframeManager {
    constructor(options){
        this.iframes = new WeakMap();
        this.crossOriginIframeMap = new WeakMap();
        this.crossOriginIframeMirror = new $9d5f51142a9a79a0$var$CrossOriginIframeMirror($9d5f51142a9a79a0$var$genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new $9d5f51142a9a79a0$var$CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) window.addEventListener("message", this.handleMessage.bind(this));
    }
    addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
        if (iframeEl.contentWindow) this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
    }
    addLoadListener(cb) {
        this.loadListener = cb;
    }
    attachIframe(iframeEl, childSn) {
        this.mutationCb({
            adds: [
                {
                    parentId: this.mirror.getId(iframeEl),
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        $9d5f51142a9a79a0$var$_optionalChain$1([
            this,
            "access",
            (_)=>_.loadListener,
            "optionalCall",
            (_2)=>_2(iframeEl)
        ]);
        if (iframeEl.contentDocument && iframeEl.contentDocument.adoptedStyleSheets && iframeEl.contentDocument.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeEl.contentDocument.adoptedStyleSheets, this.mirror.getId(iframeEl.contentDocument));
    }
    handleMessage(message) {
        const crossOriginMessageEvent = message;
        if (crossOriginMessageEvent.data.type !== "rrweb" || crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
        const iframeSourceWindow = message.source;
        if (!iframeSourceWindow) return;
        const iframeEl = this.crossOriginIframeMap.get(message.source);
        if (!iframeEl) return;
        const transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
        if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
    }
    transformCrossOriginEvent(iframeEl, e) {
        switch(e.type){
            case $9d5f51142a9a79a0$var$EventType.FullSnapshot:
                {
                    this.crossOriginIframeMirror.reset(iframeEl);
                    this.crossOriginIframeStyleMirror.reset(iframeEl);
                    this.replaceIdOnNode(e.data.node, iframeEl);
                    const rootId = e.data.node.id;
                    this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                    this.patchRootIdOnNode(e.data.node, rootId);
                    return {
                        timestamp: e.timestamp,
                        type: $9d5f51142a9a79a0$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $9d5f51142a9a79a0$var$IncrementalSource.Mutation,
                            adds: [
                                {
                                    parentId: this.mirror.getId(iframeEl),
                                    nextId: null,
                                    node: e.data.node
                                }
                            ],
                            removes: [],
                            texts: [],
                            attributes: [],
                            isAttachIframe: true
                        }
                    };
                }
            case $9d5f51142a9a79a0$var$EventType.Meta:
            case $9d5f51142a9a79a0$var$EventType.Load:
            case $9d5f51142a9a79a0$var$EventType.DomContentLoaded:
                return false;
            case $9d5f51142a9a79a0$var$EventType.Plugin:
                return e;
            case $9d5f51142a9a79a0$var$EventType.Custom:
                this.replaceIds(e.data.payload, iframeEl, [
                    "id",
                    "parentId",
                    "previousId",
                    "nextId"
                ]);
                return e;
            case $9d5f51142a9a79a0$var$EventType.IncrementalSnapshot:
                switch(e.data.source){
                    case $9d5f51142a9a79a0$var$IncrementalSource.Mutation:
                        e.data.adds.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "parentId",
                                "nextId",
                                "previousId"
                            ]);
                            this.replaceIdOnNode(n.node, iframeEl);
                            const rootId = this.crossOriginIframeRootIdMap.get(iframeEl);
                            rootId && this.patchRootIdOnNode(n.node, rootId);
                        });
                        e.data.removes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "parentId",
                                "id"
                            ]);
                        });
                        e.data.attributes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "id"
                            ]);
                        });
                        e.data.texts.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "id"
                            ]);
                        });
                        return e;
                    case $9d5f51142a9a79a0$var$IncrementalSource.Drag:
                    case $9d5f51142a9a79a0$var$IncrementalSource.TouchMove:
                    case $9d5f51142a9a79a0$var$IncrementalSource.MouseMove:
                        e.data.positions.forEach((p)=>{
                            this.replaceIds(p, iframeEl, [
                                "id"
                            ]);
                        });
                        return e;
                    case $9d5f51142a9a79a0$var$IncrementalSource.ViewportResize:
                        return false;
                    case $9d5f51142a9a79a0$var$IncrementalSource.MediaInteraction:
                    case $9d5f51142a9a79a0$var$IncrementalSource.MouseInteraction:
                    case $9d5f51142a9a79a0$var$IncrementalSource.Scroll:
                    case $9d5f51142a9a79a0$var$IncrementalSource.CanvasMutation:
                    case $9d5f51142a9a79a0$var$IncrementalSource.Input:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        return e;
                    case $9d5f51142a9a79a0$var$IncrementalSource.StyleSheetRule:
                    case $9d5f51142a9a79a0$var$IncrementalSource.StyleDeclaration:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            "styleId"
                        ]);
                        return e;
                    case $9d5f51142a9a79a0$var$IncrementalSource.Font:
                        return e;
                    case $9d5f51142a9a79a0$var$IncrementalSource.Selection:
                        e.data.ranges.forEach((range)=>{
                            this.replaceIds(range, iframeEl, [
                                "start",
                                "end"
                            ]);
                        });
                        return e;
                    case $9d5f51142a9a79a0$var$IncrementalSource.AdoptedStyleSheet:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            "styleIds"
                        ]);
                        $9d5f51142a9a79a0$var$_optionalChain$1([
                            e,
                            "access",
                            (_3)=>_3.data,
                            "access",
                            (_4)=>_4.styles,
                            "optionalAccess",
                            (_5)=>_5.forEach,
                            "call",
                            (_6)=>_6((style)=>{
                                    this.replaceStyleIds(style, iframeEl, [
                                        "styleId"
                                    ]);
                                })
                        ]);
                        return e;
                }
        }
        return false;
    }
    replace(iframeMirror, obj, iframeEl, keys) {
        for (const key of keys){
            if (!Array.isArray(obj[key]) && typeof obj[key] !== "number") continue;
            if (Array.isArray(obj[key])) obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
            else obj[key] = iframeMirror.getId(iframeEl, obj[key]);
        }
        return obj;
    }
    replaceIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
    }
    replaceStyleIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
    }
    replaceIdOnNode(node, iframeEl) {
        this.replaceIds(node, iframeEl, [
            "id",
            "rootId"
        ]);
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.replaceIdOnNode(child, iframeEl);
        });
    }
    patchRootIdOnNode(node, rootId) {
        if (node.type !== $9d5f51142a9a79a0$var$NodeType$1.Document && !node.rootId) node.rootId = rootId;
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.patchRootIdOnNode(child, rootId);
        });
    }
}
class $9d5f51142a9a79a0$var$ShadowDomManagerNoop {
    init() {}
    addShadowRoot() {}
    observeAttachShadow() {}
    reset() {}
}
class $9d5f51142a9a79a0$var$ShadowDomManager {
    constructor(options){
        this.shadowDoms = new WeakSet();
        this.restoreHandlers = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
    init() {
        this.reset();
        this.patchAttachShadow(Element, document);
    }
    addShadowRoot(shadowRoot, doc) {
        if (!$9d5f51142a9a79a0$var$isNativeShadowDom(shadowRoot)) return;
        if (this.shadowDoms.has(shadowRoot)) return;
        this.shadowDoms.add(shadowRoot);
        const observer = $9d5f51142a9a79a0$var$initMutationObserver({
            ...this.bypassOptions,
            doc: doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }, shadowRoot);
        this.restoreHandlers.push(()=>observer.disconnect());
        this.restoreHandlers.push($9d5f51142a9a79a0$var$initScrollObserver({
            ...this.bypassOptions,
            scrollCb: this.scrollCb,
            doc: shadowRoot,
            mirror: this.mirror
        }));
        $9d5f51142a9a79a0$var$setTimeout$1(()=>{
            if (shadowRoot.adoptedStyleSheets && shadowRoot.adoptedStyleSheets.length > 0) this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot.adoptedStyleSheets, this.mirror.getId(shadowRoot.host));
            this.restoreHandlers.push($9d5f51142a9a79a0$var$initAdoptedStyleSheetObserver({
                mirror: this.mirror,
                stylesheetManager: this.bypassOptions.stylesheetManager
            }, shadowRoot));
        }, 0);
    }
    observeAttachShadow(iframeElement) {
        if (!iframeElement.contentWindow || !iframeElement.contentDocument) return;
        this.patchAttachShadow(iframeElement.contentWindow.Element, iframeElement.contentDocument);
    }
    patchAttachShadow(element, doc) {
        const manager = this;
        this.restoreHandlers.push($9d5f51142a9a79a0$var$patch(element.prototype, "attachShadow", function(original) {
            return function(option) {
                const shadowRoot = original.call(this, option);
                if (this.shadowRoot && $9d5f51142a9a79a0$var$inDom(this)) manager.addShadowRoot(this.shadowRoot, doc);
                return shadowRoot;
            };
        }));
    }
    reset() {
        this.restoreHandlers.forEach((handler)=>{
            try {
                handler();
            } catch (e) {}
        });
        this.restoreHandlers = [];
        this.shadowDoms = new WeakSet();
    }
}
class $9d5f51142a9a79a0$var$CanvasManagerNoop {
    reset() {}
    freeze() {}
    unfreeze() {}
    lock() {}
    unlock() {}
    snapshot() {}
}
class $9d5f51142a9a79a0$var$StylesheetManager {
    constructor(options){
        this.trackedLinkElements = new WeakSet();
        this.styleMirror = new $9d5f51142a9a79a0$var$StyleSheetMirror();
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
    attachLinkElement(linkEl, childSn) {
        if ("_cssText" in childSn.attributes) this.mutationCb({
            adds: [],
            removes: [],
            texts: [],
            attributes: [
                {
                    id: childSn.id,
                    attributes: childSn.attributes
                }
            ]
        });
        this.trackLinkElement(linkEl);
    }
    trackLinkElement(linkEl) {
        if (this.trackedLinkElements.has(linkEl)) return;
        this.trackedLinkElements.add(linkEl);
        this.trackStylesheetInLinkElement(linkEl);
    }
    adoptStyleSheets(sheets, hostId) {
        if (sheets.length === 0) return;
        const adoptedStyleSheetData = {
            id: hostId,
            styleIds: []
        };
        const styles = [];
        for (const sheet of sheets){
            let styleId;
            if (!this.styleMirror.has(sheet)) {
                styleId = this.styleMirror.add(sheet);
                styles.push({
                    styleId: styleId,
                    rules: Array.from(sheet.rules || CSSRule, (r, index)=>({
                            rule: $9d5f51142a9a79a0$var$stringifyRule(r),
                            index: index
                        }))
                });
            } else styleId = this.styleMirror.getId(sheet);
            adoptedStyleSheetData.styleIds.push(styleId);
        }
        if (styles.length > 0) adoptedStyleSheetData.styles = styles;
        this.adoptedStyleSheetCb(adoptedStyleSheetData);
    }
    reset() {
        this.styleMirror.reset();
        this.trackedLinkElements = new WeakSet();
    }
    trackStylesheetInLinkElement(linkEl) {}
}
class $9d5f51142a9a79a0$var$ProcessedNodeManager {
    constructor(){
        this.nodeMap = new WeakMap();
        this.loop = true;
        this.periodicallyClear();
    }
    periodicallyClear() {
        $9d5f51142a9a79a0$var$onRequestAnimationFrame(()=>{
            this.clear();
            if (this.loop) this.periodicallyClear();
        });
    }
    inOtherBuffer(node, thisBuffer) {
        const buffers = this.nodeMap.get(node);
        return buffers && Array.from(buffers).some((buffer)=>buffer !== thisBuffer);
    }
    add(node, buffer) {
        this.nodeMap.set(node, (this.nodeMap.get(node) || new Set()).add(buffer));
    }
    clear() {
        this.nodeMap = new WeakMap();
    }
    destroy() {
        this.loop = false;
    }
}
let $9d5f51142a9a79a0$var$wrappedEmit;
let $9d5f51142a9a79a0$var$_takeFullSnapshot;
const $9d5f51142a9a79a0$var$mirror = $9d5f51142a9a79a0$var$createMirror();
function $9d5f51142a9a79a0$var$record(options = {}) {
    const { emit: emit, checkoutEveryNms: checkoutEveryNms, checkoutEveryNth: checkoutEveryNth, blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, ignoreClass: ignoreClass = "rr-ignore", ignoreSelector: ignoreSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = "rr-mask", unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, maskAllInputs: maskAllInputs, maskInputOptions: _maskInputOptions, slimDOMOptions: _slimDOMOptions, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, maskTextFn: maskTextFn, maxCanvasSize: maxCanvasSize = null, packFn: packFn, sampling: sampling = {}, dataURLOptions: dataURLOptions = {}, mousemoveWait: mousemoveWait, recordCanvas: recordCanvas = false, recordCrossOriginIframes: recordCrossOriginIframes = false, recordAfter: recordAfter = options.recordAfter === "DOMContentLoaded" ? options.recordAfter : "load", userTriggeredOnInput: userTriggeredOnInput = false, collectFonts: collectFonts = false, inlineImages: inlineImages = false, plugins: plugins, keepIframeSrcFn: keepIframeSrcFn = ()=>false, ignoreCSSAttributes: ignoreCSSAttributes = new Set([]), errorHandler: errorHandler, onMutation: onMutation, getCanvasManager: getCanvasManager } = options;
    $9d5f51142a9a79a0$var$registerErrorHandler(errorHandler);
    const inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
    let passEmitsToParent = false;
    if (!inEmittingFrame) try {
        if (window.parent.document) passEmitsToParent = false;
    } catch (e) {
        passEmitsToParent = true;
    }
    if (inEmittingFrame && !emit) throw new Error("emit function is required");
    if (mousemoveWait !== undefined && sampling.mousemove === undefined) sampling.mousemove = mousemoveWait;
    $9d5f51142a9a79a0$var$mirror.reset();
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        radio: true,
        checkbox: true
    } : _maskInputOptions !== undefined ? _maskInputOptions : {};
    const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        headMetaAuthorship: _slimDOMOptions === "all",
        headMetaDescKeywords: _slimDOMOptions === "all"
    } : _slimDOMOptions ? _slimDOMOptions : {};
    $9d5f51142a9a79a0$var$polyfill();
    let lastFullSnapshotEvent;
    let incrementalSnapshotCount = 0;
    const eventProcessor = (e)=>{
        for (const plugin of plugins || [])if (plugin.eventProcessor) e = plugin.eventProcessor(e);
        if (packFn && !passEmitsToParent) e = packFn(e);
        return e;
    };
    $9d5f51142a9a79a0$var$wrappedEmit = (r, isCheckout)=>{
        const e = r;
        e.timestamp = $9d5f51142a9a79a0$var$nowTimestamp();
        if ((0, $avffj._optionalChain)([
            $9d5f51142a9a79a0$var$mutationBuffers,
            "access",
            (_)=>_[0],
            "optionalAccess",
            (_2)=>_2.isFrozen,
            "call",
            (_3)=>_3()
        ]) && e.type !== $9d5f51142a9a79a0$var$EventType.FullSnapshot && !(e.type === $9d5f51142a9a79a0$var$EventType.IncrementalSnapshot && e.data.source === $9d5f51142a9a79a0$var$IncrementalSource.Mutation)) $9d5f51142a9a79a0$var$mutationBuffers.forEach((buf)=>buf.unfreeze());
        if (inEmittingFrame) (0, $avffj._optionalChain)([
            emit,
            "optionalCall",
            (_4)=>_4(eventProcessor(e), isCheckout)
        ]);
        else if (passEmitsToParent) {
            const message = {
                type: "rrweb",
                event: eventProcessor(e),
                origin: window.location.origin,
                isCheckout: isCheckout
            };
            window.parent.postMessage(message, "*");
        }
        if (e.type === $9d5f51142a9a79a0$var$EventType.FullSnapshot) {
            lastFullSnapshotEvent = e;
            incrementalSnapshotCount = 0;
        } else if (e.type === $9d5f51142a9a79a0$var$EventType.IncrementalSnapshot) {
            if (e.data.source === $9d5f51142a9a79a0$var$IncrementalSource.Mutation && e.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            const exceedTime = checkoutEveryNms && lastFullSnapshotEvent && e.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) takeFullSnapshot(true);
        }
    };
    const wrappedMutationEmit = (m)=>{
        $9d5f51142a9a79a0$var$wrappedEmit({
            type: $9d5f51142a9a79a0$var$EventType.IncrementalSnapshot,
            data: {
                source: $9d5f51142a9a79a0$var$IncrementalSource.Mutation,
                ...m
            }
        });
    };
    const wrappedScrollEmit = (p)=>$9d5f51142a9a79a0$var$wrappedEmit({
            type: $9d5f51142a9a79a0$var$EventType.IncrementalSnapshot,
            data: {
                source: $9d5f51142a9a79a0$var$IncrementalSource.Scroll,
                ...p
            }
        });
    const wrappedCanvasMutationEmit = (p)=>$9d5f51142a9a79a0$var$wrappedEmit({
            type: $9d5f51142a9a79a0$var$EventType.IncrementalSnapshot,
            data: {
                source: $9d5f51142a9a79a0$var$IncrementalSource.CanvasMutation,
                ...p
            }
        });
    const wrappedAdoptedStyleSheetEmit = (a)=>$9d5f51142a9a79a0$var$wrappedEmit({
            type: $9d5f51142a9a79a0$var$EventType.IncrementalSnapshot,
            data: {
                source: $9d5f51142a9a79a0$var$IncrementalSource.AdoptedStyleSheet,
                ...a
            }
        });
    const stylesheetManager = new $9d5f51142a9a79a0$var$StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
    });
    const iframeManager = typeof __RRWEB_EXCLUDE_IFRAME__ === "boolean" && __RRWEB_EXCLUDE_IFRAME__ ? new $9d5f51142a9a79a0$var$IframeManagerNoop() : new $9d5f51142a9a79a0$var$IframeManager({
        mirror: $9d5f51142a9a79a0$var$mirror,
        mutationCb: wrappedMutationEmit,
        stylesheetManager: stylesheetManager,
        recordCrossOriginIframes: recordCrossOriginIframes,
        wrappedEmit: $9d5f51142a9a79a0$var$wrappedEmit
    });
    for (const plugin of plugins || [])if (plugin.getMirror) plugin.getMirror({
        nodeMirror: $9d5f51142a9a79a0$var$mirror,
        crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
        crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
    });
    const processedNodeManager = new $9d5f51142a9a79a0$var$ProcessedNodeManager();
    const canvasManager = $9d5f51142a9a79a0$var$_getCanvasManager(getCanvasManager, {
        mirror: $9d5f51142a9a79a0$var$mirror,
        win: window,
        mutationCb: (p)=>$9d5f51142a9a79a0$var$wrappedEmit({
                type: $9d5f51142a9a79a0$var$EventType.IncrementalSnapshot,
                data: {
                    source: $9d5f51142a9a79a0$var$IncrementalSource.CanvasMutation,
                    ...p
                }
            }),
        recordCanvas: recordCanvas,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maxCanvasSize: maxCanvasSize,
        sampling: sampling["canvas"],
        dataURLOptions: dataURLOptions,
        errorHandler: errorHandler
    });
    const shadowDomManager = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ === "boolean" && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new $9d5f51142a9a79a0$var$ShadowDomManagerNoop() : new $9d5f51142a9a79a0$var$ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            onMutation: onMutation,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            dataURLOptions: dataURLOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            stylesheetManager: stylesheetManager,
            canvasManager: canvasManager,
            keepIframeSrcFn: keepIframeSrcFn,
            processedNodeManager: processedNodeManager
        },
        mirror: $9d5f51142a9a79a0$var$mirror
    });
    const takeFullSnapshot = (isCheckout = false)=>{
        $9d5f51142a9a79a0$var$wrappedEmit({
            type: $9d5f51142a9a79a0$var$EventType.Meta,
            data: {
                href: window.location.href,
                width: $9d5f51142a9a79a0$var$getWindowWidth(),
                height: $9d5f51142a9a79a0$var$getWindowHeight()
            }
        }, isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        $9d5f51142a9a79a0$var$mutationBuffers.forEach((buf)=>buf.lock());
        const node = $9d5f51142a9a79a0$var$snapshot(document, {
            mirror: $9d5f51142a9a79a0$var$mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskInputFn: maskInputFn,
            maskTextFn: maskTextFn,
            slimDOM: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: (n)=>{
                if ($9d5f51142a9a79a0$var$isSerializedIframe(n, $9d5f51142a9a79a0$var$mirror)) iframeManager.addIframe(n);
                if ($9d5f51142a9a79a0$var$isSerializedStylesheet(n, $9d5f51142a9a79a0$var$mirror)) stylesheetManager.trackLinkElement(n);
                if ($9d5f51142a9a79a0$var$hasShadowRoot(n)) shadowDomManager.addShadowRoot(n.shadowRoot, document);
            },
            onIframeLoad: (iframe, childSn)=>{
                iframeManager.attachIframe(iframe, childSn);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: (linkEl, childSn)=>{
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            keepIframeSrcFn: keepIframeSrcFn
        });
        if (!node) return console.warn("Failed to snapshot the document");
        $9d5f51142a9a79a0$var$wrappedEmit({
            type: $9d5f51142a9a79a0$var$EventType.FullSnapshot,
            data: {
                node: node,
                initialOffset: $9d5f51142a9a79a0$var$getWindowScroll(window)
            }
        });
        $9d5f51142a9a79a0$var$mutationBuffers.forEach((buf)=>buf.unlock());
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, $9d5f51142a9a79a0$var$mirror.getId(document));
    };
    $9d5f51142a9a79a0$var$_takeFullSnapshot = takeFullSnapshot;
    try {
        const handlers = [];
        const observe = (doc)=>{
            return $9d5f51142a9a79a0$var$callbackWrapper($9d5f51142a9a79a0$var$initObservers)({
                onMutation: onMutation,
                mutationCb: wrappedMutationEmit,
                mousemoveCb: (positions, source)=>$9d5f51142a9a79a0$var$wrappedEmit({
                        type: $9d5f51142a9a79a0$var$EventType.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    }),
                mouseInteractionCb: (d)=>$9d5f51142a9a79a0$var$wrappedEmit({
                        type: $9d5f51142a9a79a0$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $9d5f51142a9a79a0$var$IncrementalSource.MouseInteraction,
                            ...d
                        }
                    }),
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: (d)=>$9d5f51142a9a79a0$var$wrappedEmit({
                        type: $9d5f51142a9a79a0$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $9d5f51142a9a79a0$var$IncrementalSource.ViewportResize,
                            ...d
                        }
                    }),
                inputCb: (v)=>$9d5f51142a9a79a0$var$wrappedEmit({
                        type: $9d5f51142a9a79a0$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $9d5f51142a9a79a0$var$IncrementalSource.Input,
                            ...v
                        }
                    }),
                mediaInteractionCb: (p)=>$9d5f51142a9a79a0$var$wrappedEmit({
                        type: $9d5f51142a9a79a0$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $9d5f51142a9a79a0$var$IncrementalSource.MediaInteraction,
                            ...p
                        }
                    }),
                styleSheetRuleCb: (r)=>$9d5f51142a9a79a0$var$wrappedEmit({
                        type: $9d5f51142a9a79a0$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $9d5f51142a9a79a0$var$IncrementalSource.StyleSheetRule,
                            ...r
                        }
                    }),
                styleDeclarationCb: (r)=>$9d5f51142a9a79a0$var$wrappedEmit({
                        type: $9d5f51142a9a79a0$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $9d5f51142a9a79a0$var$IncrementalSource.StyleDeclaration,
                            ...r
                        }
                    }),
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: (p)=>$9d5f51142a9a79a0$var$wrappedEmit({
                        type: $9d5f51142a9a79a0$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $9d5f51142a9a79a0$var$IncrementalSource.Font,
                            ...p
                        }
                    }),
                selectionCb: (p)=>{
                    $9d5f51142a9a79a0$var$wrappedEmit({
                        type: $9d5f51142a9a79a0$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $9d5f51142a9a79a0$var$IncrementalSource.Selection,
                            ...p
                        }
                    });
                },
                customElementCb: (c)=>{
                    $9d5f51142a9a79a0$var$wrappedEmit({
                        type: $9d5f51142a9a79a0$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $9d5f51142a9a79a0$var$IncrementalSource.CustomElement,
                            ...c
                        }
                    });
                },
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskAttributeFn: maskAttributeFn,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                keepIframeSrcFn: keepIframeSrcFn,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                mirror: $9d5f51142a9a79a0$var$mirror,
                iframeManager: iframeManager,
                stylesheetManager: stylesheetManager,
                shadowDomManager: shadowDomManager,
                processedNodeManager: processedNodeManager,
                canvasManager: canvasManager,
                ignoreCSSAttributes: ignoreCSSAttributes,
                plugins: (0, $avffj._optionalChain)([
                    plugins,
                    "optionalAccess",
                    (_5)=>_5.filter,
                    "call",
                    (_6)=>_6((p)=>p.observer),
                    "optionalAccess",
                    (_7)=>_7.map,
                    "call",
                    (_8)=>_8((p)=>({
                                observer: p.observer,
                                options: p.options,
                                callback: (payload)=>$9d5f51142a9a79a0$var$wrappedEmit({
                                        type: $9d5f51142a9a79a0$var$EventType.Plugin,
                                        data: {
                                            plugin: p.name,
                                            payload: payload
                                        }
                                    })
                            }))
                ]) || []
            }, {});
        };
        iframeManager.addLoadListener((iframeEl)=>{
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        const init = ()=>{
            takeFullSnapshot();
            handlers.push(observe(document));
        };
        if (document.readyState === "interactive" || document.readyState === "complete") init();
        else {
            handlers.push($9d5f51142a9a79a0$var$on("DOMContentLoaded", ()=>{
                $9d5f51142a9a79a0$var$wrappedEmit({
                    type: $9d5f51142a9a79a0$var$EventType.DomContentLoaded,
                    data: {}
                });
                if (recordAfter === "DOMContentLoaded") init();
            }));
            handlers.push($9d5f51142a9a79a0$var$on("load", ()=>{
                $9d5f51142a9a79a0$var$wrappedEmit({
                    type: $9d5f51142a9a79a0$var$EventType.Load,
                    data: {}
                });
                if (recordAfter === "load") init();
            }, window));
        }
        return ()=>{
            handlers.forEach((h)=>h());
            processedNodeManager.destroy();
            $9d5f51142a9a79a0$var$_takeFullSnapshot = undefined;
            $9d5f51142a9a79a0$var$unregisterErrorHandler();
        };
    } catch (error) {
        console.warn(error);
    }
}
function $9d5f51142a9a79a0$var$takeFullSnapshot(isCheckout) {
    if (!$9d5f51142a9a79a0$var$_takeFullSnapshot) throw new Error("please take full snapshot after start recording");
    $9d5f51142a9a79a0$var$_takeFullSnapshot(isCheckout);
}
$9d5f51142a9a79a0$var$record.mirror = $9d5f51142a9a79a0$var$mirror;
$9d5f51142a9a79a0$var$record.takeFullSnapshot = $9d5f51142a9a79a0$var$takeFullSnapshot;
function $9d5f51142a9a79a0$var$_getCanvasManager(getCanvasManagerFn, options) {
    try {
        return getCanvasManagerFn ? getCanvasManagerFn(options) : new $9d5f51142a9a79a0$var$CanvasManagerNoop();
    } catch (e2) {
        console.warn("Unable to initialize CanvasManager");
        return new $9d5f51142a9a79a0$var$CanvasManagerNoop();
    }
}
const $9d5f51142a9a79a0$var$ReplayEventTypeIncrementalSnapshot = 3;
const $9d5f51142a9a79a0$var$ReplayEventTypeCustom = 5;
/**
 * Converts a timestamp to ms, if it was in s, or keeps it as ms.
 */ function $9d5f51142a9a79a0$var$timestampToMs(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp : timestamp * 1000;
}
/**
 * Converts a timestamp to s, if it was in ms, or keeps it as s.
 */ function $9d5f51142a9a79a0$var$timestampToS(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Add a breadcrumb event to replay.
 */ function $9d5f51142a9a79a0$var$addBreadcrumbEvent(replay, breadcrumb) {
    if (breadcrumb.category === "sentry.transaction") return;
    if ([
        "ui.click",
        "ui.input"
    ].includes(breadcrumb.category)) replay.triggerUserActivity();
    else replay.checkAndHandleExpiredSession();
    replay.addUpdate(()=>{
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $9d5f51142a9a79a0$var$EventType.Custom,
            // TODO: We were converting from ms to seconds for breadcrumbs, spans,
            // but maybe we should just keep them as milliseconds
            timestamp: (breadcrumb.timestamp || 0) * 1000,
            data: {
                tag: "breadcrumb",
                // normalize to max. 10 depth and 1_000 properties per object
                payload: (0, $6l9XD.normalize)(breadcrumb, 10, 1000)
            }
        });
        // Do not flush after console log messages
        return breadcrumb.category === "console";
    });
}
const $9d5f51142a9a79a0$var$INTERACTIVE_SELECTOR = "button,a";
/** Get the closest interactive parent element, or else return the given element. */ function $9d5f51142a9a79a0$var$getClosestInteractive(element) {
    const closestInteractive = element.closest($9d5f51142a9a79a0$var$INTERACTIVE_SELECTOR);
    return closestInteractive || element;
}
/**
 * For clicks, we check if the target is inside of a button or link
 * If so, we use this as the target instead
 * This is useful because if you click on the image in <button><img></button>,
 * The target will be the image, not the button, which we don't want here
 */ function $9d5f51142a9a79a0$var$getClickTargetNode(event) {
    const target = $9d5f51142a9a79a0$var$getTargetNode(event);
    if (!target || !(target instanceof Element)) return target;
    return $9d5f51142a9a79a0$var$getClosestInteractive(target);
}
/** Get the event target node. */ function $9d5f51142a9a79a0$var$getTargetNode(event) {
    if ($9d5f51142a9a79a0$var$isEventWithTarget(event)) return event.target;
    return event;
}
function $9d5f51142a9a79a0$var$isEventWithTarget(event) {
    return typeof event === "object" && !!event && "target" in event;
}
let $9d5f51142a9a79a0$var$handlers;
/**
 * Register a handler to be called when `window.open()` is called.
 * Returns a cleanup function.
 */ function $9d5f51142a9a79a0$var$onWindowOpen(cb) {
    // Ensure to only register this once
    if (!$9d5f51142a9a79a0$var$handlers) {
        $9d5f51142a9a79a0$var$handlers = [];
        $9d5f51142a9a79a0$var$monkeyPatchWindowOpen();
    }
    $9d5f51142a9a79a0$var$handlers.push(cb);
    return ()=>{
        const pos = $9d5f51142a9a79a0$var$handlers ? $9d5f51142a9a79a0$var$handlers.indexOf(cb) : -1;
        if (pos > -1) $9d5f51142a9a79a0$var$handlers.splice(pos, 1);
    };
}
function $9d5f51142a9a79a0$var$monkeyPatchWindowOpen() {
    (0, $8WMel.fill)($9d5f51142a9a79a0$var$WINDOW, "open", function(originalWindowOpen) {
        return function(...args) {
            if ($9d5f51142a9a79a0$var$handlers) try {
                $9d5f51142a9a79a0$var$handlers.forEach((handler)=>handler());
            } catch (e) {
            // ignore errors in here
            }
            return originalWindowOpen.apply($9d5f51142a9a79a0$var$WINDOW, args);
        };
    });
}
/** Handle a click. */ function $9d5f51142a9a79a0$var$handleClick(clickDetector, clickBreadcrumb, node) {
    clickDetector.handleClick(clickBreadcrumb, node);
}
/** A click detector class that can be used to detect slow or rage clicks on elements. */ class $9d5f51142a9a79a0$var$ClickDetector {
    // protected for testing
    constructor(replay, slowClickConfig, // Just for easier testing
    _addBreadcrumbEvent = $9d5f51142a9a79a0$var$addBreadcrumbEvent){
        this._lastMutation = 0;
        this._lastScroll = 0;
        this._clicks = [];
        // We want everything in s, but options are in ms
        this._timeout = slowClickConfig.timeout / 1000;
        this._threshold = slowClickConfig.threshold / 1000;
        this._scollTimeout = slowClickConfig.scrollTimeout / 1000;
        this._replay = replay;
        this._ignoreSelector = slowClickConfig.ignoreSelector;
        this._addBreadcrumbEvent = _addBreadcrumbEvent;
    }
    /** Register click detection handlers on mutation or scroll. */ addListeners() {
        const cleanupWindowOpen = $9d5f51142a9a79a0$var$onWindowOpen(()=>{
            // Treat window.open as mutation
            this._lastMutation = $9d5f51142a9a79a0$var$nowInSeconds();
        });
        this._teardown = ()=>{
            cleanupWindowOpen();
            this._clicks = [];
            this._lastMutation = 0;
            this._lastScroll = 0;
        };
    }
    /** Clean up listeners. */ removeListeners() {
        if (this._teardown) this._teardown();
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
    }
    /** @inheritDoc */ handleClick(breadcrumb, node) {
        if ($9d5f51142a9a79a0$var$ignoreElement(node, this._ignoreSelector) || !$9d5f51142a9a79a0$var$isClickBreadcrumb(breadcrumb)) return;
        const newClick = {
            timestamp: $9d5f51142a9a79a0$var$timestampToS(breadcrumb.timestamp),
            clickBreadcrumb: breadcrumb,
            // Set this to 0 so we know it originates from the click breadcrumb
            clickCount: 0,
            node: node
        };
        // If there was a click in the last 1s on the same element, ignore it - only keep a single reference per second
        if (this._clicks.some((click)=>click.node === newClick.node && Math.abs(click.timestamp - newClick.timestamp) < 1)) return;
        this._clicks.push(newClick);
        // If this is the first new click, set a timeout to check for multi clicks
        if (this._clicks.length === 1) this._scheduleCheckClicks();
    }
    /** @inheritDoc */ registerMutation(timestamp = Date.now()) {
        this._lastMutation = $9d5f51142a9a79a0$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerScroll(timestamp = Date.now()) {
        this._lastScroll = $9d5f51142a9a79a0$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerClick(element) {
        const node = $9d5f51142a9a79a0$var$getClosestInteractive(element);
        this._handleMultiClick(node);
    }
    /** Count multiple clicks on elements. */ _handleMultiClick(node) {
        this._getClicks(node).forEach((click)=>{
            click.clickCount++;
        });
    }
    /** Get all pending clicks for a given node. */ _getClicks(node) {
        return this._clicks.filter((click)=>click.node === node);
    }
    /** Check the clicks that happened. */ _checkClicks() {
        const timedOutClicks = [];
        const now = $9d5f51142a9a79a0$var$nowInSeconds();
        this._clicks.forEach((click)=>{
            if (!click.mutationAfter && this._lastMutation) click.mutationAfter = click.timestamp <= this._lastMutation ? this._lastMutation - click.timestamp : undefined;
            if (!click.scrollAfter && this._lastScroll) click.scrollAfter = click.timestamp <= this._lastScroll ? this._lastScroll - click.timestamp : undefined;
            // All of these are in seconds!
            if (click.timestamp + this._timeout <= now) timedOutClicks.push(click);
        });
        // Remove "old" clicks
        for (const click of timedOutClicks){
            const pos = this._clicks.indexOf(click);
            if (pos > -1) {
                this._generateBreadcrumbs(click);
                this._clicks.splice(pos, 1);
            }
        }
        // Trigger new check, unless no clicks left
        if (this._clicks.length) this._scheduleCheckClicks();
    }
    /** Generate matching breadcrumb(s) for the click. */ _generateBreadcrumbs(click) {
        const replay = this._replay;
        const hadScroll = click.scrollAfter && click.scrollAfter <= this._scollTimeout;
        const hadMutation = click.mutationAfter && click.mutationAfter <= this._threshold;
        const isSlowClick = !hadScroll && !hadMutation;
        const { clickCount: clickCount, clickBreadcrumb: clickBreadcrumb } = click;
        // Slow click
        if (isSlowClick) {
            // If `mutationAfter` is set, it means a mutation happened after the threshold, but before the timeout
            // If not, it means we just timed out without scroll & mutation
            const timeAfterClickMs = Math.min(click.mutationAfter || this._timeout, this._timeout) * 1000;
            const endReason = timeAfterClickMs < this._timeout * 1000 ? "mutation" : "timeout";
            const breadcrumb = {
                type: "default",
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: "ui.slowClickDetected",
                data: {
                    ...clickBreadcrumb.data,
                    url: $9d5f51142a9a79a0$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    timeAfterClickMs: timeAfterClickMs,
                    endReason: endReason,
                    // If clickCount === 0, it means multiClick was not correctly captured here
                    // - we still want to send 1 in this case
                    clickCount: clickCount || 1
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
            return;
        }
        // Multi click
        if (clickCount > 1) {
            const breadcrumb = {
                type: "default",
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: "ui.multiClick",
                data: {
                    ...clickBreadcrumb.data,
                    url: $9d5f51142a9a79a0$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    clickCount: clickCount,
                    metric: true
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
        }
    }
    /** Schedule to check current clicks. */ _scheduleCheckClicks() {
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
        this._checkClickTimeout = setTimeout(()=>this._checkClicks(), 1000);
    }
}
const $9d5f51142a9a79a0$var$SLOW_CLICK_TAGS = [
    "A",
    "BUTTON",
    "INPUT"
];
/** exported for tests only */ function $9d5f51142a9a79a0$var$ignoreElement(node, ignoreSelector) {
    if (!$9d5f51142a9a79a0$var$SLOW_CLICK_TAGS.includes(node.tagName)) return true;
    // If <input> tag, we only want to consider input[type='submit'] & input[type='button']
    if (node.tagName === "INPUT" && ![
        "submit",
        "button"
    ].includes(node.getAttribute("type") || "")) return true;
    // If <a> tag, detect special variants that may not lead to an action
    // If target !== _self, we may open the link somewhere else, which would lead to no action
    // Also, when downloading a file, we may not leave the page, but still not trigger an action
    if (node.tagName === "A" && (node.hasAttribute("download") || node.hasAttribute("target") && node.getAttribute("target") !== "_self")) return true;
    if (ignoreSelector && node.matches(ignoreSelector)) return true;
    return false;
}
function $9d5f51142a9a79a0$var$isClickBreadcrumb(breadcrumb) {
    return !!(breadcrumb.data && typeof breadcrumb.data.nodeId === "number" && breadcrumb.timestamp);
}
// This is good enough for us, and is easier to test/mock than `timestampInSeconds`
function $9d5f51142a9a79a0$var$nowInSeconds() {
    return Date.now() / 1000;
}
/** Update the click detector based on a recording event of rrweb. */ function $9d5f51142a9a79a0$var$updateClickDetectorForRecordingEvent(clickDetector, event) {
    try {
        // note: We only consider incremental snapshots here
        // This means that any full snapshot is ignored for mutation detection - the reason is that we simply cannot know if a mutation happened here.
        // E.g. think that we are buffering, an error happens and we take a full snapshot because we switched to session mode -
        // in this scenario, we would not know if a dead click happened because of the error, which is a key dead click scenario.
        // Instead, by ignoring full snapshots, we have the risk that we generate a false positive
        // (if a mutation _did_ happen but was "swallowed" by the full snapshot)
        // But this should be more unlikely as we'd generally capture the incremental snapshot right away
        if (!$9d5f51142a9a79a0$var$isIncrementalEvent(event)) return;
        const { source: source } = event.data;
        if (source === $9d5f51142a9a79a0$var$IncrementalSource.Mutation) clickDetector.registerMutation(event.timestamp);
        if (source === $9d5f51142a9a79a0$var$IncrementalSource.Scroll) clickDetector.registerScroll(event.timestamp);
        if ($9d5f51142a9a79a0$var$isIncrementalMouseInteraction(event)) {
            const { type: type, id: id } = event.data;
            const node = $9d5f51142a9a79a0$var$record.mirror.getNode(id);
            if (node instanceof HTMLElement && type === $9d5f51142a9a79a0$var$MouseInteractions.Click) clickDetector.registerClick(node);
        }
    } catch (e) {
    // ignore errors here, e.g. if accessing something that does not exist
    }
}
function $9d5f51142a9a79a0$var$isIncrementalEvent(event) {
    return event.type === $9d5f51142a9a79a0$var$ReplayEventTypeIncrementalSnapshot;
}
function $9d5f51142a9a79a0$var$isIncrementalMouseInteraction(event) {
    return event.data.source === $9d5f51142a9a79a0$var$IncrementalSource.MouseInteraction;
}
/**
 * Create a breadcrumb for a replay.
 */ function $9d5f51142a9a79a0$var$createBreadcrumb(breadcrumb) {
    return {
        timestamp: Date.now() / 1000,
        type: "default",
        ...breadcrumb
    };
}
var $9d5f51142a9a79a0$var$NodeType;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($9d5f51142a9a79a0$var$NodeType || ($9d5f51142a9a79a0$var$NodeType = {}));
// Note that these are the serialized attributes and not attributes directly on
// the DOM Node. Attributes we are interested in:
const $9d5f51142a9a79a0$var$ATTRIBUTES_TO_RECORD = new Set([
    "id",
    "class",
    "aria-label",
    "role",
    "name",
    "alt",
    "title",
    "data-test-id",
    "data-testid",
    "disabled",
    "aria-disabled",
    "data-sentry-component"
]);
/**
 * Inclusion list of attributes that we want to record from the DOM element
 */ function $9d5f51142a9a79a0$var$getAttributesToRecord(attributes) {
    const obj = {};
    for(const key in attributes)if ($9d5f51142a9a79a0$var$ATTRIBUTES_TO_RECORD.has(key)) {
        let normalizedKey = key;
        if (key === "data-testid" || key === "data-test-id") normalizedKey = "testId";
        obj[normalizedKey] = attributes[key];
    }
    return obj;
}
const $9d5f51142a9a79a0$var$handleDomListener = (replay)=>{
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $9d5f51142a9a79a0$var$handleDom(handlerData);
        if (!result) return;
        const isClick = handlerData.name === "click";
        const event = isClick ? handlerData.event : undefined;
        // Ignore clicks if ctrl/alt/meta/shift keys are held down as they alter behavior of clicks (e.g. open in new tab)
        if (isClick && replay.clickDetector && event && event.target && !event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) $9d5f51142a9a79a0$var$handleClick(replay.clickDetector, result, $9d5f51142a9a79a0$var$getClickTargetNode(handlerData.event));
        $9d5f51142a9a79a0$var$addBreadcrumbEvent(replay, result);
    };
};
/** Get the base DOM breadcrumb. */ function $9d5f51142a9a79a0$var$getBaseDomBreadcrumb(target, message) {
    const nodeId = $9d5f51142a9a79a0$var$record.mirror.getId(target);
    const node = nodeId && $9d5f51142a9a79a0$var$record.mirror.getNode(nodeId);
    const meta = node && $9d5f51142a9a79a0$var$record.mirror.getMeta(node);
    const element = meta && $9d5f51142a9a79a0$var$isElement(meta) ? meta : null;
    return {
        message: message,
        data: element ? {
            nodeId: nodeId,
            node: {
                id: nodeId,
                tagName: element.tagName,
                textContent: Array.from(element.childNodes).map((node)=>node.type === $9d5f51142a9a79a0$var$NodeType.Text && node.textContent).filter(Boolean) // filter out empty values
                .map((text)=>text.trim()).join(""),
                attributes: $9d5f51142a9a79a0$var$getAttributesToRecord(element.attributes)
            }
        } : {}
    };
}
/**
 * An event handler to react to DOM events.
 * Exported for tests.
 */ function $9d5f51142a9a79a0$var$handleDom(handlerData) {
    const { target: target, message: message } = $9d5f51142a9a79a0$var$getDomTarget(handlerData);
    return $9d5f51142a9a79a0$var$createBreadcrumb({
        category: `ui.${handlerData.name}`,
        ...$9d5f51142a9a79a0$var$getBaseDomBreadcrumb(target, message)
    });
}
function $9d5f51142a9a79a0$var$getDomTarget(handlerData) {
    const isClick = handlerData.name === "click";
    let message;
    let target = null;
    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
        target = isClick ? $9d5f51142a9a79a0$var$getClickTargetNode(handlerData.event) : $9d5f51142a9a79a0$var$getTargetNode(handlerData.event);
        message = (0, $db3mB.htmlTreeAsString)(target, {
            maxStringLength: 200
        }) || "<unknown>";
    } catch (e) {
        message = "<unknown>";
    }
    return {
        target: target,
        message: message
    };
}
function $9d5f51142a9a79a0$var$isElement(node) {
    return node.type === $9d5f51142a9a79a0$var$NodeType.Element;
}
/** Handle keyboard events & create breadcrumbs. */ function $9d5f51142a9a79a0$var$handleKeyboardEvent(replay, event) {
    if (!replay.isEnabled()) return;
    // Update user activity, but do not restart recording as it can create
    // noisy/low-value replays (e.g. user comes back from idle, hits alt-tab, new
    // session with a single "keydown" breadcrumb is created)
    replay.updateUserActivity();
    const breadcrumb = $9d5f51142a9a79a0$var$getKeyboardBreadcrumb(event);
    if (!breadcrumb) return;
    $9d5f51142a9a79a0$var$addBreadcrumbEvent(replay, breadcrumb);
}
/** exported only for tests */ function $9d5f51142a9a79a0$var$getKeyboardBreadcrumb(event) {
    const { metaKey: metaKey, shiftKey: shiftKey, ctrlKey: ctrlKey, altKey: altKey, key: key, target: target } = event;
    // never capture for input fields
    if (!target || $9d5f51142a9a79a0$var$isInputElement(target) || !key) return null;
    // Note: We do not consider shift here, as that means "uppercase"
    const hasModifierKey = metaKey || ctrlKey || altKey;
    const isCharacterKey = key.length === 1; // other keys like Escape, Tab, etc have a longer length
    // Do not capture breadcrumb if only a word key is pressed
    // This could leak e.g. user input
    if (!hasModifierKey && isCharacterKey) return null;
    const message = (0, $db3mB.htmlTreeAsString)(target, {
        maxStringLength: 200
    }) || "<unknown>";
    const baseBreadcrumb = $9d5f51142a9a79a0$var$getBaseDomBreadcrumb(target, message);
    return $9d5f51142a9a79a0$var$createBreadcrumb({
        category: "ui.keyDown",
        message: message,
        data: {
            ...baseBreadcrumb.data,
            metaKey: metaKey,
            shiftKey: shiftKey,
            ctrlKey: ctrlKey,
            altKey: altKey,
            key: key
        }
    });
}
function $9d5f51142a9a79a0$var$isInputElement(target) {
    return target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable;
}
// Map entryType -> function to normalize data for event
const $9d5f51142a9a79a0$var$ENTRY_TYPES = {
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    resource: $9d5f51142a9a79a0$var$createResourceEntry,
    paint: $9d5f51142a9a79a0$var$createPaintEntry,
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    navigation: $9d5f51142a9a79a0$var$createNavigationEntry
};
/**
 * Create replay performance entries from the browser performance entries.
 */ function $9d5f51142a9a79a0$var$createPerformanceEntries(entries) {
    return entries.map($9d5f51142a9a79a0$var$createPerformanceEntry).filter(Boolean);
}
function $9d5f51142a9a79a0$var$createPerformanceEntry(entry) {
    if (!$9d5f51142a9a79a0$var$ENTRY_TYPES[entry.entryType]) return null;
    return $9d5f51142a9a79a0$var$ENTRY_TYPES[entry.entryType](entry);
}
function $9d5f51142a9a79a0$var$getAbsoluteTime(time) {
    // browserPerformanceTimeOrigin can be undefined if `performance` or
    // `performance.now` doesn't exist, but this is already checked by this integration
    return (((0, $bA8KD.browserPerformanceTimeOrigin) || $9d5f51142a9a79a0$var$WINDOW.performance.timeOrigin) + time) / 1000;
}
function $9d5f51142a9a79a0$var$createPaintEntry(entry) {
    const { duration: duration, entryType: entryType, name: name, startTime: startTime } = entry;
    const start = $9d5f51142a9a79a0$var$getAbsoluteTime(startTime);
    return {
        type: entryType,
        name: name,
        start: start,
        end: start + duration,
        data: undefined
    };
}
function $9d5f51142a9a79a0$var$createNavigationEntry(entry) {
    const { entryType: entryType, name: name, decodedBodySize: decodedBodySize, duration: duration, domComplete: domComplete, encodedBodySize: encodedBodySize, domContentLoadedEventStart: domContentLoadedEventStart, domContentLoadedEventEnd: domContentLoadedEventEnd, domInteractive: domInteractive, loadEventStart: loadEventStart, loadEventEnd: loadEventEnd, redirectCount: redirectCount, startTime: startTime, transferSize: transferSize, type: type } = entry;
    // Ignore entries with no duration, they do not seem to be useful and cause dupes
    if (duration === 0) return null;
    return {
        type: `${entryType}.${type}`,
        start: $9d5f51142a9a79a0$var$getAbsoluteTime(startTime),
        end: $9d5f51142a9a79a0$var$getAbsoluteTime(domComplete),
        name: name,
        data: {
            size: transferSize,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize,
            duration: duration,
            domInteractive: domInteractive,
            domContentLoadedEventStart: domContentLoadedEventStart,
            domContentLoadedEventEnd: domContentLoadedEventEnd,
            loadEventStart: loadEventStart,
            loadEventEnd: loadEventEnd,
            domComplete: domComplete,
            redirectCount: redirectCount
        }
    };
}
function $9d5f51142a9a79a0$var$createResourceEntry(entry) {
    const { entryType: entryType, initiatorType: initiatorType, name: name, responseEnd: responseEnd, startTime: startTime, decodedBodySize: decodedBodySize, encodedBodySize: encodedBodySize, responseStatus: responseStatus, transferSize: transferSize } = entry;
    // Core SDK handles these
    if ([
        "fetch",
        "xmlhttprequest"
    ].includes(initiatorType)) return null;
    return {
        type: `${entryType}.${initiatorType}`,
        start: $9d5f51142a9a79a0$var$getAbsoluteTime(startTime),
        end: $9d5f51142a9a79a0$var$getAbsoluteTime(responseEnd),
        name: name,
        data: {
            size: transferSize,
            statusCode: responseStatus,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize
        }
    };
}
/**
 * Add a LCP event to the replay based on an LCP metric.
 */ function $9d5f51142a9a79a0$var$getLargestContentfulPaint(metric) {
    const entries = metric.entries;
    const lastEntry = entries[entries.length - 1];
    const element = lastEntry ? lastEntry.element : undefined;
    const value = metric.value;
    const end = $9d5f51142a9a79a0$var$getAbsoluteTime(value);
    const data = {
        type: "largest-contentful-paint",
        name: "largest-contentful-paint",
        start: end,
        end: end,
        data: {
            value: value,
            size: value,
            nodeId: element ? $9d5f51142a9a79a0$var$record.mirror.getId(element) : undefined
        }
    };
    return data;
}
/**
 * Sets up a PerformanceObserver to listen to all performance entry types.
 * Returns a callback to stop observing.
 */ function $9d5f51142a9a79a0$var$setupPerformanceObserver(replay) {
    function addPerformanceEntry(entry) {
        // It is possible for entries to come up multiple times
        if (!replay.performanceEntries.includes(entry)) replay.performanceEntries.push(entry);
    }
    function onEntries({ entries: entries }) {
        entries.forEach(addPerformanceEntry);
    }
    const clearCallbacks = [];
    [
        "navigation",
        "paint",
        "resource"
    ].forEach((type)=>{
        clearCallbacks.push((0, $hqqce.addPerformanceInstrumentationHandler)(type, onEntries));
    });
    clearCallbacks.push((0, $hqqce.addLcpInstrumentationHandler)(({ metric: metric })=>{
        replay.replayPerformanceEntries.push($9d5f51142a9a79a0$var$getLargestContentfulPaint(metric));
    }));
    // A callback to cleanup all handlers
    return ()=>{
        clearCallbacks.forEach((clearCallback)=>clearCallback());
    };
}
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $9d5f51142a9a79a0$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;
const $9d5f51142a9a79a0$var$r = `var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),a=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=function(t,e){for(var i=new n(31),a=0;a<31;++a)i[a]=e+=1<<t[a-1];var s=new r(i[30]);for(a=1;a<30;++a)for(var o=i[a];o<i[a+1];++o)s[o]=o-i[a]<<5|a;return{b:i,r:s}},o=s(e,2),f=o.b,h=o.r;f[28]=258,h[258]=28;for(var l=s(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,a=0,s=new n(r);a<i;++a)t[a]&&++s[t[a]-1];var o,f=new n(r);for(a=1;a<r;++a)f[a]=f[a-1]+s[a-1]<<1;if(e){o=new n(1<<r);var h=15-r;for(a=0;a<i;++a)if(t[a])for(var l=a<<4|t[a],c=r-t[a],v=f[t[a]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>h]=l}else for(o=new n(i),a=0;a<i;++a)t[a]&&(o[a]=u[f[t[a]-1]++]>>15-t[a]);return o},g=new t(288);for(c=0;c<144;++c)g[c]=8;for(c=144;c<256;++c)g[c]=9;for(c=256;c<280;++c)g[c]=7;for(c=280;c<288;++c)g[c]=8;var w=new t(32);for(c=0;c<32;++c)w[c]=5;var p=d(g,9,0),y=d(w,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==r||r<0)&&(r=0),(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},A=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},_=function(r,e){for(var i=[],a=0;a<r.length;++a)r[a]&&i.push({s:a,f:r[a]});var s=i.length,o=i.slice();if(!s)return{t:F,l:0};if(1==s){var f=new t(i[0].s+1);return f[i[0].s]=1,{t:f,l:1}}i.sort((function(t,n){return t.f-n.f})),i.push({s:-1,f:25001});var h=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:h.f+l.f,l:h,r:l};c!=s-1;)h=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:h.f+l.f,l:h,r:l};var d=o[0].s;for(a=1;a<s;++a)o[a].s>d&&(d=o[a].s);var g=new n(d+1),w=x(i[c-1],g,0);if(w>e){a=0;var p=0,y=w-e,m=1<<y;for(o.sort((function(t,n){return g[n.s]-g[t.s]||t.f-n.f}));a<s;++a){var b=o[a].s;if(!(g[b]>e))break;p+=m-(1<<w-g[b]),g[b]=e}for(p>>=y;p>0;){var M=o[a].s;g[M]<e?p-=1<<e-g[M]++-1:++a}for(;a>=0&&p;--a){var E=o[a].s;g[E]==e&&(--g[E],++p)}w=e}return{t:new t(g),l:w}},x=function(t,n,r){return-1==t.s?Math.max(x(t.l,n,r+1),x(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,a=t[0],s=1,o=function(t){e[i++]=t},f=1;f<=r;++f)if(t[f]==a&&f!=r)++s;else{if(!a&&s>2){for(;s>138;s-=138)o(32754);s>2&&(o(s>10?s-11<<5|28690:s-3<<5|12305),s=0)}else if(s>3){for(o(a),--s;s>6;s-=6)o(8304);s>2&&(o(s-3<<5|8208),s=0)}for(;s--;)o(a);s=1,a=t[f]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var a=0;a<e;++a)t[i+a+4]=r[a];return 8*(i+4+e)},C=function(t,r,s,o,f,h,l,u,c,v,m){z(r,m++,s),++f[256];for(var b=_(f,15),M=b.t,E=b.l,x=_(h,15),C=x.t,U=x.l,F=D(M),I=F.c,S=F.n,L=D(C),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=_(q,7),H=G.t,J=G.l,K=19;K>4&&!H[a[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(f,g)+T(h,w)+l,X=T(f,M)+T(h,C)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(C,U,0),R=C;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[a[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=p,P=g,Q=y,R=w;for(B=0;B<u;++B){var rt=o[B];if(rt>255){A(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;A(r,m,Q[et]),m+=R[et],et>3&&(A(r,m,rt>>5&8191),m+=i[et])}else A(r,m,N[rt]),m+=P[rt]}return A(r,m,N[256]),m+P[256]},U=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,a=0|r.length,s=0;s!=a;){for(var o=Math.min(s+2655,a);s<o;++s)i+=e+=r[s];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},L=function(a,s,o,f,u){if(!u&&(u={l:1},s.dictionary)){var c=s.dictionary.subarray(-32768),v=new t(c.length+a.length);v.set(c),v.set(a,c.length),a=v,u.w=c.length}return function(a,s,o,f,u,c){var v=c.z||a.length,d=new t(f+v+5*(1+Math.ceil(v/7e3))+u),g=d.subarray(f,d.length-u),w=c.l,p=7&(c.r||0);if(s){p&&(g[0]=c.r>>3);for(var y=U[s-1],M=y>>13,E=8191&y,z=(1<<o)-1,A=c.p||new n(32768),_=c.h||new n(z+1),x=Math.ceil(o/3),D=2*x,T=function(t){return(a[t]^a[t+1]<<x^a[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=_[H];if(A[J]=K,_[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!w)){p=C(a,g,0,F,I,S,O,q,G,j-G,p),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(a[j+Q]==a[j+Q-W]){for(var $=0;$<Z&&a[j+$]==a[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-A[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=A[J])&32767}if(R){F[q++]=268435456|h[Q]<<18|l[R];var it=31&h[Q],at=31&l[R];O+=e[it]+i[at],++I[257+it],++S[at],B=j+Q,++L}else F[q++]=a[j],++I[a[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=a[j],++I[a[j]];p=C(a,g,w,F,I,S,O,q,G,j-G,p),w||(c.r=7&p|g[p/8|0]<<3,p-=7,c.h=_,c.p=A,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+w;j+=65535){var st=j+65535;st>=v&&(g[p/8|0]=w,st=v),p=k(g,p+1,a.subarray(j,st))}c.i=v}return b(d,0,f+m(p)+u)}(a,null==s.level?6:s.level,null==s.mem?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(a.length)))):12+s.mem,o,f,u)},O=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},j=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(L(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var a=this.b.length-this.s.z;a&&(this.b.set(n.subarray(0,a),this.s.z),this.s.z=this.b.length,this.p(this.b,!1)),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(a),32768),this.s.z=n.length-a+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n}();function q(t,n){n||(n={});var r=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}}(),e=t.length;r.p(t);var i,a=L(t,n,10+((i=n).filename?i.filename.length+1:0),8),s=a.length;return function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&O(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}}(a,n),O(a,s-8,r.d()),O(a,s-4,e),a}var B=function(){function t(t,n){this.c=S(),this.v=1,j.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),j.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=L(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=S();i.p(n.dictionary),O(t,2,i.d())}}(r,this.o),this.v=0),n&&O(r,r.length-4,this.c.d()),this.ondata(r,n)},t}(),G="undefined"!=typeof TextEncoder&&new TextEncoder,H="undefined"!=typeof TextDecoder&&new TextDecoder;try{H.decode(F,{stream:!0})}catch(t){}var J=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(K(t),this.d=n||!1)},t}();function K(n,r){if(r){for(var e=new t(n.length),i=0;i<n.length;++i)e[i]=n.charCodeAt(i);return e}if(G)return G.encode(n);var a=n.length,s=new t(n.length+(n.length>>1)),o=0,f=function(t){s[o++]=t};for(i=0;i<a;++i){if(o+5>s.length){var h=new t(o+8+(a-i<<1));h.set(s),s=h}var l=n.charCodeAt(i);l<128||r?f(l):l<2048?(f(192|l>>6),f(128|63&l)):l>55295&&l<57344?(f(240|(l=65536+(1047552&l)|1023&n.charCodeAt(++i))>>18),f(128|l>>12&63),f(128|l>>6&63),f(128|63&l)):(f(224|l>>12),f(128|l>>6&63),f(128|63&l))}return b(s,0,o)}const N=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(let r=0,e=t.length;r<e;r++)n+=t[r].length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new B,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new J(((t,n)=>{this.deflate.push(t,n)})),this.stream.push("[")}},P={clear:()=>{N.clear()},addEvent:t=>N.addEvent(t),finish:()=>N.finish(),compress:t=>function(t){return q(K(t))}(t)};addEventListener("message",(function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in P&&"function"==typeof P[n])try{const t=P[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}})),postMessage({id:void 0,method:"init",success:!0,response:void 0});`;
function $9d5f51142a9a79a0$var$e() {
    const e = new Blob([
        $9d5f51142a9a79a0$var$r
    ]);
    return URL.createObjectURL(e);
}
/**
 * Log a message in debug mode, and add a breadcrumb when _experiment.traceInternals is enabled.
 */ function $9d5f51142a9a79a0$var$logInfo(message, shouldAddBreadcrumb) {
    if (!$9d5f51142a9a79a0$var$DEBUG_BUILD) return;
    (0, $7Dams.logger).info(message);
    if (shouldAddBreadcrumb) $9d5f51142a9a79a0$var$addLogBreadcrumb(message);
}
/**
 * Log a message, and add a breadcrumb in the next tick.
 * This is necessary when the breadcrumb may be added before the replay is initialized.
 */ function $9d5f51142a9a79a0$var$logInfoNextTick(message, shouldAddBreadcrumb) {
    if (!$9d5f51142a9a79a0$var$DEBUG_BUILD) return;
    (0, $7Dams.logger).info(message);
    if (shouldAddBreadcrumb) // Wait a tick here to avoid race conditions for some initial logs
    // which may be added before replay is initialized
    setTimeout(()=>{
        $9d5f51142a9a79a0$var$addLogBreadcrumb(message);
    }, 0);
}
function $9d5f51142a9a79a0$var$addLogBreadcrumb(message) {
    (0, $iKbxs.addBreadcrumb)({
        category: "console",
        data: {
            logger: "replay"
        },
        level: "info",
        message: message
    }, {
        level: "info"
    });
}
/** This error indicates that the event buffer size exceeded the limit.. */ class $9d5f51142a9a79a0$var$EventBufferSizeExceededError extends Error {
    constructor(){
        super(`Event buffer exceeded maximum size of ${$9d5f51142a9a79a0$var$REPLAY_MAX_EVENT_BUFFER_SIZE}.`);
    }
}
/**
 * A basic event buffer that does not do any compression.
 * Used as fallback if the compression worker cannot be loaded or is disabled.
 */ class $9d5f51142a9a79a0$var$EventBufferArray {
    /** All the events that are buffered to be sent. */ /** @inheritdoc */ constructor(){
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return this.events.length > 0;
    }
    /** @inheritdoc */ get type() {
        return "sync";
    }
    /** @inheritdoc */ destroy() {
        this.events = [];
    }
    /** @inheritdoc */ async addEvent(event) {
        const eventSize = JSON.stringify(event).length;
        this._totalSize += eventSize;
        if (this._totalSize > $9d5f51142a9a79a0$var$REPLAY_MAX_EVENT_BUFFER_SIZE) throw new $9d5f51142a9a79a0$var$EventBufferSizeExceededError();
        this.events.push(event);
    }
    /** @inheritdoc */ finish() {
        return new Promise((resolve)=>{
            // Make a copy of the events array reference and immediately clear the
            // events member so that we do not lose new events while uploading
            // attachment.
            const eventsRet = this.events;
            this.clear();
            resolve(JSON.stringify(eventsRet));
        });
    }
    /** @inheritdoc */ clear() {
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        const timestamp = this.events.map((event)=>event.timestamp).sort()[0];
        if (!timestamp) return null;
        return $9d5f51142a9a79a0$var$timestampToMs(timestamp);
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $9d5f51142a9a79a0$var$WorkerHandler {
    constructor(worker){
        this._worker = worker;
        this._id = 0;
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        // Ensure we only check once
        if (this._ensureReadyPromise) return this._ensureReadyPromise;
        this._ensureReadyPromise = new Promise((resolve, reject)=>{
            this._worker.addEventListener("message", ({ data: data })=>{
                if (data.success) resolve();
                else reject();
            }, {
                once: true
            });
            this._worker.addEventListener("error", (error)=>{
                reject(error);
            }, {
                once: true
            });
        });
        return this._ensureReadyPromise;
    }
    /**
   * Destroy the worker.
   */ destroy() {
        $9d5f51142a9a79a0$var$logInfo("[Replay] Destroying compression worker");
        this._worker.terminate();
    }
    /**
   * Post message to worker and wait for response before resolving promise.
   */ postMessage(method, arg) {
        const id = this._getAndIncrementId();
        return new Promise((resolve, reject)=>{
            const listener = ({ data: data })=>{
                const response = data;
                if (response.method !== method) return;
                // There can be multiple listeners for a single method, the id ensures
                // that the response matches the caller.
                if (response.id !== id) return;
                // At this point, we'll always want to remove listener regardless of result status
                this._worker.removeEventListener("message", listener);
                if (!response.success) {
                    // TODO: Do some error handling, not sure what
                    $9d5f51142a9a79a0$var$DEBUG_BUILD && (0, $7Dams.logger).error("[Replay]", response.response);
                    reject(new Error("Error in compression worker"));
                    return;
                }
                resolve(response.response);
            };
            // Note: we can't use `once` option because it's possible it needs to
            // listen to multiple messages
            this._worker.addEventListener("message", listener);
            this._worker.postMessage({
                id: id,
                method: method,
                arg: arg
            });
        });
    }
    /** Get the current ID and increment it for the next call. */ _getAndIncrementId() {
        return this._id++;
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $9d5f51142a9a79a0$var$EventBufferCompressionWorker {
    /** @inheritdoc */ constructor(worker){
        this._worker = new $9d5f51142a9a79a0$var$WorkerHandler(worker);
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return !!this._earliestTimestamp;
    }
    /** @inheritdoc */ get type() {
        return "worker";
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        return this._worker.ensureReady();
    }
    /**
   * Destroy the event buffer.
   */ destroy() {
        this._worker.destroy();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfuly received and processed by worker.
   */ addEvent(event) {
        const timestamp = $9d5f51142a9a79a0$var$timestampToMs(event.timestamp);
        if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) this._earliestTimestamp = timestamp;
        const data = JSON.stringify(event);
        this._totalSize += data.length;
        if (this._totalSize > $9d5f51142a9a79a0$var$REPLAY_MAX_EVENT_BUFFER_SIZE) return Promise.reject(new $9d5f51142a9a79a0$var$EventBufferSizeExceededError());
        return this._sendEventToWorker(data);
    }
    /**
   * Finish the event buffer and return the compressed data.
   */ finish() {
        return this._finishRequest();
    }
    /** @inheritdoc */ clear() {
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
        // We do not wait on this, as we assume the order of messages is consistent for the worker
        this._worker.postMessage("clear").then(null, (e)=>{
            $9d5f51142a9a79a0$var$DEBUG_BUILD && (0, $7Dams.logger).warn('[Replay] Sending "clear" message to worker failed', e);
        });
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._earliestTimestamp;
    }
    /**
   * Send the event to the worker.
   */ _sendEventToWorker(data) {
        return this._worker.postMessage("addEvent", data);
    }
    /**
   * Finish the request and return the compressed data from the worker.
   */ async _finishRequest() {
        const response = await this._worker.postMessage("finish");
        this._earliestTimestamp = null;
        this._totalSize = 0;
        return response;
    }
}
/**
 * This proxy will try to use the compression worker, and fall back to use the simple buffer if an error occurs there.
 * This can happen e.g. if the worker cannot be loaded.
 * Exported only for testing.
 */ class $9d5f51142a9a79a0$var$EventBufferProxy {
    constructor(worker){
        this._fallback = new $9d5f51142a9a79a0$var$EventBufferArray();
        this._compression = new $9d5f51142a9a79a0$var$EventBufferCompressionWorker(worker);
        this._used = this._fallback;
        this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
    }
    /** @inheritdoc */ get type() {
        return this._used.type;
    }
    /** @inheritDoc */ get hasEvents() {
        return this._used.hasEvents;
    }
    /** @inheritdoc */ get hasCheckout() {
        return this._used.hasCheckout;
    }
    /** @inheritdoc */ set hasCheckout(value) {
        this._used.hasCheckout = value;
    }
    /** @inheritDoc */ destroy() {
        this._fallback.destroy();
        this._compression.destroy();
    }
    /** @inheritdoc */ clear() {
        return this._used.clear();
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._used.getEarliestTimestamp();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */ addEvent(event) {
        return this._used.addEvent(event);
    }
    /** @inheritDoc */ async finish() {
        // Ensure the worker is loaded, so the sent event is compressed
        await this.ensureWorkerIsLoaded();
        return this._used.finish();
    }
    /** Ensure the worker has loaded. */ ensureWorkerIsLoaded() {
        return this._ensureWorkerIsLoadedPromise;
    }
    /** Actually check if the worker has been loaded. */ async _ensureWorkerIsLoaded() {
        try {
            await this._compression.ensureReady();
        } catch (error) {
            // If the worker fails to load, we fall back to the simple buffer.
            // Nothing more to do from our side here
            $9d5f51142a9a79a0$var$logInfo("[Replay] Failed to load the compression worker, falling back to simple buffer");
            return;
        }
        // Now we need to switch over the array buffer to the compression worker
        await this._switchToCompressionWorker();
    }
    /** Switch the used buffer to the compression worker. */ async _switchToCompressionWorker() {
        const { events: events, hasCheckout: hasCheckout } = this._fallback;
        const addEventPromises = [];
        for (const event of events)addEventPromises.push(this._compression.addEvent(event));
        this._compression.hasCheckout = hasCheckout;
        // We switch over to the new buffer immediately - any further events will be added
        // after the previously buffered ones
        this._used = this._compression;
        // Wait for original events to be re-added before resolving
        try {
            await Promise.all(addEventPromises);
        } catch (error) {
            $9d5f51142a9a79a0$var$DEBUG_BUILD && (0, $7Dams.logger).warn("[Replay] Failed to add events when switching buffers.", error);
        }
    }
}
/**
 * Create an event buffer for replays.
 */ function $9d5f51142a9a79a0$var$createEventBuffer({ useCompression: useCompression, workerUrl: customWorkerUrl }) {
    if (useCompression && // eslint-disable-next-line no-restricted-globals
    window.Worker) {
        const worker = $9d5f51142a9a79a0$var$_loadWorker(customWorkerUrl);
        if (worker) return worker;
    }
    $9d5f51142a9a79a0$var$logInfo("[Replay] Using simple buffer");
    return new $9d5f51142a9a79a0$var$EventBufferArray();
}
function $9d5f51142a9a79a0$var$_loadWorker(customWorkerUrl) {
    try {
        const workerUrl = customWorkerUrl || $9d5f51142a9a79a0$var$_getWorkerUrl();
        if (!workerUrl) return;
        $9d5f51142a9a79a0$var$logInfo(`[Replay] Using compression worker${customWorkerUrl ? ` from ${customWorkerUrl}` : ""}`);
        const worker = new Worker(workerUrl);
        return new $9d5f51142a9a79a0$var$EventBufferProxy(worker);
    } catch (error) {
        $9d5f51142a9a79a0$var$logInfo("[Replay] Failed to create compression worker");
    // Fall back to use simple event buffer array
    }
}
function $9d5f51142a9a79a0$var$_getWorkerUrl() {
    if (typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ === "undefined" || !__SENTRY_EXCLUDE_REPLAY_WORKER__) return $9d5f51142a9a79a0$var$e();
    return "";
}
/** If sessionStorage is available. */ function $9d5f51142a9a79a0$var$hasSessionStorage() {
    try {
        // This can throw, e.g. when being accessed in a sandboxed iframe
        return "sessionStorage" in $9d5f51142a9a79a0$var$WINDOW && !!$9d5f51142a9a79a0$var$WINDOW.sessionStorage;
    } catch (e) {
        return false;
    }
}
/**
 * Removes the session from Session Storage and unsets session in replay instance
 */ function $9d5f51142a9a79a0$var$clearSession(replay) {
    $9d5f51142a9a79a0$var$deleteSession();
    replay.session = undefined;
}
/**
 * Deletes a session from storage
 */ function $9d5f51142a9a79a0$var$deleteSession() {
    if (!$9d5f51142a9a79a0$var$hasSessionStorage()) return;
    try {
        $9d5f51142a9a79a0$var$WINDOW.sessionStorage.removeItem($9d5f51142a9a79a0$var$REPLAY_SESSION_KEY);
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Given a sample rate, returns true if replay should be sampled.
 *
 * 1.0 = 100% sampling
 * 0.0 = 0% sampling
 */ function $9d5f51142a9a79a0$var$isSampled(sampleRate) {
    if (sampleRate === undefined) return false;
    // Math.random() returns a number in range of 0 to 1 (inclusive of 0, but not 1)
    return Math.random() < sampleRate;
}
/**
 * Get a session with defaults & applied sampling.
 */ function $9d5f51142a9a79a0$var$makeSession(session) {
    const now = Date.now();
    const id = session.id || (0, $4zH9l.uuid4)();
    // Note that this means we cannot set a started/lastActivity of `0`, but this should not be relevant outside of tests.
    const started = session.started || now;
    const lastActivity = session.lastActivity || now;
    const segmentId = session.segmentId || 0;
    const sampled = session.sampled;
    const previousSessionId = session.previousSessionId;
    return {
        id: id,
        started: started,
        lastActivity: lastActivity,
        segmentId: segmentId,
        sampled: sampled,
        previousSessionId: previousSessionId
    };
}
/**
 * Save a session to session storage.
 */ function $9d5f51142a9a79a0$var$saveSession(session) {
    if (!$9d5f51142a9a79a0$var$hasSessionStorage()) return;
    try {
        $9d5f51142a9a79a0$var$WINDOW.sessionStorage.setItem($9d5f51142a9a79a0$var$REPLAY_SESSION_KEY, JSON.stringify(session));
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Get the sampled status for a session based on sample rates & current sampled status.
 */ function $9d5f51142a9a79a0$var$getSessionSampleType(sessionSampleRate, allowBuffering) {
    return $9d5f51142a9a79a0$var$isSampled(sessionSampleRate) ? "session" : allowBuffering ? "buffer" : false;
}
/**
 * Create a new session, which in its current implementation is a Sentry event
 * that all replays will be saved to as attachments. Currently, we only expect
 * one of these Sentry events per "replay session".
 */ function $9d5f51142a9a79a0$var$createSession({ sessionSampleRate: sessionSampleRate, allowBuffering: allowBuffering, stickySession: stickySession = false }, { previousSessionId: previousSessionId } = {}) {
    const sampled = $9d5f51142a9a79a0$var$getSessionSampleType(sessionSampleRate, allowBuffering);
    const session = $9d5f51142a9a79a0$var$makeSession({
        sampled: sampled,
        previousSessionId: previousSessionId
    });
    if (stickySession) $9d5f51142a9a79a0$var$saveSession(session);
    return session;
}
/**
 * Fetches a session from storage
 */ function $9d5f51142a9a79a0$var$fetchSession(traceInternals) {
    if (!$9d5f51142a9a79a0$var$hasSessionStorage()) return null;
    try {
        // This can throw if cookies are disabled
        const sessionStringFromStorage = $9d5f51142a9a79a0$var$WINDOW.sessionStorage.getItem($9d5f51142a9a79a0$var$REPLAY_SESSION_KEY);
        if (!sessionStringFromStorage) return null;
        const sessionObj = JSON.parse(sessionStringFromStorage);
        $9d5f51142a9a79a0$var$logInfoNextTick("[Replay] Loading existing session", traceInternals);
        return $9d5f51142a9a79a0$var$makeSession(sessionObj);
    } catch (e) {
        return null;
    }
}
/**
 * Given an initial timestamp and an expiry duration, checks to see if current
 * time should be considered as expired.
 */ function $9d5f51142a9a79a0$var$isExpired(initialTime, expiry, targetTime = +new Date()) {
    // Always expired if < 0
    if (initialTime === null || expiry === undefined || expiry < 0) return true;
    // Never expires if == 0
    if (expiry === 0) return false;
    return initialTime + expiry <= targetTime;
}
/**
 * Checks to see if session is expired
 */ function $9d5f51142a9a79a0$var$isSessionExpired(session, { maxReplayDuration: maxReplayDuration, sessionIdleExpire: sessionIdleExpire, targetTime: targetTime = Date.now() }) {
    return(// First, check that maximum session length has not been exceeded
    $9d5f51142a9a79a0$var$isExpired(session.started, maxReplayDuration, targetTime) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    $9d5f51142a9a79a0$var$isExpired(session.lastActivity, sessionIdleExpire, targetTime));
}
/** If the session should be refreshed or not. */ function $9d5f51142a9a79a0$var$shouldRefreshSession(session, { sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration }) {
    // If not expired, all good, just keep the session
    if (!$9d5f51142a9a79a0$var$isSessionExpired(session, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return false;
    // If we are buffering & haven't ever flushed yet, always continue
    if (session.sampled === "buffer" && session.segmentId === 0) return false;
    return true;
}
/**
 * Get or create a session, when initializing the replay.
 * Returns a session that may be unsampled.
 */ function $9d5f51142a9a79a0$var$loadOrCreateSession({ traceInternals: traceInternals, sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration, previousSessionId: previousSessionId }, sessionOptions) {
    const existingSession = sessionOptions.stickySession && $9d5f51142a9a79a0$var$fetchSession(traceInternals);
    // No session exists yet, just create a new one
    if (!existingSession) {
        $9d5f51142a9a79a0$var$logInfoNextTick("[Replay] Creating new session", traceInternals);
        return $9d5f51142a9a79a0$var$createSession(sessionOptions, {
            previousSessionId: previousSessionId
        });
    }
    if (!$9d5f51142a9a79a0$var$shouldRefreshSession(existingSession, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return existingSession;
    $9d5f51142a9a79a0$var$logInfoNextTick("[Replay] Session in sessionStorage is expired, creating new one...");
    return $9d5f51142a9a79a0$var$createSession(sessionOptions, {
        previousSessionId: existingSession.id
    });
}
function $9d5f51142a9a79a0$var$isCustomEvent(event) {
    return event.type === $9d5f51142a9a79a0$var$EventType.Custom;
}
/**
 * Add an event to the event buffer.
 * In contrast to `addEvent`, this does not return a promise & does not wait for the adding of the event to succeed/fail.
 * Instead this returns `true` if we tried to add the event, else false.
 * It returns `false` e.g. if we are paused, disabled, or out of the max replay duration.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $9d5f51142a9a79a0$var$addEventSync(replay, event, isCheckout) {
    if (!$9d5f51142a9a79a0$var$shouldAddEvent(replay, event)) return false;
    // This should never reject
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $9d5f51142a9a79a0$var$_addEvent(replay, event, isCheckout);
    return true;
}
/**
 * Add an event to the event buffer.
 * Resolves to `null` if no event was added, else to `void`.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $9d5f51142a9a79a0$var$addEvent(replay, event, isCheckout) {
    if (!$9d5f51142a9a79a0$var$shouldAddEvent(replay, event)) return Promise.resolve(null);
    return $9d5f51142a9a79a0$var$_addEvent(replay, event, isCheckout);
}
async function $9d5f51142a9a79a0$var$_addEvent(replay, event, isCheckout) {
    if (!replay.eventBuffer) return null;
    try {
        if (isCheckout && replay.recordingMode === "buffer") replay.eventBuffer.clear();
        if (isCheckout) replay.eventBuffer.hasCheckout = true;
        const replayOptions = replay.getOptions();
        const eventAfterPossibleCallback = $9d5f51142a9a79a0$var$maybeApplyCallback(event, replayOptions.beforeAddRecordingEvent);
        if (!eventAfterPossibleCallback) return;
        return await replay.eventBuffer.addEvent(eventAfterPossibleCallback);
    } catch (error) {
        const reason = error && error instanceof $9d5f51142a9a79a0$var$EventBufferSizeExceededError ? "addEventSizeExceeded" : "addEvent";
        $9d5f51142a9a79a0$var$DEBUG_BUILD && (0, $7Dams.logger).error(error);
        await replay.stop({
            reason: reason
        });
        const client = (0, $iKbxs.getClient)();
        if (client) client.recordDroppedEvent("internal_sdk_error", "replay");
    }
}
/** Exported only for tests. */ function $9d5f51142a9a79a0$var$shouldAddEvent(replay, event) {
    if (!replay.eventBuffer || replay.isPaused() || !replay.isEnabled()) return false;
    const timestampInMs = $9d5f51142a9a79a0$var$timestampToMs(event.timestamp);
    // Throw out events that happen more than 5 minutes ago. This can happen if
    // page has been left open and idle for a long period of time and user
    // comes back to trigger a new session. The performance entries rely on
    // `performance.timeOrigin`, which is when the page first opened.
    if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) return false;
    // Throw out events that are +60min from the initial timestamp
    if (timestampInMs > replay.getContext().initialTimestamp + replay.getOptions().maxReplayDuration) {
        $9d5f51142a9a79a0$var$logInfo(`[Replay] Skipping event with timestamp ${timestampInMs} because it is after maxReplayDuration`, replay.getOptions()._experiments.traceInternals);
        return false;
    }
    return true;
}
function $9d5f51142a9a79a0$var$maybeApplyCallback(event, callback) {
    try {
        if (typeof callback === "function" && $9d5f51142a9a79a0$var$isCustomEvent(event)) return callback(event);
    } catch (error) {
        $9d5f51142a9a79a0$var$DEBUG_BUILD && (0, $7Dams.logger).error("[Replay] An error occured in the `beforeAddRecordingEvent` callback, skipping the event...", error);
        return null;
    }
    return event;
}
/** If the event is an error event */ function $9d5f51142a9a79a0$var$isErrorEvent(event) {
    return !event.type;
}
/** If the event is a transaction event */ function $9d5f51142a9a79a0$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
/** If the event is an replay event */ function $9d5f51142a9a79a0$var$isReplayEvent(event) {
    return event.type === "replay_event";
}
/** If the event is a feedback event */ function $9d5f51142a9a79a0$var$isFeedbackEvent(event) {
    return event.type === "feedback";
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $9d5f51142a9a79a0$var$handleAfterSendEvent(replay) {
    // Custom transports may still be returning `Promise<void>`, which means we cannot expect the status code to be available there
    // TODO (v8): remove this check as it will no longer be necessary
    const enforceStatusCode = $9d5f51142a9a79a0$var$isBaseTransportSend();
    return (event, sendResponse)=>{
        if (!replay.isEnabled() || !$9d5f51142a9a79a0$var$isErrorEvent(event) && !$9d5f51142a9a79a0$var$isTransactionEvent(event)) return;
        const statusCode = sendResponse && sendResponse.statusCode;
        // We only want to do stuff on successful error sending, otherwise you get error replays without errors attached
        // If not using the base transport, we allow `undefined` response (as a custom transport may not implement this correctly yet)
        // If we do use the base transport, we skip if we encountered an non-OK status code
        if (enforceStatusCode && (!statusCode || statusCode < 200 || statusCode >= 300)) return;
        if ($9d5f51142a9a79a0$var$isTransactionEvent(event)) {
            $9d5f51142a9a79a0$var$handleTransactionEvent(replay, event);
            return;
        }
        $9d5f51142a9a79a0$var$handleErrorEvent(replay, event);
    };
}
function $9d5f51142a9a79a0$var$handleTransactionEvent(replay, event) {
    const replayContext = replay.getContext();
    // Collect traceIds in _context regardless of `recordingMode`
    // In error mode, _context gets cleared on every checkout
    // We limit to max. 100 transactions linked
    if (event.contexts && event.contexts.trace && event.contexts.trace.trace_id && replayContext.traceIds.size < 100) replayContext.traceIds.add(event.contexts.trace.trace_id);
}
function $9d5f51142a9a79a0$var$handleErrorEvent(replay, event) {
    const replayContext = replay.getContext();
    // Add error to list of errorIds of replay. This is ok to do even if not
    // sampled because context will get reset at next checkout.
    // XXX: There is also a race condition where it's possible to capture an
    // error to Sentry before Replay SDK has loaded, but response returns after
    // it was loaded, and this gets called.
    // We limit to max. 100 errors linked
    if (event.event_id && replayContext.errorIds.size < 100) replayContext.errorIds.add(event.event_id);
    // If error event is tagged with replay id it means it was sampled (when in buffer mode)
    // Need to be very careful that this does not cause an infinite loop
    if (replay.recordingMode !== "buffer" || !event.tags || !event.tags.replayId) return;
    const { beforeErrorSampling: beforeErrorSampling } = replay.getOptions();
    if (typeof beforeErrorSampling === "function" && !beforeErrorSampling(event)) return;
    setTimeout(()=>{
        // Capture current event buffer as new replay
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.sendBufferedReplayOrFlush();
    });
}
function $9d5f51142a9a79a0$var$isBaseTransportSend() {
    const client = (0, $iKbxs.getClient)();
    if (!client) return false;
    const transport = client.getTransport();
    if (!transport) return false;
    return transport.send.__sentry__baseTransport__ || false;
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $9d5f51142a9a79a0$var$handleBeforeSendEvent(replay) {
    return (event)=>{
        if (!replay.isEnabled() || !$9d5f51142a9a79a0$var$isErrorEvent(event)) return;
        $9d5f51142a9a79a0$var$handleHydrationError(replay, event);
    };
}
function $9d5f51142a9a79a0$var$handleHydrationError(replay, event) {
    const exceptionValue = event.exception && event.exception.values && event.exception.values[0].value;
    if (typeof exceptionValue !== "string") return;
    if (// Only matches errors in production builds of react-dom
    // Example https://reactjs.org/docs/error-decoder.html?invariant=423
    exceptionValue.match(/reactjs\.org\/docs\/error-decoder\.html\?invariant=(418|419|422|423|425)/) || // Development builds of react-dom
    // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
    // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
    exceptionValue.match(/(does not match server-rendered HTML|Hydration failed because)/i)) {
        const breadcrumb = $9d5f51142a9a79a0$var$createBreadcrumb({
            category: "replay.hydrate-error"
        });
        $9d5f51142a9a79a0$var$addBreadcrumbEvent(replay, breadcrumb);
    }
}
/**
 * Returns true if we think the given event is an error originating inside of rrweb.
 */ function $9d5f51142a9a79a0$var$isRrwebError(event, hint) {
    if (event.type || !event.exception || !event.exception.values || !event.exception.values.length) return false;
    // @ts-expect-error this may be set by rrweb when it finds errors
    if (hint.originalException && hint.originalException.__rrweb__) return true;
    return false;
}
/**
 * Add a feedback breadcrumb event to replay.
 */ function $9d5f51142a9a79a0$var$addFeedbackBreadcrumb(replay, event) {
    replay.triggerUserActivity();
    replay.addUpdate(()=>{
        if (!event.timestamp) // Ignore events that don't have timestamps (this shouldn't happen, more of a typing issue)
        // Return true here so that we don't flush
        return true;
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $9d5f51142a9a79a0$var$EventType.Custom,
            timestamp: event.timestamp * 1000,
            data: {
                tag: "breadcrumb",
                payload: {
                    timestamp: event.timestamp,
                    type: "default",
                    category: "sentry.feedback",
                    data: {
                        feedbackId: event.event_id
                    }
                }
            }
        });
        return false;
    });
}
/**
 * Determine if event should be sampled (only applies in buffer mode).
 * When an event is captured by `hanldleGlobalEvent`, when in buffer mode
 * we determine if we want to sample the error or not.
 */ function $9d5f51142a9a79a0$var$shouldSampleForBufferEvent(replay, event) {
    if (replay.recordingMode !== "buffer") return false;
    // ignore this error because otherwise we could loop indefinitely with
    // trying to capture replay and failing
    if (event.message === $9d5f51142a9a79a0$var$UNABLE_TO_SEND_REPLAY) return false;
    // Require the event to be an error event & to have an exception
    if (!event.exception || event.type) return false;
    return $9d5f51142a9a79a0$var$isSampled(replay.getOptions().errorSampleRate);
}
/**
 * Returns a listener to be added to `addEventProcessor(listener)`.
 */ function $9d5f51142a9a79a0$var$handleGlobalEventListener(replay, includeAfterSendEventHandling = false) {
    const afterSendHandler = includeAfterSendEventHandling ? $9d5f51142a9a79a0$var$handleAfterSendEvent(replay) : undefined;
    return Object.assign((event, hint)=>{
        // Do nothing if replay has been disabled
        if (!replay.isEnabled()) return event;
        if ($9d5f51142a9a79a0$var$isReplayEvent(event)) {
            // Replays have separate set of breadcrumbs, do not include breadcrumbs
            // from core SDK
            delete event.breadcrumbs;
            return event;
        }
        // We only want to handle errors, transactions, and feedbacks, nothing else
        if (!$9d5f51142a9a79a0$var$isErrorEvent(event) && !$9d5f51142a9a79a0$var$isTransactionEvent(event) && !$9d5f51142a9a79a0$var$isFeedbackEvent(event)) return event;
        // Ensure we do not add replay_id if the session is expired
        const isSessionActive = replay.checkAndHandleExpiredSession();
        if (!isSessionActive) return event;
        if ($9d5f51142a9a79a0$var$isFeedbackEvent(event)) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            event.contexts.feedback.replay_id = replay.getSessionId();
            // Add a replay breadcrumb for this piece of feedback
            $9d5f51142a9a79a0$var$addFeedbackBreadcrumb(replay, event);
            return event;
        }
        // Unless `captureExceptions` is enabled, we want to ignore errors coming from rrweb
        // As there can be a bunch of stuff going wrong in internals there, that we don't want to bubble up to users
        if ($9d5f51142a9a79a0$var$isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
            $9d5f51142a9a79a0$var$DEBUG_BUILD && (0, $7Dams.logger).log("[Replay] Ignoring error from rrweb internals", event);
            return null;
        }
        // When in buffer mode, we decide to sample here.
        // Later, in `handleAfterSendEvent`, if the replayId is set, we know that we sampled
        // And convert the buffer session to a full session
        const isErrorEventSampled = $9d5f51142a9a79a0$var$shouldSampleForBufferEvent(replay, event);
        // Tag errors if it has been sampled in buffer mode, or if it is session mode
        // Only tag transactions if in session mode
        const shouldTagReplayId = isErrorEventSampled || replay.recordingMode === "session";
        if (shouldTagReplayId) event.tags = {
            ...event.tags,
            replayId: replay.getSessionId()
        };
        // In cases where a custom client is used that does not support the new hooks (yet),
        // we manually call this hook method here
        if (afterSendHandler) // Pretend the error had a 200 response so we always capture it
        afterSendHandler(event, {
            statusCode: 200
        });
        return event;
    }, {
        id: "Replay"
    });
}
/**
 * Create a "span" for each performance entry.
 */ function $9d5f51142a9a79a0$var$createPerformanceSpans(replay, entries) {
    return entries.map(({ type: type, start: start, end: end, name: name, data: data })=>{
        const response = replay.throttledAddEvent({
            type: $9d5f51142a9a79a0$var$EventType.Custom,
            timestamp: start,
            data: {
                tag: "performanceSpan",
                payload: {
                    op: type,
                    description: name,
                    startTimestamp: start,
                    endTimestamp: end,
                    data: data
                }
            }
        });
        // If response is a string, it means its either THROTTLED or SKIPPED
        return typeof response === "string" ? Promise.resolve(null) : response;
    });
}
function $9d5f51142a9a79a0$var$handleHistory(handlerData) {
    const { from: from, to: to } = handlerData;
    const now = Date.now() / 1000;
    return {
        type: "navigation.push",
        start: now,
        end: now,
        name: to,
        data: {
            previous: from
        }
    };
}
/**
 * Returns a listener to be added to `addHistoryInstrumentationHandler(listener)`.
 */ function $9d5f51142a9a79a0$var$handleHistorySpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $9d5f51142a9a79a0$var$handleHistory(handlerData);
        if (result === null) return;
        // Need to collect visited URLs
        replay.getContext().urls.push(result.name);
        replay.triggerUserActivity();
        replay.addUpdate(()=>{
            $9d5f51142a9a79a0$var$createPerformanceSpans(replay, [
                result
            ]);
            // Returning false to flush
            return false;
        });
    };
}
/**
 * Check whether a given request URL should be filtered out. This is so we
 * don't log Sentry ingest requests.
 */ function $9d5f51142a9a79a0$var$shouldFilterRequest(replay, url) {
    // If we enabled the `traceInternals` experiment, we want to trace everything
    if ($9d5f51142a9a79a0$var$DEBUG_BUILD && replay.getOptions()._experiments.traceInternals) return false;
    return (0, $8ZS5a.isSentryRequestUrl)(url, (0, $iKbxs.getClient)());
}
/** Add a performance entry breadcrumb */ function $9d5f51142a9a79a0$var$addNetworkBreadcrumb(replay, result) {
    if (!replay.isEnabled()) return;
    if (result === null) return;
    if ($9d5f51142a9a79a0$var$shouldFilterRequest(replay, result.name)) return;
    replay.addUpdate(()=>{
        $9d5f51142a9a79a0$var$createPerformanceSpans(replay, [
            result
        ]);
        // Returning true will cause `addUpdate` to not flush
        // We do not want network requests to cause a flush. This will prevent
        // recurring/polling requests from keeping the replay session alive.
        return true;
    });
}
/** only exported for tests */ function $9d5f51142a9a79a0$var$handleFetch(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, fetchData: fetchData, response: response } = handlerData;
    if (!endTimestamp) return null;
    // This is only used as a fallback, so we know the body sizes are never set here
    const { method: method, url: url } = fetchData;
    return {
        type: "resource.fetch",
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: {
            method: method,
            statusCode: response ? response.status : undefined
        }
    };
}
/**
 * Returns a listener to be added to `addFetchInstrumentationHandler(listener)`.
 */ function $9d5f51142a9a79a0$var$handleFetchSpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $9d5f51142a9a79a0$var$handleFetch(handlerData);
        $9d5f51142a9a79a0$var$addNetworkBreadcrumb(replay, result);
    };
}
/** only exported for tests */ function $9d5f51142a9a79a0$var$handleXhr(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, xhr: xhr } = handlerData;
    const sentryXhrData = xhr[0, $dk3nq.SENTRY_XHR_DATA_KEY];
    if (!startTimestamp || !endTimestamp || !sentryXhrData) return null;
    // This is only used as a fallback, so we know the body sizes are never set here
    const { method: method, url: url, status_code: statusCode } = sentryXhrData;
    if (url === undefined) return null;
    return {
        type: "resource.xhr",
        name: url,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        data: {
            method: method,
            statusCode: statusCode
        }
    };
}
/**
 * Returns a listener to be added to `addXhrInstrumentationHandler(listener)`.
 */ function $9d5f51142a9a79a0$var$handleXhrSpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $9d5f51142a9a79a0$var$handleXhr(handlerData);
        $9d5f51142a9a79a0$var$addNetworkBreadcrumb(replay, result);
    };
}
/** Get the size of a body. */ function $9d5f51142a9a79a0$var$getBodySize(body, textEncoder) {
    if (!body) return undefined;
    try {
        if (typeof body === "string") return textEncoder.encode(body).length;
        if (body instanceof URLSearchParams) return textEncoder.encode(body.toString()).length;
        if (body instanceof FormData) {
            const formDataStr = $9d5f51142a9a79a0$var$_serializeFormData(body);
            return textEncoder.encode(formDataStr).length;
        }
        if (body instanceof Blob) return body.size;
        if (body instanceof ArrayBuffer) return body.byteLength;
    // Currently unhandled types: ArrayBufferView, ReadableStream
    } catch (e) {
    // just return undefined
    }
    return undefined;
}
/** Convert a Content-Length header to number/undefined.  */ function $9d5f51142a9a79a0$var$parseContentLengthHeader(header) {
    if (!header) return undefined;
    const size = parseInt(header, 10);
    return isNaN(size) ? undefined : size;
}
/** Get the string representation of a body. */ function $9d5f51142a9a79a0$var$getBodyString(body) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof URLSearchParams) return [
            body.toString()
        ];
        if (body instanceof FormData) return [
            $9d5f51142a9a79a0$var$_serializeFormData(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (e2) {
        $9d5f51142a9a79a0$var$DEBUG_BUILD && (0, $7Dams.logger).warn("[Replay] Failed to serialize body", body);
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
    $9d5f51142a9a79a0$var$DEBUG_BUILD && (0, $7Dams.logger).info("[Replay] Skipping network body because of body type", body);
    return [
        undefined,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
/** Merge a warning into an existing network request/response. */ function $9d5f51142a9a79a0$var$mergeWarning(info, warning) {
    if (!info) return {
        headers: {},
        size: undefined,
        _meta: {
            warnings: [
                warning
            ]
        }
    };
    const newMeta = {
        ...info._meta
    };
    const existingWarnings = newMeta.warnings || [];
    newMeta.warnings = [
        ...existingWarnings,
        warning
    ];
    info._meta = newMeta;
    return info;
}
/** Convert ReplayNetworkRequestData to a PerformanceEntry. */ function $9d5f51142a9a79a0$var$makeNetworkReplayBreadcrumb(type, data) {
    if (!data) return null;
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, url: url, method: method, statusCode: statusCode, request: request, response: response } = data;
    const result = {
        type: type,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: (0, $8WMel.dropUndefinedKeys)({
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        })
    };
    return result;
}
/** Build the request or response part of a replay network breadcrumb that was skipped. */ function $9d5f51142a9a79a0$var$buildSkippedNetworkRequestOrResponse(bodySize) {
    return {
        headers: {},
        size: bodySize,
        _meta: {
            warnings: [
                "URL_SKIPPED"
            ]
        }
    };
}
/** Build the request or response part of a replay network breadcrumb. */ function $9d5f51142a9a79a0$var$buildNetworkRequestOrResponse(headers, bodySize, body) {
    if (!bodySize && Object.keys(headers).length === 0) return undefined;
    if (!bodySize) return {
        headers: headers
    };
    if (!body) return {
        headers: headers,
        size: bodySize
    };
    const info = {
        headers: headers,
        size: bodySize
    };
    const { body: normalizedBody, warnings: warnings } = $9d5f51142a9a79a0$var$normalizeNetworkBody(body);
    info.body = normalizedBody;
    if (warnings && warnings.length > 0) info._meta = {
        warnings: warnings
    };
    return info;
}
/** Filter a set of headers */ function $9d5f51142a9a79a0$var$getAllowedHeaders(headers, allowedHeaders) {
    return Object.keys(headers).reduce((filteredHeaders, key)=>{
        const normalizedKey = key.toLowerCase();
        // Avoid putting empty strings into the headers
        if (allowedHeaders.includes(normalizedKey) && headers[key]) filteredHeaders[normalizedKey] = headers[key];
        return filteredHeaders;
    }, {});
}
function $9d5f51142a9a79a0$var$_serializeFormData(formData) {
    // This is a bit simplified, but gives us a decent estimate
    // This converts e.g. { name: 'Anne Smith', age: 13 } to 'name=Anne+Smith&age=13'
    // @ts-expect-error passing FormData to URLSearchParams actually works
    return new URLSearchParams(formData).toString();
}
function $9d5f51142a9a79a0$var$normalizeNetworkBody(body) {
    if (!body || typeof body !== "string") return {
        body: body
    };
    const exceedsSizeLimit = body.length > $9d5f51142a9a79a0$var$NETWORK_BODY_MAX_SIZE;
    const isProbablyJson = $9d5f51142a9a79a0$var$_strIsProbablyJson(body);
    if (exceedsSizeLimit) {
        const truncatedBody = body.slice(0, $9d5f51142a9a79a0$var$NETWORK_BODY_MAX_SIZE);
        if (isProbablyJson) return {
            body: truncatedBody,
            warnings: [
                "MAYBE_JSON_TRUNCATED"
            ]
        };
        return {
            body: `${truncatedBody}\u{2026}`,
            warnings: [
                "TEXT_TRUNCATED"
            ]
        };
    }
    if (isProbablyJson) try {
        const jsonBody = JSON.parse(body);
        return {
            body: jsonBody
        };
    } catch (e3) {
    // fall back to just send the body as string
    }
    return {
        body: body
    };
}
function $9d5f51142a9a79a0$var$_strIsProbablyJson(str) {
    const first = str[0];
    const last = str[str.length - 1];
    // Simple check: If this does not start & end with {} or [], it's not JSON
    return first === "[" && last === "]" || first === "{" && last === "}";
}
/** Match an URL against a list of strings/Regex. */ function $9d5f51142a9a79a0$var$urlMatches(url, urls) {
    const fullUrl = $9d5f51142a9a79a0$var$getFullUrl(url);
    return (0, $bqiXE.stringMatchesSomePattern)(fullUrl, urls);
}
/** exported for tests */ function $9d5f51142a9a79a0$var$getFullUrl(url, baseURI = $9d5f51142a9a79a0$var$WINDOW.document.baseURI) {
    // Short circuit for common cases:
    if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith($9d5f51142a9a79a0$var$WINDOW.location.origin)) return url;
    const fixedUrl = new URL(url, baseURI);
    // If these do not match, we are not dealing with a relative URL, so just return it
    if (fixedUrl.origin !== new URL(baseURI).origin) return url;
    const fullUrl = fixedUrl.href;
    // Remove trailing slashes, if they don't match the original URL
    if (!url.endsWith("/") && fullUrl.endsWith("/")) return fullUrl.slice(0, -1);
    return fullUrl;
}
/**
 * Capture a fetch breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function $9d5f51142a9a79a0$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = await $9d5f51142a9a79a0$var$_prepareFetchData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $9d5f51142a9a79a0$var$makeNetworkReplayBreadcrumb("resource.fetch", data);
        $9d5f51142a9a79a0$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $9d5f51142a9a79a0$var$DEBUG_BUILD && (0, $7Dams.logger).error("[Replay] Failed to capture fetch breadcrumb", error);
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $9d5f51142a9a79a0$var$enrichFetchBreadcrumb(breadcrumb, hint, options) {
    const { input: input, response: response } = hint;
    const body = input ? $9d5f51142a9a79a0$var$_getFetchRequestArgBody(input) : undefined;
    const reqSize = $9d5f51142a9a79a0$var$getBodySize(body, options.textEncoder);
    const resSize = response ? $9d5f51142a9a79a0$var$parseContentLengthHeader(response.headers.get("content-length")) : undefined;
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
async function $9d5f51142a9a79a0$var$_prepareFetchData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    const captureDetails = $9d5f51142a9a79a0$var$urlMatches(url, options.networkDetailAllowUrls) && !$9d5f51142a9a79a0$var$urlMatches(url, options.networkDetailDenyUrls);
    const request = captureDetails ? $9d5f51142a9a79a0$var$_getRequestInfo(options, hint.input, requestBodySize) : $9d5f51142a9a79a0$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
    const response = await $9d5f51142a9a79a0$var$_getResponseInfo(captureDetails, options, hint.response, responseBodySize);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: request,
        response: response
    };
}
function $9d5f51142a9a79a0$var$_getRequestInfo({ networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders }, input, requestBodySize) {
    const headers = input ? $9d5f51142a9a79a0$var$getRequestHeaders(input, networkRequestHeaders) : {};
    if (!networkCaptureBodies) return $9d5f51142a9a79a0$var$buildNetworkRequestOrResponse(headers, requestBodySize, undefined);
    // We only want to transmit string or string-like bodies
    const requestBody = $9d5f51142a9a79a0$var$_getFetchRequestArgBody(input);
    const [bodyStr, warning] = $9d5f51142a9a79a0$var$getBodyString(requestBody);
    const data = $9d5f51142a9a79a0$var$buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);
    if (warning) return $9d5f51142a9a79a0$var$mergeWarning(data, warning);
    return data;
}
/** Exported only for tests. */ async function $9d5f51142a9a79a0$var$_getResponseInfo(captureDetails, { networkCaptureBodies: networkCaptureBodies, textEncoder: textEncoder, networkResponseHeaders: networkResponseHeaders }, response, responseBodySize) {
    if (!captureDetails && responseBodySize !== undefined) return $9d5f51142a9a79a0$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
    const headers = response ? $9d5f51142a9a79a0$var$getAllHeaders(response.headers, networkResponseHeaders) : {};
    if (!response || !networkCaptureBodies && responseBodySize !== undefined) return $9d5f51142a9a79a0$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    const [bodyText, warning] = await $9d5f51142a9a79a0$var$_parseFetchResponseBody(response);
    const result = $9d5f51142a9a79a0$var$getResponseData(bodyText, {
        networkCaptureBodies: networkCaptureBodies,
        textEncoder: textEncoder,
        responseBodySize: responseBodySize,
        captureDetails: captureDetails,
        headers: headers
    });
    if (warning) return $9d5f51142a9a79a0$var$mergeWarning(result, warning);
    return result;
}
function $9d5f51142a9a79a0$var$getResponseData(bodyText, { networkCaptureBodies: networkCaptureBodies, textEncoder: textEncoder, responseBodySize: responseBodySize, captureDetails: captureDetails, headers: headers }) {
    try {
        const size = bodyText && bodyText.length && responseBodySize === undefined ? $9d5f51142a9a79a0$var$getBodySize(bodyText, textEncoder) : responseBodySize;
        if (!captureDetails) return $9d5f51142a9a79a0$var$buildSkippedNetworkRequestOrResponse(size);
        if (networkCaptureBodies) return $9d5f51142a9a79a0$var$buildNetworkRequestOrResponse(headers, size, bodyText);
        return $9d5f51142a9a79a0$var$buildNetworkRequestOrResponse(headers, size, undefined);
    } catch (error) {
        $9d5f51142a9a79a0$var$DEBUG_BUILD && (0, $7Dams.logger).warn("[Replay] Failed to serialize response body", error);
        // fallback
        return $9d5f51142a9a79a0$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    }
}
async function $9d5f51142a9a79a0$var$_parseFetchResponseBody(response) {
    const res = $9d5f51142a9a79a0$var$_tryCloneResponse(response);
    if (!res) return [
        undefined,
        "BODY_PARSE_ERROR"
    ];
    try {
        const text = await $9d5f51142a9a79a0$var$_tryGetResponseText(res);
        return [
            text
        ];
    } catch (error) {
        $9d5f51142a9a79a0$var$DEBUG_BUILD && (0, $7Dams.logger).warn("[Replay] Failed to get text body from response", error);
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
}
function $9d5f51142a9a79a0$var$_getFetchRequestArgBody(fetchArgs = []) {
    // We only support getting the body from the fetch options
    if (fetchArgs.length !== 2 || typeof fetchArgs[1] !== "object") return undefined;
    return fetchArgs[1].body;
}
function $9d5f51142a9a79a0$var$getAllHeaders(headers, allowedHeaders) {
    const allHeaders = {};
    allowedHeaders.forEach((header)=>{
        if (headers.get(header)) allHeaders[header] = headers.get(header);
    });
    return allHeaders;
}
function $9d5f51142a9a79a0$var$getRequestHeaders(fetchArgs, allowedHeaders) {
    if (fetchArgs.length === 1 && typeof fetchArgs[0] !== "string") return $9d5f51142a9a79a0$var$getHeadersFromOptions(fetchArgs[0], allowedHeaders);
    if (fetchArgs.length === 2) return $9d5f51142a9a79a0$var$getHeadersFromOptions(fetchArgs[1], allowedHeaders);
    return {};
}
function $9d5f51142a9a79a0$var$getHeadersFromOptions(input, allowedHeaders) {
    if (!input) return {};
    const headers = input.headers;
    if (!headers) return {};
    if (headers instanceof Headers) return $9d5f51142a9a79a0$var$getAllHeaders(headers, allowedHeaders);
    // We do not support this, as it is not really documented (anymore?)
    if (Array.isArray(headers)) return {};
    return $9d5f51142a9a79a0$var$getAllowedHeaders(headers, allowedHeaders);
}
function $9d5f51142a9a79a0$var$_tryCloneResponse(response) {
    try {
        // We have to clone this, as the body can only be read once
        return response.clone();
    } catch (error) {
        // this can throw if the response was already consumed before
        $9d5f51142a9a79a0$var$DEBUG_BUILD && (0, $7Dams.logger).warn("[Replay] Failed to clone response body", error);
    }
}
/**
 * Get the response body of a fetch request, or timeout after 500ms.
 * Fetch can return a streaming body, that may not resolve (or not for a long time).
 * If that happens, we rather abort after a short time than keep waiting for this.
 */ function $9d5f51142a9a79a0$var$_tryGetResponseText(response) {
    return new Promise((resolve, reject)=>{
        const timeout = setTimeout(()=>reject(new Error("Timeout while trying to read response body")), 500);
        $9d5f51142a9a79a0$var$_getResponseText(response).then((txt)=>resolve(txt), (reason)=>reject(reason)).finally(()=>clearTimeout(timeout));
    });
}
async function $9d5f51142a9a79a0$var$_getResponseText(response) {
    // Force this to be a promise, just to be safe
    // eslint-disable-next-line no-return-await
    return await response.text();
}
/**
 * Capture an XHR breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function $9d5f51142a9a79a0$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = $9d5f51142a9a79a0$var$_prepareXhrData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $9d5f51142a9a79a0$var$makeNetworkReplayBreadcrumb("resource.xhr", data);
        $9d5f51142a9a79a0$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $9d5f51142a9a79a0$var$DEBUG_BUILD && (0, $7Dams.logger).error("[Replay] Failed to capture xhr breadcrumb", error);
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $9d5f51142a9a79a0$var$enrichXhrBreadcrumb(breadcrumb, hint, options) {
    const { xhr: xhr, input: input } = hint;
    if (!xhr) return;
    const reqSize = $9d5f51142a9a79a0$var$getBodySize(input, options.textEncoder);
    const resSize = xhr.getResponseHeader("content-length") ? $9d5f51142a9a79a0$var$parseContentLengthHeader(xhr.getResponseHeader("content-length")) : $9d5f51142a9a79a0$var$_getBodySize(xhr.response, xhr.responseType, options.textEncoder);
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
function $9d5f51142a9a79a0$var$_prepareXhrData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now, input: input, xhr: xhr } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    if (!url) return null;
    if (!xhr || !$9d5f51142a9a79a0$var$urlMatches(url, options.networkDetailAllowUrls) || $9d5f51142a9a79a0$var$urlMatches(url, options.networkDetailDenyUrls)) {
        const request = $9d5f51142a9a79a0$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
        const response = $9d5f51142a9a79a0$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
        return {
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp,
            url: url,
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        };
    }
    const xhrInfo = xhr[0, $dk3nq.SENTRY_XHR_DATA_KEY];
    const networkRequestHeaders = xhrInfo ? $9d5f51142a9a79a0$var$getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders) : {};
    const networkResponseHeaders = $9d5f51142a9a79a0$var$getAllowedHeaders($9d5f51142a9a79a0$var$getResponseHeaders(xhr), options.networkResponseHeaders);
    const [requestBody, requestWarning] = options.networkCaptureBodies ? $9d5f51142a9a79a0$var$getBodyString(input) : [
        undefined
    ];
    const [responseBody, responseWarning] = options.networkCaptureBodies ? $9d5f51142a9a79a0$var$_getXhrResponseBody(xhr) : [
        undefined
    ];
    const request = $9d5f51142a9a79a0$var$buildNetworkRequestOrResponse(networkRequestHeaders, requestBodySize, requestBody);
    const response = $9d5f51142a9a79a0$var$buildNetworkRequestOrResponse(networkResponseHeaders, responseBodySize, responseBody);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: requestWarning ? $9d5f51142a9a79a0$var$mergeWarning(request, requestWarning) : request,
        response: responseWarning ? $9d5f51142a9a79a0$var$mergeWarning(response, responseWarning) : response
    };
}
function $9d5f51142a9a79a0$var$getResponseHeaders(xhr) {
    const headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split("\r\n").reduce((acc, line)=>{
        const [key, value] = line.split(": ");
        acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}
function $9d5f51142a9a79a0$var$_getXhrResponseBody(xhr) {
    // We collect errors that happen, but only log them if we can't get any response body
    const errors = [];
    try {
        return [
            xhr.responseText
        ];
    } catch (e) {
        errors.push(e);
    }
    // Try to manually parse the response body, if responseText fails
    try {
        return $9d5f51142a9a79a0$var$_parseXhrResponse(xhr.response, xhr.responseType);
    } catch (e) {
        errors.push(e);
    }
    $9d5f51142a9a79a0$var$DEBUG_BUILD && (0, $7Dams.logger).warn("[Replay] Failed to get xhr response body", ...errors);
    return [
        undefined
    ];
}
/**
 * Get the string representation of the XHR response.
 * Based on MDN, these are the possible types of the response:
 * string
 * ArrayBuffer
 * Blob
 * Document
 * POJO
 *
 * Exported only for tests.
 */ function $9d5f51142a9a79a0$var$_parseXhrResponse(body, responseType) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof Document) return [
            body.body.outerHTML
        ];
        if (responseType === "json" && body && typeof body === "object") return [
            JSON.stringify(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (e2) {
        $9d5f51142a9a79a0$var$DEBUG_BUILD && (0, $7Dams.logger).warn("[Replay] Failed to serialize body", body);
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
    $9d5f51142a9a79a0$var$DEBUG_BUILD && (0, $7Dams.logger).info("[Replay] Skipping network body because of body type", body);
    return [
        undefined,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
function $9d5f51142a9a79a0$var$_getBodySize(body, responseType, textEncoder) {
    try {
        const bodyStr = responseType === "json" && body && typeof body === "object" ? JSON.stringify(body) : body;
        return $9d5f51142a9a79a0$var$getBodySize(bodyStr, textEncoder);
    } catch (e3) {
        return undefined;
    }
}
/**
 * This method does two things:
 * - It enriches the regular XHR/fetch breadcrumbs with request/response size data
 * - It captures the XHR/fetch breadcrumbs to the replay
 *   (enriching it with further data that is _not_ added to the regular breadcrumbs)
 */ function $9d5f51142a9a79a0$var$handleNetworkBreadcrumbs(replay) {
    const client = (0, $iKbxs.getClient)();
    try {
        const textEncoder = new TextEncoder();
        const { networkDetailAllowUrls: networkDetailAllowUrls, networkDetailDenyUrls: networkDetailDenyUrls, networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders, networkResponseHeaders: networkResponseHeaders } = replay.getOptions();
        const options = {
            replay: replay,
            textEncoder: textEncoder,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: networkRequestHeaders,
            networkResponseHeaders: networkResponseHeaders
        };
        if (client && client.on) client.on("beforeAddBreadcrumb", (breadcrumb, hint)=>$9d5f51142a9a79a0$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint));
        else {
            // Fallback behavior
            (0, $4V7kV.addFetchInstrumentationHandler)($9d5f51142a9a79a0$var$handleFetchSpanListener(replay));
            (0, $dk3nq.addXhrInstrumentationHandler)($9d5f51142a9a79a0$var$handleXhrSpanListener(replay));
        }
    } catch (e2) {
    // Do nothing
    }
}
/** just exported for tests */ function $9d5f51142a9a79a0$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint) {
    if (!breadcrumb.data) return;
    try {
        if ($9d5f51142a9a79a0$var$_isXhrBreadcrumb(breadcrumb) && $9d5f51142a9a79a0$var$_isXhrHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $9d5f51142a9a79a0$var$enrichXhrBreadcrumb(breadcrumb, hint, options);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $9d5f51142a9a79a0$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
        }
        if ($9d5f51142a9a79a0$var$_isFetchBreadcrumb(breadcrumb) && $9d5f51142a9a79a0$var$_isFetchHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $9d5f51142a9a79a0$var$enrichFetchBreadcrumb(breadcrumb, hint, options);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $9d5f51142a9a79a0$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
        }
    } catch (e) {
        $9d5f51142a9a79a0$var$DEBUG_BUILD && (0, $7Dams.logger).warn("Error when enriching network breadcrumb");
    }
}
function $9d5f51142a9a79a0$var$_isXhrBreadcrumb(breadcrumb) {
    return breadcrumb.category === "xhr";
}
function $9d5f51142a9a79a0$var$_isFetchBreadcrumb(breadcrumb) {
    return breadcrumb.category === "fetch";
}
function $9d5f51142a9a79a0$var$_isXhrHint(hint) {
    return hint && hint.xhr;
}
function $9d5f51142a9a79a0$var$_isFetchHint(hint) {
    return hint && hint.response;
}
let $9d5f51142a9a79a0$var$_LAST_BREADCRUMB = null;
function $9d5f51142a9a79a0$var$isBreadcrumbWithCategory(breadcrumb) {
    return !!breadcrumb.category;
}
const $9d5f51142a9a79a0$var$handleScopeListener = (replay)=>(scope)=>{
        if (!replay.isEnabled()) return;
        const result = $9d5f51142a9a79a0$var$handleScope(scope);
        if (!result) return;
        $9d5f51142a9a79a0$var$addBreadcrumbEvent(replay, result);
    };
/**
 * An event handler to handle scope changes.
 */ function $9d5f51142a9a79a0$var$handleScope(scope) {
    // TODO (v8): Remove this guard. This was put in place because we introduced
    // Scope.getLastBreadcrumb mid-v7 which caused incompatibilities with older SDKs.
    // For now, we'll just return null if the method doesn't exist but we should eventually
    // get rid of this guard.
    const newBreadcrumb = scope.getLastBreadcrumb && scope.getLastBreadcrumb();
    // Listener can be called when breadcrumbs have not changed, so we store the
    // reference to the last crumb and only return a crumb if it has changed
    if ($9d5f51142a9a79a0$var$_LAST_BREADCRUMB === newBreadcrumb || !newBreadcrumb) return null;
    $9d5f51142a9a79a0$var$_LAST_BREADCRUMB = newBreadcrumb;
    if (!$9d5f51142a9a79a0$var$isBreadcrumbWithCategory(newBreadcrumb) || [
        "fetch",
        "xhr",
        "sentry.event",
        "sentry.transaction"
    ].includes(newBreadcrumb.category) || newBreadcrumb.category.startsWith("ui.")) return null;
    if (newBreadcrumb.category === "console") return $9d5f51142a9a79a0$var$normalizeConsoleBreadcrumb(newBreadcrumb);
    return $9d5f51142a9a79a0$var$createBreadcrumb(newBreadcrumb);
}
/** exported for tests only */ function $9d5f51142a9a79a0$var$normalizeConsoleBreadcrumb(breadcrumb) {
    const args = breadcrumb.data && breadcrumb.data.arguments;
    if (!Array.isArray(args) || args.length === 0) return $9d5f51142a9a79a0$var$createBreadcrumb(breadcrumb);
    let isTruncated = false;
    // Avoid giant args captures
    const normalizedArgs = args.map((arg)=>{
        if (!arg) return arg;
        if (typeof arg === "string") {
            if (arg.length > $9d5f51142a9a79a0$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                return `${arg.slice(0, $9d5f51142a9a79a0$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return arg;
        }
        if (typeof arg === "object") try {
            const normalizedArg = (0, $6l9XD.normalize)(arg, 7);
            const stringified = JSON.stringify(normalizedArg);
            if (stringified.length > $9d5f51142a9a79a0$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                // We use the pretty printed JSON string here as a base
                return `${JSON.stringify(normalizedArg, null, 2).slice(0, $9d5f51142a9a79a0$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return normalizedArg;
        } catch (e) {
        // fall back to default
        }
        return arg;
    });
    return $9d5f51142a9a79a0$var$createBreadcrumb({
        ...breadcrumb,
        data: {
            ...breadcrumb.data,
            arguments: normalizedArgs,
            ...isTruncated ? {
                _meta: {
                    warnings: [
                        "CONSOLE_ARG_TRUNCATED"
                    ]
                }
            } : {}
        }
    });
}
/**
 * Add global listeners that cannot be removed.
 */ function $9d5f51142a9a79a0$var$addGlobalListeners(replay) {
    // Listeners from core SDK //
    const scope = (0, $iKbxs.getCurrentScope)();
    const client = (0, $iKbxs.getClient)();
    scope.addScopeListener($9d5f51142a9a79a0$var$handleScopeListener(replay));
    (0, $gPoCM.addClickKeypressInstrumentationHandler)($9d5f51142a9a79a0$var$handleDomListener(replay));
    (0, $bU1Fh.addHistoryInstrumentationHandler)($9d5f51142a9a79a0$var$handleHistorySpanListener(replay));
    $9d5f51142a9a79a0$var$handleNetworkBreadcrumbs(replay);
    // Tag all (non replay) events that get sent to Sentry with the current
    // replay ID so that we can reference them later in the UI
    const eventProcessor = $9d5f51142a9a79a0$var$handleGlobalEventListener(replay, !$9d5f51142a9a79a0$var$hasHooks(client));
    if (client && client.addEventProcessor) client.addEventProcessor(eventProcessor);
    else (0, $kp047.addEventProcessor)(eventProcessor);
    // If a custom client has no hooks yet, we continue to use the "old" implementation
    if ($9d5f51142a9a79a0$var$hasHooks(client)) {
        client.on("beforeSendEvent", $9d5f51142a9a79a0$var$handleBeforeSendEvent(replay));
        client.on("afterSendEvent", $9d5f51142a9a79a0$var$handleAfterSendEvent(replay));
        client.on("createDsc", (dsc)=>{
            const replayId = replay.getSessionId();
            // We do not want to set the DSC when in buffer mode, as that means the replay has not been sent (yet)
            if (replayId && replay.isEnabled() && replay.recordingMode === "session") {
                // Ensure to check that the session is still active - it could have expired in the meanwhile
                const isSessionActive = replay.checkAndHandleExpiredSession();
                if (isSessionActive) dsc.replay_id = replayId;
            }
        });
        client.on("startTransaction", (transaction)=>{
            replay.lastTransaction = transaction;
        });
        // We may be missing the initial startTransaction due to timing issues,
        // so we capture it on finish again.
        client.on("finishTransaction", (transaction)=>{
            replay.lastTransaction = transaction;
        });
        // We want to flush replay
        client.on("beforeSendFeedback", (feedbackEvent, options)=>{
            const replayId = replay.getSessionId();
            if (options && options.includeReplay && replay.isEnabled() && replayId) // This should never reject
            {
                if (feedbackEvent.contexts && feedbackEvent.contexts.feedback) feedbackEvent.contexts.feedback.replay_id = replayId;
            }
        });
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9d5f51142a9a79a0$var$hasHooks(client) {
    return !!(client && client.on);
}
/**
 * Create a "span" for the total amount of memory being used by JS objects
 * (including v8 internal objects).
 */ async function $9d5f51142a9a79a0$var$addMemoryEntry(replay) {
    // window.performance.memory is a non-standard API and doesn't work on all browsers, so we try-catch this
    try {
        return Promise.all($9d5f51142a9a79a0$var$createPerformanceSpans(replay, [
            // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
            $9d5f51142a9a79a0$var$createMemoryEntry($9d5f51142a9a79a0$var$WINDOW.performance.memory)
        ]));
    } catch (error) {
        // Do nothing
        return [];
    }
}
function $9d5f51142a9a79a0$var$createMemoryEntry(memoryEntry) {
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = memoryEntry;
    // we don't want to use `getAbsoluteTime` because it adds the event time to the
    // time origin, so we get the current timestamp instead
    const time = Date.now() / 1000;
    return {
        type: "memory",
        name: "memory",
        start: time,
        end: time,
        data: {
            memory: {
                jsHeapSizeLimit: jsHeapSizeLimit,
                totalJSHeapSize: totalJSHeapSize,
                usedJSHeapSize: usedJSHeapSize
            }
        }
    };
}
/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */ function $9d5f51142a9a79a0$var$debounce(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options && options.maxWait ? Math.max(options.maxWait, wait) : 0;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== undefined && clearTimeout(timerId);
        maxTimerId !== undefined && clearTimeout(maxTimerId);
        timerId = maxTimerId = undefined;
    }
    function flush() {
        if (timerId !== undefined || maxTimerId !== undefined) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeout(invokeFunc, wait);
        if (maxWait && maxTimerId === undefined) maxTimerId = setTimeout(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}
/**
 * Handler for recording events.
 *
 * Adds to event buffer, and has varying flushing behaviors if the event was a checkout.
 */ function $9d5f51142a9a79a0$var$getHandleRecordingEmit(replay) {
    let hadFirstEvent = false;
    return (event, _isCheckout)=>{
        // If this is false, it means session is expired, create and a new session and wait for checkout
        if (!replay.checkAndHandleExpiredSession()) {
            $9d5f51142a9a79a0$var$DEBUG_BUILD && (0, $7Dams.logger).warn("[Replay] Received replay event after session expired.");
            return;
        }
        // `_isCheckout` is only set when the checkout is due to `checkoutEveryNms`
        // We also want to treat the first event as a checkout, so we handle this specifically here
        const isCheckout = _isCheckout || !hadFirstEvent;
        hadFirstEvent = true;
        if (replay.clickDetector) $9d5f51142a9a79a0$var$updateClickDetectorForRecordingEvent(replay.clickDetector, event);
        // The handler returns `true` if we do not want to trigger debounced flush, `false` if we want to debounce flush.
        replay.addUpdate(()=>{
            // The session is always started immediately on pageload/init, but for
            // error-only replays, it should reflect the most recent checkout
            // when an error occurs. Clear any state that happens before this current
            // checkout. This needs to happen before `addEvent()` which updates state
            // dependent on this reset.
            if (replay.recordingMode === "buffer" && isCheckout) replay.setInitialState();
            // If the event is not added (e.g. due to being paused, disabled, or out of the max replay duration),
            // Skip all further steps
            if (!$9d5f51142a9a79a0$var$addEventSync(replay, event, isCheckout)) // Return true to skip scheduling a debounced flush
            return true;
            // Different behavior for full snapshots (type=2), ignore other event types
            // See https://github.com/rrweb-io/rrweb/blob/d8f9290ca496712aa1e7d472549480c4e7876594/packages/rrweb/src/types.ts#L16
            if (!isCheckout) return false;
            // Additionally, create a meta event that will capture certain SDK settings.
            // In order to handle buffer mode, this needs to either be done when we
            // receive checkout events or at flush time.
            //
            // `isCheckout` is always true, but want to be explicit that it should
            // only be added for checkouts
            $9d5f51142a9a79a0$var$addSettingsEvent(replay, isCheckout);
            // If there is a previousSessionId after a full snapshot occurs, then
            // the replay session was started due to session expiration. The new session
            // is started before triggering a new checkout and contains the id
            // of the previous session. Do not immediately flush in this case
            // to avoid capturing only the checkout and instead the replay will
            // be captured if they perform any follow-up actions.
            if (replay.session && replay.session.previousSessionId) return true;
            // When in buffer mode, make sure we adjust the session started date to the current earliest event of the buffer
            // this should usually be the timestamp of the checkout event, but to be safe...
            if (replay.recordingMode === "buffer" && replay.session && replay.eventBuffer) {
                const earliestEvent = replay.eventBuffer.getEarliestTimestamp();
                if (earliestEvent) {
                    $9d5f51142a9a79a0$var$logInfo(`[Replay] Updating session start time to earliest event in buffer to ${new Date(earliestEvent)}`, replay.getOptions()._experiments.traceInternals);
                    replay.session.started = earliestEvent;
                    if (replay.getOptions().stickySession) $9d5f51142a9a79a0$var$saveSession(replay.session);
                }
            }
            if (replay.recordingMode === "session") // If the full snapshot is due to an initial load, we will not have
            // a previous session ID. In this case, we want to buffer events
            // for a set amount of time before flushing. This can help avoid
            // capturing replays of users that immediately close the window.
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            return true;
        });
    };
}
/**
 * Exported for tests
 */ function $9d5f51142a9a79a0$var$createOptionsEvent(replay) {
    const options = replay.getOptions();
    return {
        type: $9d5f51142a9a79a0$var$EventType.Custom,
        timestamp: Date.now(),
        data: {
            tag: "options",
            payload: {
                shouldRecordCanvas: replay.isRecordingCanvas(),
                sessionSampleRate: options.sessionSampleRate,
                errorSampleRate: options.errorSampleRate,
                useCompressionOption: options.useCompression,
                blockAllMedia: options.blockAllMedia,
                maskAllText: options.maskAllText,
                maskAllInputs: options.maskAllInputs,
                useCompression: replay.eventBuffer ? replay.eventBuffer.type === "worker" : false,
                networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
                networkCaptureBodies: options.networkCaptureBodies,
                networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
                networkResponseHasHeaders: options.networkResponseHeaders.length > 0
            }
        }
    };
}
/**
 * Add a "meta" event that contains a simplified view on current configuration
 * options. This should only be included on the first segment of a recording.
 */ function $9d5f51142a9a79a0$var$addSettingsEvent(replay, isCheckout) {
    // Only need to add this event when sending the first segment
    if (!isCheckout || !replay.session || replay.session.segmentId !== 0) return;
    $9d5f51142a9a79a0$var$addEventSync(replay, $9d5f51142a9a79a0$var$createOptionsEvent(replay), false);
}
/**
 * Create a replay envelope ready to be sent.
 * This includes both the replay event, as well as the recording data.
 */ function $9d5f51142a9a79a0$var$createReplayEnvelope(replayEvent, recordingData, dsn, tunnel) {
    return (0, $dp1Mp.createEnvelope)((0, $dp1Mp.createEventEnvelopeHeaders)(replayEvent, (0, $dp1Mp.getSdkMetadataForEnvelopeHeader)(replayEvent), tunnel, dsn), [
        [
            {
                type: "replay_event"
            },
            replayEvent
        ],
        [
            {
                type: "replay_recording",
                // If string then we need to encode to UTF8, otherwise will have
                // wrong size. TextEncoder has similar browser support to
                // MutationObserver, although it does not accept IE11.
                length: typeof recordingData === "string" ? new TextEncoder().encode(recordingData).length : recordingData.length
            },
            recordingData
        ]
    ]);
}
/**
 * Prepare the recording data ready to be sent.
 */ function $9d5f51142a9a79a0$var$prepareRecordingData({ recordingData: recordingData, headers: headers }) {
    let payloadWithSequence;
    // XXX: newline is needed to separate sequence id from events
    const replayHeaders = `${JSON.stringify(headers)}
`;
    if (typeof recordingData === "string") payloadWithSequence = `${replayHeaders}${recordingData}`;
    else {
        const enc = new TextEncoder();
        // XXX: newline is needed to separate sequence id from events
        const sequence = enc.encode(replayHeaders);
        // Merge the two Uint8Arrays
        payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
        payloadWithSequence.set(sequence);
        payloadWithSequence.set(recordingData, sequence.length);
    }
    return payloadWithSequence;
}
/**
 * Prepare a replay event & enrich it with the SDK metadata.
 */ async function $9d5f51142a9a79a0$var$prepareReplayEvent({ client: client, scope: scope, replayId: event_id, event: event }) {
    const integrations = typeof client._integrations === "object" && client._integrations !== null && !Array.isArray(client._integrations) ? Object.keys(client._integrations) : undefined;
    const eventHint = {
        event_id: event_id,
        integrations: integrations
    };
    if (client.emit) client.emit("preprocessEvent", event, eventHint);
    const preparedEvent = await (0, $1M1wc.prepareEvent)(client.getOptions(), event, eventHint, scope, client, (0, $aFDsf.getIsolationScope)());
    // If e.g. a global event processor returned null
    if (!preparedEvent) return null;
    // This normally happens in browser client "_prepareEvent"
    // but since we do not use this private method from the client, but rather the plain import
    // we need to do this manually.
    preparedEvent.platform = preparedEvent.platform || "javascript";
    // extract the SDK name because `client._prepareEvent` doesn't add it to the event
    const metadata = client.getSdkMetadata && client.getSdkMetadata();
    const { name: name, version: version } = metadata && metadata.sdk || {};
    preparedEvent.sdk = {
        ...preparedEvent.sdk,
        name: name || "sentry.javascript.unknown",
        version: version || "0.0.0"
    };
    return preparedEvent;
}
/**
 * Send replay attachment using `fetch()`
 */ async function $9d5f51142a9a79a0$var$sendReplayRequest({ recordingData: recordingData, replayId: replayId, segmentId: segment_id, eventContext: eventContext, timestamp: timestamp, session: session }) {
    const preparedRecordingData = $9d5f51142a9a79a0$var$prepareRecordingData({
        recordingData: recordingData,
        headers: {
            segment_id: segment_id
        }
    });
    const { urls: urls, errorIds: errorIds, traceIds: traceIds, initialTimestamp: initialTimestamp } = eventContext;
    const client = (0, $iKbxs.getClient)();
    const scope = (0, $iKbxs.getCurrentScope)();
    const transport = client && client.getTransport();
    const dsn = client && client.getDsn();
    if (!client || !transport || !dsn || !session.sampled) return;
    const baseEvent = {
        type: $9d5f51142a9a79a0$var$REPLAY_EVENT_NAME,
        replay_start_timestamp: initialTimestamp / 1000,
        timestamp: timestamp / 1000,
        error_ids: errorIds,
        trace_ids: traceIds,
        urls: urls,
        replay_id: replayId,
        segment_id: segment_id,
        replay_type: session.sampled
    };
    const replayEvent = await $9d5f51142a9a79a0$var$prepareReplayEvent({
        scope: scope,
        client: client,
        replayId: replayId,
        event: baseEvent
    });
    if (!replayEvent) {
        // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
        client.recordDroppedEvent("event_processor", "replay", baseEvent);
        $9d5f51142a9a79a0$var$logInfo("An event processor returned `null`, will not send event.");
        return;
    }
    /*
  For reference, the fully built event looks something like this:
  {
      "type": "replay_event",
      "timestamp": 1670837008.634,
      "error_ids": [
          "errorId"
      ],
      "trace_ids": [
          "traceId"
      ],
      "urls": [
          "https://example.com"
      ],
      "replay_id": "eventId",
      "segment_id": 3,
      "replay_type": "error",
      "platform": "javascript",
      "event_id": "eventId",
      "environment": "production",
      "sdk": {
          "integrations": [
              "BrowserTracing",
              "Replay"
          ],
          "name": "sentry.javascript.browser",
          "version": "7.25.0"
      },
      "sdkProcessingMetadata": {},
      "contexts": {
      },
  }
  */ // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete replayEvent.sdkProcessingMetadata;
    const envelope = $9d5f51142a9a79a0$var$createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);
    let response;
    try {
        response = await transport.send(envelope);
    } catch (err) {
        const error = new Error($9d5f51142a9a79a0$var$UNABLE_TO_SEND_REPLAY);
        try {
            // In case browsers don't allow this property to be writable
            // @ts-expect-error This needs lib es2022 and newer
            error.cause = err;
        } catch (e) {
        // nothing to do
        }
        throw error;
    }
    // TODO (v8): we can remove this guard once transport.send's type signature doesn't include void anymore
    if (!response) return response;
    // If the status code is invalid, we want to immediately stop & not retry
    if (typeof response.statusCode === "number" && (response.statusCode < 200 || response.statusCode >= 300)) throw new $9d5f51142a9a79a0$var$TransportStatusCodeError(response.statusCode);
    const rateLimits = (0, $6mJ4l.updateRateLimits)({}, response);
    if ((0, $6mJ4l.isRateLimited)(rateLimits, "replay")) throw new $9d5f51142a9a79a0$var$RateLimitError(rateLimits);
    return response;
}
/**
 * This error indicates that the transport returned an invalid status code.
 */ class $9d5f51142a9a79a0$var$TransportStatusCodeError extends Error {
    constructor(statusCode){
        super(`Transport returned status code ${statusCode}`);
    }
}
/**
 * This error indicates that we hit a rate limit API error.
 */ class $9d5f51142a9a79a0$var$RateLimitError extends Error {
    constructor(rateLimits){
        super("Rate limit hit");
        this.rateLimits = rateLimits;
    }
}
/**
 * Finalize and send the current replay event to Sentry
 */ async function $9d5f51142a9a79a0$var$sendReplay(replayData, retryConfig = {
    count: 0,
    interval: $9d5f51142a9a79a0$var$RETRY_BASE_INTERVAL
}) {
    const { recordingData: recordingData, options: options } = replayData;
    // short circuit if there's no events to upload (this shouldn't happen as _runFlush makes this check)
    if (!recordingData.length) return;
    try {
        await $9d5f51142a9a79a0$var$sendReplayRequest(replayData);
        return true;
    } catch (err) {
        if (err instanceof $9d5f51142a9a79a0$var$TransportStatusCodeError || err instanceof $9d5f51142a9a79a0$var$RateLimitError) throw err;
        // Capture error for every failed replay
        (0, $iKbxs.setContext)("Replays", {
            _retryCount: retryConfig.count
        });
        if ($9d5f51142a9a79a0$var$DEBUG_BUILD && options._experiments && options._experiments.captureExceptions) (0, $iKbxs.captureException)(err);
        // If an error happened here, it's likely that uploading the attachment
        // failed, we'll can retry with the same events payload
        if (retryConfig.count >= $9d5f51142a9a79a0$var$RETRY_MAX_COUNT) {
            const error = new Error(`${$9d5f51142a9a79a0$var$UNABLE_TO_SEND_REPLAY} - max retries exceeded`);
            try {
                // In case browsers don't allow this property to be writable
                // @ts-expect-error This needs lib es2022 and newer
                error.cause = err;
            } catch (e) {
            // nothing to do
            }
            throw error;
        }
        // will retry in intervals of 5, 10, 30
        retryConfig.interval *= ++retryConfig.count;
        return new Promise((resolve, reject)=>{
            setTimeout(async ()=>{
                try {
                    await $9d5f51142a9a79a0$var$sendReplay(replayData, retryConfig);
                    resolve(true);
                } catch (err) {
                    reject(err);
                }
            }, retryConfig.interval);
        });
    }
}
const $9d5f51142a9a79a0$var$THROTTLED = "__THROTTLED";
const $9d5f51142a9a79a0$var$SKIPPED = "__SKIPPED";
/**
 * Create a throttled function off a given function.
 * When calling the throttled function, it will call the original function only
 * if it hasn't been called more than `maxCount` times in the last `durationSeconds`.
 *
 * Returns `THROTTLED` if throttled for the first time, after that `SKIPPED`,
 * or else the return value of the original function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9d5f51142a9a79a0$var$throttle(fn, maxCount, durationSeconds) {
    const counter = new Map();
    const _cleanup = (now)=>{
        const threshold = now - durationSeconds;
        counter.forEach((_value, key)=>{
            if (key < threshold) counter.delete(key);
        });
    };
    const _getTotalCount = ()=>{
        return [
            ...counter.values()
        ].reduce((a, b)=>a + b, 0);
    };
    let isThrottled = false;
    return (...rest)=>{
        // Date in second-precision, which we use as basis for the throttling
        const now = Math.floor(Date.now() / 1000);
        // First, make sure to delete any old entries
        _cleanup(now);
        // If already over limit, do nothing
        if (_getTotalCount() >= maxCount) {
            const wasThrottled = isThrottled;
            isThrottled = true;
            return wasThrottled ? $9d5f51142a9a79a0$var$SKIPPED : $9d5f51142a9a79a0$var$THROTTLED;
        }
        isThrottled = false;
        const count = counter.get(now) || 0;
        counter.set(now, count + 1);
        return fn(...rest);
    };
}
/* eslint-disable max-lines */ // TODO: We might want to split this file up
/**
 * The main replay container class, which holds all the state and methods for recording and sending replays.
 */ class $9d5f51142a9a79a0$var$ReplayContainer {
    /**
   * Recording can happen in one of three modes:
   *   - session: Record the whole session, sending it continuously
   *   - buffer: Always keep the last 60s of recording, requires:
   *     - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *     - or calling `flush()` to send the replay
   */ /**
   * The current or last active transcation.
   * This is only available when performance is enabled.
   */ /**
   * These are here so we can overwrite them in tests etc.
   * @hidden
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Timestamp of the last user activity. This lives across sessions.
   */ /**
   * Is the integration currently active?
   */ /**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   */ /**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   */ /**
   * Function to stop recording
   */ /**
   * Internal use for canvas recording options
   */ constructor({ options: options, recordingOptions: recordingOptions }){
        $9d5f51142a9a79a0$var$ReplayContainer.prototype.__init.call(this);
        $9d5f51142a9a79a0$var$ReplayContainer.prototype.__init2.call(this);
        $9d5f51142a9a79a0$var$ReplayContainer.prototype.__init3.call(this);
        $9d5f51142a9a79a0$var$ReplayContainer.prototype.__init4.call(this);
        $9d5f51142a9a79a0$var$ReplayContainer.prototype.__init5.call(this);
        $9d5f51142a9a79a0$var$ReplayContainer.prototype.__init6.call(this);
        this.eventBuffer = null;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        this.recordingMode = "session";
        this.timeouts = {
            sessionIdlePause: $9d5f51142a9a79a0$var$SESSION_IDLE_PAUSE_DURATION,
            sessionIdleExpire: $9d5f51142a9a79a0$var$SESSION_IDLE_EXPIRE_DURATION
        };
        this._lastActivity = Date.now();
        this._isEnabled = false;
        this._isPaused = false;
        this._hasInitializedCoreListeners = false;
        this._context = {
            errorIds: new Set(),
            traceIds: new Set(),
            urls: [],
            initialTimestamp: Date.now(),
            initialUrl: ""
        };
        this._recordingOptions = recordingOptions;
        this._options = options;
        this._debouncedFlush = $9d5f51142a9a79a0$var$debounce(()=>this._flush(), this._options.flushMinDelay, {
            maxWait: this._options.flushMaxDelay
        });
        this._throttledAddEvent = $9d5f51142a9a79a0$var$throttle((event, isCheckout)=>$9d5f51142a9a79a0$var$addEvent(this, event, isCheckout), // Max 300 events...
        300, // ... per 5s
        5);
        const { slowClickTimeout: slowClickTimeout, slowClickIgnoreSelectors: slowClickIgnoreSelectors } = this.getOptions();
        const slowClickConfig = slowClickTimeout ? {
            threshold: Math.min($9d5f51142a9a79a0$var$SLOW_CLICK_THRESHOLD, slowClickTimeout),
            timeout: slowClickTimeout,
            scrollTimeout: $9d5f51142a9a79a0$var$SLOW_CLICK_SCROLL_TIMEOUT,
            ignoreSelector: slowClickIgnoreSelectors ? slowClickIgnoreSelectors.join(",") : ""
        } : undefined;
        if (slowClickConfig) this.clickDetector = new $9d5f51142a9a79a0$var$ClickDetector(this, slowClickConfig);
    }
    /** Get the event context. */ getContext() {
        return this._context;
    }
    /** If recording is currently enabled. */ isEnabled() {
        return this._isEnabled;
    }
    /** If recording is currently paused. */ isPaused() {
        return this._isPaused;
    }
    /**
   * Determine if canvas recording is enabled
   */ isRecordingCanvas() {
        return Boolean(this._canvas);
    }
    /** Get the replay integration options. */ getOptions() {
        return this._options;
    }
    /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */ initializeSampling(previousSessionId) {
        const { errorSampleRate: errorSampleRate, sessionSampleRate: sessionSampleRate } = this._options;
        // If neither sample rate is > 0, then do nothing - user will need to call one of
        // `start()` or `startBuffering` themselves.
        if (errorSampleRate <= 0 && sessionSampleRate <= 0) return;
        // Otherwise if there is _any_ sample rate set, try to load an existing
        // session, or create a new one.
        this._initializeSessionForSampling(previousSessionId);
        if (!this.session) {
            // This should not happen, something wrong has occurred
            this._handleException(new Error("Unable to initialize and create session"));
            return;
        }
        if (this.session.sampled === false) // This should only occur if `errorSampleRate` is 0 and was unsampled for
        // session-based replay. In this case there is nothing to do.
        return;
        // If segmentId > 0, it means we've previously already captured this session
        // In this case, we still want to continue in `session` recording mode
        this.recordingMode = this.session.sampled === "buffer" && this.session.segmentId === 0 ? "buffer" : "session";
        $9d5f51142a9a79a0$var$logInfoNextTick(`[Replay] Starting replay in ${this.recordingMode} mode`, this._options._experiments.traceInternals);
        this._initializeRecording();
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (this._isEnabled && this.recordingMode === "session") throw new Error("Replay recording is already in progress");
        if (this._isEnabled && this.recordingMode === "buffer") throw new Error("Replay buffering is in progress, call `flush()` to save the replay");
        $9d5f51142a9a79a0$var$logInfoNextTick("[Replay] Starting replay in session mode", this._options._experiments.traceInternals);
        // Required as user activity is initially set in
        // constructor, so if `start()` is called after
        // session idle expiration, a replay will not be
        // created due to an idle timeout.
        this._updateUserActivity();
        const session = $9d5f51142a9a79a0$var$loadOrCreateSession({
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            traceInternals: this._options._experiments.traceInternals
        }, {
            stickySession: this._options.stickySession,
            // This is intentional: create a new session-based replay when calling `start()`
            sessionSampleRate: 1,
            allowBuffering: false
        });
        this.session = session;
        this._initializeRecording();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */ startBuffering() {
        if (this._isEnabled) throw new Error("Replay recording is already in progress");
        $9d5f51142a9a79a0$var$logInfoNextTick("[Replay] Starting replay in buffer mode", this._options._experiments.traceInternals);
        const session = $9d5f51142a9a79a0$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            traceInternals: this._options._experiments.traceInternals
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: 0,
            allowBuffering: true
        });
        this.session = session;
        this.recordingMode = "buffer";
        this._initializeRecording();
    }
    /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */ startRecording() {
        try {
            const canvasOptions = this._canvas;
            this._stopRecording = $9d5f51142a9a79a0$var$record({
                ...this._recordingOptions,
                // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
                // Without this, it would record forever, until an error happens, which we don't want
                // instead, we'll always keep the last 60 seconds of replay before an error happened
                ...this.recordingMode === "buffer" && {
                    checkoutEveryNms: $9d5f51142a9a79a0$var$BUFFER_CHECKOUT_TIME
                },
                emit: $9d5f51142a9a79a0$var$getHandleRecordingEmit(this),
                onMutation: this._onMutationHandler,
                ...canvasOptions ? {
                    recordCanvas: canvasOptions.recordCanvas,
                    getCanvasManager: canvasOptions.getCanvasManager,
                    sampling: canvasOptions.sampling,
                    dataURLOptions: canvasOptions.dataURLOptions
                } : {}
            });
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */ stopRecording() {
        try {
            if (this._stopRecording) {
                this._stopRecording();
                this._stopRecording = undefined;
            }
            return true;
        } catch (err) {
            this._handleException(err);
            return false;
        }
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ async stop({ forceFlush: forceFlush = false, reason: reason } = {}) {
        if (!this._isEnabled) return;
        // We can't move `_isEnabled` after awaiting a flush, otherwise we can
        // enter into an infinite loop when `stop()` is called while flushing.
        this._isEnabled = false;
        try {
            $9d5f51142a9a79a0$var$logInfo(`[Replay] Stopping Replay${reason ? ` triggered by ${reason}` : ""}`, this._options._experiments.traceInternals);
            this._removeListeners();
            this.stopRecording();
            this._debouncedFlush.cancel();
            // See comment above re: `_isEnabled`, we "force" a flush, ignoring the
            // `_isEnabled` state of the plugin since it was disabled above.
            if (forceFlush) await this._flush({
                force: true
            });
            // After flush, destroy event buffer
            this.eventBuffer && this.eventBuffer.destroy();
            this.eventBuffer = null;
            // Clear session from session storage, note this means if a new session
            // is started after, it will not have `previousSessionId`
            $9d5f51142a9a79a0$var$clearSession(this);
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */ pause() {
        if (this._isPaused) return;
        this._isPaused = true;
        this.stopRecording();
        $9d5f51142a9a79a0$var$logInfo("[Replay] Pausing replay", this._options._experiments.traceInternals);
    }
    /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */ resume() {
        if (!this._isPaused || !this._checkSession()) return;
        this._isPaused = false;
        this.startRecording();
        $9d5f51142a9a79a0$var$logInfo("[Replay] Resuming replay", this._options._experiments.traceInternals);
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ async sendBufferedReplayOrFlush({ continueRecording: continueRecording = true } = {}) {
        if (this.recordingMode === "session") return this.flushImmediate();
        const activityTime = Date.now();
        $9d5f51142a9a79a0$var$logInfo("[Replay] Converting buffer to session", this._options._experiments.traceInternals);
        // Allow flush to complete before resuming as a session recording, otherwise
        // the checkout from `startRecording` may be included in the payload.
        // Prefer to keep the error replay as a separate (and smaller) segment
        // than the session replay.
        await this.flushImmediate();
        const hasStoppedRecording = this.stopRecording();
        if (!continueRecording || !hasStoppedRecording) return;
        // To avoid race conditions where this is called multiple times, we check here again that we are still buffering
        if (this.recordingMode === "session") return;
        // Re-start recording in session-mode
        this.recordingMode = "session";
        // Once this session ends, we do not want to refresh it
        if (this.session) {
            this._updateUserActivity(activityTime);
            this._updateSessionActivity(activityTime);
            this._maybeSaveSession();
        }
        this.startRecording();
    }
    /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */ addUpdate(cb) {
        // We need to always run `cb` (e.g. in the case of `this.recordingMode == 'buffer'`)
        const cbResult = cb();
        // If this option is turned on then we will only want to call `flush`
        // explicitly
        if (this.recordingMode === "buffer") return;
        // If callback is true, we do not want to continue with flushing -- the
        // caller will need to handle it.
        if (cbResult === true) return;
        // addUpdate is called quite frequently - use _debouncedFlush so that it
        // respects the flush delays and does not flush immediately
        this._debouncedFlush();
    }
    /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */ triggerUserActivity() {
        this._updateUserActivity();
        // This case means that recording was once stopped due to inactivity.
        // Ensure that recording is resumed.
        if (!this._stopRecording) {
            // Create a new session, otherwise when the user action is flushed, it
            // will get rejected due to an expired session.
            if (!this._checkSession()) return;
            // Note: This will cause a new DOM checkout
            this.resume();
            return;
        }
        // Otherwise... recording was never suspended, continue as normalish
        this.checkAndHandleExpiredSession();
        this._updateSessionActivity();
    }
    /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */ updateUserActivity() {
        this._updateUserActivity();
        this._updateSessionActivity();
    }
    /**
   * Only flush if `this.recordingMode === 'session'`
   */ conditionalFlush() {
        if (this.recordingMode === "buffer") return Promise.resolve();
        return this.flushImmediate();
    }
    /**
   * Flush using debounce flush
   */ flush() {
        return this._debouncedFlush();
    }
    /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of mulitple flushes happening closely together.
   */ flushImmediate() {
        this._debouncedFlush();
        // `.flush` is provided by the debounced function, analogously to lodash.debounce
        return this._debouncedFlush.flush();
    }
    /**
   * Cancels queued up flushes.
   */ cancelFlush() {
        this._debouncedFlush.cancel();
    }
    /** Get the current sesion (=replay) ID */ getSessionId() {
        return this.session && this.session.id;
    }
    /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */ checkAndHandleExpiredSession() {
        // Prevent starting a new session if the last user activity is older than
        // SESSION_IDLE_PAUSE_DURATION. Otherwise non-user activity can trigger a new
        // session+recording. This creates noisy replays that do not have much
        // content in them.
        if (this._lastActivity && $9d5f51142a9a79a0$var$isExpired(this._lastActivity, this.timeouts.sessionIdlePause) && this.session && this.session.sampled === "session") {
            // Pause recording only for session-based replays. Otherwise, resuming
            // will create a new replay and will conflict with users who only choose
            // to record error-based replays only. (e.g. the resumed replay will not
            // contain a reference to an error)
            this.pause();
            return;
        }
        // --- There is recent user activity --- //
        // This will create a new session if expired, based on expiry length
        if (!this._checkSession()) // Check session handles the refreshing itself
        return false;
        return true;
    }
    /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */ setInitialState() {
        const urlPath = `${$9d5f51142a9a79a0$var$WINDOW.location.pathname}${$9d5f51142a9a79a0$var$WINDOW.location.hash}${$9d5f51142a9a79a0$var$WINDOW.location.search}`;
        const url = `${$9d5f51142a9a79a0$var$WINDOW.location.origin}${urlPath}`;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        // Reset _context as well
        this._clearContext();
        this._context.initialUrl = url;
        this._context.initialTimestamp = Date.now();
        this._context.urls.push(url);
    }
    /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */ throttledAddEvent(event, isCheckout) {
        const res = this._throttledAddEvent(event, isCheckout);
        // If this is THROTTLED, it means we have throttled the event for the first time
        // In this case, we want to add a breadcrumb indicating that something was skipped
        if (res === $9d5f51142a9a79a0$var$THROTTLED) {
            const breadcrumb = $9d5f51142a9a79a0$var$createBreadcrumb({
                category: "replay.throttled"
            });
            this.addUpdate(()=>{
                // Return `false` if the event _was_ added, as that means we schedule a flush
                return !$9d5f51142a9a79a0$var$addEventSync(this, {
                    type: $9d5f51142a9a79a0$var$ReplayEventTypeCustom,
                    timestamp: breadcrumb.timestamp || 0,
                    data: {
                        tag: "breadcrumb",
                        payload: breadcrumb,
                        metric: true
                    }
                });
            });
        }
        return res;
    }
    /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */ getCurrentRoute() {
        // eslint-disable-next-line deprecation/deprecation
        const lastTransaction = this.lastTransaction || (0, $iKbxs.getCurrentScope)().getTransaction();
        const attributes = lastTransaction && (0, $IueXx.spanToJSON)(lastTransaction).data || {};
        const source = attributes[0, $9t32t.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        if (!lastTransaction || !source || ![
            "route",
            "custom"
        ].includes(source)) return undefined;
        return (0, $IueXx.spanToJSON)(lastTransaction).description;
    }
    /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */ _initializeRecording() {
        this.setInitialState();
        // this method is generally called on page load or manually - in both cases
        // we should treat it as an activity
        this._updateSessionActivity();
        this.eventBuffer = $9d5f51142a9a79a0$var$createEventBuffer({
            useCompression: this._options.useCompression,
            workerUrl: this._options.workerUrl
        });
        this._removeListeners();
        this._addListeners();
        // Need to set as enabled before we start recording, as `record()` can trigger a flush with a new checkout
        this._isEnabled = true;
        this._isPaused = false;
        this.startRecording();
    }
    /** A wrapper to conditionally capture exceptions. */ _handleException(error) {
        $9d5f51142a9a79a0$var$DEBUG_BUILD && (0, $7Dams.logger).error("[Replay]", error);
        if ($9d5f51142a9a79a0$var$DEBUG_BUILD && this._options._experiments && this._options._experiments.captureExceptions) (0, $iKbxs.captureException)(error);
    }
    /**
   * Loads (or refreshes) the current session.
   */ _initializeSessionForSampling(previousSessionId) {
        // Whenever there is _any_ error sample rate, we always allow buffering
        // Because we decide on sampling when an error occurs, we need to buffer at all times if sampling for errors
        const allowBuffering = this._options.errorSampleRate > 0;
        const session = $9d5f51142a9a79a0$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            traceInternals: this._options._experiments.traceInternals,
            previousSessionId: previousSessionId
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: this._options.sessionSampleRate,
            allowBuffering: allowBuffering
        });
        this.session = session;
    }
    /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */ _checkSession() {
        // If there is no session yet, we do not want to refresh anything
        // This should generally not happen, but to be safe....
        if (!this.session) return false;
        const currentSession = this.session;
        if ($9d5f51142a9a79a0$var$shouldRefreshSession(currentSession, {
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration
        })) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this._refreshSession(currentSession);
            return false;
        }
        return true;
    }
    /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */ async _refreshSession(session) {
        if (!this._isEnabled) return;
        await this.stop({
            reason: "refresh session"
        });
        this.initializeSampling(session.id);
    }
    /**
   * Adds listeners to record events for the replay
   */ _addListeners() {
        try {
            $9d5f51142a9a79a0$var$WINDOW.document.addEventListener("visibilitychange", this._handleVisibilityChange);
            $9d5f51142a9a79a0$var$WINDOW.addEventListener("blur", this._handleWindowBlur);
            $9d5f51142a9a79a0$var$WINDOW.addEventListener("focus", this._handleWindowFocus);
            $9d5f51142a9a79a0$var$WINDOW.addEventListener("keydown", this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.addListeners();
            // There is no way to remove these listeners, so ensure they are only added once
            if (!this._hasInitializedCoreListeners) {
                $9d5f51142a9a79a0$var$addGlobalListeners(this);
                this._hasInitializedCoreListeners = true;
            }
        } catch (err) {
            this._handleException(err);
        }
        this._performanceCleanupCallback = $9d5f51142a9a79a0$var$setupPerformanceObserver(this);
    }
    /**
   * Cleans up listeners that were created in `_addListeners`
   */ _removeListeners() {
        try {
            $9d5f51142a9a79a0$var$WINDOW.document.removeEventListener("visibilitychange", this._handleVisibilityChange);
            $9d5f51142a9a79a0$var$WINDOW.removeEventListener("blur", this._handleWindowBlur);
            $9d5f51142a9a79a0$var$WINDOW.removeEventListener("focus", this._handleWindowFocus);
            $9d5f51142a9a79a0$var$WINDOW.removeEventListener("keydown", this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.removeListeners();
            if (this._performanceCleanupCallback) this._performanceCleanupCallback();
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */ __init() {
        this._handleVisibilityChange = ()=>{
            if ($9d5f51142a9a79a0$var$WINDOW.document.visibilityState === "visible") this._doChangeToForegroundTasks();
            else this._doChangeToBackgroundTasks();
        };
    }
    /**
   * Handle when page is blurred
   */ __init2() {
        this._handleWindowBlur = ()=>{
            const breadcrumb = $9d5f51142a9a79a0$var$createBreadcrumb({
                category: "ui.blur"
            });
            // Do not count blur as a user action -- it's part of the process of them
            // leaving the page
            this._doChangeToBackgroundTasks(breadcrumb);
        };
    }
    /**
   * Handle when page is focused
   */ __init3() {
        this._handleWindowFocus = ()=>{
            const breadcrumb = $9d5f51142a9a79a0$var$createBreadcrumb({
                category: "ui.focus"
            });
            // Do not count focus as a user action -- instead wait until they focus and
            // interactive with page
            this._doChangeToForegroundTasks(breadcrumb);
        };
    }
    /** Ensure page remains active when a key is pressed. */ __init4() {
        this._handleKeyboardEvent = (event)=>{
            $9d5f51142a9a79a0$var$handleKeyboardEvent(this, event);
        };
    }
    /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */ _doChangeToBackgroundTasks(breadcrumb) {
        if (!this.session) return;
        const expired = $9d5f51142a9a79a0$var$isSessionExpired(this.session, {
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire
        });
        if (expired) return;
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
        // Send replay when the page/tab becomes hidden. There is no reason to send
        // replay if it becomes visible, since no actions we care about were done
        // while it was hidden
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.conditionalFlush();
    }
    /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */ _doChangeToForegroundTasks(breadcrumb) {
        if (!this.session) return;
        const isSessionActive = this.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            // If the user has come back to the page within SESSION_IDLE_PAUSE_DURATION
            // ms, we will re-use the existing session, otherwise create a new
            // session
            $9d5f51142a9a79a0$var$logInfo("[Replay] Document has become active, but session has expired");
            return;
        }
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
    }
    /**
   * Update user activity (across session lifespans)
   */ _updateUserActivity(_lastActivity = Date.now()) {
        this._lastActivity = _lastActivity;
    }
    /**
   * Updates the session's last activity timestamp
   */ _updateSessionActivity(_lastActivity = Date.now()) {
        if (this.session) {
            this.session.lastActivity = _lastActivity;
            this._maybeSaveSession();
        }
    }
    /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */ _createCustomBreadcrumb(breadcrumb) {
        this.addUpdate(()=>{
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.throttledAddEvent({
                type: $9d5f51142a9a79a0$var$EventType.Custom,
                timestamp: breadcrumb.timestamp || 0,
                data: {
                    tag: "breadcrumb",
                    payload: breadcrumb
                }
            });
        });
    }
    /**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */ _addPerformanceEntries() {
        const performanceEntries = $9d5f51142a9a79a0$var$createPerformanceEntries(this.performanceEntries).concat(this.replayPerformanceEntries);
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        return Promise.all($9d5f51142a9a79a0$var$createPerformanceSpans(this, performanceEntries));
    }
    /**
   * Clear _context
   */ _clearContext() {
        // XXX: `initialTimestamp` and `initialUrl` do not get cleared
        this._context.errorIds.clear();
        this._context.traceIds.clear();
        this._context.urls = [];
    }
    /** Update the initial timestamp based on the buffer content. */ _updateInitialTimestampFromEventBuffer() {
        const { session: session, eventBuffer: eventBuffer } = this;
        if (!session || !eventBuffer) return;
        // we only ever update this on the initial segment
        if (session.segmentId) return;
        const earliestEvent = eventBuffer.getEarliestTimestamp();
        if (earliestEvent && earliestEvent < this._context.initialTimestamp) this._context.initialTimestamp = earliestEvent;
    }
    /**
   * Return and clear _context
   */ _popEventContext() {
        const _context = {
            initialTimestamp: this._context.initialTimestamp,
            initialUrl: this._context.initialUrl,
            errorIds: Array.from(this._context.errorIds),
            traceIds: Array.from(this._context.traceIds),
            urls: this._context.urls
        };
        this._clearContext();
        return _context;
    }
    /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */ async _runFlush() {
        const replayId = this.getSessionId();
        if (!this.session || !this.eventBuffer || !replayId) {
            $9d5f51142a9a79a0$var$DEBUG_BUILD && (0, $7Dams.logger).error("[Replay] No session or eventBuffer found to flush.");
            return;
        }
        await this._addPerformanceEntries();
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer || !this.eventBuffer.hasEvents) return;
        // Only attach memory event if eventBuffer is not empty
        await $9d5f51142a9a79a0$var$addMemoryEntry(this);
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer) return;
        // if this changed in the meanwhile, e.g. because the session was refreshed or similar, we abort here
        if (replayId !== this.getSessionId()) return;
        try {
            // This uses the data from the eventBuffer, so we need to call this before `finish()
            this._updateInitialTimestampFromEventBuffer();
            const timestamp = Date.now();
            // Check total duration again, to avoid sending outdated stuff
            // We leave 30s wiggle room to accomodate late flushing etc.
            // This _could_ happen when the browser is suspended during flushing, in which case we just want to stop
            if (timestamp - this._context.initialTimestamp > this._options.maxReplayDuration + 30000) throw new Error("Session is too long, not sending replay");
            const eventContext = this._popEventContext();
            // Always increment segmentId regardless of outcome of sending replay
            const segmentId = this.session.segmentId++;
            this._maybeSaveSession();
            // Note this empties the event buffer regardless of outcome of sending replay
            const recordingData = await this.eventBuffer.finish();
            await $9d5f51142a9a79a0$var$sendReplay({
                replayId: replayId,
                recordingData: recordingData,
                segmentId: segmentId,
                eventContext: eventContext,
                session: this.session,
                options: this.getOptions(),
                timestamp: timestamp
            });
        } catch (err) {
            this._handleException(err);
            // This means we retried 3 times and all of them failed,
            // or we ran into a problem we don't want to retry, like rate limiting.
            // In this case, we want to completely stop the replay - otherwise, we may get inconsistent segments
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.stop({
                reason: "sendReplay"
            });
            const client = (0, $iKbxs.getClient)();
            if (client) client.recordDroppedEvent("send_error", "replay");
        }
    }
    /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */ __init5() {
        this._flush = async ({ force: force = false } = {})=>{
            if (!this._isEnabled && !force) // This can happen if e.g. the replay was stopped because of exceeding the retry limit
            return;
            if (!this.checkAndHandleExpiredSession()) {
                $9d5f51142a9a79a0$var$DEBUG_BUILD && (0, $7Dams.logger).error("[Replay] Attempting to finish replay event after session expired.");
                return;
            }
            if (!this.session) // should never happen, as we would have bailed out before
            return;
            const start = this.session.started;
            const now = Date.now();
            const duration = now - start;
            // A flush is about to happen, cancel any queued flushes
            this._debouncedFlush.cancel();
            // If session is too short, or too long (allow some wiggle room over maxReplayDuration), do not send it
            // This _should_ not happen, but it may happen if flush is triggered due to a page activity change or similar
            const tooShort = duration < this._options.minReplayDuration;
            const tooLong = duration > this._options.maxReplayDuration + 5000;
            if (tooShort || tooLong) {
                $9d5f51142a9a79a0$var$logInfo(`[Replay] Session duration (${Math.floor(duration / 1000)}s) is too ${tooShort ? "short" : "long"}, not sending replay.`, this._options._experiments.traceInternals);
                if (tooShort) this._debouncedFlush();
                return;
            }
            const eventBuffer = this.eventBuffer;
            if (eventBuffer && this.session.segmentId === 0 && !eventBuffer.hasCheckout) $9d5f51142a9a79a0$var$logInfo("[Replay] Flushing initial segment without checkout.", this._options._experiments.traceInternals);
            // this._flushLock acts as a lock so that future calls to `_flush()`
            // will be blocked until this promise resolves
            if (!this._flushLock) {
                this._flushLock = this._runFlush();
                await this._flushLock;
                this._flushLock = undefined;
                return;
            }
            // Wait for previous flush to finish, then call the debounced `_flush()`.
            // It's possible there are other flush requests queued and waiting for it
            // to resolve. We want to reduce all outstanding requests (as well as any
            // new flush requests that occur within a second of the locked flush
            // completing) into a single flush.
            try {
                await this._flushLock;
            } catch (err) {
                $9d5f51142a9a79a0$var$DEBUG_BUILD && (0, $7Dams.logger).error(err);
            } finally{
                this._debouncedFlush();
            }
        };
    }
    /** Save the session, if it is sticky */ _maybeSaveSession() {
        if (this.session && this._options.stickySession) $9d5f51142a9a79a0$var$saveSession(this.session);
    }
    /** Handler for rrweb.record.onMutation */ __init6() {
        this._onMutationHandler = (mutations)=>{
            const count = mutations.length;
            const mutationLimit = this._options.mutationLimit;
            const mutationBreadcrumbLimit = this._options.mutationBreadcrumbLimit;
            const overMutationLimit = mutationLimit && count > mutationLimit;
            // Create a breadcrumb if a lot of mutations happen at the same time
            // We can show this in the UI as an information with potential performance improvements
            if (count > mutationBreadcrumbLimit || overMutationLimit) {
                const breadcrumb = $9d5f51142a9a79a0$var$createBreadcrumb({
                    category: "replay.mutations",
                    data: {
                        count: count,
                        limit: overMutationLimit
                    }
                });
                this._createCustomBreadcrumb(breadcrumb);
            }
            // Stop replay if over the mutation limit
            if (overMutationLimit) {
                // This should never reject
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.stop({
                    reason: "mutationLimit",
                    forceFlush: this.recordingMode === "session"
                });
                return false;
            }
            // `true` means we use the regular mutation handling by rrweb
            return true;
        };
    }
}
function $9d5f51142a9a79a0$var$getOption(selectors, defaultSelectors, deprecatedClassOption, deprecatedSelectorOption) {
    const deprecatedSelectors = typeof deprecatedSelectorOption === "string" ? deprecatedSelectorOption.split(",") : [];
    const allSelectors = [
        ...selectors,
        // @deprecated
        ...deprecatedSelectors,
        // sentry defaults
        ...defaultSelectors
    ];
    // @deprecated
    if (typeof deprecatedClassOption !== "undefined") {
        // NOTE: No support for RegExp
        if (typeof deprecatedClassOption === "string") allSelectors.push(`.${deprecatedClassOption}`);
        (0, $7Dams.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Replay] You are using a deprecated configuration item for privacy. Read the documentation on how to use the new privacy configuration.");
        });
    }
    return allSelectors.join(",");
}
/**
 * Returns privacy related configuration for use in rrweb
 */ function $9d5f51142a9a79a0$var$getPrivacyOptions({ mask: mask, unmask: unmask, block: block, unblock: unblock, ignore: ignore, blockClass: // eslint-disable-next-line deprecation/deprecation
blockClass, blockSelector: // eslint-disable-next-line deprecation/deprecation
blockSelector, maskTextClass: // eslint-disable-next-line deprecation/deprecation
maskTextClass, maskTextSelector: // eslint-disable-next-line deprecation/deprecation
maskTextSelector, ignoreClass: // eslint-disable-next-line deprecation/deprecation
ignoreClass }) {
    const defaultBlockedElements = [
        'base[href="/"]'
    ];
    const maskSelector = $9d5f51142a9a79a0$var$getOption(mask, [
        ".sentry-mask",
        "[data-sentry-mask]"
    ], maskTextClass, maskTextSelector);
    const unmaskSelector = $9d5f51142a9a79a0$var$getOption(unmask, [
        ".sentry-unmask",
        "[data-sentry-unmask]"
    ]);
    const options = {
        // We are making the decision to make text and input selectors the same
        maskTextSelector: maskSelector,
        unmaskTextSelector: unmaskSelector,
        blockSelector: $9d5f51142a9a79a0$var$getOption(block, [
            ".sentry-block",
            "[data-sentry-block]",
            ...defaultBlockedElements
        ], blockClass, blockSelector),
        unblockSelector: $9d5f51142a9a79a0$var$getOption(unblock, [
            ".sentry-unblock",
            "[data-sentry-unblock]"
        ]),
        ignoreSelector: $9d5f51142a9a79a0$var$getOption(ignore, [
            ".sentry-ignore",
            "[data-sentry-ignore]",
            'input[type="file"]'
        ], ignoreClass)
    };
    if (blockClass instanceof RegExp) options.blockClass = blockClass;
    if (maskTextClass instanceof RegExp) options.maskTextClass = maskTextClass;
    return options;
}
/**
 * Masks an attribute if necessary, otherwise return attribute value as-is.
 */ function $9d5f51142a9a79a0$var$maskAttribute({ el: el, key: key, maskAttributes: maskAttributes, maskAllText: maskAllText, privacyOptions: privacyOptions, value: value }) {
    // We only mask attributes if `maskAllText` is true
    if (!maskAllText) return value;
    // unmaskTextSelector takes precendence
    if (privacyOptions.unmaskTextSelector && el.matches(privacyOptions.unmaskTextSelector)) return value;
    if (maskAttributes.includes(key) || // Need to mask `value` attribute for `<input>` if it's a button-like
    // type
    key === "value" && el.tagName === "INPUT" && [
        "submit",
        "button"
    ].includes(el.getAttribute("type") || "")) return value.replace(/[\S]/g, "*");
    return value;
}
const $9d5f51142a9a79a0$var$MEDIA_SELECTORS = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';
const $9d5f51142a9a79a0$var$DEFAULT_NETWORK_HEADERS = [
    "content-length",
    "content-type",
    "accept"
];
let $9d5f51142a9a79a0$var$_initialized = false;
const $9d5f51142a9a79a0$export$2832a2ae028f5e28 = (options)=>{
    // eslint-disable-next-line deprecation/deprecation
    return new $9d5f51142a9a79a0$export$6b59b88de1ff9cb7(options);
};
/**
 * The main replay integration class, to be passed to `init({  integrations: [] })`.
 * @deprecated Use `replayIntegration()` instead.
 */ class $9d5f51142a9a79a0$export$6b59b88de1ff9cb7 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Replay";
    }
    /**
   * @inheritDoc
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Initial options passed to the replay integration, merged with default values.
   * Note: `sessionSampleRate` and `errorSampleRate` are not required here, as they
   * can only be finally set when setupOnce() is called.
   *
   * @private
   */ constructor({ flushMinDelay: flushMinDelay = $9d5f51142a9a79a0$var$DEFAULT_FLUSH_MIN_DELAY, flushMaxDelay: flushMaxDelay = $9d5f51142a9a79a0$var$DEFAULT_FLUSH_MAX_DELAY, minReplayDuration: minReplayDuration = $9d5f51142a9a79a0$var$MIN_REPLAY_DURATION, maxReplayDuration: maxReplayDuration = $9d5f51142a9a79a0$var$MAX_REPLAY_DURATION, stickySession: stickySession = true, useCompression: useCompression = true, workerUrl: workerUrl, _experiments: _experiments = {}, sessionSampleRate: sessionSampleRate, errorSampleRate: errorSampleRate, maskAllText: maskAllText = true, maskAllInputs: maskAllInputs = true, blockAllMedia: blockAllMedia = true, mutationBreadcrumbLimit: mutationBreadcrumbLimit = 750, mutationLimit: mutationLimit = 10000, slowClickTimeout: slowClickTimeout = 7000, slowClickIgnoreSelectors: slowClickIgnoreSelectors = [], networkDetailAllowUrls: networkDetailAllowUrls = [], networkDetailDenyUrls: networkDetailDenyUrls = [], networkCaptureBodies: networkCaptureBodies = true, networkRequestHeaders: networkRequestHeaders = [], networkResponseHeaders: networkResponseHeaders = [], mask: mask = [], maskAttributes: maskAttributes = [
        "title",
        "placeholder"
    ], unmask: unmask = [], block: block = [], unblock: unblock = [], ignore: ignore = [], maskFn: maskFn, beforeAddRecordingEvent: beforeAddRecordingEvent, beforeErrorSampling: beforeErrorSampling, blockClass: // eslint-disable-next-line deprecation/deprecation
    blockClass, blockSelector: // eslint-disable-next-line deprecation/deprecation
    blockSelector, maskInputOptions: // eslint-disable-next-line deprecation/deprecation
    maskInputOptions, maskTextClass: // eslint-disable-next-line deprecation/deprecation
    maskTextClass, maskTextSelector: // eslint-disable-next-line deprecation/deprecation
    maskTextSelector, ignoreClass: // eslint-disable-next-line deprecation/deprecation
    ignoreClass } = {}){
        // eslint-disable-next-line deprecation/deprecation
        this.name = $9d5f51142a9a79a0$export$6b59b88de1ff9cb7.id;
        const privacyOptions = $9d5f51142a9a79a0$var$getPrivacyOptions({
            mask: mask,
            unmask: unmask,
            block: block,
            unblock: unblock,
            ignore: ignore,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            ignoreClass: ignoreClass
        });
        this._recordingOptions = {
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            maskInputOptions: {
                ...maskInputOptions || {},
                password: true
            },
            maskTextFn: maskFn,
            maskInputFn: maskFn,
            maskAttributeFn: (key, value, el)=>$9d5f51142a9a79a0$var$maskAttribute({
                    maskAttributes: maskAttributes,
                    maskAllText: maskAllText,
                    privacyOptions: privacyOptions,
                    key: key,
                    value: value,
                    el: el
                }),
            ...privacyOptions,
            // Our defaults
            slimDOMOptions: "all",
            inlineStylesheet: true,
            // Disable inline images as it will increase segment/replay size
            inlineImages: false,
            // collect fonts, but be aware that `sentry.io` needs to be an allowed
            // origin for playback
            collectFonts: true,
            errorHandler: (err)=>{
                try {
                    err.__rrweb__ = true;
                } catch (error) {
                // ignore errors here
                // this can happen if the error is frozen or does not allow mutation for other reasons
                }
            }
        };
        this._initialOptions = {
            flushMinDelay: flushMinDelay,
            flushMaxDelay: flushMaxDelay,
            minReplayDuration: Math.min(minReplayDuration, $9d5f51142a9a79a0$var$MIN_REPLAY_DURATION_LIMIT),
            maxReplayDuration: Math.min(maxReplayDuration, $9d5f51142a9a79a0$var$MAX_REPLAY_DURATION),
            stickySession: stickySession,
            sessionSampleRate: sessionSampleRate,
            errorSampleRate: errorSampleRate,
            useCompression: useCompression,
            workerUrl: workerUrl,
            blockAllMedia: blockAllMedia,
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            mutationBreadcrumbLimit: mutationBreadcrumbLimit,
            mutationLimit: mutationLimit,
            slowClickTimeout: slowClickTimeout,
            slowClickIgnoreSelectors: slowClickIgnoreSelectors,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: $9d5f51142a9a79a0$var$_getMergedNetworkHeaders(networkRequestHeaders),
            networkResponseHeaders: $9d5f51142a9a79a0$var$_getMergedNetworkHeaders(networkResponseHeaders),
            beforeAddRecordingEvent: beforeAddRecordingEvent,
            beforeErrorSampling: beforeErrorSampling,
            _experiments: _experiments
        };
        if (typeof sessionSampleRate === "number") {
            // eslint-disable-next-line
            console.warn(`[Replay] You are passing \`sessionSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysSessionSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysSessionSampleRate: ${sessionSampleRate} })`);
            this._initialOptions.sessionSampleRate = sessionSampleRate;
        }
        if (typeof errorSampleRate === "number") {
            // eslint-disable-next-line
            console.warn(`[Replay] You are passing \`errorSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysOnErrorSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysOnErrorSampleRate: ${errorSampleRate} })`);
            this._initialOptions.errorSampleRate = errorSampleRate;
        }
        if (this._initialOptions.blockAllMedia) // `blockAllMedia` is a more user friendly option to configure blocking
        // embedded media elements
        this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector ? $9d5f51142a9a79a0$var$MEDIA_SELECTORS : `${this._recordingOptions.blockSelector},${$9d5f51142a9a79a0$var$MEDIA_SELECTORS}`;
        if (this._isInitialized && (0, $lbaFw.isBrowser)()) throw new Error("Multiple Sentry Session Replay instances are not supported");
        this._isInitialized = true;
    }
    /** If replay has already been initialized */ get _isInitialized() {
        return $9d5f51142a9a79a0$var$_initialized;
    }
    /** Update _isInitialized */ set _isInitialized(value) {
        $9d5f51142a9a79a0$var$_initialized = value;
    }
    /**
   * Setup and initialize replay container
   */ setupOnce() {
        if (!(0, $lbaFw.isBrowser)()) return;
        this._setup();
        // Once upon a time, we tried to create a transaction in `setupOnce` and it would
        // potentially create a transaction before some native SDK integrations have run
        // and applied their own global event processor. An example is:
        // https://github.com/getsentry/sentry-javascript/blob/b47ceafbdac7f8b99093ce6023726ad4687edc48/packages/browser/src/integrations/useragent.ts
        //
        // So we call `this._initialize()` in next event loop as a workaround to wait for other
        // global event processors to finish. This is no longer needed, but keeping it
        // here to avoid any future issues.
        setTimeout(()=>this._initialize());
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (!this._replay) return;
        this._replay.start();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */ startBuffering() {
        if (!this._replay) return;
        this._replay.startBuffering();
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ stop() {
        if (!this._replay) return Promise.resolve();
        return this._replay.stop({
            forceFlush: this._replay.recordingMode === "session"
        });
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ flush(options) {
        if (!this._replay || !this._replay.isEnabled()) return Promise.resolve();
        return this._replay.sendBufferedReplayOrFlush(options);
    }
    /**
   * Get the current session ID.
   */ getReplayId() {
        if (!this._replay || !this._replay.isEnabled()) return;
        return this._replay.getSessionId();
    }
    /**
   * Initializes replay.
   */ _initialize() {
        if (!this._replay) return;
        // We have to run this in _initialize, because this runs in setTimeout
        // So when this runs all integrations have been added
        // Before this, we cannot access integrations on the client,
        // so we need to mutate the options here
        this._maybeLoadFromReplayCanvasIntegration();
        this._replay.initializeSampling();
    }
    /** Setup the integration. */ _setup() {
        // Client is not available in constructor, so we need to wait until setupOnce
        const finalOptions = $9d5f51142a9a79a0$var$loadReplayOptionsFromClient(this._initialOptions);
        this._replay = new $9d5f51142a9a79a0$var$ReplayContainer({
            options: finalOptions,
            recordingOptions: this._recordingOptions
        });
    }
    /** Get canvas options from ReplayCanvas integration, if it is also added. */ _maybeLoadFromReplayCanvasIntegration() {
        // To save bundle size, we skip checking for stuff here
        // and instead just try-catch everything - as generally this should all be defined
        /* eslint-disable @typescript-eslint/no-non-null-assertion */ try {
            const client = (0, $iKbxs.getClient)();
            const canvasIntegration = client.getIntegrationByName("ReplayCanvas");
            if (!canvasIntegration) return;
            this._replay["_canvas"] = canvasIntegration.getOptions();
        } catch (e) {
        // ignore errors here
        }
    /* eslint-enable @typescript-eslint/no-non-null-assertion */ }
}
$9d5f51142a9a79a0$export$6b59b88de1ff9cb7.__initStatic();
/** Parse Replay-related options from SDK options */ function $9d5f51142a9a79a0$var$loadReplayOptionsFromClient(initialOptions) {
    const client = (0, $iKbxs.getClient)();
    const opt = client && client.getOptions();
    const finalOptions = {
        sessionSampleRate: 0,
        errorSampleRate: 0,
        ...(0, $8WMel.dropUndefinedKeys)(initialOptions)
    };
    if (!opt) {
        (0, $7Dams.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn("SDK client is not available.");
        });
        return finalOptions;
    }
    if (initialOptions.sessionSampleRate == null && // TODO remove once deprecated rates are removed
    initialOptions.errorSampleRate == null && // TODO remove once deprecated rates are removed
    opt.replaysSessionSampleRate == null && opt.replaysOnErrorSampleRate == null) (0, $7Dams.consoleSandbox)(()=>{
        // eslint-disable-next-line no-console
        console.warn("Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.");
    });
    if (typeof opt.replaysSessionSampleRate === "number") finalOptions.sessionSampleRate = opt.replaysSessionSampleRate;
    if (typeof opt.replaysOnErrorSampleRate === "number") finalOptions.errorSampleRate = opt.replaysOnErrorSampleRate;
    return finalOptions;
}
function $9d5f51142a9a79a0$var$_getMergedNetworkHeaders(headers) {
    return [
        ...$9d5f51142a9a79a0$var$DEFAULT_NETWORK_HEADERS,
        ...headers.map((header)=>header.toLowerCase())
    ];
}
/**
 * This is a small utility to get a type-safe instance of the Replay integration.
 */ // eslint-disable-next-line deprecation/deprecation
function $9d5f51142a9a79a0$export$81cc0d0f72285d1() {
    const client = (0, $iKbxs.getClient)();
    return client && client.getIntegrationByName && client.getIntegrationByName("Replay");
}
// eslint-disable-next-line deprecation/deprecation
/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */ const $9d5f51142a9a79a0$export$b28310b2f161456b = $9d5f51142a9a79a0$export$81cc0d0f72285d1;
/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */ const $9d5f51142a9a79a0$export$d7706faf7ab354bf = $9d5f51142a9a79a0$export$2832a2ae028f5e28;
/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */ // eslint-disable-next-line deprecation/deprecation
class $9d5f51142a9a79a0$export$a35c789ed37ee0f7 extends $9d5f51142a9a79a0$export$6b59b88de1ff9cb7 {
}

});
parcelRegister("a5Gjy", function(module, exports) {

$parcel$export(module.exports, "_nullishCoalesce", function () { return $758b31c4c23c8f54$export$8db64e83cc1a933c; });
// https://github.com/alangpierce/sucrase/tree/265887868966917f3b924ce38dfad01fbab1329f
//
// The MIT License (MIT)
//
// Copyright (c) 2012-2018 various contributors (see AUTHORS)
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
/**
 * Polyfill for the nullish coalescing operator (`??`).
 *
 * Note that the RHS is wrapped in a function so that if it's a computed value, that evaluation won't happen unless the
 * LHS evaluates to a nullish value, to mimic the operator's short-circuiting behavior.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 *
 * @param lhs The value of the expression to the left of the `??`
 * @param rhsFn A function returning the value of the expression to the right of the `??`
 * @returns The LHS value, unless it's `null` or `undefined`, in which case, the RHS value
 */ function $758b31c4c23c8f54$export$8db64e83cc1a933c(lhs, rhsFn) {
    // by checking for loose equality to `null`, we catch both `null` and `undefined`
    return lhs != null ? lhs : rhsFn();
}

});

parcelRegister("avffj", function(module, exports) {

$parcel$export(module.exports, "_optionalChain", function () { return $7a58a0285000efc4$export$3cc482e6b02f32f7; });
/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */ function $7a58a0285000efc4$export$3cc482e6b02f32f7(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        // by checking for loose equality to `null`, we catch both `null` and `undefined`
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
        return;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}

});

parcelRegister("lbaFw", function(module, exports) {

$parcel$export(module.exports, "isBrowser", function () { return $f6b2e69d43dc6e1b$export$4e09c449d6c407f7; });

var $cjM2a = parcelRequire("cjM2a");

var $ehoTA = parcelRequire("ehoTA");
/**
 * Returns true if we are in the browser.
 */ function $f6b2e69d43dc6e1b$export$4e09c449d6c407f7() {
    // eslint-disable-next-line no-restricted-globals
    return typeof window !== "undefined" && (!(0, $cjM2a.isNodeEnv)() || $f6b2e69d43dc6e1b$var$isElectronNodeRenderer());
}
// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function $f6b2e69d43dc6e1b$var$isElectronNodeRenderer() {
    return(// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
    (0, $ehoTA.GLOBAL_OBJ).process !== undefined && (0, $ehoTA.GLOBAL_OBJ).process.type === "renderer");
}

});

parcelRegister("8ZS5a", function(module, exports) {

$parcel$export(module.exports, "isSentryRequestUrl", function () { return $68cdf8d6b345c68c$export$d92e61f5600202af; });
/**
 * Checks whether given url points to Sentry server
 * @param url url to verify
 *
 * TODO(v8): Remove Hub fallback type
 */ // eslint-disable-next-line deprecation/deprecation
function $68cdf8d6b345c68c$export$d92e61f5600202af(url, hubOrClient) {
    const client = hubOrClient && $68cdf8d6b345c68c$var$isHub(hubOrClient) ? hubOrClient.getClient() : hubOrClient;
    const dsn = client && client.getDsn();
    const tunnel = client && client.getOptions().tunnel;
    return $68cdf8d6b345c68c$var$checkDsn(url, dsn) || $68cdf8d6b345c68c$var$checkTunnel(url, tunnel);
}
function $68cdf8d6b345c68c$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $68cdf8d6b345c68c$var$removeTrailingSlash(url) === $68cdf8d6b345c68c$var$removeTrailingSlash(tunnel);
}
function $68cdf8d6b345c68c$var$checkDsn(url, dsn) {
    return dsn ? url.includes(dsn.host) : false;
}
function $68cdf8d6b345c68c$var$removeTrailingSlash(str) {
    return str[str.length - 1] === "/" ? str.slice(0, -1) : str;
}
// eslint-disable-next-line deprecation/deprecation
function $68cdf8d6b345c68c$var$isHub(hubOrClient) {
    // eslint-disable-next-line deprecation/deprecation
    return hubOrClient.getClient !== undefined;
}

});


parcelRegister("eSb8L", function(module, exports) {

$parcel$export(module.exports, "withProfiler", function () { return $ad3ec018c830d278$export$e1e354213dd1a8a7; });

var $egrOp = parcelRequire("egrOp");

var $IueXx = parcelRequire("IueXx");
var $iKbxs = parcelRequire("iKbxs");

var $bA8KD = parcelRequire("bA8KD");

var $3RaBm = parcelRequire("3RaBm");

var $jbmdS = parcelRequire("jbmdS");

var $xbd7b = parcelRequire("xbd7b");
const $ad3ec018c830d278$var$_jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/profiler.tsx";
const $ad3ec018c830d278$export$6ef4c0367e27f2d5 = "unknown";
/**
 * The Profiler component leverages Sentry's Tracing integration to generate
 * spans based on component lifecycles.
 */ class $ad3ec018c830d278$export$e2c29f18771995cb extends $jbmdS.Component {
    /**
   * The span of the mount activity
   * Made protected for the React Native SDK to access
   */ /**
   * The span that represents the duration of time between shouldComponentUpdate and componentDidUpdate
   */ // eslint-disable-next-line @typescript-eslint/member-ordering
    static __initStatic() {
        this.defaultProps = {
            disabled: false,
            includeRender: true,
            includeUpdates: true
        };
    }
    constructor(props){
        super(props);
        const { name: name, disabled: disabled = false } = this.props;
        if (disabled) return;
        this._mountSpan = (0, $egrOp.startInactiveSpan)({
            name: `<${name}>`,
            onlyIfParent: true,
            op: (0, $xbd7b.REACT_MOUNT_OP),
            origin: "auto.ui.react.profiler",
            attributes: {
                "ui.component_name": name
            }
        });
    }
    // If a component mounted, we can finish the mount activity.
    componentDidMount() {
        if (this._mountSpan) this._mountSpan.end();
    }
    shouldComponentUpdate({ updateProps: updateProps, includeUpdates: includeUpdates = true }) {
        // Only generate an update span if includeUpdates is true, if there is a valid mountSpan,
        // and if the updateProps have changed. It is ok to not do a deep equality check here as it is expensive.
        // We are just trying to give baseline clues for further investigation.
        if (includeUpdates && this._mountSpan && updateProps !== this.props.updateProps) {
            // See what props haved changed between the previous props, and the current props. This is
            // set as data on the span. We just store the prop keys as the values could be potenially very large.
            const changedProps = Object.keys(updateProps).filter((k)=>updateProps[k] !== this.props.updateProps[k]);
            if (changedProps.length > 0) {
                const now = (0, $bA8KD.timestampInSeconds)();
                this._updateSpan = (0, $iKbxs.withActiveSpan)(this._mountSpan, ()=>{
                    return (0, $egrOp.startInactiveSpan)({
                        name: `<${this.props.name}>`,
                        onlyIfParent: true,
                        op: (0, $xbd7b.REACT_UPDATE_OP),
                        origin: "auto.ui.react.profiler",
                        startTimestamp: now,
                        attributes: {
                            "ui.component_name": this.props.name,
                            "ui.react.changed_props": changedProps
                        }
                    });
                });
            }
        }
        return true;
    }
    componentDidUpdate() {
        if (this._updateSpan) {
            this._updateSpan.end();
            this._updateSpan = undefined;
        }
    }
    // If a component is unmounted, we can say it is no longer on the screen.
    // This means we can finish the span representing the component render.
    componentWillUnmount() {
        const endTimestamp = (0, $bA8KD.timestampInSeconds)();
        const { name: name, includeRender: includeRender = true } = this.props;
        if (this._mountSpan && includeRender) {
            const startTimestamp = (0, $IueXx.spanToJSON)(this._mountSpan).timestamp;
            (0, $iKbxs.withActiveSpan)(this._mountSpan, ()=>{
                const renderSpan = (0, $egrOp.startInactiveSpan)({
                    onlyIfParent: true,
                    name: `<${name}>`,
                    op: (0, $xbd7b.REACT_RENDER_OP),
                    origin: "auto.ui.react.profiler",
                    startTimestamp: startTimestamp,
                    attributes: {
                        "ui.component_name": name
                    }
                });
                if (renderSpan) // Have to cast to Span because the type of _mountSpan is Span | undefined
                // and not getting narrowed properly
                renderSpan.end(endTimestamp);
            });
        }
    }
    render() {
        return this.props.children;
    }
}
$ad3ec018c830d278$export$e2c29f18771995cb.__initStatic();
/**
 * withProfiler is a higher order component that wraps a
 * component in a {@link Profiler} component. It is recommended that
 * the higher order component be used over the regular {@link Profiler} component.
 *
 * @param WrappedComponent component that is wrapped by Profiler
 * @param options the {@link ProfilerProps} you can pass into the Profiler
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ad3ec018c830d278$export$e1e354213dd1a8a7(WrappedComponent, // We do not want to have `updateProps` given in options, it is instead filled through the HOC.
options) {
    const componentDisplayName = options && options.name || WrappedComponent.displayName || WrappedComponent.name || $ad3ec018c830d278$export$6ef4c0367e27f2d5;
    const Wrapped = (props)=>$jbmdS.createElement($ad3ec018c830d278$export$e2c29f18771995cb, {
            ...options,
            name: componentDisplayName,
            updateProps: props,
            __self: this,
            __source: {
                fileName: $ad3ec018c830d278$var$_jsxFileName,
                lineNumber: 159
            }
        }, $jbmdS.createElement(WrappedComponent, {
            ...props,
            __self: this,
            __source: {
                fileName: $ad3ec018c830d278$var$_jsxFileName,
                lineNumber: 160
            }
        }));
    Wrapped.displayName = `profiler(${componentDisplayName})`;
    // Copy over static methods from Wrapped component to Profiler HOC
    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
    (0, (/*@__PURE__*/$parcel$interopDefault($3RaBm)))(Wrapped, WrappedComponent);
    return Wrapped;
}
/**
 *
 * `useProfiler` is a React hook that profiles a React component.
 *
 * Requires React 16.8 or above.
 * @param name displayName of component being profiled
 */ function $ad3ec018c830d278$export$972a52cbfaf8cf13(name, options = {
    disabled: false,
    hasRenderSpan: true
}) {
    const [mountSpan] = $jbmdS.useState(()=>{
        if (options && options.disabled) return undefined;
        return (0, $egrOp.startInactiveSpan)({
            name: `<${name}>`,
            onlyIfParent: true,
            op: (0, $xbd7b.REACT_MOUNT_OP),
            origin: "auto.ui.react.profiler",
            attributes: {
                "ui.component_name": name
            }
        });
    });
    $jbmdS.useEffect(()=>{
        if (mountSpan) mountSpan.end();
        return ()=>{
            if (mountSpan && options.hasRenderSpan) {
                const startTimestamp = (0, $IueXx.spanToJSON)(mountSpan).timestamp;
                const endTimestamp = (0, $bA8KD.timestampInSeconds)();
                const renderSpan = (0, $egrOp.startInactiveSpan)({
                    name: `<${name}>`,
                    onlyIfParent: true,
                    op: (0, $xbd7b.REACT_RENDER_OP),
                    origin: "auto.ui.react.profiler",
                    startTimestamp: startTimestamp,
                    attributes: {
                        "ui.component_name": name
                    }
                });
                if (renderSpan) // Have to cast to Span because the type of _mountSpan is Span | undefined
                // and not getting narrowed properly
                renderSpan.end(endTimestamp);
            }
        };
    // We only want this to run once.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

});
parcelRegister("xbd7b", function(module, exports) {

$parcel$export(module.exports, "REACT_RENDER_OP", function () { return $063bc75c088634ec$export$a5a94ea2f791dca1; });
$parcel$export(module.exports, "REACT_UPDATE_OP", function () { return $063bc75c088634ec$export$ee0f1075b9437852; });
$parcel$export(module.exports, "REACT_MOUNT_OP", function () { return $063bc75c088634ec$export$2c5aa1bf688e9ea1; });
const $063bc75c088634ec$export$a5a94ea2f791dca1 = "ui.react.render";
const $063bc75c088634ec$export$ee0f1075b9437852 = "ui.react.update";
const $063bc75c088634ec$export$2c5aa1bf688e9ea1 = "ui.react.mount";

});


parcelRegister("asW9w", function(module, exports) {

$parcel$export(module.exports, "PostHogProvider", function () { return $79e9a0ccabdaf866$export$4d1dc63dbef5194f; });

var $3H03w = parcelRequire("3H03w");

var $jbmdS = parcelRequire("jbmdS");
var $79e9a0ccabdaf866$export$ef76d7336c7309f5 = (0, $jbmdS.createContext)({
    client: (0, $3H03w.default)
});
function $79e9a0ccabdaf866$var$isDeepEqual(obj1, obj2, visited) {
    if (visited === void 0) visited = new WeakMap();
    if (obj1 === obj2) return true;
    if (typeof obj1 !== "object" || obj1 === null || typeof obj2 !== "object" || obj2 === null) return false;
    if (visited.has(obj1) && visited.get(obj1) === obj2) return true;
    visited.set(obj1, obj2);
    var keys1 = Object.keys(obj1);
    var keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) return false;
    for(var _i = 0, keys1_1 = keys1; _i < keys1_1.length; _i++){
        var key = keys1_1[_i];
        if (!keys2.includes(key)) return false;
        if (!$79e9a0ccabdaf866$var$isDeepEqual(obj1[key], obj2[key], visited)) return false;
    }
    return true;
}
function $79e9a0ccabdaf866$export$4d1dc63dbef5194f(_a) {
    var children = _a.children, client = _a.client, apiKey = _a.apiKey, options = _a.options;
    var previousInitializationRef = (0, $jbmdS.useRef)(null);
    var posthog = (0, $jbmdS.useMemo)(function() {
        if (client) {
            if (apiKey) console.warn("[PostHog.js] You have provided both `client` and `apiKey` to `PostHogProvider`. `apiKey` will be ignored in favour of `client`.");
            if (options) console.warn("[PostHog.js] You have provided both `client` and `options` to `PostHogProvider`. `options` will be ignored in favour of `client`.");
            return client;
        }
        if (apiKey) return 0, $3H03w.default;
        console.warn("[PostHog.js] No `apiKey` or `client` were provided to `PostHogProvider`. Using default global `window.posthog` instance. You must initialize it manually. This is not recommended behavior.");
        return 0, $3H03w.default;
    }, [
        client,
        apiKey,
        JSON.stringify(options)
    ]);
    (0, $jbmdS.useEffect)(function() {
        if (client) return;
        var previousInitialization = previousInitializationRef.current;
        if (!previousInitialization) {
            if ((0, $3H03w.default).__loaded) console.warn("[PostHog.js] `posthog` was already loaded elsewhere. This may cause issues.");
            (0, $3H03w.default).init(apiKey, options);
            previousInitializationRef.current = {
                apiKey: apiKey,
                options: options !== null && options !== void 0 ? options : {}
            };
        } else {
            if (apiKey !== previousInitialization.apiKey) console.warn("[PostHog.js] You have provided a different `apiKey` to `PostHogProvider` than the one that was already initialized. This is not supported by our provider and we'll keep using the previous key. If you need to toggle between API Keys you need to control the `client` yourself and pass it in as a prop rather than an `apiKey` prop.");
            if (options && !$79e9a0ccabdaf866$var$isDeepEqual(options, previousInitialization.options)) (0, $3H03w.default).set_config(options);
            previousInitializationRef.current = {
                apiKey: apiKey,
                options: options !== null && options !== void 0 ? options : {}
            };
        }
    }, [
        client,
        apiKey,
        JSON.stringify(options)
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($79e9a0ccabdaf866$export$ef76d7336c7309f5.Provider, {
        value: {
            client: posthog
        }
    }, children);
}
var $79e9a0ccabdaf866$export$ba1c575d7c165008 = function() {
    var client = (0, $jbmdS.useContext)($79e9a0ccabdaf866$export$ef76d7336c7309f5).client;
    return client;
};
function $79e9a0ccabdaf866$export$e9beec7734875ebd(flag) {
    var client = $79e9a0ccabdaf866$export$ba1c575d7c165008();
    var _a = (0, $jbmdS.useState)(function() {
        return client.isFeatureEnabled(flag);
    }), featureEnabled = _a[0], setFeatureEnabled = _a[1];
    (0, $jbmdS.useEffect)(function() {
        return client.onFeatureFlags(function() {
            setFeatureEnabled(client.isFeatureEnabled(flag));
        });
    }, [
        client,
        flag
    ]);
    return featureEnabled;
}
function $79e9a0ccabdaf866$export$21b3a717c06e8b6d(flag) {
    var client = $79e9a0ccabdaf866$export$ba1c575d7c165008();
    var _a = (0, $jbmdS.useState)(function() {
        return client.getFeatureFlagPayload(flag);
    }), featureFlagPayload = _a[0], setFeatureFlagPayload = _a[1];
    (0, $jbmdS.useEffect)(function() {
        return client.onFeatureFlags(function() {
            setFeatureFlagPayload(client.getFeatureFlagPayload(flag));
        });
    }, [
        client,
        flag
    ]);
    return featureFlagPayload;
}
function $79e9a0ccabdaf866$export$31a96876dff98722() {
    var client = $79e9a0ccabdaf866$export$ba1c575d7c165008();
    var _a = (0, $jbmdS.useState)(function() {
        return client.featureFlags.getFlags();
    }), featureFlags = _a[0], setFeatureFlags = _a[1];
    (0, $jbmdS.useEffect)(function() {
        return client.onFeatureFlags(function(flags) {
            setFeatureFlags(flags);
        });
    }, [
        client
    ]);
    return featureFlags;
}
function $79e9a0ccabdaf866$export$446efd8c49462bdd(flag) {
    var client = $79e9a0ccabdaf866$export$ba1c575d7c165008();
    var _a = (0, $jbmdS.useState)(function() {
        return client.getFeatureFlag(flag);
    }), featureFlagVariantKey = _a[0], setFeatureFlagVariantKey = _a[1];
    (0, $jbmdS.useEffect)(function() {
        return client.onFeatureFlags(function() {
            setFeatureFlagVariantKey(client.getFeatureFlag(flag));
        });
    }, [
        client,
        flag
    ]);
    return featureFlagVariantKey;
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $79e9a0ccabdaf866$var$extendStatics = function(d, b) {
    $79e9a0ccabdaf866$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $79e9a0ccabdaf866$var$extendStatics(d, b);
};
function $79e9a0ccabdaf866$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $79e9a0ccabdaf866$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $79e9a0ccabdaf866$var$__assign = function() {
    $79e9a0ccabdaf866$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $79e9a0ccabdaf866$var$__assign.apply(this, arguments);
};
function $79e9a0ccabdaf866$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var $79e9a0ccabdaf866$var$isFunction = function(f) {
    return typeof f === "function";
};
var $79e9a0ccabdaf866$var$isUndefined = function(x) {
    return x === void 0;
};
var $79e9a0ccabdaf866$var$isNull = function(x) {
    return x === null;
};
function $79e9a0ccabdaf866$export$3d3d20183fb62861(_a) {
    var flag = _a.flag, match = _a.match, children = _a.children, fallback = _a.fallback, visibilityObserverOptions = _a.visibilityObserverOptions, trackInteraction = _a.trackInteraction, trackView = _a.trackView, props = $79e9a0ccabdaf866$var$__rest(_a, [
        "flag",
        "match",
        "children",
        "fallback",
        "visibilityObserverOptions",
        "trackInteraction",
        "trackView"
    ]);
    var payload = $79e9a0ccabdaf866$export$21b3a717c06e8b6d(flag);
    var variant = $79e9a0ccabdaf866$export$446efd8c49462bdd(flag);
    var shouldTrackInteraction = trackInteraction !== null && trackInteraction !== void 0 ? trackInteraction : true;
    var shouldTrackView = trackView !== null && trackView !== void 0 ? trackView : true;
    if ($79e9a0ccabdaf866$var$isUndefined(match) || variant === match) {
        var childNode = $79e9a0ccabdaf866$var$isFunction(children) ? children(payload) : children;
        return (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($79e9a0ccabdaf866$var$VisibilityAndClickTrackers, $79e9a0ccabdaf866$var$__assign({
            flag: flag,
            options: visibilityObserverOptions,
            trackInteraction: shouldTrackInteraction,
            trackView: shouldTrackView
        }, props), childNode);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).Fragment, null, fallback);
}
function $79e9a0ccabdaf866$var$captureFeatureInteraction(_a) {
    var _b;
    var flag = _a.flag, posthog = _a.posthog, flagVariant = _a.flagVariant;
    var properties = {
        feature_flag: flag,
        $set: (_b = {}, _b["$feature_interaction/".concat(flag)] = flagVariant !== null && flagVariant !== void 0 ? flagVariant : true, _b)
    };
    if (typeof flagVariant === "string") properties.feature_flag_variant = flagVariant;
    posthog.capture("$feature_interaction", properties);
}
function $79e9a0ccabdaf866$var$captureFeatureView(_a) {
    var _b;
    var flag = _a.flag, posthog = _a.posthog, flagVariant = _a.flagVariant;
    var properties = {
        feature_flag: flag,
        $set: (_b = {}, _b["$feature_view/".concat(flag)] = flagVariant !== null && flagVariant !== void 0 ? flagVariant : true, _b)
    };
    if (typeof flagVariant === "string") properties.feature_flag_variant = flagVariant;
    posthog.capture("$feature_view", properties);
}
function $79e9a0ccabdaf866$var$VisibilityAndClickTracker(_a) {
    var flag = _a.flag, children = _a.children, onIntersect = _a.onIntersect, onClick = _a.onClick, trackView = _a.trackView, options = _a.options, props = $79e9a0ccabdaf866$var$__rest(_a, [
        "flag",
        "children",
        "onIntersect",
        "onClick",
        "trackView",
        "options"
    ]);
    var ref = (0, $jbmdS.useRef)(null);
    var posthog = $79e9a0ccabdaf866$export$ba1c575d7c165008();
    (0, $jbmdS.useEffect)(function() {
        if ($79e9a0ccabdaf866$var$isNull(ref.current) || !trackView) return;
        var observer = new IntersectionObserver(function(_a) {
            var entry = _a[0];
            return onIntersect(entry);
        }, $79e9a0ccabdaf866$var$__assign({
            threshold: 0.1
        }, options));
        observer.observe(ref.current);
        return function() {
            return observer.disconnect();
        };
    }, [
        flag,
        options,
        posthog,
        ref,
        trackView,
        onIntersect
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("div", $79e9a0ccabdaf866$var$__assign({
        ref: ref
    }, props, {
        onClick: onClick
    }), children);
}
function $79e9a0ccabdaf866$var$VisibilityAndClickTrackers(_a) {
    var flag = _a.flag, children = _a.children, trackInteraction = _a.trackInteraction, trackView = _a.trackView, options = _a.options, props = $79e9a0ccabdaf866$var$__rest(_a, [
        "flag",
        "children",
        "trackInteraction",
        "trackView",
        "options"
    ]);
    var clickTrackedRef = (0, $jbmdS.useRef)(false);
    var visibilityTrackedRef = (0, $jbmdS.useRef)(false);
    var posthog = $79e9a0ccabdaf866$export$ba1c575d7c165008();
    var variant = $79e9a0ccabdaf866$export$446efd8c49462bdd(flag);
    var cachedOnClick = (0, $jbmdS.useCallback)(function() {
        if (!clickTrackedRef.current && trackInteraction) {
            $79e9a0ccabdaf866$var$captureFeatureInteraction({
                flag: flag,
                posthog: posthog,
                flagVariant: variant
            });
            clickTrackedRef.current = true;
        }
    }, [
        flag,
        posthog,
        trackInteraction,
        variant
    ]);
    var onIntersect = function(entry) {
        if (!visibilityTrackedRef.current && entry.isIntersecting) {
            $79e9a0ccabdaf866$var$captureFeatureView({
                flag: flag,
                posthog: posthog,
                flagVariant: variant
            });
            visibilityTrackedRef.current = true;
        }
    };
    var trackedChildren = (0, $jbmdS.Children).map(children, function(child) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($79e9a0ccabdaf866$var$VisibilityAndClickTracker, $79e9a0ccabdaf866$var$__assign({
            flag: flag,
            onClick: cachedOnClick,
            onIntersect: onIntersect,
            trackView: trackView,
            options: options
        }, props), child);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).Fragment, null, trackedChildren);
}
var $79e9a0ccabdaf866$var$INITIAL_STATE = {
    componentStack: null,
    error: null
};
var $79e9a0ccabdaf866$var$__POSTHOG_ERROR_MESSAGES = {
    INVALID_FALLBACK: "[PostHog.js][PostHogErrorBoundary] Invalid fallback prop, provide a valid React element or a function that returns a valid React element."
};
var $79e9a0ccabdaf866$export$2413edf479be8fff = function(_super) {
    $79e9a0ccabdaf866$var$__extends(PostHogErrorBoundary, _super);
    function PostHogErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = $79e9a0ccabdaf866$var$INITIAL_STATE;
        return _this;
    }
    PostHogErrorBoundary.prototype.componentDidCatch = function(error, errorInfo) {
        var componentStack = errorInfo.componentStack;
        var additionalProperties = this.props.additionalProperties;
        this.setState({
            error: error,
            componentStack: componentStack
        });
        var currentProperties;
        if ($79e9a0ccabdaf866$var$isFunction(additionalProperties)) currentProperties = additionalProperties(error);
        else if (typeof additionalProperties === "object") currentProperties = additionalProperties;
        var client = this.context.client;
        client.captureException(error, currentProperties);
    };
    PostHogErrorBoundary.prototype.render = function() {
        var _a = this.props, children = _a.children, fallback = _a.fallback;
        var state = this.state;
        if (state.componentStack == null) return $79e9a0ccabdaf866$var$isFunction(children) ? children() : children;
        var element = $79e9a0ccabdaf866$var$isFunction(fallback) ? (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement(fallback, {
            error: state.error,
            componentStack: state.componentStack
        }) : fallback;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).isValidElement(element)) return element;
        console.warn($79e9a0ccabdaf866$var$__POSTHOG_ERROR_MESSAGES.INVALID_FALLBACK);
        return (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).Fragment, null);
    };
    PostHogErrorBoundary.contextType = $79e9a0ccabdaf866$export$ef76d7336c7309f5;
    return PostHogErrorBoundary;
}((0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).Component);

});

parcelRegister("7t3ot", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0098a7dc3bdbffab$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");
const $0098a7dc3bdbffab$export$d4c72bab9d6cc13a = {
    hidden: document.hidden,
    visibilityState: document.visibilityState
};
const $0098a7dc3bdbffab$var$useVisible = ()=>{
    const [state, setState] = (0, $jbmdS.useState)($0098a7dc3bdbffab$export$d4c72bab9d6cc13a);
    const onVisibilityChangeEvent = (event)=>{
        setState({
            hidden: document.hidden,
            visibilityState: document.visibilityState
        });
    };
    (0, $jbmdS.useEffect)(()=>{
        document.addEventListener("visibilitychange", onVisibilityChangeEvent);
        return ()=>{
            document.removeEventListener("visibilitychange", onVisibilityChangeEvent);
        };
    }, []);
    return state;
};
var $0098a7dc3bdbffab$export$2e2bcd8739ae039 = $0098a7dc3bdbffab$var$useVisible;

});

parcelRegister("74u5y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52603f19b7753be9$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("02LyB");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $52603f19b7753be9$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(()=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "flex items-center justify-center text-center w-full h-full",
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("section", {
            className: "flex items-center justify-center flex-col",
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsxs)("header", {
                    className: "flex flex-col justify-center items-center",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            className: "logo2 s75 size-[10em] flex items-center justify-center",
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)("img", {
                                src: new URL((parcelRequire("hw9H4"))),
                                alt: "Coincraft Logo"
                            })
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)("h3", {
                            children: "Page Not Found"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    className: "body space-y-[1em] text-[13px] text-[#666] leading-5",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            children: "This page can't be found."
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            children: [
                                "If this is a mistake you can contact use via the chat or",
                                " ",
                                /*#__PURE__*/ (0, $61Ea1.jsx)("br", {}),
                                /*#__PURE__*/ (0, $61Ea1.jsx)("a", {
                                    href: "mailto:support@coincraft.co",
                                    className: "underline",
                                    children: "support@coincraft.co"
                                }),
                                "."
                            ]
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                    style: {
                                        display: "inline-block",
                                        marginRight: "1em"
                                    },
                                    children: /*#__PURE__*/ (0, $61Ea1.jsx)("a", {
                                        href: `/`,
                                        style: {
                                            textDecoration: "underline"
                                        },
                                        children: "Home"
                                    })
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                    style: {
                                        display: "inline-block"
                                    },
                                    children: /*#__PURE__*/ (0, $61Ea1.jsx)("a", {
                                        href: "/login",
                                        style: {
                                            textDecoration: "underline"
                                        },
                                        children: "Login"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
});

});
parcelRegister("02LyB", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("hw9H4", function(module, exports) {
module.exports = new URL("coincraft_logo_130.1b205a5d.png", import.meta.url).toString();

});


parcelRegister("dasFg", function(module, exports) {

$parcel$export(module.exports, "createRouter", function () { return $996271b4f79a4925$export$baddd0131ee8c05b; });

var $3c1h0 = parcelRequire("3c1h0");

var $9AyUq = parcelRequire("9AyUq");
var $9PfBl = parcelRequire("9PfBl");

var $9GFyS = parcelRequire("9GFyS");

var $2oA9E = parcelRequire("2oA9E");
var $bypHT = parcelRequire("bypHT");
var $a7sW4 = parcelRequire("a7sW4");
var $fleMh = parcelRequire("fleMh");
var $lxb5Z = parcelRequire("lxb5Z");

var $gbTjE = parcelRequire("gbTjE");

var $64Yjc = parcelRequire("64Yjc");

var $aSkHi = parcelRequire("aSkHi");
const $996271b4f79a4925$export$741158c5c07285bb = [
    "component",
    "errorComponent",
    "pendingComponent",
    "notFoundComponent"
];
function $996271b4f79a4925$var$routeNeedsPreload(route) {
    var _a;
    for (const componentType of $996271b4f79a4925$export$741158c5c07285bb){
        if ((_a = route.options[componentType]) == null ? void 0 : _a.preload) return true;
    }
    return false;
}
function $996271b4f79a4925$var$validateSearch(validateSearch2, input) {
    if (validateSearch2 == null) return {};
    if ("~standard" in validateSearch2) {
        const result = validateSearch2["~standard"].validate(input);
        if (result instanceof Promise) throw new $996271b4f79a4925$export$ca74fadaf06bf7e1("Async validation not supported");
        if (result.issues) throw new $996271b4f79a4925$export$ca74fadaf06bf7e1(JSON.stringify(result.issues, void 0, 2), {
            cause: result
        });
        return result.value;
    }
    if ("parse" in validateSearch2) return validateSearch2.parse(input);
    if (typeof validateSearch2 === "function") return validateSearch2(input);
    return {};
}
function $996271b4f79a4925$export$baddd0131ee8c05b(options) {
    return new $996271b4f79a4925$export$55185c17a0fcbe46(options);
}
class $996271b4f79a4925$export$55185c17a0fcbe46 {
    /**
   * @deprecated Use the `createRouter` function instead
   */ constructor(options){
        this.tempLocationKey = `${Math.round(Math.random() * 1e7)}`;
        this.resetNextScroll = true;
        this.shouldViewTransition = void 0;
        this.isViewTransitionTypesSupported = void 0;
        this.subscribers = /* @__PURE__ */ new Set();
        this.isScrollRestoring = false;
        this.isScrollRestorationSetup = false;
        this.startReactTransition = (fn)=>fn();
        this.update = (newOptions)=>{
            var _a;
            if (newOptions.notFoundRoute) console.warn("The notFoundRoute API is deprecated and will be removed in the next major version. See https://tanstack.com/router/v1/docs/framework/react/guide/not-found-errors#migrating-from-notfoundroute for more info.");
            const previousOptions = this.options;
            this.options = {
                ...this.options,
                ...newOptions
            };
            this.isServer = this.options.isServer ?? typeof document === "undefined";
            this.pathParamsDecodeCharMap = this.options.pathParamsAllowedCharacters ? new Map(this.options.pathParamsAllowedCharacters.map((char)=>[
                    encodeURIComponent(char),
                    char
                ])) : void 0;
            if (!this.basepath || newOptions.basepath && newOptions.basepath !== previousOptions.basepath) {
                if (newOptions.basepath === void 0 || newOptions.basepath === "" || newOptions.basepath === "/") this.basepath = "/";
                else this.basepath = `/${(0, $2oA9E.trimPath)(newOptions.basepath)}`;
            }
            if (// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            !this.history || this.options.history && this.options.history !== this.history) {
                this.history = this.options.history ?? (this.isServer ? (0, $3c1h0.createMemoryHistory)({
                    initialEntries: [
                        this.basepath || "/"
                    ]
                }) : (0, $3c1h0.createBrowserHistory)());
                this.latestLocation = this.parseLocation();
            }
            if (this.options.routeTree !== this.routeTree) {
                this.routeTree = this.options.routeTree;
                this.buildRouteTree();
            }
            if (!this.__store) {
                this.__store = new (0, $9PfBl.Store)($996271b4f79a4925$export$baa2404bdcb7f08c(this.latestLocation), {
                    onUpdate: ()=>{
                        this.__store.state = {
                            ...this.state,
                            cachedMatches: this.state.cachedMatches.filter((d)=>![
                                    "redirected"
                                ].includes(d.status))
                        };
                    }
                });
                (0, $aSkHi.setupScrollRestoration)(this);
            }
            if (typeof window !== "undefined" && "CSS" in window && // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            typeof ((_a = window.CSS) == null ? void 0 : _a.supports) === "function") this.isViewTransitionTypesSupported = window.CSS.supports("selector(:active-view-transition-type(a)");
        };
        this.buildRouteTree = ()=>{
            this.routesById = {};
            this.routesByPath = {};
            const notFoundRoute = this.options.notFoundRoute;
            if (notFoundRoute) {
                notFoundRoute.init({
                    originalIndex: 99999999999,
                    defaultSsr: this.options.defaultSsr
                });
                this.routesById[notFoundRoute.id] = notFoundRoute;
            }
            const recurseRoutes = (childRoutes)=>{
                childRoutes.forEach((childRoute, i)=>{
                    childRoute.init({
                        originalIndex: i,
                        defaultSsr: this.options.defaultSsr
                    });
                    const existingRoute = this.routesById[childRoute.id];
                    (0, $9GFyS.default)(!existingRoute, `Duplicate routes found with id: ${String(childRoute.id)}`);
                    this.routesById[childRoute.id] = childRoute;
                    if (!childRoute.isRoot && childRoute.path) {
                        const trimmedFullPath = (0, $2oA9E.trimPathRight)(childRoute.fullPath);
                        if (!this.routesByPath[trimmedFullPath] || childRoute.fullPath.endsWith("/")) this.routesByPath[trimmedFullPath] = childRoute;
                    }
                    const children = childRoute.children;
                    if (children == null ? void 0 : children.length) recurseRoutes(children);
                });
            };
            recurseRoutes([
                this.routeTree
            ]);
            const scoredRoutes = [];
            const routes = Object.values(this.routesById);
            routes.forEach((d, i)=>{
                var _a;
                if (d.isRoot || !d.path) return;
                const trimmed = (0, $2oA9E.trimPathLeft)(d.fullPath);
                const parsed = (0, $2oA9E.parsePathname)(trimmed);
                while(parsed.length > 1 && ((_a = parsed[0]) == null ? void 0 : _a.value) === "/")parsed.shift();
                const scores = parsed.map((segment)=>{
                    if (segment.value === "/") return 0.75;
                    if (segment.type === "param") return 0.5;
                    if (segment.type === "wildcard") return 0.25;
                    return 1;
                });
                scoredRoutes.push({
                    child: d,
                    trimmed: trimmed,
                    parsed: parsed,
                    index: i,
                    scores: scores
                });
            });
            this.flatRoutes = scoredRoutes.sort((a, b)=>{
                const minLength = Math.min(a.scores.length, b.scores.length);
                for(let i = 0; i < minLength; i++){
                    if (a.scores[i] !== b.scores[i]) return b.scores[i] - a.scores[i];
                }
                if (a.scores.length !== b.scores.length) return b.scores.length - a.scores.length;
                for(let i = 0; i < minLength; i++){
                    if (a.parsed[i].value !== b.parsed[i].value) return a.parsed[i].value > b.parsed[i].value ? 1 : -1;
                }
                return a.index - b.index;
            }).map((d, i)=>{
                d.child.rank = i;
                return d.child;
            });
        };
        this.subscribe = (eventType, fn)=>{
            const listener = {
                eventType: eventType,
                fn: fn
            };
            this.subscribers.add(listener);
            return ()=>{
                this.subscribers.delete(listener);
            };
        };
        this.emit = (routerEvent)=>{
            this.subscribers.forEach((listener)=>{
                if (listener.eventType === routerEvent.type) listener.fn(routerEvent);
            });
        };
        this.parseLocation = (previousLocation, locationToParse)=>{
            const parse = ({ pathname: pathname, search: search, hash: hash, state: state })=>{
                const parsedSearch = this.options.parseSearch(search);
                const searchStr = this.options.stringifySearch(parsedSearch);
                return {
                    pathname: pathname,
                    searchStr: searchStr,
                    search: (0, $bypHT.replaceEqualDeep)(previousLocation == null ? void 0 : previousLocation.search, parsedSearch),
                    hash: hash.split("#").reverse()[0] ?? "",
                    href: `${pathname}${searchStr}${hash}`,
                    state: (0, $bypHT.replaceEqualDeep)(previousLocation == null ? void 0 : previousLocation.state, state)
                };
            };
            const location = parse(locationToParse ?? this.history.location);
            const { __tempLocation: __tempLocation, __tempKey: __tempKey } = location.state;
            if (__tempLocation && (!__tempKey || __tempKey === this.tempLocationKey)) {
                const parsedTempLocation = parse(__tempLocation);
                parsedTempLocation.state.key = location.state.key;
                delete parsedTempLocation.state.__tempLocation;
                return {
                    ...parsedTempLocation,
                    maskedLocation: location
                };
            }
            return location;
        };
        this.resolvePathWithBase = (from, path)=>{
            const resolvedPath = (0, $2oA9E.resolvePath)({
                basepath: this.basepath,
                base: from,
                to: (0, $2oA9E.cleanPath)(path),
                trailingSlash: this.options.trailingSlash,
                caseSensitive: this.options.caseSensitive
            });
            return resolvedPath;
        };
        this.getMatchedRoutes = (next, dest)=>{
            let routeParams = {};
            const trimmedPath = (0, $2oA9E.trimPathRight)(next.pathname);
            const getMatchedParams = (route)=>{
                const result = (0, $2oA9E.matchPathname)(this.basepath, trimmedPath, {
                    to: route.fullPath,
                    caseSensitive: route.options.caseSensitive ?? this.options.caseSensitive,
                    fuzzy: true
                });
                return result;
            };
            let foundRoute = (dest == null ? void 0 : dest.to) !== void 0 ? this.routesByPath[dest.to] : void 0;
            if (foundRoute) routeParams = getMatchedParams(foundRoute);
            else foundRoute = this.flatRoutes.find((route)=>{
                const matchedParams = getMatchedParams(route);
                if (matchedParams) {
                    routeParams = matchedParams;
                    return true;
                }
                return false;
            });
            let routeCursor = foundRoute || this.routesById[0, $lxb5Z.rootRouteId];
            const matchedRoutes = [
                routeCursor
            ];
            while(routeCursor.parentRoute){
                routeCursor = routeCursor.parentRoute;
                matchedRoutes.unshift(routeCursor);
            }
            return {
                matchedRoutes: matchedRoutes,
                routeParams: routeParams,
                foundRoute: foundRoute
            };
        };
        this.cancelMatch = (id)=>{
            const match = this.getMatch(id);
            if (!match) return;
            match.abortController.abort();
            clearTimeout(match.pendingTimeout);
        };
        this.cancelMatches = ()=>{
            var _a;
            (_a = this.state.pendingMatches) == null || _a.forEach((match)=>{
                this.cancelMatch(match.id);
            });
        };
        this.buildLocation = (opts)=>{
            const build = (dest = {}, matchedRoutesResult)=>{
                var _a, _b, _c, _d, _e, _f;
                const fromMatches = dest._fromLocation ? this.matchRoutes(dest._fromLocation, {
                    _buildLocation: true
                }) : this.state.matches;
                const fromMatch = dest.from != null ? fromMatches.find((d)=>(0, $2oA9E.matchPathname)(this.basepath, (0, $2oA9E.trimPathRight)(d.pathname), {
                        to: dest.from,
                        caseSensitive: false,
                        fuzzy: false
                    })) : void 0;
                const fromPath = (fromMatch == null ? void 0 : fromMatch.pathname) || this.latestLocation.pathname;
                (0, $9GFyS.default)(dest.from == null || fromMatch != null, "Could not find match for from: " + dest.from);
                const fromSearch = ((_a = this.state.pendingMatches) == null ? void 0 : _a.length) ? (_b = (0, $bypHT.last)(this.state.pendingMatches)) == null ? void 0 : _b.search : ((_c = (0, $bypHT.last)(fromMatches)) == null ? void 0 : _c.search) || this.latestLocation.search;
                const stayingMatches = matchedRoutesResult == null ? void 0 : matchedRoutesResult.matchedRoutes.filter((d)=>fromMatches.find((e)=>e.routeId === d.id));
                let pathname;
                if (dest.to) {
                    const resolvePathTo = (fromMatch == null ? void 0 : fromMatch.fullPath) || this.latestLocation.pathname;
                    pathname = this.resolvePathWithBase(resolvePathTo, `${dest.to}`);
                } else {
                    const fromRouteByFromPathRouteId = this.routesById[(_d = stayingMatches == null ? void 0 : stayingMatches.find((route)=>{
                        const interpolatedPath = (0, $2oA9E.interpolatePath)({
                            path: route.fullPath,
                            params: (matchedRoutesResult == null ? void 0 : matchedRoutesResult.routeParams) ?? {},
                            decodeCharMap: this.pathParamsDecodeCharMap
                        }).interpolatedPath;
                        const pathname2 = (0, $2oA9E.joinPaths)([
                            this.basepath,
                            interpolatedPath
                        ]);
                        return pathname2 === fromPath;
                    })) == null ? void 0 : _d.id];
                    pathname = this.resolvePathWithBase(fromPath, (fromRouteByFromPathRouteId == null ? void 0 : fromRouteByFromPathRouteId.to) ?? fromPath);
                }
                const prevParams = {
                    ...(_e = (0, $bypHT.last)(fromMatches)) == null ? void 0 : _e.params
                };
                let nextParams = (dest.params ?? true) === true ? prevParams : {
                    ...prevParams,
                    ...(0, $bypHT.functionalUpdate)(dest.params, prevParams)
                };
                if (Object.keys(nextParams).length > 0) matchedRoutesResult == null || matchedRoutesResult.matchedRoutes.map((route)=>{
                    var _a2;
                    return ((_a2 = route.options.params) == null ? void 0 : _a2.stringify) ?? route.options.stringifyParams;
                }).filter(Boolean).forEach((fn)=>{
                    nextParams = {
                        ...nextParams,
                        ...fn(nextParams)
                    };
                });
                pathname = (0, $2oA9E.interpolatePath)({
                    path: pathname,
                    params: nextParams ?? {},
                    leaveWildcards: false,
                    leaveParams: opts.leaveParams,
                    decodeCharMap: this.pathParamsDecodeCharMap
                }).interpolatedPath;
                let search = fromSearch;
                if (opts._includeValidateSearch && ((_f = this.options.search) == null ? void 0 : _f.strict)) {
                    let validatedSearch = {};
                    matchedRoutesResult == null || matchedRoutesResult.matchedRoutes.forEach((route)=>{
                        try {
                            if (route.options.validateSearch) validatedSearch = {
                                ...validatedSearch,
                                ...$996271b4f79a4925$var$validateSearch(route.options.validateSearch, {
                                    ...validatedSearch,
                                    ...search
                                }) ?? {}
                            };
                        } catch  {}
                    });
                    search = validatedSearch;
                }
                const applyMiddlewares = (search2)=>{
                    const allMiddlewares = (matchedRoutesResult == null ? void 0 : matchedRoutesResult.matchedRoutes.reduce((acc, route)=>{
                        var _a2;
                        const middlewares = [];
                        if ("search" in route.options) {
                            if ((_a2 = route.options.search) == null ? void 0 : _a2.middlewares) middlewares.push(...route.options.search.middlewares);
                        } else if (route.options.preSearchFilters || route.options.postSearchFilters) {
                            const legacyMiddleware = ({ search: search3, next: next })=>{
                                let nextSearch = search3;
                                if ("preSearchFilters" in route.options && route.options.preSearchFilters) nextSearch = route.options.preSearchFilters.reduce((prev, next2)=>next2(prev), search3);
                                const result = next(nextSearch);
                                if ("postSearchFilters" in route.options && route.options.postSearchFilters) return route.options.postSearchFilters.reduce((prev, next2)=>next2(prev), result);
                                return result;
                            };
                            middlewares.push(legacyMiddleware);
                        }
                        if (opts._includeValidateSearch && route.options.validateSearch) {
                            const validate = ({ search: search3, next: next })=>{
                                try {
                                    const result = next(search3);
                                    const validatedSearch = {
                                        ...result,
                                        ...$996271b4f79a4925$var$validateSearch(route.options.validateSearch, result) ?? {}
                                    };
                                    return validatedSearch;
                                } catch  {}
                            };
                            middlewares.push(validate);
                        }
                        return acc.concat(middlewares);
                    }, [])) ?? [];
                    const final = ({ search: search3 })=>{
                        if (!dest.search) return {};
                        if (dest.search === true) return search3;
                        return (0, $bypHT.functionalUpdate)(dest.search, search3);
                    };
                    allMiddlewares.push(final);
                    const applyNext = (index, currentSearch)=>{
                        if (index >= allMiddlewares.length) return currentSearch;
                        const middleware = allMiddlewares[index];
                        const next = (newSearch)=>{
                            return applyNext(index + 1, newSearch);
                        };
                        return middleware({
                            search: currentSearch,
                            next: next
                        });
                    };
                    return applyNext(0, search2);
                };
                search = applyMiddlewares(search);
                search = (0, $bypHT.replaceEqualDeep)(fromSearch, search);
                const searchStr = this.options.stringifySearch(search);
                const hash = dest.hash === true ? this.latestLocation.hash : dest.hash ? (0, $bypHT.functionalUpdate)(dest.hash, this.latestLocation.hash) : void 0;
                const hashStr = hash ? `#${hash}` : "";
                let nextState = dest.state === true ? this.latestLocation.state : dest.state ? (0, $bypHT.functionalUpdate)(dest.state, this.latestLocation.state) : {};
                nextState = (0, $bypHT.replaceEqualDeep)(this.latestLocation.state, nextState);
                return {
                    pathname: pathname,
                    search: search,
                    searchStr: searchStr,
                    state: nextState,
                    hash: hash ?? "",
                    href: `${pathname}${searchStr}${hashStr}`,
                    unmaskOnReload: dest.unmaskOnReload
                };
            };
            const buildWithMatches = (dest = {}, maskedDest)=>{
                var _a;
                const next = build(dest);
                let maskedNext = maskedDest ? build(maskedDest) : void 0;
                if (!maskedNext) {
                    let params = {};
                    const foundMask = (_a = this.options.routeMasks) == null ? void 0 : _a.find((d)=>{
                        const match = (0, $2oA9E.matchPathname)(this.basepath, next.pathname, {
                            to: d.from,
                            caseSensitive: false,
                            fuzzy: false
                        });
                        if (match) {
                            params = match;
                            return true;
                        }
                        return false;
                    });
                    if (foundMask) {
                        const { from: _from, ...maskProps } = foundMask;
                        maskedDest = {
                            ...(0, $bypHT.pick)(opts, [
                                "from"
                            ]),
                            ...maskProps,
                            params: params
                        };
                        maskedNext = build(maskedDest);
                    }
                }
                const nextMatches = this.getMatchedRoutes(next, dest);
                const final = build(dest, nextMatches);
                if (maskedNext) {
                    const maskedMatches = this.getMatchedRoutes(maskedNext, maskedDest);
                    const maskedFinal = build(maskedDest, maskedMatches);
                    final.maskedLocation = maskedFinal;
                }
                return final;
            };
            if (opts.mask) return buildWithMatches(opts, {
                ...(0, $bypHT.pick)(opts, [
                    "from"
                ]),
                ...opts.mask
            });
            return buildWithMatches(opts);
        };
        this.commitLocation = ({ viewTransition: viewTransition, ignoreBlocker: ignoreBlocker, ...next })=>{
            const isSameState = ()=>{
                const ignoredProps = [
                    "key",
                    "__TSR_index",
                    "__hashScrollIntoViewOptions"
                ];
                ignoredProps.forEach((prop)=>{
                    next.state[prop] = this.latestLocation.state[prop];
                });
                const isEqual = (0, $bypHT.deepEqual)(next.state, this.latestLocation.state);
                ignoredProps.forEach((prop)=>{
                    delete next.state[prop];
                });
                return isEqual;
            };
            const isSameUrl = this.latestLocation.href === next.href;
            const previousCommitPromise = this.commitLocationPromise;
            this.commitLocationPromise = (0, $bypHT.createControlledPromise)(()=>{
                previousCommitPromise == null || previousCommitPromise.resolve();
            });
            if (isSameUrl && isSameState()) this.load();
            else {
                let { maskedLocation: maskedLocation, hashScrollIntoView: hashScrollIntoView, ...nextHistory } = next;
                if (maskedLocation) {
                    nextHistory = {
                        ...maskedLocation,
                        state: {
                            ...maskedLocation.state,
                            __tempKey: void 0,
                            __tempLocation: {
                                ...nextHistory,
                                search: nextHistory.searchStr,
                                state: {
                                    ...nextHistory.state,
                                    __tempKey: void 0,
                                    __tempLocation: void 0,
                                    key: void 0
                                }
                            }
                        }
                    };
                    if (nextHistory.unmaskOnReload ?? this.options.unmaskOnReload ?? false) nextHistory.state.__tempKey = this.tempLocationKey;
                }
                nextHistory.state.__hashScrollIntoViewOptions = hashScrollIntoView ?? this.options.defaultHashScrollIntoView ?? true;
                this.shouldViewTransition = viewTransition;
                this.history[next.replace ? "replace" : "push"](nextHistory.href, nextHistory.state, {
                    ignoreBlocker: ignoreBlocker
                });
            }
            this.resetNextScroll = next.resetScroll ?? true;
            if (!this.history.subscribers.size) this.load();
            return this.commitLocationPromise;
        };
        this.buildAndCommitLocation = ({ replace: replace, resetScroll: resetScroll, hashScrollIntoView: hashScrollIntoView, viewTransition: viewTransition, ignoreBlocker: ignoreBlocker, href: href, ...rest } = {})=>{
            if (href) {
                const currentIndex = this.history.location.state.__TSR_index;
                const parsed = (0, $3c1h0.parseHref)(href, {
                    __TSR_index: replace ? currentIndex : currentIndex + 1
                });
                rest.to = parsed.pathname;
                rest.search = this.options.parseSearch(parsed.search);
                rest.hash = parsed.hash.slice(1);
            }
            const location = this.buildLocation({
                ...rest,
                _includeValidateSearch: true
            });
            return this.commitLocation({
                ...location,
                viewTransition: viewTransition,
                replace: replace,
                resetScroll: resetScroll,
                hashScrollIntoView: hashScrollIntoView,
                ignoreBlocker: ignoreBlocker
            });
        };
        this.navigate = ({ to: to, reloadDocument: reloadDocument, href: href, ...rest })=>{
            if (reloadDocument) {
                if (!href) {
                    const location = this.buildLocation({
                        to: to,
                        ...rest
                    });
                    href = this.history.createHref(location.href);
                }
                if (rest.replace) window.location.replace(href);
                else window.location.href = href;
                return;
            }
            return this.buildAndCommitLocation({
                ...rest,
                href: href,
                to: to
            });
        };
        this.load = async (opts)=>{
            this.latestLocation = this.parseLocation(this.latestLocation);
            let redirect;
            let notFound;
            let loadPromise;
            loadPromise = new Promise((resolve)=>{
                this.startReactTransition(async ()=>{
                    var _a;
                    try {
                        const next = this.latestLocation;
                        const prevLocation = this.state.resolvedLocation;
                        this.cancelMatches();
                        let pendingMatches;
                        (0, $9AyUq.batch)(()=>{
                            pendingMatches = this.matchRoutes(next);
                            this.__store.setState((s)=>({
                                    ...s,
                                    status: "pending",
                                    isLoading: true,
                                    location: next,
                                    pendingMatches: pendingMatches,
                                    // If a cached moved to pendingMatches, remove it from cachedMatches
                                    cachedMatches: s.cachedMatches.filter((d)=>{
                                        return !pendingMatches.find((e)=>e.id === d.id);
                                    })
                                }));
                        });
                        if (!this.state.redirect) this.emit({
                            type: "onBeforeNavigate",
                            ...(0, $fleMh.getLocationChangeInfo)({
                                resolvedLocation: prevLocation,
                                location: next
                            })
                        });
                        this.emit({
                            type: "onBeforeLoad",
                            ...(0, $fleMh.getLocationChangeInfo)({
                                resolvedLocation: prevLocation,
                                location: next
                            })
                        });
                        await this.loadMatches({
                            sync: opts == null ? void 0 : opts.sync,
                            matches: pendingMatches,
                            location: next,
                            // eslint-disable-next-line @typescript-eslint/require-await
                            onReady: async ()=>{
                                this.startViewTransition(async ()=>{
                                    let exitingMatches;
                                    let enteringMatches;
                                    let stayingMatches;
                                    (0, $9AyUq.batch)(()=>{
                                        this.__store.setState((s)=>{
                                            const previousMatches = s.matches;
                                            const newMatches = s.pendingMatches || s.matches;
                                            exitingMatches = previousMatches.filter((match)=>!newMatches.find((d)=>d.id === match.id));
                                            enteringMatches = newMatches.filter((match)=>!previousMatches.find((d)=>d.id === match.id));
                                            stayingMatches = previousMatches.filter((match)=>newMatches.find((d)=>d.id === match.id));
                                            return {
                                                ...s,
                                                isLoading: false,
                                                loadedAt: Date.now(),
                                                matches: newMatches,
                                                pendingMatches: void 0,
                                                cachedMatches: [
                                                    ...s.cachedMatches,
                                                    ...exitingMatches.filter((d)=>d.status !== "error")
                                                ]
                                            };
                                        });
                                        this.clearExpiredCache();
                                    });
                                    [
                                        [
                                            exitingMatches,
                                            "onLeave"
                                        ],
                                        [
                                            enteringMatches,
                                            "onEnter"
                                        ],
                                        [
                                            stayingMatches,
                                            "onStay"
                                        ]
                                    ].forEach(([matches, hook])=>{
                                        matches.forEach((match)=>{
                                            var _a2, _b;
                                            (_b = (_a2 = this.looseRoutesById[match.routeId].options)[hook]) == null || _b.call(_a2, match);
                                        });
                                    });
                                });
                            }
                        });
                    } catch (err) {
                        if ((0, $gbTjE.isResolvedRedirect)(err)) {
                            redirect = err;
                            if (!this.isServer) this.navigate({
                                ...redirect,
                                replace: true,
                                ignoreBlocker: true
                            });
                        } else if ((0, $64Yjc.isNotFound)(err)) notFound = err;
                        this.__store.setState((s)=>({
                                ...s,
                                statusCode: redirect ? redirect.statusCode : notFound ? 404 : s.matches.some((d)=>d.status === "error") ? 500 : 200,
                                redirect: redirect
                            }));
                    }
                    if (this.latestLoadPromise === loadPromise) {
                        (_a = this.commitLocationPromise) == null || _a.resolve();
                        this.latestLoadPromise = void 0;
                        this.commitLocationPromise = void 0;
                    }
                    resolve();
                });
            });
            this.latestLoadPromise = loadPromise;
            await loadPromise;
            while(this.latestLoadPromise && loadPromise !== this.latestLoadPromise)await this.latestLoadPromise;
            if (this.hasNotFoundMatch()) this.__store.setState((s)=>({
                    ...s,
                    statusCode: 404
                }));
        };
        this.startViewTransition = (fn)=>{
            const shouldViewTransition = this.shouldViewTransition ?? this.options.defaultViewTransition;
            delete this.shouldViewTransition;
            if (shouldViewTransition && typeof document !== "undefined" && "startViewTransition" in document && typeof document.startViewTransition === "function") {
                let startViewTransitionParams;
                if (typeof shouldViewTransition === "object" && this.isViewTransitionTypesSupported) startViewTransitionParams = {
                    update: fn,
                    types: shouldViewTransition.types
                };
                else startViewTransitionParams = fn;
                document.startViewTransition(startViewTransitionParams);
            } else fn();
        };
        this.updateMatch = (id, updater)=>{
            var _a;
            let updated;
            const isPending = (_a = this.state.pendingMatches) == null ? void 0 : _a.find((d)=>d.id === id);
            const isMatched = this.state.matches.find((d)=>d.id === id);
            const isCached = this.state.cachedMatches.find((d)=>d.id === id);
            const matchesKey = isPending ? "pendingMatches" : isMatched ? "matches" : isCached ? "cachedMatches" : "";
            if (matchesKey) this.__store.setState((s)=>{
                var _a2;
                return {
                    ...s,
                    [matchesKey]: (_a2 = s[matchesKey]) == null ? void 0 : _a2.map((d)=>d.id === id ? updated = updater(d) : d)
                };
            });
            return updated;
        };
        this.getMatch = (matchId)=>{
            return [
                ...this.state.cachedMatches,
                ...this.state.pendingMatches ?? [],
                ...this.state.matches
            ].find((d)=>d.id === matchId);
        };
        this.loadMatches = async ({ location: location, matches: matches, preload: allPreload, onReady: onReady, updateMatch: updateMatch = this.updateMatch, sync: sync })=>{
            let firstBadMatchIndex;
            let rendered = false;
            const triggerOnReady = async ()=>{
                if (!rendered) {
                    rendered = true;
                    await (onReady == null ? void 0 : onReady());
                }
            };
            const resolvePreload = (matchId)=>{
                return !!(allPreload && !this.state.matches.find((d)=>d.id === matchId));
            };
            if (!this.isServer && !this.state.matches.length) triggerOnReady();
            const handleRedirectAndNotFound = (match, err)=>{
                var _a, _b, _c, _d;
                if ((0, $gbTjE.isResolvedRedirect)(err)) {
                    if (!err.reloadDocument) throw err;
                }
                if ((0, $gbTjE.isRedirect)(err) || (0, $64Yjc.isNotFound)(err)) {
                    updateMatch(match.id, (prev)=>({
                            ...prev,
                            status: (0, $gbTjE.isRedirect)(err) ? "redirected" : (0, $64Yjc.isNotFound)(err) ? "notFound" : "error",
                            isFetching: false,
                            error: err,
                            beforeLoadPromise: void 0,
                            loaderPromise: void 0
                        }));
                    if (!err.routeId) err.routeId = match.routeId;
                    (_a = match.beforeLoadPromise) == null || _a.resolve();
                    (_b = match.loaderPromise) == null || _b.resolve();
                    (_c = match.loadPromise) == null || _c.resolve();
                    if ((0, $gbTjE.isRedirect)(err)) {
                        rendered = true;
                        err = this.resolveRedirect({
                            ...err,
                            _fromLocation: location
                        });
                        throw err;
                    } else if ((0, $64Yjc.isNotFound)(err)) {
                        this._handleNotFound(matches, err, {
                            updateMatch: updateMatch
                        });
                        (_d = this.serverSsr) == null || _d.onMatchSettled({
                            router: this,
                            match: this.getMatch(match.id)
                        });
                        throw err;
                    }
                }
            };
            try {
                await new Promise((resolveAll, rejectAll)=>{
                    (async ()=>{
                        var _a, _b, _c;
                        try {
                            const handleSerialError = (index, err, routerCode)=>{
                                var _a2, _b2;
                                const { id: matchId, routeId: routeId } = matches[index];
                                const route = this.looseRoutesById[routeId];
                                if (err instanceof Promise) throw err;
                                err.routerCode = routerCode;
                                firstBadMatchIndex = firstBadMatchIndex ?? index;
                                handleRedirectAndNotFound(this.getMatch(matchId), err);
                                try {
                                    (_b2 = (_a2 = route.options).onError) == null || _b2.call(_a2, err);
                                } catch (errorHandlerErr) {
                                    err = errorHandlerErr;
                                    handleRedirectAndNotFound(this.getMatch(matchId), err);
                                }
                                updateMatch(matchId, (prev)=>{
                                    var _a3, _b3;
                                    (_a3 = prev.beforeLoadPromise) == null || _a3.resolve();
                                    (_b3 = prev.loadPromise) == null || _b3.resolve();
                                    return {
                                        ...prev,
                                        error: err,
                                        status: "error",
                                        isFetching: false,
                                        updatedAt: Date.now(),
                                        abortController: new AbortController(),
                                        beforeLoadPromise: void 0
                                    };
                                });
                            };
                            for (const [index, { id: matchId, routeId: routeId }] of matches.entries()){
                                const existingMatch = this.getMatch(matchId);
                                const parentMatchId = (_a = matches[index - 1]) == null ? void 0 : _a.id;
                                const route = this.looseRoutesById[routeId];
                                const pendingMs = route.options.pendingMs ?? this.options.defaultPendingMs;
                                const shouldPending = !!(onReady && !this.isServer && !resolvePreload(matchId) && (route.options.loader || route.options.beforeLoad) && typeof pendingMs === "number" && pendingMs !== Infinity && (route.options.pendingComponent ?? this.options.defaultPendingComponent));
                                let executeBeforeLoad = true;
                                if (// If we are in the middle of a load, either of these will be present
                                // (not to be confused with `loadPromise`, which is always defined)
                                existingMatch.beforeLoadPromise || existingMatch.loaderPromise) {
                                    if (shouldPending) setTimeout(()=>{
                                        try {
                                            triggerOnReady();
                                        } catch  {}
                                    }, pendingMs);
                                    await existingMatch.beforeLoadPromise;
                                    executeBeforeLoad = this.getMatch(matchId).status !== "success";
                                }
                                if (executeBeforeLoad) {
                                    try {
                                        updateMatch(matchId, (prev)=>({
                                                ...prev,
                                                loadPromise: (0, $bypHT.createControlledPromise)(()=>{
                                                    var _a2;
                                                    (_a2 = prev.loadPromise) == null || _a2.resolve();
                                                }),
                                                beforeLoadPromise: (0, $bypHT.createControlledPromise)()
                                            }));
                                        const abortController = new AbortController();
                                        let pendingTimeout;
                                        if (shouldPending) pendingTimeout = setTimeout(()=>{
                                            try {
                                                triggerOnReady();
                                            } catch  {}
                                        }, pendingMs);
                                        const { paramsError: paramsError, searchError: searchError } = this.getMatch(matchId);
                                        if (paramsError) handleSerialError(index, paramsError, "PARSE_PARAMS");
                                        if (searchError) handleSerialError(index, searchError, "VALIDATE_SEARCH");
                                        const getParentMatchContext = ()=>parentMatchId ? this.getMatch(parentMatchId).context : this.options.context ?? {};
                                        updateMatch(matchId, (prev)=>({
                                                ...prev,
                                                isFetching: "beforeLoad",
                                                fetchCount: prev.fetchCount + 1,
                                                abortController: abortController,
                                                pendingTimeout: pendingTimeout,
                                                context: {
                                                    ...getParentMatchContext(),
                                                    ...prev.__routeContext
                                                }
                                            }));
                                        const { search: search, params: params, context: context, cause: cause } = this.getMatch(matchId);
                                        const preload = resolvePreload(matchId);
                                        const beforeLoadFnContext = {
                                            search: search,
                                            abortController: abortController,
                                            params: params,
                                            preload: preload,
                                            context: context,
                                            location: location,
                                            navigate: (opts)=>this.navigate({
                                                    ...opts,
                                                    _fromLocation: location
                                                }),
                                            buildLocation: this.buildLocation,
                                            cause: preload ? "preload" : cause,
                                            matches: matches
                                        };
                                        const beforeLoadContext = await ((_c = (_b = route.options).beforeLoad) == null ? void 0 : _c.call(_b, beforeLoadFnContext)) ?? {};
                                        if ((0, $gbTjE.isRedirect)(beforeLoadContext) || (0, $64Yjc.isNotFound)(beforeLoadContext)) handleSerialError(index, beforeLoadContext, "BEFORE_LOAD");
                                        updateMatch(matchId, (prev)=>{
                                            return {
                                                ...prev,
                                                __beforeLoadContext: beforeLoadContext,
                                                context: {
                                                    ...getParentMatchContext(),
                                                    ...prev.__routeContext,
                                                    ...beforeLoadContext
                                                },
                                                abortController: abortController
                                            };
                                        });
                                    } catch (err) {
                                        handleSerialError(index, err, "BEFORE_LOAD");
                                    }
                                    updateMatch(matchId, (prev)=>{
                                        var _a2;
                                        (_a2 = prev.beforeLoadPromise) == null || _a2.resolve();
                                        return {
                                            ...prev,
                                            beforeLoadPromise: void 0,
                                            isFetching: false
                                        };
                                    });
                                }
                            }
                            const validResolvedMatches = matches.slice(0, firstBadMatchIndex);
                            const matchPromises = [];
                            validResolvedMatches.forEach(({ id: matchId, routeId: routeId }, index)=>{
                                matchPromises.push((async ()=>{
                                    const { loaderPromise: prevLoaderPromise } = this.getMatch(matchId);
                                    let loaderShouldRunAsync = false;
                                    let loaderIsRunningAsync = false;
                                    if (prevLoaderPromise) {
                                        await prevLoaderPromise;
                                        const match = this.getMatch(matchId);
                                        if (match.error) handleRedirectAndNotFound(match, match.error);
                                    } else {
                                        const parentMatchPromise = matchPromises[index - 1];
                                        const route = this.looseRoutesById[routeId];
                                        const getLoaderContext = ()=>{
                                            const { params: params, loaderDeps: loaderDeps, abortController: abortController, context: context, cause: cause } = this.getMatch(matchId);
                                            const preload2 = resolvePreload(matchId);
                                            return {
                                                params: params,
                                                deps: loaderDeps,
                                                preload: !!preload2,
                                                parentMatchPromise: parentMatchPromise,
                                                abortController: abortController,
                                                context: context,
                                                location: location,
                                                navigate: (opts)=>this.navigate({
                                                        ...opts,
                                                        _fromLocation: location
                                                    }),
                                                cause: preload2 ? "preload" : cause,
                                                route: route
                                            };
                                        };
                                        const age = Date.now() - this.getMatch(matchId).updatedAt;
                                        const preload = resolvePreload(matchId);
                                        const staleAge = preload ? route.options.preloadStaleTime ?? this.options.defaultPreloadStaleTime ?? 3e4 : route.options.staleTime ?? this.options.defaultStaleTime ?? 0;
                                        const shouldReloadOption = route.options.shouldReload;
                                        const shouldReload = typeof shouldReloadOption === "function" ? shouldReloadOption(getLoaderContext()) : shouldReloadOption;
                                        updateMatch(matchId, (prev)=>({
                                                ...prev,
                                                loaderPromise: (0, $bypHT.createControlledPromise)(),
                                                preload: !!preload && !this.state.matches.find((d)=>d.id === matchId)
                                            }));
                                        const runLoader = async ()=>{
                                            var _a2, _b2, _c2, _d, _e, _f, _g, _h, _i, _j, _k;
                                            try {
                                                const potentialPendingMinPromise = async ()=>{
                                                    const latestMatch = this.getMatch(matchId);
                                                    if (latestMatch.minPendingPromise) await latestMatch.minPendingPromise;
                                                };
                                                try {
                                                    this.loadRouteChunk(route);
                                                    updateMatch(matchId, (prev)=>({
                                                            ...prev,
                                                            isFetching: "loader"
                                                        }));
                                                    const loaderData = await ((_b2 = (_a2 = route.options).loader) == null ? void 0 : _b2.call(_a2, getLoaderContext()));
                                                    handleRedirectAndNotFound(this.getMatch(matchId), loaderData);
                                                    await route._lazyPromise;
                                                    await potentialPendingMinPromise();
                                                    const assetContext = {
                                                        matches: matches,
                                                        match: this.getMatch(matchId),
                                                        params: this.getMatch(matchId).params,
                                                        loaderData: loaderData
                                                    };
                                                    const headFnContent = (_d = (_c2 = route.options).head) == null ? void 0 : _d.call(_c2, assetContext);
                                                    const meta = headFnContent == null ? void 0 : headFnContent.meta;
                                                    const links = headFnContent == null ? void 0 : headFnContent.links;
                                                    const headScripts = headFnContent == null ? void 0 : headFnContent.scripts;
                                                    const scripts = (_f = (_e = route.options).scripts) == null ? void 0 : _f.call(_e, assetContext);
                                                    const headers = (_h = (_g = route.options).headers) == null ? void 0 : _h.call(_g, {
                                                        loaderData: loaderData
                                                    });
                                                    updateMatch(matchId, (prev)=>({
                                                            ...prev,
                                                            error: void 0,
                                                            status: "success",
                                                            isFetching: false,
                                                            updatedAt: Date.now(),
                                                            loaderData: loaderData,
                                                            meta: meta,
                                                            links: links,
                                                            headScripts: headScripts,
                                                            headers: headers,
                                                            scripts: scripts
                                                        }));
                                                } catch (e) {
                                                    let error = e;
                                                    await potentialPendingMinPromise();
                                                    handleRedirectAndNotFound(this.getMatch(matchId), e);
                                                    try {
                                                        (_j = (_i = route.options).onError) == null || _j.call(_i, e);
                                                    } catch (onErrorError) {
                                                        error = onErrorError;
                                                        handleRedirectAndNotFound(this.getMatch(matchId), onErrorError);
                                                    }
                                                    updateMatch(matchId, (prev)=>({
                                                            ...prev,
                                                            error: error,
                                                            status: "error",
                                                            isFetching: false
                                                        }));
                                                }
                                                (_k = this.serverSsr) == null || _k.onMatchSettled({
                                                    router: this,
                                                    match: this.getMatch(matchId)
                                                });
                                                await route._componentsPromise;
                                            } catch (err) {
                                                updateMatch(matchId, (prev)=>({
                                                        ...prev,
                                                        loaderPromise: void 0
                                                    }));
                                                handleRedirectAndNotFound(this.getMatch(matchId), err);
                                            }
                                        };
                                        const { status: status, invalid: invalid } = this.getMatch(matchId);
                                        loaderShouldRunAsync = status === "success" && (invalid || (shouldReload ?? age > staleAge));
                                        if (preload && route.options.preload === false) ;
                                        else if (loaderShouldRunAsync && !sync) {
                                            loaderIsRunningAsync = true;
                                            (async ()=>{
                                                try {
                                                    await runLoader();
                                                    const { loaderPromise: loaderPromise, loadPromise: loadPromise } = this.getMatch(matchId);
                                                    loaderPromise == null || loaderPromise.resolve();
                                                    loadPromise == null || loadPromise.resolve();
                                                    updateMatch(matchId, (prev)=>({
                                                            ...prev,
                                                            loaderPromise: void 0
                                                        }));
                                                } catch (err) {
                                                    if ((0, $gbTjE.isResolvedRedirect)(err)) await this.navigate(err);
                                                }
                                            })();
                                        } else if (status !== "success" || loaderShouldRunAsync && sync) await runLoader();
                                    }
                                    if (!loaderIsRunningAsync) {
                                        const { loaderPromise: loaderPromise, loadPromise: loadPromise } = this.getMatch(matchId);
                                        loaderPromise == null || loaderPromise.resolve();
                                        loadPromise == null || loadPromise.resolve();
                                    }
                                    updateMatch(matchId, (prev)=>({
                                            ...prev,
                                            isFetching: loaderIsRunningAsync ? prev.isFetching : false,
                                            loaderPromise: loaderIsRunningAsync ? prev.loaderPromise : void 0,
                                            invalid: false
                                        }));
                                    return this.getMatch(matchId);
                                })());
                            });
                            await Promise.all(matchPromises);
                            resolveAll();
                        } catch (err) {
                            rejectAll(err);
                        }
                    })();
                });
                await triggerOnReady();
            } catch (err) {
                if ((0, $gbTjE.isRedirect)(err) || (0, $64Yjc.isNotFound)(err)) {
                    if ((0, $64Yjc.isNotFound)(err) && !allPreload) await triggerOnReady();
                    throw err;
                }
            }
            return matches;
        };
        this.invalidate = (opts)=>{
            const invalidate = (d)=>{
                var _a;
                if (((_a = opts == null ? void 0 : opts.filter) == null ? void 0 : _a.call(opts, d)) ?? true) return {
                    ...d,
                    invalid: true,
                    ...d.status === "error" ? {
                        status: "pending",
                        error: void 0
                    } : {}
                };
                return d;
            };
            this.__store.setState((s)=>{
                var _a;
                return {
                    ...s,
                    matches: s.matches.map(invalidate),
                    cachedMatches: s.cachedMatches.map(invalidate),
                    pendingMatches: (_a = s.pendingMatches) == null ? void 0 : _a.map(invalidate)
                };
            });
            return this.load({
                sync: opts == null ? void 0 : opts.sync
            });
        };
        this.resolveRedirect = (err)=>{
            const redirect = err;
            if (!redirect.href) redirect.href = this.buildLocation(redirect).href;
            return redirect;
        };
        this.clearCache = (opts)=>{
            const filter = opts == null ? void 0 : opts.filter;
            if (filter !== void 0) this.__store.setState((s)=>{
                return {
                    ...s,
                    cachedMatches: s.cachedMatches.filter((m)=>!filter(m))
                };
            });
            else this.__store.setState((s)=>{
                return {
                    ...s,
                    cachedMatches: []
                };
            });
        };
        this.clearExpiredCache = ()=>{
            const filter = (d)=>{
                const route = this.looseRoutesById[d.routeId];
                if (!route.options.loader) return true;
                const gcTime = (d.preload ? route.options.preloadGcTime ?? this.options.defaultPreloadGcTime : route.options.gcTime ?? this.options.defaultGcTime) ?? 300000;
                return !(d.status !== "error" && Date.now() - d.updatedAt < gcTime);
            };
            this.clearCache({
                filter: filter
            });
        };
        this.loadRouteChunk = (route)=>{
            if (route._lazyPromise === void 0) {
                if (route.lazyFn) route._lazyPromise = route.lazyFn().then((lazyRoute)=>{
                    const { id: _id, ...options2 } = lazyRoute.options;
                    Object.assign(route.options, options2);
                });
                else route._lazyPromise = Promise.resolve();
            }
            if (route._componentsPromise === void 0) route._componentsPromise = route._lazyPromise.then(()=>Promise.all($996271b4f79a4925$export$741158c5c07285bb.map(async (type)=>{
                    const component = route.options[type];
                    if (component == null ? void 0 : component.preload) await component.preload();
                })));
            return route._componentsPromise;
        };
        this.preloadRoute = async (opts)=>{
            const next = this.buildLocation(opts);
            let matches = this.matchRoutes(next, {
                throwOnError: true,
                preload: true,
                dest: opts
            });
            const activeMatchIds = new Set([
                ...this.state.matches,
                ...this.state.pendingMatches ?? []
            ].map((d)=>d.id));
            const loadedMatchIds = /* @__PURE__ */ new Set([
                ...activeMatchIds,
                ...this.state.cachedMatches.map((d)=>d.id)
            ]);
            (0, $9AyUq.batch)(()=>{
                matches.forEach((match)=>{
                    if (!loadedMatchIds.has(match.id)) this.__store.setState((s)=>({
                            ...s,
                            cachedMatches: [
                                ...s.cachedMatches,
                                match
                            ]
                        }));
                });
            });
            try {
                matches = await this.loadMatches({
                    matches: matches,
                    location: next,
                    preload: true,
                    updateMatch: (id, updater)=>{
                        if (activeMatchIds.has(id)) matches = matches.map((d)=>d.id === id ? updater(d) : d);
                        else this.updateMatch(id, updater);
                    }
                });
                return matches;
            } catch (err) {
                if ((0, $gbTjE.isRedirect)(err)) {
                    if (err.reloadDocument) return void 0;
                    return await this.preloadRoute({
                        ...err,
                        _fromLocation: next
                    });
                }
                if (!(0, $64Yjc.isNotFound)(err)) console.error(err);
                return void 0;
            }
        };
        this.matchRoute = (location, opts)=>{
            const matchLocation = {
                ...location,
                to: location.to ? this.resolvePathWithBase(location.from || "", location.to) : void 0,
                params: location.params || {},
                leaveParams: true
            };
            const next = this.buildLocation(matchLocation);
            if ((opts == null ? void 0 : opts.pending) && this.state.status !== "pending") return false;
            const pending = (opts == null ? void 0 : opts.pending) === void 0 ? !this.state.isLoading : opts.pending;
            const baseLocation = pending ? this.latestLocation : this.state.resolvedLocation || this.state.location;
            const match = (0, $2oA9E.matchPathname)(this.basepath, baseLocation.pathname, {
                ...opts,
                to: next.pathname
            });
            if (!match) return false;
            if (location.params) {
                if (!(0, $bypHT.deepEqual)(match, location.params, {
                    partial: true
                })) return false;
            }
            if (match && ((opts == null ? void 0 : opts.includeSearch) ?? true)) return (0, $bypHT.deepEqual)(baseLocation.search, next.search, {
                partial: true
            }) ? match : false;
            return match;
        };
        this._handleNotFound = (matches, err, { updateMatch: updateMatch = this.updateMatch } = {})=>{
            const matchesByRouteId = Object.fromEntries(matches.map((match2)=>[
                    match2.routeId,
                    match2
                ]));
            let routeCursor = (err.global ? this.looseRoutesById[0, $lxb5Z.rootRouteId] : this.looseRoutesById[err.routeId]) || this.looseRoutesById[0, $lxb5Z.rootRouteId];
            while(!routeCursor.options.notFoundComponent && !this.options.defaultNotFoundComponent && routeCursor.id !== (0, $lxb5Z.rootRouteId)){
                routeCursor = routeCursor.parentRoute;
                (0, $9GFyS.default)(routeCursor, "Found invalid route tree while trying to find not-found handler.");
            }
            const match = matchesByRouteId[routeCursor.id];
            (0, $9GFyS.default)(match, "Could not find match for route: " + routeCursor.id);
            updateMatch(match.id, (prev)=>({
                    ...prev,
                    status: "notFound",
                    error: err,
                    isFetching: false
                }));
            if (err.routerCode === "BEFORE_LOAD" && routeCursor.parentRoute) {
                err.routeId = routeCursor.parentRoute.id;
                this._handleNotFound(matches, err, {
                    updateMatch: updateMatch
                });
            }
        };
        this.hasNotFoundMatch = ()=>{
            return this.__store.state.matches.some((d)=>d.status === "notFound" || d.globalNotFound);
        };
        this.update({
            defaultPreloadDelay: 50,
            defaultPendingMs: 1e3,
            defaultPendingMinMs: 500,
            context: void 0,
            ...options,
            caseSensitive: options.caseSensitive ?? false,
            notFoundMode: options.notFoundMode ?? "fuzzy",
            stringifySearch: options.stringifySearch ?? (0, $a7sW4.defaultStringifySearch),
            parseSearch: options.parseSearch ?? (0, $a7sW4.defaultParseSearch)
        });
        if (typeof document !== "undefined") window.__TSR_ROUTER__ = this;
    }
    get state() {
        return this.__store.state;
    }
    get looseRoutesById() {
        return this.routesById;
    }
    matchRoutes(pathnameOrNext, locationSearchOrOpts, opts) {
        if (typeof pathnameOrNext === "string") return this.matchRoutesInternal({
            pathname: pathnameOrNext,
            search: locationSearchOrOpts
        }, opts);
        else return this.matchRoutesInternal(pathnameOrNext, locationSearchOrOpts);
    }
    matchRoutesInternal(next, opts) {
        const { foundRoute: foundRoute, matchedRoutes: matchedRoutes, routeParams: routeParams } = this.getMatchedRoutes(next, opts == null ? void 0 : opts.dest);
        let isGlobalNotFound = false;
        if (// If we found a route, and it's not an index route and we have left over path
        foundRoute ? foundRoute.path !== "/" && routeParams["**"] : // Or if we didn't find a route and we have left over path
        (0, $2oA9E.trimPathRight)(next.pathname)) {
            if (this.options.notFoundRoute) matchedRoutes.push(this.options.notFoundRoute);
            else isGlobalNotFound = true;
        }
        const globalNotFoundRouteId = (()=>{
            if (!isGlobalNotFound) return void 0;
            if (this.options.notFoundMode !== "root") for(let i = matchedRoutes.length - 1; i >= 0; i--){
                const route = matchedRoutes[i];
                if (route.children) return route.id;
            }
            return 0, $lxb5Z.rootRouteId;
        })();
        const parseErrors = matchedRoutes.map((route)=>{
            var _a;
            let parsedParamsError;
            const parseParams = ((_a = route.options.params) == null ? void 0 : _a.parse) ?? route.options.parseParams;
            if (parseParams) try {
                const parsedParams = parseParams(routeParams);
                Object.assign(routeParams, parsedParams);
            } catch (err) {
                parsedParamsError = new $996271b4f79a4925$export$d54ad939fce4f123(err.message, {
                    cause: err
                });
                if (opts == null ? void 0 : opts.throwOnError) throw parsedParamsError;
                return parsedParamsError;
            }
            return;
        });
        const matches = [];
        const getParentContext = (parentMatch)=>{
            const parentMatchId = parentMatch == null ? void 0 : parentMatch.id;
            const parentContext = !parentMatchId ? this.options.context ?? {} : parentMatch.context ?? this.options.context ?? {};
            return parentContext;
        };
        matchedRoutes.forEach((route, index)=>{
            var _a, _b;
            const parentMatch = matches[index - 1];
            const [preMatchSearch, strictMatchSearch, searchError] = (()=>{
                const parentSearch = (parentMatch == null ? void 0 : parentMatch.search) ?? next.search;
                const parentStrictSearch = (parentMatch == null ? void 0 : parentMatch._strictSearch) ?? {};
                try {
                    const strictSearch = $996271b4f79a4925$var$validateSearch(route.options.validateSearch, {
                        ...parentSearch
                    }) ?? {};
                    return [
                        {
                            ...parentSearch,
                            ...strictSearch
                        },
                        {
                            ...parentStrictSearch,
                            ...strictSearch
                        },
                        void 0
                    ];
                } catch (err) {
                    let searchParamError = err;
                    if (!(err instanceof $996271b4f79a4925$export$ca74fadaf06bf7e1)) searchParamError = new $996271b4f79a4925$export$ca74fadaf06bf7e1(err.message, {
                        cause: err
                    });
                    if (opts == null ? void 0 : opts.throwOnError) throw searchParamError;
                    return [
                        parentSearch,
                        {},
                        searchParamError
                    ];
                }
            })();
            const loaderDeps = ((_b = (_a = route.options).loaderDeps) == null ? void 0 : _b.call(_a, {
                search: preMatchSearch
            })) ?? "";
            const loaderDepsHash = loaderDeps ? JSON.stringify(loaderDeps) : "";
            const { usedParams: usedParams, interpolatedPath: interpolatedPath } = (0, $2oA9E.interpolatePath)({
                path: route.fullPath,
                params: routeParams,
                decodeCharMap: this.pathParamsDecodeCharMap
            });
            const matchId = (0, $2oA9E.interpolatePath)({
                path: route.id,
                params: routeParams,
                leaveWildcards: true,
                decodeCharMap: this.pathParamsDecodeCharMap
            }).interpolatedPath + loaderDepsHash;
            const existingMatch = this.getMatch(matchId);
            const previousMatch = this.state.matches.find((d)=>d.routeId === route.id);
            const cause = previousMatch ? "stay" : "enter";
            let match;
            if (existingMatch) match = {
                ...existingMatch,
                cause: cause,
                params: previousMatch ? (0, $bypHT.replaceEqualDeep)(previousMatch.params, routeParams) : routeParams,
                _strictParams: usedParams,
                search: previousMatch ? (0, $bypHT.replaceEqualDeep)(previousMatch.search, preMatchSearch) : (0, $bypHT.replaceEqualDeep)(existingMatch.search, preMatchSearch),
                _strictSearch: strictMatchSearch
            };
            else {
                const status = route.options.loader || route.options.beforeLoad || route.lazyFn || $996271b4f79a4925$var$routeNeedsPreload(route) ? "pending" : "success";
                match = {
                    id: matchId,
                    index: index,
                    routeId: route.id,
                    params: previousMatch ? (0, $bypHT.replaceEqualDeep)(previousMatch.params, routeParams) : routeParams,
                    _strictParams: usedParams,
                    pathname: (0, $2oA9E.joinPaths)([
                        this.basepath,
                        interpolatedPath
                    ]),
                    updatedAt: Date.now(),
                    search: previousMatch ? (0, $bypHT.replaceEqualDeep)(previousMatch.search, preMatchSearch) : preMatchSearch,
                    _strictSearch: strictMatchSearch,
                    searchError: void 0,
                    status: status,
                    isFetching: false,
                    error: void 0,
                    paramsError: parseErrors[index],
                    __routeContext: {},
                    __beforeLoadContext: {},
                    context: {},
                    abortController: new AbortController(),
                    fetchCount: 0,
                    cause: cause,
                    loaderDeps: previousMatch ? (0, $bypHT.replaceEqualDeep)(previousMatch.loaderDeps, loaderDeps) : loaderDeps,
                    invalid: false,
                    preload: false,
                    links: void 0,
                    scripts: void 0,
                    headScripts: void 0,
                    meta: void 0,
                    staticData: route.options.staticData || {},
                    loadPromise: (0, $bypHT.createControlledPromise)(),
                    fullPath: route.fullPath
                };
            }
            if (!(opts == null ? void 0 : opts.preload)) match.globalNotFound = globalNotFoundRouteId === route.id;
            match.searchError = searchError;
            const parentContext = getParentContext(parentMatch);
            match.context = {
                ...parentContext,
                ...match.__routeContext,
                ...match.__beforeLoadContext
            };
            matches.push(match);
        });
        matches.forEach((match, index)=>{
            var _a, _b, _c, _d, _e, _f, _g, _h;
            const route = this.looseRoutesById[match.routeId];
            const existingMatch = this.getMatch(match.id);
            if (!existingMatch && (opts == null ? void 0 : opts._buildLocation) !== true) {
                const parentMatch = matches[index - 1];
                const parentContext = getParentContext(parentMatch);
                const contextFnContext = {
                    deps: match.loaderDeps,
                    params: match.params,
                    context: parentContext,
                    location: next,
                    navigate: (opts2)=>this.navigate({
                            ...opts2,
                            _fromLocation: next
                        }),
                    buildLocation: this.buildLocation,
                    cause: match.cause,
                    abortController: match.abortController,
                    preload: !!match.preload,
                    matches: matches
                };
                match.__routeContext = ((_b = (_a = route.options).context) == null ? void 0 : _b.call(_a, contextFnContext)) ?? {};
                match.context = {
                    ...parentContext,
                    ...match.__routeContext,
                    ...match.__beforeLoadContext
                };
            }
            if (match.status === "success") {
                match.headers = (_d = (_c = route.options).headers) == null ? void 0 : _d.call(_c, {
                    loaderData: match.loaderData
                });
                const assetContext = {
                    matches: matches,
                    match: match,
                    params: match.params,
                    loaderData: match.loaderData
                };
                const headFnContent = (_f = (_e = route.options).head) == null ? void 0 : _f.call(_e, assetContext);
                match.links = headFnContent == null ? void 0 : headFnContent.links;
                match.headScripts = headFnContent == null ? void 0 : headFnContent.scripts;
                match.meta = headFnContent == null ? void 0 : headFnContent.meta;
                match.scripts = (_h = (_g = route.options).scripts) == null ? void 0 : _h.call(_g, assetContext);
            }
        });
        return matches;
    }
}
function $996271b4f79a4925$export$5dc1db391e531241(fn, key) {
    return async (...args)=>{
        const imported = await fn();
        return imported[key || "default"](...args);
    };
}
class $996271b4f79a4925$export$ca74fadaf06bf7e1 extends Error {
}
class $996271b4f79a4925$export$d54ad939fce4f123 extends Error {
}
function $996271b4f79a4925$export$baa2404bdcb7f08c(location) {
    return {
        loadedAt: 0,
        isLoading: false,
        isTransitioning: false,
        status: "idle",
        resolvedLocation: void 0,
        location: location,
        matches: [],
        pendingMatches: [],
        cachedMatches: [],
        statusCode: 200
    };
}

});
parcelRegister("3c1h0", function(module, exports) {

$parcel$export(module.exports, "parseHref", function () { return $25337af3e53bf641$export$c68fd8c8a50e78e; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $25337af3e53bf641$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createMemoryHistory", function () { return $25337af3e53bf641$export$2b76ad033c6e6d08; });
const $25337af3e53bf641$var$stateIndexKey = "__TSR_index";
const $25337af3e53bf641$var$popStateEvent = "popstate";
const $25337af3e53bf641$var$beforeUnloadEvent = "beforeunload";
function $25337af3e53bf641$export$4178d7ac16e6cf7c(opts) {
    let location = opts.getLocation();
    const subscribers = /* @__PURE__ */ new Set();
    const notify = (action)=>{
        location = opts.getLocation();
        subscribers.forEach((subscriber)=>subscriber({
                location: location,
                action: action
            }));
    };
    const handleIndexChange = (action)=>{
        if (opts.notifyOnIndexChange ?? true) notify(action);
        else location = opts.getLocation();
    };
    const tryNavigation = async ({ task: task, navigateOpts: navigateOpts, ...actionInfo })=>{
        var _a, _b;
        const ignoreBlocker = (navigateOpts == null ? void 0 : navigateOpts.ignoreBlocker) ?? false;
        if (ignoreBlocker) {
            task();
            return;
        }
        const blockers = ((_a = opts.getBlockers) == null ? void 0 : _a.call(opts)) ?? [];
        const isPushOrReplace = actionInfo.type === "PUSH" || actionInfo.type === "REPLACE";
        if (typeof document !== "undefined" && blockers.length && isPushOrReplace) for (const blocker of blockers){
            const nextLocation = $25337af3e53bf641$export$c68fd8c8a50e78e(actionInfo.path, actionInfo.state);
            const isBlocked = await blocker.blockerFn({
                currentLocation: location,
                nextLocation: nextLocation,
                action: actionInfo.type
            });
            if (isBlocked) {
                (_b = opts.onBlocked) == null || _b.call(opts);
                return;
            }
        }
        task();
    };
    return {
        get location () {
            return location;
        },
        get length () {
            return opts.getLength();
        },
        subscribers: subscribers,
        subscribe: (cb)=>{
            subscribers.add(cb);
            return ()=>{
                subscribers.delete(cb);
            };
        },
        push: (path, state, navigateOpts)=>{
            const currentIndex = location.state[$25337af3e53bf641$var$stateIndexKey];
            state = $25337af3e53bf641$var$assignKeyAndIndex(currentIndex + 1, state);
            tryNavigation({
                task: ()=>{
                    opts.pushState(path, state);
                    notify({
                        type: "PUSH"
                    });
                },
                navigateOpts: navigateOpts,
                type: "PUSH",
                path: path,
                state: state
            });
        },
        replace: (path, state, navigateOpts)=>{
            const currentIndex = location.state[$25337af3e53bf641$var$stateIndexKey];
            state = $25337af3e53bf641$var$assignKeyAndIndex(currentIndex, state);
            tryNavigation({
                task: ()=>{
                    opts.replaceState(path, state);
                    notify({
                        type: "REPLACE"
                    });
                },
                navigateOpts: navigateOpts,
                type: "REPLACE",
                path: path,
                state: state
            });
        },
        go: (index, navigateOpts)=>{
            tryNavigation({
                task: ()=>{
                    opts.go(index);
                    handleIndexChange({
                        type: "GO",
                        index: index
                    });
                },
                navigateOpts: navigateOpts,
                type: "GO"
            });
        },
        back: (navigateOpts)=>{
            tryNavigation({
                task: ()=>{
                    opts.back((navigateOpts == null ? void 0 : navigateOpts.ignoreBlocker) ?? false);
                    handleIndexChange({
                        type: "BACK"
                    });
                },
                navigateOpts: navigateOpts,
                type: "BACK"
            });
        },
        forward: (navigateOpts)=>{
            tryNavigation({
                task: ()=>{
                    opts.forward((navigateOpts == null ? void 0 : navigateOpts.ignoreBlocker) ?? false);
                    handleIndexChange({
                        type: "FORWARD"
                    });
                },
                navigateOpts: navigateOpts,
                type: "FORWARD"
            });
        },
        canGoBack: ()=>location.state[$25337af3e53bf641$var$stateIndexKey] !== 0,
        createHref: (str)=>opts.createHref(str),
        block: (blocker)=>{
            var _a;
            if (!opts.setBlockers) return ()=>{};
            const blockers = ((_a = opts.getBlockers) == null ? void 0 : _a.call(opts)) ?? [];
            opts.setBlockers([
                ...blockers,
                blocker
            ]);
            return ()=>{
                var _a2, _b;
                const blockers2 = ((_a2 = opts.getBlockers) == null ? void 0 : _a2.call(opts)) ?? [];
                (_b = opts.setBlockers) == null || _b.call(opts, blockers2.filter((b)=>b !== blocker));
            };
        },
        flush: ()=>{
            var _a;
            return (_a = opts.flush) == null ? void 0 : _a.call(opts);
        },
        destroy: ()=>{
            var _a;
            return (_a = opts.destroy) == null ? void 0 : _a.call(opts);
        },
        notify: notify
    };
}
function $25337af3e53bf641$var$assignKeyAndIndex(index, state) {
    if (!state) state = {};
    return {
        ...state,
        key: $25337af3e53bf641$var$createRandomKey(),
        [$25337af3e53bf641$var$stateIndexKey]: index
    };
}
function $25337af3e53bf641$export$719fc203c4e16dee(opts) {
    var _a;
    const win = (opts == null ? void 0 : opts.window) ?? (typeof document !== "undefined" ? window : void 0);
    const originalPushState = win.history.pushState;
    const originalReplaceState = win.history.replaceState;
    let blockers = [];
    const _getBlockers = ()=>blockers;
    const _setBlockers = (newBlockers)=>blockers = newBlockers;
    const createHref = (opts == null ? void 0 : opts.createHref) ?? ((path)=>path);
    const parseLocation = (opts == null ? void 0 : opts.parseLocation) ?? (()=>$25337af3e53bf641$export$c68fd8c8a50e78e(`${win.location.pathname}${win.location.search}${win.location.hash}`, win.history.state));
    if (!((_a = win.history.state) == null ? void 0 : _a.key)) win.history.replaceState({
        [$25337af3e53bf641$var$stateIndexKey]: 0,
        key: $25337af3e53bf641$var$createRandomKey()
    }, "");
    let currentLocation = parseLocation();
    let rollbackLocation;
    let nextPopIsGo = false;
    let ignoreNextPop = false;
    let skipBlockerNextPop = false;
    let ignoreNextBeforeUnload = false;
    const getLocation = ()=>currentLocation;
    let next;
    let scheduled;
    const flush = ()=>{
        if (!next) return;
        history._ignoreSubscribers = true;
        (next.isPush ? win.history.pushState : win.history.replaceState)(next.state, "", next.href);
        history._ignoreSubscribers = false;
        next = void 0;
        scheduled = void 0;
        rollbackLocation = void 0;
    };
    const queueHistoryAction = (type, destHref, state)=>{
        const href = createHref(destHref);
        if (!scheduled) rollbackLocation = currentLocation;
        currentLocation = $25337af3e53bf641$export$c68fd8c8a50e78e(destHref, state);
        next = {
            href: href,
            state: state,
            isPush: (next == null ? void 0 : next.isPush) || type === "push"
        };
        if (!scheduled) scheduled = Promise.resolve().then(()=>flush());
    };
    const onPushPop = (type)=>{
        currentLocation = parseLocation();
        history.notify({
            type: type
        });
    };
    const onPushPopEvent = async ()=>{
        if (ignoreNextPop) {
            ignoreNextPop = false;
            return;
        }
        const nextLocation = parseLocation();
        const delta = nextLocation.state[$25337af3e53bf641$var$stateIndexKey] - currentLocation.state[$25337af3e53bf641$var$stateIndexKey];
        const isForward = delta === 1;
        const isBack = delta === -1;
        const isGo = !isForward && !isBack || nextPopIsGo;
        nextPopIsGo = false;
        const action = isGo ? "GO" : isBack ? "BACK" : "FORWARD";
        const notify = isGo ? {
            type: "GO",
            index: delta
        } : {
            type: isBack ? "BACK" : "FORWARD"
        };
        if (skipBlockerNextPop) skipBlockerNextPop = false;
        else {
            const blockers2 = _getBlockers();
            if (typeof document !== "undefined" && blockers2.length) for (const blocker of blockers2){
                const isBlocked = await blocker.blockerFn({
                    currentLocation: currentLocation,
                    nextLocation: nextLocation,
                    action: action
                });
                if (isBlocked) {
                    ignoreNextPop = true;
                    win.history.go(1);
                    history.notify(notify);
                    return;
                }
            }
        }
        currentLocation = parseLocation();
        history.notify(notify);
    };
    const onBeforeUnload = (e)=>{
        if (ignoreNextBeforeUnload) {
            ignoreNextBeforeUnload = false;
            return;
        }
        let shouldBlock = false;
        const blockers2 = _getBlockers();
        if (typeof document !== "undefined" && blockers2.length) for (const blocker of blockers2){
            const shouldHaveBeforeUnload = blocker.enableBeforeUnload ?? true;
            if (shouldHaveBeforeUnload === true) {
                shouldBlock = true;
                break;
            }
            if (typeof shouldHaveBeforeUnload === "function" && shouldHaveBeforeUnload() === true) {
                shouldBlock = true;
                break;
            }
        }
        if (shouldBlock) {
            e.preventDefault();
            return e.returnValue = "";
        }
        return;
    };
    const history = $25337af3e53bf641$export$4178d7ac16e6cf7c({
        getLocation: getLocation,
        getLength: ()=>win.history.length,
        pushState: (href, state)=>queueHistoryAction("push", href, state),
        replaceState: (href, state)=>queueHistoryAction("replace", href, state),
        back: (ignoreBlocker)=>{
            if (ignoreBlocker) skipBlockerNextPop = true;
            ignoreNextBeforeUnload = true;
            return win.history.back();
        },
        forward: (ignoreBlocker)=>{
            if (ignoreBlocker) skipBlockerNextPop = true;
            ignoreNextBeforeUnload = true;
            win.history.forward();
        },
        go: (n)=>{
            nextPopIsGo = true;
            win.history.go(n);
        },
        createHref: (href)=>createHref(href),
        flush: flush,
        destroy: ()=>{
            win.history.pushState = originalPushState;
            win.history.replaceState = originalReplaceState;
            win.removeEventListener($25337af3e53bf641$var$beforeUnloadEvent, onBeforeUnload, {
                capture: true
            });
            win.removeEventListener($25337af3e53bf641$var$popStateEvent, onPushPopEvent);
        },
        onBlocked: ()=>{
            if (rollbackLocation && currentLocation !== rollbackLocation) currentLocation = rollbackLocation;
        },
        getBlockers: _getBlockers,
        setBlockers: _setBlockers,
        notifyOnIndexChange: false
    });
    win.addEventListener($25337af3e53bf641$var$beforeUnloadEvent, onBeforeUnload, {
        capture: true
    });
    win.addEventListener($25337af3e53bf641$var$popStateEvent, onPushPopEvent);
    win.history.pushState = function(...args) {
        const res = originalPushState.apply(win.history, args);
        if (!history._ignoreSubscribers) onPushPop("PUSH");
        return res;
    };
    win.history.replaceState = function(...args) {
        const res = originalReplaceState.apply(win.history, args);
        if (!history._ignoreSubscribers) onPushPop("REPLACE");
        return res;
    };
    return history;
}
function $25337af3e53bf641$export$b71fdd3798280242(opts) {
    const win = (opts == null ? void 0 : opts.window) ?? (typeof document !== "undefined" ? window : void 0);
    return $25337af3e53bf641$export$719fc203c4e16dee({
        window: win,
        parseLocation: ()=>{
            const hashHref = win.location.hash.split("#").slice(1).join("#") ?? "/";
            return $25337af3e53bf641$export$c68fd8c8a50e78e(hashHref, win.history.state);
        },
        createHref: (href)=>`${win.location.pathname}${win.location.search}#${href}`
    });
}
function $25337af3e53bf641$export$2b76ad033c6e6d08(opts = {
    initialEntries: [
        "/"
    ]
}) {
    const entries = opts.initialEntries;
    let index = opts.initialIndex ? Math.min(Math.max(opts.initialIndex, 0), entries.length - 1) : entries.length - 1;
    const states = entries.map((_entry, index2)=>$25337af3e53bf641$var$assignKeyAndIndex(index2, void 0));
    const getLocation = ()=>$25337af3e53bf641$export$c68fd8c8a50e78e(entries[index], states[index]);
    return $25337af3e53bf641$export$4178d7ac16e6cf7c({
        getLocation: getLocation,
        getLength: ()=>entries.length,
        pushState: (path, state)=>{
            if (index < entries.length - 1) {
                entries.splice(index + 1);
                states.splice(index + 1);
            }
            states.push(state);
            entries.push(path);
            index = Math.max(entries.length - 1, 0);
        },
        replaceState: (path, state)=>{
            states[index] = state;
            entries[index] = path;
        },
        back: ()=>{
            index = Math.max(index - 1, 0);
        },
        forward: ()=>{
            index = Math.min(index + 1, entries.length - 1);
        },
        go: (n)=>{
            index = Math.min(Math.max(index + n, 0), entries.length - 1);
        },
        createHref: (path)=>path
    });
}
function $25337af3e53bf641$export$c68fd8c8a50e78e(href, state) {
    const hashIndex = href.indexOf("#");
    const searchIndex = href.indexOf("?");
    return {
        href: href,
        pathname: href.substring(0, hashIndex > 0 ? searchIndex > 0 ? Math.min(hashIndex, searchIndex) : hashIndex : searchIndex > 0 ? searchIndex : href.length),
        hash: hashIndex > -1 ? href.substring(hashIndex) : "",
        search: searchIndex > -1 ? href.slice(searchIndex, hashIndex === -1 ? void 0 : hashIndex) : "",
        state: state || {
            [$25337af3e53bf641$var$stateIndexKey]: 0,
            key: $25337af3e53bf641$var$createRandomKey()
        }
    };
}
function $25337af3e53bf641$var$createRandomKey() {
    return (Math.random() + 1).toString(36).substring(7);
}

});

parcelRegister("9AyUq", function(module, exports) {

$parcel$export(module.exports, "__storeToDerived", function () { return $6fb28e11efef15b4$export$9ea173589b25e8f7; });
$parcel$export(module.exports, "__derivedToStore", function () { return $6fb28e11efef15b4$export$2c0006798420b80d; });
$parcel$export(module.exports, "__flush", function () { return $6fb28e11efef15b4$export$d16108b43947c855; });
$parcel$export(module.exports, "batch", function () { return $6fb28e11efef15b4$export$712ea50be43a7858; });

var $2wp7Q = parcelRequire("2wp7Q");
const $6fb28e11efef15b4$export$9ea173589b25e8f7 = /* @__PURE__ */ new WeakMap();
const $6fb28e11efef15b4$export$2c0006798420b80d = /* @__PURE__ */ new WeakMap();
const $6fb28e11efef15b4$export$51a293a41f5b4b6e = {
    current: []
};
let $6fb28e11efef15b4$var$__isFlushing = false;
let $6fb28e11efef15b4$var$__batchDepth = 0;
const $6fb28e11efef15b4$var$__pendingUpdates = /* @__PURE__ */ new Set();
const $6fb28e11efef15b4$var$__initialBatchValues = /* @__PURE__ */ new Map();
function $6fb28e11efef15b4$var$__flush_internals(relatedVals) {
    const sorted = Array.from(relatedVals).sort((a, b)=>{
        if (a instanceof (0, $2wp7Q.Derived) && a.options.deps.includes(b)) return 1;
        if (b instanceof (0, $2wp7Q.Derived) && b.options.deps.includes(a)) return -1;
        return 0;
    });
    for (const derived of sorted){
        if ($6fb28e11efef15b4$export$51a293a41f5b4b6e.current.includes(derived)) continue;
        $6fb28e11efef15b4$export$51a293a41f5b4b6e.current.push(derived);
        derived.recompute();
        const stores = $6fb28e11efef15b4$export$2c0006798420b80d.get(derived);
        if (stores) for (const store of stores){
            const relatedLinkedDerivedVals = $6fb28e11efef15b4$export$9ea173589b25e8f7.get(store);
            if (!relatedLinkedDerivedVals) continue;
            $6fb28e11efef15b4$var$__flush_internals(relatedLinkedDerivedVals);
        }
    }
}
function $6fb28e11efef15b4$var$__notifyListeners(store) {
    store.listeners.forEach((listener)=>listener({
            prevVal: store.prevState,
            currentVal: store.state
        }));
}
function $6fb28e11efef15b4$var$__notifyDerivedListeners(derived) {
    derived.listeners.forEach((listener)=>listener({
            prevVal: derived.prevState,
            currentVal: derived.state
        }));
}
function $6fb28e11efef15b4$export$d16108b43947c855(store) {
    if ($6fb28e11efef15b4$var$__batchDepth > 0 && !$6fb28e11efef15b4$var$__initialBatchValues.has(store)) $6fb28e11efef15b4$var$__initialBatchValues.set(store, store.prevState);
    $6fb28e11efef15b4$var$__pendingUpdates.add(store);
    if ($6fb28e11efef15b4$var$__batchDepth > 0) return;
    if ($6fb28e11efef15b4$var$__isFlushing) return;
    try {
        $6fb28e11efef15b4$var$__isFlushing = true;
        while($6fb28e11efef15b4$var$__pendingUpdates.size > 0){
            const stores = Array.from($6fb28e11efef15b4$var$__pendingUpdates);
            $6fb28e11efef15b4$var$__pendingUpdates.clear();
            for (const store2 of stores){
                const prevState = $6fb28e11efef15b4$var$__initialBatchValues.get(store2) ?? store2.prevState;
                store2.prevState = prevState;
                $6fb28e11efef15b4$var$__notifyListeners(store2);
            }
            for (const store2 of stores){
                const derivedVals = $6fb28e11efef15b4$export$9ea173589b25e8f7.get(store2);
                if (!derivedVals) continue;
                $6fb28e11efef15b4$export$51a293a41f5b4b6e.current.push(store2);
                $6fb28e11efef15b4$var$__flush_internals(derivedVals);
            }
            for (const store2 of stores){
                const derivedVals = $6fb28e11efef15b4$export$9ea173589b25e8f7.get(store2);
                if (!derivedVals) continue;
                for (const derived of derivedVals)$6fb28e11efef15b4$var$__notifyDerivedListeners(derived);
            }
        }
    } finally{
        $6fb28e11efef15b4$var$__isFlushing = false;
        $6fb28e11efef15b4$export$51a293a41f5b4b6e.current = [];
        $6fb28e11efef15b4$var$__initialBatchValues.clear();
    }
}
function $6fb28e11efef15b4$export$712ea50be43a7858(fn) {
    $6fb28e11efef15b4$var$__batchDepth++;
    try {
        fn();
    } finally{
        $6fb28e11efef15b4$var$__batchDepth--;
        if ($6fb28e11efef15b4$var$__batchDepth === 0) {
            const pendingUpdateToFlush = Array.from($6fb28e11efef15b4$var$__pendingUpdates)[0];
            if (pendingUpdateToFlush) $6fb28e11efef15b4$export$d16108b43947c855(pendingUpdateToFlush);
        }
    }
}

});
parcelRegister("2wp7Q", function(module, exports) {

$parcel$export(module.exports, "Derived", function () { return $1d620f5b3a002bd2$export$2c3752e51f317165; });

var $9PfBl = parcelRequire("9PfBl");

var $9AyUq = parcelRequire("9AyUq");
class $1d620f5b3a002bd2$export$2c3752e51f317165 {
    constructor(options){
        this.listeners = /* @__PURE__ */ new Set();
        this._subscriptions = [];
        this.lastSeenDepValues = [];
        this.getDepVals = ()=>{
            const prevDepVals = [];
            const currDepVals = [];
            for (const dep of this.options.deps){
                prevDepVals.push(dep.prevState);
                currDepVals.push(dep.state);
            }
            this.lastSeenDepValues = currDepVals;
            return {
                prevDepVals: prevDepVals,
                currDepVals: currDepVals,
                prevVal: this.prevState ?? void 0
            };
        };
        this.recompute = ()=>{
            var _a, _b;
            this.prevState = this.state;
            const { prevDepVals: prevDepVals, currDepVals: currDepVals, prevVal: prevVal } = this.getDepVals();
            this.state = this.options.fn({
                prevDepVals: prevDepVals,
                currDepVals: currDepVals,
                prevVal: prevVal
            });
            (_b = (_a = this.options).onUpdate) == null || _b.call(_a);
        };
        this.checkIfRecalculationNeededDeeply = ()=>{
            for (const dep of this.options.deps)if (dep instanceof $1d620f5b3a002bd2$export$2c3752e51f317165) dep.checkIfRecalculationNeededDeeply();
            let shouldRecompute = false;
            const lastSeenDepValues = this.lastSeenDepValues;
            const { currDepVals: currDepVals } = this.getDepVals();
            for(let i = 0; i < currDepVals.length; i++)if (currDepVals[i] !== lastSeenDepValues[i]) {
                shouldRecompute = true;
                break;
            }
            if (shouldRecompute) this.recompute();
        };
        this.mount = ()=>{
            this.registerOnGraph();
            this.checkIfRecalculationNeededDeeply();
            return ()=>{
                this.unregisterFromGraph();
                for (const cleanup of this._subscriptions)cleanup();
            };
        };
        this.subscribe = (listener)=>{
            var _a, _b;
            this.listeners.add(listener);
            const unsub = (_b = (_a = this.options).onSubscribe) == null ? void 0 : _b.call(_a, listener, this);
            return ()=>{
                this.listeners.delete(listener);
                unsub == null || unsub();
            };
        };
        this.options = options;
        this.state = options.fn({
            prevDepVals: void 0,
            prevVal: void 0,
            currDepVals: this.getDepVals().currDepVals
        });
    }
    registerOnGraph(deps = this.options.deps) {
        for (const dep of deps){
            if (dep instanceof $1d620f5b3a002bd2$export$2c3752e51f317165) {
                dep.registerOnGraph();
                this.registerOnGraph(dep.options.deps);
            } else if (dep instanceof (0, $9PfBl.Store)) {
                let relatedLinkedDerivedVals = (0, $9AyUq.__storeToDerived).get(dep);
                if (!relatedLinkedDerivedVals) {
                    relatedLinkedDerivedVals = /* @__PURE__ */ new Set();
                    (0, $9AyUq.__storeToDerived).set(dep, relatedLinkedDerivedVals);
                }
                relatedLinkedDerivedVals.add(this);
                let relatedStores = (0, $9AyUq.__derivedToStore).get(this);
                if (!relatedStores) {
                    relatedStores = /* @__PURE__ */ new Set();
                    (0, $9AyUq.__derivedToStore).set(this, relatedStores);
                }
                relatedStores.add(dep);
            }
        }
    }
    unregisterFromGraph(deps = this.options.deps) {
        for (const dep of deps){
            if (dep instanceof $1d620f5b3a002bd2$export$2c3752e51f317165) this.unregisterFromGraph(dep.options.deps);
            else if (dep instanceof (0, $9PfBl.Store)) {
                const relatedLinkedDerivedVals = (0, $9AyUq.__storeToDerived).get(dep);
                if (relatedLinkedDerivedVals) relatedLinkedDerivedVals.delete(this);
                const relatedStores = (0, $9AyUq.__derivedToStore).get(this);
                if (relatedStores) relatedStores.delete(dep);
            }
        }
    }
}

});
parcelRegister("9PfBl", function(module, exports) {

$parcel$export(module.exports, "Store", function () { return $7274fa8e4a941918$export$390f32400eaf98c9; });

var $9AyUq = parcelRequire("9AyUq");
class $7274fa8e4a941918$export$390f32400eaf98c9 {
    constructor(initialState, options){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = (listener)=>{
            var _a, _b;
            this.listeners.add(listener);
            const unsub = (_b = (_a = this.options) == null ? void 0 : _a.onSubscribe) == null ? void 0 : _b.call(_a, listener, this);
            return ()=>{
                this.listeners.delete(listener);
                unsub == null || unsub();
            };
        };
        this.setState = (updater)=>{
            var _a, _b, _c;
            this.prevState = this.state;
            this.state = ((_a = this.options) == null ? void 0 : _a.updateFn) ? this.options.updateFn(this.prevState)(updater) : updater(this.prevState);
            (_c = (_b = this.options) == null ? void 0 : _b.onUpdate) == null || _c.call(_b);
            (0, $9AyUq.__flush)(this);
        };
        this.prevState = initialState;
        this.state = initialState;
        this.options = options;
    }
}

});



parcelRegister("9GFyS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01d1f09f2e392dd8$export$2e2bcd8739ae039; });
var $01d1f09f2e392dd8$var$isProduction = true;
var $01d1f09f2e392dd8$var$prefix = "Invariant failed";
function $01d1f09f2e392dd8$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($01d1f09f2e392dd8$var$isProduction) throw new Error($01d1f09f2e392dd8$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($01d1f09f2e392dd8$var$prefix, ": ").concat(provided) : $01d1f09f2e392dd8$var$prefix;
    throw new Error(value);
}

});

parcelRegister("2oA9E", function(module, exports) {

$parcel$export(module.exports, "joinPaths", function () { return $1be9de39046355ad$export$86d9a7913e44197e; });
$parcel$export(module.exports, "cleanPath", function () { return $1be9de39046355ad$export$b7c632328822445d; });
$parcel$export(module.exports, "trimPathLeft", function () { return $1be9de39046355ad$export$47150f29cd1fb3ae; });
$parcel$export(module.exports, "trimPathRight", function () { return $1be9de39046355ad$export$a33f08202c373623; });
$parcel$export(module.exports, "trimPath", function () { return $1be9de39046355ad$export$b86b8b1e0778ce3f; });
$parcel$export(module.exports, "removeTrailingSlash", function () { return $1be9de39046355ad$export$b6d465111d914331; });
$parcel$export(module.exports, "exactPathTest", function () { return $1be9de39046355ad$export$c2ef510b203b107f; });
$parcel$export(module.exports, "resolvePath", function () { return $1be9de39046355ad$export$b09f2ff0bbcb43c7; });
$parcel$export(module.exports, "parsePathname", function () { return $1be9de39046355ad$export$7fafb205ecc26684; });
$parcel$export(module.exports, "interpolatePath", function () { return $1be9de39046355ad$export$8ca4fd5908a217f6; });
$parcel$export(module.exports, "matchPathname", function () { return $1be9de39046355ad$export$b71b01274a8bb9ec; });

var $bypHT = parcelRequire("bypHT");
function $1be9de39046355ad$export$86d9a7913e44197e(paths) {
    return $1be9de39046355ad$export$b7c632328822445d(paths.filter((val)=>{
        return val !== void 0;
    }).join("/"));
}
function $1be9de39046355ad$export$b7c632328822445d(path) {
    return path.replace(/\/{2,}/g, "/");
}
function $1be9de39046355ad$export$47150f29cd1fb3ae(path) {
    return path === "/" ? path : path.replace(/^\/{1,}/, "");
}
function $1be9de39046355ad$export$a33f08202c373623(path) {
    return path === "/" ? path : path.replace(/\/{1,}$/, "");
}
function $1be9de39046355ad$export$b86b8b1e0778ce3f(path) {
    return $1be9de39046355ad$export$a33f08202c373623($1be9de39046355ad$export$47150f29cd1fb3ae(path));
}
function $1be9de39046355ad$export$b6d465111d914331(value, basepath) {
    if (value.endsWith("/") && value !== "/" && value !== `${basepath}/`) return value.slice(0, -1);
    return value;
}
function $1be9de39046355ad$export$c2ef510b203b107f(pathName1, pathName2, basepath) {
    return $1be9de39046355ad$export$b6d465111d914331(pathName1, basepath) === $1be9de39046355ad$export$b6d465111d914331(pathName2, basepath);
}
function $1be9de39046355ad$export$b09f2ff0bbcb43c7({ basepath: basepath, base: base, to: to, trailingSlash: trailingSlash = "never", caseSensitive: caseSensitive }) {
    var _a, _b;
    base = $1be9de39046355ad$export$544e093309626785(basepath, base, caseSensitive);
    to = $1be9de39046355ad$export$544e093309626785(basepath, to, caseSensitive);
    let baseSegments = $1be9de39046355ad$export$7fafb205ecc26684(base);
    const toSegments = $1be9de39046355ad$export$7fafb205ecc26684(to);
    if (baseSegments.length > 1 && ((_a = (0, $bypHT.last)(baseSegments)) == null ? void 0 : _a.value) === "/") baseSegments.pop();
    toSegments.forEach((toSegment, index)=>{
        if (toSegment.value === "/") {
            if (!index) baseSegments = [
                toSegment
            ];
            else if (index === toSegments.length - 1) baseSegments.push(toSegment);
        } else if (toSegment.value === "..") baseSegments.pop();
        else if (toSegment.value === ".") ;
        else baseSegments.push(toSegment);
    });
    if (baseSegments.length > 1) {
        if (((_b = (0, $bypHT.last)(baseSegments)) == null ? void 0 : _b.value) === "/") {
            if (trailingSlash === "never") baseSegments.pop();
        } else if (trailingSlash === "always") baseSegments.push({
            type: "pathname",
            value: "/"
        });
    }
    const joined = $1be9de39046355ad$export$86d9a7913e44197e([
        basepath,
        ...baseSegments.map((d)=>d.value)
    ]);
    return $1be9de39046355ad$export$b7c632328822445d(joined);
}
function $1be9de39046355ad$export$7fafb205ecc26684(pathname) {
    if (!pathname) return [];
    pathname = $1be9de39046355ad$export$b7c632328822445d(pathname);
    const segments = [];
    if (pathname.slice(0, 1) === "/") {
        pathname = pathname.substring(1);
        segments.push({
            type: "pathname",
            value: "/"
        });
    }
    if (!pathname) return segments;
    const split = pathname.split("/").filter(Boolean);
    segments.push(...split.map((part)=>{
        if (part === "$" || part === "*") return {
            type: "wildcard",
            value: part
        };
        if (part.charAt(0) === "$") return {
            type: "param",
            value: part
        };
        return {
            type: "pathname",
            value: decodeURI(part)
        };
    }));
    if (pathname.slice(-1) === "/") {
        pathname = pathname.substring(1);
        segments.push({
            type: "pathname",
            value: "/"
        });
    }
    return segments;
}
function $1be9de39046355ad$export$8ca4fd5908a217f6({ path: path, params: params, leaveWildcards: leaveWildcards, leaveParams: leaveParams, decodeCharMap: decodeCharMap }) {
    const interpolatedPathSegments = $1be9de39046355ad$export$7fafb205ecc26684(path);
    function encodeParam(key) {
        const value = params[key];
        const isValueString = typeof value === "string";
        if ([
            "*",
            "_splat"
        ].includes(key)) return isValueString ? encodeURI(value) : value;
        else return isValueString ? $1be9de39046355ad$var$encodePathParam(value, decodeCharMap) : value;
    }
    const usedParams = {};
    const interpolatedPath = $1be9de39046355ad$export$86d9a7913e44197e(interpolatedPathSegments.map((segment)=>{
        if (segment.type === "wildcard") {
            usedParams._splat = params._splat;
            const value = encodeParam("_splat");
            if (leaveWildcards) return `${segment.value}${value ?? ""}`;
            return value;
        }
        if (segment.type === "param") {
            const key = segment.value.substring(1);
            usedParams[key] = params[key];
            if (leaveParams) {
                const value = encodeParam(segment.value);
                return `${segment.value}${value ?? ""}`;
            }
            return encodeParam(key) ?? "undefined";
        }
        return segment.value;
    }));
    return {
        usedParams: usedParams,
        interpolatedPath: interpolatedPath
    };
}
function $1be9de39046355ad$var$encodePathParam(value, decodeCharMap) {
    let encoded = encodeURIComponent(value);
    if (decodeCharMap) for (const [encodedChar, char] of decodeCharMap)encoded = encoded.replaceAll(encodedChar, char);
    return encoded;
}
function $1be9de39046355ad$export$b71b01274a8bb9ec(basepath, currentPathname, matchLocation) {
    const pathParams = $1be9de39046355ad$export$75c4533b77b2c7d6(basepath, currentPathname, matchLocation);
    if (matchLocation.to && !pathParams) return;
    return pathParams ?? {};
}
function $1be9de39046355ad$export$544e093309626785(basepath, pathname, caseSensitive = false) {
    const normalizedBasepath = caseSensitive ? basepath : basepath.toLowerCase();
    const normalizedPathname = caseSensitive ? pathname : pathname.toLowerCase();
    switch(true){
        // default behaviour is to serve app from the root - pathname
        // left untouched
        case normalizedBasepath === "/":
            return pathname;
        // shortcut for removing the basepath if it matches the pathname
        case normalizedPathname === normalizedBasepath:
            return "";
        // in case pathname is shorter than basepath - there is
        // nothing to remove
        case pathname.length < basepath.length:
            return pathname;
        // avoid matching partial segments - strict equality handled
        // earlier, otherwise, basepath separated from pathname with
        // separator, therefore lack of separator means partial
        // segment match (`/app` should not match `/application`)
        case normalizedPathname[normalizedBasepath.length] !== "/":
            return pathname;
        // remove the basepath from the pathname if it starts with it
        case normalizedPathname.startsWith(normalizedBasepath):
            return pathname.slice(basepath.length);
        // otherwise, return the pathname as is
        default:
            return pathname;
    }
}
function $1be9de39046355ad$export$75c4533b77b2c7d6(basepath, from, matchLocation) {
    if (basepath !== "/" && !from.startsWith(basepath)) return void 0;
    from = $1be9de39046355ad$export$544e093309626785(basepath, from, matchLocation.caseSensitive);
    const to = $1be9de39046355ad$export$544e093309626785(basepath, `${matchLocation.to ?? "$"}`, matchLocation.caseSensitive);
    const baseSegments = $1be9de39046355ad$export$7fafb205ecc26684(from);
    const routeSegments = $1be9de39046355ad$export$7fafb205ecc26684(to);
    if (!from.startsWith("/")) baseSegments.unshift({
        type: "pathname",
        value: "/"
    });
    if (!to.startsWith("/")) routeSegments.unshift({
        type: "pathname",
        value: "/"
    });
    const params = {};
    const isMatch = (()=>{
        for(let i = 0; i < Math.max(baseSegments.length, routeSegments.length); i++){
            const baseSegment = baseSegments[i];
            const routeSegment = routeSegments[i];
            const isLastBaseSegment = i >= baseSegments.length - 1;
            const isLastRouteSegment = i >= routeSegments.length - 1;
            if (routeSegment) {
                if (routeSegment.type === "wildcard") {
                    const _splat = decodeURI($1be9de39046355ad$export$86d9a7913e44197e(baseSegments.slice(i).map((d)=>d.value)));
                    params["*"] = _splat;
                    params["_splat"] = _splat;
                    return true;
                }
                if (routeSegment.type === "pathname") {
                    if (routeSegment.value === "/" && !(baseSegment == null ? void 0 : baseSegment.value)) return true;
                    if (baseSegment) {
                        if (matchLocation.caseSensitive) {
                            if (routeSegment.value !== baseSegment.value) return false;
                        } else if (routeSegment.value.toLowerCase() !== baseSegment.value.toLowerCase()) return false;
                    }
                }
                if (!baseSegment) return false;
                if (routeSegment.type === "param") {
                    if (baseSegment.value === "/") return false;
                    if (baseSegment.value.charAt(0) !== "$") params[routeSegment.value.substring(1)] = decodeURIComponent(baseSegment.value);
                }
            }
            if (!isLastBaseSegment && isLastRouteSegment) {
                params["**"] = $1be9de39046355ad$export$86d9a7913e44197e(baseSegments.slice(i + 1).map((d)=>d.value));
                return !!matchLocation.fuzzy && (routeSegment == null ? void 0 : routeSegment.value) !== "/";
            }
        }
        return true;
    })();
    return isMatch ? params : void 0;
}

});
parcelRegister("bypHT", function(module, exports) {

$parcel$export(module.exports, "last", function () { return $8696cf8fe830d4c4$export$4c7897fafd92b108; });
$parcel$export(module.exports, "functionalUpdate", function () { return $8696cf8fe830d4c4$export$7f095f455ad5af3f; });
$parcel$export(module.exports, "pick", function () { return $8696cf8fe830d4c4$export$357523c63a2253b9; });
$parcel$export(module.exports, "replaceEqualDeep", function () { return $8696cf8fe830d4c4$export$77a71fc411098696; });
$parcel$export(module.exports, "deepEqual", function () { return $8696cf8fe830d4c4$export$9cb4719e2e525b7a; });
$parcel$export(module.exports, "createControlledPromise", function () { return $8696cf8fe830d4c4$export$3a6d79ef8ea1e9fd; });
$parcel$export(module.exports, "hasUriEncodedChars", function () { return $8696cf8fe830d4c4$export$bbcd8d1a495e51e2; });
function $8696cf8fe830d4c4$export$4c7897fafd92b108(arr) {
    return arr[arr.length - 1];
}
function $8696cf8fe830d4c4$var$isFunction(d) {
    return typeof d === "function";
}
function $8696cf8fe830d4c4$export$7f095f455ad5af3f(updater, previous) {
    if ($8696cf8fe830d4c4$var$isFunction(updater)) return updater(previous);
    return updater;
}
function $8696cf8fe830d4c4$export$357523c63a2253b9(parent, keys) {
    return keys.reduce((obj, key)=>{
        obj[key] = parent[key];
        return obj;
    }, {});
}
function $8696cf8fe830d4c4$export$77a71fc411098696(prev, _next) {
    if (prev === _next) return prev;
    const next = _next;
    const array = $8696cf8fe830d4c4$export$7a8558113332b71e(prev) && $8696cf8fe830d4c4$export$7a8558113332b71e(next);
    if (array || $8696cf8fe830d4c4$export$53b83ca8eaab0383(prev) && $8696cf8fe830d4c4$export$53b83ca8eaab0383(next)) {
        const prevItems = array ? prev : Object.keys(prev);
        const prevSize = prevItems.length;
        const nextItems = array ? next : Object.keys(next);
        const nextSize = nextItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < nextSize; i++){
            const key = array ? i : nextItems[i];
            if ((!array && prevItems.includes(key) || array) && prev[key] === void 0 && next[key] === void 0) {
                copy[key] = void 0;
                equalItems++;
            } else {
                copy[key] = $8696cf8fe830d4c4$export$77a71fc411098696(prev[key], next[key]);
                if (copy[key] === prev[key] && prev[key] !== void 0) equalItems++;
            }
        }
        return prevSize === nextSize && equalItems === prevSize ? prev : copy;
    }
    return next;
}
function $8696cf8fe830d4c4$export$53b83ca8eaab0383(o) {
    if (!$8696cf8fe830d4c4$var$hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (typeof ctor === "undefined") return true;
    const prot = ctor.prototype;
    if (!$8696cf8fe830d4c4$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    return true;
}
function $8696cf8fe830d4c4$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $8696cf8fe830d4c4$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function $8696cf8fe830d4c4$var$getObjectKeys(obj, ignoreUndefined) {
    let keys = Object.keys(obj);
    if (ignoreUndefined) keys = keys.filter((key)=>obj[key] !== void 0);
    return keys;
}
function $8696cf8fe830d4c4$export$9cb4719e2e525b7a(a, b, opts) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if ($8696cf8fe830d4c4$export$53b83ca8eaab0383(a) && $8696cf8fe830d4c4$export$53b83ca8eaab0383(b)) {
        const ignoreUndefined = (opts == null ? void 0 : opts.ignoreUndefined) ?? true;
        const aKeys = $8696cf8fe830d4c4$var$getObjectKeys(a, ignoreUndefined);
        const bKeys = $8696cf8fe830d4c4$var$getObjectKeys(b, ignoreUndefined);
        if (!(opts == null ? void 0 : opts.partial) && aKeys.length !== bKeys.length) return false;
        return bKeys.every((key)=>$8696cf8fe830d4c4$export$9cb4719e2e525b7a(a[key], b[key], opts));
    }
    if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length) return false;
        return !a.some((item, index)=>!$8696cf8fe830d4c4$export$9cb4719e2e525b7a(item, b[index], opts));
    }
    return false;
}
function $8696cf8fe830d4c4$export$3a6d79ef8ea1e9fd(onResolve) {
    let resolveLoadPromise;
    let rejectLoadPromise;
    const controlledPromise = new Promise((resolve, reject)=>{
        resolveLoadPromise = resolve;
        rejectLoadPromise = reject;
    });
    controlledPromise.status = "pending";
    controlledPromise.resolve = (value)=>{
        controlledPromise.status = "resolved";
        controlledPromise.value = value;
        resolveLoadPromise(value);
        onResolve == null || onResolve(value);
    };
    controlledPromise.reject = (e)=>{
        controlledPromise.status = "rejected";
        rejectLoadPromise(e);
    };
    return controlledPromise;
}
function $8696cf8fe830d4c4$export$2ae35b2f7ca3bb70(jsonString) {
    return jsonString.replace(/\\/g, "\\\\").replace(/'/g, "\\'").replace(/"/g, '\\"');
}
function $8696cf8fe830d4c4$export$26c89aaec4eb1d2e(objA, objB) {
    if (Object.is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    if (keysA.length !== Object.keys(objB).length) return false;
    for (const item of keysA){
        if (!Object.prototype.hasOwnProperty.call(objB, item) || !Object.is(objA[item], objB[item])) return false;
    }
    return true;
}
function $8696cf8fe830d4c4$export$bbcd8d1a495e51e2(inputString) {
    const pattern = /%[0-9A-Fa-f]{2}/;
    return pattern.test(inputString);
}

});


parcelRegister("a7sW4", function(module, exports) {

$parcel$export(module.exports, "defaultParseSearch", function () { return $75e100da64cb1bf9$export$3d477def621690a6; });
$parcel$export(module.exports, "defaultStringifySearch", function () { return $75e100da64cb1bf9$export$68863d04f13b25ce; });

var $hEcni = parcelRequire("hEcni");
const $75e100da64cb1bf9$export$3d477def621690a6 = $75e100da64cb1bf9$export$d521d019d12eb80f(JSON.parse);
const $75e100da64cb1bf9$export$68863d04f13b25ce = $75e100da64cb1bf9$export$bee16cf4e0c1bf6(JSON.stringify, JSON.parse);
function $75e100da64cb1bf9$export$d521d019d12eb80f(parser) {
    return (searchStr)=>{
        if (searchStr.substring(0, 1) === "?") searchStr = searchStr.substring(1);
        const query = (0, $hEcni.decode)(searchStr);
        for(const key in query){
            const value = query[key];
            if (typeof value === "string") try {
                query[key] = parser(value);
            } catch (err) {}
        }
        return query;
    };
}
function $75e100da64cb1bf9$export$bee16cf4e0c1bf6(stringify, parser) {
    function stringifyValue(val) {
        if (typeof val === "object" && val !== null) try {
            return stringify(val);
        } catch (err) {}
        else if (typeof val === "string" && typeof parser === "function") try {
            parser(val);
            return stringify(val);
        } catch (err) {}
        return val;
    }
    return (search)=>{
        search = {
            ...search
        };
        Object.keys(search).forEach((key)=>{
            const val = search[key];
            if (typeof val === "undefined" || val === void 0) delete search[key];
            else search[key] = stringifyValue(val);
        });
        const searchStr = (0, $hEcni.encode)(search).toString();
        return searchStr ? `?${searchStr}` : "";
    };
}

});
parcelRegister("hEcni", function(module, exports) {

$parcel$export(module.exports, "encode", function () { return $cd8fc57557454553$export$c564cdbbe6da493; });
$parcel$export(module.exports, "decode", function () { return $cd8fc57557454553$export$2f872c0f2117be69; });

var $bypHT = parcelRequire("bypHT");
function $cd8fc57557454553$export$c564cdbbe6da493(obj, pfx) {
    let k, i, tmp, str = "";
    for(k in obj)if ((tmp = obj[k]) !== void 0) {
        if (Array.isArray(tmp)) for(i = 0; i < tmp.length; i++){
            str && (str += "&");
            str += encodeURIComponent(k) + "=" + encodeURIComponent(tmp[i]);
        }
        else {
            str && (str += "&");
            str += encodeURIComponent(k) + "=" + encodeURIComponent(tmp);
        }
    }
    return (pfx || "") + str;
}
function $cd8fc57557454553$var$toValue(mix) {
    if (!mix) return "";
    const str = (0, $bypHT.hasUriEncodedChars)(mix) ? decodeURIComponent(mix) : decodeURIComponent(encodeURIComponent(mix));
    if (str === "false") return false;
    if (str === "true") return true;
    return +str * 0 === 0 && +str + "" === str ? +str : str;
}
function $cd8fc57557454553$export$2f872c0f2117be69(str, pfx) {
    let tmp, k;
    const out = {}, arr = (pfx ? str.substr(pfx.length) : str).split("&");
    while(tmp = arr.shift()){
        const equalIndex = tmp.indexOf("=");
        if (equalIndex !== -1) {
            k = tmp.slice(0, equalIndex);
            k = decodeURIComponent(k);
            const value = tmp.slice(equalIndex + 1);
            if (out[k] !== void 0) out[k] = [].concat(out[k], $cd8fc57557454553$var$toValue(value));
            else out[k] = $cd8fc57557454553$var$toValue(value);
        } else {
            k = tmp;
            k = decodeURIComponent(k);
            out[k] = "";
        }
    }
    return out;
}

});


parcelRegister("fleMh", function(module, exports) {

$parcel$export(module.exports, "getLocationChangeInfo", function () { return $b2b447bf83127b6a$export$6c2b3e1c712e7fa6; });
function $b2b447bf83127b6a$export$ec485df5fdd355c3(err) {
    if (err instanceof Error) {
        const obj = {
            name: err.name,
            message: err.message
        };
        return obj;
    }
    return {
        data: err
    };
}
function $b2b447bf83127b6a$export$6c2b3e1c712e7fa6(routerState) {
    const fromLocation = routerState.resolvedLocation;
    const toLocation = routerState.location;
    const pathChanged = (fromLocation == null ? void 0 : fromLocation.pathname) !== toLocation.pathname;
    const hrefChanged = (fromLocation == null ? void 0 : fromLocation.href) !== toLocation.href;
    const hashChanged = (fromLocation == null ? void 0 : fromLocation.hash) !== toLocation.hash;
    return {
        fromLocation: fromLocation,
        toLocation: toLocation,
        pathChanged: pathChanged,
        hrefChanged: hrefChanged,
        hashChanged: hashChanged
    };
}

});

parcelRegister("lxb5Z", function(module, exports) {

$parcel$export(module.exports, "rootRouteId", function () { return $fad549671451fa20$export$463ffa9af37e9ec5; });
const $fad549671451fa20$export$463ffa9af37e9ec5 = "__root__";

});

parcelRegister("gbTjE", function(module, exports) {

$parcel$export(module.exports, "redirect", function () { return $bc9895054077aeca$export$89e12c5b50f7529d; });
$parcel$export(module.exports, "isRedirect", function () { return $bc9895054077aeca$export$4cb830d4f7e56898; });
$parcel$export(module.exports, "isResolvedRedirect", function () { return $bc9895054077aeca$export$d8d25f72d542813b; });
function $bc9895054077aeca$export$89e12c5b50f7529d(opts) {
    opts.isRedirect = true;
    opts.statusCode = opts.statusCode || opts.code || 307;
    opts.headers = opts.headers || {};
    if (!opts.reloadDocument) {
        opts.reloadDocument = false;
        try {
            new URL(`${opts.href}`);
            opts.reloadDocument = true;
        } catch  {}
    }
    if (opts.throw) throw opts;
    return opts;
}
function $bc9895054077aeca$export$4cb830d4f7e56898(obj) {
    return !!(obj == null ? void 0 : obj.isRedirect);
}
function $bc9895054077aeca$export$d8d25f72d542813b(obj) {
    return !!(obj == null ? void 0 : obj.isRedirect) && obj.href;
}

});

parcelRegister("64Yjc", function(module, exports) {

$parcel$export(module.exports, "notFound", function () { return $46d1e5d19f4430cd$export$a33e918cb4258370; });
$parcel$export(module.exports, "isNotFound", function () { return $46d1e5d19f4430cd$export$5ceecc1876a33e64; });
$parcel$export(module.exports, "CatchNotFound", function () { return $46d1e5d19f4430cd$export$5b0f5088d44b945c; });
$parcel$export(module.exports, "DefaultGlobalNotFound", function () { return $46d1e5d19f4430cd$export$8d79a25eb6fbadf1; });

var $4TLFw = parcelRequire("4TLFw");

var $lH7MM = parcelRequire("lH7MM");

var $2cXZi = parcelRequire("2cXZi");
function $46d1e5d19f4430cd$export$a33e918cb4258370(options = {}) {
    options.isNotFound = true;
    if (options.throw) throw options;
    return options;
}
function $46d1e5d19f4430cd$export$5ceecc1876a33e64(obj) {
    return !!(obj == null ? void 0 : obj.isNotFound);
}
function $46d1e5d19f4430cd$export$5b0f5088d44b945c(props) {
    const resetKey = (0, $2cXZi.useRouterState)({
        select: (s)=>`not-found-${s.location.pathname}-${s.status}`
    });
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $lH7MM.CatchBoundary), {
        getResetKey: ()=>resetKey,
        onCatch: (error, errorInfo)=>{
            var _a;
            if ($46d1e5d19f4430cd$export$5ceecc1876a33e64(error)) (_a = props.onCatch) == null || _a.call(props, error, errorInfo);
            else throw error;
        },
        errorComponent: ({ error: error })=>{
            var _a;
            if ($46d1e5d19f4430cd$export$5ceecc1876a33e64(error)) return (_a = props.fallback) == null ? void 0 : _a.call(props, error);
            else throw error;
        },
        children: props.children
    });
}
function $46d1e5d19f4430cd$export$8d79a25eb6fbadf1() {
    return /* @__PURE__ */ (0, $4TLFw.jsx)("p", {
        children: "Not Found"
    });
}

});
parcelRegister("lH7MM", function(module, exports) {

$parcel$export(module.exports, "CatchBoundary", function () { return $fcb3a73570745d84$export$d924b55053fc70c; });
$parcel$export(module.exports, "ErrorComponent", function () { return $fcb3a73570745d84$export$65db35c377fab04b; });

var $4TLFw = parcelRequire("4TLFw");

var $jbmdS = parcelRequire("jbmdS");
function $fcb3a73570745d84$export$d924b55053fc70c(props) {
    const errorComponent = props.errorComponent ?? $fcb3a73570745d84$export$65db35c377fab04b;
    return /* @__PURE__ */ (0, $4TLFw.jsx)($fcb3a73570745d84$var$CatchBoundaryImpl, {
        getResetKey: props.getResetKey,
        onCatch: props.onCatch,
        children: ({ error: error, reset: reset })=>{
            if (error) return $jbmdS.createElement(errorComponent, {
                error: error,
                reset: reset
            });
            return props.children;
        }
    });
}
class $fcb3a73570745d84$var$CatchBoundaryImpl extends $jbmdS.Component {
    constructor(){
        super(...arguments);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromProps(props) {
        return {
            resetKey: props.getResetKey()
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    reset() {
        this.setState({
            error: null
        });
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.error && prevState.resetKey !== this.state.resetKey) this.reset();
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onCatch) this.props.onCatch(error, errorInfo);
    }
    render() {
        return this.props.children({
            error: this.state.resetKey !== this.props.getResetKey() ? null : this.state.error,
            reset: ()=>{
                this.reset();
            }
        });
    }
}
function $fcb3a73570745d84$export$65db35c377fab04b({ error: error }) {
    const [show, setShow] = $jbmdS.useState(false);
    return /* @__PURE__ */ (0, $4TLFw.jsxs)("div", {
        style: {
            padding: ".5rem",
            maxWidth: "100%"
        },
        children: [
            /* @__PURE__ */ (0, $4TLFw.jsxs)("div", {
                style: {
                    display: "flex",
                    alignItems: "center",
                    gap: ".5rem"
                },
                children: [
                    /* @__PURE__ */ (0, $4TLFw.jsx)("strong", {
                        style: {
                            fontSize: "1rem"
                        },
                        children: "Something went wrong!"
                    }),
                    /* @__PURE__ */ (0, $4TLFw.jsx)("button", {
                        style: {
                            appearance: "none",
                            fontSize: ".6em",
                            border: "1px solid currentColor",
                            padding: ".1rem .2rem",
                            fontWeight: "bold",
                            borderRadius: ".25rem"
                        },
                        onClick: ()=>setShow((d)=>!d),
                        children: show ? "Hide Error" : "Show Error"
                    })
                ]
            }),
            /* @__PURE__ */ (0, $4TLFw.jsx)("div", {
                style: {
                    height: ".25rem"
                }
            }),
            show ? /* @__PURE__ */ (0, $4TLFw.jsx)("div", {
                children: /* @__PURE__ */ (0, $4TLFw.jsx)("pre", {
                    style: {
                        fontSize: ".7em",
                        border: "1px solid red",
                        borderRadius: ".25rem",
                        padding: ".3rem",
                        color: "red",
                        overflow: "auto"
                    },
                    children: error.message ? /* @__PURE__ */ (0, $4TLFw.jsx)("code", {
                        children: error.message
                    }) : null
                })
            }) : null
        ]
    });
}

});

parcelRegister("2cXZi", function(module, exports) {

$parcel$export(module.exports, "useRouterState", function () { return $19bb3c0983b61330$export$dbb5ccc270afbbb4; });

var $YHcT5 = parcelRequire("YHcT5");

var $jbmdS = parcelRequire("jbmdS");

var $bypHT = parcelRequire("bypHT");

var $1Fr27 = parcelRequire("1Fr27");
function $19bb3c0983b61330$export$dbb5ccc270afbbb4(opts) {
    const contextRouter = (0, $1Fr27.useRouter)({
        warn: (opts == null ? void 0 : opts.router) === void 0
    });
    const router = (opts == null ? void 0 : opts.router) || contextRouter;
    const previousResult = (0, $jbmdS.useRef)(void 0);
    return (0, $YHcT5.useStore)(router.__store, (state)=>{
        if (opts == null ? void 0 : opts.select) {
            if (opts.structuralSharing ?? router.options.defaultStructuralSharing) {
                const newSlice = (0, $bypHT.replaceEqualDeep)(previousResult.current, opts.select(state));
                previousResult.current = newSlice;
                return newSlice;
            }
            return opts.select(state);
        }
        return state;
    });
}

});
parcelRegister("YHcT5", function(module, exports) {
$parcel$export(module.exports, "batch", function () { return (parcelRequire("9AyUq")).batch; });
$parcel$export(module.exports, "Store", function () { return (parcelRequire("9PfBl")).Store; });

$parcel$export(module.exports, "useStore", function () { return $0b671eb1a666728a$export$6ccbb43953eebf8; });

var $65CFF = parcelRequire("65CFF");
parcelRequire("9AyUq");parcelRequire("9PfBl");
function $0b671eb1a666728a$export$6ccbb43953eebf8(store, selector = (d)=>d) {
    const slice = (0, $65CFF.useSyncExternalStoreWithSelector)(store.subscribe, ()=>store.state, ()=>store.state, selector, $0b671eb1a666728a$export$26c89aaec4eb1d2e);
    return slice;
}
function $0b671eb1a666728a$export$26c89aaec4eb1d2e(objA, objB) {
    if (Object.is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    if (objA instanceof Map && objB instanceof Map) {
        if (objA.size !== objB.size) return false;
        for (const [k, v] of objA){
            if (!objB.has(k) || !Object.is(v, objB.get(k))) return false;
        }
        return true;
    }
    if (objA instanceof Set && objB instanceof Set) {
        if (objA.size !== objB.size) return false;
        for (const v of objA){
            if (!objB.has(v)) return false;
        }
        return true;
    }
    const keysA = Object.keys(objA);
    if (keysA.length !== Object.keys(objB).length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !Object.is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});
parcelRegister("65CFF", function(module, exports) {
"use strict";

module.exports = (parcelRequire("a3xwM"));

});
parcelRegister("a3xwM", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $7524311592291674$export$bf730a2d8bf68b42; }, function (v) { return $7524311592291674$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7524311592291674$export$bf730a2d8bf68b42;
"use strict";

var $jbmdS = parcelRequire("jbmdS");

var $9MbdG = parcelRequire("9MbdG");
function $7524311592291674$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $7524311592291674$var$objectIs = "function" === typeof Object.is ? Object.is : $7524311592291674$var$is, $7524311592291674$var$useSyncExternalStore = $9MbdG.useSyncExternalStore, $7524311592291674$var$useRef = $jbmdS.useRef, $7524311592291674$var$useEffect = $jbmdS.useEffect, $7524311592291674$var$useMemo = $jbmdS.useMemo, $7524311592291674$var$useDebugValue = $jbmdS.useDebugValue;
$7524311592291674$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $7524311592291674$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $7524311592291674$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($7524311592291674$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $7524311592291674$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $7524311592291674$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $7524311592291674$var$useDebugValue(value);
    return value;
};

});
parcelRegister("9MbdG", function(module, exports) {
"use strict";

module.exports = (parcelRequire("6QwjX"));

});
parcelRegister("6QwjX", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $4fc0aba77f100efa$export$306c0aa65ff9ec16; }, function (v) { return $4fc0aba77f100efa$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4fc0aba77f100efa$export$306c0aa65ff9ec16;
"use strict";

var $jbmdS = parcelRequire("jbmdS");
function $4fc0aba77f100efa$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $4fc0aba77f100efa$var$objectIs = "function" === typeof Object.is ? Object.is : $4fc0aba77f100efa$var$is, $4fc0aba77f100efa$var$useState = $jbmdS.useState, $4fc0aba77f100efa$var$useEffect = $jbmdS.useEffect, $4fc0aba77f100efa$var$useLayoutEffect = $jbmdS.useLayoutEffect, $4fc0aba77f100efa$var$useDebugValue = $jbmdS.useDebugValue;
function $4fc0aba77f100efa$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $4fc0aba77f100efa$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $4fc0aba77f100efa$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $4fc0aba77f100efa$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $4fc0aba77f100efa$var$useEffect(function() {
        $4fc0aba77f100efa$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $4fc0aba77f100efa$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $4fc0aba77f100efa$var$useDebugValue(value);
    return value;
}
function $4fc0aba77f100efa$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$4fc0aba77f100efa$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $4fc0aba77f100efa$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $4fc0aba77f100efa$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $4fc0aba77f100efa$var$useSyncExternalStore$1 : $4fc0aba77f100efa$var$useSyncExternalStore$2;
$4fc0aba77f100efa$export$306c0aa65ff9ec16 = void 0 !== $jbmdS.useSyncExternalStore ? $jbmdS.useSyncExternalStore : $4fc0aba77f100efa$var$shim;

});





parcelRegister("1Fr27", function(module, exports) {

$parcel$export(module.exports, "useRouter", function () { return $136e96fc15c123d2$export$9a302a45f65d0572; });

var $jbmdS = parcelRequire("jbmdS");

var $iYKZj = parcelRequire("iYKZj");

var $3l2Mo = parcelRequire("3l2Mo");
function $136e96fc15c123d2$export$9a302a45f65d0572(opts) {
    const value = $jbmdS.useContext((0, $3l2Mo.getRouterContext)());
    (0, $iYKZj.default)(!(((opts == null ? void 0 : opts.warn) ?? true) && !value), "useRouter must be used inside a <RouterProvider> component!");
    return value;
}

});
parcelRegister("iYKZj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd12476cfb4933da$export$2e2bcd8739ae039; });
var $dd12476cfb4933da$var$isProduction = true;
function $dd12476cfb4933da$var$warning(condition, message) {
    if (!$dd12476cfb4933da$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== "undefined") console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $dd12476cfb4933da$export$2e2bcd8739ae039 = $dd12476cfb4933da$var$warning;

});

parcelRegister("3l2Mo", function(module, exports) {

$parcel$export(module.exports, "getRouterContext", function () { return $26e57d333befc9fd$export$65bef39336c189ee; });

var $jbmdS = parcelRequire("jbmdS");
const $26e57d333befc9fd$var$routerContext = $jbmdS.createContext(null);
function $26e57d333befc9fd$export$65bef39336c189ee() {
    if (typeof document === "undefined") return $26e57d333befc9fd$var$routerContext;
    if (window.__TSR_ROUTER_CONTEXT__) return window.__TSR_ROUTER_CONTEXT__;
    window.__TSR_ROUTER_CONTEXT__ = $26e57d333befc9fd$var$routerContext;
    return $26e57d333befc9fd$var$routerContext;
}

});




parcelRegister("aSkHi", function(module, exports) {

$parcel$export(module.exports, "setupScrollRestoration", function () { return $7eaf00948804980e$export$7d29344e455b77d5; });
$parcel$export(module.exports, "ScrollRestoration", function () { return $7eaf00948804980e$export$11aac1aab828f1fa; });

var $4TLFw = parcelRequire("4TLFw");

var $bypHT = parcelRequire("bypHT");

var $1Fr27 = parcelRequire("1Fr27");

var $j4LPl = parcelRequire("j4LPl");
const $7eaf00948804980e$export$7367158f2f597ab1 = "tsr-scroll-restoration-v1_3";
const $7eaf00948804980e$var$sessionsStorage = typeof window !== "undefined" && window.sessionStorage;
const $7eaf00948804980e$var$throttle = (fn, wait)=>{
    let timeout;
    return (...args)=>{
        if (!timeout) timeout = setTimeout(()=>{
            fn(...args);
            timeout = null;
        }, wait);
    };
};
const $7eaf00948804980e$export$a8cd1437a65580ab = $7eaf00948804980e$var$sessionsStorage ? (()=>{
    const state = JSON.parse(window.sessionStorage.getItem($7eaf00948804980e$export$7367158f2f597ab1) || "null") || {};
    return {
        state: state,
        // This setter is simply to make sure that we set the sessionStorage right
        // after the state is updated. It doesn't necessarily need to be a functional
        // update.
        set: (updater)=>($7eaf00948804980e$export$a8cd1437a65580ab.state = (0, $bypHT.functionalUpdate)(updater, $7eaf00948804980e$export$a8cd1437a65580ab.state) || $7eaf00948804980e$export$a8cd1437a65580ab.state, window.sessionStorage.setItem($7eaf00948804980e$export$7367158f2f597ab1, JSON.stringify($7eaf00948804980e$export$a8cd1437a65580ab.state)))
    };
})() : void 0;
const $7eaf00948804980e$export$4d80c2f2d33fa119 = (location)=>{
    return location.state.key || location.href;
};
function $7eaf00948804980e$export$ebca8b3cdefcf4e2(el) {
    const path = [];
    let parent;
    while(parent = el.parentNode){
        path.unshift(`${el.tagName}:nth-child(${[].indexOf.call(parent.children, el) + 1})`);
        el = parent;
    }
    return `${path.join(" > ")}`.toLowerCase();
}
let $7eaf00948804980e$var$ignoreScroll = false;
function $7eaf00948804980e$export$1ae751dc1db106fa(storageKey2, key, behavior, shouldScrollRestoration, scrollToTopSelectors) {
    var _a;
    let byKey;
    try {
        byKey = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
    } catch (error) {
        console.error(error);
        return;
    }
    const resolvedKey = key || ((_a = window.history.state) == null ? void 0 : _a.key);
    const elementEntries = byKey[resolvedKey];
    $7eaf00948804980e$var$ignoreScroll = true;
    (()=>{
        if (shouldScrollRestoration && elementEntries) {
            for(const elementSelector in elementEntries){
                const entry = elementEntries[elementSelector];
                if (elementSelector === "window") window.scrollTo({
                    top: entry.scrollY,
                    left: entry.scrollX,
                    behavior: behavior
                });
                else if (elementSelector) {
                    const element = document.querySelector(elementSelector);
                    if (element) {
                        element.scrollLeft = entry.scrollX;
                        element.scrollTop = entry.scrollY;
                    }
                }
            }
            return;
        }
        const hash = window.location.hash.split("#")[1];
        if (hash) {
            const hashScrollIntoViewOptions = (window.history.state || {}).__hashScrollIntoViewOptions ?? true;
            if (hashScrollIntoViewOptions) {
                const el = document.getElementById(hash);
                if (el) el.scrollIntoView(hashScrollIntoViewOptions);
            }
            return;
        }
        [
            "window",
            ...(scrollToTopSelectors == null ? void 0 : scrollToTopSelectors.filter((d)=>d !== "window")) ?? []
        ].forEach((selector)=>{
            const element = selector === "window" ? window : document.querySelector(selector);
            if (element) element.scrollTo({
                top: 0,
                left: 0,
                behavior: behavior
            });
        });
    })();
    $7eaf00948804980e$var$ignoreScroll = false;
}
function $7eaf00948804980e$export$7d29344e455b77d5(router, force) {
    const shouldScrollRestoration = force ?? router.options.scrollRestoration ?? false;
    if (shouldScrollRestoration) router.isScrollRestoring = true;
    if (typeof document === "undefined" || router.isScrollRestorationSetup) return;
    router.isScrollRestorationSetup = true;
    $7eaf00948804980e$var$ignoreScroll = false;
    const getKey = router.options.getScrollRestorationKey || $7eaf00948804980e$export$4d80c2f2d33fa119;
    window.history.scrollRestoration = "manual";
    const onScroll = (event)=>{
        if ($7eaf00948804980e$var$ignoreScroll || !router.isScrollRestoring) return;
        let elementSelector = "";
        if (event.target === document || event.target === window) elementSelector = "window";
        else {
            const attrId = event.target.getAttribute("data-scroll-restoration-id");
            if (attrId) elementSelector = `[data-scroll-restoration-id="${attrId}"]`;
            else elementSelector = $7eaf00948804980e$export$ebca8b3cdefcf4e2(event.target);
        }
        const restoreKey = getKey(router.state.location);
        $7eaf00948804980e$export$a8cd1437a65580ab.set((state)=>{
            const keyEntry = state[restoreKey] = state[restoreKey] || {};
            const elementEntry = keyEntry[elementSelector] = keyEntry[elementSelector] || {};
            if (elementSelector === "window") {
                elementEntry.scrollX = window.scrollX || 0;
                elementEntry.scrollY = window.scrollY || 0;
            } else if (elementSelector) {
                const element = document.querySelector(elementSelector);
                if (element) {
                    elementEntry.scrollX = element.scrollLeft || 0;
                    elementEntry.scrollY = element.scrollTop || 0;
                }
            }
            return state;
        });
    };
    if (typeof document !== "undefined") document.addEventListener("scroll", $7eaf00948804980e$var$throttle(onScroll, 100), true);
    router.subscribe("onRendered", (event)=>{
        const cacheKey = getKey(event.toLocation);
        if (!router.resetNextScroll) {
            router.resetNextScroll = true;
            return;
        }
        $7eaf00948804980e$export$1ae751dc1db106fa($7eaf00948804980e$export$7367158f2f597ab1, cacheKey, router.options.scrollRestorationBehavior, router.isScrollRestoring, router.options.scrollToTopSelectors);
        if (router.isScrollRestoring) $7eaf00948804980e$export$a8cd1437a65580ab.set((state)=>{
            state[cacheKey] = state[cacheKey] || {};
            return state;
        });
    });
}
function $7eaf00948804980e$export$11aac1aab828f1fa() {
    const router = (0, $1Fr27.useRouter)();
    const getKey = router.options.getScrollRestorationKey || $7eaf00948804980e$export$4d80c2f2d33fa119;
    const userKey = getKey(router.latestLocation);
    const resolvedKey = userKey !== $7eaf00948804980e$export$4d80c2f2d33fa119(router.latestLocation) ? userKey : null;
    if (!router.isScrollRestoring || !router.isServer) return null;
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $j4LPl.ScriptOnce), {
        children: `(${$7eaf00948804980e$export$1ae751dc1db106fa.toString()})(${JSON.stringify($7eaf00948804980e$export$7367158f2f597ab1)},${JSON.stringify(resolvedKey)}, undefined, true)`,
        log: false
    });
}

});
parcelRegister("j4LPl", function(module, exports) {

$parcel$export(module.exports, "ScriptOnce", function () { return $de337d830e4d648a$export$22d1cd1301a566d0; });

var $4TLFw = parcelRequire("4TLFw");
parcelRequire("kbgAi");
function $de337d830e4d648a$export$22d1cd1301a566d0({ children: children, log: log }) {
    if (typeof document !== "undefined") return null;
    return /* @__PURE__ */ (0, $4TLFw.jsx)("script", {
        className: "tsr-once",
        dangerouslySetInnerHTML: {
            __html: [
                children,
                "",
                'if (typeof __TSR_SSR__ !== "undefined") __TSR_SSR__.cleanScripts()'
            ].filter(Boolean).join("\n")
        }
    });
}

});
parcelRegister("kbgAi", function(module, exports) {

var $8MyLy = parcelRequire("8MyLy");
var $eb11b306bea79b25$require$Buffer = $8MyLy.Buffer;
"use strict";
const $eb11b306bea79b25$var$object = {};
const $eb11b306bea79b25$var$hasOwnProperty = $eb11b306bea79b25$var$object.hasOwnProperty;
const $eb11b306bea79b25$var$forOwn = (object, callback)=>{
    for(const key in object)if ($eb11b306bea79b25$var$hasOwnProperty.call(object, key)) callback(key, object[key]);
};
const $eb11b306bea79b25$var$extend = (destination, source)=>{
    if (!source) return destination;
    $eb11b306bea79b25$var$forOwn(source, (key, value)=>{
        destination[key] = value;
    });
    return destination;
};
const $eb11b306bea79b25$var$forEach = (array, callback)=>{
    const length = array.length;
    let index = -1;
    while(++index < length)callback(array[index]);
};
const $eb11b306bea79b25$var$fourHexEscape = (hex)=>{
    return "\\u" + ("0000" + hex).slice(-4);
};
const $eb11b306bea79b25$var$hexadecimal = (code, lowercase)=>{
    let hexadecimal = code.toString(16);
    if (lowercase) return hexadecimal;
    return hexadecimal.toUpperCase();
};
const $eb11b306bea79b25$var$toString = $eb11b306bea79b25$var$object.toString;
const $eb11b306bea79b25$var$isArray = Array.isArray;
const $eb11b306bea79b25$var$isBuffer = (value)=>{
    return typeof $eb11b306bea79b25$require$Buffer === "function" && $eb11b306bea79b25$require$Buffer.isBuffer(value);
};
const $eb11b306bea79b25$var$isObject = (value)=>{
    // This is a very simple check, but it’s good enough for what we need.
    return $eb11b306bea79b25$var$toString.call(value) == "[object Object]";
};
const $eb11b306bea79b25$var$isString = (value)=>{
    return typeof value == "string" || $eb11b306bea79b25$var$toString.call(value) == "[object String]";
};
const $eb11b306bea79b25$var$isNumber = (value)=>{
    return typeof value == "number" || $eb11b306bea79b25$var$toString.call(value) == "[object Number]";
};
const $eb11b306bea79b25$var$isBigInt = (value)=>{
    return typeof value == "bigint";
};
const $eb11b306bea79b25$var$isFunction = (value)=>{
    return typeof value == "function";
};
const $eb11b306bea79b25$var$isMap = (value)=>{
    return $eb11b306bea79b25$var$toString.call(value) == "[object Map]";
};
const $eb11b306bea79b25$var$isSet = (value)=>{
    return $eb11b306bea79b25$var$toString.call(value) == "[object Set]";
};
/*--------------------------------------------------------------------------*/ // https://mathiasbynens.be/notes/javascript-escapes#single
const $eb11b306bea79b25$var$singleEscapes = {
    "\\": "\\\\",
    "\b": "\\b",
    "\f": "\\f",
    "\n": "\\n",
    "\r": "\\r",
    "	": "\\t"
};
const $eb11b306bea79b25$var$regexSingleEscape = /[\\\b\f\n\r\t]/;
const $eb11b306bea79b25$var$regexDigit = /[0-9]/;
const $eb11b306bea79b25$var$regexWhitespace = /[\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;
const $eb11b306bea79b25$var$escapeEverythingRegex = /([\uD800-\uDBFF][\uDC00-\uDFFF])|([\uD800-\uDFFF])|(['"`])|[^]/g;
const $eb11b306bea79b25$var$escapeNonAsciiRegex = /([\uD800-\uDBFF][\uDC00-\uDFFF])|([\uD800-\uDFFF])|(['"`])|[^ !#-&\(-\[\]-_a-~]/g;
const $eb11b306bea79b25$var$jsesc = (argument, options)=>{
    const increaseIndentation = ()=>{
        oldIndent = indent;
        ++options.indentLevel;
        indent = options.indent.repeat(options.indentLevel);
    };
    // Handle options
    const defaults = {
        "escapeEverything": false,
        "minimal": false,
        "isScriptContext": false,
        "quotes": "single",
        "wrap": false,
        "es6": false,
        "json": false,
        "compact": true,
        "lowercaseHex": false,
        "numbers": "decimal",
        "indent": "	",
        "indentLevel": 0,
        "__inline1__": false,
        "__inline2__": false
    };
    const json = options && options.json;
    if (json) {
        defaults.quotes = "double";
        defaults.wrap = true;
    }
    options = $eb11b306bea79b25$var$extend(defaults, options);
    if (options.quotes != "single" && options.quotes != "double" && options.quotes != "backtick") options.quotes = "single";
    const quote = options.quotes == "double" ? '"' : options.quotes == "backtick" ? "`" : "'";
    const compact = options.compact;
    const lowercaseHex = options.lowercaseHex;
    let indent = options.indent.repeat(options.indentLevel);
    let oldIndent = "";
    const inline1 = options.__inline1__;
    const inline2 = options.__inline2__;
    const newLine = compact ? "" : "\n";
    let result;
    let isEmpty = true;
    const useBinNumbers = options.numbers == "binary";
    const useOctNumbers = options.numbers == "octal";
    const useDecNumbers = options.numbers == "decimal";
    const useHexNumbers = options.numbers == "hexadecimal";
    if (json && argument && $eb11b306bea79b25$var$isFunction(argument.toJSON)) argument = argument.toJSON();
    if (!$eb11b306bea79b25$var$isString(argument)) {
        if ($eb11b306bea79b25$var$isMap(argument)) {
            if (argument.size == 0) return "new Map()";
            if (!compact) {
                options.__inline1__ = true;
                options.__inline2__ = false;
            }
            return "new Map(" + $eb11b306bea79b25$var$jsesc(Array.from(argument), options) + ")";
        }
        if ($eb11b306bea79b25$var$isSet(argument)) {
            if (argument.size == 0) return "new Set()";
            return "new Set(" + $eb11b306bea79b25$var$jsesc(Array.from(argument), options) + ")";
        }
        if ($eb11b306bea79b25$var$isBuffer(argument)) {
            if (argument.length == 0) return "Buffer.from([])";
            return "Buffer.from(" + $eb11b306bea79b25$var$jsesc(Array.from(argument), options) + ")";
        }
        if ($eb11b306bea79b25$var$isArray(argument)) {
            result = [];
            options.wrap = true;
            if (inline1) {
                options.__inline1__ = false;
                options.__inline2__ = true;
            }
            if (!inline2) increaseIndentation();
            $eb11b306bea79b25$var$forEach(argument, (value)=>{
                isEmpty = false;
                if (inline2) options.__inline2__ = false;
                result.push((compact || inline2 ? "" : indent) + $eb11b306bea79b25$var$jsesc(value, options));
            });
            if (isEmpty) return "[]";
            if (inline2) return "[" + result.join(", ") + "]";
            return "[" + newLine + result.join("," + newLine) + newLine + (compact ? "" : oldIndent) + "]";
        } else if ($eb11b306bea79b25$var$isNumber(argument) || $eb11b306bea79b25$var$isBigInt(argument)) {
            if (json) // Some number values (e.g. `Infinity`) cannot be represented in JSON.
            // `BigInt` values less than `-Number.MAX_VALUE` or greater than
            // `Number.MAX_VALUE` cannot be represented in JSON so they will become
            // `-Infinity` or `Infinity`, respectively, and then become `null` when
            // stringified.
            return JSON.stringify(Number(argument));
            let result;
            if (useDecNumbers) result = String(argument);
            else if (useHexNumbers) {
                let hexadecimal = argument.toString(16);
                if (!lowercaseHex) hexadecimal = hexadecimal.toUpperCase();
                result = "0x" + hexadecimal;
            } else if (useBinNumbers) result = "0b" + argument.toString(2);
            else if (useOctNumbers) result = "0o" + argument.toString(8);
            if ($eb11b306bea79b25$var$isBigInt(argument)) return result + "n";
            return result;
        } else if ($eb11b306bea79b25$var$isBigInt(argument)) {
            if (json) // `BigInt` values less than `-Number.MAX_VALUE` or greater than
            // `Number.MAX_VALUE` will become `-Infinity` or `Infinity`,
            // respectively, and cannot be represented in JSON.
            return JSON.stringify(Number(argument));
            return argument + "n";
        } else if (!$eb11b306bea79b25$var$isObject(argument)) {
            if (json) // For some values (e.g. `undefined`, `function` objects),
            // `JSON.stringify(value)` returns `undefined` (which isn’t valid
            // JSON) instead of `'null'`.
            return JSON.stringify(argument) || "null";
            return String(argument);
        } else {
            result = [];
            options.wrap = true;
            increaseIndentation();
            $eb11b306bea79b25$var$forOwn(argument, (key, value)=>{
                isEmpty = false;
                result.push((compact ? "" : indent) + $eb11b306bea79b25$var$jsesc(key, options) + ":" + (compact ? "" : " ") + $eb11b306bea79b25$var$jsesc(value, options));
            });
            if (isEmpty) return "{}";
            return "{" + newLine + result.join("," + newLine) + newLine + (compact ? "" : oldIndent) + "}";
        }
    }
    const regex = options.escapeEverything ? $eb11b306bea79b25$var$escapeEverythingRegex : $eb11b306bea79b25$var$escapeNonAsciiRegex;
    result = argument.replace(regex, (char, pair, lone, quoteChar, index, string)=>{
        if (pair) {
            if (options.minimal) return pair;
            const first = pair.charCodeAt(0);
            const second = pair.charCodeAt(1);
            if (options.es6) {
                // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                const codePoint = (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
                const hex = $eb11b306bea79b25$var$hexadecimal(codePoint, lowercaseHex);
                return "\\u{" + hex + "}";
            }
            return $eb11b306bea79b25$var$fourHexEscape($eb11b306bea79b25$var$hexadecimal(first, lowercaseHex)) + $eb11b306bea79b25$var$fourHexEscape($eb11b306bea79b25$var$hexadecimal(second, lowercaseHex));
        }
        if (lone) return $eb11b306bea79b25$var$fourHexEscape($eb11b306bea79b25$var$hexadecimal(lone.charCodeAt(0), lowercaseHex));
        if (char == "\0" && !json && !$eb11b306bea79b25$var$regexDigit.test(string.charAt(index + 1))) return "\\0";
        if (quoteChar) {
            if (quoteChar == quote || options.escapeEverything) return "\\" + quoteChar;
            return quoteChar;
        }
        if ($eb11b306bea79b25$var$regexSingleEscape.test(char)) // no need for a `hasOwnProperty` check here
        return $eb11b306bea79b25$var$singleEscapes[char];
        if (options.minimal && !$eb11b306bea79b25$var$regexWhitespace.test(char)) return char;
        const hex = $eb11b306bea79b25$var$hexadecimal(char.charCodeAt(0), lowercaseHex);
        if (json || hex.length > 2) return $eb11b306bea79b25$var$fourHexEscape(hex);
        return "\\x" + ("00" + hex).slice(-2);
    });
    if (quote == "`") result = result.replace(/\$\{/g, "\\${");
    if (options.isScriptContext) // https://mathiasbynens.be/notes/etago
    result = result.replace(/<\/(script|style)/gi, "<\\/$1").replace(/<!--/g, json ? "\\u003C!--" : "\\x3C!--");
    if (options.wrap) result = quote + result + quote;
    return result;
};
$eb11b306bea79b25$var$jsesc.version = "3.0.2";
module.exports = $eb11b306bea79b25$var$jsesc;

});
parcelRegister("8MyLy", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $664dc639e3ed0dfe$export$a143d493d941bafc; }, function (v) { return $664dc639e3ed0dfe$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $664dc639e3ed0dfe$export$f99ded8fe4b79145; }, function (v) { return $664dc639e3ed0dfe$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $664dc639e3ed0dfe$export$a143d493d941bafc;
var $664dc639e3ed0dfe$export$e4cf37d7f6fb9e0a;
var $664dc639e3ed0dfe$export$f99ded8fe4b79145;
var $664dc639e3ed0dfe$export$599f31c3813fae4d;
"use strict";

var $9P5KO = parcelRequire("9P5KO");

var $lkZcV = parcelRequire("lkZcV");
const $664dc639e3ed0dfe$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$664dc639e3ed0dfe$export$a143d493d941bafc = $664dc639e3ed0dfe$var$Buffer;
$664dc639e3ed0dfe$export$e4cf37d7f6fb9e0a = $664dc639e3ed0dfe$var$SlowBuffer;
$664dc639e3ed0dfe$export$f99ded8fe4b79145 = 50;
const $664dc639e3ed0dfe$var$K_MAX_LENGTH = 0x7fffffff;
$664dc639e3ed0dfe$export$599f31c3813fae4d = $664dc639e3ed0dfe$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $664dc639e3ed0dfe$var$Buffer.TYPED_ARRAY_SUPPORT = $664dc639e3ed0dfe$var$typedArraySupport();
if (!$664dc639e3ed0dfe$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $664dc639e3ed0dfe$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($664dc639e3ed0dfe$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$664dc639e3ed0dfe$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($664dc639e3ed0dfe$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$664dc639e3ed0dfe$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $664dc639e3ed0dfe$var$createBuffer(length) {
    if (length > $664dc639e3ed0dfe$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $664dc639e3ed0dfe$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $664dc639e3ed0dfe$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $664dc639e3ed0dfe$var$allocUnsafe(arg);
    }
    return $664dc639e3ed0dfe$var$from(arg, encodingOrOffset, length);
}
$664dc639e3ed0dfe$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $664dc639e3ed0dfe$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $664dc639e3ed0dfe$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $664dc639e3ed0dfe$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($664dc639e3ed0dfe$var$isInstance(value, ArrayBuffer) || value && $664dc639e3ed0dfe$var$isInstance(value.buffer, ArrayBuffer)) return $664dc639e3ed0dfe$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($664dc639e3ed0dfe$var$isInstance(value, SharedArrayBuffer) || value && $664dc639e3ed0dfe$var$isInstance(value.buffer, SharedArrayBuffer))) return $664dc639e3ed0dfe$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $664dc639e3ed0dfe$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $664dc639e3ed0dfe$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $664dc639e3ed0dfe$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $664dc639e3ed0dfe$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $664dc639e3ed0dfe$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($664dc639e3ed0dfe$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($664dc639e3ed0dfe$var$Buffer, Uint8Array);
function $664dc639e3ed0dfe$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $664dc639e3ed0dfe$var$alloc(size, fill, encoding) {
    $664dc639e3ed0dfe$var$assertSize(size);
    if (size <= 0) return $664dc639e3ed0dfe$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $664dc639e3ed0dfe$var$createBuffer(size).fill(fill, encoding) : $664dc639e3ed0dfe$var$createBuffer(size).fill(fill);
    return $664dc639e3ed0dfe$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $664dc639e3ed0dfe$var$Buffer.alloc = function(size, fill, encoding) {
    return $664dc639e3ed0dfe$var$alloc(size, fill, encoding);
};
function $664dc639e3ed0dfe$var$allocUnsafe(size) {
    $664dc639e3ed0dfe$var$assertSize(size);
    return $664dc639e3ed0dfe$var$createBuffer(size < 0 ? 0 : $664dc639e3ed0dfe$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $664dc639e3ed0dfe$var$Buffer.allocUnsafe = function(size) {
    return $664dc639e3ed0dfe$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $664dc639e3ed0dfe$var$Buffer.allocUnsafeSlow = function(size) {
    return $664dc639e3ed0dfe$var$allocUnsafe(size);
};
function $664dc639e3ed0dfe$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$664dc639e3ed0dfe$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $664dc639e3ed0dfe$var$byteLength(string, encoding) | 0;
    let buf = $664dc639e3ed0dfe$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $664dc639e3ed0dfe$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $664dc639e3ed0dfe$var$checked(array.length) | 0;
    const buf = $664dc639e3ed0dfe$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $664dc639e3ed0dfe$var$fromArrayView(arrayView) {
    if ($664dc639e3ed0dfe$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $664dc639e3ed0dfe$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $664dc639e3ed0dfe$var$fromArrayLike(arrayView);
}
function $664dc639e3ed0dfe$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $664dc639e3ed0dfe$var$Buffer.prototype);
    return buf;
}
function $664dc639e3ed0dfe$var$fromObject(obj) {
    if ($664dc639e3ed0dfe$var$Buffer.isBuffer(obj)) {
        const len = $664dc639e3ed0dfe$var$checked(obj.length) | 0;
        const buf = $664dc639e3ed0dfe$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $664dc639e3ed0dfe$var$numberIsNaN(obj.length)) return $664dc639e3ed0dfe$var$createBuffer(0);
        return $664dc639e3ed0dfe$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $664dc639e3ed0dfe$var$fromArrayLike(obj.data);
}
function $664dc639e3ed0dfe$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $664dc639e3ed0dfe$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $664dc639e3ed0dfe$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $664dc639e3ed0dfe$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $664dc639e3ed0dfe$var$Buffer.alloc(+length);
}
$664dc639e3ed0dfe$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $664dc639e3ed0dfe$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$664dc639e3ed0dfe$var$Buffer.compare = function compare(a, b) {
    if ($664dc639e3ed0dfe$var$isInstance(a, Uint8Array)) a = $664dc639e3ed0dfe$var$Buffer.from(a, a.offset, a.byteLength);
    if ($664dc639e3ed0dfe$var$isInstance(b, Uint8Array)) b = $664dc639e3ed0dfe$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$664dc639e3ed0dfe$var$Buffer.isBuffer(a) || !$664dc639e3ed0dfe$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$664dc639e3ed0dfe$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$664dc639e3ed0dfe$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $664dc639e3ed0dfe$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $664dc639e3ed0dfe$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($664dc639e3ed0dfe$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$664dc639e3ed0dfe$var$Buffer.isBuffer(buf)) buf = $664dc639e3ed0dfe$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$664dc639e3ed0dfe$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $664dc639e3ed0dfe$var$byteLength(string, encoding) {
    if ($664dc639e3ed0dfe$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $664dc639e3ed0dfe$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $664dc639e3ed0dfe$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $664dc639e3ed0dfe$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $664dc639e3ed0dfe$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$664dc639e3ed0dfe$var$Buffer.byteLength = $664dc639e3ed0dfe$var$byteLength;
function $664dc639e3ed0dfe$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $664dc639e3ed0dfe$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $664dc639e3ed0dfe$var$utf8Slice(this, start, end);
        case "ascii":
            return $664dc639e3ed0dfe$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $664dc639e3ed0dfe$var$latin1Slice(this, start, end);
        case "base64":
            return $664dc639e3ed0dfe$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $664dc639e3ed0dfe$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$664dc639e3ed0dfe$var$Buffer.prototype._isBuffer = true;
function $664dc639e3ed0dfe$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$664dc639e3ed0dfe$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$664dc639e3ed0dfe$var$swap(this, i, i + 1);
    return this;
};
$664dc639e3ed0dfe$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $664dc639e3ed0dfe$var$swap(this, i, i + 3);
        $664dc639e3ed0dfe$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$664dc639e3ed0dfe$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $664dc639e3ed0dfe$var$swap(this, i, i + 7);
        $664dc639e3ed0dfe$var$swap(this, i + 1, i + 6);
        $664dc639e3ed0dfe$var$swap(this, i + 2, i + 5);
        $664dc639e3ed0dfe$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$664dc639e3ed0dfe$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $664dc639e3ed0dfe$var$utf8Slice(this, 0, length);
    return $664dc639e3ed0dfe$var$slowToString.apply(this, arguments);
};
$664dc639e3ed0dfe$var$Buffer.prototype.toLocaleString = $664dc639e3ed0dfe$var$Buffer.prototype.toString;
$664dc639e3ed0dfe$var$Buffer.prototype.equals = function equals(b) {
    if (!$664dc639e3ed0dfe$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $664dc639e3ed0dfe$var$Buffer.compare(this, b) === 0;
};
$664dc639e3ed0dfe$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $664dc639e3ed0dfe$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($664dc639e3ed0dfe$var$customInspectSymbol) $664dc639e3ed0dfe$var$Buffer.prototype[$664dc639e3ed0dfe$var$customInspectSymbol] = $664dc639e3ed0dfe$var$Buffer.prototype.inspect;
$664dc639e3ed0dfe$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($664dc639e3ed0dfe$var$isInstance(target, Uint8Array)) target = $664dc639e3ed0dfe$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$664dc639e3ed0dfe$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $664dc639e3ed0dfe$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($664dc639e3ed0dfe$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $664dc639e3ed0dfe$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($664dc639e3ed0dfe$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $664dc639e3ed0dfe$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $664dc639e3ed0dfe$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $664dc639e3ed0dfe$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$664dc639e3ed0dfe$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$664dc639e3ed0dfe$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $664dc639e3ed0dfe$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$664dc639e3ed0dfe$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $664dc639e3ed0dfe$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $664dc639e3ed0dfe$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($664dc639e3ed0dfe$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $664dc639e3ed0dfe$var$utf8Write(buf, string, offset, length) {
    return $664dc639e3ed0dfe$var$blitBuffer($664dc639e3ed0dfe$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $664dc639e3ed0dfe$var$asciiWrite(buf, string, offset, length) {
    return $664dc639e3ed0dfe$var$blitBuffer($664dc639e3ed0dfe$var$asciiToBytes(string), buf, offset, length);
}
function $664dc639e3ed0dfe$var$base64Write(buf, string, offset, length) {
    return $664dc639e3ed0dfe$var$blitBuffer($664dc639e3ed0dfe$var$base64ToBytes(string), buf, offset, length);
}
function $664dc639e3ed0dfe$var$ucs2Write(buf, string, offset, length) {
    return $664dc639e3ed0dfe$var$blitBuffer($664dc639e3ed0dfe$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$664dc639e3ed0dfe$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $664dc639e3ed0dfe$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $664dc639e3ed0dfe$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $664dc639e3ed0dfe$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $664dc639e3ed0dfe$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $664dc639e3ed0dfe$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$664dc639e3ed0dfe$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $664dc639e3ed0dfe$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $9P5KO.fromByteArray(buf);
    else return $9P5KO.fromByteArray(buf.slice(start, end));
}
function $664dc639e3ed0dfe$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $664dc639e3ed0dfe$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $664dc639e3ed0dfe$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $664dc639e3ed0dfe$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $664dc639e3ed0dfe$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $664dc639e3ed0dfe$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $664dc639e3ed0dfe$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $664dc639e3ed0dfe$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $664dc639e3ed0dfe$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $664dc639e3ed0dfe$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $664dc639e3ed0dfe$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$664dc639e3ed0dfe$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $664dc639e3ed0dfe$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $664dc639e3ed0dfe$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$664dc639e3ed0dfe$var$Buffer.prototype.readUintLE = $664dc639e3ed0dfe$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $664dc639e3ed0dfe$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$664dc639e3ed0dfe$var$Buffer.prototype.readUintBE = $664dc639e3ed0dfe$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $664dc639e3ed0dfe$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$664dc639e3ed0dfe$var$Buffer.prototype.readUint8 = $664dc639e3ed0dfe$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $664dc639e3ed0dfe$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$664dc639e3ed0dfe$var$Buffer.prototype.readUint16LE = $664dc639e3ed0dfe$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $664dc639e3ed0dfe$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$664dc639e3ed0dfe$var$Buffer.prototype.readUint16BE = $664dc639e3ed0dfe$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $664dc639e3ed0dfe$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$664dc639e3ed0dfe$var$Buffer.prototype.readUint32LE = $664dc639e3ed0dfe$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $664dc639e3ed0dfe$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$664dc639e3ed0dfe$var$Buffer.prototype.readUint32BE = $664dc639e3ed0dfe$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $664dc639e3ed0dfe$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$664dc639e3ed0dfe$var$Buffer.prototype.readBigUInt64LE = $664dc639e3ed0dfe$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $664dc639e3ed0dfe$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $664dc639e3ed0dfe$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$664dc639e3ed0dfe$var$Buffer.prototype.readBigUInt64BE = $664dc639e3ed0dfe$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $664dc639e3ed0dfe$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $664dc639e3ed0dfe$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$664dc639e3ed0dfe$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $664dc639e3ed0dfe$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$664dc639e3ed0dfe$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $664dc639e3ed0dfe$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$664dc639e3ed0dfe$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $664dc639e3ed0dfe$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$664dc639e3ed0dfe$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $664dc639e3ed0dfe$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$664dc639e3ed0dfe$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $664dc639e3ed0dfe$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$664dc639e3ed0dfe$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $664dc639e3ed0dfe$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$664dc639e3ed0dfe$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $664dc639e3ed0dfe$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$664dc639e3ed0dfe$var$Buffer.prototype.readBigInt64LE = $664dc639e3ed0dfe$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $664dc639e3ed0dfe$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $664dc639e3ed0dfe$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$664dc639e3ed0dfe$var$Buffer.prototype.readBigInt64BE = $664dc639e3ed0dfe$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $664dc639e3ed0dfe$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $664dc639e3ed0dfe$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$664dc639e3ed0dfe$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $664dc639e3ed0dfe$var$checkOffset(offset, 4, this.length);
    return $lkZcV.read(this, offset, true, 23, 4);
};
$664dc639e3ed0dfe$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $664dc639e3ed0dfe$var$checkOffset(offset, 4, this.length);
    return $lkZcV.read(this, offset, false, 23, 4);
};
$664dc639e3ed0dfe$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $664dc639e3ed0dfe$var$checkOffset(offset, 8, this.length);
    return $lkZcV.read(this, offset, true, 52, 8);
};
$664dc639e3ed0dfe$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $664dc639e3ed0dfe$var$checkOffset(offset, 8, this.length);
    return $lkZcV.read(this, offset, false, 52, 8);
};
function $664dc639e3ed0dfe$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$664dc639e3ed0dfe$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$664dc639e3ed0dfe$var$Buffer.prototype.writeUintLE = $664dc639e3ed0dfe$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $664dc639e3ed0dfe$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$664dc639e3ed0dfe$var$Buffer.prototype.writeUintBE = $664dc639e3ed0dfe$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $664dc639e3ed0dfe$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$664dc639e3ed0dfe$var$Buffer.prototype.writeUint8 = $664dc639e3ed0dfe$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $664dc639e3ed0dfe$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$664dc639e3ed0dfe$var$Buffer.prototype.writeUint16LE = $664dc639e3ed0dfe$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $664dc639e3ed0dfe$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$664dc639e3ed0dfe$var$Buffer.prototype.writeUint16BE = $664dc639e3ed0dfe$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $664dc639e3ed0dfe$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$664dc639e3ed0dfe$var$Buffer.prototype.writeUint32LE = $664dc639e3ed0dfe$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $664dc639e3ed0dfe$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$664dc639e3ed0dfe$var$Buffer.prototype.writeUint32BE = $664dc639e3ed0dfe$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $664dc639e3ed0dfe$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $664dc639e3ed0dfe$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $664dc639e3ed0dfe$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $664dc639e3ed0dfe$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $664dc639e3ed0dfe$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$664dc639e3ed0dfe$var$Buffer.prototype.writeBigUInt64LE = $664dc639e3ed0dfe$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $664dc639e3ed0dfe$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$664dc639e3ed0dfe$var$Buffer.prototype.writeBigUInt64BE = $664dc639e3ed0dfe$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $664dc639e3ed0dfe$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$664dc639e3ed0dfe$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $664dc639e3ed0dfe$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$664dc639e3ed0dfe$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $664dc639e3ed0dfe$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$664dc639e3ed0dfe$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $664dc639e3ed0dfe$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$664dc639e3ed0dfe$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $664dc639e3ed0dfe$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$664dc639e3ed0dfe$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $664dc639e3ed0dfe$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$664dc639e3ed0dfe$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $664dc639e3ed0dfe$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$664dc639e3ed0dfe$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $664dc639e3ed0dfe$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$664dc639e3ed0dfe$var$Buffer.prototype.writeBigInt64LE = $664dc639e3ed0dfe$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $664dc639e3ed0dfe$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$664dc639e3ed0dfe$var$Buffer.prototype.writeBigInt64BE = $664dc639e3ed0dfe$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $664dc639e3ed0dfe$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $664dc639e3ed0dfe$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $664dc639e3ed0dfe$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $664dc639e3ed0dfe$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $lkZcV.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$664dc639e3ed0dfe$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $664dc639e3ed0dfe$var$writeFloat(this, value, offset, true, noAssert);
};
$664dc639e3ed0dfe$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $664dc639e3ed0dfe$var$writeFloat(this, value, offset, false, noAssert);
};
function $664dc639e3ed0dfe$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $664dc639e3ed0dfe$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $lkZcV.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$664dc639e3ed0dfe$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $664dc639e3ed0dfe$var$writeDouble(this, value, offset, true, noAssert);
};
$664dc639e3ed0dfe$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $664dc639e3ed0dfe$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$664dc639e3ed0dfe$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$664dc639e3ed0dfe$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$664dc639e3ed0dfe$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$664dc639e3ed0dfe$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $664dc639e3ed0dfe$var$Buffer.isBuffer(val) ? val : $664dc639e3ed0dfe$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $664dc639e3ed0dfe$var$errors = {};
function $664dc639e3ed0dfe$var$E(sym, getMessage, Base) {
    $664dc639e3ed0dfe$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$664dc639e3ed0dfe$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$664dc639e3ed0dfe$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$664dc639e3ed0dfe$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $664dc639e3ed0dfe$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $664dc639e3ed0dfe$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $664dc639e3ed0dfe$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $664dc639e3ed0dfe$var$checkBounds(buf, offset, byteLength) {
    $664dc639e3ed0dfe$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $664dc639e3ed0dfe$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $664dc639e3ed0dfe$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $664dc639e3ed0dfe$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $664dc639e3ed0dfe$var$checkBounds(buf, offset, byteLength);
}
function $664dc639e3ed0dfe$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $664dc639e3ed0dfe$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $664dc639e3ed0dfe$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $664dc639e3ed0dfe$var$validateNumber(value, type);
        throw new $664dc639e3ed0dfe$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $664dc639e3ed0dfe$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $664dc639e3ed0dfe$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $664dc639e3ed0dfe$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $664dc639e3ed0dfe$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($664dc639e3ed0dfe$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $664dc639e3ed0dfe$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $664dc639e3ed0dfe$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $664dc639e3ed0dfe$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $664dc639e3ed0dfe$var$base64ToBytes(str) {
    return $9P5KO.toByteArray($664dc639e3ed0dfe$var$base64clean(str));
}
function $664dc639e3ed0dfe$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $664dc639e3ed0dfe$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $664dc639e3ed0dfe$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $664dc639e3ed0dfe$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $664dc639e3ed0dfe$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $664dc639e3ed0dfe$var$BufferBigIntNotDefined : fn;
}
function $664dc639e3ed0dfe$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("9P5KO", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $726d5716a4e91ae5$export$d622b2ad8d90c771; }, function (v) { return $726d5716a4e91ae5$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $726d5716a4e91ae5$export$6100ba28696e12de; }, function (v) { return $726d5716a4e91ae5$export$6100ba28696e12de = v; });
var $726d5716a4e91ae5$export$a48f0734ac7c2329;
var $726d5716a4e91ae5$export$d622b2ad8d90c771;
var $726d5716a4e91ae5$export$6100ba28696e12de;
"use strict";
$726d5716a4e91ae5$export$a48f0734ac7c2329 = $726d5716a4e91ae5$var$byteLength;
$726d5716a4e91ae5$export$d622b2ad8d90c771 = $726d5716a4e91ae5$var$toByteArray;
$726d5716a4e91ae5$export$6100ba28696e12de = $726d5716a4e91ae5$var$fromByteArray;
var $726d5716a4e91ae5$var$lookup = [];
var $726d5716a4e91ae5$var$revLookup = [];
var $726d5716a4e91ae5$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $726d5716a4e91ae5$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $726d5716a4e91ae5$var$i = 0, $726d5716a4e91ae5$var$len = $726d5716a4e91ae5$var$code.length; $726d5716a4e91ae5$var$i < $726d5716a4e91ae5$var$len; ++$726d5716a4e91ae5$var$i){
    $726d5716a4e91ae5$var$lookup[$726d5716a4e91ae5$var$i] = $726d5716a4e91ae5$var$code[$726d5716a4e91ae5$var$i];
    $726d5716a4e91ae5$var$revLookup[$726d5716a4e91ae5$var$code.charCodeAt($726d5716a4e91ae5$var$i)] = $726d5716a4e91ae5$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$726d5716a4e91ae5$var$revLookup["-".charCodeAt(0)] = 62;
$726d5716a4e91ae5$var$revLookup["_".charCodeAt(0)] = 63;
function $726d5716a4e91ae5$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $726d5716a4e91ae5$var$byteLength(b64) {
    var lens = $726d5716a4e91ae5$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $726d5716a4e91ae5$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $726d5716a4e91ae5$var$toByteArray(b64) {
    var tmp;
    var lens = $726d5716a4e91ae5$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $726d5716a4e91ae5$var$Arr($726d5716a4e91ae5$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $726d5716a4e91ae5$var$revLookup[b64.charCodeAt(i)] << 18 | $726d5716a4e91ae5$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $726d5716a4e91ae5$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $726d5716a4e91ae5$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $726d5716a4e91ae5$var$revLookup[b64.charCodeAt(i)] << 2 | $726d5716a4e91ae5$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $726d5716a4e91ae5$var$revLookup[b64.charCodeAt(i)] << 10 | $726d5716a4e91ae5$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $726d5716a4e91ae5$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $726d5716a4e91ae5$var$tripletToBase64(num) {
    return $726d5716a4e91ae5$var$lookup[num >> 18 & 0x3F] + $726d5716a4e91ae5$var$lookup[num >> 12 & 0x3F] + $726d5716a4e91ae5$var$lookup[num >> 6 & 0x3F] + $726d5716a4e91ae5$var$lookup[num & 0x3F];
}
function $726d5716a4e91ae5$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($726d5716a4e91ae5$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $726d5716a4e91ae5$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($726d5716a4e91ae5$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($726d5716a4e91ae5$var$lookup[tmp >> 2] + $726d5716a4e91ae5$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($726d5716a4e91ae5$var$lookup[tmp >> 10] + $726d5716a4e91ae5$var$lookup[tmp >> 4 & 0x3F] + $726d5716a4e91ae5$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("lkZcV", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $f88af1c0975327fe$export$aafa59e2e03f2942; }, function (v) { return $f88af1c0975327fe$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $f88af1c0975327fe$export$68d8715fc104d294; }, function (v) { return $f88af1c0975327fe$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $f88af1c0975327fe$export$aafa59e2e03f2942;
var $f88af1c0975327fe$export$68d8715fc104d294;
$f88af1c0975327fe$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$f88af1c0975327fe$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});






parcelRegister("1ccU6", function(module, exports) {

$parcel$export(module.exports, "RouterProvider", function () { return $0df0ebdaa156830c$export$323e4fc2fa4753fb; });

var $4TLFw = parcelRequire("4TLFw");

var $3nEVw = parcelRequire("3nEVw");

var $3l2Mo = parcelRequire("3l2Mo");
function $0df0ebdaa156830c$export$b8d3e69d4b3eff04({ router: router, children: children, ...rest }) {
    router.update({
        ...router.options,
        ...rest,
        context: {
            ...router.options.context,
            ...rest.context
        }
    });
    const routerContext = (0, $3l2Mo.getRouterContext)();
    const provider = /* @__PURE__ */ (0, $4TLFw.jsx)(routerContext.Provider, {
        value: router,
        children: children
    });
    if (router.options.Wrap) return /* @__PURE__ */ (0, $4TLFw.jsx)(router.options.Wrap, {
        children: provider
    });
    return provider;
}
function $0df0ebdaa156830c$export$323e4fc2fa4753fb({ router: router, ...rest }) {
    return /* @__PURE__ */ (0, $4TLFw.jsx)($0df0ebdaa156830c$export$b8d3e69d4b3eff04, {
        router: router,
        ...rest,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $3nEVw.Matches), {})
    });
}

});
parcelRegister("3nEVw", function(module, exports) {

$parcel$export(module.exports, "Matches", function () { return $27634445426a8bda$export$6479cfcac2b87c0; });

var $4TLFw = parcelRequire("4TLFw");

var $jbmdS = parcelRequire("jbmdS");

var $iYKZj = parcelRequire("iYKZj");

var $lH7MM = parcelRequire("lH7MM");

var $2cXZi = parcelRequire("2cXZi");

var $1Fr27 = parcelRequire("1Fr27");

var $7c2Zr = parcelRequire("7c2Zr");

var $fj49X = parcelRequire("fj49X");

var $kdUNM = parcelRequire("kdUNM");

var $cjUu7 = parcelRequire("cjUu7");
function $27634445426a8bda$export$6479cfcac2b87c0() {
    const router = (0, $1Fr27.useRouter)();
    const pendingElement = router.options.defaultPendingComponent ? /* @__PURE__ */ (0, $4TLFw.jsx)(router.options.defaultPendingComponent, {}) : null;
    const ResolvedSuspense = router.isServer || typeof document !== "undefined" && router.clientSsr ? (0, $cjUu7.SafeFragment) : $jbmdS.Suspense;
    const inner = /* @__PURE__ */ (0, $4TLFw.jsxs)(ResolvedSuspense, {
        fallback: pendingElement,
        children: [
            /* @__PURE__ */ (0, $4TLFw.jsx)((0, $7c2Zr.Transitioner), {}),
            /* @__PURE__ */ (0, $4TLFw.jsx)($27634445426a8bda$var$MatchesInner, {})
        ]
    });
    return router.options.InnerWrap ? /* @__PURE__ */ (0, $4TLFw.jsx)(router.options.InnerWrap, {
        children: inner
    }) : inner;
}
function $27634445426a8bda$var$MatchesInner() {
    const matchId = (0, $2cXZi.useRouterState)({
        select: (s)=>{
            var _a;
            return (_a = s.matches[0]) == null ? void 0 : _a.id;
        }
    });
    const resetKey = (0, $2cXZi.useRouterState)({
        select: (s)=>s.loadedAt
    });
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $fj49X.matchContext).Provider, {
        value: matchId,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $lH7MM.CatchBoundary), {
            getResetKey: ()=>resetKey,
            errorComponent: (0, $lH7MM.ErrorComponent),
            onCatch: (error)=>{
                (0, $iYKZj.default)(false, `The following error wasn't caught by any route! At the very least, consider setting an 'errorComponent' in your RootRoute!`);
                (0, $iYKZj.default)(false, error.message || error.toString());
            },
            children: matchId ? /* @__PURE__ */ (0, $4TLFw.jsx)((0, $kdUNM.Match), {
                matchId: matchId
            }) : null
        })
    });
}
function $27634445426a8bda$export$d2ec911fa7f74821() {
    const router = (0, $1Fr27.useRouter)();
    (0, $2cXZi.useRouterState)({
        select: (s)=>{
            var _a;
            return [
                s.location.href,
                (_a = s.resolvedLocation) == null ? void 0 : _a.href,
                s.status
            ];
        },
        structuralSharing: true
    });
    return $jbmdS.useCallback((opts)=>{
        const { pending: pending, caseSensitive: caseSensitive, fuzzy: fuzzy, includeSearch: includeSearch, ...rest } = opts;
        return router.matchRoute(rest, {
            pending: pending,
            caseSensitive: caseSensitive,
            fuzzy: fuzzy,
            includeSearch: includeSearch
        });
    }, [
        router
    ]);
}
function $27634445426a8bda$export$d5ee5e80e8c60ef6(props) {
    const matchRoute = $27634445426a8bda$export$d2ec911fa7f74821();
    const params = matchRoute(props);
    if (typeof props.children === "function") return props.children(params);
    return params ? props.children : null;
}
function $27634445426a8bda$export$2378eb7f5ff86053(opts) {
    return (0, $2cXZi.useRouterState)({
        select: (state)=>{
            const matches = state.matches;
            return (opts == null ? void 0 : opts.select) ? opts.select(matches) : matches;
        },
        structuralSharing: opts == null ? void 0 : opts.structuralSharing
    });
}
function $27634445426a8bda$export$d7cb33aa1707a132(opts) {
    const contextMatchId = $jbmdS.useContext((0, $fj49X.matchContext));
    return $27634445426a8bda$export$2378eb7f5ff86053({
        select: (matches)=>{
            matches = matches.slice(0, matches.findIndex((d)=>d.id === contextMatchId));
            return (opts == null ? void 0 : opts.select) ? opts.select(matches) : matches;
        },
        structuralSharing: opts == null ? void 0 : opts.structuralSharing
    });
}
function $27634445426a8bda$export$e015d889658554d8(opts) {
    const contextMatchId = $jbmdS.useContext((0, $fj49X.matchContext));
    return $27634445426a8bda$export$2378eb7f5ff86053({
        select: (matches)=>{
            matches = matches.slice(matches.findIndex((d)=>d.id === contextMatchId) + 1);
            return (opts == null ? void 0 : opts.select) ? opts.select(matches) : matches;
        },
        structuralSharing: opts == null ? void 0 : opts.structuralSharing
    });
}

});
parcelRegister("7c2Zr", function(module, exports) {

$parcel$export(module.exports, "Transitioner", function () { return $53cbf929493fb910$export$935eb9f0b5d28fbb; });

var $jbmdS = parcelRequire("jbmdS");

var $fleMh = parcelRequire("fleMh");
var $2oA9E = parcelRequire("2oA9E");

var $l70dZ = parcelRequire("l70dZ");

var $1Fr27 = parcelRequire("1Fr27");

var $2cXZi = parcelRequire("2cXZi");
function $53cbf929493fb910$export$935eb9f0b5d28fbb() {
    const router = (0, $1Fr27.useRouter)();
    const mountLoadForRouter = $jbmdS.useRef({
        router: router,
        mounted: false
    });
    const isLoading = (0, $2cXZi.useRouterState)({
        select: ({ isLoading: isLoading2 })=>isLoading2
    });
    const [isTransitioning, setIsTransitioning] = $jbmdS.useState(false);
    const hasPendingMatches = (0, $2cXZi.useRouterState)({
        select: (s)=>s.matches.some((d)=>d.status === "pending"),
        structuralSharing: true
    });
    const previousIsLoading = (0, $l70dZ.usePrevious)(isLoading);
    const isAnyPending = isLoading || isTransitioning || hasPendingMatches;
    const previousIsAnyPending = (0, $l70dZ.usePrevious)(isAnyPending);
    const isPagePending = isLoading || hasPendingMatches;
    const previousIsPagePending = (0, $l70dZ.usePrevious)(isPagePending);
    if (!router.isServer) router.startReactTransition = (fn)=>{
        setIsTransitioning(true);
        $jbmdS.startTransition(()=>{
            fn();
            setIsTransitioning(false);
        });
    };
    $jbmdS.useEffect(()=>{
        const unsub = router.history.subscribe(router.load);
        const nextLocation = router.buildLocation({
            to: router.latestLocation.pathname,
            search: true,
            params: true,
            hash: true,
            state: true,
            _includeValidateSearch: true
        });
        if ((0, $2oA9E.trimPathRight)(router.latestLocation.href) !== (0, $2oA9E.trimPathRight)(nextLocation.href)) router.commitLocation({
            ...nextLocation,
            replace: true
        });
        return ()=>{
            unsub();
        };
    }, [
        router,
        router.history
    ]);
    (0, $l70dZ.useLayoutEffect)(()=>{
        if (typeof window !== "undefined" && router.clientSsr || mountLoadForRouter.current.router === router && mountLoadForRouter.current.mounted) return;
        mountLoadForRouter.current = {
            router: router,
            mounted: true
        };
        const tryLoad = async ()=>{
            try {
                await router.load();
            } catch (err) {
                console.error(err);
            }
        };
        tryLoad();
    }, [
        router
    ]);
    (0, $l70dZ.useLayoutEffect)(()=>{
        if (previousIsLoading && !isLoading) router.emit({
            type: "onLoad",
            // When the new URL has committed, when the new matches have been loaded into state.matches
            ...(0, $fleMh.getLocationChangeInfo)(router.state)
        });
    }, [
        previousIsLoading,
        router,
        isLoading
    ]);
    (0, $l70dZ.useLayoutEffect)(()=>{
        if (previousIsPagePending && !isPagePending) router.emit({
            type: "onBeforeRouteMount",
            ...(0, $fleMh.getLocationChangeInfo)(router.state)
        });
    }, [
        isPagePending,
        previousIsPagePending,
        router
    ]);
    (0, $l70dZ.useLayoutEffect)(()=>{
        if (previousIsAnyPending && !isAnyPending) {
            router.emit({
                type: "onResolved",
                ...(0, $fleMh.getLocationChangeInfo)(router.state)
            });
            router.__store.setState((s)=>({
                    ...s,
                    status: "idle",
                    resolvedLocation: s.location
                }));
        }
    }, [
        isAnyPending,
        previousIsAnyPending,
        router
    ]);
    return null;
}

});
parcelRegister("l70dZ", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", function () { return $f5ea6d02d2740950$export$e5c5a5f917a5871c; });
$parcel$export(module.exports, "usePrevious", function () { return $f5ea6d02d2740950$export$5cae361ad82dce8b; });
$parcel$export(module.exports, "useIntersectionObserver", function () { return $f5ea6d02d2740950$export$a7395f9832c00176; });
$parcel$export(module.exports, "useForwardedRef", function () { return $f5ea6d02d2740950$export$61dc559f8a0b9bcf; });

var $jbmdS = parcelRequire("jbmdS");
function $f5ea6d02d2740950$export$1a8b1350915fe2e0(fn) {
    const fnRef = $jbmdS.useRef(fn);
    fnRef.current = fn;
    const ref = $jbmdS.useRef((...args)=>fnRef.current(...args));
    return ref.current;
}
const $f5ea6d02d2740950$export$e5c5a5f917a5871c = typeof window !== "undefined" ? $jbmdS.useLayoutEffect : $jbmdS.useEffect;
function $f5ea6d02d2740950$export$5cae361ad82dce8b(value) {
    const ref = $jbmdS.useRef({
        value: value,
        prev: null
    });
    const current = ref.current.value;
    if (value !== current) ref.current = {
        value: value,
        prev: current
    };
    return ref.current.prev;
}
function $f5ea6d02d2740950$export$a7395f9832c00176(ref, callback, intersectionObserverOptions = {}, options = {}) {
    const isIntersectionObserverAvailable = $jbmdS.useRef(typeof IntersectionObserver === "function");
    const observerRef = $jbmdS.useRef(null);
    $jbmdS.useEffect(()=>{
        if (!ref.current || !isIntersectionObserverAvailable.current || options.disabled) return;
        observerRef.current = new IntersectionObserver(([entry])=>{
            callback(entry);
        }, intersectionObserverOptions);
        observerRef.current.observe(ref.current);
        return ()=>{
            var _a;
            (_a = observerRef.current) == null || _a.disconnect();
        };
    }, [
        callback,
        intersectionObserverOptions,
        options.disabled,
        ref
    ]);
    return observerRef.current;
}
function $f5ea6d02d2740950$export$61dc559f8a0b9bcf(ref) {
    const innerRef = $jbmdS.useRef(null);
    $jbmdS.useImperativeHandle(ref, ()=>innerRef.current, []);
    return innerRef;
}

});


parcelRegister("fj49X", function(module, exports) {

$parcel$export(module.exports, "matchContext", function () { return $b24bdb654fbbbeee$export$f6b3e78d35813d66; });
$parcel$export(module.exports, "dummyMatchContext", function () { return $b24bdb654fbbbeee$export$c7522a034e937c0c; });

var $jbmdS = parcelRequire("jbmdS");
const $b24bdb654fbbbeee$export$f6b3e78d35813d66 = $jbmdS.createContext(void 0);
const $b24bdb654fbbbeee$export$c7522a034e937c0c = $jbmdS.createContext(void 0);

});

parcelRegister("kdUNM", function(module, exports) {

$parcel$export(module.exports, "Match", function () { return $eb9115375d840b1b$export$f421feb8fad20413; });
$parcel$export(module.exports, "Outlet", function () { return $eb9115375d840b1b$export$910ae8079b2c2852; });

var $4TLFw = parcelRequire("4TLFw");

var $jbmdS = parcelRequire("jbmdS");

var $9GFyS = parcelRequire("9GFyS");

var $iYKZj = parcelRequire("iYKZj");

var $bypHT = parcelRequire("bypHT");
var $fleMh = parcelRequire("fleMh");
var $lxb5Z = parcelRequire("lxb5Z");

var $lH7MM = parcelRequire("lH7MM");

var $2cXZi = parcelRequire("2cXZi");

var $1Fr27 = parcelRequire("1Fr27");

var $64Yjc = parcelRequire("64Yjc");

var $gbTjE = parcelRequire("gbTjE");

var $fj49X = parcelRequire("fj49X");

var $cjUu7 = parcelRequire("cjUu7");

var $4tCwq = parcelRequire("4tCwq");

var $aSkHi = parcelRequire("aSkHi");
const $eb9115375d840b1b$export$f421feb8fad20413 = $jbmdS.memo(function MatchImpl({ matchId: matchId }) {
    var _a, _b;
    const router = (0, $1Fr27.useRouter)();
    const routeId = (0, $2cXZi.useRouterState)({
        select: (s)=>{
            var _a2;
            return (_a2 = s.matches.find((d)=>d.id === matchId)) == null ? void 0 : _a2.routeId;
        }
    });
    (0, $9GFyS.default)(routeId, `Could not find routeId for matchId "${matchId}". Please file an issue!`);
    const route = router.routesById[routeId];
    const PendingComponent = route.options.pendingComponent ?? router.options.defaultPendingComponent;
    const pendingElement = PendingComponent ? /* @__PURE__ */ (0, $4TLFw.jsx)(PendingComponent, {}) : null;
    const routeErrorComponent = route.options.errorComponent ?? router.options.defaultErrorComponent;
    const routeOnCatch = route.options.onCatch ?? router.options.defaultOnCatch;
    const routeNotFoundComponent = route.isRoot ? // If it's the root route, use the globalNotFound option, with fallback to the notFoundRoute's component
    route.options.notFoundComponent ?? ((_a = router.options.notFoundRoute) == null ? void 0 : _a.options.component) : route.options.notFoundComponent;
    const ResolvedSuspenseBoundary = // If we're on the root route, allow forcefully wrapping in suspense
    (!route.isRoot || route.options.wrapInSuspense) && (route.options.wrapInSuspense ?? PendingComponent ?? ((_b = route.options.errorComponent) == null ? void 0 : _b.preload)) ? $jbmdS.Suspense : (0, $cjUu7.SafeFragment);
    const ResolvedCatchBoundary = routeErrorComponent ? (0, $lH7MM.CatchBoundary) : (0, $cjUu7.SafeFragment);
    const ResolvedNotFoundBoundary = routeNotFoundComponent ? (0, $64Yjc.CatchNotFound) : (0, $cjUu7.SafeFragment);
    const resetKey = (0, $2cXZi.useRouterState)({
        select: (s)=>s.loadedAt
    });
    const parentRouteId = (0, $2cXZi.useRouterState)({
        select: (s)=>{
            var _a2;
            const index = s.matches.findIndex((d)=>d.id === matchId);
            return (_a2 = s.matches[index - 1]) == null ? void 0 : _a2.routeId;
        }
    });
    return /* @__PURE__ */ (0, $4TLFw.jsxs)((0, $4TLFw.Fragment), {
        children: [
            /* @__PURE__ */ (0, $4TLFw.jsx)((0, $fj49X.matchContext).Provider, {
                value: matchId,
                children: /* @__PURE__ */ (0, $4TLFw.jsx)(ResolvedSuspenseBoundary, {
                    fallback: pendingElement,
                    children: /* @__PURE__ */ (0, $4TLFw.jsx)(ResolvedCatchBoundary, {
                        getResetKey: ()=>resetKey,
                        errorComponent: routeErrorComponent || (0, $lH7MM.ErrorComponent),
                        onCatch: (error, errorInfo)=>{
                            if ((0, $64Yjc.isNotFound)(error)) throw error;
                            (0, $iYKZj.default)(false, `Error in route match: ${matchId}`);
                            routeOnCatch == null || routeOnCatch(error, errorInfo);
                        },
                        children: /* @__PURE__ */ (0, $4TLFw.jsx)(ResolvedNotFoundBoundary, {
                            fallback: (error)=>{
                                if (!routeNotFoundComponent || error.routeId && error.routeId !== routeId || !error.routeId && !route.isRoot) throw error;
                                return $jbmdS.createElement(routeNotFoundComponent, error);
                            },
                            children: /* @__PURE__ */ (0, $4TLFw.jsx)($eb9115375d840b1b$export$443bf6e486eb935a, {
                                matchId: matchId
                            })
                        })
                    })
                })
            }),
            parentRouteId === (0, $lxb5Z.rootRouteId) && router.options.scrollRestoration ? /* @__PURE__ */ (0, $4TLFw.jsxs)((0, $4TLFw.Fragment), {
                children: [
                    /* @__PURE__ */ (0, $4TLFw.jsx)($eb9115375d840b1b$var$OnRendered, {}),
                    /* @__PURE__ */ (0, $4TLFw.jsx)((0, $aSkHi.ScrollRestoration), {})
                ]
            }) : null
        ]
    });
});
function $eb9115375d840b1b$var$OnRendered() {
    var _a;
    const router = (0, $1Fr27.useRouter)();
    const prevLocationRef = $jbmdS.useRef(void 0);
    return /* @__PURE__ */ (0, $4TLFw.jsx)("script", {
        suppressHydrationWarning: true,
        ref: (el)=>{
            if (el) router.emit({
                type: "onRendered",
                ...(0, $fleMh.getLocationChangeInfo)(router.state)
            });
            else prevLocationRef.current = router.state.resolvedLocation;
        }
    }, (_a = router.state.resolvedLocation) == null ? void 0 : _a.state.key);
}
const $eb9115375d840b1b$export$443bf6e486eb935a = $jbmdS.memo(function MatchInnerImpl({ matchId: matchId }) {
    var _a, _b, _c;
    const router = (0, $1Fr27.useRouter)();
    const { match: match, key: key, routeId: routeId } = (0, $2cXZi.useRouterState)({
        select: (s)=>{
            const matchIndex = s.matches.findIndex((d)=>d.id === matchId);
            const match2 = s.matches[matchIndex];
            const routeId2 = match2.routeId;
            const remountFn = router.routesById[routeId2].options.remountDeps ?? router.options.defaultRemountDeps;
            const remountDeps = remountFn == null ? void 0 : remountFn({
                routeId: routeId2,
                loaderDeps: match2.loaderDeps,
                params: match2._strictParams,
                search: match2._strictSearch
            });
            const key2 = remountDeps ? JSON.stringify(remountDeps) : void 0;
            return {
                key: key2,
                routeId: routeId2,
                match: (0, $bypHT.pick)(match2, [
                    "id",
                    "status",
                    "error"
                ])
            };
        },
        structuralSharing: true
    });
    const route = router.routesById[routeId];
    const out = $jbmdS.useMemo(()=>{
        const Comp = route.options.component ?? router.options.defaultComponent;
        if (Comp) return /* @__PURE__ */ (0, $4TLFw.jsx)(Comp, {}, key);
        return /* @__PURE__ */ (0, $4TLFw.jsx)($eb9115375d840b1b$export$910ae8079b2c2852, {});
    }, [
        key,
        route.options.component,
        router.options.defaultComponent
    ]);
    const RouteErrorComponent = (route.options.errorComponent ?? router.options.defaultErrorComponent) || (0, $lH7MM.ErrorComponent);
    if (match.status === "notFound") {
        (0, $9GFyS.default)((0, $64Yjc.isNotFound)(match.error), "Expected a notFound error");
        return (0, $4tCwq.renderRouteNotFound)(router, route, match.error);
    }
    if (match.status === "redirected") {
        (0, $9GFyS.default)((0, $gbTjE.isRedirect)(match.error), "Expected a redirect error");
        throw (_a = router.getMatch(match.id)) == null ? void 0 : _a.loadPromise;
    }
    if (match.status === "error") {
        if (router.isServer) return /* @__PURE__ */ (0, $4TLFw.jsx)(RouteErrorComponent, {
            error: match.error,
            reset: void 0,
            info: {
                componentStack: ""
            }
        });
        throw match.error;
    }
    if (match.status === "pending") {
        const pendingMinMs = route.options.pendingMinMs ?? router.options.defaultPendingMinMs;
        if (pendingMinMs && !((_b = router.getMatch(match.id)) == null ? void 0 : _b.minPendingPromise)) {
            if (!router.isServer) {
                const minPendingPromise = (0, $bypHT.createControlledPromise)();
                Promise.resolve().then(()=>{
                    router.updateMatch(match.id, (prev)=>({
                            ...prev,
                            minPendingPromise: minPendingPromise
                        }));
                });
                setTimeout(()=>{
                    minPendingPromise.resolve();
                    router.updateMatch(match.id, (prev)=>({
                            ...prev,
                            minPendingPromise: void 0
                        }));
                }, pendingMinMs);
            }
        }
        throw (_c = router.getMatch(match.id)) == null ? void 0 : _c.loadPromise;
    }
    return out;
});
const $eb9115375d840b1b$export$910ae8079b2c2852 = $jbmdS.memo(function OutletImpl() {
    const router = (0, $1Fr27.useRouter)();
    const matchId = $jbmdS.useContext((0, $fj49X.matchContext));
    const routeId = (0, $2cXZi.useRouterState)({
        select: (s)=>{
            var _a;
            return (_a = s.matches.find((d)=>d.id === matchId)) == null ? void 0 : _a.routeId;
        }
    });
    const route = router.routesById[routeId];
    const parentGlobalNotFound = (0, $2cXZi.useRouterState)({
        select: (s)=>{
            const matches = s.matches;
            const parentMatch = matches.find((d)=>d.id === matchId);
            (0, $9GFyS.default)(parentMatch, `Could not find parent match for matchId "${matchId}"`);
            return parentMatch.globalNotFound;
        }
    });
    const childMatchId = (0, $2cXZi.useRouterState)({
        select: (s)=>{
            var _a;
            const matches = s.matches;
            const index = matches.findIndex((d)=>d.id === matchId);
            return (_a = matches[index + 1]) == null ? void 0 : _a.id;
        }
    });
    if (parentGlobalNotFound) return (0, $4tCwq.renderRouteNotFound)(router, route, void 0);
    if (!childMatchId) return null;
    const nextMatch = /* @__PURE__ */ (0, $4TLFw.jsx)($eb9115375d840b1b$export$f421feb8fad20413, {
        matchId: childMatchId
    });
    const pendingElement = router.options.defaultPendingComponent ? /* @__PURE__ */ (0, $4TLFw.jsx)(router.options.defaultPendingComponent, {}) : null;
    if (matchId === (0, $lxb5Z.rootRouteId)) return /* @__PURE__ */ (0, $4TLFw.jsx)($jbmdS.Suspense, {
        fallback: pendingElement,
        children: nextMatch
    });
    return nextMatch;
});

});
parcelRegister("cjUu7", function(module, exports) {

$parcel$export(module.exports, "SafeFragment", function () { return $8f83131c6e53e1f3$export$c5d4c6a51def1c34; });

var $4TLFw = parcelRequire("4TLFw");
function $8f83131c6e53e1f3$export$c5d4c6a51def1c34(props) {
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $4TLFw.Fragment), {
        children: props.children
    });
}

});

parcelRegister("4tCwq", function(module, exports) {

$parcel$export(module.exports, "renderRouteNotFound", function () { return $3427c087efaed135$export$a1a97285826ef395; });

var $4TLFw = parcelRequire("4TLFw");


var $64Yjc = parcelRequire("64Yjc");
function $3427c087efaed135$export$a1a97285826ef395(router, route, data) {
    if (!route.options.notFoundComponent) {
        if (router.options.defaultNotFoundComponent) return /* @__PURE__ */ (0, $4TLFw.jsx)(router.options.defaultNotFoundComponent, {
            data: data
        });
        return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $64Yjc.DefaultGlobalNotFound), {});
    }
    return /* @__PURE__ */ (0, $4TLFw.jsx)(route.options.notFoundComponent, {
        data: data
    });
}

});




parcelRegister("fLsc3", function(module, exports) {

$parcel$export(module.exports, "routeTree", function () { return $468ebbaa766f7f8d$export$49039328c942e39a; });
/* prettier-ignore-start */ /* eslint-disable */ // @ts-nocheck
// noinspection JSUnusedGlobalSymbols
// This file is auto-generated by TanStack Router
// Import Routes

var $dbZ04 = parcelRequire("dbZ04");

var $bP0Np = parcelRequire("bP0Np");

var $ggLDO = parcelRequire("ggLDO");

var $1m9MV = parcelRequire("1m9MV");

var $iXYDh = parcelRequire("iXYDh");

var $k9jTK = parcelRequire("k9jTK");

var $37AX6 = parcelRequire("37AX6");

var $93uGj = parcelRequire("93uGj");

var $9S1YO = parcelRequire("9S1YO");

var $ci48B = parcelRequire("ci48B");

var $463Z5 = parcelRequire("463Z5");

var $g96il = parcelRequire("g96il");

var $2Mbj3 = parcelRequire("2Mbj3");

var $kVeQ2 = parcelRequire("kVeQ2");

var $iUmlO = parcelRequire("iUmlO");

var $dW6fO = parcelRequire("dW6fO");

var $dTHhw = parcelRequire("dTHhw");

var $8MUwN = parcelRequire("8MUwN");

var $lGluJ = parcelRequire("lGluJ");

var $gvozO = parcelRequire("gvozO");

var $h5272 = parcelRequire("h5272");

var $faU8f = parcelRequire("faU8f");

var $3OLHb = parcelRequire("3OLHb");

var $d5UIc = parcelRequire("d5UIc");

var $iJYn9 = parcelRequire("iJYn9");

var $613DC = parcelRequire("613DC");

var $gtJL8 = parcelRequire("gtJL8");

var $9xWjB = parcelRequire("9xWjB");

var $72qTN = parcelRequire("72qTN");

var $eAAaV = parcelRequire("eAAaV");

var $lB9TH = parcelRequire("lB9TH");

var $cLkcu = parcelRequire("cLkcu");

var $e9SYy = parcelRequire("e9SYy");

var $kTc56 = parcelRequire("kTc56");

var $1b01r = parcelRequire("1b01r");

var $emBvU = parcelRequire("emBvU");

var $1nQXs = parcelRequire("1nQXs");

var $5krgq = parcelRequire("5krgq");

var $bumJt = parcelRequire("bumJt");

var $4q8p1 = parcelRequire("4q8p1");

var $cnp7l = parcelRequire("cnp7l");

var $blRVa = parcelRequire("blRVa");

var $9lWnL = parcelRequire("9lWnL");

var $1z0aX = parcelRequire("1z0aX");

var $6HIWs = parcelRequire("6HIWs");

var $4q3wj = parcelRequire("4q3wj");
// Create/Update Routes
const $468ebbaa766f7f8d$var$PublicRoute = (0, $bP0Np.Route).update({
    id: "/_public",
    getParentRoute: ()=>(0, $dbZ04.Route)
});
const $468ebbaa766f7f8d$var$PrivateRoute = (0, $ggLDO.Route).update({
    id: "/_private",
    getParentRoute: ()=>(0, $dbZ04.Route)
});
const $468ebbaa766f7f8d$var$IndexRoute = (0, $1m9MV.Route).update({
    id: "/",
    path: "/",
    getParentRoute: ()=>(0, $dbZ04.Route)
});
const $468ebbaa766f7f8d$var$PublicSignUpRoute = (0, $iXYDh.Route).update({
    id: "/sign-up",
    path: "/sign-up",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PublicRoute
});
const $468ebbaa766f7f8d$var$PublicSignInRoute = (0, $k9jTK.Route).update({
    id: "/sign-in",
    path: "/sign-in",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PublicRoute
});
const $468ebbaa766f7f8d$var$PublicResetPasswordRoute = (0, $37AX6.Route).update({
    id: "/reset-password",
    path: "/reset-password",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PublicRoute
});
const $468ebbaa766f7f8d$var$PublicRegisterDetailsRoute = (0, $93uGj.Route).update({
    id: "/register-details",
    path: "/register-details",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PublicRoute
});
const $468ebbaa766f7f8d$var$PublicRegisterRoute = (0, $9S1YO.Route).update({
    id: "/register",
    path: "/register",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PublicRoute
});
const $468ebbaa766f7f8d$var$PublicLoginRoute = (0, $ci48B.Route).update({
    id: "/login",
    path: "/login",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PublicRoute
});
const $468ebbaa766f7f8d$var$PublicInviteRoute = (0, $463Z5.Route).update({
    id: "/invite",
    path: "/invite",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PublicRoute
});
const $468ebbaa766f7f8d$var$PublicForgottenPasswordRoute = (0, $g96il.Route).update({
    id: "/forgotten-password",
    path: "/forgotten-password",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PublicRoute
});
const $468ebbaa766f7f8d$var$PublicActivateAccountRoute = (0, $2Mbj3.Route).update({
    id: "/activate-account",
    path: "/activate-account",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PublicRoute
});
const $468ebbaa766f7f8d$var$PrivateWeeklyPlanningRoute = (0, $kVeQ2.Route).update({
    id: "/weekly-planning",
    path: "/weekly-planning",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PrivateRoute
});
const $468ebbaa766f7f8d$var$PrivateTrackExpensesRoute = (0, $iUmlO.Route).update({
    id: "/track-expenses",
    path: "/track-expenses",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PrivateRoute
});
const $468ebbaa766f7f8d$var$PrivateSuppliersRoute = (0, $dW6fO.Route).update({
    id: "/suppliers",
    path: "/suppliers",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PrivateRoute
});
const $468ebbaa766f7f8d$var$PrivateSettingsRoute = (0, $dTHhw.Route).update({
    id: "/settings",
    path: "/settings",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PrivateRoute
});
const $468ebbaa766f7f8d$var$PrivateRevenueForecast2Route = (0, $8MUwN.Route).update({
    id: "/revenue-forecast2",
    path: "/revenue-forecast2",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PrivateRoute
});
const $468ebbaa766f7f8d$var$PrivateRevenueForecastRoute = (0, $lGluJ.Route).update({
    id: "/revenue-forecast",
    path: "/revenue-forecast",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PrivateRoute
});
const $468ebbaa766f7f8d$var$PrivateResourceScheduleRoute = (0, $gvozO.Route).update({
    id: "/resource-schedule",
    path: "/resource-schedule",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PrivateRoute
});
const $468ebbaa766f7f8d$var$PrivateOverheadExpensesRoute = (0, $h5272.Route).update({
    id: "/overhead-expenses",
    path: "/overhead-expenses",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PrivateRoute
});
const $468ebbaa766f7f8d$var$PrivateOrganisationHolidaysRoute = (0, $faU8f.Route).update({
    id: "/organisation-holidays",
    path: "/organisation-holidays",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PrivateRoute
});
const $468ebbaa766f7f8d$var$PrivateFeedbackAuthRoute = (0, $3OLHb.Route).update({
    id: "/feedback-auth",
    path: "/feedback-auth",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PrivateRoute
});
const $468ebbaa766f7f8d$var$PrivateExpenseReportsRoute = (0, $d5UIc.Route).update({
    id: "/expense-reports",
    path: "/expense-reports",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PrivateRoute
});
const $468ebbaa766f7f8d$var$PrivateBillingRoute = (0, $iJYn9.Route).update({
    id: "/billing",
    path: "/billing",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PrivateRoute
});
const $468ebbaa766f7f8d$var$PrivateTimesheetsIndexRoute = (0, $613DC.Route).update({
    id: "/timesheets/",
    path: "/timesheets/",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PrivateRoute
});
const $468ebbaa766f7f8d$var$PrivateStaffIndexRoute = (0, $gtJL8.Route).update({
    id: "/staff/",
    path: "/staff/",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PrivateRoute
});
const $468ebbaa766f7f8d$var$PrivateStaffRolesIndexRoute = (0, $9xWjB.Route).update({
    id: "/staff-roles/",
    path: "/staff-roles/",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PrivateRoute
});
const $468ebbaa766f7f8d$var$PrivateProjectsIndexRoute = (0, $72qTN.Route).update({
    id: "/projects/",
    path: "/projects/",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PrivateRoute
});
const $468ebbaa766f7f8d$var$PrivatePermissionsIndexRoute = (0, $eAAaV.Route).update({
    id: "/permissions/",
    path: "/permissions/",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PrivateRoute
});
const $468ebbaa766f7f8d$var$PrivateInvoicesIndexRoute = (0, $lB9TH.Route).update({
    id: "/invoices/",
    path: "/invoices/",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PrivateRoute
});
const $468ebbaa766f7f8d$var$PrivateCostCentresIndexRoute = (0, $cLkcu.Route).update({
    id: "/cost-centres/",
    path: "/cost-centres/",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PrivateRoute
});
const $468ebbaa766f7f8d$var$PrivateContactsIndexRoute = (0, $e9SYy.Route).update({
    id: "/contacts/",
    path: "/contacts/",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PrivateRoute
});
const $468ebbaa766f7f8d$var$PrivateTimesheetsReportRoute = (0, $kTc56.Route).update({
    id: "/timesheets/report",
    path: "/timesheets/report",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PrivateRoute
});
const $468ebbaa766f7f8d$var$PrivateTimesheetsCalendarRoute = (0, $1b01r.Route).update({
    id: "/timesheets/calendar",
    path: "/timesheets/calendar",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PrivateRoute
});
const $468ebbaa766f7f8d$var$PrivateStaffIdRoute = (0, $emBvU.Route).update({
    id: "/staff/$id",
    path: "/staff/$id",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PrivateRoute
});
const $468ebbaa766f7f8d$var$PrivateStaffRolesIdRoute = (0, $1nQXs.Route).update({
    id: "/staff-roles/$id",
    path: "/staff-roles/$id",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PrivateRoute
});
const $468ebbaa766f7f8d$var$PrivateProjectsIdRoute = (0, $5krgq.Route).update({
    id: "/projects/$id",
    path: "/projects/$id",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PrivateRoute
});
const $468ebbaa766f7f8d$var$PrivatePermissionsIdRoute = (0, $bumJt.Route).update({
    id: "/permissions/$id",
    path: "/permissions/$id",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PrivateRoute
});
const $468ebbaa766f7f8d$var$PrivateMigrateIdRoute = (0, $4q8p1.Route).update({
    id: "/migrate/$id",
    path: "/migrate/$id",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PrivateRoute
});
const $468ebbaa766f7f8d$var$PrivateImpersonateEmailRoute = (0, $cnp7l.Route).update({
    id: "/impersonate/$email",
    path: "/impersonate/$email",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PrivateRoute
});
const $468ebbaa766f7f8d$var$PrivateCostCentresIdRoute = (0, $blRVa.Route).update({
    id: "/cost-centres/$id",
    path: "/cost-centres/$id",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PrivateRoute
});
const $468ebbaa766f7f8d$var$PrivateContactsIdRoute = (0, $9lWnL.Route).update({
    id: "/contacts/$id",
    path: "/contacts/$id",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PrivateRoute
});
const $468ebbaa766f7f8d$var$PrivateAccountingAuthRoute = (0, $1z0aX.Route).update({
    id: "/accounting/auth",
    path: "/accounting/auth",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PrivateRoute
});
const $468ebbaa766f7f8d$var$PrivateInvoicesIdIndexRoute = (0, $6HIWs.Route).update({
    id: "/invoices/$id/",
    path: "/invoices/$id/",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PrivateRoute
});
const $468ebbaa766f7f8d$var$PrivateInvoicesIdPdfRoute = (0, $4q3wj.Route).update({
    id: "/invoices/$id/pdf",
    path: "/invoices/$id/pdf",
    getParentRoute: ()=>$468ebbaa766f7f8d$var$PrivateRoute
});
const $468ebbaa766f7f8d$var$PrivateRouteChildren = {
    PrivateBillingRoute: $468ebbaa766f7f8d$var$PrivateBillingRoute,
    PrivateExpenseReportsRoute: $468ebbaa766f7f8d$var$PrivateExpenseReportsRoute,
    PrivateFeedbackAuthRoute: $468ebbaa766f7f8d$var$PrivateFeedbackAuthRoute,
    PrivateOrganisationHolidaysRoute: $468ebbaa766f7f8d$var$PrivateOrganisationHolidaysRoute,
    PrivateOverheadExpensesRoute: $468ebbaa766f7f8d$var$PrivateOverheadExpensesRoute,
    PrivateResourceScheduleRoute: $468ebbaa766f7f8d$var$PrivateResourceScheduleRoute,
    PrivateRevenueForecastRoute: $468ebbaa766f7f8d$var$PrivateRevenueForecastRoute,
    PrivateRevenueForecast2Route: $468ebbaa766f7f8d$var$PrivateRevenueForecast2Route,
    PrivateSettingsRoute: $468ebbaa766f7f8d$var$PrivateSettingsRoute,
    PrivateSuppliersRoute: $468ebbaa766f7f8d$var$PrivateSuppliersRoute,
    PrivateTrackExpensesRoute: $468ebbaa766f7f8d$var$PrivateTrackExpensesRoute,
    PrivateWeeklyPlanningRoute: $468ebbaa766f7f8d$var$PrivateWeeklyPlanningRoute,
    PrivateAccountingAuthRoute: $468ebbaa766f7f8d$var$PrivateAccountingAuthRoute,
    PrivateContactsIdRoute: $468ebbaa766f7f8d$var$PrivateContactsIdRoute,
    PrivateCostCentresIdRoute: $468ebbaa766f7f8d$var$PrivateCostCentresIdRoute,
    PrivateImpersonateEmailRoute: $468ebbaa766f7f8d$var$PrivateImpersonateEmailRoute,
    PrivateMigrateIdRoute: $468ebbaa766f7f8d$var$PrivateMigrateIdRoute,
    PrivatePermissionsIdRoute: $468ebbaa766f7f8d$var$PrivatePermissionsIdRoute,
    PrivateProjectsIdRoute: $468ebbaa766f7f8d$var$PrivateProjectsIdRoute,
    PrivateStaffRolesIdRoute: $468ebbaa766f7f8d$var$PrivateStaffRolesIdRoute,
    PrivateStaffIdRoute: $468ebbaa766f7f8d$var$PrivateStaffIdRoute,
    PrivateTimesheetsCalendarRoute: $468ebbaa766f7f8d$var$PrivateTimesheetsCalendarRoute,
    PrivateTimesheetsReportRoute: $468ebbaa766f7f8d$var$PrivateTimesheetsReportRoute,
    PrivateContactsIndexRoute: $468ebbaa766f7f8d$var$PrivateContactsIndexRoute,
    PrivateCostCentresIndexRoute: $468ebbaa766f7f8d$var$PrivateCostCentresIndexRoute,
    PrivateInvoicesIndexRoute: $468ebbaa766f7f8d$var$PrivateInvoicesIndexRoute,
    PrivatePermissionsIndexRoute: $468ebbaa766f7f8d$var$PrivatePermissionsIndexRoute,
    PrivateProjectsIndexRoute: $468ebbaa766f7f8d$var$PrivateProjectsIndexRoute,
    PrivateStaffRolesIndexRoute: $468ebbaa766f7f8d$var$PrivateStaffRolesIndexRoute,
    PrivateStaffIndexRoute: $468ebbaa766f7f8d$var$PrivateStaffIndexRoute,
    PrivateTimesheetsIndexRoute: $468ebbaa766f7f8d$var$PrivateTimesheetsIndexRoute,
    PrivateInvoicesIdPdfRoute: $468ebbaa766f7f8d$var$PrivateInvoicesIdPdfRoute,
    PrivateInvoicesIdIndexRoute: $468ebbaa766f7f8d$var$PrivateInvoicesIdIndexRoute
};
const $468ebbaa766f7f8d$var$PrivateRouteWithChildren = $468ebbaa766f7f8d$var$PrivateRoute._addFileChildren($468ebbaa766f7f8d$var$PrivateRouteChildren);
const $468ebbaa766f7f8d$var$PublicRouteChildren = {
    PublicActivateAccountRoute: $468ebbaa766f7f8d$var$PublicActivateAccountRoute,
    PublicForgottenPasswordRoute: $468ebbaa766f7f8d$var$PublicForgottenPasswordRoute,
    PublicInviteRoute: $468ebbaa766f7f8d$var$PublicInviteRoute,
    PublicLoginRoute: $468ebbaa766f7f8d$var$PublicLoginRoute,
    PublicRegisterRoute: $468ebbaa766f7f8d$var$PublicRegisterRoute,
    PublicRegisterDetailsRoute: $468ebbaa766f7f8d$var$PublicRegisterDetailsRoute,
    PublicResetPasswordRoute: $468ebbaa766f7f8d$var$PublicResetPasswordRoute,
    PublicSignInRoute: $468ebbaa766f7f8d$var$PublicSignInRoute,
    PublicSignUpRoute: $468ebbaa766f7f8d$var$PublicSignUpRoute
};
const $468ebbaa766f7f8d$var$PublicRouteWithChildren = $468ebbaa766f7f8d$var$PublicRoute._addFileChildren($468ebbaa766f7f8d$var$PublicRouteChildren);
const $468ebbaa766f7f8d$var$rootRouteChildren = {
    IndexRoute: $468ebbaa766f7f8d$var$IndexRoute,
    PrivateRoute: $468ebbaa766f7f8d$var$PrivateRouteWithChildren,
    PublicRoute: $468ebbaa766f7f8d$var$PublicRouteWithChildren
};
const $468ebbaa766f7f8d$export$49039328c942e39a = (0, $dbZ04.Route)._addFileChildren($468ebbaa766f7f8d$var$rootRouteChildren)._addFileTypes(); /* prettier-ignore-end */  /* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.js",
      "children": [
        "/",
        "/_private",
        "/_public"
      ]
    },
    "/": {
      "filePath": "index.js"
    },
    "/_private": {
      "filePath": "_private.js",
      "children": [
        "/_private/billing",
        "/_private/expense-reports",
        "/_private/feedback-auth",
        "/_private/organisation-holidays",
        "/_private/overhead-expenses",
        "/_private/resource-schedule",
        "/_private/revenue-forecast",
        "/_private/revenue-forecast2",
        "/_private/settings",
        "/_private/suppliers",
        "/_private/track-expenses",
        "/_private/weekly-planning",
        "/_private/accounting/auth",
        "/_private/contacts/$id",
        "/_private/cost-centres/$id",
        "/_private/impersonate/$email",
        "/_private/migrate/$id",
        "/_private/permissions/$id",
        "/_private/projects/$id",
        "/_private/staff-roles/$id",
        "/_private/staff/$id",
        "/_private/timesheets/calendar",
        "/_private/timesheets/report",
        "/_private/contacts/",
        "/_private/cost-centres/",
        "/_private/invoices/",
        "/_private/permissions/",
        "/_private/projects/",
        "/_private/staff-roles/",
        "/_private/staff/",
        "/_private/timesheets/",
        "/_private/invoices/$id/pdf",
        "/_private/invoices/$id/"
      ]
    },
    "/_public": {
      "filePath": "_public.js",
      "children": [
        "/_public/activate-account",
        "/_public/forgotten-password",
        "/_public/invite",
        "/_public/login",
        "/_public/register",
        "/_public/register-details",
        "/_public/reset-password",
        "/_public/sign-in",
        "/_public/sign-up"
      ]
    },
    "/_private/billing": {
      "filePath": "_private/billing.js",
      "parent": "/_private"
    },
    "/_private/expense-reports": {
      "filePath": "_private/expense-reports.js",
      "parent": "/_private"
    },
    "/_private/feedback-auth": {
      "filePath": "_private/feedback-auth.js",
      "parent": "/_private"
    },
    "/_private/organisation-holidays": {
      "filePath": "_private/organisation-holidays.js",
      "parent": "/_private"
    },
    "/_private/overhead-expenses": {
      "filePath": "_private/overhead-expenses.js",
      "parent": "/_private"
    },
    "/_private/resource-schedule": {
      "filePath": "_private/resource-schedule.js",
      "parent": "/_private"
    },
    "/_private/revenue-forecast": {
      "filePath": "_private/revenue-forecast.js",
      "parent": "/_private"
    },
    "/_private/revenue-forecast2": {
      "filePath": "_private/revenue-forecast2.js",
      "parent": "/_private"
    },
    "/_private/settings": {
      "filePath": "_private/settings.js",
      "parent": "/_private"
    },
    "/_private/suppliers": {
      "filePath": "_private/suppliers.js",
      "parent": "/_private"
    },
    "/_private/track-expenses": {
      "filePath": "_private/track-expenses.js",
      "parent": "/_private"
    },
    "/_private/weekly-planning": {
      "filePath": "_private/weekly-planning.js",
      "parent": "/_private"
    },
    "/_public/activate-account": {
      "filePath": "_public/activate-account.js",
      "parent": "/_public"
    },
    "/_public/forgotten-password": {
      "filePath": "_public/forgotten-password.js",
      "parent": "/_public"
    },
    "/_public/invite": {
      "filePath": "_public/invite.js",
      "parent": "/_public"
    },
    "/_public/login": {
      "filePath": "_public/login.js",
      "parent": "/_public"
    },
    "/_public/register": {
      "filePath": "_public/register.js",
      "parent": "/_public"
    },
    "/_public/register-details": {
      "filePath": "_public/register-details.js",
      "parent": "/_public"
    },
    "/_public/reset-password": {
      "filePath": "_public/reset-password.js",
      "parent": "/_public"
    },
    "/_public/sign-in": {
      "filePath": "_public/sign-in.js",
      "parent": "/_public"
    },
    "/_public/sign-up": {
      "filePath": "_public/sign-up.js",
      "parent": "/_public"
    },
    "/_private/accounting/auth": {
      "filePath": "_private/accounting.auth.js",
      "parent": "/_private"
    },
    "/_private/contacts/$id": {
      "filePath": "_private/contacts.$id.js",
      "parent": "/_private"
    },
    "/_private/cost-centres/$id": {
      "filePath": "_private/cost-centres.$id.js",
      "parent": "/_private"
    },
    "/_private/impersonate/$email": {
      "filePath": "_private/impersonate.$email.js",
      "parent": "/_private"
    },
    "/_private/migrate/$id": {
      "filePath": "_private/migrate.$id.js",
      "parent": "/_private"
    },
    "/_private/permissions/$id": {
      "filePath": "_private/permissions.$id.js",
      "parent": "/_private"
    },
    "/_private/projects/$id": {
      "filePath": "_private/projects.$id.js",
      "parent": "/_private"
    },
    "/_private/staff-roles/$id": {
      "filePath": "_private/staff-roles.$id.js",
      "parent": "/_private"
    },
    "/_private/staff/$id": {
      "filePath": "_private/staff.$id.js",
      "parent": "/_private"
    },
    "/_private/timesheets/calendar": {
      "filePath": "_private/timesheets.calendar.js",
      "parent": "/_private"
    },
    "/_private/timesheets/report": {
      "filePath": "_private/timesheets.report.js",
      "parent": "/_private"
    },
    "/_private/contacts/": {
      "filePath": "_private/contacts.index.js",
      "parent": "/_private"
    },
    "/_private/cost-centres/": {
      "filePath": "_private/cost-centres.index.js",
      "parent": "/_private"
    },
    "/_private/invoices/": {
      "filePath": "_private/invoices.index.js",
      "parent": "/_private"
    },
    "/_private/permissions/": {
      "filePath": "_private/permissions.index.js",
      "parent": "/_private"
    },
    "/_private/projects/": {
      "filePath": "_private/projects.index.js",
      "parent": "/_private"
    },
    "/_private/staff-roles/": {
      "filePath": "_private/staff-roles.index.js",
      "parent": "/_private"
    },
    "/_private/staff/": {
      "filePath": "_private/staff.index.js",
      "parent": "/_private"
    },
    "/_private/timesheets/": {
      "filePath": "_private/timesheets.index.js",
      "parent": "/_private"
    },
    "/_private/invoices/$id/pdf": {
      "filePath": "_private/invoices.$id.pdf.js",
      "parent": "/_private"
    },
    "/_private/invoices/$id/": {
      "filePath": "_private/invoices.$id.index.js",
      "parent": "/_private"
    }
  }
}
ROUTE_MANIFEST_END */ 

});
parcelRegister("dbZ04", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $99ab9ecf53c4467e$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $g9auw = parcelRequire("g9auw");
var $kdUNM = parcelRequire("kdUNM");


var $5PXcS = parcelRequire("5PXcS");

var $4iw5i = parcelRequire("4iw5i");
const $99ab9ecf53c4467e$var$isDev = false;
const $99ab9ecf53c4467e$export$e7b0ac011bb776c6 = (0, $g9auw.createRootRoute)({
    component: $99ab9ecf53c4467e$var$RootComponent,
    pendingComponent: (0, $4iw5i.default),
    errorComponent: ({ error: error, reset: reset })=>{
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    }
});
function $99ab9ecf53c4467e$var$RootComponent() {
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kdUNM.Outlet), {})
    });
}

});
parcelRegister("g9auw", function(module, exports) {

$parcel$export(module.exports, "createRoute", function () { return $bc159ff9e2b6a887$export$544c268deaca2597; });
$parcel$export(module.exports, "createRootRoute", function () { return $bc159ff9e2b6a887$export$f20dca7d42ad6c55; });

var $9GFyS = parcelRequire("9GFyS");

var $2oA9E = parcelRequire("2oA9E");
var $lxb5Z = parcelRequire("lxb5Z");

var $hP8Kk = parcelRequire("hP8Kk");

var $5ofNy = parcelRequire("5ofNy");

var $lY8aZ = parcelRequire("lY8aZ");

var $5zaoU = parcelRequire("5zaoU");

var $64Yjc = parcelRequire("64Yjc");

var $6UBLf = parcelRequire("6UBLf");

var $4huLw = parcelRequire("4huLw");
function $bc159ff9e2b6a887$export$2126b6733cfe90ec(id) {
    return new $bc159ff9e2b6a887$export$18266edfd2f3dc40({
        id: id
    });
}
class $bc159ff9e2b6a887$export$18266edfd2f3dc40 {
    /**
   * @deprecated Use the `getRouteApi` function instead.
   */ constructor({ id: id }){
        this.useMatch = (opts)=>{
            return (0, $4huLw.useMatch)({
                select: opts == null ? void 0 : opts.select,
                from: this.id,
                structuralSharing: opts == null ? void 0 : opts.structuralSharing
            });
        };
        this.useRouteContext = (opts)=>{
            return (0, $4huLw.useMatch)({
                from: this.id,
                select: (d)=>(opts == null ? void 0 : opts.select) ? opts.select(d.context) : d.context
            });
        };
        this.useSearch = (opts)=>{
            return (0, $5zaoU.useSearch)({
                select: opts == null ? void 0 : opts.select,
                structuralSharing: opts == null ? void 0 : opts.structuralSharing,
                from: this.id
            });
        };
        this.useParams = (opts)=>{
            return (0, $lY8aZ.useParams)({
                select: opts == null ? void 0 : opts.select,
                structuralSharing: opts == null ? void 0 : opts.structuralSharing,
                from: this.id
            });
        };
        this.useLoaderDeps = (opts)=>{
            return (0, $5ofNy.useLoaderDeps)({
                ...opts,
                from: this.id,
                strict: false
            });
        };
        this.useLoaderData = (opts)=>{
            return (0, $hP8Kk.useLoaderData)({
                ...opts,
                from: this.id,
                strict: false
            });
        };
        this.useNavigate = ()=>{
            return (0, $6UBLf.useNavigate)({
                from: this.id
            });
        };
        this.notFound = (opts)=>{
            return (0, $64Yjc.notFound)({
                routeId: this.id,
                ...opts
            });
        };
        this.id = id;
    }
}
class $bc159ff9e2b6a887$export$e7b0ac011bb776c6 {
    /**
   * @deprecated Use the `createRoute` function instead.
   */ constructor(options){
        this.init = (opts)=>{
            var _a, _b;
            this.originalIndex = opts.originalIndex;
            const options2 = this.options;
            const isRoot = !(options2 == null ? void 0 : options2.path) && !(options2 == null ? void 0 : options2.id);
            this.parentRoute = (_b = (_a = this.options).getParentRoute) == null ? void 0 : _b.call(_a);
            if (isRoot) this._path = (0, $lxb5Z.rootRouteId);
            else (0, $9GFyS.default)(this.parentRoute, `Child Route instances must pass a 'getParentRoute: () => ParentRoute' option that returns a Route instance.`);
            let path = isRoot ? (0, $lxb5Z.rootRouteId) : options2.path;
            if (path && path !== "/") path = (0, $2oA9E.trimPathLeft)(path);
            const customId = (options2 == null ? void 0 : options2.id) || path;
            let id = isRoot ? (0, $lxb5Z.rootRouteId) : (0, $2oA9E.joinPaths)([
                this.parentRoute.id === (0, $lxb5Z.rootRouteId) ? "" : this.parentRoute.id,
                customId
            ]);
            if (path === (0, $lxb5Z.rootRouteId)) path = "/";
            if (id !== (0, $lxb5Z.rootRouteId)) id = (0, $2oA9E.joinPaths)([
                "/",
                id
            ]);
            const fullPath = id === (0, $lxb5Z.rootRouteId) ? "/" : (0, $2oA9E.joinPaths)([
                this.parentRoute.fullPath,
                path
            ]);
            this._path = path;
            this._id = id;
            this._fullPath = fullPath;
            this._to = fullPath;
            this._ssr = (options2 == null ? void 0 : options2.ssr) ?? opts.defaultSsr ?? true;
        };
        this.updateLoader = (options2)=>{
            Object.assign(this.options, options2);
            return this;
        };
        this.update = (options2)=>{
            Object.assign(this.options, options2);
            return this;
        };
        this.lazy = (lazyFn)=>{
            this.lazyFn = lazyFn;
            return this;
        };
        this.useMatch = (opts)=>{
            return (0, $4huLw.useMatch)({
                select: opts == null ? void 0 : opts.select,
                from: this.id,
                structuralSharing: opts == null ? void 0 : opts.structuralSharing
            });
        };
        this.useRouteContext = (opts)=>{
            return (0, $4huLw.useMatch)({
                ...opts,
                from: this.id,
                select: (d)=>(opts == null ? void 0 : opts.select) ? opts.select(d.context) : d.context
            });
        };
        this.useSearch = (opts)=>{
            return (0, $5zaoU.useSearch)({
                select: opts == null ? void 0 : opts.select,
                structuralSharing: opts == null ? void 0 : opts.structuralSharing,
                from: this.id
            });
        };
        this.useParams = (opts)=>{
            return (0, $lY8aZ.useParams)({
                select: opts == null ? void 0 : opts.select,
                structuralSharing: opts == null ? void 0 : opts.structuralSharing,
                from: this.id
            });
        };
        this.useLoaderDeps = (opts)=>{
            return (0, $5ofNy.useLoaderDeps)({
                ...opts,
                from: this.id
            });
        };
        this.useLoaderData = (opts)=>{
            return (0, $hP8Kk.useLoaderData)({
                ...opts,
                from: this.id
            });
        };
        this.useNavigate = ()=>{
            return (0, $6UBLf.useNavigate)({
                from: this.id
            });
        };
        this.options = options || {};
        this.isRoot = !(options == null ? void 0 : options.getParentRoute);
        (0, $9GFyS.default)(!((options == null ? void 0 : options.id) && (options == null ? void 0 : options.path)), `Route cannot have both an 'id' and a 'path' option.`);
        this.$$typeof = Symbol.for("react.memo");
    }
    get to() {
        return this._to;
    }
    get id() {
        return this._id;
    }
    get path() {
        return this._path;
    }
    get fullPath() {
        return this._fullPath;
    }
    get ssr() {
        return this._ssr;
    }
    addChildren(children) {
        return this._addFileChildren(children);
    }
    _addFileChildren(children) {
        if (Array.isArray(children)) this.children = children;
        if (typeof children === "object" && children !== null) this.children = Object.values(children);
        return this;
    }
}
function $bc159ff9e2b6a887$export$544c268deaca2597(options) {
    return new $bc159ff9e2b6a887$export$e7b0ac011bb776c6(options);
}
function $bc159ff9e2b6a887$export$85dd0dd8ccd4f994() {
    return (options)=>{
        return $bc159ff9e2b6a887$export$f20dca7d42ad6c55(options);
    };
}
const $bc159ff9e2b6a887$export$c4c228ca163d4e39 = $bc159ff9e2b6a887$export$85dd0dd8ccd4f994;
class $bc159ff9e2b6a887$export$6bfafc1e0f16edbd extends $bc159ff9e2b6a887$export$e7b0ac011bb776c6 {
    /**
   * @deprecated `RootRoute` is now an internal implementation detail. Use `createRootRoute()` instead.
   */ constructor(options){
        super(options);
    }
    addChildren(children) {
        super.addChildren(children);
        return this;
    }
    _addFileChildren(children) {
        super._addFileChildren(children);
        return this;
    }
    _addFileTypes() {
        return this;
    }
}
function $bc159ff9e2b6a887$export$f20dca7d42ad6c55(options) {
    return new $bc159ff9e2b6a887$export$6bfafc1e0f16edbd(options);
}
function $bc159ff9e2b6a887$export$9b5cbca98b37c390(opts) {
    return opts;
}
class $bc159ff9e2b6a887$export$e389bcff300d6f45 extends $bc159ff9e2b6a887$export$e7b0ac011bb776c6 {
    constructor(options){
        super({
            ...options,
            id: "404"
        });
    }
}

});
parcelRegister("hP8Kk", function(module, exports) {

$parcel$export(module.exports, "useLoaderData", function () { return $cf9dfbed90474c63$export$1448a5050d252c4d; });

var $4huLw = parcelRequire("4huLw");
function $cf9dfbed90474c63$export$1448a5050d252c4d(opts) {
    return (0, $4huLw.useMatch)({
        from: opts.from,
        strict: opts.strict,
        structuralSharing: opts.structuralSharing,
        select: (s)=>{
            return opts.select ? opts.select(s.loaderData) : s.loaderData;
        }
    });
}

});
parcelRegister("4huLw", function(module, exports) {

$parcel$export(module.exports, "useMatch", function () { return $31e09d5b051ce514$export$6c330e8992e8a295; });

var $jbmdS = parcelRequire("jbmdS");

var $9GFyS = parcelRequire("9GFyS");

var $2cXZi = parcelRequire("2cXZi");

var $fj49X = parcelRequire("fj49X");
function $31e09d5b051ce514$export$6c330e8992e8a295(opts) {
    const nearestMatchId = $jbmdS.useContext(opts.from ? (0, $fj49X.dummyMatchContext) : (0, $fj49X.matchContext));
    const matchSelection = (0, $2cXZi.useRouterState)({
        select: (state)=>{
            const match = state.matches.find((d)=>opts.from ? opts.from === d.routeId : d.id === nearestMatchId);
            (0, $9GFyS.default)(!((opts.shouldThrow ?? true) && !match), `Could not find ${opts.from ? `an active match from "${opts.from}"` : "a nearest match!"}`);
            if (match === void 0) return void 0;
            return opts.select ? opts.select(match) : match;
        },
        structuralSharing: opts.structuralSharing
    });
    return matchSelection;
}

});


parcelRegister("5ofNy", function(module, exports) {

$parcel$export(module.exports, "useLoaderDeps", function () { return $3ecb72dc077dc9a4$export$5b1319df652b0246; });

var $4huLw = parcelRequire("4huLw");
function $3ecb72dc077dc9a4$export$5b1319df652b0246(opts) {
    const { select: select, ...rest } = opts;
    return (0, $4huLw.useMatch)({
        ...rest,
        select: (s)=>{
            return select ? select(s.loaderDeps) : s.loaderDeps;
        }
    });
}

});

parcelRegister("lY8aZ", function(module, exports) {

$parcel$export(module.exports, "useParams", function () { return $ffe58b2e964a9528$export$99eaa27ddbbb95ef; });

var $4huLw = parcelRequire("4huLw");
function $ffe58b2e964a9528$export$99eaa27ddbbb95ef(opts) {
    return (0, $4huLw.useMatch)({
        from: opts.from,
        strict: opts.strict,
        shouldThrow: opts.shouldThrow,
        structuralSharing: opts.structuralSharing,
        select: (match)=>{
            return opts.select ? opts.select(match.params) : match.params;
        }
    });
}

});

parcelRegister("5zaoU", function(module, exports) {

$parcel$export(module.exports, "useSearch", function () { return $40d84a02baf6335d$export$bd221a7c56b93941; });

var $4huLw = parcelRequire("4huLw");
function $40d84a02baf6335d$export$bd221a7c56b93941(opts) {
    return (0, $4huLw.useMatch)({
        from: opts.from,
        strict: opts.strict,
        shouldThrow: opts.shouldThrow,
        structuralSharing: opts.structuralSharing,
        select: (match)=>{
            return opts.select ? opts.select(match.search) : match.search;
        }
    });
}

});

parcelRegister("6UBLf", function(module, exports) {

$parcel$export(module.exports, "useNavigate", function () { return $5085439e7e53153c$export$9770f232ac06a008; });

var $jbmdS = parcelRequire("jbmdS");

var $1Fr27 = parcelRequire("1Fr27");
function $5085439e7e53153c$export$9770f232ac06a008(_defaultOpts) {
    const { navigate: navigate } = (0, $1Fr27.useRouter)();
    return $jbmdS.useCallback((options)=>{
        return navigate({
            ...options
        });
    }, [
        navigate
    ]);
}
function $5085439e7e53153c$export$444b3ab0cb9aec40(props) {
    const router = (0, $1Fr27.useRouter)();
    const previousPropsRef = $jbmdS.useRef(null);
    $jbmdS.useEffect(()=>{
        if (previousPropsRef.current !== props) {
            router.navigate({
                ...props
            });
            previousPropsRef.current = props;
        }
    }, [
        router,
        props
    ]);
    return null;
}

});


parcelRegister("5PXcS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43ffa4619d7d8d37$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $iKbxs = parcelRequire("iKbxs");

var $kuPRw = parcelRequire("kuPRw");

var $3H03w = parcelRequire("3H03w");
var $43ffa4619d7d8d37$export$2e2bcd8739ae039 = ({ error: error, reset: reset })=>{
    $iKbxs.captureException(error);
    (0, $3H03w.default).captureException(error);
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kuPRw.default), {
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            children: [
                "There was an error!",
                /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                    className: "btn btn-default",
                    style: {
                        padding: "0.25em 0.5em",
                        marginLeft: "0.5em",
                        fontSize: "0.9em"
                    },
                    onClick: ()=>reset(),
                    children: "Try again"
                })
            ]
        })
    });
};

});
parcelRegister("kuPRw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eebed6bef7f21d43$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");
var $eebed6bef7f21d43$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ className: className, style: style, children: children, isLoading: isLoading })=>{
    const [isContentWider, setIsContentWider] = (0, $jbmdS.useState)(false);
    const containerRef = (0, $jbmdS.useRef)(null);
    const contentRef = (0, $jbmdS.useRef)(null);
    (0, $jbmdS.useEffect)(()=>{
        const checkWidth = ()=>{
            if (containerRef.current && contentRef.current && !isLoading) setIsContentWider(contentRef.current.scrollWidth > containerRef.current.clientWidth);
        };
        // Initial check
        checkWidth();
        // Set up a MutationObserver to watch for changes in the content
        const observer = new MutationObserver(checkWidth);
        if (contentRef.current) observer.observe(contentRef.current, {
            childList: true,
            subtree: true
        });
        // Check on window resize
        window.addEventListener("resize", checkWidth);
        return ()=>{
            observer.disconnect();
            window.removeEventListener("resize", checkWidth);
        };
    }, [
        isLoading
    ]);
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        ref: containerRef,
        className: `coincraft-page-layout__page-body relative w-full h-full shadow-md print:shadow-none print:h-auto print:block flex-auto bg-neutral-50 flex overflow-auto p-8 pb-28 ${isLoading || !isContentWider ? "justify-center" : "justify-start"}`,
        style: style,
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            ref: contentRef,
            className: `relative ${!isLoading && isContentWider ? "mr-auto" : ""}`,
            children: [
                children,
                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    className: "h-28 dont-print"
                })
            ]
        })
    });
});

});



parcelRegister("bP0Np", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $89b5132e9a18f73d$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");
var $kdUNM = parcelRequire("kdUNM");

var $kuPRw = parcelRequire("kuPRw");

var $aDP4F = parcelRequire("aDP4F");
const $89b5132e9a18f73d$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_public")({
    component: $89b5132e9a18f73d$var$Wrapper
});
function $89b5132e9a18f73d$var$Wrapper() {
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $aDP4F.default), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kuPRw.default), {
            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kdUNM.Outlet), {})
        })
    });
}

});
parcelRegister("6XFpi", function(module, exports) {

$parcel$export(module.exports, "createFileRoute", function () { return $51185f5850dcb558$export$dd68c9a13bdf675a; });

var $iYKZj = parcelRequire("iYKZj");

var $g9auw = parcelRequire("g9auw");

var $4huLw = parcelRequire("4huLw");

var $5ofNy = parcelRequire("5ofNy");

var $hP8Kk = parcelRequire("hP8Kk");

var $5zaoU = parcelRequire("5zaoU");

var $lY8aZ = parcelRequire("lY8aZ");

var $6UBLf = parcelRequire("6UBLf");
function $51185f5850dcb558$export$dd68c9a13bdf675a(path) {
    return new $51185f5850dcb558$export$750d769f4e417c13(path, {
        silent: true
    }).createRoute;
}
class $51185f5850dcb558$export$750d769f4e417c13 {
    constructor(path, _opts){
        this.path = path;
        this.createRoute = (options)=>{
            (0, $iYKZj.default)(this.silent, "FileRoute is deprecated and will be removed in the next major version. Use the createFileRoute(path)(options) function instead.");
            const route = (0, $g9auw.createRoute)(options);
            route.isRoot = false;
            return route;
        };
        this.silent = _opts == null ? void 0 : _opts.silent;
    }
}
function $51185f5850dcb558$export$a669b0f071736e77(_path) {
    (0, $iYKZj.default)(false, `FileRouteLoader is deprecated and will be removed in the next major version. Please place the loader function in the the main route file, inside the \`createFileRoute('/path/to/file')(options)\` options`);
    return (loaderFn)=>loaderFn;
}
class $51185f5850dcb558$export$54ed369afe42c465 {
    constructor(opts){
        this.useMatch = (opts2)=>{
            return (0, $4huLw.useMatch)({
                select: opts2 == null ? void 0 : opts2.select,
                from: this.options.id,
                structuralSharing: opts2 == null ? void 0 : opts2.structuralSharing
            });
        };
        this.useRouteContext = (opts2)=>{
            return (0, $4huLw.useMatch)({
                from: this.options.id,
                select: (d)=>(opts2 == null ? void 0 : opts2.select) ? opts2.select(d.context) : d.context
            });
        };
        this.useSearch = (opts2)=>{
            return (0, $5zaoU.useSearch)({
                select: opts2 == null ? void 0 : opts2.select,
                structuralSharing: opts2 == null ? void 0 : opts2.structuralSharing,
                from: this.options.id
            });
        };
        this.useParams = (opts2)=>{
            return (0, $lY8aZ.useParams)({
                select: opts2 == null ? void 0 : opts2.select,
                structuralSharing: opts2 == null ? void 0 : opts2.structuralSharing,
                from: this.options.id
            });
        };
        this.useLoaderDeps = (opts2)=>{
            return (0, $5ofNy.useLoaderDeps)({
                ...opts2,
                from: this.options.id
            });
        };
        this.useLoaderData = (opts2)=>{
            return (0, $hP8Kk.useLoaderData)({
                ...opts2,
                from: this.options.id
            });
        };
        this.useNavigate = ()=>{
            return (0, $6UBLf.useNavigate)({
                from: this.options.id
            });
        };
        this.options = opts;
        this.$$typeof = Symbol.for("react.memo");
    }
}
function $51185f5850dcb558$export$6b1f4d8d3b3c0124(id) {
    return (opts)=>{
        return new $51185f5850dcb558$export$54ed369afe42c465({
            id: id,
            ...opts
        });
    };
}
function $51185f5850dcb558$export$974586e40f6d7069(id) {
    return (opts)=>new $51185f5850dcb558$export$54ed369afe42c465({
            id: id,
            ...opts
        });
}

});

parcelRegister("aDP4F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7bf52a2b94a54c66$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $02LyB = parcelRequire("02LyB");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");
var $7bf52a2b94a54c66$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ children: children })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("coincraft-page-layout__content", "flex-1 w-full min-w-0 h-full min-h-0 overflow-hidden"),
        children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            className: "coincraft-page-layout__page relative h-full w-full overflow-auto print:block print:h-auto grid",
            children: children
        })
    });
});

});


parcelRegister("ggLDO", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $bd83187a861354bf$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");
var $kdUNM = parcelRequire("kdUNM");
var $gbTjE = parcelRequire("gbTjE");
var $1Fr27 = parcelRequire("1Fr27");

var $1BTI2 = parcelRequire("1BTI2");

var $2RNgm = parcelRequire("2RNgm");

var $4iw5i = parcelRequire("4iw5i");

var $dYful = parcelRequire("dYful");

var $8aL9y = parcelRequire("8aL9y");

var $5PXcS = parcelRequire("5PXcS");

var $47i9t = parcelRequire("47i9t");

var $aDP4F = parcelRequire("aDP4F");

var $8kZ1o = parcelRequire("8kZ1o");

var $lvC6D = parcelRequire("lvC6D");

var $hRCNE = parcelRequire("hRCNE");

var $jbmdS = parcelRequire("jbmdS");

var $38AIP = parcelRequire("38AIP");
parcelRequire("lfqR9");

var $7RI9h = parcelRequire("7RI9h");

var $3tNhL = parcelRequire("3tNhL");

var $khJQv = parcelRequire("khJQv");
const $bd83187a861354bf$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_private")({
    beforeLoad: async ({ location: location, context: context })=>{
        if (!(0, $1BTI2.default).initialized) await (0, $1BTI2.default).initialize();
        if ((0, $1BTI2.default).initialized && !(0, $1BTI2.default).authenticated) throw (0, $gbTjE.redirect)({
            to: "/login",
            search: {
                redirect: location.href
            }
        });
        else try {
            const { queryClient: queryClient, trpc: trpc } = context;
            const appData = await queryClient.fetchQuery({
                queryKey: [
                    "appDataTRPC",
                    (0, $1BTI2.default).userId
                ],
                queryFn: ()=>trpc.legacy.getAppData.query(),
                staleTime: 300000,
                cacheTime: 1800000,
                retry: 3
            });
            (0, $47i9t.processTRPCData)(appData);
            try {
                const cacheData = await queryClient.fetchQuery({
                    queryKey: (0, $38AIP.GLOBAL_CACHE_KEY),
                    queryFn: ()=>trpc.global.getCache.query(),
                    staleTime: 300000,
                    cacheTime: 1800000
                });
                (0, $38AIP.setCache)(cacheData);
            } catch (error) {
                throw new Error("Failed to load global cache: " + error.message);
            }
            return {
                appData: appData
            };
        } catch (error) {
            if (error.response && error.response.status === 401 || error.message === "GlobalCacheError" || error instanceof Error && error.message.includes("Failed to load global cache")) throw (0, $gbTjE.redirect)({
                to: "/login",
                search: {
                    redirect: location.href
                }
            });
            else {
                console.error("Error during beforeLoad data fetching:", error);
                throw error;
            }
        }
    },
    pendingComponent: (0, $4iw5i.default),
    component: $bd83187a861354bf$var$Wrapper,
    errorComponent: ({ error: error, reset: reset })=>{
        if (error.message.includes("No CollectionLookup found")) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: new Error("Application setup error: Could not process essential data. Please contact support."),
            reset: reset
        });
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    }
});
function $bd83187a861354bf$var$Wrapper() {
    const router = (0, $1Fr27.useRouter)();
    const [v2, setV2] = (0, $jbmdS.useState)((0, $8kZ1o.migratedToV2)());
    const isDev = false;
    const params = $bd83187a861354bf$export$e7b0ac011bb776c6.useParams();
    const search = $bd83187a861354bf$export$e7b0ac011bb776c6.useSearch();
    const isFetching = (0, $3tNhL.useIsFetching)({
        queryKey: [
            "appData",
            (0, $1BTI2.default).userId
        ]
    });
    (0, $jbmdS.useEffect)(()=>{
        (0, $khJQv.default).pageRendered = !isFetching;
    }, [
        isFetching
    ]);
    if (isFetching) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $4iw5i.default), {});
    if ((0, $8kZ1o.migratedToV2)()) return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7RI9h.SaveQueueProcessor), {}),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $lvC6D.Layout), {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kdUNM.Outlet), {})
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "dont-print",
                style: {
                    backgroundColor: "#ffffffcc",
                    fontWeight: "bold",
                    fontSize: "0.75em",
                    position: "absolute",
                    bottom: "0",
                    right: "1.75em",
                    height: "1.5em",
                    padding: "0 0.5em",
                    borderRadius: "0.25em",
                    display: "flex",
                    alignItems: "center",
                    zIndex: 100
                },
                children: [
                    isDev ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hRCNE.default), {
                        className: "mr-2",
                        checked: v2,
                        size: "small",
                        onChange: (v)=>{
                            (0, $1BTI2.default).setMigratedToV2(v);
                            setV2(v);
                        },
                        checkedChildren: "V2",
                        unCheckedChildren: "V2"
                    }) : null,
                    (0, $8aL9y.version)
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $dYful.default), {
                ...params,
                ...search
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7RI9h.SaveQueueProcessor), {}),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $2RNgm.default), {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $aDP4F.default), {
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kdUNM.Outlet), {})
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "dont-print",
                style: {
                    backgroundColor: "#ffffffcc",
                    fontWeight: "bold",
                    fontSize: "0.75em",
                    position: "absolute",
                    bottom: "0",
                    right: "1.75em",
                    height: "1.5em",
                    padding: "0 0.5em",
                    borderRadius: "0.25em",
                    display: "flex",
                    alignItems: "center",
                    zIndex: 100
                },
                children: [
                    isDev ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hRCNE.default), {
                        className: "mr-2",
                        checked: v2,
                        size: "small",
                        onChange: (v)=>{
                            setV2(v);
                            (0, $1BTI2.default).setMigratedToV2(v);
                            router.invalidate();
                            setTimeout(()=>router.invalidate(), 0);
                        },
                        checkedChildren: "V2",
                        unCheckedChildren: "V2"
                    }) : null,
                    (0, $8aL9y.version)
                ]
            })
        ]
    });
}

});
parcelRegister("2RNgm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2166be93ba3f13dc$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("jbmdS");

var $lgTBN = parcelRequire("lgTBN");

var $1EEMt = parcelRequire("1EEMt");

var $6okYk = parcelRequire("6okYk");

var $am6LL = parcelRequire("am6LL");
var $2166be93ba3f13dc$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ children: children })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "coincraft-page-layout__header flex-none w-full relative",
                style: {
                    zIndex: 10001
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $am6LL.UpdateBanner), {}),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $am6LL.default), {}),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $lgTBN.default), {}),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6okYk.default), {})
                ]
            }),
            children
        ]
    });
});

});
parcelRegister("lgTBN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7c63a52addf86cd$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("eat5C");

var $02LyB = parcelRequire("02LyB");

var $1BTI2 = parcelRequire("1BTI2");

var $gLg6a = parcelRequire("gLg6a");

var $1EEMt = parcelRequire("1EEMt");

var $8kZ1o = parcelRequire("8kZ1o");

var $kqlQp = parcelRequire("kqlQp");
var $6UBLf = parcelRequire("6UBLf");

var $gJT7h = parcelRequire("gJT7h");

var $htkeB = parcelRequire("htkeB");

var $khJQv = parcelRequire("khJQv");

var $A8k4f = parcelRequire("A8k4f");

var $ldrel = parcelRequire("ldrel");

var $afeg2 = parcelRequire("afeg2");

var $hzmaq = parcelRequire("hzmaq");
const $f7c63a52addf86cd$var$menuItems = [
    {
        label: "Forecasts",
        children: [
            {
                label: "Revenue Forecast",
                route: "/revenue-forecast",
                permissions: (user)=>(0, $8kZ1o.canViewRoute)(user, "revenueForecast")
            },
            {
                label: "Revenue Forecast 2",
                route: "/revenue-forecast2",
                permissions: (user)=>(0, $8kZ1o.canViewRoute)(user, "revenueForecast2")
            },
            {
                label: "Resource Schedule",
                route: "/resource-schedule",
                permissions: (user)=>(0, $8kZ1o.canViewRoute)(user, "resourceSchedule")
            }
        ]
    },
    {
        label: "Projects",
        children: [
            {
                label: "Project List",
                route: "/projects",
                permissions: (user)=>(0, $8kZ1o.canViewRoute)(user, "projectList")
            },
            {
                label: "+ Create Project",
                onClick: ()=>{
                    const project = (0, $gJT7h.default).createProject();
                    return `/projects/${project.id}`;
                },
                permissions: (user)=>(0, $8kZ1o.canViewRoute)(user, "createProject")
            }
        ]
    },
    {
        label: "Staff",
        children: [
            {
                label: "Staff List",
                route: "/staff",
                permissions: (user)=>(0, $8kZ1o.canViewRoute)(user, "staffList")
            },
            {
                label: "Staff Roles",
                route: "/staff-roles",
                permissions: (user)=>(0, $8kZ1o.canViewRoute)(user, "staffRoleList")
            },
            {
                label: "Permissions",
                route: "/permissions",
                permissions: (user)=>(0, $8kZ1o.canViewRoute)(user, "staff-permissions")
            },
            {
                label: "+ Create Staff",
                onClick: ()=>{
                    const staff = (0, $htkeB.default).createStaff();
                    return `/staff/${staff.id}`;
                },
                permissions: (user)=>(0, $8kZ1o.canViewRoute)(user, "createStaff")
            }
        ]
    },
    {
        label: "Invoices",
        children: [
            {
                label: "Invoice List",
                route: "/invoices",
                permissions: (user)=>(0, $8kZ1o.canViewRoute)(user, "invoiceList")
            },
            {
                label: "Invoice Templates",
                onClick: ()=>{
                    (0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $A8k4f.default), {
                        modalId: "invoice-templates"
                    }));
                },
                permissions: (user)=>(0, $8kZ1o.canViewRoute)(user, "invoiceTemplates")
            },
            {
                label: "Invoice Settings",
                onClick: ()=>{
                    (0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $ldrel.default), {
                        modalId: "invoice-settings"
                    }));
                },
                permissions: (user)=>(0, $8kZ1o.canViewRoute)(user, "invoiceSettings")
            },
            {
                label: "+ Create Invoice",
                onClick: ()=>{
                    (0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $afeg2.default), {
                        modalId: "new-invoice"
                    }));
                },
                permissions: (user)=>(0, $8kZ1o.canViewRoute)(user, "createInvoice")
            }
        ]
    },
    {
        label: "Timesheets",
        children: [
            {
                label: "Timesheets",
                route: "/timesheets",
                permissions: (user)=>(0, $8kZ1o.canViewRoute)(user, "timesheets")
            },
            {
                label: "Calendar",
                route: "/timesheets/calendar",
                permissions: (user)=>(0, $8kZ1o.canViewRoute)(user, "timesheetCalendar")
            },
            {
                label: "Timesheet Reports",
                route: "/timesheets/report",
                permissions: (user)=>(0, $8kZ1o.canViewRoute)(user, "timesheetReports")
            }
        ]
    },
    {
        label: "Expenses",
        children: [
            {
                label: "Track Expenses",
                route: "/track-expenses",
                permissions: (user)=>(0, $8kZ1o.canViewRoute)(user, "trackExpenses")
            },
            {
                label: "Expense Reports",
                route: "/expense-reports",
                permissions: (user)=>(0, $8kZ1o.canViewRoute)(user, "expenseReports")
            },
            {
                label: "Suppliers",
                route: "/suppliers",
                permissions: (user)=>(0, $8kZ1o.canViewRoute)(user, "suppliers")
            }
        ]
    },
    {
        label: "Organisation",
        children: [
            {
                label: "Overhead Expenses",
                route: "/overhead-expenses",
                permissions: (user)=>(0, $8kZ1o.canViewRoute)(user, "overheadExpenses")
            },
            {
                label: "Cost Centres",
                route: "/cost-centres",
                permissions: (user)=>(0, $8kZ1o.canViewRoute)(user, "costCentres")
            },
            {
                label: "Holidays",
                route: "/organisation-holidays",
                permissions: (user)=>(0, $8kZ1o.canViewRoute)(user, "organisationHolidays")
            },
            {
                label: "Contacts",
                route: "/contacts",
                permissions: (user)=>(0, $8kZ1o.canViewRoute)(user, "contacts")
            },
            {
                label: "Settings",
                route: "/settings",
                permissions: (user)=>(0, $8kZ1o.canViewRoute)(user, "settings")
            }
        ]
    }
];
const $f7c63a52addf86cd$var$menuStructure = ()=>{
    const menu = [];
    $f7c63a52addf86cd$var$menuItems.forEach((item)=>{
        const children = item.children.filter((child)=>child.permissions((0, $1BTI2.default).user));
        if (children.length > 0) menu.push([
            item.label,
            children
        ]);
    });
    return menu;
};
var $f7c63a52addf86cd$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(()=>{
    var _SessionStore$user;
    const [hoveredItem, setHoveredItem] = (0, $jbmdS.useState)(null);
    const [pointerDownTs, setPointerDownTs] = (0, $jbmdS.useState)(0);
    return /*#__PURE__*/ (0, $61Ea1.jsx)("header", {
        className: "coincraft-header",
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            className: "header-bar dont-print text-444 bg-gold justify-between w-full lg:flex-row flex-col flex items-center shadow-[rgba(0,0,0,0.2)_0px_4px_8px] m-0 px-8 py-0 text-sm",
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    className: "navigation",
                    children: $f7c63a52addf86cd$var$menuStructure().map(([menu, pages], i)=>{
                        return /*#__PURE__*/ (0, $61Ea1.jsx)($f7c63a52addf86cd$var$MenuItem, {
                            menu: menu,
                            pages: pages,
                            i: i,
                            setHoveredItem: setHoveredItem,
                            hoveredItem: hoveredItem
                        }, i);
                    })
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    className: "account-info text-right items-center flex",
                    children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "user-info items-center flex",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $gLg6a.default), {}),
                            !(0, $8kZ1o.usingNewLogin)() ? /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "inline-block text-[0.95em] py-[0.25em] px-[0.5em]",
                                children: (_SessionStore$user = (0, $1BTI2.default).user) === null || _SessionStore$user === void 0 ? void 0 : _SessionStore$user.fullName
                            }) : null,
                            (0, $8kZ1o.canViewBilling)((0, $1BTI2.default).user) ? /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "billing-btn",
                                style: {
                                    marginRight: "1em",
                                    marginLeft: "1em"
                                },
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqlQp.Link), {
                                    to: "/billing",
                                    children: "Billing"
                                })
                            }) : null,
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "inline-flex text-[0.95em] ",
                                children: !(0, $8kZ1o.usingNewLogin)() ? /*#__PURE__*/ (0, $61Ea1.jsxs)("a", {
                                    onClick: ()=>(0, $1BTI2.default).logout(),
                                    children: [
                                        "Sign Out \xa0",
                                        /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                            className: "fa fa-sign-out"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
                                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hzmaq.UserButton), {
                                        showName: true
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
});
const $f7c63a52addf86cd$var$MenuItem = (0, $1EEMt.observer)(({ menu: menu, pages: pages, i: i, hoveredItem: hoveredItem, setHoveredItem: setHoveredItem })=>{
    const navigate = (0, $6UBLf.useNavigate)();
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useRef();
    const [isPointerUp, setIsPointerUp] = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useState(false);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        ref: ref,
        className: "inline-block relative whitespace-nowrap hover:bg-highlighted focus:bg-highlighted",
        "data-menu-item-id": menu,
        onPointerOut: (e)=>{
            if (isPointerUp) {
                setIsPointerUp(false);
                return;
            }
            if (!ref.current.contains(e.relatedTarget)) setHoveredItem(null);
        },
        onPointerUp: ()=>{
            setIsPointerUp(true);
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                onPointerOver: (e)=>{
                    if (menu !== hoveredItem) setHoveredItem(menu);
                    else setHoveredItem(null);
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("nav-button", "cursor-pointer font-semibold inline-block px-6 py-4", menu === hoveredItem && "bg-highlighted"),
                children: menu
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("nav-dropdown z-[1001] bg-[rgb(255,222,102)] absolute shadow-[rgba(0,0,0,0.2)_0px_8px_16px] left-0 top-full", menu === hoveredItem ? "inline-block" : "hidden"),
                children: pages.map((page)=>{
                    return page.onClick ? /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("nav-dropdown-item", "cursor-pointer w-full block pl-6 pr-10 py-4 border-t-[rgb(255,233,153)] border-b-[rgb(255,211,51)] border-t border-solid border-b hover:bg-[linear-gradient(hsla(47,100%,80%,1),hsla(47,100%,90%,1))]", {
                            highlighted: false
                        }),
                        onClick: ()=>{
                            // [Refactoring Needed] this workaround to done because redirect is not working.
                            // Will look for better solution later.
                            const url = page.onClick();
                            if (url) navigate({
                                to: url
                            });
                            setHoveredItem(null);
                        },
                        children: page.label
                    }, page.id) : /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqlQp.Link), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("nav-dropdown-item", "cursor-pointer block pl-6 pr-10 py-4 border-t-[rgb(255,233,153)] border-b-[rgb(255,211,51)] border-t border-solid border-b hover:bg-[linear-gradient(hsla(47,100%,80%,1),hsla(47,100%,90%,1))]", {
                            highlighted: false
                        }),
                        to: page.route,
                        onClick: ()=>{
                            setHoveredItem(null);
                        },
                        children: page.label
                    }, page.id);
                })
            })
        ]
    }, menu + i);
});

});
parcelRegister("gLg6a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c33d85f06dc40a02$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $ayM8m = parcelRequire("ayM8m");

var $3TBH9 = parcelRequire("3TBH9");
var $c33d85f06dc40a02$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(()=>{
    // useEffect(() => {
    //     timerStore.init() // make sure data loaded before intializing
    // }, [])
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        style: {
            position: "relative",
            cursor: "pointer"
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                onClick: ()=>{
                    // console.trace()
                    (0, $3TBH9.default).toggleOpen(!(0, $3TBH9.default).open);
                },
                children: [
                    (0, $3TBH9.default).timeDisplay,
                    /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                        style: {
                            fontSize: "1.25em",
                            marginLeft: "0.5em"
                        },
                        className: "fa fa-clock-o"
                    })
                ]
            }),
            (0, $3TBH9.default).open ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ayM8m.default), {}) : null
        ]
    });
});

});
parcelRegister("ayM8m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b026abddda2973e$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $e4oIi = parcelRequire("e4oIi");
var $6N1HV = parcelRequire("6N1HV");
var $hRCNE = parcelRequire("hRCNE");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $3TBH9 = parcelRequire("3TBH9");

var $jd5kC = parcelRequire("jd5kC");

var $gqtmM = parcelRequire("gqtmM");

var $7NI2K = parcelRequire("7NI2K");

var $e8Hda = parcelRequire("e8Hda");

var $1BTI2 = parcelRequire("1BTI2");

var $ax8Km = parcelRequire("ax8Km");

var $4hBm1 = parcelRequire("4hBm1");

var $XoImS = parcelRequire("XoImS");

var $gJT7h = parcelRequire("gJT7h");

var $htkeB = parcelRequire("htkeB");

var $6RcUP = parcelRequire("6RcUP");

var $keGWP = parcelRequire("keGWP");

var $8kZ1o = parcelRequire("8kZ1o");
parcelRequire("jE5CX");

var $6Q5sp = parcelRequire("6Q5sp");

var $QiMYe = parcelRequire("QiMYe");
parcelRequire("f44xu");

var $eat5C = parcelRequire("eat5C");

var $ewAM3 = parcelRequire("ewAM3");

var $b9nYY = parcelRequire("b9nYY");

var $47i9t = parcelRequire("47i9t");

var $3h7sC = parcelRequire("3h7sC");
const { TextArea: $7b026abddda2973e$var$TextArea } = (0, $6N1HV.default);
var $7b026abddda2973e$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(()=>{
    var _PhaseCollection$phas, _TaskCollection$tasks;
    const [renderTime] = (0, $jbmdS.useState)(new Date());
    const settings = (0, $1BTI2.default).organisation.settings;
    const disabled = (0, $3TBH9.default).saveState === "pending";
    let progressGradient = {
        "0%": "#108ee9"
    };
    progressGradient[`${Math.round(0.5 / (0, $3TBH9.default).budget.percent * 100)}%`] = "#87d068";
    if ((0, $3TBH9.default).budget.percent > 0.8) progressGradient[`${Math.round(0.8 / (0, $3TBH9.default).budget.percent * 100)}%`] = "#ffc200";
    if ((0, $3TBH9.default).budget.percent > 1) progressGradient[`${Math.round(1 / (0, $3TBH9.default).budget.percent * 100)}%`] = "#ff5800";
    const panelRef = (0, $jbmdS.useRef)();
    function outsideClick(e) {
        const panel = panelRef.current.getBoundingClientRect();
        const x = e.clientX;
        const y = e.clientY;
        if (new Date() - renderTime < 100 || // registers the open event as a click outside
        x >= panel.left && x <= panel.right && y >= panel.top && y <= panel.bottom) ;
        else // console.log('Clicked outside panel', new Date() - renderTime)
        (0, $3TBH9.default).toggleOpen(false);
    }
    (0, $7NI2K.default)(panelRef, outsideClick);
    const project = (0, $gJT7h.default).projectsById[(0, $3TBH9.default).selectedValues.projectId];
    const phase = (0, $XoImS.default).phasesById[(0, $3TBH9.default).selectedValues.phaseId] || ((_PhaseCollection$phas = (0, $XoImS.default).phasesByProjectId[project === null || project === void 0 ? void 0 : project.id]) === null || _PhaseCollection$phas === void 0 ? void 0 : _PhaseCollection$phas[0]);
    const task = (0, $keGWP.default).tasksById[(0, $3TBH9.default).selectedValues.taskId] || ((_TaskCollection$tasks = (0, $keGWP.default).tasksByPhaseId[phase === null || phase === void 0 ? void 0 : phase.id]) === null || _TaskCollection$tasks === void 0 ? void 0 : _TaskCollection$tasks[0]);
    const staff = (0, $htkeB.default).staffsById[(0, $3TBH9.default).selectedValues.staffId] || (0, $1BTI2.default).user;
    const role = staff === null || staff === void 0 ? void 0 : staff.role;
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "w-[20em] absolute top-[2.5em] right-0 z-[1001] shadow-[6px_6px_16px_-1px_#00000033]",
        ref: panelRef,
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "bg-white p-3.5 z-10",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "text-center flex items-center justify-center text-[45px] pt-5 pb-2.5",
                        children: [
                            (0, $3TBH9.default).timeDisplay,
                            (0, $3TBH9.default).timerState === "idle" ? /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                className: "ml-3 cursor-pointer text-[40px]",
                                onClick: (0, $3TBH9.default).interfaceDisabled ? ()=>null : (0, $3TBH9.default).startTimer,
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jd5kC.FontAwesomeIcon), {
                                    icon: (0, $gqtmM.faPlayCircle)
                                })
                            }) : /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                className: "ml-3 cursor-pointer text-[40px]",
                                onClick: (0, $3TBH9.default).interfaceDisabled ? ()=>null : (0, $3TBH9.default).pauseTimer,
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jd5kC.FontAwesomeIcon), {
                                    icon: (0, $gqtmM.faPauseCircle)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "py-6",
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6RcUP.default), {
                            queryIds: [
                                project !== null && project !== void 0 && project.id ? {
                                    id: `phases-${project.id}`,
                                    queryFn: async ()=>{
                                        const requestData = await (0, $3h7sC.trpc).legacy.getProjectPhases.query({
                                            projectId: project.id
                                        });
                                        return (0, $47i9t.processTRPCData)(requestData, `phases-${project.id}`);
                                    }
                                } : null
                            ].filter((v)=>v),
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ax8Km.default), {
                                dropdownClassName: "!text-xs",
                                project: project,
                                phase: phase,
                                role: role,
                                staff: staff,
                                startDate: (0, $4hBm1.startOfDay)(new Date()),
                                endDate: (0, $4hBm1.endOfDay)(new Date()),
                                extraHours: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(((0, $QiMYe.default).timeEntries || []).filter((te)=>te.staffId === (staff === null || staff === void 0 ? void 0 : staff.id) && te.phaseId === (phase === null || phase === void 0 ? void 0 : phase.id) && te.date.getTime() === new Date().getTime() && !te.deletedAt).map((te)=>te.hours)),
                                variant: "secondary"
                            }, String(project === null || project === void 0 ? void 0 : project.id) + String(phase === null || phase === void 0 ? void 0 : phase.id))
                        })
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "flex flex-col gap-1",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.ProjectSelector), {
                                selectedProject: project,
                                projectOptions: ((0, $gJT7h.default).projects || []).filter((p)=>(0, $8kZ1o.canEnterTimeAgainstProject)((0, $1BTI2.default).user, p, false)),
                                onChange: (project)=>{
                                    const projectId = project === null || project === void 0 ? void 0 : project.id;
                                    (0, $6Q5sp.queryClient).invalidateQueries([
                                        `phases-${projectId}`
                                    ]);
                                    (0, $3TBH9.default).updateSelectedValues({
                                        projectId: projectId
                                    });
                                },
                                disabled: (0, $3TBH9.default).interfaceDisabled,
                                variant: "secondary",
                                style: {
                                    width: "100%"
                                }
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6RcUP.default), {
                                queryIds: [
                                    project !== null && project !== void 0 && project.id ? {
                                        id: `phases-${project.id}`,
                                        queryFn: async ()=>{
                                            const requestData = await (0, $3h7sC.trpc).legacy.getProjectPhases.query({
                                                projectId: project.id
                                            });
                                            return (0, $47i9t.processTRPCData)(requestData, `phases-${project.id}`);
                                        }
                                    } : null,
                                    project !== null && project !== void 0 && project.id ? {
                                        id: `tasks-${project.id}`,
                                        queryFn: async ()=>{
                                            const requestData = await (0, $3h7sC.trpc).legacy.getTasks.query({
                                                projectId: project.id
                                            });
                                            return (0, $47i9t.processTRPCData)(requestData, `tasks-${project.id}`);
                                        }
                                    } : null
                                ].filter((v)=>v),
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $b9nYY.PhaseAndTaskSelectors), {
                                    store: (0, $3TBH9.default),
                                    disabled: disabled,
                                    variant: "secondary"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "flex justify-around text-center my-8 text-sm text-[#666]",
                        children: [
                            settings.timeEntryFlags.includes("billable") && /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                className: "flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hRCNE.default), {
                                        checked: (0, $3TBH9.default).selectedValues.isBillable || (task === null || task === void 0 ? void 0 : task.isBillable),
                                        onChange: (isBillable)=>{
                                            (0, $3TBH9.default).updateSelectedValues({
                                                isBillable: isBillable
                                            });
                                        },
                                        disabled: (0, $3TBH9.default).interfaceDisabled
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        children: "Billable"
                                    })
                                ]
                            }),
                            settings.timeEntryFlags.includes("variation") && /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                className: "flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hRCNE.default), {
                                        checked: (0, $3TBH9.default).selectedValues.isVariation || (task === null || task === void 0 ? void 0 : task.isVariation),
                                        onChange: (isVariation)=>{
                                            (0, $3TBH9.default).updateSelectedValues({
                                                isVariation: isVariation
                                            });
                                        },
                                        disabled: (0, $3TBH9.default).interfaceDisabled
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        children: "Variation"
                                    })
                                ]
                            }),
                            settings.timeEntryFlags.includes("overtime") && /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                className: "flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hRCNE.default), {
                                        checked: (0, $3TBH9.default).selectedValues.isOvertime || (task === null || task === void 0 ? void 0 : task.isOvertime),
                                        onChange: (isOvertime)=>{
                                            (0, $3TBH9.default).updateSelectedValues({
                                                isOvertime: isOvertime
                                            });
                                        },
                                        disabled: (0, $3TBH9.default).interfaceDisabled
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        children: "Overtime"
                                    })
                                ]
                            }),
                            (0, $8kZ1o.canViewRemote)() && settings.timeEntryFlags.includes("remote") && /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hRCNE.default), {
                                        checked: (0, $3TBH9.default).selectedValues.remote,
                                        onChange: (remote)=>{
                                            (0, $3TBH9.default).updateSelectedValues({
                                                remote: remote
                                            });
                                        },
                                        disabled: (0, $3TBH9.default).interfaceDisabled
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        children: "Remote"
                                    })
                                ]
                            }),
                            (0, $8kZ1o.canViewFlexi)() && settings.timeEntryFlags.includes("flexi") && /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hRCNE.default), {
                                        checked: (0, $3TBH9.default).selectedValues.flexi || (task === null || task === void 0 ? void 0 : task.flexi),
                                        onChange: (flexi)=>{
                                            (0, $3TBH9.default).updateSelectedValues({
                                                flexi: flexi
                                            });
                                        },
                                        disabled: (0, $3TBH9.default).interfaceDisabled
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        children: "Flexi"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)($7b026abddda2973e$var$TextArea, {
                        value: (0, $3TBH9.default).selectedValues.notes,
                        onChange: (e)=>{
                            (0, $3TBH9.default).updateSelectedValues({
                                notes: e.target.value
                            });
                        },
                        style: {
                            fontSize: "1.2rem"
                        },
                        placeholder: "Enter some notes...",
                        autoSize: {
                            minRows: 5
                        },
                        allowClear: true,
                        disabled: (0, $3TBH9.default).interfaceDisabled
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $e4oIi.default), {
                        danger: true,
                        style: {
                            marginTop: "1rem",
                            width: "100%"
                        },
                        onClick: (0, $3TBH9.default).resetTimer,
                        disabled: (0, $3TBH9.default).interfaceDisabled,
                        children: "Cancel Timer"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $e4oIi.default), {
                        style: {
                            marginTop: "1rem",
                            width: "100%"
                        },
                        onClick: (0, $3TBH9.default).saveTimeEntry,
                        disabled: (0, $3TBH9.default).interfaceDisabled,
                        children: (0, $3TBH9.default).saveState === "saved" ? "Saved!" : (0, $3TBH9.default).saveState === "saving" ? "Saving..." : "Save Time Entry"
                    })
                ]
            }),
            (0, $3TBH9.default).timeEntries.length ? /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    background: "#f5f5f5",
                    padding: "1em",
                    boxShadow: "3px 3px 12px -1px inset #00000011",
                    position: "relative",
                    borderTop: "solid 1px #ddd",
                    maxHeight: "7em",
                    overflow: "auto"
                },
                children: [
                    ...(0, $3TBH9.default).timeEntries
                ].sort((a, b)=>b.startMinutes - a.startMinutes).map((te)=>{
                    var _te$phase;
                    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            padding: "1em",
                            fontSize: "0.8em",
                            lineHeight: "1.2em",
                            borderBottom: "solid 1px #ddd"
                        },
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                style: {
                                    display: "flex"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        style: {
                                            flex: "1 1 auto",
                                            textAlign: "left"
                                        },
                                        children: `${(0, $e8Hda.formatNumber2)(te.numMinutes / 60)} hours`
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        style: {
                                            flex: "0 0 auto"
                                        },
                                        children: `${te.project.title}`
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                style: {
                                    display: "flex"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        style: {
                                            flex: "1 1 auto",
                                            textAlign: "left"
                                        },
                                        children: `${$7b026abddda2973e$var$formatTime(te.startMinutes / 60)}-${$7b026abddda2973e$var$formatTime(te.endMinutes / 60)}`
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        style: {
                                            flex: "0 0 auto"
                                        },
                                        children: `${(_te$phase = te.phase) === null || _te$phase === void 0 ? void 0 : _te$phase.title}`
                                    })
                                ]
                            })
                        ]
                    });
                })
            }) : null
        ]
    });
});
const $7b026abddda2973e$var$formatTime = (hours)=>{
    let wholeHours = Math.floor(hours);
    let mins = Math.round((hours - wholeHours) * 60);
    let ampm = "am";
    if (wholeHours > 12) {
        wholeHours -= 12;
        ampm = "pm";
    }
    return `${wholeHours}:${mins < 10 ? "0" : ""}${mins}${ampm}`;
};

});
parcelRegister("e4oIi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3e49c0273c2b57e$export$2e2bcd8739ae039; });

var $dbzOt = parcelRequire("dbzOt");
var $a3e49c0273c2b57e$export$2e2bcd8739ae039 = (0, $dbzOt.default);

});
parcelRegister("dbzOt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99981527f631c75b$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $8K2NM = parcelRequire("8K2NM");

var $CZyex = parcelRequire("CZyex");

var $jncUt = parcelRequire("jncUt");

var $02LyB = parcelRequire("02LyB");

var $cXDkH = parcelRequire("cXDkH");

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("8uDri");
var $ewikT = parcelRequire("ewikT");

var $kgIuF = parcelRequire("kgIuF");

var $7VQDG = parcelRequire("7VQDG");

var $9RKXl = parcelRequire("9RKXl");

var $l34u6 = parcelRequire("l34u6");

var $3IdWL = parcelRequire("3IdWL");


var $ccZcg = parcelRequire("ccZcg");

var $bOMNW = parcelRequire("bOMNW");

var $fKUMH = parcelRequire("fKUMH");
var $99981527f631c75b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $99981527f631c75b$var$rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
var $99981527f631c75b$var$isTwoCNChar = $99981527f631c75b$var$rxTwoCNChar.test.bind($99981527f631c75b$var$rxTwoCNChar);
function $99981527f631c75b$var$isString(str) {
    return typeof str === "string";
}
function $99981527f631c75b$var$isUnBorderedButtonType(type) {
    return type === "text" || type === "link";
}
// Insert one space between two chinese characters automatically.
function $99981527f631c75b$var$insertSpace(child, needInserted) {
    // Check the child if is undefined or null.
    if (child === null || child === undefined) return;
    var SPACE = needInserted ? " " : "";
    // strictNullChecks oops.
    if (typeof child !== "string" && typeof child !== "number" && $99981527f631c75b$var$isString(child.type) && $99981527f631c75b$var$isTwoCNChar(child.props.children)) return (0, $l34u6.cloneElement)(child, {
        children: child.props.children.split("").join(SPACE)
    });
    if (typeof child === "string") return $99981527f631c75b$var$isTwoCNChar(child) ? /*#__PURE__*/ $jbmdS.createElement("span", null, child.split("").join(SPACE)) : /*#__PURE__*/ $jbmdS.createElement("span", null, child);
    if ((0, $l34u6.isFragment)(child)) return /*#__PURE__*/ $jbmdS.createElement("span", null, child);
    return child;
}
function $99981527f631c75b$var$spaceChildren(children, needInserted) {
    var isPrevChildPure = false;
    var childList = [];
    $jbmdS.Children.forEach(children, function(child) {
        var type = (0, $jncUt.default)(child);
        var isCurrentChildPure = type === "string" || type === "number";
        if (isPrevChildPure && isCurrentChildPure) {
            var lastIndex = childList.length - 1;
            var lastChild = childList[lastIndex];
            childList[lastIndex] = "".concat(lastChild).concat(child);
        } else childList.push(child);
        isPrevChildPure = isCurrentChildPure;
    });
    // Pass to React.Children.map to auto fill key
    return $jbmdS.Children.map(childList, function(child) {
        return $99981527f631c75b$var$insertSpace(child, needInserted);
    });
}
var $99981527f631c75b$var$ButtonTypes = (0, $3IdWL.tuple)("default", "primary", "ghost", "dashed", "link", "text");
var $99981527f631c75b$var$ButtonShapes = (0, $3IdWL.tuple)("default", "circle", "round");
var $99981527f631c75b$var$ButtonHTMLTypes = (0, $3IdWL.tuple)("submit", "button", "reset");
function $99981527f631c75b$export$19bc9a290855952(type) {
    if (type === "danger") return {
        danger: true
    };
    return {
        type: type
    };
}
var $99981527f631c75b$var$InternalButton = function InternalButton(props, ref) {
    var _classNames;
    var _props$loading = props.loading, loading = _props$loading === void 0 ? false : _props$loading, customizePrefixCls = props.prefixCls, _props$type = props.type, type = _props$type === void 0 ? "default" : _props$type, danger = props.danger, _props$shape = props.shape, shape = _props$shape === void 0 ? "default" : _props$shape, customizeSize = props.size, customDisabled = props.disabled, className = props.className, children = props.children, icon = props.icon, _props$ghost = props.ghost, ghost = _props$ghost === void 0 ? false : _props$ghost, _props$block = props.block, block = _props$block === void 0 ? false : _props$block, _props$htmlType = props.htmlType, htmlType = _props$htmlType === void 0 ? "button" : _props$htmlType, rest = $99981527f631c75b$var$__rest(props, [
        "loading",
        "prefixCls",
        "type",
        "danger",
        "shape",
        "size",
        "disabled",
        "className",
        "children",
        "icon",
        "ghost",
        "block",
        "htmlType"
    ]);
    var size = $jbmdS.useContext((0, $7VQDG.default));
    // ===================== Disabled =====================
    var disabled = $jbmdS.useContext((0, $kgIuF.default));
    var mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    var groupSize = $jbmdS.useContext((0, $bOMNW.GroupSizeContext));
    var _React$useState = $jbmdS.useState(!!loading), _React$useState2 = (0, $CZyex.default)(_React$useState, 2), innerLoading = _React$useState2[0], setLoading = _React$useState2[1];
    var _React$useState3 = $jbmdS.useState(false), _React$useState4 = (0, $CZyex.default)(_React$useState3, 2), hasTwoCNChar = _React$useState4[0], setHasTwoCNChar = _React$useState4[1];
    var _React$useContext = $jbmdS.useContext((0, $ewikT.ConfigContext)), getPrefixCls = _React$useContext.getPrefixCls, autoInsertSpaceInButton = _React$useContext.autoInsertSpaceInButton, direction = _React$useContext.direction;
    var buttonRef = ref || /*#__PURE__*/ $jbmdS.createRef();
    var isNeedInserted = function isNeedInserted() {
        return $jbmdS.Children.count(children) === 1 && !icon && !$99981527f631c75b$var$isUnBorderedButtonType(type);
    };
    var fixTwoCNChar = function fixTwoCNChar() {
        // Fix for HOC usage like <FormatMessage />
        if (!buttonRef || !buttonRef.current || autoInsertSpaceInButton === false) return;
        var buttonText = buttonRef.current.textContent;
        if (isNeedInserted() && $99981527f631c75b$var$isTwoCNChar(buttonText)) {
            if (!hasTwoCNChar) setHasTwoCNChar(true);
        } else if (hasTwoCNChar) setHasTwoCNChar(false);
    };
    // =============== Update Loading ===============
    var loadingOrDelay = typeof loading === "boolean" ? loading : (loading === null || loading === void 0 ? void 0 : loading.delay) || true;
    $jbmdS.useEffect(function() {
        var delayTimer = null;
        if (typeof loadingOrDelay === "number") delayTimer = window.setTimeout(function() {
            delayTimer = null;
            setLoading(loadingOrDelay);
        }, loadingOrDelay);
        else setLoading(loadingOrDelay);
        return function() {
            if (delayTimer) {
                // in order to not perform a React state update on an unmounted component
                // and clear timer after 'loadingOrDelay' updated.
                window.clearTimeout(delayTimer);
                delayTimer = null;
            }
        };
    }, [
        loadingOrDelay
    ]);
    $jbmdS.useEffect(fixTwoCNChar, [
        buttonRef
    ]);
    var handleClick = function handleClick(e) {
        var onClick = props.onClick;
        // https://github.com/ant-design/ant-design/issues/30207
        if (innerLoading || mergedDisabled) {
            e.preventDefault();
            return;
        }
        onClick === null || onClick === void 0 || onClick(e);
    };
    var prefixCls = getPrefixCls("btn", customizePrefixCls);
    var autoInsertSpace = autoInsertSpaceInButton !== false;
    var _useCompactItemContex = (0, $9RKXl.useCompactItemContext)(prefixCls, direction), compactSize = _useCompactItemContex.compactSize, compactItemClassnames = _useCompactItemContex.compactItemClassnames;
    var sizeClassNameMap = {
        large: "lg",
        small: "sm",
        middle: undefined
    };
    var sizeFullname = compactSize || groupSize || customizeSize || size;
    var sizeCls = sizeFullname ? sizeClassNameMap[sizeFullname] || "" : "";
    var iconType = innerLoading ? "loading" : icon;
    var linkButtonRestProps = (0, $cXDkH.default)(rest, [
        "navigate"
    ]);
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(prefixCls, (_classNames = {}, (0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)(_classNames, "".concat(prefixCls, "-").concat(shape), shape !== "default" && shape), "".concat(prefixCls, "-").concat(type), type), "".concat(prefixCls, "-").concat(sizeCls), sizeCls), "".concat(prefixCls, "-icon-only"), !children && children !== 0 && !!iconType), "".concat(prefixCls, "-background-ghost"), ghost && !$99981527f631c75b$var$isUnBorderedButtonType(type)), "".concat(prefixCls, "-loading"), innerLoading), "".concat(prefixCls, "-two-chinese-chars"), hasTwoCNChar && autoInsertSpace && !innerLoading), "".concat(prefixCls, "-block"), block), "".concat(prefixCls, "-dangerous"), !!danger), "".concat(prefixCls, "-rtl"), direction === "rtl"), (0, $8K2NM.default)(_classNames, "".concat(prefixCls, "-disabled"), linkButtonRestProps.href !== undefined && mergedDisabled)), compactItemClassnames, className);
    var iconNode = icon && !innerLoading ? icon : /*#__PURE__*/ $jbmdS.createElement((0, $fKUMH.default), {
        existIcon: !!icon,
        prefixCls: prefixCls,
        loading: !!innerLoading
    });
    var kids = children || children === 0 ? $99981527f631c75b$var$spaceChildren(children, isNeedInserted() && autoInsertSpace) : null;
    if (linkButtonRestProps.href !== undefined) return /*#__PURE__*/ $jbmdS.createElement("a", (0, $7i29i.default)({}, linkButtonRestProps, {
        className: classes,
        onClick: handleClick,
        ref: buttonRef
    }), iconNode, kids);
    var buttonNode = /*#__PURE__*/ $jbmdS.createElement("button", (0, $7i29i.default)({}, rest, {
        type: htmlType,
        className: classes,
        onClick: handleClick,
        disabled: mergedDisabled,
        ref: buttonRef
    }), iconNode, kids);
    if ($99981527f631c75b$var$isUnBorderedButtonType(type)) return buttonNode;
    return /*#__PURE__*/ $jbmdS.createElement((0, $ccZcg.default), {
        disabled: !!innerLoading
    }, buttonNode);
};
var $99981527f631c75b$var$Button = /*#__PURE__*/ $jbmdS.forwardRef($99981527f631c75b$var$InternalButton);
$99981527f631c75b$var$Button.Group = (0, $bOMNW.default);
$99981527f631c75b$var$Button.__ANT_BUTTON = true;
var $99981527f631c75b$export$2e2bcd8739ae039 = $99981527f631c75b$var$Button;

});
parcelRegister("8K2NM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65d4cb00fa49e65c$export$2e2bcd8739ae039; });

var $90Xx2 = parcelRequire("90Xx2");
function $65d4cb00fa49e65c$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $90Xx2.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("90Xx2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69024aeba6fdb7e1$export$2e2bcd8739ae039; });

var $jncUt = parcelRequire("jncUt");

var $6sYbt = parcelRequire("6sYbt");
function $69024aeba6fdb7e1$export$2e2bcd8739ae039(t) {
    var i = (0, $6sYbt.default)(t, "string");
    return "symbol" == (0, $jncUt.default)(i) ? i : i + "";
}

});
parcelRegister("jncUt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1aa2deae44c4df2$export$2e2bcd8739ae039; });
function $e1aa2deae44c4df2$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $e1aa2deae44c4df2$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e1aa2deae44c4df2$export$2e2bcd8739ae039(o);
}

});

parcelRegister("6sYbt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b540ae87de45d4e$export$2e2bcd8739ae039; });

var $jncUt = parcelRequire("jncUt");
function $4b540ae87de45d4e$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $jncUt.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $jncUt.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("CZyex", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07534b806b26f2af$export$2e2bcd8739ae039; });

var $xhMdv = parcelRequire("xhMdv");

var $dJ86c = parcelRequire("dJ86c");

var $9wrOE = parcelRequire("9wrOE");

var $5EV8b = parcelRequire("5EV8b");
function $07534b806b26f2af$export$2e2bcd8739ae039(r, e) {
    return (0, $xhMdv.default)(r) || (0, $dJ86c.default)(r, e) || (0, $9wrOE.default)(r, e) || (0, $5EV8b.default)();
}

});
parcelRegister("xhMdv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0640df434952dd8a$export$2e2bcd8739ae039; });
function $0640df434952dd8a$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("dJ86c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fe5c2a41c8a784c$export$2e2bcd8739ae039; });
function $9fe5c2a41c8a784c$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("9wrOE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6eecaddbd25608ce$export$2e2bcd8739ae039; });

var $5az5B = parcelRequire("5az5B");
function $6eecaddbd25608ce$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $5az5B.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $5az5B.default)(r, a) : void 0;
    }
}

});
parcelRegister("5az5B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c391af71c756fbb$export$2e2bcd8739ae039; });
function $3c391af71c756fbb$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("5EV8b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41ed013a444e661e$export$2e2bcd8739ae039; });
function $41ed013a444e661e$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("cXDkH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96f9816845c9bb99$export$2e2bcd8739ae039; });
function $96f9816845c9bb99$export$2e2bcd8739ae039(obj, fields) {
    var clone = Object.assign({}, obj);
    if (Array.isArray(fields)) fields.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}

});

parcelRegister("8uDri", function(module, exports) {

$parcel$export(module.exports, "globalConfig", function () { return $62efb7e325e687ab$export$f9cd1e43211d8a4a; });
$parcel$export(module.exports, "default", function () { return $62efb7e325e687ab$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "ConfigContext", function () { return (parcelRequire("ewikT")).ConfigContext; });
$parcel$export(module.exports, "ConfigConsumer", function () { return (parcelRequire("ewikT")).ConfigConsumer; });

var $7i29i = parcelRequire("7i29i");

var $k3Laf = parcelRequire("k3Laf");

var $gwVpW = parcelRequire("gwVpW");

var $jbmdS = parcelRequire("jbmdS");

var $cbsvf = parcelRequire("cbsvf");

var $glvXz = parcelRequire("glvXz");

var $8C6T9 = parcelRequire("8C6T9");

var $bGRjq = parcelRequire("bGRjq");

var $4b0G1 = parcelRequire("4b0G1");

var $d2T9p = parcelRequire("d2T9p");

var $k5oMv = parcelRequire("k5oMv");

var $ewikT = parcelRequire("ewikT");

var $6fsb1 = parcelRequire("6fsb1");

var $kgIuF = parcelRequire("kgIuF");

var $7VQDG = parcelRequire("7VQDG");
var $62efb7e325e687ab$export$e7f14a745e5c386a = [
    "getTargetContainer",
    "getPopupContainer",
    "rootPrefixCls",
    "getPrefixCls",
    "renderEmpty",
    "csp",
    "autoInsertSpaceInButton",
    "locale",
    "pageHeader"
];
// These props is used by `useContext` directly in sub component
var $62efb7e325e687ab$var$PASSED_PROPS = [
    "getTargetContainer",
    "getPopupContainer",
    "renderEmpty",
    "pageHeader",
    "input",
    "pagination",
    "form"
];
var $62efb7e325e687ab$export$e4ec87ea71f29b41 = "ant";
var $62efb7e325e687ab$export$eaca8ee5ed21b4e9 = "anticon";
var $62efb7e325e687ab$var$globalPrefixCls;
var $62efb7e325e687ab$var$globalIconPrefixCls;
function $62efb7e325e687ab$var$getGlobalPrefixCls() {
    return $62efb7e325e687ab$var$globalPrefixCls || $62efb7e325e687ab$export$e4ec87ea71f29b41;
}
function $62efb7e325e687ab$var$getGlobalIconPrefixCls() {
    return $62efb7e325e687ab$var$globalIconPrefixCls || $62efb7e325e687ab$export$eaca8ee5ed21b4e9;
}
var $62efb7e325e687ab$var$setGlobalConfig = function setGlobalConfig(_ref) {
    var prefixCls = _ref.prefixCls, iconPrefixCls = _ref.iconPrefixCls, theme = _ref.theme;
    if (prefixCls !== undefined) $62efb7e325e687ab$var$globalPrefixCls = prefixCls;
    if (iconPrefixCls !== undefined) $62efb7e325e687ab$var$globalIconPrefixCls = iconPrefixCls;
    if (theme) (0, $6fsb1.registerTheme)($62efb7e325e687ab$var$getGlobalPrefixCls(), theme);
};
var $62efb7e325e687ab$export$f9cd1e43211d8a4a = function globalConfig() {
    return {
        getPrefixCls: function getPrefixCls(suffixCls, customizePrefixCls) {
            if (customizePrefixCls) return customizePrefixCls;
            return suffixCls ? "".concat($62efb7e325e687ab$var$getGlobalPrefixCls(), "-").concat(suffixCls) : $62efb7e325e687ab$var$getGlobalPrefixCls();
        },
        getIconPrefixCls: $62efb7e325e687ab$var$getGlobalIconPrefixCls,
        getRootPrefixCls: function getRootPrefixCls(rootPrefixCls, customizePrefixCls) {
            // Customize rootPrefixCls is first priority
            if (rootPrefixCls) return rootPrefixCls;
            // If Global prefixCls provided, use this
            if ($62efb7e325e687ab$var$globalPrefixCls) return $62efb7e325e687ab$var$globalPrefixCls;
            // [Legacy] If customize prefixCls provided, we cut it to get the prefixCls
            if (customizePrefixCls && customizePrefixCls.includes("-")) return customizePrefixCls.replace(/^(.*)-[^-]*$/, "$1");
            // Fallback to default prefixCls
            return $62efb7e325e687ab$var$getGlobalPrefixCls();
        }
    };
};
var $62efb7e325e687ab$var$ProviderChildren = function ProviderChildren(props) {
    var children = props.children, csp = props.csp, autoInsertSpaceInButton = props.autoInsertSpaceInButton, form = props.form, locale = props.locale, componentSize = props.componentSize, direction = props.direction, space = props.space, virtual = props.virtual, dropdownMatchSelectWidth = props.dropdownMatchSelectWidth, legacyLocale = props.legacyLocale, parentContext = props.parentContext, iconPrefixCls = props.iconPrefixCls, componentDisabled = props.componentDisabled;
    var getPrefixCls = $jbmdS.useCallback(function(suffixCls, customizePrefixCls) {
        var prefixCls = props.prefixCls;
        if (customizePrefixCls) return customizePrefixCls;
        var mergedPrefixCls = prefixCls || parentContext.getPrefixCls("");
        return suffixCls ? "".concat(mergedPrefixCls, "-").concat(suffixCls) : mergedPrefixCls;
    }, [
        parentContext.getPrefixCls,
        props.prefixCls
    ]);
    var config = (0, $7i29i.default)((0, $7i29i.default)({}, parentContext), {
        csp: csp,
        autoInsertSpaceInButton: autoInsertSpaceInButton,
        locale: locale || legacyLocale,
        direction: direction,
        space: space,
        virtual: virtual,
        dropdownMatchSelectWidth: dropdownMatchSelectWidth,
        getPrefixCls: getPrefixCls
    });
    // Pass the props used by `useContext` directly with child component.
    // These props should merged into `config`.
    $62efb7e325e687ab$var$PASSED_PROPS.forEach(function(propName) {
        var propValue = props[propName];
        if (propValue) config[propName] = propValue;
    });
    // https://github.com/ant-design/ant-design/issues/27617
    var memoedConfig = (0, $gwVpW.default)(function() {
        return config;
    }, config, function(prevConfig, currentConfig) {
        var prevKeys = Object.keys(prevConfig);
        var currentKeys = Object.keys(currentConfig);
        return prevKeys.length !== currentKeys.length || prevKeys.some(function(key) {
            return prevConfig[key] !== currentConfig[key];
        });
    });
    var memoIconContextValue = $jbmdS.useMemo(function() {
        return {
            prefixCls: iconPrefixCls,
            csp: csp
        };
    }, [
        iconPrefixCls,
        csp
    ]);
    var childNode = children;
    var validateMessages = $jbmdS.useMemo(function() {
        var _a, _b, _c, _d;
        return (0, $cbsvf.merge)(((_a = (0, $4b0G1.default).Form) === null || _a === void 0 ? void 0 : _a.defaultValidateMessages) || {}, ((_c = (_b = memoedConfig.locale) === null || _b === void 0 ? void 0 : _b.Form) === null || _c === void 0 ? void 0 : _c.defaultValidateMessages) || {}, ((_d = memoedConfig.form) === null || _d === void 0 ? void 0 : _d.validateMessages) || {}, (form === null || form === void 0 ? void 0 : form.validateMessages) || {});
    }, [
        memoedConfig,
        form === null || form === void 0 ? void 0 : form.validateMessages
    ]);
    if (Object.keys(validateMessages).length > 0) childNode = /*#__PURE__*/ $jbmdS.createElement((0, $glvXz.default).Provider, {
        value: validateMessages
    }, children);
    if (locale) childNode = /*#__PURE__*/ $jbmdS.createElement((0, $8C6T9.default), {
        locale: locale,
        _ANT_MARK__: (0, $8C6T9.ANT_MARK)
    }, childNode);
    if (iconPrefixCls || csp) childNode = /*#__PURE__*/ $jbmdS.createElement((0, $k3Laf.default).Provider, {
        value: memoIconContextValue
    }, childNode);
    if (componentSize) childNode = /*#__PURE__*/ $jbmdS.createElement((0, $7VQDG.SizeContextProvider), {
        size: componentSize
    }, childNode);
    if (componentDisabled !== undefined) childNode = /*#__PURE__*/ $jbmdS.createElement((0, $kgIuF.DisabledContextProvider), {
        disabled: componentDisabled
    }, childNode);
    return /*#__PURE__*/ $jbmdS.createElement((0, $ewikT.ConfigContext).Provider, {
        value: memoedConfig
    }, childNode);
};
var $62efb7e325e687ab$var$ConfigProvider = function ConfigProvider(props) {
    $jbmdS.useEffect(function() {
        if (props.direction) {
            (0, $d2T9p.default).config({
                rtl: props.direction === "rtl"
            });
            (0, $k5oMv.default).config({
                rtl: props.direction === "rtl"
            });
        }
    }, [
        props.direction
    ]);
    return /*#__PURE__*/ $jbmdS.createElement((0, $bGRjq.default), null, function(_, __, legacyLocale) {
        return /*#__PURE__*/ $jbmdS.createElement((0, $ewikT.ConfigConsumer), null, function(context) {
            return /*#__PURE__*/ $jbmdS.createElement($62efb7e325e687ab$var$ProviderChildren, (0, $7i29i.default)({
                parentContext: context,
                legacyLocale: legacyLocale
            }, props));
        });
    });
};
/** @private internal Usage. do not use in your production */ $62efb7e325e687ab$var$ConfigProvider.ConfigContext = (0, $ewikT.ConfigContext);
$62efb7e325e687ab$var$ConfigProvider.SizeContext = (0, $7VQDG.default);
$62efb7e325e687ab$var$ConfigProvider.config = $62efb7e325e687ab$var$setGlobalConfig;
var $62efb7e325e687ab$export$2e2bcd8739ae039 = $62efb7e325e687ab$var$ConfigProvider;

});
parcelRegister("k3Laf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9a8ac4a0c11a4fe$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");
var $e9a8ac4a0c11a4fe$var$IconContext = /*#__PURE__*/ (0, $jbmdS.createContext)({});
var $e9a8ac4a0c11a4fe$export$2e2bcd8739ae039 = $e9a8ac4a0c11a4fe$var$IconContext;

});

parcelRegister("gwVpW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c08c2c6c83ff2eb3$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");
function $c08c2c6c83ff2eb3$export$2e2bcd8739ae039(getValue, condition, shouldUpdate) {
    var cacheRef = $jbmdS.useRef({});
    if (!("value" in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
        cacheRef.current.value = getValue();
        cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
}

});

parcelRegister("cbsvf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8dec9f3874c4b2a2$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "merge", function () { return $8dec9f3874c4b2a2$export$4950aa0f605343fb; });

var $jncUt = parcelRequire("jncUt");

var $lv6ip = parcelRequire("lv6ip");

var $huwkX = parcelRequire("huwkX");

var $fdUcS = parcelRequire("fdUcS");

var $4eeUf = parcelRequire("4eeUf");
function $8dec9f3874c4b2a2$var$internalSet(entity, paths, value, removeIfUndefined) {
    if (!paths.length) return value;
    var _paths = (0, $fdUcS.default)(paths), path = _paths[0], restPath = _paths.slice(1);
    var clone;
    if (!entity && typeof path === "number") clone = [];
    else if (Array.isArray(entity)) clone = (0, $huwkX.default)(entity);
    else clone = (0, $lv6ip.default)({}, entity);
    // Delete prop if `removeIfUndefined` and value is undefined
    if (removeIfUndefined && value === undefined && restPath.length === 1) delete clone[path][restPath[0]];
    else clone[path] = $8dec9f3874c4b2a2$var$internalSet(clone[path], restPath, value, removeIfUndefined);
    return clone;
}
function $8dec9f3874c4b2a2$export$2e2bcd8739ae039(entity, paths, value) {
    var removeIfUndefined = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    // Do nothing if `removeIfUndefined` and parent object not exist
    if (paths.length && removeIfUndefined && value === undefined && !(0, $4eeUf.default)(entity, paths.slice(0, -1))) return entity;
    return $8dec9f3874c4b2a2$var$internalSet(entity, paths, value, removeIfUndefined);
}
function $8dec9f3874c4b2a2$var$isObject(obj) {
    return (0, $jncUt.default)(obj) === "object" && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
function $8dec9f3874c4b2a2$var$createEmpty(source) {
    return Array.isArray(source) ? [] : {};
}
var $8dec9f3874c4b2a2$var$keys = typeof Reflect === "undefined" ? Object.keys : Reflect.ownKeys;
function $8dec9f3874c4b2a2$export$4950aa0f605343fb() {
    for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
    var clone = $8dec9f3874c4b2a2$var$createEmpty(sources[0]);
    sources.forEach(function(src) {
        function internalMerge(path, parentLoopSet) {
            var loopSet = new Set(parentLoopSet);
            var value = (0, $4eeUf.default)(src, path);
            var isArr = Array.isArray(value);
            if (isArr || $8dec9f3874c4b2a2$var$isObject(value)) // Only add not loop obj
            {
                if (!loopSet.has(value)) {
                    loopSet.add(value);
                    var originValue = (0, $4eeUf.default)(clone, path);
                    if (isArr) // Array will always be override
                    clone = $8dec9f3874c4b2a2$export$2e2bcd8739ae039(clone, path, []);
                    else if (!originValue || (0, $jncUt.default)(originValue) !== "object") // Init container if not exist
                    clone = $8dec9f3874c4b2a2$export$2e2bcd8739ae039(clone, path, $8dec9f3874c4b2a2$var$createEmpty(value));
                    $8dec9f3874c4b2a2$var$keys(value).forEach(function(key) {
                        internalMerge([].concat((0, $huwkX.default)(path), [
                            key
                        ]), loopSet);
                    });
                }
            } else clone = $8dec9f3874c4b2a2$export$2e2bcd8739ae039(clone, path, value);
        }
        internalMerge([]);
    });
    return clone;
}

});
parcelRegister("lv6ip", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa7160766547d224$export$2e2bcd8739ae039; });

var $8K2NM = parcelRequire("8K2NM");
function $fa7160766547d224$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fa7160766547d224$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fa7160766547d224$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $8K2NM.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fa7160766547d224$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});

parcelRegister("huwkX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cbbe527a60268080$export$2e2bcd8739ae039; });

var $1Rz2S = parcelRequire("1Rz2S");

var $2efwL = parcelRequire("2efwL");

var $9wrOE = parcelRequire("9wrOE");

var $4obXR = parcelRequire("4obXR");
function $cbbe527a60268080$export$2e2bcd8739ae039(r) {
    return (0, $1Rz2S.default)(r) || (0, $2efwL.default)(r) || (0, $9wrOE.default)(r) || (0, $4obXR.default)();
}

});
parcelRegister("1Rz2S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15b5ecf610cbf87d$export$2e2bcd8739ae039; });

var $5az5B = parcelRequire("5az5B");
function $15b5ecf610cbf87d$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $5az5B.default)(r);
}

});

parcelRegister("2efwL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19f8eefe1f8ac608$export$2e2bcd8739ae039; });
function $19f8eefe1f8ac608$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("4obXR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3322af369f5a6a8d$export$2e2bcd8739ae039; });
function $3322af369f5a6a8d$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("fdUcS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b153ab5e07f113a0$export$2e2bcd8739ae039; });

var $xhMdv = parcelRequire("xhMdv");

var $2efwL = parcelRequire("2efwL");

var $9wrOE = parcelRequire("9wrOE");

var $5EV8b = parcelRequire("5EV8b");
function $b153ab5e07f113a0$export$2e2bcd8739ae039(r) {
    return (0, $xhMdv.default)(r) || (0, $2efwL.default)(r) || (0, $9wrOE.default)(r) || (0, $5EV8b.default)();
}

});

parcelRegister("4eeUf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3144084d663eae0c$export$2e2bcd8739ae039; });
function $3144084d663eae0c$export$2e2bcd8739ae039(entity, path) {
    var current = entity;
    for(var i = 0; i < path.length; i += 1){
        if (current === null || current === undefined) return undefined;
        current = current[path[i]];
    }
    return current;
}

});


parcelRegister("glvXz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be67660abd3765a4$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");
var // ZombieJ: We export single file here since
// ConfigProvider use this which will make loop deps
// to import whole `rc-field-form`
$be67660abd3765a4$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $jbmdS.createContext)(undefined);

});

parcelRegister("8C6T9", function(module, exports) {

$parcel$export(module.exports, "ANT_MARK", function () { return $6457374300fb2aa5$export$b2f162cd5c15ea3e; });
$parcel$export(module.exports, "default", function () { return $6457374300fb2aa5$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $jbmdS = parcelRequire("jbmdS");


var $eBIZK = parcelRequire("eBIZK");

var $nZa4R = parcelRequire("nZa4R");
var $6457374300fb2aa5$export$b2f162cd5c15ea3e = "internalMark";
var $6457374300fb2aa5$var$LocaleProvider = function LocaleProvider(props) {
    var _props$locale = props.locale, locale = _props$locale === void 0 ? {} : _props$locale, children = props.children, _ANT_MARK__ = props._ANT_MARK__;
    $jbmdS.useEffect(function() {
        (0, $eBIZK.changeConfirmLocale)(locale && locale.Modal);
        return function() {
            (0, $eBIZK.changeConfirmLocale)();
        };
    }, [
        locale
    ]);
    var getMemoizedContextValue = $jbmdS.useMemo(function() {
        return (0, $7i29i.default)((0, $7i29i.default)({}, locale), {
            exist: true
        });
    }, [
        locale
    ]);
    return /*#__PURE__*/ $jbmdS.createElement((0, $nZa4R.default).Provider, {
        value: getMemoizedContextValue
    }, children);
};
var $6457374300fb2aa5$export$2e2bcd8739ae039 = $6457374300fb2aa5$var$LocaleProvider;

});
parcelRegister("eBIZK", function(module, exports) {

$parcel$export(module.exports, "changeConfirmLocale", function () { return $aa276c6e4f02ee33$export$9485ecb9d81a550c; });

var $7i29i = parcelRequire("7i29i");

var $4b0G1 = parcelRequire("4b0G1");
var $aa276c6e4f02ee33$var$runtimeLocale = (0, $7i29i.default)({}, (0, $4b0G1.default).Modal);
function $aa276c6e4f02ee33$export$9485ecb9d81a550c(newLocale) {
    if (newLocale) $aa276c6e4f02ee33$var$runtimeLocale = (0, $7i29i.default)((0, $7i29i.default)({}, $aa276c6e4f02ee33$var$runtimeLocale), newLocale);
    else $aa276c6e4f02ee33$var$runtimeLocale = (0, $7i29i.default)({}, (0, $4b0G1.default).Modal);
}
function $aa276c6e4f02ee33$export$1b6004afda18cd51() {
    return $aa276c6e4f02ee33$var$runtimeLocale;
}

});
parcelRegister("4b0G1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30a8b6e46fdf83f6$export$2e2bcd8739ae039; });
/* eslint-disable no-template-curly-in-string */ 
var $gaAz9 = parcelRequire("gaAz9");

var $1ro7X = parcelRequire("1ro7X");

var $72IEL = parcelRequire("72IEL");

var $kJgZ3 = parcelRequire("kJgZ3");
var $30a8b6e46fdf83f6$var$typeTemplate = "${label} is not a valid ${type}";
var $30a8b6e46fdf83f6$var$localeValues = {
    locale: "en",
    Pagination: (0, $gaAz9.default),
    DatePicker: (0, $72IEL.default),
    TimePicker: (0, $kJgZ3.default),
    Calendar: (0, $1ro7X.default),
    global: {
        placeholder: "Please select"
    },
    Table: {
        filterTitle: "Filter menu",
        filterConfirm: "OK",
        filterReset: "Reset",
        filterEmptyText: "No filters",
        filterCheckall: "Select all items",
        filterSearchPlaceholder: "Search in filters",
        emptyText: "No data",
        selectAll: "Select current page",
        selectInvert: "Invert current page",
        selectNone: "Clear all data",
        selectionAll: "Select all data",
        sortTitle: "Sort",
        expand: "Expand row",
        collapse: "Collapse row",
        triggerDesc: "Click to sort descending",
        triggerAsc: "Click to sort ascending",
        cancelSort: "Click to cancel sorting"
    },
    Modal: {
        okText: "OK",
        cancelText: "Cancel",
        justOkText: "OK"
    },
    Popconfirm: {
        okText: "OK",
        cancelText: "Cancel"
    },
    Transfer: {
        titles: [
            "",
            ""
        ],
        searchPlaceholder: "Search here",
        itemUnit: "item",
        itemsUnit: "items",
        remove: "Remove",
        selectCurrent: "Select current page",
        removeCurrent: "Remove current page",
        selectAll: "Select all data",
        removeAll: "Remove all data",
        selectInvert: "Invert current page"
    },
    Upload: {
        uploading: "Uploading...",
        removeFile: "Remove file",
        uploadError: "Upload error",
        previewFile: "Preview file",
        downloadFile: "Download file"
    },
    Empty: {
        description: "No data"
    },
    Icon: {
        icon: "icon"
    },
    Text: {
        edit: "Edit",
        copy: "Copy",
        copied: "Copied",
        expand: "Expand"
    },
    PageHeader: {
        back: "Back"
    },
    Form: {
        optional: "(optional)",
        defaultValidateMessages: {
            "default": "Field validation error for ${label}",
            required: "Please enter ${label}",
            "enum": "${label} must be one of [${enum}]",
            whitespace: "${label} cannot be a blank character",
            date: {
                format: "${label} date format is invalid",
                parse: "${label} cannot be converted to a date",
                invalid: "${label} is an invalid date"
            },
            types: {
                string: $30a8b6e46fdf83f6$var$typeTemplate,
                method: $30a8b6e46fdf83f6$var$typeTemplate,
                array: $30a8b6e46fdf83f6$var$typeTemplate,
                object: $30a8b6e46fdf83f6$var$typeTemplate,
                number: $30a8b6e46fdf83f6$var$typeTemplate,
                date: $30a8b6e46fdf83f6$var$typeTemplate,
                "boolean": $30a8b6e46fdf83f6$var$typeTemplate,
                integer: $30a8b6e46fdf83f6$var$typeTemplate,
                "float": $30a8b6e46fdf83f6$var$typeTemplate,
                regexp: $30a8b6e46fdf83f6$var$typeTemplate,
                email: $30a8b6e46fdf83f6$var$typeTemplate,
                url: $30a8b6e46fdf83f6$var$typeTemplate,
                hex: $30a8b6e46fdf83f6$var$typeTemplate
            },
            string: {
                len: "${label} must be ${len} characters",
                min: "${label} must be at least ${min} characters",
                max: "${label} must be up to ${max} characters",
                range: "${label} must be between ${min}-${max} characters"
            },
            number: {
                len: "${label} must be equal to ${len}",
                min: "${label} must be minimum ${min}",
                max: "${label} must be maximum ${max}",
                range: "${label} must be between ${min}-${max}"
            },
            array: {
                len: "Must be ${len} ${label}",
                min: "At least ${min} ${label}",
                max: "At most ${max} ${label}",
                range: "The amount of ${label} must be between ${min}-${max}"
            },
            pattern: {
                mismatch: "${label} does not match the pattern ${pattern}"
            }
        }
    },
    Image: {
        preview: "Preview"
    }
};
var $30a8b6e46fdf83f6$export$2e2bcd8739ae039 = $30a8b6e46fdf83f6$var$localeValues;

});
parcelRegister("gaAz9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc59f1c05237c9c4$export$2e2bcd8739ae039; });
var $bc59f1c05237c9c4$export$2e2bcd8739ae039 = {
    // Options.jsx
    items_per_page: "/ page",
    jump_to: "Go to",
    jump_to_confirm: "confirm",
    page: "Page",
    // Pagination.jsx
    prev_page: "Previous Page",
    next_page: "Next Page",
    prev_5: "Previous 5 Pages",
    next_5: "Next 5 Pages",
    prev_3: "Previous 3 Pages",
    next_3: "Next 3 Pages",
    page_size: "Page Size"
};

});

parcelRegister("1ro7X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10cb074567f20006$export$2e2bcd8739ae039; });

var $72IEL = parcelRequire("72IEL");
var $10cb074567f20006$export$2e2bcd8739ae039 = (0, $72IEL.default);

});
parcelRegister("72IEL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $520b5c2b04135977$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $9n2iB = parcelRequire("9n2iB");

var $kJgZ3 = parcelRequire("kJgZ3");
// Merge into a locale object
var $520b5c2b04135977$var$locale = {
    lang: (0, $7i29i.default)({
        placeholder: "Select date",
        yearPlaceholder: "Select year",
        quarterPlaceholder: "Select quarter",
        monthPlaceholder: "Select month",
        weekPlaceholder: "Select week",
        rangePlaceholder: [
            "Start date",
            "End date"
        ],
        rangeYearPlaceholder: [
            "Start year",
            "End year"
        ],
        rangeQuarterPlaceholder: [
            "Start quarter",
            "End quarter"
        ],
        rangeMonthPlaceholder: [
            "Start month",
            "End month"
        ],
        rangeWeekPlaceholder: [
            "Start week",
            "End week"
        ]
    }, (0, $9n2iB.default)),
    timePickerLocale: (0, $7i29i.default)({}, (0, $kJgZ3.default))
};
var // All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
$520b5c2b04135977$export$2e2bcd8739ae039 = $520b5c2b04135977$var$locale;

});
parcelRegister("9n2iB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d280b97649930e0$export$2e2bcd8739ae039; });
var $6d280b97649930e0$var$locale = {
    locale: "en_US",
    today: "Today",
    now: "Now",
    backToToday: "Back to today",
    ok: "OK",
    clear: "Clear",
    month: "Month",
    year: "Year",
    timeSelect: "select time",
    dateSelect: "select date",
    weekSelect: "Choose a week",
    monthSelect: "Choose a month",
    yearSelect: "Choose a year",
    decadeSelect: "Choose a decade",
    yearFormat: "YYYY",
    dateFormat: "M/D/YYYY",
    dayFormat: "D",
    dateTimeFormat: "M/D/YYYY HH:mm:ss",
    monthBeforeYear: true,
    previousMonth: "Previous month (PageUp)",
    nextMonth: "Next month (PageDown)",
    previousYear: "Last year (Control + left)",
    nextYear: "Next year (Control + right)",
    previousDecade: "Last decade",
    nextDecade: "Next decade",
    previousCentury: "Last century",
    nextCentury: "Next century"
};
var $6d280b97649930e0$export$2e2bcd8739ae039 = $6d280b97649930e0$var$locale;

});

parcelRegister("kJgZ3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1752f3fb17d81ae$export$2e2bcd8739ae039; });
var $f1752f3fb17d81ae$var$locale = {
    placeholder: "Select time",
    rangePlaceholder: [
        "Start time",
        "End time"
    ]
};
var $f1752f3fb17d81ae$export$2e2bcd8739ae039 = $f1752f3fb17d81ae$var$locale;

});





parcelRegister("nZa4R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $048197811c051bee$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");
var $048197811c051bee$var$LocaleContext = /*#__PURE__*/ (0, $jbmdS.createContext)(undefined);
var $048197811c051bee$export$2e2bcd8739ae039 = $048197811c051bee$var$LocaleContext;

});


parcelRegister("bGRjq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $882cf8b072f2cc7c$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $jbmdS = parcelRequire("jbmdS");

var $nZa4R = parcelRequire("nZa4R");

var $1RM2M = parcelRequire("1RM2M");
var $882cf8b072f2cc7c$var$LocaleReceiver = function LocaleReceiver(props) {
    var _props$componentName = props.componentName, componentName = _props$componentName === void 0 ? "global" : _props$componentName, defaultLocale = props.defaultLocale, children = props.children;
    var antLocale = $jbmdS.useContext((0, $nZa4R.default));
    var getLocale = $jbmdS.useMemo(function() {
        var _a;
        var locale = defaultLocale || (0, $1RM2M.default)[componentName];
        var localeFromContext = (_a = antLocale === null || antLocale === void 0 ? void 0 : antLocale[componentName]) !== null && _a !== void 0 ? _a : {};
        return (0, $7i29i.default)((0, $7i29i.default)({}, locale instanceof Function ? locale() : locale), localeFromContext || {});
    }, [
        componentName,
        defaultLocale,
        antLocale
    ]);
    var getLocaleCode = $jbmdS.useMemo(function() {
        var localeCode = antLocale && antLocale.locale;
        // Had use LocaleProvide but didn't set locale
        if (antLocale && antLocale.exist && !localeCode) return (0, $1RM2M.default).locale;
        return localeCode;
    }, [
        antLocale
    ]);
    return children(getLocale, getLocaleCode, antLocale);
};
var $882cf8b072f2cc7c$export$2e2bcd8739ae039 = $882cf8b072f2cc7c$var$LocaleReceiver;
var $882cf8b072f2cc7c$export$52f95bab0279a481 = function useLocaleReceiver(componentName, defaultLocale) {
    var antLocale = $jbmdS.useContext((0, $nZa4R.default));
    var getLocale = $jbmdS.useMemo(function() {
        var _a;
        var locale = defaultLocale || (0, $1RM2M.default)[componentName];
        var localeFromContext = (_a = antLocale === null || antLocale === void 0 ? void 0 : antLocale[componentName]) !== null && _a !== void 0 ? _a : {};
        return (0, $7i29i.default)((0, $7i29i.default)({}, typeof locale === "function" ? locale() : locale), localeFromContext || {});
    }, [
        componentName,
        defaultLocale,
        antLocale
    ]);
    return [
        getLocale
    ];
};

});
parcelRegister("1RM2M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15c0022f2825d208$export$2e2bcd8739ae039; });

var $4b0G1 = parcelRequire("4b0G1");
var $15c0022f2825d208$export$2e2bcd8739ae039 = (0, $4b0G1.default);

});


parcelRegister("d2T9p", function(module, exports) {

$parcel$export(module.exports, "getKeyThenIncreaseKey", function () { return $97f63e0f85f01047$export$ab227b2024307500; });
$parcel$export(module.exports, "typeList", function () { return $97f63e0f85f01047$export$37928ca2918d853b; });
$parcel$export(module.exports, "attachTypeApi", function () { return $97f63e0f85f01047$export$63b017493c112c94; });
$parcel$export(module.exports, "default", function () { return $97f63e0f85f01047$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $8K2NM = parcelRequire("8K2NM");

var $1QBcl = parcelRequire("1QBcl");

var $kPBAG = parcelRequire("kPBAG");

var $6kn9Y = parcelRequire("6kn9Y");

var $lRx2a = parcelRequire("lRx2a");

var $97QHC = parcelRequire("97QHC");

var $02LyB = parcelRequire("02LyB");

var $iJQYM = parcelRequire("iJQYM");

var $jbmdS = parcelRequire("jbmdS");

var $8uDri = parcelRequire("8uDri");

var $gOp0Y = parcelRequire("gOp0Y");
var $97f63e0f85f01047$var$messageInstance;
var $97f63e0f85f01047$var$defaultDuration = 3;
var $97f63e0f85f01047$var$defaultTop;
var $97f63e0f85f01047$var$key = 1;
var $97f63e0f85f01047$var$localPrefixCls = "";
var $97f63e0f85f01047$var$transitionName = "move-up";
var $97f63e0f85f01047$var$hasTransitionName = false;
var $97f63e0f85f01047$var$getContainer;
var $97f63e0f85f01047$var$maxCount;
var $97f63e0f85f01047$var$rtl = false;
function $97f63e0f85f01047$export$ab227b2024307500() {
    return $97f63e0f85f01047$var$key++;
}
function $97f63e0f85f01047$var$setMessageConfig(options) {
    if (options.top !== undefined) {
        $97f63e0f85f01047$var$defaultTop = options.top;
        $97f63e0f85f01047$var$messageInstance = null; // delete messageInstance for new defaultTop
    }
    if (options.duration !== undefined) $97f63e0f85f01047$var$defaultDuration = options.duration;
    if (options.prefixCls !== undefined) $97f63e0f85f01047$var$localPrefixCls = options.prefixCls;
    if (options.getContainer !== undefined) {
        $97f63e0f85f01047$var$getContainer = options.getContainer;
        $97f63e0f85f01047$var$messageInstance = null; // delete messageInstance for new getContainer
    }
    if (options.transitionName !== undefined) {
        $97f63e0f85f01047$var$transitionName = options.transitionName;
        $97f63e0f85f01047$var$messageInstance = null; // delete messageInstance for new transitionName
        $97f63e0f85f01047$var$hasTransitionName = true;
    }
    if (options.maxCount !== undefined) {
        $97f63e0f85f01047$var$maxCount = options.maxCount;
        $97f63e0f85f01047$var$messageInstance = null;
    }
    if (options.rtl !== undefined) $97f63e0f85f01047$var$rtl = options.rtl;
}
function $97f63e0f85f01047$var$getRCNotificationInstance(args, callback) {
    var customizePrefixCls = args.prefixCls, getContextPopupContainer = args.getPopupContainer;
    var _globalConfig = (0, $8uDri.globalConfig)(), getPrefixCls = _globalConfig.getPrefixCls, getRootPrefixCls = _globalConfig.getRootPrefixCls, getIconPrefixCls = _globalConfig.getIconPrefixCls;
    var prefixCls = getPrefixCls("message", customizePrefixCls || $97f63e0f85f01047$var$localPrefixCls);
    var rootPrefixCls = getRootPrefixCls(args.rootPrefixCls, prefixCls);
    var iconPrefixCls = getIconPrefixCls();
    if ($97f63e0f85f01047$var$messageInstance) {
        callback({
            prefixCls: prefixCls,
            rootPrefixCls: rootPrefixCls,
            iconPrefixCls: iconPrefixCls,
            instance: $97f63e0f85f01047$var$messageInstance
        });
        return;
    }
    var instanceConfig = {
        prefixCls: prefixCls,
        transitionName: $97f63e0f85f01047$var$hasTransitionName ? $97f63e0f85f01047$var$transitionName : "".concat(rootPrefixCls, "-").concat($97f63e0f85f01047$var$transitionName),
        style: {
            top: $97f63e0f85f01047$var$defaultTop
        },
        getContainer: $97f63e0f85f01047$var$getContainer || getContextPopupContainer,
        maxCount: $97f63e0f85f01047$var$maxCount
    };
    (0, $iJQYM.default).newInstance(instanceConfig, function(instance) {
        if ($97f63e0f85f01047$var$messageInstance) {
            callback({
                prefixCls: prefixCls,
                rootPrefixCls: rootPrefixCls,
                iconPrefixCls: iconPrefixCls,
                instance: $97f63e0f85f01047$var$messageInstance
            });
            return;
        }
        $97f63e0f85f01047$var$messageInstance = instance;
        callback({
            prefixCls: prefixCls,
            rootPrefixCls: rootPrefixCls,
            iconPrefixCls: iconPrefixCls,
            instance: instance
        });
    });
}
var $97f63e0f85f01047$var$typeToIcon = {
    info: (0, $lRx2a.default),
    success: (0, $1QBcl.default),
    error: (0, $kPBAG.default),
    warning: (0, $6kn9Y.default),
    loading: (0, $97QHC.default)
};
var $97f63e0f85f01047$export$37928ca2918d853b = Object.keys($97f63e0f85f01047$var$typeToIcon);
function $97f63e0f85f01047$var$getRCNoticeProps(args, prefixCls, iconPrefixCls) {
    var duration = args.duration !== undefined ? args.duration : $97f63e0f85f01047$var$defaultDuration;
    var IconComponent = $97f63e0f85f01047$var$typeToIcon[args.type];
    var messageClass = (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("".concat(prefixCls, "-custom-content"), (0, $8K2NM.default)((0, $8K2NM.default)({}, "".concat(prefixCls, "-").concat(args.type), args.type), "".concat(prefixCls, "-rtl"), $97f63e0f85f01047$var$rtl === true));
    return {
        key: args.key,
        duration: duration,
        style: args.style || {},
        className: args.className,
        content: /*#__PURE__*/ $jbmdS.createElement((0, $8uDri.default), {
            iconPrefixCls: iconPrefixCls
        }, /*#__PURE__*/ $jbmdS.createElement("div", {
            className: messageClass
        }, args.icon || IconComponent && /*#__PURE__*/ $jbmdS.createElement(IconComponent, null), /*#__PURE__*/ $jbmdS.createElement("span", null, args.content))),
        onClose: args.onClose,
        onClick: args.onClick
    };
}
function $97f63e0f85f01047$var$notice(args) {
    var target = args.key || $97f63e0f85f01047$export$ab227b2024307500();
    var closePromise = new Promise(function(resolve) {
        var callback = function callback() {
            if (typeof args.onClose === "function") args.onClose();
            return resolve(true);
        };
        $97f63e0f85f01047$var$getRCNotificationInstance(args, function(_ref) {
            var prefixCls = _ref.prefixCls, iconPrefixCls = _ref.iconPrefixCls, instance = _ref.instance;
            instance.notice($97f63e0f85f01047$var$getRCNoticeProps((0, $7i29i.default)((0, $7i29i.default)({}, args), {
                key: target,
                onClose: callback
            }), prefixCls, iconPrefixCls));
        });
    });
    var result = function result() {
        var _a;
        if ($97f63e0f85f01047$var$messageInstance) {
            $97f63e0f85f01047$var$messageInstance.removeNotice(target);
            (_a = args.onClose) === null || _a === void 0 || _a.call(args);
        }
    };
    result.then = function(filled, rejected) {
        return closePromise.then(filled, rejected);
    };
    result.promise = closePromise;
    return result;
}
function $97f63e0f85f01047$var$isArgsProps(content) {
    return Object.prototype.toString.call(content) === "[object Object]" && !!content.content;
}
var $97f63e0f85f01047$var$api = {
    open: $97f63e0f85f01047$var$notice,
    config: $97f63e0f85f01047$var$setMessageConfig,
    destroy: function destroy(messageKey) {
        if ($97f63e0f85f01047$var$messageInstance) {
            if (messageKey) {
                var _messageInstance = $97f63e0f85f01047$var$messageInstance, removeNotice = _messageInstance.removeNotice;
                removeNotice(messageKey);
            } else {
                var _messageInstance2 = $97f63e0f85f01047$var$messageInstance, destroy = _messageInstance2.destroy;
                destroy();
                $97f63e0f85f01047$var$messageInstance = null;
            }
        }
    }
};
function $97f63e0f85f01047$export$63b017493c112c94(originalApi, type) {
    originalApi[type] = function(content, duration, onClose) {
        if ($97f63e0f85f01047$var$isArgsProps(content)) return originalApi.open((0, $7i29i.default)((0, $7i29i.default)({}, content), {
            type: type
        }));
        if (typeof duration === "function") {
            onClose = duration;
            duration = undefined;
        }
        return originalApi.open({
            content: content,
            duration: duration,
            type: type,
            onClose: onClose
        });
    };
}
$97f63e0f85f01047$export$37928ca2918d853b.forEach(function(type) {
    return $97f63e0f85f01047$export$63b017493c112c94($97f63e0f85f01047$var$api, type);
});
$97f63e0f85f01047$var$api.warn = $97f63e0f85f01047$var$api.warning;
$97f63e0f85f01047$var$api.useMessage = (0, $gOp0Y.default)($97f63e0f85f01047$var$getRCNotificationInstance, $97f63e0f85f01047$var$getRCNoticeProps);
var $97f63e0f85f01047$export$8bedcca5bbd73999 = function getInstance() {
    return null;
};
var $97f63e0f85f01047$export$2e2bcd8739ae039 = $97f63e0f85f01047$var$api;

});
parcelRegister("1QBcl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15878089df912386$export$2e2bcd8739ae039; });

var $lv6ip = parcelRequire("lv6ip");

var $jbmdS = parcelRequire("jbmdS");

var $iIHF3 = parcelRequire("iIHF3");

var $4hKc4 = parcelRequire("4hKc4");
var $15878089df912386$var$CheckCircleFilled = function CheckCircleFilled(props, ref) {
    return /*#__PURE__*/ $jbmdS.createElement((0, $4hKc4.default), (0, $lv6ip.default)((0, $lv6ip.default)({}, props), {}, {
        ref: ref,
        icon: (0, $iIHF3.default)
    }));
};
var $15878089df912386$var$RefIcon = /*#__PURE__*/ $jbmdS.forwardRef($15878089df912386$var$CheckCircleFilled);
var $15878089df912386$export$2e2bcd8739ae039 = $15878089df912386$var$RefIcon;

});
parcelRegister("iIHF3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da0e34415f9e58a3$export$2e2bcd8739ae039; });
// This icon file is generated automatically.
var $da0e34415f9e58a3$var$CheckCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z"
                }
            }
        ]
    },
    "name": "check-circle",
    "theme": "filled"
};
var $da0e34415f9e58a3$export$2e2bcd8739ae039 = $da0e34415f9e58a3$var$CheckCircleFilled;

});

parcelRegister("4hKc4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31ec950e1e07741e$export$2e2bcd8739ae039; });

var $lv6ip = parcelRequire("lv6ip");

var $CZyex = parcelRequire("CZyex");

var $8K2NM = parcelRequire("8K2NM");

var $ccQt4 = parcelRequire("ccQt4");

var $jbmdS = parcelRequire("jbmdS");

var $02LyB = parcelRequire("02LyB");

var $k3Laf = parcelRequire("k3Laf");

var $hZvah = parcelRequire("hZvah");

var $b18a6 = parcelRequire("b18a6");

var $g4bYW = parcelRequire("g4bYW");
var $31ec950e1e07741e$var$_excluded = [
    "className",
    "icon",
    "spin",
    "rotate",
    "tabIndex",
    "onClick",
    "twoToneColor"
];
// Initial setting
// should move it to antd main repo?
(0, $b18a6.setTwoToneColor)("#1890ff");
var $31ec950e1e07741e$var$Icon = /*#__PURE__*/ $jbmdS.forwardRef(function(props, ref) {
    var className = props.className, icon = props.icon, spin = props.spin, rotate = props.rotate, tabIndex = props.tabIndex, onClick = props.onClick, twoToneColor = props.twoToneColor, restProps = (0, $ccQt4.default)(props, $31ec950e1e07741e$var$_excluded);
    var _React$useContext = $jbmdS.useContext((0, $k3Laf.default)), _React$useContext$pre = _React$useContext.prefixCls, prefixCls = _React$useContext$pre === void 0 ? "anticon" : _React$useContext$pre, rootClassName = _React$useContext.rootClassName;
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(rootClassName, prefixCls, (0, $8K2NM.default)((0, $8K2NM.default)({}, "".concat(prefixCls, "-").concat(icon.name), !!icon.name), "".concat(prefixCls, "-spin"), !!spin || icon.name === "loading"), className);
    var iconTabIndex = tabIndex;
    if (iconTabIndex === undefined && onClick) iconTabIndex = -1;
    var svgStyle = rotate ? {
        msTransform: "rotate(".concat(rotate, "deg)"),
        transform: "rotate(".concat(rotate, "deg)")
    } : undefined;
    var _normalizeTwoToneColo = (0, $g4bYW.normalizeTwoToneColors)(twoToneColor), _normalizeTwoToneColo2 = (0, $CZyex.default)(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
    return /*#__PURE__*/ $jbmdS.createElement("span", (0, $lv6ip.default)((0, $lv6ip.default)({
        role: "img",
        "aria-label": icon.name
    }, restProps), {}, {
        ref: ref,
        tabIndex: iconTabIndex,
        onClick: onClick,
        className: classString
    }), /*#__PURE__*/ $jbmdS.createElement((0, $hZvah.default), {
        icon: icon,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        style: svgStyle
    }));
});
$31ec950e1e07741e$var$Icon.displayName = "AntdIcon";
$31ec950e1e07741e$var$Icon.getTwoToneColor = (0, $b18a6.getTwoToneColor);
$31ec950e1e07741e$var$Icon.setTwoToneColor = (0, $b18a6.setTwoToneColor);
var $31ec950e1e07741e$export$2e2bcd8739ae039 = $31ec950e1e07741e$var$Icon;

});
parcelRegister("ccQt4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e2f4e0bf23dfe78$export$2e2bcd8739ae039; });

var $etz1B = parcelRequire("etz1B");
function $8e2f4e0bf23dfe78$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $etz1B.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("etz1B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a89ef1520d92bd86$export$2e2bcd8739ae039; });
function $a89ef1520d92bd86$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("hZvah", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1904edad59c4b3b$export$2e2bcd8739ae039; });

var $ccQt4 = parcelRequire("ccQt4");

var $lv6ip = parcelRequire("lv6ip");

var $g4bYW = parcelRequire("g4bYW");
var $d1904edad59c4b3b$var$_excluded = [
    "icon",
    "className",
    "onClick",
    "style",
    "primaryColor",
    "secondaryColor"
];
var $d1904edad59c4b3b$var$twoToneColorPalette = {
    primaryColor: "#333",
    secondaryColor: "#E6E6E6",
    calculated: false
};
function $d1904edad59c4b3b$var$setTwoToneColors(_ref) {
    var primaryColor = _ref.primaryColor, secondaryColor = _ref.secondaryColor;
    $d1904edad59c4b3b$var$twoToneColorPalette.primaryColor = primaryColor;
    $d1904edad59c4b3b$var$twoToneColorPalette.secondaryColor = secondaryColor || (0, $g4bYW.getSecondaryColor)(primaryColor);
    $d1904edad59c4b3b$var$twoToneColorPalette.calculated = !!secondaryColor;
}
function $d1904edad59c4b3b$var$getTwoToneColors() {
    return (0, $lv6ip.default)({}, $d1904edad59c4b3b$var$twoToneColorPalette);
}
var $d1904edad59c4b3b$var$IconBase = function IconBase(props) {
    var icon = props.icon, className = props.className, onClick = props.onClick, style = props.style, primaryColor = props.primaryColor, secondaryColor = props.secondaryColor, restProps = (0, $ccQt4.default)(props, $d1904edad59c4b3b$var$_excluded);
    var colors = $d1904edad59c4b3b$var$twoToneColorPalette;
    if (primaryColor) colors = {
        primaryColor: primaryColor,
        secondaryColor: secondaryColor || (0, $g4bYW.getSecondaryColor)(primaryColor)
    };
    (0, $g4bYW.useInsertStyles)();
    (0, $g4bYW.warning)((0, $g4bYW.isIconDefinition)(icon), "icon should be icon definiton, but got ".concat(icon));
    if (!(0, $g4bYW.isIconDefinition)(icon)) return null;
    var target = icon;
    if (target && typeof target.icon === "function") target = (0, $lv6ip.default)((0, $lv6ip.default)({}, target), {}, {
        icon: target.icon(colors.primaryColor, colors.secondaryColor)
    });
    return (0, $g4bYW.generate)(target.icon, "svg-".concat(target.name), (0, $lv6ip.default)({
        className: className,
        onClick: onClick,
        style: style,
        "data-icon": target.name,
        width: "1em",
        height: "1em",
        fill: "currentColor",
        "aria-hidden": "true"
    }, restProps));
};
$d1904edad59c4b3b$var$IconBase.displayName = "IconReact";
$d1904edad59c4b3b$var$IconBase.getTwoToneColors = $d1904edad59c4b3b$var$getTwoToneColors;
$d1904edad59c4b3b$var$IconBase.setTwoToneColors = $d1904edad59c4b3b$var$setTwoToneColors;
var $d1904edad59c4b3b$export$2e2bcd8739ae039 = $d1904edad59c4b3b$var$IconBase;

});
parcelRegister("g4bYW", function(module, exports) {

$parcel$export(module.exports, "warning", function () { return $bb26507162bf1b72$export$491112666e282270; });
$parcel$export(module.exports, "isIconDefinition", function () { return $bb26507162bf1b72$export$ab652842c37578f4; });
$parcel$export(module.exports, "generate", function () { return $bb26507162bf1b72$export$80d376111cc09ad7; });
$parcel$export(module.exports, "getSecondaryColor", function () { return $bb26507162bf1b72$export$b71c93f469694483; });
$parcel$export(module.exports, "normalizeTwoToneColors", function () { return $bb26507162bf1b72$export$b5b464c3d8433a9b; });
$parcel$export(module.exports, "useInsertStyles", function () { return $bb26507162bf1b72$export$938b1f86b61613d0; });

var $lv6ip = parcelRequire("lv6ip");

var $jncUt = parcelRequire("jncUt");

var $jROxP = parcelRequire("jROxP");

var $jbmdS = parcelRequire("jbmdS");

var $8tMCd = parcelRequire("8tMCd");

var $kNt4K = parcelRequire("kNt4K");

var $k3Laf = parcelRequire("k3Laf");

var $jm4N7 = parcelRequire("jm4N7");
function $bb26507162bf1b72$export$491112666e282270(valid, message) {
    (0, $8tMCd.default)(valid, "[@ant-design/icons] ".concat(message));
}
function $bb26507162bf1b72$export$ab652842c37578f4(target) {
    return (0, $jncUt.default)(target) === "object" && typeof target.name === "string" && typeof target.theme === "string" && ((0, $jncUt.default)(target.icon) === "object" || typeof target.icon === "function");
}
function $bb26507162bf1b72$export$9f5073e7201cc21c() {
    var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return Object.keys(attrs).reduce(function(acc, key) {
        var val = attrs[key];
        switch(key){
            case "class":
                acc.className = val;
                delete acc.class;
                break;
            default:
                delete acc[key];
                acc[(0, (/*@__PURE__*/$parcel$interopDefault($jm4N7)))(key)] = val;
        }
        return acc;
    }, {});
}
function $bb26507162bf1b72$export$80d376111cc09ad7(node, key, rootProps) {
    if (!rootProps) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement(node.tag, (0, $lv6ip.default)({
        key: key
    }, $bb26507162bf1b72$export$9f5073e7201cc21c(node.attrs)), (node.children || []).map(function(child, index) {
        return $bb26507162bf1b72$export$80d376111cc09ad7(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement(node.tag, (0, $lv6ip.default)((0, $lv6ip.default)({
        key: key
    }, $bb26507162bf1b72$export$9f5073e7201cc21c(node.attrs)), rootProps), (node.children || []).map(function(child, index) {
        return $bb26507162bf1b72$export$80d376111cc09ad7(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
    }));
}
function $bb26507162bf1b72$export$b71c93f469694483(primaryColor) {
    // choose the second color
    return (0, $jROxP.generate)(primaryColor)[0];
}
function $bb26507162bf1b72$export$b5b464c3d8433a9b(twoToneColor) {
    if (!twoToneColor) return [];
    return Array.isArray(twoToneColor) ? twoToneColor : [
        twoToneColor
    ];
}
var $bb26507162bf1b72$export$960a899a9cccb2d5 = {
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    focusable: "false"
};
var $bb26507162bf1b72$export$2c99b98b77550cb4 = "\n.anticon {\n  display: inline-flex;\n  alignItems: center;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.anticon > * {\n  line-height: 1;\n}\n\n.anticon svg {\n  display: inline-block;\n}\n\n.anticon::before {\n  display: none;\n}\n\n.anticon .anticon-icon {\n  display: block;\n}\n\n.anticon[tabindex] {\n  cursor: pointer;\n}\n\n.anticon-spin::before,\n.anticon-spin {\n  display: inline-block;\n  -webkit-animation: loadingCircle 1s infinite linear;\n  animation: loadingCircle 1s infinite linear;\n}\n\n@-webkit-keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n";
var $bb26507162bf1b72$export$938b1f86b61613d0 = function useInsertStyles() {
    var styleStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $bb26507162bf1b72$export$2c99b98b77550cb4;
    var _useContext = (0, $jbmdS.useContext)((0, $k3Laf.default)), csp = _useContext.csp;
    (0, $jbmdS.useEffect)(function() {
        (0, $kNt4K.updateCSS)(styleStr, "@ant-design-icons", {
            prepend: true,
            csp: csp
        });
    }, []);
};

});
parcelRegister("jROxP", function(module, exports) {

$parcel$export(module.exports, "generate", function () { return $e76a2cae0d7c06be$export$80d376111cc09ad7; });

var $2SfD2 = parcelRequire("2SfD2");
var $grUmi = parcelRequire("grUmi");
var $e76a2cae0d7c06be$var$hueStep = 2; // 色相阶梯
var $e76a2cae0d7c06be$var$saturationStep = 0.16; // 饱和度阶梯，浅色部分
var $e76a2cae0d7c06be$var$saturationStep2 = 0.05; // 饱和度阶梯，深色部分
var $e76a2cae0d7c06be$var$brightnessStep1 = 0.05; // 亮度阶梯，浅色部分
var $e76a2cae0d7c06be$var$brightnessStep2 = 0.15; // 亮度阶梯，深色部分
var $e76a2cae0d7c06be$var$lightColorCount = 5; // 浅色数量，主色上
var $e76a2cae0d7c06be$var$darkColorCount = 4; // 深色数量，主色下
// 暗色主题颜色映射关系表
var $e76a2cae0d7c06be$var$darkColorMap = [
    {
        index: 7,
        opacity: 0.15
    },
    {
        index: 6,
        opacity: 0.25
    },
    {
        index: 5,
        opacity: 0.3
    },
    {
        index: 5,
        opacity: 0.45
    },
    {
        index: 5,
        opacity: 0.65
    },
    {
        index: 5,
        opacity: 0.85
    },
    {
        index: 4,
        opacity: 0.9
    },
    {
        index: 3,
        opacity: 0.95
    },
    {
        index: 2,
        opacity: 0.97
    },
    {
        index: 1,
        opacity: 0.98
    }
]; // Wrapper function ported from TinyColor.prototype.toHsv
// Keep it here because of `hsv.h * 360`
function $e76a2cae0d7c06be$var$toHsv(_ref) {
    var r = _ref.r, g = _ref.g, b = _ref.b;
    var hsv = (0, $grUmi.rgbToHsv)(r, g, b);
    return {
        h: hsv.h * 360,
        s: hsv.s,
        v: hsv.v
    };
} // Wrapper function ported from TinyColor.prototype.toHexString
// Keep it here because of the prefix `#`
function $e76a2cae0d7c06be$var$toHex(_ref2) {
    var r = _ref2.r, g = _ref2.g, b = _ref2.b;
    return "#".concat((0, $grUmi.rgbToHex)(r, g, b, false));
} // Wrapper function ported from TinyColor.prototype.mix, not treeshakable.
// Amount in range [0, 1]
// Assume color1 & color2 has no alpha, since the following src code did so.
function $e76a2cae0d7c06be$var$mix(rgb1, rgb2, amount) {
    var p = amount / 100;
    var rgb = {
        r: (rgb2.r - rgb1.r) * p + rgb1.r,
        g: (rgb2.g - rgb1.g) * p + rgb1.g,
        b: (rgb2.b - rgb1.b) * p + rgb1.b
    };
    return rgb;
}
function $e76a2cae0d7c06be$var$getHue(hsv, i, light) {
    var hue; // 根据色相不同，色相转向不同
    if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) hue = light ? Math.round(hsv.h) - $e76a2cae0d7c06be$var$hueStep * i : Math.round(hsv.h) + $e76a2cae0d7c06be$var$hueStep * i;
    else hue = light ? Math.round(hsv.h) + $e76a2cae0d7c06be$var$hueStep * i : Math.round(hsv.h) - $e76a2cae0d7c06be$var$hueStep * i;
    if (hue < 0) hue += 360;
    else if (hue >= 360) hue -= 360;
    return hue;
}
function $e76a2cae0d7c06be$var$getSaturation(hsv, i, light) {
    // grey color don't change saturation
    if (hsv.h === 0 && hsv.s === 0) return hsv.s;
    var saturation;
    if (light) saturation = hsv.s - $e76a2cae0d7c06be$var$saturationStep * i;
    else if (i === $e76a2cae0d7c06be$var$darkColorCount) saturation = hsv.s + $e76a2cae0d7c06be$var$saturationStep;
    else saturation = hsv.s + $e76a2cae0d7c06be$var$saturationStep2 * i;
     // 边界值修正
    if (saturation > 1) saturation = 1;
     // 第一格的 s 限制在 0.06-0.1 之间
    if (light && i === $e76a2cae0d7c06be$var$lightColorCount && saturation > 0.1) saturation = 0.1;
    if (saturation < 0.06) saturation = 0.06;
    return Number(saturation.toFixed(2));
}
function $e76a2cae0d7c06be$var$getValue(hsv, i, light) {
    var value;
    if (light) value = hsv.v + $e76a2cae0d7c06be$var$brightnessStep1 * i;
    else value = hsv.v - $e76a2cae0d7c06be$var$brightnessStep2 * i;
    if (value > 1) value = 1;
    return Number(value.toFixed(2));
}
function $e76a2cae0d7c06be$export$80d376111cc09ad7(color) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var patterns = [];
    var pColor = (0, $2SfD2.inputToRGB)(color);
    for(var i = $e76a2cae0d7c06be$var$lightColorCount; i > 0; i -= 1){
        var hsv = $e76a2cae0d7c06be$var$toHsv(pColor);
        var colorString = $e76a2cae0d7c06be$var$toHex((0, $2SfD2.inputToRGB)({
            h: $e76a2cae0d7c06be$var$getHue(hsv, i, true),
            s: $e76a2cae0d7c06be$var$getSaturation(hsv, i, true),
            v: $e76a2cae0d7c06be$var$getValue(hsv, i, true)
        }));
        patterns.push(colorString);
    }
    patterns.push($e76a2cae0d7c06be$var$toHex(pColor));
    for(var _i = 1; _i <= $e76a2cae0d7c06be$var$darkColorCount; _i += 1){
        var _hsv = $e76a2cae0d7c06be$var$toHsv(pColor);
        var _colorString = $e76a2cae0d7c06be$var$toHex((0, $2SfD2.inputToRGB)({
            h: $e76a2cae0d7c06be$var$getHue(_hsv, _i),
            s: $e76a2cae0d7c06be$var$getSaturation(_hsv, _i),
            v: $e76a2cae0d7c06be$var$getValue(_hsv, _i)
        }));
        patterns.push(_colorString);
    } // dark theme patterns
    if (opts.theme === "dark") return $e76a2cae0d7c06be$var$darkColorMap.map(function(_ref3) {
        var index = _ref3.index, opacity = _ref3.opacity;
        var darkColorString = $e76a2cae0d7c06be$var$toHex($e76a2cae0d7c06be$var$mix((0, $2SfD2.inputToRGB)(opts.backgroundColor || "#141414"), (0, $2SfD2.inputToRGB)(patterns[index]), opacity * 100));
        return darkColorString;
    });
    return patterns;
}
var $e76a2cae0d7c06be$export$3968a3afc810b5f5 = {
    red: "#F5222D",
    volcano: "#FA541C",
    orange: "#FA8C16",
    gold: "#FAAD14",
    yellow: "#FADB14",
    lime: "#A0D911",
    green: "#52C41A",
    cyan: "#13C2C2",
    blue: "#1890FF",
    geekblue: "#2F54EB",
    purple: "#722ED1",
    magenta: "#EB2F96",
    grey: "#666666"
};
var $e76a2cae0d7c06be$export$36ad6df0f83f284d = {};
var $e76a2cae0d7c06be$export$24617255e4daf647 = {};
Object.keys($e76a2cae0d7c06be$export$3968a3afc810b5f5).forEach(function(key) {
    $e76a2cae0d7c06be$export$36ad6df0f83f284d[key] = $e76a2cae0d7c06be$export$80d376111cc09ad7($e76a2cae0d7c06be$export$3968a3afc810b5f5[key]);
    $e76a2cae0d7c06be$export$36ad6df0f83f284d[key].primary = $e76a2cae0d7c06be$export$36ad6df0f83f284d[key][5]; // dark presetPalettes
    $e76a2cae0d7c06be$export$24617255e4daf647[key] = $e76a2cae0d7c06be$export$80d376111cc09ad7($e76a2cae0d7c06be$export$3968a3afc810b5f5[key], {
        theme: "dark",
        backgroundColor: "#141414"
    });
    $e76a2cae0d7c06be$export$24617255e4daf647[key].primary = $e76a2cae0d7c06be$export$24617255e4daf647[key][5];
});
var $e76a2cae0d7c06be$export$a90204d1394caf30 = $e76a2cae0d7c06be$export$36ad6df0f83f284d.red;
var $e76a2cae0d7c06be$export$e63a1643b2f79b16 = $e76a2cae0d7c06be$export$36ad6df0f83f284d.volcano;
var $e76a2cae0d7c06be$export$c24201f7fe3571d8 = $e76a2cae0d7c06be$export$36ad6df0f83f284d.gold;
var $e76a2cae0d7c06be$export$ad766f34ace1cafd = $e76a2cae0d7c06be$export$36ad6df0f83f284d.orange;
var $e76a2cae0d7c06be$export$594c5a8758200c32 = $e76a2cae0d7c06be$export$36ad6df0f83f284d.yellow;
var $e76a2cae0d7c06be$export$221d31baf2636aad = $e76a2cae0d7c06be$export$36ad6df0f83f284d.lime;
var $e76a2cae0d7c06be$export$955a2ebd2fb142ae = $e76a2cae0d7c06be$export$36ad6df0f83f284d.green;
var $e76a2cae0d7c06be$export$7474046f446842ee = $e76a2cae0d7c06be$export$36ad6df0f83f284d.cyan;
var $e76a2cae0d7c06be$export$2aa0182783e7e9de = $e76a2cae0d7c06be$export$36ad6df0f83f284d.blue;
var $e76a2cae0d7c06be$export$4138d3aeddcbf415 = $e76a2cae0d7c06be$export$36ad6df0f83f284d.geekblue;
var $e76a2cae0d7c06be$export$e13cce2a2d16a9d4 = $e76a2cae0d7c06be$export$36ad6df0f83f284d.purple;
var $e76a2cae0d7c06be$export$2a9ca2e383622e18 = $e76a2cae0d7c06be$export$36ad6df0f83f284d.magenta;
var $e76a2cae0d7c06be$export$e4c89085febbc618 = $e76a2cae0d7c06be$export$36ad6df0f83f284d.grey;

});
parcelRegister("2SfD2", function(module, exports) {

$parcel$export(module.exports, "inputToRGB", function () { return $217cbf74c8103268$export$87de337d8199f22c; });
/* eslint-disable @typescript-eslint/no-redundant-type-constituents */ 
var $grUmi = parcelRequire("grUmi");

var $purGc = parcelRequire("purGc");

var $3j2oj = parcelRequire("3j2oj");
function $217cbf74c8103268$export$87de337d8199f22c(color) {
    var rgb = {
        r: 0,
        g: 0,
        b: 0
    };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;
    if (typeof color === "string") color = $217cbf74c8103268$export$56237d872eed15a0(color);
    if (typeof color === "object") {
        if ($217cbf74c8103268$export$80d4d71a83d4526d(color.r) && $217cbf74c8103268$export$80d4d71a83d4526d(color.g) && $217cbf74c8103268$export$80d4d71a83d4526d(color.b)) {
            rgb = (0, $grUmi.rgbToRgb)(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        } else if ($217cbf74c8103268$export$80d4d71a83d4526d(color.h) && $217cbf74c8103268$export$80d4d71a83d4526d(color.s) && $217cbf74c8103268$export$80d4d71a83d4526d(color.v)) {
            s = (0, $3j2oj.convertToPercentage)(color.s);
            v = (0, $3j2oj.convertToPercentage)(color.v);
            rgb = (0, $grUmi.hsvToRgb)(color.h, s, v);
            ok = true;
            format = "hsv";
        } else if ($217cbf74c8103268$export$80d4d71a83d4526d(color.h) && $217cbf74c8103268$export$80d4d71a83d4526d(color.s) && $217cbf74c8103268$export$80d4d71a83d4526d(color.l)) {
            s = (0, $3j2oj.convertToPercentage)(color.s);
            l = (0, $3j2oj.convertToPercentage)(color.l);
            rgb = (0, $grUmi.hslToRgb)(color.h, s, l);
            ok = true;
            format = "hsl";
        }
        if (Object.prototype.hasOwnProperty.call(color, "a")) a = color.a;
    }
    a = (0, $3j2oj.boundAlpha)(a);
    return {
        ok: ok,
        format: color.format || format,
        r: Math.min(255, Math.max(rgb.r, 0)),
        g: Math.min(255, Math.max(rgb.g, 0)),
        b: Math.min(255, Math.max(rgb.b, 0)),
        a: a
    };
}
// <http://www.w3.org/TR/css3-values/#integers>
var $217cbf74c8103268$var$CSS_INTEGER = "[-\\+]?\\d+%?";
// <http://www.w3.org/TR/css3-values/#number-value>
var $217cbf74c8103268$var$CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
// Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
var $217cbf74c8103268$var$CSS_UNIT = "(?:".concat($217cbf74c8103268$var$CSS_NUMBER, ")|(?:").concat($217cbf74c8103268$var$CSS_INTEGER, ")");
// Actual matching.
// Parentheses and commas are optional, but not required.
// Whitespace can take the place of commas or opening paren
var $217cbf74c8103268$var$PERMISSIVE_MATCH3 = "[\\s|\\(]+(".concat($217cbf74c8103268$var$CSS_UNIT, ")[,|\\s]+(").concat($217cbf74c8103268$var$CSS_UNIT, ")[,|\\s]+(").concat($217cbf74c8103268$var$CSS_UNIT, ")\\s*\\)?");
var $217cbf74c8103268$var$PERMISSIVE_MATCH4 = "[\\s|\\(]+(".concat($217cbf74c8103268$var$CSS_UNIT, ")[,|\\s]+(").concat($217cbf74c8103268$var$CSS_UNIT, ")[,|\\s]+(").concat($217cbf74c8103268$var$CSS_UNIT, ")[,|\\s]+(").concat($217cbf74c8103268$var$CSS_UNIT, ")\\s*\\)?");
var $217cbf74c8103268$var$matchers = {
    CSS_UNIT: new RegExp($217cbf74c8103268$var$CSS_UNIT),
    rgb: new RegExp("rgb" + $217cbf74c8103268$var$PERMISSIVE_MATCH3),
    rgba: new RegExp("rgba" + $217cbf74c8103268$var$PERMISSIVE_MATCH4),
    hsl: new RegExp("hsl" + $217cbf74c8103268$var$PERMISSIVE_MATCH3),
    hsla: new RegExp("hsla" + $217cbf74c8103268$var$PERMISSIVE_MATCH4),
    hsv: new RegExp("hsv" + $217cbf74c8103268$var$PERMISSIVE_MATCH3),
    hsva: new RegExp("hsva" + $217cbf74c8103268$var$PERMISSIVE_MATCH4),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function $217cbf74c8103268$export$56237d872eed15a0(color) {
    color = color.trim().toLowerCase();
    if (color.length === 0) return false;
    var named = false;
    if ((0, $purGc.names)[color]) {
        color = (0, $purGc.names)[color];
        named = true;
    } else if (color === "transparent") return {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
        format: "name"
    };
    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match = $217cbf74c8103268$var$matchers.rgb.exec(color);
    if (match) return {
        r: match[1],
        g: match[2],
        b: match[3]
    };
    match = $217cbf74c8103268$var$matchers.rgba.exec(color);
    if (match) return {
        r: match[1],
        g: match[2],
        b: match[3],
        a: match[4]
    };
    match = $217cbf74c8103268$var$matchers.hsl.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        l: match[3]
    };
    match = $217cbf74c8103268$var$matchers.hsla.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        l: match[3],
        a: match[4]
    };
    match = $217cbf74c8103268$var$matchers.hsv.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        v: match[3]
    };
    match = $217cbf74c8103268$var$matchers.hsva.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        v: match[3],
        a: match[4]
    };
    match = $217cbf74c8103268$var$matchers.hex8.exec(color);
    if (match) return {
        r: (0, $grUmi.parseIntFromHex)(match[1]),
        g: (0, $grUmi.parseIntFromHex)(match[2]),
        b: (0, $grUmi.parseIntFromHex)(match[3]),
        a: (0, $grUmi.convertHexToDecimal)(match[4]),
        format: named ? "name" : "hex8"
    };
    match = $217cbf74c8103268$var$matchers.hex6.exec(color);
    if (match) return {
        r: (0, $grUmi.parseIntFromHex)(match[1]),
        g: (0, $grUmi.parseIntFromHex)(match[2]),
        b: (0, $grUmi.parseIntFromHex)(match[3]),
        format: named ? "name" : "hex"
    };
    match = $217cbf74c8103268$var$matchers.hex4.exec(color);
    if (match) return {
        r: (0, $grUmi.parseIntFromHex)(match[1] + match[1]),
        g: (0, $grUmi.parseIntFromHex)(match[2] + match[2]),
        b: (0, $grUmi.parseIntFromHex)(match[3] + match[3]),
        a: (0, $grUmi.convertHexToDecimal)(match[4] + match[4]),
        format: named ? "name" : "hex8"
    };
    match = $217cbf74c8103268$var$matchers.hex3.exec(color);
    if (match) return {
        r: (0, $grUmi.parseIntFromHex)(match[1] + match[1]),
        g: (0, $grUmi.parseIntFromHex)(match[2] + match[2]),
        b: (0, $grUmi.parseIntFromHex)(match[3] + match[3]),
        format: named ? "name" : "hex"
    };
    return false;
}
function $217cbf74c8103268$export$80d4d71a83d4526d(color) {
    return Boolean($217cbf74c8103268$var$matchers.CSS_UNIT.exec(String(color)));
}

});
parcelRegister("grUmi", function(module, exports) {

$parcel$export(module.exports, "rgbToRgb", function () { return $bf9ae295cdbab34e$export$1a0d7f039f803cb; });
$parcel$export(module.exports, "rgbToHsl", function () { return $bf9ae295cdbab34e$export$c85ca4f4753af384; });
$parcel$export(module.exports, "hslToRgb", function () { return $bf9ae295cdbab34e$export$29fb7152bd3f781a; });
$parcel$export(module.exports, "rgbToHsv", function () { return $bf9ae295cdbab34e$export$f76e85ca00a47f5c; });
$parcel$export(module.exports, "hsvToRgb", function () { return $bf9ae295cdbab34e$export$210753cfeec758a5; });
$parcel$export(module.exports, "rgbToHex", function () { return $bf9ae295cdbab34e$export$34d09c4a771c46ef; });
$parcel$export(module.exports, "rgbaToHex", function () { return $bf9ae295cdbab34e$export$ffee5509a14af63d; });
$parcel$export(module.exports, "convertHexToDecimal", function () { return $bf9ae295cdbab34e$export$616da979ad1c2414; });
$parcel$export(module.exports, "parseIntFromHex", function () { return $bf9ae295cdbab34e$export$262b3ba788b4d07c; });
$parcel$export(module.exports, "numberInputToObject", function () { return $bf9ae295cdbab34e$export$4076ec82b665900d; });

var $3j2oj = parcelRequire("3j2oj");
function $bf9ae295cdbab34e$export$1a0d7f039f803cb(r, g, b) {
    return {
        r: (0, $3j2oj.bound01)(r, 255) * 255,
        g: (0, $3j2oj.bound01)(g, 255) * 255,
        b: (0, $3j2oj.bound01)(b, 255) * 255
    };
}
function $bf9ae295cdbab34e$export$c85ca4f4753af384(r, g, b) {
    r = (0, $3j2oj.bound01)(r, 255);
    g = (0, $3j2oj.bound01)(g, 255);
    b = (0, $3j2oj.bound01)(b, 255);
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h = 0;
    var s = 0;
    var l = (max + min) / 2;
    if (max === min) {
        s = 0;
        h = 0; // achromatic
    } else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
            default:
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        l: l
    };
}
function $bf9ae295cdbab34e$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * (6 * t);
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $bf9ae295cdbab34e$export$29fb7152bd3f781a(h, s, l) {
    var r;
    var g;
    var b;
    h = (0, $3j2oj.bound01)(h, 360);
    s = (0, $3j2oj.bound01)(s, 100);
    l = (0, $3j2oj.bound01)(l, 100);
    if (s === 0) {
        // achromatic
        g = l;
        b = l;
        r = l;
    } else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = $bf9ae295cdbab34e$var$hue2rgb(p, q, h + 1 / 3);
        g = $bf9ae295cdbab34e$var$hue2rgb(p, q, h);
        b = $bf9ae295cdbab34e$var$hue2rgb(p, q, h - 1 / 3);
    }
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
function $bf9ae295cdbab34e$export$f76e85ca00a47f5c(r, g, b) {
    r = (0, $3j2oj.bound01)(r, 255);
    g = (0, $3j2oj.bound01)(g, 255);
    b = (0, $3j2oj.bound01)(b, 255);
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h = 0;
    var v = max;
    var d = max - min;
    var s = max === 0 ? 0 : d / max;
    if (max === min) h = 0; // achromatic
    else {
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
            default:
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        v: v
    };
}
function $bf9ae295cdbab34e$export$210753cfeec758a5(h, s, v) {
    h = (0, $3j2oj.bound01)(h, 360) * 6;
    s = (0, $3j2oj.bound01)(s, 100);
    v = (0, $3j2oj.bound01)(v, 100);
    var i = Math.floor(h);
    var f = h - i;
    var p = v * (1 - s);
    var q = v * (1 - f * s);
    var t = v * (1 - (1 - f) * s);
    var mod = i % 6;
    var r = [
        v,
        q,
        p,
        p,
        t,
        v
    ][mod];
    var g = [
        t,
        v,
        v,
        q,
        p,
        p
    ][mod];
    var b = [
        p,
        p,
        t,
        v,
        v,
        q
    ][mod];
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
function $bf9ae295cdbab34e$export$34d09c4a771c46ef(r, g, b, allow3Char) {
    var hex = [
        (0, $3j2oj.pad2)(Math.round(r).toString(16)),
        (0, $3j2oj.pad2)(Math.round(g).toString(16)),
        (0, $3j2oj.pad2)(Math.round(b).toString(16))
    ];
    // Return a 3 character hex if possible
    if (allow3Char && hex[0].startsWith(hex[0].charAt(1)) && hex[1].startsWith(hex[1].charAt(1)) && hex[2].startsWith(hex[2].charAt(1))) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    return hex.join("");
}
function $bf9ae295cdbab34e$export$ffee5509a14af63d(r, g, b, a, allow4Char) {
    var hex = [
        (0, $3j2oj.pad2)(Math.round(r).toString(16)),
        (0, $3j2oj.pad2)(Math.round(g).toString(16)),
        (0, $3j2oj.pad2)(Math.round(b).toString(16)),
        (0, $3j2oj.pad2)($bf9ae295cdbab34e$export$51dcdea396f3aff6(a))
    ];
    // Return a 4 character hex if possible
    if (allow4Char && hex[0].startsWith(hex[0].charAt(1)) && hex[1].startsWith(hex[1].charAt(1)) && hex[2].startsWith(hex[2].charAt(1)) && hex[3].startsWith(hex[3].charAt(1))) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    return hex.join("");
}
function $bf9ae295cdbab34e$export$ce6645f7d73030f4(r, g, b, a) {
    var hex = [
        (0, $3j2oj.pad2)($bf9ae295cdbab34e$export$51dcdea396f3aff6(a)),
        (0, $3j2oj.pad2)(Math.round(r).toString(16)),
        (0, $3j2oj.pad2)(Math.round(g).toString(16)),
        (0, $3j2oj.pad2)(Math.round(b).toString(16))
    ];
    return hex.join("");
}
function $bf9ae295cdbab34e$export$51dcdea396f3aff6(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
function $bf9ae295cdbab34e$export$616da979ad1c2414(h) {
    return $bf9ae295cdbab34e$export$262b3ba788b4d07c(h) / 255;
}
function $bf9ae295cdbab34e$export$262b3ba788b4d07c(val) {
    return parseInt(val, 16);
}
function $bf9ae295cdbab34e$export$4076ec82b665900d(color) {
    return {
        r: color >> 16,
        g: (color & 0xff00) >> 8,
        b: color & 0xff
    };
}

});
parcelRegister("3j2oj", function(module, exports) {

$parcel$export(module.exports, "bound01", function () { return $26850048acb4f6fe$export$b0e60b43d1d059f0; });
$parcel$export(module.exports, "clamp01", function () { return $26850048acb4f6fe$export$5c5ee632c52bc4a2; });
$parcel$export(module.exports, "boundAlpha", function () { return $26850048acb4f6fe$export$3ae665204365318d; });
$parcel$export(module.exports, "convertToPercentage", function () { return $26850048acb4f6fe$export$8ba0754c08bd5ca8; });
$parcel$export(module.exports, "pad2", function () { return $26850048acb4f6fe$export$9decc9dc70e2c76f; });
/**
 * Take input from [0, n] and return it as [0, 1]
 * @hidden
 */ function $26850048acb4f6fe$export$b0e60b43d1d059f0(n, max) {
    if ($26850048acb4f6fe$export$7bf7d6849640691b(n)) n = "100%";
    var isPercent = $26850048acb4f6fe$export$d86432a85610ea90(n);
    n = max === 360 ? n : Math.min(max, Math.max(0, parseFloat(n)));
    // Automatically convert percentage into number
    if (isPercent) n = parseInt(String(n * max), 10) / 100;
    // Handle floating point rounding errors
    if (Math.abs(n - max) < 0.000001) return 1;
    // Convert into [0, 1] range if it isn't already
    if (max === 360) // If n is a hue given in degrees,
    // wrap around out-of-range values into [0, 360] range
    // then convert into [0, 1].
    n = (n < 0 ? n % max + max : n % max) / parseFloat(String(max));
    else // If n not a hue given in degrees
    // Convert into [0, 1] range if it isn't already.
    n = n % max / parseFloat(String(max));
    return n;
}
function $26850048acb4f6fe$export$5c5ee632c52bc4a2(val) {
    return Math.min(1, Math.max(0, val));
}
function $26850048acb4f6fe$export$7bf7d6849640691b(n) {
    return typeof n === "string" && n.indexOf(".") !== -1 && parseFloat(n) === 1;
}
function $26850048acb4f6fe$export$d86432a85610ea90(n) {
    return typeof n === "string" && n.indexOf("%") !== -1;
}
function $26850048acb4f6fe$export$3ae665204365318d(a) {
    a = parseFloat(a);
    if (isNaN(a) || a < 0 || a > 1) a = 1;
    return a;
}
function $26850048acb4f6fe$export$8ba0754c08bd5ca8(n) {
    if (n <= 1) return "".concat(Number(n) * 100, "%");
    return n;
}
function $26850048acb4f6fe$export$9decc9dc70e2c76f(c) {
    return c.length === 1 ? "0" + c : String(c);
}

});


parcelRegister("purGc", function(module, exports) {

$parcel$export(module.exports, "names", function () { return $04c9f3bed9f458d1$export$e4b2ac9215619f8d; });
// https://github.com/bahamas10/css-color-names/blob/master/css-color-names.json
/**
 * @hidden
 */ var $04c9f3bed9f458d1$export$e4b2ac9215619f8d = {
    aliceblue: "#f0f8ff",
    antiquewhite: "#faebd7",
    aqua: "#00ffff",
    aquamarine: "#7fffd4",
    azure: "#f0ffff",
    beige: "#f5f5dc",
    bisque: "#ffe4c4",
    black: "#000000",
    blanchedalmond: "#ffebcd",
    blue: "#0000ff",
    blueviolet: "#8a2be2",
    brown: "#a52a2a",
    burlywood: "#deb887",
    cadetblue: "#5f9ea0",
    chartreuse: "#7fff00",
    chocolate: "#d2691e",
    coral: "#ff7f50",
    cornflowerblue: "#6495ed",
    cornsilk: "#fff8dc",
    crimson: "#dc143c",
    cyan: "#00ffff",
    darkblue: "#00008b",
    darkcyan: "#008b8b",
    darkgoldenrod: "#b8860b",
    darkgray: "#a9a9a9",
    darkgreen: "#006400",
    darkgrey: "#a9a9a9",
    darkkhaki: "#bdb76b",
    darkmagenta: "#8b008b",
    darkolivegreen: "#556b2f",
    darkorange: "#ff8c00",
    darkorchid: "#9932cc",
    darkred: "#8b0000",
    darksalmon: "#e9967a",
    darkseagreen: "#8fbc8f",
    darkslateblue: "#483d8b",
    darkslategray: "#2f4f4f",
    darkslategrey: "#2f4f4f",
    darkturquoise: "#00ced1",
    darkviolet: "#9400d3",
    deeppink: "#ff1493",
    deepskyblue: "#00bfff",
    dimgray: "#696969",
    dimgrey: "#696969",
    dodgerblue: "#1e90ff",
    firebrick: "#b22222",
    floralwhite: "#fffaf0",
    forestgreen: "#228b22",
    fuchsia: "#ff00ff",
    gainsboro: "#dcdcdc",
    ghostwhite: "#f8f8ff",
    goldenrod: "#daa520",
    gold: "#ffd700",
    gray: "#808080",
    green: "#008000",
    greenyellow: "#adff2f",
    grey: "#808080",
    honeydew: "#f0fff0",
    hotpink: "#ff69b4",
    indianred: "#cd5c5c",
    indigo: "#4b0082",
    ivory: "#fffff0",
    khaki: "#f0e68c",
    lavenderblush: "#fff0f5",
    lavender: "#e6e6fa",
    lawngreen: "#7cfc00",
    lemonchiffon: "#fffacd",
    lightblue: "#add8e6",
    lightcoral: "#f08080",
    lightcyan: "#e0ffff",
    lightgoldenrodyellow: "#fafad2",
    lightgray: "#d3d3d3",
    lightgreen: "#90ee90",
    lightgrey: "#d3d3d3",
    lightpink: "#ffb6c1",
    lightsalmon: "#ffa07a",
    lightseagreen: "#20b2aa",
    lightskyblue: "#87cefa",
    lightslategray: "#778899",
    lightslategrey: "#778899",
    lightsteelblue: "#b0c4de",
    lightyellow: "#ffffe0",
    lime: "#00ff00",
    limegreen: "#32cd32",
    linen: "#faf0e6",
    magenta: "#ff00ff",
    maroon: "#800000",
    mediumaquamarine: "#66cdaa",
    mediumblue: "#0000cd",
    mediumorchid: "#ba55d3",
    mediumpurple: "#9370db",
    mediumseagreen: "#3cb371",
    mediumslateblue: "#7b68ee",
    mediumspringgreen: "#00fa9a",
    mediumturquoise: "#48d1cc",
    mediumvioletred: "#c71585",
    midnightblue: "#191970",
    mintcream: "#f5fffa",
    mistyrose: "#ffe4e1",
    moccasin: "#ffe4b5",
    navajowhite: "#ffdead",
    navy: "#000080",
    oldlace: "#fdf5e6",
    olive: "#808000",
    olivedrab: "#6b8e23",
    orange: "#ffa500",
    orangered: "#ff4500",
    orchid: "#da70d6",
    palegoldenrod: "#eee8aa",
    palegreen: "#98fb98",
    paleturquoise: "#afeeee",
    palevioletred: "#db7093",
    papayawhip: "#ffefd5",
    peachpuff: "#ffdab9",
    peru: "#cd853f",
    pink: "#ffc0cb",
    plum: "#dda0dd",
    powderblue: "#b0e0e6",
    purple: "#800080",
    rebeccapurple: "#663399",
    red: "#ff0000",
    rosybrown: "#bc8f8f",
    royalblue: "#4169e1",
    saddlebrown: "#8b4513",
    salmon: "#fa8072",
    sandybrown: "#f4a460",
    seagreen: "#2e8b57",
    seashell: "#fff5ee",
    sienna: "#a0522d",
    silver: "#c0c0c0",
    skyblue: "#87ceeb",
    slateblue: "#6a5acd",
    slategray: "#708090",
    slategrey: "#708090",
    snow: "#fffafa",
    springgreen: "#00ff7f",
    steelblue: "#4682b4",
    tan: "#d2b48c",
    teal: "#008080",
    thistle: "#d8bfd8",
    tomato: "#ff6347",
    turquoise: "#40e0d0",
    violet: "#ee82ee",
    wheat: "#f5deb3",
    white: "#ffffff",
    whitesmoke: "#f5f5f5",
    yellow: "#ffff00",
    yellowgreen: "#9acd32"
};

});



parcelRegister("8tMCd", function(module, exports) {

$parcel$export(module.exports, "warning", function () { return $62c6be2b10c4b155$export$491112666e282270; });
$parcel$export(module.exports, "noteOnce", function () { return $62c6be2b10c4b155$export$89ff31684837bbbf; });
$parcel$export(module.exports, "default", function () { return $62c6be2b10c4b155$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $62c6be2b10c4b155$var$warned = {};
var $62c6be2b10c4b155$var$preWarningFns = [];
var $62c6be2b10c4b155$export$61616f168f0e5a05 = function preMessage(fn) {
    $62c6be2b10c4b155$var$preWarningFns.push(fn);
};
function $62c6be2b10c4b155$export$491112666e282270(valid, message) {
    var finalMessage;
}
function $62c6be2b10c4b155$export$a92e4c44d367d0af(valid, message) {
    var finalMessage;
}
function $62c6be2b10c4b155$export$60eef1277fe463e4() {
    $62c6be2b10c4b155$var$warned = {};
}
function $62c6be2b10c4b155$export$848feb93d8f32b9b(method, valid, message) {
    if (!valid && !$62c6be2b10c4b155$var$warned[message]) {
        method(false, message);
        $62c6be2b10c4b155$var$warned[message] = true;
    }
}
function $62c6be2b10c4b155$export$82934adf09101657(valid, message) {
    $62c6be2b10c4b155$export$848feb93d8f32b9b($62c6be2b10c4b155$export$491112666e282270, valid, message);
}
function $62c6be2b10c4b155$export$89ff31684837bbbf(valid, message) {
    $62c6be2b10c4b155$export$848feb93d8f32b9b($62c6be2b10c4b155$export$a92e4c44d367d0af, valid, message);
}
$62c6be2b10c4b155$export$82934adf09101657.preMessage = $62c6be2b10c4b155$export$61616f168f0e5a05;
$62c6be2b10c4b155$export$82934adf09101657.resetWarned = $62c6be2b10c4b155$export$60eef1277fe463e4;
$62c6be2b10c4b155$export$82934adf09101657.noteOnce = $62c6be2b10c4b155$export$89ff31684837bbbf;
var $62c6be2b10c4b155$export$2e2bcd8739ae039 = $62c6be2b10c4b155$export$82934adf09101657;

});

parcelRegister("kNt4K", function(module, exports) {

$parcel$export(module.exports, "updateCSS", function () { return $f23ef007bf1c5714$export$4d99a2890bb989f0; });

var $lv6ip = parcelRequire("lv6ip");

var $gnP4S = parcelRequire("gnP4S");

var $1sys4 = parcelRequire("1sys4");
var $f23ef007bf1c5714$var$APPEND_ORDER = "data-rc-order";
var $f23ef007bf1c5714$var$APPEND_PRIORITY = "data-rc-priority";
var $f23ef007bf1c5714$var$MARK_KEY = "rc-util-key";
var $f23ef007bf1c5714$var$containerCache = new Map();
function $f23ef007bf1c5714$var$getMark() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, mark = _ref.mark;
    if (mark) return mark.startsWith("data-") ? mark : "data-".concat(mark);
    return $f23ef007bf1c5714$var$MARK_KEY;
}
function $f23ef007bf1c5714$var$getContainer(option) {
    if (option.attachTo) return option.attachTo;
    var head = document.querySelector("head");
    return head || document.body;
}
function $f23ef007bf1c5714$var$getOrder(prepend) {
    if (prepend === "queue") return "prependQueue";
    return prepend ? "prepend" : "append";
}
/**
 * Find style which inject by rc-util
 */ function $f23ef007bf1c5714$var$findStyles(container) {
    return Array.from(($f23ef007bf1c5714$var$containerCache.get(container) || container).children).filter(function(node) {
        return node.tagName === "STYLE";
    });
}
function $f23ef007bf1c5714$export$1ab5838465dbd10a(css) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!(0, $gnP4S.default)()) return null;
    var csp = option.csp, prepend = option.prepend, _option$priority = option.priority, priority = _option$priority === void 0 ? 0 : _option$priority;
    var mergedOrder = $f23ef007bf1c5714$var$getOrder(prepend);
    var isPrependQueue = mergedOrder === "prependQueue";
    var styleNode = document.createElement("style");
    styleNode.setAttribute($f23ef007bf1c5714$var$APPEND_ORDER, mergedOrder);
    if (isPrependQueue && priority) styleNode.setAttribute($f23ef007bf1c5714$var$APPEND_PRIORITY, "".concat(priority));
    if (csp !== null && csp !== void 0 && csp.nonce) styleNode.nonce = csp === null || csp === void 0 ? void 0 : csp.nonce;
    styleNode.innerHTML = css;
    var container = $f23ef007bf1c5714$var$getContainer(option);
    var firstChild = container.firstChild;
    if (prepend) {
        // If is queue `prepend`, it will prepend first style and then append rest style
        if (isPrependQueue) {
            var existStyle = (option.styles || $f23ef007bf1c5714$var$findStyles(container)).filter(function(node) {
                // Ignore style which not injected by rc-util with prepend
                if (![
                    "prepend",
                    "prependQueue"
                ].includes(node.getAttribute($f23ef007bf1c5714$var$APPEND_ORDER))) return false;
                // Ignore style which priority less then new style
                var nodePriority = Number(node.getAttribute($f23ef007bf1c5714$var$APPEND_PRIORITY) || 0);
                return priority >= nodePriority;
            });
            if (existStyle.length) {
                container.insertBefore(styleNode, existStyle[existStyle.length - 1].nextSibling);
                return styleNode;
            }
        }
        // Use `insertBefore` as `prepend`
        container.insertBefore(styleNode, firstChild);
    } else container.appendChild(styleNode);
    return styleNode;
}
function $f23ef007bf1c5714$var$findExistNode(key) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var container = $f23ef007bf1c5714$var$getContainer(option);
    return (option.styles || $f23ef007bf1c5714$var$findStyles(container)).find(function(node) {
        return node.getAttribute($f23ef007bf1c5714$var$getMark(option)) === key;
    });
}
function $f23ef007bf1c5714$export$2232e336aecaa80a(key) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var existNode = $f23ef007bf1c5714$var$findExistNode(key, option);
    if (existNode) {
        var container = $f23ef007bf1c5714$var$getContainer(option);
        container.removeChild(existNode);
    }
}
/**
 * qiankun will inject `appendChild` to insert into other
 */ function $f23ef007bf1c5714$var$syncRealContainer(container, option) {
    var cachedRealContainer = $f23ef007bf1c5714$var$containerCache.get(container);
    // Find real container when not cached or cached container removed
    if (!cachedRealContainer || !(0, $1sys4.default)(document, cachedRealContainer)) {
        var placeholderStyle = $f23ef007bf1c5714$export$1ab5838465dbd10a("", option);
        var parentNode = placeholderStyle.parentNode;
        $f23ef007bf1c5714$var$containerCache.set(container, parentNode);
        container.removeChild(placeholderStyle);
    }
}
function $f23ef007bf1c5714$export$f80df667f2f5a272() {
    $f23ef007bf1c5714$var$containerCache.clear();
}
function $f23ef007bf1c5714$export$4d99a2890bb989f0(css, key) {
    var originOption = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var container = $f23ef007bf1c5714$var$getContainer(originOption);
    var styles = $f23ef007bf1c5714$var$findStyles(container);
    var option = (0, $lv6ip.default)((0, $lv6ip.default)({}, originOption), {}, {
        styles: styles
    });
    // Sync real parent
    $f23ef007bf1c5714$var$syncRealContainer(container, option);
    var existNode = $f23ef007bf1c5714$var$findExistNode(key, option);
    if (existNode) {
        var _option$csp, _option$csp2;
        if ((_option$csp = option.csp) !== null && _option$csp !== void 0 && _option$csp.nonce && existNode.nonce !== ((_option$csp2 = option.csp) === null || _option$csp2 === void 0 ? void 0 : _option$csp2.nonce)) {
            var _option$csp3;
            existNode.nonce = (_option$csp3 = option.csp) === null || _option$csp3 === void 0 ? void 0 : _option$csp3.nonce;
        }
        if (existNode.innerHTML !== css) existNode.innerHTML = css;
        return existNode;
    }
    var newNode = $f23ef007bf1c5714$export$1ab5838465dbd10a(css, option);
    newNode.setAttribute($f23ef007bf1c5714$var$getMark(option), key);
    return newNode;
}

});
parcelRegister("gnP4S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bed66a48ebbb07dc$export$2e2bcd8739ae039; });
function $bed66a48ebbb07dc$export$2e2bcd8739ae039() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}

});

parcelRegister("1sys4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11032161cbd9c9b7$export$2e2bcd8739ae039; });
function $11032161cbd9c9b7$export$2e2bcd8739ae039(root, n) {
    if (!root) return false;
    // Use native if support
    if (root.contains) return root.contains(n);
    // `document.contains` not support with IE11
    var node = n;
    while(node){
        if (node === root) return true;
        node = node.parentNode;
    }
    return false;
}

});


parcelRegister("jm4N7", function(module, exports) {

var $1zIVC = parcelRequire("1zIVC");

var $lP0S2 = parcelRequire("lP0S2");
/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $e173c9d005ee7fbe$var$camelCase = $lP0S2(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $1zIVC(word) : word);
});
module.exports = $e173c9d005ee7fbe$var$camelCase;

});
parcelRegister("1zIVC", function(module, exports) {

var $ebkZ0 = parcelRequire("ebkZ0");

var $lKqbf = parcelRequire("lKqbf");
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $125be928515df3a8$var$capitalize(string) {
    return $lKqbf($ebkZ0(string).toLowerCase());
}
module.exports = $125be928515df3a8$var$capitalize;

});
parcelRegister("ebkZ0", function(module, exports) {

var $byej1 = parcelRequire("byej1");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $a5325e8e980d1301$var$toString(value) {
    return value == null ? "" : $byej1(value);
}
module.exports = $a5325e8e980d1301$var$toString;

});
parcelRegister("byej1", function(module, exports) {

var $1QaHq = parcelRequire("1QaHq");

var $f63qI = parcelRequire("f63qI");

var $687Zl = parcelRequire("687Zl");

var $5Ob3C = parcelRequire("5Ob3C");
/** Used as references for various `Number` constants. */ var $868df78a2b941ee8$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $868df78a2b941ee8$var$symbolProto = $1QaHq ? $1QaHq.prototype : undefined, $868df78a2b941ee8$var$symbolToString = $868df78a2b941ee8$var$symbolProto ? $868df78a2b941ee8$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $868df78a2b941ee8$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($687Zl(value)) // Recursively convert values (susceptible to call stack limits).
    return $f63qI(value, $868df78a2b941ee8$var$baseToString) + "";
    if ($5Ob3C(value)) return $868df78a2b941ee8$var$symbolToString ? $868df78a2b941ee8$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$868df78a2b941ee8$var$INFINITY ? "-0" : result;
}
module.exports = $868df78a2b941ee8$var$baseToString;

});
parcelRegister("1QaHq", function(module, exports) {

var $bHcVp = parcelRequire("bHcVp");
/** Built-in value references. */ var $1572f275ac621e08$var$Symbol = $bHcVp.Symbol;
module.exports = $1572f275ac621e08$var$Symbol;

});
parcelRegister("bHcVp", function(module, exports) {

var $lPf0h = parcelRequire("lPf0h");
/** Detect free variable `self`. */ var $883dbc7c7d498b3c$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $883dbc7c7d498b3c$var$root = $lPf0h || $883dbc7c7d498b3c$var$freeSelf || Function("return this")();
module.exports = $883dbc7c7d498b3c$var$root;

});
parcelRegister("lPf0h", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $fe39ffcbf6764ca2$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $fe39ffcbf6764ca2$var$freeGlobal;

});



parcelRegister("f63qI", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $afda13a76e2b3f67$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $afda13a76e2b3f67$var$arrayMap;

});

parcelRegister("687Zl", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $4769afc185919177$var$isArray = Array.isArray;
module.exports = $4769afc185919177$var$isArray;

});

parcelRegister("5Ob3C", function(module, exports) {

var $d8VrW = parcelRequire("d8VrW");

var $8JxPO = parcelRequire("8JxPO");
/** `Object#toString` result references. */ var $43aa3307b278a060$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $43aa3307b278a060$var$isSymbol(value) {
    return typeof value == "symbol" || $8JxPO(value) && $d8VrW(value) == $43aa3307b278a060$var$symbolTag;
}
module.exports = $43aa3307b278a060$var$isSymbol;

});
parcelRegister("d8VrW", function(module, exports) {

var $1QaHq = parcelRequire("1QaHq");

var $4Farc = parcelRequire("4Farc");

var $4jUBP = parcelRequire("4jUBP");
/** `Object#toString` result references. */ var $99189608ed369f74$var$nullTag = "[object Null]", $99189608ed369f74$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $99189608ed369f74$var$symToStringTag = $1QaHq ? $1QaHq.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $99189608ed369f74$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $99189608ed369f74$var$undefinedTag : $99189608ed369f74$var$nullTag;
    return $99189608ed369f74$var$symToStringTag && $99189608ed369f74$var$symToStringTag in Object(value) ? $4Farc(value) : $4jUBP(value);
}
module.exports = $99189608ed369f74$var$baseGetTag;

});
parcelRegister("4Farc", function(module, exports) {

var $1QaHq = parcelRequire("1QaHq");
/** Used for built-in method references. */ var $3653167ddde536f8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3653167ddde536f8$var$hasOwnProperty = $3653167ddde536f8$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3653167ddde536f8$var$nativeObjectToString = $3653167ddde536f8$var$objectProto.toString;
/** Built-in value references. */ var $3653167ddde536f8$var$symToStringTag = $1QaHq ? $1QaHq.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $3653167ddde536f8$var$getRawTag(value) {
    var isOwn = $3653167ddde536f8$var$hasOwnProperty.call(value, $3653167ddde536f8$var$symToStringTag), tag = value[$3653167ddde536f8$var$symToStringTag];
    try {
        value[$3653167ddde536f8$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $3653167ddde536f8$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$3653167ddde536f8$var$symToStringTag] = tag;
        else delete value[$3653167ddde536f8$var$symToStringTag];
    }
    return result;
}
module.exports = $3653167ddde536f8$var$getRawTag;

});

parcelRegister("4jUBP", function(module, exports) {
/** Used for built-in method references. */ var $3254d9262a8f3c26$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3254d9262a8f3c26$var$nativeObjectToString = $3254d9262a8f3c26$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $3254d9262a8f3c26$var$objectToString(value) {
    return $3254d9262a8f3c26$var$nativeObjectToString.call(value);
}
module.exports = $3254d9262a8f3c26$var$objectToString;

});


parcelRegister("8JxPO", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $65bcc58fe2c934a2$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = $65bcc58fe2c934a2$var$isObjectLike;

});




parcelRegister("lKqbf", function(module, exports) {

var $1hAvA = parcelRequire("1hAvA");
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $fd5233b66553d9c4$var$upperFirst = $1hAvA("toUpperCase");
module.exports = $fd5233b66553d9c4$var$upperFirst;

});
parcelRegister("1hAvA", function(module, exports) {

var $8JU2R = parcelRequire("8JU2R");

var $d69fv = parcelRequire("d69fv");

var $jNWp8 = parcelRequire("jNWp8");

var $ebkZ0 = parcelRequire("ebkZ0");
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $0ef3b2cd0f8c1a37$var$createCaseFirst(methodName) {
    return function(string) {
        string = $ebkZ0(string);
        var strSymbols = $d69fv(string) ? $jNWp8(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $8JU2R(strSymbols, 1).join("") : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
module.exports = $0ef3b2cd0f8c1a37$var$createCaseFirst;

});
parcelRegister("8JU2R", function(module, exports) {

var $k26HL = parcelRequire("k26HL");
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $65ce0014ccbf5b38$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $k26HL(array, start, end);
}
module.exports = $65ce0014ccbf5b38$var$castSlice;

});
parcelRegister("k26HL", function(module, exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $e95931febbd56ff7$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = $e95931febbd56ff7$var$baseSlice;

});


parcelRegister("d69fv", function(module, exports) {
/** Used to compose unicode character classes. */ var $989302950a6cdb5c$var$rsAstralRange = "\ud800-\udfff", $989302950a6cdb5c$var$rsComboMarksRange = "\\u0300-\\u036f", $989302950a6cdb5c$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $989302950a6cdb5c$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $989302950a6cdb5c$var$rsComboRange = $989302950a6cdb5c$var$rsComboMarksRange + $989302950a6cdb5c$var$reComboHalfMarksRange + $989302950a6cdb5c$var$rsComboSymbolsRange, $989302950a6cdb5c$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $989302950a6cdb5c$var$rsZWJ = "\\u200d";
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $989302950a6cdb5c$var$reHasUnicode = RegExp("[" + $989302950a6cdb5c$var$rsZWJ + $989302950a6cdb5c$var$rsAstralRange + $989302950a6cdb5c$var$rsComboRange + $989302950a6cdb5c$var$rsVarRange + "]");
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $989302950a6cdb5c$var$hasUnicode(string) {
    return $989302950a6cdb5c$var$reHasUnicode.test(string);
}
module.exports = $989302950a6cdb5c$var$hasUnicode;

});

parcelRegister("jNWp8", function(module, exports) {

var $iO9Hj = parcelRequire("iO9Hj");

var $d69fv = parcelRequire("d69fv");

var $87Zxc = parcelRequire("87Zxc");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $e6afe5ccab802ad0$var$stringToArray(string) {
    return $d69fv(string) ? $87Zxc(string) : $iO9Hj(string);
}
module.exports = $e6afe5ccab802ad0$var$stringToArray;

});
parcelRegister("iO9Hj", function(module, exports) {
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $db146b3cd35f2be8$var$asciiToArray(string) {
    return string.split("");
}
module.exports = $db146b3cd35f2be8$var$asciiToArray;

});

parcelRegister("87Zxc", function(module, exports) {
/** Used to compose unicode character classes. */ var $5eaeb5a83ac0a1f9$var$rsAstralRange = "\ud800-\udfff", $5eaeb5a83ac0a1f9$var$rsComboMarksRange = "\\u0300-\\u036f", $5eaeb5a83ac0a1f9$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $5eaeb5a83ac0a1f9$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $5eaeb5a83ac0a1f9$var$rsComboRange = $5eaeb5a83ac0a1f9$var$rsComboMarksRange + $5eaeb5a83ac0a1f9$var$reComboHalfMarksRange + $5eaeb5a83ac0a1f9$var$rsComboSymbolsRange, $5eaeb5a83ac0a1f9$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $5eaeb5a83ac0a1f9$var$rsAstral = "[" + $5eaeb5a83ac0a1f9$var$rsAstralRange + "]", $5eaeb5a83ac0a1f9$var$rsCombo = "[" + $5eaeb5a83ac0a1f9$var$rsComboRange + "]", $5eaeb5a83ac0a1f9$var$rsFitz = "\ud83c[\udffb-\udfff]", $5eaeb5a83ac0a1f9$var$rsModifier = "(?:" + $5eaeb5a83ac0a1f9$var$rsCombo + "|" + $5eaeb5a83ac0a1f9$var$rsFitz + ")", $5eaeb5a83ac0a1f9$var$rsNonAstral = "[^" + $5eaeb5a83ac0a1f9$var$rsAstralRange + "]", $5eaeb5a83ac0a1f9$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $5eaeb5a83ac0a1f9$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $5eaeb5a83ac0a1f9$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $5eaeb5a83ac0a1f9$var$reOptMod = $5eaeb5a83ac0a1f9$var$rsModifier + "?", $5eaeb5a83ac0a1f9$var$rsOptVar = "[" + $5eaeb5a83ac0a1f9$var$rsVarRange + "]?", $5eaeb5a83ac0a1f9$var$rsOptJoin = "(?:" + $5eaeb5a83ac0a1f9$var$rsZWJ + "(?:" + [
    $5eaeb5a83ac0a1f9$var$rsNonAstral,
    $5eaeb5a83ac0a1f9$var$rsRegional,
    $5eaeb5a83ac0a1f9$var$rsSurrPair
].join("|") + ")" + $5eaeb5a83ac0a1f9$var$rsOptVar + $5eaeb5a83ac0a1f9$var$reOptMod + ")*", $5eaeb5a83ac0a1f9$var$rsSeq = $5eaeb5a83ac0a1f9$var$rsOptVar + $5eaeb5a83ac0a1f9$var$reOptMod + $5eaeb5a83ac0a1f9$var$rsOptJoin, $5eaeb5a83ac0a1f9$var$rsSymbol = "(?:" + [
    $5eaeb5a83ac0a1f9$var$rsNonAstral + $5eaeb5a83ac0a1f9$var$rsCombo + "?",
    $5eaeb5a83ac0a1f9$var$rsCombo,
    $5eaeb5a83ac0a1f9$var$rsRegional,
    $5eaeb5a83ac0a1f9$var$rsSurrPair,
    $5eaeb5a83ac0a1f9$var$rsAstral
].join("|") + ")";
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $5eaeb5a83ac0a1f9$var$reUnicode = RegExp($5eaeb5a83ac0a1f9$var$rsFitz + "(?=" + $5eaeb5a83ac0a1f9$var$rsFitz + ")|" + $5eaeb5a83ac0a1f9$var$rsSymbol + $5eaeb5a83ac0a1f9$var$rsSeq, "g");
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $5eaeb5a83ac0a1f9$var$unicodeToArray(string) {
    return string.match($5eaeb5a83ac0a1f9$var$reUnicode) || [];
}
module.exports = $5eaeb5a83ac0a1f9$var$unicodeToArray;

});





parcelRegister("lP0S2", function(module, exports) {

var $97fr5 = parcelRequire("97fr5");

var $6zCdR = parcelRequire("6zCdR");

var $O6QWa = parcelRequire("O6QWa");
/** Used to compose unicode capture groups. */ var $fe2f094b7c0d747e$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $fe2f094b7c0d747e$var$reApos = RegExp($fe2f094b7c0d747e$var$rsApos, "g");
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $fe2f094b7c0d747e$var$createCompounder(callback) {
    return function(string) {
        return $97fr5($O6QWa($6zCdR(string).replace($fe2f094b7c0d747e$var$reApos, "")), callback, "");
    };
}
module.exports = $fe2f094b7c0d747e$var$createCompounder;

});
parcelRegister("97fr5", function(module, exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $6a30bdbc0de90211$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = $6a30bdbc0de90211$var$arrayReduce;

});

parcelRegister("6zCdR", function(module, exports) {

var $krRl3 = parcelRequire("krRl3");

var $ebkZ0 = parcelRequire("ebkZ0");
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $4c93a92da9b2d214$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $4c93a92da9b2d214$var$rsComboMarksRange = "\\u0300-\\u036f", $4c93a92da9b2d214$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $4c93a92da9b2d214$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $4c93a92da9b2d214$var$rsComboRange = $4c93a92da9b2d214$var$rsComboMarksRange + $4c93a92da9b2d214$var$reComboHalfMarksRange + $4c93a92da9b2d214$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $4c93a92da9b2d214$var$rsCombo = "[" + $4c93a92da9b2d214$var$rsComboRange + "]";
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $4c93a92da9b2d214$var$reComboMark = RegExp($4c93a92da9b2d214$var$rsCombo, "g");
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $4c93a92da9b2d214$var$deburr(string) {
    string = $ebkZ0(string);
    return string && string.replace($4c93a92da9b2d214$var$reLatin, $krRl3).replace($4c93a92da9b2d214$var$reComboMark, "");
}
module.exports = $4c93a92da9b2d214$var$deburr;

});
parcelRegister("krRl3", function(module, exports) {

var $7eqqT = parcelRequire("7eqqT");
/** Used to map Latin Unicode letters to basic Latin letters. */ var $ee2fb42d01cd0653$var$deburredLetters = {
    // Latin-1 Supplement block.
    "\xc0": "A",
    "\xc1": "A",
    "\xc2": "A",
    "\xc3": "A",
    "\xc4": "A",
    "\xc5": "A",
    "\xe0": "a",
    "\xe1": "a",
    "\xe2": "a",
    "\xe3": "a",
    "\xe4": "a",
    "\xe5": "a",
    "\xc7": "C",
    "\xe7": "c",
    "\xd0": "D",
    "\xf0": "d",
    "\xc8": "E",
    "\xc9": "E",
    "\xca": "E",
    "\xcb": "E",
    "\xe8": "e",
    "\xe9": "e",
    "\xea": "e",
    "\xeb": "e",
    "\xcc": "I",
    "\xcd": "I",
    "\xce": "I",
    "\xcf": "I",
    "\xec": "i",
    "\xed": "i",
    "\xee": "i",
    "\xef": "i",
    "\xd1": "N",
    "\xf1": "n",
    "\xd2": "O",
    "\xd3": "O",
    "\xd4": "O",
    "\xd5": "O",
    "\xd6": "O",
    "\xd8": "O",
    "\xf2": "o",
    "\xf3": "o",
    "\xf4": "o",
    "\xf5": "o",
    "\xf6": "o",
    "\xf8": "o",
    "\xd9": "U",
    "\xda": "U",
    "\xdb": "U",
    "\xdc": "U",
    "\xf9": "u",
    "\xfa": "u",
    "\xfb": "u",
    "\xfc": "u",
    "\xdd": "Y",
    "\xfd": "y",
    "\xff": "y",
    "\xc6": "Ae",
    "\xe6": "ae",
    "\xde": "Th",
    "\xfe": "th",
    "\xdf": "ss",
    // Latin Extended-A block.
    "\u0100": "A",
    "\u0102": "A",
    "\u0104": "A",
    "\u0101": "a",
    "\u0103": "a",
    "\u0105": "a",
    "\u0106": "C",
    "\u0108": "C",
    "\u010A": "C",
    "\u010C": "C",
    "\u0107": "c",
    "\u0109": "c",
    "\u010B": "c",
    "\u010D": "c",
    "\u010E": "D",
    "\u0110": "D",
    "\u010F": "d",
    "\u0111": "d",
    "\u0112": "E",
    "\u0114": "E",
    "\u0116": "E",
    "\u0118": "E",
    "\u011A": "E",
    "\u0113": "e",
    "\u0115": "e",
    "\u0117": "e",
    "\u0119": "e",
    "\u011B": "e",
    "\u011C": "G",
    "\u011E": "G",
    "\u0120": "G",
    "\u0122": "G",
    "\u011D": "g",
    "\u011F": "g",
    "\u0121": "g",
    "\u0123": "g",
    "\u0124": "H",
    "\u0126": "H",
    "\u0125": "h",
    "\u0127": "h",
    "\u0128": "I",
    "\u012A": "I",
    "\u012C": "I",
    "\u012E": "I",
    "\u0130": "I",
    "\u0129": "i",
    "\u012B": "i",
    "\u012D": "i",
    "\u012F": "i",
    "\u0131": "i",
    "\u0134": "J",
    "\u0135": "j",
    "\u0136": "K",
    "\u0137": "k",
    "\u0138": "k",
    "\u0139": "L",
    "\u013B": "L",
    "\u013D": "L",
    "\u013F": "L",
    "\u0141": "L",
    "\u013A": "l",
    "\u013C": "l",
    "\u013E": "l",
    "\u0140": "l",
    "\u0142": "l",
    "\u0143": "N",
    "\u0145": "N",
    "\u0147": "N",
    "\u014A": "N",
    "\u0144": "n",
    "\u0146": "n",
    "\u0148": "n",
    "\u014B": "n",
    "\u014C": "O",
    "\u014E": "O",
    "\u0150": "O",
    "\u014D": "o",
    "\u014F": "o",
    "\u0151": "o",
    "\u0154": "R",
    "\u0156": "R",
    "\u0158": "R",
    "\u0155": "r",
    "\u0157": "r",
    "\u0159": "r",
    "\u015A": "S",
    "\u015C": "S",
    "\u015E": "S",
    "\u0160": "S",
    "\u015B": "s",
    "\u015D": "s",
    "\u015F": "s",
    "\u0161": "s",
    "\u0162": "T",
    "\u0164": "T",
    "\u0166": "T",
    "\u0163": "t",
    "\u0165": "t",
    "\u0167": "t",
    "\u0168": "U",
    "\u016A": "U",
    "\u016C": "U",
    "\u016E": "U",
    "\u0170": "U",
    "\u0172": "U",
    "\u0169": "u",
    "\u016B": "u",
    "\u016D": "u",
    "\u016F": "u",
    "\u0171": "u",
    "\u0173": "u",
    "\u0174": "W",
    "\u0175": "w",
    "\u0176": "Y",
    "\u0177": "y",
    "\u0178": "Y",
    "\u0179": "Z",
    "\u017B": "Z",
    "\u017D": "Z",
    "\u017A": "z",
    "\u017C": "z",
    "\u017E": "z",
    "\u0132": "IJ",
    "\u0133": "ij",
    "\u0152": "Oe",
    "\u0153": "oe",
    "\u0149": "'n",
    "\u017F": "s"
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $ee2fb42d01cd0653$var$deburrLetter = $7eqqT($ee2fb42d01cd0653$var$deburredLetters);
module.exports = $ee2fb42d01cd0653$var$deburrLetter;

});
parcelRegister("7eqqT", function(module, exports) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $543e5837b5eea92d$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $543e5837b5eea92d$var$basePropertyOf;

});



parcelRegister("O6QWa", function(module, exports) {

var $9Bol6 = parcelRequire("9Bol6");

var $j5B2V = parcelRequire("j5B2V");

var $ebkZ0 = parcelRequire("ebkZ0");

var $37XTz = parcelRequire("37XTz");
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $0969fc746d5c57a5$var$words(string, pattern, guard) {
    string = $ebkZ0(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $j5B2V(string) ? $37XTz(string) : $9Bol6(string);
    return string.match(pattern) || [];
}
module.exports = $0969fc746d5c57a5$var$words;

});
parcelRegister("9Bol6", function(module, exports) {
/** Used to match words composed of alphanumeric characters. */ var $6fda730ad22579b0$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $6fda730ad22579b0$var$asciiWords(string) {
    return string.match($6fda730ad22579b0$var$reAsciiWord) || [];
}
module.exports = $6fda730ad22579b0$var$asciiWords;

});

parcelRegister("j5B2V", function(module, exports) {
/** Used to detect strings that need a more robust regexp to match words. */ var $de5b388caa7086cf$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $de5b388caa7086cf$var$hasUnicodeWord(string) {
    return $de5b388caa7086cf$var$reHasUnicodeWord.test(string);
}
module.exports = $de5b388caa7086cf$var$hasUnicodeWord;

});

parcelRegister("37XTz", function(module, exports) {
/** Used to compose unicode character classes. */ var $24707c7b0ac2a08c$var$rsAstralRange = "\ud800-\udfff", $24707c7b0ac2a08c$var$rsComboMarksRange = "\\u0300-\\u036f", $24707c7b0ac2a08c$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $24707c7b0ac2a08c$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $24707c7b0ac2a08c$var$rsComboRange = $24707c7b0ac2a08c$var$rsComboMarksRange + $24707c7b0ac2a08c$var$reComboHalfMarksRange + $24707c7b0ac2a08c$var$rsComboSymbolsRange, $24707c7b0ac2a08c$var$rsDingbatRange = "\\u2700-\\u27bf", $24707c7b0ac2a08c$var$rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", $24707c7b0ac2a08c$var$rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", $24707c7b0ac2a08c$var$rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", $24707c7b0ac2a08c$var$rsPunctuationRange = "\\u2000-\\u206f", $24707c7b0ac2a08c$var$rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", $24707c7b0ac2a08c$var$rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", $24707c7b0ac2a08c$var$rsVarRange = "\\ufe0e\\ufe0f", $24707c7b0ac2a08c$var$rsBreakRange = $24707c7b0ac2a08c$var$rsMathOpRange + $24707c7b0ac2a08c$var$rsNonCharRange + $24707c7b0ac2a08c$var$rsPunctuationRange + $24707c7b0ac2a08c$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $24707c7b0ac2a08c$var$rsApos = "['\u2019]", $24707c7b0ac2a08c$var$rsBreak = "[" + $24707c7b0ac2a08c$var$rsBreakRange + "]", $24707c7b0ac2a08c$var$rsCombo = "[" + $24707c7b0ac2a08c$var$rsComboRange + "]", $24707c7b0ac2a08c$var$rsDigits = "\\d+", $24707c7b0ac2a08c$var$rsDingbat = "[" + $24707c7b0ac2a08c$var$rsDingbatRange + "]", $24707c7b0ac2a08c$var$rsLower = "[" + $24707c7b0ac2a08c$var$rsLowerRange + "]", $24707c7b0ac2a08c$var$rsMisc = "[^" + $24707c7b0ac2a08c$var$rsAstralRange + $24707c7b0ac2a08c$var$rsBreakRange + $24707c7b0ac2a08c$var$rsDigits + $24707c7b0ac2a08c$var$rsDingbatRange + $24707c7b0ac2a08c$var$rsLowerRange + $24707c7b0ac2a08c$var$rsUpperRange + "]", $24707c7b0ac2a08c$var$rsFitz = "\ud83c[\udffb-\udfff]", $24707c7b0ac2a08c$var$rsModifier = "(?:" + $24707c7b0ac2a08c$var$rsCombo + "|" + $24707c7b0ac2a08c$var$rsFitz + ")", $24707c7b0ac2a08c$var$rsNonAstral = "[^" + $24707c7b0ac2a08c$var$rsAstralRange + "]", $24707c7b0ac2a08c$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $24707c7b0ac2a08c$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $24707c7b0ac2a08c$var$rsUpper = "[" + $24707c7b0ac2a08c$var$rsUpperRange + "]", $24707c7b0ac2a08c$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $24707c7b0ac2a08c$var$rsMiscLower = "(?:" + $24707c7b0ac2a08c$var$rsLower + "|" + $24707c7b0ac2a08c$var$rsMisc + ")", $24707c7b0ac2a08c$var$rsMiscUpper = "(?:" + $24707c7b0ac2a08c$var$rsUpper + "|" + $24707c7b0ac2a08c$var$rsMisc + ")", $24707c7b0ac2a08c$var$rsOptContrLower = "(?:" + $24707c7b0ac2a08c$var$rsApos + "(?:d|ll|m|re|s|t|ve))?", $24707c7b0ac2a08c$var$rsOptContrUpper = "(?:" + $24707c7b0ac2a08c$var$rsApos + "(?:D|LL|M|RE|S|T|VE))?", $24707c7b0ac2a08c$var$reOptMod = $24707c7b0ac2a08c$var$rsModifier + "?", $24707c7b0ac2a08c$var$rsOptVar = "[" + $24707c7b0ac2a08c$var$rsVarRange + "]?", $24707c7b0ac2a08c$var$rsOptJoin = "(?:" + $24707c7b0ac2a08c$var$rsZWJ + "(?:" + [
    $24707c7b0ac2a08c$var$rsNonAstral,
    $24707c7b0ac2a08c$var$rsRegional,
    $24707c7b0ac2a08c$var$rsSurrPair
].join("|") + ")" + $24707c7b0ac2a08c$var$rsOptVar + $24707c7b0ac2a08c$var$reOptMod + ")*", $24707c7b0ac2a08c$var$rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", $24707c7b0ac2a08c$var$rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", $24707c7b0ac2a08c$var$rsSeq = $24707c7b0ac2a08c$var$rsOptVar + $24707c7b0ac2a08c$var$reOptMod + $24707c7b0ac2a08c$var$rsOptJoin, $24707c7b0ac2a08c$var$rsEmoji = "(?:" + [
    $24707c7b0ac2a08c$var$rsDingbat,
    $24707c7b0ac2a08c$var$rsRegional,
    $24707c7b0ac2a08c$var$rsSurrPair
].join("|") + ")" + $24707c7b0ac2a08c$var$rsSeq;
/** Used to match complex or compound words. */ var $24707c7b0ac2a08c$var$reUnicodeWord = RegExp([
    $24707c7b0ac2a08c$var$rsUpper + "?" + $24707c7b0ac2a08c$var$rsLower + "+" + $24707c7b0ac2a08c$var$rsOptContrLower + "(?=" + [
        $24707c7b0ac2a08c$var$rsBreak,
        $24707c7b0ac2a08c$var$rsUpper,
        "$"
    ].join("|") + ")",
    $24707c7b0ac2a08c$var$rsMiscUpper + "+" + $24707c7b0ac2a08c$var$rsOptContrUpper + "(?=" + [
        $24707c7b0ac2a08c$var$rsBreak,
        $24707c7b0ac2a08c$var$rsUpper + $24707c7b0ac2a08c$var$rsMiscLower,
        "$"
    ].join("|") + ")",
    $24707c7b0ac2a08c$var$rsUpper + "?" + $24707c7b0ac2a08c$var$rsMiscLower + "+" + $24707c7b0ac2a08c$var$rsOptContrLower,
    $24707c7b0ac2a08c$var$rsUpper + "+" + $24707c7b0ac2a08c$var$rsOptContrUpper,
    $24707c7b0ac2a08c$var$rsOrdUpper,
    $24707c7b0ac2a08c$var$rsOrdLower,
    $24707c7b0ac2a08c$var$rsDigits,
    $24707c7b0ac2a08c$var$rsEmoji
].join("|"), "g");
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $24707c7b0ac2a08c$var$unicodeWords(string) {
    return string.match($24707c7b0ac2a08c$var$reUnicodeWord) || [];
}
module.exports = $24707c7b0ac2a08c$var$unicodeWords;

});






parcelRegister("b18a6", function(module, exports) {

$parcel$export(module.exports, "setTwoToneColor", function () { return $80561e7c4ee2d39b$export$8a145f34580ff02b; });
$parcel$export(module.exports, "getTwoToneColor", function () { return $80561e7c4ee2d39b$export$abc7c554784cb4a7; });

var $CZyex = parcelRequire("CZyex");

var $hZvah = parcelRequire("hZvah");

var $g4bYW = parcelRequire("g4bYW");
function $80561e7c4ee2d39b$export$8a145f34580ff02b(twoToneColor) {
    var _normalizeTwoToneColo = (0, $g4bYW.normalizeTwoToneColors)(twoToneColor), _normalizeTwoToneColo2 = (0, $CZyex.default)(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
    return (0, $hZvah.default).setTwoToneColors({
        primaryColor: primaryColor,
        secondaryColor: secondaryColor
    });
}
function $80561e7c4ee2d39b$export$abc7c554784cb4a7() {
    var colors = (0, $hZvah.default).getTwoToneColors();
    if (!colors.calculated) return colors.primaryColor;
    return [
        colors.primaryColor,
        colors.secondaryColor
    ];
}

});



parcelRegister("kPBAG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2a5bacf2a9005cc$export$2e2bcd8739ae039; });

var $lv6ip = parcelRequire("lv6ip");

var $jbmdS = parcelRequire("jbmdS");

var $8FkzX = parcelRequire("8FkzX");

var $4hKc4 = parcelRequire("4hKc4");
var $f2a5bacf2a9005cc$var$CloseCircleFilled = function CloseCircleFilled(props, ref) {
    return /*#__PURE__*/ $jbmdS.createElement((0, $4hKc4.default), (0, $lv6ip.default)((0, $lv6ip.default)({}, props), {}, {
        ref: ref,
        icon: (0, $8FkzX.default)
    }));
};
var $f2a5bacf2a9005cc$var$RefIcon = /*#__PURE__*/ $jbmdS.forwardRef($f2a5bacf2a9005cc$var$CloseCircleFilled);
var $f2a5bacf2a9005cc$export$2e2bcd8739ae039 = $f2a5bacf2a9005cc$var$RefIcon;

});
parcelRegister("8FkzX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64f21da1d0cde04c$export$2e2bcd8739ae039; });
// This icon file is generated automatically.
var $64f21da1d0cde04c$var$CloseCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z"
                }
            }
        ]
    },
    "name": "close-circle",
    "theme": "filled"
};
var $64f21da1d0cde04c$export$2e2bcd8739ae039 = $64f21da1d0cde04c$var$CloseCircleFilled;

});


parcelRegister("6kn9Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49b69369a4012a5a$export$2e2bcd8739ae039; });

var $lv6ip = parcelRequire("lv6ip");

var $jbmdS = parcelRequire("jbmdS");

var $OWKP3 = parcelRequire("OWKP3");

var $4hKc4 = parcelRequire("4hKc4");
var $49b69369a4012a5a$var$ExclamationCircleFilled = function ExclamationCircleFilled(props, ref) {
    return /*#__PURE__*/ $jbmdS.createElement((0, $4hKc4.default), (0, $lv6ip.default)((0, $lv6ip.default)({}, props), {}, {
        ref: ref,
        icon: (0, $OWKP3.default)
    }));
};
var $49b69369a4012a5a$var$RefIcon = /*#__PURE__*/ $jbmdS.forwardRef($49b69369a4012a5a$var$ExclamationCircleFilled);
var $49b69369a4012a5a$export$2e2bcd8739ae039 = $49b69369a4012a5a$var$RefIcon;

});
parcelRegister("OWKP3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09923efcadc8a9e4$export$2e2bcd8739ae039; });
// This icon file is generated automatically.
var $09923efcadc8a9e4$var$ExclamationCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    "name": "exclamation-circle",
    "theme": "filled"
};
var $09923efcadc8a9e4$export$2e2bcd8739ae039 = $09923efcadc8a9e4$var$ExclamationCircleFilled;

});


parcelRegister("lRx2a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fea82c14e9542be8$export$2e2bcd8739ae039; });

var $lv6ip = parcelRequire("lv6ip");

var $jbmdS = parcelRequire("jbmdS");

var $4hn6a = parcelRequire("4hn6a");

var $4hKc4 = parcelRequire("4hKc4");
var $fea82c14e9542be8$var$InfoCircleFilled = function InfoCircleFilled(props, ref) {
    return /*#__PURE__*/ $jbmdS.createElement((0, $4hKc4.default), (0, $lv6ip.default)((0, $lv6ip.default)({}, props), {}, {
        ref: ref,
        icon: (0, $4hn6a.default)
    }));
};
var $fea82c14e9542be8$var$RefIcon = /*#__PURE__*/ $jbmdS.forwardRef($fea82c14e9542be8$var$InfoCircleFilled);
var $fea82c14e9542be8$export$2e2bcd8739ae039 = $fea82c14e9542be8$var$RefIcon;

});
parcelRegister("4hn6a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31daaad8edafe763$export$2e2bcd8739ae039; });
// This icon file is generated automatically.
var $31daaad8edafe763$var$InfoCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    "name": "info-circle",
    "theme": "filled"
};
var $31daaad8edafe763$export$2e2bcd8739ae039 = $31daaad8edafe763$var$InfoCircleFilled;

});


parcelRegister("97QHC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a4da621ab3fdb3e$export$2e2bcd8739ae039; });

var $lv6ip = parcelRequire("lv6ip");

var $jbmdS = parcelRequire("jbmdS");

var $8QWOl = parcelRequire("8QWOl");

var $4hKc4 = parcelRequire("4hKc4");
var $6a4da621ab3fdb3e$var$LoadingOutlined = function LoadingOutlined(props, ref) {
    return /*#__PURE__*/ $jbmdS.createElement((0, $4hKc4.default), (0, $lv6ip.default)((0, $lv6ip.default)({}, props), {}, {
        ref: ref,
        icon: (0, $8QWOl.default)
    }));
};
var $6a4da621ab3fdb3e$var$RefIcon = /*#__PURE__*/ $jbmdS.forwardRef($6a4da621ab3fdb3e$var$LoadingOutlined);
var $6a4da621ab3fdb3e$export$2e2bcd8739ae039 = $6a4da621ab3fdb3e$var$RefIcon;

});
parcelRegister("8QWOl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6720ccae6a3ca4fc$export$2e2bcd8739ae039; });
// This icon file is generated automatically.
var $6720ccae6a3ca4fc$var$LoadingOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"
                }
            }
        ]
    },
    "name": "loading",
    "theme": "outlined"
};
var $6720ccae6a3ca4fc$export$2e2bcd8739ae039 = $6720ccae6a3ca4fc$var$LoadingOutlined;

});


parcelRegister("iJQYM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da45868cdc572bc0$export$2e2bcd8739ae039; });

var $bJHiM = parcelRequire("bJHiM");
var $da45868cdc572bc0$export$2e2bcd8739ae039 = (0, $bJHiM.default);

});
parcelRegister("bJHiM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88b57c8ac410a511$export$2e2bcd8739ae039; });

var $ccQt4 = parcelRequire("ccQt4");

var $7i29i = parcelRequire("7i29i");

var $lv6ip = parcelRequire("lv6ip");

var $3GVdq = parcelRequire("3GVdq");

var $jj5jQ = parcelRequire("jj5jQ");

var $1N4zm = parcelRequire("1N4zm");

var $gRFRo = parcelRequire("gRFRo");

var $jbmdS = parcelRequire("jbmdS");

var $kIEZk = parcelRequire("kIEZk");

var $02LyB = parcelRequire("02LyB");
parcelRequire("jGjXd");
var $2xRuy = parcelRequire("2xRuy");

var $7WElh = parcelRequire("7WElh");

var $8TM7P = parcelRequire("8TM7P");
var $88b57c8ac410a511$var$_excluded = [
    "getContainer"
];
var $88b57c8ac410a511$var$seed = 0;
var $88b57c8ac410a511$var$now = Date.now();
function $88b57c8ac410a511$var$getUuid() {
    var id = $88b57c8ac410a511$var$seed;
    $88b57c8ac410a511$var$seed += 1;
    return "rcNotification_".concat($88b57c8ac410a511$var$now, "_").concat(id);
}
var $88b57c8ac410a511$var$Notification = /*#__PURE__*/ function(_Component) {
    (0, $1N4zm.default)(Notification, _Component);
    var _super = (0, $gRFRo.default)(Notification);
    function Notification() {
        var _this;
        (0, $3GVdq.default)(this, Notification);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.state = {
            notices: []
        };
        _this.hookRefs = new Map();
        _this.add = function(originNotice, holderCallback) {
            var _originNotice$key;
            var key = (_originNotice$key = originNotice.key) !== null && _originNotice$key !== void 0 ? _originNotice$key : $88b57c8ac410a511$var$getUuid();
            var notice = (0, $lv6ip.default)((0, $lv6ip.default)({}, originNotice), {}, {
                key: key
            });
            var maxCount = _this.props.maxCount;
            _this.setState(function(previousState) {
                var notices = previousState.notices;
                var noticeIndex = notices.map(function(v) {
                    return v.notice.key;
                }).indexOf(key);
                var updatedNotices = notices.concat();
                if (noticeIndex !== -1) updatedNotices.splice(noticeIndex, 1, {
                    notice: notice,
                    holderCallback: holderCallback
                });
                else {
                    if (maxCount && notices.length >= maxCount) {
                        // XXX, use key of first item to update new added (let React to move exsiting
                        // instead of remove and mount). Same key was used before for both a) external
                        // manual control and b) internal react 'key' prop , which is not that good.
                        // eslint-disable-next-line no-param-reassign
                        // zombieJ: Not know why use `updateKey`. This makes Notice infinite loop in jest.
                        // Change to `updateMark` for compare instead.
                        // https://github.com/react-component/notification/commit/32299e6be396f94040bfa82517eea940db947ece
                        notice.key = updatedNotices[0].notice.key;
                        notice.updateMark = $88b57c8ac410a511$var$getUuid();
                        // zombieJ: That's why. User may close by key directly.
                        // We need record this but not re-render to avoid upper issue
                        // https://github.com/react-component/notification/issues/129
                        notice.userPassKey = key;
                        updatedNotices.shift();
                    }
                    updatedNotices.push({
                        notice: notice,
                        holderCallback: holderCallback
                    });
                }
                return {
                    notices: updatedNotices
                };
            });
        };
        _this.remove = function(removeKey) {
            _this.setState(function(_ref) {
                var notices = _ref.notices;
                return {
                    notices: notices.filter(function(_ref2) {
                        var _ref2$notice = _ref2.notice, key = _ref2$notice.key, userPassKey = _ref2$notice.userPassKey;
                        var mergedKey = userPassKey !== null && userPassKey !== void 0 ? userPassKey : key;
                        return mergedKey !== removeKey;
                    })
                };
            });
        };
        _this.noticePropsMap = {};
        return _this;
    }
    (0, $jj5jQ.default)(Notification, [
        {
            key: "getTransitionName",
            value: function getTransitionName() {
                var _this$props = this.props, prefixCls = _this$props.prefixCls, animation = _this$props.animation;
                var transitionName = this.props.transitionName;
                if (!transitionName && animation) transitionName = "".concat(prefixCls, "-").concat(animation);
                return transitionName;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var notices = this.state.notices;
                var _this$props2 = this.props, prefixCls = _this$props2.prefixCls, className = _this$props2.className, closeIcon = _this$props2.closeIcon, style = _this$props2.style;
                var noticeKeys = [];
                notices.forEach(function(_ref3, index) {
                    var notice = _ref3.notice, holderCallback = _ref3.holderCallback;
                    var updateMark = index === notices.length - 1 ? notice.updateMark : undefined;
                    var key = notice.key, userPassKey = notice.userPassKey;
                    var noticeProps = (0, $lv6ip.default)((0, $lv6ip.default)((0, $lv6ip.default)({
                        prefixCls: prefixCls,
                        closeIcon: closeIcon
                    }, notice), notice.props), {}, {
                        key: key,
                        noticeKey: userPassKey || key,
                        updateMark: updateMark,
                        onClose: function onClose(noticeKey) {
                            var _notice$onClose;
                            _this2.remove(noticeKey);
                            (_notice$onClose = notice.onClose) === null || _notice$onClose === void 0 || _notice$onClose.call(notice);
                        },
                        onClick: notice.onClick,
                        children: notice.content
                    });
                    // Give to motion
                    noticeKeys.push(key);
                    _this2.noticePropsMap[key] = {
                        props: noticeProps,
                        holderCallback: holderCallback
                    };
                });
                return /*#__PURE__*/ $jbmdS.createElement("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(prefixCls, className),
                    style: style
                }, /*#__PURE__*/ $jbmdS.createElement((0, $2xRuy.default), {
                    keys: noticeKeys,
                    motionName: this.getTransitionName(),
                    onVisibleChanged: function onVisibleChanged(changedVisible, _ref4) {
                        var key = _ref4.key;
                        if (!changedVisible) delete _this2.noticePropsMap[key];
                    }
                }, function(_ref5) {
                    var key = _ref5.key, motionClassName = _ref5.className, motionStyle = _ref5.style, visible = _ref5.visible;
                    var _this2$noticePropsMap = _this2.noticePropsMap[key], noticeProps = _this2$noticePropsMap.props, holderCallback = _this2$noticePropsMap.holderCallback;
                    if (holderCallback) return /*#__PURE__*/ $jbmdS.createElement("div", {
                        key: key,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(motionClassName, "".concat(prefixCls, "-hook-holder")),
                        style: (0, $lv6ip.default)({}, motionStyle),
                        ref: function ref(div) {
                            if (typeof key === "undefined") return;
                            if (div) {
                                _this2.hookRefs.set(key, div);
                                holderCallback(div, noticeProps);
                            } else _this2.hookRefs.delete(key);
                        }
                    });
                    return /*#__PURE__*/ $jbmdS.createElement((0, $7WElh.default), (0, $7i29i.default)({}, noticeProps, {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(motionClassName, noticeProps === null || noticeProps === void 0 ? void 0 : noticeProps.className),
                        style: (0, $lv6ip.default)((0, $lv6ip.default)({}, motionStyle), noticeProps === null || noticeProps === void 0 ? void 0 : noticeProps.style),
                        visible: visible
                    }));
                }));
            }
        }
    ]);
    return Notification;
}((0, $jbmdS.Component));
$88b57c8ac410a511$var$Notification.newInstance = void 0;
$88b57c8ac410a511$var$Notification.defaultProps = {
    prefixCls: "rc-notification",
    animation: "fade",
    style: {
        top: 65,
        left: "50%"
    }
};
$88b57c8ac410a511$var$Notification.newInstance = function newNotificationInstance(properties, callback) {
    var _ref6 = properties || {}, getContainer = _ref6.getContainer, props = (0, $ccQt4.default)(_ref6, $88b57c8ac410a511$var$_excluded);
    var div = document.createElement("div");
    if (getContainer) {
        var root = getContainer();
        root.appendChild(div);
    } else document.body.appendChild(div);
    var called = false;
    function ref(notification) {
        if (called) return;
        called = true;
        callback({
            notice: function notice(noticeProps) {
                notification.add(noticeProps);
            },
            removeNotice: function removeNotice(key) {
                notification.remove(key);
            },
            component: notification,
            destroy: function destroy() {
                (0, $kIEZk.unmount)(div);
                if (div.parentNode) div.parentNode.removeChild(div);
            },
            // Hooks
            useNotification: function useNotification() {
                return (0, $8TM7P.default)(notification);
            }
        });
    }
    (0, $kIEZk.render)(/*#__PURE__*/ $jbmdS.createElement($88b57c8ac410a511$var$Notification, (0, $7i29i.default)({}, props, {
        ref: ref
    })), div);
};
var $88b57c8ac410a511$export$2e2bcd8739ae039 = $88b57c8ac410a511$var$Notification;

});
parcelRegister("3GVdq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b01ad2aee3340d6$export$2e2bcd8739ae039; });
function $2b01ad2aee3340d6$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("jj5jQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0e3eaeac8dba9dd$export$2e2bcd8739ae039; });

var $90Xx2 = parcelRequire("90Xx2");
function $e0e3eaeac8dba9dd$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $90Xx2.default)(o.key), o);
    }
}
function $e0e3eaeac8dba9dd$export$2e2bcd8739ae039(e, r, t) {
    return r && $e0e3eaeac8dba9dd$var$_defineProperties(e.prototype, r), t && $e0e3eaeac8dba9dd$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("1N4zm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14dde968be070acc$export$2e2bcd8739ae039; });

var $koP04 = parcelRequire("koP04");
function $14dde968be070acc$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $koP04.default)(t, e);
}

});
parcelRegister("koP04", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed9d9c15066682b4$export$2e2bcd8739ae039; });
function $ed9d9c15066682b4$export$2e2bcd8739ae039(t, e) {
    return $ed9d9c15066682b4$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $ed9d9c15066682b4$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("gRFRo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c472111f04b7e618$export$2e2bcd8739ae039; });

var $dO7bG = parcelRequire("dO7bG");

var $lJpH8 = parcelRequire("lJpH8");

var $ibb6t = parcelRequire("ibb6t");
function $c472111f04b7e618$export$2e2bcd8739ae039(t) {
    var r = (0, $lJpH8.default)();
    return function() {
        var e, o = (0, $dO7bG.default)(t);
        if (r) {
            var s = (0, $dO7bG.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $ibb6t.default)(this, e);
    };
}

});
parcelRegister("dO7bG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0d5852cac6fe452$export$2e2bcd8739ae039; });
function $a0d5852cac6fe452$export$2e2bcd8739ae039(t) {
    return $a0d5852cac6fe452$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $a0d5852cac6fe452$export$2e2bcd8739ae039(t);
}

});

parcelRegister("lJpH8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd21bb65877ad407$export$2e2bcd8739ae039; });
function $fd21bb65877ad407$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($fd21bb65877ad407$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("ibb6t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3c1ddff2e63b218$export$2e2bcd8739ae039; });

var $jncUt = parcelRequire("jncUt");

var $br3Qu = parcelRequire("br3Qu");
function $d3c1ddff2e63b218$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $jncUt.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $br3Qu.default)(t);
}

});
parcelRegister("br3Qu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $853532f5e64cd8bb$export$2e2bcd8739ae039; });
function $853532f5e64cd8bb$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});



parcelRegister("kIEZk", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $f157b6172864f3de$export$b3890eb0ae9dca99; });
$parcel$export(module.exports, "unmount", function () { return $f157b6172864f3de$export$121e2d597d222bad; });

var $9TNqp = parcelRequire("9TNqp");

var $raxj3 = parcelRequire("raxj3");

var $jncUt = parcelRequire("jncUt");

var $lv6ip = parcelRequire("lv6ip");

var $jCNM0 = parcelRequire("jCNM0");
// Let compiler not to search module usage
var $f157b6172864f3de$var$fullClone = (0, $lv6ip.default)({}, $jCNM0);
var $f157b6172864f3de$var$version = $f157b6172864f3de$var$fullClone.version, $f157b6172864f3de$var$reactRender = $f157b6172864f3de$var$fullClone.render, $f157b6172864f3de$var$unmountComponentAtNode = $f157b6172864f3de$var$fullClone.unmountComponentAtNode;
var $f157b6172864f3de$var$createRoot;
try {
    var $f157b6172864f3de$var$mainVersion = Number(($f157b6172864f3de$var$version || "").split(".")[0]);
    if ($f157b6172864f3de$var$mainVersion >= 18) $f157b6172864f3de$var$createRoot = $f157b6172864f3de$var$fullClone.createRoot;
} catch (e) {
// Do nothing;
}
function $f157b6172864f3de$var$toggleWarning(skip) {
    var __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = $f157b6172864f3de$var$fullClone.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    if (__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED && (0, $jncUt.default)(__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === "object") __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.usingClientEntryPoint = skip;
}
var $f157b6172864f3de$var$MARK = "__rc_react_root__";
// ========================== Render ==========================
function $f157b6172864f3de$var$modernRender(node, container) {
    $f157b6172864f3de$var$toggleWarning(true);
    var root = container[$f157b6172864f3de$var$MARK] || $f157b6172864f3de$var$createRoot(container);
    $f157b6172864f3de$var$toggleWarning(false);
    root.render(node);
    container[$f157b6172864f3de$var$MARK] = root;
}
function $f157b6172864f3de$var$legacyRender(node, container) {
    $f157b6172864f3de$var$reactRender(node, container);
}
function $f157b6172864f3de$export$892c6608f54d7438(node, container) {}
function $f157b6172864f3de$export$b3890eb0ae9dca99(node, container) {
    if ($f157b6172864f3de$var$createRoot) {
        $f157b6172864f3de$var$modernRender(node, container);
        return;
    }
    $f157b6172864f3de$var$legacyRender(node, container);
}
// ========================= Unmount ==========================
function $f157b6172864f3de$var$modernUnmount(_x) {
    return $f157b6172864f3de$var$_modernUnmount.apply(this, arguments);
}
function $f157b6172864f3de$var$_modernUnmount() {
    $f157b6172864f3de$var$_modernUnmount = (0, $raxj3.default)(/*#__PURE__*/ (0, $9TNqp.default)().mark(function _callee(container) {
        return (0, $9TNqp.default)().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    return _context.abrupt("return", Promise.resolve().then(function() {
                        var _container$MARK;
                        (_container$MARK = container[$f157b6172864f3de$var$MARK]) === null || _container$MARK === void 0 || _container$MARK.unmount();
                        delete container[$f157b6172864f3de$var$MARK];
                    }));
                case 1:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $f157b6172864f3de$var$_modernUnmount.apply(this, arguments);
}
function $f157b6172864f3de$var$legacyUnmount(container) {
    $f157b6172864f3de$var$unmountComponentAtNode(container);
}
function $f157b6172864f3de$export$fd39fe14445b207a(container) {}
function $f157b6172864f3de$export$121e2d597d222bad(_x2) {
    return $f157b6172864f3de$var$_unmount.apply(this, arguments);
}
function $f157b6172864f3de$var$_unmount() {
    $f157b6172864f3de$var$_unmount = (0, $raxj3.default)(/*#__PURE__*/ (0, $9TNqp.default)().mark(function _callee2(container) {
        return (0, $9TNqp.default)().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    if (!($f157b6172864f3de$var$createRoot !== undefined)) {
                        _context2.next = 2;
                        break;
                    }
                    return _context2.abrupt("return", $f157b6172864f3de$var$modernUnmount(container));
                case 2:
                    $f157b6172864f3de$var$legacyUnmount(container);
                case 3:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return $f157b6172864f3de$var$_unmount.apply(this, arguments);
}

});
parcelRegister("9TNqp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $734f96dab02f6554$export$2e2bcd8739ae039; });

var $jncUt = parcelRequire("jncUt");
function $734f96dab02f6554$export$2e2bcd8739ae039() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $734f96dab02f6554$export$2e2bcd8739ae039 = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == (0, $jncUt.default)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError((0, $jncUt.default)(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}

});

parcelRegister("raxj3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $051ab200244fa57b$export$2e2bcd8739ae039; });
function $051ab200244fa57b$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $051ab200244fa57b$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $051ab200244fa57b$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $051ab200244fa57b$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});


parcelRegister("jGjXd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5416b0c4df6d99e$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "CSSMotionList", function () { return (parcelRequire("2xRuy")).default; });

var $dlKAD = parcelRequire("dlKAD");

var $2xRuy = parcelRequire("2xRuy");

var $ixAWj = parcelRequire("ixAWj");
var $e5416b0c4df6d99e$export$2e2bcd8739ae039 = (0, $dlKAD.default);

});
parcelRegister("dlKAD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b81605350b61490$export$2e2bcd8739ae039; });

var $8K2NM = parcelRequire("8K2NM");

var $lv6ip = parcelRequire("lv6ip");

var $CZyex = parcelRequire("CZyex");

var $jncUt = parcelRequire("jncUt");

var $02LyB = parcelRequire("02LyB");

var $1RfjE = parcelRequire("1RfjE");

var $aKVEK = parcelRequire("aKVEK");

var $jbmdS = parcelRequire("jbmdS");

var $ixAWj = parcelRequire("ixAWj");

var $5R32K = parcelRequire("5R32K");

var $39bWQ = parcelRequire("39bWQ");

var $lHNXB = parcelRequire("lHNXB");

var $bGtKS = parcelRequire("bGtKS");

var $7hUap = parcelRequire("7hUap");
function $9b81605350b61490$export$e265d52a86a9f199(config) {
    var transitionSupport = config;
    if ((0, $jncUt.default)(config) === "object") transitionSupport = config.transitionSupport;
    function isSupportTransition(props, contextMotion) {
        return !!(props.motionName && transitionSupport && contextMotion !== false);
    }
    var CSSMotion = /*#__PURE__*/ $jbmdS.forwardRef(function(props, ref) {
        var _props$visible = props.visible, visible = _props$visible === void 0 ? true : _props$visible, _props$removeOnLeave = props.removeOnLeave, removeOnLeave = _props$removeOnLeave === void 0 ? true : _props$removeOnLeave, forceRender = props.forceRender, children = props.children, motionName = props.motionName, leavedClassName = props.leavedClassName, eventProps = props.eventProps;
        var _React$useContext = $jbmdS.useContext((0, $ixAWj.Context)), contextMotion = _React$useContext.motion;
        var supportMotion = isSupportTransition(props, contextMotion);
        // Ref to the react node, it may be a HTMLElement
        var nodeRef = (0, $jbmdS.useRef)();
        // Ref to the dom wrapper in case ref can not pass to HTMLElement
        var wrapperNodeRef = (0, $jbmdS.useRef)();
        function getDomElement() {
            try {
                // Here we're avoiding call for findDOMNode since it's deprecated
                // in strict mode. We're calling it only when node ref is not
                // an instance of DOM HTMLElement. Otherwise use
                // findDOMNode as a final resort
                return nodeRef.current instanceof HTMLElement ? nodeRef.current : (0, $1RfjE.default)(wrapperNodeRef.current);
            } catch (e) {
                // Only happen when `motionDeadline` trigger but element removed.
                return null;
            }
        }
        var _useStatus = (0, $39bWQ.default)(supportMotion, visible, getDomElement, props), _useStatus2 = (0, $CZyex.default)(_useStatus, 4), status = _useStatus2[0], statusStep = _useStatus2[1], statusStyle = _useStatus2[2], mergedVisible = _useStatus2[3];
        // Record whether content has rendered
        // Will return null for un-rendered even when `removeOnLeave={false}`
        var renderedRef = $jbmdS.useRef(mergedVisible);
        if (mergedVisible) renderedRef.current = true;
        // ====================== Refs ======================
        var setNodeRef = $jbmdS.useCallback(function(node) {
            nodeRef.current = node;
            (0, $aKVEK.fillRef)(ref, node);
        }, [
            ref
        ]);
        // ===================== Render =====================
        var motionChildren;
        var mergedProps = (0, $lv6ip.default)((0, $lv6ip.default)({}, eventProps), {}, {
            visible: visible
        });
        if (!children) // No children
        motionChildren = null;
        else if (status === (0, $bGtKS.STATUS_NONE)) {
            // Stable children
            if (mergedVisible) motionChildren = children((0, $lv6ip.default)({}, mergedProps), setNodeRef);
            else if (!removeOnLeave && renderedRef.current && leavedClassName) motionChildren = children((0, $lv6ip.default)((0, $lv6ip.default)({}, mergedProps), {}, {
                className: leavedClassName
            }), setNodeRef);
            else if (forceRender || !removeOnLeave && !leavedClassName) motionChildren = children((0, $lv6ip.default)((0, $lv6ip.default)({}, mergedProps), {}, {
                style: {
                    display: "none"
                }
            }), setNodeRef);
            else motionChildren = null;
        } else {
            // In motion
            var statusSuffix;
            if (statusStep === (0, $bGtKS.STEP_PREPARE)) statusSuffix = "prepare";
            else if ((0, $lHNXB.isActive)(statusStep)) statusSuffix = "active";
            else if (statusStep === (0, $bGtKS.STEP_START)) statusSuffix = "start";
            var motionCls = (0, $7hUap.getTransitionName)(motionName, "".concat(status, "-").concat(statusSuffix));
            motionChildren = children((0, $lv6ip.default)((0, $lv6ip.default)({}, mergedProps), {}, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))((0, $7hUap.getTransitionName)(motionName, status), (0, $8K2NM.default)((0, $8K2NM.default)({}, motionCls, motionCls && statusSuffix), motionName, typeof motionName === "string")),
                style: statusStyle
            }), setNodeRef);
        }
        // Auto inject ref if child node not have `ref` props
        if (/*#__PURE__*/ $jbmdS.isValidElement(motionChildren) && (0, $aKVEK.supportRef)(motionChildren)) {
            var _ref = motionChildren, originNodeRef = _ref.ref;
            if (!originNodeRef) motionChildren = /*#__PURE__*/ $jbmdS.cloneElement(motionChildren, {
                ref: setNodeRef
            });
        }
        return /*#__PURE__*/ $jbmdS.createElement((0, $5R32K.default), {
            ref: wrapperNodeRef
        }, motionChildren);
    });
    CSSMotion.displayName = "CSSMotion";
    return CSSMotion;
}
var $9b81605350b61490$export$2e2bcd8739ae039 = $9b81605350b61490$export$e265d52a86a9f199((0, $7hUap.supportTransition));

});
parcelRegister("1RfjE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15a69f1b94d15f6e$export$2e2bcd8739ae039; });

var $jncUt = parcelRequire("jncUt");

var $jbmdS = parcelRequire("jbmdS");

var $jCNM0 = parcelRequire("jCNM0");
function $15a69f1b94d15f6e$export$41e30d8dd0ba7a50(node) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Element
    // Since XULElement is also subclass of Element, we only need HTMLElement and SVGElement
    return node instanceof HTMLElement || node instanceof SVGElement;
}
function $15a69f1b94d15f6e$export$9aa546fdc20ae5b3(node) {
    if (node && (0, $jncUt.default)(node) === "object" && $15a69f1b94d15f6e$export$41e30d8dd0ba7a50(node.nativeElement)) return node.nativeElement;
    if ($15a69f1b94d15f6e$export$41e30d8dd0ba7a50(node)) return node;
    return null;
}
function $15a69f1b94d15f6e$export$2e2bcd8739ae039(node) {
    var domNode = $15a69f1b94d15f6e$export$9aa546fdc20ae5b3(node);
    if (domNode) return domNode;
    if (node instanceof (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).Component) {
        var _ReactDOM$findDOMNode;
        return (_ReactDOM$findDOMNode = (0, (/*@__PURE__*/$parcel$interopDefault($jCNM0))).findDOMNode) === null || _ReactDOM$findDOMNode === void 0 ? void 0 : _ReactDOM$findDOMNode.call((0, (/*@__PURE__*/$parcel$interopDefault($jCNM0))), node);
    }
    return null;
}

});

parcelRegister("aKVEK", function(module, exports) {

$parcel$export(module.exports, "fillRef", function () { return $7d4aec904e3156bf$export$f17fd18fa51dcb5b; });
$parcel$export(module.exports, "composeRef", function () { return $7d4aec904e3156bf$export$ab452c34e8e05029; });
$parcel$export(module.exports, "useComposeRef", function () { return $7d4aec904e3156bf$export$1d1c999670a1285d; });
$parcel$export(module.exports, "supportRef", function () { return $7d4aec904e3156bf$export$c1cec34af06bcf7; });

var $jncUt = parcelRequire("jncUt");

var $jbmdS = parcelRequire("jbmdS");

var $5byCE = parcelRequire("5byCE");

var $gwVpW = parcelRequire("gwVpW");
var $7d4aec904e3156bf$export$f17fd18fa51dcb5b = function fillRef(ref, node) {
    if (typeof ref === "function") ref(node);
    else if ((0, $jncUt.default)(ref) === "object" && ref && "current" in ref) ref.current = node;
};
var $7d4aec904e3156bf$export$ab452c34e8e05029 = function composeRef() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    var refList = refs.filter(Boolean);
    if (refList.length <= 1) return refList[0];
    return function(node) {
        refs.forEach(function(ref) {
            $7d4aec904e3156bf$export$f17fd18fa51dcb5b(ref, node);
        });
    };
};
var $7d4aec904e3156bf$export$1d1c999670a1285d = function useComposeRef() {
    for(var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)refs[_key2] = arguments[_key2];
    return (0, $gwVpW.default)(function() {
        return $7d4aec904e3156bf$export$ab452c34e8e05029.apply(void 0, refs);
    }, refs, function(prev, next) {
        return prev.length !== next.length || prev.every(function(ref, i) {
            return ref !== next[i];
        });
    });
};
var $7d4aec904e3156bf$export$c1cec34af06bcf7 = function supportRef(nodeOrComponent) {
    var _type$prototype, _nodeOrComponent$prot;
    var type = (0, $5byCE.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    // Function component node
    if (typeof type === "function" && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render) && type.$$typeof !== (0, $5byCE.ForwardRef)) return false;
    // Class component
    if (typeof nodeOrComponent === "function" && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render) && nodeOrComponent.$$typeof !== (0, $5byCE.ForwardRef)) return false;
    return true;
};
function $7d4aec904e3156bf$var$isReactElement(node) {
    return /*#__PURE__*/ (0, $jbmdS.isValidElement)(node) && !(0, $5byCE.isFragment)(node);
}
var $7d4aec904e3156bf$export$b51ae67c7882a242 = function supportNodeRef(node) {
    return $7d4aec904e3156bf$var$isReactElement(node) && $7d4aec904e3156bf$export$c1cec34af06bcf7(node);
};
var $7d4aec904e3156bf$export$7465e5c0bf44f19a = Number((0, $jbmdS.version).split(".")[0]) >= 19 ? // >= React 19
function(node) {
    if ($7d4aec904e3156bf$var$isReactElement(node)) return node.props.ref;
    return null;
} : // < React 19
function(node) {
    if ($7d4aec904e3156bf$var$isReactElement(node)) return node.ref;
    return null;
};

});
parcelRegister("5byCE", function(module, exports) {
"use strict";

module.exports = (parcelRequire("5jL19"));

});
parcelRegister("5jL19", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $3df332d001f1fe70$export$a7c73072b1a182ae; }, function (v) { return $3df332d001f1fe70$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $3df332d001f1fe70$export$9f27bc3417b4524d; }, function (v) { return $3df332d001f1fe70$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $3df332d001f1fe70$export$db77ccec0bb4ccac; }, function (v) { return $3df332d001f1fe70$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $3df332d001f1fe70$export$8392c0c9d3dcbd35; }, function (v) { return $3df332d001f1fe70$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $3df332d001f1fe70$export$ffb0004e005737fa; }, function (v) { return $3df332d001f1fe70$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $3df332d001f1fe70$export$b624eff549462981; }, function (v) { return $3df332d001f1fe70$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $3df332d001f1fe70$export$7897aa7841a5380c; }, function (v) { return $3df332d001f1fe70$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $3df332d001f1fe70$export$602eac185826482c; }, function (v) { return $3df332d001f1fe70$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $3df332d001f1fe70$export$e2c29f18771995cb; }, function (v) { return $3df332d001f1fe70$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $3df332d001f1fe70$export$5f8d39834fd61797; }, function (v) { return $3df332d001f1fe70$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $3df332d001f1fe70$export$74bf444e3cd11ea5; }, function (v) { return $3df332d001f1fe70$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $3df332d001f1fe70$export$998bcd577473dd93; }, function (v) { return $3df332d001f1fe70$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $3df332d001f1fe70$export$92387174baf9b227; }, function (v) { return $3df332d001f1fe70$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $3df332d001f1fe70$export$ec112efeb987d9c6; }, function (v) { return $3df332d001f1fe70$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $3df332d001f1fe70$export$b706b080d889d2c9; }, function (v) { return $3df332d001f1fe70$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $3df332d001f1fe70$export$5be5a87408f70ddc; }, function (v) { return $3df332d001f1fe70$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $3df332d001f1fe70$export$45a5e7f76e0caa8d; }, function (v) { return $3df332d001f1fe70$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $3df332d001f1fe70$export$455c2e768291efa6; }, function (v) { return $3df332d001f1fe70$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $3df332d001f1fe70$export$9522e17588c12572; }, function (v) { return $3df332d001f1fe70$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $3df332d001f1fe70$export$2110ac352bb060b9; }, function (v) { return $3df332d001f1fe70$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $3df332d001f1fe70$export$56885ab8b9c456ab; }, function (v) { return $3df332d001f1fe70$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $3df332d001f1fe70$export$d927fcb6adf8f9de; }, function (v) { return $3df332d001f1fe70$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $3df332d001f1fe70$export$b82d16f27459e05a; }, function (v) { return $3df332d001f1fe70$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $3df332d001f1fe70$export$522c17b4f5e123e8; }, function (v) { return $3df332d001f1fe70$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $3df332d001f1fe70$export$1aabd8a0274ecfd6; }, function (v) { return $3df332d001f1fe70$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $3df332d001f1fe70$export$3d6c20d97e46b957; }, function (v) { return $3df332d001f1fe70$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $3df332d001f1fe70$export$9b621391a187a31a; }, function (v) { return $3df332d001f1fe70$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $3df332d001f1fe70$export$f5bbd400c2f4426f; }, function (v) { return $3df332d001f1fe70$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3df332d001f1fe70$export$a7c73072b1a182ae;
var $3df332d001f1fe70$export$9f27bc3417b4524d;
var $3df332d001f1fe70$export$db77ccec0bb4ccac;
var $3df332d001f1fe70$export$8392c0c9d3dcbd35;
var $3df332d001f1fe70$export$ffb0004e005737fa;
var $3df332d001f1fe70$export$b624eff549462981;
var $3df332d001f1fe70$export$7897aa7841a5380c;
var $3df332d001f1fe70$export$602eac185826482c;
var $3df332d001f1fe70$export$e2c29f18771995cb;
var $3df332d001f1fe70$export$5f8d39834fd61797;
var $3df332d001f1fe70$export$74bf444e3cd11ea5;
var $3df332d001f1fe70$export$998bcd577473dd93;
var $3df332d001f1fe70$export$92387174baf9b227;
var $3df332d001f1fe70$export$ec112efeb987d9c6;
var $3df332d001f1fe70$export$b706b080d889d2c9;
var $3df332d001f1fe70$export$5be5a87408f70ddc;
var $3df332d001f1fe70$export$45a5e7f76e0caa8d;
var $3df332d001f1fe70$export$455c2e768291efa6;
var $3df332d001f1fe70$export$9522e17588c12572;
var $3df332d001f1fe70$export$2110ac352bb060b9;
var $3df332d001f1fe70$export$56885ab8b9c456ab;
var $3df332d001f1fe70$export$d927fcb6adf8f9de;
var $3df332d001f1fe70$export$b82d16f27459e05a;
var $3df332d001f1fe70$export$522c17b4f5e123e8;
var $3df332d001f1fe70$export$1aabd8a0274ecfd6;
var $3df332d001f1fe70$export$3d6c20d97e46b957;
var $3df332d001f1fe70$export$9b621391a187a31a;
var $3df332d001f1fe70$export$f5bbd400c2f4426f;
"use strict";
var $3df332d001f1fe70$var$b = Symbol.for("react.element"), $3df332d001f1fe70$var$c = Symbol.for("react.portal"), $3df332d001f1fe70$var$d = Symbol.for("react.fragment"), $3df332d001f1fe70$var$e = Symbol.for("react.strict_mode"), $3df332d001f1fe70$var$f = Symbol.for("react.profiler"), $3df332d001f1fe70$var$g = Symbol.for("react.provider"), $3df332d001f1fe70$var$h = Symbol.for("react.context"), $3df332d001f1fe70$var$k = Symbol.for("react.server_context"), $3df332d001f1fe70$var$l = Symbol.for("react.forward_ref"), $3df332d001f1fe70$var$m = Symbol.for("react.suspense"), $3df332d001f1fe70$var$n = Symbol.for("react.suspense_list"), $3df332d001f1fe70$var$p = Symbol.for("react.memo"), $3df332d001f1fe70$var$q = Symbol.for("react.lazy"), $3df332d001f1fe70$var$t = Symbol.for("react.offscreen"), $3df332d001f1fe70$var$u;
$3df332d001f1fe70$var$u = Symbol.for("react.module.reference");
function $3df332d001f1fe70$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $3df332d001f1fe70$var$b:
                switch(a = a.type, a){
                    case $3df332d001f1fe70$var$d:
                    case $3df332d001f1fe70$var$f:
                    case $3df332d001f1fe70$var$e:
                    case $3df332d001f1fe70$var$m:
                    case $3df332d001f1fe70$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $3df332d001f1fe70$var$k:
                            case $3df332d001f1fe70$var$h:
                            case $3df332d001f1fe70$var$l:
                            case $3df332d001f1fe70$var$q:
                            case $3df332d001f1fe70$var$p:
                            case $3df332d001f1fe70$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $3df332d001f1fe70$var$c:
                return r;
        }
    }
}
$3df332d001f1fe70$export$a7c73072b1a182ae = $3df332d001f1fe70$var$h;
$3df332d001f1fe70$export$9f27bc3417b4524d = $3df332d001f1fe70$var$g;
$3df332d001f1fe70$export$db77ccec0bb4ccac = $3df332d001f1fe70$var$b;
$3df332d001f1fe70$export$8392c0c9d3dcbd35 = $3df332d001f1fe70$var$l;
$3df332d001f1fe70$export$ffb0004e005737fa = $3df332d001f1fe70$var$d;
$3df332d001f1fe70$export$b624eff549462981 = $3df332d001f1fe70$var$q;
$3df332d001f1fe70$export$7897aa7841a5380c = $3df332d001f1fe70$var$p;
$3df332d001f1fe70$export$602eac185826482c = $3df332d001f1fe70$var$c;
$3df332d001f1fe70$export$e2c29f18771995cb = $3df332d001f1fe70$var$f;
$3df332d001f1fe70$export$5f8d39834fd61797 = $3df332d001f1fe70$var$e;
$3df332d001f1fe70$export$74bf444e3cd11ea5 = $3df332d001f1fe70$var$m;
$3df332d001f1fe70$export$998bcd577473dd93 = $3df332d001f1fe70$var$n;
$3df332d001f1fe70$export$92387174baf9b227 = function() {
    return !1;
};
$3df332d001f1fe70$export$ec112efeb987d9c6 = function() {
    return !1;
};
$3df332d001f1fe70$export$b706b080d889d2c9 = function(a) {
    return $3df332d001f1fe70$var$v(a) === $3df332d001f1fe70$var$h;
};
$3df332d001f1fe70$export$5be5a87408f70ddc = function(a) {
    return $3df332d001f1fe70$var$v(a) === $3df332d001f1fe70$var$g;
};
$3df332d001f1fe70$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $3df332d001f1fe70$var$b;
};
$3df332d001f1fe70$export$455c2e768291efa6 = function(a) {
    return $3df332d001f1fe70$var$v(a) === $3df332d001f1fe70$var$l;
};
$3df332d001f1fe70$export$9522e17588c12572 = function(a) {
    return $3df332d001f1fe70$var$v(a) === $3df332d001f1fe70$var$d;
};
$3df332d001f1fe70$export$2110ac352bb060b9 = function(a) {
    return $3df332d001f1fe70$var$v(a) === $3df332d001f1fe70$var$q;
};
$3df332d001f1fe70$export$56885ab8b9c456ab = function(a) {
    return $3df332d001f1fe70$var$v(a) === $3df332d001f1fe70$var$p;
};
$3df332d001f1fe70$export$d927fcb6adf8f9de = function(a) {
    return $3df332d001f1fe70$var$v(a) === $3df332d001f1fe70$var$c;
};
$3df332d001f1fe70$export$b82d16f27459e05a = function(a) {
    return $3df332d001f1fe70$var$v(a) === $3df332d001f1fe70$var$f;
};
$3df332d001f1fe70$export$522c17b4f5e123e8 = function(a) {
    return $3df332d001f1fe70$var$v(a) === $3df332d001f1fe70$var$e;
};
$3df332d001f1fe70$export$1aabd8a0274ecfd6 = function(a) {
    return $3df332d001f1fe70$var$v(a) === $3df332d001f1fe70$var$m;
};
$3df332d001f1fe70$export$3d6c20d97e46b957 = function(a) {
    return $3df332d001f1fe70$var$v(a) === $3df332d001f1fe70$var$n;
};
$3df332d001f1fe70$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $3df332d001f1fe70$var$d || a === $3df332d001f1fe70$var$f || a === $3df332d001f1fe70$var$e || a === $3df332d001f1fe70$var$m || a === $3df332d001f1fe70$var$n || a === $3df332d001f1fe70$var$t || "object" === typeof a && null !== a && (a.$$typeof === $3df332d001f1fe70$var$q || a.$$typeof === $3df332d001f1fe70$var$p || a.$$typeof === $3df332d001f1fe70$var$g || a.$$typeof === $3df332d001f1fe70$var$h || a.$$typeof === $3df332d001f1fe70$var$l || a.$$typeof === $3df332d001f1fe70$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$3df332d001f1fe70$export$f5bbd400c2f4426f = $3df332d001f1fe70$var$v;

});



parcelRegister("ixAWj", function(module, exports) {

$parcel$export(module.exports, "Context", function () { return $d7f7f676cf1e0fe6$export$841858b892ce1f4c; });

var $ccQt4 = parcelRequire("ccQt4");

var $jbmdS = parcelRequire("jbmdS");
var $d7f7f676cf1e0fe6$var$_excluded = [
    "children"
];
var $d7f7f676cf1e0fe6$export$841858b892ce1f4c = /*#__PURE__*/ $jbmdS.createContext({});
function $d7f7f676cf1e0fe6$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, props = (0, $ccQt4.default)(_ref, $d7f7f676cf1e0fe6$var$_excluded);
    return /*#__PURE__*/ $jbmdS.createElement($d7f7f676cf1e0fe6$export$841858b892ce1f4c.Provider, {
        value: props
    }, children);
}

});

parcelRegister("5R32K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $443443556f4e6fb2$export$2e2bcd8739ae039; });

var $3GVdq = parcelRequire("3GVdq");

var $jj5jQ = parcelRequire("jj5jQ");

var $1N4zm = parcelRequire("1N4zm");

var $gRFRo = parcelRequire("gRFRo");

var $jbmdS = parcelRequire("jbmdS");
var $443443556f4e6fb2$var$DomWrapper = /*#__PURE__*/ function(_React$Component) {
    (0, $1N4zm.default)(DomWrapper, _React$Component);
    var _super = (0, $gRFRo.default)(DomWrapper);
    function DomWrapper() {
        (0, $3GVdq.default)(this, DomWrapper);
        return _super.apply(this, arguments);
    }
    (0, $jj5jQ.default)(DomWrapper, [
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return DomWrapper;
}($jbmdS.Component);
var $443443556f4e6fb2$export$2e2bcd8739ae039 = $443443556f4e6fb2$var$DomWrapper;

});

parcelRegister("39bWQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24ab7aff31aa3a79$export$2e2bcd8739ae039; });

var $lv6ip = parcelRequire("lv6ip");

var $8K2NM = parcelRequire("8K2NM");

var $CZyex = parcelRequire("CZyex");
parcelRequire("7AQNp");
var $gZPGe = parcelRequire("gZPGe");

var $eRdwh = parcelRequire("eRdwh");

var $4ue4X = parcelRequire("4ue4X");

var $jbmdS = parcelRequire("jbmdS");

var $bGtKS = parcelRequire("bGtKS");

var $56MGc = parcelRequire("56MGc");

var $bhrTo = parcelRequire("bhrTo");

var $lHNXB = parcelRequire("lHNXB");
function $24ab7aff31aa3a79$export$2e2bcd8739ae039(supportMotion, visible, getElement, _ref) {
    var _ref$motionEnter = _ref.motionEnter, motionEnter = _ref$motionEnter === void 0 ? true : _ref$motionEnter, _ref$motionAppear = _ref.motionAppear, motionAppear = _ref$motionAppear === void 0 ? true : _ref$motionAppear, _ref$motionLeave = _ref.motionLeave, motionLeave = _ref$motionLeave === void 0 ? true : _ref$motionLeave, motionDeadline = _ref.motionDeadline, motionLeaveImmediately = _ref.motionLeaveImmediately, onAppearPrepare = _ref.onAppearPrepare, onEnterPrepare = _ref.onEnterPrepare, onLeavePrepare = _ref.onLeavePrepare, onAppearStart = _ref.onAppearStart, onEnterStart = _ref.onEnterStart, onLeaveStart = _ref.onLeaveStart, onAppearActive = _ref.onAppearActive, onEnterActive = _ref.onEnterActive, onLeaveActive = _ref.onLeaveActive, onAppearEnd = _ref.onAppearEnd, onEnterEnd = _ref.onEnterEnd, onLeaveEnd = _ref.onLeaveEnd, onVisibleChanged = _ref.onVisibleChanged;
    // Used for outer render usage to avoid `visible: false & status: none` to render nothing
    var _useState = (0, $eRdwh.default)(), _useState2 = (0, $CZyex.default)(_useState, 2), asyncVisible = _useState2[0], setAsyncVisible = _useState2[1];
    var _useSyncState = (0, $4ue4X.default)((0, $bGtKS.STATUS_NONE)), _useSyncState2 = (0, $CZyex.default)(_useSyncState, 2), getStatus = _useSyncState2[0], setStatus = _useSyncState2[1];
    var _useState3 = (0, $eRdwh.default)(null), _useState4 = (0, $CZyex.default)(_useState3, 2), style = _useState4[0], setStyle = _useState4[1];
    var currentStatus = getStatus();
    var mountedRef = (0, $jbmdS.useRef)(false);
    var deadlineRef = (0, $jbmdS.useRef)(null);
    // =========================== Dom Node ===========================
    function getDomElement() {
        return getElement();
    }
    // ========================== Motion End ==========================
    var activeRef = (0, $jbmdS.useRef)(false);
    /**
   * Clean up status & style
   */ function updateMotionEndStatus() {
        setStatus((0, $bGtKS.STATUS_NONE));
        setStyle(null, true);
    }
    var onInternalMotionEnd = (0, $gZPGe.default)(function(event) {
        var status = getStatus();
        // Do nothing since not in any transition status.
        // This may happen when `motionDeadline` trigger.
        if (status === (0, $bGtKS.STATUS_NONE)) return;
        var element = getDomElement();
        if (event && !event.deadline && event.target !== element) // event exists
        // not initiated by deadline
        // transitionEnd not fired by inner elements
        return;
        var currentActive = activeRef.current;
        var canEnd;
        if (status === (0, $bGtKS.STATUS_APPEAR) && currentActive) canEnd = onAppearEnd === null || onAppearEnd === void 0 ? void 0 : onAppearEnd(element, event);
        else if (status === (0, $bGtKS.STATUS_ENTER) && currentActive) canEnd = onEnterEnd === null || onEnterEnd === void 0 ? void 0 : onEnterEnd(element, event);
        else if (status === (0, $bGtKS.STATUS_LEAVE) && currentActive) canEnd = onLeaveEnd === null || onLeaveEnd === void 0 ? void 0 : onLeaveEnd(element, event);
        // Only update status when `canEnd` and not destroyed
        if (currentActive && canEnd !== false) updateMotionEndStatus();
    });
    var _useDomMotionEvents = (0, $56MGc.default)(onInternalMotionEnd), _useDomMotionEvents2 = (0, $CZyex.default)(_useDomMotionEvents, 1), patchMotionEvents = _useDomMotionEvents2[0];
    // ============================= Step =============================
    var getEventHandlers = function getEventHandlers(targetStatus) {
        switch(targetStatus){
            case 0, $bGtKS.STATUS_APPEAR:
                return (0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)({}, (0, $bGtKS.STEP_PREPARE), onAppearPrepare), (0, $bGtKS.STEP_START), onAppearStart), (0, $bGtKS.STEP_ACTIVE), onAppearActive);
            case 0, $bGtKS.STATUS_ENTER:
                return (0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)({}, (0, $bGtKS.STEP_PREPARE), onEnterPrepare), (0, $bGtKS.STEP_START), onEnterStart), (0, $bGtKS.STEP_ACTIVE), onEnterActive);
            case 0, $bGtKS.STATUS_LEAVE:
                return (0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)({}, (0, $bGtKS.STEP_PREPARE), onLeavePrepare), (0, $bGtKS.STEP_START), onLeaveStart), (0, $bGtKS.STEP_ACTIVE), onLeaveActive);
            default:
                return {};
        }
    };
    var eventHandlers = $jbmdS.useMemo(function() {
        return getEventHandlers(currentStatus);
    }, [
        currentStatus
    ]);
    var _useStepQueue = (0, $lHNXB.default)(currentStatus, !supportMotion, function(newStep) {
        // Only prepare step can be skip
        if (newStep === (0, $bGtKS.STEP_PREPARE)) {
            var onPrepare = eventHandlers[0, $bGtKS.STEP_PREPARE];
            if (!onPrepare) return 0, $lHNXB.SkipStep;
            return onPrepare(getDomElement());
        }
        // Rest step is sync update
        if (step in eventHandlers) {
            var _eventHandlers$step;
            setStyle(((_eventHandlers$step = eventHandlers[step]) === null || _eventHandlers$step === void 0 ? void 0 : _eventHandlers$step.call(eventHandlers, getDomElement(), null)) || null);
        }
        if (step === (0, $bGtKS.STEP_ACTIVE) && currentStatus !== (0, $bGtKS.STATUS_NONE)) {
            // Patch events when motion needed
            patchMotionEvents(getDomElement());
            if (motionDeadline > 0) {
                clearTimeout(deadlineRef.current);
                deadlineRef.current = setTimeout(function() {
                    onInternalMotionEnd({
                        deadline: true
                    });
                }, motionDeadline);
            }
        }
        if (step === (0, $bGtKS.STEP_PREPARED)) updateMotionEndStatus();
        return 0, $lHNXB.DoStep;
    }), _useStepQueue2 = (0, $CZyex.default)(_useStepQueue, 2), startStep = _useStepQueue2[0], step = _useStepQueue2[1];
    var active = (0, $lHNXB.isActive)(step);
    activeRef.current = active;
    // ============================ Status ============================
    // Update with new status
    (0, $bhrTo.default)(function() {
        setAsyncVisible(visible);
        var isMounted = mountedRef.current;
        mountedRef.current = true;
        // if (!supportMotion) {
        //   return;
        // }
        var nextStatus;
        // Appear
        if (!isMounted && visible && motionAppear) nextStatus = (0, $bGtKS.STATUS_APPEAR);
        // Enter
        if (isMounted && visible && motionEnter) nextStatus = (0, $bGtKS.STATUS_ENTER);
        // Leave
        if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) nextStatus = (0, $bGtKS.STATUS_LEAVE);
        var nextEventHandlers = getEventHandlers(nextStatus);
        // Update to next status
        if (nextStatus && (supportMotion || nextEventHandlers[0, $bGtKS.STEP_PREPARE])) {
            setStatus(nextStatus);
            startStep();
        } else // Set back in case no motion but prev status has prepare step
        setStatus((0, $bGtKS.STATUS_NONE));
    }, [
        visible
    ]);
    // ============================ Effect ============================
    // Reset when motion changed
    (0, $jbmdS.useEffect)(function() {
        if (// Cancel appear
        currentStatus === (0, $bGtKS.STATUS_APPEAR) && !motionAppear || // Cancel enter
        currentStatus === (0, $bGtKS.STATUS_ENTER) && !motionEnter || // Cancel leave
        currentStatus === (0, $bGtKS.STATUS_LEAVE) && !motionLeave) setStatus((0, $bGtKS.STATUS_NONE));
    }, [
        motionAppear,
        motionEnter,
        motionLeave
    ]);
    (0, $jbmdS.useEffect)(function() {
        return function() {
            mountedRef.current = false;
            clearTimeout(deadlineRef.current);
        };
    }, []);
    // Trigger `onVisibleChanged`
    var firstMountChangeRef = $jbmdS.useRef(false);
    (0, $jbmdS.useEffect)(function() {
        // [visible & motion not end] => [!visible & motion end] still need trigger onVisibleChanged
        if (asyncVisible) firstMountChangeRef.current = true;
        if (asyncVisible !== undefined && currentStatus === (0, $bGtKS.STATUS_NONE)) {
            // Skip first render is invisible since it's nothing changed
            if (firstMountChangeRef.current || asyncVisible) onVisibleChanged === null || onVisibleChanged === void 0 || onVisibleChanged(asyncVisible);
            firstMountChangeRef.current = true;
        }
    }, [
        asyncVisible,
        currentStatus
    ]);
    // ============================ Styles ============================
    var mergedStyle = style;
    if (eventHandlers[0, $bGtKS.STEP_PREPARE] && step === (0, $bGtKS.STEP_START)) mergedStyle = (0, $lv6ip.default)({
        transition: "none"
    }, mergedStyle);
    return [
        currentStatus,
        step,
        mergedStyle,
        asyncVisible !== null && asyncVisible !== void 0 ? asyncVisible : visible
    ];
}

});
parcelRegister("7AQNp", function(module, exports) {

$parcel$export(module.exports, "useEvent", function () { return (parcelRequire("gZPGe")).default; });

var $gZPGe = parcelRequire("gZPGe");

var $9nYhz = parcelRequire("9nYhz");

var $aKVEK = parcelRequire("aKVEK");

var $4eeUf = parcelRequire("4eeUf");

var $cbsvf = parcelRequire("cbsvf");

var $8tMCd = parcelRequire("8tMCd");

});
parcelRegister("gZPGe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5fa6e712c6e28f3$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");
function $c5fa6e712c6e28f3$export$2e2bcd8739ae039(callback) {
    var fnRef = $jbmdS.useRef();
    fnRef.current = callback;
    var memoFn = $jbmdS.useCallback(function() {
        var _fnRef$current;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [
            fnRef
        ].concat(args));
    }, []);
    return memoFn;
}

});

parcelRegister("9nYhz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d5505e1e215d2c3$export$2e2bcd8739ae039; });

var $CZyex = parcelRequire("CZyex");

var $gZPGe = parcelRequire("gZPGe");

var $iDOLX = parcelRequire("iDOLX");

var $eRdwh = parcelRequire("eRdwh");
/** We only think `undefined` is empty */ function $6d5505e1e215d2c3$var$hasValue(value) {
    return value !== undefined;
}
function $6d5505e1e215d2c3$export$2e2bcd8739ae039(defaultStateValue, option) {
    var _ref = option || {}, defaultValue = _ref.defaultValue, value = _ref.value, onChange = _ref.onChange, postState = _ref.postState;
    // ======================= Init =======================
    var _useState = (0, $eRdwh.default)(function() {
        if ($6d5505e1e215d2c3$var$hasValue(value)) return value;
        else if ($6d5505e1e215d2c3$var$hasValue(defaultValue)) return typeof defaultValue === "function" ? defaultValue() : defaultValue;
        else return typeof defaultStateValue === "function" ? defaultStateValue() : defaultStateValue;
    }), _useState2 = (0, $CZyex.default)(_useState, 2), innerValue = _useState2[0], setInnerValue = _useState2[1];
    var mergedValue = value !== undefined ? value : innerValue;
    var postMergedValue = postState ? postState(mergedValue) : mergedValue;
    // ====================== Change ======================
    var onChangeFn = (0, $gZPGe.default)(onChange);
    var _useState3 = (0, $eRdwh.default)([
        mergedValue
    ]), _useState4 = (0, $CZyex.default)(_useState3, 2), prevValue = _useState4[0], setPrevValue = _useState4[1];
    (0, $iDOLX.useLayoutUpdateEffect)(function() {
        var prev = prevValue[0];
        if (innerValue !== prev) onChangeFn(innerValue, prev);
    }, [
        prevValue
    ]);
    // Sync value back to `undefined` when it from control to un-control
    (0, $iDOLX.useLayoutUpdateEffect)(function() {
        if (!$6d5505e1e215d2c3$var$hasValue(value)) setInnerValue(value);
    }, [
        value
    ]);
    // ====================== Update ======================
    var triggerChange = (0, $gZPGe.default)(function(updater, ignoreDestroy) {
        setInnerValue(updater, ignoreDestroy);
        setPrevValue([
            mergedValue
        ], ignoreDestroy);
    });
    return [
        postMergedValue,
        triggerChange
    ];
}

});
parcelRegister("iDOLX", function(module, exports) {

$parcel$export(module.exports, "useLayoutUpdateEffect", function () { return $d92340e43b08d16d$export$9283e56bae2f7b0f; });
$parcel$export(module.exports, "default", function () { return $d92340e43b08d16d$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");

var $gnP4S = parcelRequire("gnP4S");
/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */ var $d92340e43b08d16d$var$useInternalLayoutEffect = (0, $gnP4S.default)() ? $jbmdS.useLayoutEffect : $jbmdS.useEffect;
var $d92340e43b08d16d$var$useLayoutEffect = function useLayoutEffect(callback, deps) {
    var firstMountRef = $jbmdS.useRef(true);
    $d92340e43b08d16d$var$useInternalLayoutEffect(function() {
        return callback(firstMountRef.current);
    }, deps);
    // We tell react that first mount has passed
    $d92340e43b08d16d$var$useInternalLayoutEffect(function() {
        firstMountRef.current = false;
        return function() {
            firstMountRef.current = true;
        };
    }, []);
};
var $d92340e43b08d16d$export$9283e56bae2f7b0f = function useLayoutUpdateEffect(callback, deps) {
    $d92340e43b08d16d$var$useLayoutEffect(function(firstMount) {
        if (!firstMount) return callback();
    }, deps);
};
var $d92340e43b08d16d$export$2e2bcd8739ae039 = $d92340e43b08d16d$var$useLayoutEffect;

});

parcelRegister("eRdwh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad1080a364a4c082$export$2e2bcd8739ae039; });

var $CZyex = parcelRequire("CZyex");

var $jbmdS = parcelRequire("jbmdS");
function $ad1080a364a4c082$export$2e2bcd8739ae039(defaultValue) {
    var destroyRef = $jbmdS.useRef(false);
    var _React$useState = $jbmdS.useState(defaultValue), _React$useState2 = (0, $CZyex.default)(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
    $jbmdS.useEffect(function() {
        destroyRef.current = false;
        return function() {
            destroyRef.current = true;
        };
    }, []);
    function safeSetState(updater, ignoreDestroy) {
        if (ignoreDestroy && destroyRef.current) return;
        setValue(updater);
    }
    return [
        value,
        safeSetState
    ];
}

});



parcelRegister("4ue4X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3444e28809b89451$export$2e2bcd8739ae039; });

var $CZyex = parcelRequire("CZyex");

var $jbmdS = parcelRequire("jbmdS");

var $gZPGe = parcelRequire("gZPGe");
function $3444e28809b89451$export$2e2bcd8739ae039(defaultValue) {
    var _React$useReducer = $jbmdS.useReducer(function(x) {
        return x + 1;
    }, 0), _React$useReducer2 = (0, $CZyex.default)(_React$useReducer, 2), forceUpdate = _React$useReducer2[1];
    var currentValueRef = $jbmdS.useRef(defaultValue);
    var getValue = (0, $gZPGe.default)(function() {
        return currentValueRef.current;
    });
    var setValue = (0, $gZPGe.default)(function(updater) {
        currentValueRef.current = typeof updater === "function" ? updater(currentValueRef.current) : updater;
        forceUpdate();
    });
    return [
        getValue,
        setValue
    ];
}

});

parcelRegister("bGtKS", function(module, exports) {

$parcel$export(module.exports, "STATUS_NONE", function () { return $881ab2b2537604f6$export$de71442bbf2143da; });
$parcel$export(module.exports, "STATUS_APPEAR", function () { return $881ab2b2537604f6$export$4fc3521687bcacd2; });
$parcel$export(module.exports, "STATUS_ENTER", function () { return $881ab2b2537604f6$export$5d6af549241fe2e8; });
$parcel$export(module.exports, "STATUS_LEAVE", function () { return $881ab2b2537604f6$export$59b1c493d29f68e4; });
$parcel$export(module.exports, "STEP_NONE", function () { return $881ab2b2537604f6$export$40b34dd77d5522bf; });
$parcel$export(module.exports, "STEP_PREPARE", function () { return $881ab2b2537604f6$export$1b792916a5fac4fc; });
$parcel$export(module.exports, "STEP_START", function () { return $881ab2b2537604f6$export$9563153dd25a3ce8; });
$parcel$export(module.exports, "STEP_ACTIVE", function () { return $881ab2b2537604f6$export$e205886172277ec6; });
$parcel$export(module.exports, "STEP_ACTIVATED", function () { return $881ab2b2537604f6$export$3a846c3d2fac10b8; });
$parcel$export(module.exports, "STEP_PREPARED", function () { return $881ab2b2537604f6$export$98351fa4e6b4f204; });
var $881ab2b2537604f6$export$de71442bbf2143da = "none";
var $881ab2b2537604f6$export$4fc3521687bcacd2 = "appear";
var $881ab2b2537604f6$export$5d6af549241fe2e8 = "enter";
var $881ab2b2537604f6$export$59b1c493d29f68e4 = "leave";
var $881ab2b2537604f6$export$40b34dd77d5522bf = "none";
var $881ab2b2537604f6$export$1b792916a5fac4fc = "prepare";
var $881ab2b2537604f6$export$9563153dd25a3ce8 = "start";
var $881ab2b2537604f6$export$e205886172277ec6 = "active";
var $881ab2b2537604f6$export$3a846c3d2fac10b8 = "end";
var $881ab2b2537604f6$export$98351fa4e6b4f204 = "prepared";

});

parcelRegister("56MGc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b834612c6170516$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");

var $7hUap = parcelRequire("7hUap");
var $3b834612c6170516$export$2e2bcd8739ae039 = function(onInternalMotionEnd) {
    var cacheElementRef = (0, $jbmdS.useRef)();
    // Remove events
    function removeMotionEvents(element) {
        if (element) {
            element.removeEventListener((0, $7hUap.transitionEndName), onInternalMotionEnd);
            element.removeEventListener((0, $7hUap.animationEndName), onInternalMotionEnd);
        }
    }
    // Patch events
    function patchMotionEvents(element) {
        if (cacheElementRef.current && cacheElementRef.current !== element) removeMotionEvents(cacheElementRef.current);
        if (element && element !== cacheElementRef.current) {
            element.addEventListener((0, $7hUap.transitionEndName), onInternalMotionEnd);
            element.addEventListener((0, $7hUap.animationEndName), onInternalMotionEnd);
            // Save as cache in case dom removed trigger by `motionDeadline`
            cacheElementRef.current = element;
        }
    }
    // Clean up when removed
    $jbmdS.useEffect(function() {
        return function() {
            removeMotionEvents(cacheElementRef.current);
        };
    }, []);
    return [
        patchMotionEvents,
        removeMotionEvents
    ];
};

});
parcelRegister("7hUap", function(module, exports) {

$parcel$export(module.exports, "supportTransition", function () { return $54e5b080d4480ceb$export$d28133ed3ad06c8b; });
$parcel$export(module.exports, "animationEndName", function () { return $54e5b080d4480ceb$export$760cc9769c51b738; });
$parcel$export(module.exports, "transitionEndName", function () { return $54e5b080d4480ceb$export$44baea64b8602e3c; });
$parcel$export(module.exports, "getTransitionName", function () { return $54e5b080d4480ceb$export$27c72201b1d09951; });

var $jncUt = parcelRequire("jncUt");

var $gnP4S = parcelRequire("gnP4S");
// ================= Transition =================
// Event wrapper. Copy from react source code
function $54e5b080d4480ceb$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit".concat(styleProp)] = "webkit".concat(eventName);
    prefixes["Moz".concat(styleProp)] = "moz".concat(eventName);
    prefixes["ms".concat(styleProp)] = "MS".concat(eventName);
    prefixes["O".concat(styleProp)] = "o".concat(eventName.toLowerCase());
    return prefixes;
}
function $54e5b080d4480ceb$export$6e8b350b1a8958a0(domSupport, win) {
    var prefixes = {
        animationend: $54e5b080d4480ceb$var$makePrefixMap("Animation", "AnimationEnd"),
        transitionend: $54e5b080d4480ceb$var$makePrefixMap("Transition", "TransitionEnd")
    };
    if (domSupport) {
        if (!("AnimationEvent" in win)) delete prefixes.animationend.animation;
        if (!("TransitionEvent" in win)) delete prefixes.transitionend.transition;
    }
    return prefixes;
}
var $54e5b080d4480ceb$var$vendorPrefixes = $54e5b080d4480ceb$export$6e8b350b1a8958a0((0, $gnP4S.default)(), typeof window !== "undefined" ? window : {});
var $54e5b080d4480ceb$var$style = {};
if ((0, $gnP4S.default)()) {
    var $54e5b080d4480ceb$var$_document$createEleme = document.createElement("div");
    $54e5b080d4480ceb$var$style = $54e5b080d4480ceb$var$_document$createEleme.style;
}
var $54e5b080d4480ceb$var$prefixedEventNames = {};
function $54e5b080d4480ceb$export$a032e4f39350c1d8(eventName) {
    if ($54e5b080d4480ceb$var$prefixedEventNames[eventName]) return $54e5b080d4480ceb$var$prefixedEventNames[eventName];
    var prefixMap = $54e5b080d4480ceb$var$vendorPrefixes[eventName];
    if (prefixMap) {
        var stylePropList = Object.keys(prefixMap);
        var len = stylePropList.length;
        for(var i = 0; i < len; i += 1){
            var styleProp = stylePropList[i];
            if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in $54e5b080d4480ceb$var$style) {
                $54e5b080d4480ceb$var$prefixedEventNames[eventName] = prefixMap[styleProp];
                return $54e5b080d4480ceb$var$prefixedEventNames[eventName];
            }
        }
    }
    return "";
}
var $54e5b080d4480ceb$var$internalAnimationEndName = $54e5b080d4480ceb$export$a032e4f39350c1d8("animationend");
var $54e5b080d4480ceb$var$internalTransitionEndName = $54e5b080d4480ceb$export$a032e4f39350c1d8("transitionend");
var $54e5b080d4480ceb$export$d28133ed3ad06c8b = !!($54e5b080d4480ceb$var$internalAnimationEndName && $54e5b080d4480ceb$var$internalTransitionEndName);
var $54e5b080d4480ceb$export$760cc9769c51b738 = $54e5b080d4480ceb$var$internalAnimationEndName || "animationend";
var $54e5b080d4480ceb$export$44baea64b8602e3c = $54e5b080d4480ceb$var$internalTransitionEndName || "transitionend";
function $54e5b080d4480ceb$export$27c72201b1d09951(transitionName, transitionType) {
    if (!transitionName) return null;
    if ((0, $jncUt.default)(transitionName) === "object") {
        var type = transitionType.replace(/-\w/g, function(match) {
            return match[1].toUpperCase();
        });
        return transitionName[type];
    }
    return "".concat(transitionName, "-").concat(transitionType);
}

});


parcelRegister("bhrTo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8366eb1cff24a9ad$export$2e2bcd8739ae039; });

var $gnP4S = parcelRequire("gnP4S");

var $jbmdS = parcelRequire("jbmdS");
// It's safe to use `useLayoutEffect` but the warning is annoying
var $8366eb1cff24a9ad$var$useIsomorphicLayoutEffect = (0, $gnP4S.default)() ? (0, $jbmdS.useLayoutEffect) : (0, $jbmdS.useEffect);
var $8366eb1cff24a9ad$export$2e2bcd8739ae039 = $8366eb1cff24a9ad$var$useIsomorphicLayoutEffect;

});

parcelRegister("lHNXB", function(module, exports) {

$parcel$export(module.exports, "SkipStep", function () { return $fcd45e394cbe5a55$export$c2029bf6cfdbc28a; });
$parcel$export(module.exports, "DoStep", function () { return $fcd45e394cbe5a55$export$dbee1e282e8c4830; });
$parcel$export(module.exports, "isActive", function () { return $fcd45e394cbe5a55$export$39e04e72f972b885; });
$parcel$export(module.exports, "default", function () { return $fcd45e394cbe5a55$export$2e2bcd8739ae039; });

var $CZyex = parcelRequire("CZyex");

var $eRdwh = parcelRequire("eRdwh");

var $jbmdS = parcelRequire("jbmdS");

var $bGtKS = parcelRequire("bGtKS");

var $bhrTo = parcelRequire("bhrTo");

var $lLz3c = parcelRequire("lLz3c");
var $fcd45e394cbe5a55$var$FULL_STEP_QUEUE = [
    (0, $bGtKS.STEP_PREPARE),
    (0, $bGtKS.STEP_START),
    (0, $bGtKS.STEP_ACTIVE),
    (0, $bGtKS.STEP_ACTIVATED)
];
var $fcd45e394cbe5a55$var$SIMPLE_STEP_QUEUE = [
    (0, $bGtKS.STEP_PREPARE),
    (0, $bGtKS.STEP_PREPARED)
];
var $fcd45e394cbe5a55$export$c2029bf6cfdbc28a = false;
var $fcd45e394cbe5a55$export$dbee1e282e8c4830 = true;
function $fcd45e394cbe5a55$export$39e04e72f972b885(step) {
    return step === (0, $bGtKS.STEP_ACTIVE) || step === (0, $bGtKS.STEP_ACTIVATED);
}
var $fcd45e394cbe5a55$export$2e2bcd8739ae039 = function(status, prepareOnly, callback) {
    var _useState = (0, $eRdwh.default)((0, $bGtKS.STEP_NONE)), _useState2 = (0, $CZyex.default)(_useState, 2), step = _useState2[0], setStep = _useState2[1];
    var _useNextFrame = (0, $lLz3c.default)(), _useNextFrame2 = (0, $CZyex.default)(_useNextFrame, 2), nextFrame = _useNextFrame2[0], cancelNextFrame = _useNextFrame2[1];
    function startQueue() {
        setStep((0, $bGtKS.STEP_PREPARE), true);
    }
    var STEP_QUEUE = prepareOnly ? $fcd45e394cbe5a55$var$SIMPLE_STEP_QUEUE : $fcd45e394cbe5a55$var$FULL_STEP_QUEUE;
    (0, $bhrTo.default)(function() {
        if (step !== (0, $bGtKS.STEP_NONE) && step !== (0, $bGtKS.STEP_ACTIVATED)) {
            var index = STEP_QUEUE.indexOf(step);
            var nextStep = STEP_QUEUE[index + 1];
            var result = callback(step);
            if (result === $fcd45e394cbe5a55$export$c2029bf6cfdbc28a) // Skip when no needed
            setStep(nextStep, true);
            else if (nextStep) // Do as frame for step update
            nextFrame(function(info) {
                function doNext() {
                    // Skip since current queue is ood
                    if (info.isCanceled()) return;
                    setStep(nextStep, true);
                }
                if (result === true) doNext();
                else // Only promise should be async
                Promise.resolve(result).then(doNext);
            });
        }
    }, [
        status,
        step
    ]);
    $jbmdS.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        startQueue,
        step
    ];
};

});
parcelRegister("lLz3c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0416db90bdfb32ba$export$2e2bcd8739ae039; });

var $2iJQe = parcelRequire("2iJQe");

var $jbmdS = parcelRequire("jbmdS");
var $0416db90bdfb32ba$export$2e2bcd8739ae039 = function() {
    var nextFrameRef = $jbmdS.useRef(null);
    function cancelNextFrame() {
        (0, $2iJQe.default).cancel(nextFrameRef.current);
    }
    function nextFrame(callback) {
        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
        cancelNextFrame();
        var nextFrameId = (0, $2iJQe.default)(function() {
            if (delay <= 1) callback({
                isCanceled: function isCanceled() {
                    return nextFrameId !== nextFrameRef.current;
                }
            });
            else nextFrame(callback, delay - 1);
        });
        nextFrameRef.current = nextFrameId;
    }
    $jbmdS.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        nextFrame,
        cancelNextFrame
    ];
};

});
parcelRegister("2iJQe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ad0d261542f2af9$export$2e2bcd8739ae039; });
var $1ad0d261542f2af9$var$raf = function raf(callback) {
    return +setTimeout(callback, 16);
};
var $1ad0d261542f2af9$var$caf = function caf(num) {
    return clearTimeout(num);
};
if (typeof window !== "undefined" && "requestAnimationFrame" in window) {
    $1ad0d261542f2af9$var$raf = function raf(callback) {
        return window.requestAnimationFrame(callback);
    };
    $1ad0d261542f2af9$var$caf = function caf(handle) {
        return window.cancelAnimationFrame(handle);
    };
}
var $1ad0d261542f2af9$var$rafUUID = 0;
var $1ad0d261542f2af9$var$rafIds = new Map();
function $1ad0d261542f2af9$var$cleanup(id) {
    $1ad0d261542f2af9$var$rafIds.delete(id);
}
var $1ad0d261542f2af9$var$wrapperRaf = function wrapperRaf(callback) {
    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    $1ad0d261542f2af9$var$rafUUID += 1;
    var id = $1ad0d261542f2af9$var$rafUUID;
    function callRef(leftTimes) {
        if (leftTimes === 0) {
            // Clean up
            $1ad0d261542f2af9$var$cleanup(id);
            // Trigger
            callback();
        } else {
            // Next raf
            var realId = $1ad0d261542f2af9$var$raf(function() {
                callRef(leftTimes - 1);
            });
            // Bind real raf id
            $1ad0d261542f2af9$var$rafIds.set(id, realId);
        }
    }
    callRef(times);
    return id;
};
$1ad0d261542f2af9$var$wrapperRaf.cancel = function(id) {
    var realId = $1ad0d261542f2af9$var$rafIds.get(id);
    $1ad0d261542f2af9$var$cleanup(id);
    return $1ad0d261542f2af9$var$caf(realId);
};
var $1ad0d261542f2af9$export$2e2bcd8739ae039 = $1ad0d261542f2af9$var$wrapperRaf;

});





parcelRegister("2xRuy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1da82831c0d5f5a9$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $ccQt4 = parcelRequire("ccQt4");

var $lv6ip = parcelRequire("lv6ip");

var $3GVdq = parcelRequire("3GVdq");

var $jj5jQ = parcelRequire("jj5jQ");

var $br3Qu = parcelRequire("br3Qu");

var $1N4zm = parcelRequire("1N4zm");

var $gRFRo = parcelRequire("gRFRo");

var $8K2NM = parcelRequire("8K2NM");

var $jbmdS = parcelRequire("jbmdS");

var $dlKAD = parcelRequire("dlKAD");

var $I9SrJ = parcelRequire("I9SrJ");

var $7hUap = parcelRequire("7hUap");
var $1da82831c0d5f5a9$var$_excluded = [
    "component",
    "children",
    "onVisibleChanged",
    "onAllRemoved"
], $1da82831c0d5f5a9$var$_excluded2 = [
    "status"
];
var $1da82831c0d5f5a9$var$MOTION_PROP_NAMES = [
    "eventProps",
    "visible",
    "children",
    "motionName",
    "motionAppear",
    "motionEnter",
    "motionLeave",
    "motionLeaveImmediately",
    "motionDeadline",
    "removeOnLeave",
    "leavedClassName",
    "onAppearPrepare",
    "onAppearStart",
    "onAppearActive",
    "onAppearEnd",
    "onEnterStart",
    "onEnterActive",
    "onEnterEnd",
    "onLeaveStart",
    "onLeaveActive",
    "onLeaveEnd"
];
function $1da82831c0d5f5a9$export$fcfc62c1d33d5e2e(transitionSupport) {
    var CSSMotion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $dlKAD.default);
    var CSSMotionList = /*#__PURE__*/ function(_React$Component) {
        (0, $1N4zm.default)(CSSMotionList, _React$Component);
        var _super = (0, $gRFRo.default)(CSSMotionList);
        function CSSMotionList() {
            var _this;
            (0, $3GVdq.default)(this, CSSMotionList);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            (0, $8K2NM.default)((0, $br3Qu.default)(_this), "state", {
                keyEntities: []
            });
            // ZombieJ: Return the count of rest keys. It's safe to refactor if need more info.
            (0, $8K2NM.default)((0, $br3Qu.default)(_this), "removeKey", function(removeKey) {
                _this.setState(function(prevState) {
                    var nextKeyEntities = prevState.keyEntities.map(function(entity) {
                        if (entity.key !== removeKey) return entity;
                        return (0, $lv6ip.default)((0, $lv6ip.default)({}, entity), {}, {
                            status: (0, $I9SrJ.STATUS_REMOVED)
                        });
                    });
                    return {
                        keyEntities: nextKeyEntities
                    };
                }, function() {
                    var keyEntities = _this.state.keyEntities;
                    var restKeysCount = keyEntities.filter(function(_ref) {
                        var status = _ref.status;
                        return status !== (0, $I9SrJ.STATUS_REMOVED);
                    }).length;
                    if (restKeysCount === 0 && _this.props.onAllRemoved) _this.props.onAllRemoved();
                });
            });
            return _this;
        }
        (0, $jj5jQ.default)(CSSMotionList, [
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    var keyEntities = this.state.keyEntities;
                    var _this$props = this.props, component = _this$props.component, children = _this$props.children, _onVisibleChanged = _this$props.onVisibleChanged, onAllRemoved = _this$props.onAllRemoved, restProps = (0, $ccQt4.default)(_this$props, $1da82831c0d5f5a9$var$_excluded);
                    var Component = component || $jbmdS.Fragment;
                    var motionProps = {};
                    $1da82831c0d5f5a9$var$MOTION_PROP_NAMES.forEach(function(prop) {
                        motionProps[prop] = restProps[prop];
                        delete restProps[prop];
                    });
                    delete restProps.keys;
                    return /*#__PURE__*/ $jbmdS.createElement(Component, restProps, keyEntities.map(function(_ref2, index) {
                        var status = _ref2.status, eventProps = (0, $ccQt4.default)(_ref2, $1da82831c0d5f5a9$var$_excluded2);
                        var visible = status === (0, $I9SrJ.STATUS_ADD) || status === (0, $I9SrJ.STATUS_KEEP);
                        return /*#__PURE__*/ $jbmdS.createElement(CSSMotion, (0, $7i29i.default)({}, motionProps, {
                            key: eventProps.key,
                            visible: visible,
                            eventProps: eventProps,
                            onVisibleChanged: function onVisibleChanged(changedVisible) {
                                _onVisibleChanged === null || _onVisibleChanged === void 0 || _onVisibleChanged(changedVisible, {
                                    key: eventProps.key
                                });
                                if (!changedVisible) _this2.removeKey(eventProps.key);
                            }
                        }), function(props, ref) {
                            return children((0, $lv6ip.default)((0, $lv6ip.default)({}, props), {}, {
                                index: index
                            }), ref);
                        });
                    }));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(_ref3, _ref4) {
                    var keys = _ref3.keys;
                    var keyEntities = _ref4.keyEntities;
                    var parsedKeyObjects = (0, $I9SrJ.parseKeys)(keys);
                    var mixedKeyEntities = (0, $I9SrJ.diffKeys)(keyEntities, parsedKeyObjects);
                    return {
                        keyEntities: mixedKeyEntities.filter(function(entity) {
                            var prevEntity = keyEntities.find(function(_ref5) {
                                var key = _ref5.key;
                                return entity.key === key;
                            });
                            // Remove if already mark as removed
                            if (prevEntity && prevEntity.status === (0, $I9SrJ.STATUS_REMOVED) && entity.status === (0, $I9SrJ.STATUS_REMOVE)) return false;
                            return true;
                        })
                    };
                }
            }
        ]);
        return CSSMotionList;
    }($jbmdS.Component);
    (0, $8K2NM.default)(CSSMotionList, "defaultProps", {
        component: "div"
    });
    return CSSMotionList;
}
var $1da82831c0d5f5a9$export$2e2bcd8739ae039 = $1da82831c0d5f5a9$export$fcfc62c1d33d5e2e((0, $7hUap.supportTransition));

});
parcelRegister("I9SrJ", function(module, exports) {

$parcel$export(module.exports, "STATUS_ADD", function () { return $084bc59314d9625e$export$3904baa009bc026e; });
$parcel$export(module.exports, "STATUS_KEEP", function () { return $084bc59314d9625e$export$851162f0adad2cbc; });
$parcel$export(module.exports, "STATUS_REMOVE", function () { return $084bc59314d9625e$export$c8b3fb08b68cfc85; });
$parcel$export(module.exports, "STATUS_REMOVED", function () { return $084bc59314d9625e$export$2ac1bd1808d2e43a; });
$parcel$export(module.exports, "parseKeys", function () { return $084bc59314d9625e$export$84bd7bd42ccc0f72; });
$parcel$export(module.exports, "diffKeys", function () { return $084bc59314d9625e$export$14527669107aa301; });

var $lv6ip = parcelRequire("lv6ip");

var $jncUt = parcelRequire("jncUt");
var $084bc59314d9625e$export$3904baa009bc026e = "add";
var $084bc59314d9625e$export$851162f0adad2cbc = "keep";
var $084bc59314d9625e$export$c8b3fb08b68cfc85 = "remove";
var $084bc59314d9625e$export$2ac1bd1808d2e43a = "removed";
function $084bc59314d9625e$export$c47fd798e598c85c(key) {
    var keyObj;
    if (key && (0, $jncUt.default)(key) === "object" && "key" in key) keyObj = key;
    else keyObj = {
        key: key
    };
    return (0, $lv6ip.default)((0, $lv6ip.default)({}, keyObj), {}, {
        key: String(keyObj.key)
    });
}
function $084bc59314d9625e$export$84bd7bd42ccc0f72() {
    var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return keys.map($084bc59314d9625e$export$c47fd798e598c85c);
}
function $084bc59314d9625e$export$14527669107aa301() {
    var prevKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var currentKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var list = [];
    var currentIndex = 0;
    var currentLen = currentKeys.length;
    var prevKeyObjects = $084bc59314d9625e$export$84bd7bd42ccc0f72(prevKeys);
    var currentKeyObjects = $084bc59314d9625e$export$84bd7bd42ccc0f72(currentKeys);
    // Check prev keys to insert or keep
    prevKeyObjects.forEach(function(keyObj) {
        var hit = false;
        for(var i = currentIndex; i < currentLen; i += 1){
            var currentKeyObj = currentKeyObjects[i];
            if (currentKeyObj.key === keyObj.key) {
                // New added keys should add before current key
                if (currentIndex < i) {
                    list = list.concat(currentKeyObjects.slice(currentIndex, i).map(function(obj) {
                        return (0, $lv6ip.default)((0, $lv6ip.default)({}, obj), {}, {
                            status: $084bc59314d9625e$export$3904baa009bc026e
                        });
                    }));
                    currentIndex = i;
                }
                list.push((0, $lv6ip.default)((0, $lv6ip.default)({}, currentKeyObj), {}, {
                    status: $084bc59314d9625e$export$851162f0adad2cbc
                }));
                currentIndex += 1;
                hit = true;
                break;
            }
        }
        // If not hit, it means key is removed
        if (!hit) list.push((0, $lv6ip.default)((0, $lv6ip.default)({}, keyObj), {}, {
            status: $084bc59314d9625e$export$c8b3fb08b68cfc85
        }));
    });
    // Add rest to the list
    if (currentIndex < currentLen) list = list.concat(currentKeyObjects.slice(currentIndex).map(function(obj) {
        return (0, $lv6ip.default)((0, $lv6ip.default)({}, obj), {}, {
            status: $084bc59314d9625e$export$3904baa009bc026e
        });
    }));
    /**
   * Merge same key when it remove and add again:
   *    [1 - add, 2 - keep, 1 - remove] -> [1 - keep, 2 - keep]
   */ var keys = {};
    list.forEach(function(_ref) {
        var key = _ref.key;
        keys[key] = (keys[key] || 0) + 1;
    });
    var duplicatedKeys = Object.keys(keys).filter(function(key) {
        return keys[key] > 1;
    });
    duplicatedKeys.forEach(function(matchKey) {
        // Remove `STATUS_REMOVE` node.
        list = list.filter(function(_ref2) {
            var key = _ref2.key, status = _ref2.status;
            return key !== matchKey || status !== $084bc59314d9625e$export$c8b3fb08b68cfc85;
        });
        // Update `STATUS_ADD` to `STATUS_KEEP`
        list.forEach(function(node) {
            if (node.key === matchKey) // eslint-disable-next-line no-param-reassign
            node.status = $084bc59314d9625e$export$851162f0adad2cbc;
        });
    });
    return list;
}

});



parcelRegister("7WElh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c8d3e4ca91b085d$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $8K2NM = parcelRequire("8K2NM");

var $3GVdq = parcelRequire("3GVdq");

var $jj5jQ = parcelRequire("jj5jQ");

var $1N4zm = parcelRequire("1N4zm");

var $gRFRo = parcelRequire("gRFRo");

var $jbmdS = parcelRequire("jbmdS");

var $jCNM0 = parcelRequire("jCNM0");

var $02LyB = parcelRequire("02LyB");
var $5c8d3e4ca91b085d$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, $1N4zm.default)(Notice, _Component);
    var _super = (0, $gRFRo.default)(Notice);
    function Notice() {
        var _this;
        (0, $3GVdq.default)(this, Notice);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.closeTimer = null;
        _this.close = function(e) {
            if (e) e.stopPropagation();
            _this.clearCloseTimer();
            var _this$props = _this.props, onClose = _this$props.onClose, noticeKey = _this$props.noticeKey;
            if (onClose) onClose(noticeKey);
        };
        _this.startCloseTimer = function() {
            if (_this.props.duration) _this.closeTimer = window.setTimeout(function() {
                _this.close();
            }, _this.props.duration * 1000);
        };
        _this.clearCloseTimer = function() {
            if (_this.closeTimer) {
                clearTimeout(_this.closeTimer);
                _this.closeTimer = null;
            }
        };
        return _this;
    }
    (0, $jj5jQ.default)(Notice, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startCloseTimer();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (this.props.duration !== prevProps.duration || this.props.updateMark !== prevProps.updateMark || // Visible again need reset timer
                this.props.visible !== prevProps.visible && this.props.visible) this.restartCloseTimer();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.clearCloseTimer();
            }
        },
        {
            key: "restartCloseTimer",
            value: function restartCloseTimer() {
                this.clearCloseTimer();
                this.startCloseTimer();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, prefixCls = _this$props2.prefixCls, className = _this$props2.className, closable = _this$props2.closable, closeIcon = _this$props2.closeIcon, style = _this$props2.style, onClick = _this$props2.onClick, children = _this$props2.children, holder = _this$props2.holder;
                var componentClass = "".concat(prefixCls, "-notice");
                var dataOrAriaAttributeProps = Object.keys(this.props).reduce(function(acc, key) {
                    if (key.substr(0, 5) === "data-" || key.substr(0, 5) === "aria-" || key === "role") acc[key] = _this2.props[key];
                    return acc;
                }, {});
                var node = /*#__PURE__*/ $jbmdS.createElement("div", (0, $7i29i.default)({
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(componentClass, className, (0, $8K2NM.default)({}, "".concat(componentClass, "-closable"), closable)),
                    style: style,
                    onMouseEnter: this.clearCloseTimer,
                    onMouseLeave: this.startCloseTimer,
                    onClick: onClick
                }, dataOrAriaAttributeProps), /*#__PURE__*/ $jbmdS.createElement("div", {
                    className: "".concat(componentClass, "-content")
                }, children), closable ? /*#__PURE__*/ $jbmdS.createElement("a", {
                    tabIndex: 0,
                    onClick: this.close,
                    className: "".concat(componentClass, "-close")
                }, closeIcon || /*#__PURE__*/ $jbmdS.createElement("span", {
                    className: "".concat(componentClass, "-close-x")
                })) : null);
                if (holder) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jCNM0))).createPortal(node, holder);
                return node;
            }
        }
    ]);
    return Notice;
}((0, $jbmdS.Component));
$5c8d3e4ca91b085d$export$2e2bcd8739ae039.defaultProps = {
    onClose: function onClose() {},
    duration: 1.5
};

});

parcelRegister("8TM7P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67a8ca73fd025da1$export$2e2bcd8739ae039; });

var $huwkX = parcelRequire("huwkX");

var $7i29i = parcelRequire("7i29i");

var $CZyex = parcelRequire("CZyex");

var $jbmdS = parcelRequire("jbmdS");

var $7WElh = parcelRequire("7WElh");
function $67a8ca73fd025da1$export$2e2bcd8739ae039(notificationInstance) {
    var createdRef = $jbmdS.useRef({});
    var _React$useState = $jbmdS.useState([]), _React$useState2 = (0, $CZyex.default)(_React$useState, 2), elements = _React$useState2[0], setElements = _React$useState2[1];
    function notify(noticeProps) {
        var firstMount = true;
        notificationInstance.add(noticeProps, function(div, props) {
            var key = props.key;
            if (div && (!createdRef.current[key] || firstMount)) {
                var noticeEle = /*#__PURE__*/ $jbmdS.createElement((0, $7WElh.default), (0, $7i29i.default)({}, props, {
                    holder: div
                }));
                createdRef.current[key] = noticeEle;
                setElements(function(originElements) {
                    var index = originElements.findIndex(function(ele) {
                        return ele.key === props.key;
                    });
                    if (index === -1) return [].concat((0, $huwkX.default)(originElements), [
                        noticeEle
                    ]);
                    var cloneList = (0, $huwkX.default)(originElements);
                    cloneList[index] = noticeEle;
                    return cloneList;
                });
            }
            firstMount = false;
        });
    }
    return [
        notify,
        /*#__PURE__*/ $jbmdS.createElement($jbmdS.Fragment, null, elements)
    ];
}

});



parcelRegister("gOp0Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3d4b83f0d15c906$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $CZyex = parcelRequire("CZyex");

var $8TM7P = parcelRequire("8TM7P");

var $jbmdS = parcelRequire("jbmdS");

var $d2T9p = parcelRequire("d2T9p");
parcelRequire("8uDri");
var $ewikT = parcelRequire("ewikT");
function $c3d4b83f0d15c906$export$2e2bcd8739ae039(getRcNotificationInstance, getRCNoticeProps) {
    var useMessage = function useMessage() {
        // We can only get content by render
        var getPrefixCls;
        var getPopupContainer;
        // We create a proxy to handle delay created instance
        var innerInstance = null;
        var proxy = {
            add: function add(noticeProps, holderCallback) {
                innerInstance === null || innerInstance === void 0 || innerInstance.component.add(noticeProps, holderCallback);
            }
        };
        var _useRCNotification = (0, $8TM7P.default)(proxy), _useRCNotification2 = (0, $CZyex.default)(_useRCNotification, 2), hookNotify = _useRCNotification2[0], holder = _useRCNotification2[1];
        function notify(args) {
            var customizePrefixCls = args.prefixCls;
            var mergedPrefixCls = getPrefixCls("message", customizePrefixCls);
            var rootPrefixCls = getPrefixCls();
            var target = args.key || (0, $d2T9p.getKeyThenIncreaseKey)();
            var closePromise = new Promise(function(resolve) {
                var callback = function callback() {
                    if (typeof args.onClose === "function") args.onClose();
                    return resolve(true);
                };
                getRcNotificationInstance((0, $7i29i.default)((0, $7i29i.default)({}, args), {
                    prefixCls: mergedPrefixCls,
                    rootPrefixCls: rootPrefixCls,
                    getPopupContainer: getPopupContainer
                }), function(_ref) {
                    var prefixCls = _ref.prefixCls, instance = _ref.instance;
                    innerInstance = instance;
                    hookNotify(getRCNoticeProps((0, $7i29i.default)((0, $7i29i.default)({}, args), {
                        key: target,
                        onClose: callback
                    }), prefixCls));
                });
            });
            var result = function result() {
                if (innerInstance) innerInstance.removeNotice(target);
            };
            result.then = function(filled, rejected) {
                return closePromise.then(filled, rejected);
            };
            result.promise = closePromise;
            return result;
        }
        // Fill functions
        var hookApiRef = $jbmdS.useRef({});
        hookApiRef.current.open = notify;
        (0, $d2T9p.typeList).forEach(function(type) {
            return (0, $d2T9p.attachTypeApi)(hookApiRef.current, type);
        });
        return [
            hookApiRef.current,
            /*#__PURE__*/ $jbmdS.createElement((0, $ewikT.ConfigConsumer), {
                key: "holder"
            }, function(context) {
                getPrefixCls = context.getPrefixCls;
                getPopupContainer = context.getPopupContainer;
                return holder;
            })
        ];
    };
    return useMessage;
}

});


parcelRegister("k5oMv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9f77f5bcbdb45d8$export$2e2bcd8739ae039; });

var $9TNqp = parcelRequire("9TNqp");

var $7i29i = parcelRequire("7i29i");

var $8K2NM = parcelRequire("8K2NM");

var $7oynS = parcelRequire("7oynS");

var $7zb1D = parcelRequire("7zb1D");

var $8u58w = parcelRequire("8u58w");

var $jcunH = parcelRequire("jcunH");

var $baxAi = parcelRequire("baxAi");

var $02LyB = parcelRequire("02LyB");

var $iJQYM = parcelRequire("iJQYM");

var $jbmdS = parcelRequire("jbmdS");

var $8uDri = parcelRequire("8uDri");

var $7H2k4 = parcelRequire("7H2k4");
var $e9f77f5bcbdb45d8$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $e9f77f5bcbdb45d8$var$notificationInstance = {};
var $e9f77f5bcbdb45d8$var$defaultDuration = 4.5;
var $e9f77f5bcbdb45d8$var$defaultTop = 24;
var $e9f77f5bcbdb45d8$var$defaultBottom = 24;
var $e9f77f5bcbdb45d8$var$defaultPrefixCls = "";
var $e9f77f5bcbdb45d8$var$defaultPlacement = "topRight";
var $e9f77f5bcbdb45d8$var$defaultGetContainer;
var $e9f77f5bcbdb45d8$var$defaultCloseIcon;
var $e9f77f5bcbdb45d8$var$rtl = false;
var $e9f77f5bcbdb45d8$var$maxCount;
function $e9f77f5bcbdb45d8$var$setNotificationConfig(options) {
    var duration = options.duration, placement = options.placement, bottom = options.bottom, top = options.top, getContainer = options.getContainer, closeIcon = options.closeIcon, prefixCls = options.prefixCls;
    if (prefixCls !== undefined) $e9f77f5bcbdb45d8$var$defaultPrefixCls = prefixCls;
    if (duration !== undefined) $e9f77f5bcbdb45d8$var$defaultDuration = duration;
    if (placement !== undefined) $e9f77f5bcbdb45d8$var$defaultPlacement = placement;
    else if (options.rtl) $e9f77f5bcbdb45d8$var$defaultPlacement = "topLeft";
    if (bottom !== undefined) $e9f77f5bcbdb45d8$var$defaultBottom = bottom;
    if (top !== undefined) $e9f77f5bcbdb45d8$var$defaultTop = top;
    if (getContainer !== undefined) $e9f77f5bcbdb45d8$var$defaultGetContainer = getContainer;
    if (closeIcon !== undefined) $e9f77f5bcbdb45d8$var$defaultCloseIcon = closeIcon;
    if (options.rtl !== undefined) $e9f77f5bcbdb45d8$var$rtl = options.rtl;
    if (options.maxCount !== undefined) $e9f77f5bcbdb45d8$var$maxCount = options.maxCount;
}
function $e9f77f5bcbdb45d8$var$getPlacementStyle(placement) {
    var top = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $e9f77f5bcbdb45d8$var$defaultTop;
    var bottom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $e9f77f5bcbdb45d8$var$defaultBottom;
    var style;
    switch(placement){
        case "top":
            style = {
                left: "50%",
                transform: "translateX(-50%)",
                right: "auto",
                top: top,
                bottom: "auto"
            };
            break;
        case "topLeft":
            style = {
                left: 0,
                top: top,
                bottom: "auto"
            };
            break;
        case "topRight":
            style = {
                right: 0,
                top: top,
                bottom: "auto"
            };
            break;
        case "bottom":
            style = {
                left: "50%",
                transform: "translateX(-50%)",
                right: "auto",
                top: "auto",
                bottom: bottom
            };
            break;
        case "bottomLeft":
            style = {
                left: 0,
                top: "auto",
                bottom: bottom
            };
            break;
        default:
            style = {
                right: 0,
                top: "auto",
                bottom: bottom
            };
            break;
    }
    return style;
}
function $e9f77f5bcbdb45d8$var$getNotificationInstance(args, callback) {
    var _args$placement = args.placement, placement = _args$placement === void 0 ? $e9f77f5bcbdb45d8$var$defaultPlacement : _args$placement, top = args.top, bottom = args.bottom, _args$getContainer = args.getContainer, getContainer = _args$getContainer === void 0 ? $e9f77f5bcbdb45d8$var$defaultGetContainer : _args$getContainer, customizePrefixCls = args.prefixCls;
    var _globalConfig = (0, $8uDri.globalConfig)(), getPrefixCls = _globalConfig.getPrefixCls, getIconPrefixCls = _globalConfig.getIconPrefixCls;
    var prefixCls = getPrefixCls("notification", customizePrefixCls || $e9f77f5bcbdb45d8$var$defaultPrefixCls);
    var iconPrefixCls = getIconPrefixCls();
    var cacheKey = "".concat(prefixCls, "-").concat(placement);
    var cacheInstance = $e9f77f5bcbdb45d8$var$notificationInstance[cacheKey];
    if (cacheInstance) {
        Promise.resolve(cacheInstance).then(function(instance) {
            callback({
                prefixCls: "".concat(prefixCls, "-notice"),
                iconPrefixCls: iconPrefixCls,
                instance: instance
            });
        });
        return;
    }
    var notificationClass = (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("".concat(prefixCls, "-").concat(placement), (0, $8K2NM.default)({}, "".concat(prefixCls, "-rtl"), $e9f77f5bcbdb45d8$var$rtl === true));
    $e9f77f5bcbdb45d8$var$notificationInstance[cacheKey] = new Promise(function(resolve) {
        (0, $iJQYM.default).newInstance({
            prefixCls: prefixCls,
            className: notificationClass,
            style: $e9f77f5bcbdb45d8$var$getPlacementStyle(placement, top, bottom),
            getContainer: getContainer,
            maxCount: $e9f77f5bcbdb45d8$var$maxCount
        }, function(notification) {
            resolve(notification);
            callback({
                prefixCls: "".concat(prefixCls, "-notice"),
                iconPrefixCls: iconPrefixCls,
                instance: notification
            });
        });
    });
}
var $e9f77f5bcbdb45d8$var$typeToIcon = {
    success: (0, $7oynS.default),
    info: (0, $baxAi.default),
    error: (0, $7zb1D.default),
    warning: (0, $jcunH.default)
};
function $e9f77f5bcbdb45d8$var$getRCNoticeProps(args, prefixCls, iconPrefixCls) {
    var durationArg = args.duration, icon = args.icon, type = args.type, description = args.description, message = args.message, btn = args.btn, onClose = args.onClose, onClick = args.onClick, key = args.key, style = args.style, className = args.className, _args$closeIcon = args.closeIcon, closeIcon = _args$closeIcon === void 0 ? $e9f77f5bcbdb45d8$var$defaultCloseIcon : _args$closeIcon, props = args.props;
    var duration = durationArg === undefined ? $e9f77f5bcbdb45d8$var$defaultDuration : durationArg;
    var iconNode = null;
    if (icon) iconNode = /*#__PURE__*/ $jbmdS.createElement("span", {
        className: "".concat(prefixCls, "-icon")
    }, args.icon);
    else if (type) iconNode = /*#__PURE__*/ $jbmdS.createElement($e9f77f5bcbdb45d8$var$typeToIcon[type] || null, {
        className: "".concat(prefixCls, "-icon ").concat(prefixCls, "-icon-").concat(type)
    });
    var closeIconToRender = typeof closeIcon === "undefined" ? /*#__PURE__*/ $jbmdS.createElement("span", {
        className: "".concat(prefixCls, "-close-x")
    }, /*#__PURE__*/ $jbmdS.createElement((0, $8u58w.default), {
        className: "".concat(prefixCls, "-close-icon")
    })) : closeIcon;
    var autoMarginTag = !description && iconNode ? /*#__PURE__*/ $jbmdS.createElement("span", {
        className: "".concat(prefixCls, "-message-single-line-auto-margin")
    }) : null;
    return {
        content: /*#__PURE__*/ $jbmdS.createElement((0, $8uDri.default), {
            iconPrefixCls: iconPrefixCls
        }, /*#__PURE__*/ $jbmdS.createElement("div", {
            className: iconNode ? "".concat(prefixCls, "-with-icon") : "",
            role: "alert"
        }, iconNode, /*#__PURE__*/ $jbmdS.createElement("div", {
            className: "".concat(prefixCls, "-message")
        }, autoMarginTag, message), /*#__PURE__*/ $jbmdS.createElement("div", {
            className: "".concat(prefixCls, "-description")
        }, description), btn ? /*#__PURE__*/ $jbmdS.createElement("span", {
            className: "".concat(prefixCls, "-btn")
        }, btn) : null)),
        duration: duration,
        closable: true,
        closeIcon: closeIconToRender,
        onClose: onClose,
        onClick: onClick,
        key: key,
        style: style || {},
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(className, (0, $8K2NM.default)({}, "".concat(prefixCls, "-").concat(type), !!type)),
        props: props
    };
}
function $e9f77f5bcbdb45d8$var$notice(args) {
    $e9f77f5bcbdb45d8$var$getNotificationInstance(args, function(_ref) {
        var prefixCls = _ref.prefixCls, iconPrefixCls = _ref.iconPrefixCls, instance = _ref.instance;
        instance.notice($e9f77f5bcbdb45d8$var$getRCNoticeProps(args, prefixCls, iconPrefixCls));
    });
}
var $e9f77f5bcbdb45d8$var$api = {
    open: $e9f77f5bcbdb45d8$var$notice,
    close: function close(key) {
        Object.keys($e9f77f5bcbdb45d8$var$notificationInstance).forEach(function(cacheKey) {
            return Promise.resolve($e9f77f5bcbdb45d8$var$notificationInstance[cacheKey]).then(function(instance) {
                instance.removeNotice(key);
            });
        });
    },
    config: $e9f77f5bcbdb45d8$var$setNotificationConfig,
    destroy: function destroy() {
        Object.keys($e9f77f5bcbdb45d8$var$notificationInstance).forEach(function(cacheKey) {
            Promise.resolve($e9f77f5bcbdb45d8$var$notificationInstance[cacheKey]).then(function(instance) {
                instance.destroy();
            });
            delete $e9f77f5bcbdb45d8$var$notificationInstance[cacheKey]; // lgtm[js/missing-await]
        });
    }
};
[
    "success",
    "info",
    "warning",
    "error"
].forEach(function(type) {
    $e9f77f5bcbdb45d8$var$api[type] = function(args) {
        return $e9f77f5bcbdb45d8$var$api.open((0, $7i29i.default)((0, $7i29i.default)({}, args), {
            type: type
        }));
    };
});
$e9f77f5bcbdb45d8$var$api.warn = $e9f77f5bcbdb45d8$var$api.warning;
$e9f77f5bcbdb45d8$var$api.useNotification = (0, $7H2k4.default)($e9f77f5bcbdb45d8$var$getNotificationInstance, $e9f77f5bcbdb45d8$var$getRCNoticeProps);
var $e9f77f5bcbdb45d8$export$8bedcca5bbd73999 = function getInstance(cacheKey) {
    return $e9f77f5bcbdb45d8$var$__awaiter(void 0, void 0, void 0, /*#__PURE__*/ (0, $9TNqp.default)().mark(function _callee() {
        return (0, $9TNqp.default)().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    return _context.abrupt("return", null);
                case 1:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
};
var $e9f77f5bcbdb45d8$export$2e2bcd8739ae039 = $e9f77f5bcbdb45d8$var$api;

});
parcelRegister("7oynS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56257240d29e5bcc$export$2e2bcd8739ae039; });

var $lv6ip = parcelRequire("lv6ip");

var $jbmdS = parcelRequire("jbmdS");

var $kG1dv = parcelRequire("kG1dv");

var $4hKc4 = parcelRequire("4hKc4");
var $56257240d29e5bcc$var$CheckCircleOutlined = function CheckCircleOutlined(props, ref) {
    return /*#__PURE__*/ $jbmdS.createElement((0, $4hKc4.default), (0, $lv6ip.default)((0, $lv6ip.default)({}, props), {}, {
        ref: ref,
        icon: (0, $kG1dv.default)
    }));
};
var $56257240d29e5bcc$var$RefIcon = /*#__PURE__*/ $jbmdS.forwardRef($56257240d29e5bcc$var$CheckCircleOutlined);
var $56257240d29e5bcc$export$2e2bcd8739ae039 = $56257240d29e5bcc$var$RefIcon;

});
parcelRegister("kG1dv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0d8ac88a1069169$export$2e2bcd8739ae039; });
// This icon file is generated automatically.
var $f0d8ac88a1069169$var$CheckCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0051.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            }
        ]
    },
    "name": "check-circle",
    "theme": "outlined"
};
var $f0d8ac88a1069169$export$2e2bcd8739ae039 = $f0d8ac88a1069169$var$CheckCircleOutlined;

});


parcelRegister("7zb1D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58245aac4d4c1344$export$2e2bcd8739ae039; });

var $lv6ip = parcelRequire("lv6ip");

var $jbmdS = parcelRequire("jbmdS");

var $ktWE8 = parcelRequire("ktWE8");

var $4hKc4 = parcelRequire("4hKc4");
var $58245aac4d4c1344$var$CloseCircleOutlined = function CloseCircleOutlined(props, ref) {
    return /*#__PURE__*/ $jbmdS.createElement((0, $4hKc4.default), (0, $lv6ip.default)((0, $lv6ip.default)({}, props), {}, {
        ref: ref,
        icon: (0, $ktWE8.default)
    }));
};
var $58245aac4d4c1344$var$RefIcon = /*#__PURE__*/ $jbmdS.forwardRef($58245aac4d4c1344$var$CloseCircleOutlined);
var $58245aac4d4c1344$export$2e2bcd8739ae039 = $58245aac4d4c1344$var$RefIcon;

});
parcelRegister("ktWE8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee940204a399d6fa$export$2e2bcd8739ae039; });
// This icon file is generated automatically.
var $ee940204a399d6fa$var$CloseCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm0 76c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm128.01 198.83c.03 0 .05.01.09.06l45.02 45.01a.2.2 0 01.05.09.12.12 0 010 .07c0 .02-.01.04-.05.08L557.25 512l127.87 127.86a.27.27 0 01.05.06v.02a.12.12 0 010 .07c0 .03-.01.05-.05.09l-45.02 45.02a.2.2 0 01-.09.05.12.12 0 01-.07 0c-.02 0-.04-.01-.08-.05L512 557.25 384.14 685.12c-.04.04-.06.05-.08.05a.12.12 0 01-.07 0c-.03 0-.05-.01-.09-.05l-45.02-45.02a.2.2 0 01-.05-.09.12.12 0 010-.07c0-.02.01-.04.06-.08L466.75 512 338.88 384.14a.27.27 0 01-.05-.06l-.01-.02a.12.12 0 010-.07c0-.03.01-.05.05-.09l45.02-45.02a.2.2 0 01.09-.05.12.12 0 01.07 0c.02 0 .04.01.08.06L512 466.75l127.86-127.86c.04-.05.06-.06.08-.06a.12.12 0 01.07 0z"
                }
            }
        ]
    },
    "name": "close-circle",
    "theme": "outlined"
};
var $ee940204a399d6fa$export$2e2bcd8739ae039 = $ee940204a399d6fa$var$CloseCircleOutlined;

});


parcelRegister("8u58w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62d51c16a4da7f17$export$2e2bcd8739ae039; });

var $lv6ip = parcelRequire("lv6ip");

var $jbmdS = parcelRequire("jbmdS");

var $bsizp = parcelRequire("bsizp");

var $4hKc4 = parcelRequire("4hKc4");
var $62d51c16a4da7f17$var$CloseOutlined = function CloseOutlined(props, ref) {
    return /*#__PURE__*/ $jbmdS.createElement((0, $4hKc4.default), (0, $lv6ip.default)((0, $lv6ip.default)({}, props), {}, {
        ref: ref,
        icon: (0, $bsizp.default)
    }));
};
var $62d51c16a4da7f17$var$RefIcon = /*#__PURE__*/ $jbmdS.forwardRef($62d51c16a4da7f17$var$CloseOutlined);
var $62d51c16a4da7f17$export$2e2bcd8739ae039 = $62d51c16a4da7f17$var$RefIcon;

});
parcelRegister("bsizp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8570b6de9d9d9b92$export$2e2bcd8739ae039; });
// This icon file is generated automatically.
var $8570b6de9d9d9b92$var$CloseOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z"
                }
            }
        ]
    },
    "name": "close",
    "theme": "outlined"
};
var $8570b6de9d9d9b92$export$2e2bcd8739ae039 = $8570b6de9d9d9b92$var$CloseOutlined;

});


parcelRegister("jcunH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dfa6b467eacb0dc6$export$2e2bcd8739ae039; });

var $lv6ip = parcelRequire("lv6ip");

var $jbmdS = parcelRequire("jbmdS");

var $4Q2DA = parcelRequire("4Q2DA");

var $4hKc4 = parcelRequire("4hKc4");
var $dfa6b467eacb0dc6$var$ExclamationCircleOutlined = function ExclamationCircleOutlined(props, ref) {
    return /*#__PURE__*/ $jbmdS.createElement((0, $4hKc4.default), (0, $lv6ip.default)((0, $lv6ip.default)({}, props), {}, {
        ref: ref,
        icon: (0, $4Q2DA.default)
    }));
};
var $dfa6b467eacb0dc6$var$RefIcon = /*#__PURE__*/ $jbmdS.forwardRef($dfa6b467eacb0dc6$var$ExclamationCircleOutlined);
var $dfa6b467eacb0dc6$export$2e2bcd8739ae039 = $dfa6b467eacb0dc6$var$RefIcon;

});
parcelRegister("4Q2DA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $385e10877bb43393$export$2e2bcd8739ae039; });
// This icon file is generated automatically.
var $385e10877bb43393$var$ExclamationCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M464 688a48 48 0 1096 0 48 48 0 10-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    },
    "name": "exclamation-circle",
    "theme": "outlined"
};
var $385e10877bb43393$export$2e2bcd8739ae039 = $385e10877bb43393$var$ExclamationCircleOutlined;

});


parcelRegister("baxAi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $821aae0697bc40e4$export$2e2bcd8739ae039; });

var $lv6ip = parcelRequire("lv6ip");

var $jbmdS = parcelRequire("jbmdS");

var $fngdS = parcelRequire("fngdS");

var $4hKc4 = parcelRequire("4hKc4");
var $821aae0697bc40e4$var$InfoCircleOutlined = function InfoCircleOutlined(props, ref) {
    return /*#__PURE__*/ $jbmdS.createElement((0, $4hKc4.default), (0, $lv6ip.default)((0, $lv6ip.default)({}, props), {}, {
        ref: ref,
        icon: (0, $fngdS.default)
    }));
};
var $821aae0697bc40e4$var$RefIcon = /*#__PURE__*/ $jbmdS.forwardRef($821aae0697bc40e4$var$InfoCircleOutlined);
var $821aae0697bc40e4$export$2e2bcd8739ae039 = $821aae0697bc40e4$var$RefIcon;

});
parcelRegister("fngdS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b315967fba5cbb4c$export$2e2bcd8739ae039; });
// This icon file is generated automatically.
var $b315967fba5cbb4c$var$InfoCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "info-circle",
    "theme": "outlined"
};
var $b315967fba5cbb4c$export$2e2bcd8739ae039 = $b315967fba5cbb4c$var$InfoCircleOutlined;

});


parcelRegister("7H2k4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $599e59cdec5a0547$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $CZyex = parcelRequire("CZyex");

var $8TM7P = parcelRequire("8TM7P");

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("8uDri");
var $ewikT = parcelRequire("ewikT");
function $599e59cdec5a0547$export$2e2bcd8739ae039(getNotificationInstance, getRCNoticeProps) {
    var useNotification = function useNotification() {
        // We can only get content by render
        var getPrefixCls;
        // We create a proxy to handle delay created instance
        var innerInstance = null;
        var proxy = {
            add: function add(noticeProps, holderCallback) {
                innerInstance === null || innerInstance === void 0 || innerInstance.component.add(noticeProps, holderCallback);
            }
        };
        var _useRCNotification = (0, $8TM7P.default)(proxy), _useRCNotification2 = (0, $CZyex.default)(_useRCNotification, 2), hookNotify = _useRCNotification2[0], holder = _useRCNotification2[1];
        function notify(args) {
            var customizePrefixCls = args.prefixCls;
            var mergedPrefixCls = getPrefixCls("notification", customizePrefixCls);
            getNotificationInstance((0, $7i29i.default)((0, $7i29i.default)({}, args), {
                prefixCls: mergedPrefixCls
            }), function(_ref) {
                var prefixCls = _ref.prefixCls, instance = _ref.instance;
                innerInstance = instance;
                hookNotify(getRCNoticeProps(args, prefixCls));
            });
        }
        // Fill functions
        var hookApiRef = $jbmdS.useRef({});
        hookApiRef.current.open = notify;
        [
            "success",
            "info",
            "warning",
            "error"
        ].forEach(function(type) {
            hookApiRef.current[type] = function(args) {
                return hookApiRef.current.open((0, $7i29i.default)((0, $7i29i.default)({}, args), {
                    type: type
                }));
            };
        });
        return [
            hookApiRef.current,
            /*#__PURE__*/ $jbmdS.createElement((0, $ewikT.ConfigConsumer), {
                key: "holder"
            }, function(context) {
                getPrefixCls = context.getPrefixCls;
                return holder;
            })
        ];
    };
    return useNotification;
}

});


parcelRegister("ewikT", function(module, exports) {

$parcel$export(module.exports, "ConfigContext", function () { return $a92246fecb76a906$export$a92f85ab3e9ad68b; });
$parcel$export(module.exports, "ConfigConsumer", function () { return $a92246fecb76a906$export$cd5442f2b8da7663; });

var $7i29i = parcelRequire("7i29i");

var $jbmdS = parcelRequire("jbmdS");
var $a92246fecb76a906$var$defaultGetPrefixCls = function defaultGetPrefixCls(suffixCls, customizePrefixCls) {
    if (customizePrefixCls) return customizePrefixCls;
    return suffixCls ? "ant-".concat(suffixCls) : "ant";
};
var $a92246fecb76a906$export$a92f85ab3e9ad68b = /*#__PURE__*/ $jbmdS.createContext({
    // We provide a default function for Context without provider
    getPrefixCls: $a92246fecb76a906$var$defaultGetPrefixCls
});
var $a92246fecb76a906$export$cd5442f2b8da7663 = $a92246fecb76a906$export$a92f85ab3e9ad68b.Consumer;
function $a92246fecb76a906$export$ac719629fc076fcb(config) {
    return function withConfigConsumerFunc(Component) {
        // Wrap with ConfigConsumer. Since we need compatible with react 15, be care when using ref methods
        var SFC = function SFC(props) {
            return /*#__PURE__*/ $jbmdS.createElement($a92246fecb76a906$export$cd5442f2b8da7663, null, function(configProps) {
                var basicPrefixCls = config.prefixCls;
                var getPrefixCls = configProps.getPrefixCls;
                var customizePrefixCls = props.prefixCls;
                var prefixCls = getPrefixCls(basicPrefixCls, customizePrefixCls);
                return /*#__PURE__*/ $jbmdS.createElement(Component, (0, $7i29i.default)({}, configProps, props, {
                    prefixCls: prefixCls
                }));
            });
        };
        var cons = Component.constructor;
        var name = cons && cons.displayName || Component.name || "Component";
        return SFC;
    };
}

});

parcelRegister("6fsb1", function(module, exports) {

$parcel$export(module.exports, "registerTheme", function () { return $48ca001da3e9601d$export$f9c59eed5de5ff80; });
/* eslint-disable import/prefer-default-export, prefer-destructuring */ 
var $jROxP = parcelRequire("jROxP");

var $8UjT2 = parcelRequire("8UjT2");

var $gnP4S = parcelRequire("gnP4S");

var $kNt4K = parcelRequire("kNt4K");

var $48ca001da3e9601d$var$dynamicStyleMark = "-ant-".concat(Date.now(), "-").concat(Math.random());
function $48ca001da3e9601d$export$3d2f074408bd1b82(globalPrefixCls, theme) {
    var variables = {};
    var formatColor = function formatColor(color, updater) {
        var clone = color.clone();
        clone = (updater === null || updater === void 0 ? void 0 : updater(clone)) || clone;
        return clone.toRgbString();
    };
    var fillColor = function fillColor(colorVal, type) {
        var baseColor = new (0, $8UjT2.TinyColor)(colorVal);
        var colorPalettes = (0, $jROxP.generate)(baseColor.toRgbString());
        variables["".concat(type, "-color")] = formatColor(baseColor);
        variables["".concat(type, "-color-disabled")] = colorPalettes[1];
        variables["".concat(type, "-color-hover")] = colorPalettes[4];
        variables["".concat(type, "-color-active")] = colorPalettes[6];
        variables["".concat(type, "-color-outline")] = baseColor.clone().setAlpha(0.2).toRgbString();
        variables["".concat(type, "-color-deprecated-bg")] = colorPalettes[0];
        variables["".concat(type, "-color-deprecated-border")] = colorPalettes[2];
    };
    // ================ Primary Color ================
    if (theme.primaryColor) {
        fillColor(theme.primaryColor, "primary");
        var primaryColor = new (0, $8UjT2.TinyColor)(theme.primaryColor);
        var primaryColors = (0, $jROxP.generate)(primaryColor.toRgbString());
        // Legacy - We should use semantic naming standard
        primaryColors.forEach(function(color, index) {
            variables["primary-".concat(index + 1)] = color;
        });
        // Deprecated
        variables["primary-color-deprecated-l-35"] = formatColor(primaryColor, function(c) {
            return c.lighten(35);
        });
        variables["primary-color-deprecated-l-20"] = formatColor(primaryColor, function(c) {
            return c.lighten(20);
        });
        variables["primary-color-deprecated-t-20"] = formatColor(primaryColor, function(c) {
            return c.tint(20);
        });
        variables["primary-color-deprecated-t-50"] = formatColor(primaryColor, function(c) {
            return c.tint(50);
        });
        variables["primary-color-deprecated-f-12"] = formatColor(primaryColor, function(c) {
            return c.setAlpha(c.getAlpha() * 0.12);
        });
        var primaryActiveColor = new (0, $8UjT2.TinyColor)(primaryColors[0]);
        variables["primary-color-active-deprecated-f-30"] = formatColor(primaryActiveColor, function(c) {
            return c.setAlpha(c.getAlpha() * 0.3);
        });
        variables["primary-color-active-deprecated-d-02"] = formatColor(primaryActiveColor, function(c) {
            return c.darken(2);
        });
    }
    // ================ Success Color ================
    if (theme.successColor) fillColor(theme.successColor, "success");
    // ================ Warning Color ================
    if (theme.warningColor) fillColor(theme.warningColor, "warning");
    // ================= Error Color =================
    if (theme.errorColor) fillColor(theme.errorColor, "error");
    // ================= Info Color ==================
    if (theme.infoColor) fillColor(theme.infoColor, "info");
    // Convert to css variables
    var cssList = Object.keys(variables).map(function(key) {
        return "--".concat(globalPrefixCls, "-").concat(key, ": ").concat(variables[key], ";");
    });
    return "\n  :root {\n    ".concat(cssList.join("\n"), "\n  }\n  ").trim();
}
function $48ca001da3e9601d$export$f9c59eed5de5ff80(globalPrefixCls, theme) {
    var style = $48ca001da3e9601d$export$3d2f074408bd1b82(globalPrefixCls, theme);
    if ((0, $gnP4S.default)()) (0, $kNt4K.updateCSS)(style, "".concat($48ca001da3e9601d$var$dynamicStyleMark, "-dynamic-theme"));
}

});
parcelRegister("8UjT2", function(module, exports) {

$parcel$export(module.exports, "TinyColor", function () { return $67c2facb7a96d7bf$export$d850312fc213f33e; });

var $grUmi = parcelRequire("grUmi");

var $purGc = parcelRequire("purGc");

var $2SfD2 = parcelRequire("2SfD2");

var $3j2oj = parcelRequire("3j2oj");
var $67c2facb7a96d7bf$export$d850312fc213f33e = /** @class */ function() {
    function TinyColor(color, opts) {
        if (color === void 0) color = "";
        if (opts === void 0) opts = {};
        var _a;
        // If input is already a tinycolor, return itself
        if (color instanceof TinyColor) // eslint-disable-next-line no-constructor-return
        return color;
        if (typeof color === "number") color = (0, $grUmi.numberInputToObject)(color);
        this.originalInput = color;
        var rgb = (0, $2SfD2.inputToRGB)(color);
        this.originalInput = color;
        this.r = rgb.r;
        this.g = rgb.g;
        this.b = rgb.b;
        this.a = rgb.a;
        this.roundA = Math.round(100 * this.a) / 100;
        this.format = (_a = opts.format) !== null && _a !== void 0 ? _a : rgb.format;
        this.gradientType = opts.gradientType;
        // Don't let the range of [0,255] come back in [0,1].
        // Potentially lose a little bit of precision here, but will fix issues where
        // .5 gets interpreted as half of the total, instead of half of 1
        // If it was supposed to be 128, this was already taken care of by `inputToRgb`
        if (this.r < 1) this.r = Math.round(this.r);
        if (this.g < 1) this.g = Math.round(this.g);
        if (this.b < 1) this.b = Math.round(this.b);
        this.isValid = rgb.ok;
    }
    TinyColor.prototype.isDark = function() {
        return this.getBrightness() < 128;
    };
    TinyColor.prototype.isLight = function() {
        return !this.isDark();
    };
    /**
     * Returns the perceived brightness of the color, from 0-255.
     */ TinyColor.prototype.getBrightness = function() {
        // http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    };
    /**
     * Returns the perceived luminance of a color, from 0-1.
     */ TinyColor.prototype.getLuminance = function() {
        // http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var R;
        var G;
        var B;
        var RsRGB = rgb.r / 255;
        var GsRGB = rgb.g / 255;
        var BsRGB = rgb.b / 255;
        if (RsRGB <= 0.03928) R = RsRGB / 12.92;
        else // eslint-disable-next-line prefer-exponentiation-operator
        R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
        if (GsRGB <= 0.03928) G = GsRGB / 12.92;
        else // eslint-disable-next-line prefer-exponentiation-operator
        G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
        if (BsRGB <= 0.03928) B = BsRGB / 12.92;
        else // eslint-disable-next-line prefer-exponentiation-operator
        B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
        return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    };
    /**
     * Returns the alpha value of a color, from 0-1.
     */ TinyColor.prototype.getAlpha = function() {
        return this.a;
    };
    /**
     * Sets the alpha value on the current color.
     *
     * @param alpha - The new alpha value. The accepted range is 0-1.
     */ TinyColor.prototype.setAlpha = function(alpha) {
        this.a = (0, $3j2oj.boundAlpha)(alpha);
        this.roundA = Math.round(100 * this.a) / 100;
        return this;
    };
    /**
     * Returns whether the color is monochrome.
     */ TinyColor.prototype.isMonochrome = function() {
        var s = this.toHsl().s;
        return s === 0;
    };
    /**
     * Returns the object as a HSVA object.
     */ TinyColor.prototype.toHsv = function() {
        var hsv = (0, $grUmi.rgbToHsv)(this.r, this.g, this.b);
        return {
            h: hsv.h * 360,
            s: hsv.s,
            v: hsv.v,
            a: this.a
        };
    };
    /**
     * Returns the hsva values interpolated into a string with the following format:
     * "hsva(xxx, xxx, xxx, xx)".
     */ TinyColor.prototype.toHsvString = function() {
        var hsv = (0, $grUmi.rgbToHsv)(this.r, this.g, this.b);
        var h = Math.round(hsv.h * 360);
        var s = Math.round(hsv.s * 100);
        var v = Math.round(hsv.v * 100);
        return this.a === 1 ? "hsv(".concat(h, ", ").concat(s, "%, ").concat(v, "%)") : "hsva(".concat(h, ", ").concat(s, "%, ").concat(v, "%, ").concat(this.roundA, ")");
    };
    /**
     * Returns the object as a HSLA object.
     */ TinyColor.prototype.toHsl = function() {
        var hsl = (0, $grUmi.rgbToHsl)(this.r, this.g, this.b);
        return {
            h: hsl.h * 360,
            s: hsl.s,
            l: hsl.l,
            a: this.a
        };
    };
    /**
     * Returns the hsla values interpolated into a string with the following format:
     * "hsla(xxx, xxx, xxx, xx)".
     */ TinyColor.prototype.toHslString = function() {
        var hsl = (0, $grUmi.rgbToHsl)(this.r, this.g, this.b);
        var h = Math.round(hsl.h * 360);
        var s = Math.round(hsl.s * 100);
        var l = Math.round(hsl.l * 100);
        return this.a === 1 ? "hsl(".concat(h, ", ").concat(s, "%, ").concat(l, "%)") : "hsla(".concat(h, ", ").concat(s, "%, ").concat(l, "%, ").concat(this.roundA, ")");
    };
    /**
     * Returns the hex value of the color.
     * @param allow3Char will shorten hex value to 3 char if possible
     */ TinyColor.prototype.toHex = function(allow3Char) {
        if (allow3Char === void 0) allow3Char = false;
        return (0, $grUmi.rgbToHex)(this.r, this.g, this.b, allow3Char);
    };
    /**
     * Returns the hex value of the color -with a # prefixed.
     * @param allow3Char will shorten hex value to 3 char if possible
     */ TinyColor.prototype.toHexString = function(allow3Char) {
        if (allow3Char === void 0) allow3Char = false;
        return "#" + this.toHex(allow3Char);
    };
    /**
     * Returns the hex 8 value of the color.
     * @param allow4Char will shorten hex value to 4 char if possible
     */ TinyColor.prototype.toHex8 = function(allow4Char) {
        if (allow4Char === void 0) allow4Char = false;
        return (0, $grUmi.rgbaToHex)(this.r, this.g, this.b, this.a, allow4Char);
    };
    /**
     * Returns the hex 8 value of the color -with a # prefixed.
     * @param allow4Char will shorten hex value to 4 char if possible
     */ TinyColor.prototype.toHex8String = function(allow4Char) {
        if (allow4Char === void 0) allow4Char = false;
        return "#" + this.toHex8(allow4Char);
    };
    /**
     * Returns the shorter hex value of the color depends on its alpha -with a # prefixed.
     * @param allowShortChar will shorten hex value to 3 or 4 char if possible
     */ TinyColor.prototype.toHexShortString = function(allowShortChar) {
        if (allowShortChar === void 0) allowShortChar = false;
        return this.a === 1 ? this.toHexString(allowShortChar) : this.toHex8String(allowShortChar);
    };
    /**
     * Returns the object as a RGBA object.
     */ TinyColor.prototype.toRgb = function() {
        return {
            r: Math.round(this.r),
            g: Math.round(this.g),
            b: Math.round(this.b),
            a: this.a
        };
    };
    /**
     * Returns the RGBA values interpolated into a string with the following format:
     * "RGBA(xxx, xxx, xxx, xx)".
     */ TinyColor.prototype.toRgbString = function() {
        var r = Math.round(this.r);
        var g = Math.round(this.g);
        var b = Math.round(this.b);
        return this.a === 1 ? "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")") : "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(this.roundA, ")");
    };
    /**
     * Returns the object as a RGBA object.
     */ TinyColor.prototype.toPercentageRgb = function() {
        var fmt = function(x) {
            return "".concat(Math.round((0, $3j2oj.bound01)(x, 255) * 100), "%");
        };
        return {
            r: fmt(this.r),
            g: fmt(this.g),
            b: fmt(this.b),
            a: this.a
        };
    };
    /**
     * Returns the RGBA relative values interpolated into a string
     */ TinyColor.prototype.toPercentageRgbString = function() {
        var rnd = function(x) {
            return Math.round((0, $3j2oj.bound01)(x, 255) * 100);
        };
        return this.a === 1 ? "rgb(".concat(rnd(this.r), "%, ").concat(rnd(this.g), "%, ").concat(rnd(this.b), "%)") : "rgba(".concat(rnd(this.r), "%, ").concat(rnd(this.g), "%, ").concat(rnd(this.b), "%, ").concat(this.roundA, ")");
    };
    /**
     * The 'real' name of the color -if there is one.
     */ TinyColor.prototype.toName = function() {
        if (this.a === 0) return "transparent";
        if (this.a < 1) return false;
        var hex = "#" + (0, $grUmi.rgbToHex)(this.r, this.g, this.b, false);
        for(var _i = 0, _a = Object.entries((0, $purGc.names)); _i < _a.length; _i++){
            var _b = _a[_i], key = _b[0], value = _b[1];
            if (hex === value) return key;
        }
        return false;
    };
    TinyColor.prototype.toString = function(format) {
        var formatSet = Boolean(format);
        format = format !== null && format !== void 0 ? format : this.format;
        var formattedString = false;
        var hasAlpha = this.a < 1 && this.a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format.startsWith("hex") || format === "name");
        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === "name" && this.a === 0) return this.toName();
            return this.toRgbString();
        }
        if (format === "rgb") formattedString = this.toRgbString();
        if (format === "prgb") formattedString = this.toPercentageRgbString();
        if (format === "hex" || format === "hex6") formattedString = this.toHexString();
        if (format === "hex3") formattedString = this.toHexString(true);
        if (format === "hex4") formattedString = this.toHex8String(true);
        if (format === "hex8") formattedString = this.toHex8String();
        if (format === "name") formattedString = this.toName();
        if (format === "hsl") formattedString = this.toHslString();
        if (format === "hsv") formattedString = this.toHsvString();
        return formattedString || this.toHexString();
    };
    TinyColor.prototype.toNumber = function() {
        return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
    };
    TinyColor.prototype.clone = function() {
        return new TinyColor(this.toString());
    };
    /**
     * Lighten the color a given amount. Providing 100 will always return white.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.lighten = function(amount) {
        if (amount === void 0) amount = 10;
        var hsl = this.toHsl();
        hsl.l += amount / 100;
        hsl.l = (0, $3j2oj.clamp01)(hsl.l);
        return new TinyColor(hsl);
    };
    /**
     * Brighten the color a given amount, from 0 to 100.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.brighten = function(amount) {
        if (amount === void 0) amount = 10;
        var rgb = this.toRgb();
        rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
        rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
        rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
        return new TinyColor(rgb);
    };
    /**
     * Darken the color a given amount, from 0 to 100.
     * Providing 100 will always return black.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.darken = function(amount) {
        if (amount === void 0) amount = 10;
        var hsl = this.toHsl();
        hsl.l -= amount / 100;
        hsl.l = (0, $3j2oj.clamp01)(hsl.l);
        return new TinyColor(hsl);
    };
    /**
     * Mix the color with pure white, from 0 to 100.
     * Providing 0 will do nothing, providing 100 will always return white.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.tint = function(amount) {
        if (amount === void 0) amount = 10;
        return this.mix("white", amount);
    };
    /**
     * Mix the color with pure black, from 0 to 100.
     * Providing 0 will do nothing, providing 100 will always return black.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.shade = function(amount) {
        if (amount === void 0) amount = 10;
        return this.mix("black", amount);
    };
    /**
     * Desaturate the color a given amount, from 0 to 100.
     * Providing 100 will is the same as calling greyscale
     * @param amount - valid between 1-100
     */ TinyColor.prototype.desaturate = function(amount) {
        if (amount === void 0) amount = 10;
        var hsl = this.toHsl();
        hsl.s -= amount / 100;
        hsl.s = (0, $3j2oj.clamp01)(hsl.s);
        return new TinyColor(hsl);
    };
    /**
     * Saturate the color a given amount, from 0 to 100.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.saturate = function(amount) {
        if (amount === void 0) amount = 10;
        var hsl = this.toHsl();
        hsl.s += amount / 100;
        hsl.s = (0, $3j2oj.clamp01)(hsl.s);
        return new TinyColor(hsl);
    };
    /**
     * Completely desaturates a color into greyscale.
     * Same as calling `desaturate(100)`
     */ TinyColor.prototype.greyscale = function() {
        return this.desaturate(100);
    };
    /**
     * Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
     * Values outside of this range will be wrapped into this range.
     */ TinyColor.prototype.spin = function(amount) {
        var hsl = this.toHsl();
        var hue = (hsl.h + amount) % 360;
        hsl.h = hue < 0 ? 360 + hue : hue;
        return new TinyColor(hsl);
    };
    /**
     * Mix the current color a given amount with another color, from 0 to 100.
     * 0 means no mixing (return current color).
     */ TinyColor.prototype.mix = function(color, amount) {
        if (amount === void 0) amount = 50;
        var rgb1 = this.toRgb();
        var rgb2 = new TinyColor(color).toRgb();
        var p = amount / 100;
        var rgba = {
            r: (rgb2.r - rgb1.r) * p + rgb1.r,
            g: (rgb2.g - rgb1.g) * p + rgb1.g,
            b: (rgb2.b - rgb1.b) * p + rgb1.b,
            a: (rgb2.a - rgb1.a) * p + rgb1.a
        };
        return new TinyColor(rgba);
    };
    TinyColor.prototype.analogous = function(results, slices) {
        if (results === void 0) results = 6;
        if (slices === void 0) slices = 30;
        var hsl = this.toHsl();
        var part = 360 / slices;
        var ret = [
            this
        ];
        for(hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;){
            hsl.h = (hsl.h + part) % 360;
            ret.push(new TinyColor(hsl));
        }
        return ret;
    };
    /**
     * taken from https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js
     */ TinyColor.prototype.complement = function() {
        var hsl = this.toHsl();
        hsl.h = (hsl.h + 180) % 360;
        return new TinyColor(hsl);
    };
    TinyColor.prototype.monochromatic = function(results) {
        if (results === void 0) results = 6;
        var hsv = this.toHsv();
        var h = hsv.h;
        var s = hsv.s;
        var v = hsv.v;
        var res = [];
        var modification = 1 / results;
        while(results--){
            res.push(new TinyColor({
                h: h,
                s: s,
                v: v
            }));
            v = (v + modification) % 1;
        }
        return res;
    };
    TinyColor.prototype.splitcomplement = function() {
        var hsl = this.toHsl();
        var h = hsl.h;
        return [
            this,
            new TinyColor({
                h: (h + 72) % 360,
                s: hsl.s,
                l: hsl.l
            }),
            new TinyColor({
                h: (h + 216) % 360,
                s: hsl.s,
                l: hsl.l
            })
        ];
    };
    /**
     * Compute how the color would appear on a background
     */ TinyColor.prototype.onBackground = function(background) {
        var fg = this.toRgb();
        var bg = new TinyColor(background).toRgb();
        var alpha = fg.a + bg.a * (1 - fg.a);
        return new TinyColor({
            r: (fg.r * fg.a + bg.r * bg.a * (1 - fg.a)) / alpha,
            g: (fg.g * fg.a + bg.g * bg.a * (1 - fg.a)) / alpha,
            b: (fg.b * fg.a + bg.b * bg.a * (1 - fg.a)) / alpha,
            a: alpha
        });
    };
    /**
     * Alias for `polyad(3)`
     */ TinyColor.prototype.triad = function() {
        return this.polyad(3);
    };
    /**
     * Alias for `polyad(4)`
     */ TinyColor.prototype.tetrad = function() {
        return this.polyad(4);
    };
    /**
     * Get polyad colors, like (for 1, 2, 3, 4, 5, 6, 7, 8, etc...)
     * monad, dyad, triad, tetrad, pentad, hexad, heptad, octad, etc...
     */ TinyColor.prototype.polyad = function(n) {
        var hsl = this.toHsl();
        var h = hsl.h;
        var result = [
            this
        ];
        var increment = 360 / n;
        for(var i = 1; i < n; i++)result.push(new TinyColor({
            h: (h + i * increment) % 360,
            s: hsl.s,
            l: hsl.l
        }));
        return result;
    };
    /**
     * compare color vs current color
     */ TinyColor.prototype.equals = function(color) {
        return this.toRgbString() === new TinyColor(color).toRgbString();
    };
    return TinyColor;
}();
function $67c2facb7a96d7bf$export$6325b328a5266d34(color, opts) {
    if (color === void 0) color = "";
    if (opts === void 0) opts = {};
    return new $67c2facb7a96d7bf$export$d850312fc213f33e(color, opts);
}

});


parcelRegister("kgIuF", function(module, exports) {

$parcel$export(module.exports, "DisabledContextProvider", function () { return $ec17d0c3c154b6a5$export$6adb5f3b918b11bb; });
$parcel$export(module.exports, "default", function () { return $ec17d0c3c154b6a5$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");
var $ec17d0c3c154b6a5$var$DisabledContext = /*#__PURE__*/ $jbmdS.createContext(false);
var $ec17d0c3c154b6a5$export$6adb5f3b918b11bb = function DisabledContextProvider(_ref) {
    var children = _ref.children, disabled = _ref.disabled;
    var originDisabled = $jbmdS.useContext($ec17d0c3c154b6a5$var$DisabledContext);
    return /*#__PURE__*/ $jbmdS.createElement($ec17d0c3c154b6a5$var$DisabledContext.Provider, {
        value: disabled !== null && disabled !== void 0 ? disabled : originDisabled
    }, children);
};
var $ec17d0c3c154b6a5$export$2e2bcd8739ae039 = $ec17d0c3c154b6a5$var$DisabledContext;

});

parcelRegister("7VQDG", function(module, exports) {

$parcel$export(module.exports, "SizeContextProvider", function () { return $5c66b04bef4b70d0$export$dbc92d89fabc8ebe; });
$parcel$export(module.exports, "default", function () { return $5c66b04bef4b70d0$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");
var $5c66b04bef4b70d0$var$SizeContext = /*#__PURE__*/ $jbmdS.createContext(undefined);
var $5c66b04bef4b70d0$export$dbc92d89fabc8ebe = function SizeContextProvider(_ref) {
    var children = _ref.children, size = _ref.size;
    return /*#__PURE__*/ $jbmdS.createElement($5c66b04bef4b70d0$var$SizeContext.Consumer, null, function(originSize) {
        return /*#__PURE__*/ $jbmdS.createElement($5c66b04bef4b70d0$var$SizeContext.Provider, {
            value: size || originSize
        }, children);
    });
};
var $5c66b04bef4b70d0$export$2e2bcd8739ae039 = $5c66b04bef4b70d0$var$SizeContext;

});


parcelRegister("9RKXl", function(module, exports) {

$parcel$export(module.exports, "useCompactItemContext", function () { return $72ed7ccd55183ee8$export$cd8cf9d7bab8dd4; });
$parcel$export(module.exports, "NoCompactStyle", function () { return $72ed7ccd55183ee8$export$5f56e610a4afb685; });

var $7i29i = parcelRequire("7i29i");

var $8K2NM = parcelRequire("8K2NM");

var $02LyB = parcelRequire("02LyB");

var $5AfDn = parcelRequire("5AfDn");

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("8uDri");
var $ewikT = parcelRequire("ewikT");
var $72ed7ccd55183ee8$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $72ed7ccd55183ee8$export$8d1c486ac0db0a7d = /*#__PURE__*/ $jbmdS.createContext(null);
var $72ed7ccd55183ee8$export$cd8cf9d7bab8dd4 = function useCompactItemContext(prefixCls, direction) {
    var compactItemContext = $jbmdS.useContext($72ed7ccd55183ee8$export$8d1c486ac0db0a7d);
    var compactItemClassnames = $jbmdS.useMemo(function() {
        if (!compactItemContext) return "";
        var compactDirection = compactItemContext.compactDirection, isFirstItem = compactItemContext.isFirstItem, isLastItem = compactItemContext.isLastItem;
        var separator = compactDirection === "vertical" ? "-vertical-" : "-";
        return (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)({}, "".concat(prefixCls, "-compact").concat(separator, "item"), true), "".concat(prefixCls, "-compact").concat(separator, "first-item"), isFirstItem), "".concat(prefixCls, "-compact").concat(separator, "last-item"), isLastItem), "".concat(prefixCls, "-compact").concat(separator, "item-rtl"), direction === "rtl"));
    }, [
        prefixCls,
        direction,
        compactItemContext
    ]);
    return {
        compactSize: compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.compactSize,
        compactDirection: compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.compactDirection,
        compactItemClassnames: compactItemClassnames
    };
};
var $72ed7ccd55183ee8$export$5f56e610a4afb685 = function NoCompactStyle(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $jbmdS.createElement($72ed7ccd55183ee8$export$8d1c486ac0db0a7d.Provider, {
        value: null
    }, children);
};
var $72ed7ccd55183ee8$var$CompactItem = function CompactItem(_a) {
    var children = _a.children, otherProps = $72ed7ccd55183ee8$var$__rest(_a, [
        "children"
    ]);
    return /*#__PURE__*/ $jbmdS.createElement($72ed7ccd55183ee8$export$8d1c486ac0db0a7d.Provider, {
        value: otherProps
    }, children);
};
var $72ed7ccd55183ee8$var$Compact = function Compact(props) {
    var _React$useContext = $jbmdS.useContext((0, $ewikT.ConfigContext)), getPrefixCls = _React$useContext.getPrefixCls, directionConfig = _React$useContext.direction;
    var _props$size = props.size, size = _props$size === void 0 ? "middle" : _props$size, direction = props.direction, block = props.block, customizePrefixCls = props.prefixCls, className = props.className, children = props.children, restProps = $72ed7ccd55183ee8$var$__rest(props, [
        "size",
        "direction",
        "block",
        "prefixCls",
        "className",
        "children"
    ]);
    var prefixCls = getPrefixCls("space-compact", customizePrefixCls);
    var clx = (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(prefixCls, (0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)({}, "".concat(prefixCls, "-rtl"), directionConfig === "rtl"), "".concat(prefixCls, "-block"), block), "".concat(prefixCls, "-vertical"), direction === "vertical"), className);
    var compactItemContext = $jbmdS.useContext($72ed7ccd55183ee8$export$8d1c486ac0db0a7d);
    var childNodes = (0, $5AfDn.default)(children);
    var nodes = $jbmdS.useMemo(function() {
        return childNodes.map(function(child, i) {
            var key = child && child.key || "".concat(prefixCls, "-item-").concat(i);
            return /*#__PURE__*/ $jbmdS.createElement($72ed7ccd55183ee8$var$CompactItem, {
                key: key,
                compactSize: size,
                compactDirection: direction,
                isFirstItem: i === 0 && (!compactItemContext || (compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.isFirstItem)),
                isLastItem: i === childNodes.length - 1 && (!compactItemContext || (compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.isLastItem))
            }, child);
        });
    }, [
        size,
        childNodes,
        compactItemContext
    ]);
    // =========================== Render ===========================
    if (childNodes.length === 0) return null;
    return /*#__PURE__*/ $jbmdS.createElement("div", (0, $7i29i.default)({
        className: clx
    }, restProps), nodes);
};
var $72ed7ccd55183ee8$export$2e2bcd8739ae039 = $72ed7ccd55183ee8$var$Compact;

});
parcelRegister("5AfDn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $410c712164e7aa39$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");

var $5byCE = parcelRequire("5byCE");
function $410c712164e7aa39$export$2e2bcd8739ae039(children) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var ret = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).Children.forEach(children, function(child) {
        if ((child === undefined || child === null) && !option.keepEmpty) return;
        if (Array.isArray(child)) ret = ret.concat($410c712164e7aa39$export$2e2bcd8739ae039(child));
        else if ((0, $5byCE.isFragment)(child) && child.props) ret = ret.concat($410c712164e7aa39$export$2e2bcd8739ae039(child.props.children, option));
        else ret.push(child);
    });
    return ret;
}

});


parcelRegister("l34u6", function(module, exports) {

$parcel$export(module.exports, "isFragment", function () { return $f52d5b53b3a85297$export$9522e17588c12572; });
$parcel$export(module.exports, "replaceElement", function () { return $f52d5b53b3a85297$export$2dfe578f95754f6a; });
$parcel$export(module.exports, "cloneElement", function () { return $f52d5b53b3a85297$export$e530037191fcd5d7; });

var $jbmdS = parcelRequire("jbmdS");
var $f52d5b53b3a85297$export$a8257692ac88316c = $jbmdS.isValidElement;
function $f52d5b53b3a85297$export$9522e17588c12572(child) {
    return child && $f52d5b53b3a85297$export$a8257692ac88316c(child) && child.type === $jbmdS.Fragment;
}
function $f52d5b53b3a85297$export$2dfe578f95754f6a(element, replacement, props) {
    if (!$f52d5b53b3a85297$export$a8257692ac88316c(element)) return replacement;
    return /*#__PURE__*/ $jbmdS.cloneElement(element, typeof props === "function" ? props(element.props || {}) : props);
}
function $f52d5b53b3a85297$export$e530037191fcd5d7(element, props) {
    return $f52d5b53b3a85297$export$2dfe578f95754f6a(element, element, props);
}

});

parcelRegister("3IdWL", function(module, exports) {

$parcel$export(module.exports, "tuple", function () { return $2b404cb5014ece2a$export$65e3907585753458; });
// https://stackoverflow.com/questions/46176165/ways-to-get-string-literal-type-of-array-values-without-enum-overhead
var $2b404cb5014ece2a$export$65e3907585753458 = function tuple() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return args;
};
var $2b404cb5014ece2a$export$1ada10640a0e4dad = function tupleNum() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    return args;
};

});

parcelRegister("ccZcg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e36136a240555ef$export$2e2bcd8739ae039; });

var $3GVdq = parcelRequire("3GVdq");

var $jj5jQ = parcelRequire("jj5jQ");

var $ibb6t = parcelRequire("ibb6t");

var $lJpH8 = parcelRequire("lJpH8");

var $dO7bG = parcelRequire("dO7bG");

var $br3Qu = parcelRequire("br3Qu");

var $1N4zm = parcelRequire("1N4zm");

var $kNt4K = parcelRequire("kNt4K");

var $aKVEK = parcelRequire("aKVEK");

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("8uDri");
var $ewikT = parcelRequire("ewikT");

var $3L2eJ = parcelRequire("3L2eJ");

var $l34u6 = parcelRequire("l34u6");
function $8e36136a240555ef$var$_callSuper(t, o, e) {
    return o = (0, $dO7bG.default)(o), (0, $ibb6t.default)(t, (0, $lJpH8.default)() ? Reflect.construct(o, e || [], (0, $dO7bG.default)(t).constructor) : o.apply(t, e));
}
var $8e36136a240555ef$var$styleForPseudo;
// Where el is the DOM element you'd like to test for visibility
function $8e36136a240555ef$var$isHidden(element) {
    return !element || element.offsetParent === null || element.hidden;
}
function $8e36136a240555ef$var$getValidateContainer(nodeRoot) {
    if (nodeRoot instanceof Document) return nodeRoot.body;
    return Array.from(nodeRoot.childNodes).find(function(ele) {
        return (ele === null || ele === void 0 ? void 0 : ele.nodeType) === Node.ELEMENT_NODE;
    });
}
function $8e36136a240555ef$var$isNotGrey(color) {
    // eslint-disable-next-line no-useless-escape
    var match = (color || "").match(/rgba?\((\d*), (\d*), (\d*)(, [\d.]*)?\)/);
    if (match && match[1] && match[2] && match[3]) return !(match[1] === match[2] && match[2] === match[3]);
    return true;
}
var $8e36136a240555ef$var$Wave = /*#__PURE__*/ function(_React$Component) {
    (0, $1N4zm.default)(Wave, _React$Component);
    function Wave() {
        var _this;
        (0, $3GVdq.default)(this, Wave);
        _this = $8e36136a240555ef$var$_callSuper(this, Wave, arguments);
        _this.containerRef = /*#__PURE__*/ $jbmdS.createRef();
        _this.animationStart = false;
        _this.destroyed = false;
        _this.onClick = function(node, waveColor) {
            var _a, _b;
            var _this$props = _this.props, insertExtraNode = _this$props.insertExtraNode, disabled = _this$props.disabled;
            if (disabled || !node || $8e36136a240555ef$var$isHidden(node) || node.className.includes("-leave")) return;
            _this.extraNode = document.createElement("div");
            var _assertThisInitialize = (0, $br3Qu.default)(_this), extraNode = _assertThisInitialize.extraNode;
            var getPrefixCls = _this.context.getPrefixCls;
            extraNode.className = "".concat(getPrefixCls(""), "-click-animating-node");
            var attributeName = _this.getAttributeName();
            node.setAttribute(attributeName, "true");
            // Not white or transparent or grey
            if (waveColor && waveColor !== "#fff" && waveColor !== "#ffffff" && waveColor !== "rgb(255, 255, 255)" && waveColor !== "rgba(255, 255, 255, 1)" && $8e36136a240555ef$var$isNotGrey(waveColor) && !/rgba\((?:\d*, ){3}0\)/.test(waveColor) && // any transparent rgba color
            waveColor !== "transparent") {
                extraNode.style.borderColor = waveColor;
                var nodeRoot = ((_a = node.getRootNode) === null || _a === void 0 ? void 0 : _a.call(node)) || node.ownerDocument;
                var nodeBody = (_b = $8e36136a240555ef$var$getValidateContainer(nodeRoot)) !== null && _b !== void 0 ? _b : nodeRoot;
                $8e36136a240555ef$var$styleForPseudo = (0, $kNt4K.updateCSS)("\n      [".concat(getPrefixCls(""), "-click-animating-without-extra-node='true']::after, .").concat(getPrefixCls(""), "-click-animating-node {\n        --antd-wave-shadow-color: ").concat(waveColor, ";\n      }"), "antd-wave", {
                    csp: _this.csp,
                    attachTo: nodeBody
                });
            }
            if (insertExtraNode) node.appendChild(extraNode);
            [
                "transition",
                "animation"
            ].forEach(function(name) {
                node.addEventListener("".concat(name, "start"), _this.onTransitionStart);
                node.addEventListener("".concat(name, "end"), _this.onTransitionEnd);
            });
        };
        _this.onTransitionStart = function(e) {
            if (_this.destroyed) return;
            var node = _this.containerRef.current;
            if (!e || e.target !== node || _this.animationStart) return;
            _this.resetEffect(node);
        };
        _this.onTransitionEnd = function(e) {
            if (!e || e.animationName !== "fadeEffect") return;
            _this.resetEffect(e.target);
        };
        _this.bindAnimationEvent = function(node) {
            if (!node || !node.getAttribute || node.getAttribute("disabled") || node.className.includes("disabled")) return;
            var onClick = function onClick(e) {
                // Fix radio button click twice
                if (e.target.tagName === "INPUT" || $8e36136a240555ef$var$isHidden(e.target)) return;
                _this.resetEffect(node);
                // Get wave color from target
                var waveColor = getComputedStyle(node).getPropertyValue("border-top-color") || // Firefox Compatible
                getComputedStyle(node).getPropertyValue("border-color") || getComputedStyle(node).getPropertyValue("background-color");
                _this.clickWaveTimeoutId = window.setTimeout(function() {
                    return _this.onClick(node, waveColor);
                }, 0);
                (0, $3L2eJ.default).cancel(_this.animationStartId);
                _this.animationStart = true;
                // Render to trigger transition event cost 3 frames. Let's delay 10 frames to reset this.
                _this.animationStartId = (0, $3L2eJ.default)(function() {
                    _this.animationStart = false;
                }, 10);
            };
            node.addEventListener("click", onClick, true);
            return {
                cancel: function cancel() {
                    node.removeEventListener("click", onClick, true);
                }
            };
        };
        _this.renderWave = function(_ref) {
            var csp = _ref.csp;
            var children = _this.props.children;
            _this.csp = csp;
            if (!/*#__PURE__*/ $jbmdS.isValidElement(children)) return children;
            var ref = _this.containerRef;
            if ((0, $aKVEK.supportRef)(children)) ref = (0, $aKVEK.composeRef)(children.ref, _this.containerRef);
            return (0, $l34u6.cloneElement)(children, {
                ref: ref
            });
        };
        return _this;
    }
    (0, $jj5jQ.default)(Wave, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.destroyed = false;
                var node = this.containerRef.current;
                if (!node || node.nodeType !== 1) return;
                this.instance = this.bindAnimationEvent(node);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.instance) this.instance.cancel();
                if (this.clickWaveTimeoutId) clearTimeout(this.clickWaveTimeoutId);
                this.destroyed = true;
            }
        },
        {
            key: "getAttributeName",
            value: function getAttributeName() {
                var getPrefixCls = this.context.getPrefixCls;
                var insertExtraNode = this.props.insertExtraNode;
                return insertExtraNode ? "".concat(getPrefixCls(""), "-click-animating") : "".concat(getPrefixCls(""), "-click-animating-without-extra-node");
            }
        },
        {
            key: "resetEffect",
            value: function resetEffect(node) {
                var _this2 = this;
                if (!node || node === this.extraNode || !(node instanceof Element)) return;
                var insertExtraNode = this.props.insertExtraNode;
                var attributeName = this.getAttributeName();
                node.setAttribute(attributeName, "false"); // edge has bug on `removeAttribute` #14466
                if ($8e36136a240555ef$var$styleForPseudo) $8e36136a240555ef$var$styleForPseudo.innerHTML = "";
                if (insertExtraNode && this.extraNode && node.contains(this.extraNode)) node.removeChild(this.extraNode);
                [
                    "transition",
                    "animation"
                ].forEach(function(name) {
                    node.removeEventListener("".concat(name, "start"), _this2.onTransitionStart);
                    node.removeEventListener("".concat(name, "end"), _this2.onTransitionEnd);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ $jbmdS.createElement((0, $ewikT.ConfigConsumer), null, this.renderWave);
            }
        }
    ]);
    return Wave;
}($jbmdS.Component);
$8e36136a240555ef$var$Wave.contextType = (0, $ewikT.ConfigContext);
var $8e36136a240555ef$export$2e2bcd8739ae039 = $8e36136a240555ef$var$Wave;

});
parcelRegister("3L2eJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2bc77f0db4f2ce74$export$2e2bcd8739ae039; });

var $2iJQe = parcelRequire("2iJQe");
var $2bc77f0db4f2ce74$var$id = 0;
var $2bc77f0db4f2ce74$var$ids = {};
function $2bc77f0db4f2ce74$export$2e2bcd8739ae039(callback) {
    var delayFrames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var myId = $2bc77f0db4f2ce74$var$id++;
    var restFrames = delayFrames;
    function internalCallback() {
        restFrames -= 1;
        if (restFrames <= 0) {
            callback();
            delete $2bc77f0db4f2ce74$var$ids[myId];
        } else $2bc77f0db4f2ce74$var$ids[myId] = (0, $2iJQe.default)(internalCallback);
    }
    $2bc77f0db4f2ce74$var$ids[myId] = (0, $2iJQe.default)(internalCallback);
    return myId;
}
$2bc77f0db4f2ce74$export$2e2bcd8739ae039.cancel = function cancel(pid) {
    if (pid === undefined) return;
    (0, $2iJQe.default).cancel($2bc77f0db4f2ce74$var$ids[pid]);
    delete $2bc77f0db4f2ce74$var$ids[pid];
};
$2bc77f0db4f2ce74$export$2e2bcd8739ae039.ids = $2bc77f0db4f2ce74$var$ids; // export this for test usage

});


parcelRegister("bOMNW", function(module, exports) {

$parcel$export(module.exports, "GroupSizeContext", function () { return $89aa38c46010aa42$export$ed0cc8bd1f617d6d; });
$parcel$export(module.exports, "default", function () { return $89aa38c46010aa42$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $8K2NM = parcelRequire("8K2NM");

var $02LyB = parcelRequire("02LyB");

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("8uDri");
var $ewikT = parcelRequire("ewikT");

var $89aa38c46010aa42$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $89aa38c46010aa42$export$ed0cc8bd1f617d6d = /*#__PURE__*/ $jbmdS.createContext(undefined);
var $89aa38c46010aa42$var$ButtonGroup = function ButtonGroup(props) {
    var _React$useContext = $jbmdS.useContext((0, $ewikT.ConfigContext)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var customizePrefixCls = props.prefixCls, size = props.size, className = props.className, others = $89aa38c46010aa42$var$__rest(props, [
        "prefixCls",
        "size",
        "className"
    ]);
    var prefixCls = getPrefixCls("btn-group", customizePrefixCls);
    // large => lg
    // small => sm
    var sizeCls = "";
    switch(size){
        case "large":
            sizeCls = "lg";
            break;
        case "small":
            sizeCls = "sm";
            break;
        case "middle":
        case undefined:
            break;
        default:
    }
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(prefixCls, (0, $8K2NM.default)((0, $8K2NM.default)({}, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), "".concat(prefixCls, "-rtl"), direction === "rtl"), className);
    return /*#__PURE__*/ $jbmdS.createElement($89aa38c46010aa42$export$ed0cc8bd1f617d6d.Provider, {
        value: size
    }, /*#__PURE__*/ $jbmdS.createElement("div", (0, $7i29i.default)({}, others, {
        className: classes
    })));
};
var $89aa38c46010aa42$export$2e2bcd8739ae039 = $89aa38c46010aa42$var$ButtonGroup;

});

parcelRegister("fKUMH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b787331d029955c5$export$2e2bcd8739ae039; });

var $97QHC = parcelRequire("97QHC");

var $jGjXd = parcelRequire("jGjXd");

var $jbmdS = parcelRequire("jbmdS");
var $b787331d029955c5$var$getCollapsedWidth = function getCollapsedWidth() {
    return {
        width: 0,
        opacity: 0,
        transform: "scale(0)"
    };
};
var $b787331d029955c5$var$getRealWidth = function getRealWidth(node) {
    return {
        width: node.scrollWidth,
        opacity: 1,
        transform: "scale(1)"
    };
};
var $b787331d029955c5$var$LoadingIcon = function LoadingIcon(_ref) {
    var prefixCls = _ref.prefixCls, loading = _ref.loading, existIcon = _ref.existIcon;
    var visible = !!loading;
    if (existIcon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("span", {
        className: "".concat(prefixCls, "-loading-icon")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $97QHC.default), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $jGjXd.default), {
        visible: visible,
        // We do not really use this motionName
        motionName: "".concat(prefixCls, "-loading-icon-motion"),
        removeOnLeave: true,
        onAppearStart: $b787331d029955c5$var$getCollapsedWidth,
        onAppearActive: $b787331d029955c5$var$getRealWidth,
        onEnterStart: $b787331d029955c5$var$getCollapsedWidth,
        onEnterActive: $b787331d029955c5$var$getRealWidth,
        onLeaveStart: $b787331d029955c5$var$getRealWidth,
        onLeaveActive: $b787331d029955c5$var$getCollapsedWidth
    }, function(_ref2, ref) {
        var className = _ref2.className, style = _ref2.style;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("span", {
            className: "".concat(prefixCls, "-loading-icon"),
            style: style,
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $97QHC.default), {
            className: className
        }));
    });
};
var $b787331d029955c5$export$2e2bcd8739ae039 = $b787331d029955c5$var$LoadingIcon;

});



parcelRegister("6N1HV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f18a4c4bd974d07$export$2e2bcd8739ae039; });

var $iXoQw = parcelRequire("iXoQw");

var $lsAFg = parcelRequire("lsAFg");

var $9p1pa = parcelRequire("9p1pa");

var $3pGzq = parcelRequire("3pGzq");

var $3xbOw = parcelRequire("3xbOw");
var $4f18a4c4bd974d07$var$Input = (0, $lsAFg.default);
$4f18a4c4bd974d07$var$Input.Group = (0, $iXoQw.default);
$4f18a4c4bd974d07$var$Input.Search = (0, $3pGzq.default);
$4f18a4c4bd974d07$var$Input.TextArea = (0, $3xbOw.default);
$4f18a4c4bd974d07$var$Input.Password = (0, $9p1pa.default);
var $4f18a4c4bd974d07$export$2e2bcd8739ae039 = $4f18a4c4bd974d07$var$Input;

});
parcelRegister("iXoQw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcd1029d538920c8$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $8K2NM = parcelRequire("8K2NM");

var $02LyB = parcelRequire("02LyB");

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("8uDri");
var $ewikT = parcelRequire("ewikT");

var $3ACNS = parcelRequire("3ACNS");
var $dcd1029d538920c8$var$Group = function Group(props) {
    var _useContext = (0, $jbmdS.useContext)((0, $ewikT.ConfigContext)), getPrefixCls = _useContext.getPrefixCls, direction = _useContext.direction;
    var customizePrefixCls = props.prefixCls, _props$className = props.className, className = _props$className === void 0 ? "" : _props$className;
    var prefixCls = getPrefixCls("input-group", customizePrefixCls);
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(prefixCls, (0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)({}, "".concat(prefixCls, "-lg"), props.size === "large"), "".concat(prefixCls, "-sm"), props.size === "small"), "".concat(prefixCls, "-compact"), props.compact), "".concat(prefixCls, "-rtl"), direction === "rtl"), className);
    var formItemContext = (0, $jbmdS.useContext)((0, $3ACNS.FormItemInputContext));
    var groupFormItemContext = (0, $jbmdS.useMemo)(function() {
        return (0, $7i29i.default)((0, $7i29i.default)({}, formItemContext), {
            isFormItemInput: false
        });
    }, [
        formItemContext
    ]);
    return /*#__PURE__*/ $jbmdS.createElement("span", {
        className: cls,
        style: props.style,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onFocus: props.onFocus,
        onBlur: props.onBlur
    }, /*#__PURE__*/ $jbmdS.createElement((0, $3ACNS.FormItemInputContext).Provider, {
        value: groupFormItemContext
    }, props.children));
};
var $dcd1029d538920c8$export$2e2bcd8739ae039 = $dcd1029d538920c8$var$Group;

});
parcelRegister("3ACNS", function(module, exports) {

$parcel$export(module.exports, "FormItemInputContext", function () { return $29d2d56dcd0b2e98$export$bbb5553c6c7a14ed; });
$parcel$export(module.exports, "NoFormStyle", function () { return $29d2d56dcd0b2e98$export$80e4c53cb85dcab1; });

var $7i29i = parcelRequire("7i29i");
parcelRequire("8jskC");
var $6M4HU = parcelRequire("6M4HU");

var $cXDkH = parcelRequire("cXDkH");

var $jbmdS = parcelRequire("jbmdS");
var $29d2d56dcd0b2e98$export$c24727297075ec6a = /*#__PURE__*/ $jbmdS.createContext({
    labelAlign: "right",
    vertical: false,
    itemRef: function itemRef() {}
});
var $29d2d56dcd0b2e98$export$d718247e9f9b0b9e = /*#__PURE__*/ $jbmdS.createContext(null);
var $29d2d56dcd0b2e98$export$8ce1ff4f94d08846 = function FormProvider(props) {
    var providerProps = (0, $cXDkH.default)(props, [
        "prefixCls"
    ]);
    return /*#__PURE__*/ $jbmdS.createElement((0, $6M4HU.FormProvider), (0, $7i29i.default)({}, providerProps));
};
var $29d2d56dcd0b2e98$export$fb6582d3042cc879 = /*#__PURE__*/ $jbmdS.createContext({
    prefixCls: ""
});
var $29d2d56dcd0b2e98$export$bbb5553c6c7a14ed = /*#__PURE__*/ $jbmdS.createContext({});
var $29d2d56dcd0b2e98$export$80e4c53cb85dcab1 = function NoFormStyle(_ref) {
    var children = _ref.children, status = _ref.status, override = _ref.override;
    var formItemInputContext = (0, $jbmdS.useContext)($29d2d56dcd0b2e98$export$bbb5553c6c7a14ed);
    var newFormItemInputContext = (0, $jbmdS.useMemo)(function() {
        var newContext = (0, $7i29i.default)({}, formItemInputContext);
        if (override) delete newContext.isFormItemInput;
        if (status) {
            delete newContext.status;
            delete newContext.hasFeedback;
            delete newContext.feedbackIcon;
        }
        return newContext;
    }, [
        status,
        override,
        formItemInputContext
    ]);
    return /*#__PURE__*/ $jbmdS.createElement($29d2d56dcd0b2e98$export$bbb5553c6c7a14ed.Provider, {
        value: newFormItemInputContext
    }, children);
};

});
parcelRegister("8jskC", function(module, exports) {

$parcel$export(module.exports, "FormProvider", function () { return (parcelRequire("6M4HU")).FormProvider; });

var $jbmdS = parcelRequire("jbmdS");

var $gnihy = parcelRequire("gnihy");

var $iJYiS = parcelRequire("iJYiS");

var $giUv8 = parcelRequire("giUv8");

var $7z7SN = parcelRequire("7z7SN");

var $6M4HU = parcelRequire("6M4HU");

var $gjHn8 = parcelRequire("gjHn8");

var $3KctZ = parcelRequire("3KctZ");

var $eqPZA = parcelRequire("eqPZA");
var $60d613259ca74efd$var$InternalForm = /*#__PURE__*/ $jbmdS.forwardRef((0, $7z7SN.default));
var $60d613259ca74efd$var$RefForm = $60d613259ca74efd$var$InternalForm;
$60d613259ca74efd$var$RefForm.FormProvider = (0, $6M4HU.FormProvider);
$60d613259ca74efd$var$RefForm.Field = (0, $gnihy.default);
$60d613259ca74efd$var$RefForm.List = (0, $iJYiS.default);
$60d613259ca74efd$var$RefForm.useForm = (0, $giUv8.default);
$60d613259ca74efd$var$RefForm.useWatch = (0, $eqPZA.default);
var $60d613259ca74efd$export$2e2bcd8739ae039 = $60d613259ca74efd$var$RefForm;

});
parcelRegister("gnihy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bebcf9c0dd2e751a$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $ccQt4 = parcelRequire("ccQt4");

var $9TNqp = parcelRequire("9TNqp");

var $raxj3 = parcelRequire("raxj3");

var $lv6ip = parcelRequire("lv6ip");

var $huwkX = parcelRequire("huwkX");

var $3GVdq = parcelRequire("3GVdq");

var $jj5jQ = parcelRequire("jj5jQ");

var $br3Qu = parcelRequire("br3Qu");

var $1N4zm = parcelRequire("1N4zm");

var $gRFRo = parcelRequire("gRFRo");

var $8K2NM = parcelRequire("8K2NM");

var $5AfDn = parcelRequire("5AfDn");

var $2BNx7 = parcelRequire("2BNx7");

var $8tMCd = parcelRequire("8tMCd");

var $jbmdS = parcelRequire("jbmdS");

var $gjHn8 = parcelRequire("gjHn8");

var $3KctZ = parcelRequire("3KctZ");

var $hsiPi = parcelRequire("hsiPi");

var $4pq8s = parcelRequire("4pq8s");

var $9OV34 = parcelRequire("9OV34");
var $4eeUf = parcelRequire("4eeUf");
var $bebcf9c0dd2e751a$var$_excluded = [
    "name"
];
var $bebcf9c0dd2e751a$var$EMPTY_ERRORS = [];
function $bebcf9c0dd2e751a$var$requireUpdate(shouldUpdate, prev, next, prevValue, nextValue, info) {
    if (typeof shouldUpdate === "function") return shouldUpdate(prev, next, "source" in info ? {
        source: info.source
    } : {});
    return prevValue !== nextValue;
}
// eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
// We use Class instead of Hooks here since it will cost much code by using Hooks.
var $bebcf9c0dd2e751a$var$Field = /*#__PURE__*/ function(_React$Component) {
    (0, $1N4zm.default)(Field, _React$Component);
    var _super = (0, $gRFRo.default)(Field);
    // ============================== Subscriptions ==============================
    function Field(props) {
        var _this;
        (0, $3GVdq.default)(this, Field);
        _this = _super.call(this, props);
        // Register on init
        (0, $8K2NM.default)((0, $br3Qu.default)(_this), "state", {
            resetCount: 0
        });
        (0, $8K2NM.default)((0, $br3Qu.default)(_this), "cancelRegisterFunc", null);
        (0, $8K2NM.default)((0, $br3Qu.default)(_this), "mounted", false);
        /**
     * Follow state should not management in State since it will async update by React.
     * This makes first render of form can not get correct state value.
     */ (0, $8K2NM.default)((0, $br3Qu.default)(_this), "touched", false);
        /**
     * Mark when touched & validated. Currently only used for `dependencies`.
     * Note that we do not think field with `initialValue` is dirty
     * but this will be by `isFieldDirty` func.
     */ (0, $8K2NM.default)((0, $br3Qu.default)(_this), "dirty", false);
        (0, $8K2NM.default)((0, $br3Qu.default)(_this), "validatePromise", void 0);
        (0, $8K2NM.default)((0, $br3Qu.default)(_this), "prevValidating", void 0);
        (0, $8K2NM.default)((0, $br3Qu.default)(_this), "errors", $bebcf9c0dd2e751a$var$EMPTY_ERRORS);
        (0, $8K2NM.default)((0, $br3Qu.default)(_this), "warnings", $bebcf9c0dd2e751a$var$EMPTY_ERRORS);
        (0, $8K2NM.default)((0, $br3Qu.default)(_this), "cancelRegister", function() {
            var _this$props = _this.props, preserve = _this$props.preserve, isListField = _this$props.isListField, name = _this$props.name;
            if (_this.cancelRegisterFunc) _this.cancelRegisterFunc(isListField, preserve, (0, $9OV34.getNamePath)(name));
            _this.cancelRegisterFunc = null;
        });
        // ================================== Utils ==================================
        (0, $8K2NM.default)((0, $br3Qu.default)(_this), "getNamePath", function() {
            var _this$props2 = _this.props, name = _this$props2.name, fieldContext = _this$props2.fieldContext;
            var _fieldContext$prefixN = fieldContext.prefixName, prefixName = _fieldContext$prefixN === void 0 ? [] : _fieldContext$prefixN;
            return name !== undefined ? [].concat((0, $huwkX.default)(prefixName), (0, $huwkX.default)(name)) : [];
        });
        (0, $8K2NM.default)((0, $br3Qu.default)(_this), "getRules", function() {
            var _this$props3 = _this.props, _this$props3$rules = _this$props3.rules, rules = _this$props3$rules === void 0 ? [] : _this$props3$rules, fieldContext = _this$props3.fieldContext;
            return rules.map(function(rule) {
                if (typeof rule === "function") return rule(fieldContext);
                return rule;
            });
        });
        (0, $8K2NM.default)((0, $br3Qu.default)(_this), "refresh", function() {
            if (!_this.mounted) return;
            /**
       * Clean up current node.
       */ _this.setState(function(_ref) {
                var resetCount = _ref.resetCount;
                return {
                    resetCount: resetCount + 1
                };
            });
        });
        // Event should only trigger when meta changed
        (0, $8K2NM.default)((0, $br3Qu.default)(_this), "metaCache", null);
        (0, $8K2NM.default)((0, $br3Qu.default)(_this), "triggerMetaEvent", function(destroy) {
            var onMetaChange = _this.props.onMetaChange;
            if (onMetaChange) {
                var _meta = (0, $lv6ip.default)((0, $lv6ip.default)({}, _this.getMeta()), {}, {
                    destroy: destroy
                });
                if (!(0, $2BNx7.default)(_this.metaCache, _meta)) onMetaChange(_meta);
                _this.metaCache = _meta;
            } else _this.metaCache = null;
        });
        // ========================= Field Entity Interfaces =========================
        // Trigger by store update. Check if need update the component
        (0, $8K2NM.default)((0, $br3Qu.default)(_this), "onStoreChange", function(prevStore, namePathList, info) {
            var _this$props4 = _this.props, shouldUpdate = _this$props4.shouldUpdate, _this$props4$dependen = _this$props4.dependencies, dependencies = _this$props4$dependen === void 0 ? [] : _this$props4$dependen, onReset = _this$props4.onReset;
            var store = info.store;
            var namePath = _this.getNamePath();
            var prevValue = _this.getValue(prevStore);
            var curValue = _this.getValue(store);
            var namePathMatch = namePathList && (0, $9OV34.containsNamePath)(namePathList, namePath);
            // `setFieldsValue` is a quick access to update related status
            if (info.type === "valueUpdate" && info.source === "external" && prevValue !== curValue) {
                _this.touched = true;
                _this.dirty = true;
                _this.validatePromise = null;
                _this.errors = $bebcf9c0dd2e751a$var$EMPTY_ERRORS;
                _this.warnings = $bebcf9c0dd2e751a$var$EMPTY_ERRORS;
                _this.triggerMetaEvent();
            }
            switch(info.type){
                case "reset":
                    if (!namePathList || namePathMatch) {
                        // Clean up state
                        _this.touched = false;
                        _this.dirty = false;
                        _this.validatePromise = undefined;
                        _this.errors = $bebcf9c0dd2e751a$var$EMPTY_ERRORS;
                        _this.warnings = $bebcf9c0dd2e751a$var$EMPTY_ERRORS;
                        _this.triggerMetaEvent();
                        onReset === null || onReset === void 0 || onReset();
                        _this.refresh();
                        return;
                    }
                    break;
                /**
         * In case field with `preserve = false` nest deps like:
         * - A = 1 => show B
         * - B = 1 => show C
         * - Reset A, need clean B, C
         */ case "remove":
                    if (shouldUpdate) {
                        _this.reRender();
                        return;
                    }
                    break;
                case "setField":
                    var data = info.data;
                    if (namePathMatch) {
                        if ("touched" in data) _this.touched = data.touched;
                        if ("validating" in data && !("originRCField" in data)) _this.validatePromise = data.validating ? Promise.resolve([]) : null;
                        if ("errors" in data) _this.errors = data.errors || $bebcf9c0dd2e751a$var$EMPTY_ERRORS;
                        if ("warnings" in data) _this.warnings = data.warnings || $bebcf9c0dd2e751a$var$EMPTY_ERRORS;
                        _this.dirty = true;
                        _this.triggerMetaEvent();
                        _this.reRender();
                        return;
                    } else if ("value" in data && (0, $9OV34.containsNamePath)(namePathList, namePath, true)) {
                        // Contains path with value should also check
                        _this.reRender();
                        return;
                    }
                    // Handle update by `setField` with `shouldUpdate`
                    if (shouldUpdate && !namePath.length && $bebcf9c0dd2e751a$var$requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                        _this.reRender();
                        return;
                    }
                    break;
                case "dependenciesUpdate":
                    /**
             * Trigger when marked `dependencies` updated. Related fields will all update
             */ var dependencyList = dependencies.map((0, $9OV34.getNamePath));
                    // No need for `namePathMath` check and `shouldUpdate` check, since `valueUpdate` will be
                    // emitted earlier and they will work there
                    // If set it may cause unnecessary twice rerendering
                    if (dependencyList.some(function(dependency) {
                        return (0, $9OV34.containsNamePath)(info.relatedFields, dependency);
                    })) {
                        _this.reRender();
                        return;
                    }
                    break;
                default:
                    // 1. If `namePath` exists in `namePathList`, means it's related value and should update
                    //      For example <List name="list"><Field name={['list', 0]}></List>
                    //      If `namePathList` is [['list']] (List value update), Field should be updated
                    //      If `namePathList` is [['list', 0]] (Field value update), List shouldn't be updated
                    // 2.
                    //   2.1 If `dependencies` is set, `name` is not set and `shouldUpdate` is not set,
                    //       don't use `shouldUpdate`. `dependencies` is view as a shortcut if `shouldUpdate`
                    //       is not provided
                    //   2.2 If `shouldUpdate` provided, use customize logic to update the field
                    //       else to check if value changed
                    if (namePathMatch || (!dependencies.length || namePath.length || shouldUpdate) && $bebcf9c0dd2e751a$var$requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                        _this.reRender();
                        return;
                    }
                    break;
            }
            if (shouldUpdate === true) _this.reRender();
        });
        (0, $8K2NM.default)((0, $br3Qu.default)(_this), "validateRules", function(options) {
            // We should fixed namePath & value to avoid developer change then by form function
            var namePath = _this.getNamePath();
            var currentValue = _this.getValue();
            var _ref2 = options || {}, triggerName = _ref2.triggerName, _ref2$validateOnly = _ref2.validateOnly, validateOnly = _ref2$validateOnly === void 0 ? false : _ref2$validateOnly;
            // Force change to async to avoid rule OOD under renderProps field
            var rootPromise = Promise.resolve().then(/*#__PURE__*/ (0, $raxj3.default)(/*#__PURE__*/ (0, $9TNqp.default)().mark(function _callee() {
                var _this$props5, _this$props5$validate, validateFirst, messageVariables, validateDebounce, filteredRules, promise;
                return (0, $9TNqp.default)().wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (_this.mounted) {
                                _context.next = 2;
                                break;
                            }
                            return _context.abrupt("return", []);
                        case 2:
                            _this$props5 = _this.props, _this$props5$validate = _this$props5.validateFirst, validateFirst = _this$props5$validate === void 0 ? false : _this$props5$validate, messageVariables = _this$props5.messageVariables, validateDebounce = _this$props5.validateDebounce; // Start validate
                            filteredRules = _this.getRules();
                            if (triggerName) filteredRules = filteredRules.filter(function(rule) {
                                return rule;
                            }).filter(function(rule) {
                                var validateTrigger = rule.validateTrigger;
                                if (!validateTrigger) return true;
                                var triggerList = (0, $hsiPi.toArray)(validateTrigger);
                                return triggerList.includes(triggerName);
                            });
                            // Wait for debounce. Skip if no `triggerName` since its from `validateFields / submit`
                            if (!(validateDebounce && triggerName)) {
                                _context.next = 10;
                                break;
                            }
                            _context.next = 8;
                            return new Promise(function(resolve) {
                                setTimeout(resolve, validateDebounce);
                            });
                        case 8:
                            if (!(_this.validatePromise !== rootPromise)) {
                                _context.next = 10;
                                break;
                            }
                            return _context.abrupt("return", []);
                        case 10:
                            promise = (0, $4pq8s.validateRules)(namePath, currentValue, filteredRules, options, validateFirst, messageVariables);
                            promise.catch(function(e) {
                                return e;
                            }).then(function() {
                                var ruleErrors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $bebcf9c0dd2e751a$var$EMPTY_ERRORS;
                                if (_this.validatePromise === rootPromise) {
                                    var _ruleErrors$forEach;
                                    _this.validatePromise = null;
                                    // Get errors & warnings
                                    var nextErrors = [];
                                    var nextWarnings = [];
                                    (_ruleErrors$forEach = ruleErrors.forEach) === null || _ruleErrors$forEach === void 0 || _ruleErrors$forEach.call(ruleErrors, function(_ref4) {
                                        var warningOnly = _ref4.rule.warningOnly, _ref4$errors = _ref4.errors, errors = _ref4$errors === void 0 ? $bebcf9c0dd2e751a$var$EMPTY_ERRORS : _ref4$errors;
                                        if (warningOnly) nextWarnings.push.apply(nextWarnings, (0, $huwkX.default)(errors));
                                        else nextErrors.push.apply(nextErrors, (0, $huwkX.default)(errors));
                                    });
                                    _this.errors = nextErrors;
                                    _this.warnings = nextWarnings;
                                    _this.triggerMetaEvent();
                                    _this.reRender();
                                }
                            });
                            return _context.abrupt("return", promise);
                        case 13:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            })));
            if (validateOnly) return rootPromise;
            _this.validatePromise = rootPromise;
            _this.dirty = true;
            _this.errors = $bebcf9c0dd2e751a$var$EMPTY_ERRORS;
            _this.warnings = $bebcf9c0dd2e751a$var$EMPTY_ERRORS;
            _this.triggerMetaEvent();
            // Force trigger re-render since we need sync renderProps with new meta
            _this.reRender();
            return rootPromise;
        });
        (0, $8K2NM.default)((0, $br3Qu.default)(_this), "isFieldValidating", function() {
            return !!_this.validatePromise;
        });
        (0, $8K2NM.default)((0, $br3Qu.default)(_this), "isFieldTouched", function() {
            return _this.touched;
        });
        (0, $8K2NM.default)((0, $br3Qu.default)(_this), "isFieldDirty", function() {
            // Touched or validate or has initialValue
            if (_this.dirty || _this.props.initialValue !== undefined) return true;
            // Form set initialValue
            var fieldContext = _this.props.fieldContext;
            var _fieldContext$getInte = fieldContext.getInternalHooks((0, $gjHn8.HOOK_MARK)), getInitialValue = _fieldContext$getInte.getInitialValue;
            if (getInitialValue(_this.getNamePath()) !== undefined) return true;
            return false;
        });
        (0, $8K2NM.default)((0, $br3Qu.default)(_this), "getErrors", function() {
            return _this.errors;
        });
        (0, $8K2NM.default)((0, $br3Qu.default)(_this), "getWarnings", function() {
            return _this.warnings;
        });
        (0, $8K2NM.default)((0, $br3Qu.default)(_this), "isListField", function() {
            return _this.props.isListField;
        });
        (0, $8K2NM.default)((0, $br3Qu.default)(_this), "isList", function() {
            return _this.props.isList;
        });
        (0, $8K2NM.default)((0, $br3Qu.default)(_this), "isPreserve", function() {
            return _this.props.preserve;
        });
        // ============================= Child Component =============================
        (0, $8K2NM.default)((0, $br3Qu.default)(_this), "getMeta", function() {
            // Make error & validating in cache to save perf
            _this.prevValidating = _this.isFieldValidating();
            var meta = {
                touched: _this.isFieldTouched(),
                validating: _this.prevValidating,
                errors: _this.errors,
                warnings: _this.warnings,
                name: _this.getNamePath(),
                validated: _this.validatePromise === null
            };
            return meta;
        });
        // Only return validate child node. If invalidate, will do nothing about field.
        (0, $8K2NM.default)((0, $br3Qu.default)(_this), "getOnlyChild", function(children) {
            // Support render props
            if (typeof children === "function") {
                var _meta2 = _this.getMeta();
                return (0, $lv6ip.default)((0, $lv6ip.default)({}, _this.getOnlyChild(children(_this.getControlled(), _meta2, _this.props.fieldContext))), {}, {
                    isFunction: true
                });
            }
            // Filed element only
            var childList = (0, $5AfDn.default)(children);
            if (childList.length !== 1 || !/*#__PURE__*/ $jbmdS.isValidElement(childList[0])) return {
                child: childList,
                isFunction: false
            };
            return {
                child: childList[0],
                isFunction: false
            };
        });
        // ============================== Field Control ==============================
        (0, $8K2NM.default)((0, $br3Qu.default)(_this), "getValue", function(store) {
            var getFieldsValue = _this.props.fieldContext.getFieldsValue;
            var namePath = _this.getNamePath();
            return (0, $4eeUf.default)(store || getFieldsValue(true), namePath);
        });
        (0, $8K2NM.default)((0, $br3Qu.default)(_this), "getControlled", function() {
            var childProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _this$props6 = _this.props, trigger = _this$props6.trigger, validateTrigger = _this$props6.validateTrigger, getValueFromEvent = _this$props6.getValueFromEvent, normalize = _this$props6.normalize, valuePropName = _this$props6.valuePropName, getValueProps = _this$props6.getValueProps, fieldContext = _this$props6.fieldContext;
            var mergedValidateTrigger = validateTrigger !== undefined ? validateTrigger : fieldContext.validateTrigger;
            var namePath = _this.getNamePath();
            var getInternalHooks = fieldContext.getInternalHooks, getFieldsValue = fieldContext.getFieldsValue;
            var _getInternalHooks = getInternalHooks((0, $gjHn8.HOOK_MARK)), dispatch = _getInternalHooks.dispatch;
            var value = _this.getValue();
            var mergedGetValueProps = getValueProps || function(val) {
                return (0, $8K2NM.default)({}, valuePropName, val);
            };
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var originTriggerFunc = childProps[trigger];
            var control = (0, $lv6ip.default)((0, $lv6ip.default)({}, childProps), mergedGetValueProps(value));
            // Add trigger
            control[trigger] = function() {
                // Mark as touched
                _this.touched = true;
                _this.dirty = true;
                _this.triggerMetaEvent();
                var newValue;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (getValueFromEvent) newValue = getValueFromEvent.apply(void 0, args);
                else newValue = (0, $9OV34.defaultGetValueFromEvent).apply(void 0, [
                    valuePropName
                ].concat(args));
                if (normalize) newValue = normalize(newValue, value, getFieldsValue(true));
                dispatch({
                    type: "updateValue",
                    namePath: namePath,
                    value: newValue
                });
                if (originTriggerFunc) originTriggerFunc.apply(void 0, args);
            };
            // Add validateTrigger
            var validateTriggerList = (0, $hsiPi.toArray)(mergedValidateTrigger || []);
            validateTriggerList.forEach(function(triggerName) {
                // Wrap additional function of component, so that we can get latest value from store
                var originTrigger = control[triggerName];
                control[triggerName] = function() {
                    if (originTrigger) originTrigger.apply(void 0, arguments);
                    // Always use latest rules
                    var rules = _this.props.rules;
                    if (rules && rules.length) // We dispatch validate to root,
                    // since it will update related data with other field with same name
                    dispatch({
                        type: "validateField",
                        namePath: namePath,
                        triggerName: triggerName
                    });
                };
            });
            return control;
        });
        if (props.fieldContext) {
            var getInternalHooks = props.fieldContext.getInternalHooks;
            var _getInternalHooks2 = getInternalHooks((0, $gjHn8.HOOK_MARK)), initEntityValue = _getInternalHooks2.initEntityValue;
            initEntityValue((0, $br3Qu.default)(_this));
        }
        return _this;
    }
    (0, $jj5jQ.default)(Field, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props7 = this.props, shouldUpdate = _this$props7.shouldUpdate, fieldContext = _this$props7.fieldContext;
                this.mounted = true;
                // Register on init
                if (fieldContext) {
                    var getInternalHooks = fieldContext.getInternalHooks;
                    var _getInternalHooks3 = getInternalHooks((0, $gjHn8.HOOK_MARK)), registerField = _getInternalHooks3.registerField;
                    this.cancelRegisterFunc = registerField(this);
                }
                // One more render for component in case fields not ready
                if (shouldUpdate === true) this.reRender();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.cancelRegister();
                this.triggerMetaEvent(true);
                this.mounted = false;
            }
        },
        {
            key: "reRender",
            value: function reRender() {
                if (!this.mounted) return;
                this.forceUpdate();
            }
        },
        {
            key: "render",
            value: function render() {
                var resetCount = this.state.resetCount;
                var children = this.props.children;
                var _this$getOnlyChild = this.getOnlyChild(children), child = _this$getOnlyChild.child, isFunction = _this$getOnlyChild.isFunction;
                // Not need to `cloneElement` since user can handle this in render function self
                var returnChildNode;
                if (isFunction) returnChildNode = child;
                else if (/*#__PURE__*/ $jbmdS.isValidElement(child)) returnChildNode = /*#__PURE__*/ $jbmdS.cloneElement(child, this.getControlled(child.props));
                else {
                    (0, $8tMCd.default)(!child, "`children` of Field is not validate ReactElement.");
                    returnChildNode = child;
                }
                return /*#__PURE__*/ $jbmdS.createElement($jbmdS.Fragment, {
                    key: resetCount
                }, returnChildNode);
            }
        }
    ]);
    return Field;
}($jbmdS.Component);
(0, $8K2NM.default)($bebcf9c0dd2e751a$var$Field, "contextType", (0, $gjHn8.default));
(0, $8K2NM.default)($bebcf9c0dd2e751a$var$Field, "defaultProps", {
    trigger: "onChange",
    valuePropName: "value"
});
function $bebcf9c0dd2e751a$var$WrapperField(_ref6) {
    var name = _ref6.name, restProps = (0, $ccQt4.default)(_ref6, $bebcf9c0dd2e751a$var$_excluded);
    var fieldContext = $jbmdS.useContext((0, $gjHn8.default));
    var listContext = $jbmdS.useContext((0, $3KctZ.default));
    var namePath = name !== undefined ? (0, $9OV34.getNamePath)(name) : undefined;
    var key = "keep";
    if (!restProps.isListField) key = "_".concat((namePath || []).join("_"));
    return /*#__PURE__*/ $jbmdS.createElement($bebcf9c0dd2e751a$var$Field, (0, $7i29i.default)({
        key: key,
        name: namePath,
        isListField: !!listContext
    }, restProps, {
        fieldContext: fieldContext
    }));
}
var $bebcf9c0dd2e751a$export$2e2bcd8739ae039 = $bebcf9c0dd2e751a$var$WrapperField;

});
parcelRegister("2BNx7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e6575bdd278d38e$export$2e2bcd8739ae039; });

var $jncUt = parcelRequire("jncUt");

var $8tMCd = parcelRequire("8tMCd");
/**
 * Deeply compares two object literals.
 * @param obj1 object 1
 * @param obj2 object 2
 * @param shallow shallow compare
 * @returns
 */ function $1e6575bdd278d38e$var$isEqual(obj1, obj2) {
    var shallow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    // https://github.com/mapbox/mapbox-gl-js/pull/5979/files#diff-fde7145050c47cc3a306856efd5f9c3016e86e859de9afbd02c879be5067e58f
    var refSet = new Set();
    function deepEqual(a, b) {
        var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        var circular = refSet.has(a);
        (0, $8tMCd.default)(!circular, "Warning: There may be circular references");
        if (circular) return false;
        if (a === b) return true;
        if (shallow && level > 1) return false;
        refSet.add(a);
        var newLevel = level + 1;
        if (Array.isArray(a)) {
            if (!Array.isArray(b) || a.length !== b.length) return false;
            for(var i = 0; i < a.length; i++){
                if (!deepEqual(a[i], b[i], newLevel)) return false;
            }
            return true;
        }
        if (a && b && (0, $jncUt.default)(a) === "object" && (0, $jncUt.default)(b) === "object") {
            var keys = Object.keys(a);
            if (keys.length !== Object.keys(b).length) return false;
            return keys.every(function(key) {
                return deepEqual(a[key], b[key], newLevel);
            });
        }
        // other
        return false;
    }
    return deepEqual(obj1, obj2);
}
var $1e6575bdd278d38e$export$2e2bcd8739ae039 = $1e6575bdd278d38e$var$isEqual;

});

parcelRegister("gjHn8", function(module, exports) {

$parcel$export(module.exports, "HOOK_MARK", function () { return $be10107d5026b0eb$export$24829b7c0e49e9f7; });
$parcel$export(module.exports, "default", function () { return $be10107d5026b0eb$export$2e2bcd8739ae039; });

var $8tMCd = parcelRequire("8tMCd");

var $jbmdS = parcelRequire("jbmdS");
var $be10107d5026b0eb$export$24829b7c0e49e9f7 = "RC_FORM_INTERNAL_HOOKS";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var $be10107d5026b0eb$var$warningFunc = function warningFunc() {
    (0, $8tMCd.default)(false, "Can not find FormContext. Please make sure you wrap Field under Form.");
};
var $be10107d5026b0eb$var$Context = /*#__PURE__*/ $jbmdS.createContext({
    getFieldValue: $be10107d5026b0eb$var$warningFunc,
    getFieldsValue: $be10107d5026b0eb$var$warningFunc,
    getFieldError: $be10107d5026b0eb$var$warningFunc,
    getFieldWarning: $be10107d5026b0eb$var$warningFunc,
    getFieldsError: $be10107d5026b0eb$var$warningFunc,
    isFieldsTouched: $be10107d5026b0eb$var$warningFunc,
    isFieldTouched: $be10107d5026b0eb$var$warningFunc,
    isFieldValidating: $be10107d5026b0eb$var$warningFunc,
    isFieldsValidating: $be10107d5026b0eb$var$warningFunc,
    resetFields: $be10107d5026b0eb$var$warningFunc,
    setFields: $be10107d5026b0eb$var$warningFunc,
    setFieldValue: $be10107d5026b0eb$var$warningFunc,
    setFieldsValue: $be10107d5026b0eb$var$warningFunc,
    validateFields: $be10107d5026b0eb$var$warningFunc,
    submit: $be10107d5026b0eb$var$warningFunc,
    getInternalHooks: function getInternalHooks() {
        $be10107d5026b0eb$var$warningFunc();
        return {
            dispatch: $be10107d5026b0eb$var$warningFunc,
            initEntityValue: $be10107d5026b0eb$var$warningFunc,
            registerField: $be10107d5026b0eb$var$warningFunc,
            useSubscribe: $be10107d5026b0eb$var$warningFunc,
            setInitialValues: $be10107d5026b0eb$var$warningFunc,
            destroyForm: $be10107d5026b0eb$var$warningFunc,
            setCallbacks: $be10107d5026b0eb$var$warningFunc,
            registerWatch: $be10107d5026b0eb$var$warningFunc,
            getFields: $be10107d5026b0eb$var$warningFunc,
            setValidateMessages: $be10107d5026b0eb$var$warningFunc,
            setPreserve: $be10107d5026b0eb$var$warningFunc,
            getInitialValue: $be10107d5026b0eb$var$warningFunc
        };
    }
});
var $be10107d5026b0eb$export$2e2bcd8739ae039 = $be10107d5026b0eb$var$Context;

});

parcelRegister("3KctZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b9f59cde7c73f7f$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");
var $2b9f59cde7c73f7f$var$ListContext = /*#__PURE__*/ $jbmdS.createContext(null);
var $2b9f59cde7c73f7f$export$2e2bcd8739ae039 = $2b9f59cde7c73f7f$var$ListContext;

});

parcelRegister("hsiPi", function(module, exports) {

$parcel$export(module.exports, "toArray", function () { return $cb53a7bab69fd480$export$45b10814cc054894; });
$parcel$export(module.exports, "isFormInstance", function () { return $cb53a7bab69fd480$export$717b316e73068e8d; });
function $cb53a7bab69fd480$export$45b10814cc054894(value) {
    if (value === undefined || value === null) return [];
    return Array.isArray(value) ? value : [
        value
    ];
}
function $cb53a7bab69fd480$export$717b316e73068e8d(form) {
    return form && !!form._init;
}

});

parcelRegister("4pq8s", function(module, exports) {

$parcel$export(module.exports, "validateRules", function () { return $335dc52bfc60ecee$export$e1fc4b442d0297dd; });

var $huwkX = parcelRequire("huwkX");

var $8K2NM = parcelRequire("8K2NM");

var $9TNqp = parcelRequire("9TNqp");

var $lv6ip = parcelRequire("lv6ip");

var $raxj3 = parcelRequire("raxj3");

var $7JU37 = parcelRequire("7JU37");

var $jbmdS = parcelRequire("jbmdS");

var $8tMCd = parcelRequire("8tMCd");

var $4G8fk = parcelRequire("4G8fk");

var $cbsvf = parcelRequire("cbsvf");
// Remove incorrect original ts define
var $335dc52bfc60ecee$var$AsyncValidator = (0, $7JU37.default);
/**
 * Replace with template.
 *   `I'm ${name}` + { name: 'bamboo' } = I'm bamboo
 */ function $335dc52bfc60ecee$var$replaceMessage(template, kv) {
    return template.replace(/\$\{\w+\}/g, function(str) {
        var key = str.slice(2, -1);
        return kv[key];
    });
}
var $335dc52bfc60ecee$var$CODE_LOGIC_ERROR = "CODE_LOGIC_ERROR";
function $335dc52bfc60ecee$var$validateRule(_x, _x2, _x3, _x4, _x5) {
    return $335dc52bfc60ecee$var$_validateRule.apply(this, arguments);
}
/**
 * We use `async-validator` to validate the value.
 * But only check one value in a time to avoid namePath validate issue.
 */ function $335dc52bfc60ecee$var$_validateRule() {
    $335dc52bfc60ecee$var$_validateRule = (0, $raxj3.default)(/*#__PURE__*/ (0, $9TNqp.default)().mark(function _callee2(name, value, rule, options, messageVariables) {
        var cloneRule, originValidator, subRuleField, validator, messages, result, subResults, kv, fillVariableResult;
        return (0, $9TNqp.default)().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    cloneRule = (0, $lv6ip.default)({}, rule); // Bug of `async-validator`
                    // https://github.com/react-component/field-form/issues/316
                    // https://github.com/react-component/field-form/issues/313
                    delete cloneRule.ruleIndex;
                    // https://github.com/ant-design/ant-design/issues/40497#issuecomment-1422282378
                    $335dc52bfc60ecee$var$AsyncValidator.warning = function() {
                        return void 0;
                    };
                    if (cloneRule.validator) {
                        originValidator = cloneRule.validator;
                        cloneRule.validator = function() {
                            try {
                                return originValidator.apply(void 0, arguments);
                            } catch (error) {
                                console.error(error);
                                return Promise.reject($335dc52bfc60ecee$var$CODE_LOGIC_ERROR);
                            }
                        };
                    }
                    // We should special handle array validate
                    subRuleField = null;
                    if (cloneRule && cloneRule.type === "array" && cloneRule.defaultField) {
                        subRuleField = cloneRule.defaultField;
                        delete cloneRule.defaultField;
                    }
                    validator = new $335dc52bfc60ecee$var$AsyncValidator((0, $8K2NM.default)({}, name, [
                        cloneRule
                    ]));
                    messages = (0, $cbsvf.merge)((0, $4G8fk.defaultValidateMessages), options.validateMessages);
                    validator.messages(messages);
                    result = [];
                    _context2.prev = 10;
                    _context2.next = 13;
                    return Promise.resolve(validator.validate((0, $8K2NM.default)({}, name, value), (0, $lv6ip.default)({}, options)));
                case 13:
                    _context2.next = 18;
                    break;
                case 15:
                    _context2.prev = 15;
                    _context2.t0 = _context2["catch"](10);
                    if (_context2.t0.errors) result = _context2.t0.errors.map(function(_ref4, index) {
                        var message = _ref4.message;
                        var mergedMessage = message === $335dc52bfc60ecee$var$CODE_LOGIC_ERROR ? messages.default : message;
                        return /*#__PURE__*/ $jbmdS.isValidElement(mergedMessage) ? /*#__PURE__*/ // Wrap ReactNode with `key`
                        $jbmdS.cloneElement(mergedMessage, {
                            key: "error_".concat(index)
                        }) : mergedMessage;
                    });
                case 18:
                    if (!(!result.length && subRuleField)) {
                        _context2.next = 23;
                        break;
                    }
                    _context2.next = 21;
                    return Promise.all(value.map(function(subValue, i) {
                        return $335dc52bfc60ecee$var$validateRule("".concat(name, ".").concat(i), subValue, subRuleField, options, messageVariables);
                    }));
                case 21:
                    subResults = _context2.sent;
                    return _context2.abrupt("return", subResults.reduce(function(prev, errors) {
                        return [].concat((0, $huwkX.default)(prev), (0, $huwkX.default)(errors));
                    }, []));
                case 23:
                    // Replace message with variables
                    kv = (0, $lv6ip.default)((0, $lv6ip.default)({}, rule), {}, {
                        name: name,
                        enum: (rule.enum || []).join(", ")
                    }, messageVariables);
                    fillVariableResult = result.map(function(error) {
                        if (typeof error === "string") return $335dc52bfc60ecee$var$replaceMessage(error, kv);
                        return error;
                    });
                    return _context2.abrupt("return", fillVariableResult);
                case 26:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                10,
                15
            ]
        ]);
    }));
    return $335dc52bfc60ecee$var$_validateRule.apply(this, arguments);
}
function $335dc52bfc60ecee$export$e1fc4b442d0297dd(namePath, value, rules, options, validateFirst, messageVariables) {
    var name = namePath.join(".");
    // Fill rule with context
    var filledRules = rules.map(function(currentRule, ruleIndex) {
        var originValidatorFunc = currentRule.validator;
        var cloneRule = (0, $lv6ip.default)((0, $lv6ip.default)({}, currentRule), {}, {
            ruleIndex: ruleIndex
        });
        // Replace validator if needed
        if (originValidatorFunc) cloneRule.validator = function(rule, val, callback) {
            var hasPromise = false;
            // Wrap callback only accept when promise not provided
            var wrappedCallback = function wrappedCallback() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                // Wait a tick to make sure return type is a promise
                Promise.resolve().then(function() {
                    (0, $8tMCd.default)(!hasPromise, "Your validator function has already return a promise. `callback` will be ignored.");
                    if (!hasPromise) callback.apply(void 0, args);
                });
            };
            // Get promise
            var promise = originValidatorFunc(rule, val, wrappedCallback);
            hasPromise = promise && typeof promise.then === "function" && typeof promise.catch === "function";
            /**
         * 1. Use promise as the first priority.
         * 2. If promise not exist, use callback with warning instead
         */ (0, $8tMCd.default)(hasPromise, "`callback` is deprecated. Please return a promise instead.");
            if (hasPromise) promise.then(function() {
                callback();
            }).catch(function(err) {
                callback(err || " ");
            });
        };
        return cloneRule;
    }).sort(function(_ref, _ref2) {
        var w1 = _ref.warningOnly, i1 = _ref.ruleIndex;
        var w2 = _ref2.warningOnly, i2 = _ref2.ruleIndex;
        if (!!w1 === !!w2) // Let keep origin order
        return i1 - i2;
        if (w1) return 1;
        return -1;
    });
    // Do validate rules
    var summaryPromise;
    if (validateFirst === true) // >>>>> Validate by serialization
    summaryPromise = new Promise(/*#__PURE__*/ function() {
        var _ref3 = (0, $raxj3.default)(/*#__PURE__*/ (0, $9TNqp.default)().mark(function _callee(resolve, reject) {
            var i, rule, errors;
            return (0, $9TNqp.default)().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        i = 0;
                    case 1:
                        if (!(i < filledRules.length)) {
                            _context.next = 12;
                            break;
                        }
                        rule = filledRules[i];
                        _context.next = 5;
                        return $335dc52bfc60ecee$var$validateRule(name, value, rule, options, messageVariables);
                    case 5:
                        errors = _context.sent;
                        if (!errors.length) {
                            _context.next = 9;
                            break;
                        }
                        reject([
                            {
                                errors: errors,
                                rule: rule
                            }
                        ]);
                        return _context.abrupt("return");
                    case 9:
                        i += 1;
                        _context.next = 1;
                        break;
                    case 12:
                        /* eslint-enable */ resolve([]);
                    case 13:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }));
        return function(_x6, _x7) {
            return _ref3.apply(this, arguments);
        };
    }());
    else {
        // >>>>> Validate by parallel
        var rulePromises = filledRules.map(function(rule) {
            return $335dc52bfc60ecee$var$validateRule(name, value, rule, options, messageVariables).then(function(errors) {
                return {
                    errors: errors,
                    rule: rule
                };
            });
        });
        summaryPromise = (validateFirst ? $335dc52bfc60ecee$var$finishOnFirstFailed(rulePromises) : $335dc52bfc60ecee$var$finishOnAllFailed(rulePromises)).then(function(errors) {
            // Always change to rejection for Field to catch
            return Promise.reject(errors);
        });
    }
    // Internal catch error to avoid console error log.
    summaryPromise.catch(function(e) {
        return e;
    });
    return summaryPromise;
}
function $335dc52bfc60ecee$var$finishOnAllFailed(_x8) {
    return $335dc52bfc60ecee$var$_finishOnAllFailed.apply(this, arguments);
}
function $335dc52bfc60ecee$var$_finishOnAllFailed() {
    $335dc52bfc60ecee$var$_finishOnAllFailed = (0, $raxj3.default)(/*#__PURE__*/ (0, $9TNqp.default)().mark(function _callee3(rulePromises) {
        return (0, $9TNqp.default)().wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    return _context3.abrupt("return", Promise.all(rulePromises).then(function(errorsList) {
                        var _ref5;
                        var errors = (_ref5 = []).concat.apply(_ref5, (0, $huwkX.default)(errorsList));
                        return errors;
                    }));
                case 1:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return $335dc52bfc60ecee$var$_finishOnAllFailed.apply(this, arguments);
}
function $335dc52bfc60ecee$var$finishOnFirstFailed(_x9) {
    return $335dc52bfc60ecee$var$_finishOnFirstFailed.apply(this, arguments);
}
function $335dc52bfc60ecee$var$_finishOnFirstFailed() {
    $335dc52bfc60ecee$var$_finishOnFirstFailed = (0, $raxj3.default)(/*#__PURE__*/ (0, $9TNqp.default)().mark(function _callee4(rulePromises) {
        var count;
        return (0, $9TNqp.default)().wrap(function _callee4$(_context4) {
            while(true)switch(_context4.prev = _context4.next){
                case 0:
                    count = 0;
                    return _context4.abrupt("return", new Promise(function(resolve) {
                        rulePromises.forEach(function(promise) {
                            promise.then(function(ruleError) {
                                if (ruleError.errors.length) resolve([
                                    ruleError
                                ]);
                                count += 1;
                                if (count === rulePromises.length) resolve([]);
                            });
                        });
                    }));
                case 2:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return $335dc52bfc60ecee$var$_finishOnFirstFailed.apply(this, arguments);
}

});
parcelRegister("7JU37", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a28369ee5cb6488$export$2e2bcd8739ae039; });

var $2Prz7 = parcelRequire("2Prz7");
function $5a28369ee5cb6488$var$_extends() {
    $5a28369ee5cb6488$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5a28369ee5cb6488$var$_extends.apply(this, arguments);
}
function $5a28369ee5cb6488$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $5a28369ee5cb6488$var$_setPrototypeOf(subClass, superClass);
}
function $5a28369ee5cb6488$var$_getPrototypeOf(o) {
    $5a28369ee5cb6488$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $5a28369ee5cb6488$var$_getPrototypeOf(o);
}
function $5a28369ee5cb6488$var$_setPrototypeOf(o, p) {
    $5a28369ee5cb6488$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $5a28369ee5cb6488$var$_setPrototypeOf(o, p);
}
function $5a28369ee5cb6488$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $5a28369ee5cb6488$var$_construct(Parent, args, Class) {
    if ($5a28369ee5cb6488$var$_isNativeReflectConstruct()) $5a28369ee5cb6488$var$_construct = Reflect.construct.bind();
    else $5a28369ee5cb6488$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $5a28369ee5cb6488$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $5a28369ee5cb6488$var$_construct.apply(null, arguments);
}
function $5a28369ee5cb6488$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $5a28369ee5cb6488$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $5a28369ee5cb6488$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$5a28369ee5cb6488$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $5a28369ee5cb6488$var$_construct(Class, arguments, $5a28369ee5cb6488$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $5a28369ee5cb6488$var$_setPrototypeOf(Wrapper, Class);
    };
    return $5a28369ee5cb6488$var$_wrapNativeSuper(Class);
}
/* eslint no-console:0 */ var $5a28369ee5cb6488$var$formatRegExp = /%[sdj%]/g;
var $5a28369ee5cb6488$var$warning = function warning() {}; // don't print warning message when in production env or node runtime
typeof $2Prz7 !== "undefined" && $2Prz7.env;
function $5a28369ee5cb6488$var$convertFieldsError(errors) {
    if (!errors || !errors.length) return null;
    var fields = {};
    errors.forEach(function(error) {
        var field = error.field;
        fields[field] = fields[field] || [];
        fields[field].push(error);
    });
    return fields;
}
function $5a28369ee5cb6488$var$format(template) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var i = 0;
    var len = args.length;
    if (typeof template === "function") return template.apply(null, args);
    if (typeof template === "string") {
        var str = template.replace($5a28369ee5cb6488$var$formatRegExp, function(x) {
            if (x === "%%") return "%";
            if (i >= len) return x;
            switch(x){
                case "%s":
                    return String(args[i++]);
                case "%d":
                    return Number(args[i++]);
                case "%j":
                    try {
                        return JSON.stringify(args[i++]);
                    } catch (_) {
                        return "[Circular]";
                    }
                    break;
                default:
                    return x;
            }
        });
        return str;
    }
    return template;
}
function $5a28369ee5cb6488$var$isNativeStringType(type) {
    return type === "string" || type === "url" || type === "hex" || type === "email" || type === "date" || type === "pattern";
}
function $5a28369ee5cb6488$var$isEmptyValue(value, type) {
    if (value === undefined || value === null) return true;
    if (type === "array" && Array.isArray(value) && !value.length) return true;
    if ($5a28369ee5cb6488$var$isNativeStringType(type) && typeof value === "string" && !value) return true;
    return false;
}
function $5a28369ee5cb6488$var$asyncParallelArray(arr, func, callback) {
    var results = [];
    var total = 0;
    var arrLength = arr.length;
    function count(errors) {
        results.push.apply(results, errors || []);
        total++;
        if (total === arrLength) callback(results);
    }
    arr.forEach(function(a) {
        func(a, count);
    });
}
function $5a28369ee5cb6488$var$asyncSerialArray(arr, func, callback) {
    var index = 0;
    var arrLength = arr.length;
    function next(errors) {
        if (errors && errors.length) {
            callback(errors);
            return;
        }
        var original = index;
        index = index + 1;
        if (original < arrLength) func(arr[original], next);
        else callback([]);
    }
    next([]);
}
function $5a28369ee5cb6488$var$flattenObjArr(objArr) {
    var ret = [];
    Object.keys(objArr).forEach(function(k) {
        ret.push.apply(ret, objArr[k] || []);
    });
    return ret;
}
var $5a28369ee5cb6488$var$AsyncValidationError = /*#__PURE__*/ function(_Error) {
    $5a28369ee5cb6488$var$_inheritsLoose(AsyncValidationError, _Error);
    function AsyncValidationError(errors, fields) {
        var _this;
        _this = _Error.call(this, "Async Validation Error") || this;
        _this.errors = errors;
        _this.fields = fields;
        return _this;
    }
    return AsyncValidationError;
}(/*#__PURE__*/ $5a28369ee5cb6488$var$_wrapNativeSuper(Error));
function $5a28369ee5cb6488$var$asyncMap(objArr, option, func, callback, source) {
    if (option.first) {
        var _pending = new Promise(function(resolve, reject) {
            var next = function next(errors) {
                callback(errors);
                return errors.length ? reject(new $5a28369ee5cb6488$var$AsyncValidationError(errors, $5a28369ee5cb6488$var$convertFieldsError(errors))) : resolve(source);
            };
            var flattenArr = $5a28369ee5cb6488$var$flattenObjArr(objArr);
            $5a28369ee5cb6488$var$asyncSerialArray(flattenArr, func, next);
        });
        _pending["catch"](function(e) {
            return e;
        });
        return _pending;
    }
    var firstFields = option.firstFields === true ? Object.keys(objArr) : option.firstFields || [];
    var objArrKeys = Object.keys(objArr);
    var objArrLength = objArrKeys.length;
    var total = 0;
    var results = [];
    var pending = new Promise(function(resolve, reject) {
        var next = function next(errors) {
            results.push.apply(results, errors);
            total++;
            if (total === objArrLength) {
                callback(results);
                return results.length ? reject(new $5a28369ee5cb6488$var$AsyncValidationError(results, $5a28369ee5cb6488$var$convertFieldsError(results))) : resolve(source);
            }
        };
        if (!objArrKeys.length) {
            callback(results);
            resolve(source);
        }
        objArrKeys.forEach(function(key) {
            var arr = objArr[key];
            if (firstFields.indexOf(key) !== -1) $5a28369ee5cb6488$var$asyncSerialArray(arr, func, next);
            else $5a28369ee5cb6488$var$asyncParallelArray(arr, func, next);
        });
    });
    pending["catch"](function(e) {
        return e;
    });
    return pending;
}
function $5a28369ee5cb6488$var$isErrorObj(obj) {
    return !!(obj && obj.message !== undefined);
}
function $5a28369ee5cb6488$var$getValue(value, path) {
    var v = value;
    for(var i = 0; i < path.length; i++){
        if (v == undefined) return v;
        v = v[path[i]];
    }
    return v;
}
function $5a28369ee5cb6488$var$complementError(rule, source) {
    return function(oe) {
        var fieldValue;
        if (rule.fullFields) fieldValue = $5a28369ee5cb6488$var$getValue(source, rule.fullFields);
        else fieldValue = source[oe.field || rule.fullField];
        if ($5a28369ee5cb6488$var$isErrorObj(oe)) {
            oe.field = oe.field || rule.fullField;
            oe.fieldValue = fieldValue;
            return oe;
        }
        return {
            message: typeof oe === "function" ? oe() : oe,
            fieldValue: fieldValue,
            field: oe.field || rule.fullField
        };
    };
}
function $5a28369ee5cb6488$var$deepMerge(target, source) {
    if (source) {
        for(var s in source)if (source.hasOwnProperty(s)) {
            var value = source[s];
            if (typeof value === "object" && typeof target[s] === "object") target[s] = $5a28369ee5cb6488$var$_extends({}, target[s], value);
            else target[s] = value;
        }
    }
    return target;
}
var $5a28369ee5cb6488$var$required$1 = function required(rule, value, source, errors, options, type) {
    if (rule.required && (!source.hasOwnProperty(rule.field) || $5a28369ee5cb6488$var$isEmptyValue(value, type || rule.type))) errors.push($5a28369ee5cb6488$var$format(options.messages.required, rule.fullField));
};
/**
 *  Rule for validating whitespace.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */ var $5a28369ee5cb6488$var$whitespace = function whitespace(rule, value, source, errors, options) {
    if (/^\s+$/.test(value) || value === "") errors.push($5a28369ee5cb6488$var$format(options.messages.whitespace, rule.fullField));
};
// https://github.com/kevva/url-regex/blob/master/index.js
var $5a28369ee5cb6488$var$urlReg;
var $5a28369ee5cb6488$var$getUrlRegex = function() {
    if ($5a28369ee5cb6488$var$urlReg) return $5a28369ee5cb6488$var$urlReg;
    var word = "[a-fA-F\\d:]";
    var b = function b(options) {
        return options && options.includeBoundaries ? "(?:(?<=\\s|^)(?=" + word + ")|(?<=" + word + ")(?=\\s|$))" : "";
    };
    var v4 = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}";
    var v6seg = "[a-fA-F\\d]{1,4}";
    var v6 = ("\n(?:\n(?:" + v6seg + ":){7}(?:" + v6seg + "|:)|                                    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8\n(?:" + v6seg + ":){6}(?:" + v4 + "|:" + v6seg + "|:)|                             // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::1.2.3.4\n(?:" + v6seg + ":){5}(?::" + v4 + "|(?::" + v6seg + "){1,2}|:)|                   // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::7:1.2.3.4\n(?:" + v6seg + ":){4}(?:(?::" + v6seg + "){0,1}:" + v4 + "|(?::" + v6seg + "){1,3}|:)| // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::6:7:1.2.3.4\n(?:" + v6seg + ":){3}(?:(?::" + v6seg + "){0,2}:" + v4 + "|(?::" + v6seg + "){1,4}|:)| // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::5:6:7:1.2.3.4\n(?:" + v6seg + ":){2}(?:(?::" + v6seg + "){0,3}:" + v4 + "|(?::" + v6seg + "){1,5}|:)| // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::4:5:6:7:1.2.3.4\n(?:" + v6seg + ":){1}(?:(?::" + v6seg + "){0,4}:" + v4 + "|(?::" + v6seg + "){1,6}|:)| // 1::              1::3:4:5:6:7:8   1::8            1::3:4:5:6:7:1.2.3.4\n(?::(?:(?::" + v6seg + "){0,5}:" + v4 + "|(?::" + v6seg + "){1,7}|:))             // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::1.2.3.4\n)(?:%[0-9a-zA-Z]{1,})?                                             // %eth0            %1\n").replace(/\s*\/\/.*$/gm, "").replace(/\n/g, "").trim(); // Pre-compile only the exact regexes because adding a global flag make regexes stateful
    var v46Exact = new RegExp("(?:^" + v4 + "$)|(?:^" + v6 + "$)");
    var v4exact = new RegExp("^" + v4 + "$");
    var v6exact = new RegExp("^" + v6 + "$");
    var ip = function ip(options) {
        return options && options.exact ? v46Exact : new RegExp("(?:" + b(options) + v4 + b(options) + ")|(?:" + b(options) + v6 + b(options) + ")", "g");
    };
    ip.v4 = function(options) {
        return options && options.exact ? v4exact : new RegExp("" + b(options) + v4 + b(options), "g");
    };
    ip.v6 = function(options) {
        return options && options.exact ? v6exact : new RegExp("" + b(options) + v6 + b(options), "g");
    };
    var protocol = "(?:(?:[a-z]+:)?//)";
    var auth = "(?:\\S+(?::\\S*)?@)?";
    var ipv4 = ip.v4().source;
    var ipv6 = ip.v6().source;
    var host = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)";
    var domain = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*";
    var tld = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))";
    var port = "(?::\\d{2,5})?";
    var path = '(?:[/?#][^\\s"]*)?';
    var regex = "(?:" + protocol + "|www\\.)" + auth + "(?:localhost|" + ipv4 + "|" + ipv6 + "|" + host + domain + tld + ")" + port + path;
    $5a28369ee5cb6488$var$urlReg = new RegExp("(?:^" + regex + "$)", "i");
    return $5a28369ee5cb6488$var$urlReg;
};
/* eslint max-len:0 */ var $5a28369ee5cb6488$var$pattern$2 = {
    // http://emailregex.com/
    email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
    // url: new RegExp(
    //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
    //   'i',
    // ),
    hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};
var $5a28369ee5cb6488$var$types = {
    integer: function integer(value) {
        return $5a28369ee5cb6488$var$types.number(value) && parseInt(value, 10) === value;
    },
    "float": function float(value) {
        return $5a28369ee5cb6488$var$types.number(value) && !$5a28369ee5cb6488$var$types.integer(value);
    },
    array: function array(value) {
        return Array.isArray(value);
    },
    regexp: function regexp(value) {
        if (value instanceof RegExp) return true;
        try {
            return new RegExp(value), true;
        } catch (e) {
            return false;
        }
    },
    date: function date(value) {
        return typeof value.getTime === "function" && typeof value.getMonth === "function" && typeof value.getYear === "function" && !isNaN(value.getTime());
    },
    number: function number(value) {
        if (isNaN(value)) return false;
        return typeof value === "number";
    },
    object: function object(value) {
        return typeof value === "object" && !$5a28369ee5cb6488$var$types.array(value);
    },
    method: function method(value) {
        return typeof value === "function";
    },
    email: function email(value) {
        return typeof value === "string" && value.length <= 320 && !!value.match($5a28369ee5cb6488$var$pattern$2.email);
    },
    url: function url(value) {
        return typeof value === "string" && value.length <= 2048 && !!value.match($5a28369ee5cb6488$var$getUrlRegex());
    },
    hex: function hex(value) {
        return typeof value === "string" && !!value.match($5a28369ee5cb6488$var$pattern$2.hex);
    }
};
var $5a28369ee5cb6488$var$type$1 = function type(rule, value, source, errors, options) {
    if (rule.required && value === undefined) {
        $5a28369ee5cb6488$var$required$1(rule, value, source, errors, options);
        return;
    }
    var custom = [
        "integer",
        "float",
        "array",
        "regexp",
        "object",
        "method",
        "email",
        "number",
        "date",
        "url",
        "hex"
    ];
    var ruleType = rule.type;
    if (custom.indexOf(ruleType) > -1) {
        if (!$5a28369ee5cb6488$var$types[ruleType](value)) errors.push($5a28369ee5cb6488$var$format(options.messages.types[ruleType], rule.fullField, rule.type));
         // straight typeof check
    } else if (ruleType && typeof value !== rule.type) errors.push($5a28369ee5cb6488$var$format(options.messages.types[ruleType], rule.fullField, rule.type));
};
var $5a28369ee5cb6488$var$range = function range(rule, value, source, errors, options) {
    var len = typeof rule.len === "number";
    var min = typeof rule.min === "number";
    var max = typeof rule.max === "number"; // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
    var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
    var val = value;
    var key = null;
    var num = typeof value === "number";
    var str = typeof value === "string";
    var arr = Array.isArray(value);
    if (num) key = "number";
    else if (str) key = "string";
    else if (arr) key = "array";
     // if the value is not of a supported type for range validation
    // the validation rule rule should use the
    // type property to also test for a particular type
    if (!key) return false;
    if (arr) val = value.length;
    if (str) // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".lenght !== 3
    val = value.replace(spRegexp, "_").length;
    if (len) {
        if (val !== rule.len) errors.push($5a28369ee5cb6488$var$format(options.messages[key].len, rule.fullField, rule.len));
    } else if (min && !max && val < rule.min) errors.push($5a28369ee5cb6488$var$format(options.messages[key].min, rule.fullField, rule.min));
    else if (max && !min && val > rule.max) errors.push($5a28369ee5cb6488$var$format(options.messages[key].max, rule.fullField, rule.max));
    else if (min && max && (val < rule.min || val > rule.max)) errors.push($5a28369ee5cb6488$var$format(options.messages[key].range, rule.fullField, rule.min, rule.max));
};
var $5a28369ee5cb6488$var$ENUM$1 = "enum";
var $5a28369ee5cb6488$var$enumerable$1 = function enumerable(rule, value, source, errors, options) {
    rule[$5a28369ee5cb6488$var$ENUM$1] = Array.isArray(rule[$5a28369ee5cb6488$var$ENUM$1]) ? rule[$5a28369ee5cb6488$var$ENUM$1] : [];
    if (rule[$5a28369ee5cb6488$var$ENUM$1].indexOf(value) === -1) errors.push($5a28369ee5cb6488$var$format(options.messages[$5a28369ee5cb6488$var$ENUM$1], rule.fullField, rule[$5a28369ee5cb6488$var$ENUM$1].join(", ")));
};
var $5a28369ee5cb6488$var$pattern$1 = function pattern(rule, value, source, errors, options) {
    if (rule.pattern) {
        if (rule.pattern instanceof RegExp) {
            // if a RegExp instance is passed, reset `lastIndex` in case its `global`
            // flag is accidentally set to `true`, which in a validation scenario
            // is not necessary and the result might be misleading
            rule.pattern.lastIndex = 0;
            if (!rule.pattern.test(value)) errors.push($5a28369ee5cb6488$var$format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
        } else if (typeof rule.pattern === "string") {
            var _pattern = new RegExp(rule.pattern);
            if (!_pattern.test(value)) errors.push($5a28369ee5cb6488$var$format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
        }
    }
};
var $5a28369ee5cb6488$var$rules = {
    required: $5a28369ee5cb6488$var$required$1,
    whitespace: $5a28369ee5cb6488$var$whitespace,
    type: $5a28369ee5cb6488$var$type$1,
    range: $5a28369ee5cb6488$var$range,
    "enum": $5a28369ee5cb6488$var$enumerable$1,
    pattern: $5a28369ee5cb6488$var$pattern$1
};
var $5a28369ee5cb6488$var$string = function string(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($5a28369ee5cb6488$var$isEmptyValue(value, "string") && !rule.required) return callback();
        $5a28369ee5cb6488$var$rules.required(rule, value, source, errors, options, "string");
        if (!$5a28369ee5cb6488$var$isEmptyValue(value, "string")) {
            $5a28369ee5cb6488$var$rules.type(rule, value, source, errors, options);
            $5a28369ee5cb6488$var$rules.range(rule, value, source, errors, options);
            $5a28369ee5cb6488$var$rules.pattern(rule, value, source, errors, options);
            if (rule.whitespace === true) $5a28369ee5cb6488$var$rules.whitespace(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $5a28369ee5cb6488$var$method = function method(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($5a28369ee5cb6488$var$isEmptyValue(value) && !rule.required) return callback();
        $5a28369ee5cb6488$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) $5a28369ee5cb6488$var$rules.type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $5a28369ee5cb6488$var$number = function number(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if (value === "") value = undefined;
        if ($5a28369ee5cb6488$var$isEmptyValue(value) && !rule.required) return callback();
        $5a28369ee5cb6488$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) {
            $5a28369ee5cb6488$var$rules.type(rule, value, source, errors, options);
            $5a28369ee5cb6488$var$rules.range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $5a28369ee5cb6488$var$_boolean = function _boolean(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($5a28369ee5cb6488$var$isEmptyValue(value) && !rule.required) return callback();
        $5a28369ee5cb6488$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) $5a28369ee5cb6488$var$rules.type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $5a28369ee5cb6488$var$regexp = function regexp(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($5a28369ee5cb6488$var$isEmptyValue(value) && !rule.required) return callback();
        $5a28369ee5cb6488$var$rules.required(rule, value, source, errors, options);
        if (!$5a28369ee5cb6488$var$isEmptyValue(value)) $5a28369ee5cb6488$var$rules.type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $5a28369ee5cb6488$var$integer = function integer(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($5a28369ee5cb6488$var$isEmptyValue(value) && !rule.required) return callback();
        $5a28369ee5cb6488$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) {
            $5a28369ee5cb6488$var$rules.type(rule, value, source, errors, options);
            $5a28369ee5cb6488$var$rules.range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $5a28369ee5cb6488$var$floatFn = function floatFn(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($5a28369ee5cb6488$var$isEmptyValue(value) && !rule.required) return callback();
        $5a28369ee5cb6488$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) {
            $5a28369ee5cb6488$var$rules.type(rule, value, source, errors, options);
            $5a28369ee5cb6488$var$rules.range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $5a28369ee5cb6488$var$array = function array(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((value === undefined || value === null) && !rule.required) return callback();
        $5a28369ee5cb6488$var$rules.required(rule, value, source, errors, options, "array");
        if (value !== undefined && value !== null) {
            $5a28369ee5cb6488$var$rules.type(rule, value, source, errors, options);
            $5a28369ee5cb6488$var$rules.range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $5a28369ee5cb6488$var$object = function object(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($5a28369ee5cb6488$var$isEmptyValue(value) && !rule.required) return callback();
        $5a28369ee5cb6488$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) $5a28369ee5cb6488$var$rules.type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $5a28369ee5cb6488$var$ENUM = "enum";
var $5a28369ee5cb6488$var$enumerable = function enumerable(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($5a28369ee5cb6488$var$isEmptyValue(value) && !rule.required) return callback();
        $5a28369ee5cb6488$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) $5a28369ee5cb6488$var$rules[$5a28369ee5cb6488$var$ENUM](rule, value, source, errors, options);
    }
    callback(errors);
};
var $5a28369ee5cb6488$var$pattern = function pattern(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($5a28369ee5cb6488$var$isEmptyValue(value, "string") && !rule.required) return callback();
        $5a28369ee5cb6488$var$rules.required(rule, value, source, errors, options);
        if (!$5a28369ee5cb6488$var$isEmptyValue(value, "string")) $5a28369ee5cb6488$var$rules.pattern(rule, value, source, errors, options);
    }
    callback(errors);
};
var $5a28369ee5cb6488$var$date = function date(rule, value, callback, source, options) {
    // console.log('integer rule called %j', rule);
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field); // console.log('validate on %s value', value);
    if (validate) {
        if ($5a28369ee5cb6488$var$isEmptyValue(value, "date") && !rule.required) return callback();
        $5a28369ee5cb6488$var$rules.required(rule, value, source, errors, options);
        if (!$5a28369ee5cb6488$var$isEmptyValue(value, "date")) {
            var dateObject;
            if (value instanceof Date) dateObject = value;
            else dateObject = new Date(value);
            $5a28369ee5cb6488$var$rules.type(rule, dateObject, source, errors, options);
            if (dateObject) $5a28369ee5cb6488$var$rules.range(rule, dateObject.getTime(), source, errors, options);
        }
    }
    callback(errors);
};
var $5a28369ee5cb6488$var$required = function required(rule, value, callback, source, options) {
    var errors = [];
    var type = Array.isArray(value) ? "array" : typeof value;
    $5a28369ee5cb6488$var$rules.required(rule, value, source, errors, options, type);
    callback(errors);
};
var $5a28369ee5cb6488$var$type = function type(rule, value, callback, source, options) {
    var ruleType = rule.type;
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($5a28369ee5cb6488$var$isEmptyValue(value, ruleType) && !rule.required) return callback();
        $5a28369ee5cb6488$var$rules.required(rule, value, source, errors, options, ruleType);
        if (!$5a28369ee5cb6488$var$isEmptyValue(value, ruleType)) $5a28369ee5cb6488$var$rules.type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $5a28369ee5cb6488$var$any = function any(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($5a28369ee5cb6488$var$isEmptyValue(value) && !rule.required) return callback();
        $5a28369ee5cb6488$var$rules.required(rule, value, source, errors, options);
    }
    callback(errors);
};
var $5a28369ee5cb6488$var$validators = {
    string: $5a28369ee5cb6488$var$string,
    method: $5a28369ee5cb6488$var$method,
    number: $5a28369ee5cb6488$var$number,
    "boolean": $5a28369ee5cb6488$var$_boolean,
    regexp: $5a28369ee5cb6488$var$regexp,
    integer: $5a28369ee5cb6488$var$integer,
    "float": $5a28369ee5cb6488$var$floatFn,
    array: $5a28369ee5cb6488$var$array,
    object: $5a28369ee5cb6488$var$object,
    "enum": $5a28369ee5cb6488$var$enumerable,
    pattern: $5a28369ee5cb6488$var$pattern,
    date: $5a28369ee5cb6488$var$date,
    url: $5a28369ee5cb6488$var$type,
    hex: $5a28369ee5cb6488$var$type,
    email: $5a28369ee5cb6488$var$type,
    required: $5a28369ee5cb6488$var$required,
    any: $5a28369ee5cb6488$var$any
};
function $5a28369ee5cb6488$var$newMessages() {
    return {
        "default": "Validation error on field %s",
        required: "%s is required",
        "enum": "%s must be one of %s",
        whitespace: "%s cannot be empty",
        date: {
            format: "%s date %s is invalid for format %s",
            parse: "%s date could not be parsed, %s is invalid ",
            invalid: "%s date %s is invalid"
        },
        types: {
            string: "%s is not a %s",
            method: "%s is not a %s (function)",
            array: "%s is not an %s",
            object: "%s is not an %s",
            number: "%s is not a %s",
            date: "%s is not a %s",
            "boolean": "%s is not a %s",
            integer: "%s is not an %s",
            "float": "%s is not a %s",
            regexp: "%s is not a valid %s",
            email: "%s is not a valid %s",
            url: "%s is not a valid %s",
            hex: "%s is not a valid %s"
        },
        string: {
            len: "%s must be exactly %s characters",
            min: "%s must be at least %s characters",
            max: "%s cannot be longer than %s characters",
            range: "%s must be between %s and %s characters"
        },
        number: {
            len: "%s must equal %s",
            min: "%s cannot be less than %s",
            max: "%s cannot be greater than %s",
            range: "%s must be between %s and %s"
        },
        array: {
            len: "%s must be exactly %s in length",
            min: "%s cannot be less than %s in length",
            max: "%s cannot be greater than %s in length",
            range: "%s must be between %s and %s in length"
        },
        pattern: {
            mismatch: "%s value %s does not match pattern %s"
        },
        clone: function clone() {
            var cloned = JSON.parse(JSON.stringify(this));
            cloned.clone = this.clone;
            return cloned;
        }
    };
}
var $5a28369ee5cb6488$var$messages = $5a28369ee5cb6488$var$newMessages();
/**
 *  Encapsulates a validation schema.
 *
 *  @param descriptor An object declaring validation rules
 *  for this schema.
 */ var $5a28369ee5cb6488$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    // ========================= Static =========================
    // ======================== Instance ========================
    function Schema(descriptor) {
        this.rules = null;
        this._messages = $5a28369ee5cb6488$var$messages;
        this.define(descriptor);
    }
    var _proto = Schema.prototype;
    _proto.define = function define(rules) {
        var _this = this;
        if (!rules) throw new Error("Cannot configure a schema with no rules");
        if (typeof rules !== "object" || Array.isArray(rules)) throw new Error("Rules must be an object");
        this.rules = {};
        Object.keys(rules).forEach(function(name) {
            var item = rules[name];
            _this.rules[name] = Array.isArray(item) ? item : [
                item
            ];
        });
    };
    _proto.messages = function messages(_messages) {
        if (_messages) this._messages = $5a28369ee5cb6488$var$deepMerge($5a28369ee5cb6488$var$newMessages(), _messages);
        return this._messages;
    };
    _proto.validate = function validate(source_, o, oc) {
        var _this2 = this;
        if (o === void 0) o = {};
        if (oc === void 0) oc = function oc() {};
        var source = source_;
        var options = o;
        var callback = oc;
        if (typeof options === "function") {
            callback = options;
            options = {};
        }
        if (!this.rules || Object.keys(this.rules).length === 0) {
            if (callback) callback(null, source);
            return Promise.resolve(source);
        }
        function complete(results) {
            var errors = [];
            var fields = {};
            function add(e) {
                if (Array.isArray(e)) {
                    var _errors;
                    errors = (_errors = errors).concat.apply(_errors, e);
                } else errors.push(e);
            }
            for(var i = 0; i < results.length; i++)add(results[i]);
            if (!errors.length) callback(null, source);
            else {
                fields = $5a28369ee5cb6488$var$convertFieldsError(errors);
                callback(errors, fields);
            }
        }
        if (options.messages) {
            var messages$1 = this.messages();
            if (messages$1 === $5a28369ee5cb6488$var$messages) messages$1 = $5a28369ee5cb6488$var$newMessages();
            $5a28369ee5cb6488$var$deepMerge(messages$1, options.messages);
            options.messages = messages$1;
        } else options.messages = this.messages();
        var series = {};
        var keys = options.keys || Object.keys(this.rules);
        keys.forEach(function(z) {
            var arr = _this2.rules[z];
            var value = source[z];
            arr.forEach(function(r) {
                var rule = r;
                if (typeof rule.transform === "function") {
                    if (source === source_) source = $5a28369ee5cb6488$var$_extends({}, source);
                    value = source[z] = rule.transform(value);
                }
                if (typeof rule === "function") rule = {
                    validator: rule
                };
                else rule = $5a28369ee5cb6488$var$_extends({}, rule);
                 // Fill validator. Skip if nothing need to validate
                rule.validator = _this2.getValidationMethod(rule);
                if (!rule.validator) return;
                rule.field = z;
                rule.fullField = rule.fullField || z;
                rule.type = _this2.getType(rule);
                series[z] = series[z] || [];
                series[z].push({
                    rule: rule,
                    value: value,
                    source: source,
                    field: z
                });
            });
        });
        var errorFields = {};
        return $5a28369ee5cb6488$var$asyncMap(series, options, function(data, doIt) {
            var rule = data.rule;
            var deep = (rule.type === "object" || rule.type === "array") && (typeof rule.fields === "object" || typeof rule.defaultField === "object");
            deep = deep && (rule.required || !rule.required && data.value);
            rule.field = data.field;
            function addFullField(key, schema) {
                return $5a28369ee5cb6488$var$_extends({}, schema, {
                    fullField: rule.fullField + "." + key,
                    fullFields: rule.fullFields ? [].concat(rule.fullFields, [
                        key
                    ]) : [
                        key
                    ]
                });
            }
            function cb(e) {
                if (e === void 0) e = [];
                var errorList = Array.isArray(e) ? e : [
                    e
                ];
                if (!options.suppressWarning && errorList.length) Schema.warning("async-validator:", errorList);
                if (errorList.length && rule.message !== undefined) errorList = [].concat(rule.message);
                 // Fill error info
                var filledErrors = errorList.map($5a28369ee5cb6488$var$complementError(rule, source));
                if (options.first && filledErrors.length) {
                    errorFields[rule.field] = 1;
                    return doIt(filledErrors);
                }
                if (!deep) doIt(filledErrors);
                else {
                    // if rule is required but the target object
                    // does not exist fail at the rule level and don't
                    // go deeper
                    if (rule.required && !data.value) {
                        if (rule.message !== undefined) filledErrors = [].concat(rule.message).map($5a28369ee5cb6488$var$complementError(rule, source));
                        else if (options.error) filledErrors = [
                            options.error(rule, $5a28369ee5cb6488$var$format(options.messages.required, rule.field))
                        ];
                        return doIt(filledErrors);
                    }
                    var fieldsSchema = {};
                    if (rule.defaultField) Object.keys(data.value).map(function(key) {
                        fieldsSchema[key] = rule.defaultField;
                    });
                    fieldsSchema = $5a28369ee5cb6488$var$_extends({}, fieldsSchema, data.rule.fields);
                    var paredFieldsSchema = {};
                    Object.keys(fieldsSchema).forEach(function(field) {
                        var fieldSchema = fieldsSchema[field];
                        var fieldSchemaList = Array.isArray(fieldSchema) ? fieldSchema : [
                            fieldSchema
                        ];
                        paredFieldsSchema[field] = fieldSchemaList.map(addFullField.bind(null, field));
                    });
                    var schema = new Schema(paredFieldsSchema);
                    schema.messages(options.messages);
                    if (data.rule.options) {
                        data.rule.options.messages = options.messages;
                        data.rule.options.error = options.error;
                    }
                    schema.validate(data.value, data.rule.options || options, function(errs) {
                        var finalErrors = [];
                        if (filledErrors && filledErrors.length) finalErrors.push.apply(finalErrors, filledErrors);
                        if (errs && errs.length) finalErrors.push.apply(finalErrors, errs);
                        doIt(finalErrors.length ? finalErrors : null);
                    });
                }
            }
            var res;
            if (rule.asyncValidator) res = rule.asyncValidator(rule, data.value, cb, data.source, options);
            else if (rule.validator) {
                try {
                    res = rule.validator(rule, data.value, cb, data.source, options);
                } catch (error) {
                    console.error == null || console.error(error); // rethrow to report error
                    if (!options.suppressValidatorError) setTimeout(function() {
                        throw error;
                    }, 0);
                    cb(error.message);
                }
                if (res === true) cb();
                else if (res === false) cb(typeof rule.message === "function" ? rule.message(rule.fullField || rule.field) : rule.message || (rule.fullField || rule.field) + " fails");
                else if (res instanceof Array) cb(res);
                else if (res instanceof Error) cb(res.message);
            }
            if (res && res.then) res.then(function() {
                return cb();
            }, function(e) {
                return cb(e);
            });
        }, function(results) {
            complete(results);
        }, source);
    };
    _proto.getType = function getType(rule) {
        if (rule.type === undefined && rule.pattern instanceof RegExp) rule.type = "pattern";
        if (typeof rule.validator !== "function" && rule.type && !$5a28369ee5cb6488$var$validators.hasOwnProperty(rule.type)) throw new Error($5a28369ee5cb6488$var$format("Unknown rule type %s", rule.type));
        return rule.type || "string";
    };
    _proto.getValidationMethod = function getValidationMethod(rule) {
        if (typeof rule.validator === "function") return rule.validator;
        var keys = Object.keys(rule);
        var messageIndex = keys.indexOf("message");
        if (messageIndex !== -1) keys.splice(messageIndex, 1);
        if (keys.length === 1 && keys[0] === "required") return $5a28369ee5cb6488$var$validators.required;
        return $5a28369ee5cb6488$var$validators[this.getType(rule)] || undefined;
    };
    return Schema;
}();
$5a28369ee5cb6488$export$2e2bcd8739ae039.register = function register(type, validator) {
    if (typeof validator !== "function") throw new Error("Cannot register a validator by type, validator is not a function");
    $5a28369ee5cb6488$var$validators[type] = validator;
};
$5a28369ee5cb6488$export$2e2bcd8739ae039.warning = $5a28369ee5cb6488$var$warning;
$5a28369ee5cb6488$export$2e2bcd8739ae039.messages = $5a28369ee5cb6488$var$messages;
$5a28369ee5cb6488$export$2e2bcd8739ae039.validators = $5a28369ee5cb6488$var$validators;

});

parcelRegister("4G8fk", function(module, exports) {

$parcel$export(module.exports, "defaultValidateMessages", function () { return $36817b32926ee76f$export$c86b939816b8fbf8; });
var $36817b32926ee76f$var$typeTemplate = "'${name}' is not a valid ${type}";
var $36817b32926ee76f$export$c86b939816b8fbf8 = {
    default: "Validation error on field '${name}'",
    required: "'${name}' is required",
    enum: "'${name}' must be one of [${enum}]",
    whitespace: "'${name}' cannot be empty",
    date: {
        format: "'${name}' is invalid for format date",
        parse: "'${name}' could not be parsed as date",
        invalid: "'${name}' is invalid date"
    },
    types: {
        string: $36817b32926ee76f$var$typeTemplate,
        method: $36817b32926ee76f$var$typeTemplate,
        array: $36817b32926ee76f$var$typeTemplate,
        object: $36817b32926ee76f$var$typeTemplate,
        number: $36817b32926ee76f$var$typeTemplate,
        date: $36817b32926ee76f$var$typeTemplate,
        boolean: $36817b32926ee76f$var$typeTemplate,
        integer: $36817b32926ee76f$var$typeTemplate,
        float: $36817b32926ee76f$var$typeTemplate,
        regexp: $36817b32926ee76f$var$typeTemplate,
        email: $36817b32926ee76f$var$typeTemplate,
        url: $36817b32926ee76f$var$typeTemplate,
        hex: $36817b32926ee76f$var$typeTemplate
    },
    string: {
        len: "'${name}' must be exactly ${len} characters",
        min: "'${name}' must be at least ${min} characters",
        max: "'${name}' cannot be longer than ${max} characters",
        range: "'${name}' must be between ${min} and ${max} characters"
    },
    number: {
        len: "'${name}' must equal ${len}",
        min: "'${name}' cannot be less than ${min}",
        max: "'${name}' cannot be greater than ${max}",
        range: "'${name}' must be between ${min} and ${max}"
    },
    array: {
        len: "'${name}' must be exactly ${len} in length",
        min: "'${name}' cannot be less than ${min} in length",
        max: "'${name}' cannot be greater than ${max} in length",
        range: "'${name}' must be between ${min} and ${max} in length"
    },
    pattern: {
        mismatch: "'${name}' does not match pattern ${pattern}"
    }
};

});


parcelRegister("9OV34", function(module, exports) {

$parcel$export(module.exports, "getNamePath", function () { return $7265093a11dd24ab$export$f877b3cb4cb4ccf9; });
$parcel$export(module.exports, "cloneByNamePathList", function () { return $7265093a11dd24ab$export$f5be6dfb30403c59; });
$parcel$export(module.exports, "containsNamePath", function () { return $7265093a11dd24ab$export$646d5504364ae55b; });
$parcel$export(module.exports, "matchNamePath", function () { return $7265093a11dd24ab$export$325a4bd0e71bdc3a; });
$parcel$export(module.exports, "isSimilar", function () { return $7265093a11dd24ab$export$dfcec05bb7372a54; });
$parcel$export(module.exports, "defaultGetValueFromEvent", function () { return $7265093a11dd24ab$export$6eeac3c5b406fb30; });
$parcel$export(module.exports, "move", function () { return $7265093a11dd24ab$export$d947e5f4f4c48d48; });
$parcel$export(module.exports, "getValue", function () { return (parcelRequire("4eeUf")).default; });
$parcel$export(module.exports, "setValue", function () { return (parcelRequire("cbsvf")).default; });

var $huwkX = parcelRequire("huwkX");

var $jncUt = parcelRequire("jncUt");

var $4eeUf = parcelRequire("4eeUf");

var $cbsvf = parcelRequire("cbsvf");

var $hsiPi = parcelRequire("hsiPi");
function $7265093a11dd24ab$export$f877b3cb4cb4ccf9(path) {
    return (0, $hsiPi.toArray)(path);
}
function $7265093a11dd24ab$export$f5be6dfb30403c59(store, namePathList) {
    var newStore = {};
    namePathList.forEach(function(namePath) {
        var value = (0, $4eeUf.default)(store, namePath);
        newStore = (0, $cbsvf.default)(newStore, namePath, value);
    });
    return newStore;
}
function $7265093a11dd24ab$export$646d5504364ae55b(namePathList, namePath) {
    var partialMatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return namePathList && namePathList.some(function(path) {
        return $7265093a11dd24ab$export$325a4bd0e71bdc3a(namePath, path, partialMatch);
    });
}
function $7265093a11dd24ab$export$325a4bd0e71bdc3a(namePath, subNamePath) {
    var partialMatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (!namePath || !subNamePath) return false;
    if (!partialMatch && namePath.length !== subNamePath.length) return false;
    return subNamePath.every(function(nameUnit, i) {
        return namePath[i] === nameUnit;
    });
}
function $7265093a11dd24ab$export$dfcec05bb7372a54(source, target) {
    if (source === target) return true;
    if (!source && target || source && !target) return false;
    if (!source || !target || (0, $jncUt.default)(source) !== "object" || (0, $jncUt.default)(target) !== "object") return false;
    var sourceKeys = Object.keys(source);
    var targetKeys = Object.keys(target);
    var keys = new Set([].concat(sourceKeys, targetKeys));
    return (0, $huwkX.default)(keys).every(function(key) {
        var sourceValue = source[key];
        var targetValue = target[key];
        if (typeof sourceValue === "function" && typeof targetValue === "function") return true;
        return sourceValue === targetValue;
    });
}
function $7265093a11dd24ab$export$6eeac3c5b406fb30(valuePropName) {
    var event = arguments.length <= 1 ? undefined : arguments[1];
    if (event && event.target && (0, $jncUt.default)(event.target) === "object" && valuePropName in event.target) return event.target[valuePropName];
    return event;
}
function $7265093a11dd24ab$export$d947e5f4f4c48d48(array, moveIndex, toIndex) {
    var length = array.length;
    if (moveIndex < 0 || moveIndex >= length || toIndex < 0 || toIndex >= length) return array;
    var item = array[moveIndex];
    var diff = moveIndex - toIndex;
    if (diff > 0) // move left
    return [].concat((0, $huwkX.default)(array.slice(0, toIndex)), [
        item
    ], (0, $huwkX.default)(array.slice(toIndex, moveIndex)), (0, $huwkX.default)(array.slice(moveIndex + 1, length)));
    if (diff < 0) // move right
    return [].concat((0, $huwkX.default)(array.slice(0, moveIndex)), (0, $huwkX.default)(array.slice(moveIndex + 1, toIndex + 1)), [
        item
    ], (0, $huwkX.default)(array.slice(toIndex + 1, length)));
    return array;
}

});


parcelRegister("iJYiS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da4b34f4c97e8bf7$export$2e2bcd8739ae039; });

var $lv6ip = parcelRequire("lv6ip");

var $huwkX = parcelRequire("huwkX");

var $jbmdS = parcelRequire("jbmdS");

var $8tMCd = parcelRequire("8tMCd");

var $gjHn8 = parcelRequire("gjHn8");

var $gnihy = parcelRequire("gnihy");

var $9OV34 = parcelRequire("9OV34");

var $3KctZ = parcelRequire("3KctZ");
function $da4b34f4c97e8bf7$var$List(_ref) {
    var name = _ref.name, initialValue = _ref.initialValue, children = _ref.children, rules = _ref.rules, validateTrigger = _ref.validateTrigger, isListField = _ref.isListField;
    var context = $jbmdS.useContext((0, $gjHn8.default));
    var wrapperListContext = $jbmdS.useContext((0, $3KctZ.default));
    var keyRef = $jbmdS.useRef({
        keys: [],
        id: 0
    });
    var keyManager = keyRef.current;
    var prefixName = $jbmdS.useMemo(function() {
        var parentPrefixName = (0, $9OV34.getNamePath)(context.prefixName) || [];
        return [].concat((0, $huwkX.default)(parentPrefixName), (0, $huwkX.default)((0, $9OV34.getNamePath)(name)));
    }, [
        context.prefixName,
        name
    ]);
    var fieldContext = $jbmdS.useMemo(function() {
        return (0, $lv6ip.default)((0, $lv6ip.default)({}, context), {}, {
            prefixName: prefixName
        });
    }, [
        context,
        prefixName
    ]);
    // List context
    var listContext = $jbmdS.useMemo(function() {
        return {
            getKey: function getKey(namePath) {
                var len = prefixName.length;
                var pathName = namePath[len];
                return [
                    keyManager.keys[pathName],
                    namePath.slice(len + 1)
                ];
            }
        };
    }, [
        prefixName
    ]);
    // User should not pass `children` as other type.
    if (typeof children !== "function") {
        (0, $8tMCd.default)(false, "Form.List only accepts function as children.");
        return null;
    }
    var shouldUpdate = function shouldUpdate(prevValue, nextValue, _ref2) {
        var source = _ref2.source;
        if (source === "internal") return false;
        return prevValue !== nextValue;
    };
    return /*#__PURE__*/ $jbmdS.createElement((0, $3KctZ.default).Provider, {
        value: listContext
    }, /*#__PURE__*/ $jbmdS.createElement((0, $gjHn8.default).Provider, {
        value: fieldContext
    }, /*#__PURE__*/ $jbmdS.createElement((0, $gnihy.default), {
        name: [],
        shouldUpdate: shouldUpdate,
        rules: rules,
        validateTrigger: validateTrigger,
        initialValue: initialValue,
        isList: true,
        isListField: isListField !== null && isListField !== void 0 ? isListField : !!wrapperListContext
    }, function(_ref3, meta) {
        var _ref3$value = _ref3.value, value = _ref3$value === void 0 ? [] : _ref3$value, onChange = _ref3.onChange;
        var getFieldValue = context.getFieldValue;
        var getNewValue = function getNewValue() {
            var values = getFieldValue(prefixName || []);
            return values || [];
        };
        /**
     * Always get latest value in case user update fields by `form` api.
     */ var operations = {
            add: function add(defaultValue, index) {
                // Mapping keys
                var newValue = getNewValue();
                if (index >= 0 && index <= newValue.length) {
                    keyManager.keys = [].concat((0, $huwkX.default)(keyManager.keys.slice(0, index)), [
                        keyManager.id
                    ], (0, $huwkX.default)(keyManager.keys.slice(index)));
                    onChange([].concat((0, $huwkX.default)(newValue.slice(0, index)), [
                        defaultValue
                    ], (0, $huwkX.default)(newValue.slice(index))));
                } else {
                    keyManager.keys = [].concat((0, $huwkX.default)(keyManager.keys), [
                        keyManager.id
                    ]);
                    onChange([].concat((0, $huwkX.default)(newValue), [
                        defaultValue
                    ]));
                }
                keyManager.id += 1;
            },
            remove: function remove(index) {
                var newValue = getNewValue();
                var indexSet = new Set(Array.isArray(index) ? index : [
                    index
                ]);
                if (indexSet.size <= 0) return;
                keyManager.keys = keyManager.keys.filter(function(_, keysIndex) {
                    return !indexSet.has(keysIndex);
                });
                // Trigger store change
                onChange(newValue.filter(function(_, valueIndex) {
                    return !indexSet.has(valueIndex);
                }));
            },
            move: function move(from, to) {
                if (from === to) return;
                var newValue = getNewValue();
                // Do not handle out of range
                if (from < 0 || from >= newValue.length || to < 0 || to >= newValue.length) return;
                keyManager.keys = (0, $9OV34.move)(keyManager.keys, from, to);
                // Trigger store change
                onChange((0, $9OV34.move)(newValue, from, to));
            }
        };
        var listValue = value || [];
        if (!Array.isArray(listValue)) listValue = [];
        return children(listValue.map(function(__, index) {
            var key = keyManager.keys[index];
            if (key === undefined) {
                keyManager.keys[index] = keyManager.id;
                key = keyManager.keys[index];
                keyManager.id += 1;
            }
            return {
                name: index,
                key: key,
                isListField: true
            };
        }), operations, meta);
    })));
}
var $da4b34f4c97e8bf7$export$2e2bcd8739ae039 = $da4b34f4c97e8bf7$var$List;

});

parcelRegister("giUv8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bdea27ba224149aa$export$2e2bcd8739ae039; });

var $CZyex = parcelRequire("CZyex");

var $lv6ip = parcelRequire("lv6ip");

var $ccQt4 = parcelRequire("ccQt4");

var $huwkX = parcelRequire("huwkX");

var $jncUt = parcelRequire("jncUt");

var $jj5jQ = parcelRequire("jj5jQ");

var $3GVdq = parcelRequire("3GVdq");

var $8K2NM = parcelRequire("8K2NM");

var $8tMCd = parcelRequire("8tMCd");

var $jbmdS = parcelRequire("jbmdS");

var $gjHn8 = parcelRequire("gjHn8");

var $97Hvx = parcelRequire("97Hvx");

var $cbsvf = parcelRequire("cbsvf");

var $4G8fk = parcelRequire("4G8fk");

var $ccopR = parcelRequire("ccopR");

var $9OV34 = parcelRequire("9OV34");
var $4eeUf = parcelRequire("4eeUf");
var $cbsvf = parcelRequire("cbsvf");
var $bdea27ba224149aa$var$_excluded = [
    "name"
];
var $bdea27ba224149aa$export$75ff1ab1187e691 = /*#__PURE__*/ (0, $jj5jQ.default)(function FormStore(forceRootUpdate) {
    var _this = this;
    (0, $3GVdq.default)(this, FormStore);
    (0, $8K2NM.default)(this, "formHooked", false);
    (0, $8K2NM.default)(this, "forceRootUpdate", void 0);
    (0, $8K2NM.default)(this, "subscribable", true);
    (0, $8K2NM.default)(this, "store", {});
    (0, $8K2NM.default)(this, "fieldEntities", []);
    (0, $8K2NM.default)(this, "initialValues", {});
    (0, $8K2NM.default)(this, "callbacks", {});
    (0, $8K2NM.default)(this, "validateMessages", null);
    (0, $8K2NM.default)(this, "preserve", null);
    (0, $8K2NM.default)(this, "lastValidatePromise", null);
    (0, $8K2NM.default)(this, "getForm", function() {
        return {
            getFieldValue: _this.getFieldValue,
            getFieldsValue: _this.getFieldsValue,
            getFieldError: _this.getFieldError,
            getFieldWarning: _this.getFieldWarning,
            getFieldsError: _this.getFieldsError,
            isFieldsTouched: _this.isFieldsTouched,
            isFieldTouched: _this.isFieldTouched,
            isFieldValidating: _this.isFieldValidating,
            isFieldsValidating: _this.isFieldsValidating,
            resetFields: _this.resetFields,
            setFields: _this.setFields,
            setFieldValue: _this.setFieldValue,
            setFieldsValue: _this.setFieldsValue,
            validateFields: _this.validateFields,
            submit: _this.submit,
            _init: true,
            getInternalHooks: _this.getInternalHooks
        };
    });
    // ======================== Internal Hooks ========================
    (0, $8K2NM.default)(this, "getInternalHooks", function(key) {
        if (key === (0, $gjHn8.HOOK_MARK)) {
            _this.formHooked = true;
            return {
                dispatch: _this.dispatch,
                initEntityValue: _this.initEntityValue,
                registerField: _this.registerField,
                useSubscribe: _this.useSubscribe,
                setInitialValues: _this.setInitialValues,
                destroyForm: _this.destroyForm,
                setCallbacks: _this.setCallbacks,
                setValidateMessages: _this.setValidateMessages,
                getFields: _this.getFields,
                setPreserve: _this.setPreserve,
                getInitialValue: _this.getInitialValue,
                registerWatch: _this.registerWatch
            };
        }
        (0, $8tMCd.default)(false, "`getInternalHooks` is internal usage. Should not call directly.");
        return null;
    });
    (0, $8K2NM.default)(this, "useSubscribe", function(subscribable) {
        _this.subscribable = subscribable;
    });
    /**
   * Record prev Form unmount fieldEntities which config preserve false.
   * This need to be refill with initialValues instead of store value.
   */ (0, $8K2NM.default)(this, "prevWithoutPreserves", null);
    /**
   * First time `setInitialValues` should update store with initial value
   */ (0, $8K2NM.default)(this, "setInitialValues", function(initialValues, init) {
        _this.initialValues = initialValues || {};
        if (init) {
            var _this$prevWithoutPres;
            var nextStore = (0, $cbsvf.merge)(initialValues, _this.store);
            // We will take consider prev form unmount fields.
            // When the field is not `preserve`, we need fill this with initialValues instead of store.
            // eslint-disable-next-line array-callback-return
            (_this$prevWithoutPres = _this.prevWithoutPreserves) === null || _this$prevWithoutPres === void 0 || _this$prevWithoutPres.map(function(_ref) {
                var namePath = _ref.key;
                nextStore = (0, $cbsvf.default)(nextStore, namePath, (0, $4eeUf.default)(initialValues, namePath));
            });
            _this.prevWithoutPreserves = null;
            _this.updateStore(nextStore);
        }
    });
    (0, $8K2NM.default)(this, "destroyForm", function() {
        var prevWithoutPreserves = new (0, $ccopR.default)();
        _this.getFieldEntities(true).forEach(function(entity) {
            if (!_this.isMergedPreserve(entity.isPreserve())) prevWithoutPreserves.set(entity.getNamePath(), true);
        });
        _this.prevWithoutPreserves = prevWithoutPreserves;
    });
    (0, $8K2NM.default)(this, "getInitialValue", function(namePath) {
        var initValue = (0, $4eeUf.default)(_this.initialValues, namePath);
        // Not cloneDeep when without `namePath`
        return namePath.length ? (0, $cbsvf.merge)(initValue) : initValue;
    });
    (0, $8K2NM.default)(this, "setCallbacks", function(callbacks) {
        _this.callbacks = callbacks;
    });
    (0, $8K2NM.default)(this, "setValidateMessages", function(validateMessages) {
        _this.validateMessages = validateMessages;
    });
    (0, $8K2NM.default)(this, "setPreserve", function(preserve) {
        _this.preserve = preserve;
    });
    // ============================= Watch ============================
    (0, $8K2NM.default)(this, "watchList", []);
    (0, $8K2NM.default)(this, "registerWatch", function(callback) {
        _this.watchList.push(callback);
        return function() {
            _this.watchList = _this.watchList.filter(function(fn) {
                return fn !== callback;
            });
        };
    });
    (0, $8K2NM.default)(this, "notifyWatch", function() {
        var namePath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        // No need to cost perf when nothing need to watch
        if (_this.watchList.length) {
            var values = _this.getFieldsValue();
            var allValues = _this.getFieldsValue(true);
            _this.watchList.forEach(function(callback) {
                callback(values, allValues, namePath);
            });
        }
    });
    // ========================== Dev Warning =========================
    (0, $8K2NM.default)(this, "timeoutId", null);
    (0, $8K2NM.default)(this, "warningUnhooked", function() {});
    // ============================ Store =============================
    (0, $8K2NM.default)(this, "updateStore", function(nextStore) {
        _this.store = nextStore;
    });
    // ============================ Fields ============================
    /**
   * Get registered field entities.
   * @param pure Only return field which has a `name`. Default: false
   */ (0, $8K2NM.default)(this, "getFieldEntities", function() {
        var pure = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        if (!pure) return _this.fieldEntities;
        return _this.fieldEntities.filter(function(field) {
            return field.getNamePath().length;
        });
    });
    (0, $8K2NM.default)(this, "getFieldsMap", function() {
        var pure = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var cache = new (0, $ccopR.default)();
        _this.getFieldEntities(pure).forEach(function(field) {
            var namePath = field.getNamePath();
            cache.set(namePath, field);
        });
        return cache;
    });
    (0, $8K2NM.default)(this, "getFieldEntitiesForNamePathList", function(nameList) {
        if (!nameList) return _this.getFieldEntities(true);
        var cache = _this.getFieldsMap(true);
        return nameList.map(function(name) {
            var namePath = (0, $9OV34.getNamePath)(name);
            return cache.get(namePath) || {
                INVALIDATE_NAME_PATH: (0, $9OV34.getNamePath)(name)
            };
        });
    });
    (0, $8K2NM.default)(this, "getFieldsValue", function(nameList, filterFunc) {
        _this.warningUnhooked();
        // Fill args
        var mergedNameList;
        var mergedFilterFunc;
        var mergedStrict;
        if (nameList === true || Array.isArray(nameList)) {
            mergedNameList = nameList;
            mergedFilterFunc = filterFunc;
        } else if (nameList && (0, $jncUt.default)(nameList) === "object") {
            mergedStrict = nameList.strict;
            mergedFilterFunc = nameList.filter;
        }
        if (mergedNameList === true && !mergedFilterFunc) return _this.store;
        var fieldEntities = _this.getFieldEntitiesForNamePathList(Array.isArray(mergedNameList) ? mergedNameList : null);
        var filteredNameList = [];
        fieldEntities.forEach(function(entity) {
            var _isListField, _ref3;
            var namePath = "INVALIDATE_NAME_PATH" in entity ? entity.INVALIDATE_NAME_PATH : entity.getNamePath();
            // Ignore when it's a list item and not specific the namePath,
            // since parent field is already take in count
            if (mergedStrict) {
                var _isList, _ref2;
                if ((_isList = (_ref2 = entity).isList) !== null && _isList !== void 0 && _isList.call(_ref2)) return;
            } else if (!mergedNameList && (_isListField = (_ref3 = entity).isListField) !== null && _isListField !== void 0 && _isListField.call(_ref3)) return;
            if (!mergedFilterFunc) filteredNameList.push(namePath);
            else {
                var meta = "getMeta" in entity ? entity.getMeta() : null;
                if (mergedFilterFunc(meta)) filteredNameList.push(namePath);
            }
        });
        return (0, $9OV34.cloneByNamePathList)(_this.store, filteredNameList.map((0, $9OV34.getNamePath)));
    });
    (0, $8K2NM.default)(this, "getFieldValue", function(name) {
        _this.warningUnhooked();
        var namePath = (0, $9OV34.getNamePath)(name);
        return (0, $4eeUf.default)(_this.store, namePath);
    });
    (0, $8K2NM.default)(this, "getFieldsError", function(nameList) {
        _this.warningUnhooked();
        var fieldEntities = _this.getFieldEntitiesForNamePathList(nameList);
        return fieldEntities.map(function(entity, index) {
            if (entity && !("INVALIDATE_NAME_PATH" in entity)) return {
                name: entity.getNamePath(),
                errors: entity.getErrors(),
                warnings: entity.getWarnings()
            };
            return {
                name: (0, $9OV34.getNamePath)(nameList[index]),
                errors: [],
                warnings: []
            };
        });
    });
    (0, $8K2NM.default)(this, "getFieldError", function(name) {
        _this.warningUnhooked();
        var namePath = (0, $9OV34.getNamePath)(name);
        var fieldError = _this.getFieldsError([
            namePath
        ])[0];
        return fieldError.errors;
    });
    (0, $8K2NM.default)(this, "getFieldWarning", function(name) {
        _this.warningUnhooked();
        var namePath = (0, $9OV34.getNamePath)(name);
        var fieldError = _this.getFieldsError([
            namePath
        ])[0];
        return fieldError.warnings;
    });
    (0, $8K2NM.default)(this, "isFieldsTouched", function() {
        _this.warningUnhooked();
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var arg0 = args[0], arg1 = args[1];
        var namePathList;
        var isAllFieldsTouched = false;
        if (args.length === 0) namePathList = null;
        else if (args.length === 1) {
            if (Array.isArray(arg0)) {
                namePathList = arg0.map((0, $9OV34.getNamePath));
                isAllFieldsTouched = false;
            } else {
                namePathList = null;
                isAllFieldsTouched = arg0;
            }
        } else {
            namePathList = arg0.map((0, $9OV34.getNamePath));
            isAllFieldsTouched = arg1;
        }
        var fieldEntities = _this.getFieldEntities(true);
        var isFieldTouched = function isFieldTouched(field) {
            return field.isFieldTouched();
        };
        // ===== Will get fully compare when not config namePathList =====
        if (!namePathList) return isAllFieldsTouched ? fieldEntities.every(isFieldTouched) : fieldEntities.some(isFieldTouched);
        // Generate a nest tree for validate
        var map = new (0, $ccopR.default)();
        namePathList.forEach(function(shortNamePath) {
            map.set(shortNamePath, []);
        });
        fieldEntities.forEach(function(field) {
            var fieldNamePath = field.getNamePath();
            // Find matched entity and put into list
            namePathList.forEach(function(shortNamePath) {
                if (shortNamePath.every(function(nameUnit, i) {
                    return fieldNamePath[i] === nameUnit;
                })) map.update(shortNamePath, function(list) {
                    return [].concat((0, $huwkX.default)(list), [
                        field
                    ]);
                });
            });
        });
        // Check if NameMap value is touched
        var isNamePathListTouched = function isNamePathListTouched(entities) {
            return entities.some(isFieldTouched);
        };
        var namePathListEntities = map.map(function(_ref4) {
            var value = _ref4.value;
            return value;
        });
        return isAllFieldsTouched ? namePathListEntities.every(isNamePathListTouched) : namePathListEntities.some(isNamePathListTouched);
    });
    (0, $8K2NM.default)(this, "isFieldTouched", function(name) {
        _this.warningUnhooked();
        return _this.isFieldsTouched([
            name
        ]);
    });
    (0, $8K2NM.default)(this, "isFieldsValidating", function(nameList) {
        _this.warningUnhooked();
        var fieldEntities = _this.getFieldEntities();
        if (!nameList) return fieldEntities.some(function(testField) {
            return testField.isFieldValidating();
        });
        var namePathList = nameList.map((0, $9OV34.getNamePath));
        return fieldEntities.some(function(testField) {
            var fieldNamePath = testField.getNamePath();
            return (0, $9OV34.containsNamePath)(namePathList, fieldNamePath) && testField.isFieldValidating();
        });
    });
    (0, $8K2NM.default)(this, "isFieldValidating", function(name) {
        _this.warningUnhooked();
        return _this.isFieldsValidating([
            name
        ]);
    });
    /**
   * Reset Field with field `initialValue` prop.
   * Can pass `entities` or `namePathList` or just nothing.
   */ (0, $8K2NM.default)(this, "resetWithFieldInitialValue", function() {
        var info = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // Create cache
        var cache = new (0, $ccopR.default)();
        var fieldEntities = _this.getFieldEntities(true);
        fieldEntities.forEach(function(field) {
            var initialValue = field.props.initialValue;
            var namePath = field.getNamePath();
            // Record only if has `initialValue`
            if (initialValue !== undefined) {
                var records = cache.get(namePath) || new Set();
                records.add({
                    entity: field,
                    value: initialValue
                });
                cache.set(namePath, records);
            }
        });
        // Reset
        var resetWithFields = function resetWithFields(entities) {
            entities.forEach(function(field) {
                var initialValue = field.props.initialValue;
                if (initialValue !== undefined) {
                    var namePath = field.getNamePath();
                    var formInitialValue = _this.getInitialValue(namePath);
                    if (formInitialValue !== undefined) // Warning if conflict with form initialValues and do not modify value
                    (0, $8tMCd.default)(false, "Form already set 'initialValues' with path '".concat(namePath.join("."), "'. Field can not overwrite it."));
                    else {
                        var records = cache.get(namePath);
                        if (records && records.size > 1) // Warning if multiple field set `initialValue`and do not modify value
                        (0, $8tMCd.default)(false, "Multiple Field with path '".concat(namePath.join("."), "' set 'initialValue'. Can not decide which one to pick."));
                        else if (records) {
                            var originValue = _this.getFieldValue(namePath);
                            // Set `initialValue`
                            if (!info.skipExist || originValue === undefined) _this.updateStore((0, $cbsvf.default)(_this.store, namePath, (0, $huwkX.default)(records)[0].value));
                        }
                    }
                }
            });
        };
        var requiredFieldEntities;
        if (info.entities) requiredFieldEntities = info.entities;
        else if (info.namePathList) {
            requiredFieldEntities = [];
            info.namePathList.forEach(function(namePath) {
                var records = cache.get(namePath);
                if (records) {
                    var _requiredFieldEntitie;
                    (_requiredFieldEntitie = requiredFieldEntities).push.apply(_requiredFieldEntitie, (0, $huwkX.default)((0, $huwkX.default)(records).map(function(r) {
                        return r.entity;
                    })));
                }
            });
        } else requiredFieldEntities = fieldEntities;
        resetWithFields(requiredFieldEntities);
    });
    (0, $8K2NM.default)(this, "resetFields", function(nameList) {
        _this.warningUnhooked();
        var prevStore = _this.store;
        if (!nameList) {
            _this.updateStore((0, $cbsvf.merge)(_this.initialValues));
            _this.resetWithFieldInitialValue();
            _this.notifyObservers(prevStore, null, {
                type: "reset"
            });
            _this.notifyWatch();
            return;
        }
        // Reset by `nameList`
        var namePathList = nameList.map((0, $9OV34.getNamePath));
        namePathList.forEach(function(namePath) {
            var initialValue = _this.getInitialValue(namePath);
            _this.updateStore((0, $cbsvf.default)(_this.store, namePath, initialValue));
        });
        _this.resetWithFieldInitialValue({
            namePathList: namePathList
        });
        _this.notifyObservers(prevStore, namePathList, {
            type: "reset"
        });
        _this.notifyWatch(namePathList);
    });
    (0, $8K2NM.default)(this, "setFields", function(fields) {
        _this.warningUnhooked();
        var prevStore = _this.store;
        var namePathList = [];
        fields.forEach(function(fieldData) {
            var name = fieldData.name, data = (0, $ccQt4.default)(fieldData, $bdea27ba224149aa$var$_excluded);
            var namePath = (0, $9OV34.getNamePath)(name);
            namePathList.push(namePath);
            // Value
            if ("value" in data) _this.updateStore((0, $cbsvf.default)(_this.store, namePath, data.value));
            _this.notifyObservers(prevStore, [
                namePath
            ], {
                type: "setField",
                data: fieldData
            });
        });
        _this.notifyWatch(namePathList);
    });
    (0, $8K2NM.default)(this, "getFields", function() {
        var entities = _this.getFieldEntities(true);
        var fields = entities.map(function(field) {
            var namePath = field.getNamePath();
            var meta = field.getMeta();
            var fieldData = (0, $lv6ip.default)((0, $lv6ip.default)({}, meta), {}, {
                name: namePath,
                value: _this.getFieldValue(namePath)
            });
            Object.defineProperty(fieldData, "originRCField", {
                value: true
            });
            return fieldData;
        });
        return fields;
    });
    // =========================== Observer ===========================
    /**
   * This only trigger when a field is on constructor to avoid we get initialValue too late
   */ (0, $8K2NM.default)(this, "initEntityValue", function(entity) {
        var initialValue = entity.props.initialValue;
        if (initialValue !== undefined) {
            var namePath = entity.getNamePath();
            var prevValue = (0, $4eeUf.default)(_this.store, namePath);
            if (prevValue === undefined) _this.updateStore((0, $cbsvf.default)(_this.store, namePath, initialValue));
        }
    });
    (0, $8K2NM.default)(this, "isMergedPreserve", function(fieldPreserve) {
        var mergedPreserve = fieldPreserve !== undefined ? fieldPreserve : _this.preserve;
        return mergedPreserve !== null && mergedPreserve !== void 0 ? mergedPreserve : true;
    });
    (0, $8K2NM.default)(this, "registerField", function(entity) {
        _this.fieldEntities.push(entity);
        var namePath = entity.getNamePath();
        _this.notifyWatch([
            namePath
        ]);
        // Set initial values
        if (entity.props.initialValue !== undefined) {
            var prevStore = _this.store;
            _this.resetWithFieldInitialValue({
                entities: [
                    entity
                ],
                skipExist: true
            });
            _this.notifyObservers(prevStore, [
                entity.getNamePath()
            ], {
                type: "valueUpdate",
                source: "internal"
            });
        }
        // un-register field callback
        return function(isListField, preserve) {
            var subNamePath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
            _this.fieldEntities = _this.fieldEntities.filter(function(item) {
                return item !== entity;
            });
            // Clean up store value if not preserve
            if (!_this.isMergedPreserve(preserve) && (!isListField || subNamePath.length > 1)) {
                var defaultValue = isListField ? undefined : _this.getInitialValue(namePath);
                if (namePath.length && _this.getFieldValue(namePath) !== defaultValue && _this.fieldEntities.every(function(field) {
                    return(// Only reset when no namePath exist
                    !(0, $9OV34.matchNamePath)(field.getNamePath(), namePath));
                })) {
                    var _prevStore = _this.store;
                    _this.updateStore((0, $cbsvf.default)(_prevStore, namePath, defaultValue, true));
                    // Notify that field is unmount
                    _this.notifyObservers(_prevStore, [
                        namePath
                    ], {
                        type: "remove"
                    });
                    // Dependencies update
                    _this.triggerDependenciesUpdate(_prevStore, namePath);
                }
            }
            _this.notifyWatch([
                namePath
            ]);
        };
    });
    (0, $8K2NM.default)(this, "dispatch", function(action) {
        switch(action.type){
            case "updateValue":
                var namePath = action.namePath, value = action.value;
                _this.updateValue(namePath, value);
                break;
            case "validateField":
                var _namePath = action.namePath, triggerName = action.triggerName;
                _this.validateFields([
                    _namePath
                ], {
                    triggerName: triggerName
                });
                break;
            default:
        }
    });
    (0, $8K2NM.default)(this, "notifyObservers", function(prevStore, namePathList, info) {
        if (_this.subscribable) {
            var mergedInfo = (0, $lv6ip.default)((0, $lv6ip.default)({}, info), {}, {
                store: _this.getFieldsValue(true)
            });
            _this.getFieldEntities().forEach(function(_ref5) {
                var onStoreChange = _ref5.onStoreChange;
                onStoreChange(prevStore, namePathList, mergedInfo);
            });
        } else _this.forceRootUpdate();
    });
    /**
   * Notify dependencies children with parent update
   * We need delay to trigger validate in case Field is under render props
   */ (0, $8K2NM.default)(this, "triggerDependenciesUpdate", function(prevStore, namePath) {
        var childrenFields = _this.getDependencyChildrenFields(namePath);
        if (childrenFields.length) _this.validateFields(childrenFields);
        _this.notifyObservers(prevStore, childrenFields, {
            type: "dependenciesUpdate",
            relatedFields: [
                namePath
            ].concat((0, $huwkX.default)(childrenFields))
        });
        return childrenFields;
    });
    (0, $8K2NM.default)(this, "updateValue", function(name, value) {
        var namePath = (0, $9OV34.getNamePath)(name);
        var prevStore = _this.store;
        _this.updateStore((0, $cbsvf.default)(_this.store, namePath, value));
        _this.notifyObservers(prevStore, [
            namePath
        ], {
            type: "valueUpdate",
            source: "internal"
        });
        _this.notifyWatch([
            namePath
        ]);
        // Dependencies update
        var childrenFields = _this.triggerDependenciesUpdate(prevStore, namePath);
        // trigger callback function
        var onValuesChange = _this.callbacks.onValuesChange;
        if (onValuesChange) {
            var changedValues = (0, $9OV34.cloneByNamePathList)(_this.store, [
                namePath
            ]);
            onValuesChange(changedValues, _this.getFieldsValue());
        }
        _this.triggerOnFieldsChange([
            namePath
        ].concat((0, $huwkX.default)(childrenFields)));
    });
    // Let all child Field get update.
    (0, $8K2NM.default)(this, "setFieldsValue", function(store) {
        _this.warningUnhooked();
        var prevStore = _this.store;
        if (store) {
            var nextStore = (0, $cbsvf.merge)(_this.store, store);
            _this.updateStore(nextStore);
        }
        _this.notifyObservers(prevStore, null, {
            type: "valueUpdate",
            source: "external"
        });
        _this.notifyWatch();
    });
    (0, $8K2NM.default)(this, "setFieldValue", function(name, value) {
        _this.setFields([
            {
                name: name,
                value: value
            }
        ]);
    });
    (0, $8K2NM.default)(this, "getDependencyChildrenFields", function(rootNamePath) {
        var children = new Set();
        var childrenFields = [];
        var dependencies2fields = new (0, $ccopR.default)();
        /**
     * Generate maps
     * Can use cache to save perf if user report performance issue with this
     */ _this.getFieldEntities().forEach(function(field) {
            var dependencies = field.props.dependencies;
            (dependencies || []).forEach(function(dependency) {
                var dependencyNamePath = (0, $9OV34.getNamePath)(dependency);
                dependencies2fields.update(dependencyNamePath, function() {
                    var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Set();
                    fields.add(field);
                    return fields;
                });
            });
        });
        var fillChildren = function fillChildren(namePath) {
            var fields = dependencies2fields.get(namePath) || new Set();
            fields.forEach(function(field) {
                if (!children.has(field)) {
                    children.add(field);
                    var fieldNamePath = field.getNamePath();
                    if (field.isFieldDirty() && fieldNamePath.length) {
                        childrenFields.push(fieldNamePath);
                        fillChildren(fieldNamePath);
                    }
                }
            });
        };
        fillChildren(rootNamePath);
        return childrenFields;
    });
    (0, $8K2NM.default)(this, "triggerOnFieldsChange", function(namePathList, filedErrors) {
        var onFieldsChange = _this.callbacks.onFieldsChange;
        if (onFieldsChange) {
            var fields = _this.getFields();
            /**
       * Fill errors since `fields` may be replaced by controlled fields
       */ if (filedErrors) {
                var cache = new (0, $ccopR.default)();
                filedErrors.forEach(function(_ref6) {
                    var name = _ref6.name, errors = _ref6.errors;
                    cache.set(name, errors);
                });
                fields.forEach(function(field) {
                    // eslint-disable-next-line no-param-reassign
                    field.errors = cache.get(field.name) || field.errors;
                });
            }
            var changedFields = fields.filter(function(_ref7) {
                var fieldName = _ref7.name;
                return (0, $9OV34.containsNamePath)(namePathList, fieldName);
            });
            if (changedFields.length) onFieldsChange(changedFields, fields);
        }
    });
    // =========================== Validate ===========================
    (0, $8K2NM.default)(this, "validateFields", function(arg1, arg2) {
        var _options;
        _this.warningUnhooked();
        var nameList;
        var options;
        if (Array.isArray(arg1) || typeof arg1 === "string" || typeof arg2 === "string") {
            nameList = arg1;
            options = arg2;
        } else options = arg1;
        var provideNameList = !!nameList;
        var namePathList = provideNameList ? nameList.map((0, $9OV34.getNamePath)) : [];
        // Collect result in promise list
        var promiseList = [];
        // We temp save the path which need trigger for `onFieldsChange`
        var TMP_SPLIT = String(Date.now());
        var validateNamePathList = new Set();
        var recursive = (_options = options) === null || _options === void 0 ? void 0 : _options.recursive;
        _this.getFieldEntities(true).forEach(function(field) {
            // Add field if not provide `nameList`
            if (!provideNameList) namePathList.push(field.getNamePath());
            // Skip if without rule
            if (!field.props.rules || !field.props.rules.length) return;
            var fieldNamePath = field.getNamePath();
            validateNamePathList.add(fieldNamePath.join(TMP_SPLIT));
            // Add field validate rule in to promise list
            if (!provideNameList || (0, $9OV34.containsNamePath)(namePathList, fieldNamePath, recursive)) {
                var promise = field.validateRules((0, $lv6ip.default)({
                    validateMessages: (0, $lv6ip.default)((0, $lv6ip.default)({}, (0, $4G8fk.defaultValidateMessages)), _this.validateMessages)
                }, options));
                // Wrap promise with field
                promiseList.push(promise.then(function() {
                    return {
                        name: fieldNamePath,
                        errors: [],
                        warnings: []
                    };
                }).catch(function(ruleErrors) {
                    var _ruleErrors$forEach;
                    var mergedErrors = [];
                    var mergedWarnings = [];
                    (_ruleErrors$forEach = ruleErrors.forEach) === null || _ruleErrors$forEach === void 0 || _ruleErrors$forEach.call(ruleErrors, function(_ref8) {
                        var warningOnly = _ref8.rule.warningOnly, errors = _ref8.errors;
                        if (warningOnly) mergedWarnings.push.apply(mergedWarnings, (0, $huwkX.default)(errors));
                        else mergedErrors.push.apply(mergedErrors, (0, $huwkX.default)(errors));
                    });
                    if (mergedErrors.length) return Promise.reject({
                        name: fieldNamePath,
                        errors: mergedErrors,
                        warnings: mergedWarnings
                    });
                    return {
                        name: fieldNamePath,
                        errors: mergedErrors,
                        warnings: mergedWarnings
                    };
                }));
            }
        });
        var summaryPromise = (0, $97Hvx.allPromiseFinish)(promiseList);
        _this.lastValidatePromise = summaryPromise;
        // Notify fields with rule that validate has finished and need update
        summaryPromise.catch(function(results) {
            return results;
        }).then(function(results) {
            var resultNamePathList = results.map(function(_ref9) {
                var name = _ref9.name;
                return name;
            });
            _this.notifyObservers(_this.store, resultNamePathList, {
                type: "validateFinish"
            });
            _this.triggerOnFieldsChange(resultNamePathList, results);
        });
        var returnPromise = summaryPromise.then(function() {
            if (_this.lastValidatePromise === summaryPromise) return Promise.resolve(_this.getFieldsValue(namePathList));
            return Promise.reject([]);
        }).catch(function(results) {
            var errorList = results.filter(function(result) {
                return result && result.errors.length;
            });
            return Promise.reject({
                values: _this.getFieldsValue(namePathList),
                errorFields: errorList,
                outOfDate: _this.lastValidatePromise !== summaryPromise
            });
        });
        // Do not throw in console
        returnPromise.catch(function(e) {
            return e;
        });
        // `validating` changed. Trigger `onFieldsChange`
        var triggerNamePathList = namePathList.filter(function(namePath) {
            return validateNamePathList.has(namePath.join(TMP_SPLIT));
        });
        _this.triggerOnFieldsChange(triggerNamePathList);
        return returnPromise;
    });
    // ============================ Submit ============================
    (0, $8K2NM.default)(this, "submit", function() {
        _this.warningUnhooked();
        _this.validateFields().then(function(values) {
            var onFinish = _this.callbacks.onFinish;
            if (onFinish) try {
                onFinish(values);
            } catch (err) {
                // Should print error if user `onFinish` callback failed
                console.error(err);
            }
        }).catch(function(e) {
            var onFinishFailed = _this.callbacks.onFinishFailed;
            if (onFinishFailed) onFinishFailed(e);
        });
    });
    this.forceRootUpdate = forceRootUpdate;
});
function $bdea27ba224149aa$var$useForm(form) {
    var formRef = $jbmdS.useRef();
    var _React$useState = $jbmdS.useState({}), _React$useState2 = (0, $CZyex.default)(_React$useState, 2), forceUpdate = _React$useState2[1];
    if (!formRef.current) {
        if (form) formRef.current = form;
        else {
            // Create a new FormStore if not provided
            var forceReRender = function forceReRender() {
                forceUpdate({});
            };
            var formStore = new $bdea27ba224149aa$export$75ff1ab1187e691(forceReRender);
            formRef.current = formStore.getForm();
        }
    }
    return [
        formRef.current
    ];
}
var $bdea27ba224149aa$export$2e2bcd8739ae039 = $bdea27ba224149aa$var$useForm;

});
parcelRegister("97Hvx", function(module, exports) {

$parcel$export(module.exports, "allPromiseFinish", function () { return $6a4684366251a18d$export$6152adfdcc6be2b5; });
function $6a4684366251a18d$export$6152adfdcc6be2b5(promiseList) {
    var hasError = false;
    var count = promiseList.length;
    var results = [];
    if (!promiseList.length) return Promise.resolve([]);
    return new Promise(function(resolve, reject) {
        promiseList.forEach(function(promise, index) {
            promise.catch(function(e) {
                hasError = true;
                return e;
            }).then(function(result) {
                count -= 1;
                results[index] = result;
                if (count > 0) return;
                if (hasError) reject(results);
                resolve(results);
            });
        });
    });
}

});

parcelRegister("ccopR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e198b879dfa731d$export$2e2bcd8739ae039; });

var $CZyex = parcelRequire("CZyex");

var $huwkX = parcelRequire("huwkX");

var $3GVdq = parcelRequire("3GVdq");

var $jj5jQ = parcelRequire("jj5jQ");

var $8K2NM = parcelRequire("8K2NM");

var $jncUt = parcelRequire("jncUt");
var $8e198b879dfa731d$var$SPLIT = "__@field_split__";
/**
 * Convert name path into string to fast the fetch speed of Map.
 */ function $8e198b879dfa731d$var$normalize(namePath) {
    return namePath.map(function(cell) {
        return "".concat((0, $jncUt.default)(cell), ":").concat(cell);
    })// Magic split
    .join($8e198b879dfa731d$var$SPLIT);
}
/**
 * NameMap like a `Map` but accepts `string[]` as key.
 */ var $8e198b879dfa731d$var$NameMap = /*#__PURE__*/ function() {
    function NameMap() {
        (0, $3GVdq.default)(this, NameMap);
        (0, $8K2NM.default)(this, "kvs", new Map());
    }
    (0, $jj5jQ.default)(NameMap, [
        {
            key: "set",
            value: function set(key, value) {
                this.kvs.set($8e198b879dfa731d$var$normalize(key), value);
            }
        },
        {
            key: "get",
            value: function get(key) {
                return this.kvs.get($8e198b879dfa731d$var$normalize(key));
            }
        },
        {
            key: "update",
            value: function update(key, updater) {
                var origin = this.get(key);
                var next = updater(origin);
                if (!next) this.delete(key);
                else this.set(key, next);
            }
        },
        {
            key: "delete",
            value: function _delete(key) {
                this.kvs.delete($8e198b879dfa731d$var$normalize(key));
            }
        },
        {
            key: "map",
            value: function map(callback) {
                return (0, $huwkX.default)(this.kvs.entries()).map(function(_ref) {
                    var _ref2 = (0, $CZyex.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
                    var cells = key.split($8e198b879dfa731d$var$SPLIT);
                    return callback({
                        key: cells.map(function(cell) {
                            var _cell$match = cell.match(/^([^:]*):(.*)$/), _cell$match2 = (0, $CZyex.default)(_cell$match, 3), type = _cell$match2[1], unit = _cell$match2[2];
                            return type === "number" ? Number(unit) : unit;
                        }),
                        value: value
                    });
                });
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var json = {};
                this.map(function(_ref3) {
                    var key = _ref3.key, value = _ref3.value;
                    json[key.join(".")] = value;
                    return null;
                });
                return json;
            }
        }
    ]);
    return NameMap;
}();
var $8e198b879dfa731d$export$2e2bcd8739ae039 = $8e198b879dfa731d$var$NameMap;

});


parcelRegister("7z7SN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5821eaa1528c8b3e$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $lv6ip = parcelRequire("lv6ip");

var $CZyex = parcelRequire("CZyex");

var $ccQt4 = parcelRequire("ccQt4");

var $jbmdS = parcelRequire("jbmdS");

var $giUv8 = parcelRequire("giUv8");

var $gjHn8 = parcelRequire("gjHn8");

var $6M4HU = parcelRequire("6M4HU");

var $9OV34 = parcelRequire("9OV34");

var $3KctZ = parcelRequire("3KctZ");
var $5821eaa1528c8b3e$var$_excluded = [
    "name",
    "initialValues",
    "fields",
    "form",
    "preserve",
    "children",
    "component",
    "validateMessages",
    "validateTrigger",
    "onValuesChange",
    "onFieldsChange",
    "onFinish",
    "onFinishFailed"
];
var $5821eaa1528c8b3e$var$Form = function Form(_ref, ref) {
    var name = _ref.name, initialValues = _ref.initialValues, fields = _ref.fields, form = _ref.form, preserve = _ref.preserve, children = _ref.children, _ref$component = _ref.component, Component = _ref$component === void 0 ? "form" : _ref$component, validateMessages = _ref.validateMessages, _ref$validateTrigger = _ref.validateTrigger, validateTrigger = _ref$validateTrigger === void 0 ? "onChange" : _ref$validateTrigger, onValuesChange = _ref.onValuesChange, _onFieldsChange = _ref.onFieldsChange, _onFinish = _ref.onFinish, onFinishFailed = _ref.onFinishFailed, restProps = (0, $ccQt4.default)(_ref, $5821eaa1528c8b3e$var$_excluded);
    var formContext = $jbmdS.useContext((0, $6M4HU.default));
    // We customize handle event since Context will makes all the consumer re-render:
    // https://reactjs.org/docs/context.html#contextprovider
    var _useForm = (0, $giUv8.default)(form), _useForm2 = (0, $CZyex.default)(_useForm, 1), formInstance = _useForm2[0];
    var _getInternalHooks = formInstance.getInternalHooks((0, $gjHn8.HOOK_MARK)), useSubscribe = _getInternalHooks.useSubscribe, setInitialValues = _getInternalHooks.setInitialValues, setCallbacks = _getInternalHooks.setCallbacks, setValidateMessages = _getInternalHooks.setValidateMessages, setPreserve = _getInternalHooks.setPreserve, destroyForm = _getInternalHooks.destroyForm;
    // Pass ref with form instance
    $jbmdS.useImperativeHandle(ref, function() {
        return formInstance;
    });
    // Register form into Context
    $jbmdS.useEffect(function() {
        formContext.registerForm(name, formInstance);
        return function() {
            formContext.unregisterForm(name);
        };
    }, [
        formContext,
        formInstance,
        name
    ]);
    // Pass props to store
    setValidateMessages((0, $lv6ip.default)((0, $lv6ip.default)({}, formContext.validateMessages), validateMessages));
    setCallbacks({
        onValuesChange: onValuesChange,
        onFieldsChange: function onFieldsChange(changedFields) {
            formContext.triggerFormChange(name, changedFields);
            if (_onFieldsChange) {
                for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
                _onFieldsChange.apply(void 0, [
                    changedFields
                ].concat(rest));
            }
        },
        onFinish: function onFinish(values) {
            formContext.triggerFormFinish(name, values);
            if (_onFinish) _onFinish(values);
        },
        onFinishFailed: onFinishFailed
    });
    setPreserve(preserve);
    // Set initial value, init store value when first mount
    var mountRef = $jbmdS.useRef(null);
    setInitialValues(initialValues, !mountRef.current);
    if (!mountRef.current) mountRef.current = true;
    $jbmdS.useEffect(function() {
        return destroyForm;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Prepare children by `children` type
    var childrenNode;
    var childrenRenderProps = typeof children === "function";
    if (childrenRenderProps) {
        var _values = formInstance.getFieldsValue(true);
        childrenNode = children(_values, formInstance);
    } else childrenNode = children;
    // Not use subscribe when using render props
    useSubscribe(!childrenRenderProps);
    // Listen if fields provided. We use ref to save prev data here to avoid additional render
    var prevFieldsRef = $jbmdS.useRef();
    $jbmdS.useEffect(function() {
        if (!(0, $9OV34.isSimilar)(prevFieldsRef.current || [], fields || [])) formInstance.setFields(fields || []);
        prevFieldsRef.current = fields;
    }, [
        fields,
        formInstance
    ]);
    var formContextValue = $jbmdS.useMemo(function() {
        return (0, $lv6ip.default)((0, $lv6ip.default)({}, formInstance), {}, {
            validateTrigger: validateTrigger
        });
    }, [
        formInstance,
        validateTrigger
    ]);
    var wrapperNode = /*#__PURE__*/ $jbmdS.createElement((0, $3KctZ.default).Provider, {
        value: null
    }, /*#__PURE__*/ $jbmdS.createElement((0, $gjHn8.default).Provider, {
        value: formContextValue
    }, childrenNode));
    if (Component === false) return wrapperNode;
    return /*#__PURE__*/ $jbmdS.createElement(Component, (0, $7i29i.default)({}, restProps, {
        onSubmit: function onSubmit(event) {
            event.preventDefault();
            event.stopPropagation();
            formInstance.submit();
        },
        onReset: function onReset(event) {
            var _restProps$onReset;
            event.preventDefault();
            formInstance.resetFields();
            (_restProps$onReset = restProps.onReset) === null || _restProps$onReset === void 0 || _restProps$onReset.call(restProps, event);
        }
    }), wrapperNode);
};
var $5821eaa1528c8b3e$export$2e2bcd8739ae039 = $5821eaa1528c8b3e$var$Form;

});
parcelRegister("6M4HU", function(module, exports) {

$parcel$export(module.exports, "FormProvider", function () { return $4eeae088fd52ceb7$export$8ce1ff4f94d08846; });
$parcel$export(module.exports, "default", function () { return $4eeae088fd52ceb7$export$2e2bcd8739ae039; });

var $8K2NM = parcelRequire("8K2NM");

var $lv6ip = parcelRequire("lv6ip");

var $jbmdS = parcelRequire("jbmdS");
var $4eeae088fd52ceb7$var$FormContext = /*#__PURE__*/ $jbmdS.createContext({
    triggerFormChange: function triggerFormChange() {},
    triggerFormFinish: function triggerFormFinish() {},
    registerForm: function registerForm() {},
    unregisterForm: function unregisterForm() {}
});
var $4eeae088fd52ceb7$export$8ce1ff4f94d08846 = function FormProvider(_ref) {
    var validateMessages = _ref.validateMessages, onFormChange = _ref.onFormChange, onFormFinish = _ref.onFormFinish, children = _ref.children;
    var formContext = $jbmdS.useContext($4eeae088fd52ceb7$var$FormContext);
    var formsRef = $jbmdS.useRef({});
    return /*#__PURE__*/ $jbmdS.createElement($4eeae088fd52ceb7$var$FormContext.Provider, {
        value: (0, $lv6ip.default)((0, $lv6ip.default)({}, formContext), {}, {
            validateMessages: (0, $lv6ip.default)((0, $lv6ip.default)({}, formContext.validateMessages), validateMessages),
            // =========================================================
            // =                  Global Form Control                  =
            // =========================================================
            triggerFormChange: function triggerFormChange(name, changedFields) {
                if (onFormChange) onFormChange(name, {
                    changedFields: changedFields,
                    forms: formsRef.current
                });
                formContext.triggerFormChange(name, changedFields);
            },
            triggerFormFinish: function triggerFormFinish(name, values) {
                if (onFormFinish) onFormFinish(name, {
                    values: values,
                    forms: formsRef.current
                });
                formContext.triggerFormFinish(name, values);
            },
            registerForm: function registerForm(name, form) {
                if (name) formsRef.current = (0, $lv6ip.default)((0, $lv6ip.default)({}, formsRef.current), {}, (0, $8K2NM.default)({}, name, form));
                formContext.registerForm(name, form);
            },
            unregisterForm: function unregisterForm(name) {
                var newForms = (0, $lv6ip.default)({}, formsRef.current);
                delete newForms[name];
                formsRef.current = newForms;
                formContext.unregisterForm(name);
            }
        })
    }, children);
};
var $4eeae088fd52ceb7$export$2e2bcd8739ae039 = $4eeae088fd52ceb7$var$FormContext;

});


parcelRegister("eqPZA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a81bd2fd7df604fd$export$2e2bcd8739ae039; });

var $CZyex = parcelRequire("CZyex");
parcelRequire("8tMCd");

var $jbmdS = parcelRequire("jbmdS");

var $gjHn8 = parcelRequire("gjHn8");

var $hsiPi = parcelRequire("hsiPi");

var $9OV34 = parcelRequire("9OV34");
var $4eeUf = parcelRequire("4eeUf");
function $a81bd2fd7df604fd$export$fac44ee5b035f737(value) {
    try {
        return JSON.stringify(value);
    } catch (err) {
        return Math.random();
    }
}
var $a81bd2fd7df604fd$var$useWatchWarning = function() {};
function $a81bd2fd7df604fd$var$useWatch() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var _args$ = args[0], dependencies = _args$ === void 0 ? [] : _args$, _args$2 = args[1], _form = _args$2 === void 0 ? {} : _args$2;
    var options = (0, $hsiPi.isFormInstance)(_form) ? {
        form: _form
    } : _form;
    var form = options.form;
    var _useState = (0, $jbmdS.useState)(), _useState2 = (0, $CZyex.default)(_useState, 2), value = _useState2[0], setValue = _useState2[1];
    var valueStr = (0, $jbmdS.useMemo)(function() {
        return $a81bd2fd7df604fd$export$fac44ee5b035f737(value);
    }, [
        value
    ]);
    var valueStrRef = (0, $jbmdS.useRef)(valueStr);
    valueStrRef.current = valueStr;
    var fieldContext = (0, $jbmdS.useContext)((0, $gjHn8.default));
    var formInstance = form || fieldContext;
    var isValidForm = formInstance && formInstance._init;
    var namePath = (0, $9OV34.getNamePath)(dependencies);
    var namePathRef = (0, $jbmdS.useRef)(namePath);
    namePathRef.current = namePath;
    $a81bd2fd7df604fd$var$useWatchWarning(namePath);
    (0, $jbmdS.useEffect)(function() {
        // Skip if not exist form instance
        if (!isValidForm) return;
        var getFieldsValue = formInstance.getFieldsValue, getInternalHooks = formInstance.getInternalHooks;
        var _getInternalHooks = getInternalHooks((0, $gjHn8.HOOK_MARK)), registerWatch = _getInternalHooks.registerWatch;
        var cancelRegister = registerWatch(function(values, allValues) {
            var newValue = (0, $4eeUf.default)(options.preserve ? allValues : values, namePathRef.current);
            var nextValueStr = $a81bd2fd7df604fd$export$fac44ee5b035f737(newValue);
            // Compare stringify in case it's nest object
            if (valueStrRef.current !== nextValueStr) {
                valueStrRef.current = nextValueStr;
                setValue(newValue);
            }
        });
        // TODO: We can improve this perf in future
        var initialValue = (0, $4eeUf.default)(options.preserve ? getFieldsValue(true) : getFieldsValue(), namePathRef.current);
        // React 18 has the bug that will queue update twice even the value is not changed
        // ref: https://github.com/facebook/react/issues/27213
        if (value !== initialValue) setValue(initialValue);
        return cancelRegister;
    }, // We do not need re-register since namePath content is the same
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isValidForm
    ]);
    return value;
}
var $a81bd2fd7df604fd$export$2e2bcd8739ae039 = $a81bd2fd7df604fd$var$useWatch;

});




parcelRegister("lsAFg", function(module, exports) {

$parcel$export(module.exports, "fixControlledValue", function () { return $f9f8a74aac4600fd$export$ef94f7f24276a29c; });
$parcel$export(module.exports, "resolveOnChange", function () { return $f9f8a74aac4600fd$export$c28984794956ddc0; });
$parcel$export(module.exports, "triggerFocus", function () { return $f9f8a74aac4600fd$export$2b92016deb0b7aad; });
$parcel$export(module.exports, "default", function () { return $f9f8a74aac4600fd$export$2e2bcd8739ae039; });

var $8K2NM = parcelRequire("8K2NM");

var $7i29i = parcelRequire("7i29i");

var $jncUt = parcelRequire("jncUt");

var $kPBAG = parcelRequire("kPBAG");

var $02LyB = parcelRequire("02LyB");

var $aAjJO = parcelRequire("aAjJO");

var $aKVEK = parcelRequire("aKVEK");

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("8uDri");
var $ewikT = parcelRequire("ewikT");

var $kgIuF = parcelRequire("kgIuF");

var $7VQDG = parcelRequire("7VQDG");

var $3ACNS = parcelRequire("3ACNS");

var $9RKXl = parcelRequire("9RKXl");

var $j4i2o = parcelRequire("j4i2o");


var $cynju = parcelRequire("cynju");

var $gUkIS = parcelRequire("gUkIS");
var $f9f8a74aac4600fd$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $f9f8a74aac4600fd$export$ef94f7f24276a29c(value) {
    if (typeof value === "undefined" || value === null) return "";
    return String(value);
}
function $f9f8a74aac4600fd$export$c28984794956ddc0(target, e, onChange, targetValue) {
    if (!onChange) return;
    var event = e;
    if (e.type === "click") {
        // Clone a new target for event.
        // Avoid the following usage, the setQuery method gets the original value.
        //
        // const [query, setQuery] = React.useState('');
        // <Input
        //   allowClear
        //   value={query}
        //   onChange={(e)=> {
        //     setQuery((prevStatus) => e.target.value);
        //   }}
        // />
        var currentTarget = target.cloneNode(true);
        // click clear icon
        event = Object.create(e, {
            target: {
                value: currentTarget
            },
            currentTarget: {
                value: currentTarget
            }
        });
        currentTarget.value = "";
        onChange(event);
        return;
    }
    // Trigger by composition event, this means we need force change the input value
    if (targetValue !== undefined) {
        event = Object.create(e, {
            target: {
                value: target
            },
            currentTarget: {
                value: target
            }
        });
        target.value = targetValue;
        onChange(event);
        return;
    }
    onChange(event);
}
function $f9f8a74aac4600fd$export$2b92016deb0b7aad(element, option) {
    if (!element) return;
    element.focus(option);
    // Selection content
    var _ref = option || {}, cursor = _ref.cursor;
    if (cursor) {
        var len = element.value.length;
        switch(cursor){
            case "start":
                element.setSelectionRange(0, 0);
                break;
            case "end":
                element.setSelectionRange(len, len);
                break;
            default:
                element.setSelectionRange(0, len);
                break;
        }
    }
}
var $f9f8a74aac4600fd$var$Input = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(props, ref) {
    var customizePrefixCls = props.prefixCls, _props$bordered = props.bordered, bordered = _props$bordered === void 0 ? true : _props$bordered, customStatus = props.status, customSize = props.size, customDisabled = props.disabled, onBlur = props.onBlur, onFocus = props.onFocus, suffix = props.suffix, allowClear = props.allowClear, addonAfter = props.addonAfter, addonBefore = props.addonBefore, className = props.className, onChange = props.onChange, rest = $f9f8a74aac4600fd$var$__rest(props, [
        "prefixCls",
        "bordered",
        "status",
        "size",
        "disabled",
        "onBlur",
        "onFocus",
        "suffix",
        "allowClear",
        "addonAfter",
        "addonBefore",
        "className",
        "onChange"
    ]);
    var _React$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useContext((0, $ewikT.ConfigContext)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction, input = _React$useContext.input;
    var prefixCls = getPrefixCls("input", customizePrefixCls);
    var inputRef = (0, $jbmdS.useRef)(null);
    // ===================== Compact Item =====================
    var _useCompactItemContex = (0, $9RKXl.useCompactItemContext)(prefixCls, direction), compactSize = _useCompactItemContex.compactSize, compactItemClassnames = _useCompactItemContex.compactItemClassnames;
    // ===================== Size =====================
    var size = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useContext((0, $7VQDG.default));
    var mergedSize = compactSize || customSize || size;
    // ===================== Disabled =====================
    var disabled = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useContext((0, $kgIuF.default));
    var mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    // ===================== Status =====================
    var _useContext = (0, $jbmdS.useContext)((0, $3ACNS.FormItemInputContext)), contextStatus = _useContext.status, hasFeedback = _useContext.hasFeedback, feedbackIcon = _useContext.feedbackIcon;
    var mergedStatus = (0, $j4i2o.getMergedStatus)(contextStatus, customStatus);
    // ===================== Focus warning =====================
    var inputHasPrefixSuffix = (0, $gUkIS.hasPrefixSuffix)(props) || !!hasFeedback;
    var prevHasPrefixSuffix = (0, $jbmdS.useRef)(inputHasPrefixSuffix);
    (0, $jbmdS.useEffect)(function() {
        var _a;
        inputHasPrefixSuffix && prevHasPrefixSuffix.current;
        prevHasPrefixSuffix.current = inputHasPrefixSuffix;
    }, [
        inputHasPrefixSuffix
    ]);
    // ===================== Remove Password value =====================
    var removePasswordTimeout = (0, $cynju.default)(inputRef, true);
    var handleBlur = function handleBlur(e) {
        removePasswordTimeout();
        onBlur === null || onBlur === void 0 || onBlur(e);
    };
    var handleFocus = function handleFocus(e) {
        removePasswordTimeout();
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    var handleChange = function handleChange(e) {
        removePasswordTimeout();
        onChange === null || onChange === void 0 || onChange(e);
    };
    var suffixNode = (hasFeedback || suffix) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).Fragment, null, suffix, hasFeedback && feedbackIcon);
    // Allow clear
    var mergedAllowClear;
    if ((0, $jncUt.default)(allowClear) === "object" && (allowClear === null || allowClear === void 0 ? void 0 : allowClear.clearIcon)) mergedAllowClear = allowClear;
    else if (allowClear) mergedAllowClear = {
        clearIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $kPBAG.default), null)
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $aAjJO.default), (0, $7i29i.default)({
        ref: (0, $aKVEK.composeRef)(ref, inputRef),
        prefixCls: prefixCls,
        autoComplete: input === null || input === void 0 ? void 0 : input.autoComplete
    }, rest, {
        disabled: mergedDisabled || undefined,
        onBlur: handleBlur,
        onFocus: handleFocus,
        suffix: suffixNode,
        allowClear: mergedAllowClear,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(className, compactItemClassnames),
        onChange: handleChange,
        addonAfter: addonAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $9RKXl.NoCompactStyle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $3ACNS.NoFormStyle), {
            override: true,
            status: true
        }, addonAfter)),
        addonBefore: addonBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $9RKXl.NoCompactStyle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $3ACNS.NoFormStyle), {
            override: true,
            status: true
        }, addonBefore)),
        inputClassName: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)({}, "".concat(prefixCls, "-sm"), mergedSize === "small"), "".concat(prefixCls, "-lg"), mergedSize === "large"), "".concat(prefixCls, "-rtl"), direction === "rtl"), "".concat(prefixCls, "-borderless"), !bordered), !inputHasPrefixSuffix && (0, $j4i2o.getStatusClassNames)(prefixCls, mergedStatus)),
        affixWrapperClassName: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)({}, "".concat(prefixCls, "-affix-wrapper-sm"), mergedSize === "small"), "".concat(prefixCls, "-affix-wrapper-lg"), mergedSize === "large"), "".concat(prefixCls, "-affix-wrapper-rtl"), direction === "rtl"), "".concat(prefixCls, "-affix-wrapper-borderless"), !bordered), (0, $j4i2o.getStatusClassNames)("".concat(prefixCls, "-affix-wrapper"), mergedStatus, hasFeedback)),
        wrapperClassName: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))((0, $8K2NM.default)({}, "".concat(prefixCls, "-group-rtl"), direction === "rtl")),
        groupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)({}, "".concat(prefixCls, "-group-wrapper-sm"), mergedSize === "small"), "".concat(prefixCls, "-group-wrapper-lg"), mergedSize === "large"), "".concat(prefixCls, "-group-wrapper-rtl"), direction === "rtl"), (0, $j4i2o.getStatusClassNames)("".concat(prefixCls, "-group-wrapper"), mergedStatus, hasFeedback))
    }));
});
var $f9f8a74aac4600fd$export$2e2bcd8739ae039 = $f9f8a74aac4600fd$var$Input;

});
parcelRegister("aAjJO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b4c93b6e93a0a3a$export$2e2bcd8739ae039; });

var $228sj = parcelRequire("228sj");

var $cxWfh = parcelRequire("cxWfh");
var $7b4c93b6e93a0a3a$export$2e2bcd8739ae039 = (0, $cxWfh.default);

});
parcelRegister("228sj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17b253c8f2c3ecb5$export$2e2bcd8739ae039; });

var $8K2NM = parcelRequire("8K2NM");

var $jncUt = parcelRequire("jncUt");

var $jbmdS = parcelRequire("jbmdS");

var $02LyB = parcelRequire("02LyB");

var $9qkZ9 = parcelRequire("9qkZ9");
var $17b253c8f2c3ecb5$var$BaseInput = function BaseInput(props) {
    var inputElement = props.inputElement, prefixCls = props.prefixCls, prefix = props.prefix, suffix = props.suffix, addonBefore = props.addonBefore, addonAfter = props.addonAfter, className = props.className, style = props.style, affixWrapperClassName = props.affixWrapperClassName, groupClassName = props.groupClassName, wrapperClassName = props.wrapperClassName, disabled = props.disabled, readOnly = props.readOnly, focused = props.focused, triggerFocus = props.triggerFocus, allowClear = props.allowClear, value = props.value, handleReset = props.handleReset, hidden = props.hidden;
    var containerRef = (0, $jbmdS.useRef)(null);
    var onInputClick = function onInputClick(e) {
        var _containerRef$current;
        if ((_containerRef$current = containerRef.current) !== null && _containerRef$current !== void 0 && _containerRef$current.contains(e.target)) triggerFocus === null || triggerFocus === void 0 || triggerFocus();
    }; // ================== Clear Icon ================== //
    var getClearIcon = function getClearIcon() {
        var _classNames;
        if (!allowClear) return null;
        var needClear = !disabled && !readOnly && value;
        var clearIconCls = "".concat(prefixCls, "-clear-icon");
        var iconNode = (0, $jncUt.default)(allowClear) === "object" && allowClear !== null && allowClear !== void 0 && allowClear.clearIcon ? allowClear.clearIcon : "\u2716";
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("span", {
            onClick: handleReset // Do not trigger onBlur when clear input
            ,
            onMouseDown: function onMouseDown(e) {
                return e.preventDefault();
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(clearIconCls, (_classNames = {}, (0, $8K2NM.default)(_classNames, "".concat(clearIconCls, "-hidden"), !needClear), (0, $8K2NM.default)(_classNames, "".concat(clearIconCls, "-has-suffix"), !!suffix), _classNames)),
            role: "button",
            tabIndex: -1
        }, iconNode);
    };
    var element = /*#__PURE__*/ (0, $jbmdS.cloneElement)(inputElement, {
        value: value,
        hidden: hidden
    }); // ================== Prefix & Suffix ================== //
    if ((0, $9qkZ9.hasPrefixSuffix)(props)) {
        var _classNames2;
        var affixWrapperPrefixCls = "".concat(prefixCls, "-affix-wrapper");
        var affixWrapperCls = (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(affixWrapperPrefixCls, (_classNames2 = {}, (0, $8K2NM.default)(_classNames2, "".concat(affixWrapperPrefixCls, "-disabled"), disabled), (0, $8K2NM.default)(_classNames2, "".concat(affixWrapperPrefixCls, "-focused"), focused), (0, $8K2NM.default)(_classNames2, "".concat(affixWrapperPrefixCls, "-readonly"), readOnly), (0, $8K2NM.default)(_classNames2, "".concat(affixWrapperPrefixCls, "-input-with-clear-btn"), suffix && allowClear && value), _classNames2), !(0, $9qkZ9.hasAddon)(props) && className, affixWrapperClassName);
        var suffixNode = (suffix || allowClear) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("span", {
            className: "".concat(prefixCls, "-suffix")
        }, getClearIcon(), suffix);
        element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("span", {
            className: affixWrapperCls,
            style: style,
            hidden: !(0, $9qkZ9.hasAddon)(props) && hidden,
            onClick: onInputClick,
            ref: containerRef
        }, prefix && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("span", {
            className: "".concat(prefixCls, "-prefix")
        }, prefix), /*#__PURE__*/ (0, $jbmdS.cloneElement)(inputElement, {
            style: null,
            value: value,
            hidden: null
        }), suffixNode);
    } // ================== Addon ================== //
    if ((0, $9qkZ9.hasAddon)(props)) {
        var wrapperCls = "".concat(prefixCls, "-group");
        var addonCls = "".concat(wrapperCls, "-addon");
        var mergedWrapperClassName = (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("".concat(prefixCls, "-wrapper"), wrapperCls, wrapperClassName);
        var mergedGroupClassName = (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("".concat(prefixCls, "-group-wrapper"), className, groupClassName); // Need another wrapper for changing display:table to display:inline-block
        // and put style prop in wrapper
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("span", {
            className: mergedGroupClassName,
            style: style,
            hidden: hidden
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("span", {
            className: mergedWrapperClassName
        }, addonBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("span", {
            className: addonCls
        }, addonBefore), /*#__PURE__*/ (0, $jbmdS.cloneElement)(element, {
            style: null,
            hidden: null
        }), addonAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("span", {
            className: addonCls
        }, addonAfter)));
    }
    return element;
};
var $17b253c8f2c3ecb5$export$2e2bcd8739ae039 = $17b253c8f2c3ecb5$var$BaseInput;

});
parcelRegister("9qkZ9", function(module, exports) {

$parcel$export(module.exports, "hasAddon", function () { return $6dc6d2073ba32fa1$export$ae6255aa850a31d1; });
$parcel$export(module.exports, "hasPrefixSuffix", function () { return $6dc6d2073ba32fa1$export$a19010aeeaa0c7a; });
$parcel$export(module.exports, "resolveOnChange", function () { return $6dc6d2073ba32fa1$export$c28984794956ddc0; });
$parcel$export(module.exports, "triggerFocus", function () { return $6dc6d2073ba32fa1$export$2b92016deb0b7aad; });
$parcel$export(module.exports, "fixControlledValue", function () { return $6dc6d2073ba32fa1$export$ef94f7f24276a29c; });
function $6dc6d2073ba32fa1$export$ae6255aa850a31d1(props) {
    return !!(props.addonBefore || props.addonAfter);
}
function $6dc6d2073ba32fa1$export$a19010aeeaa0c7a(props) {
    return !!(props.prefix || props.suffix || props.allowClear);
}
function $6dc6d2073ba32fa1$export$c28984794956ddc0(target, e, onChange, targetValue) {
    if (!onChange) return;
    var event = e;
    if (e.type === "click") {
        // Clone a new target for event.
        // Avoid the following usage, the setQuery method gets the original value.
        //
        // const [query, setQuery] = React.useState('');
        // <Input
        //   allowClear
        //   value={query}
        //   onChange={(e)=> {
        //     setQuery((prevStatus) => e.target.value);
        //   }}
        // />
        var currentTarget = target.cloneNode(true); // click clear icon
        event = Object.create(e, {
            target: {
                value: currentTarget
            },
            currentTarget: {
                value: currentTarget
            }
        });
        currentTarget.value = "";
        onChange(event);
        return;
    } // Trigger by composition event, this means we need force change the input value
    if (targetValue !== undefined) {
        event = Object.create(e, {
            target: {
                value: target
            },
            currentTarget: {
                value: target
            }
        });
        target.value = targetValue;
        onChange(event);
        return;
    }
    onChange(event);
}
function $6dc6d2073ba32fa1$export$2b92016deb0b7aad(element, option) {
    if (!element) return;
    element.focus(option); // Selection content
    var _ref = option || {}, cursor = _ref.cursor;
    if (cursor) {
        var len = element.value.length;
        switch(cursor){
            case "start":
                element.setSelectionRange(0, 0);
                break;
            case "end":
                element.setSelectionRange(len, len);
                break;
            default:
                element.setSelectionRange(0, len);
        }
    }
}
function $6dc6d2073ba32fa1$export$ef94f7f24276a29c(value) {
    if (typeof value === "undefined" || value === null) return "";
    return String(value);
}

});


parcelRegister("cxWfh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9225bf6c69c415e6$export$2e2bcd8739ae039; });

var $jncUt = parcelRequire("jncUt");

var $huwkX = parcelRequire("huwkX");

var $7i29i = parcelRequire("7i29i");

var $8K2NM = parcelRequire("8K2NM");

var $CZyex = parcelRequire("CZyex");

var $ccQt4 = parcelRequire("ccQt4");

var $jbmdS = parcelRequire("jbmdS");

var $228sj = parcelRequire("228sj");

var $cXDkH = parcelRequire("cXDkH");

var $9qkZ9 = parcelRequire("9qkZ9");

var $02LyB = parcelRequire("02LyB");

var $9nYhz = parcelRequire("9nYhz");
var $9225bf6c69c415e6$var$_excluded = [
    "autoComplete",
    "onChange",
    "onFocus",
    "onBlur",
    "onPressEnter",
    "onKeyDown",
    "prefixCls",
    "disabled",
    "htmlSize",
    "className",
    "maxLength",
    "suffix",
    "showCount",
    "type",
    "inputClassName"
];
var $9225bf6c69c415e6$var$Input = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(props, ref) {
    var autoComplete = props.autoComplete, onChange = props.onChange, onFocus = props.onFocus, onBlur = props.onBlur, onPressEnter = props.onPressEnter, onKeyDown = props.onKeyDown, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-input" : _props$prefixCls, disabled = props.disabled, htmlSize = props.htmlSize, className = props.className, maxLength = props.maxLength, suffix = props.suffix, showCount = props.showCount, _props$type = props.type, type = _props$type === void 0 ? "text" : _props$type, inputClassName = props.inputClassName, rest = (0, $ccQt4.default)(props, $9225bf6c69c415e6$var$_excluded);
    var _useMergedState = (0, $9nYhz.default)(props.defaultValue, {
        value: props.value
    }), _useMergedState2 = (0, $CZyex.default)(_useMergedState, 2), value = _useMergedState2[0], setValue = _useMergedState2[1];
    var _useState = (0, $jbmdS.useState)(false), _useState2 = (0, $CZyex.default)(_useState, 2), focused = _useState2[0], setFocused = _useState2[1];
    var inputRef = (0, $jbmdS.useRef)(null);
    var focus = function focus(option) {
        if (inputRef.current) (0, $9qkZ9.triggerFocus)(inputRef.current, option);
    };
    (0, $jbmdS.useImperativeHandle)(ref, function() {
        return {
            focus: focus,
            blur: function blur() {
                var _inputRef$current;
                (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.blur();
            },
            setSelectionRange: function setSelectionRange(start, end, direction) {
                var _inputRef$current2;
                (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.setSelectionRange(start, end, direction);
            },
            select: function select() {
                var _inputRef$current3;
                (_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 || _inputRef$current3.select();
            },
            input: inputRef.current
        };
    });
    (0, $jbmdS.useEffect)(function() {
        setFocused(function(prev) {
            return prev && disabled ? false : prev;
        });
    }, [
        disabled
    ]);
    var handleChange = function handleChange(e) {
        if (props.value === undefined) setValue(e.target.value);
        if (inputRef.current) (0, $9qkZ9.resolveOnChange)(inputRef.current, e, onChange);
    };
    var handleKeyDown = function handleKeyDown(e) {
        if (onPressEnter && e.key === "Enter") onPressEnter(e);
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
    };
    var handleFocus = function handleFocus(e) {
        setFocused(true);
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    var handleBlur = function handleBlur(e) {
        setFocused(false);
        onBlur === null || onBlur === void 0 || onBlur(e);
    };
    var handleReset = function handleReset(e) {
        setValue("");
        focus();
        if (inputRef.current) (0, $9qkZ9.resolveOnChange)(inputRef.current, e, onChange);
    };
    var getInputElement = function getInputElement() {
        // Fix https://fb.me/react-unknown-prop
        var otherProps = (0, $cXDkH.default)(props, [
            "prefixCls",
            "onPressEnter",
            "addonBefore",
            "addonAfter",
            "prefix",
            "suffix",
            "allowClear",
            // specify either the value prop, or the defaultValue prop, but not both.
            "defaultValue",
            "showCount",
            "affixWrapperClassName",
            "groupClassName",
            "inputClassName",
            "wrapperClassName",
            "htmlSize"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("input", (0, $7i29i.default)({
            autoComplete: autoComplete
        }, otherProps, {
            onChange: handleChange,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyDown: handleKeyDown,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(prefixCls, (0, $8K2NM.default)({}, "".concat(prefixCls, "-disabled"), disabled), inputClassName, !(0, $9qkZ9.hasAddon)(props) && !(0, $9qkZ9.hasPrefixSuffix)(props) && className),
            ref: inputRef,
            size: htmlSize,
            type: type
        }));
    };
    var getSuffix = function getSuffix() {
        // Max length value
        var hasMaxLength = Number(maxLength) > 0;
        if (suffix || showCount) {
            var val = (0, $9qkZ9.fixControlledValue)(value);
            var valueLength = (0, $huwkX.default)(val).length;
            var dataCount = (0, $jncUt.default)(showCount) === "object" ? showCount.formatter({
                value: val,
                count: valueLength,
                maxLength: maxLength
            }) : "".concat(valueLength).concat(hasMaxLength ? " / ".concat(maxLength) : "");
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).Fragment, null, !!showCount && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("".concat(prefixCls, "-show-count-suffix"), (0, $8K2NM.default)({}, "".concat(prefixCls, "-show-count-has-suffix"), !!suffix))
            }, dataCount), suffix);
        }
        return null;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $228sj.default), (0, $7i29i.default)({}, rest, {
        prefixCls: prefixCls,
        className: className,
        inputElement: getInputElement(),
        handleReset: handleReset,
        value: (0, $9qkZ9.fixControlledValue)(value),
        focused: focused,
        triggerFocus: focus,
        suffix: getSuffix(),
        disabled: disabled
    }));
});
var $9225bf6c69c415e6$export$2e2bcd8739ae039 = $9225bf6c69c415e6$var$Input;

});


parcelRegister("j4i2o", function(module, exports) {

$parcel$export(module.exports, "getStatusClassNames", function () { return $de1c61f3256ec654$export$b08e7b47149942a2; });
$parcel$export(module.exports, "getMergedStatus", function () { return $de1c61f3256ec654$export$314e193082d7ba49; });

var $8K2NM = parcelRequire("8K2NM");

var $02LyB = parcelRequire("02LyB");

var $3IdWL = parcelRequire("3IdWL");
var $de1c61f3256ec654$var$InputStatuses = (0, $3IdWL.tuple)("warning", "error", "");
function $de1c61f3256ec654$export$b08e7b47149942a2(prefixCls, status, hasFeedback) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)({}, "".concat(prefixCls, "-status-success"), status === "success"), "".concat(prefixCls, "-status-warning"), status === "warning"), "".concat(prefixCls, "-status-error"), status === "error"), "".concat(prefixCls, "-status-validating"), status === "validating"), "".concat(prefixCls, "-has-feedback"), hasFeedback));
}
var $de1c61f3256ec654$export$314e193082d7ba49 = function getMergedStatus(contextStatus, customStatus) {
    return customStatus || contextStatus;
};

});

parcelRegister("cynju", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $923abe8e64041310$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");
function $923abe8e64041310$export$2e2bcd8739ae039(inputRef, triggerOnMount) {
    var removePasswordTimeoutRef = (0, $jbmdS.useRef)([]);
    var removePasswordTimeout = function removePasswordTimeout() {
        removePasswordTimeoutRef.current.push(setTimeout(function() {
            var _a, _b, _c, _d;
            if (((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input) && ((_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.input.getAttribute("type")) === "password" && ((_c = inputRef.current) === null || _c === void 0 ? void 0 : _c.input.hasAttribute("value"))) (_d = inputRef.current) === null || _d === void 0 || _d.input.removeAttribute("value");
        }));
    };
    (0, $jbmdS.useEffect)(function() {
        if (triggerOnMount) removePasswordTimeout();
        return function() {
            return removePasswordTimeoutRef.current.forEach(function(timer) {
                if (timer) clearTimeout(timer);
            });
        };
    }, []);
    return removePasswordTimeout;
}

});

parcelRegister("gUkIS", function(module, exports) {

$parcel$export(module.exports, "hasPrefixSuffix", function () { return $c4f1f36d75f86f1b$export$a19010aeeaa0c7a; });
// eslint-disable-next-line import/prefer-default-export
function $c4f1f36d75f86f1b$export$a19010aeeaa0c7a(props) {
    return !!(props.prefix || props.suffix || props.allowClear);
}

});


parcelRegister("9p1pa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d8789d959ca9216$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $8K2NM = parcelRequire("8K2NM");

var $CZyex = parcelRequire("CZyex");

var $jncUt = parcelRequire("jncUt");

var $gjSBn = parcelRequire("gjSBn");

var $6htix = parcelRequire("6htix");

var $02LyB = parcelRequire("02LyB");

var $cXDkH = parcelRequire("cXDkH");

var $aKVEK = parcelRequire("aKVEK");

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("8uDri");
var $ewikT = parcelRequire("ewikT");

var $cynju = parcelRequire("cynju");

var $lsAFg = parcelRequire("lsAFg");
var $6d8789d959ca9216$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $6d8789d959ca9216$var$defaultIconRender = function defaultIconRender(visible) {
    return visible ? /*#__PURE__*/ $jbmdS.createElement((0, $6htix.default), null) : /*#__PURE__*/ $jbmdS.createElement((0, $gjSBn.default), null);
};
var $6d8789d959ca9216$var$ActionMap = {
    click: "onClick",
    hover: "onMouseOver"
};
var $6d8789d959ca9216$var$Password = /*#__PURE__*/ $jbmdS.forwardRef(function(props, ref) {
    var _props$visibilityTogg = props.visibilityToggle, visibilityToggle = _props$visibilityTogg === void 0 ? true : _props$visibilityTogg;
    var visibilityControlled = (0, $jncUt.default)(visibilityToggle) === "object" && visibilityToggle.visible !== undefined;
    var _useState = (0, $jbmdS.useState)(function() {
        return visibilityControlled ? visibilityToggle.visible : false;
    }), _useState2 = (0, $CZyex.default)(_useState, 2), visible = _useState2[0], setVisible = _useState2[1];
    var inputRef = (0, $jbmdS.useRef)(null);
    $jbmdS.useEffect(function() {
        if (visibilityControlled) setVisible(visibilityToggle.visible);
    }, [
        visibilityControlled,
        visibilityToggle
    ]);
    // Remove Password value
    var removePasswordTimeout = (0, $cynju.default)(inputRef);
    var onVisibleChange = function onVisibleChange() {
        var disabled = props.disabled;
        if (disabled) return;
        if (visible) removePasswordTimeout();
        setVisible(function(prevState) {
            var _a;
            var newState = !prevState;
            if ((0, $jncUt.default)(visibilityToggle) === "object") (_a = visibilityToggle.onVisibleChange) === null || _a === void 0 || _a.call(visibilityToggle, newState);
            return newState;
        });
    };
    var getIcon = function getIcon(prefixCls) {
        var _props$action = props.action, action = _props$action === void 0 ? "click" : _props$action, _props$iconRender = props.iconRender, iconRender = _props$iconRender === void 0 ? $6d8789d959ca9216$var$defaultIconRender : _props$iconRender;
        var iconTrigger = $6d8789d959ca9216$var$ActionMap[action] || "";
        var icon = iconRender(visible);
        var iconProps = (0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)({}, iconTrigger, onVisibleChange), "className", "".concat(prefixCls, "-icon")), "key", "passwordIcon"), "onMouseDown", function onMouseDown(e) {
            // Prevent focused state lost
            // https://github.com/ant-design/ant-design/issues/15173
            e.preventDefault();
        }), "onMouseUp", function onMouseUp(e) {
            // Prevent caret position change
            // https://github.com/ant-design/ant-design/issues/23524
            e.preventDefault();
        });
        return /*#__PURE__*/ $jbmdS.cloneElement(/*#__PURE__*/ $jbmdS.isValidElement(icon) ? icon : /*#__PURE__*/ $jbmdS.createElement("span", null, icon), iconProps);
    };
    var renderPassword = function renderPassword(_ref) {
        var getPrefixCls = _ref.getPrefixCls;
        var className = props.className, customizePrefixCls = props.prefixCls, customizeInputPrefixCls = props.inputPrefixCls, size = props.size, restProps = $6d8789d959ca9216$var$__rest(props, [
            "className",
            "prefixCls",
            "inputPrefixCls",
            "size"
        ]);
        var inputPrefixCls = getPrefixCls("input", customizeInputPrefixCls);
        var prefixCls = getPrefixCls("input-password", customizePrefixCls);
        var suffixIcon = visibilityToggle && getIcon(prefixCls);
        var inputClassName = (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(prefixCls, className, (0, $8K2NM.default)({}, "".concat(prefixCls, "-").concat(size), !!size));
        var omittedProps = (0, $7i29i.default)((0, $7i29i.default)({}, (0, $cXDkH.default)(restProps, [
            "suffix",
            "iconRender",
            "visibilityToggle"
        ])), {
            type: visible ? "text" : "password",
            className: inputClassName,
            prefixCls: inputPrefixCls,
            suffix: suffixIcon
        });
        if (size) omittedProps.size = size;
        return /*#__PURE__*/ $jbmdS.createElement((0, $lsAFg.default), (0, $7i29i.default)({
            ref: (0, $aKVEK.composeRef)(ref, inputRef)
        }, omittedProps));
    };
    return /*#__PURE__*/ $jbmdS.createElement((0, $ewikT.ConfigConsumer), null, renderPassword);
});
var $6d8789d959ca9216$export$2e2bcd8739ae039 = $6d8789d959ca9216$var$Password;

});
parcelRegister("gjSBn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be18c675f0c43b60$export$2e2bcd8739ae039; });

var $lv6ip = parcelRequire("lv6ip");

var $jbmdS = parcelRequire("jbmdS");

var $534SQ = parcelRequire("534SQ");

var $4hKc4 = parcelRequire("4hKc4");
var $be18c675f0c43b60$var$EyeInvisibleOutlined = function EyeInvisibleOutlined(props, ref) {
    return /*#__PURE__*/ $jbmdS.createElement((0, $4hKc4.default), (0, $lv6ip.default)((0, $lv6ip.default)({}, props), {}, {
        ref: ref,
        icon: (0, $534SQ.default)
    }));
};
var $be18c675f0c43b60$var$RefIcon = /*#__PURE__*/ $jbmdS.forwardRef($be18c675f0c43b60$var$EyeInvisibleOutlined);
var $be18c675f0c43b60$export$2e2bcd8739ae039 = $be18c675f0c43b60$var$RefIcon;

});
parcelRegister("534SQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ad1055dbc44d91f$export$2e2bcd8739ae039; });
// This icon file is generated automatically.
var $3ad1055dbc44d91f$var$EyeInvisibleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z"
                }
            }
        ]
    },
    "name": "eye-invisible",
    "theme": "outlined"
};
var $3ad1055dbc44d91f$export$2e2bcd8739ae039 = $3ad1055dbc44d91f$var$EyeInvisibleOutlined;

});


parcelRegister("6htix", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $492b0e9a2a996687$export$2e2bcd8739ae039; });

var $lv6ip = parcelRequire("lv6ip");

var $jbmdS = parcelRequire("jbmdS");

var $kxHmp = parcelRequire("kxHmp");

var $4hKc4 = parcelRequire("4hKc4");
var $492b0e9a2a996687$var$EyeOutlined = function EyeOutlined(props, ref) {
    return /*#__PURE__*/ $jbmdS.createElement((0, $4hKc4.default), (0, $lv6ip.default)((0, $lv6ip.default)({}, props), {}, {
        ref: ref,
        icon: (0, $kxHmp.default)
    }));
};
var $492b0e9a2a996687$var$RefIcon = /*#__PURE__*/ $jbmdS.forwardRef($492b0e9a2a996687$var$EyeOutlined);
var $492b0e9a2a996687$export$2e2bcd8739ae039 = $492b0e9a2a996687$var$RefIcon;

});
parcelRegister("kxHmp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef4886353b3be3d5$export$2e2bcd8739ae039; });
// This icon file is generated automatically.
var $ef4886353b3be3d5$var$EyeOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"
                }
            }
        ]
    },
    "name": "eye",
    "theme": "outlined"
};
var $ef4886353b3be3d5$export$2e2bcd8739ae039 = $ef4886353b3be3d5$var$EyeOutlined;

});



parcelRegister("3pGzq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27c4ba77219509b3$export$2e2bcd8739ae039; });

var $8K2NM = parcelRequire("8K2NM");

var $7i29i = parcelRequire("7i29i");

var $lCuWO = parcelRequire("lCuWO");

var $02LyB = parcelRequire("02LyB");

var $aKVEK = parcelRequire("aKVEK");

var $jbmdS = parcelRequire("jbmdS");

var $e4oIi = parcelRequire("e4oIi");
parcelRequire("8uDri");
var $ewikT = parcelRequire("ewikT");

var $7VQDG = parcelRequire("7VQDG");

var $9RKXl = parcelRequire("9RKXl");

var $l34u6 = parcelRequire("l34u6");

var $lsAFg = parcelRequire("lsAFg");
var $27c4ba77219509b3$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $27c4ba77219509b3$var$Search = /*#__PURE__*/ $jbmdS.forwardRef(function(props, ref) {
    var customizePrefixCls = props.prefixCls, customizeInputPrefixCls = props.inputPrefixCls, className = props.className, customizeSize = props.size, suffix = props.suffix, _props$enterButton = props.enterButton, enterButton = _props$enterButton === void 0 ? false : _props$enterButton, addonAfter = props.addonAfter, loading = props.loading, disabled = props.disabled, customOnSearch = props.onSearch, customOnChange = props.onChange, onCompositionStart = props.onCompositionStart, onCompositionEnd = props.onCompositionEnd, restProps = $27c4ba77219509b3$var$__rest(props, [
        "prefixCls",
        "inputPrefixCls",
        "className",
        "size",
        "suffix",
        "enterButton",
        "addonAfter",
        "loading",
        "disabled",
        "onSearch",
        "onChange",
        "onCompositionStart",
        "onCompositionEnd"
    ]);
    var _React$useContext = $jbmdS.useContext((0, $ewikT.ConfigContext)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var contextSize = $jbmdS.useContext((0, $7VQDG.default));
    var composedRef = $jbmdS.useRef(false);
    var prefixCls = getPrefixCls("input-search", customizePrefixCls);
    var inputPrefixCls = getPrefixCls("input", customizeInputPrefixCls);
    var _useCompactItemContex = (0, $9RKXl.useCompactItemContext)(prefixCls, direction), compactSize = _useCompactItemContex.compactSize;
    var size = compactSize || customizeSize || contextSize;
    var inputRef = $jbmdS.useRef(null);
    var onChange = function onChange(e) {
        if (e && e.target && e.type === "click" && customOnSearch) customOnSearch(e.target.value, e);
        if (customOnChange) customOnChange(e);
    };
    var onMouseDown = function onMouseDown(e) {
        var _a;
        if (document.activeElement === ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input)) e.preventDefault();
    };
    var onSearch = function onSearch(e) {
        var _a, _b;
        if (customOnSearch) customOnSearch((_b = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input) === null || _b === void 0 ? void 0 : _b.value, e);
    };
    var onPressEnter = function onPressEnter(e) {
        if (composedRef.current || loading) return;
        onSearch(e);
    };
    var searchIcon = typeof enterButton === "boolean" ? /*#__PURE__*/ $jbmdS.createElement((0, $lCuWO.default), null) : null;
    var btnClassName = "".concat(prefixCls, "-button");
    var button;
    var enterButtonAsElement = enterButton || {};
    var isAntdButton = enterButtonAsElement.type && enterButtonAsElement.type.__ANT_BUTTON === true;
    if (isAntdButton || enterButtonAsElement.type === "button") button = (0, $l34u6.cloneElement)(enterButtonAsElement, (0, $7i29i.default)({
        onMouseDown: onMouseDown,
        onClick: function onClick(e) {
            var _a, _b;
            (_b = (_a = enterButtonAsElement === null || enterButtonAsElement === void 0 ? void 0 : enterButtonAsElement.props) === null || _a === void 0 ? void 0 : _a.onClick) === null || _b === void 0 || _b.call(_a, e);
            onSearch(e);
        },
        key: "enterButton"
    }, isAntdButton ? {
        className: btnClassName,
        size: size
    } : {}));
    else button = /*#__PURE__*/ $jbmdS.createElement((0, $e4oIi.default), {
        className: btnClassName,
        type: enterButton ? "primary" : undefined,
        size: size,
        disabled: disabled,
        key: "enterButton",
        onMouseDown: onMouseDown,
        onClick: onSearch,
        loading: loading,
        icon: searchIcon
    }, enterButton);
    if (addonAfter) button = [
        button,
        (0, $l34u6.cloneElement)(addonAfter, {
            key: "addonAfter"
        })
    ];
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(prefixCls, (0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)({}, "".concat(prefixCls, "-rtl"), direction === "rtl"), "".concat(prefixCls, "-").concat(size), !!size), "".concat(prefixCls, "-with-button"), !!enterButton), className);
    var handleOnCompositionStart = function handleOnCompositionStart(e) {
        composedRef.current = true;
        onCompositionStart === null || onCompositionStart === void 0 || onCompositionStart(e);
    };
    var handleOnCompositionEnd = function handleOnCompositionEnd(e) {
        composedRef.current = false;
        onCompositionEnd === null || onCompositionEnd === void 0 || onCompositionEnd(e);
    };
    return /*#__PURE__*/ $jbmdS.createElement((0, $lsAFg.default), (0, $7i29i.default)({
        ref: (0, $aKVEK.composeRef)(inputRef, ref),
        onPressEnter: onPressEnter
    }, restProps, {
        size: size,
        onCompositionStart: handleOnCompositionStart,
        onCompositionEnd: handleOnCompositionEnd,
        prefixCls: inputPrefixCls,
        addonAfter: button,
        suffix: suffix,
        onChange: onChange,
        className: cls,
        disabled: disabled
    }));
});
var $27c4ba77219509b3$export$2e2bcd8739ae039 = $27c4ba77219509b3$var$Search;

});
parcelRegister("lCuWO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fbd52722ccb085b8$export$2e2bcd8739ae039; });

var $lv6ip = parcelRequire("lv6ip");

var $jbmdS = parcelRequire("jbmdS");

var $lOrya = parcelRequire("lOrya");

var $4hKc4 = parcelRequire("4hKc4");
var $fbd52722ccb085b8$var$SearchOutlined = function SearchOutlined(props, ref) {
    return /*#__PURE__*/ $jbmdS.createElement((0, $4hKc4.default), (0, $lv6ip.default)((0, $lv6ip.default)({}, props), {}, {
        ref: ref,
        icon: (0, $lOrya.default)
    }));
};
var $fbd52722ccb085b8$var$RefIcon = /*#__PURE__*/ $jbmdS.forwardRef($fbd52722ccb085b8$var$SearchOutlined);
var $fbd52722ccb085b8$export$2e2bcd8739ae039 = $fbd52722ccb085b8$var$RefIcon;

});
parcelRegister("lOrya", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe13a357d28a947d$export$2e2bcd8739ae039; });
// This icon file is generated automatically.
var $fe13a357d28a947d$var$SearchOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"
                }
            }
        ]
    },
    "name": "search",
    "theme": "outlined"
};
var $fe13a357d28a947d$export$2e2bcd8739ae039 = $fe13a357d28a947d$var$SearchOutlined;

});



parcelRegister("3xbOw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $292d9e251defcd77$export$2e2bcd8739ae039; });

var $jncUt = parcelRequire("jncUt");

var $8K2NM = parcelRequire("8K2NM");

var $7i29i = parcelRequire("7i29i");

var $CZyex = parcelRequire("CZyex");

var $huwkX = parcelRequire("huwkX");

var $02LyB = parcelRequire("02LyB");

var $3Yxet = parcelRequire("3Yxet");

var $9nYhz = parcelRequire("9nYhz");

var $cXDkH = parcelRequire("cXDkH");

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("8uDri");
var $ewikT = parcelRequire("ewikT");

var $kgIuF = parcelRequire("kgIuF");

var $7VQDG = parcelRequire("7VQDG");

var $3ACNS = parcelRequire("3ACNS");

var $j4i2o = parcelRequire("j4i2o");

var $782ya = parcelRequire("782ya");

var $lsAFg = parcelRequire("lsAFg");
var $292d9e251defcd77$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $292d9e251defcd77$var$fixEmojiLength(value, maxLength) {
    return (0, $huwkX.default)(value || "").slice(0, maxLength).join("");
}
function $292d9e251defcd77$var$setTriggerValue(isCursorInEnd, preValue, triggerValue, maxLength) {
    var newTriggerValue = triggerValue;
    if (isCursorInEnd) // 光标在尾部，直接截断
    newTriggerValue = $292d9e251defcd77$var$fixEmojiLength(triggerValue, maxLength);
    else if ((0, $huwkX.default)(preValue || "").length < triggerValue.length && (0, $huwkX.default)(triggerValue || "").length > maxLength) // 光标在中间，如果最后的值超过最大值，则采用原先的值
    newTriggerValue = preValue;
    return newTriggerValue;
}
var $292d9e251defcd77$var$TextArea = /*#__PURE__*/ $jbmdS.forwardRef(function(_a, ref) {
    var customizePrefixCls = _a.prefixCls, _a$bordered = _a.bordered, bordered = _a$bordered === void 0 ? true : _a$bordered, _a$showCount = _a.showCount, showCount = _a$showCount === void 0 ? false : _a$showCount, maxLength = _a.maxLength, className = _a.className, style = _a.style, customizeSize = _a.size, customDisabled = _a.disabled, onCompositionStart = _a.onCompositionStart, onCompositionEnd = _a.onCompositionEnd, onChange = _a.onChange, onFocus = _a.onFocus, onBlur = _a.onBlur, customStatus = _a.status, props = $292d9e251defcd77$var$__rest(_a, [
        "prefixCls",
        "bordered",
        "showCount",
        "maxLength",
        "className",
        "style",
        "size",
        "disabled",
        "onCompositionStart",
        "onCompositionEnd",
        "onChange",
        "onFocus",
        "onBlur",
        "status"
    ]);
    var _React$useContext = $jbmdS.useContext((0, $ewikT.ConfigContext)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var size = $jbmdS.useContext((0, $7VQDG.default));
    // ===================== Disabled =====================
    var disabled = $jbmdS.useContext((0, $kgIuF.default));
    var mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    var _React$useContext2 = $jbmdS.useContext((0, $3ACNS.FormItemInputContext)), contextStatus = _React$useContext2.status, hasFeedback = _React$useContext2.hasFeedback, isFormItemInput = _React$useContext2.isFormItemInput, feedbackIcon = _React$useContext2.feedbackIcon;
    var mergedStatus = (0, $j4i2o.getMergedStatus)(contextStatus, customStatus);
    var innerRef = $jbmdS.useRef(null);
    var clearableInputRef = $jbmdS.useRef(null);
    var _React$useState = $jbmdS.useState(false), _React$useState2 = (0, $CZyex.default)(_React$useState, 2), compositing = _React$useState2[0], setCompositing = _React$useState2[1];
    var _React$useState3 = $jbmdS.useState(false), _React$useState4 = (0, $CZyex.default)(_React$useState3, 2), focused = _React$useState4[0], setFocused = _React$useState4[1];
    var oldCompositionValueRef = $jbmdS.useRef();
    var oldSelectionStartRef = $jbmdS.useRef(0);
    var _useMergedState = (0, $9nYhz.default)(props.defaultValue, {
        value: props.value
    }), _useMergedState2 = (0, $CZyex.default)(_useMergedState, 2), value = _useMergedState2[0], setValue = _useMergedState2[1];
    var hidden = props.hidden;
    var handleSetValue = function handleSetValue(val, callback) {
        if (props.value === undefined) {
            setValue(val);
            callback === null || callback === void 0 || callback();
        }
    };
    // =========================== Value Update ===========================
    // Max length value
    var hasMaxLength = Number(maxLength) > 0;
    var onInternalCompositionStart = function onInternalCompositionStart(e) {
        setCompositing(true);
        // 拼音输入前保存一份旧值
        oldCompositionValueRef.current = value;
        // 保存旧的光标位置
        oldSelectionStartRef.current = e.currentTarget.selectionStart;
        onCompositionStart === null || onCompositionStart === void 0 || onCompositionStart(e);
    };
    var onInternalCompositionEnd = function onInternalCompositionEnd(e) {
        var _a;
        setCompositing(false);
        var triggerValue = e.currentTarget.value;
        if (hasMaxLength) {
            var isCursorInEnd = oldSelectionStartRef.current >= maxLength + 1 || oldSelectionStartRef.current === ((_a = oldCompositionValueRef.current) === null || _a === void 0 ? void 0 : _a.length);
            triggerValue = $292d9e251defcd77$var$setTriggerValue(isCursorInEnd, oldCompositionValueRef.current, triggerValue, maxLength);
        }
        // Patch composition onChange when value changed
        if (triggerValue !== value) {
            handleSetValue(triggerValue);
            (0, $lsAFg.resolveOnChange)(e.currentTarget, e, onChange, triggerValue);
        }
        onCompositionEnd === null || onCompositionEnd === void 0 || onCompositionEnd(e);
    };
    var handleChange = function handleChange(e) {
        var triggerValue = e.target.value;
        if (!compositing && hasMaxLength) {
            // 1. 复制粘贴超过maxlength的情况 2.未超过maxlength的情况
            var isCursorInEnd = e.target.selectionStart >= maxLength + 1 || e.target.selectionStart === triggerValue.length || !e.target.selectionStart;
            triggerValue = $292d9e251defcd77$var$setTriggerValue(isCursorInEnd, value, triggerValue, maxLength);
        }
        handleSetValue(triggerValue);
        (0, $lsAFg.resolveOnChange)(e.currentTarget, e, onChange, triggerValue);
    };
    var handleBlur = function handleBlur(e) {
        setFocused(false);
        onBlur === null || onBlur === void 0 || onBlur(e);
    };
    var handleFocus = function handleFocus(e) {
        setFocused(true);
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    $jbmdS.useEffect(function() {
        setFocused(function(prev) {
            return !mergedDisabled && prev;
        });
    }, [
        mergedDisabled
    ]);
    // ============================== Reset ===============================
    var handleReset = function handleReset(e) {
        var _a, _b, _c;
        handleSetValue("");
        (_a = innerRef.current) === null || _a === void 0 || _a.focus();
        (0, $lsAFg.resolveOnChange)((_c = (_b = innerRef.current) === null || _b === void 0 ? void 0 : _b.resizableTextArea) === null || _c === void 0 ? void 0 : _c.textArea, e, onChange);
    };
    var prefixCls = getPrefixCls("input", customizePrefixCls);
    $jbmdS.useImperativeHandle(ref, function() {
        var _a;
        return {
            resizableTextArea: (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.resizableTextArea,
            focus: function focus(option) {
                var _a, _b;
                (0, $lsAFg.triggerFocus)((_b = (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.resizableTextArea) === null || _b === void 0 ? void 0 : _b.textArea, option);
            },
            blur: function blur() {
                var _a;
                return (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.blur();
            }
        };
    });
    var textArea = /*#__PURE__*/ $jbmdS.createElement((0, $3Yxet.default), (0, $7i29i.default)({}, (0, $cXDkH.default)(props, [
        "allowClear"
    ]), {
        disabled: mergedDisabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)({}, "".concat(prefixCls, "-borderless"), !bordered), className, className && !showCount), "".concat(prefixCls, "-sm"), size === "small" || customizeSize === "small"), "".concat(prefixCls, "-lg"), size === "large" || customizeSize === "large"), (0, $j4i2o.getStatusClassNames)(prefixCls, mergedStatus)),
        style: showCount ? {
            resize: style === null || style === void 0 ? void 0 : style.resize
        } : style,
        prefixCls: prefixCls,
        onCompositionStart: onInternalCompositionStart,
        onChange: handleChange,
        onBlur: handleBlur,
        onFocus: handleFocus,
        onCompositionEnd: onInternalCompositionEnd,
        ref: innerRef
    }));
    var val = (0, $lsAFg.fixControlledValue)(value);
    if (!compositing && hasMaxLength && (props.value === null || props.value === undefined)) // fix #27612 将value转为数组进行截取，解决 '😂'.length === 2 等emoji表情导致的截取乱码的问题
    val = $292d9e251defcd77$var$fixEmojiLength(val, maxLength);
    // TextArea
    var textareaNode = /*#__PURE__*/ $jbmdS.createElement((0, $782ya.default), (0, $7i29i.default)({
        disabled: mergedDisabled,
        focused: focused
    }, props, {
        prefixCls: prefixCls,
        direction: direction,
        inputType: "text",
        value: val,
        element: textArea,
        handleReset: handleReset,
        ref: clearableInputRef,
        bordered: bordered,
        status: customStatus,
        style: showCount ? undefined : style
    }));
    // Only show text area wrapper when needed
    if (showCount || hasFeedback) {
        var valueLength = (0, $huwkX.default)(val).length;
        var dataCount = "";
        if ((0, $jncUt.default)(showCount) === "object") dataCount = showCount.formatter({
            value: val,
            count: valueLength,
            maxLength: maxLength
        });
        else dataCount = "".concat(valueLength).concat(hasMaxLength ? " / ".concat(maxLength) : "");
        return /*#__PURE__*/ $jbmdS.createElement("div", {
            hidden: hidden,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("".concat(prefixCls, "-textarea"), (0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)({}, "".concat(prefixCls, "-textarea-rtl"), direction === "rtl"), "".concat(prefixCls, "-textarea-show-count"), showCount), "".concat(prefixCls, "-textarea-in-form-item"), isFormItemInput), (0, $j4i2o.getStatusClassNames)("".concat(prefixCls, "-textarea"), mergedStatus, hasFeedback), className),
            style: style,
            "data-count": dataCount
        }, textareaNode, hasFeedback && /*#__PURE__*/ $jbmdS.createElement("span", {
            className: "".concat(prefixCls, "-textarea-suffix")
        }, feedbackIcon));
    }
    return textareaNode;
});
var $292d9e251defcd77$export$2e2bcd8739ae039 = $292d9e251defcd77$var$TextArea;

});
parcelRegister("3Yxet", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e50c0f193f3ba53$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $3GVdq = parcelRequire("3GVdq");

var $jj5jQ = parcelRequire("jj5jQ");

var $1N4zm = parcelRequire("1N4zm");

var $gRFRo = parcelRequire("gRFRo");

var $jbmdS = parcelRequire("jbmdS");

var $lYkCM = parcelRequire("lYkCM");
var $2e50c0f193f3ba53$var$TextArea = /*#__PURE__*/ function(_React$Component) {
    (0, $1N4zm.default)(TextArea, _React$Component);
    var _super = (0, $gRFRo.default)(TextArea);
    function TextArea(props) {
        var _this;
        (0, $3GVdq.default)(this, TextArea);
        _this = _super.call(this, props);
        _this.resizableTextArea = void 0;
        _this.focus = function() {
            _this.resizableTextArea.textArea.focus();
        };
        _this.saveTextArea = function(resizableTextArea) {
            _this.resizableTextArea = resizableTextArea;
        };
        _this.handleChange = function(e) {
            var onChange = _this.props.onChange;
            _this.setValue(e.target.value);
            if (onChange) onChange(e);
        };
        _this.handleKeyDown = function(e) {
            var _this$props = _this.props, onPressEnter = _this$props.onPressEnter, onKeyDown = _this$props.onKeyDown;
            if (e.keyCode === 13 && onPressEnter) onPressEnter(e);
            if (onKeyDown) onKeyDown(e);
        };
        var value = typeof props.value === "undefined" || props.value === null ? props.defaultValue : props.value;
        _this.state = {
            value: value
        };
        return _this;
    }
    (0, $jj5jQ.default)(TextArea, [
        {
            key: "setValue",
            value: function setValue(value, callback) {
                if (!("value" in this.props)) this.setState({
                    value: value
                }, callback);
            }
        },
        {
            key: "blur",
            value: function blur() {
                this.resizableTextArea.textArea.blur();
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ $jbmdS.createElement((0, $lYkCM.default), (0, $7i29i.default)({}, this.props, {
                    value: this.state.value,
                    onKeyDown: this.handleKeyDown,
                    onChange: this.handleChange,
                    ref: this.saveTextArea
                }));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps) {
                if ("value" in nextProps) return {
                    value: nextProps.value
                };
                return null;
            }
        }
    ]);
    return TextArea;
}($jbmdS.Component);
var $2e50c0f193f3ba53$export$2e2bcd8739ae039 = $2e50c0f193f3ba53$var$TextArea;

});
parcelRegister("lYkCM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ffef332bf1bd42c4$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $8K2NM = parcelRequire("8K2NM");

var $lv6ip = parcelRequire("lv6ip");

var $jncUt = parcelRequire("jncUt");

var $CZyex = parcelRequire("CZyex");

var $ccQt4 = parcelRequire("ccQt4");

var $jbmdS = parcelRequire("jbmdS");

var $fvfrs = parcelRequire("fvfrs");

var $iDOLX = parcelRequire("iDOLX");

var $2iJQe = parcelRequire("2iJQe");

var $9nYhz = parcelRequire("9nYhz");

var $02LyB = parcelRequire("02LyB");

var $595TI = parcelRequire("595TI");
var $ffef332bf1bd42c4$var$_excluded = [
    "prefixCls",
    "onPressEnter",
    "defaultValue",
    "value",
    "autoSize",
    "onResize",
    "className",
    "style",
    "disabled",
    "onChange",
    "onInternalAutoSize"
];
var $ffef332bf1bd42c4$var$RESIZE_START = 0;
var $ffef332bf1bd42c4$var$RESIZE_MEASURING = 1;
var $ffef332bf1bd42c4$var$RESIZE_STABLE = 2;
var $ffef332bf1bd42c4$var$ResizableTextArea = /*#__PURE__*/ $jbmdS.forwardRef(function(props, ref) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-textarea" : _props$prefixCls, onPressEnter = props.onPressEnter, defaultValue = props.defaultValue, value = props.value, autoSize = props.autoSize, onResize = props.onResize, className = props.className, style = props.style, disabled = props.disabled, onChange = props.onChange, onInternalAutoSize = props.onInternalAutoSize, restProps = (0, $ccQt4.default)(props, $ffef332bf1bd42c4$var$_excluded);
    // =============================== Value ================================
    var _useMergedState = (0, $9nYhz.default)(defaultValue, {
        value: value,
        postState: function postState(val) {
            return val !== null && val !== void 0 ? val : "";
        }
    }), _useMergedState2 = (0, $CZyex.default)(_useMergedState, 2), mergedValue = _useMergedState2[0], setMergedValue = _useMergedState2[1];
    var onInternalChange = function onInternalChange(event) {
        setMergedValue(event.target.value);
        onChange === null || onChange === void 0 || onChange(event);
    };
    // ================================ Ref =================================
    var textareaRef = $jbmdS.useRef();
    $jbmdS.useImperativeHandle(ref, function() {
        return {
            textArea: textareaRef.current
        };
    });
    // ============================== AutoSize ==============================
    var _React$useMemo = $jbmdS.useMemo(function() {
        if (autoSize && (0, $jncUt.default)(autoSize) === "object") return [
            autoSize.minRows,
            autoSize.maxRows
        ];
        return [];
    }, [
        autoSize
    ]), _React$useMemo2 = (0, $CZyex.default)(_React$useMemo, 2), minRows = _React$useMemo2[0], maxRows = _React$useMemo2[1];
    var needAutoSize = !!autoSize;
    // =============================== Scroll ===============================
    // https://github.com/ant-design/ant-design/issues/21870
    var fixFirefoxAutoScroll = function fixFirefoxAutoScroll() {
        try {
            // FF has bug with jump of scroll to top. We force back here.
            if (document.activeElement === textareaRef.current) {
                var _textareaRef$current = textareaRef.current, selectionStart = _textareaRef$current.selectionStart, selectionEnd = _textareaRef$current.selectionEnd, scrollTop = _textareaRef$current.scrollTop;
                // Fix Safari bug which not rollback when break line
                // This makes Chinese IME can't input. Do not fix this
                // const { value: tmpValue } = textareaRef.current;
                // textareaRef.current.value = '';
                // textareaRef.current.value = tmpValue;
                textareaRef.current.setSelectionRange(selectionStart, selectionEnd);
                textareaRef.current.scrollTop = scrollTop;
            }
        } catch (e) {
        // Fix error in Chrome:
        // Failed to read the 'selectionStart' property from 'HTMLInputElement'
        // http://stackoverflow.com/q/21177489/3040605
        }
    };
    // =============================== Resize ===============================
    var _React$useState = $jbmdS.useState($ffef332bf1bd42c4$var$RESIZE_STABLE), _React$useState2 = (0, $CZyex.default)(_React$useState, 2), resizeState = _React$useState2[0], setResizeState = _React$useState2[1];
    var _React$useState3 = $jbmdS.useState(), _React$useState4 = (0, $CZyex.default)(_React$useState3, 2), autoSizeStyle = _React$useState4[0], setAutoSizeStyle = _React$useState4[1];
    var startResize = function startResize() {
        setResizeState($ffef332bf1bd42c4$var$RESIZE_START);
    };
    // Change to trigger resize measure
    (0, $iDOLX.default)(function() {
        if (needAutoSize) startResize();
    }, [
        value,
        minRows,
        maxRows,
        needAutoSize
    ]);
    (0, $iDOLX.default)(function() {
        if (resizeState === $ffef332bf1bd42c4$var$RESIZE_START) setResizeState($ffef332bf1bd42c4$var$RESIZE_MEASURING);
        else if (resizeState === $ffef332bf1bd42c4$var$RESIZE_MEASURING) {
            var textareaStyles = (0, $595TI.default)(textareaRef.current, false, minRows, maxRows);
            // Safari has bug that text will keep break line on text cut when it's prev is break line.
            // ZombieJ: This not often happen. So we just skip it.
            // const { selectionStart, selectionEnd, scrollTop } = textareaRef.current;
            // const { value: tmpValue } = textareaRef.current;
            // textareaRef.current.value = '';
            // textareaRef.current.value = tmpValue;
            // if (document.activeElement === textareaRef.current) {
            //   textareaRef.current.scrollTop = scrollTop;
            //   textareaRef.current.setSelectionRange(selectionStart, selectionEnd);
            // }
            setResizeState($ffef332bf1bd42c4$var$RESIZE_STABLE);
            setAutoSizeStyle(textareaStyles);
        } else fixFirefoxAutoScroll();
    }, [
        resizeState
    ]);
    // We lock resize trigger by raf to avoid Safari warning
    var resizeRafRef = $jbmdS.useRef();
    var cleanRaf = function cleanRaf() {
        (0, $2iJQe.default).cancel(resizeRafRef.current);
    };
    var onInternalResize = function onInternalResize(size) {
        if (resizeState === $ffef332bf1bd42c4$var$RESIZE_STABLE) {
            onResize === null || onResize === void 0 || onResize(size);
            if (autoSize) {
                cleanRaf();
                resizeRafRef.current = (0, $2iJQe.default)(function() {
                    startResize();
                });
            }
        }
    };
    $jbmdS.useEffect(function() {
        return cleanRaf;
    }, []);
    // =============================== Render ===============================
    var mergedAutoSizeStyle = needAutoSize ? autoSizeStyle : null;
    var mergedStyle = (0, $lv6ip.default)((0, $lv6ip.default)({}, style), mergedAutoSizeStyle);
    if (resizeState === $ffef332bf1bd42c4$var$RESIZE_START || resizeState === $ffef332bf1bd42c4$var$RESIZE_MEASURING) {
        mergedStyle.overflowY = "hidden";
        mergedStyle.overflowX = "hidden";
    }
    return /*#__PURE__*/ $jbmdS.createElement((0, $fvfrs.default), {
        onResize: onInternalResize,
        disabled: !(autoSize || onResize)
    }, /*#__PURE__*/ $jbmdS.createElement("textarea", (0, $7i29i.default)({}, restProps, {
        ref: textareaRef,
        style: mergedStyle,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(prefixCls, className, (0, $8K2NM.default)({}, "".concat(prefixCls, "-disabled"), disabled)),
        disabled: disabled,
        value: mergedValue,
        onChange: onInternalChange
    })));
});
var $ffef332bf1bd42c4$export$2e2bcd8739ae039 = $ffef332bf1bd42c4$var$ResizableTextArea;

});
parcelRegister("fvfrs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b495bab641cd53b6$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $jbmdS = parcelRequire("jbmdS");

var $5AfDn = parcelRequire("5AfDn");
parcelRequire("8tMCd");

var $1Vzkv = parcelRequire("1Vzkv");

var $41tUJ = parcelRequire("41tUJ");

var $3Jsk7 = parcelRequire("3Jsk7");
var $b495bab641cd53b6$var$INTERNAL_PREFIX_KEY = "rc-observer-key";
function $b495bab641cd53b6$var$ResizeObserver(props, ref) {
    var children = props.children;
    var childNodes = typeof children === "function" ? [
        children
    ] : (0, $5AfDn.default)(children);
    return childNodes.map(function(child, index) {
        var key = (child === null || child === void 0 ? void 0 : child.key) || "".concat($b495bab641cd53b6$var$INTERNAL_PREFIX_KEY, "-").concat(index);
        return /*#__PURE__*/ $jbmdS.createElement((0, $1Vzkv.default), (0, $7i29i.default)({}, props, {
            key: key,
            ref: index === 0 ? ref : undefined
        }), child);
    });
}
var $b495bab641cd53b6$var$RefResizeObserver = /*#__PURE__*/ $jbmdS.forwardRef($b495bab641cd53b6$var$ResizeObserver);
$b495bab641cd53b6$var$RefResizeObserver.Collection = (0, $41tUJ.Collection);
var $b495bab641cd53b6$export$2e2bcd8739ae039 = $b495bab641cd53b6$var$RefResizeObserver;

});
parcelRegister("1Vzkv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16768510292504b1$export$2e2bcd8739ae039; });

var $lv6ip = parcelRequire("lv6ip");

var $jncUt = parcelRequire("jncUt");

var $1RfjE = parcelRequire("1RfjE");

var $aKVEK = parcelRequire("aKVEK");

var $jbmdS = parcelRequire("jbmdS");

var $41tUJ = parcelRequire("41tUJ");

var $3Jsk7 = parcelRequire("3Jsk7");

var $fP6W5 = parcelRequire("fP6W5");
function $16768510292504b1$var$SingleObserver(props, ref) {
    var children = props.children, disabled = props.disabled;
    var elementRef = $jbmdS.useRef(null);
    var wrapperRef = $jbmdS.useRef(null);
    var onCollectionResize = $jbmdS.useContext((0, $41tUJ.CollectionContext));
    // =========================== Children ===========================
    var isRenderProps = typeof children === "function";
    var mergedChildren = isRenderProps ? children(elementRef) : children;
    // ============================= Size =============================
    var sizeRef = $jbmdS.useRef({
        width: -1,
        height: -1,
        offsetWidth: -1,
        offsetHeight: -1
    });
    // ============================= Ref ==============================
    var canRef = !isRenderProps && /*#__PURE__*/ $jbmdS.isValidElement(mergedChildren) && (0, $aKVEK.supportRef)(mergedChildren);
    var originRef = canRef ? mergedChildren.ref : null;
    var mergedRef = (0, $aKVEK.useComposeRef)(originRef, elementRef);
    var getDom = function getDom() {
        var _elementRef$current;
        return (0, $1RfjE.default)(elementRef.current) || // Support `nativeElement` format
        (elementRef.current && (0, $jncUt.default)(elementRef.current) === "object" ? (0, $1RfjE.default)((_elementRef$current = elementRef.current) === null || _elementRef$current === void 0 ? void 0 : _elementRef$current.nativeElement) : null) || (0, $1RfjE.default)(wrapperRef.current);
    };
    $jbmdS.useImperativeHandle(ref, function() {
        return getDom();
    });
    // =========================== Observe ============================
    var propsRef = $jbmdS.useRef(props);
    propsRef.current = props;
    // Handler
    var onInternalResize = $jbmdS.useCallback(function(target) {
        var _propsRef$current = propsRef.current, onResize = _propsRef$current.onResize, data = _propsRef$current.data;
        var _target$getBoundingCl = target.getBoundingClientRect(), width = _target$getBoundingCl.width, height = _target$getBoundingCl.height;
        var offsetWidth = target.offsetWidth, offsetHeight = target.offsetHeight;
        /**
     * Resize observer trigger when content size changed.
     * In most case we just care about element size,
     * let's use `boundary` instead of `contentRect` here to avoid shaking.
     */ var fixedWidth = Math.floor(width);
        var fixedHeight = Math.floor(height);
        if (sizeRef.current.width !== fixedWidth || sizeRef.current.height !== fixedHeight || sizeRef.current.offsetWidth !== offsetWidth || sizeRef.current.offsetHeight !== offsetHeight) {
            var size = {
                width: fixedWidth,
                height: fixedHeight,
                offsetWidth: offsetWidth,
                offsetHeight: offsetHeight
            };
            sizeRef.current = size;
            // IE is strange, right?
            var mergedOffsetWidth = offsetWidth === Math.round(width) ? width : offsetWidth;
            var mergedOffsetHeight = offsetHeight === Math.round(height) ? height : offsetHeight;
            var sizeInfo = (0, $lv6ip.default)((0, $lv6ip.default)({}, size), {}, {
                offsetWidth: mergedOffsetWidth,
                offsetHeight: mergedOffsetHeight
            });
            // Let collection know what happened
            onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(sizeInfo, target, data);
            if (onResize) // defer the callback but not defer to next frame
            Promise.resolve().then(function() {
                onResize(sizeInfo, target);
            });
        }
    }, []);
    // Dynamic observe
    $jbmdS.useEffect(function() {
        var currentElement = getDom();
        if (currentElement && !disabled) (0, $3Jsk7.observe)(currentElement, onInternalResize);
        return function() {
            return (0, $3Jsk7.unobserve)(currentElement, onInternalResize);
        };
    }, [
        elementRef.current,
        disabled
    ]);
    // ============================ Render ============================
    return /*#__PURE__*/ $jbmdS.createElement((0, $fP6W5.default), {
        ref: wrapperRef
    }, canRef ? /*#__PURE__*/ $jbmdS.cloneElement(mergedChildren, {
        ref: mergedRef
    }) : mergedChildren);
}
var $16768510292504b1$var$RefSingleObserver = /*#__PURE__*/ $jbmdS.forwardRef($16768510292504b1$var$SingleObserver);
var $16768510292504b1$export$2e2bcd8739ae039 = $16768510292504b1$var$RefSingleObserver;

});
parcelRegister("41tUJ", function(module, exports) {

$parcel$export(module.exports, "CollectionContext", function () { return $2ede75b62b9b0fa1$export$db36075d98ba73d3; });
$parcel$export(module.exports, "Collection", function () { return $2ede75b62b9b0fa1$export$fb8073518f34e6ec; });

var $jbmdS = parcelRequire("jbmdS");
var $2ede75b62b9b0fa1$export$db36075d98ba73d3 = /*#__PURE__*/ $jbmdS.createContext(null);
function $2ede75b62b9b0fa1$export$fb8073518f34e6ec(_ref) {
    var children = _ref.children, onBatchResize = _ref.onBatchResize;
    var resizeIdRef = $jbmdS.useRef(0);
    var resizeInfosRef = $jbmdS.useRef([]);
    var onCollectionResize = $jbmdS.useContext($2ede75b62b9b0fa1$export$db36075d98ba73d3);
    var onResize = $jbmdS.useCallback(function(size, element, data) {
        resizeIdRef.current += 1;
        var currentId = resizeIdRef.current;
        resizeInfosRef.current.push({
            size: size,
            element: element,
            data: data
        });
        Promise.resolve().then(function() {
            if (currentId === resizeIdRef.current) {
                onBatchResize === null || onBatchResize === void 0 || onBatchResize(resizeInfosRef.current);
                resizeInfosRef.current = [];
            }
        });
        // Continue bubbling if parent exist
        onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(size, element, data);
    }, [
        onBatchResize,
        onCollectionResize
    ]);
    return /*#__PURE__*/ $jbmdS.createElement($2ede75b62b9b0fa1$export$db36075d98ba73d3.Provider, {
        value: onResize
    }, children);
}

});

parcelRegister("3Jsk7", function(module, exports) {

$parcel$export(module.exports, "observe", function () { return $2b7b8b7fa3262565$export$d1203567a167490e; });
$parcel$export(module.exports, "unobserve", function () { return $2b7b8b7fa3262565$export$23a2283368c55ea2; });

var $22BIt = parcelRequire("22BIt");
// =============================== Const ===============================
var $2b7b8b7fa3262565$var$elementListeners = new Map();
function $2b7b8b7fa3262565$var$onResize(entities) {
    entities.forEach(function(entity) {
        var _elementListeners$get;
        var target = entity.target;
        (_elementListeners$get = $2b7b8b7fa3262565$var$elementListeners.get(target)) === null || _elementListeners$get === void 0 || _elementListeners$get.forEach(function(listener) {
            return listener(target);
        });
    });
}
// Note: ResizeObserver polyfill not support option to measure border-box resize
var $2b7b8b7fa3262565$var$resizeObserver = new (0, $22BIt.default)($2b7b8b7fa3262565$var$onResize);
var $2b7b8b7fa3262565$export$3fbe5a08fd9e4702 = null; // eslint-disable-line
var $2b7b8b7fa3262565$export$524f0fd3b47831a = null; // eslint-disable-line
function $2b7b8b7fa3262565$export$d1203567a167490e(element, callback) {
    if (!$2b7b8b7fa3262565$var$elementListeners.has(element)) {
        $2b7b8b7fa3262565$var$elementListeners.set(element, new Set());
        $2b7b8b7fa3262565$var$resizeObserver.observe(element);
    }
    $2b7b8b7fa3262565$var$elementListeners.get(element).add(callback);
}
function $2b7b8b7fa3262565$export$23a2283368c55ea2(element, callback) {
    if ($2b7b8b7fa3262565$var$elementListeners.has(element)) {
        $2b7b8b7fa3262565$var$elementListeners.get(element).delete(callback);
        if (!$2b7b8b7fa3262565$var$elementListeners.get(element).size) {
            $2b7b8b7fa3262565$var$resizeObserver.unobserve(element);
            $2b7b8b7fa3262565$var$elementListeners.delete(element);
        }
    }
}

});
parcelRegister("22BIt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17c906541cc87d77$export$2e2bcd8739ae039; });
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */ /* eslint-disable require-jsdoc, valid-jsdoc */ var $17c906541cc87d77$var$MapShim = function() {
    if (typeof Map !== "undefined") return Map;
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */ function getIndex(arr, key) {
        var result = -1;
        arr.some(function(entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ function() {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */ get: function() {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */ class_1.prototype.get = function(key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */ class_1.prototype.set = function(key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) this.__entries__[index][1] = value;
            else this.__entries__.push([
                key,
                value
            ]);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.delete = function(key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) entries.splice(index, 1);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.has = function(key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */ class_1.prototype.clear = function() {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */ class_1.prototype.forEach = function(callback, ctx) {
            if (ctx === void 0) ctx = null;
            for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }();
}();
/**
 * Detects whether window and document objects are available in current environment.
 */ var $17c906541cc87d77$var$isBrowser = typeof window !== "undefined" && typeof document !== "undefined" && window.document === document;
// Returns global object of a current environment.
var $17c906541cc87d77$var$global$1 = function() {
    if (typeof $parcel$global !== "undefined" && $parcel$global.Math === Math) return $parcel$global;
    if (typeof self !== "undefined" && self.Math === Math) return self;
    if (typeof window !== "undefined" && window.Math === Math) return window;
    // eslint-disable-next-line no-new-func
    return Function("return this")();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */ var $17c906541cc87d77$var$requestAnimationFrame$1 = function() {
    if (typeof requestAnimationFrame === "function") // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind($17c906541cc87d77$var$global$1);
    return function(callback) {
        return setTimeout(function() {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();
// Defines minimum timeout before adding a trailing call.
var $17c906541cc87d77$var$trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */ function $17c906541cc87d77$var$throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */ function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) proxy();
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */ function timeoutCallback() {
        $17c906541cc87d77$var$requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */ function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < $17c906541cc87d77$var$trailingTimeout) return;
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
// Minimum delay before invoking the update of observers.
var $17c906541cc87d77$var$REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var $17c906541cc87d77$var$transitionKeys = [
    "top",
    "right",
    "bottom",
    "left",
    "width",
    "height",
    "size",
    "weight"
];
// Check if MutationObserver is available.
var $17c906541cc87d77$var$mutationObserverSupported = typeof MutationObserver !== "undefined";
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */ var $17c906541cc87d77$var$ResizeObserverController = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */ function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */ this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */ this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */ this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */ this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = $17c906541cc87d77$var$throttle(this.refresh.bind(this), $17c906541cc87d77$var$REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */ ResizeObserverController.prototype.addObserver = function(observer) {
        if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
        // Add listeners if they haven't been added yet.
        if (!this.connected_) this.connect_();
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */ ResizeObserverController.prototype.removeObserver = function(observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) observers.splice(index, 1);
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) this.disconnect_();
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */ ResizeObserverController.prototype.refresh = function() {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) this.refresh();
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */ ResizeObserverController.prototype.updateObservers_ = function() {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function(observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function(observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.connect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!$17c906541cc87d77$var$isBrowser || this.connected_) return;
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener("transitionend", this.onTransitionEnd_);
        window.addEventListener("resize", this.refresh);
        if ($17c906541cc87d77$var$mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener("DOMSubtreeModified", this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.disconnect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!$17c906541cc87d77$var$isBrowser || !this.connected_) return;
        document.removeEventListener("transitionend", this.onTransitionEnd_);
        window.removeEventListener("resize", this.refresh);
        if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
        if (this.mutationEventsAdded_) document.removeEventListener("DOMSubtreeModified", this.refresh);
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */ ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? "" : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = $17c906541cc87d77$var$transitionKeys.some(function(key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) this.refresh();
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */ ResizeObserverController.getInstance = function() {
        if (!this.instance_) this.instance_ = new ResizeObserverController();
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */ ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */ var $17c906541cc87d77$var$defineConfigurable = function(target, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */ var $17c906541cc87d77$var$getWindowOf = function(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || $17c906541cc87d77$var$global$1;
};
// Placeholder of an empty content rectangle.
var $17c906541cc87d77$var$emptyRect = $17c906541cc87d77$var$createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */ function $17c906541cc87d77$var$toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */ function $17c906541cc87d77$var$getBordersSize(styles) {
    var positions = [];
    for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
    return positions.reduce(function(size, position) {
        var value = styles["border-" + position + "-width"];
        return size + $17c906541cc87d77$var$toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */ function $17c906541cc87d77$var$getPaddings(styles) {
    var positions = [
        "top",
        "right",
        "bottom",
        "left"
    ];
    var paddings = {};
    for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
        var position = positions_1[_i];
        var value = styles["padding-" + position];
        paddings[position] = $17c906541cc87d77$var$toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */ function $17c906541cc87d77$var$getSVGContentRect(target) {
    var bbox = target.getBBox();
    return $17c906541cc87d77$var$createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */ function $17c906541cc87d77$var$getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) return $17c906541cc87d77$var$emptyRect;
    var styles = $17c906541cc87d77$var$getWindowOf(target).getComputedStyle(target);
    var paddings = $17c906541cc87d77$var$getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = $17c906541cc87d77$var$toFloat(styles.width), height = $17c906541cc87d77$var$toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === "border-box") {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) width -= $17c906541cc87d77$var$getBordersSize(styles, "left", "right") + horizPad;
        if (Math.round(height + vertPad) !== clientHeight) height -= $17c906541cc87d77$var$getBordersSize(styles, "top", "bottom") + vertPad;
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!$17c906541cc87d77$var$isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
        if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
    }
    return $17c906541cc87d77$var$createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ var $17c906541cc87d77$var$isSVGGraphicsElement = function() {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== "undefined") return function(target) {
        return target instanceof $17c906541cc87d77$var$getWindowOf(target).SVGGraphicsElement;
    };
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function(target) {
        return target instanceof $17c906541cc87d77$var$getWindowOf(target).SVGElement && typeof target.getBBox === "function";
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ function $17c906541cc87d77$var$isDocumentElement(target) {
    return target === $17c906541cc87d77$var$getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */ function $17c906541cc87d77$var$getContentRect(target) {
    if (!$17c906541cc87d77$var$isBrowser) return $17c906541cc87d77$var$emptyRect;
    if ($17c906541cc87d77$var$isSVGGraphicsElement(target)) return $17c906541cc87d77$var$getSVGContentRect(target);
    return $17c906541cc87d77$var$getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */ function $17c906541cc87d77$var$createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== "undefined" ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    $17c906541cc87d77$var$defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */ function $17c906541cc87d77$var$createRectInit(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */ var $17c906541cc87d77$var$ResizeObservation = /** @class */ function() {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */ function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */ this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */ this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */ this.contentRect_ = $17c906541cc87d77$var$createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */ ResizeObservation.prototype.isActive = function() {
        var rect = $17c906541cc87d77$var$getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */ ResizeObservation.prototype.broadcastRect = function() {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();
var $17c906541cc87d77$var$ResizeObserverEntry = /** @class */ function() {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */ function ResizeObserverEntry(target, rectInit) {
        var contentRect = $17c906541cc87d77$var$createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        $17c906541cc87d77$var$defineConfigurable(this, {
            target: target,
            contentRect: contentRect
        });
    }
    return ResizeObserverEntry;
}();
var $17c906541cc87d77$var$ResizeObserverSPI = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */ function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */ this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */ this.observations_ = new $17c906541cc87d77$var$MapShim();
        if (typeof callback !== "function") throw new TypeError("The callback provided as parameter 1 is not a function.");
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */ ResizeObserverSPI.prototype.observe = function(target) {
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === "undefined" || !(Element instanceof Object)) return;
        if (!(target instanceof $17c906541cc87d77$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) return;
        observations.set(target, new $17c906541cc87d77$var$ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */ ResizeObserverSPI.prototype.unobserve = function(target) {
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === "undefined" || !(Element instanceof Object)) return;
        if (!(target instanceof $17c906541cc87d77$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) return;
        observations.delete(target);
        if (!observations.size) this.controller_.removeObserver(this);
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.disconnect = function() {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.gatherActive = function() {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function(observation) {
            if (observation.isActive()) _this.activeObservations_.push(observation);
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.broadcastActive = function() {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) return;
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function(observation) {
            return new $17c906541cc87d77$var$ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */ ResizeObserverSPI.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();
// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var $17c906541cc87d77$var$observers = typeof WeakMap !== "undefined" ? new WeakMap() : new $17c906541cc87d77$var$MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */ var $17c906541cc87d77$var$ResizeObserver = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */ function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) throw new TypeError("Cannot call a class as a function.");
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        var controller = $17c906541cc87d77$var$ResizeObserverController.getInstance();
        var observer = new $17c906541cc87d77$var$ResizeObserverSPI(callback, controller, this);
        $17c906541cc87d77$var$observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
[
    "observe",
    "unobserve",
    "disconnect"
].forEach(function(method) {
    $17c906541cc87d77$var$ResizeObserver.prototype[method] = function() {
        var _a;
        return (_a = $17c906541cc87d77$var$observers.get(this))[method].apply(_a, arguments);
    };
});
var $17c906541cc87d77$var$index = function() {
    // Export existing implementation if available.
    if (typeof $17c906541cc87d77$var$global$1.ResizeObserver !== "undefined") return $17c906541cc87d77$var$global$1.ResizeObserver;
    return $17c906541cc87d77$var$ResizeObserver;
}();
var $17c906541cc87d77$export$2e2bcd8739ae039 = $17c906541cc87d77$var$index;

});


parcelRegister("fP6W5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b850ffc64f8a66db$export$2e2bcd8739ae039; });

var $3GVdq = parcelRequire("3GVdq");

var $jj5jQ = parcelRequire("jj5jQ");

var $1N4zm = parcelRequire("1N4zm");

var $gRFRo = parcelRequire("gRFRo");

var $jbmdS = parcelRequire("jbmdS");
/**
 * Fallback to findDOMNode if origin ref do not provide any dom element
 */ var $b850ffc64f8a66db$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, $1N4zm.default)(DomWrapper, _React$Component);
    var _super = (0, $gRFRo.default)(DomWrapper);
    function DomWrapper() {
        (0, $3GVdq.default)(this, DomWrapper);
        return _super.apply(this, arguments);
    }
    (0, $jj5jQ.default)(DomWrapper, [
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return DomWrapper;
}($jbmdS.Component);

});



parcelRegister("595TI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3bf25e2f51b09109$export$2e2bcd8739ae039; });
// Thanks to https://github.com/andreypopp/react-textarea-autosize/
/**
 * calculateNodeHeight(uiTextNode, useCache = false)
 */ var $3bf25e2f51b09109$var$HIDDEN_TEXTAREA_STYLE = "\n  min-height:0 !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important;\n  pointer-events: none !important;\n";
var $3bf25e2f51b09109$var$SIZING_STYLE = [
    "letter-spacing",
    "line-height",
    "padding-top",
    "padding-bottom",
    "font-family",
    "font-weight",
    "font-size",
    "font-variant",
    "text-rendering",
    "text-transform",
    "width",
    "text-indent",
    "padding-left",
    "padding-right",
    "border-width",
    "box-sizing",
    "word-break"
];
var $3bf25e2f51b09109$var$computedStyleCache = {};
var $3bf25e2f51b09109$var$hiddenTextarea;
function $3bf25e2f51b09109$export$1a56dc6a39385a18(node) {
    var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var nodeRef = node.getAttribute("id") || node.getAttribute("data-reactid") || node.getAttribute("name");
    if (useCache && $3bf25e2f51b09109$var$computedStyleCache[nodeRef]) return $3bf25e2f51b09109$var$computedStyleCache[nodeRef];
    var style = window.getComputedStyle(node);
    var boxSizing = style.getPropertyValue("box-sizing") || style.getPropertyValue("-moz-box-sizing") || style.getPropertyValue("-webkit-box-sizing");
    var paddingSize = parseFloat(style.getPropertyValue("padding-bottom")) + parseFloat(style.getPropertyValue("padding-top"));
    var borderSize = parseFloat(style.getPropertyValue("border-bottom-width")) + parseFloat(style.getPropertyValue("border-top-width"));
    var sizingStyle = $3bf25e2f51b09109$var$SIZING_STYLE.map(function(name) {
        return "".concat(name, ":").concat(style.getPropertyValue(name));
    }).join(";");
    var nodeInfo = {
        sizingStyle: sizingStyle,
        paddingSize: paddingSize,
        borderSize: borderSize,
        boxSizing: boxSizing
    };
    if (useCache && nodeRef) $3bf25e2f51b09109$var$computedStyleCache[nodeRef] = nodeInfo;
    return nodeInfo;
}
function $3bf25e2f51b09109$export$2e2bcd8739ae039(uiTextNode) {
    var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var minRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var maxRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    if (!$3bf25e2f51b09109$var$hiddenTextarea) {
        $3bf25e2f51b09109$var$hiddenTextarea = document.createElement("textarea");
        $3bf25e2f51b09109$var$hiddenTextarea.setAttribute("tab-index", "-1");
        $3bf25e2f51b09109$var$hiddenTextarea.setAttribute("aria-hidden", "true");
        document.body.appendChild($3bf25e2f51b09109$var$hiddenTextarea);
    }
    // Fix wrap="off" issue
    // https://github.com/ant-design/ant-design/issues/6577
    if (uiTextNode.getAttribute("wrap")) $3bf25e2f51b09109$var$hiddenTextarea.setAttribute("wrap", uiTextNode.getAttribute("wrap"));
    else $3bf25e2f51b09109$var$hiddenTextarea.removeAttribute("wrap");
    // Copy all CSS properties that have an impact on the height of the content in
    // the textbox
    var _calculateNodeStyling = $3bf25e2f51b09109$export$1a56dc6a39385a18(uiTextNode, useCache), paddingSize = _calculateNodeStyling.paddingSize, borderSize = _calculateNodeStyling.borderSize, boxSizing = _calculateNodeStyling.boxSizing, sizingStyle = _calculateNodeStyling.sizingStyle;
    // Need to have the overflow attribute to hide the scrollbar otherwise
    // text-lines will not calculated properly as the shadow will technically be
    // narrower for content
    $3bf25e2f51b09109$var$hiddenTextarea.setAttribute("style", "".concat(sizingStyle, ";").concat($3bf25e2f51b09109$var$HIDDEN_TEXTAREA_STYLE));
    $3bf25e2f51b09109$var$hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || "";
    var minHeight = undefined;
    var maxHeight = undefined;
    var overflowY;
    var height = $3bf25e2f51b09109$var$hiddenTextarea.scrollHeight;
    if (boxSizing === "border-box") // border-box: add border, since height = content + padding + border
    height += borderSize;
    else if (boxSizing === "content-box") // remove padding, since height = content
    height -= paddingSize;
    if (minRows !== null || maxRows !== null) {
        // measure height of a textarea with a single row
        $3bf25e2f51b09109$var$hiddenTextarea.value = " ";
        var singleRowHeight = $3bf25e2f51b09109$var$hiddenTextarea.scrollHeight - paddingSize;
        if (minRows !== null) {
            minHeight = singleRowHeight * minRows;
            if (boxSizing === "border-box") minHeight = minHeight + paddingSize + borderSize;
            height = Math.max(minHeight, height);
        }
        if (maxRows !== null) {
            maxHeight = singleRowHeight * maxRows;
            if (boxSizing === "border-box") maxHeight = maxHeight + paddingSize + borderSize;
            overflowY = height > maxHeight ? "" : "hidden";
            height = Math.min(maxHeight, height);
        }
    }
    var style = {
        height: height,
        overflowY: overflowY,
        resize: "none"
    };
    if (minHeight) style.minHeight = minHeight;
    if (maxHeight) style.maxHeight = maxHeight;
    return style;
}

});



parcelRegister("782ya", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $530b42278172bb61$export$2e2bcd8739ae039; });

var $8K2NM = parcelRequire("8K2NM");

var $3GVdq = parcelRequire("3GVdq");

var $jj5jQ = parcelRequire("jj5jQ");

var $ibb6t = parcelRequire("ibb6t");

var $lJpH8 = parcelRequire("lJpH8");

var $dO7bG = parcelRequire("dO7bG");

var $1N4zm = parcelRequire("1N4zm");

var $kPBAG = parcelRequire("kPBAG");

var $02LyB = parcelRequire("02LyB");

var $jbmdS = parcelRequire("jbmdS");

var $3ACNS = parcelRequire("3ACNS");

var $l34u6 = parcelRequire("l34u6");

var $j4i2o = parcelRequire("j4i2o");

var $3IdWL = parcelRequire("3IdWL");
function $530b42278172bb61$var$_callSuper(t, o, e) {
    return o = (0, $dO7bG.default)(o), (0, $ibb6t.default)(t, (0, $lJpH8.default)() ? Reflect.construct(o, e || [], (0, $dO7bG.default)(t).constructor) : o.apply(t, e));
}
var $530b42278172bb61$var$ClearableInputType = (0, $3IdWL.tuple)("text", "input");
function $530b42278172bb61$var$hasAddon(props) {
    return !!(props.addonBefore || props.addonAfter);
}
var $530b42278172bb61$var$ClearableLabeledInput = /*#__PURE__*/ function(_React$Component) {
    (0, $1N4zm.default)(ClearableLabeledInput, _React$Component);
    function ClearableLabeledInput() {
        (0, $3GVdq.default)(this, ClearableLabeledInput);
        return $530b42278172bb61$var$_callSuper(this, ClearableLabeledInput, arguments);
    }
    (0, $jj5jQ.default)(ClearableLabeledInput, [
        {
            key: "renderClearIcon",
            value: function renderClearIcon(prefixCls) {
                var _this$props = this.props, value = _this$props.value, disabled = _this$props.disabled, readOnly = _this$props.readOnly, handleReset = _this$props.handleReset, suffix = _this$props.suffix;
                var needClear = !disabled && !readOnly && value;
                var className = "".concat(prefixCls, "-clear-icon");
                return /*#__PURE__*/ $jbmdS.createElement((0, $kPBAG.default), {
                    onClick: handleReset,
                    // Do not trigger onBlur when clear input
                    // https://github.com/ant-design/ant-design/issues/31200
                    onMouseDown: function onMouseDown(e) {
                        return e.preventDefault();
                    },
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))((0, $8K2NM.default)((0, $8K2NM.default)({}, "".concat(className, "-hidden"), !needClear), "".concat(className, "-has-suffix"), !!suffix), className),
                    role: "button"
                });
            }
        },
        {
            key: "renderTextAreaWithClearIcon",
            value: function renderTextAreaWithClearIcon(prefixCls, element, statusContext) {
                var _this$props2 = this.props, value = _this$props2.value, allowClear = _this$props2.allowClear, className = _this$props2.className, focused = _this$props2.focused, style = _this$props2.style, direction = _this$props2.direction, bordered = _this$props2.bordered, hidden = _this$props2.hidden, customStatus = _this$props2.status;
                var contextStatus = statusContext.status, hasFeedback = statusContext.hasFeedback;
                if (!allowClear) return (0, $l34u6.cloneElement)(element, {
                    value: value
                });
                var affixWrapperCls = (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("".concat(prefixCls, "-affix-wrapper"), "".concat(prefixCls, "-affix-wrapper-textarea-with-clear-btn"), (0, $j4i2o.getStatusClassNames)("".concat(prefixCls, "-affix-wrapper"), (0, $j4i2o.getMergedStatus)(contextStatus, customStatus), hasFeedback), (0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)({}, "".concat(prefixCls, "-affix-wrapper-focused"), focused), "".concat(prefixCls, "-affix-wrapper-rtl"), direction === "rtl"), "".concat(prefixCls, "-affix-wrapper-borderless"), !bordered), "".concat(className), !$530b42278172bb61$var$hasAddon(this.props) && className));
                return /*#__PURE__*/ $jbmdS.createElement("span", {
                    className: affixWrapperCls,
                    style: style,
                    hidden: hidden
                }, (0, $l34u6.cloneElement)(element, {
                    style: null,
                    value: value
                }), this.renderClearIcon(prefixCls));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                return /*#__PURE__*/ $jbmdS.createElement((0, $3ACNS.FormItemInputContext).Consumer, null, function(statusContext) {
                    var _this$props3 = _this.props, prefixCls = _this$props3.prefixCls, inputType = _this$props3.inputType, element = _this$props3.element;
                    if (inputType === $530b42278172bb61$var$ClearableInputType[0]) return _this.renderTextAreaWithClearIcon(prefixCls, element, statusContext);
                });
            }
        }
    ]);
    return ClearableLabeledInput;
}($jbmdS.Component);
var $530b42278172bb61$export$2e2bcd8739ae039 = $530b42278172bb61$var$ClearableLabeledInput;

});



parcelRegister("hRCNE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0157bc0f75134b3$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $8K2NM = parcelRequire("8K2NM");

var $97QHC = parcelRequire("97QHC");

var $02LyB = parcelRequire("02LyB");

var $gnhtg = parcelRequire("gnhtg");

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("8uDri");
var $ewikT = parcelRequire("ewikT");

var $kgIuF = parcelRequire("kgIuF");

var $7VQDG = parcelRequire("7VQDG");


var $ccZcg = parcelRequire("ccZcg");
var $d0157bc0f75134b3$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d0157bc0f75134b3$var$Switch = /*#__PURE__*/ $jbmdS.forwardRef(function(_a, ref) {
    var customizePrefixCls = _a.prefixCls, customizeSize = _a.size, customDisabled = _a.disabled, loading = _a.loading, _a$className = _a.className, className = _a$className === void 0 ? "" : _a$className, props = $d0157bc0f75134b3$var$__rest(_a, [
        "prefixCls",
        "size",
        "disabled",
        "loading",
        "className"
    ]);
    var _React$useContext = $jbmdS.useContext((0, $ewikT.ConfigContext)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var size = $jbmdS.useContext((0, $7VQDG.default));
    // ===================== Disabled =====================
    var disabled = $jbmdS.useContext((0, $kgIuF.default));
    var mergedDisabled = (customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled) || loading;
    var prefixCls = getPrefixCls("switch", customizePrefixCls);
    var loadingIcon = /*#__PURE__*/ $jbmdS.createElement("div", {
        className: "".concat(prefixCls, "-handle")
    }, loading && /*#__PURE__*/ $jbmdS.createElement((0, $97QHC.default), {
        className: "".concat(prefixCls, "-loading-icon")
    }));
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)({}, "".concat(prefixCls, "-small"), (customizeSize || size) === "small"), "".concat(prefixCls, "-loading"), loading), "".concat(prefixCls, "-rtl"), direction === "rtl"), className);
    return /*#__PURE__*/ $jbmdS.createElement((0, $ccZcg.default), {
        insertExtraNode: true
    }, /*#__PURE__*/ $jbmdS.createElement((0, $gnhtg.default), (0, $7i29i.default)({}, props, {
        prefixCls: prefixCls,
        className: classes,
        disabled: mergedDisabled,
        ref: ref,
        loadingIcon: loadingIcon
    })));
});
$d0157bc0f75134b3$var$Switch.__ANT_SWITCH = true;
var $d0157bc0f75134b3$export$2e2bcd8739ae039 = $d0157bc0f75134b3$var$Switch;

});
parcelRegister("gnhtg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bebc58b563b7b02d$export$2e2bcd8739ae039; });

var $8K2NM = parcelRequire("8K2NM");

var $CZyex = parcelRequire("CZyex");

var $ccQt4 = parcelRequire("ccQt4");

var $jbmdS = parcelRequire("jbmdS");

var $02LyB = parcelRequire("02LyB");

var $9nYhz = parcelRequire("9nYhz");

var $5yi5E = parcelRequire("5yi5E");
var $bebc58b563b7b02d$var$Switch = $jbmdS.forwardRef(function(_ref, ref) {
    var _classNames;
    var _ref$prefixCls = _ref.prefixCls, prefixCls = _ref$prefixCls === void 0 ? "rc-switch" : _ref$prefixCls, className = _ref.className, checked = _ref.checked, defaultChecked = _ref.defaultChecked, disabled = _ref.disabled, loadingIcon = _ref.loadingIcon, checkedChildren = _ref.checkedChildren, unCheckedChildren = _ref.unCheckedChildren, onClick = _ref.onClick, onChange = _ref.onChange, onKeyDown = _ref.onKeyDown, restProps = (0, $ccQt4.default)(_ref, [
        "prefixCls",
        "className",
        "checked",
        "defaultChecked",
        "disabled",
        "loadingIcon",
        "checkedChildren",
        "unCheckedChildren",
        "onClick",
        "onChange",
        "onKeyDown"
    ]);
    var _useMergedState = (0, $9nYhz.default)(false, {
        value: checked,
        defaultValue: defaultChecked
    }), _useMergedState2 = (0, $CZyex.default)(_useMergedState, 2), innerChecked = _useMergedState2[0], setInnerChecked = _useMergedState2[1];
    function triggerChange(newChecked, event) {
        var mergedChecked = innerChecked;
        if (!disabled) {
            mergedChecked = newChecked;
            setInnerChecked(mergedChecked);
            onChange === null || onChange === void 0 || onChange(mergedChecked, event);
        }
        return mergedChecked;
    }
    function onInternalKeyDown(e) {
        if (e.which === (0, $5yi5E.default).LEFT) triggerChange(false, e);
        else if (e.which === (0, $5yi5E.default).RIGHT) triggerChange(true, e);
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
    }
    function onInternalClick(e) {
        var ret = triggerChange(!innerChecked, e); // [Legacy] trigger onClick with value
        onClick === null || onClick === void 0 || onClick(ret, e);
    }
    var switchClassName = (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(prefixCls, className, (_classNames = {}, (0, $8K2NM.default)(_classNames, "".concat(prefixCls, "-checked"), innerChecked), (0, $8K2NM.default)(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames));
    return $jbmdS.createElement("button", Object.assign({}, restProps, {
        type: "button",
        role: "switch",
        "aria-checked": innerChecked,
        disabled: disabled,
        className: switchClassName,
        ref: ref,
        onKeyDown: onInternalKeyDown,
        onClick: onInternalClick
    }), loadingIcon, $jbmdS.createElement("span", {
        className: "".concat(prefixCls, "-inner")
    }, innerChecked ? checkedChildren : unCheckedChildren));
});
$bebc58b563b7b02d$var$Switch.displayName = "Switch";
var $bebc58b563b7b02d$export$2e2bcd8739ae039 = $bebc58b563b7b02d$var$Switch;

});
parcelRegister("5yi5E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40ae291403be0711$export$2e2bcd8739ae039; });
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */ var $40ae291403be0711$var$KeyCode = {
    /**
   * MAC_ENTER
   */ MAC_ENTER: 3,
    /**
   * BACKSPACE
   */ BACKSPACE: 8,
    /**
   * TAB
   */ TAB: 9,
    /**
   * NUMLOCK on FF/Safari Mac
   */ NUM_CENTER: 12,
    // NUMLOCK on FF/Safari Mac
    /**
   * ENTER
   */ ENTER: 13,
    /**
   * SHIFT
   */ SHIFT: 16,
    /**
   * CTRL
   */ CTRL: 17,
    /**
   * ALT
   */ ALT: 18,
    /**
   * PAUSE
   */ PAUSE: 19,
    /**
   * CAPS_LOCK
   */ CAPS_LOCK: 20,
    /**
   * ESC
   */ ESC: 27,
    /**
   * SPACE
   */ SPACE: 32,
    /**
   * PAGE_UP
   */ PAGE_UP: 33,
    // also NUM_NORTH_EAST
    /**
   * PAGE_DOWN
   */ PAGE_DOWN: 34,
    // also NUM_SOUTH_EAST
    /**
   * END
   */ END: 35,
    // also NUM_SOUTH_WEST
    /**
   * HOME
   */ HOME: 36,
    // also NUM_NORTH_WEST
    /**
   * LEFT
   */ LEFT: 37,
    // also NUM_WEST
    /**
   * UP
   */ UP: 38,
    // also NUM_NORTH
    /**
   * RIGHT
   */ RIGHT: 39,
    // also NUM_EAST
    /**
   * DOWN
   */ DOWN: 40,
    // also NUM_SOUTH
    /**
   * PRINT_SCREEN
   */ PRINT_SCREEN: 44,
    /**
   * INSERT
   */ INSERT: 45,
    // also NUM_INSERT
    /**
   * DELETE
   */ DELETE: 46,
    // also NUM_DELETE
    /**
   * ZERO
   */ ZERO: 48,
    /**
   * ONE
   */ ONE: 49,
    /**
   * TWO
   */ TWO: 50,
    /**
   * THREE
   */ THREE: 51,
    /**
   * FOUR
   */ FOUR: 52,
    /**
   * FIVE
   */ FIVE: 53,
    /**
   * SIX
   */ SIX: 54,
    /**
   * SEVEN
   */ SEVEN: 55,
    /**
   * EIGHT
   */ EIGHT: 56,
    /**
   * NINE
   */ NINE: 57,
    /**
   * QUESTION_MARK
   */ QUESTION_MARK: 63,
    // needs localization
    /**
   * A
   */ A: 65,
    /**
   * B
   */ B: 66,
    /**
   * C
   */ C: 67,
    /**
   * D
   */ D: 68,
    /**
   * E
   */ E: 69,
    /**
   * F
   */ F: 70,
    /**
   * G
   */ G: 71,
    /**
   * H
   */ H: 72,
    /**
   * I
   */ I: 73,
    /**
   * J
   */ J: 74,
    /**
   * K
   */ K: 75,
    /**
   * L
   */ L: 76,
    /**
   * M
   */ M: 77,
    /**
   * N
   */ N: 78,
    /**
   * O
   */ O: 79,
    /**
   * P
   */ P: 80,
    /**
   * Q
   */ Q: 81,
    /**
   * R
   */ R: 82,
    /**
   * S
   */ S: 83,
    /**
   * T
   */ T: 84,
    /**
   * U
   */ U: 85,
    /**
   * V
   */ V: 86,
    /**
   * W
   */ W: 87,
    /**
   * X
   */ X: 88,
    /**
   * Y
   */ Y: 89,
    /**
   * Z
   */ Z: 90,
    /**
   * META
   */ META: 91,
    // WIN_KEY_LEFT
    /**
   * WIN_KEY_RIGHT
   */ WIN_KEY_RIGHT: 92,
    /**
   * CONTEXT_MENU
   */ CONTEXT_MENU: 93,
    /**
   * NUM_ZERO
   */ NUM_ZERO: 96,
    /**
   * NUM_ONE
   */ NUM_ONE: 97,
    /**
   * NUM_TWO
   */ NUM_TWO: 98,
    /**
   * NUM_THREE
   */ NUM_THREE: 99,
    /**
   * NUM_FOUR
   */ NUM_FOUR: 100,
    /**
   * NUM_FIVE
   */ NUM_FIVE: 101,
    /**
   * NUM_SIX
   */ NUM_SIX: 102,
    /**
   * NUM_SEVEN
   */ NUM_SEVEN: 103,
    /**
   * NUM_EIGHT
   */ NUM_EIGHT: 104,
    /**
   * NUM_NINE
   */ NUM_NINE: 105,
    /**
   * NUM_MULTIPLY
   */ NUM_MULTIPLY: 106,
    /**
   * NUM_PLUS
   */ NUM_PLUS: 107,
    /**
   * NUM_MINUS
   */ NUM_MINUS: 109,
    /**
   * NUM_PERIOD
   */ NUM_PERIOD: 110,
    /**
   * NUM_DIVISION
   */ NUM_DIVISION: 111,
    /**
   * F1
   */ F1: 112,
    /**
   * F2
   */ F2: 113,
    /**
   * F3
   */ F3: 114,
    /**
   * F4
   */ F4: 115,
    /**
   * F5
   */ F5: 116,
    /**
   * F6
   */ F6: 117,
    /**
   * F7
   */ F7: 118,
    /**
   * F8
   */ F8: 119,
    /**
   * F9
   */ F9: 120,
    /**
   * F10
   */ F10: 121,
    /**
   * F11
   */ F11: 122,
    /**
   * F12
   */ F12: 123,
    /**
   * NUMLOCK
   */ NUMLOCK: 144,
    /**
   * SEMICOLON
   */ SEMICOLON: 186,
    // needs localization
    /**
   * DASH
   */ DASH: 189,
    // needs localization
    /**
   * EQUALS
   */ EQUALS: 187,
    // needs localization
    /**
   * COMMA
   */ COMMA: 188,
    // needs localization
    /**
   * PERIOD
   */ PERIOD: 190,
    // needs localization
    /**
   * SLASH
   */ SLASH: 191,
    // needs localization
    /**
   * APOSTROPHE
   */ APOSTROPHE: 192,
    // needs localization
    /**
   * SINGLE_QUOTE
   */ SINGLE_QUOTE: 222,
    // needs localization
    /**
   * OPEN_SQUARE_BRACKET
   */ OPEN_SQUARE_BRACKET: 219,
    // needs localization
    /**
   * BACKSLASH
   */ BACKSLASH: 220,
    // needs localization
    /**
   * CLOSE_SQUARE_BRACKET
   */ CLOSE_SQUARE_BRACKET: 221,
    // needs localization
    /**
   * WIN_KEY
   */ WIN_KEY: 224,
    /**
   * MAC_FF_META
   */ MAC_FF_META: 224,
    // Firefox (Gecko) fires this for the meta key instead of 91
    /**
   * WIN_IME
   */ WIN_IME: 229,
    // ======================== Function ========================
    /**
   * whether text and modified key is entered at the same time.
   */ isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
        var keyCode = e.keyCode;
        if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
        keyCode >= $40ae291403be0711$var$KeyCode.F1 && keyCode <= $40ae291403be0711$var$KeyCode.F12) return false;
        // The following keys are quite harmless, even in combination with
        // CTRL, ALT or SHIFT.
        switch(keyCode){
            case $40ae291403be0711$var$KeyCode.ALT:
            case $40ae291403be0711$var$KeyCode.CAPS_LOCK:
            case $40ae291403be0711$var$KeyCode.CONTEXT_MENU:
            case $40ae291403be0711$var$KeyCode.CTRL:
            case $40ae291403be0711$var$KeyCode.DOWN:
            case $40ae291403be0711$var$KeyCode.END:
            case $40ae291403be0711$var$KeyCode.ESC:
            case $40ae291403be0711$var$KeyCode.HOME:
            case $40ae291403be0711$var$KeyCode.INSERT:
            case $40ae291403be0711$var$KeyCode.LEFT:
            case $40ae291403be0711$var$KeyCode.MAC_FF_META:
            case $40ae291403be0711$var$KeyCode.META:
            case $40ae291403be0711$var$KeyCode.NUMLOCK:
            case $40ae291403be0711$var$KeyCode.NUM_CENTER:
            case $40ae291403be0711$var$KeyCode.PAGE_DOWN:
            case $40ae291403be0711$var$KeyCode.PAGE_UP:
            case $40ae291403be0711$var$KeyCode.PAUSE:
            case $40ae291403be0711$var$KeyCode.PRINT_SCREEN:
            case $40ae291403be0711$var$KeyCode.RIGHT:
            case $40ae291403be0711$var$KeyCode.SHIFT:
            case $40ae291403be0711$var$KeyCode.UP:
            case $40ae291403be0711$var$KeyCode.WIN_KEY:
            case $40ae291403be0711$var$KeyCode.WIN_KEY_RIGHT:
                return false;
            default:
                return true;
        }
    },
    /**
   * whether character is entered.
   */ isCharacterKey: function isCharacterKey(keyCode) {
        if (keyCode >= $40ae291403be0711$var$KeyCode.ZERO && keyCode <= $40ae291403be0711$var$KeyCode.NINE) return true;
        if (keyCode >= $40ae291403be0711$var$KeyCode.NUM_ZERO && keyCode <= $40ae291403be0711$var$KeyCode.NUM_MULTIPLY) return true;
        if (keyCode >= $40ae291403be0711$var$KeyCode.A && keyCode <= $40ae291403be0711$var$KeyCode.Z) return true;
        // Safari sends zero key code for non-latin characters.
        if (window.navigator.userAgent.indexOf("WebKit") !== -1 && keyCode === 0) return true;
        switch(keyCode){
            case $40ae291403be0711$var$KeyCode.SPACE:
            case $40ae291403be0711$var$KeyCode.QUESTION_MARK:
            case $40ae291403be0711$var$KeyCode.NUM_PLUS:
            case $40ae291403be0711$var$KeyCode.NUM_MINUS:
            case $40ae291403be0711$var$KeyCode.NUM_PERIOD:
            case $40ae291403be0711$var$KeyCode.NUM_DIVISION:
            case $40ae291403be0711$var$KeyCode.SEMICOLON:
            case $40ae291403be0711$var$KeyCode.DASH:
            case $40ae291403be0711$var$KeyCode.EQUALS:
            case $40ae291403be0711$var$KeyCode.COMMA:
            case $40ae291403be0711$var$KeyCode.PERIOD:
            case $40ae291403be0711$var$KeyCode.SLASH:
            case $40ae291403be0711$var$KeyCode.APOSTROPHE:
            case $40ae291403be0711$var$KeyCode.SINGLE_QUOTE:
            case $40ae291403be0711$var$KeyCode.OPEN_SQUARE_BRACKET:
            case $40ae291403be0711$var$KeyCode.BACKSLASH:
            case $40ae291403be0711$var$KeyCode.CLOSE_SQUARE_BRACKET:
                return true;
            default:
                return false;
        }
    }
};
var $40ae291403be0711$export$2e2bcd8739ae039 = $40ae291403be0711$var$KeyCode;

});



parcelRegister("3TBH9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d63bf965c3884ca$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $4hBm1 = parcelRequire("4hBm1");

var $7Fn0s = parcelRequire("7Fn0s");

var $72ezo = parcelRequire("72ezo");

var $1BTI2 = parcelRequire("1BTI2");

var $gJT7h = parcelRequire("gJT7h");

var $XoImS = parcelRequire("XoImS");

var $QiMYe = parcelRequire("QiMYe");

var $fM2j4 = parcelRequire("fM2j4");

var $f44xu = parcelRequire("f44xu");

var $8kZ1o = parcelRequire("8kZ1o");

var $6fNfM = parcelRequire("6fNfM");
var $2d63bf965c3884ca$var$_dec, $2d63bf965c3884ca$var$_dec2, $2d63bf965c3884ca$var$_dec3, $2d63bf965c3884ca$var$_dec4, $2d63bf965c3884ca$var$_dec5, $2d63bf965c3884ca$var$_dec6, $2d63bf965c3884ca$var$_dec7, $2d63bf965c3884ca$var$_dec8, $2d63bf965c3884ca$var$_dec9, $2d63bf965c3884ca$var$_dec10, $2d63bf965c3884ca$var$_dec11, $2d63bf965c3884ca$var$_class, $2d63bf965c3884ca$var$_descriptor, $2d63bf965c3884ca$var$_descriptor2, $2d63bf965c3884ca$var$_descriptor3, $2d63bf965c3884ca$var$_descriptor4, $2d63bf965c3884ca$var$_descriptor5, $2d63bf965c3884ca$var$_descriptor6, $2d63bf965c3884ca$var$_descriptor7, $2d63bf965c3884ca$var$_descriptor8, $2d63bf965c3884ca$var$_descriptor9;
function $2d63bf965c3884ca$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $2d63bf965c3884ca$var$_defineProperty(e, r, t) {
    return (r = $2d63bf965c3884ca$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $2d63bf965c3884ca$var$_toPropertyKey(t) {
    var i = $2d63bf965c3884ca$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $2d63bf965c3884ca$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $2d63bf965c3884ca$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $2d63bf965c3884ca$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $2d63bf965c3884ca$var$timerStore = ($2d63bf965c3884ca$var$_dec = (0, $4JcCM.action).bound, $2d63bf965c3884ca$var$_dec2 = (0, $4JcCM.action).bound, $2d63bf965c3884ca$var$_dec3 = (0, $4JcCM.action).bound, $2d63bf965c3884ca$var$_dec4 = (0, $4JcCM.action).bound, $2d63bf965c3884ca$var$_dec5 = (0, $4JcCM.action).bound, $2d63bf965c3884ca$var$_dec6 = (0, $4JcCM.action).bound, $2d63bf965c3884ca$var$_dec7 = (0, $4JcCM.action).bound, $2d63bf965c3884ca$var$_dec8 = (0, $4JcCM.action).bound, $2d63bf965c3884ca$var$_dec9 = (0, $4JcCM.action).bound, $2d63bf965c3884ca$var$_dec10 = (0, $4JcCM.action).bound, $2d63bf965c3884ca$var$_dec11 = (0, $4JcCM.action).bound, $2d63bf965c3884ca$var$_class = class timerStore {
    constructor(){
        $2d63bf965c3884ca$var$_initializerDefineProperty(this, "timerState", $2d63bf965c3884ca$var$_descriptor, this);
        $2d63bf965c3884ca$var$_initializerDefineProperty(this, "saveState", $2d63bf965c3884ca$var$_descriptor2, this);
        $2d63bf965c3884ca$var$_initializerDefineProperty(this, "selectedValues", $2d63bf965c3884ca$var$_descriptor3, this);
        $2d63bf965c3884ca$var$_initializerDefineProperty(this, "budgetType", $2d63bf965c3884ca$var$_descriptor4, this);
        $2d63bf965c3884ca$var$_initializerDefineProperty(this, "prevSeconds", $2d63bf965c3884ca$var$_descriptor5, this);
        $2d63bf965c3884ca$var$_initializerDefineProperty(this, "startTime", $2d63bf965c3884ca$var$_descriptor6, this);
        $2d63bf965c3884ca$var$_initializerDefineProperty(this, "currentTime", $2d63bf965c3884ca$var$_descriptor7, this);
        $2d63bf965c3884ca$var$_initializerDefineProperty(this, "open", $2d63bf965c3884ca$var$_descriptor8, this);
        $2d63bf965c3884ca$var$_initializerDefineProperty(this, "initialized", $2d63bf965c3884ca$var$_descriptor9, this);
        $2d63bf965c3884ca$var$_defineProperty(this, "timerInterval", null);
        (0, $4JcCM.makeObservable)(this);
        this.init();
    }
    init() {
        // make conditional so it doesn't reset
        if (!this.selectedValues.projectId) this.setDefaults();
    // if (!this.timerInterval) this.startTimer();
    }
    tick() {
        this.currentTime = new Date();
    }
    startTimer() {
        clearInterval(this.timerInterval);
        this.startTime = new Date();
        this.timerInterval = setInterval(this.tick, 1000);
        this.timerState = "running";
        this.storeLocal();
    }
    pauseTimer() {
        this.prevSeconds = this.seconds;
        // this.startTime = null;
        this.currentTime = null;
        clearInterval(this.timerInterval);
        this.timerState = "idle";
        this.storeLocal();
    }
    resetTimer() {
        this.pauseTimer();
        this.prevSeconds = 0;
        this.storeLocal();
    }
    get currentSeconds() {
        return this.startTime && this.currentTime ? (this.currentTime - this.startTime) / 1000 : 0;
    }
    get seconds() {
        return this.prevSeconds + this.currentSeconds;
    }
    get timeDisplay() {
        return new Date(this.seconds * 1000).toISOString().substr(12, 7);
    }
    toggleOpen(val) {
        if (val || !this.open) this.init();
        this.open = val || !this.open;
    }
    setDefaults(selectedValues = {}) {
        const setDefaults = ()=>{
            var _ProjectCollection$pr, _project$phases, _phase$tasks, _task$isBillable, _task$isVariation;
            const project = (_ProjectCollection$pr = (0, $gJT7h.default).projects) === null || _ProjectCollection$pr === void 0 ? void 0 : _ProjectCollection$pr.sort((a, b)=>{
                var _a$title, _a$title$localeCompar;
                return (_a$title = a.title) === null || _a$title === void 0 ? void 0 : (_a$title$localeCompar = _a$title.localeCompare) === null || _a$title$localeCompar === void 0 ? void 0 : _a$title$localeCompar.call(_a$title, b.title);
            }).filter((p)=>(0, $8kZ1o.canEnterTimeAgainstProject)((0, $1BTI2.default).user, p))[0];
            const phase = project === null || project === void 0 ? void 0 : (_project$phases = project.phases) === null || _project$phases === void 0 ? void 0 : _project$phases.sort((0, $6fNfM.default)).filter((p)=>(0, $8kZ1o.canEnterTimeAgainstPhase)((0, $1BTI2.default).user, p))[0];
            const task = phase === null || phase === void 0 ? void 0 : (_phase$tasks = phase.tasks) === null || _phase$tasks === void 0 ? void 0 : _phase$tasks.sort((a, b)=>{
                var _a$name, _a$name$localeCompare;
                return (_a$name = a.name) === null || _a$name === void 0 ? void 0 : (_a$name$localeCompare = _a$name.localeCompare) === null || _a$name$localeCompare === void 0 ? void 0 : _a$name$localeCompare.call(_a$name, b.name);
            })[0];
            this.selectedValues = {
                projectId: project === null || project === void 0 ? void 0 : project.id,
                costCentreId: project === null || project === void 0 ? void 0 : project.costCentreId,
                phaseId: phase === null || phase === void 0 ? void 0 : phase.id,
                taskId: task === null || task === void 0 ? void 0 : task.id,
                staffId: (0, $1BTI2.default).userId,
                isBillable: (_task$isBillable = task === null || task === void 0 ? void 0 : task.isBillable) !== null && _task$isBillable !== void 0 ? _task$isBillable : true,
                isVariation: (_task$isVariation = task === null || task === void 0 ? void 0 : task.isVariation) !== null && _task$isVariation !== void 0 ? _task$isVariation : false,
                isOvertime: false,
                isLocked: false,
                remote: false,
                flexi: false,
                ...selectedValues
            };
            // budgetStore.getBudget(
            //     new Date(), //weekStart
            //     new Date(), //selectedDate
            //     this.mode,
            //     this.selectedValues.staffId,
            //     this.selectedValues.projectId,
            //     this.selectedValues.phaseId
            // )
            this.storeLocal();
            this.initialized = true;
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($7Fn0s))).getItem("timer").then((v)=>{
            var _v, _v$selectedValues, _v2, _v2$selectedValues;
            v = v ? (0, $72ezo.default).parse(v) : null;
            if (!((_v = v) !== null && _v !== void 0 && (_v$selectedValues = _v.selectedValues) !== null && _v$selectedValues !== void 0 && _v$selectedValues.projectId) || ((_v2 = v) === null || _v2 === void 0 ? void 0 : (_v2$selectedValues = _v2.selectedValues) === null || _v2$selectedValues === void 0 ? void 0 : _v2$selectedValues.staffId) !== (0, $1BTI2.default).userId) setDefaults();
            else {
                this.timerState = v.timerState;
                this.selectedValues = v.selectedValues;
                this.budgetType = v.budgetType;
                this.prevSeconds = v.prevSeconds;
                this.startTime = v.startTime;
                if (this.timerState !== "idle") {
                    this.currentTime = Date.now();
                    clearInterval(this.timerInterval);
                    this.timerInterval = setInterval(this.tick, 1000);
                    this.timerState = "running";
                }
                // budgetStore.getBudget(
                //     new Date(), //weekStart
                //     new Date(), //selectedDate
                //     this.mode,
                //     this.selectedValues.staffId,
                //     this.selectedValues.projectId,
                //     this.selectedValues.phaseId
                // )
                this.initialized = true;
            }
        }).catch((e)=>{
            console.error(e);
            setDefaults();
        });
    }
    updateSelectedValues(data) {
        this.selectedValues = {
            ...this.selectedValues,
            ...data
        };
        if ("projectId" in data) {
            var _project$phases2, _task$isBillable2, _task$isVariation2;
            const project = (0, $gJT7h.default).projectsById[data.projectId];
            const phase = project === null || project === void 0 ? void 0 : (_project$phases2 = project.phases) === null || _project$phases2 === void 0 ? void 0 : _project$phases2.sort((0, $6fNfM.default)).filter((p)=>(0, $8kZ1o.canEnterTimeAgainstPhase)((0, $1BTI2.default).user, p))[0];
            const task = (phase === null || phase === void 0 ? void 0 : phase.defaultTask) || (phase === null || phase === void 0 ? void 0 : phase.tasks[0]);
            this.selectedValues = {
                ...this.selectedValues,
                costCentreId: project.costCentreId,
                phaseId: phase === null || phase === void 0 ? void 0 : phase.id,
                taskId: task === null || task === void 0 ? void 0 : task.id,
                isBillable: (_task$isBillable2 = task === null || task === void 0 ? void 0 : task.isBillable) !== null && _task$isBillable2 !== void 0 ? _task$isBillable2 : true,
                isVariation: (_task$isVariation2 = task === null || task === void 0 ? void 0 : task.isVariation) !== null && _task$isVariation2 !== void 0 ? _task$isVariation2 : false
            };
        }
        if ("phaseId" in data) {
            var _task$isBillable3, _task$isVariation3;
            const phase = (0, $XoImS.default).phasesById[data.phaseId];
            const task = (phase === null || phase === void 0 ? void 0 : phase.defaultTask) || (phase === null || phase === void 0 ? void 0 : phase.tasks[0]);
            this.selectedValues = {
                ...this.selectedValues,
                taskId: task === null || task === void 0 ? void 0 : task.id,
                isBillable: (_task$isBillable3 = task === null || task === void 0 ? void 0 : task.isBillable) !== null && _task$isBillable3 !== void 0 ? _task$isBillable3 : true,
                isVariation: (_task$isVariation3 = task === null || task === void 0 ? void 0 : task.isVariation) !== null && _task$isVariation3 !== void 0 ? _task$isVariation3 : false
            };
        }
        // budgetStore.getBudget(
        //     new Date(), //weekStart
        //     new Date(), //selectedDate
        //     this.mode,
        //     this.selectedValues.staffId,
        //     this.selectedValues.projectId,
        //     this.selectedValues.phaseId
        // )
        this.storeLocal();
    }
    changeBudgetType(newType) {
        this.budgetType = newType;
        this.storeLocal();
    }
    get budget() {
        // TODO
        return {
            budget: 0,
            use: 0,
            percent: 0
        };
    }
    saveTimeEntry() {
        var _this$selectedValues$, _this$selectedValues$2, _this$selectedValues$3, _this$selectedValues$4, _this$selectedValues$5, _this$selectedValues$6;
        this.pauseTimer();
        this.saveState = "saving";
        const timeEntryData = {
            costCentreId: this.selectedValues.costCentreId,
            projectId: this.selectedValues.projectId,
            phaseId: this.selectedValues.phaseId,
            taskId: this.selectedValues.taskId,
            staffId: (0, $1BTI2.default).userId,
            date: this.startTime || new Date(),
            numMinutes: Math.round(this.seconds / 60) || 0,
            startMinutes: Math.max(Math.round((0, $4hBm1.differenceInMinutes)((0, $4hBm1.subSeconds)(this.startTime, this.prevSeconds), (0, $4hBm1.startOfDay)(this.startTime))), 0),
            notes: this.selectedValues.notes,
            isBillable: (_this$selectedValues$ = this.selectedValues.isBillable) !== null && _this$selectedValues$ !== void 0 ? _this$selectedValues$ : true,
            isVariation: (_this$selectedValues$2 = this.selectedValues.isVariation) !== null && _this$selectedValues$2 !== void 0 ? _this$selectedValues$2 : false,
            isOvertime: (_this$selectedValues$3 = this.selectedValues.isOvertime) !== null && _this$selectedValues$3 !== void 0 ? _this$selectedValues$3 : false,
            remote: (_this$selectedValues$4 = this.selectedValues.remote) !== null && _this$selectedValues$4 !== void 0 ? _this$selectedValues$4 : false,
            flexi: (_this$selectedValues$5 = this.selectedValues.flexi) !== null && _this$selectedValues$5 !== void 0 ? _this$selectedValues$5 : false,
            isLocked: (_this$selectedValues$6 = this.selectedValues.isLocked) !== null && _this$selectedValues$6 !== void 0 ? _this$selectedValues$6 : false
        };
        const te = (0, $QiMYe.default).add(timeEntryData, {
            trackUpdates: true
        });
        (0, $fM2j4.default).saveModel(te).then(()=>{
            this.saveState = "saved";
            this.resetTimer();
            setTimeout(()=>this.saveState = "idle", 500);
        });
    }
    storeLocal() {
        (0, (/*@__PURE__*/$parcel$interopDefault($7Fn0s))).setItem("timer", (0, $72ezo.default).stringify({
            timerState: this.timerState,
            selectedValues: {
                ...this.selectedValues,
                staffId: (0, $1BTI2.default).userId
            },
            budgetType: this.budgetType,
            prevSeconds: this.prevSeconds,
            startTime: this.startTime
        }));
    }
    get interfaceDisabled() {
        return !this.initialized || this.saveState !== "idle";
    }
    get timeEntries() {
        return (0, $QiMYe.default).timeEntriesByStaffIdDate[(0, $f44xu.default)((0, $1BTI2.default).userId, (0, $4hBm1.startOfDay)(new Date()).getTime())] || [];
    }
}, $2d63bf965c3884ca$var$_descriptor = $2d63bf965c3884ca$var$_applyDecoratedDescriptor($2d63bf965c3884ca$var$_class.prototype, "timerState", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "idle";
    }
}), $2d63bf965c3884ca$var$_descriptor2 = $2d63bf965c3884ca$var$_applyDecoratedDescriptor($2d63bf965c3884ca$var$_class.prototype, "saveState", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "idle";
    }
}), $2d63bf965c3884ca$var$_descriptor3 = $2d63bf965c3884ca$var$_applyDecoratedDescriptor($2d63bf965c3884ca$var$_class.prototype, "selectedValues", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {
            projectId: null,
            costCentreId: null,
            phaseId: null,
            taskId: null,
            staffId: null,
            isBillable: true,
            isVariation: false,
            isOvertime: false,
            isLocked: false,
            remote: false,
            flexi: false
        };
    }
}), $2d63bf965c3884ca$var$_descriptor4 = $2d63bf965c3884ca$var$_applyDecoratedDescriptor($2d63bf965c3884ca$var$_class.prototype, "budgetType", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "phase";
    }
}), $2d63bf965c3884ca$var$_descriptor5 = $2d63bf965c3884ca$var$_applyDecoratedDescriptor($2d63bf965c3884ca$var$_class.prototype, "prevSeconds", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $2d63bf965c3884ca$var$_descriptor6 = $2d63bf965c3884ca$var$_applyDecoratedDescriptor($2d63bf965c3884ca$var$_class.prototype, "startTime", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $2d63bf965c3884ca$var$_descriptor7 = $2d63bf965c3884ca$var$_applyDecoratedDescriptor($2d63bf965c3884ca$var$_class.prototype, "currentTime", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $2d63bf965c3884ca$var$_descriptor8 = $2d63bf965c3884ca$var$_applyDecoratedDescriptor($2d63bf965c3884ca$var$_class.prototype, "open", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $2d63bf965c3884ca$var$_descriptor9 = $2d63bf965c3884ca$var$_applyDecoratedDescriptor($2d63bf965c3884ca$var$_class.prototype, "initialized", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $2d63bf965c3884ca$var$_applyDecoratedDescriptor($2d63bf965c3884ca$var$_class.prototype, "init", [
    $2d63bf965c3884ca$var$_dec
], Object.getOwnPropertyDescriptor($2d63bf965c3884ca$var$_class.prototype, "init"), $2d63bf965c3884ca$var$_class.prototype), $2d63bf965c3884ca$var$_applyDecoratedDescriptor($2d63bf965c3884ca$var$_class.prototype, "tick", [
    $2d63bf965c3884ca$var$_dec2
], Object.getOwnPropertyDescriptor($2d63bf965c3884ca$var$_class.prototype, "tick"), $2d63bf965c3884ca$var$_class.prototype), $2d63bf965c3884ca$var$_applyDecoratedDescriptor($2d63bf965c3884ca$var$_class.prototype, "startTimer", [
    $2d63bf965c3884ca$var$_dec3
], Object.getOwnPropertyDescriptor($2d63bf965c3884ca$var$_class.prototype, "startTimer"), $2d63bf965c3884ca$var$_class.prototype), $2d63bf965c3884ca$var$_applyDecoratedDescriptor($2d63bf965c3884ca$var$_class.prototype, "pauseTimer", [
    $2d63bf965c3884ca$var$_dec4
], Object.getOwnPropertyDescriptor($2d63bf965c3884ca$var$_class.prototype, "pauseTimer"), $2d63bf965c3884ca$var$_class.prototype), $2d63bf965c3884ca$var$_applyDecoratedDescriptor($2d63bf965c3884ca$var$_class.prototype, "resetTimer", [
    $2d63bf965c3884ca$var$_dec5
], Object.getOwnPropertyDescriptor($2d63bf965c3884ca$var$_class.prototype, "resetTimer"), $2d63bf965c3884ca$var$_class.prototype), $2d63bf965c3884ca$var$_applyDecoratedDescriptor($2d63bf965c3884ca$var$_class.prototype, "currentSeconds", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($2d63bf965c3884ca$var$_class.prototype, "currentSeconds"), $2d63bf965c3884ca$var$_class.prototype), $2d63bf965c3884ca$var$_applyDecoratedDescriptor($2d63bf965c3884ca$var$_class.prototype, "seconds", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($2d63bf965c3884ca$var$_class.prototype, "seconds"), $2d63bf965c3884ca$var$_class.prototype), $2d63bf965c3884ca$var$_applyDecoratedDescriptor($2d63bf965c3884ca$var$_class.prototype, "timeDisplay", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($2d63bf965c3884ca$var$_class.prototype, "timeDisplay"), $2d63bf965c3884ca$var$_class.prototype), $2d63bf965c3884ca$var$_applyDecoratedDescriptor($2d63bf965c3884ca$var$_class.prototype, "toggleOpen", [
    $2d63bf965c3884ca$var$_dec6
], Object.getOwnPropertyDescriptor($2d63bf965c3884ca$var$_class.prototype, "toggleOpen"), $2d63bf965c3884ca$var$_class.prototype), $2d63bf965c3884ca$var$_applyDecoratedDescriptor($2d63bf965c3884ca$var$_class.prototype, "setDefaults", [
    $2d63bf965c3884ca$var$_dec7
], Object.getOwnPropertyDescriptor($2d63bf965c3884ca$var$_class.prototype, "setDefaults"), $2d63bf965c3884ca$var$_class.prototype), $2d63bf965c3884ca$var$_applyDecoratedDescriptor($2d63bf965c3884ca$var$_class.prototype, "updateSelectedValues", [
    $2d63bf965c3884ca$var$_dec8
], Object.getOwnPropertyDescriptor($2d63bf965c3884ca$var$_class.prototype, "updateSelectedValues"), $2d63bf965c3884ca$var$_class.prototype), $2d63bf965c3884ca$var$_applyDecoratedDescriptor($2d63bf965c3884ca$var$_class.prototype, "changeBudgetType", [
    $2d63bf965c3884ca$var$_dec9
], Object.getOwnPropertyDescriptor($2d63bf965c3884ca$var$_class.prototype, "changeBudgetType"), $2d63bf965c3884ca$var$_class.prototype), $2d63bf965c3884ca$var$_applyDecoratedDescriptor($2d63bf965c3884ca$var$_class.prototype, "budget", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($2d63bf965c3884ca$var$_class.prototype, "budget"), $2d63bf965c3884ca$var$_class.prototype), $2d63bf965c3884ca$var$_applyDecoratedDescriptor($2d63bf965c3884ca$var$_class.prototype, "saveTimeEntry", [
    $2d63bf965c3884ca$var$_dec10
], Object.getOwnPropertyDescriptor($2d63bf965c3884ca$var$_class.prototype, "saveTimeEntry"), $2d63bf965c3884ca$var$_class.prototype), $2d63bf965c3884ca$var$_applyDecoratedDescriptor($2d63bf965c3884ca$var$_class.prototype, "storeLocal", [
    $2d63bf965c3884ca$var$_dec11
], Object.getOwnPropertyDescriptor($2d63bf965c3884ca$var$_class.prototype, "storeLocal"), $2d63bf965c3884ca$var$_class.prototype), $2d63bf965c3884ca$var$_applyDecoratedDescriptor($2d63bf965c3884ca$var$_class.prototype, "interfaceDisabled", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($2d63bf965c3884ca$var$_class.prototype, "interfaceDisabled"), $2d63bf965c3884ca$var$_class.prototype), $2d63bf965c3884ca$var$_applyDecoratedDescriptor($2d63bf965c3884ca$var$_class.prototype, "timeEntries", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($2d63bf965c3884ca$var$_class.prototype, "timeEntries"), $2d63bf965c3884ca$var$_class.prototype), $2d63bf965c3884ca$var$_class);
var $2d63bf965c3884ca$export$2e2bcd8739ae039 = new $2d63bf965c3884ca$var$timerStore();

});
parcelRegister("XoImS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b28ae9c324f4ce6$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "PhaseCollectionClass", function () { return $0b28ae9c324f4ce6$export$12f8bb3600aabab2; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $9n4C6 = parcelRequire("9n4C6");

var $keGWP = parcelRequire("keGWP");

var $8kZ1o = parcelRequire("8kZ1o");
var $0b28ae9c324f4ce6$var$_dec, $0b28ae9c324f4ce6$var$_dec2, $0b28ae9c324f4ce6$var$_dec3, $0b28ae9c324f4ce6$var$_dec4, $0b28ae9c324f4ce6$var$_class;
function $0b28ae9c324f4ce6$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $0b28ae9c324f4ce6$var$PhaseCollection = ($0b28ae9c324f4ce6$var$_dec = (0, $4JcCM.action).bound, $0b28ae9c324f4ce6$var$_dec2 = (0, $4JcCM.action).bound, $0b28ae9c324f4ce6$var$_dec3 = (0, $4JcCM.action).bound, $0b28ae9c324f4ce6$var$_dec4 = (0, $4JcCM.action).bound, $0b28ae9c324f4ce6$var$_class = class PhaseCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "phases",
            modelClass: (0, $9n4C6.default)
        });
        this.addLookup("phasesByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get phasesById() {
        return this.modelsById;
    }
    get phases() {
        return this.models;
    }
    addPhase(data) {
        this.add(data);
    }
    addPhases(data) {
        this.addMany(data);
    }
    createPhase(projectId) {
        var _phase$project$costCe, _phase$project, _phase$project$costCe2;
        const phase = this.add({
            name: "New Phase",
            projectId: projectId,
            status: "active"
        }, {
            trackUpdates: true
        });
        const task = (0, $keGWP.default).add({
            name: "(No task)",
            projectId: projectId,
            phaseId: phase.id,
            isDefault: true,
            isBillable: (_phase$project$costCe = (_phase$project = phase.project) === null || _phase$project === void 0 ? void 0 : (_phase$project$costCe2 = _phase$project.costCentre) === null || _phase$project$costCe2 === void 0 ? void 0 : _phase$project$costCe2.isBillable) !== null && _phase$project$costCe !== void 0 ? _phase$project$costCe : true,
            isVariation: false
        }, {
            trackUpdates: true
        });
        (0, $8kZ1o.getDefaultTasks)().forEach((task)=>{
            (0, $keGWP.default).add({
                projectId: projectId,
                phaseId: phase.id,
                isDefault: false,
                ...task
            }, {
                trackUpdates: true
            });
        });
        return phase;
    }
    createRootPhase(projectId) {
        const phase = this.add({
            name: "(No Phase)",
            projectId: projectId,
            status: "active",
            isRootPhase: true
        }, {
            trackUpdates: true
        });
        return phase;
    }
}, $0b28ae9c324f4ce6$var$_applyDecoratedDescriptor($0b28ae9c324f4ce6$var$_class.prototype, "addPhase", [
    $0b28ae9c324f4ce6$var$_dec
], Object.getOwnPropertyDescriptor($0b28ae9c324f4ce6$var$_class.prototype, "addPhase"), $0b28ae9c324f4ce6$var$_class.prototype), $0b28ae9c324f4ce6$var$_applyDecoratedDescriptor($0b28ae9c324f4ce6$var$_class.prototype, "addPhases", [
    $0b28ae9c324f4ce6$var$_dec2
], Object.getOwnPropertyDescriptor($0b28ae9c324f4ce6$var$_class.prototype, "addPhases"), $0b28ae9c324f4ce6$var$_class.prototype), $0b28ae9c324f4ce6$var$_applyDecoratedDescriptor($0b28ae9c324f4ce6$var$_class.prototype, "createPhase", [
    $0b28ae9c324f4ce6$var$_dec3
], Object.getOwnPropertyDescriptor($0b28ae9c324f4ce6$var$_class.prototype, "createPhase"), $0b28ae9c324f4ce6$var$_class.prototype), $0b28ae9c324f4ce6$var$_applyDecoratedDescriptor($0b28ae9c324f4ce6$var$_class.prototype, "createRootPhase", [
    $0b28ae9c324f4ce6$var$_dec4
], Object.getOwnPropertyDescriptor($0b28ae9c324f4ce6$var$_class.prototype, "createRootPhase"), $0b28ae9c324f4ce6$var$_class.prototype), $0b28ae9c324f4ce6$var$_class);
var $0b28ae9c324f4ce6$export$2e2bcd8739ae039 = new $0b28ae9c324f4ce6$var$PhaseCollection();
const $0b28ae9c324f4ce6$export$12f8bb3600aabab2 = $0b28ae9c324f4ce6$var$PhaseCollection;

});
parcelRegister("9n4C6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d29d731f9635d66$export$2e2bcd8739ae039; });
parcelRequire("gN0TC");


var $4JcCM = parcelRequire("4JcCM");

var $9VnJj = parcelRequire("9VnJj");

var $gJT7h = parcelRequire("gJT7h");

var $cfp1m = parcelRequire("cfp1m");

var $avf6p = parcelRequire("avf6p");

var $keGWP = parcelRequire("keGWP");

var $QiMYe = parcelRequire("QiMYe");

var $3PpOX = parcelRequire("3PpOX");

var $7CaHe = parcelRequire("7CaHe");

var $XoImS = parcelRequire("XoImS");

var $eat5C = parcelRequire("eat5C");

var $hSUCJ = parcelRequire("hSUCJ");

var $4tYKG = parcelRequire("4tYKG");

var $kRqe9 = parcelRequire("kRqe9");

var $jYjJH = parcelRequire("jYjJH");

var $jc1Yz = parcelRequire("jc1Yz");

var $64hVI = parcelRequire("64hVI");

var $d4jhX = parcelRequire("d4jhX");

var $gkMXq = parcelRequire("gkMXq");

var $62nmb = parcelRequire("62nmb");
parcelRequire("MRmcQ");

var $37AD0 = parcelRequire("37AD0");
parcelRequire("eBwNQ");

var $huUQP = parcelRequire("huUQP");

var $fFfyp = parcelRequire("fFfyp");
var $6d29d731f9635d66$var$_dec, $6d29d731f9635d66$var$_dec2, $6d29d731f9635d66$var$_dec3, $6d29d731f9635d66$var$_class, $6d29d731f9635d66$var$_descriptor, $6d29d731f9635d66$var$_descriptor2, $6d29d731f9635d66$var$_descriptor3, $6d29d731f9635d66$var$_descriptor4, $6d29d731f9635d66$var$_descriptor5, $6d29d731f9635d66$var$_descriptor6, $6d29d731f9635d66$var$_descriptor7, $6d29d731f9635d66$var$_descriptor8, $6d29d731f9635d66$var$_descriptor9, $6d29d731f9635d66$var$_descriptor10, $6d29d731f9635d66$var$_descriptor11, $6d29d731f9635d66$var$_descriptor12, $6d29d731f9635d66$var$_descriptor13, $6d29d731f9635d66$var$_descriptor14, $6d29d731f9635d66$var$_descriptor15, $6d29d731f9635d66$var$_descriptor16, $6d29d731f9635d66$var$_descriptor17;
function $6d29d731f9635d66$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $6d29d731f9635d66$var$_defineProperty(e, r, t) {
    return (r = $6d29d731f9635d66$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $6d29d731f9635d66$var$_toPropertyKey(t) {
    var i = $6d29d731f9635d66$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $6d29d731f9635d66$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $6d29d731f9635d66$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $6d29d731f9635d66$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $6d29d731f9635d66$var$PhaseModel = ($6d29d731f9635d66$var$_dec = (0, $4JcCM.action).bound, $6d29d731f9635d66$var$_dec2 = (0, $4JcCM.action).bound, $6d29d731f9635d66$var$_dec3 = (0, $4JcCM.action).bound, $6d29d731f9635d66$var$_class = class PhaseModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $6d29d731f9635d66$var$_initializerDefineProperty(this, "jobNumber", $6d29d731f9635d66$var$_descriptor, this);
        $6d29d731f9635d66$var$_initializerDefineProperty(this, "name", $6d29d731f9635d66$var$_descriptor2, this);
        $6d29d731f9635d66$var$_initializerDefineProperty(this, "projectId", $6d29d731f9635d66$var$_descriptor3, this);
        $6d29d731f9635d66$var$_initializerDefineProperty(this, "startDate", $6d29d731f9635d66$var$_descriptor4, this);
        $6d29d731f9635d66$var$_initializerDefineProperty(this, "endDate", $6d29d731f9635d66$var$_descriptor5, this);
        $6d29d731f9635d66$var$_initializerDefineProperty(this, "fee", $6d29d731f9635d66$var$_descriptor6, this);
        $6d29d731f9635d66$var$_initializerDefineProperty(this, "expenseBudget", $6d29d731f9635d66$var$_descriptor7, this);
        $6d29d731f9635d66$var$_initializerDefineProperty(this, "hoursBudget", $6d29d731f9635d66$var$_descriptor8, this);
        $6d29d731f9635d66$var$_initializerDefineProperty(this, "status", $6d29d731f9635d66$var$_descriptor9, this);
        $6d29d731f9635d66$var$_initializerDefineProperty(this, "percentLikelihood", $6d29d731f9635d66$var$_descriptor10, this);
        $6d29d731f9635d66$var$_initializerDefineProperty(this, "feeLinked", $6d29d731f9635d66$var$_descriptor11, this);
        $6d29d731f9635d66$var$_initializerDefineProperty(this, "expenseBudgetLinked", $6d29d731f9635d66$var$_descriptor12, this);
        $6d29d731f9635d66$var$_initializerDefineProperty(this, "hoursBudgetLinked", $6d29d731f9635d66$var$_descriptor13, this);
        $6d29d731f9635d66$var$_initializerDefineProperty(this, "durationUnit", $6d29d731f9635d66$var$_descriptor14, this);
        $6d29d731f9635d66$var$_initializerDefineProperty(this, "phaseData", $6d29d731f9635d66$var$_descriptor15, this);
        $6d29d731f9635d66$var$_initializerDefineProperty(this, "previousBilled", $6d29d731f9635d66$var$_descriptor16, this);
        $6d29d731f9635d66$var$_initializerDefineProperty(this, "isRootPhase", $6d29d731f9635d66$var$_descriptor17, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $XoImS.default);
        this.init(data, options);
    }
    get project() {
        return (0, $gJT7h.default).modelsById[this.projectId];
    }
    get allocations() {
        return this.monthlyAllocations;
    }
    get monthlyAllocations() {
        return (0, $huUQP.default).allocationsByPhaseId[this.id] || [];
    }
    get weeklyAllocations() {
        return (0, $fFfyp.default).allocationsByPhaseId[this.id] || [];
    }
    get allocatedStaff() {
        return this.allocations.map((a)=>a.staff);
    }
    get dailyAllocations() {
        return (0, $9VnJj.default).dailyAllocationsByPhaseId[this.id] || [];
    }
    get title() {
        return this.jobNumber && this.name ? `${this.jobNumber}: ${this.name}` : this.name || this.jobNumber;
    }
    get expenses() {
        return (0, $cfp1m.default).expensesByPhaseId[this.id] || [];
    }
    get expenseAllocations() {
        return (0, $d4jhX.default).expenseAllocationsByPhaseId[this.id] || [];
    }
    get rates() {
        return (0, $avf6p.default).ratesByPhaseId[this.id] || [];
    }
    get tasks() {
        return ((0, $keGWP.default).tasksByPhaseId[this.id] || []).sort((a, b)=>{
            // First, sort by createdAt.
            const createdAtComparison = new Date(a.initiatedAt) - new Date(b.initiatedAt);
            if (createdAtComparison !== 0) return createdAtComparison;
            // If createdAt is the same, sort by name.
            // Tasks without names go last.
            if (a.name && b.name) return a.name.localeCompare(b.name);
            if (a.name) return -1; // a has a name and comes before b
            if (b.name) return 1; // b has a name and comes before a
            // If both don't have a name, keep their order unchanged.
            return 0;
        });
    }
    get budgets() {
        return (0, $hSUCJ.default).budgetsByPhaseId[this.id] || [];
    }
    get hoursFromBudgets() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.budgets.map((b)=>b.hours));
    }
    get costFromBudgets() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.budgets.map((b)=>b.cost));
    }
    get budgetedStaff() {
        return this.budgets.map((b)=>b.staff);
    }
    get budgetedRoles() {
        return [
            ...new Set([
                ...this.budgets.map((b)=>{
                    var _b$staff;
                    return (_b$staff = b.staff) === null || _b$staff === void 0 ? void 0 : _b$staff.role;
                }),
                ...this.budgets.map((b)=>b.role)
            ].filter((r)=>r))
        ];
    }
    get duration() {
        return (0, $7CaHe.unitsBetween)(this.startDate, this.endDate, this.durationUnit);
    }
    get invoiceLineItems() {
        return (0, $kRqe9.default).lineItemsByPhaseId[this.id] || [];
    }
    get timeEntries() {
        return (0, $QiMYe.default).timeEntriesByPhaseId[this.id] || [];
    }
    getAggregateInvoiceLineItems(group) {
        return (0, $4tYKG.default).getGroupCollection(group).lineItemsByPhaseId[this.id] || [];
    }
    getAggregateTimeEntries(group) {
        return (0, $jYjJH.default).getGroupCollection(group).timeEntriesByPhaseId[this.id] || [];
    }
    get revenueTargets() {
        return (0, $64hVI.default).revenueTargetsByPhaseId[this.id] || [];
    }
    get costCentre() {
        var _this$project;
        return (_this$project = this.project) === null || _this$project === void 0 ? void 0 : _this$project.costCentre;
    }
    get contact() {
        var _this$project2;
        return (_this$project2 = this.project) === null || _this$project2 === void 0 ? void 0 : _this$project2.contact;
    }
    get primaryContact() {
        var _this$project3;
        return (_this$project3 = this.project) === null || _this$project3 === void 0 ? void 0 : _this$project3.primaryContact;
    }
    get owner() {
        var _this$project4;
        return (_this$project4 = this.project) === null || _this$project4 === void 0 ? void 0 : _this$project4.owner;
    }
    get notes() {
        return (0, $jc1Yz.default).notesByPhaseId[this.id];
    }
    get changeLog() {
        return (0, $gkMXq.default).changeLogItemsByPhaseId[this.id] || [];
    }
    updateDuration(duration, options) {
        const newEndDate = (0, $7CaHe.addUnitToDate)(this.startDate, duration.unit, duration.value);
        this.update({
            endDate: newEndDate
        }, options);
    }
    get hasDates() {
        return this.startDate && this.endDate;
    }
    get isCurrent() {
        return !this.startDate && this.endDate >= new Date() || !this.endDate && this.startDate <= new Date() || this.endDate >= new Date() && this.startDate <= new Date();
    }
    get hasEnded() {
        return this.hasDates && !this.isCurrent;
    }
    updateBudgets(field) {
        const budgets = this.budgets.filter((b)=>b.resource);
        const expenses = this.expenses.filter((e)=>!e.billable);
        if (field === "fee" && this.feeLinked && budgets.length) {
            const existingBudgetFee = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(budgets.map((b)=>b.chargeOut));
            if (!existingBudgetFee) budgets.forEach((b)=>{
                b.update({
                    hours: 1
                });
            });
            const ratio = this.fee / (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(budgets.map((b)=>b.chargeOut));
            budgets.forEach((b)=>{
                b.update({
                    hours: isFinite(b.hours * ratio) ? b.hours * ratio : 0
                });
            });
        } else if (field === "expenseBudget" && this.expenseBudgetLinked && (budgets.length || expenses.length)) {
            const existingBudget = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(budgets.map((b)=>b.cost));
            if (!existingBudget) budgets.forEach((b)=>{
                b.update({
                    hours: 1
                });
            });
            const ratio = (this.expenseBudget - (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(expenses.map((e)=>e.cost))) / (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(budgets.map((b)=>b.cost));
            budgets.forEach((b)=>{
                b.update({
                    hours: isFinite(b.hours * ratio) ? b.hours * ratio : 0
                });
            });
        } else if (field === "hoursBudget" && this.hoursBudgetLinked && budgets.length) {
            const existingBudget = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(budgets.map((b)=>b.hours));
            if (!existingBudget) budgets.forEach((b)=>{
                b.update({
                    hours: 1
                });
            });
            const ratio = this.hoursBudget / (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(budgets.map((b)=>b.hours));
            budgets.forEach((b)=>{
                b.update({
                    hours: isFinite(b.hours * ratio) ? b.hours * ratio : 0
                });
            });
        }
        this.updateFromBudgets();
    }
    updateFromBudgets() {
        const budgets = this.budgets.filter((b)=>b.resource);
        const expenses = this.expenses.filter((e)=>!e.billable);
        if (this.feeLinked && budgets.length) this.update({
            fee: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(budgets.map((b)=>b.chargeOut))
        });
        if (this.expenseBudgetLinked && (budgets.length || expenses.length)) this.update({
            expenseBudget: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(budgets.map((b)=>b.cost)) + (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(expenses.map((e)=>e.cost))
        });
        if (this.hoursBudgetLinked && budgets.length) this.update({
            hoursBudget: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(budgets.map((b)=>b.hours))
        });
    }
    get feeAdjustedByLikelihood() {
        if ([
            "prospective",
            "onHold"
        ].includes(this.status) && this.percentLikelihood) return this.fee * (this.percentLikelihood / 100);
        else return this.fee;
    }
    get defaultTask() {
        var _this$tasks;
        return this.tasks.find((t)=>t.isDefault) || ((_this$tasks = this.tasks) === null || _this$tasks === void 0 ? void 0 : _this$tasks[0]);
    }
    get costRate() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).mean(this.budgets.map((b)=>b.costRate));
    }
    get chargeOutRate() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).mean(this.budgets.map((b)=>b.chargeOutRate));
    }
    getRateAtDate(rateType, date) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).mean(this.budgets.map((b)=>{
            var _b$staff2, _b$role;
            return (0, $37AD0.default)(this.rates.filter((r)=>r.staff === b.staff || !r.staff && r.role === b.role), rateType, date) || ((_b$staff2 = b.staff) === null || _b$staff2 === void 0 ? void 0 : _b$staff2.getRateAtDate(rateType, date)) || ((_b$role = b.role) === null || _b$role === void 0 ? void 0 : _b$role.getRateAtDate(rateType, date)) || 0;
        }));
    }
}, $6d29d731f9635d66$var$_descriptor = $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "jobNumber", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $6d29d731f9635d66$var$_descriptor2 = $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "name", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $6d29d731f9635d66$var$_descriptor3 = $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "projectId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $6d29d731f9635d66$var$_descriptor4 = $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "startDate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $6d29d731f9635d66$var$_descriptor5 = $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "endDate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $6d29d731f9635d66$var$_descriptor6 = $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "fee", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $6d29d731f9635d66$var$_descriptor7 = $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "expenseBudget", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $6d29d731f9635d66$var$_descriptor8 = $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "hoursBudget", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $6d29d731f9635d66$var$_descriptor9 = $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "status", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $6d29d731f9635d66$var$_descriptor10 = $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "percentLikelihood", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $6d29d731f9635d66$var$_descriptor11 = $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "feeLinked", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $6d29d731f9635d66$var$_descriptor12 = $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "expenseBudgetLinked", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $6d29d731f9635d66$var$_descriptor13 = $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "hoursBudgetLinked", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $6d29d731f9635d66$var$_descriptor14 = $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "durationUnit", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "weeks";
    }
}), $6d29d731f9635d66$var$_descriptor15 = $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "phaseData", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $6d29d731f9635d66$var$_descriptor16 = $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "previousBilled", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $6d29d731f9635d66$var$_descriptor17 = $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "isRootPhase", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "project", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6d29d731f9635d66$var$_class.prototype, "project"), $6d29d731f9635d66$var$_class.prototype), $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "allocations", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6d29d731f9635d66$var$_class.prototype, "allocations"), $6d29d731f9635d66$var$_class.prototype), $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "monthlyAllocations", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6d29d731f9635d66$var$_class.prototype, "monthlyAllocations"), $6d29d731f9635d66$var$_class.prototype), $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "weeklyAllocations", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6d29d731f9635d66$var$_class.prototype, "weeklyAllocations"), $6d29d731f9635d66$var$_class.prototype), $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "allocatedStaff", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6d29d731f9635d66$var$_class.prototype, "allocatedStaff"), $6d29d731f9635d66$var$_class.prototype), $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "dailyAllocations", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6d29d731f9635d66$var$_class.prototype, "dailyAllocations"), $6d29d731f9635d66$var$_class.prototype), $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "title", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6d29d731f9635d66$var$_class.prototype, "title"), $6d29d731f9635d66$var$_class.prototype), $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "expenses", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6d29d731f9635d66$var$_class.prototype, "expenses"), $6d29d731f9635d66$var$_class.prototype), $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "expenseAllocations", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6d29d731f9635d66$var$_class.prototype, "expenseAllocations"), $6d29d731f9635d66$var$_class.prototype), $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "rates", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6d29d731f9635d66$var$_class.prototype, "rates"), $6d29d731f9635d66$var$_class.prototype), $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "tasks", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6d29d731f9635d66$var$_class.prototype, "tasks"), $6d29d731f9635d66$var$_class.prototype), $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "budgets", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6d29d731f9635d66$var$_class.prototype, "budgets"), $6d29d731f9635d66$var$_class.prototype), $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "hoursFromBudgets", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6d29d731f9635d66$var$_class.prototype, "hoursFromBudgets"), $6d29d731f9635d66$var$_class.prototype), $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "costFromBudgets", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6d29d731f9635d66$var$_class.prototype, "costFromBudgets"), $6d29d731f9635d66$var$_class.prototype), $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "budgetedStaff", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6d29d731f9635d66$var$_class.prototype, "budgetedStaff"), $6d29d731f9635d66$var$_class.prototype), $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "budgetedRoles", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6d29d731f9635d66$var$_class.prototype, "budgetedRoles"), $6d29d731f9635d66$var$_class.prototype), $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "duration", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6d29d731f9635d66$var$_class.prototype, "duration"), $6d29d731f9635d66$var$_class.prototype), $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "invoiceLineItems", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6d29d731f9635d66$var$_class.prototype, "invoiceLineItems"), $6d29d731f9635d66$var$_class.prototype), $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "timeEntries", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6d29d731f9635d66$var$_class.prototype, "timeEntries"), $6d29d731f9635d66$var$_class.prototype), $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "getAggregateInvoiceLineItems", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($6d29d731f9635d66$var$_class.prototype, "getAggregateInvoiceLineItems"), $6d29d731f9635d66$var$_class.prototype), $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "getAggregateTimeEntries", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($6d29d731f9635d66$var$_class.prototype, "getAggregateTimeEntries"), $6d29d731f9635d66$var$_class.prototype), $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "revenueTargets", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6d29d731f9635d66$var$_class.prototype, "revenueTargets"), $6d29d731f9635d66$var$_class.prototype), $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "costCentre", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6d29d731f9635d66$var$_class.prototype, "costCentre"), $6d29d731f9635d66$var$_class.prototype), $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "contact", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6d29d731f9635d66$var$_class.prototype, "contact"), $6d29d731f9635d66$var$_class.prototype), $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "primaryContact", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6d29d731f9635d66$var$_class.prototype, "primaryContact"), $6d29d731f9635d66$var$_class.prototype), $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "owner", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6d29d731f9635d66$var$_class.prototype, "owner"), $6d29d731f9635d66$var$_class.prototype), $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "notes", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6d29d731f9635d66$var$_class.prototype, "notes"), $6d29d731f9635d66$var$_class.prototype), $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "changeLog", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6d29d731f9635d66$var$_class.prototype, "changeLog"), $6d29d731f9635d66$var$_class.prototype), $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "updateDuration", [
    $6d29d731f9635d66$var$_dec
], Object.getOwnPropertyDescriptor($6d29d731f9635d66$var$_class.prototype, "updateDuration"), $6d29d731f9635d66$var$_class.prototype), $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "hasDates", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6d29d731f9635d66$var$_class.prototype, "hasDates"), $6d29d731f9635d66$var$_class.prototype), $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "isCurrent", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6d29d731f9635d66$var$_class.prototype, "isCurrent"), $6d29d731f9635d66$var$_class.prototype), $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "hasEnded", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6d29d731f9635d66$var$_class.prototype, "hasEnded"), $6d29d731f9635d66$var$_class.prototype), $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "updateBudgets", [
    $6d29d731f9635d66$var$_dec2
], Object.getOwnPropertyDescriptor($6d29d731f9635d66$var$_class.prototype, "updateBudgets"), $6d29d731f9635d66$var$_class.prototype), $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "updateFromBudgets", [
    $6d29d731f9635d66$var$_dec3
], Object.getOwnPropertyDescriptor($6d29d731f9635d66$var$_class.prototype, "updateFromBudgets"), $6d29d731f9635d66$var$_class.prototype), $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "feeAdjustedByLikelihood", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6d29d731f9635d66$var$_class.prototype, "feeAdjustedByLikelihood"), $6d29d731f9635d66$var$_class.prototype), $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "defaultTask", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6d29d731f9635d66$var$_class.prototype, "defaultTask"), $6d29d731f9635d66$var$_class.prototype), $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "costRate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6d29d731f9635d66$var$_class.prototype, "costRate"), $6d29d731f9635d66$var$_class.prototype), $6d29d731f9635d66$var$_applyDecoratedDescriptor($6d29d731f9635d66$var$_class.prototype, "chargeOutRate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6d29d731f9635d66$var$_class.prototype, "chargeOutRate"), $6d29d731f9635d66$var$_class.prototype), $6d29d731f9635d66$var$_class);
var $6d29d731f9635d66$export$2e2bcd8739ae039 = $6d29d731f9635d66$var$PhaseModel;

});
parcelRegister("9VnJj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $739bd829ae7cd8b1$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "DailyAllocationCollectionClass", function () { return $739bd829ae7cd8b1$export$790db561260f3e4; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $d4CwR = parcelRequire("d4CwR");

var $f44xu = parcelRequire("f44xu");
var $739bd829ae7cd8b1$var$_dec, $739bd829ae7cd8b1$var$_dec2, $739bd829ae7cd8b1$var$_class;
function $739bd829ae7cd8b1$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $739bd829ae7cd8b1$var$DailyAllocationCollection = ($739bd829ae7cd8b1$var$_dec = (0, $4JcCM.action).bound, $739bd829ae7cd8b1$var$_dec2 = (0, $4JcCM.action).bound, $739bd829ae7cd8b1$var$_class = class DailyAllocationCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "dailyAllocations",
            modelClass: (0, $d4CwR.default)
        });
        this.addLookup("dailyAllocationsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("dailyAllocationsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("dailyAllocationsByStaffId", "manyByKey", {
            key: (t)=>t.staffId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("dailyAllocationsByRoleId", "manyByKey", {
            key: (t)=>{
                var _t$staff;
                return t.roleId || ((_t$staff = t.staff) === null || _t$staff === void 0 ? void 0 : _t$staff.roleId);
            },
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("dailyAllocationsByTaskId", "manyByKey", {
            key: (t)=>t.taskId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("dailyAllocationsByCostCentreId", "manyByKey", {
            key: (t)=>t.costCentreId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("dailyAllocationsByStaffIdDate", "manyByKey", {
            key: (t)=>(0, $f44xu.default)(t.staffId, t.date.getTime()),
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("dailyAllocationsByStaffIdWeek", "manyByKey", {
            key: (t)=>{
                return (0, $f44xu.default)(t.staffId, t.week);
            },
            filter: (t)=>!t.deletedAt
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get dailyAllocationsById() {
        return this.modelsById;
    }
    get dailyAllocations() {
        return this.models;
    }
    get dailyAllocationsById() {
        return this.modelsById;
    }
    addDailyAllocation(data, options) {
        this.add(data, options);
    }
    addDailyAllocations(data, options) {
        this.addMany(data, options);
    }
}, $739bd829ae7cd8b1$var$_applyDecoratedDescriptor($739bd829ae7cd8b1$var$_class.prototype, "addDailyAllocation", [
    $739bd829ae7cd8b1$var$_dec
], Object.getOwnPropertyDescriptor($739bd829ae7cd8b1$var$_class.prototype, "addDailyAllocation"), $739bd829ae7cd8b1$var$_class.prototype), $739bd829ae7cd8b1$var$_applyDecoratedDescriptor($739bd829ae7cd8b1$var$_class.prototype, "addDailyAllocations", [
    $739bd829ae7cd8b1$var$_dec2
], Object.getOwnPropertyDescriptor($739bd829ae7cd8b1$var$_class.prototype, "addDailyAllocations"), $739bd829ae7cd8b1$var$_class.prototype), $739bd829ae7cd8b1$var$_class);
var $739bd829ae7cd8b1$export$2e2bcd8739ae039 = new $739bd829ae7cd8b1$var$DailyAllocationCollection();
const $739bd829ae7cd8b1$export$790db561260f3e4 = $739bd829ae7cd8b1$var$DailyAllocationCollection;

});
parcelRegister("d4CwR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $984989218c09cc10$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $htkeB = parcelRequire("htkeB");

var $gJT7h = parcelRequire("gJT7h");

var $XoImS = parcelRequire("XoImS");

var $keGWP = parcelRequire("keGWP");

var $3PpOX = parcelRequire("3PpOX");

var $9VnJj = parcelRequire("9VnJj");

var $eNcHX = parcelRequire("eNcHX");

var $4hBm1 = parcelRequire("4hBm1");

var $bxXv3 = parcelRequire("bxXv3");
var $984989218c09cc10$var$_class, $984989218c09cc10$var$_descriptor, $984989218c09cc10$var$_descriptor2, $984989218c09cc10$var$_descriptor3, $984989218c09cc10$var$_descriptor4, $984989218c09cc10$var$_descriptor5, $984989218c09cc10$var$_descriptor6, $984989218c09cc10$var$_descriptor7, $984989218c09cc10$var$_descriptor8, $984989218c09cc10$var$_descriptor9, $984989218c09cc10$var$_descriptor10, $984989218c09cc10$var$_descriptor11, $984989218c09cc10$var$_descriptor12, $984989218c09cc10$var$_descriptor13, $984989218c09cc10$var$_descriptor14, $984989218c09cc10$var$_descriptor15, $984989218c09cc10$var$_descriptor16, $984989218c09cc10$var$_descriptor17, $984989218c09cc10$var$_descriptor18, $984989218c09cc10$var$_descriptor19, $984989218c09cc10$var$_descriptor20, $984989218c09cc10$var$_descriptor21;
function $984989218c09cc10$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $984989218c09cc10$var$_defineProperty(e, r, t) {
    return (r = $984989218c09cc10$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $984989218c09cc10$var$_toPropertyKey(t) {
    var i = $984989218c09cc10$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $984989218c09cc10$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $984989218c09cc10$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $984989218c09cc10$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $984989218c09cc10$var$DailyAllocationModel = ($984989218c09cc10$var$_class = class DailyAllocationModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $984989218c09cc10$var$_initializerDefineProperty(this, "staffId", $984989218c09cc10$var$_descriptor, this);
        $984989218c09cc10$var$_initializerDefineProperty(this, "roleId", $984989218c09cc10$var$_descriptor2, this);
        $984989218c09cc10$var$_initializerDefineProperty(this, "costCentreId", $984989218c09cc10$var$_descriptor3, this);
        $984989218c09cc10$var$_initializerDefineProperty(this, "projectId", $984989218c09cc10$var$_descriptor4, this);
        $984989218c09cc10$var$_initializerDefineProperty(this, "phaseId", $984989218c09cc10$var$_descriptor5, this);
        $984989218c09cc10$var$_initializerDefineProperty(this, "taskId", $984989218c09cc10$var$_descriptor6, this);
        $984989218c09cc10$var$_initializerDefineProperty(this, "date", $984989218c09cc10$var$_descriptor7, this);
        $984989218c09cc10$var$_initializerDefineProperty(this, "numMinutes", $984989218c09cc10$var$_descriptor8, this);
        $984989218c09cc10$var$_initializerDefineProperty(this, "startMinutes", $984989218c09cc10$var$_descriptor9, this);
        $984989218c09cc10$var$_initializerDefineProperty(this, "pay", $984989218c09cc10$var$_descriptor10, this);
        $984989218c09cc10$var$_initializerDefineProperty(this, "cost", $984989218c09cc10$var$_descriptor11, this);
        $984989218c09cc10$var$_initializerDefineProperty(this, "charge_out", $984989218c09cc10$var$_descriptor12, this);
        $984989218c09cc10$var$_initializerDefineProperty(this, "isBillable", $984989218c09cc10$var$_descriptor13, this);
        $984989218c09cc10$var$_initializerDefineProperty(this, "isVariation", $984989218c09cc10$var$_descriptor14, this);
        $984989218c09cc10$var$_initializerDefineProperty(this, "isOvertime", $984989218c09cc10$var$_descriptor15, this);
        $984989218c09cc10$var$_initializerDefineProperty(this, "beenInvoiced", $984989218c09cc10$var$_descriptor16, this);
        $984989218c09cc10$var$_initializerDefineProperty(this, "flexi", $984989218c09cc10$var$_descriptor17, this);
        $984989218c09cc10$var$_initializerDefineProperty(this, "remote", $984989218c09cc10$var$_descriptor18, this);
        $984989218c09cc10$var$_initializerDefineProperty(this, "isLocked", $984989218c09cc10$var$_descriptor19, this);
        $984989218c09cc10$var$_initializerDefineProperty(this, "notes", $984989218c09cc10$var$_descriptor20, this);
        $984989218c09cc10$var$_initializerDefineProperty(this, "deleted", $984989218c09cc10$var$_descriptor21, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $9VnJj.default);
        this.init(data, options);
    }
    get staff() {
        return (0, $htkeB.default).staffsById[this.staffId];
    }
    get role() {
        var _this$staff;
        return (0, $bxXv3.default).rolesById[this.roleId] || ((_this$staff = this.staff) === null || _this$staff === void 0 ? void 0 : _this$staff.role);
    }
    get costCentre() {
        return (0, $eNcHX.default).modelsById[this.costCentreId] || this.project.costCentre;
    }
    get project() {
        return (0, $gJT7h.default).modelsById[this.projectId];
    }
    get phase() {
        return (0, $XoImS.default).modelsById[this.phaseId];
    }
    get task() {
        return (0, $keGWP.default).modelsById[this.taskId];
    }
    get endMinutes() {
        return this.startMinutes + this.numMinutes;
    }
    get hours() {
        return this.numMinutes / 60;
    }
    get payRate() {
        return this.pay / this.hours;
    }
    get costRate() {
        return this.cost / this.hours;
    }
    get chargeOutRate() {
        return this.chargeOut / this.hours;
    }
    // @computed
    // get pay() {
    //     return this.payRate * this.hours
    // }
    // @computed
    // get cost() {
    //     return this.costRate * this.hours
    // }
    // @computed
    // get chargeOut() {
    //     return this.chargeOutRate * this.hours
    // }
    get week() {
        return (0, $4hBm1.getWeek)(this.date, {
            weekStartsOn: 1
        });
    }
    get month() {
        return (0, $4hBm1.getMonth)(this.date);
    }
    get likelihood() {
        var _this$phase;
        return ((_this$phase = this.phase) === null || _this$phase === void 0 ? void 0 : _this$phase.likelihood) || 100;
    }
}, $984989218c09cc10$var$_descriptor = $984989218c09cc10$var$_applyDecoratedDescriptor($984989218c09cc10$var$_class.prototype, "staffId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $984989218c09cc10$var$_descriptor2 = $984989218c09cc10$var$_applyDecoratedDescriptor($984989218c09cc10$var$_class.prototype, "roleId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $984989218c09cc10$var$_descriptor3 = $984989218c09cc10$var$_applyDecoratedDescriptor($984989218c09cc10$var$_class.prototype, "costCentreId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $984989218c09cc10$var$_descriptor4 = $984989218c09cc10$var$_applyDecoratedDescriptor($984989218c09cc10$var$_class.prototype, "projectId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $984989218c09cc10$var$_descriptor5 = $984989218c09cc10$var$_applyDecoratedDescriptor($984989218c09cc10$var$_class.prototype, "phaseId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $984989218c09cc10$var$_descriptor6 = $984989218c09cc10$var$_applyDecoratedDescriptor($984989218c09cc10$var$_class.prototype, "taskId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $984989218c09cc10$var$_descriptor7 = $984989218c09cc10$var$_applyDecoratedDescriptor($984989218c09cc10$var$_class.prototype, "date", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Date();
    }
}), $984989218c09cc10$var$_descriptor8 = $984989218c09cc10$var$_applyDecoratedDescriptor($984989218c09cc10$var$_class.prototype, "numMinutes", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $984989218c09cc10$var$_descriptor9 = $984989218c09cc10$var$_applyDecoratedDescriptor($984989218c09cc10$var$_class.prototype, "startMinutes", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $984989218c09cc10$var$_descriptor10 = $984989218c09cc10$var$_applyDecoratedDescriptor($984989218c09cc10$var$_class.prototype, "pay", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $984989218c09cc10$var$_descriptor11 = $984989218c09cc10$var$_applyDecoratedDescriptor($984989218c09cc10$var$_class.prototype, "cost", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $984989218c09cc10$var$_descriptor12 = $984989218c09cc10$var$_applyDecoratedDescriptor($984989218c09cc10$var$_class.prototype, "charge_out", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $984989218c09cc10$var$_descriptor13 = $984989218c09cc10$var$_applyDecoratedDescriptor($984989218c09cc10$var$_class.prototype, "isBillable", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $984989218c09cc10$var$_descriptor14 = $984989218c09cc10$var$_applyDecoratedDescriptor($984989218c09cc10$var$_class.prototype, "isVariation", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $984989218c09cc10$var$_descriptor15 = $984989218c09cc10$var$_applyDecoratedDescriptor($984989218c09cc10$var$_class.prototype, "isOvertime", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $984989218c09cc10$var$_descriptor16 = $984989218c09cc10$var$_applyDecoratedDescriptor($984989218c09cc10$var$_class.prototype, "beenInvoiced", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $984989218c09cc10$var$_descriptor17 = $984989218c09cc10$var$_applyDecoratedDescriptor($984989218c09cc10$var$_class.prototype, "flexi", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $984989218c09cc10$var$_descriptor18 = $984989218c09cc10$var$_applyDecoratedDescriptor($984989218c09cc10$var$_class.prototype, "remote", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $984989218c09cc10$var$_descriptor19 = $984989218c09cc10$var$_applyDecoratedDescriptor($984989218c09cc10$var$_class.prototype, "isLocked", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $984989218c09cc10$var$_descriptor20 = $984989218c09cc10$var$_applyDecoratedDescriptor($984989218c09cc10$var$_class.prototype, "notes", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "";
    }
}), $984989218c09cc10$var$_descriptor21 = $984989218c09cc10$var$_applyDecoratedDescriptor($984989218c09cc10$var$_class.prototype, "deleted", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $984989218c09cc10$var$_applyDecoratedDescriptor($984989218c09cc10$var$_class.prototype, "staff", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($984989218c09cc10$var$_class.prototype, "staff"), $984989218c09cc10$var$_class.prototype), $984989218c09cc10$var$_applyDecoratedDescriptor($984989218c09cc10$var$_class.prototype, "role", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($984989218c09cc10$var$_class.prototype, "role"), $984989218c09cc10$var$_class.prototype), $984989218c09cc10$var$_applyDecoratedDescriptor($984989218c09cc10$var$_class.prototype, "costCentre", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($984989218c09cc10$var$_class.prototype, "costCentre"), $984989218c09cc10$var$_class.prototype), $984989218c09cc10$var$_applyDecoratedDescriptor($984989218c09cc10$var$_class.prototype, "project", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($984989218c09cc10$var$_class.prototype, "project"), $984989218c09cc10$var$_class.prototype), $984989218c09cc10$var$_applyDecoratedDescriptor($984989218c09cc10$var$_class.prototype, "phase", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($984989218c09cc10$var$_class.prototype, "phase"), $984989218c09cc10$var$_class.prototype), $984989218c09cc10$var$_applyDecoratedDescriptor($984989218c09cc10$var$_class.prototype, "task", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($984989218c09cc10$var$_class.prototype, "task"), $984989218c09cc10$var$_class.prototype), $984989218c09cc10$var$_applyDecoratedDescriptor($984989218c09cc10$var$_class.prototype, "endMinutes", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($984989218c09cc10$var$_class.prototype, "endMinutes"), $984989218c09cc10$var$_class.prototype), $984989218c09cc10$var$_applyDecoratedDescriptor($984989218c09cc10$var$_class.prototype, "hours", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($984989218c09cc10$var$_class.prototype, "hours"), $984989218c09cc10$var$_class.prototype), $984989218c09cc10$var$_applyDecoratedDescriptor($984989218c09cc10$var$_class.prototype, "payRate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($984989218c09cc10$var$_class.prototype, "payRate"), $984989218c09cc10$var$_class.prototype), $984989218c09cc10$var$_applyDecoratedDescriptor($984989218c09cc10$var$_class.prototype, "costRate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($984989218c09cc10$var$_class.prototype, "costRate"), $984989218c09cc10$var$_class.prototype), $984989218c09cc10$var$_applyDecoratedDescriptor($984989218c09cc10$var$_class.prototype, "chargeOutRate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($984989218c09cc10$var$_class.prototype, "chargeOutRate"), $984989218c09cc10$var$_class.prototype), $984989218c09cc10$var$_applyDecoratedDescriptor($984989218c09cc10$var$_class.prototype, "week", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($984989218c09cc10$var$_class.prototype, "week"), $984989218c09cc10$var$_class.prototype), $984989218c09cc10$var$_applyDecoratedDescriptor($984989218c09cc10$var$_class.prototype, "month", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($984989218c09cc10$var$_class.prototype, "month"), $984989218c09cc10$var$_class.prototype), $984989218c09cc10$var$_applyDecoratedDescriptor($984989218c09cc10$var$_class.prototype, "likelihood", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($984989218c09cc10$var$_class.prototype, "likelihood"), $984989218c09cc10$var$_class.prototype), $984989218c09cc10$var$_class);
var $984989218c09cc10$export$2e2bcd8739ae039 = $984989218c09cc10$var$DailyAllocationModel;

});
parcelRegister("keGWP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebb66e02d0b6c861$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "TaskCollectionClass", function () { return $ebb66e02d0b6c861$export$ae76438fa4f4f36a; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $5sTo1 = parcelRequire("5sTo1");
var $ebb66e02d0b6c861$var$_dec, $ebb66e02d0b6c861$var$_dec2, $ebb66e02d0b6c861$var$_class;
function $ebb66e02d0b6c861$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $ebb66e02d0b6c861$var$TaskCollection = ($ebb66e02d0b6c861$var$_dec = (0, $4JcCM.action).bound, $ebb66e02d0b6c861$var$_dec2 = (0, $4JcCM.action).bound, $ebb66e02d0b6c861$var$_class = class TaskCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "tasks",
            modelClass: (0, $5sTo1.default)
        });
        this.addLookup("tasksByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("tasksByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get tasksById() {
        return this.modelsById;
    }
    get tasks() {
        return this.models;
    }
    addTask(data) {
        this.add(data);
    }
    addTasks(data) {
        this.addMany(data);
    }
}, $ebb66e02d0b6c861$var$_applyDecoratedDescriptor($ebb66e02d0b6c861$var$_class.prototype, "addTask", [
    $ebb66e02d0b6c861$var$_dec
], Object.getOwnPropertyDescriptor($ebb66e02d0b6c861$var$_class.prototype, "addTask"), $ebb66e02d0b6c861$var$_class.prototype), $ebb66e02d0b6c861$var$_applyDecoratedDescriptor($ebb66e02d0b6c861$var$_class.prototype, "addTasks", [
    $ebb66e02d0b6c861$var$_dec2
], Object.getOwnPropertyDescriptor($ebb66e02d0b6c861$var$_class.prototype, "addTasks"), $ebb66e02d0b6c861$var$_class.prototype), $ebb66e02d0b6c861$var$_class);
var $ebb66e02d0b6c861$export$2e2bcd8739ae039 = new $ebb66e02d0b6c861$var$TaskCollection();
const $ebb66e02d0b6c861$export$ae76438fa4f4f36a = $ebb66e02d0b6c861$var$TaskCollection;

});
parcelRegister("5sTo1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3faa87db40159aa0$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $9VnJj = parcelRequire("9VnJj");

var $XoImS = parcelRequire("XoImS");

var $gJT7h = parcelRequire("gJT7h");

var $keGWP = parcelRequire("keGWP");

var $QiMYe = parcelRequire("QiMYe");

var $3PpOX = parcelRequire("3PpOX");
var $3faa87db40159aa0$var$_class, $3faa87db40159aa0$var$_descriptor, $3faa87db40159aa0$var$_descriptor2, $3faa87db40159aa0$var$_descriptor3, $3faa87db40159aa0$var$_descriptor4, $3faa87db40159aa0$var$_descriptor5, $3faa87db40159aa0$var$_descriptor6;
function $3faa87db40159aa0$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $3faa87db40159aa0$var$_defineProperty(e, r, t) {
    return (r = $3faa87db40159aa0$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $3faa87db40159aa0$var$_toPropertyKey(t) {
    var i = $3faa87db40159aa0$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $3faa87db40159aa0$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $3faa87db40159aa0$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $3faa87db40159aa0$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $3faa87db40159aa0$var$TaskModel = ($3faa87db40159aa0$var$_class = class TaskModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $3faa87db40159aa0$var$_initializerDefineProperty(this, "name", $3faa87db40159aa0$var$_descriptor, this);
        $3faa87db40159aa0$var$_initializerDefineProperty(this, "isDefault", $3faa87db40159aa0$var$_descriptor2, this);
        $3faa87db40159aa0$var$_initializerDefineProperty(this, "isBillable", $3faa87db40159aa0$var$_descriptor3, this);
        $3faa87db40159aa0$var$_initializerDefineProperty(this, "isVariation", $3faa87db40159aa0$var$_descriptor4, this);
        $3faa87db40159aa0$var$_initializerDefineProperty(this, "projectId", $3faa87db40159aa0$var$_descriptor5, this);
        $3faa87db40159aa0$var$_initializerDefineProperty(this, "phaseId", $3faa87db40159aa0$var$_descriptor6, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $keGWP.default);
        this.init(data, options);
    }
    get dailyAllocations() {
        return (0, $9VnJj.default).dailyAllocationsByTaskId[this.id];
    }
    get timeEntries() {
        return (0, $QiMYe.default).timeEntriesByTaskId[this.id];
    }
    get phase() {
        return (0, $XoImS.default).phasesById[this.phaseId];
    }
    get project() {
        return (0, $gJT7h.default).projectsById[this.projectId];
    }
}, $3faa87db40159aa0$var$_descriptor = $3faa87db40159aa0$var$_applyDecoratedDescriptor($3faa87db40159aa0$var$_class.prototype, "name", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $3faa87db40159aa0$var$_descriptor2 = $3faa87db40159aa0$var$_applyDecoratedDescriptor($3faa87db40159aa0$var$_class.prototype, "isDefault", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $3faa87db40159aa0$var$_descriptor3 = $3faa87db40159aa0$var$_applyDecoratedDescriptor($3faa87db40159aa0$var$_class.prototype, "isBillable", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $3faa87db40159aa0$var$_descriptor4 = $3faa87db40159aa0$var$_applyDecoratedDescriptor($3faa87db40159aa0$var$_class.prototype, "isVariation", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $3faa87db40159aa0$var$_descriptor5 = $3faa87db40159aa0$var$_applyDecoratedDescriptor($3faa87db40159aa0$var$_class.prototype, "projectId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $3faa87db40159aa0$var$_descriptor6 = $3faa87db40159aa0$var$_applyDecoratedDescriptor($3faa87db40159aa0$var$_class.prototype, "phaseId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $3faa87db40159aa0$var$_applyDecoratedDescriptor($3faa87db40159aa0$var$_class.prototype, "dailyAllocations", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($3faa87db40159aa0$var$_class.prototype, "dailyAllocations"), $3faa87db40159aa0$var$_class.prototype), $3faa87db40159aa0$var$_applyDecoratedDescriptor($3faa87db40159aa0$var$_class.prototype, "timeEntries", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($3faa87db40159aa0$var$_class.prototype, "timeEntries"), $3faa87db40159aa0$var$_class.prototype), $3faa87db40159aa0$var$_applyDecoratedDescriptor($3faa87db40159aa0$var$_class.prototype, "phase", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($3faa87db40159aa0$var$_class.prototype, "phase"), $3faa87db40159aa0$var$_class.prototype), $3faa87db40159aa0$var$_applyDecoratedDescriptor($3faa87db40159aa0$var$_class.prototype, "project", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($3faa87db40159aa0$var$_class.prototype, "project"), $3faa87db40159aa0$var$_class.prototype), $3faa87db40159aa0$var$_class);
var $3faa87db40159aa0$export$2e2bcd8739ae039 = $3faa87db40159aa0$var$TaskModel;

});
parcelRegister("QiMYe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09d36e844f3ea71b$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "TimeEntryCollectionClass", function () { return $09d36e844f3ea71b$export$b87d50baeffb91d5; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $hfd05 = parcelRequire("hfd05");

var $f44xu = parcelRequire("f44xu");
var $09d36e844f3ea71b$var$_dec, $09d36e844f3ea71b$var$_dec2, $09d36e844f3ea71b$var$_class;
function $09d36e844f3ea71b$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $09d36e844f3ea71b$var$TimeEntryCollection = ($09d36e844f3ea71b$var$_dec = (0, $4JcCM.action).bound, $09d36e844f3ea71b$var$_dec2 = (0, $4JcCM.action).bound, $09d36e844f3ea71b$var$_class = class TimeEntryCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "timeEntries",
            modelClass: (0, $hfd05.default)
        });
        this.addLookup("timeEntriesByProjectId", "manyByKey", {
            key: (t)=>t === null || t === void 0 ? void 0 : t.projectId,
            filter: (t)=>!(t !== null && t !== void 0 && t.deletedAt)
        });
        this.addLookup("timeEntriesByPhaseId", "manyByKey", {
            key: (t)=>t === null || t === void 0 ? void 0 : t.phaseId,
            filter: (t)=>!(t !== null && t !== void 0 && t.deletedAt)
        });
        this.addLookup("timeEntriesByStaffId", "manyByKey", {
            key: (t)=>t === null || t === void 0 ? void 0 : t.staffId,
            filter: (t)=>!(t !== null && t !== void 0 && t.deletedAt)
        });
        this.addLookup("timeEntriesByRoleId", "manyByKey", {
            key: (t)=>{
                var _t$staff;
                return (t === null || t === void 0 ? void 0 : t.roleId) || (t === null || t === void 0 ? void 0 : (_t$staff = t.staff) === null || _t$staff === void 0 ? void 0 : _t$staff.roleId);
            },
            filter: (t)=>!(t !== null && t !== void 0 && t.deletedAt)
        });
        this.addLookup("timeEntriesByTaskId", "manyByKey", {
            key: (t)=>t === null || t === void 0 ? void 0 : t.taskId,
            filter: (t)=>!(t !== null && t !== void 0 && t.deletedAt)
        });
        this.addLookup("timeEntriesByCostCentreId", "manyByKey", {
            key: (t)=>t === null || t === void 0 ? void 0 : t.costCentreId,
            filter: (t)=>!(t !== null && t !== void 0 && t.deletedAt)
        });
        this.addLookup("timeEntriesByStaffIdDate", "manyByKey", {
            key: (t)=>{
                var _t$date;
                return (0, $f44xu.default)(t === null || t === void 0 ? void 0 : t.staffId, t === null || t === void 0 ? void 0 : (_t$date = t.date) === null || _t$date === void 0 ? void 0 : _t$date.getTime());
            },
            filter: (t)=>!(t !== null && t !== void 0 && t.deletedAt)
        });
        this.addLookup("timeEntriesByStaffIdWeek", "manyByKey", {
            key: (t)=>{
                return (0, $f44xu.default)(t === null || t === void 0 ? void 0 : t.staffId, t === null || t === void 0 ? void 0 : t.week);
            },
            filter: (t)=>!(t !== null && t !== void 0 && t.deletedAt)
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get timeEntriesById() {
        return this.modelsById;
    }
    get timeEntries() {
        return this.models;
    }
    addTimeEntry(data) {
        this.add(data);
    }
    addTimeEntries(data) {
        this.addMany(data);
    }
}, $09d36e844f3ea71b$var$_applyDecoratedDescriptor($09d36e844f3ea71b$var$_class.prototype, "addTimeEntry", [
    $09d36e844f3ea71b$var$_dec
], Object.getOwnPropertyDescriptor($09d36e844f3ea71b$var$_class.prototype, "addTimeEntry"), $09d36e844f3ea71b$var$_class.prototype), $09d36e844f3ea71b$var$_applyDecoratedDescriptor($09d36e844f3ea71b$var$_class.prototype, "addTimeEntries", [
    $09d36e844f3ea71b$var$_dec2
], Object.getOwnPropertyDescriptor($09d36e844f3ea71b$var$_class.prototype, "addTimeEntries"), $09d36e844f3ea71b$var$_class.prototype), $09d36e844f3ea71b$var$_class);
var $09d36e844f3ea71b$export$2e2bcd8739ae039 = new $09d36e844f3ea71b$var$TimeEntryCollection();
const $09d36e844f3ea71b$export$b87d50baeffb91d5 = $09d36e844f3ea71b$var$TimeEntryCollection;

});
parcelRegister("hfd05", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8ddebfb1b8fc0ec$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $htkeB = parcelRequire("htkeB");

var $gJT7h = parcelRequire("gJT7h");

var $XoImS = parcelRequire("XoImS");

var $keGWP = parcelRequire("keGWP");

var $3PpOX = parcelRequire("3PpOX");

var $QiMYe = parcelRequire("QiMYe");

var $eNcHX = parcelRequire("eNcHX");

var $4hBm1 = parcelRequire("4hBm1");

var $bxXv3 = parcelRequire("bxXv3");
var $c8ddebfb1b8fc0ec$var$_class, $c8ddebfb1b8fc0ec$var$_descriptor, $c8ddebfb1b8fc0ec$var$_descriptor2, $c8ddebfb1b8fc0ec$var$_descriptor3, $c8ddebfb1b8fc0ec$var$_descriptor4, $c8ddebfb1b8fc0ec$var$_descriptor5, $c8ddebfb1b8fc0ec$var$_descriptor6, $c8ddebfb1b8fc0ec$var$_descriptor7, $c8ddebfb1b8fc0ec$var$_descriptor8, $c8ddebfb1b8fc0ec$var$_descriptor9, $c8ddebfb1b8fc0ec$var$_descriptor10, $c8ddebfb1b8fc0ec$var$_descriptor11, $c8ddebfb1b8fc0ec$var$_descriptor12, $c8ddebfb1b8fc0ec$var$_descriptor13, $c8ddebfb1b8fc0ec$var$_descriptor14, $c8ddebfb1b8fc0ec$var$_descriptor15, $c8ddebfb1b8fc0ec$var$_descriptor16, $c8ddebfb1b8fc0ec$var$_descriptor17, $c8ddebfb1b8fc0ec$var$_descriptor18, $c8ddebfb1b8fc0ec$var$_descriptor19, $c8ddebfb1b8fc0ec$var$_descriptor20, $c8ddebfb1b8fc0ec$var$_descriptor21;
function $c8ddebfb1b8fc0ec$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $c8ddebfb1b8fc0ec$var$_defineProperty(e, r, t) {
    return (r = $c8ddebfb1b8fc0ec$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $c8ddebfb1b8fc0ec$var$_toPropertyKey(t) {
    var i = $c8ddebfb1b8fc0ec$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $c8ddebfb1b8fc0ec$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $c8ddebfb1b8fc0ec$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $c8ddebfb1b8fc0ec$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $c8ddebfb1b8fc0ec$var$TimeEntryModel = ($c8ddebfb1b8fc0ec$var$_class = class TimeEntryModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $c8ddebfb1b8fc0ec$var$_initializerDefineProperty(this, "staffId", $c8ddebfb1b8fc0ec$var$_descriptor, this);
        $c8ddebfb1b8fc0ec$var$_initializerDefineProperty(this, "roleId", $c8ddebfb1b8fc0ec$var$_descriptor2, this);
        $c8ddebfb1b8fc0ec$var$_initializerDefineProperty(this, "costCentreId", $c8ddebfb1b8fc0ec$var$_descriptor3, this);
        $c8ddebfb1b8fc0ec$var$_initializerDefineProperty(this, "projectId", $c8ddebfb1b8fc0ec$var$_descriptor4, this);
        $c8ddebfb1b8fc0ec$var$_initializerDefineProperty(this, "phaseId", $c8ddebfb1b8fc0ec$var$_descriptor5, this);
        $c8ddebfb1b8fc0ec$var$_initializerDefineProperty(this, "taskId", $c8ddebfb1b8fc0ec$var$_descriptor6, this);
        $c8ddebfb1b8fc0ec$var$_initializerDefineProperty(this, "date", $c8ddebfb1b8fc0ec$var$_descriptor7, this);
        $c8ddebfb1b8fc0ec$var$_initializerDefineProperty(this, "numMinutes", $c8ddebfb1b8fc0ec$var$_descriptor8, this);
        $c8ddebfb1b8fc0ec$var$_initializerDefineProperty(this, "startMinutes", $c8ddebfb1b8fc0ec$var$_descriptor9, this);
        $c8ddebfb1b8fc0ec$var$_initializerDefineProperty(this, "pay", $c8ddebfb1b8fc0ec$var$_descriptor10, this);
        $c8ddebfb1b8fc0ec$var$_initializerDefineProperty(this, "cost", $c8ddebfb1b8fc0ec$var$_descriptor11, this);
        $c8ddebfb1b8fc0ec$var$_initializerDefineProperty(this, "charge_out", $c8ddebfb1b8fc0ec$var$_descriptor12, this);
        $c8ddebfb1b8fc0ec$var$_initializerDefineProperty(this, "isBillable", $c8ddebfb1b8fc0ec$var$_descriptor13, this);
        $c8ddebfb1b8fc0ec$var$_initializerDefineProperty(this, "isVariation", $c8ddebfb1b8fc0ec$var$_descriptor14, this);
        $c8ddebfb1b8fc0ec$var$_initializerDefineProperty(this, "isOvertime", $c8ddebfb1b8fc0ec$var$_descriptor15, this);
        $c8ddebfb1b8fc0ec$var$_initializerDefineProperty(this, "beenInvoiced", $c8ddebfb1b8fc0ec$var$_descriptor16, this);
        $c8ddebfb1b8fc0ec$var$_initializerDefineProperty(this, "flexi", $c8ddebfb1b8fc0ec$var$_descriptor17, this);
        $c8ddebfb1b8fc0ec$var$_initializerDefineProperty(this, "remote", $c8ddebfb1b8fc0ec$var$_descriptor18, this);
        $c8ddebfb1b8fc0ec$var$_initializerDefineProperty(this, "isLocked", $c8ddebfb1b8fc0ec$var$_descriptor19, this);
        $c8ddebfb1b8fc0ec$var$_initializerDefineProperty(this, "notes", $c8ddebfb1b8fc0ec$var$_descriptor20, this);
        $c8ddebfb1b8fc0ec$var$_initializerDefineProperty(this, "deleted", $c8ddebfb1b8fc0ec$var$_descriptor21, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $QiMYe.default);
        this.init(data, options);
    }
    get staff() {
        return (0, $htkeB.default).modelsById[this.staffId];
    }
    get role() {
        var _this$staff;
        return (0, $bxXv3.default).rolesById[this.roleId] || ((_this$staff = this.staff) === null || _this$staff === void 0 ? void 0 : _this$staff.role);
    }
    get costCentre() {
        return (0, $eNcHX.default).modelsById[this.costCentreId];
    }
    get project() {
        return (0, $gJT7h.default).modelsById[this.projectId];
    }
    get phase() {
        return (0, $XoImS.default).modelsById[this.phaseId];
    }
    get task() {
        return (0, $keGWP.default).modelsById[this.taskId];
    }
    get endMinutes() {
        return this.startMinutes + this.numMinutes;
    }
    get hours() {
        return this.numMinutes / 60;
    }
    get payRate() {
        return this.pay / this.hours;
    }
    get costRate() {
        return this.cost / this.hours;
    }
    get chargeOutRate() {
        return this.chargeOut / this.hours;
    }
    // @computed
    // get pay() {
    //     return this.payRate * this.hours
    // }
    // @computed
    // get cost() {
    //     return this.costRate * this.hours
    // }
    // @computed
    // get chargeOut() {
    //     return this.chargeOutRate * this.hours
    // }
    get week() {
        return (0, $4hBm1.getWeek)(this.date, {
            weekStartsOn: 1
        });
    }
    get month() {
        return (0, $4hBm1.format)(this.date, "yyyy-MM");
    }
}, $c8ddebfb1b8fc0ec$var$_descriptor = $c8ddebfb1b8fc0ec$var$_applyDecoratedDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "staffId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c8ddebfb1b8fc0ec$var$_descriptor2 = $c8ddebfb1b8fc0ec$var$_applyDecoratedDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "roleId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c8ddebfb1b8fc0ec$var$_descriptor3 = $c8ddebfb1b8fc0ec$var$_applyDecoratedDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "costCentreId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c8ddebfb1b8fc0ec$var$_descriptor4 = $c8ddebfb1b8fc0ec$var$_applyDecoratedDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "projectId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c8ddebfb1b8fc0ec$var$_descriptor5 = $c8ddebfb1b8fc0ec$var$_applyDecoratedDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "phaseId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c8ddebfb1b8fc0ec$var$_descriptor6 = $c8ddebfb1b8fc0ec$var$_applyDecoratedDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "taskId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c8ddebfb1b8fc0ec$var$_descriptor7 = $c8ddebfb1b8fc0ec$var$_applyDecoratedDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "date", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c8ddebfb1b8fc0ec$var$_descriptor8 = $c8ddebfb1b8fc0ec$var$_applyDecoratedDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "numMinutes", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $c8ddebfb1b8fc0ec$var$_descriptor9 = $c8ddebfb1b8fc0ec$var$_applyDecoratedDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "startMinutes", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $c8ddebfb1b8fc0ec$var$_descriptor10 = $c8ddebfb1b8fc0ec$var$_applyDecoratedDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "pay", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $c8ddebfb1b8fc0ec$var$_descriptor11 = $c8ddebfb1b8fc0ec$var$_applyDecoratedDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "cost", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $c8ddebfb1b8fc0ec$var$_descriptor12 = $c8ddebfb1b8fc0ec$var$_applyDecoratedDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "charge_out", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $c8ddebfb1b8fc0ec$var$_descriptor13 = $c8ddebfb1b8fc0ec$var$_applyDecoratedDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "isBillable", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c8ddebfb1b8fc0ec$var$_descriptor14 = $c8ddebfb1b8fc0ec$var$_applyDecoratedDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "isVariation", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c8ddebfb1b8fc0ec$var$_descriptor15 = $c8ddebfb1b8fc0ec$var$_applyDecoratedDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "isOvertime", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c8ddebfb1b8fc0ec$var$_descriptor16 = $c8ddebfb1b8fc0ec$var$_applyDecoratedDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "beenInvoiced", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c8ddebfb1b8fc0ec$var$_descriptor17 = $c8ddebfb1b8fc0ec$var$_applyDecoratedDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "flexi", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c8ddebfb1b8fc0ec$var$_descriptor18 = $c8ddebfb1b8fc0ec$var$_applyDecoratedDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "remote", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c8ddebfb1b8fc0ec$var$_descriptor19 = $c8ddebfb1b8fc0ec$var$_applyDecoratedDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "isLocked", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c8ddebfb1b8fc0ec$var$_descriptor20 = $c8ddebfb1b8fc0ec$var$_applyDecoratedDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "notes", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "";
    }
}), $c8ddebfb1b8fc0ec$var$_descriptor21 = $c8ddebfb1b8fc0ec$var$_applyDecoratedDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "deleted", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $c8ddebfb1b8fc0ec$var$_applyDecoratedDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "staff", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "staff"), $c8ddebfb1b8fc0ec$var$_class.prototype), $c8ddebfb1b8fc0ec$var$_applyDecoratedDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "role", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "role"), $c8ddebfb1b8fc0ec$var$_class.prototype), $c8ddebfb1b8fc0ec$var$_applyDecoratedDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "costCentre", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "costCentre"), $c8ddebfb1b8fc0ec$var$_class.prototype), $c8ddebfb1b8fc0ec$var$_applyDecoratedDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "project", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "project"), $c8ddebfb1b8fc0ec$var$_class.prototype), $c8ddebfb1b8fc0ec$var$_applyDecoratedDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "phase", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "phase"), $c8ddebfb1b8fc0ec$var$_class.prototype), $c8ddebfb1b8fc0ec$var$_applyDecoratedDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "task", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "task"), $c8ddebfb1b8fc0ec$var$_class.prototype), $c8ddebfb1b8fc0ec$var$_applyDecoratedDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "endMinutes", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "endMinutes"), $c8ddebfb1b8fc0ec$var$_class.prototype), $c8ddebfb1b8fc0ec$var$_applyDecoratedDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "hours", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "hours"), $c8ddebfb1b8fc0ec$var$_class.prototype), $c8ddebfb1b8fc0ec$var$_applyDecoratedDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "payRate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "payRate"), $c8ddebfb1b8fc0ec$var$_class.prototype), $c8ddebfb1b8fc0ec$var$_applyDecoratedDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "costRate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "costRate"), $c8ddebfb1b8fc0ec$var$_class.prototype), $c8ddebfb1b8fc0ec$var$_applyDecoratedDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "chargeOutRate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "chargeOutRate"), $c8ddebfb1b8fc0ec$var$_class.prototype), $c8ddebfb1b8fc0ec$var$_applyDecoratedDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "week", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "week"), $c8ddebfb1b8fc0ec$var$_class.prototype), $c8ddebfb1b8fc0ec$var$_applyDecoratedDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "month", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c8ddebfb1b8fc0ec$var$_class.prototype, "month"), $c8ddebfb1b8fc0ec$var$_class.prototype), $c8ddebfb1b8fc0ec$var$_class);
var $c8ddebfb1b8fc0ec$export$2e2bcd8739ae039 = $c8ddebfb1b8fc0ec$var$TimeEntryModel;

});
parcelRegister("bxXv3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8680ee30457dcb0d$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "RoleCollectionClass", function () { return $8680ee30457dcb0d$export$864f7350f070dc1; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $9FgwP = parcelRequire("9FgwP");

var $dtlWt = parcelRequire("dtlWt");
var $8680ee30457dcb0d$var$_dec, $8680ee30457dcb0d$var$_dec2, $8680ee30457dcb0d$var$_dec3, $8680ee30457dcb0d$var$_class;
function $8680ee30457dcb0d$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $8680ee30457dcb0d$var$RoleCollection = ($8680ee30457dcb0d$var$_dec = (0, $4JcCM.action).bound, $8680ee30457dcb0d$var$_dec2 = (0, $4JcCM.action).bound, $8680ee30457dcb0d$var$_dec3 = (0, $4JcCM.action).bound, $8680ee30457dcb0d$var$_class = class RoleCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "roles",
            modelClass: (0, $9FgwP.default)
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get rolesById() {
        return this.modelsById;
    }
    get roles() {
        return this.models;
    }
    addRole(data) {
        this.add(data);
    }
    addRoles(data) {
        this.addMany(data);
    }
    createRole() {
        const role = this.add({
            name: "New Role"
        }, {
            trackUpdates: true
        });
        const rate = (0, $dtlWt.default).add({
            roleId: role.id,
            date: "2000-01-01",
            payRate: 0,
            costRate: 0,
            chargeOutRate: 0,
            overtimeRate: 0
        }, {
            trackUpdates: true
        });
        return role;
    }
}, $8680ee30457dcb0d$var$_applyDecoratedDescriptor($8680ee30457dcb0d$var$_class.prototype, "addRole", [
    $8680ee30457dcb0d$var$_dec
], Object.getOwnPropertyDescriptor($8680ee30457dcb0d$var$_class.prototype, "addRole"), $8680ee30457dcb0d$var$_class.prototype), $8680ee30457dcb0d$var$_applyDecoratedDescriptor($8680ee30457dcb0d$var$_class.prototype, "addRoles", [
    $8680ee30457dcb0d$var$_dec2
], Object.getOwnPropertyDescriptor($8680ee30457dcb0d$var$_class.prototype, "addRoles"), $8680ee30457dcb0d$var$_class.prototype), $8680ee30457dcb0d$var$_applyDecoratedDescriptor($8680ee30457dcb0d$var$_class.prototype, "createRole", [
    $8680ee30457dcb0d$var$_dec3
], Object.getOwnPropertyDescriptor($8680ee30457dcb0d$var$_class.prototype, "createRole"), $8680ee30457dcb0d$var$_class.prototype), $8680ee30457dcb0d$var$_class);
var $8680ee30457dcb0d$export$2e2bcd8739ae039 = new $8680ee30457dcb0d$var$RoleCollection();
const $8680ee30457dcb0d$export$864f7350f070dc1 = $8680ee30457dcb0d$var$RoleCollection;

});
parcelRegister("9FgwP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7094c39b7522bac3$export$2e2bcd8739ae039; });

var $8lBDl = parcelRequire("8lBDl");

var $4JcCM = parcelRequire("4JcCM");

var $bxXv3 = parcelRequire("bxXv3");

var $dtlWt = parcelRequire("dtlWt");

var $htkeB = parcelRequire("htkeB");

var $3PpOX = parcelRequire("3PpOX");

var $eat5C = parcelRequire("eat5C");

var $37AD0 = parcelRequire("37AD0");

var $MRmcQ = parcelRequire("MRmcQ");
var $7094c39b7522bac3$var$_class, $7094c39b7522bac3$var$_descriptor, $7094c39b7522bac3$var$_descriptor2, $7094c39b7522bac3$var$_descriptor3, $7094c39b7522bac3$var$_descriptor4, $7094c39b7522bac3$var$_descriptor5;
function $7094c39b7522bac3$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $7094c39b7522bac3$var$_defineProperty(e, r, t) {
    return (r = $7094c39b7522bac3$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $7094c39b7522bac3$var$_toPropertyKey(t) {
    var i = $7094c39b7522bac3$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $7094c39b7522bac3$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $7094c39b7522bac3$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $7094c39b7522bac3$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $7094c39b7522bac3$var$RoleModel = ($7094c39b7522bac3$var$_class = class RoleModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $7094c39b7522bac3$var$_initializerDefineProperty(this, "isArchived", $7094c39b7522bac3$var$_descriptor, this);
        $7094c39b7522bac3$var$_initializerDefineProperty(this, "avgPayRate", $7094c39b7522bac3$var$_descriptor2, this);
        $7094c39b7522bac3$var$_initializerDefineProperty(this, "avgOvertimeRate", $7094c39b7522bac3$var$_descriptor3, this);
        $7094c39b7522bac3$var$_initializerDefineProperty(this, "avgCostRate", $7094c39b7522bac3$var$_descriptor4, this);
        $7094c39b7522bac3$var$_initializerDefineProperty(this, "avgChargeOutRate", $7094c39b7522bac3$var$_descriptor5, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $bxXv3.default);
        this.init(data, options);
    }
    get rates() {
        return (0, $dtlWt.default).ratesByRoleId[this.id] || [];
    }
    get payRate() {
        return this.getRateAtDate("pay", new Date());
    }
    get overtimeRate() {
        return this.getRateAtDate("overtime", new Date());
    }
    get costRate() {
        return this.getRateAtDate("cost", new Date());
    }
    get chargeOutRate() {
        return this.getRateAtDate("chargeOut", new Date());
    }
    get staffAndRoleRates() {
        const ratesByDate = {};
        this.staff.filter((s)=>!s.deletedAt && !s.isArchived).flatMap((s)=>s.rates).forEach((r)=>{
            ratesByDate[r.date] = r;
        });
        this.rates.forEach((r)=>{
            ratesByDate[r.date] = r;
        });
        return Object.values(ratesByDate).sort((a, b)=>a.date - b.date);
    }
    get staff() {
        return (0, $htkeB.default).staffByRoleId[this.id] || [];
    }
    avgRateType(rateType) {
        return this["avg" + (0, $8lBDl.pascalCase)(rateType) + "Rate"];
    }
    getRateInDateRange(rateType, dateRange) {
        if (this.staff.filter((s)=>!s.inheritRateType(rateType)).length && this.avgRateType(rateType)) return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).mean(this.staff.filter((s)=>!s.inheritRateType(rateType) && !s.deletedAt && !s.isArchived).map((s)=>s.getRateInDateRange(rateType, dateRange)));
        return (0, $MRmcQ.default)(this.rates, rateType, dateRange);
    }
    getRateAtDate(rateType, date) {
        if (this.staff.filter((s)=>!s.inheritRateType(rateType) && !s.deletedAt && !s.isArchived).length && this.avgRateType(rateType)) return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).mean(this.staff.filter((s)=>!s.inheritRateType(rateType) && !s.deletedAt && !s.isArchived).map((s)=>s.getRateAtDate(rateType, date)).filter((v)=>v));
        return (0, $37AD0.default)(this.rates, rateType, date);
    }
    getAvailabilityInDateRange(dateRange) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.staff.map((s)=>s.getAvailabilityInDateRange(dateRange)));
    }
    getAvailabilityAtDate(date) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.staff.map((s)=>s.getAvailabilityAtDate(date)));
    }
}, $7094c39b7522bac3$var$_descriptor = $7094c39b7522bac3$var$_applyDecoratedDescriptor($7094c39b7522bac3$var$_class.prototype, "isArchived", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $7094c39b7522bac3$var$_descriptor2 = $7094c39b7522bac3$var$_applyDecoratedDescriptor($7094c39b7522bac3$var$_class.prototype, "avgPayRate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $7094c39b7522bac3$var$_descriptor3 = $7094c39b7522bac3$var$_applyDecoratedDescriptor($7094c39b7522bac3$var$_class.prototype, "avgOvertimeRate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $7094c39b7522bac3$var$_descriptor4 = $7094c39b7522bac3$var$_applyDecoratedDescriptor($7094c39b7522bac3$var$_class.prototype, "avgCostRate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $7094c39b7522bac3$var$_descriptor5 = $7094c39b7522bac3$var$_applyDecoratedDescriptor($7094c39b7522bac3$var$_class.prototype, "avgChargeOutRate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $7094c39b7522bac3$var$_applyDecoratedDescriptor($7094c39b7522bac3$var$_class.prototype, "rates", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($7094c39b7522bac3$var$_class.prototype, "rates"), $7094c39b7522bac3$var$_class.prototype), $7094c39b7522bac3$var$_applyDecoratedDescriptor($7094c39b7522bac3$var$_class.prototype, "payRate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($7094c39b7522bac3$var$_class.prototype, "payRate"), $7094c39b7522bac3$var$_class.prototype), $7094c39b7522bac3$var$_applyDecoratedDescriptor($7094c39b7522bac3$var$_class.prototype, "overtimeRate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($7094c39b7522bac3$var$_class.prototype, "overtimeRate"), $7094c39b7522bac3$var$_class.prototype), $7094c39b7522bac3$var$_applyDecoratedDescriptor($7094c39b7522bac3$var$_class.prototype, "costRate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($7094c39b7522bac3$var$_class.prototype, "costRate"), $7094c39b7522bac3$var$_class.prototype), $7094c39b7522bac3$var$_applyDecoratedDescriptor($7094c39b7522bac3$var$_class.prototype, "chargeOutRate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($7094c39b7522bac3$var$_class.prototype, "chargeOutRate"), $7094c39b7522bac3$var$_class.prototype), $7094c39b7522bac3$var$_applyDecoratedDescriptor($7094c39b7522bac3$var$_class.prototype, "staffAndRoleRates", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($7094c39b7522bac3$var$_class.prototype, "staffAndRoleRates"), $7094c39b7522bac3$var$_class.prototype), $7094c39b7522bac3$var$_applyDecoratedDescriptor($7094c39b7522bac3$var$_class.prototype, "staff", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($7094c39b7522bac3$var$_class.prototype, "staff"), $7094c39b7522bac3$var$_class.prototype), $7094c39b7522bac3$var$_class);
var $7094c39b7522bac3$export$2e2bcd8739ae039 = $7094c39b7522bac3$var$RoleModel;

});
parcelRegister("dtlWt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9cef0104e6a45144$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "RoleRateCollectionClass", function () { return $9cef0104e6a45144$export$620868d49ddd222e; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $jWHb4 = parcelRequire("jWHb4");
var $9cef0104e6a45144$var$_dec, $9cef0104e6a45144$var$_dec2, $9cef0104e6a45144$var$_class;
function $9cef0104e6a45144$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $9cef0104e6a45144$var$RoleRateCollection = ($9cef0104e6a45144$var$_dec = (0, $4JcCM.action).bound, $9cef0104e6a45144$var$_dec2 = (0, $4JcCM.action).bound, $9cef0104e6a45144$var$_class = class RoleRateCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "roleRates",
            modelClass: (0, $jWHb4.default)
        });
        this.addLookup("ratesByRoleId", "manyByKey", {
            key: (t)=>t.roleId,
            filter: (t)=>!t.deletedAt
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get roleRatesById() {
        return this.modelsById;
    }
    get roleRates() {
        return this.models;
    }
    addRoleRate(data) {
        this.add(data);
    }
    addRoleRates(data) {
        this.addMany(data);
    }
}, $9cef0104e6a45144$var$_applyDecoratedDescriptor($9cef0104e6a45144$var$_class.prototype, "addRoleRate", [
    $9cef0104e6a45144$var$_dec
], Object.getOwnPropertyDescriptor($9cef0104e6a45144$var$_class.prototype, "addRoleRate"), $9cef0104e6a45144$var$_class.prototype), $9cef0104e6a45144$var$_applyDecoratedDescriptor($9cef0104e6a45144$var$_class.prototype, "addRoleRates", [
    $9cef0104e6a45144$var$_dec2
], Object.getOwnPropertyDescriptor($9cef0104e6a45144$var$_class.prototype, "addRoleRates"), $9cef0104e6a45144$var$_class.prototype), $9cef0104e6a45144$var$_class);
var $9cef0104e6a45144$export$2e2bcd8739ae039 = new $9cef0104e6a45144$var$RoleRateCollection();
const $9cef0104e6a45144$export$620868d49ddd222e = $9cef0104e6a45144$var$RoleRateCollection;

});
parcelRegister("jWHb4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e854ed49afb3bb22$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $bxXv3 = parcelRequire("bxXv3");

var $dtlWt = parcelRequire("dtlWt");

var $3PpOX = parcelRequire("3PpOX");
var $e854ed49afb3bb22$var$_class, $e854ed49afb3bb22$var$_descriptor, $e854ed49afb3bb22$var$_descriptor2, $e854ed49afb3bb22$var$_descriptor3, $e854ed49afb3bb22$var$_descriptor4, $e854ed49afb3bb22$var$_descriptor5, $e854ed49afb3bb22$var$_descriptor6;
function $e854ed49afb3bb22$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $e854ed49afb3bb22$var$_defineProperty(e, r, t) {
    return (r = $e854ed49afb3bb22$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $e854ed49afb3bb22$var$_toPropertyKey(t) {
    var i = $e854ed49afb3bb22$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $e854ed49afb3bb22$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $e854ed49afb3bb22$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $e854ed49afb3bb22$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $e854ed49afb3bb22$var$RoleRateModel = ($e854ed49afb3bb22$var$_class = class RoleRateModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $e854ed49afb3bb22$var$_initializerDefineProperty(this, "roleId", $e854ed49afb3bb22$var$_descriptor, this);
        $e854ed49afb3bb22$var$_initializerDefineProperty(this, "date", $e854ed49afb3bb22$var$_descriptor2, this);
        $e854ed49afb3bb22$var$_initializerDefineProperty(this, "payRate", $e854ed49afb3bb22$var$_descriptor3, this);
        $e854ed49afb3bb22$var$_initializerDefineProperty(this, "costRate", $e854ed49afb3bb22$var$_descriptor4, this);
        $e854ed49afb3bb22$var$_initializerDefineProperty(this, "chargeOutRate", $e854ed49afb3bb22$var$_descriptor5, this);
        $e854ed49afb3bb22$var$_initializerDefineProperty(this, "overtimeRate", $e854ed49afb3bb22$var$_descriptor6, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $dtlWt.default);
        this.init(data, options);
    }
    get role() {
        return (0, $bxXv3.default).modelsById[this.roleId];
    }
}, $e854ed49afb3bb22$var$_descriptor = $e854ed49afb3bb22$var$_applyDecoratedDescriptor($e854ed49afb3bb22$var$_class.prototype, "roleId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $e854ed49afb3bb22$var$_descriptor2 = $e854ed49afb3bb22$var$_applyDecoratedDescriptor($e854ed49afb3bb22$var$_class.prototype, "date", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $e854ed49afb3bb22$var$_descriptor3 = $e854ed49afb3bb22$var$_applyDecoratedDescriptor($e854ed49afb3bb22$var$_class.prototype, "payRate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $e854ed49afb3bb22$var$_descriptor4 = $e854ed49afb3bb22$var$_applyDecoratedDescriptor($e854ed49afb3bb22$var$_class.prototype, "costRate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $e854ed49afb3bb22$var$_descriptor5 = $e854ed49afb3bb22$var$_applyDecoratedDescriptor($e854ed49afb3bb22$var$_class.prototype, "chargeOutRate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $e854ed49afb3bb22$var$_descriptor6 = $e854ed49afb3bb22$var$_applyDecoratedDescriptor($e854ed49afb3bb22$var$_class.prototype, "overtimeRate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $e854ed49afb3bb22$var$_applyDecoratedDescriptor($e854ed49afb3bb22$var$_class.prototype, "role", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($e854ed49afb3bb22$var$_class.prototype, "role"), $e854ed49afb3bb22$var$_class.prototype), $e854ed49afb3bb22$var$_class);
var $e854ed49afb3bb22$export$2e2bcd8739ae039 = $e854ed49afb3bb22$var$RoleRateModel;

});





parcelRegister("f44xu", function(module, exports) {

$parcel$export(module.exports, "tuple", function () { return $29607f66ebe6fcd4$export$65e3907585753458; });
$parcel$export(module.exports, "default", function () { return $29607f66ebe6fcd4$export$2e2bcd8739ae039; });
// Although `Symbol` is widely supported these days, we can safely fall
// back to using a non-enumerable string property without violating any
// assumptions elsewhere in the implementation.
var $29607f66ebe6fcd4$var$useSymbol = typeof Symbol === "function" && typeof Symbol.for === "function";
// Used to mark `tuple.prototype` so that all objects that inherit from
// any `tuple.prototype` object (there could be more than one) will test
// positive according to `tuple.isTuple`.
var $29607f66ebe6fcd4$var$brand = $29607f66ebe6fcd4$var$useSymbol ? Symbol.for("immutable-tuple") : "@@__IMMUTABLE_TUPLE__@@";
// Used to save a reference to the globally shared `UniversalWeakMap` that
// stores all known `tuple` objects.
var $29607f66ebe6fcd4$var$globalKey = $29607f66ebe6fcd4$var$useSymbol ? Symbol.for("immutable-tuple-root") : "@@__IMMUTABLE_TUPLE_ROOT__@@";
// Convenient helper for defining hidden immutable properties.
function $29607f66ebe6fcd4$var$def(obj, name, value, enumerable) {
    Object.defineProperty(obj, name, {
        value: value,
        enumerable: !!enumerable,
        writable: false,
        configurable: false
    });
    return value;
}
var $29607f66ebe6fcd4$var$freeze = Object.freeze || function(obj) {
    return obj;
};
function $29607f66ebe6fcd4$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) return false;
        case "function":
            return true;
        default:
            return false;
    }
}
// The `mustConvertThisToArray` value is true when the corresponding
// `Array` method does not attempt to modify `this`, which means we can
// pass a `tuple` object as `this` without first converting it to an
// `Array`.
function $29607f66ebe6fcd4$var$forEachArrayMethod(fn) {
    function call(name, mustConvertThisToArray) {
        var desc = Object.getOwnPropertyDescriptor(Array.prototype, name);
        fn(name, desc, !!mustConvertThisToArray);
    }
    call("every");
    call("filter");
    call("find");
    call("findIndex");
    call("forEach");
    call("includes");
    call("indexOf");
    call("join");
    call("lastIndexOf");
    call("map");
    call("reduce");
    call("reduceRight");
    call("slice");
    call("some");
    call("toLocaleString");
    call("toString");
    // The `reverse` and `sort` methods are usually destructive, but for
    // `tuple` objects they return a new `tuple` object that has been
    // appropriately reversed/sorted.
    call("reverse", true);
    call("sort", true);
    // Make `[...someTuple]` work.
    call($29607f66ebe6fcd4$var$useSymbol && Symbol.iterator || "@@iterator");
}
// A map data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var $29607f66ebe6fcd4$var$UniversalWeakMap = function UniversalWeakMap() {
    // Since a `WeakMap` cannot hold primitive values as keys, we need a
    // backup `Map` instance to hold primitive keys. Both `this._weakMap`
    // and `this._strongMap` are lazily initialized.
    this._weakMap = null;
    this._strongMap = null;
    this.data = null;
};
// Since `get` and `set` are the only methods used, that's all I've
// implemented here.
$29607f66ebe6fcd4$var$UniversalWeakMap.prototype.get = function get(key) {
    var map = this._getMap(key, false);
    if (map) return map.get(key);
};
$29607f66ebe6fcd4$var$UniversalWeakMap.prototype.set = function set(key, value) {
    this._getMap(key, true).set(key, value);
    // An actual `Map` or `WeakMap` would return `this` here, but
    // returning the `value` is more convenient for the `tuple`
    // implementation.
    return value;
};
$29607f66ebe6fcd4$var$UniversalWeakMap.prototype._getMap = function _getMap(key, canCreate) {
    if (!canCreate) return $29607f66ebe6fcd4$var$isObjRef(key) ? this._weakMap : this._strongMap;
    if ($29607f66ebe6fcd4$var$isObjRef(key)) return this._weakMap || (this._weakMap = new WeakMap);
    return this._strongMap || (this._strongMap = new Map);
};
// See [`universal-weak-map.js`](universal-weak-map.html).
// See [`util.js`](util.html).
// If this package is installed multiple times, there could be mutiple
// implementations of the `tuple` function with distinct `tuple.prototype`
// objects, but the shared pool of `tuple` objects must be the same across
// all implementations. While it would be ideal to use the `global`
// object, there's no reliable way to get the global object across all JS
// environments without using the `Function` constructor, so instead we
// use the global `Array` constructor as a shared namespace.
var $29607f66ebe6fcd4$var$root = Array[$29607f66ebe6fcd4$var$globalKey] || $29607f66ebe6fcd4$var$def(Array, $29607f66ebe6fcd4$var$globalKey, new $29607f66ebe6fcd4$var$UniversalWeakMap, false);
function $29607f66ebe6fcd4$export$dfc7155ac0343b8() {
    return $29607f66ebe6fcd4$export$90d439304ff38d15(arguments);
}
function $29607f66ebe6fcd4$export$90d439304ff38d15(array) {
    var node = $29607f66ebe6fcd4$var$root;
    // Because we are building a tree of *weak* maps, the tree will not
    // prevent objects in tuples from being garbage collected, since the
    // tree itself will be pruned over time when the corresponding `tuple`
    // objects become unreachable. In addition to internalization, this
    // property is a key advantage of the `immutable-tuple` package.
    var len = array.length;
    for(var i = 0; i < len; ++i){
        var item = array[i];
        node = node.get(item) || node.set(item, new $29607f66ebe6fcd4$var$UniversalWeakMap);
    }
    // Return node.data rather than node itself to prevent tampering with
    // the UniversalWeakMap tree.
    return node.data || (node.data = Object.create(null));
}
// See [`lookup.js`](lookup.html).
// See [`util.js`](util.html).
// When called with any number of arguments, this function returns an
// object that inherits from `tuple.prototype` and is guaranteed to be
// `===` any other `tuple` object that has exactly the same items. In
// computer science jargon, `tuple` instances are "internalized" or just
// "interned," which allows for constant-time equality checking, and makes
// it possible for tuple objects to be used as `Map` or `WeakMap` keys, or
// stored in a `Set`.
function $29607f66ebe6fcd4$export$65e3907585753458() {
    var arguments$1 = arguments;
    var node = $29607f66ebe6fcd4$export$dfc7155ac0343b8.apply(null, arguments);
    if (node.tuple) return node.tuple;
    var t = Object.create($29607f66ebe6fcd4$export$65e3907585753458.prototype);
    // Define immutable items with numeric indexes, and permanently fix the
    // `.length` property.
    var argc = arguments.length;
    for(var i = 0; i < argc; ++i)t[i] = arguments$1[i];
    $29607f66ebe6fcd4$var$def(t, "length", argc, false);
    // Remember this new `tuple` object so that we can return the same object
    // earlier next time.
    return $29607f66ebe6fcd4$var$freeze(node.tuple = t);
}
// Since the `immutable-tuple` package could be installed multiple times
// in an application, there is no guarantee that the `tuple` constructor
// or `tuple.prototype` will be unique, so `value instanceof tuple` is
// unreliable. Instead, to test if a value is a tuple, you should use
// `tuple.isTuple(value)`.
$29607f66ebe6fcd4$var$def($29607f66ebe6fcd4$export$65e3907585753458.prototype, $29607f66ebe6fcd4$var$brand, true, false);
function $29607f66ebe6fcd4$var$isTuple(that) {
    return !!(that && that[$29607f66ebe6fcd4$var$brand] === true);
}
$29607f66ebe6fcd4$export$65e3907585753458.isTuple = $29607f66ebe6fcd4$var$isTuple;
function $29607f66ebe6fcd4$var$toArray(tuple) {
    var array = [];
    var i = tuple.length;
    while(i--)array[i] = tuple[i];
    return array;
}
// Copy all generic non-destructive Array methods to `tuple.prototype`.
// This works because (for example) `Array.prototype.slice` can be invoked
// against any `Array`-like object.
$29607f66ebe6fcd4$var$forEachArrayMethod(function(name, desc, mustConvertThisToArray) {
    var method = desc && desc.value;
    if (typeof method === "function") {
        desc.value = function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            var result = method.apply(mustConvertThisToArray ? $29607f66ebe6fcd4$var$toArray(this) : this, args);
            // Of course, `tuple.prototype.slice` should return a `tuple` object,
            // not a new `Array`.
            return Array.isArray(result) ? $29607f66ebe6fcd4$export$65e3907585753458.apply(void 0, result) : result;
        };
        Object.defineProperty($29607f66ebe6fcd4$export$65e3907585753458.prototype, name, desc);
    }
});
// Like `Array.prototype.concat`, except for the extra effort required to
// convert any tuple arguments to arrays, so that
// ```
// tuple(1).concat(tuple(2), 3) === tuple(1, 2, 3)
// ```
var $29607f66ebe6fcd4$var$ref = Array.prototype;
var $29607f66ebe6fcd4$var$concat = $29607f66ebe6fcd4$var$ref.concat;
$29607f66ebe6fcd4$export$65e3907585753458.prototype.concat = function() {
    var args = [], len = arguments.length;
    while(len--)args[len] = arguments[len];
    return $29607f66ebe6fcd4$export$65e3907585753458.apply(void 0, $29607f66ebe6fcd4$var$concat.apply($29607f66ebe6fcd4$var$toArray(this), args.map(function(item) {
        return $29607f66ebe6fcd4$var$isTuple(item) ? $29607f66ebe6fcd4$var$toArray(item) : item;
    })));
};
var $29607f66ebe6fcd4$export$2e2bcd8739ae039 = $29607f66ebe6fcd4$export$65e3907585753458;

});






parcelRegister("cfp1m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8eaa4b610249e9cc$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "ProjectExpenseCollectionClass", function () { return $8eaa4b610249e9cc$export$c3a184893613313d; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $fZxja = parcelRequire("fZxja");
var $8eaa4b610249e9cc$var$_dec, $8eaa4b610249e9cc$var$_dec2, $8eaa4b610249e9cc$var$_class;
function $8eaa4b610249e9cc$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $8eaa4b610249e9cc$var$ProjectExpenseCollection = ($8eaa4b610249e9cc$var$_dec = (0, $4JcCM.action).bound, $8eaa4b610249e9cc$var$_dec2 = (0, $4JcCM.action).bound, $8eaa4b610249e9cc$var$_class = class ProjectExpenseCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "projectExpenses",
            modelClass: (0, $fZxja.default)
        });
        this.addLookup("expensesByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("expensesByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("expensesByName", "manyByKey", {
            key: (t)=>t.name,
            filter: (t)=>!t.deletedAt
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get projectExpensesById() {
        return this.modelsById;
    }
    get projectExpenses() {
        return this.models;
    }
    addProjectExpense(data) {
        this.add(data);
    }
    addProjectExpenses(data) {
        this.addMany(data);
    }
}, $8eaa4b610249e9cc$var$_applyDecoratedDescriptor($8eaa4b610249e9cc$var$_class.prototype, "addProjectExpense", [
    $8eaa4b610249e9cc$var$_dec
], Object.getOwnPropertyDescriptor($8eaa4b610249e9cc$var$_class.prototype, "addProjectExpense"), $8eaa4b610249e9cc$var$_class.prototype), $8eaa4b610249e9cc$var$_applyDecoratedDescriptor($8eaa4b610249e9cc$var$_class.prototype, "addProjectExpenses", [
    $8eaa4b610249e9cc$var$_dec2
], Object.getOwnPropertyDescriptor($8eaa4b610249e9cc$var$_class.prototype, "addProjectExpenses"), $8eaa4b610249e9cc$var$_class.prototype), $8eaa4b610249e9cc$var$_class);
var $8eaa4b610249e9cc$export$2e2bcd8739ae039 = new $8eaa4b610249e9cc$var$ProjectExpenseCollection();
const $8eaa4b610249e9cc$export$c3a184893613313d = $8eaa4b610249e9cc$var$ProjectExpenseCollection;

});
parcelRegister("fZxja", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba4663d319e0111b$export$2e2bcd8739ae039; });

var $4hBm1 = parcelRequire("4hBm1");

var $4JcCM = parcelRequire("4JcCM");

var $XoImS = parcelRequire("XoImS");

var $gJT7h = parcelRequire("gJT7h");

var $d4jhX = parcelRequire("d4jhX");

var $cfp1m = parcelRequire("cfp1m");

var $3PpOX = parcelRequire("3PpOX");

var $eat5C = parcelRequire("eat5C");

var $kRqe9 = parcelRequire("kRqe9");

var $2Zzii = parcelRequire("2Zzii");

var $evRPQ = parcelRequire("evRPQ");
var $ba4663d319e0111b$var$_class, $ba4663d319e0111b$var$_descriptor, $ba4663d319e0111b$var$_descriptor2, $ba4663d319e0111b$var$_descriptor3, $ba4663d319e0111b$var$_descriptor4, $ba4663d319e0111b$var$_descriptor5, $ba4663d319e0111b$var$_descriptor6, $ba4663d319e0111b$var$_descriptor7, $ba4663d319e0111b$var$_descriptor8, $ba4663d319e0111b$var$_descriptor9, $ba4663d319e0111b$var$_descriptor10, $ba4663d319e0111b$var$_descriptor11, $ba4663d319e0111b$var$_descriptor12;
function $ba4663d319e0111b$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $ba4663d319e0111b$var$_defineProperty(e, r, t) {
    return (r = $ba4663d319e0111b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ba4663d319e0111b$var$_toPropertyKey(t) {
    var i = $ba4663d319e0111b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $ba4663d319e0111b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $ba4663d319e0111b$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $ba4663d319e0111b$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $ba4663d319e0111b$var$ProjectExpenseModel = ($ba4663d319e0111b$var$_class = class ProjectExpenseModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $ba4663d319e0111b$var$_initializerDefineProperty(this, "projectId", $ba4663d319e0111b$var$_descriptor, this);
        $ba4663d319e0111b$var$_initializerDefineProperty(this, "phaseId", $ba4663d319e0111b$var$_descriptor2, this);
        $ba4663d319e0111b$var$_initializerDefineProperty(this, "supplierId", $ba4663d319e0111b$var$_descriptor3, this);
        $ba4663d319e0111b$var$_initializerDefineProperty(this, "name", $ba4663d319e0111b$var$_descriptor4, this);
        $ba4663d319e0111b$var$_initializerDefineProperty(this, "quantity", $ba4663d319e0111b$var$_descriptor5, this);
        $ba4663d319e0111b$var$_initializerDefineProperty(this, "unitCost", $ba4663d319e0111b$var$_descriptor6, this);
        $ba4663d319e0111b$var$_initializerDefineProperty(this, "billable", $ba4663d319e0111b$var$_descriptor7, this);
        $ba4663d319e0111b$var$_initializerDefineProperty(this, "cost", $ba4663d319e0111b$var$_descriptor8, this);
        $ba4663d319e0111b$var$_initializerDefineProperty(this, "startDate", $ba4663d319e0111b$var$_descriptor9, this);
        $ba4663d319e0111b$var$_initializerDefineProperty(this, "endDate", $ba4663d319e0111b$var$_descriptor10, this);
        $ba4663d319e0111b$var$_initializerDefineProperty(this, "beenInvoiced", $ba4663d319e0111b$var$_descriptor11, this);
        $ba4663d319e0111b$var$_initializerDefineProperty(this, "previousBilled", $ba4663d319e0111b$var$_descriptor12, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $cfp1m.default);
        this.init(data, options);
    }
    get project() {
        return (0, $gJT7h.default).modelsById[this.projectId];
    }
    get phase() {
        return (0, $XoImS.default).modelsById[this.phaseId];
    }
    get supplier() {
        return (0, $2Zzii.default).modelsById[this.supplierId];
    }
    get allocations() {
        return (0, $d4jhX.default).expenseAllocationsByExpenseId[this.id] || [];
    }
    get invoiceLineItems() {
        return (0, $kRqe9.default).lineItemsByExpenseId[this.id] || [];
    }
    get businessDays() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).max([
            (0, $4hBm1.differenceInBusinessDays)((0, $4hBm1.addDays)(this.endDate, 1), this.startDate),
            1
        ]);
    }
    get expenseItems() {
        return (0, $evRPQ.default).expenseItemsByExpenseId[this.id] || [];
    }
    costInDateRange(dateRange) {
        if (dateRange[0] > this.endDate) return 0;
        if (dateRange[1] < this.startDate) return 0;
        const businessDays = (0, $4hBm1.differenceInBusinessDays)((0, $4hBm1.addDays)((0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).min([
            dateRange[1],
            this.endDate
        ]), 1), (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).max([
            dateRange[0],
            this.startDate
        ]));
        const businessDayRatio = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).min([
            businessDays / this.businessDays,
            1
        ]);
        return businessDayRatio * this.cost;
    }
    allocatedCostInDateRange(dateRange) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.allocations.filter((a)=>a.date >= dateRange[0] && a.date <= dateRange[1]).map((a)=>a.amount));
    }
    allocatedCostInDateRangeAdjustedByLikelihood(dateRange) {
        var _this$phase, _this$phase2;
        const value = this.allocatedCostInDateRange(dateRange);
        if ([
            "prospective",
            "onHold"
        ].includes((_this$phase = this.phase) === null || _this$phase === void 0 ? void 0 : _this$phase.status) && ((_this$phase2 = this.phase) === null || _this$phase2 === void 0 ? void 0 : _this$phase2.percentLikelihood) != undefined) {
            var _this$phase$percentLi, _this$phase3;
            return value * Math.min(((_this$phase$percentLi = (_this$phase3 = this.phase) === null || _this$phase3 === void 0 ? void 0 : _this$phase3.percentLikelihood) !== null && _this$phase$percentLi !== void 0 ? _this$phase$percentLi : 100) / 100, 1);
        } else return value;
    }
    amountBilledInDateRange(dateRange) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.invoiceLineItems.filter((a)=>a.date >= dateRange[0] && a.date <= dateRange[1]).map((a)=>a.amount));
    }
}, $ba4663d319e0111b$var$_descriptor = $ba4663d319e0111b$var$_applyDecoratedDescriptor($ba4663d319e0111b$var$_class.prototype, "projectId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $ba4663d319e0111b$var$_descriptor2 = $ba4663d319e0111b$var$_applyDecoratedDescriptor($ba4663d319e0111b$var$_class.prototype, "phaseId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $ba4663d319e0111b$var$_descriptor3 = $ba4663d319e0111b$var$_applyDecoratedDescriptor($ba4663d319e0111b$var$_class.prototype, "supplierId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $ba4663d319e0111b$var$_descriptor4 = $ba4663d319e0111b$var$_applyDecoratedDescriptor($ba4663d319e0111b$var$_class.prototype, "name", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $ba4663d319e0111b$var$_descriptor5 = $ba4663d319e0111b$var$_applyDecoratedDescriptor($ba4663d319e0111b$var$_class.prototype, "quantity", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $ba4663d319e0111b$var$_descriptor6 = $ba4663d319e0111b$var$_applyDecoratedDescriptor($ba4663d319e0111b$var$_class.prototype, "unitCost", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $ba4663d319e0111b$var$_descriptor7 = $ba4663d319e0111b$var$_applyDecoratedDescriptor($ba4663d319e0111b$var$_class.prototype, "billable", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $ba4663d319e0111b$var$_descriptor8 = $ba4663d319e0111b$var$_applyDecoratedDescriptor($ba4663d319e0111b$var$_class.prototype, "cost", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $ba4663d319e0111b$var$_descriptor9 = $ba4663d319e0111b$var$_applyDecoratedDescriptor($ba4663d319e0111b$var$_class.prototype, "startDate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $ba4663d319e0111b$var$_descriptor10 = $ba4663d319e0111b$var$_applyDecoratedDescriptor($ba4663d319e0111b$var$_class.prototype, "endDate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $ba4663d319e0111b$var$_descriptor11 = $ba4663d319e0111b$var$_applyDecoratedDescriptor($ba4663d319e0111b$var$_class.prototype, "beenInvoiced", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $ba4663d319e0111b$var$_descriptor12 = $ba4663d319e0111b$var$_applyDecoratedDescriptor($ba4663d319e0111b$var$_class.prototype, "previousBilled", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $ba4663d319e0111b$var$_applyDecoratedDescriptor($ba4663d319e0111b$var$_class.prototype, "project", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($ba4663d319e0111b$var$_class.prototype, "project"), $ba4663d319e0111b$var$_class.prototype), $ba4663d319e0111b$var$_applyDecoratedDescriptor($ba4663d319e0111b$var$_class.prototype, "phase", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($ba4663d319e0111b$var$_class.prototype, "phase"), $ba4663d319e0111b$var$_class.prototype), $ba4663d319e0111b$var$_applyDecoratedDescriptor($ba4663d319e0111b$var$_class.prototype, "supplier", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($ba4663d319e0111b$var$_class.prototype, "supplier"), $ba4663d319e0111b$var$_class.prototype), $ba4663d319e0111b$var$_applyDecoratedDescriptor($ba4663d319e0111b$var$_class.prototype, "allocations", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($ba4663d319e0111b$var$_class.prototype, "allocations"), $ba4663d319e0111b$var$_class.prototype), $ba4663d319e0111b$var$_applyDecoratedDescriptor($ba4663d319e0111b$var$_class.prototype, "invoiceLineItems", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($ba4663d319e0111b$var$_class.prototype, "invoiceLineItems"), $ba4663d319e0111b$var$_class.prototype), $ba4663d319e0111b$var$_applyDecoratedDescriptor($ba4663d319e0111b$var$_class.prototype, "businessDays", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($ba4663d319e0111b$var$_class.prototype, "businessDays"), $ba4663d319e0111b$var$_class.prototype), $ba4663d319e0111b$var$_applyDecoratedDescriptor($ba4663d319e0111b$var$_class.prototype, "expenseItems", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($ba4663d319e0111b$var$_class.prototype, "expenseItems"), $ba4663d319e0111b$var$_class.prototype), $ba4663d319e0111b$var$_class);
var $ba4663d319e0111b$export$2e2bcd8739ae039 = $ba4663d319e0111b$var$ProjectExpenseModel;

});
parcelRegister("d4jhX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $983a9c6b57b6135f$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "ProjectExpenseAllocationCollectionClass", function () { return $983a9c6b57b6135f$export$62a818585501d2ca; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $hezkU = parcelRequire("hezkU");
var $983a9c6b57b6135f$var$_dec, $983a9c6b57b6135f$var$_dec2, $983a9c6b57b6135f$var$_class;
function $983a9c6b57b6135f$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $983a9c6b57b6135f$var$ProjectExpenseAllocationCollection = ($983a9c6b57b6135f$var$_dec = (0, $4JcCM.action).bound, $983a9c6b57b6135f$var$_dec2 = (0, $4JcCM.action).bound, $983a9c6b57b6135f$var$_class = class ProjectExpenseAllocationCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "projectExpenseAllocations",
            modelClass: (0, $hezkU.default)
        });
        this.addLookup("expenseAllocationsByExpenseId", "manyByKey", {
            key: (t)=>t.expenseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("expenseAllocationsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("expenseAllocationsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get projectExpenseAllocationsById() {
        return this.modelsById;
    }
    get projectExpenseAllocations() {
        return this.models;
    }
    addProjectExpenseAllocation(data) {
        this.add(data);
    }
    addProjectExpenseAllocations(data) {
        this.addMany(data);
    }
}, $983a9c6b57b6135f$var$_applyDecoratedDescriptor($983a9c6b57b6135f$var$_class.prototype, "addProjectExpenseAllocation", [
    $983a9c6b57b6135f$var$_dec
], Object.getOwnPropertyDescriptor($983a9c6b57b6135f$var$_class.prototype, "addProjectExpenseAllocation"), $983a9c6b57b6135f$var$_class.prototype), $983a9c6b57b6135f$var$_applyDecoratedDescriptor($983a9c6b57b6135f$var$_class.prototype, "addProjectExpenseAllocations", [
    $983a9c6b57b6135f$var$_dec2
], Object.getOwnPropertyDescriptor($983a9c6b57b6135f$var$_class.prototype, "addProjectExpenseAllocations"), $983a9c6b57b6135f$var$_class.prototype), $983a9c6b57b6135f$var$_class);
var $983a9c6b57b6135f$export$2e2bcd8739ae039 = new $983a9c6b57b6135f$var$ProjectExpenseAllocationCollection();
const $983a9c6b57b6135f$export$62a818585501d2ca = $983a9c6b57b6135f$var$ProjectExpenseAllocationCollection;

});
parcelRegister("hezkU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8bf2786da66fd49$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $XoImS = parcelRequire("XoImS");

var $gJT7h = parcelRequire("gJT7h");

var $d4jhX = parcelRequire("d4jhX");

var $cfp1m = parcelRequire("cfp1m");

var $3PpOX = parcelRequire("3PpOX");
var $c8bf2786da66fd49$var$_class, $c8bf2786da66fd49$var$_descriptor, $c8bf2786da66fd49$var$_descriptor2, $c8bf2786da66fd49$var$_descriptor3, $c8bf2786da66fd49$var$_descriptor4, $c8bf2786da66fd49$var$_descriptor5;
function $c8bf2786da66fd49$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $c8bf2786da66fd49$var$_defineProperty(e, r, t) {
    return (r = $c8bf2786da66fd49$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $c8bf2786da66fd49$var$_toPropertyKey(t) {
    var i = $c8bf2786da66fd49$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $c8bf2786da66fd49$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $c8bf2786da66fd49$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $c8bf2786da66fd49$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $c8bf2786da66fd49$var$ProjectExpenseAllocationModel = ($c8bf2786da66fd49$var$_class = class ProjectExpenseAllocationModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $c8bf2786da66fd49$var$_initializerDefineProperty(this, "projectId", $c8bf2786da66fd49$var$_descriptor, this);
        $c8bf2786da66fd49$var$_initializerDefineProperty(this, "phaseId", $c8bf2786da66fd49$var$_descriptor2, this);
        $c8bf2786da66fd49$var$_initializerDefineProperty(this, "expenseId", $c8bf2786da66fd49$var$_descriptor3, this);
        $c8bf2786da66fd49$var$_initializerDefineProperty(this, "date", $c8bf2786da66fd49$var$_descriptor4, this);
        $c8bf2786da66fd49$var$_initializerDefineProperty(this, "amount", $c8bf2786da66fd49$var$_descriptor5, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $d4jhX.default);
        this.init(data, options);
    }
    get project() {
        return (0, $gJT7h.default).modelsById[this.projectId];
    }
    get phase() {
        return (0, $XoImS.default).modelsById[this.phaseId];
    }
    get expense() {
        return (0, $cfp1m.default).modelsById[this.expenseId];
    }
}, $c8bf2786da66fd49$var$_descriptor = $c8bf2786da66fd49$var$_applyDecoratedDescriptor($c8bf2786da66fd49$var$_class.prototype, "projectId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c8bf2786da66fd49$var$_descriptor2 = $c8bf2786da66fd49$var$_applyDecoratedDescriptor($c8bf2786da66fd49$var$_class.prototype, "phaseId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c8bf2786da66fd49$var$_descriptor3 = $c8bf2786da66fd49$var$_applyDecoratedDescriptor($c8bf2786da66fd49$var$_class.prototype, "expenseId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c8bf2786da66fd49$var$_descriptor4 = $c8bf2786da66fd49$var$_applyDecoratedDescriptor($c8bf2786da66fd49$var$_class.prototype, "date", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c8bf2786da66fd49$var$_descriptor5 = $c8bf2786da66fd49$var$_applyDecoratedDescriptor($c8bf2786da66fd49$var$_class.prototype, "amount", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c8bf2786da66fd49$var$_applyDecoratedDescriptor($c8bf2786da66fd49$var$_class.prototype, "project", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c8bf2786da66fd49$var$_class.prototype, "project"), $c8bf2786da66fd49$var$_class.prototype), $c8bf2786da66fd49$var$_applyDecoratedDescriptor($c8bf2786da66fd49$var$_class.prototype, "phase", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c8bf2786da66fd49$var$_class.prototype, "phase"), $c8bf2786da66fd49$var$_class.prototype), $c8bf2786da66fd49$var$_applyDecoratedDescriptor($c8bf2786da66fd49$var$_class.prototype, "expense", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c8bf2786da66fd49$var$_class.prototype, "expense"), $c8bf2786da66fd49$var$_class.prototype), $c8bf2786da66fd49$var$_class);
var $c8bf2786da66fd49$export$2e2bcd8739ae039 = $c8bf2786da66fd49$var$ProjectExpenseAllocationModel;

});


parcelRegister("2Zzii", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22dca7f15f457c64$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "SupplierCollectionClass", function () { return $22dca7f15f457c64$export$5a8dcfc08959bb7; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $5NRoN = parcelRequire("5NRoN");
var $22dca7f15f457c64$var$_dec, $22dca7f15f457c64$var$_dec2, $22dca7f15f457c64$var$_class;
function $22dca7f15f457c64$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $22dca7f15f457c64$var$SupplierCollection = ($22dca7f15f457c64$var$_dec = (0, $4JcCM.action).bound, $22dca7f15f457c64$var$_dec2 = (0, $4JcCM.action).bound, $22dca7f15f457c64$var$_class = class SupplierCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "suppliers",
            modelClass: (0, $5NRoN.default)
        });
        this.addLookup("activeSuppliers", "list", {
            filter: (t)=>!t.deletedAt
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get suppliersById() {
        return this.modelsById;
    }
    get suppliers() {
        return this.models;
    }
    addSupplier(data) {
        this.add(data);
    }
    addSuppliers(data) {
        this.addMany(data);
    }
}, $22dca7f15f457c64$var$_applyDecoratedDescriptor($22dca7f15f457c64$var$_class.prototype, "addSupplier", [
    $22dca7f15f457c64$var$_dec
], Object.getOwnPropertyDescriptor($22dca7f15f457c64$var$_class.prototype, "addSupplier"), $22dca7f15f457c64$var$_class.prototype), $22dca7f15f457c64$var$_applyDecoratedDescriptor($22dca7f15f457c64$var$_class.prototype, "addSuppliers", [
    $22dca7f15f457c64$var$_dec2
], Object.getOwnPropertyDescriptor($22dca7f15f457c64$var$_class.prototype, "addSuppliers"), $22dca7f15f457c64$var$_class.prototype), $22dca7f15f457c64$var$_class);
var $22dca7f15f457c64$export$2e2bcd8739ae039 = new $22dca7f15f457c64$var$SupplierCollection();
const $22dca7f15f457c64$export$5a8dcfc08959bb7 = $22dca7f15f457c64$var$SupplierCollection;

});
parcelRegister("5NRoN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $439af34aa5996c56$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $2Zzii = parcelRequire("2Zzii");

var $3PpOX = parcelRequire("3PpOX");
var $439af34aa5996c56$var$_class, $439af34aa5996c56$var$_descriptor;
function $439af34aa5996c56$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $439af34aa5996c56$var$_defineProperty(e, r, t) {
    return (r = $439af34aa5996c56$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $439af34aa5996c56$var$_toPropertyKey(t) {
    var i = $439af34aa5996c56$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $439af34aa5996c56$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $439af34aa5996c56$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $439af34aa5996c56$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $439af34aa5996c56$var$SupplierModel = ($439af34aa5996c56$var$_class = class SupplierModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $439af34aa5996c56$var$_initializerDefineProperty(this, "name", $439af34aa5996c56$var$_descriptor, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $2Zzii.default);
        this.init(data, options);
    }
}, $439af34aa5996c56$var$_descriptor = $439af34aa5996c56$var$_applyDecoratedDescriptor($439af34aa5996c56$var$_class.prototype, "name", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $439af34aa5996c56$var$_class);
var $439af34aa5996c56$export$2e2bcd8739ae039 = $439af34aa5996c56$var$SupplierModel;

});


parcelRegister("evRPQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a90db87a937531e2$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "ProjectExpenseItemCollectionClass", function () { return $a90db87a937531e2$export$3b87e9d4226b3e21; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $4p5DK = parcelRequire("4p5DK");

var $f44xu = parcelRequire("f44xu");
var $a90db87a937531e2$var$_dec, $a90db87a937531e2$var$_dec2, $a90db87a937531e2$var$_class;
function $a90db87a937531e2$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $a90db87a937531e2$var$ProjectExpenseItemCollection = ($a90db87a937531e2$var$_dec = (0, $4JcCM.action).bound, $a90db87a937531e2$var$_dec2 = (0, $4JcCM.action).bound, $a90db87a937531e2$var$_class = class ProjectExpenseItemCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "projectExpenseItems",
            modelClass: (0, $4p5DK.default)
        });
        this.addLookup("expenseItemsByExpenseId", "manyByKey", {
            key: (t)=>t.expenseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("expenseItemsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("expenseItemsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("expenseItemsByStaffIdDate", "manyByKey", {
            key: (t)=>{
                var _t$date;
                return (0, $f44xu.tuple)(t === null || t === void 0 ? void 0 : t.staffId, t === null || t === void 0 ? void 0 : (_t$date = t.date) === null || _t$date === void 0 ? void 0 : _t$date.getTime());
            },
            filter: (t)=>!(t !== null && t !== void 0 && t.deletedAt)
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get projectExpenseItemsById() {
        return this.modelsById;
    }
    get projectExpenseItems() {
        return this.models;
    }
    addProjectExpenseItem(data) {
        this.add(data);
    }
    addProjectExpenseItems(data) {
        this.addMany(data);
    }
}, $a90db87a937531e2$var$_applyDecoratedDescriptor($a90db87a937531e2$var$_class.prototype, "addProjectExpenseItem", [
    $a90db87a937531e2$var$_dec
], Object.getOwnPropertyDescriptor($a90db87a937531e2$var$_class.prototype, "addProjectExpenseItem"), $a90db87a937531e2$var$_class.prototype), $a90db87a937531e2$var$_applyDecoratedDescriptor($a90db87a937531e2$var$_class.prototype, "addProjectExpenseItems", [
    $a90db87a937531e2$var$_dec2
], Object.getOwnPropertyDescriptor($a90db87a937531e2$var$_class.prototype, "addProjectExpenseItems"), $a90db87a937531e2$var$_class.prototype), $a90db87a937531e2$var$_class);
var $a90db87a937531e2$export$2e2bcd8739ae039 = new $a90db87a937531e2$var$ProjectExpenseItemCollection();
const $a90db87a937531e2$export$3b87e9d4226b3e21 = $a90db87a937531e2$var$ProjectExpenseItemCollection;

});
parcelRegister("4p5DK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $334ddf3cec080422$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $XoImS = parcelRequire("XoImS");

var $gJT7h = parcelRequire("gJT7h");

var $evRPQ = parcelRequire("evRPQ");

var $cfp1m = parcelRequire("cfp1m");

var $3PpOX = parcelRequire("3PpOX");
var $334ddf3cec080422$var$_class, $334ddf3cec080422$var$_descriptor, $334ddf3cec080422$var$_descriptor2, $334ddf3cec080422$var$_descriptor3, $334ddf3cec080422$var$_descriptor4, $334ddf3cec080422$var$_descriptor5, $334ddf3cec080422$var$_descriptor6, $334ddf3cec080422$var$_descriptor7, $334ddf3cec080422$var$_descriptor8, $334ddf3cec080422$var$_descriptor9, $334ddf3cec080422$var$_descriptor10;
function $334ddf3cec080422$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $334ddf3cec080422$var$_defineProperty(e, r, t) {
    return (r = $334ddf3cec080422$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $334ddf3cec080422$var$_toPropertyKey(t) {
    var i = $334ddf3cec080422$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $334ddf3cec080422$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $334ddf3cec080422$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $334ddf3cec080422$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $334ddf3cec080422$var$ProjectExpenseItemModel = ($334ddf3cec080422$var$_class = class ProjectExpenseItemModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $334ddf3cec080422$var$_initializerDefineProperty(this, "projectId", $334ddf3cec080422$var$_descriptor, this);
        $334ddf3cec080422$var$_initializerDefineProperty(this, "phaseId", $334ddf3cec080422$var$_descriptor2, this);
        $334ddf3cec080422$var$_initializerDefineProperty(this, "staffId", $334ddf3cec080422$var$_descriptor3, this);
        $334ddf3cec080422$var$_initializerDefineProperty(this, "expenseId", $334ddf3cec080422$var$_descriptor4, this);
        $334ddf3cec080422$var$_initializerDefineProperty(this, "date", $334ddf3cec080422$var$_descriptor5, this);
        $334ddf3cec080422$var$_initializerDefineProperty(this, "cost", $334ddf3cec080422$var$_descriptor6, this);
        $334ddf3cec080422$var$_initializerDefineProperty(this, "quantity", $334ddf3cec080422$var$_descriptor7, this);
        $334ddf3cec080422$var$_initializerDefineProperty(this, "description", $334ddf3cec080422$var$_descriptor8, this);
        $334ddf3cec080422$var$_initializerDefineProperty(this, "isLocked", $334ddf3cec080422$var$_descriptor9, this);
        $334ddf3cec080422$var$_initializerDefineProperty(this, "beenInvoiced", $334ddf3cec080422$var$_descriptor10, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $evRPQ.default);
        this.init(data, options);
    }
    get project() {
        return (0, $gJT7h.default).modelsById[this.projectId];
    }
    get phase() {
        return (0, $XoImS.default).modelsById[this.phaseId];
    }
    get expense() {
        return (0, $cfp1m.default).modelsById[this.expenseId];
    }
}, $334ddf3cec080422$var$_descriptor = $334ddf3cec080422$var$_applyDecoratedDescriptor($334ddf3cec080422$var$_class.prototype, "projectId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $334ddf3cec080422$var$_descriptor2 = $334ddf3cec080422$var$_applyDecoratedDescriptor($334ddf3cec080422$var$_class.prototype, "phaseId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $334ddf3cec080422$var$_descriptor3 = $334ddf3cec080422$var$_applyDecoratedDescriptor($334ddf3cec080422$var$_class.prototype, "staffId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $334ddf3cec080422$var$_descriptor4 = $334ddf3cec080422$var$_applyDecoratedDescriptor($334ddf3cec080422$var$_class.prototype, "expenseId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $334ddf3cec080422$var$_descriptor5 = $334ddf3cec080422$var$_applyDecoratedDescriptor($334ddf3cec080422$var$_class.prototype, "date", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $334ddf3cec080422$var$_descriptor6 = $334ddf3cec080422$var$_applyDecoratedDescriptor($334ddf3cec080422$var$_class.prototype, "cost", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $334ddf3cec080422$var$_descriptor7 = $334ddf3cec080422$var$_applyDecoratedDescriptor($334ddf3cec080422$var$_class.prototype, "quantity", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $334ddf3cec080422$var$_descriptor8 = $334ddf3cec080422$var$_applyDecoratedDescriptor($334ddf3cec080422$var$_class.prototype, "description", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $334ddf3cec080422$var$_descriptor9 = $334ddf3cec080422$var$_applyDecoratedDescriptor($334ddf3cec080422$var$_class.prototype, "isLocked", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $334ddf3cec080422$var$_descriptor10 = $334ddf3cec080422$var$_applyDecoratedDescriptor($334ddf3cec080422$var$_class.prototype, "beenInvoiced", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $334ddf3cec080422$var$_applyDecoratedDescriptor($334ddf3cec080422$var$_class.prototype, "project", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($334ddf3cec080422$var$_class.prototype, "project"), $334ddf3cec080422$var$_class.prototype), $334ddf3cec080422$var$_applyDecoratedDescriptor($334ddf3cec080422$var$_class.prototype, "phase", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($334ddf3cec080422$var$_class.prototype, "phase"), $334ddf3cec080422$var$_class.prototype), $334ddf3cec080422$var$_applyDecoratedDescriptor($334ddf3cec080422$var$_class.prototype, "expense", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($334ddf3cec080422$var$_class.prototype, "expense"), $334ddf3cec080422$var$_class.prototype), $334ddf3cec080422$var$_class);
var $334ddf3cec080422$export$2e2bcd8739ae039 = $334ddf3cec080422$var$ProjectExpenseItemModel;

});




parcelRegister("avf6p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a5883acdc29e6b1$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "ProjectRateCollectionClass", function () { return $7a5883acdc29e6b1$export$353aa4820a667e4e; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $i7BVX = parcelRequire("i7BVX");
var $7a5883acdc29e6b1$var$_dec, $7a5883acdc29e6b1$var$_dec2, $7a5883acdc29e6b1$var$_class;
function $7a5883acdc29e6b1$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $7a5883acdc29e6b1$var$ProjectRateCollection = ($7a5883acdc29e6b1$var$_dec = (0, $4JcCM.action).bound, $7a5883acdc29e6b1$var$_dec2 = (0, $4JcCM.action).bound, $7a5883acdc29e6b1$var$_class = class ProjectRateCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "projectRates",
            modelClass: (0, $i7BVX.default)
        });
        this.addLookup("ratesByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("ratesByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get projectRatesById() {
        return this.modelsById;
    }
    get projectRates() {
        return this.models;
    }
    addProjectRate(data) {
        this.add(data);
    }
    addProjectRates(data) {
        this.addMany(data);
    }
}, $7a5883acdc29e6b1$var$_applyDecoratedDescriptor($7a5883acdc29e6b1$var$_class.prototype, "addProjectRate", [
    $7a5883acdc29e6b1$var$_dec
], Object.getOwnPropertyDescriptor($7a5883acdc29e6b1$var$_class.prototype, "addProjectRate"), $7a5883acdc29e6b1$var$_class.prototype), $7a5883acdc29e6b1$var$_applyDecoratedDescriptor($7a5883acdc29e6b1$var$_class.prototype, "addProjectRates", [
    $7a5883acdc29e6b1$var$_dec2
], Object.getOwnPropertyDescriptor($7a5883acdc29e6b1$var$_class.prototype, "addProjectRates"), $7a5883acdc29e6b1$var$_class.prototype), $7a5883acdc29e6b1$var$_class);
var $7a5883acdc29e6b1$export$2e2bcd8739ae039 = new $7a5883acdc29e6b1$var$ProjectRateCollection();
const $7a5883acdc29e6b1$export$353aa4820a667e4e = $7a5883acdc29e6b1$var$ProjectRateCollection;

});
parcelRegister("i7BVX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3164e4dd2af16e7$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $XoImS = parcelRequire("XoImS");

var $gJT7h = parcelRequire("gJT7h");

var $avf6p = parcelRequire("avf6p");

var $bxXv3 = parcelRequire("bxXv3");

var $htkeB = parcelRequire("htkeB");

var $3PpOX = parcelRequire("3PpOX");
var $d3164e4dd2af16e7$var$_class, $d3164e4dd2af16e7$var$_descriptor, $d3164e4dd2af16e7$var$_descriptor2, $d3164e4dd2af16e7$var$_descriptor3, $d3164e4dd2af16e7$var$_descriptor4, $d3164e4dd2af16e7$var$_descriptor5, $d3164e4dd2af16e7$var$_descriptor6, $d3164e4dd2af16e7$var$_descriptor7;
function $d3164e4dd2af16e7$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $d3164e4dd2af16e7$var$_defineProperty(e, r, t) {
    return (r = $d3164e4dd2af16e7$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $d3164e4dd2af16e7$var$_toPropertyKey(t) {
    var i = $d3164e4dd2af16e7$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $d3164e4dd2af16e7$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $d3164e4dd2af16e7$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $d3164e4dd2af16e7$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $d3164e4dd2af16e7$var$ProjectRateModel = ($d3164e4dd2af16e7$var$_class = class ProjectRateModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $d3164e4dd2af16e7$var$_initializerDefineProperty(this, "projectId", $d3164e4dd2af16e7$var$_descriptor, this);
        $d3164e4dd2af16e7$var$_initializerDefineProperty(this, "itemType", $d3164e4dd2af16e7$var$_descriptor2, this);
        $d3164e4dd2af16e7$var$_initializerDefineProperty(this, "date", $d3164e4dd2af16e7$var$_descriptor3, this);
        $d3164e4dd2af16e7$var$_initializerDefineProperty(this, "costRate", $d3164e4dd2af16e7$var$_descriptor4, this);
        $d3164e4dd2af16e7$var$_initializerDefineProperty(this, "chargeOutRate", $d3164e4dd2af16e7$var$_descriptor5, this);
        $d3164e4dd2af16e7$var$_initializerDefineProperty(this, "itemId", $d3164e4dd2af16e7$var$_descriptor6, this);
        $d3164e4dd2af16e7$var$_initializerDefineProperty(this, "phaseId", $d3164e4dd2af16e7$var$_descriptor7, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $avf6p.default);
        this.init(data, options);
    }
    get project() {
        return (0, $gJT7h.default).modelsById[this.projectId];
    }
    get phase() {
        return (0, $XoImS.default).modelsById[this.phaseId];
    }
    get staff() {
        return (0, $htkeB.default).modelsById[this.itemId];
    }
    get role() {
        return (0, $bxXv3.default).modelsById[this.itemId];
    }
    get resource() {
        return this.staff || this.role;
    }
}, $d3164e4dd2af16e7$var$_descriptor = $d3164e4dd2af16e7$var$_applyDecoratedDescriptor($d3164e4dd2af16e7$var$_class.prototype, "projectId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d3164e4dd2af16e7$var$_descriptor2 = $d3164e4dd2af16e7$var$_applyDecoratedDescriptor($d3164e4dd2af16e7$var$_class.prototype, "itemType", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d3164e4dd2af16e7$var$_descriptor3 = $d3164e4dd2af16e7$var$_applyDecoratedDescriptor($d3164e4dd2af16e7$var$_class.prototype, "date", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d3164e4dd2af16e7$var$_descriptor4 = $d3164e4dd2af16e7$var$_applyDecoratedDescriptor($d3164e4dd2af16e7$var$_class.prototype, "costRate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d3164e4dd2af16e7$var$_descriptor5 = $d3164e4dd2af16e7$var$_applyDecoratedDescriptor($d3164e4dd2af16e7$var$_class.prototype, "chargeOutRate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d3164e4dd2af16e7$var$_descriptor6 = $d3164e4dd2af16e7$var$_applyDecoratedDescriptor($d3164e4dd2af16e7$var$_class.prototype, "itemId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d3164e4dd2af16e7$var$_descriptor7 = $d3164e4dd2af16e7$var$_applyDecoratedDescriptor($d3164e4dd2af16e7$var$_class.prototype, "phaseId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d3164e4dd2af16e7$var$_applyDecoratedDescriptor($d3164e4dd2af16e7$var$_class.prototype, "project", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($d3164e4dd2af16e7$var$_class.prototype, "project"), $d3164e4dd2af16e7$var$_class.prototype), $d3164e4dd2af16e7$var$_applyDecoratedDescriptor($d3164e4dd2af16e7$var$_class.prototype, "phase", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($d3164e4dd2af16e7$var$_class.prototype, "phase"), $d3164e4dd2af16e7$var$_class.prototype), $d3164e4dd2af16e7$var$_applyDecoratedDescriptor($d3164e4dd2af16e7$var$_class.prototype, "staff", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($d3164e4dd2af16e7$var$_class.prototype, "staff"), $d3164e4dd2af16e7$var$_class.prototype), $d3164e4dd2af16e7$var$_applyDecoratedDescriptor($d3164e4dd2af16e7$var$_class.prototype, "role", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($d3164e4dd2af16e7$var$_class.prototype, "role"), $d3164e4dd2af16e7$var$_class.prototype), $d3164e4dd2af16e7$var$_applyDecoratedDescriptor($d3164e4dd2af16e7$var$_class.prototype, "resource", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($d3164e4dd2af16e7$var$_class.prototype, "resource"), $d3164e4dd2af16e7$var$_class.prototype), $d3164e4dd2af16e7$var$_class);
var $d3164e4dd2af16e7$export$2e2bcd8739ae039 = $d3164e4dd2af16e7$var$ProjectRateModel;

});


parcelRegister("hSUCJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0536718a213eab8$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "BudgetCollectionClass", function () { return $d0536718a213eab8$export$7a8bad899befefd5; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $aSdwE = parcelRequire("aSdwE");
var $d0536718a213eab8$var$_dec, $d0536718a213eab8$var$_dec2, $d0536718a213eab8$var$_class;
function $d0536718a213eab8$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $d0536718a213eab8$var$BudgetCollection = ($d0536718a213eab8$var$_dec = (0, $4JcCM.action).bound, $d0536718a213eab8$var$_dec2 = (0, $4JcCM.action).bound, $d0536718a213eab8$var$_class = class BudgetCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "budgetedHours",
            modelClass: (0, $aSdwE.default)
        });
        this.addLookup("budgetsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("budgetsByStaffId", "manyByKey", {
            key: (t)=>t.staffId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("budgetsByRoleId", "manyByKey", {
            key: (t)=>t.roleId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("budgetsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get budgetsById() {
        return this.modelsById;
    }
    get budgets() {
        return this.models;
    }
    get budgetsById() {
        return this.modelsById;
    }
    addBudget(data) {
        this.add(data);
    }
    addBudgets(data) {
        this.addMany(data);
    }
}, $d0536718a213eab8$var$_applyDecoratedDescriptor($d0536718a213eab8$var$_class.prototype, "addBudget", [
    $d0536718a213eab8$var$_dec
], Object.getOwnPropertyDescriptor($d0536718a213eab8$var$_class.prototype, "addBudget"), $d0536718a213eab8$var$_class.prototype), $d0536718a213eab8$var$_applyDecoratedDescriptor($d0536718a213eab8$var$_class.prototype, "addBudgets", [
    $d0536718a213eab8$var$_dec2
], Object.getOwnPropertyDescriptor($d0536718a213eab8$var$_class.prototype, "addBudgets"), $d0536718a213eab8$var$_class.prototype), $d0536718a213eab8$var$_class);
var $d0536718a213eab8$export$2e2bcd8739ae039 = new $d0536718a213eab8$var$BudgetCollection();
const $d0536718a213eab8$export$7a8bad899befefd5 = $d0536718a213eab8$var$BudgetCollection;

});
parcelRegister("aSdwE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ea9707427cbaf44$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $XoImS = parcelRequire("XoImS");

var $htkeB = parcelRequire("htkeB");

var $3PpOX = parcelRequire("3PpOX");

var $gJT7h = parcelRequire("gJT7h");

var $bxXv3 = parcelRequire("bxXv3");

var $hSUCJ = parcelRequire("hSUCJ");
parcelRequire("h999z");
parcelRequire("eiE7v");

var $ywyHN = parcelRequire("ywyHN");
var $7ea9707427cbaf44$var$_dec, $7ea9707427cbaf44$var$_class, $7ea9707427cbaf44$var$_descriptor, $7ea9707427cbaf44$var$_descriptor2, $7ea9707427cbaf44$var$_descriptor3, $7ea9707427cbaf44$var$_descriptor4, $7ea9707427cbaf44$var$_descriptor5;
function $7ea9707427cbaf44$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $7ea9707427cbaf44$var$_defineProperty(e, r, t) {
    return (r = $7ea9707427cbaf44$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $7ea9707427cbaf44$var$_toPropertyKey(t) {
    var i = $7ea9707427cbaf44$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $7ea9707427cbaf44$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $7ea9707427cbaf44$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $7ea9707427cbaf44$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $7ea9707427cbaf44$var$BudgetModel = ($7ea9707427cbaf44$var$_dec = (0, $4JcCM.action).bound, $7ea9707427cbaf44$var$_class = class BudgetModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $7ea9707427cbaf44$var$_initializerDefineProperty(this, "staffId", $7ea9707427cbaf44$var$_descriptor, this);
        $7ea9707427cbaf44$var$_initializerDefineProperty(this, "roleId", $7ea9707427cbaf44$var$_descriptor2, this);
        $7ea9707427cbaf44$var$_initializerDefineProperty(this, "projectId", $7ea9707427cbaf44$var$_descriptor3, this);
        $7ea9707427cbaf44$var$_initializerDefineProperty(this, "phaseId", $7ea9707427cbaf44$var$_descriptor4, this);
        $7ea9707427cbaf44$var$_initializerDefineProperty(this, "hours", $7ea9707427cbaf44$var$_descriptor5, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $hSUCJ.default);
        this.init(data, options);
    }
    get resource() {
        return this.staff || this.role;
    }
    get staff() {
        return (0, $htkeB.default).staffsById[this.staffId];
    }
    get phase() {
        return (0, $XoImS.default).phasesById[this.phaseId];
    }
    get project() {
        return (0, $gJT7h.default).projectsById[this.projectId];
    }
    get role() {
        return (0, $bxXv3.default).rolesById[this.roleId];
    }
    get costRate() {
        if (!this.resource) return 0;
        return (0, $ywyHN.default)({
            project: this.project,
            phase: this.phase,
            staff: this.staff,
            role: this.role
        }, "cost", [
            this.startDate,
            this.endDate
        ]);
    }
    get chargeOutRate() {
        if (!this.resource) return 0;
        return (0, $ywyHN.default)({
            project: this.project,
            phase: this.phase,
            staff: this.staff,
            role: this.role
        }, "chargeOut", [
            this.startDate,
            this.endDate
        ]);
    }
    get cost() {
        return this.hours * this.costRate;
    }
    get chargeOut() {
        return this.hours * this.chargeOutRate;
    }
    rateValueToHours(value, rateType) {
        const rateName = rateType === "availability" ? "weeklyAvailability" : rateType + "Rate";
        const val = value / this[rateName];
        this.update({
            hours: isFinite(val) ? val : 0
        });
    }
    get rates() {
        var _this$resource;
        return (_this$resource = this.resource) === null || _this$resource === void 0 ? void 0 : _this$resource.rates.sort((a, b)=>a.date - b.date);
    }
    get startDate() {
        var _this$phase;
        return (_this$phase = this.phase) === null || _this$phase === void 0 ? void 0 : _this$phase.startDate;
    }
    get endDate() {
        var _this$phase2;
        return (_this$phase2 = this.phase) === null || _this$phase2 === void 0 ? void 0 : _this$phase2.endDate;
    }
}, $7ea9707427cbaf44$var$_descriptor = $7ea9707427cbaf44$var$_applyDecoratedDescriptor($7ea9707427cbaf44$var$_class.prototype, "staffId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $7ea9707427cbaf44$var$_descriptor2 = $7ea9707427cbaf44$var$_applyDecoratedDescriptor($7ea9707427cbaf44$var$_class.prototype, "roleId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $7ea9707427cbaf44$var$_descriptor3 = $7ea9707427cbaf44$var$_applyDecoratedDescriptor($7ea9707427cbaf44$var$_class.prototype, "projectId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $7ea9707427cbaf44$var$_descriptor4 = $7ea9707427cbaf44$var$_applyDecoratedDescriptor($7ea9707427cbaf44$var$_class.prototype, "phaseId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $7ea9707427cbaf44$var$_descriptor5 = $7ea9707427cbaf44$var$_applyDecoratedDescriptor($7ea9707427cbaf44$var$_class.prototype, "hours", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $7ea9707427cbaf44$var$_applyDecoratedDescriptor($7ea9707427cbaf44$var$_class.prototype, "resource", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($7ea9707427cbaf44$var$_class.prototype, "resource"), $7ea9707427cbaf44$var$_class.prototype), $7ea9707427cbaf44$var$_applyDecoratedDescriptor($7ea9707427cbaf44$var$_class.prototype, "staff", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($7ea9707427cbaf44$var$_class.prototype, "staff"), $7ea9707427cbaf44$var$_class.prototype), $7ea9707427cbaf44$var$_applyDecoratedDescriptor($7ea9707427cbaf44$var$_class.prototype, "phase", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($7ea9707427cbaf44$var$_class.prototype, "phase"), $7ea9707427cbaf44$var$_class.prototype), $7ea9707427cbaf44$var$_applyDecoratedDescriptor($7ea9707427cbaf44$var$_class.prototype, "project", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($7ea9707427cbaf44$var$_class.prototype, "project"), $7ea9707427cbaf44$var$_class.prototype), $7ea9707427cbaf44$var$_applyDecoratedDescriptor($7ea9707427cbaf44$var$_class.prototype, "role", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($7ea9707427cbaf44$var$_class.prototype, "role"), $7ea9707427cbaf44$var$_class.prototype), $7ea9707427cbaf44$var$_applyDecoratedDescriptor($7ea9707427cbaf44$var$_class.prototype, "costRate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($7ea9707427cbaf44$var$_class.prototype, "costRate"), $7ea9707427cbaf44$var$_class.prototype), $7ea9707427cbaf44$var$_applyDecoratedDescriptor($7ea9707427cbaf44$var$_class.prototype, "chargeOutRate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($7ea9707427cbaf44$var$_class.prototype, "chargeOutRate"), $7ea9707427cbaf44$var$_class.prototype), $7ea9707427cbaf44$var$_applyDecoratedDescriptor($7ea9707427cbaf44$var$_class.prototype, "cost", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($7ea9707427cbaf44$var$_class.prototype, "cost"), $7ea9707427cbaf44$var$_class.prototype), $7ea9707427cbaf44$var$_applyDecoratedDescriptor($7ea9707427cbaf44$var$_class.prototype, "chargeOut", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($7ea9707427cbaf44$var$_class.prototype, "chargeOut"), $7ea9707427cbaf44$var$_class.prototype), $7ea9707427cbaf44$var$_applyDecoratedDescriptor($7ea9707427cbaf44$var$_class.prototype, "rateValueToHours", [
    $7ea9707427cbaf44$var$_dec
], Object.getOwnPropertyDescriptor($7ea9707427cbaf44$var$_class.prototype, "rateValueToHours"), $7ea9707427cbaf44$var$_class.prototype), $7ea9707427cbaf44$var$_applyDecoratedDescriptor($7ea9707427cbaf44$var$_class.prototype, "rates", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($7ea9707427cbaf44$var$_class.prototype, "rates"), $7ea9707427cbaf44$var$_class.prototype), $7ea9707427cbaf44$var$_applyDecoratedDescriptor($7ea9707427cbaf44$var$_class.prototype, "startDate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($7ea9707427cbaf44$var$_class.prototype, "startDate"), $7ea9707427cbaf44$var$_class.prototype), $7ea9707427cbaf44$var$_applyDecoratedDescriptor($7ea9707427cbaf44$var$_class.prototype, "endDate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($7ea9707427cbaf44$var$_class.prototype, "endDate"), $7ea9707427cbaf44$var$_class.prototype), $7ea9707427cbaf44$var$_class);
var $7ea9707427cbaf44$export$2e2bcd8739ae039 = $7ea9707427cbaf44$var$BudgetModel;

});
parcelRegister("eiE7v", function(module, exports) {

var $eat5C = parcelRequire("eat5C");

var $h999z = parcelRequire("h999z");

var $BqJ1K = parcelRequire("BqJ1K");
var $a691de244e403795$export$2e2bcd8739ae039 = ({ project: project, phase: phase, staff: staff, role: role }, rateType)=>{
    var _phase$project;
    let resourceRates;
    if (staff && !staff.inheritRateType(rateType)) resourceRates = (0, $BqJ1K.default)(staff.rates.sort((a, b)=>a.date - b.date), rateType);
    else if (!staff || staff.inheritRateType(rateType)) {
        role = (staff === null || staff === void 0 ? void 0 : staff.role) || role;
        if (!role) resourceRates = [];
        else if (role.avgRateType(rateType)) resourceRates = (0, $h999z.combineSpanSets)(role.staff.filter((s)=>!s.inheritRateType(rateType)).map((s)=>(0, $BqJ1K.default)(s.rates.sort((a, b)=>a.date - b.date), rateType)), (...values)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).mean(values.filter((v)=>v));
        });
        else resourceRates = (0, $BqJ1K.default)(role.rates.sort((a, b)=>a.date - b.date), rateType);
    }
    const projectRates = (0, $BqJ1K.default)(((phase === null || phase === void 0 ? void 0 : (_phase$project = phase.project) === null || _phase$project === void 0 ? void 0 : _phase$project.rates) || (project === null || project === void 0 ? void 0 : project.rates) || []).filter((r)=>{
        var _r$phase;
        return (!phase || !r.phase || r.phase === r.project.rootPhase || ((_r$phase = r.phase) === null || _r$phase === void 0 ? void 0 : _r$phase.isRootPhase) || phase.id === r.phase) && (!r.resource || staff && r.staff === staff || !staff && role && r.role === role);
    }).sort((a, b)=>a.date - b.date), rateType);
    const phaseRates = (0, $BqJ1K.default)(phase === null || phase === void 0 ? void 0 : phase.rates.filter((r)=>!r.resource || staff && r.staff === staff || !staff && role && r.role === role).sort((a, b)=>a.date - b.date), rateType);
    const combinedSpans = (0, $h999z.combineSpanSets)([
        phaseRates,
        projectRates,
        resourceRates
    ], (phaseRate, projectRate, resourceRate)=>{
        var _resourceRates$, _resourceRates$2;
        return phaseRate || projectRate || resourceRate || ((_resourceRates$ = resourceRates[1]) === null || _resourceRates$ === void 0 ? void 0 : _resourceRates$.value) || ((_resourceRates$2 = resourceRates[0]) === null || _resourceRates$2 === void 0 ? void 0 : _resourceRates$2.value // to handle potential NaN before first rate
        );
    });
    return combinedSpans;
};

});

parcelRegister("ywyHN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $067c6e952aab9927$export$2e2bcd8739ae039; });

var $4hBm1 = parcelRequire("4hBm1");

var $hK7Y7 = parcelRequire("hK7Y7");

var $eat5C = parcelRequire("eat5C");
var $067c6e952aab9927$export$2e2bcd8739ae039 = (models, rateType, dateRange)=>{
    var _2, _dateRange$_, _3, _dateRange$_2, _dateRange$, _dateRange$2;
    const now = new Date();
    (_dateRange$_ = dateRange[_2 = 0]) !== null && _dateRange$_ !== void 0 ? _dateRange$_ : dateRange[_2] = now;
    (_dateRange$_2 = dateRange[_3 = 1]) !== null && _dateRange$_2 !== void 0 ? _dateRange$_2 : dateRange[_3] = now;
    if (((_dateRange$ = dateRange[0]) === null || _dateRange$ === void 0 ? void 0 : _dateRange$.getTime()) === ((_dateRange$2 = dateRange[1]) === null || _dateRange$2 === void 0 ? void 0 : _dateRange$2.getTime())) return (0, $hK7Y7.default)(models, rateType, dateRange[0]);
    const businessDays = $067c6e952aab9927$var$getBusinessDaysBetweenDates(...dateRange);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).mean(businessDays.map((d)=>{
        return (0, $hK7Y7.default)(models, rateType, d) || 0;
    }));
};
const $067c6e952aab9927$var$getBusinessDaysBetweenDates = (startDate, endDate)=>{
    const start = new Date(startDate);
    const end = new Date(endDate);
    const businessDays = [];
    let currentDate = start;
    while(currentDate <= end){
        const day = currentDate.getDay();
        if (![
            0,
            6
        ].includes(day)) businessDays.push(currentDate);
        currentDate = (0, $4hBm1.addDays)(currentDate, 1);
    }
    return businessDays;
};

});
parcelRegister("hK7Y7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ceace9f847b13169$export$2e2bcd8739ae039; });

var $eat5C = parcelRequire("eat5C");
const $ceace9f847b13169$var$getCombinedRateAtDate = (models, rateType, date)=>{
    var _date, _role, _staff$role, _role2, _staff$inheritRateTyp;
    (_date = date) !== null && _date !== void 0 ? _date : date = new Date();
    let { project: project, phase: phase, staff: staff, role: role } = models;
    const projectId = project === null || project === void 0 ? void 0 : project.id;
    const phaseId = phase === null || phase === void 0 ? void 0 : phase.id;
    const staffId = staff === null || staff === void 0 ? void 0 : staff.id;
    const roleId = ((_role = role) === null || _role === void 0 ? void 0 : _role.id) || (staff === null || staff === void 0 ? void 0 : (_staff$role = staff.role) === null || _staff$role === void 0 ? void 0 : _staff$role.id);
    (_role2 = role) !== null && _role2 !== void 0 ? _role2 : role = staff === null || staff === void 0 ? void 0 : staff.role;
    const matchingProjectRates = ((project === null || project === void 0 ? void 0 : project.rates) || []).filter((x)=>{
        var _x$phase;
        return x.date <= date && (!x.phaseId || ((_x$phase = x.phase) === null || _x$phase === void 0 ? void 0 : _x$phase.isRootPhase) || x.phaseId === phaseId) && (!x.itemId || staffId === x.itemId || roleId === x.itemId);
    }).sort((a, b)=>b.date - a.date);
    const perfectPhaseMatches = matchingProjectRates.filter((x)=>x.phaseId === phaseId);
    const perfectPhaseStaffMatches = perfectPhaseMatches.filter((x)=>x.itemId === staffId);
    const perfectPhaseRoleMatches = perfectPhaseMatches.filter((x)=>x.itemId === roleId);
    const perfectStaffMatches = matchingProjectRates.filter((x)=>x.itemId === staffId);
    const perfectRoleMatches = matchingProjectRates.filter((x)=>x.itemId === roleId);
    const perfectPhaseMatch = perfectPhaseMatches[0] || null;
    const perfectPhaseStaffMatch = perfectPhaseStaffMatches[0] || null;
    const perfectPhaseRoleMatch = perfectPhaseRoleMatches[0] || null;
    const perfectStaffMatch = perfectStaffMatches[0] || null;
    const perfectRoleMatch = perfectRoleMatches[0] || null;
    const projectMatch = matchingProjectRates[0] || null;
    const latestProjectRate = perfectPhaseStaffMatch || perfectPhaseRoleMatch || perfectPhaseMatch || perfectStaffMatch || perfectRoleMatch || projectMatch;
    if (latestProjectRate && [
        "cost",
        "chargeOut"
    ].includes(rateType) && (latestProjectRate === null || latestProjectRate === void 0 ? void 0 : latestProjectRate[rateType + "Rate"]) > 0) return (latestProjectRate === null || latestProjectRate === void 0 ? void 0 : latestProjectRate[rateType + "Rate"]) || 0;
    if (staffId && (_staff$inheritRateTyp = staff.inheritRateType) !== null && _staff$inheritRateTyp !== void 0 && _staff$inheritRateTyp.call(staff, rateType) || !staffId && roleId) {
        var _role$avgRateType, _role3;
        if (!staffId && (_role$avgRateType = (_role3 = role).avgRateType) !== null && _role$avgRateType !== void 0 && _role$avgRateType.call(_role3, rateType)) return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).mean(role.staff.map((s)=>{
            return $ceace9f847b13169$var$getCombinedRateAtDate({
                project: project,
                phase: phase,
                staff: s,
                role: role
            }, rateType, date) || 0;
        }));
        else {
            var _role4;
            const matchingRoleRates = (((_role4 = role) === null || _role4 === void 0 ? void 0 : _role4.rates) || []).filter((x)=>x.date <= date);
            const latestRoleRate = matchingRoleRates.sort((a, b)=>b.date - a.date)[0];
            return (latestRoleRate === null || latestRoleRate === void 0 ? void 0 : latestRoleRate[rateType + "Rate"]) || 0;
        }
    } else {
        const matchingStaffRates = ((staff === null || staff === void 0 ? void 0 : staff.rates) || []).filter((x)=>x.date <= date);
        const latestStaffRate = matchingStaffRates.sort((a, b)=>b.date - a.date)[0];
        return (latestStaffRate === null || latestStaffRate === void 0 ? void 0 : latestStaffRate[rateType + "Rate"]) || 0;
    }
};
var $ceace9f847b13169$export$2e2bcd8739ae039 = $ceace9f847b13169$var$getCombinedRateAtDate;

});




parcelRegister("4tYKG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3438feea6204c757$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "InvoiceLineItemAggregateCollectionClass", function () { return $3438feea6204c757$export$649da615b4200d2c; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $1kjVt = parcelRequire("1kjVt");

var $4QeWD = parcelRequire("4QeWD");
var $3438feea6204c757$var$_dec, $3438feea6204c757$var$_dec2, $3438feea6204c757$var$_class;
function $3438feea6204c757$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
class $3438feea6204c757$var$InvoiceLineItemAggregate extends (0, $1kjVt.default) {
    constructor(){
        super({
            collectionClass: $3438feea6204c757$var$InvoiceLineItemAggregateCollection
        });
        (0, $4JcCM.makeObservable)(this);
    }
}
let $3438feea6204c757$var$InvoiceLineItemAggregateCollection = ($3438feea6204c757$var$_dec = (0, $4JcCM.action).bound, $3438feea6204c757$var$_dec2 = (0, $4JcCM.action).bound, $3438feea6204c757$var$_class = class InvoiceLineItemAggregateCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "invoiceLineItems",
            modelClass: (0, $4QeWD.default)
        });
        this.addLookup("lineItemsByInvoiceId", "manyByKey", {
            key: (t)=>t.invoiceId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("lineItemsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("lineItemsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("lineItemsByContactId", "manyByKey", {
            key: (t)=>t.contactId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("lineItemsByExpenseId", "manyByKey", {
            key: (t)=>t.expenseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("lineItemsByInvoicePhaseId", "manyByKey", {
            key: (t)=>"i" + t.invoiceId + "ph" + (t.phaseId ? t.phaseId : "undefined"),
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("lineItemsByStatus", "manyByKey", {
            key: (t)=>t.status,
            filter: (t)=>!t.deletedAt
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get invoiceLineItemsById() {
        return this.modelsById;
    }
    get invoiceLineItems() {
        return this.models;
    }
    get invoiceLineItemsById() {
        return this.modelsById;
    }
    addInvoiceLineItem(data) {
        this.add(data);
    }
    addInvoiceLineItems(data) {
        this.addMany(data);
    }
}, $3438feea6204c757$var$_applyDecoratedDescriptor($3438feea6204c757$var$_class.prototype, "addInvoiceLineItem", [
    $3438feea6204c757$var$_dec
], Object.getOwnPropertyDescriptor($3438feea6204c757$var$_class.prototype, "addInvoiceLineItem"), $3438feea6204c757$var$_class.prototype), $3438feea6204c757$var$_applyDecoratedDescriptor($3438feea6204c757$var$_class.prototype, "addInvoiceLineItems", [
    $3438feea6204c757$var$_dec2
], Object.getOwnPropertyDescriptor($3438feea6204c757$var$_class.prototype, "addInvoiceLineItems"), $3438feea6204c757$var$_class.prototype), $3438feea6204c757$var$_class);
var $3438feea6204c757$export$2e2bcd8739ae039 = new $3438feea6204c757$var$InvoiceLineItemAggregate();
const $3438feea6204c757$export$649da615b4200d2c = $3438feea6204c757$var$InvoiceLineItemAggregateCollection;

});
parcelRegister("1kjVt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f771d9202c0fed6$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $62nmb = parcelRequire("62nmb");
var $0f771d9202c0fed6$var$_dec, $0f771d9202c0fed6$var$_dec2, $0f771d9202c0fed6$var$_dec3, $0f771d9202c0fed6$var$_dec4, $0f771d9202c0fed6$var$_class, $0f771d9202c0fed6$var$_descriptor;
function $0f771d9202c0fed6$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $0f771d9202c0fed6$var$_defineProperty(e, r, t) {
    return (r = $0f771d9202c0fed6$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $0f771d9202c0fed6$var$_toPropertyKey(t) {
    var i = $0f771d9202c0fed6$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $0f771d9202c0fed6$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $0f771d9202c0fed6$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $0f771d9202c0fed6$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $0f771d9202c0fed6$var$Aggregate = ($0f771d9202c0fed6$var$_dec = (0, $4JcCM.action).bound, $0f771d9202c0fed6$var$_dec2 = (0, $4JcCM.action).bound, $0f771d9202c0fed6$var$_dec3 = (0, $4JcCM.action).bound, $0f771d9202c0fed6$var$_dec4 = (0, $4JcCM.action).bound, $0f771d9202c0fed6$var$_class = class Aggregate {
    constructor({ collectionClass: collectionClass }){
        $0f771d9202c0fed6$var$_initializerDefineProperty(this, "collectionsByGroup", $0f771d9202c0fed6$var$_descriptor, this);
        $0f771d9202c0fed6$var$_defineProperty(this, "collectionClass", null);
        this.collectionClass = collectionClass;
        (0, $4JcCM.makeObservable)(this);
    }
    get collection() {
        return new this.collectionClass().collection;
    }
    get modelType() {
        return new this.collectionClass().modelType;
    }
    groupByModelId(groupBy, modelData) {
        return this.modelType + String(groupBy.sort().map((prop)=>modelData[prop]));
    }
    groupById(groupBy) {
        return this.modelType + String(groupBy.sort());
    }
    getGroupCollection(groupBy) {
        var _this$collectionsByGr, _this$collectionsByGr2;
        const groupId = this.groupById(groupBy);
        (_this$collectionsByGr2 = (_this$collectionsByGr = this.collectionsByGroup)[groupId]) !== null && _this$collectionsByGr2 !== void 0 ? _this$collectionsByGr2 : _this$collectionsByGr[groupId] = new this.collectionClass();
        return this.collectionsByGroup[groupId];
    }
    add(groupBy, modelData, options) {
        const collection = this.getGroupCollection(groupBy);
        const modelId = this.groupByModelId(groupBy, modelData);
        modelData.id = modelId;
        modelData.id = modelId;
        return collection.add(modelData, options);
    }
    addMany(groupBy, modelDataArray, options) {
        return modelDataArray.map((md)=>this.add(groupBy, md, options));
    }
    clearGroupCollection(groupBy) {
        const groupId = this.groupById(groupBy);
        delete this.collectionsByGroup[groupId];
    }
    clear() {
        const collections = Object.values(this.collectionsByGroup);
        collections.forEach((collection)=>collection.clear());
        this.collectionsByGroup = {};
    }
}, $0f771d9202c0fed6$var$_descriptor = $0f771d9202c0fed6$var$_applyDecoratedDescriptor($0f771d9202c0fed6$var$_class.prototype, "collectionsByGroup", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $0f771d9202c0fed6$var$_applyDecoratedDescriptor($0f771d9202c0fed6$var$_class.prototype, "groupByModelId", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($0f771d9202c0fed6$var$_class.prototype, "groupByModelId"), $0f771d9202c0fed6$var$_class.prototype), $0f771d9202c0fed6$var$_applyDecoratedDescriptor($0f771d9202c0fed6$var$_class.prototype, "groupById", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($0f771d9202c0fed6$var$_class.prototype, "groupById"), $0f771d9202c0fed6$var$_class.prototype), $0f771d9202c0fed6$var$_applyDecoratedDescriptor($0f771d9202c0fed6$var$_class.prototype, "getGroupCollection", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($0f771d9202c0fed6$var$_class.prototype, "getGroupCollection"), $0f771d9202c0fed6$var$_class.prototype), $0f771d9202c0fed6$var$_applyDecoratedDescriptor($0f771d9202c0fed6$var$_class.prototype, "add", [
    $0f771d9202c0fed6$var$_dec
], Object.getOwnPropertyDescriptor($0f771d9202c0fed6$var$_class.prototype, "add"), $0f771d9202c0fed6$var$_class.prototype), $0f771d9202c0fed6$var$_applyDecoratedDescriptor($0f771d9202c0fed6$var$_class.prototype, "addMany", [
    $0f771d9202c0fed6$var$_dec2
], Object.getOwnPropertyDescriptor($0f771d9202c0fed6$var$_class.prototype, "addMany"), $0f771d9202c0fed6$var$_class.prototype), $0f771d9202c0fed6$var$_applyDecoratedDescriptor($0f771d9202c0fed6$var$_class.prototype, "clearGroupCollection", [
    $0f771d9202c0fed6$var$_dec3
], Object.getOwnPropertyDescriptor($0f771d9202c0fed6$var$_class.prototype, "clearGroupCollection"), $0f771d9202c0fed6$var$_class.prototype), $0f771d9202c0fed6$var$_applyDecoratedDescriptor($0f771d9202c0fed6$var$_class.prototype, "clear", [
    $0f771d9202c0fed6$var$_dec4
], Object.getOwnPropertyDescriptor($0f771d9202c0fed6$var$_class.prototype, "clear"), $0f771d9202c0fed6$var$_class.prototype), $0f771d9202c0fed6$var$_class);
var $0f771d9202c0fed6$export$2e2bcd8739ae039 = $0f771d9202c0fed6$var$Aggregate;

});

parcelRegister("4QeWD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38679c7176e01ba7$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $bhvQG = parcelRequire("bhvQG");

var $cxnwP = parcelRequire("cxnwP");

var $4tYKG = parcelRequire("4tYKG");

var $XoImS = parcelRequire("XoImS");

var $gJT7h = parcelRequire("gJT7h");

var $3PpOX = parcelRequire("3PpOX");
var $38679c7176e01ba7$var$_class, $38679c7176e01ba7$var$_descriptor, $38679c7176e01ba7$var$_descriptor2, $38679c7176e01ba7$var$_descriptor3, $38679c7176e01ba7$var$_descriptor4, $38679c7176e01ba7$var$_descriptor5;
function $38679c7176e01ba7$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $38679c7176e01ba7$var$_defineProperty(e, r, t) {
    return (r = $38679c7176e01ba7$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $38679c7176e01ba7$var$_toPropertyKey(t) {
    var i = $38679c7176e01ba7$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $38679c7176e01ba7$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $38679c7176e01ba7$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $38679c7176e01ba7$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $38679c7176e01ba7$var$InvoiceLineItemAggregateModel = ($38679c7176e01ba7$var$_class = class InvoiceLineItemAggregateModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $38679c7176e01ba7$var$_initializerDefineProperty(this, "projectId", $38679c7176e01ba7$var$_descriptor, this);
        $38679c7176e01ba7$var$_initializerDefineProperty(this, "contactId", $38679c7176e01ba7$var$_descriptor2, this);
        $38679c7176e01ba7$var$_initializerDefineProperty(this, "phaseId", $38679c7176e01ba7$var$_descriptor3, this);
        $38679c7176e01ba7$var$_initializerDefineProperty(this, "billingType", $38679c7176e01ba7$var$_descriptor4, this);
        $38679c7176e01ba7$var$_initializerDefineProperty(this, "amount", $38679c7176e01ba7$var$_descriptor5, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $4tYKG.default);
        this.init(data, options);
    }
    get invoice() {
        return (0, $cxnwP.default).invoicesById[this.invoiceId];
    }
    get project() {
        return (0, $gJT7h.default).projectsById[this.projectId];
    }
    get phase() {
        return (0, $XoImS.default).phasesById[this.phaseId];
    }
    get contact() {
        return (0, $bhvQG.default).contactsById[this.contactId];
    }
}, $38679c7176e01ba7$var$_descriptor = $38679c7176e01ba7$var$_applyDecoratedDescriptor($38679c7176e01ba7$var$_class.prototype, "projectId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $38679c7176e01ba7$var$_descriptor2 = $38679c7176e01ba7$var$_applyDecoratedDescriptor($38679c7176e01ba7$var$_class.prototype, "contactId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $38679c7176e01ba7$var$_descriptor3 = $38679c7176e01ba7$var$_applyDecoratedDescriptor($38679c7176e01ba7$var$_class.prototype, "phaseId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $38679c7176e01ba7$var$_descriptor4 = $38679c7176e01ba7$var$_applyDecoratedDescriptor($38679c7176e01ba7$var$_class.prototype, "billingType", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $38679c7176e01ba7$var$_descriptor5 = $38679c7176e01ba7$var$_applyDecoratedDescriptor($38679c7176e01ba7$var$_class.prototype, "amount", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $38679c7176e01ba7$var$_applyDecoratedDescriptor($38679c7176e01ba7$var$_class.prototype, "invoice", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($38679c7176e01ba7$var$_class.prototype, "invoice"), $38679c7176e01ba7$var$_class.prototype), $38679c7176e01ba7$var$_applyDecoratedDescriptor($38679c7176e01ba7$var$_class.prototype, "project", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($38679c7176e01ba7$var$_class.prototype, "project"), $38679c7176e01ba7$var$_class.prototype), $38679c7176e01ba7$var$_applyDecoratedDescriptor($38679c7176e01ba7$var$_class.prototype, "phase", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($38679c7176e01ba7$var$_class.prototype, "phase"), $38679c7176e01ba7$var$_class.prototype), $38679c7176e01ba7$var$_applyDecoratedDescriptor($38679c7176e01ba7$var$_class.prototype, "contact", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($38679c7176e01ba7$var$_class.prototype, "contact"), $38679c7176e01ba7$var$_class.prototype), $38679c7176e01ba7$var$_class);
var $38679c7176e01ba7$export$2e2bcd8739ae039 = $38679c7176e01ba7$var$InvoiceLineItemAggregateModel;

});


parcelRegister("jYjJH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8a2ee18cf38f1de$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "TimeEntryAggregateCollectionClass", function () { return $e8a2ee18cf38f1de$export$debcd62ea0d4cde0; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $557d7 = parcelRequire("557d7");

var $1kjVt = parcelRequire("1kjVt");
parcelRequire("62nmb");

var $f44xu = parcelRequire("f44xu");
var $e8a2ee18cf38f1de$var$_dec, $e8a2ee18cf38f1de$var$_dec2, $e8a2ee18cf38f1de$var$_class;
function $e8a2ee18cf38f1de$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
class $e8a2ee18cf38f1de$var$TimeEntryAggregate extends (0, $1kjVt.default) {
    constructor(){
        super({
            collectionClass: $e8a2ee18cf38f1de$var$TimeEntryAggregateCollection
        });
        (0, $4JcCM.makeObservable)(this);
    }
}
let $e8a2ee18cf38f1de$var$TimeEntryAggregateCollection = ($e8a2ee18cf38f1de$var$_dec = (0, $4JcCM.action).bound, $e8a2ee18cf38f1de$var$_dec2 = (0, $4JcCM.action).bound, $e8a2ee18cf38f1de$var$_class = class TimeEntryAggregateCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "timeEntries",
            modelClass: (0, $557d7.default)
        });
        this.addLookup("timeEntriesByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("timeEntriesByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("timeEntriesByStaffId", "manyByKey", {
            key: (t)=>t.staffId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("timeEntriesByRoleId", "manyByKey", {
            key: (t)=>{
                var _t$staff;
                return t.roleId || ((_t$staff = t.staff) === null || _t$staff === void 0 ? void 0 : _t$staff.roleId);
            },
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("timeEntriesByMonth", "manyByKey", {
            key: (t)=>t.month,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("timeEntriesByModelTuple", "manyByMany", {
            keys: (t)=>{
                var _t$project, _t$phase, _t$role, _t$staff2, _t$project2, _t$phase2, _t$project3, _t$role2, _t$project4, _t$staff3, _t$phase3, _t$role3, _t$phase4, _t$staff4, _t$role4, _t$staff5, _t$project5, _t$phase5, _t$role5, _t$project6, _t$phase6, _t$staff6, _t$project7, _t$role6, _t$staff7, _t$phase7, _t$role7, _t$staff8, _t$project8, _t$phase8, _t$role8, _t$staff9;
                return [
                    (0, $f44xu.default)((_t$project = t.project) === null || _t$project === void 0 ? void 0 : _t$project.id, undefined, undefined, undefined),
                    (0, $f44xu.default)(undefined, (_t$phase = t.phase) === null || _t$phase === void 0 ? void 0 : _t$phase.id, undefined, undefined),
                    (0, $f44xu.default)(undefined, undefined, (_t$role = t.role) === null || _t$role === void 0 ? void 0 : _t$role.id, undefined),
                    (0, $f44xu.default)(undefined, undefined, undefined, (_t$staff2 = t.staff) === null || _t$staff2 === void 0 ? void 0 : _t$staff2.id),
                    (0, $f44xu.default)((_t$project2 = t.project) === null || _t$project2 === void 0 ? void 0 : _t$project2.id, (_t$phase2 = t.phase) === null || _t$phase2 === void 0 ? void 0 : _t$phase2.id, undefined, undefined),
                    (0, $f44xu.default)((_t$project3 = t.project) === null || _t$project3 === void 0 ? void 0 : _t$project3.id, undefined, (_t$role2 = t.role) === null || _t$role2 === void 0 ? void 0 : _t$role2.id, undefined),
                    (0, $f44xu.default)((_t$project4 = t.project) === null || _t$project4 === void 0 ? void 0 : _t$project4.id, undefined, undefined, (_t$staff3 = t.staff) === null || _t$staff3 === void 0 ? void 0 : _t$staff3.id),
                    (0, $f44xu.default)(undefined, (_t$phase3 = t.phase) === null || _t$phase3 === void 0 ? void 0 : _t$phase3.id, (_t$role3 = t.role) === null || _t$role3 === void 0 ? void 0 : _t$role3.id, undefined),
                    (0, $f44xu.default)(undefined, (_t$phase4 = t.phase) === null || _t$phase4 === void 0 ? void 0 : _t$phase4.id, undefined, (_t$staff4 = t.staff) === null || _t$staff4 === void 0 ? void 0 : _t$staff4.id),
                    (0, $f44xu.default)(undefined, undefined, (_t$role4 = t.role) === null || _t$role4 === void 0 ? void 0 : _t$role4.id, (_t$staff5 = t.staff) === null || _t$staff5 === void 0 ? void 0 : _t$staff5.id),
                    (0, $f44xu.default)((_t$project5 = t.project) === null || _t$project5 === void 0 ? void 0 : _t$project5.id, (_t$phase5 = t.phase) === null || _t$phase5 === void 0 ? void 0 : _t$phase5.id, (_t$role5 = t.role) === null || _t$role5 === void 0 ? void 0 : _t$role5.id, undefined),
                    (0, $f44xu.default)((_t$project6 = t.project) === null || _t$project6 === void 0 ? void 0 : _t$project6.id, (_t$phase6 = t.phase) === null || _t$phase6 === void 0 ? void 0 : _t$phase6.id, undefined, (_t$staff6 = t.staff) === null || _t$staff6 === void 0 ? void 0 : _t$staff6.id),
                    (0, $f44xu.default)((_t$project7 = t.project) === null || _t$project7 === void 0 ? void 0 : _t$project7.id, undefined, (_t$role6 = t.role) === null || _t$role6 === void 0 ? void 0 : _t$role6.id, (_t$staff7 = t.staff) === null || _t$staff7 === void 0 ? void 0 : _t$staff7.id),
                    (0, $f44xu.default)(undefined, (_t$phase7 = t.phase) === null || _t$phase7 === void 0 ? void 0 : _t$phase7.id, (_t$role7 = t.role) === null || _t$role7 === void 0 ? void 0 : _t$role7.id, (_t$staff8 = t.staff) === null || _t$staff8 === void 0 ? void 0 : _t$staff8.id),
                    (0, $f44xu.default)((_t$project8 = t.project) === null || _t$project8 === void 0 ? void 0 : _t$project8.id, (_t$phase8 = t.phase) === null || _t$phase8 === void 0 ? void 0 : _t$phase8.id, (_t$role8 = t.role) === null || _t$role8 === void 0 ? void 0 : _t$role8.id, (_t$staff9 = t.staff) === null || _t$staff9 === void 0 ? void 0 : _t$staff9.id)
                ];
            },
            filter: (t)=>!t.deletedAt
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get timeEntriesById() {
        return this.modelsById;
    }
    get timeEntries() {
        return this.models;
    }
    get timeEntriesById() {
        return this.modelsById;
    }
    addTimeEntry(data) {
        this.add(data);
    }
    addTimeEntries(data) {
        this.addMany(data);
    }
}, $e8a2ee18cf38f1de$var$_applyDecoratedDescriptor($e8a2ee18cf38f1de$var$_class.prototype, "addTimeEntry", [
    $e8a2ee18cf38f1de$var$_dec
], Object.getOwnPropertyDescriptor($e8a2ee18cf38f1de$var$_class.prototype, "addTimeEntry"), $e8a2ee18cf38f1de$var$_class.prototype), $e8a2ee18cf38f1de$var$_applyDecoratedDescriptor($e8a2ee18cf38f1de$var$_class.prototype, "addTimeEntries", [
    $e8a2ee18cf38f1de$var$_dec2
], Object.getOwnPropertyDescriptor($e8a2ee18cf38f1de$var$_class.prototype, "addTimeEntries"), $e8a2ee18cf38f1de$var$_class.prototype), $e8a2ee18cf38f1de$var$_class);
var $e8a2ee18cf38f1de$export$2e2bcd8739ae039 = new $e8a2ee18cf38f1de$var$TimeEntryAggregate();
const $e8a2ee18cf38f1de$export$debcd62ea0d4cde0 = $e8a2ee18cf38f1de$var$TimeEntryAggregateCollection;

});
parcelRegister("557d7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b33033b729e5a4f$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $htkeB = parcelRequire("htkeB");

var $gJT7h = parcelRequire("gJT7h");

var $XoImS = parcelRequire("XoImS");

var $3PpOX = parcelRequire("3PpOX");

var $jYjJH = parcelRequire("jYjJH");

var $4hBm1 = parcelRequire("4hBm1");

var $bxXv3 = parcelRequire("bxXv3");
var $3b33033b729e5a4f$var$_class, $3b33033b729e5a4f$var$_descriptor, $3b33033b729e5a4f$var$_descriptor2, $3b33033b729e5a4f$var$_descriptor3, $3b33033b729e5a4f$var$_descriptor4, $3b33033b729e5a4f$var$_descriptor5, $3b33033b729e5a4f$var$_descriptor6, $3b33033b729e5a4f$var$_descriptor7, $3b33033b729e5a4f$var$_descriptor8, $3b33033b729e5a4f$var$_descriptor9, $3b33033b729e5a4f$var$_descriptor10, $3b33033b729e5a4f$var$_descriptor11;
function $3b33033b729e5a4f$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $3b33033b729e5a4f$var$_defineProperty(e, r, t) {
    return (r = $3b33033b729e5a4f$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $3b33033b729e5a4f$var$_toPropertyKey(t) {
    var i = $3b33033b729e5a4f$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $3b33033b729e5a4f$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $3b33033b729e5a4f$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $3b33033b729e5a4f$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $3b33033b729e5a4f$var$TimeEntryAggregateModel = ($3b33033b729e5a4f$var$_class = class TimeEntryAggregateModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $3b33033b729e5a4f$var$_initializerDefineProperty(this, "staffId", $3b33033b729e5a4f$var$_descriptor, this);
        $3b33033b729e5a4f$var$_initializerDefineProperty(this, "projectId", $3b33033b729e5a4f$var$_descriptor2, this);
        $3b33033b729e5a4f$var$_initializerDefineProperty(this, "phaseId", $3b33033b729e5a4f$var$_descriptor3, this);
        $3b33033b729e5a4f$var$_initializerDefineProperty(this, "month", $3b33033b729e5a4f$var$_descriptor4, this);
        $3b33033b729e5a4f$var$_initializerDefineProperty(this, "numMinutes", $3b33033b729e5a4f$var$_descriptor5, this);
        $3b33033b729e5a4f$var$_initializerDefineProperty(this, "pay", $3b33033b729e5a4f$var$_descriptor6, this);
        $3b33033b729e5a4f$var$_initializerDefineProperty(this, "cost", $3b33033b729e5a4f$var$_descriptor7, this);
        $3b33033b729e5a4f$var$_initializerDefineProperty(this, "chargeOut", $3b33033b729e5a4f$var$_descriptor8, this);
        $3b33033b729e5a4f$var$_initializerDefineProperty(this, "isBillable", $3b33033b729e5a4f$var$_descriptor9, this);
        $3b33033b729e5a4f$var$_initializerDefineProperty(this, "isVariation", $3b33033b729e5a4f$var$_descriptor10, this);
        $3b33033b729e5a4f$var$_initializerDefineProperty(this, "beenInvoiced", $3b33033b729e5a4f$var$_descriptor11, this);
        (0, $4JcCM.makeObservable)(this);
        data._date = data.date;
        delete data.date;
        this.collection = (0, $jYjJH.default);
        this.init(data, options);
    }
    get staff() {
        return (0, $htkeB.default).modelsById[this.staffId];
    }
    get role() {
        var _this$staff;
        return ((_this$staff = this.staff) === null || _this$staff === void 0 ? void 0 : _this$staff.role) || (0, $bxXv3.default).modelsById[this.staffRoleId] || (0, $bxXv3.default).modelsById[this.roleId];
    }
    get project() {
        return (0, $gJT7h.default).modelsById[this.projectId];
    }
    get phase() {
        return (0, $XoImS.default).modelsById[this.phaseId];
    }
    get date() {
        return this._date || (this.month ? (0, $4hBm1.parse)(this.month, "yyyy-MM", new Date()) : this.week ? (0, $4hBm1.parse)(this.week, "RRRR-II", new Date()) : null);
    }
    get startDate() {
        return (0, $4hBm1.startOfMonth)((0, $4hBm1.parse)(this.month, "yyyy-MM", new Date()));
    }
    get endDate() {
        return (0, $4hBm1.endOfMonth)((0, $4hBm1.parse)(this.month, "yyyy-MM", new Date()));
    }
    get hours() {
        return this.numMinutes / 60;
    }
}, $3b33033b729e5a4f$var$_descriptor = $3b33033b729e5a4f$var$_applyDecoratedDescriptor($3b33033b729e5a4f$var$_class.prototype, "staffId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $3b33033b729e5a4f$var$_descriptor2 = $3b33033b729e5a4f$var$_applyDecoratedDescriptor($3b33033b729e5a4f$var$_class.prototype, "projectId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $3b33033b729e5a4f$var$_descriptor3 = $3b33033b729e5a4f$var$_applyDecoratedDescriptor($3b33033b729e5a4f$var$_class.prototype, "phaseId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $3b33033b729e5a4f$var$_descriptor4 = $3b33033b729e5a4f$var$_applyDecoratedDescriptor($3b33033b729e5a4f$var$_class.prototype, "month", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "";
    }
}), $3b33033b729e5a4f$var$_descriptor5 = $3b33033b729e5a4f$var$_applyDecoratedDescriptor($3b33033b729e5a4f$var$_class.prototype, "numMinutes", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $3b33033b729e5a4f$var$_descriptor6 = $3b33033b729e5a4f$var$_applyDecoratedDescriptor($3b33033b729e5a4f$var$_class.prototype, "pay", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $3b33033b729e5a4f$var$_descriptor7 = $3b33033b729e5a4f$var$_applyDecoratedDescriptor($3b33033b729e5a4f$var$_class.prototype, "cost", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $3b33033b729e5a4f$var$_descriptor8 = $3b33033b729e5a4f$var$_applyDecoratedDescriptor($3b33033b729e5a4f$var$_class.prototype, "chargeOut", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $3b33033b729e5a4f$var$_descriptor9 = $3b33033b729e5a4f$var$_applyDecoratedDescriptor($3b33033b729e5a4f$var$_class.prototype, "isBillable", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $3b33033b729e5a4f$var$_descriptor10 = $3b33033b729e5a4f$var$_applyDecoratedDescriptor($3b33033b729e5a4f$var$_class.prototype, "isVariation", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $3b33033b729e5a4f$var$_descriptor11 = $3b33033b729e5a4f$var$_applyDecoratedDescriptor($3b33033b729e5a4f$var$_class.prototype, "beenInvoiced", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $3b33033b729e5a4f$var$_applyDecoratedDescriptor($3b33033b729e5a4f$var$_class.prototype, "staff", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($3b33033b729e5a4f$var$_class.prototype, "staff"), $3b33033b729e5a4f$var$_class.prototype), $3b33033b729e5a4f$var$_applyDecoratedDescriptor($3b33033b729e5a4f$var$_class.prototype, "role", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($3b33033b729e5a4f$var$_class.prototype, "role"), $3b33033b729e5a4f$var$_class.prototype), $3b33033b729e5a4f$var$_applyDecoratedDescriptor($3b33033b729e5a4f$var$_class.prototype, "project", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($3b33033b729e5a4f$var$_class.prototype, "project"), $3b33033b729e5a4f$var$_class.prototype), $3b33033b729e5a4f$var$_applyDecoratedDescriptor($3b33033b729e5a4f$var$_class.prototype, "phase", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($3b33033b729e5a4f$var$_class.prototype, "phase"), $3b33033b729e5a4f$var$_class.prototype), $3b33033b729e5a4f$var$_applyDecoratedDescriptor($3b33033b729e5a4f$var$_class.prototype, "date", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($3b33033b729e5a4f$var$_class.prototype, "date"), $3b33033b729e5a4f$var$_class.prototype), $3b33033b729e5a4f$var$_applyDecoratedDescriptor($3b33033b729e5a4f$var$_class.prototype, "startDate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($3b33033b729e5a4f$var$_class.prototype, "startDate"), $3b33033b729e5a4f$var$_class.prototype), $3b33033b729e5a4f$var$_applyDecoratedDescriptor($3b33033b729e5a4f$var$_class.prototype, "endDate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($3b33033b729e5a4f$var$_class.prototype, "endDate"), $3b33033b729e5a4f$var$_class.prototype), $3b33033b729e5a4f$var$_applyDecoratedDescriptor($3b33033b729e5a4f$var$_class.prototype, "hours", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($3b33033b729e5a4f$var$_class.prototype, "hours"), $3b33033b729e5a4f$var$_class.prototype), $3b33033b729e5a4f$var$_class);
var $3b33033b729e5a4f$export$2e2bcd8739ae039 = $3b33033b729e5a4f$var$TimeEntryAggregateModel;

});


parcelRegister("jc1Yz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df90abad448bf32d$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "ProjectNoteCollectionClass", function () { return $df90abad448bf32d$export$6e7f6fc112bd9aaa; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $sKZfS = parcelRequire("sKZfS");
var $df90abad448bf32d$var$_dec, $df90abad448bf32d$var$_dec2, $df90abad448bf32d$var$_class;
function $df90abad448bf32d$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $df90abad448bf32d$var$ProjectNoteCollection = ($df90abad448bf32d$var$_dec = (0, $4JcCM.action).bound, $df90abad448bf32d$var$_dec2 = (0, $4JcCM.action).bound, $df90abad448bf32d$var$_class = class ProjectNoteCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "projectNotes",
            modelClass: (0, $sKZfS.default)
        });
        this.addLookup("notesByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("notesByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get notesById() {
        return this.modelsById;
    }
    get notes() {
        return this.models;
    }
    addNote(data) {
        this.add(data);
    }
    addNotes(data) {
        this.addMany(data);
    }
}, $df90abad448bf32d$var$_applyDecoratedDescriptor($df90abad448bf32d$var$_class.prototype, "addNote", [
    $df90abad448bf32d$var$_dec
], Object.getOwnPropertyDescriptor($df90abad448bf32d$var$_class.prototype, "addNote"), $df90abad448bf32d$var$_class.prototype), $df90abad448bf32d$var$_applyDecoratedDescriptor($df90abad448bf32d$var$_class.prototype, "addNotes", [
    $df90abad448bf32d$var$_dec2
], Object.getOwnPropertyDescriptor($df90abad448bf32d$var$_class.prototype, "addNotes"), $df90abad448bf32d$var$_class.prototype), $df90abad448bf32d$var$_class);
var $df90abad448bf32d$export$2e2bcd8739ae039 = new $df90abad448bf32d$var$ProjectNoteCollection();
const $df90abad448bf32d$export$6e7f6fc112bd9aaa = $df90abad448bf32d$var$ProjectNoteCollection;

});
parcelRegister("sKZfS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05671046af1a8bf8$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $XoImS = parcelRequire("XoImS");

var $gJT7h = parcelRequire("gJT7h");

var $jc1Yz = parcelRequire("jc1Yz");

var $3PpOX = parcelRequire("3PpOX");
var $05671046af1a8bf8$var$_class, $05671046af1a8bf8$var$_descriptor, $05671046af1a8bf8$var$_descriptor2, $05671046af1a8bf8$var$_descriptor3, $05671046af1a8bf8$var$_descriptor4;
function $05671046af1a8bf8$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $05671046af1a8bf8$var$_defineProperty(e, r, t) {
    return (r = $05671046af1a8bf8$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $05671046af1a8bf8$var$_toPropertyKey(t) {
    var i = $05671046af1a8bf8$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $05671046af1a8bf8$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $05671046af1a8bf8$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $05671046af1a8bf8$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $05671046af1a8bf8$var$ProjectNoteModel = ($05671046af1a8bf8$var$_class = class ProjectNoteModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $05671046af1a8bf8$var$_initializerDefineProperty(this, "date", $05671046af1a8bf8$var$_descriptor, this);
        $05671046af1a8bf8$var$_initializerDefineProperty(this, "description", $05671046af1a8bf8$var$_descriptor2, this);
        $05671046af1a8bf8$var$_initializerDefineProperty(this, "projectId", $05671046af1a8bf8$var$_descriptor3, this);
        $05671046af1a8bf8$var$_initializerDefineProperty(this, "phaseId", $05671046af1a8bf8$var$_descriptor4, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $jc1Yz.default);
        this.init(data, options);
    }
    get phase() {
        return (0, $XoImS.default).phasesById[this.phaseId];
    }
    get project() {
        return (0, $gJT7h.default).projectsById[this.projectId];
    }
}, $05671046af1a8bf8$var$_descriptor = $05671046af1a8bf8$var$_applyDecoratedDescriptor($05671046af1a8bf8$var$_class.prototype, "date", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $05671046af1a8bf8$var$_descriptor2 = $05671046af1a8bf8$var$_applyDecoratedDescriptor($05671046af1a8bf8$var$_class.prototype, "description", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $05671046af1a8bf8$var$_descriptor3 = $05671046af1a8bf8$var$_applyDecoratedDescriptor($05671046af1a8bf8$var$_class.prototype, "projectId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $05671046af1a8bf8$var$_descriptor4 = $05671046af1a8bf8$var$_applyDecoratedDescriptor($05671046af1a8bf8$var$_class.prototype, "phaseId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $05671046af1a8bf8$var$_applyDecoratedDescriptor($05671046af1a8bf8$var$_class.prototype, "phase", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($05671046af1a8bf8$var$_class.prototype, "phase"), $05671046af1a8bf8$var$_class.prototype), $05671046af1a8bf8$var$_applyDecoratedDescriptor($05671046af1a8bf8$var$_class.prototype, "project", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($05671046af1a8bf8$var$_class.prototype, "project"), $05671046af1a8bf8$var$_class.prototype), $05671046af1a8bf8$var$_class);
var $05671046af1a8bf8$export$2e2bcd8739ae039 = $05671046af1a8bf8$var$ProjectNoteModel;

});


parcelRegister("64hVI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46b106494daca52c$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "RevenueTargetCollectionClass", function () { return $46b106494daca52c$export$53bbc56d3b16a709; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $82JrF = parcelRequire("82JrF");
var $46b106494daca52c$var$_dec, $46b106494daca52c$var$_dec2, $46b106494daca52c$var$_class;
function $46b106494daca52c$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $46b106494daca52c$var$RevenueTargetCollection = ($46b106494daca52c$var$_dec = (0, $4JcCM.action).bound, $46b106494daca52c$var$_dec2 = (0, $4JcCM.action).bound, $46b106494daca52c$var$_class = class RevenueTargetCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "revenueTargets",
            modelClass: (0, $82JrF.default)
        });
        this.addLookup("revenueTargetsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("revenueTargetsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get revenueTargetsById() {
        return this.modelsById;
    }
    get revenueTargets() {
        return this.models;
    }
    addRevenueTarget(data, options) {
        return this.add(data, options);
    }
    addRevenueTargets(data, options) {
        return this.addMany(data, options);
    }
}, $46b106494daca52c$var$_applyDecoratedDescriptor($46b106494daca52c$var$_class.prototype, "addRevenueTarget", [
    $46b106494daca52c$var$_dec
], Object.getOwnPropertyDescriptor($46b106494daca52c$var$_class.prototype, "addRevenueTarget"), $46b106494daca52c$var$_class.prototype), $46b106494daca52c$var$_applyDecoratedDescriptor($46b106494daca52c$var$_class.prototype, "addRevenueTargets", [
    $46b106494daca52c$var$_dec2
], Object.getOwnPropertyDescriptor($46b106494daca52c$var$_class.prototype, "addRevenueTargets"), $46b106494daca52c$var$_class.prototype), $46b106494daca52c$var$_class);
var $46b106494daca52c$export$2e2bcd8739ae039 = new $46b106494daca52c$var$RevenueTargetCollection();
const $46b106494daca52c$export$53bbc56d3b16a709 = $46b106494daca52c$var$RevenueTargetCollection;

});
parcelRegister("82JrF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5db1c31c91f90cf2$export$2e2bcd8739ae039; });
parcelRequire("gN0TC");

var $4JcCM = parcelRequire("4JcCM");

var $XoImS = parcelRequire("XoImS");

var $gJT7h = parcelRequire("gJT7h");

var $64hVI = parcelRequire("64hVI");

var $3PpOX = parcelRequire("3PpOX");
var $5db1c31c91f90cf2$var$_class, $5db1c31c91f90cf2$var$_descriptor, $5db1c31c91f90cf2$var$_descriptor2, $5db1c31c91f90cf2$var$_descriptor3, $5db1c31c91f90cf2$var$_descriptor4;
function $5db1c31c91f90cf2$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $5db1c31c91f90cf2$var$_defineProperty(e, r, t) {
    return (r = $5db1c31c91f90cf2$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $5db1c31c91f90cf2$var$_toPropertyKey(t) {
    var i = $5db1c31c91f90cf2$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $5db1c31c91f90cf2$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $5db1c31c91f90cf2$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $5db1c31c91f90cf2$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $5db1c31c91f90cf2$var$RevenueTargetModel = ($5db1c31c91f90cf2$var$_class = class RevenueTargetModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $5db1c31c91f90cf2$var$_initializerDefineProperty(this, "projectId", $5db1c31c91f90cf2$var$_descriptor, this);
        $5db1c31c91f90cf2$var$_initializerDefineProperty(this, "phaseId", $5db1c31c91f90cf2$var$_descriptor2, this);
        $5db1c31c91f90cf2$var$_initializerDefineProperty(this, "date", $5db1c31c91f90cf2$var$_descriptor3, this);
        $5db1c31c91f90cf2$var$_initializerDefineProperty(this, "amount", $5db1c31c91f90cf2$var$_descriptor4, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $64hVI.default);
        this.init(data, options);
    }
    get project() {
        return (0, $gJT7h.default).modelsById[this.projectId];
    }
    get phase() {
        return (0, $XoImS.default).modelsById[this.phaseId];
    }
    get amountAdjustedByLikelihood() {
        var _this$phase, _this$phase2;
        if ([
            "prospective",
            "onHold"
        ].includes((_this$phase = this.phase) === null || _this$phase === void 0 ? void 0 : _this$phase.status) && (_this$phase2 = this.phase) !== null && _this$phase2 !== void 0 && _this$phase2.percentLikelihood) {
            var _this$phase3;
            return this.amount * (((_this$phase3 = this.phase) === null || _this$phase3 === void 0 ? void 0 : _this$phase3.percentLikelihood) / 100);
        } else return this.amount;
    }
}, $5db1c31c91f90cf2$var$_descriptor = $5db1c31c91f90cf2$var$_applyDecoratedDescriptor($5db1c31c91f90cf2$var$_class.prototype, "projectId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $5db1c31c91f90cf2$var$_descriptor2 = $5db1c31c91f90cf2$var$_applyDecoratedDescriptor($5db1c31c91f90cf2$var$_class.prototype, "phaseId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $5db1c31c91f90cf2$var$_descriptor3 = $5db1c31c91f90cf2$var$_applyDecoratedDescriptor($5db1c31c91f90cf2$var$_class.prototype, "date", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Date();
    }
}), $5db1c31c91f90cf2$var$_descriptor4 = $5db1c31c91f90cf2$var$_applyDecoratedDescriptor($5db1c31c91f90cf2$var$_class.prototype, "amount", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $5db1c31c91f90cf2$var$_applyDecoratedDescriptor($5db1c31c91f90cf2$var$_class.prototype, "project", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($5db1c31c91f90cf2$var$_class.prototype, "project"), $5db1c31c91f90cf2$var$_class.prototype), $5db1c31c91f90cf2$var$_applyDecoratedDescriptor($5db1c31c91f90cf2$var$_class.prototype, "phase", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($5db1c31c91f90cf2$var$_class.prototype, "phase"), $5db1c31c91f90cf2$var$_class.prototype), $5db1c31c91f90cf2$var$_applyDecoratedDescriptor($5db1c31c91f90cf2$var$_class.prototype, "amountAdjustedByLikelihood", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($5db1c31c91f90cf2$var$_class.prototype, "amountAdjustedByLikelihood"), $5db1c31c91f90cf2$var$_class.prototype), $5db1c31c91f90cf2$var$_class);
var $5db1c31c91f90cf2$export$2e2bcd8739ae039 = $5db1c31c91f90cf2$var$RevenueTargetModel;

});


parcelRegister("gkMXq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be447d82cecbe646$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "ChangeLogCollectionClass", function () { return $be447d82cecbe646$export$5f370d5d1485773b; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");
parcelRequire("sKZfS");

var $14RZh = parcelRequire("14RZh");
var $be447d82cecbe646$var$_dec, $be447d82cecbe646$var$_dec2, $be447d82cecbe646$var$_class;
function $be447d82cecbe646$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $be447d82cecbe646$var$ChangeLogCollection = ($be447d82cecbe646$var$_dec = (0, $4JcCM.action).bound, $be447d82cecbe646$var$_dec2 = (0, $4JcCM.action).bound, $be447d82cecbe646$var$_class = class ChangeLogCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "changeLogItems",
            modelClass: (0, $14RZh.default)
        });
        this.addLookup("changeLogItemsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("changeLogItemsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get changeLogItemsById() {
        return this.modelsById;
    }
    get changeLogItems() {
        return this.models;
    }
    get changeLogItemsById() {
        return this.modelsById;
    }
    addChangeLogItem(data) {
        this.add(data);
    }
    addChangeLogItems(data) {
        this.addMany(data);
    }
}, $be447d82cecbe646$var$_applyDecoratedDescriptor($be447d82cecbe646$var$_class.prototype, "addChangeLogItem", [
    $be447d82cecbe646$var$_dec
], Object.getOwnPropertyDescriptor($be447d82cecbe646$var$_class.prototype, "addChangeLogItem"), $be447d82cecbe646$var$_class.prototype), $be447d82cecbe646$var$_applyDecoratedDescriptor($be447d82cecbe646$var$_class.prototype, "addChangeLogItems", [
    $be447d82cecbe646$var$_dec2
], Object.getOwnPropertyDescriptor($be447d82cecbe646$var$_class.prototype, "addChangeLogItems"), $be447d82cecbe646$var$_class.prototype), $be447d82cecbe646$var$_class);
var $be447d82cecbe646$export$2e2bcd8739ae039 = new $be447d82cecbe646$var$ChangeLogCollection();
const $be447d82cecbe646$export$5f370d5d1485773b = $be447d82cecbe646$var$ChangeLogCollection;

});
parcelRegister("14RZh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c900af5eefcf883$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $gkMXq = parcelRequire("gkMXq");

var $XoImS = parcelRequire("XoImS");

var $gJT7h = parcelRequire("gJT7h");

var $3PpOX = parcelRequire("3PpOX");
var $0c900af5eefcf883$var$_class, $0c900af5eefcf883$var$_descriptor, $0c900af5eefcf883$var$_descriptor2, $0c900af5eefcf883$var$_descriptor3, $0c900af5eefcf883$var$_descriptor4, $0c900af5eefcf883$var$_descriptor5, $0c900af5eefcf883$var$_descriptor6, $0c900af5eefcf883$var$_descriptor7, $0c900af5eefcf883$var$_descriptor8;
function $0c900af5eefcf883$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $0c900af5eefcf883$var$_defineProperty(e, r, t) {
    return (r = $0c900af5eefcf883$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $0c900af5eefcf883$var$_toPropertyKey(t) {
    var i = $0c900af5eefcf883$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $0c900af5eefcf883$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $0c900af5eefcf883$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $0c900af5eefcf883$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $0c900af5eefcf883$var$ChangeLogModel = ($0c900af5eefcf883$var$_class = class ChangeLogModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $0c900af5eefcf883$var$_initializerDefineProperty(this, "date", $0c900af5eefcf883$var$_descriptor, this);
        $0c900af5eefcf883$var$_initializerDefineProperty(this, "title", $0c900af5eefcf883$var$_descriptor2, this);
        $0c900af5eefcf883$var$_initializerDefineProperty(this, "revenueType", $0c900af5eefcf883$var$_descriptor3, this);
        $0c900af5eefcf883$var$_initializerDefineProperty(this, "revenue", $0c900af5eefcf883$var$_descriptor4, this);
        $0c900af5eefcf883$var$_initializerDefineProperty(this, "expenses", $0c900af5eefcf883$var$_descriptor5, this);
        $0c900af5eefcf883$var$_initializerDefineProperty(this, "percentProgress", $0c900af5eefcf883$var$_descriptor6, this);
        $0c900af5eefcf883$var$_initializerDefineProperty(this, "projectId", $0c900af5eefcf883$var$_descriptor7, this);
        $0c900af5eefcf883$var$_initializerDefineProperty(this, "phaseId", $0c900af5eefcf883$var$_descriptor8, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $gkMXq.default);
        this.init(data, options);
    }
    get phase() {
        return (0, $XoImS.default).phasesById[this.phaseId];
    }
    get project() {
        return (0, $gJT7h.default).projectsById[this.projectId];
    }
}, $0c900af5eefcf883$var$_descriptor = $0c900af5eefcf883$var$_applyDecoratedDescriptor($0c900af5eefcf883$var$_class.prototype, "date", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $0c900af5eefcf883$var$_descriptor2 = $0c900af5eefcf883$var$_applyDecoratedDescriptor($0c900af5eefcf883$var$_class.prototype, "title", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $0c900af5eefcf883$var$_descriptor3 = $0c900af5eefcf883$var$_applyDecoratedDescriptor($0c900af5eefcf883$var$_class.prototype, "revenueType", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $0c900af5eefcf883$var$_descriptor4 = $0c900af5eefcf883$var$_applyDecoratedDescriptor($0c900af5eefcf883$var$_class.prototype, "revenue", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $0c900af5eefcf883$var$_descriptor5 = $0c900af5eefcf883$var$_applyDecoratedDescriptor($0c900af5eefcf883$var$_class.prototype, "expenses", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $0c900af5eefcf883$var$_descriptor6 = $0c900af5eefcf883$var$_applyDecoratedDescriptor($0c900af5eefcf883$var$_class.prototype, "percentProgress", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $0c900af5eefcf883$var$_descriptor7 = $0c900af5eefcf883$var$_applyDecoratedDescriptor($0c900af5eefcf883$var$_class.prototype, "projectId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $0c900af5eefcf883$var$_descriptor8 = $0c900af5eefcf883$var$_applyDecoratedDescriptor($0c900af5eefcf883$var$_class.prototype, "phaseId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $0c900af5eefcf883$var$_applyDecoratedDescriptor($0c900af5eefcf883$var$_class.prototype, "phase", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($0c900af5eefcf883$var$_class.prototype, "phase"), $0c900af5eefcf883$var$_class.prototype), $0c900af5eefcf883$var$_applyDecoratedDescriptor($0c900af5eefcf883$var$_class.prototype, "project", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($0c900af5eefcf883$var$_class.prototype, "project"), $0c900af5eefcf883$var$_class.prototype), $0c900af5eefcf883$var$_class);
var $0c900af5eefcf883$export$2e2bcd8739ae039 = $0c900af5eefcf883$var$ChangeLogModel;

});


parcelRegister("huUQP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cbd1566e9a199a7e$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "MonthlyAllocationCollectionClass", function () { return $cbd1566e9a199a7e$export$8c2a7cbfa9d4b9db; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $lM3jf = parcelRequire("lM3jf");

var $f44xu = parcelRequire("f44xu");

var $4hBm1 = parcelRequire("4hBm1");
var $cbd1566e9a199a7e$var$_dec, $cbd1566e9a199a7e$var$_dec2, $cbd1566e9a199a7e$var$_dec3, $cbd1566e9a199a7e$var$_class;
function $cbd1566e9a199a7e$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $cbd1566e9a199a7e$var$MonthlyAllocationCollection = ($cbd1566e9a199a7e$var$_dec = (0, $4JcCM.action).bound, $cbd1566e9a199a7e$var$_dec2 = (0, $4JcCM.action).bound, $cbd1566e9a199a7e$var$_dec3 = (0, $4JcCM.action).bound, $cbd1566e9a199a7e$var$_class = class MonthlyAllocationCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "monthlyAllocations",
            modelClass: (0, $lM3jf.default)
        });
        this.addLookup("allocationsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByStaffId", "manyByKey", {
            key: (t)=>t.staffId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByRoleId", "manyByKey", {
            key: (t)=>{
                var _t$staff;
                return t.roleId || ((_t$staff = t.staff) === null || _t$staff === void 0 ? void 0 : _t$staff.roleId);
            },
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByTaskId", "manyByKey", {
            key: (t)=>t.taskId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByCostCentreId", "manyByKey", {
            key: (t)=>t.costCentreId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByStaffIdDate", "manyByKey", {
            key: (t)=>(0, $f44xu.default)(t.staffId, t.date.getTime()),
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByStaffIdWeek", "manyByKey", {
            key: (t)=>{
                return (0, $f44xu.default)(t.staffId, t.week);
            },
            filter: (t)=>!t.deletedAt
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get allocationsById() {
        return this.modelsById;
    }
    get allocations() {
        return this.models;
    }
    get allocationsById() {
        return this.modelsById;
    }
    addAllocation(data, options) {
        this.add(data, options);
    }
    addAllocations(data, options) {
        this.addMany(data, options);
    }
    addAllocationsAcrossDateRange(dateRange, data, options) {
        const workingDays = [];
        let date = dateRange[0];
        while(date <= dateRange[1]){
            if (!(0, $4hBm1.isWeekend)(date)) workingDays.push(date);
            date = (0, $4hBm1.addDays)(date, 1);
        }
        const numMinutes = data.numMinutes / workingDays.length;
        this.addMany(workingDays.map((date)=>({
                ...data,
                date: date,
                numMinutes: numMinutes
            })), options);
    }
}, $cbd1566e9a199a7e$var$_applyDecoratedDescriptor($cbd1566e9a199a7e$var$_class.prototype, "addAllocation", [
    $cbd1566e9a199a7e$var$_dec
], Object.getOwnPropertyDescriptor($cbd1566e9a199a7e$var$_class.prototype, "addAllocation"), $cbd1566e9a199a7e$var$_class.prototype), $cbd1566e9a199a7e$var$_applyDecoratedDescriptor($cbd1566e9a199a7e$var$_class.prototype, "addAllocations", [
    $cbd1566e9a199a7e$var$_dec2
], Object.getOwnPropertyDescriptor($cbd1566e9a199a7e$var$_class.prototype, "addAllocations"), $cbd1566e9a199a7e$var$_class.prototype), $cbd1566e9a199a7e$var$_applyDecoratedDescriptor($cbd1566e9a199a7e$var$_class.prototype, "addAllocationsAcrossDateRange", [
    $cbd1566e9a199a7e$var$_dec3
], Object.getOwnPropertyDescriptor($cbd1566e9a199a7e$var$_class.prototype, "addAllocationsAcrossDateRange"), $cbd1566e9a199a7e$var$_class.prototype), $cbd1566e9a199a7e$var$_class);
var $cbd1566e9a199a7e$export$2e2bcd8739ae039 = new $cbd1566e9a199a7e$var$MonthlyAllocationCollection();
const $cbd1566e9a199a7e$export$8c2a7cbfa9d4b9db = $cbd1566e9a199a7e$var$MonthlyAllocationCollection;

});
parcelRegister("lM3jf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fda0a5e0d90e47b0$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $htkeB = parcelRequire("htkeB");

var $gJT7h = parcelRequire("gJT7h");

var $XoImS = parcelRequire("XoImS");
parcelRequire("keGWP");

var $3PpOX = parcelRequire("3PpOX");

var $huUQP = parcelRequire("huUQP");
parcelRequire("eNcHX");

var $4hBm1 = parcelRequire("4hBm1");

var $bxXv3 = parcelRequire("bxXv3");
var $fda0a5e0d90e47b0$var$_class, $fda0a5e0d90e47b0$var$_descriptor, $fda0a5e0d90e47b0$var$_descriptor2, $fda0a5e0d90e47b0$var$_descriptor3, $fda0a5e0d90e47b0$var$_descriptor4, $fda0a5e0d90e47b0$var$_descriptor5, $fda0a5e0d90e47b0$var$_descriptor6, $fda0a5e0d90e47b0$var$_descriptor7, $fda0a5e0d90e47b0$var$_descriptor8, $fda0a5e0d90e47b0$var$_descriptor9, $fda0a5e0d90e47b0$var$_descriptor10;
function $fda0a5e0d90e47b0$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $fda0a5e0d90e47b0$var$_defineProperty(e, r, t) {
    return (r = $fda0a5e0d90e47b0$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fda0a5e0d90e47b0$var$_toPropertyKey(t) {
    var i = $fda0a5e0d90e47b0$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $fda0a5e0d90e47b0$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $fda0a5e0d90e47b0$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $fda0a5e0d90e47b0$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $fda0a5e0d90e47b0$var$MonthlyAllocationModel = ($fda0a5e0d90e47b0$var$_class = class MonthlyAllocationModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $fda0a5e0d90e47b0$var$_initializerDefineProperty(this, "staffId", $fda0a5e0d90e47b0$var$_descriptor, this);
        $fda0a5e0d90e47b0$var$_initializerDefineProperty(this, "roleId", $fda0a5e0d90e47b0$var$_descriptor2, this);
        $fda0a5e0d90e47b0$var$_initializerDefineProperty(this, "projectId", $fda0a5e0d90e47b0$var$_descriptor3, this);
        $fda0a5e0d90e47b0$var$_initializerDefineProperty(this, "phaseId", $fda0a5e0d90e47b0$var$_descriptor4, this);
        $fda0a5e0d90e47b0$var$_initializerDefineProperty(this, "month", $fda0a5e0d90e47b0$var$_descriptor5, this);
        $fda0a5e0d90e47b0$var$_initializerDefineProperty(this, "numMinutes", $fda0a5e0d90e47b0$var$_descriptor6, this);
        $fda0a5e0d90e47b0$var$_initializerDefineProperty(this, "startMinutes", $fda0a5e0d90e47b0$var$_descriptor7, this);
        $fda0a5e0d90e47b0$var$_initializerDefineProperty(this, "pay", $fda0a5e0d90e47b0$var$_descriptor8, this);
        $fda0a5e0d90e47b0$var$_initializerDefineProperty(this, "cost", $fda0a5e0d90e47b0$var$_descriptor9, this);
        $fda0a5e0d90e47b0$var$_initializerDefineProperty(this, "charge_out", $fda0a5e0d90e47b0$var$_descriptor10, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $huUQP.default);
        this.init(data, options);
    }
    get staff() {
        return (0, $htkeB.default).staffsById[this.staffId];
    }
    get role() {
        var _this$staff;
        return (0, $bxXv3.default).rolesById[this.roleId] || ((_this$staff = this.staff) === null || _this$staff === void 0 ? void 0 : _this$staff.role);
    }
    get costCentre() {
        return this.project.costCentre;
    }
    get project() {
        return (0, $gJT7h.default).modelsById[this.projectId];
    }
    get phase() {
        return (0, $XoImS.default).modelsById[this.phaseId];
    }
    get hours() {
        return this.numMinutes / 60;
    }
    get payRate() {
        return this.pay / this.hours;
    }
    get costRate() {
        return this.cost / this.hours;
    }
    get chargeOutRate() {
        return this.chargeOut / this.hours;
    }
    get week() {
        return (0, $4hBm1.getWeek)(this.date, {
            weekStartsOn: 1
        });
    }
    get date() {
        return (0, $4hBm1.startOfMonth)((0, $4hBm1.parse)(this.month, "yyyy-MM", new Date()));
    }
    get likelihood() {
        var _this$phase;
        return ((_this$phase = this.phase) === null || _this$phase === void 0 ? void 0 : _this$phase.likelihood) || 100;
    }
}, $fda0a5e0d90e47b0$var$_descriptor = $fda0a5e0d90e47b0$var$_applyDecoratedDescriptor($fda0a5e0d90e47b0$var$_class.prototype, "staffId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $fda0a5e0d90e47b0$var$_descriptor2 = $fda0a5e0d90e47b0$var$_applyDecoratedDescriptor($fda0a5e0d90e47b0$var$_class.prototype, "roleId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $fda0a5e0d90e47b0$var$_descriptor3 = $fda0a5e0d90e47b0$var$_applyDecoratedDescriptor($fda0a5e0d90e47b0$var$_class.prototype, "projectId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $fda0a5e0d90e47b0$var$_descriptor4 = $fda0a5e0d90e47b0$var$_applyDecoratedDescriptor($fda0a5e0d90e47b0$var$_class.prototype, "phaseId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $fda0a5e0d90e47b0$var$_descriptor5 = $fda0a5e0d90e47b0$var$_applyDecoratedDescriptor($fda0a5e0d90e47b0$var$_class.prototype, "month", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return (0, $4hBm1.format)(new Date(), "yyyy-MM");
    }
}), $fda0a5e0d90e47b0$var$_descriptor6 = $fda0a5e0d90e47b0$var$_applyDecoratedDescriptor($fda0a5e0d90e47b0$var$_class.prototype, "numMinutes", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $fda0a5e0d90e47b0$var$_descriptor7 = $fda0a5e0d90e47b0$var$_applyDecoratedDescriptor($fda0a5e0d90e47b0$var$_class.prototype, "startMinutes", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $fda0a5e0d90e47b0$var$_descriptor8 = $fda0a5e0d90e47b0$var$_applyDecoratedDescriptor($fda0a5e0d90e47b0$var$_class.prototype, "pay", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $fda0a5e0d90e47b0$var$_descriptor9 = $fda0a5e0d90e47b0$var$_applyDecoratedDescriptor($fda0a5e0d90e47b0$var$_class.prototype, "cost", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $fda0a5e0d90e47b0$var$_descriptor10 = $fda0a5e0d90e47b0$var$_applyDecoratedDescriptor($fda0a5e0d90e47b0$var$_class.prototype, "charge_out", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $fda0a5e0d90e47b0$var$_applyDecoratedDescriptor($fda0a5e0d90e47b0$var$_class.prototype, "staff", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($fda0a5e0d90e47b0$var$_class.prototype, "staff"), $fda0a5e0d90e47b0$var$_class.prototype), $fda0a5e0d90e47b0$var$_applyDecoratedDescriptor($fda0a5e0d90e47b0$var$_class.prototype, "role", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($fda0a5e0d90e47b0$var$_class.prototype, "role"), $fda0a5e0d90e47b0$var$_class.prototype), $fda0a5e0d90e47b0$var$_applyDecoratedDescriptor($fda0a5e0d90e47b0$var$_class.prototype, "costCentre", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($fda0a5e0d90e47b0$var$_class.prototype, "costCentre"), $fda0a5e0d90e47b0$var$_class.prototype), $fda0a5e0d90e47b0$var$_applyDecoratedDescriptor($fda0a5e0d90e47b0$var$_class.prototype, "project", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($fda0a5e0d90e47b0$var$_class.prototype, "project"), $fda0a5e0d90e47b0$var$_class.prototype), $fda0a5e0d90e47b0$var$_applyDecoratedDescriptor($fda0a5e0d90e47b0$var$_class.prototype, "phase", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($fda0a5e0d90e47b0$var$_class.prototype, "phase"), $fda0a5e0d90e47b0$var$_class.prototype), $fda0a5e0d90e47b0$var$_applyDecoratedDescriptor($fda0a5e0d90e47b0$var$_class.prototype, "hours", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($fda0a5e0d90e47b0$var$_class.prototype, "hours"), $fda0a5e0d90e47b0$var$_class.prototype), $fda0a5e0d90e47b0$var$_applyDecoratedDescriptor($fda0a5e0d90e47b0$var$_class.prototype, "payRate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($fda0a5e0d90e47b0$var$_class.prototype, "payRate"), $fda0a5e0d90e47b0$var$_class.prototype), $fda0a5e0d90e47b0$var$_applyDecoratedDescriptor($fda0a5e0d90e47b0$var$_class.prototype, "costRate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($fda0a5e0d90e47b0$var$_class.prototype, "costRate"), $fda0a5e0d90e47b0$var$_class.prototype), $fda0a5e0d90e47b0$var$_applyDecoratedDescriptor($fda0a5e0d90e47b0$var$_class.prototype, "chargeOutRate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($fda0a5e0d90e47b0$var$_class.prototype, "chargeOutRate"), $fda0a5e0d90e47b0$var$_class.prototype), $fda0a5e0d90e47b0$var$_applyDecoratedDescriptor($fda0a5e0d90e47b0$var$_class.prototype, "week", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($fda0a5e0d90e47b0$var$_class.prototype, "week"), $fda0a5e0d90e47b0$var$_class.prototype), $fda0a5e0d90e47b0$var$_applyDecoratedDescriptor($fda0a5e0d90e47b0$var$_class.prototype, "date", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($fda0a5e0d90e47b0$var$_class.prototype, "date"), $fda0a5e0d90e47b0$var$_class.prototype), $fda0a5e0d90e47b0$var$_applyDecoratedDescriptor($fda0a5e0d90e47b0$var$_class.prototype, "likelihood", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($fda0a5e0d90e47b0$var$_class.prototype, "likelihood"), $fda0a5e0d90e47b0$var$_class.prototype), $fda0a5e0d90e47b0$var$_class);
var $fda0a5e0d90e47b0$export$2e2bcd8739ae039 = $fda0a5e0d90e47b0$var$MonthlyAllocationModel;

});


parcelRegister("fFfyp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b676c007e600c7cc$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "WeeklyAllocationCollectionClass", function () { return $b676c007e600c7cc$export$8832f0b03729b15f; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $dlYZ5 = parcelRequire("dlYZ5");

var $f44xu = parcelRequire("f44xu");

var $4hBm1 = parcelRequire("4hBm1");
var $b676c007e600c7cc$var$_dec, $b676c007e600c7cc$var$_dec2, $b676c007e600c7cc$var$_dec3, $b676c007e600c7cc$var$_class;
function $b676c007e600c7cc$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $b676c007e600c7cc$var$WeeklyAllocationCollection = ($b676c007e600c7cc$var$_dec = (0, $4JcCM.action).bound, $b676c007e600c7cc$var$_dec2 = (0, $4JcCM.action).bound, $b676c007e600c7cc$var$_dec3 = (0, $4JcCM.action).bound, $b676c007e600c7cc$var$_class = class WeeklyAllocationCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "weeklyAllocations",
            modelClass: (0, $dlYZ5.default)
        });
        this.addLookup("allocationsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByStaffId", "manyByKey", {
            key: (t)=>t.staffId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByRoleId", "manyByKey", {
            key: (t)=>{
                var _t$staff;
                return t.roleId || ((_t$staff = t.staff) === null || _t$staff === void 0 ? void 0 : _t$staff.roleId);
            },
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByTaskId", "manyByKey", {
            key: (t)=>t.taskId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByCostCentreId", "manyByKey", {
            key: (t)=>t.costCentreId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByStaffIdDate", "manyByKey", {
            key: (t)=>(0, $f44xu.default)(t.staffId, t.date.getTime()),
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByStaffIdWeek", "manyByKey", {
            key: (t)=>{
                return (0, $f44xu.default)(t.staffId, t.week);
            },
            filter: (t)=>!t.deletedAt
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get allocationsById() {
        return this.modelsById;
    }
    get allocations() {
        return this.models;
    }
    get allocationsById() {
        return this.modelsById;
    }
    addAllocation(data, options) {
        this.add(data, options);
    }
    addAllocations(data, options) {
        this.addMany(data, options);
    }
    addAllocationsAcrossDateRange(dateRange, data, options) {
        const workingDays = [];
        let date = dateRange[0];
        while(date <= dateRange[1]){
            if (!(0, $4hBm1.isWeekend)(date)) workingDays.push(date);
            date = (0, $4hBm1.addDays)(date, 1);
        }
        const numMinutes = data.numMinutes / workingDays.length;
        this.addMany(workingDays.map((date)=>({
                ...data,
                date: date,
                numMinutes: numMinutes
            })), options);
    }
}, $b676c007e600c7cc$var$_applyDecoratedDescriptor($b676c007e600c7cc$var$_class.prototype, "addAllocation", [
    $b676c007e600c7cc$var$_dec
], Object.getOwnPropertyDescriptor($b676c007e600c7cc$var$_class.prototype, "addAllocation"), $b676c007e600c7cc$var$_class.prototype), $b676c007e600c7cc$var$_applyDecoratedDescriptor($b676c007e600c7cc$var$_class.prototype, "addAllocations", [
    $b676c007e600c7cc$var$_dec2
], Object.getOwnPropertyDescriptor($b676c007e600c7cc$var$_class.prototype, "addAllocations"), $b676c007e600c7cc$var$_class.prototype), $b676c007e600c7cc$var$_applyDecoratedDescriptor($b676c007e600c7cc$var$_class.prototype, "addAllocationsAcrossDateRange", [
    $b676c007e600c7cc$var$_dec3
], Object.getOwnPropertyDescriptor($b676c007e600c7cc$var$_class.prototype, "addAllocationsAcrossDateRange"), $b676c007e600c7cc$var$_class.prototype), $b676c007e600c7cc$var$_class);
var $b676c007e600c7cc$export$2e2bcd8739ae039 = new $b676c007e600c7cc$var$WeeklyAllocationCollection();
const $b676c007e600c7cc$export$8832f0b03729b15f = $b676c007e600c7cc$var$WeeklyAllocationCollection;

});
parcelRegister("dlYZ5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b8c8ac1de5b221b$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $htkeB = parcelRequire("htkeB");

var $gJT7h = parcelRequire("gJT7h");

var $XoImS = parcelRequire("XoImS");
parcelRequire("keGWP");

var $3PpOX = parcelRequire("3PpOX");

var $fFfyp = parcelRequire("fFfyp");
parcelRequire("eNcHX");

var $4hBm1 = parcelRequire("4hBm1");

var $bxXv3 = parcelRequire("bxXv3");
var $9b8c8ac1de5b221b$var$_class, $9b8c8ac1de5b221b$var$_descriptor, $9b8c8ac1de5b221b$var$_descriptor2, $9b8c8ac1de5b221b$var$_descriptor3, $9b8c8ac1de5b221b$var$_descriptor4, $9b8c8ac1de5b221b$var$_descriptor5, $9b8c8ac1de5b221b$var$_descriptor6, $9b8c8ac1de5b221b$var$_descriptor7, $9b8c8ac1de5b221b$var$_descriptor8, $9b8c8ac1de5b221b$var$_descriptor9, $9b8c8ac1de5b221b$var$_descriptor10;
function $9b8c8ac1de5b221b$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $9b8c8ac1de5b221b$var$_defineProperty(e, r, t) {
    return (r = $9b8c8ac1de5b221b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $9b8c8ac1de5b221b$var$_toPropertyKey(t) {
    var i = $9b8c8ac1de5b221b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $9b8c8ac1de5b221b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $9b8c8ac1de5b221b$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $9b8c8ac1de5b221b$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $9b8c8ac1de5b221b$var$WeeklyAllocationModel = ($9b8c8ac1de5b221b$var$_class = class WeeklyAllocationModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $9b8c8ac1de5b221b$var$_initializerDefineProperty(this, "staffId", $9b8c8ac1de5b221b$var$_descriptor, this);
        $9b8c8ac1de5b221b$var$_initializerDefineProperty(this, "roleId", $9b8c8ac1de5b221b$var$_descriptor2, this);
        $9b8c8ac1de5b221b$var$_initializerDefineProperty(this, "projectId", $9b8c8ac1de5b221b$var$_descriptor3, this);
        $9b8c8ac1de5b221b$var$_initializerDefineProperty(this, "phaseId", $9b8c8ac1de5b221b$var$_descriptor4, this);
        $9b8c8ac1de5b221b$var$_initializerDefineProperty(this, "week", $9b8c8ac1de5b221b$var$_descriptor5, this);
        $9b8c8ac1de5b221b$var$_initializerDefineProperty(this, "numMinutes", $9b8c8ac1de5b221b$var$_descriptor6, this);
        $9b8c8ac1de5b221b$var$_initializerDefineProperty(this, "startMinutes", $9b8c8ac1de5b221b$var$_descriptor7, this);
        $9b8c8ac1de5b221b$var$_initializerDefineProperty(this, "pay", $9b8c8ac1de5b221b$var$_descriptor8, this);
        $9b8c8ac1de5b221b$var$_initializerDefineProperty(this, "cost", $9b8c8ac1de5b221b$var$_descriptor9, this);
        $9b8c8ac1de5b221b$var$_initializerDefineProperty(this, "charge_out", $9b8c8ac1de5b221b$var$_descriptor10, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $fFfyp.default);
        this.init(data, options);
    }
    get staff() {
        return (0, $htkeB.default).staffsById[this.staffId];
    }
    get role() {
        var _this$staff;
        return (0, $bxXv3.default).rolesById[this.roleId] || ((_this$staff = this.staff) === null || _this$staff === void 0 ? void 0 : _this$staff.role);
    }
    get costCentre() {
        return this.project.costCentre;
    }
    get project() {
        return (0, $gJT7h.default).modelsById[this.projectId];
    }
    get phase() {
        return (0, $XoImS.default).modelsById[this.phaseId];
    }
    get hours() {
        return this.numMinutes / 60;
    }
    get payRate() {
        return this.pay / this.hours;
    }
    get costRate() {
        return this.cost / this.hours;
    }
    get chargeOutRate() {
        return this.chargeOut / this.hours;
    }
    get month() {
        return (0, $4hBm1.format)(this.date, "yyyy-MM");
    }
    get date() {
        return (0, $4hBm1.startOfISOWeek)((0, $4hBm1.parse)(this.week, "RRRR-II", new Date(), {
            weekStartsOn: 1
        }));
    }
    get likelihood() {
        var _this$phase;
        return ((_this$phase = this.phase) === null || _this$phase === void 0 ? void 0 : _this$phase.likelihood) || 100;
    }
}, $9b8c8ac1de5b221b$var$_descriptor = $9b8c8ac1de5b221b$var$_applyDecoratedDescriptor($9b8c8ac1de5b221b$var$_class.prototype, "staffId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $9b8c8ac1de5b221b$var$_descriptor2 = $9b8c8ac1de5b221b$var$_applyDecoratedDescriptor($9b8c8ac1de5b221b$var$_class.prototype, "roleId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $9b8c8ac1de5b221b$var$_descriptor3 = $9b8c8ac1de5b221b$var$_applyDecoratedDescriptor($9b8c8ac1de5b221b$var$_class.prototype, "projectId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $9b8c8ac1de5b221b$var$_descriptor4 = $9b8c8ac1de5b221b$var$_applyDecoratedDescriptor($9b8c8ac1de5b221b$var$_class.prototype, "phaseId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $9b8c8ac1de5b221b$var$_descriptor5 = $9b8c8ac1de5b221b$var$_applyDecoratedDescriptor($9b8c8ac1de5b221b$var$_class.prototype, "week", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return (0, $4hBm1.format)(new Date(), "RRRR-II");
    }
}), $9b8c8ac1de5b221b$var$_descriptor6 = $9b8c8ac1de5b221b$var$_applyDecoratedDescriptor($9b8c8ac1de5b221b$var$_class.prototype, "numMinutes", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $9b8c8ac1de5b221b$var$_descriptor7 = $9b8c8ac1de5b221b$var$_applyDecoratedDescriptor($9b8c8ac1de5b221b$var$_class.prototype, "startMinutes", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $9b8c8ac1de5b221b$var$_descriptor8 = $9b8c8ac1de5b221b$var$_applyDecoratedDescriptor($9b8c8ac1de5b221b$var$_class.prototype, "pay", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $9b8c8ac1de5b221b$var$_descriptor9 = $9b8c8ac1de5b221b$var$_applyDecoratedDescriptor($9b8c8ac1de5b221b$var$_class.prototype, "cost", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $9b8c8ac1de5b221b$var$_descriptor10 = $9b8c8ac1de5b221b$var$_applyDecoratedDescriptor($9b8c8ac1de5b221b$var$_class.prototype, "charge_out", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $9b8c8ac1de5b221b$var$_applyDecoratedDescriptor($9b8c8ac1de5b221b$var$_class.prototype, "staff", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($9b8c8ac1de5b221b$var$_class.prototype, "staff"), $9b8c8ac1de5b221b$var$_class.prototype), $9b8c8ac1de5b221b$var$_applyDecoratedDescriptor($9b8c8ac1de5b221b$var$_class.prototype, "role", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($9b8c8ac1de5b221b$var$_class.prototype, "role"), $9b8c8ac1de5b221b$var$_class.prototype), $9b8c8ac1de5b221b$var$_applyDecoratedDescriptor($9b8c8ac1de5b221b$var$_class.prototype, "costCentre", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($9b8c8ac1de5b221b$var$_class.prototype, "costCentre"), $9b8c8ac1de5b221b$var$_class.prototype), $9b8c8ac1de5b221b$var$_applyDecoratedDescriptor($9b8c8ac1de5b221b$var$_class.prototype, "project", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($9b8c8ac1de5b221b$var$_class.prototype, "project"), $9b8c8ac1de5b221b$var$_class.prototype), $9b8c8ac1de5b221b$var$_applyDecoratedDescriptor($9b8c8ac1de5b221b$var$_class.prototype, "phase", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($9b8c8ac1de5b221b$var$_class.prototype, "phase"), $9b8c8ac1de5b221b$var$_class.prototype), $9b8c8ac1de5b221b$var$_applyDecoratedDescriptor($9b8c8ac1de5b221b$var$_class.prototype, "hours", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($9b8c8ac1de5b221b$var$_class.prototype, "hours"), $9b8c8ac1de5b221b$var$_class.prototype), $9b8c8ac1de5b221b$var$_applyDecoratedDescriptor($9b8c8ac1de5b221b$var$_class.prototype, "payRate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($9b8c8ac1de5b221b$var$_class.prototype, "payRate"), $9b8c8ac1de5b221b$var$_class.prototype), $9b8c8ac1de5b221b$var$_applyDecoratedDescriptor($9b8c8ac1de5b221b$var$_class.prototype, "costRate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($9b8c8ac1de5b221b$var$_class.prototype, "costRate"), $9b8c8ac1de5b221b$var$_class.prototype), $9b8c8ac1de5b221b$var$_applyDecoratedDescriptor($9b8c8ac1de5b221b$var$_class.prototype, "chargeOutRate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($9b8c8ac1de5b221b$var$_class.prototype, "chargeOutRate"), $9b8c8ac1de5b221b$var$_class.prototype), $9b8c8ac1de5b221b$var$_applyDecoratedDescriptor($9b8c8ac1de5b221b$var$_class.prototype, "month", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($9b8c8ac1de5b221b$var$_class.prototype, "month"), $9b8c8ac1de5b221b$var$_class.prototype), $9b8c8ac1de5b221b$var$_applyDecoratedDescriptor($9b8c8ac1de5b221b$var$_class.prototype, "date", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($9b8c8ac1de5b221b$var$_class.prototype, "date"), $9b8c8ac1de5b221b$var$_class.prototype), $9b8c8ac1de5b221b$var$_applyDecoratedDescriptor($9b8c8ac1de5b221b$var$_class.prototype, "likelihood", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($9b8c8ac1de5b221b$var$_class.prototype, "likelihood"), $9b8c8ac1de5b221b$var$_class.prototype), $9b8c8ac1de5b221b$var$_class);
var $9b8c8ac1de5b221b$export$2e2bcd8739ae039 = $9b8c8ac1de5b221b$var$WeeklyAllocationModel;

});




parcelRegister("fM2j4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7bd20c54fddca1b$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("7Fn0s");

var $4JcCM = parcelRequire("4JcCM");

var $gMPFt = parcelRequire("gMPFt");

var $iOQGT = parcelRequire("iOQGT");

var $7Vift = parcelRequire("7Vift");
parcelRequire("XoImS");

var $1BTI2 = parcelRequire("1BTI2");
parcelRequire("jbmdS");

var $khJQv = parcelRequire("khJQv");

var $hSUCJ = parcelRequire("hSUCJ");

var $gN0TC = parcelRequire("gN0TC");

var $cfp1m = parcelRequire("cfp1m");

var $26CpJ = parcelRequire("26CpJ");

var $cv7Es = parcelRequire("cv7Es");

var $iKbxs = parcelRequire("iKbxs");

var $8kZ1o = parcelRequire("8kZ1o");

var $ixbie = parcelRequire("ixbie");

var $kRqe9 = parcelRequire("kRqe9");

var $3H03w = parcelRequire("3H03w");

var $3h7sC = parcelRequire("3h7sC");

var $6Q5sp = parcelRequire("6Q5sp");
var $b7bd20c54fddca1b$var$_dec, $b7bd20c54fddca1b$var$_dec2, $b7bd20c54fddca1b$var$_dec3, $b7bd20c54fddca1b$var$_dec4, $b7bd20c54fddca1b$var$_dec5, $b7bd20c54fddca1b$var$_dec6, $b7bd20c54fddca1b$var$_dec7, $b7bd20c54fddca1b$var$_dec8, $b7bd20c54fddca1b$var$_dec9, $b7bd20c54fddca1b$var$_class, $b7bd20c54fddca1b$var$_descriptor, $b7bd20c54fddca1b$var$_descriptor2, $b7bd20c54fddca1b$var$_descriptor3, $b7bd20c54fddca1b$var$_descriptor4, $b7bd20c54fddca1b$var$_descriptor5, $b7bd20c54fddca1b$var$_descriptor6, $b7bd20c54fddca1b$var$_descriptor7;
function $b7bd20c54fddca1b$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $b7bd20c54fddca1b$var$_defineProperty(e, r, t) {
    return (r = $b7bd20c54fddca1b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $b7bd20c54fddca1b$var$_toPropertyKey(t) {
    var i = $b7bd20c54fddca1b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $b7bd20c54fddca1b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $b7bd20c54fddca1b$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $b7bd20c54fddca1b$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $b7bd20c54fddca1b$var$DataStore = ($b7bd20c54fddca1b$var$_dec = (0, $4JcCM.action).bound, $b7bd20c54fddca1b$var$_dec2 = (0, $4JcCM.action).bound, $b7bd20c54fddca1b$var$_dec3 = (0, $4JcCM.action).bound, $b7bd20c54fddca1b$var$_dec4 = (0, $4JcCM.action).bound, $b7bd20c54fddca1b$var$_dec5 = (0, $4JcCM.action).bound, $b7bd20c54fddca1b$var$_dec6 = (0, $4JcCM.action).bound, $b7bd20c54fddca1b$var$_dec7 = (0, $4JcCM.action).bound, $b7bd20c54fddca1b$var$_dec8 = (0, $4JcCM.action).bound, $b7bd20c54fddca1b$var$_dec9 = (0, $4JcCM.action).bound, $b7bd20c54fddca1b$var$_class = class DataStore {
    constructor(props){
        $b7bd20c54fddca1b$var$_initializerDefineProperty(this, "state", $b7bd20c54fddca1b$var$_descriptor, this);
        // fetching, success, error
        $b7bd20c54fddca1b$var$_initializerDefineProperty(this, "rawData", $b7bd20c54fddca1b$var$_descriptor2, this);
        $b7bd20c54fddca1b$var$_initializerDefineProperty(this, "saveState", $b7bd20c54fddca1b$var$_descriptor3, this);
        $b7bd20c54fddca1b$var$_initializerDefineProperty(this, "autosave", $b7bd20c54fddca1b$var$_descriptor4, this);
        $b7bd20c54fddca1b$var$_initializerDefineProperty(this, "lastSaveAttemptAt", $b7bd20c54fddca1b$var$_descriptor5, this);
        $b7bd20c54fddca1b$var$_initializerDefineProperty(this, "saveFunctions", $b7bd20c54fddca1b$var$_descriptor6, this);
        $b7bd20c54fddca1b$var$_initializerDefineProperty(this, "funcUpdatedAt", $b7bd20c54fddca1b$var$_descriptor7, this);
        $b7bd20c54fddca1b$var$_defineProperty(this, "idsToSave", new Set());
        (0, $4JcCM.makeObservable)(this);
        (0, $4JcCM.reaction)(()=>this.updatedAt, this.whenNeedsSaving);
        // autosave
        (0, $4JcCM.reaction)(()=>this.updatedAt, this.startAutosave);
        (0, $4JcCM.reaction)(()=>this.funcUpdatedAt, this.startAutosave);
        this.debouncedStartSave = (0, (/*@__PURE__*/$parcel$interopDefault($ixbie)))(this.startSave.bind(this), 500);
    }
    addSaveFunction(id, f) {
        this.saveFunctions[id] = f;
        this.saveState = "needsSaving";
        this.funcUpdatedAt = Date.now();
    }
    setAutosave(autosave) {
        this.autosave = autosave;
    }
    async startAutosave() {
        if (this.autosave) this.debouncedStartSave();
    }
    whenNeedsSaving() {
        if (this.needsSaving) this.saveState = "needsSaving";
    }
    get needsSaving() {
        return (0, $7Vift.autoSaveCollections).some((c)=>c.needsSaving) || (0, $7Vift.autoSaveCollections).some((c)=>c.updatedAt > this.lastSaveAttemptAt) || (0, $26CpJ.default).needsSaving || (0, $cv7Es.default).needsSaving || Object.values(this.saveFunctions).length > 0;
    }
    get updatedAt() {
        return Math.max(...(0, $7Vift.autoSaveCollections).map((c)=>c.updatedAt));
    }
    async retrySave() {
        this.saveState = "idle";
        await this.startSave();
    }
    destroyNewItems(idProp, id) {
        if (this.saveState !== "saving") (0, $7Vift.autoSaveCollections).forEach((c)=>{
            c.newUnsavedModels.forEach((m)=>{
                if (m.id === id || m[idProp] === id) {
                    if (c.collection === "invoiceLineItems") {
                        m.timeEntries.forEach((te)=>{
                            te.update({
                                beenInvoiced: false
                            });
                        });
                        m.expenseItems.forEach((ei)=>{
                            ei.update({
                                beenInvoiced: false
                            });
                        });
                    }
                    c.delete(m.id);
                }
            });
        });
        if (!this.needsSaving) this.saveState = "idle";
    }
    async startSave() {
        if (this.needsSaving && this.saveState !== "saving" //&&
        ) {
            this.saveState = "saving";
            const savedAt = Date.now();
            const saveData = {};
            const modals = {};
            const freshModels = [];
            const failedModels = [];
            (0, $7Vift.autoSaveCollections).forEach((c)=>{
                if (c.needsSaving) {
                    freshModels.push(...c.modelsToSave.filter((m)=>!m.failedToSave));
                    failedModels.push(...c.modelsToSave.filter((m)=>m.failedToSave));
                }
            });
            const trySavingFailedModels = !freshModels.length;
            let modelsInBatch = trySavingFailedModels ? failedModels : freshModels;
            modelsInBatch.forEach((m)=>{
                var _m$collection$collect, _saveData$_m$collecti;
                (_saveData$_m$collecti = saveData[_m$collection$collect = m.collection.collection]) !== null && _saveData$_m$collecti !== void 0 ? _saveData$_m$collecti : saveData[_m$collection$collect] = [];
                saveData[m.collection.collection].push(this.serializeModel(m));
            });
            try {
                const newIds = await (0, $3h7sC.trpc).legacy.saveData.mutate(saveData);
                if (trySavingFailedModels) modelsInBatch.forEach((m)=>{
                    m.failedToSave = false;
                });
                modelsInBatch = [];
                Object.entries(newIds).forEach(([collection, idLookup])=>{
                    const c = (0, $7Vift.CollectionLookup)[collection];
                    Object.values(idLookup).forEach((id)=>{
                        c.update(id, {}, {
                            trackUpdates: false,
                            savedAt: savedAt
                        });
                    });
                });
                this.saveState = "success";
                this.idsToSave = new Set();
                $b7bd20c54fddca1b$var$openAdjustForecastModal(saveData, modals);
                Object.values(modals).forEach((modal)=>{
                    (0, $khJQv.default).openModal(modal);
                });
                const saveFunctions = Object.entries(this.saveFunctions);
                for (const [id, f] of Object.entries(this.saveFunctions))try {
                    const test = await f();
                    delete this.saveFunctions[id];
                } catch (e) {
                    console.error(`Error saving function with id ${id}: ${e}`);
                    throw e;
                }
                if (this.needsSaving) this.startSave();
                else setTimeout(()=>{
                    if (this.saveState === "success") this.saveState = "idle";
                }, 1000);
            } catch (e) {
                modelsInBatch.forEach((m)=>{
                    m.failedToSave = true;
                });
                $iKbxs.captureException(e);
                (0, $3H03w.default).captureException(e);
                console.error(e.message);
                this.saveState = "error";
            }
            await (0, $cv7Es.default).startSave();
            await (0, $26CpJ.default).startSave();
            (0, $1BTI2.default).checkIfUpdateIsAvailable();
        }
    }
    serializeModel(model) {
        let data = model.serializeUpdates();
        Object.keys(data).forEach((field)=>{
            if ([
                "id",
                "id",
                "updatedAt",
                "deletedAt",
                "createdAt"
            ].includes(field)) return;
        });
        return data;
    }
    async saveModel(model) {
        this.saveState = "saving";
        const savedAt = Date.now();
        const saveData = {};
        try {
            saveData[model.collection.collection] = [
                this.serializeModel(model)
            ];
            const newIds = await (0, $3h7sC.trpc).legacy.saveData.mutate(saveData);
            this.saveState = "success";
            (0, $6Q5sp.queryClient).invalidateQueries();
            if (this.needsSaving) this.startSave();
            else setTimeout(()=>{
                if (this.saveState === "success") this.saveState = "idle";
            }, 1000);
        } catch (e) {
            $iKbxs.captureException(e);
            (0, $3H03w.default).captureException(e);
            console.error(e.message);
            this.saveState = "error";
        }
    }
}, $b7bd20c54fddca1b$var$_descriptor = $b7bd20c54fddca1b$var$_applyDecoratedDescriptor($b7bd20c54fddca1b$var$_class.prototype, "state", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "uninitialized";
    }
}), $b7bd20c54fddca1b$var$_descriptor2 = $b7bd20c54fddca1b$var$_applyDecoratedDescriptor($b7bd20c54fddca1b$var$_class.prototype, "rawData", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $b7bd20c54fddca1b$var$_descriptor3 = $b7bd20c54fddca1b$var$_applyDecoratedDescriptor($b7bd20c54fddca1b$var$_class.prototype, "saveState", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "idle";
    }
}), $b7bd20c54fddca1b$var$_descriptor4 = $b7bd20c54fddca1b$var$_applyDecoratedDescriptor($b7bd20c54fddca1b$var$_class.prototype, "autosave", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $b7bd20c54fddca1b$var$_descriptor5 = $b7bd20c54fddca1b$var$_applyDecoratedDescriptor($b7bd20c54fddca1b$var$_class.prototype, "lastSaveAttemptAt", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return Date.now();
    }
}), $b7bd20c54fddca1b$var$_descriptor6 = $b7bd20c54fddca1b$var$_applyDecoratedDescriptor($b7bd20c54fddca1b$var$_class.prototype, "saveFunctions", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $b7bd20c54fddca1b$var$_descriptor7 = $b7bd20c54fddca1b$var$_applyDecoratedDescriptor($b7bd20c54fddca1b$var$_class.prototype, "funcUpdatedAt", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return Date.now();
    }
}), $b7bd20c54fddca1b$var$_applyDecoratedDescriptor($b7bd20c54fddca1b$var$_class.prototype, "addSaveFunction", [
    $b7bd20c54fddca1b$var$_dec
], Object.getOwnPropertyDescriptor($b7bd20c54fddca1b$var$_class.prototype, "addSaveFunction"), $b7bd20c54fddca1b$var$_class.prototype), $b7bd20c54fddca1b$var$_applyDecoratedDescriptor($b7bd20c54fddca1b$var$_class.prototype, "setAutosave", [
    $b7bd20c54fddca1b$var$_dec2
], Object.getOwnPropertyDescriptor($b7bd20c54fddca1b$var$_class.prototype, "setAutosave"), $b7bd20c54fddca1b$var$_class.prototype), $b7bd20c54fddca1b$var$_applyDecoratedDescriptor($b7bd20c54fddca1b$var$_class.prototype, "startAutosave", [
    $b7bd20c54fddca1b$var$_dec3
], Object.getOwnPropertyDescriptor($b7bd20c54fddca1b$var$_class.prototype, "startAutosave"), $b7bd20c54fddca1b$var$_class.prototype), $b7bd20c54fddca1b$var$_applyDecoratedDescriptor($b7bd20c54fddca1b$var$_class.prototype, "whenNeedsSaving", [
    $b7bd20c54fddca1b$var$_dec4
], Object.getOwnPropertyDescriptor($b7bd20c54fddca1b$var$_class.prototype, "whenNeedsSaving"), $b7bd20c54fddca1b$var$_class.prototype), $b7bd20c54fddca1b$var$_applyDecoratedDescriptor($b7bd20c54fddca1b$var$_class.prototype, "needsSaving", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($b7bd20c54fddca1b$var$_class.prototype, "needsSaving"), $b7bd20c54fddca1b$var$_class.prototype), $b7bd20c54fddca1b$var$_applyDecoratedDescriptor($b7bd20c54fddca1b$var$_class.prototype, "updatedAt", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($b7bd20c54fddca1b$var$_class.prototype, "updatedAt"), $b7bd20c54fddca1b$var$_class.prototype), $b7bd20c54fddca1b$var$_applyDecoratedDescriptor($b7bd20c54fddca1b$var$_class.prototype, "retrySave", [
    $b7bd20c54fddca1b$var$_dec5
], Object.getOwnPropertyDescriptor($b7bd20c54fddca1b$var$_class.prototype, "retrySave"), $b7bd20c54fddca1b$var$_class.prototype), $b7bd20c54fddca1b$var$_applyDecoratedDescriptor($b7bd20c54fddca1b$var$_class.prototype, "destroyNewItems", [
    $b7bd20c54fddca1b$var$_dec6
], Object.getOwnPropertyDescriptor($b7bd20c54fddca1b$var$_class.prototype, "destroyNewItems"), $b7bd20c54fddca1b$var$_class.prototype), $b7bd20c54fddca1b$var$_applyDecoratedDescriptor($b7bd20c54fddca1b$var$_class.prototype, "startSave", [
    $b7bd20c54fddca1b$var$_dec7
], Object.getOwnPropertyDescriptor($b7bd20c54fddca1b$var$_class.prototype, "startSave"), $b7bd20c54fddca1b$var$_class.prototype), $b7bd20c54fddca1b$var$_applyDecoratedDescriptor($b7bd20c54fddca1b$var$_class.prototype, "serializeModel", [
    $b7bd20c54fddca1b$var$_dec8
], Object.getOwnPropertyDescriptor($b7bd20c54fddca1b$var$_class.prototype, "serializeModel"), $b7bd20c54fddca1b$var$_class.prototype), $b7bd20c54fddca1b$var$_applyDecoratedDescriptor($b7bd20c54fddca1b$var$_class.prototype, "saveModel", [
    $b7bd20c54fddca1b$var$_dec9
], Object.getOwnPropertyDescriptor($b7bd20c54fddca1b$var$_class.prototype, "saveModel"), $b7bd20c54fddca1b$var$_class.prototype), $b7bd20c54fddca1b$var$_class);
var $b7bd20c54fddca1b$export$2e2bcd8739ae039 = new $b7bd20c54fddca1b$var$DataStore();
function $b7bd20c54fddca1b$var$timeout(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
const $b7bd20c54fddca1b$var$openAdjustForecastModal = (saveData, modals)=>{
    var _saveData$phases, _saveData$phases2, _saveData$invoiceLine, _saveData$changeLogIt, _saveData$changeLogIt2, _saveData$budgetedHou, _saveData$projectExpe;
    if ((0, $8kZ1o.neverAdjustForecasts)()) return;
    const adjustedDatesPhases = ((_saveData$phases = saveData.phases) === null || _saveData$phases === void 0 ? void 0 : _saveData$phases.length) && saveData.phases.filter((ph)=>ph.startDate || ph.endDate) || [];
    const adjustRevenueTargetPhaseIds = ((_saveData$phases2 = saveData.phases) === null || _saveData$phases2 === void 0 ? void 0 : _saveData$phases2.length) && saveData.phases.filter((ph)=>ph.fee != null || adjustedDatesPhases.includes(ph)).map((ph)=>ph.id) || [];
    const adjustInvoiceLineItemsPhaseIds = ((_saveData$invoiceLine = saveData.invoiceLineItems) === null || _saveData$invoiceLine === void 0 ? void 0 : _saveData$invoiceLine.length) && saveData.invoiceLineItems.filter((i)=>(i === null || i === void 0 ? void 0 : i.unitQuantity) != null || (i === null || i === void 0 ? void 0 : i.unitCost) != null || (i === null || i === void 0 ? void 0 : i.billingType)).map((i)=>{
        var _InvoiceLineItemColle;
        return (_InvoiceLineItemColle = (0, $kRqe9.default).invoiceLineItemsById[i.id]) === null || _InvoiceLineItemColle === void 0 ? void 0 : _InvoiceLineItemColle.phaseId;
    }) || [];
    const adjustChangeLogPhaseIds = ((_saveData$changeLogIt = saveData.changeLogItems) === null || _saveData$changeLogIt === void 0 ? void 0 : _saveData$changeLogIt.length) && ((_saveData$changeLogIt2 = saveData.changeLogItems) === null || _saveData$changeLogIt2 === void 0 ? void 0 : _saveData$changeLogIt2.map((c)=>c.phaseId)) || [];
    const adjustAllocationBudgetPhaseIds = [
        ...new Set([
            ...adjustedDatesPhases.map((ph)=>ph.id),
            ...((_saveData$budgetedHou = saveData.budgetedHours) === null || _saveData$budgetedHou === void 0 ? void 0 : _saveData$budgetedHou.length) && saveData.budgetedHours.map((b)=>(0, $hSUCJ.default).budgetsById[b.id].phaseId) || []
        ])
    ];
    const adjustAllocationProjectExpensePhaseIds = ((_saveData$projectExpe = saveData.projectExpenses) === null || _saveData$projectExpe === void 0 ? void 0 : _saveData$projectExpe.length) && saveData.projectExpenses.filter((e)=>e.cost != null || e.startDate || e.endDate).map((e)=>(0, $cfp1m.default).projectExpensesById[e.id].phaseId) || [];
    const adjustPhaseIds = [
        ...adjustRevenueTargetPhaseIds,
        ...adjustInvoiceLineItemsPhaseIds,
        ...adjustChangeLogPhaseIds
    ];
    if (adjustPhaseIds.length || adjustAllocationBudgetPhaseIds !== null && adjustAllocationBudgetPhaseIds !== void 0 && adjustAllocationBudgetPhaseIds.length || adjustAllocationProjectExpensePhaseIds !== null && adjustAllocationProjectExpensePhaseIds !== void 0 && adjustAllocationProjectExpensePhaseIds.length) {
        if ((0, $8kZ1o.shouldOpenUpdateForecastModalForRevenue)() && (adjustRevenueTargetPhaseIds !== null && adjustRevenueTargetPhaseIds !== void 0 && adjustRevenueTargetPhaseIds.length || adjustInvoiceLineItemsPhaseIds !== null && adjustInvoiceLineItemsPhaseIds !== void 0 && adjustInvoiceLineItemsPhaseIds.length || adjustAllocationProjectExpensePhaseIds !== null && adjustAllocationProjectExpensePhaseIds !== void 0 && adjustAllocationProjectExpensePhaseIds.length || adjustChangeLogPhaseIds !== null && adjustChangeLogPhaseIds !== void 0 && adjustChangeLogPhaseIds.length) || (0, $8kZ1o.shouldOpenUpdateForecastModalForResources)() && adjustAllocationBudgetPhaseIds !== null && adjustAllocationBudgetPhaseIds !== void 0 && adjustAllocationBudgetPhaseIds.length) {
            const modalId = "adjustFee" + (0, (/*@__PURE__*/$parcel$interopDefault($gN0TC)))();
            modals[modalId] = /*#__PURE__*/ (0, $61Ea1.jsx)((0, $gMPFt.default), {
                phaseIds: adjustPhaseIds,
                budgetPhaseIds: adjustAllocationBudgetPhaseIds,
                expensePhaseIds: adjustAllocationProjectExpensePhaseIds,
                revenue: Boolean((adjustPhaseIds === null || adjustPhaseIds === void 0 ? void 0 : adjustPhaseIds.length) || (adjustAllocationProjectExpensePhaseIds === null || adjustAllocationProjectExpensePhaseIds === void 0 ? void 0 : adjustAllocationProjectExpensePhaseIds.length)),
                hours: Boolean(adjustAllocationBudgetPhaseIds === null || adjustAllocationBudgetPhaseIds === void 0 ? void 0 : adjustAllocationBudgetPhaseIds.length),
                modalId: modalId
            });
        }
        if ((0, $8kZ1o.alwaysUpdateRevenue)() && adjustRevenueTargetPhaseIds !== null && adjustRevenueTargetPhaseIds !== void 0 && adjustRevenueTargetPhaseIds.length) {
            var _SessionStore$user, _SessionStore$organis, _SessionStore$organis2, _SessionStore$organis3, _SessionStore$organis4, _SessionStore$organis5, _SessionStore$organis6;
            (0, $iOQGT.makeRequest)({
                path: "https://server2.coincraft.co/auto-adjust/revenue",
                method: "POST",
                data: {
                    organisationId: (0, $1BTI2.default).organisation.id,
                    userId: (_SessionStore$user = (0, $1BTI2.default).user) === null || _SessionStore$user === void 0 ? void 0 : _SessionStore$user.id,
                    phaseIds: adjustPhaseIds,
                    budgetType: ((_SessionStore$organis = (0, $1BTI2.default).organisation.settings) === null || _SessionStore$organis === void 0 ? void 0 : (_SessionStore$organis2 = _SessionStore$organis.autoUpdateRevenue) === null || _SessionStore$organis2 === void 0 ? void 0 : _SessionStore$organis2.budget) || "remaining",
                    startDateType: ((_SessionStore$organis3 = (0, $1BTI2.default).organisation.settings) === null || _SessionStore$organis3 === void 0 ? void 0 : (_SessionStore$organis4 = _SessionStore$organis3.autoUpdateRevenue) === null || _SessionStore$organis4 === void 0 ? void 0 : _SessionStore$organis4.start) || "now",
                    endDateType: ((_SessionStore$organis5 = (0, $1BTI2.default).organisation.settings) === null || _SessionStore$organis5 === void 0 ? void 0 : (_SessionStore$organis6 = _SessionStore$organis5.autoUpdateRevenue) === null || _SessionStore$organis6 === void 0 ? void 0 : _SessionStore$organis6.end) || "endDate",
                    nowTs: Date.now()
                }
            });
        }
        if ((0, $8kZ1o.alwaysUpdateRevenue)() && adjustAllocationProjectExpensePhaseIds !== null && adjustAllocationProjectExpensePhaseIds !== void 0 && adjustAllocationProjectExpensePhaseIds.length) {
            var _SessionStore$user2, _SessionStore$organis7, _SessionStore$organis8, _SessionStore$organis9, _SessionStore$organis10, _SessionStore$organis11, _SessionStore$organis12;
            (0, $iOQGT.makeRequest)({
                path: "https://server2.coincraft.co/auto-adjust/expenses",
                method: "POST",
                data: {
                    organisationId: (0, $1BTI2.default).organisation.id,
                    userId: (_SessionStore$user2 = (0, $1BTI2.default).user) === null || _SessionStore$user2 === void 0 ? void 0 : _SessionStore$user2.id,
                    phaseIds: adjustAllocationProjectExpensePhaseIds,
                    budgetType: ((_SessionStore$organis7 = (0, $1BTI2.default).organisation.settings) === null || _SessionStore$organis7 === void 0 ? void 0 : (_SessionStore$organis8 = _SessionStore$organis7.autoUpdateRevenue) === null || _SessionStore$organis8 === void 0 ? void 0 : _SessionStore$organis8.budget) || "remaining",
                    startDateType: ((_SessionStore$organis9 = (0, $1BTI2.default).organisation.settings) === null || _SessionStore$organis9 === void 0 ? void 0 : (_SessionStore$organis10 = _SessionStore$organis9.autoUpdateRevenue) === null || _SessionStore$organis10 === void 0 ? void 0 : _SessionStore$organis10.start) || "now",
                    endDateType: ((_SessionStore$organis11 = (0, $1BTI2.default).organisation.settings) === null || _SessionStore$organis11 === void 0 ? void 0 : (_SessionStore$organis12 = _SessionStore$organis11.autoUpdateRevenue) === null || _SessionStore$organis12 === void 0 ? void 0 : _SessionStore$organis12.end) || "endDate",
                    nowTs: Date.now()
                }
            });
        }
        if ((0, $8kZ1o.alwaysUpdateHours)() && adjustAllocationBudgetPhaseIds !== null && adjustAllocationBudgetPhaseIds !== void 0 && adjustAllocationBudgetPhaseIds.length) {
            var _SessionStore$user3, _SessionStore$organis13, _SessionStore$organis14, _SessionStore$organis15, _SessionStore$organis16, _SessionStore$organis17, _SessionStore$organis18;
            (0, $iOQGT.makeRequest)({
                path: "https://server2.coincraft.co/auto-adjust/resources",
                method: "POST",
                data: {
                    organisationId: (0, $1BTI2.default).organisation.id,
                    userId: (_SessionStore$user3 = (0, $1BTI2.default).user) === null || _SessionStore$user3 === void 0 ? void 0 : _SessionStore$user3.id,
                    phaseIds: adjustAllocationBudgetPhaseIds,
                    budgetType: ((_SessionStore$organis13 = (0, $1BTI2.default).organisation.settings) === null || _SessionStore$organis13 === void 0 ? void 0 : (_SessionStore$organis14 = _SessionStore$organis13.autoUpdateHours) === null || _SessionStore$organis14 === void 0 ? void 0 : _SessionStore$organis14.budget) || "remaining",
                    startDateType: ((_SessionStore$organis15 = (0, $1BTI2.default).organisation.settings) === null || _SessionStore$organis15 === void 0 ? void 0 : (_SessionStore$organis16 = _SessionStore$organis15.autoUpdateHours) === null || _SessionStore$organis16 === void 0 ? void 0 : _SessionStore$organis16.start) || "now",
                    endDateType: ((_SessionStore$organis17 = (0, $1BTI2.default).organisation.settings) === null || _SessionStore$organis17 === void 0 ? void 0 : (_SessionStore$organis18 = _SessionStore$organis17.autoUpdateHours) === null || _SessionStore$organis18 === void 0 ? void 0 : _SessionStore$organis18.end) || "endDate",
                    nowTs: Date.now()
                }
            });
        }
    }
};

});
parcelRegister("gMPFt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3893536088ede9c$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $f44xu = parcelRequire("f44xu");
parcelRequire("eat5C");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $fEcKX = parcelRequire("fEcKX");

var $ewAM3 = parcelRequire("ewAM3");

var $fM2j4 = parcelRequire("fM2j4");
parcelRequire("4B1JG");

var $iOQGT = parcelRequire("iOQGT");

var $1BTI2 = parcelRequire("1BTI2");
// tuple (revenue, resourcing)
const $c3893536088ede9c$var$labels = new Map([
    [
        (0, $f44xu.default)(true, true),
        "Revenue Forecast & Resource Schedule"
    ],
    [
        (0, $f44xu.default)(true, false),
        "Revenue Forecast"
    ],
    [
        (0, $f44xu.default)(false, true),
        "Resource Schedule"
    ],
    [
        (0, $f44xu.default)(false, false),
        "Nothing"
    ]
]);
const $c3893536088ede9c$var$updateAmountOptions = {
    total: "Total Budget",
    remaining: "Remaining Budget"
};
const $c3893536088ede9c$var$updateFromOptions = {
    startDate: "Start Date",
    now: "Now",
    endDate: "End Date"
};
const $c3893536088ede9c$var$updateToOptions = {
    startDate: "Start Date",
    endDate: "End Date"
};
var $c3893536088ede9c$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ phaseIds: phaseIds, budgetPhaseIds: budgetPhaseIds, expensePhaseIds: expensePhaseIds, modalId: modalId, revenue: revenue, hours: hours })=>{
    var _SessionStore$organis, _SessionStore$organis2, _SessionStore$organis3, _SessionStore$organis4, _SessionStore$organis5, _SessionStore$organis6;
    const [adjustRevenue, setAdjustRevenue] = (0, $jbmdS.useState)(revenue);
    const [adjustResourcing, setAdjustResourcing] = (0, $jbmdS.useState)(hours);
    const [updateAmount, setUpdateAmount] = (0, $jbmdS.useState)(((_SessionStore$organis = (0, $1BTI2.default).organisation.settings) === null || _SessionStore$organis === void 0 ? void 0 : (_SessionStore$organis2 = _SessionStore$organis.autoUpdateHours) === null || _SessionStore$organis2 === void 0 ? void 0 : _SessionStore$organis2.budget) || "remaining");
    const [updateFrom, setUpdateFrom] = (0, $jbmdS.useState)(((_SessionStore$organis3 = (0, $1BTI2.default).organisation.settings) === null || _SessionStore$organis3 === void 0 ? void 0 : (_SessionStore$organis4 = _SessionStore$organis3.autoUpdateHours) === null || _SessionStore$organis4 === void 0 ? void 0 : _SessionStore$organis4.start) || "now");
    const [updateTo, setUpdateTo] = (0, $jbmdS.useState)(((_SessionStore$organis5 = (0, $1BTI2.default).organisation.settings) === null || _SessionStore$organis5 === void 0 ? void 0 : (_SessionStore$organis6 = _SessionStore$organis5.autoUpdateHours) === null || _SessionStore$organis6 === void 0 ? void 0 : _SessionStore$organis6.end) || "endDate");
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fEcKX.default), {
        modalId: modalId,
        heading: "Adjust Forecasts",
        onSave: ()=>{
            if (adjustRevenue && phaseIds !== null && phaseIds !== void 0 && phaseIds.length) {
                var _SessionStore$user;
                (0, $iOQGT.makeRequest)({
                    path: "https://server2.coincraft.co/auto-adjust/revenue",
                    method: "POST",
                    data: {
                        organisationId: (0, $1BTI2.default).organisation.id,
                        userId: (_SessionStore$user = (0, $1BTI2.default).user) === null || _SessionStore$user === void 0 ? void 0 : _SessionStore$user.id,
                        phaseIds: phaseIds,
                        budgetType: updateAmount,
                        startDateType: updateFrom,
                        endDateType: updateTo,
                        nowTs: Date.now()
                    }
                });
            }
            if (adjustRevenue && expensePhaseIds !== null && expensePhaseIds !== void 0 && expensePhaseIds.length) {
                var _SessionStore$user2;
                (0, $iOQGT.makeRequest)({
                    path: "https://server2.coincraft.co/auto-adjust/expenses",
                    method: "POST",
                    data: {
                        organisationId: (0, $1BTI2.default).organisation.id,
                        userId: (_SessionStore$user2 = (0, $1BTI2.default).user) === null || _SessionStore$user2 === void 0 ? void 0 : _SessionStore$user2.id,
                        phaseIds: expensePhaseIds,
                        budgetType: updateAmount,
                        startDateType: updateFrom,
                        endDateType: updateTo,
                        nowTs: Date.now()
                    }
                });
            }
            if (adjustResourcing && budgetPhaseIds !== null && budgetPhaseIds !== void 0 && budgetPhaseIds.length) {
                var _SessionStore$user3;
                (0, $iOQGT.makeRequest)({
                    path: "https://server2.coincraft.co/auto-adjust/resources",
                    method: "POST",
                    data: {
                        organisationId: (0, $1BTI2.default).organisation.id,
                        userId: (_SessionStore$user3 = (0, $1BTI2.default).user) === null || _SessionStore$user3 === void 0 ? void 0 : _SessionStore$user3.id,
                        phaseIds: budgetPhaseIds,
                        budgetType: updateAmount,
                        startDateType: updateFrom,
                        endDateType: updateTo,
                        nowTs: Date.now()
                    }
                });
            }
            (0, $fM2j4.default).startSave();
        },
        saveLabel: "Adjust Forecasts",
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    padding: "0 1em"
                },
                children: `Would you like to adjust your Project's ${$c3893536088ede9c$var$labels.get((0, $f44xu.default)(revenue, hours))} based on your new settings?`
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    padding: "1em"
                },
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                        children: "Adjust:"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                        style: {
                            margin: "0 1em",
                            width: "auto"
                        },
                        selectedOption: (0, $f44xu.default)(adjustRevenue, adjustResourcing),
                        options: [
                            ...Array.from($c3893536088ede9c$var$labels.keys()).filter((k)=>(revenue || !k[0]) && (hours || !k[1]))
                        ],
                        optionLabel: (o)=>$c3893536088ede9c$var$labels.get(o),
                        onChange: (tuple)=>{
                            setAdjustRevenue(tuple[0]);
                            setAdjustResourcing(tuple[1]);
                        },
                        variant: "secondary"
                    })
                ]
            }),
            adjustRevenue || adjustResourcing ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    padding: "2em 1em 0 1em",
                    borderTop: "1px solid #eee"
                },
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                        style: {
                            display: "inline-block"
                        },
                        children: "Distribute"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        style: {
                            margin: "0 1em",
                            width: "12em"
                        },
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                            style: {
                                width: "100%"
                            },
                            selectedOption: updateAmount,
                            onChange: setUpdateAmount,
                            options: Object.keys($c3893536088ede9c$var$updateAmountOptions),
                            optionLabel: (o)=>$c3893536088ede9c$var$updateAmountOptions[o],
                            variant: "secondary"
                        })
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                        style: {
                            display: "inline-block"
                        },
                        children: "between"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        style: {
                            margin: "0 1em",
                            width: "9em"
                        },
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                            style: {
                                width: "100%"
                            },
                            selectedOption: updateFrom,
                            onChange: setUpdateFrom,
                            options: Object.keys($c3893536088ede9c$var$updateFromOptions),
                            optionLabel: (o)=>$c3893536088ede9c$var$updateFromOptions[o],
                            variant: "secondary"
                        })
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                        style: {
                            display: "inline-block"
                        },
                        children: `>>`
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        style: {
                            margin: "0 1em",
                            width: "9em"
                        },
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                            style: {
                                width: "100%"
                            },
                            selectedOption: updateTo,
                            onChange: setUpdateTo,
                            options: Object.keys($c3893536088ede9c$var$updateToOptions),
                            optionLabel: (o)=>$c3893536088ede9c$var$updateToOptions[o],
                            variant: "secondary"
                        })
                    })
                ]
            }) : null
        ]
    });
});

});
parcelRegister("fEcKX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6447c93995ec1f6$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $khJQv = parcelRequire("khJQv");

var $ewAM3 = parcelRequire("ewAM3");
var $b6447c93995ec1f6$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ modalId: modalId, style: style, bodyStyle: bodyStyle, children: children, width: width, onClose: onClose, onSave: onSave, saveLabel: saveLabel, saveOptions: saveOptions, saveButtons: saveButtons, defaultSaveOption: defaultSaveOption, heading: heading, canSave: canSave = ()=>true, ...props })=>{
    const [selectedSaveOption, setSelectedSaveOption] = (0, $jbmdS.useState)(saveOptions !== null && saveOptions !== void 0 && saveOptions.length ? saveOptions.find((o)=>o.id === defaultSaveOption) || saveOptions[0] : null);
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "bg-black/50 z-[10003] fixed inset-0 overflow-y-scroll",
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            className: "flex max-h-[75%] my-[5em] mx-auto p-0 flex-col text-444 bg-white",
            style: {
                width: width || "40%",
                ...style
            },
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsx)($b6447c93995ec1f6$var$ModalHeader, {
                    children: heading
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)($b6447c93995ec1f6$var$ModalBody, {
                    style: bodyStyle,
                    children: children
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)($b6447c93995ec1f6$var$ModalFooter, {
                    onClose: ()=>{
                        onClose && onClose();
                        (0, $khJQv.default).closeModal(modalId);
                    },
                    onSave: async ()=>{
                        try {
                            if (onSave) await onSave(selectedSaveOption);
                            (0, $khJQv.default).closeModal(modalId);
                        } catch (e) {
                            console.error(e);
                        }
                    },
                    showSave: !!onSave,
                    saveLabel: saveLabel,
                    saveButtons: saveButtons,
                    saveOptions: saveOptions,
                    selectedSaveOption: selectedSaveOption,
                    setSelectedSaveOption: setSelectedSaveOption,
                    canSave: canSave,
                    closeModal: ()=>(0, $khJQv.default).closeModal(modalId)
                })
            ]
        })
    });
});
const $b6447c93995ec1f6$var$ModalHeader = (0, $1EEMt.observer)(({ children: children })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "flex-grow-0 flex-shrink-0 basis-auto py-1.5 px-4 border-b border-b-[#ccc] relative h-[53px] p-2.5",
        children: /*#__PURE__*/ (0, $61Ea1.jsx)("h3", {
            className: "mt-0",
            children: children
        })
    });
});
const $b6447c93995ec1f6$var$ModalBody = (0, $1EEMt.observer)(({ children: children, style: style })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "modal-body flex-1 p-[1em] relative overflow-y-auto",
        style: {
            ...style
        },
        children: children
    });
});
const $b6447c93995ec1f6$var$ModalFooter = (0, $1EEMt.observer)(({ onClose: onClose, onSave: onSave, saveLabel: saveLabel = "Save", saveButtons: saveButtons = [], saveOptions: saveOptions, selectedSaveOption: selectedSaveOption, setSelectedSaveOption: setSelectedSaveOption, showSave: showSave, closeModal: closeModal, canSave: canSave })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "modal-footer flex-0-0-auto px-[1em] text-right border-t border-t-[#ddd] flex items-center justify-end",
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                className: "btn btn-btn-default text-sm py-3 px-4 leading-8 whitespace-nowrap",
                onClick: onClose,
                children: "Cancel"
            }),
            saveButtons.map(({ label: label, onClick: onClick })=>/*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                    className: "btn btn-success",
                    style: {
                        marginLeft: "1em"
                    },
                    onClick: ()=>{
                        onClick();
                        closeModal();
                    },
                    children: label
                }, label)),
            showSave && /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                disabled: !canSave(),
                className: "btn btn-success",
                onClick: onSave,
                style: {
                    marginLeft: "1em",
                    borderRadius: saveOptions !== null && saveOptions !== void 0 && saveOptions.length ? "4px 0 0 4px" : null
                },
                children: saveLabel
            }),
            saveOptions !== null && saveOptions !== void 0 && saveOptions.length ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                disabled: !canSave(),
                dropLeft: true,
                options: saveOptions,
                optionLabel: (o)=>o.label,
                selectedOption: selectedSaveOption,
                onChange: setSelectedSaveOption,
                style: {
                    borderRadius: saveOptions !== null && saveOptions !== void 0 && saveOptions.length ? "0 4px 4px 0" : null
                },
                className: "max-w-max",
                variant: "secondary"
            }) : null
        ]
    });
});

});
parcelRegister("khJQv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec48f53790634329$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");
parcelRequire("6Q5sp");
var $ec48f53790634329$var$_dec, $ec48f53790634329$var$_class, $ec48f53790634329$var$_descriptor, $ec48f53790634329$var$_descriptor2, $ec48f53790634329$var$_descriptor3;
function $ec48f53790634329$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $ec48f53790634329$var$_defineProperty(e, r, t) {
    return (r = $ec48f53790634329$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ec48f53790634329$var$_toPropertyKey(t) {
    var i = $ec48f53790634329$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $ec48f53790634329$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $ec48f53790634329$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $ec48f53790634329$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $ec48f53790634329$var$LayoutStore = ($ec48f53790634329$var$_dec = (0, $4JcCM.action).bound, $ec48f53790634329$var$_class = class LayoutStore {
    constructor(props){
        $ec48f53790634329$var$_initializerDefineProperty(this, "modals", $ec48f53790634329$var$_descriptor, this);
        $ec48f53790634329$var$_initializerDefineProperty(this, "showSidebar", $ec48f53790634329$var$_descriptor2, this);
        $ec48f53790634329$var$_initializerDefineProperty(this, "pageRendered", $ec48f53790634329$var$_descriptor3, this);
        (0, $4JcCM.makeObservable)(this);
    }
    toggleSidebar(setSidebar) {
        this.showSidebar = setSidebar !== null && setSidebar !== void 0 ? setSidebar : !this.showSidebar;
    }
    get displayedModals() {
        return this.modals.values();
    }
    openModal(modal) {
        if (!this.modals.has(modal.props.modalId)) this.modals.set(modal.props.modalId, modal);
    }
    closeModal(modalId) {
        this.modals.delete(modalId);
        // Update URL using history.replaceState to avoid TanStack Router navigation side effects
        try {
            const currentUrl = new URL(window.location.href);
            if (currentUrl.searchParams.has("modal")) {
                currentUrl.searchParams.delete("modal");
                history.replaceState({}, "", currentUrl.toString());
            }
        } catch (e) {
            console.error("Error updating URL:", e);
        }
    }
}, $ec48f53790634329$var$_descriptor = $ec48f53790634329$var$_applyDecoratedDescriptor($ec48f53790634329$var$_class.prototype, "modals", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Map();
    }
}), $ec48f53790634329$var$_descriptor2 = $ec48f53790634329$var$_applyDecoratedDescriptor($ec48f53790634329$var$_class.prototype, "showSidebar", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $ec48f53790634329$var$_descriptor3 = $ec48f53790634329$var$_applyDecoratedDescriptor($ec48f53790634329$var$_class.prototype, "pageRendered", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $ec48f53790634329$var$_applyDecoratedDescriptor($ec48f53790634329$var$_class.prototype, "toggleSidebar", [
    $ec48f53790634329$var$_dec
], Object.getOwnPropertyDescriptor($ec48f53790634329$var$_class.prototype, "toggleSidebar"), $ec48f53790634329$var$_class.prototype), $ec48f53790634329$var$_applyDecoratedDescriptor($ec48f53790634329$var$_class.prototype, "displayedModals", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($ec48f53790634329$var$_class.prototype, "displayedModals"), $ec48f53790634329$var$_class.prototype), $ec48f53790634329$var$_class);
var $ec48f53790634329$export$2e2bcd8739ae039 = new $ec48f53790634329$var$LayoutStore();

});

parcelRegister("ewAM3", function(module, exports) {

$parcel$export(module.exports, "Selector", function () { return $a930946c53e92d1b$export$d15f4cd5286f9b1e; });
$parcel$export(module.exports, "BooleanSelector", function () { return $a930946c53e92d1b$export$9e6a0c752efd96fc; });
$parcel$export(module.exports, "ContactSelector", function () { return $a930946c53e92d1b$export$9ec8b34c1e7a643e; });
$parcel$export(module.exports, "CostCentreSelector", function () { return $a930946c53e92d1b$export$2d2573c5466d1f18; });
$parcel$export(module.exports, "StaffSelector", function () { return $a930946c53e92d1b$export$74aac9a301f18d2e; });
$parcel$export(module.exports, "RoleSelector", function () { return $a930946c53e92d1b$export$7b32174eb7b60a13; });
$parcel$export(module.exports, "ProjectSelector", function () { return $a930946c53e92d1b$export$a764642e4b725728; });
$parcel$export(module.exports, "PhaseSelector", function () { return $a930946c53e92d1b$export$c6fe3fcc5c7d197b; });
$parcel$export(module.exports, "TaskSelector", function () { return $a930946c53e92d1b$export$b1a90c704904b8d3; });
$parcel$export(module.exports, "SupplierSelector", function () { return $a930946c53e92d1b$export$1a0b0fec383cc555; });
$parcel$export(module.exports, "ProjectExpenseSelector", function () { return $a930946c53e92d1b$export$e66457f9b133ddfa; });
$parcel$export(module.exports, "StaffOrRoleSelector", function () { return $a930946c53e92d1b$export$96db3e3d08047f0e; });
$parcel$export(module.exports, "StatusSelector", function () { return $a930946c53e92d1b$export$73bf5bb44ab352ee; });
$parcel$export(module.exports, "RelativeDateSelector", function () { return $a930946c53e92d1b$export$7d0eb98e148310d4; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $bhvQG = parcelRequire("bhvQG");

var $eNcHX = parcelRequire("eNcHX");

var $htkeB = parcelRequire("htkeB");
parcelRequire("eat5C");

var $XoImS = parcelRequire("XoImS");

var $bxXv3 = parcelRequire("bxXv3");

var $ikffN = parcelRequire("ikffN");

var $gJT7h = parcelRequire("gJT7h");

var $cnmvx = parcelRequire("cnmvx");

var $keGWP = parcelRequire("keGWP");
parcelRequire("ek5Pm");

var $e8Hda = parcelRequire("e8Hda");

var $1kvoC = parcelRequire("1kvoC");
var $kSlHv = parcelRequire("kSlHv");
parcelRequire("hzq93");

var $aouPi = parcelRequire("aouPi");

var $6gkJQ = parcelRequire("6gkJQ");

var $4hBm1 = parcelRequire("4hBm1");

parcelRequire("fEtu5");
var $avIhR = parcelRequire("avIhR");

var $khJQv = parcelRequire("khJQv");

var $2Zzii = parcelRequire("2Zzii");

var $cfp1m = parcelRequire("cfp1m");

var $3X7oM = parcelRequire("3X7oM");

var $80DmM = parcelRequire("80DmM");

var $6fNfM = parcelRequire("6fNfM");

var $cXBQb = parcelRequire("cXBQb");
const $a930946c53e92d1b$export$d15f4cd5286f9b1e = ({ selectedOption: selectedOption, value: value, options: options, searchableOptions: searchableOptions, onChange: onChange, disableOption: disableOption, searchMatcher: searchMatcher, optionLabel: optionLabel = (o)=>(o === null || o === void 0 ? void 0 : o.label) || o, groupBy: groupBy, groupOrder: groupOrder, sort: sort, placeholder: placeholder, isEditable: isEditable = true, chevrons: chevrons = true, style: style, ...props })=>{
    var _selectedOption, _options, _options$, _selectedOption2;
    const [open, setOpen] = (0, $jbmdS.useState)(false);
    const [filter, setFilter] = (0, $jbmdS.useState)("");
    (_selectedOption = selectedOption) !== null && _selectedOption !== void 0 ? _selectedOption : selectedOption = value;
    if ((_options = options) !== null && _options !== void 0 && (_options$ = _options[0]) !== null && _options$ !== void 0 && _options$.value && options.find((o)=>(o === null || o === void 0 ? void 0 : o.value) === selectedOption)) selectedOption = options.find((o)=>(o === null || o === void 0 ? void 0 : o.value) === selectedOption);
    if (sort) // Defensive copy to keep props immutable
    options = [
        ...options
    ].sort(sort);
    if (searchMatcher && filter.length > 0) {
        // Use searchableOptions if they exist and there's a filter value
        const optionsToSearch = filter.length > 0 && searchableOptions ? searchableOptions : options;
        options = optionsToSearch.filter((option)=>{
            return searchMatcher(option, filter);
        });
        // Limit to first 20 results when filtering
        if (filter.length > 0 && options.length > 20) options = options.slice(0, 100);
    }
    // Group options and then sort items within each group
    const groupedAndSortedOptions = (0, $jbmdS.useMemo)(()=>{
        if (!groupBy) return null;
        const groups = options.reduce((acc, option)=>{
            const groupKey = groupBy(option);
            if (!acc[groupKey]) acc[groupKey] = [];
            acc[groupKey].push(option);
            return acc;
        }, {});
        // If sort function is provided, use it to sort the groups
        if (sort) {
            // Get representative items from each group for sorting
            const groupRepresentatives = {};
            Object.keys(groups).forEach((groupKey)=>{
                // For each group, find the item with the minimum sort value
                groupRepresentatives[groupKey] = groups[groupKey].reduce((minItem, currentItem)=>{
                    return sort(currentItem, minItem) < 0 ? currentItem : minItem;
                }, groups[groupKey][0]);
            });
            // Sort the group keys based on the representative items or groupOrder
            let sortedKeys;
            if (groupOrder) {
                // Use the provided group order
                sortedKeys = groupOrder.filter((groupLabel)=>groups[groupLabel]);
                // Add any groups not in the order at the end
                const remainingKeys = Object.keys(groups).filter((key)=>!groupOrder.includes(key));
                sortedKeys = [
                    ...sortedKeys,
                    ...remainingKeys
                ];
            } else if (sort) // Use the sort function as before
            sortedKeys = Object.keys(groups).sort((keyA, keyB)=>{
                return sort(groupRepresentatives[keyA], groupRepresentatives[keyB]);
            });
            else sortedKeys = Object.keys(groups);
            // Create the final ordered groups object
            const sortedGroups = {};
            sortedKeys.forEach((key)=>{
                sortedGroups[key] = groups[key].sort(sort);
            });
            return sortedGroups;
        } else return groups;
    }, [
        options,
        groupBy,
        searchableOptions,
        filter,
        sort,
        searchMatcher,
        groupOrder
    ]);
    const oldOptionLabel = optionLabel;
    optionLabel = (o)=>{
        const label = oldOptionLabel(o);
        return label !== null && label !== void 0 && label.replace ? label.replace(/["\\]/g, "") : label;
    };
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $6gkJQ.Popover), {
        open: open,
        onOpenChange: isEditable ? setOpen : ()=>null,
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6gkJQ.PopoverTrigger), {
                asChild: true,
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3X7oM.default), {
                    role: "combobox",
                    "aria-expanded": open,
                    label: optionLabel(selectedOption) || ((_selectedOption2 = selectedOption) === null || _selectedOption2 === void 0 ? void 0 : _selectedOption2.label) || placeholder || "Select...",
                    rightIcon: chevrons ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kSlHv.default), {
                        style: {
                            height: "16px",
                            width: "16px",
                            flexShrink: 0,
                            opacity: 0.5,
                            marginRight: "-0.8rem"
                        }
                    }) : null,
                    variant: props.variant,
                    style: style,
                    className: `gap-0 ${props.className}`
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6gkJQ.PopoverContent), {
                style: {
                    zIndex: 10004
                },
                children: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $aouPi.Command), {
                    style: {
                        width: "100%"
                    },
                    shouldFilter: false,
                    children: [
                        searchMatcher && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $aouPi.CommandInput), {
                            placeholder: placeholder || "Search...",
                            value: filter,
                            onValueChange: (v)=>setFilter(v)
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $aouPi.CommandList), {
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $aouPi.CommandEmpty), {
                                    children: "Nothing found."
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                    style: {
                                        overflowY: "auto",
                                        maxHeight: "200px"
                                    },
                                    children: groupedAndSortedOptions ? Object.entries(groupedAndSortedOptions).map(([group, items], index)=>/*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                    style: {
                                                        fontWeight: "600",
                                                        fontSize: "0.75rem",
                                                        textTransform: "uppercase",
                                                        letterSpacing: "0.05em",
                                                        color: "#6b7280",
                                                        backgroundColor: "#f9fafb",
                                                        padding: "8px 12px",
                                                        marginTop: index > 0 ? "4px" : "0",
                                                        borderTop: index > 0 ? "1px solid #e5e7eb" : "none",
                                                        position: "sticky",
                                                        top: "0",
                                                        zIndex: 10
                                                    },
                                                    children: group
                                                }),
                                                items.map((option, index)=>{
                                                    var _option$value;
                                                    const itemValue = (_option$value = option === null || option === void 0 ? void 0 : option.value) !== null && _option$value !== void 0 ? _option$value : option;
                                                    const commandItemValue = itemValue === null ? "__NULL_VALUE__" : typeof itemValue === "object" ? optionLabel(option) : String(itemValue);
                                                    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $aouPi.CommandItem), {
                                                        value: commandItemValue,
                                                        onSelect: ()=>{
                                                            const actualValue = commandItemValue === "__NULL_VALUE__" ? null : itemValue;
                                                            onChange(actualValue);
                                                            setOpen(false);
                                                        },
                                                        style: {
                                                            display: "flex",
                                                            alignItems: "center",
                                                            padding: "0.5rem",
                                                            paddingRight: "2.5rem"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $1kvoC.default), {
                                                                style: {
                                                                    marginRight: "8px",
                                                                    height: "16px",
                                                                    width: "16px",
                                                                    opacity: itemValue === selectedOption ? 1 : 0
                                                                }
                                                            }),
                                                            optionLabel(option)
                                                        ]
                                                    }, optionLabel(option) + index);
                                                })
                                            ]
                                        }, group + index)) : options.map((option, index)=>{
                                        var _option$value2;
                                        const itemValue = (_option$value2 = option === null || option === void 0 ? void 0 : option.value) !== null && _option$value2 !== void 0 ? _option$value2 : option;
                                        const commandItemValue = itemValue === null ? "__NULL_VALUE__" : typeof itemValue === "object" ? optionLabel(option) : String(itemValue);
                                        return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $aouPi.CommandItem), {
                                            value: commandItemValue,
                                            onSelect: ()=>{
                                                const actualValue = commandItemValue === "__NULL_VALUE__" ? null : itemValue;
                                                onChange(actualValue);
                                                setOpen(false);
                                            },
                                            style: {
                                                display: "flex",
                                                alignItems: "center",
                                                padding: "0.5rem",
                                                paddingRight: "2.5rem"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $1kvoC.default), {
                                                    style: {
                                                        marginRight: "8px",
                                                        height: "16px",
                                                        width: "16px",
                                                        opacity: itemValue === selectedOption ? 1 : 0
                                                    }
                                                }),
                                                optionLabel(option)
                                            ]
                                        }, optionLabel(option) + index);
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
const $a930946c53e92d1b$export$9e6a0c752efd96fc = ({ selectedOption: selectedOption, onChange: onChange, placeholderLabel: placeholderLabel = "All", nullable: nullable, ...props })=>{
    let options = [
        true,
        false
    ];
    if (nullable) options = [
        null,
        ...options
    ];
    return /*#__PURE__*/ (0, $61Ea1.jsx)($a930946c53e92d1b$export$d15f4cd5286f9b1e, {
        selectedOption: selectedOption,
        onChange: onChange,
        options: options,
        sort: (c)=>c,
        optionLabel: (c)=>{
            if (c === null) return placeholderLabel;
            return c ? "Yes" : "No";
        },
        searchMatcher: (c, text)=>{
            var _match, _ref;
            if (c === null) return placeholderLabel.toLowerCase().includes(text.toLowerCase());
            return (_match = (_ref = c ? "yes" : "no").match) === null || _match === void 0 ? void 0 : _match.call(_ref, text.toLowerCase());
        },
        ...props
    });
};


const $a930946c53e92d1b$export$9ec8b34c1e7a643e = ({ selectedContact: selectedContact, contactOptions: contactOptions, disabledContacts: disabledContacts, onChange: onChange, placeholderLabel: placeholderLabel, nullable: nullable, ...props })=>{
    let options = contactOptions || (0, $bhvQG.default).contacts;
    if (nullable) options = [
        null,
        ...options
    ];
    const isOptionDisabled = (contact)=>disabledContacts ? disabledContacts.includes(contact) : false;
    const [ImportModal, setImportModal] = (0, $jbmdS.useState)(null);
    const [CreateModal, setCreateModal] = (0, $jbmdS.useState)(null);
    (0, $jbmdS.useEffect)(()=>{
        const importComponent = async ()=>{
            const importModule = await Promise.resolve((parcelRequire("ip90b")));
            const ImportOneContactModal = importModule.default;
            setImportModal(ImportOneContactModal);
            const createModule = await (parcelRequire("i7jlS"));
            const CreateContactModal = createModule.default;
            setCreateModal(CreateContactModal);
        };
        importComponent();
    }, []);
    if (!ImportModal || !CreateModal) return;
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        style: {
            display: "flex",
            width: "calc(100% - 2.5em)"
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $avIhR.Dropdown3), {
                toggleElement: /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                    className: "btn btn-default",
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                        style: {
                            margin: 0
                        },
                        className: "fa fa-plus text-xs"
                    })
                }),
                contentStyle: {
                    width: "8em",
                    marginTop: "0.5em",
                    color: "#444"
                },
                containerStyle: {
                    float: "right"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $avIhR.Dropdown3ListItem), {
                        style: {
                            padding: "0.5em 1em",
                            height: "2.5em"
                        },
                        onClick: ()=>(0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)(CreateModal, {
                                modalId: "create-contact",
                                onSave: (contact)=>{
                                    onChange(contact);
                                }
                            })),
                        children: "Create"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $avIhR.Dropdown3ListItem), {
                        style: {
                            padding: "0.5em 1em",
                            height: "2.5em"
                        },
                        onClick: ()=>(0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)(ImportModal, {
                                modalId: "import-one-contact",
                                onSave: (contact)=>{
                                    onChange(contact);
                                }
                            })),
                        children: "Import"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)($a930946c53e92d1b$export$d15f4cd5286f9b1e, {
                selectedOption: selectedContact,
                onChange: onChange,
                options: options,
                isOptionDisabled: isOptionDisabled,
                sort: (c)=>(c === null || c === void 0 ? void 0 : c.label) || -Infinity,
                optionLabel: (c)=>(c === null || c === void 0 ? void 0 : c.label) || placeholderLabel || "Select Contact...",
                searchMatcher: (c, text)=>{
                    var _c$label, _c$label$toLowerCase, _c$label$toLowerCase$, _c$label$toLowerCase$2;
                    return c === null || c === void 0 ? void 0 : (_c$label = c.label) === null || _c$label === void 0 ? void 0 : (_c$label$toLowerCase = _c$label.toLowerCase) === null || _c$label$toLowerCase === void 0 ? void 0 : (_c$label$toLowerCase$ = _c$label$toLowerCase.call(_c$label)) === null || _c$label$toLowerCase$ === void 0 ? void 0 : (_c$label$toLowerCase$2 = _c$label$toLowerCase$.match) === null || _c$label$toLowerCase$2 === void 0 ? void 0 : _c$label$toLowerCase$2.call(_c$label$toLowerCase$, text.toLowerCase());
                },
                ...props,
                style: {
                    display: "inline-flex",
                    ...props.style
                }
            })
        ]
    });
};
const $a930946c53e92d1b$export$2d2573c5466d1f18 = ({ selectedCostCentre: selectedCostCentre, costCentreOptions: costCentreOptions, disabledCostCentres: disabledCostCentres, onChange: onChange, placeholderLabel: placeholderLabel, nullable: nullable, ...props })=>{
    let options = costCentreOptions || (0, $eNcHX.default).costCentres;
    if (nullable) options = [
        null,
        ...options
    ];
    const isOptionDisabled = (costCentre)=>disabledCostCentres ? disabledCostCentres.includes(costCentre) : false;
    return /*#__PURE__*/ (0, $61Ea1.jsx)($a930946c53e92d1b$export$d15f4cd5286f9b1e, {
        selectedOption: selectedCostCentre,
        onChange: onChange,
        options: options,
        isOptionDisabled: isOptionDisabled,
        sort: (cc)=>(cc === null || cc === void 0 ? void 0 : cc.name) || -Infinity,
        optionLabel: (cc)=>(cc === null || cc === void 0 ? void 0 : cc.name) || placeholderLabel || "Select Cost Centre...",
        searchMatcher: (cc, text)=>{
            var _cc$name, _cc$name$toLowerCase, _cc$name$toLowerCase$, _cc$name$toLowerCase$2;
            return cc === null || cc === void 0 ? void 0 : (_cc$name = cc.name) === null || _cc$name === void 0 ? void 0 : (_cc$name$toLowerCase = _cc$name.toLowerCase) === null || _cc$name$toLowerCase === void 0 ? void 0 : (_cc$name$toLowerCase$ = _cc$name$toLowerCase.call(_cc$name)) === null || _cc$name$toLowerCase$ === void 0 ? void 0 : (_cc$name$toLowerCase$2 = _cc$name$toLowerCase$.match) === null || _cc$name$toLowerCase$2 === void 0 ? void 0 : _cc$name$toLowerCase$2.call(_cc$name$toLowerCase$, text.toLowerCase());
        },
        ...props
    });
};
const $a930946c53e92d1b$export$74aac9a301f18d2e = ({ selectedStaffMember: selectedStaffMember, staffOptions: staffOptions, disabledStaff: disabledStaff, onChange: onChange, placeholderLabel: placeholderLabel, nullable: nullable, ...props })=>{
    var _options2;
    let options = staffOptions || (0, $htkeB.default).staffs;
    if (nullable) options = [
        null,
        ...options
    ];
    const isOptionDisabled = (staff)=>disabledStaff ? disabledStaff.includes(staff) : false;
    // Define groups in the order they should appear
    const groupOrder = [
        {
            key: "active",
            label: "Active Staff"
        },
        {
            key: "archived",
            label: "Archived Staff"
        }
    ];
    // Function to get group key from staff member
    const getGroupKey = (staff)=>staff !== null && staff !== void 0 && staff.isArchived ? "archived" : "active";
    // Function to get group label from group key
    const getGroupLabel = (groupKey)=>{
        const group = groupOrder.find((g)=>g.key === groupKey);
        return group ? group.label : groupKey;
    };
    return /*#__PURE__*/ (0, $61Ea1.jsx)($a930946c53e92d1b$export$d15f4cd5286f9b1e, {
        selectedOption: selectedStaffMember,
        onChange: onChange,
        options: options,
        isOptionDisabled: isOptionDisabled,
        sort: (sm)=>(sm !== null && sm !== void 0 && sm.isArchived ? 9 : 1) + ((sm === null || sm === void 0 ? void 0 : sm.fullName) || -Infinity),
        optionLabel: (sm)=>(sm === null || sm === void 0 ? void 0 : sm.fullName) || placeholderLabel || "Select Staff...",
        searchMatcher: (sm, text)=>{
            var _sm$fullName, _sm$fullName$toLowerC, _sm$fullName$toLowerC2, _sm$fullName$toLowerC3;
            return sm === null || sm === void 0 ? void 0 : (_sm$fullName = sm.fullName) === null || _sm$fullName === void 0 ? void 0 : (_sm$fullName$toLowerC = _sm$fullName.toLowerCase) === null || _sm$fullName$toLowerC === void 0 ? void 0 : (_sm$fullName$toLowerC2 = _sm$fullName$toLowerC.call(_sm$fullName)) === null || _sm$fullName$toLowerC2 === void 0 ? void 0 : (_sm$fullName$toLowerC3 = _sm$fullName$toLowerC2.match) === null || _sm$fullName$toLowerC3 === void 0 ? void 0 : _sm$fullName$toLowerC3.call(_sm$fullName$toLowerC2, text === null || text === void 0 ? void 0 : text.toLowerCase());
        },
        groupBy: ((_options2 = options[nullable ? 1 : 0]) === null || _options2 === void 0 ? void 0 : _options2.isArchived) !== undefined ? (staff)=>getGroupLabel(getGroupKey(staff)) : null,
        groupOrder: groupOrder.map((g)=>g.label),
        ...props
    });
};
const $a930946c53e92d1b$export$7b32174eb7b60a13 = ({ selectedRole: selectedRole, roleOptions: roleOptions, disabledRoles: disabledRoles, onChange: onChange, placeholderLabel: placeholderLabel, nullable: nullable, ...props })=>{
    let options = roleOptions || (0, $bxXv3.default).roles;
    if (nullable) options = [
        null,
        ...options
    ];
    const isOptionDisabled = (role)=>disabledRoles ? disabledRoles.includes(role) : false;
    return /*#__PURE__*/ (0, $61Ea1.jsx)($a930946c53e92d1b$export$d15f4cd5286f9b1e, {
        selectedOption: selectedRole,
        onChange: onChange,
        options: options,
        isOptionDisabled: isOptionDisabled,
        sort: (sm)=>(sm === null || sm === void 0 ? void 0 : sm.name) || -Infinity,
        optionLabel: (sm)=>(sm === null || sm === void 0 ? void 0 : sm.name) || placeholderLabel || "Select Role...",
        searchMatcher: (sm, text)=>{
            var _sm$name, _sm$name$toLowerCase, _sm$name$toLowerCase$, _sm$name$toLowerCase$2;
            return sm === null || sm === void 0 ? void 0 : (_sm$name = sm.name) === null || _sm$name === void 0 ? void 0 : (_sm$name$toLowerCase = _sm$name.toLowerCase) === null || _sm$name$toLowerCase === void 0 ? void 0 : (_sm$name$toLowerCase$ = _sm$name$toLowerCase.call(_sm$name)) === null || _sm$name$toLowerCase$ === void 0 ? void 0 : (_sm$name$toLowerCase$2 = _sm$name$toLowerCase$.match) === null || _sm$name$toLowerCase$2 === void 0 ? void 0 : _sm$name$toLowerCase$2.call(_sm$name$toLowerCase$, text.toLowerCase());
        },
        ...props
    });
};
const $a930946c53e92d1b$export$a764642e4b725728 = ({ selectedProject: selectedProject, projectOptions: projectOptions, disabledProjects: disabledProjects, onChange: onChange, placeholderLabel: placeholderLabel, nullable: nullable, ...props })=>{
    var _options3;
    // Store all projects in allOptions
    const allOptions = projectOptions || (0, $gJT7h.default).projects;
    // Filter out archived projects for the default view
    let options = allOptions.filter((project)=>(project === null || project === void 0 ? void 0 : project.status) !== "archived");
    if (nullable) options = [
        null,
        ...options
    ];
    const isOptionDisabled = (project)=>disabledProjects ? disabledProjects.includes(project) : false;
    // Define groups in the order they should appear
    const groupOrder = [
        {
            key: "active",
            label: "Active Projects"
        },
        {
            key: "onHold",
            label: "On Hold Projects"
        },
        {
            key: "prospective",
            label: "Prospective Projects"
        },
        {
            key: "archived",
            label: "Archived Projects"
        }
    ];
    // Function to get group key from project
    const getGroupKey = (project)=>(project === null || project === void 0 ? void 0 : project.status) || "active";
    // Function to get group label from group key
    const getGroupLabel = (groupKey)=>{
        const group = groupOrder.find((g)=>g.key === groupKey);
        return group ? group.label : `\u{1F4C2} ${(0, $e8Hda.camelCaseToSentence)(groupKey + "Projects")}`;
    };
    return /*#__PURE__*/ (0, $61Ea1.jsx)($a930946c53e92d1b$export$d15f4cd5286f9b1e, {
        selectedOption: selectedProject,
        onChange: onChange,
        options: options,
        searchableOptions: nullable ? [
            null,
            ...allOptions
        ] : allOptions,
        isOptionDisabled: isOptionDisabled,
        sort: (0, $cXBQb.default),
        optionLabel: (sm)=>(sm === null || sm === void 0 ? void 0 : sm.title) || placeholderLabel || "Select Project...",
        searchMatcher: (sm, text)=>{
            var _sm$title, _sm$title$toLowerCase, _sm$title$toLowerCase2, _sm$title$toLowerCase3;
            return sm === null || sm === void 0 ? void 0 : (_sm$title = sm.title) === null || _sm$title === void 0 ? void 0 : (_sm$title$toLowerCase = _sm$title.toLowerCase) === null || _sm$title$toLowerCase === void 0 ? void 0 : (_sm$title$toLowerCase2 = _sm$title$toLowerCase.call(_sm$title)) === null || _sm$title$toLowerCase2 === void 0 ? void 0 : (_sm$title$toLowerCase3 = _sm$title$toLowerCase2.match) === null || _sm$title$toLowerCase3 === void 0 ? void 0 : _sm$title$toLowerCase3.call(_sm$title$toLowerCase2, text.toLowerCase());
        },
        groupBy: (_options3 = options[nullable ? 1 : 0]) !== null && _options3 !== void 0 && _options3.status ? (project)=>getGroupLabel(getGroupKey(project)) : null,
        groupOrder: groupOrder.map((g)=>g.label),
        ...props
    });
};
const $a930946c53e92d1b$export$c6fe3fcc5c7d197b = ({ selectedPhase: selectedPhase, phaseOptions: phaseOptions, disabledPhases: disabledPhases, onChange: onChange, placeholderLabel: placeholderLabel, nullable: nullable, ...props })=>{
    var _options4;
    let options = phaseOptions || (0, $XoImS.default).phases;
    if (nullable) options = [
        null,
        ...options
    ];
    const isOptionDisabled = (phase)=>disabledPhases ? disabledPhases.includes(phase) : false;
    // Define groups in the order they should appear
    const groupOrder = [
        {
            key: "active",
            label: "Active Phases"
        },
        {
            key: "onHold",
            label: "On Hold Phases"
        },
        {
            key: "prospective",
            label: "Prospective Phases"
        },
        {
            key: "archived",
            label: "Archived Phases"
        }
    ];
    // Function to get group key from phase
    const getGroupKey = (phase)=>(phase === null || phase === void 0 ? void 0 : phase.status) || "active";
    // Function to get group label from group key
    const getGroupLabel = (groupKey)=>{
        const group = groupOrder.find((g)=>g.key === groupKey);
        return group ? group.label : `\u{1F4C2} ${(0, $e8Hda.camelCaseToSentence)(groupKey + "Phases")}`;
    };
    return /*#__PURE__*/ (0, $61Ea1.jsx)($a930946c53e92d1b$export$d15f4cd5286f9b1e, {
        selectedOption: selectedPhase,
        onChange: onChange,
        options: options,
        isOptionDisabled: isOptionDisabled,
        sort: (0, $6fNfM.default),
        optionLabel: (sm)=>(sm === null || sm === void 0 ? void 0 : sm.title) || placeholderLabel || "Select Phase...",
        searchMatcher: (sm, text)=>sm.title.toLowerCase().match(text.toLowerCase()),
        groupBy: (_options4 = options[nullable ? 1 : 0]) !== null && _options4 !== void 0 && _options4.status ? (phase)=>getGroupLabel(getGroupKey(phase)) : null,
        groupOrder: groupOrder.map((g)=>g.label),
        ...props
    });
};
const $a930946c53e92d1b$export$b1a90c704904b8d3 = ({ selectedTask: selectedTask, taskOptions: taskOptions, disabledTasks: disabledTasks, onChange: onChange, placeholderLabel: placeholderLabel, nullable: nullable, ...props })=>{
    let options = taskOptions || (0, $keGWP.default).tasks;
    if (nullable) options = [
        null,
        ...options
    ];
    const isOptionDisabled = (task)=>disabledTasks ? disabledTasks.includes(task) : false;
    return /*#__PURE__*/ (0, $61Ea1.jsx)($a930946c53e92d1b$export$d15f4cd5286f9b1e, {
        selectedOption: selectedTask,
        onChange: onChange,
        options: options.sort((a, b)=>{
            var _a$name, _a$name$localeCompare;
            return (_a$name = a.name) === null || _a$name === void 0 ? void 0 : (_a$name$localeCompare = _a$name.localeCompare) === null || _a$name$localeCompare === void 0 ? void 0 : _a$name$localeCompare.call(_a$name, b.name);
        }),
        isOptionDisabled: isOptionDisabled,
        sort: (ph)=>(ph === null || ph === void 0 ? void 0 : ph.name) || -Infinity,
        optionLabel: (sm)=>(sm === null || sm === void 0 ? void 0 : sm.name) || placeholderLabel || "Select Task...",
        searchMatcher: (sm, text)=>{
            var _sm$name2;
            return sm === null || sm === void 0 ? void 0 : (_sm$name2 = sm.name) === null || _sm$name2 === void 0 ? void 0 : _sm$name2.toLowerCase().match(text.toLowerCase());
        },
        ...props
    });
};
const $a930946c53e92d1b$export$1a0b0fec383cc555 = ({ selectedSupplier: selectedSupplier, supplierOptions: supplierOptions, disabledSuppliers: disabledSuppliers, onChange: onChange, placeholderLabel: placeholderLabel, nullable: nullable, ...props })=>{
    let options = supplierOptions || (0, $2Zzii.default).suppliers;
    const noSupplier = {
        name: null,
        id: null
    };
    if (nullable) options = [
        noSupplier,
        ...options
    ];
    const isOptionDisabled = (task)=>{
        var _disabledSuppliers$in;
        return disabledSuppliers ? disabledSuppliers === null || disabledSuppliers === void 0 ? void 0 : (_disabledSuppliers$in = disabledSuppliers.includes) === null || _disabledSuppliers$in === void 0 ? void 0 : _disabledSuppliers$in.call(disabledSuppliers, task) : false;
    };
    return /*#__PURE__*/ (0, $61Ea1.jsx)($a930946c53e92d1b$export$d15f4cd5286f9b1e, {
        selectedOption: selectedSupplier || noSupplier,
        onChange: onChange,
        options: options.sort((a, b)=>{
            var _a$name2, _a$name2$localeCompar;
            return (_a$name2 = a.name) === null || _a$name2 === void 0 ? void 0 : (_a$name2$localeCompar = _a$name2.localeCompare) === null || _a$name2$localeCompar === void 0 ? void 0 : _a$name2$localeCompar.call(_a$name2, b === null || b === void 0 ? void 0 : b.name);
        }),
        isOptionDisabled: isOptionDisabled,
        sort: (s)=>(s === null || s === void 0 ? void 0 : s.name) || -Infinity,
        optionLabel: (s)=>(s === null || s === void 0 ? void 0 : s.name) || placeholderLabel || "Select Supplier...",
        searchMatcher: (s, text)=>{
            var _s$name, _s$name$toLowerCase, _s$name$toLowerCase$c, _s$name$toLowerCase$c2, _text$toLowerCase;
            return (_s$name = s.name) === null || _s$name === void 0 ? void 0 : (_s$name$toLowerCase = _s$name.toLowerCase) === null || _s$name$toLowerCase === void 0 ? void 0 : (_s$name$toLowerCase$c = _s$name$toLowerCase.call(_s$name)) === null || _s$name$toLowerCase$c === void 0 ? void 0 : (_s$name$toLowerCase$c2 = _s$name$toLowerCase$c.match) === null || _s$name$toLowerCase$c2 === void 0 ? void 0 : _s$name$toLowerCase$c2.call(_s$name$toLowerCase$c, text === null || text === void 0 ? void 0 : (_text$toLowerCase = text.toLowerCase) === null || _text$toLowerCase === void 0 ? void 0 : _text$toLowerCase.call(text));
        },
        style: {
            maxWidth: "max-content"
        },
        ...props
    });
};
const $a930946c53e92d1b$export$e66457f9b133ddfa = ({ selectedProjectExpense: selectedProjectExpense, projectExpenseOptions: projectExpenseOptions, disabledProjectExpenses: disabledProjectExpenses, onChange: onChange, placeholderLabel: placeholderLabel, nullable: nullable, ...props })=>{
    let options = projectExpenseOptions || (0, $cfp1m.default).projectExpenses;
    const noProjectExpense = {
        name: null,
        id: null
    };
    if (nullable) options = [
        noProjectExpense,
        ...options
    ];
    const isOptionDisabled = (task)=>{
        var _disabledProjectExpen;
        return disabledProjectExpenses ? disabledProjectExpenses === null || disabledProjectExpenses === void 0 ? void 0 : (_disabledProjectExpen = disabledProjectExpenses.includes) === null || _disabledProjectExpen === void 0 ? void 0 : _disabledProjectExpen.call(disabledProjectExpenses, task) : false;
    };
    return /*#__PURE__*/ (0, $61Ea1.jsx)($a930946c53e92d1b$export$d15f4cd5286f9b1e, {
        selectedOption: selectedProjectExpense || noProjectExpense,
        onChange: onChange,
        options: options.sort((a, b)=>{
            var _a$name3, _a$name3$localeCompar;
            return (_a$name3 = a.name) === null || _a$name3 === void 0 ? void 0 : (_a$name3$localeCompar = _a$name3.localeCompare) === null || _a$name3$localeCompar === void 0 ? void 0 : _a$name3$localeCompar.call(_a$name3, b === null || b === void 0 ? void 0 : b.name);
        }),
        isOptionDisabled: isOptionDisabled,
        sort: (s)=>(s === null || s === void 0 ? void 0 : s.name) || -Infinity,
        optionLabel: (s)=>(s === null || s === void 0 ? void 0 : s.name) || placeholderLabel || "Select Project Expense...",
        searchMatcher: (s, text)=>{
            var _s$name2, _s$name2$toLowerCase, _s$name2$toLowerCase$, _s$name2$toLowerCase$2, _text$toLowerCase2;
            return (_s$name2 = s.name) === null || _s$name2 === void 0 ? void 0 : (_s$name2$toLowerCase = _s$name2.toLowerCase) === null || _s$name2$toLowerCase === void 0 ? void 0 : (_s$name2$toLowerCase$ = _s$name2$toLowerCase.call(_s$name2)) === null || _s$name2$toLowerCase$ === void 0 ? void 0 : (_s$name2$toLowerCase$2 = _s$name2$toLowerCase$.match) === null || _s$name2$toLowerCase$2 === void 0 ? void 0 : _s$name2$toLowerCase$2.call(_s$name2$toLowerCase$, text === null || text === void 0 ? void 0 : (_text$toLowerCase2 = text.toLowerCase) === null || _text$toLowerCase2 === void 0 ? void 0 : _text$toLowerCase2.call(text));
        },
        ...props
    });
};
const $a930946c53e92d1b$export$96db3e3d08047f0e = ({ selectedStaffOrRole: selectedStaffOrRole, staffOrRoleOptions: staffOrRoleOptions, disabledStaffOrRoles: disabledStaffOrRoles, onChange: onChange, placeholderLabel: placeholderLabel, nullable: nullable, ...props })=>{
    var _options5;
    let options = staffOrRoleOptions || [
        ...(0, $bxXv3.default).roles,
        ...(0, $htkeB.default).staffs
    ];
    if (nullable) options = [
        null,
        ...options
    ];
    const isOptionDisabled = (sor)=>disabledStaffOrRoles ? disabledStaffOrRoles.includes(sor) : false;
    // Define groups in the order they should appear
    const groupOrder = [
        {
            key: "active",
            label: "Active"
        },
        {
            key: "archived",
            label: "Archived"
        }
    ];
    // Function to get group key from staff or role
    const getGroupKey = (item)=>item !== null && item !== void 0 && item.isArchived ? "archived" : "active";
    // Function to get group label from group key
    const getGroupLabel = (groupKey)=>{
        const group = groupOrder.find((g)=>g.key === groupKey);
        return group ? group.label : groupKey;
    };
    return /*#__PURE__*/ (0, $61Ea1.jsx)($a930946c53e92d1b$export$d15f4cd5286f9b1e, {
        selectedOption: selectedStaffOrRole,
        onChange: onChange,
        options: options,
        isOptionDisabled: isOptionDisabled,
        sort: (sm)=>{
            var _sm$role;
            return (sm.isArchived ? "9" : "1") + (sm.name ? "1" : "9") + (sm.name || ((_sm$role = sm.role) === null || _sm$role === void 0 ? void 0 : _sm$role.name) || "") + ((sm === null || sm === void 0 ? void 0 : sm.fullName) || "");
        },
        optionLabel: (sor)=>(sor === null || sor === void 0 ? void 0 : sor.fullName) || (sor === null || sor === void 0 ? void 0 : sor.name) || placeholderLabel || "Select Staff or Role...",
        searchMatcher: (sor, text)=>{
            var _ref2, _ref2$toLowerCase, _ref2$toLowerCase$cal, _ref2$toLowerCase$cal2;
            return (_ref2 = (sor === null || sor === void 0 ? void 0 : sor.fullName) || (sor === null || sor === void 0 ? void 0 : sor.name)) === null || _ref2 === void 0 ? void 0 : (_ref2$toLowerCase = _ref2.toLowerCase) === null || _ref2$toLowerCase === void 0 ? void 0 : (_ref2$toLowerCase$cal = _ref2$toLowerCase.call(_ref2)) === null || _ref2$toLowerCase$cal === void 0 ? void 0 : (_ref2$toLowerCase$cal2 = _ref2$toLowerCase$cal.match) === null || _ref2$toLowerCase$cal2 === void 0 ? void 0 : _ref2$toLowerCase$cal2.call(_ref2$toLowerCase$cal, text.toLowerCase());
        },
        groupBy: ((_options5 = options[nullable ? 1 : 0]) === null || _options5 === void 0 ? void 0 : _options5.isArchived) !== undefined ? (item)=>getGroupLabel(getGroupKey(item)) : null,
        groupOrder: groupOrder.map((g)=>g.label),
        ...props
    });
};
const $a930946c53e92d1b$export$798b7b5bfe472f0c = ({ selectedCostCentreOrProject: selectedCostCentreOrProject, costCentreOrProjectOptions: costCentreOrProjectOptions, disabledCostCentresOrProjects: disabledCostCentresOrProjects, onChange: onChange, placeholderLabel: placeholderLabel, nullable: nullable, ...props })=>{
    let options = costCentreOrProjectOptions || [
        ...(0, $eNcHX.default).costCentres,
        ...(0, $gJT7h.default).projects
    ];
    if (nullable) options = [
        null,
        ...options
    ];
    const isOptionDisabled = (ccop)=>disabledCostCentresOrProjects ? disabledCostCentresOrProjects.includes(ccop) : false;
    return /*#__PURE__*/ (0, $61Ea1.jsx)($a930946c53e92d1b$export$d15f4cd5286f9b1e, {
        selectedOption: selectedCostCentreOrProject,
        onChange: onChange,
        options: options,
        isOptionDisabled: isOptionDisabled,
        sort: (ccop)=>(ccop === null || ccop === void 0 ? void 0 : ccop.name) || (ccop === null || ccop === void 0 ? void 0 : ccop.title) || -Infinity,
        optionLabel: (ccop)=>(ccop === null || ccop === void 0 ? void 0 : ccop.name) || (ccop === null || ccop === void 0 ? void 0 : ccop.title) || placeholderLabel || "Select Cost Centre or Project...",
        searchMatcher: (ccop, text)=>{
            var _ref3, _ref3$toLowerCase, _ref3$toLowerCase$cal, _ref3$toLowerCase$cal2;
            return (_ref3 = ccop.name || ccop.title) === null || _ref3 === void 0 ? void 0 : (_ref3$toLowerCase = _ref3.toLowerCase) === null || _ref3$toLowerCase === void 0 ? void 0 : (_ref3$toLowerCase$cal = _ref3$toLowerCase.call(_ref3)) === null || _ref3$toLowerCase$cal === void 0 ? void 0 : (_ref3$toLowerCase$cal2 = _ref3$toLowerCase$cal.match) === null || _ref3$toLowerCase$cal2 === void 0 ? void 0 : _ref3$toLowerCase$cal2.call(_ref3$toLowerCase$cal, text.toLowerCase());
        },
        ...props
    });
};
const $a930946c53e92d1b$export$73bf5bb44ab352ee = ({ selectedStatus: selectedStatus, onChange: onChange, placeholderLabel: placeholderLabel, ...props })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)($a930946c53e92d1b$export$d15f4cd5286f9b1e, {
        selectedOption: selectedStatus,
        onChange: onChange,
        options: [
            "active",
            "onHold",
            "prospective",
            "archived"
        ],
        // sort={(c) => c.label}
        optionLabel: (s)=>(0, $ikffN.capitalCase)(s),
        ...props
    });
};
const $a930946c53e92d1b$export$7d0eb98e148310d4 = ({ selectedDateRange: selectedDateRange, onChange: onChange, fortnightType: fortnightType = "a", onChangeFortnightType: onChangeFortnightType = ()=>null, ...props })=>{
    const optionsKeys = Object.keys((0, $cnmvx.dateStringLabels));
    const selectedOption = optionsKeys.includes(selectedDateRange) ? selectedDateRange : "custom";
    const dates = selectedOption !== "custom" ? (0, $cnmvx.dateStringLookup)[selectedOption](fortnightType) : selectedDateRange;
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        style: {
            display: "flex"
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)($a930946c53e92d1b$export$d15f4cd5286f9b1e, {
                selectedOption: selectedOption,
                onChange: (opt)=>onChange(opt === "custom" ? [
                        new Date(),
                        new Date()
                    ] : opt),
                options: optionsKeys,
                // sort={(c) => c.label}
                optionLabel: (s)=>(0, $cnmvx.dateStringLabels)[s],
                searchMatcher: (c, text)=>(0, $cnmvx.dateStringLabels)[c].toLowerCase().match(text.toLowerCase()),
                ...props
            }),
            selectedOption.includes("Fortnight") ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "flex items-center",
                style: {
                    marginRight: "1em"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                        className: fortnightType === "a" ? "btn-primary" : "btn-default",
                        onClick: ()=>onChangeFortnightType("a"),
                        children: "A"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                        className: fortnightType === "b" ? "btn-primary" : "btn-default",
                        onClick: ()=>onChangeFortnightType("b"),
                        children: "B"
                    })
                ]
            }) : null,
            selectedOption === "custom" ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "flex items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $80DmM.DatePicker), {
                        className: "w-[200px] text-black",
                        popoverClassName: "!z-[9999999999]",
                        value: selectedDateRange === null || selectedDateRange === void 0 ? void 0 : selectedDateRange[0],
                        onChange: (val)=>{
                            if (val) onChange([
                                val,
                                selectedDateRange === null || selectedDateRange === void 0 ? void 0 : selectedDateRange[1]
                            ]);
                        }
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "text-white",
                        children: "to"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $80DmM.DatePicker), {
                        className: "w-[200px] text-black",
                        popoverClassName: "!z-[9999999999]",
                        value: selectedDateRange === null || selectedDateRange === void 0 ? void 0 : selectedDateRange[1],
                        onChange: (val)=>{
                            if (val) onChange([
                                selectedDateRange === null || selectedDateRange === void 0 ? void 0 : selectedDateRange[0],
                                val
                            ]);
                        }
                    })
                ]
            }) : selectedOption !== "allTime" ? /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    color: "white"
                },
                children: `(${(0, $4hBm1.format)(dates[0], "dd MMM yyyy")} - ${(0, $4hBm1.format)(dates[1], "dd MMM yyyy")})`
            }) : null
        ]
    });
};
const $a930946c53e92d1b$var$statuses = [
    "active",
    "onHold",
    "prospective",
    "archived"
];

});
parcelRegister("ek5Pm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6d774252e6c4e48$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

parcelRequire("jbmdS");

var $12o9H = parcelRequire("12o9H");

var $cD0xd = parcelRequire("cD0xd");

var $cwjKY = parcelRequire("cwjKY");

var $1oGzi = parcelRequire("1oGzi");

var $gjxeM = parcelRequire("gjxeM");

var $2ZA1t = parcelRequire("2ZA1t");
parcelRequire("amISd");

var $c86dX = parcelRequire("c86dX");

var $ewAM3 = parcelRequire("ewAM3");

var $52dEm = parcelRequire("52dEm");

var $7GQic = parcelRequire("7GQic");

var $foLWS = parcelRequire("foLWS");

var $y5iig = parcelRequire("y5iig");

var $eriOD = parcelRequire("eriOD");
var $a6d774252e6c4e48$export$2e2bcd8739ae039 = {
    text: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $foLWS.default), {
            value: value,
            isEditable: editable,
            className: "coincraft-table-cell__input coincraft-table-cell__text",
            onChange: (v)=>onChange(v),
            isvalid: validator,
            ...props
        }),
    textarea: ({ value: value, editable: editable, onChange: onChange, validator: validator, style: style, ...props })=>/*#__PURE__*/ (0, $61Ea1.jsx)("textarea", {
            rows: 2,
            value: value,
            disabled: !editable,
            className: "coincraft-table-cell__textarea",
            onChange: (e)=>onChange(e.target.value),
            style: {
                padding: "1em",
                ...style
            },
            ...props
        }),
    number: ({ value: value, editable: editable, onChange: onChange, validator: validator, style: style, ...props })=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $foLWS.default), {
            className: "coincraft-table-cell__input coincraft-table-cell__currency",
            value: value,
            formatter: (0, $cwjKY.FormatNumber),
            parser: (0, $1oGzi.ParseNumber),
            isEditable: editable,
            onChange: onChange,
            isValid: validator,
            style: {
                textAlign: "right",
                ...style
            },
            ...props
        }),
    currency: ({ value: value, editable: editable, onChange: onChange, validator: validator, style: style, ...props })=>{
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $foLWS.default), {
            className: "coincraft-table-cell__input coincraft-table-cell__currency",
            value: value,
            formatter: (0, $12o9H.FormatCurrency),
            parser: (0, $cD0xd.ParseCurrency),
            isEditable: editable,
            onChange: onChange,
            isValid: validator,
            style: {
                textAlign: "right",
                ...style
            },
            ...props
        });
    },
    percent: ({ value: value, editable: editable, onChange: onChange, validator: validator, style: style, formatter: formatter = (0, $gjxeM.FormatPercent), parser: parser = (0, $2ZA1t.ParsePercent), ...props })=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $foLWS.default), {
            className: "coincraft-table-cell__input coincraft-table-cell__currency",
            value: value,
            formatter: formatter,
            parser: parser,
            isEditable: editable,
            onChange: onChange,
            isValid: validator,
            style: {
                textAlign: "right",
                ...style
            },
            ...props
        }),
    progress: ({ value: value, editable: editable, onChange: onChange, validator: validator, style: style, ...props })=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $foLWS.default), {
            className: "coincraft-table-cell__input coincraft-table-cell__currency",
            value: value,
            formatter: (0, $gjxeM.FormatPercent),
            parser: (0, $2ZA1t.ParsePercent),
            isEditable: editable,
            onChange: onChange,
            isValid: validator,
            style: {
                textAlign: "right",
                ...style
            },
            ...props
        }),
    progressBar: ({ value: value, editable: editable, onChange: onChange, validator: validator, style: style, ...props })=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $foLWS.default), {
            className: "coincraft-table-cell__input coincraft-table-cell__currency",
            value: value,
            formatter: (0, $gjxeM.FormatPercent),
            parser: (0, $2ZA1t.ParsePercent),
            isEditable: editable,
            onChange: onChange,
            isValid: validator,
            style: {
                textAlign: "right",
                ...style
            },
            ...props
        }),
    date: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $7GQic.default), {
            isvalid: validator,
            value: value,
            isEditable: editable,
            onChange: onChange,
            ...props,
            style: {
                border: "none",
                fontSize: "13px !important"
            },
            tableStyle: "[&_input]:!bg-black/[0.01] [&_input]:!text-xs [&_input]:!px-0 !bg-transparent [&_input]:!shadow-none [&_.rw-select]:!border-none"
        }),
    time: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>{
        value = new Date(value);
        value = value && value.getTime() ? value : new Date();
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $eriOD.TimePicker), {
            value: value,
            disabled: !editable,
            onChange: onChange,
            ...props
        });
    },
    duration: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $61Ea1.jsx)($a6d774252e6c4e48$var$DurationInput, {
            value: value,
            isEditable: editable,
            className: "coincraft-table-cell__input coincraft-table-cell__duration h-full",
            onChange: onChange,
            isvalid: validator,
            ...props
        }),
    checkbox: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
            value: value,
            isEditable: editable,
            className: "coincraft-table-cell__checkbox",
            onChange: onChange,
            isvalid: validator,
            ...props,
            variant: "secondary"
        }),
    button: ({ value: value, editable: editable, onChange: onChange, onClick: onClick, validator: validator, style: style, ...props })=>{
        return /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
            disabled: editable === false,
            className: "coincraft-table-cell__button",
            onClick: onClick,
            style: {
                ...style,
                ...editable === false ? {
                    opacity: 0.75
                } : {}
            },
            ...props,
            children: value
        });
    },
    boolean: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.BooleanSelector), {
            selectedOption: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__bool",
            onChange: onChange,
            isvalid: validator,
            ...props,
            variant: "secondary"
        }),
    project: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.ProjectSelector), {
            selectedProject: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__phase",
            onChange: onChange,
            isvalid: validator,
            ...props,
            variant: "secondary"
        }),
    phase: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.PhaseSelector), {
            selectedPhase: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__phase",
            onChange: onChange,
            isvalid: validator,
            ...props,
            variant: "secondary"
        }),
    task: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.TaskSelector), {
            selectedTask: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__task",
            onChange: onChange,
            isvalid: validator,
            ...props,
            variant: "secondary"
        }),
    contact: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.ContactSelector), {
            selectedContact: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__contact",
            onChange: onChange,
            isvalid: validator,
            ...props,
            variant: "secondary"
        }),
    costCentre: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>{
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.CostCentreSelector), {
            selectedCostCentre: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__contact",
            onChange: onChange,
            isvalid: validator,
            ...props,
            variant: "secondary"
        });
    },
    staffMember: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.StaffSelector), {
            selectedStaffOrRole: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__staff",
            onChange: onChange,
            isvalid: validator,
            ...props,
            variant: "secondary"
        }),
    staff: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.StaffSelector), {
            selectedStaffOrRole: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__staff",
            onChange: onChange,
            isvalid: validator,
            ...props,
            variant: "secondary"
        }),
    role: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.RoleSelector), {
            selectedStaffOrRole: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__staff",
            onChange: onChange,
            isvalid: validator,
            ...props,
            variant: "secondary"
        }),
    staffOrRole: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.StaffOrRoleSelector), {
            selectedStaffOrRole: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__staffOrRole",
            onChange: onChange,
            isvalid: validator,
            ...props,
            variant: "secondary"
        }),
    status: ({ value: value, editable: editable, onChange: onChange, validator: validator, style: style, ...props })=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.StatusSelector), {
            selectedStatus: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__status",
            onChange: onChange,
            isvalid: validator,
            ...props,
            variant: "secondary"
        }),
    statuses: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $c86dX.StatusMultiselect), {
            selectedStatuses: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__status",
            onChange: onChange,
            isvalid: validator,
            ...props
        }),
    projects: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $c86dX.ProjectMultiselect), {
            selectedProjects: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__phase",
            onChange: onChange,
            isvalid: validator,
            ...props
        }),
    phases: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $c86dX.PhaseMultiselect), {
            selectedPhases: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__phase",
            onChange: onChange,
            isvalid: validator,
            ...props
        }),
    tasks: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $c86dX.TaskMultiselect), {
            selectedTasks: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__task",
            onChange: onChange,
            isvalid: validator,
            ...props
        }),
    contacts: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $c86dX.ContactMultiselect), {
            selectedContacts: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__contact",
            onChange: onChange,
            isvalid: validator,
            ...props
        }),
    costCentres: ({ value: value, editable: editable, onChange: onChange, onClick: onClick, validator: validator, style: style, ...props })=>{
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $c86dX.CostCentreMultiselect), {
            selectedCostCentres: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__contact",
            onChange: onChange,
            isvalid: validator,
            ...props
        });
    },
    staffs: ({ value: value, editable: editable, onChange: onChange, validator: validator, style: style, ...props })=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $c86dX.StaffMultiselect), {
            selectedStaffMembers: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__staff",
            onChange: onChange,
            isvalid: validator,
            ...props
        }),
    staffMembers: ({ value: value, editable: editable, onChange: onChange, onClick: onClick, validator: validator, ...props })=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $c86dX.StaffMultiselect), {
            selectedStaffMembers: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__staff",
            onChange: onChange,
            isvalid: validator,
            ...props
        }),
    roles: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $c86dX.RoleMultiselect), {
            selectedRoles: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__staff",
            onChange: onChange,
            isvalid: validator,
            ...props
        }),
    durationMinutes: ({ value: value, editable: editable, onChange: onChange, onClick: onClick, validator: validator, ...props })=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $y5iig.HoursInput), {
            value: value,
            isEditable: editable,
            className: "coincraft-table-cell__input coincraft-table-cell__currency",
            onChange: onChange,
            isvalid: validator,
            ...props
        })
};
const $a6d774252e6c4e48$var$DurationInput = ({ value: value, isEditable: isEditable, onChange: onChange, isvalid: isvalid, className: className, ...props })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        ...props,
        style: {
            width: "100%"
        },
        className: `flex ${className}`,
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "coincraft-table-cell coincraft-table-cell--text",
                style: {
                    width: "40%"
                },
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $foLWS.default), {
                    className: "coincraft-table-cell__input coincraft-table-cell__text",
                    value: value.value || 0,
                    formatter: (v)=>(0, $cwjKY.FormatNumber)(v, {
                            decimals: 2
                        }),
                    parser: (0, $1oGzi.ParseNumber),
                    isEditable: isEditable,
                    onChange: (v)=>onChange({
                            value: v
                        }),
                    style: {
                        textAlign: "right"
                    }
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "coincraft-table-cell coincraft-table-cell--dropdown [&_button]:!bg-transparent",
                style: {
                    width: "60%"
                },
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                    selectedOption: value.unit || "days",
                    onChange: (unit)=>onChange({
                            unit: unit
                        }),
                    options: [
                        "days",
                        "weeks",
                        "months"
                    ],
                    optionLabel: (o)=>o,
                    style: {
                        border: "none"
                    },
                    variant: "secondary"
                })
            })
        ]
    });
};

});
parcelRegister("cD0xd", function(module, exports) {

$parcel$export(module.exports, "ParseCurrency", function () { return $93198abf4ea93065$export$37c7b4632bbb0536; });

var $lHDBd = parcelRequire("lHDBd");


var $8KnSr = parcelRequire("8KnSr");

var $3arU6 = parcelRequire("3arU6");

var $1BTI2 = parcelRequire("1BTI2");

var $aTUKb = parcelRequire("aTUKb");

var $iVCd9 = parcelRequire("iVCd9");
parcelRequire("12o9H");
const $93198abf4ea93065$export$37c7b4632bbb0536 = (valueString, { currency: currency = (0, (/*@__PURE__*/$parcel$interopDefault($8KnSr))).getCurrency((0, (/*@__PURE__*/$parcel$interopDefault($3arU6))).findCountryLocales((0, $aTUKb.constantCase)(((0, $1BTI2.default) === null || (0, $1BTI2.default) === void 0 ? void 0 : (0, $1BTI2.default).organisationCountry) || "us"))[0]) } = {})=>{
    if ([
        null,
        undefined,
        ""
    ].includes(valueString)) return valueString;
    try {
        // Check if the string contains mathematical operators
        if (/[+\-*/()^]/.test(valueString)) {
            // Get the current locale based on organisation country
            const locale = (0, (/*@__PURE__*/$parcel$interopDefault($3arU6))).findCountryLocales((0, $aTUKb.constantCase)(((0, $1BTI2.default) === null || (0, $1BTI2.default) === void 0 ? void 0 : (0, $1BTI2.default).organisationCountry) || "us"))[0];
            // Create currency parser for the current locale
            const parser = new (0, $lHDBd.NumberParser)(locale, {
                style: "currency",
                currency: currency || "USD"
            });
            // Regular expression to match currency values and operators
            // This improved regex handles currency symbols/codes at both start and end of numbers
            const regex = /(\p{Sc}?\s*\d[\d.,]*(?:\s*[a-zA-Z]{1,3})?)|([-+*/()^])/gu;
            // Process the string to replace localized currency values with standard format
            let standardizedExpression = "";
            let lastIndex = 0;
            let match;
            const expression = String(valueString);
            // Use regex to find all currency values and operators
            while((match = regex.exec(expression)) !== null){
                // If there's text between the last match and this one, add it to result
                if (match.index > lastIndex) standardizedExpression += expression.substring(lastIndex, match.index);
                if (match[1]) // This is a currency value - parse it according to locale
                try {
                    const parsedValue = parser.parse(match[1]);
                    standardizedExpression += parsedValue;
                } catch (e) {
                    // If parsing fails, try removing all currency characters and try again
                    try {
                        // Remove both currency symbols and currency codes (2-3 letter codes like EUR, USD, kn, etc.)
                        const valueWithoutCurrency = match[1].replace(/\p{Sc}/gu, "") // Remove currency symbols
                        .replace(/\s*[a-zA-Z]{1,3}\s*$/g, "") // Remove currency codes at the end
                        .trim();
                        const parsedValue = parser.parse(valueWithoutCurrency);
                        standardizedExpression += parsedValue;
                    } catch (innerError) {
                        // Last resort: clean the string and try to get a numeric value out of it
                        try {
                            // Keep only digits, decimal point, and comma
                            let cleanValue = match[1].replace(/[^\d.,]/g, "");
                            // Handle different decimal separators
                            // In Croatian locale, comma is decimal separator and period is thousands separator
                            if (locale.startsWith("hr")) cleanValue = cleanValue.replace(/\./g, "") // Remove thousands separators (periods)
                            .replace(/,/g, "."); // Replace decimal comma with decimal point
                            else if (/,\d{1,2}$/.test(cleanValue)) // If there's a comma followed by 1-2 digits at the end, likely a decimal comma
                            cleanValue = cleanValue.replace(/,(\d{1,2})$/, ".$1");
                            // Convert to number and back to string to ensure it's a valid number
                            standardizedExpression += parseFloat(cleanValue);
                        } catch (finalError) {
                            // If all parsing fails, just remove non-numeric characters
                            standardizedExpression += match[1].replace(/[^\d.]/g, "");
                        }
                    }
                }
                else if (match[2]) // This is an operator - keep it as is
                standardizedExpression += match[2];
                lastIndex = regex.lastIndex;
            }
            // Add any remaining text after the last match
            if (lastIndex < expression.length) standardizedExpression += expression.substring(lastIndex);
            // Evaluate the standardized expression
            return (0, $iVCd9.evaluate)(standardizedExpression);
        } else {
            // If there are no operators, just parse the currency value normally
            const parser = new (0, $lHDBd.NumberParser)((0, (/*@__PURE__*/$parcel$interopDefault($3arU6))).findCountryLocales((0, $aTUKb.constantCase)(((0, $1BTI2.default) === null || (0, $1BTI2.default) === void 0 ? void 0 : (0, $1BTI2.default).organisationCountry) || "us"))[0], {
                style: "currency",
                currency: currency || "USD"
            });
            // Try direct parsing first
            try {
                return parser.parse(String(valueString));
            } catch (e) {
                // If direct parsing fails, try removing currency codes
                try {
                    const valueWithoutCurrency = String(valueString).replace(/\p{Sc}/gu, "").replace(/\s*[a-zA-Z]{1,3}\s*$/g, "").trim();
                    return parser.parse(valueWithoutCurrency);
                } catch (innerError) {
                    // Return the original string as a fallback
                    return valueString;
                }
            }
        }
    } catch (e) {
        // If all else fails, return the original string
        return valueString;
    }
};

});
parcelRegister("lHDBd", function(module, exports) {

$parcel$export(module.exports, "NumberParser", function () { return $fccc54bbffc24c0a$export$cd11ab140839f11d; });

var $d0JnH = parcelRequire("d0JnH");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $fccc54bbffc24c0a$var$$6c7bd7858deea686$var$CURRENCY_SIGN_REGEX = new RegExp("^.*\\(.*\\).*$");
const $fccc54bbffc24c0a$var$$6c7bd7858deea686$var$NUMBERING_SYSTEMS = [
    "latn",
    "arab",
    "hanidec"
];
class $fccc54bbffc24c0a$export$cd11ab140839f11d {
    /**
   * Parses the given string to a number. Returns NaN if a valid number could not be parsed.
   */ parse(value) {
        return $fccc54bbffc24c0a$var$$6c7bd7858deea686$var$getNumberParserImpl(this.locale, this.options, value).parse(value);
    }
    /**
   * Returns whether the given string could potentially be a valid number. This should be used to
   * validate user input as the user types. If a `minValue` or `maxValue` is provided, the validity
   * of the minus/plus sign characters can be checked.
   */ isValidPartialNumber(value, minValue, maxValue) {
        return $fccc54bbffc24c0a$var$$6c7bd7858deea686$var$getNumberParserImpl(this.locale, this.options, value).isValidPartialNumber(value, minValue, maxValue);
    }
    /**
   * Returns a numbering system for which the given string is valid in the current locale.
   * If no numbering system could be detected, the default numbering system for the current
   * locale is returned.
   */ getNumberingSystem(value) {
        return $fccc54bbffc24c0a$var$$6c7bd7858deea686$var$getNumberParserImpl(this.locale, this.options, value).options.numberingSystem;
    }
    constructor(locale, options = {}){
        this.locale = locale;
        this.options = options;
    }
}
const $fccc54bbffc24c0a$var$$6c7bd7858deea686$var$numberParserCache = new Map();
function $fccc54bbffc24c0a$var$$6c7bd7858deea686$var$getNumberParserImpl(locale, options, value) {
    // First try the default numbering system for the provided locale
    let defaultParser = $fccc54bbffc24c0a$var$$6c7bd7858deea686$var$getCachedNumberParser(locale, options);
    // If that doesn't match, and the locale doesn't include a hard coded numbering system,
    // try each of the other supported numbering systems until we find one that matches.
    if (!locale.includes("-nu-") && !defaultParser.isValidPartialNumber(value)) {
        for (let numberingSystem of $fccc54bbffc24c0a$var$$6c7bd7858deea686$var$NUMBERING_SYSTEMS)if (numberingSystem !== defaultParser.options.numberingSystem) {
            let parser = $fccc54bbffc24c0a$var$$6c7bd7858deea686$var$getCachedNumberParser(locale + (locale.includes("-u-") ? "-nu-" : "-u-nu-") + numberingSystem, options);
            if (parser.isValidPartialNumber(value)) return parser;
        }
    }
    return defaultParser;
}
function $fccc54bbffc24c0a$var$$6c7bd7858deea686$var$getCachedNumberParser(locale, options) {
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : "");
    let parser = $fccc54bbffc24c0a$var$$6c7bd7858deea686$var$numberParserCache.get(cacheKey);
    if (!parser) {
        parser = new $fccc54bbffc24c0a$var$$6c7bd7858deea686$var$NumberParserImpl(locale, options);
        $fccc54bbffc24c0a$var$$6c7bd7858deea686$var$numberParserCache.set(cacheKey, parser);
    }
    return parser;
}
// The actual number parser implementation. Instances of this class are cached
// based on the locale, options, and detected numbering system.
class $fccc54bbffc24c0a$var$$6c7bd7858deea686$var$NumberParserImpl {
    parse(value) {
        // to parse the number, we need to remove anything that isn't actually part of the number, for example we want '-10.40' not '-10.40 USD'
        let fullySanitizedValue = this.sanitize(value);
        if (this.symbols.group) fullySanitizedValue = $fccc54bbffc24c0a$var$$6c7bd7858deea686$var$replaceAll(fullySanitizedValue, this.symbols.group, "");
        if (this.symbols.decimal) fullySanitizedValue = fullySanitizedValue.replace(this.symbols.decimal, ".");
        if (this.symbols.minusSign) fullySanitizedValue = fullySanitizedValue.replace(this.symbols.minusSign, "-");
        fullySanitizedValue = fullySanitizedValue.replace(this.symbols.numeral, this.symbols.index);
        if (this.options.style === "percent") {
            // javascript is bad at dividing by 100 and maintaining the same significant figures, so perform it on the string before parsing
            let isNegative = fullySanitizedValue.indexOf("-");
            fullySanitizedValue = fullySanitizedValue.replace("-", "");
            let index = fullySanitizedValue.indexOf(".");
            if (index === -1) index = fullySanitizedValue.length;
            fullySanitizedValue = fullySanitizedValue.replace(".", "");
            if (index - 2 === 0) fullySanitizedValue = `0.${fullySanitizedValue}`;
            else if (index - 2 === -1) fullySanitizedValue = `0.0${fullySanitizedValue}`;
            else if (index - 2 === -2) fullySanitizedValue = "0.00";
            else fullySanitizedValue = `${fullySanitizedValue.slice(0, index - 2)}.${fullySanitizedValue.slice(index - 2)}`;
            if (isNegative > -1) fullySanitizedValue = `-${fullySanitizedValue}`;
        }
        let newValue = fullySanitizedValue ? +fullySanitizedValue : NaN;
        if (isNaN(newValue)) return NaN;
        if (this.options.style === "percent") {
            var _this_options_minimumFractionDigits, _this_options_maximumFractionDigits;
            // extra step for rounding percents to what our formatter would output
            let options = {
                ...this.options,
                style: "decimal",
                minimumFractionDigits: Math.min(((_this_options_minimumFractionDigits = this.options.minimumFractionDigits) !== null && _this_options_minimumFractionDigits !== void 0 ? _this_options_minimumFractionDigits : 0) + 2, 20),
                maximumFractionDigits: Math.min(((_this_options_maximumFractionDigits = this.options.maximumFractionDigits) !== null && _this_options_maximumFractionDigits !== void 0 ? _this_options_maximumFractionDigits : 0) + 2, 20)
            };
            return new $fccc54bbffc24c0a$export$cd11ab140839f11d(this.locale, options).parse(new (0, $d0JnH.NumberFormatter)(this.locale, options).format(newValue));
        }
        // accounting will always be stripped to a positive number, so if it's accounting and has a () around everything, then we need to make it negative again
        if (this.options.currencySign === "accounting" && $fccc54bbffc24c0a$var$$6c7bd7858deea686$var$CURRENCY_SIGN_REGEX.test(value)) newValue = -1 * newValue;
        return newValue;
    }
    sanitize(value) {
        // Remove literals and whitespace, which are allowed anywhere in the string
        value = value.replace(this.symbols.literals, "");
        // Replace the ASCII minus sign with the minus sign used in the current locale
        // so that both are allowed in case the user's keyboard doesn't have the locale's minus sign.
        if (this.symbols.minusSign) value = value.replace("-", this.symbols.minusSign);
        // In arab numeral system, their decimal character is 1643, but most keyboards don't type that
        // instead they use the , (44) character or apparently the (1548) character.
        if (this.options.numberingSystem === "arab") {
            if (this.symbols.decimal) {
                value = value.replace(",", this.symbols.decimal);
                value = value.replace(String.fromCharCode(1548), this.symbols.decimal);
            }
            if (this.symbols.group) value = $fccc54bbffc24c0a$var$$6c7bd7858deea686$var$replaceAll(value, ".", this.symbols.group);
        }
        // fr-FR group character is char code 8239, but that's not a key on the french keyboard,
        // so allow 'period' as a group char and replace it with a space
        if (this.options.locale === "fr-FR") value = $fccc54bbffc24c0a$var$$6c7bd7858deea686$var$replaceAll(value, ".", String.fromCharCode(8239));
        return value;
    }
    isValidPartialNumber(value, minValue = -Infinity, maxValue = Infinity) {
        value = this.sanitize(value);
        // Remove minus or plus sign, which must be at the start of the string.
        if (this.symbols.minusSign && value.startsWith(this.symbols.minusSign) && minValue < 0) value = value.slice(this.symbols.minusSign.length);
        else if (this.symbols.plusSign && value.startsWith(this.symbols.plusSign) && maxValue > 0) value = value.slice(this.symbols.plusSign.length);
        // Numbers cannot start with a group separator
        if (this.symbols.group && value.startsWith(this.symbols.group)) return false;
        // Numbers that can't have any decimal values fail if a decimal character is typed
        if (this.symbols.decimal && value.indexOf(this.symbols.decimal) > -1 && this.options.maximumFractionDigits === 0) return false;
        // Remove numerals, groups, and decimals
        if (this.symbols.group) value = $fccc54bbffc24c0a$var$$6c7bd7858deea686$var$replaceAll(value, this.symbols.group, "");
        value = value.replace(this.symbols.numeral, "");
        if (this.symbols.decimal) value = value.replace(this.symbols.decimal, "");
        // The number is valid if there are no remaining characters
        return value.length === 0;
    }
    constructor(locale, options = {}){
        this.locale = locale;
        this.formatter = new Intl.NumberFormat(locale, options);
        this.options = this.formatter.resolvedOptions();
        this.symbols = $fccc54bbffc24c0a$var$$6c7bd7858deea686$var$getSymbols(locale, this.formatter, this.options, options);
        var _this_options_minimumFractionDigits, _this_options_maximumFractionDigits;
        if (this.options.style === "percent" && (((_this_options_minimumFractionDigits = this.options.minimumFractionDigits) !== null && _this_options_minimumFractionDigits !== void 0 ? _this_options_minimumFractionDigits : 0) > 18 || ((_this_options_maximumFractionDigits = this.options.maximumFractionDigits) !== null && _this_options_maximumFractionDigits !== void 0 ? _this_options_maximumFractionDigits : 0) > 18)) console.warn("NumberParser cannot handle percentages with greater than 18 decimal places, please reduce the number in your options.");
    }
}
const $fccc54bbffc24c0a$var$$6c7bd7858deea686$var$nonLiteralParts = new Set([
    "decimal",
    "fraction",
    "integer",
    "minusSign",
    "plusSign",
    "group"
]);
// This list is derived from https://www.unicode.org/cldr/charts/43/supplemental/language_plural_rules.html#comparison and includes
// all unique numbers which we need to check in order to determine all the plural forms for a given locale.
// See: https://github.com/adobe/react-spectrum/pull/5134/files#r1337037855 for used script
const $fccc54bbffc24c0a$var$$6c7bd7858deea686$var$pluralNumbers = [
    0,
    4,
    2,
    1,
    11,
    20,
    3,
    7,
    100,
    21,
    0.1,
    1.1
];
function $fccc54bbffc24c0a$var$$6c7bd7858deea686$var$getSymbols(locale, formatter, intlOptions, originalOptions) {
    var _allParts_find, _posAllParts_find, _decimalParts_find, _allParts_find1;
    // formatter needs access to all decimal places in order to generate the correct literal strings for the plural set
    let symbolFormatter = new Intl.NumberFormat(locale, {
        ...intlOptions,
        minimumSignificantDigits: 1,
        maximumSignificantDigits: 21
    });
    // Note: some locale's don't add a group symbol until there is a ten thousands place
    let allParts = symbolFormatter.formatToParts(-10000.111);
    let posAllParts = symbolFormatter.formatToParts(10000.111);
    let pluralParts = $fccc54bbffc24c0a$var$$6c7bd7858deea686$var$pluralNumbers.map((n)=>symbolFormatter.formatToParts(n));
    var _allParts_find_value;
    let minusSign = (_allParts_find_value = (_allParts_find = allParts.find((p)=>p.type === "minusSign")) === null || _allParts_find === void 0 ? void 0 : _allParts_find.value) !== null && _allParts_find_value !== void 0 ? _allParts_find_value : "-";
    let plusSign = (_posAllParts_find = posAllParts.find((p)=>p.type === "plusSign")) === null || _posAllParts_find === void 0 ? void 0 : _posAllParts_find.value;
    // Safari does not support the signDisplay option, but our number parser polyfills it.
    // If no plus sign was returned, but the original options contained signDisplay, default to the '+' character.
    // @ts-ignore
    if (!plusSign && ((originalOptions === null || originalOptions === void 0 ? void 0 : originalOptions.signDisplay) === "exceptZero" || (originalOptions === null || originalOptions === void 0 ? void 0 : originalOptions.signDisplay) === "always")) plusSign = "+";
    // If maximumSignificantDigits is 1 (the minimum) then we won't get decimal characters out of the above formatters
    // Percent also defaults to 0 fractionDigits, so we need to make a new one that isn't percent to get an accurate decimal
    let decimalParts = new Intl.NumberFormat(locale, {
        ...intlOptions,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).formatToParts(0.001);
    let decimal = (_decimalParts_find = decimalParts.find((p)=>p.type === "decimal")) === null || _decimalParts_find === void 0 ? void 0 : _decimalParts_find.value;
    let group = (_allParts_find1 = allParts.find((p)=>p.type === "group")) === null || _allParts_find1 === void 0 ? void 0 : _allParts_find1.value;
    // this set is also for a regex, it's all literals that might be in the string we want to eventually parse that
    // don't contribute to the numerical value
    let allPartsLiterals = allParts.filter((p)=>!$fccc54bbffc24c0a$var$$6c7bd7858deea686$var$nonLiteralParts.has(p.type)).map((p)=>$fccc54bbffc24c0a$var$$6c7bd7858deea686$var$escapeRegex(p.value));
    let pluralPartsLiterals = pluralParts.flatMap((p)=>p.filter((p)=>!$fccc54bbffc24c0a$var$$6c7bd7858deea686$var$nonLiteralParts.has(p.type)).map((p)=>$fccc54bbffc24c0a$var$$6c7bd7858deea686$var$escapeRegex(p.value)));
    let sortedLiterals = [
        ...new Set([
            ...allPartsLiterals,
            ...pluralPartsLiterals
        ])
    ].sort((a, b)=>b.length - a.length);
    let literals = sortedLiterals.length === 0 ? new RegExp("[\\p{White_Space}]", "gu") : new RegExp(`${sortedLiterals.join("|")}|[\\p{White_Space}]`, "gu");
    // These are for replacing non-latn characters with the latn equivalent
    let numerals = [
        ...new Intl.NumberFormat(intlOptions.locale, {
            useGrouping: false
        }).format(9876543210)
    ].reverse();
    let indexes = new Map(numerals.map((d, i)=>[
            d,
            i
        ]));
    let numeral = new RegExp(`[${numerals.join("")}]`, "g");
    let index = (d)=>String(indexes.get(d));
    return {
        minusSign: minusSign,
        plusSign: plusSign,
        decimal: decimal,
        group: group,
        literals: literals,
        numeral: numeral,
        index: index
    };
}
function $fccc54bbffc24c0a$var$$6c7bd7858deea686$var$replaceAll(str, find, replace) {
    // @ts-ignore
    if (str.replaceAll) return str.replaceAll(find, replace);
    return str.split(find).join(replace);
}
function $fccc54bbffc24c0a$var$$6c7bd7858deea686$var$escapeRegex(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

});

parcelRegister("iVCd9", function(module, exports) {

$parcel$export(module.exports, "evaluate", function () { return $dc7b30c8aa9a3509$export$fef61f332f2c0afc; });

var $89s6m = parcelRequire("89s6m");

var $asmGj = parcelRequire("asmGj");
var $ajZDX = parcelRequire("ajZDX");
var $9YGyY = parcelRequire("9YGyY");
var $pvzaC = parcelRequire("pvzaC");
var $fHFIO = parcelRequire("fHFIO");
var $43buJ = parcelRequire("43buJ");
var $fM22c = parcelRequire("fM22c");
var $9Z8BS = parcelRequire("9Z8BS");
var $gOTg6 = parcelRequire("gOTg6");
var $gC4ea = parcelRequire("gC4ea");
var $jY7fN = parcelRequire("jY7fN");
var $iKJit = parcelRequire("iKJit");
var $c7Jeb = parcelRequire("c7Jeb");
var $2TjMU = parcelRequire("2TjMU");
var $gHcOy = parcelRequire("gHcOy");
var $lvMNH = parcelRequire("lvMNH");
var $52TUB = parcelRequire("52TUB");
var $gT4Ra = parcelRequire("gT4Ra");
var $ehBJU = parcelRequire("ehBJU");
var $fTGKn = parcelRequire("fTGKn");
var $eBv9n = parcelRequire("eBv9n");
var $iQKTE = parcelRequire("iQKTE");
var $7xwSh = parcelRequire("7xwSh");
var $1hNiT = parcelRequire("1hNiT");
var $lxQ6R = parcelRequire("lxQ6R");
var $6UsSe = parcelRequire("6UsSe");
var $d3O1R = parcelRequire("d3O1R");
var $fv3L7 = parcelRequire("fv3L7");
var $e771R = parcelRequire("e771R");
var $jRgnt = parcelRequire("jRgnt");
var $e4Jrf = parcelRequire("e4Jrf");
var $eZkT2 = parcelRequire("eZkT2");
var $d6Zpi = parcelRequire("d6Zpi");
var $4s10Q = parcelRequire("4s10Q");
var $lfJeA = parcelRequire("lfJeA");
var $1uL9J = parcelRequire("1uL9J");
var $hcdH4 = parcelRequire("hcdH4");
var $9qO5M = parcelRequire("9qO5M");
var $a4HxT = parcelRequire("a4HxT");
var $fvcKJ = parcelRequire("fvcKJ");
var $jJ20c = parcelRequire("jJ20c");
var $fbyJR = parcelRequire("fbyJR");
var $dYbzE = parcelRequire("dYbzE");
var $jK9Uj = parcelRequire("jK9Uj");
var $hL252 = parcelRequire("hL252");

var $kbUbx = parcelRequire("kbUbx");

function $dc7b30c8aa9a3509$var$_extends() {
    $dc7b30c8aa9a3509$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dc7b30c8aa9a3509$var$_extends.apply(this, arguments);
}
var $dc7b30c8aa9a3509$var$math = {}; // NOT pure!
var $dc7b30c8aa9a3509$var$mathWithTransform = {}; // NOT pure!
var $dc7b30c8aa9a3509$var$classes = {}; // NOT pure!
var $dc7b30c8aa9a3509$export$85c928794f8d04d4 = (0, $d3O1R.createNode)({
    mathWithTransform: $dc7b30c8aa9a3509$var$mathWithTransform
});
var $dc7b30c8aa9a3509$export$97d96bf9b84874d5 = (0, $9YGyY.createArrayNode)({
    Node: $dc7b30c8aa9a3509$export$85c928794f8d04d4
});
var $dc7b30c8aa9a3509$export$ec7b1e3e36733ff3 = (0, $fHFIO.createBlockNode)({
    Node: $dc7b30c8aa9a3509$export$85c928794f8d04d4,
    ResultSet: (0, $kbUbx.ResultSet)
});
var $dc7b30c8aa9a3509$export$3166e8715d58cf9a = (0, $iKJit.createConstantNode)({
    Node: $dc7b30c8aa9a3509$export$85c928794f8d04d4
});
var $dc7b30c8aa9a3509$export$b70fa93b5fbdd997 = (0, $fv3L7.createObjectNode)({
    Node: $dc7b30c8aa9a3509$export$85c928794f8d04d4
});
var $dc7b30c8aa9a3509$export$dbdb6279b6a3bac9 = (0, $jRgnt.createParenthesisNode)({
    Node: $dc7b30c8aa9a3509$export$85c928794f8d04d4
});
var $dc7b30c8aa9a3509$export$a4d9a8de1ded3461 = (0, $hcdH4.createRelationalNode)({
    Node: $dc7b30c8aa9a3509$export$85c928794f8d04d4
});
var $dc7b30c8aa9a3509$export$f18d5acc27d70423 = (0, $fM22c.createChainClass)({
    math: $dc7b30c8aa9a3509$var$math
});
var $dc7b30c8aa9a3509$export$63698c10df99509c = (0, $9qO5M.createReviver)({
    classes: $dc7b30c8aa9a3509$var$classes
});
var $dc7b30c8aa9a3509$export$8e402c64e6081013 = (0, $jY7fN.createConditionalNode)({
    Node: $dc7b30c8aa9a3509$export$85c928794f8d04d4
});
var $dc7b30c8aa9a3509$export$cd498840ad265e90 = (0, $e771R.createOperatorNode)({
    Node: $dc7b30c8aa9a3509$export$85c928794f8d04d4
});
var $dc7b30c8aa9a3509$export$d0e9917d83c120a0 = (0, $4s10Q.createRangeNode)({
    Node: $dc7b30c8aa9a3509$export$85c928794f8d04d4
});
var $dc7b30c8aa9a3509$export$446a68c3fb943f17 = (0, $52TUB.createFunctionAssignmentNode)({
    Node: $dc7b30c8aa9a3509$export$85c928794f8d04d4,
    typed: (0, $kbUbx.typed)
});
var $dc7b30c8aa9a3509$export$e08e3b67e392101e = (0, $43buJ.createChain)({
    Chain: $dc7b30c8aa9a3509$export$f18d5acc27d70423,
    typed: (0, $kbUbx.typed)
});
var $dc7b30c8aa9a3509$export$c3248ebc7ade74c5 = (0, $asmGj.createAccessorNode)({
    Node: $dc7b30c8aa9a3509$export$85c928794f8d04d4,
    subset: (0, $kbUbx.subset)
});
var $dc7b30c8aa9a3509$export$929eaad981940a63 = (0, $eBv9n.createIndexNode)({
    Node: $dc7b30c8aa9a3509$export$85c928794f8d04d4,
    Range: (0, $kbUbx.Range),
    size: (0, $kbUbx.size)
});
var $dc7b30c8aa9a3509$export$a144098e31f7b52f = (0, $pvzaC.createAssignmentNode)({
    matrix: (0, $kbUbx.matrix),
    Node: $dc7b30c8aa9a3509$export$85c928794f8d04d4,
    subset: (0, $kbUbx.subset)
});
var $dc7b30c8aa9a3509$export$93b6424aaa42dda7 = (0, $jK9Uj.createSymbolNode)({
    Unit: (0, $kbUbx.Unit),
    Node: $dc7b30c8aa9a3509$export$85c928794f8d04d4,
    math: $dc7b30c8aa9a3509$var$math
});
var $dc7b30c8aa9a3509$export$f2972be796679c12 = (0, $gT4Ra.createFunctionNode)({
    Node: $dc7b30c8aa9a3509$export$85c928794f8d04d4,
    SymbolNode: $dc7b30c8aa9a3509$export$93b6424aaa42dda7,
    math: $dc7b30c8aa9a3509$var$math
});
var $dc7b30c8aa9a3509$export$98e6a39c04603d36 = (0, $e4Jrf.createParse)({
    AccessorNode: $dc7b30c8aa9a3509$export$c3248ebc7ade74c5,
    ArrayNode: $dc7b30c8aa9a3509$export$97d96bf9b84874d5,
    AssignmentNode: $dc7b30c8aa9a3509$export$a144098e31f7b52f,
    BlockNode: $dc7b30c8aa9a3509$export$ec7b1e3e36733ff3,
    ConditionalNode: $dc7b30c8aa9a3509$export$8e402c64e6081013,
    ConstantNode: $dc7b30c8aa9a3509$export$3166e8715d58cf9a,
    FunctionAssignmentNode: $dc7b30c8aa9a3509$export$446a68c3fb943f17,
    FunctionNode: $dc7b30c8aa9a3509$export$f2972be796679c12,
    IndexNode: $dc7b30c8aa9a3509$export$929eaad981940a63,
    ObjectNode: $dc7b30c8aa9a3509$export$b70fa93b5fbdd997,
    OperatorNode: $dc7b30c8aa9a3509$export$cd498840ad265e90,
    ParenthesisNode: $dc7b30c8aa9a3509$export$dbdb6279b6a3bac9,
    RangeNode: $dc7b30c8aa9a3509$export$d0e9917d83c120a0,
    RelationalNode: $dc7b30c8aa9a3509$export$a4d9a8de1ded3461,
    SymbolNode: $dc7b30c8aa9a3509$export$93b6424aaa42dda7,
    config: (0, $89s6m.config),
    numeric: (0, $kbUbx.numeric),
    typed: (0, $kbUbx.typed)
});
var $dc7b30c8aa9a3509$export$fef61f332f2c0afc = (0, $2TjMU.createEvaluate)({
    parse: $dc7b30c8aa9a3509$export$98e6a39c04603d36,
    typed: (0, $kbUbx.typed)
});
var $dc7b30c8aa9a3509$export$7acfa6ed01010e37 = (0, $d6Zpi.createParserClass)({
    parse: $dc7b30c8aa9a3509$export$98e6a39c04603d36
});
var $dc7b30c8aa9a3509$export$1be7516c0280bee8 = (0, $fTGKn.createHelpClass)({
    parse: $dc7b30c8aa9a3509$export$98e6a39c04603d36
});
var $dc7b30c8aa9a3509$export$ef7acd7185315e22 = (0, $gOTg6.createCompile)({
    parse: $dc7b30c8aa9a3509$export$98e6a39c04603d36,
    typed: (0, $kbUbx.typed)
});
var $dc7b30c8aa9a3509$export$8f49e4af10703ce3 = (0, $eZkT2.createParser)({
    Parser: $dc7b30c8aa9a3509$export$7acfa6ed01010e37,
    typed: (0, $kbUbx.typed)
});
var $dc7b30c8aa9a3509$export$798b53621063651 = (0, $fvcKJ.createSimplify)({
    bignumber: (0, $kbUbx.bignumber),
    fraction: (0, $kbUbx.fraction),
    ConstantNode: $dc7b30c8aa9a3509$export$3166e8715d58cf9a,
    FunctionNode: $dc7b30c8aa9a3509$export$f2972be796679c12,
    OperatorNode: $dc7b30c8aa9a3509$export$cd498840ad265e90,
    ParenthesisNode: $dc7b30c8aa9a3509$export$dbdb6279b6a3bac9,
    SymbolNode: $dc7b30c8aa9a3509$export$93b6424aaa42dda7,
    add: (0, $kbUbx.add),
    config: (0, $89s6m.config),
    divide: (0, $kbUbx.divide),
    equal: (0, $kbUbx.equal),
    isZero: (0, $kbUbx.isZero),
    mathWithTransform: $dc7b30c8aa9a3509$var$mathWithTransform,
    multiply: (0, $kbUbx.multiply),
    parse: $dc7b30c8aa9a3509$export$98e6a39c04603d36,
    pow: (0, $kbUbx.pow),
    subtract: (0, $kbUbx.subtract),
    typed: (0, $kbUbx.typed)
});
var $dc7b30c8aa9a3509$export$725d762cc154d53 = (0, $1uL9J.createRationalize)({
    bignumber: (0, $kbUbx.bignumber),
    fraction: (0, $kbUbx.fraction),
    ConstantNode: $dc7b30c8aa9a3509$export$3166e8715d58cf9a,
    FunctionNode: $dc7b30c8aa9a3509$export$f2972be796679c12,
    OperatorNode: $dc7b30c8aa9a3509$export$cd498840ad265e90,
    ParenthesisNode: $dc7b30c8aa9a3509$export$dbdb6279b6a3bac9,
    SymbolNode: $dc7b30c8aa9a3509$export$93b6424aaa42dda7,
    add: (0, $kbUbx.add),
    config: (0, $89s6m.config),
    divide: (0, $kbUbx.divide),
    equal: (0, $kbUbx.equal),
    isZero: (0, $kbUbx.isZero),
    mathWithTransform: $dc7b30c8aa9a3509$var$mathWithTransform,
    multiply: (0, $kbUbx.multiply),
    parse: $dc7b30c8aa9a3509$export$98e6a39c04603d36,
    pow: (0, $kbUbx.pow),
    simplify: $dc7b30c8aa9a3509$export$798b53621063651,
    subtract: (0, $kbUbx.subtract),
    typed: (0, $kbUbx.typed)
});
var $dc7b30c8aa9a3509$export$34512e3b2db52a4e = (0, $ehBJU.createHelp)({
    Help: $dc7b30c8aa9a3509$export$1be7516c0280bee8,
    mathWithTransform: $dc7b30c8aa9a3509$var$mathWithTransform,
    typed: (0, $kbUbx.typed)
});
var $dc7b30c8aa9a3509$export$42645bbd8ddfc464 = (0, $c7Jeb.createDerivative)({
    ConstantNode: $dc7b30c8aa9a3509$export$3166e8715d58cf9a,
    FunctionNode: $dc7b30c8aa9a3509$export$f2972be796679c12,
    OperatorNode: $dc7b30c8aa9a3509$export$cd498840ad265e90,
    ParenthesisNode: $dc7b30c8aa9a3509$export$dbdb6279b6a3bac9,
    SymbolNode: $dc7b30c8aa9a3509$export$93b6424aaa42dda7,
    config: (0, $89s6m.config),
    equal: (0, $kbUbx.equal),
    isZero: (0, $kbUbx.isZero),
    numeric: (0, $kbUbx.numeric),
    parse: $dc7b30c8aa9a3509$export$98e6a39c04603d36,
    simplify: $dc7b30c8aa9a3509$export$798b53621063651,
    typed: (0, $kbUbx.typed)
});
$dc7b30c8aa9a3509$var$_extends($dc7b30c8aa9a3509$var$math, {
    "typeof": (0, $kbUbx.typeOf),
    eye: (0, $kbUbx.eye),
    reviver: $dc7b30c8aa9a3509$export$63698c10df99509c,
    "false": (0, $kbUbx._false),
    "null": (0, $kbUbx._null),
    "true": (0, $kbUbx._true),
    replacer: (0, $kbUbx.replacer),
    i: (0, $kbUbx.i),
    LN10: (0, $kbUbx.LN10),
    LOG10E: (0, $kbUbx.LOG10E),
    NaN: (0, $kbUbx._NaN),
    pi: (0, $kbUbx.pi),
    SQRT1_2: (0, $kbUbx.SQRT1_2),
    tau: (0, $kbUbx.tau),
    efimovFactor: (0, $kbUbx.efimovFactor),
    fineStructure: (0, $kbUbx.fineStructure),
    sackurTetrode: (0, $kbUbx.sackurTetrode),
    weakMixingAngle: (0, $kbUbx.weakMixingAngle),
    e: (0, $kbUbx.e),
    Infinity: (0, $kbUbx._Infinity),
    LOG2E: (0, $kbUbx.LOG2E),
    "PI": (0, $kbUbx.pi),
    version: (0, $kbUbx.version),
    "E": (0, $kbUbx.e),
    phi: (0, $kbUbx.phi),
    typed: (0, $kbUbx.typed),
    isInteger: (0, $kbUbx.isInteger),
    isNumeric: (0, $kbUbx.isNumeric),
    isPositive: (0, $kbUbx.isPositive),
    isNaN: (0, $kbUbx.isNaN),
    equalScalar: (0, $kbUbx.equalScalar),
    number: (0, $kbUbx.number),
    "boolean": (0, $kbUbx.boolean),
    complex: (0, $kbUbx.complex),
    splitUnit: (0, $kbUbx.splitUnit),
    unaryPlus: (0, $kbUbx.unaryPlus),
    apply: (0, $kbUbx.apply),
    cube: (0, $kbUbx.cube),
    expm1: (0, $kbUbx.expm1),
    log10: (0, $kbUbx.log10),
    multiplyScalar: (0, $kbUbx.multiplyScalar),
    sign: (0, $kbUbx.sign),
    square: (0, $kbUbx.square),
    bitNot: (0, $kbUbx.bitNot),
    arg: (0, $kbUbx.arg),
    im: (0, $kbUbx.im),
    not: (0, $kbUbx.not),
    filter: (0, $kbUbx.filter),
    forEach: (0, $kbUbx.forEach),
    map: (0, $kbUbx.map),
    erf: (0, $kbUbx.erf),
    format: (0, $kbUbx.format),
    isPrime: (0, $kbUbx.isPrime),
    acos: (0, $kbUbx.acos),
    acot: (0, $kbUbx.acot),
    acsc: (0, $kbUbx.acsc),
    asec: (0, $kbUbx.asec),
    asin: (0, $kbUbx.asin),
    atan: (0, $kbUbx.atan),
    atanh: (0, $kbUbx.atanh),
    cosh: (0, $kbUbx.cosh),
    coth: (0, $kbUbx.coth),
    csch: (0, $kbUbx.csch),
    sech: (0, $kbUbx.sech),
    sinh: (0, $kbUbx.sinh),
    tanh: (0, $kbUbx.tanh),
    chain: $dc7b30c8aa9a3509$export$e08e3b67e392101e,
    combinations: (0, $kbUbx.combinations),
    pickRandom: (0, $kbUbx.pickRandom),
    randomInt: (0, $kbUbx.randomInt),
    LN2: (0, $kbUbx.LN2),
    clone: (0, $kbUbx.clone),
    hasNumericValue: (0, $kbUbx.hasNumericValue),
    typeOf: (0, $kbUbx.typeOf),
    string: (0, $kbUbx.string),
    fraction: (0, $kbUbx.fraction),
    unaryMinus: (0, $kbUbx.unaryMinus),
    addScalar: (0, $kbUbx.addScalar),
    exp: (0, $kbUbx.exp),
    log2: (0, $kbUbx.log2),
    sqrt: (0, $kbUbx.sqrt),
    conj: (0, $kbUbx.conj),
    getMatrixDataType: (0, $kbUbx.getMatrixDataType),
    mode: (0, $kbUbx.mode),
    print: (0, $kbUbx.print),
    acosh: (0, $kbUbx.acosh),
    acsch: (0, $kbUbx.acsch),
    asinh: (0, $kbUbx.asinh),
    cos: (0, $kbUbx.cos),
    csc: (0, $kbUbx.csc),
    sin: (0, $kbUbx.sin),
    combinationsWithRep: (0, $kbUbx.combinationsWithRep),
    random: (0, $kbUbx.random),
    SQRT2: (0, $kbUbx.SQRT2),
    isNegative: (0, $kbUbx.isNegative),
    matrix: (0, $kbUbx.matrix),
    cbrt: (0, $kbUbx.cbrt),
    gcd: (0, $kbUbx.gcd),
    mod: (0, $kbUbx.mod),
    nthRoot: (0, $kbUbx.nthRoot),
    xgcd: (0, $kbUbx.xgcd),
    bitAnd: (0, $kbUbx.bitAnd),
    bitXor: (0, $kbUbx.bitXor),
    or: (0, $kbUbx.or),
    concat: (0, $kbUbx.concat),
    diag: (0, $kbUbx.diag),
    identity: (0, $kbUbx.identity),
    ones: (0, $kbUbx.ones),
    reshape: (0, $kbUbx.reshape),
    size: (0, $kbUbx.size),
    subset: (0, $kbUbx.subset),
    zeros: (0, $kbUbx.zeros),
    to: (0, $kbUbx.to),
    round: (0, $kbUbx.round),
    leftShift: (0, $kbUbx.leftShift),
    rightLogShift: (0, $kbUbx.rightLogShift),
    compare: (0, $kbUbx.compare),
    compareText: (0, $kbUbx.compareText),
    smaller: (0, $kbUbx.smaller),
    larger: (0, $kbUbx.larger),
    unequal: (0, $kbUbx.unequal),
    max: (0, $kbUbx.max),
    sparse: (0, $kbUbx.sparse),
    acoth: (0, $kbUbx.acoth),
    atan2: (0, $kbUbx.atan2),
    sec: (0, $kbUbx.sec),
    add: (0, $kbUbx.add),
    trace: (0, $kbUbx.trace),
    composition: (0, $kbUbx.composition),
    isZero: (0, $kbUbx.isZero),
    abs: (0, $kbUbx.abs),
    floor: (0, $kbUbx.floor),
    multiply: (0, $kbUbx.multiply),
    dotMultiply: (0, $kbUbx.dotMultiply),
    re: (0, $kbUbx.re),
    flatten: (0, $kbUbx.flatten),
    resize: (0, $kbUbx.resize),
    squeeze: (0, $kbUbx.squeeze),
    prod: (0, $kbUbx.prod),
    pow: (0, $kbUbx.pow),
    dotPow: (0, $kbUbx.dotPow),
    rightArithShift: (0, $kbUbx.rightArithShift),
    compareNatural: (0, $kbUbx.compareNatural),
    equalText: (0, $kbUbx.equalText),
    largerEq: (0, $kbUbx.largerEq),
    partitionSelect: (0, $kbUbx.partitionSelect),
    min: (0, $kbUbx.min),
    asech: (0, $kbUbx.asech),
    tan: (0, $kbUbx.tan),
    setSize: (0, $kbUbx.setSize),
    norm: (0, $kbUbx.norm),
    quantileSeq: (0, $kbUbx.quantileSeq),
    gamma: (0, $kbUbx.gamma),
    bignumber: (0, $kbUbx.bignumber),
    lcm: (0, $kbUbx.lcm),
    bitOr: (0, $kbUbx.bitOr),
    kron: (0, $kbUbx.kron),
    transpose: (0, $kbUbx.transpose),
    numeric: (0, $kbUbx.numeric),
    and: (0, $kbUbx.and),
    smallerEq: (0, $kbUbx.smallerEq),
    sort: (0, $kbUbx.sort),
    cot: (0, $kbUbx.cot),
    dot: (0, $kbUbx.dot),
    sum: (0, $kbUbx.sum),
    factorial: (0, $kbUbx.factorial),
    permutations: (0, $kbUbx.permutations),
    ceil: (0, $kbUbx.ceil),
    subtract: (0, $kbUbx.subtract),
    cross: (0, $kbUbx.cross),
    ctranspose: (0, $kbUbx.ctranspose),
    equal: (0, $kbUbx.equal),
    setCartesian: (0, $kbUbx.setCartesian),
    setDistinct: (0, $kbUbx.setDistinct),
    setIsSubset: (0, $kbUbx.setIsSubset),
    setPowerset: (0, $kbUbx.setPowerset),
    index: (0, $kbUbx.index),
    fix: (0, $kbUbx.fix),
    range: (0, $kbUbx.range),
    divideScalar: (0, $kbUbx.divideScalar),
    nthRoots: (0, $kbUbx.nthRoots),
    lsolve: (0, $kbUbx.lsolve),
    deepEqual: (0, $kbUbx.deepEqual),
    setDifference: (0, $kbUbx.setDifference),
    setMultiplicity: (0, $kbUbx.setMultiplicity),
    hypot: (0, $kbUbx.hypot),
    lup: (0, $kbUbx.lup),
    slu: (0, $kbUbx.slu),
    det: (0, $kbUbx.det),
    distance: (0, $kbUbx.distance),
    stirlingS2: (0, $kbUbx.stirlingS2),
    catalan: (0, $kbUbx.catalan),
    xor: (0, $kbUbx.xor),
    row: (0, $kbUbx.row),
    dotDivide: (0, $kbUbx.dotDivide),
    createUnit: (0, $kbUbx.createUnit),
    setSymDifference: (0, $kbUbx.setSymDifference),
    qr: (0, $kbUbx.qr),
    inv: (0, $kbUbx.inv),
    expm: (0, $kbUbx.expm),
    divide: (0, $kbUbx.divide),
    mean: (0, $kbUbx.mean),
    variance: (0, $kbUbx.variance),
    std: (0, $kbUbx.std),
    multinomial: (0, $kbUbx.multinomial),
    atomicMass: (0, $kbUbx.atomicMass),
    bohrMagneton: (0, $kbUbx.bohrMagneton),
    boltzmann: (0, $kbUbx.boltzmann),
    conductanceQuantum: (0, $kbUbx.conductanceQuantum),
    deuteronMass: (0, $kbUbx.deuteronMass),
    electronMass: (0, $kbUbx.electronMass),
    faraday: (0, $kbUbx.faraday),
    firstRadiation: (0, $kbUbx.firstRadiation),
    gravitationConstant: (0, $kbUbx.gravitationConstant),
    hartreeEnergy: (0, $kbUbx.hartreeEnergy),
    klitzing: (0, $kbUbx.klitzing),
    magneticConstant: (0, $kbUbx.magneticConstant),
    molarMass: (0, $kbUbx.molarMass),
    molarPlanckConstant: (0, $kbUbx.molarPlanckConstant),
    neutronMass: (0, $kbUbx.neutronMass),
    planckCharge: (0, $kbUbx.planckCharge),
    planckLength: (0, $kbUbx.planckLength),
    planckTemperature: (0, $kbUbx.planckTemperature),
    protonMass: (0, $kbUbx.protonMass),
    reducedPlanckConstant: (0, $kbUbx.reducedPlanckConstant),
    secondRadiation: (0, $kbUbx.secondRadiation),
    stefanBoltzmann: (0, $kbUbx.stefanBoltzmann),
    vacuumImpedance: (0, $kbUbx.vacuumImpedance),
    column: (0, $kbUbx.column),
    usolve: (0, $kbUbx.usolve),
    setIntersect: (0, $kbUbx.setIntersect),
    lusolve: (0, $kbUbx.lusolve),
    eigs: (0, $kbUbx.eigs),
    intersect: (0, $kbUbx.intersect),
    "var": (0, $kbUbx.variance),
    bellNumbers: (0, $kbUbx.bellNumbers),
    avogadro: (0, $kbUbx.avogadro),
    classicalElectronRadius: (0, $kbUbx.classicalElectronRadius),
    electricConstant: (0, $kbUbx.electricConstant),
    fermiCoupling: (0, $kbUbx.fermiCoupling),
    gravity: (0, $kbUbx.gravity),
    loschmidt: (0, $kbUbx.loschmidt),
    molarMassC12: (0, $kbUbx.molarMassC12),
    nuclearMagneton: (0, $kbUbx.nuclearMagneton),
    planckMass: (0, $kbUbx.planckMass),
    quantumOfCirculation: (0, $kbUbx.quantumOfCirculation),
    speedOfLight: (0, $kbUbx.speedOfLight),
    wienDisplacement: (0, $kbUbx.wienDisplacement),
    log: (0, $kbUbx.log),
    unit: (0, $kbUbx.unit),
    parse: $dc7b30c8aa9a3509$export$98e6a39c04603d36,
    evaluate: $dc7b30c8aa9a3509$export$fef61f332f2c0afc,
    sqrtm: (0, $kbUbx.sqrtm),
    kldivergence: (0, $kbUbx.kldivergence),
    bohrRadius: (0, $kbUbx.bohrRadius),
    elementaryCharge: (0, $kbUbx.elementaryCharge),
    inverseConductanceQuantum: (0, $kbUbx.inverseConductanceQuantum),
    molarVolume: (0, $kbUbx.molarVolume),
    planckTime: (0, $kbUbx.planckTime),
    thomsonCrossSection: (0, $kbUbx.thomsonCrossSection),
    log1p: (0, $kbUbx.log1p),
    compile: $dc7b30c8aa9a3509$export$ef7acd7185315e22,
    parser: $dc7b30c8aa9a3509$export$8f49e4af10703ce3,
    median: (0, $kbUbx.median),
    simplify: $dc7b30c8aa9a3509$export$798b53621063651,
    rationalize: $dc7b30c8aa9a3509$export$725d762cc154d53,
    gasConstant: (0, $kbUbx.gasConstant),
    planckConstant: (0, $kbUbx.planckConstant),
    setUnion: (0, $kbUbx.setUnion),
    help: $dc7b30c8aa9a3509$export$34512e3b2db52a4e,
    derivative: $dc7b30c8aa9a3509$export$42645bbd8ddfc464,
    magneticFluxQuantum: (0, $kbUbx.magneticFluxQuantum),
    "eval": $dc7b30c8aa9a3509$export$fef61f332f2c0afc,
    coulomb: (0, $kbUbx.coulomb),
    mad: (0, $kbUbx.mad),
    rydberg: (0, $kbUbx.rydberg),
    config: (0, $89s6m.config)
});
$dc7b30c8aa9a3509$var$_extends($dc7b30c8aa9a3509$var$mathWithTransform, $dc7b30c8aa9a3509$var$math, {
    apply: (0, $ajZDX.createApplyTransform)({
        isInteger: (0, $kbUbx.isInteger),
        typed: (0, $kbUbx.typed)
    }),
    filter: (0, $gHcOy.createFilterTransform)({
        typed: (0, $kbUbx.typed)
    }),
    map: (0, $7xwSh.createMapTransform)({
        typed: (0, $kbUbx.typed)
    }),
    forEach: (0, $lvMNH.createForEachTransform)({
        typed: (0, $kbUbx.typed)
    }),
    max: (0, $1hNiT.createMaxTransform)({
        larger: (0, $kbUbx.larger),
        typed: (0, $kbUbx.typed)
    }),
    min: (0, $6UsSe.createMinTransform)({
        smaller: (0, $kbUbx.smaller),
        typed: (0, $kbUbx.typed)
    }),
    subset: (0, $fbyJR.createSubsetTransform)({
        matrix: (0, $kbUbx.matrix),
        typed: (0, $kbUbx.typed)
    }),
    concat: (0, $gC4ea.createConcatTransform)({
        isInteger: (0, $kbUbx.isInteger),
        matrix: (0, $kbUbx.matrix),
        typed: (0, $kbUbx.typed)
    }),
    range: (0, $lfJeA.createRangeTransform)({
        bignumber: (0, $kbUbx.bignumber),
        matrix: (0, $kbUbx.matrix),
        config: (0, $89s6m.config),
        larger: (0, $kbUbx.larger),
        largerEq: (0, $kbUbx.largerEq),
        smaller: (0, $kbUbx.smaller),
        smallerEq: (0, $kbUbx.smallerEq),
        typed: (0, $kbUbx.typed)
    }),
    sum: (0, $dYbzE.createSumTransform)({
        bignumber: (0, $kbUbx.bignumber),
        fraction: (0, $kbUbx.fraction),
        add: (0, $kbUbx.add),
        config: (0, $89s6m.config),
        typed: (0, $kbUbx.typed)
    }),
    index: (0, $iQKTE.createIndexTransform)({
        Index: (0, $kbUbx.Index)
    }),
    column: (0, $9Z8BS.createColumnTransform)({
        Index: (0, $kbUbx.Index),
        matrix: (0, $kbUbx.matrix),
        range: (0, $kbUbx.range),
        typed: (0, $kbUbx.typed)
    }),
    row: (0, $a4HxT.createRowTransform)({
        Index: (0, $kbUbx.Index),
        matrix: (0, $kbUbx.matrix),
        range: (0, $kbUbx.range),
        typed: (0, $kbUbx.typed)
    }),
    mean: (0, $lxQ6R.createMeanTransform)({
        add: (0, $kbUbx.add),
        divide: (0, $kbUbx.divide),
        typed: (0, $kbUbx.typed)
    }),
    variance: (0, $hL252.createVarianceTransform)({
        add: (0, $kbUbx.add),
        apply: (0, $kbUbx.apply),
        divide: (0, $kbUbx.divide),
        isNaN: (0, $kbUbx.isNaN),
        multiply: (0, $kbUbx.multiply),
        subtract: (0, $kbUbx.subtract),
        typed: (0, $kbUbx.typed)
    }),
    std: (0, $jJ20c.createStdTransform)({
        sqrt: (0, $kbUbx.sqrt),
        typed: (0, $kbUbx.typed),
        variance: (0, $kbUbx.variance)
    })
});
$dc7b30c8aa9a3509$var$_extends($dc7b30c8aa9a3509$var$classes, {
    ResultSet: (0, $kbUbx.ResultSet),
    Complex: (0, $kbUbx.Complex),
    Range: (0, $kbUbx.Range),
    Node: $dc7b30c8aa9a3509$export$85c928794f8d04d4,
    ArrayNode: $dc7b30c8aa9a3509$export$97d96bf9b84874d5,
    BlockNode: $dc7b30c8aa9a3509$export$ec7b1e3e36733ff3,
    ConstantNode: $dc7b30c8aa9a3509$export$3166e8715d58cf9a,
    ObjectNode: $dc7b30c8aa9a3509$export$b70fa93b5fbdd997,
    ParenthesisNode: $dc7b30c8aa9a3509$export$dbdb6279b6a3bac9,
    RelationalNode: $dc7b30c8aa9a3509$export$a4d9a8de1ded3461,
    Chain: $dc7b30c8aa9a3509$export$f18d5acc27d70423,
    BigNumber: (0, $kbUbx.BigNumber),
    Matrix: (0, $kbUbx.Matrix),
    ConditionalNode: $dc7b30c8aa9a3509$export$8e402c64e6081013,
    OperatorNode: $dc7b30c8aa9a3509$export$cd498840ad265e90,
    Fraction: (0, $kbUbx.Fraction),
    RangeNode: $dc7b30c8aa9a3509$export$d0e9917d83c120a0,
    DenseMatrix: (0, $kbUbx.DenseMatrix),
    FunctionAssignmentNode: $dc7b30c8aa9a3509$export$446a68c3fb943f17,
    SparseMatrix: (0, $kbUbx.SparseMatrix),
    ImmutableDenseMatrix: (0, $kbUbx.ImmutableDenseMatrix),
    FibonacciHeap: (0, $kbUbx.FibonacciHeap),
    AccessorNode: $dc7b30c8aa9a3509$export$c3248ebc7ade74c5,
    IndexNode: $dc7b30c8aa9a3509$export$929eaad981940a63,
    Spa: (0, $kbUbx.Spa),
    AssignmentNode: $dc7b30c8aa9a3509$export$a144098e31f7b52f,
    Index: (0, $kbUbx.Index),
    Unit: (0, $kbUbx.Unit),
    SymbolNode: $dc7b30c8aa9a3509$export$93b6424aaa42dda7,
    FunctionNode: $dc7b30c8aa9a3509$export$f2972be796679c12,
    Parser: $dc7b30c8aa9a3509$export$7acfa6ed01010e37,
    Help: $dc7b30c8aa9a3509$export$1be7516c0280bee8
});
$dc7b30c8aa9a3509$export$f18d5acc27d70423.createProxy($dc7b30c8aa9a3509$var$math);

});
parcelRegister("89s6m", function(module, exports) {

$parcel$export(module.exports, "config", function () { return $5ef4f6631b0222cc$export$e506a1d27d1eaa20; });

var $fZq3S = parcelRequire("fZq3S");

var $gRkMH = parcelRequire("gRkMH");
function $5ef4f6631b0222cc$var$_extends() {
    $5ef4f6631b0222cc$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5ef4f6631b0222cc$var$_extends.apply(this, arguments);
}
var $5ef4f6631b0222cc$export$e506a1d27d1eaa20 = /* #__PURE__ */ function config(options) {
    if (options) throw new Error("The global config is readonly. \nPlease create a mathjs instance if you want to change the default configuration. \nExample:\n\n  import { create, all } from 'mathjs';\n  const mathjs = create(all);\n  mathjs.config({ number: 'BigNumber' });\n");
    return Object.freeze((0, $fZq3S.DEFAULT_CONFIG));
};
$5ef4f6631b0222cc$var$_extends($5ef4f6631b0222cc$export$e506a1d27d1eaa20, (0, $fZq3S.DEFAULT_CONFIG), {
    MATRIX_OPTIONS: (0, $gRkMH.MATRIX_OPTIONS),
    NUMBER_OPTIONS: (0, $gRkMH.NUMBER_OPTIONS)
});

});
parcelRegister("fZq3S", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CONFIG", function () { return $ba40c4cd59939a80$export$c2f8e0cc249a8d8f; });
var $ba40c4cd59939a80$export$c2f8e0cc249a8d8f = {
    // minimum relative difference between two compared values,
    // used by all comparison functions
    epsilon: 1e-12,
    // type of default matrix output. Choose 'matrix' (default) or 'array'
    matrix: "Matrix",
    // type of default number output. Choose 'number' (default) 'BigNumber', or 'Fraction
    number: "number",
    // number of significant digits in BigNumbers
    precision: 64,
    // predictable output type of functions. When true, output type depends only
    // on the input types. When false (default), output type can vary depending
    // on input values. For example `math.sqrt(-4)` returns `complex('2i')` when
    // predictable is false, and returns `NaN` when true.
    predictable: false,
    // random seed for seeded pseudo random number generation
    // null = randomly seed
    randomSeed: null
};

});

parcelRegister("gRkMH", function(module, exports) {

$parcel$export(module.exports, "MATRIX_OPTIONS", function () { return $c461b7ed105ce648$export$517ab898194ae9af; });
$parcel$export(module.exports, "NUMBER_OPTIONS", function () { return $c461b7ed105ce648$export$f4b0a2084fdf2177; });

var $7ITGG = parcelRequire("7ITGG");

var $fZq3S = parcelRequire("fZq3S");
var $c461b7ed105ce648$export$517ab898194ae9af = [
    "Matrix",
    "Array"
]; // valid values for option matrix
var $c461b7ed105ce648$export$f4b0a2084fdf2177 = [
    "number",
    "BigNumber",
    "Fraction"
]; // valid values for option number
function $c461b7ed105ce648$export$3984aa6f7f77f1ae(config, emit) {
    /**
   * Set configuration options for math.js, and get current options.
   * Will emit a 'config' event, with arguments (curr, prev, changes).
   *
   * This function is only available on a mathjs instance created using `create`.
   *
   * Syntax:
   *
   *     math.config(config: Object): Object
   *
   * Examples:
   *
   *
   *     import { create, all } from 'mathjs'
   *
   *     // create a mathjs instance
   *     const math = create(all)
   *
   *     math.config().number                // outputs 'number'
   *     math.evaluate('0.4')                // outputs number 0.4
   *     math.config({number: 'Fraction'})
   *     math.evaluate('0.4')                // outputs Fraction 2/5
   *
   * @param {Object} [options] Available options:
   *                            {number} epsilon
   *                              Minimum relative difference between two
   *                              compared values, used by all comparison functions.
   *                            {string} matrix
   *                              A string 'Matrix' (default) or 'Array'.
   *                            {string} number
   *                              A string 'number' (default), 'BigNumber', or 'Fraction'
   *                            {number} precision
   *                              The number of significant digits for BigNumbers.
   *                              Not applicable for Numbers.
   *                            {string} parenthesis
   *                              How to display parentheses in LaTeX and string
   *                              output.
   *                            {string} randomSeed
   *                              Random seed for seeded pseudo random number generator.
   *                              Set to null to randomly seed.
   * @return {Object} Returns the current configuration
   */ function _config(options) {
        if (options) {
            var prev = (0, $7ITGG.mapObject)(config, (0, $7ITGG.clone)); // validate some of the options
            $c461b7ed105ce648$var$validateOption(options, "matrix", $c461b7ed105ce648$export$517ab898194ae9af);
            $c461b7ed105ce648$var$validateOption(options, "number", $c461b7ed105ce648$export$f4b0a2084fdf2177); // merge options
            (0, $7ITGG.deepExtend)(config, options);
            var curr = (0, $7ITGG.mapObject)(config, (0, $7ITGG.clone));
            var changes = (0, $7ITGG.mapObject)(options, (0, $7ITGG.clone)); // emit 'config' event
            emit("config", curr, prev, changes);
            return curr;
        } else return (0, $7ITGG.mapObject)(config, (0, $7ITGG.clone));
    } // attach the valid options to the function so they can be extended
    _config.MATRIX_OPTIONS = $c461b7ed105ce648$export$517ab898194ae9af;
    _config.NUMBER_OPTIONS = $c461b7ed105ce648$export$f4b0a2084fdf2177; // attach the config properties as readonly properties to the config function
    Object.keys((0, $fZq3S.DEFAULT_CONFIG)).forEach(function(key) {
        Object.defineProperty(_config, key, {
            get: function get() {
                return config[key];
            },
            enumerable: true,
            configurable: true
        });
    });
    return _config;
}
/**
 * Test whether an Array contains a specific item.
 * @param {Array.<string>} array
 * @param {string} item
 * @return {boolean}
 */ function $c461b7ed105ce648$var$contains(array, item) {
    return array.indexOf(item) !== -1;
}
/**
 * Find a string in an array. Case insensitive search
 * @param {Array.<string>} array
 * @param {string} item
 * @return {number} Returns the index when found. Returns -1 when not found
 */ function $c461b7ed105ce648$var$findIndex(array, item) {
    return array.map(function(i) {
        return i.toLowerCase();
    }).indexOf(item.toLowerCase());
}
/**
 * Validate an option
 * @param {Object} options         Object with options
 * @param {string} name            Name of the option to validate
 * @param {Array.<string>} values  Array with valid values for this option
 */ function $c461b7ed105ce648$var$validateOption(options, name, values) {
    if (options[name] !== undefined && !$c461b7ed105ce648$var$contains(values, options[name])) {
        var index = $c461b7ed105ce648$var$findIndex(values, options[name]);
        if (index !== -1) {
            // right value, wrong casing
            // TODO: lower case values are deprecated since v3, remove this warning some day.
            console.warn('Warning: Wrong casing for configuration option "' + name + '", should be "' + values[index] + '" instead of "' + options[name] + '".');
            options[name] = values[index]; // change the option to the right casing
        } else // unknown value
        console.warn('Warning: Unknown value "' + options[name] + '" for configuration option "' + name + '". Available options: ' + values.map(JSON.stringify).join(", ") + ".");
    }
}

});
parcelRegister("7ITGG", function(module, exports) {

$parcel$export(module.exports, "clone", function () { return $59f7d6cfe950316a$export$9cd59f9826255e47; });
$parcel$export(module.exports, "mapObject", function () { return $59f7d6cfe950316a$export$d6051a0f7a227332; });
$parcel$export(module.exports, "hasOwnProperty", function () { return $59f7d6cfe950316a$export$5a15a386532a5ea4; });
$parcel$export(module.exports, "extend", function () { return $59f7d6cfe950316a$export$8b58be045bf06082; });
$parcel$export(module.exports, "deepExtend", function () { return $59f7d6cfe950316a$export$54e9fb29908872fa; });
$parcel$export(module.exports, "deepStrictEqual", function () { return $59f7d6cfe950316a$export$6cc798251952180; });
$parcel$export(module.exports, "lazy", function () { return $59f7d6cfe950316a$export$488013bae63b21da; });
$parcel$export(module.exports, "pickShallow", function () { return $59f7d6cfe950316a$export$8cea971c64639ea7; });

var $1amHZ = parcelRequire("1amHZ");
function $59f7d6cfe950316a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $59f7d6cfe950316a$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $59f7d6cfe950316a$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $59f7d6cfe950316a$var$_typeof(obj);
}
function $59f7d6cfe950316a$export$9cd59f9826255e47(x) {
    var type = $59f7d6cfe950316a$var$_typeof(x); // immutable primitive types
    if (type === "number" || type === "string" || type === "boolean" || x === null || x === undefined) return x;
     // use clone function of the object when available
    if (typeof x.clone === "function") return x.clone();
     // array
    if (Array.isArray(x)) return x.map(function(value) {
        return $59f7d6cfe950316a$export$9cd59f9826255e47(value);
    });
    if (x instanceof Date) return new Date(x.valueOf());
    if ((0, $1amHZ.isBigNumber)(x)) return x; // bignumbers are immutable
    if (x instanceof RegExp) throw new TypeError("Cannot clone " + x); // TODO: clone a RegExp
    // object
    return $59f7d6cfe950316a$export$d6051a0f7a227332(x, $59f7d6cfe950316a$export$9cd59f9826255e47);
}
function $59f7d6cfe950316a$export$d6051a0f7a227332(object, callback) {
    var clone = {};
    for(var key in object)if ($59f7d6cfe950316a$export$5a15a386532a5ea4(object, key)) clone[key] = callback(object[key]);
    return clone;
}
function $59f7d6cfe950316a$export$8b58be045bf06082(a, b) {
    for(var prop in b)if ($59f7d6cfe950316a$export$5a15a386532a5ea4(b, prop)) a[prop] = b[prop];
    return a;
}
function $59f7d6cfe950316a$export$54e9fb29908872fa(a, b) {
    // TODO: add support for Arrays to deepExtend
    if (Array.isArray(b)) throw new TypeError("Arrays are not supported by deepExtend");
    for(var prop in b)if ($59f7d6cfe950316a$export$5a15a386532a5ea4(b, prop)) {
        if (b[prop] && b[prop].constructor === Object) {
            if (a[prop] === undefined) a[prop] = {};
            if (a[prop] && a[prop].constructor === Object) $59f7d6cfe950316a$export$54e9fb29908872fa(a[prop], b[prop]);
            else a[prop] = b[prop];
        } else if (Array.isArray(b[prop])) throw new TypeError("Arrays are not supported by deepExtend");
        else a[prop] = b[prop];
    }
    return a;
}
function $59f7d6cfe950316a$export$6cc798251952180(a, b) {
    var prop, i, len;
    if (Array.isArray(a)) {
        if (!Array.isArray(b)) return false;
        if (a.length !== b.length) return false;
        for(i = 0, len = a.length; i < len; i++){
            if (!$59f7d6cfe950316a$export$6cc798251952180(a[i], b[i])) return false;
        }
        return true;
    } else if (typeof a === "function") return a === b;
    else if (a instanceof Object) {
        if (Array.isArray(b) || !(b instanceof Object)) return false;
        for(prop in a){
            // noinspection JSUnfilteredForInLoop
            if (!(prop in b) || !$59f7d6cfe950316a$export$6cc798251952180(a[prop], b[prop])) return false;
        }
        for(prop in b){
            // noinspection JSUnfilteredForInLoop
            if (!(prop in a) || !$59f7d6cfe950316a$export$6cc798251952180(a[prop], b[prop])) return false;
        }
        return true;
    } else return a === b;
}
function $59f7d6cfe950316a$export$519b2d75cc54d03b(nestedObject) {
    var flattenedObject = {};
    $59f7d6cfe950316a$var$_deepFlatten(nestedObject, flattenedObject);
    return flattenedObject;
} // helper function used by deepFlatten
function $59f7d6cfe950316a$var$_deepFlatten(nestedObject, flattenedObject) {
    for(var prop in nestedObject)if ($59f7d6cfe950316a$export$5a15a386532a5ea4(nestedObject, prop)) {
        var value = nestedObject[prop];
        if ($59f7d6cfe950316a$var$_typeof(value) === "object" && value !== null) $59f7d6cfe950316a$var$_deepFlatten(value, flattenedObject);
        else flattenedObject[prop] = value;
    }
}
function $59f7d6cfe950316a$export$a73e197d57374bd3() {
    // test needed for broken IE8 implementation
    try {
        if (Object.defineProperty) {
            Object.defineProperty({}, "x", {
                get: function get() {}
            });
            return true;
        }
    } catch (e) {}
    return false;
}
function $59f7d6cfe950316a$export$488013bae63b21da(object, prop, valueResolver) {
    var _uninitialized = true;
    var _value;
    Object.defineProperty(object, prop, {
        get: function get() {
            if (_uninitialized) {
                _value = valueResolver();
                _uninitialized = false;
            }
            return _value;
        },
        set: function set(value) {
            _value = value;
            _uninitialized = false;
        },
        configurable: true,
        enumerable: true
    });
}
function $59f7d6cfe950316a$export$df3f009e3d155b20(object, path) {
    if (path && typeof path === "string") return $59f7d6cfe950316a$export$df3f009e3d155b20(object, path.split("."));
    var obj = object;
    if (path) for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (!(key in obj)) obj[key] = {};
        obj = obj[key];
    }
    return obj;
}
function $59f7d6cfe950316a$export$5a15a386532a5ea4(object, property) {
    return object && Object.hasOwnProperty.call(object, property);
}
function $59f7d6cfe950316a$export$1bc2c269dfa97885(object) {
    return object && typeof object.factory === "function";
}
function $59f7d6cfe950316a$export$3988ae62b71be9a3(object, path) {
    if (typeof path === "string") {
        if ($59f7d6cfe950316a$var$isPath(path)) return $59f7d6cfe950316a$export$3988ae62b71be9a3(object, path.split("."));
        else return object[path];
    }
    var child = object;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        child = child ? child[key] : undefined;
    }
    return child;
}
function $59f7d6cfe950316a$export$adaa4cf7ef1b65be(object, path, value) {
    if (typeof path === "string") {
        if ($59f7d6cfe950316a$var$isPath(path)) return $59f7d6cfe950316a$export$adaa4cf7ef1b65be(object, path.split("."), value);
        else {
            object[path] = value;
            return object;
        }
    }
    var child = object;
    for(var i = 0; i < path.length - 1; i++){
        var key = path[i];
        if (child[key] === undefined) child[key] = {};
        child = child[key];
    }
    if (path.length > 0) {
        var lastKey = path[path.length - 1];
        child[lastKey] = value;
    }
    return object;
}
function $59f7d6cfe950316a$export$357523c63a2253b9(object, properties, transform) {
    var copy = {};
    for(var i = 0; i < properties.length; i++){
        var key = properties[i];
        var value = $59f7d6cfe950316a$export$3988ae62b71be9a3(object, key);
        if (value !== undefined) $59f7d6cfe950316a$export$adaa4cf7ef1b65be(copy, key, transform ? transform(value, key) : value);
    }
    return copy;
}
function $59f7d6cfe950316a$export$8cea971c64639ea7(object, properties) {
    var copy = {};
    for(var i = 0; i < properties.length; i++){
        var key = properties[i];
        var value = object[key];
        if (value !== undefined) copy[key] = value;
    }
    return copy;
}
function $59f7d6cfe950316a$export$68c286be0e7e55b7(object) {
    return Object.keys(object).map(function(key) {
        return object[key];
    });
} // helper function to test whether a string contains a path like 'user.name'
function $59f7d6cfe950316a$var$isPath(str) {
    return str.indexOf(".") !== -1;
}

});
parcelRegister("1amHZ", function(module, exports) {

$parcel$export(module.exports, "isNumber", function () { return $0d98570b3577b810$export$7e4aa119212bc614; });
$parcel$export(module.exports, "isBigNumber", function () { return $0d98570b3577b810$export$e51d0e7e5c4a03ab; });
$parcel$export(module.exports, "isComplex", function () { return $0d98570b3577b810$export$8849a896711efe0c; });
$parcel$export(module.exports, "isFraction", function () { return $0d98570b3577b810$export$e312cb8a8e5e7c34; });
$parcel$export(module.exports, "isUnit", function () { return $0d98570b3577b810$export$8960dc335987b8da; });
$parcel$export(module.exports, "isString", function () { return $0d98570b3577b810$export$844ec244b1367d54; });
$parcel$export(module.exports, "isArray", function () { return $0d98570b3577b810$export$43bee75e5e14138e; });
$parcel$export(module.exports, "isMatrix", function () { return $0d98570b3577b810$export$b22160e0a14f87b7; });
$parcel$export(module.exports, "isCollection", function () { return $0d98570b3577b810$export$cea7aa84e978eba5; });
$parcel$export(module.exports, "isDenseMatrix", function () { return $0d98570b3577b810$export$eb44495df7ba11d; });
$parcel$export(module.exports, "isSparseMatrix", function () { return $0d98570b3577b810$export$d508368d4da3c38a; });
$parcel$export(module.exports, "isRange", function () { return $0d98570b3577b810$export$e331ccfa6f694c99; });
$parcel$export(module.exports, "isIndex", function () { return $0d98570b3577b810$export$ba3dc792055c2f45; });
$parcel$export(module.exports, "isBoolean", function () { return $0d98570b3577b810$export$f9ce7b637dfbe238; });
$parcel$export(module.exports, "isResultSet", function () { return $0d98570b3577b810$export$381a1a20e6a63376; });
$parcel$export(module.exports, "isHelp", function () { return $0d98570b3577b810$export$e5dec9a75b602d6c; });
$parcel$export(module.exports, "isFunction", function () { return $0d98570b3577b810$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "isDate", function () { return $0d98570b3577b810$export$871608497c498473; });
$parcel$export(module.exports, "isRegExp", function () { return $0d98570b3577b810$export$49841c62b9eff15; });
$parcel$export(module.exports, "isObject", function () { return $0d98570b3577b810$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "isNull", function () { return $0d98570b3577b810$export$630801d484da15df; });
$parcel$export(module.exports, "isUndefined", function () { return $0d98570b3577b810$export$fce6876652108ab; });
$parcel$export(module.exports, "isAccessorNode", function () { return $0d98570b3577b810$export$f88fb19d6b9ee5cb; });
$parcel$export(module.exports, "isArrayNode", function () { return $0d98570b3577b810$export$440fa93dcf2757a3; });
$parcel$export(module.exports, "isAssignmentNode", function () { return $0d98570b3577b810$export$64d7d515ec030d5e; });
$parcel$export(module.exports, "isBlockNode", function () { return $0d98570b3577b810$export$1665e2275a3d717a; });
$parcel$export(module.exports, "isConditionalNode", function () { return $0d98570b3577b810$export$e1babefe78c70737; });
$parcel$export(module.exports, "isConstantNode", function () { return $0d98570b3577b810$export$fa9d80731fd8c54b; });
$parcel$export(module.exports, "isFunctionAssignmentNode", function () { return $0d98570b3577b810$export$27c05cfffd263d30; });
$parcel$export(module.exports, "isFunctionNode", function () { return $0d98570b3577b810$export$6ae03b16e064e6c4; });
$parcel$export(module.exports, "isIndexNode", function () { return $0d98570b3577b810$export$ff90979121a6cabc; });
$parcel$export(module.exports, "isNode", function () { return $0d98570b3577b810$export$8ee0fc9ee280b4ee; });
$parcel$export(module.exports, "isObjectNode", function () { return $0d98570b3577b810$export$3f18867a334658e9; });
$parcel$export(module.exports, "isOperatorNode", function () { return $0d98570b3577b810$export$7e624cbaab6cce94; });
$parcel$export(module.exports, "isParenthesisNode", function () { return $0d98570b3577b810$export$c55e3736c5721220; });
$parcel$export(module.exports, "isRangeNode", function () { return $0d98570b3577b810$export$92729c5c4ff6fc83; });
$parcel$export(module.exports, "isSymbolNode", function () { return $0d98570b3577b810$export$87815d550facaed9; });
$parcel$export(module.exports, "isChain", function () { return $0d98570b3577b810$export$dc36953d0b3a4f05; });
$parcel$export(module.exports, "typeOf", function () { return $0d98570b3577b810$export$f5bbd400c2f4426f; });
function $0d98570b3577b810$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $0d98570b3577b810$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $0d98570b3577b810$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $0d98570b3577b810$var$_typeof(obj);
}
function $0d98570b3577b810$export$7e4aa119212bc614(x) {
    return typeof x === "number";
}
function $0d98570b3577b810$export$e51d0e7e5c4a03ab(x) {
    return x && x.constructor.prototype.isBigNumber === true || false;
}
function $0d98570b3577b810$export$8849a896711efe0c(x) {
    return x && $0d98570b3577b810$var$_typeof(x) === "object" && Object.getPrototypeOf(x).isComplex === true || false;
}
function $0d98570b3577b810$export$e312cb8a8e5e7c34(x) {
    return x && $0d98570b3577b810$var$_typeof(x) === "object" && Object.getPrototypeOf(x).isFraction === true || false;
}
function $0d98570b3577b810$export$8960dc335987b8da(x) {
    return x && x.constructor.prototype.isUnit === true || false;
}
function $0d98570b3577b810$export$844ec244b1367d54(x) {
    return typeof x === "string";
}
var $0d98570b3577b810$export$43bee75e5e14138e = Array.isArray;
function $0d98570b3577b810$export$b22160e0a14f87b7(x) {
    return x && x.constructor.prototype.isMatrix === true || false;
}
function $0d98570b3577b810$export$cea7aa84e978eba5(x) {
    return Array.isArray(x) || $0d98570b3577b810$export$b22160e0a14f87b7(x);
}
function $0d98570b3577b810$export$eb44495df7ba11d(x) {
    return x && x.isDenseMatrix && x.constructor.prototype.isMatrix === true || false;
}
function $0d98570b3577b810$export$d508368d4da3c38a(x) {
    return x && x.isSparseMatrix && x.constructor.prototype.isMatrix === true || false;
}
function $0d98570b3577b810$export$e331ccfa6f694c99(x) {
    return x && x.constructor.prototype.isRange === true || false;
}
function $0d98570b3577b810$export$ba3dc792055c2f45(x) {
    return x && x.constructor.prototype.isIndex === true || false;
}
function $0d98570b3577b810$export$f9ce7b637dfbe238(x) {
    return typeof x === "boolean";
}
function $0d98570b3577b810$export$381a1a20e6a63376(x) {
    return x && x.constructor.prototype.isResultSet === true || false;
}
function $0d98570b3577b810$export$e5dec9a75b602d6c(x) {
    return x && x.constructor.prototype.isHelp === true || false;
}
function $0d98570b3577b810$export$f6e2535fb5126e54(x) {
    return typeof x === "function";
}
function $0d98570b3577b810$export$871608497c498473(x) {
    return x instanceof Date;
}
function $0d98570b3577b810$export$49841c62b9eff15(x) {
    return x instanceof RegExp;
}
function $0d98570b3577b810$export$a6cdc56e425d0d0a(x) {
    return !!(x && $0d98570b3577b810$var$_typeof(x) === "object" && x.constructor === Object && !$0d98570b3577b810$export$8849a896711efe0c(x) && !$0d98570b3577b810$export$e312cb8a8e5e7c34(x));
}
function $0d98570b3577b810$export$630801d484da15df(x) {
    return x === null;
}
function $0d98570b3577b810$export$fce6876652108ab(x) {
    return x === undefined;
}
function $0d98570b3577b810$export$f88fb19d6b9ee5cb(x) {
    return x && x.isAccessorNode === true && x.constructor.prototype.isNode === true || false;
}
function $0d98570b3577b810$export$440fa93dcf2757a3(x) {
    return x && x.isArrayNode === true && x.constructor.prototype.isNode === true || false;
}
function $0d98570b3577b810$export$64d7d515ec030d5e(x) {
    return x && x.isAssignmentNode === true && x.constructor.prototype.isNode === true || false;
}
function $0d98570b3577b810$export$1665e2275a3d717a(x) {
    return x && x.isBlockNode === true && x.constructor.prototype.isNode === true || false;
}
function $0d98570b3577b810$export$e1babefe78c70737(x) {
    return x && x.isConditionalNode === true && x.constructor.prototype.isNode === true || false;
}
function $0d98570b3577b810$export$fa9d80731fd8c54b(x) {
    return x && x.isConstantNode === true && x.constructor.prototype.isNode === true || false;
}
function $0d98570b3577b810$export$27c05cfffd263d30(x) {
    return x && x.isFunctionAssignmentNode === true && x.constructor.prototype.isNode === true || false;
}
function $0d98570b3577b810$export$6ae03b16e064e6c4(x) {
    return x && x.isFunctionNode === true && x.constructor.prototype.isNode === true || false;
}
function $0d98570b3577b810$export$ff90979121a6cabc(x) {
    return x && x.isIndexNode === true && x.constructor.prototype.isNode === true || false;
}
function $0d98570b3577b810$export$8ee0fc9ee280b4ee(x) {
    return x && x.isNode === true && x.constructor.prototype.isNode === true || false;
}
function $0d98570b3577b810$export$3f18867a334658e9(x) {
    return x && x.isObjectNode === true && x.constructor.prototype.isNode === true || false;
}
function $0d98570b3577b810$export$7e624cbaab6cce94(x) {
    return x && x.isOperatorNode === true && x.constructor.prototype.isNode === true || false;
}
function $0d98570b3577b810$export$c55e3736c5721220(x) {
    return x && x.isParenthesisNode === true && x.constructor.prototype.isNode === true || false;
}
function $0d98570b3577b810$export$92729c5c4ff6fc83(x) {
    return x && x.isRangeNode === true && x.constructor.prototype.isNode === true || false;
}
function $0d98570b3577b810$export$87815d550facaed9(x) {
    return x && x.isSymbolNode === true && x.constructor.prototype.isNode === true || false;
}
function $0d98570b3577b810$export$dc36953d0b3a4f05(x) {
    return x && x.constructor.prototype.isChain === true || false;
}
function $0d98570b3577b810$export$f5bbd400c2f4426f(x) {
    var t = $0d98570b3577b810$var$_typeof(x);
    if (t === "object") {
        // JavaScript types
        if (x === null) return "null";
        if (Array.isArray(x)) return "Array";
        if (x instanceof Date) return "Date";
        if (x instanceof RegExp) return "RegExp"; // math.js types
        if ($0d98570b3577b810$export$e51d0e7e5c4a03ab(x)) return "BigNumber";
        if ($0d98570b3577b810$export$8849a896711efe0c(x)) return "Complex";
        if ($0d98570b3577b810$export$e312cb8a8e5e7c34(x)) return "Fraction";
        if ($0d98570b3577b810$export$b22160e0a14f87b7(x)) return "Matrix";
        if ($0d98570b3577b810$export$8960dc335987b8da(x)) return "Unit";
        if ($0d98570b3577b810$export$ba3dc792055c2f45(x)) return "Index";
        if ($0d98570b3577b810$export$e331ccfa6f694c99(x)) return "Range";
        if ($0d98570b3577b810$export$381a1a20e6a63376(x)) return "ResultSet";
        if ($0d98570b3577b810$export$8ee0fc9ee280b4ee(x)) return x.type;
        if ($0d98570b3577b810$export$dc36953d0b3a4f05(x)) return "Chain";
        if ($0d98570b3577b810$export$e5dec9a75b602d6c(x)) return "Help";
        return "Object";
    }
    if (t === "function") return "Function";
    return t; // can be 'string', 'number', 'boolean', ...
}

});




parcelRegister("asmGj", function(module, exports) {

$parcel$export(module.exports, "createAccessorNode", function () { return $79ce1cf9bb29187b$export$a21116b1766eb74; });

var $1amHZ = parcelRequire("1amHZ");

var $45IYD = parcelRequire("45IYD");

var $2mPYl = parcelRequire("2mPYl");

var $9edVT = parcelRequire("9edVT");
var $79ce1cf9bb29187b$var$name = "AccessorNode";
var $79ce1cf9bb29187b$var$dependencies = [
    "subset",
    "Node"
];
var $79ce1cf9bb29187b$export$a21116b1766eb74 = /* #__PURE__ */ (0, $2mPYl.factory)($79ce1cf9bb29187b$var$name, $79ce1cf9bb29187b$var$dependencies, function(_ref) {
    var subset = _ref.subset, Node = _ref.Node;
    var access = (0, $9edVT.accessFactory)({
        subset: subset
    });
    /**
   * @constructor AccessorNode
   * @extends {Node}
   * Access an object property or get a matrix subset
   *
   * @param {Node} object                 The object from which to retrieve
   *                                      a property or subset.
   * @param {IndexNode} index             IndexNode containing ranges
   */ function AccessorNode(object, index) {
        if (!(this instanceof AccessorNode)) throw new SyntaxError("Constructor must be called with the new operator");
        if (!(0, $1amHZ.isNode)(object)) throw new TypeError('Node expected for parameter "object"');
        if (!(0, $1amHZ.isIndexNode)(index)) throw new TypeError('IndexNode expected for parameter "index"');
        this.object = object || null;
        this.index = index; // readonly property name
        Object.defineProperty(this, "name", {
            get: (function() {
                if (this.index) return this.index.isObjectProperty() ? this.index.getObjectProperty() : "";
                else return this.object.name || "";
            }).bind(this),
            set: function set() {
                throw new Error("Cannot assign a new name, name is read-only");
            }
        });
    }
    AccessorNode.prototype = new Node();
    AccessorNode.prototype.type = "AccessorNode";
    AccessorNode.prototype.isAccessorNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ AccessorNode.prototype._compile = function(math, argNames) {
        var evalObject = this.object._compile(math, argNames);
        var evalIndex = this.index._compile(math, argNames);
        if (this.index.isObjectProperty()) {
            var prop = this.index.getObjectProperty();
            return function evalAccessorNode(scope, args, context) {
                return (0, $45IYD.getSafeProperty)(evalObject(scope, args, context), prop);
            };
        } else return function evalAccessorNode(scope, args, context) {
            var object = evalObject(scope, args, context);
            var index = evalIndex(scope, args, object); // we pass object here instead of context
            return access(object, index);
        };
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ AccessorNode.prototype.forEach = function(callback) {
        callback(this.object, "object", this);
        callback(this.index, "index", this);
    };
    /**
   * Create a new AccessorNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node): Node} callback
   * @returns {AccessorNode} Returns a transformed copy of the node
   */ AccessorNode.prototype.map = function(callback) {
        return new AccessorNode(this._ifNode(callback(this.object, "object", this)), this._ifNode(callback(this.index, "index", this)));
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {AccessorNode}
   */ AccessorNode.prototype.clone = function() {
        return new AccessorNode(this.object, this.index);
    };
    /**
   * Get string representation
   * @param {Object} options
   * @return {string}
   */ AccessorNode.prototype._toString = function(options) {
        var object = this.object.toString(options);
        if (needParenthesis(this.object)) object = "(" + object + ")";
        return object + this.index.toString(options);
    };
    /**
   * Get HTML representation
   * @param {Object} options
   * @return {string}
   */ AccessorNode.prototype.toHTML = function(options) {
        var object = this.object.toHTML(options);
        if (needParenthesis(this.object)) object = '<span class="math-parenthesis math-round-parenthesis">(</span>' + object + '<span class="math-parenthesis math-round-parenthesis">)</span>';
        return object + this.index.toHTML(options);
    };
    /**
   * Get LaTeX representation
   * @param {Object} options
   * @return {string}
   */ AccessorNode.prototype._toTex = function(options) {
        var object = this.object.toTex(options);
        if (needParenthesis(this.object)) object = "\\left(' + object + '\\right)";
        return object + this.index.toTex(options);
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ AccessorNode.prototype.toJSON = function() {
        return {
            mathjs: "AccessorNode",
            object: this.object,
            index: this.index
        };
    };
    /**
   * Instantiate an AccessorNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "AccessorNode", object: ..., index: ...}`,
   *                       where mathjs is optional
   * @returns {AccessorNode}
   */ AccessorNode.fromJSON = function(json) {
        return new AccessorNode(json.object, json.index);
    };
    /**
   * Are parenthesis needed?
   * @private
   */ function needParenthesis(node) {
        // TODO: maybe make a method on the nodes which tells whether they need parenthesis?
        return !((0, $1amHZ.isAccessorNode)(node) || (0, $1amHZ.isArrayNode)(node) || (0, $1amHZ.isConstantNode)(node) || (0, $1amHZ.isFunctionNode)(node) || (0, $1amHZ.isObjectNode)(node) || (0, $1amHZ.isParenthesisNode)(node) || (0, $1amHZ.isSymbolNode)(node));
    }
    return AccessorNode;
}, {
    isClass: true,
    isNode: true
});

});
parcelRegister("45IYD", function(module, exports) {

$parcel$export(module.exports, "getSafeProperty", function () { return $2faa848ac8d86db4$export$87a87648a1961976; });
$parcel$export(module.exports, "isSafeProperty", function () { return $2faa848ac8d86db4$export$3039c640f3cfc12a; });
$parcel$export(module.exports, "isSafeMethod", function () { return $2faa848ac8d86db4$export$2220a91638ab1d9e; });
$parcel$export(module.exports, "setSafeProperty", function () { return $2faa848ac8d86db4$export$e99fe8700ee9f9cd; });
$parcel$export(module.exports, "validateSafeMethod", function () { return $2faa848ac8d86db4$export$7cfb146d96805fec; });

var $7ITGG = parcelRequire("7ITGG");
function $2faa848ac8d86db4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $2faa848ac8d86db4$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $2faa848ac8d86db4$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $2faa848ac8d86db4$var$_typeof(obj);
}
/**
 * Get a property of a plain object
 * Throws an error in case the object is not a plain object or the
 * property is not defined on the object itself
 * @param {Object} object
 * @param {string} prop
 * @return {*} Returns the property value when safe
 */ function $2faa848ac8d86db4$export$87a87648a1961976(object, prop) {
    // only allow getting safe properties of a plain object
    if ($2faa848ac8d86db4$export$53b83ca8eaab0383(object) && $2faa848ac8d86db4$export$3039c640f3cfc12a(object, prop)) return object[prop];
    if (typeof object[prop] === "function" && $2faa848ac8d86db4$export$2220a91638ab1d9e(object, prop)) throw new Error('Cannot access method "' + prop + '" as a property');
    throw new Error('No access to property "' + prop + '"');
}
/**
 * Set a property on a plain object.
 * Throws an error in case the object is not a plain object or the
 * property would override an inherited property like .constructor or .toString
 * @param {Object} object
 * @param {string} prop
 * @param {*} value
 * @return {*} Returns the value
 */ // TODO: merge this function into access.js?
function $2faa848ac8d86db4$export$e99fe8700ee9f9cd(object, prop, value) {
    // only allow setting safe properties of a plain object
    if ($2faa848ac8d86db4$export$53b83ca8eaab0383(object) && $2faa848ac8d86db4$export$3039c640f3cfc12a(object, prop)) {
        object[prop] = value;
        return value;
    }
    throw new Error('No access to property "' + prop + '"');
}
/**
 * Test whether a property is safe to use for an object.
 * For example .toString and .constructor are not safe
 * @param {string} prop
 * @return {boolean} Returns true when safe
 */ function $2faa848ac8d86db4$export$3039c640f3cfc12a(object, prop) {
    if (!object || $2faa848ac8d86db4$var$_typeof(object) !== "object") return false;
     // SAFE: whitelisted
    // e.g length
    if ((0, $7ITGG.hasOwnProperty)($2faa848ac8d86db4$var$safeNativeProperties, prop)) return true;
     // UNSAFE: inherited from Object prototype
    // e.g constructor
    if (prop in Object.prototype) // 'in' is used instead of hasOwnProperty for nodejs v0.10
    // which is inconsistent on root prototypes. It is safe
    // here because Object.prototype is a root object
    return false;
     // UNSAFE: inherited from Function prototype
    // e.g call, apply
    if (prop in Function.prototype) // 'in' is used instead of hasOwnProperty for nodejs v0.10
    // which is inconsistent on root prototypes. It is safe
    // here because Function.prototype is a root object
    return false;
    return true;
}
/**
 * Validate whether a method is safe.
 * Throws an error when that's not the case.
 * @param {Object} object
 * @param {string} method
 */ // TODO: merge this function into assign.js?
function $2faa848ac8d86db4$export$7cfb146d96805fec(object, method) {
    if (!$2faa848ac8d86db4$export$2220a91638ab1d9e(object, method)) throw new Error('No access to method "' + method + '"');
}
/**
 * Check whether a method is safe.
 * Throws an error when that's not the case (for example for `constructor`).
 * @param {Object} object
 * @param {string} method
 * @return {boolean} Returns true when safe, false otherwise
 */ function $2faa848ac8d86db4$export$2220a91638ab1d9e(object, method) {
    if (object === null || object === undefined || typeof object[method] !== "function") return false;
     // UNSAFE: ghosted
    // e.g overridden toString
    // Note that IE10 doesn't support __proto__ and we can't do this check there.
    if ((0, $7ITGG.hasOwnProperty)(object, method) && Object.getPrototypeOf && method in Object.getPrototypeOf(object)) return false;
     // SAFE: whitelisted
    // e.g toString
    if ((0, $7ITGG.hasOwnProperty)($2faa848ac8d86db4$var$safeNativeMethods, method)) return true;
     // UNSAFE: inherited from Object prototype
    // e.g constructor
    if (method in Object.prototype) // 'in' is used instead of hasOwnProperty for nodejs v0.10
    // which is inconsistent on root prototypes. It is safe
    // here because Object.prototype is a root object
    return false;
     // UNSAFE: inherited from Function prototype
    // e.g call, apply
    if (method in Function.prototype) // 'in' is used instead of hasOwnProperty for nodejs v0.10
    // which is inconsistent on root prototypes. It is safe
    // here because Function.prototype is a root object
    return false;
    return true;
}
function $2faa848ac8d86db4$export$53b83ca8eaab0383(object) {
    return $2faa848ac8d86db4$var$_typeof(object) === "object" && object && object.constructor === Object;
}
var $2faa848ac8d86db4$var$safeNativeProperties = {
    length: true,
    name: true
};
var $2faa848ac8d86db4$var$safeNativeMethods = {
    toString: true,
    valueOf: true,
    toLocaleString: true
};

});

parcelRegister("2mPYl", function(module, exports) {

$parcel$export(module.exports, "factory", function () { return $1b95f37b727dca38$export$e9008f2713103c6c; });

var $5WdrK = parcelRequire("5WdrK");

var $7ITGG = parcelRequire("7ITGG");
function $1b95f37b727dca38$export$e9008f2713103c6c(name, dependencies, create, meta) {
    function assertAndCreate(scope) {
        // we only pass the requested dependencies to the factory function
        // to prevent functions to rely on dependencies that are not explicitly
        // requested.
        var deps = (0, $7ITGG.pickShallow)(scope, dependencies.map($1b95f37b727dca38$export$2f4d32a1468e229c));
        $1b95f37b727dca38$export$19a2c26dad95d6e7(name, dependencies, scope);
        return create(deps);
    }
    assertAndCreate.isFactory = true;
    assertAndCreate.fn = name;
    assertAndCreate.dependencies = dependencies.slice().sort();
    if (meta) assertAndCreate.meta = meta;
    return assertAndCreate;
}
function $1b95f37b727dca38$export$883f1d394ed355c(factories) {
    var factoriesByName = {};
    factories.forEach(function(factory) {
        factoriesByName[factory.fn] = factory;
    });
    function containsDependency(factory, dependency) {
        // TODO: detect circular references
        if ($1b95f37b727dca38$export$34763cfbed1075c2(factory)) {
            if ((0, $5WdrK.contains)(factory.dependencies, dependency.fn || dependency.name)) return true;
            if (factory.dependencies.some(function(d) {
                return containsDependency(factoriesByName[d], dependency);
            })) return true;
        }
        return false;
    }
    var sorted = [];
    function addFactory(factory) {
        var index = 0;
        while(index < sorted.length && !containsDependency(sorted[index], factory))index++;
        sorted.splice(index, 0, factory);
    } // sort regular factory functions
    factories.filter($1b95f37b727dca38$export$34763cfbed1075c2).forEach(addFactory); // sort legacy factory functions AFTER the regular factory functions
    factories.filter(function(factory) {
        return !$1b95f37b727dca38$export$34763cfbed1075c2(factory);
    }).forEach(addFactory);
    return sorted;
} // TODO: comment or cleanup if unused in the end
function $1b95f37b727dca38$export$185802fd694ee1f5(factories) {
    var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    $1b95f37b727dca38$export$883f1d394ed355c(factories).forEach(function(factory) {
        return factory(scope);
    });
    return scope;
}
function $1b95f37b727dca38$export$34763cfbed1075c2(obj) {
    return typeof obj === "function" && typeof obj.fn === "string" && Array.isArray(obj.dependencies);
}
function $1b95f37b727dca38$export$19a2c26dad95d6e7(name, dependencies, scope) {
    var allDefined = dependencies.filter(function(dependency) {
        return !$1b95f37b727dca38$export$1399ac7f45b04b5(dependency);
    }) // filter optionals
    .every(function(dependency) {
        return scope[dependency] !== undefined;
    });
    if (!allDefined) {
        var missingDependencies = dependencies.filter(function(dependency) {
            return scope[dependency] === undefined;
        }); // TODO: create a custom error class for this, a MathjsError or something like that
        throw new Error('Cannot create function "'.concat(name, '", ') + "some dependencies are missing: ".concat(missingDependencies.map(function(d) {
            return '"'.concat(d, '"');
        }).join(", "), "."));
    }
}
function $1b95f37b727dca38$export$1399ac7f45b04b5(dependency) {
    return dependency && dependency[0] === "?";
}
function $1b95f37b727dca38$export$2f4d32a1468e229c(dependency) {
    return dependency && dependency[0] === "?" ? dependency.slice(1) : dependency;
}

});
parcelRegister("5WdrK", function(module, exports) {

$parcel$export(module.exports, "arraySize", function () { return $452cccc11a69c5c0$export$51ffaee4afb683a5; });
$parcel$export(module.exports, "validate", function () { return $452cccc11a69c5c0$export$a22775fa5e2eebd9; });
$parcel$export(module.exports, "validateIndex", function () { return $452cccc11a69c5c0$export$3cfe3fbfec03f260; });
$parcel$export(module.exports, "resize", function () { return $452cccc11a69c5c0$export$4380c87abf28fdf; });
$parcel$export(module.exports, "reshape", function () { return $452cccc11a69c5c0$export$9eaad88cf88cee2b; });
$parcel$export(module.exports, "flatten", function () { return $452cccc11a69c5c0$export$bffa455ba8c619a6; });
$parcel$export(module.exports, "squeeze", function () { return $452cccc11a69c5c0$export$889c931173b77c2f; });
$parcel$export(module.exports, "unsqueeze", function () { return $452cccc11a69c5c0$export$5a07c5202d40a604; });
$parcel$export(module.exports, "map", function () { return $452cccc11a69c5c0$export$871de8747c9eaa88; });
$parcel$export(module.exports, "forEach", function () { return $452cccc11a69c5c0$export$4b80e395e36b5a56; });
$parcel$export(module.exports, "filter", function () { return $452cccc11a69c5c0$export$3dea766d36a8935f; });
$parcel$export(module.exports, "filterRegExp", function () { return $452cccc11a69c5c0$export$322859471e81229d; });
$parcel$export(module.exports, "join", function () { return $452cccc11a69c5c0$export$f7e2c8231c57a8bd; });
$parcel$export(module.exports, "identify", function () { return $452cccc11a69c5c0$export$65e5b62a4c490288; });
$parcel$export(module.exports, "generalize", function () { return $452cccc11a69c5c0$export$d57ad8b840ad6a01; });
$parcel$export(module.exports, "getArrayDataType", function () { return $452cccc11a69c5c0$export$d31e00bf4359ea8b; });
$parcel$export(module.exports, "contains", function () { return $452cccc11a69c5c0$export$2344b14b097df817; });

var $kFRKb = parcelRequire("kFRKb");

var $1amHZ = parcelRequire("1amHZ");

var $6NxuJ = parcelRequire("6NxuJ");

var $hy7Bx = parcelRequire("hy7Bx");

var $5ITEv = parcelRequire("5ITEv");
function $452cccc11a69c5c0$export$51ffaee4afb683a5(x) {
    var s = [];
    while(Array.isArray(x)){
        s.push(x.length);
        x = x[0];
    }
    return s;
}
/**
 * Recursively validate whether each element in a multi dimensional array
 * has a size corresponding to the provided size array.
 * @param {Array} array    Array to be validated
 * @param {number[]} size  Array with the size of each dimension
 * @param {number} dim   Current dimension
 * @throws DimensionError
 * @private
 */ function $452cccc11a69c5c0$var$_validate(array, size, dim) {
    var i;
    var len = array.length;
    if (len !== size[dim]) throw new (0, $hy7Bx.DimensionError)(len, size[dim]);
    if (dim < size.length - 1) {
        // recursively validate each child array
        var dimNext = dim + 1;
        for(i = 0; i < len; i++){
            var child = array[i];
            if (!Array.isArray(child)) throw new (0, $hy7Bx.DimensionError)(size.length - 1, size.length, "<");
            $452cccc11a69c5c0$var$_validate(array[i], size, dimNext);
        }
    } else // last dimension. none of the childs may be an array
    for(i = 0; i < len; i++){
        if (Array.isArray(array[i])) throw new (0, $hy7Bx.DimensionError)(size.length + 1, size.length, ">");
    }
}
function $452cccc11a69c5c0$export$a22775fa5e2eebd9(array, size) {
    var isScalar = size.length === 0;
    if (isScalar) {
        // scalar
        if (Array.isArray(array)) throw new (0, $hy7Bx.DimensionError)(array.length, 0);
    } else // array
    $452cccc11a69c5c0$var$_validate(array, size, 0);
}
function $452cccc11a69c5c0$export$3cfe3fbfec03f260(index, length) {
    if (!(0, $1amHZ.isNumber)(index) || !(0, $kFRKb.isInteger)(index)) throw new TypeError("Index must be an integer (value: " + index + ")");
    if (index < 0 || typeof length === "number" && index >= length) throw new (0, $5ITEv.IndexError)(index, length);
}
function $452cccc11a69c5c0$export$4380c87abf28fdf(array, size, defaultValue) {
    // TODO: add support for scalars, having size=[] ?
    // check the type of the arguments
    if (!Array.isArray(array) || !Array.isArray(size)) throw new TypeError("Array expected");
    if (size.length === 0) throw new Error("Resizing to scalar is not supported");
     // check whether size contains positive integers
    size.forEach(function(value) {
        if (!(0, $1amHZ.isNumber)(value) || !(0, $kFRKb.isInteger)(value) || value < 0) throw new TypeError("Invalid size, must contain positive integers (size: " + (0, $6NxuJ.format)(size) + ")");
    }); // recursively resize the array
    var _defaultValue = defaultValue !== undefined ? defaultValue : 0;
    $452cccc11a69c5c0$var$_resize(array, size, 0, _defaultValue);
    return array;
}
/**
 * Recursively resize a multi dimensional array
 * @param {Array} array         Array to be resized
 * @param {number[]} size       Array with the size of each dimension
 * @param {number} dim          Current dimension
 * @param {*} [defaultValue]    Value to be filled in in new entries,
 *                              undefined by default.
 * @private
 */ function $452cccc11a69c5c0$var$_resize(array, size, dim, defaultValue) {
    var i;
    var elem;
    var oldLen = array.length;
    var newLen = size[dim];
    var minLen = Math.min(oldLen, newLen); // apply new length
    array.length = newLen;
    if (dim < size.length - 1) {
        // non-last dimension
        var dimNext = dim + 1; // resize existing child arrays
        for(i = 0; i < minLen; i++){
            // resize child array
            elem = array[i];
            if (!Array.isArray(elem)) {
                elem = [
                    elem
                ]; // add a dimension
                array[i] = elem;
            }
            $452cccc11a69c5c0$var$_resize(elem, size, dimNext, defaultValue);
        } // create new child arrays
        for(i = minLen; i < newLen; i++){
            // get child array
            elem = [];
            array[i] = elem; // resize new child array
            $452cccc11a69c5c0$var$_resize(elem, size, dimNext, defaultValue);
        }
    } else {
        // last dimension
        // remove dimensions of existing values
        for(i = 0; i < minLen; i++)while(Array.isArray(array[i]))array[i] = array[i][0];
         // fill new elements with the default value
        for(i = minLen; i < newLen; i++)array[i] = defaultValue;
    }
}
function $452cccc11a69c5c0$export$9eaad88cf88cee2b(array, sizes) {
    var flatArray = $452cccc11a69c5c0$export$bffa455ba8c619a6(array);
    var newArray;
    function product(arr) {
        return arr.reduce(function(prev, curr) {
            return prev * curr;
        });
    }
    if (!Array.isArray(array) || !Array.isArray(sizes)) throw new TypeError("Array expected");
    if (sizes.length === 0) throw new (0, $hy7Bx.DimensionError)(0, product($452cccc11a69c5c0$export$51ffaee4afb683a5(array)), "!=");
    var totalSize = 1;
    for(var sizeIndex = 0; sizeIndex < sizes.length; sizeIndex++)totalSize *= sizes[sizeIndex];
    if (flatArray.length !== totalSize) throw new (0, $hy7Bx.DimensionError)(product(sizes), product($452cccc11a69c5c0$export$51ffaee4afb683a5(array)), "!=");
    try {
        newArray = $452cccc11a69c5c0$var$_reshape(flatArray, sizes);
    } catch (e) {
        if (e instanceof (0, $hy7Bx.DimensionError)) throw new (0, $hy7Bx.DimensionError)(product(sizes), product($452cccc11a69c5c0$export$51ffaee4afb683a5(array)), "!=");
        throw e;
    }
    return newArray;
}
/**
 * Iteratively re-shape a multi dimensional array to fit the specified dimensions
 * @param {Array} array           Array to be reshaped
 * @param {Array.<number>} sizes  List of sizes for each dimension
 * @returns {Array}               Array whose data has been formatted to fit the
 *                                specified dimensions
 */ function $452cccc11a69c5c0$var$_reshape(array, sizes) {
    // testing if there are enough elements for the requested shape
    var tmpArray = array;
    var tmpArray2; // for each dimensions starting by the last one and ignoring the first one
    for(var sizeIndex = sizes.length - 1; sizeIndex > 0; sizeIndex--){
        var size = sizes[sizeIndex];
        tmpArray2 = []; // aggregate the elements of the current tmpArray in elements of the requested size
        var length = tmpArray.length / size;
        for(var i = 0; i < length; i++)tmpArray2.push(tmpArray.slice(i * size, (i + 1) * size));
         // set it as the new tmpArray for the next loop turn or for return
        tmpArray = tmpArray2;
    }
    return tmpArray;
}
function $452cccc11a69c5c0$export$889c931173b77c2f(array, size) {
    var s = size || $452cccc11a69c5c0$export$51ffaee4afb683a5(array); // squeeze outer dimensions
    while(Array.isArray(array) && array.length === 1){
        array = array[0];
        s.shift();
    } // find the first dimension to be squeezed
    var dims = s.length;
    while(s[dims - 1] === 1)dims--;
     // squeeze inner dimensions
    if (dims < s.length) {
        array = $452cccc11a69c5c0$var$_squeeze(array, dims, 0);
        s.length = dims;
    }
    return array;
}
/**
 * Recursively squeeze a multi dimensional array
 * @param {Array} array
 * @param {number} dims Required number of dimensions
 * @param {number} dim  Current dimension
 * @returns {Array | *} Returns the squeezed array
 * @private
 */ function $452cccc11a69c5c0$var$_squeeze(array, dims, dim) {
    var i, ii;
    if (dim < dims) {
        var next = dim + 1;
        for(i = 0, ii = array.length; i < ii; i++)array[i] = $452cccc11a69c5c0$var$_squeeze(array[i], dims, next);
    } else while(Array.isArray(array))array = array[0];
    return array;
}
function $452cccc11a69c5c0$export$5a07c5202d40a604(array, dims, outer, size) {
    var s = size || $452cccc11a69c5c0$export$51ffaee4afb683a5(array); // unsqueeze outer dimensions
    if (outer) for(var i = 0; i < outer; i++){
        array = [
            array
        ];
        s.unshift(1);
    }
     // unsqueeze inner dimensions
    array = $452cccc11a69c5c0$var$_unsqueeze(array, dims, 0);
    while(s.length < dims)s.push(1);
    return array;
}
/**
 * Recursively unsqueeze a multi dimensional array
 * @param {Array} array
 * @param {number} dims Required number of dimensions
 * @param {number} dim  Current dimension
 * @returns {Array | *} Returns the squeezed array
 * @private
 */ function $452cccc11a69c5c0$var$_unsqueeze(array, dims, dim) {
    var i, ii;
    if (Array.isArray(array)) {
        var next = dim + 1;
        for(i = 0, ii = array.length; i < ii; i++)array[i] = $452cccc11a69c5c0$var$_unsqueeze(array[i], dims, next);
    } else for(var d = dim; d < dims; d++)array = [
        array
    ];
    return array;
}
function $452cccc11a69c5c0$export$bffa455ba8c619a6(array) {
    if (!Array.isArray(array)) // if not an array, return as is
    return array;
    var flat = [];
    array.forEach(function callback(value) {
        if (Array.isArray(value)) value.forEach(callback); // traverse through sub-arrays recursively
        else flat.push(value);
    });
    return flat;
}
function $452cccc11a69c5c0$export$871de8747c9eaa88(array, callback) {
    return Array.prototype.map.call(array, callback);
}
function $452cccc11a69c5c0$export$4b80e395e36b5a56(array, callback) {
    Array.prototype.forEach.call(array, callback);
}
function $452cccc11a69c5c0$export$3dea766d36a8935f(array, callback) {
    if ($452cccc11a69c5c0$export$51ffaee4afb683a5(array).length !== 1) throw new Error("Only one dimensional matrices supported");
    return Array.prototype.filter.call(array, callback);
}
function $452cccc11a69c5c0$export$322859471e81229d(array, regexp) {
    if ($452cccc11a69c5c0$export$51ffaee4afb683a5(array).length !== 1) throw new Error("Only one dimensional matrices supported");
    return Array.prototype.filter.call(array, function(entry) {
        return regexp.test(entry);
    });
}
function $452cccc11a69c5c0$export$f7e2c8231c57a8bd(array, separator) {
    return Array.prototype.join.call(array, separator);
}
function $452cccc11a69c5c0$export$65e5b62a4c490288(a) {
    if (!Array.isArray(a)) throw new TypeError("Array input expected");
    if (a.length === 0) return a;
    var b = [];
    var count = 0;
    b[0] = {
        value: a[0],
        identifier: 0
    };
    for(var i = 1; i < a.length; i++){
        if (a[i] === a[i - 1]) count++;
        else count = 0;
        b.push({
            value: a[i],
            identifier: count
        });
    }
    return b;
}
function $452cccc11a69c5c0$export$d57ad8b840ad6a01(a) {
    if (!Array.isArray(a)) throw new TypeError("Array input expected");
    if (a.length === 0) return a;
    var b = [];
    for(var i = 0; i < a.length; i++)b.push(a[i].value);
    return b;
}
function $452cccc11a69c5c0$export$d31e00bf4359ea8b(array, typeOf) {
    var type; // to hold type info
    var length = 0; // to hold length value to ensure it has consistent sizes
    for(var i = 0; i < array.length; i++){
        var item = array[i];
        var isArray = Array.isArray(item); // Saving the target matrix row size
        if (i === 0 && isArray) length = item.length;
         // If the current item is an array but the length does not equal the targetVectorSize
        if (isArray && item.length !== length) return undefined;
        var itemType = isArray ? $452cccc11a69c5c0$export$d31e00bf4359ea8b(item, typeOf) // recurse into a nested array
         : typeOf(item);
        if (type === undefined) type = itemType; // first item
        else if (type !== itemType) return "mixed";
    }
    return type;
}
function $452cccc11a69c5c0$export$4c7897fafd92b108(array) {
    return array[array.length - 1];
}
function $452cccc11a69c5c0$export$59ff82fc918bd7e3(array) {
    return array.slice(0, array.length - 1);
}
function $452cccc11a69c5c0$export$2344b14b097df817(array, item) {
    return array.indexOf(item) !== -1;
}

});
parcelRegister("kFRKb", function(module, exports) {

$parcel$export(module.exports, "isInteger", function () { return $f0d15362fbf20f57$export$a287f47fed4544b8; });
$parcel$export(module.exports, "sign", function () { return $f0d15362fbf20f57$export$c5552dfdbc7cec71; });
$parcel$export(module.exports, "log2", function () { return $f0d15362fbf20f57$export$b9fae0bba9d9094d; });
$parcel$export(module.exports, "log10", function () { return $f0d15362fbf20f57$export$75e08744a3ff8516; });
$parcel$export(module.exports, "log1p", function () { return $f0d15362fbf20f57$export$144dcf16adfb9698; });
$parcel$export(module.exports, "cbrt", function () { return $f0d15362fbf20f57$export$841fc4d5a1480b85; });
$parcel$export(module.exports, "expm1", function () { return $f0d15362fbf20f57$export$b6c0a80d46d3391d; });
$parcel$export(module.exports, "format", function () { return $f0d15362fbf20f57$export$d9468344d3651243; });
$parcel$export(module.exports, "toFixed", function () { return $f0d15362fbf20f57$export$a81f732198733497; });
$parcel$export(module.exports, "digits", function () { return $f0d15362fbf20f57$export$9c0987062f8f5d89; });
$parcel$export(module.exports, "nearlyEqual", function () { return $f0d15362fbf20f57$export$6f3989c6ecc04081; });
$parcel$export(module.exports, "acosh", function () { return $f0d15362fbf20f57$export$b26caf0f29211d08; });
$parcel$export(module.exports, "asinh", function () { return $f0d15362fbf20f57$export$839d8a01b6af4fc0; });
$parcel$export(module.exports, "atanh", function () { return $f0d15362fbf20f57$export$21ea955025ceb08b; });
$parcel$export(module.exports, "cosh", function () { return $f0d15362fbf20f57$export$2e2fd1ad24e4d350; });
$parcel$export(module.exports, "sinh", function () { return $f0d15362fbf20f57$export$545004b505d7c555; });
$parcel$export(module.exports, "tanh", function () { return $f0d15362fbf20f57$export$7128670e45beef9a; });

var $7ITGG = parcelRequire("7ITGG");

var $1amHZ = parcelRequire("1amHZ");
function $f0d15362fbf20f57$export$a287f47fed4544b8(value) {
    if (typeof value === "boolean") return true;
    return isFinite(value) ? value === Math.round(value) : false; // Note: we use ==, not ===, as we can have Booleans as well
}
var $f0d15362fbf20f57$export$c5552dfdbc7cec71 = /* #__PURE__ */ Math.sign || function(x) {
    if (x > 0) return 1;
    else if (x < 0) return -1;
    else return 0;
};
var $f0d15362fbf20f57$export$b9fae0bba9d9094d = /* #__PURE__ */ Math.log2 || function log2(x) {
    return Math.log(x) / Math.LN2;
};
var $f0d15362fbf20f57$export$75e08744a3ff8516 = /* #__PURE__ */ Math.log10 || function log10(x) {
    return Math.log(x) / Math.LN10;
};
var $f0d15362fbf20f57$export$144dcf16adfb9698 = /* #__PURE__ */ Math.log1p || function(x) {
    return Math.log(x + 1);
};
var $f0d15362fbf20f57$export$841fc4d5a1480b85 = /* #__PURE__ */ Math.cbrt || function cbrt(x) {
    if (x === 0) return x;
    var negate = x < 0;
    var result;
    if (negate) x = -x;
    if (isFinite(x)) {
        result = Math.exp(Math.log(x) / 3); // from https://en.wikipedia.org/wiki/Cube_root#Numerical_methods
        result = (x / (result * result) + 2 * result) / 3;
    } else result = x;
    return negate ? -result : result;
};
var $f0d15362fbf20f57$export$b6c0a80d46d3391d = /* #__PURE__ */ Math.expm1 || function expm1(x) {
    return x >= 2e-4 || x <= -0.0002 ? Math.exp(x) - 1 : x + x * x / 2 + x * x * x / 6;
};
function $f0d15362fbf20f57$export$d9468344d3651243(value, options) {
    if (typeof options === "function") // handle format(value, fn)
    return options(value);
     // handle special cases
    if (value === Infinity) return "Infinity";
    else if (value === -Infinity) return "-Infinity";
    else if (isNaN(value)) return "NaN";
     // default values for options
    var notation = "auto";
    var precision;
    if (options) {
        // determine notation from options
        if (options.notation) notation = options.notation;
         // determine precision from options
        if ((0, $1amHZ.isNumber)(options)) precision = options;
        else if ((0, $1amHZ.isNumber)(options.precision)) precision = options.precision;
    } // handle the various notations
    switch(notation){
        case "fixed":
            return $f0d15362fbf20f57$export$a81f732198733497(value, precision);
        case "exponential":
            return $f0d15362fbf20f57$export$888cb08ddc4765be(value, precision);
        case "engineering":
            return $f0d15362fbf20f57$export$9299fe684ed0ee48(value, precision);
        case "auto":
            // TODO: clean up some day. Deprecated since: 2018-01-24
            // @deprecated upper and lower are replaced with upperExp and lowerExp since v4.0.0
            if (options && options.exponential && (options.exponential.lower !== undefined || options.exponential.upper !== undefined)) {
                var fixedOptions = (0, $7ITGG.mapObject)(options, function(x) {
                    return x;
                });
                fixedOptions.exponential = undefined;
                if (options.exponential.lower !== undefined) fixedOptions.lowerExp = Math.round(Math.log(options.exponential.lower) / Math.LN10);
                if (options.exponential.upper !== undefined) fixedOptions.upperExp = Math.round(Math.log(options.exponential.upper) / Math.LN10);
                console.warn("Deprecation warning: Formatting options exponential.lower and exponential.upper (minimum and maximum value) are replaced with exponential.lowerExp and exponential.upperExp (minimum and maximum exponent) since version 4.0.0. Replace " + JSON.stringify(options) + " with " + JSON.stringify(fixedOptions));
                return $f0d15362fbf20f57$export$3e91a10e66078270(value, precision, fixedOptions);
            } // remove trailing zeros after the decimal point
            return $f0d15362fbf20f57$export$3e91a10e66078270(value, precision, options && options).replace(/((\.\d*?)(0+))($|e)/, function() {
                var digits = arguments[2];
                var e = arguments[4];
                return digits !== "." ? digits + e : e;
            });
        default:
            throw new Error('Unknown notation "' + notation + '". ' + 'Choose "auto", "exponential", or "fixed".');
    }
}
function $f0d15362fbf20f57$export$feb80e120a50087f(value) {
    // parse the input value
    var match = String(value).toLowerCase().match(/^0*?(-?)(\d+\.?\d*)(e([+-]?\d+))?$/);
    if (!match) throw new SyntaxError("Invalid number " + value);
    var sign = match[1];
    var digits = match[2];
    var exponent = parseFloat(match[4] || "0");
    var dot = digits.indexOf(".");
    exponent += dot !== -1 ? dot - 1 : digits.length - 1;
    var coefficients = digits.replace(".", "") // remove the dot (must be removed before removing leading zeros)
    .replace(/^0*/, function(zeros) {
        // remove leading zeros, add their count to the exponent
        exponent -= zeros.length;
        return "";
    }).replace(/0*$/, "") // remove trailing zeros
    .split("").map(function(d) {
        return parseInt(d);
    });
    if (coefficients.length === 0) {
        coefficients.push(0);
        exponent++;
    }
    return {
        sign: sign,
        coefficients: coefficients,
        exponent: exponent
    };
}
function $f0d15362fbf20f57$export$9299fe684ed0ee48(value, precision) {
    if (isNaN(value) || !isFinite(value)) return String(value);
    var split = $f0d15362fbf20f57$export$feb80e120a50087f(value);
    var rounded = $f0d15362fbf20f57$export$e5b32ced877afc7e(split, precision);
    var e = rounded.exponent;
    var c = rounded.coefficients; // find nearest lower multiple of 3 for exponent
    var newExp = e % 3 === 0 ? e : e < 0 ? e - 3 - e % 3 : e - e % 3;
    if ((0, $1amHZ.isNumber)(precision)) // add zeroes to give correct sig figs
    while(precision > c.length || e - newExp + 1 > c.length)c.push(0);
    else {
        // concatenate coefficients with necessary zeros
        // add zeros if necessary (for example: 1e+8 -> 100e+6)
        var missingZeros = Math.abs(e - newExp) - (c.length - 1);
        for(var i = 0; i < missingZeros; i++)c.push(0);
    } // find difference in exponents
    var expDiff = Math.abs(e - newExp);
    var decimalIdx = 1; // push decimal index over by expDiff times
    while(expDiff > 0){
        decimalIdx++;
        expDiff--;
    } // if all coefficient values are zero after the decimal point and precision is unset, don't add a decimal value.
    // otherwise concat with the rest of the coefficients
    var decimals = c.slice(decimalIdx).join("");
    var decimalVal = (0, $1amHZ.isNumber)(precision) && decimals.length || decimals.match(/[1-9]/) ? "." + decimals : "";
    var str = c.slice(0, decimalIdx).join("") + decimalVal + "e" + (e >= 0 ? "+" : "") + newExp.toString();
    return rounded.sign + str;
}
function $f0d15362fbf20f57$export$a81f732198733497(value, precision) {
    if (isNaN(value) || !isFinite(value)) return String(value);
    var splitValue = $f0d15362fbf20f57$export$feb80e120a50087f(value);
    var rounded = typeof precision === "number" ? $f0d15362fbf20f57$export$e5b32ced877afc7e(splitValue, splitValue.exponent + 1 + precision) : splitValue;
    var c = rounded.coefficients;
    var p = rounded.exponent + 1; // exponent may have changed
    // append zeros if needed
    var pp = p + (precision || 0);
    if (c.length < pp) c = c.concat($f0d15362fbf20f57$var$zeros(pp - c.length));
     // prepend zeros if needed
    if (p < 0) {
        c = $f0d15362fbf20f57$var$zeros(-p + 1).concat(c);
        p = 1;
    } // insert a dot if needed
    if (p < c.length) c.splice(p, 0, p === 0 ? "0." : ".");
    return rounded.sign + c.join("");
}
function $f0d15362fbf20f57$export$888cb08ddc4765be(value, precision) {
    if (isNaN(value) || !isFinite(value)) return String(value);
     // round if needed, else create a clone
    var split = $f0d15362fbf20f57$export$feb80e120a50087f(value);
    var rounded = precision ? $f0d15362fbf20f57$export$e5b32ced877afc7e(split, precision) : split;
    var c = rounded.coefficients;
    var e = rounded.exponent; // append zeros if needed
    if (c.length < precision) c = c.concat($f0d15362fbf20f57$var$zeros(precision - c.length));
     // format as `C.CCCe+EEE` or `C.CCCe-EEE`
    var first = c.shift();
    return rounded.sign + first + (c.length > 0 ? "." + c.join("") : "") + "e" + (e >= 0 ? "+" : "") + e;
}
function $f0d15362fbf20f57$export$3e91a10e66078270(value, precision, options) {
    if (isNaN(value) || !isFinite(value)) return String(value);
     // determine lower and upper bound for exponential notation.
    var lowerExp = options && options.lowerExp !== undefined ? options.lowerExp : -3;
    var upperExp = options && options.upperExp !== undefined ? options.upperExp : 5;
    var split = $f0d15362fbf20f57$export$feb80e120a50087f(value);
    var rounded = precision ? $f0d15362fbf20f57$export$e5b32ced877afc7e(split, precision) : split;
    if (rounded.exponent < lowerExp || rounded.exponent >= upperExp) // exponential notation
    return $f0d15362fbf20f57$export$888cb08ddc4765be(value, precision);
    else {
        var c = rounded.coefficients;
        var e = rounded.exponent; // append trailing zeros
        if (c.length < precision) c = c.concat($f0d15362fbf20f57$var$zeros(precision - c.length));
         // append trailing zeros
        // TODO: simplify the next statement
        c = c.concat($f0d15362fbf20f57$var$zeros(e - c.length + 1 + (c.length < precision ? precision - c.length : 0))); // prepend zeros
        c = $f0d15362fbf20f57$var$zeros(-e).concat(c);
        var dot = e > 0 ? e : 0;
        if (dot < c.length - 1) c.splice(dot + 1, 0, ".");
        return rounded.sign + c.join("");
    }
}
function $f0d15362fbf20f57$export$e5b32ced877afc7e(split, precision) {
    // create a clone
    var rounded = {
        sign: split.sign,
        coefficients: split.coefficients,
        exponent: split.exponent
    };
    var c = rounded.coefficients; // prepend zeros if needed
    while(precision <= 0){
        c.unshift(0);
        rounded.exponent++;
        precision++;
    }
    if (c.length > precision) {
        var removed = c.splice(precision, c.length - precision);
        if (removed[0] >= 5) {
            var i = precision - 1;
            c[i]++;
            while(c[i] === 10){
                c.pop();
                if (i === 0) {
                    c.unshift(0);
                    rounded.exponent++;
                    i++;
                }
                i--;
                c[i]++;
            }
        }
    }
    return rounded;
}
/**
 * Create an array filled with zeros.
 * @param {number} length
 * @return {Array}
 */ function $f0d15362fbf20f57$var$zeros(length) {
    var arr = [];
    for(var i = 0; i < length; i++)arr.push(0);
    return arr;
}
function $f0d15362fbf20f57$export$9c0987062f8f5d89(value) {
    return value.toExponential().replace(/e.*$/, "") // remove exponential notation
    .replace(/^0\.?0*|\./, "") // remove decimal point and leading zeros
    .length;
}
var $f0d15362fbf20f57$export$41b54fa1db30dbb5 = Number.EPSILON || 2.2204460492503130808472633361816E-16;
function $f0d15362fbf20f57$export$6f3989c6ecc04081(x, y, epsilon) {
    // if epsilon is null or undefined, test whether x and y are exactly equal
    if (epsilon === null || epsilon === undefined) return x === y;
    if (x === y) return true;
     // NaN
    if (isNaN(x) || isNaN(y)) return false;
     // at this point x and y should be finite
    if (isFinite(x) && isFinite(y)) {
        // check numbers are very close, needed when comparing numbers near zero
        var diff = Math.abs(x - y);
        if (diff < $f0d15362fbf20f57$export$41b54fa1db30dbb5) return true;
        else // use relative error
        return diff <= Math.max(Math.abs(x), Math.abs(y)) * epsilon;
    } // Infinite and Number or negative Infinite and positive Infinite cases
    return false;
}
var $f0d15362fbf20f57$export$b26caf0f29211d08 = Math.acosh || function(x) {
    return Math.log(Math.sqrt(x * x - 1) + x);
};
var $f0d15362fbf20f57$export$839d8a01b6af4fc0 = Math.asinh || function(x) {
    return Math.log(Math.sqrt(x * x + 1) + x);
};
var $f0d15362fbf20f57$export$21ea955025ceb08b = Math.atanh || function(x) {
    return Math.log((1 + x) / (1 - x)) / 2;
};
var $f0d15362fbf20f57$export$2e2fd1ad24e4d350 = Math.cosh || function(x) {
    return (Math.exp(x) + Math.exp(-x)) / 2;
};
var $f0d15362fbf20f57$export$545004b505d7c555 = Math.sinh || function(x) {
    return (Math.exp(x) - Math.exp(-x)) / 2;
};
var $f0d15362fbf20f57$export$7128670e45beef9a = Math.tanh || function(x) {
    var e = Math.exp(2 * x);
    return (e - 1) / (e + 1);
};

});

parcelRegister("6NxuJ", function(module, exports) {

$parcel$export(module.exports, "endsWith", function () { return $4f314d033fcf8fb7$export$10fdab3683b55b22; });
$parcel$export(module.exports, "format", function () { return $4f314d033fcf8fb7$export$d9468344d3651243; });
$parcel$export(module.exports, "stringify", function () { return $4f314d033fcf8fb7$export$fac44ee5b035f737; });
$parcel$export(module.exports, "escape", function () { return $4f314d033fcf8fb7$export$4e7f196112fea3c5; });
$parcel$export(module.exports, "compareText", function () { return $4f314d033fcf8fb7$export$2da9287da10b19e2; });

var $1amHZ = parcelRequire("1amHZ");

var $kFRKb = parcelRequire("kFRKb");

var $sF5ft = parcelRequire("sF5ft");
function $4f314d033fcf8fb7$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $4f314d033fcf8fb7$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $4f314d033fcf8fb7$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $4f314d033fcf8fb7$var$_typeof(obj);
}
function $4f314d033fcf8fb7$export$10fdab3683b55b22(text, search) {
    var start = text.length - search.length;
    var end = text.length;
    return text.substring(start, end) === search;
}
function $4f314d033fcf8fb7$export$d9468344d3651243(value, options) {
    if (typeof value === "number") return (0, $kFRKb.format)(value, options);
    if ((0, $1amHZ.isBigNumber)(value)) return (0, $sF5ft.format)(value, options);
     // note: we use unsafe duck-typing here to check for Fractions, this is
    // ok here since we're only invoking toString or concatenating its values
    if ($4f314d033fcf8fb7$var$looksLikeFraction(value)) {
        if (!options || options.fraction !== "decimal") // output as ratio, like '1/3'
        return value.s * value.n + "/" + value.d;
        else // output as decimal, like '0.(3)'
        return value.toString();
    }
    if (Array.isArray(value)) return $4f314d033fcf8fb7$var$formatArray(value, options);
    if ((0, $1amHZ.isString)(value)) return '"' + value + '"';
    if (typeof value === "function") return value.syntax ? String(value.syntax) : "function";
    if (value && $4f314d033fcf8fb7$var$_typeof(value) === "object") {
        if (typeof value.format === "function") return value.format(options);
        else if (value && value.toString(options) !== ({}).toString()) // this object has a non-native toString method, use that one
        return value.toString(options);
        else {
            var entries = Object.keys(value).map(function(key) {
                return '"' + key + '": ' + $4f314d033fcf8fb7$export$d9468344d3651243(value[key], options);
            });
            return "{" + entries.join(", ") + "}";
        }
    }
    return String(value);
}
function $4f314d033fcf8fb7$export$fac44ee5b035f737(value) {
    var text = String(value);
    var escaped = "";
    var i = 0;
    while(i < text.length){
        var c = text.charAt(i);
        if (c === "\\") {
            escaped += c;
            i++;
            c = text.charAt(i);
            if (c === "" || '"\\/bfnrtu'.indexOf(c) === -1) escaped += "\\"; // no valid escape character -> escape it
            escaped += c;
        } else if (c === '"') escaped += '\\"';
        else escaped += c;
        i++;
    }
    return '"' + escaped + '"';
}
function $4f314d033fcf8fb7$export$4e7f196112fea3c5(value) {
    var text = String(value);
    text = text.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    return text;
}
/**
 * Recursively format an n-dimensional matrix
 * Example output: "[[1, 2], [3, 4]]"
 * @param {Array} array
 * @param {Object | number | Function} [options]  Formatting options. See
 *                                                lib/utils/number:format for a
 *                                                description of the available
 *                                                options.
 * @returns {string} str
 */ function $4f314d033fcf8fb7$var$formatArray(array, options) {
    if (Array.isArray(array)) {
        var str = "[";
        var len = array.length;
        for(var i = 0; i < len; i++){
            if (i !== 0) str += ", ";
            str += $4f314d033fcf8fb7$var$formatArray(array[i], options);
        }
        str += "]";
        return str;
    } else return $4f314d033fcf8fb7$export$d9468344d3651243(array, options);
}
/**
 * Check whether a value looks like a Fraction (unsafe duck-type check)
 * @param {*} value
 * @return {boolean}
 */ function $4f314d033fcf8fb7$var$looksLikeFraction(value) {
    return value && $4f314d033fcf8fb7$var$_typeof(value) === "object" && typeof value.s === "number" && typeof value.n === "number" && typeof value.d === "number" || false;
}
function $4f314d033fcf8fb7$export$2da9287da10b19e2(x, y) {
    // we don't want to convert numbers to string, only accept string input
    if (!(0, $1amHZ.isString)(x)) throw new TypeError("Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: " + (0, $1amHZ.typeOf)(x) + ", index: 0)");
    if (!(0, $1amHZ.isString)(y)) throw new TypeError("Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: " + (0, $1amHZ.typeOf)(y) + ", index: 1)");
    return x === y ? 0 : x > y ? 1 : -1;
}

});
parcelRegister("sF5ft", function(module, exports) {

$parcel$export(module.exports, "format", function () { return $05627bff49f922d0$export$d9468344d3651243; });

var $7ITGG = parcelRequire("7ITGG");
function $05627bff49f922d0$export$d9468344d3651243(value, options) {
    if (typeof options === "function") // handle format(value, fn)
    return options(value);
     // handle special cases
    if (!value.isFinite()) return value.isNaN() ? "NaN" : value.gt(0) ? "Infinity" : "-Infinity";
     // default values for options
    var notation = "auto";
    var precision;
    if (options !== undefined) {
        // determine notation from options
        if (options.notation) notation = options.notation;
         // determine precision from options
        if (typeof options === "number") precision = options;
        else if (options.precision) precision = options.precision;
    } // handle the various notations
    switch(notation){
        case "fixed":
            return $05627bff49f922d0$export$a81f732198733497(value, precision);
        case "exponential":
            return $05627bff49f922d0$export$888cb08ddc4765be(value, precision);
        case "engineering":
            return $05627bff49f922d0$export$9299fe684ed0ee48(value, precision);
        case "auto":
            // TODO: clean up some day. Deprecated since: 2018-01-24
            // @deprecated upper and lower are replaced with upperExp and lowerExp since v4.0.0
            if (options && options.exponential && (options.exponential.lower !== undefined || options.exponential.upper !== undefined)) {
                var fixedOptions = (0, $7ITGG.mapObject)(options, function(x) {
                    return x;
                });
                fixedOptions.exponential = undefined;
                if (options.exponential.lower !== undefined) fixedOptions.lowerExp = Math.round(Math.log(options.exponential.lower) / Math.LN10);
                if (options.exponential.upper !== undefined) fixedOptions.upperExp = Math.round(Math.log(options.exponential.upper) / Math.LN10);
                console.warn("Deprecation warning: Formatting options exponential.lower and exponential.upper (minimum and maximum value) are replaced with exponential.lowerExp and exponential.upperExp (minimum and maximum exponent) since version 4.0.0. Replace " + JSON.stringify(options) + " with " + JSON.stringify(fixedOptions));
                return $05627bff49f922d0$export$d9468344d3651243(value, fixedOptions);
            } // determine lower and upper bound for exponential notation.
            // TODO: implement support for upper and lower to be BigNumbers themselves
            var lowerExp = options && options.lowerExp !== undefined ? options.lowerExp : -3;
            var upperExp = options && options.upperExp !== undefined ? options.upperExp : 5; // handle special case zero
            if (value.isZero()) return "0"; // determine whether or not to output exponential notation
            var str;
            var rounded = value.toSignificantDigits(precision);
            var exp = rounded.e;
            if (exp >= lowerExp && exp < upperExp) // normal number notation
            str = rounded.toFixed();
            else // exponential notation
            str = $05627bff49f922d0$export$888cb08ddc4765be(value, precision);
             // remove trailing zeros after the decimal point
            return str.replace(/((\.\d*?)(0+))($|e)/, function() {
                var digits = arguments[2];
                var e = arguments[4];
                return digits !== "." ? digits + e : e;
            });
        default:
            throw new Error('Unknown notation "' + notation + '". ' + 'Choose "auto", "exponential", or "fixed".');
    }
}
function $05627bff49f922d0$export$9299fe684ed0ee48(value, precision) {
    // find nearest lower multiple of 3 for exponent
    var e = value.e;
    var newExp = e % 3 === 0 ? e : e < 0 ? e - 3 - e % 3 : e - e % 3; // find difference in exponents, and calculate the value without exponent
    var valueWithoutExp = value.mul(Math.pow(10, -newExp));
    var valueStr = valueWithoutExp.toPrecision(precision);
    if (valueStr.indexOf("e") !== -1) valueStr = valueWithoutExp.toString();
    return valueStr + "e" + (e >= 0 ? "+" : "") + newExp.toString();
}
function $05627bff49f922d0$export$888cb08ddc4765be(value, precision) {
    if (precision !== undefined) return value.toExponential(precision - 1); // Note the offset of one
    else return value.toExponential();
}
function $05627bff49f922d0$export$a81f732198733497(value, precision) {
    return value.toFixed(precision);
}

});


parcelRegister("hy7Bx", function(module, exports) {

$parcel$export(module.exports, "DimensionError", function () { return $cc6b82b97f4092af$export$ad1391ca020fdd96; });
/**
 * Create a range error with the message:
 *     'Dimension mismatch (<actual size> != <expected size>)'
 * @param {number | number[]} actual        The actual size
 * @param {number | number[]} expected      The expected size
 * @param {string} [relation='!=']          Optional relation between actual
 *                                          and expected size: '!=', '<', etc.
 * @extends RangeError
 */ function $cc6b82b97f4092af$export$ad1391ca020fdd96(actual, expected, relation) {
    if (!(this instanceof $cc6b82b97f4092af$export$ad1391ca020fdd96)) throw new SyntaxError("Constructor must be called with the new operator");
    this.actual = actual;
    this.expected = expected;
    this.relation = relation;
    this.message = "Dimension mismatch (" + (Array.isArray(actual) ? "[" + actual.join(", ") + "]" : actual) + " " + (this.relation || "!=") + " " + (Array.isArray(expected) ? "[" + expected.join(", ") + "]" : expected) + ")";
    this.stack = new Error().stack;
}
$cc6b82b97f4092af$export$ad1391ca020fdd96.prototype = new RangeError();
$cc6b82b97f4092af$export$ad1391ca020fdd96.prototype.constructor = RangeError;
$cc6b82b97f4092af$export$ad1391ca020fdd96.prototype.name = "DimensionError";
$cc6b82b97f4092af$export$ad1391ca020fdd96.prototype.isDimensionError = true;

});

parcelRegister("5ITEv", function(module, exports) {

$parcel$export(module.exports, "IndexError", function () { return $42ac3b348842899f$export$efa5eacb1304c464; });
/**
 * Create a range error with the message:
 *     'Index out of range (index < min)'
 *     'Index out of range (index < max)'
 *
 * @param {number} index     The actual index
 * @param {number} [min=0]   Minimum index (included)
 * @param {number} [max]     Maximum index (excluded)
 * @extends RangeError
 */ function $42ac3b348842899f$export$efa5eacb1304c464(index, min, max) {
    if (!(this instanceof $42ac3b348842899f$export$efa5eacb1304c464)) throw new SyntaxError("Constructor must be called with the new operator");
    this.index = index;
    if (arguments.length < 3) {
        this.min = 0;
        this.max = min;
    } else {
        this.min = min;
        this.max = max;
    }
    if (this.min !== undefined && this.index < this.min) this.message = "Index out of range (" + this.index + " < " + this.min + ")";
    else if (this.max !== undefined && this.index >= this.max) this.message = "Index out of range (" + this.index + " > " + (this.max - 1) + ")";
    else this.message = "Index out of range (" + this.index + ")";
    this.stack = new Error().stack;
}
$42ac3b348842899f$export$efa5eacb1304c464.prototype = new RangeError();
$42ac3b348842899f$export$efa5eacb1304c464.prototype.constructor = RangeError;
$42ac3b348842899f$export$efa5eacb1304c464.prototype.name = "IndexError";
$42ac3b348842899f$export$efa5eacb1304c464.prototype.isIndexError = true;

});



parcelRegister("9edVT", function(module, exports) {

$parcel$export(module.exports, "accessFactory", function () { return $6b803aa06d57f0c5$export$f8ba146648777f78; });

var $dJ38g = parcelRequire("dJ38g");

var $45IYD = parcelRequire("45IYD");
function $6b803aa06d57f0c5$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $6b803aa06d57f0c5$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $6b803aa06d57f0c5$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $6b803aa06d57f0c5$var$_typeof(obj);
}
function $6b803aa06d57f0c5$export$f8ba146648777f78(_ref) {
    var subset = _ref.subset;
    /**
   * Retrieve part of an object:
   *
   * - Retrieve a property from an object
   * - Retrieve a part of a string
   * - Retrieve a matrix subset
   *
   * @param {Object | Array | Matrix | string} object
   * @param {Index} index
   * @return {Object | Array | Matrix | string} Returns the subset
   */ return function access(object, index) {
        try {
            if (Array.isArray(object)) return subset(object, index);
            else if (object && typeof object.subset === "function") // Matrix
            return object.subset(index);
            else if (typeof object === "string") // TODO: move getStringSubset into a separate util file, use that
            return subset(object, index);
            else if ($6b803aa06d57f0c5$var$_typeof(object) === "object") {
                if (!index.isObjectProperty()) throw new TypeError("Cannot apply a numeric index as object property");
                return (0, $45IYD.getSafeProperty)(object, index.getObjectProperty());
            } else throw new TypeError("Cannot apply index: unsupported type of object");
        } catch (err) {
            throw (0, $dJ38g.errorTransform)(err);
        }
    };
}

});
parcelRegister("dJ38g", function(module, exports) {

$parcel$export(module.exports, "errorTransform", function () { return $9fe1e853513a4eea$export$1b927030cd80a31b; });

var $5ITEv = parcelRequire("5ITEv");
function $9fe1e853513a4eea$export$1b927030cd80a31b(err) {
    if (err && err.isIndexError) return new (0, $5ITEv.IndexError)(err.index + 1, err.min + 1, err.max !== undefined ? err.max + 1 : undefined);
    return err;
}

});



parcelRegister("ajZDX", function(module, exports) {

$parcel$export(module.exports, "createApplyTransform", function () { return $783b7ed3331842fd$export$1c2b553a3b99e; });

var $dJ38g = parcelRequire("dJ38g");

var $2mPYl = parcelRequire("2mPYl");

var $5kHy5 = parcelRequire("5kHy5");

var $1amHZ = parcelRequire("1amHZ");
var $783b7ed3331842fd$var$name = "apply";
var $783b7ed3331842fd$var$dependencies = [
    "typed",
    "isInteger"
];
var $783b7ed3331842fd$export$1c2b553a3b99e = /* #__PURE__ */ (0, $2mPYl.factory)($783b7ed3331842fd$var$name, $783b7ed3331842fd$var$dependencies, function(_ref) {
    var typed = _ref.typed, isInteger = _ref.isInteger;
    var apply = (0, $5kHy5.createApply)({
        typed: typed,
        isInteger: isInteger
    }); // @see: comment of concat itself
    return typed("apply", {
        "...any": function any(args) {
            // change dim from one-based to zero-based
            var dim = args[1];
            if ((0, $1amHZ.isNumber)(dim)) args[1] = dim - 1;
            else if ((0, $1amHZ.isBigNumber)(dim)) args[1] = dim.minus(1);
            try {
                return apply.apply(null, args);
            } catch (err) {
                throw (0, $dJ38g.errorTransform)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});

});
parcelRegister("5kHy5", function(module, exports) {

$parcel$export(module.exports, "createApply", function () { return $3e2099e91e450453$export$5ccffa1686df7f00; });

var $2mPYl = parcelRequire("2mPYl");

var $5WdrK = parcelRequire("5WdrK");

var $1amHZ = parcelRequire("1amHZ");

var $5ITEv = parcelRequire("5ITEv");
var $3e2099e91e450453$var$name = "apply";
var $3e2099e91e450453$var$dependencies = [
    "typed",
    "isInteger"
];
var $3e2099e91e450453$export$5ccffa1686df7f00 = /* #__PURE__ */ (0, $2mPYl.factory)($3e2099e91e450453$var$name, $3e2099e91e450453$var$dependencies, function(_ref) {
    var typed = _ref.typed, isInteger = _ref.isInteger;
    /**
   * Apply a function that maps an array to a scalar
   * along a given axis of a matrix or array.
   * Returns a new matrix or array with one less dimension than the input.
   *
   * Syntax:
   *
   *     math.apply(A, dim, callback)
   *
   * Where:
   *
   * - `dim: number` is a zero-based dimension over which to concatenate the matrices.
   *
   * Examples:
   *
   *    const A = [[1, 2], [3, 4]]
   *    const sum = math.sum
   *
   *    math.apply(A, 0, sum)             // returns [4, 6]
   *    math.apply(A, 1, sum)             // returns [3, 7]
   *
   * See also:
   *
   *    map, filter, forEach
   *
   * @param {Array | Matrix} array   The input Matrix
   * @param {number} dim             The dimension along which the callback is applied
   * @param {Function} callback      The callback function that is applied. This Function
   *                                 should take an array or 1-d matrix as an input and
   *                                 return a number.
   * @return {Array | Matrix} res    The residual matrix with the function applied over some dimension.
   */ var apply = typed($3e2099e91e450453$var$name, {
        "Array | Matrix, number | BigNumber, function": function ArrayMatrixNumberBigNumberFunction(mat, dim, callback) {
            if (!isInteger(dim)) throw new TypeError("Integer number expected for dimension");
            var size = Array.isArray(mat) ? (0, $5WdrK.arraySize)(mat) : mat.size();
            if (dim < 0 || dim >= size.length) throw new (0, $5ITEv.IndexError)(dim, size.length);
            if ((0, $1amHZ.isMatrix)(mat)) return mat.create($3e2099e91e450453$var$_apply(mat.valueOf(), dim, callback));
            else return $3e2099e91e450453$var$_apply(mat, dim, callback);
        }
    });
    return apply;
});
/**
 * Recursively reduce a matrix
 * @param {Array} mat
 * @param {number} dim
 * @param {Function} callback
 * @returns {Array} ret
 * @private
 */ function $3e2099e91e450453$var$_apply(mat, dim, callback) {
    var i, ret, tran;
    if (dim <= 0) {
        if (!Array.isArray(mat[0])) return callback(mat);
        else {
            tran = $3e2099e91e450453$var$_switch(mat);
            ret = [];
            for(i = 0; i < tran.length; i++)ret[i] = $3e2099e91e450453$var$_apply(tran[i], dim - 1, callback);
            return ret;
        }
    } else {
        ret = [];
        for(i = 0; i < mat.length; i++)ret[i] = $3e2099e91e450453$var$_apply(mat[i], dim - 1, callback);
        return ret;
    }
}
/**
 * Transpose a matrix
 * @param {Array} mat
 * @returns {Array} ret
 * @private
 */ function $3e2099e91e450453$var$_switch(mat) {
    var I = mat.length;
    var J = mat[0].length;
    var i, j;
    var ret = [];
    for(j = 0; j < J; j++){
        var tmp = [];
        for(i = 0; i < I; i++)tmp.push(mat[i][j]);
        ret.push(tmp);
    }
    return ret;
}

});


parcelRegister("9YGyY", function(module, exports) {

$parcel$export(module.exports, "createArrayNode", function () { return $743abbc6992bfa03$export$c4666c772dc9bece; });

var $1amHZ = parcelRequire("1amHZ");

var $5WdrK = parcelRequire("5WdrK");

var $2mPYl = parcelRequire("2mPYl");
var $743abbc6992bfa03$var$name = "ArrayNode";
var $743abbc6992bfa03$var$dependencies = [
    "Node"
];
var $743abbc6992bfa03$export$c4666c772dc9bece = /* #__PURE__ */ (0, $2mPYl.factory)($743abbc6992bfa03$var$name, $743abbc6992bfa03$var$dependencies, function(_ref) {
    var Node = _ref.Node;
    /**
   * @constructor ArrayNode
   * @extends {Node}
   * Holds an 1-dimensional array with items
   * @param {Node[]} [items]   1 dimensional array with items
   */ function ArrayNode(items) {
        if (!(this instanceof ArrayNode)) throw new SyntaxError("Constructor must be called with the new operator");
        this.items = items || []; // validate input
        if (!Array.isArray(this.items) || !this.items.every((0, $1amHZ.isNode))) throw new TypeError("Array containing Nodes expected");
         // TODO: deprecated since v3, remove some day
        var deprecated = function deprecated() {
            throw new Error("Property `ArrayNode.nodes` is deprecated, use `ArrayNode.items` instead");
        };
        Object.defineProperty(this, "nodes", {
            get: deprecated,
            set: deprecated
        });
    }
    ArrayNode.prototype = new Node();
    ArrayNode.prototype.type = "ArrayNode";
    ArrayNode.prototype.isArrayNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ ArrayNode.prototype._compile = function(math, argNames) {
        var evalItems = (0, $5WdrK.map)(this.items, function(item) {
            return item._compile(math, argNames);
        });
        var asMatrix = math.config.matrix !== "Array";
        if (asMatrix) {
            var matrix = math.matrix;
            return function evalArrayNode(scope, args, context) {
                return matrix((0, $5WdrK.map)(evalItems, function(evalItem) {
                    return evalItem(scope, args, context);
                }));
            };
        } else return function evalArrayNode(scope, args, context) {
            return (0, $5WdrK.map)(evalItems, function(evalItem) {
                return evalItem(scope, args, context);
            });
        };
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ ArrayNode.prototype.forEach = function(callback) {
        for(var i = 0; i < this.items.length; i++){
            var node = this.items[i];
            callback(node, "items[" + i + "]", this);
        }
    };
    /**
   * Create a new ArrayNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node): Node} callback
   * @returns {ArrayNode} Returns a transformed copy of the node
   */ ArrayNode.prototype.map = function(callback) {
        var items = [];
        for(var i = 0; i < this.items.length; i++)items[i] = this._ifNode(callback(this.items[i], "items[" + i + "]", this));
        return new ArrayNode(items);
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {ArrayNode}
   */ ArrayNode.prototype.clone = function() {
        return new ArrayNode(this.items.slice(0));
    };
    /**
   * Get string representation
   * @param {Object} options
   * @return {string} str
   * @override
   */ ArrayNode.prototype._toString = function(options) {
        var items = this.items.map(function(node) {
            return node.toString(options);
        });
        return "[" + items.join(", ") + "]";
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ ArrayNode.prototype.toJSON = function() {
        return {
            mathjs: "ArrayNode",
            items: this.items
        };
    };
    /**
   * Instantiate an ArrayNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "ArrayNode", items: [...]}`,
   *                       where mathjs is optional
   * @returns {ArrayNode}
   */ ArrayNode.fromJSON = function(json) {
        return new ArrayNode(json.items);
    };
    /**
   * Get HTML representation
   * @param {Object} options
   * @return {string} str
   * @override
   */ ArrayNode.prototype.toHTML = function(options) {
        var items = this.items.map(function(node) {
            return node.toHTML(options);
        });
        return '<span class="math-parenthesis math-square-parenthesis">[</span>' + items.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-square-parenthesis">]</span>';
    };
    /**
   * Get LaTeX representation
   * @param {Object} options
   * @return {string} str
   */ ArrayNode.prototype._toTex = function(options) {
        var s = "\\begin{bmatrix}";
        this.items.forEach(function(node) {
            if (node.items) s += node.items.map(function(childNode) {
                return childNode.toTex(options);
            }).join("&");
            else s += node.toTex(options);
             // new line
            s += "\\\\";
        });
        s += "\\end{bmatrix}";
        return s;
    };
    return ArrayNode;
}, {
    isClass: true,
    isNode: true
});

});

parcelRegister("pvzaC", function(module, exports) {

$parcel$export(module.exports, "createAssignmentNode", function () { return $04cad250f1f6a291$export$1461ecd49f170d54; });

var $1amHZ = parcelRequire("1amHZ");

var $45IYD = parcelRequire("45IYD");

var $2mPYl = parcelRequire("2mPYl");

var $9edVT = parcelRequire("9edVT");

var $dm0L0 = parcelRequire("dm0L0");

var $cAxNq = parcelRequire("cAxNq");
var $04cad250f1f6a291$var$name = "AssignmentNode";
var $04cad250f1f6a291$var$dependencies = [
    "subset",
    "?matrix",
    "Node"
];
var $04cad250f1f6a291$export$1461ecd49f170d54 = /* #__PURE__ */ (0, $2mPYl.factory)($04cad250f1f6a291$var$name, $04cad250f1f6a291$var$dependencies, function(_ref) {
    var subset = _ref.subset, matrix = _ref.matrix, Node = _ref.Node;
    var access = (0, $9edVT.accessFactory)({
        subset: subset
    });
    var assign = (0, $dm0L0.assignFactory)({
        subset: subset,
        matrix: matrix
    });
    /**
   * @constructor AssignmentNode
   * @extends {Node}
   *
   * Define a symbol, like `a=3.2`, update a property like `a.b=3.2`, or
   * replace a subset of a matrix like `A[2,2]=42`.
   *
   * Syntax:
   *
   *     new AssignmentNode(symbol, value)
   *     new AssignmentNode(object, index, value)
   *
   * Usage:
   *
   *    new AssignmentNode(new SymbolNode('a'), new ConstantNode(2))                       // a=2
   *    new AssignmentNode(new SymbolNode('a'), new IndexNode('b'), new ConstantNode(2))   // a.b=2
   *    new AssignmentNode(new SymbolNode('a'), new IndexNode(1, 2), new ConstantNode(3))  // a[1,2]=3
   *
   * @param {SymbolNode | AccessorNode} object  Object on which to assign a value
   * @param {IndexNode} [index=null]            Index, property name or matrix
   *                                            index. Optional. If not provided
   *                                            and `object` is a SymbolNode,
   *                                            the property is assigned to the
   *                                            global scope.
   * @param {Node} value                        The value to be assigned
   */ function AssignmentNode(object, index, value) {
        if (!(this instanceof AssignmentNode)) throw new SyntaxError("Constructor must be called with the new operator");
        this.object = object;
        this.index = value ? index : null;
        this.value = value || index; // validate input
        if (!(0, $1amHZ.isSymbolNode)(object) && !(0, $1amHZ.isAccessorNode)(object)) throw new TypeError('SymbolNode or AccessorNode expected as "object"');
        if ((0, $1amHZ.isSymbolNode)(object) && object.name === "end") throw new Error('Cannot assign to symbol "end"');
        if (this.index && !(0, $1amHZ.isIndexNode)(this.index)) // index is optional
        throw new TypeError('IndexNode expected as "index"');
        if (!(0, $1amHZ.isNode)(this.value)) throw new TypeError('Node expected as "value"');
         // readonly property name
        Object.defineProperty(this, "name", {
            get: (function() {
                if (this.index) return this.index.isObjectProperty() ? this.index.getObjectProperty() : "";
                else return this.object.name || "";
            }).bind(this),
            set: function set() {
                throw new Error("Cannot assign a new name, name is read-only");
            }
        });
    }
    AssignmentNode.prototype = new Node();
    AssignmentNode.prototype.type = "AssignmentNode";
    AssignmentNode.prototype.isAssignmentNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ AssignmentNode.prototype._compile = function(math, argNames) {
        var evalObject = this.object._compile(math, argNames);
        var evalIndex = this.index ? this.index._compile(math, argNames) : null;
        var evalValue = this.value._compile(math, argNames);
        var name = this.object.name;
        if (!this.index) {
            // apply a variable to the scope, for example `a=2`
            if (!(0, $1amHZ.isSymbolNode)(this.object)) throw new TypeError("SymbolNode expected as object");
            return function evalAssignmentNode(scope, args, context) {
                return (0, $45IYD.setSafeProperty)(scope, name, evalValue(scope, args, context));
            };
        } else if (this.index.isObjectProperty()) {
            // apply an object property for example `a.b=2`
            var prop = this.index.getObjectProperty();
            return function evalAssignmentNode(scope, args, context) {
                var object = evalObject(scope, args, context);
                var value = evalValue(scope, args, context);
                return (0, $45IYD.setSafeProperty)(object, prop, value);
            };
        } else if ((0, $1amHZ.isSymbolNode)(this.object)) // update a matrix subset, for example `a[2]=3`
        return function evalAssignmentNode(scope, args, context) {
            var childObject = evalObject(scope, args, context);
            var value = evalValue(scope, args, context);
            var index = evalIndex(scope, args, childObject); // Important:  we pass childObject instead of context
            (0, $45IYD.setSafeProperty)(scope, name, assign(childObject, index, value));
            return value;
        };
        else {
            // isAccessorNode(node.object) === true
            // update a matrix subset, for example `a.b[2]=3`
            // we will not use the compile function of the AccessorNode, but compile it
            // ourselves here as we need the parent object of the AccessorNode:
            // wee need to apply the updated object to parent object
            var evalParentObject = this.object.object._compile(math, argNames);
            if (this.object.index.isObjectProperty()) {
                var parentProp = this.object.index.getObjectProperty();
                return function evalAssignmentNode(scope, args, context) {
                    var parent = evalParentObject(scope, args, context);
                    var childObject = (0, $45IYD.getSafeProperty)(parent, parentProp);
                    var index = evalIndex(scope, args, childObject); // Important: we pass childObject instead of context
                    var value = evalValue(scope, args, context);
                    (0, $45IYD.setSafeProperty)(parent, parentProp, assign(childObject, index, value));
                    return value;
                };
            } else {
                // if some parameters use the 'end' parameter, we need to calculate the size
                var evalParentIndex = this.object.index._compile(math, argNames);
                return function evalAssignmentNode(scope, args, context) {
                    var parent = evalParentObject(scope, args, context);
                    var parentIndex = evalParentIndex(scope, args, parent); // Important: we pass parent instead of context
                    var childObject = access(parent, parentIndex);
                    var index = evalIndex(scope, args, childObject); // Important:  we pass childObject instead of context
                    var value = evalValue(scope, args, context);
                    assign(parent, parentIndex, assign(childObject, index, value));
                    return value;
                };
            }
        }
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ AssignmentNode.prototype.forEach = function(callback) {
        callback(this.object, "object", this);
        if (this.index) callback(this.index, "index", this);
        callback(this.value, "value", this);
    };
    /**
   * Create a new AssignmentNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node): Node} callback
   * @returns {AssignmentNode} Returns a transformed copy of the node
   */ AssignmentNode.prototype.map = function(callback) {
        var object = this._ifNode(callback(this.object, "object", this));
        var index = this.index ? this._ifNode(callback(this.index, "index", this)) : null;
        var value = this._ifNode(callback(this.value, "value", this));
        return new AssignmentNode(object, index, value);
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {AssignmentNode}
   */ AssignmentNode.prototype.clone = function() {
        return new AssignmentNode(this.object, this.index, this.value);
    };
    /*
   * Is parenthesis needed?
   * @param {node} node
   * @param {string} [parenthesis='keep']
   * @private
   */ function needParenthesis(node, parenthesis) {
        if (!parenthesis) parenthesis = "keep";
        var precedence = (0, $cAxNq.getPrecedence)(node, parenthesis);
        var exprPrecedence = (0, $cAxNq.getPrecedence)(node.value, parenthesis);
        return parenthesis === "all" || exprPrecedence !== null && exprPrecedence <= precedence;
    }
    /**
   * Get string representation
   * @param {Object} options
   * @return {string}
   */ AssignmentNode.prototype._toString = function(options) {
        var object = this.object.toString(options);
        var index = this.index ? this.index.toString(options) : "";
        var value = this.value.toString(options);
        if (needParenthesis(this, options && options.parenthesis)) value = "(" + value + ")";
        return object + index + " = " + value;
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ AssignmentNode.prototype.toJSON = function() {
        return {
            mathjs: "AssignmentNode",
            object: this.object,
            index: this.index,
            value: this.value
        };
    };
    /**
   * Instantiate an AssignmentNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "AssignmentNode", object: ..., index: ..., value: ...}`,
   *                       where mathjs is optional
   * @returns {AssignmentNode}
   */ AssignmentNode.fromJSON = function(json) {
        return new AssignmentNode(json.object, json.index, json.value);
    };
    /**
   * Get HTML representation
   * @param {Object} options
   * @return {string}
   */ AssignmentNode.prototype.toHTML = function(options) {
        var object = this.object.toHTML(options);
        var index = this.index ? this.index.toHTML(options) : "";
        var value = this.value.toHTML(options);
        if (needParenthesis(this, options && options.parenthesis)) value = '<span class="math-paranthesis math-round-parenthesis">(</span>' + value + '<span class="math-paranthesis math-round-parenthesis">)</span>';
        return object + index + '<span class="math-operator math-assignment-operator math-variable-assignment-operator math-binary-operator">=</span>' + value;
    };
    /**
   * Get LaTeX representation
   * @param {Object} options
   * @return {string}
   */ AssignmentNode.prototype._toTex = function(options) {
        var object = this.object.toTex(options);
        var index = this.index ? this.index.toTex(options) : "";
        var value = this.value.toTex(options);
        if (needParenthesis(this, options && options.parenthesis)) value = "\\left(".concat(value, "\\right)");
        return object + index + ":=" + value;
    };
    return AssignmentNode;
}, {
    isClass: true,
    isNode: true
});

});
parcelRegister("dm0L0", function(module, exports) {

$parcel$export(module.exports, "assignFactory", function () { return $9b8deacd6b8c3310$export$796df36381b10d7d; });

var $dJ38g = parcelRequire("dJ38g");

var $45IYD = parcelRequire("45IYD");
function $9b8deacd6b8c3310$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $9b8deacd6b8c3310$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $9b8deacd6b8c3310$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $9b8deacd6b8c3310$var$_typeof(obj);
}
function $9b8deacd6b8c3310$export$796df36381b10d7d(_ref) {
    var subset = _ref.subset, matrix = _ref.matrix;
    /**
   * Replace part of an object:
   *
   * - Assign a property to an object
   * - Replace a part of a string
   * - Replace a matrix subset
   *
   * @param {Object | Array | Matrix | string} object
   * @param {Index} index
   * @param {*} value
   * @return {Object | Array | Matrix | string} Returns the original object
   *                                            except in case of a string
   */ // TODO: change assign to return the value instead of the object
    return function assign(object, index, value) {
        try {
            if (Array.isArray(object)) // we use matrix.subset here instead of the function subset because we must not clone the contents
            return matrix(object).subset(index, value).valueOf();
            else if (object && typeof object.subset === "function") // Matrix
            return object.subset(index, value);
            else if (typeof object === "string") // TODO: move setStringSubset into a separate util file, use that
            return subset(object, index, value);
            else if ($9b8deacd6b8c3310$var$_typeof(object) === "object") {
                if (!index.isObjectProperty()) throw TypeError("Cannot apply a numeric index as object property");
                (0, $45IYD.setSafeProperty)(object, index.getObjectProperty(), value);
                return object;
            } else throw new TypeError("Cannot apply index: unsupported type of object");
        } catch (err) {
            throw (0, $dJ38g.errorTransform)(err);
        }
    };
}

});

parcelRegister("cAxNq", function(module, exports) {

$parcel$export(module.exports, "properties", function () { return $92a310090b3e41df$export$3cb21709c4058847; });
$parcel$export(module.exports, "getPrecedence", function () { return $92a310090b3e41df$export$94314bea1477f3d5; });
$parcel$export(module.exports, "getAssociativity", function () { return $92a310090b3e41df$export$8a3de49886b85474; });
$parcel$export(module.exports, "isAssociativeWith", function () { return $92a310090b3e41df$export$b539869f53b6850a; });
// list of identifiers of nodes in order of their precedence
// also contains information about left/right associativity
// and which other operator the operator is associative with
// Example:
// addition is associative with addition and subtraction, because:
// (a+b)+c=a+(b+c)
// (a+b)-c=a+(b-c)
//
// postfix operators are left associative, prefix operators
// are right associative
//
// It's also possible to set the following properties:
// latexParens: if set to false, this node doesn't need to be enclosed
//              in parentheses when using LaTeX
// latexLeftParens: if set to false, this !OperatorNode's!
//                  left argument doesn't need to be enclosed
//                  in parentheses
// latexRightParens: the same for the right argument

var $7ITGG = parcelRequire("7ITGG");
var $92a310090b3e41df$export$3cb21709c4058847 = [
    {
        // assignment
        AssignmentNode: {},
        FunctionAssignmentNode: {}
    },
    {
        // conditional expression
        ConditionalNode: {
            latexLeftParens: false,
            latexRightParens: false,
            latexParens: false // conditionals don't need parentheses in LaTeX because
        }
    },
    {
        // logical or
        "OperatorNode:or": {
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // logical xor
        "OperatorNode:xor": {
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // logical and
        "OperatorNode:and": {
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // bitwise or
        "OperatorNode:bitOr": {
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // bitwise xor
        "OperatorNode:bitXor": {
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // bitwise and
        "OperatorNode:bitAnd": {
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // relational operators
        "OperatorNode:equal": {
            associativity: "left",
            associativeWith: []
        },
        "OperatorNode:unequal": {
            associativity: "left",
            associativeWith: []
        },
        "OperatorNode:smaller": {
            associativity: "left",
            associativeWith: []
        },
        "OperatorNode:larger": {
            associativity: "left",
            associativeWith: []
        },
        "OperatorNode:smallerEq": {
            associativity: "left",
            associativeWith: []
        },
        "OperatorNode:largerEq": {
            associativity: "left",
            associativeWith: []
        },
        RelationalNode: {
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // bitshift operators
        "OperatorNode:leftShift": {
            associativity: "left",
            associativeWith: []
        },
        "OperatorNode:rightArithShift": {
            associativity: "left",
            associativeWith: []
        },
        "OperatorNode:rightLogShift": {
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // unit conversion
        "OperatorNode:to": {
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // range
        RangeNode: {}
    },
    {
        // addition, subtraction
        "OperatorNode:add": {
            associativity: "left",
            associativeWith: [
                "OperatorNode:add",
                "OperatorNode:subtract"
            ]
        },
        "OperatorNode:subtract": {
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // multiply, divide, modulus
        "OperatorNode:multiply": {
            associativity: "left",
            associativeWith: [
                "OperatorNode:multiply",
                "OperatorNode:divide",
                "Operator:dotMultiply",
                "Operator:dotDivide"
            ]
        },
        "OperatorNode:divide": {
            associativity: "left",
            associativeWith: [],
            latexLeftParens: false,
            latexRightParens: false,
            latexParens: false // fractions don't require parentheses because
        },
        "OperatorNode:dotMultiply": {
            associativity: "left",
            associativeWith: [
                "OperatorNode:multiply",
                "OperatorNode:divide",
                "OperatorNode:dotMultiply",
                "OperatorNode:doDivide"
            ]
        },
        "OperatorNode:dotDivide": {
            associativity: "left",
            associativeWith: []
        },
        "OperatorNode:mod": {
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // unary prefix operators
        "OperatorNode:unaryPlus": {
            associativity: "right"
        },
        "OperatorNode:unaryMinus": {
            associativity: "right"
        },
        "OperatorNode:bitNot": {
            associativity: "right"
        },
        "OperatorNode:not": {
            associativity: "right"
        }
    },
    {
        // exponentiation
        "OperatorNode:pow": {
            associativity: "right",
            associativeWith: [],
            latexRightParens: false // the exponent doesn't need parentheses in
        },
        "OperatorNode:dotPow": {
            associativity: "right",
            associativeWith: []
        }
    },
    {
        // factorial
        "OperatorNode:factorial": {
            associativity: "left"
        }
    },
    {
        // matrix transpose
        "OperatorNode:transpose": {
            associativity: "left"
        }
    }
];
function $92a310090b3e41df$export$94314bea1477f3d5(_node, parenthesis) {
    var node = _node;
    if (parenthesis !== "keep") // ParenthesisNodes are only ignored when not in 'keep' mode
    node = _node.getContent();
    var identifier = node.getIdentifier();
    for(var i = 0; i < $92a310090b3e41df$export$3cb21709c4058847.length; i++){
        if (identifier in $92a310090b3e41df$export$3cb21709c4058847[i]) return i;
    }
    return null;
}
function $92a310090b3e41df$export$8a3de49886b85474(_node, parenthesis) {
    var node = _node;
    if (parenthesis !== "keep") // ParenthesisNodes are only ignored when not in 'keep' mode
    node = _node.getContent();
    var identifier = node.getIdentifier();
    var index = $92a310090b3e41df$export$94314bea1477f3d5(node, parenthesis);
    if (index === null) // node isn't in the list
    return null;
    var property = $92a310090b3e41df$export$3cb21709c4058847[index][identifier];
    if ((0, $7ITGG.hasOwnProperty)(property, "associativity")) {
        if (property.associativity === "left") return "left";
        if (property.associativity === "right") return "right";
         // associativity is invalid
        throw Error("'" + identifier + "' has the invalid associativity '" + property.associativity + "'.");
    } // associativity is undefined
    return null;
}
function $92a310090b3e41df$export$b539869f53b6850a(nodeA, nodeB, parenthesis) {
    // ParenthesisNodes are only ignored when not in 'keep' mode
    var a = parenthesis !== "keep" ? nodeA.getContent() : nodeA;
    var b = parenthesis !== "keep" ? nodeA.getContent() : nodeB;
    var identifierA = a.getIdentifier();
    var identifierB = b.getIdentifier();
    var index = $92a310090b3e41df$export$94314bea1477f3d5(a, parenthesis);
    if (index === null) // node isn't in the list
    return null;
    var property = $92a310090b3e41df$export$3cb21709c4058847[index][identifierA];
    if ((0, $7ITGG.hasOwnProperty)(property, "associativeWith") && property.associativeWith instanceof Array) {
        for(var i = 0; i < property.associativeWith.length; i++){
            if (property.associativeWith[i] === identifierB) return true;
        }
        return false;
    } // associativeWith is not defined
    return null;
}

});


parcelRegister("fHFIO", function(module, exports) {

$parcel$export(module.exports, "createBlockNode", function () { return $b6eb3c3f76e3f68b$export$850df8ca0896c9ef; });

var $1amHZ = parcelRequire("1amHZ");

var $5WdrK = parcelRequire("5WdrK");

var $2mPYl = parcelRequire("2mPYl");
var $b6eb3c3f76e3f68b$var$name = "BlockNode";
var $b6eb3c3f76e3f68b$var$dependencies = [
    "ResultSet",
    "Node"
];
var $b6eb3c3f76e3f68b$export$850df8ca0896c9ef = /* #__PURE__ */ (0, $2mPYl.factory)($b6eb3c3f76e3f68b$var$name, $b6eb3c3f76e3f68b$var$dependencies, function(_ref) {
    var ResultSet = _ref.ResultSet, Node = _ref.Node;
    /**
   * @constructor BlockNode
   * @extends {Node}
   * Holds a set with blocks
   * @param {Array.<{node: Node} | {node: Node, visible: boolean}>} blocks
   *            An array with blocks, where a block is constructed as an Object
   *            with properties block, which is a Node, and visible, which is
   *            a boolean. The property visible is optional and is true by default
   */ function BlockNode(blocks) {
        if (!(this instanceof BlockNode)) throw new SyntaxError("Constructor must be called with the new operator");
         // validate input, copy blocks
        if (!Array.isArray(blocks)) throw new Error("Array expected");
        this.blocks = blocks.map(function(block) {
            var node = block && block.node;
            var visible = block && block.visible !== undefined ? block.visible : true;
            if (!(0, $1amHZ.isNode)(node)) throw new TypeError('Property "node" must be a Node');
            if (typeof visible !== "boolean") throw new TypeError('Property "visible" must be a boolean');
            return {
                node: node,
                visible: visible
            };
        });
    }
    BlockNode.prototype = new Node();
    BlockNode.prototype.type = "BlockNode";
    BlockNode.prototype.isBlockNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ BlockNode.prototype._compile = function(math, argNames) {
        var evalBlocks = (0, $5WdrK.map)(this.blocks, function(block) {
            return {
                evaluate: block.node._compile(math, argNames),
                visible: block.visible
            };
        });
        return function evalBlockNodes(scope, args, context) {
            var results = [];
            (0, $5WdrK.forEach)(evalBlocks, function evalBlockNode(block) {
                var result = block.evaluate(scope, args, context);
                if (block.visible) results.push(result);
            });
            return new ResultSet(results);
        };
    };
    /**
   * Execute a callback for each of the child blocks of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ BlockNode.prototype.forEach = function(callback) {
        for(var i = 0; i < this.blocks.length; i++)callback(this.blocks[i].node, "blocks[" + i + "].node", this);
    };
    /**
   * Create a new BlockNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node): Node} callback
   * @returns {BlockNode} Returns a transformed copy of the node
   */ BlockNode.prototype.map = function(callback) {
        var blocks = [];
        for(var i = 0; i < this.blocks.length; i++){
            var block = this.blocks[i];
            var node = this._ifNode(callback(block.node, "blocks[" + i + "].node", this));
            blocks[i] = {
                node: node,
                visible: block.visible
            };
        }
        return new BlockNode(blocks);
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {BlockNode}
   */ BlockNode.prototype.clone = function() {
        var blocks = this.blocks.map(function(block) {
            return {
                node: block.node,
                visible: block.visible
            };
        });
        return new BlockNode(blocks);
    };
    /**
   * Get string representation
   * @param {Object} options
   * @return {string} str
   * @override
   */ BlockNode.prototype._toString = function(options) {
        return this.blocks.map(function(param) {
            return param.node.toString(options) + (param.visible ? "" : ";");
        }).join("\n");
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ BlockNode.prototype.toJSON = function() {
        return {
            mathjs: "BlockNode",
            blocks: this.blocks
        };
    };
    /**
   * Instantiate an BlockNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "BlockNode", blocks: [{node: ..., visible: false}, ...]}`,
   *                       where mathjs is optional
   * @returns {BlockNode}
   */ BlockNode.fromJSON = function(json) {
        return new BlockNode(json.blocks);
    };
    /**
   * Get HTML representation
   * @param {Object} options
   * @return {string} str
   * @override
   */ BlockNode.prototype.toHTML = function(options) {
        return this.blocks.map(function(param) {
            return param.node.toHTML(options) + (param.visible ? "" : '<span class="math-separator">;</span>');
        }).join('<span class="math-separator"><br /></span>');
    };
    /**
   * Get LaTeX representation
   * @param {Object} options
   * @return {string} str
   */ BlockNode.prototype._toTex = function(options) {
        return this.blocks.map(function(param) {
            return param.node.toTex(options) + (param.visible ? "" : ";");
        }).join("\\;\\;\n");
    };
    return BlockNode;
}, {
    isClass: true,
    isNode: true
});

});

parcelRegister("43buJ", function(module, exports) {

$parcel$export(module.exports, "createChain", function () { return $2f305bd0c511d31f$export$3ffb1c732bc8392d; });

var $2mPYl = parcelRequire("2mPYl");
var $2f305bd0c511d31f$var$name = "chain";
var $2f305bd0c511d31f$var$dependencies = [
    "typed",
    "Chain"
];
var $2f305bd0c511d31f$export$3ffb1c732bc8392d = /* #__PURE__ */ (0, $2mPYl.factory)($2f305bd0c511d31f$var$name, $2f305bd0c511d31f$var$dependencies, function(_ref) {
    var typed = _ref.typed, Chain = _ref.Chain;
    /**
   * Wrap any value in a chain, allowing to perform chained operations on
   * the value.
   *
   * All methods available in the math.js library can be called upon the chain,
   * and then will be evaluated with the value itself as first argument.
   * The chain can be closed by executing `chain.done()`, which returns
   * the final value.
   *
   * The chain has a number of special functions:
   *
   * - `done()`     Finalize the chain and return the chain's value.
   * - `valueOf()`  The same as `done()`
   * - `toString()` Executes `math.format()` onto the chain's value, returning
   *                a string representation of the value.
   *
   * Syntax:
   *
   *    math.chain(value)
   *
   * Examples:
   *
   *     math.chain(3)
   *         .add(4)
   *         .subtract(2)
   *         .done()     // 5
   *
   *     math.chain( [[1, 2], [3, 4]] )
   *         .subset(math.index(0, 0), 8)
   *         .multiply(3)
   *         .done()     // [[24, 6], [9, 12]]
   *
   * @param {*} [value]   A value of any type on which to start a chained operation.
   * @return {math.Chain} The created chain
   */ return typed($2f305bd0c511d31f$var$name, {
        "": function _() {
            return new Chain();
        },
        any: function any(value) {
            return new Chain(value);
        }
    });
});

});

parcelRegister("fM22c", function(module, exports) {

$parcel$export(module.exports, "createChainClass", function () { return $b7bceabcccb14033$export$1aeed9ab2df4999f; });

var $1amHZ = parcelRequire("1amHZ");

var $6NxuJ = parcelRequire("6NxuJ");

var $7ITGG = parcelRequire("7ITGG");

var $2mPYl = parcelRequire("2mPYl");
var $b7bceabcccb14033$var$name = "Chain";
var $b7bceabcccb14033$var$dependencies = [
    "?on",
    "math"
];
var $b7bceabcccb14033$export$1aeed9ab2df4999f = /* #__PURE__ */ (0, $2mPYl.factory)($b7bceabcccb14033$var$name, $b7bceabcccb14033$var$dependencies, function(_ref) {
    var on = _ref.on, math = _ref.math;
    /**
   * @constructor Chain
   * Wrap any value in a chain, allowing to perform chained operations on
   * the value.
   *
   * All methods available in the math.js library can be called upon the chain,
   * and then will be evaluated with the value itself as first argument.
   * The chain can be closed by executing chain.done(), which will return
   * the final value.
   *
   * The Chain has a number of special functions:
   * - done()             Finalize the chained operation and return the
   *                      chain's value.
   * - valueOf()          The same as done()
   * - toString()         Returns a string representation of the chain's value.
   *
   * @param {*} [value]
   */ function Chain(value) {
        if (!(this instanceof Chain)) throw new SyntaxError("Constructor must be called with the new operator");
        if ((0, $1amHZ.isChain)(value)) this.value = value.value;
        else this.value = value;
    }
    /**
   * Attach type information
   */ Chain.prototype.type = "Chain";
    Chain.prototype.isChain = true;
    /**
   * Close the chain. Returns the final value.
   * Does the same as method valueOf()
   * @returns {*} value
   */ Chain.prototype.done = function() {
        return this.value;
    };
    /**
   * Close the chain. Returns the final value.
   * Does the same as method done()
   * @returns {*} value
   */ Chain.prototype.valueOf = function() {
        return this.value;
    };
    /**
   * Get a string representation of the value in the chain
   * @returns {string}
   */ Chain.prototype.toString = function() {
        return (0, $6NxuJ.format)(this.value);
    };
    /**
   * Get a JSON representation of the chain
   * @returns {Object}
   */ Chain.prototype.toJSON = function() {
        return {
            mathjs: "Chain",
            value: this.value
        };
    };
    /**
   * Instantiate a Chain from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "Chain", value: ...}`,
   *                       where mathjs is optional
   * @returns {Chain}
   */ Chain.fromJSON = function(json) {
        return new Chain(json.value);
    };
    /**
   * Create a proxy method for the chain
   * @param {string} name
   * @param {Function} fn      The function to be proxied
   *                           If fn is no function, it is silently ignored.
   * @private
   */ function createProxy(name, fn) {
        if (typeof fn === "function") Chain.prototype[name] = chainify(fn);
    }
    /**
   * Create a proxy method for the chain
   * @param {string} name
   * @param {function} resolver   The function resolving with the
   *                              function to be proxied
   * @private
   */ function createLazyProxy(name, resolver) {
        (0, $7ITGG.lazy)(Chain.prototype, name, function outerResolver() {
            var fn = resolver();
            if (typeof fn === "function") return chainify(fn);
            return undefined; // if not a function, ignore
        });
    }
    /**
   * Make a function chainable
   * @param {function} fn
   * @return {Function} chain function
   * @private
   */ function chainify(fn) {
        return function() {
            var args = [
                this.value
            ]; // `this` will be the context of a Chain instance
            for(var i = 0; i < arguments.length; i++)args[i + 1] = arguments[i];
            return new Chain(fn.apply(fn, args));
        };
    }
    /**
   * Create a proxy for a single method, or an object with multiple methods.
   * Example usage:
   *
   *   Chain.createProxy('add', function add (x, y) {...})
   *   Chain.createProxy({
   *     add:      function add (x, y) {...},
   *     subtract: function subtract (x, y) {...}
   *   }
   *
   * @param {string | Object} arg0   A name (string), or an object with
   *                                 functions
   * @param {*} [arg1]               A function, when arg0 is a name
   */ Chain.createProxy = function(arg0, arg1) {
        if (typeof arg0 === "string") // createProxy(name, value)
        createProxy(arg0, arg1);
        else {
            var _loop = function _loop(_name) {
                if ((0, $7ITGG.hasOwnProperty)(arg0, _name) && excludedNames[_name] === undefined) createLazyProxy(_name, function() {
                    return arg0[_name];
                });
            };
            // createProxy(values)
            for(var _name in arg0)_loop(_name);
        }
    };
    var excludedNames = {
        expression: true,
        docs: true,
        type: true,
        classes: true,
        json: true,
        error: true,
        isChain: true // conflicts with the property isChain of a Chain instance
    }; // create proxy for everything that is in math.js
    Chain.createProxy(math); // register on the import event, automatically add a proxy for every imported function.
    if (on) on("import", function(name, resolver, path) {
        if (!path) // an imported function (not a data type or something special)
        createLazyProxy(name, resolver);
    });
    return Chain;
}, {
    isClass: true
});

});

parcelRegister("9Z8BS", function(module, exports) {

$parcel$export(module.exports, "createColumnTransform", function () { return $74507d508da965b5$export$cb052a3b92a960e; });

var $dJ38g = parcelRequire("dJ38g");

var $2mPYl = parcelRequire("2mPYl");

var $kMxeC = parcelRequire("kMxeC");

var $1amHZ = parcelRequire("1amHZ");
var $74507d508da965b5$var$name = "column";
var $74507d508da965b5$var$dependencies = [
    "typed",
    "Index",
    "matrix",
    "range"
];
var $74507d508da965b5$export$cb052a3b92a960e = /* #__PURE__ */ (0, $2mPYl.factory)($74507d508da965b5$var$name, $74507d508da965b5$var$dependencies, function(_ref) {
    var typed = _ref.typed, Index = _ref.Index, matrix = _ref.matrix, range = _ref.range;
    var column = (0, $kMxeC.createColumn)({
        typed: typed,
        Index: Index,
        matrix: matrix,
        range: range
    }); // @see: comment of column itself
    return typed("column", {
        "...any": function any(args) {
            // change last argument from zero-based to one-based
            var lastIndex = args.length - 1;
            var last = args[lastIndex];
            if ((0, $1amHZ.isNumber)(last)) args[lastIndex] = last - 1;
            try {
                return column.apply(null, args);
            } catch (err) {
                throw (0, $dJ38g.errorTransform)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});

});
parcelRegister("kMxeC", function(module, exports) {

$parcel$export(module.exports, "createColumn", function () { return $f21212133f77e1fa$export$1bfa986e9c92c0b5; });

var $2mPYl = parcelRequire("2mPYl");

var $7ITGG = parcelRequire("7ITGG");

var $5WdrK = parcelRequire("5WdrK");
var $f21212133f77e1fa$var$name = "column";
var $f21212133f77e1fa$var$dependencies = [
    "typed",
    "Index",
    "matrix",
    "range"
];
var $f21212133f77e1fa$export$1bfa986e9c92c0b5 = /* #__PURE__ */ (0, $2mPYl.factory)($f21212133f77e1fa$var$name, $f21212133f77e1fa$var$dependencies, function(_ref) {
    var typed = _ref.typed, Index = _ref.Index, matrix = _ref.matrix, range = _ref.range;
    /**
   * Return a column from a Matrix.
   *
   * Syntax:
   *
   *     math.column(value, index)
   *
   * Example:
   *
   *     // get a column
   *     const d = [[1, 2], [3, 4]]
   *     math.column(d, 1) // returns [[2], [4]]
   *
   * See also:
   *
   *     row
   *
   * @param {Array | Matrix } value   An array or matrix
   * @param {number} column           The index of the column
   * @return {Array | Matrix}         The retrieved column
   */ var column = typed($f21212133f77e1fa$var$name, {
        "Matrix, number": _column,
        "Array, number": function ArrayNumber(value, column) {
            return _column(matrix((0, $7ITGG.clone)(value)), column).valueOf();
        }
    });
    return column;
    /**
   * Retrieve a column of a matrix
   * @param {Matrix } value  A matrix
   * @param {number} column  The index of the column
   * @return {Matrix}        The retrieved column
   */ function _column(value, column) {
        // check dimensions
        if (value.size().length !== 2) throw new Error("Only two dimensional matrix is supported");
        (0, $5WdrK.validateIndex)(column, value.size()[1]);
        var rowRange = range(0, value.size()[0]);
        var index = new Index(rowRange, column);
        return value.subset(index);
    }
});

});


parcelRegister("gOTg6", function(module, exports) {

$parcel$export(module.exports, "createCompile", function () { return $0328f87c321b47e6$export$6c15201c8dbd106f; });

var $e04i1 = parcelRequire("e04i1");

var $2mPYl = parcelRequire("2mPYl");
var $0328f87c321b47e6$var$name = "compile";
var $0328f87c321b47e6$var$dependencies = [
    "typed",
    "parse"
];
var $0328f87c321b47e6$export$6c15201c8dbd106f = /* #__PURE__ */ (0, $2mPYl.factory)($0328f87c321b47e6$var$name, $0328f87c321b47e6$var$dependencies, function(_ref) {
    var typed = _ref.typed, parse = _ref.parse;
    /**
   * Parse and compile an expression.
   * Returns a an object with a function `evaluate([scope])` to evaluate the
   * compiled expression.
   *
   * Syntax:
   *
   *     math.compile(expr)                       // returns one node
   *     math.compile([expr1, expr2, expr3, ...]) // returns an array with nodes
   *
   * Examples:
   *
   *     const code1 = math.compile('sqrt(3^2 + 4^2)')
   *     code1.evaluate() // 5
   *
   *     let scope = {a: 3, b: 4}
   *     const code2 = math.compile('a * b') // 12
   *     code2.evaluate(scope) // 12
   *     scope.a = 5
   *     code2.evaluate(scope) // 20
   *
   *     const nodes = math.compile(['a = 3', 'b = 4', 'a * b'])
   *     nodes[2].evaluate() // 12
   *
   * See also:
   *
   *    parse, evaluate
   *
   * @param {string | string[] | Array | Matrix} expr
   *            The expression to be compiled
   * @return {{evaluate: Function} | Array.<{evaluate: Function}>} code
   *            An object with the compiled expression
   * @throws {Error}
   */ return typed($0328f87c321b47e6$var$name, {
        string: function string(expr) {
            return parse(expr).compile();
        },
        "Array | Matrix": function ArrayMatrix(expr) {
            return (0, $e04i1.deepMap)(expr, function(entry) {
                return parse(entry).compile();
            });
        }
    });
});

});
parcelRegister("e04i1", function(module, exports) {

$parcel$export(module.exports, "containsCollections", function () { return $a314649e89ba10b9$export$4d8f6a27e2f5bcb2; });
$parcel$export(module.exports, "deepForEach", function () { return $a314649e89ba10b9$export$519ada94592b97fc; });
$parcel$export(module.exports, "deepMap", function () { return $a314649e89ba10b9$export$ce7eaaed37329a1b; });
$parcel$export(module.exports, "reduce", function () { return $a314649e89ba10b9$export$533b26079ad0b4b; });
$parcel$export(module.exports, "scatter", function () { return $a314649e89ba10b9$export$c97954fff4307550; });

var $1amHZ = parcelRequire("1amHZ");

var $5ITEv = parcelRequire("5ITEv");

var $5WdrK = parcelRequire("5WdrK");
function $a314649e89ba10b9$export$4d8f6a27e2f5bcb2(array) {
    for(var i = 0; i < array.length; i++){
        if ((0, $1amHZ.isCollection)(array[i])) return true;
    }
    return false;
}
function $a314649e89ba10b9$export$519ada94592b97fc(array, callback) {
    if ((0, $1amHZ.isMatrix)(array)) array = array.valueOf();
    for(var i = 0, ii = array.length; i < ii; i++){
        var value = array[i];
        if (Array.isArray(value)) $a314649e89ba10b9$export$519ada94592b97fc(value, callback);
        else callback(value);
    }
}
function $a314649e89ba10b9$export$ce7eaaed37329a1b(array, callback, skipZeros) {
    if (array && typeof array.map === "function") // TODO: replace array.map with a for loop to improve performance
    return array.map(function(x) {
        return $a314649e89ba10b9$export$ce7eaaed37329a1b(x, callback, skipZeros);
    });
    else return callback(array);
}
function $a314649e89ba10b9$export$533b26079ad0b4b(mat, dim, callback) {
    var size = Array.isArray(mat) ? (0, $5WdrK.arraySize)(mat) : mat.size();
    if (dim < 0 || dim >= size.length) // TODO: would be more clear when throwing a DimensionError here
    throw new (0, $5ITEv.IndexError)(dim, size.length);
    if ((0, $1amHZ.isMatrix)(mat)) return mat.create($a314649e89ba10b9$var$_reduce(mat.valueOf(), dim, callback));
    else return $a314649e89ba10b9$var$_reduce(mat, dim, callback);
}
/**
 * Recursively reduce a matrix
 * @param {Array} mat
 * @param {number} dim
 * @param {Function} callback
 * @returns {Array} ret
 * @private
 */ function $a314649e89ba10b9$var$_reduce(mat, dim, callback) {
    var i, ret, val, tran;
    if (dim <= 0) {
        if (!Array.isArray(mat[0])) {
            val = mat[0];
            for(i = 1; i < mat.length; i++)val = callback(val, mat[i]);
            return val;
        } else {
            tran = $a314649e89ba10b9$var$_switch(mat);
            ret = [];
            for(i = 0; i < tran.length; i++)ret[i] = $a314649e89ba10b9$var$_reduce(tran[i], dim - 1, callback);
            return ret;
        }
    } else {
        ret = [];
        for(i = 0; i < mat.length; i++)ret[i] = $a314649e89ba10b9$var$_reduce(mat[i], dim - 1, callback);
        return ret;
    }
}
/**
 * Transpose a matrix
 * @param {Array} mat
 * @returns {Array} ret
 * @private
 */ function $a314649e89ba10b9$var$_switch(mat) {
    var I = mat.length;
    var J = mat[0].length;
    var i, j;
    var ret = [];
    for(j = 0; j < J; j++){
        var tmp = [];
        for(i = 0; i < I; i++)tmp.push(mat[i][j]);
        ret.push(tmp);
    }
    return ret;
} // TODO: document function scatter
function $a314649e89ba10b9$export$c97954fff4307550(a, j, w, x, u, mark, cindex, f, inverse, update, value) {
    // a arrays
    var avalues = a._values;
    var aindex = a._index;
    var aptr = a._ptr; // vars
    var k, k0, k1, i; // check we need to process values (pattern matrix)
    if (x) // values in j
    for(k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
        // row
        i = aindex[k]; // check value exists in current j
        if (w[i] !== mark) {
            // i is new entry in j
            w[i] = mark; // add i to pattern of C
            cindex.push(i); // x(i) = A, check we need to call function this time
            if (update) {
                // copy value to workspace calling callback function
                x[i] = inverse ? f(avalues[k], value) : f(value, avalues[k]); // function was called on current row
                u[i] = mark;
            } else // copy value to workspace
            x[i] = avalues[k];
        } else {
            // i exists in C already
            x[i] = inverse ? f(avalues[k], x[i]) : f(x[i], avalues[k]); // function was called on current row
            u[i] = mark;
        }
    }
    else // values in j
    for(k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
        // row
        i = aindex[k]; // check value exists in current j
        if (w[i] !== mark) {
            // i is new entry in j
            w[i] = mark; // add i to pattern of C
            cindex.push(i);
        } else // indicate function was called on current row
        u[i] = mark;
    }
}

});


parcelRegister("gC4ea", function(module, exports) {

$parcel$export(module.exports, "createConcatTransform", function () { return $c183796c012be845$export$3571c61ed942e965; });

var $1amHZ = parcelRequire("1amHZ");

var $dJ38g = parcelRequire("dJ38g");

var $2mPYl = parcelRequire("2mPYl");

var $28Jrs = parcelRequire("28Jrs");
var $c183796c012be845$var$name = "concat";
var $c183796c012be845$var$dependencies = [
    "typed",
    "matrix",
    "isInteger"
];
var $c183796c012be845$export$3571c61ed942e965 = /* #__PURE__ */ (0, $2mPYl.factory)($c183796c012be845$var$name, $c183796c012be845$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, isInteger = _ref.isInteger;
    var concat = (0, $28Jrs.createConcat)({
        typed: typed,
        matrix: matrix,
        isInteger: isInteger
    });
    /**
   * Attach a transform function to math.range
   * Adds a property transform containing the transform function.
   *
   * This transform changed the last `dim` parameter of function concat
   * from one-based to zero based
   */ return typed("concat", {
        "...any": function any(args) {
            // change last argument from one-based to zero-based
            var lastIndex = args.length - 1;
            var last = args[lastIndex];
            if ((0, $1amHZ.isNumber)(last)) args[lastIndex] = last - 1;
            else if ((0, $1amHZ.isBigNumber)(last)) args[lastIndex] = last.minus(1);
            try {
                return concat.apply(null, args);
            } catch (err) {
                throw (0, $dJ38g.errorTransform)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});

});
parcelRegister("28Jrs", function(module, exports) {

$parcel$export(module.exports, "createConcat", function () { return $18ef93ec6cfcf56e$export$c36b5511b12560e8; });

var $1amHZ = parcelRequire("1amHZ");

var $7ITGG = parcelRequire("7ITGG");

var $5WdrK = parcelRequire("5WdrK");

var $5ITEv = parcelRequire("5ITEv");

var $hy7Bx = parcelRequire("hy7Bx");

var $2mPYl = parcelRequire("2mPYl");
var $18ef93ec6cfcf56e$var$name = "concat";
var $18ef93ec6cfcf56e$var$dependencies = [
    "typed",
    "matrix",
    "isInteger"
];
var $18ef93ec6cfcf56e$export$c36b5511b12560e8 = /* #__PURE__ */ (0, $2mPYl.factory)($18ef93ec6cfcf56e$var$name, $18ef93ec6cfcf56e$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, isInteger = _ref.isInteger;
    /**
   * Concatenate two or more matrices.
   *
   * Syntax:
   *
   *     math.concat(A, B, C, ...)
   *     math.concat(A, B, C, ..., dim)
   *
   * Where:
   *
   * - `dim: number` is a zero-based dimension over which to concatenate the matrices.
   *   By default the last dimension of the matrices.
   *
   * Examples:
   *
   *    const A = [[1, 2], [5, 6]]
   *    const B = [[3, 4], [7, 8]]
   *
   *    math.concat(A, B)                  // returns [[1, 2, 3, 4], [5, 6, 7, 8]]
   *    math.concat(A, B, 0)               // returns [[1, 2], [5, 6], [3, 4], [7, 8]]
   *    math.concat('hello', ' ', 'world') // returns 'hello world'
   *
   * See also:
   *
   *    size, squeeze, subset, transpose
   *
   * @param {... Array | Matrix} args     Two or more matrices
   * @return {Array | Matrix} Concatenated matrix
   */ return typed($18ef93ec6cfcf56e$var$name, {
        // TODO: change signature to '...Array | Matrix, dim?' when supported
        "...Array | Matrix | number | BigNumber": function ArrayMatrixNumberBigNumber(args) {
            var i;
            var len = args.length;
            var dim = -1; // zero-based dimension
            var prevDim;
            var asMatrix = false;
            var matrices = []; // contains multi dimensional arrays
            for(i = 0; i < len; i++){
                var arg = args[i]; // test whether we need to return a Matrix (if not we return an Array)
                if ((0, $1amHZ.isMatrix)(arg)) asMatrix = true;
                if ((0, $1amHZ.isNumber)(arg) || (0, $1amHZ.isBigNumber)(arg)) {
                    if (i !== len - 1) throw new Error("Dimension must be specified as last argument");
                     // last argument contains the dimension on which to concatenate
                    prevDim = dim;
                    dim = arg.valueOf(); // change BigNumber to number
                    if (!isInteger(dim)) throw new TypeError("Integer number expected for dimension");
                    if (dim < 0 || i > 0 && dim > prevDim) // TODO: would be more clear when throwing a DimensionError here
                    throw new (0, $5ITEv.IndexError)(dim, prevDim + 1);
                } else {
                    // this is a matrix or array
                    var m = (0, $7ITGG.clone)(arg).valueOf();
                    var size = (0, $5WdrK.arraySize)(m);
                    matrices[i] = m;
                    prevDim = dim;
                    dim = size.length - 1; // verify whether each of the matrices has the same number of dimensions
                    if (i > 0 && dim !== prevDim) throw new (0, $hy7Bx.DimensionError)(prevDim + 1, dim + 1);
                }
            }
            if (matrices.length === 0) throw new SyntaxError("At least one matrix expected");
            var res = matrices.shift();
            while(matrices.length)res = $18ef93ec6cfcf56e$var$_concat(res, matrices.shift(), dim, 0);
            return asMatrix ? matrix(res) : res;
        },
        "...string": function string(args) {
            return args.join("");
        }
    });
});
/**
 * Recursively concatenate two matrices.
 * The contents of the matrices is not cloned.
 * @param {Array} a             Multi dimensional array
 * @param {Array} b             Multi dimensional array
 * @param {number} concatDim    The dimension on which to concatenate (zero-based)
 * @param {number} dim          The current dim (zero-based)
 * @return {Array} c            The concatenated matrix
 * @private
 */ function $18ef93ec6cfcf56e$var$_concat(a, b, concatDim, dim) {
    if (dim < concatDim) {
        // recurse into next dimension
        if (a.length !== b.length) throw new (0, $hy7Bx.DimensionError)(a.length, b.length);
        var c = [];
        for(var i = 0; i < a.length; i++)c[i] = $18ef93ec6cfcf56e$var$_concat(a[i], b[i], concatDim, dim + 1);
        return c;
    } else // concatenate this dimension
    return a.concat(b);
}

});


parcelRegister("jY7fN", function(module, exports) {

$parcel$export(module.exports, "createConditionalNode", function () { return $e8993f5b91764dd2$export$401636051e48ab09; });

var $1amHZ = parcelRequire("1amHZ");

var $2mPYl = parcelRequire("2mPYl");

var $cAxNq = parcelRequire("cAxNq");
var $e8993f5b91764dd2$var$name = "ConditionalNode";
var $e8993f5b91764dd2$var$dependencies = [
    "Node"
];
var $e8993f5b91764dd2$export$401636051e48ab09 = /* #__PURE__ */ (0, $2mPYl.factory)($e8993f5b91764dd2$var$name, $e8993f5b91764dd2$var$dependencies, function(_ref) {
    var Node = _ref.Node;
    /**
   * A lazy evaluating conditional operator: 'condition ? trueExpr : falseExpr'
   *
   * @param {Node} condition   Condition, must result in a boolean
   * @param {Node} trueExpr    Expression evaluated when condition is true
   * @param {Node} falseExpr   Expression evaluated when condition is true
   *
   * @constructor ConditionalNode
   * @extends {Node}
   */ function ConditionalNode(condition, trueExpr, falseExpr) {
        if (!(this instanceof ConditionalNode)) throw new SyntaxError("Constructor must be called with the new operator");
        if (!(0, $1amHZ.isNode)(condition)) throw new TypeError("Parameter condition must be a Node");
        if (!(0, $1amHZ.isNode)(trueExpr)) throw new TypeError("Parameter trueExpr must be a Node");
        if (!(0, $1amHZ.isNode)(falseExpr)) throw new TypeError("Parameter falseExpr must be a Node");
        this.condition = condition;
        this.trueExpr = trueExpr;
        this.falseExpr = falseExpr;
    }
    ConditionalNode.prototype = new Node();
    ConditionalNode.prototype.type = "ConditionalNode";
    ConditionalNode.prototype.isConditionalNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ ConditionalNode.prototype._compile = function(math, argNames) {
        var evalCondition = this.condition._compile(math, argNames);
        var evalTrueExpr = this.trueExpr._compile(math, argNames);
        var evalFalseExpr = this.falseExpr._compile(math, argNames);
        return function evalConditionalNode(scope, args, context) {
            return testCondition(evalCondition(scope, args, context)) ? evalTrueExpr(scope, args, context) : evalFalseExpr(scope, args, context);
        };
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ ConditionalNode.prototype.forEach = function(callback) {
        callback(this.condition, "condition", this);
        callback(this.trueExpr, "trueExpr", this);
        callback(this.falseExpr, "falseExpr", this);
    };
    /**
   * Create a new ConditionalNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node): Node} callback
   * @returns {ConditionalNode} Returns a transformed copy of the node
   */ ConditionalNode.prototype.map = function(callback) {
        return new ConditionalNode(this._ifNode(callback(this.condition, "condition", this)), this._ifNode(callback(this.trueExpr, "trueExpr", this)), this._ifNode(callback(this.falseExpr, "falseExpr", this)));
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {ConditionalNode}
   */ ConditionalNode.prototype.clone = function() {
        return new ConditionalNode(this.condition, this.trueExpr, this.falseExpr);
    };
    /**
   * Get string representation
   * @param {Object} options
   * @return {string} str
   */ ConditionalNode.prototype._toString = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var precedence = (0, $cAxNq.getPrecedence)(this, parenthesis); // Enclose Arguments in parentheses if they are an OperatorNode
        // or have lower or equal precedence
        // NOTE: enclosing all OperatorNodes in parentheses is a decision
        // purely based on aesthetics and readability
        var condition = this.condition.toString(options);
        var conditionPrecedence = (0, $cAxNq.getPrecedence)(this.condition, parenthesis);
        if (parenthesis === "all" || this.condition.type === "OperatorNode" || conditionPrecedence !== null && conditionPrecedence <= precedence) condition = "(" + condition + ")";
        var trueExpr = this.trueExpr.toString(options);
        var truePrecedence = (0, $cAxNq.getPrecedence)(this.trueExpr, parenthesis);
        if (parenthesis === "all" || this.trueExpr.type === "OperatorNode" || truePrecedence !== null && truePrecedence <= precedence) trueExpr = "(" + trueExpr + ")";
        var falseExpr = this.falseExpr.toString(options);
        var falsePrecedence = (0, $cAxNq.getPrecedence)(this.falseExpr, parenthesis);
        if (parenthesis === "all" || this.falseExpr.type === "OperatorNode" || falsePrecedence !== null && falsePrecedence <= precedence) falseExpr = "(" + falseExpr + ")";
        return condition + " ? " + trueExpr + " : " + falseExpr;
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ ConditionalNode.prototype.toJSON = function() {
        return {
            mathjs: "ConditionalNode",
            condition: this.condition,
            trueExpr: this.trueExpr,
            falseExpr: this.falseExpr
        };
    };
    /**
   * Instantiate an ConditionalNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "ConditionalNode", "condition": ..., "trueExpr": ..., "falseExpr": ...}`,
   *                       where mathjs is optional
   * @returns {ConditionalNode}
   */ ConditionalNode.fromJSON = function(json) {
        return new ConditionalNode(json.condition, json.trueExpr, json.falseExpr);
    };
    /**
   * Get HTML representation
   * @param {Object} options
   * @return {string} str
   */ ConditionalNode.prototype.toHTML = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var precedence = (0, $cAxNq.getPrecedence)(this, parenthesis); // Enclose Arguments in parentheses if they are an OperatorNode
        // or have lower or equal precedence
        // NOTE: enclosing all OperatorNodes in parentheses is a decision
        // purely based on aesthetics and readability
        var condition = this.condition.toHTML(options);
        var conditionPrecedence = (0, $cAxNq.getPrecedence)(this.condition, parenthesis);
        if (parenthesis === "all" || this.condition.type === "OperatorNode" || conditionPrecedence !== null && conditionPrecedence <= precedence) condition = '<span class="math-parenthesis math-round-parenthesis">(</span>' + condition + '<span class="math-parenthesis math-round-parenthesis">)</span>';
        var trueExpr = this.trueExpr.toHTML(options);
        var truePrecedence = (0, $cAxNq.getPrecedence)(this.trueExpr, parenthesis);
        if (parenthesis === "all" || this.trueExpr.type === "OperatorNode" || truePrecedence !== null && truePrecedence <= precedence) trueExpr = '<span class="math-parenthesis math-round-parenthesis">(</span>' + trueExpr + '<span class="math-parenthesis math-round-parenthesis">)</span>';
        var falseExpr = this.falseExpr.toHTML(options);
        var falsePrecedence = (0, $cAxNq.getPrecedence)(this.falseExpr, parenthesis);
        if (parenthesis === "all" || this.falseExpr.type === "OperatorNode" || falsePrecedence !== null && falsePrecedence <= precedence) falseExpr = '<span class="math-parenthesis math-round-parenthesis">(</span>' + falseExpr + '<span class="math-parenthesis math-round-parenthesis">)</span>';
        return condition + '<span class="math-operator math-conditional-operator">?</span>' + trueExpr + '<span class="math-operator math-conditional-operator">:</span>' + falseExpr;
    };
    /**
   * Get LaTeX representation
   * @param {Object} options
   * @return {string} str
   */ ConditionalNode.prototype._toTex = function(options) {
        return "\\begin{cases} {" + this.trueExpr.toTex(options) + "}, &\\quad{\\text{if }\\;" + this.condition.toTex(options) + "}\\\\{" + this.falseExpr.toTex(options) + "}, &\\quad{\\text{otherwise}}\\end{cases}";
    };
    /**
   * Test whether a condition is met
   * @param {*} condition
   * @returns {boolean} true if condition is true or non-zero, else false
   */ function testCondition(condition) {
        if (typeof condition === "number" || typeof condition === "boolean" || typeof condition === "string") return !!condition;
        if (condition) {
            if ((0, $1amHZ.isBigNumber)(condition)) return !condition.isZero();
            if ((0, $1amHZ.isComplex)(condition)) return !!(condition.re || condition.im);
            if ((0, $1amHZ.isUnit)(condition)) return !!condition.value;
        }
        if (condition === null || condition === undefined) return false;
        throw new TypeError('Unsupported type of condition "' + (0, $1amHZ.typeOf)(condition) + '"');
    }
    return ConditionalNode;
}, {
    isClass: true,
    isNode: true
});

});

parcelRegister("iKJit", function(module, exports) {

$parcel$export(module.exports, "createConstantNode", function () { return $da6fa8e77814cb4e$export$70fc17189bb5117e; });

var $6NxuJ = parcelRequire("6NxuJ");

var $1amHZ = parcelRequire("1amHZ");

var $6Zo9s = parcelRequire("6Zo9s");

var $2mPYl = parcelRequire("2mPYl");
var $da6fa8e77814cb4e$var$name = "ConstantNode";
var $da6fa8e77814cb4e$var$dependencies = [
    "Node"
];
var $da6fa8e77814cb4e$export$70fc17189bb5117e = /* #__PURE__ */ (0, $2mPYl.factory)($da6fa8e77814cb4e$var$name, $da6fa8e77814cb4e$var$dependencies, function(_ref) {
    var Node = _ref.Node;
    /**
   * A ConstantNode holds a constant value like a number or string.
   *
   * Usage:
   *
   *     new ConstantNode(2.3)
   *     new ConstantNode('hello')
   *
   * @param {*} value    Value can be any type (number, BigNumber, string, ...)
   * @constructor ConstantNode
   * @extends {Node}
   */ function ConstantNode(value) {
        if (!(this instanceof ConstantNode)) throw new SyntaxError("Constructor must be called with the new operator");
        if (arguments.length === 2) // TODO: remove deprecation error some day (created 2018-01-23)
        throw new SyntaxError("new ConstantNode(valueStr, valueType) is not supported anymore since math v4.0.0. Use new ConstantNode(value) instead, where value is a non-stringified value.");
        this.value = value;
    }
    ConstantNode.prototype = new Node();
    ConstantNode.prototype.type = "ConstantNode";
    ConstantNode.prototype.isConstantNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ ConstantNode.prototype._compile = function(math, argNames) {
        var value = this.value;
        return function evalConstantNode() {
            return value;
        };
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ ConstantNode.prototype.forEach = function(callback) {} // nothing to do, we don't have childs
     /**
   * Create a new ConstantNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node) : Node} callback
   * @returns {ConstantNode} Returns a clone of the node
   */ ;
    ConstantNode.prototype.map = function(callback) {
        return this.clone();
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {ConstantNode}
   */ ConstantNode.prototype.clone = function() {
        return new ConstantNode(this.value);
    };
    /**
   * Get string representation
   * @param {Object} options
   * @return {string} str
   */ ConstantNode.prototype._toString = function(options) {
        return (0, $6NxuJ.format)(this.value, options);
    };
    /**
   * Get HTML representation
   * @param {Object} options
   * @return {string} str
   */ ConstantNode.prototype.toHTML = function(options) {
        var value = this._toString(options);
        switch((0, $1amHZ.typeOf)(this.value)){
            case "number":
            case "BigNumber":
            case "Fraction":
                return '<span class="math-number">' + value + "</span>";
            case "string":
                return '<span class="math-string">' + value + "</span>";
            case "boolean":
                return '<span class="math-boolean">' + value + "</span>";
            case "null":
                return '<span class="math-null-symbol">' + value + "</span>";
            case "undefined":
                return '<span class="math-undefined">' + value + "</span>";
            default:
                return '<span class="math-symbol">' + value + "</span>";
        }
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ ConstantNode.prototype.toJSON = function() {
        return {
            mathjs: "ConstantNode",
            value: this.value
        };
    };
    /**
   * Instantiate a ConstantNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "SymbolNode", value: 2.3}`,
   *                       where mathjs is optional
   * @returns {ConstantNode}
   */ ConstantNode.fromJSON = function(json) {
        return new ConstantNode(json.value);
    };
    /**
   * Get LaTeX representation
   * @param {Object} options
   * @return {string} str
   */ ConstantNode.prototype._toTex = function(options) {
        var value = this._toString(options);
        switch((0, $1amHZ.typeOf)(this.value)){
            case "string":
                return "\\mathtt{" + (0, $6Zo9s.escapeLatex)(value) + "}";
            case "number":
            case "BigNumber":
                if (!isFinite(this.value)) return this.value.valueOf() < 0 ? "-\\infty" : "\\infty";
                var index = value.toLowerCase().indexOf("e");
                if (index !== -1) return value.substring(0, index) + "\\cdot10^{" + value.substring(index + 1) + "}";
                return value;
            case "Fraction":
                return this.value.toLatex();
            default:
                return value;
        }
    };
    return ConstantNode;
}, {
    isClass: true,
    isNode: true
});

});
parcelRegister("6Zo9s", function(module, exports) {

$parcel$export(module.exports, "latexOperators", function () { return $516b2c972a023dce$export$c728a46e4168cd75; });
$parcel$export(module.exports, "latexFunctions", function () { return $516b2c972a023dce$export$b0cfc37067573780; });
$parcel$export(module.exports, "defaultTemplate", function () { return $516b2c972a023dce$export$76173758cefa70e5; });
$parcel$export(module.exports, "escapeLatex", function () { return $516b2c972a023dce$export$1b86a510a6af60c2; });
$parcel$export(module.exports, "toSymbol", function () { return $516b2c972a023dce$export$358d3bb1a752ff; });
/* eslint no-template-curly-in-string: "off" */ 
var $7Nw70 = parcelRequire("7Nw70");

var $7ITGG = parcelRequire("7ITGG");
var $516b2c972a023dce$export$98cd3902fcdeb93d = {
    // GREEK LETTERS
    Alpha: "A",
    alpha: "\\alpha",
    Beta: "B",
    beta: "\\beta",
    Gamma: "\\Gamma",
    gamma: "\\gamma",
    Delta: "\\Delta",
    delta: "\\delta",
    Epsilon: "E",
    epsilon: "\\epsilon",
    varepsilon: "\\varepsilon",
    Zeta: "Z",
    zeta: "\\zeta",
    Eta: "H",
    eta: "\\eta",
    Theta: "\\Theta",
    theta: "\\theta",
    vartheta: "\\vartheta",
    Iota: "I",
    iota: "\\iota",
    Kappa: "K",
    kappa: "\\kappa",
    varkappa: "\\varkappa",
    Lambda: "\\Lambda",
    lambda: "\\lambda",
    Mu: "M",
    mu: "\\mu",
    Nu: "N",
    nu: "\\nu",
    Xi: "\\Xi",
    xi: "\\xi",
    Omicron: "O",
    omicron: "o",
    Pi: "\\Pi",
    pi: "\\pi",
    varpi: "\\varpi",
    Rho: "P",
    rho: "\\rho",
    varrho: "\\varrho",
    Sigma: "\\Sigma",
    sigma: "\\sigma",
    varsigma: "\\varsigma",
    Tau: "T",
    tau: "\\tau",
    Upsilon: "\\Upsilon",
    upsilon: "\\upsilon",
    Phi: "\\Phi",
    phi: "\\phi",
    varphi: "\\varphi",
    Chi: "X",
    chi: "\\chi",
    Psi: "\\Psi",
    psi: "\\psi",
    Omega: "\\Omega",
    omega: "\\omega",
    // logic
    "true": "\\mathrm{True}",
    "false": "\\mathrm{False}",
    // other
    i: "i",
    // TODO use \i ??
    inf: "\\infty",
    Inf: "\\infty",
    infinity: "\\infty",
    Infinity: "\\infty",
    oo: "\\infty",
    lim: "\\lim",
    undefined: "\\mathbf{?}"
};
var $516b2c972a023dce$export$c728a46e4168cd75 = {
    transpose: "^\\top",
    ctranspose: "^H",
    factorial: "!",
    pow: "^",
    dotPow: ".^\\wedge",
    // TODO find ideal solution
    unaryPlus: "+",
    unaryMinus: "-",
    bitNot: "\\~",
    // TODO find ideal solution
    not: "\\neg",
    multiply: "\\cdot",
    divide: "\\frac",
    // TODO how to handle that properly?
    dotMultiply: ".\\cdot",
    // TODO find ideal solution
    dotDivide: ".:",
    // TODO find ideal solution
    mod: "\\mod",
    add: "+",
    subtract: "-",
    to: "\\rightarrow",
    leftShift: "<<",
    rightArithShift: ">>",
    rightLogShift: ">>>",
    equal: "=",
    unequal: "\\neq",
    smaller: "<",
    larger: ">",
    smallerEq: "\\leq",
    largerEq: "\\geq",
    bitAnd: "\\&",
    bitXor: "\\underline{|}",
    bitOr: "|",
    and: "\\wedge",
    xor: "\\veebar",
    or: "\\vee"
};
var $516b2c972a023dce$export$b0cfc37067573780 = {
    // arithmetic
    abs: {
        1: "\\left|${args[0]}\\right|"
    },
    add: {
        2: "\\left(${args[0]}".concat($516b2c972a023dce$export$c728a46e4168cd75.add, "${args[1]}\\right)")
    },
    cbrt: {
        1: "\\sqrt[3]{${args[0]}}"
    },
    ceil: {
        1: "\\left\\lceil${args[0]}\\right\\rceil"
    },
    cube: {
        1: "\\left(${args[0]}\\right)^3"
    },
    divide: {
        2: "\\frac{${args[0]}}{${args[1]}}"
    },
    dotDivide: {
        2: "\\left(${args[0]}".concat($516b2c972a023dce$export$c728a46e4168cd75.dotDivide, "${args[1]}\\right)")
    },
    dotMultiply: {
        2: "\\left(${args[0]}".concat($516b2c972a023dce$export$c728a46e4168cd75.dotMultiply, "${args[1]}\\right)")
    },
    dotPow: {
        2: "\\left(${args[0]}".concat($516b2c972a023dce$export$c728a46e4168cd75.dotPow, "${args[1]}\\right)")
    },
    exp: {
        1: "\\exp\\left(${args[0]}\\right)"
    },
    expm1: "\\left(e".concat($516b2c972a023dce$export$c728a46e4168cd75.pow, "{${args[0]}}-1\\right)"),
    fix: {
        1: "\\mathrm{${name}}\\left(${args[0]}\\right)"
    },
    floor: {
        1: "\\left\\lfloor${args[0]}\\right\\rfloor"
    },
    gcd: "\\gcd\\left(${args}\\right)",
    hypot: "\\hypot\\left(${args}\\right)",
    log: {
        1: "\\ln\\left(${args[0]}\\right)",
        2: "\\log_{${args[1]}}\\left(${args[0]}\\right)"
    },
    log10: {
        1: "\\log_{10}\\left(${args[0]}\\right)"
    },
    log1p: {
        1: "\\ln\\left(${args[0]}+1\\right)",
        2: "\\log_{${args[1]}}\\left(${args[0]}+1\\right)"
    },
    log2: "\\log_{2}\\left(${args[0]}\\right)",
    mod: {
        2: "\\left(${args[0]}".concat($516b2c972a023dce$export$c728a46e4168cd75.mod, "${args[1]}\\right)")
    },
    multiply: {
        2: "\\left(${args[0]}".concat($516b2c972a023dce$export$c728a46e4168cd75.multiply, "${args[1]}\\right)")
    },
    norm: {
        1: "\\left\\|${args[0]}\\right\\|",
        2: undefined // use default template
    },
    nthRoot: {
        2: "\\sqrt[${args[1]}]{${args[0]}}"
    },
    nthRoots: {
        2: "\\{y : $y^{args[1]} = {${args[0]}}\\}"
    },
    pow: {
        2: "\\left(${args[0]}\\right)".concat($516b2c972a023dce$export$c728a46e4168cd75.pow, "{${args[1]}}")
    },
    round: {
        1: "\\left\\lfloor${args[0]}\\right\\rceil",
        2: undefined // use default template
    },
    sign: {
        1: "\\mathrm{${name}}\\left(${args[0]}\\right)"
    },
    sqrt: {
        1: "\\sqrt{${args[0]}}"
    },
    square: {
        1: "\\left(${args[0]}\\right)^2"
    },
    subtract: {
        2: "\\left(${args[0]}".concat($516b2c972a023dce$export$c728a46e4168cd75.subtract, "${args[1]}\\right)")
    },
    unaryMinus: {
        1: "".concat($516b2c972a023dce$export$c728a46e4168cd75.unaryMinus, "\\left(${args[0]}\\right)")
    },
    unaryPlus: {
        1: "".concat($516b2c972a023dce$export$c728a46e4168cd75.unaryPlus, "\\left(${args[0]}\\right)")
    },
    // bitwise
    bitAnd: {
        2: "\\left(${args[0]}".concat($516b2c972a023dce$export$c728a46e4168cd75.bitAnd, "${args[1]}\\right)")
    },
    bitNot: {
        1: $516b2c972a023dce$export$c728a46e4168cd75.bitNot + "\\left(${args[0]}\\right)"
    },
    bitOr: {
        2: "\\left(${args[0]}".concat($516b2c972a023dce$export$c728a46e4168cd75.bitOr, "${args[1]}\\right)")
    },
    bitXor: {
        2: "\\left(${args[0]}".concat($516b2c972a023dce$export$c728a46e4168cd75.bitXor, "${args[1]}\\right)")
    },
    leftShift: {
        2: "\\left(${args[0]}".concat($516b2c972a023dce$export$c728a46e4168cd75.leftShift, "${args[1]}\\right)")
    },
    rightArithShift: {
        2: "\\left(${args[0]}".concat($516b2c972a023dce$export$c728a46e4168cd75.rightArithShift, "${args[1]}\\right)")
    },
    rightLogShift: {
        2: "\\left(${args[0]}".concat($516b2c972a023dce$export$c728a46e4168cd75.rightLogShift, "${args[1]}\\right)")
    },
    // combinatorics
    bellNumbers: {
        1: "\\mathrm{B}_{${args[0]}}"
    },
    catalan: {
        1: "\\mathrm{C}_{${args[0]}}"
    },
    stirlingS2: {
        2: "\\mathrm{S}\\left(${args}\\right)"
    },
    // complex
    arg: {
        1: "\\arg\\left(${args[0]}\\right)"
    },
    conj: {
        1: "\\left(${args[0]}\\right)^*"
    },
    im: {
        1: "\\Im\\left\\lbrace${args[0]}\\right\\rbrace"
    },
    re: {
        1: "\\Re\\left\\lbrace${args[0]}\\right\\rbrace"
    },
    // logical
    and: {
        2: "\\left(${args[0]}".concat($516b2c972a023dce$export$c728a46e4168cd75.and, "${args[1]}\\right)")
    },
    not: {
        1: $516b2c972a023dce$export$c728a46e4168cd75.not + "\\left(${args[0]}\\right)"
    },
    or: {
        2: "\\left(${args[0]}".concat($516b2c972a023dce$export$c728a46e4168cd75.or, "${args[1]}\\right)")
    },
    xor: {
        2: "\\left(${args[0]}".concat($516b2c972a023dce$export$c728a46e4168cd75.xor, "${args[1]}\\right)")
    },
    // matrix
    cross: {
        2: "\\left(${args[0]}\\right)\\times\\left(${args[1]}\\right)"
    },
    ctranspose: {
        1: "\\left(${args[0]}\\right)".concat($516b2c972a023dce$export$c728a46e4168cd75.ctranspose)
    },
    det: {
        1: "\\det\\left(${args[0]}\\right)"
    },
    dot: {
        2: "\\left(${args[0]}\\cdot${args[1]}\\right)"
    },
    expm: {
        1: "\\exp\\left(${args[0]}\\right)"
    },
    inv: {
        1: "\\left(${args[0]}\\right)^{-1}"
    },
    sqrtm: {
        1: "{${args[0]}}".concat($516b2c972a023dce$export$c728a46e4168cd75.pow, "{\\frac{1}{2}}")
    },
    trace: {
        1: "\\mathrm{tr}\\left(${args[0]}\\right)"
    },
    transpose: {
        1: "\\left(${args[0]}\\right)".concat($516b2c972a023dce$export$c728a46e4168cd75.transpose)
    },
    // probability
    combinations: {
        2: "\\binom{${args[0]}}{${args[1]}}"
    },
    combinationsWithRep: {
        2: "\\left(\\!\\!{\\binom{${args[0]}}{${args[1]}}}\\!\\!\\right)"
    },
    factorial: {
        1: "\\left(${args[0]}\\right)".concat($516b2c972a023dce$export$c728a46e4168cd75.factorial)
    },
    gamma: {
        1: "\\Gamma\\left(${args[0]}\\right)"
    },
    // relational
    equal: {
        2: "\\left(${args[0]}".concat($516b2c972a023dce$export$c728a46e4168cd75.equal, "${args[1]}\\right)")
    },
    larger: {
        2: "\\left(${args[0]}".concat($516b2c972a023dce$export$c728a46e4168cd75.larger, "${args[1]}\\right)")
    },
    largerEq: {
        2: "\\left(${args[0]}".concat($516b2c972a023dce$export$c728a46e4168cd75.largerEq, "${args[1]}\\right)")
    },
    smaller: {
        2: "\\left(${args[0]}".concat($516b2c972a023dce$export$c728a46e4168cd75.smaller, "${args[1]}\\right)")
    },
    smallerEq: {
        2: "\\left(${args[0]}".concat($516b2c972a023dce$export$c728a46e4168cd75.smallerEq, "${args[1]}\\right)")
    },
    unequal: {
        2: "\\left(${args[0]}".concat($516b2c972a023dce$export$c728a46e4168cd75.unequal, "${args[1]}\\right)")
    },
    // special
    erf: {
        1: "erf\\left(${args[0]}\\right)"
    },
    // statistics
    max: "\\max\\left(${args}\\right)",
    min: "\\min\\left(${args}\\right)",
    variance: "\\mathrm{Var}\\left(${args}\\right)",
    // trigonometry
    acos: {
        1: "\\cos^{-1}\\left(${args[0]}\\right)"
    },
    acosh: {
        1: "\\cosh^{-1}\\left(${args[0]}\\right)"
    },
    acot: {
        1: "\\cot^{-1}\\left(${args[0]}\\right)"
    },
    acoth: {
        1: "\\coth^{-1}\\left(${args[0]}\\right)"
    },
    acsc: {
        1: "\\csc^{-1}\\left(${args[0]}\\right)"
    },
    acsch: {
        1: "\\mathrm{csch}^{-1}\\left(${args[0]}\\right)"
    },
    asec: {
        1: "\\sec^{-1}\\left(${args[0]}\\right)"
    },
    asech: {
        1: "\\mathrm{sech}^{-1}\\left(${args[0]}\\right)"
    },
    asin: {
        1: "\\sin^{-1}\\left(${args[0]}\\right)"
    },
    asinh: {
        1: "\\sinh^{-1}\\left(${args[0]}\\right)"
    },
    atan: {
        1: "\\tan^{-1}\\left(${args[0]}\\right)"
    },
    atan2: {
        2: "\\mathrm{atan2}\\left(${args}\\right)"
    },
    atanh: {
        1: "\\tanh^{-1}\\left(${args[0]}\\right)"
    },
    cos: {
        1: "\\cos\\left(${args[0]}\\right)"
    },
    cosh: {
        1: "\\cosh\\left(${args[0]}\\right)"
    },
    cot: {
        1: "\\cot\\left(${args[0]}\\right)"
    },
    coth: {
        1: "\\coth\\left(${args[0]}\\right)"
    },
    csc: {
        1: "\\csc\\left(${args[0]}\\right)"
    },
    csch: {
        1: "\\mathrm{csch}\\left(${args[0]}\\right)"
    },
    sec: {
        1: "\\sec\\left(${args[0]}\\right)"
    },
    sech: {
        1: "\\mathrm{sech}\\left(${args[0]}\\right)"
    },
    sin: {
        1: "\\sin\\left(${args[0]}\\right)"
    },
    sinh: {
        1: "\\sinh\\left(${args[0]}\\right)"
    },
    tan: {
        1: "\\tan\\left(${args[0]}\\right)"
    },
    tanh: {
        1: "\\tanh\\left(${args[0]}\\right)"
    },
    // unit
    to: {
        2: "\\left(${args[0]}".concat($516b2c972a023dce$export$c728a46e4168cd75.to, "${args[1]}\\right)")
    },
    // utils
    numeric: function numeric(node, options) {
        // Not sure if this is strictly right but should work correctly for the vast majority of use cases.
        return node.args[0].toTex();
    },
    // type
    number: {
        0: "0",
        1: "\\left(${args[0]}\\right)",
        2: "\\left(\\left(${args[0]}\\right)${args[1]}\\right)"
    },
    string: {
        0: '\\mathtt{""}',
        1: "\\mathrm{string}\\left(${args[0]}\\right)"
    },
    bignumber: {
        0: "0",
        1: "\\left(${args[0]}\\right)"
    },
    complex: {
        0: "0",
        1: "\\left(${args[0]}\\right)",
        2: "\\left(\\left(${args[0]}\\right)+".concat($516b2c972a023dce$export$98cd3902fcdeb93d.i, "\\cdot\\left(${args[1]}\\right)\\right)")
    },
    matrix: {
        0: "\\begin{bmatrix}\\end{bmatrix}",
        1: "\\left(${args[0]}\\right)",
        2: "\\left(${args[0]}\\right)"
    },
    sparse: {
        0: "\\begin{bsparse}\\end{bsparse}",
        1: "\\left(${args[0]}\\right)"
    },
    unit: {
        1: "\\left(${args[0]}\\right)",
        2: "\\left(\\left(${args[0]}\\right)${args[1]}\\right)"
    }
};
var $516b2c972a023dce$export$76173758cefa70e5 = "\\mathrm{${name}}\\left(${args}\\right)";
var $516b2c972a023dce$var$latexUnits = {
    deg: "^\\circ"
};
function $516b2c972a023dce$export$1b86a510a6af60c2(string) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7Nw70)))(string, {
        preserveFormatting: true
    });
} // @param {string} name
function $516b2c972a023dce$export$358d3bb1a752ff(name, isUnit) {
    isUnit = typeof isUnit === "undefined" ? false : isUnit;
    if (isUnit) {
        if ((0, $7ITGG.hasOwnProperty)($516b2c972a023dce$var$latexUnits, name)) return $516b2c972a023dce$var$latexUnits[name];
        return "\\mathrm{" + $516b2c972a023dce$export$1b86a510a6af60c2(name) + "}";
    }
    if ((0, $7ITGG.hasOwnProperty)($516b2c972a023dce$export$98cd3902fcdeb93d, name)) return $516b2c972a023dce$export$98cd3902fcdeb93d[name];
    return $516b2c972a023dce$export$1b86a510a6af60c2(name);
}

});
parcelRegister("7Nw70", function(module, exports) {
"use strict";
// Map the characters to escape to their escaped values. The list is derived
// from http://www.cespedes.org/blog/85/how-to-escape-latex-special-characters
var $5ad604c50b64c5f0$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $5ad604c50b64c5f0$var$defaultEscapes = {
    "{": "\\{",
    "}": "\\}",
    "\\": "\\textbackslash{}",
    "#": "\\#",
    $: "\\$",
    "%": "\\%",
    "&": "\\&",
    "^": "\\textasciicircum{}",
    _: "\\_",
    "~": "\\textasciitilde{}"
};
var $5ad604c50b64c5f0$var$formatEscapes = {
    "\u2013": "\\--",
    "\u2014": "\\---",
    " ": "~",
    "	": "\\qquad{}",
    "\r\n": "\\newline{}",
    "\n": "\\newline{}"
};
var $5ad604c50b64c5f0$var$defaultEscapeMapFn = function defaultEscapeMapFn(defaultEscapes, formatEscapes) {
    return $5ad604c50b64c5f0$var$_extends({}, defaultEscapes, formatEscapes);
};
/**
 * Escape a string to be used in LaTeX documents.
 * @param {string} str the string to be escaped.
 * @param {boolean} params.preserveFormatting whether formatting escapes should
 *  be performed (default: false).
 * @param {function} params.escapeMapFn the function to modify the escape maps.
 * @return {string} the escaped string, ready to be used in LaTeX.
 */ module.exports = function(str) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$preserveFormatti = _ref.preserveFormatting, preserveFormatting = _ref$preserveFormatti === undefined ? false : _ref$preserveFormatti, _ref$escapeMapFn = _ref.escapeMapFn, escapeMapFn = _ref$escapeMapFn === undefined ? $5ad604c50b64c5f0$var$defaultEscapeMapFn : _ref$escapeMapFn;
    var runningStr = String(str);
    var result = "";
    var escapes = escapeMapFn($5ad604c50b64c5f0$var$_extends({}, $5ad604c50b64c5f0$var$defaultEscapes), preserveFormatting ? $5ad604c50b64c5f0$var$_extends({}, $5ad604c50b64c5f0$var$formatEscapes) : {});
    var escapeKeys = Object.keys(escapes); // as it is reused later on
    // Algorithm: Go through the string character by character, if it matches
    // with one of the special characters then we'll replace it with the escaped
    // version.
    var _loop = function _loop() {
        var specialCharFound = false;
        escapeKeys.forEach(function(key, index) {
            if (specialCharFound) return;
            if (runningStr.length >= key.length && runningStr.slice(0, key.length) === key) {
                result += escapes[escapeKeys[index]];
                runningStr = runningStr.slice(key.length, runningStr.length);
                specialCharFound = true;
            }
        });
        if (!specialCharFound) {
            result += runningStr.slice(0, 1);
            runningStr = runningStr.slice(1, runningStr.length);
        }
    };
    while(runningStr)_loop();
    return result;
};

});



parcelRegister("c7Jeb", function(module, exports) {

$parcel$export(module.exports, "createDerivative", function () { return $8d3938c4650a7b02$export$d1d6fcabea5d55e0; });

var $1amHZ = parcelRequire("1amHZ");

var $2mPYl = parcelRequire("2mPYl");
var $8d3938c4650a7b02$var$name = "derivative";
var $8d3938c4650a7b02$var$dependencies = [
    "typed",
    "config",
    "parse",
    "simplify",
    "equal",
    "isZero",
    "numeric",
    "ConstantNode",
    "FunctionNode",
    "OperatorNode",
    "ParenthesisNode",
    "SymbolNode"
];
var $8d3938c4650a7b02$export$d1d6fcabea5d55e0 = /* #__PURE__ */ (0, $2mPYl.factory)($8d3938c4650a7b02$var$name, $8d3938c4650a7b02$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, parse = _ref.parse, simplify = _ref.simplify, equal = _ref.equal, isZero = _ref.isZero, numeric = _ref.numeric, ConstantNode = _ref.ConstantNode, FunctionNode = _ref.FunctionNode, OperatorNode = _ref.OperatorNode, ParenthesisNode = _ref.ParenthesisNode, SymbolNode = _ref.SymbolNode;
    /**
   * Takes the derivative of an expression expressed in parser Nodes.
   * The derivative will be taken over the supplied variable in the
   * second parameter. If there are multiple variables in the expression,
   * it will return a partial derivative.
   *
   * This uses rules of differentiation which can be found here:
   *
   * - [Differentiation rules (Wikipedia)](https://en.wikipedia.org/wiki/Differentiation_rules)
   *
   * Syntax:
   *
   *     derivative(expr, variable)
   *     derivative(expr, variable, options)
   *
   * Examples:
   *
   *     math.derivative('x^2', 'x')                     // Node {2 * x}
   *     math.derivative('x^2', 'x', {simplify: false})  // Node {2 * 1 * x ^ (2 - 1)
   *     math.derivative('sin(2x)', 'x'))                // Node {2 * cos(2 * x)}
   *     math.derivative('2*x', 'x').evaluate()          // number 2
   *     math.derivative('x^2', 'x').evaluate({x: 4})    // number 8
   *     const f = math.parse('x^2')
   *     const x = math.parse('x')
   *     math.derivative(f, x)                           // Node {2 * x}
   *
   * See also:
   *
   *     simplify, parse, evaluate
   *
   * @param  {Node | string} expr           The expression to differentiate
   * @param  {SymbolNode | string} variable The variable over which to differentiate
   * @param  {{simplify: boolean}} [options]
   *                         There is one option available, `simplify`, which
   *                         is true by default. When false, output will not
   *                         be simplified.
   * @return {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode}    The derivative of `expr`
   */ var derivative = typed("derivative", {
        "Node, SymbolNode, Object": function NodeSymbolNodeObject(expr, variable, options) {
            var constNodes = {};
            constTag(constNodes, expr, variable.name);
            var res = _derivative(expr, constNodes);
            return options.simplify ? simplify(res) : res;
        },
        "Node, SymbolNode": function NodeSymbolNode(expr, variable) {
            return derivative(expr, variable, {
                simplify: true
            });
        },
        "string, SymbolNode": function stringSymbolNode(expr, variable) {
            return derivative(parse(expr), variable);
        },
        "string, SymbolNode, Object": function stringSymbolNodeObject(expr, variable, options) {
            return derivative(parse(expr), variable, options);
        },
        "string, string": function stringString(expr, variable) {
            return derivative(parse(expr), parse(variable));
        },
        "string, string, Object": function stringStringObject(expr, variable, options) {
            return derivative(parse(expr), parse(variable), options);
        },
        "Node, string": function NodeString(expr, variable) {
            return derivative(expr, parse(variable));
        },
        "Node, string, Object": function NodeStringObject(expr, variable, options) {
            return derivative(expr, parse(variable), options);
        } // TODO: replace the 8 signatures above with 4 as soon as typed-function supports optional arguments
    });
    derivative._simplify = true;
    derivative.toTex = function(deriv) {
        return _derivTex.apply(null, deriv.args);
    }; // FIXME: move the toTex method of derivative to latex.js. Difficulty is that it relies on parse.
    // NOTE: the optional "order" parameter here is currently unused
    var _derivTex = typed("_derivTex", {
        "Node, SymbolNode": function NodeSymbolNode(expr, x) {
            if ((0, $1amHZ.isConstantNode)(expr) && (0, $1amHZ.typeOf)(expr.value) === "string") return _derivTex(parse(expr.value).toString(), x.toString(), 1);
            else return _derivTex(expr.toString(), x.toString(), 1);
        },
        "Node, ConstantNode": function NodeConstantNode(expr, x) {
            if ((0, $1amHZ.typeOf)(x.value) === "string") return _derivTex(expr, parse(x.value));
            else throw new Error("The second parameter to 'derivative' is a non-string constant");
        },
        "Node, SymbolNode, ConstantNode": function NodeSymbolNodeConstantNode(expr, x, order) {
            return _derivTex(expr.toString(), x.name, order.value);
        },
        "string, string, number": function stringStringNumber(expr, x, order) {
            var d;
            if (order === 1) d = "{d\\over d" + x + "}";
            else d = "{d^{" + order + "}\\over d" + x + "^{" + order + "}}";
            return d + "\\left[".concat(expr, "\\right]");
        }
    });
    /**
   * Does a depth-first search on the expression tree to identify what Nodes
   * are constants (e.g. 2 + 2), and stores the ones that are constants in
   * constNodes. Classification is done as follows:
   *
   *   1. ConstantNodes are constants.
   *   2. If there exists a SymbolNode, of which we are differentiating over,
   *      in the subtree it is not constant.
   *
   * @param  {Object} constNodes  Holds the nodes that are constant
   * @param  {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} node
   * @param  {string} varName     Variable that we are differentiating
   * @return {boolean}  if node is constant
   */ // TODO: can we rewrite constTag into a pure function?
    var constTag = typed("constTag", {
        "Object, ConstantNode, string": function ObjectConstantNodeString(constNodes, node) {
            constNodes[node] = true;
            return true;
        },
        "Object, SymbolNode, string": function ObjectSymbolNodeString(constNodes, node, varName) {
            // Treat other variables like constants. For reasoning, see:
            //   https://en.wikipedia.org/wiki/Partial_derivative
            if (node.name !== varName) {
                constNodes[node] = true;
                return true;
            }
            return false;
        },
        "Object, ParenthesisNode, string": function ObjectParenthesisNodeString(constNodes, node, varName) {
            return constTag(constNodes, node.content, varName);
        },
        "Object, FunctionAssignmentNode, string": function ObjectFunctionAssignmentNodeString(constNodes, node, varName) {
            if (node.params.indexOf(varName) === -1) {
                constNodes[node] = true;
                return true;
            }
            return constTag(constNodes, node.expr, varName);
        },
        "Object, FunctionNode | OperatorNode, string": function ObjectFunctionNodeOperatorNodeString(constNodes, node, varName) {
            if (node.args.length > 0) {
                var isConst = constTag(constNodes, node.args[0], varName);
                for(var i = 1; i < node.args.length; ++i)isConst = constTag(constNodes, node.args[i], varName) && isConst;
                if (isConst) {
                    constNodes[node] = true;
                    return true;
                }
            }
            return false;
        }
    });
    /**
   * Applies differentiation rules.
   *
   * @param  {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} node
   * @param  {Object} constNodes  Holds the nodes that are constant
   * @return {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode}    The derivative of `expr`
   */ var _derivative = typed("_derivative", {
        "ConstantNode, Object": function ConstantNodeObject(node) {
            return createConstantNode(0);
        },
        "SymbolNode, Object": function SymbolNodeObject(node, constNodes) {
            if (constNodes[node] !== undefined) return createConstantNode(0);
            return createConstantNode(1);
        },
        "ParenthesisNode, Object": function ParenthesisNodeObject(node, constNodes) {
            return new ParenthesisNode(_derivative(node.content, constNodes));
        },
        "FunctionAssignmentNode, Object": function FunctionAssignmentNodeObject(node, constNodes) {
            if (constNodes[node] !== undefined) return createConstantNode(0);
            return _derivative(node.expr, constNodes);
        },
        "FunctionNode, Object": function FunctionNodeObject(node, constNodes) {
            if (node.args.length !== 1) funcArgsCheck(node);
            if (constNodes[node] !== undefined) return createConstantNode(0);
            var arg0 = node.args[0];
            var arg1;
            var div = false; // is output a fraction?
            var negative = false; // is output negative?
            var funcDerivative;
            switch(node.name){
                case "cbrt":
                    // d/dx(cbrt(x)) = 1 / (3x^(2/3))
                    div = true;
                    funcDerivative = new OperatorNode("*", "multiply", [
                        createConstantNode(3),
                        new OperatorNode("^", "pow", [
                            arg0,
                            new OperatorNode("/", "divide", [
                                createConstantNode(2),
                                createConstantNode(3)
                            ])
                        ])
                    ]);
                    break;
                case "sqrt":
                case "nthRoot":
                    // d/dx(sqrt(x)) = 1 / (2*sqrt(x))
                    if (node.args.length === 1) {
                        div = true;
                        funcDerivative = new OperatorNode("*", "multiply", [
                            createConstantNode(2),
                            new FunctionNode("sqrt", [
                                arg0
                            ])
                        ]);
                    } else if (node.args.length === 2) {
                        // Rearrange from nthRoot(x, a) -> x^(1/a)
                        arg1 = new OperatorNode("/", "divide", [
                            createConstantNode(1),
                            node.args[1]
                        ]); // Is a variable?
                        constNodes[arg1] = constNodes[node.args[1]];
                        return _derivative(new OperatorNode("^", "pow", [
                            arg0,
                            arg1
                        ]), constNodes);
                    }
                    break;
                case "log10":
                    arg1 = createConstantNode(10);
                /* fall through! */ case "log":
                    if (!arg1 && node.args.length === 1) {
                        // d/dx(log(x)) = 1 / x
                        funcDerivative = arg0.clone();
                        div = true;
                    } else if (node.args.length === 1 && arg1 || node.args.length === 2 && constNodes[node.args[1]] !== undefined) {
                        // d/dx(log(x, c)) = 1 / (x*ln(c))
                        funcDerivative = new OperatorNode("*", "multiply", [
                            arg0.clone(),
                            new FunctionNode("log", [
                                arg1 || node.args[1]
                            ])
                        ]);
                        div = true;
                    } else if (node.args.length === 2) // d/dx(log(f(x), g(x))) = d/dx(log(f(x)) / log(g(x)))
                    return _derivative(new OperatorNode("/", "divide", [
                        new FunctionNode("log", [
                            arg0
                        ]),
                        new FunctionNode("log", [
                            node.args[1]
                        ])
                    ]), constNodes);
                    break;
                case "pow":
                    constNodes[arg1] = constNodes[node.args[1]]; // Pass to pow operator node parser
                    return _derivative(new OperatorNode("^", "pow", [
                        arg0,
                        node.args[1]
                    ]), constNodes);
                case "exp":
                    // d/dx(e^x) = e^x
                    funcDerivative = new FunctionNode("exp", [
                        arg0.clone()
                    ]);
                    break;
                case "sin":
                    // d/dx(sin(x)) = cos(x)
                    funcDerivative = new FunctionNode("cos", [
                        arg0.clone()
                    ]);
                    break;
                case "cos":
                    // d/dx(cos(x)) = -sin(x)
                    funcDerivative = new OperatorNode("-", "unaryMinus", [
                        new FunctionNode("sin", [
                            arg0.clone()
                        ])
                    ]);
                    break;
                case "tan":
                    // d/dx(tan(x)) = sec(x)^2
                    funcDerivative = new OperatorNode("^", "pow", [
                        new FunctionNode("sec", [
                            arg0.clone()
                        ]),
                        createConstantNode(2)
                    ]);
                    break;
                case "sec":
                    // d/dx(sec(x)) = sec(x)tan(x)
                    funcDerivative = new OperatorNode("*", "multiply", [
                        node,
                        new FunctionNode("tan", [
                            arg0.clone()
                        ])
                    ]);
                    break;
                case "csc":
                    // d/dx(csc(x)) = -csc(x)cot(x)
                    negative = true;
                    funcDerivative = new OperatorNode("*", "multiply", [
                        node,
                        new FunctionNode("cot", [
                            arg0.clone()
                        ])
                    ]);
                    break;
                case "cot":
                    // d/dx(cot(x)) = -csc(x)^2
                    negative = true;
                    funcDerivative = new OperatorNode("^", "pow", [
                        new FunctionNode("csc", [
                            arg0.clone()
                        ]),
                        createConstantNode(2)
                    ]);
                    break;
                case "asin":
                    // d/dx(asin(x)) = 1 / sqrt(1 - x^2)
                    div = true;
                    funcDerivative = new FunctionNode("sqrt", [
                        new OperatorNode("-", "subtract", [
                            createConstantNode(1),
                            new OperatorNode("^", "pow", [
                                arg0.clone(),
                                createConstantNode(2)
                            ])
                        ])
                    ]);
                    break;
                case "acos":
                    // d/dx(acos(x)) = -1 / sqrt(1 - x^2)
                    div = true;
                    negative = true;
                    funcDerivative = new FunctionNode("sqrt", [
                        new OperatorNode("-", "subtract", [
                            createConstantNode(1),
                            new OperatorNode("^", "pow", [
                                arg0.clone(),
                                createConstantNode(2)
                            ])
                        ])
                    ]);
                    break;
                case "atan":
                    // d/dx(atan(x)) = 1 / (x^2 + 1)
                    div = true;
                    funcDerivative = new OperatorNode("+", "add", [
                        new OperatorNode("^", "pow", [
                            arg0.clone(),
                            createConstantNode(2)
                        ]),
                        createConstantNode(1)
                    ]);
                    break;
                case "asec":
                    // d/dx(asec(x)) = 1 / (|x|*sqrt(x^2 - 1))
                    div = true;
                    funcDerivative = new OperatorNode("*", "multiply", [
                        new FunctionNode("abs", [
                            arg0.clone()
                        ]),
                        new FunctionNode("sqrt", [
                            new OperatorNode("-", "subtract", [
                                new OperatorNode("^", "pow", [
                                    arg0.clone(),
                                    createConstantNode(2)
                                ]),
                                createConstantNode(1)
                            ])
                        ])
                    ]);
                    break;
                case "acsc":
                    // d/dx(acsc(x)) = -1 / (|x|*sqrt(x^2 - 1))
                    div = true;
                    negative = true;
                    funcDerivative = new OperatorNode("*", "multiply", [
                        new FunctionNode("abs", [
                            arg0.clone()
                        ]),
                        new FunctionNode("sqrt", [
                            new OperatorNode("-", "subtract", [
                                new OperatorNode("^", "pow", [
                                    arg0.clone(),
                                    createConstantNode(2)
                                ]),
                                createConstantNode(1)
                            ])
                        ])
                    ]);
                    break;
                case "acot":
                    // d/dx(acot(x)) = -1 / (x^2 + 1)
                    div = true;
                    negative = true;
                    funcDerivative = new OperatorNode("+", "add", [
                        new OperatorNode("^", "pow", [
                            arg0.clone(),
                            createConstantNode(2)
                        ]),
                        createConstantNode(1)
                    ]);
                    break;
                case "sinh":
                    // d/dx(sinh(x)) = cosh(x)
                    funcDerivative = new FunctionNode("cosh", [
                        arg0.clone()
                    ]);
                    break;
                case "cosh":
                    // d/dx(cosh(x)) = sinh(x)
                    funcDerivative = new FunctionNode("sinh", [
                        arg0.clone()
                    ]);
                    break;
                case "tanh":
                    // d/dx(tanh(x)) = sech(x)^2
                    funcDerivative = new OperatorNode("^", "pow", [
                        new FunctionNode("sech", [
                            arg0.clone()
                        ]),
                        createConstantNode(2)
                    ]);
                    break;
                case "sech":
                    // d/dx(sech(x)) = -sech(x)tanh(x)
                    negative = true;
                    funcDerivative = new OperatorNode("*", "multiply", [
                        node,
                        new FunctionNode("tanh", [
                            arg0.clone()
                        ])
                    ]);
                    break;
                case "csch":
                    // d/dx(csch(x)) = -csch(x)coth(x)
                    negative = true;
                    funcDerivative = new OperatorNode("*", "multiply", [
                        node,
                        new FunctionNode("coth", [
                            arg0.clone()
                        ])
                    ]);
                    break;
                case "coth":
                    // d/dx(coth(x)) = -csch(x)^2
                    negative = true;
                    funcDerivative = new OperatorNode("^", "pow", [
                        new FunctionNode("csch", [
                            arg0.clone()
                        ]),
                        createConstantNode(2)
                    ]);
                    break;
                case "asinh":
                    // d/dx(asinh(x)) = 1 / sqrt(x^2 + 1)
                    div = true;
                    funcDerivative = new FunctionNode("sqrt", [
                        new OperatorNode("+", "add", [
                            new OperatorNode("^", "pow", [
                                arg0.clone(),
                                createConstantNode(2)
                            ]),
                            createConstantNode(1)
                        ])
                    ]);
                    break;
                case "acosh":
                    // d/dx(acosh(x)) = 1 / sqrt(x^2 - 1); XXX potentially only for x >= 1 (the real spectrum)
                    div = true;
                    funcDerivative = new FunctionNode("sqrt", [
                        new OperatorNode("-", "subtract", [
                            new OperatorNode("^", "pow", [
                                arg0.clone(),
                                createConstantNode(2)
                            ]),
                            createConstantNode(1)
                        ])
                    ]);
                    break;
                case "atanh":
                    // d/dx(atanh(x)) = 1 / (1 - x^2)
                    div = true;
                    funcDerivative = new OperatorNode("-", "subtract", [
                        createConstantNode(1),
                        new OperatorNode("^", "pow", [
                            arg0.clone(),
                            createConstantNode(2)
                        ])
                    ]);
                    break;
                case "asech":
                    // d/dx(asech(x)) = -1 / (x*sqrt(1 - x^2))
                    div = true;
                    negative = true;
                    funcDerivative = new OperatorNode("*", "multiply", [
                        arg0.clone(),
                        new FunctionNode("sqrt", [
                            new OperatorNode("-", "subtract", [
                                createConstantNode(1),
                                new OperatorNode("^", "pow", [
                                    arg0.clone(),
                                    createConstantNode(2)
                                ])
                            ])
                        ])
                    ]);
                    break;
                case "acsch":
                    // d/dx(acsch(x)) = -1 / (|x|*sqrt(x^2 + 1))
                    div = true;
                    negative = true;
                    funcDerivative = new OperatorNode("*", "multiply", [
                        new FunctionNode("abs", [
                            arg0.clone()
                        ]),
                        new FunctionNode("sqrt", [
                            new OperatorNode("+", "add", [
                                new OperatorNode("^", "pow", [
                                    arg0.clone(),
                                    createConstantNode(2)
                                ]),
                                createConstantNode(1)
                            ])
                        ])
                    ]);
                    break;
                case "acoth":
                    // d/dx(acoth(x)) = -1 / (1 - x^2)
                    div = true;
                    negative = true;
                    funcDerivative = new OperatorNode("-", "subtract", [
                        createConstantNode(1),
                        new OperatorNode("^", "pow", [
                            arg0.clone(),
                            createConstantNode(2)
                        ])
                    ]);
                    break;
                case "abs":
                    // d/dx(abs(x)) = abs(x)/x
                    funcDerivative = new OperatorNode("/", "divide", [
                        new FunctionNode(new SymbolNode("abs"), [
                            arg0.clone()
                        ]),
                        arg0.clone()
                    ]);
                    break;
                case "gamma":
                default:
                    throw new Error('Function "' + node.name + '" is not supported by derivative, or a wrong number of arguments is passed');
            }
            var op, func;
            if (div) {
                op = "/";
                func = "divide";
            } else {
                op = "*";
                func = "multiply";
            }
            /* Apply chain rule to all functions:
         F(x)  = f(g(x))
         F'(x) = g'(x)*f'(g(x)) */ var chainDerivative = _derivative(arg0, constNodes);
            if (negative) chainDerivative = new OperatorNode("-", "unaryMinus", [
                chainDerivative
            ]);
            return new OperatorNode(op, func, [
                chainDerivative,
                funcDerivative
            ]);
        },
        "OperatorNode, Object": function OperatorNodeObject(node, constNodes) {
            if (constNodes[node] !== undefined) return createConstantNode(0);
            if (node.op === "+") // d/dx(sum(f(x)) = sum(f'(x))
            return new OperatorNode(node.op, node.fn, node.args.map(function(arg) {
                return _derivative(arg, constNodes);
            }));
            if (node.op === "-") {
                // d/dx(+/-f(x)) = +/-f'(x)
                if (node.isUnary()) return new OperatorNode(node.op, node.fn, [
                    _derivative(node.args[0], constNodes)
                ]);
                 // Linearity of differentiation, d/dx(f(x) +/- g(x)) = f'(x) +/- g'(x)
                if (node.isBinary()) return new OperatorNode(node.op, node.fn, [
                    _derivative(node.args[0], constNodes),
                    _derivative(node.args[1], constNodes)
                ]);
            }
            if (node.op === "*") {
                // d/dx(c*f(x)) = c*f'(x)
                var constantTerms = node.args.filter(function(arg) {
                    return constNodes[arg] !== undefined;
                });
                if (constantTerms.length > 0) {
                    var nonConstantTerms = node.args.filter(function(arg) {
                        return constNodes[arg] === undefined;
                    });
                    var nonConstantNode = nonConstantTerms.length === 1 ? nonConstantTerms[0] : new OperatorNode("*", "multiply", nonConstantTerms);
                    var newArgs = constantTerms.concat(_derivative(nonConstantNode, constNodes));
                    return new OperatorNode("*", "multiply", newArgs);
                } // Product Rule, d/dx(f(x)*g(x)) = f'(x)*g(x) + f(x)*g'(x)
                return new OperatorNode("+", "add", node.args.map(function(argOuter) {
                    return new OperatorNode("*", "multiply", node.args.map(function(argInner) {
                        return argInner === argOuter ? _derivative(argInner, constNodes) : argInner.clone();
                    }));
                }));
            }
            if (node.op === "/" && node.isBinary()) {
                var arg0 = node.args[0];
                var arg1 = node.args[1]; // d/dx(f(x) / c) = f'(x) / c
                if (constNodes[arg1] !== undefined) return new OperatorNode("/", "divide", [
                    _derivative(arg0, constNodes),
                    arg1
                ]);
                 // Reciprocal Rule, d/dx(c / f(x)) = -c(f'(x)/f(x)^2)
                if (constNodes[arg0] !== undefined) return new OperatorNode("*", "multiply", [
                    new OperatorNode("-", "unaryMinus", [
                        arg0
                    ]),
                    new OperatorNode("/", "divide", [
                        _derivative(arg1, constNodes),
                        new OperatorNode("^", "pow", [
                            arg1.clone(),
                            createConstantNode(2)
                        ])
                    ])
                ]);
                 // Quotient rule, d/dx(f(x) / g(x)) = (f'(x)g(x) - f(x)g'(x)) / g(x)^2
                return new OperatorNode("/", "divide", [
                    new OperatorNode("-", "subtract", [
                        new OperatorNode("*", "multiply", [
                            _derivative(arg0, constNodes),
                            arg1.clone()
                        ]),
                        new OperatorNode("*", "multiply", [
                            arg0.clone(),
                            _derivative(arg1, constNodes)
                        ])
                    ]),
                    new OperatorNode("^", "pow", [
                        arg1.clone(),
                        createConstantNode(2)
                    ])
                ]);
            }
            if (node.op === "^" && node.isBinary()) {
                var _arg = node.args[0];
                var _arg2 = node.args[1];
                if (constNodes[_arg] !== undefined) {
                    // If is secretly constant; 0^f(x) = 1 (in JS), 1^f(x) = 1
                    if ((0, $1amHZ.isConstantNode)(_arg) && (isZero(_arg.value) || equal(_arg.value, 1))) return createConstantNode(0);
                     // d/dx(c^f(x)) = c^f(x)*ln(c)*f'(x)
                    return new OperatorNode("*", "multiply", [
                        node,
                        new OperatorNode("*", "multiply", [
                            new FunctionNode("log", [
                                _arg.clone()
                            ]),
                            _derivative(_arg2.clone(), constNodes)
                        ])
                    ]);
                }
                if (constNodes[_arg2] !== undefined) {
                    if ((0, $1amHZ.isConstantNode)(_arg2)) {
                        // If is secretly constant; f(x)^0 = 1 -> d/dx(1) = 0
                        if (isZero(_arg2.value)) return createConstantNode(0);
                         // Ignore exponent; f(x)^1 = f(x)
                        if (equal(_arg2.value, 1)) return _derivative(_arg, constNodes);
                    } // Elementary Power Rule, d/dx(f(x)^c) = c*f'(x)*f(x)^(c-1)
                    var powMinusOne = new OperatorNode("^", "pow", [
                        _arg.clone(),
                        new OperatorNode("-", "subtract", [
                            _arg2,
                            createConstantNode(1)
                        ])
                    ]);
                    return new OperatorNode("*", "multiply", [
                        _arg2.clone(),
                        new OperatorNode("*", "multiply", [
                            _derivative(_arg, constNodes),
                            powMinusOne
                        ])
                    ]);
                } // Functional Power Rule, d/dx(f^g) = f^g*[f'*(g/f) + g'ln(f)]
                return new OperatorNode("*", "multiply", [
                    new OperatorNode("^", "pow", [
                        _arg.clone(),
                        _arg2.clone()
                    ]),
                    new OperatorNode("+", "add", [
                        new OperatorNode("*", "multiply", [
                            _derivative(_arg, constNodes),
                            new OperatorNode("/", "divide", [
                                _arg2.clone(),
                                _arg.clone()
                            ])
                        ]),
                        new OperatorNode("*", "multiply", [
                            _derivative(_arg2, constNodes),
                            new FunctionNode("log", [
                                _arg.clone()
                            ])
                        ])
                    ])
                ]);
            }
            throw new Error('Operator "' + node.op + '" is not supported by derivative, or a wrong number of arguments is passed');
        }
    });
    /**
   * Ensures the number of arguments for a function are correct,
   * and will throw an error otherwise.
   *
   * @param {FunctionNode} node
   */ function funcArgsCheck(node) {
        // TODO add min, max etc
        if ((node.name === "log" || node.name === "nthRoot" || node.name === "pow") && node.args.length === 2) return;
         // There should be an incorrect number of arguments if we reach here
        // Change all args to constants to avoid unidentified
        // symbol error when compiling function
        for(var i = 0; i < node.args.length; ++i)node.args[i] = createConstantNode(0);
        node.compile().evaluate();
        throw new Error("Expected TypeError, but none found");
    }
    /**
   * Helper function to create a constant node with a specific type
   * (number, BigNumber, Fraction)
   * @param {number} value
   * @param {string} [valueType]
   * @return {ConstantNode}
   */ function createConstantNode(value, valueType) {
        return new ConstantNode(numeric(value, valueType || config.number));
    }
    return derivative;
});

});

parcelRegister("2TjMU", function(module, exports) {

$parcel$export(module.exports, "createEvaluate", function () { return $21b011418174c1b9$export$4f825d0ade64f616; });

var $e04i1 = parcelRequire("e04i1");

var $2mPYl = parcelRequire("2mPYl");
var $21b011418174c1b9$var$name = "evaluate";
var $21b011418174c1b9$var$dependencies = [
    "typed",
    "parse"
];
var $21b011418174c1b9$export$4f825d0ade64f616 = /* #__PURE__ */ (0, $2mPYl.factory)($21b011418174c1b9$var$name, $21b011418174c1b9$var$dependencies, function(_ref) {
    var typed = _ref.typed, parse = _ref.parse;
    /**
   * Evaluate an expression.
   *
   * Note the evaluating arbitrary expressions may involve security risks,
   * see [https://mathjs.org/docs/expressions/security.html](https://mathjs.org/docs/expressions/security.html) for more information.
   *
   * Syntax:
   *
   *     math.evaluate(expr)
   *     math.evaluate(expr, scope)
   *     math.evaluate([expr1, expr2, expr3, ...])
   *     math.evaluate([expr1, expr2, expr3, ...], scope)
   *
   * Example:
   *
   *     math.evaluate('(2+3)/4')                // 1.25
   *     math.evaluate('sqrt(3^2 + 4^2)')        // 5
   *     math.evaluate('sqrt(-4)')               // 2i
   *     math.evaluate(['a=3', 'b=4', 'a*b'])    // [3, 4, 12]
   *
   *     let scope = {a:3, b:4}
   *     math.evaluate('a * b', scope)           // 12
   *
   * See also:
   *
   *    parse, compile
   *
   * @param {string | string[] | Matrix} expr   The expression to be evaluated
   * @param {Object} [scope]                    Scope to read/write variables
   * @return {*} The result of the expression
   * @throws {Error}
   */ return typed($21b011418174c1b9$var$name, {
        string: function string(expr) {
            var scope = {};
            return parse(expr).compile().evaluate(scope);
        },
        "string, Object": function stringObject(expr, scope) {
            return parse(expr).compile().evaluate(scope);
        },
        "Array | Matrix": function ArrayMatrix(expr) {
            var scope = {};
            return (0, $e04i1.deepMap)(expr, function(entry) {
                return parse(entry).compile().evaluate(scope);
            });
        },
        "Array | Matrix, Object": function ArrayMatrixObject(expr, scope) {
            return (0, $e04i1.deepMap)(expr, function(entry) {
                return parse(entry).compile().evaluate(scope);
            });
        }
    });
});

});

parcelRegister("gHcOy", function(module, exports) {

$parcel$export(module.exports, "createFilterTransform", function () { return $c27a9a287709329e$export$a53d7aa4a2c1e7e3; });

var $1amHZ = parcelRequire("1amHZ");

var $5WdrK = parcelRequire("5WdrK");

var $kpJv9 = parcelRequire("kpJv9");

var $j4nFQ = parcelRequire("j4nFQ");

var $2mPYl = parcelRequire("2mPYl");
var $c27a9a287709329e$var$name = "filter";
var $c27a9a287709329e$var$dependencies = [
    "typed"
];
var $c27a9a287709329e$export$a53d7aa4a2c1e7e3 = /* #__PURE__ */ (0, $2mPYl.factory)($c27a9a287709329e$var$name, $c27a9a287709329e$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Attach a transform function to math.filter
   * Adds a property transform containing the transform function.
   *
   * This transform adds support for equations as test function for math.filter,
   * so you can do something like 'filter([3, -2, 5], x > 0)'.
   */ function filterTransform(args, math, scope) {
        var x, callback;
        if (args[0]) x = args[0].compile().evaluate(scope);
        if (args[1]) {
            if ((0, $1amHZ.isSymbolNode)(args[1]) || (0, $1amHZ.isFunctionAssignmentNode)(args[1])) // a function pointer, like filter([3, -2, 5], myTestFunction)
            callback = args[1].compile().evaluate(scope);
            else // an expression like filter([3, -2, 5], x > 0)
            callback = (0, $j4nFQ.compileInlineExpression)(args[1], math, scope);
        }
        return filter(x, callback);
    }
    filterTransform.rawArgs = true; // one based version of function filter
    var filter = typed("filter", {
        "Array, function": $c27a9a287709329e$var$_filter,
        "Matrix, function": function MatrixFunction(x, test) {
            return x.create($c27a9a287709329e$var$_filter(x.toArray(), test));
        },
        "Array, RegExp": (0, $5WdrK.filterRegExp),
        "Matrix, RegExp": function MatrixRegExp(x, test) {
            return x.create((0, $5WdrK.filterRegExp)(x.toArray(), test));
        }
    });
    return filterTransform;
}, {
    isTransformFunction: true
});
/**
 * Filter values in a callback given a callback function
 *
 * !!! Passes a one-based index !!!
 *
 * @param {Array} x
 * @param {Function} callback
 * @return {Array} Returns the filtered array
 * @private
 */ function $c27a9a287709329e$var$_filter(x, callback) {
    // figure out what number of arguments the callback function expects
    var args = (0, $kpJv9.maxArgumentCount)(callback);
    return (0, $5WdrK.filter)(x, function(value, index, array) {
        // invoke the callback function with the right number of arguments
        if (args === 1) return callback(value);
        else if (args === 2) return callback(value, [
            index + 1
        ]);
        else // 3 or -1
        return callback(value, [
            index + 1
        ], array);
    });
}

});
parcelRegister("kpJv9", function(module, exports) {

$parcel$export(module.exports, "memoize", function () { return $edc9701325f6985d$export$fc10aeed3a532e2a; });
$parcel$export(module.exports, "maxArgumentCount", function () { return $edc9701325f6985d$export$6c00fba23f8c91a7; });
function $edc9701325f6985d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $edc9701325f6985d$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $edc9701325f6985d$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $edc9701325f6985d$var$_typeof(obj);
}
function $edc9701325f6985d$export$fc10aeed3a532e2a(fn, hasher) {
    return function memoize() {
        if ($edc9701325f6985d$var$_typeof(memoize.cache) !== "object") memoize.cache = {};
        var args = [];
        for(var i = 0; i < arguments.length; i++)args[i] = arguments[i];
        var hash = hasher ? hasher(args) : JSON.stringify(args);
        if (!(hash in memoize.cache)) memoize.cache[hash] = fn.apply(fn, args);
        return memoize.cache[hash];
    };
}
function $edc9701325f6985d$export$22992fec26710d5a(fn, isEqual) {
    var memoize = function memoize() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args[i] = arguments[i];
        for(var c = 0; c < memoize.cache.length; c++){
            var cached = memoize.cache[c];
            if (isEqual(args, cached.args)) // TODO: move this cache entry to the top so recently used entries move up?
            return cached.res;
        }
        var res = fn.apply(fn, args);
        memoize.cache.unshift({
            args: args,
            res: res
        });
        return res;
    };
    memoize.cache = [];
    return memoize;
}
function $edc9701325f6985d$export$6c00fba23f8c91a7(fn) {
    return Object.keys(fn.signatures || {}).reduce(function(args, signature) {
        var count = (signature.match(/,/g) || []).length + 1;
        return Math.max(args, count);
    }, -1);
}

});

parcelRegister("j4nFQ", function(module, exports) {

$parcel$export(module.exports, "compileInlineExpression", function () { return $de20c135ea53af9a$export$cbb6101da03c2e83; });

var $1amHZ = parcelRequire("1amHZ");
function $de20c135ea53af9a$export$cbb6101da03c2e83(expression, math, scope) {
    // find an undefined symbol
    var symbol = expression.filter(function(node) {
        return (0, $1amHZ.isSymbolNode)(node) && !(node.name in math) && !(node.name in scope);
    })[0];
    if (!symbol) throw new Error('No undefined variable found in inline expression "' + expression + '"');
     // create a test function for this equation
    var name = symbol.name; // variable name
    var subScope = Object.create(scope);
    var eq = expression.compile();
    return function inlineExpression(x) {
        subScope[name] = x;
        return eq.evaluate(subScope);
    };
}

});


parcelRegister("lvMNH", function(module, exports) {

$parcel$export(module.exports, "createForEachTransform", function () { return $fa92590679d40120$export$342aa09106704265; });

var $1amHZ = parcelRequire("1amHZ");

var $kpJv9 = parcelRequire("kpJv9");

var $5WdrK = parcelRequire("5WdrK");

var $2mPYl = parcelRequire("2mPYl");

var $j4nFQ = parcelRequire("j4nFQ");
var $fa92590679d40120$var$name = "forEach";
var $fa92590679d40120$var$dependencies = [
    "typed"
];
var $fa92590679d40120$export$342aa09106704265 = /* #__PURE__ */ (0, $2mPYl.factory)($fa92590679d40120$var$name, $fa92590679d40120$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Attach a transform function to math.forEach
   * Adds a property transform containing the transform function.
   *
   * This transform creates a one-based index instead of a zero-based index
   */ function forEachTransform(args, math, scope) {
        var x, callback;
        if (args[0]) x = args[0].compile().evaluate(scope);
        if (args[1]) {
            if ((0, $1amHZ.isSymbolNode)(args[1]) || (0, $1amHZ.isFunctionAssignmentNode)(args[1])) // a function pointer, like forEach([3, -2, 5], myTestFunction)
            callback = args[1].compile().evaluate(scope);
            else // an expression like forEach([3, -2, 5], x > 0 ? callback1(x) : callback2(x) )
            callback = (0, $j4nFQ.compileInlineExpression)(args[1], math, scope);
        }
        return _forEach(x, callback);
    }
    forEachTransform.rawArgs = true; // one-based version of forEach
    var _forEach = typed("forEach", {
        "Array | Matrix, function": function ArrayMatrixFunction(array, callback) {
            // figure out what number of arguments the callback function expects
            var args = (0, $kpJv9.maxArgumentCount)(callback);
            var recurse = function recurse(value, index) {
                if (Array.isArray(value)) (0, $5WdrK.forEach)(value, function(child, i) {
                    // we create a copy of the index array and append the new index value
                    recurse(child, index.concat(i + 1)); // one based index, hence i+1
                });
                else {
                    // invoke the callback function with the right number of arguments
                    if (args === 1) callback(value);
                    else if (args === 2) callback(value, index);
                    else // 3 or -1
                    callback(value, index, array);
                }
            };
            recurse(array.valueOf(), []); // pass Array
        }
    });
    return forEachTransform;
}, {
    isTransformFunction: true
});

});

parcelRegister("52TUB", function(module, exports) {

$parcel$export(module.exports, "createFunctionAssignmentNode", function () { return $3ac8829f2173836f$export$fd037c04876b4924; });

var $1amHZ = parcelRequire("1amHZ");

var $5AhuD = parcelRequire("5AhuD");

var $6NxuJ = parcelRequire("6NxuJ");

var $5WdrK = parcelRequire("5WdrK");

var $6Zo9s = parcelRequire("6Zo9s");

var $cAxNq = parcelRequire("cAxNq");

var $45IYD = parcelRequire("45IYD");

var $2mPYl = parcelRequire("2mPYl");
var $3ac8829f2173836f$var$name = "FunctionAssignmentNode";
var $3ac8829f2173836f$var$dependencies = [
    "typed",
    "Node"
];
var $3ac8829f2173836f$export$fd037c04876b4924 = /* #__PURE__ */ (0, $2mPYl.factory)($3ac8829f2173836f$var$name, $3ac8829f2173836f$var$dependencies, function(_ref) {
    var typed = _ref.typed, Node = _ref.Node;
    /**
   * @constructor FunctionAssignmentNode
   * @extends {Node}
   * Function assignment
   *
   * @param {string} name           Function name
   * @param {string[] | Array.<{name: string, type: string}>} params
   *                                Array with function parameter names, or an
   *                                array with objects containing the name
   *                                and type of the parameter
   * @param {Node} expr             The function expression
   */ function FunctionAssignmentNode(name, params, expr) {
        if (!(this instanceof FunctionAssignmentNode)) throw new SyntaxError("Constructor must be called with the new operator");
         // validate input
        if (typeof name !== "string") throw new TypeError('String expected for parameter "name"');
        if (!Array.isArray(params)) throw new TypeError('Array containing strings or objects expected for parameter "params"');
        if (!(0, $1amHZ.isNode)(expr)) throw new TypeError('Node expected for parameter "expr"');
        if (name in (0, $5AhuD.keywords)) throw new Error('Illegal function name, "' + name + '" is a reserved keyword');
        this.name = name;
        this.params = params.map(function(param) {
            return param && param.name || param;
        });
        this.types = params.map(function(param) {
            return param && param.type || "any";
        });
        this.expr = expr;
    }
    FunctionAssignmentNode.prototype = new Node();
    FunctionAssignmentNode.prototype.type = "FunctionAssignmentNode";
    FunctionAssignmentNode.prototype.isFunctionAssignmentNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ FunctionAssignmentNode.prototype._compile = function(math, argNames) {
        var childArgNames = Object.create(argNames);
        (0, $5WdrK.forEach)(this.params, function(param) {
            childArgNames[param] = true;
        }); // compile the function expression with the child args
        var evalExpr = this.expr._compile(math, childArgNames);
        var name = this.name;
        var params = this.params;
        var signature = (0, $5WdrK.join)(this.types, ",");
        var syntax = name + "(" + (0, $5WdrK.join)(this.params, ", ") + ")";
        return function evalFunctionAssignmentNode(scope, args, context) {
            var signatures = {};
            signatures[signature] = function() {
                var childArgs = Object.create(args);
                for(var i = 0; i < params.length; i++)childArgs[params[i]] = arguments[i];
                return evalExpr(scope, childArgs, context);
            };
            var fn = typed(name, signatures);
            fn.syntax = syntax;
            (0, $45IYD.setSafeProperty)(scope, name, fn);
            return fn;
        };
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ FunctionAssignmentNode.prototype.forEach = function(callback) {
        callback(this.expr, "expr", this);
    };
    /**
   * Create a new FunctionAssignmentNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node): Node} callback
   * @returns {FunctionAssignmentNode} Returns a transformed copy of the node
   */ FunctionAssignmentNode.prototype.map = function(callback) {
        var expr = this._ifNode(callback(this.expr, "expr", this));
        return new FunctionAssignmentNode(this.name, this.params.slice(0), expr);
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {FunctionAssignmentNode}
   */ FunctionAssignmentNode.prototype.clone = function() {
        return new FunctionAssignmentNode(this.name, this.params.slice(0), this.expr);
    };
    /**
   * Is parenthesis needed?
   * @param {Node} node
   * @param {Object} parenthesis
   * @private
   */ function needParenthesis(node, parenthesis) {
        var precedence = (0, $cAxNq.getPrecedence)(node, parenthesis);
        var exprPrecedence = (0, $cAxNq.getPrecedence)(node.expr, parenthesis);
        return parenthesis === "all" || exprPrecedence !== null && exprPrecedence <= precedence;
    }
    /**
   * get string representation
   * @param {Object} options
   * @return {string} str
   */ FunctionAssignmentNode.prototype._toString = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var expr = this.expr.toString(options);
        if (needParenthesis(this, parenthesis)) expr = "(" + expr + ")";
        return this.name + "(" + this.params.join(", ") + ") = " + expr;
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ FunctionAssignmentNode.prototype.toJSON = function() {
        var types = this.types;
        return {
            mathjs: "FunctionAssignmentNode",
            name: this.name,
            params: this.params.map(function(param, index) {
                return {
                    name: param,
                    type: types[index]
                };
            }),
            expr: this.expr
        };
    };
    /**
   * Instantiate an FunctionAssignmentNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "FunctionAssignmentNode", name: ..., params: ..., expr: ...}`,
   *                       where mathjs is optional
   * @returns {FunctionAssignmentNode}
   */ FunctionAssignmentNode.fromJSON = function(json) {
        return new FunctionAssignmentNode(json.name, json.params, json.expr);
    };
    /**
   * get HTML representation
   * @param {Object} options
   * @return {string} str
   */ FunctionAssignmentNode.prototype.toHTML = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var params = [];
        for(var i = 0; i < this.params.length; i++)params.push('<span class="math-symbol math-parameter">' + (0, $6NxuJ.escape)(this.params[i]) + "</span>");
        var expr = this.expr.toHTML(options);
        if (needParenthesis(this, parenthesis)) expr = '<span class="math-parenthesis math-round-parenthesis">(</span>' + expr + '<span class="math-parenthesis math-round-parenthesis">)</span>';
        return '<span class="math-function">' + (0, $6NxuJ.escape)(this.name) + "</span>" + '<span class="math-parenthesis math-round-parenthesis">(</span>' + params.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-round-parenthesis">)</span><span class="math-operator math-assignment-operator math-variable-assignment-operator math-binary-operator">=</span>' + expr;
    };
    /**
   * get LaTeX representation
   * @param {Object} options
   * @return {string} str
   */ FunctionAssignmentNode.prototype._toTex = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var expr = this.expr.toTex(options);
        if (needParenthesis(this, parenthesis)) expr = "\\left(".concat(expr, "\\right)");
        return "\\mathrm{" + this.name + "}\\left(" + this.params.map((0, $6Zo9s.toSymbol)).join(",") + "\\right):=" + expr;
    };
    return FunctionAssignmentNode;
}, {
    isClass: true,
    isNode: true
});

});
parcelRegister("5AhuD", function(module, exports) {

$parcel$export(module.exports, "keywords", function () { return $410de24cbbfd2e29$export$eebaaf2b24d91f63; });
// Reserved keywords not allowed to use in the parser
var $410de24cbbfd2e29$export$eebaaf2b24d91f63 = {
    end: true
};

});


parcelRegister("gT4Ra", function(module, exports) {

$parcel$export(module.exports, "createFunctionNode", function () { return $c4b58ccb2268f505$export$d03e7338a74cdf4c; });

var $1amHZ = parcelRequire("1amHZ");

var $6NxuJ = parcelRequire("6NxuJ");

var $7ITGG = parcelRequire("7ITGG");

var $5WdrK = parcelRequire("5WdrK");

var $45IYD = parcelRequire("45IYD");

var $2mPYl = parcelRequire("2mPYl");

var $6Zo9s = parcelRequire("6Zo9s");
function $c4b58ccb2268f505$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $c4b58ccb2268f505$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $c4b58ccb2268f505$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $c4b58ccb2268f505$var$_typeof(obj);
}
function $c4b58ccb2268f505$var$_extends() {
    $c4b58ccb2268f505$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c4b58ccb2268f505$var$_extends.apply(this, arguments);
}
var $c4b58ccb2268f505$var$name = "FunctionNode";
var $c4b58ccb2268f505$var$dependencies = [
    "math",
    "Node",
    "SymbolNode"
];
var $c4b58ccb2268f505$export$d03e7338a74cdf4c = /* #__PURE__ */ (0, $2mPYl.factory)($c4b58ccb2268f505$var$name, $c4b58ccb2268f505$var$dependencies, function(_ref) {
    var math = _ref.math, Node = _ref.Node, SymbolNode = _ref.SymbolNode;
    /**
   * @constructor FunctionNode
   * @extends {./Node}
   * invoke a list with arguments on a node
   * @param {./Node | string} fn Node resolving with a function on which to invoke
   *                             the arguments, typically a SymboNode or AccessorNode
   * @param {./Node[]} args
   */ function FunctionNode(fn, args) {
        if (!(this instanceof FunctionNode)) throw new SyntaxError("Constructor must be called with the new operator");
        if (typeof fn === "string") fn = new SymbolNode(fn);
         // validate input
        if (!(0, $1amHZ.isNode)(fn)) throw new TypeError('Node expected as parameter "fn"');
        if (!Array.isArray(args) || !args.every((0, $1amHZ.isNode))) throw new TypeError('Array containing Nodes expected for parameter "args"');
        this.fn = fn;
        this.args = args || []; // readonly property name
        Object.defineProperty(this, "name", {
            get: (function() {
                return this.fn.name || "";
            }).bind(this),
            set: function set() {
                throw new Error("Cannot assign a new name, name is read-only");
            }
        }); // TODO: deprecated since v3, remove some day
        var deprecated = function deprecated() {
            throw new Error("Property `FunctionNode.object` is deprecated, use `FunctionNode.fn` instead");
        };
        Object.defineProperty(this, "object", {
            get: deprecated,
            set: deprecated
        });
    }
    FunctionNode.prototype = new Node();
    FunctionNode.prototype.type = "FunctionNode";
    FunctionNode.prototype.isFunctionNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ FunctionNode.prototype._compile = function(math, argNames) {
        if (!(this instanceof FunctionNode)) throw new TypeError("No valid FunctionNode");
         // compile arguments
        var evalArgs = (0, $5WdrK.map)(this.args, function(arg) {
            return arg._compile(math, argNames);
        });
        if ((0, $1amHZ.isSymbolNode)(this.fn)) {
            // we can statically determine whether the function has an rawArgs property
            var _name = this.fn.name;
            var fn = _name in math ? (0, $45IYD.getSafeProperty)(math, _name) : undefined;
            var isRaw = typeof fn === "function" && fn.rawArgs === true;
            if (isRaw) {
                // pass unevaluated parameters (nodes) to the function
                // "raw" evaluation
                var rawArgs = this.args;
                return function evalFunctionNode(scope, args, context) {
                    return (_name in scope ? (0, $45IYD.getSafeProperty)(scope, _name) : fn)(rawArgs, math, $c4b58ccb2268f505$var$_extends({}, scope, args));
                };
            } else {
                // "regular" evaluation
                if (evalArgs.length === 1) {
                    var evalArg0 = evalArgs[0];
                    return function evalFunctionNode(scope, args, context) {
                        return (_name in scope ? (0, $45IYD.getSafeProperty)(scope, _name) : fn)(evalArg0(scope, args, context));
                    };
                } else if (evalArgs.length === 2) {
                    var _evalArg = evalArgs[0];
                    var evalArg1 = evalArgs[1];
                    return function evalFunctionNode(scope, args, context) {
                        return (_name in scope ? (0, $45IYD.getSafeProperty)(scope, _name) : fn)(_evalArg(scope, args, context), evalArg1(scope, args, context));
                    };
                } else return function evalFunctionNode(scope, args, context) {
                    return (_name in scope ? (0, $45IYD.getSafeProperty)(scope, _name) : fn).apply(null, (0, $5WdrK.map)(evalArgs, function(evalArg) {
                        return evalArg(scope, args, context);
                    }));
                };
            }
        } else if ((0, $1amHZ.isAccessorNode)(this.fn) && (0, $1amHZ.isIndexNode)(this.fn.index) && this.fn.index.isObjectProperty()) {
            // execute the function with the right context: the object of the AccessorNode
            var evalObject = this.fn.object._compile(math, argNames);
            var prop = this.fn.index.getObjectProperty();
            var _rawArgs = this.args;
            return function evalFunctionNode(scope, args, context) {
                var object = evalObject(scope, args, context);
                (0, $45IYD.validateSafeMethod)(object, prop);
                var isRaw = object[prop] && object[prop].rawArgs;
                return isRaw ? object[prop](_rawArgs, math, $c4b58ccb2268f505$var$_extends({}, scope, args)) // "raw" evaluation
                 : object[prop].apply(object, (0, $5WdrK.map)(evalArgs, function(evalArg) {
                    // "regular" evaluation
                    return evalArg(scope, args, context);
                }));
            };
        } else {
            // node.fn.isAccessorNode && !node.fn.index.isObjectProperty()
            // we have to dynamically determine whether the function has a rawArgs property
            var evalFn = this.fn._compile(math, argNames);
            var _rawArgs2 = this.args;
            return function evalFunctionNode(scope, args, context) {
                var fn = evalFn(scope, args, context);
                var isRaw = fn && fn.rawArgs;
                return isRaw ? fn(_rawArgs2, math, $c4b58ccb2268f505$var$_extends({}, scope, args)) // "raw" evaluation
                 : fn.apply(fn, (0, $5WdrK.map)(evalArgs, function(evalArg) {
                    // "regular" evaluation
                    return evalArg(scope, args, context);
                }));
            };
        }
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ FunctionNode.prototype.forEach = function(callback) {
        callback(this.fn, "fn", this);
        for(var i = 0; i < this.args.length; i++)callback(this.args[i], "args[" + i + "]", this);
    };
    /**
   * Create a new FunctionNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node): Node} callback
   * @returns {FunctionNode} Returns a transformed copy of the node
   */ FunctionNode.prototype.map = function(callback) {
        var fn = this._ifNode(callback(this.fn, "fn", this));
        var args = [];
        for(var i = 0; i < this.args.length; i++)args[i] = this._ifNode(callback(this.args[i], "args[" + i + "]", this));
        return new FunctionNode(fn, args);
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {FunctionNode}
   */ FunctionNode.prototype.clone = function() {
        return new FunctionNode(this.fn, this.args.slice(0));
    }; // backup Node's toString function
    // @private
    var nodeToString = FunctionNode.prototype.toString;
    /**
   * Get string representation. (wrapper function)
   * This overrides parts of Node's toString function.
   * If callback is an object containing callbacks, it
   * calls the correct callback for the current node,
   * otherwise it falls back to calling Node's toString
   * function.
   *
   * @param {Object} options
   * @return {string} str
   * @override
   */ FunctionNode.prototype.toString = function(options) {
        var customString;
        var name = this.fn.toString(options);
        if (options && $c4b58ccb2268f505$var$_typeof(options.handler) === "object" && (0, $7ITGG.hasOwnProperty)(options.handler, name)) // callback is a map of callback functions
        customString = options.handler[name](this, options);
        if (typeof customString !== "undefined") return customString;
         // fall back to Node's toString
        return nodeToString.call(this, options);
    };
    /**
   * Get string representation
   * @param {Object} options
   * @return {string} str
   */ FunctionNode.prototype._toString = function(options) {
        var args = this.args.map(function(arg) {
            return arg.toString(options);
        });
        var fn = (0, $1amHZ.isFunctionAssignmentNode)(this.fn) ? "(" + this.fn.toString(options) + ")" : this.fn.toString(options); // format the arguments like "add(2, 4.2)"
        return fn + "(" + args.join(", ") + ")";
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ FunctionNode.prototype.toJSON = function() {
        return {
            mathjs: "FunctionNode",
            fn: this.fn,
            args: this.args
        };
    };
    /**
   * Instantiate an AssignmentNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "FunctionNode", fn: ..., args: ...}`,
   *                       where mathjs is optional
   * @returns {FunctionNode}
   */ FunctionNode.fromJSON = function(json) {
        return new FunctionNode(json.fn, json.args);
    };
    /**
   * Get HTML representation
   * @param {Object} options
   * @return {string} str
   */ FunctionNode.prototype.toHTML = function(options) {
        var args = this.args.map(function(arg) {
            return arg.toHTML(options);
        }); // format the arguments like "add(2, 4.2)"
        return '<span class="math-function">' + (0, $6NxuJ.escape)(this.fn) + '</span><span class="math-paranthesis math-round-parenthesis">(</span>' + args.join('<span class="math-separator">,</span>') + '<span class="math-paranthesis math-round-parenthesis">)</span>';
    };
    /*
   * Expand a LaTeX template
   *
   * @param {string} template
   * @param {Node} node
   * @param {Object} options
   * @private
   **/ function expandTemplate(template, node, options) {
        var latex = ""; // Match everything of the form ${identifier} or ${identifier[2]} or $$
        // while submatching identifier and 2 (in the second case)
        var regex = new RegExp("\\$(?:\\{([a-z_][a-z_0-9]*)(?:\\[([0-9]+)\\])?\\}|\\$)", "ig");
        var inputPos = 0; // position in the input string
        var match;
        while((match = regex.exec(template)) !== null){
            // go through all matches
            // add everything in front of the match to the LaTeX string
            latex += template.substring(inputPos, match.index);
            inputPos = match.index;
            if (match[0] === "$$") {
                // escaped dollar sign
                latex += "$";
                inputPos++;
            } else {
                // template parameter
                inputPos += match[0].length;
                var property = node[match[1]];
                if (!property) throw new ReferenceError("Template: Property " + match[1] + " does not exist.");
                if (match[2] === undefined) // no square brackets
                switch($c4b58ccb2268f505$var$_typeof(property)){
                    case "string":
                        latex += property;
                        break;
                    case "object":
                        if ((0, $1amHZ.isNode)(property)) latex += property.toTex(options);
                        else if (Array.isArray(property)) // make array of Nodes into comma separated list
                        latex += property.map(function(arg, index) {
                            if ((0, $1amHZ.isNode)(arg)) return arg.toTex(options);
                            throw new TypeError("Template: " + match[1] + "[" + index + "] is not a Node.");
                        }).join(",");
                        else throw new TypeError("Template: " + match[1] + " has to be a Node, String or array of Nodes");
                        break;
                    default:
                        throw new TypeError("Template: " + match[1] + " has to be a Node, String or array of Nodes");
                }
                else {
                    // with square brackets
                    if ((0, $1amHZ.isNode)(property[match[2]] && property[match[2]])) latex += property[match[2]].toTex(options);
                    else throw new TypeError("Template: " + match[1] + "[" + match[2] + "] is not a Node.");
                }
            }
        }
        latex += template.slice(inputPos); // append rest of the template
        return latex;
    } // backup Node's toTex function
    // @private
    var nodeToTex = FunctionNode.prototype.toTex;
    /**
   * Get LaTeX representation. (wrapper function)
   * This overrides parts of Node's toTex function.
   * If callback is an object containing callbacks, it
   * calls the correct callback for the current node,
   * otherwise it falls back to calling Node's toTex
   * function.
   *
   * @param {Object} options
   * @return {string}
   */ FunctionNode.prototype.toTex = function(options) {
        var customTex;
        if (options && $c4b58ccb2268f505$var$_typeof(options.handler) === "object" && (0, $7ITGG.hasOwnProperty)(options.handler, this.name)) // callback is a map of callback functions
        customTex = options.handler[this.name](this, options);
        if (typeof customTex !== "undefined") return customTex;
         // fall back to Node's toTex
        return nodeToTex.call(this, options);
    };
    /**
   * Get LaTeX representation
   * @param {Object} options
   * @return {string} str
   */ FunctionNode.prototype._toTex = function(options) {
        var args = this.args.map(function(arg) {
            // get LaTeX of the arguments
            return arg.toTex(options);
        });
        var latexConverter;
        if ((0, $6Zo9s.latexFunctions)[this.name]) latexConverter = (0, $6Zo9s.latexFunctions)[this.name];
         // toTex property on the function itself
        if (math[this.name] && (typeof math[this.name].toTex === "function" || $c4b58ccb2268f505$var$_typeof(math[this.name].toTex) === "object" || typeof math[this.name].toTex === "string")) // .toTex is a callback function
        latexConverter = math[this.name].toTex;
        var customToTex;
        switch($c4b58ccb2268f505$var$_typeof(latexConverter)){
            case "function":
                // a callback function
                customToTex = latexConverter(this, options);
                break;
            case "string":
                // a template string
                customToTex = expandTemplate(latexConverter, this, options);
                break;
            case "object":
                // an object with different "converters" for different numbers of arguments
                switch($c4b58ccb2268f505$var$_typeof(latexConverter[args.length])){
                    case "function":
                        customToTex = latexConverter[args.length](this, options);
                        break;
                    case "string":
                        customToTex = expandTemplate(latexConverter[args.length], this, options);
                        break;
                }
        }
        if (typeof customToTex !== "undefined") return customToTex;
        return expandTemplate((0, $6Zo9s.defaultTemplate), this, options);
    };
    /**
   * Get identifier.
   * @return {string}
   */ FunctionNode.prototype.getIdentifier = function() {
        return this.type + ":" + this.name;
    };
    return FunctionNode;
}, {
    isClass: true,
    isNode: true
});

});

parcelRegister("ehBJU", function(module, exports) {

$parcel$export(module.exports, "createHelp", function () { return $a65fed78931b0c5b$export$cbe80567b8b3b8ac; });

var $2mPYl = parcelRequire("2mPYl");

var $45IYD = parcelRequire("45IYD");

var $1q9yd = parcelRequire("1q9yd");

var $7ITGG = parcelRequire("7ITGG");
var $a65fed78931b0c5b$var$name = "help";
var $a65fed78931b0c5b$var$dependencies = [
    "typed",
    "mathWithTransform",
    "Help"
];
var $a65fed78931b0c5b$export$cbe80567b8b3b8ac = /* #__PURE__ */ (0, $2mPYl.factory)($a65fed78931b0c5b$var$name, $a65fed78931b0c5b$var$dependencies, function(_ref) {
    var typed = _ref.typed, mathWithTransform = _ref.mathWithTransform, Help = _ref.Help;
    /**
   * Retrieve help on a function or data type.
   * Help files are retrieved from the embedded documentation in math.docs.
   *
   * Syntax:
   *
   *    math.help(search)
   *
   * Examples:
   *
   *    console.log(math.help('sin').toString())
   *    console.log(math.help(math.add).toString())
   *    console.log(math.help(math.add).toJSON())
   *
   * @param {Function | string | Object} search   A function or function name
   *                                              for which to get help
   * @return {Help} A help object
   */ return typed($a65fed78931b0c5b$var$name, {
        any: function any(search) {
            var prop;
            var searchName = search;
            if (typeof search !== "string") {
                for(prop in mathWithTransform)// search in functions and constants
                if ((0, $7ITGG.hasOwnProperty)(mathWithTransform, prop) && search === mathWithTransform[prop]) {
                    searchName = prop;
                    break;
                }
            /* TODO: implement help for data types
         if (!text) {
         // search data type
         for (prop in math.type) {
         if (hasOwnProperty(math, prop)) {
         if (search === math.type[prop]) {
         text = prop
         break
         }
         }
         }
         }
         */ }
            var doc = (0, $45IYD.getSafeProperty)((0, $1q9yd.embeddedDocs), searchName);
            if (!doc) {
                var searchText = typeof searchName === "function" ? searchName.name : searchName;
                throw new Error('No documentation found on "' + searchText + '"');
            }
            return new Help(doc);
        }
    });
});

});
parcelRegister("1q9yd", function(module, exports) {

$parcel$export(module.exports, "embeddedDocs", function () { return $108fa0c525a4406e$export$c2adf0a3344c85c9; });

var $5kzEv = parcelRequire("5kzEv");

var $8kX3O = parcelRequire("8kX3O");

var $hdNYo = parcelRequire("hdNYo");

var $hxi9q = parcelRequire("hxi9q");

var $ccULi = parcelRequire("ccULi");

var $jzRMx = parcelRequire("jzRMx");

var $aQx2E = parcelRequire("aQx2E");

var $ead42 = parcelRequire("ead42");

var $7Dcqm = parcelRequire("7Dcqm");

var $177rE = parcelRequire("177rE");

var $3qRXF = parcelRequire("3qRXF");

var $lLteI = parcelRequire("lLteI");

var $lJcO2 = parcelRequire("lJcO2");

var $2l1Oz = parcelRequire("2l1Oz");

var $4dG2O = parcelRequire("4dG2O");

var $dBtQs = parcelRequire("dBtQs");

var $cuD5n = parcelRequire("cuD5n");

var $f6WHL = parcelRequire("f6WHL");

var $dALHF = parcelRequire("dALHF");

var $I1r5m = parcelRequire("I1r5m");

var $cTfOk = parcelRequire("cTfOk");

var $7XT8h = parcelRequire("7XT8h");

var $2TjDj = parcelRequire("2TjDj");

var $eSl11 = parcelRequire("eSl11");

var $h0sRW = parcelRequire("h0sRW");

var $7Ejfz = parcelRequire("7Ejfz");

var $1x5s1 = parcelRequire("1x5s1");

var $5jiAW = parcelRequire("5jiAW");

var $elvDr = parcelRequire("elvDr");

var $l1L0N = parcelRequire("l1L0N");

var $tGO2Q = parcelRequire("tGO2Q");

var $am6DR = parcelRequire("am6DR");

var $8MOt5 = parcelRequire("8MOt5");

var $4pXds = parcelRequire("4pXds");

var $2Y2zy = parcelRequire("2Y2zy");

var $fT0yP = parcelRequire("fT0yP");

var $6ohB2 = parcelRequire("6ohB2");

var $iNen5 = parcelRequire("iNen5");

var $cHsca = parcelRequire("cHsca");

var $3J6Dw = parcelRequire("3J6Dw");

var $77yAj = parcelRequire("77yAj");

var $cD720 = parcelRequire("cD720");

var $8zOz4 = parcelRequire("8zOz4");

var $l2j6x = parcelRequire("l2j6x");

var $2BF6s = parcelRequire("2BF6s");

var $5sM0g = parcelRequire("5sM0g");

var $jKiII = parcelRequire("jKiII");

var $3LIoX = parcelRequire("3LIoX");

var $gjqkX = parcelRequire("gjqkX");

var $5CuJu = parcelRequire("5CuJu");

var $4UV5j = parcelRequire("4UV5j");

var $gClhT = parcelRequire("gClhT");

var $1JgD8 = parcelRequire("1JgD8");

var $5metl = parcelRequire("5metl");

var $hXFLv = parcelRequire("hXFLv");

var $5jTG7 = parcelRequire("5jTG7");

var $1HbGK = parcelRequire("1HbGK");

var $hswFv = parcelRequire("hswFv");

var $1vn8b = parcelRequire("1vn8b");

var $iD8Dz = parcelRequire("iD8Dz");

var $pAd0e = parcelRequire("pAd0e");

var $fMspx = parcelRequire("fMspx");

var $29Sk0 = parcelRequire("29Sk0");

var $5rQ2p = parcelRequire("5rQ2p");

var $hWjKc = parcelRequire("hWjKc");

var $f4IAk = parcelRequire("f4IAk");

var $esSbP = parcelRequire("esSbP");

var $cJOhk = parcelRequire("cJOhk");

var $bPPUd = parcelRequire("bPPUd");

var $bhUEc = parcelRequire("bhUEc");

var $iqyuY = parcelRequire("iqyuY");

var $6oAiR = parcelRequire("6oAiR");

var $Hb4my = parcelRequire("Hb4my");

var $6zv1C = parcelRequire("6zv1C");

var $94ozR = parcelRequire("94ozR");

var $jWioE = parcelRequire("jWioE");

var $98IcR = parcelRequire("98IcR");

var $5jAbk = parcelRequire("5jAbk");

var $ajzBf = parcelRequire("ajzBf");

var $4xjiF = parcelRequire("4xjiF");

var $6NTLP = parcelRequire("6NTLP");

var $5dNX5 = parcelRequire("5dNX5");

var $9upGK = parcelRequire("9upGK");

var $ep8CJ = parcelRequire("ep8CJ");

var $7iAxZ = parcelRequire("7iAxZ");

var $8sSTA = parcelRequire("8sSTA");

var $2IAga = parcelRequire("2IAga");

var $bK9Ub = parcelRequire("bK9Ub");

var $iCWKL = parcelRequire("iCWKL");

var $7w6rE = parcelRequire("7w6rE");

var $ejDM7 = parcelRequire("ejDM7");

var $caseB = parcelRequire("caseB");

var $fzWrz = parcelRequire("fzWrz");

var $1eZRj = parcelRequire("1eZRj");

var $5aBGU = parcelRequire("5aBGU");

var $bNrUA = parcelRequire("bNrUA");

var $9P90h = parcelRequire("9P90h");

var $kT6kx = parcelRequire("kT6kx");

var $8a0Jr = parcelRequire("8a0Jr");

var $2dqcg = parcelRequire("2dqcg");

var $2x6QV = parcelRequire("2x6QV");

var $eDw1l = parcelRequire("eDw1l");

var $gohFp = parcelRequire("gohFp");

var $72AW0 = parcelRequire("72AW0");

var $auL4F = parcelRequire("auL4F");

var $ab3Mw = parcelRequire("ab3Mw");

var $03EUJ = parcelRequire("03EUJ");

var $iEbSj = parcelRequire("iEbSj");

var $jWo8L = parcelRequire("jWo8L");

var $6nd4e = parcelRequire("6nd4e");

var $7xW65 = parcelRequire("7xW65");

var $dxQ9l = parcelRequire("dxQ9l");

var $fAyhW = parcelRequire("fAyhW");

var $2c5zB = parcelRequire("2c5zB");

var $dZ8st = parcelRequire("dZ8st");

var $6W62t = parcelRequire("6W62t");

var $80r5u = parcelRequire("80r5u");

var $bjbPq = parcelRequire("bjbPq");

var $jrwph = parcelRequire("jrwph");

var $7PMEC = parcelRequire("7PMEC");

var $1Is2D = parcelRequire("1Is2D");

var $4mq0M = parcelRequire("4mq0M");

var $8vAqe = parcelRequire("8vAqe");

var $aoMft = parcelRequire("aoMft");

var $bJGII = parcelRequire("bJGII");

var $5VeVS = parcelRequire("5VeVS");

var $MtLIv = parcelRequire("MtLIv");

var $jJ2Hn = parcelRequire("jJ2Hn");

var $aK9ta = parcelRequire("aK9ta");

var $kTOSY = parcelRequire("kTOSY");

var $5Bnil = parcelRequire("5Bnil");

var $hFxzz = parcelRequire("hFxzz");

var $aCwWZ = parcelRequire("aCwWZ");

var $4xJia = parcelRequire("4xJia");

var $guRgs = parcelRequire("guRgs");

var $3FZHK = parcelRequire("3FZHK");

var $eQI16 = parcelRequire("eQI16");

var $2SqMq = parcelRequire("2SqMq");

var $lANzd = parcelRequire("lANzd");

var $ebxdO = parcelRequire("ebxdO");

var $5myNz = parcelRequire("5myNz");

var $gVdRU = parcelRequire("gVdRU");

var $j7uge = parcelRequire("j7uge");

var $8UIvy = parcelRequire("8UIvy");

var $i3zPi = parcelRequire("i3zPi");

var $9VyOB = parcelRequire("9VyOB");

var $1VKaL = parcelRequire("1VKaL");

var $k0oGZ = parcelRequire("k0oGZ");

var $hfhXI = parcelRequire("hfhXI");

var $9tjy2 = parcelRequire("9tjy2");

var $2CUEz = parcelRequire("2CUEz");

var $eKbt8 = parcelRequire("eKbt8");

var $1nuwR = parcelRequire("1nuwR");

var $aPSFs = parcelRequire("aPSFs");

var $aucjV = parcelRequire("aucjV");

var $6kdGd = parcelRequire("6kdGd");

var $fiOXs = parcelRequire("fiOXs");

var $66pcK = parcelRequire("66pcK");

var $hHuRe = parcelRequire("hHuRe");

var $7qL1g = parcelRequire("7qL1g");

var $3pLqw = parcelRequire("3pLqw");

var $7X0mg = parcelRequire("7X0mg");

var $9V40U = parcelRequire("9V40U");

var $bp2rB = parcelRequire("bp2rB");

var $ev3N4 = parcelRequire("ev3N4");

var $9JtUj = parcelRequire("9JtUj");

var $6cUvE = parcelRequire("6cUvE");

var $hBK1o = parcelRequire("hBK1o");

var $6CCvg = parcelRequire("6CCvg");

var $34utO = parcelRequire("34utO");

var $4H26S = parcelRequire("4H26S");

var $gR5wf = parcelRequire("gR5wf");

var $bj0Pn = parcelRequire("bj0Pn");

var $4FuGC = parcelRequire("4FuGC");

var $kRHRd = parcelRequire("kRHRd");

var $kyiN3 = parcelRequire("kyiN3");

var $h1Xj3 = parcelRequire("h1Xj3");

var $ct3Ip = parcelRequire("ct3Ip");

var $4wx44 = parcelRequire("4wx44");

var $lYjVz = parcelRequire("lYjVz");

var $cTzze = parcelRequire("cTzze");

var $63VU1 = parcelRequire("63VU1");

var $8c7fr = parcelRequire("8c7fr");

var $itTiH = parcelRequire("itTiH");

var $fmiHs = parcelRequire("fmiHs");

var $ccMvY = parcelRequire("ccMvY");

var $iqRSN = parcelRequire("iqRSN");

var $bRBg8 = parcelRequire("bRBg8");

var $b2VFA = parcelRequire("b2VFA");

var $h6xG2 = parcelRequire("h6xG2");

var $2GX6q = parcelRequire("2GX6q");

var $hIK3f = parcelRequire("hIK3f");

var $dt2RG = parcelRequire("dt2RG");

var $93VPs = parcelRequire("93VPs");

var $4ZofO = parcelRequire("4ZofO");

var $ixFIj = parcelRequire("ixFIj");

var $3qbVG = parcelRequire("3qbVG");

var $jOQNC = parcelRequire("jOQNC");

var $ddhGV = parcelRequire("ddhGV");

var $ct5JI = parcelRequire("ct5JI");

var $aXBsd = parcelRequire("aXBsd");

var $j9kpd = parcelRequire("j9kpd");

var $giZIF = parcelRequire("giZIF");

var $k4gW9 = parcelRequire("k4gW9");

var $2xP82 = parcelRequire("2xP82");

var $17xd2 = parcelRequire("17xd2");

var $gl9oO = parcelRequire("gl9oO");

var $3xnbV = parcelRequire("3xnbV");

var $94H8i = parcelRequire("94H8i");

var $lQaPd = parcelRequire("lQaPd");
var $108fa0c525a4406e$export$c2adf0a3344c85c9 = {
    // construction functions
    bignumber: (0, $5kzEv.bignumberDocs),
    "boolean": (0, $j9kpd.booleanDocs),
    complex: (0, $aXBsd.complexDocs),
    createUnit: (0, $ct5JI.createUnitDocs),
    fraction: (0, $ddhGV.fractionDocs),
    index: (0, $jOQNC.indexDocs),
    matrix: (0, $3qbVG.matrixDocs),
    number: (0, $ixFIj.numberDocs),
    sparse: (0, $4ZofO.sparseDocs),
    splitUnit: (0, $93VPs.splitUnitDocs),
    string: (0, $dt2RG.stringDocs),
    unit: (0, $hIK3f.unitDocs),
    // constants
    e: (0, $2GX6q.eDocs),
    E: (0, $2GX6q.eDocs),
    "false": (0, $h6xG2.falseDocs),
    i: (0, $b2VFA.iDocs),
    Infinity: (0, $bRBg8.InfinityDocs),
    LN2: (0, $iqRSN.LN2Docs),
    LN10: (0, $ccMvY.LN10Docs),
    LOG2E: (0, $fmiHs.LOG2EDocs),
    LOG10E: (0, $itTiH.LOG10EDocs),
    NaN: (0, $8c7fr.NaNDocs),
    "null": (0, $63VU1.nullDocs),
    pi: (0, $cTzze.piDocs),
    PI: (0, $cTzze.piDocs),
    phi: (0, $lYjVz.phiDocs),
    SQRT1_2: (0, $4wx44.SQRT12Docs),
    SQRT2: (0, $ct3Ip.SQRT2Docs),
    tau: (0, $h1Xj3.tauDocs),
    "true": (0, $kyiN3.trueDocs),
    version: (0, $kRHRd.versionDocs),
    // physical constants
    // TODO: more detailed docs for physical constants
    speedOfLight: {
        description: "Speed of light in vacuum",
        examples: [
            "speedOfLight"
        ]
    },
    gravitationConstant: {
        description: "Newtonian constant of gravitation",
        examples: [
            "gravitationConstant"
        ]
    },
    planckConstant: {
        description: "Planck constant",
        examples: [
            "planckConstant"
        ]
    },
    reducedPlanckConstant: {
        description: "Reduced Planck constant",
        examples: [
            "reducedPlanckConstant"
        ]
    },
    magneticConstant: {
        description: "Magnetic constant (vacuum permeability)",
        examples: [
            "magneticConstant"
        ]
    },
    electricConstant: {
        description: "Electric constant (vacuum permeability)",
        examples: [
            "electricConstant"
        ]
    },
    vacuumImpedance: {
        description: "Characteristic impedance of vacuum",
        examples: [
            "vacuumImpedance"
        ]
    },
    coulomb: {
        description: "Coulomb's constant",
        examples: [
            "coulomb"
        ]
    },
    elementaryCharge: {
        description: "Elementary charge",
        examples: [
            "elementaryCharge"
        ]
    },
    bohrMagneton: {
        description: "Borh magneton",
        examples: [
            "bohrMagneton"
        ]
    },
    conductanceQuantum: {
        description: "Conductance quantum",
        examples: [
            "conductanceQuantum"
        ]
    },
    inverseConductanceQuantum: {
        description: "Inverse conductance quantum",
        examples: [
            "inverseConductanceQuantum"
        ]
    },
    // josephson: {description: 'Josephson constant', examples: ['josephson']},
    magneticFluxQuantum: {
        description: "Magnetic flux quantum",
        examples: [
            "magneticFluxQuantum"
        ]
    },
    nuclearMagneton: {
        description: "Nuclear magneton",
        examples: [
            "nuclearMagneton"
        ]
    },
    klitzing: {
        description: "Von Klitzing constant",
        examples: [
            "klitzing"
        ]
    },
    bohrRadius: {
        description: "Borh radius",
        examples: [
            "bohrRadius"
        ]
    },
    classicalElectronRadius: {
        description: "Classical electron radius",
        examples: [
            "classicalElectronRadius"
        ]
    },
    electronMass: {
        description: "Electron mass",
        examples: [
            "electronMass"
        ]
    },
    fermiCoupling: {
        description: "Fermi coupling constant",
        examples: [
            "fermiCoupling"
        ]
    },
    fineStructure: {
        description: "Fine-structure constant",
        examples: [
            "fineStructure"
        ]
    },
    hartreeEnergy: {
        description: "Hartree energy",
        examples: [
            "hartreeEnergy"
        ]
    },
    protonMass: {
        description: "Proton mass",
        examples: [
            "protonMass"
        ]
    },
    deuteronMass: {
        description: "Deuteron Mass",
        examples: [
            "deuteronMass"
        ]
    },
    neutronMass: {
        description: "Neutron mass",
        examples: [
            "neutronMass"
        ]
    },
    quantumOfCirculation: {
        description: "Quantum of circulation",
        examples: [
            "quantumOfCirculation"
        ]
    },
    rydberg: {
        description: "Rydberg constant",
        examples: [
            "rydberg"
        ]
    },
    thomsonCrossSection: {
        description: "Thomson cross section",
        examples: [
            "thomsonCrossSection"
        ]
    },
    weakMixingAngle: {
        description: "Weak mixing angle",
        examples: [
            "weakMixingAngle"
        ]
    },
    efimovFactor: {
        description: "Efimov factor",
        examples: [
            "efimovFactor"
        ]
    },
    atomicMass: {
        description: "Atomic mass constant",
        examples: [
            "atomicMass"
        ]
    },
    avogadro: {
        description: "Avogadro's number",
        examples: [
            "avogadro"
        ]
    },
    boltzmann: {
        description: "Boltzmann constant",
        examples: [
            "boltzmann"
        ]
    },
    faraday: {
        description: "Faraday constant",
        examples: [
            "faraday"
        ]
    },
    firstRadiation: {
        description: "First radiation constant",
        examples: [
            "firstRadiation"
        ]
    },
    loschmidt: {
        description: "Loschmidt constant at T=273.15 K and p=101.325 kPa",
        examples: [
            "loschmidt"
        ]
    },
    gasConstant: {
        description: "Gas constant",
        examples: [
            "gasConstant"
        ]
    },
    molarPlanckConstant: {
        description: "Molar Planck constant",
        examples: [
            "molarPlanckConstant"
        ]
    },
    molarVolume: {
        description: "Molar volume of an ideal gas at T=273.15 K and p=101.325 kPa",
        examples: [
            "molarVolume"
        ]
    },
    sackurTetrode: {
        description: "Sackur-Tetrode constant at T=1 K and p=101.325 kPa",
        examples: [
            "sackurTetrode"
        ]
    },
    secondRadiation: {
        description: "Second radiation constant",
        examples: [
            "secondRadiation"
        ]
    },
    stefanBoltzmann: {
        description: "Stefan-Boltzmann constant",
        examples: [
            "stefanBoltzmann"
        ]
    },
    wienDisplacement: {
        description: "Wien displacement law constant",
        examples: [
            "wienDisplacement"
        ]
    },
    // spectralRadiance: {description: 'First radiation constant for spectral radiance', examples: ['spectralRadiance']},
    molarMass: {
        description: "Molar mass constant",
        examples: [
            "molarMass"
        ]
    },
    molarMassC12: {
        description: "Molar mass constant of carbon-12",
        examples: [
            "molarMassC12"
        ]
    },
    gravity: {
        description: "Standard acceleration of gravity (standard acceleration of free-fall on Earth)",
        examples: [
            "gravity"
        ]
    },
    planckLength: {
        description: "Planck length",
        examples: [
            "planckLength"
        ]
    },
    planckMass: {
        description: "Planck mass",
        examples: [
            "planckMass"
        ]
    },
    planckTime: {
        description: "Planck time",
        examples: [
            "planckTime"
        ]
    },
    planckCharge: {
        description: "Planck charge",
        examples: [
            "planckCharge"
        ]
    },
    planckTemperature: {
        description: "Planck temperature",
        examples: [
            "planckTemperature"
        ]
    },
    // functions - algebra
    derivative: (0, $4FuGC.derivativeDocs),
    lsolve: (0, $bj0Pn.lsolveDocs),
    lup: (0, $gR5wf.lupDocs),
    lusolve: (0, $k4gW9.lusolveDocs),
    simplify: (0, $4H26S.simplifyDocs),
    rationalize: (0, $34utO.rationalizeDocs),
    slu: (0, $6CCvg.sluDocs),
    usolve: (0, $hBK1o.usolveDocs),
    qr: (0, $6cUvE.qrDocs),
    // functions - arithmetic
    abs: (0, $9JtUj.absDocs),
    add: (0, $ev3N4.addDocs),
    cbrt: (0, $bp2rB.cbrtDocs),
    ceil: (0, $9V40U.ceilDocs),
    cube: (0, $7X0mg.cubeDocs),
    divide: (0, $3pLqw.divideDocs),
    dotDivide: (0, $7qL1g.dotDivideDocs),
    dotMultiply: (0, $hHuRe.dotMultiplyDocs),
    dotPow: (0, $giZIF.dotPowDocs),
    exp: (0, $66pcK.expDocs),
    expm: (0, $6kdGd.expmDocs),
    expm1: (0, $aucjV.expm1Docs),
    fix: (0, $aPSFs.fixDocs),
    floor: (0, $1nuwR.floorDocs),
    gcd: (0, $eKbt8.gcdDocs),
    hypot: (0, $2CUEz.hypotDocs),
    lcm: (0, $9tjy2.lcmDocs),
    log: (0, $hfhXI.logDocs),
    log2: (0, $k0oGZ.log2Docs),
    log1p: (0, $1VKaL.log1pDocs),
    log10: (0, $9VyOB.log10Docs),
    mod: (0, $i3zPi.modDocs),
    multiply: (0, $8UIvy.multiplyDocs),
    norm: (0, $j7uge.normDocs),
    nthRoot: (0, $gVdRU.nthRootDocs),
    nthRoots: (0, $5myNz.nthRootsDocs),
    pow: (0, $ebxdO.powDocs),
    round: (0, $lANzd.roundDocs),
    sign: (0, $2SqMq.signDocs),
    sqrt: (0, $eQI16.sqrtDocs),
    sqrtm: (0, $3FZHK.sqrtmDocs),
    square: (0, $guRgs.squareDocs),
    subtract: (0, $2xP82.subtractDocs),
    unaryMinus: (0, $4xJia.unaryMinusDocs),
    unaryPlus: (0, $aCwWZ.unaryPlusDocs),
    xgcd: (0, $hFxzz.xgcdDocs),
    // functions - bitwise
    bitAnd: (0, $5Bnil.bitAndDocs),
    bitNot: (0, $kTOSY.bitNotDocs),
    bitOr: (0, $aK9ta.bitOrDocs),
    bitXor: (0, $jJ2Hn.bitXorDocs),
    leftShift: (0, $MtLIv.leftShiftDocs),
    rightArithShift: (0, $5VeVS.rightArithShiftDocs),
    rightLogShift: (0, $bJGII.rightLogShiftDocs),
    // functions - combinatorics
    bellNumbers: (0, $aoMft.bellNumbersDocs),
    catalan: (0, $8vAqe.catalanDocs),
    composition: (0, $4mq0M.compositionDocs),
    stirlingS2: (0, $1Is2D.stirlingS2Docs),
    // functions - core
    config: (0, $7PMEC.configDocs),
    "import": (0, $jrwph.importDocs),
    typed: (0, $bjbPq.typedDocs),
    // functions - complex
    arg: (0, $80r5u.argDocs),
    conj: (0, $6W62t.conjDocs),
    re: (0, $dZ8st.reDocs),
    im: (0, $2c5zB.imDocs),
    // functions - expression
    evaluate: (0, $fAyhW.evaluateDocs),
    eval: (0, $fAyhW.evaluateDocs),
    // TODO: deprecated, cleanup in v7
    help: (0, $dxQ9l.helpDocs),
    // functions - geometry
    distance: (0, $7xW65.distanceDocs),
    intersect: (0, $6nd4e.intersectDocs),
    // functions - logical
    and: (0, $jWo8L.andDocs),
    not: (0, $iEbSj.notDocs),
    or: (0, $03EUJ.orDocs),
    xor: (0, $ab3Mw.xorDocs),
    // functions - matrix
    concat: (0, $auL4F.concatDocs),
    cross: (0, $72AW0.crossDocs),
    column: (0, $94H8i.columnDocs),
    ctranspose: (0, $gohFp.ctransposeDocs),
    det: (0, $eDw1l.detDocs),
    diag: (0, $2x6QV.diagDocs),
    dot: (0, $2dqcg.dotDocs),
    getMatrixDataType: (0, $8a0Jr.getMatrixDataTypeDocs),
    identity: (0, $kT6kx.identityDocs),
    filter: (0, $9P90h.filterDocs),
    flatten: (0, $bNrUA.flattenDocs),
    forEach: (0, $5aBGU.forEachDocs),
    inv: (0, $1eZRj.invDocs),
    eigs: (0, $fiOXs.eigsDocs),
    kron: (0, $fzWrz.kronDocs),
    map: (0, $caseB.mapDocs),
    ones: (0, $ejDM7.onesDocs),
    partitionSelect: (0, $7w6rE.partitionSelectDocs),
    range: (0, $iCWKL.rangeDocs),
    resize: (0, $bK9Ub.resizeDocs),
    reshape: (0, $2IAga.reshapeDocs),
    row: (0, $lQaPd.rowDocs),
    size: (0, $8sSTA.sizeDocs),
    sort: (0, $7iAxZ.sortDocs),
    squeeze: (0, $ep8CJ.squeezeDocs),
    subset: (0, $9upGK.subsetDocs),
    trace: (0, $5dNX5.traceDocs),
    transpose: (0, $6NTLP.transposeDocs),
    zeros: (0, $4xjiF.zerosDocs),
    // functions - probability
    combinations: (0, $5jAbk.combinationsDocs),
    combinationsWithRep: (0, $ajzBf.combinationsWithRepDocs),
    // distribution: distributionDocs,
    factorial: (0, $98IcR.factorialDocs),
    gamma: (0, $jWioE.gammaDocs),
    kldivergence: (0, $94ozR.kldivergenceDocs),
    multinomial: (0, $6zv1C.multinomialDocs),
    permutations: (0, $Hb4my.permutationsDocs),
    pickRandom: (0, $6oAiR.pickRandomDocs),
    random: (0, $iqyuY.randomDocs),
    randomInt: (0, $bhUEc.randomIntDocs),
    // functions - relational
    compare: (0, $bPPUd.compareDocs),
    compareNatural: (0, $cJOhk.compareNaturalDocs),
    compareText: (0, $esSbP.compareTextDocs),
    deepEqual: (0, $f4IAk.deepEqualDocs),
    equal: (0, $hWjKc.equalDocs),
    equalText: (0, $5rQ2p.equalTextDocs),
    larger: (0, $29Sk0.largerDocs),
    largerEq: (0, $fMspx.largerEqDocs),
    smaller: (0, $pAd0e.smallerDocs),
    smallerEq: (0, $iD8Dz.smallerEqDocs),
    unequal: (0, $1vn8b.unequalDocs),
    // functions - set
    setCartesian: (0, $hswFv.setCartesianDocs),
    setDifference: (0, $1HbGK.setDifferenceDocs),
    setDistinct: (0, $5jTG7.setDistinctDocs),
    setIntersect: (0, $hXFLv.setIntersectDocs),
    setIsSubset: (0, $5metl.setIsSubsetDocs),
    setMultiplicity: (0, $1JgD8.setMultiplicityDocs),
    setPowerset: (0, $gClhT.setPowersetDocs),
    setSize: (0, $4UV5j.setSizeDocs),
    setSymDifference: (0, $5CuJu.setSymDifferenceDocs),
    setUnion: (0, $gjqkX.setUnionDocs),
    // functions - special
    erf: (0, $3LIoX.erfDocs),
    // functions - statistics
    mad: (0, $jKiII.madDocs),
    max: (0, $5sM0g.maxDocs),
    mean: (0, $2BF6s.meanDocs),
    median: (0, $l2j6x.medianDocs),
    min: (0, $8zOz4.minDocs),
    mode: (0, $cD720.modeDocs),
    prod: (0, $77yAj.prodDocs),
    quantileSeq: (0, $3J6Dw.quantileSeqDocs),
    std: (0, $cHsca.stdDocs),
    sum: (0, $iNen5.sumDocs),
    variance: (0, $17xd2.varianceDocs),
    "var": (0, $17xd2.varianceDocs),
    // TODO: deprecated, cleanup in v7
    // functions - trigonometry
    acos: (0, $6ohB2.acosDocs),
    acosh: (0, $fT0yP.acoshDocs),
    acot: (0, $2Y2zy.acotDocs),
    acoth: (0, $4pXds.acothDocs),
    acsc: (0, $8MOt5.acscDocs),
    acsch: (0, $am6DR.acschDocs),
    asec: (0, $tGO2Q.asecDocs),
    asech: (0, $l1L0N.asechDocs),
    asin: (0, $elvDr.asinDocs),
    asinh: (0, $5jiAW.asinhDocs),
    atan: (0, $1x5s1.atanDocs),
    atanh: (0, $7Ejfz.atanhDocs),
    atan2: (0, $h0sRW.atan2Docs),
    cos: (0, $eSl11.cosDocs),
    cosh: (0, $2TjDj.coshDocs),
    cot: (0, $7XT8h.cotDocs),
    coth: (0, $cTfOk.cothDocs),
    csc: (0, $I1r5m.cscDocs),
    csch: (0, $dALHF.cschDocs),
    sec: (0, $f6WHL.secDocs),
    sech: (0, $cuD5n.sechDocs),
    sin: (0, $gl9oO.sinDocs),
    sinh: (0, $dBtQs.sinhDocs),
    tan: (0, $4dG2O.tanDocs),
    tanh: (0, $2l1Oz.tanhDocs),
    // functions - units
    to: (0, $lJcO2.toDocs),
    // functions - utils
    clone: (0, $lLteI.cloneDocs),
    format: (0, $3qRXF.formatDocs),
    isNaN: (0, $177rE.isNaNDocs),
    isInteger: (0, $7Dcqm.isIntegerDocs),
    isNegative: (0, $ead42.isNegativeDocs),
    isNumeric: (0, $jzRMx.isNumericDocs),
    hasNumericValue: (0, $aQx2E.hasNumericValueDocs),
    isPositive: (0, $ccULi.isPositiveDocs),
    isPrime: (0, $hxi9q.isPrimeDocs),
    isZero: (0, $hdNYo.isZeroDocs),
    // print: printDocs // TODO: add documentation for print as soon as the parser supports objects.
    typeOf: (0, $8kX3O.typeOfDocs),
    "typeof": (0, $8kX3O.typeOfDocs),
    // TODO: deprecated, cleanup in v7
    numeric: (0, $3xnbV.numericDocs)
};

});
parcelRegister("5kzEv", function(module, exports) {

$parcel$export(module.exports, "bignumberDocs", function () { return $3e1a79d3285f93bc$export$e8c3f4e3ad52a4e6; });
var $3e1a79d3285f93bc$export$e8c3f4e3ad52a4e6 = {
    name: "bignumber",
    category: "Construction",
    syntax: [
        "bignumber(x)"
    ],
    description: "Create a big number from a number or string.",
    examples: [
        "0.1 + 0.2",
        "bignumber(0.1) + bignumber(0.2)",
        'bignumber("7.2")',
        'bignumber("7.2e500")',
        "bignumber([0.1, 0.2, 0.3])"
    ],
    seealso: [
        "boolean",
        "complex",
        "fraction",
        "index",
        "matrix",
        "string",
        "unit"
    ]
};

});

parcelRegister("8kX3O", function(module, exports) {

$parcel$export(module.exports, "typeOfDocs", function () { return $611e013005c20cae$export$5b193b71b9b497e6; });
var $611e013005c20cae$export$5b193b71b9b497e6 = {
    name: "typeOf",
    category: "Utils",
    syntax: [
        "typeOf(x)"
    ],
    description: "Get the type of a variable.",
    examples: [
        "typeOf(3.5)",
        "typeOf(2 - 4i)",
        "typeOf(45 deg)",
        'typeOf("hello world")'
    ],
    seealso: [
        "getMatrixDataType"
    ]
};

});

parcelRegister("hdNYo", function(module, exports) {

$parcel$export(module.exports, "isZeroDocs", function () { return $c89a6a2f61178135$export$52c03b663dd15fa3; });
var $c89a6a2f61178135$export$52c03b663dd15fa3 = {
    name: "isZero",
    category: "Utils",
    syntax: [
        "isZero(x)"
    ],
    description: "Test whether a value is zero.",
    examples: [
        "isZero(2)",
        "isZero(0)",
        "isZero(-4)",
        "isZero([3, 0, -2, 0])"
    ],
    seealso: [
        "isInteger",
        "isNumeric",
        "isNegative",
        "isPositive"
    ]
};

});

parcelRegister("hxi9q", function(module, exports) {

$parcel$export(module.exports, "isPrimeDocs", function () { return $034b69b21df5dcf5$export$d6ada432c5e7d9c7; });
var $034b69b21df5dcf5$export$d6ada432c5e7d9c7 = {
    name: "isPrime",
    category: "Utils",
    syntax: [
        "isPrime(x)"
    ],
    description: "Test whether a value is prime: has no divisors other than itself and one.",
    examples: [
        "isPrime(3)",
        "isPrime(-2)",
        "isPrime([2, 17, 100])"
    ],
    seealso: [
        "isInteger",
        "isNumeric",
        "isNegative",
        "isZero"
    ]
};

});

parcelRegister("ccULi", function(module, exports) {

$parcel$export(module.exports, "isPositiveDocs", function () { return $8e32a2bd26babf60$export$338f53b321c261b9; });
var $8e32a2bd26babf60$export$338f53b321c261b9 = {
    name: "isPositive",
    category: "Utils",
    syntax: [
        "isPositive(x)"
    ],
    description: "Test whether a value is positive: larger than zero.",
    examples: [
        "isPositive(2)",
        "isPositive(0)",
        "isPositive(-4)",
        "isPositive([3, 0.5, -2])"
    ],
    seealso: [
        "isInteger",
        "isNumeric",
        "isNegative",
        "isZero"
    ]
};

});

parcelRegister("jzRMx", function(module, exports) {

$parcel$export(module.exports, "isNumericDocs", function () { return $e40b012da19181dd$export$7ac3927ed17fe2b6; });
var $e40b012da19181dd$export$7ac3927ed17fe2b6 = {
    name: "isNumeric",
    category: "Utils",
    syntax: [
        "isNumeric(x)"
    ],
    description: "Test whether a value is a numeric value. Returns true when the input is a number, BigNumber, Fraction, or boolean.",
    examples: [
        "isNumeric(2)",
        'isNumeric("2")',
        'hasNumericValue("2")',
        "isNumeric(0)",
        "isNumeric(bignumber(500))",
        "isNumeric(fraction(0.125))",
        "isNumeric(2 + 3i)",
        'isNumeric([2.3, "foo", false])'
    ],
    seealso: [
        "isInteger",
        "isZero",
        "isNegative",
        "isPositive",
        "isNaN",
        "hasNumericValue"
    ]
};

});

parcelRegister("aQx2E", function(module, exports) {

$parcel$export(module.exports, "hasNumericValueDocs", function () { return $7e5864209d67c6c0$export$9d10d68d9b7d7a67; });
var $7e5864209d67c6c0$export$9d10d68d9b7d7a67 = {
    name: "hasNumericValue",
    category: "Utils",
    syntax: [
        "hasNumericValue(x)"
    ],
    description: "Test whether a value is an numeric value. In case of a string, true is returned if the string contains a numeric value.",
    examples: [
        "hasNumericValue(2)",
        'hasNumericValue("2")',
        'isNumeric("2")',
        "hasNumericValue(0)",
        "hasNumericValue(bignumber(500))",
        "hasNumericValue(fraction(0.125))",
        "hasNumericValue(2 + 3i)",
        'hasNumericValue([2.3, "foo", false])'
    ],
    seealso: [
        "isInteger",
        "isZero",
        "isNegative",
        "isPositive",
        "isNaN",
        "isNumeric"
    ]
};

});

parcelRegister("ead42", function(module, exports) {

$parcel$export(module.exports, "isNegativeDocs", function () { return $a4fc22265aa636f0$export$f94a800b9b237f17; });
var $a4fc22265aa636f0$export$f94a800b9b237f17 = {
    name: "isNegative",
    category: "Utils",
    syntax: [
        "isNegative(x)"
    ],
    description: "Test whether a value is negative: smaller than zero.",
    examples: [
        "isNegative(2)",
        "isNegative(0)",
        "isNegative(-4)",
        "isNegative([3, 0.5, -2])"
    ],
    seealso: [
        "isInteger",
        "isNumeric",
        "isPositive",
        "isZero"
    ]
};

});

parcelRegister("7Dcqm", function(module, exports) {

$parcel$export(module.exports, "isIntegerDocs", function () { return $58e5d0160688f098$export$1d8b51b394bbccdc; });
var $58e5d0160688f098$export$1d8b51b394bbccdc = {
    name: "isInteger",
    category: "Utils",
    syntax: [
        "isInteger(x)"
    ],
    description: "Test whether a value is an integer number.",
    examples: [
        "isInteger(2)",
        "isInteger(3.5)",
        "isInteger([3, 0.5, -2])"
    ],
    seealso: [
        "isNegative",
        "isNumeric",
        "isPositive",
        "isZero"
    ]
};

});

parcelRegister("177rE", function(module, exports) {

$parcel$export(module.exports, "isNaNDocs", function () { return $0cfc38540d75c112$export$f4e7c51d549c187f; });
var $0cfc38540d75c112$export$f4e7c51d549c187f = {
    name: "isNaN",
    category: "Utils",
    syntax: [
        "isNaN(x)"
    ],
    description: "Test whether a value is NaN (not a number)",
    examples: [
        "isNaN(2)",
        "isNaN(0 / 0)",
        "isNaN(NaN)",
        "isNaN(Infinity)"
    ],
    seealso: [
        "isNegative",
        "isNumeric",
        "isPositive",
        "isZero"
    ]
};

});

parcelRegister("3qRXF", function(module, exports) {

$parcel$export(module.exports, "formatDocs", function () { return $27fda86b312bcc16$export$278425b4fe1ff1bf; });
var $27fda86b312bcc16$export$278425b4fe1ff1bf = {
    name: "format",
    category: "Utils",
    syntax: [
        "format(value)",
        "format(value, precision)"
    ],
    description: "Format a value of any type as string.",
    examples: [
        "format(2.3)",
        "format(3 - 4i)",
        "format([])",
        "format(pi, 3)"
    ],
    seealso: [
        "print"
    ]
};

});

parcelRegister("lLteI", function(module, exports) {

$parcel$export(module.exports, "cloneDocs", function () { return $fd84aa81bc1596c9$export$500c01a79e32a1ad; });
var $fd84aa81bc1596c9$export$500c01a79e32a1ad = {
    name: "clone",
    category: "Utils",
    syntax: [
        "clone(x)"
    ],
    description: "Clone a variable. Creates a copy of primitive variables,and a deep copy of matrices",
    examples: [
        "clone(3.5)",
        "clone(2 - 4i)",
        "clone(45 deg)",
        "clone([1, 2; 3, 4])",
        'clone("hello world")'
    ],
    seealso: []
};

});

parcelRegister("lJcO2", function(module, exports) {

$parcel$export(module.exports, "toDocs", function () { return $fd17bbf7bc3fae4a$export$c532fecb2dfa6274; });
var $fd17bbf7bc3fae4a$export$c532fecb2dfa6274 = {
    name: "to",
    category: "Units",
    syntax: [
        "x to unit",
        "to(x, unit)"
    ],
    description: "Change the unit of a value.",
    examples: [
        "5 inch to cm",
        "3.2kg to g",
        "16 bytes in bits"
    ],
    seealso: []
};

});

parcelRegister("2l1Oz", function(module, exports) {

$parcel$export(module.exports, "tanhDocs", function () { return $1b3ef34f559f156c$export$52a5c54b85f75620; });
var $1b3ef34f559f156c$export$52a5c54b85f75620 = {
    name: "tanh",
    category: "Trigonometry",
    syntax: [
        "tanh(x)"
    ],
    description: "Compute the hyperbolic tangent of x in radians.",
    examples: [
        "tanh(0.5)",
        "sinh(0.5) / cosh(0.5)"
    ],
    seealso: [
        "sinh",
        "cosh"
    ]
};

});

parcelRegister("4dG2O", function(module, exports) {

$parcel$export(module.exports, "tanDocs", function () { return $3128fd71261d4644$export$14fc997d4768f36a; });
var $3128fd71261d4644$export$14fc997d4768f36a = {
    name: "tan",
    category: "Trigonometry",
    syntax: [
        "tan(x)"
    ],
    description: "Compute the tangent of x in radians.",
    examples: [
        "tan(0.5)",
        "sin(0.5) / cos(0.5)",
        "tan(pi / 4)",
        "tan(45 deg)"
    ],
    seealso: [
        "atan",
        "sin",
        "cos"
    ]
};

});

parcelRegister("dBtQs", function(module, exports) {

$parcel$export(module.exports, "sinhDocs", function () { return $9e75e1ace1beb654$export$e07b4c62bc488091; });
var $9e75e1ace1beb654$export$e07b4c62bc488091 = {
    name: "sinh",
    category: "Trigonometry",
    syntax: [
        "sinh(x)"
    ],
    description: "Compute the hyperbolic sine of x in radians.",
    examples: [
        "sinh(0.5)"
    ],
    seealso: [
        "cosh",
        "tanh"
    ]
};

});

parcelRegister("cuD5n", function(module, exports) {

$parcel$export(module.exports, "sechDocs", function () { return $91869b0080f702e5$export$6da75bc9afc8303b; });
var $91869b0080f702e5$export$6da75bc9afc8303b = {
    name: "sech",
    category: "Trigonometry",
    syntax: [
        "sech(x)"
    ],
    description: "Compute the hyperbolic secant of x in radians. Defined as 1/cosh(x)",
    examples: [
        "sech(2)",
        "1 / cosh(2)"
    ],
    seealso: [
        "coth",
        "csch",
        "cosh"
    ]
};

});

parcelRegister("f6WHL", function(module, exports) {

$parcel$export(module.exports, "secDocs", function () { return $b004f41ab6fbe660$export$3dae56ab28d48626; });
var $b004f41ab6fbe660$export$3dae56ab28d48626 = {
    name: "sec",
    category: "Trigonometry",
    syntax: [
        "sec(x)"
    ],
    description: "Compute the secant of x in radians. Defined as 1/cos(x)",
    examples: [
        "sec(2)",
        "1 / cos(2)"
    ],
    seealso: [
        "cot",
        "csc",
        "cos"
    ]
};

});

parcelRegister("dALHF", function(module, exports) {

$parcel$export(module.exports, "cschDocs", function () { return $9e53a4052c8e6149$export$8baf7f6e609495d8; });
var $9e53a4052c8e6149$export$8baf7f6e609495d8 = {
    name: "csch",
    category: "Trigonometry",
    syntax: [
        "csch(x)"
    ],
    description: "Compute the hyperbolic cosecant of x in radians. Defined as 1/sinh(x)",
    examples: [
        "csch(2)",
        "1 / sinh(2)"
    ],
    seealso: [
        "sech",
        "coth",
        "sinh"
    ]
};

});

parcelRegister("I1r5m", function(module, exports) {

$parcel$export(module.exports, "cscDocs", function () { return $0845394eb5092a55$export$1be2e18f41ba39dc; });
var $0845394eb5092a55$export$1be2e18f41ba39dc = {
    name: "csc",
    category: "Trigonometry",
    syntax: [
        "csc(x)"
    ],
    description: "Compute the cosecant of x in radians. Defined as 1/sin(x)",
    examples: [
        "csc(2)",
        "1 / sin(2)"
    ],
    seealso: [
        "sec",
        "cot",
        "sin"
    ]
};

});

parcelRegister("cTfOk", function(module, exports) {

$parcel$export(module.exports, "cothDocs", function () { return $9626e2cafed705fd$export$7cd2898db0b732d0; });
var $9626e2cafed705fd$export$7cd2898db0b732d0 = {
    name: "coth",
    category: "Trigonometry",
    syntax: [
        "coth(x)"
    ],
    description: "Compute the hyperbolic cotangent of x in radians.",
    examples: [
        "coth(2)",
        "1 / tanh(2)"
    ],
    seealso: [
        "sech",
        "csch",
        "tanh"
    ]
};

});

parcelRegister("7XT8h", function(module, exports) {

$parcel$export(module.exports, "cotDocs", function () { return $5cc8cf42d842d294$export$b6bae004c5b418ef; });
var $5cc8cf42d842d294$export$b6bae004c5b418ef = {
    name: "cot",
    category: "Trigonometry",
    syntax: [
        "cot(x)"
    ],
    description: "Compute the cotangent of x in radians. Defined as 1/tan(x)",
    examples: [
        "cot(2)",
        "1 / tan(2)"
    ],
    seealso: [
        "sec",
        "csc",
        "tan"
    ]
};

});

parcelRegister("2TjDj", function(module, exports) {

$parcel$export(module.exports, "coshDocs", function () { return $21aff2867b7f5235$export$5af2bed23001ffc5; });
var $21aff2867b7f5235$export$5af2bed23001ffc5 = {
    name: "cosh",
    category: "Trigonometry",
    syntax: [
        "cosh(x)"
    ],
    description: "Compute the hyperbolic cosine of x in radians.",
    examples: [
        "cosh(0.5)"
    ],
    seealso: [
        "sinh",
        "tanh",
        "coth"
    ]
};

});

parcelRegister("eSl11", function(module, exports) {

$parcel$export(module.exports, "cosDocs", function () { return $ad4669107bffaab8$export$1a1af52900b6c58e; });
var $ad4669107bffaab8$export$1a1af52900b6c58e = {
    name: "cos",
    category: "Trigonometry",
    syntax: [
        "cos(x)"
    ],
    description: "Compute the cosine of x in radians.",
    examples: [
        "cos(2)",
        "cos(pi / 4) ^ 2",
        "cos(180 deg)",
        "cos(60 deg)",
        "sin(0.2)^2 + cos(0.2)^2"
    ],
    seealso: [
        "acos",
        "sin",
        "tan"
    ]
};

});

parcelRegister("h0sRW", function(module, exports) {

$parcel$export(module.exports, "atan2Docs", function () { return $c618d49058148403$export$e4fc5308b4910337; });
var $c618d49058148403$export$e4fc5308b4910337 = {
    name: "atan2",
    category: "Trigonometry",
    syntax: [
        "atan2(y, x)"
    ],
    description: "Computes the principal value of the arc tangent of y/x in radians.",
    examples: [
        "atan2(2, 2) / pi",
        "angle = 60 deg in rad",
        "x = cos(angle)",
        "y = sin(angle)",
        "atan2(y, x)"
    ],
    seealso: [
        "sin",
        "cos",
        "tan"
    ]
};

});

parcelRegister("7Ejfz", function(module, exports) {

$parcel$export(module.exports, "atanhDocs", function () { return $591b338604148aa8$export$e5bbdb9caa9a8f09; });
var $591b338604148aa8$export$e5bbdb9caa9a8f09 = {
    name: "atanh",
    category: "Trigonometry",
    syntax: [
        "atanh(x)"
    ],
    description: "Calculate the hyperbolic arctangent of a value, defined as `atanh(x) = ln((1 + x)/(1 - x)) / 2`.",
    examples: [
        "atanh(0.5)"
    ],
    seealso: [
        "acosh",
        "asinh"
    ]
};

});

parcelRegister("1x5s1", function(module, exports) {

$parcel$export(module.exports, "atanDocs", function () { return $11dd19f1bfd24a96$export$80066e40c56154f0; });
var $11dd19f1bfd24a96$export$80066e40c56154f0 = {
    name: "atan",
    category: "Trigonometry",
    syntax: [
        "atan(x)"
    ],
    description: "Compute the inverse tangent of a value in radians.",
    examples: [
        "atan(0.5)",
        "atan(tan(0.5))"
    ],
    seealso: [
        "tan",
        "acos",
        "asin"
    ]
};

});

parcelRegister("5jiAW", function(module, exports) {

$parcel$export(module.exports, "asinhDocs", function () { return $3ddd26a1a575ddb0$export$afe7a3b04750ebb7; });
var $3ddd26a1a575ddb0$export$afe7a3b04750ebb7 = {
    name: "asinh",
    category: "Trigonometry",
    syntax: [
        "asinh(x)"
    ],
    description: "Calculate the hyperbolic arcsine of a value, defined as `asinh(x) = ln(x + sqrt(x^2 + 1))`.",
    examples: [
        "asinh(0.5)"
    ],
    seealso: [
        "acosh",
        "atanh"
    ]
};

});

parcelRegister("elvDr", function(module, exports) {

$parcel$export(module.exports, "asinDocs", function () { return $a71b90f61a81a8df$export$b85b8db6e8a2ed3d; });
var $a71b90f61a81a8df$export$b85b8db6e8a2ed3d = {
    name: "asin",
    category: "Trigonometry",
    syntax: [
        "asin(x)"
    ],
    description: "Compute the inverse sine of a value in radians.",
    examples: [
        "asin(0.5)",
        "asin(sin(0.5))"
    ],
    seealso: [
        "sin",
        "acos",
        "atan"
    ]
};

});

parcelRegister("l1L0N", function(module, exports) {

$parcel$export(module.exports, "asechDocs", function () { return $f4ee28882a63d360$export$52f8b22e9936e0e; });
var $f4ee28882a63d360$export$52f8b22e9936e0e = {
    name: "asech",
    category: "Trigonometry",
    syntax: [
        "asech(x)"
    ],
    description: "Calculate the inverse secant of a value.",
    examples: [
        "asech(0.5)"
    ],
    seealso: [
        "acsch",
        "acoth"
    ]
};

});

parcelRegister("tGO2Q", function(module, exports) {

$parcel$export(module.exports, "asecDocs", function () { return $0593e9f69495a285$export$fbe1d815e0591494; });
var $0593e9f69495a285$export$fbe1d815e0591494 = {
    name: "asec",
    category: "Trigonometry",
    syntax: [
        "asec(x)"
    ],
    description: "Calculate the inverse secant of a value.",
    examples: [
        "asec(0.5)",
        "asec(sec(0.5))",
        "asec(2)"
    ],
    seealso: [
        "acos",
        "acot",
        "acsc"
    ]
};

});

parcelRegister("am6DR", function(module, exports) {

$parcel$export(module.exports, "acschDocs", function () { return $78a11c67990643b8$export$319c6d631e591850; });
var $78a11c67990643b8$export$319c6d631e591850 = {
    name: "acsch",
    category: "Trigonometry",
    syntax: [
        "acsch(x)"
    ],
    description: "Calculate the hyperbolic arccosecant of a value, defined as `acsch(x) = ln(1/x + sqrt(1/x^2 + 1))`.",
    examples: [
        "acsch(0.5)"
    ],
    seealso: [
        "asech",
        "acoth"
    ]
};

});

parcelRegister("8MOt5", function(module, exports) {

$parcel$export(module.exports, "acscDocs", function () { return $6659f4576a63d692$export$911b51cd6a7612a8; });
var $6659f4576a63d692$export$911b51cd6a7612a8 = {
    name: "acsc",
    category: "Trigonometry",
    syntax: [
        "acsc(x)"
    ],
    description: "Calculate the inverse cotangent of a value.",
    examples: [
        "acsc(2)",
        "acsc(csc(0.5))",
        "acsc(0.5)"
    ],
    seealso: [
        "csc",
        "asin",
        "asec"
    ]
};

});

parcelRegister("4pXds", function(module, exports) {

$parcel$export(module.exports, "acothDocs", function () { return $33776e52905b238a$export$b7d7f2d7d0d4ec7d; });
var $33776e52905b238a$export$b7d7f2d7d0d4ec7d = {
    name: "acoth",
    category: "Trigonometry",
    syntax: [
        "acoth(x)"
    ],
    description: "Calculate the hyperbolic arccotangent of a value, defined as `acoth(x) = (ln((x+1)/x) + ln(x/(x-1))) / 2`.",
    examples: [
        "acoth(2)",
        "acoth(0.5)"
    ],
    seealso: [
        "acsch",
        "asech"
    ]
};

});

parcelRegister("2Y2zy", function(module, exports) {

$parcel$export(module.exports, "acotDocs", function () { return $22932e2e841b7b58$export$5df2d36103c3facc; });
var $22932e2e841b7b58$export$5df2d36103c3facc = {
    name: "acot",
    category: "Trigonometry",
    syntax: [
        "acot(x)"
    ],
    description: "Calculate the inverse cotangent of a value.",
    examples: [
        "acot(0.5)",
        "acot(cot(0.5))",
        "acot(2)"
    ],
    seealso: [
        "cot",
        "atan"
    ]
};

});

parcelRegister("fT0yP", function(module, exports) {

$parcel$export(module.exports, "acoshDocs", function () { return $b90c6d69f35827cc$export$eb8f1b26819009ca; });
var $b90c6d69f35827cc$export$eb8f1b26819009ca = {
    name: "acosh",
    category: "Trigonometry",
    syntax: [
        "acosh(x)"
    ],
    description: "Calculate the hyperbolic arccos of a value, defined as `acosh(x) = ln(sqrt(x^2 - 1) + x)`.",
    examples: [
        "acosh(1.5)"
    ],
    seealso: [
        "cosh",
        "asinh",
        "atanh"
    ]
};

});

parcelRegister("6ohB2", function(module, exports) {

$parcel$export(module.exports, "acosDocs", function () { return $4a72a23f5b51cec1$export$a96a9170bca705dc; });
var $4a72a23f5b51cec1$export$a96a9170bca705dc = {
    name: "acos",
    category: "Trigonometry",
    syntax: [
        "acos(x)"
    ],
    description: "Compute the inverse cosine of a value in radians.",
    examples: [
        "acos(0.5)",
        "acos(cos(2.3))"
    ],
    seealso: [
        "cos",
        "atan",
        "asin"
    ]
};

});

parcelRegister("iNen5", function(module, exports) {

$parcel$export(module.exports, "sumDocs", function () { return $dae7f3773e8786a9$export$cd6065b38df4efb0; });
var $dae7f3773e8786a9$export$cd6065b38df4efb0 = {
    name: "sum",
    category: "Statistics",
    syntax: [
        "sum(a, b, c, ...)",
        "sum(A)"
    ],
    description: "Compute the sum of all values.",
    examples: [
        "sum(2, 3, 4, 1)",
        "sum([2, 3, 4, 1])",
        "sum([2, 5; 4, 3])"
    ],
    seealso: [
        "max",
        "mean",
        "median",
        "min",
        "prod",
        "std",
        "sum",
        "variance"
    ]
};

});

parcelRegister("cHsca", function(module, exports) {

$parcel$export(module.exports, "stdDocs", function () { return $93ef5f2f67c05f6b$export$d1c23b21300d0eb8; });
var $93ef5f2f67c05f6b$export$d1c23b21300d0eb8 = {
    name: "std",
    category: "Statistics",
    syntax: [
        "std(a, b, c, ...)",
        "std(A)",
        "std(A, normalization)"
    ],
    description: 'Compute the standard deviation of all values, defined as std(A) = sqrt(variance(A)). Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".',
    examples: [
        "std(2, 4, 6)",
        "std([2, 4, 6, 8])",
        'std([2, 4, 6, 8], "uncorrected")',
        'std([2, 4, 6, 8], "biased")',
        "std([1, 2, 3; 4, 5, 6])"
    ],
    seealso: [
        "max",
        "mean",
        "min",
        "median",
        "prod",
        "sum",
        "variance"
    ]
};

});

parcelRegister("3J6Dw", function(module, exports) {

$parcel$export(module.exports, "quantileSeqDocs", function () { return $2b6ab8f29e4c3ac1$export$f80c87524ae9a59f; });
var $2b6ab8f29e4c3ac1$export$f80c87524ae9a59f = {
    name: "quantileSeq",
    category: "Statistics",
    syntax: [
        "quantileSeq(A, prob[, sorted])",
        "quantileSeq(A, [prob1, prob2, ...][, sorted])",
        "quantileSeq(A, N[, sorted])"
    ],
    description: "Compute the prob order quantile of a matrix or a list with values. The sequence is sorted and the middle value is returned. Supported types of sequence values are: Number, BigNumber, Unit Supported types of probablity are: Number, BigNumber. \n\nIn case of a (multi dimensional) array or matrix, the prob order quantile of all elements will be calculated.",
    examples: [
        "quantileSeq([3, -1, 5, 7], 0.5)",
        "quantileSeq([3, -1, 5, 7], [1/3, 2/3])",
        "quantileSeq([3, -1, 5, 7], 2)",
        "quantileSeq([-1, 3, 5, 7], 0.5, true)"
    ],
    seealso: [
        "mean",
        "median",
        "min",
        "max",
        "prod",
        "std",
        "sum",
        "variance"
    ]
};

});

parcelRegister("77yAj", function(module, exports) {

$parcel$export(module.exports, "prodDocs", function () { return $52f403a9565b52f1$export$524cc5e521f0e533; });
var $52f403a9565b52f1$export$524cc5e521f0e533 = {
    name: "prod",
    category: "Statistics",
    syntax: [
        "prod(a, b, c, ...)",
        "prod(A)"
    ],
    description: "Compute the product of all values.",
    examples: [
        "prod(2, 3, 4)",
        "prod([2, 3, 4])",
        "prod([2, 5; 4, 3])"
    ],
    seealso: [
        "max",
        "mean",
        "min",
        "median",
        "min",
        "std",
        "sum",
        "variance"
    ]
};

});

parcelRegister("cD720", function(module, exports) {

$parcel$export(module.exports, "modeDocs", function () { return $931e94dc2ebb6e8f$export$30b601fd0273be74; });
var $931e94dc2ebb6e8f$export$30b601fd0273be74 = {
    name: "mode",
    category: "Statistics",
    syntax: [
        "mode(a, b, c, ...)",
        "mode(A)",
        "mode(A, a, b, B, c, ...)"
    ],
    description: "Computes the mode of all values as an array. In case mode being more than one, multiple values are returned in an array.",
    examples: [
        "mode(2, 1, 4, 3, 1)",
        "mode([1, 2.7, 3.2, 4, 2.7])",
        "mode(1, 4, 6, 1, 6)"
    ],
    seealso: [
        "max",
        "mean",
        "min",
        "median",
        "prod",
        "std",
        "sum",
        "variance"
    ]
};

});

parcelRegister("8zOz4", function(module, exports) {

$parcel$export(module.exports, "minDocs", function () { return $63e8d0b15dea9179$export$17718e9907e3ac84; });
var $63e8d0b15dea9179$export$17718e9907e3ac84 = {
    name: "min",
    category: "Statistics",
    syntax: [
        "min(a, b, c, ...)",
        "min(A)",
        "min(A, dim)"
    ],
    description: "Compute the minimum value of a list of values.",
    examples: [
        "min(2, 3, 4, 1)",
        "min([2, 3, 4, 1])",
        "min([2, 5; 4, 3])",
        "min([2, 5; 4, 3], 1)",
        "min([2, 5; 4, 3], 2)",
        "min(2.7, 7.1, -4.5, 2.0, 4.1)",
        "max(2.7, 7.1, -4.5, 2.0, 4.1)"
    ],
    seealso: [
        "max",
        "mean",
        "median",
        "prod",
        "std",
        "sum",
        "variance"
    ]
};

});

parcelRegister("l2j6x", function(module, exports) {

$parcel$export(module.exports, "medianDocs", function () { return $f5089a9fd48c15c4$export$dd1c97a64d85784b; });
var $f5089a9fd48c15c4$export$dd1c97a64d85784b = {
    name: "median",
    category: "Statistics",
    syntax: [
        "median(a, b, c, ...)",
        "median(A)"
    ],
    description: "Compute the median of all values. The values are sorted and the middle value is returned. In case of an even number of values, the average of the two middle values is returned.",
    examples: [
        "median(5, 2, 7)",
        "median([3, -1, 5, 7])"
    ],
    seealso: [
        "max",
        "mean",
        "min",
        "prod",
        "std",
        "sum",
        "variance",
        "quantileSeq"
    ]
};

});

parcelRegister("2BF6s", function(module, exports) {

$parcel$export(module.exports, "meanDocs", function () { return $1e5eebb827c7dbfc$export$1f7fad79151d4cc1; });
var $1e5eebb827c7dbfc$export$1f7fad79151d4cc1 = {
    name: "mean",
    category: "Statistics",
    syntax: [
        "mean(a, b, c, ...)",
        "mean(A)",
        "mean(A, dim)"
    ],
    description: "Compute the arithmetic mean of a list of values.",
    examples: [
        "mean(2, 3, 4, 1)",
        "mean([2, 3, 4, 1])",
        "mean([2, 5; 4, 3])",
        "mean([2, 5; 4, 3], 1)",
        "mean([2, 5; 4, 3], 2)",
        "mean([1.0, 2.7, 3.2, 4.0])"
    ],
    seealso: [
        "max",
        "median",
        "min",
        "prod",
        "std",
        "sum",
        "variance"
    ]
};

});

parcelRegister("5sM0g", function(module, exports) {

$parcel$export(module.exports, "maxDocs", function () { return $3fa4cdb9d68c3a0f$export$f3fddd6eb2764aa6; });
var $3fa4cdb9d68c3a0f$export$f3fddd6eb2764aa6 = {
    name: "max",
    category: "Statistics",
    syntax: [
        "max(a, b, c, ...)",
        "max(A)",
        "max(A, dim)"
    ],
    description: "Compute the maximum value of a list of values.",
    examples: [
        "max(2, 3, 4, 1)",
        "max([2, 3, 4, 1])",
        "max([2, 5; 4, 3])",
        "max([2, 5; 4, 3], 1)",
        "max([2, 5; 4, 3], 2)",
        "max(2.7, 7.1, -4.5, 2.0, 4.1)",
        "min(2.7, 7.1, -4.5, 2.0, 4.1)"
    ],
    seealso: [
        "mean",
        "median",
        "min",
        "prod",
        "std",
        "sum",
        "variance"
    ]
};

});

parcelRegister("jKiII", function(module, exports) {

$parcel$export(module.exports, "madDocs", function () { return $e600d5a1a4ffd99d$export$113a75651a4a72c6; });
var $e600d5a1a4ffd99d$export$113a75651a4a72c6 = {
    name: "mad",
    category: "Statistics",
    syntax: [
        "mad(a, b, c, ...)",
        "mad(A)"
    ],
    description: "Compute the median absolute deviation of a matrix or a list with values. The median absolute deviation is defined as the median of the absolute deviations from the median.",
    examples: [
        "mad(10, 20, 30)",
        "mad([1, 2, 3])"
    ],
    seealso: [
        "mean",
        "median",
        "std",
        "abs"
    ]
};

});

parcelRegister("3LIoX", function(module, exports) {

$parcel$export(module.exports, "erfDocs", function () { return $2be8341d419705e5$export$23984555c8f4e00a; });
var $2be8341d419705e5$export$23984555c8f4e00a = {
    name: "erf",
    category: "Special",
    syntax: [
        "erf(x)"
    ],
    description: "Compute the erf function of a value using a rational Chebyshev approximations for different intervals of x",
    examples: [
        "erf(0.2)",
        "erf(-0.5)",
        "erf(4)"
    ],
    seealso: []
};

});

parcelRegister("gjqkX", function(module, exports) {

$parcel$export(module.exports, "setUnionDocs", function () { return $be02d9acbdda1d6f$export$c6ab538723059178; });
var $be02d9acbdda1d6f$export$c6ab538723059178 = {
    name: "setUnion",
    category: "Set",
    syntax: [
        "setUnion(set1, set2)"
    ],
    description: "Create the union of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
    examples: [
        "setUnion([1, 2, 3, 4], [3, 4, 5, 6])",
        "setUnion([[1, 2], [3, 4]], [[3, 4], [5, 6]])"
    ],
    seealso: [
        "setIntersect",
        "setDifference"
    ]
};

});

parcelRegister("5CuJu", function(module, exports) {

$parcel$export(module.exports, "setSymDifferenceDocs", function () { return $4178573bae3b69b8$export$340d6a7da02d62f3; });
var $4178573bae3b69b8$export$340d6a7da02d62f3 = {
    name: "setSymDifference",
    category: "Set",
    syntax: [
        "setSymDifference(set1, set2)"
    ],
    description: "Create the symmetric difference of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
    examples: [
        "setSymDifference([1, 2, 3, 4], [3, 4, 5, 6])",
        "setSymDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])"
    ],
    seealso: [
        "setUnion",
        "setIntersect",
        "setDifference"
    ]
};

});

parcelRegister("4UV5j", function(module, exports) {

$parcel$export(module.exports, "setSizeDocs", function () { return $3948ac393721fe58$export$47ff1cdc99784c11; });
var $3948ac393721fe58$export$47ff1cdc99784c11 = {
    name: "setSize",
    category: "Set",
    syntax: [
        "setSize(set)",
        "setSize(set, unique)"
    ],
    description: 'Count the number of elements of a (multi)set. When the second parameter "unique" is true, count only the unique values. A multi-dimension array will be converted to a single-dimension array before the operation.',
    examples: [
        "setSize([1, 2, 2, 4])",
        "setSize([1, 2, 2, 4], true)"
    ],
    seealso: [
        "setUnion",
        "setIntersect",
        "setDifference"
    ]
};

});

parcelRegister("gClhT", function(module, exports) {

$parcel$export(module.exports, "setPowersetDocs", function () { return $c190b5352fea768d$export$7040fb97e0f08a08; });
var $c190b5352fea768d$export$7040fb97e0f08a08 = {
    name: "setPowerset",
    category: "Set",
    syntax: [
        "setPowerset(set)"
    ],
    description: "Create the powerset of a (multi)set: the powerset contains very possible subsets of a (multi)set. A multi-dimension array will be converted to a single-dimension array before the operation.",
    examples: [
        "setPowerset([1, 2, 3])"
    ],
    seealso: [
        "setCartesian"
    ]
};

});

parcelRegister("1JgD8", function(module, exports) {

$parcel$export(module.exports, "setMultiplicityDocs", function () { return $1426e4d5ea459e21$export$33972a95e247fd58; });
var $1426e4d5ea459e21$export$33972a95e247fd58 = {
    name: "setMultiplicity",
    category: "Set",
    syntax: [
        "setMultiplicity(element, set)"
    ],
    description: "Count the multiplicity of an element in a multiset. A multi-dimension array will be converted to a single-dimension array before the operation.",
    examples: [
        "setMultiplicity(1, [1, 2, 2, 4])",
        "setMultiplicity(2, [1, 2, 2, 4])"
    ],
    seealso: [
        "setDistinct",
        "setSize"
    ]
};

});

parcelRegister("5metl", function(module, exports) {

$parcel$export(module.exports, "setIsSubsetDocs", function () { return $3e6a3bbf0ca5a074$export$995337132a02fcf0; });
var $3e6a3bbf0ca5a074$export$995337132a02fcf0 = {
    name: "setIsSubset",
    category: "Set",
    syntax: [
        "setIsSubset(set1, set2)"
    ],
    description: "Check whether a (multi)set is a subset of another (multi)set: every element of set1 is the element of set2. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
    examples: [
        "setIsSubset([1, 2], [3, 4, 5, 6])",
        "setIsSubset([3, 4], [3, 4, 5, 6])"
    ],
    seealso: [
        "setUnion",
        "setIntersect",
        "setDifference"
    ]
};

});

parcelRegister("hXFLv", function(module, exports) {

$parcel$export(module.exports, "setIntersectDocs", function () { return $d1385809f816f1c0$export$97fa484e42285777; });
var $d1385809f816f1c0$export$97fa484e42285777 = {
    name: "setIntersect",
    category: "Set",
    syntax: [
        "setIntersect(set1, set2)"
    ],
    description: "Create the intersection of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
    examples: [
        "setIntersect([1, 2, 3, 4], [3, 4, 5, 6])",
        "setIntersect([[1, 2], [3, 4]], [[3, 4], [5, 6]])"
    ],
    seealso: [
        "setUnion",
        "setDifference"
    ]
};

});

parcelRegister("5jTG7", function(module, exports) {

$parcel$export(module.exports, "setDistinctDocs", function () { return $3df9eaaca00adc28$export$4c8f2f903562c625; });
var $3df9eaaca00adc28$export$4c8f2f903562c625 = {
    name: "setDistinct",
    category: "Set",
    syntax: [
        "setDistinct(set)"
    ],
    description: "Collect the distinct elements of a multiset. A multi-dimension array will be converted to a single-dimension array before the operation.",
    examples: [
        "setDistinct([1, 1, 1, 2, 2, 3])"
    ],
    seealso: [
        "setMultiplicity"
    ]
};

});

parcelRegister("1HbGK", function(module, exports) {

$parcel$export(module.exports, "setDifferenceDocs", function () { return $13c2dfab4ff787fd$export$44337ef629295c55; });
var $13c2dfab4ff787fd$export$44337ef629295c55 = {
    name: "setDifference",
    category: "Set",
    syntax: [
        "setDifference(set1, set2)"
    ],
    description: "Create the difference of two (multi)sets: every element of set1, that is not the element of set2. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
    examples: [
        "setDifference([1, 2, 3, 4], [3, 4, 5, 6])",
        "setDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])"
    ],
    seealso: [
        "setUnion",
        "setIntersect",
        "setSymDifference"
    ]
};

});

parcelRegister("hswFv", function(module, exports) {

$parcel$export(module.exports, "setCartesianDocs", function () { return $cb5e64770b0cf893$export$6f06d74ab9e6fcad; });
var $cb5e64770b0cf893$export$6f06d74ab9e6fcad = {
    name: "setCartesian",
    category: "Set",
    syntax: [
        "setCartesian(set1, set2)"
    ],
    description: "Create the cartesian product of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
    examples: [
        "setCartesian([1, 2], [3, 4])"
    ],
    seealso: [
        "setUnion",
        "setIntersect",
        "setDifference",
        "setPowerset"
    ]
};

});

parcelRegister("1vn8b", function(module, exports) {

$parcel$export(module.exports, "unequalDocs", function () { return $118aa108c537e559$export$adade6432715c34e; });
var $118aa108c537e559$export$adade6432715c34e = {
    name: "unequal",
    category: "Relational",
    syntax: [
        "x != y",
        "unequal(x, y)"
    ],
    description: "Check unequality of two values. Returns true if the values are unequal, and false if they are equal.",
    examples: [
        "2+2 != 3",
        "2+2 != 4",
        "a = 3.2",
        "b = 6-2.8",
        "a != b",
        "50cm != 0.5m",
        "5 cm != 2 inch"
    ],
    seealso: [
        "equal",
        "smaller",
        "larger",
        "smallerEq",
        "largerEq",
        "compare",
        "deepEqual"
    ]
};

});

parcelRegister("iD8Dz", function(module, exports) {

$parcel$export(module.exports, "smallerEqDocs", function () { return $d90291b5f63985c3$export$2693b3d153548453; });
var $d90291b5f63985c3$export$2693b3d153548453 = {
    name: "smallerEq",
    category: "Relational",
    syntax: [
        "x <= y",
        "smallerEq(x, y)"
    ],
    description: "Check if value x is smaller or equal to value y. Returns true if x is smaller than y, and false if not.",
    examples: [
        "2 <= 1+1",
        "2 < 1+1",
        "a = 3.2",
        "b = 6-2.8",
        "(a <= b)"
    ],
    seealso: [
        "equal",
        "unequal",
        "larger",
        "smaller",
        "largerEq",
        "compare"
    ]
};

});

parcelRegister("pAd0e", function(module, exports) {

$parcel$export(module.exports, "smallerDocs", function () { return $04ce6c3661b6363d$export$4ecf0efdd4fb906b; });
var $04ce6c3661b6363d$export$4ecf0efdd4fb906b = {
    name: "smaller",
    category: "Relational",
    syntax: [
        "x < y",
        "smaller(x, y)"
    ],
    description: "Check if value x is smaller than value y. Returns true if x is smaller than y, and false if not.",
    examples: [
        "2 < 3",
        "5 < 2*2",
        "a = 3.3",
        "b = 6-2.8",
        "(a < b)",
        "5 cm < 2 inch"
    ],
    seealso: [
        "equal",
        "unequal",
        "larger",
        "smallerEq",
        "largerEq",
        "compare"
    ]
};

});

parcelRegister("fMspx", function(module, exports) {

$parcel$export(module.exports, "largerEqDocs", function () { return $b7d16089d15b49ec$export$6ba4892ab98a938f; });
var $b7d16089d15b49ec$export$6ba4892ab98a938f = {
    name: "largerEq",
    category: "Relational",
    syntax: [
        "x >= y",
        "largerEq(x, y)"
    ],
    description: "Check if value x is larger or equal to y. Returns true if x is larger or equal to y, and false if not.",
    examples: [
        "2 >= 1+1",
        "2 > 1+1",
        "a = 3.2",
        "b = 6-2.8",
        "(a >= b)"
    ],
    seealso: [
        "equal",
        "unequal",
        "smallerEq",
        "smaller",
        "compare"
    ]
};

});

parcelRegister("29Sk0", function(module, exports) {

$parcel$export(module.exports, "largerDocs", function () { return $19268f2f9c5ed0d3$export$c775ecf5ac7366c3; });
var $19268f2f9c5ed0d3$export$c775ecf5ac7366c3 = {
    name: "larger",
    category: "Relational",
    syntax: [
        "x > y",
        "larger(x, y)"
    ],
    description: "Check if value x is larger than y. Returns true if x is larger than y, and false if not.",
    examples: [
        "2 > 3",
        "5 > 2*2",
        "a = 3.3",
        "b = 6-2.8",
        "(a > b)",
        "(b < a)",
        "5 cm > 2 inch"
    ],
    seealso: [
        "equal",
        "unequal",
        "smaller",
        "smallerEq",
        "largerEq",
        "compare"
    ]
};

});

parcelRegister("5rQ2p", function(module, exports) {

$parcel$export(module.exports, "equalTextDocs", function () { return $3f77d6fe273feaa8$export$9f17f53860452971; });
var $3f77d6fe273feaa8$export$9f17f53860452971 = {
    name: "equalText",
    category: "Relational",
    syntax: [
        "equalText(x, y)"
    ],
    description: "Check equality of two strings. Comparison is case sensitive. Returns true if the values are equal, and false if not.",
    examples: [
        'equalText("Hello", "Hello")',
        'equalText("a", "A")',
        'equal("2e3", "2000")',
        'equalText("2e3", "2000")',
        'equalText("B", ["A", "B", "C"])'
    ],
    seealso: [
        "compare",
        "compareNatural",
        "compareText",
        "equal"
    ]
};

});

parcelRegister("hWjKc", function(module, exports) {

$parcel$export(module.exports, "equalDocs", function () { return $d0f72b3aa32f649b$export$5d5e6107045d826c; });
var $d0f72b3aa32f649b$export$5d5e6107045d826c = {
    name: "equal",
    category: "Relational",
    syntax: [
        "x == y",
        "equal(x, y)"
    ],
    description: "Check equality of two values. Returns true if the values are equal, and false if not.",
    examples: [
        "2+2 == 3",
        "2+2 == 4",
        "a = 3.2",
        "b = 6-2.8",
        "a == b",
        "50cm == 0.5m"
    ],
    seealso: [
        "unequal",
        "smaller",
        "larger",
        "smallerEq",
        "largerEq",
        "compare",
        "deepEqual",
        "equalText"
    ]
};

});

parcelRegister("f4IAk", function(module, exports) {

$parcel$export(module.exports, "deepEqualDocs", function () { return $af99d05a0f37721a$export$b25f67ed715e775e; });
var $af99d05a0f37721a$export$b25f67ed715e775e = {
    name: "deepEqual",
    category: "Relational",
    syntax: [
        "deepEqual(x, y)"
    ],
    description: "Check equality of two matrices element wise. Returns true if the size of both matrices is equal and when and each of the elements are equal.",
    examples: [
        "deepEqual([1,3,4], [1,3,4])",
        "deepEqual([1,3,4], [1,3])"
    ],
    seealso: [
        "equal",
        "unequal",
        "smaller",
        "larger",
        "smallerEq",
        "largerEq",
        "compare"
    ]
};

});

parcelRegister("esSbP", function(module, exports) {

$parcel$export(module.exports, "compareTextDocs", function () { return $a87db72ff3d520cd$export$f1ca5e1f3bd19e5d; });
var $a87db72ff3d520cd$export$f1ca5e1f3bd19e5d = {
    name: "compareText",
    category: "Relational",
    syntax: [
        "compareText(x, y)"
    ],
    description: "Compare two strings lexically. Comparison is case sensitive. Returns 1 when x > y, -1 when x < y, and 0 when x == y.",
    examples: [
        'compareText("B", "A")',
        'compareText("A", "B")',
        'compareText("A", "A")',
        'compareText("2", "10")',
        'compare("2", "10")',
        "compare(2, 10)",
        'compareNatural("2", "10")',
        'compareText("B", ["A", "B", "C"])'
    ],
    seealso: [
        "compare",
        "compareNatural"
    ]
};

});

parcelRegister("cJOhk", function(module, exports) {

$parcel$export(module.exports, "compareNaturalDocs", function () { return $9460b041553ab38a$export$3d0415783a6e23a4; });
var $9460b041553ab38a$export$3d0415783a6e23a4 = {
    name: "compareNatural",
    category: "Relational",
    syntax: [
        "compareNatural(x, y)"
    ],
    description: "Compare two values of any type in a deterministic, natural way. Returns 1 when x > y, -1 when x < y, and 0 when x == y.",
    examples: [
        "compareNatural(2, 3)",
        "compareNatural(3, 2)",
        "compareNatural(2, 2)",
        "compareNatural(5cm, 40mm)",
        'compareNatural("2", "10")',
        "compareNatural(2 + 3i, 2 + 4i)",
        "compareNatural([1, 2, 4], [1, 2, 3])",
        "compareNatural([1, 5], [1, 2, 3])",
        "compareNatural([1, 2], [1, 2])",
        "compareNatural({a: 2}, {a: 4})"
    ],
    seealso: [
        "equal",
        "unequal",
        "smaller",
        "smallerEq",
        "largerEq",
        "compare",
        "compareText"
    ]
};

});

parcelRegister("bPPUd", function(module, exports) {

$parcel$export(module.exports, "compareDocs", function () { return $89dcb887aa0f40de$export$b01f6c58c90dea20; });
var $89dcb887aa0f40de$export$b01f6c58c90dea20 = {
    name: "compare",
    category: "Relational",
    syntax: [
        "compare(x, y)"
    ],
    description: "Compare two values. Returns 1 when x > y, -1 when x < y, and 0 when x == y.",
    examples: [
        "compare(2, 3)",
        "compare(3, 2)",
        "compare(2, 2)",
        "compare(5cm, 40mm)",
        "compare(2, [1, 2, 3])"
    ],
    seealso: [
        "equal",
        "unequal",
        "smaller",
        "smallerEq",
        "largerEq",
        "compareNatural",
        "compareText"
    ]
};

});

parcelRegister("bhUEc", function(module, exports) {

$parcel$export(module.exports, "randomIntDocs", function () { return $837d393c7edcedf3$export$8e2c9b3226630e9d; });
var $837d393c7edcedf3$export$8e2c9b3226630e9d = {
    name: "randomInt",
    category: "Probability",
    syntax: [
        "randomInt(max)",
        "randomInt(min, max)",
        "randomInt(size)",
        "randomInt(size, max)",
        "randomInt(size, min, max)"
    ],
    description: "Return a random integer number",
    examples: [
        "randomInt(10, 20)",
        "randomInt([2, 3], 10)"
    ],
    seealso: [
        "pickRandom",
        "random"
    ]
};

});

parcelRegister("iqyuY", function(module, exports) {

$parcel$export(module.exports, "randomDocs", function () { return $d6a56a6270332876$export$d2b3cacd4d3219ec; });
var $d6a56a6270332876$export$d2b3cacd4d3219ec = {
    name: "random",
    category: "Probability",
    syntax: [
        "random()",
        "random(max)",
        "random(min, max)",
        "random(size)",
        "random(size, max)",
        "random(size, min, max)"
    ],
    description: "Return a random number.",
    examples: [
        "random()",
        "random(10, 20)",
        "random([2, 3])"
    ],
    seealso: [
        "pickRandom",
        "randomInt"
    ]
};

});

parcelRegister("6oAiR", function(module, exports) {

$parcel$export(module.exports, "pickRandomDocs", function () { return $4a81250a964f586e$export$4a787d8dccbe181f; });
var $4a81250a964f586e$export$4a787d8dccbe181f = {
    name: "pickRandom",
    category: "Probability",
    syntax: [
        "pickRandom(array)",
        "pickRandom(array, number)",
        "pickRandom(array, weights)",
        "pickRandom(array, number, weights)",
        "pickRandom(array, weights, number)"
    ],
    description: "Pick a random entry from a given array.",
    examples: [
        "pickRandom(0:10)",
        "pickRandom([1, 3, 1, 6])",
        "pickRandom([1, 3, 1, 6], 2)",
        "pickRandom([1, 3, 1, 6], [2, 3, 2, 1])",
        "pickRandom([1, 3, 1, 6], 2, [2, 3, 2, 1])",
        "pickRandom([1, 3, 1, 6], [2, 3, 2, 1], 2)"
    ],
    seealso: [
        "random",
        "randomInt"
    ]
};

});

parcelRegister("Hb4my", function(module, exports) {

$parcel$export(module.exports, "permutationsDocs", function () { return $081c9a69c4937cde$export$eebb1076c4c85884; });
var $081c9a69c4937cde$export$eebb1076c4c85884 = {
    name: "permutations",
    category: "Probability",
    syntax: [
        "permutations(n)",
        "permutations(n, k)"
    ],
    description: "Compute the number of permutations of n items taken k at a time",
    examples: [
        "permutations(5)",
        "permutations(5, 3)"
    ],
    seealso: [
        "combinations",
        "combinationsWithRep",
        "factorial"
    ]
};

});

parcelRegister("6zv1C", function(module, exports) {

$parcel$export(module.exports, "multinomialDocs", function () { return $4c8e13e537354771$export$5f53cf42e3f9579d; });
var $4c8e13e537354771$export$5f53cf42e3f9579d = {
    name: "multinomial",
    category: "Probability",
    syntax: [
        "multinomial(A)"
    ],
    description: "Multinomial Coefficients compute the number of ways of picking a1, a2, ..., ai unordered outcomes from `n` possibilities. multinomial takes one array of integers as an argument. The following condition must be enforced: every ai > 0.",
    examples: [
        "multinomial([1, 2, 1])"
    ],
    seealso: [
        "combinations",
        "factorial"
    ]
};

});

parcelRegister("94ozR", function(module, exports) {

$parcel$export(module.exports, "kldivergenceDocs", function () { return $69a78d4fedcc03ea$export$9f240af60ea686af; });
var $69a78d4fedcc03ea$export$9f240af60ea686af = {
    name: "kldivergence",
    category: "Probability",
    syntax: [
        "kldivergence(x, y)"
    ],
    description: "Calculate the Kullback-Leibler (KL) divergence  between two distributions.",
    examples: [
        "kldivergence([0.7,0.5,0.4], [0.2,0.9,0.5])"
    ],
    seealso: []
};

});

parcelRegister("jWioE", function(module, exports) {

$parcel$export(module.exports, "gammaDocs", function () { return $03befec7624fa29a$export$499ae9272b264120; });
var $03befec7624fa29a$export$499ae9272b264120 = {
    name: "gamma",
    category: "Probability",
    syntax: [
        "gamma(n)"
    ],
    description: "Compute the gamma function. For small values, the Lanczos approximation is used, and for large values the extended Stirling approximation.",
    examples: [
        "gamma(4)",
        "3!",
        "gamma(1/2)",
        "sqrt(pi)"
    ],
    seealso: [
        "factorial"
    ]
};

});

parcelRegister("98IcR", function(module, exports) {

$parcel$export(module.exports, "factorialDocs", function () { return $6a7726e1c5336633$export$3e6b0f8e2df12b9d; });
var $6a7726e1c5336633$export$3e6b0f8e2df12b9d = {
    name: "factorial",
    category: "Probability",
    syntax: [
        "n!",
        "factorial(n)"
    ],
    description: "Compute the factorial of a value",
    examples: [
        "5!",
        "5 * 4 * 3 * 2 * 1",
        "3!"
    ],
    seealso: [
        "combinations",
        "combinationsWithRep",
        "permutations",
        "gamma"
    ]
};

});

parcelRegister("5jAbk", function(module, exports) {

$parcel$export(module.exports, "combinationsDocs", function () { return $3deacb079589c2a7$export$c3382240e69dd024; });
var $3deacb079589c2a7$export$c3382240e69dd024 = {
    name: "combinations",
    category: "Probability",
    syntax: [
        "combinations(n, k)"
    ],
    description: "Compute the number of combinations of n items taken k at a time",
    examples: [
        "combinations(7, 5)"
    ],
    seealso: [
        "combinationsWithRep",
        "permutations",
        "factorial"
    ]
};

});

parcelRegister("ajzBf", function(module, exports) {

$parcel$export(module.exports, "combinationsWithRepDocs", function () { return $78274b17df533a3b$export$6bd2fb28e29d18e3; });
var $78274b17df533a3b$export$6bd2fb28e29d18e3 = {
    name: "combinationsWithRep",
    category: "Probability",
    syntax: [
        "combinationsWithRep(n, k)"
    ],
    description: "Compute the number of combinations of n items taken k at a time with replacements.",
    examples: [
        "combinationsWithRep(7, 5)"
    ],
    seealso: [
        "combinations",
        "permutations",
        "factorial"
    ]
};

});

parcelRegister("4xjiF", function(module, exports) {

$parcel$export(module.exports, "zerosDocs", function () { return $34d9371bce40811d$export$d2794fce5915ba29; });
var $34d9371bce40811d$export$d2794fce5915ba29 = {
    name: "zeros",
    category: "Matrix",
    syntax: [
        "zeros(m)",
        "zeros(m, n)",
        "zeros(m, n, p, ...)",
        "zeros([m])",
        "zeros([m, n])",
        "zeros([m, n, p, ...])"
    ],
    description: "Create a matrix containing zeros.",
    examples: [
        "zeros(3)",
        "zeros(3, 5)",
        "a = [1, 2, 3; 4, 5, 6]",
        "zeros(size(a))"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "identity",
        "inv",
        "ones",
        "range",
        "size",
        "squeeze",
        "subset",
        "trace",
        "transpose"
    ]
};

});

parcelRegister("6NTLP", function(module, exports) {

$parcel$export(module.exports, "transposeDocs", function () { return $4f42948a1bbf7294$export$96fcaa3e48aec95b; });
var $4f42948a1bbf7294$export$96fcaa3e48aec95b = {
    name: "transpose",
    category: "Matrix",
    syntax: [
        "x'",
        "transpose(x)"
    ],
    description: "Transpose a matrix",
    examples: [
        "a = [1, 2, 3; 4, 5, 6]",
        "a'",
        "transpose(a)"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "identity",
        "inv",
        "ones",
        "range",
        "size",
        "squeeze",
        "subset",
        "trace",
        "zeros"
    ]
};

});

parcelRegister("5dNX5", function(module, exports) {

$parcel$export(module.exports, "traceDocs", function () { return $3cd4ea10f7745255$export$46db08346422dd41; });
var $3cd4ea10f7745255$export$46db08346422dd41 = {
    name: "trace",
    category: "Matrix",
    syntax: [
        "trace(A)"
    ],
    description: "Calculate the trace of a matrix: the sum of the elements on the main diagonal of a square matrix.",
    examples: [
        "A = [1, 2, 3; -1, 2, 3; 2, 0, 3]",
        "trace(A)"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "identity",
        "inv",
        "ones",
        "range",
        "size",
        "squeeze",
        "subset",
        "transpose",
        "zeros"
    ]
};

});

parcelRegister("9upGK", function(module, exports) {

$parcel$export(module.exports, "subsetDocs", function () { return $6e8ad79440d65ddc$export$c809a1297fda8972; });
var $6e8ad79440d65ddc$export$c809a1297fda8972 = {
    name: "subset",
    category: "Matrix",
    syntax: [
        "value(index)",
        "value(index) = replacement",
        "subset(value, [index])",
        "subset(value, [index], replacement)"
    ],
    description: "Get or set a subset of a matrix or string. Indexes are one-based. Both the ranges lower-bound and upper-bound are included.",
    examples: [
        "d = [1, 2; 3, 4]",
        "e = []",
        "e[1, 1:2] = [5, 6]",
        "e[2, :] = [7, 8]",
        "f = d * e",
        "f[2, 1]",
        "f[:, 1]"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "identity",
        "inv",
        "ones",
        "range",
        "size",
        "squeeze",
        "trace",
        "transpose",
        "zeros"
    ]
};

});

parcelRegister("ep8CJ", function(module, exports) {

$parcel$export(module.exports, "squeezeDocs", function () { return $a7ca16fc9e589339$export$84665209630d2bb0; });
var $a7ca16fc9e589339$export$84665209630d2bb0 = {
    name: "squeeze",
    category: "Matrix",
    syntax: [
        "squeeze(x)"
    ],
    description: "Remove inner and outer singleton dimensions from a matrix.",
    examples: [
        "a = zeros(3,2,1)",
        "size(squeeze(a))",
        "b = zeros(1,1,3)",
        "size(squeeze(b))"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "identity",
        "inv",
        "ones",
        "range",
        "size",
        "subset",
        "trace",
        "transpose",
        "zeros"
    ]
};

});

parcelRegister("7iAxZ", function(module, exports) {

$parcel$export(module.exports, "sortDocs", function () { return $55069059f27a9574$export$879539db0de7fe73; });
var $55069059f27a9574$export$879539db0de7fe73 = {
    name: "sort",
    category: "Matrix",
    syntax: [
        "sort(x)",
        "sort(x, compare)"
    ],
    description: 'Sort the items in a matrix. Compare can be a string "asc", "desc", "natural", or a custom sort function.',
    examples: [
        "sort([5, 10, 1])",
        'sort(["C", "B", "A", "D"])',
        "sortByLength(a, b) = size(a)[1] - size(b)[1]",
        'sort(["Langdon", "Tom", "Sara"], sortByLength)',
        'sort(["10", "1", "2"], "natural")'
    ],
    seealso: [
        "map",
        "filter",
        "forEach"
    ]
};

});

parcelRegister("8sSTA", function(module, exports) {

$parcel$export(module.exports, "sizeDocs", function () { return $629b8561d15873d7$export$5044182a5ddc46fd; });
var $629b8561d15873d7$export$5044182a5ddc46fd = {
    name: "size",
    category: "Matrix",
    syntax: [
        "size(x)"
    ],
    description: "Calculate the size of a matrix.",
    examples: [
        "size(2.3)",
        'size("hello world")',
        "a = [1, 2; 3, 4; 5, 6]",
        "size(a)",
        "size(1:6)"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "identity",
        "inv",
        "ones",
        "range",
        "squeeze",
        "subset",
        "trace",
        "transpose",
        "zeros"
    ]
};

});

parcelRegister("2IAga", function(module, exports) {

$parcel$export(module.exports, "reshapeDocs", function () { return $1fabd143b758fe95$export$f57c799cb449edab; });
var $1fabd143b758fe95$export$f57c799cb449edab = {
    name: "reshape",
    category: "Matrix",
    syntax: [
        "reshape(x, sizes)"
    ],
    description: "Reshape a multi dimensional array to fit the specified dimensions.",
    examples: [
        "reshape([1, 2, 3, 4, 5, 6], [2, 3])",
        "reshape([[1, 2], [3, 4]], [1, 4])",
        "reshape([[1, 2], [3, 4]], [4])"
    ],
    seealso: [
        "size",
        "squeeze",
        "resize"
    ]
};

});

parcelRegister("bK9Ub", function(module, exports) {

$parcel$export(module.exports, "resizeDocs", function () { return $88cbac89479c4445$export$9444f970d5d871cc; });
var $88cbac89479c4445$export$9444f970d5d871cc = {
    name: "resize",
    category: "Matrix",
    syntax: [
        "resize(x, size)",
        "resize(x, size, defaultValue)"
    ],
    description: "Resize a matrix.",
    examples: [
        "resize([1,2,3,4,5], [3])",
        "resize([1,2,3], [5])",
        "resize([1,2,3], [5], -1)",
        "resize(2, [2, 3])",
        'resize("hello", [8], "!")'
    ],
    seealso: [
        "size",
        "subset",
        "squeeze",
        "reshape"
    ]
};

});

parcelRegister("iCWKL", function(module, exports) {

$parcel$export(module.exports, "rangeDocs", function () { return $d8f959cc11d8dc4a$export$f7c7d2df7253c271; });
var $d8f959cc11d8dc4a$export$f7c7d2df7253c271 = {
    name: "range",
    category: "Type",
    syntax: [
        "start:end",
        "start:step:end",
        "range(start, end)",
        "range(start, end, step)",
        "range(string)"
    ],
    description: "Create a range. Lower bound of the range is included, upper bound is excluded.",
    examples: [
        "1:5",
        "3:-1:-3",
        "range(3, 7)",
        "range(0, 12, 2)",
        'range("4:10")',
        "a = [1, 2, 3, 4; 5, 6, 7, 8]",
        "a[1:2, 1:2]"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "identity",
        "inv",
        "ones",
        "size",
        "squeeze",
        "subset",
        "trace",
        "transpose",
        "zeros"
    ]
};

});

parcelRegister("7w6rE", function(module, exports) {

$parcel$export(module.exports, "partitionSelectDocs", function () { return $57908560749070e7$export$65c28ab37b5158f2; });
var $57908560749070e7$export$65c28ab37b5158f2 = {
    name: "partitionSelect",
    category: "Matrix",
    syntax: [
        "partitionSelect(x, k)",
        "partitionSelect(x, k, compare)"
    ],
    description: "Partition-based selection of an array or 1D matrix. Will find the kth smallest value, and mutates the input array. Uses Quickselect.",
    examples: [
        "partitionSelect([5, 10, 1], 2)",
        'partitionSelect(["C", "B", "A", "D"], 1)'
    ],
    seealso: [
        "sort"
    ]
};

});

parcelRegister("ejDM7", function(module, exports) {

$parcel$export(module.exports, "onesDocs", function () { return $a6c1b18c4969197e$export$910fc795c37fb1b2; });
var $a6c1b18c4969197e$export$910fc795c37fb1b2 = {
    name: "ones",
    category: "Matrix",
    syntax: [
        "ones(m)",
        "ones(m, n)",
        "ones(m, n, p, ...)",
        "ones([m])",
        "ones([m, n])",
        "ones([m, n, p, ...])"
    ],
    description: "Create a matrix containing ones.",
    examples: [
        "ones(3)",
        "ones(3, 5)",
        "ones([2,3]) * 4.5",
        "a = [1, 2, 3; 4, 5, 6]",
        "ones(size(a))"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "identity",
        "inv",
        "range",
        "size",
        "squeeze",
        "subset",
        "trace",
        "transpose",
        "zeros"
    ]
};

});

parcelRegister("caseB", function(module, exports) {

$parcel$export(module.exports, "mapDocs", function () { return $8dbc51fd3e5faea1$export$212579151a971c0d; });
var $8dbc51fd3e5faea1$export$212579151a971c0d = {
    name: "map",
    category: "Matrix",
    syntax: [
        "map(x, callback)"
    ],
    description: "Create a new matrix or array with the results of the callback function executed on each entry of the matrix/array.",
    examples: [
        "map([1, 2, 3], square)"
    ],
    seealso: [
        "filter",
        "forEach"
    ]
};

});

parcelRegister("fzWrz", function(module, exports) {

$parcel$export(module.exports, "kronDocs", function () { return $b57775936e9688da$export$483111e0489c2571; });
var $b57775936e9688da$export$483111e0489c2571 = {
    name: "kron",
    category: "Matrix",
    syntax: [
        "kron(x, y)"
    ],
    description: "Calculates the kronecker product of 2 matrices or vectors.",
    examples: [
        "kron([[1, 0], [0, 1]], [[1, 2], [3, 4]])",
        "kron([1,1], [2,3,4])"
    ],
    seealso: [
        "multiply",
        "dot",
        "cross"
    ]
};

});

parcelRegister("1eZRj", function(module, exports) {

$parcel$export(module.exports, "invDocs", function () { return $0e77151fb75c3c6d$export$d584490ba37af473; });
var $0e77151fb75c3c6d$export$d584490ba37af473 = {
    name: "inv",
    category: "Matrix",
    syntax: [
        "inv(x)"
    ],
    description: "Calculate the inverse of a matrix",
    examples: [
        "inv([1, 2; 3, 4])",
        "inv(4)",
        "1 / 4"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "identity",
        "ones",
        "range",
        "size",
        "squeeze",
        "subset",
        "trace",
        "transpose",
        "zeros"
    ]
};

});

parcelRegister("5aBGU", function(module, exports) {

$parcel$export(module.exports, "forEachDocs", function () { return $3c3b1f96c6d8d3eb$export$aa1ea88ef762ab5e; });
var $3c3b1f96c6d8d3eb$export$aa1ea88ef762ab5e = {
    name: "forEach",
    category: "Matrix",
    syntax: [
        "forEach(x, callback)"
    ],
    description: "Iterates over all elements of a matrix/array, and executes the given callback function.",
    examples: [
        "forEach([1, 2, 3], function(val) { console.log(val) })"
    ],
    seealso: [
        "map",
        "sort",
        "filter"
    ]
};

});

parcelRegister("bNrUA", function(module, exports) {

$parcel$export(module.exports, "flattenDocs", function () { return $8969ebf9a9699f44$export$501e32649028a485; });
var $8969ebf9a9699f44$export$501e32649028a485 = {
    name: "flatten",
    category: "Matrix",
    syntax: [
        "flatten(x)"
    ],
    description: "Flatten a multi dimensional matrix into a single dimensional matrix.",
    examples: [
        "a = [1, 2, 3; 4, 5, 6]",
        "size(a)",
        "b = flatten(a)",
        "size(b)"
    ],
    seealso: [
        "concat",
        "resize",
        "size",
        "squeeze"
    ]
};

});

parcelRegister("9P90h", function(module, exports) {

$parcel$export(module.exports, "filterDocs", function () { return $726fdc5faea6c36a$export$86d791908cc7fd0c; });
var $726fdc5faea6c36a$export$86d791908cc7fd0c = {
    name: "filter",
    category: "Matrix",
    syntax: [
        "filter(x, test)"
    ],
    description: "Filter items in a matrix.",
    examples: [
        "isPositive(x) = x > 0",
        "filter([6, -2, -1, 4, 3], isPositive)",
        "filter([6, -2, 0, 1, 0], x != 0)"
    ],
    seealso: [
        "sort",
        "map",
        "forEach"
    ]
};

});

parcelRegister("kT6kx", function(module, exports) {

$parcel$export(module.exports, "identityDocs", function () { return $f34ddac6ec75f906$export$7fb92bf552f6842; });
var $f34ddac6ec75f906$export$7fb92bf552f6842 = {
    name: "identity",
    category: "Matrix",
    syntax: [
        "identity(n)",
        "identity(m, n)",
        "identity([m, n])"
    ],
    description: "Returns the identity matrix with size m-by-n. The matrix has ones on the diagonal and zeros elsewhere.",
    examples: [
        "identity(3)",
        "identity(3, 5)",
        "a = [1, 2, 3; 4, 5, 6]",
        "identity(size(a))"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "inv",
        "ones",
        "range",
        "size",
        "squeeze",
        "subset",
        "trace",
        "transpose",
        "zeros"
    ]
};

});

parcelRegister("8a0Jr", function(module, exports) {

$parcel$export(module.exports, "getMatrixDataTypeDocs", function () { return $5f0fd33e3f108b6c$export$bd8d81afc6159d78; });
var $5f0fd33e3f108b6c$export$bd8d81afc6159d78 = {
    name: "getMatrixDataType",
    category: "Matrix",
    syntax: [
        "getMatrixDataType(x)"
    ],
    description: 'Find the data type of all elements in a matrix or array, for example "number" if all items are a number and "Complex" if all values are complex numbers. If a matrix contains more than one data type, it will return "mixed".',
    examples: [
        "getMatrixDataType([1, 2, 3])",
        "getMatrixDataType([[5 cm], [2 inch]])",
        'getMatrixDataType([1, "text"])',
        "getMatrixDataType([1, bignumber(4)])"
    ],
    seealso: [
        "matrix",
        "sparse",
        "typeOf"
    ]
};

});

parcelRegister("2dqcg", function(module, exports) {

$parcel$export(module.exports, "dotDocs", function () { return $19d11dcfae5604b1$export$5fcedf26656436a1; });
var $19d11dcfae5604b1$export$5fcedf26656436a1 = {
    name: "dot",
    category: "Matrix",
    syntax: [
        "dot(A, B)",
        "A * B"
    ],
    description: "Calculate the dot product of two vectors. The dot product of A = [a1, a2, a3, ..., an] and B = [b1, b2, b3, ..., bn] is defined as dot(A, B) = a1 * b1 + a2 * b2 + a3 * b3 + ... + an * bn",
    examples: [
        "dot([2, 4, 1], [2, 2, 3])",
        "[2, 4, 1] * [2, 2, 3]"
    ],
    seealso: [
        "multiply",
        "cross"
    ]
};

});

parcelRegister("2x6QV", function(module, exports) {

$parcel$export(module.exports, "diagDocs", function () { return $1d83fa9de007ef78$export$1c196182ad1e1777; });
var $1d83fa9de007ef78$export$1c196182ad1e1777 = {
    name: "diag",
    category: "Matrix",
    syntax: [
        "diag(x)",
        "diag(x, k)"
    ],
    description: "Create a diagonal matrix or retrieve the diagonal of a matrix. When x is a vector, a matrix with the vector values on the diagonal will be returned. When x is a matrix, a vector with the diagonal values of the matrix is returned. When k is provided, the k-th diagonal will be filled in or retrieved, if k is positive, the values are placed on the super diagonal. When k is negative, the values are placed on the sub diagonal.",
    examples: [
        "diag(1:3)",
        "diag(1:3, 1)",
        "a = [1, 2, 3; 4, 5, 6; 7, 8, 9]",
        "diag(a)"
    ],
    seealso: [
        "concat",
        "det",
        "identity",
        "inv",
        "ones",
        "range",
        "size",
        "squeeze",
        "subset",
        "trace",
        "transpose",
        "zeros"
    ]
};

});

parcelRegister("eDw1l", function(module, exports) {

$parcel$export(module.exports, "detDocs", function () { return $aa7d8bdc6a8c20ed$export$8730784260ee72c2; });
var $aa7d8bdc6a8c20ed$export$8730784260ee72c2 = {
    name: "det",
    category: "Matrix",
    syntax: [
        "det(x)"
    ],
    description: "Calculate the determinant of a matrix",
    examples: [
        "det([1, 2; 3, 4])",
        "det([-2, 2, 3; -1, 1, 3; 2, 0, -1])"
    ],
    seealso: [
        "concat",
        "diag",
        "identity",
        "inv",
        "ones",
        "range",
        "size",
        "squeeze",
        "subset",
        "trace",
        "transpose",
        "zeros"
    ]
};

});

parcelRegister("gohFp", function(module, exports) {

$parcel$export(module.exports, "ctransposeDocs", function () { return $beec9782df1c8a6c$export$f9de74ff268bebd9; });
var $beec9782df1c8a6c$export$f9de74ff268bebd9 = {
    name: "ctranspose",
    category: "Matrix",
    syntax: [
        "x'",
        "ctranspose(x)"
    ],
    description: "Complex Conjugate and Transpose a matrix",
    examples: [
        "a = [1, 2, 3; 4, 5, 6]",
        "a'",
        "ctranspose(a)"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "identity",
        "inv",
        "ones",
        "range",
        "size",
        "squeeze",
        "subset",
        "trace",
        "zeros"
    ]
};

});

parcelRegister("72AW0", function(module, exports) {

$parcel$export(module.exports, "crossDocs", function () { return $52055ebaad342885$export$daf3380fde4ae39d; });
var $52055ebaad342885$export$daf3380fde4ae39d = {
    name: "cross",
    category: "Matrix",
    syntax: [
        "cross(A, B)"
    ],
    description: "Calculate the cross product for two vectors in three dimensional space.",
    examples: [
        "cross([1, 1, 0],  [0, 1, 1])",
        "cross([3, -3, 1], [4, 9, 2])",
        "cross([2, 3, 4],  [5, 6, 7])"
    ],
    seealso: [
        "multiply",
        "dot"
    ]
};

});

parcelRegister("auL4F", function(module, exports) {

$parcel$export(module.exports, "concatDocs", function () { return $7a4138b20207fb37$export$2651d46c991329eb; });
var $7a4138b20207fb37$export$2651d46c991329eb = {
    name: "concat",
    category: "Matrix",
    syntax: [
        "concat(A, B, C, ...)",
        "concat(A, B, C, ..., dim)"
    ],
    description: "Concatenate matrices. By default, the matrices are concatenated by the last dimension. The dimension on which to concatenate can be provided as last argument.",
    examples: [
        "A = [1, 2; 5, 6]",
        "B = [3, 4; 7, 8]",
        "concat(A, B)",
        "concat(A, B, 1)",
        "concat(A, B, 2)"
    ],
    seealso: [
        "det",
        "diag",
        "identity",
        "inv",
        "ones",
        "range",
        "size",
        "squeeze",
        "subset",
        "trace",
        "transpose",
        "zeros"
    ]
};

});

parcelRegister("ab3Mw", function(module, exports) {

$parcel$export(module.exports, "xorDocs", function () { return $768ddd6b4551419b$export$dd9d665b8b14e2b2; });
var $768ddd6b4551419b$export$dd9d665b8b14e2b2 = {
    name: "xor",
    category: "Logical",
    syntax: [
        "x xor y",
        "xor(x, y)"
    ],
    description: "Logical exclusive or, xor. Test whether one and only one value is defined with a nonzero/nonempty value.",
    examples: [
        "true xor false",
        "false xor false",
        "true xor true",
        "0 xor 4"
    ],
    seealso: [
        "not",
        "and",
        "or"
    ]
};

});

parcelRegister("03EUJ", function(module, exports) {

$parcel$export(module.exports, "orDocs", function () { return $00b0049c6b3f4390$export$2200bcb1a08f6f8d; });
var $00b0049c6b3f4390$export$2200bcb1a08f6f8d = {
    name: "or",
    category: "Logical",
    syntax: [
        "x or y",
        "or(x, y)"
    ],
    description: "Logical or. Test if at least one value is defined with a nonzero/nonempty value.",
    examples: [
        "true or false",
        "false or false",
        "0 or 4"
    ],
    seealso: [
        "not",
        "and",
        "xor"
    ]
};

});

parcelRegister("iEbSj", function(module, exports) {

$parcel$export(module.exports, "notDocs", function () { return $d9352c8965acf24c$export$dfd4aa05f81041ff; });
var $d9352c8965acf24c$export$dfd4aa05f81041ff = {
    name: "not",
    category: "Logical",
    syntax: [
        "not x",
        "not(x)"
    ],
    description: "Logical not. Flips the boolean value of given argument.",
    examples: [
        "not true",
        "not false",
        "not 2",
        "not 0"
    ],
    seealso: [
        "and",
        "or",
        "xor"
    ]
};

});

parcelRegister("jWo8L", function(module, exports) {

$parcel$export(module.exports, "andDocs", function () { return $e84628dc4e4b613d$export$20737fc9b0a3839c; });
var $e84628dc4e4b613d$export$20737fc9b0a3839c = {
    name: "and",
    category: "Logical",
    syntax: [
        "x and y",
        "and(x, y)"
    ],
    description: "Logical and. Test whether two values are both defined with a nonzero/nonempty value.",
    examples: [
        "true and false",
        "true and true",
        "2 and 4"
    ],
    seealso: [
        "not",
        "or",
        "xor"
    ]
};

});

parcelRegister("6nd4e", function(module, exports) {

$parcel$export(module.exports, "intersectDocs", function () { return $4a3f06ebd44a1230$export$cf98256b70808117; });
var $4a3f06ebd44a1230$export$cf98256b70808117 = {
    name: "intersect",
    category: "Geometry",
    syntax: [
        "intersect(expr1, expr2, expr3, expr4)",
        "intersect(expr1, expr2, expr3)"
    ],
    description: "Computes the intersection point of lines and/or planes.",
    examples: [
        "intersect([0, 0], [10, 10], [10, 0], [0, 10])",
        "intersect([1, 0, 1],  [4, -2, 2], [1, 1, 1, 6])"
    ],
    seealso: []
};

});

parcelRegister("7xW65", function(module, exports) {

$parcel$export(module.exports, "distanceDocs", function () { return $57e8ae563cd068be$export$128b8878fdfb9e22; });
var $57e8ae563cd068be$export$128b8878fdfb9e22 = {
    name: "distance",
    category: "Geometry",
    syntax: [
        "distance([x1, y1], [x2, y2])",
        "distance([[x1, y1], [x2, y2]])"
    ],
    description: "Calculates the Euclidean distance between two points.",
    examples: [
        "distance([0,0], [4,4])",
        "distance([[0,0], [4,4]])"
    ],
    seealso: []
};

});

parcelRegister("dxQ9l", function(module, exports) {

$parcel$export(module.exports, "helpDocs", function () { return $9dc6cf47c38ac620$export$e55ca8c24fbd3be8; });
var $9dc6cf47c38ac620$export$e55ca8c24fbd3be8 = {
    name: "help",
    category: "Expression",
    syntax: [
        "help(object)",
        "help(string)"
    ],
    description: "Display documentation on a function or data type.",
    examples: [
        "help(sqrt)",
        'help("complex")'
    ],
    seealso: []
};

});

parcelRegister("fAyhW", function(module, exports) {

$parcel$export(module.exports, "evaluateDocs", function () { return $b594d0c29a67ef1a$export$f32c54c70ddd9931; });
var $b594d0c29a67ef1a$export$f32c54c70ddd9931 = {
    name: "evaluate",
    category: "Expression",
    syntax: [
        "evaluate(expression)",
        "evaluate([expr1, expr2, expr3, ...])"
    ],
    description: "Evaluate an expression or an array with expressions.",
    examples: [
        'evaluate("2 + 3")',
        'evaluate("sqrt(" + 4 + ")")'
    ],
    seealso: []
};

});

parcelRegister("2c5zB", function(module, exports) {

$parcel$export(module.exports, "imDocs", function () { return $1991067ad710dad4$export$3476e22b3f658c7c; });
var $1991067ad710dad4$export$3476e22b3f658c7c = {
    name: "im",
    category: "Complex",
    syntax: [
        "im(x)"
    ],
    description: "Get the imaginary part of a complex number.",
    examples: [
        "im(2 + 3i)",
        "re(2 + 3i)",
        "im(-5.2i)",
        "im(2.4)"
    ],
    seealso: [
        "re",
        "conj",
        "abs",
        "arg"
    ]
};

});

parcelRegister("dZ8st", function(module, exports) {

$parcel$export(module.exports, "reDocs", function () { return $a2e7887a0dba35a1$export$f13699bc77b8ea67; });
var $a2e7887a0dba35a1$export$f13699bc77b8ea67 = {
    name: "re",
    category: "Complex",
    syntax: [
        "re(x)"
    ],
    description: "Get the real part of a complex number.",
    examples: [
        "re(2 + 3i)",
        "im(2 + 3i)",
        "re(-5.2i)",
        "re(2.4)"
    ],
    seealso: [
        "im",
        "conj",
        "abs",
        "arg"
    ]
};

});

parcelRegister("6W62t", function(module, exports) {

$parcel$export(module.exports, "conjDocs", function () { return $50ccd8108b6e1c75$export$e042ae5cfa3c3343; });
var $50ccd8108b6e1c75$export$e042ae5cfa3c3343 = {
    name: "conj",
    category: "Complex",
    syntax: [
        "conj(x)"
    ],
    description: "Compute the complex conjugate of a complex value. If x = a+bi, the complex conjugate is a-bi.",
    examples: [
        "conj(2 + 3i)",
        "conj(2 - 3i)",
        "conj(-5.2i)"
    ],
    seealso: [
        "re",
        "im",
        "abs",
        "arg"
    ]
};

});

parcelRegister("80r5u", function(module, exports) {

$parcel$export(module.exports, "argDocs", function () { return $5d4355dae482fb23$export$eace15c6c3c286dc; });
var $5d4355dae482fb23$export$eace15c6c3c286dc = {
    name: "arg",
    category: "Complex",
    syntax: [
        "arg(x)"
    ],
    description: "Compute the argument of a complex value. If x = a+bi, the argument is computed as atan2(b, a).",
    examples: [
        "arg(2 + 2i)",
        "atan2(3, 2)",
        "arg(2 + 3i)"
    ],
    seealso: [
        "re",
        "im",
        "conj",
        "abs"
    ]
};

});

parcelRegister("bjbPq", function(module, exports) {

$parcel$export(module.exports, "typedDocs", function () { return $83baa4f45eb04fda$export$7adf399073101884; });
var $83baa4f45eb04fda$export$7adf399073101884 = {
    name: "typed",
    category: "Core",
    syntax: [
        "typed(signatures)",
        "typed(name, signatures)"
    ],
    description: "Create a typed function.",
    examples: [
        'double = typed({ "number, number": f(x)=x+x })',
        "double(2)",
        'double("hello")'
    ],
    seealso: []
};

});

parcelRegister("jrwph", function(module, exports) {

$parcel$export(module.exports, "importDocs", function () { return $e279ad3b9adcd2da$export$5989ac4b02cf8057; });
var $e279ad3b9adcd2da$export$5989ac4b02cf8057 = {
    name: "import",
    category: "Core",
    syntax: [
        "import(functions)",
        "import(functions, options)"
    ],
    description: "Import functions or constants from an object.",
    examples: [
        "import({myFn: f(x)=x^2, myConstant: 32 })",
        "myFn(2)",
        "myConstant"
    ],
    seealso: []
};

});

parcelRegister("7PMEC", function(module, exports) {

$parcel$export(module.exports, "configDocs", function () { return $5b430982606ef78f$export$ec99a334d8c9a14a; });
var $5b430982606ef78f$export$ec99a334d8c9a14a = {
    name: "config",
    category: "Core",
    syntax: [
        "config()",
        "config(options)"
    ],
    description: "Get configuration or change configuration.",
    examples: [
        "config()",
        "1/3 + 1/4",
        'config({number: "Fraction"})',
        "1/3 + 1/4"
    ],
    seealso: []
};

});

parcelRegister("1Is2D", function(module, exports) {

$parcel$export(module.exports, "stirlingS2Docs", function () { return $13ffa6f5cd85c302$export$46c34bdf03072170; });
var $13ffa6f5cd85c302$export$46c34bdf03072170 = {
    name: "stirlingS2",
    category: "Combinatorics",
    syntax: [
        "stirlingS2(n, k)"
    ],
    description: "he Stirling numbers of the second kind, counts the number of ways to partition a set of n labelled objects into k nonempty unlabelled subsets. `stirlingS2` only takes integer arguments. The following condition must be enforced: k <= n. If n = k or k = 1, then s(n,k) = 1.",
    examples: [
        "stirlingS2(5, 3)"
    ],
    seealso: [
        "bellNumbers"
    ]
};

});

parcelRegister("4mq0M", function(module, exports) {

$parcel$export(module.exports, "compositionDocs", function () { return $32cd64dc750f1ba3$export$7898728062a0cb7c; });
var $32cd64dc750f1ba3$export$7898728062a0cb7c = {
    name: "composition",
    category: "Combinatorics",
    syntax: [
        "composition(n, k)"
    ],
    description: "The composition counts of n into k parts. composition only takes integer arguments. The following condition must be enforced: k <= n.",
    examples: [
        "composition(5, 3)"
    ],
    seealso: [
        "combinations"
    ]
};

});

parcelRegister("8vAqe", function(module, exports) {

$parcel$export(module.exports, "catalanDocs", function () { return $631d78a4dcea72ca$export$b34ea8a080f60e3b; });
var $631d78a4dcea72ca$export$b34ea8a080f60e3b = {
    name: "catalan",
    category: "Combinatorics",
    syntax: [
        "catalan(n)"
    ],
    description: "The Catalan Numbers enumerate combinatorial structures of many different types. catalan only takes integer arguments. The following condition must be enforced: n >= 0.",
    examples: [
        "catalan(3)",
        "catalan(8)"
    ],
    seealso: [
        "bellNumbers"
    ]
};

});

parcelRegister("aoMft", function(module, exports) {

$parcel$export(module.exports, "bellNumbersDocs", function () { return $7921926ca30e650f$export$f6a5bb92e66e375e; });
var $7921926ca30e650f$export$f6a5bb92e66e375e = {
    name: "bellNumbers",
    category: "Combinatorics",
    syntax: [
        "bellNumbers(n)"
    ],
    description: "The Bell Numbers count the number of partitions of a set. A partition is a pairwise disjoint subset of S whose union is S. `bellNumbers` only takes integer arguments. The following condition must be enforced: n >= 0.",
    examples: [
        "bellNumbers(3)",
        "bellNumbers(8)"
    ],
    seealso: [
        "stirlingS2"
    ]
};

});

parcelRegister("bJGII", function(module, exports) {

$parcel$export(module.exports, "rightLogShiftDocs", function () { return $88b5090cc784337b$export$613695fe01bcb038; });
var $88b5090cc784337b$export$613695fe01bcb038 = {
    name: "rightLogShift",
    category: "Bitwise",
    syntax: [
        "x >>> y",
        "rightLogShift(x, y)"
    ],
    description: "Bitwise right logical shift of a value x by y number of bits.",
    examples: [
        "8 >>> 1",
        "4 << 1",
        "-12 >>> 2"
    ],
    seealso: [
        "bitAnd",
        "bitNot",
        "bitOr",
        "bitXor",
        "leftShift",
        "rightArithShift"
    ]
};

});

parcelRegister("5VeVS", function(module, exports) {

$parcel$export(module.exports, "rightArithShiftDocs", function () { return $44fddbecf4ac9daa$export$180767993e37a793; });
var $44fddbecf4ac9daa$export$180767993e37a793 = {
    name: "rightArithShift",
    category: "Bitwise",
    syntax: [
        "x >> y",
        "rightArithShift(x, y)"
    ],
    description: "Bitwise right arithmetic shift of a value x by y number of bits.",
    examples: [
        "8 >> 1",
        "4 << 1",
        "-12 >> 2"
    ],
    seealso: [
        "bitAnd",
        "bitNot",
        "bitOr",
        "bitXor",
        "leftShift",
        "rightLogShift"
    ]
};

});

parcelRegister("MtLIv", function(module, exports) {

$parcel$export(module.exports, "leftShiftDocs", function () { return $091b933d2bc5e202$export$fb75ebd54811e095; });
var $091b933d2bc5e202$export$fb75ebd54811e095 = {
    name: "leftShift",
    category: "Bitwise",
    syntax: [
        "x << y",
        "leftShift(x, y)"
    ],
    description: "Bitwise left logical shift of a value x by y number of bits.",
    examples: [
        "4 << 1",
        "8 >> 1"
    ],
    seealso: [
        "bitAnd",
        "bitNot",
        "bitOr",
        "bitXor",
        "rightArithShift",
        "rightLogShift"
    ]
};

});

parcelRegister("jJ2Hn", function(module, exports) {

$parcel$export(module.exports, "bitXorDocs", function () { return $e5c4502d7366b41d$export$c5717818ea6d1c80; });
var $e5c4502d7366b41d$export$c5717818ea6d1c80 = {
    name: "bitXor",
    category: "Bitwise",
    syntax: [
        "bitXor(x, y)"
    ],
    description: "Bitwise XOR operation, exclusive OR. Performs the logical exclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if only the first bit is 1 or only the second bit is 1, but will be 0 if both are 0 or both are 1.",
    examples: [
        "bitOr(1, 2)",
        "bitXor([2, 3, 4], 4)"
    ],
    seealso: [
        "bitAnd",
        "bitNot",
        "bitOr",
        "leftShift",
        "rightArithShift",
        "rightLogShift"
    ]
};

});

parcelRegister("aK9ta", function(module, exports) {

$parcel$export(module.exports, "bitOrDocs", function () { return $7d258baf12b66f30$export$dc934370739527a8; });
var $7d258baf12b66f30$export$dc934370739527a8 = {
    name: "bitOr",
    category: "Bitwise",
    syntax: [
        "x | y",
        "bitOr(x, y)"
    ],
    description: "Bitwise OR operation. Performs the logical inclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if the first bit is 1 or the second bit is 1 or both bits are 1, otherwise, the result is 0.",
    examples: [
        "5 | 3",
        "bitOr([1, 2, 3], 4)"
    ],
    seealso: [
        "bitAnd",
        "bitNot",
        "bitXor",
        "leftShift",
        "rightArithShift",
        "rightLogShift"
    ]
};

});

parcelRegister("kTOSY", function(module, exports) {

$parcel$export(module.exports, "bitNotDocs", function () { return $f3706a8d4fd452c1$export$3d49fbbfcb05eb36; });
var $f3706a8d4fd452c1$export$3d49fbbfcb05eb36 = {
    name: "bitNot",
    category: "Bitwise",
    syntax: [
        "~x",
        "bitNot(x)"
    ],
    description: "Bitwise NOT operation. Performs a logical negation on each bit of the given value. Bits that are 0 become 1, and those that are 1 become 0.",
    examples: [
        "~1",
        "~2",
        "bitNot([2, -3, 4])"
    ],
    seealso: [
        "bitAnd",
        "bitOr",
        "bitXor",
        "leftShift",
        "rightArithShift",
        "rightLogShift"
    ]
};

});

parcelRegister("5Bnil", function(module, exports) {

$parcel$export(module.exports, "bitAndDocs", function () { return $41427a50c9a874a2$export$9809e2502d5f7c7c; });
var $41427a50c9a874a2$export$9809e2502d5f7c7c = {
    name: "bitAnd",
    category: "Bitwise",
    syntax: [
        "x & y",
        "bitAnd(x, y)"
    ],
    description: "Bitwise AND operation. Performs the logical AND operation on each pair of the corresponding bits of the two given values by multiplying them. If both bits in the compared position are 1, the bit in the resulting binary representation is 1, otherwise, the result is 0",
    examples: [
        "5 & 3",
        "bitAnd(53, 131)",
        "[1, 12, 31] & 42"
    ],
    seealso: [
        "bitNot",
        "bitOr",
        "bitXor",
        "leftShift",
        "rightArithShift",
        "rightLogShift"
    ]
};

});

parcelRegister("hFxzz", function(module, exports) {

$parcel$export(module.exports, "xgcdDocs", function () { return $cdd04ed487ae20e2$export$82911c1a1d0407b8; });
var $cdd04ed487ae20e2$export$82911c1a1d0407b8 = {
    name: "xgcd",
    category: "Arithmetic",
    syntax: [
        "xgcd(a, b)"
    ],
    description: "Calculate the extended greatest common divisor for two values. The result is an array [d, x, y] with 3 entries, where d is the greatest common divisor, and d = x * a + y * b.",
    examples: [
        "xgcd(8, 12)",
        "gcd(8, 12)",
        "xgcd(36163, 21199)"
    ],
    seealso: [
        "gcd",
        "lcm"
    ]
};

});

parcelRegister("aCwWZ", function(module, exports) {

$parcel$export(module.exports, "unaryPlusDocs", function () { return $7bb703432fb21b53$export$e50639526da1c8e2; });
var $7bb703432fb21b53$export$e50639526da1c8e2 = {
    name: "unaryPlus",
    category: "Operators",
    syntax: [
        "+x",
        "unaryPlus(x)"
    ],
    description: "Converts booleans and strings to numbers.",
    examples: [
        "+true",
        '+"2"'
    ],
    seealso: [
        "add",
        "subtract",
        "unaryMinus"
    ]
};

});

parcelRegister("4xJia", function(module, exports) {

$parcel$export(module.exports, "unaryMinusDocs", function () { return $34ed608c68164f72$export$4d94f3f25dc2600b; });
var $34ed608c68164f72$export$4d94f3f25dc2600b = {
    name: "unaryMinus",
    category: "Operators",
    syntax: [
        "-x",
        "unaryMinus(x)"
    ],
    description: "Inverse the sign of a value. Converts booleans and strings to numbers.",
    examples: [
        "-4.5",
        "-(-5.6)",
        '-"22"'
    ],
    seealso: [
        "add",
        "subtract",
        "unaryPlus"
    ]
};

});

parcelRegister("guRgs", function(module, exports) {

$parcel$export(module.exports, "squareDocs", function () { return $c028c3df95a5529a$export$8aa8fe580e40693e; });
var $c028c3df95a5529a$export$8aa8fe580e40693e = {
    name: "square",
    category: "Arithmetic",
    syntax: [
        "square(x)"
    ],
    description: "Compute the square of a value. The square of x is x * x.",
    examples: [
        "square(3)",
        "sqrt(9)",
        "3^2",
        "3 * 3"
    ],
    seealso: [
        "multiply",
        "pow",
        "sqrt",
        "cube"
    ]
};

});

parcelRegister("3FZHK", function(module, exports) {

$parcel$export(module.exports, "sqrtmDocs", function () { return $2ad510b263f2ea25$export$f470c8ca9def7f14; });
var $2ad510b263f2ea25$export$f470c8ca9def7f14 = {
    name: "sqrtm",
    category: "Arithmetic",
    syntax: [
        "sqrtm(x)"
    ],
    description: "Calculate the principal square root of a square matrix. The principal square root matrix `X` of another matrix `A` is such that `X * X = A`.",
    examples: [
        "sqrtm([[1, 2], [3, 4]])"
    ],
    seealso: [
        "sqrt",
        "abs",
        "square",
        "multiply"
    ]
};

});

parcelRegister("eQI16", function(module, exports) {

$parcel$export(module.exports, "sqrtDocs", function () { return $acf810d30a567e88$export$4c6bee88dcda7f24; });
var $acf810d30a567e88$export$4c6bee88dcda7f24 = {
    name: "sqrt",
    category: "Arithmetic",
    syntax: [
        "sqrt(x)"
    ],
    description: "Compute the square root value. If x = y * y, then y is the square root of x.",
    examples: [
        "sqrt(25)",
        "5 * 5",
        "sqrt(-1)"
    ],
    seealso: [
        "square",
        "sqrtm",
        "multiply",
        "nthRoot",
        "nthRoots",
        "pow"
    ]
};

});

parcelRegister("2SqMq", function(module, exports) {

$parcel$export(module.exports, "signDocs", function () { return $218565de96883167$export$4190acef139a44f2; });
var $218565de96883167$export$4190acef139a44f2 = {
    name: "sign",
    category: "Arithmetic",
    syntax: [
        "sign(x)"
    ],
    description: "Compute the sign of a value. The sign of a value x is 1 when x>1, -1 when x<0, and 0 when x=0.",
    examples: [
        "sign(3.5)",
        "sign(-4.2)",
        "sign(0)"
    ],
    seealso: [
        "abs"
    ]
};

});

parcelRegister("lANzd", function(module, exports) {

$parcel$export(module.exports, "roundDocs", function () { return $fb8368b8744037f0$export$aaef6018d3e651c3; });
var $fb8368b8744037f0$export$aaef6018d3e651c3 = {
    name: "round",
    category: "Arithmetic",
    syntax: [
        "round(x)",
        "round(x, n)"
    ],
    description: "round a value towards the nearest integer.If x is complex, both real and imaginary part are rounded towards the nearest integer. When n is specified, the value is rounded to n decimals.",
    examples: [
        "round(3.2)",
        "round(3.8)",
        "round(-4.2)",
        "round(-4.8)",
        "round(pi, 3)",
        "round(123.45678, 2)"
    ],
    seealso: [
        "ceil",
        "floor",
        "fix"
    ]
};

});

parcelRegister("ebxdO", function(module, exports) {

$parcel$export(module.exports, "powDocs", function () { return $a53bdce6ac5189a4$export$2d9619da64c2bdd4; });
var $a53bdce6ac5189a4$export$2d9619da64c2bdd4 = {
    name: "pow",
    category: "Operators",
    syntax: [
        "x ^ y",
        "pow(x, y)"
    ],
    description: "Calculates the power of x to y, x^y.",
    examples: [
        "2^3",
        "2*2*2",
        "1 + e ^ (pi * i)"
    ],
    seealso: [
        "multiply",
        "nthRoot",
        "nthRoots",
        "sqrt"
    ]
};

});

parcelRegister("5myNz", function(module, exports) {

$parcel$export(module.exports, "nthRootsDocs", function () { return $3e7a0018a673d444$export$3d5c8967f6152f8f; });
var $3e7a0018a673d444$export$3d5c8967f6152f8f = {
    name: "nthRoots",
    category: "Arithmetic",
    syntax: [
        "nthRoots(A)",
        "nthRoots(A, root)"
    ],
    description: 'Calculate the nth roots of a value. An nth root of a positive real number A, is a positive real solution of the equation "x^root = A". This function returns an array of complex values.',
    examples: [
        "nthRoots(1)",
        "nthRoots(1, 3)"
    ],
    seealso: [
        "sqrt",
        "pow",
        "nthRoot"
    ]
};

});

parcelRegister("gVdRU", function(module, exports) {

$parcel$export(module.exports, "nthRootDocs", function () { return $c51cba2efcb53677$export$6eeb5046d44da601; });
var $c51cba2efcb53677$export$6eeb5046d44da601 = {
    name: "nthRoot",
    category: "Arithmetic",
    syntax: [
        "nthRoot(a)",
        "nthRoot(a, root)"
    ],
    description: 'Calculate the nth root of a value. The principal nth root of a positive real number A, is the positive real solution of the equation "x^root = A".',
    examples: [
        "4 ^ 3",
        "nthRoot(64, 3)",
        "nthRoot(9, 2)",
        "sqrt(9)"
    ],
    seealso: [
        "nthRoots",
        "pow",
        "sqrt"
    ]
};

});

parcelRegister("j7uge", function(module, exports) {

$parcel$export(module.exports, "normDocs", function () { return $deb624e82d66d563$export$9745ccea7c23999; });
var $deb624e82d66d563$export$9745ccea7c23999 = {
    name: "norm",
    category: "Arithmetic",
    syntax: [
        "norm(x)",
        "norm(x, p)"
    ],
    description: "Calculate the norm of a number, vector or matrix.",
    examples: [
        "abs(-3.5)",
        "norm(-3.5)",
        "norm(3 - 4i)",
        "norm([1, 2, -3], Infinity)",
        "norm([1, 2, -3], -Infinity)",
        "norm([3, 4], 2)",
        "norm([[1, 2], [3, 4]], 1)",
        'norm([[1, 2], [3, 4]], "inf")',
        'norm([[1, 2], [3, 4]], "fro")'
    ]
};

});

parcelRegister("8UIvy", function(module, exports) {

$parcel$export(module.exports, "multiplyDocs", function () { return $67d6140678c5ec9a$export$1506e47b2a5ae6da; });
var $67d6140678c5ec9a$export$1506e47b2a5ae6da = {
    name: "multiply",
    category: "Operators",
    syntax: [
        "x * y",
        "multiply(x, y)"
    ],
    description: "multiply two values.",
    examples: [
        "a = 2.1 * 3.4",
        "a / 3.4",
        "2 * 3 + 4",
        "2 * (3 + 4)",
        "3 * 2.1 km"
    ],
    seealso: [
        "divide"
    ]
};

});

parcelRegister("i3zPi", function(module, exports) {

$parcel$export(module.exports, "modDocs", function () { return $d2544c2d1e24fea3$export$f9c7d95d1ec52e50; });
var $d2544c2d1e24fea3$export$f9c7d95d1ec52e50 = {
    name: "mod",
    category: "Operators",
    syntax: [
        "x % y",
        "x mod y",
        "mod(x, y)"
    ],
    description: "Calculates the modulus, the remainder of an integer division.",
    examples: [
        "7 % 3",
        "11 % 2",
        "10 mod 4",
        "isOdd(x) = x % 2",
        "isOdd(2)",
        "isOdd(3)"
    ],
    seealso: [
        "divide"
    ]
};

});

parcelRegister("9VyOB", function(module, exports) {

$parcel$export(module.exports, "log10Docs", function () { return $73a47183aac0bd23$export$a4c310b6d4346035; });
var $73a47183aac0bd23$export$a4c310b6d4346035 = {
    name: "log10",
    category: "Arithmetic",
    syntax: [
        "log10(x)"
    ],
    description: "Compute the 10-base logarithm of a value.",
    examples: [
        "log10(0.00001)",
        "log10(10000)",
        "10 ^ 4",
        "log(10000) / log(10)",
        "log(10000, 10)"
    ],
    seealso: [
        "exp",
        "log"
    ]
};

});

parcelRegister("1VKaL", function(module, exports) {

$parcel$export(module.exports, "log1pDocs", function () { return $167eee3efe9e6354$export$5739f5d11cd187ac; });
var $167eee3efe9e6354$export$5739f5d11cd187ac = {
    name: "log1p",
    category: "Arithmetic",
    syntax: [
        "log1p(x)",
        "log1p(x, base)"
    ],
    description: "Calculate the logarithm of a `value+1`",
    examples: [
        "log1p(2.5)",
        "exp(log1p(1.4))",
        "pow(10, 4)",
        "log1p(9999, 10)",
        "log1p(9999) / log(10)"
    ],
    seealso: [
        "exp",
        "log",
        "log2",
        "log10"
    ]
};

});

parcelRegister("k0oGZ", function(module, exports) {

$parcel$export(module.exports, "log2Docs", function () { return $e906f61d98080d1b$export$fa36f06e6e8bfb36; });
var $e906f61d98080d1b$export$fa36f06e6e8bfb36 = {
    name: "log2",
    category: "Arithmetic",
    syntax: [
        "log2(x)"
    ],
    description: "Calculate the 2-base of a value. This is the same as calculating `log(x, 2)`.",
    examples: [
        "log2(0.03125)",
        "log2(16)",
        "log2(16) / log2(2)",
        "pow(2, 4)"
    ],
    seealso: [
        "exp",
        "log1p",
        "log",
        "log10"
    ]
};

});

parcelRegister("hfhXI", function(module, exports) {

$parcel$export(module.exports, "logDocs", function () { return $c8e1c54ef111b463$export$10fa3fadd260900f; });
var $c8e1c54ef111b463$export$10fa3fadd260900f = {
    name: "log",
    category: "Arithmetic",
    syntax: [
        "log(x)",
        "log(x, base)"
    ],
    description: "Compute the logarithm of a value. If no base is provided, the natural logarithm of x is calculated. If base if provided, the logarithm is calculated for the specified base. log(x, base) is defined as log(x) / log(base).",
    examples: [
        "log(3.5)",
        "a = log(2.4)",
        "exp(a)",
        "10 ^ 4",
        "log(10000, 10)",
        "log(10000) / log(10)",
        "b = log(1024, 2)",
        "2 ^ b"
    ],
    seealso: [
        "exp",
        "log1p",
        "log2",
        "log10"
    ]
};

});

parcelRegister("9tjy2", function(module, exports) {

$parcel$export(module.exports, "lcmDocs", function () { return $6e55fc4cb92ae924$export$371d4953326569cb; });
var $6e55fc4cb92ae924$export$371d4953326569cb = {
    name: "lcm",
    category: "Arithmetic",
    syntax: [
        "lcm(x, y)"
    ],
    description: "Compute the least common multiple.",
    examples: [
        "lcm(4, 6)",
        "lcm(6, 21)",
        "lcm(6, 21, 5)"
    ],
    seealso: [
        "gcd"
    ]
};

});

parcelRegister("2CUEz", function(module, exports) {

$parcel$export(module.exports, "hypotDocs", function () { return $1e9b138ef54cab21$export$53821d38c3eeff69; });
var $1e9b138ef54cab21$export$53821d38c3eeff69 = {
    name: "hypot",
    category: "Arithmetic",
    syntax: [
        "hypot(a, b, c, ...)",
        "hypot([a, b, c, ...])"
    ],
    description: "Calculate the hypotenusa of a list with values. ",
    examples: [
        "hypot(3, 4)",
        "sqrt(3^2 + 4^2)",
        "hypot(-2)",
        "hypot([3, 4, 5])"
    ],
    seealso: [
        "abs",
        "norm"
    ]
};

});

parcelRegister("eKbt8", function(module, exports) {

$parcel$export(module.exports, "gcdDocs", function () { return $abbe420d10436eb5$export$ccc9190f6201c21e; });
var $abbe420d10436eb5$export$ccc9190f6201c21e = {
    name: "gcd",
    category: "Arithmetic",
    syntax: [
        "gcd(a, b)",
        "gcd(a, b, c, ...)"
    ],
    description: "Compute the greatest common divisor.",
    examples: [
        "gcd(8, 12)",
        "gcd(-4, 6)",
        "gcd(25, 15, -10)"
    ],
    seealso: [
        "lcm",
        "xgcd"
    ]
};

});

parcelRegister("1nuwR", function(module, exports) {

$parcel$export(module.exports, "floorDocs", function () { return $100f9edb3505e502$export$7eb1ac5a6cfbe8b6; });
var $100f9edb3505e502$export$7eb1ac5a6cfbe8b6 = {
    name: "floor",
    category: "Arithmetic",
    syntax: [
        "floor(x)"
    ],
    description: "Round a value towards minus infinity.If x is complex, both real and imaginary part are rounded towards minus infinity.",
    examples: [
        "floor(3.2)",
        "floor(3.8)",
        "floor(-4.2)"
    ],
    seealso: [
        "ceil",
        "fix",
        "round"
    ]
};

});

parcelRegister("aPSFs", function(module, exports) {

$parcel$export(module.exports, "fixDocs", function () { return $7e3912a7c5a1d693$export$ec1a27fd93212099; });
var $7e3912a7c5a1d693$export$ec1a27fd93212099 = {
    name: "fix",
    category: "Arithmetic",
    syntax: [
        "fix(x)"
    ],
    description: "Round a value towards zero. If x is complex, both real and imaginary part are rounded towards zero.",
    examples: [
        "fix(3.2)",
        "fix(3.8)",
        "fix(-4.2)",
        "fix(-4.8)"
    ],
    seealso: [
        "ceil",
        "floor",
        "round"
    ]
};

});

parcelRegister("aucjV", function(module, exports) {

$parcel$export(module.exports, "expm1Docs", function () { return $7a26434cba3fcb43$export$d6fb67f466ac866c; });
var $7a26434cba3fcb43$export$d6fb67f466ac866c = {
    name: "expm1",
    category: "Arithmetic",
    syntax: [
        "expm1(x)"
    ],
    description: "Calculate the value of subtracting 1 from the exponential value.",
    examples: [
        "expm1(2)",
        "pow(e, 2) - 1",
        "log(expm1(2) + 1)"
    ],
    seealso: [
        "exp",
        "pow",
        "log"
    ]
};

});

parcelRegister("6kdGd", function(module, exports) {

$parcel$export(module.exports, "expmDocs", function () { return $49af38df9e409545$export$df3b4f2159ca23f5; });
var $49af38df9e409545$export$df3b4f2159ca23f5 = {
    name: "expm",
    category: "Arithmetic",
    syntax: [
        "exp(x)"
    ],
    description: "Compute the matrix exponential, expm(A) = e^A. The matrix must be square. Not to be confused with exp(a), which performs element-wise exponentiation.",
    examples: [
        "expm([[0,2],[0,0]])"
    ],
    seealso: [
        "exp"
    ]
};

});

parcelRegister("fiOXs", function(module, exports) {

$parcel$export(module.exports, "eigsDocs", function () { return $b24010ab6851d734$export$fb74125542bfdbb; });
var $b24010ab6851d734$export$fb74125542bfdbb = {
    name: "eigs",
    category: "Matrix",
    syntax: [
        "eigs(x)"
    ],
    description: "Calculate the eigenvalues and eigenvectors of a real symmetric matrix",
    examples: [
        "eigs([[5, 2.3], [2.3, 1]])"
    ],
    seealso: [
        "inv"
    ]
};

});

parcelRegister("66pcK", function(module, exports) {

$parcel$export(module.exports, "expDocs", function () { return $4716dabae5f31be3$export$e855e42434736fab; });
var $4716dabae5f31be3$export$e855e42434736fab = {
    name: "exp",
    category: "Arithmetic",
    syntax: [
        "exp(x)"
    ],
    description: "Calculate the exponent of a value.",
    examples: [
        "exp(1.3)",
        "e ^ 1.3",
        "log(exp(1.3))",
        "x = 2.4",
        "(exp(i*x) == cos(x) + i*sin(x))   # Euler's formula"
    ],
    seealso: [
        "expm",
        "expm1",
        "pow",
        "log"
    ]
};

});

parcelRegister("hHuRe", function(module, exports) {

$parcel$export(module.exports, "dotMultiplyDocs", function () { return $ce2e63846685e5fb$export$4e72f4c646ece24a; });
var $ce2e63846685e5fb$export$4e72f4c646ece24a = {
    name: "dotMultiply",
    category: "Operators",
    syntax: [
        "x .* y",
        "dotMultiply(x, y)"
    ],
    description: "Multiply two values element wise.",
    examples: [
        "a = [1, 2, 3; 4, 5, 6]",
        "b = [2, 1, 1; 3, 2, 5]",
        "a .* b"
    ],
    seealso: [
        "multiply",
        "divide",
        "dotDivide"
    ]
};

});

parcelRegister("7qL1g", function(module, exports) {

$parcel$export(module.exports, "dotDivideDocs", function () { return $568f6f31e889f2d3$export$f1a6e1f6a311adf8; });
var $568f6f31e889f2d3$export$f1a6e1f6a311adf8 = {
    name: "dotDivide",
    category: "Operators",
    syntax: [
        "x ./ y",
        "dotDivide(x, y)"
    ],
    description: "Divide two values element wise.",
    examples: [
        "a = [1, 2, 3; 4, 5, 6]",
        "b = [2, 1, 1; 3, 2, 5]",
        "a ./ b"
    ],
    seealso: [
        "multiply",
        "dotMultiply",
        "divide"
    ]
};

});

parcelRegister("3pLqw", function(module, exports) {

$parcel$export(module.exports, "divideDocs", function () { return $27c87edba6ef701b$export$e4cc3c6ddad47fb; });
var $27c87edba6ef701b$export$e4cc3c6ddad47fb = {
    name: "divide",
    category: "Operators",
    syntax: [
        "x / y",
        "divide(x, y)"
    ],
    description: "Divide two values.",
    examples: [
        "a = 2 / 3",
        "a * 3",
        "4.5 / 2",
        "3 + 4 / 2",
        "(3 + 4) / 2",
        "18 km / 4.5"
    ],
    seealso: [
        "multiply"
    ]
};

});

parcelRegister("7X0mg", function(module, exports) {

$parcel$export(module.exports, "cubeDocs", function () { return $5c9e523246ca31d6$export$ceabaa40b420fd2f; });
var $5c9e523246ca31d6$export$ceabaa40b420fd2f = {
    name: "cube",
    category: "Arithmetic",
    syntax: [
        "cube(x)"
    ],
    description: "Compute the cube of a value. The cube of x is x * x * x.",
    examples: [
        "cube(2)",
        "2^3",
        "2 * 2 * 2"
    ],
    seealso: [
        "multiply",
        "square",
        "pow"
    ]
};

});

parcelRegister("9V40U", function(module, exports) {

$parcel$export(module.exports, "ceilDocs", function () { return $738c8cef677f87bc$export$bf625dbce78edf39; });
var $738c8cef677f87bc$export$bf625dbce78edf39 = {
    name: "ceil",
    category: "Arithmetic",
    syntax: [
        "ceil(x)"
    ],
    description: "Round a value towards plus infinity. If x is complex, both real and imaginary part are rounded towards plus infinity.",
    examples: [
        "ceil(3.2)",
        "ceil(3.8)",
        "ceil(-4.2)"
    ],
    seealso: [
        "floor",
        "fix",
        "round"
    ]
};

});

parcelRegister("bp2rB", function(module, exports) {

$parcel$export(module.exports, "cbrtDocs", function () { return $84d3ece16ca4e0ad$export$9330e90a8e7851e6; });
var $84d3ece16ca4e0ad$export$9330e90a8e7851e6 = {
    name: "cbrt",
    category: "Arithmetic",
    syntax: [
        "cbrt(x)",
        "cbrt(x, allRoots)"
    ],
    description: "Compute the cubic root value. If x = y * y * y, then y is the cubic root of x. When `x` is a number or complex number, an optional second argument `allRoots` can be provided to return all three cubic roots. If not provided, the principal root is returned",
    examples: [
        "cbrt(64)",
        "cube(4)",
        "cbrt(-8)",
        "cbrt(2 + 3i)",
        "cbrt(8i)",
        "cbrt(8i, true)",
        "cbrt(27 m^3)"
    ],
    seealso: [
        "square",
        "sqrt",
        "cube",
        "multiply"
    ]
};

});

parcelRegister("ev3N4", function(module, exports) {

$parcel$export(module.exports, "addDocs", function () { return $a8e6e6a8a2decff7$export$6fe0cea5d5e6ddba; });
var $a8e6e6a8a2decff7$export$6fe0cea5d5e6ddba = {
    name: "add",
    category: "Operators",
    syntax: [
        "x + y",
        "add(x, y)"
    ],
    description: "Add two values.",
    examples: [
        "a = 2.1 + 3.6",
        "a - 3.6",
        "3 + 2i",
        "3 cm + 2 inch",
        '"2.3" + "4"'
    ],
    seealso: [
        "subtract"
    ]
};

});

parcelRegister("9JtUj", function(module, exports) {

$parcel$export(module.exports, "absDocs", function () { return $715f83fe2fcc0791$export$d21ec9cf3daa768b; });
var $715f83fe2fcc0791$export$d21ec9cf3daa768b = {
    name: "abs",
    category: "Arithmetic",
    syntax: [
        "abs(x)"
    ],
    description: "Compute the absolute value.",
    examples: [
        "abs(3.5)",
        "abs(-4.2)"
    ],
    seealso: [
        "sign"
    ]
};

});

parcelRegister("6cUvE", function(module, exports) {

$parcel$export(module.exports, "qrDocs", function () { return $484fb2a978ba97b2$export$717c61ebe37cce2a; });
var $484fb2a978ba97b2$export$717c61ebe37cce2a = {
    name: "qr",
    category: "Algebra",
    syntax: [
        "qr(A)"
    ],
    description: "Calculates the Matrix QR decomposition. Matrix `A` is decomposed in two matrices (`Q`, `R`) where `Q` is an orthogonal matrix and `R` is an upper triangular matrix.",
    examples: [
        "qr([[1, -1,  4], [1,  4, -2], [1,  4,  2], [1,  -1, 0]])"
    ],
    seealso: [
        "lup",
        "slu",
        "matrix"
    ]
};

});

parcelRegister("hBK1o", function(module, exports) {

$parcel$export(module.exports, "usolveDocs", function () { return $cd19974243fb828c$export$2e45391f5cc49d1d; });
var $cd19974243fb828c$export$2e45391f5cc49d1d = {
    name: "usolve",
    category: "Algebra",
    syntax: [
        "x=usolve(U, b)"
    ],
    description: "Solves the linear system U * x = b where U is an [n x n] upper triangular matrix and b is a [n] column vector.",
    examples: [
        "x=usolve(sparse([1, 1, 1, 1; 0, 1, 1, 1; 0, 0, 1, 1; 0, 0, 0, 1]), [1; 2; 3; 4])"
    ],
    seealso: [
        "lup",
        "lusolve",
        "lsolve",
        "matrix",
        "sparse"
    ]
};

});

parcelRegister("6CCvg", function(module, exports) {

$parcel$export(module.exports, "sluDocs", function () { return $4d24289f3a973ff0$export$a68dbefd846d8955; });
var $4d24289f3a973ff0$export$a68dbefd846d8955 = {
    name: "slu",
    category: "Algebra",
    syntax: [
        "slu(A, order, threshold)"
    ],
    description: "Calculate the Matrix LU decomposition with full pivoting. Matrix A is decomposed in two matrices (L, U) and two permutation vectors (pinv, q) where P * A * Q = L * U",
    examples: [
        "slu(sparse([4.5, 0, 3.2, 0; 3.1, 2.9, 0, 0.9; 0, 1.7, 3, 0; 3.5, 0.4, 0, 1]), 1, 0.001)"
    ],
    seealso: [
        "lusolve",
        "lsolve",
        "usolve",
        "matrix",
        "sparse",
        "lup",
        "qr"
    ]
};

});

parcelRegister("34utO", function(module, exports) {

$parcel$export(module.exports, "rationalizeDocs", function () { return $23c9637aa4fdc86d$export$1802f015e36a313; });
var $23c9637aa4fdc86d$export$1802f015e36a313 = {
    name: "rationalize",
    category: "Algebra",
    syntax: [
        "rationalize(expr)",
        "rationalize(expr, scope)",
        "rationalize(expr, scope, detailed)"
    ],
    description: "Transform a rationalizable expression in a rational fraction. If rational fraction is one variable polynomial then converts the numerator and denominator in canonical form, with decreasing exponents, returning the coefficients of numerator.",
    examples: [
        'rationalize("2x/y - y/(x+1)")',
        'rationalize("2x/y - y/(x+1)", true)'
    ],
    seealso: [
        "simplify"
    ]
};

});

parcelRegister("4H26S", function(module, exports) {

$parcel$export(module.exports, "simplifyDocs", function () { return $36acd08b8c11be15$export$5a53589a8ff0d1cd; });
var $36acd08b8c11be15$export$5a53589a8ff0d1cd = {
    name: "simplify",
    category: "Algebra",
    syntax: [
        "simplify(expr)",
        "simplify(expr, rules)"
    ],
    description: "Simplify an expression tree.",
    examples: [
        'simplify("3 + 2 / 4")',
        'simplify("2x + x")',
        'f = parse("x * (x + 2 + x)")',
        "simplified = simplify(f)",
        "simplified.evaluate({x: 2})"
    ],
    seealso: [
        "derivative",
        "parse",
        "evaluate"
    ]
};

});

parcelRegister("gR5wf", function(module, exports) {

$parcel$export(module.exports, "lupDocs", function () { return $c455e09615c06042$export$aa45954995260db7; });
var $c455e09615c06042$export$aa45954995260db7 = {
    name: "lup",
    category: "Algebra",
    syntax: [
        "lup(m)"
    ],
    description: "Calculate the Matrix LU decomposition with partial pivoting. Matrix A is decomposed in three matrices (L, U, P) where P * A = L * U",
    examples: [
        "lup([[2, 1], [1, 4]])",
        "lup(matrix([[2, 1], [1, 4]]))",
        "lup(sparse([[2, 1], [1, 4]]))"
    ],
    seealso: [
        "lusolve",
        "lsolve",
        "usolve",
        "matrix",
        "sparse",
        "slu",
        "qr"
    ]
};

});

parcelRegister("bj0Pn", function(module, exports) {

$parcel$export(module.exports, "lsolveDocs", function () { return $83b21c68b9ad0316$export$4bef5c6fa8c1f081; });
var $83b21c68b9ad0316$export$4bef5c6fa8c1f081 = {
    name: "lsolve",
    category: "Algebra",
    syntax: [
        "x=lsolve(L, b)"
    ],
    description: "Solves the linear system L * x = b where L is an [n x n] lower triangular matrix and b is a [n] column vector.",
    examples: [
        "a = [-2, 3; 2, 1]",
        "b = [11, 9]",
        "x = lsolve(a, b)"
    ],
    seealso: [
        "lup",
        "lusolve",
        "usolve",
        "matrix",
        "sparse"
    ]
};

});

parcelRegister("4FuGC", function(module, exports) {

$parcel$export(module.exports, "derivativeDocs", function () { return $3662cb6be7ebd538$export$14d93412c4f1ed0d; });
var $3662cb6be7ebd538$export$14d93412c4f1ed0d = {
    name: "derivative",
    category: "Algebra",
    syntax: [
        "derivative(expr, variable)",
        "derivative(expr, variable, {simplify: boolean})"
    ],
    description: "Takes the derivative of an expression expressed in parser Nodes. The derivative will be taken over the supplied variable in the second parameter. If there are multiple variables in the expression, it will return a partial derivative.",
    examples: [
        'derivative("2x^3", "x")',
        'derivative("2x^3", "x", {simplify: false})',
        'derivative("2x^2 + 3x + 4", "x")',
        'derivative("sin(2x)", "x")',
        'f = parse("x^2 + x")',
        'x = parse("x")',
        "df = derivative(f, x)",
        "df.evaluate({x: 3})"
    ],
    seealso: [
        "simplify",
        "parse",
        "evaluate"
    ]
};

});

parcelRegister("kRHRd", function(module, exports) {

$parcel$export(module.exports, "versionDocs", function () { return $f30ac705401f7288$export$c94cc7868097f914; });
var $f30ac705401f7288$export$c94cc7868097f914 = {
    name: "version",
    category: "Constants",
    syntax: [
        "version"
    ],
    description: "A string with the version number of math.js",
    examples: [
        "version"
    ],
    seealso: []
};

});

parcelRegister("kyiN3", function(module, exports) {

$parcel$export(module.exports, "trueDocs", function () { return $ef658ef5948418d0$export$f6ccf6a3f013127d; });
var $ef658ef5948418d0$export$f6ccf6a3f013127d = {
    name: "true",
    category: "Constants",
    syntax: [
        "true"
    ],
    description: "Boolean value true",
    examples: [
        "true"
    ],
    seealso: [
        "false"
    ]
};

});

parcelRegister("h1Xj3", function(module, exports) {

$parcel$export(module.exports, "tauDocs", function () { return $c66088a864bbd5ae$export$aee6f1e4bf7402c8; });
var $c66088a864bbd5ae$export$aee6f1e4bf7402c8 = {
    name: "tau",
    category: "Constants",
    syntax: [
        "tau"
    ],
    description: "Tau is the ratio constant of a circle's circumference to radius, equal to 2 * pi, approximately 6.2832.",
    examples: [
        "tau",
        "2 * pi"
    ],
    seealso: [
        "pi"
    ]
};

});

parcelRegister("ct3Ip", function(module, exports) {

$parcel$export(module.exports, "SQRT2Docs", function () { return $913b133fe3f20813$export$ce0e8257aab3e4ae; });
var $913b133fe3f20813$export$ce0e8257aab3e4ae = {
    name: "SQRT2",
    category: "Constants",
    syntax: [
        "SQRT2"
    ],
    description: "Returns the square root of 2, approximately equal to 1.414",
    examples: [
        "SQRT2",
        "sqrt(2)"
    ],
    seealso: []
};

});

parcelRegister("4wx44", function(module, exports) {

$parcel$export(module.exports, "SQRT12Docs", function () { return $34b3cc8a0e635d1a$export$6838d33506c2b5d0; });
var $34b3cc8a0e635d1a$export$6838d33506c2b5d0 = {
    name: "SQRT1_2",
    category: "Constants",
    syntax: [
        "SQRT1_2"
    ],
    description: "Returns the square root of 1/2, approximately equal to 0.707",
    examples: [
        "SQRT1_2",
        "sqrt(1/2)"
    ],
    seealso: []
};

});

parcelRegister("lYjVz", function(module, exports) {

$parcel$export(module.exports, "phiDocs", function () { return $ffeea8bf52083b13$export$f4e037238b5533c1; });
var $ffeea8bf52083b13$export$f4e037238b5533c1 = {
    name: "phi",
    category: "Constants",
    syntax: [
        "phi"
    ],
    description: "Phi is the golden ratio. Two quantities are in the golden ratio if their ratio is the same as the ratio of their sum to the larger of the two quantities. Phi is defined as `(1 + sqrt(5)) / 2` and is approximately 1.618034...",
    examples: [
        "phi"
    ],
    seealso: []
};

});

parcelRegister("cTzze", function(module, exports) {

$parcel$export(module.exports, "piDocs", function () { return $96363600231be565$export$acdd1b7b7d3e5e4e; });
var $96363600231be565$export$acdd1b7b7d3e5e4e = {
    name: "pi",
    category: "Constants",
    syntax: [
        "pi"
    ],
    description: "The number pi is a mathematical constant that is the ratio of a circle's circumference to its diameter, and is approximately equal to 3.14159",
    examples: [
        "pi",
        "sin(pi/2)"
    ],
    seealso: [
        "tau"
    ]
};

});

parcelRegister("63VU1", function(module, exports) {

$parcel$export(module.exports, "nullDocs", function () { return $469ff01eaed76ba5$export$a805f16f075f20cb; });
var $469ff01eaed76ba5$export$a805f16f075f20cb = {
    name: "null",
    category: "Constants",
    syntax: [
        "null"
    ],
    description: "Value null",
    examples: [
        "null"
    ],
    seealso: [
        "true",
        "false"
    ]
};

});

parcelRegister("8c7fr", function(module, exports) {

$parcel$export(module.exports, "NaNDocs", function () { return $5f7511090b337b53$export$eabb08eada5c068d; });
var $5f7511090b337b53$export$eabb08eada5c068d = {
    name: "NaN",
    category: "Constants",
    syntax: [
        "NaN"
    ],
    description: "Not a number",
    examples: [
        "NaN",
        "0 / 0"
    ],
    seealso: []
};

});

parcelRegister("itTiH", function(module, exports) {

$parcel$export(module.exports, "LOG10EDocs", function () { return $d745d4f72c658197$export$c706f91356bdd28c; });
var $d745d4f72c658197$export$c706f91356bdd28c = {
    name: "LOG10E",
    category: "Constants",
    syntax: [
        "LOG10E"
    ],
    description: "Returns the base-10 logarithm of E, approximately equal to 0.434",
    examples: [
        "LOG10E",
        "log(e, 10)"
    ],
    seealso: []
};

});

parcelRegister("fmiHs", function(module, exports) {

$parcel$export(module.exports, "LOG2EDocs", function () { return $b2e76a84887bacdd$export$813e053668381c19; });
var $b2e76a84887bacdd$export$813e053668381c19 = {
    name: "LOG2E",
    category: "Constants",
    syntax: [
        "LOG2E"
    ],
    description: "Returns the base-2 logarithm of E, approximately equal to 1.442",
    examples: [
        "LOG2E",
        "log(e, 2)"
    ],
    seealso: []
};

});

parcelRegister("ccMvY", function(module, exports) {

$parcel$export(module.exports, "LN10Docs", function () { return $8e2c3d048f5599eb$export$a1bd41a4b6a2fca0; });
var $8e2c3d048f5599eb$export$a1bd41a4b6a2fca0 = {
    name: "LN10",
    category: "Constants",
    syntax: [
        "LN10"
    ],
    description: "Returns the natural logarithm of 10, approximately equal to 2.302",
    examples: [
        "LN10",
        "log(10)"
    ],
    seealso: []
};

});

parcelRegister("iqRSN", function(module, exports) {

$parcel$export(module.exports, "LN2Docs", function () { return $037685febd199574$export$6e0577c024a56563; });
var $037685febd199574$export$6e0577c024a56563 = {
    name: "LN2",
    category: "Constants",
    syntax: [
        "LN2"
    ],
    description: "Returns the natural logarithm of 2, approximately equal to 0.693",
    examples: [
        "LN2",
        "log(2)"
    ],
    seealso: []
};

});

parcelRegister("bRBg8", function(module, exports) {

$parcel$export(module.exports, "InfinityDocs", function () { return $8a318bd822995619$export$15a96a548a33c6f1; });
var $8a318bd822995619$export$15a96a548a33c6f1 = {
    name: "Infinity",
    category: "Constants",
    syntax: [
        "Infinity"
    ],
    description: "Infinity, a number which is larger than the maximum number that can be handled by a floating point number.",
    examples: [
        "Infinity",
        "1 / 0"
    ],
    seealso: []
};

});

parcelRegister("b2VFA", function(module, exports) {

$parcel$export(module.exports, "iDocs", function () { return $80ac9d9a3f56177c$export$e6ca220ee1b42382; });
var $80ac9d9a3f56177c$export$e6ca220ee1b42382 = {
    name: "i",
    category: "Constants",
    syntax: [
        "i"
    ],
    description: "Imaginary unit, defined as i*i=-1. A complex number is described as a + b*i, where a is the real part, and b is the imaginary part.",
    examples: [
        "i",
        "i * i",
        "sqrt(-1)"
    ],
    seealso: []
};

});

parcelRegister("h6xG2", function(module, exports) {

$parcel$export(module.exports, "falseDocs", function () { return $c73d1ec2f75661bf$export$a73c839095ae9f5c; });
var $c73d1ec2f75661bf$export$a73c839095ae9f5c = {
    name: "false",
    category: "Constants",
    syntax: [
        "false"
    ],
    description: "Boolean value false",
    examples: [
        "false"
    ],
    seealso: [
        "true"
    ]
};

});

parcelRegister("2GX6q", function(module, exports) {

$parcel$export(module.exports, "eDocs", function () { return $1f5d59910cc48fce$export$3fcb7a132c6e2ba6; });
var $1f5d59910cc48fce$export$3fcb7a132c6e2ba6 = {
    name: "e",
    category: "Constants",
    syntax: [
        "e"
    ],
    description: "Euler's number, the base of the natural logarithm. Approximately equal to 2.71828",
    examples: [
        "e",
        "e ^ 2",
        "exp(2)",
        "log(e)"
    ],
    seealso: [
        "exp"
    ]
};

});

parcelRegister("hIK3f", function(module, exports) {

$parcel$export(module.exports, "unitDocs", function () { return $ce6a44979449927e$export$478a7368ebd56459; });
var $ce6a44979449927e$export$478a7368ebd56459 = {
    name: "unit",
    category: "Construction",
    syntax: [
        "value unit",
        "unit(value, unit)",
        "unit(string)"
    ],
    description: "Create a unit.",
    examples: [
        "5.5 mm",
        "3 inch",
        'unit(7.1, "kilogram")',
        'unit("23 deg")'
    ],
    seealso: [
        "bignumber",
        "boolean",
        "complex",
        "index",
        "matrix",
        "number",
        "string"
    ]
};

});

parcelRegister("dt2RG", function(module, exports) {

$parcel$export(module.exports, "stringDocs", function () { return $9ce034b52e76aee9$export$783e4a4a90f7bc1d; });
var $9ce034b52e76aee9$export$783e4a4a90f7bc1d = {
    name: "string",
    category: "Construction",
    syntax: [
        '"text"',
        "string(x)"
    ],
    description: "Create a string or convert a value to a string",
    examples: [
        '"Hello World!"',
        "string(4.2)",
        "string(3 + 2i)"
    ],
    seealso: [
        "bignumber",
        "boolean",
        "complex",
        "index",
        "matrix",
        "number",
        "unit"
    ]
};

});

parcelRegister("93VPs", function(module, exports) {

$parcel$export(module.exports, "splitUnitDocs", function () { return $6991407d1436192f$export$f729a0241c48cb52; });
var $6991407d1436192f$export$f729a0241c48cb52 = {
    name: "splitUnit",
    category: "Construction",
    syntax: [
        "splitUnit(unit: Unit, parts: Unit[])"
    ],
    description: "Split a unit in an array of units whose sum is equal to the original unit.",
    examples: [
        'splitUnit(1 m, ["feet", "inch"])'
    ],
    seealso: [
        "unit",
        "createUnit"
    ]
};

});

parcelRegister("4ZofO", function(module, exports) {

$parcel$export(module.exports, "sparseDocs", function () { return $3a1fac441b5e3e18$export$b569625c2404133; });
var $3a1fac441b5e3e18$export$b569625c2404133 = {
    name: "sparse",
    category: "Construction",
    syntax: [
        "sparse()",
        "sparse([a1, b1, ...; a1, b2, ...])",
        'sparse([a1, b1, ...; a1, b2, ...], "number")'
    ],
    description: "Create a sparse matrix.",
    examples: [
        "sparse()",
        "sparse([3, 4; 5, 6])",
        'sparse([3, 0; 5, 0], "number")'
    ],
    seealso: [
        "bignumber",
        "boolean",
        "complex",
        "index",
        "number",
        "string",
        "unit",
        "matrix"
    ]
};

});

parcelRegister("ixFIj", function(module, exports) {

$parcel$export(module.exports, "numberDocs", function () { return $d7fbaa88c288a128$export$3b011c0eed79d7e0; });
var $d7fbaa88c288a128$export$3b011c0eed79d7e0 = {
    name: "number",
    category: "Construction",
    syntax: [
        "x",
        "number(x)",
        "number(unit, valuelessUnit)"
    ],
    description: "Create a number or convert a string or boolean into a number.",
    examples: [
        "2",
        "2e3",
        "4.05",
        "number(2)",
        'number("7.2")',
        "number(true)",
        "number([true, false, true, true])",
        'number(unit("52cm"), "m")'
    ],
    seealso: [
        "bignumber",
        "boolean",
        "complex",
        "fraction",
        "index",
        "matrix",
        "string",
        "unit"
    ]
};

});

parcelRegister("3qbVG", function(module, exports) {

$parcel$export(module.exports, "matrixDocs", function () { return $27dd0dba8a471a07$export$dc433018b5b5e90f; });
var $27dd0dba8a471a07$export$dc433018b5b5e90f = {
    name: "matrix",
    category: "Construction",
    syntax: [
        "[]",
        "[a1, b1, ...; a2, b2, ...]",
        "matrix()",
        'matrix("dense")',
        "matrix([...])"
    ],
    description: "Create a matrix.",
    examples: [
        "[]",
        "[1, 2, 3]",
        "[1, 2, 3; 4, 5, 6]",
        "matrix()",
        "matrix([3, 4])",
        'matrix([3, 4; 5, 6], "sparse")',
        'matrix([3, 4; 5, 6], "sparse", "number")'
    ],
    seealso: [
        "bignumber",
        "boolean",
        "complex",
        "index",
        "number",
        "string",
        "unit",
        "sparse"
    ]
};

});

parcelRegister("jOQNC", function(module, exports) {

$parcel$export(module.exports, "indexDocs", function () { return $e6dba4b25846e2cf$export$39876fcf61312bba; });
var $e6dba4b25846e2cf$export$39876fcf61312bba = {
    name: "index",
    category: "Construction",
    syntax: [
        "[start]",
        "[start:end]",
        "[start:step:end]",
        "[start1, start 2, ...]",
        "[start1:end1, start2:end2, ...]",
        "[start1:step1:end1, start2:step2:end2, ...]"
    ],
    description: "Create an index to get or replace a subset of a matrix",
    examples: [
        "[]",
        "[1, 2, 3]",
        "A = [1, 2, 3; 4, 5, 6]",
        "A[1, :]",
        "A[1, 2] = 50",
        "A[0:2, 0:2] = ones(2, 2)"
    ],
    seealso: [
        "bignumber",
        "boolean",
        "complex",
        "matrix,",
        "number",
        "range",
        "string",
        "unit"
    ]
};

});

parcelRegister("ddhGV", function(module, exports) {

$parcel$export(module.exports, "fractionDocs", function () { return $99ea3669a9bd61c6$export$46678100e6b87439; });
var $99ea3669a9bd61c6$export$46678100e6b87439 = {
    name: "fraction",
    category: "Construction",
    syntax: [
        "fraction(num)",
        "fraction(num,den)"
    ],
    description: "Create a fraction from a number or from a numerator and denominator.",
    examples: [
        "fraction(0.125)",
        "fraction(1, 3) + fraction(2, 5)"
    ],
    seealso: [
        "bignumber",
        "boolean",
        "complex",
        "index",
        "matrix",
        "string",
        "unit"
    ]
};

});

parcelRegister("ct5JI", function(module, exports) {

$parcel$export(module.exports, "createUnitDocs", function () { return $913ca494dfb3f792$export$e56a121dfffbec82; });
var $913ca494dfb3f792$export$e56a121dfffbec82 = {
    name: "createUnit",
    category: "Construction",
    syntax: [
        "createUnit(definitions)",
        "createUnit(name, definition)"
    ],
    description: "Create a user-defined unit and register it with the Unit type.",
    examples: [
        'createUnit("foo")',
        'createUnit("knot", {definition: "0.514444444 m/s", aliases: ["knots", "kt", "kts"]})',
        'createUnit("mph", "1 mile/hour")'
    ],
    seealso: [
        "unit",
        "splitUnit"
    ]
};

});

parcelRegister("aXBsd", function(module, exports) {

$parcel$export(module.exports, "complexDocs", function () { return $7fac77b1ceceaf83$export$a266a326dd0e84ff; });
var $7fac77b1ceceaf83$export$a266a326dd0e84ff = {
    name: "complex",
    category: "Construction",
    syntax: [
        "complex()",
        "complex(re, im)",
        "complex(string)"
    ],
    description: "Create a complex number.",
    examples: [
        "complex()",
        "complex(2, 3)",
        'complex("7 - 2i")'
    ],
    seealso: [
        "bignumber",
        "boolean",
        "index",
        "matrix",
        "number",
        "string",
        "unit"
    ]
};

});

parcelRegister("j9kpd", function(module, exports) {

$parcel$export(module.exports, "booleanDocs", function () { return $df0eafbbf0485ed8$export$dbe10b9a90fd671a; });
var $df0eafbbf0485ed8$export$dbe10b9a90fd671a = {
    name: "boolean",
    category: "Construction",
    syntax: [
        "x",
        "boolean(x)"
    ],
    description: "Convert a string or number into a boolean.",
    examples: [
        "boolean(0)",
        "boolean(1)",
        "boolean(3)",
        'boolean("true")',
        'boolean("false")',
        "boolean([1, 0, 1, 1])"
    ],
    seealso: [
        "bignumber",
        "complex",
        "index",
        "matrix",
        "number",
        "string",
        "unit"
    ]
};

});

parcelRegister("giZIF", function(module, exports) {

$parcel$export(module.exports, "dotPowDocs", function () { return $bdee33f6e3d494e4$export$db82d026e80f1871; });
var $bdee33f6e3d494e4$export$db82d026e80f1871 = {
    name: "dotPow",
    category: "Operators",
    syntax: [
        "x .^ y",
        "dotPow(x, y)"
    ],
    description: "Calculates the power of x to y element wise.",
    examples: [
        "a = [1, 2, 3; 4, 5, 6]",
        "a .^ 2"
    ],
    seealso: [
        "pow"
    ]
};

});

parcelRegister("k4gW9", function(module, exports) {

$parcel$export(module.exports, "lusolveDocs", function () { return $e9c151b05df846a3$export$b24588d98e782136; });
var $e9c151b05df846a3$export$b24588d98e782136 = {
    name: "lusolve",
    category: "Algebra",
    syntax: [
        "x=lusolve(A, b)",
        "x=lusolve(lu, b)"
    ],
    description: "Solves the linear system A * x = b where A is an [n x n] matrix and b is a [n] column vector.",
    examples: [
        "a = [-2, 3; 2, 1]",
        "b = [11, 9]",
        "x = lusolve(a, b)"
    ],
    seealso: [
        "lup",
        "slu",
        "lsolve",
        "usolve",
        "matrix",
        "sparse"
    ]
};

});

parcelRegister("2xP82", function(module, exports) {

$parcel$export(module.exports, "subtractDocs", function () { return $1da652f151532288$export$435374265ca1b923; });
var $1da652f151532288$export$435374265ca1b923 = {
    name: "subtract",
    category: "Operators",
    syntax: [
        "x - y",
        "subtract(x, y)"
    ],
    description: "subtract two values.",
    examples: [
        "a = 5.3 - 2",
        "a + 2",
        "2/3 - 1/6",
        "2 * 3 - 3",
        "2.1 km - 500m"
    ],
    seealso: [
        "add"
    ]
};

});

parcelRegister("17xd2", function(module, exports) {

$parcel$export(module.exports, "varianceDocs", function () { return $0d10348ea57d53f4$export$5a58a225f78b347f; });
var $0d10348ea57d53f4$export$5a58a225f78b347f = {
    name: "variance",
    category: "Statistics",
    syntax: [
        "variance(a, b, c, ...)",
        "variance(A)",
        "variance(A, normalization)"
    ],
    description: 'Compute the variance of all values. Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".',
    examples: [
        "variance(2, 4, 6)",
        "variance([2, 4, 6, 8])",
        'variance([2, 4, 6, 8], "uncorrected")',
        'variance([2, 4, 6, 8], "biased")',
        "variance([1, 2, 3; 4, 5, 6])"
    ],
    seealso: [
        "max",
        "mean",
        "min",
        "median",
        "min",
        "prod",
        "std",
        "sum"
    ]
};

});

parcelRegister("gl9oO", function(module, exports) {

$parcel$export(module.exports, "sinDocs", function () { return $be55e5feac4826d7$export$c7700d6ff32b1413; });
var $be55e5feac4826d7$export$c7700d6ff32b1413 = {
    name: "sin",
    category: "Trigonometry",
    syntax: [
        "sin(x)"
    ],
    description: "Compute the sine of x in radians.",
    examples: [
        "sin(2)",
        "sin(pi / 4) ^ 2",
        "sin(90 deg)",
        "sin(30 deg)",
        "sin(0.2)^2 + cos(0.2)^2"
    ],
    seealso: [
        "asin",
        "cos",
        "tan"
    ]
};

});

parcelRegister("3xnbV", function(module, exports) {

$parcel$export(module.exports, "numericDocs", function () { return $29367178a98911e7$export$d275ce05039a5f7a; });
var $29367178a98911e7$export$d275ce05039a5f7a = {
    name: "numeric",
    category: "Utils",
    syntax: [
        "numeric(x)"
    ],
    description: "Convert a numeric input to a specific numeric type: number, BigNumber, or Fraction.",
    examples: [
        'numeric("4")',
        'numeric("4", "number")',
        'numeric("4", "BigNumber")',
        'numeric("4", "Fraction)',
        'numeric(4, "Fraction")',
        'numeric(fraction(2, 5), "number)'
    ],
    seealso: [
        "number",
        "fraction",
        "bignumber",
        "string",
        "format"
    ]
};

});

parcelRegister("94H8i", function(module, exports) {

$parcel$export(module.exports, "columnDocs", function () { return $69b5f21457ed1342$export$a5760461eff76999; });
var $69b5f21457ed1342$export$a5760461eff76999 = {
    name: "column",
    category: "Matrix",
    syntax: [
        "column(x, index)"
    ],
    description: "Return a column from a matrix or array.",
    examples: [
        "A = [[1, 2], [3, 4]]",
        "column(A, 1)",
        "column(A, 2)"
    ],
    seealso: [
        "row"
    ]
};

});

parcelRegister("lQaPd", function(module, exports) {

$parcel$export(module.exports, "rowDocs", function () { return $fe66d9ee55e4733e$export$74b9786bafaa0a25; });
var $fe66d9ee55e4733e$export$74b9786bafaa0a25 = {
    name: "row",
    category: "Matrix",
    syntax: [
        "row(x, index)"
    ],
    description: "Return a row from a matrix or array.",
    examples: [
        "A = [[1, 2], [3, 4]]",
        "row(A, 1)",
        "row(A, 2)"
    ],
    seealso: [
        "column"
    ]
};

});



parcelRegister("fTGKn", function(module, exports) {

$parcel$export(module.exports, "createHelpClass", function () { return $b92d26c202a65ff8$export$704346eb22eef29; });

var $1amHZ = parcelRequire("1amHZ");

var $7ITGG = parcelRequire("7ITGG");

var $6NxuJ = parcelRequire("6NxuJ");

var $2mPYl = parcelRequire("2mPYl");
var $b92d26c202a65ff8$var$name = "Help";
var $b92d26c202a65ff8$var$dependencies = [
    "parse"
];
var $b92d26c202a65ff8$export$704346eb22eef29 = /* #__PURE__ */ (0, $2mPYl.factory)($b92d26c202a65ff8$var$name, $b92d26c202a65ff8$var$dependencies, function(_ref) {
    var parse = _ref.parse;
    /**
   * Documentation object
   * @param {Object} doc  Object containing properties:
   *                      {string} name
   *                      {string} category
   *                      {string} description
   *                      {string[]} syntax
   *                      {string[]} examples
   *                      {string[]} seealso
   * @constructor
   */ function Help(doc) {
        if (!(this instanceof Help)) throw new SyntaxError("Constructor must be called with the new operator");
        if (!doc) throw new Error('Argument "doc" missing');
        this.doc = doc;
    }
    /**
   * Attach type information
   */ Help.prototype.type = "Help";
    Help.prototype.isHelp = true;
    /**
   * Generate a string representation of the Help object
   * @return {string} Returns a string
   * @private
   */ Help.prototype.toString = function() {
        var doc = this.doc || {};
        var desc = "\n";
        if (doc.name) desc += "Name: " + doc.name + "\n\n";
        if (doc.category) desc += "Category: " + doc.category + "\n\n";
        if (doc.description) desc += "Description:\n    " + doc.description + "\n\n";
        if (doc.syntax) desc += "Syntax:\n    " + doc.syntax.join("\n    ") + "\n\n";
        if (doc.examples) {
            desc += "Examples:\n";
            var scope = {};
            for(var i = 0; i < doc.examples.length; i++){
                var expr = doc.examples[i];
                desc += "    " + expr + "\n";
                var res = void 0;
                try {
                    // note: res can be undefined when `expr` is an empty string
                    res = parse(expr).compile().evaluate(scope);
                } catch (e) {
                    res = e;
                }
                if (res !== undefined && !(0, $1amHZ.isHelp)(res)) desc += "        " + (0, $6NxuJ.format)(res, {
                    precision: 14
                }) + "\n";
            }
            desc += "\n";
        }
        if (doc.seealso && doc.seealso.length) desc += "See also: " + doc.seealso.join(", ") + "\n";
        return desc;
    };
    /**
   * Export the help object to JSON
   */ Help.prototype.toJSON = function() {
        var obj = (0, $7ITGG.clone)(this.doc);
        obj.mathjs = "Help";
        return obj;
    };
    /**
   * Instantiate a Help object from a JSON object
   * @param {Object} json
   * @returns {Help} Returns a new Help object
   */ Help.fromJSON = function(json) {
        var doc = {};
        for(var prop in json)if (prop !== "mathjs") // ignore mathjs field
        doc[prop] = json[prop];
        return new Help(doc);
    };
    /**
   * Returns a string representation of the Help object
   */ Help.prototype.valueOf = Help.prototype.toString;
    return Help;
}, {
    isClass: true
});

});

parcelRegister("eBv9n", function(module, exports) {

$parcel$export(module.exports, "createIndexNode", function () { return $aa1caf2cae2481a5$export$883b7fdc0499e9f0; });

var $1amHZ = parcelRequire("1amHZ");

var $5WdrK = parcelRequire("5WdrK");

var $6NxuJ = parcelRequire("6NxuJ");

var $2mPYl = parcelRequire("2mPYl");

var $45IYD = parcelRequire("45IYD");
function $aa1caf2cae2481a5$var$_toConsumableArray(arr) {
    return $aa1caf2cae2481a5$var$_arrayWithoutHoles(arr) || $aa1caf2cae2481a5$var$_iterableToArray(arr) || $aa1caf2cae2481a5$var$_unsupportedIterableToArray(arr) || $aa1caf2cae2481a5$var$_nonIterableSpread();
}
function $aa1caf2cae2481a5$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $aa1caf2cae2481a5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $aa1caf2cae2481a5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $aa1caf2cae2481a5$var$_arrayLikeToArray(o, minLen);
}
function $aa1caf2cae2481a5$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $aa1caf2cae2481a5$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $aa1caf2cae2481a5$var$_arrayLikeToArray(arr);
}
function $aa1caf2cae2481a5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $aa1caf2cae2481a5$var$name = "IndexNode";
var $aa1caf2cae2481a5$var$dependencies = [
    "Range",
    "Node",
    "size"
];
var $aa1caf2cae2481a5$export$883b7fdc0499e9f0 = /* #__PURE__ */ (0, $2mPYl.factory)($aa1caf2cae2481a5$var$name, $aa1caf2cae2481a5$var$dependencies, function(_ref) {
    var Range = _ref.Range, Node = _ref.Node, size = _ref.size;
    /**
   * @constructor IndexNode
   * @extends Node
   *
   * Describes a subset of a matrix or an object property.
   * Cannot be used on its own, needs to be used within an AccessorNode or
   * AssignmentNode.
   *
   * @param {Node[]} dimensions
   * @param {boolean} [dotNotation=false]  Optional property describing whether
   *                                       this index was written using dot
   *                                       notation like `a.b`, or using bracket
   *                                       notation like `a["b"]` (default).
   *                                       Used to stringify an IndexNode.
   */ function IndexNode(dimensions, dotNotation) {
        if (!(this instanceof IndexNode)) throw new SyntaxError("Constructor must be called with the new operator");
        this.dimensions = dimensions;
        this.dotNotation = dotNotation || false; // validate input
        if (!Array.isArray(dimensions) || !dimensions.every((0, $1amHZ.isNode))) throw new TypeError('Array containing Nodes expected for parameter "dimensions"');
        if (this.dotNotation && !this.isObjectProperty()) throw new Error("dotNotation only applicable for object properties");
         // TODO: deprecated since v3, remove some day
        var deprecated = function deprecated() {
            throw new Error("Property `IndexNode.object` is deprecated, use `IndexNode.fn` instead");
        };
        Object.defineProperty(this, "object", {
            get: deprecated,
            set: deprecated
        });
    }
    IndexNode.prototype = new Node();
    IndexNode.prototype.type = "IndexNode";
    IndexNode.prototype.isIndexNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ IndexNode.prototype._compile = function(math, argNames) {
        // TODO: implement support for bignumber (currently bignumbers are silently
        //       reduced to numbers when changing the value to zero-based)
        // TODO: Optimization: when the range values are ConstantNodes,
        //       we can beforehand resolve the zero-based value
        // optimization for a simple object property
        var evalDimensions = (0, $5WdrK.map)(this.dimensions, function(range, i) {
            if ((0, $1amHZ.isRangeNode)(range)) {
                if (range.needsEnd()) {
                    // create a range containing end (like '4:end')
                    var childArgNames = Object.create(argNames);
                    childArgNames.end = true;
                    var evalStart = range.start._compile(math, childArgNames);
                    var evalEnd = range.end._compile(math, childArgNames);
                    var evalStep = range.step ? range.step._compile(math, childArgNames) : function() {
                        return 1;
                    };
                    return function evalDimension(scope, args, context) {
                        var s = size(context).valueOf();
                        var childArgs = Object.create(args);
                        childArgs.end = s[i];
                        return createRange(evalStart(scope, childArgs, context), evalEnd(scope, childArgs, context), evalStep(scope, childArgs, context));
                    };
                } else {
                    // create range
                    var _evalStart = range.start._compile(math, argNames);
                    var _evalEnd = range.end._compile(math, argNames);
                    var _evalStep = range.step ? range.step._compile(math, argNames) : function() {
                        return 1;
                    };
                    return function evalDimension(scope, args, context) {
                        return createRange(_evalStart(scope, args, context), _evalEnd(scope, args, context), _evalStep(scope, args, context));
                    };
                }
            } else if ((0, $1amHZ.isSymbolNode)(range) && range.name === "end") {
                // SymbolNode 'end'
                var _childArgNames = Object.create(argNames);
                _childArgNames.end = true;
                var evalRange = range._compile(math, _childArgNames);
                return function evalDimension(scope, args, context) {
                    var s = size(context).valueOf();
                    var childArgs = Object.create(args);
                    childArgs.end = s[i];
                    return evalRange(scope, childArgs, context);
                };
            } else {
                // ConstantNode
                var _evalRange = range._compile(math, argNames);
                return function evalDimension(scope, args, context) {
                    return _evalRange(scope, args, context);
                };
            }
        });
        var index = (0, $45IYD.getSafeProperty)(math, "index");
        return function evalIndexNode(scope, args, context) {
            var dimensions = (0, $5WdrK.map)(evalDimensions, function(evalDimension) {
                return evalDimension(scope, args, context);
            });
            return index.apply(void 0, $aa1caf2cae2481a5$var$_toConsumableArray(dimensions));
        };
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ IndexNode.prototype.forEach = function(callback) {
        for(var i = 0; i < this.dimensions.length; i++)callback(this.dimensions[i], "dimensions[" + i + "]", this);
    };
    /**
   * Create a new IndexNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node): Node} callback
   * @returns {IndexNode} Returns a transformed copy of the node
   */ IndexNode.prototype.map = function(callback) {
        var dimensions = [];
        for(var i = 0; i < this.dimensions.length; i++)dimensions[i] = this._ifNode(callback(this.dimensions[i], "dimensions[" + i + "]", this));
        return new IndexNode(dimensions, this.dotNotation);
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {IndexNode}
   */ IndexNode.prototype.clone = function() {
        return new IndexNode(this.dimensions.slice(0), this.dotNotation);
    };
    /**
   * Test whether this IndexNode contains a single property name
   * @return {boolean}
   */ IndexNode.prototype.isObjectProperty = function() {
        return this.dimensions.length === 1 && (0, $1amHZ.isConstantNode)(this.dimensions[0]) && typeof this.dimensions[0].value === "string";
    };
    /**
   * Returns the property name if IndexNode contains a property.
   * If not, returns null.
   * @return {string | null}
   */ IndexNode.prototype.getObjectProperty = function() {
        return this.isObjectProperty() ? this.dimensions[0].value : null;
    };
    /**
   * Get string representation
   * @param {Object} options
   * @return {string} str
   */ IndexNode.prototype._toString = function(options) {
        // format the parameters like "[1, 0:5]"
        return this.dotNotation ? "." + this.getObjectProperty() : "[" + this.dimensions.join(", ") + "]";
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ IndexNode.prototype.toJSON = function() {
        return {
            mathjs: "IndexNode",
            dimensions: this.dimensions,
            dotNotation: this.dotNotation
        };
    };
    /**
   * Instantiate an IndexNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "IndexNode", dimensions: [...], dotNotation: false}`,
   *                       where mathjs is optional
   * @returns {IndexNode}
   */ IndexNode.fromJSON = function(json) {
        return new IndexNode(json.dimensions, json.dotNotation);
    };
    /**
   * Get HTML representation
   * @param {Object} options
   * @return {string} str
   */ IndexNode.prototype.toHTML = function(options) {
        // format the parameters like "[1, 0:5]"
        var dimensions = [];
        for(var i = 0; i < this.dimensions.length; i++)dimensions[i] = this.dimensions[i].toHTML();
        if (this.dotNotation) return '<span class="math-operator math-accessor-operator">.</span><span class="math-symbol math-property">' + (0, $6NxuJ.escape)(this.getObjectProperty()) + "</span>";
        else return '<span class="math-parenthesis math-square-parenthesis">[</span>' + dimensions.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-square-parenthesis">]</span>';
    };
    /**
   * Get LaTeX representation
   * @param {Object} options
   * @return {string} str
   */ IndexNode.prototype._toTex = function(options) {
        var dimensions = this.dimensions.map(function(range) {
            return range.toTex(options);
        });
        return this.dotNotation ? "." + this.getObjectProperty() + "" : "_{" + dimensions.join(",") + "}";
    }; // helper function to create a Range from start, step and end
    function createRange(start, end, step) {
        return new Range((0, $1amHZ.isBigNumber)(start) ? start.toNumber() : start, (0, $1amHZ.isBigNumber)(end) ? end.toNumber() : end, (0, $1amHZ.isBigNumber)(step) ? step.toNumber() : step);
    }
    return IndexNode;
}, {
    isClass: true,
    isNode: true
});

});

parcelRegister("iQKTE", function(module, exports) {

$parcel$export(module.exports, "createIndexTransform", function () { return $db9175fca1a8ad7e$export$f20e87a60dbfc89e; });

var $1amHZ = parcelRequire("1amHZ");

var $2mPYl = parcelRequire("2mPYl");
var $db9175fca1a8ad7e$var$name = "index";
var $db9175fca1a8ad7e$var$dependencies = [
    "Index"
];
var $db9175fca1a8ad7e$export$f20e87a60dbfc89e = /* #__PURE__ */ (0, $2mPYl.factory)($db9175fca1a8ad7e$var$name, $db9175fca1a8ad7e$var$dependencies, function(_ref) {
    var Index = _ref.Index;
    /**
   * Attach a transform function to math.index
   * Adds a property transform containing the transform function.
   *
   * This transform creates a one-based index instead of a zero-based index
   */ return function indexTransform() {
        var args = [];
        for(var i = 0, ii = arguments.length; i < ii; i++){
            var arg = arguments[i]; // change from one-based to zero based, and convert BigNumber to number
            if ((0, $1amHZ.isRange)(arg)) {
                arg.start--;
                arg.end -= arg.step > 0 ? 0 : 2;
            } else if (arg && arg.isSet === true) arg = arg.map(function(v) {
                return v - 1;
            });
            else if ((0, $1amHZ.isArray)(arg) || (0, $1amHZ.isMatrix)(arg)) arg = arg.map(function(v) {
                return v - 1;
            });
            else if ((0, $1amHZ.isNumber)(arg)) arg--;
            else if ((0, $1amHZ.isBigNumber)(arg)) arg = arg.toNumber() - 1;
            else if (typeof arg === "string") ;
            else throw new TypeError("Dimension must be an Array, Matrix, number, string, or Range");
            args[i] = arg;
        }
        var res = new Index();
        Index.apply(res, args);
        return res;
    };
}, {
    isTransformFunction: true
});

});

parcelRegister("7xwSh", function(module, exports) {

$parcel$export(module.exports, "createMapTransform", function () { return $57d51da80bd6ea22$export$5ae33143d676d4d4; });

var $1amHZ = parcelRequire("1amHZ");

var $kpJv9 = parcelRequire("kpJv9");

var $5WdrK = parcelRequire("5WdrK");

var $2mPYl = parcelRequire("2mPYl");

var $j4nFQ = parcelRequire("j4nFQ");
var $57d51da80bd6ea22$var$name = "map";
var $57d51da80bd6ea22$var$dependencies = [
    "typed"
];
var $57d51da80bd6ea22$export$5ae33143d676d4d4 = /* #__PURE__ */ (0, $2mPYl.factory)($57d51da80bd6ea22$var$name, $57d51da80bd6ea22$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Attach a transform function to math.map
   * Adds a property transform containing the transform function.
   *
   * This transform creates a one-based index instead of a zero-based index
   */ function mapTransform(args, math, scope) {
        var x, callback;
        if (args[0]) x = args[0].compile().evaluate(scope);
        if (args[1]) {
            if ((0, $1amHZ.isSymbolNode)(args[1]) || (0, $1amHZ.isFunctionAssignmentNode)(args[1])) // a function pointer, like filter([3, -2, 5], myTestFunction)
            callback = args[1].compile().evaluate(scope);
            else // an expression like filter([3, -2, 5], x > 0)
            callback = (0, $j4nFQ.compileInlineExpression)(args[1], math, scope);
        }
        return map(x, callback);
    }
    mapTransform.rawArgs = true; // one-based version of map function
    var map = typed("map", {
        "Array, function": function ArrayFunction(x, callback) {
            return $57d51da80bd6ea22$var$_map(x, callback, x);
        },
        "Matrix, function": function MatrixFunction(x, callback) {
            return x.create($57d51da80bd6ea22$var$_map(x.valueOf(), callback, x));
        }
    });
    return mapTransform;
}, {
    isTransformFunction: true
});
/**
 * Map for a multi dimensional array. One-based indexes
 * @param {Array} array
 * @param {function} callback
 * @param {Array} orig
 * @return {Array}
 * @private
 */ function $57d51da80bd6ea22$var$_map(array, callback, orig) {
    // figure out what number of arguments the callback function expects
    var argsCount = (0, $kpJv9.maxArgumentCount)(callback);
    function recurse(value, index) {
        if (Array.isArray(value)) return (0, $5WdrK.map)(value, function(child, i) {
            // we create a copy of the index array and append the new index value
            return recurse(child, index.concat(i + 1)); // one based index, hence i + 1
        });
        else {
            // invoke the (typed) callback function with the right number of arguments
            if (argsCount === 1) return callback(value);
            else if (argsCount === 2) return callback(value, index);
            else // 3 or -1
            return callback(value, index, orig);
        }
    }
    return recurse(array, []);
}

});

parcelRegister("1hNiT", function(module, exports) {

$parcel$export(module.exports, "createMaxTransform", function () { return $0efd9fb0c72b6223$export$cb806a795cec8077; });

var $1amHZ = parcelRequire("1amHZ");

var $2mPYl = parcelRequire("2mPYl");

var $dJ38g = parcelRequire("dJ38g");

var $No7sr = parcelRequire("No7sr");
var $0efd9fb0c72b6223$var$name = "max";
var $0efd9fb0c72b6223$var$dependencies = [
    "typed",
    "larger"
];
var $0efd9fb0c72b6223$export$cb806a795cec8077 = /* #__PURE__ */ (0, $2mPYl.factory)($0efd9fb0c72b6223$var$name, $0efd9fb0c72b6223$var$dependencies, function(_ref) {
    var typed = _ref.typed, larger = _ref.larger;
    var max = (0, $No7sr.createMax)({
        typed: typed,
        larger: larger
    });
    /**
   * Attach a transform function to math.max
   * Adds a property transform containing the transform function.
   *
   * This transform changed the last `dim` parameter of function max
   * from one-based to zero based
   */ return typed("max", {
        "...any": function any(args) {
            // change last argument dim from one-based to zero-based
            if (args.length === 2 && (0, $1amHZ.isCollection)(args[0])) {
                var dim = args[1];
                if ((0, $1amHZ.isNumber)(dim)) args[1] = dim - 1;
                else if ((0, $1amHZ.isBigNumber)(dim)) args[1] = dim.minus(1);
            }
            try {
                return max.apply(null, args);
            } catch (err) {
                throw (0, $dJ38g.errorTransform)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});

});
parcelRegister("No7sr", function(module, exports) {

$parcel$export(module.exports, "createMax", function () { return $0947494e5681e076$export$b18a1b0c26c000ee; });

var $e04i1 = parcelRequire("e04i1");

var $2mPYl = parcelRequire("2mPYl");

var $l16bl = parcelRequire("l16bl");
var $0947494e5681e076$var$name = "max";
var $0947494e5681e076$var$dependencies = [
    "typed",
    "larger"
];
var $0947494e5681e076$export$b18a1b0c26c000ee = /* #__PURE__ */ (0, $2mPYl.factory)($0947494e5681e076$var$name, $0947494e5681e076$var$dependencies, function(_ref) {
    var typed = _ref.typed, larger = _ref.larger;
    /**
   * Compute the maximum value of a matrix or a  list with values.
   * In case of a multi dimensional array, the maximum of the flattened array
   * will be calculated. When `dim` is provided, the maximum over the selected
   * dimension will be calculated. Parameter `dim` is zero-based.
   *
   * Syntax:
   *
   *     math.max(a, b, c, ...)
   *     math.max(A)
   *     math.max(A, dim)
   *
   * Examples:
   *
   *     math.max(2, 1, 4, 3)                  // returns 4
   *     math.max([2, 1, 4, 3])                // returns 4
   *
   *     // maximum over a specified dimension (zero-based)
   *     math.max([[2, 5], [4, 3], [1, 7]], 0) // returns [4, 7]
   *     math.max([[2, 5], [4, 3]], [1, 7], 1) // returns [5, 4, 7]
   *
   *     math.max(2.7, 7.1, -4.5, 2.0, 4.1)    // returns 7.1
   *     math.min(2.7, 7.1, -4.5, 2.0, 4.1)    // returns -4.5
   *
   * See also:
   *
   *    mean, median, min, prod, std, sum, variance
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The maximum value
   */ return typed($0947494e5681e076$var$name, {
        // max([a, b, c, d, ...])
        "Array | Matrix": _max,
        // max([a, b, c, d, ...], dim)
        "Array | Matrix, number | BigNumber": function ArrayMatrixNumberBigNumber(array, dim) {
            return (0, $e04i1.reduce)(array, dim.valueOf(), _largest);
        },
        // max(a, b, c, d, ...)
        "...": function _(args) {
            if ((0, $e04i1.containsCollections)(args)) throw new TypeError("Scalar values expected in function max");
            return _max(args);
        }
    });
    /**
   * Return the largest of two values
   * @param {*} x
   * @param {*} y
   * @returns {*} Returns x when x is largest, or y when y is largest
   * @private
   */ function _largest(x, y) {
        try {
            return larger(x, y) ? x : y;
        } catch (err) {
            throw (0, $l16bl.improveErrorMessage)(err, "max", y);
        }
    }
    /**
   * Recursively calculate the maximum value in an n-dimensional array
   * @param {Array} array
   * @return {number} max
   * @private
   */ function _max(array) {
        var res;
        (0, $e04i1.deepForEach)(array, function(value) {
            try {
                if (isNaN(value) && typeof value === "number") res = NaN;
                else if (res === undefined || larger(value, res)) res = value;
            } catch (err) {
                throw (0, $l16bl.improveErrorMessage)(err, "max", value);
            }
        });
        if (res === undefined) throw new Error("Cannot calculate max of an empty array");
        return res;
    }
});

});
parcelRegister("l16bl", function(module, exports) {

$parcel$export(module.exports, "improveErrorMessage", function () { return $f4ce7c90e421253c$export$c8994973cec629ae; });

var $1amHZ = parcelRequire("1amHZ");
function $f4ce7c90e421253c$export$c8994973cec629ae(err, fnName, value) {
    // TODO: add information with the index (also needs transform in expression parser)
    var details;
    if (String(err).indexOf("Unexpected type") !== -1) {
        details = arguments.length > 2 ? " (type: " + (0, $1amHZ.typeOf)(value) + ", value: " + JSON.stringify(value) + ")" : " (type: " + err.data.actual + ")";
        return new TypeError("Cannot calculate " + fnName + ", unexpected type of argument" + details);
    }
    if (String(err).indexOf("complex numbers") !== -1) {
        details = arguments.length > 2 ? " (type: " + (0, $1amHZ.typeOf)(value) + ", value: " + JSON.stringify(value) + ")" : "";
        return new TypeError("Cannot calculate " + fnName + ", no ordering relation is defined for complex numbers" + details);
    }
    return err;
}

});



parcelRegister("lxQ6R", function(module, exports) {

$parcel$export(module.exports, "createMeanTransform", function () { return $faf519eb85d1442a$export$caaba12fb8f94b67; });

var $1amHZ = parcelRequire("1amHZ");

var $2mPYl = parcelRequire("2mPYl");

var $dJ38g = parcelRequire("dJ38g");

var $2y0Ri = parcelRequire("2y0Ri");
var $faf519eb85d1442a$var$name = "mean";
var $faf519eb85d1442a$var$dependencies = [
    "typed",
    "add",
    "divide"
];
var $faf519eb85d1442a$export$caaba12fb8f94b67 = /* #__PURE__ */ (0, $2mPYl.factory)($faf519eb85d1442a$var$name, $faf519eb85d1442a$var$dependencies, function(_ref) {
    var typed = _ref.typed, add = _ref.add, divide = _ref.divide;
    var mean = (0, $2y0Ri.createMean)({
        typed: typed,
        add: add,
        divide: divide
    });
    /**
   * Attach a transform function to math.mean
   * Adds a property transform containing the transform function.
   *
   * This transform changed the last `dim` parameter of function mean
   * from one-based to zero based
   */ return typed("mean", {
        "...any": function any(args) {
            // change last argument dim from one-based to zero-based
            if (args.length === 2 && (0, $1amHZ.isCollection)(args[0])) {
                var dim = args[1];
                if ((0, $1amHZ.isNumber)(dim)) args[1] = dim - 1;
                else if ((0, $1amHZ.isBigNumber)(dim)) args[1] = dim.minus(1);
            }
            try {
                return mean.apply(null, args);
            } catch (err) {
                throw (0, $dJ38g.errorTransform)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});

});
parcelRegister("2y0Ri", function(module, exports) {

$parcel$export(module.exports, "createMean", function () { return $1daf6c45e0128138$export$301ef7ca1de6782c; });

var $e04i1 = parcelRequire("e04i1");

var $5WdrK = parcelRequire("5WdrK");

var $2mPYl = parcelRequire("2mPYl");

var $l16bl = parcelRequire("l16bl");
var $1daf6c45e0128138$var$name = "mean";
var $1daf6c45e0128138$var$dependencies = [
    "typed",
    "add",
    "divide"
];
var $1daf6c45e0128138$export$301ef7ca1de6782c = /* #__PURE__ */ (0, $2mPYl.factory)($1daf6c45e0128138$var$name, $1daf6c45e0128138$var$dependencies, function(_ref) {
    var typed = _ref.typed, add = _ref.add, divide = _ref.divide;
    /**
   * Compute the mean value of matrix or a list with values.
   * In case of a multi dimensional array, the mean of the flattened array
   * will be calculated. When `dim` is provided, the maximum over the selected
   * dimension will be calculated. Parameter `dim` is zero-based.
   *
   * Syntax:
   *
   *     math.mean(a, b, c, ...)
   *     math.mean(A)
   *     math.mean(A, dim)
   *
   * Examples:
   *
   *     math.mean(2, 1, 4, 3)                     // returns 2.5
   *     math.mean([1, 2.7, 3.2, 4])               // returns 2.725
   *
   *     math.mean([[2, 5], [6, 3], [1, 7]], 0)    // returns [3, 5]
   *     math.mean([[2, 5], [6, 3], [1, 7]], 1)    // returns [3.5, 4.5, 4]
   *
   * See also:
   *
   *     median, min, max, sum, prod, std, variance
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The mean of all values
   */ return typed($1daf6c45e0128138$var$name, {
        // mean([a, b, c, d, ...])
        "Array | Matrix": _mean,
        // mean([a, b, c, d, ...], dim)
        "Array | Matrix, number | BigNumber": _nmeanDim,
        // mean(a, b, c, d, ...)
        "...": function _(args) {
            if ((0, $e04i1.containsCollections)(args)) throw new TypeError("Scalar values expected in function mean");
            return _mean(args);
        }
    });
    /**
   * Calculate the mean value in an n-dimensional array, returning a
   * n-1 dimensional array
   * @param {Array} array
   * @param {number} dim
   * @return {number} mean
   * @private
   */ function _nmeanDim(array, dim) {
        try {
            var sum = (0, $e04i1.reduce)(array, dim, add);
            var s = Array.isArray(array) ? (0, $5WdrK.arraySize)(array) : array.size();
            return divide(sum, s[dim]);
        } catch (err) {
            throw (0, $l16bl.improveErrorMessage)(err, "mean");
        }
    }
    /**
   * Recursively calculate the mean value in an n-dimensional array
   * @param {Array} array
   * @return {number} mean
   * @private
   */ function _mean(array) {
        var sum;
        var num = 0;
        (0, $e04i1.deepForEach)(array, function(value) {
            try {
                sum = sum === undefined ? value : add(sum, value);
                num++;
            } catch (err) {
                throw (0, $l16bl.improveErrorMessage)(err, "mean", value);
            }
        });
        if (num === 0) throw new Error("Cannot calculate the mean of an empty array");
        return divide(sum, num);
    }
});

});


parcelRegister("6UsSe", function(module, exports) {

$parcel$export(module.exports, "createMinTransform", function () { return $507e5ec1d0984b62$export$e6239917a808c35d; });

var $1amHZ = parcelRequire("1amHZ");

var $2mPYl = parcelRequire("2mPYl");

var $dJ38g = parcelRequire("dJ38g");

var $c8qEj = parcelRequire("c8qEj");
var $507e5ec1d0984b62$var$name = "min";
var $507e5ec1d0984b62$var$dependencies = [
    "typed",
    "smaller"
];
var $507e5ec1d0984b62$export$e6239917a808c35d = /* #__PURE__ */ (0, $2mPYl.factory)($507e5ec1d0984b62$var$name, $507e5ec1d0984b62$var$dependencies, function(_ref) {
    var typed = _ref.typed, smaller = _ref.smaller;
    var min = (0, $c8qEj.createMin)({
        typed: typed,
        smaller: smaller
    });
    /**
   * Attach a transform function to math.min
   * Adds a property transform containing the transform function.
   *
   * This transform changed the last `dim` parameter of function min
   * from one-based to zero based
   */ return typed("min", {
        "...any": function any(args) {
            // change last argument dim from one-based to zero-based
            if (args.length === 2 && (0, $1amHZ.isCollection)(args[0])) {
                var dim = args[1];
                if ((0, $1amHZ.isNumber)(dim)) args[1] = dim - 1;
                else if ((0, $1amHZ.isBigNumber)(dim)) args[1] = dim.minus(1);
            }
            try {
                return min.apply(null, args);
            } catch (err) {
                throw (0, $dJ38g.errorTransform)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});

});
parcelRegister("c8qEj", function(module, exports) {

$parcel$export(module.exports, "createMin", function () { return $8d5ae7620c8f9dd7$export$b795f47e2b99170; });

var $e04i1 = parcelRequire("e04i1");

var $2mPYl = parcelRequire("2mPYl");

var $l16bl = parcelRequire("l16bl");
var $8d5ae7620c8f9dd7$var$name = "min";
var $8d5ae7620c8f9dd7$var$dependencies = [
    "typed",
    "smaller"
];
var $8d5ae7620c8f9dd7$export$b795f47e2b99170 = /* #__PURE__ */ (0, $2mPYl.factory)($8d5ae7620c8f9dd7$var$name, $8d5ae7620c8f9dd7$var$dependencies, function(_ref) {
    var typed = _ref.typed, smaller = _ref.smaller;
    /**
   * Compute the minimum value of a matrix or a  list of values.
   * In case of a multi dimensional array, the minimum of the flattened array
   * will be calculated. When `dim` is provided, the minimum over the selected
   * dimension will be calculated. Parameter `dim` is zero-based.
   *
   * Syntax:
   *
   *     math.min(a, b, c, ...)
   *     math.min(A)
   *     math.min(A, dim)
   *
   * Examples:
   *
   *     math.min(2, 1, 4, 3)                  // returns 1
   *     math.min([2, 1, 4, 3])                // returns 1
   *
   *     // minimum over a specified dimension (zero-based)
   *     math.min([[2, 5], [4, 3], [1, 7]], 0) // returns [1, 3]
   *     math.min([[2, 5], [4, 3], [1, 7]], 1) // returns [2, 3, 1]
   *
   *     math.max(2.7, 7.1, -4.5, 2.0, 4.1)    // returns 7.1
   *     math.min(2.7, 7.1, -4.5, 2.0, 4.1)    // returns -4.5
   *
   * See also:
   *
   *    mean, median, max, prod, std, sum, variance
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The minimum value
   */ return typed($8d5ae7620c8f9dd7$var$name, {
        // min([a, b, c, d, ...])
        "Array | Matrix": _min,
        // min([a, b, c, d, ...], dim)
        "Array | Matrix, number | BigNumber": function ArrayMatrixNumberBigNumber(array, dim) {
            return (0, $e04i1.reduce)(array, dim.valueOf(), _smallest);
        },
        // min(a, b, c, d, ...)
        "...": function _(args) {
            if ((0, $e04i1.containsCollections)(args)) throw new TypeError("Scalar values expected in function min");
            return _min(args);
        }
    });
    /**
   * Return the smallest of two values
   * @param {*} x
   * @param {*} y
   * @returns {*} Returns x when x is smallest, or y when y is smallest
   * @private
   */ function _smallest(x, y) {
        try {
            return smaller(x, y) ? x : y;
        } catch (err) {
            throw (0, $l16bl.improveErrorMessage)(err, "min", y);
        }
    }
    /**
   * Recursively calculate the minimum value in an n-dimensional array
   * @param {Array} array
   * @return {number} min
   * @private
   */ function _min(array) {
        var min;
        (0, $e04i1.deepForEach)(array, function(value) {
            try {
                if (isNaN(value) && typeof value === "number") min = NaN;
                else if (min === undefined || smaller(value, min)) min = value;
            } catch (err) {
                throw (0, $l16bl.improveErrorMessage)(err, "min", value);
            }
        });
        if (min === undefined) throw new Error("Cannot calculate min of an empty array");
        return min;
    }
});

});


parcelRegister("d3O1R", function(module, exports) {

$parcel$export(module.exports, "createNode", function () { return $98225ce422b52328$export$270e7ba5936d3c48; });

var $1amHZ = parcelRequire("1amHZ");

var $5AhuD = parcelRequire("5AhuD");

var $7ITGG = parcelRequire("7ITGG");

var $2mPYl = parcelRequire("2mPYl");

var $kcYaK = parcelRequire("kcYaK");
function $98225ce422b52328$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $98225ce422b52328$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $98225ce422b52328$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $98225ce422b52328$var$_typeof(obj);
}
var $98225ce422b52328$var$name = "Node";
var $98225ce422b52328$var$dependencies = [
    "mathWithTransform"
];
var $98225ce422b52328$export$270e7ba5936d3c48 = /* #__PURE__ */ (0, $2mPYl.factory)($98225ce422b52328$var$name, $98225ce422b52328$var$dependencies, function(_ref) {
    var mathWithTransform = _ref.mathWithTransform;
    /**
   * Node
   */ function Node() {
        if (!(this instanceof Node)) throw new SyntaxError("Constructor must be called with the new operator");
    }
    /**
   * Evaluate the node
   * @param {Object} [scope]  Scope to read/write variables
   * @return {*}              Returns the result
   */ Node.prototype.evaluate = function(scope) {
        return this.compile().evaluate(scope);
    };
    /**
   * Evaluate the node
   * @param {Object} [scope]  Scope to read/write variables
   * @return {*}              Returns the result
   */ // TODO: Deprecated since v6.0.0. Clean up some day
    Node.prototype.eval = function(scope) {
        (0, $kcYaK.warnOnce)("Method Node.eval is renamed to Node.evaluate. Please use the new method name.");
        return this.evaluate(scope);
    };
    Node.prototype.type = "Node";
    Node.prototype.isNode = true;
    Node.prototype.comment = "";
    /**
   * Compile the node into an optimized, evauatable JavaScript function
   * @return {{evaluate: function([Object])}} object
   *                Returns an object with a function 'evaluate',
   *                which can be invoked as expr.evaluate([scope: Object]),
   *                where scope is an optional object with
   *                variables.
   */ Node.prototype.compile = function() {
        var expr = this._compile(mathWithTransform, {});
        var args = {};
        var context = null;
        function evaluate(scope) {
            var s = scope || {};
            _validateScope(s);
            return expr(s, args, context);
        }
        return {
            evaluate: evaluate,
            // TODO: Deprecated since v6.0.0. Clean up some day
            eval: function deprecatedEval(scope) {
                (0, $kcYaK.warnOnce)("Method eval is renamed to evaluate. Please use the new method.");
                return evaluate(scope);
            }
        };
    };
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ Node.prototype._compile = function(math, argNames) {
        throw new Error("Method _compile should be implemented by type " + this.type);
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ Node.prototype.forEach = function(callback) {
        // must be implemented by each of the Node implementations
        throw new Error("Cannot run forEach on a Node interface");
    };
    /**
   * Create a new Node having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node): Node} callback
   * @returns {OperatorNode} Returns a transformed copy of the node
   */ Node.prototype.map = function(callback) {
        // must be implemented by each of the Node implementations
        throw new Error("Cannot run map on a Node interface");
    };
    /**
   * Validate whether an object is a Node, for use with map
   * @param {Node} node
   * @returns {Node} Returns the input if it's a node, else throws an Error
   * @protected
   */ Node.prototype._ifNode = function(node) {
        if (!(0, $1amHZ.isNode)(node)) throw new TypeError("Callback function must return a Node");
        return node;
    };
    /**
   * Recursively traverse all nodes in a node tree. Executes given callback for
   * this node and each of its child nodes.
   * @param {function(node: Node, path: string, parent: Node)} callback
   *          A callback called for every node in the node tree.
   */ Node.prototype.traverse = function(callback) {
        // execute callback for itself
        callback(this, null, null); // eslint-disable-line standard/no-callback-literal
        // recursively traverse over all childs of a node
        function _traverse(node, callback) {
            node.forEach(function(child, path, parent) {
                callback(child, path, parent);
                _traverse(child, callback);
            });
        }
        _traverse(this, callback);
    };
    /**
   * Recursively transform a node tree via a transform function.
   *
   * For example, to replace all nodes of type SymbolNode having name 'x' with a
   * ConstantNode with value 2:
   *
   *     const res = Node.transform(function (node, path, parent) {
   *       if (node && node.isSymbolNode) && (node.name === 'x')) {
   *         return new ConstantNode(2)
   *       }
   *       else {
   *         return node
   *       }
   *     })
   *
   * @param {function(node: Node, path: string, parent: Node) : Node} callback
   *          A mapping function accepting a node, and returning
   *          a replacement for the node or the original node.
   *          Signature: callback(node: Node, index: string, parent: Node) : Node
   * @return {Node} Returns the original node or its replacement
   */ Node.prototype.transform = function(callback) {
        function _transform(child, path, parent) {
            var replacement = callback(child, path, parent);
            if (replacement !== child) // stop iterating when the node is replaced
            return replacement;
            return child.map(_transform);
        }
        return _transform(this, null, null);
    };
    /**
   * Find any node in the node tree matching given filter function. For example, to
   * find all nodes of type SymbolNode having name 'x':
   *
   *     const results = Node.filter(function (node) {
   *       return (node && node.isSymbolNode) && (node.name === 'x')
   *     })
   *
   * @param {function(node: Node, path: string, parent: Node) : Node} callback
   *            A test function returning true when a node matches, and false
   *            otherwise. Function signature:
   *            callback(node: Node, index: string, parent: Node) : boolean
   * @return {Node[]} nodes       An array with nodes matching given filter criteria
   */ Node.prototype.filter = function(callback) {
        var nodes = [];
        this.traverse(function(node, path, parent) {
            if (callback(node, path, parent)) nodes.push(node);
        });
        return nodes;
    }; // TODO: deprecated since version 1.1.0, remove this some day
    Node.prototype.find = function() {
        throw new Error("Function Node.find is deprecated. Use Node.filter instead.");
    }; // TODO: deprecated since version 1.1.0, remove this some day
    Node.prototype.match = function() {
        throw new Error("Function Node.match is deprecated. See functions Node.filter, Node.transform, Node.traverse.");
    };
    /**
   * Create a shallow clone of this node
   * @return {Node}
   */ Node.prototype.clone = function() {
        // must be implemented by each of the Node implementations
        throw new Error("Cannot clone a Node interface");
    };
    /**
   * Create a deep clone of this node
   * @return {Node}
   */ Node.prototype.cloneDeep = function() {
        return this.map(function(node) {
            return node.cloneDeep();
        });
    };
    /**
   * Deep compare this node with another node.
   * @param {Node} other
   * @return {boolean} Returns true when both nodes are of the same type and
   *                   contain the same values (as do their childs)
   */ Node.prototype.equals = function(other) {
        return other ? (0, $7ITGG.deepStrictEqual)(this, other) : false;
    };
    /**
   * Get string representation. (wrapper function)
   *
   * This function can get an object of the following form:
   * {
   *    handler: //This can be a callback function of the form
   *             // "function callback(node, options)"or
   *             // a map that maps function names (used in FunctionNodes)
   *             // to callbacks
   *    parenthesis: "keep" //the parenthesis option (This is optional)
   * }
   *
   * @param {Object} [options]
   * @return {string}
   */ Node.prototype.toString = function(options) {
        var customString;
        if (options && $98225ce422b52328$var$_typeof(options) === "object") switch($98225ce422b52328$var$_typeof(options.handler)){
            case "object":
            case "undefined":
                break;
            case "function":
                customString = options.handler(this, options);
                break;
            default:
                throw new TypeError("Object or function expected as callback");
        }
        if (typeof customString !== "undefined") return customString;
        return this._toString(options);
    };
    /**
   * Get a JSON representation of the node
   * Both .toJSON() and the static .fromJSON(json) should be implemented by all
   * implementations of Node
   * @returns {Object}
   */ Node.prototype.toJSON = function() {
        throw new Error("Cannot serialize object: toJSON not implemented by " + this.type);
    };
    /**
   * Get HTML representation. (wrapper function)
   *
   * This function can get an object of the following form:
   * {
   *    handler: //This can be a callback function of the form
   *             // "function callback(node, options)" or
   *             // a map that maps function names (used in FunctionNodes)
   *             // to callbacks
   *    parenthesis: "keep" //the parenthesis option (This is optional)
   * }
   *
   * @param {Object} [options]
   * @return {string}
   */ Node.prototype.toHTML = function(options) {
        var customString;
        if (options && $98225ce422b52328$var$_typeof(options) === "object") switch($98225ce422b52328$var$_typeof(options.handler)){
            case "object":
            case "undefined":
                break;
            case "function":
                customString = options.handler(this, options);
                break;
            default:
                throw new TypeError("Object or function expected as callback");
        }
        if (typeof customString !== "undefined") return customString;
        return this.toHTML(options);
    };
    /**
   * Internal function to generate the string output.
   * This has to be implemented by every Node
   *
   * @throws {Error}
   */ Node.prototype._toString = function() {
        // must be implemented by each of the Node implementations
        throw new Error("_toString not implemented for " + this.type);
    };
    /**
   * Get LaTeX representation. (wrapper function)
   *
   * This function can get an object of the following form:
   * {
   *    handler: //This can be a callback function of the form
   *             // "function callback(node, options)"or
   *             // a map that maps function names (used in FunctionNodes)
   *             // to callbacks
   *    parenthesis: "keep" //the parenthesis option (This is optional)
   * }
   *
   * @param {Object} [options]
   * @return {string}
   */ Node.prototype.toTex = function(options) {
        var customTex;
        if (options && $98225ce422b52328$var$_typeof(options) === "object") switch($98225ce422b52328$var$_typeof(options.handler)){
            case "object":
            case "undefined":
                break;
            case "function":
                customTex = options.handler(this, options);
                break;
            default:
                throw new TypeError("Object or function expected as callback");
        }
        if (typeof customTex !== "undefined") return customTex;
        return this._toTex(options);
    };
    /**
   * Internal function to generate the LaTeX output.
   * This has to be implemented by every Node
   *
   * @param {Object} [options]
   * @throws {Error}
   */ Node.prototype._toTex = function(options) {
        // must be implemented by each of the Node implementations
        throw new Error("_toTex not implemented for " + this.type);
    };
    /**
   * Get identifier.
   * @return {string}
   */ Node.prototype.getIdentifier = function() {
        return this.type;
    };
    /**
   * Get the content of the current Node.
   * @return {Node} node
   **/ Node.prototype.getContent = function() {
        return this;
    };
    /**
   * Validate the symbol names of a scope.
   * Throws an error when the scope contains an illegal symbol.
   * @param {Object} scope
   */ function _validateScope(scope) {
        for(var symbol in scope)if ((0, $7ITGG.hasOwnProperty)(scope, symbol)) {
            if (symbol in (0, $5AhuD.keywords)) throw new Error('Scope contains an illegal symbol, "' + symbol + '" is a reserved keyword');
        }
    }
    return Node;
}, {
    isClass: true,
    isNode: true
});

});
parcelRegister("kcYaK", function(module, exports) {

$parcel$export(module.exports, "warnOnce", function () { return $eb639a9ec06a8629$export$5b28268982f175ba; });
/**
 * Log a console.warn message only once
 */ var $eb639a9ec06a8629$export$5b28268982f175ba = function() {
    var messages = {};
    return function warnOnce() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var message = args.join(", ");
        if (!messages[message]) {
            var _console;
            messages[message] = true;
            (_console = console).warn.apply(_console, [
                "Warning:"
            ].concat(args));
        }
    };
}();

});


parcelRegister("fv3L7", function(module, exports) {

$parcel$export(module.exports, "createObjectNode", function () { return $b48caab8ef7f9e0d$export$385a7f4e27f173c4; });

var $1amHZ = parcelRequire("1amHZ");

var $6NxuJ = parcelRequire("6NxuJ");

var $45IYD = parcelRequire("45IYD");

var $7ITGG = parcelRequire("7ITGG");

var $2mPYl = parcelRequire("2mPYl");
function $b48caab8ef7f9e0d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $b48caab8ef7f9e0d$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $b48caab8ef7f9e0d$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $b48caab8ef7f9e0d$var$_typeof(obj);
}
var $b48caab8ef7f9e0d$var$name = "ObjectNode";
var $b48caab8ef7f9e0d$var$dependencies = [
    "Node"
];
var $b48caab8ef7f9e0d$export$385a7f4e27f173c4 = /* #__PURE__ */ (0, $2mPYl.factory)($b48caab8ef7f9e0d$var$name, $b48caab8ef7f9e0d$var$dependencies, function(_ref) {
    var Node = _ref.Node;
    /**
   * @constructor ObjectNode
   * @extends {Node}
   * Holds an object with keys/values
   * @param {Object.<string, Node>} [properties]   object with key/value pairs
   */ function ObjectNode(properties) {
        if (!(this instanceof ObjectNode)) throw new SyntaxError("Constructor must be called with the new operator");
        this.properties = properties || {}; // validate input
        if (properties) {
            if (!($b48caab8ef7f9e0d$var$_typeof(properties) === "object") || !Object.keys(properties).every(function(key) {
                return (0, $1amHZ.isNode)(properties[key]);
            })) throw new TypeError("Object containing Nodes expected");
        }
    }
    ObjectNode.prototype = new Node();
    ObjectNode.prototype.type = "ObjectNode";
    ObjectNode.prototype.isObjectNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ ObjectNode.prototype._compile = function(math, argNames) {
        var evalEntries = {};
        for(var key in this.properties)if ((0, $7ITGG.hasOwnProperty)(this.properties, key)) {
            // we stringify/parse the key here to resolve unicode characters,
            // so you cannot create a key like {"co\\u006Estructor": null}
            var stringifiedKey = (0, $6NxuJ.stringify)(key);
            var parsedKey = JSON.parse(stringifiedKey);
            if (!(0, $45IYD.isSafeProperty)(this.properties, parsedKey)) throw new Error('No access to property "' + parsedKey + '"');
            evalEntries[parsedKey] = this.properties[key]._compile(math, argNames);
        }
        return function evalObjectNode(scope, args, context) {
            var obj = {};
            for(var _key in evalEntries)if ((0, $7ITGG.hasOwnProperty)(evalEntries, _key)) obj[_key] = evalEntries[_key](scope, args, context);
            return obj;
        };
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ ObjectNode.prototype.forEach = function(callback) {
        for(var key in this.properties)if ((0, $7ITGG.hasOwnProperty)(this.properties, key)) callback(this.properties[key], "properties[" + (0, $6NxuJ.stringify)(key) + "]", this);
    };
    /**
   * Create a new ObjectNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node): Node} callback
   * @returns {ObjectNode} Returns a transformed copy of the node
   */ ObjectNode.prototype.map = function(callback) {
        var properties = {};
        for(var key in this.properties)if ((0, $7ITGG.hasOwnProperty)(this.properties, key)) properties[key] = this._ifNode(callback(this.properties[key], "properties[" + (0, $6NxuJ.stringify)(key) + "]", this));
        return new ObjectNode(properties);
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {ObjectNode}
   */ ObjectNode.prototype.clone = function() {
        var properties = {};
        for(var key in this.properties)if ((0, $7ITGG.hasOwnProperty)(this.properties, key)) properties[key] = this.properties[key];
        return new ObjectNode(properties);
    };
    /**
   * Get string representation
   * @param {Object} options
   * @return {string} str
   * @override
   */ ObjectNode.prototype._toString = function(options) {
        var entries = [];
        for(var key in this.properties)if ((0, $7ITGG.hasOwnProperty)(this.properties, key)) entries.push((0, $6NxuJ.stringify)(key) + ": " + this.properties[key].toString(options));
        return "{" + entries.join(", ") + "}";
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ ObjectNode.prototype.toJSON = function() {
        return {
            mathjs: "ObjectNode",
            properties: this.properties
        };
    };
    /**
   * Instantiate an OperatorNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "ObjectNode", "properties": {...}}`,
   *                       where mathjs is optional
   * @returns {ObjectNode}
   */ ObjectNode.fromJSON = function(json) {
        return new ObjectNode(json.properties);
    };
    /**
   * Get HTML representation
   * @param {Object} options
   * @return {string} str
   * @override
   */ ObjectNode.prototype.toHTML = function(options) {
        var entries = [];
        for(var key in this.properties)if ((0, $7ITGG.hasOwnProperty)(this.properties, key)) entries.push('<span class="math-symbol math-property">' + (0, $6NxuJ.escape)(key) + "</span>" + '<span class="math-operator math-assignment-operator math-property-assignment-operator math-binary-operator">:</span>' + this.properties[key].toHTML(options));
        return '<span class="math-parenthesis math-curly-parenthesis">{</span>' + entries.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-curly-parenthesis">}</span>';
    };
    /**
   * Get LaTeX representation
   * @param {Object} options
   * @return {string} str
   */ ObjectNode.prototype._toTex = function(options) {
        var entries = [];
        for(var key in this.properties)if ((0, $7ITGG.hasOwnProperty)(this.properties, key)) entries.push("\\mathbf{" + key + ":} & " + this.properties[key].toTex(options) + "\\\\");
        return "\\left\\{\\begin{array}{ll}".concat(entries.join("\n"), "\\end{array}\\right\\}");
    };
    return ObjectNode;
}, {
    isClass: true,
    isNode: true
});

});

parcelRegister("e771R", function(module, exports) {

$parcel$export(module.exports, "createOperatorNode", function () { return $a4672bf7e3164af1$export$aa95756bacab93d; });

var $1amHZ = parcelRequire("1amHZ");

var $5WdrK = parcelRequire("5WdrK");

var $6NxuJ = parcelRequire("6NxuJ");

var $45IYD = parcelRequire("45IYD");

var $cAxNq = parcelRequire("cAxNq");

var $6Zo9s = parcelRequire("6Zo9s");

var $2mPYl = parcelRequire("2mPYl");
var $a4672bf7e3164af1$var$name = "OperatorNode";
var $a4672bf7e3164af1$var$dependencies = [
    "Node"
];
var $a4672bf7e3164af1$export$aa95756bacab93d = /* #__PURE__ */ (0, $2mPYl.factory)($a4672bf7e3164af1$var$name, $a4672bf7e3164af1$var$dependencies, function(_ref) {
    var Node = _ref.Node;
    /**
   * @constructor OperatorNode
   * @extends {Node}
   * An operator with two arguments, like 2+3
   *
   * @param {string} op           Operator name, for example '+'
   * @param {string} fn           Function name, for example 'add'
   * @param {Node[]} args         Operator arguments
   * @param {boolean} [implicit]  Is this an implicit multiplication?
   */ function OperatorNode(op, fn, args, implicit) {
        if (!(this instanceof OperatorNode)) throw new SyntaxError("Constructor must be called with the new operator");
         // validate input
        if (typeof op !== "string") throw new TypeError('string expected for parameter "op"');
        if (typeof fn !== "string") throw new TypeError('string expected for parameter "fn"');
        if (!Array.isArray(args) || !args.every((0, $1amHZ.isNode))) throw new TypeError('Array containing Nodes expected for parameter "args"');
        this.implicit = implicit === true;
        this.op = op;
        this.fn = fn;
        this.args = args || [];
    }
    OperatorNode.prototype = new Node();
    OperatorNode.prototype.type = "OperatorNode";
    OperatorNode.prototype.isOperatorNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ OperatorNode.prototype._compile = function(math, argNames) {
        // validate fn
        if (typeof this.fn !== "string" || !(0, $45IYD.isSafeMethod)(math, this.fn)) {
            if (!math[this.fn]) throw new Error("Function " + this.fn + ' missing in provided namespace "math"');
            else throw new Error('No access to function "' + this.fn + '"');
        }
        var fn = (0, $45IYD.getSafeProperty)(math, this.fn);
        var evalArgs = (0, $5WdrK.map)(this.args, function(arg) {
            return arg._compile(math, argNames);
        });
        if (evalArgs.length === 1) {
            var evalArg0 = evalArgs[0];
            return function evalOperatorNode(scope, args, context) {
                return fn(evalArg0(scope, args, context));
            };
        } else if (evalArgs.length === 2) {
            var _evalArg = evalArgs[0];
            var evalArg1 = evalArgs[1];
            return function evalOperatorNode(scope, args, context) {
                return fn(_evalArg(scope, args, context), evalArg1(scope, args, context));
            };
        } else return function evalOperatorNode(scope, args, context) {
            return fn.apply(null, (0, $5WdrK.map)(evalArgs, function(evalArg) {
                return evalArg(scope, args, context);
            }));
        };
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ OperatorNode.prototype.forEach = function(callback) {
        for(var i = 0; i < this.args.length; i++)callback(this.args[i], "args[" + i + "]", this);
    };
    /**
   * Create a new OperatorNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node): Node} callback
   * @returns {OperatorNode} Returns a transformed copy of the node
   */ OperatorNode.prototype.map = function(callback) {
        var args = [];
        for(var i = 0; i < this.args.length; i++)args[i] = this._ifNode(callback(this.args[i], "args[" + i + "]", this));
        return new OperatorNode(this.op, this.fn, args, this.implicit);
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {OperatorNode}
   */ OperatorNode.prototype.clone = function() {
        return new OperatorNode(this.op, this.fn, this.args.slice(0), this.implicit);
    };
    /**
   * Check whether this is an unary OperatorNode:
   * has exactly one argument, like `-a`.
   * @return {boolean} Returns true when an unary operator node, false otherwise.
   */ OperatorNode.prototype.isUnary = function() {
        return this.args.length === 1;
    };
    /**
   * Check whether this is a binary OperatorNode:
   * has exactly two arguments, like `a + b`.
   * @return {boolean} Returns true when a binary operator node, false otherwise.
   */ OperatorNode.prototype.isBinary = function() {
        return this.args.length === 2;
    };
    /**
   * Calculate which parentheses are necessary. Gets an OperatorNode
   * (which is the root of the tree) and an Array of Nodes
   * (this.args) and returns an array where 'true' means that an argument
   * has to be enclosed in parentheses whereas 'false' means the opposite.
   *
   * @param {OperatorNode} root
   * @param {string} parenthesis
   * @param {Node[]} args
   * @param {boolean} latex
   * @return {boolean[]}
   * @private
   */ function calculateNecessaryParentheses(root, parenthesis, implicit, args, latex) {
        // precedence of the root OperatorNode
        var precedence = (0, $cAxNq.getPrecedence)(root, parenthesis);
        var associativity = (0, $cAxNq.getAssociativity)(root, parenthesis);
        if (parenthesis === "all" || args.length > 2 && root.getIdentifier() !== "OperatorNode:add" && root.getIdentifier() !== "OperatorNode:multiply") return args.map(function(arg) {
            switch(arg.getContent().type){
                // Nodes that don't need extra parentheses
                case "ArrayNode":
                case "ConstantNode":
                case "SymbolNode":
                case "ParenthesisNode":
                    return false;
                default:
                    return true;
            }
        });
        var result;
        switch(args.length){
            case 0:
                result = [];
                break;
            case 1:
                // precedence of the operand
                var operandPrecedence = (0, $cAxNq.getPrecedence)(args[0], parenthesis); // handle special cases for LaTeX, where some of the parentheses aren't needed
                if (latex && operandPrecedence !== null) {
                    var operandIdentifier;
                    var rootIdentifier;
                    if (parenthesis === "keep") {
                        operandIdentifier = args[0].getIdentifier();
                        rootIdentifier = root.getIdentifier();
                    } else {
                        // Ignore Parenthesis Nodes when not in 'keep' mode
                        operandIdentifier = args[0].getContent().getIdentifier();
                        rootIdentifier = root.getContent().getIdentifier();
                    }
                    if ((0, $cAxNq.properties)[precedence][rootIdentifier].latexLeftParens === false) {
                        result = [
                            false
                        ];
                        break;
                    }
                    if ((0, $cAxNq.properties)[operandPrecedence][operandIdentifier].latexParens === false) {
                        result = [
                            false
                        ];
                        break;
                    }
                }
                if (operandPrecedence === null) {
                    // if the operand has no defined precedence, no parens are needed
                    result = [
                        false
                    ];
                    break;
                }
                if (operandPrecedence <= precedence) {
                    // if the operands precedence is lower, parens are needed
                    result = [
                        true
                    ];
                    break;
                } // otherwise, no parens needed
                result = [
                    false
                ];
                break;
            case 2:
                var lhsParens; // left hand side needs parenthesis?
                // precedence of the left hand side
                var lhsPrecedence = (0, $cAxNq.getPrecedence)(args[0], parenthesis); // is the root node associative with the left hand side
                var assocWithLhs = (0, $cAxNq.isAssociativeWith)(root, args[0], parenthesis);
                if (lhsPrecedence === null) // if the left hand side has no defined precedence, no parens are needed
                // FunctionNode for example
                lhsParens = false;
                else if (lhsPrecedence === precedence && associativity === "right" && !assocWithLhs) // In case of equal precedence, if the root node is left associative
                // parens are **never** necessary for the left hand side.
                // If it is right associative however, parens are necessary
                // if the root node isn't associative with the left hand side
                lhsParens = true;
                else if (lhsPrecedence < precedence) lhsParens = true;
                else lhsParens = false;
                var rhsParens; // right hand side needs parenthesis?
                // precedence of the right hand side
                var rhsPrecedence = (0, $cAxNq.getPrecedence)(args[1], parenthesis); // is the root node associative with the right hand side?
                var assocWithRhs = (0, $cAxNq.isAssociativeWith)(root, args[1], parenthesis);
                if (rhsPrecedence === null) // if the right hand side has no defined precedence, no parens are needed
                // FunctionNode for example
                rhsParens = false;
                else if (rhsPrecedence === precedence && associativity === "left" && !assocWithRhs) // In case of equal precedence, if the root node is right associative
                // parens are **never** necessary for the right hand side.
                // If it is left associative however, parens are necessary
                // if the root node isn't associative with the right hand side
                rhsParens = true;
                else if (rhsPrecedence < precedence) rhsParens = true;
                else rhsParens = false;
                 // handle special cases for LaTeX, where some of the parentheses aren't needed
                if (latex) {
                    var _rootIdentifier;
                    var lhsIdentifier;
                    var rhsIdentifier;
                    if (parenthesis === "keep") {
                        _rootIdentifier = root.getIdentifier();
                        lhsIdentifier = root.args[0].getIdentifier();
                        rhsIdentifier = root.args[1].getIdentifier();
                    } else {
                        // Ignore ParenthesisNodes when not in 'keep' mode
                        _rootIdentifier = root.getContent().getIdentifier();
                        lhsIdentifier = root.args[0].getContent().getIdentifier();
                        rhsIdentifier = root.args[1].getContent().getIdentifier();
                    }
                    if (lhsPrecedence !== null) {
                        if ((0, $cAxNq.properties)[precedence][_rootIdentifier].latexLeftParens === false) lhsParens = false;
                        if ((0, $cAxNq.properties)[lhsPrecedence][lhsIdentifier].latexParens === false) lhsParens = false;
                    }
                    if (rhsPrecedence !== null) {
                        if ((0, $cAxNq.properties)[precedence][_rootIdentifier].latexRightParens === false) rhsParens = false;
                        if ((0, $cAxNq.properties)[rhsPrecedence][rhsIdentifier].latexParens === false) rhsParens = false;
                    }
                }
                result = [
                    lhsParens,
                    rhsParens
                ];
                break;
            default:
                if (root.getIdentifier() === "OperatorNode:add" || root.getIdentifier() === "OperatorNode:multiply") result = args.map(function(arg) {
                    var argPrecedence = (0, $cAxNq.getPrecedence)(arg, parenthesis);
                    var assocWithArg = (0, $cAxNq.isAssociativeWith)(root, arg, parenthesis);
                    var argAssociativity = (0, $cAxNq.getAssociativity)(arg, parenthesis);
                    if (argPrecedence === null) // if the argument has no defined precedence, no parens are needed
                    return false;
                    else if (precedence === argPrecedence && associativity === argAssociativity && !assocWithArg) return true;
                    else if (argPrecedence < precedence) return true;
                    return false;
                });
                break;
        } // handles an edge case of 'auto' parentheses with implicit multiplication of ConstantNode
        // In that case print parentheses for ParenthesisNodes even though they normally wouldn't be
        // printed.
        if (args.length >= 2 && root.getIdentifier() === "OperatorNode:multiply" && root.implicit && parenthesis === "auto" && implicit === "hide") result = args.map(function(arg, index) {
            var isParenthesisNode = arg.getIdentifier() === "ParenthesisNode";
            if (result[index] || isParenthesisNode) // put in parenthesis?
            return true;
            return false;
        });
        return result;
    }
    /**
   * Get string representation.
   * @param {Object} options
   * @return {string} str
   */ OperatorNode.prototype._toString = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var implicit = options && options.implicit ? options.implicit : "hide";
        var args = this.args;
        var parens = calculateNecessaryParentheses(this, parenthesis, implicit, args, false);
        if (args.length === 1) {
            // unary operators
            var assoc = (0, $cAxNq.getAssociativity)(this, parenthesis);
            var operand = args[0].toString(options);
            if (parens[0]) operand = "(" + operand + ")";
             // for example for "not", we want a space between operand and argument
            var opIsNamed = /[a-zA-Z]+/.test(this.op);
            if (assoc === "right") // prefix operator
            return this.op + (opIsNamed ? " " : "") + operand;
            else if (assoc === "left") // postfix
            return operand + (opIsNamed ? " " : "") + this.op;
             // fall back to postfix
            return operand + this.op;
        } else if (args.length === 2) {
            var lhs = args[0].toString(options); // left hand side
            var rhs = args[1].toString(options); // right hand side
            if (parens[0]) // left hand side in parenthesis?
            lhs = "(" + lhs + ")";
            if (parens[1]) // right hand side in parenthesis?
            rhs = "(" + rhs + ")";
            if (this.implicit && this.getIdentifier() === "OperatorNode:multiply" && implicit === "hide") return lhs + " " + rhs;
            return lhs + " " + this.op + " " + rhs;
        } else if (args.length > 2 && (this.getIdentifier() === "OperatorNode:add" || this.getIdentifier() === "OperatorNode:multiply")) {
            var stringifiedArgs = args.map(function(arg, index) {
                arg = arg.toString(options);
                if (parens[index]) // put in parenthesis?
                arg = "(" + arg + ")";
                return arg;
            });
            if (this.implicit && this.getIdentifier() === "OperatorNode:multiply" && implicit === "hide") return stringifiedArgs.join(" ");
            return stringifiedArgs.join(" " + this.op + " ");
        } else // fallback to formatting as a function call
        return this.fn + "(" + this.args.join(", ") + ")";
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ OperatorNode.prototype.toJSON = function() {
        return {
            mathjs: "OperatorNode",
            op: this.op,
            fn: this.fn,
            args: this.args,
            implicit: this.implicit
        };
    };
    /**
   * Instantiate an OperatorNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "OperatorNode", "op": "+", "fn": "add", "args": [...], "implicit": false}`,
   *                       where mathjs is optional
   * @returns {OperatorNode}
   */ OperatorNode.fromJSON = function(json) {
        return new OperatorNode(json.op, json.fn, json.args, json.implicit);
    };
    /**
   * Get HTML representation.
   * @param {Object} options
   * @return {string} str
   */ OperatorNode.prototype.toHTML = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var implicit = options && options.implicit ? options.implicit : "hide";
        var args = this.args;
        var parens = calculateNecessaryParentheses(this, parenthesis, implicit, args, false);
        if (args.length === 1) {
            // unary operators
            var assoc = (0, $cAxNq.getAssociativity)(this, parenthesis);
            var operand = args[0].toHTML(options);
            if (parens[0]) operand = '<span class="math-parenthesis math-round-parenthesis">(</span>' + operand + '<span class="math-parenthesis math-round-parenthesis">)</span>';
            if (assoc === "right") // prefix operator
            return '<span class="math-operator math-unary-operator math-lefthand-unary-operator">' + (0, $6NxuJ.escape)(this.op) + "</span>" + operand;
            else // postfix when assoc === 'left' or undefined
            return operand + '<span class="math-operator math-unary-operator math-righthand-unary-operator">' + (0, $6NxuJ.escape)(this.op) + "</span>";
        } else if (args.length === 2) {
            // binary operatoes
            var lhs = args[0].toHTML(options); // left hand side
            var rhs = args[1].toHTML(options); // right hand side
            if (parens[0]) // left hand side in parenthesis?
            lhs = '<span class="math-parenthesis math-round-parenthesis">(</span>' + lhs + '<span class="math-parenthesis math-round-parenthesis">)</span>';
            if (parens[1]) // right hand side in parenthesis?
            rhs = '<span class="math-parenthesis math-round-parenthesis">(</span>' + rhs + '<span class="math-parenthesis math-round-parenthesis">)</span>';
            if (this.implicit && this.getIdentifier() === "OperatorNode:multiply" && implicit === "hide") return lhs + '<span class="math-operator math-binary-operator math-implicit-binary-operator"></span>' + rhs;
            return lhs + '<span class="math-operator math-binary-operator math-explicit-binary-operator">' + (0, $6NxuJ.escape)(this.op) + "</span>" + rhs;
        } else {
            var stringifiedArgs = args.map(function(arg, index) {
                arg = arg.toHTML(options);
                if (parens[index]) // put in parenthesis?
                arg = '<span class="math-parenthesis math-round-parenthesis">(</span>' + arg + '<span class="math-parenthesis math-round-parenthesis">)</span>';
                return arg;
            });
            if (args.length > 2 && (this.getIdentifier() === "OperatorNode:add" || this.getIdentifier() === "OperatorNode:multiply")) {
                if (this.implicit && this.getIdentifier() === "OperatorNode:multiply" && implicit === "hide") return stringifiedArgs.join('<span class="math-operator math-binary-operator math-implicit-binary-operator"></span>');
                return stringifiedArgs.join('<span class="math-operator math-binary-operator math-explicit-binary-operator">' + (0, $6NxuJ.escape)(this.op) + "</span>");
            } else // fallback to formatting as a function call
            return '<span class="math-function">' + (0, $6NxuJ.escape)(this.fn) + '</span><span class="math-paranthesis math-round-parenthesis">(</span>' + stringifiedArgs.join('<span class="math-separator">,</span>') + '<span class="math-paranthesis math-round-parenthesis">)</span>';
        }
    };
    /**
   * Get LaTeX representation
   * @param {Object} options
   * @return {string} str
   */ OperatorNode.prototype._toTex = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var implicit = options && options.implicit ? options.implicit : "hide";
        var args = this.args;
        var parens = calculateNecessaryParentheses(this, parenthesis, implicit, args, true);
        var op = (0, $6Zo9s.latexOperators)[this.fn];
        op = typeof op === "undefined" ? this.op : op; // fall back to using this.op
        if (args.length === 1) {
            // unary operators
            var assoc = (0, $cAxNq.getAssociativity)(this, parenthesis);
            var operand = args[0].toTex(options);
            if (parens[0]) operand = "\\left(".concat(operand, "\\right)");
            if (assoc === "right") // prefix operator
            return op + operand;
            else if (assoc === "left") // postfix operator
            return operand + op;
             // fall back to postfix
            return operand + op;
        } else if (args.length === 2) {
            // binary operators
            var lhs = args[0]; // left hand side
            var lhsTex = lhs.toTex(options);
            if (parens[0]) lhsTex = "\\left(".concat(lhsTex, "\\right)");
            var rhs = args[1]; // right hand side
            var rhsTex = rhs.toTex(options);
            if (parens[1]) rhsTex = "\\left(".concat(rhsTex, "\\right)");
             // handle some exceptions (due to the way LaTeX works)
            var lhsIdentifier;
            if (parenthesis === "keep") lhsIdentifier = lhs.getIdentifier();
            else // Ignore ParenthesisNodes if in 'keep' mode
            lhsIdentifier = lhs.getContent().getIdentifier();
            switch(this.getIdentifier()){
                case "OperatorNode:divide":
                    // op contains '\\frac' at this point
                    return op + "{" + lhsTex + "}" + "{" + rhsTex + "}";
                case "OperatorNode:pow":
                    lhsTex = "{" + lhsTex + "}";
                    rhsTex = "{" + rhsTex + "}";
                    switch(lhsIdentifier){
                        case "ConditionalNode":
                        case "OperatorNode:divide":
                            lhsTex = "\\left(".concat(lhsTex, "\\right)");
                    }
                    break;
                case "OperatorNode:multiply":
                    if (this.implicit && implicit === "hide") return lhsTex + "~" + rhsTex;
            }
            return lhsTex + op + rhsTex;
        } else if (args.length > 2 && (this.getIdentifier() === "OperatorNode:add" || this.getIdentifier() === "OperatorNode:multiply")) {
            var texifiedArgs = args.map(function(arg, index) {
                arg = arg.toTex(options);
                if (parens[index]) arg = "\\left(".concat(arg, "\\right)");
                return arg;
            });
            if (this.getIdentifier() === "OperatorNode:multiply" && this.implicit) return texifiedArgs.join("~");
            return texifiedArgs.join(op);
        } else // fall back to formatting as a function call
        // as this is a fallback, it doesn't use
        // fancy function names
        return "\\mathrm{" + this.fn + "}\\left(" + args.map(function(arg) {
            return arg.toTex(options);
        }).join(",") + "\\right)";
    };
    /**
   * Get identifier.
   * @return {string}
   */ OperatorNode.prototype.getIdentifier = function() {
        return this.type + ":" + this.fn;
    };
    return OperatorNode;
}, {
    isClass: true,
    isNode: true
});

});

parcelRegister("jRgnt", function(module, exports) {

$parcel$export(module.exports, "createParenthesisNode", function () { return $e74fabcd00cebed6$export$9bf5d3d4ef922b0c; });

var $1amHZ = parcelRequire("1amHZ");

var $2mPYl = parcelRequire("2mPYl");
var $e74fabcd00cebed6$var$name = "ParenthesisNode";
var $e74fabcd00cebed6$var$dependencies = [
    "Node"
];
var $e74fabcd00cebed6$export$9bf5d3d4ef922b0c = /* #__PURE__ */ (0, $2mPYl.factory)($e74fabcd00cebed6$var$name, $e74fabcd00cebed6$var$dependencies, function(_ref) {
    var Node = _ref.Node;
    /**
   * @constructor ParenthesisNode
   * @extends {Node}
   * A parenthesis node describes manual parenthesis from the user input
   * @param {Node} content
   * @extends {Node}
   */ function ParenthesisNode(content) {
        if (!(this instanceof ParenthesisNode)) throw new SyntaxError("Constructor must be called with the new operator");
         // validate input
        if (!(0, $1amHZ.isNode)(content)) throw new TypeError('Node expected for parameter "content"');
        this.content = content;
    }
    ParenthesisNode.prototype = new Node();
    ParenthesisNode.prototype.type = "ParenthesisNode";
    ParenthesisNode.prototype.isParenthesisNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ ParenthesisNode.prototype._compile = function(math, argNames) {
        return this.content._compile(math, argNames);
    };
    /**
   * Get the content of the current Node.
   * @return {Node} content
   * @override
   **/ ParenthesisNode.prototype.getContent = function() {
        return this.content.getContent();
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ ParenthesisNode.prototype.forEach = function(callback) {
        callback(this.content, "content", this);
    };
    /**
   * Create a new ParenthesisNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node) : Node} callback
   * @returns {ParenthesisNode} Returns a clone of the node
   */ ParenthesisNode.prototype.map = function(callback) {
        var content = callback(this.content, "content", this);
        return new ParenthesisNode(content);
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {ParenthesisNode}
   */ ParenthesisNode.prototype.clone = function() {
        return new ParenthesisNode(this.content);
    };
    /**
   * Get string representation
   * @param {Object} options
   * @return {string} str
   * @override
   */ ParenthesisNode.prototype._toString = function(options) {
        if (!options || options && !options.parenthesis || options && options.parenthesis === "keep") return "(" + this.content.toString(options) + ")";
        return this.content.toString(options);
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ ParenthesisNode.prototype.toJSON = function() {
        return {
            mathjs: "ParenthesisNode",
            content: this.content
        };
    };
    /**
   * Instantiate an ParenthesisNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "ParenthesisNode", "content": ...}`,
   *                       where mathjs is optional
   * @returns {ParenthesisNode}
   */ ParenthesisNode.fromJSON = function(json) {
        return new ParenthesisNode(json.content);
    };
    /**
   * Get HTML representation
   * @param {Object} options
   * @return {string} str
   * @override
   */ ParenthesisNode.prototype.toHTML = function(options) {
        if (!options || options && !options.parenthesis || options && options.parenthesis === "keep") return '<span class="math-parenthesis math-round-parenthesis">(</span>' + this.content.toHTML(options) + '<span class="math-parenthesis math-round-parenthesis">)</span>';
        return this.content.toHTML(options);
    };
    /**
   * Get LaTeX representation
   * @param {Object} options
   * @return {string} str
   * @override
   */ ParenthesisNode.prototype._toTex = function(options) {
        if (!options || options && !options.parenthesis || options && options.parenthesis === "keep") return "\\left(".concat(this.content.toTex(options), "\\right)");
        return this.content.toTex(options);
    };
    return ParenthesisNode;
}, {
    isClass: true,
    isNode: true
});

});

parcelRegister("e4Jrf", function(module, exports) {

$parcel$export(module.exports, "createParse", function () { return $a3f4af8c9a89557d$export$fef7a8850e50b7; });

var $2mPYl = parcelRequire("2mPYl");

var $1amHZ = parcelRequire("1amHZ");

var $e04i1 = parcelRequire("e04i1");

var $7ITGG = parcelRequire("7ITGG");
function $a3f4af8c9a89557d$var$_extends() {
    $a3f4af8c9a89557d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a3f4af8c9a89557d$var$_extends.apply(this, arguments);
}
var $a3f4af8c9a89557d$var$name = "parse";
var $a3f4af8c9a89557d$var$dependencies = [
    "typed",
    "numeric",
    "config",
    "AccessorNode",
    "ArrayNode",
    "AssignmentNode",
    "BlockNode",
    "ConditionalNode",
    "ConstantNode",
    "FunctionAssignmentNode",
    "FunctionNode",
    "IndexNode",
    "ObjectNode",
    "OperatorNode",
    "ParenthesisNode",
    "RangeNode",
    "RelationalNode",
    "SymbolNode"
];
var $a3f4af8c9a89557d$export$fef7a8850e50b7 = /* #__PURE__ */ (0, $2mPYl.factory)($a3f4af8c9a89557d$var$name, $a3f4af8c9a89557d$var$dependencies, function(_ref) {
    var typed = _ref.typed, numeric = _ref.numeric, config = _ref.config, AccessorNode = _ref.AccessorNode, ArrayNode = _ref.ArrayNode, AssignmentNode = _ref.AssignmentNode, BlockNode = _ref.BlockNode, ConditionalNode = _ref.ConditionalNode, ConstantNode = _ref.ConstantNode, FunctionAssignmentNode = _ref.FunctionAssignmentNode, FunctionNode = _ref.FunctionNode, IndexNode = _ref.IndexNode, ObjectNode = _ref.ObjectNode, OperatorNode = _ref.OperatorNode, ParenthesisNode = _ref.ParenthesisNode, RangeNode = _ref.RangeNode, RelationalNode = _ref.RelationalNode, SymbolNode = _ref.SymbolNode;
    /**
   * Parse an expression. Returns a node tree, which can be evaluated by
   * invoking node.evaluate().
   *
   * Note the evaluating arbitrary expressions may involve security risks,
   * see [https://mathjs.org/docs/expressions/security.html](https://mathjs.org/docs/expressions/security.html) for more information.
   *
   * Syntax:
   *
   *     math.parse(expr)
   *     math.parse(expr, options)
   *     math.parse([expr1, expr2, expr3, ...])
   *     math.parse([expr1, expr2, expr3, ...], options)
   *
   * Example:
   *
   *     const node1 = math.parse('sqrt(3^2 + 4^2)')
   *     node1.compile().evaluate() // 5
   *
   *     let scope = {a:3, b:4}
   *     const node2 = math.parse('a * b') // 12
   *     const code2 = node2.compile()
   *     code2.evaluate(scope) // 12
   *     scope.a = 5
   *     code2.evaluate(scope) // 20
   *
   *     const nodes = math.parse(['a = 3', 'b = 4', 'a * b'])
   *     nodes[2].compile().evaluate() // 12
   *
   * See also:
   *
   *     evaluate, compile
   *
   * @param {string | string[] | Matrix} expr          Expression to be parsed
   * @param {{nodes: Object<string, Node>}} [options]  Available options:
   *                                                   - `nodes` a set of custom nodes
   * @return {Node | Node[]} node
   * @throws {Error}
   */ var parse = typed($a3f4af8c9a89557d$var$name, {
        string: function string(expression) {
            return parseStart(expression, {});
        },
        "Array | Matrix": function ArrayMatrix(expressions) {
            return parseMultiple(expressions, {});
        },
        "string, Object": function stringObject(expression, options) {
            var extraNodes = options.nodes !== undefined ? options.nodes : {};
            return parseStart(expression, extraNodes);
        },
        "Array | Matrix, Object": parseMultiple
    });
    function parseMultiple(expressions) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var extraNodes = options.nodes !== undefined ? options.nodes : {}; // parse an array or matrix with expressions
        return (0, $e04i1.deepMap)(expressions, function(elem) {
            if (typeof elem !== "string") throw new TypeError("String expected");
            return parseStart(elem, extraNodes);
        });
    } // token types enumeration
    var TOKENTYPE = {
        NULL: 0,
        DELIMITER: 1,
        NUMBER: 2,
        SYMBOL: 3,
        UNKNOWN: 4
    }; // map with all delimiters
    var DELIMITERS = {
        ",": true,
        "(": true,
        ")": true,
        "[": true,
        "]": true,
        "{": true,
        "}": true,
        '"': true,
        "'": true,
        ";": true,
        "+": true,
        "-": true,
        "*": true,
        ".*": true,
        "/": true,
        "./": true,
        "%": true,
        "^": true,
        ".^": true,
        "~": true,
        "!": true,
        "&": true,
        "|": true,
        "^|": true,
        "=": true,
        ":": true,
        "?": true,
        "==": true,
        "!=": true,
        "<": true,
        ">": true,
        "<=": true,
        ">=": true,
        "<<": true,
        ">>": true,
        ">>>": true
    }; // map with all named delimiters
    var NAMED_DELIMITERS = {
        mod: true,
        to: true,
        "in": true,
        and: true,
        xor: true,
        or: true,
        not: true
    };
    var CONSTANTS = {
        "true": true,
        "false": false,
        "null": null,
        undefined: undefined
    };
    var NUMERIC_CONSTANTS = [
        "NaN",
        "Infinity"
    ];
    function initialState() {
        return {
            extraNodes: {},
            // current extra nodes, must be careful not to mutate
            expression: "",
            // current expression
            comment: "",
            // last parsed comment
            index: 0,
            // current index in expr
            token: "",
            // current token
            tokenType: TOKENTYPE.NULL,
            // type of the token
            nestingLevel: 0,
            // level of nesting inside parameters, used to ignore newline characters
            conditionalLevel: null // when a conditional is being parsed, the level of the conditional is stored here
        };
    }
    /**
   * View upto `length` characters of the expression starting at the current character.
   *
   * @param {Object} state
   * @param {number} [length=1] Number of characters to view
   * @returns {string}
   * @private
   */ function currentString(state, length) {
        return state.expression.substr(state.index, length);
    }
    /**
   * View the current character. Returns '' if end of expression is reached.
   *
   * @param {Object} state
   * @returns {string}
   * @private
   */ function currentCharacter(state) {
        return currentString(state, 1);
    }
    /**
   * Get the next character from the expression.
   * The character is stored into the char c. If the end of the expression is
   * reached, the function puts an empty string in c.
   * @private
   */ function next(state) {
        state.index++;
    }
    /**
   * Preview the previous character from the expression.
   * @return {string} cNext
   * @private
   */ function prevCharacter(state) {
        return state.expression.charAt(state.index - 1);
    }
    /**
   * Preview the next character from the expression.
   * @return {string} cNext
   * @private
   */ function nextCharacter(state) {
        return state.expression.charAt(state.index + 1);
    }
    /**
   * Get next token in the current string expr.
   * The token and token type are available as token and tokenType
   * @private
   */ function getToken(state) {
        state.tokenType = TOKENTYPE.NULL;
        state.token = "";
        state.comment = ""; // skip over whitespaces
        // space, tab, and newline when inside parameters
        while(parse.isWhitespace(currentCharacter(state), state.nestingLevel))next(state);
         // skip comment
        if (currentCharacter(state) === "#") while(currentCharacter(state) !== "\n" && currentCharacter(state) !== ""){
            state.comment += currentCharacter(state);
            next(state);
        }
         // check for end of expression
        if (currentCharacter(state) === "") {
            // token is still empty
            state.tokenType = TOKENTYPE.DELIMITER;
            return;
        } // check for new line character
        if (currentCharacter(state) === "\n" && !state.nestingLevel) {
            state.tokenType = TOKENTYPE.DELIMITER;
            state.token = currentCharacter(state);
            next(state);
            return;
        }
        var c1 = currentCharacter(state);
        var c2 = currentString(state, 2);
        var c3 = currentString(state, 3);
        if (c3.length === 3 && DELIMITERS[c3]) {
            state.tokenType = TOKENTYPE.DELIMITER;
            state.token = c3;
            next(state);
            next(state);
            next(state);
            return;
        } // check for delimiters consisting of 2 characters
        if (c2.length === 2 && DELIMITERS[c2]) {
            state.tokenType = TOKENTYPE.DELIMITER;
            state.token = c2;
            next(state);
            next(state);
            return;
        } // check for delimiters consisting of 1 character
        if (DELIMITERS[c1]) {
            state.tokenType = TOKENTYPE.DELIMITER;
            state.token = c1;
            next(state);
            return;
        } // check for a number
        if (parse.isDigitDot(c1)) {
            state.tokenType = TOKENTYPE.NUMBER; // get number, can have a single dot
            if (currentCharacter(state) === ".") {
                state.token += currentCharacter(state);
                next(state);
                if (!parse.isDigit(currentCharacter(state))) // this is no number, it is just a dot (can be dot notation)
                state.tokenType = TOKENTYPE.DELIMITER;
            } else {
                while(parse.isDigit(currentCharacter(state))){
                    state.token += currentCharacter(state);
                    next(state);
                }
                if (parse.isDecimalMark(currentCharacter(state), nextCharacter(state))) {
                    state.token += currentCharacter(state);
                    next(state);
                }
            }
            while(parse.isDigit(currentCharacter(state))){
                state.token += currentCharacter(state);
                next(state);
            } // check for exponential notation like "2.3e-4", "1.23e50" or "2e+4"
            if (currentCharacter(state) === "E" || currentCharacter(state) === "e") {
                if (parse.isDigit(nextCharacter(state)) || nextCharacter(state) === "-" || nextCharacter(state) === "+") {
                    state.token += currentCharacter(state);
                    next(state);
                    if (currentCharacter(state) === "+" || currentCharacter(state) === "-") {
                        state.token += currentCharacter(state);
                        next(state);
                    } // Scientific notation MUST be followed by an exponent
                    if (!parse.isDigit(currentCharacter(state))) throw createSyntaxError(state, 'Digit expected, got "' + currentCharacter(state) + '"');
                    while(parse.isDigit(currentCharacter(state))){
                        state.token += currentCharacter(state);
                        next(state);
                    }
                    if (parse.isDecimalMark(currentCharacter(state), nextCharacter(state))) throw createSyntaxError(state, 'Digit expected, got "' + currentCharacter(state) + '"');
                } else if (nextCharacter(state) === ".") {
                    next(state);
                    throw createSyntaxError(state, 'Digit expected, got "' + currentCharacter(state) + '"');
                }
            }
            return;
        } // check for variables, functions, named operators
        if (parse.isAlpha(currentCharacter(state), prevCharacter(state), nextCharacter(state))) {
            while(parse.isAlpha(currentCharacter(state), prevCharacter(state), nextCharacter(state)) || parse.isDigit(currentCharacter(state))){
                state.token += currentCharacter(state);
                next(state);
            }
            if ((0, $7ITGG.hasOwnProperty)(NAMED_DELIMITERS, state.token)) state.tokenType = TOKENTYPE.DELIMITER;
            else state.tokenType = TOKENTYPE.SYMBOL;
            return;
        } // something unknown is found, wrong characters -> a syntax error
        state.tokenType = TOKENTYPE.UNKNOWN;
        while(currentCharacter(state) !== ""){
            state.token += currentCharacter(state);
            next(state);
        }
        throw createSyntaxError(state, 'Syntax error in part "' + state.token + '"');
    }
    /**
   * Get next token and skip newline tokens
   */ function getTokenSkipNewline(state) {
        do getToken(state);
        while (state.token === "\n"); // eslint-disable-line no-unmodified-loop-condition
    }
    /**
   * Open parameters.
   * New line characters will be ignored until closeParams(state) is called
   */ function openParams(state) {
        state.nestingLevel++;
    }
    /**
   * Close parameters.
   * New line characters will no longer be ignored
   */ function closeParams(state) {
        state.nestingLevel--;
    }
    /**
   * Checks whether the current character `c` is a valid alpha character:
   *
   * - A latin letter (upper or lower case) Ascii: a-z, A-Z
   * - An underscore                        Ascii: _
   * - A dollar sign                        Ascii: $
   * - A latin letter with accents          Unicode: \u00C0 - \u02AF
   * - A greek letter                       Unicode: \u0370 - \u03FF
   * - A mathematical alphanumeric symbol   Unicode: \u{1D400} - \u{1D7FF} excluding invalid code points
   *
   * The previous and next characters are needed to determine whether
   * this character is part of a unicode surrogate pair.
   *
   * @param {string} c      Current character in the expression
   * @param {string} cPrev  Previous character
   * @param {string} cNext  Next character
   * @return {boolean}
   */ parse.isAlpha = function isAlpha(c, cPrev, cNext) {
        return parse.isValidLatinOrGreek(c) || parse.isValidMathSymbol(c, cNext) || parse.isValidMathSymbol(cPrev, c);
    };
    /**
   * Test whether a character is a valid latin, greek, or letter-like character
   * @param {string} c
   * @return {boolean}
   */ parse.isValidLatinOrGreek = function isValidLatinOrGreek(c) {
        return /^[a-zA-Z_$\u00C0-\u02AF\u0370-\u03FF\u2100-\u214F]$/.test(c);
    };
    /**
   * Test whether two given 16 bit characters form a surrogate pair of a
   * unicode math symbol.
   *
   * https://unicode-table.com/en/
   * https://www.wikiwand.com/en/Mathematical_operators_and_symbols_in_Unicode
   *
   * Note: In ES6 will be unicode aware:
   * https://stackoverflow.com/questions/280712/javascript-unicode-regexes
   * https://mathiasbynens.be/notes/es6-unicode-regex
   *
   * @param {string} high
   * @param {string} low
   * @return {boolean}
   */ parse.isValidMathSymbol = function isValidMathSymbol(high, low) {
        return /^[\uD835]$/.test(high) && /^[\uDC00-\uDFFF]$/.test(low) && /^[^\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]$/.test(low);
    };
    /**
   * Check whether given character c is a white space character: space, tab, or enter
   * @param {string} c
   * @param {number} nestingLevel
   * @return {boolean}
   */ parse.isWhitespace = function isWhitespace(c, nestingLevel) {
        // TODO: also take '\r' carriage return as newline? Or does that give problems on mac?
        return c === " " || c === "	" || c === "\n" && nestingLevel > 0;
    };
    /**
   * Test whether the character c is a decimal mark (dot).
   * This is the case when it's not the start of a delimiter '.*', './', or '.^'
   * @param {string} c
   * @param {string} cNext
   * @return {boolean}
   */ parse.isDecimalMark = function isDecimalMark(c, cNext) {
        return c === "." && cNext !== "/" && cNext !== "*" && cNext !== "^";
    };
    /**
   * checks if the given char c is a digit or dot
   * @param {string} c   a string with one character
   * @return {boolean}
   */ parse.isDigitDot = function isDigitDot(c) {
        return c >= "0" && c <= "9" || c === ".";
    };
    /**
   * checks if the given char c is a digit
   * @param {string} c   a string with one character
   * @return {boolean}
   */ parse.isDigit = function isDigit(c) {
        return c >= "0" && c <= "9";
    };
    /**
   * Start of the parse levels below, in order of precedence
   * @return {Node} node
   * @private
   */ function parseStart(expression, extraNodes) {
        var state = initialState();
        $a3f4af8c9a89557d$var$_extends(state, {
            expression: expression,
            extraNodes: extraNodes
        });
        getToken(state);
        var node = parseBlock(state); // check for garbage at the end of the expression
        // an expression ends with a empty character '' and tokenType DELIMITER
        if (state.token !== "") {
            if (state.tokenType === TOKENTYPE.DELIMITER) // user entered a not existing operator like "//"
            // TODO: give hints for aliases, for example with "<>" give as hint " did you mean !== ?"
            throw createError(state, "Unexpected operator " + state.token);
            else throw createSyntaxError(state, 'Unexpected part "' + state.token + '"');
        }
        return node;
    }
    /**
   * Parse a block with expressions. Expressions can be separated by a newline
   * character '\n', or by a semicolon ';'. In case of a semicolon, no output
   * of the preceding line is returned.
   * @return {Node} node
   * @private
   */ function parseBlock(state) {
        var node;
        var blocks = [];
        var visible;
        if (state.token !== "" && state.token !== "\n" && state.token !== ";") {
            node = parseAssignment(state);
            node.comment = state.comment;
        } // TODO: simplify this loop
        while(state.token === "\n" || state.token === ";"){
            // eslint-disable-line no-unmodified-loop-condition
            if (blocks.length === 0 && node) {
                visible = state.token !== ";";
                blocks.push({
                    node: node,
                    visible: visible
                });
            }
            getToken(state);
            if (state.token !== "\n" && state.token !== ";" && state.token !== "") {
                node = parseAssignment(state);
                node.comment = state.comment;
                visible = state.token !== ";";
                blocks.push({
                    node: node,
                    visible: visible
                });
            }
        }
        if (blocks.length > 0) return new BlockNode(blocks);
        else {
            if (!node) {
                node = new ConstantNode(undefined);
                node.comment = state.comment;
            }
            return node;
        }
    }
    /**
   * Assignment of a function or variable,
   * - can be a variable like 'a=2.3'
   * - or a updating an existing variable like 'matrix(2,3:5)=[6,7,8]'
   * - defining a function like 'f(x) = x^2'
   * @return {Node} node
   * @private
   */ function parseAssignment(state) {
        var name, args, value, valid;
        var node = parseConditional(state);
        if (state.token === "=") {
            if ((0, $1amHZ.isSymbolNode)(node)) {
                // parse a variable assignment like 'a = 2/3'
                name = node.name;
                getTokenSkipNewline(state);
                value = parseAssignment(state);
                return new AssignmentNode(new SymbolNode(name), value);
            } else if ((0, $1amHZ.isAccessorNode)(node)) {
                // parse a matrix subset assignment like 'A[1,2] = 4'
                getTokenSkipNewline(state);
                value = parseAssignment(state);
                return new AssignmentNode(node.object, node.index, value);
            } else if ((0, $1amHZ.isFunctionNode)(node) && (0, $1amHZ.isSymbolNode)(node.fn)) {
                // parse function assignment like 'f(x) = x^2'
                valid = true;
                args = [];
                name = node.name;
                node.args.forEach(function(arg, index) {
                    if ((0, $1amHZ.isSymbolNode)(arg)) args[index] = arg.name;
                    else valid = false;
                });
                if (valid) {
                    getTokenSkipNewline(state);
                    value = parseAssignment(state);
                    return new FunctionAssignmentNode(name, args, value);
                }
            }
            throw createSyntaxError(state, "Invalid left hand side of assignment operator =");
        }
        return node;
    }
    /**
   * conditional operation
   *
   *     condition ? truePart : falsePart
   *
   * Note: conditional operator is right-associative
   *
   * @return {Node} node
   * @private
   */ function parseConditional(state) {
        var node = parseLogicalOr(state);
        while(state.token === "?"){
            // eslint-disable-line no-unmodified-loop-condition
            // set a conditional level, the range operator will be ignored as long
            // as conditionalLevel === state.nestingLevel.
            var prev = state.conditionalLevel;
            state.conditionalLevel = state.nestingLevel;
            getTokenSkipNewline(state);
            var condition = node;
            var trueExpr = parseAssignment(state);
            if (state.token !== ":") throw createSyntaxError(state, "False part of conditional expression expected");
            state.conditionalLevel = null;
            getTokenSkipNewline(state);
            var falseExpr = parseAssignment(state); // Note: check for conditional operator again, right associativity
            node = new ConditionalNode(condition, trueExpr, falseExpr); // restore the previous conditional level
            state.conditionalLevel = prev;
        }
        return node;
    }
    /**
   * logical or, 'x or y'
   * @return {Node} node
   * @private
   */ function parseLogicalOr(state) {
        var node = parseLogicalXor(state);
        while(state.token === "or"){
            // eslint-disable-line no-unmodified-loop-condition
            getTokenSkipNewline(state);
            node = new OperatorNode("or", "or", [
                node,
                parseLogicalXor(state)
            ]);
        }
        return node;
    }
    /**
   * logical exclusive or, 'x xor y'
   * @return {Node} node
   * @private
   */ function parseLogicalXor(state) {
        var node = parseLogicalAnd(state);
        while(state.token === "xor"){
            // eslint-disable-line no-unmodified-loop-condition
            getTokenSkipNewline(state);
            node = new OperatorNode("xor", "xor", [
                node,
                parseLogicalAnd(state)
            ]);
        }
        return node;
    }
    /**
   * logical and, 'x and y'
   * @return {Node} node
   * @private
   */ function parseLogicalAnd(state) {
        var node = parseBitwiseOr(state);
        while(state.token === "and"){
            // eslint-disable-line no-unmodified-loop-condition
            getTokenSkipNewline(state);
            node = new OperatorNode("and", "and", [
                node,
                parseBitwiseOr(state)
            ]);
        }
        return node;
    }
    /**
   * bitwise or, 'x | y'
   * @return {Node} node
   * @private
   */ function parseBitwiseOr(state) {
        var node = parseBitwiseXor(state);
        while(state.token === "|"){
            // eslint-disable-line no-unmodified-loop-condition
            getTokenSkipNewline(state);
            node = new OperatorNode("|", "bitOr", [
                node,
                parseBitwiseXor(state)
            ]);
        }
        return node;
    }
    /**
   * bitwise exclusive or (xor), 'x ^| y'
   * @return {Node} node
   * @private
   */ function parseBitwiseXor(state) {
        var node = parseBitwiseAnd(state);
        while(state.token === "^|"){
            // eslint-disable-line no-unmodified-loop-condition
            getTokenSkipNewline(state);
            node = new OperatorNode("^|", "bitXor", [
                node,
                parseBitwiseAnd(state)
            ]);
        }
        return node;
    }
    /**
   * bitwise and, 'x & y'
   * @return {Node} node
   * @private
   */ function parseBitwiseAnd(state) {
        var node = parseRelational(state);
        while(state.token === "&"){
            // eslint-disable-line no-unmodified-loop-condition
            getTokenSkipNewline(state);
            node = new OperatorNode("&", "bitAnd", [
                node,
                parseRelational(state)
            ]);
        }
        return node;
    }
    /**
   * Parse a chained conditional, like 'a > b >= c'
   * @return {Node} node
   */ function parseRelational(state) {
        var params = [
            parseShift(state)
        ];
        var conditionals = [];
        var operators = {
            "==": "equal",
            "!=": "unequal",
            "<": "smaller",
            ">": "larger",
            "<=": "smallerEq",
            ">=": "largerEq"
        };
        while((0, $7ITGG.hasOwnProperty)(operators, state.token)){
            // eslint-disable-line no-unmodified-loop-condition
            var cond = {
                name: state.token,
                fn: operators[state.token]
            };
            conditionals.push(cond);
            getTokenSkipNewline(state);
            params.push(parseShift(state));
        }
        if (params.length === 1) return params[0];
        else if (params.length === 2) return new OperatorNode(conditionals[0].name, conditionals[0].fn, params);
        else return new RelationalNode(conditionals.map(function(c) {
            return c.fn;
        }), params);
    }
    /**
   * Bitwise left shift, bitwise right arithmetic shift, bitwise right logical shift
   * @return {Node} node
   * @private
   */ function parseShift(state) {
        var node, name, fn, params;
        node = parseConversion(state);
        var operators = {
            "<<": "leftShift",
            ">>": "rightArithShift",
            ">>>": "rightLogShift"
        };
        while((0, $7ITGG.hasOwnProperty)(operators, state.token)){
            name = state.token;
            fn = operators[name];
            getTokenSkipNewline(state);
            params = [
                node,
                parseConversion(state)
            ];
            node = new OperatorNode(name, fn, params);
        }
        return node;
    }
    /**
   * conversion operators 'to' and 'in'
   * @return {Node} node
   * @private
   */ function parseConversion(state) {
        var node, name, fn, params;
        node = parseRange(state);
        var operators = {
            to: "to",
            "in": "to" // alias of 'to'
        };
        while((0, $7ITGG.hasOwnProperty)(operators, state.token)){
            name = state.token;
            fn = operators[name];
            getTokenSkipNewline(state);
            if (name === "in" && state.token === "") // end of expression -> this is the unit 'in' ('inch')
            node = new OperatorNode("*", "multiply", [
                node,
                new SymbolNode("in")
            ], true);
            else {
                // operator 'a to b' or 'a in b'
                params = [
                    node,
                    parseRange(state)
                ];
                node = new OperatorNode(name, fn, params);
            }
        }
        return node;
    }
    /**
   * parse range, "start:end", "start:step:end", ":", "start:", ":end", etc
   * @return {Node} node
   * @private
   */ function parseRange(state) {
        var node;
        var params = [];
        if (state.token === ":") // implicit start=1 (one-based)
        node = new ConstantNode(1);
        else // explicit start
        node = parseAddSubtract(state);
        if (state.token === ":" && state.conditionalLevel !== state.nestingLevel) {
            // we ignore the range operator when a conditional operator is being processed on the same level
            params.push(node); // parse step and end
            while(state.token === ":" && params.length < 3){
                // eslint-disable-line no-unmodified-loop-condition
                getTokenSkipNewline(state);
                if (state.token === ")" || state.token === "]" || state.token === "," || state.token === "") // implicit end
                params.push(new SymbolNode("end"));
                else // explicit end
                params.push(parseAddSubtract(state));
            }
            if (params.length === 3) // params = [start, step, end]
            node = new RangeNode(params[0], params[2], params[1]); // start, end, step
            else // length === 2
            // params = [start, end]
            node = new RangeNode(params[0], params[1]); // start, end
        }
        return node;
    }
    /**
   * add or subtract
   * @return {Node} node
   * @private
   */ function parseAddSubtract(state) {
        var node, name, fn, params;
        node = parseMultiplyDivide(state);
        var operators = {
            "+": "add",
            "-": "subtract"
        };
        while((0, $7ITGG.hasOwnProperty)(operators, state.token)){
            name = state.token;
            fn = operators[name];
            getTokenSkipNewline(state);
            params = [
                node,
                parseMultiplyDivide(state)
            ];
            node = new OperatorNode(name, fn, params);
        }
        return node;
    }
    /**
   * multiply, divide, modulus
   * @return {Node} node
   * @private
   */ function parseMultiplyDivide(state) {
        var node, last, name, fn;
        node = parseImplicitMultiplication(state);
        last = node;
        var operators = {
            "*": "multiply",
            ".*": "dotMultiply",
            "/": "divide",
            "./": "dotDivide",
            "%": "mod",
            mod: "mod"
        };
        while(true){
            if ((0, $7ITGG.hasOwnProperty)(operators, state.token)) {
                // explicit operators
                name = state.token;
                fn = operators[name];
                getTokenSkipNewline(state);
                last = parseImplicitMultiplication(state);
                node = new OperatorNode(name, fn, [
                    node,
                    last
                ]);
            } else break;
        }
        return node;
    }
    /**
   * implicit multiplication
   * @return {Node} node
   * @private
   */ function parseImplicitMultiplication(state) {
        var node, last;
        node = parseRule2(state);
        last = node;
        while(true){
            if (state.tokenType === TOKENTYPE.SYMBOL || state.token === "in" && (0, $1amHZ.isConstantNode)(node) || state.tokenType === TOKENTYPE.NUMBER && !(0, $1amHZ.isConstantNode)(last) && (!(0, $1amHZ.isOperatorNode)(last) || last.op === "!") || state.token === "(") {
                // parse implicit multiplication
                //
                // symbol:      implicit multiplication like '2a', '(2+3)a', 'a b'
                // number:      implicit multiplication like '(2+3)2'
                // parenthesis: implicit multiplication like '2(3+4)', '(3+4)(1+2)'
                last = parseRule2(state);
                node = new OperatorNode("*", "multiply", [
                    node,
                    last
                ], true);
            } else break;
        }
        return node;
    }
    /**
   * Infamous "rule 2" as described in https://github.com/josdejong/mathjs/issues/792#issuecomment-361065370
   * Explicit division gets higher precedence than implicit multiplication
   * when the division matches this pattern: [number] / [number] [symbol]
   * @return {Node} node
   * @private
   */ function parseRule2(state) {
        var node = parseUnary(state);
        var last = node;
        var tokenStates = [];
        while(true){
            // Match the "number /" part of the pattern "number / number symbol"
            if (state.token === "/" && (0, $1amHZ.isConstantNode)(last)) {
                // Look ahead to see if the next token is a number
                tokenStates.push($a3f4af8c9a89557d$var$_extends({}, state));
                getTokenSkipNewline(state); // Match the "number / number" part of the pattern
                if (state.tokenType === TOKENTYPE.NUMBER) {
                    // Look ahead again
                    tokenStates.push($a3f4af8c9a89557d$var$_extends({}, state));
                    getTokenSkipNewline(state); // Match the "symbol" part of the pattern, or a left parenthesis
                    if (state.tokenType === TOKENTYPE.SYMBOL || state.token === "(") {
                        // We've matched the pattern "number / number symbol".
                        // Rewind once and build the "number / number" node; the symbol will be consumed later
                        $a3f4af8c9a89557d$var$_extends(state, tokenStates.pop());
                        tokenStates.pop();
                        last = parseUnary(state);
                        node = new OperatorNode("/", "divide", [
                            node,
                            last
                        ]);
                    } else {
                        // Not a match, so rewind
                        tokenStates.pop();
                        $a3f4af8c9a89557d$var$_extends(state, tokenStates.pop());
                        break;
                    }
                } else {
                    // Not a match, so rewind
                    $a3f4af8c9a89557d$var$_extends(state, tokenStates.pop());
                    break;
                }
            } else break;
        }
        return node;
    }
    /**
   * Unary plus and minus, and logical and bitwise not
   * @return {Node} node
   * @private
   */ function parseUnary(state) {
        var name, params, fn;
        var operators = {
            "-": "unaryMinus",
            "+": "unaryPlus",
            "~": "bitNot",
            not: "not"
        };
        if ((0, $7ITGG.hasOwnProperty)(operators, state.token)) {
            fn = operators[state.token];
            name = state.token;
            getTokenSkipNewline(state);
            params = [
                parseUnary(state)
            ];
            return new OperatorNode(name, fn, params);
        }
        return parsePow(state);
    }
    /**
   * power
   * Note: power operator is right associative
   * @return {Node} node
   * @private
   */ function parsePow(state) {
        var node, name, fn, params;
        node = parseLeftHandOperators(state);
        if (state.token === "^" || state.token === ".^") {
            name = state.token;
            fn = name === "^" ? "pow" : "dotPow";
            getTokenSkipNewline(state);
            params = [
                node,
                parseUnary(state)
            ]; // Go back to unary, we can have '2^-3'
            node = new OperatorNode(name, fn, params);
        }
        return node;
    }
    /**
   * Left hand operators: factorial x!, ctranspose x'
   * @return {Node} node
   * @private
   */ function parseLeftHandOperators(state) {
        var node, name, fn, params;
        node = parseCustomNodes(state);
        var operators = {
            "!": "factorial",
            "'": "ctranspose"
        };
        while((0, $7ITGG.hasOwnProperty)(operators, state.token)){
            name = state.token;
            fn = operators[name];
            getToken(state);
            params = [
                node
            ];
            node = new OperatorNode(name, fn, params);
            node = parseAccessors(state, node);
        }
        return node;
    }
    /**
   * Parse a custom node handler. A node handler can be used to process
   * nodes in a custom way, for example for handling a plot.
   *
   * A handler must be passed as second argument of the parse function.
   * - must extend math.expression.node.Node
   * - must contain a function _compile(defs: Object) : string
   * - must contain a function find(filter: Object) : Node[]
   * - must contain a function toString() : string
   * - the constructor is called with a single argument containing all parameters
   *
   * For example:
   *
   *     nodes = {
   *       'plot': PlotHandler
   *     }
   *
   * The constructor of the handler is called as:
   *
   *     node = new PlotHandler(params)
   *
   * The handler will be invoked when evaluating an expression like:
   *
   *     node = math.parse('plot(sin(x), x)', nodes)
   *
   * @return {Node} node
   * @private
   */ function parseCustomNodes(state) {
        var params = [];
        if (state.tokenType === TOKENTYPE.SYMBOL && (0, $7ITGG.hasOwnProperty)(state.extraNodes, state.token)) {
            var CustomNode = state.extraNodes[state.token];
            getToken(state); // parse parameters
            if (state.token === "(") {
                params = [];
                openParams(state);
                getToken(state);
                if (state.token !== ")") {
                    params.push(parseAssignment(state)); // parse a list with parameters
                    while(state.token === ","){
                        // eslint-disable-line no-unmodified-loop-condition
                        getToken(state);
                        params.push(parseAssignment(state));
                    }
                }
                if (state.token !== ")") throw createSyntaxError(state, "Parenthesis ) expected");
                closeParams(state);
                getToken(state);
            } // create a new custom node
            // noinspection JSValidateTypes
            return new CustomNode(params);
        }
        return parseSymbol(state);
    }
    /**
   * parse symbols: functions, variables, constants, units
   * @return {Node} node
   * @private
   */ function parseSymbol(state) {
        var node, name;
        if (state.tokenType === TOKENTYPE.SYMBOL || state.tokenType === TOKENTYPE.DELIMITER && state.token in NAMED_DELIMITERS) {
            name = state.token;
            getToken(state);
            if ((0, $7ITGG.hasOwnProperty)(CONSTANTS, name)) // true, false, null, ...
            node = new ConstantNode(CONSTANTS[name]);
            else if (NUMERIC_CONSTANTS.indexOf(name) !== -1) // NaN, Infinity
            node = new ConstantNode(numeric(name, "number"));
            else node = new SymbolNode(name);
             // parse function parameters and matrix index
            node = parseAccessors(state, node);
            return node;
        }
        return parseDoubleQuotesString(state);
    }
    /**
   * parse accessors:
   * - function invocation in round brackets (...), for example sqrt(2)
   * - index enclosed in square brackets [...], for example A[2,3]
   * - dot notation for properties, like foo.bar
   * @param {Object} state
   * @param {Node} node    Node on which to apply the parameters. If there
   *                       are no parameters in the expression, the node
   *                       itself is returned
   * @param {string[]} [types]  Filter the types of notations
   *                            can be ['(', '[', '.']
   * @return {Node} node
   * @private
   */ function parseAccessors(state, node, types) {
        var params;
        while((state.token === "(" || state.token === "[" || state.token === ".") && (!types || types.indexOf(state.token) !== -1)){
            // eslint-disable-line no-unmodified-loop-condition
            params = [];
            if (state.token === "(") {
                if ((0, $1amHZ.isSymbolNode)(node) || (0, $1amHZ.isAccessorNode)(node)) {
                    // function invocation like fn(2, 3) or obj.fn(2, 3)
                    openParams(state);
                    getToken(state);
                    if (state.token !== ")") {
                        params.push(parseAssignment(state)); // parse a list with parameters
                        while(state.token === ","){
                            // eslint-disable-line no-unmodified-loop-condition
                            getToken(state);
                            params.push(parseAssignment(state));
                        }
                    }
                    if (state.token !== ")") throw createSyntaxError(state, "Parenthesis ) expected");
                    closeParams(state);
                    getToken(state);
                    node = new FunctionNode(node, params);
                } else // implicit multiplication like (2+3)(4+5) or sqrt(2)(1+2)
                // don't parse it here but let it be handled by parseImplicitMultiplication
                // with correct precedence
                return node;
            } else if (state.token === "[") {
                // index notation like variable[2, 3]
                openParams(state);
                getToken(state);
                if (state.token !== "]") {
                    params.push(parseAssignment(state)); // parse a list with parameters
                    while(state.token === ","){
                        // eslint-disable-line no-unmodified-loop-condition
                        getToken(state);
                        params.push(parseAssignment(state));
                    }
                }
                if (state.token !== "]") throw createSyntaxError(state, "Parenthesis ] expected");
                closeParams(state);
                getToken(state);
                node = new AccessorNode(node, new IndexNode(params));
            } else {
                // dot notation like variable.prop
                getToken(state);
                if (state.tokenType !== TOKENTYPE.SYMBOL) throw createSyntaxError(state, "Property name expected after dot");
                params.push(new ConstantNode(state.token));
                getToken(state);
                var dotNotation = true;
                node = new AccessorNode(node, new IndexNode(params, dotNotation));
            }
        }
        return node;
    }
    /**
   * Parse a double quotes string.
   * @return {Node} node
   * @private
   */ function parseDoubleQuotesString(state) {
        var node, str;
        if (state.token === '"') {
            str = parseDoubleQuotesStringToken(state); // create constant
            node = new ConstantNode(str); // parse index parameters
            node = parseAccessors(state, node);
            return node;
        }
        return parseSingleQuotesString(state);
    }
    /**
   * Parse a string surrounded by double quotes "..."
   * @return {string}
   */ function parseDoubleQuotesStringToken(state) {
        var str = "";
        while(currentCharacter(state) !== "" && currentCharacter(state) !== '"'){
            if (currentCharacter(state) === "\\") {
                // escape character, immediately process the next
                // character to prevent stopping at a next '\"'
                str += currentCharacter(state);
                next(state);
            }
            str += currentCharacter(state);
            next(state);
        }
        getToken(state);
        if (state.token !== '"') throw createSyntaxError(state, 'End of string " expected');
        getToken(state);
        return JSON.parse('"' + str + '"'); // unescape escaped characters
    }
    /**
   * Parse a single quotes string.
   * @return {Node} node
   * @private
   */ function parseSingleQuotesString(state) {
        var node, str;
        if (state.token === "'") {
            str = parseSingleQuotesStringToken(state); // create constant
            node = new ConstantNode(str); // parse index parameters
            node = parseAccessors(state, node);
            return node;
        }
        return parseMatrix(state);
    }
    /**
   * Parse a string surrounded by single quotes '...'
   * @return {string}
   */ function parseSingleQuotesStringToken(state) {
        var str = "";
        while(currentCharacter(state) !== "" && currentCharacter(state) !== "'"){
            if (currentCharacter(state) === "\\") {
                // escape character, immediately process the next
                // character to prevent stopping at a next '\''
                str += currentCharacter(state);
                next(state);
            }
            str += currentCharacter(state);
            next(state);
        }
        getToken(state);
        if (state.token !== "'") throw createSyntaxError(state, "End of string ' expected");
        getToken(state);
        return JSON.parse('"' + str + '"'); // unescape escaped characters
    }
    /**
   * parse the matrix
   * @return {Node} node
   * @private
   */ function parseMatrix(state) {
        var array, params, rows, cols;
        if (state.token === "[") {
            // matrix [...]
            openParams(state);
            getToken(state);
            if (state.token !== "]") {
                // this is a non-empty matrix
                var row = parseRow(state);
                if (state.token === ";") {
                    // 2 dimensional array
                    rows = 1;
                    params = [
                        row
                    ]; // the rows of the matrix are separated by dot-comma's
                    while(state.token === ";"){
                        // eslint-disable-line no-unmodified-loop-condition
                        getToken(state);
                        params[rows] = parseRow(state);
                        rows++;
                    }
                    if (state.token !== "]") throw createSyntaxError(state, "End of matrix ] expected");
                    closeParams(state);
                    getToken(state); // check if the number of columns matches in all rows
                    cols = params[0].items.length;
                    for(var r = 1; r < rows; r++){
                        if (params[r].items.length !== cols) throw createError(state, "Column dimensions mismatch (" + params[r].items.length + " !== " + cols + ")");
                    }
                    array = new ArrayNode(params);
                } else {
                    // 1 dimensional vector
                    if (state.token !== "]") throw createSyntaxError(state, "End of matrix ] expected");
                    closeParams(state);
                    getToken(state);
                    array = row;
                }
            } else {
                // this is an empty matrix "[ ]"
                closeParams(state);
                getToken(state);
                array = new ArrayNode([]);
            }
            return parseAccessors(state, array);
        }
        return parseObject(state);
    }
    /**
   * Parse a single comma-separated row from a matrix, like 'a, b, c'
   * @return {ArrayNode} node
   */ function parseRow(state) {
        var params = [
            parseAssignment(state)
        ];
        var len = 1;
        while(state.token === ","){
            // eslint-disable-line no-unmodified-loop-condition
            getToken(state); // parse expression
            params[len] = parseAssignment(state);
            len++;
        }
        return new ArrayNode(params);
    }
    /**
   * parse an object, enclosed in angle brackets{...}, for example {value: 2}
   * @return {Node} node
   * @private
   */ function parseObject(state) {
        if (state.token === "{") {
            openParams(state);
            var key;
            var properties = {};
            do {
                getToken(state);
                if (state.token !== "}") {
                    // parse key
                    if (state.token === '"') key = parseDoubleQuotesStringToken(state);
                    else if (state.token === "'") key = parseSingleQuotesStringToken(state);
                    else if (state.tokenType === TOKENTYPE.SYMBOL || state.tokenType === TOKENTYPE.DELIMITER && state.token in NAMED_DELIMITERS) {
                        key = state.token;
                        getToken(state);
                    } else throw createSyntaxError(state, "Symbol or string expected as object key");
                     // parse key/value separator
                    if (state.token !== ":") throw createSyntaxError(state, "Colon : expected after object key");
                    getToken(state); // parse key
                    properties[key] = parseAssignment(state);
                }
            }while (state.token === ","); // eslint-disable-line no-unmodified-loop-condition
            if (state.token !== "}") throw createSyntaxError(state, "Comma , or bracket } expected after object value");
            closeParams(state);
            getToken(state);
            var node = new ObjectNode(properties); // parse index parameters
            node = parseAccessors(state, node);
            return node;
        }
        return parseNumber(state);
    }
    /**
   * parse a number
   * @return {Node} node
   * @private
   */ function parseNumber(state) {
        var numberStr;
        if (state.tokenType === TOKENTYPE.NUMBER) {
            // this is a number
            numberStr = state.token;
            getToken(state);
            return new ConstantNode(numeric(numberStr, config.number));
        }
        return parseParentheses(state);
    }
    /**
   * parentheses
   * @return {Node} node
   * @private
   */ function parseParentheses(state) {
        var node; // check if it is a parenthesized expression
        if (state.token === "(") {
            // parentheses (...)
            openParams(state);
            getToken(state);
            node = parseAssignment(state); // start again
            if (state.token !== ")") throw createSyntaxError(state, "Parenthesis ) expected");
            closeParams(state);
            getToken(state);
            node = new ParenthesisNode(node);
            node = parseAccessors(state, node);
            return node;
        }
        return parseEnd(state);
    }
    /**
   * Evaluated when the expression is not yet ended but expected to end
   * @return {Node} res
   * @private
   */ function parseEnd(state) {
        if (state.token === "") // syntax error or unexpected end of expression
        throw createSyntaxError(state, "Unexpected end of expression");
        else throw createSyntaxError(state, "Value expected");
    }
    /**
   * Shortcut for getting the current row value (one based)
   * Returns the line of the currently handled expression
   * @private
   */ /* TODO: implement keeping track on the row number
  function row () {
    return null
  }
  */ /**
   * Shortcut for getting the current col value (one based)
   * Returns the column (position) where the last state.token starts
   * @private
   */ function col(state) {
        return state.index - state.token.length + 1;
    }
    /**
   * Create an error
   * @param {Object} state
   * @param {string} message
   * @return {SyntaxError} instantiated error
   * @private
   */ function createSyntaxError(state, message) {
        var c = col(state);
        var error = new SyntaxError(message + " (char " + c + ")");
        error["char"] = c;
        return error;
    }
    /**
   * Create an error
   * @param {Object} state
   * @param {string} message
   * @return {Error} instantiated error
   * @private
   */ function createError(state, message) {
        var c = col(state);
        var error = new SyntaxError(message + " (char " + c + ")");
        error["char"] = c;
        return error;
    }
    return parse;
});

});

parcelRegister("eZkT2", function(module, exports) {

$parcel$export(module.exports, "createParser", function () { return $ae96f6dd183d69ec$export$88a1156fad04455f; });

var $2mPYl = parcelRequire("2mPYl");
var $ae96f6dd183d69ec$var$name = "parser";
var $ae96f6dd183d69ec$var$dependencies = [
    "typed",
    "Parser"
];
var $ae96f6dd183d69ec$export$88a1156fad04455f = /* #__PURE__ */ (0, $2mPYl.factory)($ae96f6dd183d69ec$var$name, $ae96f6dd183d69ec$var$dependencies, function(_ref) {
    var typed = _ref.typed, Parser = _ref.Parser;
    /**
   * Create a parser. The function creates a new `math.Parser` object.
   *
   * Syntax:
   *
   *    math.parser()
   *
   * Examples:
   *
   *     const parser = new math.parser()
   *
   *     // evaluate expressions
   *     const a = parser.evaluate('sqrt(3^2 + 4^2)') // 5
   *     const b = parser.evaluate('sqrt(-4)')        // 2i
   *     const c = parser.evaluate('2 inch in cm')    // 5.08 cm
   *     const d = parser.evaluate('cos(45 deg)')     // 0.7071067811865476
   *
   *     // define variables and functions
   *     parser.evaluate('x = 7 / 2')                 // 3.5
   *     parser.evaluate('x + 3')                     // 6.5
   *     parser.evaluate('function f(x, y) = x^y')    // f(x, y)
   *     parser.evaluate('f(2, 3)')                   // 8
   *
   *     // get and set variables and functions
   *     const x = parser.get('x')                // 7
   *     const f = parser.get('f')                // function
   *     const g = f(3, 2)                        // 9
   *     parser.set('h', 500)
   *     const i = parser.evaluate('h / 2')       // 250
   *     parser.set('hello', function (name) {
   *       return 'hello, ' + name + '!'
   *     })
   *     parser.evaluate('hello("user")')         // "hello, user!"
   *
   *     // clear defined functions and variables
   *     parser.clear()
   *
   * See also:
   *
   *    evaluate, compile, parse
   *
   * @return {Parser} Parser
   */ return typed($ae96f6dd183d69ec$var$name, {
        "": function _() {
            return new Parser();
        }
    });
});

});

parcelRegister("d6Zpi", function(module, exports) {

$parcel$export(module.exports, "createParserClass", function () { return $98bb78085b7c0a12$export$17c8a99aaef91654; });

var $2mPYl = parcelRequire("2mPYl");

var $7ITGG = parcelRequire("7ITGG");

var $45IYD = parcelRequire("45IYD");

var $kcYaK = parcelRequire("kcYaK");
var $98bb78085b7c0a12$var$name = "Parser";
var $98bb78085b7c0a12$var$dependencies = [
    "parse"
];
var $98bb78085b7c0a12$export$17c8a99aaef91654 = /* #__PURE__ */ (0, $2mPYl.factory)($98bb78085b7c0a12$var$name, $98bb78085b7c0a12$var$dependencies, function(_ref) {
    var parse = _ref.parse;
    /**
   * @constructor Parser
   * Parser contains methods to evaluate or parse expressions, and has a number
   * of convenience methods to get, set, and remove variables from memory. Parser
   * keeps a scope containing variables in memory, which is used for all
   * evaluations.
   *
   * Methods:
   *    const result = parser.evaluate(expr)  // evaluate an expression
   *    const value = parser.get(name)        // retrieve a variable from the parser
   *    const values = parser.getAll()        // retrieve all defined variables
   *    parser.set(name, value)               // set a variable in the parser
   *    parser.remove(name)                   // clear a variable from the
   *                                          // parsers scope
   *    parser.clear()                        // clear the parsers scope
   *
   * Example usage:
   *    const parser = new Parser()
   *    // Note: there is a convenience method which can be used instead:
   *    // const parser = new math.parser()
   *
   *    // evaluate expressions
   *    parser.evaluate('sqrt(3^2 + 4^2)')        // 5
   *    parser.evaluate('sqrt(-4)')               // 2i
   *    parser.evaluate('2 inch in cm')           // 5.08 cm
   *    parser.evaluate('cos(45 deg)')            // 0.7071067811865476
   *
   *    // define variables and functions
   *    parser.evaluate('x = 7 / 2')              // 3.5
   *    parser.evaluate('x + 3')                  // 6.5
   *    parser.evaluate('function f(x, y) = x^y') // f(x, y)
   *    parser.evaluate('f(2, 3)')                // 8
   *
   *    // get and set variables and functions
   *    const x = parser.get('x')                 // 7
   *    const f = parser.get('f')                 // function
   *    const g = f(3, 2)                         // 9
   *    parser.set('h', 500)
   *    const i = parser.evaluate('h / 2')        // 250
   *    parser.set('hello', function (name) {
   *        return 'hello, ' + name + '!'
   *    })
   *    parser.evaluate('hello("user")')          // "hello, user!"
   *
   *    // clear defined functions and variables
   *    parser.clear()
   *
   */ function Parser() {
        if (!(this instanceof Parser)) throw new SyntaxError("Constructor must be called with the new operator");
        this.scope = {};
    }
    /**
   * Attach type information
   */ Parser.prototype.type = "Parser";
    Parser.prototype.isParser = true;
    /**
   * Parse an expression and return the parsed function node.
   * The node tree can be compiled via `code = node.compile(math)`,
   * and the compiled code can be executed as `code.evaluate([scope])`
   * @param {string} expr
   * @return {Node} node
   * @throws {Error}
   */ Parser.prototype.parse = function(expr) {
        throw new Error("Parser.parse is deprecated. Use math.parse instead.");
    };
    /**
   * Parse and compile an expression, return the compiled javascript code.
   * The node can be evaluated via code.evaluate([scope])
   * @param {string} expr
   * @return {{evaluate: function}} code
   * @throws {Error}
   */ Parser.prototype.compile = function(expr) {
        throw new Error("Parser.compile is deprecated. Use math.compile instead.");
    };
    /**
   * Parse and evaluate the given expression
   * @param {string} expr   A string containing an expression, for example "2+3"
   * @return {*} result     The result, or undefined when the expression was empty
   * @throws {Error}
   */ Parser.prototype.evaluate = function(expr) {
        // TODO: validate arguments
        return parse(expr).compile().evaluate(this.scope);
    };
    /**
   * Parse and evaluate the given expression
   * @param {string} expr   A string containing an expression, for example "2+3"
   * @return {*} result     The result, or undefined when the expression was empty
   * @throws {Error}
   */ // TODO: Deprecated since v6.0.0. Clean up some day
    Parser.prototype.eval = function(expr) {
        (0, $kcYaK.warnOnce)("Method Parser.eval is renamed to Parser.evaluate. Please use the new method name.");
        return this.evaluate(expr);
    };
    /**
   * Get a variable (a function or variable) by name from the parsers scope.
   * Returns undefined when not found
   * @param {string} name
   * @return {* | undefined} value
   */ Parser.prototype.get = function(name) {
        // TODO: validate arguments
        return name in this.scope ? (0, $45IYD.getSafeProperty)(this.scope, name) : undefined;
    };
    /**
   * Get a map with all defined variables
   * @return {Object} values
   */ Parser.prototype.getAll = function() {
        return (0, $7ITGG.extend)({}, this.scope);
    };
    /**
   * Set a symbol (a function or variable) by name from the parsers scope.
   * @param {string} name
   * @param {* | undefined} value
   */ Parser.prototype.set = function(name, value) {
        // TODO: validate arguments
        return (0, $45IYD.setSafeProperty)(this.scope, name, value);
    };
    /**
   * Remove a variable from the parsers scope
   * @param {string} name
   */ Parser.prototype.remove = function(name) {
        // TODO: validate arguments
        delete this.scope[name];
    };
    /**
   * Clear the scope with variables and functions
   */ Parser.prototype.clear = function() {
        for(var _name in this.scope)if ((0, $7ITGG.hasOwnProperty)(this.scope, _name)) delete this.scope[_name];
    };
    return Parser;
}, {
    isClass: true
});

});

parcelRegister("4s10Q", function(module, exports) {

$parcel$export(module.exports, "createRangeNode", function () { return $33da900cd30340e8$export$fb6d9b21e29b8d46; });

var $1amHZ = parcelRequire("1amHZ");

var $2mPYl = parcelRequire("2mPYl");

var $cAxNq = parcelRequire("cAxNq");
var $33da900cd30340e8$var$name = "RangeNode";
var $33da900cd30340e8$var$dependencies = [
    "Node"
];
var $33da900cd30340e8$export$fb6d9b21e29b8d46 = /* #__PURE__ */ (0, $2mPYl.factory)($33da900cd30340e8$var$name, $33da900cd30340e8$var$dependencies, function(_ref) {
    var Node = _ref.Node;
    /**
   * @constructor RangeNode
   * @extends {Node}
   * create a range
   * @param {Node} start  included lower-bound
   * @param {Node} end    included upper-bound
   * @param {Node} [step] optional step
   */ function RangeNode(start, end, step) {
        if (!(this instanceof RangeNode)) throw new SyntaxError("Constructor must be called with the new operator");
         // validate inputs
        if (!(0, $1amHZ.isNode)(start)) throw new TypeError("Node expected");
        if (!(0, $1amHZ.isNode)(end)) throw new TypeError("Node expected");
        if (step && !(0, $1amHZ.isNode)(step)) throw new TypeError("Node expected");
        if (arguments.length > 3) throw new Error("Too many arguments");
        this.start = start; // included lower-bound
        this.end = end; // included upper-bound
        this.step = step || null; // optional step
    }
    RangeNode.prototype = new Node();
    RangeNode.prototype.type = "RangeNode";
    RangeNode.prototype.isRangeNode = true;
    /**
   * Check whether the RangeNode needs the `end` symbol to be defined.
   * This end is the size of the Matrix in current dimension.
   * @return {boolean}
   */ RangeNode.prototype.needsEnd = function() {
        // find all `end` symbols in this RangeNode
        var endSymbols = this.filter(function(node) {
            return (0, $1amHZ.isSymbolNode)(node) && node.name === "end";
        });
        return endSymbols.length > 0;
    };
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ RangeNode.prototype._compile = function(math, argNames) {
        var range = math.range;
        var evalStart = this.start._compile(math, argNames);
        var evalEnd = this.end._compile(math, argNames);
        if (this.step) {
            var evalStep = this.step._compile(math, argNames);
            return function evalRangeNode(scope, args, context) {
                return range(evalStart(scope, args, context), evalEnd(scope, args, context), evalStep(scope, args, context));
            };
        } else return function evalRangeNode(scope, args, context) {
            return range(evalStart(scope, args, context), evalEnd(scope, args, context));
        };
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ RangeNode.prototype.forEach = function(callback) {
        callback(this.start, "start", this);
        callback(this.end, "end", this);
        if (this.step) callback(this.step, "step", this);
    };
    /**
   * Create a new RangeNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node): Node} callback
   * @returns {RangeNode} Returns a transformed copy of the node
   */ RangeNode.prototype.map = function(callback) {
        return new RangeNode(this._ifNode(callback(this.start, "start", this)), this._ifNode(callback(this.end, "end", this)), this.step && this._ifNode(callback(this.step, "step", this)));
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {RangeNode}
   */ RangeNode.prototype.clone = function() {
        return new RangeNode(this.start, this.end, this.step && this.step);
    };
    /**
   * Calculate the necessary parentheses
   * @param {Node} node
   * @param {string} parenthesis
   * @return {Object} parentheses
   * @private
   */ function calculateNecessaryParentheses(node, parenthesis) {
        var precedence = (0, $cAxNq.getPrecedence)(node, parenthesis);
        var parens = {};
        var startPrecedence = (0, $cAxNq.getPrecedence)(node.start, parenthesis);
        parens.start = startPrecedence !== null && startPrecedence <= precedence || parenthesis === "all";
        if (node.step) {
            var stepPrecedence = (0, $cAxNq.getPrecedence)(node.step, parenthesis);
            parens.step = stepPrecedence !== null && stepPrecedence <= precedence || parenthesis === "all";
        }
        var endPrecedence = (0, $cAxNq.getPrecedence)(node.end, parenthesis);
        parens.end = endPrecedence !== null && endPrecedence <= precedence || parenthesis === "all";
        return parens;
    }
    /**
   * Get string representation
   * @param {Object} options
   * @return {string} str
   */ RangeNode.prototype._toString = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var parens = calculateNecessaryParentheses(this, parenthesis); // format string as start:step:stop
        var str;
        var start = this.start.toString(options);
        if (parens.start) start = "(" + start + ")";
        str = start;
        if (this.step) {
            var step = this.step.toString(options);
            if (parens.step) step = "(" + step + ")";
            str += ":" + step;
        }
        var end = this.end.toString(options);
        if (parens.end) end = "(" + end + ")";
        str += ":" + end;
        return str;
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ RangeNode.prototype.toJSON = function() {
        return {
            mathjs: "RangeNode",
            start: this.start,
            end: this.end,
            step: this.step
        };
    };
    /**
   * Instantiate an RangeNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "RangeNode", "start": ..., "end": ..., "step": ...}`,
   *                       where mathjs is optional
   * @returns {RangeNode}
   */ RangeNode.fromJSON = function(json) {
        return new RangeNode(json.start, json.end, json.step);
    };
    /**
   * Get HTML representation
   * @param {Object} options
   * @return {string} str
   */ RangeNode.prototype.toHTML = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var parens = calculateNecessaryParentheses(this, parenthesis); // format string as start:step:stop
        var str;
        var start = this.start.toHTML(options);
        if (parens.start) start = '<span class="math-parenthesis math-round-parenthesis">(</span>' + start + '<span class="math-parenthesis math-round-parenthesis">)</span>';
        str = start;
        if (this.step) {
            var step = this.step.toHTML(options);
            if (parens.step) step = '<span class="math-parenthesis math-round-parenthesis">(</span>' + step + '<span class="math-parenthesis math-round-parenthesis">)</span>';
            str += '<span class="math-operator math-range-operator">:</span>' + step;
        }
        var end = this.end.toHTML(options);
        if (parens.end) end = '<span class="math-parenthesis math-round-parenthesis">(</span>' + end + '<span class="math-parenthesis math-round-parenthesis">)</span>';
        str += '<span class="math-operator math-range-operator">:</span>' + end;
        return str;
    };
    /**
   * Get LaTeX representation
   * @params {Object} options
   * @return {string} str
   */ RangeNode.prototype._toTex = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var parens = calculateNecessaryParentheses(this, parenthesis);
        var str = this.start.toTex(options);
        if (parens.start) str = "\\left(".concat(str, "\\right)");
        if (this.step) {
            var step = this.step.toTex(options);
            if (parens.step) step = "\\left(".concat(step, "\\right)");
            str += ":" + step;
        }
        var end = this.end.toTex(options);
        if (parens.end) end = "\\left(".concat(end, "\\right)");
        str += ":" + end;
        return str;
    };
    return RangeNode;
}, {
    isClass: true,
    isNode: true
});

});

parcelRegister("lfJeA", function(module, exports) {

$parcel$export(module.exports, "createRangeTransform", function () { return $f78e16431a9c4641$export$af4628cd15bbfbf2; });

var $2mPYl = parcelRequire("2mPYl");

var $akiB1 = parcelRequire("akiB1");
var $f78e16431a9c4641$var$name = "range";
var $f78e16431a9c4641$var$dependencies = [
    "typed",
    "config",
    "?matrix",
    "?bignumber",
    "smaller",
    "smallerEq",
    "larger",
    "largerEq"
];
var $f78e16431a9c4641$export$af4628cd15bbfbf2 = /* #__PURE__ */ (0, $2mPYl.factory)($f78e16431a9c4641$var$name, $f78e16431a9c4641$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, matrix = _ref.matrix, bignumber = _ref.bignumber, smaller = _ref.smaller, smallerEq = _ref.smallerEq, larger = _ref.larger, largerEq = _ref.largerEq;
    var range = (0, $akiB1.createRange)({
        typed: typed,
        config: config,
        matrix: matrix,
        bignumber: bignumber,
        smaller: smaller,
        smallerEq: smallerEq,
        larger: larger,
        largerEq: largerEq
    });
    /**
   * Attach a transform function to math.range
   * Adds a property transform containing the transform function.
   *
   * This transform creates a range which includes the end value
   */ return typed("range", {
        "...any": function any(args) {
            var lastIndex = args.length - 1;
            var last = args[lastIndex];
            if (typeof last !== "boolean") // append a parameter includeEnd=true
            args.push(true);
            return range.apply(null, args);
        }
    });
}, {
    isTransformFunction: true
});

});
parcelRegister("akiB1", function(module, exports) {

$parcel$export(module.exports, "createRange", function () { return $784a327816150d00$export$d372f2f3c4d1b8e5; });

var $2mPYl = parcelRequire("2mPYl");

var $rJyG2 = parcelRequire("rJyG2");
var $784a327816150d00$var$name = "range";
var $784a327816150d00$var$dependencies = [
    "typed",
    "config",
    "?matrix",
    "?bignumber",
    "smaller",
    "smallerEq",
    "larger",
    "largerEq"
];
var $784a327816150d00$export$d372f2f3c4d1b8e5 = /* #__PURE__ */ (0, $2mPYl.factory)($784a327816150d00$var$name, $784a327816150d00$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, matrix = _ref.matrix, bignumber = _ref.bignumber, smaller = _ref.smaller, smallerEq = _ref.smallerEq, larger = _ref.larger, largerEq = _ref.largerEq;
    /**
   * Create an array from a range.
   * By default, the range end is excluded. This can be customized by providing
   * an extra parameter `includeEnd`.
   *
   * Syntax:
   *
   *     math.range(str [, includeEnd])               // Create a range from a string,
   *                                                  // where the string contains the
   *                                                  // start, optional step, and end,
   *                                                  // separated by a colon.
   *     math.range(start, end [, includeEnd])        // Create a range with start and
   *                                                  // end and a step size of 1.
   *     math.range(start, end, step [, includeEnd])  // Create a range with start, step,
   *                                                  // and end.
   *
   * Where:
   *
   * - `str: string`
   *   A string 'start:end' or 'start:step:end'
   * - `start: {number | BigNumber}`
   *   Start of the range
   * - `end: number | BigNumber`
   *   End of the range, excluded by default, included when parameter includeEnd=true
   * - `step: number | BigNumber`
   *   Step size. Default value is 1.
   * - `includeEnd: boolean`
   *   Option to specify whether to include the end or not. False by default.
   *
   * Examples:
   *
   *     math.range(2, 6)        // [2, 3, 4, 5]
   *     math.range(2, -3, -1)   // [2, 1, 0, -1, -2]
   *     math.range('2:1:6')     // [2, 3, 4, 5]
   *     math.range(2, 6, true)  // [2, 3, 4, 5, 6]
   *
   * See also:
   *
   *     ones, zeros, size, subset
   *
   * @param {*} args   Parameters describing the ranges `start`, `end`, and optional `step`.
   * @return {Array | Matrix} range
   */ return typed($784a327816150d00$var$name, {
        // TODO: simplify signatures when typed-function supports default values and optional arguments
        // TODO: a number or boolean should not be converted to string here
        string: _strRange,
        "string, boolean": _strRange,
        "number, number": function numberNumber(start, end) {
            return _out(_rangeEx(start, end, 1));
        },
        "number, number, number": function numberNumberNumber(start, end, step) {
            return _out(_rangeEx(start, end, step));
        },
        "number, number, boolean": function numberNumberBoolean(start, end, includeEnd) {
            return includeEnd ? _out(_rangeInc(start, end, 1)) : _out(_rangeEx(start, end, 1));
        },
        "number, number, number, boolean": function numberNumberNumberBoolean(start, end, step, includeEnd) {
            return includeEnd ? _out(_rangeInc(start, end, step)) : _out(_rangeEx(start, end, step));
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(start, end) {
            var BigNumber = start.constructor;
            return _out(_bigRangeEx(start, end, new BigNumber(1)));
        },
        "BigNumber, BigNumber, BigNumber": function BigNumberBigNumberBigNumber(start, end, step) {
            return _out(_bigRangeEx(start, end, step));
        },
        "BigNumber, BigNumber, boolean": function BigNumberBigNumberBoolean(start, end, includeEnd) {
            var BigNumber = start.constructor;
            return includeEnd ? _out(_bigRangeInc(start, end, new BigNumber(1))) : _out(_bigRangeEx(start, end, new BigNumber(1)));
        },
        "BigNumber, BigNumber, BigNumber, boolean": function BigNumberBigNumberBigNumberBoolean(start, end, step, includeEnd) {
            return includeEnd ? _out(_bigRangeInc(start, end, step)) : _out(_bigRangeEx(start, end, step));
        }
    });
    function _out(arr) {
        if (config.matrix === "Matrix") return matrix ? matrix(arr) : (0, $rJyG2.noMatrix)();
        return arr;
    }
    function _strRange(str, includeEnd) {
        var r = _parse(str);
        if (!r) throw new SyntaxError('String "' + str + '" is no valid range');
        var fn;
        if (config.number === "BigNumber") {
            if (bignumber === undefined) (0, $rJyG2.noBignumber)();
            fn = includeEnd ? _bigRangeInc : _bigRangeEx;
            return _out(fn(bignumber(r.start), bignumber(r.end), bignumber(r.step)));
        } else {
            fn = includeEnd ? _rangeInc : _rangeEx;
            return _out(fn(r.start, r.end, r.step));
        }
    }
    /**
   * Create a range with numbers. End is excluded
   * @param {number} start
   * @param {number} end
   * @param {number} step
   * @returns {Array} range
   * @private
   */ function _rangeEx(start, end, step) {
        var array = [];
        var x = start;
        if (step > 0) while(smaller(x, end)){
            array.push(x);
            x += step;
        }
        else if (step < 0) while(larger(x, end)){
            array.push(x);
            x += step;
        }
        return array;
    }
    /**
   * Create a range with numbers. End is included
   * @param {number} start
   * @param {number} end
   * @param {number} step
   * @returns {Array} range
   * @private
   */ function _rangeInc(start, end, step) {
        var array = [];
        var x = start;
        if (step > 0) while(smallerEq(x, end)){
            array.push(x);
            x += step;
        }
        else if (step < 0) while(largerEq(x, end)){
            array.push(x);
            x += step;
        }
        return array;
    }
    /**
   * Create a range with big numbers. End is excluded
   * @param {BigNumber} start
   * @param {BigNumber} end
   * @param {BigNumber} step
   * @returns {Array} range
   * @private
   */ function _bigRangeEx(start, end, step) {
        var zero = bignumber(0);
        var array = [];
        var x = start;
        if (step.gt(zero)) while(smaller(x, end)){
            array.push(x);
            x = x.plus(step);
        }
        else if (step.lt(zero)) while(larger(x, end)){
            array.push(x);
            x = x.plus(step);
        }
        return array;
    }
    /**
   * Create a range with big numbers. End is included
   * @param {BigNumber} start
   * @param {BigNumber} end
   * @param {BigNumber} step
   * @returns {Array} range
   * @private
   */ function _bigRangeInc(start, end, step) {
        var zero = bignumber(0);
        var array = [];
        var x = start;
        if (step.gt(zero)) while(smallerEq(x, end)){
            array.push(x);
            x = x.plus(step);
        }
        else if (step.lt(zero)) while(largerEq(x, end)){
            array.push(x);
            x = x.plus(step);
        }
        return array;
    }
    /**
   * Parse a string into a range,
   * The string contains the start, optional step, and end, separated by a colon.
   * If the string does not contain a valid range, null is returned.
   * For example str='0:2:11'.
   * @param {string} str
   * @return {{start: number, end: number, step: number} | null} range Object containing properties start, end, step
   * @private
   */ function _parse(str) {
        var args = str.split(":"); // number
        var nums = args.map(function(arg) {
            // use Number and not parseFloat as Number returns NaN on invalid garbage in the string
            return Number(arg);
        });
        var invalid = nums.some(function(num) {
            return isNaN(num);
        });
        if (invalid) return null;
        switch(nums.length){
            case 2:
                return {
                    start: nums[0],
                    end: nums[1],
                    step: 1
                };
            case 3:
                return {
                    start: nums[0],
                    end: nums[2],
                    step: nums[1]
                };
            default:
                return null;
        }
    }
});

});
parcelRegister("rJyG2", function(module, exports) {

$parcel$export(module.exports, "noBignumber", function () { return $0535dca98c1b8ef2$export$f0829713dc162a8; });
$parcel$export(module.exports, "noFraction", function () { return $0535dca98c1b8ef2$export$9978fd42ef220ba0; });
$parcel$export(module.exports, "noMatrix", function () { return $0535dca98c1b8ef2$export$b81416cb7ecca475; });
function $0535dca98c1b8ef2$export$f0829713dc162a8() {
    throw new Error('No "bignumber" implementation available');
}
function $0535dca98c1b8ef2$export$9978fd42ef220ba0() {
    throw new Error('No "fraction" implementation available');
}
function $0535dca98c1b8ef2$export$b81416cb7ecca475() {
    throw new Error('No "matrix" implementation available');
}
function $0535dca98c1b8ef2$export$a38f8cf2e48f2bd() {
    throw new Error('No "index" implementation available');
}
function $0535dca98c1b8ef2$export$32411ef9704d5eea() {
    throw new Error('No "matrix" implementation available');
}

});



parcelRegister("1uL9J", function(module, exports) {

$parcel$export(module.exports, "createRationalize", function () { return $116d2c0092d59d6b$export$abd0968f5b11b2a8; });

var $kFRKb = parcelRequire("kFRKb");

var $2mPYl = parcelRequire("2mPYl");

var $8lPHq = parcelRequire("8lPHq");

var $6FJEW = parcelRequire("6FJEW");
var $116d2c0092d59d6b$var$name = "rationalize";
var $116d2c0092d59d6b$var$dependencies = [
    "config",
    "typed",
    "equal",
    "isZero",
    "add",
    "subtract",
    "multiply",
    "divide",
    "pow",
    "parse",
    "simplify",
    "?bignumber",
    "?fraction",
    "mathWithTransform",
    "ConstantNode",
    "OperatorNode",
    "FunctionNode",
    "SymbolNode",
    "ParenthesisNode"
];
var $116d2c0092d59d6b$export$abd0968f5b11b2a8 = /* #__PURE__ */ (0, $2mPYl.factory)($116d2c0092d59d6b$var$name, $116d2c0092d59d6b$var$dependencies, function(_ref) {
    var config = _ref.config, typed = _ref.typed, equal = _ref.equal, isZero = _ref.isZero, add = _ref.add, subtract = _ref.subtract, multiply = _ref.multiply, divide = _ref.divide, pow = _ref.pow, parse = _ref.parse, simplify = _ref.simplify, fraction = _ref.fraction, bignumber = _ref.bignumber, mathWithTransform = _ref.mathWithTransform, ConstantNode = _ref.ConstantNode, OperatorNode = _ref.OperatorNode, FunctionNode = _ref.FunctionNode, SymbolNode = _ref.SymbolNode, ParenthesisNode = _ref.ParenthesisNode;
    var simplifyConstant = (0, $8lPHq.createSimplifyConstant)({
        typed: typed,
        config: config,
        mathWithTransform: mathWithTransform,
        fraction: fraction,
        bignumber: bignumber,
        ConstantNode: ConstantNode,
        OperatorNode: OperatorNode,
        FunctionNode: FunctionNode,
        SymbolNode: SymbolNode
    });
    var simplifyCore = (0, $6FJEW.createSimplifyCore)({
        equal: equal,
        isZero: isZero,
        add: add,
        subtract: subtract,
        multiply: multiply,
        divide: divide,
        pow: pow,
        ConstantNode: ConstantNode,
        OperatorNode: OperatorNode,
        FunctionNode: FunctionNode,
        ParenthesisNode: ParenthesisNode
    });
    /**
   * Transform a rationalizable expression in a rational fraction.
   * If rational fraction is one variable polynomial then converts
   * the numerator and denominator in canonical form, with decreasing
   * exponents, returning the coefficients of numerator.
   *
   * Syntax:
   *
   *     rationalize(expr)
   *     rationalize(expr, detailed)
   *     rationalize(expr, scope)
   *     rationalize(expr, scope, detailed)
   *
   * Examples:
   *
   *     math.rationalize('sin(x)+y')
   *                   //  Error: There is an unsolved function call
   *     math.rationalize('2x/y - y/(x+1)')
   *                   // (2*x^2-y^2+2*x)/(x*y+y)
   *     math.rationalize('(2x+1)^6')
   *                   // 64*x^6+192*x^5+240*x^4+160*x^3+60*x^2+12*x+1
   *     math.rationalize('2x/( (2x-1) / (3x+2) ) - 5x/ ( (3x+4) / (2x^2-5) ) + 3')
   *                   // -20*x^4+28*x^3+104*x^2+6*x-12)/(6*x^2+5*x-4)
   *     math.rationalize('x/(1-x)/(x-2)/(x-3)/(x-4) + 2x/ ( (1-2x)/(2-3x) )/ ((3-4x)/(4-5x) )') =
   *                   // (-30*x^7+344*x^6-1506*x^5+3200*x^4-3472*x^3+1846*x^2-381*x)/
   *                   //     (-8*x^6+90*x^5-383*x^4+780*x^3-797*x^2+390*x-72)
   *
   *     math.rationalize('x+x+x+y',{y:1}) // 3*x+1
   *     math.rationalize('x+x+x+y',{})    // 3*x+y
   *
   *     const ret = math.rationalize('x+x+x+y',{},true)
   *                   // ret.expression=3*x+y, ret.variables = ["x","y"]
   *     const ret = math.rationalize('-2+5x^2',{},true)
   *                   // ret.expression=5*x^2-2, ret.variables = ["x"], ret.coefficients=[-2,0,5]
   *
   * See also:
   *
   *     simplify
   *
   * @param  {Node|string} expr    The expression to check if is a polynomial expression
   * @param  {Object|boolean}      optional scope of expression or true for already evaluated rational expression at input
   * @param  {Boolean}  detailed   optional True if return an object, false if return expression node (default)
   *
   * @return {Object | Node}    The rational polynomial of `expr` or na object
   *            {Object}
   *              {Expression Node} expression: node simplified expression
   *              {Expression Node} numerator: simplified numerator of expression
   *              {Expression Node | boolean} denominator: simplified denominator or false (if there is no denominator)
   *              {Array}           variables:  variable names
   *              {Array}           coefficients: coefficients of numerator sorted by increased exponent
   *           {Expression Node}  node simplified expression
   *
   */ var rationalize = typed($116d2c0092d59d6b$var$name, {
        string: function string(expr) {
            return rationalize(parse(expr), {}, false);
        },
        "string, boolean": function stringBoolean(expr, detailed) {
            return rationalize(parse(expr), {}, detailed);
        },
        "string, Object": function stringObject(expr, scope) {
            return rationalize(parse(expr), scope, false);
        },
        "string, Object, boolean": function stringObjectBoolean(expr, scope, detailed) {
            return rationalize(parse(expr), scope, detailed);
        },
        Node: function Node(expr) {
            return rationalize(expr, {}, false);
        },
        "Node, boolean": function NodeBoolean(expr, detailed) {
            return rationalize(expr, {}, detailed);
        },
        "Node, Object": function NodeObject(expr, scope) {
            return rationalize(expr, scope, false);
        },
        "Node, Object, boolean": function NodeObjectBoolean(expr, scope, detailed) {
            var setRules = rulesRationalize(); // Rules for change polynomial in near canonical form
            var polyRet = polynomial(expr, scope, true, setRules.firstRules); // Check if expression is a rationalizable polynomial
            var nVars = polyRet.variables.length;
            expr = polyRet.expression;
            if (nVars >= 1) {
                // If expression in not a constant
                expr = expandPower(expr); // First expand power of polynomials (cannot be made from rules!)
                var sBefore; // Previous expression
                var rules;
                var eDistrDiv = true;
                var redoInic = false;
                expr = simplify(expr, setRules.firstRules, {}, {
                    exactFractions: false
                }); // Apply the initial rules, including succ div rules
                var s;
                while(true){
                    // Apply alternately  successive division rules and distr.div.rules
                    rules = eDistrDiv ? setRules.distrDivRules : setRules.sucDivRules;
                    expr = simplify(expr, rules); // until no more changes
                    eDistrDiv = !eDistrDiv; // Swap between Distr.Div and Succ. Div. Rules
                    s = expr.toString();
                    if (s === sBefore) break; // No changes : end of the loop
                    redoInic = true;
                    sBefore = s;
                }
                if (redoInic) // Apply first rules again without succ div rules (if there are changes)
                expr = simplify(expr, setRules.firstRulesAgain, {}, {
                    exactFractions: false
                });
                expr = simplify(expr, setRules.finalRules, {}, {
                    exactFractions: false
                }); // Apply final rules
            } // NVars >= 1
            var coefficients = [];
            var retRationalize = {};
            if (expr.type === "OperatorNode" && expr.isBinary() && expr.op === "/") {
                // Separate numerator from denominator
                if (nVars === 1) {
                    expr.args[0] = polyToCanonical(expr.args[0], coefficients);
                    expr.args[1] = polyToCanonical(expr.args[1]);
                }
                if (detailed) {
                    retRationalize.numerator = expr.args[0];
                    retRationalize.denominator = expr.args[1];
                }
            } else {
                if (nVars === 1) expr = polyToCanonical(expr, coefficients);
                if (detailed) {
                    retRationalize.numerator = expr;
                    retRationalize.denominator = null;
                }
            } // nVars
            if (!detailed) return expr;
            retRationalize.coefficients = coefficients;
            retRationalize.variables = polyRet.variables;
            retRationalize.expression = expr;
            return retRationalize;
        } // ^^^^^^^ end of rationalize ^^^^^^^^
    }); // end of typed rationalize
    /**
   *  Function to simplify an expression using an optional scope and
   *  return it if the expression is a polynomial expression, i.e.
   *  an expression with one or more variables and the operators
   *  +, -, *, and ^, where the exponent can only be a positive integer.
   *
   * Syntax:
   *
   *     polynomial(expr,scope,extended, rules)
   *
   * @param  {Node | string} expr     The expression to simplify and check if is polynomial expression
   * @param  {object} scope           Optional scope for expression simplification
   * @param  {boolean} extended       Optional. Default is false. When true allows divide operator.
   * @param  {array}  rules           Optional. Default is no rule.
   *
   *
   * @return {Object}
   *            {Object} node:   node simplified expression
   *            {Array}  variables:  variable names
   */ function polynomial(expr, scope, extended, rules) {
        var variables = [];
        var node = simplify(expr, rules, scope, {
            exactFractions: false
        }); // Resolves any variables and functions with all defined parameters
        extended = !!extended;
        var oper = "+-*" + (extended ? "/" : "");
        recPoly(node);
        var retFunc = {};
        retFunc.expression = node;
        retFunc.variables = variables;
        return retFunc; // -------------------------------------------------------------------------------------------------------
        /**
     *  Function to simplify an expression using an optional scope and
     *  return it if the expression is a polynomial expression, i.e.
     *  an expression with one or more variables and the operators
     *  +, -, *, and ^, where the exponent can only be a positive integer.
     *
     * Syntax:
     *
     *     recPoly(node)
     *
     *
     * @param  {Node} node               The current sub tree expression in recursion
     *
     * @return                           nothing, throw an exception if error
     */ function recPoly(node) {
            var tp = node.type; // node type
            if (tp === "FunctionNode") // No function call in polynomial expression
            throw new Error("There is an unsolved function call");
            else if (tp === "OperatorNode") {
                if (node.op === "^") {
                    // TODO: handle negative exponents like in '1/x^(-2)'
                    if (node.args[1].type !== "ConstantNode" || !(0, $kFRKb.isInteger)(parseFloat(node.args[1].value))) throw new Error("There is a non-integer exponent");
                    else recPoly(node.args[0]);
                } else {
                    if (oper.indexOf(node.op) === -1) throw new Error("Operator " + node.op + " invalid in polynomial expression");
                    for(var i = 0; i < node.args.length; i++)recPoly(node.args[i]);
                } // type of operator
            } else if (tp === "SymbolNode") {
                var _name = node.name; // variable name
                var pos = variables.indexOf(_name);
                if (pos === -1) // new variable in expression
                variables.push(_name);
            } else if (tp === "ParenthesisNode") recPoly(node.content);
            else if (tp !== "ConstantNode") throw new Error("type " + tp + " is not allowed in polynomial expression");
        } // end of recPoly
    } // end of polynomial
    // ---------------------------------------------------------------------------------------
    /**
   * Return a rule set to rationalize an polynomial expression in rationalize
   *
   * Syntax:
   *
   *     rulesRationalize()
   *
   * @return {array}        rule set to rationalize an polynomial expression
   */ function rulesRationalize() {
        var oldRules = [
            simplifyCore,
            {
                l: "n+n",
                r: "2*n"
            },
            {
                l: "n+-n",
                r: "0"
            },
            simplifyConstant,
            {
                l: "n*(n1^-1)",
                r: "n/n1"
            },
            {
                l: "n*n1^-n2",
                r: "n/n1^n2"
            },
            {
                l: "n1^-1",
                r: "1/n1"
            },
            {
                l: "n*(n1/n2)",
                r: "(n*n1)/n2"
            },
            {
                l: "1*n",
                r: "n"
            }
        ];
        var rulesFirst = [
            {
                l: "(-n1)/(-n2)",
                r: "n1/n2"
            },
            {
                l: "(-n1)*(-n2)",
                r: "n1*n2"
            },
            {
                l: "n1--n2",
                r: "n1+n2"
            },
            {
                l: "n1-n2",
                r: "n1+(-n2)"
            },
            {
                l: "(n1+n2)*n3",
                r: "(n1*n3 + n2*n3)"
            },
            {
                l: "n1*(n2+n3)",
                r: "(n1*n2+n1*n3)"
            },
            {
                l: "c1*n + c2*n",
                r: "(c1+c2)*n"
            },
            {
                l: "c1*n + n",
                r: "(c1+1)*n"
            },
            {
                l: "c1*n - c2*n",
                r: "(c1-c2)*n"
            },
            {
                l: "c1*n - n",
                r: "(c1-1)*n"
            },
            {
                l: "v/c",
                r: "(1/c)*v"
            },
            {
                l: "v/-c",
                r: "-(1/c)*v"
            },
            {
                l: "-v*-c",
                r: "c*v"
            },
            {
                l: "-v*c",
                r: "-c*v"
            },
            {
                l: "v*-c",
                r: "-c*v"
            },
            {
                l: "v*c",
                r: "c*v"
            },
            {
                l: "-(-n1*n2)",
                r: "(n1*n2)"
            },
            {
                l: "-(n1*n2)",
                r: "(-n1*n2)"
            },
            {
                l: "-(-n1+n2)",
                r: "(n1-n2)"
            },
            {
                l: "-(n1+n2)",
                r: "(-n1-n2)"
            },
            {
                l: "(n1^n2)^n3",
                r: "(n1^(n2*n3))"
            },
            {
                l: "-(-n1/n2)",
                r: "(n1/n2)"
            },
            {
                l: "-(n1/n2)",
                r: "(-n1/n2)"
            }
        ]; // Divisao and Unary
        var rulesDistrDiv = [
            {
                l: "(n1/n2 + n3/n4)",
                r: "((n1*n4 + n3*n2)/(n2*n4))"
            },
            {
                l: "(n1/n2 + n3)",
                r: "((n1 + n3*n2)/n2)"
            },
            {
                l: "(n1 + n2/n3)",
                r: "((n1*n3 + n2)/n3)"
            }
        ]; // Sum fraction with number 1
        var rulesSucDiv = [
            {
                l: "(n1/(n2/n3))",
                r: "((n1*n3)/n2)"
            },
            {
                l: "(n1/n2/n3)",
                r: "(n1/(n2*n3))"
            }
        ];
        var setRules = {}; // rules set in 4 steps.
        // All rules => infinite loop
        // setRules.allRules =oldRules.concat(rulesFirst,rulesDistrDiv,rulesSucDiv)
        setRules.firstRules = oldRules.concat(rulesFirst, rulesSucDiv); // First rule set
        setRules.distrDivRules = rulesDistrDiv; // Just distr. div. rules
        setRules.sucDivRules = rulesSucDiv; // Jus succ. div. rules
        setRules.firstRulesAgain = oldRules.concat(rulesFirst); // Last rules set without succ. div.
        // Division simplification
        // Second rule set.
        // There is no aggregate expression with parentesis, but the only variable can be scattered.
        setRules.finalRules = [
            simplifyCore,
            {
                l: "n*-n",
                r: "-n^2"
            },
            {
                l: "n*n",
                r: "n^2"
            },
            simplifyConstant,
            {
                l: "n*-n^n1",
                r: "-n^(n1+1)"
            },
            {
                l: "n*n^n1",
                r: "n^(n1+1)"
            },
            {
                l: "n^n1*-n^n2",
                r: "-n^(n1+n2)"
            },
            {
                l: "n^n1*n^n2",
                r: "n^(n1+n2)"
            },
            {
                l: "n^n1*-n",
                r: "-n^(n1+1)"
            },
            {
                l: "n^n1*n",
                r: "n^(n1+1)"
            },
            {
                l: "n^n1/-n",
                r: "-n^(n1-1)"
            },
            {
                l: "n^n1/n",
                r: "n^(n1-1)"
            },
            {
                l: "n/-n^n1",
                r: "-n^(1-n1)"
            },
            {
                l: "n/n^n1",
                r: "n^(1-n1)"
            },
            {
                l: "n^n1/-n^n2",
                r: "n^(n1-n2)"
            },
            {
                l: "n^n1/n^n2",
                r: "n^(n1-n2)"
            },
            {
                l: "n1+(-n2*n3)",
                r: "n1-n2*n3"
            },
            {
                l: "v*(-c)",
                r: "-c*v"
            },
            {
                l: "n1+-n2",
                r: "n1-n2"
            },
            {
                l: "v*c",
                r: "c*v"
            },
            {
                l: "(n1^n2)^n3",
                r: "(n1^(n2*n3))"
            } // Power to Power
        ];
        return setRules;
    } // End rulesRationalize
    // ---------------------------------------------------------------------------------------
    /**
   *  Expand recursively a tree node for handling with expressions with exponents
   *  (it's not for constants, symbols or functions with exponents)
   *  PS: The other parameters are internal for recursion
   *
   * Syntax:
   *
   *     expandPower(node)
   *
   * @param  {Node} node         Current expression node
   * @param  {node} parent       Parent current node inside the recursion
   * @param  (int}               Parent number of chid inside the rercursion
   *
   * @return {node}        node expression with all powers expanded.
   */ function expandPower(node, parent, indParent) {
        var tp = node.type;
        var internal = arguments.length > 1; // TRUE in internal calls
        if (tp === "OperatorNode" && node.isBinary()) {
            var does = false;
            var val;
            if (node.op === "^") // First operator: Parenthesis or UnaryMinus
            {
                if ((node.args[0].type === "ParenthesisNode" || node.args[0].type === "OperatorNode") && node.args[1].type === "ConstantNode") {
                    // Second operator: Constant
                    val = parseFloat(node.args[1].value);
                    does = val >= 2 && (0, $kFRKb.isInteger)(val);
                }
            }
            if (does) {
                // Exponent >= 2
                // Before:
                //            operator A --> Subtree
                // parent pow
                //            constant
                //
                if (val > 2) {
                    // Exponent > 2,
                    // AFTER:  (exponent > 2)
                    //             operator A --> Subtree
                    // parent  *
                    //                 deep clone (operator A --> Subtree
                    //             pow
                    //                 constant - 1
                    //
                    var nEsqTopo = node.args[0];
                    var nDirTopo = new OperatorNode("^", "pow", [
                        node.args[0].cloneDeep(),
                        new ConstantNode(val - 1)
                    ]);
                    node = new OperatorNode("*", "multiply", [
                        nEsqTopo,
                        nDirTopo
                    ]);
                } else // Expo = 2 - no power
                // AFTER:  (exponent =  2)
                //             operator A --> Subtree
                // parent   oper
                //            deep clone (operator A --> Subtree)
                //
                node = new OperatorNode("*", "multiply", [
                    node.args[0],
                    node.args[0].cloneDeep()
                ]);
                if (internal) {
                    // Change parent references in internal recursive calls
                    if (indParent === "content") parent.content = node;
                    else parent.args[indParent] = node;
                }
            } // does
        } // binary OperatorNode
        if (tp === "ParenthesisNode") // Recursion
        expandPower(node.content, node, "content");
        else if (tp !== "ConstantNode" && tp !== "SymbolNode") for(var i = 0; i < node.args.length; i++)expandPower(node.args[i], node, i);
        if (!internal) // return the root node
        return node;
    } // End expandPower
    // ---------------------------------------------------------------------------------------
    /**
   * Auxilary function for rationalize
   * Convert near canonical polynomial in one variable in a canonical polynomial
   * with one term for each exponent in decreasing order
   *
   * Syntax:
   *
   *     polyToCanonical(node [, coefficients])
   *
   * @param  {Node | string} expr       The near canonical polynomial expression to convert in a a canonical polynomial expression
   *
   *        The string or tree expression needs to be at below syntax, with free spaces:
   *         (  (^(-)? | [+-]? )cte (*)? var (^expo)?  | cte )+
   *       Where 'var' is one variable with any valid name
   *             'cte' are real numeric constants with any value. It can be omitted if equal than 1
   *             'expo' are integers greater than 0. It can be omitted if equal than 1.
   *
   * @param  {array}   coefficients             Optional returns coefficients sorted by increased exponent
   *
   *
   * @return {node}        new node tree with one variable polynomial or string error.
   */ function polyToCanonical(node, coefficients) {
        if (coefficients === undefined) coefficients = [];
         // coefficients.
        coefficients[0] = 0; // index is the exponent
        var o = {};
        o.cte = 1;
        o.oper = "+"; // fire: mark with * or ^ when finds * or ^ down tree, reset to "" with + and -.
        //       It is used to deduce the exponent: 1 for *, 0 for "".
        o.fire = "";
        var maxExpo = 0; // maximum exponent
        var varname = ""; // variable name
        recurPol(node, null, o);
        maxExpo = coefficients.length - 1;
        var first = true;
        var no;
        for(var i = maxExpo; i >= 0; i--){
            if (coefficients[i] === 0) continue;
            var n1 = new ConstantNode(first ? coefficients[i] : Math.abs(coefficients[i]));
            var op = coefficients[i] < 0 ? "-" : "+";
            if (i > 0) {
                // Is not a constant without variable
                var n2 = new SymbolNode(varname);
                if (i > 1) {
                    var n3 = new ConstantNode(i);
                    n2 = new OperatorNode("^", "pow", [
                        n2,
                        n3
                    ]);
                }
                if (coefficients[i] === -1 && first) n1 = new OperatorNode("-", "unaryMinus", [
                    n2
                ]);
                else if (Math.abs(coefficients[i]) === 1) n1 = n2;
                else n1 = new OperatorNode("*", "multiply", [
                    n1,
                    n2
                ]);
            }
            if (first) no = n1;
            else if (op === "+") no = new OperatorNode("+", "add", [
                no,
                n1
            ]);
            else no = new OperatorNode("-", "subtract", [
                no,
                n1
            ]);
            first = false;
        } // for
        if (first) return new ConstantNode(0);
        else return no;
        /**
     * Recursive auxilary function inside polyToCanonical for
     * converting expression in canonical form
     *
     * Syntax:
     *
     *     recurPol(node, noPai, obj)
     *
     * @param  {Node} node        The current subpolynomial expression
     * @param  {Node | Null}  noPai   The current parent node
     * @param  {object}    obj        Object with many internal flags
     *
     * @return {}                    No return. If error, throws an exception
     */ function recurPol(node, noPai, o) {
            var tp = node.type;
            if (tp === "FunctionNode") // ***** FunctionName *****
            // No function call in polynomial expression
            throw new Error("There is an unsolved function call");
            else if (tp === "OperatorNode") {
                // ***** OperatorName *****
                if ("+-*^".indexOf(node.op) === -1) throw new Error("Operator " + node.op + " invalid");
                if (noPai !== null) {
                    // -(unary),^  : children of *,+,-
                    if ((node.fn === "unaryMinus" || node.fn === "pow") && noPai.fn !== "add" && noPai.fn !== "subtract" && noPai.fn !== "multiply") throw new Error("Invalid " + node.op + " placing");
                     // -,+,* : children of +,-
                    if ((node.fn === "subtract" || node.fn === "add" || node.fn === "multiply") && noPai.fn !== "add" && noPai.fn !== "subtract") throw new Error("Invalid " + node.op + " placing");
                     // -,+ : first child
                    if ((node.fn === "subtract" || node.fn === "add" || node.fn === "unaryMinus") && o.noFil !== 0) throw new Error("Invalid " + node.op + " placing");
                } // Has parent
                // Firers: ^,*       Old:   ^,&,-(unary): firers
                if (node.op === "^" || node.op === "*") o.fire = node.op;
                for(var _i = 0; _i < node.args.length; _i++){
                    // +,-: reset fire
                    if (node.fn === "unaryMinus") o.oper = "-";
                    if (node.op === "+" || node.fn === "subtract") {
                        o.fire = "";
                        o.cte = 1; // default if there is no constant
                        o.oper = _i === 0 ? "+" : node.op;
                    }
                    o.noFil = _i; // number of son
                    recurPol(node.args[_i], node, o);
                } // for in children
            } else if (tp === "SymbolNode") {
                // ***** SymbolName *****
                if (node.name !== varname && varname !== "") throw new Error("There is more than one variable");
                varname = node.name;
                if (noPai === null) {
                    coefficients[1] = 1;
                    return;
                } // ^: Symbol is First child
                if (noPai.op === "^" && o.noFil !== 0) throw new Error("In power the variable should be the first parameter");
                 // *: Symbol is Second child
                if (noPai.op === "*" && o.noFil !== 1) throw new Error("In multiply the variable should be the second parameter");
                 // Symbol: firers '',* => it means there is no exponent above, so it's 1 (cte * var)
                if (o.fire === "" || o.fire === "*") {
                    if (maxExpo < 1) coefficients[1] = 0;
                    coefficients[1] += o.cte * (o.oper === "+" ? 1 : -1);
                    maxExpo = Math.max(1, maxExpo);
                }
            } else if (tp === "ConstantNode") {
                var valor = parseFloat(node.value);
                if (noPai === null) {
                    coefficients[0] = valor;
                    return;
                }
                if (noPai.op === "^") {
                    // cte: second  child of power
                    if (o.noFil !== 1) throw new Error("Constant cannot be powered");
                    if (!(0, $kFRKb.isInteger)(valor) || valor <= 0) throw new Error("Non-integer exponent is not allowed");
                    for(var _i2 = maxExpo + 1; _i2 < valor; _i2++)coefficients[_i2] = 0;
                    if (valor > maxExpo) coefficients[valor] = 0;
                    coefficients[valor] += o.cte * (o.oper === "+" ? 1 : -1);
                    maxExpo = Math.max(valor, maxExpo);
                    return;
                }
                o.cte = valor; // Cte: firer '' => There is no exponent and no multiplication, so the exponent is 0.
                if (o.fire === "") coefficients[0] += o.cte * (o.oper === "+" ? 1 : -1);
            } else throw new Error("Type " + tp + " is not allowed");
        } // End of recurPol
    } // End of polyToCanonical
    return rationalize;
});

});
parcelRegister("8lPHq", function(module, exports) {

$parcel$export(module.exports, "createSimplifyConstant", function () { return $6148634c293a4367$export$d72b8f0d2b277ae2; });
// TODO this could be improved by simplifying seperated constants under associative and commutative operators

var $1amHZ = parcelRequire("1amHZ");

var $2mPYl = parcelRequire("2mPYl");

var $70kB0 = parcelRequire("70kB0");

var $rJyG2 = parcelRequire("rJyG2");
var $6148634c293a4367$var$name = "simplifyConstant";
var $6148634c293a4367$var$dependencies = [
    "typed",
    "config",
    "mathWithTransform",
    "?fraction",
    "?bignumber",
    "ConstantNode",
    "OperatorNode",
    "FunctionNode",
    "SymbolNode"
];
var $6148634c293a4367$export$d72b8f0d2b277ae2 = /* #__PURE__ */ (0, $2mPYl.factory)($6148634c293a4367$var$name, $6148634c293a4367$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, mathWithTransform = _ref.mathWithTransform, fraction = _ref.fraction, bignumber = _ref.bignumber, ConstantNode = _ref.ConstantNode, OperatorNode = _ref.OperatorNode, FunctionNode = _ref.FunctionNode, SymbolNode = _ref.SymbolNode;
    var _createUtil = (0, $70kB0.createUtil)({
        FunctionNode: FunctionNode,
        OperatorNode: OperatorNode,
        SymbolNode: SymbolNode
    }), isCommutative = _createUtil.isCommutative, isAssociative = _createUtil.isAssociative, allChildren = _createUtil.allChildren, createMakeNodeFunction = _createUtil.createMakeNodeFunction;
    function simplifyConstant(expr, options) {
        var res = foldFraction(expr, options);
        return (0, $1amHZ.isNode)(res) ? res : _toNode(res);
    }
    function _eval(fnname, args, options) {
        try {
            return _toNumber(mathWithTransform[fnname].apply(null, args), options);
        } catch (ignore) {
            // sometimes the implicit type conversion causes the evaluation to fail, so we'll try again after removing Fractions
            args = args.map(function(x) {
                if ((0, $1amHZ.isFraction)(x)) return x.valueOf();
                return x;
            });
            return _toNumber(mathWithTransform[fnname].apply(null, args), options);
        }
    }
    var _toNode = typed({
        Fraction: _fractionToNode,
        number: function number(n) {
            if (n < 0) return unaryMinusNode(new ConstantNode(-n));
            return new ConstantNode(n);
        },
        BigNumber: function BigNumber(n) {
            if (n < 0) return unaryMinusNode(new ConstantNode(-n));
            return new ConstantNode(n); // old parameters: (n.toString(), 'number')
        },
        Complex: function Complex(s) {
            throw new Error("Cannot convert Complex number to Node");
        }
    }); // convert a number to a fraction only if it can be expressed exactly
    function _exactFraction(n, options) {
        var exactFractions = options && options.exactFractions !== false;
        if (exactFractions && isFinite(n) && fraction) {
            var f = fraction(n);
            if (f.valueOf() === n) return f;
        }
        return n;
    } // Convert numbers to a preferred number type in preference order: Fraction, number, Complex
    // BigNumbers are left alone
    var _toNumber = typed({
        "string, Object": function stringObject(s, options) {
            if (config.number === "BigNumber") {
                if (bignumber === undefined) (0, $rJyG2.noBignumber)();
                return bignumber(s);
            } else if (config.number === "Fraction") {
                if (fraction === undefined) (0, $rJyG2.noFraction)();
                return fraction(s);
            } else {
                var n = parseFloat(s);
                return _exactFraction(n, options);
            }
        },
        "Fraction, Object": function FractionObject(s, options) {
            return s;
        },
        // we don't need options here
        "BigNumber, Object": function BigNumberObject(s, options) {
            return s;
        },
        // we don't need options here
        "number, Object": function numberObject(s, options) {
            return _exactFraction(s, options);
        },
        "Complex, Object": function ComplexObject(s, options) {
            if (s.im !== 0) return s;
            return _exactFraction(s.re, options);
        }
    });
    function unaryMinusNode(n) {
        return new OperatorNode("-", "unaryMinus", [
            n
        ]);
    }
    function _fractionToNode(f) {
        var n;
        var vn = f.s * f.n;
        if (vn < 0) n = new OperatorNode("-", "unaryMinus", [
            new ConstantNode(-vn)
        ]);
        else n = new ConstantNode(vn);
        if (f.d === 1) return n;
        return new OperatorNode("/", "divide", [
            n,
            new ConstantNode(f.d)
        ]);
    }
    /*
   * Create a binary tree from a list of Fractions and Nodes.
   * Tries to fold Fractions by evaluating them until the first Node in the list is hit, so
   * `args` should be sorted to have the Fractions at the start (if the operator is commutative).
   * @param args - list of Fractions and Nodes
   * @param fn - evaluator for the binary operation evaluator that accepts two Fractions
   * @param makeNode - creates a binary OperatorNode/FunctionNode from a list of child Nodes
   * if args.length is 1, returns args[0]
   * @return - Either a Node representing a binary expression or Fraction
   */ function foldOp(fn, args, makeNode, options) {
        return args.reduce(function(a, b) {
            if (!(0, $1amHZ.isNode)(a) && !(0, $1amHZ.isNode)(b)) {
                try {
                    return _eval(fn, [
                        a,
                        b
                    ], options);
                } catch (ignoreandcontinue) {}
                a = _toNode(a);
                b = _toNode(b);
            } else if (!(0, $1amHZ.isNode)(a)) a = _toNode(a);
            else if (!(0, $1amHZ.isNode)(b)) b = _toNode(b);
            return makeNode([
                a,
                b
            ]);
        });
    } // destroys the original node and returns a folded one
    function foldFraction(node, options) {
        switch(node.type){
            case "SymbolNode":
                return node;
            case "ConstantNode":
                if (typeof node.value === "number" || !isNaN(node.value)) return _toNumber(node.value, options);
                return node;
            case "FunctionNode":
                if (mathWithTransform[node.name] && mathWithTransform[node.name].rawArgs) return node;
                // Process operators as OperatorNode
                var operatorFunctions = [
                    "add",
                    "multiply"
                ];
                if (operatorFunctions.indexOf(node.name) === -1) {
                    var args = node.args.map(function(arg) {
                        return foldFraction(arg, options);
                    }); // If all args are numbers
                    if (!args.some((0, $1amHZ.isNode))) try {
                        return _eval(node.name, args, options);
                    } catch (ignoreandcontine) {}
                     // Convert all args to nodes and construct a symbolic function call
                    args = args.map(function(arg) {
                        return (0, $1amHZ.isNode)(arg) ? arg : _toNode(arg);
                    });
                    return new FunctionNode(node.name, args);
                }
            /* falls through */ case "OperatorNode":
                var fn = node.fn.toString();
                var _args;
                var res;
                var makeNode = createMakeNodeFunction(node);
                if ((0, $1amHZ.isOperatorNode)(node) && node.isUnary()) {
                    _args = [
                        foldFraction(node.args[0], options)
                    ];
                    if (!(0, $1amHZ.isNode)(_args[0])) res = _eval(fn, _args, options);
                    else res = makeNode(_args);
                } else if (isAssociative(node)) {
                    _args = allChildren(node);
                    _args = _args.map(function(arg) {
                        return foldFraction(arg, options);
                    });
                    if (isCommutative(fn)) {
                        // commutative binary operator
                        var consts = [];
                        var vars = [];
                        for(var i = 0; i < _args.length; i++)if (!(0, $1amHZ.isNode)(_args[i])) consts.push(_args[i]);
                        else vars.push(_args[i]);
                        if (consts.length > 1) {
                            res = foldOp(fn, consts, makeNode, options);
                            vars.unshift(res);
                            res = foldOp(fn, vars, makeNode, options);
                        } else // we won't change the children order since it's not neccessary
                        res = foldOp(fn, _args, makeNode, options);
                    } else // non-commutative binary operator
                    res = foldOp(fn, _args, makeNode, options);
                } else {
                    // non-associative binary operator
                    _args = node.args.map(function(arg) {
                        return foldFraction(arg, options);
                    });
                    res = foldOp(fn, _args, makeNode, options);
                }
                return res;
            case "ParenthesisNode":
                // remove the uneccessary parenthesis
                return foldFraction(node.content, options);
            case "AccessorNode":
            /* falls through */ case "ArrayNode":
            /* falls through */ case "AssignmentNode":
            /* falls through */ case "BlockNode":
            /* falls through */ case "FunctionAssignmentNode":
            /* falls through */ case "IndexNode":
            /* falls through */ case "ObjectNode":
            /* falls through */ case "RangeNode":
            /* falls through */ case "ConditionalNode":
            /* falls through */ default:
                throw new Error("Unimplemented node type in simplifyConstant: ".concat(node.type));
        }
    }
    return simplifyConstant;
});

});
parcelRegister("70kB0", function(module, exports) {

$parcel$export(module.exports, "createUtil", function () { return $51988260c2a4bad7$export$f2206d57cebf291a; });

var $1amHZ = parcelRequire("1amHZ");

var $2mPYl = parcelRequire("2mPYl");

var $7ITGG = parcelRequire("7ITGG");
var $51988260c2a4bad7$var$name = "simplifyUtil";
var $51988260c2a4bad7$var$dependencies = [
    "FunctionNode",
    "OperatorNode",
    "SymbolNode"
];
var $51988260c2a4bad7$export$f2206d57cebf291a = /* #__PURE__ */ (0, $2mPYl.factory)($51988260c2a4bad7$var$name, $51988260c2a4bad7$var$dependencies, function(_ref) {
    var FunctionNode = _ref.FunctionNode, OperatorNode = _ref.OperatorNode, SymbolNode = _ref.SymbolNode;
    // TODO commutative/associative properties rely on the arguments
    // e.g. multiply is not commutative for matrices
    // The properties should be calculated from an argument to simplify, or possibly something in math.config
    // the other option is for typed() to specify a return type so that we can evaluate the type of arguments
    var commutative = {
        add: true,
        multiply: true
    };
    var associative = {
        add: true,
        multiply: true
    };
    function isCommutative(node, context) {
        if (!(0, $1amHZ.isOperatorNode)(node)) return true;
        var name = node.fn.toString();
        if (context && (0, $7ITGG.hasOwnProperty)(context, name) && (0, $7ITGG.hasOwnProperty)(context[name], "commutative")) return context[name].commutative;
        return commutative[name] || false;
    }
    function isAssociative(node, context) {
        if (!(0, $1amHZ.isOperatorNode)(node)) return false;
        var name = node.fn.toString();
        if (context && (0, $7ITGG.hasOwnProperty)(context, name) && (0, $7ITGG.hasOwnProperty)(context[name], "associative")) return context[name].associative;
        return associative[name] || false;
    }
    /**
   * Flatten all associative operators in an expression tree.
   * Assumes parentheses have already been removed.
   */ function flatten(node) {
        if (!node.args || node.args.length === 0) return node;
        node.args = allChildren(node);
        for(var i = 0; i < node.args.length; i++)flatten(node.args[i]);
    }
    /**
   * Get the children of a node as if it has been flattened.
   * TODO implement for FunctionNodes
   */ function allChildren(node) {
        var op;
        var children = [];
        var findChildren = function findChildren(node) {
            for(var i = 0; i < node.args.length; i++){
                var child = node.args[i];
                if ((0, $1amHZ.isOperatorNode)(child) && op === child.op) findChildren(child);
                else children.push(child);
            }
        };
        if (isAssociative(node)) {
            op = node.op;
            findChildren(node);
            return children;
        } else return node.args;
    }
    /**
   *  Unflatten all flattened operators to a right-heavy binary tree.
   */ function unflattenr(node) {
        if (!node.args || node.args.length === 0) return;
        var makeNode = createMakeNodeFunction(node);
        var l = node.args.length;
        for(var i = 0; i < l; i++)unflattenr(node.args[i]);
        if (l > 2 && isAssociative(node)) {
            var curnode = node.args.pop();
            while(node.args.length > 0)curnode = makeNode([
                node.args.pop(),
                curnode
            ]);
            node.args = curnode.args;
        }
    }
    /**
   *  Unflatten all flattened operators to a left-heavy binary tree.
   */ function unflattenl(node) {
        if (!node.args || node.args.length === 0) return;
        var makeNode = createMakeNodeFunction(node);
        var l = node.args.length;
        for(var i = 0; i < l; i++)unflattenl(node.args[i]);
        if (l > 2 && isAssociative(node)) {
            var curnode = node.args.shift();
            while(node.args.length > 0)curnode = makeNode([
                curnode,
                node.args.shift()
            ]);
            node.args = curnode.args;
        }
    }
    function createMakeNodeFunction(node) {
        if ((0, $1amHZ.isOperatorNode)(node)) return function(args) {
            try {
                return new OperatorNode(node.op, node.fn, args, node.implicit);
            } catch (err) {
                console.error(err);
                return [];
            }
        };
        else return function(args) {
            return new FunctionNode(new SymbolNode(node.name), args);
        };
    }
    return {
        createMakeNodeFunction: createMakeNodeFunction,
        isCommutative: isCommutative,
        isAssociative: isAssociative,
        flatten: flatten,
        allChildren: allChildren,
        unflattenr: unflattenr,
        unflattenl: unflattenl
    };
});

});


parcelRegister("6FJEW", function(module, exports) {

$parcel$export(module.exports, "createSimplifyCore", function () { return $4db9fd6b7846fd8a$export$c3d7d520703291df; });

var $1amHZ = parcelRequire("1amHZ");

var $2mPYl = parcelRequire("2mPYl");
var $4db9fd6b7846fd8a$var$name = "simplifyCore";
var $4db9fd6b7846fd8a$var$dependencies = [
    "equal",
    "isZero",
    "add",
    "subtract",
    "multiply",
    "divide",
    "pow",
    "ConstantNode",
    "OperatorNode",
    "FunctionNode",
    "ParenthesisNode"
];
var $4db9fd6b7846fd8a$export$c3d7d520703291df = /* #__PURE__ */ (0, $2mPYl.factory)($4db9fd6b7846fd8a$var$name, $4db9fd6b7846fd8a$var$dependencies, function(_ref) {
    var equal = _ref.equal, isZero = _ref.isZero, add = _ref.add, subtract = _ref.subtract, multiply = _ref.multiply, divide = _ref.divide, pow = _ref.pow, ConstantNode = _ref.ConstantNode, OperatorNode = _ref.OperatorNode, FunctionNode = _ref.FunctionNode, ParenthesisNode = _ref.ParenthesisNode;
    var node0 = new ConstantNode(0);
    var node1 = new ConstantNode(1);
    /**
   * simplifyCore() performs single pass simplification suitable for
   * applications requiring ultimate performance. In contrast, simplify()
   * extends simplifyCore() with additional passes to provide deeper
   * simplification.
   *
   * Syntax:
   *
   *     simplify.simplifyCore(expr)
   *
   * Examples:
   *
   *     const f = math.parse('2 * 1 * x ^ (2 - 1)')
   *     math.simplify.simpifyCore(f)                          // Node {2 * x}
   *     math.simplify('2 * 1 * x ^ (2 - 1)', [math.simplify.simpifyCore]) // Node {2 * x}
   *
   * See also:
   *
   *     derivative
   *
   * @param {Node} node
   *     The expression to be simplified
   */ function simplifyCore(node) {
        if ((0, $1amHZ.isOperatorNode)(node) && node.isUnary()) {
            var a0 = simplifyCore(node.args[0]);
            if (node.op === "+") // unary plus
            return a0;
            if (node.op === "-") {
                // unary minus
                if ((0, $1amHZ.isOperatorNode)(a0)) {
                    if (a0.isUnary() && a0.op === "-") return a0.args[0];
                    else if (a0.isBinary() && a0.fn === "subtract") return new OperatorNode("-", "subtract", [
                        a0.args[1],
                        a0.args[0]
                    ]);
                }
                return new OperatorNode(node.op, node.fn, [
                    a0
                ]);
            }
        } else if ((0, $1amHZ.isOperatorNode)(node) && node.isBinary()) {
            var _a = simplifyCore(node.args[0]);
            var a1 = simplifyCore(node.args[1]);
            if (node.op === "+") {
                if ((0, $1amHZ.isConstantNode)(_a)) {
                    if (isZero(_a.value)) return a1;
                    else if ((0, $1amHZ.isConstantNode)(a1)) return new ConstantNode(add(_a.value, a1.value));
                }
                if ((0, $1amHZ.isConstantNode)(a1) && isZero(a1.value)) return _a;
                if ((0, $1amHZ.isOperatorNode)(a1) && a1.isUnary() && a1.op === "-") return new OperatorNode("-", "subtract", [
                    _a,
                    a1.args[0]
                ]);
                return new OperatorNode(node.op, node.fn, a1 ? [
                    _a,
                    a1
                ] : [
                    _a
                ]);
            } else if (node.op === "-") {
                if ((0, $1amHZ.isConstantNode)(_a) && a1) {
                    if ((0, $1amHZ.isConstantNode)(a1)) return new ConstantNode(subtract(_a.value, a1.value));
                    else if (isZero(_a.value)) return new OperatorNode("-", "unaryMinus", [
                        a1
                    ]);
                } // if (node.fn === "subtract" && node.args.length === 2) {
                if (node.fn === "subtract") {
                    if ((0, $1amHZ.isConstantNode)(a1) && isZero(a1.value)) return _a;
                    if ((0, $1amHZ.isOperatorNode)(a1) && a1.isUnary() && a1.op === "-") return simplifyCore(new OperatorNode("+", "add", [
                        _a,
                        a1.args[0]
                    ]));
                    return new OperatorNode(node.op, node.fn, [
                        _a,
                        a1
                    ]);
                }
            } else if (node.op === "*") {
                if ((0, $1amHZ.isConstantNode)(_a)) {
                    if (isZero(_a.value)) return node0;
                    else if (equal(_a.value, 1)) return a1;
                    else if ((0, $1amHZ.isConstantNode)(a1)) return new ConstantNode(multiply(_a.value, a1.value));
                }
                if ((0, $1amHZ.isConstantNode)(a1)) {
                    if (isZero(a1.value)) return node0;
                    else if (equal(a1.value, 1)) return _a;
                    else if ((0, $1amHZ.isOperatorNode)(_a) && _a.isBinary() && _a.op === node.op) {
                        var a00 = _a.args[0];
                        if ((0, $1amHZ.isConstantNode)(a00)) {
                            var a00a1 = new ConstantNode(multiply(a00.value, a1.value));
                            return new OperatorNode(node.op, node.fn, [
                                a00a1,
                                _a.args[1]
                            ], node.implicit); // constants on left
                        }
                    }
                    return new OperatorNode(node.op, node.fn, [
                        a1,
                        _a
                    ], node.implicit); // constants on left
                }
                return new OperatorNode(node.op, node.fn, [
                    _a,
                    a1
                ], node.implicit);
            } else if (node.op === "/") {
                if ((0, $1amHZ.isConstantNode)(_a)) {
                    if (isZero(_a.value)) return node0;
                    else if ((0, $1amHZ.isConstantNode)(a1) && (equal(a1.value, 1) || equal(a1.value, 2) || equal(a1.value, 4))) return new ConstantNode(divide(_a.value, a1.value));
                }
                return new OperatorNode(node.op, node.fn, [
                    _a,
                    a1
                ]);
            } else if (node.op === "^") {
                if ((0, $1amHZ.isConstantNode)(a1)) {
                    if (isZero(a1.value)) return node1;
                    else if (equal(a1.value, 1)) return _a;
                    else {
                        if ((0, $1amHZ.isConstantNode)(_a)) // fold constant
                        return new ConstantNode(pow(_a.value, a1.value));
                        else if ((0, $1amHZ.isOperatorNode)(_a) && _a.isBinary() && _a.op === "^") {
                            var a01 = _a.args[1];
                            if ((0, $1amHZ.isConstantNode)(a01)) return new OperatorNode(node.op, node.fn, [
                                _a.args[0],
                                new ConstantNode(multiply(a01.value, a1.value))
                            ]);
                        }
                    }
                }
                return new OperatorNode(node.op, node.fn, [
                    _a,
                    a1
                ]);
            }
        } else if ((0, $1amHZ.isParenthesisNode)(node)) {
            var c = simplifyCore(node.content);
            if ((0, $1amHZ.isParenthesisNode)(c) || (0, $1amHZ.isSymbolNode)(c) || (0, $1amHZ.isConstantNode)(c)) return c;
            return new ParenthesisNode(c);
        } else if ((0, $1amHZ.isFunctionNode)(node)) {
            var args = node.args.map(simplifyCore).map(function(arg) {
                return (0, $1amHZ.isParenthesisNode)(arg) ? arg.content : arg;
            });
            return new FunctionNode(simplifyCore(node.fn), args);
        }
        return node;
    }
    return simplifyCore;
});

});


parcelRegister("hcdH4", function(module, exports) {

$parcel$export(module.exports, "createRelationalNode", function () { return $c84e2deaf182d5c2$export$92a3c2dff1e32f25; });

var $cAxNq = parcelRequire("cAxNq");

var $6NxuJ = parcelRequire("6NxuJ");

var $45IYD = parcelRequire("45IYD");

var $6Zo9s = parcelRequire("6Zo9s");

var $2mPYl = parcelRequire("2mPYl");
var $c84e2deaf182d5c2$var$name = "RelationalNode";
var $c84e2deaf182d5c2$var$dependencies = [
    "Node"
];
var $c84e2deaf182d5c2$export$92a3c2dff1e32f25 = /* #__PURE__ */ (0, $2mPYl.factory)($c84e2deaf182d5c2$var$name, $c84e2deaf182d5c2$var$dependencies, function(_ref) {
    var Node = _ref.Node;
    /**
   * A node representing a chained conditional expression, such as 'x > y > z'
   *
   * @param {String[]} conditionals   An array of conditional operators used to compare the parameters
   * @param {Node[]} params   The parameters that will be compared
   *
   * @constructor RelationalNode
   * @extends {Node}
   */ function RelationalNode(conditionals, params) {
        if (!(this instanceof RelationalNode)) throw new SyntaxError("Constructor must be called with the new operator");
        if (!Array.isArray(conditionals)) throw new TypeError("Parameter conditionals must be an array");
        if (!Array.isArray(params)) throw new TypeError("Parameter params must be an array");
        if (conditionals.length !== params.length - 1) throw new TypeError("Parameter params must contain exactly one more element than parameter conditionals");
        this.conditionals = conditionals;
        this.params = params;
    }
    RelationalNode.prototype = new Node();
    RelationalNode.prototype.type = "RelationalNode";
    RelationalNode.prototype.isRelationalNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ RelationalNode.prototype._compile = function(math, argNames) {
        var self = this;
        var compiled = this.params.map(function(p) {
            return p._compile(math, argNames);
        });
        return function evalRelationalNode(scope, args, context) {
            var evalLhs;
            var evalRhs = compiled[0](scope, args, context);
            for(var i = 0; i < self.conditionals.length; i++){
                evalLhs = evalRhs;
                evalRhs = compiled[i + 1](scope, args, context);
                var condFn = (0, $45IYD.getSafeProperty)(math, self.conditionals[i]);
                if (!condFn(evalLhs, evalRhs)) return false;
            }
            return true;
        };
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ RelationalNode.prototype.forEach = function(callback) {
        var _this = this;
        this.params.forEach(function(n, i) {
            return callback(n, "params[" + i + "]", _this);
        }, this);
    };
    /**
   * Create a new RelationalNode having its childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node): Node} callback
   * @returns {RelationalNode} Returns a transformed copy of the node
   */ RelationalNode.prototype.map = function(callback) {
        var _this2 = this;
        return new RelationalNode(this.conditionals.slice(), this.params.map(function(n, i) {
            return _this2._ifNode(callback(n, "params[" + i + "]", _this2));
        }, this));
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {RelationalNode}
   */ RelationalNode.prototype.clone = function() {
        return new RelationalNode(this.conditionals, this.params);
    };
    /**
   * Get string representation.
   * @param {Object} options
   * @return {string} str
   */ RelationalNode.prototype._toString = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var precedence = (0, $cAxNq.getPrecedence)(this, parenthesis);
        var paramStrings = this.params.map(function(p, index) {
            var paramPrecedence = (0, $cAxNq.getPrecedence)(p, parenthesis);
            return parenthesis === "all" || paramPrecedence !== null && paramPrecedence <= precedence ? "(" + p.toString(options) + ")" : p.toString(options);
        });
        var operatorMap = {
            equal: "==",
            unequal: "!=",
            smaller: "<",
            larger: ">",
            smallerEq: "<=",
            largerEq: ">="
        };
        var ret = paramStrings[0];
        for(var i = 0; i < this.conditionals.length; i++)ret += " " + operatorMap[this.conditionals[i]] + " " + paramStrings[i + 1];
        return ret;
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ RelationalNode.prototype.toJSON = function() {
        return {
            mathjs: "RelationalNode",
            conditionals: this.conditionals,
            params: this.params
        };
    };
    /**
   * Instantiate a RelationalNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "RelationalNode", "condition": ..., "trueExpr": ..., "falseExpr": ...}`,
   *                       where mathjs is optional
   * @returns {RelationalNode}
   */ RelationalNode.fromJSON = function(json) {
        return new RelationalNode(json.conditionals, json.params);
    };
    /**
   * Get HTML representation
   * @param {Object} options
   * @return {string} str
   */ RelationalNode.prototype.toHTML = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var precedence = (0, $cAxNq.getPrecedence)(this, parenthesis);
        var paramStrings = this.params.map(function(p, index) {
            var paramPrecedence = (0, $cAxNq.getPrecedence)(p, parenthesis);
            return parenthesis === "all" || paramPrecedence !== null && paramPrecedence <= precedence ? '<span class="math-parenthesis math-round-parenthesis">(</span>' + p.toHTML(options) + '<span class="math-parenthesis math-round-parenthesis">)</span>' : p.toHTML(options);
        });
        var operatorMap = {
            equal: "==",
            unequal: "!=",
            smaller: "<",
            larger: ">",
            smallerEq: "<=",
            largerEq: ">="
        };
        var ret = paramStrings[0];
        for(var i = 0; i < this.conditionals.length; i++)ret += '<span class="math-operator math-binary-operator math-explicit-binary-operator">' + (0, $6NxuJ.escape)(operatorMap[this.conditionals[i]]) + "</span>" + paramStrings[i + 1];
        return ret;
    };
    /**
   * Get LaTeX representation
   * @param {Object} options
   * @return {string} str
   */ RelationalNode.prototype._toTex = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var precedence = (0, $cAxNq.getPrecedence)(this, parenthesis);
        var paramStrings = this.params.map(function(p, index) {
            var paramPrecedence = (0, $cAxNq.getPrecedence)(p, parenthesis);
            return parenthesis === "all" || paramPrecedence !== null && paramPrecedence <= precedence ? "\\left(" + p.toTex(options) + "\right)" : p.toTex(options);
        });
        var ret = paramStrings[0];
        for(var i = 0; i < this.conditionals.length; i++)ret += (0, $6Zo9s.latexOperators)[this.conditionals[i]] + paramStrings[i + 1];
        return ret;
    };
    return RelationalNode;
}, {
    isClass: true,
    isNode: true
});

});

parcelRegister("9qO5M", function(module, exports) {

$parcel$export(module.exports, "createReviver", function () { return $6ddd660e43b6d076$export$288f43fef560974b; });

var $2mPYl = parcelRequire("2mPYl");
var $6ddd660e43b6d076$var$name = "reviver";
var $6ddd660e43b6d076$var$dependencies = [
    "classes"
];
var $6ddd660e43b6d076$export$288f43fef560974b = /* #__PURE__ */ (0, $2mPYl.factory)($6ddd660e43b6d076$var$name, $6ddd660e43b6d076$var$dependencies, function(_ref) {
    var classes = _ref.classes;
    /**
   * Instantiate mathjs data types from their JSON representation
   * @param {string} key
   * @param {*} value
   * @returns {*} Returns the revived object
   */ return function reviver(key, value) {
        var constructor = classes[value && value.mathjs];
        if (constructor && typeof constructor.fromJSON === "function") return constructor.fromJSON(value);
        return value;
    };
});

});

parcelRegister("a4HxT", function(module, exports) {

$parcel$export(module.exports, "createRowTransform", function () { return $755c0e62d7434142$export$649101a1e7f0c38d; });

var $2mPYl = parcelRequire("2mPYl");

var $hHIzA = parcelRequire("hHIzA");

var $dJ38g = parcelRequire("dJ38g");

var $1amHZ = parcelRequire("1amHZ");
var $755c0e62d7434142$var$name = "row";
var $755c0e62d7434142$var$dependencies = [
    "typed",
    "Index",
    "matrix",
    "range"
];
var $755c0e62d7434142$export$649101a1e7f0c38d = /* #__PURE__ */ (0, $2mPYl.factory)($755c0e62d7434142$var$name, $755c0e62d7434142$var$dependencies, function(_ref) {
    var typed = _ref.typed, Index = _ref.Index, matrix = _ref.matrix, range = _ref.range;
    var row = (0, $hHIzA.createRow)({
        typed: typed,
        Index: Index,
        matrix: matrix,
        range: range
    }); // @see: comment of row itself
    return typed("row", {
        "...any": function any(args) {
            // change last argument from zero-based to one-based
            var lastIndex = args.length - 1;
            var last = args[lastIndex];
            if ((0, $1amHZ.isNumber)(last)) args[lastIndex] = last - 1;
            try {
                return row.apply(null, args);
            } catch (err) {
                throw (0, $dJ38g.errorTransform)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});

});
parcelRegister("hHIzA", function(module, exports) {

$parcel$export(module.exports, "createRow", function () { return $ce3907168eea4df0$export$3442c5d213434705; });

var $2mPYl = parcelRequire("2mPYl");

var $7ITGG = parcelRequire("7ITGG");

var $5WdrK = parcelRequire("5WdrK");
var $ce3907168eea4df0$var$name = "row";
var $ce3907168eea4df0$var$dependencies = [
    "typed",
    "Index",
    "matrix",
    "range"
];
var $ce3907168eea4df0$export$3442c5d213434705 = /* #__PURE__ */ (0, $2mPYl.factory)($ce3907168eea4df0$var$name, $ce3907168eea4df0$var$dependencies, function(_ref) {
    var typed = _ref.typed, Index = _ref.Index, matrix = _ref.matrix, range = _ref.range;
    /**
   * Return a row from a Matrix.
   *
   * Syntax:
   *
   *     math.row(value, index)
   *
   * Example:
   *
   *     // get a row
   *     const d = [[1, 2], [3, 4]]
   *     math.row(d, 1) // returns [[3, 4]]
   *
   * See also:
   *
   *     column
   *
   * @param {Array | Matrix } value   An array or matrix
   * @param {number} row              The index of the row
   * @return {Array | Matrix}         The retrieved row
   */ var row = typed($ce3907168eea4df0$var$name, {
        "Matrix, number": _row,
        "Array, number": function ArrayNumber(value, row) {
            return _row(matrix((0, $7ITGG.clone)(value)), row).valueOf();
        }
    });
    return row;
    /**
   * Retrieve a row of a matrix
   * @param {Matrix } value  A matrix
   * @param {number} row     The index of the row
   * @return {Matrix}        The retrieved row
   */ function _row(value, row) {
        // check dimensions
        if (value.size().length !== 2) throw new Error("Only two dimensional matrix is supported");
        (0, $5WdrK.validateIndex)(row, value.size()[0]);
        var columnRange = range(0, value.size()[1]);
        var index = new Index(row, columnRange);
        return value.subset(index);
    }
});

});


parcelRegister("fvcKJ", function(module, exports) {

$parcel$export(module.exports, "createSimplify", function () { return $b493a4afb461d7d1$export$5085b3a4c8276699; });

var $1amHZ = parcelRequire("1amHZ");

var $2mPYl = parcelRequire("2mPYl");

var $70kB0 = parcelRequire("70kB0");

var $6FJEW = parcelRequire("6FJEW");

var $8lPHq = parcelRequire("8lPHq");

var $1kfe4 = parcelRequire("1kfe4");

var $7ITGG = parcelRequire("7ITGG");
function $b493a4afb461d7d1$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $b493a4afb461d7d1$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $b493a4afb461d7d1$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $b493a4afb461d7d1$var$_typeof(obj);
}
var $b493a4afb461d7d1$var$name = "simplify";
var $b493a4afb461d7d1$var$dependencies = [
    "config",
    "typed",
    "parse",
    "add",
    "subtract",
    "multiply",
    "divide",
    "pow",
    "isZero",
    "equal",
    "?fraction",
    "?bignumber",
    "mathWithTransform",
    "ConstantNode",
    "FunctionNode",
    "OperatorNode",
    "ParenthesisNode",
    "SymbolNode"
];
var $b493a4afb461d7d1$export$5085b3a4c8276699 = /* #__PURE__ */ (0, $2mPYl.factory)($b493a4afb461d7d1$var$name, $b493a4afb461d7d1$var$dependencies, function(_ref) {
    var config = _ref.config, typed = _ref.typed, parse = _ref.parse, add = _ref.add, subtract = _ref.subtract, multiply = _ref.multiply, divide = _ref.divide, pow = _ref.pow, isZero = _ref.isZero, equal = _ref.equal, fraction = _ref.fraction, bignumber = _ref.bignumber, mathWithTransform = _ref.mathWithTransform, ConstantNode = _ref.ConstantNode, FunctionNode = _ref.FunctionNode, OperatorNode = _ref.OperatorNode, ParenthesisNode = _ref.ParenthesisNode, SymbolNode = _ref.SymbolNode;
    var simplifyConstant = (0, $8lPHq.createSimplifyConstant)({
        typed: typed,
        config: config,
        mathWithTransform: mathWithTransform,
        fraction: fraction,
        bignumber: bignumber,
        ConstantNode: ConstantNode,
        OperatorNode: OperatorNode,
        FunctionNode: FunctionNode,
        SymbolNode: SymbolNode
    });
    var simplifyCore = (0, $6FJEW.createSimplifyCore)({
        equal: equal,
        isZero: isZero,
        add: add,
        subtract: subtract,
        multiply: multiply,
        divide: divide,
        pow: pow,
        ConstantNode: ConstantNode,
        OperatorNode: OperatorNode,
        FunctionNode: FunctionNode,
        ParenthesisNode: ParenthesisNode
    });
    var resolve = (0, $1kfe4.createResolve)({
        parse: parse,
        FunctionNode: FunctionNode,
        OperatorNode: OperatorNode,
        ParenthesisNode: ParenthesisNode
    });
    var _createUtil = (0, $70kB0.createUtil)({
        FunctionNode: FunctionNode,
        OperatorNode: OperatorNode,
        SymbolNode: SymbolNode
    }), isCommutative = _createUtil.isCommutative, isAssociative = _createUtil.isAssociative, flatten = _createUtil.flatten, unflattenr = _createUtil.unflattenr, unflattenl = _createUtil.unflattenl, createMakeNodeFunction = _createUtil.createMakeNodeFunction;
    /**
   * Simplify an expression tree.
   *
   * A list of rules are applied to an expression, repeating over the list until
   * no further changes are made.
   * It's possible to pass a custom set of rules to the function as second
   * argument. A rule can be specified as an object, string, or function:
   *
   *     const rules = [
   *       { l: 'n1*n3 + n2*n3', r: '(n1+n2)*n3' },
   *       'n1*n3 + n2*n3 -> (n1+n2)*n3',
   *       function (node) {
   *         // ... return a new node or return the node unchanged
   *         return node
   *       }
   *     ]
   *
   * String and object rules consist of a left and right pattern. The left is
   * used to match against the expression and the right determines what matches
   * are replaced with. The main difference between a pattern and a normal
   * expression is that variables starting with the following characters are
   * interpreted as wildcards:
   *
   * - 'n' - matches any Node
   * - 'c' - matches any ConstantNode
   * - 'v' - matches any Node that is not a ConstantNode
   *
   * The default list of rules is exposed on the function as `simplify.rules`
   * and can be used as a basis to built a set of custom rules.
   *
   * For more details on the theory, see:
   *
   * - [Strategies for simplifying math expressions (Stackoverflow)](https://stackoverflow.com/questions/7540227/strategies-for-simplifying-math-expressions)
   * - [Symbolic computation - Simplification (Wikipedia)](https://en.wikipedia.org/wiki/Symbolic_computation#Simplification)
   *
   *  An optional `options` argument can be passed as last argument of `simplify`.
   *  There is currently one option available: `exactFractions`, a boolean which
   *  is `true` by default.
   *
   * Syntax:
   *
   *     simplify(expr)
   *     simplify(expr, rules)
   *     simplify(expr, rules)
   *     simplify(expr, rules, scope)
   *     simplify(expr, rules, scope, options)
   *     simplify(expr, scope)
   *     simplify(expr, scope, options)
   *
   * Examples:
   *
   *     math.simplify('2 * 1 * x ^ (2 - 1)')      // Node "2 * x"
   *     math.simplify('2 * 3 * x', {x: 4})        // Node "24"
   *     const f = math.parse('2 * 1 * x ^ (2 - 1)')
   *     math.simplify(f)                          // Node "2 * x"
   *     math.simplify('0.4 * x', {}, {exactFractions: true})  // Node "x * 2 / 5"
   *     math.simplify('0.4 * x', {}, {exactFractions: false}) // Node "0.4 * x"
   *
   * See also:
   *
   *     derivative, parse, evaluate, rationalize
   *
   * @param {Node | string} expr
   *            The expression to be simplified
   * @param {Array<{l:string, r: string} | string | function>} [rules]
   *            Optional list with custom rules
   * @return {Node} Returns the simplified form of `expr`
   */ var simplify = typed("simplify", {
        string: function string(expr) {
            return simplify(parse(expr), simplify.rules, {}, {});
        },
        "string, Object": function stringObject(expr, scope) {
            return simplify(parse(expr), simplify.rules, scope, {});
        },
        "string, Object, Object": function stringObjectObject(expr, scope, options) {
            return simplify(parse(expr), simplify.rules, scope, options);
        },
        "string, Array": function stringArray(expr, rules) {
            return simplify(parse(expr), rules, {}, {});
        },
        "string, Array, Object": function stringArrayObject(expr, rules, scope) {
            return simplify(parse(expr), rules, scope, {});
        },
        "string, Array, Object, Object": function stringArrayObjectObject(expr, rules, scope, options) {
            return simplify(parse(expr), rules, scope, options);
        },
        "Node, Object": function NodeObject(expr, scope) {
            return simplify(expr, simplify.rules, scope, {});
        },
        "Node, Object, Object": function NodeObjectObject(expr, scope, options) {
            return simplify(expr, simplify.rules, scope, options);
        },
        Node: function Node(expr) {
            return simplify(expr, simplify.rules, {}, {});
        },
        "Node, Array": function NodeArray(expr, rules) {
            return simplify(expr, rules, {}, {});
        },
        "Node, Array, Object": function NodeArrayObject(expr, rules, scope) {
            return simplify(expr, rules, scope, {});
        },
        "Node, Array, Object, Object": function NodeArrayObjectObject(expr, rules, scope, options) {
            rules = _buildRules(rules);
            var res = resolve(expr, scope);
            res = removeParens(res);
            var visited = {};
            var str = res.toString({
                parenthesis: "all"
            });
            while(!visited[str]){
                visited[str] = true;
                _lastsym = 0; // counter for placeholder symbols
                for(var i = 0; i < rules.length; i++){
                    if (typeof rules[i] === "function") res = rules[i](res, options);
                    else {
                        flatten(res);
                        res = applyRule(res, rules[i]);
                    }
                    unflattenl(res); // using left-heavy binary tree here since custom rule functions may expect it
                }
                str = res.toString({
                    parenthesis: "all"
                });
            }
            return res;
        }
    });
    simplify.simplifyCore = simplifyCore;
    simplify.resolve = resolve;
    function removeParens(node) {
        return node.transform(function(node, path, parent) {
            return (0, $1amHZ.isParenthesisNode)(node) ? removeParens(node.content) : node;
        });
    } // All constants that are allowed in rules
    var SUPPORTED_CONSTANTS = {
        "true": true,
        "false": true,
        e: true,
        i: true,
        Infinity: true,
        LN2: true,
        LN10: true,
        LOG2E: true,
        LOG10E: true,
        NaN: true,
        phi: true,
        pi: true,
        SQRT1_2: true,
        SQRT2: true,
        tau: true // null: false,
    }; // Array of strings, used to build the ruleSet.
    // Each l (left side) and r (right side) are parsed by
    // the expression parser into a node tree.
    // Left hand sides are matched to subtrees within the
    // expression to be parsed and replaced with the right
    // hand side.
    // TODO: Add support for constraints on constants (either in the form of a '=' expression or a callback [callback allows things like comparing symbols alphabetically])
    // To evaluate lhs constants for rhs constants, use: { l: 'c1+c2', r: 'c3', evaluate: 'c3 = c1 + c2' }. Multiple assignments are separated by ';' in block format.
    // It is possible to get into an infinite loop with conflicting rules
    simplify.rules = [
        simplifyCore,
        // { l: 'n^0', r: '1' },     // simplifyCore
        // { l: '0*n', r: '0' },     // simplifyCore
        // { l: 'n/n', r: '1'},      // simplifyCore
        // { l: 'n^1', r: 'n' },     // simplifyCore
        // { l: '+n1', r:'n1' },     // simplifyCore
        // { l: 'n--n1', r:'n+n1' }, // simplifyCore
        {
            l: "log(e)",
            r: "1"
        },
        {
            l: "n-n1",
            r: "n+-n1"
        },
        {
            l: "-(c*v)",
            r: "(-c) * v"
        },
        {
            l: "-v",
            r: "(-1) * v"
        },
        {
            l: "n/n1^n2",
            r: "n*n1^-n2"
        },
        {
            l: "n/n1",
            r: "n*n1^-1"
        },
        {
            l: "(n ^ n1) ^ n2",
            r: "n ^ (n1 * n2)"
        },
        {
            l: "n*n",
            r: "n^2"
        },
        {
            l: "n * n^n1",
            r: "n^(n1+1)"
        },
        {
            l: "n^n1 * n^n2",
            r: "n^(n1+n2)"
        },
        {
            l: "n+n",
            r: "2*n"
        },
        {
            l: "n+-n",
            r: "0"
        },
        {
            l: "n1*n2 + n2",
            r: "(n1+1)*n2"
        },
        {
            l: "n1*n3 + n2*n3",
            r: "(n1+n2)*n3"
        },
        {
            l: "n1 + -1 * (n2 + n3)",
            r: "n1 + -1 * n2 + -1 * n3"
        },
        simplifyConstant,
        {
            l: "(-n)*n1",
            r: "-(n*n1)"
        },
        // ordering of constants
        {
            l: "c+v",
            r: "v+c",
            context: {
                add: {
                    commutative: false
                }
            }
        },
        {
            l: "v*c",
            r: "c*v",
            context: {
                multiply: {
                    commutative: false
                }
            }
        },
        // { l: '(-1) * n', r: '-n' }, // #811 added test which proved this is redundant
        {
            l: "n+-n1",
            r: "n-n1"
        },
        {
            l: "n*(n1^-1)",
            r: "n/n1"
        },
        {
            l: "n*n1^-n2",
            r: "n/n1^n2"
        },
        {
            l: "n1^-1",
            r: "1/n1"
        },
        {
            l: "n*(n1/n2)",
            r: "(n*n1)/n2"
        },
        {
            l: "n-(n1+n2)",
            r: "n-n1-n2"
        },
        // { l: '(n1/n2)/n3', r: 'n1/(n2*n3)' },
        // { l: '(n*n1)/(n*n2)', r: 'n1/n2' },
        {
            l: "1*n",
            r: "n"
        },
        {
            l: "n1/(n2/n3)",
            r: "(n1*n3)/n2"
        }
    ];
    /**
   * Parse the string array of rules into nodes
   *
   * Example syntax for rules:
   *
   * Position constants to the left in a product:
   * { l: 'n1 * c1', r: 'c1 * n1' }
   * n1 is any Node, and c1 is a ConstantNode.
   *
   * Apply difference of squares formula:
   * { l: '(n1 - n2) * (n1 + n2)', r: 'n1^2 - n2^2' }
   * n1, n2 mean any Node.
   *
   * Short hand notation:
   * 'n1 * c1 -> c1 * n1'
   */ function _buildRules(rules) {
        // Array of rules to be used to simplify expressions
        var ruleSet = [];
        for(var i = 0; i < rules.length; i++){
            var rule = rules[i];
            var newRule = void 0;
            var ruleType = $b493a4afb461d7d1$var$_typeof(rule);
            switch(ruleType){
                case "string":
                    var lr = rule.split("->");
                    if (lr.length === 2) rule = {
                        l: lr[0],
                        r: lr[1]
                    };
                    else throw SyntaxError("Could not parse rule: " + rule);
                /* falls through */ case "object":
                    newRule = {
                        l: removeParens(parse(rule.l)),
                        r: removeParens(parse(rule.r))
                    };
                    if (rule.context) newRule.evaluate = rule.context;
                    if (rule.evaluate) newRule.evaluate = parse(rule.evaluate);
                    if (isAssociative(newRule.l)) {
                        var makeNode = createMakeNodeFunction(newRule.l);
                        var expandsym = _getExpandPlaceholderSymbol();
                        newRule.expanded = {};
                        newRule.expanded.l = makeNode([
                            newRule.l.clone(),
                            expandsym
                        ]); // Push the expandsym into the deepest possible branch.
                        // This helps to match the newRule against nodes returned from getSplits() later on.
                        flatten(newRule.expanded.l);
                        unflattenr(newRule.expanded.l);
                        newRule.expanded.r = makeNode([
                            newRule.r,
                            expandsym
                        ]);
                    }
                    break;
                case "function":
                    newRule = rule;
                    break;
                default:
                    throw TypeError("Unsupported type of rule: " + ruleType);
            } // console.log('Adding rule: ' + rules[i])
            // console.log(newRule)
            ruleSet.push(newRule);
        }
        return ruleSet;
    }
    var _lastsym = 0;
    function _getExpandPlaceholderSymbol() {
        return new SymbolNode("_p" + _lastsym++);
    }
    /**
   * Returns a simplfied form of node, or the original node if no simplification was possible.
   *
   * @param  {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} node
   * @return {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} The simplified form of `expr`, or the original node if no simplification was possible.
   */ var applyRule = typed("applyRule", {
        "Node, Object": function NodeObject(node, rule) {
            // console.log('Entering applyRule(' + node.toString() + ')')
            // Do not clone node unless we find a match
            var res = node; // First replace our child nodes with their simplified versions
            // If a child could not be simplified, the assignments will have
            // no effect since the node is returned unchanged
            if (res instanceof OperatorNode || res instanceof FunctionNode) {
                if (res.args) for(var i = 0; i < res.args.length; i++)res.args[i] = applyRule(res.args[i], rule);
            } else if (res instanceof ParenthesisNode) {
                if (res.content) res.content = applyRule(res.content, rule);
            } // Try to match a rule against this node
            var repl = rule.r;
            var matches = _ruleMatch(rule.l, res)[0]; // If the rule is associative operator, we can try matching it while allowing additional terms.
            // This allows us to match rules like 'n+n' to the expression '(1+x)+x' or even 'x+1+x' if the operator is commutative.
            if (!matches && rule.expanded) {
                repl = rule.expanded.r;
                matches = _ruleMatch(rule.expanded.l, res)[0];
            }
            if (matches) {
                // const before = res.toString({parenthesis: 'all'})
                // Create a new node by cloning the rhs of the matched rule
                // we keep any implicit multiplication state if relevant
                var implicit = res.implicit;
                res = repl.clone();
                if (implicit && "implicit" in repl) res.implicit = true;
                 // Replace placeholders with their respective nodes without traversing deeper into the replaced nodes
                res = res.transform(function(node) {
                    if (node.isSymbolNode && (0, $7ITGG.hasOwnProperty)(matches.placeholders, node.name)) return matches.placeholders[node.name].clone();
                    else return node;
                }); // const after = res.toString({parenthesis: 'all'})
            // console.log('Simplified ' + before + ' to ' + after)
            }
            return res;
        }
    });
    /**
   * Get (binary) combinations of a flattened binary node
   * e.g. +(node1, node2, node3) -> [
   *        +(node1,  +(node2, node3)),
   *        +(node2,  +(node1, node3)),
   *        +(node3,  +(node1, node2))]
   *
   */ function getSplits(node, context) {
        var res = [];
        var right, rightArgs;
        var makeNode = createMakeNodeFunction(node);
        if (isCommutative(node, context)) for(var i = 0; i < node.args.length; i++){
            rightArgs = node.args.slice(0);
            rightArgs.splice(i, 1);
            right = rightArgs.length === 1 ? rightArgs[0] : makeNode(rightArgs);
            res.push(makeNode([
                node.args[i],
                right
            ]));
        }
        else {
            rightArgs = node.args.slice(1);
            right = rightArgs.length === 1 ? rightArgs[0] : makeNode(rightArgs);
            res.push(makeNode([
                node.args[0],
                right
            ]));
        }
        return res;
    }
    /**
   * Returns the set union of two match-placeholders or null if there is a conflict.
   */ function mergeMatch(match1, match2) {
        var res = {
            placeholders: {}
        }; // Some matches may not have placeholders; this is OK
        if (!match1.placeholders && !match2.placeholders) return res;
        else if (!match1.placeholders) return match2;
        else if (!match2.placeholders) return match1;
         // Placeholders with the same key must match exactly
        for(var key in match1.placeholders){
            res.placeholders[key] = match1.placeholders[key];
            if ((0, $7ITGG.hasOwnProperty)(match2.placeholders, key)) {
                if (!_exactMatch(match1.placeholders[key], match2.placeholders[key])) return null;
            }
        }
        for(var _key in match2.placeholders)res.placeholders[_key] = match2.placeholders[_key];
        return res;
    }
    /**
   * Combine two lists of matches by applying mergeMatch to the cartesian product of two lists of matches.
   * Each list represents matches found in one child of a node.
   */ function combineChildMatches(list1, list2) {
        var res = [];
        if (list1.length === 0 || list2.length === 0) return res;
        var merged;
        for(var i1 = 0; i1 < list1.length; i1++)for(var i2 = 0; i2 < list2.length; i2++){
            merged = mergeMatch(list1[i1], list2[i2]);
            if (merged) res.push(merged);
        }
        return res;
    }
    /**
   * Combine multiple lists of matches by applying mergeMatch to the cartesian product of two lists of matches.
   * Each list represents matches found in one child of a node.
   * Returns a list of unique matches.
   */ function mergeChildMatches(childMatches) {
        if (childMatches.length === 0) return childMatches;
        var sets = childMatches.reduce(combineChildMatches);
        var uniqueSets = [];
        var unique = {};
        for(var i = 0; i < sets.length; i++){
            var s = JSON.stringify(sets[i]);
            if (!unique[s]) {
                unique[s] = true;
                uniqueSets.push(sets[i]);
            }
        }
        return uniqueSets;
    }
    /**
   * Determines whether node matches rule.
   *
   * @param {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} rule
   * @param {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} node
   * @return {Object} Information about the match, if it exists.
   */ function _ruleMatch(rule, node, isSplit) {
        //    console.log('Entering _ruleMatch(' + JSON.stringify(rule) + ', ' + JSON.stringify(node) + ')')
        //    console.log('rule = ' + rule)
        //    console.log('node = ' + node)
        //    console.log('Entering _ruleMatch(' + rule.toString() + ', ' + node.toString() + ')')
        var res = [
            {
                placeholders: {}
            }
        ];
        if (rule instanceof OperatorNode && node instanceof OperatorNode || rule instanceof FunctionNode && node instanceof FunctionNode) {
            // If the rule is an OperatorNode or a FunctionNode, then node must match exactly
            if (rule instanceof OperatorNode) {
                if (rule.op !== node.op || rule.fn !== node.fn) return [];
            } else if (rule instanceof FunctionNode) {
                if (rule.name !== node.name) return [];
            } // rule and node match. Search the children of rule and node.
            if (node.args.length === 1 && rule.args.length === 1 || !isAssociative(node) || isSplit) {
                // Expect non-associative operators to match exactly
                var childMatches = [];
                for(var i = 0; i < rule.args.length; i++){
                    var childMatch = _ruleMatch(rule.args[i], node.args[i]);
                    if (childMatch.length === 0) // Child did not match, so stop searching immediately
                    return [];
                     // The child matched, so add the information returned from the child to our result
                    childMatches.push(childMatch);
                }
                res = mergeChildMatches(childMatches);
            } else if (node.args.length >= 2 && rule.args.length === 2) {
                // node is flattened, rule is not
                // Associative operators/functions can be split in different ways so we check if the rule matches each
                // them and return their union.
                var splits = getSplits(node, rule.context);
                var splitMatches = [];
                for(var _i = 0; _i < splits.length; _i++){
                    var matchSet = _ruleMatch(rule, splits[_i], true); // recursing at the same tree depth here
                    splitMatches = splitMatches.concat(matchSet);
                }
                return splitMatches;
            } else if (rule.args.length > 2) throw Error("Unexpected non-binary associative function: " + rule.toString());
            else // Incorrect number of arguments in rule and node, so no match
            return [];
        } else if (rule instanceof SymbolNode) {
            // If the rule is a SymbolNode, then it carries a special meaning
            // according to the first character of the symbol node name.
            // c.* matches a ConstantNode
            // n.* matches any node
            if (rule.name.length === 0) throw new Error("Symbol in rule has 0 length...!?");
            if (SUPPORTED_CONSTANTS[rule.name]) {
                // built-in constant must match exactly
                if (rule.name !== node.name) return [];
            } else if (rule.name[0] === "n" || rule.name.substring(0, 2) === "_p") // rule matches _anything_, so assign this node to the rule.name placeholder
            // Assign node to the rule.name placeholder.
            // Our parent will check for matches among placeholders.
            res[0].placeholders[rule.name] = node;
            else if (rule.name[0] === "v") {
                // rule matches any variable thing (not a ConstantNode)
                if (!(0, $1amHZ.isConstantNode)(node)) res[0].placeholders[rule.name] = node;
                else // Mis-match: rule was expecting something other than a ConstantNode
                return [];
            } else if (rule.name[0] === "c") {
                // rule matches any ConstantNode
                if (node instanceof ConstantNode) res[0].placeholders[rule.name] = node;
                else // Mis-match: rule was expecting a ConstantNode
                return [];
            } else throw new Error("Invalid symbol in rule: " + rule.name);
        } else if (rule instanceof ConstantNode) {
            // Literal constant must match exactly
            if (!equal(rule.value, node.value)) return [];
        } else // Some other node was encountered which we aren't prepared for, so no match
        return [];
         // It's a match!
        // console.log('_ruleMatch(' + rule.toString() + ', ' + node.toString() + ') found a match')
        return res;
    }
    /**
   * Determines whether p and q (and all their children nodes) are identical.
   *
   * @param {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} p
   * @param {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} q
   * @return {Object} Information about the match, if it exists.
   */ function _exactMatch(p, q) {
        if (p instanceof ConstantNode && q instanceof ConstantNode) {
            if (!equal(p.value, q.value)) return false;
        } else if (p instanceof SymbolNode && q instanceof SymbolNode) {
            if (p.name !== q.name) return false;
        } else if (p instanceof OperatorNode && q instanceof OperatorNode || p instanceof FunctionNode && q instanceof FunctionNode) {
            if (p instanceof OperatorNode) {
                if (p.op !== q.op || p.fn !== q.fn) return false;
            } else if (p instanceof FunctionNode) {
                if (p.name !== q.name) return false;
            }
            if (p.args.length !== q.args.length) return false;
            for(var i = 0; i < p.args.length; i++){
                if (!_exactMatch(p.args[i], q.args[i])) return false;
            }
        } else return false;
        return true;
    }
    return simplify;
});

});
parcelRegister("1kfe4", function(module, exports) {

$parcel$export(module.exports, "createResolve", function () { return $0f7378444ad7cc31$export$de059f4622c7c2ca; });

var $1amHZ = parcelRequire("1amHZ");

var $2mPYl = parcelRequire("2mPYl");
var $0f7378444ad7cc31$var$name = "resolve";
var $0f7378444ad7cc31$var$dependencies = [
    "parse",
    "FunctionNode",
    "OperatorNode",
    "ParenthesisNode"
];
var $0f7378444ad7cc31$export$de059f4622c7c2ca = /* #__PURE__ */ (0, $2mPYl.factory)($0f7378444ad7cc31$var$name, $0f7378444ad7cc31$var$dependencies, function(_ref) {
    var parse = _ref.parse, FunctionNode = _ref.FunctionNode, OperatorNode = _ref.OperatorNode, ParenthesisNode = _ref.ParenthesisNode;
    /**
   * resolve(expr, scope) replaces variable nodes with their scoped values
   *
   * Syntax:
   *
   *     simplify.resolve(expr, scope)
   *
   * Examples:
   *
   *     math.simplify.resolve('x + y', {x:1, y:2})           // Node {1 + 2}
   *     math.simplify.resolve(math.parse('x+y'), {x:1, y:2}) // Node {1 + 2}
   *     math.simplify('x+y', {x:2, y:'x+x'}).toString()      // "6"
   *
   * @param {Node} node
   *     The expression tree to be simplified
   * @param {Object} scope with variables to be resolved
   */ function resolve(node, scope) {
        if (!scope) return node;
        if ((0, $1amHZ.isSymbolNode)(node)) {
            var value = scope[node.name];
            if ((0, $1amHZ.isNode)(value)) return resolve(value, scope);
            else if (typeof value === "number") return parse(String(value));
        } else if ((0, $1amHZ.isOperatorNode)(node)) {
            var args = node.args.map(function(arg) {
                return resolve(arg, scope);
            });
            return new OperatorNode(node.op, node.fn, args, node.implicit);
        } else if ((0, $1amHZ.isParenthesisNode)(node)) return new ParenthesisNode(resolve(node.content, scope));
        else if ((0, $1amHZ.isFunctionNode)(node)) {
            var _args = node.args.map(function(arg) {
                return resolve(arg, scope);
            });
            return new FunctionNode(node.name, _args);
        }
        return node;
    }
    return resolve;
});

});


parcelRegister("jJ20c", function(module, exports) {

$parcel$export(module.exports, "createStdTransform", function () { return $e5c3c5e2fd86b8e6$export$ef5049c11f391200; });

var $2mPYl = parcelRequire("2mPYl");

var $dirAu = parcelRequire("dirAu");

var $1amHZ = parcelRequire("1amHZ");

var $dJ38g = parcelRequire("dJ38g");
var $e5c3c5e2fd86b8e6$var$name = "std";
var $e5c3c5e2fd86b8e6$var$dependencies = [
    "typed",
    "sqrt",
    "variance"
];
var $e5c3c5e2fd86b8e6$export$ef5049c11f391200 = /* #__PURE__ */ (0, $2mPYl.factory)($e5c3c5e2fd86b8e6$var$name, $e5c3c5e2fd86b8e6$var$dependencies, function(_ref) {
    var typed = _ref.typed, sqrt = _ref.sqrt, variance = _ref.variance;
    var std = (0, $dirAu.createStd)({
        typed: typed,
        sqrt: sqrt,
        variance: variance
    });
    return typed("std", {
        "...any": function any(args) {
            // change last argument dim from one-based to zero-based
            if (args.length >= 2 && (0, $1amHZ.isCollection)(args[0])) {
                var dim = args[1];
                if ((0, $1amHZ.isNumber)(dim)) args[1] = dim - 1;
                else if ((0, $1amHZ.isBigNumber)(dim)) args[1] = dim.minus(1);
            }
            try {
                return std.apply(null, args);
            } catch (err) {
                throw (0, $dJ38g.errorTransform)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});

});
parcelRegister("dirAu", function(module, exports) {

$parcel$export(module.exports, "createStd", function () { return $9ae25b2346cb5935$export$d3f0a8dda5df7afd; });

var $2mPYl = parcelRequire("2mPYl");
var $9ae25b2346cb5935$var$name = "std";
var $9ae25b2346cb5935$var$dependencies = [
    "typed",
    "sqrt",
    "variance"
];
var $9ae25b2346cb5935$export$d3f0a8dda5df7afd = /* #__PURE__ */ (0, $2mPYl.factory)($9ae25b2346cb5935$var$name, $9ae25b2346cb5935$var$dependencies, function(_ref) {
    var typed = _ref.typed, sqrt = _ref.sqrt, variance = _ref.variance;
    /**
   * Compute the standard deviation of a matrix or a  list with values.
   * The standard deviations is defined as the square root of the variance:
   * `std(A) = sqrt(variance(A))`.
   * In case of a (multi dimensional) array or matrix, the standard deviation
   * over all elements will be calculated by default, unless an axis is specified
   * in which case the standard deviation will be computed along that axis.
   *
   * Additionally, it is possible to compute the standard deviation along the rows
   * or columns of a matrix by specifying the dimension as the second argument.
   *
   * Optionally, the type of normalization can be specified as the final
   * parameter. The parameter `normalization` can be one of the following values:
   *
   * - 'unbiased' (default) The sum of squared errors is divided by (n - 1)
   * - 'uncorrected'        The sum of squared errors is divided by n
   * - 'biased'             The sum of squared errors is divided by (n + 1)
   *
   *
   * Syntax:
   *
   *     math.std(a, b, c, ...)
   *     math.std(A)
   *     math.std(A, normalization)
   *     math.std(A, dimension)
   *     math.std(A, dimension, normalization)
   *
   * Examples:
   *
   *     math.std(2, 4, 6)                     // returns 2
   *     math.std([2, 4, 6, 8])                // returns 2.581988897471611
   *     math.std([2, 4, 6, 8], 'uncorrected') // returns 2.23606797749979
   *     math.std([2, 4, 6, 8], 'biased')      // returns 2
   *
   *     math.std([[1, 2, 3], [4, 5, 6]])      // returns 1.8708286933869707
   *     math.std([[1, 2, 3], [4, 6, 8]], 0)    // returns [2.1213203435596424, 2.8284271247461903, 3.5355339059327378]
   *     math.std([[1, 2, 3], [4, 6, 8]], 1)    // returns [1, 2]
   *     math.std([[1, 2, 3], [4, 6, 8]], 1, 'biased') // returns [0.7071067811865476, 1.4142135623730951]
   *
   * See also:
   *
   *    mean, median, max, min, prod, sum, variance
   *
   * @param {Array | Matrix} array
   *                        A single matrix or or multiple scalar values
   * @param {string} [normalization='unbiased']
   *                        Determines how to normalize the variance.
   *                        Choose 'unbiased' (default), 'uncorrected', or 'biased'.
   * @param dimension {number | BigNumber}
   *                        Determines the axis to compute the standard deviation for a matrix
   * @return {*} The standard deviation
   */ return typed($9ae25b2346cb5935$var$name, {
        // std([a, b, c, d, ...])
        "Array | Matrix": _std,
        // std([a, b, c, d, ...], normalization)
        "Array | Matrix, string": _std,
        // std([a, b, c, c, ...], dim)
        "Array | Matrix, number | BigNumber": _std,
        // std([a, b, c, c, ...], dim, normalization)
        "Array | Matrix, number | BigNumber, string": _std,
        // std(a, b, c, d, ...)
        "...": function _(args) {
            return _std(args);
        }
    });
    function _std(array, normalization) {
        if (array.length === 0) throw new SyntaxError("Function std requires one or more parameters (0 provided)");
        try {
            return sqrt(variance.apply(null, arguments));
        } catch (err) {
            if (err instanceof TypeError && err.message.indexOf(" variance") !== -1) throw new TypeError(err.message.replace(" variance", " std"));
            else throw err;
        }
    }
});

});


parcelRegister("fbyJR", function(module, exports) {

$parcel$export(module.exports, "createSubsetTransform", function () { return $02da5e440b4ab989$export$3dd4e26b0ef52fd5; });

var $2mPYl = parcelRequire("2mPYl");

var $dJ38g = parcelRequire("dJ38g");

var $hqnPB = parcelRequire("hqnPB");
var $02da5e440b4ab989$var$name = "subset";
var $02da5e440b4ab989$var$dependencies = [
    "typed",
    "matrix"
];
var $02da5e440b4ab989$export$3dd4e26b0ef52fd5 = /* #__PURE__ */ (0, $2mPYl.factory)($02da5e440b4ab989$var$name, $02da5e440b4ab989$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix;
    var subset = (0, $hqnPB.createSubset)({
        typed: typed,
        matrix: matrix
    });
    /**
   * Attach a transform function to math.subset
   * Adds a property transform containing the transform function.
   *
   * This transform creates a range which includes the end value
   */ return typed("subset", {
        "...any": function any(args) {
            try {
                return subset.apply(null, args);
            } catch (err) {
                throw (0, $dJ38g.errorTransform)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});

});
parcelRegister("hqnPB", function(module, exports) {

$parcel$export(module.exports, "createSubset", function () { return $caf759c62f78b4ec$export$d8c56e74d683bb33; });

var $1amHZ = parcelRequire("1amHZ");

var $7ITGG = parcelRequire("7ITGG");

var $5WdrK = parcelRequire("5WdrK");

var $45IYD = parcelRequire("45IYD");

var $hy7Bx = parcelRequire("hy7Bx");

var $2mPYl = parcelRequire("2mPYl");
var $caf759c62f78b4ec$var$name = "subset";
var $caf759c62f78b4ec$var$dependencies = [
    "typed",
    "matrix"
];
var $caf759c62f78b4ec$export$d8c56e74d683bb33 = /* #__PURE__ */ (0, $2mPYl.factory)($caf759c62f78b4ec$var$name, $caf759c62f78b4ec$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix;
    /**
   * Get or set a subset of a matrix or string.
   *
   * Syntax:
   *     math.subset(value, index)                                // retrieve a subset
   *     math.subset(value, index, replacement [, defaultValue])  // replace a subset
   *
   * Examples:
   *
   *     // get a subset
   *     const d = [[1, 2], [3, 4]]
   *     math.subset(d, math.index(1, 0))        // returns 3
   *     math.subset(d, math.index([0, 1], 1))   // returns [[2], [4]]
   *
   *     // replace a subset
   *     const e = []
   *     const f = math.subset(e, math.index(0, [0, 2]), [5, 6])  // f = [[5, 6]]
   *     const g = math.subset(f, math.index(1, 1), 7, 0)         // g = [[5, 6], [0, 7]]
   *
   * See also:
   *
   *     size, resize, squeeze, index
   *
   * @param {Array | Matrix | string} matrix  An array, matrix, or string
   * @param {Index} index                     An index containing ranges for each
   *                                          dimension
   * @param {*} [replacement]                 An array, matrix, or scalar.
   *                                          If provided, the subset is replaced with replacement.
   *                                          If not provided, the subset is returned
   * @param {*} [defaultValue=undefined]      Default value, filled in on new entries when
   *                                          the matrix is resized. If not provided,
   *                                          math.matrix elements will be left undefined.
   * @return {Array | Matrix | string} Either the retrieved subset or the updated matrix.
   */ return typed($caf759c62f78b4ec$var$name, {
        // get subset
        "Array, Index": function ArrayIndex(value, index) {
            var m = matrix(value);
            var subset = m.subset(index); // returns a Matrix
            return index.isScalar() ? subset : subset.valueOf(); // return an Array (like the input)
        },
        "Matrix, Index": function MatrixIndex(value, index) {
            return value.subset(index);
        },
        "Object, Index": $caf759c62f78b4ec$var$_getObjectProperty,
        "string, Index": $caf759c62f78b4ec$var$_getSubstring,
        // set subset
        "Array, Index, any": function ArrayIndexAny(value, index, replacement) {
            return matrix((0, $7ITGG.clone)(value)).subset(index, replacement, undefined).valueOf();
        },
        "Array, Index, any, any": function ArrayIndexAnyAny(value, index, replacement, defaultValue) {
            return matrix((0, $7ITGG.clone)(value)).subset(index, replacement, defaultValue).valueOf();
        },
        "Matrix, Index, any": function MatrixIndexAny(value, index, replacement) {
            return value.clone().subset(index, replacement);
        },
        "Matrix, Index, any, any": function MatrixIndexAnyAny(value, index, replacement, defaultValue) {
            return value.clone().subset(index, replacement, defaultValue);
        },
        "string, Index, string": $caf759c62f78b4ec$var$_setSubstring,
        "string, Index, string, string": $caf759c62f78b4ec$var$_setSubstring,
        "Object, Index, any": $caf759c62f78b4ec$var$_setObjectProperty
    });
});
/**
 * Retrieve a subset of a string
 * @param {string} str            string from which to get a substring
 * @param {Index} index           An index containing ranges for each dimension
 * @returns {string} substring
 * @private
 */ function $caf759c62f78b4ec$var$_getSubstring(str, index) {
    if (!(0, $1amHZ.isIndex)(index)) // TODO: better error message
    throw new TypeError("Index expected");
    if (index.size().length !== 1) throw new (0, $hy7Bx.DimensionError)(index.size().length, 1);
     // validate whether the range is out of range
    var strLen = str.length;
    (0, $5WdrK.validateIndex)(index.min()[0], strLen);
    (0, $5WdrK.validateIndex)(index.max()[0], strLen);
    var range = index.dimension(0);
    var substr = "";
    range.forEach(function(v) {
        substr += str.charAt(v);
    });
    return substr;
}
/**
 * Replace a substring in a string
 * @param {string} str            string to be replaced
 * @param {Index} index           An index containing ranges for each dimension
 * @param {string} replacement    Replacement string
 * @param {string} [defaultValue] Default value to be uses when resizing
 *                                the string. is ' ' by default
 * @returns {string} result
 * @private
 */ function $caf759c62f78b4ec$var$_setSubstring(str, index, replacement, defaultValue) {
    if (!index || index.isIndex !== true) // TODO: better error message
    throw new TypeError("Index expected");
    if (index.size().length !== 1) throw new (0, $hy7Bx.DimensionError)(index.size().length, 1);
    if (defaultValue !== undefined) {
        if (typeof defaultValue !== "string" || defaultValue.length !== 1) throw new TypeError("Single character expected as defaultValue");
    } else defaultValue = " ";
    var range = index.dimension(0);
    var len = range.size()[0];
    if (len !== replacement.length) throw new (0, $hy7Bx.DimensionError)(range.size()[0], replacement.length);
     // validate whether the range is out of range
    var strLen = str.length;
    (0, $5WdrK.validateIndex)(index.min()[0]);
    (0, $5WdrK.validateIndex)(index.max()[0]); // copy the string into an array with characters
    var chars = [];
    for(var i = 0; i < strLen; i++)chars[i] = str.charAt(i);
    range.forEach(function(v, i) {
        chars[v] = replacement.charAt(i[0]);
    }); // initialize undefined characters with a space
    if (chars.length > strLen) {
        for(var _i = strLen - 1, _len = chars.length; _i < _len; _i++)if (!chars[_i]) chars[_i] = defaultValue;
    }
    return chars.join("");
}
/**
 * Retrieve a property from an object
 * @param {Object} object
 * @param {Index} index
 * @return {*} Returns the value of the property
 * @private
 */ function $caf759c62f78b4ec$var$_getObjectProperty(object, index) {
    if (index.size().length !== 1) throw new (0, $hy7Bx.DimensionError)(index.size(), 1);
    var key = index.dimension(0);
    if (typeof key !== "string") throw new TypeError("String expected as index to retrieve an object property");
    return (0, $45IYD.getSafeProperty)(object, key);
}
/**
 * Set a property on an object
 * @param {Object} object
 * @param {Index} index
 * @param {*} replacement
 * @return {*} Returns the updated object
 * @private
 */ function $caf759c62f78b4ec$var$_setObjectProperty(object, index, replacement) {
    if (index.size().length !== 1) throw new (0, $hy7Bx.DimensionError)(index.size(), 1);
    var key = index.dimension(0);
    if (typeof key !== "string") throw new TypeError("String expected as index to retrieve an object property");
     // clone the object, and apply the property to the clone
    var updated = (0, $7ITGG.clone)(object);
    (0, $45IYD.setSafeProperty)(updated, key, replacement);
    return updated;
}

});


parcelRegister("dYbzE", function(module, exports) {

$parcel$export(module.exports, "createSumTransform", function () { return $a2b9db54f72f4b17$export$1b9b65ea533d42ec; });

var $1amHZ = parcelRequire("1amHZ");

var $2mPYl = parcelRequire("2mPYl");

var $dJ38g = parcelRequire("dJ38g");

var $8qyM8 = parcelRequire("8qyM8");
/**
 * Attach a transform function to math.sum
 * Adds a property transform containing the transform function.
 *
 * This transform changed the last `dim` parameter of function mean
 * from one-based to zero based
 */ var $a2b9db54f72f4b17$var$name = "sum";
var $a2b9db54f72f4b17$var$dependencies = [
    "typed",
    "config",
    "add",
    "?bignumber",
    "?fraction"
];
var $a2b9db54f72f4b17$export$1b9b65ea533d42ec = /* #__PURE__ */ (0, $2mPYl.factory)($a2b9db54f72f4b17$var$name, $a2b9db54f72f4b17$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, add = _ref.add, bignumber = _ref.bignumber, fraction = _ref.fraction;
    var sum = (0, $8qyM8.createSum)({
        typed: typed,
        config: config,
        add: add,
        bignumber: bignumber,
        fraction: fraction
    });
    return typed($a2b9db54f72f4b17$var$name, {
        "...any": function any(args) {
            // change last argument dim from one-based to zero-based
            if (args.length === 2 && (0, $1amHZ.isCollection)(args[0])) {
                var dim = args[1];
                if ((0, $1amHZ.isNumber)(dim)) args[1] = dim - 1;
                else if ((0, $1amHZ.isBigNumber)(dim)) args[1] = dim.minus(1);
            }
            try {
                return sum.apply(null, args);
            } catch (err) {
                throw (0, $dJ38g.errorTransform)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});

});
parcelRegister("8qyM8", function(module, exports) {

$parcel$export(module.exports, "createSum", function () { return $622bba17b0a84d30$export$14d444d810bc35b5; });

var $e04i1 = parcelRequire("e04i1");

var $2mPYl = parcelRequire("2mPYl");

var $l16bl = parcelRequire("l16bl");

var $rJyG2 = parcelRequire("rJyG2");
var $622bba17b0a84d30$var$name = "sum";
var $622bba17b0a84d30$var$dependencies = [
    "typed",
    "config",
    "add",
    "?bignumber",
    "?fraction"
];
var $622bba17b0a84d30$export$14d444d810bc35b5 = /* #__PURE__ */ (0, $2mPYl.factory)($622bba17b0a84d30$var$name, $622bba17b0a84d30$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, add = _ref.add, bignumber = _ref.bignumber, fraction = _ref.fraction;
    /**
   * Compute the sum of a matrix or a list with values.
   * In case of a (multi dimensional) array or matrix, the sum of all
   * elements will be calculated.
   *
   * Syntax:
   *
   *     math.sum(a, b, c, ...)
   *     math.sum(A)
   *
   * Examples:
   *
   *     math.sum(2, 1, 4, 3)               // returns 10
   *     math.sum([2, 1, 4, 3])             // returns 10
   *     math.sum([[2, 5], [4, 3], [1, 7]]) // returns 22
   *
   * See also:
   *
   *    mean, median, min, max, prod, std, variance
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The sum of all values
   */ return typed($622bba17b0a84d30$var$name, {
        // sum([a, b, c, d, ...])
        "Array | Matrix": _sum,
        // sum([a, b, c, d, ...], dim)
        "Array | Matrix, number | BigNumber": _nsumDim,
        // sum(a, b, c, d, ...)
        "...": function _(args) {
            if ((0, $e04i1.containsCollections)(args)) throw new TypeError("Scalar values expected in function sum");
            return _sum(args);
        }
    });
    /**
   * Recursively calculate the sum of an n-dimensional array
   * @param {Array} array
   * @return {number} sum
   * @private
   */ function _sum(array) {
        var sum;
        (0, $e04i1.deepForEach)(array, function(value) {
            try {
                sum = sum === undefined ? value : add(sum, value);
            } catch (err) {
                throw (0, $l16bl.improveErrorMessage)(err, "sum", value);
            }
        });
        if (sum === undefined) switch(config.number){
            case "number":
                return 0;
            case "BigNumber":
                return bignumber ? bignumber(0) : (0, $rJyG2.noBignumber)();
            case "Fraction":
                return fraction ? fraction(0) : (0, $rJyG2.noFraction)();
            default:
                return 0;
        }
        return sum;
    }
    function _nsumDim(array, dim) {
        try {
            var sum = (0, $e04i1.reduce)(array, dim, add);
            return sum;
        } catch (err) {
            throw (0, $l16bl.improveErrorMessage)(err, "sum");
        }
    }
});

});


parcelRegister("jK9Uj", function(module, exports) {

$parcel$export(module.exports, "createSymbolNode", function () { return $e5f9ff8ce26da8be$export$b9e0005fc35ab4ee; });

var $6NxuJ = parcelRequire("6NxuJ");

var $45IYD = parcelRequire("45IYD");

var $2mPYl = parcelRequire("2mPYl");

var $6Zo9s = parcelRequire("6Zo9s");
var $e5f9ff8ce26da8be$var$name = "SymbolNode";
var $e5f9ff8ce26da8be$var$dependencies = [
    "math",
    "?Unit",
    "Node"
];
var $e5f9ff8ce26da8be$export$b9e0005fc35ab4ee = /* #__PURE__ */ (0, $2mPYl.factory)($e5f9ff8ce26da8be$var$name, $e5f9ff8ce26da8be$var$dependencies, function(_ref) {
    var math = _ref.math, Unit = _ref.Unit, Node = _ref.Node;
    /**
   * Check whether some name is a valueless unit like "inch".
   * @param {string} name
   * @return {boolean}
   */ function isValuelessUnit(name) {
        return Unit ? Unit.isValuelessUnit(name) : false;
    }
    /**
   * @constructor SymbolNode
   * @extends {Node}
   * A symbol node can hold and resolve a symbol
   * @param {string} name
   * @extends {Node}
   */ function SymbolNode(name) {
        if (!(this instanceof SymbolNode)) throw new SyntaxError("Constructor must be called with the new operator");
         // validate input
        if (typeof name !== "string") throw new TypeError('String expected for parameter "name"');
        this.name = name;
    }
    SymbolNode.prototype = new Node();
    SymbolNode.prototype.type = "SymbolNode";
    SymbolNode.prototype.isSymbolNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ SymbolNode.prototype._compile = function(math, argNames) {
        var name = this.name;
        if (argNames[name] === true) // this is a FunctionAssignment argument
        // (like an x when inside the expression of a function assignment `f(x) = ...`)
        return function(scope, args, context) {
            return args[name];
        };
        else if (name in math) return function(scope, args, context) {
            return name in scope ? (0, $45IYD.getSafeProperty)(scope, name) : (0, $45IYD.getSafeProperty)(math, name);
        };
        else {
            var isUnit = isValuelessUnit(name);
            return function(scope, args, context) {
                return name in scope ? (0, $45IYD.getSafeProperty)(scope, name) : isUnit ? new Unit(null, name) : undef(name);
            };
        }
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ SymbolNode.prototype.forEach = function(callback) {} // nothing to do, we don't have childs
     /**
   * Create a new SymbolNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node) : Node} callback
   * @returns {SymbolNode} Returns a clone of the node
   */ ;
    SymbolNode.prototype.map = function(callback) {
        return this.clone();
    };
    /**
   * Throws an error 'Undefined symbol {name}'
   * @param {string} name
   */ function undef(name) {
        throw new Error("Undefined symbol " + name);
    }
    /**
   * Create a clone of this node, a shallow copy
   * @return {SymbolNode}
   */ SymbolNode.prototype.clone = function() {
        return new SymbolNode(this.name);
    };
    /**
   * Get string representation
   * @param {Object} options
   * @return {string} str
   * @override
   */ SymbolNode.prototype._toString = function(options) {
        return this.name;
    };
    /**
   * Get HTML representation
   * @param {Object} options
   * @return {string} str
   * @override
   */ SymbolNode.prototype.toHTML = function(options) {
        var name = (0, $6NxuJ.escape)(this.name);
        if (name === "true" || name === "false") return '<span class="math-symbol math-boolean">' + name + "</span>";
        else if (name === "i") return '<span class="math-symbol math-imaginary-symbol">' + name + "</span>";
        else if (name === "Infinity") return '<span class="math-symbol math-infinity-symbol">' + name + "</span>";
        else if (name === "NaN") return '<span class="math-symbol math-nan-symbol">' + name + "</span>";
        else if (name === "null") return '<span class="math-symbol math-null-symbol">' + name + "</span>";
        else if (name === "undefined") return '<span class="math-symbol math-undefined-symbol">' + name + "</span>";
        return '<span class="math-symbol">' + name + "</span>";
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ SymbolNode.prototype.toJSON = function() {
        return {
            mathjs: "SymbolNode",
            name: this.name
        };
    };
    /**
   * Instantiate a SymbolNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "SymbolNode", name: "x"}`,
   *                       where mathjs is optional
   * @returns {SymbolNode}
   */ SymbolNode.fromJSON = function(json) {
        return new SymbolNode(json.name);
    };
    /**
   * Get LaTeX representation
   * @param {Object} options
   * @return {string} str
   * @override
   */ SymbolNode.prototype._toTex = function(options) {
        var isUnit = false;
        if (typeof math[this.name] === "undefined" && isValuelessUnit(this.name)) isUnit = true;
        var symbol = (0, $6Zo9s.toSymbol)(this.name, isUnit);
        if (symbol[0] === "\\") // no space needed if the symbol starts with '\'
        return symbol;
         // the space prevents symbols from breaking stuff like '\cdot' if it's written right before the symbol
        return " " + symbol;
    };
    return SymbolNode;
}, {
    isClass: true,
    isNode: true
});

});

parcelRegister("hL252", function(module, exports) {

$parcel$export(module.exports, "createVarianceTransform", function () { return $ced8708c0d63e535$export$8ab5ca08ecd18ef3; });

var $2mPYl = parcelRequire("2mPYl");

var $1amHZ = parcelRequire("1amHZ");

var $dJ38g = parcelRequire("dJ38g");

var $9NVBk = parcelRequire("9NVBk");
var $ced8708c0d63e535$var$name = "variance";
var $ced8708c0d63e535$var$dependencies = [
    "typed",
    "add",
    "subtract",
    "multiply",
    "divide",
    "apply",
    "isNaN"
];
var $ced8708c0d63e535$export$8ab5ca08ecd18ef3 = /* #__PURE__ */ (0, $2mPYl.factory)($ced8708c0d63e535$var$name, $ced8708c0d63e535$var$dependencies, function(_ref) {
    var typed = _ref.typed, add = _ref.add, subtract = _ref.subtract, multiply = _ref.multiply, divide = _ref.divide, apply = _ref.apply, isNaN = _ref.isNaN;
    var variance = (0, $9NVBk.createVariance)({
        typed: typed,
        add: add,
        subtract: subtract,
        multiply: multiply,
        divide: divide,
        apply: apply,
        isNaN: isNaN
    });
    return typed($ced8708c0d63e535$var$name, {
        "...any": function any(args) {
            // change last argument dim from one-based to zero-based
            if (args.length >= 2 && (0, $1amHZ.isCollection)(args[0])) {
                var dim = args[1];
                if ((0, $1amHZ.isNumber)(dim)) args[1] = dim - 1;
                else if ((0, $1amHZ.isBigNumber)(dim)) args[1] = dim.minus(1);
            }
            try {
                return variance.apply(null, args);
            } catch (err) {
                throw (0, $dJ38g.errorTransform)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});

});
parcelRegister("9NVBk", function(module, exports) {

$parcel$export(module.exports, "createVariance", function () { return $72355f0ef16e31d2$export$b989221824390fb; });

var $e04i1 = parcelRequire("e04i1");

var $1amHZ = parcelRequire("1amHZ");

var $2mPYl = parcelRequire("2mPYl");

var $l16bl = parcelRequire("l16bl");

var $kcYaK = parcelRequire("kcYaK");
var $72355f0ef16e31d2$var$DEFAULT_NORMALIZATION = "unbiased";
var $72355f0ef16e31d2$var$name = "variance";
var $72355f0ef16e31d2$var$dependencies = [
    "typed",
    "add",
    "subtract",
    "multiply",
    "divide",
    "apply",
    "isNaN"
];
var $72355f0ef16e31d2$export$b989221824390fb = /* #__PURE__ */ (0, $2mPYl.factory)($72355f0ef16e31d2$var$name, $72355f0ef16e31d2$var$dependencies, function(_ref) {
    var typed = _ref.typed, add = _ref.add, subtract = _ref.subtract, multiply = _ref.multiply, divide = _ref.divide, apply = _ref.apply, isNaN = _ref.isNaN;
    /**
   * Compute the variance of a matrix or a  list with values.
   * In case of a (multi dimensional) array or matrix, the variance over all
   * elements will be calculated.
   *
   * Additionally, it is possible to compute the variance along the rows
   * or columns of a matrix by specifying the dimension as the second argument.
   *
   * Optionally, the type of normalization can be specified as the final
   * parameter. The parameter `normalization` can be one of the following values:
   *
   * - 'unbiased' (default) The sum of squared errors is divided by (n - 1)
   * - 'uncorrected'        The sum of squared errors is divided by n
   * - 'biased'             The sum of squared errors is divided by (n + 1)
   *
   *
   * Note that older browser may not like the variable name `var`. In that
   * case, the function can be called as `math['var'](...)` instead of
   * `math.var(...)`.
   *
   * Syntax:
   *
   *     math.variance(a, b, c, ...)
   *     math.variance(A)
   *     math.variance(A, normalization)
   *     math.variance(A, dimension)
   *     math.variance(A, dimension, normalization)
   *
   * Examples:
   *
   *     math.variance(2, 4, 6)                     // returns 4
   *     math.variance([2, 4, 6, 8])                // returns 6.666666666666667
   *     math.variance([2, 4, 6, 8], 'uncorrected') // returns 5
   *     math.variance([2, 4, 6, 8], 'biased')      // returns 4
   *
   *     math.variance([[1, 2, 3], [4, 5, 6]])      // returns 3.5
   *     math.variance([[1, 2, 3], [4, 6, 8]], 0)   // returns [4.5, 8, 12.5]
   *     math.variance([[1, 2, 3], [4, 6, 8]], 1)   // returns [1, 4]
   *     math.variance([[1, 2, 3], [4, 6, 8]], 1, 'biased') // returns [0.5, 2]
   *
   * See also:
   *
   *    mean, median, max, min, prod, std, sum
   *
   * @param {Array | Matrix} array
   *                        A single matrix or or multiple scalar values
   * @param {string} [normalization='unbiased']
   *                        Determines how to normalize the variance.
   *                        Choose 'unbiased' (default), 'uncorrected', or 'biased'.
   * @param dimension {number | BigNumber}
   *                        Determines the axis to compute the variance for a matrix
   * @return {*} The variance
   */ return typed($72355f0ef16e31d2$var$name, {
        // variance([a, b, c, d, ...])
        "Array | Matrix": function ArrayMatrix(array) {
            return _var(array, $72355f0ef16e31d2$var$DEFAULT_NORMALIZATION);
        },
        // variance([a, b, c, d, ...], normalization)
        "Array | Matrix, string": _var,
        // variance([a, b, c, c, ...], dim)
        "Array | Matrix, number | BigNumber": function ArrayMatrixNumberBigNumber(array, dim) {
            return _varDim(array, dim, $72355f0ef16e31d2$var$DEFAULT_NORMALIZATION);
        },
        // variance([a, b, c, c, ...], dim, normalization)
        "Array | Matrix, number | BigNumber, string": _varDim,
        // variance(a, b, c, d, ...)
        "...": function _(args) {
            return _var(args, $72355f0ef16e31d2$var$DEFAULT_NORMALIZATION);
        }
    });
    /**
   * Recursively calculate the variance of an n-dimensional array
   * @param {Array} array
   * @param {string} normalization
   *                        Determines how to normalize the variance:
   *                        - 'unbiased'    The sum of squared errors is divided by (n - 1)
   *                        - 'uncorrected' The sum of squared errors is divided by n
   *                        - 'biased'      The sum of squared errors is divided by (n + 1)
   * @return {number | BigNumber} variance
   * @private
   */ function _var(array, normalization) {
        var sum = 0;
        var num = 0;
        if (array.length === 0) throw new SyntaxError("Function variance requires one or more parameters (0 provided)");
         // calculate the mean and number of elements
        (0, $e04i1.deepForEach)(array, function(value) {
            try {
                sum = add(sum, value);
                num++;
            } catch (err) {
                throw (0, $l16bl.improveErrorMessage)(err, "variance", value);
            }
        });
        if (num === 0) throw new Error("Cannot calculate variance of an empty array");
        var mean = divide(sum, num); // calculate the variance
        sum = 0;
        (0, $e04i1.deepForEach)(array, function(value) {
            var diff = subtract(value, mean);
            sum = add(sum, multiply(diff, diff));
        });
        if (isNaN(sum)) return sum;
        switch(normalization){
            case "uncorrected":
                return divide(sum, num);
            case "biased":
                return divide(sum, num + 1);
            case "unbiased":
                var zero = (0, $1amHZ.isBigNumber)(sum) ? sum.mul(0) : 0;
                return num === 1 ? zero : divide(sum, num - 1);
            default:
                throw new Error('Unknown normalization "' + normalization + '". ' + 'Choose "unbiased" (default), "uncorrected", or "biased".');
        }
    }
    function _varDim(array, dim, normalization) {
        try {
            if (array.length === 0) throw new SyntaxError("Function variance requires one or more parameters (0 provided)");
            return apply(array, dim, function(x) {
                return _var(x, normalization);
            });
        } catch (err) {
            throw (0, $l16bl.improveErrorMessage)(err, "variance");
        }
    }
}); // For backward compatibility, deprecated since version 6.0.0. Date: 2018-11-09
var $72355f0ef16e31d2$export$aa3270b68c308b31 = /* #__PURE__ */ (0, $2mPYl.factory)("var", [
    "variance"
], function(_ref2) {
    var variance = _ref2.variance;
    return function() {
        (0, $kcYaK.warnOnce)('Function "var" has been renamed to "variance" in v6.0.0, please use the new function instead.');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return variance.apply(variance, args);
    };
});

});


parcelRegister("kbUbx", function(module, exports) {

$parcel$export(module.exports, "ResultSet", function () { return $eb306aeedec1e78b$export$aebd5179ff543a90; });
$parcel$export(module.exports, "Complex", function () { return $eb306aeedec1e78b$export$50ceb3fb9926e63e; });
$parcel$export(module.exports, "Range", function () { return $eb306aeedec1e78b$export$9a58ef0d7ad3278c; });
$parcel$export(module.exports, "eye", function () { return $eb306aeedec1e78b$export$4e18cf730a59887e; });
$parcel$export(module.exports, "_false", function () { return $eb306aeedec1e78b$export$f650004d56f90c2a; });
$parcel$export(module.exports, "_null", function () { return $eb306aeedec1e78b$export$a2cbb38cda512d16; });
$parcel$export(module.exports, "_true", function () { return $eb306aeedec1e78b$export$93f71dfe5e50cd3e; });
$parcel$export(module.exports, "BigNumber", function () { return $eb306aeedec1e78b$export$d97aa349ed20696; });
$parcel$export(module.exports, "Matrix", function () { return $eb306aeedec1e78b$export$5b12bf1653c0dd85; });
$parcel$export(module.exports, "replacer", function () { return $eb306aeedec1e78b$export$b644b65666fe0c18; });
$parcel$export(module.exports, "i", function () { return $eb306aeedec1e78b$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "LN10", function () { return $eb306aeedec1e78b$export$c44341d65988fdd6; });
$parcel$export(module.exports, "LOG10E", function () { return $eb306aeedec1e78b$export$5ed2c057bd191c66; });
$parcel$export(module.exports, "_NaN", function () { return $eb306aeedec1e78b$export$14edd9ca775dcd61; });
$parcel$export(module.exports, "pi", function () { return $eb306aeedec1e78b$export$18c7bea995a110f; });
$parcel$export(module.exports, "SQRT1_2", function () { return $eb306aeedec1e78b$export$83247d8be11c091e; });
$parcel$export(module.exports, "tau", function () { return $eb306aeedec1e78b$export$a4b4b4d4d776fe92; });
$parcel$export(module.exports, "efimovFactor", function () { return $eb306aeedec1e78b$export$9ea6550edaaee998; });
$parcel$export(module.exports, "fineStructure", function () { return $eb306aeedec1e78b$export$5c15dd8d2782cbd0; });
$parcel$export(module.exports, "sackurTetrode", function () { return $eb306aeedec1e78b$export$a7100dcd4c5af6d4; });
$parcel$export(module.exports, "weakMixingAngle", function () { return $eb306aeedec1e78b$export$857d2e3e2bc524d0; });
$parcel$export(module.exports, "Fraction", function () { return $eb306aeedec1e78b$export$b336c2702c498be5; });
$parcel$export(module.exports, "e", function () { return $eb306aeedec1e78b$export$f1e1789686576879; });
$parcel$export(module.exports, "_Infinity", function () { return $eb306aeedec1e78b$export$20607595d292e7d3; });
$parcel$export(module.exports, "LOG2E", function () { return $eb306aeedec1e78b$export$8c2c65adacba8d14; });
$parcel$export(module.exports, "version", function () { return $eb306aeedec1e78b$export$83d89fbfd8236492; });
$parcel$export(module.exports, "DenseMatrix", function () { return $eb306aeedec1e78b$export$97f0d27b48f120e8; });
$parcel$export(module.exports, "phi", function () { return $eb306aeedec1e78b$export$324943737027944a; });
$parcel$export(module.exports, "typed", function () { return $eb306aeedec1e78b$export$519f616c41a1c711; });
$parcel$export(module.exports, "isInteger", function () { return $eb306aeedec1e78b$export$a287f47fed4544b8; });
$parcel$export(module.exports, "isNumeric", function () { return $eb306aeedec1e78b$export$e90fb89750dba83f; });
$parcel$export(module.exports, "isPositive", function () { return $eb306aeedec1e78b$export$7e69d4236fcc3b19; });
$parcel$export(module.exports, "isNaN", function () { return $eb306aeedec1e78b$export$c9f5652083b8129d; });
$parcel$export(module.exports, "equalScalar", function () { return $eb306aeedec1e78b$export$943761f5c9c3f156; });
$parcel$export(module.exports, "number", function () { return $eb306aeedec1e78b$export$98e628dec113755e; });
$parcel$export(module.exports, "boolean", function () { return $eb306aeedec1e78b$export$4a21f16c33752377; });
$parcel$export(module.exports, "complex", function () { return $eb306aeedec1e78b$export$83a0e34f1302825b; });
$parcel$export(module.exports, "splitUnit", function () { return $eb306aeedec1e78b$export$dd67294014106b35; });
$parcel$export(module.exports, "unaryPlus", function () { return $eb306aeedec1e78b$export$df8c837ae5df4ce4; });
$parcel$export(module.exports, "apply", function () { return $eb306aeedec1e78b$export$5635d7ef4b8fee1c; });
$parcel$export(module.exports, "cube", function () { return $eb306aeedec1e78b$export$2b0340f6c7dec49a; });
$parcel$export(module.exports, "expm1", function () { return $eb306aeedec1e78b$export$b6c0a80d46d3391d; });
$parcel$export(module.exports, "log10", function () { return $eb306aeedec1e78b$export$75e08744a3ff8516; });
$parcel$export(module.exports, "multiplyScalar", function () { return $eb306aeedec1e78b$export$c697bed75648cdb7; });
$parcel$export(module.exports, "sign", function () { return $eb306aeedec1e78b$export$c5552dfdbc7cec71; });
$parcel$export(module.exports, "square", function () { return $eb306aeedec1e78b$export$dd4f28cef696bc7d; });
$parcel$export(module.exports, "bitNot", function () { return $eb306aeedec1e78b$export$aabc449fa5b5f4c0; });
$parcel$export(module.exports, "arg", function () { return $eb306aeedec1e78b$export$d8da458ed75e15b; });
$parcel$export(module.exports, "im", function () { return $eb306aeedec1e78b$export$5fc500b917996661; });
$parcel$export(module.exports, "not", function () { return $eb306aeedec1e78b$export$6003a5f097c73977; });
$parcel$export(module.exports, "filter", function () { return $eb306aeedec1e78b$export$3dea766d36a8935f; });
$parcel$export(module.exports, "forEach", function () { return $eb306aeedec1e78b$export$4b80e395e36b5a56; });
$parcel$export(module.exports, "map", function () { return $eb306aeedec1e78b$export$871de8747c9eaa88; });
$parcel$export(module.exports, "erf", function () { return $eb306aeedec1e78b$export$d3896f355fc09423; });
$parcel$export(module.exports, "format", function () { return $eb306aeedec1e78b$export$d9468344d3651243; });
$parcel$export(module.exports, "isPrime", function () { return $eb306aeedec1e78b$export$8676dd5fabd5ee34; });
$parcel$export(module.exports, "acos", function () { return $eb306aeedec1e78b$export$fd6306be3fde5b04; });
$parcel$export(module.exports, "acot", function () { return $eb306aeedec1e78b$export$4919a578c4aafd3; });
$parcel$export(module.exports, "acsc", function () { return $eb306aeedec1e78b$export$43298db932064b4a; });
$parcel$export(module.exports, "asec", function () { return $eb306aeedec1e78b$export$ec42f46098b24bb4; });
$parcel$export(module.exports, "asin", function () { return $eb306aeedec1e78b$export$41726bdb1fc63f; });
$parcel$export(module.exports, "atan", function () { return $eb306aeedec1e78b$export$628dc4eed22b0fbd; });
$parcel$export(module.exports, "atanh", function () { return $eb306aeedec1e78b$export$21ea955025ceb08b; });
$parcel$export(module.exports, "cosh", function () { return $eb306aeedec1e78b$export$2e2fd1ad24e4d350; });
$parcel$export(module.exports, "coth", function () { return $eb306aeedec1e78b$export$fe7b8a3b046ac25b; });
$parcel$export(module.exports, "csch", function () { return $eb306aeedec1e78b$export$ca7427e8bf42a21b; });
$parcel$export(module.exports, "sech", function () { return $eb306aeedec1e78b$export$becbc39f348ea65e; });
$parcel$export(module.exports, "sinh", function () { return $eb306aeedec1e78b$export$545004b505d7c555; });
$parcel$export(module.exports, "tanh", function () { return $eb306aeedec1e78b$export$7128670e45beef9a; });
$parcel$export(module.exports, "combinations", function () { return $eb306aeedec1e78b$export$bdfcf4c6b5766439; });
$parcel$export(module.exports, "pickRandom", function () { return $eb306aeedec1e78b$export$2e015b6955893291; });
$parcel$export(module.exports, "randomInt", function () { return $eb306aeedec1e78b$export$3c5f89dae98e900b; });
$parcel$export(module.exports, "LN2", function () { return $eb306aeedec1e78b$export$578b45ddcdefa518; });
$parcel$export(module.exports, "clone", function () { return $eb306aeedec1e78b$export$9cd59f9826255e47; });
$parcel$export(module.exports, "hasNumericValue", function () { return $eb306aeedec1e78b$export$f6fc628e09f3ff5d; });
$parcel$export(module.exports, "typeOf", function () { return $eb306aeedec1e78b$export$f5bbd400c2f4426f; });
$parcel$export(module.exports, "string", function () { return $eb306aeedec1e78b$export$22b082955e083ec3; });
$parcel$export(module.exports, "fraction", function () { return $eb306aeedec1e78b$export$7f34ce79760854f7; });
$parcel$export(module.exports, "unaryMinus", function () { return $eb306aeedec1e78b$export$6cd304851a69e08; });
$parcel$export(module.exports, "addScalar", function () { return $eb306aeedec1e78b$export$2b7b095c4f443355; });
$parcel$export(module.exports, "exp", function () { return $eb306aeedec1e78b$export$b310ec824aaee37f; });
$parcel$export(module.exports, "log2", function () { return $eb306aeedec1e78b$export$b9fae0bba9d9094d; });
$parcel$export(module.exports, "sqrt", function () { return $eb306aeedec1e78b$export$eba8049fb5020b81; });
$parcel$export(module.exports, "conj", function () { return $eb306aeedec1e78b$export$fb254c661fe9c0db; });
$parcel$export(module.exports, "getMatrixDataType", function () { return $eb306aeedec1e78b$export$42c7d1d712906e32; });
$parcel$export(module.exports, "mode", function () { return $eb306aeedec1e78b$export$549ff81930776885; });
$parcel$export(module.exports, "print", function () { return $eb306aeedec1e78b$export$c2d084dc44961371; });
$parcel$export(module.exports, "acosh", function () { return $eb306aeedec1e78b$export$b26caf0f29211d08; });
$parcel$export(module.exports, "acsch", function () { return $eb306aeedec1e78b$export$eafdb403a25900df; });
$parcel$export(module.exports, "asinh", function () { return $eb306aeedec1e78b$export$839d8a01b6af4fc0; });
$parcel$export(module.exports, "cos", function () { return $eb306aeedec1e78b$export$50d414a77b60d802; });
$parcel$export(module.exports, "csc", function () { return $eb306aeedec1e78b$export$a830b5ed334924be; });
$parcel$export(module.exports, "sin", function () { return $eb306aeedec1e78b$export$5de3937cb4b592ed; });
$parcel$export(module.exports, "combinationsWithRep", function () { return $eb306aeedec1e78b$export$f297162cf5d656b2; });
$parcel$export(module.exports, "random", function () { return $eb306aeedec1e78b$export$4385e60b38654f68; });
$parcel$export(module.exports, "SQRT2", function () { return $eb306aeedec1e78b$export$3681641e15b6e2c3; });
$parcel$export(module.exports, "isNegative", function () { return $eb306aeedec1e78b$export$d0909a4f38b5c4d0; });
$parcel$export(module.exports, "SparseMatrix", function () { return $eb306aeedec1e78b$export$de9b2b7556879848; });
$parcel$export(module.exports, "matrix", function () { return $eb306aeedec1e78b$export$9bdad1ae37d738e0; });
$parcel$export(module.exports, "cbrt", function () { return $eb306aeedec1e78b$export$841fc4d5a1480b85; });
$parcel$export(module.exports, "gcd", function () { return $eb306aeedec1e78b$export$f81847884871263e; });
$parcel$export(module.exports, "mod", function () { return $eb306aeedec1e78b$export$842a2cf37af977e1; });
$parcel$export(module.exports, "nthRoot", function () { return $eb306aeedec1e78b$export$cc5da69d359d7991; });
$parcel$export(module.exports, "xgcd", function () { return $eb306aeedec1e78b$export$6ba103b0465fe6cc; });
$parcel$export(module.exports, "bitAnd", function () { return $eb306aeedec1e78b$export$a74ff8d3fdef72fc; });
$parcel$export(module.exports, "bitXor", function () { return $eb306aeedec1e78b$export$bfcff4501301c191; });
$parcel$export(module.exports, "or", function () { return $eb306aeedec1e78b$export$252bb8b3bbdf6749; });
$parcel$export(module.exports, "concat", function () { return $eb306aeedec1e78b$export$ee1b3e54f0441b22; });
$parcel$export(module.exports, "diag", function () { return $eb306aeedec1e78b$export$c042e7c2f59bc046; });
$parcel$export(module.exports, "identity", function () { return $eb306aeedec1e78b$export$f0954fd7d5368655; });
$parcel$export(module.exports, "ones", function () { return $eb306aeedec1e78b$export$21041dee6b8001b0; });
$parcel$export(module.exports, "reshape", function () { return $eb306aeedec1e78b$export$9eaad88cf88cee2b; });
$parcel$export(module.exports, "size", function () { return $eb306aeedec1e78b$export$346677f925de839c; });
$parcel$export(module.exports, "subset", function () { return $eb306aeedec1e78b$export$e06bd7b1ab877a71; });
$parcel$export(module.exports, "zeros", function () { return $eb306aeedec1e78b$export$4445a00dafa2633b; });
$parcel$export(module.exports, "to", function () { return $eb306aeedec1e78b$export$2c618a4308a30424; });
$parcel$export(module.exports, "round", function () { return $eb306aeedec1e78b$export$2077e0241d6afd3c; });
$parcel$export(module.exports, "leftShift", function () { return $eb306aeedec1e78b$export$48901d58d322262f; });
$parcel$export(module.exports, "rightLogShift", function () { return $eb306aeedec1e78b$export$502f8a5a1147da; });
$parcel$export(module.exports, "compare", function () { return $eb306aeedec1e78b$export$398604a469f7de9a; });
$parcel$export(module.exports, "compareText", function () { return $eb306aeedec1e78b$export$2da9287da10b19e2; });
$parcel$export(module.exports, "smaller", function () { return $eb306aeedec1e78b$export$3f732695c1493aec; });
$parcel$export(module.exports, "larger", function () { return $eb306aeedec1e78b$export$a94a7414fa942aea; });
$parcel$export(module.exports, "unequal", function () { return $eb306aeedec1e78b$export$b20c1c5fa0c7dd75; });
$parcel$export(module.exports, "max", function () { return $eb306aeedec1e78b$export$8960430cfd85939f; });
$parcel$export(module.exports, "ImmutableDenseMatrix", function () { return $eb306aeedec1e78b$export$66fe727d7ec8c7b9; });
$parcel$export(module.exports, "FibonacciHeap", function () { return $eb306aeedec1e78b$export$dd5bb73729f20aa3; });
$parcel$export(module.exports, "sparse", function () { return $eb306aeedec1e78b$export$b6b7e189aa5d134c; });
$parcel$export(module.exports, "acoth", function () { return $eb306aeedec1e78b$export$6faaac9ab79fd3a4; });
$parcel$export(module.exports, "atan2", function () { return $eb306aeedec1e78b$export$b8b770ee6a0d9760; });
$parcel$export(module.exports, "sec", function () { return $eb306aeedec1e78b$export$e17a63917e2ebf0f; });
$parcel$export(module.exports, "add", function () { return $eb306aeedec1e78b$export$e16d8520af44a096; });
$parcel$export(module.exports, "trace", function () { return $eb306aeedec1e78b$export$357889f174732d38; });
$parcel$export(module.exports, "composition", function () { return $eb306aeedec1e78b$export$fd2cf6bce05a0b18; });
$parcel$export(module.exports, "isZero", function () { return $eb306aeedec1e78b$export$c46ec7d82fb1f602; });
$parcel$export(module.exports, "abs", function () { return $eb306aeedec1e78b$export$2335f513bbd82c6d; });
$parcel$export(module.exports, "floor", function () { return $eb306aeedec1e78b$export$a3fe094919f356fd; });
$parcel$export(module.exports, "multiply", function () { return $eb306aeedec1e78b$export$2060d2db72cce88f; });
$parcel$export(module.exports, "dotMultiply", function () { return $eb306aeedec1e78b$export$c6d93afbf4ee8afc; });
$parcel$export(module.exports, "re", function () { return $eb306aeedec1e78b$export$b1f1627d659a651; });
$parcel$export(module.exports, "flatten", function () { return $eb306aeedec1e78b$export$bffa455ba8c619a6; });
$parcel$export(module.exports, "resize", function () { return $eb306aeedec1e78b$export$4380c87abf28fdf; });
$parcel$export(module.exports, "squeeze", function () { return $eb306aeedec1e78b$export$889c931173b77c2f; });
$parcel$export(module.exports, "prod", function () { return $eb306aeedec1e78b$export$5e143010dea16c85; });
$parcel$export(module.exports, "pow", function () { return $eb306aeedec1e78b$export$9c297f60e22e3389; });
$parcel$export(module.exports, "dotPow", function () { return $eb306aeedec1e78b$export$ef3b15136279c2ab; });
$parcel$export(module.exports, "rightArithShift", function () { return $eb306aeedec1e78b$export$a1da16976d3a5f68; });
$parcel$export(module.exports, "compareNatural", function () { return $eb306aeedec1e78b$export$762e84baec56595d; });
$parcel$export(module.exports, "equalText", function () { return $eb306aeedec1e78b$export$5bc21f656fb5d284; });
$parcel$export(module.exports, "largerEq", function () { return $eb306aeedec1e78b$export$72693dfc692346df; });
$parcel$export(module.exports, "partitionSelect", function () { return $eb306aeedec1e78b$export$54d1e322cf7aa273; });
$parcel$export(module.exports, "min", function () { return $eb306aeedec1e78b$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "Spa", function () { return $eb306aeedec1e78b$export$6d4069f4b64f7492; });
$parcel$export(module.exports, "asech", function () { return $eb306aeedec1e78b$export$3aaf4e522be48075; });
$parcel$export(module.exports, "tan", function () { return $eb306aeedec1e78b$export$fcdd3b0b3246a325; });
$parcel$export(module.exports, "setSize", function () { return $eb306aeedec1e78b$export$1c70a6cc12bc0366; });
$parcel$export(module.exports, "norm", function () { return $eb306aeedec1e78b$export$1991ecd29cc92c6b; });
$parcel$export(module.exports, "quantileSeq", function () { return $eb306aeedec1e78b$export$ff63ee916cadcfe; });
$parcel$export(module.exports, "gamma", function () { return $eb306aeedec1e78b$export$a7ebe8cc6aaf8d37; });
$parcel$export(module.exports, "bignumber", function () { return $eb306aeedec1e78b$export$8576f72eb7f14a7e; });
$parcel$export(module.exports, "lcm", function () { return $eb306aeedec1e78b$export$f686d97e407ec4ef; });
$parcel$export(module.exports, "bitOr", function () { return $eb306aeedec1e78b$export$361eb278cc70bacf; });
$parcel$export(module.exports, "kron", function () { return $eb306aeedec1e78b$export$44f32dfde3d58545; });
$parcel$export(module.exports, "transpose", function () { return $eb306aeedec1e78b$export$9cb09a71b7d66923; });
$parcel$export(module.exports, "numeric", function () { return $eb306aeedec1e78b$export$b7a508fa8dae59fc; });
$parcel$export(module.exports, "and", function () { return $eb306aeedec1e78b$export$21c0ac7fe1cef1b8; });
$parcel$export(module.exports, "smallerEq", function () { return $eb306aeedec1e78b$export$8d38c87f33a93d98; });
$parcel$export(module.exports, "sort", function () { return $eb306aeedec1e78b$export$97db5808d8f88186; });
$parcel$export(module.exports, "cot", function () { return $eb306aeedec1e78b$export$ef569ec50496610c; });
$parcel$export(module.exports, "dot", function () { return $eb306aeedec1e78b$export$94132a0e348806d4; });
$parcel$export(module.exports, "sum", function () { return $eb306aeedec1e78b$export$8a63f25cc62965f1; });
$parcel$export(module.exports, "factorial", function () { return $eb306aeedec1e78b$export$329ce89a99f0e343; });
$parcel$export(module.exports, "permutations", function () { return $eb306aeedec1e78b$export$4567adbe5dd91621; });
$parcel$export(module.exports, "ceil", function () { return $eb306aeedec1e78b$export$803ce6b71a0a94b2; });
$parcel$export(module.exports, "subtract", function () { return $eb306aeedec1e78b$export$4e2d2ead65e5f7e3; });
$parcel$export(module.exports, "cross", function () { return $eb306aeedec1e78b$export$bb646b20bb93d339; });
$parcel$export(module.exports, "ctranspose", function () { return $eb306aeedec1e78b$export$eb6ad7870b1d0b0b; });
$parcel$export(module.exports, "equal", function () { return $eb306aeedec1e78b$export$411ce8e5a71e3069; });
$parcel$export(module.exports, "Index", function () { return $eb306aeedec1e78b$export$cf17b003b6192af3; });
$parcel$export(module.exports, "setCartesian", function () { return $eb306aeedec1e78b$export$dcac7a71ff10ad82; });
$parcel$export(module.exports, "setDistinct", function () { return $eb306aeedec1e78b$export$ec60221e756bab15; });
$parcel$export(module.exports, "setIsSubset", function () { return $eb306aeedec1e78b$export$ca5251f59a067f9a; });
$parcel$export(module.exports, "setPowerset", function () { return $eb306aeedec1e78b$export$f6ce4c11993e56f2; });
$parcel$export(module.exports, "index", function () { return $eb306aeedec1e78b$export$b610b8812bbcded9; });
$parcel$export(module.exports, "fix", function () { return $eb306aeedec1e78b$export$d838837eb5b184e3; });
$parcel$export(module.exports, "range", function () { return $eb306aeedec1e78b$export$d02631cccf789723; });
$parcel$export(module.exports, "divideScalar", function () { return $eb306aeedec1e78b$export$67275f837d70084d; });
$parcel$export(module.exports, "nthRoots", function () { return $eb306aeedec1e78b$export$adb173527af10aca; });
$parcel$export(module.exports, "lsolve", function () { return $eb306aeedec1e78b$export$be3b83cc1aa539e4; });
$parcel$export(module.exports, "deepEqual", function () { return $eb306aeedec1e78b$export$9cb4719e2e525b7a; });
$parcel$export(module.exports, "setDifference", function () { return $eb306aeedec1e78b$export$8bd517cc5b3722f7; });
$parcel$export(module.exports, "setMultiplicity", function () { return $eb306aeedec1e78b$export$8bb4a52260216736; });
$parcel$export(module.exports, "hypot", function () { return $eb306aeedec1e78b$export$f95c7888b62f8e9a; });
$parcel$export(module.exports, "lup", function () { return $eb306aeedec1e78b$export$91d2d01a33a1e6f8; });
$parcel$export(module.exports, "slu", function () { return $eb306aeedec1e78b$export$95c7459688ef4e3a; });
$parcel$export(module.exports, "det", function () { return $eb306aeedec1e78b$export$d063d65fed97e7fa; });
$parcel$export(module.exports, "distance", function () { return $eb306aeedec1e78b$export$9f17032d917177de; });
$parcel$export(module.exports, "stirlingS2", function () { return $eb306aeedec1e78b$export$a5abae3de3985f2f; });
$parcel$export(module.exports, "catalan", function () { return $eb306aeedec1e78b$export$d8807a6c0487483a; });
$parcel$export(module.exports, "xor", function () { return $eb306aeedec1e78b$export$6444ef5cd411280c; });
$parcel$export(module.exports, "row", function () { return $eb306aeedec1e78b$export$120ff0929b202a6d; });
$parcel$export(module.exports, "dotDivide", function () { return $eb306aeedec1e78b$export$c74f132961c51406; });
$parcel$export(module.exports, "Unit", function () { return $eb306aeedec1e78b$export$1d8b9ae22d404866; });
$parcel$export(module.exports, "createUnit", function () { return $eb306aeedec1e78b$export$aab44654646f3ccc; });
$parcel$export(module.exports, "setSymDifference", function () { return $eb306aeedec1e78b$export$a7eac91d5496c35b; });
$parcel$export(module.exports, "qr", function () { return $eb306aeedec1e78b$export$7c27fb47516129d9; });
$parcel$export(module.exports, "inv", function () { return $eb306aeedec1e78b$export$c02accee9f2b6a8f; });
$parcel$export(module.exports, "expm", function () { return $eb306aeedec1e78b$export$d9bacaa51f70e8e; });
$parcel$export(module.exports, "divide", function () { return $eb306aeedec1e78b$export$cd007d971a5a2143; });
$parcel$export(module.exports, "mean", function () { return $eb306aeedec1e78b$export$1ce691f85baaa52; });
$parcel$export(module.exports, "variance", function () { return $eb306aeedec1e78b$export$9b77da0927470c3d; });
$parcel$export(module.exports, "std", function () { return $eb306aeedec1e78b$export$b14c5e819cb6c927; });
$parcel$export(module.exports, "multinomial", function () { return $eb306aeedec1e78b$export$f4d580f3101a1c7e; });
$parcel$export(module.exports, "atomicMass", function () { return $eb306aeedec1e78b$export$11b531e5540c3ca4; });
$parcel$export(module.exports, "bohrMagneton", function () { return $eb306aeedec1e78b$export$c779781d69f736e8; });
$parcel$export(module.exports, "boltzmann", function () { return $eb306aeedec1e78b$export$f727e86dcab4e2c6; });
$parcel$export(module.exports, "conductanceQuantum", function () { return $eb306aeedec1e78b$export$6eafe330bdda8c71; });
$parcel$export(module.exports, "deuteronMass", function () { return $eb306aeedec1e78b$export$80bf07f129ad1319; });
$parcel$export(module.exports, "electronMass", function () { return $eb306aeedec1e78b$export$c00fb43e712bef2c; });
$parcel$export(module.exports, "faraday", function () { return $eb306aeedec1e78b$export$7130fbae042d5c0f; });
$parcel$export(module.exports, "firstRadiation", function () { return $eb306aeedec1e78b$export$f83f3c3b84952e0b; });
$parcel$export(module.exports, "gravitationConstant", function () { return $eb306aeedec1e78b$export$d9cccfa50756330b; });
$parcel$export(module.exports, "hartreeEnergy", function () { return $eb306aeedec1e78b$export$37b0dd3693d47685; });
$parcel$export(module.exports, "klitzing", function () { return $eb306aeedec1e78b$export$10054c6b64de12f5; });
$parcel$export(module.exports, "magneticConstant", function () { return $eb306aeedec1e78b$export$ba3f3691dd1c5a7; });
$parcel$export(module.exports, "molarMass", function () { return $eb306aeedec1e78b$export$6d4ff429f3f89356; });
$parcel$export(module.exports, "molarPlanckConstant", function () { return $eb306aeedec1e78b$export$dacf4a2cf8881dff; });
$parcel$export(module.exports, "neutronMass", function () { return $eb306aeedec1e78b$export$ba7a41eda790cc15; });
$parcel$export(module.exports, "planckCharge", function () { return $eb306aeedec1e78b$export$9b1b4e5bc980cec6; });
$parcel$export(module.exports, "planckLength", function () { return $eb306aeedec1e78b$export$c20ab336465d7d5e; });
$parcel$export(module.exports, "planckTemperature", function () { return $eb306aeedec1e78b$export$5a85cd1a26c2cced; });
$parcel$export(module.exports, "protonMass", function () { return $eb306aeedec1e78b$export$1c88a737209eb089; });
$parcel$export(module.exports, "reducedPlanckConstant", function () { return $eb306aeedec1e78b$export$963167ae5579ea00; });
$parcel$export(module.exports, "secondRadiation", function () { return $eb306aeedec1e78b$export$1f7c42a78c01e4f9; });
$parcel$export(module.exports, "stefanBoltzmann", function () { return $eb306aeedec1e78b$export$f63e81544c3d56ef; });
$parcel$export(module.exports, "vacuumImpedance", function () { return $eb306aeedec1e78b$export$4b15dbe639ad9539; });
$parcel$export(module.exports, "column", function () { return $eb306aeedec1e78b$export$4e0c71f277ca26b3; });
$parcel$export(module.exports, "usolve", function () { return $eb306aeedec1e78b$export$41828460570e21eb; });
$parcel$export(module.exports, "setIntersect", function () { return $eb306aeedec1e78b$export$9404cfefeb010e68; });
$parcel$export(module.exports, "lusolve", function () { return $eb306aeedec1e78b$export$fccc724a69f253a; });
$parcel$export(module.exports, "eigs", function () { return $eb306aeedec1e78b$export$e822b38c59ee8a2a; });
$parcel$export(module.exports, "intersect", function () { return $eb306aeedec1e78b$export$1f4807a235930d45; });
$parcel$export(module.exports, "bellNumbers", function () { return $eb306aeedec1e78b$export$bb522a71cda46a13; });
$parcel$export(module.exports, "avogadro", function () { return $eb306aeedec1e78b$export$1236f2451dbdfd63; });
$parcel$export(module.exports, "classicalElectronRadius", function () { return $eb306aeedec1e78b$export$f48a0c6b8cc21601; });
$parcel$export(module.exports, "electricConstant", function () { return $eb306aeedec1e78b$export$11ff82822f958f25; });
$parcel$export(module.exports, "fermiCoupling", function () { return $eb306aeedec1e78b$export$84a9a66802fec40; });
$parcel$export(module.exports, "gravity", function () { return $eb306aeedec1e78b$export$bfb00cec0048377d; });
$parcel$export(module.exports, "loschmidt", function () { return $eb306aeedec1e78b$export$9eedba962d6a1c01; });
$parcel$export(module.exports, "molarMassC12", function () { return $eb306aeedec1e78b$export$9589ebe123df8f2e; });
$parcel$export(module.exports, "nuclearMagneton", function () { return $eb306aeedec1e78b$export$7274fb1d27d1cd19; });
$parcel$export(module.exports, "planckMass", function () { return $eb306aeedec1e78b$export$5ce790af25e5ac75; });
$parcel$export(module.exports, "quantumOfCirculation", function () { return $eb306aeedec1e78b$export$5d88bfa2004001d3; });
$parcel$export(module.exports, "speedOfLight", function () { return $eb306aeedec1e78b$export$5d66ae3b3e8fce48; });
$parcel$export(module.exports, "wienDisplacement", function () { return $eb306aeedec1e78b$export$2bcc1e96766dec50; });
$parcel$export(module.exports, "log", function () { return $eb306aeedec1e78b$export$bef1f36f5486a6a3; });
$parcel$export(module.exports, "unit", function () { return $eb306aeedec1e78b$export$523c0b569236b342; });
$parcel$export(module.exports, "sqrtm", function () { return $eb306aeedec1e78b$export$17c7cd2216e18593; });
$parcel$export(module.exports, "kldivergence", function () { return $eb306aeedec1e78b$export$a9fffb6ae6e33dcc; });
$parcel$export(module.exports, "bohrRadius", function () { return $eb306aeedec1e78b$export$5a57f82afcc3edeb; });
$parcel$export(module.exports, "elementaryCharge", function () { return $eb306aeedec1e78b$export$199cdfec7f52c877; });
$parcel$export(module.exports, "inverseConductanceQuantum", function () { return $eb306aeedec1e78b$export$f060c4f0aa5bef89; });
$parcel$export(module.exports, "molarVolume", function () { return $eb306aeedec1e78b$export$863459416408c428; });
$parcel$export(module.exports, "planckTime", function () { return $eb306aeedec1e78b$export$85aaf319784a5b0; });
$parcel$export(module.exports, "thomsonCrossSection", function () { return $eb306aeedec1e78b$export$93039724ea765a8e; });
$parcel$export(module.exports, "log1p", function () { return $eb306aeedec1e78b$export$144dcf16adfb9698; });
$parcel$export(module.exports, "median", function () { return $eb306aeedec1e78b$export$9c490b34b2f16a34; });
$parcel$export(module.exports, "gasConstant", function () { return $eb306aeedec1e78b$export$a614e1ad972260a9; });
$parcel$export(module.exports, "planckConstant", function () { return $eb306aeedec1e78b$export$cbd33810258dab2e; });
$parcel$export(module.exports, "setUnion", function () { return $eb306aeedec1e78b$export$667066422fa0af46; });
$parcel$export(module.exports, "magneticFluxQuantum", function () { return $eb306aeedec1e78b$export$699e2a89b148c5ee; });
$parcel$export(module.exports, "coulomb", function () { return $eb306aeedec1e78b$export$2f2e110dac549211; });
$parcel$export(module.exports, "mad", function () { return $eb306aeedec1e78b$export$b14ea41a64d6efa6; });
$parcel$export(module.exports, "rydberg", function () { return $eb306aeedec1e78b$export$683732ab8f5759dc; });
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */ 
var $89s6m = parcelRequire("89s6m");

var $iTLx7 = parcelRequire("iTLx7");
var $lqksZ = parcelRequire("lqksZ");
var $4slJf = parcelRequire("4slJf");
var $hIz83 = parcelRequire("hIz83");
var $4pbjb = parcelRequire("4pbjb");
var $52gGD = parcelRequire("52gGD");
var $cmOCU = parcelRequire("cmOCU");
var $ivSXu = parcelRequire("ivSXu");
var $2hq9f = parcelRequire("2hq9f");
var $frWlf = parcelRequire("frWlf");
var $5kHy5 = parcelRequire("5kHy5");
var $53FUY = parcelRequire("53FUY");
var $hIQTp = parcelRequire("hIQTp");
var $gylhh = parcelRequire("gylhh");
var $bWXDL = parcelRequire("bWXDL");
var $c5mOF = parcelRequire("c5mOF");
var $2ORcQ = parcelRequire("2ORcQ");
var $hrHyk = parcelRequire("hrHyk");
var $bcMLK = parcelRequire("bcMLK");
var $ktwBg = parcelRequire("ktwBg");
var $dVSwh = parcelRequire("dVSwh");
var $cTd4r = parcelRequire("cTd4r");
var $8tyDe = parcelRequire("8tyDe");
var $josr1 = parcelRequire("josr1");
var $iYM8q = parcelRequire("iYM8q");
var $4a9NS = parcelRequire("4a9NS");
var $d2Cqy = parcelRequire("d2Cqy");
var $fvJuV = parcelRequire("fvJuV");
var $do5MS = parcelRequire("do5MS");
var $2jVeI = parcelRequire("2jVeI");
var $9kiFT = parcelRequire("9kiFT");
var $pi7tG = parcelRequire("pi7tG");
var $kMxeC = parcelRequire("kMxeC");
var $89Lra = parcelRequire("89Lra");
var $dNoTM = parcelRequire("dNoTM");
var $4GaSd = parcelRequire("4GaSd");
var $3c8MR = parcelRequire("3c8MR");
var $i4qxa = parcelRequire("i4qxa");
var $9LsUU = parcelRequire("9LsUU");
var $dDldj = parcelRequire("dDldj");
var $2H2OT = parcelRequire("2H2OT");
var $28Jrs = parcelRequire("28Jrs");
var $8s0Jy = parcelRequire("8s0Jy");
var $fAfsd = parcelRequire("fAfsd");
var $jQYDB = parcelRequire("jQYDB");
var $eAT74 = parcelRequire("eAT74");
var $7zpx7 = parcelRequire("7zpx7");
var $b1H27 = parcelRequire("b1H27");
var $bPaMl = parcelRequire("bPaMl");
var $aSKzv = parcelRequire("aSKzv");
var $yZ5Il = parcelRequire("yZ5Il");
var $gXhPT = parcelRequire("gXhPT");
var $gCgDL = parcelRequire("gCgDL");
var $3PwsX = parcelRequire("3PwsX");
var $5I5uC = parcelRequire("5I5uC");
var $1lMmn = parcelRequire("1lMmn");
var $iyczN = parcelRequire("iyczN");
var $6P0H6 = parcelRequire("6P0H6");
var $gO6Ud = parcelRequire("gO6Ud");
var $iSkrf = parcelRequire("iSkrf");
var $8RpBq = parcelRequire("8RpBq");
var $fxhCt = parcelRequire("fxhCt");
var $2dOZi = parcelRequire("2dOZi");
var $7RV4T = parcelRequire("7RV4T");
var $eRQhw = parcelRequire("eRQhw");
var $hUbAD = parcelRequire("hUbAD");
var $cZmUN = parcelRequire("cZmUN");
var $e1yLF = parcelRequire("e1yLF");
var $3xiqs = parcelRequire("3xiqs");
var $gF5Al = parcelRequire("gF5Al");
var $5ANsT = parcelRequire("5ANsT");
var $cErc7 = parcelRequire("cErc7");
var $bvvLQ = parcelRequire("bvvLQ");
var $hyM3K = parcelRequire("hyM3K");
var $k8VNd = parcelRequire("k8VNd");
var $9t5pt = parcelRequire("9t5pt");
var $h3w9M = parcelRequire("h3w9M");
var $lCJe5 = parcelRequire("lCJe5");
var $5svDZ = parcelRequire("5svDZ");
var $hY9Fd = parcelRequire("hY9Fd");
var $lBVSt = parcelRequire("lBVSt");
var $gEIS9 = parcelRequire("gEIS9");
var $78v1C = parcelRequire("78v1C");
var $3j8Ha = parcelRequire("3j8Ha");
var $cUOM8 = parcelRequire("cUOM8");
var $h0gTZ = parcelRequire("h0gTZ");
var $4TwHx = parcelRequire("4TwHx");
var $lKbtb = parcelRequire("lKbtb");
var $3L0Dr = parcelRequire("3L0Dr");
var $3tz7Y = parcelRequire("3tz7Y");
var $91rws = parcelRequire("91rws");
var $53Sj1 = parcelRequire("53Sj1");
var $7SBld = parcelRequire("7SBld");
var $9MONg = parcelRequire("9MONg");
var $k40sh = parcelRequire("k40sh");
var $339f8 = parcelRequire("339f8");
var $7gZON = parcelRequire("7gZON");
var $gO8O1 = parcelRequire("gO8O1");
var $jUmYr = parcelRequire("jUmYr");
var $7quLY = parcelRequire("7quLY");
var $gX2t3 = parcelRequire("gX2t3");
var $7Uryu = parcelRequire("7Uryu");
var $8b5FJ = parcelRequire("8b5FJ");
var $1srjG = parcelRequire("1srjG");
var $5eRkA = parcelRequire("5eRkA");
var $cUU3S = parcelRequire("cUU3S");
var $3MOz5 = parcelRequire("3MOz5");
var $8lih4 = parcelRequire("8lih4");
var $aUJyL = parcelRequire("aUJyL");
var $bw5eO = parcelRequire("bw5eO");
var $AdJT9 = parcelRequire("AdJT9");
var $81mLS = parcelRequire("81mLS");
var $hkSiL = parcelRequire("hkSiL");
var $kiDwM = parcelRequire("kiDwM");
var $jt5km = parcelRequire("jt5km");
var $lkRnE = parcelRequire("lkRnE");
var $13FHT = parcelRequire("13FHT");
var $4p0TV = parcelRequire("4p0TV");
var $aHWC7 = parcelRequire("aHWC7");
var $atRDv = parcelRequire("atRDv");
var $No7sr = parcelRequire("No7sr");
var $2y0Ri = parcelRequire("2y0Ri");
var $kzEhI = parcelRequire("kzEhI");
var $c8qEj = parcelRequire("c8qEj");
var $khtXV = parcelRequire("khtXV");
var $cYqrK = parcelRequire("cYqrK");
var $hzPWT = parcelRequire("hzPWT");
var $k3AOO = parcelRequire("k3AOO");
var $hsb4M = parcelRequire("hsb4M");
var $9KzjP = parcelRequire("9KzjP");
var $9LrdT = parcelRequire("9LrdT");
var $4jogG = parcelRequire("4jogG");
var $VnIhn = parcelRequire("VnIhn");
var $aQkjJ = parcelRequire("aQkjJ");
var $v3afu = parcelRequire("v3afu");
var $hyyaM = parcelRequire("hyyaM");
var $dfJfX = parcelRequire("dfJfX");
var $5v3G9 = parcelRequire("5v3G9");
var $aY2pj = parcelRequire("aY2pj");
var $dlWMO = parcelRequire("dlWMO");
var $4xcq3 = parcelRequire("4xcq3");
var $k1d7p = parcelRequire("k1d7p");
var $3fJbS = parcelRequire("3fJbS");
var $7Hu1z = parcelRequire("7Hu1z");
var $2V5Tl = parcelRequire("2V5Tl");
var $hmmXX = parcelRequire("hmmXX");
var $bzpJA = parcelRequire("bzpJA");
var $akiB1 = parcelRequire("akiB1");
var $8KyMk = parcelRequire("8KyMk");
var $arz0k = parcelRequire("arz0k");
var $ifoxr = parcelRequire("ifoxr");
var $kLs7z = parcelRequire("kLs7z");
var $62UxD = parcelRequire("62UxD");
var $jzXAX = parcelRequire("jzXAX");
var $cyEyv = parcelRequire("cyEyv");
var $lprSh = parcelRequire("lprSh");
var $dO1oA = parcelRequire("dO1oA");
var $hHIzA = parcelRequire("hHIzA");
var $lDVE4 = parcelRequire("lDVE4");
var $8OkRr = parcelRequire("8OkRr");
var $k2AKL = parcelRequire("k2AKL");
var $4ngij = parcelRequire("4ngij");
var $bBOHk = parcelRequire("bBOHk");
var $2Il54 = parcelRequire("2Il54");
var $itVHz = parcelRequire("itVHz");
var $crsqy = parcelRequire("crsqy");
var $7iBA0 = parcelRequire("7iBA0");
var $i22NM = parcelRequire("i22NM");
var $5pxQQ = parcelRequire("5pxQQ");
var $eJPWT = parcelRequire("eJPWT");
var $aI8OJ = parcelRequire("aI8OJ");
var $aLTLB = parcelRequire("aLTLB");
var $hsMTl = parcelRequire("hsMTl");
var $75QEb = parcelRequire("75QEb");
var $6lgyq = parcelRequire("6lgyq");
var $kZ6Yc = parcelRequire("kZ6Yc");
var $hYYhh = parcelRequire("hYYhh");
var $iF8zF = parcelRequire("iF8zF");
var $kqnlZ = parcelRequire("kqnlZ");
var $7A2Ci = parcelRequire("7A2Ci");
var $2fv1z = parcelRequire("2fv1z");
var $6WD2R = parcelRequire("6WD2R");
var $ielEK = parcelRequire("ielEK");
var $i3llS = parcelRequire("i3llS");
var $50AXM = parcelRequire("50AXM");
var $2KWps = parcelRequire("2KWps");
var $dirAu = parcelRequire("dirAu");
var $81hN6 = parcelRequire("81hN6");
var $gPj2C = parcelRequire("gPj2C");
var $hqnPB = parcelRequire("hqnPB");
var $fFD0Y = parcelRequire("fFD0Y");
var $8qyM8 = parcelRequire("8qyM8");
var $4O9gL = parcelRequire("4O9gL");
var $fQa2o = parcelRequire("fQa2o");
var $ezKv2 = parcelRequire("ezKv2");
var $7Cwki = parcelRequire("7Cwki");
var $cIf9i = parcelRequire("cIf9i");
var $4nRyY = parcelRequire("4nRyY");
var $bLADv = parcelRequire("bLADv");
var $9eOSV = parcelRequire("9eOSV");
var $hP7lt = parcelRequire("hP7lt");
var $6XBRu = parcelRequire("6XBRu");
var $iT8TK = parcelRequire("iT8TK");
var $baZLo = parcelRequire("baZLo");
var $3oCz3 = parcelRequire("3oCz3");
var $9NVBk = parcelRequire("9NVBk");
var $3cHKt = parcelRequire("3cHKt");
var $4BDvJ = parcelRequire("4BDvJ");
var $fcSN4 = parcelRequire("fcSN4");
var $eb306aeedec1e78b$export$aebd5179ff543a90 = /* #__PURE__ */ (0, $jzXAX.createResultSet)({});
var $eb306aeedec1e78b$export$50ceb3fb9926e63e = /* #__PURE__ */ (0, $dDldj.createComplexClass)({});
var $eb306aeedec1e78b$export$9a58ef0d7ad3278c = /* #__PURE__ */ (0, $8KyMk.createRangeClass)({});
var $eb306aeedec1e78b$export$4e18cf730a59887e = /* #__PURE__ */ (0, $hyM3K.createEye)({});
var $eb306aeedec1e78b$export$f650004d56f90c2a = /* #__PURE__ */ (0, $eRQhw.createFalse)({});
var $eb306aeedec1e78b$export$a2cbb38cda512d16 = /* #__PURE__ */ (0, $eRQhw.createNull)({});
var $eb306aeedec1e78b$export$93f71dfe5e50cd3e = /* #__PURE__ */ (0, $eRQhw.createTrue)({});
var $eb306aeedec1e78b$export$d97aa349ed20696 = /* #__PURE__ */ (0, $8tyDe.createBigNumberClass)({
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$5b12bf1653c0dd85 = /* #__PURE__ */ (0, $atRDv.createMatrixClass)({});
var $eb306aeedec1e78b$export$b644b65666fe0c18 = /* #__PURE__ */ (0, $ifoxr.createReplacer)({});
var $eb306aeedec1e78b$export$23f2a1d2818174ef = /* #__PURE__ */ (0, $eRQhw.createI)({
    Complex: $eb306aeedec1e78b$export$50ceb3fb9926e63e
});
var $eb306aeedec1e78b$export$c44341d65988fdd6 = /* #__PURE__ */ (0, $eRQhw.createLN10)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$5ed2c057bd191c66 = /* #__PURE__ */ (0, $eRQhw.createLOG10E)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$14edd9ca775dcd61 = /* #__PURE__ */ (0, $eRQhw.createNaN)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$18c7bea995a110f = /* #__PURE__ */ (0, $eRQhw.createPi)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$83247d8be11c091e = /* #__PURE__ */ (0, $eRQhw.createSQRT1_2)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$a4b4b4d4d776fe92 = /* #__PURE__ */ (0, $eRQhw.createTau)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$9ea6550edaaee998 = /* #__PURE__ */ (0, $ktwBg.createEfimovFactor)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$5c15dd8d2782cbd0 = /* #__PURE__ */ (0, $ktwBg.createFineStructure)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$a7100dcd4c5af6d4 = /* #__PURE__ */ (0, $ktwBg.createSackurTetrode)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$857d2e3e2bc524d0 = /* #__PURE__ */ (0, $ktwBg.createWeakMixingAngle)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$b336c2702c498be5 = /* #__PURE__ */ (0, $3j8Ha.createFractionClass)({});
var $eb306aeedec1e78b$export$f1e1789686576879 = /* #__PURE__ */ (0, $eRQhw.createE)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$20607595d292e7d3 = /* #__PURE__ */ (0, $eRQhw.createInfinity)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$8c2c65adacba8d14 = /* #__PURE__ */ (0, $eRQhw.createLOG2E)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$83d89fbfd8236492 = /* #__PURE__ */ (0, $eRQhw.createVersion)({});
var $eb306aeedec1e78b$export$97f0d27b48f120e8 = /* #__PURE__ */ (0, $5I5uC.createDenseMatrixClass)({
    Matrix: $eb306aeedec1e78b$export$5b12bf1653c0dd85
});
var $eb306aeedec1e78b$export$324943737027944a = /* #__PURE__ */ (0, $eRQhw.createPhi)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$519f616c41a1c711 = /* #__PURE__ */ (0, $4nRyY.createTyped)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Complex: $eb306aeedec1e78b$export$50ceb3fb9926e63e,
    DenseMatrix: $eb306aeedec1e78b$export$97f0d27b48f120e8,
    Fraction: $eb306aeedec1e78b$export$b336c2702c498be5
});
var $eb306aeedec1e78b$export$a287f47fed4544b8 = /* #__PURE__ */ (0, $7gZON.createIsInteger)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$e90fb89750dba83f = /* #__PURE__ */ (0, $7quLY.createIsNumeric)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$7e69d4236fcc3b19 = /* #__PURE__ */ (0, $gX2t3.createIsPositive)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$c9f5652083b8129d = /* #__PURE__ */ (0, $gO8O1.createIsNaN)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$943761f5c9c3f156 = /* #__PURE__ */ (0, $e1yLF.createEqualScalar)({
    config: (0, $89s6m.config),
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$98e628dec113755e = /* #__PURE__ */ (0, $aQkjJ.createNumber)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$4a21f16c33752377 = /* #__PURE__ */ (0, $fvJuV.createBoolean)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$83a0e34f1302825b = /* #__PURE__ */ (0, $9LsUU.createComplex)({
    Complex: $eb306aeedec1e78b$export$50ceb3fb9926e63e,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$dd67294014106b35 = /* #__PURE__ */ (0, $6WD2R.createSplitUnit)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$df8c837ae5df4ce4 = /* #__PURE__ */ (0, $hP7lt.createUnaryPlus)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    config: (0, $89s6m.config),
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$5635d7ef4b8fee1c = /* #__PURE__ */ (0, $5kHy5.createApply)({
    isInteger: $eb306aeedec1e78b$export$a287f47fed4544b8,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$2b0340f6c7dec49a = /* #__PURE__ */ (0, $gCgDL.createCube)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$b6c0a80d46d3391d = /* #__PURE__ */ (0, $bvvLQ.createExpm1)({
    Complex: $eb306aeedec1e78b$export$50ceb3fb9926e63e,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$75e08744a3ff8516 = /* #__PURE__ */ (0, $AdJT9.createLog10)({
    Complex: $eb306aeedec1e78b$export$50ceb3fb9926e63e,
    config: (0, $89s6m.config),
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$c697bed75648cdb7 = /* #__PURE__ */ (0, $hsb4M.createMultiplyScalar)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$c5552dfdbc7cec71 = /* #__PURE__ */ (0, $aI8OJ.createSign)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Fraction: $eb306aeedec1e78b$export$b336c2702c498be5,
    complex: $eb306aeedec1e78b$export$83a0e34f1302825b,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$dd4f28cef696bc7d = /* #__PURE__ */ (0, $50AXM.createSquare)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$aabc449fa5b5f4c0 = /* #__PURE__ */ (0, $iYM8q.createBitNot)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$d8da458ed75e15b = /* #__PURE__ */ (0, $53FUY.createArg)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$5fc500b917996661 = /* #__PURE__ */ (0, $91rws.createIm)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$6003a5f097c73977 = /* #__PURE__ */ (0, $9LrdT.createNot)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$3dea766d36a8935f = /* #__PURE__ */ (0, $h3w9M.createFilter)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$4b80e395e36b5a56 = /* #__PURE__ */ (0, $lBVSt.createForEach)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$871de8747c9eaa88 = /* #__PURE__ */ (0, $4p0TV.createMap)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$d3896f355fc09423 = /* #__PURE__ */ (0, $gF5Al.createErf)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$d9468344d3651243 = /* #__PURE__ */ (0, $gEIS9.createFormat)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$8676dd5fabd5ee34 = /* #__PURE__ */ (0, $7Uryu.createIsPrime)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$fd6306be3fde5b04 = /* #__PURE__ */ (0, $lqksZ.createAcos)({
    Complex: $eb306aeedec1e78b$export$50ceb3fb9926e63e,
    config: (0, $89s6m.config),
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$4919a578c4aafd3 = /* #__PURE__ */ (0, $hIz83.createAcot)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$43298db932064b4a = /* #__PURE__ */ (0, $52gGD.createAcsc)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Complex: $eb306aeedec1e78b$export$50ceb3fb9926e63e,
    config: (0, $89s6m.config),
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$ec42f46098b24bb4 = /* #__PURE__ */ (0, $hIQTp.createAsec)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Complex: $eb306aeedec1e78b$export$50ceb3fb9926e63e,
    config: (0, $89s6m.config),
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$41726bdb1fc63f = /* #__PURE__ */ (0, $bWXDL.createAsin)({
    Complex: $eb306aeedec1e78b$export$50ceb3fb9926e63e,
    config: (0, $89s6m.config),
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$628dc4eed22b0fbd = /* #__PURE__ */ (0, $2ORcQ.createAtan)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$21ea955025ceb08b = /* #__PURE__ */ (0, $bcMLK.createAtanh)({
    Complex: $eb306aeedec1e78b$export$50ceb3fb9926e63e,
    config: (0, $89s6m.config),
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$2e2fd1ad24e4d350 = /* #__PURE__ */ (0, $jQYDB.createCosh)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$fe7b8a3b046ac25b = /* #__PURE__ */ (0, $7zpx7.createCoth)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$ca7427e8bf42a21b = /* #__PURE__ */ (0, $yZ5Il.createCsch)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$becbc39f348ea65e = /* #__PURE__ */ (0, $8OkRr.createSech)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$545004b505d7c555 = /* #__PURE__ */ (0, $hsMTl.createSinh)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$7128670e45beef9a = /* #__PURE__ */ (0, $fQa2o.createTanh)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$bdfcf4c6b5766439 = /* #__PURE__ */ (0, $89Lra.createCombinations)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$2e015b6955893291 = /* #__PURE__ */ (0, $dlWMO.createPickRandom)({
    config: (0, $89s6m.config),
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$3c5f89dae98e900b = /* #__PURE__ */ (0, $bzpJA.createRandomInt)({
    config: (0, $89s6m.config),
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$578b45ddcdefa518 = /* #__PURE__ */ (0, $eRQhw.createLN2)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$9cd59f9826255e47 = /* #__PURE__ */ (0, $pi7tG.createClone)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$f6fc628e09f3ff5d = /* #__PURE__ */ (0, $lKbtb.createHasNumericValue)({
    isNumeric: $eb306aeedec1e78b$export$e90fb89750dba83f,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$f5bbd400c2f4426f = /* #__PURE__ */ (0, $bLADv.createTypeOf)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$22b082955e083ec3 = /* #__PURE__ */ (0, $gPj2C.createString)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$7f34ce79760854f7 = /* #__PURE__ */ (0, $78v1C.createFraction)({
    Fraction: $eb306aeedec1e78b$export$b336c2702c498be5,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$6cd304851a69e08 = /* #__PURE__ */ (0, $9eOSV.createUnaryMinus)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$2b7b095c4f443355 = /* #__PURE__ */ (0, $2hq9f.createAddScalar)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$b310ec824aaee37f = /* #__PURE__ */ (0, $5ANsT.createExp)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$b9fae0bba9d9094d = /* #__PURE__ */ (0, $hkSiL.createLog2)({
    Complex: $eb306aeedec1e78b$export$50ceb3fb9926e63e,
    config: (0, $89s6m.config),
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$eba8049fb5020b81 = /* #__PURE__ */ (0, $ielEK.createSqrt)({
    Complex: $eb306aeedec1e78b$export$50ceb3fb9926e63e,
    config: (0, $89s6m.config),
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$fb254c661fe9c0db = /* #__PURE__ */ (0, $8s0Jy.createConj)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$42c7d1d712906e32 = /* #__PURE__ */ (0, $4TwHx.createGetMatrixDataType)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$549ff81930776885 = /* #__PURE__ */ (0, $cYqrK.createMode)({
    isNaN: $eb306aeedec1e78b$export$c9f5652083b8129d,
    isNumeric: $eb306aeedec1e78b$export$e90fb89750dba83f,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$c2d084dc44961371 = /* #__PURE__ */ (0, $k1d7p.createPrint)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$b26caf0f29211d08 = /* #__PURE__ */ (0, $4slJf.createAcosh)({
    Complex: $eb306aeedec1e78b$export$50ceb3fb9926e63e,
    config: (0, $89s6m.config),
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$eafdb403a25900df = /* #__PURE__ */ (0, $cmOCU.createAcsch)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$839d8a01b6af4fc0 = /* #__PURE__ */ (0, $c5mOF.createAsinh)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$50d414a77b60d802 = /* #__PURE__ */ (0, $fAfsd.createCos)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$a830b5ed334924be = /* #__PURE__ */ (0, $aSKzv.createCsc)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$5de3937cb4b592ed = /* #__PURE__ */ (0, $aLTLB.createSin)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$f297162cf5d656b2 = /* #__PURE__ */ (0, $dNoTM.createCombinationsWithRep)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$4385e60b38654f68 = /* #__PURE__ */ (0, $hmmXX.createRandom)({
    config: (0, $89s6m.config),
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$3681641e15b6e2c3 = /* #__PURE__ */ (0, $eRQhw.createSQRT2)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$d0909a4f38b5c4d0 = /* #__PURE__ */ (0, $jUmYr.createIsNegative)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$de9b2b7556879848 = /* #__PURE__ */ (0, $2fv1z.createSparseMatrixClass)({
    Matrix: $eb306aeedec1e78b$export$5b12bf1653c0dd85,
    equalScalar: $eb306aeedec1e78b$export$943761f5c9c3f156,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$9bdad1ae37d738e0 = /* #__PURE__ */ (0, $aHWC7.createMatrix)({
    DenseMatrix: $eb306aeedec1e78b$export$97f0d27b48f120e8,
    Matrix: $eb306aeedec1e78b$export$5b12bf1653c0dd85,
    SparseMatrix: $eb306aeedec1e78b$export$de9b2b7556879848,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$841fc4d5a1480b85 = /* #__PURE__ */ (0, $2jVeI.createCbrt)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Complex: $eb306aeedec1e78b$export$50ceb3fb9926e63e,
    Fraction: $eb306aeedec1e78b$export$b336c2702c498be5,
    config: (0, $89s6m.config),
    isNegative: $eb306aeedec1e78b$export$d0909a4f38b5c4d0,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711,
    unaryMinus: $eb306aeedec1e78b$export$6cd304851a69e08
});
var $eb306aeedec1e78b$export$f81847884871263e = /* #__PURE__ */ (0, $h0gTZ.createGcd)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    DenseMatrix: $eb306aeedec1e78b$export$97f0d27b48f120e8,
    equalScalar: $eb306aeedec1e78b$export$943761f5c9c3f156,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$842a2cf37af977e1 = /* #__PURE__ */ (0, $khtXV.createMod)({
    DenseMatrix: $eb306aeedec1e78b$export$97f0d27b48f120e8,
    equalScalar: $eb306aeedec1e78b$export$943761f5c9c3f156,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$cc5da69d359d7991 = /* #__PURE__ */ (0, $4jogG.createNthRoot)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    equalScalar: $eb306aeedec1e78b$export$943761f5c9c3f156,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$6ba103b0465fe6cc = /* #__PURE__ */ (0, $3cHKt.createXgcd)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    config: (0, $89s6m.config),
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$a74ff8d3fdef72fc = /* #__PURE__ */ (0, $josr1.createBitAnd)({
    equalScalar: $eb306aeedec1e78b$export$943761f5c9c3f156,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$bfcff4501301c191 = /* #__PURE__ */ (0, $d2Cqy.createBitXor)({
    DenseMatrix: $eb306aeedec1e78b$export$97f0d27b48f120e8,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$252bb8b3bbdf6749 = /* #__PURE__ */ (0, $dfJfX.createOr)({
    DenseMatrix: $eb306aeedec1e78b$export$97f0d27b48f120e8,
    equalScalar: $eb306aeedec1e78b$export$943761f5c9c3f156,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$ee1b3e54f0441b22 = /* #__PURE__ */ (0, $28Jrs.createConcat)({
    isInteger: $eb306aeedec1e78b$export$a287f47fed4544b8,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$c042e7c2f59bc046 = /* #__PURE__ */ (0, $iyczN.createDiag)({
    DenseMatrix: $eb306aeedec1e78b$export$97f0d27b48f120e8,
    SparseMatrix: $eb306aeedec1e78b$export$de9b2b7556879848,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$f0954fd7d5368655 = /* #__PURE__ */ (0, $3tz7Y.createIdentity)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    DenseMatrix: $eb306aeedec1e78b$export$97f0d27b48f120e8,
    SparseMatrix: $eb306aeedec1e78b$export$de9b2b7556879848,
    config: (0, $89s6m.config),
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$21041dee6b8001b0 = /* #__PURE__ */ (0, $hyyaM.createOnes)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    config: (0, $89s6m.config),
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$9eaad88cf88cee2b = /* #__PURE__ */ (0, $kLs7z.createReshape)({
    isInteger: $eb306aeedec1e78b$export$a287f47fed4544b8,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$346677f925de839c = /* #__PURE__ */ (0, $75QEb.createSize)({
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    config: (0, $89s6m.config),
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$e06bd7b1ab877a71 = /* #__PURE__ */ (0, $hqnPB.createSubset)({
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$4445a00dafa2633b = /* #__PURE__ */ (0, $fcSN4.createZeros)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    config: (0, $89s6m.config),
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$2c618a4308a30424 = /* #__PURE__ */ (0, $ezKv2.createTo)({
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$2077e0241d6afd3c = /* #__PURE__ */ (0, $dO1oA.createRound)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    DenseMatrix: $eb306aeedec1e78b$export$97f0d27b48f120e8,
    equalScalar: $eb306aeedec1e78b$export$943761f5c9c3f156,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711,
    zeros: $eb306aeedec1e78b$export$4445a00dafa2633b
});
var $eb306aeedec1e78b$export$48901d58d322262f = /* #__PURE__ */ (0, $aUJyL.createLeftShift)({
    DenseMatrix: $eb306aeedec1e78b$export$97f0d27b48f120e8,
    equalScalar: $eb306aeedec1e78b$export$943761f5c9c3f156,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711,
    zeros: $eb306aeedec1e78b$export$4445a00dafa2633b
});
var $eb306aeedec1e78b$export$502f8a5a1147da = /* #__PURE__ */ (0, $lprSh.createRightLogShift)({
    DenseMatrix: $eb306aeedec1e78b$export$97f0d27b48f120e8,
    equalScalar: $eb306aeedec1e78b$export$943761f5c9c3f156,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711,
    zeros: $eb306aeedec1e78b$export$4445a00dafa2633b
});
var $eb306aeedec1e78b$export$398604a469f7de9a = /* #__PURE__ */ (0, $4GaSd.createCompare)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    DenseMatrix: $eb306aeedec1e78b$export$97f0d27b48f120e8,
    Fraction: $eb306aeedec1e78b$export$b336c2702c498be5,
    config: (0, $89s6m.config),
    equalScalar: $eb306aeedec1e78b$export$943761f5c9c3f156,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$2da9287da10b19e2 = /* #__PURE__ */ (0, $i4qxa.createCompareText)({
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$3f732695c1493aec = /* #__PURE__ */ (0, $kZ6Yc.createSmaller)({
    DenseMatrix: $eb306aeedec1e78b$export$97f0d27b48f120e8,
    config: (0, $89s6m.config),
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$a94a7414fa942aea = /* #__PURE__ */ (0, $cUU3S.createLarger)({
    DenseMatrix: $eb306aeedec1e78b$export$97f0d27b48f120e8,
    config: (0, $89s6m.config),
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$b20c1c5fa0c7dd75 = /* #__PURE__ */ (0, $6XBRu.createUnequal)({
    DenseMatrix: $eb306aeedec1e78b$export$97f0d27b48f120e8,
    config: (0, $89s6m.config),
    equalScalar: $eb306aeedec1e78b$export$943761f5c9c3f156,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$8960430cfd85939f = /* #__PURE__ */ (0, $No7sr.createMax)({
    larger: $eb306aeedec1e78b$export$a94a7414fa942aea,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$66fe727d7ec8c7b9 = /* #__PURE__ */ (0, $53Sj1.createImmutableDenseMatrixClass)({
    DenseMatrix: $eb306aeedec1e78b$export$97f0d27b48f120e8,
    smaller: $eb306aeedec1e78b$export$3f732695c1493aec
});
var $eb306aeedec1e78b$export$dd5bb73729f20aa3 = /* #__PURE__ */ (0, $9t5pt.createFibonacciHeapClass)({
    larger: $eb306aeedec1e78b$export$a94a7414fa942aea,
    smaller: $eb306aeedec1e78b$export$3f732695c1493aec
});
var $eb306aeedec1e78b$export$b6b7e189aa5d134c = /* #__PURE__ */ (0, $7A2Ci.createSparse)({
    SparseMatrix: $eb306aeedec1e78b$export$de9b2b7556879848,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$6faaac9ab79fd3a4 = /* #__PURE__ */ (0, $4pbjb.createAcoth)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Complex: $eb306aeedec1e78b$export$50ceb3fb9926e63e,
    config: (0, $89s6m.config),
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$b8b770ee6a0d9760 = /* #__PURE__ */ (0, $hrHyk.createAtan2)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    DenseMatrix: $eb306aeedec1e78b$export$97f0d27b48f120e8,
    equalScalar: $eb306aeedec1e78b$export$943761f5c9c3f156,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$e17a63917e2ebf0f = /* #__PURE__ */ (0, $lDVE4.createSec)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$e16d8520af44a096 = /* #__PURE__ */ (0, $ivSXu.createAdd)({
    DenseMatrix: $eb306aeedec1e78b$export$97f0d27b48f120e8,
    SparseMatrix: $eb306aeedec1e78b$export$de9b2b7556879848,
    addScalar: $eb306aeedec1e78b$export$2b7b095c4f443355,
    equalScalar: $eb306aeedec1e78b$export$943761f5c9c3f156,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$357889f174732d38 = /* #__PURE__ */ (0, $7Cwki.createTrace)({
    add: $eb306aeedec1e78b$export$e16d8520af44a096,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$fd2cf6bce05a0b18 = /* #__PURE__ */ (0, $2H2OT.createComposition)({
    addScalar: $eb306aeedec1e78b$export$2b7b095c4f443355,
    combinations: $eb306aeedec1e78b$export$bdfcf4c6b5766439,
    isInteger: $eb306aeedec1e78b$export$a287f47fed4544b8,
    isNegative: $eb306aeedec1e78b$export$d0909a4f38b5c4d0,
    isPositive: $eb306aeedec1e78b$export$7e69d4236fcc3b19,
    larger: $eb306aeedec1e78b$export$a94a7414fa942aea,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$c46ec7d82fb1f602 = /* #__PURE__ */ (0, $8b5FJ.createIsZero)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$2335f513bbd82c6d = /* #__PURE__ */ (0, $iTLx7.createAbs)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$a3fe094919f356fd = /* #__PURE__ */ (0, $hY9Fd.createFloor)({
    config: (0, $89s6m.config),
    round: $eb306aeedec1e78b$export$2077e0241d6afd3c,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$2060d2db72cce88f = /* #__PURE__ */ (0, $k3AOO.createMultiply)({
    addScalar: $eb306aeedec1e78b$export$2b7b095c4f443355,
    equalScalar: $eb306aeedec1e78b$export$943761f5c9c3f156,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    multiplyScalar: $eb306aeedec1e78b$export$c697bed75648cdb7,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$c6d93afbf4ee8afc = /* #__PURE__ */ (0, $2dOZi.createDotMultiply)({
    equalScalar: $eb306aeedec1e78b$export$943761f5c9c3f156,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    multiplyScalar: $eb306aeedec1e78b$export$c697bed75648cdb7,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$b1f1627d659a651 = /* #__PURE__ */ (0, $arz0k.createRe)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$bffa455ba8c619a6 = /* #__PURE__ */ (0, $5svDZ.createFlatten)({
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$4380c87abf28fdf = /* #__PURE__ */ (0, $62UxD.createResize)({
    config: (0, $89s6m.config),
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0
});
var $eb306aeedec1e78b$export$889c931173b77c2f = /* #__PURE__ */ (0, $2KWps.createSqueeze)({
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$5e143010dea16c85 = /* #__PURE__ */ (0, $3fJbS.createProd)({
    multiply: $eb306aeedec1e78b$export$2060d2db72cce88f,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$9c297f60e22e3389 = /* #__PURE__ */ (0, $4xcq3.createPow)({
    Complex: $eb306aeedec1e78b$export$50ceb3fb9926e63e,
    config: (0, $89s6m.config),
    fraction: $eb306aeedec1e78b$export$7f34ce79760854f7,
    identity: $eb306aeedec1e78b$export$f0954fd7d5368655,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    multiply: $eb306aeedec1e78b$export$2060d2db72cce88f,
    number: $eb306aeedec1e78b$export$98e628dec113755e,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$ef3b15136279c2ab = /* #__PURE__ */ (0, $7RV4T.createDotPow)({
    DenseMatrix: $eb306aeedec1e78b$export$97f0d27b48f120e8,
    equalScalar: $eb306aeedec1e78b$export$943761f5c9c3f156,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    pow: $eb306aeedec1e78b$export$9c297f60e22e3389,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$a1da16976d3a5f68 = /* #__PURE__ */ (0, $cyEyv.createRightArithShift)({
    DenseMatrix: $eb306aeedec1e78b$export$97f0d27b48f120e8,
    equalScalar: $eb306aeedec1e78b$export$943761f5c9c3f156,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711,
    zeros: $eb306aeedec1e78b$export$4445a00dafa2633b
});
var $eb306aeedec1e78b$export$762e84baec56595d = /* #__PURE__ */ (0, $3c8MR.createCompareNatural)({
    compare: $eb306aeedec1e78b$export$398604a469f7de9a,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$5bc21f656fb5d284 = /* #__PURE__ */ (0, $3xiqs.createEqualText)({
    compareText: $eb306aeedec1e78b$export$2da9287da10b19e2,
    isZero: $eb306aeedec1e78b$export$c46ec7d82fb1f602,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$72693dfc692346df = /* #__PURE__ */ (0, $3MOz5.createLargerEq)({
    DenseMatrix: $eb306aeedec1e78b$export$97f0d27b48f120e8,
    config: (0, $89s6m.config),
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$54d1e322cf7aa273 = /* #__PURE__ */ (0, $5v3G9.createPartitionSelect)({
    compare: $eb306aeedec1e78b$export$398604a469f7de9a,
    isNaN: $eb306aeedec1e78b$export$c9f5652083b8129d,
    isNumeric: $eb306aeedec1e78b$export$e90fb89750dba83f,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$96ec731ed4dcb222 = /* #__PURE__ */ (0, $c8qEj.createMin)({
    smaller: $eb306aeedec1e78b$export$3f732695c1493aec,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$6d4069f4b64f7492 = /* #__PURE__ */ (0, $kqnlZ.createSpaClass)({
    FibonacciHeap: $eb306aeedec1e78b$export$dd5bb73729f20aa3,
    addScalar: $eb306aeedec1e78b$export$2b7b095c4f443355,
    equalScalar: $eb306aeedec1e78b$export$943761f5c9c3f156
});
var $eb306aeedec1e78b$export$3aaf4e522be48075 = /* #__PURE__ */ (0, $gylhh.createAsech)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Complex: $eb306aeedec1e78b$export$50ceb3fb9926e63e,
    config: (0, $89s6m.config),
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$fcdd3b0b3246a325 = /* #__PURE__ */ (0, $4O9gL.createTan)({
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$1c70a6cc12bc0366 = /* #__PURE__ */ (0, $i22NM.createSetSize)({
    compareNatural: $eb306aeedec1e78b$export$762e84baec56595d,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$1991ecd29cc92c6b = /* #__PURE__ */ (0, $9KzjP.createNorm)({
    abs: $eb306aeedec1e78b$export$2335f513bbd82c6d,
    add: $eb306aeedec1e78b$export$e16d8520af44a096,
    conj: $eb306aeedec1e78b$export$fb254c661fe9c0db,
    equalScalar: $eb306aeedec1e78b$export$943761f5c9c3f156,
    larger: $eb306aeedec1e78b$export$a94a7414fa942aea,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    multiply: $eb306aeedec1e78b$export$2060d2db72cce88f,
    pow: $eb306aeedec1e78b$export$9c297f60e22e3389,
    smaller: $eb306aeedec1e78b$export$3f732695c1493aec,
    sqrt: $eb306aeedec1e78b$export$eba8049fb5020b81,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$ff63ee916cadcfe = /* #__PURE__ */ (0, $2V5Tl.createQuantileSeq)({
    add: $eb306aeedec1e78b$export$e16d8520af44a096,
    compare: $eb306aeedec1e78b$export$398604a469f7de9a,
    multiply: $eb306aeedec1e78b$export$2060d2db72cce88f,
    partitionSelect: $eb306aeedec1e78b$export$54d1e322cf7aa273,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$a7ebe8cc6aaf8d37 = /* #__PURE__ */ (0, $cUOM8.createGamma)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Complex: $eb306aeedec1e78b$export$50ceb3fb9926e63e,
    config: (0, $89s6m.config),
    multiplyScalar: $eb306aeedec1e78b$export$c697bed75648cdb7,
    pow: $eb306aeedec1e78b$export$9c297f60e22e3389,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$8576f72eb7f14a7e = /* #__PURE__ */ (0, $cTd4r.createBignumber)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$f686d97e407ec4ef = /* #__PURE__ */ (0, $8lih4.createLcm)({
    equalScalar: $eb306aeedec1e78b$export$943761f5c9c3f156,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$361eb278cc70bacf = /* #__PURE__ */ (0, $4a9NS.createBitOr)({
    DenseMatrix: $eb306aeedec1e78b$export$97f0d27b48f120e8,
    equalScalar: $eb306aeedec1e78b$export$943761f5c9c3f156,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$44f32dfde3d58545 = /* #__PURE__ */ (0, $5eRkA.createKron)({
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    multiplyScalar: $eb306aeedec1e78b$export$c697bed75648cdb7,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$9cb09a71b7d66923 = /* #__PURE__ */ (0, $cIf9i.createTranspose)({
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$b7a508fa8dae59fc = /* #__PURE__ */ (0, $v3afu.createNumeric)({
    bignumber: $eb306aeedec1e78b$export$8576f72eb7f14a7e,
    fraction: $eb306aeedec1e78b$export$7f34ce79760854f7,
    number: $eb306aeedec1e78b$export$98e628dec113755e
});
var $eb306aeedec1e78b$export$21c0ac7fe1cef1b8 = /* #__PURE__ */ (0, $frWlf.createAnd)({
    equalScalar: $eb306aeedec1e78b$export$943761f5c9c3f156,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    not: $eb306aeedec1e78b$export$6003a5f097c73977,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711,
    zeros: $eb306aeedec1e78b$export$4445a00dafa2633b
});
var $eb306aeedec1e78b$export$8d38c87f33a93d98 = /* #__PURE__ */ (0, $hYYhh.createSmallerEq)({
    DenseMatrix: $eb306aeedec1e78b$export$97f0d27b48f120e8,
    config: (0, $89s6m.config),
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$97db5808d8f88186 = /* #__PURE__ */ (0, $iF8zF.createSort)({
    compare: $eb306aeedec1e78b$export$398604a469f7de9a,
    compareNatural: $eb306aeedec1e78b$export$762e84baec56595d,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$ef569ec50496610c = /* #__PURE__ */ (0, $eAT74.createCot)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$94132a0e348806d4 = /* #__PURE__ */ (0, $8RpBq.createDot)({
    add: $eb306aeedec1e78b$export$e16d8520af44a096,
    multiply: $eb306aeedec1e78b$export$2060d2db72cce88f,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$8a63f25cc62965f1 = /* #__PURE__ */ (0, $8qyM8.createSum)({
    bignumber: $eb306aeedec1e78b$export$8576f72eb7f14a7e,
    fraction: $eb306aeedec1e78b$export$7f34ce79760854f7,
    add: $eb306aeedec1e78b$export$e16d8520af44a096,
    config: (0, $89s6m.config),
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$329ce89a99f0e343 = /* #__PURE__ */ (0, $k8VNd.createFactorial)({
    gamma: $eb306aeedec1e78b$export$a7ebe8cc6aaf8d37,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$4567adbe5dd91621 = /* #__PURE__ */ (0, $aY2pj.createPermutations)({
    factorial: $eb306aeedec1e78b$export$329ce89a99f0e343,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$803ce6b71a0a94b2 = /* #__PURE__ */ (0, $9kiFT.createCeil)({
    config: (0, $89s6m.config),
    round: $eb306aeedec1e78b$export$2077e0241d6afd3c,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$4e2d2ead65e5f7e3 = /* #__PURE__ */ (0, $fFD0Y.createSubtract)({
    DenseMatrix: $eb306aeedec1e78b$export$97f0d27b48f120e8,
    addScalar: $eb306aeedec1e78b$export$2b7b095c4f443355,
    equalScalar: $eb306aeedec1e78b$export$943761f5c9c3f156,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711,
    unaryMinus: $eb306aeedec1e78b$export$6cd304851a69e08
});
var $eb306aeedec1e78b$export$bb646b20bb93d339 = /* #__PURE__ */ (0, $bPaMl.createCross)({
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    multiply: $eb306aeedec1e78b$export$2060d2db72cce88f,
    subtract: $eb306aeedec1e78b$export$4e2d2ead65e5f7e3,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$eb6ad7870b1d0b0b = /* #__PURE__ */ (0, $gXhPT.createCtranspose)({
    conj: $eb306aeedec1e78b$export$fb254c661fe9c0db,
    transpose: $eb306aeedec1e78b$export$9cb09a71b7d66923,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$411ce8e5a71e3069 = /* #__PURE__ */ (0, $cZmUN.createEqual)({
    DenseMatrix: $eb306aeedec1e78b$export$97f0d27b48f120e8,
    equalScalar: $eb306aeedec1e78b$export$943761f5c9c3f156,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$cf17b003b6192af3 = /* #__PURE__ */ (0, $9MONg.createIndexClass)({
    ImmutableDenseMatrix: $eb306aeedec1e78b$export$66fe727d7ec8c7b9
});
var $eb306aeedec1e78b$export$dcac7a71ff10ad82 = /* #__PURE__ */ (0, $k2AKL.createSetCartesian)({
    DenseMatrix: $eb306aeedec1e78b$export$97f0d27b48f120e8,
    Index: $eb306aeedec1e78b$export$cf17b003b6192af3,
    compareNatural: $eb306aeedec1e78b$export$762e84baec56595d,
    size: $eb306aeedec1e78b$export$346677f925de839c,
    subset: $eb306aeedec1e78b$export$e06bd7b1ab877a71,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$ec60221e756bab15 = /* #__PURE__ */ (0, $bBOHk.createSetDistinct)({
    DenseMatrix: $eb306aeedec1e78b$export$97f0d27b48f120e8,
    Index: $eb306aeedec1e78b$export$cf17b003b6192af3,
    compareNatural: $eb306aeedec1e78b$export$762e84baec56595d,
    size: $eb306aeedec1e78b$export$346677f925de839c,
    subset: $eb306aeedec1e78b$export$e06bd7b1ab877a71,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$ca5251f59a067f9a = /* #__PURE__ */ (0, $itVHz.createSetIsSubset)({
    Index: $eb306aeedec1e78b$export$cf17b003b6192af3,
    compareNatural: $eb306aeedec1e78b$export$762e84baec56595d,
    size: $eb306aeedec1e78b$export$346677f925de839c,
    subset: $eb306aeedec1e78b$export$e06bd7b1ab877a71,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$f6ce4c11993e56f2 = /* #__PURE__ */ (0, $7iBA0.createSetPowerset)({
    Index: $eb306aeedec1e78b$export$cf17b003b6192af3,
    compareNatural: $eb306aeedec1e78b$export$762e84baec56595d,
    size: $eb306aeedec1e78b$export$346677f925de839c,
    subset: $eb306aeedec1e78b$export$e06bd7b1ab877a71,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$b610b8812bbcded9 = /* #__PURE__ */ (0, $7SBld.createIndex)({
    Index: $eb306aeedec1e78b$export$cf17b003b6192af3,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$d838837eb5b184e3 = /* #__PURE__ */ (0, $lCJe5.createFix)({
    Complex: $eb306aeedec1e78b$export$50ceb3fb9926e63e,
    ceil: $eb306aeedec1e78b$export$803ce6b71a0a94b2,
    floor: $eb306aeedec1e78b$export$a3fe094919f356fd,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$d02631cccf789723 = /* #__PURE__ */ (0, $akiB1.createRange)({
    bignumber: $eb306aeedec1e78b$export$8576f72eb7f14a7e,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    config: (0, $89s6m.config),
    larger: $eb306aeedec1e78b$export$a94a7414fa942aea,
    largerEq: $eb306aeedec1e78b$export$72693dfc692346df,
    smaller: $eb306aeedec1e78b$export$3f732695c1493aec,
    smallerEq: $eb306aeedec1e78b$export$8d38c87f33a93d98,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$67275f837d70084d = /* #__PURE__ */ (0, $iSkrf.createDivideScalar)({
    numeric: $eb306aeedec1e78b$export$b7a508fa8dae59fc,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$adb173527af10aca = /* #__PURE__ */ (0, $VnIhn.createNthRoots)({
    Complex: $eb306aeedec1e78b$export$50ceb3fb9926e63e,
    config: (0, $89s6m.config),
    divideScalar: $eb306aeedec1e78b$export$67275f837d70084d,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$be3b83cc1aa539e4 = /* #__PURE__ */ (0, $kiDwM.createLsolve)({
    DenseMatrix: $eb306aeedec1e78b$export$97f0d27b48f120e8,
    divideScalar: $eb306aeedec1e78b$export$67275f837d70084d,
    equalScalar: $eb306aeedec1e78b$export$943761f5c9c3f156,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    multiplyScalar: $eb306aeedec1e78b$export$c697bed75648cdb7,
    subtract: $eb306aeedec1e78b$export$4e2d2ead65e5f7e3,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$9cb4719e2e525b7a = /* #__PURE__ */ (0, $3PwsX.createDeepEqual)({
    equal: $eb306aeedec1e78b$export$411ce8e5a71e3069,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$8bd517cc5b3722f7 = /* #__PURE__ */ (0, $4ngij.createSetDifference)({
    DenseMatrix: $eb306aeedec1e78b$export$97f0d27b48f120e8,
    Index: $eb306aeedec1e78b$export$cf17b003b6192af3,
    compareNatural: $eb306aeedec1e78b$export$762e84baec56595d,
    size: $eb306aeedec1e78b$export$346677f925de839c,
    subset: $eb306aeedec1e78b$export$e06bd7b1ab877a71,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$8bb4a52260216736 = /* #__PURE__ */ (0, $crsqy.createSetMultiplicity)({
    Index: $eb306aeedec1e78b$export$cf17b003b6192af3,
    compareNatural: $eb306aeedec1e78b$export$762e84baec56595d,
    size: $eb306aeedec1e78b$export$346677f925de839c,
    subset: $eb306aeedec1e78b$export$e06bd7b1ab877a71,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$f95c7888b62f8e9a = /* #__PURE__ */ (0, $3L0Dr.createHypot)({
    abs: $eb306aeedec1e78b$export$2335f513bbd82c6d,
    addScalar: $eb306aeedec1e78b$export$2b7b095c4f443355,
    divideScalar: $eb306aeedec1e78b$export$67275f837d70084d,
    isPositive: $eb306aeedec1e78b$export$7e69d4236fcc3b19,
    multiplyScalar: $eb306aeedec1e78b$export$c697bed75648cdb7,
    smaller: $eb306aeedec1e78b$export$3f732695c1493aec,
    sqrt: $eb306aeedec1e78b$export$eba8049fb5020b81,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$91d2d01a33a1e6f8 = /* #__PURE__ */ (0, $jt5km.createLup)({
    DenseMatrix: $eb306aeedec1e78b$export$97f0d27b48f120e8,
    Spa: $eb306aeedec1e78b$export$6d4069f4b64f7492,
    SparseMatrix: $eb306aeedec1e78b$export$de9b2b7556879848,
    abs: $eb306aeedec1e78b$export$2335f513bbd82c6d,
    addScalar: $eb306aeedec1e78b$export$2b7b095c4f443355,
    divideScalar: $eb306aeedec1e78b$export$67275f837d70084d,
    equalScalar: $eb306aeedec1e78b$export$943761f5c9c3f156,
    larger: $eb306aeedec1e78b$export$a94a7414fa942aea,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    multiplyScalar: $eb306aeedec1e78b$export$c697bed75648cdb7,
    subtract: $eb306aeedec1e78b$export$4e2d2ead65e5f7e3,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711,
    unaryMinus: $eb306aeedec1e78b$export$6cd304851a69e08
});
var $eb306aeedec1e78b$export$95c7459688ef4e3a = /* #__PURE__ */ (0, $6lgyq.createSlu)({
    SparseMatrix: $eb306aeedec1e78b$export$de9b2b7556879848,
    abs: $eb306aeedec1e78b$export$2335f513bbd82c6d,
    add: $eb306aeedec1e78b$export$e16d8520af44a096,
    divideScalar: $eb306aeedec1e78b$export$67275f837d70084d,
    larger: $eb306aeedec1e78b$export$a94a7414fa942aea,
    largerEq: $eb306aeedec1e78b$export$72693dfc692346df,
    multiply: $eb306aeedec1e78b$export$2060d2db72cce88f,
    subtract: $eb306aeedec1e78b$export$4e2d2ead65e5f7e3,
    transpose: $eb306aeedec1e78b$export$9cb09a71b7d66923,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$d063d65fed97e7fa = /* #__PURE__ */ (0, $1lMmn.createDet)({
    lup: $eb306aeedec1e78b$export$91d2d01a33a1e6f8,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    multiply: $eb306aeedec1e78b$export$2060d2db72cce88f,
    subtract: $eb306aeedec1e78b$export$4e2d2ead65e5f7e3,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711,
    unaryMinus: $eb306aeedec1e78b$export$6cd304851a69e08
});
var $eb306aeedec1e78b$export$9f17032d917177de = /* #__PURE__ */ (0, $6P0H6.createDistance)({
    abs: $eb306aeedec1e78b$export$2335f513bbd82c6d,
    addScalar: $eb306aeedec1e78b$export$2b7b095c4f443355,
    divideScalar: $eb306aeedec1e78b$export$67275f837d70084d,
    multiplyScalar: $eb306aeedec1e78b$export$c697bed75648cdb7,
    sqrt: $eb306aeedec1e78b$export$eba8049fb5020b81,
    subtract: $eb306aeedec1e78b$export$4e2d2ead65e5f7e3,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711,
    unaryMinus: $eb306aeedec1e78b$export$6cd304851a69e08
});
var $eb306aeedec1e78b$export$a5abae3de3985f2f = /* #__PURE__ */ (0, $81hN6.createStirlingS2)({
    addScalar: $eb306aeedec1e78b$export$2b7b095c4f443355,
    combinations: $eb306aeedec1e78b$export$bdfcf4c6b5766439,
    divideScalar: $eb306aeedec1e78b$export$67275f837d70084d,
    factorial: $eb306aeedec1e78b$export$329ce89a99f0e343,
    isInteger: $eb306aeedec1e78b$export$a287f47fed4544b8,
    isNegative: $eb306aeedec1e78b$export$d0909a4f38b5c4d0,
    larger: $eb306aeedec1e78b$export$a94a7414fa942aea,
    multiplyScalar: $eb306aeedec1e78b$export$c697bed75648cdb7,
    pow: $eb306aeedec1e78b$export$9c297f60e22e3389,
    subtract: $eb306aeedec1e78b$export$4e2d2ead65e5f7e3,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$d8807a6c0487483a = /* #__PURE__ */ (0, $do5MS.createCatalan)({
    addScalar: $eb306aeedec1e78b$export$2b7b095c4f443355,
    combinations: $eb306aeedec1e78b$export$bdfcf4c6b5766439,
    divideScalar: $eb306aeedec1e78b$export$67275f837d70084d,
    isInteger: $eb306aeedec1e78b$export$a287f47fed4544b8,
    isNegative: $eb306aeedec1e78b$export$d0909a4f38b5c4d0,
    multiplyScalar: $eb306aeedec1e78b$export$c697bed75648cdb7,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$6444ef5cd411280c = /* #__PURE__ */ (0, $4BDvJ.createXor)({
    DenseMatrix: $eb306aeedec1e78b$export$97f0d27b48f120e8,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$120ff0929b202a6d = /* #__PURE__ */ (0, $hHIzA.createRow)({
    Index: $eb306aeedec1e78b$export$cf17b003b6192af3,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    range: $eb306aeedec1e78b$export$d02631cccf789723,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$c74f132961c51406 = /* #__PURE__ */ (0, $fxhCt.createDotDivide)({
    DenseMatrix: $eb306aeedec1e78b$export$97f0d27b48f120e8,
    divideScalar: $eb306aeedec1e78b$export$67275f837d70084d,
    equalScalar: $eb306aeedec1e78b$export$943761f5c9c3f156,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$1d8b9ae22d404866 = /* #__PURE__ */ (0, $iT8TK.createUnitClass)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Complex: $eb306aeedec1e78b$export$50ceb3fb9926e63e,
    Fraction: $eb306aeedec1e78b$export$b336c2702c498be5,
    abs: $eb306aeedec1e78b$export$2335f513bbd82c6d,
    addScalar: $eb306aeedec1e78b$export$2b7b095c4f443355,
    config: (0, $89s6m.config),
    divideScalar: $eb306aeedec1e78b$export$67275f837d70084d,
    equal: $eb306aeedec1e78b$export$411ce8e5a71e3069,
    fix: $eb306aeedec1e78b$export$d838837eb5b184e3,
    format: $eb306aeedec1e78b$export$d9468344d3651243,
    isNumeric: $eb306aeedec1e78b$export$e90fb89750dba83f,
    multiplyScalar: $eb306aeedec1e78b$export$c697bed75648cdb7,
    number: $eb306aeedec1e78b$export$98e628dec113755e,
    pow: $eb306aeedec1e78b$export$9c297f60e22e3389,
    round: $eb306aeedec1e78b$export$2077e0241d6afd3c,
    subtract: $eb306aeedec1e78b$export$4e2d2ead65e5f7e3
});
var $eb306aeedec1e78b$export$aab44654646f3ccc = /* #__PURE__ */ (0, $b1H27.createCreateUnit)({
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$a7eac91d5496c35b = /* #__PURE__ */ (0, $5pxQQ.createSetSymDifference)({
    Index: $eb306aeedec1e78b$export$cf17b003b6192af3,
    concat: $eb306aeedec1e78b$export$ee1b3e54f0441b22,
    setDifference: $eb306aeedec1e78b$export$8bd517cc5b3722f7,
    size: $eb306aeedec1e78b$export$346677f925de839c,
    subset: $eb306aeedec1e78b$export$e06bd7b1ab877a71,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$7c27fb47516129d9 = /* #__PURE__ */ (0, $7Hu1z.createQr)({
    addScalar: $eb306aeedec1e78b$export$2b7b095c4f443355,
    complex: $eb306aeedec1e78b$export$83a0e34f1302825b,
    conj: $eb306aeedec1e78b$export$fb254c661fe9c0db,
    divideScalar: $eb306aeedec1e78b$export$67275f837d70084d,
    equal: $eb306aeedec1e78b$export$411ce8e5a71e3069,
    identity: $eb306aeedec1e78b$export$f0954fd7d5368655,
    isZero: $eb306aeedec1e78b$export$c46ec7d82fb1f602,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    multiplyScalar: $eb306aeedec1e78b$export$c697bed75648cdb7,
    sign: $eb306aeedec1e78b$export$c5552dfdbc7cec71,
    sqrt: $eb306aeedec1e78b$export$eba8049fb5020b81,
    subtract: $eb306aeedec1e78b$export$4e2d2ead65e5f7e3,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711,
    unaryMinus: $eb306aeedec1e78b$export$6cd304851a69e08,
    zeros: $eb306aeedec1e78b$export$4445a00dafa2633b
});
var $eb306aeedec1e78b$export$c02accee9f2b6a8f = /* #__PURE__ */ (0, $339f8.createInv)({
    abs: $eb306aeedec1e78b$export$2335f513bbd82c6d,
    addScalar: $eb306aeedec1e78b$export$2b7b095c4f443355,
    det: $eb306aeedec1e78b$export$d063d65fed97e7fa,
    divideScalar: $eb306aeedec1e78b$export$67275f837d70084d,
    identity: $eb306aeedec1e78b$export$f0954fd7d5368655,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    multiply: $eb306aeedec1e78b$export$2060d2db72cce88f,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711,
    unaryMinus: $eb306aeedec1e78b$export$6cd304851a69e08
});
var $eb306aeedec1e78b$export$d9bacaa51f70e8e = /* #__PURE__ */ (0, $cErc7.createExpm)({
    abs: $eb306aeedec1e78b$export$2335f513bbd82c6d,
    add: $eb306aeedec1e78b$export$e16d8520af44a096,
    identity: $eb306aeedec1e78b$export$f0954fd7d5368655,
    inv: $eb306aeedec1e78b$export$c02accee9f2b6a8f,
    multiply: $eb306aeedec1e78b$export$2060d2db72cce88f,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$cd007d971a5a2143 = /* #__PURE__ */ (0, $gO6Ud.createDivide)({
    divideScalar: $eb306aeedec1e78b$export$67275f837d70084d,
    equalScalar: $eb306aeedec1e78b$export$943761f5c9c3f156,
    inv: $eb306aeedec1e78b$export$c02accee9f2b6a8f,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    multiply: $eb306aeedec1e78b$export$2060d2db72cce88f,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$1ce691f85baaa52 = /* #__PURE__ */ (0, $2y0Ri.createMean)({
    add: $eb306aeedec1e78b$export$e16d8520af44a096,
    divide: $eb306aeedec1e78b$export$cd007d971a5a2143,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$9b77da0927470c3d = /* #__PURE__ */ (0, $9NVBk.createVariance)({
    add: $eb306aeedec1e78b$export$e16d8520af44a096,
    apply: $eb306aeedec1e78b$export$5635d7ef4b8fee1c,
    divide: $eb306aeedec1e78b$export$cd007d971a5a2143,
    isNaN: $eb306aeedec1e78b$export$c9f5652083b8129d,
    multiply: $eb306aeedec1e78b$export$2060d2db72cce88f,
    subtract: $eb306aeedec1e78b$export$4e2d2ead65e5f7e3,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$b14c5e819cb6c927 = /* #__PURE__ */ (0, $dirAu.createStd)({
    sqrt: $eb306aeedec1e78b$export$eba8049fb5020b81,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711,
    variance: $eb306aeedec1e78b$export$9b77da0927470c3d
});
var $eb306aeedec1e78b$export$f4d580f3101a1c7e = /* #__PURE__ */ (0, $hzPWT.createMultinomial)({
    add: $eb306aeedec1e78b$export$e16d8520af44a096,
    divide: $eb306aeedec1e78b$export$cd007d971a5a2143,
    factorial: $eb306aeedec1e78b$export$329ce89a99f0e343,
    isInteger: $eb306aeedec1e78b$export$a287f47fed4544b8,
    isPositive: $eb306aeedec1e78b$export$7e69d4236fcc3b19,
    multiply: $eb306aeedec1e78b$export$2060d2db72cce88f,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$11b531e5540c3ca4 = /* #__PURE__ */ (0, $ktwBg.createAtomicMass)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$c779781d69f736e8 = /* #__PURE__ */ (0, $ktwBg.createBohrMagneton)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$f727e86dcab4e2c6 = /* #__PURE__ */ (0, $ktwBg.createBoltzmann)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$6eafe330bdda8c71 = /* #__PURE__ */ (0, $ktwBg.createConductanceQuantum)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$80bf07f129ad1319 = /* #__PURE__ */ (0, $ktwBg.createDeuteronMass)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$c00fb43e712bef2c = /* #__PURE__ */ (0, $ktwBg.createElectronMass)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$7130fbae042d5c0f = /* #__PURE__ */ (0, $ktwBg.createFaraday)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$f83f3c3b84952e0b = /* #__PURE__ */ (0, $ktwBg.createFirstRadiation)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$d9cccfa50756330b = /* #__PURE__ */ (0, $ktwBg.createGravitationConstant)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$37b0dd3693d47685 = /* #__PURE__ */ (0, $ktwBg.createHartreeEnergy)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$10054c6b64de12f5 = /* #__PURE__ */ (0, $ktwBg.createKlitzing)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$ba3f3691dd1c5a7 = /* #__PURE__ */ (0, $ktwBg.createMagneticConstant)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$6d4ff429f3f89356 = /* #__PURE__ */ (0, $ktwBg.createMolarMass)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$dacf4a2cf8881dff = /* #__PURE__ */ (0, $ktwBg.createMolarPlanckConstant)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$ba7a41eda790cc15 = /* #__PURE__ */ (0, $ktwBg.createNeutronMass)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$9b1b4e5bc980cec6 = /* #__PURE__ */ (0, $ktwBg.createPlanckCharge)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$c20ab336465d7d5e = /* #__PURE__ */ (0, $ktwBg.createPlanckLength)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$5a85cd1a26c2cced = /* #__PURE__ */ (0, $ktwBg.createPlanckTemperature)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$1c88a737209eb089 = /* #__PURE__ */ (0, $ktwBg.createProtonMass)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$963167ae5579ea00 = /* #__PURE__ */ (0, $ktwBg.createReducedPlanckConstant)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$1f7c42a78c01e4f9 = /* #__PURE__ */ (0, $ktwBg.createSecondRadiation)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$f63e81544c3d56ef = /* #__PURE__ */ (0, $ktwBg.createStefanBoltzmann)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$4b15dbe639ad9539 = /* #__PURE__ */ (0, $ktwBg.createVacuumImpedance)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$4e0c71f277ca26b3 = /* #__PURE__ */ (0, $kMxeC.createColumn)({
    Index: $eb306aeedec1e78b$export$cf17b003b6192af3,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    range: $eb306aeedec1e78b$export$d02631cccf789723,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$41828460570e21eb = /* #__PURE__ */ (0, $3oCz3.createUsolve)({
    DenseMatrix: $eb306aeedec1e78b$export$97f0d27b48f120e8,
    divideScalar: $eb306aeedec1e78b$export$67275f837d70084d,
    equalScalar: $eb306aeedec1e78b$export$943761f5c9c3f156,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    multiplyScalar: $eb306aeedec1e78b$export$c697bed75648cdb7,
    subtract: $eb306aeedec1e78b$export$4e2d2ead65e5f7e3,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$9404cfefeb010e68 = /* #__PURE__ */ (0, $2Il54.createSetIntersect)({
    DenseMatrix: $eb306aeedec1e78b$export$97f0d27b48f120e8,
    Index: $eb306aeedec1e78b$export$cf17b003b6192af3,
    compareNatural: $eb306aeedec1e78b$export$762e84baec56595d,
    size: $eb306aeedec1e78b$export$346677f925de839c,
    subset: $eb306aeedec1e78b$export$e06bd7b1ab877a71,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$fccc724a69f253a = /* #__PURE__ */ (0, $lkRnE.createLusolve)({
    DenseMatrix: $eb306aeedec1e78b$export$97f0d27b48f120e8,
    lsolve: $eb306aeedec1e78b$export$be3b83cc1aa539e4,
    lup: $eb306aeedec1e78b$export$91d2d01a33a1e6f8,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    slu: $eb306aeedec1e78b$export$95c7459688ef4e3a,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711,
    usolve: $eb306aeedec1e78b$export$41828460570e21eb
});
var $eb306aeedec1e78b$export$e822b38c59ee8a2a = /* #__PURE__ */ (0, $hUbAD.createEigs)({
    abs: $eb306aeedec1e78b$export$2335f513bbd82c6d,
    add: $eb306aeedec1e78b$export$e16d8520af44a096,
    addScalar: $eb306aeedec1e78b$export$2b7b095c4f443355,
    atan: $eb306aeedec1e78b$export$628dc4eed22b0fbd,
    bignumber: $eb306aeedec1e78b$export$8576f72eb7f14a7e,
    config: (0, $89s6m.config),
    cos: $eb306aeedec1e78b$export$50d414a77b60d802,
    equal: $eb306aeedec1e78b$export$411ce8e5a71e3069,
    inv: $eb306aeedec1e78b$export$c02accee9f2b6a8f,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    multiply: $eb306aeedec1e78b$export$2060d2db72cce88f,
    multiplyScalar: $eb306aeedec1e78b$export$c697bed75648cdb7,
    sin: $eb306aeedec1e78b$export$5de3937cb4b592ed,
    subtract: $eb306aeedec1e78b$export$4e2d2ead65e5f7e3,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$1f4807a235930d45 = /* #__PURE__ */ (0, $k40sh.createIntersect)({
    abs: $eb306aeedec1e78b$export$2335f513bbd82c6d,
    add: $eb306aeedec1e78b$export$e16d8520af44a096,
    addScalar: $eb306aeedec1e78b$export$2b7b095c4f443355,
    config: (0, $89s6m.config),
    divideScalar: $eb306aeedec1e78b$export$67275f837d70084d,
    equalScalar: $eb306aeedec1e78b$export$943761f5c9c3f156,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    multiply: $eb306aeedec1e78b$export$2060d2db72cce88f,
    multiplyScalar: $eb306aeedec1e78b$export$c697bed75648cdb7,
    smaller: $eb306aeedec1e78b$export$3f732695c1493aec,
    subtract: $eb306aeedec1e78b$export$4e2d2ead65e5f7e3,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$bb522a71cda46a13 = /* #__PURE__ */ (0, $dVSwh.createBellNumbers)({
    addScalar: $eb306aeedec1e78b$export$2b7b095c4f443355,
    isInteger: $eb306aeedec1e78b$export$a287f47fed4544b8,
    isNegative: $eb306aeedec1e78b$export$d0909a4f38b5c4d0,
    stirlingS2: $eb306aeedec1e78b$export$a5abae3de3985f2f,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$1236f2451dbdfd63 = /* #__PURE__ */ (0, $ktwBg.createAvogadro)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$f48a0c6b8cc21601 = /* #__PURE__ */ (0, $ktwBg.createClassicalElectronRadius)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$11ff82822f958f25 = /* #__PURE__ */ (0, $ktwBg.createElectricConstant)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$84a9a66802fec40 = /* #__PURE__ */ (0, $ktwBg.createFermiCoupling)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$bfb00cec0048377d = /* #__PURE__ */ (0, $ktwBg.createGravity)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$9eedba962d6a1c01 = /* #__PURE__ */ (0, $ktwBg.createLoschmidt)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$9589ebe123df8f2e = /* #__PURE__ */ (0, $ktwBg.createMolarMassC12)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$7274fb1d27d1cd19 = /* #__PURE__ */ (0, $ktwBg.createNuclearMagneton)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$5ce790af25e5ac75 = /* #__PURE__ */ (0, $ktwBg.createPlanckMass)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$5d88bfa2004001d3 = /* #__PURE__ */ (0, $ktwBg.createQuantumOfCirculation)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$5d66ae3b3e8fce48 = /* #__PURE__ */ (0, $ktwBg.createSpeedOfLight)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$2bcc1e96766dec50 = /* #__PURE__ */ (0, $ktwBg.createWienDisplacement)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$bef1f36f5486a6a3 = /* #__PURE__ */ (0, $bw5eO.createLog)({
    Complex: $eb306aeedec1e78b$export$50ceb3fb9926e63e,
    config: (0, $89s6m.config),
    divideScalar: $eb306aeedec1e78b$export$67275f837d70084d,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$523c0b569236b342 = /* #__PURE__ */ (0, $baZLo.createUnitFunction)({
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$17c7cd2216e18593 = /* #__PURE__ */ (0, $i3llS.createSqrtm)({
    abs: $eb306aeedec1e78b$export$2335f513bbd82c6d,
    add: $eb306aeedec1e78b$export$e16d8520af44a096,
    identity: $eb306aeedec1e78b$export$f0954fd7d5368655,
    inv: $eb306aeedec1e78b$export$c02accee9f2b6a8f,
    max: $eb306aeedec1e78b$export$8960430cfd85939f,
    multiply: $eb306aeedec1e78b$export$2060d2db72cce88f,
    size: $eb306aeedec1e78b$export$346677f925de839c,
    sqrt: $eb306aeedec1e78b$export$eba8049fb5020b81,
    subtract: $eb306aeedec1e78b$export$4e2d2ead65e5f7e3,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$a9fffb6ae6e33dcc = /* #__PURE__ */ (0, $1srjG.createKldivergence)({
    divide: $eb306aeedec1e78b$export$cd007d971a5a2143,
    dotDivide: $eb306aeedec1e78b$export$c74f132961c51406,
    isNumeric: $eb306aeedec1e78b$export$e90fb89750dba83f,
    log: $eb306aeedec1e78b$export$bef1f36f5486a6a3,
    matrix: $eb306aeedec1e78b$export$9bdad1ae37d738e0,
    multiply: $eb306aeedec1e78b$export$2060d2db72cce88f,
    sum: $eb306aeedec1e78b$export$8a63f25cc62965f1,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$5a57f82afcc3edeb = /* #__PURE__ */ (0, $ktwBg.createBohrRadius)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$199cdfec7f52c877 = /* #__PURE__ */ (0, $ktwBg.createElementaryCharge)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$f060c4f0aa5bef89 = /* #__PURE__ */ (0, $ktwBg.createInverseConductanceQuantum)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$863459416408c428 = /* #__PURE__ */ (0, $ktwBg.createMolarVolume)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$85aaf319784a5b0 = /* #__PURE__ */ (0, $ktwBg.createPlanckTime)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$93039724ea765a8e = /* #__PURE__ */ (0, $ktwBg.createThomsonCrossSection)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$144dcf16adfb9698 = /* #__PURE__ */ (0, $81mLS.createLog1p)({
    Complex: $eb306aeedec1e78b$export$50ceb3fb9926e63e,
    config: (0, $89s6m.config),
    divideScalar: $eb306aeedec1e78b$export$67275f837d70084d,
    log: $eb306aeedec1e78b$export$bef1f36f5486a6a3,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$9c490b34b2f16a34 = /* #__PURE__ */ (0, $kzEhI.createMedian)({
    add: $eb306aeedec1e78b$export$e16d8520af44a096,
    compare: $eb306aeedec1e78b$export$398604a469f7de9a,
    divide: $eb306aeedec1e78b$export$cd007d971a5a2143,
    partitionSelect: $eb306aeedec1e78b$export$54d1e322cf7aa273,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$a614e1ad972260a9 = /* #__PURE__ */ (0, $ktwBg.createGasConstant)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$cbd33810258dab2e = /* #__PURE__ */ (0, $ktwBg.createPlanckConstant)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$667066422fa0af46 = /* #__PURE__ */ (0, $eJPWT.createSetUnion)({
    Index: $eb306aeedec1e78b$export$cf17b003b6192af3,
    concat: $eb306aeedec1e78b$export$ee1b3e54f0441b22,
    setIntersect: $eb306aeedec1e78b$export$9404cfefeb010e68,
    setSymDifference: $eb306aeedec1e78b$export$a7eac91d5496c35b,
    size: $eb306aeedec1e78b$export$346677f925de839c,
    subset: $eb306aeedec1e78b$export$e06bd7b1ab877a71,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$699e2a89b148c5ee = /* #__PURE__ */ (0, $ktwBg.createMagneticFluxQuantum)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$2f2e110dac549211 = /* #__PURE__ */ (0, $ktwBg.createCoulomb)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});
var $eb306aeedec1e78b$export$b14ea41a64d6efa6 = /* #__PURE__ */ (0, $13FHT.createMad)({
    abs: $eb306aeedec1e78b$export$2335f513bbd82c6d,
    map: $eb306aeedec1e78b$export$871de8747c9eaa88,
    median: $eb306aeedec1e78b$export$9c490b34b2f16a34,
    subtract: $eb306aeedec1e78b$export$4e2d2ead65e5f7e3,
    typed: $eb306aeedec1e78b$export$519f616c41a1c711
});
var $eb306aeedec1e78b$export$683732ab8f5759dc = /* #__PURE__ */ (0, $ktwBg.createRydberg)({
    BigNumber: $eb306aeedec1e78b$export$d97aa349ed20696,
    Unit: $eb306aeedec1e78b$export$1d8b9ae22d404866,
    config: (0, $89s6m.config)
});

});
parcelRegister("iTLx7", function(module, exports) {

$parcel$export(module.exports, "createAbs", function () { return $dc223c2715a872bb$export$dd8a9b3843a4df95; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");

var $6fCew = parcelRequire("6fCew");
var $dc223c2715a872bb$var$name = "abs";
var $dc223c2715a872bb$var$dependencies = [
    "typed"
];
var $dc223c2715a872bb$export$dd8a9b3843a4df95 = /* #__PURE__ */ (0, $2mPYl.factory)($dc223c2715a872bb$var$name, $dc223c2715a872bb$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Calculate the absolute value of a number. For matrices, the function is
   * evaluated element wise.
   *
   * Syntax:
   *
   *    math.abs(x)
   *
   * Examples:
   *
   *    math.abs(3.5)                // returns number 3.5
   *    math.abs(-4.2)               // returns number 4.2
   *
   *    math.abs([3, -5, -1, 0, 2])  // returns Array [3, 5, 1, 0, 2]
   *
   * See also:
   *
   *    sign
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix | Unit} x
   *            A number or matrix for which to get the absolute value
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix | Unit}
   *            Absolute value of `x`
   */ var abs = typed($dc223c2715a872bb$var$name, {
        number: (0, $6fCew.absNumber),
        Complex: function Complex(x) {
            return x.abs();
        },
        BigNumber: function BigNumber(x) {
            return x.abs();
        },
        Fraction: function Fraction(x) {
            return x.abs();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since abs(0) = 0
            return (0, $e04i1.deepMap)(x, abs, true);
        },
        Unit: function Unit(x) {
            return x.abs();
        }
    });
    return abs;
});

});
parcelRegister("6fCew", function(module, exports) {

$parcel$export(module.exports, "absNumber", function () { return $48d1cd21c8c03358$export$59270f717756a93a; });
$parcel$export(module.exports, "addNumber", function () { return $48d1cd21c8c03358$export$d6751d2a3b6da12a; });
$parcel$export(module.exports, "multiplyNumber", function () { return $48d1cd21c8c03358$export$4ad41ac849e391ec; });
$parcel$export(module.exports, "unaryMinusNumber", function () { return $48d1cd21c8c03358$export$339666dc881be46b; });
$parcel$export(module.exports, "unaryPlusNumber", function () { return $48d1cd21c8c03358$export$da5b80d388a295fb; });
$parcel$export(module.exports, "cbrtNumber", function () { return $48d1cd21c8c03358$export$95c2aecb85f70726; });
$parcel$export(module.exports, "ceilNumber", function () { return $48d1cd21c8c03358$export$dd91a1966a303b99; });
$parcel$export(module.exports, "cubeNumber", function () { return $48d1cd21c8c03358$export$9505f0b39acd04c; });
$parcel$export(module.exports, "expNumber", function () { return $48d1cd21c8c03358$export$a33b288b35672fe5; });
$parcel$export(module.exports, "expm1Number", function () { return $48d1cd21c8c03358$export$756d0c010cecc6c3; });
$parcel$export(module.exports, "gcdNumber", function () { return $48d1cd21c8c03358$export$3a8d786b08b3a70c; });
$parcel$export(module.exports, "lcmNumber", function () { return $48d1cd21c8c03358$export$b55f99ec1f4c5649; });
$parcel$export(module.exports, "logNumber", function () { return $48d1cd21c8c03358$export$4df0e8fcdd5c0927; });
$parcel$export(module.exports, "log10Number", function () { return $48d1cd21c8c03358$export$e3f8d49574d29dff; });
$parcel$export(module.exports, "log2Number", function () { return $48d1cd21c8c03358$export$f9bc93220cfa3c59; });
$parcel$export(module.exports, "modNumber", function () { return $48d1cd21c8c03358$export$64b58c5b0372ae95; });
$parcel$export(module.exports, "nthRootNumber", function () { return $48d1cd21c8c03358$export$9f26f16bd796a7b3; });
$parcel$export(module.exports, "signNumber", function () { return $48d1cd21c8c03358$export$af3d9fe43be78285; });
$parcel$export(module.exports, "squareNumber", function () { return $48d1cd21c8c03358$export$c4094a156ed9ab35; });
$parcel$export(module.exports, "xgcdNumber", function () { return $48d1cd21c8c03358$export$8cb756a23a623229; });
$parcel$export(module.exports, "powNumber", function () { return $48d1cd21c8c03358$export$3f512e7fd4999e01; });
$parcel$export(module.exports, "roundNumber", function () { return $48d1cd21c8c03358$export$a3992db8dd0fd9e6; });

var $kFRKb = parcelRequire("kFRKb");
var $48d1cd21c8c03358$var$n1 = "number";
var $48d1cd21c8c03358$var$n2 = "number, number";
function $48d1cd21c8c03358$export$59270f717756a93a(a) {
    return Math.abs(a);
}
$48d1cd21c8c03358$export$59270f717756a93a.signature = $48d1cd21c8c03358$var$n1;
function $48d1cd21c8c03358$export$d6751d2a3b6da12a(a, b) {
    return a + b;
}
$48d1cd21c8c03358$export$d6751d2a3b6da12a.signature = $48d1cd21c8c03358$var$n2;
function $48d1cd21c8c03358$export$fd8ce9cfca47ace5(a, b) {
    return a - b;
}
$48d1cd21c8c03358$export$fd8ce9cfca47ace5.signature = $48d1cd21c8c03358$var$n2;
function $48d1cd21c8c03358$export$4ad41ac849e391ec(a, b) {
    return a * b;
}
$48d1cd21c8c03358$export$4ad41ac849e391ec.signature = $48d1cd21c8c03358$var$n2;
function $48d1cd21c8c03358$export$58c48a269ab4a155(a, b) {
    return a / b;
}
$48d1cd21c8c03358$export$58c48a269ab4a155.signature = $48d1cd21c8c03358$var$n2;
function $48d1cd21c8c03358$export$339666dc881be46b(x) {
    return -x;
}
$48d1cd21c8c03358$export$339666dc881be46b.signature = $48d1cd21c8c03358$var$n1;
function $48d1cd21c8c03358$export$da5b80d388a295fb(x) {
    return x;
}
$48d1cd21c8c03358$export$da5b80d388a295fb.signature = $48d1cd21c8c03358$var$n1;
function $48d1cd21c8c03358$export$95c2aecb85f70726(x) {
    return (0, $kFRKb.cbrt)(x);
}
$48d1cd21c8c03358$export$95c2aecb85f70726.signature = $48d1cd21c8c03358$var$n1;
function $48d1cd21c8c03358$export$dd91a1966a303b99(x) {
    return Math.ceil(x);
}
$48d1cd21c8c03358$export$dd91a1966a303b99.signature = $48d1cd21c8c03358$var$n1;
function $48d1cd21c8c03358$export$9505f0b39acd04c(x) {
    return x * x * x;
}
$48d1cd21c8c03358$export$9505f0b39acd04c.signature = $48d1cd21c8c03358$var$n1;
function $48d1cd21c8c03358$export$a33b288b35672fe5(x) {
    return Math.exp(x);
}
$48d1cd21c8c03358$export$a33b288b35672fe5.signature = $48d1cd21c8c03358$var$n1;
function $48d1cd21c8c03358$export$756d0c010cecc6c3(x) {
    return (0, $kFRKb.expm1)(x);
}
$48d1cd21c8c03358$export$756d0c010cecc6c3.signature = $48d1cd21c8c03358$var$n1;
function $48d1cd21c8c03358$export$f0d92d0037f57a41(x) {
    return x > 0 ? Math.floor(x) : Math.ceil(x);
}
$48d1cd21c8c03358$export$f0d92d0037f57a41.signature = $48d1cd21c8c03358$var$n1;
function $48d1cd21c8c03358$export$10d3df201a8983fc(x) {
    return Math.floor(x);
}
$48d1cd21c8c03358$export$10d3df201a8983fc.signature = $48d1cd21c8c03358$var$n1;
function $48d1cd21c8c03358$export$3a8d786b08b3a70c(a, b) {
    if (!(0, $kFRKb.isInteger)(a) || !(0, $kFRKb.isInteger)(b)) throw new Error("Parameters in function gcd must be integer numbers");
     // https://en.wikipedia.org/wiki/Euclidean_algorithm
    var r;
    while(b !== 0){
        r = a % b;
        a = b;
        b = r;
    }
    return a < 0 ? -a : a;
}
$48d1cd21c8c03358$export$3a8d786b08b3a70c.signature = $48d1cd21c8c03358$var$n2;
function $48d1cd21c8c03358$export$b55f99ec1f4c5649(a, b) {
    if (!(0, $kFRKb.isInteger)(a) || !(0, $kFRKb.isInteger)(b)) throw new Error("Parameters in function lcm must be integer numbers");
    if (a === 0 || b === 0) return 0;
     // https://en.wikipedia.org/wiki/Euclidean_algorithm
    // evaluate lcm here inline to reduce overhead
    var t;
    var prod = a * b;
    while(b !== 0){
        t = b;
        b = a % t;
        a = t;
    }
    return Math.abs(prod / a);
}
$48d1cd21c8c03358$export$b55f99ec1f4c5649.signature = $48d1cd21c8c03358$var$n2;
function $48d1cd21c8c03358$export$4df0e8fcdd5c0927(x) {
    return Math.log(x);
}
$48d1cd21c8c03358$export$4df0e8fcdd5c0927.signature = $48d1cd21c8c03358$var$n1;
function $48d1cd21c8c03358$export$e3f8d49574d29dff(x) {
    return (0, $kFRKb.log10)(x);
}
$48d1cd21c8c03358$export$e3f8d49574d29dff.signature = $48d1cd21c8c03358$var$n1;
function $48d1cd21c8c03358$export$f9bc93220cfa3c59(x) {
    return (0, $kFRKb.log2)(x);
}
$48d1cd21c8c03358$export$f9bc93220cfa3c59.signature = $48d1cd21c8c03358$var$n1;
function $48d1cd21c8c03358$export$ae1f56e105ebe4a1(x) {
    return (0, $kFRKb.log1p)(x);
}
$48d1cd21c8c03358$export$ae1f56e105ebe4a1.signature = $48d1cd21c8c03358$var$n1;
function $48d1cd21c8c03358$export$64b58c5b0372ae95(x, y) {
    if (y > 0) // We don't use JavaScript's % operator here as this doesn't work
    // correctly for x < 0 and x === 0
    // see https://en.wikipedia.org/wiki/Modulo_operation
    return x - y * Math.floor(x / y);
    else if (y === 0) return x;
    else // y < 0
    // TODO: implement mod for a negative divisor
    throw new Error("Cannot calculate mod for a negative divisor");
}
$48d1cd21c8c03358$export$64b58c5b0372ae95.signature = $48d1cd21c8c03358$var$n2;
function $48d1cd21c8c03358$export$9f26f16bd796a7b3(a, root) {
    var inv = root < 0;
    if (inv) root = -root;
    if (root === 0) throw new Error("Root must be non-zero");
    if (a < 0 && Math.abs(root) % 2 !== 1) throw new Error("Root must be odd when a is negative.");
     // edge cases zero and infinity
    if (a === 0) return inv ? Infinity : 0;
    if (!isFinite(a)) return inv ? 0 : a;
    var x = Math.pow(Math.abs(a), 1 / root); // If a < 0, we require that root is an odd integer,
    // so (-1) ^ (1/root) = -1
    x = a < 0 ? -x : x;
    return inv ? 1 / x : x; // Very nice algorithm, but fails with nthRoot(-2, 3).
// Newton's method has some well-known problems at times:
// https://en.wikipedia.org/wiki/Newton%27s_method#Failure_analysis
/*
  let x = 1 // Initial guess
  let xPrev = 1
  let i = 0
  const iMax = 10000
  do {
    const delta = (a / Math.pow(x, root - 1) - x) / root
    xPrev = x
    x = x + delta
    i++
  }
  while (xPrev !== x && i < iMax)
   if (xPrev !== x) {
    throw new Error('Function nthRoot failed to converge')
  }
   return inv ? 1 / x : x
  */ }
$48d1cd21c8c03358$export$9f26f16bd796a7b3.signature = $48d1cd21c8c03358$var$n2;
function $48d1cd21c8c03358$export$af3d9fe43be78285(x) {
    return (0, $kFRKb.sign)(x);
}
$48d1cd21c8c03358$export$af3d9fe43be78285.signature = $48d1cd21c8c03358$var$n1;
function $48d1cd21c8c03358$export$aacd0ed14e49886d(x) {
    return Math.sqrt(x);
}
$48d1cd21c8c03358$export$aacd0ed14e49886d.signature = $48d1cd21c8c03358$var$n1;
function $48d1cd21c8c03358$export$c4094a156ed9ab35(x) {
    return x * x;
}
$48d1cd21c8c03358$export$c4094a156ed9ab35.signature = $48d1cd21c8c03358$var$n1;
function $48d1cd21c8c03358$export$8cb756a23a623229(a, b) {
    // source: https://en.wikipedia.org/wiki/Extended_Euclidean_algorithm
    var t; // used to swap two variables
    var q; // quotient
    var r; // remainder
    var x = 0;
    var lastx = 1;
    var y = 1;
    var lasty = 0;
    if (!(0, $kFRKb.isInteger)(a) || !(0, $kFRKb.isInteger)(b)) throw new Error("Parameters in function xgcd must be integer numbers");
    while(b){
        q = Math.floor(a / b);
        r = a - q * b;
        t = x;
        x = lastx - q * x;
        lastx = t;
        t = y;
        y = lasty - q * y;
        lasty = t;
        a = b;
        b = r;
    }
    var res;
    if (a < 0) res = [
        -a,
        -lastx,
        -lasty
    ];
    else res = [
        a,
        a ? lastx : 0,
        lasty
    ];
    return res;
}
$48d1cd21c8c03358$export$8cb756a23a623229.signature = $48d1cd21c8c03358$var$n2;
function $48d1cd21c8c03358$export$3f512e7fd4999e01(x, y) {
    // x^Infinity === 0 if -1 < x < 1
    // A real number 0 is returned instead of complex(0)
    if (x * x < 1 && y === Infinity || x * x > 1 && y === -Infinity) return 0;
    return Math.pow(x, y);
}
$48d1cd21c8c03358$export$3f512e7fd4999e01.signature = $48d1cd21c8c03358$var$n2;
function $48d1cd21c8c03358$export$a3992db8dd0fd9e6(value) {
    var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return parseFloat((0, $kFRKb.toFixed)(value, decimals));
}
$48d1cd21c8c03358$export$a3992db8dd0fd9e6.signature = $48d1cd21c8c03358$var$n2;
function $48d1cd21c8c03358$export$d78ecacee56245ec(x) {
    return Math.abs(x);
}
$48d1cd21c8c03358$export$d78ecacee56245ec.signature = $48d1cd21c8c03358$var$n1;

});


parcelRegister("lqksZ", function(module, exports) {

$parcel$export(module.exports, "createAcos", function () { return $f98be6f02fcab5b5$export$33da46c5ece67581; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");
var $f98be6f02fcab5b5$var$name = "acos";
var $f98be6f02fcab5b5$var$dependencies = [
    "typed",
    "config",
    "Complex"
];
var $f98be6f02fcab5b5$export$33da46c5ece67581 = /* #__PURE__ */ (0, $2mPYl.factory)($f98be6f02fcab5b5$var$name, $f98be6f02fcab5b5$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, Complex = _ref.Complex;
    /**
   * Calculate the inverse cosine of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.acos(x)
   *
   * Examples:
   *
   *    math.acos(0.5)           // returns number 1.0471975511965979
   *    math.acos(math.cos(1.5)) // returns number 1.5
   *
   *    math.acos(2)             // returns Complex 0 + 1.3169578969248166 i
   *
   * See also:
   *
   *    cos, atan, asin
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x  Function input
   * @return {number | BigNumber | Complex | Array | Matrix} The arc cosine of x
   */ var acos = typed($f98be6f02fcab5b5$var$name, {
        number: function number(x) {
            if (x >= -1 && x <= 1 || config.predictable) return Math.acos(x);
            else return new Complex(x, 0).acos();
        },
        Complex: function Complex(x) {
            return x.acos();
        },
        BigNumber: function BigNumber(x) {
            return x.acos();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, acos);
        }
    });
    return acos;
});

});

parcelRegister("4slJf", function(module, exports) {

$parcel$export(module.exports, "createAcosh", function () { return $33eaa1d2849593e4$export$c634796792055579; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");

var $2F5hp = parcelRequire("2F5hp");
var $33eaa1d2849593e4$var$name = "acosh";
var $33eaa1d2849593e4$var$dependencies = [
    "typed",
    "config",
    "Complex"
];
var $33eaa1d2849593e4$export$c634796792055579 = /* #__PURE__ */ (0, $2mPYl.factory)($33eaa1d2849593e4$var$name, $33eaa1d2849593e4$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, Complex = _ref.Complex;
    /**
   * Calculate the hyperbolic arccos of a value,
   * defined as `acosh(x) = ln(sqrt(x^2 - 1) + x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.acosh(x)
   *
   * Examples:
   *
   *    math.acosh(1.5)       // returns 0.9624236501192069
   *
   * See also:
   *
   *    cosh, asinh, atanh
   *
   * @param {number | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic arccosine of x
   */ var acosh = typed($33eaa1d2849593e4$var$name, {
        number: function number(x) {
            if (x >= 1 || config.predictable) return (0, $2F5hp.acoshNumber)(x);
            if (x <= -1) return new Complex(Math.log(Math.sqrt(x * x - 1) - x), Math.PI);
            return new Complex(x, 0).acosh();
        },
        Complex: function Complex(x) {
            return x.acosh();
        },
        BigNumber: function BigNumber(x) {
            return x.acosh();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, acosh);
        }
    });
    return acosh;
});

});
parcelRegister("2F5hp", function(module, exports) {

$parcel$export(module.exports, "acoshNumber", function () { return $1f03818e41f8a631$export$84088556f7d2d0be; });
$parcel$export(module.exports, "acotNumber", function () { return $1f03818e41f8a631$export$ba80ccbf024897ef; });
$parcel$export(module.exports, "acothNumber", function () { return $1f03818e41f8a631$export$e2be1aa5d5a3f81; });
$parcel$export(module.exports, "acscNumber", function () { return $1f03818e41f8a631$export$e3b67a6e3df3fd81; });
$parcel$export(module.exports, "acschNumber", function () { return $1f03818e41f8a631$export$51cd224337b2c783; });
$parcel$export(module.exports, "asecNumber", function () { return $1f03818e41f8a631$export$5ec3930177455ade; });
$parcel$export(module.exports, "asechNumber", function () { return $1f03818e41f8a631$export$cf144300ea173362; });
$parcel$export(module.exports, "asinhNumber", function () { return $1f03818e41f8a631$export$3a027485d3336d8d; });
$parcel$export(module.exports, "atanhNumber", function () { return $1f03818e41f8a631$export$44a1f653c6513db8; });
$parcel$export(module.exports, "cotNumber", function () { return $1f03818e41f8a631$export$515b39f7fd07e09f; });
$parcel$export(module.exports, "cothNumber", function () { return $1f03818e41f8a631$export$925affe88b2512fc; });
$parcel$export(module.exports, "cscNumber", function () { return $1f03818e41f8a631$export$5a8409ad16e318b2; });
$parcel$export(module.exports, "cschNumber", function () { return $1f03818e41f8a631$export$143835b5c1db9790; });
$parcel$export(module.exports, "secNumber", function () { return $1f03818e41f8a631$export$ee1efc70bd8a6d93; });
$parcel$export(module.exports, "sechNumber", function () { return $1f03818e41f8a631$export$b83345d70fe4a871; });
$parcel$export(module.exports, "sinhNumber", function () { return $1f03818e41f8a631$export$89648c4ce0d79e70; });

var $kFRKb = parcelRequire("kFRKb");
var $1f03818e41f8a631$var$n1 = "number";
var $1f03818e41f8a631$var$n2 = "number, number";
function $1f03818e41f8a631$export$99a14685a3a2b607(x) {
    return Math.acos(x);
}
$1f03818e41f8a631$export$99a14685a3a2b607.signature = $1f03818e41f8a631$var$n1;
function $1f03818e41f8a631$export$84088556f7d2d0be(x) {
    return (0, $kFRKb.acosh)(x);
}
$1f03818e41f8a631$export$84088556f7d2d0be.signature = $1f03818e41f8a631$var$n1;
function $1f03818e41f8a631$export$ba80ccbf024897ef(x) {
    return Math.atan(1 / x);
}
$1f03818e41f8a631$export$ba80ccbf024897ef.signature = $1f03818e41f8a631$var$n1;
function $1f03818e41f8a631$export$e2be1aa5d5a3f81(x) {
    return isFinite(x) ? (Math.log((x + 1) / x) + Math.log(x / (x - 1))) / 2 : 0;
}
$1f03818e41f8a631$export$e2be1aa5d5a3f81.signature = $1f03818e41f8a631$var$n1;
function $1f03818e41f8a631$export$e3b67a6e3df3fd81(x) {
    return Math.asin(1 / x);
}
$1f03818e41f8a631$export$e3b67a6e3df3fd81.signature = $1f03818e41f8a631$var$n1;
function $1f03818e41f8a631$export$51cd224337b2c783(x) {
    var xInv = 1 / x;
    return Math.log(xInv + Math.sqrt(xInv * xInv + 1));
}
$1f03818e41f8a631$export$51cd224337b2c783.signature = $1f03818e41f8a631$var$n1;
function $1f03818e41f8a631$export$5ec3930177455ade(x) {
    return Math.acos(1 / x);
}
$1f03818e41f8a631$export$5ec3930177455ade.signature = $1f03818e41f8a631$var$n1;
function $1f03818e41f8a631$export$cf144300ea173362(x) {
    var xInv = 1 / x;
    var ret = Math.sqrt(xInv * xInv - 1);
    return Math.log(ret + xInv);
}
$1f03818e41f8a631$export$cf144300ea173362.signature = $1f03818e41f8a631$var$n1;
function $1f03818e41f8a631$export$444ef2855488a2d5(x) {
    return Math.asin(x);
}
$1f03818e41f8a631$export$444ef2855488a2d5.signature = $1f03818e41f8a631$var$n1;
function $1f03818e41f8a631$export$3a027485d3336d8d(x) {
    return (0, $kFRKb.asinh)(x);
}
$1f03818e41f8a631$export$3a027485d3336d8d.signature = $1f03818e41f8a631$var$n1;
function $1f03818e41f8a631$export$c38dcb11df4699c0(x) {
    return Math.atan(x);
}
$1f03818e41f8a631$export$c38dcb11df4699c0.signature = $1f03818e41f8a631$var$n1;
function $1f03818e41f8a631$export$a97666a135b540f9(y, x) {
    return Math.atan2(y, x);
}
$1f03818e41f8a631$export$a97666a135b540f9.signature = $1f03818e41f8a631$var$n2;
function $1f03818e41f8a631$export$44a1f653c6513db8(x) {
    return (0, $kFRKb.atanh)(x);
}
$1f03818e41f8a631$export$44a1f653c6513db8.signature = $1f03818e41f8a631$var$n1;
function $1f03818e41f8a631$export$8d04496be3e647d4(x) {
    return Math.cos(x);
}
$1f03818e41f8a631$export$8d04496be3e647d4.signature = $1f03818e41f8a631$var$n1;
function $1f03818e41f8a631$export$7cf8db0cff734545(x) {
    return (0, $kFRKb.cosh)(x);
}
$1f03818e41f8a631$export$7cf8db0cff734545.signature = $1f03818e41f8a631$var$n1;
function $1f03818e41f8a631$export$515b39f7fd07e09f(x) {
    return 1 / Math.tan(x);
}
$1f03818e41f8a631$export$515b39f7fd07e09f.signature = $1f03818e41f8a631$var$n1;
function $1f03818e41f8a631$export$925affe88b2512fc(x) {
    var e = Math.exp(2 * x);
    return (e + 1) / (e - 1);
}
$1f03818e41f8a631$export$925affe88b2512fc.signature = $1f03818e41f8a631$var$n1;
function $1f03818e41f8a631$export$5a8409ad16e318b2(x) {
    return 1 / Math.sin(x);
}
$1f03818e41f8a631$export$5a8409ad16e318b2.signature = $1f03818e41f8a631$var$n1;
function $1f03818e41f8a631$export$143835b5c1db9790(x) {
    // consider values close to zero (+/-)
    if (x === 0) return Number.POSITIVE_INFINITY;
    else return Math.abs(2 / (Math.exp(x) - Math.exp(-x))) * (0, $kFRKb.sign)(x);
}
$1f03818e41f8a631$export$143835b5c1db9790.signature = $1f03818e41f8a631$var$n1;
function $1f03818e41f8a631$export$ee1efc70bd8a6d93(x) {
    return 1 / Math.cos(x);
}
$1f03818e41f8a631$export$ee1efc70bd8a6d93.signature = $1f03818e41f8a631$var$n1;
function $1f03818e41f8a631$export$b83345d70fe4a871(x) {
    return 2 / (Math.exp(x) + Math.exp(-x));
}
$1f03818e41f8a631$export$b83345d70fe4a871.signature = $1f03818e41f8a631$var$n1;
function $1f03818e41f8a631$export$b6e96f13f41c8816(x) {
    return Math.sin(x);
}
$1f03818e41f8a631$export$b6e96f13f41c8816.signature = $1f03818e41f8a631$var$n1;
function $1f03818e41f8a631$export$89648c4ce0d79e70(x) {
    return (0, $kFRKb.sinh)(x);
}
$1f03818e41f8a631$export$89648c4ce0d79e70.signature = $1f03818e41f8a631$var$n1;
function $1f03818e41f8a631$export$ecbd7b3271ebce16(x) {
    return Math.tan(x);
}
$1f03818e41f8a631$export$ecbd7b3271ebce16.signature = $1f03818e41f8a631$var$n1;
function $1f03818e41f8a631$export$70e2e2cc9c2555e4(x) {
    return (0, $kFRKb.tanh)(x);
}
$1f03818e41f8a631$export$70e2e2cc9c2555e4.signature = $1f03818e41f8a631$var$n1;

});


parcelRegister("hIz83", function(module, exports) {

$parcel$export(module.exports, "createAcot", function () { return $ce61cb929f079923$export$8a6845771325148e; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");

var $2F5hp = parcelRequire("2F5hp");
var $ce61cb929f079923$var$name = "acot";
var $ce61cb929f079923$var$dependencies = [
    "typed",
    "BigNumber"
];
var $ce61cb929f079923$export$8a6845771325148e = /* #__PURE__ */ (0, $2mPYl.factory)($ce61cb929f079923$var$name, $ce61cb929f079923$var$dependencies, function(_ref) {
    var typed = _ref.typed, _BigNumber = _ref.BigNumber;
    /**
   * Calculate the inverse cotangent of a value, defined as `acot(x) = atan(1/x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.acot(x)
   *
   * Examples:
   *
   *    math.acot(0.5)           // returns number 0.4636476090008061
   *    math.acot(math.cot(1.5)) // returns number 1.5
   *
   *    math.acot(2)             // returns Complex 1.5707963267948966 -1.3169578969248166 i
   *
   * See also:
   *
   *    cot, atan
   *
   * @param {number | Complex | Array | Matrix} x   Function input
   * @return {number | Complex | Array | Matrix} The arc cotangent of x
   */ var acot = typed($ce61cb929f079923$var$name, {
        number: (0, $2F5hp.acotNumber),
        Complex: function Complex(x) {
            return x.acot();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).atan();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, acot);
        }
    });
    return acot;
});

});

parcelRegister("4pbjb", function(module, exports) {

$parcel$export(module.exports, "createAcoth", function () { return $335244d4a849731b$export$67e40c7fd8f5703a; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");

var $2F5hp = parcelRequire("2F5hp");
var $335244d4a849731b$var$name = "acoth";
var $335244d4a849731b$var$dependencies = [
    "typed",
    "config",
    "Complex",
    "BigNumber"
];
var $335244d4a849731b$export$67e40c7fd8f5703a = /* #__PURE__ */ (0, $2mPYl.factory)($335244d4a849731b$var$name, $335244d4a849731b$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, Complex = _ref.Complex, _BigNumber = _ref.BigNumber;
    /**
   * Calculate the hyperbolic arccotangent of a value,
   * defined as `acoth(x) = atanh(1/x) = (ln((x+1)/x) + ln(x/(x-1))) / 2`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.acoth(x)
   *
   * Examples:
   *
   *    math.acoth(0.5)       // returns 0.8047189562170503
   *
   * See also:
   *
   *    acsch, asech
   *
   * @param {number | Complex | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic arccotangent of x
   */ var acoth = typed($335244d4a849731b$var$name, {
        number: function number(x) {
            if (x >= 1 || x <= -1 || config.predictable) return (0, $2F5hp.acothNumber)(x);
            return new Complex(x, 0).acoth();
        },
        Complex: function Complex(x) {
            return x.acoth();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).atanh();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, acoth);
        }
    });
    return acoth;
});

});

parcelRegister("52gGD", function(module, exports) {

$parcel$export(module.exports, "createAcsc", function () { return $3aaa15473a209d74$export$95580581b134a5bd; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");

var $2F5hp = parcelRequire("2F5hp");
var $3aaa15473a209d74$var$name = "acsc";
var $3aaa15473a209d74$var$dependencies = [
    "typed",
    "config",
    "Complex",
    "BigNumber"
];
var $3aaa15473a209d74$export$95580581b134a5bd = /* #__PURE__ */ (0, $2mPYl.factory)($3aaa15473a209d74$var$name, $3aaa15473a209d74$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, Complex = _ref.Complex, _BigNumber = _ref.BigNumber;
    /**
   * Calculate the inverse cosecant of a value, defined as `acsc(x) = asin(1/x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.acsc(x)
   *
   * Examples:
   *
   *    math.acsc(0.5)           // returns number 0.5235987755982989
   *    math.acsc(math.csc(1.5)) // returns number ~1.5
   *
   *    math.acsc(2)             // returns Complex 1.5707963267948966 -1.3169578969248166 i
   *
   * See also:
   *
   *    csc, asin, asec
   *
   * @param {number | Complex | Array | Matrix} x   Function input
   * @return {number | Complex | Array | Matrix} The arc cosecant of x
   */ var acsc = typed($3aaa15473a209d74$var$name, {
        number: function number(x) {
            if (x <= -1 || x >= 1 || config.predictable) return (0, $2F5hp.acscNumber)(x);
            return new Complex(x, 0).acsc();
        },
        Complex: function Complex(x) {
            return x.acsc();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).asin();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, acsc);
        }
    });
    return acsc;
});

});

parcelRegister("cmOCU", function(module, exports) {

$parcel$export(module.exports, "createAcsch", function () { return $900ecf779cada109$export$d6534043a40dc59; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");

var $2F5hp = parcelRequire("2F5hp");
var $900ecf779cada109$var$name = "acsch";
var $900ecf779cada109$var$dependencies = [
    "typed",
    "BigNumber"
];
var $900ecf779cada109$export$d6534043a40dc59 = /* #__PURE__ */ (0, $2mPYl.factory)($900ecf779cada109$var$name, $900ecf779cada109$var$dependencies, function(_ref) {
    var typed = _ref.typed, _BigNumber = _ref.BigNumber;
    /**
   * Calculate the hyperbolic arccosecant of a value,
   * defined as `acsch(x) = asinh(1/x) = ln(1/x + sqrt(1/x^2 + 1))`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.acsch(x)
   *
   * Examples:
   *
   *    math.acsch(0.5)       // returns 1.4436354751788103
   *
   * See also:
   *
   *    asech, acoth
   *
   * @param {number | Complex | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic arccosecant of x
   */ var acsch = typed($900ecf779cada109$var$name, {
        number: (0, $2F5hp.acschNumber),
        Complex: function Complex(x) {
            return x.acsch();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).asinh();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, acsch);
        }
    });
    return acsch;
});

});

parcelRegister("ivSXu", function(module, exports) {

$parcel$export(module.exports, "createAdd", function () { return $d7a5c0d6b916d330$export$c6b51545da64d82f; });

var $2mPYl = parcelRequire("2mPYl");

var $7ITGG = parcelRequire("7ITGG");

var $gIOYU = parcelRequire("gIOYU");

var $5mDFR = parcelRequire("5mDFR");

var $1rFP6 = parcelRequire("1rFP6");

var $1bBLS = parcelRequire("1bBLS");

var $iHnaT = parcelRequire("iHnaT");
var $d7a5c0d6b916d330$var$name = "add";
var $d7a5c0d6b916d330$var$dependencies = [
    "typed",
    "matrix",
    "addScalar",
    "equalScalar",
    "DenseMatrix",
    "SparseMatrix"
];
var $d7a5c0d6b916d330$export$c6b51545da64d82f = /* #__PURE__ */ (0, $2mPYl.factory)($d7a5c0d6b916d330$var$name, $d7a5c0d6b916d330$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, addScalar = _ref.addScalar, equalScalar = _ref.equalScalar, DenseMatrix = _ref.DenseMatrix, SparseMatrix = _ref.SparseMatrix;
    var algorithm01 = (0, $gIOYU.createAlgorithm01)({
        typed: typed
    });
    var algorithm04 = (0, $5mDFR.createAlgorithm04)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm10 = (0, $1rFP6.createAlgorithm10)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $1bBLS.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $iHnaT.createAlgorithm14)({
        typed: typed
    });
    /**
   * Add two or more values, `x + y`.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.add(x, y)
   *    math.add(x, y, z, ...)
   *
   * Examples:
   *
   *    math.add(2, 3)               // returns number 5
   *    math.add(2, 3, 4)            // returns number 9
   *
   *    const a = math.complex(2, 3)
   *    const b = math.complex(-4, 1)
   *    math.add(a, b)               // returns Complex -2 + 4i
   *
   *    math.add([1, 2, 3], 4)       // returns Array [5, 6, 7]
   *
   *    const c = math.unit('5 cm')
   *    const d = math.unit('2.1 mm')
   *    math.add(c, d)               // returns Unit 52.1 mm
   *
   *    math.add("2.3", "4")         // returns number 6.3
   *
   * See also:
   *
   *    subtract, sum
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x First value to add
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Second value to add
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} Sum of `x` and `y`
   */ var add = typed($d7a5c0d6b916d330$var$name, (0, $7ITGG.extend)({
        // we extend the signatures of addScalar with signatures dealing with matrices
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, addScalar);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm01(x, y, addScalar, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm01(y, x, addScalar, true);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm04(x, y, addScalar);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return add(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return add(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return add(x, matrix(y));
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, addScalar, false);
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm10(x, y, addScalar, false);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, addScalar, true);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm10(y, x, addScalar, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, addScalar, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, addScalar, true).valueOf();
        },
        "any, any": addScalar,
        "any, any, ...any": function anyAnyAny(x, y, rest) {
            var result = add(x, y);
            for(var i = 0; i < rest.length; i++)result = add(result, rest[i]);
            return result;
        }
    }, addScalar.signatures));
    return add;
});

});
parcelRegister("gIOYU", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm01", function () { return $c2c84d3a86553eb7$export$5e6d55d37a917802; });

var $2mPYl = parcelRequire("2mPYl");

var $hy7Bx = parcelRequire("hy7Bx");
var $c2c84d3a86553eb7$var$name = "algorithm01";
var $c2c84d3a86553eb7$var$dependencies = [
    "typed"
];
var $c2c84d3a86553eb7$export$5e6d55d37a917802 = /* #__PURE__ */ (0, $2mPYl.factory)($c2c84d3a86553eb7$var$name, $c2c84d3a86553eb7$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Iterates over SparseMatrix nonzero items and invokes the callback function f(Dij, Sij).
   * Callback function invoked NNZ times (number of nonzero items in SparseMatrix).
   *
   *
   *          ┌  f(Dij, Sij)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  Dij          ; otherwise
   *
   *
   * @param {Matrix}   denseMatrix       The DenseMatrix instance (D)
   * @param {Matrix}   sparseMatrix      The SparseMatrix instance (S)
   * @param {Function} callback          The f(Dij,Sij) operation to invoke, where Dij = DenseMatrix(i,j) and Sij = SparseMatrix(i,j)
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(Sij,Dij)
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97477571
   */ return function algorithm1(denseMatrix, sparseMatrix, callback, inverse) {
        // dense matrix arrays
        var adata = denseMatrix._data;
        var asize = denseMatrix._size;
        var adt = denseMatrix._datatype; // sparse matrix arrays
        var bvalues = sparseMatrix._values;
        var bindex = sparseMatrix._index;
        var bptr = sparseMatrix._ptr;
        var bsize = sparseMatrix._size;
        var bdt = sparseMatrix._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $hy7Bx.DimensionError)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
         // sparse matrix cannot be a Pattern matrix
        if (!bvalues) throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // process data types
        var dt = typeof adt === "string" && adt === bdt ? adt : undefined; // callback function
        var cf = dt ? typed.find(callback, [
            dt,
            dt
        ]) : callback; // vars
        var i, j; // result (DenseMatrix)
        var cdata = []; // initialize c
        for(i = 0; i < rows; i++)cdata[i] = [];
         // workspace
        var x = []; // marks indicating we have a value in x for a given column
        var w = []; // loop columns in b
        for(j = 0; j < columns; j++){
            // column mark
            var mark = j + 1; // values in column j
            for(var k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                i = bindex[k]; // update workspace
                x[i] = inverse ? cf(bvalues[k], adata[i][j]) : cf(adata[i][j], bvalues[k]); // mark i as updated
                w[i] = mark;
            } // loop rows
            for(i = 0; i < rows; i++)// check row is in workspace
            if (w[i] === mark) // c[i][j] was already calculated
            cdata[i][j] = x[i];
            else // item does not exist in S
            cdata[i][j] = adata[i][j];
        } // return dense matrix
        return denseMatrix.createDenseMatrix({
            data: cdata,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});

});

parcelRegister("5mDFR", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm04", function () { return $3e7dc844143b416f$export$898ea3bef50d41b7; });

var $2mPYl = parcelRequire("2mPYl");

var $hy7Bx = parcelRequire("hy7Bx");
var $3e7dc844143b416f$var$name = "algorithm04";
var $3e7dc844143b416f$var$dependencies = [
    "typed",
    "equalScalar"
];
var $3e7dc844143b416f$export$898ea3bef50d41b7 = /* #__PURE__ */ (0, $2mPYl.factory)($3e7dc844143b416f$var$name, $3e7dc844143b416f$var$dependencies, function(_ref) {
    var typed = _ref.typed, equalScalar = _ref.equalScalar;
    /**
   * Iterates over SparseMatrix A and SparseMatrix B nonzero items and invokes the callback function f(Aij, Bij).
   * Callback function invoked MAX(NNZA, NNZB) times
   *
   *
   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0 && B(i,j) !== 0
   * C(i,j) = ┤  A(i,j)       ; A(i,j) !== 0
   *          └  B(i,j)       ; B(i,j) !== 0
   *
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function algorithm04(a, b, callback) {
        // sparse matrix arrays
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var asize = a._size;
        var adt = a._datatype; // sparse matrix arrays
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bsize = b._size;
        var bdt = b._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $hy7Bx.DimensionError)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string" && adt === bdt) {
            // datatype
            dt = adt; // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cvalues = avalues && bvalues ? [] : undefined;
        var cindex = [];
        var cptr = []; // workspace
        var xa = avalues && bvalues ? [] : undefined;
        var xb = avalues && bvalues ? [] : undefined; // marks indicating we have a value in x for a given column
        var wa = [];
        var wb = []; // vars
        var i, j, k, k0, k1; // loop columns
        for(j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length; // columns mark
            var mark = j + 1; // loop A(:,j)
            for(k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                i = aindex[k]; // update c
                cindex.push(i); // update workspace
                wa[i] = mark; // check we need to process values
                if (xa) xa[i] = avalues[k];
            } // loop B(:,j)
            for(k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                i = bindex[k]; // check row exists in A
                if (wa[i] === mark) // update record in xa @ i
                {
                    if (xa) {
                        // invoke callback
                        var v = cf(xa[i], bvalues[k]); // check for zero
                        if (!eq(v, zero)) // update workspace
                        xa[i] = v;
                        else // remove mark (index will be removed later)
                        wa[i] = null;
                    }
                } else {
                    // update c
                    cindex.push(i); // update workspace
                    wb[i] = mark; // check we need to process values
                    if (xb) xb[i] = bvalues[k];
                }
            } // check we need to process values (non pattern matrix)
            if (xa && xb) {
                // initialize first index in j
                k = cptr[j]; // loop index in j
                while(k < cindex.length){
                    // row
                    i = cindex[k]; // check workspace has value @ i
                    if (wa[i] === mark) {
                        // push value (Aij != 0 || (Aij != 0 && Bij != 0))
                        cvalues[k] = xa[i]; // increment pointer
                        k++;
                    } else if (wb[i] === mark) {
                        // push value (bij != 0)
                        cvalues[k] = xb[i]; // increment pointer
                        k++;
                    } else // remove index @ k
                    cindex.splice(k, 1);
                }
            }
        } // update cptr
        cptr[columns] = cindex.length; // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});

});

parcelRegister("1rFP6", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm10", function () { return $10d8c14df1944284$export$72a88f2eee9ec1ed; });

var $2mPYl = parcelRequire("2mPYl");
var $10d8c14df1944284$var$name = "algorithm10";
var $10d8c14df1944284$var$dependencies = [
    "typed",
    "DenseMatrix"
];
var $10d8c14df1944284$export$72a88f2eee9ec1ed = /* #__PURE__ */ (0, $2mPYl.factory)($10d8c14df1944284$var$name, $10d8c14df1944284$var$dependencies, function(_ref) {
    var typed = _ref.typed, DenseMatrix = _ref.DenseMatrix;
    /**
   * Iterates over SparseMatrix S nonzero items and invokes the callback function f(Sij, b).
   * Callback function invoked NZ times (number of nonzero items in S).
   *
   *
   *          ┌  f(Sij, b)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  b          ; otherwise
   *
   *
   * @param {Matrix}   s                 The SparseMatrix instance (S)
   * @param {Scalar}   b                 The Scalar value
   * @param {Function} callback          The f(Aij,b) operation to invoke
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Sij)
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97626813
   */ return function algorithm10(s, b, callback, inverse) {
        // sparse matrix arrays
        var avalues = s._values;
        var aindex = s._index;
        var aptr = s._ptr;
        var asize = s._size;
        var adt = s._datatype; // sparse matrix cannot be a Pattern matrix
        if (!avalues) throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string") {
            // datatype
            dt = adt; // convert b to the same datatype
            b = typed.convert(b, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cdata = []; // workspaces
        var x = []; // marks indicating we have a value in x for a given column
        var w = []; // loop columns
        for(var j = 0; j < columns; j++){
            // columns mark
            var mark = j + 1; // values in j
            for(var k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                var r = aindex[k]; // update workspace
                x[r] = avalues[k];
                w[r] = mark;
            } // loop rows
            for(var i = 0; i < rows; i++){
                // initialize C on first column
                if (j === 0) // create row array
                cdata[i] = [];
                 // check sparse matrix has a value @ i,j
                if (w[i] === mark) // invoke callback, update C
                cdata[i][j] = inverse ? cf(b, x[i]) : cf(x[i], b);
                else // dense matrix value @ i, j
                cdata[i][j] = b;
            }
        } // return dense matrix
        return new DenseMatrix({
            data: cdata,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});

});

parcelRegister("1bBLS", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm13", function () { return $0dd41e16f27a393e$export$fa05124e71a8ffb3; });

var $2mPYl = parcelRequire("2mPYl");

var $hy7Bx = parcelRequire("hy7Bx");
var $0dd41e16f27a393e$var$name = "algorithm13";
var $0dd41e16f27a393e$var$dependencies = [
    "typed"
];
var $0dd41e16f27a393e$export$fa05124e71a8ffb3 = /* #__PURE__ */ (0, $2mPYl.factory)($0dd41e16f27a393e$var$name, $0dd41e16f27a393e$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Iterates over DenseMatrix items and invokes the callback function f(Aij..z, Bij..z).
   * Callback function invoked MxN times.
   *
   * C(i,j,...z) = f(Aij..z, Bij..z)
   *
   * @param {Matrix}   a                 The DenseMatrix instance (A)
   * @param {Matrix}   b                 The DenseMatrix instance (B)
   * @param {Function} callback          The f(Aij..z,Bij..z) operation to invoke
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97658658
   */ return function algorithm13(a, b, callback) {
        // a arrays
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype; // b arrays
        var bdata = b._data;
        var bsize = b._size;
        var bdt = b._datatype; // c arrays
        var csize = []; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $hy7Bx.DimensionError)(asize.length, bsize.length);
         // validate each one of the dimension sizes
        for(var s = 0; s < asize.length; s++){
            // must match
            if (asize[s] !== bsize[s]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
             // update dimension in c
            csize[s] = asize[s];
        } // datatype
        var dt; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string" && adt === bdt) {
            // datatype
            dt = adt; // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // populate cdata, iterate through dimensions
        var cdata = csize.length > 0 ? _iterate(cf, 0, csize, csize[0], adata, bdata) : []; // c matrix
        return a.createDenseMatrix({
            data: cdata,
            size: csize,
            datatype: dt
        });
    }; // recursive function
    function _iterate(f, level, s, n, av, bv) {
        // initialize array for this level
        var cv = []; // check we reach the last level
        if (level === s.length - 1) // loop arrays in last level
        for(var i = 0; i < n; i++)// invoke callback and store value
        cv[i] = f(av[i], bv[i]);
        else // iterate current level
        for(var j = 0; j < n; j++)// iterate next level
        cv[j] = _iterate(f, level + 1, s, s[level + 1], av[j], bv[j]);
        return cv;
    }
});

});

parcelRegister("iHnaT", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm14", function () { return $d9ce382a8c9a09a8$export$e5afe3bc814ef550; });

var $2mPYl = parcelRequire("2mPYl");

var $7ITGG = parcelRequire("7ITGG");
var $d9ce382a8c9a09a8$var$name = "algorithm14";
var $d9ce382a8c9a09a8$var$dependencies = [
    "typed"
];
var $d9ce382a8c9a09a8$export$e5afe3bc814ef550 = /* #__PURE__ */ (0, $2mPYl.factory)($d9ce382a8c9a09a8$var$name, $d9ce382a8c9a09a8$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Iterates over DenseMatrix items and invokes the callback function f(Aij..z, b).
   * Callback function invoked MxN times.
   *
   * C(i,j,...z) = f(Aij..z, b)
   *
   * @param {Matrix}   a                 The DenseMatrix instance (A)
   * @param {Scalar}   b                 The Scalar value
   * @param {Function} callback          The f(Aij..z,b) operation to invoke
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Aij..z)
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97659042
   */ return function algorithm14(a, b, callback, inverse) {
        // a arrays
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype; // datatype
        var dt; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string") {
            // datatype
            dt = adt; // convert b to the same datatype
            b = typed.convert(b, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // populate cdata, iterate through dimensions
        var cdata = asize.length > 0 ? _iterate(cf, 0, asize, asize[0], adata, b, inverse) : []; // c matrix
        return a.createDenseMatrix({
            data: cdata,
            size: (0, $7ITGG.clone)(asize),
            datatype: dt
        });
    }; // recursive function
    function _iterate(f, level, s, n, av, bv, inverse) {
        // initialize array for this level
        var cv = []; // check we reach the last level
        if (level === s.length - 1) // loop arrays in last level
        for(var i = 0; i < n; i++)// invoke callback and store value
        cv[i] = inverse ? f(bv, av[i]) : f(av[i], bv);
        else // iterate current level
        for(var j = 0; j < n; j++)// iterate next level
        cv[j] = _iterate(f, level + 1, s, s[level + 1], av[j], bv, inverse);
        return cv;
    }
});

});


parcelRegister("2hq9f", function(module, exports) {

$parcel$export(module.exports, "createAddScalar", function () { return $1a9173ccfb9d58b7$export$bbebd809b9ccc50b; });

var $2mPYl = parcelRequire("2mPYl");

var $6fCew = parcelRequire("6fCew");
var $1a9173ccfb9d58b7$var$name = "addScalar";
var $1a9173ccfb9d58b7$var$dependencies = [
    "typed"
];
var $1a9173ccfb9d58b7$export$bbebd809b9ccc50b = /* #__PURE__ */ (0, $2mPYl.factory)($1a9173ccfb9d58b7$var$name, $1a9173ccfb9d58b7$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Add two scalar values, `x + y`.
   * This function is meant for internal use: it is used by the public function
   * `add`
   *
   * This function does not support collections (Array or Matrix).
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit} x   First value to add
   * @param  {number | BigNumber | Fraction | Complex} y          Second value to add
   * @return {number | BigNumber | Fraction | Complex | Unit}     Sum of `x` and `y`
   * @private
   */ var addScalar = typed($1a9173ccfb9d58b7$var$name, {
        "number, number": (0, $6fCew.addNumber),
        "Complex, Complex": function ComplexComplex(x, y) {
            return x.add(y);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.plus(y);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.add(y);
        },
        "Unit, Unit": function UnitUnit(x, y) {
            if (x.value === null || x.value === undefined) throw new Error("Parameter x contains a unit with undefined value");
            if (y.value === null || y.value === undefined) throw new Error("Parameter y contains a unit with undefined value");
            if (!x.equalBase(y)) throw new Error("Units do not match");
            var res = x.clone();
            res.value = addScalar(res.value, y.value);
            res.fixPrefix = false;
            return res;
        }
    });
    return addScalar;
});

});

parcelRegister("frWlf", function(module, exports) {

$parcel$export(module.exports, "createAnd", function () { return $b3f6a212dcc28ff5$export$15a698d88cae0eff; });

var $cITNv = parcelRequire("cITNv");

var $cZfrH = parcelRequire("cZfrH");

var $1bBLS = parcelRequire("1bBLS");

var $iHnaT = parcelRequire("iHnaT");

var $9INF1 = parcelRequire("9INF1");

var $2mPYl = parcelRequire("2mPYl");

var $fAJNv = parcelRequire("fAJNv");
var $b3f6a212dcc28ff5$var$name = "and";
var $b3f6a212dcc28ff5$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "zeros",
    "not"
];
var $b3f6a212dcc28ff5$export$15a698d88cae0eff = /* #__PURE__ */ (0, $2mPYl.factory)($b3f6a212dcc28ff5$var$name, $b3f6a212dcc28ff5$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, equalScalar = _ref.equalScalar, zeros = _ref.zeros, not = _ref.not;
    var algorithm02 = (0, $cITNv.createAlgorithm02)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm06 = (0, $9INF1.createAlgorithm06)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm11 = (0, $cZfrH.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $1bBLS.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $iHnaT.createAlgorithm14)({
        typed: typed
    });
    /**
   * Logical `and`. Test whether two values are both defined with a nonzero/nonempty value.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.and(x, y)
   *
   * Examples:
   *
   *    math.and(2, 4)   // returns true
   *
   *    a = [2, 0, 0]
   *    b = [3, 7, 0]
   *    c = 0
   *
   *    math.and(a, b)   // returns [true, false, false]
   *    math.and(a, c)   // returns [false, false, false]
   *
   * See also:
   *
   *    not, or, xor
   *
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x First value to check
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} y Second value to check
   * @return {boolean | Array | Matrix}
   *            Returns true when both inputs are defined with a nonzero/nonempty value.
   */ var and = typed($b3f6a212dcc28ff5$var$name, {
        "number, number": (0, $fAJNv.andNumber),
        "Complex, Complex": function ComplexComplex(x, y) {
            return (x.re !== 0 || x.im !== 0) && (y.re !== 0 || y.im !== 0);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return !x.isZero() && !y.isZero() && !x.isNaN() && !y.isNaN();
        },
        "Unit, Unit": function UnitUnit(x, y) {
            return and(x.value || 0, y.value || 0);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm06(x, y, and, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, and, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm02(x, y, and, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, and);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return and(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return and(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return and(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            // check scalar
            if (not(y)) // return zero matrix
            return zeros(x.size(), x.storage());
            return algorithm11(x, y, and, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            // check scalar
            if (not(y)) // return zero matrix
            return zeros(x.size(), x.storage());
            return algorithm14(x, y, and, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            // check scalar
            if (not(x)) // return zero matrix
            return zeros(x.size(), x.storage());
            return algorithm11(y, x, and, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            // check scalar
            if (not(x)) // return zero matrix
            return zeros(x.size(), x.storage());
            return algorithm14(y, x, and, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return and(matrix(x), y).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return and(x, matrix(y)).valueOf();
        }
    });
    return and;
});

});
parcelRegister("cITNv", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm02", function () { return $9434e054539ac257$export$92edb534a8f19a37; });

var $2mPYl = parcelRequire("2mPYl");

var $hy7Bx = parcelRequire("hy7Bx");
var $9434e054539ac257$var$name = "algorithm02";
var $9434e054539ac257$var$dependencies = [
    "typed",
    "equalScalar"
];
var $9434e054539ac257$export$92edb534a8f19a37 = /* #__PURE__ */ (0, $2mPYl.factory)($9434e054539ac257$var$name, $9434e054539ac257$var$dependencies, function(_ref) {
    var typed = _ref.typed, equalScalar = _ref.equalScalar;
    /**
   * Iterates over SparseMatrix nonzero items and invokes the callback function f(Dij, Sij).
   * Callback function invoked NNZ times (number of nonzero items in SparseMatrix).
   *
   *
   *          ┌  f(Dij, Sij)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  0            ; otherwise
   *
   *
   * @param {Matrix}   denseMatrix       The DenseMatrix instance (D)
   * @param {Matrix}   sparseMatrix      The SparseMatrix instance (S)
   * @param {Function} callback          The f(Dij,Sij) operation to invoke, where Dij = DenseMatrix(i,j) and Sij = SparseMatrix(i,j)
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(Sij,Dij)
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97477571
   */ return function algorithm02(denseMatrix, sparseMatrix, callback, inverse) {
        // dense matrix arrays
        var adata = denseMatrix._data;
        var asize = denseMatrix._size;
        var adt = denseMatrix._datatype; // sparse matrix arrays
        var bvalues = sparseMatrix._values;
        var bindex = sparseMatrix._index;
        var bptr = sparseMatrix._ptr;
        var bsize = sparseMatrix._size;
        var bdt = sparseMatrix._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $hy7Bx.DimensionError)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
         // sparse matrix cannot be a Pattern matrix
        if (!bvalues) throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string" && adt === bdt) {
            // datatype
            dt = adt; // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result (SparseMatrix)
        var cvalues = [];
        var cindex = [];
        var cptr = []; // loop columns in b
        for(var j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length; // values in column j
            for(var k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                var i = bindex[k]; // update C(i,j)
                var cij = inverse ? cf(bvalues[k], adata[i][j]) : cf(adata[i][j], bvalues[k]); // check for nonzero
                if (!eq(cij, zero)) {
                    // push i & v
                    cindex.push(i);
                    cvalues.push(cij);
                }
            }
        } // update cptr
        cptr[columns] = cindex.length; // return sparse matrix
        return sparseMatrix.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});

});

parcelRegister("cZfrH", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm11", function () { return $974729b90f5c4e72$export$a38279a12199d831; });

var $2mPYl = parcelRequire("2mPYl");
var $974729b90f5c4e72$var$name = "algorithm11";
var $974729b90f5c4e72$var$dependencies = [
    "typed",
    "equalScalar"
];
var $974729b90f5c4e72$export$a38279a12199d831 = /* #__PURE__ */ (0, $2mPYl.factory)($974729b90f5c4e72$var$name, $974729b90f5c4e72$var$dependencies, function(_ref) {
    var typed = _ref.typed, equalScalar = _ref.equalScalar;
    /**
   * Iterates over SparseMatrix S nonzero items and invokes the callback function f(Sij, b).
   * Callback function invoked NZ times (number of nonzero items in S).
   *
   *
   *          ┌  f(Sij, b)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  0          ; otherwise
   *
   *
   * @param {Matrix}   s                 The SparseMatrix instance (S)
   * @param {Scalar}   b                 The Scalar value
   * @param {Function} callback          The f(Aij,b) operation to invoke
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Sij)
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97626813
   */ return function algorithm11(s, b, callback, inverse) {
        // sparse matrix arrays
        var avalues = s._values;
        var aindex = s._index;
        var aptr = s._ptr;
        var asize = s._size;
        var adt = s._datatype; // sparse matrix cannot be a Pattern matrix
        if (!avalues) throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string") {
            // datatype
            dt = adt; // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt); // convert b to the same datatype
            b = typed.convert(b, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cvalues = [];
        var cindex = [];
        var cptr = []; // loop columns
        for(var j = 0; j < columns; j++){
            // initialize ptr
            cptr[j] = cindex.length; // values in j
            for(var k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                var i = aindex[k]; // invoke callback
                var v = inverse ? cf(b, avalues[k]) : cf(avalues[k], b); // check value is zero
                if (!eq(v, zero)) {
                    // push index & value
                    cindex.push(i);
                    cvalues.push(v);
                }
            }
        } // update ptr
        cptr[columns] = cindex.length; // return sparse matrix
        return s.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});

});

parcelRegister("9INF1", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm06", function () { return $713ebeacc300c815$export$d6f401e6f2a7e54b; });

var $2mPYl = parcelRequire("2mPYl");

var $hy7Bx = parcelRequire("hy7Bx");

var $e04i1 = parcelRequire("e04i1");
var $713ebeacc300c815$var$name = "algorithm06";
var $713ebeacc300c815$var$dependencies = [
    "typed",
    "equalScalar"
];
var $713ebeacc300c815$export$d6f401e6f2a7e54b = /* #__PURE__ */ (0, $2mPYl.factory)($713ebeacc300c815$var$name, $713ebeacc300c815$var$dependencies, function(_ref) {
    var typed = _ref.typed, equalScalar = _ref.equalScalar;
    /**
   * Iterates over SparseMatrix A and SparseMatrix B nonzero items and invokes the callback function f(Aij, Bij).
   * Callback function invoked (Anz U Bnz) times, where Anz and Bnz are the nonzero elements in both matrices.
   *
   *
   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0 && B(i,j) !== 0
   * C(i,j) = ┤
   *          └  0            ; otherwise
   *
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function algorithm06(a, b, callback) {
        // sparse matrix arrays
        var avalues = a._values;
        var asize = a._size;
        var adt = a._datatype; // sparse matrix arrays
        var bvalues = b._values;
        var bsize = b._size;
        var bdt = b._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $hy7Bx.DimensionError)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string" && adt === bdt) {
            // datatype
            dt = adt; // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cvalues = avalues && bvalues ? [] : undefined;
        var cindex = [];
        var cptr = []; // workspaces
        var x = cvalues ? [] : undefined; // marks indicating we have a value in x for a given column
        var w = []; // marks indicating value in a given row has been updated
        var u = []; // loop columns
        for(var j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length; // columns mark
            var mark = j + 1; // scatter the values of A(:,j) into workspace
            (0, $e04i1.scatter)(a, j, w, x, u, mark, cindex, cf); // scatter the values of B(:,j) into workspace
            (0, $e04i1.scatter)(b, j, w, x, u, mark, cindex, cf); // check we need to process values (non pattern matrix)
            if (x) {
                // initialize first index in j
                var k = cptr[j]; // loop index in j
                while(k < cindex.length){
                    // row
                    var i = cindex[k]; // check function was invoked on current row (Aij !=0 && Bij != 0)
                    if (u[i] === mark) {
                        // value @ i
                        var v = x[i]; // check for zero value
                        if (!eq(v, zero)) {
                            // push value
                            cvalues.push(v); // increment pointer
                            k++;
                        } else // remove value @ i, do not increment pointer
                        cindex.splice(k, 1);
                    } else // remove value @ i, do not increment pointer
                    cindex.splice(k, 1);
                }
            } else {
                // initialize first index in j
                var p = cptr[j]; // loop index in j
                while(p < cindex.length){
                    // row
                    var r = cindex[p]; // check function was invoked on current row (Aij !=0 && Bij != 0)
                    if (u[r] !== mark) // remove value @ i, do not increment pointer
                    cindex.splice(p, 1);
                    else // increment pointer
                    p++;
                }
            }
        } // update cptr
        cptr[columns] = cindex.length; // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});

});

parcelRegister("fAJNv", function(module, exports) {

$parcel$export(module.exports, "notNumber", function () { return $b59dbe402f76c85b$export$5c3e9fce4e8f3d3a; });
$parcel$export(module.exports, "orNumber", function () { return $b59dbe402f76c85b$export$cb9e31d07eec8012; });
$parcel$export(module.exports, "xorNumber", function () { return $b59dbe402f76c85b$export$17cc7dc3a74df3af; });
$parcel$export(module.exports, "andNumber", function () { return $b59dbe402f76c85b$export$11dffb061e00e795; });
var $b59dbe402f76c85b$var$n1 = "number";
var $b59dbe402f76c85b$var$n2 = "number, number";
function $b59dbe402f76c85b$export$5c3e9fce4e8f3d3a(x) {
    return !x;
}
$b59dbe402f76c85b$export$5c3e9fce4e8f3d3a.signature = $b59dbe402f76c85b$var$n1;
function $b59dbe402f76c85b$export$cb9e31d07eec8012(x, y) {
    return !!(x || y);
}
$b59dbe402f76c85b$export$cb9e31d07eec8012.signature = $b59dbe402f76c85b$var$n2;
function $b59dbe402f76c85b$export$17cc7dc3a74df3af(x, y) {
    return !!x !== !!y;
}
$b59dbe402f76c85b$export$17cc7dc3a74df3af.signature = $b59dbe402f76c85b$var$n2;
function $b59dbe402f76c85b$export$11dffb061e00e795(x, y) {
    return !!(x && y);
}
$b59dbe402f76c85b$export$11dffb061e00e795.signature = $b59dbe402f76c85b$var$n2;

});


parcelRegister("53FUY", function(module, exports) {

$parcel$export(module.exports, "createArg", function () { return $3aedbf91027144fd$export$bde3dabbd4699a93; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");
var $3aedbf91027144fd$var$name = "arg";
var $3aedbf91027144fd$var$dependencies = [
    "typed"
];
var $3aedbf91027144fd$export$bde3dabbd4699a93 = /* #__PURE__ */ (0, $2mPYl.factory)($3aedbf91027144fd$var$name, $3aedbf91027144fd$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Compute the argument of a complex value.
   * For a complex number `a + bi`, the argument is computed as `atan2(b, a)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.arg(x)
   *
   * Examples:
   *
   *    const a = math.complex(2, 2)
   *    math.arg(a) / math.pi          // returns number 0.25
   *
   *    const b = math.complex('2 + 3i')
   *    math.arg(b)                    // returns number 0.982793723247329
   *    math.atan2(3, 2)               // returns number 0.982793723247329
   *
   * See also:
   *
   *    re, im, conj, abs
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            A complex number or array with complex numbers
   * @return {number | BigNumber | Array | Matrix} The argument of x
   */ var arg = typed($3aedbf91027144fd$var$name, {
        number: function number(x) {
            return Math.atan2(0, x);
        },
        BigNumber: function BigNumber(x) {
            return x.constructor.atan2(0, x);
        },
        Complex: function Complex(x) {
            return x.arg();
        },
        // TODO: implement BigNumber support for function arg
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, arg);
        }
    });
    return arg;
});

});

parcelRegister("hIQTp", function(module, exports) {

$parcel$export(module.exports, "createAsec", function () { return $ce6f932303352d99$export$e1f28fc7c94f90b0; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");

var $2F5hp = parcelRequire("2F5hp");
var $ce6f932303352d99$var$name = "asec";
var $ce6f932303352d99$var$dependencies = [
    "typed",
    "config",
    "Complex",
    "BigNumber"
];
var $ce6f932303352d99$export$e1f28fc7c94f90b0 = /* #__PURE__ */ (0, $2mPYl.factory)($ce6f932303352d99$var$name, $ce6f932303352d99$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, Complex = _ref.Complex, _BigNumber = _ref.BigNumber;
    /**
   * Calculate the inverse secant of a value. Defined as `asec(x) = acos(1/x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.asec(x)
   *
   * Examples:
   *
   *    math.asec(0.5)           // returns 1.0471975511965979
   *    math.asec(math.sec(1.5)) // returns 1.5
   *
   *    math.asec(2)             // returns 0 + 1.3169578969248166 i
   *
   * See also:
   *
   *    acos, acot, acsc
   *
   * @param {number | Complex | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} The arc secant of x
   */ var asec = typed($ce6f932303352d99$var$name, {
        number: function number(x) {
            if (x <= -1 || x >= 1 || config.predictable) return (0, $2F5hp.asecNumber)(x);
            return new Complex(x, 0).asec();
        },
        Complex: function Complex(x) {
            return x.asec();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).acos();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, asec);
        }
    });
    return asec;
});

});

parcelRegister("gylhh", function(module, exports) {

$parcel$export(module.exports, "createAsech", function () { return $c0d0539c51ba8c69$export$8eeff5f09afe95bc; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");

var $2F5hp = parcelRequire("2F5hp");
var $c0d0539c51ba8c69$var$name = "asech";
var $c0d0539c51ba8c69$var$dependencies = [
    "typed",
    "config",
    "Complex",
    "BigNumber"
];
var $c0d0539c51ba8c69$export$8eeff5f09afe95bc = /* #__PURE__ */ (0, $2mPYl.factory)($c0d0539c51ba8c69$var$name, $c0d0539c51ba8c69$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, Complex = _ref.Complex, _BigNumber = _ref.BigNumber;
    /**
   * Calculate the hyperbolic arcsecant of a value,
   * defined as `asech(x) = acosh(1/x) = ln(sqrt(1/x^2 - 1) + 1/x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.asech(x)
   *
   * Examples:
   *
   *    math.asech(0.5)       // returns 1.3169578969248166
   *
   * See also:
   *
   *    acsch, acoth
   *
   * @param {number | Complex | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic arcsecant of x
   */ var asech = typed($c0d0539c51ba8c69$var$name, {
        number: function number(x) {
            if (x <= 1 && x >= -1 || config.predictable) {
                var xInv = 1 / x;
                if (xInv > 0 || config.predictable) return (0, $2F5hp.asechNumber)(x);
                var ret = Math.sqrt(xInv * xInv - 1);
                return new Complex(Math.log(ret - xInv), Math.PI);
            }
            return new Complex(x, 0).asech();
        },
        Complex: function Complex(x) {
            return x.asech();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).acosh();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, asech);
        }
    });
    return asech;
});

});

parcelRegister("bWXDL", function(module, exports) {

$parcel$export(module.exports, "createAsin", function () { return $8b335fd6190a20ec$export$5f05d91ddc56bc14; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");
var $8b335fd6190a20ec$var$name = "asin";
var $8b335fd6190a20ec$var$dependencies = [
    "typed",
    "config",
    "Complex"
];
var $8b335fd6190a20ec$export$5f05d91ddc56bc14 = /* #__PURE__ */ (0, $2mPYl.factory)($8b335fd6190a20ec$var$name, $8b335fd6190a20ec$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, Complex = _ref.Complex;
    /**
   * Calculate the inverse sine of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.asin(x)
   *
   * Examples:
   *
   *    math.asin(0.5)           // returns number 0.5235987755982989
   *    math.asin(math.sin(1.5)) // returns number ~1.5
   *
   *    math.asin(2)             // returns Complex 1.5707963267948966 -1.3169578969248166 i
   *
   * See also:
   *
   *    sin, atan, acos
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x   Function input
   * @return {number | BigNumber | Complex | Array | Matrix} The arc sine of x
   */ var asin = typed($8b335fd6190a20ec$var$name, {
        number: function number(x) {
            if (x >= -1 && x <= 1 || config.predictable) return Math.asin(x);
            else return new Complex(x, 0).asin();
        },
        Complex: function Complex(x) {
            return x.asin();
        },
        BigNumber: function BigNumber(x) {
            return x.asin();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since asin(0) = 0
            return (0, $e04i1.deepMap)(x, asin, true);
        }
    });
    return asin;
});

});

parcelRegister("c5mOF", function(module, exports) {

$parcel$export(module.exports, "createAsinh", function () { return $024548e0e76ab63f$export$7278bb4e3c84d46a; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");

var $2F5hp = parcelRequire("2F5hp");
var $024548e0e76ab63f$var$name = "asinh";
var $024548e0e76ab63f$var$dependencies = [
    "typed"
];
var $024548e0e76ab63f$export$7278bb4e3c84d46a = /* #__PURE__ */ (0, $2mPYl.factory)($024548e0e76ab63f$var$name, $024548e0e76ab63f$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Calculate the hyperbolic arcsine of a value,
   * defined as `asinh(x) = ln(x + sqrt(x^2 + 1))`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.asinh(x)
   *
   * Examples:
   *
   *    math.asinh(0.5)       // returns 0.48121182505960347
   *
   * See also:
   *
   *    acosh, atanh
   *
   * @param {number | Complex | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic arcsine of x
   */ var asinh = typed("asinh", {
        number: (0, $2F5hp.asinhNumber),
        Complex: function Complex(x) {
            return x.asinh();
        },
        BigNumber: function BigNumber(x) {
            return x.asinh();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since asinh(0) = 0
            return (0, $e04i1.deepMap)(x, asinh, true);
        }
    });
    return asinh;
});

});

parcelRegister("2ORcQ", function(module, exports) {

$parcel$export(module.exports, "createAtan", function () { return $20d985ea9edb5099$export$b87f3a3301a24256; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");
var $20d985ea9edb5099$var$name = "atan";
var $20d985ea9edb5099$var$dependencies = [
    "typed"
];
var $20d985ea9edb5099$export$b87f3a3301a24256 = /* #__PURE__ */ (0, $2mPYl.factory)($20d985ea9edb5099$var$name, $20d985ea9edb5099$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Calculate the inverse tangent of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.atan(x)
   *
   * Examples:
   *
   *    math.atan(0.5)           // returns number 0.4636476090008061
   *    math.atan(math.tan(1.5)) // returns number 1.5
   *
   *    math.atan(2)             // returns Complex 1.5707963267948966 -1.3169578969248166 i
   *
   * See also:
   *
   *    tan, asin, acos
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x   Function input
   * @return {number | BigNumber | Complex | Array | Matrix} The arc tangent of x
   */ var atan = typed("atan", {
        number: function number(x) {
            return Math.atan(x);
        },
        Complex: function Complex(x) {
            return x.atan();
        },
        BigNumber: function BigNumber(x) {
            return x.atan();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since atan(0) = 0
            return (0, $e04i1.deepMap)(x, atan, true);
        }
    });
    return atan;
});

});

parcelRegister("hrHyk", function(module, exports) {

$parcel$export(module.exports, "createAtan2", function () { return $cb36bdf2f88b36c6$export$c56716e11a38354e; });

var $2mPYl = parcelRequire("2mPYl");

var $cITNv = parcelRequire("cITNv");

var $jaKH8 = parcelRequire("jaKH8");

var $lF8tr = parcelRequire("lF8tr");

var $cZfrH = parcelRequire("cZfrH");

var $dNuvz = parcelRequire("dNuvz");

var $1bBLS = parcelRequire("1bBLS");

var $iHnaT = parcelRequire("iHnaT");
var $cb36bdf2f88b36c6$var$name = "atan2";
var $cb36bdf2f88b36c6$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "BigNumber",
    "DenseMatrix"
];
var $cb36bdf2f88b36c6$export$c56716e11a38354e = /* #__PURE__ */ (0, $2mPYl.factory)($cb36bdf2f88b36c6$var$name, $cb36bdf2f88b36c6$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, equalScalar = _ref.equalScalar, BigNumber = _ref.BigNumber, DenseMatrix = _ref.DenseMatrix;
    var algorithm02 = (0, $cITNv.createAlgorithm02)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm03 = (0, $jaKH8.createAlgorithm03)({
        typed: typed
    });
    var algorithm09 = (0, $lF8tr.createAlgorithm09)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm11 = (0, $cZfrH.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm12 = (0, $dNuvz.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $1bBLS.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $iHnaT.createAlgorithm14)({
        typed: typed
    });
    /**
   * Calculate the inverse tangent function with two arguments, y/x.
   * By providing two arguments, the right quadrant of the computed angle can be
   * determined.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.atan2(y, x)
   *
   * Examples:
   *
   *    math.atan2(2, 2) / math.pi       // returns number 0.25
   *
   *    const angle = math.unit(60, 'deg') // returns Unit 60 deg
   *    const x = math.cos(angle)
   *    const y = math.sin(angle)
   *
   *    math.atan(2)             // returns Complex 1.5707963267948966 -1.3169578969248166 i
   *
   * See also:
   *
   *    tan, atan, sin, cos
   *
   * @param {number | Array | Matrix} y  Second dimension
   * @param {number | Array | Matrix} x  First dimension
   * @return {number | Array | Matrix} Four-quadrant inverse tangent
   */ var atan2 = typed($cb36bdf2f88b36c6$var$name, {
        "number, number": Math.atan2,
        // Complex numbers doesn't seem to have a reasonable implementation of
        // atan2(). Even Matlab removed the support, after they only calculated
        // the atan only on base of the real part of the numbers and ignored the imaginary.
        "BigNumber, BigNumber": function BigNumberBigNumber(y, x) {
            return BigNumber.atan2(y, x);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm09(x, y, atan2, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            // mind the order of y and x!
            return algorithm02(y, x, atan2, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, atan2, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, atan2);
        },
        "Array, Array": function ArrayArray(x, y) {
            return atan2(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            return atan2(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            return atan2(x, matrix(y));
        },
        "SparseMatrix, number | BigNumber": function SparseMatrixNumberBigNumber(x, y) {
            return algorithm11(x, y, atan2, false);
        },
        "DenseMatrix, number | BigNumber": function DenseMatrixNumberBigNumber(x, y) {
            return algorithm14(x, y, atan2, false);
        },
        "number | BigNumber, SparseMatrix": function numberBigNumberSparseMatrix(x, y) {
            // mind the order of y and x
            return algorithm12(y, x, atan2, true);
        },
        "number | BigNumber, DenseMatrix": function numberBigNumberDenseMatrix(x, y) {
            // mind the order of y and x
            return algorithm14(y, x, atan2, true);
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(x, y) {
            return algorithm14(matrix(x), y, atan2, false).valueOf();
        },
        "number | BigNumber, Array": function numberBigNumberArray(x, y) {
            return algorithm14(matrix(y), x, atan2, true).valueOf();
        }
    });
    return atan2;
});

});
parcelRegister("jaKH8", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm03", function () { return $df532c1774ab44ee$export$486bb900f1a3c833; });

var $2mPYl = parcelRequire("2mPYl");

var $hy7Bx = parcelRequire("hy7Bx");
var $df532c1774ab44ee$var$name = "algorithm03";
var $df532c1774ab44ee$var$dependencies = [
    "typed"
];
var $df532c1774ab44ee$export$486bb900f1a3c833 = /* #__PURE__ */ (0, $2mPYl.factory)($df532c1774ab44ee$var$name, $df532c1774ab44ee$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Iterates over SparseMatrix items and invokes the callback function f(Dij, Sij).
   * Callback function invoked M*N times.
   *
   *
   *          ┌  f(Dij, Sij)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  f(Dij, 0)    ; otherwise
   *
   *
   * @param {Matrix}   denseMatrix       The DenseMatrix instance (D)
   * @param {Matrix}   sparseMatrix      The SparseMatrix instance (C)
   * @param {Function} callback          The f(Dij,Sij) operation to invoke, where Dij = DenseMatrix(i,j) and Sij = SparseMatrix(i,j)
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(Sij,Dij)
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97477571
   */ return function algorithm03(denseMatrix, sparseMatrix, callback, inverse) {
        // dense matrix arrays
        var adata = denseMatrix._data;
        var asize = denseMatrix._size;
        var adt = denseMatrix._datatype; // sparse matrix arrays
        var bvalues = sparseMatrix._values;
        var bindex = sparseMatrix._index;
        var bptr = sparseMatrix._ptr;
        var bsize = sparseMatrix._size;
        var bdt = sparseMatrix._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $hy7Bx.DimensionError)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
         // sparse matrix cannot be a Pattern matrix
        if (!bvalues) throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string" && adt === bdt) {
            // datatype
            dt = adt; // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result (DenseMatrix)
        var cdata = []; // initialize dense matrix
        for(var z = 0; z < rows; z++)// initialize row
        cdata[z] = [];
         // workspace
        var x = []; // marks indicating we have a value in x for a given column
        var w = []; // loop columns in b
        for(var j = 0; j < columns; j++){
            // column mark
            var mark = j + 1; // values in column j
            for(var k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                var i = bindex[k]; // update workspace
                x[i] = inverse ? cf(bvalues[k], adata[i][j]) : cf(adata[i][j], bvalues[k]);
                w[i] = mark;
            } // process workspace
            for(var y = 0; y < rows; y++)// check we have a calculated value for current row
            if (w[y] === mark) // use calculated value
            cdata[y][j] = x[y];
            else // calculate value
            cdata[y][j] = inverse ? cf(zero, adata[y][j]) : cf(adata[y][j], zero);
        } // return dense matrix
        return denseMatrix.createDenseMatrix({
            data: cdata,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});

});

parcelRegister("lF8tr", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm09", function () { return $fc540007ef3a6803$export$c769437575b0fcdd; });

var $2mPYl = parcelRequire("2mPYl");

var $hy7Bx = parcelRequire("hy7Bx");
var $fc540007ef3a6803$var$name = "algorithm09";
var $fc540007ef3a6803$var$dependencies = [
    "typed",
    "equalScalar"
];
var $fc540007ef3a6803$export$c769437575b0fcdd = /* #__PURE__ */ (0, $2mPYl.factory)($fc540007ef3a6803$var$name, $fc540007ef3a6803$var$dependencies, function(_ref) {
    var typed = _ref.typed, equalScalar = _ref.equalScalar;
    /**
   * Iterates over SparseMatrix A and invokes the callback function f(Aij, Bij).
   * Callback function invoked NZA times, number of nonzero elements in A.
   *
   *
   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0
   * C(i,j) = ┤
   *          └  0            ; otherwise
   *
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function algorithm09(a, b, callback) {
        // sparse matrix arrays
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var asize = a._size;
        var adt = a._datatype; // sparse matrix arrays
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bsize = b._size;
        var bdt = b._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $hy7Bx.DimensionError)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string" && adt === bdt) {
            // datatype
            dt = adt; // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cvalues = avalues && bvalues ? [] : undefined;
        var cindex = [];
        var cptr = []; // workspaces
        var x = cvalues ? [] : undefined; // marks indicating we have a value in x for a given column
        var w = []; // vars
        var i, j, k, k0, k1; // loop columns
        for(j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length; // column mark
            var mark = j + 1; // check we need to process values
            if (x) // loop B(:,j)
            for(k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                i = bindex[k]; // update workspace
                w[i] = mark;
                x[i] = bvalues[k];
            }
             // loop A(:,j)
            for(k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                i = aindex[k]; // check we need to process values
                if (x) {
                    // b value @ i,j
                    var vb = w[i] === mark ? x[i] : zero; // invoke f
                    var vc = cf(avalues[k], vb); // check zero value
                    if (!eq(vc, zero)) {
                        // push index
                        cindex.push(i); // push value
                        cvalues.push(vc);
                    }
                } else // push index
                cindex.push(i);
            }
        } // update cptr
        cptr[columns] = cindex.length; // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});

});

parcelRegister("dNuvz", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm12", function () { return $a0b7843e26d43824$export$806772cd23b603dc; });

var $2mPYl = parcelRequire("2mPYl");
var $a0b7843e26d43824$var$name = "algorithm12";
var $a0b7843e26d43824$var$dependencies = [
    "typed",
    "DenseMatrix"
];
var $a0b7843e26d43824$export$806772cd23b603dc = /* #__PURE__ */ (0, $2mPYl.factory)($a0b7843e26d43824$var$name, $a0b7843e26d43824$var$dependencies, function(_ref) {
    var typed = _ref.typed, DenseMatrix = _ref.DenseMatrix;
    /**
   * Iterates over SparseMatrix S nonzero items and invokes the callback function f(Sij, b).
   * Callback function invoked MxN times.
   *
   *
   *          ┌  f(Sij, b)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  f(0, b)    ; otherwise
   *
   *
   * @param {Matrix}   s                 The SparseMatrix instance (S)
   * @param {Scalar}   b                 The Scalar value
   * @param {Function} callback          The f(Aij,b) operation to invoke
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Sij)
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97626813
   */ return function algorithm12(s, b, callback, inverse) {
        // sparse matrix arrays
        var avalues = s._values;
        var aindex = s._index;
        var aptr = s._ptr;
        var asize = s._size;
        var adt = s._datatype; // sparse matrix cannot be a Pattern matrix
        if (!avalues) throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string") {
            // datatype
            dt = adt; // convert b to the same datatype
            b = typed.convert(b, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cdata = []; // workspaces
        var x = []; // marks indicating we have a value in x for a given column
        var w = []; // loop columns
        for(var j = 0; j < columns; j++){
            // columns mark
            var mark = j + 1; // values in j
            for(var k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                var r = aindex[k]; // update workspace
                x[r] = avalues[k];
                w[r] = mark;
            } // loop rows
            for(var i = 0; i < rows; i++){
                // initialize C on first column
                if (j === 0) // create row array
                cdata[i] = [];
                 // check sparse matrix has a value @ i,j
                if (w[i] === mark) // invoke callback, update C
                cdata[i][j] = inverse ? cf(b, x[i]) : cf(x[i], b);
                else // dense matrix value @ i, j
                cdata[i][j] = inverse ? cf(b, 0) : cf(0, b);
            }
        } // return dense matrix
        return new DenseMatrix({
            data: cdata,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});

});


parcelRegister("bcMLK", function(module, exports) {

$parcel$export(module.exports, "createAtanh", function () { return $8286a53f853c612f$export$c2dbbeab1e5e6195; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");

var $2F5hp = parcelRequire("2F5hp");
var $8286a53f853c612f$var$name = "atanh";
var $8286a53f853c612f$var$dependencies = [
    "typed",
    "config",
    "Complex"
];
var $8286a53f853c612f$export$c2dbbeab1e5e6195 = /* #__PURE__ */ (0, $2mPYl.factory)($8286a53f853c612f$var$name, $8286a53f853c612f$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, Complex = _ref.Complex;
    /**
   * Calculate the hyperbolic arctangent of a value,
   * defined as `atanh(x) = ln((1 + x)/(1 - x)) / 2`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.atanh(x)
   *
   * Examples:
   *
   *    math.atanh(0.5)       // returns 0.5493061443340549
   *
   * See also:
   *
   *    acosh, asinh
   *
   * @param {number | Complex | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic arctangent of x
   */ var atanh = typed($8286a53f853c612f$var$name, {
        number: function number(x) {
            if (x <= 1 && x >= -1 || config.predictable) return (0, $2F5hp.atanhNumber)(x);
            return new Complex(x, 0).atanh();
        },
        Complex: function Complex(x) {
            return x.atanh();
        },
        BigNumber: function BigNumber(x) {
            return x.atanh();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since atanh(0) = 0
            return (0, $e04i1.deepMap)(x, atanh, true);
        }
    });
    return atanh;
});

});

parcelRegister("ktwBg", function(module, exports) {

$parcel$export(module.exports, "createSpeedOfLight", function () { return $ee7fcdc73448b6d0$export$ace78258608300fc; });
$parcel$export(module.exports, "createGravitationConstant", function () { return $ee7fcdc73448b6d0$export$157e78cb05354391; });
$parcel$export(module.exports, "createPlanckConstant", function () { return $ee7fcdc73448b6d0$export$e58ff8150d83ea6a; });
$parcel$export(module.exports, "createReducedPlanckConstant", function () { return $ee7fcdc73448b6d0$export$50bee65ab76b402; });
$parcel$export(module.exports, "createMagneticConstant", function () { return $ee7fcdc73448b6d0$export$e7fcb8898ecb0703; });
$parcel$export(module.exports, "createElectricConstant", function () { return $ee7fcdc73448b6d0$export$d69030cf93f04407; });
$parcel$export(module.exports, "createVacuumImpedance", function () { return $ee7fcdc73448b6d0$export$c9ff08d282f03cf0; });
$parcel$export(module.exports, "createCoulomb", function () { return $ee7fcdc73448b6d0$export$815f2029cd62d0d6; });
$parcel$export(module.exports, "createElementaryCharge", function () { return $ee7fcdc73448b6d0$export$542715ad7e3a9798; });
$parcel$export(module.exports, "createBohrMagneton", function () { return $ee7fcdc73448b6d0$export$f5851397fd1173db; });
$parcel$export(module.exports, "createConductanceQuantum", function () { return $ee7fcdc73448b6d0$export$e26bbd27fc291ddf; });
$parcel$export(module.exports, "createInverseConductanceQuantum", function () { return $ee7fcdc73448b6d0$export$f2f136373157165b; });
$parcel$export(module.exports, "createMagneticFluxQuantum", function () { return $ee7fcdc73448b6d0$export$fd46b6c8680e4d01; });
$parcel$export(module.exports, "createNuclearMagneton", function () { return $ee7fcdc73448b6d0$export$9670d94122b9a81b; });
$parcel$export(module.exports, "createKlitzing", function () { return $ee7fcdc73448b6d0$export$e3f21ac13bee6a0f; });
$parcel$export(module.exports, "createBohrRadius", function () { return $ee7fcdc73448b6d0$export$19b72356ad84e4ee; });
$parcel$export(module.exports, "createClassicalElectronRadius", function () { return $ee7fcdc73448b6d0$export$68a9771dccce9a23; });
$parcel$export(module.exports, "createElectronMass", function () { return $ee7fcdc73448b6d0$export$85362d2a7862e209; });
$parcel$export(module.exports, "createFermiCoupling", function () { return $ee7fcdc73448b6d0$export$b6687a2f3911256b; });
$parcel$export(module.exports, "createFineStructure", function () { return $ee7fcdc73448b6d0$export$aaddb59a993d3ac4; });
$parcel$export(module.exports, "createHartreeEnergy", function () { return $ee7fcdc73448b6d0$export$8bb818baeaa40bd6; });
$parcel$export(module.exports, "createProtonMass", function () { return $ee7fcdc73448b6d0$export$f357c1a8d4fccef6; });
$parcel$export(module.exports, "createDeuteronMass", function () { return $ee7fcdc73448b6d0$export$a403f6c5bed71f22; });
$parcel$export(module.exports, "createNeutronMass", function () { return $ee7fcdc73448b6d0$export$676d5ebe8fbeb250; });
$parcel$export(module.exports, "createQuantumOfCirculation", function () { return $ee7fcdc73448b6d0$export$6840f334b8a5b6b1; });
$parcel$export(module.exports, "createRydberg", function () { return $ee7fcdc73448b6d0$export$fd1b48ecb0d5c0ef; });
$parcel$export(module.exports, "createThomsonCrossSection", function () { return $ee7fcdc73448b6d0$export$229739a879741f68; });
$parcel$export(module.exports, "createWeakMixingAngle", function () { return $ee7fcdc73448b6d0$export$fa2d42c5c25c1883; });
$parcel$export(module.exports, "createEfimovFactor", function () { return $ee7fcdc73448b6d0$export$55fc8769b037d266; });
$parcel$export(module.exports, "createAtomicMass", function () { return $ee7fcdc73448b6d0$export$2f8d2da219209d0a; });
$parcel$export(module.exports, "createAvogadro", function () { return $ee7fcdc73448b6d0$export$4924e3d8de6ad850; });
$parcel$export(module.exports, "createBoltzmann", function () { return $ee7fcdc73448b6d0$export$221b7a8c9510b6cc; });
$parcel$export(module.exports, "createFaraday", function () { return $ee7fcdc73448b6d0$export$17ef8d738c9b0091; });
$parcel$export(module.exports, "createFirstRadiation", function () { return $ee7fcdc73448b6d0$export$266a9bae8a62fb6e; });
$parcel$export(module.exports, "createLoschmidt", function () { return $ee7fcdc73448b6d0$export$c38bce537e0ffddb; });
$parcel$export(module.exports, "createGasConstant", function () { return $ee7fcdc73448b6d0$export$85a77a0842c24f74; });
$parcel$export(module.exports, "createMolarPlanckConstant", function () { return $ee7fcdc73448b6d0$export$12e2358797b853c9; });
$parcel$export(module.exports, "createMolarVolume", function () { return $ee7fcdc73448b6d0$export$f5e8f56ebfacbaca; });
$parcel$export(module.exports, "createSackurTetrode", function () { return $ee7fcdc73448b6d0$export$467c65d9dfc3d3a2; });
$parcel$export(module.exports, "createSecondRadiation", function () { return $ee7fcdc73448b6d0$export$ea93a35a6f35e1b6; });
$parcel$export(module.exports, "createStefanBoltzmann", function () { return $ee7fcdc73448b6d0$export$a943525a62f69cd2; });
$parcel$export(module.exports, "createWienDisplacement", function () { return $ee7fcdc73448b6d0$export$3c74568e9574d168; });
$parcel$export(module.exports, "createMolarMass", function () { return $ee7fcdc73448b6d0$export$85414d775c93e6de; });
$parcel$export(module.exports, "createMolarMassC12", function () { return $ee7fcdc73448b6d0$export$d5045cf71611a462; });
$parcel$export(module.exports, "createGravity", function () { return $ee7fcdc73448b6d0$export$42b5845f95e0feee; });
$parcel$export(module.exports, "createPlanckLength", function () { return $ee7fcdc73448b6d0$export$675ebbcd6bdcebd7; });
$parcel$export(module.exports, "createPlanckMass", function () { return $ee7fcdc73448b6d0$export$d44b96c94520b20e; });
$parcel$export(module.exports, "createPlanckTime", function () { return $ee7fcdc73448b6d0$export$3bf63d7b96fd8541; });
$parcel$export(module.exports, "createPlanckCharge", function () { return $ee7fcdc73448b6d0$export$43e139a6eec1ab59; });
$parcel$export(module.exports, "createPlanckTemperature", function () { return $ee7fcdc73448b6d0$export$d21f20fc89fac8c0; });

var $2mPYl = parcelRequire("2mPYl");
var $ee7fcdc73448b6d0$export$ace78258608300fc = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("speedOfLight", "299792458", "m s^-1");
var $ee7fcdc73448b6d0$export$157e78cb05354391 = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("gravitationConstant", "6.67430e-11", "m^3 kg^-1 s^-2");
var $ee7fcdc73448b6d0$export$e58ff8150d83ea6a = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("planckConstant", "6.62607015e-34", "J s");
var $ee7fcdc73448b6d0$export$50bee65ab76b402 = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("reducedPlanckConstant", "1.0545718176461565e-34", "J s"); // Electromagnetic constants
var $ee7fcdc73448b6d0$export$e7fcb8898ecb0703 = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("magneticConstant", "1.25663706212e-6", "N A^-2");
var $ee7fcdc73448b6d0$export$d69030cf93f04407 = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("electricConstant", "8.8541878128e-12", "F m^-1");
var $ee7fcdc73448b6d0$export$c9ff08d282f03cf0 = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("vacuumImpedance", "376.730313667", "ohm");
var $ee7fcdc73448b6d0$export$815f2029cd62d0d6 = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("coulomb", "8.987551792261171e9", "N m^2 C^-2");
var $ee7fcdc73448b6d0$export$542715ad7e3a9798 = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("elementaryCharge", "1.602176634e-19", "C");
var $ee7fcdc73448b6d0$export$f5851397fd1173db = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("bohrMagneton", "9.2740100783e-24", "J T^-1");
var $ee7fcdc73448b6d0$export$e26bbd27fc291ddf = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("conductanceQuantum", "7.748091729863649e-5", "S");
var $ee7fcdc73448b6d0$export$f2f136373157165b = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("inverseConductanceQuantum", "12906.403729652257", "ohm");
var $ee7fcdc73448b6d0$export$fd46b6c8680e4d01 = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("magneticFluxQuantum", "2.0678338484619295e-15", "Wb");
var $ee7fcdc73448b6d0$export$9670d94122b9a81b = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("nuclearMagneton", "5.0507837461e-27", "J T^-1");
var $ee7fcdc73448b6d0$export$e3f21ac13bee6a0f = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("klitzing", "25812.807459304513", "ohm");
var $ee7fcdc73448b6d0$export$c090909964c68de4 = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("josephson", "4.835978484169836e14 Hz V", "Hz V^-1"); // TODO: support for Hz needed
var $ee7fcdc73448b6d0$export$19b72356ad84e4ee = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("bohrRadius", "5.29177210903e-11", "m");
var $ee7fcdc73448b6d0$export$68a9771dccce9a23 = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("classicalElectronRadius", "2.8179403262e-15", "m");
var $ee7fcdc73448b6d0$export$85362d2a7862e209 = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("electronMass", "9.1093837015e-31", "kg");
var $ee7fcdc73448b6d0$export$b6687a2f3911256b = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("fermiCoupling", "1.1663787e-5", "GeV^-2");
var $ee7fcdc73448b6d0$export$aaddb59a993d3ac4 = $ee7fcdc73448b6d0$var$numberFactory("fineStructure", 7.2973525693e-3);
var $ee7fcdc73448b6d0$export$8bb818baeaa40bd6 = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("hartreeEnergy", "4.3597447222071e-18", "J");
var $ee7fcdc73448b6d0$export$f357c1a8d4fccef6 = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("protonMass", "1.67262192369e-27", "kg");
var $ee7fcdc73448b6d0$export$a403f6c5bed71f22 = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("deuteronMass", "3.3435830926e-27", "kg");
var $ee7fcdc73448b6d0$export$676d5ebe8fbeb250 = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("neutronMass", "1.6749271613e-27", "kg");
var $ee7fcdc73448b6d0$export$6840f334b8a5b6b1 = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("quantumOfCirculation", "3.6369475516e-4", "m^2 s^-1");
var $ee7fcdc73448b6d0$export$fd1b48ecb0d5c0ef = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("rydberg", "10973731.568160", "m^-1");
var $ee7fcdc73448b6d0$export$229739a879741f68 = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("thomsonCrossSection", "6.6524587321e-29", "m^2");
var $ee7fcdc73448b6d0$export$fa2d42c5c25c1883 = $ee7fcdc73448b6d0$var$numberFactory("weakMixingAngle", 0.22290);
var $ee7fcdc73448b6d0$export$55fc8769b037d266 = $ee7fcdc73448b6d0$var$numberFactory("efimovFactor", 22.7); // Physico-chemical constants
var $ee7fcdc73448b6d0$export$2f8d2da219209d0a = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("atomicMass", "1.66053906660e-27", "kg");
var $ee7fcdc73448b6d0$export$4924e3d8de6ad850 = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("avogadro", "6.02214076e23", "mol^-1");
var $ee7fcdc73448b6d0$export$221b7a8c9510b6cc = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("boltzmann", "1.380649e-23", "J K^-1");
var $ee7fcdc73448b6d0$export$17ef8d738c9b0091 = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("faraday", "96485.33212331001", "C mol^-1");
var $ee7fcdc73448b6d0$export$266a9bae8a62fb6e = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("firstRadiation", "3.7417718521927573e-16", "W m^2"); // export const createSpectralRadiance = /* #__PURE__ */ unitFactory('spectralRadiance', '1.1910429723971881e-16', 'W m^2 sr^-1') // TODO spectralRadiance
var $ee7fcdc73448b6d0$export$c38bce537e0ffddb = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("loschmidt", "2.686780111798444e25", "m^-3");
var $ee7fcdc73448b6d0$export$85a77a0842c24f74 = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("gasConstant", "8.31446261815324", "J K^-1 mol^-1");
var $ee7fcdc73448b6d0$export$12e2358797b853c9 = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("molarPlanckConstant", "3.990312712893431e-10", "J s mol^-1");
var $ee7fcdc73448b6d0$export$f5e8f56ebfacbaca = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("molarVolume", "0.022413969545014137", "m^3 mol^-1");
var $ee7fcdc73448b6d0$export$467c65d9dfc3d3a2 = $ee7fcdc73448b6d0$var$numberFactory("sackurTetrode", -1.16487052358);
var $ee7fcdc73448b6d0$export$ea93a35a6f35e1b6 = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("secondRadiation", "0.014387768775039337", "m K");
var $ee7fcdc73448b6d0$export$a943525a62f69cd2 = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("stefanBoltzmann", "5.67037441918443e-8", "W m^-2 K^-4");
var $ee7fcdc73448b6d0$export$3c74568e9574d168 = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("wienDisplacement", "2.897771955e-3", "m K"); // Adopted values
var $ee7fcdc73448b6d0$export$85414d775c93e6de = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("molarMass", "0.99999999965e-3", "kg mol^-1");
var $ee7fcdc73448b6d0$export$d5045cf71611a462 = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("molarMassC12", "11.9999999958e-3", "kg mol^-1");
var $ee7fcdc73448b6d0$export$42b5845f95e0feee = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("gravity", "9.80665", "m s^-2"); // atm is defined in Unit.js
var $ee7fcdc73448b6d0$export$675ebbcd6bdcebd7 = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("planckLength", "1.616255e-35", "m");
var $ee7fcdc73448b6d0$export$d44b96c94520b20e = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("planckMass", "2.176435e-8", "kg");
var $ee7fcdc73448b6d0$export$3bf63d7b96fd8541 = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("planckTime", "5.391245e-44", "s");
var $ee7fcdc73448b6d0$export$43e139a6eec1ab59 = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("planckCharge", "1.87554603778e-18", "C");
var $ee7fcdc73448b6d0$export$d21f20fc89fac8c0 = /* #__PURE__ */ $ee7fcdc73448b6d0$var$unitFactory("planckTemperature", "1.416785e+32", "K"); // helper function to create a factory function which creates a physical constant,
// a Unit with either a number value or a BigNumber value depending on the configuration
function $ee7fcdc73448b6d0$var$unitFactory(name, valueStr, unitStr) {
    var dependencies = [
        "config",
        "Unit",
        "BigNumber"
    ];
    return (0, $2mPYl.factory)(name, dependencies, function(_ref) {
        var config = _ref.config, Unit = _ref.Unit, BigNumber = _ref.BigNumber;
        // Note that we can parse into number or BigNumber.
        // We do not parse into Fractions as that doesn't make sense: we would lose precision of the values
        // Therefore we dont use Unit.parse()
        var value = config.number === "BigNumber" ? new BigNumber(valueStr) : parseFloat(valueStr);
        var unit = new Unit(value, unitStr);
        unit.fixPrefix = true;
        return unit;
    });
} // helper function to create a factory function which creates a numeric constant,
// either a number or BigNumber depending on the configuration
function $ee7fcdc73448b6d0$var$numberFactory(name, value) {
    var dependencies = [
        "config",
        "BigNumber"
    ];
    return (0, $2mPYl.factory)(name, dependencies, function(_ref2) {
        var config = _ref2.config, BigNumber = _ref2.BigNumber;
        return config.number === "BigNumber" ? new BigNumber(value) : value;
    });
}

});

parcelRegister("dVSwh", function(module, exports) {

$parcel$export(module.exports, "createBellNumbers", function () { return $a24ae3ae2ba576e8$export$7b7dc3bd00d38afb; });

var $2mPYl = parcelRequire("2mPYl");
var $a24ae3ae2ba576e8$var$name = "bellNumbers";
var $a24ae3ae2ba576e8$var$dependencies = [
    "typed",
    "addScalar",
    "isNegative",
    "isInteger",
    "stirlingS2"
];
var $a24ae3ae2ba576e8$export$7b7dc3bd00d38afb = /* #__PURE__ */ (0, $2mPYl.factory)($a24ae3ae2ba576e8$var$name, $a24ae3ae2ba576e8$var$dependencies, function(_ref) {
    var typed = _ref.typed, addScalar = _ref.addScalar, isNegative = _ref.isNegative, isInteger = _ref.isInteger, stirlingS2 = _ref.stirlingS2;
    /**
   * The Bell Numbers count the number of partitions of a set. A partition is a pairwise disjoint subset of S whose union is S.
   * bellNumbers only takes integer arguments.
   * The following condition must be enforced: n >= 0
   *
   * Syntax:
   *
   *   math.bellNumbers(n)
   *
   * Examples:
   *
   *    math.bellNumbers(3) // returns 5
   *    math.bellNumbers(8) // returns 4140
   *
   * See also:
   *
   *    stirlingS2
   *
   * @param {Number | BigNumber} n    Total number of objects in the set
   * @return {Number | BigNumber}     B(n)
   */ return typed($a24ae3ae2ba576e8$var$name, {
        "number | BigNumber": function numberBigNumber(n) {
            if (!isInteger(n) || isNegative(n)) throw new TypeError("Non-negative integer value expected in function bellNumbers");
             // Sum (k=0, n) S(n,k).
            var result = 0;
            for(var i = 0; i <= n; i++)result = addScalar(result, stirlingS2(n, i));
            return result;
        }
    });
});

});

parcelRegister("cTd4r", function(module, exports) {

$parcel$export(module.exports, "createBignumber", function () { return $9624c2aaafb5b887$export$1c955ee1b8a97877; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");
var $9624c2aaafb5b887$var$name = "bignumber";
var $9624c2aaafb5b887$var$dependencies = [
    "typed",
    "BigNumber"
];
var $9624c2aaafb5b887$export$1c955ee1b8a97877 = /* #__PURE__ */ (0, $2mPYl.factory)($9624c2aaafb5b887$var$name, $9624c2aaafb5b887$var$dependencies, function(_ref) {
    var typed = _ref.typed, BigNumber = _ref.BigNumber;
    /**
   * Create a BigNumber, which can store numbers with arbitrary precision.
   * When a matrix is provided, all elements will be converted to BigNumber.
   *
   * Syntax:
   *
   *    math.bignumber(x)
   *
   * Examples:
   *
   *    0.1 + 0.2                                  // returns number 0.30000000000000004
   *    math.bignumber(0.1) + math.bignumber(0.2)  // returns BigNumber 0.3
   *
   *
   *    7.2e500                                    // returns number Infinity
   *    math.bignumber('7.2e500')                  // returns BigNumber 7.2e500
   *
   * See also:
   *
   *    boolean, complex, index, matrix, string, unit
   *
   * @param {number | string | Fraction | BigNumber | Array | Matrix | boolean | null} [value]  Value for the big number,
   *                                                    0 by default.
   * @returns {BigNumber} The created bignumber
   */ var bignumber = typed("bignumber", {
        "": function _() {
            return new BigNumber(0);
        },
        number: function number(x) {
            // convert to string to prevent errors in case of >15 digits
            return new BigNumber(x + "");
        },
        string: function string(x) {
            return new BigNumber(x);
        },
        BigNumber: function BigNumber(x) {
            // we assume a BigNumber is immutable
            return x;
        },
        Fraction: function Fraction(x) {
            return new BigNumber(x.n).div(x.d).times(x.s);
        },
        "null": function _null(x) {
            return new BigNumber(0);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, bignumber);
        }
    });
    return bignumber;
});

});

parcelRegister("8tyDe", function(module, exports) {

$parcel$export(module.exports, "createBigNumberClass", function () { return $62bbe553b59b6b50$export$234de8d4231bfea3; });

var $3qOsS = parcelRequire("3qOsS");

var $2mPYl = parcelRequire("2mPYl");
var $62bbe553b59b6b50$var$name = "BigNumber";
var $62bbe553b59b6b50$var$dependencies = [
    "?on",
    "config"
];
var $62bbe553b59b6b50$export$234de8d4231bfea3 = /* #__PURE__ */ (0, $2mPYl.factory)($62bbe553b59b6b50$var$name, $62bbe553b59b6b50$var$dependencies, function(_ref) {
    var on = _ref.on, config = _ref.config;
    var BigNumber = (0, (/*@__PURE__*/$parcel$interopDefault($3qOsS))).clone({
        precision: config.precision
    });
    /**
   * Attach type information
   */ BigNumber.prototype.type = "BigNumber";
    BigNumber.prototype.isBigNumber = true;
    /**
   * Get a JSON representation of a BigNumber containing
   * type information
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "BigNumber", "value": "0.2"}`
   */ BigNumber.prototype.toJSON = function() {
        return {
            mathjs: "BigNumber",
            value: this.toString()
        };
    };
    /**
   * Instantiate a BigNumber from a JSON object
   * @param {Object} json  a JSON object structured as:
   *                       `{"mathjs": "BigNumber", "value": "0.2"}`
   * @return {BigNumber}
   */ BigNumber.fromJSON = function(json) {
        return new BigNumber(json.value);
    };
    if (on) // listen for changed in the configuration, automatically apply changed precision
    on("config", function(curr, prev) {
        if (curr.precision !== prev.precision) BigNumber.config({
            precision: curr.precision
        });
    });
    return BigNumber;
}, {
    isClass: true
});

});
parcelRegister("3qOsS", function(module, exports) {
(function(globalScope) {
    "use strict";
    /*!
   *  decimal.js v10.4.3
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js
   *  Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The maximum exponent magnitude.
    // The limit on the value of `toExpNeg`, `toExpPos`, `minE` and `maxE`.
    var EXP_LIMIT = 9e15, // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    MAX_DIGITS = 1e9, // Base conversion alphabet.
    NUMERALS = "0123456789abcdef", // The natural logarithm of 10 (1025 digits).
    LN10 = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058", // Pi (1025 digits).
    PI = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789", // The initial configuration properties of the Decimal constructor.
    DEFAULTS = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed at run-time using the `Decimal.config` method.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used when rounding to `precision`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The modulo mode used when calculating the modulus: a mod n.
        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
        // The remainder (r) is calculated as: r = a - n * q.
        //
        // UP         0 The remainder is positive if the dividend is negative, else is negative.
        // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
        // FLOOR      3 The remainder has the same sign as the divisor (Python %).
        // HALF_EVEN  6 The IEEE 754 remainder function.
        // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
        //
        // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
        // division (9) are commonly used for the modulus operation. The other rounding modes can also
        // be used, but they may not give useful results.
        modulo: 1,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The minimum exponent value, beneath which underflow to zero occurs.
        // JavaScript numbers: -324  (5e-324)
        minE: -EXP_LIMIT,
        // The maximum exponent value, above which overflow to Infinity occurs.
        // JavaScript numbers: 308  (1.7976931348623157e+308)
        maxE: EXP_LIMIT,
        // Whether to use cryptographically-secure random number generation, if available.
        crypto: false // true/false
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    Decimal, inexact, noConflict, quadrant, external = true, decimalError = "[DecimalError] ", invalidArgument = decimalError + "Invalid argument: ", precisionLimitExceeded = decimalError + "Precision limit exceeded", cryptoUnavailable = decimalError + "crypto unavailable", tag = "[object Decimal]", mathfloor = Math.floor, mathpow = Math.pow, isBinary = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, isHex = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, isOctal = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, LN10_PRECISION = LN10.length - 1, PI_PRECISION = PI.length - 1, // Decimal.prototype object
    P = {
        toStringTag: tag
    };
    // Decimal prototype methods
    /*
   *  absoluteValue             abs
   *  ceil
   *  clampedTo                 clamp
   *  comparedTo                cmp
   *  cosine                    cos
   *  cubeRoot                  cbrt
   *  decimalPlaces             dp
   *  dividedBy                 div
   *  dividedToIntegerBy        divToInt
   *  equals                    eq
   *  floor
   *  greaterThan               gt
   *  greaterThanOrEqualTo      gte
   *  hyperbolicCosine          cosh
   *  hyperbolicSine            sinh
   *  hyperbolicTangent         tanh
   *  inverseCosine             acos
   *  inverseHyperbolicCosine   acosh
   *  inverseHyperbolicSine     asinh
   *  inverseHyperbolicTangent  atanh
   *  inverseSine               asin
   *  inverseTangent            atan
   *  isFinite
   *  isInteger                 isInt
   *  isNaN
   *  isNegative                isNeg
   *  isPositive                isPos
   *  isZero
   *  lessThan                  lt
   *  lessThanOrEqualTo         lte
   *  logarithm                 log
   *  [maximum]                 [max]
   *  [minimum]                 [min]
   *  minus                     sub
   *  modulo                    mod
   *  naturalExponential        exp
   *  naturalLogarithm          ln
   *  negated                   neg
   *  plus                      add
   *  precision                 sd
   *  round
   *  sine                      sin
   *  squareRoot                sqrt
   *  tangent                   tan
   *  times                     mul
   *  toBinary
   *  toDecimalPlaces           toDP
   *  toExponential
   *  toFixed
   *  toFraction
   *  toHexadecimal             toHex
   *  toNearest
   *  toNumber
   *  toOctal
   *  toPower                   pow
   *  toPrecision
   *  toSignificantDigits       toSD
   *  toString
   *  truncated                 trunc
   *  valueOf                   toJSON
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s < 0) x.s = 1;
        return finalise(x);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number in the
   * direction of positive Infinity.
   *
   */ P.ceil = function() {
        return finalise(new this.constructor(this), this.e + 1, 2);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal clamped to the range
   * delineated by `min` and `max`.
   *
   * min {number|string|Decimal}
   * max {number|string|Decimal}
   *
   */ P.clampedTo = P.clamp = function(min, max) {
        var k, x = this, Ctor = x.constructor;
        min = new Ctor(min);
        max = new Ctor(max);
        if (!min.s || !max.s) return new Ctor(NaN);
        if (min.gt(max)) throw Error(invalidArgument + max);
        k = x.cmp(min);
        return k < 0 ? min : x.cmp(max) > 0 ? max : new Ctor(x);
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value,
   *   NaN  if the value of either Decimal is NaN.
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this, xd = x.d, yd = (y = new x.constructor(y)).d, xs = x.s, ys = y.s;
        // Either NaN or ±Infinity?
        if (!xd || !yd) return !xs || !ys ? NaN : xs !== ys ? xs : xd === yd ? 0 : !xd ^ xs < 0 ? 1 : -1;
        // Either zero?
        if (!xd[0] || !yd[0]) return xd[0] ? xs : yd[0] ? -ys : 0;
        // Signs differ?
        if (xs !== ys) return xs;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ xs < 0 ? 1 : -1;
        xdL = xd.length;
        ydL = yd.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (xd[i] !== yd[i]) return xd[i] > yd[i] ^ xs < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ xs < 0 ? 1 : -1;
    };
    /*
   * Return a new Decimal whose value is the cosine of the value in radians of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-1, 1]
   *
   * cos(0)         = 1
   * cos(-0)        = 1
   * cos(Infinity)  = NaN
   * cos(-Infinity) = NaN
   * cos(NaN)       = NaN
   *
   */ P.cosine = P.cos = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.d) return new Ctor(NaN);
        // cos(0) = cos(-0) = 1
        if (!x.d[0]) return new Ctor(1);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + LOG_BASE;
        Ctor.rounding = 1;
        x = cosine(Ctor, toLessThanHalfPi(Ctor, x));
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(quadrant == 2 || quadrant == 3 ? x.neg() : x, pr, rm, true);
    };
    /*
   *
   * Return a new Decimal whose value is the cube root of the value of this Decimal, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   *  cbrt(0)  =  0
   *  cbrt(-0) = -0
   *  cbrt(1)  =  1
   *  cbrt(-1) = -1
   *  cbrt(N)  =  N
   *  cbrt(-I) = -I
   *  cbrt(I)  =  I
   *
   * Math.cbrt(x) = (x < 0 ? -Math.pow(-x, 1/3) : Math.pow(x, 1/3))
   *
   */ P.cubeRoot = P.cbrt = function() {
        var e, m, n, r, rep, s, sd, t, t3, t3plusx, x = this, Ctor = x.constructor;
        if (!x.isFinite() || x.isZero()) return new Ctor(x);
        external = false;
        // Initial estimate.
        s = x.s * mathpow(x.s * x, 1 / 3);
        // Math.cbrt underflow/overflow?
        // Pass x to Math.pow as integer, then adjust the exponent of the result.
        if (!s || Math.abs(s) == 1 / 0) {
            n = digitsToString(x.d);
            e = x.e;
            // Adjust n exponent so it is a multiple of 3 away from x exponent.
            if (s = (e - n.length + 1) % 3) n += s == 1 || s == -2 ? "0" : "00";
            s = mathpow(n, 1 / 3);
            // Rarely, e may be one less than the result exponent value.
            e = mathfloor((e + 1) / 3) - (e % 3 == (e < 0 ? -1 : 2));
            if (s == 1 / 0) n = "5e" + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf("e") + 1) + e;
            }
            r = new Ctor(n);
            r.s = x.s;
        } else r = new Ctor(s.toString());
        sd = (e = Ctor.precision) + 3;
        // Halley's method.
        // TODO? Compare Newton's method.
        for(;;){
            t = r;
            t3 = t.times(t).times(t);
            t3plusx = t3.plus(x);
            r = divide(t3plusx.plus(x).times(t), t3plusx.plus(t3), sd + 2, 1);
            // TODO? Replace with for-loop and checkRoundingDigits.
            if (digitsToString(t.d).slice(0, sd) === (n = digitsToString(r.d)).slice(0, sd)) {
                n = n.slice(sd - 3, sd + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or 4999
                // , i.e. approaching a rounding boundary, continue the iteration.
                if (n == "9999" || !rep && n == "4999") {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    if (!rep) {
                        finalise(t, e + 1, 0);
                        if (t.times(t).times(t).eq(x)) {
                            r = t;
                            break;
                        }
                    }
                    sd += 4;
                    rep = 1;
                } else {
                    // If the rounding digits are null, 0{0,4} or 50{0,3}, check for an exact result.
                    // If not, then there are further digits and m will be truthy.
                    if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                        // Truncate to the first rounding digit.
                        finalise(r, e + 1, 1);
                        m = !r.times(r).times(r).eq(x);
                    }
                    break;
                }
            }
        }
        external = true;
        return finalise(r, e, Ctor.rounding, m);
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var w, d = this.d, n = NaN;
        if (d) {
            w = d.length - 1;
            n = (w - mathfloor(this.e / LOG_BASE)) * LOG_BASE;
            // Subtract the number of trailing zeros of the last word.
            w = d[w];
            if (w) for(; w % 10 == 0; w /= 10)n--;
            if (n < 0) n = 0;
        }
        return n;
    };
    /*
   *  n / 0 = I
   *  n / N = N
   *  n / I = 0
   *  0 / n = 0
   *  0 / 0 = N
   *  0 / N = N
   *  0 / I = 0
   *  N / n = N
   *  N / 0 = N
   *  N / N = N
   *  N / I = N
   *  I / n = I
   *  I / 0 = I
   *  I / N = N
   *  I / I = N
   *
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, rounded to `precision` significant digits using rounding mode `rounding`.
   *
   */ P.dividedToIntegerBy = P.divToInt = function(y) {
        var x = this, Ctor = x.constructor;
        return finalise(divide(x, new Ctor(y), 0, 1, 1), Ctor.precision, Ctor.rounding);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return this.cmp(y) === 0;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number in the
   * direction of negative Infinity.
   *
   */ P.floor = function() {
        return finalise(new this.constructor(this), this.e + 1, 3);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        var k = this.cmp(y);
        return k == 1 || k === 0;
    };
    /*
   * Return a new Decimal whose value is the hyperbolic cosine of the value in radians of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [1, Infinity]
   *
   * cosh(x) = 1 + x^2/2! + x^4/4! + x^6/6! + ...
   *
   * cosh(0)         = 1
   * cosh(-0)        = 1
   * cosh(Infinity)  = Infinity
   * cosh(-Infinity) = Infinity
   * cosh(NaN)       = NaN
   *
   *  x        time taken (ms)   result
   * 1000      9                 9.8503555700852349694e+433
   * 10000     25                4.4034091128314607936e+4342
   * 100000    171               1.4033316802130615897e+43429
   * 1000000   3817              1.5166076984010437725e+434294
   * 10000000  abandoned after 2 minute wait
   *
   * TODO? Compare performance of cosh(x) = 0.5 * (exp(x) + exp(-x))
   *
   */ P.hyperbolicCosine = P.cosh = function() {
        var k, n, pr, rm, len, x = this, Ctor = x.constructor, one = new Ctor(1);
        if (!x.isFinite()) return new Ctor(x.s ? 1 / 0 : NaN);
        if (x.isZero()) return one;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
        Ctor.rounding = 1;
        len = x.d.length;
        // Argument reduction: cos(4x) = 1 - 8cos^2(x) + 8cos^4(x) + 1
        // i.e. cos(x) = 1 - cos^2(x/4)(8 - 8cos^2(x/4))
        // Estimate the optimum number of times to use the argument reduction.
        // TODO? Estimation reused from cosine() and may not be optimal here.
        if (len < 32) {
            k = Math.ceil(len / 3);
            n = (1 / tinyPow(4, k)).toString();
        } else {
            k = 16;
            n = "2.3283064365386962890625e-10";
        }
        x = taylorSeries(Ctor, 1, x.times(n), new Ctor(1), true);
        // Reverse argument reduction
        var cosh2_x, i = k, d8 = new Ctor(8);
        for(; i--;){
            cosh2_x = x.times(x);
            x = one.minus(cosh2_x.times(d8.minus(cosh2_x.times(d8))));
        }
        return finalise(x, Ctor.precision = pr, Ctor.rounding = rm, true);
    };
    /*
   * Return a new Decimal whose value is the hyperbolic sine of the value in radians of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-Infinity, Infinity]
   *
   * sinh(x) = x + x^3/3! + x^5/5! + x^7/7! + ...
   *
   * sinh(0)         = 0
   * sinh(-0)        = -0
   * sinh(Infinity)  = Infinity
   * sinh(-Infinity) = -Infinity
   * sinh(NaN)       = NaN
   *
   * x        time taken (ms)
   * 10       2 ms
   * 100      5 ms
   * 1000     14 ms
   * 10000    82 ms
   * 100000   886 ms            1.4033316802130615897e+43429
   * 200000   2613 ms
   * 300000   5407 ms
   * 400000   8824 ms
   * 500000   13026 ms          8.7080643612718084129e+217146
   * 1000000  48543 ms
   *
   * TODO? Compare performance of sinh(x) = 0.5 * (exp(x) - exp(-x))
   *
   */ P.hyperbolicSine = P.sinh = function() {
        var k, pr, rm, len, x = this, Ctor = x.constructor;
        if (!x.isFinite() || x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
        Ctor.rounding = 1;
        len = x.d.length;
        if (len < 3) x = taylorSeries(Ctor, 2, x, x, true);
        else {
            // Alternative argument reduction: sinh(3x) = sinh(x)(3 + 4sinh^2(x))
            // i.e. sinh(x) = sinh(x/3)(3 + 4sinh^2(x/3))
            // 3 multiplications and 1 addition
            // Argument reduction: sinh(5x) = sinh(x)(5 + sinh^2(x)(20 + 16sinh^2(x)))
            // i.e. sinh(x) = sinh(x/5)(5 + sinh^2(x/5)(20 + 16sinh^2(x/5)))
            // 4 multiplications and 2 additions
            // Estimate the optimum number of times to use the argument reduction.
            k = 1.4 * Math.sqrt(len);
            k = k > 16 ? 16 : k | 0;
            x = x.times(1 / tinyPow(5, k));
            x = taylorSeries(Ctor, 2, x, x, true);
            // Reverse argument reduction
            var sinh2_x, d5 = new Ctor(5), d16 = new Ctor(16), d20 = new Ctor(20);
            for(; k--;){
                sinh2_x = x.times(x);
                x = x.times(d5.plus(sinh2_x.times(d16.times(sinh2_x).plus(d20))));
            }
        }
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(x, pr, rm, true);
    };
    /*
   * Return a new Decimal whose value is the hyperbolic tangent of the value in radians of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-1, 1]
   *
   * tanh(x) = sinh(x) / cosh(x)
   *
   * tanh(0)         = 0
   * tanh(-0)        = -0
   * tanh(Infinity)  = 1
   * tanh(-Infinity) = -1
   * tanh(NaN)       = NaN
   *
   */ P.hyperbolicTangent = P.tanh = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(x.s);
        if (x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + 7;
        Ctor.rounding = 1;
        return divide(x.sinh(), x.cosh(), Ctor.precision = pr, Ctor.rounding = rm);
    };
    /*
   * Return a new Decimal whose value is the arccosine (inverse cosine) in radians of the value of
   * this Decimal.
   *
   * Domain: [-1, 1]
   * Range: [0, pi]
   *
   * acos(x) = pi/2 - asin(x)
   *
   * acos(0)       = pi/2
   * acos(-0)      = pi/2
   * acos(1)       = 0
   * acos(-1)      = pi
   * acos(1/2)     = pi/3
   * acos(-1/2)    = 2*pi/3
   * acos(|x| > 1) = NaN
   * acos(NaN)     = NaN
   *
   */ P.inverseCosine = P.acos = function() {
        var halfPi, x = this, Ctor = x.constructor, k = x.abs().cmp(1), pr = Ctor.precision, rm = Ctor.rounding;
        if (k !== -1) return k === 0 ? x.isNeg() ? getPi(Ctor, pr, rm) : new Ctor(0) : new Ctor(NaN);
        if (x.isZero()) return getPi(Ctor, pr + 4, rm).times(0.5);
        // TODO? Special case acos(0.5) = pi/3 and acos(-0.5) = 2*pi/3
        Ctor.precision = pr + 6;
        Ctor.rounding = 1;
        x = x.asin();
        halfPi = getPi(Ctor, pr + 4, rm).times(0.5);
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return halfPi.minus(x);
    };
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic cosine in radians of the
   * value of this Decimal.
   *
   * Domain: [1, Infinity]
   * Range: [0, Infinity]
   *
   * acosh(x) = ln(x + sqrt(x^2 - 1))
   *
   * acosh(x < 1)     = NaN
   * acosh(NaN)       = NaN
   * acosh(Infinity)  = Infinity
   * acosh(-Infinity) = NaN
   * acosh(0)         = NaN
   * acosh(-0)        = NaN
   * acosh(1)         = 0
   * acosh(-1)        = NaN
   *
   */ P.inverseHyperbolicCosine = P.acosh = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (x.lte(1)) return new Ctor(x.eq(1) ? 0 : NaN);
        if (!x.isFinite()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(Math.abs(x.e), x.sd()) + 4;
        Ctor.rounding = 1;
        external = false;
        x = x.times(x).minus(1).sqrt().plus(x);
        external = true;
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.ln();
    };
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic sine in radians of the value
   * of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-Infinity, Infinity]
   *
   * asinh(x) = ln(x + sqrt(x^2 + 1))
   *
   * asinh(NaN)       = NaN
   * asinh(Infinity)  = Infinity
   * asinh(-Infinity) = -Infinity
   * asinh(0)         = 0
   * asinh(-0)        = -0
   *
   */ P.inverseHyperbolicSine = P.asinh = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite() || x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + 2 * Math.max(Math.abs(x.e), x.sd()) + 6;
        Ctor.rounding = 1;
        external = false;
        x = x.times(x).plus(1).sqrt().plus(x);
        external = true;
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.ln();
    };
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic tangent in radians of the
   * value of this Decimal.
   *
   * Domain: [-1, 1]
   * Range: [-Infinity, Infinity]
   *
   * atanh(x) = 0.5 * ln((1 + x) / (1 - x))
   *
   * atanh(|x| > 1)   = NaN
   * atanh(NaN)       = NaN
   * atanh(Infinity)  = NaN
   * atanh(-Infinity) = NaN
   * atanh(0)         = 0
   * atanh(-0)        = -0
   * atanh(1)         = Infinity
   * atanh(-1)        = -Infinity
   *
   */ P.inverseHyperbolicTangent = P.atanh = function() {
        var pr, rm, wpr, xsd, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(NaN);
        if (x.e >= 0) return new Ctor(x.abs().eq(1) ? x.s / 0 : x.isZero() ? x : NaN);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        xsd = x.sd();
        if (Math.max(xsd, pr) < 2 * -x.e - 1) return finalise(new Ctor(x), pr, rm, true);
        Ctor.precision = wpr = xsd - x.e;
        x = divide(x.plus(1), new Ctor(1).minus(x), wpr + pr, 1);
        Ctor.precision = pr + 4;
        Ctor.rounding = 1;
        x = x.ln();
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.times(0.5);
    };
    /*
   * Return a new Decimal whose value is the arcsine (inverse sine) in radians of the value of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-pi/2, pi/2]
   *
   * asin(x) = 2*atan(x/(1 + sqrt(1 - x^2)))
   *
   * asin(0)       = 0
   * asin(-0)      = -0
   * asin(1/2)     = pi/6
   * asin(-1/2)    = -pi/6
   * asin(1)       = pi/2
   * asin(-1)      = -pi/2
   * asin(|x| > 1) = NaN
   * asin(NaN)     = NaN
   *
   * TODO? Compare performance of Taylor series.
   *
   */ P.inverseSine = P.asin = function() {
        var halfPi, k, pr, rm, x = this, Ctor = x.constructor;
        if (x.isZero()) return new Ctor(x);
        k = x.abs().cmp(1);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        if (k !== -1) {
            // |x| is 1
            if (k === 0) {
                halfPi = getPi(Ctor, pr + 4, rm).times(0.5);
                halfPi.s = x.s;
                return halfPi;
            }
            // |x| > 1 or x is NaN
            return new Ctor(NaN);
        }
        // TODO? Special case asin(1/2) = pi/6 and asin(-1/2) = -pi/6
        Ctor.precision = pr + 6;
        Ctor.rounding = 1;
        x = x.div(new Ctor(1).minus(x.times(x)).sqrt().plus(1)).atan();
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.times(2);
    };
    /*
   * Return a new Decimal whose value is the arctangent (inverse tangent) in radians of the value
   * of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-pi/2, pi/2]
   *
   * atan(x) = x - x^3/3 + x^5/5 - x^7/7 + ...
   *
   * atan(0)         = 0
   * atan(-0)        = -0
   * atan(1)         = pi/4
   * atan(-1)        = -pi/4
   * atan(Infinity)  = pi/2
   * atan(-Infinity) = -pi/2
   * atan(NaN)       = NaN
   *
   */ P.inverseTangent = P.atan = function() {
        var i, j, k, n, px, t, r, wpr, x2, x = this, Ctor = x.constructor, pr = Ctor.precision, rm = Ctor.rounding;
        if (!x.isFinite()) {
            if (!x.s) return new Ctor(NaN);
            if (pr + 4 <= PI_PRECISION) {
                r = getPi(Ctor, pr + 4, rm).times(0.5);
                r.s = x.s;
                return r;
            }
        } else if (x.isZero()) return new Ctor(x);
        else if (x.abs().eq(1) && pr + 4 <= PI_PRECISION) {
            r = getPi(Ctor, pr + 4, rm).times(0.25);
            r.s = x.s;
            return r;
        }
        Ctor.precision = wpr = pr + 10;
        Ctor.rounding = 1;
        // TODO? if (x >= 1 && pr <= PI_PRECISION) atan(x) = halfPi * x.s - atan(1 / x);
        // Argument reduction
        // Ensure |x| < 0.42
        // atan(x) = 2 * atan(x / (1 + sqrt(1 + x^2)))
        k = Math.min(28, wpr / LOG_BASE + 2 | 0);
        for(i = k; i; --i)x = x.div(x.times(x).plus(1).sqrt().plus(1));
        external = false;
        j = Math.ceil(wpr / LOG_BASE);
        n = 1;
        x2 = x.times(x);
        r = new Ctor(x);
        px = x;
        // atan(x) = x - x^3/3 + x^5/5 - x^7/7 + ...
        for(; i !== -1;){
            px = px.times(x2);
            t = r.minus(px.div(n += 2));
            px = px.times(x2);
            r = t.plus(px.div(n += 2));
            if (r.d[j] !== void 0) for(i = j; r.d[i] === t.d[i] && i--;);
        }
        if (k) r = r.times(2 << k - 1);
        external = true;
        return finalise(r, Ctor.precision = pr, Ctor.rounding = rm, true);
    };
    /*
   * Return true if the value of this Decimal is a finite number, otherwise return false.
   *
   */ P.isFinite = function() {
        return !!this.d;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isInt = function() {
        return !!this.d && mathfloor(this.e / LOG_BASE) > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is NaN, otherwise return false.
   *
   */ P.isNaN = function() {
        return !this.s;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isNeg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.isPos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0 or -0, otherwise return false.
   *
   */ P.isZero = function() {
        return !!this.d && this.d[0] === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * If no base is specified, return log[10](arg).
   *
   * log[base](arg) = ln(arg) / ln(base)
   *
   * The result will always be correctly rounded if the base of the log is 10, and 'almost always'
   * otherwise:
   *
   * Depending on the rounding mode, the result may be incorrectly rounded if the first fifteen
   * rounding digits are [49]99999999999999 or [50]00000000000000. In that case, the maximum error
   * between the result and the correctly rounded result will be one ulp (unit in the last place).
   *
   * log[-b](a)       = NaN
   * log[0](a)        = NaN
   * log[1](a)        = NaN
   * log[NaN](a)      = NaN
   * log[Infinity](a) = NaN
   * log[b](0)        = -Infinity
   * log[b](-0)       = -Infinity
   * log[b](-a)       = NaN
   * log[b](1)        = 0
   * log[b](Infinity) = Infinity
   * log[b](NaN)      = NaN
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var isBase10, d, denominator, k, inf, num, sd, r, arg = this, Ctor = arg.constructor, pr = Ctor.precision, rm = Ctor.rounding, guard = 5;
        // Default base is 10.
        if (base == null) {
            base = new Ctor(10);
            isBase10 = true;
        } else {
            base = new Ctor(base);
            d = base.d;
            // Return NaN if base is negative, or non-finite, or is 0 or 1.
            if (base.s < 0 || !d || !d[0] || base.eq(1)) return new Ctor(NaN);
            isBase10 = base.eq(10);
        }
        d = arg.d;
        // Is arg negative, non-finite, 0 or 1?
        if (arg.s < 0 || !d || !d[0] || arg.eq(1)) return new Ctor(d && !d[0] ? -1 / 0 : arg.s != 1 ? NaN : d ? 0 : 1 / 0);
        // The result will have a non-terminating decimal expansion if base is 10 and arg is not an
        // integer power of 10.
        if (isBase10) {
            if (d.length > 1) inf = true;
            else {
                for(k = d[0]; k % 10 === 0;)k /= 10;
                inf = k !== 1;
            }
        }
        external = false;
        sd = pr + guard;
        num = naturalLogarithm(arg, sd);
        denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);
        // The result will have 5 rounding digits.
        r = divide(num, denominator, sd, 1);
        // If at a rounding boundary, i.e. the result's rounding digits are [49]9999 or [50]0000,
        // calculate 10 further digits.
        //
        // If the result is known to have an infinite decimal expansion, repeat this until it is clear
        // that the result is above or below the boundary. Otherwise, if after calculating the 10
        // further digits, the last 14 are nines, round up and assume the result is exact.
        // Also assume the result is exact if the last 14 are zero.
        //
        // Example of a result that will be incorrectly rounded:
        // log[1048576](4503599627370502) = 2.60000000000000009610279511444746...
        // The above result correctly rounded using ROUND_CEIL to 1 decimal place should be 2.7, but it
        // will be given as 2.6 as there are 15 zeros immediately after the requested decimal place, so
        // the exact result would be assumed to be 2.6, which rounded using ROUND_CEIL to 1 decimal
        // place is still 2.6.
        if (checkRoundingDigits(r.d, k = pr, rm)) do {
            sd += 10;
            num = naturalLogarithm(arg, sd);
            denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);
            r = divide(num, denominator, sd, 1);
            if (!inf) {
                // Check for 14 nines from the 2nd rounding digit, as the first may be 4.
                if (+digitsToString(r.d).slice(k + 1, k + 15) + 1 == 1e14) r = finalise(r, pr + 1, 0);
                break;
            }
        }while (checkRoundingDigits(r.d, k += 10, rm));
        external = true;
        return finalise(r, pr, rm);
    };
    /*
   * Return a new Decimal whose value is the maximum of the arguments and the value of this Decimal.
   *
   * arguments {number|string|Decimal}
   *
  P.max = function () {
    Array.prototype.push.call(arguments, this);
    return maxOrMin(this.constructor, arguments, 'lt');
  };
   */ /*
   * Return a new Decimal whose value is the minimum of the arguments and the value of this Decimal.
   *
   * arguments {number|string|Decimal}
   *
  P.min = function () {
    Array.prototype.push.call(arguments, this);
    return maxOrMin(this.constructor, arguments, 'gt');
  };
   */ /*
   *  n - 0 = n
   *  n - N = N
   *  n - I = -I
   *  0 - n = -n
   *  0 - 0 = 0
   *  0 - N = N
   *  0 - I = -I
   *  N - n = N
   *  N - 0 = N
   *  N - N = N
   *  N - I = N
   *  I - n = I
   *  I - 0 = I
   *  I - N = N
   *  I - I = N
   *
   * Return a new Decimal whose value is the value of this Decimal minus `y`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   */ P.minus = P.sub = function(y) {
        var d, e, i, j, k, len, pr, rm, xd, xe, xLTy, yd, x = this, Ctor = x.constructor;
        y = new Ctor(y);
        // If either is not finite...
        if (!x.d || !y.d) {
            // Return NaN if either is NaN.
            if (!x.s || !y.s) y = new Ctor(NaN);
            else if (x.d) y.s = -y.s;
            else y = new Ctor(y.d || x.s !== y.s ? x : NaN);
            return y;
        }
        // If signs differ...
        if (x.s != y.s) {
            y.s = -y.s;
            return x.plus(y);
        }
        xd = x.d;
        yd = y.d;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        // If either is zero...
        if (!xd[0] || !yd[0]) {
            // Return y negated if x is zero and y is non-zero.
            if (yd[0]) y.s = -y.s;
            else if (xd[0]) y = new Ctor(x);
            else return new Ctor(rm === 3 ? -0 : 0);
            return external ? finalise(y, pr, rm) : y;
        }
        // x and y are finite, non-zero numbers with the same sign.
        // Calculate base 1e7 exponents.
        e = mathfloor(y.e / LOG_BASE);
        xe = mathfloor(x.e / LOG_BASE);
        xd = xd.slice();
        k = xe - e;
        // If base 1e7 exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of
            // zeros needing to be prepended, but this can be avoided while still ensuring correct
            // rounding by limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to `xd` if shorter.
        // Don't add zeros to `yd` if shorter as subtraction only needs to start at `yd` length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(rm === 3 ? -0 : 0);
        y.d = xd;
        y.e = getBase10Exponent(xd, e);
        return external ? finalise(y, pr, rm) : y;
    };
    /*
   *   n % 0 =  N
   *   n % N =  N
   *   n % I =  n
   *   0 % n =  0
   *  -0 % n = -0
   *   0 % 0 =  N
   *   0 % N =  N
   *   0 % I =  0
   *   N % n =  N
   *   N % 0 =  N
   *   N % N =  N
   *   N % I =  N
   *   I % n =  N
   *   I % 0 =  N
   *   I % N =  N
   *   I % I =  N
   *
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * The result depends on the modulo mode.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor;
        y = new Ctor(y);
        // Return NaN if x is ±Infinity or NaN, or y is NaN or ±0.
        if (!x.d || !y.s || y.d && !y.d[0]) return new Ctor(NaN);
        // Return x if y is ±Infinity or x is ±0.
        if (!y.d || x.d && !x.d[0]) return finalise(new Ctor(x), Ctor.precision, Ctor.rounding);
        // Prevent rounding of intermediate calculations.
        external = false;
        if (Ctor.modulo == 9) {
            // Euclidian division: q = sign(y) * floor(x / abs(y))
            // result = x - q * y    where  0 <= result < abs(y)
            q = divide(x, y.abs(), 0, 3, 1);
            q.s *= y.s;
        } else q = divide(x, y, 0, Ctor.modulo, 1);
        q = q.times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   */ P.naturalExponential = P.exp = function() {
        return naturalExponential(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * rounded to `precision` significant digits using rounding mode `rounding`.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return naturalLogarithm(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s;
        return finalise(x);
    };
    /*
   *  n + 0 = n
   *  n + N = N
   *  n + I = I
   *  0 + n = n
   *  0 + 0 = 0
   *  0 + N = N
   *  0 + I = I
   *  N + n = N
   *  N + 0 = N
   *  N + N = N
   *  N + I = N
   *  I + n = I
   *  I + 0 = I
   *  I + N = N
   *  I + I = I
   *
   * Return a new Decimal whose value is the value of this Decimal plus `y`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   */ P.plus = P.add = function(y) {
        var carry, d, e, i, k, len, pr, rm, xd, yd, x = this, Ctor = x.constructor;
        y = new Ctor(y);
        // If either is not finite...
        if (!x.d || !y.d) {
            // Return NaN if either is NaN.
            if (!x.s || !y.s) y = new Ctor(NaN);
            else if (!x.d) y = new Ctor(y.d || x.s === y.s ? x : NaN);
            return y;
        }
        // If signs differ...
        if (x.s != y.s) {
            y.s = -y.s;
            return x.minus(y);
        }
        xd = x.d;
        yd = y.d;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        // If either is zero...
        if (!xd[0] || !yd[0]) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!yd[0]) y = new Ctor(x);
            return external ? finalise(y, pr, rm) : y;
        }
        // x and y are finite, non-zero numbers with the same sign.
        // Calculate base 1e7 exponents.
        k = mathfloor(x.e / LOG_BASE);
        e = mathfloor(y.e / LOG_BASE);
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = getBase10Exponent(xd, e);
        return external ? finalise(y, pr, rm) : y;
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var k, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        if (x.d) {
            k = getPrecision(x.d);
            if (z && x.e + 1 > k) k = x.e + 1;
        } else k = NaN;
        return k;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.round = function() {
        var x = this, Ctor = x.constructor;
        return finalise(new Ctor(x), x.e + 1, Ctor.rounding);
    };
    /*
   * Return a new Decimal whose value is the sine of the value in radians of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-1, 1]
   *
   * sin(x) = x - x^3/3! + x^5/5! - ...
   *
   * sin(0)         = 0
   * sin(-0)        = -0
   * sin(Infinity)  = NaN
   * sin(-Infinity) = NaN
   * sin(NaN)       = NaN
   *
   */ P.sine = P.sin = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(NaN);
        if (x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + LOG_BASE;
        Ctor.rounding = 1;
        x = sine(Ctor, toLessThanHalfPi(Ctor, x));
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(quadrant > 2 ? x.neg() : x, pr, rm, true);
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   *  sqrt(-n) =  N
   *  sqrt(N)  =  N
   *  sqrt(-I) =  N
   *  sqrt(I)  =  I
   *  sqrt(0)  =  0
   *  sqrt(-0) = -0
   *
   */ P.squareRoot = P.sqrt = function() {
        var m, n, sd, r, rep, t, x = this, d = x.d, e = x.e, s = x.s, Ctor = x.constructor;
        // Negative/NaN/Infinity/zero?
        if (s !== 1 || !d || !d[0]) return new Ctor(!s || s < 0 && (!d || d[0]) ? NaN : d ? x : 1 / 0);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(d);
            if ((n.length + e) % 2 == 0) n += "0";
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = "5e" + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf("e") + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        sd = (e = Ctor.precision) + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, sd + 2, 1)).times(0.5);
            // TODO? Replace with for-loop and checkRoundingDigits.
            if (digitsToString(t.d).slice(0, sd) === (n = digitsToString(r.d)).slice(0, sd)) {
                n = n.slice(sd - 3, sd + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (n == "9999" || !rep && n == "4999") {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    if (!rep) {
                        finalise(t, e + 1, 0);
                        if (t.times(t).eq(x)) {
                            r = t;
                            break;
                        }
                    }
                    sd += 4;
                    rep = 1;
                } else {
                    // If the rounding digits are null, 0{0,4} or 50{0,3}, check for an exact result.
                    // If not, then there are further digits and m will be truthy.
                    if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                        // Truncate to the first rounding digit.
                        finalise(r, e + 1, 1);
                        m = !r.times(r).eq(x);
                    }
                    break;
                }
            }
        }
        external = true;
        return finalise(r, e, Ctor.rounding, m);
    };
    /*
   * Return a new Decimal whose value is the tangent of the value in radians of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-Infinity, Infinity]
   *
   * tan(0)         = 0
   * tan(-0)        = -0
   * tan(Infinity)  = NaN
   * tan(-Infinity) = NaN
   * tan(NaN)       = NaN
   *
   */ P.tangent = P.tan = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(NaN);
        if (x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + 10;
        Ctor.rounding = 1;
        x = x.sin();
        x.s = 1;
        x = divide(x, new Ctor(1).minus(x.times(x)).sqrt(), pr + 10, 0);
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(quadrant == 2 || quadrant == 4 ? x.neg() : x, pr, rm, true);
    };
    /*
   *  n * 0 = 0
   *  n * N = N
   *  n * I = I
   *  0 * n = 0
   *  0 * 0 = 0
   *  0 * N = N
   *  0 * I = N
   *  N * n = N
   *  N * 0 = N
   *  N * N = N
   *  N * I = N
   *  I * n = I
   *  I * 0 = N
   *  I * N = N
   *  I * I = I
   *
   * Return a new Decimal whose value is this Decimal times `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        y.s *= x.s;
        // If either is NaN, ±Infinity or ±0...
        if (!xd || !xd[0] || !yd || !yd[0]) return new Ctor(!y.s || xd && !xd[0] && !yd || yd && !yd[0] && !xd ? NaN : !xd || !yd ? y.s / 0 : y.s * 0);
        e = mathfloor(x.e / LOG_BASE) + mathfloor(y.e / LOG_BASE);
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = getBase10Exponent(r, e);
        return external ? finalise(y, Ctor.precision, Ctor.rounding) : y;
    };
    /*
   * Return a string representing the value of this Decimal in base 2, round to `sd` significant
   * digits using rounding mode `rm`.
   *
   * If the optional `sd` argument is present then return binary exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toBinary = function(sd, rm) {
        return toStringBinary(this, 2, sd, rm);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.toDP = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return finalise(x, dp + x.e + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = finiteToString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = finalise(new Ctor(x), dp + 1, rm);
            str = finiteToString(x, true, dp + 1);
        }
        return x.isNeg() && !x.isZero() ? "-" + str : str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) str = finiteToString(x);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            y = finalise(new Ctor(x), dp + x.e + 1, rm);
            str = finiteToString(y, false, dp + y.e + 1);
        }
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isNeg() && !x.isZero() ? "-" + str : str;
    };
    /*
   * Return an array representing the value of this Decimal as a simple fraction with an integer
   * numerator and an integer denominator.
   *
   * The denominator will be a positive non-zero value less than or equal to the specified maximum
   * denominator. If a maximum denominator is not specified, the denominator will be the lowest
   * value necessary to represent the number exactly.
   *
   * [maxD] {number|string|Decimal} Maximum denominator. Integer >= 1 and < Infinity.
   *
   */ P.toFraction = function(maxD) {
        var d, d0, d1, d2, e, k, n, n0, n1, pr, q, r, x = this, xd = x.d, Ctor = x.constructor;
        if (!xd) return new Ctor(x);
        n1 = d0 = new Ctor(1);
        d1 = n0 = new Ctor(0);
        d = new Ctor(d1);
        e = d.e = getPrecision(xd) - x.e - 1;
        k = e % LOG_BASE;
        d.d[0] = mathpow(10, k < 0 ? LOG_BASE + k : k);
        if (maxD == null) // d is 10**e, the minimum max-denominator needed.
        maxD = e > 0 ? d : n1;
        else {
            n = new Ctor(maxD);
            if (!n.isInt() || n.lt(n1)) throw Error(invalidArgument + n);
            maxD = n.gt(d) ? e > 0 ? d : n1 : n;
        }
        external = false;
        n = new Ctor(digitsToString(xd));
        pr = Ctor.precision;
        Ctor.precision = e = xd.length * LOG_BASE * 2;
        for(;;){
            q = divide(n, d, 0, 1, 1);
            d2 = d0.plus(q.times(d1));
            if (d2.cmp(maxD) == 1) break;
            d0 = d1;
            d1 = d2;
            d2 = n1;
            n1 = n0.plus(q.times(d2));
            n0 = d2;
            d2 = d;
            d = n.minus(q.times(d2));
            n = d2;
        }
        d2 = divide(maxD.minus(d0), d1, 0, 1, 1);
        n0 = n0.plus(d2.times(n1));
        d0 = d0.plus(d2.times(d1));
        n0.s = n1.s = x.s;
        // Determine which fraction is closer to x, n0/d0 or n1/d1?
        r = divide(n1, d1, e, 1).minus(x).abs().cmp(divide(n0, d0, e, 1).minus(x).abs()) < 1 ? [
            n1,
            d1
        ] : [
            n0,
            d0
        ];
        Ctor.precision = pr;
        external = true;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal in base 16, round to `sd` significant
   * digits using rounding mode `rm`.
   *
   * If the optional `sd` argument is present then return binary exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toHexadecimal = P.toHex = function(sd, rm) {
        return toStringBinary(this, 16, sd, rm);
    };
    /*
   * Returns a new Decimal whose value is the nearest multiple of `y` in the direction of rounding
   * mode `rm`, or `Decimal.rounding` if `rm` is omitted, to the value of this Decimal.
   *
   * The return value will always have the same sign as this Decimal, unless either this Decimal
   * or `y` is NaN, in which case the return value will be also be NaN.
   *
   * The return value is not affected by the value of `precision`.
   *
   * y {number|string|Decimal} The magnitude to round to a multiple of.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * 'toNearest() rounding mode not an integer: {rm}'
   * 'toNearest() rounding mode out of range: {rm}'
   *
   */ P.toNearest = function(y, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (y == null) {
            // If x is not finite, return x.
            if (!x.d) return x;
            y = new Ctor(1);
            rm = Ctor.rounding;
        } else {
            y = new Ctor(y);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            // If x is not finite, return x if y is not NaN, else NaN.
            if (!x.d) return y.s ? x : y;
            // If y is not finite, return Infinity with the sign of x if y is Infinity, else NaN.
            if (!y.d) {
                if (y.s) y.s = x.s;
                return y;
            }
        }
        // If y is not zero, calculate the nearest multiple of y to x.
        if (y.d[0]) {
            external = false;
            x = divide(x, y, 0, rm, 1).times(y);
            external = true;
            finalise(x);
        // If y is zero, return zero with the sign of x.
        } else {
            y.s = x.s;
            x = y;
        }
        return x;
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   * Zero keeps its sign.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a string representing the value of this Decimal in base 8, round to `sd` significant
   * digits using rounding mode `rm`.
   *
   * If the optional `sd` argument is present then return binary exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toOctal = function(sd, rm) {
        return toStringBinary(this, 8, sd, rm);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`, rounded
   * to `precision` significant digits using rounding mode `rounding`.
   *
   * ECMAScript compliant.
   *
   *   pow(x, NaN)                           = NaN
   *   pow(x, ±0)                            = 1

   *   pow(NaN, non-zero)                    = NaN
   *   pow(abs(x) > 1, +Infinity)            = +Infinity
   *   pow(abs(x) > 1, -Infinity)            = +0
   *   pow(abs(x) == 1, ±Infinity)           = NaN
   *   pow(abs(x) < 1, +Infinity)            = +0
   *   pow(abs(x) < 1, -Infinity)            = +Infinity
   *   pow(+Infinity, y > 0)                 = +Infinity
   *   pow(+Infinity, y < 0)                 = +0
   *   pow(-Infinity, odd integer > 0)       = -Infinity
   *   pow(-Infinity, even integer > 0)      = +Infinity
   *   pow(-Infinity, odd integer < 0)       = -0
   *   pow(-Infinity, even integer < 0)      = +0
   *   pow(+0, y > 0)                        = +0
   *   pow(+0, y < 0)                        = +Infinity
   *   pow(-0, odd integer > 0)              = -0
   *   pow(-0, even integer > 0)             = +0
   *   pow(-0, odd integer < 0)              = -Infinity
   *   pow(-0, even integer < 0)             = +Infinity
   *   pow(finite x < 0, finite non-integer) = NaN
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * Assuming the first 15 rounding digits are each equally likely to be any digit 0-9, the
   * probability of an incorrectly rounded result
   * P([49]9{14} | [50]0{14}) = 2 * 0.2 * 10^-14 = 4e-15 = 1/2.5e+14
   * i.e. 1 in 250,000,000,000,000
   *
   * If a result is incorrectly rounded the maximum error will be 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, rm, s, x = this, Ctor = x.constructor, yn = +(y = new Ctor(y));
        // Either ±Infinity, NaN or ±0?
        if (!x.d || !y.d || !x.d[0] || !y.d[0]) return new Ctor(mathpow(+x, yn));
        x = new Ctor(x);
        if (x.eq(1)) return x;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        if (y.eq(1)) return finalise(x, pr, rm);
        // y exponent
        e = mathfloor(y.e / LOG_BASE);
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        if (e >= y.d.length - 1 && (k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = intPow(Ctor, x, k, pr);
            return y.s < 0 ? new Ctor(1).div(r) : finalise(r, pr, rm);
        }
        s = x.s;
        // if x is negative
        if (s < 0) {
            // if y is not an integer
            if (e < y.d.length - 1) return new Ctor(NaN);
            // Result is positive if x is negative and the last digit of integer y is even.
            if ((y.d[e] & 1) == 0) s = 1;
            // if x.eq(-1)
            if (x.e == 0 && x.d[0] == 1 && x.d.length == 1) {
                x.s = s;
                return x;
            }
        }
        // Estimate result exponent.
        // x^y = 10^e,  where e = y * log10(x)
        // log10(x) = log10(x_significand) + x_exponent
        // log10(x_significand) = ln(x_significand) / ln(10)
        k = mathpow(+x, yn);
        e = k == 0 || !isFinite(k) ? mathfloor(yn * (Math.log("0." + digitsToString(x.d)) / Math.LN10 + x.e + 1)) : new Ctor(k + "").e;
        // Exponent estimate may be incorrect e.g. x: 0.999999999999999999, y: 2.29, e: 0, r.e: -1.
        // Overflow/underflow?
        if (e > Ctor.maxE + 1 || e < Ctor.minE - 1) return new Ctor(e > 0 ? s / 0 : 0);
        external = false;
        Ctor.rounding = x.s = 1;
        // Estimate the extra guard digits needed to ensure five correct rounding digits from
        // naturalLogarithm(x). Example of failure without these extra digits (precision: 10):
        // new Decimal(2.32456).pow('2087987436534566.46411')
        // should be 1.162377823e+764914905173815, but is 1.162355823e+764914905173815
        k = Math.min(12, (e + "").length);
        // r = x^y = exp(y*ln(x))
        r = naturalExponential(y.times(naturalLogarithm(x, pr + k)), pr);
        // r may be Infinity, e.g. (0.9999999999999999).pow(-1e+40)
        if (r.d) {
            // Truncate to the required precision plus five rounding digits.
            r = finalise(r, pr + 5, 1);
            // If the rounding digits are [49]9999 or [50]0000 increase the precision by 10 and recalculate
            // the result.
            if (checkRoundingDigits(r.d, pr, rm)) {
                e = pr + 10;
                // Truncate to the increased precision plus five rounding digits.
                r = finalise(naturalExponential(y.times(naturalLogarithm(x, e + k)), e), e + 5, 1);
                // Check for 14 nines from the 2nd rounding digit (the first rounding digit may be 4 or 9).
                if (+digitsToString(r.d).slice(pr + 1, pr + 15) + 1 == 1e14) r = finalise(r, pr + 1, 0);
            }
        }
        r.s = s;
        external = true;
        Ctor.rounding = rm;
        return finalise(r, pr, rm);
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var str, x = this, Ctor = x.constructor;
        if (sd === void 0) str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
        else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = finalise(new Ctor(x), sd, rm);
            str = finiteToString(x, sd <= x.e || x.e <= Ctor.toExpNeg, sd);
        }
        return x.isNeg() && !x.isZero() ? "-" + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * 'toSD() digits out of range: {sd}'
   * 'toSD() digits not an integer: {sd}'
   * 'toSD() rounding mode not an integer: {rm}'
   * 'toSD() rounding mode out of range: {rm}'
   *
   */ P.toSignificantDigits = P.toSD = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return finalise(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = function() {
        var x = this, Ctor = x.constructor, str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
        return x.isNeg() && !x.isZero() ? "-" + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal truncated to a whole number.
   *
   */ P.truncated = P.trunc = function() {
        return finalise(new this.constructor(this), this.e + 1, 1);
    };
    /*
   * Return a string representing the value of this Decimal.
   * Unlike `toString`, negative zero will include the minus sign.
   *
   */ P.valueOf = P.toJSON = function() {
        var x = this, Ctor = x.constructor, str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
        return x.isNeg() ? "-" + str : str;
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  digitsToString           P.cubeRoot, P.logarithm, P.squareRoot, P.toFraction, P.toPower,
   *                           finiteToString, naturalExponential, naturalLogarithm
   *  checkInt32               P.toDecimalPlaces, P.toExponential, P.toFixed, P.toNearest,
   *                           P.toPrecision, P.toSignificantDigits, toStringBinary, random
   *  checkRoundingDigits      P.logarithm, P.toPower, naturalExponential, naturalLogarithm
   *  convertBase              toStringBinary, parseOther
   *  cos                      P.cos
   *  divide                   P.atanh, P.cubeRoot, P.dividedBy, P.dividedToIntegerBy,
   *                           P.logarithm, P.modulo, P.squareRoot, P.tan, P.tanh, P.toFraction,
   *                           P.toNearest, toStringBinary, naturalExponential, naturalLogarithm,
   *                           taylorSeries, atan2, parseOther
   *  finalise                 P.absoluteValue, P.atan, P.atanh, P.ceil, P.cos, P.cosh,
   *                           P.cubeRoot, P.dividedToIntegerBy, P.floor, P.logarithm, P.minus,
   *                           P.modulo, P.negated, P.plus, P.round, P.sin, P.sinh, P.squareRoot,
   *                           P.tan, P.times, P.toDecimalPlaces, P.toExponential, P.toFixed,
   *                           P.toNearest, P.toPower, P.toPrecision, P.toSignificantDigits,
   *                           P.truncated, divide, getLn10, getPi, naturalExponential,
   *                           naturalLogarithm, ceil, floor, round, trunc
   *  finiteToString           P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf,
   *                           toStringBinary
   *  getBase10Exponent        P.minus, P.plus, P.times, parseOther
   *  getLn10                  P.logarithm, naturalLogarithm
   *  getPi                    P.acos, P.asin, P.atan, toLessThanHalfPi, atan2
   *  getPrecision             P.precision, P.toFraction
   *  getZeroString            digitsToString, finiteToString
   *  intPow                   P.toPower, parseOther
   *  isOdd                    toLessThanHalfPi
   *  maxOrMin                 max, min
   *  naturalExponential       P.naturalExponential, P.toPower
   *  naturalLogarithm         P.acosh, P.asinh, P.atanh, P.logarithm, P.naturalLogarithm,
   *                           P.toPower, naturalExponential
   *  nonFiniteToString        finiteToString, toStringBinary
   *  parseDecimal             Decimal
   *  parseOther               Decimal
   *  sin                      P.sin
   *  taylorSeries             P.cosh, P.sinh, cos, sin
   *  toLessThanHalfPi         P.cos, P.sin
   *  toStringBinary           P.toBinary, P.toHexadecimal, P.toOctal
   *  truncate                 intPow
   *
   *  Throws:                  P.logarithm, P.precision, P.toFraction, checkInt32, getLn10, getPi,
   *                           naturalLogarithm, config, parseOther, random, Decimal
   */ function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = "", w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + "";
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + "";
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return "0";
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    /*
   * Check 5 rounding digits if `repeating` is null, 4 otherwise.
   * `repeating == null` if caller is `log` or `pow`,
   * `repeating != null` if caller is `naturalLogarithm` or `naturalExponential`.
   */ function checkRoundingDigits(d, i, rm, repeating) {
        var di, k, r, rd;
        // Get the length of the first word of the array d.
        for(k = d[0]; k >= 10; k /= 10)--i;
        // Is the rounding digit in the first word of d?
        if (--i < 0) {
            i += LOG_BASE;
            di = 0;
        } else {
            di = Math.ceil((i + 1) / LOG_BASE);
            i %= LOG_BASE;
        }
        // i is the index (0 - 6) of the rounding digit.
        // E.g. if within the word 3487563 the first rounding digit is 5,
        // then i = 4, k = 1000, rd = 3487563 % 1000 = 563
        k = mathpow(10, LOG_BASE - i);
        rd = d[di] % k | 0;
        if (repeating == null) {
            if (i < 3) {
                if (i == 0) rd = rd / 100 | 0;
                else if (i == 1) rd = rd / 10 | 0;
                r = rm < 4 && rd == 99999 || rm > 3 && rd == 49999 || rd == 50000 || rd == 0;
            } else r = (rm < 4 && rd + 1 == k || rm > 3 && rd + 1 == k / 2) && (d[di + 1] / k / 100 | 0) == mathpow(10, i - 2) - 1 || (rd == k / 2 || rd == 0) && (d[di + 1] / k / 100 | 0) == 0;
        } else if (i < 4) {
            if (i == 0) rd = rd / 1000 | 0;
            else if (i == 1) rd = rd / 100 | 0;
            else if (i == 2) rd = rd / 10 | 0;
            r = (repeating || rm < 4) && rd == 9999 || !repeating && rm > 3 && rd == 4999;
        } else r = ((repeating || rm < 4) && rd + 1 == k || !repeating && rm > 3 && rd + 1 == k / 2) && (d[di + 1] / k / 1000 | 0) == mathpow(10, i - 3) - 1;
        return r;
    }
    // Convert string of `baseIn` to an array of numbers of `baseOut`.
    // Eg. convertBase('255', 10, 16) returns [15, 15].
    // Eg. convertBase('ff', 16, 10) returns [2, 5, 5].
    function convertBase(str, baseIn, baseOut) {
        var j, arr = [
            0
        ], arrL, i = 0, strL = str.length;
        for(; i < strL;){
            for(arrL = arr.length; arrL--;)arr[arrL] *= baseIn;
            arr[0] += NUMERALS.indexOf(str.charAt(i++));
            for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                if (arr[j + 1] === void 0) arr[j + 1] = 0;
                arr[j + 1] += arr[j] / baseOut | 0;
                arr[j] %= baseOut;
            }
        }
        return arr.reverse();
    }
    /*
   * cos(x) = 1 - x^2/2! + x^4/4! - ...
   * |x| < pi/2
   *
   */ function cosine(Ctor, x) {
        var k, len, y;
        if (x.isZero()) return x;
        // Argument reduction: cos(4x) = 8*(cos^4(x) - cos^2(x)) + 1
        // i.e. cos(x) = 8*(cos^4(x/4) - cos^2(x/4)) + 1
        // Estimate the optimum number of times to use the argument reduction.
        len = x.d.length;
        if (len < 32) {
            k = Math.ceil(len / 3);
            y = (1 / tinyPow(4, k)).toString();
        } else {
            k = 16;
            y = "2.3283064365386962890625e-10";
        }
        Ctor.precision += k;
        x = taylorSeries(Ctor, 1, x.times(y), new Ctor(1));
        // Reverse argument reduction
        for(var i = k; i--;){
            var cos2x = x.times(x);
            x = cos2x.times(cos2x).minus(cos2x).times(8).plus(1);
        }
        Ctor.precision -= k;
        return x;
    }
    /*
   * Perform division in the specified base.
   */ var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k, base) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % base | 0;
                carry = temp / base | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL, base) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * base + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, rm, dp, base) {
            var cmp, e, i, k, logBase, more, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either NaN, Infinity or 0?
            if (!xd || !xd[0] || !yd || !yd[0]) return new Ctor(!x.s || !y.s || (xd ? yd && xd[0] == yd[0] : !yd) ? NaN : // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
            xd && xd[0] == 0 || !yd ? sign * 0 : sign / 0);
            if (base) {
                logBase = 1;
                e = x.e - y.e;
            } else {
                base = BASE;
                logBase = LOG_BASE;
                e = mathfloor(x.e / logBase) - mathfloor(y.e / logBase);
            }
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            // The digit array of a Decimal from toStringBinary may have trailing zeros.
            for(i = 0; yd[i] == (xd[i] || 0); i++);
            if (yd[i] > (xd[i] || 0)) e--;
            if (pr == null) {
                sd = pr = Ctor.precision;
                rm = Ctor.rounding;
            } else if (dp) sd = pr + (x.e - y.e) + 1;
            else sd = pr;
            if (sd < 0) {
                qd.push(1);
                more = true;
            } else {
                // Convert precision in number of base 10 digits to base 1e7 digits.
                sd = sd / logBase + 2 | 0;
                i = 0;
                // divisor < 1e7
                if (yL == 1) {
                    k = 0;
                    yd = yd[0];
                    sd++;
                    // k is the carry.
                    for(; (i < xL || k) && sd--; i++){
                        t = k * base + (xd[i] || 0);
                        qd[i] = t / yd | 0;
                        k = t % yd | 0;
                    }
                    more = k || i < xL;
                // divisor >= 1e7
                } else {
                    // Normalise xd and yd so highest order digit of yd is >= base/2
                    k = base / (yd[0] + 1) | 0;
                    if (k > 1) {
                        yd = multiplyInteger(yd, k, base);
                        xd = multiplyInteger(xd, k, base);
                        yL = yd.length;
                        xL = xd.length;
                    }
                    xi = yL;
                    rem = xd.slice(0, yL);
                    remL = rem.length;
                    // Add zeros to make remainder as long as divisor.
                    for(; remL < yL;)rem[remL++] = 0;
                    yz = yd.slice();
                    yz.unshift(0);
                    yd0 = yd[0];
                    if (yd[1] >= base / 2) ++yd0;
                    do {
                        k = 0;
                        // Compare divisor and remainder.
                        cmp = compare(yd, rem, yL, remL);
                        // If divisor < remainder.
                        if (cmp < 0) {
                            // Calculate trial digit, k.
                            rem0 = rem[0];
                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                            // k will be how many times the divisor goes into the current remainder.
                            k = rem0 / yd0 | 0;
                            //  Algorithm:
                            //  1. product = divisor * trial digit (k)
                            //  2. if product > remainder: product -= divisor, k--
                            //  3. remainder -= product
                            //  4. if product was < remainder at 2:
                            //    5. compare new remainder and divisor
                            //    6. If remainder > divisor: remainder -= divisor, k++
                            if (k > 1) {
                                if (k >= base) k = base - 1;
                                // product = divisor * trial digit.
                                prod = multiplyInteger(yd, k, base);
                                prodL = prod.length;
                                remL = rem.length;
                                // Compare product and remainder.
                                cmp = compare(prod, rem, prodL, remL);
                                // product > remainder.
                                if (cmp == 1) {
                                    k--;
                                    // Subtract divisor from product.
                                    subtract(prod, yL < prodL ? yz : yd, prodL, base);
                                }
                            } else {
                                // cmp is -1.
                                // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                                // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                                if (k == 0) cmp = k = 1;
                                prod = yd.slice();
                            }
                            prodL = prod.length;
                            if (prodL < remL) prod.unshift(0);
                            // Subtract product from remainder.
                            subtract(rem, prod, remL, base);
                            // If product was < previous remainder.
                            if (cmp == -1) {
                                remL = rem.length;
                                // Compare divisor and new remainder.
                                cmp = compare(yd, rem, yL, remL);
                                // If divisor < new remainder, subtract divisor from remainder.
                                if (cmp < 1) {
                                    k++;
                                    // Subtract divisor from remainder.
                                    subtract(rem, yL < remL ? yz : yd, remL, base);
                                }
                            }
                            remL = rem.length;
                        } else if (cmp === 0) {
                            k++;
                            rem = [
                                0
                            ];
                        } // if cmp === 1, k will be 0
                        // Add the next digit, k, to the result array.
                        qd[i++] = k;
                        // Update the remainder.
                        if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                        else {
                            rem = [
                                xd[xi]
                            ];
                            remL = 1;
                        }
                    }while ((xi++ < xL || rem[0] !== void 0) && sd--);
                    more = rem[0] !== void 0;
                }
                // Leading zero?
                if (!qd[0]) qd.shift();
            }
            // logBase is 1 when divide is being used for base conversion.
            if (logBase == 1) {
                q.e = e;
                inexact = more;
            } else {
                // To calculate q.e, first get the number of digits of qd[0].
                for(i = 1, k = qd[0]; k >= 10; k /= 10)i++;
                q.e = i + e * logBase - 1;
                finalise(q, dp ? pr + q.e + 1 : pr, rm, more);
            }
            return q;
        };
    }();
    /*
   * Round `x` to `sd` significant digits using rounding mode `rm`.
   * Check for over/under-flow.
   */ function finalise(x, sd, rm, isTruncated) {
        var digits, i, j, k, rd, roundUp, w, xd, xdi, Ctor = x.constructor;
        // Don't round if sd is null or undefined.
        out: if (sd != null) {
            xd = x.d;
            // Infinity/NaN.
            if (!xd) return x;
            // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
            // w: the word of xd containing rd, a base 1e7 number.
            // xdi: the index of w within xd.
            // digits: the number of digits of w.
            // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
            // they had leading zeros)
            // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
            // Get the length of the first word of the digits array xd.
            for(digits = 1, k = xd[0]; k >= 10; k /= 10)digits++;
            i = sd - digits;
            // Is the rounding digit in the first word of xd?
            if (i < 0) {
                i += LOG_BASE;
                j = sd;
                w = xd[xdi = 0];
                // Get the rounding digit at index j of w.
                rd = w / mathpow(10, digits - j - 1) % 10 | 0;
            } else {
                xdi = Math.ceil((i + 1) / LOG_BASE);
                k = xd.length;
                if (xdi >= k) {
                    if (isTruncated) {
                        // Needed by `naturalExponential`, `naturalLogarithm` and `squareRoot`.
                        for(; k++ <= xdi;)xd.push(0);
                        w = rd = 0;
                        digits = 1;
                        i %= LOG_BASE;
                        j = i - LOG_BASE + 1;
                    } else break out;
                } else {
                    w = k = xd[xdi];
                    // Get the number of digits of w.
                    for(digits = 1; k >= 10; k /= 10)digits++;
                    // Get the index of rd within w.
                    i %= LOG_BASE;
                    // Get the index of rd within w, adjusted for leading zeros.
                    // The number of leading zeros of w is given by LOG_BASE - digits.
                    j = i - LOG_BASE + digits;
                    // Get the rounding digit at index j of w.
                    rd = j < 0 ? 0 : w / mathpow(10, digits - j - 1) % 10 | 0;
                }
            }
            // Are there any non-zero digits after the rounding digit?
            isTruncated = isTruncated || sd < 0 || xd[xdi + 1] !== void 0 || (j < 0 ? w : w % mathpow(10, digits - j - 1));
            // The expression `w % mathpow(10, digits - j - 1)` returns all the digits of w to the right
            // of the digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression
            // will give 714.
            roundUp = rm < 4 ? (rd || isTruncated) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || isTruncated || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, digits - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
            if (sd < 1 || !xd[0]) {
                xd.length = 0;
                if (roundUp) {
                    // Convert sd to decimal places.
                    sd -= x.e + 1;
                    // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                    xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                    x.e = -sd || 0;
                } else // Zero.
                xd[0] = x.e = 0;
                return x;
            }
            // Remove excess digits.
            if (i == 0) {
                xd.length = xdi;
                k = 1;
                xdi--;
            } else {
                xd.length = xdi + 1;
                k = mathpow(10, LOG_BASE - i);
                // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                // j > 0 means i > number of leading zeros of w.
                xd[xdi] = j > 0 ? (w / mathpow(10, digits - j) % mathpow(10, j) | 0) * k : 0;
            }
            if (roundUp) {
                for(;;)// Is the digit to be rounded up in the first word of xd?
                if (xdi == 0) {
                    // i will be the length of xd[0] before k is added.
                    for(i = 1, j = xd[0]; j >= 10; j /= 10)i++;
                    j = xd[0] += k;
                    for(k = 1; j >= 10; j /= 10)k++;
                    // if i != k the length has increased.
                    if (i != k) {
                        x.e++;
                        if (xd[0] == BASE) xd[0] = 1;
                    }
                    break;
                } else {
                    xd[xdi] += k;
                    if (xd[xdi] != BASE) break;
                    xd[xdi--] = 0;
                    k = 1;
                }
            }
            // Remove trailing zeros.
            for(i = xd.length; xd[--i] === 0;)xd.pop();
        }
        if (external) {
            // Overflow?
            if (x.e > Ctor.maxE) {
                // Infinity.
                x.d = null;
                x.e = NaN;
            // Underflow?
            } else if (x.e < Ctor.minE) {
                // Zero.
                x.e = 0;
                x.d = [
                    0
                ];
            // Ctor.underflow = true;
            } // else Ctor.underflow = false;
        }
        return x;
    }
    function finiteToString(x, isExp, sd) {
        if (!x.isFinite()) return nonFiniteToString(x);
        var k, e = x.e, str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + "." + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + "." + str.slice(1);
            str = str + (x.e < 0 ? "e" : "e+") + x.e;
        } else if (e < 0) {
            str = "0." + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + "." + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + "." + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += ".";
                str += getZeroString(k);
            }
        }
        return str;
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(digits, e) {
        var w = digits[0];
        // Add the number of digits of the first word of the digits array.
        for(e *= LOG_BASE; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > LN10_PRECISION) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(precisionLimitExceeded);
        }
        return finalise(new Ctor(LN10), sd, 1, true);
    }
    function getPi(Ctor, sd, rm) {
        if (sd > PI_PRECISION) throw Error(precisionLimitExceeded);
        return finalise(new Ctor(PI), sd, rm, true);
    }
    function getPrecision(digits) {
        var w = digits.length - 1, len = w * LOG_BASE + 1;
        w = digits[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)len--;
            // Add the number of digits of the first word.
            for(w = digits[0]; w >= 10; w /= 10)len++;
        }
        return len;
    }
    function getZeroString(k) {
        var zs = "";
        for(; k--;)zs += "0";
        return zs;
    }
    /*
   * Return a new Decimal whose value is the value of Decimal `x` to the power `n`, where `n` is an
   * integer of type number.
   *
   * Implements 'exponentiation by squaring'. Called by `pow` and `parseOther`.
   *
   */ function intPow(Ctor, x, n, pr) {
        var isTruncated, r = new Ctor(1), // Max n of 9007199254740991 takes 53 loop iterations.
        // Maximum digits array length; leaves [28, 34] guard digits.
        k = Math.ceil(pr / LOG_BASE + 4);
        external = false;
        for(;;){
            if (n % 2) {
                r = r.times(x);
                if (truncate(r.d, k)) isTruncated = true;
            }
            n = mathfloor(n / 2);
            if (n === 0) {
                // To ensure correct rounding when r.d is truncated, increment the last word if it is zero.
                n = r.d.length - 1;
                if (isTruncated && r.d[n] === 0) ++r.d[n];
                break;
            }
            x = x.times(x);
            truncate(x.d, k);
        }
        external = true;
        return r;
    }
    function isOdd(n) {
        return n.d[n.d.length - 1] & 1;
    }
    /*
   * Handle `max` and `min`. `ltgt` is 'lt' or 'gt'.
   */ function maxOrMin(Ctor, args, ltgt) {
        var y, x = new Ctor(args[0]), i = 0;
        for(; ++i < args.length;){
            y = new Ctor(args[i]);
            if (!y.s) {
                x = y;
                break;
            } else if (x[ltgt](y)) x = y;
        }
        return x;
    }
    /*
   * Return a new Decimal whose value is the natural exponential of `x` rounded to `sd` significant
   * digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * Max integer argument: exp('20723265836946413') = 6.3e+9000000000000000
   * Min integer argument: exp('-20723265836946411') = 1.2e-9000000000000000
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(Infinity)  = Infinity
   *  exp(-Infinity) = 0
   *  exp(NaN)       = NaN
   *  exp(±0)        = 1
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   *  The result will always be correctly rounded.
   *
   */ function naturalExponential(x, sd) {
        var denominator, guard, j, pow, sum, t, wpr, rep = 0, i = 0, k = 0, Ctor = x.constructor, rm = Ctor.rounding, pr = Ctor.precision;
        // 0/NaN/Infinity?
        if (!x.d || !x.d[0] || x.e > 17) return new Ctor(x.d ? !x.d[0] ? 1 : x.s < 0 ? 0 : 1 / 0 : x.s ? x.s < 0 ? 0 : x : 0 / 0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        // while abs(x) >= 0.1
        while(x.e > -2){
            // x = x / 2^5
            x = x.times(t);
            k += 5;
        }
        // Use 2 * log10(2^k) + 5 (empirically derived) to estimate the increase in precision
        // necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(1);
        Ctor.precision = wpr;
        for(;;){
            pow = finalise(pow.times(x), wpr, 1);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr, 1));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                j = k;
                while(j--)sum = finalise(sum.times(sum), wpr, 1);
                // Check to see if the first 4 rounding digits are [49]999.
                // If so, repeat the summation with a higher precision, otherwise
                // e.g. with precision: 18, rounding: 1
                // exp(18.404272462595034083567793919843761) = 98372560.1229999999 (should be 98372560.123)
                // `wpr - guard` is the index of first rounding digit.
                if (sd == null) {
                    if (rep < 3 && checkRoundingDigits(sum.d, wpr - guard, rm, rep)) {
                        Ctor.precision = wpr += 10;
                        denominator = pow = t = new Ctor(1);
                        i = 0;
                        rep++;
                    } else return finalise(sum, Ctor.precision = pr, rm, external = true);
                } else {
                    Ctor.precision = pr;
                    return sum;
                }
            }
            sum = t;
        }
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` rounded to `sd` significant
   * digits.
   *
   *  ln(-n)        = NaN
   *  ln(0)         = -Infinity
   *  ln(-0)        = -Infinity
   *  ln(1)         = 0
   *  ln(Infinity)  = Infinity
   *  ln(-Infinity) = NaN
   *  ln(NaN)       = NaN
   *
   *  ln(n) (n != 1) is non-terminating.
   *
   */ function naturalLogarithm(y, sd) {
        var c, c0, denominator, e, numerator, rep, sum, t, wpr, x1, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, rm = Ctor.rounding, pr = Ctor.precision;
        // Is x negative or Infinity, NaN, 0 or 1?
        if (x.s < 0 || !xd || !xd[0] || !x.e && xd[0] == 1 && xd.length == 1) return new Ctor(xd && !xd[0] ? -1 / 0 : x.s != 1 ? NaN : xd ? 0 : x);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        Ctor.precision = wpr += guard;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        if (Math.abs(e = x.e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = x.e;
            if (c0 > 1) {
                x = new Ctor("0." + c);
                e++;
            } else x = new Ctor(c0 + "." + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + "");
            x = naturalLogarithm(new Ctor(c0 + "." + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? finalise(x, pr, rm, external = true) : x;
        }
        // x1 is x reduced to a value near 1.
        x1 = x;
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(1), x.plus(1), wpr, 1);
        x2 = finalise(x.times(x), wpr, 1);
        denominator = 3;
        for(;;){
            numerator = finalise(numerator.times(x2), wpr, 1);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr, 1));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction. Check that e is not 0 because, besides preventing an
                // unnecessary calculation, -0 + 0 = +0 and to ensure correct rounding -0 needs to stay -0.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ""));
                sum = divide(sum, new Ctor(n), wpr, 1);
                // Is rm > 3 and the first 4 rounding digits 4999, or rm < 4 (or the summation has
                // been repeated previously) and the first 4 rounding digits 9999?
                // If so, restart the summation with a higher precision, otherwise
                // e.g. with precision: 12, rounding: 1
                // ln(135520028.6126091714265381533) = 18.7246299999 when it should be 18.72463.
                // `wpr - guard` is the index of first rounding digit.
                if (sd == null) {
                    if (checkRoundingDigits(sum.d, wpr - guard, rm, rep)) {
                        Ctor.precision = wpr += guard;
                        t = numerator = x = divide(x1.minus(1), x1.plus(1), wpr, 1);
                        x2 = finalise(x.times(x), wpr, 1);
                        denominator = rep = 1;
                    } else return finalise(sum, Ctor.precision = pr, rm, external = true);
                } else {
                    Ctor.precision = pr;
                    return sum;
                }
            }
            sum = t;
            denominator += 2;
        }
    }
    // ±Infinity, NaN.
    function nonFiniteToString(x) {
        // Unsigned.
        return String(x.s * x.s / 0);
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // Decimal point?
        if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48; i++);
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48; --len);
        str = str.slice(i, len);
        if (str) {
            len -= i;
            x.e = e = e - i - 1;
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += "0";
            x.d.push(+str);
            if (external) {
                // Overflow?
                if (x.e > x.constructor.maxE) {
                    // Infinity.
                    x.d = null;
                    x.e = NaN;
                // Underflow?
                } else if (x.e < x.constructor.minE) {
                    // Zero.
                    x.e = 0;
                    x.d = [
                        0
                    ];
                // x.constructor.underflow = true;
                } // else x.constructor.underflow = false;
            }
        } else {
            // Zero.
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Parse the value of a new Decimal `x` from a string `str`, which is not a decimal value.
   */ function parseOther(x, str) {
        var base, Ctor, divisor, i, isFloat, len, p, xd, xe;
        if (str.indexOf("_") > -1) {
            str = str.replace(/(\d)_(?=\d)/g, "$1");
            if (isDecimal.test(str)) return parseDecimal(x, str);
        } else if (str === "Infinity" || str === "NaN") {
            if (!+str) x.s = NaN;
            x.e = NaN;
            x.d = null;
            return x;
        }
        if (isHex.test(str)) {
            base = 16;
            str = str.toLowerCase();
        } else if (isBinary.test(str)) base = 2;
        else if (isOctal.test(str)) base = 8;
        else throw Error(invalidArgument + str);
        // Is there a binary exponent part?
        i = str.search(/p/i);
        if (i > 0) {
            p = +str.slice(i + 1);
            str = str.substring(2, i);
        } else str = str.slice(2);
        // Convert `str` as an integer then divide the result by `base` raised to a power such that the
        // fraction part will be restored.
        i = str.indexOf(".");
        isFloat = i >= 0;
        Ctor = x.constructor;
        if (isFloat) {
            str = str.replace(".", "");
            len = str.length;
            i = len - i;
            // log[10](16) = 1.2041... , log[10](88) = 1.9444....
            divisor = intPow(Ctor, new Ctor(base), i, i * 2);
        }
        xd = convertBase(str, base, BASE);
        xe = xd.length - 1;
        // Remove trailing zeros.
        for(i = xe; xd[i] === 0; --i)xd.pop();
        if (i < 0) return new Ctor(x.s * 0);
        x.e = getBase10Exponent(xd, xe);
        x.d = xd;
        external = false;
        // At what precision to perform the division to ensure exact conversion?
        // maxDecimalIntegerPartDigitCount = ceil(log[10](b) * otherBaseIntegerPartDigitCount)
        // log[10](2) = 0.30103, log[10](8) = 0.90309, log[10](16) = 1.20412
        // E.g. ceil(1.2 * 3) = 4, so up to 4 decimal digits are needed to represent 3 hex int digits.
        // maxDecimalFractionPartDigitCount = {Hex:4|Oct:3|Bin:1} * otherBaseFractionPartDigitCount
        // Therefore using 4 * the number of digits of str will always be enough.
        if (isFloat) x = divide(x, divisor, len * 4);
        // Multiply by the binary exponent part if present.
        if (p) x = x.times(Math.abs(p) < 54 ? mathpow(2, p) : Decimal.pow(2, p));
        external = true;
        return x;
    }
    /*
   * sin(x) = x - x^3/3! + x^5/5! - ...
   * |x| < pi/2
   *
   */ function sine(Ctor, x) {
        var k, len = x.d.length;
        if (len < 3) return x.isZero() ? x : taylorSeries(Ctor, 2, x, x);
        // Argument reduction: sin(5x) = 16*sin^5(x) - 20*sin^3(x) + 5*sin(x)
        // i.e. sin(x) = 16*sin^5(x/5) - 20*sin^3(x/5) + 5*sin(x/5)
        // and  sin(x) = sin(x/5)(5 + sin^2(x/5)(16sin^2(x/5) - 20))
        // Estimate the optimum number of times to use the argument reduction.
        k = 1.4 * Math.sqrt(len);
        k = k > 16 ? 16 : k | 0;
        x = x.times(1 / tinyPow(5, k));
        x = taylorSeries(Ctor, 2, x, x);
        // Reverse argument reduction
        var sin2_x, d5 = new Ctor(5), d16 = new Ctor(16), d20 = new Ctor(20);
        for(; k--;){
            sin2_x = x.times(x);
            x = x.times(d5.plus(sin2_x.times(d16.times(sin2_x).minus(d20))));
        }
        return x;
    }
    // Calculate Taylor series for `cos`, `cosh`, `sin` and `sinh`.
    function taylorSeries(Ctor, n, x, y, isHyperbolic) {
        var j, t, u, x2, i = 1, pr = Ctor.precision, k = Math.ceil(pr / LOG_BASE);
        external = false;
        x2 = x.times(x);
        u = new Ctor(y);
        for(;;){
            t = divide(u.times(x2), new Ctor(n++ * n++), pr, 1);
            u = isHyperbolic ? y.plus(t) : y.minus(t);
            y = divide(t.times(x2), new Ctor(n++ * n++), pr, 1);
            t = u.plus(y);
            if (t.d[k] !== void 0) {
                for(j = k; t.d[j] === u.d[j] && j--;);
                if (j == -1) break;
            }
            j = u;
            u = y;
            y = t;
            t = j;
            i++;
        }
        external = true;
        t.d.length = k + 1;
        return t;
    }
    // Exponent e must be positive and non-zero.
    function tinyPow(b, e) {
        var n = b;
        while(--e)n *= b;
        return n;
    }
    // Return the absolute value of `x` reduced to less than or equal to half pi.
    function toLessThanHalfPi(Ctor, x) {
        var t, isNeg = x.s < 0, pi = getPi(Ctor, Ctor.precision, 1), halfPi = pi.times(0.5);
        x = x.abs();
        if (x.lte(halfPi)) {
            quadrant = isNeg ? 4 : 1;
            return x;
        }
        t = x.divToInt(pi);
        if (t.isZero()) quadrant = isNeg ? 3 : 2;
        else {
            x = x.minus(t.times(pi));
            // 0 <= x < pi
            if (x.lte(halfPi)) {
                quadrant = isOdd(t) ? isNeg ? 2 : 3 : isNeg ? 4 : 1;
                return x;
            }
            quadrant = isOdd(t) ? isNeg ? 1 : 4 : isNeg ? 3 : 2;
        }
        return x.minus(pi).abs();
    }
    /*
   * Return the value of Decimal `x` as a string in base `baseOut`.
   *
   * If the optional `sd` argument is present include a binary exponent suffix.
   */ function toStringBinary(x, baseOut, sd, rm) {
        var base, e, i, k, len, roundUp, str, xd, y, Ctor = x.constructor, isExp = sd !== void 0;
        if (isExp) {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        } else {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        }
        if (!x.isFinite()) str = nonFiniteToString(x);
        else {
            str = finiteToString(x);
            i = str.indexOf(".");
            // Use exponential notation according to `toExpPos` and `toExpNeg`? No, but if required:
            // maxBinaryExponent = floor((decimalExponent + 1) * log[2](10))
            // minBinaryExponent = floor(decimalExponent * log[2](10))
            // log[2](10) = 3.321928094887362347870319429489390175864
            if (isExp) {
                base = 2;
                if (baseOut == 16) sd = sd * 4 - 3;
                else if (baseOut == 8) sd = sd * 3 - 2;
            } else base = baseOut;
            // Convert the number as an integer then divide the result by its base raised to a power such
            // that the fraction part will be restored.
            // Non-integer.
            if (i >= 0) {
                str = str.replace(".", "");
                y = new Ctor(1);
                y.e = str.length - i;
                y.d = convertBase(finiteToString(y), 10, base);
                y.e = y.d.length;
            }
            xd = convertBase(str, 10, base);
            e = len = xd.length;
            // Remove trailing zeros.
            for(; xd[--len] == 0;)xd.pop();
            if (!xd[0]) str = isExp ? "0p+0" : "0";
            else {
                if (i < 0) e--;
                else {
                    x = new Ctor(x);
                    x.d = xd;
                    x.e = e;
                    x = divide(x, y, sd, rm, 0, base);
                    xd = x.d;
                    e = x.e;
                    roundUp = inexact;
                }
                // The rounding digit, i.e. the digit after the digit that may be rounded up.
                i = xd[sd];
                k = base / 2;
                roundUp = roundUp || xd[sd + 1] !== void 0;
                roundUp = rm < 4 ? (i !== void 0 || roundUp) && (rm === 0 || rm === (x.s < 0 ? 3 : 2)) : i > k || i === k && (rm === 4 || roundUp || rm === 6 && xd[sd - 1] & 1 || rm === (x.s < 0 ? 8 : 7));
                xd.length = sd;
                if (roundUp) // Rounding up may mean the previous digit has to be rounded up and so on.
                for(; ++xd[--sd] > base - 1;){
                    xd[sd] = 0;
                    if (!sd) {
                        ++e;
                        xd.unshift(1);
                    }
                }
                // Determine trailing zeros.
                for(len = xd.length; !xd[len - 1]; --len);
                // E.g. [4, 11, 15] becomes 4bf.
                for(i = 0, str = ""; i < len; i++)str += NUMERALS.charAt(xd[i]);
                // Add binary exponent suffix?
                if (isExp) {
                    if (len > 1) {
                        if (baseOut == 16 || baseOut == 8) {
                            i = baseOut == 16 ? 4 : 3;
                            for(--len; len % i; len++)str += "0";
                            xd = convertBase(str, base, baseOut);
                            for(len = xd.length; !xd[len - 1]; --len);
                            // xd[0] will always be be 1
                            for(i = 1, str = "1."; i < len; i++)str += NUMERALS.charAt(xd[i]);
                        } else str = str.charAt(0) + "." + str.slice(1);
                    }
                    str = str + (e < 0 ? "p" : "p+") + e;
                } else if (e < 0) {
                    for(; ++e;)str = "0" + str;
                    str = "0." + str;
                } else {
                    if (++e > len) for(e -= len; e--;)str += "0";
                    else if (e < len) str = str.slice(0, e) + "." + str.slice(e);
                }
            }
            str = (baseOut == 16 ? "0x" : baseOut == 2 ? "0b" : baseOut == 8 ? "0o" : "") + str;
        }
        return x.s < 0 ? "-" + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  abs
   *  acos
   *  acosh
   *  add
   *  asin
   *  asinh
   *  atan
   *  atanh
   *  atan2
   *  cbrt
   *  ceil
   *  clamp
   *  clone
   *  config
   *  cos
   *  cosh
   *  div
   *  exp
   *  floor
   *  hypot
   *  ln
   *  log
   *  log2
   *  log10
   *  max
   *  min
   *  mod
   *  mul
   *  pow
   *  random
   *  round
   *  set
   *  sign
   *  sin
   *  sinh
   *  sqrt
   *  sub
   *  sum
   *  tan
   *  tanh
   *  trunc
   */ /*
   * Return a new Decimal whose value is the absolute value of `x`.
   *
   * x {number|string|Decimal}
   *
   */ function abs(x) {
        return new this(x).abs();
    }
    /*
   * Return a new Decimal whose value is the arccosine in radians of `x`.
   *
   * x {number|string|Decimal}
   *
   */ function acos(x) {
        return new this(x).acos();
    }
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic cosine of `x`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function acosh(x) {
        return new this(x).acosh();
    }
    /*
   * Return a new Decimal whose value is the sum of `x` and `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function add(x, y) {
        return new this(x).plus(y);
    }
    /*
   * Return a new Decimal whose value is the arcsine in radians of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function asin(x) {
        return new this(x).asin();
    }
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic sine of `x`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function asinh(x) {
        return new this(x).asinh();
    }
    /*
   * Return a new Decimal whose value is the arctangent in radians of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function atan(x) {
        return new this(x).atan();
    }
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic tangent of `x`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function atanh(x) {
        return new this(x).atanh();
    }
    /*
   * Return a new Decimal whose value is the arctangent in radians of `y/x` in the range -pi to pi
   * (inclusive), rounded to `precision` significant digits using rounding mode `rounding`.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-pi, pi]
   *
   * y {number|string|Decimal} The y-coordinate.
   * x {number|string|Decimal} The x-coordinate.
   *
   * atan2(±0, -0)               = ±pi
   * atan2(±0, +0)               = ±0
   * atan2(±0, -x)               = ±pi for x > 0
   * atan2(±0, x)                = ±0 for x > 0
   * atan2(-y, ±0)               = -pi/2 for y > 0
   * atan2(y, ±0)                = pi/2 for y > 0
   * atan2(±y, -Infinity)        = ±pi for finite y > 0
   * atan2(±y, +Infinity)        = ±0 for finite y > 0
   * atan2(±Infinity, x)         = ±pi/2 for finite x
   * atan2(±Infinity, -Infinity) = ±3*pi/4
   * atan2(±Infinity, +Infinity) = ±pi/4
   * atan2(NaN, x) = NaN
   * atan2(y, NaN) = NaN
   *
   */ function atan2(y, x) {
        y = new this(y);
        x = new this(x);
        var r, pr = this.precision, rm = this.rounding, wpr = pr + 4;
        // Either NaN
        if (!y.s || !x.s) r = new this(NaN);
        else if (!y.d && !x.d) {
            r = getPi(this, wpr, 1).times(x.s > 0 ? 0.25 : 0.75);
            r.s = y.s;
        // x is ±Infinity or y is ±0
        } else if (!x.d || y.isZero()) {
            r = x.s < 0 ? getPi(this, pr, rm) : new this(0);
            r.s = y.s;
        // y is ±Infinity or x is ±0
        } else if (!y.d || x.isZero()) {
            r = getPi(this, wpr, 1).times(0.5);
            r.s = y.s;
        // Both non-zero and finite
        } else if (x.s < 0) {
            this.precision = wpr;
            this.rounding = 1;
            r = this.atan(divide(y, x, wpr, 1));
            x = getPi(this, wpr, 1);
            this.precision = pr;
            this.rounding = rm;
            r = y.s < 0 ? r.minus(x) : r.plus(x);
        } else r = this.atan(divide(y, x, wpr, 1));
        return r;
    }
    /*
   * Return a new Decimal whose value is the cube root of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function cbrt(x) {
        return new this(x).cbrt();
    }
    /*
   * Return a new Decimal whose value is `x` rounded to an integer using `ROUND_CEIL`.
   *
   * x {number|string|Decimal}
   *
   */ function ceil(x) {
        return finalise(x = new this(x), x.e + 1, 2);
    }
    /*
   * Return a new Decimal whose value is `x` clamped to the range delineated by `min` and `max`.
   *
   * x {number|string|Decimal}
   * min {number|string|Decimal}
   * max {number|string|Decimal}
   *
   */ function clamp(x, min, max) {
        return new this(x).clamp(min, max);
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *   maxE       {number}
   *   minE       {number}
   *   modulo     {number}
   *   crypto     {boolean|number}
   *   defaults   {true}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== "object") throw Error(decimalError + "Object expected");
        var i, p, v, useDefaults = obj.defaults === true, ps = [
            "precision",
            1,
            MAX_DIGITS,
            "rounding",
            0,
            8,
            "toExpNeg",
            -EXP_LIMIT,
            0,
            "toExpPos",
            0,
            EXP_LIMIT,
            "maxE",
            0,
            EXP_LIMIT,
            "minE",
            -EXP_LIMIT,
            0,
            "modulo",
            0,
            9
        ];
        for(i = 0; i < ps.length; i += 3){
            if (p = ps[i], useDefaults) this[p] = DEFAULTS[p];
            if ((v = obj[p]) !== void 0) {
                if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
                else throw Error(invalidArgument + p + ": " + v);
            }
        }
        if (p = "crypto", useDefaults) this[p] = DEFAULTS[p];
        if ((v = obj[p]) !== void 0) {
            if (v === true || v === false || v === 0 || v === 1) {
                if (v) {
                    if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) this[p] = true;
                    else throw Error(cryptoUnavailable);
                } else this[p] = false;
            } else throw Error(invalidArgument + p + ": " + v);
        }
        return this;
    }
    /*
   * Return a new Decimal whose value is the cosine of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function cos(x) {
        return new this(x).cos();
    }
    /*
   * Return a new Decimal whose value is the hyperbolic cosine of `x`, rounded to precision
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function cosh(x) {
        return new this(x).cosh();
    }
    /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * v {number|string|Decimal} A numeric value.
     *
     */ function Decimal(v) {
            var e, i, t, x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(v);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            // Duplicate.
            if (isDecimalInstance(v)) {
                x.s = v.s;
                if (external) {
                    if (!v.d || v.e > Decimal.maxE) {
                        // Infinity.
                        x.e = NaN;
                        x.d = null;
                    } else if (v.e < Decimal.minE) {
                        // Zero.
                        x.e = 0;
                        x.d = [
                            0
                        ];
                    } else {
                        x.e = v.e;
                        x.d = v.d.slice();
                    }
                } else {
                    x.e = v.e;
                    x.d = v.d ? v.d.slice() : v.d;
                }
                return;
            }
            t = typeof v;
            if (t === "number") {
                if (v === 0) {
                    x.s = 1 / v < 0 ? -1 : 1;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                if (v < 0) {
                    v = -v;
                    x.s = -1;
                } else x.s = 1;
                // Fast path for small integers.
                if (v === ~~v && v < 1e7) {
                    for(e = 0, i = v; i >= 10; i /= 10)e++;
                    if (external) {
                        if (e > Decimal.maxE) {
                            x.e = NaN;
                            x.d = null;
                        } else if (e < Decimal.minE) {
                            x.e = 0;
                            x.d = [
                                0
                            ];
                        } else {
                            x.e = e;
                            x.d = [
                                v
                            ];
                        }
                    } else {
                        x.e = e;
                        x.d = [
                            v
                        ];
                    }
                    return;
                // Infinity, NaN.
                } else if (v * 0 !== 0) {
                    if (!v) x.s = NaN;
                    x.e = NaN;
                    x.d = null;
                    return;
                }
                return parseDecimal(x, v.toString());
            } else if (t !== "string") throw Error(invalidArgument + v);
            // Minus sign?
            if ((i = v.charCodeAt(0)) === 45) {
                v = v.slice(1);
                x.s = -1;
            } else {
                // Plus sign?
                if (i === 43) v = v.slice(1);
                x.s = 1;
            }
            return isDecimal.test(v) ? parseDecimal(x, v) : parseOther(x, v);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.EUCLID = 9;
        Decimal.config = Decimal.set = config;
        Decimal.clone = clone;
        Decimal.isDecimal = isDecimalInstance;
        Decimal.abs = abs;
        Decimal.acos = acos;
        Decimal.acosh = acosh; // ES6
        Decimal.add = add;
        Decimal.asin = asin;
        Decimal.asinh = asinh; // ES6
        Decimal.atan = atan;
        Decimal.atanh = atanh; // ES6
        Decimal.atan2 = atan2;
        Decimal.cbrt = cbrt; // ES6
        Decimal.ceil = ceil;
        Decimal.clamp = clamp;
        Decimal.cos = cos;
        Decimal.cosh = cosh; // ES6
        Decimal.div = div;
        Decimal.exp = exp;
        Decimal.floor = floor;
        Decimal.hypot = hypot; // ES6
        Decimal.ln = ln;
        Decimal.log = log;
        Decimal.log10 = log10; // ES6
        Decimal.log2 = log2; // ES6
        Decimal.max = max;
        Decimal.min = min;
        Decimal.mod = mod;
        Decimal.mul = mul;
        Decimal.pow = pow;
        Decimal.random = random;
        Decimal.round = round;
        Decimal.sign = sign; // ES6
        Decimal.sin = sin;
        Decimal.sinh = sinh; // ES6
        Decimal.sqrt = sqrt;
        Decimal.sub = sub;
        Decimal.sum = sum;
        Decimal.tan = tan;
        Decimal.tanh = tanh; // ES6
        Decimal.trunc = trunc; // ES6
        if (obj === void 0) obj = {};
        if (obj) {
            if (obj.defaults !== true) {
                ps = [
                    "precision",
                    "rounding",
                    "toExpNeg",
                    "toExpPos",
                    "maxE",
                    "minE",
                    "modulo",
                    "crypto"
                ];
                for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
            }
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Return a new Decimal whose value is `x` divided by `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function div(x, y) {
        return new this(x).div(y);
    }
    /*
   * Return a new Decimal whose value is the natural exponential of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} The power to which to raise the base of the natural log.
   *
   */ function exp(x) {
        return new this(x).exp();
    }
    /*
   * Return a new Decimal whose value is `x` round to an integer using `ROUND_FLOOR`.
   *
   * x {number|string|Decimal}
   *
   */ function floor(x) {
        return finalise(x = new this(x), x.e + 1, 3);
    }
    /*
   * Return a new Decimal whose value is the square root of the sum of the squares of the arguments,
   * rounded to `precision` significant digits using rounding mode `rounding`.
   *
   * hypot(a, b, ...) = sqrt(a^2 + b^2 + ...)
   *
   * arguments {number|string|Decimal}
   *
   */ function hypot() {
        var i, n, t = new this(0);
        external = false;
        for(i = 0; i < arguments.length;){
            n = new this(arguments[i++]);
            if (!n.d) {
                if (n.s) {
                    external = true;
                    return new this(1 / 0);
                }
                t = n;
            } else if (t.d) t = t.plus(n.times(n));
        }
        external = true;
        return t.sqrt();
    }
    /*
   * Return true if object is a Decimal instance (where Decimal is any Decimal constructor),
   * otherwise return false.
   *
   */ function isDecimalInstance(obj) {
        return obj instanceof Decimal || obj && obj.toStringTag === tag || false;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function ln(x) {
        return new this(x).ln();
    }
    /*
   * Return a new Decimal whose value is the log of `x` to the base `y`, or to base 10 if no base
   * is specified, rounded to `precision` significant digits using rounding mode `rounding`.
   *
   * log[y](x)
   *
   * x {number|string|Decimal} The argument of the logarithm.
   * y {number|string|Decimal} The base of the logarithm.
   *
   */ function log(x, y) {
        return new this(x).log(y);
    }
    /*
   * Return a new Decimal whose value is the base 2 logarithm of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function log2(x) {
        return new this(x).log(2);
    }
    /*
   * Return a new Decimal whose value is the base 10 logarithm of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function log10(x) {
        return new this(x).log(10);
    }
    /*
   * Return a new Decimal whose value is the maximum of the arguments.
   *
   * arguments {number|string|Decimal}
   *
   */ function max() {
        return maxOrMin(this, arguments, "lt");
    }
    /*
   * Return a new Decimal whose value is the minimum of the arguments.
   *
   * arguments {number|string|Decimal}
   *
   */ function min() {
        return maxOrMin(this, arguments, "gt");
    }
    /*
   * Return a new Decimal whose value is `x` modulo `y`, rounded to `precision` significant digits
   * using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function mod(x, y) {
        return new this(x).mod(y);
    }
    /*
   * Return a new Decimal whose value is `x` multiplied by `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function mul(x, y) {
        return new this(x).mul(y);
    }
    /*
   * Return a new Decimal whose value is `x` raised to the power `y`, rounded to precision
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} The base.
   * y {number|string|Decimal} The exponent.
   *
   */ function pow(x, y) {
        return new this(x).pow(y);
    }
    /*
   * Returns a new Decimal with a random value equal to or greater than 0 and less than 1, and with
   * `sd`, or `Decimal.precision` if `sd` is omitted, significant digits (or less if trailing zeros
   * are produced).
   *
   * [sd] {number} Significant digits. Integer, 0 to MAX_DIGITS inclusive.
   *
   */ function random(sd) {
        var d, e, k, n, i = 0, r = new this(1), rd = [];
        if (sd === void 0) sd = this.precision;
        else checkInt32(sd, 1, MAX_DIGITS);
        k = Math.ceil(sd / LOG_BASE);
        if (!this.crypto) for(; i < k;)rd[i++] = Math.random() * 1e7 | 0;
        else if (crypto.getRandomValues) {
            d = crypto.getRandomValues(new Uint32Array(k));
            for(; i < k;){
                n = d[i];
                // 0 <= n < 4294967296
                // Probability n >= 4.29e9, is 4967296 / 4294967296 = 0.00116 (1 in 865).
                if (n >= 4.29e9) d[i] = crypto.getRandomValues(new Uint32Array(1))[0];
                else // 0 <= n <= 4289999999
                // 0 <= (n % 1e7) <= 9999999
                rd[i++] = n % 1e7;
            }
        // Node.js supporting crypto.randomBytes.
        } else if (crypto.randomBytes) {
            // buffer
            d = crypto.randomBytes(k *= 4);
            for(; i < k;){
                // 0 <= n < 2147483648
                n = d[i] + (d[i + 1] << 8) + (d[i + 2] << 16) + ((d[i + 3] & 0x7f) << 24);
                // Probability n >= 2.14e9, is 7483648 / 2147483648 = 0.0035 (1 in 286).
                if (n >= 2.14e9) crypto.randomBytes(4).copy(d, i);
                else {
                    // 0 <= n <= 2139999999
                    // 0 <= (n % 1e7) <= 9999999
                    rd.push(n % 1e7);
                    i += 4;
                }
            }
            i = k / 4;
        } else throw Error(cryptoUnavailable);
        k = rd[--i];
        sd %= LOG_BASE;
        // Convert trailing digits to zeros according to sd.
        if (k && sd) {
            n = mathpow(10, LOG_BASE - sd);
            rd[i] = (k / n | 0) * n;
        }
        // Remove trailing words which are zero.
        for(; rd[i] === 0; i--)rd.pop();
        // Zero?
        if (i < 0) {
            e = 0;
            rd = [
                0
            ];
        } else {
            e = -1;
            // Remove leading words which are zero and adjust exponent accordingly.
            for(; rd[0] === 0; e -= LOG_BASE)rd.shift();
            // Count the digits of the first word of rd to determine leading zeros.
            for(k = 1, n = rd[0]; n >= 10; n /= 10)k++;
            // Adjust the exponent for leading zeros of the first word of rd.
            if (k < LOG_BASE) e -= LOG_BASE - k;
        }
        r.e = e;
        r.d = rd;
        return r;
    }
    /*
   * Return a new Decimal whose value is `x` rounded to an integer using rounding mode `rounding`.
   *
   * To emulate `Math.round`, set rounding to 7 (ROUND_HALF_CEIL).
   *
   * x {number|string|Decimal}
   *
   */ function round(x) {
        return finalise(x = new this(x), x.e + 1, this.rounding);
    }
    /*
   * Return
   *   1    if x > 0,
   *  -1    if x < 0,
   *   0    if x is 0,
   *  -0    if x is -0,
   *   NaN  otherwise
   *
   * x {number|string|Decimal}
   *
   */ function sign(x) {
        x = new this(x);
        return x.d ? x.d[0] ? x.s : 0 * x.s : x.s || NaN;
    }
    /*
   * Return a new Decimal whose value is the sine of `x`, rounded to `precision` significant digits
   * using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function sin(x) {
        return new this(x).sin();
    }
    /*
   * Return a new Decimal whose value is the hyperbolic sine of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function sinh(x) {
        return new this(x).sinh();
    }
    /*
   * Return a new Decimal whose value is the square root of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function sqrt(x) {
        return new this(x).sqrt();
    }
    /*
   * Return a new Decimal whose value is `x` minus `y`, rounded to `precision` significant digits
   * using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function sub(x, y) {
        return new this(x).sub(y);
    }
    /*
   * Return a new Decimal whose value is the sum of the arguments, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * Only the result is rounded, not the intermediate calculations.
   *
   * arguments {number|string|Decimal}
   *
   */ function sum() {
        var i = 0, args = arguments, x = new this(args[i]);
        external = false;
        for(; x.s && ++i < args.length;)x = x.plus(args[i]);
        external = true;
        return finalise(x, this.precision, this.rounding);
    }
    /*
   * Return a new Decimal whose value is the tangent of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function tan(x) {
        return new this(x).tan();
    }
    /*
   * Return a new Decimal whose value is the hyperbolic tangent of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function tanh(x) {
        return new this(x).tanh();
    }
    /*
   * Return a new Decimal whose value is `x` truncated to an integer.
   *
   * x {number|string|Decimal}
   *
   */ function trunc(x) {
        return finalise(x = new this(x), x.e + 1, 1);
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(DEFAULTS);
    Decimal.prototype.constructor = Decimal;
    Decimal["default"] = Decimal.Decimal = Decimal;
    // Create the internal constants from their string values.
    LN10 = new Decimal(LN10);
    PI = new Decimal(PI);
    // Export.
    // AMD.
    if (typeof define == "function" && define.amd) define(function() {
        return Decimal;
    });
    else if (0, module.exports) {
        if (typeof Symbol == "function" && typeof Symbol.iterator == "symbol") {
            P[Symbol["for"]("nodejs.util.inspect.custom")] = P.toString;
            P[Symbol.toStringTag] = "Decimal";
        }
        module.exports = Decimal;
    // Browser.
    } else {
        if (!globalScope) globalScope = typeof self != "undefined" && self && self.self == self ? self : window;
        noConflict = globalScope.Decimal;
        Decimal.noConflict = function() {
            globalScope.Decimal = noConflict;
            return Decimal;
        };
        globalScope.Decimal = Decimal;
    }
})(module.exports);

});


parcelRegister("josr1", function(module, exports) {

$parcel$export(module.exports, "createBitAnd", function () { return $e1e650c334c4a863$export$bea4e06c5befec3b; });

var $1Jf3Z = parcelRequire("1Jf3Z");

var $cITNv = parcelRequire("cITNv");

var $cZfrH = parcelRequire("cZfrH");

var $1bBLS = parcelRequire("1bBLS");

var $iHnaT = parcelRequire("iHnaT");

var $9INF1 = parcelRequire("9INF1");

var $2mPYl = parcelRequire("2mPYl");

var $gVfmZ = parcelRequire("gVfmZ");
var $e1e650c334c4a863$var$name = "bitAnd";
var $e1e650c334c4a863$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar"
];
var $e1e650c334c4a863$export$bea4e06c5befec3b = /* #__PURE__ */ (0, $2mPYl.factory)($e1e650c334c4a863$var$name, $e1e650c334c4a863$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, equalScalar = _ref.equalScalar;
    var algorithm02 = (0, $cITNv.createAlgorithm02)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm06 = (0, $9INF1.createAlgorithm06)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm11 = (0, $cZfrH.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $1bBLS.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $iHnaT.createAlgorithm14)({
        typed: typed
    });
    /**
   * Bitwise AND two values, `x & y`.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.bitAnd(x, y)
   *
   * Examples:
   *
   *    math.bitAnd(53, 131)               // returns number 1
   *
   *    math.bitAnd([1, 12, 31], 42)       // returns Array [0, 8, 10]
   *
   * See also:
   *
   *    bitNot, bitOr, bitXor, leftShift, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | Array | Matrix} x First value to and
   * @param  {number | BigNumber | Array | Matrix} y Second value to and
   * @return {number | BigNumber | Array | Matrix} AND of `x` and `y`
   */ var bitAnd = typed($e1e650c334c4a863$var$name, {
        "number, number": (0, $gVfmZ.bitAndNumber),
        "BigNumber, BigNumber": (0, $1Jf3Z.bitAndBigNumber),
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm06(x, y, bitAnd, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, bitAnd, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm02(x, y, bitAnd, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, bitAnd);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return bitAnd(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return bitAnd(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return bitAnd(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm11(x, y, bitAnd, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, bitAnd, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm11(y, x, bitAnd, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, bitAnd, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, bitAnd, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, bitAnd, true).valueOf();
        }
    });
    return bitAnd;
});

});
parcelRegister("1Jf3Z", function(module, exports) {

$parcel$export(module.exports, "bitAndBigNumber", function () { return $1425adaa2f2468c9$export$94757ce5cf54fec9; });
$parcel$export(module.exports, "bitNotBigNumber", function () { return $1425adaa2f2468c9$export$2ada53b3c51e9645; });
$parcel$export(module.exports, "bitOrBigNumber", function () { return $1425adaa2f2468c9$export$e43ec6c4cff46d2c; });
$parcel$export(module.exports, "bitXor", function () { return $1425adaa2f2468c9$export$bfcff4501301c191; });
$parcel$export(module.exports, "leftShiftBigNumber", function () { return $1425adaa2f2468c9$export$626dff8098a67b4c; });
$parcel$export(module.exports, "rightArithShiftBigNumber", function () { return $1425adaa2f2468c9$export$d489c03691bd4cd; });
/**
 * Bitwise and for Bignumbers
 *
 * Special Cases:
 *   N &  n =  N
 *   n &  0 =  0
 *   n & -1 =  n
 *   n &  n =  n
 *   I &  I =  I
 *  -I & -I = -I
 *   I & -I =  0
 *   I &  n =  n
 *   I & -n =  I
 *  -I &  n =  0
 *  -I & -n = -I
 *
 * @param {BigNumber} x
 * @param {BigNumber} y
 * @return {BigNumber} Result of `x` & `y`, is fully precise
 * @private
 */ function $1425adaa2f2468c9$export$94757ce5cf54fec9(x, y) {
    if (x.isFinite() && !x.isInteger() || y.isFinite() && !y.isInteger()) throw new Error("Integers expected in function bitAnd");
    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN()) return new BigNumber(NaN);
    if (x.isZero() || y.eq(-1) || x.eq(y)) return x;
    if (y.isZero() || x.eq(-1)) return y;
    if (!x.isFinite() || !y.isFinite()) {
        if (!x.isFinite() && !y.isFinite()) {
            if (x.isNegative() === y.isNegative()) return x;
            return new BigNumber(0);
        }
        if (!x.isFinite()) {
            if (y.isNegative()) return x;
            if (x.isNegative()) return new BigNumber(0);
            return y;
        }
        if (!y.isFinite()) {
            if (x.isNegative()) return y;
            if (y.isNegative()) return new BigNumber(0);
            return x;
        }
    }
    return $1425adaa2f2468c9$export$884842863a0853c4(x, y, function(a, b) {
        return a & b;
    });
}
function $1425adaa2f2468c9$export$2ada53b3c51e9645(x) {
    if (x.isFinite() && !x.isInteger()) throw new Error("Integer expected in function bitNot");
    var BigNumber = x.constructor;
    var prevPrec = BigNumber.precision;
    BigNumber.config({
        precision: 1E9
    });
    var result = x.plus(new BigNumber(1));
    result.s = -result.s || null;
    BigNumber.config({
        precision: prevPrec
    });
    return result;
}
function $1425adaa2f2468c9$export$e43ec6c4cff46d2c(x, y) {
    if (x.isFinite() && !x.isInteger() || y.isFinite() && !y.isInteger()) throw new Error("Integers expected in function bitOr");
    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN()) return new BigNumber(NaN);
    var negOne = new BigNumber(-1);
    if (x.isZero() || y.eq(negOne) || x.eq(y)) return y;
    if (y.isZero() || x.eq(negOne)) return x;
    if (!x.isFinite() || !y.isFinite()) {
        if (!x.isFinite() && !x.isNegative() && y.isNegative() || x.isNegative() && !y.isNegative() && !y.isFinite()) return negOne;
        if (x.isNegative() && y.isNegative()) return x.isFinite() ? x : y;
        return x.isFinite() ? y : x;
    }
    return $1425adaa2f2468c9$export$884842863a0853c4(x, y, function(a, b) {
        return a | b;
    });
}
function $1425adaa2f2468c9$export$884842863a0853c4(x, y, func) {
    var BigNumber = x.constructor;
    var xBits, yBits;
    var xSign = +(x.s < 0);
    var ySign = +(y.s < 0);
    if (xSign) {
        xBits = $1425adaa2f2468c9$var$decCoefficientToBinaryString($1425adaa2f2468c9$export$2ada53b3c51e9645(x));
        for(var i = 0; i < xBits.length; ++i)xBits[i] ^= 1;
    } else xBits = $1425adaa2f2468c9$var$decCoefficientToBinaryString(x);
    if (ySign) {
        yBits = $1425adaa2f2468c9$var$decCoefficientToBinaryString($1425adaa2f2468c9$export$2ada53b3c51e9645(y));
        for(var _i = 0; _i < yBits.length; ++_i)yBits[_i] ^= 1;
    } else yBits = $1425adaa2f2468c9$var$decCoefficientToBinaryString(y);
    var minBits, maxBits, minSign;
    if (xBits.length <= yBits.length) {
        minBits = xBits;
        maxBits = yBits;
        minSign = xSign;
    } else {
        minBits = yBits;
        maxBits = xBits;
        minSign = ySign;
    }
    var shortLen = minBits.length;
    var longLen = maxBits.length;
    var expFuncVal = func(xSign, ySign) ^ 1;
    var outVal = new BigNumber(expFuncVal ^ 1);
    var twoPower = new BigNumber(1);
    var two = new BigNumber(2);
    var prevPrec = BigNumber.precision;
    BigNumber.config({
        precision: 1E9
    });
    while(shortLen > 0){
        if (func(minBits[--shortLen], maxBits[--longLen]) === expFuncVal) outVal = outVal.plus(twoPower);
        twoPower = twoPower.times(two);
    }
    while(longLen > 0){
        if (func(minSign, maxBits[--longLen]) === expFuncVal) outVal = outVal.plus(twoPower);
        twoPower = twoPower.times(two);
    }
    BigNumber.config({
        precision: prevPrec
    });
    if (expFuncVal === 0) outVal.s = -outVal.s;
    return outVal;
}
/* Extracted from decimal.js, and edited to specialize. */ function $1425adaa2f2468c9$var$decCoefficientToBinaryString(x) {
    // Convert to string
    var a = x.d; // array with digits
    var r = a[0] + "";
    for(var i = 1; i < a.length; ++i){
        var s = a[i] + "";
        for(var z = 7 - s.length; z--;)s = "0" + s;
        r += s;
    }
    var j = r.length;
    while(r.charAt(j) === "0")j--;
    var xe = x.e;
    var str = r.slice(0, j + 1 || 1);
    var strL = str.length;
    if (xe > 0) {
        if (++xe > strL) {
            // Append zeros.
            xe -= strL;
            while(xe--)str += "0";
        } else if (xe < strL) str = str.slice(0, xe) + "." + str.slice(xe);
    } // Convert from base 10 (decimal) to base 2
    var arr = [
        0
    ];
    for(var _i2 = 0; _i2 < str.length;){
        var arrL = arr.length;
        while(arrL--)arr[arrL] *= 10;
        arr[0] += parseInt(str.charAt(_i2++)); // convert to int
        for(var _j = 0; _j < arr.length; ++_j)if (arr[_j] > 1) {
            if (arr[_j + 1] === null || arr[_j + 1] === undefined) arr[_j + 1] = 0;
            arr[_j + 1] += arr[_j] >> 1;
            arr[_j] &= 1;
        }
    }
    return arr.reverse();
}
function $1425adaa2f2468c9$export$bfcff4501301c191(x, y) {
    if (x.isFinite() && !x.isInteger() || y.isFinite() && !y.isInteger()) throw new Error("Integers expected in function bitXor");
    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN()) return new BigNumber(NaN);
    if (x.isZero()) return y;
    if (y.isZero()) return x;
    if (x.eq(y)) return new BigNumber(0);
    var negOne = new BigNumber(-1);
    if (x.eq(negOne)) return $1425adaa2f2468c9$export$2ada53b3c51e9645(y);
    if (y.eq(negOne)) return $1425adaa2f2468c9$export$2ada53b3c51e9645(x);
    if (!x.isFinite() || !y.isFinite()) {
        if (!x.isFinite() && !y.isFinite()) return negOne;
        return new BigNumber(x.isNegative() === y.isNegative() ? Infinity : -Infinity);
    }
    return $1425adaa2f2468c9$export$884842863a0853c4(x, y, function(a, b) {
        return a ^ b;
    });
}
function $1425adaa2f2468c9$export$626dff8098a67b4c(x, y) {
    if (x.isFinite() && !x.isInteger() || y.isFinite() && !y.isInteger()) throw new Error("Integers expected in function leftShift");
    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN() || y.isNegative() && !y.isZero()) return new BigNumber(NaN);
    if (x.isZero() || y.isZero()) return x;
    if (!x.isFinite() && !y.isFinite()) return new BigNumber(NaN);
     // Math.pow(2, y) is fully precise for y < 55, and fast
    if (y.lt(55)) return x.times(Math.pow(2, y.toNumber()) + "");
    return x.times(new BigNumber(2).pow(y));
}
function $1425adaa2f2468c9$export$d489c03691bd4cd(x, y) {
    if (x.isFinite() && !x.isInteger() || y.isFinite() && !y.isInteger()) throw new Error("Integers expected in function rightArithShift");
    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN() || y.isNegative() && !y.isZero()) return new BigNumber(NaN);
    if (x.isZero() || y.isZero()) return x;
    if (!y.isFinite()) {
        if (x.isNegative()) return new BigNumber(-1);
        if (!x.isFinite()) return new BigNumber(NaN);
        return new BigNumber(0);
    } // Math.pow(2, y) is fully precise for y < 55, and fast
    if (y.lt(55)) return x.div(Math.pow(2, y.toNumber()) + "").floor();
    return x.div(new BigNumber(2).pow(y)).floor();
}

});

parcelRegister("gVfmZ", function(module, exports) {

$parcel$export(module.exports, "bitAndNumber", function () { return $c51de450b9dd4660$export$e7607930867bd49a; });
$parcel$export(module.exports, "bitNotNumber", function () { return $c51de450b9dd4660$export$22a2b2a0351218e7; });
$parcel$export(module.exports, "bitOrNumber", function () { return $c51de450b9dd4660$export$9aecb772cb5ad1c7; });
$parcel$export(module.exports, "bitXorNumber", function () { return $c51de450b9dd4660$export$2260a44ec1c987dc; });
$parcel$export(module.exports, "leftShiftNumber", function () { return $c51de450b9dd4660$export$65c07a47901525ba; });
$parcel$export(module.exports, "rightArithShiftNumber", function () { return $c51de450b9dd4660$export$b6d96f775be90000; });
$parcel$export(module.exports, "rightLogShiftNumber", function () { return $c51de450b9dd4660$export$2a8d1e3dcede6e47; });

var $kFRKb = parcelRequire("kFRKb");
var $c51de450b9dd4660$var$n1 = "number";
var $c51de450b9dd4660$var$n2 = "number, number";
function $c51de450b9dd4660$export$e7607930867bd49a(x, y) {
    if (!(0, $kFRKb.isInteger)(x) || !(0, $kFRKb.isInteger)(y)) throw new Error("Integers expected in function bitAnd");
    return x & y;
}
$c51de450b9dd4660$export$e7607930867bd49a.signature = $c51de450b9dd4660$var$n2;
function $c51de450b9dd4660$export$22a2b2a0351218e7(x) {
    if (!(0, $kFRKb.isInteger)(x)) throw new Error("Integer expected in function bitNot");
    return ~x;
}
$c51de450b9dd4660$export$22a2b2a0351218e7.signature = $c51de450b9dd4660$var$n1;
function $c51de450b9dd4660$export$9aecb772cb5ad1c7(x, y) {
    if (!(0, $kFRKb.isInteger)(x) || !(0, $kFRKb.isInteger)(y)) throw new Error("Integers expected in function bitOr");
    return x | y;
}
$c51de450b9dd4660$export$9aecb772cb5ad1c7.signature = $c51de450b9dd4660$var$n2;
function $c51de450b9dd4660$export$2260a44ec1c987dc(x, y) {
    if (!(0, $kFRKb.isInteger)(x) || !(0, $kFRKb.isInteger)(y)) throw new Error("Integers expected in function bitXor");
    return x ^ y;
}
$c51de450b9dd4660$export$2260a44ec1c987dc.signature = $c51de450b9dd4660$var$n2;
function $c51de450b9dd4660$export$65c07a47901525ba(x, y) {
    if (!(0, $kFRKb.isInteger)(x) || !(0, $kFRKb.isInteger)(y)) throw new Error("Integers expected in function leftShift");
    return x << y;
}
$c51de450b9dd4660$export$65c07a47901525ba.signature = $c51de450b9dd4660$var$n2;
function $c51de450b9dd4660$export$b6d96f775be90000(x, y) {
    if (!(0, $kFRKb.isInteger)(x) || !(0, $kFRKb.isInteger)(y)) throw new Error("Integers expected in function rightArithShift");
    return x >> y;
}
$c51de450b9dd4660$export$b6d96f775be90000.signature = $c51de450b9dd4660$var$n2;
function $c51de450b9dd4660$export$2a8d1e3dcede6e47(x, y) {
    if (!(0, $kFRKb.isInteger)(x) || !(0, $kFRKb.isInteger)(y)) throw new Error("Integers expected in function rightLogShift");
    return x >>> y;
}
$c51de450b9dd4660$export$2a8d1e3dcede6e47.signature = $c51de450b9dd4660$var$n2;

});


parcelRegister("iYM8q", function(module, exports) {

$parcel$export(module.exports, "createBitNot", function () { return $dd132b29cdc91858$export$9e7f3c72ca8b5aa; });

var $1Jf3Z = parcelRequire("1Jf3Z");

var $e04i1 = parcelRequire("e04i1");

var $2mPYl = parcelRequire("2mPYl");

var $gVfmZ = parcelRequire("gVfmZ");
var $dd132b29cdc91858$var$name = "bitNot";
var $dd132b29cdc91858$var$dependencies = [
    "typed"
];
var $dd132b29cdc91858$export$9e7f3c72ca8b5aa = /* #__PURE__ */ (0, $2mPYl.factory)($dd132b29cdc91858$var$name, $dd132b29cdc91858$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Bitwise NOT value, `~x`.
   * For matrices, the function is evaluated element wise.
   * For units, the function is evaluated on the best prefix base.
   *
   * Syntax:
   *
   *    math.bitNot(x)
   *
   * Examples:
   *
   *    math.bitNot(1)               // returns number -2
   *
   *    math.bitNot([2, -3, 4])      // returns Array [-3, 2, 5]
   *
   * See also:
   *
   *    bitAnd, bitOr, bitXor, leftShift, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | Array | Matrix} x Value to not
   * @return {number | BigNumber | Array | Matrix} NOT of `x`
   */ var bitNot = typed($dd132b29cdc91858$var$name, {
        number: (0, $gVfmZ.bitNotNumber),
        BigNumber: (0, $1Jf3Z.bitNotBigNumber),
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, bitNot);
        }
    });
    return bitNot;
});

});

parcelRegister("4a9NS", function(module, exports) {

$parcel$export(module.exports, "createBitOr", function () { return $307fb358154fbfb0$export$f45a7846535e9b07; });

var $1Jf3Z = parcelRequire("1Jf3Z");

var $2mPYl = parcelRequire("2mPYl");

var $iHnaT = parcelRequire("iHnaT");

var $1bBLS = parcelRequire("1bBLS");

var $1rFP6 = parcelRequire("1rFP6");

var $5mDFR = parcelRequire("5mDFR");

var $gIOYU = parcelRequire("gIOYU");

var $gVfmZ = parcelRequire("gVfmZ");
var $307fb358154fbfb0$var$name = "bitOr";
var $307fb358154fbfb0$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "DenseMatrix"
];
var $307fb358154fbfb0$export$f45a7846535e9b07 = /* #__PURE__ */ (0, $2mPYl.factory)($307fb358154fbfb0$var$name, $307fb358154fbfb0$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, equalScalar = _ref.equalScalar, DenseMatrix = _ref.DenseMatrix;
    var algorithm01 = (0, $gIOYU.createAlgorithm01)({
        typed: typed
    });
    var algorithm04 = (0, $5mDFR.createAlgorithm04)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm10 = (0, $1rFP6.createAlgorithm10)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $1bBLS.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $iHnaT.createAlgorithm14)({
        typed: typed
    });
    /**
   * Bitwise OR two values, `x | y`.
   * For matrices, the function is evaluated element wise.
   * For units, the function is evaluated on the lowest print base.
   *
   * Syntax:
   *
   *    math.bitOr(x, y)
   *
   * Examples:
   *
   *    math.bitOr(1, 2)               // returns number 3
   *
   *    math.bitOr([1, 2, 3], 4)       // returns Array [5, 6, 7]
   *
   * See also:
   *
   *    bitAnd, bitNot, bitXor, leftShift, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | Array | Matrix} x First value to or
   * @param  {number | BigNumber | Array | Matrix} y Second value to or
   * @return {number | BigNumber | Array | Matrix} OR of `x` and `y`
   */ var bitOr = typed($307fb358154fbfb0$var$name, {
        "number, number": (0, $gVfmZ.bitOrNumber),
        "BigNumber, BigNumber": (0, $1Jf3Z.bitOrBigNumber),
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm04(x, y, bitOr);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm01(y, x, bitOr, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm01(x, y, bitOr, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, bitOr);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return bitOr(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return bitOr(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return bitOr(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm10(x, y, bitOr, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, bitOr, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm10(y, x, bitOr, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, bitOr, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, bitOr, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, bitOr, true).valueOf();
        }
    });
    return bitOr;
});

});

parcelRegister("d2Cqy", function(module, exports) {

$parcel$export(module.exports, "createBitXor", function () { return $97e94523af291db2$export$1cae728fa8e01928; });

var $1Jf3Z = parcelRequire("1Jf3Z");

var $jaKH8 = parcelRequire("jaKH8");

var $awGkR = parcelRequire("awGkR");

var $dNuvz = parcelRequire("dNuvz");

var $1bBLS = parcelRequire("1bBLS");

var $iHnaT = parcelRequire("iHnaT");

var $2mPYl = parcelRequire("2mPYl");

var $gVfmZ = parcelRequire("gVfmZ");
var $97e94523af291db2$var$name = "bitXor";
var $97e94523af291db2$var$dependencies = [
    "typed",
    "matrix",
    "DenseMatrix"
];
var $97e94523af291db2$export$1cae728fa8e01928 = /* #__PURE__ */ (0, $2mPYl.factory)($97e94523af291db2$var$name, $97e94523af291db2$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, DenseMatrix = _ref.DenseMatrix;
    var algorithm03 = (0, $jaKH8.createAlgorithm03)({
        typed: typed
    });
    var algorithm07 = (0, $awGkR.createAlgorithm07)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $dNuvz.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $1bBLS.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $iHnaT.createAlgorithm14)({
        typed: typed
    });
    /**
   * Bitwise XOR two values, `x ^ y`.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.bitXor(x, y)
   *
   * Examples:
   *
   *    math.bitXor(1, 2)               // returns number 3
   *
   *    math.bitXor([2, 3, 4], 4)       // returns Array [6, 7, 0]
   *
   * See also:
   *
   *    bitAnd, bitNot, bitOr, leftShift, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | Array | Matrix} x First value to xor
   * @param  {number | BigNumber | Array | Matrix} y Second value to xor
   * @return {number | BigNumber | Array | Matrix} XOR of `x` and `y`
   */ var bitXor = typed($97e94523af291db2$var$name, {
        "number, number": (0, $gVfmZ.bitXorNumber),
        "BigNumber, BigNumber": (0, $1Jf3Z.bitXor),
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, bitXor);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, bitXor, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, bitXor, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, bitXor);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return bitXor(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return bitXor(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return bitXor(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, bitXor, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, bitXor, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, bitXor, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, bitXor, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, bitXor, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, bitXor, true).valueOf();
        }
    });
    return bitXor;
});

});
parcelRegister("awGkR", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm07", function () { return $7a9dbb80739a7c49$export$b908fb77c4366999; });

var $2mPYl = parcelRequire("2mPYl");

var $hy7Bx = parcelRequire("hy7Bx");
var $7a9dbb80739a7c49$var$name = "algorithm07";
var $7a9dbb80739a7c49$var$dependencies = [
    "typed",
    "DenseMatrix"
];
var $7a9dbb80739a7c49$export$b908fb77c4366999 = /* #__PURE__ */ (0, $2mPYl.factory)($7a9dbb80739a7c49$var$name, $7a9dbb80739a7c49$var$dependencies, function(_ref) {
    var typed = _ref.typed, DenseMatrix = _ref.DenseMatrix;
    /**
   * Iterates over SparseMatrix A and SparseMatrix B items (zero and nonzero) and invokes the callback function f(Aij, Bij).
   * Callback function invoked MxN times.
   *
   * C(i,j) = f(Aij, Bij)
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function algorithm07(a, b, callback) {
        // sparse matrix arrays
        var asize = a._size;
        var adt = a._datatype; // sparse matrix arrays
        var bsize = b._size;
        var bdt = b._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $hy7Bx.DimensionError)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string" && adt === bdt) {
            // datatype
            dt = adt; // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // vars
        var i, j; // result arrays
        var cdata = []; // initialize c
        for(i = 0; i < rows; i++)cdata[i] = [];
         // workspaces
        var xa = [];
        var xb = []; // marks indicating we have a value in x for a given column
        var wa = [];
        var wb = []; // loop columns
        for(j = 0; j < columns; j++){
            // columns mark
            var mark = j + 1; // scatter the values of A(:,j) into workspace
            _scatter(a, j, wa, xa, mark); // scatter the values of B(:,j) into workspace
            _scatter(b, j, wb, xb, mark); // loop rows
            for(i = 0; i < rows; i++){
                // matrix values @ i,j
                var va = wa[i] === mark ? xa[i] : zero;
                var vb = wb[i] === mark ? xb[i] : zero; // invoke callback
                cdata[i][j] = cf(va, vb);
            }
        } // return dense matrix
        return new DenseMatrix({
            data: cdata,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
    function _scatter(m, j, w, x, mark) {
        // a arrays
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr; // loop values in column j
        for(var k = ptr[j], k1 = ptr[j + 1]; k < k1; k++){
            // row
            var i = index[k]; // update workspace
            w[i] = mark;
            x[i] = values[k];
        }
    }
});

});


parcelRegister("fvJuV", function(module, exports) {

$parcel$export(module.exports, "createBoolean", function () { return $b4ad0b2915e133f2$export$3c82aec2d86a5525; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");
var $b4ad0b2915e133f2$var$name = "boolean";
var $b4ad0b2915e133f2$var$dependencies = [
    "typed"
];
var $b4ad0b2915e133f2$export$3c82aec2d86a5525 = /* #__PURE__ */ (0, $2mPYl.factory)($b4ad0b2915e133f2$var$name, $b4ad0b2915e133f2$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Create a boolean or convert a string or number to a boolean.
   * In case of a number, `true` is returned for non-zero numbers, and `false` in
   * case of zero.
   * Strings can be `'true'` or `'false'`, or can contain a number.
   * When value is a matrix, all elements will be converted to boolean.
   *
   * Syntax:
   *
   *    math.boolean(x)
   *
   * Examples:
   *
   *    math.boolean(0)     // returns false
   *    math.boolean(1)     // returns true
   *    math.boolean(-3)     // returns true
   *    math.boolean('true')     // returns true
   *    math.boolean('false')     // returns false
   *    math.boolean([1, 0, 1, 1])     // returns [true, false, true, true]
   *
   * See also:
   *
   *    bignumber, complex, index, matrix, string, unit
   *
   * @param {string | number | boolean | Array | Matrix | null} value  A value of any type
   * @return {boolean | Array | Matrix} The boolean value
   */ var bool = typed($b4ad0b2915e133f2$var$name, {
        "": function _() {
            return false;
        },
        "boolean": function boolean(x) {
            return x;
        },
        number: function number(x) {
            return !!x;
        },
        "null": function _null(x) {
            return false;
        },
        BigNumber: function BigNumber(x) {
            return !x.isZero();
        },
        string: function string(x) {
            // try case insensitive
            var lcase = x.toLowerCase();
            if (lcase === "true") return true;
            else if (lcase === "false") return false;
             // test whether value is a valid number
            var num = Number(x);
            if (x !== "" && !isNaN(num)) return !!num;
            throw new Error('Cannot convert "' + x + '" to a boolean');
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, bool);
        }
    });
    return bool;
});

});

parcelRegister("do5MS", function(module, exports) {

$parcel$export(module.exports, "createCatalan", function () { return $9bf201832bb4666e$export$5a3f7692f3d4dd50; });

var $2mPYl = parcelRequire("2mPYl");
var $9bf201832bb4666e$var$name = "catalan";
var $9bf201832bb4666e$var$dependencies = [
    "typed",
    "addScalar",
    "divideScalar",
    "multiplyScalar",
    "combinations",
    "isNegative",
    "isInteger"
];
var $9bf201832bb4666e$export$5a3f7692f3d4dd50 = /* #__PURE__ */ (0, $2mPYl.factory)($9bf201832bb4666e$var$name, $9bf201832bb4666e$var$dependencies, function(_ref) {
    var typed = _ref.typed, addScalar = _ref.addScalar, divideScalar = _ref.divideScalar, multiplyScalar = _ref.multiplyScalar, combinations = _ref.combinations, isNegative = _ref.isNegative, isInteger = _ref.isInteger;
    /**
   * The Catalan Numbers enumerate combinatorial structures of many different types.
   * catalan only takes integer arguments.
   * The following condition must be enforced: n >= 0
   *
   * Syntax:
   *
   *   math.catalan(n)
   *
   * Examples:
   *
   *    math.catalan(3) // returns 5
   *    math.catalan(8) // returns 1430
   *
   * See also:
   *
   *    bellNumbers
   *
   * @param {Number | BigNumber} n    nth Catalan number
   * @return {Number | BigNumber}     Cn(n)
   */ return typed($9bf201832bb4666e$var$name, {
        "number | BigNumber": function numberBigNumber(n) {
            if (!isInteger(n) || isNegative(n)) throw new TypeError("Non-negative integer value expected in function catalan");
            return divideScalar(combinations(multiplyScalar(n, 2), n), addScalar(n, 1));
        }
    });
});

});

parcelRegister("2jVeI", function(module, exports) {

$parcel$export(module.exports, "createCbrt", function () { return $1b09c11586ad1e13$export$2103fed9c34b0004; });

var $2mPYl = parcelRequire("2mPYl");

var $1amHZ = parcelRequire("1amHZ");

var $e04i1 = parcelRequire("e04i1");

var $6fCew = parcelRequire("6fCew");
var $1b09c11586ad1e13$var$name = "cbrt";
var $1b09c11586ad1e13$var$dependencies = [
    "config",
    "typed",
    "isNegative",
    "unaryMinus",
    "matrix",
    "Complex",
    "BigNumber",
    "Fraction"
];
var $1b09c11586ad1e13$export$2103fed9c34b0004 = /* #__PURE__ */ (0, $2mPYl.factory)($1b09c11586ad1e13$var$name, $1b09c11586ad1e13$var$dependencies, function(_ref) {
    var config = _ref.config, typed = _ref.typed, isNegative = _ref.isNegative, unaryMinus = _ref.unaryMinus, matrix = _ref.matrix, Complex = _ref.Complex, BigNumber = _ref.BigNumber, Fraction = _ref.Fraction;
    /**
   * Calculate the cubic root of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.cbrt(x)
   *    math.cbrt(x, allRoots)
   *
   * Examples:
   *
   *    math.cbrt(27)                  // returns 3
   *    math.cube(3)                   // returns 27
   *    math.cbrt(-64)                 // returns -4
   *    math.cbrt(math.unit('27 m^3')) // returns Unit 3 m
   *    math.cbrt([27, 64, 125])       // returns [3, 4, 5]
   *
   *    const x = math.complex('8i')
   *    math.cbrt(x)                   // returns Complex 1.7320508075689 + i
   *    math.cbrt(x, true)             // returns Matrix [
   *                                    //    1.7320508075689 + i
   *                                    //   -1.7320508075689 + i
   *                                    //   -2i
   *                                    // ]
   *
   * See also:
   *
   *    square, sqrt, cube
   *
   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x
   *            Value for which to calculate the cubic root.
   * @param {boolean} [allRoots]  Optional, false by default. Only applicable
   *            when `x` is a number or complex number. If true, all complex
   *            roots are returned, if false (default) the principal root is
   *            returned.
   * @return {number | BigNumber | Complex | Unit | Array | Matrix}
   *            Returns the cubic root of `x`
   */ var cbrt = typed($1b09c11586ad1e13$var$name, {
        number: (0, $6fCew.cbrtNumber),
        // note: signature 'number, boolean' is also supported,
        //       created by typed as it knows how to convert number to Complex
        Complex: _cbrtComplex,
        "Complex, boolean": _cbrtComplex,
        BigNumber: function BigNumber(x) {
            return x.cbrt();
        },
        Unit: _cbrtUnit,
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since cbrt(0) = 0
            return (0, $e04i1.deepMap)(x, cbrt, true);
        }
    });
    /**
   * Calculate the cubic root for a complex number
   * @param {Complex} x
   * @param {boolean} [allRoots]   If true, the function will return an array
   *                               with all three roots. If false or undefined,
   *                               the principal root is returned.
   * @returns {Complex | Array.<Complex> | Matrix.<Complex>} Returns the cubic root(s) of x
   * @private
   */ function _cbrtComplex(x, allRoots) {
        // https://www.wikiwand.com/en/Cube_root#/Complex_numbers
        var arg3 = x.arg() / 3;
        var abs = x.abs(); // principal root:
        var principal = new Complex((0, $6fCew.cbrtNumber)(abs), 0).mul(new Complex(0, arg3).exp());
        if (allRoots) {
            var all = [
                principal,
                new Complex((0, $6fCew.cbrtNumber)(abs), 0).mul(new Complex(0, arg3 + Math.PI * 2 / 3).exp()),
                new Complex((0, $6fCew.cbrtNumber)(abs), 0).mul(new Complex(0, arg3 - Math.PI * 2 / 3).exp())
            ];
            return config.matrix === "Array" ? all : matrix(all);
        } else return principal;
    }
    /**
   * Calculate the cubic root for a Unit
   * @param {Unit} x
   * @return {Unit} Returns the cubic root of x
   * @private
   */ function _cbrtUnit(x) {
        if (x.value && (0, $1amHZ.isComplex)(x.value)) {
            var result = x.clone();
            result.value = 1.0;
            result = result.pow(1.0 / 3); // Compute the units
            result.value = _cbrtComplex(x.value); // Compute the value
            return result;
        } else {
            var negate = isNegative(x.value);
            if (negate) x.value = unaryMinus(x.value);
             // TODO: create a helper function for this
            var third;
            if ((0, $1amHZ.isBigNumber)(x.value)) third = new BigNumber(1).div(3);
            else if ((0, $1amHZ.isFraction)(x.value)) third = new Fraction(1, 3);
            else third = 1 / 3;
            var _result = x.pow(third);
            if (negate) _result.value = unaryMinus(_result.value);
            return _result;
        }
    }
    return cbrt;
});

});

parcelRegister("9kiFT", function(module, exports) {

$parcel$export(module.exports, "createCeil", function () { return $6ca477bb5290b92e$export$bab247d909829ddf; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");

var $kFRKb = parcelRequire("kFRKb");

var $ijobM = parcelRequire("ijobM");

var $6fCew = parcelRequire("6fCew");
var $6ca477bb5290b92e$var$name = "ceil";
var $6ca477bb5290b92e$var$dependencies = [
    "typed",
    "config",
    "round"
];
var $6ca477bb5290b92e$export$bab247d909829ddf = /* #__PURE__ */ (0, $2mPYl.factory)($6ca477bb5290b92e$var$name, $6ca477bb5290b92e$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, round = _ref.round;
    /**
   * Round a value towards plus infinity
   * If `x` is complex, both real and imaginary part are rounded towards plus infinity.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.ceil(x)
   *
   * Examples:
   *
   *    math.ceil(3.2)               // returns number 4
   *    math.ceil(3.8)               // returns number 4
   *    math.ceil(-4.2)              // returns number -4
   *    math.ceil(-4.7)              // returns number -4
   *
   *    const c = math.complex(3.2, -2.7)
   *    math.ceil(c)                 // returns Complex 4 - 2i
   *
   *    math.ceil([3.2, 3.8, -4.7])  // returns Array [4, 4, -4]
   *
   * See also:
   *
   *    floor, fix, round
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix} x  Number to be rounded
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix} Rounded value
   */ var ceil = typed("ceil", {
        number: function number(x) {
            if ((0, $kFRKb.nearlyEqual)(x, round(x), config.epsilon)) return round(x);
            else return (0, $6fCew.ceilNumber)(x);
        },
        Complex: function Complex(x) {
            return x.ceil();
        },
        BigNumber: function BigNumber(x) {
            if ((0, $ijobM.nearlyEqual)(x, round(x), config.epsilon)) return round(x);
            else return x.ceil();
        },
        Fraction: function Fraction(x) {
            return x.ceil();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since ceil(0) = 0
            return (0, $e04i1.deepMap)(x, ceil, true);
        }
    });
    return ceil;
});

});
parcelRegister("ijobM", function(module, exports) {

$parcel$export(module.exports, "nearlyEqual", function () { return $d54cc3c28150565d$export$6f3989c6ecc04081; });
/**
 * Compares two BigNumbers.
 * @param {BigNumber} x       First value to compare
 * @param {BigNumber} y       Second value to compare
 * @param {number} [epsilon]  The maximum relative difference between x and y
 *                            If epsilon is undefined or null, the function will
 *                            test whether x and y are exactly equal.
 * @return {boolean} whether the two numbers are nearly equal
 */ function $d54cc3c28150565d$export$6f3989c6ecc04081(x, y, epsilon) {
    // if epsilon is null or undefined, test whether x and y are exactly equal
    if (epsilon === null || epsilon === undefined) return x.eq(y);
     // use "==" operator, handles infinities
    if (x.eq(y)) return true;
     // NaN
    if (x.isNaN() || y.isNaN()) return false;
     // at this point x and y should be finite
    if (x.isFinite() && y.isFinite()) {
        // check numbers are very close, needed when comparing numbers near zero
        var diff = x.minus(y).abs();
        if (diff.isZero()) return true;
        else {
            // use relative error
            var max = x.constructor.max(x.abs(), y.abs());
            return diff.lte(max.times(epsilon));
        }
    } // Infinite and Number or negative Infinite and positive Infinite cases
    return false;
}

});


parcelRegister("pi7tG", function(module, exports) {

$parcel$export(module.exports, "createClone", function () { return $04c064174a241247$export$39ad70de4044028a; });

var $7ITGG = parcelRequire("7ITGG");

var $2mPYl = parcelRequire("2mPYl");
var $04c064174a241247$var$name = "clone";
var $04c064174a241247$var$dependencies = [
    "typed"
];
var $04c064174a241247$export$39ad70de4044028a = /* #__PURE__ */ (0, $2mPYl.factory)($04c064174a241247$var$name, $04c064174a241247$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Clone an object.
   *
   * Syntax:
   *
   *     math.clone(x)
   *
   * Examples:
   *
   *    math.clone(3.5)                   // returns number 3.5
   *    math.clone(math.complex('2-4i') // returns Complex 2 - 4i
   *    math.clone(math.unit(45, 'deg'))  // returns Unit 45 deg
   *    math.clone([[1, 2], [3, 4]])      // returns Array [[1, 2], [3, 4]]
   *    math.clone("hello world")         // returns string "hello world"
   *
   * @param {*} x   Object to be cloned
   * @return {*} A clone of object x
   */ return typed($04c064174a241247$var$name, {
        any: (0, $7ITGG.clone)
    });
});

});

parcelRegister("89Lra", function(module, exports) {

$parcel$export(module.exports, "createCombinations", function () { return $5f03f605f143cafa$export$63e3129a196da23d; });

var $2mPYl = parcelRequire("2mPYl");

var $gCvql = parcelRequire("gCvql");
var $5f03f605f143cafa$var$name = "combinations";
var $5f03f605f143cafa$var$dependencies = [
    "typed"
];
var $5f03f605f143cafa$export$63e3129a196da23d = /* #__PURE__ */ (0, $2mPYl.factory)($5f03f605f143cafa$var$name, $5f03f605f143cafa$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Compute the number of ways of picking `k` unordered outcomes from `n`
   * possibilities.
   *
   * Combinations only takes integer arguments.
   * The following condition must be enforced: k <= n.
   *
   * Syntax:
   *
   *     math.combinations(n, k)
   *
   * Examples:
   *
   *    math.combinations(7, 5) // returns 21
   *
   * See also:
   *
   *    combinationsWithRep, permutations, factorial
   *
   * @param {number | BigNumber} n    Total number of objects in the set
   * @param {number | BigNumber} k    Number of objects in the subset
   * @return {number | BigNumber}     Number of possible combinations.
   */ return typed($5f03f605f143cafa$var$name, {
        "number, number": (0, $gCvql.combinationsNumber),
        "BigNumber, BigNumber": function BigNumberBigNumber(n, k) {
            var BigNumber = n.constructor;
            var result, i;
            var nMinusk = n.minus(k);
            var one = new BigNumber(1);
            if (!$5f03f605f143cafa$var$isPositiveInteger(n) || !$5f03f605f143cafa$var$isPositiveInteger(k)) throw new TypeError("Positive integer value expected in function combinations");
            if (k.gt(n)) throw new TypeError("k must be less than n in function combinations");
            result = one;
            if (k.lt(nMinusk)) for(i = one; i.lte(nMinusk); i = i.plus(one))result = result.times(k.plus(i)).dividedBy(i);
            else for(i = one; i.lte(k); i = i.plus(one))result = result.times(nMinusk.plus(i)).dividedBy(i);
            return result;
        } // TODO: implement support for collection in combinations
    });
});
/**
 * Test whether BigNumber n is a positive integer
 * @param {BigNumber} n
 * @returns {boolean} isPositiveInteger
 */ function $5f03f605f143cafa$var$isPositiveInteger(n) {
    return n.isInteger() && n.gte(0);
}

});
parcelRegister("gCvql", function(module, exports) {

$parcel$export(module.exports, "combinationsNumber", function () { return $c1989219d3f69382$export$2a122d28e37477a2; });

var $kFRKb = parcelRequire("kFRKb");

var $kzt53 = parcelRequire("kzt53");
function $c1989219d3f69382$export$2a122d28e37477a2(n, k) {
    if (!(0, $kFRKb.isInteger)(n) || n < 0) throw new TypeError("Positive integer value expected in function combinations");
    if (!(0, $kFRKb.isInteger)(k) || k < 0) throw new TypeError("Positive integer value expected in function combinations");
    if (k > n) throw new TypeError("k must be less than or equal to n");
    var nMinusk = n - k;
    var prodrange;
    if (k < nMinusk) {
        prodrange = (0, $kzt53.product)(nMinusk + 1, n);
        return prodrange / (0, $kzt53.product)(1, k);
    }
    prodrange = (0, $kzt53.product)(k + 1, n);
    return prodrange / (0, $kzt53.product)(1, nMinusk);
}
$c1989219d3f69382$export$2a122d28e37477a2.signature = "number, number";

});
parcelRegister("kzt53", function(module, exports) {

$parcel$export(module.exports, "product", function () { return $ef9da2578d4bbd11$export$dbd0f18357df1ddd; });
/** @param {number} i
 *  @param {number} n
 *  @returns {number} product of i to n
 */ function $ef9da2578d4bbd11$export$dbd0f18357df1ddd(i, n) {
    if (n < i) return 1;
    if (n === i) return n;
    var half = n + i >> 1; // divide (n + i) by 2 and truncate to integer
    return $ef9da2578d4bbd11$export$dbd0f18357df1ddd(i, half) * $ef9da2578d4bbd11$export$dbd0f18357df1ddd(half + 1, n);
}

});



parcelRegister("dNoTM", function(module, exports) {

$parcel$export(module.exports, "createCombinationsWithRep", function () { return $a0b32a59af504b35$export$4bdc90311ec7c1dd; });

var $2mPYl = parcelRequire("2mPYl");

var $kFRKb = parcelRequire("kFRKb");

var $kzt53 = parcelRequire("kzt53");
var $a0b32a59af504b35$var$name = "combinationsWithRep";
var $a0b32a59af504b35$var$dependencies = [
    "typed"
];
var $a0b32a59af504b35$export$4bdc90311ec7c1dd = /* #__PURE__ */ (0, $2mPYl.factory)($a0b32a59af504b35$var$name, $a0b32a59af504b35$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Compute the number of ways of picking `k` unordered outcomes from `n`
   * possibilities, allowing individual outcomes to be repeated more than once.
   *
   * CombinationsWithRep only takes integer arguments.
   * The following condition must be enforced: k <= n + k -1.
   *
   * Syntax:
   *
   *     math.combinationsWithRep(n, k)
   *
   * Examples:
   *
   *    math.combinationsWithRep(7, 5) // returns 462
   *
   * See also:
   *
   *    combinations, permutations, factorial
   *
   * @param {number | BigNumber} n    Total number of objects in the set
   * @param {number | BigNumber} k    Number of objects in the subset
   * @return {number | BigNumber}     Number of possible combinations with replacement.
   */ return typed($a0b32a59af504b35$var$name, {
        "number, number": function numberNumber(n, k) {
            if (!(0, $kFRKb.isInteger)(n) || n < 0) throw new TypeError("Positive integer value expected in function combinationsWithRep");
            if (!(0, $kFRKb.isInteger)(k) || k < 0) throw new TypeError("Positive integer value expected in function combinationsWithRep");
            if (n < 1) throw new TypeError("k must be less than or equal to n + k - 1");
            if (k < n - 1) {
                var _prodrange = (0, $kzt53.product)(n, n + k - 1);
                return _prodrange / (0, $kzt53.product)(1, k);
            }
            var prodrange = (0, $kzt53.product)(k + 1, n + k - 1);
            return prodrange / (0, $kzt53.product)(1, n - 1);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(n, k) {
            var BigNumber = n.constructor;
            var result, i;
            var one = new BigNumber(1);
            var nMinusOne = n.minus(one);
            if (!$a0b32a59af504b35$var$isPositiveInteger(n) || !$a0b32a59af504b35$var$isPositiveInteger(k)) throw new TypeError("Positive integer value expected in function combinationsWithRep");
            if (n.lt(one)) throw new TypeError("k must be less than or equal to n + k - 1 in function combinationsWithRep");
            result = one;
            if (k.lt(nMinusOne)) for(i = one; i.lte(nMinusOne); i = i.plus(one))result = result.times(k.plus(i)).dividedBy(i);
            else for(i = one; i.lte(k); i = i.plus(one))result = result.times(nMinusOne.plus(i)).dividedBy(i);
            return result;
        }
    });
});
/**
 * Test whether BigNumber n is a positive integer
 * @param {BigNumber} n
 * @returns {boolean} isPositiveInteger
 */ function $a0b32a59af504b35$var$isPositiveInteger(n) {
    return n.isInteger() && n.gte(0);
}

});

parcelRegister("4GaSd", function(module, exports) {

$parcel$export(module.exports, "createCompare", function () { return $368384ea53ce7d96$export$a6e723c0e3b918d4; });

var $ijobM = parcelRequire("ijobM");

var $kFRKb = parcelRequire("kFRKb");

var $2mPYl = parcelRequire("2mPYl");

var $jaKH8 = parcelRequire("jaKH8");

var $dNuvz = parcelRequire("dNuvz");

var $iHnaT = parcelRequire("iHnaT");

var $1bBLS = parcelRequire("1bBLS");

var $6XnjD = parcelRequire("6XnjD");
var $368384ea53ce7d96$var$name = "compare";
var $368384ea53ce7d96$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "equalScalar",
    "BigNumber",
    "Fraction",
    "DenseMatrix"
];
var $368384ea53ce7d96$export$a6e723c0e3b918d4 = /* #__PURE__ */ (0, $2mPYl.factory)($368384ea53ce7d96$var$name, $368384ea53ce7d96$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, equalScalar = _ref.equalScalar, matrix = _ref.matrix, BigNumber = _ref.BigNumber, Fraction = _ref.Fraction, DenseMatrix = _ref.DenseMatrix;
    var algorithm03 = (0, $jaKH8.createAlgorithm03)({
        typed: typed
    });
    var algorithm05 = (0, $6XnjD.createAlgorithm05)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm12 = (0, $dNuvz.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $1bBLS.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $iHnaT.createAlgorithm14)({
        typed: typed
    });
    /**
   * Compare two values. Returns 1 when x > y, -1 when x < y, and 0 when x == y.
   *
   * x and y are considered equal when the relative difference between x and y
   * is smaller than the configured epsilon. The function cannot be used to
   * compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.compare(x, y)
   *
   * Examples:
   *
   *    math.compare(6, 1)           // returns 1
   *    math.compare(2, 3)           // returns -1
   *    math.compare(7, 7)           // returns 0
   *    math.compare('10', '2')      // returns 1
   *    math.compare('1000', '1e3')  // returns 0
   *
   *    const a = math.unit('5 cm')
   *    const b = math.unit('40 mm')
   *    math.compare(a, b)           // returns 1
   *
   *    math.compare(2, [1, 2, 3])   // returns [1, 0, -1]
   *
   * See also:
   *
   *    equal, unequal, smaller, smallerEq, larger, largerEq, compareNatural, compareText
   *
   * @param  {number | BigNumber | Fraction | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | Fraction | Unit | string | Array | Matrix} y Second value to compare
   * @return {number | BigNumber | Fraction | Array | Matrix} Returns the result of the comparison:
   *                                                          1 when x > y, -1 when x < y, and 0 when x == y.
   */ var compare = typed($368384ea53ce7d96$var$name, {
        "boolean, boolean": function booleanBoolean(x, y) {
            return x === y ? 0 : x > y ? 1 : -1;
        },
        "number, number": function numberNumber(x, y) {
            return (0, $kFRKb.nearlyEqual)(x, y, config.epsilon) ? 0 : x > y ? 1 : -1;
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return (0, $ijobM.nearlyEqual)(x, y, config.epsilon) ? new BigNumber(0) : new BigNumber(x.cmp(y));
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return new Fraction(x.compare(y));
        },
        "Complex, Complex": function ComplexComplex() {
            throw new TypeError("No ordering relation is defined for complex numbers");
        },
        "Unit, Unit": function UnitUnit(x, y) {
            if (!x.equalBase(y)) throw new Error("Cannot compare units with different base");
            return compare(x.value, y.value);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm05(x, y, compare);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, compare, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, compare, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, compare);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return compare(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return compare(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return compare(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, compare, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, compare, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, compare, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, compare, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, compare, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, compare, true).valueOf();
        }
    });
    return compare;
});
var $368384ea53ce7d96$export$e744cf3e2e3d6926 = /* #__PURE__ */ (0, $2mPYl.factory)($368384ea53ce7d96$var$name, [
    "typed",
    "config"
], function(_ref2) {
    var typed = _ref2.typed, config = _ref2.config;
    return typed($368384ea53ce7d96$var$name, {
        "number, number": function numberNumber(x, y) {
            return (0, $kFRKb.nearlyEqual)(x, y, config.epsilon) ? 0 : x > y ? 1 : -1;
        }
    });
});

});
parcelRegister("6XnjD", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm05", function () { return $510a56c68eb9211b$export$f80c3080566d43b4; });

var $2mPYl = parcelRequire("2mPYl");

var $hy7Bx = parcelRequire("hy7Bx");
var $510a56c68eb9211b$var$name = "algorithm05";
var $510a56c68eb9211b$var$dependencies = [
    "typed",
    "equalScalar"
];
var $510a56c68eb9211b$export$f80c3080566d43b4 = /* #__PURE__ */ (0, $2mPYl.factory)($510a56c68eb9211b$var$name, $510a56c68eb9211b$var$dependencies, function(_ref) {
    var typed = _ref.typed, equalScalar = _ref.equalScalar;
    /**
   * Iterates over SparseMatrix A and SparseMatrix B nonzero items and invokes the callback function f(Aij, Bij).
   * Callback function invoked MAX(NNZA, NNZB) times
   *
   *
   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0 || B(i,j) !== 0
   * C(i,j) = ┤
   *          └  0            ; otherwise
   *
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function algorithm05(a, b, callback) {
        // sparse matrix arrays
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var asize = a._size;
        var adt = a._datatype; // sparse matrix arrays
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bsize = b._size;
        var bdt = b._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $hy7Bx.DimensionError)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string" && adt === bdt) {
            // datatype
            dt = adt; // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cvalues = avalues && bvalues ? [] : undefined;
        var cindex = [];
        var cptr = []; // workspaces
        var xa = cvalues ? [] : undefined;
        var xb = cvalues ? [] : undefined; // marks indicating we have a value in x for a given column
        var wa = [];
        var wb = []; // vars
        var i, j, k, k1; // loop columns
        for(j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length; // columns mark
            var mark = j + 1; // loop values A(:,j)
            for(k = aptr[j], k1 = aptr[j + 1]; k < k1; k++){
                // row
                i = aindex[k]; // push index
                cindex.push(i); // update workspace
                wa[i] = mark; // check we need to process values
                if (xa) xa[i] = avalues[k];
            } // loop values B(:,j)
            for(k = bptr[j], k1 = bptr[j + 1]; k < k1; k++){
                // row
                i = bindex[k]; // check row existed in A
                if (wa[i] !== mark) // push index
                cindex.push(i);
                 // update workspace
                wb[i] = mark; // check we need to process values
                if (xb) xb[i] = bvalues[k];
            } // check we need to process values (non pattern matrix)
            if (cvalues) {
                // initialize first index in j
                k = cptr[j]; // loop index in j
                while(k < cindex.length){
                    // row
                    i = cindex[k]; // marks
                    var wai = wa[i];
                    var wbi = wb[i]; // check Aij or Bij are nonzero
                    if (wai === mark || wbi === mark) {
                        // matrix values @ i,j
                        var va = wai === mark ? xa[i] : zero;
                        var vb = wbi === mark ? xb[i] : zero; // Cij
                        var vc = cf(va, vb); // check for zero
                        if (!eq(vc, zero)) {
                            // push value
                            cvalues.push(vc); // increment pointer
                            k++;
                        } else // remove value @ i, do not increment pointer
                        cindex.splice(k, 1);
                    }
                }
            }
        } // update cptr
        cptr[columns] = cindex.length; // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});

});


parcelRegister("3c8MR", function(module, exports) {

$parcel$export(module.exports, "createCompareNatural", function () { return $25394f05f821c7ff$export$ac9dd39e43534605; });

var $1kEA8 = parcelRequire("1kEA8");

var $1amHZ = parcelRequire("1amHZ");

var $2mPYl = parcelRequire("2mPYl");
var $25394f05f821c7ff$var$name = "compareNatural";
var $25394f05f821c7ff$var$dependencies = [
    "typed",
    "compare"
];
var $25394f05f821c7ff$export$ac9dd39e43534605 = /* #__PURE__ */ (0, $2mPYl.factory)($25394f05f821c7ff$var$name, $25394f05f821c7ff$var$dependencies, function(_ref) {
    var typed = _ref.typed, compare = _ref.compare;
    var compareBooleans = compare.signatures["boolean,boolean"];
    /**
   * Compare two values of any type in a deterministic, natural way.
   *
   * For numeric values, the function works the same as `math.compare`.
   * For types of values that can't be compared mathematically,
   * the function compares in a natural way.
   *
   * For numeric values, x and y are considered equal when the relative
   * difference between x and y is smaller than the configured epsilon.
   * The function cannot be used to compare values smaller than
   * approximately 2.22e-16.
   *
   * For Complex numbers, first the real parts are compared. If equal,
   * the imaginary parts are compared.
   *
   * Strings are compared with a natural sorting algorithm, which
   * orders strings in a "logic" way following some heuristics.
   * This differs from the function `compare`, which converts the string
   * into a numeric value and compares that. The function `compareText`
   * on the other hand compares text lexically.
   *
   * Arrays and Matrices are compared value by value until there is an
   * unequal pair of values encountered. Objects are compared by sorted
   * keys until the keys or their values are unequal.
   *
   * Syntax:
   *
   *    math.compareNatural(x, y)
   *
   * Examples:
   *
   *    math.compareNatural(6, 1)              // returns 1
   *    math.compareNatural(2, 3)              // returns -1
   *    math.compareNatural(7, 7)              // returns 0
   *
   *    math.compareNatural('10', '2')         // returns 1
   *    math.compareText('10', '2')            // returns -1
   *    math.compare('10', '2')                // returns 1
   *
   *    math.compareNatural('Answer: 10', 'Answer: 2') // returns 1
   *    math.compareText('Answer: 10', 'Answer: 2')    // returns -1
   *    math.compare('Answer: 10', 'Answer: 2')
   *        // Error: Cannot convert "Answer: 10" to a number
   *
   *    const a = math.unit('5 cm')
   *    const b = math.unit('40 mm')
   *    math.compareNatural(a, b)              // returns 1
   *
   *    const c = math.complex('2 + 3i')
   *    const d = math.complex('2 + 4i')
   *    math.compareNatural(c, d)              // returns -1
   *
   *    math.compareNatural([1, 2, 4], [1, 2, 3]) // returns 1
   *    math.compareNatural([1, 2, 3], [1, 2])    // returns 1
   *    math.compareNatural([1, 5], [1, 2, 3])    // returns 1
   *    math.compareNatural([1, 2], [1, 2])       // returns 0
   *
   *    math.compareNatural({a: 2}, {a: 4})       // returns -1
   *
   * See also:
   *
   *    compare, compareText
   *
   * @param  {*} x First value to compare
   * @param  {*} y Second value to compare
   * @return {number} Returns the result of the comparison:
   *                  1 when x > y, -1 when x < y, and 0 when x == y.
   */ var compareNatural = typed($25394f05f821c7ff$var$name, {
        "any, any": function anyAny(x, y) {
            var typeX = (0, $1amHZ.typeOf)(x);
            var typeY = (0, $1amHZ.typeOf)(y);
            var c; // numeric types
            if ((typeX === "number" || typeX === "BigNumber" || typeX === "Fraction") && (typeY === "number" || typeY === "BigNumber" || typeY === "Fraction")) {
                c = compare(x, y);
                if (c.toString() !== "0") // c can be number, BigNumber, or Fraction
                return c > 0 ? 1 : -1; // return a number
                else return (0, (/*@__PURE__*/$parcel$interopDefault($1kEA8)))(typeX, typeY);
            } // matrix types
            if (typeX === "Array" || typeX === "Matrix" || typeY === "Array" || typeY === "Matrix") {
                c = compareMatricesAndArrays(x, y);
                if (c !== 0) return c;
                else return (0, (/*@__PURE__*/$parcel$interopDefault($1kEA8)))(typeX, typeY);
            } // in case of different types, order by name of type, i.e. 'BigNumber' < 'Complex'
            if (typeX !== typeY) return (0, (/*@__PURE__*/$parcel$interopDefault($1kEA8)))(typeX, typeY);
            if (typeX === "Complex") return $25394f05f821c7ff$var$compareComplexNumbers(x, y);
            if (typeX === "Unit") {
                if (x.equalBase(y)) return compareNatural(x.value, y.value);
                 // compare by units
                return compareArrays(x.formatUnits(), y.formatUnits());
            }
            if (typeX === "boolean") return compareBooleans(x, y);
            if (typeX === "string") return (0, (/*@__PURE__*/$parcel$interopDefault($1kEA8)))(x, y);
            if (typeX === "Object") return compareObjects(x, y);
            if (typeX === "null") return 0;
            if (typeX === "undefined") return 0;
             // this should not occur...
            throw new TypeError('Unsupported type of value "' + typeX + '"');
        }
    });
    /**
   * Compare mixed matrix/array types, by converting to same-shaped array.
   * This comparator is non-deterministic regarding input types.
   * @param {Array | SparseMatrix | DenseMatrix | *} x
   * @param {Array | SparseMatrix | DenseMatrix | *} y
   * @returns {number} Returns the comparison result: -1, 0, or 1
   */ function compareMatricesAndArrays(x, y) {
        if ((0, $1amHZ.isSparseMatrix)(x) && (0, $1amHZ.isSparseMatrix)(y)) return compareArrays(x.toJSON().values, y.toJSON().values);
        if ((0, $1amHZ.isSparseMatrix)(x)) // note: convert to array is expensive
        return compareMatricesAndArrays(x.toArray(), y);
        if ((0, $1amHZ.isSparseMatrix)(y)) // note: convert to array is expensive
        return compareMatricesAndArrays(x, y.toArray());
         // convert DenseArray into Array
        if ((0, $1amHZ.isDenseMatrix)(x)) return compareMatricesAndArrays(x.toJSON().data, y);
        if ((0, $1amHZ.isDenseMatrix)(y)) return compareMatricesAndArrays(x, y.toJSON().data);
         // convert scalars to array
        if (!Array.isArray(x)) return compareMatricesAndArrays([
            x
        ], y);
        if (!Array.isArray(y)) return compareMatricesAndArrays(x, [
            y
        ]);
        return compareArrays(x, y);
    }
    /**
   * Compare two Arrays
   *
   * - First, compares value by value
   * - Next, if all corresponding values are equal,
   *   look at the length: longest array will be considered largest
   *
   * @param {Array} x
   * @param {Array} y
   * @returns {number} Returns the comparison result: -1, 0, or 1
   */ function compareArrays(x, y) {
        // compare each value
        for(var i = 0, ii = Math.min(x.length, y.length); i < ii; i++){
            var v = compareNatural(x[i], y[i]);
            if (v !== 0) return v;
        } // compare the size of the arrays
        if (x.length > y.length) return 1;
        if (x.length < y.length) return -1;
         // both Arrays have equal size and content
        return 0;
    }
    /**
   * Compare two objects
   *
   * - First, compare sorted property names
   * - Next, compare the property values
   *
   * @param {Object} x
   * @param {Object} y
   * @returns {number} Returns the comparison result: -1, 0, or 1
   */ function compareObjects(x, y) {
        var keysX = Object.keys(x);
        var keysY = Object.keys(y); // compare keys
        keysX.sort((0, (/*@__PURE__*/$parcel$interopDefault($1kEA8))));
        keysY.sort((0, (/*@__PURE__*/$parcel$interopDefault($1kEA8))));
        var c = compareArrays(keysX, keysY);
        if (c !== 0) return c;
         // compare values
        for(var i = 0; i < keysX.length; i++){
            var v = compareNatural(x[keysX[i]], y[keysY[i]]);
            if (v !== 0) return v;
        }
        return 0;
    }
    return compareNatural;
});
/**
 * Compare two complex numbers, `x` and `y`:
 *
 * - First, compare the real values of `x` and `y`
 * - If equal, compare the imaginary values of `x` and `y`
 *
 * @params {Complex} x
 * @params {Complex} y
 * @returns {number} Returns the comparison result: -1, 0, or 1
 */ function $25394f05f821c7ff$var$compareComplexNumbers(x, y) {
    if (x.re > y.re) return 1;
    if (x.re < y.re) return -1;
    if (x.im > y.im) return 1;
    if (x.im < y.im) return -1;
    return 0;
}

});
parcelRegister("1kEA8", function(module, exports) {
/*
 * Natural Sort algorithm for Javascript - Version 0.7 - Released under MIT license
 * Author: Jim Palmer (based on chunking idea from Dave Koelle)
 */ /*jshint unused:false */ module.exports = function naturalSort(a, b) {
    "use strict";
    var re = /(^([+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?)?$|^0x[0-9a-f]+$|\d+)/gi, sre = /(^[ ]*|[ ]*$)/g, dre = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/, hre = /^0x[0-9a-f]+$/i, ore = /^0/, i = function(s) {
        return naturalSort.insensitive && ("" + s).toLowerCase() || "" + s;
    }, // convert all to strings strip whitespace
    x = i(a).replace(sre, "") || "", y = i(b).replace(sre, "") || "", // chunk/tokenize
    xN = x.replace(re, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0"), yN = y.replace(re, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0"), // numeric, hex or date detection
    xD = parseInt(x.match(hre), 16) || xN.length !== 1 && x.match(dre) && Date.parse(x), yD = parseInt(y.match(hre), 16) || xD && y.match(dre) && Date.parse(y) || null, oFxNcL, oFyNcL;
    // first try and sort Hex codes or Dates
    if (yD) {
        if (xD < yD) return -1;
        else if (xD > yD) return 1;
    }
    // natural sorting through split numeric strings and default strings
    for(var cLoc = 0, numS = Math.max(xN.length, yN.length); cLoc < numS; cLoc++){
        // find floats not starting with '0', string or 0 if not defined (Clint Priest)
        oFxNcL = !(xN[cLoc] || "").match(ore) && parseFloat(xN[cLoc]) || xN[cLoc] || 0;
        oFyNcL = !(yN[cLoc] || "").match(ore) && parseFloat(yN[cLoc]) || yN[cLoc] || 0;
        // handle numeric vs string comparison - number < string - (Kyle Adams)
        if (isNaN(oFxNcL) !== isNaN(oFyNcL)) return isNaN(oFxNcL) ? 1 : -1;
        else if (typeof oFxNcL !== typeof oFyNcL) {
            oFxNcL += "";
            oFyNcL += "";
        }
        if (oFxNcL < oFyNcL) return -1;
        if (oFxNcL > oFyNcL) return 1;
    }
    return 0;
};

});


parcelRegister("i4qxa", function(module, exports) {

$parcel$export(module.exports, "createCompareText", function () { return $d27d2ec8240d0c85$export$3e578d0534ab5935; });

var $6NxuJ = parcelRequire("6NxuJ");

var $2mPYl = parcelRequire("2mPYl");

var $iHnaT = parcelRequire("iHnaT");

var $1bBLS = parcelRequire("1bBLS");
var $d27d2ec8240d0c85$var$name = "compareText";
var $d27d2ec8240d0c85$var$dependencies = [
    "typed",
    "matrix"
];
var $d27d2ec8240d0c85$export$3e578d0534ab5935 = /* #__PURE__ */ (0, $2mPYl.factory)($d27d2ec8240d0c85$var$name, $d27d2ec8240d0c85$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix;
    var algorithm13 = (0, $1bBLS.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $iHnaT.createAlgorithm14)({
        typed: typed
    });
    /**
   * Compare two strings lexically. Comparison is case sensitive.
   * Returns 1 when x > y, -1 when x < y, and 0 when x == y.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.compareText(x, y)
   *
   * Examples:
   *
   *    math.compareText('B', 'A')     // returns 1
   *    math.compareText('2', '10')    // returns 1
   *    math.compare('2', '10')        // returns -1
   *    math.compareNatural('2', '10') // returns -1
   *
   *    math.compareText('B', ['A', 'B', 'C']) // returns [1, 0, -1]
   *
   * See also:
   *
   *    equal, equalText, compare, compareNatural
   *
   * @param  {string | Array | DenseMatrix} x First string to compare
   * @param  {string | Array | DenseMatrix} y Second string to compare
   * @return {number | Array | DenseMatrix} Returns the result of the comparison:
   *                                        1 when x > y, -1 when x < y, and 0 when x == y.
   */ var compareText = typed($d27d2ec8240d0c85$var$name, {
        "any, any": (0, $6NxuJ.compareText),
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, (0, $6NxuJ.compareText));
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return compareText(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return compareText(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return compareText(x, matrix(y));
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, (0, $6NxuJ.compareText), false);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, (0, $6NxuJ.compareText), true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, (0, $6NxuJ.compareText), false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, (0, $6NxuJ.compareText), true).valueOf();
        }
    });
    return compareText;
});
var $d27d2ec8240d0c85$export$1d0ea0d151dafd85 = /* #__PURE__ */ (0, $2mPYl.factory)($d27d2ec8240d0c85$var$name, [
    "typed"
], function(_ref2) {
    var typed = _ref2.typed;
    return typed($d27d2ec8240d0c85$var$name, {
        "any, any": (0, $6NxuJ.compareText)
    });
});

});

parcelRegister("9LsUU", function(module, exports) {

$parcel$export(module.exports, "createComplex", function () { return $71beef1c5ffb8d6b$export$82a905fb6826da0d; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");
var $71beef1c5ffb8d6b$var$name = "complex";
var $71beef1c5ffb8d6b$var$dependencies = [
    "typed",
    "Complex"
];
var $71beef1c5ffb8d6b$export$82a905fb6826da0d = /* #__PURE__ */ (0, $2mPYl.factory)($71beef1c5ffb8d6b$var$name, $71beef1c5ffb8d6b$var$dependencies, function(_ref) {
    var typed = _ref.typed, Complex = _ref.Complex;
    /**
   * Create a complex value or convert a value to a complex value.
   *
   * Syntax:
   *
   *     math.complex()                           // creates a complex value with zero
   *                                              // as real and imaginary part.
   *     math.complex(re : number, im : string)   // creates a complex value with provided
   *                                              // values for real and imaginary part.
   *     math.complex(re : number)                // creates a complex value with provided
   *                                              // real value and zero imaginary part.
   *     math.complex(complex : Complex)          // clones the provided complex value.
   *     math.complex(arg : string)               // parses a string into a complex value.
   *     math.complex(array : Array)              // converts the elements of the array
   *                                              // or matrix element wise into a
   *                                              // complex value.
   *     math.complex({re: number, im: number})   // creates a complex value with provided
   *                                              // values for real an imaginary part.
   *     math.complex({r: number, phi: number})   // creates a complex value with provided
   *                                              // polar coordinates
   *
   * Examples:
   *
   *    const a = math.complex(3, -4)     // a = Complex 3 - 4i
   *    a.re = 5                          // a = Complex 5 - 4i
   *    const i = a.im                    // Number -4
   *    const b = math.complex('2 + 6i')  // Complex 2 + 6i
   *    const c = math.complex()          // Complex 0 + 0i
   *    const d = math.add(a, b)          // Complex 5 + 2i
   *
   * See also:
   *
   *    bignumber, boolean, index, matrix, number, string, unit
   *
   * @param {* | Array | Matrix} [args]
   *            Arguments specifying the real and imaginary part of the complex number
   * @return {Complex | Array | Matrix} Returns a complex value
   */ var complex = typed("complex", {
        "": function _() {
            return Complex.ZERO;
        },
        number: function number(x) {
            return new Complex(x, 0);
        },
        "number, number": function numberNumber(re, im) {
            return new Complex(re, im);
        },
        // TODO: this signature should be redundant
        "BigNumber, BigNumber": function BigNumberBigNumber(re, im) {
            return new Complex(re.toNumber(), im.toNumber());
        },
        Fraction: function Fraction(x) {
            return new Complex(x.valueOf(), 0);
        },
        Complex: function Complex(x) {
            return x.clone();
        },
        string: function string(x) {
            return Complex(x); // for example '2 + 3i'
        },
        "null": function _null(x) {
            return Complex(0);
        },
        Object: function Object(x) {
            if ("re" in x && "im" in x) return new Complex(x.re, x.im);
            if ("r" in x && "phi" in x || "abs" in x && "arg" in x) return new Complex(x);
            throw new Error("Expected object with properties (re and im) or (r and phi) or (abs and arg)");
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, complex);
        }
    });
    return complex;
});

});

parcelRegister("dDldj", function(module, exports) {

$parcel$export(module.exports, "createComplexClass", function () { return $9ecf5f7dcdd13d7c$export$24a4be44fc8b6392; });

var $6RgnB = parcelRequire("6RgnB");

var $kFRKb = parcelRequire("kFRKb");

var $1amHZ = parcelRequire("1amHZ");

var $2mPYl = parcelRequire("2mPYl");
function $9ecf5f7dcdd13d7c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $9ecf5f7dcdd13d7c$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $9ecf5f7dcdd13d7c$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $9ecf5f7dcdd13d7c$var$_typeof(obj);
}
var $9ecf5f7dcdd13d7c$var$name = "Complex";
var $9ecf5f7dcdd13d7c$var$dependencies = [];
var $9ecf5f7dcdd13d7c$export$24a4be44fc8b6392 = /* #__PURE__ */ (0, $2mPYl.factory)($9ecf5f7dcdd13d7c$var$name, $9ecf5f7dcdd13d7c$var$dependencies, function() {
    /**
   * Attach type information
   */ (0, (/*@__PURE__*/$parcel$interopDefault($6RgnB))).prototype.type = "Complex";
    (0, (/*@__PURE__*/$parcel$interopDefault($6RgnB))).prototype.isComplex = true;
    /**
   * Get a JSON representation of the complex number
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "Complex", "re": 2, "im": 3}`
   */ (0, (/*@__PURE__*/$parcel$interopDefault($6RgnB))).prototype.toJSON = function() {
        return {
            mathjs: "Complex",
            re: this.re,
            im: this.im
        };
    };
    /*
   * Return the value of the complex number in polar notation
   * The angle phi will be set in the interval of [-pi, pi].
   * @return {{r: number, phi: number}} Returns and object with properties r and phi.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($6RgnB))).prototype.toPolar = function() {
        return {
            r: this.abs(),
            phi: this.arg()
        };
    };
    /**
   * Get a string representation of the complex number,
   * with optional formatting options.
   * @param {Object | number | Function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @return {string} str
   */ (0, (/*@__PURE__*/$parcel$interopDefault($6RgnB))).prototype.format = function(options) {
        var str = "";
        var im = this.im;
        var re = this.re;
        var strRe = (0, $kFRKb.format)(this.re, options);
        var strIm = (0, $kFRKb.format)(this.im, options); // round either re or im when smaller than the configured precision
        var precision = (0, $1amHZ.isNumber)(options) ? options : options ? options.precision : null;
        if (precision !== null) {
            var epsilon = Math.pow(10, -precision);
            if (Math.abs(re / im) < epsilon) re = 0;
            if (Math.abs(im / re) < epsilon) im = 0;
        }
        if (im === 0) // real value
        str = strRe;
        else if (re === 0) {
            // purely complex value
            if (im === 1) str = "i";
            else if (im === -1) str = "-i";
            else str = strIm + "i";
        } else {
            // complex value
            if (im < 0) {
                if (im === -1) str = strRe + " - i";
                else str = strRe + " - " + strIm.substring(1) + "i";
            } else if (im === 1) str = strRe + " + i";
            else str = strRe + " + " + strIm + "i";
        }
        return str;
    };
    /**
   * Create a complex number from polar coordinates
   *
   * Usage:
   *
   *     Complex.fromPolar(r: number, phi: number) : Complex
   *     Complex.fromPolar({r: number, phi: number}) : Complex
   *
   * @param {*} args...
   * @return {Complex}
   */ (0, (/*@__PURE__*/$parcel$interopDefault($6RgnB))).fromPolar = function(args) {
        switch(arguments.length){
            case 1:
                var arg = arguments[0];
                if ($9ecf5f7dcdd13d7c$var$_typeof(arg) === "object") return (0, (/*@__PURE__*/$parcel$interopDefault($6RgnB)))(arg);
                else throw new TypeError("Input has to be an object with r and phi keys.");
            case 2:
                var r = arguments[0];
                var phi = arguments[1];
                if ((0, $1amHZ.isNumber)(r)) {
                    if ((0, $1amHZ.isUnit)(phi) && phi.hasBase("ANGLE")) // convert unit to a number in radians
                    phi = phi.toNumber("rad");
                    if ((0, $1amHZ.isNumber)(phi)) return new (0, (/*@__PURE__*/$parcel$interopDefault($6RgnB)))({
                        r: r,
                        phi: phi
                    });
                    throw new TypeError("Phi is not a number nor an angle unit.");
                } else throw new TypeError("Radius r is not a number.");
            default:
                throw new SyntaxError("Wrong number of arguments in function fromPolar");
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($6RgnB))).prototype.valueOf = (0, (/*@__PURE__*/$parcel$interopDefault($6RgnB))).prototype.toString;
    /**
   * Create a Complex number from a JSON object
   * @param {Object} json  A JSON Object structured as
   *                       {"mathjs": "Complex", "re": 2, "im": 3}
   *                       All properties are optional, default values
   *                       for `re` and `im` are 0.
   * @return {Complex} Returns a new Complex number
   */ (0, (/*@__PURE__*/$parcel$interopDefault($6RgnB))).fromJSON = function(json) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($6RgnB)))(json);
    };
    /**
   * Compare two complex numbers, `a` and `b`:
   *
   * - Returns 1 when the real part of `a` is larger than the real part of `b`
   * - Returns -1 when the real part of `a` is smaller than the real part of `b`
   * - Returns 1 when the real parts are equal
   *   and the imaginary part of `a` is larger than the imaginary part of `b`
   * - Returns -1 when the real parts are equal
   *   and the imaginary part of `a` is smaller than the imaginary part of `b`
   * - Returns 0 when both real and imaginary parts are equal.
   *
   * @params {Complex} a
   * @params {Complex} b
   * @returns {number} Returns the comparison result: -1, 0, or 1
   */ (0, (/*@__PURE__*/$parcel$interopDefault($6RgnB))).compare = function(a, b) {
        if (a.re > b.re) return 1;
        if (a.re < b.re) return -1;
        if (a.im > b.im) return 1;
        if (a.im < b.im) return -1;
        return 0;
    };
    return 0, (/*@__PURE__*/$parcel$interopDefault($6RgnB));
}, {
    isClass: true
});

});
parcelRegister("6RgnB", function(module, exports) {
/*
Complex.js v2.3.0 10/10/2024
https://raw.org/article/complex-numbers-in-javascript/

Copyright (c) 2024, Robert Eisele (https://raw.org/)
Licensed under the MIT license.
*/ "use strict";
(function(n) {
    function l() {
        throw SyntaxError("Invalid Param");
    }
    function m(a, b) {
        var c = Math.abs(a), e = Math.abs(b);
        if (0 === a) return Math.log(e);
        if (0 === b) return Math.log(c);
        if (3E3 > c && 3E3 > e) return .5 * Math.log(a * a + b * b);
        a /= 2;
        b /= 2;
        return .5 * Math.log(a * a + b * b) + Math.LN2;
    }
    function d(a, b) {
        if (!(this instanceof d)) return new d(a, b);
        var c = {
            re: 0,
            im: 0
        };
        if (void 0 === a || null === a) c.re = c.im = 0;
        else if (void 0 !== b) c.re = a, c.im = b;
        else switch(typeof a){
            case "object":
                "im" in a && "re" in a ? (c.re = a.re, c.im = a.im) : "abs" in a && "arg" in a ? !Number.isFinite(a.abs) && Number.isFinite(a.arg) ? c = d.INFINITY : (c.re = a.abs * Math.cos(a.arg), c.im = a.abs * Math.sin(a.arg)) : "r" in a && "phi" in a ? !Number.isFinite(a.r) && Number.isFinite(a.phi) ? c = d.INFINITY : (c.re = a.r * Math.cos(a.phi), c.im = a.r * Math.sin(a.phi)) : 2 === a.length ? (c.re = a[0], c.im = a[1]) : l();
                break;
            case "string":
                c.im = c.re = 0;
                a = a.replace(/_/g, "").match(/\d+\.?\d*e[+-]?\d+|\d+\.?\d*|\.\d+|./g);
                b = 1;
                var e = 0;
                null === a && l();
                for(var f = 0; f < a.length; f++){
                    var h = a[f];
                    " " !== h && "	" !== h && "\n" !== h && ("+" === h ? b++ : "-" === h ? e++ : ("i" === h || "I" === h ? (0 === b + e && l(), " " === a[f + 1] || isNaN(a[f + 1]) ? c.im += parseFloat((e % 2 ? "-" : "") + "1") : (c.im += parseFloat((e % 2 ? "-" : "") + a[f + 1]), f++)) : ((0 === b + e || isNaN(h)) && l(), "i" === a[f + 1] || "I" === a[f + 1] ? (c.im += parseFloat((e % 2 ? "-" : "") + h), f++) : c.re += parseFloat((e % 2 ? "-" : "") + h)), b = e = 0));
                }
                0 < b + e && l();
                break;
            case "number":
                c.im = 0;
                c.re = a;
                break;
            default:
                l();
        }
        this.re = c.re;
        this.im = c.im;
    }
    var g = Math.cosh || function(a) {
        return 1E-9 > Math.abs(a) ? 1 - a : .5 * (Math.exp(a) + Math.exp(-a));
    }, k = Math.sinh || function(a) {
        return 1E-9 > Math.abs(a) ? a : .5 * (Math.exp(a) - Math.exp(-a));
    };
    d.prototype = {
        re: 0,
        im: 0,
        sign: function() {
            var a = this.abs();
            return new d(this.re / a, this.im / a);
        },
        add: function(a, b) {
            a = new d(a, b);
            return this.isInfinite() && a.isInfinite() ? d.NAN : this.isInfinite() || a.isInfinite() ? d.INFINITY : new d(this.re + a.re, this.im + a.im);
        },
        sub: function(a, b) {
            a = new d(a, b);
            return this.isInfinite() && a.isInfinite() ? d.NAN : this.isInfinite() || a.isInfinite() ? d.INFINITY : new d(this.re - a.re, this.im - a.im);
        },
        mul: function(a, b) {
            a = new d(a, b);
            return this.isInfinite() && a.isZero() || this.isZero() && a.isInfinite() ? d.NAN : this.isInfinite() || a.isInfinite() ? d.INFINITY : 0 === a.im && 0 === this.im ? new d(this.re * a.re, 0) : new d(this.re * a.re - this.im * a.im, this.re * a.im + this.im * a.re);
        },
        div: function(a, b) {
            var c = new d(a, b);
            if (this.isZero() && c.isZero() || this.isInfinite() && c.isInfinite()) return d.NAN;
            if (this.isInfinite() || c.isZero()) return d.INFINITY;
            if (this.isZero() || c.isInfinite()) return d.ZERO;
            a = this.re;
            b = this.im;
            var e = c.re, f = c.im;
            if (0 === f) return new d(a / e, b / e);
            if (Math.abs(e) < Math.abs(f)) return c = e / f, e = e * c + f, new d((a * c + b) / e, (b * c - a) / e);
            c = f / e;
            e = f * c + e;
            return new d((a + b * c) / e, (b - a * c) / e);
        },
        pow: function(a, b) {
            var c = new d(a, b);
            a = this.re;
            b = this.im;
            if (c.isZero()) return d.ONE;
            if (0 === c.im) {
                if (0 === b && 0 < a) return new d(Math.pow(a, c.re), 0);
                if (0 === a) switch((c.re % 4 + 4) % 4){
                    case 0:
                        return new d(Math.pow(b, c.re), 0);
                    case 1:
                        return new d(0, Math.pow(b, c.re));
                    case 2:
                        return new d(-Math.pow(b, c.re), 0);
                    case 3:
                        return new d(0, -Math.pow(b, c.re));
                }
            }
            if (0 === a && 0 === b && 0 < c.re && 0 <= c.im) return d.ZERO;
            var e = Math.atan2(b, a);
            b = m(a, b);
            a = Math.exp(c.re * b - c.im * e);
            b = c.im * b + c.re * e;
            return new d(a * Math.cos(b), a * Math.sin(b));
        },
        sqrt: function() {
            var a = this.re, b = this.im, c = this.abs();
            if (0 <= a) {
                if (0 === b) return new d(Math.sqrt(a), 0);
                var e = .5 * Math.sqrt(2 * (c + a));
            } else e = Math.abs(b) / Math.sqrt(2 * (c - a));
            a = 0 >= a ? .5 * Math.sqrt(2 * (c - a)) : Math.abs(b) / Math.sqrt(2 * (c + a));
            return new d(e, 0 > b ? -a : a);
        },
        exp: function() {
            var a = Math.exp(this.re);
            return new d(a * Math.cos(this.im), a * Math.sin(this.im));
        },
        expm1: function() {
            var a = this.re, b = this.im, c = Math.expm1(a) * Math.cos(b);
            var e = Math.PI / 4;
            -e > b || b > e ? e = Math.cos(b) - 1 : (e = b * b, e *= e * (e * (e * (e * (e * (e * (e / 20922789888E3 - 1 / 87178291200) + 1 / 479001600) - 1 / 3628800) + 1 / 40320) - 1 / 720) + 1 / 24) - .5);
            return new d(c + e, Math.exp(a) * Math.sin(b));
        },
        log: function() {
            var a = this.re, b = this.im;
            return new d(m(a, b), Math.atan2(b, a));
        },
        abs: function() {
            var a = this.re;
            var b = this.im, c = Math.abs(a), e = Math.abs(b);
            3E3 > c && 3E3 > e ? a = Math.sqrt(c * c + e * e) : (c < e ? (c = e, e = a / b) : e = b / a, a = c * Math.sqrt(1 + e * e));
            return a;
        },
        arg: function() {
            return Math.atan2(this.im, this.re);
        },
        sin: function() {
            var a = this.re, b = this.im;
            return new d(Math.sin(a) * g(b), Math.cos(a) * k(b));
        },
        cos: function() {
            var a = this.re, b = this.im;
            return new d(Math.cos(a) * g(b), -Math.sin(a) * k(b));
        },
        tan: function() {
            var a = 2 * this.re, b = 2 * this.im, c = Math.cos(a) + g(b);
            return new d(Math.sin(a) / c, k(b) / c);
        },
        cot: function() {
            var a = 2 * this.re, b = 2 * this.im, c = Math.cos(a) - g(b);
            return new d(-Math.sin(a) / c, k(b) / c);
        },
        sec: function() {
            var a = this.re, b = this.im, c = .5 * g(2 * b) + .5 * Math.cos(2 * a);
            return new d(Math.cos(a) * g(b) / c, Math.sin(a) * k(b) / c);
        },
        csc: function() {
            var a = this.re, b = this.im, c = .5 * g(2 * b) - .5 * Math.cos(2 * a);
            return new d(Math.sin(a) * g(b) / c, -Math.cos(a) * k(b) / c);
        },
        asin: function() {
            var a = this.re, b = this.im, c = new d(b * b - a * a + 1, -2 * a * b).sqrt();
            a = new d(c.re - b, c.im + a).log();
            return new d(a.im, -a.re);
        },
        acos: function() {
            var a = this.re, b = this.im, c = new d(b * b - a * a + 1, -2 * a * b).sqrt();
            a = new d(c.re - b, c.im + a).log();
            return new d(Math.PI / 2 - a.im, a.re);
        },
        atan: function() {
            var a = this.re, b = this.im;
            if (0 === a) {
                if (1 === b) return new d(0, Infinity);
                if (-1 === b) return new d(0, -Infinity);
            }
            var c = a * a + (1 - b) * (1 - b);
            a = new d((1 - b * b - a * a) / c, -2 * a / c).log();
            return new d(-0.5 * a.im, .5 * a.re);
        },
        acot: function() {
            var a = this.re, b = this.im;
            if (0 === b) return new d(Math.atan2(1, a), 0);
            var c = a * a + b * b;
            return 0 !== c ? new d(a / c, -b / c).atan() : new d(0 !== a ? a / 0 : 0, 0 !== b ? -b / 0 : 0).atan();
        },
        asec: function() {
            var a = this.re, b = this.im;
            if (0 === a && 0 === b) return new d(0, Infinity);
            var c = a * a + b * b;
            return 0 !== c ? new d(a / c, -b / c).acos() : new d(0 !== a ? a / 0 : 0, 0 !== b ? -b / 0 : 0).acos();
        },
        acsc: function() {
            var a = this.re, b = this.im;
            if (0 === a && 0 === b) return new d(Math.PI / 2, Infinity);
            var c = a * a + b * b;
            return 0 !== c ? new d(a / c, -b / c).asin() : new d(0 !== a ? a / 0 : 0, 0 !== b ? -b / 0 : 0).asin();
        },
        sinh: function() {
            var a = this.re, b = this.im;
            return new d(k(a) * Math.cos(b), g(a) * Math.sin(b));
        },
        cosh: function() {
            var a = this.re, b = this.im;
            return new d(g(a) * Math.cos(b), k(a) * Math.sin(b));
        },
        tanh: function() {
            var a = 2 * this.re, b = 2 * this.im, c = g(a) + Math.cos(b);
            return new d(k(a) / c, Math.sin(b) / c);
        },
        coth: function() {
            var a = 2 * this.re, b = 2 * this.im, c = g(a) - Math.cos(b);
            return new d(k(a) / c, -Math.sin(b) / c);
        },
        csch: function() {
            var a = this.re, b = this.im, c = Math.cos(2 * b) - g(2 * a);
            return new d(-2 * k(a) * Math.cos(b) / c, 2 * g(a) * Math.sin(b) / c);
        },
        sech: function() {
            var a = this.re, b = this.im, c = Math.cos(2 * b) + g(2 * a);
            return new d(2 * g(a) * Math.cos(b) / c, -2 * k(a) * Math.sin(b) / c);
        },
        asinh: function() {
            var a = this.im;
            this.im = -this.re;
            this.re = a;
            var b = this.asin();
            this.re = -this.im;
            this.im = a;
            a = b.re;
            b.re = -b.im;
            b.im = a;
            return b;
        },
        acosh: function() {
            var a = this.acos();
            if (0 >= a.im) {
                var b = a.re;
                a.re = -a.im;
                a.im = b;
            } else b = a.im, a.im = -a.re, a.re = b;
            return a;
        },
        atanh: function() {
            var a = this.re, b = this.im, c = 1 < a && 0 === b, e = 1 - a, f = 1 + a, h = e * e + b * b;
            a = 0 !== h ? new d((f * e - b * b) / h, (b * e + f * b) / h) : new d(-1 !== a ? a / 0 : 0, 0 !== b ? b / 0 : 0);
            b = a.re;
            a.re = m(a.re, a.im) / 2;
            a.im = Math.atan2(a.im, b) / 2;
            c && (a.im = -a.im);
            return a;
        },
        acoth: function() {
            var a = this.re, b = this.im;
            if (0 === a && 0 === b) return new d(0, Math.PI / 2);
            var c = a * a + b * b;
            return 0 !== c ? new d(a / c, -b / c).atanh() : new d(0 !== a ? a / 0 : 0, 0 !== b ? -b / 0 : 0).atanh();
        },
        acsch: function() {
            var a = this.re, b = this.im;
            if (0 === b) return new d(0 !== a ? Math.log(a + Math.sqrt(a * a + 1)) : Infinity, 0);
            var c = a * a + b * b;
            return 0 !== c ? new d(a / c, -b / c).asinh() : new d(0 !== a ? a / 0 : 0, 0 !== b ? -b / 0 : 0).asinh();
        },
        asech: function() {
            var a = this.re, b = this.im;
            if (this.isZero()) return d.INFINITY;
            var c = a * a + b * b;
            return 0 !== c ? new d(a / c, -b / c).acosh() : new d(0 !== a ? a / 0 : 0, 0 !== b ? -b / 0 : 0).acosh();
        },
        inverse: function() {
            if (this.isZero()) return d.INFINITY;
            if (this.isInfinite()) return d.ZERO;
            var a = this.re, b = this.im, c = a * a + b * b;
            return new d(a / c, -b / c);
        },
        conjugate: function() {
            return new d(this.re, -this.im);
        },
        neg: function() {
            return new d(-this.re, -this.im);
        },
        ceil: function(a) {
            a = Math.pow(10, a || 0);
            return new d(Math.ceil(this.re * a) / a, Math.ceil(this.im * a) / a);
        },
        floor: function(a) {
            a = Math.pow(10, a || 0);
            return new d(Math.floor(this.re * a) / a, Math.floor(this.im * a) / a);
        },
        round: function(a) {
            a = Math.pow(10, a || 0);
            return new d(Math.round(this.re * a) / a, Math.round(this.im * a) / a);
        },
        equals: function(a, b) {
            a = new d(a, b);
            return Math.abs(a.re - this.re) <= d.EPSILON && Math.abs(a.im - this.im) <= d.EPSILON;
        },
        clone: function() {
            return new d(this.re, this.im);
        },
        toString: function() {
            var a = this.re, b = this.im, c = "";
            if (this.isNaN()) return "NaN";
            if (this.isInfinite()) return "Infinity";
            Math.abs(a) < d.EPSILON && (a = 0);
            Math.abs(b) < d.EPSILON && (b = 0);
            if (0 === b) return c + a;
            0 !== a ? (c = c + a + " ", 0 > b ? (b = -b, c += "-") : c += "+", c += " ") : 0 > b && (b = -b, c += "-");
            1 !== b && (c += b);
            return c + "i";
        },
        toVector: function() {
            return [
                this.re,
                this.im
            ];
        },
        valueOf: function() {
            return 0 === this.im ? this.re : null;
        },
        isNaN: function() {
            return isNaN(this.re) || isNaN(this.im);
        },
        isZero: function() {
            return 0 === this.im && 0 === this.re;
        },
        isFinite: function() {
            return isFinite(this.re) && isFinite(this.im);
        },
        isInfinite: function() {
            return !(this.isNaN() || this.isFinite());
        }
    };
    d.ZERO = new d(0, 0);
    d.ONE = new d(1, 0);
    d.I = new d(0, 1);
    d.PI = new d(Math.PI, 0);
    d.E = new d(Math.E, 0);
    d.INFINITY = new d(Infinity, Infinity);
    d.NAN = new d(NaN, NaN);
    d.EPSILON = 1E-15;
    "function" === typeof define && define.amd ? define([], function() {
        return d;
    }) : (Object.defineProperty(d, "__esModule", {
        value: !0
    }), d["default"] = d, d.Complex = d, module.exports = d);
})(module.exports);

});


parcelRegister("2H2OT", function(module, exports) {

$parcel$export(module.exports, "createComposition", function () { return $1f61c8e47635a344$export$1ddf9cbadd17315f; });

var $2mPYl = parcelRequire("2mPYl");
var $1f61c8e47635a344$var$name = "composition";
var $1f61c8e47635a344$var$dependencies = [
    "typed",
    "addScalar",
    "combinations",
    "isNegative",
    "isPositive",
    "isInteger",
    "larger"
];
var $1f61c8e47635a344$export$1ddf9cbadd17315f = /* #__PURE__ */ (0, $2mPYl.factory)($1f61c8e47635a344$var$name, $1f61c8e47635a344$var$dependencies, function(_ref) {
    var typed = _ref.typed, addScalar = _ref.addScalar, combinations = _ref.combinations, isPositive = _ref.isPositive, isNegative = _ref.isNegative, isInteger = _ref.isInteger, larger = _ref.larger;
    /**
   * The composition counts of n into k parts.
   *
   * composition only takes integer arguments.
   * The following condition must be enforced: k <= n.
   *
   * Syntax:
   *
   *   math.composition(n, k)
   *
   * Examples:
   *
   *    math.composition(5, 3) // returns 6
   *
   * See also:
   *
   *    combinations
   *
   * @param {Number | BigNumber} n    Total number of objects in the set
   * @param {Number | BigNumber} k    Number of objects in the subset
   * @return {Number | BigNumber}     Returns the composition counts of n into k parts.
   */ return typed($1f61c8e47635a344$var$name, {
        "number | BigNumber, number | BigNumber": function numberBigNumberNumberBigNumber(n, k) {
            if (!isInteger(n) || !isPositive(n) || !isInteger(k) || !isPositive(k)) throw new TypeError("Positive integer value expected in function composition");
            else if (larger(k, n)) throw new TypeError("k must be less than or equal to n in function composition");
            return combinations(addScalar(n, -1), addScalar(k, -1));
        }
    });
});

});

parcelRegister("8s0Jy", function(module, exports) {

$parcel$export(module.exports, "createConj", function () { return $627181fc5023fb22$export$af5efe8ad97f01a2; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");
var $627181fc5023fb22$var$name = "conj";
var $627181fc5023fb22$var$dependencies = [
    "typed"
];
var $627181fc5023fb22$export$af5efe8ad97f01a2 = /* #__PURE__ */ (0, $2mPYl.factory)($627181fc5023fb22$var$name, $627181fc5023fb22$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Compute the complex conjugate of a complex value.
   * If `x = a+bi`, the complex conjugate of `x` is `a - bi`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.conj(x)
   *
   * Examples:
   *
   *    math.conj(math.complex('2 + 3i'))  // returns Complex 2 - 3i
   *    math.conj(math.complex('2 - 3i'))  // returns Complex 2 + 3i
   *    math.conj(math.complex('-5.2i'))  // returns Complex 5.2i
   *
   * See also:
   *
   *    re, im, arg, abs
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            A complex number or array with complex numbers
   * @return {number | BigNumber | Complex | Array | Matrix}
   *            The complex conjugate of x
   */ var conj = typed($627181fc5023fb22$var$name, {
        number: function number(x) {
            return x;
        },
        BigNumber: function BigNumber(x) {
            return x;
        },
        Complex: function Complex(x) {
            return x.conjugate();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, conj);
        }
    });
    return conj;
});

});

parcelRegister("fAfsd", function(module, exports) {

$parcel$export(module.exports, "createCos", function () { return $b58634ac090944eb$export$923b60dfa791c630; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");
var $b58634ac090944eb$var$name = "cos";
var $b58634ac090944eb$var$dependencies = [
    "typed"
];
var $b58634ac090944eb$export$923b60dfa791c630 = /* #__PURE__ */ (0, $2mPYl.factory)($b58634ac090944eb$var$name, $b58634ac090944eb$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Calculate the cosine of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.cos(x)
   *
   * Examples:
   *
   *    math.cos(2)                      // returns number -0.4161468365471422
   *    math.cos(math.pi / 4)            // returns number  0.7071067811865475
   *    math.cos(math.unit(180, 'deg'))  // returns number -1
   *    math.cos(math.unit(60, 'deg'))   // returns number  0.5
   *
   *    const angle = 0.2
   *    math.pow(math.sin(angle), 2) + math.pow(math.cos(angle), 2) // returns number ~1
   *
   * See also:
   *
   *    cos, tan
   *
   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | BigNumber | Complex | Array | Matrix} Cosine of x
   */ var cos = typed($b58634ac090944eb$var$name, {
        number: Math.cos,
        Complex: function Complex(x) {
            return x.cos();
        },
        BigNumber: function BigNumber(x) {
            return x.cos();
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function cos is no angle");
            return cos(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, cos);
        }
    });
    return cos;
});

});

parcelRegister("jQYDB", function(module, exports) {

$parcel$export(module.exports, "createCosh", function () { return $e741e90edf355760$export$63d35097da636c02; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");

var $kFRKb = parcelRequire("kFRKb");
var $e741e90edf355760$var$name = "cosh";
var $e741e90edf355760$var$dependencies = [
    "typed"
];
var $e741e90edf355760$export$63d35097da636c02 = /* #__PURE__ */ (0, $2mPYl.factory)($e741e90edf355760$var$name, $e741e90edf355760$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Calculate the hyperbolic cosine of a value,
   * defined as `cosh(x) = 1/2 * (exp(x) + exp(-x))`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.cosh(x)
   *
   * Examples:
   *
   *    math.cosh(0.5)       // returns number 1.1276259652063807
   *
   * See also:
   *
   *    sinh, tanh
   *
   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | BigNumber | Complex | Array | Matrix} Hyperbolic cosine of x
   */ var cosh = typed($e741e90edf355760$var$name, {
        number: (0, $kFRKb.cosh),
        Complex: function Complex(x) {
            return x.cosh();
        },
        BigNumber: function BigNumber(x) {
            return x.cosh();
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function cosh is no angle");
            return cosh(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, cosh);
        }
    });
    return cosh;
});

});

parcelRegister("eAT74", function(module, exports) {

$parcel$export(module.exports, "createCot", function () { return $a9ff2dc74ba41fe8$export$c5598f542ea1565c; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");

var $2F5hp = parcelRequire("2F5hp");
var $a9ff2dc74ba41fe8$var$name = "cot";
var $a9ff2dc74ba41fe8$var$dependencies = [
    "typed",
    "BigNumber"
];
var $a9ff2dc74ba41fe8$export$c5598f542ea1565c = /* #__PURE__ */ (0, $2mPYl.factory)($a9ff2dc74ba41fe8$var$name, $a9ff2dc74ba41fe8$var$dependencies, function(_ref) {
    var typed = _ref.typed, _BigNumber = _ref.BigNumber;
    /**
   * Calculate the cotangent of a value. Defined as `cot(x) = 1 / tan(x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.cot(x)
   *
   * Examples:
   *
   *    math.cot(2)      // returns number -0.45765755436028577
   *    1 / math.tan(2)  // returns number -0.45765755436028577
   *
   * See also:
   *
   *    tan, sec, csc
   *
   * @param {number | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Cotangent of x
   */ var cot = typed($a9ff2dc74ba41fe8$var$name, {
        number: (0, $2F5hp.cotNumber),
        Complex: function Complex(x) {
            return x.cot();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x.tan());
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function cot is no angle");
            return cot(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, cot);
        }
    });
    return cot;
});

});

parcelRegister("7zpx7", function(module, exports) {

$parcel$export(module.exports, "createCoth", function () { return $582f9ba7e11bada9$export$3f7f9b5400315e6a; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");

var $2F5hp = parcelRequire("2F5hp");
var $582f9ba7e11bada9$var$name = "coth";
var $582f9ba7e11bada9$var$dependencies = [
    "typed",
    "BigNumber"
];
var $582f9ba7e11bada9$export$3f7f9b5400315e6a = /* #__PURE__ */ (0, $2mPYl.factory)($582f9ba7e11bada9$var$name, $582f9ba7e11bada9$var$dependencies, function(_ref) {
    var typed = _ref.typed, _BigNumber = _ref.BigNumber;
    /**
   * Calculate the hyperbolic cotangent of a value,
   * defined as `coth(x) = 1 / tanh(x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.coth(x)
   *
   * Examples:
   *
   *    // coth(x) = 1 / tanh(x)
   *    math.coth(2)         // returns 1.0373147207275482
   *    1 / math.tanh(2)     // returns 1.0373147207275482
   *
   * See also:
   *
   *    sinh, tanh, cosh
   *
   * @param {number | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic cotangent of x
   */ var coth = typed($582f9ba7e11bada9$var$name, {
        number: (0, $2F5hp.cothNumber),
        Complex: function Complex(x) {
            return x.coth();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x.tanh());
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function coth is no angle");
            return coth(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, coth);
        }
    });
    return coth;
});

});

parcelRegister("b1H27", function(module, exports) {

$parcel$export(module.exports, "createCreateUnit", function () { return $80712b3215a49aaf$export$27641941eb5cadbb; });

var $2mPYl = parcelRequire("2mPYl");
var $80712b3215a49aaf$var$name = "createUnit";
var $80712b3215a49aaf$var$dependencies = [
    "typed",
    "Unit"
];
var $80712b3215a49aaf$export$27641941eb5cadbb = /* #__PURE__ */ (0, $2mPYl.factory)($80712b3215a49aaf$var$name, $80712b3215a49aaf$var$dependencies, function(_ref) {
    var typed = _ref.typed, Unit = _ref.Unit;
    /**
   * Create a user-defined unit and register it with the Unit type.
   *
   * Syntax:
   *
   *     math.createUnit({
   *       baseUnit1: {
   *         aliases: [string, ...]
   *         prefixes: object
   *       },
   *       unit2: {
   *         definition: string,
   *         aliases: [string, ...]
   *         prefixes: object,
   *         offset: number
   *       },
   *       unit3: string    // Shortcut
   *     })
   *
   *     // Another shortcut:
   *     math.createUnit(string, unit : string, [object])
   *
   * Examples:
   *
   *     math.createUnit('foo')
   *     math.createUnit('knot', {definition: '0.514444444 m/s', aliases: ['knots', 'kt', 'kts']})
   *     math.createUnit('mph', '1 mile/hour')
   *
   * @param {string} name      The name of the new unit. Must be unique. Example: 'knot'
   * @param {string, Unit} definition      Definition of the unit in terms of existing units. For example, '0.514444444 m / s'.
   * @param {Object} options   (optional) An object containing any of the following properties:
   *     - `prefixes {string}` "none", "short", "long", "binary_short", or "binary_long". The default is "none".
   *     - `aliases {Array}` Array of strings. Example: ['knots', 'kt', 'kts']
   *     - `offset {Numeric}` An offset to apply when converting from the unit. For example, the offset for celsius is 273.15. Default is 0.
   *
   * See also:
   *
   *     unit
   *
   * @return {Unit} The new unit
   */ return typed($80712b3215a49aaf$var$name, {
        // General function signature. First parameter is an object where each property is the definition of a new unit. The object keys are the unit names and the values are the definitions. The values can be objects, strings, or Units. If a property is an empty object or an empty string, a new base unit is created. The second parameter is the options.
        "Object, Object": function ObjectObject(obj, options) {
            return Unit.createUnit(obj, options);
        },
        // Same as above but without the options.
        Object: function Object(obj) {
            return Unit.createUnit(obj, {});
        },
        // Shortcut method for creating one unit.
        "string, Unit | string | Object, Object": function stringUnitStringObjectObject(name, def, options) {
            var obj = {};
            obj[name] = def;
            return Unit.createUnit(obj, options);
        },
        // Same as above but without the options.
        "string, Unit | string | Object": function stringUnitStringObject(name, def) {
            var obj = {};
            obj[name] = def;
            return Unit.createUnit(obj, {});
        },
        // Without a definition, creates a base unit.
        string: function string(name) {
            var obj = {};
            obj[name] = {};
            return Unit.createUnit(obj, {});
        }
    });
});

});

parcelRegister("bPaMl", function(module, exports) {

$parcel$export(module.exports, "createCross", function () { return $89bcd1964ea5df1d$export$bc2585c0ed744c0e; });

var $5WdrK = parcelRequire("5WdrK");

var $2mPYl = parcelRequire("2mPYl");
var $89bcd1964ea5df1d$var$name = "cross";
var $89bcd1964ea5df1d$var$dependencies = [
    "typed",
    "matrix",
    "subtract",
    "multiply"
];
var $89bcd1964ea5df1d$export$bc2585c0ed744c0e = /* #__PURE__ */ (0, $2mPYl.factory)($89bcd1964ea5df1d$var$name, $89bcd1964ea5df1d$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, subtract = _ref.subtract, multiply = _ref.multiply;
    /**
   * Calculate the cross product for two vectors in three dimensional space.
   * The cross product of `A = [a1, a2, a3]` and `B = [b1, b2, b3]` is defined
   * as:
   *
   *    cross(A, B) = [
   *      a2 * b3 - a3 * b2,
   *      a3 * b1 - a1 * b3,
   *      a1 * b2 - a2 * b1
   *    ]
   *
   * If one of the input vectors has a dimension greater than 1, the output
   * vector will be a 1x3 (2-dimensional) matrix.
   *
   * Syntax:
   *
   *    math.cross(x, y)
   *
   * Examples:
   *
   *    math.cross([1, 1, 0],   [0, 1, 1])       // Returns [1, -1, 1]
   *    math.cross([3, -3, 1],  [4, 9, 2])       // Returns [-15, -2, 39]
   *    math.cross([2, 3, 4],   [5, 6, 7])       // Returns [-3, 6, -3]
   *    math.cross([[1, 2, 3]], [[4], [5], [6]]) // Returns [[-3, 6, -3]]
   *
   * See also:
   *
   *    dot, multiply
   *
   * @param  {Array | Matrix} x   First vector
   * @param  {Array | Matrix} y   Second vector
   * @return {Array | Matrix}     Returns the cross product of `x` and `y`
   */ return typed($89bcd1964ea5df1d$var$name, {
        "Matrix, Matrix": function MatrixMatrix(x, y) {
            return matrix(_cross(x.toArray(), y.toArray()));
        },
        "Matrix, Array": function MatrixArray(x, y) {
            return matrix(_cross(x.toArray(), y));
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            return matrix(_cross(x, y.toArray()));
        },
        "Array, Array": _cross
    });
    /**
   * Calculate the cross product for two arrays
   * @param {Array} x  First vector
   * @param {Array} y  Second vector
   * @returns {Array} Returns the cross product of x and y
   * @private
   */ function _cross(x, y) {
        var highestDimension = Math.max((0, $5WdrK.arraySize)(x).length, (0, $5WdrK.arraySize)(y).length);
        x = (0, $5WdrK.squeeze)(x);
        y = (0, $5WdrK.squeeze)(y);
        var xSize = (0, $5WdrK.arraySize)(x);
        var ySize = (0, $5WdrK.arraySize)(y);
        if (xSize.length !== 1 || ySize.length !== 1 || xSize[0] !== 3 || ySize[0] !== 3) throw new RangeError("Vectors with length 3 expected (Size A = [" + xSize.join(", ") + "], B = [" + ySize.join(", ") + "])");
        var product = [
            subtract(multiply(x[1], y[2]), multiply(x[2], y[1])),
            subtract(multiply(x[2], y[0]), multiply(x[0], y[2])),
            subtract(multiply(x[0], y[1]), multiply(x[1], y[0]))
        ];
        if (highestDimension > 1) return [
            product
        ];
        else return product;
    }
});

});

parcelRegister("aSKzv", function(module, exports) {

$parcel$export(module.exports, "createCsc", function () { return $7ec312b149a7e8a0$export$a0beb298aa7a2962; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");

var $2F5hp = parcelRequire("2F5hp");
var $7ec312b149a7e8a0$var$name = "csc";
var $7ec312b149a7e8a0$var$dependencies = [
    "typed",
    "BigNumber"
];
var $7ec312b149a7e8a0$export$a0beb298aa7a2962 = /* #__PURE__ */ (0, $2mPYl.factory)($7ec312b149a7e8a0$var$name, $7ec312b149a7e8a0$var$dependencies, function(_ref) {
    var typed = _ref.typed, _BigNumber = _ref.BigNumber;
    /**
   * Calculate the cosecant of a value, defined as `csc(x) = 1/sin(x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.csc(x)
   *
   * Examples:
   *
   *    math.csc(2)      // returns number 1.099750170294617
   *    1 / math.sin(2)  // returns number 1.099750170294617
   *
   * See also:
   *
   *    sin, sec, cot
   *
   * @param {number | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Cosecant of x
   */ var csc = typed($7ec312b149a7e8a0$var$name, {
        number: (0, $2F5hp.cscNumber),
        Complex: function Complex(x) {
            return x.csc();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x.sin());
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function csc is no angle");
            return csc(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, csc);
        }
    });
    return csc;
});

});

parcelRegister("yZ5Il", function(module, exports) {

$parcel$export(module.exports, "createCsch", function () { return $06929085e80f484b$export$9160aa3a39425fc9; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");

var $2F5hp = parcelRequire("2F5hp");
var $06929085e80f484b$var$name = "csch";
var $06929085e80f484b$var$dependencies = [
    "typed",
    "BigNumber"
];
var $06929085e80f484b$export$9160aa3a39425fc9 = /* #__PURE__ */ (0, $2mPYl.factory)($06929085e80f484b$var$name, $06929085e80f484b$var$dependencies, function(_ref) {
    var typed = _ref.typed, _BigNumber = _ref.BigNumber;
    /**
   * Calculate the hyperbolic cosecant of a value,
   * defined as `csch(x) = 1 / sinh(x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.csch(x)
   *
   * Examples:
   *
   *    // csch(x) = 1/ sinh(x)
   *    math.csch(0.5)       // returns 1.9190347513349437
   *    1 / math.sinh(0.5)   // returns 1.9190347513349437
   *
   * See also:
   *
   *    sinh, sech, coth
   *
   * @param {number | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic cosecant of x
   */ var csch = typed($06929085e80f484b$var$name, {
        number: (0, $2F5hp.cschNumber),
        Complex: function Complex(x) {
            return x.csch();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x.sinh());
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function csch is no angle");
            return csch(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, csch);
        }
    });
    return csch;
});

});

parcelRegister("gXhPT", function(module, exports) {

$parcel$export(module.exports, "createCtranspose", function () { return $c57ffde60401c1bc$export$5d07146b3894f212; });

var $2mPYl = parcelRequire("2mPYl");
var $c57ffde60401c1bc$var$name = "ctranspose";
var $c57ffde60401c1bc$var$dependencies = [
    "typed",
    "transpose",
    "conj"
];
var $c57ffde60401c1bc$export$5d07146b3894f212 = /* #__PURE__ */ (0, $2mPYl.factory)($c57ffde60401c1bc$var$name, $c57ffde60401c1bc$var$dependencies, function(_ref) {
    var typed = _ref.typed, transpose = _ref.transpose, conj = _ref.conj;
    /**
   * Transpose and complex conjugate a matrix. All values of the matrix are
   * reflected over its main diagonal and then the complex conjugate is
   * taken. This is equivalent to complex conjugation for scalars and
   * vectors.
   *
   * Syntax:
   *
   *     math.ctranspose(x)
   *
   * Examples:
   *
   *     const A = [[1, 2, 3], [4, 5, math.complex(6,7)]]
   *     math.ctranspose(A)               // returns [[1, 4], [2, 5], [3, {re:6,im:7}]]
   *
   * See also:
   *
   *     transpose, diag, inv, subset, squeeze
   *
   * @param {Array | Matrix} x  Matrix to be ctransposed
   * @return {Array | Matrix}   The ctransposed matrix
   */ return typed($c57ffde60401c1bc$var$name, {
        any: function any(x) {
            return conj(transpose(x));
        }
    });
});

});

parcelRegister("gCgDL", function(module, exports) {

$parcel$export(module.exports, "createCube", function () { return $c18d1a621e6896b7$export$ce223d612b94804b; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");

var $6fCew = parcelRequire("6fCew");
var $c18d1a621e6896b7$var$name = "cube";
var $c18d1a621e6896b7$var$dependencies = [
    "typed"
];
var $c18d1a621e6896b7$export$ce223d612b94804b = /* #__PURE__ */ (0, $2mPYl.factory)($c18d1a621e6896b7$var$name, $c18d1a621e6896b7$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Compute the cube of a value, `x * x * x`.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.cube(x)
   *
   * Examples:
   *
   *    math.cube(2)            // returns number 8
   *    math.pow(2, 3)          // returns number 8
   *    math.cube(4)            // returns number 64
   *    4 * 4 * 4               // returns number 64
   *
   *    math.cube([1, 2, 3, 4]) // returns Array [1, 8, 27, 64]
   *
   * See also:
   *
   *    multiply, square, pow, cbrt
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix | Unit} x  Number for which to calculate the cube
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix | Unit} Cube of x
   */ var cube = typed($c18d1a621e6896b7$var$name, {
        number: (0, $6fCew.cubeNumber),
        Complex: function Complex(x) {
            return x.mul(x).mul(x); // Is faster than pow(x, 3)
        },
        BigNumber: function BigNumber(x) {
            return x.times(x).times(x);
        },
        Fraction: function Fraction(x) {
            return x.pow(3); // Is faster than mul()mul()mul()
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since cube(0) = 0
            return (0, $e04i1.deepMap)(x, cube, true);
        },
        Unit: function Unit(x) {
            return x.pow(3);
        }
    });
    return cube;
});

});

parcelRegister("3PwsX", function(module, exports) {

$parcel$export(module.exports, "createDeepEqual", function () { return $2c9f519c3e0b4ffc$export$b1b11fc839367b58; });

var $2mPYl = parcelRequire("2mPYl");
var $2c9f519c3e0b4ffc$var$name = "deepEqual";
var $2c9f519c3e0b4ffc$var$dependencies = [
    "typed",
    "equal"
];
var $2c9f519c3e0b4ffc$export$b1b11fc839367b58 = /* #__PURE__ */ (0, $2mPYl.factory)($2c9f519c3e0b4ffc$var$name, $2c9f519c3e0b4ffc$var$dependencies, function(_ref) {
    var typed = _ref.typed, equal = _ref.equal;
    /**
   * Test element wise whether two matrices are equal.
   * The function accepts both matrices and scalar values.
   *
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.deepEqual(x, y)
   *
   * Examples:
   *
   *    math.deepEqual(2, 4)   // returns false
   *
   *    a = [2, 5, 1]
   *    b = [2, 7, 1]
   *
   *    math.deepEqual(a, b)   // returns false
   *    math.equal(a, b)       // returns [true, false, true]
   *
   * See also:
   *
   *    equal, unequal
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x First matrix to compare
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Second matrix to compare
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}
   *            Returns true when the input matrices have the same size and each of their elements is equal.
   */ return typed($2c9f519c3e0b4ffc$var$name, {
        "any, any": function anyAny(x, y) {
            return _deepEqual(x.valueOf(), y.valueOf());
        }
    });
    /**
   * Test whether two arrays have the same size and all elements are equal
   * @param {Array | *} x
   * @param {Array | *} y
   * @return {boolean} Returns true if both arrays are deep equal
   */ function _deepEqual(x, y) {
        if (Array.isArray(x)) {
            if (Array.isArray(y)) {
                var len = x.length;
                if (len !== y.length) return false;
                for(var i = 0; i < len; i++){
                    if (!_deepEqual(x[i], y[i])) return false;
                }
                return true;
            } else return false;
        } else {
            if (Array.isArray(y)) return false;
            else return equal(x, y);
        }
    }
});

});

parcelRegister("5I5uC", function(module, exports) {

$parcel$export(module.exports, "createDenseMatrixClass", function () { return $428552927857dccf$export$1a088ca8dd364cd1; });

var $1amHZ = parcelRequire("1amHZ");

var $5WdrK = parcelRequire("5WdrK");

var $6NxuJ = parcelRequire("6NxuJ");

var $kFRKb = parcelRequire("kFRKb");

var $7ITGG = parcelRequire("7ITGG");

var $hy7Bx = parcelRequire("hy7Bx");

var $2mPYl = parcelRequire("2mPYl");
var $428552927857dccf$var$name = "DenseMatrix";
var $428552927857dccf$var$dependencies = [
    "Matrix"
];
var $428552927857dccf$export$1a088ca8dd364cd1 = /* #__PURE__ */ (0, $2mPYl.factory)($428552927857dccf$var$name, $428552927857dccf$var$dependencies, function(_ref) {
    var Matrix = _ref.Matrix;
    /**
   * Dense Matrix implementation. A regular, dense matrix, supporting multi-dimensional matrices. This is the default matrix type.
   * @class DenseMatrix
   */ function DenseMatrix(data, datatype) {
        if (!(this instanceof DenseMatrix)) throw new SyntaxError("Constructor must be called with the new operator");
        if (datatype && !(0, $1amHZ.isString)(datatype)) throw new Error("Invalid datatype: " + datatype);
        if ((0, $1amHZ.isMatrix)(data)) {
            // check data is a DenseMatrix
            if (data.type === "DenseMatrix") {
                // clone data & size
                this._data = (0, $7ITGG.clone)(data._data);
                this._size = (0, $7ITGG.clone)(data._size);
                this._datatype = datatype || data._datatype;
            } else {
                // build data from existing matrix
                this._data = data.toArray();
                this._size = data.size();
                this._datatype = datatype || data._datatype;
            }
        } else if (data && (0, $1amHZ.isArray)(data.data) && (0, $1amHZ.isArray)(data.size)) {
            // initialize fields from JSON representation
            this._data = data.data;
            this._size = data.size; // verify the dimensions of the array
            (0, $5WdrK.validate)(this._data, this._size);
            this._datatype = datatype || data.datatype;
        } else if ((0, $1amHZ.isArray)(data)) {
            // replace nested Matrices with Arrays
            this._data = preprocess(data); // get the dimensions of the array
            this._size = (0, $5WdrK.arraySize)(this._data); // verify the dimensions of the array, TODO: compute size while processing array
            (0, $5WdrK.validate)(this._data, this._size); // data type unknown
            this._datatype = datatype;
        } else if (data) // unsupported type
        throw new TypeError("Unsupported type of data (" + (0, $1amHZ.typeOf)(data) + ")");
        else {
            // nothing provided
            this._data = [];
            this._size = [
                0
            ];
            this._datatype = datatype;
        }
    }
    DenseMatrix.prototype = new Matrix();
    /**
   * Create a new DenseMatrix
   */ DenseMatrix.prototype.createDenseMatrix = function(data, datatype) {
        return new DenseMatrix(data, datatype);
    };
    /**
   * Attach type information
   */ DenseMatrix.prototype.type = "DenseMatrix";
    DenseMatrix.prototype.isDenseMatrix = true;
    /**
   * Get the matrix type
   *
   * Usage:
   *    const matrixType = matrix.getDataType()  // retrieves the matrix type
   *
   * @memberOf DenseMatrix
   * @return {string}   type information; if multiple types are found from the Matrix, it will return "mixed"
   */ DenseMatrix.prototype.getDataType = function() {
        return (0, $5WdrK.getArrayDataType)(this._data, (0, $1amHZ.typeOf));
    };
    /**
   * Get the storage format used by the matrix.
   *
   * Usage:
   *     const format = matrix.storage()  // retrieve storage format
   *
   * @memberof DenseMatrix
   * @return {string}           The storage format.
   */ DenseMatrix.prototype.storage = function() {
        return "dense";
    };
    /**
   * Get the datatype of the data stored in the matrix.
   *
   * Usage:
   *     const format = matrix.datatype()   // retrieve matrix datatype
   *
   * @memberof DenseMatrix
   * @return {string}           The datatype.
   */ DenseMatrix.prototype.datatype = function() {
        return this._datatype;
    };
    /**
   * Create a new DenseMatrix
   * @memberof DenseMatrix
   * @param {Array} data
   * @param {string} [datatype]
   */ DenseMatrix.prototype.create = function(data, datatype) {
        return new DenseMatrix(data, datatype);
    };
    /**
   * Get a subset of the matrix, or replace a subset of the matrix.
   *
   * Usage:
   *     const subset = matrix.subset(index)               // retrieve subset
   *     const value = matrix.subset(index, replacement)   // replace subset
   *
   * @memberof DenseMatrix
   * @param {Index} index
   * @param {Array | Matrix | *} [replacement]
   * @param {*} [defaultValue=0]      Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be filled with zeros.
   */ DenseMatrix.prototype.subset = function(index, replacement, defaultValue) {
        switch(arguments.length){
            case 1:
                return _get(this, index);
            // intentional fall through
            case 2:
            case 3:
                return _set(this, index, replacement, defaultValue);
            default:
                throw new SyntaxError("Wrong number of arguments");
        }
    };
    /**
   * Get a single element from the matrix.
   * @memberof DenseMatrix
   * @param {number[]} index   Zero-based index
   * @return {*} value
   */ DenseMatrix.prototype.get = function(index) {
        if (!(0, $1amHZ.isArray)(index)) throw new TypeError("Array expected");
        if (index.length !== this._size.length) throw new (0, $hy7Bx.DimensionError)(index.length, this._size.length);
         // check index
        for(var x = 0; x < index.length; x++)(0, $5WdrK.validateIndex)(index[x], this._size[x]);
        var data = this._data;
        for(var i = 0, ii = index.length; i < ii; i++){
            var indexI = index[i];
            (0, $5WdrK.validateIndex)(indexI, data.length);
            data = data[indexI];
        }
        return data;
    };
    /**
   * Replace a single element in the matrix.
   * @memberof DenseMatrix
   * @param {number[]} index   Zero-based index
   * @param {*} value
   * @param {*} [defaultValue]        Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be left undefined.
   * @return {DenseMatrix} self
   */ DenseMatrix.prototype.set = function(index, value, defaultValue) {
        if (!(0, $1amHZ.isArray)(index)) throw new TypeError("Array expected");
        if (index.length < this._size.length) throw new (0, $hy7Bx.DimensionError)(index.length, this._size.length, "<");
        var i, ii, indexI; // enlarge matrix when needed
        var size = index.map(function(i) {
            return i + 1;
        });
        _fit(this, size, defaultValue); // traverse over the dimensions
        var data = this._data;
        for(i = 0, ii = index.length - 1; i < ii; i++){
            indexI = index[i];
            (0, $5WdrK.validateIndex)(indexI, data.length);
            data = data[indexI];
        } // set new value
        indexI = index[index.length - 1];
        (0, $5WdrK.validateIndex)(indexI, data.length);
        data[indexI] = value;
        return this;
    };
    /**
   * Get a submatrix of this matrix
   * @memberof DenseMatrix
   * @param {DenseMatrix} matrix
   * @param {Index} index   Zero-based index
   * @private
   */ function _get(matrix, index) {
        if (!(0, $1amHZ.isIndex)(index)) throw new TypeError("Invalid index");
        var isScalar = index.isScalar();
        if (isScalar) // return a scalar
        return matrix.get(index.min());
        else {
            // validate dimensions
            var size = index.size();
            if (size.length !== matrix._size.length) throw new (0, $hy7Bx.DimensionError)(size.length, matrix._size.length);
             // validate if any of the ranges in the index is out of range
            var min = index.min();
            var max = index.max();
            for(var i = 0, ii = matrix._size.length; i < ii; i++){
                (0, $5WdrK.validateIndex)(min[i], matrix._size[i]);
                (0, $5WdrK.validateIndex)(max[i], matrix._size[i]);
            } // retrieve submatrix
            // TODO: more efficient when creating an empty matrix and setting _data and _size manually
            return new DenseMatrix(_getSubmatrix(matrix._data, index, size.length, 0), matrix._datatype);
        }
    }
    /**
   * Recursively get a submatrix of a multi dimensional matrix.
   * Index is not checked for correct number or length of dimensions.
   * @memberof DenseMatrix
   * @param {Array} data
   * @param {Index} index
   * @param {number} dims   Total number of dimensions
   * @param {number} dim    Current dimension
   * @return {Array} submatrix
   * @private
   */ function _getSubmatrix(data, index, dims, dim) {
        var last = dim === dims - 1;
        var range = index.dimension(dim);
        if (last) return range.map(function(i) {
            (0, $5WdrK.validateIndex)(i, data.length);
            return data[i];
        }).valueOf();
        else return range.map(function(i) {
            (0, $5WdrK.validateIndex)(i, data.length);
            var child = data[i];
            return _getSubmatrix(child, index, dims, dim + 1);
        }).valueOf();
    }
    /**
   * Replace a submatrix in this matrix
   * Indexes are zero-based.
   * @memberof DenseMatrix
   * @param {DenseMatrix} matrix
   * @param {Index} index
   * @param {DenseMatrix | Array | *} submatrix
   * @param {*} defaultValue          Default value, filled in on new entries when
   *                                  the matrix is resized.
   * @return {DenseMatrix} matrix
   * @private
   */ function _set(matrix, index, submatrix, defaultValue) {
        if (!index || index.isIndex !== true) throw new TypeError("Invalid index");
         // get index size and check whether the index contains a single value
        var iSize = index.size();
        var isScalar = index.isScalar(); // calculate the size of the submatrix, and convert it into an Array if needed
        var sSize;
        if ((0, $1amHZ.isMatrix)(submatrix)) {
            sSize = submatrix.size();
            submatrix = submatrix.valueOf();
        } else sSize = (0, $5WdrK.arraySize)(submatrix);
        if (isScalar) {
            // set a scalar
            // check whether submatrix is a scalar
            if (sSize.length !== 0) throw new TypeError("Scalar expected");
            matrix.set(index.min(), submatrix, defaultValue);
        } else {
            // set a submatrix
            // validate dimensions
            if (iSize.length < matrix._size.length) throw new (0, $hy7Bx.DimensionError)(iSize.length, matrix._size.length, "<");
            if (sSize.length < iSize.length) {
                // calculate number of missing outer dimensions
                var i = 0;
                var outer = 0;
                while(iSize[i] === 1 && sSize[i] === 1)i++;
                while(iSize[i] === 1){
                    outer++;
                    i++;
                } // unsqueeze both outer and inner dimensions
                submatrix = (0, $5WdrK.unsqueeze)(submatrix, iSize.length, outer, sSize);
            } // check whether the size of the submatrix matches the index size
            if (!(0, $7ITGG.deepStrictEqual)(iSize, sSize)) throw new (0, $hy7Bx.DimensionError)(iSize, sSize, ">");
             // enlarge matrix when needed
            var size = index.max().map(function(i) {
                return i + 1;
            });
            _fit(matrix, size, defaultValue); // insert the sub matrix
            var dims = iSize.length;
            var dim = 0;
            _setSubmatrix(matrix._data, index, submatrix, dims, dim);
        }
        return matrix;
    }
    /**
   * Replace a submatrix of a multi dimensional matrix.
   * @memberof DenseMatrix
   * @param {Array} data
   * @param {Index} index
   * @param {Array} submatrix
   * @param {number} dims   Total number of dimensions
   * @param {number} dim
   * @private
   */ function _setSubmatrix(data, index, submatrix, dims, dim) {
        var last = dim === dims - 1;
        var range = index.dimension(dim);
        if (last) range.forEach(function(dataIndex, subIndex) {
            (0, $5WdrK.validateIndex)(dataIndex);
            data[dataIndex] = submatrix[subIndex[0]];
        });
        else range.forEach(function(dataIndex, subIndex) {
            (0, $5WdrK.validateIndex)(dataIndex);
            _setSubmatrix(data[dataIndex], index, submatrix[subIndex[0]], dims, dim + 1);
        });
    }
    /**
   * Resize the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (resize in place).
   *
   * @memberof DenseMatrix
   * @param {number[]} size           The new size the matrix should have.
   * @param {*} [defaultValue=0]      Default value, filled in on new entries.
   *                                  If not provided, the matrix elements will
   *                                  be filled with zeros.
   * @param {boolean} [copy]          Return a resized copy of the matrix
   *
   * @return {Matrix}                 The resized matrix
   */ DenseMatrix.prototype.resize = function(size, defaultValue, copy) {
        // validate arguments
        if (!(0, $1amHZ.isArray)(size)) throw new TypeError("Array expected");
         // matrix to resize
        var m = copy ? this.clone() : this; // resize matrix
        return _resize(m, size, defaultValue);
    };
    function _resize(matrix, size, defaultValue) {
        // check size
        if (size.length === 0) {
            // first value in matrix
            var v = matrix._data; // go deep
            while((0, $1amHZ.isArray)(v))v = v[0];
            return v;
        } // resize matrix
        matrix._size = size.slice(0); // copy the array
        matrix._data = (0, $5WdrK.resize)(matrix._data, matrix._size, defaultValue); // return matrix
        return matrix;
    }
    /**
   * Reshape the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (reshape in place).
   *
   * NOTE: This might be better suited to copy by default, instead of modifying
   *       in place. For now, it operates in place to remain consistent with
   *       resize().
   *
   * @memberof DenseMatrix
   * @param {number[]} size           The new size the matrix should have.
   * @param {boolean} [copy]          Return a reshaped copy of the matrix
   *
   * @return {Matrix}                 The reshaped matrix
   */ DenseMatrix.prototype.reshape = function(size, copy) {
        var m = copy ? this.clone() : this;
        m._data = (0, $5WdrK.reshape)(m._data, size);
        m._size = size.slice(0);
        return m;
    };
    /**
   * Enlarge the matrix when it is smaller than given size.
   * If the matrix is larger or equal sized, nothing is done.
   * @memberof DenseMatrix
   * @param {DenseMatrix} matrix           The matrix to be resized
   * @param {number[]} size
   * @param {*} defaultValue          Default value, filled in on new entries.
   * @private
   */ function _fit(matrix, size, defaultValue) {
        var newSize = matrix._size.slice(0);
        var changed = false; // add dimensions when needed
        while(newSize.length < size.length){
            newSize.push(0);
            changed = true;
        } // enlarge size when needed
        for(var i = 0, ii = size.length; i < ii; i++)if (size[i] > newSize[i]) {
            newSize[i] = size[i];
            changed = true;
        }
        if (changed) // resize only when size is changed
        _resize(matrix, newSize, defaultValue);
    }
    /**
   * Create a clone of the matrix
   * @memberof DenseMatrix
   * @return {DenseMatrix} clone
   */ DenseMatrix.prototype.clone = function() {
        var m = new DenseMatrix({
            data: (0, $7ITGG.clone)(this._data),
            size: (0, $7ITGG.clone)(this._size),
            datatype: this._datatype
        });
        return m;
    };
    /**
   * Retrieve the size of the matrix.
   * @memberof DenseMatrix
   * @returns {number[]} size
   */ DenseMatrix.prototype.size = function() {
        return this._size.slice(0); // return a clone of _size
    };
    /**
   * Create a new matrix with the results of the callback function executed on
   * each entry of the matrix.
   * @memberof DenseMatrix
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   *
   * @return {DenseMatrix} matrix
   */ DenseMatrix.prototype.map = function(callback) {
        // matrix instance
        var me = this;
        var recurse = function recurse(value, index) {
            if ((0, $1amHZ.isArray)(value)) return value.map(function(child, i) {
                return recurse(child, index.concat(i));
            });
            else return callback(value, index, me);
        }; // determine the new datatype when the original matrix has datatype defined
        // TODO: should be done in matrix constructor instead
        var data = recurse(this._data, []);
        var datatype = this._datatype !== undefined ? (0, $5WdrK.getArrayDataType)(data, (0, $1amHZ.typeOf)) : undefined;
        return new DenseMatrix(data, datatype);
    };
    /**
   * Execute a callback function on each entry of the matrix.
   * @memberof DenseMatrix
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   */ DenseMatrix.prototype.forEach = function(callback) {
        // matrix instance
        var me = this;
        var recurse = function recurse(value, index) {
            if ((0, $1amHZ.isArray)(value)) value.forEach(function(child, i) {
                recurse(child, index.concat(i));
            });
            else callback(value, index, me);
        };
        recurse(this._data, []);
    };
    /**
   * Create an Array with a copy of the data of the DenseMatrix
   * @memberof DenseMatrix
   * @returns {Array} array
   */ DenseMatrix.prototype.toArray = function() {
        return (0, $7ITGG.clone)(this._data);
    };
    /**
   * Get the primitive value of the DenseMatrix: a multidimensional array
   * @memberof DenseMatrix
   * @returns {Array} array
   */ DenseMatrix.prototype.valueOf = function() {
        return this._data;
    };
    /**
   * Get a string representation of the matrix, with optional formatting options.
   * @memberof DenseMatrix
   * @param {Object | number | Function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @returns {string} str
   */ DenseMatrix.prototype.format = function(options) {
        return (0, $6NxuJ.format)(this._data, options);
    };
    /**
   * Get a string representation of the matrix
   * @memberof DenseMatrix
   * @returns {string} str
   */ DenseMatrix.prototype.toString = function() {
        return (0, $6NxuJ.format)(this._data);
    };
    /**
   * Get a JSON representation of the matrix
   * @memberof DenseMatrix
   * @returns {Object}
   */ DenseMatrix.prototype.toJSON = function() {
        return {
            mathjs: "DenseMatrix",
            data: this._data,
            size: this._size,
            datatype: this._datatype
        };
    };
    /**
   * Get the kth Matrix diagonal.
   *
   * @memberof DenseMatrix
   * @param {number | BigNumber} [k=0]     The kth diagonal where the vector will retrieved.
   *
   * @returns {Matrix}                     The matrix with the diagonal values.
   */ DenseMatrix.prototype.diagonal = function(k) {
        // validate k if any
        if (k) {
            // convert BigNumber to a number
            if ((0, $1amHZ.isBigNumber)(k)) k = k.toNumber();
             // is must be an integer
            if (!(0, $1amHZ.isNumber)(k) || !(0, $kFRKb.isInteger)(k)) throw new TypeError("The parameter k must be an integer number");
        } else // default value
        k = 0;
        var kSuper = k > 0 ? k : 0;
        var kSub = k < 0 ? -k : 0; // rows & columns
        var rows = this._size[0];
        var columns = this._size[1]; // number diagonal values
        var n = Math.min(rows - kSub, columns - kSuper); // x is a matrix get diagonal from matrix
        var data = []; // loop rows
        for(var i = 0; i < n; i++)data[i] = this._data[i + kSub][i + kSuper];
         // create DenseMatrix
        return new DenseMatrix({
            data: data,
            size: [
                n
            ],
            datatype: this._datatype
        });
    };
    /**
   * Create a diagonal matrix.
   *
   * @memberof DenseMatrix
   * @param {Array} size                     The matrix size.
   * @param {number | Matrix | Array } value The values for the diagonal.
   * @param {number | BigNumber} [k=0]       The kth diagonal where the vector will be filled in.
   * @param {number} [defaultValue]          The default value for non-diagonal
   * @param {string} [datatype]              The datatype for the diagonal
   *
   * @returns {DenseMatrix}
   */ DenseMatrix.diagonal = function(size, value, k, defaultValue) {
        if (!(0, $1amHZ.isArray)(size)) throw new TypeError("Array expected, size parameter");
        if (size.length !== 2) throw new Error("Only two dimensions matrix are supported");
         // map size & validate
        size = size.map(function(s) {
            // check it is a big number
            if ((0, $1amHZ.isBigNumber)(s)) // convert it
            s = s.toNumber();
             // validate arguments
            if (!(0, $1amHZ.isNumber)(s) || !(0, $kFRKb.isInteger)(s) || s < 1) throw new Error("Size values must be positive integers");
            return s;
        }); // validate k if any
        if (k) {
            // convert BigNumber to a number
            if ((0, $1amHZ.isBigNumber)(k)) k = k.toNumber();
             // is must be an integer
            if (!(0, $1amHZ.isNumber)(k) || !(0, $kFRKb.isInteger)(k)) throw new TypeError("The parameter k must be an integer number");
        } else // default value
        k = 0;
        var kSuper = k > 0 ? k : 0;
        var kSub = k < 0 ? -k : 0; // rows and columns
        var rows = size[0];
        var columns = size[1]; // number of non-zero items
        var n = Math.min(rows - kSub, columns - kSuper); // value extraction function
        var _value; // check value
        if ((0, $1amHZ.isArray)(value)) {
            // validate array
            if (value.length !== n) // number of values in array must be n
            throw new Error("Invalid value array length");
             // define function
            _value = function _value(i) {
                // return value @ i
                return value[i];
            };
        } else if ((0, $1amHZ.isMatrix)(value)) {
            // matrix size
            var ms = value.size(); // validate matrix
            if (ms.length !== 1 || ms[0] !== n) // number of values in array must be n
            throw new Error("Invalid matrix length");
             // define function
            _value = function _value(i) {
                // return value @ i
                return value.get([
                    i
                ]);
            };
        } else // define function
        _value = function _value() {
            // return value
            return value;
        };
         // discover default value if needed
        if (!defaultValue) // check first value in array
        defaultValue = (0, $1amHZ.isBigNumber)(_value(0)) ? _value(0).mul(0) // trick to create a BigNumber with value zero
         : 0;
         // empty array
        var data = []; // check we need to resize array
        if (size.length > 0) {
            // resize array
            data = (0, $5WdrK.resize)(data, size, defaultValue); // fill diagonal
            for(var d = 0; d < n; d++)data[d + kSub][d + kSuper] = _value(d);
        } // create DenseMatrix
        return new DenseMatrix({
            data: data,
            size: [
                rows,
                columns
            ]
        });
    };
    /**
   * Generate a matrix from a JSON object
   * @memberof DenseMatrix
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "DenseMatrix", data: [], size: []}`,
   *                       where mathjs is optional
   * @returns {DenseMatrix}
   */ DenseMatrix.fromJSON = function(json) {
        return new DenseMatrix(json);
    };
    /**
   * Swap rows i and j in Matrix.
   *
   * @memberof DenseMatrix
   * @param {number} i       Matrix row index 1
   * @param {number} j       Matrix row index 2
   *
   * @return {Matrix}        The matrix reference
   */ DenseMatrix.prototype.swapRows = function(i, j) {
        // check index
        if (!(0, $1amHZ.isNumber)(i) || !(0, $kFRKb.isInteger)(i) || !(0, $1amHZ.isNumber)(j) || !(0, $kFRKb.isInteger)(j)) throw new Error("Row index must be positive integers");
         // check dimensions
        if (this._size.length !== 2) throw new Error("Only two dimensional matrix is supported");
         // validate index
        (0, $5WdrK.validateIndex)(i, this._size[0]);
        (0, $5WdrK.validateIndex)(j, this._size[0]); // swap rows
        DenseMatrix._swapRows(i, j, this._data); // return current instance
        return this;
    };
    /**
   * Swap rows i and j in Dense Matrix data structure.
   *
   * @param {number} i       Matrix row index 1
   * @param {number} j       Matrix row index 2
   * @param {Array} data     Matrix data
   */ DenseMatrix._swapRows = function(i, j, data) {
        // swap values i <-> j
        var vi = data[i];
        data[i] = data[j];
        data[j] = vi;
    };
    /**
   * Preprocess data, which can be an Array or DenseMatrix with nested Arrays and
   * Matrices. Replaces all nested Matrices with Arrays
   * @memberof DenseMatrix
   * @param {Array} data
   * @return {Array} data
   */ function preprocess(data) {
        for(var i = 0, ii = data.length; i < ii; i++){
            var elem = data[i];
            if ((0, $1amHZ.isArray)(elem)) data[i] = preprocess(elem);
            else if (elem && elem.isMatrix === true) data[i] = preprocess(elem.valueOf());
        }
        return data;
    }
    return DenseMatrix;
}, {
    isClass: true
});

});

parcelRegister("1lMmn", function(module, exports) {

$parcel$export(module.exports, "createDet", function () { return $0fbd43e318505bb9$export$93f810683c54b005; });

var $1amHZ = parcelRequire("1amHZ");

var $7ITGG = parcelRequire("7ITGG");

var $6NxuJ = parcelRequire("6NxuJ");

var $2mPYl = parcelRequire("2mPYl");
var $0fbd43e318505bb9$var$name = "det";
var $0fbd43e318505bb9$var$dependencies = [
    "typed",
    "matrix",
    "subtract",
    "multiply",
    "unaryMinus",
    "lup"
];
var $0fbd43e318505bb9$export$93f810683c54b005 = /* #__PURE__ */ (0, $2mPYl.factory)($0fbd43e318505bb9$var$name, $0fbd43e318505bb9$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, subtract = _ref.subtract, multiply = _ref.multiply, unaryMinus = _ref.unaryMinus, lup = _ref.lup;
    /**
   * Calculate the determinant of a matrix.
   *
   * Syntax:
   *
   *    math.det(x)
   *
   * Examples:
   *
   *    math.det([[1, 2], [3, 4]]) // returns -2
   *
   *    const A = [
   *      [-2, 2, 3],
   *      [-1, 1, 3],
   *      [2, 0, -1]
   *    ]
   *    math.det(A) // returns 6
   *
   * See also:
   *
   *    inv
   *
   * @param {Array | Matrix} x  A matrix
   * @return {number} The determinant of `x`
   */ return typed($0fbd43e318505bb9$var$name, {
        any: function any(x) {
            return (0, $7ITGG.clone)(x);
        },
        "Array | Matrix": function det(x) {
            var size;
            if ((0, $1amHZ.isMatrix)(x)) size = x.size();
            else if (Array.isArray(x)) {
                x = matrix(x);
                size = x.size();
            } else // a scalar
            size = [];
            switch(size.length){
                case 0:
                    // scalar
                    return (0, $7ITGG.clone)(x);
                case 1:
                    // vector
                    if (size[0] === 1) return (0, $7ITGG.clone)(x.valueOf()[0]);
                    else throw new RangeError("Matrix must be square (size: " + (0, $6NxuJ.format)(size) + ")");
                case 2:
                    // two dimensional array
                    var rows = size[0];
                    var cols = size[1];
                    if (rows === cols) return _det(x.clone().valueOf(), rows, cols);
                    else throw new RangeError("Matrix must be square (size: " + (0, $6NxuJ.format)(size) + ")");
                default:
                    // multi dimensional array
                    throw new RangeError("Matrix must be two dimensional (size: " + (0, $6NxuJ.format)(size) + ")");
            }
        }
    });
    /**
   * Calculate the determinant of a matrix
   * @param {Array[]} matrix  A square, two dimensional matrix
   * @param {number} rows     Number of rows of the matrix (zero-based)
   * @param {number} cols     Number of columns of the matrix (zero-based)
   * @returns {number} det
   * @private
   */ function _det(matrix, rows, cols) {
        if (rows === 1) // this is a 1 x 1 matrix
        return (0, $7ITGG.clone)(matrix[0][0]);
        else if (rows === 2) // this is a 2 x 2 matrix
        // the determinant of [a11,a12;a21,a22] is det = a11*a22-a21*a12
        return subtract(multiply(matrix[0][0], matrix[1][1]), multiply(matrix[1][0], matrix[0][1]));
        else {
            // Compute the LU decomposition
            var decomp = lup(matrix); // The determinant is the product of the diagonal entries of U (and those of L, but they are all 1)
            var det = decomp.U[0][0];
            for(var _i = 1; _i < rows; _i++)det = multiply(det, decomp.U[_i][_i]);
             // The determinant will be multiplied by 1 or -1 depending on the parity of the permutation matrix.
            // This can be determined by counting the cycles. This is roughly a linear time algorithm.
            var evenCycles = 0;
            var i = 0;
            var visited = [];
            while(true){
                while(visited[i])i++;
                if (i >= rows) break;
                var j = i;
                var cycleLen = 0;
                while(!visited[decomp.p[j]]){
                    visited[decomp.p[j]] = true;
                    j = decomp.p[j];
                    cycleLen++;
                }
                if (cycleLen % 2 === 0) evenCycles++;
            }
            return evenCycles % 2 === 0 ? det : unaryMinus(det);
        }
    }
});

});

parcelRegister("iyczN", function(module, exports) {

$parcel$export(module.exports, "createDiag", function () { return $d81528590f588012$export$743a950f2cd4bacc; });

var $1amHZ = parcelRequire("1amHZ");

var $5WdrK = parcelRequire("5WdrK");

var $kFRKb = parcelRequire("kFRKb");

var $2mPYl = parcelRequire("2mPYl");
var $d81528590f588012$var$name = "diag";
var $d81528590f588012$var$dependencies = [
    "typed",
    "matrix",
    "DenseMatrix",
    "SparseMatrix"
];
var $d81528590f588012$export$743a950f2cd4bacc = /* #__PURE__ */ (0, $2mPYl.factory)($d81528590f588012$var$name, $d81528590f588012$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, DenseMatrix = _ref.DenseMatrix, SparseMatrix = _ref.SparseMatrix;
    /**
   * Create a diagonal matrix or retrieve the diagonal of a matrix
   *
   * When `x` is a vector, a matrix with vector `x` on the diagonal will be returned.
   * When `x` is a two dimensional matrix, the matrixes `k`th diagonal will be returned as vector.
   * When k is positive, the values are placed on the super diagonal.
   * When k is negative, the values are placed on the sub diagonal.
   *
   * Syntax:
   *
   *     math.diag(X)
   *     math.diag(X, format)
   *     math.diag(X, k)
   *     math.diag(X, k, format)
   *
   * Examples:
   *
   *     // create a diagonal matrix
   *     math.diag([1, 2, 3])      // returns [[1, 0, 0], [0, 2, 0], [0, 0, 3]]
   *     math.diag([1, 2, 3], 1)   // returns [[0, 1, 0, 0], [0, 0, 2, 0], [0, 0, 0, 3]]
   *     math.diag([1, 2, 3], -1)  // returns [[0, 0, 0], [1, 0, 0], [0, 2, 0], [0, 0, 3]]
   *
   *    // retrieve the diagonal from a matrix
   *    const a = [[1, 2, 3], [4, 5, 6], [7, 8, 9]]
   *    math.diag(a)   // returns [1, 5, 9]
   *
   * See also:
   *
   *     ones, zeros, identity
   *
   * @param {Matrix | Array} x          A two dimensional matrix or a vector
   * @param {number | BigNumber} [k=0]  The diagonal where the vector will be filled
   *                                    in or retrieved.
   * @param {string} [format='dense']   The matrix storage format.
   *
   * @returns {Matrix | Array} Diagonal matrix from input vector, or diagonal from input matrix.
   */ return typed($d81528590f588012$var$name, {
        // FIXME: simplify this huge amount of signatures as soon as typed-function supports optional arguments
        Array: function Array(x) {
            return _diag(x, 0, (0, $5WdrK.arraySize)(x), null);
        },
        "Array, number": function ArrayNumber(x, k) {
            return _diag(x, k, (0, $5WdrK.arraySize)(x), null);
        },
        "Array, BigNumber": function ArrayBigNumber(x, k) {
            return _diag(x, k.toNumber(), (0, $5WdrK.arraySize)(x), null);
        },
        "Array, string": function ArrayString(x, format) {
            return _diag(x, 0, (0, $5WdrK.arraySize)(x), format);
        },
        "Array, number, string": function ArrayNumberString(x, k, format) {
            return _diag(x, k, (0, $5WdrK.arraySize)(x), format);
        },
        "Array, BigNumber, string": function ArrayBigNumberString(x, k, format) {
            return _diag(x, k.toNumber(), (0, $5WdrK.arraySize)(x), format);
        },
        Matrix: function Matrix(x) {
            return _diag(x, 0, x.size(), x.storage());
        },
        "Matrix, number": function MatrixNumber(x, k) {
            return _diag(x, k, x.size(), x.storage());
        },
        "Matrix, BigNumber": function MatrixBigNumber(x, k) {
            return _diag(x, k.toNumber(), x.size(), x.storage());
        },
        "Matrix, string": function MatrixString(x, format) {
            return _diag(x, 0, x.size(), format);
        },
        "Matrix, number, string": function MatrixNumberString(x, k, format) {
            return _diag(x, k, x.size(), format);
        },
        "Matrix, BigNumber, string": function MatrixBigNumberString(x, k, format) {
            return _diag(x, k.toNumber(), x.size(), format);
        }
    });
    /**
   * Creeate diagonal matrix from a vector or vice versa
   * @param {Array | Matrix} x
   * @param {number} k
   * @param {string} format Storage format for matrix. If null,
   *                          an Array is returned
   * @returns {Array | Matrix}
   * @private
   */ function _diag(x, k, size, format) {
        if (!(0, $kFRKb.isInteger)(k)) throw new TypeError("Second parameter in function diag must be an integer");
        var kSuper = k > 0 ? k : 0;
        var kSub = k < 0 ? -k : 0; // check dimensions
        switch(size.length){
            case 1:
                return _createDiagonalMatrix(x, k, format, size[0], kSub, kSuper);
            case 2:
                return _getDiagonal(x, k, format, size, kSub, kSuper);
        }
        throw new RangeError("Matrix for function diag must be 2 dimensional");
    }
    function _createDiagonalMatrix(x, k, format, l, kSub, kSuper) {
        // matrix size
        var ms = [
            l + kSub,
            l + kSuper
        ];
        if (format && format !== "sparse" && format !== "dense") throw new TypeError("Unknown matrix type ".concat(format, '"'));
         // create diagonal matrix
        var m = format === "sparse" ? SparseMatrix.diagonal(ms, x, k) : DenseMatrix.diagonal(ms, x, k); // check we need to return a matrix
        return format !== null ? m : m.valueOf();
    }
    function _getDiagonal(x, k, format, s, kSub, kSuper) {
        // check x is a Matrix
        if ((0, $1amHZ.isMatrix)(x)) {
            // get diagonal matrix
            var dm = x.diagonal(k); // check we need to return a matrix
            if (format !== null) {
                // check we need to change matrix format
                if (format !== dm.storage()) return matrix(dm, format);
                return dm;
            }
            return dm.valueOf();
        } // vector size
        var n = Math.min(s[0] - kSub, s[1] - kSuper); // diagonal values
        var vector = []; // loop diagonal
        for(var i = 0; i < n; i++)vector[i] = x[i + kSub][i + kSuper];
         // check we need to return a matrix
        return format !== null ? matrix(vector) : vector;
    }
});

});

parcelRegister("6P0H6", function(module, exports) {

$parcel$export(module.exports, "createDistance", function () { return $4f780b5875722d67$export$23f482ad1a94fa7e; });

var $1amHZ = parcelRequire("1amHZ");

var $2mPYl = parcelRequire("2mPYl");
var $4f780b5875722d67$var$name = "distance";
var $4f780b5875722d67$var$dependencies = [
    "typed",
    "addScalar",
    "subtract",
    "divideScalar",
    "multiplyScalar",
    "unaryMinus",
    "sqrt",
    "abs"
];
var $4f780b5875722d67$export$23f482ad1a94fa7e = /* #__PURE__ */ (0, $2mPYl.factory)($4f780b5875722d67$var$name, $4f780b5875722d67$var$dependencies, function(_ref) {
    var typed = _ref.typed, addScalar = _ref.addScalar, subtract = _ref.subtract, multiplyScalar = _ref.multiplyScalar, divideScalar = _ref.divideScalar, unaryMinus = _ref.unaryMinus, sqrt = _ref.sqrt, abs = _ref.abs;
    /**
    * Calculates:
    *    The eucledian distance between two points in N-dimensional spaces.
    *    Distance between point and a line in 2 and 3 dimensional spaces.
    *    Pairwise distance between a set of 2D or 3D points
    * NOTE:
    *    When substituting coefficients of a line(a, b and c), use ax + by + c = 0 instead of ax + by = c
    *    For parametric equation of a 3D line, x0, y0, z0, a, b, c are from: (x−x0, y−y0, z−z0) = t(a, b, c)
    *
    * Syntax:
    *    math.distance([x1, y1], [x2, y2])
    *-   math.distance({pointOneX: 4, pointOneY: 5}, {pointTwoX: 2, pointTwoY: 7})
    *    math.distance([x1, y1, z1], [x2, y2, z2])
    *    math.distance({pointOneX: 4, pointOneY: 5, pointOneZ: 8}, {pointTwoX: 2, pointTwoY: 7, pointTwoZ: 9})
    *    math.distance([x1, y1, ... , N1], [x2, y2, ... , N2])
    *    math.distance([[A], [B], [C]...])
    *    math.distance([x1, y1], [LinePtX1, LinePtY1], [LinePtX2, LinePtY2])
    *    math.distance({pointX: 1, pointY: 4}, {lineOnePtX: 6, lineOnePtY: 3}, {lineTwoPtX: 2, lineTwoPtY: 8})
    *    math.distance([x1, y1, z1], [LinePtX1, LinePtY1, LinePtZ1], [LinePtX2, LinePtY2, LinePtZ2])
    *    math.distance({pointX: 1, pointY: 4, pointZ: 7}, {lineOnePtX: 6, lineOnePtY: 3, lineOnePtZ: 4}, {lineTwoPtX: 2, lineTwoPtY: 8, lineTwoPtZ: 5})
    *    math.distance([x1, y1], [xCoeffLine, yCoeffLine, constant])
    *    math.distance({pointX: 10, pointY: 10}, {xCoeffLine: 8, yCoeffLine: 1, constant: 3})
    *    math.distance([x1, y1, z1], [x0, y0, z0, a-tCoeff, b-tCoeff, c-tCoeff]) point and parametric equation of 3D line
    *    math.distance([x, y, z], [x0, y0, z0, a, b, c])
    *    math.distance({pointX: 2, pointY: 5, pointZ: 9}, {x0: 4, y0: 6, z0: 3, a: 4, b: 2, c: 0})
    *
    * Examples:
    *    math.distance([0,0], [4,4])                     // Returns 5.6569
    *    math.distance(
    *     {pointOneX: 0, pointOneY: 0},
    *     {pointTwoX: 10, pointTwoY: 10})                // Returns 14.142135623730951
    *    math.distance([1, 0, 1], [4, -2, 2])            // Returns 3.74166
    *    math.distance(
    *     {pointOneX: 4, pointOneY: 5, pointOneZ: 8},
    *     {pointTwoX: 2, pointTwoY: 7, pointTwoZ: 9})    // Returns 3
    *    math.distance([1, 0, 1, 0], [0, -1, 0, -1])     // Returns 2
    *    math.distance([[1, 2], [1, 2], [1, 3]])         // Returns [0, 1, 1]
    *    math.distance([[1,2,4], [1,2,6], [8,1,3]])      // Returns [2, 7.14142842854285, 7.681145747868608]
    *    math.distance([10, 10], [8, 1, 3])              // Returns 11.535230316796387
    *    math.distance([10, 10], [2, 3], [-8, 0])        // Returns 8.759953130362847
    *    math.distance(
    *     {pointX: 1, pointY: 4},
    *     {lineOnePtX: 6, lineOnePtY: 3},
    *     {lineTwoPtX: 2, lineTwoPtY: 8})                // Returns 2.720549372624744
    *    math.distance([2, 3, 1], [1, 1, 2, 5, 0, 1])    // Returns 2.3204774044612857
    *    math.distance(
    *     {pointX: 2, pointY: 3, pointZ: 1},
    *     {x0: 1, y0: 1, z0: 2, a: 5, b: 0, c: 1}        // Returns 2.3204774044612857
    *
    * @param {Array | Matrix | Object} x    Co-ordinates of first point
    * @param {Array | Matrix | Object} y    Co-ordinates of second point
    * @return {Number | BigNumber} Returns the distance from two/three points
  */ return typed($4f780b5875722d67$var$name, {
        "Array, Array, Array": function ArrayArrayArray(x, y, z) {
            // Point to Line 2D (x=Point, y=LinePoint1, z=LinePoint2)
            if (x.length === 2 && y.length === 2 && z.length === 2) {
                if (!_2d(x)) throw new TypeError("Array with 2 numbers or BigNumbers expected for first argument");
                if (!_2d(y)) throw new TypeError("Array with 2 numbers or BigNumbers expected for second argument");
                if (!_2d(z)) throw new TypeError("Array with 2 numbers or BigNumbers expected for third argument");
                var m = divideScalar(subtract(z[1], z[0]), subtract(y[1], y[0]));
                var xCoeff = multiplyScalar(multiplyScalar(m, m), y[0]);
                var yCoeff = unaryMinus(multiplyScalar(m, y[0]));
                var constant = x[1];
                return _distancePointLine2D(x[0], x[1], xCoeff, yCoeff, constant);
            } else throw new TypeError("Invalid Arguments: Try again");
        },
        "Object, Object, Object": function ObjectObjectObject(x, y, z) {
            if (Object.keys(x).length === 2 && Object.keys(y).length === 2 && Object.keys(z).length === 2) {
                if (!_2d(x)) throw new TypeError("Values of pointX and pointY should be numbers or BigNumbers");
                if (!_2d(y)) throw new TypeError("Values of lineOnePtX and lineOnePtY should be numbers or BigNumbers");
                if (!_2d(z)) throw new TypeError("Values of lineTwoPtX and lineTwoPtY should be numbers or BigNumbers");
                if ("pointX" in x && "pointY" in x && "lineOnePtX" in y && "lineOnePtY" in y && "lineTwoPtX" in z && "lineTwoPtY" in z) {
                    var m = divideScalar(subtract(z.lineTwoPtY, z.lineTwoPtX), subtract(y.lineOnePtY, y.lineOnePtX));
                    var xCoeff = multiplyScalar(multiplyScalar(m, m), y.lineOnePtX);
                    var yCoeff = unaryMinus(multiplyScalar(m, y.lineOnePtX));
                    var constant = x.pointX;
                    return _distancePointLine2D(x.pointX, x.pointY, xCoeff, yCoeff, constant);
                } else throw new TypeError("Key names do not match");
            } else throw new TypeError("Invalid Arguments: Try again");
        },
        "Array, Array": function ArrayArray(x, y) {
            // Point to Line 2D (x=[pointX, pointY], y=[x-coeff, y-coeff, const])
            if (x.length === 2 && y.length === 3) {
                if (!_2d(x)) throw new TypeError("Array with 2 numbers or BigNumbers expected for first argument");
                if (!_3d(y)) throw new TypeError("Array with 3 numbers or BigNumbers expected for second argument");
                return _distancePointLine2D(x[0], x[1], y[0], y[1], y[2]);
            } else if (x.length === 3 && y.length === 6) {
                // Point to Line 3D
                if (!_3d(x)) throw new TypeError("Array with 3 numbers or BigNumbers expected for first argument");
                if (!_parametricLine(y)) throw new TypeError("Array with 6 numbers or BigNumbers expected for second argument");
                return _distancePointLine3D(x[0], x[1], x[2], y[0], y[1], y[2], y[3], y[4], y[5]);
            } else if (x.length === y.length && x.length > 0) {
                // Point to Point N-dimensions
                if (!_containsOnlyNumbers(x)) throw new TypeError("All values of an array should be numbers or BigNumbers");
                if (!_containsOnlyNumbers(y)) throw new TypeError("All values of an array should be numbers or BigNumbers");
                return _euclideanDistance(x, y);
            } else throw new TypeError("Invalid Arguments: Try again");
        },
        "Object, Object": function ObjectObject(x, y) {
            if (Object.keys(x).length === 2 && Object.keys(y).length === 3) {
                if (!_2d(x)) throw new TypeError("Values of pointX and pointY should be numbers or BigNumbers");
                if (!_3d(y)) throw new TypeError("Values of xCoeffLine, yCoeffLine and constant should be numbers or BigNumbers");
                if ("pointX" in x && "pointY" in x && "xCoeffLine" in y && "yCoeffLine" in y && "constant" in y) return _distancePointLine2D(x.pointX, x.pointY, y.xCoeffLine, y.yCoeffLine, y.constant);
                else throw new TypeError("Key names do not match");
            } else if (Object.keys(x).length === 3 && Object.keys(y).length === 6) {
                // Point to Line 3D
                if (!_3d(x)) throw new TypeError("Values of pointX, pointY and pointZ should be numbers or BigNumbers");
                if (!_parametricLine(y)) throw new TypeError("Values of x0, y0, z0, a, b and c should be numbers or BigNumbers");
                if ("pointX" in x && "pointY" in x && "x0" in y && "y0" in y && "z0" in y && "a" in y && "b" in y && "c" in y) return _distancePointLine3D(x.pointX, x.pointY, x.pointZ, y.x0, y.y0, y.z0, y.a, y.b, y.c);
                else throw new TypeError("Key names do not match");
            } else if (Object.keys(x).length === 2 && Object.keys(y).length === 2) {
                // Point to Point 2D
                if (!_2d(x)) throw new TypeError("Values of pointOneX and pointOneY should be numbers or BigNumbers");
                if (!_2d(y)) throw new TypeError("Values of pointTwoX and pointTwoY should be numbers or BigNumbers");
                if ("pointOneX" in x && "pointOneY" in x && "pointTwoX" in y && "pointTwoY" in y) return _euclideanDistance([
                    x.pointOneX,
                    x.pointOneY
                ], [
                    y.pointTwoX,
                    y.pointTwoY
                ]);
                else throw new TypeError("Key names do not match");
            } else if (Object.keys(x).length === 3 && Object.keys(y).length === 3) {
                // Point to Point 3D
                if (!_3d(x)) throw new TypeError("Values of pointOneX, pointOneY and pointOneZ should be numbers or BigNumbers");
                if (!_3d(y)) throw new TypeError("Values of pointTwoX, pointTwoY and pointTwoZ should be numbers or BigNumbers");
                if ("pointOneX" in x && "pointOneY" in x && "pointOneZ" in x && "pointTwoX" in y && "pointTwoY" in y && "pointTwoZ" in y) return _euclideanDistance([
                    x.pointOneX,
                    x.pointOneY,
                    x.pointOneZ
                ], [
                    y.pointTwoX,
                    y.pointTwoY,
                    y.pointTwoZ
                ]);
                else throw new TypeError("Key names do not match");
            } else throw new TypeError("Invalid Arguments: Try again");
        },
        Array: function Array1(arr) {
            if (!_pairwise(arr)) throw new TypeError("Incorrect array format entered for pairwise distance calculation");
            return _distancePairwise(arr);
        }
    });
    function _isNumber(a) {
        // distance supports numbers and bignumbers
        return typeof a === "number" || (0, $1amHZ.isBigNumber)(a);
    }
    function _2d(a) {
        // checks if the number of arguments are correct in count and are valid (should be numbers)
        if (a.constructor !== Array) a = _objectToArray(a);
        return _isNumber(a[0]) && _isNumber(a[1]);
    }
    function _3d(a) {
        // checks if the number of arguments are correct in count and are valid (should be numbers)
        if (a.constructor !== Array) a = _objectToArray(a);
        return _isNumber(a[0]) && _isNumber(a[1]) && _isNumber(a[2]);
    }
    function _containsOnlyNumbers(a) {
        // checks if the number of arguments are correct in count and are valid (should be numbers)
        if (!Array.isArray(a)) a = _objectToArray(a);
        return a.every(_isNumber);
    }
    function _parametricLine(a) {
        if (a.constructor !== Array) a = _objectToArray(a);
        return _isNumber(a[0]) && _isNumber(a[1]) && _isNumber(a[2]) && _isNumber(a[3]) && _isNumber(a[4]) && _isNumber(a[5]);
    }
    function _objectToArray(o) {
        var keys = Object.keys(o);
        var a = [];
        for(var i = 0; i < keys.length; i++)a.push(o[keys[i]]);
        return a;
    }
    function _pairwise(a) {
        // checks for valid arguments passed to _distancePairwise(Array)
        if (a[0].length === 2 && _isNumber(a[0][0]) && _isNumber(a[0][1])) {
            if (a.some(function(aI) {
                return aI.length !== 2 || !_isNumber(aI[0]) || !_isNumber(aI[1]);
            })) return false;
        } else if (a[0].length === 3 && _isNumber(a[0][0]) && _isNumber(a[0][1]) && _isNumber(a[0][2])) {
            if (a.some(function(aI) {
                return aI.length !== 3 || !_isNumber(aI[0]) || !_isNumber(aI[1]) || !_isNumber(aI[2]);
            })) return false;
        } else return false;
        return true;
    }
    function _distancePointLine2D(x, y, a, b, c) {
        var num = abs(addScalar(addScalar(multiplyScalar(a, x), multiplyScalar(b, y)), c));
        var den = sqrt(addScalar(multiplyScalar(a, a), multiplyScalar(b, b)));
        return divideScalar(num, den);
    }
    function _distancePointLine3D(x, y, z, x0, y0, z0, a, b, c) {
        var num = [
            subtract(multiplyScalar(subtract(y0, y), c), multiplyScalar(subtract(z0, z), b)),
            subtract(multiplyScalar(subtract(z0, z), a), multiplyScalar(subtract(x0, x), c)),
            subtract(multiplyScalar(subtract(x0, x), b), multiplyScalar(subtract(y0, y), a))
        ];
        num = sqrt(addScalar(addScalar(multiplyScalar(num[0], num[0]), multiplyScalar(num[1], num[1])), multiplyScalar(num[2], num[2])));
        var den = sqrt(addScalar(addScalar(multiplyScalar(a, a), multiplyScalar(b, b)), multiplyScalar(c, c)));
        return divideScalar(num, den);
    }
    function _euclideanDistance(x, y) {
        var vectorSize = x.length;
        var result = 0;
        var diff = 0;
        for(var i = 0; i < vectorSize; i++){
            diff = subtract(x[i], y[i]);
            result = addScalar(multiplyScalar(diff, diff), result);
        }
        return sqrt(result);
    }
    function _distancePairwise(a) {
        var result = [];
        var pointA = [];
        var pointB = [];
        for(var i = 0; i < a.length - 1; i++)for(var j = i + 1; j < a.length; j++){
            if (a[0].length === 2) {
                pointA = [
                    a[i][0],
                    a[i][1]
                ];
                pointB = [
                    a[j][0],
                    a[j][1]
                ];
            } else if (a[0].length === 3) {
                pointA = [
                    a[i][0],
                    a[i][1],
                    a[i][2]
                ];
                pointB = [
                    a[j][0],
                    a[j][1],
                    a[j][2]
                ];
            }
            result.push(_euclideanDistance(pointA, pointB));
        }
        return result;
    }
});

});

parcelRegister("gO6Ud", function(module, exports) {

$parcel$export(module.exports, "createDivide", function () { return $c3c6ac2dc883b2ae$export$4df5e56bb6d14758; });

var $2mPYl = parcelRequire("2mPYl");

var $7ITGG = parcelRequire("7ITGG");

var $cZfrH = parcelRequire("cZfrH");

var $iHnaT = parcelRequire("iHnaT");
var $c3c6ac2dc883b2ae$var$name = "divide";
var $c3c6ac2dc883b2ae$var$dependencies = [
    "typed",
    "matrix",
    "multiply",
    "equalScalar",
    "divideScalar",
    "inv"
];
var $c3c6ac2dc883b2ae$export$4df5e56bb6d14758 = /* #__PURE__ */ (0, $2mPYl.factory)($c3c6ac2dc883b2ae$var$name, $c3c6ac2dc883b2ae$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, multiply = _ref.multiply, equalScalar = _ref.equalScalar, divideScalar = _ref.divideScalar, inv = _ref.inv;
    var algorithm11 = (0, $cZfrH.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm14 = (0, $iHnaT.createAlgorithm14)({
        typed: typed
    });
    /**
   * Divide two values, `x / y`.
   * To divide matrices, `x` is multiplied with the inverse of `y`: `x * inv(y)`.
   *
   * Syntax:
   *
   *    math.divide(x, y)
   *
   * Examples:
   *
   *    math.divide(2, 3)            // returns number 0.6666666666666666
   *
   *    const a = math.complex(5, 14)
   *    const b = math.complex(4, 1)
   *    math.divide(a, b)            // returns Complex 2 + 3i
   *
   *    const c = [[7, -6], [13, -4]]
   *    const d = [[1, 2], [4, 3]]
   *    math.divide(c, d)            // returns Array [[-9, 4], [-11, 6]]
   *
   *    const e = math.unit('18 km')
   *    math.divide(e, 4.5)          // returns Unit 4 km
   *
   * See also:
   *
   *    multiply
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x   Numerator
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix} y          Denominator
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}                      Quotient, `x / y`
   */ return typed("divide", (0, $7ITGG.extend)({
        // we extend the signatures of divideScalar with signatures dealing with matrices
        "Array | Matrix, Array | Matrix": function ArrayMatrixArrayMatrix(x, y) {
            // TODO: implement matrix right division using pseudo inverse
            // https://www.mathworks.nl/help/matlab/ref/mrdivide.html
            // https://www.gnu.org/software/octave/doc/interpreter/Arithmetic-Ops.html
            // https://stackoverflow.com/questions/12263932/how-does-gnu-octave-matrix-division-work-getting-unexpected-behaviour
            return multiply(x, inv(y));
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, divideScalar, false);
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm11(x, y, divideScalar, false);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, divideScalar, false).valueOf();
        },
        "any, Array | Matrix": function anyArrayMatrix(x, y) {
            return multiply(x, inv(y));
        }
    }, divideScalar.signatures));
});

});

parcelRegister("iSkrf", function(module, exports) {

$parcel$export(module.exports, "createDivideScalar", function () { return $dbdd1fcfb8cc1c1c$export$399593177816ff82; });

var $2mPYl = parcelRequire("2mPYl");

var $1amHZ = parcelRequire("1amHZ");
var $dbdd1fcfb8cc1c1c$var$name = "divideScalar";
var $dbdd1fcfb8cc1c1c$var$dependencies = [
    "typed",
    "numeric"
];
var $dbdd1fcfb8cc1c1c$export$399593177816ff82 = /* #__PURE__ */ (0, $2mPYl.factory)($dbdd1fcfb8cc1c1c$var$name, $dbdd1fcfb8cc1c1c$var$dependencies, function(_ref) {
    var typed = _ref.typed, numeric = _ref.numeric;
    /**
   * Divide two scalar values, `x / y`.
   * This function is meant for internal use: it is used by the public functions
   * `divide` and `inv`.
   *
   * This function does not support collections (Array or Matrix).
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit} x   Numerator
   * @param  {number | BigNumber | Fraction | Complex} y          Denominator
   * @return {number | BigNumber | Fraction | Complex | Unit}     Quotient, `x / y`
   * @private
   */ var divideScalar = typed($dbdd1fcfb8cc1c1c$var$name, {
        "number, number": function numberNumber(x, y) {
            return x / y;
        },
        "Complex, Complex": function ComplexComplex(x, y) {
            return x.div(y);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.div(y);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.div(y);
        },
        "Unit, number | Fraction | BigNumber": function UnitNumberFractionBigNumber(x, y) {
            var res = x.clone(); // TODO: move the divide function to Unit.js, it uses internals of Unit
            var one = numeric(1, (0, $1amHZ.typeOf)(y));
            res.value = divideScalar(res.value === null ? res._normalize(one) : res.value, y);
            return res;
        },
        "number | Fraction | BigNumber, Unit": function numberFractionBigNumberUnit(x, y) {
            var res = y.clone();
            res = res.pow(-1); // TODO: move the divide function to Unit.js, it uses internals of Unit
            var one = numeric(1, (0, $1amHZ.typeOf)(x));
            res.value = divideScalar(x, y.value === null ? y._normalize(one) : y.value);
            return res;
        },
        "Unit, Unit": function UnitUnit(x, y) {
            return x.divide(y);
        }
    });
    return divideScalar;
});

});

parcelRegister("8RpBq", function(module, exports) {

$parcel$export(module.exports, "createDot", function () { return $6737221f4d1d3ad6$export$3dc59ff00984d687; });

var $5WdrK = parcelRequire("5WdrK");

var $2mPYl = parcelRequire("2mPYl");
var $6737221f4d1d3ad6$var$name = "dot";
var $6737221f4d1d3ad6$var$dependencies = [
    "typed",
    "add",
    "multiply"
];
var $6737221f4d1d3ad6$export$3dc59ff00984d687 = /* #__PURE__ */ (0, $2mPYl.factory)($6737221f4d1d3ad6$var$name, $6737221f4d1d3ad6$var$dependencies, function(_ref) {
    var typed = _ref.typed, add = _ref.add, multiply = _ref.multiply;
    /**
   * Calculate the dot product of two vectors. The dot product of
   * `A = [a1, a2, a3, ..., an]` and `B = [b1, b2, b3, ..., bn]` is defined as:
   *
   *    dot(A, B) = a1 * b1 + a2 * b2 + a3 * b3 + ... + an * bn
   *
   * Syntax:
   *
   *    math.dot(x, y)
   *
   * Examples:
   *
   *    math.dot([2, 4, 1], [2, 2, 3])       // returns number 15
   *    math.multiply([2, 4, 1], [2, 2, 3])  // returns number 15
   *
   * See also:
   *
   *    multiply, cross
   *
   * @param  {Array | Matrix} x     First vector
   * @param  {Array | Matrix} y     Second vector
   * @return {number}               Returns the dot product of `x` and `y`
   */ return typed($6737221f4d1d3ad6$var$name, {
        "Matrix, Matrix": function MatrixMatrix(x, y) {
            return _dot(x.toArray(), y.toArray());
        },
        "Matrix, Array": function MatrixArray(x, y) {
            return _dot(x.toArray(), y);
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            return _dot(x, y.toArray());
        },
        "Array, Array": _dot
    });
    /**
   * Calculate the dot product for two arrays
   * @param {Array} x  First vector
   * @param {Array} y  Second vector
   * @returns {number} Returns the dot product of x and y
   * @private
   */ // TODO: double code with math.multiply
    function _dot(x, y) {
        var xSize = (0, $5WdrK.arraySize)(x);
        var ySize = (0, $5WdrK.arraySize)(y);
        var len = xSize[0];
        if (xSize.length !== 1 || ySize.length !== 1) throw new RangeError("Vector expected"); // TODO: better error message
        if (xSize[0] !== ySize[0]) throw new RangeError("Vectors must have equal length (" + xSize[0] + " != " + ySize[0] + ")");
        if (len === 0) throw new RangeError("Cannot calculate the dot product of empty vectors");
        var prod = 0;
        for(var i = 0; i < len; i++)prod = add(prod, multiply(x[i], y[i]));
        return prod;
    }
});

});

parcelRegister("fxhCt", function(module, exports) {

$parcel$export(module.exports, "createDotDivide", function () { return $b4f79af1b6374f86$export$e4930a420a373a24; });

var $2mPYl = parcelRequire("2mPYl");

var $cITNv = parcelRequire("cITNv");

var $jaKH8 = parcelRequire("jaKH8");

var $awGkR = parcelRequire("awGkR");

var $cZfrH = parcelRequire("cZfrH");

var $dNuvz = parcelRequire("dNuvz");

var $1bBLS = parcelRequire("1bBLS");

var $iHnaT = parcelRequire("iHnaT");
var $b4f79af1b6374f86$var$name = "dotDivide";
var $b4f79af1b6374f86$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "divideScalar",
    "DenseMatrix"
];
var $b4f79af1b6374f86$export$e4930a420a373a24 = /* #__PURE__ */ (0, $2mPYl.factory)($b4f79af1b6374f86$var$name, $b4f79af1b6374f86$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, equalScalar = _ref.equalScalar, divideScalar = _ref.divideScalar, DenseMatrix = _ref.DenseMatrix;
    var algorithm02 = (0, $cITNv.createAlgorithm02)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm03 = (0, $jaKH8.createAlgorithm03)({
        typed: typed
    });
    var algorithm07 = (0, $awGkR.createAlgorithm07)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm11 = (0, $cZfrH.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm12 = (0, $dNuvz.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $1bBLS.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $iHnaT.createAlgorithm14)({
        typed: typed
    });
    /**
   * Divide two matrices element wise. The function accepts both matrices and
   * scalar values.
   *
   * Syntax:
   *
   *    math.dotDivide(x, y)
   *
   * Examples:
   *
   *    math.dotDivide(2, 4)   // returns 0.5
   *
   *    a = [[9, 5], [6, 1]]
   *    b = [[3, 2], [5, 2]]
   *
   *    math.dotDivide(a, b)   // returns [[3, 2.5], [1.2, 0.5]]
   *    math.divide(a, b)      // returns [[1.75, 0.75], [-1.75, 2.25]]
   *
   * See also:
   *
   *    divide, multiply, dotMultiply
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x Numerator
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Denominator
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}                    Quotient, `x ./ y`
   */ var dotDivide = typed($b4f79af1b6374f86$var$name, {
        "any, any": divideScalar,
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, divideScalar, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, divideScalar, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, divideScalar, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, divideScalar);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return dotDivide(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return dotDivide(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return dotDivide(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm11(x, y, divideScalar, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, divideScalar, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, divideScalar, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, divideScalar, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, divideScalar, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, divideScalar, true).valueOf();
        }
    });
    return dotDivide;
});

});

parcelRegister("2dOZi", function(module, exports) {

$parcel$export(module.exports, "createDotMultiply", function () { return $19e458bc40dde5f4$export$a4620e84460f321e; });

var $2mPYl = parcelRequire("2mPYl");

var $cITNv = parcelRequire("cITNv");

var $lF8tr = parcelRequire("lF8tr");

var $cZfrH = parcelRequire("cZfrH");

var $1bBLS = parcelRequire("1bBLS");

var $iHnaT = parcelRequire("iHnaT");
var $19e458bc40dde5f4$var$name = "dotMultiply";
var $19e458bc40dde5f4$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "multiplyScalar"
];
var $19e458bc40dde5f4$export$a4620e84460f321e = /* #__PURE__ */ (0, $2mPYl.factory)($19e458bc40dde5f4$var$name, $19e458bc40dde5f4$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, equalScalar = _ref.equalScalar, multiplyScalar = _ref.multiplyScalar;
    var algorithm02 = (0, $cITNv.createAlgorithm02)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm09 = (0, $lF8tr.createAlgorithm09)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm11 = (0, $cZfrH.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $1bBLS.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $iHnaT.createAlgorithm14)({
        typed: typed
    });
    /**
   * Multiply two matrices element wise. The function accepts both matrices and
   * scalar values.
   *
   * Syntax:
   *
   *    math.dotMultiply(x, y)
   *
   * Examples:
   *
   *    math.dotMultiply(2, 4) // returns 8
   *
   *    a = [[9, 5], [6, 1]]
   *    b = [[3, 2], [5, 2]]
   *
   *    math.dotMultiply(a, b) // returns [[27, 10], [30, 2]]
   *    math.multiply(a, b)    // returns [[52, 28], [23, 14]]
   *
   * See also:
   *
   *    multiply, divide, dotDivide
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x Left hand value
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Right hand value
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}                    Multiplication of `x` and `y`
   */ var dotMultiply = typed($19e458bc40dde5f4$var$name, {
        "any, any": multiplyScalar,
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm09(x, y, multiplyScalar, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, multiplyScalar, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm02(x, y, multiplyScalar, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, multiplyScalar);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return dotMultiply(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return dotMultiply(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return dotMultiply(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm11(x, y, multiplyScalar, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, multiplyScalar, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm11(y, x, multiplyScalar, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, multiplyScalar, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, multiplyScalar, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, multiplyScalar, true).valueOf();
        }
    });
    return dotMultiply;
});

});

parcelRegister("7RV4T", function(module, exports) {

$parcel$export(module.exports, "createDotPow", function () { return $5ba9c21e9b58d1dc$export$734b49568d8effd6; });

var $2mPYl = parcelRequire("2mPYl");

var $jaKH8 = parcelRequire("jaKH8");

var $awGkR = parcelRequire("awGkR");

var $cZfrH = parcelRequire("cZfrH");

var $dNuvz = parcelRequire("dNuvz");

var $1bBLS = parcelRequire("1bBLS");

var $iHnaT = parcelRequire("iHnaT");
var $5ba9c21e9b58d1dc$var$name = "dotPow";
var $5ba9c21e9b58d1dc$var$dependencies = [
    "typed",
    "equalScalar",
    "matrix",
    "pow",
    "DenseMatrix"
];
var $5ba9c21e9b58d1dc$export$734b49568d8effd6 = /* #__PURE__ */ (0, $2mPYl.factory)($5ba9c21e9b58d1dc$var$name, $5ba9c21e9b58d1dc$var$dependencies, function(_ref) {
    var typed = _ref.typed, equalScalar = _ref.equalScalar, matrix = _ref.matrix, pow = _ref.pow, DenseMatrix = _ref.DenseMatrix;
    var algorithm03 = (0, $jaKH8.createAlgorithm03)({
        typed: typed
    });
    var algorithm07 = (0, $awGkR.createAlgorithm07)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm11 = (0, $cZfrH.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm12 = (0, $dNuvz.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $1bBLS.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $iHnaT.createAlgorithm14)({
        typed: typed
    });
    /**
   * Calculates the power of x to y element wise.
   *
   * Syntax:
   *
   *    math.dotPow(x, y)
   *
   * Examples:
   *
   *    math.dotPow(2, 3)            // returns number 8
   *
   *    const a = [[1, 2], [4, 3]]
   *    math.dotPow(a, 2)            // returns Array [[1, 4], [16, 9]]
   *    math.pow(a, 2)               // returns Array [[9, 8], [16, 17]]
   *
   * See also:
   *
   *    pow, sqrt, multiply
   *
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x  The base
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} y  The exponent
   * @return {number | BigNumber | Complex | Unit | Array | Matrix}                     The value of `x` to the power `y`
   */ var dotPow = typed($5ba9c21e9b58d1dc$var$name, {
        "any, any": pow,
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, pow, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, pow, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, pow, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, pow);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return dotPow(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return dotPow(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return dotPow(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm11(x, y, dotPow, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, dotPow, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, dotPow, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, dotPow, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, dotPow, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, dotPow, true).valueOf();
        }
    });
    return dotPow;
});

});

parcelRegister("eRQhw", function(module, exports) {

$parcel$export(module.exports, "createTrue", function () { return $ad2e91f108bd992d$export$e13d32722e2756df; });
$parcel$export(module.exports, "createFalse", function () { return $ad2e91f108bd992d$export$cb94e3a54c9e99b; });
$parcel$export(module.exports, "createNull", function () { return $ad2e91f108bd992d$export$d07c6114481fc17b; });
$parcel$export(module.exports, "createInfinity", function () { return $ad2e91f108bd992d$export$df1313fb6eb44f05; });
$parcel$export(module.exports, "createNaN", function () { return $ad2e91f108bd992d$export$fbdaee11df58c3cc; });
$parcel$export(module.exports, "createPi", function () { return $ad2e91f108bd992d$export$2dbe69c48ac7f49c; });
$parcel$export(module.exports, "createTau", function () { return $ad2e91f108bd992d$export$d5973a6d5d95d479; });
$parcel$export(module.exports, "createE", function () { return $ad2e91f108bd992d$export$6dca51ff4d4b257f; });
$parcel$export(module.exports, "createPhi", function () { return $ad2e91f108bd992d$export$f131830080647892; });
$parcel$export(module.exports, "createLN2", function () { return $ad2e91f108bd992d$export$ab67ddb9e8290a2c; });
$parcel$export(module.exports, "createLN10", function () { return $ad2e91f108bd992d$export$5365e90aad1235b4; });
$parcel$export(module.exports, "createLOG2E", function () { return $ad2e91f108bd992d$export$b57f4b4cfc057c2d; });
$parcel$export(module.exports, "createLOG10E", function () { return $ad2e91f108bd992d$export$57f654bce66ec8ce; });
$parcel$export(module.exports, "createSQRT1_2", function () { return $ad2e91f108bd992d$export$e6df2cb14f3e8316; });
$parcel$export(module.exports, "createSQRT2", function () { return $ad2e91f108bd992d$export$f7a593fe98eba575; });
$parcel$export(module.exports, "createI", function () { return $ad2e91f108bd992d$export$7122d2461a6f9b76; });
$parcel$export(module.exports, "createVersion", function () { return $ad2e91f108bd992d$export$72a91d9326d5a672; });

var $2mPYl = parcelRequire("2mPYl");

var $af19C = parcelRequire("af19C");

var $4zk7D = parcelRequire("4zk7D");

var $ch8oY = parcelRequire("ch8oY");
var $ad2e91f108bd992d$export$e13d32722e2756df = /* #__PURE__ */ (0, $2mPYl.factory)("true", [], function() {
    return true;
});
var $ad2e91f108bd992d$export$cb94e3a54c9e99b = /* #__PURE__ */ (0, $2mPYl.factory)("false", [], function() {
    return false;
});
var $ad2e91f108bd992d$export$d07c6114481fc17b = /* #__PURE__ */ (0, $2mPYl.factory)("null", [], function() {
    return null;
});
var $ad2e91f108bd992d$export$df1313fb6eb44f05 = /* #__PURE__ */ $ad2e91f108bd992d$var$recreateFactory("Infinity", [
    "config",
    "?BigNumber"
], function(_ref) {
    var config = _ref.config, BigNumber = _ref.BigNumber;
    return config.number === "BigNumber" ? new BigNumber(Infinity) : Infinity;
});
var $ad2e91f108bd992d$export$fbdaee11df58c3cc = /* #__PURE__ */ $ad2e91f108bd992d$var$recreateFactory("NaN", [
    "config",
    "?BigNumber"
], function(_ref2) {
    var config = _ref2.config, BigNumber = _ref2.BigNumber;
    return config.number === "BigNumber" ? new BigNumber(NaN) : NaN;
});
var $ad2e91f108bd992d$export$2dbe69c48ac7f49c = /* #__PURE__ */ $ad2e91f108bd992d$var$recreateFactory("pi", [
    "config",
    "?BigNumber"
], function(_ref3) {
    var config = _ref3.config, BigNumber = _ref3.BigNumber;
    return config.number === "BigNumber" ? (0, $4zk7D.createBigNumberPi)(BigNumber) : (0, $ch8oY.pi);
});
var $ad2e91f108bd992d$export$d5973a6d5d95d479 = /* #__PURE__ */ $ad2e91f108bd992d$var$recreateFactory("tau", [
    "config",
    "?BigNumber"
], function(_ref4) {
    var config = _ref4.config, BigNumber = _ref4.BigNumber;
    return config.number === "BigNumber" ? (0, $4zk7D.createBigNumberTau)(BigNumber) : (0, $ch8oY.tau);
});
var $ad2e91f108bd992d$export$6dca51ff4d4b257f = /* #__PURE__ */ $ad2e91f108bd992d$var$recreateFactory("e", [
    "config",
    "?BigNumber"
], function(_ref5) {
    var config = _ref5.config, BigNumber = _ref5.BigNumber;
    return config.number === "BigNumber" ? (0, $4zk7D.createBigNumberE)(BigNumber) : (0, $ch8oY.e);
}); // golden ratio, (1+sqrt(5))/2
var $ad2e91f108bd992d$export$f131830080647892 = /* #__PURE__ */ $ad2e91f108bd992d$var$recreateFactory("phi", [
    "config",
    "?BigNumber"
], function(_ref6) {
    var config = _ref6.config, BigNumber = _ref6.BigNumber;
    return config.number === "BigNumber" ? (0, $4zk7D.createBigNumberPhi)(BigNumber) : (0, $ch8oY.phi);
});
var $ad2e91f108bd992d$export$ab67ddb9e8290a2c = /* #__PURE__ */ $ad2e91f108bd992d$var$recreateFactory("LN2", [
    "config",
    "?BigNumber"
], function(_ref7) {
    var config = _ref7.config, BigNumber = _ref7.BigNumber;
    return config.number === "BigNumber" ? new BigNumber(2).ln() : Math.LN2;
});
var $ad2e91f108bd992d$export$5365e90aad1235b4 = /* #__PURE__ */ $ad2e91f108bd992d$var$recreateFactory("LN10", [
    "config",
    "?BigNumber"
], function(_ref8) {
    var config = _ref8.config, BigNumber = _ref8.BigNumber;
    return config.number === "BigNumber" ? new BigNumber(10).ln() : Math.LN10;
});
var $ad2e91f108bd992d$export$b57f4b4cfc057c2d = /* #__PURE__ */ $ad2e91f108bd992d$var$recreateFactory("LOG2E", [
    "config",
    "?BigNumber"
], function(_ref9) {
    var config = _ref9.config, BigNumber = _ref9.BigNumber;
    return config.number === "BigNumber" ? new BigNumber(1).div(new BigNumber(2).ln()) : Math.LOG2E;
});
var $ad2e91f108bd992d$export$57f654bce66ec8ce = /* #__PURE__ */ $ad2e91f108bd992d$var$recreateFactory("LOG10E", [
    "config",
    "?BigNumber"
], function(_ref10) {
    var config = _ref10.config, BigNumber = _ref10.BigNumber;
    return config.number === "BigNumber" ? new BigNumber(1).div(new BigNumber(10).ln()) : Math.LOG10E;
});
var $ad2e91f108bd992d$export$e6df2cb14f3e8316 = /* #__PURE__ */ $ad2e91f108bd992d$var$recreateFactory("SQRT1_2", [
    "config",
    "?BigNumber"
], function(_ref11) {
    var config = _ref11.config, BigNumber = _ref11.BigNumber;
    return config.number === "BigNumber" ? new BigNumber("0.5").sqrt() : Math.SQRT1_2;
});
var $ad2e91f108bd992d$export$f7a593fe98eba575 = /* #__PURE__ */ $ad2e91f108bd992d$var$recreateFactory("SQRT2", [
    "config",
    "?BigNumber"
], function(_ref12) {
    var config = _ref12.config, BigNumber = _ref12.BigNumber;
    return config.number === "BigNumber" ? new BigNumber(2).sqrt() : Math.SQRT2;
});
var $ad2e91f108bd992d$export$7122d2461a6f9b76 = /* #__PURE__ */ $ad2e91f108bd992d$var$recreateFactory("i", [
    "Complex"
], function(_ref13) {
    var Complex = _ref13.Complex;
    return Complex.I;
}); // for backward compatibility with v5
var $ad2e91f108bd992d$export$5aab935c59859292 = /* #__PURE__ */ (0, $2mPYl.factory)("PI", [
    "pi"
], function(_ref14) {
    var pi = _ref14.pi;
    return pi;
});
var $ad2e91f108bd992d$export$56c791a240a1c942 = /* #__PURE__ */ (0, $2mPYl.factory)("E", [
    "e"
], function(_ref15) {
    var e = _ref15.e;
    return e;
});
var $ad2e91f108bd992d$export$72a91d9326d5a672 = /* #__PURE__ */ (0, $2mPYl.factory)("version", [], function() {
    return 0, $af19C.version;
}); // helper function to create a factory with a flag recreateOnConfigChange
// idea: allow passing optional properties to be attached to the factory function as 4th argument?
function $ad2e91f108bd992d$var$recreateFactory(name, dependencies, create) {
    return (0, $2mPYl.factory)(name, dependencies, create, {
        recreateOnConfigChange: true
    });
}

});
parcelRegister("af19C", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $774c33485e5a7365$export$83d89fbfd8236492; });
var $774c33485e5a7365$export$83d89fbfd8236492 = "6.6.5"; // Note: This file is automatically generated when building math.js.
 // Changes made in this file will be overwritten.

});

parcelRegister("4zk7D", function(module, exports) {

$parcel$export(module.exports, "createBigNumberE", function () { return $353a0a25d1264721$export$737cba75de6dfb68; });
$parcel$export(module.exports, "createBigNumberPhi", function () { return $353a0a25d1264721$export$c7e121b24930c156; });
$parcel$export(module.exports, "createBigNumberPi", function () { return $353a0a25d1264721$export$d0a8190d955e3c5b; });
$parcel$export(module.exports, "createBigNumberTau", function () { return $353a0a25d1264721$export$83b6ee92a84f32c6; });

var $kpJv9 = parcelRequire("kpJv9");
var $353a0a25d1264721$export$737cba75de6dfb68 = (0, $kpJv9.memoize)(function(BigNumber) {
    return new BigNumber(1).exp();
}, $353a0a25d1264721$var$hasher);
var $353a0a25d1264721$export$c7e121b24930c156 = (0, $kpJv9.memoize)(function(BigNumber) {
    return new BigNumber(1).plus(new BigNumber(5).sqrt()).div(2);
}, $353a0a25d1264721$var$hasher);
var $353a0a25d1264721$export$d0a8190d955e3c5b = (0, $kpJv9.memoize)(function(BigNumber) {
    return BigNumber.acos(-1);
}, $353a0a25d1264721$var$hasher);
var $353a0a25d1264721$export$83b6ee92a84f32c6 = (0, $kpJv9.memoize)(function(BigNumber) {
    return $353a0a25d1264721$export$d0a8190d955e3c5b(BigNumber).times(2);
}, $353a0a25d1264721$var$hasher);
/**
 * Create a hash for a BigNumber constructor function. The created has is
 * the configured precision
 * @param {Array} args         Supposed to contain a single entry with
 *                             a BigNumber constructor
 * @return {number} precision
 * @private
 */ function $353a0a25d1264721$var$hasher(args) {
    return args[0].precision;
}

});

parcelRegister("ch8oY", function(module, exports) {

$parcel$export(module.exports, "pi", function () { return $8efd96fecd1d1acc$export$18c7bea995a110f; });
$parcel$export(module.exports, "tau", function () { return $8efd96fecd1d1acc$export$a4b4b4d4d776fe92; });
$parcel$export(module.exports, "e", function () { return $8efd96fecd1d1acc$export$f1e1789686576879; });
$parcel$export(module.exports, "phi", function () { return $8efd96fecd1d1acc$export$324943737027944a; });
var $8efd96fecd1d1acc$export$18c7bea995a110f = Math.PI;
var $8efd96fecd1d1acc$export$a4b4b4d4d776fe92 = 2 * Math.PI;
var $8efd96fecd1d1acc$export$f1e1789686576879 = Math.E;
var $8efd96fecd1d1acc$export$324943737027944a = 1.61803398874989484820458683436563811772030917980576286213545;

});


parcelRegister("hUbAD", function(module, exports) {

$parcel$export(module.exports, "createEigs", function () { return $d090a8262e79e65f$export$ba9e077a2df092d7; });

var $7ITGG = parcelRequire("7ITGG");

var $2mPYl = parcelRequire("2mPYl");

var $6NxuJ = parcelRequire("6NxuJ");
var $d090a8262e79e65f$var$name = "eigs";
var $d090a8262e79e65f$var$dependencies = [
    "config",
    "typed",
    "matrix",
    "addScalar",
    "equal",
    "subtract",
    "abs",
    "atan",
    "cos",
    "sin",
    "multiplyScalar",
    "inv",
    "bignumber",
    "multiply",
    "add"
];
var $d090a8262e79e65f$export$ba9e077a2df092d7 = /* #__PURE__ */ (0, $2mPYl.factory)($d090a8262e79e65f$var$name, $d090a8262e79e65f$var$dependencies, function(_ref) {
    var config = _ref.config, typed = _ref.typed, matrix = _ref.matrix, addScalar = _ref.addScalar, subtract = _ref.subtract, equal = _ref.equal, abs = _ref.abs, atan = _ref.atan, cos = _ref.cos, sin = _ref.sin, multiplyScalar = _ref.multiplyScalar, inv = _ref.inv, bignumber = _ref.bignumber, multiply = _ref.multiply, add = _ref.add;
    /**
   * Compute eigenvalue and eigenvector of a real symmetric matrix.
   * Only applicable to two dimensional symmetric matrices. Uses Jacobi
   * Algorithm. Matrix containing mixed type ('number', 'bignumber', 'fraction')
   * of elements are not supported. Input matrix or 2D array should contain all elements
   * of either 'number', 'bignumber' or 'fraction' type. For 'number' and 'fraction', the
   * eigenvalues are of 'number' type. For 'bignumber' the eigenvalues are of ''bignumber' type.
   * Eigenvectors are always of 'number' type.
   *
   * Syntax:
   *
   *     math.eigs(x)
   *
   * Examples:
   *
   *     const H = [[5, 2.3], [2.3, 1]]
   *     const ans = math.eigs(H) // returns {values: [E1,E2...sorted], vectors: [v1,v2.... corresponding vectors]}
   *     const E = ans.values
   *     const U = ans.vectors
   *     const UTxHxU = math.multiply(math.transpose(U), H, U) // rotates H to the eigen-representation
   *     E[0] == UTxHxU[0][0]  // returns true
   * See also:
   *
   *     inv
   *
   * @param {Array | Matrix} x  Matrix to be diagonalized
   * @return {{values: Array, vectors: Array} | {values: Matrix, vectors: Matrix}} Object containing eigenvalues (Array or Matrix) and eigenvectors (2D Array/Matrix).
   */ var eigs = typed("eigs", {
        Array: function Array1(x) {
            // check array size
            var mat = matrix(x);
            var size = mat.size();
            if (size.length !== 2 || size[0] !== size[1]) throw new RangeError("Matrix must be square (size: " + (0, $6NxuJ.format)(size) + ")");
             // use dense 2D matrix implementation
            var ans = checkAndSubmit(mat, size[0]);
            return {
                values: ans[0],
                vectors: ans[1]
            };
        },
        Matrix: function Matrix(x) {
            // use dense 2D array implementation
            // dense matrix
            var size = x.size();
            if (size.length !== 2 || size[0] !== size[1]) throw new RangeError("Matrix must be square (size: " + (0, $6NxuJ.format)(size) + ")");
            var ans = checkAndSubmit(x, size[0]);
            return {
                values: matrix(ans[0]),
                vectors: matrix(ans[1])
            };
        }
    }); // Is the matrix
    // symmetric ?
    function isSymmetric(x, n) {
        for(var i = 0; i < n; i++)for(var j = i; j < n; j++){
            // not symmtric
            if (!equal(x[i][j], x[j][i])) throw new TypeError("Input matrix is not symmetric");
        }
    } // check input for possible problems
    // and perform diagonalization efficiently for
    // specific type of number
    function checkAndSubmit(x, n) {
        var type = x.datatype(); // type check
        if (type === undefined) type = x.getDataType();
        if (type !== "number" && type !== "BigNumber" && type !== "Fraction") {
            if (type === "mixed") throw new TypeError("Mixed matrix element type is not supported");
            else throw new TypeError("Matrix element type not supported (" + type + ")");
        } else isSymmetric(x.toArray(), n);
         // perform efficient calculation for 'numbers'
        if (type === "number") return diag(x.toArray());
        else if (type === "Fraction") {
            var xArr = x.toArray(); // convert fraction to numbers
            for(var i = 0; i < n; i++)for(var j = i; j < n; j++){
                xArr[i][j] = xArr[i][j].valueOf();
                xArr[j][i] = xArr[i][j];
            }
            return diag(x.toArray());
        } else if (type === "BigNumber") return diagBig(x.toArray());
    } // diagonalization implementation for number (efficient)
    function diag(x) {
        var N = x.length;
        var e0 = Math.abs(config.epsilon / N);
        var psi;
        var Sij = new Array(N); // Sij is Identity Matrix
        for(var i = 0; i < N; i++){
            Sij[i] = createArray(N, 0);
            Sij[i][i] = 1.0;
        } // initial error
        var Vab = getAij(x);
        while(Math.abs(Vab[1]) >= Math.abs(e0)){
            var _i = Vab[0][0];
            var j = Vab[0][1];
            psi = getTheta(x[_i][_i], x[j][j], x[_i][j]);
            x = x1(x, psi, _i, j);
            Sij = Sij1(Sij, psi, _i, j);
            Vab = getAij(x);
        }
        var Ei = createArray(N, 0); // eigenvalues
        for(var _i2 = 0; _i2 < N; _i2++)Ei[_i2] = x[_i2][_i2];
        return sorting((0, $7ITGG.clone)(Ei), (0, $7ITGG.clone)(Sij));
    } // diagonalization implementation for bigNumber
    function diagBig(x) {
        var N = x.length;
        var e0 = abs(config.epsilon / N);
        var psi;
        var Sij = new Array(N); // Sij is Identity Matrix
        for(var i = 0; i < N; i++){
            Sij[i] = createArray(N, 0);
            Sij[i][i] = 1.0;
        } // initial error
        var Vab = getAijBig(x);
        while(abs(Vab[1]) >= abs(e0)){
            var _i3 = Vab[0][0];
            var j = Vab[0][1];
            psi = getThetaBig(x[_i3][_i3], x[j][j], x[_i3][j]);
            x = x1Big(x, psi, _i3, j);
            Sij = Sij1Big(Sij, psi, _i3, j);
            Vab = getAijBig(x);
        }
        var Ei = createArray(N, 0); // eigenvalues
        for(var _i4 = 0; _i4 < N; _i4++)Ei[_i4] = x[_i4][_i4];
         // return [clone(Ei), clone(Sij)]
        return sorting((0, $7ITGG.clone)(Ei), (0, $7ITGG.clone)(Sij));
    } // get angle
    function getTheta(aii, ajj, aij) {
        var denom = ajj - aii;
        if (Math.abs(denom) <= config.epsilon) return Math.PI / 4;
        else return 0.5 * Math.atan(2 * aij / (ajj - aii));
    } // get angle
    function getThetaBig(aii, ajj, aij) {
        var denom = subtract(ajj, aii);
        if (abs(denom) <= config.epsilon) return bignumber(-1).acos().div(4);
        else return multiplyScalar(0.5, atan(multiply(2, aij, inv(denom))));
    } // update eigvec
    function Sij1(Sij, theta, i, j) {
        var N = Sij.length;
        var c = Math.cos(theta);
        var s = Math.sin(theta);
        var Ski = createArray(N, 0);
        var Skj = createArray(N, 0);
        for(var k = 0; k < N; k++){
            Ski[k] = c * Sij[k][i] - s * Sij[k][j];
            Skj[k] = s * Sij[k][i] + c * Sij[k][j];
        }
        for(var _k = 0; _k < N; _k++){
            Sij[_k][i] = Ski[_k];
            Sij[_k][j] = Skj[_k];
        }
        return Sij;
    } // update eigvec for overlap
    function Sij1Big(Sij, theta, i, j) {
        var N = Sij.length;
        var c = cos(theta);
        var s = sin(theta);
        var Ski = createArray(N, bignumber(0));
        var Skj = createArray(N, bignumber(0));
        for(var k = 0; k < N; k++){
            Ski[k] = subtract(multiplyScalar(c, Sij[k][i]), multiplyScalar(s, Sij[k][j]));
            Skj[k] = addScalar(multiplyScalar(s, Sij[k][i]), multiplyScalar(c, Sij[k][j]));
        }
        for(var _k2 = 0; _k2 < N; _k2++){
            Sij[_k2][i] = Ski[_k2];
            Sij[_k2][j] = Skj[_k2];
        }
        return Sij;
    } // update matrix
    function x1Big(Hij, theta, i, j) {
        var N = Hij.length;
        var c = bignumber(cos(theta));
        var s = bignumber(sin(theta));
        var c2 = multiplyScalar(c, c);
        var s2 = multiplyScalar(s, s);
        var Aki = createArray(N, bignumber(0));
        var Akj = createArray(N, bignumber(0)); // 2cs Hij
        var csHij = multiply(bignumber(2), c, s, Hij[i][j]); //  Aii
        var Aii = addScalar(subtract(multiplyScalar(c2, Hij[i][i]), csHij), multiplyScalar(s2, Hij[j][j]));
        var Ajj = add(multiplyScalar(s2, Hij[i][i]), csHij, multiplyScalar(c2, Hij[j][j])); // 0  to i
        for(var k = 0; k < N; k++){
            Aki[k] = subtract(multiplyScalar(c, Hij[i][k]), multiplyScalar(s, Hij[j][k]));
            Akj[k] = addScalar(multiplyScalar(s, Hij[i][k]), multiplyScalar(c, Hij[j][k]));
        } // Modify Hij
        Hij[i][i] = Aii;
        Hij[j][j] = Ajj;
        Hij[i][j] = bignumber(0);
        Hij[j][i] = bignumber(0); // 0  to i
        for(var _k3 = 0; _k3 < N; _k3++)if (_k3 !== i && _k3 !== j) {
            Hij[i][_k3] = Aki[_k3];
            Hij[_k3][i] = Aki[_k3];
            Hij[j][_k3] = Akj[_k3];
            Hij[_k3][j] = Akj[_k3];
        }
        return Hij;
    } // update matrix
    function x1(Hij, theta, i, j) {
        var N = Hij.length;
        var c = Math.cos(theta);
        var s = Math.sin(theta);
        var c2 = c * c;
        var s2 = s * s;
        var Aki = createArray(N, 0);
        var Akj = createArray(N, 0); //  Aii
        var Aii = c2 * Hij[i][i] - 2 * c * s * Hij[i][j] + s2 * Hij[j][j];
        var Ajj = s2 * Hij[i][i] + 2 * c * s * Hij[i][j] + c2 * Hij[j][j]; // 0  to i
        for(var k = 0; k < N; k++){
            Aki[k] = c * Hij[i][k] - s * Hij[j][k];
            Akj[k] = s * Hij[i][k] + c * Hij[j][k];
        } // Modify Hij
        Hij[i][i] = Aii;
        Hij[j][j] = Ajj;
        Hij[i][j] = 0;
        Hij[j][i] = 0; // 0  to i
        for(var _k4 = 0; _k4 < N; _k4++)if (_k4 !== i && _k4 !== j) {
            Hij[i][_k4] = Aki[_k4];
            Hij[_k4][i] = Aki[_k4];
            Hij[j][_k4] = Akj[_k4];
            Hij[_k4][j] = Akj[_k4];
        }
        return Hij;
    } // get max off-diagonal value from Upper Diagonal
    function getAij(Mij) {
        var N = Mij.length;
        var maxMij = 0;
        var maxIJ = [
            0,
            1
        ];
        for(var i = 0; i < N; i++){
            for(var j = i + 1; j < N; j++)if (Math.abs(maxMij) < Math.abs(Mij[i][j])) {
                maxMij = Math.abs(Mij[i][j]);
                maxIJ = [
                    i,
                    j
                ];
            }
        }
        return [
            maxIJ,
            maxMij
        ];
    } // get max off-diagonal value from Upper Diagonal
    function getAijBig(Mij) {
        var N = Mij.length;
        var maxMij = 0;
        var maxIJ = [
            0,
            1
        ];
        for(var i = 0; i < N; i++){
            for(var j = i + 1; j < N; j++)if (abs(maxMij) < abs(Mij[i][j])) {
                maxMij = abs(Mij[i][j]);
                maxIJ = [
                    i,
                    j
                ];
            }
        }
        return [
            maxIJ,
            maxMij
        ];
    } // sort results
    function sorting(E, S) {
        var N = E.length;
        var Ef = Array(N);
        var Sf = Array(N);
        for(var k = 0; k < N; k++)Sf[k] = Array(N);
        for(var i = 0; i < N; i++){
            var minID = 0;
            var minE = E[0];
            for(var j = 0; j < E.length; j++)if (E[j] < minE) {
                minID = j;
                minE = E[minID];
            }
            Ef[i] = E.splice(minID, 1)[0];
            for(var _k5 = 0; _k5 < N; _k5++){
                Sf[_k5][i] = S[_k5][minID];
                S[_k5].splice(minID, 1);
            }
        }
        return [
            (0, $7ITGG.clone)(Ef),
            (0, $7ITGG.clone)(Sf)
        ];
    }
    /**
   * Create an array of a certain size and fill all items with an initial value
   * @param {number} size
   * @param {number} value
   * @return {number[]}
   */ function createArray(size, value) {
        // TODO: as soon as all browsers support Array.fill, use that instead (IE doesn't support it)
        var array = new Array(size);
        for(var i = 0; i < size; i++)array[i] = value;
        return array;
    }
    return eigs;
});

});

parcelRegister("cZmUN", function(module, exports) {

$parcel$export(module.exports, "createEqual", function () { return $974cf4f92eacf3f2$export$988f37bc1f709b0d; });

var $2mPYl = parcelRequire("2mPYl");

var $jaKH8 = parcelRequire("jaKH8");

var $awGkR = parcelRequire("awGkR");

var $dNuvz = parcelRequire("dNuvz");

var $1bBLS = parcelRequire("1bBLS");

var $iHnaT = parcelRequire("iHnaT");
var $974cf4f92eacf3f2$var$name = "equal";
var $974cf4f92eacf3f2$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "DenseMatrix"
];
var $974cf4f92eacf3f2$export$988f37bc1f709b0d = /* #__PURE__ */ (0, $2mPYl.factory)($974cf4f92eacf3f2$var$name, $974cf4f92eacf3f2$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, equalScalar = _ref.equalScalar, DenseMatrix = _ref.DenseMatrix;
    var algorithm03 = (0, $jaKH8.createAlgorithm03)({
        typed: typed
    });
    var algorithm07 = (0, $awGkR.createAlgorithm07)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $dNuvz.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $1bBLS.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $iHnaT.createAlgorithm14)({
        typed: typed
    });
    /**
   * Test whether two values are equal.
   *
   * The function tests whether the relative difference between x and y is
   * smaller than the configured epsilon. The function cannot be used to
   * compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * In case of complex numbers, x.re must equal y.re, and x.im must equal y.im.
   *
   * Values `null` and `undefined` are compared strictly, thus `null` is only
   * equal to `null` and nothing else, and `undefined` is only equal to
   * `undefined` and nothing else. Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.equal(x, y)
   *
   * Examples:
   *
   *    math.equal(2 + 2, 3)         // returns false
   *    math.equal(2 + 2, 4)         // returns true
   *
   *    const a = math.unit('50 cm')
   *    const b = math.unit('5 m')
   *    math.equal(a, b)             // returns true
   *
   *    const c = [2, 5, 1]
   *    const d = [2, 7, 1]
   *
   *    math.equal(c, d)             // returns [true, false, true]
   *    math.deepEqual(c, d)         // returns false
   *
   *    math.equal("1000", "1e3")    // returns true
   *    math.equal(0, null)          // returns false
   *
   * See also:
   *
   *    unequal, smaller, smallerEq, larger, largerEq, compare, deepEqual, equalText
   *
   * @param  {number | BigNumber | boolean | Complex | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | boolean | Complex | Unit | string | Array | Matrix} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the compared values are equal, else returns false
   */ var equal = typed($974cf4f92eacf3f2$var$name, {
        "any, any": function anyAny(x, y) {
            // strict equality for null and undefined?
            if (x === null) return y === null;
            if (y === null) return x === null;
            if (x === undefined) return y === undefined;
            if (y === undefined) return x === undefined;
            return equalScalar(x, y);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, equalScalar);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, equalScalar, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, equalScalar, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, equalScalar);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return equal(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return equal(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return equal(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, equalScalar, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, equalScalar, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, equalScalar, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, equalScalar, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, equalScalar, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, equalScalar, true).valueOf();
        }
    });
    return equal;
});
var $974cf4f92eacf3f2$export$87c1b92540f5e2ae = (0, $2mPYl.factory)($974cf4f92eacf3f2$var$name, [
    "typed",
    "equalScalar"
], function(_ref2) {
    var typed = _ref2.typed, equalScalar = _ref2.equalScalar;
    return typed($974cf4f92eacf3f2$var$name, {
        "any, any": function anyAny(x, y) {
            // strict equality for null and undefined?
            if (x === null) return y === null;
            if (y === null) return x === null;
            if (x === undefined) return y === undefined;
            if (y === undefined) return x === undefined;
            return equalScalar(x, y);
        }
    });
});

});

parcelRegister("e1yLF", function(module, exports) {

$parcel$export(module.exports, "createEqualScalar", function () { return $a35c20db73fbd3d4$export$c370bab664a0c9a2; });

var $ijobM = parcelRequire("ijobM");

var $kFRKb = parcelRequire("kFRKb");

var $2mPYl = parcelRequire("2mPYl");

var $4FcNd = parcelRequire("4FcNd");
var $a35c20db73fbd3d4$var$name = "equalScalar";
var $a35c20db73fbd3d4$var$dependencies = [
    "typed",
    "config"
];
var $a35c20db73fbd3d4$export$c370bab664a0c9a2 = /* #__PURE__ */ (0, $2mPYl.factory)($a35c20db73fbd3d4$var$name, $a35c20db73fbd3d4$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config;
    /**
   * Test whether two scalar values are nearly equal.
   *
   * @param  {number | BigNumber | Fraction | boolean | Complex | Unit} x   First value to compare
   * @param  {number | BigNumber | Fraction | boolean | Complex} y          Second value to compare
   * @return {boolean}                                                  Returns true when the compared values are equal, else returns false
   * @private
   */ var equalScalar = typed($a35c20db73fbd3d4$var$name, {
        "boolean, boolean": function booleanBoolean(x, y) {
            return x === y;
        },
        "number, number": function numberNumber(x, y) {
            return (0, $kFRKb.nearlyEqual)(x, y, config.epsilon);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.eq(y) || (0, $ijobM.nearlyEqual)(x, y, config.epsilon);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.equals(y);
        },
        "Complex, Complex": function ComplexComplex(x, y) {
            return (0, $4FcNd.complexEquals)(x, y, config.epsilon);
        },
        "Unit, Unit": function UnitUnit(x, y) {
            if (!x.equalBase(y)) throw new Error("Cannot compare units with different base");
            return equalScalar(x.value, y.value);
        }
    });
    return equalScalar;
});
var $a35c20db73fbd3d4$export$55f78fcc2979d648 = (0, $2mPYl.factory)($a35c20db73fbd3d4$var$name, [
    "typed",
    "config"
], function(_ref2) {
    var typed = _ref2.typed, config = _ref2.config;
    return typed($a35c20db73fbd3d4$var$name, {
        "number, number": function numberNumber(x, y) {
            return (0, $kFRKb.nearlyEqual)(x, y, config.epsilon);
        }
    });
});

});
parcelRegister("4FcNd", function(module, exports) {

$parcel$export(module.exports, "complexEquals", function () { return $3654ea1e4267644a$export$852c8261c9f393e0; });

var $kFRKb = parcelRequire("kFRKb");
function $3654ea1e4267644a$export$852c8261c9f393e0(x, y, epsilon) {
    return (0, $kFRKb.nearlyEqual)(x.re, y.re, epsilon) && (0, $kFRKb.nearlyEqual)(x.im, y.im, epsilon);
}

});


parcelRegister("3xiqs", function(module, exports) {

$parcel$export(module.exports, "createEqualText", function () { return $2932bf1d5a3c7767$export$1589aaa29568b87; });

var $2mPYl = parcelRequire("2mPYl");
var $2932bf1d5a3c7767$var$name = "equalText";
var $2932bf1d5a3c7767$var$dependencies = [
    "typed",
    "compareText",
    "isZero"
];
var $2932bf1d5a3c7767$export$1589aaa29568b87 = /* #__PURE__ */ (0, $2mPYl.factory)($2932bf1d5a3c7767$var$name, $2932bf1d5a3c7767$var$dependencies, function(_ref) {
    var typed = _ref.typed, compareText = _ref.compareText, isZero = _ref.isZero;
    /**
   * Check equality of two strings. Comparison is case sensitive.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.equalText(x, y)
   *
   * Examples:
   *
   *    math.equalText('Hello', 'Hello')     // returns true
   *    math.equalText('a', 'A')             // returns false
   *    math.equal('2e3', '2000')            // returns true
   *    math.equalText('2e3', '2000')        // returns false
   *
   *    math.equalText('B', ['A', 'B', 'C']) // returns [false, true, false]
   *
   * See also:
   *
   *    equal, compareText, compare, compareNatural
   *
   * @param  {string | Array | DenseMatrix} x First string to compare
   * @param  {string | Array | DenseMatrix} y Second string to compare
   * @return {number | Array | DenseMatrix} Returns true if the values are equal, and false if not.
   */ return typed($2932bf1d5a3c7767$var$name, {
        "any, any": function anyAny(x, y) {
            return isZero(compareText(x, y));
        }
    });
});

});

parcelRegister("gF5Al", function(module, exports) {

$parcel$export(module.exports, "createErf", function () { return $c214cec69c9c5b9e$export$470dfa326d6cbdf5; });

var $e04i1 = parcelRequire("e04i1");

var $kFRKb = parcelRequire("kFRKb");

var $2mPYl = parcelRequire("2mPYl");
var $c214cec69c9c5b9e$var$name = "erf";
var $c214cec69c9c5b9e$var$dependencies = [
    "typed"
];
var $c214cec69c9c5b9e$export$470dfa326d6cbdf5 = /* #__PURE__ */ (0, $2mPYl.factory)($c214cec69c9c5b9e$var$name, $c214cec69c9c5b9e$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Compute the erf function of a value using a rational Chebyshev
   * approximations for different intervals of x.
   *
   * This is a translation of W. J. Cody's Fortran implementation from 1987
   * ( https://www.netlib.org/specfun/erf ). See the AMS publication
   * "Rational Chebyshev Approximations for the Error Function" by W. J. Cody
   * for an explanation of this process.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.erf(x)
   *
   * Examples:
   *
   *    math.erf(0.2)    // returns 0.22270258921047847
   *    math.erf(-0.5)   // returns -0.5204998778130465
   *    math.erf(4)      // returns 0.9999999845827421
   *
   * @param {number | Array | Matrix} x   A real number
   * @return {number | Array | Matrix}    The erf of `x`
   */ var erf = typed("name", {
        number: function number(x) {
            var y = Math.abs(x);
            if (y >= $c214cec69c9c5b9e$var$MAX_NUM) return (0, $kFRKb.sign)(x);
            if (y <= $c214cec69c9c5b9e$var$THRESH) return (0, $kFRKb.sign)(x) * erf1(y);
            if (y <= 4.0) return (0, $kFRKb.sign)(x) * (1 - erfc2(y));
            return (0, $kFRKb.sign)(x) * (1 - erfc3(y));
        },
        "Array | Matrix": function ArrayMatrix(n) {
            return (0, $e04i1.deepMap)(n, erf);
        } // TODO: For complex numbers, use the approximation for the Faddeeva function
    });
    /**
   * Approximates the error function erf() for x <= 0.46875 using this function:
   *               n
   * erf(x) = x * sum (p_j * x^(2j)) / (q_j * x^(2j))
   *              j=0
   */ function erf1(y) {
        var ysq = y * y;
        var xnum = $c214cec69c9c5b9e$var$P[0][4] * ysq;
        var xden = ysq;
        var i;
        for(i = 0; i < 3; i += 1){
            xnum = (xnum + $c214cec69c9c5b9e$var$P[0][i]) * ysq;
            xden = (xden + $c214cec69c9c5b9e$var$Q[0][i]) * ysq;
        }
        return y * (xnum + $c214cec69c9c5b9e$var$P[0][3]) / (xden + $c214cec69c9c5b9e$var$Q[0][3]);
    }
    /**
   * Approximates the complement of the error function erfc() for
   * 0.46875 <= x <= 4.0 using this function:
   *                       n
   * erfc(x) = e^(-x^2) * sum (p_j * x^j) / (q_j * x^j)
   *                      j=0
   */ function erfc2(y) {
        var xnum = $c214cec69c9c5b9e$var$P[1][8] * y;
        var xden = y;
        var i;
        for(i = 0; i < 7; i += 1){
            xnum = (xnum + $c214cec69c9c5b9e$var$P[1][i]) * y;
            xden = (xden + $c214cec69c9c5b9e$var$Q[1][i]) * y;
        }
        var result = (xnum + $c214cec69c9c5b9e$var$P[1][7]) / (xden + $c214cec69c9c5b9e$var$Q[1][7]);
        var ysq = parseInt(y * 16) / 16;
        var del = (y - ysq) * (y + ysq);
        return Math.exp(-ysq * ysq) * Math.exp(-del) * result;
    }
    /**
   * Approximates the complement of the error function erfc() for x > 4.0 using
   * this function:
   *
   * erfc(x) = (e^(-x^2) / x) * [ 1/sqrt(pi) +
   *               n
   *    1/(x^2) * sum (p_j * x^(-2j)) / (q_j * x^(-2j)) ]
   *              j=0
   */ function erfc3(y) {
        var ysq = 1 / (y * y);
        var xnum = $c214cec69c9c5b9e$var$P[2][5] * ysq;
        var xden = ysq;
        var i;
        for(i = 0; i < 4; i += 1){
            xnum = (xnum + $c214cec69c9c5b9e$var$P[2][i]) * ysq;
            xden = (xden + $c214cec69c9c5b9e$var$Q[2][i]) * ysq;
        }
        var result = ysq * (xnum + $c214cec69c9c5b9e$var$P[2][4]) / (xden + $c214cec69c9c5b9e$var$Q[2][4]);
        result = ($c214cec69c9c5b9e$var$SQRPI - result) / y;
        ysq = parseInt(y * 16) / 16;
        var del = (y - ysq) * (y + ysq);
        return Math.exp(-ysq * ysq) * Math.exp(-del) * result;
    }
    return erf;
});
/**
 * Upper bound for the first approximation interval, 0 <= x <= THRESH
 * @constant
 */ var $c214cec69c9c5b9e$var$THRESH = 0.46875;
/**
 * Constant used by W. J. Cody's Fortran77 implementation to denote sqrt(pi)
 * @constant
 */ var $c214cec69c9c5b9e$var$SQRPI = 5.6418958354775628695e-1;
/**
 * Coefficients for each term of the numerator sum (p_j) for each approximation
 * interval (see W. J. Cody's paper for more details)
 * @constant
 */ var $c214cec69c9c5b9e$var$P = [
    [
        3.16112374387056560e00,
        1.13864154151050156e02,
        3.77485237685302021e02,
        3.20937758913846947e03,
        1.85777706184603153e-1
    ],
    [
        5.64188496988670089e-1,
        8.88314979438837594e00,
        6.61191906371416295e01,
        2.98635138197400131e02,
        8.81952221241769090e02,
        1.71204761263407058e03,
        2.05107837782607147e03,
        1.23033935479799725e03,
        2.15311535474403846e-8
    ],
    [
        3.05326634961232344e-1,
        3.60344899949804439e-1,
        1.25781726111229246e-1,
        1.60837851487422766e-2,
        6.58749161529837803e-4,
        1.63153871373020978e-2
    ]
];
/**
 * Coefficients for each term of the denominator sum (q_j) for each approximation
 * interval (see W. J. Cody's paper for more details)
 * @constant
 */ var $c214cec69c9c5b9e$var$Q = [
    [
        2.36012909523441209e01,
        2.44024637934444173e02,
        1.28261652607737228e03,
        2.84423683343917062e03
    ],
    [
        1.57449261107098347e01,
        1.17693950891312499e02,
        5.37181101862009858e02,
        1.62138957456669019e03,
        3.29079923573345963e03,
        4.36261909014324716e03,
        3.43936767414372164e03,
        1.23033935480374942e03
    ],
    [
        2.56852019228982242e00,
        1.87295284992346047e00,
        5.27905102951428412e-1,
        6.05183413124413191e-2,
        2.33520497626869185e-3
    ]
];
/**
 * Maximum/minimum safe numbers to input to erf() (in ES6+, this number is
 * Number.[MAX|MIN]_SAFE_INTEGER). erf() for all numbers beyond this limit will
 * return 1
 */ var $c214cec69c9c5b9e$var$MAX_NUM = Math.pow(2, 53);

});

parcelRegister("5ANsT", function(module, exports) {

$parcel$export(module.exports, "createExp", function () { return $4126af40e6c2f8d2$export$95a576617fd015b1; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");

var $6fCew = parcelRequire("6fCew");
var $4126af40e6c2f8d2$var$name = "exp";
var $4126af40e6c2f8d2$var$dependencies = [
    "typed"
];
var $4126af40e6c2f8d2$export$95a576617fd015b1 = /* #__PURE__ */ (0, $2mPYl.factory)($4126af40e6c2f8d2$var$name, $4126af40e6c2f8d2$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Calculate the exponent of a value.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.exp(x)
   *
   * Examples:
   *
   *    math.exp(2)                  // returns number 7.3890560989306495
   *    math.pow(math.e, 2)          // returns number 7.3890560989306495
   *    math.log(math.exp(2))        // returns number 2
   *
   *    math.exp([1, 2, 3])
   *    // returns Array [
   *    //   2.718281828459045,
   *    //   7.3890560989306495,
   *    //   20.085536923187668
   *    // ]
   *
   * See also:
   *
   *    expm1, log, pow
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x  A number or matrix to exponentiate
   * @return {number | BigNumber | Complex | Array | Matrix} Exponent of `x`
   */ var exp = typed($4126af40e6c2f8d2$var$name, {
        number: (0, $6fCew.expNumber),
        Complex: function Complex(x) {
            return x.exp();
        },
        BigNumber: function BigNumber(x) {
            return x.exp();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // TODO: exp(sparse) should return a dense matrix since exp(0)==1
            return (0, $e04i1.deepMap)(x, exp);
        }
    });
    return exp;
});

});

parcelRegister("cErc7", function(module, exports) {

$parcel$export(module.exports, "createExpm", function () { return $935e50bc5cc802d1$export$f2c0a6357ff6cb4c; });

var $1amHZ = parcelRequire("1amHZ");

var $6NxuJ = parcelRequire("6NxuJ");

var $2mPYl = parcelRequire("2mPYl");
var $935e50bc5cc802d1$var$name = "expm";
var $935e50bc5cc802d1$var$dependencies = [
    "typed",
    "abs",
    "add",
    "identity",
    "inv",
    "multiply"
];
var $935e50bc5cc802d1$export$f2c0a6357ff6cb4c = /* #__PURE__ */ (0, $2mPYl.factory)($935e50bc5cc802d1$var$name, $935e50bc5cc802d1$var$dependencies, function(_ref) {
    var typed = _ref.typed, abs = _ref.abs, add = _ref.add, identity = _ref.identity, inv = _ref.inv, multiply = _ref.multiply;
    /**
   * Compute the matrix exponential, expm(A) = e^A. The matrix must be square.
   * Not to be confused with exp(a), which performs element-wise
   * exponentiation.
   *
   * The exponential is calculated using the Padé approximant with scaling and
   * squaring; see "Nineteen Dubious Ways to Compute the Exponential of a
   * Matrix," by Moler and Van Loan.
   *
   * Syntax:
   *
   *     math.expm(x)
   *
   * Examples:
   *
   *     const A = [[0,2],[0,0]]
   *     math.expm(A)        // returns [[1,2],[0,1]]
   *
   * See also:
   *
   *     exp
   *
   * @param {Matrix} x  A square Matrix
   * @return {Matrix}   The exponential of x
   */ return typed($935e50bc5cc802d1$var$name, {
        Matrix: function Matrix(A) {
            // Check matrix size
            var size = A.size();
            if (size.length !== 2 || size[0] !== size[1]) throw new RangeError("Matrix must be square (size: " + (0, $6NxuJ.format)(size) + ")");
            var n = size[0]; // Desired accuracy of the approximant (The actual accuracy
            // will be affected by round-off error)
            var eps = 1e-15; // The Padé approximant is not so accurate when the values of A
            // are "large", so scale A by powers of two. Then compute the
            // exponential, and square the result repeatedly according to
            // the identity e^A = (e^(A/m))^m
            // Compute infinity-norm of A, ||A||, to see how "big" it is
            var infNorm = infinityNorm(A); // Find the optimal scaling factor and number of terms in the
            // Padé approximant to reach the desired accuracy
            var params = findParams(infNorm, eps);
            var q = params.q;
            var j = params.j; // The Pade approximation to e^A is:
            // Rqq(A) = Dqq(A) ^ -1 * Nqq(A)
            // where
            // Nqq(A) = sum(i=0, q, (2q-i)!p! / [ (2q)!i!(q-i)! ] A^i
            // Dqq(A) = sum(i=0, q, (2q-i)!q! / [ (2q)!i!(q-i)! ] (-A)^i
            // Scale A by 1 / 2^j
            var Apos = multiply(A, Math.pow(2, -j)); // The i=0 term is just the identity matrix
            var N = identity(n);
            var D = identity(n); // Initialization (i=0)
            var factor = 1; // Initialization (i=1)
            var AposToI = Apos; // Cloning not necessary
            var alternate = -1;
            for(var i = 1; i <= q; i++){
                if (i > 1) {
                    AposToI = multiply(AposToI, Apos);
                    alternate = -alternate;
                }
                factor = factor * (q - i + 1) / ((2 * q - i + 1) * i);
                N = add(N, multiply(factor, AposToI));
                D = add(D, multiply(factor * alternate, AposToI));
            }
            var R = multiply(inv(D), N); // Square j times
            for(var _i = 0; _i < j; _i++)R = multiply(R, R);
            return (0, $1amHZ.isSparseMatrix)(A) ? A.createSparseMatrix(R) : R;
        }
    });
    function infinityNorm(A) {
        var n = A.size()[0];
        var infNorm = 0;
        for(var i = 0; i < n; i++){
            var rowSum = 0;
            for(var j = 0; j < n; j++)rowSum += abs(A.get([
                i,
                j
            ]));
            infNorm = Math.max(rowSum, infNorm);
        }
        return infNorm;
    }
    /**
   * Find the best parameters for the Pade approximant given
   * the matrix norm and desired accuracy. Returns the first acceptable
   * combination in order of increasing computational load.
   */ function findParams(infNorm, eps) {
        var maxSearchSize = 30;
        for(var k = 0; k < maxSearchSize; k++)for(var q = 0; q <= k; q++){
            var j = k - q;
            if (errorEstimate(infNorm, q, j) < eps) return {
                q: q,
                j: j
            };
        }
        throw new Error("Could not find acceptable parameters to compute the matrix exponential (try increasing maxSearchSize in expm.js)");
    }
    /**
   * Returns the estimated error of the Pade approximant for the given
   * parameters.
   */ function errorEstimate(infNorm, q, j) {
        var qfac = 1;
        for(var i = 2; i <= q; i++)qfac *= i;
        var twoqfac = qfac;
        for(var _i2 = q + 1; _i2 <= 2 * q; _i2++)twoqfac *= _i2;
        var twoqp1fac = twoqfac * (2 * q + 1);
        return 8.0 * Math.pow(infNorm / Math.pow(2, j), 2 * q) * qfac * qfac / (twoqfac * twoqp1fac);
    }
});

});

parcelRegister("bvvLQ", function(module, exports) {

$parcel$export(module.exports, "createExpm1", function () { return $860b3bf97dfba798$export$2b203b63f664bab3; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");

var $6fCew = parcelRequire("6fCew");
var $860b3bf97dfba798$var$name = "expm1";
var $860b3bf97dfba798$var$dependencies = [
    "typed",
    "Complex"
];
var $860b3bf97dfba798$export$2b203b63f664bab3 = /* #__PURE__ */ (0, $2mPYl.factory)($860b3bf97dfba798$var$name, $860b3bf97dfba798$var$dependencies, function(_ref) {
    var typed = _ref.typed, _Complex = _ref.Complex;
    /**
   * Calculate the value of subtracting 1 from the exponential value.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.expm1(x)
   *
   * Examples:
   *
   *    math.expm1(2)                      // returns number 6.38905609893065
   *    math.pow(math.e, 2) - 1            // returns number 6.3890560989306495
   *    math.log(math.expm1(2) + 1)        // returns number 2
   *
   *    math.expm1([1, 2, 3])
   *    // returns Array [
   *    //   1.718281828459045,
   *    //   6.3890560989306495,
   *    //   19.085536923187668
   *    // ]
   *
   * See also:
   *
   *    exp, log, pow
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x  A number or matrix to apply expm1
   * @return {number | BigNumber | Complex | Array | Matrix} Exponent of `x`
   */ var expm1 = typed($860b3bf97dfba798$var$name, {
        number: (0, $6fCew.expm1Number),
        Complex: function Complex(x) {
            var r = Math.exp(x.re);
            return new _Complex(r * Math.cos(x.im) - 1, r * Math.sin(x.im));
        },
        BigNumber: function BigNumber(x) {
            return x.exp().minus(1);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, expm1);
        }
    });
    return expm1;
});

});

parcelRegister("hyM3K", function(module, exports) {

$parcel$export(module.exports, "createEye", function () { return $cc8ae441322e0a87$export$a261decc5e53c821; });
// TODO: function eye is removed since v5.0.0 (June 2018). Remove it some day.

var $2mPYl = parcelRequire("2mPYl");
var $cc8ae441322e0a87$export$a261decc5e53c821 = /* #__PURE__ */ (0, $2mPYl.factory)("eye", [], function() {
    return function eye() {
        throw new Error('Function "eye" is renamed to "identity" since mathjs version 5.0.0. To keep eye working, create an alias for it using "math.import({eye: math.identity}, {override: true})"');
    };
});

});

parcelRegister("k8VNd", function(module, exports) {

$parcel$export(module.exports, "createFactorial", function () { return $eaa1627510ce41ca$export$92c37ad44e3d0481; });

var $e04i1 = parcelRequire("e04i1");

var $2mPYl = parcelRequire("2mPYl");
var $eaa1627510ce41ca$var$name = "factorial";
var $eaa1627510ce41ca$var$dependencies = [
    "typed",
    "gamma"
];
var $eaa1627510ce41ca$export$92c37ad44e3d0481 = /* #__PURE__ */ (0, $2mPYl.factory)($eaa1627510ce41ca$var$name, $eaa1627510ce41ca$var$dependencies, function(_ref) {
    var typed = _ref.typed, gamma = _ref.gamma;
    /**
   * Compute the factorial of a value
   *
   * Factorial only supports an integer value as argument.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.factorial(n)
   *
   * Examples:
   *
   *    math.factorial(5)    // returns 120
   *    math.factorial(3)    // returns 6
   *
   * See also:
   *
   *    combinations, combinationsWithRep, gamma, permutations
   *
   * @param {number | BigNumber | Array | Matrix} n   An integer number
   * @return {number | BigNumber | Array | Matrix}    The factorial of `n`
   */ var factorial = typed($eaa1627510ce41ca$var$name, {
        number: function number(n) {
            if (n < 0) throw new Error("Value must be non-negative");
            return gamma(n + 1);
        },
        BigNumber: function BigNumber(n) {
            if (n.isNegative()) throw new Error("Value must be non-negative");
            return gamma(n.plus(1));
        },
        "Array | Matrix": function ArrayMatrix(n) {
            return (0, $e04i1.deepMap)(n, factorial);
        }
    });
    return factorial;
});

});

parcelRegister("9t5pt", function(module, exports) {

$parcel$export(module.exports, "createFibonacciHeapClass", function () { return $6e4b04c036f4179f$export$3143a09e27a84c41; });

var $2mPYl = parcelRequire("2mPYl");
var $6e4b04c036f4179f$var$name = "FibonacciHeap";
var $6e4b04c036f4179f$var$dependencies = [
    "smaller",
    "larger"
];
var $6e4b04c036f4179f$export$3143a09e27a84c41 = /* #__PURE__ */ (0, $2mPYl.factory)($6e4b04c036f4179f$var$name, $6e4b04c036f4179f$var$dependencies, function(_ref) {
    var smaller = _ref.smaller, larger = _ref.larger;
    var oneOverLogPhi = 1.0 / Math.log((1.0 + Math.sqrt(5.0)) / 2.0);
    /**
   * Fibonacci Heap implementation, used interally for Matrix math.
   * @class FibonacciHeap
   * @constructor FibonacciHeap
   */ function FibonacciHeap() {
        if (!(this instanceof FibonacciHeap)) throw new SyntaxError("Constructor must be called with the new operator");
         // initialize fields
        this._minimum = null;
        this._size = 0;
    }
    /**
   * Attach type information
   */ FibonacciHeap.prototype.type = "FibonacciHeap";
    FibonacciHeap.prototype.isFibonacciHeap = true;
    /**
   * Inserts a new data element into the heap. No heap consolidation is
   * performed at this time, the new node is simply inserted into the root
   * list of this heap. Running time: O(1) actual.
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.insert = function(key, value) {
        // create node
        var node = {
            key: key,
            value: value,
            degree: 0
        }; // check we have a node in the minimum
        if (this._minimum) {
            // minimum node
            var minimum = this._minimum; // update left & right of node
            node.left = minimum;
            node.right = minimum.right;
            minimum.right = node;
            node.right.left = node; // update minimum node in heap if needed
            if (smaller(key, minimum.key)) // node has a smaller key, use it as minimum
            this._minimum = node;
        } else {
            // set left & right
            node.left = node;
            node.right = node; // this is the first node
            this._minimum = node;
        } // increment number of nodes in heap
        this._size++; // return node
        return node;
    };
    /**
   * Returns the number of nodes in heap. Running time: O(1) actual.
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.size = function() {
        return this._size;
    };
    /**
   * Removes all elements from this heap.
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.clear = function() {
        this._minimum = null;
        this._size = 0;
    };
    /**
   * Returns true if the heap is empty, otherwise false.
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.isEmpty = function() {
        return this._size === 0;
    };
    /**
   * Extracts the node with minimum key from heap. Amortized running
   * time: O(log n).
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.extractMinimum = function() {
        // node to remove
        var node = this._minimum; // check we have a minimum
        if (node === null) return node;
         // current minimum
        var minimum = this._minimum; // get number of children
        var numberOfChildren = node.degree; // pointer to the first child
        var x = node.child; // for each child of node do...
        while(numberOfChildren > 0){
            // store node in right side
            var tempRight = x.right; // remove x from child list
            x.left.right = x.right;
            x.right.left = x.left; // add x to root list of heap
            x.left = minimum;
            x.right = minimum.right;
            minimum.right = x;
            x.right.left = x; // set Parent[x] to null
            x.parent = null;
            x = tempRight;
            numberOfChildren--;
        } // remove node from root list of heap
        node.left.right = node.right;
        node.right.left = node.left; // update minimum
        if (node === node.right) // empty
        minimum = null;
        else {
            // update minimum
            minimum = node.right; // we need to update the pointer to the root with minimum key
            minimum = _findMinimumNode(minimum, this._size);
        } // decrement size of heap
        this._size--; // update minimum
        this._minimum = minimum; // return node
        return node;
    };
    /**
   * Removes a node from the heap given the reference to the node. The trees
   * in the heap will be consolidated, if necessary. This operation may fail
   * to remove the correct element if there are nodes with key value -Infinity.
   * Running time: O(log n) amortized.
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.remove = function(node) {
        // decrease key value
        this._minimum = _decreaseKey(this._minimum, node, -1); // remove the smallest
        this.extractMinimum();
    };
    /**
   * Decreases the key value for a heap node, given the new value to take on.
   * The structure of the heap may be changed and will not be consolidated.
   * Running time: O(1) amortized.
   * @memberof FibonacciHeap
   */ function _decreaseKey(minimum, node, key) {
        // set node key
        node.key = key; // get parent node
        var parent = node.parent;
        if (parent && smaller(node.key, parent.key)) {
            // remove node from parent
            _cut(minimum, node, parent); // remove all nodes from parent to the root parent
            _cascadingCut(minimum, parent);
        } // update minimum node if needed
        if (smaller(node.key, minimum.key)) minimum = node;
         // return minimum
        return minimum;
    }
    /**
   * The reverse of the link operation: removes node from the child list of parent.
   * This method assumes that min is non-null. Running time: O(1).
   * @memberof FibonacciHeap
   */ function _cut(minimum, node, parent) {
        // remove node from parent children and decrement Degree[parent]
        node.left.right = node.right;
        node.right.left = node.left;
        parent.degree--; // reset y.child if necessary
        if (parent.child === node) parent.child = node.right;
         // remove child if degree is 0
        if (parent.degree === 0) parent.child = null;
         // add node to root list of heap
        node.left = minimum;
        node.right = minimum.right;
        minimum.right = node;
        node.right.left = node; // set parent[node] to null
        node.parent = null; // set mark[node] to false
        node.mark = false;
    }
    /**
   * Performs a cascading cut operation. This cuts node from its parent and then
   * does the same for its parent, and so on up the tree.
   * Running time: O(log n); O(1) excluding the recursion.
   * @memberof FibonacciHeap
   */ function _cascadingCut(minimum, node) {
        // store parent node
        var parent = node.parent; // if there's a parent...
        if (!parent) return;
         // if node is unmarked, set it marked
        if (!node.mark) node.mark = true;
        else {
            // it's marked, cut it from parent
            _cut(minimum, node, parent); // cut its parent as well
            _cascadingCut(parent);
        }
    }
    /**
   * Make the first node a child of the second one. Running time: O(1) actual.
   * @memberof FibonacciHeap
   */ var _linkNodes = function _linkNodes(node, parent) {
        // remove node from root list of heap
        node.left.right = node.right;
        node.right.left = node.left; // make node a Child of parent
        node.parent = parent;
        if (!parent.child) {
            parent.child = node;
            node.right = node;
            node.left = node;
        } else {
            node.left = parent.child;
            node.right = parent.child.right;
            parent.child.right = node;
            node.right.left = node;
        } // increase degree[parent]
        parent.degree++; // set mark[node] false
        node.mark = false;
    };
    function _findMinimumNode(minimum, size) {
        // to find trees of the same degree efficiently we use an array of length O(log n) in which we keep a pointer to one root of each degree
        var arraySize = Math.floor(Math.log(size) * oneOverLogPhi) + 1; // create list with initial capacity
        var array = new Array(arraySize); // find the number of root nodes.
        var numRoots = 0;
        var x = minimum;
        if (x) {
            numRoots++;
            x = x.right;
            while(x !== minimum){
                numRoots++;
                x = x.right;
            }
        } // vars
        var y; // For each node in root list do...
        while(numRoots > 0){
            // access this node's degree..
            var d = x.degree; // get next node
            var next = x.right; // check if there is a node already in array with the same degree
            while(true){
                // get node with the same degree is any
                y = array[d];
                if (!y) break;
                 // make one node with the same degree a child of the other, do this based on the key value.
                if (larger(x.key, y.key)) {
                    var temp = y;
                    y = x;
                    x = temp;
                } // make y a child of x
                _linkNodes(y, x); // we have handled this degree, go to next one.
                array[d] = null;
                d++;
            } // save this node for later when we might encounter another of the same degree.
            array[d] = x; // move forward through list.
            x = next;
            numRoots--;
        } // Set min to null (effectively losing the root list) and reconstruct the root list from the array entries in array[].
        minimum = null; // loop nodes in array
        for(var i = 0; i < arraySize; i++){
            // get current node
            y = array[i];
            if (!y) continue;
             // check if we have a linked list
            if (minimum) {
                // First remove node from root list.
                y.left.right = y.right;
                y.right.left = y.left; // now add to root list, again.
                y.left = minimum;
                y.right = minimum.right;
                minimum.right = y;
                y.right.left = y; // check if this is a new min.
                if (smaller(y.key, minimum.key)) minimum = y;
            } else minimum = y;
        }
        return minimum;
    }
    return FibonacciHeap;
}, {
    isClass: true
});

});

parcelRegister("h3w9M", function(module, exports) {

$parcel$export(module.exports, "createFilter", function () { return $c6aba9296a2ca584$export$5d81789ff4aeccdf; });

var $5WdrK = parcelRequire("5WdrK");

var $kpJv9 = parcelRequire("kpJv9");

var $2mPYl = parcelRequire("2mPYl");
var $c6aba9296a2ca584$var$name = "filter";
var $c6aba9296a2ca584$var$dependencies = [
    "typed"
];
var $c6aba9296a2ca584$export$5d81789ff4aeccdf = /* #__PURE__ */ (0, $2mPYl.factory)($c6aba9296a2ca584$var$name, $c6aba9296a2ca584$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Filter the items in an array or one dimensional matrix.
   *
   * Syntax:
   *
   *    math.filter(x, test)
   *
   * Examples:
   *
   *    function isPositive (x) {
   *      return x > 0
   *    }
   *    math.filter([6, -2, -1, 4, 3], isPositive) // returns [6, 4, 3]
   *
   *    math.filter(["23", "foo", "100", "55", "bar"], /[0-9]+/) // returns ["23", "100", "55"]
   *
   * See also:
   *
   *    forEach, map, sort
   *
   * @param {Matrix | Array} x    A one dimensional matrix or array to filter
   * @param {Function | RegExp} test
   *        A function or regular expression to test items.
   *        All entries for which `test` returns true are returned.
   *        When `test` is a function, it is invoked with three parameters:
   *        the value of the element, the index of the element, and the
   *        matrix/array being traversed. The function must return a boolean.
   * @return {Matrix | Array} Returns the filtered matrix.
   */ return typed("filter", {
        "Array, function": $c6aba9296a2ca584$var$_filterCallback,
        "Matrix, function": function MatrixFunction(x, test) {
            return x.create($c6aba9296a2ca584$var$_filterCallback(x.toArray(), test));
        },
        "Array, RegExp": (0, $5WdrK.filterRegExp),
        "Matrix, RegExp": function MatrixRegExp(x, test) {
            return x.create((0, $5WdrK.filterRegExp)(x.toArray(), test));
        }
    });
});
/**
 * Filter values in a callback given a callback function
 * @param {Array} x
 * @param {Function} callback
 * @return {Array} Returns the filtered array
 * @private
 */ function $c6aba9296a2ca584$var$_filterCallback(x, callback) {
    // figure out what number of arguments the callback function expects
    var args = (0, $kpJv9.maxArgumentCount)(callback);
    return (0, $5WdrK.filter)(x, function(value, index, array) {
        // invoke the callback function with the right number of arguments
        if (args === 1) return callback(value);
        else if (args === 2) return callback(value, [
            index
        ]);
        else // 3 or -1
        return callback(value, [
            index
        ], array);
    });
}

});

parcelRegister("lCJe5", function(module, exports) {

$parcel$export(module.exports, "createFix", function () { return $fbe03a8f602d2131$export$3ed06081b8a4ee6; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");
var $fbe03a8f602d2131$var$name = "fix";
var $fbe03a8f602d2131$var$dependencies = [
    "typed",
    "Complex",
    "ceil",
    "floor"
];
var $fbe03a8f602d2131$export$3ed06081b8a4ee6 = /* #__PURE__ */ (0, $2mPYl.factory)($fbe03a8f602d2131$var$name, $fbe03a8f602d2131$var$dependencies, function(_ref) {
    var typed = _ref.typed, _Complex = _ref.Complex, ceil = _ref.ceil, floor = _ref.floor;
    /**
   * Round a value towards zero.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.fix(x)
   *
   * Examples:
   *
   *    math.fix(3.2)                // returns number 3
   *    math.fix(3.8)                // returns number 3
   *    math.fix(-4.2)               // returns number -4
   *    math.fix(-4.7)               // returns number -4
   *
   *    const c = math.complex(3.2, -2.7)
   *    math.fix(c)                  // returns Complex 3 - 2i
   *
   *    math.fix([3.2, 3.8, -4.7])   // returns Array [3, 3, -4]
   *
   * See also:
   *
   *    ceil, floor, round
   *
   * @param {number | BigNumber | Fraction | Complex | Array | Matrix} x Number to be rounded
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix}            Rounded value
   */ var fix = typed("fix", {
        number: function number(x) {
            return x > 0 ? floor(x) : ceil(x);
        },
        Complex: function Complex(x) {
            return new _Complex(x.re > 0 ? Math.floor(x.re) : Math.ceil(x.re), x.im > 0 ? Math.floor(x.im) : Math.ceil(x.im));
        },
        BigNumber: function BigNumber(x) {
            return x.isNegative() ? ceil(x) : floor(x);
        },
        Fraction: function Fraction(x) {
            return x.s < 0 ? x.ceil() : x.floor();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since fix(0) = 0
            return (0, $e04i1.deepMap)(x, fix, true);
        }
    });
    return fix;
});

});

parcelRegister("5svDZ", function(module, exports) {

$parcel$export(module.exports, "createFlatten", function () { return $3f981d20763f2154$export$107988e3ee9f3d12; });

var $7ITGG = parcelRequire("7ITGG");

var $5WdrK = parcelRequire("5WdrK");

var $2mPYl = parcelRequire("2mPYl");
var $3f981d20763f2154$var$name = "flatten";
var $3f981d20763f2154$var$dependencies = [
    "typed",
    "matrix"
];
var $3f981d20763f2154$export$107988e3ee9f3d12 = /* #__PURE__ */ (0, $2mPYl.factory)($3f981d20763f2154$var$name, $3f981d20763f2154$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix;
    /**
   * Flatten a multi dimensional matrix into a single dimensional matrix.
   *
   * Syntax:
   *
   *    math.flatten(x)
   *
   * Examples:
   *
   *    math.flatten([[1,2], [3,4]])   // returns [1, 2, 3, 4]
   *
   * See also:
   *
   *    concat, resize, size, squeeze
   *
   * @param {Matrix | Array} x   Matrix to be flattened
   * @return {Matrix | Array} Returns the flattened matrix
   */ return typed($3f981d20763f2154$var$name, {
        Array: function Array(x) {
            return (0, $5WdrK.flatten)((0, $7ITGG.clone)(x));
        },
        Matrix: function Matrix(x) {
            var flat = (0, $5WdrK.flatten)((0, $7ITGG.clone)(x.toArray())); // TODO: return the same matrix type as x
            return matrix(flat);
        }
    });
});

});

parcelRegister("hY9Fd", function(module, exports) {

$parcel$export(module.exports, "createFloor", function () { return $d14f894d8c1ce50a$export$e04e4803a9128c9b; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");

var $kFRKb = parcelRequire("kFRKb");

var $ijobM = parcelRequire("ijobM");
var $d14f894d8c1ce50a$var$name = "floor";
var $d14f894d8c1ce50a$var$dependencies = [
    "typed",
    "config",
    "round"
];
var $d14f894d8c1ce50a$export$e04e4803a9128c9b = /* #__PURE__ */ (0, $2mPYl.factory)($d14f894d8c1ce50a$var$name, $d14f894d8c1ce50a$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, round = _ref.round;
    /**
   * Round a value towards minus infinity.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.floor(x)
   *
   * Examples:
   *
   *    math.floor(3.2)              // returns number 3
   *    math.floor(3.8)              // returns number 3
   *    math.floor(-4.2)             // returns number -5
   *    math.floor(-4.7)             // returns number -5
   *
   *    const c = math.complex(3.2, -2.7)
   *    math.floor(c)                // returns Complex 3 - 3i
   *
   *    math.floor([3.2, 3.8, -4.7]) // returns Array [3, 3, -5]
   *
   * See also:
   *
   *    ceil, fix, round
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix} x  Number to be rounded
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix} Rounded value
   */ var floor = typed("floor", {
        number: function number(x) {
            if ((0, $kFRKb.nearlyEqual)(x, round(x), config.epsilon)) return round(x);
            else return Math.floor(x);
        },
        Complex: function Complex(x) {
            return x.floor();
        },
        BigNumber: function BigNumber(x) {
            if ((0, $ijobM.nearlyEqual)(x, round(x), config.epsilon)) return round(x);
            else return x.floor();
        },
        Fraction: function Fraction(x) {
            return x.floor();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since floor(0) = 0
            return (0, $e04i1.deepMap)(x, floor, true);
        }
    });
    return floor;
});

});

parcelRegister("lBVSt", function(module, exports) {

$parcel$export(module.exports, "createForEach", function () { return $fbb9f2f6a02d2a9b$export$a5218987e0811e05; });

var $kpJv9 = parcelRequire("kpJv9");

var $5WdrK = parcelRequire("5WdrK");

var $2mPYl = parcelRequire("2mPYl");
var $fbb9f2f6a02d2a9b$var$name = "forEach";
var $fbb9f2f6a02d2a9b$var$dependencies = [
    "typed"
];
var $fbb9f2f6a02d2a9b$export$a5218987e0811e05 = /* #__PURE__ */ (0, $2mPYl.factory)($fbb9f2f6a02d2a9b$var$name, $fbb9f2f6a02d2a9b$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Iterate over all elements of a matrix/array, and executes the given callback function.
   *
   * Syntax:
   *
   *    math.forEach(x, callback)
   *
   * Examples:
   *
   *    math.forEach([1, 2, 3], function(value) {
   *      console.log(value)
   *    })
   *    // outputs 1, 2, 3
   *
   * See also:
   *
   *    filter, map, sort
   *
   * @param {Matrix | Array} x    The matrix to iterate on.
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix/array being traversed.
   */ return typed($fbb9f2f6a02d2a9b$var$name, {
        "Array, function": $fbb9f2f6a02d2a9b$var$_forEach,
        "Matrix, function": function MatrixFunction(x, callback) {
            return x.forEach(callback);
        }
    });
});
/**
 * forEach for a multi dimensional array
 * @param {Array} array
 * @param {Function} callback
 * @private
 */ function $fbb9f2f6a02d2a9b$var$_forEach(array, callback) {
    // figure out what number of arguments the callback function expects
    var args = (0, $kpJv9.maxArgumentCount)(callback);
    var recurse = function recurse(value, index) {
        if (Array.isArray(value)) (0, $5WdrK.forEach)(value, function(child, i) {
            // we create a copy of the index array and append the new index value
            recurse(child, index.concat(i));
        });
        else {
            // invoke the callback function with the right number of arguments
            if (args === 1) callback(value);
            else if (args === 2) callback(value, index);
            else // 3 or -1
            callback(value, index, array);
        }
    };
    recurse(array, []);
}

});

parcelRegister("gEIS9", function(module, exports) {

$parcel$export(module.exports, "createFormat", function () { return $c203307d5dda238f$export$abf0d9399b60f9bb; });

var $6NxuJ = parcelRequire("6NxuJ");

var $2mPYl = parcelRequire("2mPYl");
var $c203307d5dda238f$var$name = "format";
var $c203307d5dda238f$var$dependencies = [
    "typed"
];
var $c203307d5dda238f$export$abf0d9399b60f9bb = /* #__PURE__ */ (0, $2mPYl.factory)($c203307d5dda238f$var$name, $c203307d5dda238f$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Format a value of any type into a string.
   *
   * Syntax:
   *
   *    math.format(value)
   *    math.format(value, options)
   *    math.format(value, precision)
   *    math.format(value, callback)
   *
   * Where:
   *
   *  - `value: *`
   *    The value to be formatted
   *  - `options: Object`
   *    An object with formatting options. Available options:
   *    - `notation: string`
   *      Number notation. Choose from:
   *      - 'fixed'
   *        Always use regular number notation.
   *        For example '123.40' and '14000000'
   *      - 'exponential'
   *        Always use exponential notation.
   *        For example '1.234e+2' and '1.4e+7'
   *      - 'engineering'
   *        Always use engineering notation: always have exponential notation,
   *        and select the exponent to be a multiple of 3.
   *        For example '123.4e+0' and '14.0e+6'
   *      - 'auto' (default)
   *        Regular number notation for numbers having an absolute value between
   *        `lower` and `upper` bounds, and uses exponential notation elsewhere.
   *        Lower bound is included, upper bound is excluded.
   *        For example '123.4' and '1.4e7'.
   *    - `precision: number`
   *      A number between 0 and 16 to round the digits of the number. In case
   *      of notations 'exponential', 'engineering', and 'auto', `precision`
   *      defines the total number of significant digits returned.
   *      In case of notation 'fixed', `precision` defines the number of
   *      significant digits after the decimal point.
   *      `precision` is undefined by default.
   *    - `lowerExp: number`
   *      Exponent determining the lower boundary for formatting a value with
   *      an exponent when `notation='auto`. Default value is `-3`.
   *    - `upperExp: number`
   *      Exponent determining the upper boundary for formatting a value with
   *      an exponent when `notation='auto`. Default value is `5`.
   *    - `fraction: string`. Available values: 'ratio' (default) or 'decimal'.
   *      For example `format(fraction(1, 3))` will output '1/3' when 'ratio' is
   *      configured, and will output `0.(3)` when 'decimal' is configured.
   * - `callback: function`
   *   A custom formatting function, invoked for all numeric elements in `value`,
   *   for example all elements of a matrix, or the real and imaginary
   *   parts of a complex number. This callback can be used to override the
   *   built-in numeric notation with any type of formatting. Function `callback`
   *   is called with `value` as parameter and must return a string.
   *
   * When `value` is an Object:
   *
   * - When the object contains a property `format` being a function, this function
   *   is invoked as `value.format(options)` and the result is returned.
   * - When the object has its own `toString` method, this method is invoked
   *   and the result is returned.
   * - In other cases the function will loop over all object properties and
   *   return JSON object notation like '{"a": 2, "b": 3}'.
   *
   * When value is a function:
   *
   * - When the function has a property `syntax`, it returns this
   *   syntax description.
   * - In other cases, a string `'function'` is returned.
   *
   * Examples:
   *
   *    math.format(6.4)                                        // returns '6.4'
   *    math.format(1240000)                                    // returns '1.24e6'
   *    math.format(1/3)                                        // returns '0.3333333333333333'
   *    math.format(1/3, 3)                                     // returns '0.333'
   *    math.format(21385, 2)                                   // returns '21000'
   *    math.format(12e8, {notation: 'fixed'})                  // returns '1200000000'
   *    math.format(2.3,  {notation: 'fixed', precision: 4})    // returns '2.3000'
   *    math.format(52.8, {notation: 'exponential'})            // returns '5.28e+1'
   *    math.format(12400,{notation: 'engineering'})            // returns '12.400e+3'
   *    math.format(2000, {lowerExp: -2, upperExp: 2})          // returns '2e+3'
   *
   *    function formatCurrency(value) {
   *      // return currency notation with two digits:
   *      return '$' + value.toFixed(2)
   *
   *      // you could also use math.format inside the callback:
   *      // return '$' + math.format(value, {notation: 'fixed', precision: 2})
   *    }
   *    math.format([2.1, 3, 0.016], formatCurrency}            // returns '[$2.10, $3.00, $0.02]'
   *
   * See also:
   *
   *    print
   *
   * @param {*} value                               Value to be stringified
   * @param {Object | Function | number} [options]  Formatting options
   * @return {string} The formatted value
   */ return typed($c203307d5dda238f$var$name, {
        any: (0, $6NxuJ.format),
        "any, Object | function | number": (0, $6NxuJ.format)
    });
});

});

parcelRegister("78v1C", function(module, exports) {

$parcel$export(module.exports, "createFraction", function () { return $532158aec369822a$export$de147ca8498e0312; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");
var $532158aec369822a$var$name = "fraction";
var $532158aec369822a$var$dependencies = [
    "typed",
    "Fraction"
];
var $532158aec369822a$export$de147ca8498e0312 = /* #__PURE__ */ (0, $2mPYl.factory)($532158aec369822a$var$name, $532158aec369822a$var$dependencies, function(_ref) {
    var typed = _ref.typed, Fraction = _ref.Fraction;
    /**
   * Create a fraction convert a value to a fraction.
   *
   * Syntax:
   *     math.fraction(numerator, denominator)
   *     math.fraction({n: numerator, d: denominator})
   *     math.fraction(matrix: Array | Matrix)         Turn all matrix entries
   *                                                   into fractions
   *
   * Examples:
   *
   *     math.fraction(1, 3)
   *     math.fraction('2/3')
   *     math.fraction({n: 2, d: 3})
   *     math.fraction([0.2, 0.25, 1.25])
   *
   * See also:
   *
   *    bignumber, number, string, unit
   *
   * @param {number | string | Fraction | BigNumber | Array | Matrix} [args]
   *            Arguments specifying the numerator and denominator of
   *            the fraction
   * @return {Fraction | Array | Matrix} Returns a fraction
   */ var fraction = typed("fraction", {
        number: function number(x) {
            if (!isFinite(x) || isNaN(x)) throw new Error(x + " cannot be represented as a fraction");
            return new Fraction(x);
        },
        string: function string(x) {
            return new Fraction(x);
        },
        "number, number": function numberNumber(numerator, denominator) {
            return new Fraction(numerator, denominator);
        },
        "null": function _null(x) {
            return new Fraction(0);
        },
        BigNumber: function BigNumber(x) {
            return new Fraction(x.toString());
        },
        Fraction: function Fraction(x) {
            return x; // fractions are immutable
        },
        Object: function Object(x) {
            return new Fraction(x);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, fraction);
        }
    });
    return fraction;
});

});

parcelRegister("3j8Ha", function(module, exports) {

$parcel$export(module.exports, "createFractionClass", function () { return $2689e429b7ef79aa$export$c317f082100fca89; });

var $hi4nT = parcelRequire("hi4nT");

var $2mPYl = parcelRequire("2mPYl");
var $2689e429b7ef79aa$var$name = "Fraction";
var $2689e429b7ef79aa$var$dependencies = [];
var $2689e429b7ef79aa$export$c317f082100fca89 = /* #__PURE__ */ (0, $2mPYl.factory)($2689e429b7ef79aa$var$name, $2689e429b7ef79aa$var$dependencies, function() {
    /**
   * Attach type information
   */ (0, (/*@__PURE__*/$parcel$interopDefault($hi4nT))).prototype.type = "Fraction";
    (0, (/*@__PURE__*/$parcel$interopDefault($hi4nT))).prototype.isFraction = true;
    /**
   * Get a JSON representation of a Fraction containing type information
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "Fraction", "n": 3, "d": 8}`
   */ (0, (/*@__PURE__*/$parcel$interopDefault($hi4nT))).prototype.toJSON = function() {
        return {
            mathjs: "Fraction",
            n: this.s * this.n,
            d: this.d
        };
    };
    /**
   * Instantiate a Fraction from a JSON object
   * @param {Object} json  a JSON object structured as:
   *                       `{"mathjs": "Fraction", "n": 3, "d": 8}`
   * @return {BigNumber}
   */ (0, (/*@__PURE__*/$parcel$interopDefault($hi4nT))).fromJSON = function(json) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($hi4nT)))(json);
    };
    return 0, (/*@__PURE__*/$parcel$interopDefault($hi4nT));
}, {
    isClass: true
});

});
parcelRegister("hi4nT", function(module, exports) {
/**
 * @license Fraction.js v4.3.7 31/08/2023
 * https://www.xarg.org/2014/03/rational-numbers-in-javascript/
 *
 * Copyright (c) 2023, Robert Eisele (robert@raw.org)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 **/ /**
 *
 * This class offers the possibility to calculate fractions.
 * You can pass a fraction in different formats. Either as array, as double, as string or as an integer.
 *
 * Array/Object form
 * [ 0 => <numerator>, 1 => <denominator> ]
 * [ n => <numerator>, d => <denominator> ]
 *
 * Integer form
 * - Single integer value
 *
 * Double form
 * - Single double value
 *
 * String form
 * 123.456 - a simple double
 * 123/456 - a string fraction
 * 123.'456' - a double with repeating decimal places
 * 123.(456) - synonym
 * 123.45'6' - a double with repeating last place
 * 123.45(6) - synonym
 *
 * Example:
 *
 * var f = new Fraction("9.4'31'");
 * f.mul([-4, 3]).div(4.9);
 *
 */ (function(root) {
    "use strict";
    // Maximum search depth for cyclic rational numbers. 2000 should be more than enough.
    // Example: 1/7 = 0.(142857) has 6 repeating decimal places.
    // If MAX_CYCLE_LEN gets reduced, long cycles will not be detected and toString() only gets the first 10 digits
    var MAX_CYCLE_LEN = 2000;
    // Parsed data to avoid calling "new" all the time
    var P = {
        "s": 1,
        "n": 0,
        "d": 1
    };
    function assign(n, s) {
        if (isNaN(n = parseInt(n, 10))) throw InvalidParameter();
        return n * s;
    }
    // Creates a new Fraction internally without the need of the bulky constructor
    function newFraction(n, d) {
        if (d === 0) throw DivisionByZero();
        var f = Object.create(Fraction.prototype);
        f["s"] = n < 0 ? -1 : 1;
        n = n < 0 ? -n : n;
        var a = gcd(n, d);
        f["n"] = n / a;
        f["d"] = d / a;
        return f;
    }
    function factorize(num) {
        var factors = {};
        var n = num;
        var i = 2;
        var s = 4;
        while(s <= n){
            while(n % i === 0){
                n /= i;
                factors[i] = (factors[i] || 0) + 1;
            }
            s += 1 + 2 * i++;
        }
        if (n !== num) {
            if (n > 1) factors[n] = (factors[n] || 0) + 1;
        } else factors[num] = (factors[num] || 0) + 1;
        return factors;
    }
    var parse = function(p1, p2) {
        var n = 0, d = 1, s = 1;
        var v = 0, w = 0, x = 0, y = 1, z = 1;
        var A = 0, B = 1;
        var C = 1, D = 1;
        var N = 10000000;
        var M;
        if (p1 === undefined || p1 === null) ;
        else if (p2 !== undefined) {
            n = p1;
            d = p2;
            s = n * d;
            if (n % 1 !== 0 || d % 1 !== 0) throw NonIntegerParameter();
        } else switch(typeof p1){
            case "object":
                if ("d" in p1 && "n" in p1) {
                    n = p1["n"];
                    d = p1["d"];
                    if ("s" in p1) n *= p1["s"];
                } else if (0 in p1) {
                    n = p1[0];
                    if (1 in p1) d = p1[1];
                } else throw InvalidParameter();
                s = n * d;
                break;
            case "number":
                if (p1 < 0) {
                    s = p1;
                    p1 = -p1;
                }
                if (p1 % 1 === 0) n = p1;
                else if (p1 > 0) {
                    if (p1 >= 1) {
                        z = Math.pow(10, Math.floor(1 + Math.log(p1) / Math.LN10));
                        p1 /= z;
                    }
                    // Using Farey Sequences
                    // http://www.johndcook.com/blog/2010/10/20/best-rational-approximation/
                    while(B <= N && D <= N){
                        M = (A + C) / (B + D);
                        if (p1 === M) {
                            if (B + D <= N) {
                                n = A + C;
                                d = B + D;
                            } else if (D > B) {
                                n = C;
                                d = D;
                            } else {
                                n = A;
                                d = B;
                            }
                            break;
                        } else {
                            if (p1 > M) {
                                A += C;
                                B += D;
                            } else {
                                C += A;
                                D += B;
                            }
                            if (B > N) {
                                n = C;
                                d = D;
                            } else {
                                n = A;
                                d = B;
                            }
                        }
                    }
                    n *= z;
                } else if (isNaN(p1) || isNaN(p2)) d = n = NaN;
                break;
            case "string":
                B = p1.match(/\d+|./g);
                if (B === null) throw InvalidParameter();
                if (B[A] === "-") {
                    s = -1;
                    A++;
                } else if (B[A] === "+") A++;
                if (B.length === A + 1) w = assign(B[A++], s);
                else if (B[A + 1] === "." || B[A] === ".") {
                    if (B[A] !== ".") v = assign(B[A++], s);
                    A++;
                    // Check for decimal places
                    if (A + 1 === B.length || B[A + 1] === "(" && B[A + 3] === ")" || B[A + 1] === "'" && B[A + 3] === "'") {
                        w = assign(B[A], s);
                        y = Math.pow(10, B[A].length);
                        A++;
                    }
                    // Check for repeating places
                    if (B[A] === "(" && B[A + 2] === ")" || B[A] === "'" && B[A + 2] === "'") {
                        x = assign(B[A + 1], s);
                        z = Math.pow(10, B[A + 1].length) - 1;
                        A += 3;
                    }
                } else if (B[A + 1] === "/" || B[A + 1] === ":") {
                    w = assign(B[A], s);
                    y = assign(B[A + 2], 1);
                    A += 3;
                } else if (B[A + 3] === "/" && B[A + 1] === " ") {
                    v = assign(B[A], s);
                    w = assign(B[A + 2], s);
                    y = assign(B[A + 4], 1);
                    A += 5;
                }
                if (B.length <= A) {
                    d = y * z;
                    s = /* void */ n = x + d * v + z * w;
                    break;
                }
            default:
                throw InvalidParameter();
        }
        if (d === 0) throw DivisionByZero();
        P["s"] = s < 0 ? -1 : 1;
        P["n"] = Math.abs(n);
        P["d"] = Math.abs(d);
    };
    function modpow(b, e, m) {
        var r = 1;
        for(; e > 0; b = b * b % m, e >>= 1)if (e & 1) r = r * b % m;
        return r;
    }
    function cycleLen(n, d) {
        for(; d % 2 === 0; d /= 2);
        for(; d % 5 === 0; d /= 5);
        if (d === 1) return 0;
        // If we would like to compute really large numbers quicker, we could make use of Fermat's little theorem:
        // 10^(d-1) % d == 1
        // However, we don't need such large numbers and MAX_CYCLE_LEN should be the capstone,
        // as we want to translate the numbers to strings.
        var rem = 10 % d;
        var t = 1;
        for(; rem !== 1; t++){
            rem = rem * 10 % d;
            if (t > MAX_CYCLE_LEN) return 0; // Returning 0 here means that we don't print it as a cyclic number. It's likely that the answer is `d-1`
        }
        return t;
    }
    function cycleStart(n, d, len) {
        var rem1 = 1;
        var rem2 = modpow(10, len, d);
        for(var t = 0; t < 300; t++){
            // Solve 10^s == 10^(s+t) (mod d)
            if (rem1 === rem2) return t;
            rem1 = rem1 * 10 % d;
            rem2 = rem2 * 10 % d;
        }
        return 0;
    }
    function gcd(a, b) {
        if (!a) return b;
        if (!b) return a;
        while(true){
            a %= b;
            if (!a) return b;
            b %= a;
            if (!b) return a;
        }
    }
    /**
   * Module constructor
   *
   * @constructor
   * @param {number|Fraction=} a
   * @param {number=} b
   */ function Fraction(a, b) {
        parse(a, b);
        if (this instanceof Fraction) {
            a = gcd(P["d"], P["n"]); // Abuse variable a
            this["s"] = P["s"];
            this["n"] = P["n"] / a;
            this["d"] = P["d"] / a;
        } else return newFraction(P["s"] * P["n"], P["d"]);
    }
    var DivisionByZero = function() {
        return new Error("Division by Zero");
    };
    var InvalidParameter = function() {
        return new Error("Invalid argument");
    };
    var NonIntegerParameter = function() {
        return new Error("Parameters must be integer");
    };
    Fraction.prototype = {
        "s": 1,
        "n": 0,
        "d": 1,
        /**
     * Calculates the absolute value
     *
     * Ex: new Fraction(-4).abs() => 4
     **/ "abs": function() {
            return newFraction(this["n"], this["d"]);
        },
        /**
     * Inverts the sign of the current fraction
     *
     * Ex: new Fraction(-4).neg() => 4
     **/ "neg": function() {
            return newFraction(-this["s"] * this["n"], this["d"]);
        },
        /**
     * Adds two rational numbers
     *
     * Ex: new Fraction({n: 2, d: 3}).add("14.9") => 467 / 30
     **/ "add": function(a, b) {
            parse(a, b);
            return newFraction(this["s"] * this["n"] * P["d"] + P["s"] * this["d"] * P["n"], this["d"] * P["d"]);
        },
        /**
     * Subtracts two rational numbers
     *
     * Ex: new Fraction({n: 2, d: 3}).add("14.9") => -427 / 30
     **/ "sub": function(a, b) {
            parse(a, b);
            return newFraction(this["s"] * this["n"] * P["d"] - P["s"] * this["d"] * P["n"], this["d"] * P["d"]);
        },
        /**
     * Multiplies two rational numbers
     *
     * Ex: new Fraction("-17.(345)").mul(3) => 5776 / 111
     **/ "mul": function(a, b) {
            parse(a, b);
            return newFraction(this["s"] * P["s"] * this["n"] * P["n"], this["d"] * P["d"]);
        },
        /**
     * Divides two rational numbers
     *
     * Ex: new Fraction("-17.(345)").inverse().div(3)
     **/ "div": function(a, b) {
            parse(a, b);
            return newFraction(this["s"] * P["s"] * this["n"] * P["d"], this["d"] * P["n"]);
        },
        /**
     * Clones the actual object
     *
     * Ex: new Fraction("-17.(345)").clone()
     **/ "clone": function() {
            return newFraction(this["s"] * this["n"], this["d"]);
        },
        /**
     * Calculates the modulo of two rational numbers - a more precise fmod
     *
     * Ex: new Fraction('4.(3)').mod([7, 8]) => (13/3) % (7/8) = (5/6)
     **/ "mod": function(a, b) {
            if (isNaN(this["n"]) || isNaN(this["d"])) return new Fraction(NaN);
            if (a === undefined) return newFraction(this["s"] * this["n"] % this["d"], 1);
            parse(a, b);
            if (0 === P["n"] && 0 === this["d"]) throw DivisionByZero();
            /*
       * First silly attempt, kinda slow
       *
       return that["sub"]({
       "n": num["n"] * Math.floor((this.n / this.d) / (num.n / num.d)),
       "d": num["d"],
       "s": this["s"]
       });*/ /*
       * New attempt: a1 / b1 = a2 / b2 * q + r
       * => b2 * a1 = a2 * b1 * q + b1 * b2 * r
       * => (b2 * a1 % a2 * b1) / (b1 * b2)
       */ return newFraction(this["s"] * (P["d"] * this["n"]) % (P["n"] * this["d"]), P["d"] * this["d"]);
        },
        /**
     * Calculates the fractional gcd of two rational numbers
     *
     * Ex: new Fraction(5,8).gcd(3,7) => 1/56
     */ "gcd": function(a, b) {
            parse(a, b);
            // gcd(a / b, c / d) = gcd(a, c) / lcm(b, d)
            return newFraction(gcd(P["n"], this["n"]) * gcd(P["d"], this["d"]), P["d"] * this["d"]);
        },
        /**
     * Calculates the fractional lcm of two rational numbers
     *
     * Ex: new Fraction(5,8).lcm(3,7) => 15
     */ "lcm": function(a, b) {
            parse(a, b);
            // lcm(a / b, c / d) = lcm(a, c) / gcd(b, d)
            if (P["n"] === 0 && this["n"] === 0) return newFraction(0, 1);
            return newFraction(P["n"] * this["n"], gcd(P["n"], this["n"]) * gcd(P["d"], this["d"]));
        },
        /**
     * Calculates the ceil of a rational number
     *
     * Ex: new Fraction('4.(3)').ceil() => (5 / 1)
     **/ "ceil": function(places) {
            places = Math.pow(10, places || 0);
            if (isNaN(this["n"]) || isNaN(this["d"])) return new Fraction(NaN);
            return newFraction(Math.ceil(places * this["s"] * this["n"] / this["d"]), places);
        },
        /**
     * Calculates the floor of a rational number
     *
     * Ex: new Fraction('4.(3)').floor() => (4 / 1)
     **/ "floor": function(places) {
            places = Math.pow(10, places || 0);
            if (isNaN(this["n"]) || isNaN(this["d"])) return new Fraction(NaN);
            return newFraction(Math.floor(places * this["s"] * this["n"] / this["d"]), places);
        },
        /**
     * Rounds a rational numbers
     *
     * Ex: new Fraction('4.(3)').round() => (4 / 1)
     **/ "round": function(places) {
            places = Math.pow(10, places || 0);
            if (isNaN(this["n"]) || isNaN(this["d"])) return new Fraction(NaN);
            return newFraction(Math.round(places * this["s"] * this["n"] / this["d"]), places);
        },
        /**
     * Rounds a rational number to a multiple of another rational number
     *
     * Ex: new Fraction('0.9').roundTo("1/8") => 7 / 8
     **/ "roundTo": function(a, b) {
            /*
      k * x/y ≤ a/b < (k+1) * x/y
      ⇔ k ≤ a/b / (x/y) < (k+1)
      ⇔ k = floor(a/b * y/x)
      */ parse(a, b);
            return newFraction(this["s"] * Math.round(this["n"] * P["d"] / (this["d"] * P["n"])) * P["n"], P["d"]);
        },
        /**
     * Gets the inverse of the fraction, means numerator and denominator are exchanged
     *
     * Ex: new Fraction([-3, 4]).inverse() => -4 / 3
     **/ "inverse": function() {
            return newFraction(this["s"] * this["d"], this["n"]);
        },
        /**
     * Calculates the fraction to some rational exponent, if possible
     *
     * Ex: new Fraction(-1,2).pow(-3) => -8
     */ "pow": function(a, b) {
            parse(a, b);
            // Trivial case when exp is an integer
            if (P["d"] === 1) {
                if (P["s"] < 0) return newFraction(Math.pow(this["s"] * this["d"], P["n"]), Math.pow(this["n"], P["n"]));
                else return newFraction(Math.pow(this["s"] * this["n"], P["n"]), Math.pow(this["d"], P["n"]));
            }
            // Negative roots become complex
            //     (-a/b)^(c/d) = x
            // <=> (-1)^(c/d) * (a/b)^(c/d) = x
            // <=> (cos(pi) + i*sin(pi))^(c/d) * (a/b)^(c/d) = x         # rotate 1 by 180°
            // <=> (cos(c*pi/d) + i*sin(c*pi/d)) * (a/b)^(c/d) = x       # DeMoivre's formula in Q ( https://proofwiki.org/wiki/De_Moivre%27s_Formula/Rational_Index )
            // From which follows that only for c=0 the root is non-complex. c/d is a reduced fraction, so that sin(c/dpi)=0 occurs for d=1, which is handled by our trivial case.
            if (this["s"] < 0) return null;
            // Now prime factor n and d
            var N = factorize(this["n"]);
            var D = factorize(this["d"]);
            // Exponentiate and take root for n and d individually
            var n = 1;
            var d = 1;
            for(var k in N){
                if (k === "1") continue;
                if (k === "0") {
                    n = 0;
                    break;
                }
                N[k] *= P["n"];
                if (N[k] % P["d"] === 0) N[k] /= P["d"];
                else return null;
                n *= Math.pow(k, N[k]);
            }
            for(var k in D){
                if (k === "1") continue;
                D[k] *= P["n"];
                if (D[k] % P["d"] === 0) D[k] /= P["d"];
                else return null;
                d *= Math.pow(k, D[k]);
            }
            if (P["s"] < 0) return newFraction(d, n);
            return newFraction(n, d);
        },
        /**
     * Check if two rational numbers are the same
     *
     * Ex: new Fraction(19.6).equals([98, 5]);
     **/ "equals": function(a, b) {
            parse(a, b);
            return this["s"] * this["n"] * P["d"] === P["s"] * P["n"] * this["d"]; // Same as compare() === 0
        },
        /**
     * Check if two rational numbers are the same
     *
     * Ex: new Fraction(19.6).equals([98, 5]);
     **/ "compare": function(a, b) {
            parse(a, b);
            var t = this["s"] * this["n"] * P["d"] - P["s"] * P["n"] * this["d"];
            return (0 < t) - (t < 0);
        },
        "simplify": function(eps) {
            if (isNaN(this["n"]) || isNaN(this["d"])) return this;
            eps = eps || 0.001;
            var thisABS = this["abs"]();
            var cont = thisABS["toContinued"]();
            for(var i = 1; i < cont.length; i++){
                var s = newFraction(cont[i - 1], 1);
                for(var k = i - 2; k >= 0; k--)s = s["inverse"]()["add"](cont[k]);
                if (Math.abs(s["sub"](thisABS).valueOf()) < eps) return s["mul"](this["s"]);
            }
            return this;
        },
        /**
     * Check if two rational numbers are divisible
     *
     * Ex: new Fraction(19.6).divisible(1.5);
     */ "divisible": function(a, b) {
            parse(a, b);
            return !(!(P["n"] * this["d"]) || this["n"] * P["d"] % (P["n"] * this["d"]));
        },
        /**
     * Returns a decimal representation of the fraction
     *
     * Ex: new Fraction("100.'91823'").valueOf() => 100.91823918239183
     **/ "valueOf": function() {
            return this["s"] * this["n"] / this["d"];
        },
        /**
     * Returns a string-fraction representation of a Fraction object
     *
     * Ex: new Fraction("1.'3'").toFraction(true) => "4 1/3"
     **/ "toFraction": function(excludeWhole) {
            var whole, str = "";
            var n = this["n"];
            var d = this["d"];
            if (this["s"] < 0) str += "-";
            if (d === 1) str += n;
            else {
                if (excludeWhole && (whole = Math.floor(n / d)) > 0) {
                    str += whole;
                    str += " ";
                    n %= d;
                }
                str += n;
                str += "/";
                str += d;
            }
            return str;
        },
        /**
     * Returns a latex representation of a Fraction object
     *
     * Ex: new Fraction("1.'3'").toLatex() => "\frac{4}{3}"
     **/ "toLatex": function(excludeWhole) {
            var whole, str = "";
            var n = this["n"];
            var d = this["d"];
            if (this["s"] < 0) str += "-";
            if (d === 1) str += n;
            else {
                if (excludeWhole && (whole = Math.floor(n / d)) > 0) {
                    str += whole;
                    n %= d;
                }
                str += "\\frac{";
                str += n;
                str += "}{";
                str += d;
                str += "}";
            }
            return str;
        },
        /**
     * Returns an array of continued fraction elements
     *
     * Ex: new Fraction("7/8").toContinued() => [0,1,7]
     */ "toContinued": function() {
            var t;
            var a = this["n"];
            var b = this["d"];
            var res = [];
            if (isNaN(a) || isNaN(b)) return res;
            do {
                res.push(Math.floor(a / b));
                t = a % b;
                a = b;
                b = t;
            }while (a !== 1);
            return res;
        },
        /**
     * Creates a string representation of a fraction with all digits
     *
     * Ex: new Fraction("100.'91823'").toString() => "100.(91823)"
     **/ "toString": function(dec) {
            var N = this["n"];
            var D = this["d"];
            if (isNaN(N) || isNaN(D)) return "NaN";
            dec = dec || 15; // 15 = decimal places when no repetation
            var cycLen = cycleLen(N, D); // Cycle length
            var cycOff = cycleStart(N, D, cycLen); // Cycle start
            var str = this["s"] < 0 ? "-" : "";
            str += N / D | 0;
            N %= D;
            N *= 10;
            if (N) str += ".";
            if (cycLen) {
                for(var i = cycOff; i--;){
                    str += N / D | 0;
                    N %= D;
                    N *= 10;
                }
                str += "(";
                for(var i = cycLen; i--;){
                    str += N / D | 0;
                    N %= D;
                    N *= 10;
                }
                str += ")";
            } else for(var i = dec; N && i--;){
                str += N / D | 0;
                N %= D;
                N *= 10;
            }
            return str;
        }
    };
    Object.defineProperty(module.exports, "__esModule", {
        "value": true
    });
    module.exports["default"] = Fraction;
    module.exports = Fraction;
})(module.exports);

});


parcelRegister("cUOM8", function(module, exports) {

$parcel$export(module.exports, "createGamma", function () { return $967219f25bedeb80$export$115da31fc3cf3d15; });

var $e04i1 = parcelRequire("e04i1");

var $2mPYl = parcelRequire("2mPYl");

var $aSl1k = parcelRequire("aSl1k");
var $967219f25bedeb80$var$name = "gamma";
var $967219f25bedeb80$var$dependencies = [
    "typed",
    "config",
    "multiplyScalar",
    "pow",
    "BigNumber",
    "Complex"
];
var $967219f25bedeb80$export$115da31fc3cf3d15 = /* #__PURE__ */ (0, $2mPYl.factory)($967219f25bedeb80$var$name, $967219f25bedeb80$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, multiplyScalar = _ref.multiplyScalar, pow = _ref.pow, _BigNumber = _ref.BigNumber, _Complex = _ref.Complex;
    /**
   * Compute the gamma function of a value using Lanczos approximation for
   * small values, and an extended Stirling approximation for large values.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.gamma(n)
   *
   * Examples:
   *
   *    math.gamma(5)       // returns 24
   *    math.gamma(-0.5)    // returns -3.5449077018110335
   *    math.gamma(math.i)  // returns -0.15494982830180973 - 0.49801566811835596i
   *
   * See also:
   *
   *    combinations, factorial, permutations
   *
   * @param {number | Array | Matrix} n   A real or complex number
   * @return {number | Array | Matrix}    The gamma of `n`
   */ var gamma = typed($967219f25bedeb80$var$name, {
        number: (0, $aSl1k.gammaNumber),
        Complex: function Complex(n) {
            if (n.im === 0) return gamma(n.re);
            n = new _Complex(n.re - 1, n.im);
            var x = new _Complex((0, $aSl1k.gammaP)[0], 0);
            for(var i = 1; i < (0, $aSl1k.gammaP).length; ++i){
                var real = n.re + i; // x += p[i]/(n+i)
                var den = real * real + n.im * n.im;
                if (den !== 0) {
                    x.re += (0, $aSl1k.gammaP)[i] * real / den;
                    x.im += -((0, $aSl1k.gammaP)[i] * n.im) / den;
                } else x.re = (0, $aSl1k.gammaP)[i] < 0 ? -Infinity : Infinity;
            }
            var t = new _Complex(n.re + (0, $aSl1k.gammaG) + 0.5, n.im);
            var twoPiSqrt = Math.sqrt(2 * Math.PI);
            n.re += 0.5;
            var result = pow(t, n);
            if (result.im === 0) // sqrt(2*PI)*result
            result.re *= twoPiSqrt;
            else if (result.re === 0) result.im *= twoPiSqrt;
            else {
                result.re *= twoPiSqrt;
                result.im *= twoPiSqrt;
            }
            var r = Math.exp(-t.re); // exp(-t)
            t.re = r * Math.cos(-t.im);
            t.im = r * Math.sin(-t.im);
            return multiplyScalar(multiplyScalar(result, t), x);
        },
        BigNumber: function BigNumber(n) {
            if (n.isInteger()) return n.isNegative() || n.isZero() ? new _BigNumber(Infinity) : bigFactorial(n.minus(1));
            if (!n.isFinite()) return new _BigNumber(n.isNegative() ? NaN : Infinity);
            throw new Error("Integer BigNumber expected");
        },
        "Array | Matrix": function ArrayMatrix(n) {
            return (0, $e04i1.deepMap)(n, gamma);
        }
    });
    /**
   * Calculate factorial for a BigNumber
   * @param {BigNumber} n
   * @returns {BigNumber} Returns the factorial of n
   */ function bigFactorial(n) {
        if (n < 8) return new _BigNumber([
            1,
            1,
            2,
            6,
            24,
            120,
            720,
            5040
        ][n]);
        var precision = config.precision + (Math.log(n.toNumber()) | 0);
        var Big = _BigNumber.clone({
            precision: precision
        });
        if (n % 2 === 1) return n.times(bigFactorial(new _BigNumber(n - 1)));
        var p = n;
        var prod = new Big(n);
        var sum = n.toNumber();
        while(p > 2){
            p -= 2;
            sum += p;
            prod = prod.times(sum);
        }
        return new _BigNumber(prod.toPrecision(_BigNumber.precision));
    }
    return gamma;
});

});
parcelRegister("aSl1k", function(module, exports) {

$parcel$export(module.exports, "gammaNumber", function () { return $7eaf40baa742fd10$export$da03a9f23c941fae; });
$parcel$export(module.exports, "gammaP", function () { return $7eaf40baa742fd10$export$4ef5d09c80bf8d89; });
$parcel$export(module.exports, "gammaG", function () { return $7eaf40baa742fd10$export$c1392abb9fefd3b6; });

var $kFRKb = parcelRequire("kFRKb");

var $kzt53 = parcelRequire("kzt53");
function $7eaf40baa742fd10$export$da03a9f23c941fae(n) {
    var x;
    if ((0, $kFRKb.isInteger)(n)) {
        if (n <= 0) return isFinite(n) ? Infinity : NaN;
        if (n > 171) return Infinity; // Will overflow
        return (0, $kzt53.product)(1, n - 1);
    }
    if (n < 0.5) return Math.PI / (Math.sin(Math.PI * n) * $7eaf40baa742fd10$export$da03a9f23c941fae(1 - n));
    if (n >= 171.35) return Infinity; // will overflow
    if (n > 85.0) {
        // Extended Stirling Approx
        var twoN = n * n;
        var threeN = twoN * n;
        var fourN = threeN * n;
        var fiveN = fourN * n;
        return Math.sqrt(2 * Math.PI / n) * Math.pow(n / Math.E, n) * (1 + 1 / (12 * n) + 1 / (288 * twoN) - 139 / (51840 * threeN) - 571 / (2488320 * fourN) + 163879 / (209018880 * fiveN) + 5246819 / (75246796800 * fiveN * n));
    }
    --n;
    x = $7eaf40baa742fd10$export$4ef5d09c80bf8d89[0];
    for(var i = 1; i < $7eaf40baa742fd10$export$4ef5d09c80bf8d89.length; ++i)x += $7eaf40baa742fd10$export$4ef5d09c80bf8d89[i] / (n + i);
    var t = n + $7eaf40baa742fd10$export$c1392abb9fefd3b6 + 0.5;
    return Math.sqrt(2 * Math.PI) * Math.pow(t, n + 0.5) * Math.exp(-t) * x;
}
$7eaf40baa742fd10$export$da03a9f23c941fae.signature = "number"; // TODO: comment on the variables g and p
var $7eaf40baa742fd10$export$c1392abb9fefd3b6 = 4.7421875;
var $7eaf40baa742fd10$export$4ef5d09c80bf8d89 = [
    0.99999999999999709182,
    57.156235665862923517,
    -59.59796035547549,
    14.136097974741747174,
    -0.4919138160976202,
    0.33994649984811888699e-4,
    0.46523628927048575665e-4,
    -0.00009837447530487956,
    0.15808870322491248884e-3,
    -0.00021026444172410488,
    0.21743961811521264320e-3,
    -0.0001643181065367639,
    0.84418223983852743293e-4,
    -0.000026190838401581408,
    0.36899182659531622704e-5
];

});


parcelRegister("h0gTZ", function(module, exports) {

$parcel$export(module.exports, "createGcd", function () { return $c60f8c23e8536077$export$2eb8acc96c598512; });

var $2mPYl = parcelRequire("2mPYl");

var $gIOYU = parcelRequire("gIOYU");

var $5mDFR = parcelRequire("5mDFR");

var $1rFP6 = parcelRequire("1rFP6");

var $1bBLS = parcelRequire("1bBLS");

var $iHnaT = parcelRequire("iHnaT");

var $6fCew = parcelRequire("6fCew");
var $c60f8c23e8536077$var$name = "gcd";
var $c60f8c23e8536077$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "BigNumber",
    "DenseMatrix"
];
var $c60f8c23e8536077$export$2eb8acc96c598512 = /* #__PURE__ */ (0, $2mPYl.factory)($c60f8c23e8536077$var$name, $c60f8c23e8536077$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, equalScalar = _ref.equalScalar, BigNumber = _ref.BigNumber, DenseMatrix = _ref.DenseMatrix;
    var algorithm01 = (0, $gIOYU.createAlgorithm01)({
        typed: typed
    });
    var algorithm04 = (0, $5mDFR.createAlgorithm04)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm10 = (0, $1rFP6.createAlgorithm10)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $1bBLS.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $iHnaT.createAlgorithm14)({
        typed: typed
    });
    /**
   * Calculate the greatest common divisor for two or more values or arrays.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.gcd(a, b)
   *    math.gcd(a, b, c, ...)
   *
   * Examples:
   *
   *    math.gcd(8, 12)              // returns 4
   *    math.gcd(-4, 6)              // returns 2
   *    math.gcd(25, 15, -10)        // returns 5
   *
   *    math.gcd([8, -4], [12, 6])   // returns [4, 2]
   *
   * See also:
   *
   *    lcm, xgcd
   *
   * @param {... number | BigNumber | Fraction | Array | Matrix} args  Two or more integer numbers
   * @return {number | BigNumber | Fraction | Array | Matrix}                           The greatest common divisor
   */ var gcd = typed($c60f8c23e8536077$var$name, {
        "number, number": (0, $6fCew.gcdNumber),
        "BigNumber, BigNumber": _gcdBigNumber,
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.gcd(y);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm04(x, y, gcd);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm01(y, x, gcd, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm01(x, y, gcd, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, gcd);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return gcd(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return gcd(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return gcd(x, matrix(y));
        },
        "SparseMatrix, number | BigNumber": function SparseMatrixNumberBigNumber(x, y) {
            return algorithm10(x, y, gcd, false);
        },
        "DenseMatrix, number | BigNumber": function DenseMatrixNumberBigNumber(x, y) {
            return algorithm14(x, y, gcd, false);
        },
        "number | BigNumber, SparseMatrix": function numberBigNumberSparseMatrix(x, y) {
            return algorithm10(y, x, gcd, true);
        },
        "number | BigNumber, DenseMatrix": function numberBigNumberDenseMatrix(x, y) {
            return algorithm14(y, x, gcd, true);
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, gcd, false).valueOf();
        },
        "number | BigNumber, Array": function numberBigNumberArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, gcd, true).valueOf();
        },
        // TODO: need a smarter notation here
        "Array | Matrix | number | BigNumber, Array | Matrix | number | BigNumber, ...Array | Matrix | number | BigNumber": function ArrayMatrixNumberBigNumberArrayMatrixNumberBigNumberArrayMatrixNumberBigNumber(a, b, args) {
            var res = gcd(a, b);
            for(var i = 0; i < args.length; i++)res = gcd(res, args[i]);
            return res;
        }
    });
    return gcd;
    /**
   * Calculate gcd for BigNumbers
   * @param {BigNumber} a
   * @param {BigNumber} b
   * @returns {BigNumber} Returns greatest common denominator of a and b
   * @private
   */ function _gcdBigNumber(a, b) {
        if (!a.isInt() || !b.isInt()) throw new Error("Parameters in function gcd must be integer numbers");
         // https://en.wikipedia.org/wiki/Euclidean_algorithm
        var zero = new BigNumber(0);
        while(!b.isZero()){
            var r = a.mod(b);
            a = b;
            b = r;
        }
        return a.lt(zero) ? a.neg() : a;
    }
});

});

parcelRegister("4TwHx", function(module, exports) {

$parcel$export(module.exports, "createGetMatrixDataType", function () { return $3905aa42b477b0b5$export$b83055c9a38abe3c; });

var $2mPYl = parcelRequire("2mPYl");

var $5WdrK = parcelRequire("5WdrK");

var $1amHZ = parcelRequire("1amHZ");
var $3905aa42b477b0b5$var$name = "getMatrixDataType";
var $3905aa42b477b0b5$var$dependencies = [
    "typed"
];
var $3905aa42b477b0b5$export$b83055c9a38abe3c = /* #__PURE__ */ (0, $2mPYl.factory)($3905aa42b477b0b5$var$name, $3905aa42b477b0b5$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Find the data type of all elements in a matrix or array,
   * for example 'number' if all items are a number and 'Complex' if all values
   * are complex numbers.
   * If a matrix contains more than one data type, it will return 'mixed'.
   *
   * Syntax:
   *
   *    math.getMatrixDataType(x)
   *
   * Examples:
   *
   *    const x = [ [1, 2, 3], [4, 5, 6] ]
   *    const mixedX = [ [1, true], [2, 3] ]
   *    const fractionX = [ [math.fraction(1, 3)], [math.fraction(1, 3] ]
   *    const unitX = [ [math.unit('5cm')], [math.unit('5cm')] ]
   *    const bigNumberX = [ [math.bignumber(1)], [math.bignumber(0)] ]
   *    const sparse = math.sparse(x)
   *    const dense = math.matrix(x)
   *    math.getMatrixDataType(x)   // returns 'number'
   *    math.getMatrixDataType(sparse)   // returns 'number'
   *    math.getMatrixDataType(dense)   // returns 'number'
   *    math.getMatrixDataType(mixedX) // returns 'mixed'
   *    math.getMatrixDataType(fractionX) // returns 'Fraction'
   *    math.getMatrixDataType(unitX) // returns 'Unit'
   *    math.getMatrixDataType(bigNumberX) // return 'BigNumber'
   *
   * See also:
   *  SparseMatrix, DenseMatrix
   *
   * @param {...Matrix | Array} x   The Matrix with values.
   *
   * @return {string} A string representation of the matrix type
   */ return typed($3905aa42b477b0b5$var$name, {
        Array: function Array(x) {
            return (0, $5WdrK.getArrayDataType)(x, (0, $1amHZ.typeOf));
        },
        Matrix: function Matrix(x) {
            return x.getDataType();
        }
    });
});

});

parcelRegister("lKbtb", function(module, exports) {

$parcel$export(module.exports, "createHasNumericValue", function () { return $fd46ca7f45189625$export$acff9f91b891ace6; });

var $2mPYl = parcelRequire("2mPYl");
var $fd46ca7f45189625$var$name = "hasNumericValue";
var $fd46ca7f45189625$var$dependencies = [
    "typed",
    "isNumeric"
];
var $fd46ca7f45189625$export$acff9f91b891ace6 = /* #__PURE__ */ (0, $2mPYl.factory)($fd46ca7f45189625$var$name, $fd46ca7f45189625$var$dependencies, function(_ref) {
    var typed = _ref.typed, isNumeric = _ref.isNumeric;
    /**
   * Test whether a value is an numeric value.
   *
   * In case of a string, true is returned if the string contains a numeric value.
   *
   * Syntax:
   *
   *     math.hasNumericValue(x)
   *
   * Examples:
   *
   *    math.hasNumericValue(2)                     // returns true
   *    math.hasNumericValue('2')                   // returns true
   *    math.isNumeric('2')                         // returns false
   *    math.hasNumericValue(0)                     // returns true
   *    math.hasNumericValue(math.bignumber(500))   // returns true
   *    math.hasNumericValue(math.fraction(4))      // returns true
   *    math.hasNumericValue(math.complex('2-4i')   // returns false
   *    math.hasNumericValue([2.3, 'foo', false])   // returns [true, false, true]
   *
   * See also:
   *
   *    isZero, isPositive, isNegative, isInteger, isNumeric
   *
   * @param {*} x       Value to be tested
   * @return {boolean}  Returns true when `x` is a `number`, `BigNumber`,
   *                    `Fraction`, `Boolean`, or a `String` containing number. Returns false for other types.
   *                    Throws an error in case of unknown types.
   */ return typed($fd46ca7f45189625$var$name, {
        string: function string(x) {
            return x.trim().length > 0 && !isNaN(Number(x));
        },
        any: function any(x) {
            return isNumeric(x);
        }
    });
});

});

parcelRegister("3L0Dr", function(module, exports) {

$parcel$export(module.exports, "createHypot", function () { return $2bc64100940496dd$export$87e3687740a09cb; });

var $2mPYl = parcelRequire("2mPYl");

var $5WdrK = parcelRequire("5WdrK");
var $2bc64100940496dd$var$name = "hypot";
var $2bc64100940496dd$var$dependencies = [
    "typed",
    "abs",
    "addScalar",
    "divideScalar",
    "multiplyScalar",
    "sqrt",
    "smaller",
    "isPositive"
];
var $2bc64100940496dd$export$87e3687740a09cb = /* #__PURE__ */ (0, $2mPYl.factory)($2bc64100940496dd$var$name, $2bc64100940496dd$var$dependencies, function(_ref) {
    var typed = _ref.typed, abs = _ref.abs, addScalar = _ref.addScalar, divideScalar = _ref.divideScalar, multiplyScalar = _ref.multiplyScalar, sqrt = _ref.sqrt, smaller = _ref.smaller, isPositive = _ref.isPositive;
    /**
   * Calculate the hypotenusa of a list with values. The hypotenusa is defined as:
   *
   *     hypot(a, b, c, ...) = sqrt(a^2 + b^2 + c^2 + ...)
   *
   * For matrix input, the hypotenusa is calculated for all values in the matrix.
   *
   * Syntax:
   *
   *     math.hypot(a, b, ...)
   *     math.hypot([a, b, c, ...])
   *
   * Examples:
   *
   *     math.hypot(3, 4)      // 5
   *     math.hypot(3, 4, 5)   // 7.0710678118654755
   *     math.hypot([3, 4, 5]) // 7.0710678118654755
   *     math.hypot(-2)        // 2
   *
   * See also:
   *
   *     abs, norm
   *
   * @param {... number | BigNumber | Array | Matrix} args    A list with numeric values or an Array or Matrix.
   *                                                          Matrix and Array input is flattened and returns a
   *                                                          single number for the whole matrix.
   * @return {number | BigNumber} Returns the hypothenusa of the input values.
   */ var hypot = typed($2bc64100940496dd$var$name, {
        "... number | BigNumber": _hypot,
        Array: function Array(x) {
            return hypot.apply(hypot, (0, $5WdrK.flatten)(x));
        },
        Matrix: function Matrix(x) {
            return hypot.apply(hypot, (0, $5WdrK.flatten)(x.toArray()));
        }
    });
    /**
   * Calculate the hypotenusa for an Array with values
   * @param {Array.<number | BigNumber>} args
   * @return {number | BigNumber} Returns the result
   * @private
   */ function _hypot(args) {
        // code based on `hypot` from es6-shim:
        // https://github.com/paulmillr/es6-shim/blob/master/es6-shim.js#L1619-L1633
        var result = 0;
        var largest = 0;
        for(var i = 0; i < args.length; i++){
            var value = abs(args[i]);
            if (smaller(largest, value)) {
                result = multiplyScalar(result, multiplyScalar(divideScalar(largest, value), divideScalar(largest, value)));
                result = addScalar(result, 1);
                largest = value;
            } else result = addScalar(result, isPositive(value) ? multiplyScalar(divideScalar(value, largest), divideScalar(value, largest)) : value);
        }
        return multiplyScalar(largest, sqrt(result));
    }
    return hypot;
});

});

parcelRegister("3tz7Y", function(module, exports) {

$parcel$export(module.exports, "createIdentity", function () { return $287f542a4207ec47$export$2eca89e9ac669625; });

var $1amHZ = parcelRequire("1amHZ");

var $5WdrK = parcelRequire("5WdrK");

var $kFRKb = parcelRequire("kFRKb");

var $2mPYl = parcelRequire("2mPYl");
var $287f542a4207ec47$var$name = "identity";
var $287f542a4207ec47$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "BigNumber",
    "DenseMatrix",
    "SparseMatrix"
];
var $287f542a4207ec47$export$2eca89e9ac669625 = /* #__PURE__ */ (0, $2mPYl.factory)($287f542a4207ec47$var$name, $287f542a4207ec47$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, matrix = _ref.matrix, BigNumber = _ref.BigNumber, DenseMatrix = _ref.DenseMatrix, SparseMatrix = _ref.SparseMatrix;
    /**
   * Create a 2-dimensional identity matrix with size m x n or n x n.
   * The matrix has ones on the diagonal and zeros elsewhere.
   *
   * Syntax:
   *
   *    math.identity(n)
   *    math.identity(n, format)
   *    math.identity(m, n)
   *    math.identity(m, n, format)
   *    math.identity([m, n])
   *    math.identity([m, n], format)
   *
   * Examples:
   *
   *    math.identity(3)                    // returns [[1, 0, 0], [0, 1, 0], [0, 0, 1]]
   *    math.identity(3, 2)                 // returns [[1, 0], [0, 1], [0, 0]]
   *
   *    const A = [[1, 2, 3], [4, 5, 6]]
   *    math.identity(math.size(A))         // returns [[1, 0, 0], [0, 1, 0]]
   *
   * See also:
   *
   *    diag, ones, zeros, size, range
   *
   * @param {...number | Matrix | Array} size   The size for the matrix
   * @param {string} [format]                   The Matrix storage format
   *
   * @return {Matrix | Array | number} A matrix with ones on the diagonal.
   */ return typed($287f542a4207ec47$var$name, {
        "": function _() {
            return config.matrix === "Matrix" ? matrix([]) : [];
        },
        string: function string(format) {
            return matrix(format);
        },
        "number | BigNumber": function numberBigNumber(rows) {
            return _identity(rows, rows, config.matrix === "Matrix" ? "dense" : undefined);
        },
        "number | BigNumber, string": function numberBigNumberString(rows, format) {
            return _identity(rows, rows, format);
        },
        "number | BigNumber, number | BigNumber": function numberBigNumberNumberBigNumber(rows, cols) {
            return _identity(rows, cols, config.matrix === "Matrix" ? "dense" : undefined);
        },
        "number | BigNumber, number | BigNumber, string": function numberBigNumberNumberBigNumberString(rows, cols, format) {
            return _identity(rows, cols, format);
        },
        Array: function Array(size) {
            return _identityVector(size);
        },
        "Array, string": function ArrayString(size, format) {
            return _identityVector(size, format);
        },
        Matrix: function Matrix(size) {
            return _identityVector(size.valueOf(), size.storage());
        },
        "Matrix, string": function MatrixString(size, format) {
            return _identityVector(size.valueOf(), format);
        }
    });
    function _identityVector(size, format) {
        switch(size.length){
            case 0:
                return format ? matrix(format) : [];
            case 1:
                return _identity(size[0], size[0], format);
            case 2:
                return _identity(size[0], size[1], format);
            default:
                throw new Error("Vector containing two values expected");
        }
    }
    /**
   * Create an identity matrix
   * @param {number | BigNumber} rows
   * @param {number | BigNumber} cols
   * @param {string} [format]
   * @returns {Matrix}
   * @private
   */ function _identity(rows, cols, format) {
        // BigNumber constructor with the right precision
        var Big = (0, $1amHZ.isBigNumber)(rows) || (0, $1amHZ.isBigNumber)(cols) ? BigNumber : null;
        if ((0, $1amHZ.isBigNumber)(rows)) rows = rows.toNumber();
        if ((0, $1amHZ.isBigNumber)(cols)) cols = cols.toNumber();
        if (!(0, $kFRKb.isInteger)(rows) || rows < 1) throw new Error("Parameters in function identity must be positive integers");
        if (!(0, $kFRKb.isInteger)(cols) || cols < 1) throw new Error("Parameters in function identity must be positive integers");
        var one = Big ? new BigNumber(1) : 1;
        var defaultValue = Big ? new Big(0) : 0;
        var size = [
            rows,
            cols
        ]; // check we need to return a matrix
        if (format) {
            // create diagonal matrix (use optimized implementation for storage format)
            if (format === "sparse") return SparseMatrix.diagonal(size, one, 0, defaultValue);
            if (format === "dense") return DenseMatrix.diagonal(size, one, 0, defaultValue);
            throw new TypeError('Unknown matrix type "'.concat(format, '"'));
        } // create and resize array
        var res = (0, $5WdrK.resize)([], size, defaultValue); // fill in ones on the diagonal
        var minimum = rows < cols ? rows : cols; // fill diagonal
        for(var d = 0; d < minimum; d++)res[d][d] = one;
        return res;
    }
});

});

parcelRegister("91rws", function(module, exports) {

$parcel$export(module.exports, "createIm", function () { return $69198e77c7839c2e$export$47dfdf308b91581; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");
var $69198e77c7839c2e$var$name = "im";
var $69198e77c7839c2e$var$dependencies = [
    "typed"
];
var $69198e77c7839c2e$export$47dfdf308b91581 = /* #__PURE__ */ (0, $2mPYl.factory)($69198e77c7839c2e$var$name, $69198e77c7839c2e$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Get the imaginary part of a complex number.
   * For a complex number `a + bi`, the function returns `b`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.im(x)
   *
   * Examples:
   *
   *    const a = math.complex(2, 3)
   *    math.re(a)                     // returns number 2
   *    math.im(a)                     // returns number 3
   *
   *    math.re(math.complex('-5.2i')) // returns number -5.2
   *    math.re(math.complex(2.4))     // returns number 0
   *
   * See also:
   *
   *    re, conj, abs, arg
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            A complex number or array with complex numbers
   * @return {number | BigNumber | Array | Matrix} The imaginary part of x
   */ var im = typed($69198e77c7839c2e$var$name, {
        number: function number(x) {
            return 0;
        },
        BigNumber: function BigNumber(x) {
            return x.mul(0);
        },
        Complex: function Complex(x) {
            return x.im;
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, im);
        }
    });
    return im;
});

});

parcelRegister("53Sj1", function(module, exports) {

$parcel$export(module.exports, "createImmutableDenseMatrixClass", function () { return $3af75b8cca13bfce$export$49a565643b9ab608; });

var $1amHZ = parcelRequire("1amHZ");

var $7ITGG = parcelRequire("7ITGG");

var $2mPYl = parcelRequire("2mPYl");
var $3af75b8cca13bfce$var$name = "ImmutableDenseMatrix";
var $3af75b8cca13bfce$var$dependencies = [
    "smaller",
    "DenseMatrix"
];
var $3af75b8cca13bfce$export$49a565643b9ab608 = /* #__PURE__ */ (0, $2mPYl.factory)($3af75b8cca13bfce$var$name, $3af75b8cca13bfce$var$dependencies, function(_ref) {
    var smaller = _ref.smaller, DenseMatrix = _ref.DenseMatrix;
    function ImmutableDenseMatrix(data, datatype) {
        if (!(this instanceof ImmutableDenseMatrix)) throw new SyntaxError("Constructor must be called with the new operator");
        if (datatype && !(0, $1amHZ.isString)(datatype)) throw new Error("Invalid datatype: " + datatype);
        if ((0, $1amHZ.isMatrix)(data) || (0, $1amHZ.isArray)(data)) {
            // use DenseMatrix implementation
            var matrix = new DenseMatrix(data, datatype); // internal structures
            this._data = matrix._data;
            this._size = matrix._size;
            this._datatype = matrix._datatype;
            this._min = null;
            this._max = null;
        } else if (data && (0, $1amHZ.isArray)(data.data) && (0, $1amHZ.isArray)(data.size)) {
            // initialize fields from JSON representation
            this._data = data.data;
            this._size = data.size;
            this._datatype = data.datatype;
            this._min = typeof data.min !== "undefined" ? data.min : null;
            this._max = typeof data.max !== "undefined" ? data.max : null;
        } else if (data) // unsupported type
        throw new TypeError("Unsupported type of data (" + (0, $1amHZ.typeOf)(data) + ")");
        else {
            // nothing provided
            this._data = [];
            this._size = [
                0
            ];
            this._datatype = datatype;
            this._min = null;
            this._max = null;
        }
    }
    ImmutableDenseMatrix.prototype = new DenseMatrix();
    /**
   * Attach type information
   */ ImmutableDenseMatrix.prototype.type = "ImmutableDenseMatrix";
    ImmutableDenseMatrix.prototype.isImmutableDenseMatrix = true;
    /**
   * Get a subset of the matrix, or replace a subset of the matrix.
   *
   * Usage:
   *     const subset = matrix.subset(index)               // retrieve subset
   *     const value = matrix.subset(index, replacement)   // replace subset
   *
   * @param {Index} index
   * @param {Array | ImmutableDenseMatrix | *} [replacement]
   * @param {*} [defaultValue=0]      Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be filled with zeros.
   */ ImmutableDenseMatrix.prototype.subset = function(index) {
        switch(arguments.length){
            case 1:
                // use base implementation
                var m = DenseMatrix.prototype.subset.call(this, index); // check result is a matrix
                if ((0, $1amHZ.isMatrix)(m)) // return immutable matrix
                return new ImmutableDenseMatrix({
                    data: m._data,
                    size: m._size,
                    datatype: m._datatype
                });
                return m;
            // intentional fall through
            case 2:
            case 3:
                throw new Error("Cannot invoke set subset on an Immutable Matrix instance");
            default:
                throw new SyntaxError("Wrong number of arguments");
        }
    };
    /**
   * Replace a single element in the matrix.
   * @param {Number[]} index   Zero-based index
   * @param {*} value
   * @param {*} [defaultValue]        Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be left undefined.
   * @return {ImmutableDenseMatrix} self
   */ ImmutableDenseMatrix.prototype.set = function() {
        throw new Error("Cannot invoke set on an Immutable Matrix instance");
    };
    /**
   * Resize the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (resize in place).
   *
   * @param {Number[]} size           The new size the matrix should have.
   * @param {*} [defaultValue=0]      Default value, filled in on new entries.
   *                                  If not provided, the matrix elements will
   *                                  be filled with zeros.
   * @param {boolean} [copy]          Return a resized copy of the matrix
   *
   * @return {Matrix}                 The resized matrix
   */ ImmutableDenseMatrix.prototype.resize = function() {
        throw new Error("Cannot invoke resize on an Immutable Matrix instance");
    };
    /**
   * Disallows reshaping in favor of immutability.
   *
   * @throws {Error} Operation not allowed
   */ ImmutableDenseMatrix.prototype.reshape = function() {
        throw new Error("Cannot invoke reshape on an Immutable Matrix instance");
    };
    /**
   * Create a clone of the matrix
   * @return {ImmutableDenseMatrix} clone
   */ ImmutableDenseMatrix.prototype.clone = function() {
        return new ImmutableDenseMatrix({
            data: (0, $7ITGG.clone)(this._data),
            size: (0, $7ITGG.clone)(this._size),
            datatype: this._datatype
        });
    };
    /**
   * Get a JSON representation of the matrix
   * @returns {Object}
   */ ImmutableDenseMatrix.prototype.toJSON = function() {
        return {
            mathjs: "ImmutableDenseMatrix",
            data: this._data,
            size: this._size,
            datatype: this._datatype
        };
    };
    /**
   * Generate a matrix from a JSON object
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "ImmutableDenseMatrix", data: [], size: []}`,
   *                       where mathjs is optional
   * @returns {ImmutableDenseMatrix}
   */ ImmutableDenseMatrix.fromJSON = function(json) {
        return new ImmutableDenseMatrix(json);
    };
    /**
   * Swap rows i and j in Matrix.
   *
   * @param {Number} i       Matrix row index 1
   * @param {Number} j       Matrix row index 2
   *
   * @return {Matrix}        The matrix reference
   */ ImmutableDenseMatrix.prototype.swapRows = function() {
        throw new Error("Cannot invoke swapRows on an Immutable Matrix instance");
    };
    /**
   * Calculate the minimum value in the set
   * @return {Number | undefined} min
   */ ImmutableDenseMatrix.prototype.min = function() {
        // check min has been calculated before
        if (this._min === null) {
            // minimum
            var m = null; // compute min
            this.forEach(function(v) {
                if (m === null || smaller(v, m)) m = v;
            });
            this._min = m !== null ? m : undefined;
        }
        return this._min;
    };
    /**
   * Calculate the maximum value in the set
   * @return {Number | undefined} max
   */ ImmutableDenseMatrix.prototype.max = function() {
        // check max has been calculated before
        if (this._max === null) {
            // maximum
            var m = null; // compute max
            this.forEach(function(v) {
                if (m === null || smaller(m, v)) m = v;
            });
            this._max = m !== null ? m : undefined;
        }
        return this._max;
    };
    return ImmutableDenseMatrix;
}, {
    isClass: true
});

});

parcelRegister("7SBld", function(module, exports) {

$parcel$export(module.exports, "createIndex", function () { return $5bca8abdb5d820ff$export$c6d108d7c8095f19; });

var $2mPYl = parcelRequire("2mPYl");

var $1amHZ = parcelRequire("1amHZ");
var $5bca8abdb5d820ff$var$name = "index";
var $5bca8abdb5d820ff$var$dependencies = [
    "typed",
    "Index"
];
var $5bca8abdb5d820ff$export$c6d108d7c8095f19 = /* #__PURE__ */ (0, $2mPYl.factory)($5bca8abdb5d820ff$var$name, $5bca8abdb5d820ff$var$dependencies, function(_ref) {
    var typed = _ref.typed, Index = _ref.Index;
    /**
   * Create an index. An Index can store ranges having start, step, and end
   * for multiple dimensions.
   * Matrix.get, Matrix.set, and math.subset accept an Index as input.
   *
   * Syntax:
   *
   *     math.index(range1, range2, ...)
   *
   * Where each range can be any of:
   *
   * - A number
   * - A string for getting/setting an object property
   * - An instance of `Range`
   * - A one-dimensional Array or a Matrix with numbers
   *
   * Indexes must be zero-based, integer numbers.
   *
   * Examples:
   *
   *    const b = [1, 2, 3, 4, 5]
   *    math.subset(b, math.index([1, 2, 3]))     // returns [2, 3, 4]
   *
   *    const a = math.matrix([[1, 2], [3, 4]])
   *    a.subset(math.index(0, 1))             // returns 2
   *
   * See also:
   *
   *    bignumber, boolean, complex, matrix, number, string, unit
   *
   * @param {...*} ranges   Zero or more ranges or numbers.
   * @return {Index}        Returns the created index
   */ return typed($5bca8abdb5d820ff$var$name, {
        "...number | string | BigNumber | Range | Array | Matrix": function numberStringBigNumberRangeArrayMatrix(args) {
            var ranges = args.map(function(arg) {
                if ((0, $1amHZ.isBigNumber)(arg)) return arg.toNumber(); // convert BigNumber to Number
                else if (Array.isArray(arg) || (0, $1amHZ.isMatrix)(arg)) return arg.map(function(elem) {
                    // convert BigNumber to Number
                    return (0, $1amHZ.isBigNumber)(elem) ? elem.toNumber() : elem;
                });
                else return arg;
            });
            var res = new Index();
            Index.apply(res, ranges);
            return res;
        }
    });
});

});

parcelRegister("9MONg", function(module, exports) {

$parcel$export(module.exports, "createIndexClass", function () { return $71ffff5028327813$export$300720b4fe34e62e; });

var $1amHZ = parcelRequire("1amHZ");

var $7ITGG = parcelRequire("7ITGG");

var $kFRKb = parcelRequire("kFRKb");

var $2mPYl = parcelRequire("2mPYl");
var $71ffff5028327813$var$name = "Index";
var $71ffff5028327813$var$dependencies = [
    "ImmutableDenseMatrix"
];
var $71ffff5028327813$export$300720b4fe34e62e = /* #__PURE__ */ (0, $2mPYl.factory)($71ffff5028327813$var$name, $71ffff5028327813$var$dependencies, function(_ref) {
    var ImmutableDenseMatrix = _ref.ImmutableDenseMatrix;
    /**
   * Create an index. An Index can store ranges and sets for multiple dimensions.
   * Matrix.get, Matrix.set, and math.subset accept an Index as input.
   *
   * Usage:
   *     const index = new Index(range1, range2, matrix1, array1, ...)
   *
   * Where each parameter can be any of:
   *     A number
   *     A string (containing a name of an object property)
   *     An instance of Range
   *     An Array with the Set values
   *     A Matrix with the Set values
   *
   * The parameters start, end, and step must be integer numbers.
   *
   * @class Index
   * @Constructor Index
   * @param {...*} ranges
   */ function Index(ranges) {
        if (!(this instanceof Index)) throw new SyntaxError("Constructor must be called with the new operator");
        this._dimensions = [];
        this._isScalar = true;
        for(var i = 0, ii = arguments.length; i < ii; i++){
            var arg = arguments[i];
            if ((0, $1amHZ.isRange)(arg)) {
                this._dimensions.push(arg);
                this._isScalar = false;
            } else if (Array.isArray(arg) || (0, $1amHZ.isMatrix)(arg)) {
                // create matrix
                var m = _createImmutableMatrix(arg.valueOf());
                this._dimensions.push(m); // size
                var size = m.size(); // scalar
                if (size.length !== 1 || size[0] !== 1) this._isScalar = false;
            } else if (typeof arg === "number") this._dimensions.push(_createImmutableMatrix([
                arg
            ]));
            else if (typeof arg === "string") // object property (arguments.count should be 1)
            this._dimensions.push(arg);
            else throw new TypeError("Dimension must be an Array, Matrix, number, string, or Range");
             // TODO: implement support for wildcard '*'
        }
    }
    /**
   * Attach type information
   */ Index.prototype.type = "Index";
    Index.prototype.isIndex = true;
    function _createImmutableMatrix(arg) {
        // loop array elements
        for(var i = 0, l = arg.length; i < l; i++){
            if (typeof arg[i] !== "number" || !(0, $kFRKb.isInteger)(arg[i])) throw new TypeError("Index parameters must be positive integer numbers");
        } // create matrix
        return new ImmutableDenseMatrix(arg);
    }
    /**
   * Create a clone of the index
   * @memberof Index
   * @return {Index} clone
   */ Index.prototype.clone = function() {
        var index = new Index();
        index._dimensions = (0, $7ITGG.clone)(this._dimensions);
        index._isScalar = this._isScalar;
        return index;
    };
    /**
   * Create an index from an array with ranges/numbers
   * @memberof Index
   * @param {Array.<Array | number>} ranges
   * @return {Index} index
   * @private
   */ Index.create = function(ranges) {
        var index = new Index();
        Index.apply(index, ranges);
        return index;
    };
    /**
   * Retrieve the size of the index, the number of elements for each dimension.
   * @memberof Index
   * @returns {number[]} size
   */ Index.prototype.size = function() {
        var size = [];
        for(var i = 0, ii = this._dimensions.length; i < ii; i++){
            var d = this._dimensions[i];
            size[i] = typeof d === "string" ? 1 : d.size()[0];
        }
        return size;
    };
    /**
   * Get the maximum value for each of the indexes ranges.
   * @memberof Index
   * @returns {number[]} max
   */ Index.prototype.max = function() {
        var values = [];
        for(var i = 0, ii = this._dimensions.length; i < ii; i++){
            var range = this._dimensions[i];
            values[i] = typeof range === "string" ? range : range.max();
        }
        return values;
    };
    /**
   * Get the minimum value for each of the indexes ranges.
   * @memberof Index
   * @returns {number[]} min
   */ Index.prototype.min = function() {
        var values = [];
        for(var i = 0, ii = this._dimensions.length; i < ii; i++){
            var range = this._dimensions[i];
            values[i] = typeof range === "string" ? range : range.min();
        }
        return values;
    };
    /**
   * Loop over each of the ranges of the index
   * @memberof Index
   * @param {Function} callback   Called for each range with a Range as first
   *                              argument, the dimension as second, and the
   *                              index object as third.
   */ Index.prototype.forEach = function(callback) {
        for(var i = 0, ii = this._dimensions.length; i < ii; i++)callback(this._dimensions[i], i, this);
    };
    /**
   * Retrieve the dimension for the given index
   * @memberof Index
   * @param {Number} dim                  Number of the dimension
   * @returns {Range | null} range
   */ Index.prototype.dimension = function(dim) {
        return this._dimensions[dim] || null;
    };
    /**
   * Test whether this index contains an object property
   * @returns {boolean} Returns true if the index is an object property
   */ Index.prototype.isObjectProperty = function() {
        return this._dimensions.length === 1 && typeof this._dimensions[0] === "string";
    };
    /**
   * Returns the object property name when the Index holds a single object property,
   * else returns null
   * @returns {string | null}
   */ Index.prototype.getObjectProperty = function() {
        return this.isObjectProperty() ? this._dimensions[0] : null;
    };
    /**
   * Test whether this index contains only a single value.
   *
   * This is the case when the index is created with only scalar values as ranges,
   * not for ranges resolving into a single value.
   * @memberof Index
   * @return {boolean} isScalar
   */ Index.prototype.isScalar = function() {
        return this._isScalar;
    };
    /**
   * Expand the Index into an array.
   * For example new Index([0,3], [2,7]) returns [[0,1,2], [2,3,4,5,6]]
   * @memberof Index
   * @returns {Array} array
   */ Index.prototype.toArray = function() {
        var array = [];
        for(var i = 0, ii = this._dimensions.length; i < ii; i++){
            var dimension = this._dimensions[i];
            array.push(typeof dimension === "string" ? dimension : dimension.toArray());
        }
        return array;
    };
    /**
   * Get the primitive value of the Index, a two dimensional array.
   * Equivalent to Index.toArray().
   * @memberof Index
   * @returns {Array} array
   */ Index.prototype.valueOf = Index.prototype.toArray;
    /**
   * Get the string representation of the index, for example '[2:6]' or '[0:2:10, 4:7, [1,2,3]]'
   * @memberof Index
   * @returns {String} str
   */ Index.prototype.toString = function() {
        var strings = [];
        for(var i = 0, ii = this._dimensions.length; i < ii; i++){
            var dimension = this._dimensions[i];
            if (typeof dimension === "string") strings.push(JSON.stringify(dimension));
            else strings.push(dimension.toString());
        }
        return "[" + strings.join(", ") + "]";
    };
    /**
   * Get a JSON representation of the Index
   * @memberof Index
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "Index", "ranges": [{"mathjs": "Range", start: 0, end: 10, step:1}, ...]}`
   */ Index.prototype.toJSON = function() {
        return {
            mathjs: "Index",
            dimensions: this._dimensions
        };
    };
    /**
   * Instantiate an Index from a JSON object
   * @memberof Index
   * @param {Object} json A JSON object structured as:
   *                     `{"mathjs": "Index", "dimensions": [{"mathjs": "Range", start: 0, end: 10, step:1}, ...]}`
   * @return {Index}
   */ Index.fromJSON = function(json) {
        return Index.create(json.dimensions);
    };
    return Index;
}, {
    isClass: true
});

});

parcelRegister("k40sh", function(module, exports) {

$parcel$export(module.exports, "createIntersect", function () { return $e9b488bfdec086df$export$e2d92d8f89fdd92d; });

var $1amHZ = parcelRequire("1amHZ");

var $2mPYl = parcelRequire("2mPYl");
var $e9b488bfdec086df$var$name = "intersect";
var $e9b488bfdec086df$var$dependencies = [
    "typed",
    "config",
    "abs",
    "add",
    "addScalar",
    "matrix",
    "multiply",
    "multiplyScalar",
    "divideScalar",
    "subtract",
    "smaller",
    "equalScalar"
];
var $e9b488bfdec086df$export$e2d92d8f89fdd92d = /* #__PURE__ */ (0, $2mPYl.factory)($e9b488bfdec086df$var$name, $e9b488bfdec086df$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, abs = _ref.abs, add = _ref.add, addScalar = _ref.addScalar, matrix = _ref.matrix, multiply = _ref.multiply, multiplyScalar = _ref.multiplyScalar, divideScalar = _ref.divideScalar, subtract = _ref.subtract, smaller = _ref.smaller, equalScalar = _ref.equalScalar;
    /**
   * Calculates the point of intersection of two lines in two or three dimensions
   * and of a line and a plane in three dimensions. The inputs are in the form of
   * arrays or 1 dimensional matrices. The line intersection functions return null
   * if the lines do not meet.
   *
   * Note: Fill the plane coefficients as `x + y + z = c` and not as `x + y + z + c = 0`.
   *
   * Syntax:
   *
   *    math.intersect(endPoint1Line1, endPoint2Line1, endPoint1Line2, endPoint2Line2)
   *    math.intersect(endPoint1, endPoint2, planeCoefficients)
   *
   * Examples:
   *
   *    math.intersect([0, 0], [10, 10], [10, 0], [0, 10])              // Returns [5, 5]
   *    math.intersect([0, 0, 0], [10, 10, 0], [10, 0, 0], [0, 10, 0])  // Returns [5, 5, 0]
   *    math.intersect([1, 0, 1],  [4, -2, 2], [1, 1, 1, 6])            // Returns [7, -4, 3]
   *
   * @param  {Array | Matrix} w   Co-ordinates of first end-point of first line
   * @param  {Array | Matrix} x   Co-ordinates of second end-point of first line
   * @param  {Array | Matrix} y   Co-ordinates of first end-point of second line
   *                              OR Co-efficients of the plane's equation
   * @param  {Array | Matrix} z   Co-ordinates of second end-point of second line
   *                              OR null if the calculation is for line and plane
   * @return {Array}              Returns the point of intersection of lines/lines-planes
   */ var intersect = typed("intersect", {
        "Array, Array, Array": function ArrayArrayArray(x, y, plane) {
            if (!_3d(x)) throw new TypeError("Array with 3 numbers or BigNumbers expected for first argument");
            if (!_3d(y)) throw new TypeError("Array with 3 numbers or BigNumbers expected for second argument");
            if (!_4d(plane)) throw new TypeError("Array with 4 numbers expected as third argument");
            return _intersectLinePlane(x[0], x[1], x[2], y[0], y[1], y[2], plane[0], plane[1], plane[2], plane[3]);
        },
        "Array, Array, Array, Array": function ArrayArrayArrayArray(w, x, y, z) {
            if (w.length === 2) {
                if (!_2d(w)) throw new TypeError("Array with 2 numbers or BigNumbers expected for first argument");
                if (!_2d(x)) throw new TypeError("Array with 2 numbers or BigNumbers expected for second argument");
                if (!_2d(y)) throw new TypeError("Array with 2 numbers or BigNumbers expected for third argument");
                if (!_2d(z)) throw new TypeError("Array with 2 numbers or BigNumbers expected for fourth argument");
                return _intersect2d(w, x, y, z);
            } else if (w.length === 3) {
                if (!_3d(w)) throw new TypeError("Array with 3 numbers or BigNumbers expected for first argument");
                if (!_3d(x)) throw new TypeError("Array with 3 numbers or BigNumbers expected for second argument");
                if (!_3d(y)) throw new TypeError("Array with 3 numbers or BigNumbers expected for third argument");
                if (!_3d(z)) throw new TypeError("Array with 3 numbers or BigNumbers expected for fourth argument");
                return _intersect3d(w[0], w[1], w[2], x[0], x[1], x[2], y[0], y[1], y[2], z[0], z[1], z[2]);
            } else throw new TypeError("Arrays with two or thee dimensional points expected");
        },
        "Matrix, Matrix, Matrix": function MatrixMatrixMatrix(x, y, plane) {
            return matrix(intersect(x.valueOf(), y.valueOf(), plane.valueOf()));
        },
        "Matrix, Matrix, Matrix, Matrix": function MatrixMatrixMatrixMatrix(w, x, y, z) {
            // TODO: output matrix type should match input matrix type
            return matrix(intersect(w.valueOf(), x.valueOf(), y.valueOf(), z.valueOf()));
        }
    });
    function _isNumeric(a) {
        // intersect supports numbers and bignumbers
        return typeof a === "number" || (0, $1amHZ.isBigNumber)(a);
    }
    function _2d(x) {
        return x.length === 2 && _isNumeric(x[0]) && _isNumeric(x[1]);
    }
    function _3d(x) {
        return x.length === 3 && _isNumeric(x[0]) && _isNumeric(x[1]) && _isNumeric(x[2]);
    }
    function _4d(x) {
        return x.length === 4 && _isNumeric(x[0]) && _isNumeric(x[1]) && _isNumeric(x[2]) && _isNumeric(x[3]);
    }
    function _intersect2d(p1a, p1b, p2a, p2b) {
        var o1 = p1a;
        var o2 = p2a;
        var d1 = subtract(o1, p1b);
        var d2 = subtract(o2, p2b);
        var det = subtract(multiplyScalar(d1[0], d2[1]), multiplyScalar(d2[0], d1[1]));
        if (smaller(abs(det), config.epsilon)) return null;
        var d20o11 = multiplyScalar(d2[0], o1[1]);
        var d21o10 = multiplyScalar(d2[1], o1[0]);
        var d20o21 = multiplyScalar(d2[0], o2[1]);
        var d21o20 = multiplyScalar(d2[1], o2[0]);
        var t = divideScalar(addScalar(subtract(subtract(d20o11, d21o10), d20o21), d21o20), det);
        return add(multiply(d1, t), o1);
    }
    function _intersect3dHelper(a, b, c, d, e, f, g, h, i, j, k, l) {
        // (a - b)*(c - d) + (e - f)*(g - h) + (i - j)*(k - l)
        var add1 = multiplyScalar(subtract(a, b), subtract(c, d));
        var add2 = multiplyScalar(subtract(e, f), subtract(g, h));
        var add3 = multiplyScalar(subtract(i, j), subtract(k, l));
        return addScalar(addScalar(add1, add2), add3);
    }
    function _intersect3d(x1, y1, z1, x2, y2, z2, x3, y3, z3, x4, y4, z4) {
        var d1343 = _intersect3dHelper(x1, x3, x4, x3, y1, y3, y4, y3, z1, z3, z4, z3);
        var d4321 = _intersect3dHelper(x4, x3, x2, x1, y4, y3, y2, y1, z4, z3, z2, z1);
        var d1321 = _intersect3dHelper(x1, x3, x2, x1, y1, y3, y2, y1, z1, z3, z2, z1);
        var d4343 = _intersect3dHelper(x4, x3, x4, x3, y4, y3, y4, y3, z4, z3, z4, z3);
        var d2121 = _intersect3dHelper(x2, x1, x2, x1, y2, y1, y2, y1, z2, z1, z2, z1);
        var ta = divideScalar(subtract(multiplyScalar(d1343, d4321), multiplyScalar(d1321, d4343)), subtract(multiplyScalar(d2121, d4343), multiplyScalar(d4321, d4321)));
        var tb = divideScalar(addScalar(d1343, multiplyScalar(ta, d4321)), d4343);
        var pax = addScalar(x1, multiplyScalar(ta, subtract(x2, x1)));
        var pay = addScalar(y1, multiplyScalar(ta, subtract(y2, y1)));
        var paz = addScalar(z1, multiplyScalar(ta, subtract(z2, z1)));
        var pbx = addScalar(x3, multiplyScalar(tb, subtract(x4, x3)));
        var pby = addScalar(y3, multiplyScalar(tb, subtract(y4, y3)));
        var pbz = addScalar(z3, multiplyScalar(tb, subtract(z4, z3)));
        if (equalScalar(pax, pbx) && equalScalar(pay, pby) && equalScalar(paz, pbz)) return [
            pax,
            pay,
            paz
        ];
        else return null;
    }
    function _intersectLinePlane(x1, y1, z1, x2, y2, z2, x, y, z, c) {
        var x1x = multiplyScalar(x1, x);
        var x2x = multiplyScalar(x2, x);
        var y1y = multiplyScalar(y1, y);
        var y2y = multiplyScalar(y2, y);
        var z1z = multiplyScalar(z1, z);
        var z2z = multiplyScalar(z2, z);
        var t = divideScalar(subtract(subtract(subtract(c, x1x), y1y), z1z), subtract(subtract(subtract(addScalar(addScalar(x2x, y2y), z2z), x1x), y1y), z1z));
        var px = addScalar(x1, multiplyScalar(t, subtract(x2, x1)));
        var py = addScalar(y1, multiplyScalar(t, subtract(y2, y1)));
        var pz = addScalar(z1, multiplyScalar(t, subtract(z2, z1)));
        return [
            px,
            py,
            pz
        ]; // TODO: Add cases when line is parallel to the plane:
    //       (a) no intersection,
    //       (b) line contained in plane
    }
    return intersect;
});

});

parcelRegister("339f8", function(module, exports) {

$parcel$export(module.exports, "createInv", function () { return $2388d265ebbae8d3$export$ad9771ef9eafe06a; });

var $1amHZ = parcelRequire("1amHZ");

var $5WdrK = parcelRequire("5WdrK");

var $2mPYl = parcelRequire("2mPYl");

var $6NxuJ = parcelRequire("6NxuJ");
var $2388d265ebbae8d3$var$name = "inv";
var $2388d265ebbae8d3$var$dependencies = [
    "typed",
    "matrix",
    "divideScalar",
    "addScalar",
    "multiply",
    "unaryMinus",
    "det",
    "identity",
    "abs"
];
var $2388d265ebbae8d3$export$ad9771ef9eafe06a = /* #__PURE__ */ (0, $2mPYl.factory)($2388d265ebbae8d3$var$name, $2388d265ebbae8d3$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, divideScalar = _ref.divideScalar, addScalar = _ref.addScalar, multiply = _ref.multiply, unaryMinus = _ref.unaryMinus, det = _ref.det, identity = _ref.identity, abs = _ref.abs;
    /**
   * Calculate the inverse of a square matrix.
   *
   * Syntax:
   *
   *     math.inv(x)
   *
   * Examples:
   *
   *     math.inv([[1, 2], [3, 4]])  // returns [[-2, 1], [1.5, -0.5]]
   *     math.inv(4)                 // returns 0.25
   *     1 / 4                       // returns 0.25
   *
   * See also:
   *
   *     det, transpose
   *
   * @param {number | Complex | Array | Matrix} x     Matrix to be inversed
   * @return {number | Complex | Array | Matrix} The inverse of `x`.
   */ return typed($2388d265ebbae8d3$var$name, {
        "Array | Matrix": function ArrayMatrix(x) {
            var size = (0, $1amHZ.isMatrix)(x) ? x.size() : (0, $5WdrK.arraySize)(x);
            switch(size.length){
                case 1:
                    // vector
                    if (size[0] === 1) {
                        if ((0, $1amHZ.isMatrix)(x)) return matrix([
                            divideScalar(1, x.valueOf()[0])
                        ]);
                        else return [
                            divideScalar(1, x[0])
                        ];
                    } else throw new RangeError("Matrix must be square (size: " + (0, $6NxuJ.format)(size) + ")");
                case 2:
                    var rows = size[0];
                    var cols = size[1];
                    if (rows === cols) {
                        if ((0, $1amHZ.isMatrix)(x)) return matrix(_inv(x.valueOf(), rows, cols), x.storage());
                        else // return an Array
                        return _inv(x, rows, cols);
                    } else throw new RangeError("Matrix must be square (size: " + (0, $6NxuJ.format)(size) + ")");
                default:
                    // multi dimensional array
                    throw new RangeError("Matrix must be two dimensional (size: " + (0, $6NxuJ.format)(size) + ")");
            }
        },
        any: function any(x) {
            // scalar
            return divideScalar(1, x); // FIXME: create a BigNumber one when configured for bignumbers
        }
    });
    /**
   * Calculate the inverse of a square matrix
   * @param {Array[]} mat     A square matrix
   * @param {number} rows     Number of rows
   * @param {number} cols     Number of columns, must equal rows
   * @return {Array[]} inv    Inverse matrix
   * @private
   */ function _inv(mat, rows, cols) {
        var r, s, f, value, temp;
        if (rows === 1) {
            // this is a 1 x 1 matrix
            value = mat[0][0];
            if (value === 0) throw Error("Cannot calculate inverse, determinant is zero");
            return [
                [
                    divideScalar(1, value)
                ]
            ];
        } else if (rows === 2) {
            // this is a 2 x 2 matrix
            var d = det(mat);
            if (d === 0) throw Error("Cannot calculate inverse, determinant is zero");
            return [
                [
                    divideScalar(mat[1][1], d),
                    divideScalar(unaryMinus(mat[0][1]), d)
                ],
                [
                    divideScalar(unaryMinus(mat[1][0]), d),
                    divideScalar(mat[0][0], d)
                ]
            ];
        } else {
            // this is a matrix of 3 x 3 or larger
            // calculate inverse using gauss-jordan elimination
            //      https://en.wikipedia.org/wiki/Gaussian_elimination
            //      http://mathworld.wolfram.com/MatrixInverse.html
            //      http://math.uww.edu/~mcfarlat/inverse.htm
            // make a copy of the matrix (only the arrays, not of the elements)
            var A = mat.concat();
            for(r = 0; r < rows; r++)A[r] = A[r].concat();
             // create an identity matrix which in the end will contain the
            // matrix inverse
            var B = identity(rows).valueOf(); // loop over all columns, and perform row reductions
            for(var c = 0; c < cols; c++){
                // Pivoting: Swap row c with row r, where row r contains the largest element A[r][c]
                var ABig = abs(A[c][c]);
                var rBig = c;
                r = c + 1;
                while(r < rows){
                    if (abs(A[r][c]) > ABig) {
                        ABig = abs(A[r][c]);
                        rBig = r;
                    }
                    r++;
                }
                if (ABig === 0) throw Error("Cannot calculate inverse, determinant is zero");
                r = rBig;
                if (r !== c) {
                    temp = A[c];
                    A[c] = A[r];
                    A[r] = temp;
                    temp = B[c];
                    B[c] = B[r];
                    B[r] = temp;
                } // eliminate non-zero values on the other rows at column c
                var Ac = A[c];
                var Bc = B[c];
                for(r = 0; r < rows; r++){
                    var Ar = A[r];
                    var Br = B[r];
                    if (r !== c) // eliminate value at column c and row r
                    {
                        if (Ar[c] !== 0) {
                            f = divideScalar(unaryMinus(Ar[c]), Ac[c]); // add (f * row c) to row r to eliminate the value
                            // at column c
                            for(s = c; s < cols; s++)Ar[s] = addScalar(Ar[s], multiply(f, Ac[s]));
                            for(s = 0; s < cols; s++)Br[s] = addScalar(Br[s], multiply(f, Bc[s]));
                        }
                    } else {
                        // normalize value at Acc to 1,
                        // divide each value on row r with the value at Acc
                        f = Ac[c];
                        for(s = c; s < cols; s++)Ar[s] = divideScalar(Ar[s], f);
                        for(s = 0; s < cols; s++)Br[s] = divideScalar(Br[s], f);
                    }
                }
            }
            return B;
        }
    }
});

});

parcelRegister("7gZON", function(module, exports) {

$parcel$export(module.exports, "createIsInteger", function () { return $54b9fadc47b9ea8b$export$766996d075d5608a; });

var $e04i1 = parcelRequire("e04i1");

var $kFRKb = parcelRequire("kFRKb");

var $2mPYl = parcelRequire("2mPYl");
var $54b9fadc47b9ea8b$var$name = "isInteger";
var $54b9fadc47b9ea8b$var$dependencies = [
    "typed"
];
var $54b9fadc47b9ea8b$export$766996d075d5608a = /* #__PURE__ */ (0, $2mPYl.factory)($54b9fadc47b9ea8b$var$name, $54b9fadc47b9ea8b$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Test whether a value is an integer number.
   * The function supports `number`, `BigNumber`, and `Fraction`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isInteger(x)
   *
   * Examples:
   *
   *    math.isInteger(2)                     // returns true
   *    math.isInteger(0)                     // returns true
   *    math.isInteger(0.5)                   // returns false
   *    math.isInteger(math.bignumber(500))   // returns true
   *    math.isInteger(math.fraction(4))      // returns true
   *    math.isInteger('3')                   // returns true
   *    math.isInteger([3, 0.5, -2])          // returns [true, false, true]
   *    math.isInteger(math.complex('2-4i')   // throws an error
   *
   * See also:
   *
   *    isNumeric, isPositive, isNegative, isZero
   *
   * @param {number | BigNumber | Fraction | Array | Matrix} x   Value to be tested
   * @return {boolean}  Returns true when `x` contains a numeric, integer value.
   *                    Throws an error in case of an unknown data type.
   */ var isInteger = typed($54b9fadc47b9ea8b$var$name, {
        number: (0, $kFRKb.isInteger),
        // TODO: what to do with isInteger(add(0.1, 0.2))  ?
        BigNumber: function BigNumber(x) {
            return x.isInt();
        },
        Fraction: function Fraction(x) {
            return x.d === 1 && isFinite(x.n);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, isInteger);
        }
    });
    return isInteger;
});

});

parcelRegister("gO8O1", function(module, exports) {

$parcel$export(module.exports, "createIsNaN", function () { return $c3c82584c5d00a70$export$f85085363cf09711; });

var $e04i1 = parcelRequire("e04i1");

var $2mPYl = parcelRequire("2mPYl");

var $lIGoq = parcelRequire("lIGoq");
var $c3c82584c5d00a70$var$name = "isNaN";
var $c3c82584c5d00a70$var$dependencies = [
    "typed"
];
var $c3c82584c5d00a70$export$f85085363cf09711 = /* #__PURE__ */ (0, $2mPYl.factory)($c3c82584c5d00a70$var$name, $c3c82584c5d00a70$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Test whether a value is NaN (not a number).
   * The function supports types `number`, `BigNumber`, `Fraction`, `Unit` and `Complex`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isNaN(x)
   *
   * Examples:
   *
   *    math.isNaN(3)                     // returns false
   *    math.isNaN(NaN)                   // returns true
   *    math.isNaN(0)                     // returns false
   *    math.isNaN(math.bignumber(NaN))   // returns true
   *    math.isNaN(math.bignumber(0))     // returns false
   *    math.isNaN(math.fraction(-2, 5))  // returns false
   *    math.isNaN('-2')                  // returns false
   *    math.isNaN([2, 0, -3, NaN]')      // returns [false, false, false, true]
   *
   * See also:
   *
   *    isNumeric, isNegative, isPositive, isZero, isInteger
   *
   * @param {number | BigNumber | Fraction | Unit | Array | Matrix} x  Value to be tested
   * @return {boolean}  Returns true when `x` is NaN.
   *                    Throws an error in case of an unknown data type.
   */ return typed($c3c82584c5d00a70$var$name, {
        number: (0, $lIGoq.isNaNNumber),
        BigNumber: function BigNumber(x) {
            return x.isNaN();
        },
        Fraction: function Fraction(x) {
            return false;
        },
        Complex: function Complex(x) {
            return x.isNaN();
        },
        Unit: function Unit(x) {
            return Number.isNaN(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, Number.isNaN);
        }
    });
});

});
parcelRegister("lIGoq", function(module, exports) {

$parcel$export(module.exports, "isNegativeNumber", function () { return $fcfe9763b0eb5144$export$6dbd64961904ec9a; });
$parcel$export(module.exports, "isPositiveNumber", function () { return $fcfe9763b0eb5144$export$5374bb854d0e41c8; });
$parcel$export(module.exports, "isZeroNumber", function () { return $fcfe9763b0eb5144$export$83fb4ed1cc9804a; });
$parcel$export(module.exports, "isNaNNumber", function () { return $fcfe9763b0eb5144$export$9fd08d8371c55110; });

var $kFRKb = parcelRequire("kFRKb");
var $fcfe9763b0eb5144$var$n1 = "number";
function $fcfe9763b0eb5144$export$312381923ba56895(x) {
    return (0, $kFRKb.isInteger)(x);
}
$fcfe9763b0eb5144$export$312381923ba56895.signature = $fcfe9763b0eb5144$var$n1;
function $fcfe9763b0eb5144$export$6dbd64961904ec9a(x) {
    return x < 0;
}
$fcfe9763b0eb5144$export$6dbd64961904ec9a.signature = $fcfe9763b0eb5144$var$n1;
function $fcfe9763b0eb5144$export$5374bb854d0e41c8(x) {
    return x > 0;
}
$fcfe9763b0eb5144$export$5374bb854d0e41c8.signature = $fcfe9763b0eb5144$var$n1;
function $fcfe9763b0eb5144$export$83fb4ed1cc9804a(x) {
    return x === 0;
}
$fcfe9763b0eb5144$export$83fb4ed1cc9804a.signature = $fcfe9763b0eb5144$var$n1;
function $fcfe9763b0eb5144$export$9fd08d8371c55110(x) {
    return Number.isNaN(x);
}
$fcfe9763b0eb5144$export$9fd08d8371c55110.signature = $fcfe9763b0eb5144$var$n1;

});


parcelRegister("jUmYr", function(module, exports) {

$parcel$export(module.exports, "createIsNegative", function () { return $e7e51170184b23fc$export$159ccd8c63e17c58; });

var $e04i1 = parcelRequire("e04i1");

var $2mPYl = parcelRequire("2mPYl");

var $lIGoq = parcelRequire("lIGoq");
var $e7e51170184b23fc$var$name = "isNegative";
var $e7e51170184b23fc$var$dependencies = [
    "typed"
];
var $e7e51170184b23fc$export$159ccd8c63e17c58 = /* #__PURE__ */ (0, $2mPYl.factory)($e7e51170184b23fc$var$name, $e7e51170184b23fc$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Test whether a value is negative: smaller than zero.
   * The function supports types `number`, `BigNumber`, `Fraction`, and `Unit`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isNegative(x)
   *
   * Examples:
   *
   *    math.isNegative(3)                     // returns false
   *    math.isNegative(-2)                    // returns true
   *    math.isNegative(0)                     // returns false
   *    math.isNegative(-0)                    // returns false
   *    math.isNegative(math.bignumber(2))     // returns false
   *    math.isNegative(math.fraction(-2, 5))  // returns true
   *    math.isNegative('-2')                  // returns true
   *    math.isNegative([2, 0, -3]')           // returns [false, false, true]
   *
   * See also:
   *
   *    isNumeric, isPositive, isZero, isInteger
   *
   * @param {number | BigNumber | Fraction | Unit | Array | Matrix} x  Value to be tested
   * @return {boolean}  Returns true when `x` is larger than zero.
   *                    Throws an error in case of an unknown data type.
   */ var isNegative = typed($e7e51170184b23fc$var$name, {
        number: (0, $lIGoq.isNegativeNumber),
        BigNumber: function BigNumber(x) {
            return x.isNeg() && !x.isZero() && !x.isNaN();
        },
        Fraction: function Fraction(x) {
            return x.s < 0; // It's enough to decide on the sign
        },
        Unit: function Unit(x) {
            return isNegative(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, isNegative);
        }
    });
    return isNegative;
});

});

parcelRegister("7quLY", function(module, exports) {

$parcel$export(module.exports, "createIsNumeric", function () { return $5682d4efb55a7eaa$export$85b0631fa122b7f1; });

var $e04i1 = parcelRequire("e04i1");

var $2mPYl = parcelRequire("2mPYl");
var $5682d4efb55a7eaa$var$name = "isNumeric";
var $5682d4efb55a7eaa$var$dependencies = [
    "typed"
];
var $5682d4efb55a7eaa$export$85b0631fa122b7f1 = /* #__PURE__ */ (0, $2mPYl.factory)($5682d4efb55a7eaa$var$name, $5682d4efb55a7eaa$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Test whether a value is an numeric value.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isNumeric(x)
   *
   * Examples:
   *
   *    math.isNumeric(2)                     // returns true
   *    math.isNumeric('2')                   // returns false
   *    math.hasNumericValue('2')             // returns true
   *    math.isNumeric(0)                     // returns true
   *    math.isNumeric(math.bignumber(500))   // returns true
   *    math.isNumeric(math.fraction(4))      // returns true
   *    math.isNumeric(math.complex('2-4i')   // returns false
   *    math.isNumeric([2.3, 'foo', false])   // returns [true, false, true]
   *
   * See also:
   *
   *    isZero, isPositive, isNegative, isInteger, hasNumericValue
   *
   * @param {*} x       Value to be tested
   * @return {boolean}  Returns true when `x` is a `number`, `BigNumber`,
   *                    `Fraction`, or `boolean`. Returns false for other types.
   *                    Throws an error in case of unknown types.
   */ var isNumeric = typed($5682d4efb55a7eaa$var$name, {
        "number | BigNumber | Fraction | boolean": function numberBigNumberFractionBoolean() {
            return true;
        },
        "Complex | Unit | string | null | undefined | Node": function ComplexUnitStringNullUndefinedNode() {
            return false;
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, isNumeric);
        }
    });
    return isNumeric;
});

});

parcelRegister("gX2t3", function(module, exports) {

$parcel$export(module.exports, "createIsPositive", function () { return $c5741208e69de4c7$export$2d862c12fb537dd9; });

var $e04i1 = parcelRequire("e04i1");

var $2mPYl = parcelRequire("2mPYl");

var $lIGoq = parcelRequire("lIGoq");
var $c5741208e69de4c7$var$name = "isPositive";
var $c5741208e69de4c7$var$dependencies = [
    "typed"
];
var $c5741208e69de4c7$export$2d862c12fb537dd9 = /* #__PURE__ */ (0, $2mPYl.factory)($c5741208e69de4c7$var$name, $c5741208e69de4c7$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Test whether a value is positive: larger than zero.
   * The function supports types `number`, `BigNumber`, `Fraction`, and `Unit`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isPositive(x)
   *
   * Examples:
   *
   *    math.isPositive(3)                     // returns true
   *    math.isPositive(-2)                    // returns false
   *    math.isPositive(0)                     // returns false
   *    math.isPositive(-0)                    // returns false
   *    math.isPositive(0.5)                   // returns true
   *    math.isPositive(math.bignumber(2))     // returns true
   *    math.isPositive(math.fraction(-2, 5))  // returns false
   *    math.isPositive(math.fraction(1,3))    // returns false
   *    math.isPositive('2')                   // returns true
   *    math.isPositive([2, 0, -3])            // returns [true, false, false]
   *
   * See also:
   *
   *    isNumeric, isZero, isNegative, isInteger
   *
   * @param {number | BigNumber | Fraction | Unit | Array | Matrix} x  Value to be tested
   * @return {boolean}  Returns true when `x` is larger than zero.
   *                    Throws an error in case of an unknown data type.
   */ var isPositive = typed($c5741208e69de4c7$var$name, {
        number: (0, $lIGoq.isPositiveNumber),
        BigNumber: function BigNumber(x) {
            return !x.isNeg() && !x.isZero() && !x.isNaN();
        },
        Fraction: function Fraction(x) {
            return x.s > 0 && x.n > 0;
        },
        Unit: function Unit(x) {
            return isPositive(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, isPositive);
        }
    });
    return isPositive;
});

});

parcelRegister("7Uryu", function(module, exports) {

$parcel$export(module.exports, "createIsPrime", function () { return $5c232346a316895a$export$4e02350f5fb7a050; });

var $e04i1 = parcelRequire("e04i1");

var $2mPYl = parcelRequire("2mPYl");
var $5c232346a316895a$var$name = "isPrime";
var $5c232346a316895a$var$dependencies = [
    "typed"
];
var $5c232346a316895a$export$4e02350f5fb7a050 = /* #__PURE__ */ (0, $2mPYl.factory)($5c232346a316895a$var$name, $5c232346a316895a$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Test whether a value is prime: has no divisors other than itself and one.
   * The function supports type `number`, `bignumber`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isPrime(x)
   *
   * Examples:
   *
   *    math.isPrime(3)                     // returns true
   *    math.isPrime(-2)                    // returns false
   *    math.isPrime(0)                     // returns false
   *    math.isPrime(-0)                    // returns false
   *    math.isPrime(0.5)                   // returns false
   *    math.isPrime('2')                   // returns true
   *    math.isPrime([2, 17, 100])           // returns [true, true, false]
   *
   * See also:
   *
   *    isNumeric, isZero, isNegative, isInteger
   *
   * @param {number | BigNumber | Array | Matrix} x  Value to be tested
   * @return {boolean}  Returns true when `x` is larger than zero.
   *                    Throws an error in case of an unknown data type.
   */ var isPrime = typed($5c232346a316895a$var$name, {
        number: function number(x) {
            if (x * 0 !== 0) return false;
            if (x <= 3) return x > 1;
            if (x % 2 === 0 || x % 3 === 0) return false;
            for(var i = 5; i * i <= x; i += 6){
                if (x % i === 0 || x % (i + 2) === 0) return false;
            }
            return true;
        },
        BigNumber: function BigNumber(n) {
            if (n.toNumber() * 0 !== 0) return false;
            if (n.lte(3)) return n.gt(1);
            if (n.mod(2).eq(0) || n.mod(3).eq(0)) return false;
            for(var i = 5; n.gte(i * i); i += 6){
                if (n.mod(i).eq(0) || n.mod(i + 2).eq(0)) return false;
            }
            return true;
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, isPrime);
        }
    });
    return isPrime;
});

});

parcelRegister("8b5FJ", function(module, exports) {

$parcel$export(module.exports, "createIsZero", function () { return $5f43c0307d12abcf$export$ea90652d00dab06e; });

var $e04i1 = parcelRequire("e04i1");

var $2mPYl = parcelRequire("2mPYl");

var $lIGoq = parcelRequire("lIGoq");
var $5f43c0307d12abcf$var$name = "isZero";
var $5f43c0307d12abcf$var$dependencies = [
    "typed"
];
var $5f43c0307d12abcf$export$ea90652d00dab06e = /* #__PURE__ */ (0, $2mPYl.factory)($5f43c0307d12abcf$var$name, $5f43c0307d12abcf$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Test whether a value is zero.
   * The function can check for zero for types `number`, `BigNumber`, `Fraction`,
   * `Complex`, and `Unit`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isZero(x)
   *
   * Examples:
   *
   *    math.isZero(0)                     // returns true
   *    math.isZero(2)                     // returns false
   *    math.isZero(0.5)                   // returns false
   *    math.isZero(math.bignumber(0))     // returns true
   *    math.isZero(math.fraction(0))      // returns true
   *    math.isZero(math.fraction(1,3))    // returns false
   *    math.isZero(math.complex('2 - 4i') // returns false
   *    math.isZero(math.complex('0i')     // returns true
   *    math.isZero('0')                   // returns true
   *    math.isZero('2')                   // returns false
   *    math.isZero([2, 0, -3]')           // returns [false, true, false]
   *
   * See also:
   *
   *    isNumeric, isPositive, isNegative, isInteger
   *
   * @param {number | BigNumber | Complex | Fraction | Unit | Array | Matrix} x       Value to be tested
   * @return {boolean}  Returns true when `x` is zero.
   *                    Throws an error in case of an unknown data type.
   */ var isZero = typed($5f43c0307d12abcf$var$name, {
        number: (0, $lIGoq.isZeroNumber),
        BigNumber: function BigNumber(x) {
            return x.isZero();
        },
        Complex: function Complex(x) {
            return x.re === 0 && x.im === 0;
        },
        Fraction: function Fraction(x) {
            return x.d === 1 && x.n === 0;
        },
        Unit: function Unit(x) {
            return isZero(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, isZero);
        }
    });
    return isZero;
});

});

parcelRegister("1srjG", function(module, exports) {

$parcel$export(module.exports, "createKldivergence", function () { return $10fd987a4728796b$export$eaa5cb8fd86b8d43; });

var $2mPYl = parcelRequire("2mPYl");
var $10fd987a4728796b$var$name = "kldivergence";
var $10fd987a4728796b$var$dependencies = [
    "typed",
    "matrix",
    "divide",
    "sum",
    "multiply",
    "dotDivide",
    "log",
    "isNumeric"
];
var $10fd987a4728796b$export$eaa5cb8fd86b8d43 = /* #__PURE__ */ (0, $2mPYl.factory)($10fd987a4728796b$var$name, $10fd987a4728796b$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, divide = _ref.divide, sum = _ref.sum, multiply = _ref.multiply, dotDivide = _ref.dotDivide, log = _ref.log, isNumeric = _ref.isNumeric;
    /**
     * Calculate the Kullback-Leibler (KL) divergence  between two distributions
     *
     * Syntax:
     *
     *     math.kldivergence(x, y)
     *
     * Examples:
     *
     *     math.kldivergence([0.7,0.5,0.4], [0.2,0.9,0.5])   //returns 0.24376698773121153
     *
     *
     * @param  {Array | Matrix} q    First vector
     * @param  {Array | Matrix} p    Second vector
     * @return {number}              Returns distance between q and p
     */ return typed($10fd987a4728796b$var$name, {
        "Array, Array": function ArrayArray(q, p) {
            return _kldiv(matrix(q), matrix(p));
        },
        "Matrix, Array": function MatrixArray(q, p) {
            return _kldiv(q, matrix(p));
        },
        "Array, Matrix": function ArrayMatrix(q, p) {
            return _kldiv(matrix(q), p);
        },
        "Matrix, Matrix": function MatrixMatrix(q, p) {
            return _kldiv(q, p);
        }
    });
    function _kldiv(q, p) {
        var plength = p.size().length;
        var qlength = q.size().length;
        if (plength > 1) throw new Error("first object must be one dimensional");
        if (qlength > 1) throw new Error("second object must be one dimensional");
        if (plength !== qlength) throw new Error("Length of two vectors must be equal");
         // Before calculation, apply normalization
        var sumq = sum(q);
        if (sumq === 0) throw new Error("Sum of elements in first object must be non zero");
        var sump = sum(p);
        if (sump === 0) throw new Error("Sum of elements in second object must be non zero");
        var qnorm = divide(q, sum(q));
        var pnorm = divide(p, sum(p));
        var result = sum(multiply(qnorm, log(dotDivide(qnorm, pnorm))));
        if (isNumeric(result)) return result;
        else return Number.NaN;
    }
});

});

parcelRegister("5eRkA", function(module, exports) {

$parcel$export(module.exports, "createKron", function () { return $3d07a0fed797be3d$export$cee275bf38ddc295; });

var $5WdrK = parcelRequire("5WdrK");

var $2mPYl = parcelRequire("2mPYl");
var $3d07a0fed797be3d$var$name = "kron";
var $3d07a0fed797be3d$var$dependencies = [
    "typed",
    "matrix",
    "multiplyScalar"
];
var $3d07a0fed797be3d$export$cee275bf38ddc295 = /* #__PURE__ */ (0, $2mPYl.factory)($3d07a0fed797be3d$var$name, $3d07a0fed797be3d$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, multiplyScalar = _ref.multiplyScalar;
    /**
     * Calculates the kronecker product of 2 matrices or vectors.
     *
     * NOTE: If a one dimensional vector / matrix is given, it will be
     * wrapped so its two dimensions.
     * See the examples.
     *
     * Syntax:
     *
     *    math.kron(x, y)
     *
     * Examples:
     *
     *    math.kron([[1, 0], [0, 1]], [[1, 2], [3, 4]])
     *    // returns [ [ 1, 2, 0, 0 ], [ 3, 4, 0, 0 ], [ 0, 0, 1, 2 ], [ 0, 0, 3, 4 ] ]
     *
     *    math.kron([1,1], [2,3,4])
     *    // returns [ [ 2, 3, 4, 2, 3, 4 ] ]
     *
     * See also:
     *
     *    multiply, dot, cross
     *
     * @param  {Array | Matrix} x     First vector
     * @param  {Array | Matrix} y     Second vector
     * @return {Array | Matrix}       Returns the kronecker product of `x` and `y`
     */ return typed($3d07a0fed797be3d$var$name, {
        "Matrix, Matrix": function MatrixMatrix(x, y) {
            return matrix(_kron(x.toArray(), y.toArray()));
        },
        "Matrix, Array": function MatrixArray(x, y) {
            return matrix(_kron(x.toArray(), y));
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            return matrix(_kron(x, y.toArray()));
        },
        "Array, Array": _kron
    });
    /**
     * Calculate the kronecker product of two matrices / vectors
     * @param {Array} a  First vector
     * @param {Array} b  Second vector
     * @returns {Array} Returns the kronecker product of x and y
     * @private
     */ function _kron(a, b) {
        // Deal with the dimensions of the matricies.
        if ((0, $5WdrK.arraySize)(a).length === 1) // Wrap it in a 2D Matrix
        a = [
            a
        ];
        if ((0, $5WdrK.arraySize)(b).length === 1) // Wrap it in a 2D Matrix
        b = [
            b
        ];
        if ((0, $5WdrK.arraySize)(a).length > 2 || (0, $5WdrK.arraySize)(b).length > 2) throw new RangeError("Vectors with dimensions greater then 2 are not supported expected (Size x = " + JSON.stringify(a.length) + ", y = " + JSON.stringify(b.length) + ")");
        var t = [];
        var r = [];
        return a.map(function(a) {
            return b.map(function(b) {
                r = [];
                t.push(r);
                return a.map(function(y) {
                    return b.map(function(x) {
                        return r.push(multiplyScalar(y, x));
                    });
                });
            });
        }) && t;
    }
});

});

parcelRegister("cUU3S", function(module, exports) {

$parcel$export(module.exports, "createLarger", function () { return $967633a321f3b25c$export$af9bc16ae70e9aa8; });

var $ijobM = parcelRequire("ijobM");

var $kFRKb = parcelRequire("kFRKb");

var $2mPYl = parcelRequire("2mPYl");

var $jaKH8 = parcelRequire("jaKH8");

var $awGkR = parcelRequire("awGkR");

var $dNuvz = parcelRequire("dNuvz");

var $iHnaT = parcelRequire("iHnaT");

var $1bBLS = parcelRequire("1bBLS");
var $967633a321f3b25c$var$name = "larger";
var $967633a321f3b25c$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "DenseMatrix"
];
var $967633a321f3b25c$export$af9bc16ae70e9aa8 = /* #__PURE__ */ (0, $2mPYl.factory)($967633a321f3b25c$var$name, $967633a321f3b25c$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, matrix = _ref.matrix, DenseMatrix = _ref.DenseMatrix;
    var algorithm03 = (0, $jaKH8.createAlgorithm03)({
        typed: typed
    });
    var algorithm07 = (0, $awGkR.createAlgorithm07)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $dNuvz.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $1bBLS.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $iHnaT.createAlgorithm14)({
        typed: typed
    });
    /**
   * Test whether value x is larger than y.
   *
   * The function returns true when x is larger than y and the relative
   * difference between x and y is larger than the configured epsilon. The
   * function cannot be used to compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.larger(x, y)
   *
   * Examples:
   *
   *    math.larger(2, 3)             // returns false
   *    math.larger(5, 2 + 2)         // returns true
   *
   *    const a = math.unit('5 cm')
   *    const b = math.unit('2 inch')
   *    math.larger(a, b)             // returns false
   *
   * See also:
   *
   *    equal, unequal, smaller, smallerEq, largerEq, compare
   *
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the x is larger than y, else returns false
   */ var larger = typed($967633a321f3b25c$var$name, {
        "boolean, boolean": function booleanBoolean(x, y) {
            return x > y;
        },
        "number, number": function numberNumber(x, y) {
            return x > y && !(0, $kFRKb.nearlyEqual)(x, y, config.epsilon);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.gt(y) && !(0, $ijobM.nearlyEqual)(x, y, config.epsilon);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.compare(y) === 1;
        },
        "Complex, Complex": function ComplexComplex() {
            throw new TypeError("No ordering relation is defined for complex numbers");
        },
        "Unit, Unit": function UnitUnit(x, y) {
            if (!x.equalBase(y)) throw new Error("Cannot compare units with different base");
            return larger(x.value, y.value);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, larger);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, larger, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, larger, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, larger);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return larger(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return larger(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return larger(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, larger, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, larger, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, larger, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, larger, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, larger, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, larger, true).valueOf();
        }
    });
    return larger;
});
var $967633a321f3b25c$export$36e0507f86788708 = /* #__PURE__ */ (0, $2mPYl.factory)($967633a321f3b25c$var$name, [
    "typed",
    "config"
], function(_ref2) {
    var typed = _ref2.typed, config = _ref2.config;
    return typed($967633a321f3b25c$var$name, {
        "number, number": function numberNumber(x, y) {
            return x > y && !(0, $kFRKb.nearlyEqual)(x, y, config.epsilon);
        }
    });
});

});

parcelRegister("3MOz5", function(module, exports) {

$parcel$export(module.exports, "createLargerEq", function () { return $2c1d13ef7b22737f$export$26aa7f5b5fee1150; });

var $ijobM = parcelRequire("ijobM");

var $kFRKb = parcelRequire("kFRKb");

var $2mPYl = parcelRequire("2mPYl");

var $jaKH8 = parcelRequire("jaKH8");

var $awGkR = parcelRequire("awGkR");

var $dNuvz = parcelRequire("dNuvz");

var $iHnaT = parcelRequire("iHnaT");

var $1bBLS = parcelRequire("1bBLS");
var $2c1d13ef7b22737f$var$name = "largerEq";
var $2c1d13ef7b22737f$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "DenseMatrix"
];
var $2c1d13ef7b22737f$export$26aa7f5b5fee1150 = /* #__PURE__ */ (0, $2mPYl.factory)($2c1d13ef7b22737f$var$name, $2c1d13ef7b22737f$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, matrix = _ref.matrix, DenseMatrix = _ref.DenseMatrix;
    var algorithm03 = (0, $jaKH8.createAlgorithm03)({
        typed: typed
    });
    var algorithm07 = (0, $awGkR.createAlgorithm07)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $dNuvz.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $1bBLS.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $iHnaT.createAlgorithm14)({
        typed: typed
    });
    /**
   * Test whether value x is larger or equal to y.
   *
   * The function returns true when x is larger than y or the relative
   * difference between x and y is smaller than the configured epsilon. The
   * function cannot be used to compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.largerEq(x, y)
   *
   * Examples:
   *
   *    math.larger(2, 1 + 1)         // returns false
   *    math.largerEq(2, 1 + 1)       // returns true
   *
   * See also:
   *
   *    equal, unequal, smaller, smallerEq, larger, compare
   *
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the x is larger or equal to y, else returns false
   */ var largerEq = typed($2c1d13ef7b22737f$var$name, {
        "boolean, boolean": function booleanBoolean(x, y) {
            return x >= y;
        },
        "number, number": function numberNumber(x, y) {
            return x >= y || (0, $kFRKb.nearlyEqual)(x, y, config.epsilon);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.gte(y) || (0, $ijobM.nearlyEqual)(x, y, config.epsilon);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.compare(y) !== -1;
        },
        "Complex, Complex": function ComplexComplex() {
            throw new TypeError("No ordering relation is defined for complex numbers");
        },
        "Unit, Unit": function UnitUnit(x, y) {
            if (!x.equalBase(y)) throw new Error("Cannot compare units with different base");
            return largerEq(x.value, y.value);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, largerEq);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, largerEq, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, largerEq, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, largerEq);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return largerEq(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return largerEq(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return largerEq(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, largerEq, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, largerEq, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, largerEq, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, largerEq, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, largerEq, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, largerEq, true).valueOf();
        }
    });
    return largerEq;
});
var $2c1d13ef7b22737f$export$494ed93834104475 = /* #__PURE__ */ (0, $2mPYl.factory)($2c1d13ef7b22737f$var$name, [
    "typed",
    "config"
], function(_ref2) {
    var typed = _ref2.typed, config = _ref2.config;
    return typed($2c1d13ef7b22737f$var$name, {
        "number, number": function numberNumber(x, y) {
            return x >= y || (0, $kFRKb.nearlyEqual)(x, y, config.epsilon);
        }
    });
});

});

parcelRegister("8lih4", function(module, exports) {

$parcel$export(module.exports, "createLcm", function () { return $612e75c9dbc69d0f$export$5d3af1956d9bb33b; });

var $2mPYl = parcelRequire("2mPYl");

var $cITNv = parcelRequire("cITNv");

var $9INF1 = parcelRequire("9INF1");

var $cZfrH = parcelRequire("cZfrH");

var $1bBLS = parcelRequire("1bBLS");

var $iHnaT = parcelRequire("iHnaT");

var $6fCew = parcelRequire("6fCew");
var $612e75c9dbc69d0f$var$name = "lcm";
var $612e75c9dbc69d0f$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar"
];
var $612e75c9dbc69d0f$export$5d3af1956d9bb33b = /* #__PURE__ */ (0, $2mPYl.factory)($612e75c9dbc69d0f$var$name, $612e75c9dbc69d0f$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, equalScalar = _ref.equalScalar;
    var algorithm02 = (0, $cITNv.createAlgorithm02)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm06 = (0, $9INF1.createAlgorithm06)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm11 = (0, $cZfrH.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $1bBLS.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $iHnaT.createAlgorithm14)({
        typed: typed
    });
    /**
   * Calculate the least common multiple for two or more values or arrays.
   *
   * lcm is defined as:
   *
   *     lcm(a, b) = abs(a * b) / gcd(a, b)
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.lcm(a, b)
   *    math.lcm(a, b, c, ...)
   *
   * Examples:
   *
   *    math.lcm(4, 6)               // returns 12
   *    math.lcm(6, 21)              // returns 42
   *    math.lcm(6, 21, 5)           // returns 210
   *
   *    math.lcm([4, 6], [6, 21])    // returns [12, 42]
   *
   * See also:
   *
   *    gcd, xgcd
   *
   * @param {... number | BigNumber | Array | Matrix} args  Two or more integer numbers
   * @return {number | BigNumber | Array | Matrix}                           The least common multiple
   */ var lcm = typed($612e75c9dbc69d0f$var$name, {
        "number, number": (0, $6fCew.lcmNumber),
        "BigNumber, BigNumber": _lcmBigNumber,
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.lcm(y);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm06(x, y, lcm);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, lcm, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm02(x, y, lcm, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, lcm);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return lcm(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return lcm(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return lcm(x, matrix(y));
        },
        "SparseMatrix, number | BigNumber": function SparseMatrixNumberBigNumber(x, y) {
            return algorithm11(x, y, lcm, false);
        },
        "DenseMatrix, number | BigNumber": function DenseMatrixNumberBigNumber(x, y) {
            return algorithm14(x, y, lcm, false);
        },
        "number | BigNumber, SparseMatrix": function numberBigNumberSparseMatrix(x, y) {
            return algorithm11(y, x, lcm, true);
        },
        "number | BigNumber, DenseMatrix": function numberBigNumberDenseMatrix(x, y) {
            return algorithm14(y, x, lcm, true);
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, lcm, false).valueOf();
        },
        "number | BigNumber, Array": function numberBigNumberArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, lcm, true).valueOf();
        },
        // TODO: need a smarter notation here
        "Array | Matrix | number | BigNumber, Array | Matrix | number | BigNumber, ...Array | Matrix | number | BigNumber": function ArrayMatrixNumberBigNumberArrayMatrixNumberBigNumberArrayMatrixNumberBigNumber(a, b, args) {
            var res = lcm(a, b);
            for(var i = 0; i < args.length; i++)res = lcm(res, args[i]);
            return res;
        }
    });
    return lcm;
    /**
   * Calculate lcm for two BigNumbers
   * @param {BigNumber} a
   * @param {BigNumber} b
   * @returns {BigNumber} Returns the least common multiple of a and b
   * @private
   */ function _lcmBigNumber(a, b) {
        if (!a.isInt() || !b.isInt()) throw new Error("Parameters in function lcm must be integer numbers");
        if (a.isZero()) return a;
        if (b.isZero()) return b;
         // https://en.wikipedia.org/wiki/Euclidean_algorithm
        // evaluate lcm here inline to reduce overhead
        var prod = a.times(b);
        while(!b.isZero()){
            var t = b;
            b = a.mod(t);
            a = t;
        }
        return prod.div(a).abs();
    }
});

});

parcelRegister("aUJyL", function(module, exports) {

$parcel$export(module.exports, "createLeftShift", function () { return $7f2279927c89c35b$export$ce15600b23f5e78; });

var $cITNv = parcelRequire("cITNv");

var $cZfrH = parcelRequire("cZfrH");

var $1bBLS = parcelRequire("1bBLS");

var $iHnaT = parcelRequire("iHnaT");

var $gIOYU = parcelRequire("gIOYU");

var $1rFP6 = parcelRequire("1rFP6");

var $4gqxn = parcelRequire("4gqxn");

var $2mPYl = parcelRequire("2mPYl");

var $gVfmZ = parcelRequire("gVfmZ");

var $1Jf3Z = parcelRequire("1Jf3Z");
var $7f2279927c89c35b$var$name = "leftShift";
var $7f2279927c89c35b$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "zeros",
    "DenseMatrix"
];
var $7f2279927c89c35b$export$ce15600b23f5e78 = /* #__PURE__ */ (0, $2mPYl.factory)($7f2279927c89c35b$var$name, $7f2279927c89c35b$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, equalScalar = _ref.equalScalar, zeros = _ref.zeros, DenseMatrix = _ref.DenseMatrix;
    var algorithm01 = (0, $gIOYU.createAlgorithm01)({
        typed: typed
    });
    var algorithm02 = (0, $cITNv.createAlgorithm02)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm08 = (0, $4gqxn.createAlgorithm08)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm10 = (0, $1rFP6.createAlgorithm10)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm11 = (0, $cZfrH.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $1bBLS.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $iHnaT.createAlgorithm14)({
        typed: typed
    });
    /**
   * Bitwise left logical shift of a value x by y number of bits, `x << y`.
   * For matrices, the function is evaluated element wise.
   * For units, the function is evaluated on the best prefix base.
   *
   * Syntax:
   *
   *    math.leftShift(x, y)
   *
   * Examples:
   *
   *    math.leftShift(1, 2)               // returns number 4
   *
   *    math.leftShift([1, 2, 3], 4)       // returns Array [16, 32, 64]
   *
   * See also:
   *
   *    leftShift, bitNot, bitOr, bitXor, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | Array | Matrix} x Value to be shifted
   * @param  {number | BigNumber} y Amount of shifts
   * @return {number | BigNumber | Array | Matrix} `x` shifted left `y` times
   */ var leftShift = typed($7f2279927c89c35b$var$name, {
        "number, number": (0, $gVfmZ.leftShiftNumber),
        "BigNumber, BigNumber": (0, $1Jf3Z.leftShiftBigNumber),
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm08(x, y, leftShift, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, leftShift, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm01(x, y, leftShift, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, leftShift);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return leftShift(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return leftShift(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return leftShift(x, matrix(y));
        },
        "SparseMatrix, number | BigNumber": function SparseMatrixNumberBigNumber(x, y) {
            // check scalar
            if (equalScalar(y, 0)) return x.clone();
            return algorithm11(x, y, leftShift, false);
        },
        "DenseMatrix, number | BigNumber": function DenseMatrixNumberBigNumber(x, y) {
            // check scalar
            if (equalScalar(y, 0)) return x.clone();
            return algorithm14(x, y, leftShift, false);
        },
        "number | BigNumber, SparseMatrix": function numberBigNumberSparseMatrix(x, y) {
            // check scalar
            if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
            return algorithm10(y, x, leftShift, true);
        },
        "number | BigNumber, DenseMatrix": function numberBigNumberDenseMatrix(x, y) {
            // check scalar
            if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
            return algorithm14(y, x, leftShift, true);
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(x, y) {
            // use matrix implementation
            return leftShift(matrix(x), y).valueOf();
        },
        "number | BigNumber, Array": function numberBigNumberArray(x, y) {
            // use matrix implementation
            return leftShift(x, matrix(y)).valueOf();
        }
    });
    return leftShift;
});

});
parcelRegister("4gqxn", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm08", function () { return $31ad3dd196c4993c$export$59a068f853cfbf8; });

var $2mPYl = parcelRequire("2mPYl");

var $hy7Bx = parcelRequire("hy7Bx");
var $31ad3dd196c4993c$var$name = "algorithm08";
var $31ad3dd196c4993c$var$dependencies = [
    "typed",
    "equalScalar"
];
var $31ad3dd196c4993c$export$59a068f853cfbf8 = /* #__PURE__ */ (0, $2mPYl.factory)($31ad3dd196c4993c$var$name, $31ad3dd196c4993c$var$dependencies, function(_ref) {
    var typed = _ref.typed, equalScalar = _ref.equalScalar;
    /**
   * Iterates over SparseMatrix A and SparseMatrix B nonzero items and invokes the callback function f(Aij, Bij).
   * Callback function invoked MAX(NNZA, NNZB) times
   *
   *
   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0 && B(i,j) !== 0
   * C(i,j) = ┤  A(i,j)       ; A(i,j) !== 0
   *          └  0            ; otherwise
   *
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function algorithm08(a, b, callback) {
        // sparse matrix arrays
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var asize = a._size;
        var adt = a._datatype; // sparse matrix arrays
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bsize = b._size;
        var bdt = b._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $hy7Bx.DimensionError)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
         // sparse matrix cannot be a Pattern matrix
        if (!avalues || !bvalues) throw new Error("Cannot perform operation on Pattern Sparse Matrices");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string" && adt === bdt) {
            // datatype
            dt = adt; // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cvalues = [];
        var cindex = [];
        var cptr = []; // workspace
        var x = []; // marks indicating we have a value in x for a given column
        var w = []; // vars
        var k, k0, k1, i; // loop columns
        for(var j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length; // columns mark
            var mark = j + 1; // loop values in a
            for(k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                i = aindex[k]; // mark workspace
                w[i] = mark; // set value
                x[i] = avalues[k]; // add index
                cindex.push(i);
            } // loop values in b
            for(k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                i = bindex[k]; // check value exists in workspace
                if (w[i] === mark) // evaluate callback
                x[i] = cf(x[i], bvalues[k]);
            } // initialize first index in j
            k = cptr[j]; // loop index in j
            while(k < cindex.length){
                // row
                i = cindex[k]; // value @ i
                var v = x[i]; // check for zero value
                if (!eq(v, zero)) {
                    // push value
                    cvalues.push(v); // increment pointer
                    k++;
                } else // remove value @ i, do not increment pointer
                cindex.splice(k, 1);
            }
        } // update cptr
        cptr[columns] = cindex.length; // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});

});


parcelRegister("bw5eO", function(module, exports) {

$parcel$export(module.exports, "createLog", function () { return $8626befffd0de065$export$aea8a16d5c9d1b93; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");

var $6fCew = parcelRequire("6fCew");
var $8626befffd0de065$var$name = "log";
var $8626befffd0de065$var$dependencies = [
    "config",
    "typed",
    "divideScalar",
    "Complex"
];
var $8626befffd0de065$export$aea8a16d5c9d1b93 = /* #__PURE__ */ (0, $2mPYl.factory)($8626befffd0de065$var$name, $8626befffd0de065$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, divideScalar = _ref.divideScalar, Complex = _ref.Complex;
    /**
   * Calculate the logarithm of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.log(x)
   *    math.log(x, base)
   *
   * Examples:
   *
   *    math.log(3.5)                  // returns 1.252762968495368
   *    math.exp(math.log(2.4))        // returns 2.4
   *
   *    math.pow(10, 4)                // returns 10000
   *    math.log(10000, 10)            // returns 4
   *    math.log(10000) / math.log(10) // returns 4
   *
   *    math.log(1024, 2)              // returns 10
   *    math.pow(2, 10)                // returns 1024
   *
   * See also:
   *
   *    exp, log2, log10, log1p
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            Value for which to calculate the logarithm.
   * @param {number | BigNumber | Complex} [base=e]
   *            Optional base for the logarithm. If not provided, the natural
   *            logarithm of `x` is calculated.
   * @return {number | BigNumber | Complex | Array | Matrix}
   *            Returns the logarithm of `x`
   */ var log = typed($8626befffd0de065$var$name, {
        number: function number(x) {
            if (x >= 0 || config.predictable) return (0, $6fCew.logNumber)(x);
            else // negative value -> complex value computation
            return new Complex(x, 0).log();
        },
        Complex: function Complex(x) {
            return x.log();
        },
        BigNumber: function BigNumber(x) {
            if (!x.isNegative() || config.predictable) return x.ln();
            else // downgrade to number, return Complex valued result
            return new Complex(x.toNumber(), 0).log();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, log);
        },
        "any, any": function anyAny(x, base) {
            // calculate logarithm for a specified base, log(x, base)
            return divideScalar(log(x), log(base));
        }
    });
    return log;
});

});

parcelRegister("AdJT9", function(module, exports) {

$parcel$export(module.exports, "createLog10", function () { return $06ce0536e666e8aa$export$dea4efeb24d4590d; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");

var $6fCew = parcelRequire("6fCew");
var $06ce0536e666e8aa$var$name = "log10";
var $06ce0536e666e8aa$var$dependencies = [
    "typed",
    "config",
    "Complex"
];
var $06ce0536e666e8aa$export$dea4efeb24d4590d = /* #__PURE__ */ (0, $2mPYl.factory)($06ce0536e666e8aa$var$name, $06ce0536e666e8aa$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, _Complex = _ref.Complex;
    /**
   * Calculate the 10-base logarithm of a value. This is the same as calculating `log(x, 10)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.log10(x)
   *
   * Examples:
   *
   *    math.log10(0.00001)            // returns -5
   *    math.log10(10000)              // returns 4
   *    math.log(10000) / math.log(10) // returns 4
   *    math.pow(10, 4)                // returns 10000
   *
   * See also:
   *
   *    exp, log, log1p, log2
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            Value for which to calculate the logarithm.
   * @return {number | BigNumber | Complex | Array | Matrix}
   *            Returns the 10-base logarithm of `x`
   */ var log10 = typed($06ce0536e666e8aa$var$name, {
        number: function number(x) {
            if (x >= 0 || config.predictable) return (0, $6fCew.log10Number)(x);
            else // negative value -> complex value computation
            return new _Complex(x, 0).log().div(Math.LN10);
        },
        Complex: function Complex(x) {
            return new _Complex(x).log().div(Math.LN10);
        },
        BigNumber: function BigNumber(x) {
            if (!x.isNegative() || config.predictable) return x.log();
            else // downgrade to number, return Complex valued result
            return new _Complex(x.toNumber(), 0).log().div(Math.LN10);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, log10);
        }
    });
    return log10;
});

});

parcelRegister("81mLS", function(module, exports) {

$parcel$export(module.exports, "createLog1p", function () { return $5d7014a09cca2dbd$export$93da279859a704f0; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");

var $kFRKb = parcelRequire("kFRKb");
var $5d7014a09cca2dbd$var$name = "log1p";
var $5d7014a09cca2dbd$var$dependencies = [
    "typed",
    "config",
    "divideScalar",
    "log",
    "Complex"
];
var $5d7014a09cca2dbd$export$93da279859a704f0 = /* #__PURE__ */ (0, $2mPYl.factory)($5d7014a09cca2dbd$var$name, $5d7014a09cca2dbd$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, divideScalar = _ref.divideScalar, log = _ref.log, Complex = _ref.Complex;
    /**
   * Calculate the logarithm of a `value+1`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.log1p(x)
   *    math.log1p(x, base)
   *
   * Examples:
   *
   *    math.log1p(2.5)                 // returns 1.252762968495368
   *    math.exp(math.log1p(1.4))       // returns 2.4
   *
   *    math.pow(10, 4)                 // returns 10000
   *    math.log1p(9999, 10)            // returns 4
   *    math.log1p(9999) / math.log(10) // returns 4
   *
   * See also:
   *
   *    exp, log, log2, log10
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            Value for which to calculate the logarithm of `x+1`.
   * @param {number | BigNumber | Complex} [base=e]
   *            Optional base for the logarithm. If not provided, the natural
   *            logarithm of `x+1` is calculated.
   * @return {number | BigNumber | Complex | Array | Matrix}
   *            Returns the logarithm of `x+1`
   */ var log1p = typed($5d7014a09cca2dbd$var$name, {
        number: function number(x) {
            if (x >= -1 || config.predictable) return (0, $kFRKb.log1p)(x);
            else // negative value -> complex value computation
            return _log1pComplex(new Complex(x, 0));
        },
        Complex: _log1pComplex,
        BigNumber: function BigNumber(x) {
            var y = x.plus(1);
            if (!y.isNegative() || config.predictable) return y.ln();
            else // downgrade to number, return Complex valued result
            return _log1pComplex(new Complex(x.toNumber(), 0));
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, log1p);
        },
        "any, any": function anyAny(x, base) {
            // calculate logarithm for a specified base, log1p(x, base)
            return divideScalar(log1p(x), log(base));
        }
    });
    /**
   * Calculate the natural logarithm of a complex number + 1
   * @param {Complex} x
   * @returns {Complex}
   * @private
   */ function _log1pComplex(x) {
        var xRe1p = x.re + 1;
        return new Complex(Math.log(Math.sqrt(xRe1p * xRe1p + x.im * x.im)), Math.atan2(x.im, xRe1p));
    }
    return log1p;
});

});

parcelRegister("hkSiL", function(module, exports) {

$parcel$export(module.exports, "createLog2", function () { return $c9ee6d147122d780$export$a993dae3988e0f19; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");

var $6fCew = parcelRequire("6fCew");
var $c9ee6d147122d780$var$name = "log2";
var $c9ee6d147122d780$var$dependencies = [
    "typed",
    "config",
    "Complex"
];
var $c9ee6d147122d780$export$a993dae3988e0f19 = /* #__PURE__ */ (0, $2mPYl.factory)($c9ee6d147122d780$var$name, $c9ee6d147122d780$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, Complex = _ref.Complex;
    /**
   * Calculate the 2-base of a value. This is the same as calculating `log(x, 2)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.log2(x)
   *
   * Examples:
   *
   *    math.log2(0.03125)           // returns -5
   *    math.log2(16)                // returns 4
   *    math.log2(16) / math.log2(2) // returns 4
   *    math.pow(2, 4)               // returns 16
   *
   * See also:
   *
   *    exp, log, log1p, log10
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            Value for which to calculate the logarithm.
   * @return {number | BigNumber | Complex | Array | Matrix}
   *            Returns the 2-base logarithm of `x`
   */ var log2 = typed($c9ee6d147122d780$var$name, {
        number: function number(x) {
            if (x >= 0 || config.predictable) return (0, $6fCew.log2Number)(x);
            else // negative value -> complex value computation
            return _log2Complex(new Complex(x, 0));
        },
        Complex: _log2Complex,
        BigNumber: function BigNumber(x) {
            if (!x.isNegative() || config.predictable) return x.log(2);
            else // downgrade to number, return Complex valued result
            return _log2Complex(new Complex(x.toNumber(), 0));
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, log2);
        }
    });
    /**
   * Calculate log2 for a complex value
   * @param {Complex} x
   * @returns {Complex}
   * @private
   */ function _log2Complex(x) {
        var newX = Math.sqrt(x.re * x.re + x.im * x.im);
        return new Complex(Math.log2 ? Math.log2(newX) : Math.log(newX) / Math.LN2, Math.atan2(x.im, x.re) / Math.LN2);
    }
    return log2;
});

});

parcelRegister("kiDwM", function(module, exports) {

$parcel$export(module.exports, "createLsolve", function () { return $ec742671e9d8df78$export$1b88d04961967a10; });

var $2mPYl = parcelRequire("2mPYl");

var $9AqV5 = parcelRequire("9AqV5");
var $ec742671e9d8df78$var$name = "lsolve";
var $ec742671e9d8df78$var$dependencies = [
    "typed",
    "matrix",
    "divideScalar",
    "multiplyScalar",
    "subtract",
    "equalScalar",
    "DenseMatrix"
];
var $ec742671e9d8df78$export$1b88d04961967a10 = /* #__PURE__ */ (0, $2mPYl.factory)($ec742671e9d8df78$var$name, $ec742671e9d8df78$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, divideScalar = _ref.divideScalar, multiplyScalar = _ref.multiplyScalar, subtract = _ref.subtract, equalScalar = _ref.equalScalar, DenseMatrix = _ref.DenseMatrix;
    var solveValidation = (0, $9AqV5.createSolveValidation)({
        DenseMatrix: DenseMatrix
    });
    /**
   * Solves the linear equation system by forwards substitution. Matrix must be a lower triangular matrix.
   *
   * `L * x = b`
   *
   * Syntax:
   *
   *    math.lsolve(L, b)
   *
   * Examples:
   *
   *    const a = [[-2, 3], [2, 1]]
   *    const b = [11, 9]
   *    const x = lsolve(a, b)  // [[-5.5], [20]]
   *
   * See also:
   *
   *    lup, slu, usolve, lusolve
   *
   * @param {Matrix, Array} L       A N x N matrix or array (L)
   * @param {Matrix, Array} b       A column vector with the b values
   *
   * @return {DenseMatrix | Array}  A column vector with the linear system solution (x)
   */ return typed($ec742671e9d8df78$var$name, {
        "SparseMatrix, Array | Matrix": function SparseMatrixArrayMatrix(m, b) {
            // process matrix
            return _sparseForwardSubstitution(m, b);
        },
        "DenseMatrix, Array | Matrix": function DenseMatrixArrayMatrix(m, b) {
            // process matrix
            return _denseForwardSubstitution(m, b);
        },
        "Array, Array | Matrix": function ArrayArrayMatrix(a, b) {
            // create dense matrix from array
            var m = matrix(a); // use matrix implementation
            var r = _denseForwardSubstitution(m, b); // result
            return r.valueOf();
        }
    });
    function _denseForwardSubstitution(m, b) {
        // validate matrix and vector, return copy of column vector b
        b = solveValidation(m, b, true); // column vector data
        var bdata = b._data; // rows & columns
        var rows = m._size[0];
        var columns = m._size[1]; // result
        var x = []; // data
        var data = m._data; // forward solve m * x = b, loop columns
        for(var j = 0; j < columns; j++){
            // b[j]
            var bj = bdata[j][0] || 0; // x[j]
            var xj = void 0; // forward substitution (outer product) avoids inner looping when bj === 0
            if (!equalScalar(bj, 0)) {
                // value @ [j, j]
                var vjj = data[j][j]; // check vjj
                if (equalScalar(vjj, 0)) // system cannot be solved
                throw new Error("Linear system cannot be solved since matrix is singular");
                 // calculate xj
                xj = divideScalar(bj, vjj); // loop rows
                for(var i = j + 1; i < rows; i++)// update copy of b
                bdata[i] = [
                    subtract(bdata[i][0] || 0, multiplyScalar(xj, data[i][j]))
                ];
            } else // zero @ j
            xj = 0;
             // update x
            x[j] = [
                xj
            ];
        } // return vector
        return new DenseMatrix({
            data: x,
            size: [
                rows,
                1
            ]
        });
    }
    function _sparseForwardSubstitution(m, b) {
        // validate matrix and vector, return copy of column vector b
        b = solveValidation(m, b, true); // column vector data
        var bdata = b._data; // rows & columns
        var rows = m._size[0];
        var columns = m._size[1]; // matrix arrays
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr; // vars
        var i, k; // result
        var x = []; // forward solve m * x = b, loop columns
        for(var j = 0; j < columns; j++){
            // b[j]
            var bj = bdata[j][0] || 0; // forward substitution (outer product) avoids inner looping when bj === 0
            if (!equalScalar(bj, 0)) {
                // value @ [j, j]
                var vjj = 0; // lower triangular matrix values & index (column j)
                var jvalues = [];
                var jindex = []; // last index in column
                var l = ptr[j + 1]; // values in column, find value @ [j, j]
                for(k = ptr[j]; k < l; k++){
                    // row
                    i = index[k]; // check row (rows are not sorted!)
                    if (i === j) // update vjj
                    vjj = values[k];
                    else if (i > j) {
                        // store lower triangular
                        jvalues.push(values[k]);
                        jindex.push(i);
                    }
                } // at this point we must have a value @ [j, j]
                if (equalScalar(vjj, 0)) // system cannot be solved, there is no value @ [j, j]
                throw new Error("Linear system cannot be solved since matrix is singular");
                 // calculate xj
                var xj = divideScalar(bj, vjj); // loop lower triangular
                for(k = 0, l = jindex.length; k < l; k++){
                    // row
                    i = jindex[k]; // update copy of b
                    bdata[i] = [
                        subtract(bdata[i][0] || 0, multiplyScalar(xj, jvalues[k]))
                    ];
                } // update x
                x[j] = [
                    xj
                ];
            } else // update x
            x[j] = [
                0
            ];
        } // return vector
        return new DenseMatrix({
            data: x,
            size: [
                rows,
                1
            ]
        });
    }
});

});
parcelRegister("9AqV5", function(module, exports) {

$parcel$export(module.exports, "createSolveValidation", function () { return $6fac5b8de54388cf$export$6accbcba5dda801d; });

var $1amHZ = parcelRequire("1amHZ");

var $5WdrK = parcelRequire("5WdrK");

var $6NxuJ = parcelRequire("6NxuJ");
function $6fac5b8de54388cf$export$6accbcba5dda801d(_ref) {
    var DenseMatrix = _ref.DenseMatrix;
    /**
   * Validates matrix and column vector b for backward/forward substitution algorithms.
   *
   * @param {Matrix} m            An N x N matrix
   * @param {Array | Matrix} b    A column vector
   * @param {Boolean} copy        Return a copy of vector b
   *
   * @return {DenseMatrix}        Dense column vector b
   */ return function solveValidation(m, b, copy) {
        // matrix size
        var size = m.size(); // validate matrix dimensions
        if (size.length !== 2) throw new RangeError("Matrix must be two dimensional (size: " + (0, $6NxuJ.format)(size) + ")");
         // rows & columns
        var rows = size[0];
        var columns = size[1]; // validate rows & columns
        if (rows !== columns) throw new RangeError("Matrix must be square (size: " + (0, $6NxuJ.format)(size) + ")");
         // vars
        var data, i, bdata; // check b is matrix
        if ((0, $1amHZ.isMatrix)(b)) {
            // matrix size
            var msize = b.size(); // vector
            if (msize.length === 1) {
                // check vector length
                if (msize[0] !== rows) throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
                 // create data array
                data = []; // matrix data (DenseMatrix)
                bdata = b._data; // loop b data
                for(i = 0; i < rows; i++)// row array
                data[i] = [
                    bdata[i]
                ];
                 // return Dense Matrix
                return new DenseMatrix({
                    data: data,
                    size: [
                        rows,
                        1
                    ],
                    datatype: b._datatype
                });
            } // two dimensions
            if (msize.length === 2) {
                // array must be a column vector
                if (msize[0] !== rows || msize[1] !== 1) throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
                 // check matrix type
                if ((0, $1amHZ.isDenseMatrix)(b)) {
                    // check a copy is needed
                    if (copy) {
                        // create data array
                        data = []; // matrix data (DenseMatrix)
                        bdata = b._data; // loop b data
                        for(i = 0; i < rows; i++)// row array
                        data[i] = [
                            bdata[i][0]
                        ];
                         // return Dense Matrix
                        return new DenseMatrix({
                            data: data,
                            size: [
                                rows,
                                1
                            ],
                            datatype: b._datatype
                        });
                    } // b is already a column vector
                    return b;
                } // create data array
                data = [];
                for(i = 0; i < rows; i++)data[i] = [
                    0
                ];
                 // sparse matrix arrays
                var values = b._values;
                var index = b._index;
                var ptr = b._ptr; // loop values in column 0
                for(var k1 = ptr[1], k = ptr[0]; k < k1; k++){
                    // row
                    i = index[k]; // add to data
                    data[i][0] = values[k];
                } // return Dense Matrix
                return new DenseMatrix({
                    data: data,
                    size: [
                        rows,
                        1
                    ],
                    datatype: b._datatype
                });
            } // throw error
            throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
        } // check b is array
        if ((0, $1amHZ.isArray)(b)) {
            // size
            var asize = (0, $5WdrK.arraySize)(b); // check matrix dimensions, vector
            if (asize.length === 1) {
                // check vector length
                if (asize[0] !== rows) throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
                 // create data array
                data = []; // loop b
                for(i = 0; i < rows; i++)// row array
                data[i] = [
                    b[i]
                ];
                 // return Dense Matrix
                return new DenseMatrix({
                    data: data,
                    size: [
                        rows,
                        1
                    ]
                });
            }
            if (asize.length === 2) {
                // array must be a column vector
                if (asize[0] !== rows || asize[1] !== 1) throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
                 // create data array
                data = []; // loop b data
                for(i = 0; i < rows; i++)// row array
                data[i] = [
                    b[i][0]
                ];
                 // return Dense Matrix
                return new DenseMatrix({
                    data: data,
                    size: [
                        rows,
                        1
                    ]
                });
            } // throw error
            throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
        }
    };
}

});


parcelRegister("jt5km", function(module, exports) {

$parcel$export(module.exports, "createLup", function () { return $e2c4dbac517e9207$export$86ddf344397699d5; });

var $7ITGG = parcelRequire("7ITGG");

var $2mPYl = parcelRequire("2mPYl");
var $e2c4dbac517e9207$var$name = "lup";
var $e2c4dbac517e9207$var$dependencies = [
    "typed",
    "matrix",
    "abs",
    "addScalar",
    "divideScalar",
    "multiplyScalar",
    "subtract",
    "larger",
    "equalScalar",
    "unaryMinus",
    "DenseMatrix",
    "SparseMatrix",
    "Spa"
];
var $e2c4dbac517e9207$export$86ddf344397699d5 = /* #__PURE__ */ (0, $2mPYl.factory)($e2c4dbac517e9207$var$name, $e2c4dbac517e9207$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, abs = _ref.abs, addScalar = _ref.addScalar, divideScalar = _ref.divideScalar, multiplyScalar = _ref.multiplyScalar, subtract = _ref.subtract, larger = _ref.larger, equalScalar = _ref.equalScalar, unaryMinus = _ref.unaryMinus, DenseMatrix = _ref.DenseMatrix, SparseMatrix = _ref.SparseMatrix, Spa = _ref.Spa;
    /**
   * Calculate the Matrix LU decomposition with partial pivoting. Matrix `A` is decomposed in two matrices (`L`, `U`) and a
   * row permutation vector `p` where `A[p,:] = L * U`
   *
   * Syntax:
   *
   *    math.lup(A)
   *
   * Example:
   *
   *    const m = [[2, 1], [1, 4]]
   *    const r = math.lup(m)
   *    // r = {
   *    //   L: [[1, 0], [0.5, 1]],
   *    //   U: [[2, 1], [0, 3.5]],
   *    //   P: [0, 1]
   *    // }
   *
   * See also:
   *
   *    slu, lsolve, lusolve, usolve
   *
   * @param {Matrix | Array} A    A two dimensional matrix or array for which to get the LUP decomposition.
   *
   * @return {{L: Array | Matrix, U: Array | Matrix, P: Array.<number>}} The lower triangular matrix, the upper triangular matrix and the permutation matrix.
   */ return typed($e2c4dbac517e9207$var$name, {
        DenseMatrix: function DenseMatrix(m) {
            return _denseLUP(m);
        },
        SparseMatrix: function SparseMatrix(m) {
            return _sparseLUP(m);
        },
        Array: function Array(a) {
            // create dense matrix from array
            var m = matrix(a); // lup, use matrix implementation
            var r = _denseLUP(m); // result
            return {
                L: r.L.valueOf(),
                U: r.U.valueOf(),
                p: r.p
            };
        }
    });
    function _denseLUP(m) {
        // rows & columns
        var rows = m._size[0];
        var columns = m._size[1]; // minimum rows and columns
        var n = Math.min(rows, columns); // matrix array, clone original data
        var data = (0, $7ITGG.clone)(m._data); // l matrix arrays
        var ldata = [];
        var lsize = [
            rows,
            n
        ]; // u matrix arrays
        var udata = [];
        var usize = [
            n,
            columns
        ]; // vars
        var i, j, k; // permutation vector
        var p = [];
        for(i = 0; i < rows; i++)p[i] = i;
         // loop columns
        for(j = 0; j < columns; j++){
            // skip first column in upper triangular matrix
            if (j > 0) // loop rows
            for(i = 0; i < rows; i++){
                // min i,j
                var min = Math.min(i, j); // v[i, j]
                var s = 0; // loop up to min
                for(k = 0; k < min; k++)// s = l[i, k] - data[k, j]
                s = addScalar(s, multiplyScalar(data[i][k], data[k][j]));
                data[i][j] = subtract(data[i][j], s);
            }
             // row with larger value in cvector, row >= j
            var pi = j;
            var pabsv = 0;
            var vjj = 0; // loop rows
            for(i = j; i < rows; i++){
                // data @ i, j
                var v = data[i][j]; // absolute value
                var absv = abs(v); // value is greater than pivote value
                if (larger(absv, pabsv)) {
                    // store row
                    pi = i; // update max value
                    pabsv = absv; // value @ [j, j]
                    vjj = v;
                }
            } // swap rows (j <-> pi)
            if (j !== pi) {
                // swap values j <-> pi in p
                p[j] = [
                    p[pi],
                    p[pi] = p[j]
                ][0]; // swap j <-> pi in data
                DenseMatrix._swapRows(j, pi, data);
            } // check column is in lower triangular matrix
            if (j < rows) // loop rows (lower triangular matrix)
            for(i = j + 1; i < rows; i++){
                // value @ i, j
                var vij = data[i][j];
                if (!equalScalar(vij, 0)) // update data
                data[i][j] = divideScalar(data[i][j], vjj);
            }
        } // loop columns
        for(j = 0; j < columns; j++)// loop rows
        for(i = 0; i < rows; i++){
            // initialize row in arrays
            if (j === 0) {
                // check row exists in upper triangular matrix
                if (i < columns) // U
                udata[i] = [];
                 // L
                ldata[i] = [];
            } // check we are in the upper triangular matrix
            if (i < j) {
                // check row exists in upper triangular matrix
                if (i < columns) // U
                udata[i][j] = data[i][j];
                 // check column exists in lower triangular matrix
                if (j < rows) // L
                ldata[i][j] = 0;
                continue;
            } // diagonal value
            if (i === j) {
                // check row exists in upper triangular matrix
                if (i < columns) // U
                udata[i][j] = data[i][j];
                 // check column exists in lower triangular matrix
                if (j < rows) // L
                ldata[i][j] = 1;
                continue;
            } // check row exists in upper triangular matrix
            if (i < columns) // U
            udata[i][j] = 0;
             // check column exists in lower triangular matrix
            if (j < rows) // L
            ldata[i][j] = data[i][j];
        }
         // l matrix
        var l = new DenseMatrix({
            data: ldata,
            size: lsize
        }); // u matrix
        var u = new DenseMatrix({
            data: udata,
            size: usize
        }); // p vector
        var pv = [];
        for(i = 0, n = p.length; i < n; i++)pv[p[i]] = i;
         // return matrices
        return {
            L: l,
            U: u,
            p: pv,
            toString: function toString() {
                return "L: " + this.L.toString() + "\nU: " + this.U.toString() + "\nP: " + this.p;
            }
        };
    }
    function _sparseLUP(m) {
        // rows & columns
        var rows = m._size[0];
        var columns = m._size[1]; // minimum rows and columns
        var n = Math.min(rows, columns); // matrix arrays (will not be modified, thanks to permutation vector)
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr; // l matrix arrays
        var lvalues = [];
        var lindex = [];
        var lptr = [];
        var lsize = [
            rows,
            n
        ]; // u matrix arrays
        var uvalues = [];
        var uindex = [];
        var uptr = [];
        var usize = [
            n,
            columns
        ]; // vars
        var i, j, k; // permutation vectors, (current index -> original index) and (original index -> current index)
        var pvCo = [];
        var pvOc = [];
        for(i = 0; i < rows; i++){
            pvCo[i] = i;
            pvOc[i] = i;
        } // swap indices in permutation vectors (condition x < y)!
        var swapIndeces = function swapIndeces(x, y) {
            // find pv indeces getting data from x and y
            var kx = pvOc[x];
            var ky = pvOc[y]; // update permutation vector current -> original
            pvCo[kx] = y;
            pvCo[ky] = x; // update permutation vector original -> current
            pvOc[x] = ky;
            pvOc[y] = kx;
        }; // loop columns
        var _loop = function _loop() {
            // sparse accumulator
            var spa = new Spa(); // check lower triangular matrix has a value @ column j
            if (j < rows) {
                // update ptr
                lptr.push(lvalues.length); // first value in j column for lower triangular matrix
                lvalues.push(1);
                lindex.push(j);
            } // update ptr
            uptr.push(uvalues.length); // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = ptr[j];
            var k1 = ptr[j + 1]; // copy column j into sparse accumulator
            for(k = k0; k < k1; k++){
                // row
                i = index[k]; // copy column values into sparse accumulator (use permutation vector)
                spa.set(pvCo[i], values[k]);
            } // skip first column in upper triangular matrix
            if (j > 0) // loop rows in column j (above diagonal)
            spa.forEach(0, j - 1, function(k, vkj) {
                // loop rows in column k (L)
                SparseMatrix._forEachRow(k, lvalues, lindex, lptr, function(i, vik) {
                    // check row is below k
                    if (i > k) // update spa value
                    spa.accumulate(i, unaryMinus(multiplyScalar(vik, vkj)));
                });
            });
             // row with larger value in spa, row >= j
            var pi = j;
            var vjj = spa.get(j);
            var pabsv = abs(vjj); // loop values in spa (order by row, below diagonal)
            spa.forEach(j + 1, rows - 1, function(x, v) {
                // absolute value
                var absv = abs(v); // value is greater than pivote value
                if (larger(absv, pabsv)) {
                    // store row
                    pi = x; // update max value
                    pabsv = absv; // value @ [j, j]
                    vjj = v;
                }
            }); // swap rows (j <-> pi)
            if (j !== pi) {
                // swap values j <-> pi in L
                SparseMatrix._swapRows(j, pi, lsize[1], lvalues, lindex, lptr); // swap values j <-> pi in U
                SparseMatrix._swapRows(j, pi, usize[1], uvalues, uindex, uptr); // swap values in spa
                spa.swap(j, pi); // update permutation vector (swap values @ j, pi)
                swapIndeces(j, pi);
            } // loop values in spa (order by row)
            spa.forEach(0, rows - 1, function(x, v) {
                // check we are above diagonal
                if (x <= j) {
                    // update upper triangular matrix
                    uvalues.push(v);
                    uindex.push(x);
                } else {
                    // update value
                    v = divideScalar(v, vjj); // check value is non zero
                    if (!equalScalar(v, 0)) {
                        // update lower triangular matrix
                        lvalues.push(v);
                        lindex.push(x);
                    }
                }
            });
        };
        for(j = 0; j < columns; j++)_loop();
         // update ptrs
        uptr.push(uvalues.length);
        lptr.push(lvalues.length); // return matrices
        return {
            L: new SparseMatrix({
                values: lvalues,
                index: lindex,
                ptr: lptr,
                size: lsize
            }),
            U: new SparseMatrix({
                values: uvalues,
                index: uindex,
                ptr: uptr,
                size: usize
            }),
            p: pvCo,
            toString: function toString() {
                return "L: " + this.L.toString() + "\nU: " + this.U.toString() + "\nP: " + this.p;
            }
        };
    }
});

});

parcelRegister("lkRnE", function(module, exports) {

$parcel$export(module.exports, "createLusolve", function () { return $f884df80f029d2bb$export$a3f0777edf21dcd5; });

var $1amHZ = parcelRequire("1amHZ");

var $2mPYl = parcelRequire("2mPYl");

var $9AqV5 = parcelRequire("9AqV5");

var $999Uf = parcelRequire("999Uf");
var $f884df80f029d2bb$var$name = "lusolve";
var $f884df80f029d2bb$var$dependencies = [
    "typed",
    "matrix",
    "lup",
    "slu",
    "usolve",
    "lsolve",
    "DenseMatrix"
];
var $f884df80f029d2bb$export$a3f0777edf21dcd5 = /* #__PURE__ */ (0, $2mPYl.factory)($f884df80f029d2bb$var$name, $f884df80f029d2bb$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, lup = _ref.lup, slu = _ref.slu, usolve = _ref.usolve, lsolve = _ref.lsolve, DenseMatrix = _ref.DenseMatrix;
    var solveValidation = (0, $9AqV5.createSolveValidation)({
        DenseMatrix: DenseMatrix
    });
    /**
   * Solves the linear system `A * x = b` where `A` is an [n x n] matrix and `b` is a [n] column vector.
   *
   * Syntax:
   *
   *    math.lusolve(A, b)     // returns column vector with the solution to the linear system A * x = b
   *    math.lusolve(lup, b)   // returns column vector with the solution to the linear system A * x = b, lup = math.lup(A)
   *
   * Examples:
   *
   *    const m = [[1, 0, 0, 0], [0, 2, 0, 0], [0, 0, 3, 0], [0, 0, 0, 4]]
   *
   *    const x = math.lusolve(m, [-1, -1, -1, -1])        // x = [[-1], [-0.5], [-1/3], [-0.25]]
   *
   *    const f = math.lup(m)
   *    const x1 = math.lusolve(f, [-1, -1, -1, -1])       // x1 = [[-1], [-0.5], [-1/3], [-0.25]]
   *    const x2 = math.lusolve(f, [1, 2, 1, -1])          // x2 = [[1], [1], [1/3], [-0.25]]
   *
   *    const a = [[-2, 3], [2, 1]]
   *    const b = [11, 9]
   *    const x = math.lusolve(a, b)  // [[2], [5]]
   *
   * See also:
   *
   *    lup, slu, lsolve, usolve
   *
   * @param {Matrix | Array | Object} A      Invertible Matrix or the Matrix LU decomposition
   * @param {Matrix | Array} b               Column Vector
   * @param {number} [order]                 The Symbolic Ordering and Analysis order, see slu for details. Matrix must be a SparseMatrix
   * @param {Number} [threshold]             Partial pivoting threshold (1 for partial pivoting), see slu for details. Matrix must be a SparseMatrix.
   *
   * @return {DenseMatrix | Array}           Column vector with the solution to the linear system A * x = b
   */ return typed($f884df80f029d2bb$var$name, {
        "Array, Array | Matrix": function ArrayArrayMatrix(a, b) {
            // convert a to matrix
            a = matrix(a); // matrix lup decomposition
            var d = lup(a); // solve
            var x = _lusolve(d.L, d.U, d.p, null, b); // convert result to array
            return x.valueOf();
        },
        "DenseMatrix, Array | Matrix": function DenseMatrixArrayMatrix(a, b) {
            // matrix lup decomposition
            var d = lup(a); // solve
            return _lusolve(d.L, d.U, d.p, null, b);
        },
        "SparseMatrix, Array | Matrix": function SparseMatrixArrayMatrix(a, b) {
            // matrix lup decomposition
            var d = lup(a); // solve
            return _lusolve(d.L, d.U, d.p, null, b);
        },
        "SparseMatrix, Array | Matrix, number, number": function SparseMatrixArrayMatrixNumberNumber(a, b, order, threshold) {
            // matrix lu decomposition
            var d = slu(a, order, threshold); // solve
            return _lusolve(d.L, d.U, d.p, d.q, b);
        },
        "Object, Array | Matrix": function ObjectArrayMatrix(d, b) {
            // solve
            return _lusolve(d.L, d.U, d.p, d.q, b);
        }
    });
    function _toMatrix(a) {
        // check it is a matrix
        if ((0, $1amHZ.isMatrix)(a)) return a;
         // check array
        if ((0, $1amHZ.isArray)(a)) return matrix(a);
         // throw
        throw new TypeError("Invalid Matrix LU decomposition");
    }
    function _lusolve(l, u, p, q, b) {
        // verify L, U, P
        l = _toMatrix(l);
        u = _toMatrix(u); // validate matrix and vector
        b = solveValidation(l, b, false); // apply row permutations if needed (b is a DenseMatrix)
        if (p) b._data = (0, $999Uf.csIpvec)(p, b._data);
         // use forward substitution to resolve L * y = b
        var y = lsolve(l, b); // use backward substitution to resolve U * x = y
        var x = usolve(u, y); // apply column permutations if needed (x is a DenseMatrix)
        if (q) x._data = (0, $999Uf.csIpvec)(q, x._data);
         // return solution
        return x;
    }
});

});
parcelRegister("999Uf", function(module, exports) {

$parcel$export(module.exports, "csIpvec", function () { return $6a8ca37dc39d0c93$export$29cc81cfd083fd62; });
/**
 * Permutes a vector; x = P'b. In MATLAB notation, x(p)=b.
 *
 * @param {Array} p           The permutation vector of length n. null value denotes identity
 * @param {Array} b           The input vector
 *
 * @return {Array}            The output vector x = P'b
 */ function $6a8ca37dc39d0c93$export$29cc81cfd083fd62(p, b) {
    // vars
    var k;
    var n = b.length;
    var x = []; // check permutation vector was provided, p = null denotes identity
    if (p) // loop vector
    for(k = 0; k < n; k++)// apply permutation
    x[p[k]] = b[k];
    else // loop vector
    for(k = 0; k < n; k++)// x[i] = b[i]
    x[k] = b[k];
    return x;
}

});


parcelRegister("13FHT", function(module, exports) {

$parcel$export(module.exports, "createMad", function () { return $0c566c6306ca62a7$export$7b17fbe41c88575a; });

var $5WdrK = parcelRequire("5WdrK");

var $2mPYl = parcelRequire("2mPYl");

var $l16bl = parcelRequire("l16bl");
var $0c566c6306ca62a7$var$name = "mad";
var $0c566c6306ca62a7$var$dependencies = [
    "typed",
    "abs",
    "map",
    "median",
    "subtract"
];
var $0c566c6306ca62a7$export$7b17fbe41c88575a = /* #__PURE__ */ (0, $2mPYl.factory)($0c566c6306ca62a7$var$name, $0c566c6306ca62a7$var$dependencies, function(_ref) {
    var typed = _ref.typed, abs = _ref.abs, map = _ref.map, median = _ref.median, subtract = _ref.subtract;
    /**
   * Compute the median absolute deviation of a matrix or a list with values.
   * The median absolute deviation is defined as the median of the absolute
   * deviations from the median.
   *
   * Syntax:
   *
   *     math.mad(a, b, c, ...)
   *     math.mad(A)
   *
   * Examples:
   *
   *     math.mad(10, 20, 30)             // returns 10
   *     math.mad([1, 2, 3])              // returns 1
   *     math.mad([[1, 2, 3], [4, 5, 6]]) // returns 1.5
   *
   * See also:
   *
   *     median, mean, std, abs
   *
   * @param {Array | Matrix} array
   *                        A single matrix or multiple scalar values.
   * @return {*} The median absolute deviation.
   */ return typed($0c566c6306ca62a7$var$name, {
        // mad([a, b, c, d, ...])
        "Array | Matrix": _mad,
        // mad(a, b, c, d, ...)
        "...": function _(args) {
            return _mad(args);
        }
    });
    function _mad(array) {
        array = (0, $5WdrK.flatten)(array.valueOf());
        if (array.length === 0) throw new Error("Cannot calculate median absolute deviation (mad) of an empty array");
        try {
            var med = median(array);
            return median(map(array, function(value) {
                return abs(subtract(value, med));
            }));
        } catch (err) {
            if (err instanceof TypeError && err.message.indexOf("median") !== -1) throw new TypeError(err.message.replace("median", "mad"));
            else throw (0, $l16bl.improveErrorMessage)(err, "mad");
        }
    }
});

});

parcelRegister("4p0TV", function(module, exports) {

$parcel$export(module.exports, "createMap", function () { return $334a322650e96036$export$d49c9aa30b771d59; });

var $kpJv9 = parcelRequire("kpJv9");

var $2mPYl = parcelRequire("2mPYl");
var $334a322650e96036$var$name = "map";
var $334a322650e96036$var$dependencies = [
    "typed"
];
var $334a322650e96036$export$d49c9aa30b771d59 = /* #__PURE__ */ (0, $2mPYl.factory)($334a322650e96036$var$name, $334a322650e96036$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Create a new matrix or array with the results of the callback function executed on
   * each entry of the matrix/array.
   *
   * Syntax:
   *
   *    math.map(x, callback)
   *
   * Examples:
   *
   *    math.map([1, 2, 3], function(value) {
   *      return value * value
   *    })  // returns [1, 4, 9]
   *
   * See also:
   *
   *    filter, forEach, sort
   *
   * @param {Matrix | Array} x    The matrix to iterate on.
   * @param {Function} callback   The callback method is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the matrix being traversed.
   * @return {Matrix | array}     Transformed map of x
   */ return typed($334a322650e96036$var$name, {
        "Array, function": $334a322650e96036$var$_map,
        "Matrix, function": function MatrixFunction(x, callback) {
            return x.map(callback);
        }
    });
});
/**
 * Map for a multi dimensional array
 * @param {Array} array
 * @param {Function} callback
 * @return {Array}
 * @private
 */ function $334a322650e96036$var$_map(array, callback) {
    // figure out what number of arguments the callback function expects
    var args = (0, $kpJv9.maxArgumentCount)(callback);
    var recurse = function recurse(value, index) {
        if (Array.isArray(value)) return value.map(function(child, i) {
            // we create a copy of the index array and append the new index value
            return recurse(child, index.concat(i));
        });
        else {
            // invoke the callback function with the right number of arguments
            if (args === 1) return callback(value);
            else if (args === 2) return callback(value, index);
            else // 3 or -1
            return callback(value, index, array);
        }
    };
    return recurse(array, []);
}

});

parcelRegister("aHWC7", function(module, exports) {

$parcel$export(module.exports, "createMatrix", function () { return $7cbb62fe623b7e9e$export$f3cf8b510f9cb8ab; });

var $2mPYl = parcelRequire("2mPYl");
var $7cbb62fe623b7e9e$var$name = "matrix";
var $7cbb62fe623b7e9e$var$dependencies = [
    "typed",
    "Matrix",
    "DenseMatrix",
    "SparseMatrix"
];
var $7cbb62fe623b7e9e$export$f3cf8b510f9cb8ab = /* #__PURE__ */ (0, $2mPYl.factory)($7cbb62fe623b7e9e$var$name, $7cbb62fe623b7e9e$var$dependencies, function(_ref) {
    var typed = _ref.typed, Matrix = _ref.Matrix, DenseMatrix = _ref.DenseMatrix, SparseMatrix = _ref.SparseMatrix;
    /**
   * Create a Matrix. The function creates a new `math.Matrix` object from
   * an `Array`. A Matrix has utility functions to manipulate the data in the
   * matrix, like getting the size and getting or setting values in the matrix.
   * Supported storage formats are 'dense' and 'sparse'.
   *
   * Syntax:
   *
   *    math.matrix()                         // creates an empty matrix using default storage format (dense).
   *    math.matrix(data)                     // creates a matrix with initial data using default storage format (dense).
   *    math.matrix('dense')                  // creates an empty matrix using the given storage format.
   *    math.matrix(data, 'dense')            // creates a matrix with initial data using the given storage format.
   *    math.matrix(data, 'sparse')           // creates a sparse matrix with initial data.
   *    math.matrix(data, 'sparse', 'number') // creates a sparse matrix with initial data, number data type.
   *
   * Examples:
   *
   *    let m = math.matrix([[1, 2], [3, 4]])
   *    m.size()                        // Array [2, 2]
   *    m.resize([3, 2], 5)
   *    m.valueOf()                     // Array [[1, 2], [3, 4], [5, 5]]
   *    m.get([1, 0])                    // number 3
   *
   * See also:
   *
   *    bignumber, boolean, complex, index, number, string, unit, sparse
   *
   * @param {Array | Matrix} [data]    A multi dimensional array
   * @param {string} [format]          The Matrix storage format
   *
   * @return {Matrix} The created matrix
   */ return typed($7cbb62fe623b7e9e$var$name, {
        "": function _() {
            return _create([]);
        },
        string: function string(format) {
            return _create([], format);
        },
        "string, string": function stringString(format, datatype) {
            return _create([], format, datatype);
        },
        Array: function Array(data) {
            return _create(data);
        },
        Matrix: function Matrix(data) {
            return _create(data, data.storage());
        },
        "Array | Matrix, string": _create,
        "Array | Matrix, string, string": _create
    });
    /**
   * Create a new Matrix with given storage format
   * @param {Array} data
   * @param {string} [format]
   * @param {string} [datatype]
   * @returns {Matrix} Returns a new Matrix
   * @private
   */ function _create(data, format, datatype) {
        // get storage format constructor
        if (format === "dense" || format === "default" || format === undefined) return new DenseMatrix(data, datatype);
        if (format === "sparse") return new SparseMatrix(data, datatype);
        throw new TypeError("Unknown matrix type " + JSON.stringify(format) + ".");
    }
});

});

parcelRegister("atRDv", function(module, exports) {

$parcel$export(module.exports, "createMatrixClass", function () { return $7a1637d7ee969c88$export$72d485cc3ed6a97a; });

var $2mPYl = parcelRequire("2mPYl");
var $7a1637d7ee969c88$var$name = "Matrix";
var $7a1637d7ee969c88$var$dependencies = [];
var $7a1637d7ee969c88$export$72d485cc3ed6a97a = /* #__PURE__ */ (0, $2mPYl.factory)($7a1637d7ee969c88$var$name, $7a1637d7ee969c88$var$dependencies, function() {
    /**
   * @constructor Matrix
   *
   * A Matrix is a wrapper around an Array. A matrix can hold a multi dimensional
   * array. A matrix can be constructed as:
   *
   *     let matrix = math.matrix(data)
   *
   * Matrix contains the functions to resize, get and set values, get the size,
   * clone the matrix and to convert the matrix to a vector, array, or scalar.
   * Furthermore, one can iterate over the matrix using map and forEach.
   * The internal Array of the Matrix can be accessed using the function valueOf.
   *
   * Example usage:
   *
   *     let matrix = math.matrix([[1, 2], [3, 4]])
   *     matix.size()              // [2, 2]
   *     matrix.resize([3, 2], 5)
   *     matrix.valueOf()          // [[1, 2], [3, 4], [5, 5]]
   *     matrix.subset([1,2])       // 3 (indexes are zero-based)
   *
   */ function Matrix() {
        if (!(this instanceof Matrix)) throw new SyntaxError("Constructor must be called with the new operator");
    }
    /**
   * Attach type information
   */ Matrix.prototype.type = "Matrix";
    Matrix.prototype.isMatrix = true;
    /**
   * Get the Matrix storage constructor for the given format.
   *
   * @param {string} format       The Matrix storage format.
   *
   * @return {Function}           The Matrix storage constructor.
   */ Matrix.storage = function(format) {
        // TODO: deprecated since v6.0.0. Clean up some day
        throw new Error("Matrix.storage is deprecated since v6.0.0. Use the factory function math.matrix instead.");
    };
    /**
   * Get the storage format used by the matrix.
   *
   * Usage:
   *     const format = matrix.storage()   // retrieve storage format
   *
   * @return {string}           The storage format.
   */ Matrix.prototype.storage = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke storage on a Matrix interface");
    };
    /**
   * Get the datatype of the data stored in the matrix.
   *
   * Usage:
   *     const format = matrix.datatype()    // retrieve matrix datatype
   *
   * @return {string}           The datatype.
   */ Matrix.prototype.datatype = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke datatype on a Matrix interface");
    };
    /**
   * Create a new Matrix With the type of the current matrix instance
   * @param {Array | Object} data
   * @param {string} [datatype]
   */ Matrix.prototype.create = function(data, datatype) {
        throw new Error("Cannot invoke create on a Matrix interface");
    };
    /**
   * Get a subset of the matrix, or replace a subset of the matrix.
   *
   * Usage:
   *     const subset = matrix.subset(index)               // retrieve subset
   *     const value = matrix.subset(index, replacement)   // replace subset
   *
   * @param {Index} index
   * @param {Array | Matrix | *} [replacement]
   * @param {*} [defaultValue=0]      Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be filled with zeros.
   */ Matrix.prototype.subset = function(index, replacement, defaultValue) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke subset on a Matrix interface");
    };
    /**
   * Get a single element from the matrix.
   * @param {number[]} index   Zero-based index
   * @return {*} value
   */ Matrix.prototype.get = function(index) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke get on a Matrix interface");
    };
    /**
   * Replace a single element in the matrix.
   * @param {number[]} index   Zero-based index
   * @param {*} value
   * @param {*} [defaultValue]        Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be left undefined.
   * @return {Matrix} self
   */ Matrix.prototype.set = function(index, value, defaultValue) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke set on a Matrix interface");
    };
    /**
   * Resize the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (resize in place).
   *
   * @param {number[]} size           The new size the matrix should have.
   * @param {*} [defaultValue=0]      Default value, filled in on new entries.
   *                                  If not provided, the matrix elements will
   *                                  be filled with zeros.
   * @param {boolean} [copy]          Return a resized copy of the matrix
   *
   * @return {Matrix}                 The resized matrix
   */ Matrix.prototype.resize = function(size, defaultValue) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke resize on a Matrix interface");
    };
    /**
   * Reshape the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (reshape in place).
   *
   * @param {number[]} size           The new size the matrix should have.
   * @param {boolean} [copy]          Return a reshaped copy of the matrix
   *
   * @return {Matrix}                 The reshaped matrix
   */ Matrix.prototype.reshape = function(size, defaultValue) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke reshape on a Matrix interface");
    };
    /**
   * Create a clone of the matrix
   * @return {Matrix} clone
   */ Matrix.prototype.clone = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke clone on a Matrix interface");
    };
    /**
   * Retrieve the size of the matrix.
   * @returns {number[]} size
   */ Matrix.prototype.size = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke size on a Matrix interface");
    };
    /**
   * Create a new matrix with the results of the callback function executed on
   * each entry of the matrix.
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   * @param {boolean} [skipZeros] Invoke callback function for non-zero values only.
   *
   * @return {Matrix} matrix
   */ Matrix.prototype.map = function(callback, skipZeros) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke map on a Matrix interface");
    };
    /**
   * Execute a callback function on each entry of the matrix.
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   */ Matrix.prototype.forEach = function(callback) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke forEach on a Matrix interface");
    };
    /**
   * Create an Array with a copy of the data of the Matrix
   * @returns {Array} array
   */ Matrix.prototype.toArray = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke toArray on a Matrix interface");
    };
    /**
   * Get the primitive value of the Matrix: a multidimensional array
   * @returns {Array} array
   */ Matrix.prototype.valueOf = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke valueOf on a Matrix interface");
    };
    /**
   * Get a string representation of the matrix, with optional formatting options.
   * @param {Object | number | Function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @returns {string} str
   */ Matrix.prototype.format = function(options) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke format on a Matrix interface");
    };
    /**
   * Get a string representation of the matrix
   * @returns {string} str
   */ Matrix.prototype.toString = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke toString on a Matrix interface");
    };
    return Matrix;
}, {
    isClass: true
});

});

parcelRegister("kzEhI", function(module, exports) {

$parcel$export(module.exports, "createMedian", function () { return $efa6533842d92984$export$cdebf3fc89add777; });

var $e04i1 = parcelRequire("e04i1");

var $5WdrK = parcelRequire("5WdrK");

var $2mPYl = parcelRequire("2mPYl");

var $l16bl = parcelRequire("l16bl");
var $efa6533842d92984$var$name = "median";
var $efa6533842d92984$var$dependencies = [
    "typed",
    "add",
    "divide",
    "compare",
    "partitionSelect"
];
var $efa6533842d92984$export$cdebf3fc89add777 = /* #__PURE__ */ (0, $2mPYl.factory)($efa6533842d92984$var$name, $efa6533842d92984$var$dependencies, function(_ref) {
    var typed = _ref.typed, add = _ref.add, divide = _ref.divide, compare = _ref.compare, partitionSelect = _ref.partitionSelect;
    /**
   * Compute the median of a matrix or a list with values. The values are
   * sorted and the middle value is returned. In case of an even number of
   * values, the average of the two middle values is returned.
   * Supported types of values are: Number, BigNumber, Unit
   *
   * In case of a (multi dimensional) array or matrix, the median of all
   * elements will be calculated.
   *
   * Syntax:
   *
   *     math.median(a, b, c, ...)
   *     math.median(A)
   *
   * Examples:
   *
   *     math.median(5, 2, 7)        // returns 5
   *     math.median([3, -1, 5, 7])  // returns 4
   *
   * See also:
   *
   *     mean, min, max, sum, prod, std, variance, quantileSeq
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The median
   */ var median = typed($efa6533842d92984$var$name, {
        // median([a, b, c, d, ...])
        "Array | Matrix": _median,
        // median([a, b, c, d, ...], dim)
        "Array | Matrix, number | BigNumber": function ArrayMatrixNumberBigNumber(array, dim) {
            // TODO: implement median(A, dim)
            throw new Error("median(A, dim) is not yet supported"); // return reduce(arguments[0], arguments[1], ...)
        },
        // median(a, b, c, d, ...)
        "...": function _(args) {
            if ((0, $e04i1.containsCollections)(args)) throw new TypeError("Scalar values expected in function median");
            return _median(args);
        }
    });
    /**
   * Recursively calculate the median of an n-dimensional array
   * @param {Array} array
   * @return {Number} median
   * @private
   */ function _median(array) {
        try {
            array = (0, $5WdrK.flatten)(array.valueOf());
            var num = array.length;
            if (num === 0) throw new Error("Cannot calculate median of an empty array");
            if (num % 2 === 0) {
                // even: return the average of the two middle values
                var mid = num / 2 - 1;
                var right = partitionSelect(array, mid + 1); // array now partitioned at mid + 1, take max of left part
                var left = array[mid];
                for(var i = 0; i < mid; ++i)if (compare(array[i], left) > 0) left = array[i];
                return middle2(left, right);
            } else {
                // odd: return the middle value
                var m = partitionSelect(array, (num - 1) / 2);
                return middle(m);
            }
        } catch (err) {
            throw (0, $l16bl.improveErrorMessage)(err, "median");
        }
    } // helper function to type check the middle value of the array
    var middle = typed({
        "number | BigNumber | Complex | Unit": function numberBigNumberComplexUnit(value) {
            return value;
        }
    }); // helper function to type check the two middle value of the array
    var middle2 = typed({
        "number | BigNumber | Complex | Unit, number | BigNumber | Complex | Unit": function numberBigNumberComplexUnitNumberBigNumberComplexUnit(left, right) {
            return divide(add(left, right), 2);
        }
    });
    return median;
});

});

parcelRegister("khtXV", function(module, exports) {

$parcel$export(module.exports, "createMod", function () { return $ec3ca3b47ef17564$export$735bb6c30160c058; });

var $2mPYl = parcelRequire("2mPYl");

var $cITNv = parcelRequire("cITNv");

var $jaKH8 = parcelRequire("jaKH8");

var $6XnjD = parcelRequire("6XnjD");

var $cZfrH = parcelRequire("cZfrH");

var $dNuvz = parcelRequire("dNuvz");

var $1bBLS = parcelRequire("1bBLS");

var $iHnaT = parcelRequire("iHnaT");

var $6fCew = parcelRequire("6fCew");
var $ec3ca3b47ef17564$var$name = "mod";
var $ec3ca3b47ef17564$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "DenseMatrix"
];
var $ec3ca3b47ef17564$export$735bb6c30160c058 = /* #__PURE__ */ (0, $2mPYl.factory)($ec3ca3b47ef17564$var$name, $ec3ca3b47ef17564$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, equalScalar = _ref.equalScalar, DenseMatrix = _ref.DenseMatrix;
    var algorithm02 = (0, $cITNv.createAlgorithm02)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm03 = (0, $jaKH8.createAlgorithm03)({
        typed: typed
    });
    var algorithm05 = (0, $6XnjD.createAlgorithm05)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm11 = (0, $cZfrH.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm12 = (0, $dNuvz.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $1bBLS.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $iHnaT.createAlgorithm14)({
        typed: typed
    });
    /**
   * Calculates the modulus, the remainder of an integer division.
   *
   * For matrices, the function is evaluated element wise.
   *
   * The modulus is defined as:
   *
   *     x - y * floor(x / y)
   *
   * See https://en.wikipedia.org/wiki/Modulo_operation.
   *
   * Syntax:
   *
   *    math.mod(x, y)
   *
   * Examples:
   *
   *    math.mod(8, 3)                // returns 2
   *    math.mod(11, 2)               // returns 1
   *
   *    function isOdd(x) {
   *      return math.mod(x, 2) != 0
   *    }
   *
   *    isOdd(2)                      // returns false
   *    isOdd(3)                      // returns true
   *
   * See also:
   *
   *    divide
   *
   * @param  {number | BigNumber | Fraction | Array | Matrix} x Dividend
   * @param  {number | BigNumber | Fraction | Array | Matrix} y Divisor
   * @return {number | BigNumber | Fraction | Array | Matrix} Returns the remainder of `x` divided by `y`.
   */ var mod = typed($ec3ca3b47ef17564$var$name, {
        "number, number": (0, $6fCew.modNumber),
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return y.isZero() ? x : x.mod(y);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.mod(y);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm05(x, y, mod, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, mod, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, mod, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, mod);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return mod(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return mod(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return mod(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm11(x, y, mod, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, mod, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, mod, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, mod, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, mod, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, mod, true).valueOf();
        }
    });
    return mod;
});

});

parcelRegister("cYqrK", function(module, exports) {

$parcel$export(module.exports, "createMode", function () { return $971f9a6281957ed5$export$822530980ba269d9; });

var $5WdrK = parcelRequire("5WdrK");

var $2mPYl = parcelRequire("2mPYl");
var $971f9a6281957ed5$var$name = "mode";
var $971f9a6281957ed5$var$dependencies = [
    "typed",
    "isNaN",
    "isNumeric"
];
var $971f9a6281957ed5$export$822530980ba269d9 = /* #__PURE__ */ (0, $2mPYl.factory)($971f9a6281957ed5$var$name, $971f9a6281957ed5$var$dependencies, function(_ref) {
    var typed = _ref.typed, isNaN = _ref.isNaN, isNumeric = _ref.isNumeric;
    /**
  * Computes the mode of a set of numbers or a list with values(numbers or characters).
  * If there are more than one modes, it returns a list of those values.
  *
  * Syntax:
  *
  *     math.mode(a, b, c, ...)
  *     math.mode(A)
  *
  * Examples:
  *
  *     math.mode(2, 1, 4, 3, 1)                            // returns [1]
  *     math.mode([1, 2.7, 3.2, 4, 2.7])                    // returns [2.7]
  *     math.mode(1, 4, 6, 1, 6)                             // returns [1, 6]
  *     math.mode('a','a','b','c')                           // returns ["a"]
  *     math.mode(1, 1.5, 'abc')                             // returns [1, 1.5, "abc"]
  *
  * See also:
  *
  *     median,
  *     mean
  *
  * @param {... *} args  A single matrix
  * @return {*} The mode of all values
  */ return typed($971f9a6281957ed5$var$name, {
        "Array | Matrix": _mode,
        "...": function _(args) {
            return _mode(args);
        }
    });
    /**
   * Calculates the mode in an 1-dimensional array
   * @param {Array} values
   * @return {Array} mode
   * @private
   */ function _mode(values) {
        values = (0, $5WdrK.flatten)(values.valueOf());
        var num = values.length;
        if (num === 0) throw new Error("Cannot calculate mode of an empty array");
        var count = {};
        var mode = [];
        var max = 0;
        for(var i = 0; i < values.length; i++){
            var value = values[i];
            if (isNumeric(value) && isNaN(value)) throw new Error("Cannot calculate mode of an array containing NaN values");
            if (!(value in count)) count[value] = 0;
            count[value]++;
            if (count[value] === max) mode.push(value);
            else if (count[value] > max) {
                max = count[value];
                mode = [
                    value
                ];
            }
        }
        return mode;
    }
});

});

parcelRegister("hzPWT", function(module, exports) {

$parcel$export(module.exports, "createMultinomial", function () { return $ccbe007ed8048c46$export$b15aee1001d110; });

var $e04i1 = parcelRequire("e04i1");

var $2mPYl = parcelRequire("2mPYl");
var $ccbe007ed8048c46$var$name = "multinomial";
var $ccbe007ed8048c46$var$dependencies = [
    "typed",
    "add",
    "divide",
    "multiply",
    "factorial",
    "isInteger",
    "isPositive"
];
var $ccbe007ed8048c46$export$b15aee1001d110 = /* #__PURE__ */ (0, $2mPYl.factory)($ccbe007ed8048c46$var$name, $ccbe007ed8048c46$var$dependencies, function(_ref) {
    var typed = _ref.typed, add = _ref.add, divide = _ref.divide, multiply = _ref.multiply, factorial = _ref.factorial, isInteger = _ref.isInteger, isPositive = _ref.isPositive;
    /**
   * Multinomial Coefficients compute the number of ways of picking a1, a2, ..., ai unordered outcomes from `n` possibilities.
   *
   * multinomial takes one array of integers as an argument.
   * The following condition must be enforced: every ai <= 0
   *
   * Syntax:
   *
   *     math.multinomial(a) // a is an array type
   *
   * Examples:
   *
   *    math.multinomial([1,2,1]) // returns 12
   *
   * See also:
   *
   *    combinations, factorial
   *
   * @param {number[] | BigNumber[]} a    Integer numbers of objects in the subset
   * @return {Number | BigNumber}         Multinomial coefficient.
   */ return typed($ccbe007ed8048c46$var$name, {
        "Array | Matrix": function ArrayMatrix(a) {
            var sum = 0;
            var denom = 1;
            (0, $e04i1.deepForEach)(a, function(ai) {
                if (!isInteger(ai) || !isPositive(ai)) throw new TypeError("Positive integer value expected in function multinomial");
                sum = add(sum, ai);
                denom = multiply(denom, factorial(ai));
            });
            return divide(factorial(sum), denom);
        }
    });
});

});

parcelRegister("k3AOO", function(module, exports) {

$parcel$export(module.exports, "createMultiply", function () { return $e9a0a5d52061b647$export$86d08fd318fa07c8; });

var $2mPYl = parcelRequire("2mPYl");

var $1amHZ = parcelRequire("1amHZ");

var $7ITGG = parcelRequire("7ITGG");

var $5WdrK = parcelRequire("5WdrK");

var $cZfrH = parcelRequire("cZfrH");

var $iHnaT = parcelRequire("iHnaT");
var $e9a0a5d52061b647$var$name = "multiply";
var $e9a0a5d52061b647$var$dependencies = [
    "typed",
    "matrix",
    "addScalar",
    "multiplyScalar",
    "equalScalar"
];
var $e9a0a5d52061b647$export$86d08fd318fa07c8 = /* #__PURE__ */ (0, $2mPYl.factory)($e9a0a5d52061b647$var$name, $e9a0a5d52061b647$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, addScalar = _ref.addScalar, multiplyScalar = _ref.multiplyScalar, equalScalar = _ref.equalScalar;
    var algorithm11 = (0, $cZfrH.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm14 = (0, $iHnaT.createAlgorithm14)({
        typed: typed
    });
    /**
   * Multiply two or more values, `x * y`.
   * For matrices, the matrix product is calculated.
   *
   * Syntax:
   *
   *    math.multiply(x, y)
   *    math.multiply(x, y, z, ...)
   *
   * Examples:
   *
   *    math.multiply(4, 5.2)        // returns number 20.8
   *    math.multiply(2, 3, 4)       // returns number 24
   *
   *    const a = math.complex(2, 3)
   *    const b = math.complex(4, 1)
   *    math.multiply(a, b)          // returns Complex 5 + 14i
   *
   *    const c = [[1, 2], [4, 3]]
   *    const d = [[1, 2, 3], [3, -4, 7]]
   *    math.multiply(c, d)          // returns Array [[7, -6, 17], [13, -4, 33]]
   *
   *    const e = math.unit('2.1 km')
   *    math.multiply(3, e)          // returns Unit 6.3 km
   *
   * See also:
   *
   *    divide, prod, cross, dot
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x First value to multiply
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Second value to multiply
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} Multiplication of `x` and `y`
   */ var multiply = typed($e9a0a5d52061b647$var$name, (0, $7ITGG.extend)({
        // we extend the signatures of multiplyScalar with signatures dealing with matrices
        "Array, Array": function ArrayArray(x, y) {
            // check dimensions
            _validateMatrixDimensions((0, $5WdrK.arraySize)(x), (0, $5WdrK.arraySize)(y)); // use dense matrix implementation
            var m = multiply(matrix(x), matrix(y)); // return array or scalar
            return (0, $1amHZ.isMatrix)(m) ? m.valueOf() : m;
        },
        "Matrix, Matrix": function MatrixMatrix(x, y) {
            // dimensions
            var xsize = x.size();
            var ysize = y.size(); // check dimensions
            _validateMatrixDimensions(xsize, ysize); // process dimensions
            if (xsize.length === 1) {
                // process y dimensions
                if (ysize.length === 1) // Vector * Vector
                return _multiplyVectorVector(x, y, xsize[0]);
                 // Vector * Matrix
                return _multiplyVectorMatrix(x, y);
            } // process y dimensions
            if (ysize.length === 1) // Matrix * Vector
            return _multiplyMatrixVector(x, y);
             // Matrix * Matrix
            return _multiplyMatrixMatrix(x, y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use Matrix * Matrix implementation
            return multiply(x, matrix(y));
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use Matrix * Matrix implementation
            return multiply(matrix(x, y.storage()), y);
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm11(x, y, multiplyScalar, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, multiplyScalar, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm11(y, x, multiplyScalar, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, multiplyScalar, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, multiplyScalar, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, multiplyScalar, true).valueOf();
        },
        "any, any": multiplyScalar,
        "any, any, ...any": function anyAnyAny(x, y, rest) {
            var result = multiply(x, y);
            for(var i = 0; i < rest.length; i++)result = multiply(result, rest[i]);
            return result;
        }
    }, multiplyScalar.signatures));
    function _validateMatrixDimensions(size1, size2) {
        // check left operand dimensions
        switch(size1.length){
            case 1:
                // check size2
                switch(size2.length){
                    case 1:
                        // Vector x Vector
                        if (size1[0] !== size2[0]) // throw error
                        throw new RangeError("Dimension mismatch in multiplication. Vectors must have the same length");
                        break;
                    case 2:
                        // Vector x Matrix
                        if (size1[0] !== size2[0]) // throw error
                        throw new RangeError("Dimension mismatch in multiplication. Vector length (" + size1[0] + ") must match Matrix rows (" + size2[0] + ")");
                        break;
                    default:
                        throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has " + size2.length + " dimensions)");
                }
                break;
            case 2:
                // check size2
                switch(size2.length){
                    case 1:
                        // Matrix x Vector
                        if (size1[1] !== size2[0]) // throw error
                        throw new RangeError("Dimension mismatch in multiplication. Matrix columns (" + size1[1] + ") must match Vector length (" + size2[0] + ")");
                        break;
                    case 2:
                        // Matrix x Matrix
                        if (size1[1] !== size2[0]) // throw error
                        throw new RangeError("Dimension mismatch in multiplication. Matrix A columns (" + size1[1] + ") must match Matrix B rows (" + size2[0] + ")");
                        break;
                    default:
                        throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has " + size2.length + " dimensions)");
                }
                break;
            default:
                throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix A has " + size1.length + " dimensions)");
        }
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            Dense Vector   (N)
   * @param {Matrix} b            Dense Vector   (N)
   *
   * @return {number}             Scalar value
   */ function _multiplyVectorVector(a, b, n) {
        // check empty vector
        if (n === 0) throw new Error("Cannot multiply two empty vectors");
         // a dense
        var adata = a._data;
        var adt = a._datatype; // b dense
        var bdata = b._data;
        var bdt = b._datatype; // datatype
        var dt; // addScalar signature to use
        var af = addScalar; // multiplyScalar signature to use
        var mf = multiplyScalar; // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string") {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
        } // result (do not initialize it with zero)
        var c = mf(adata[0], bdata[0]); // loop data
        for(var i = 1; i < n; i++)// multiply and accumulate
        c = af(c, mf(adata[i], bdata[i]));
        return c;
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            Dense Vector   (M)
   * @param {Matrix} b            Matrix         (MxN)
   *
   * @return {Matrix}             Dense Vector   (N)
   */ function _multiplyVectorMatrix(a, b) {
        // process storage
        if (b.storage() !== "dense") throw new Error("Support for SparseMatrix not implemented");
        return _multiplyVectorDenseMatrix(a, b);
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            Dense Vector   (M)
   * @param {Matrix} b            Dense Matrix   (MxN)
   *
   * @return {Matrix}             Dense Vector   (N)
   */ function _multiplyVectorDenseMatrix(a, b) {
        // a dense
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype; // b dense
        var bdata = b._data;
        var bsize = b._size;
        var bdt = b._datatype; // rows & columns
        var alength = asize[0];
        var bcolumns = bsize[1]; // datatype
        var dt; // addScalar signature to use
        var af = addScalar; // multiplyScalar signature to use
        var mf = multiplyScalar; // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string") {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
        } // result
        var c = []; // loop matrix columns
        for(var j = 0; j < bcolumns; j++){
            // sum (do not initialize it with zero)
            var sum = mf(adata[0], bdata[0][j]); // loop vector
            for(var i = 1; i < alength; i++)// multiply & accumulate
            sum = af(sum, mf(adata[i], bdata[i][j]));
            c[j] = sum;
        } // return matrix
        return a.createDenseMatrix({
            data: c,
            size: [
                bcolumns
            ],
            datatype: dt
        });
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            Matrix         (MxN)
   * @param {Matrix} b            Dense Vector   (N)
   *
   * @return {Matrix}             Dense Vector   (M)
   */ var _multiplyMatrixVector = typed("_multiplyMatrixVector", {
        "DenseMatrix, any": _multiplyDenseMatrixVector,
        "SparseMatrix, any": _multiplySparseMatrixVector
    });
    /**
   * C = A * B
   *
   * @param {Matrix} a            Matrix         (MxN)
   * @param {Matrix} b            Matrix         (NxC)
   *
   * @return {Matrix}             Matrix         (MxC)
   */ var _multiplyMatrixMatrix = typed("_multiplyMatrixMatrix", {
        "DenseMatrix, DenseMatrix": _multiplyDenseMatrixDenseMatrix,
        "DenseMatrix, SparseMatrix": _multiplyDenseMatrixSparseMatrix,
        "SparseMatrix, DenseMatrix": _multiplySparseMatrixDenseMatrix,
        "SparseMatrix, SparseMatrix": _multiplySparseMatrixSparseMatrix
    });
    /**
   * C = A * B
   *
   * @param {Matrix} a            DenseMatrix  (MxN)
   * @param {Matrix} b            Dense Vector (N)
   *
   * @return {Matrix}             Dense Vector (M)
   */ function _multiplyDenseMatrixVector(a, b) {
        // a dense
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype; // b dense
        var bdata = b._data;
        var bdt = b._datatype; // rows & columns
        var arows = asize[0];
        var acolumns = asize[1]; // datatype
        var dt; // addScalar signature to use
        var af = addScalar; // multiplyScalar signature to use
        var mf = multiplyScalar; // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string") {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
        } // result
        var c = []; // loop matrix a rows
        for(var i = 0; i < arows; i++){
            // current row
            var row = adata[i]; // sum (do not initialize it with zero)
            var sum = mf(row[0], bdata[0]); // loop matrix a columns
            for(var j = 1; j < acolumns; j++)// multiply & accumulate
            sum = af(sum, mf(row[j], bdata[j]));
            c[i] = sum;
        } // return matrix
        return a.createDenseMatrix({
            data: c,
            size: [
                arows
            ],
            datatype: dt
        });
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            DenseMatrix    (MxN)
   * @param {Matrix} b            DenseMatrix    (NxC)
   *
   * @return {Matrix}             DenseMatrix    (MxC)
   */ function _multiplyDenseMatrixDenseMatrix(a, b) {
        // a dense
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype; // b dense
        var bdata = b._data;
        var bsize = b._size;
        var bdt = b._datatype; // rows & columns
        var arows = asize[0];
        var acolumns = asize[1];
        var bcolumns = bsize[1]; // datatype
        var dt; // addScalar signature to use
        var af = addScalar; // multiplyScalar signature to use
        var mf = multiplyScalar; // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string") {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
        } // result
        var c = []; // loop matrix a rows
        for(var i = 0; i < arows; i++){
            // current row
            var row = adata[i]; // initialize row array
            c[i] = []; // loop matrix b columns
            for(var j = 0; j < bcolumns; j++){
                // sum (avoid initializing sum to zero)
                var sum = mf(row[0], bdata[0][j]); // loop matrix a columns
                for(var x = 1; x < acolumns; x++)// multiply & accumulate
                sum = af(sum, mf(row[x], bdata[x][j]));
                c[i][j] = sum;
            }
        } // return matrix
        return a.createDenseMatrix({
            data: c,
            size: [
                arows,
                bcolumns
            ],
            datatype: dt
        });
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            DenseMatrix    (MxN)
   * @param {Matrix} b            SparseMatrix   (NxC)
   *
   * @return {Matrix}             SparseMatrix   (MxC)
   */ function _multiplyDenseMatrixSparseMatrix(a, b) {
        // a dense
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype; // b sparse
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bsize = b._size;
        var bdt = b._datatype; // validate b matrix
        if (!bvalues) throw new Error("Cannot multiply Dense Matrix times Pattern only Matrix");
         // rows & columns
        var arows = asize[0];
        var bcolumns = bsize[1]; // datatype
        var dt; // addScalar signature to use
        var af = addScalar; // multiplyScalar signature to use
        var mf = multiplyScalar; // equalScalar signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string") {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt);
        } // result
        var cvalues = [];
        var cindex = [];
        var cptr = []; // c matrix
        var c = b.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                arows,
                bcolumns
            ],
            datatype: dt
        }); // loop b columns
        for(var jb = 0; jb < bcolumns; jb++){
            // update ptr
            cptr[jb] = cindex.length; // indeces in column jb
            var kb0 = bptr[jb];
            var kb1 = bptr[jb + 1]; // do not process column jb if no data exists
            if (kb1 > kb0) {
                // last row mark processed
                var last = 0; // loop a rows
                for(var i = 0; i < arows; i++){
                    // column mark
                    var mark = i + 1; // C[i, jb]
                    var cij = void 0; // values in b column j
                    for(var kb = kb0; kb < kb1; kb++){
                        // row
                        var ib = bindex[kb]; // check value has been initialized
                        if (last !== mark) {
                            // first value in column jb
                            cij = mf(adata[i][ib], bvalues[kb]); // update mark
                            last = mark;
                        } else // accumulate value
                        cij = af(cij, mf(adata[i][ib], bvalues[kb]));
                    } // check column has been processed and value != 0
                    if (last === mark && !eq(cij, zero)) {
                        // push row & value
                        cindex.push(i);
                        cvalues.push(cij);
                    }
                }
            }
        } // update ptr
        cptr[bcolumns] = cindex.length; // return sparse matrix
        return c;
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            SparseMatrix    (MxN)
   * @param {Matrix} b            Dense Vector (N)
   *
   * @return {Matrix}             SparseMatrix    (M, 1)
   */ function _multiplySparseMatrixVector(a, b) {
        // a sparse
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var adt = a._datatype; // validate a matrix
        if (!avalues) throw new Error("Cannot multiply Pattern only Matrix times Dense Matrix");
         // b dense
        var bdata = b._data;
        var bdt = b._datatype; // rows & columns
        var arows = a._size[0];
        var brows = b._size[0]; // result
        var cvalues = [];
        var cindex = [];
        var cptr = []; // datatype
        var dt; // addScalar signature to use
        var af = addScalar; // multiplyScalar signature to use
        var mf = multiplyScalar; // equalScalar signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string") {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt);
        } // workspace
        var x = []; // vector with marks indicating a value x[i] exists in a given column
        var w = []; // update ptr
        cptr[0] = 0; // rows in b
        for(var ib = 0; ib < brows; ib++){
            // b[ib]
            var vbi = bdata[ib]; // check b[ib] != 0, avoid loops
            if (!eq(vbi, zero)) // A values & index in ib column
            for(var ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++){
                // a row
                var ia = aindex[ka]; // check value exists in current j
                if (!w[ia]) {
                    // ia is new entry in j
                    w[ia] = true; // add i to pattern of C
                    cindex.push(ia); // x(ia) = A
                    x[ia] = mf(vbi, avalues[ka]);
                } else // i exists in C already
                x[ia] = af(x[ia], mf(vbi, avalues[ka]));
            }
        } // copy values from x to column jb of c
        for(var p1 = cindex.length, p = 0; p < p1; p++){
            // row
            var ic = cindex[p]; // copy value
            cvalues[p] = x[ic];
        } // update ptr
        cptr[1] = cindex.length; // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                arows,
                1
            ],
            datatype: dt
        });
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            SparseMatrix      (MxN)
   * @param {Matrix} b            DenseMatrix       (NxC)
   *
   * @return {Matrix}             SparseMatrix      (MxC)
   */ function _multiplySparseMatrixDenseMatrix(a, b) {
        // a sparse
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var adt = a._datatype; // validate a matrix
        if (!avalues) throw new Error("Cannot multiply Pattern only Matrix times Dense Matrix");
         // b dense
        var bdata = b._data;
        var bdt = b._datatype; // rows & columns
        var arows = a._size[0];
        var brows = b._size[0];
        var bcolumns = b._size[1]; // datatype
        var dt; // addScalar signature to use
        var af = addScalar; // multiplyScalar signature to use
        var mf = multiplyScalar; // equalScalar signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string") {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt);
        } // result
        var cvalues = [];
        var cindex = [];
        var cptr = []; // c matrix
        var c = a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                arows,
                bcolumns
            ],
            datatype: dt
        }); // workspace
        var x = []; // vector with marks indicating a value x[i] exists in a given column
        var w = []; // loop b columns
        for(var jb = 0; jb < bcolumns; jb++){
            // update ptr
            cptr[jb] = cindex.length; // mark in workspace for current column
            var mark = jb + 1; // rows in jb
            for(var ib = 0; ib < brows; ib++){
                // b[ib, jb]
                var vbij = bdata[ib][jb]; // check b[ib, jb] != 0, avoid loops
                if (!eq(vbij, zero)) // A values & index in ib column
                for(var ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++){
                    // a row
                    var ia = aindex[ka]; // check value exists in current j
                    if (w[ia] !== mark) {
                        // ia is new entry in j
                        w[ia] = mark; // add i to pattern of C
                        cindex.push(ia); // x(ia) = A
                        x[ia] = mf(vbij, avalues[ka]);
                    } else // i exists in C already
                    x[ia] = af(x[ia], mf(vbij, avalues[ka]));
                }
            } // copy values from x to column jb of c
            for(var p0 = cptr[jb], p1 = cindex.length, p = p0; p < p1; p++){
                // row
                var ic = cindex[p]; // copy value
                cvalues[p] = x[ic];
            }
        } // update ptr
        cptr[bcolumns] = cindex.length; // return sparse matrix
        return c;
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            SparseMatrix      (MxN)
   * @param {Matrix} b            SparseMatrix      (NxC)
   *
   * @return {Matrix}             SparseMatrix      (MxC)
   */ function _multiplySparseMatrixSparseMatrix(a, b) {
        // a sparse
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var adt = a._datatype; // b sparse
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bdt = b._datatype; // rows & columns
        var arows = a._size[0];
        var bcolumns = b._size[1]; // flag indicating both matrices (a & b) contain data
        var values = avalues && bvalues; // datatype
        var dt; // addScalar signature to use
        var af = addScalar; // multiplyScalar signature to use
        var mf = multiplyScalar; // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string") {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
        } // result
        var cvalues = values ? [] : undefined;
        var cindex = [];
        var cptr = []; // c matrix
        var c = a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                arows,
                bcolumns
            ],
            datatype: dt
        }); // workspace
        var x = values ? [] : undefined; // vector with marks indicating a value x[i] exists in a given column
        var w = []; // variables
        var ka, ka0, ka1, kb, kb0, kb1, ia, ib; // loop b columns
        for(var jb = 0; jb < bcolumns; jb++){
            // update ptr
            cptr[jb] = cindex.length; // mark in workspace for current column
            var mark = jb + 1; // B values & index in j
            for(kb0 = bptr[jb], kb1 = bptr[jb + 1], kb = kb0; kb < kb1; kb++){
                // b row
                ib = bindex[kb]; // check we need to process values
                if (values) // loop values in a[:,ib]
                for(ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++){
                    // row
                    ia = aindex[ka]; // check value exists in current j
                    if (w[ia] !== mark) {
                        // ia is new entry in j
                        w[ia] = mark; // add i to pattern of C
                        cindex.push(ia); // x(ia) = A
                        x[ia] = mf(bvalues[kb], avalues[ka]);
                    } else // i exists in C already
                    x[ia] = af(x[ia], mf(bvalues[kb], avalues[ka]));
                }
                else // loop values in a[:,ib]
                for(ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++){
                    // row
                    ia = aindex[ka]; // check value exists in current j
                    if (w[ia] !== mark) {
                        // ia is new entry in j
                        w[ia] = mark; // add i to pattern of C
                        cindex.push(ia);
                    }
                }
            } // check we need to process matrix values (pattern matrix)
            if (values) // copy values from x to column jb of c
            for(var p0 = cptr[jb], p1 = cindex.length, p = p0; p < p1; p++){
                // row
                var ic = cindex[p]; // copy value
                cvalues[p] = x[ic];
            }
        } // update ptr
        cptr[bcolumns] = cindex.length; // return sparse matrix
        return c;
    }
    return multiply;
});

});

parcelRegister("hsb4M", function(module, exports) {

$parcel$export(module.exports, "createMultiplyScalar", function () { return $cb4da4a8b9bf66fa$export$37dc64d7e8361b32; });

var $2mPYl = parcelRequire("2mPYl");

var $6fCew = parcelRequire("6fCew");
var $cb4da4a8b9bf66fa$var$name = "multiplyScalar";
var $cb4da4a8b9bf66fa$var$dependencies = [
    "typed"
];
var $cb4da4a8b9bf66fa$export$37dc64d7e8361b32 = /* #__PURE__ */ (0, $2mPYl.factory)($cb4da4a8b9bf66fa$var$name, $cb4da4a8b9bf66fa$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Multiply two scalar values, `x * y`.
   * This function is meant for internal use: it is used by the public function
   * `multiply`
   *
   * This function does not support collections (Array or Matrix).
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit} x   First value to multiply
   * @param  {number | BigNumber | Fraction | Complex} y          Second value to multiply
   * @return {number | BigNumber | Fraction | Complex | Unit}     Multiplication of `x` and `y`
   * @private
   */ var multiplyScalar = typed("multiplyScalar", {
        "number, number": (0, $6fCew.multiplyNumber),
        "Complex, Complex": function ComplexComplex(x, y) {
            return x.mul(y);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.times(y);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.mul(y);
        },
        "number | Fraction | BigNumber | Complex, Unit": function numberFractionBigNumberComplexUnit(x, y) {
            var res = y.clone();
            res.value = res.value === null ? res._normalize(x) : multiplyScalar(res.value, x);
            return res;
        },
        "Unit, number | Fraction | BigNumber | Complex": function UnitNumberFractionBigNumberComplex(x, y) {
            var res = x.clone();
            res.value = res.value === null ? res._normalize(y) : multiplyScalar(res.value, y);
            return res;
        },
        "Unit, Unit": function UnitUnit(x, y) {
            return x.multiply(y);
        }
    });
    return multiplyScalar;
});

});

parcelRegister("9KzjP", function(module, exports) {

$parcel$export(module.exports, "createNorm", function () { return $7193ce7dc7a018a5$export$ce85a9d2952c2966; });

var $2mPYl = parcelRequire("2mPYl");
var $7193ce7dc7a018a5$var$name = "norm";
var $7193ce7dc7a018a5$var$dependencies = [
    "typed",
    "abs",
    "add",
    "pow",
    "conj",
    "sqrt",
    "multiply",
    "equalScalar",
    "larger",
    "smaller",
    "matrix"
];
var $7193ce7dc7a018a5$export$ce85a9d2952c2966 = /* #__PURE__ */ (0, $2mPYl.factory)($7193ce7dc7a018a5$var$name, $7193ce7dc7a018a5$var$dependencies, function(_ref) {
    var typed = _ref.typed, abs = _ref.abs, add = _ref.add, pow = _ref.pow, conj = _ref.conj, sqrt = _ref.sqrt, multiply = _ref.multiply, equalScalar = _ref.equalScalar, larger = _ref.larger, smaller = _ref.smaller, matrix = _ref.matrix;
    /**
   * Calculate the norm of a number, vector or matrix.
   *
   * The second parameter p is optional. If not provided, it defaults to 2.
   *
   * Syntax:
   *
   *    math.norm(x)
   *    math.norm(x, p)
   *
   * Examples:
   *
   *    math.abs(-3.5)                         // returns 3.5
   *    math.norm(-3.5)                        // returns 3.5
   *
   *    math.norm(math.complex(3, -4))         // returns 5
   *
   *    math.norm([1, 2, -3], Infinity)        // returns 3
   *    math.norm([1, 2, -3], -Infinity)       // returns 1
   *
   *    math.norm([3, 4], 2)                   // returns 5
   *
   *    math.norm([[1, 2], [3, 4]], 1)          // returns 6
   *    math.norm([[1, 2], [3, 4]], 'inf')     // returns 7
   *    math.norm([[1, 2], [3, 4]], 'fro')     // returns 5.477225575051661
   *
   * See also:
   *
   *    abs, hypot
   *
   * @param  {number | BigNumber | Complex | Array | Matrix} x
   *            Value for which to calculate the norm
   * @param  {number | BigNumber | string} [p=2]
   *            Vector space.
   *            Supported numbers include Infinity and -Infinity.
   *            Supported strings are: 'inf', '-inf', and 'fro' (The Frobenius norm)
   * @return {number | BigNumber} the p-norm
   */ var norm = typed($7193ce7dc7a018a5$var$name, {
        number: Math.abs,
        Complex: function Complex(x) {
            return x.abs();
        },
        BigNumber: function BigNumber(x) {
            // norm(x) = abs(x)
            return x.abs();
        },
        "boolean": function boolean(x) {
            // norm(x) = abs(x)
            return Math.abs(x);
        },
        Array: function Array(x) {
            return _norm(matrix(x), 2);
        },
        Matrix: function Matrix(x) {
            return _norm(x, 2);
        },
        "number | Complex | BigNumber | boolean, number | BigNumber | string": function numberComplexBigNumberBooleanNumberBigNumberString(x) {
            // ignore second parameter, TODO: remove the option of second parameter for these types
            return norm(x);
        },
        "Array, number | BigNumber | string": function ArrayNumberBigNumberString(x, p) {
            return _norm(matrix(x), p);
        },
        "Matrix, number | BigNumber | string": function MatrixNumberBigNumberString(x, p) {
            return _norm(x, p);
        }
    });
    /**
   * Calculate the norm for an array
   * @param {Matrix} x
   * @param {number | string} p
   * @returns {number} Returns the norm
   * @private
   */ function _norm(x, p) {
        // size
        var sizeX = x.size(); // check if it is a vector
        if (sizeX.length === 1) {
            // check p
            if (p === Number.POSITIVE_INFINITY || p === "inf") {
                // norm(x, Infinity) = max(abs(x))
                var pinf = 0; // skip zeros since abs(0) === 0
                x.forEach(function(value) {
                    var v = abs(value);
                    if (larger(v, pinf)) pinf = v;
                }, true);
                return pinf;
            }
            if (p === Number.NEGATIVE_INFINITY || p === "-inf") {
                // norm(x, -Infinity) = min(abs(x))
                var ninf; // skip zeros since abs(0) === 0
                x.forEach(function(value) {
                    var v = abs(value);
                    if (!ninf || smaller(v, ninf)) ninf = v;
                }, true);
                return ninf || 0;
            }
            if (p === "fro") return _norm(x, 2);
            if (typeof p === "number" && !isNaN(p)) {
                // check p != 0
                if (!equalScalar(p, 0)) {
                    // norm(x, p) = sum(abs(xi) ^ p) ^ 1/p
                    var n = 0; // skip zeros since abs(0) === 0
                    x.forEach(function(value) {
                        n = add(pow(abs(value), p), n);
                    }, true);
                    return pow(n, 1 / p);
                }
                return Number.POSITIVE_INFINITY;
            } // invalid parameter value
            throw new Error("Unsupported parameter value");
        } // MxN matrix
        if (sizeX.length === 2) {
            // check p
            if (p === 1) {
                // norm(x) = the largest column sum
                var c = []; // result
                var maxc = 0; // skip zeros since abs(0) == 0
                x.forEach(function(value, index) {
                    var j = index[1];
                    var cj = add(c[j] || 0, abs(value));
                    if (larger(cj, maxc)) maxc = cj;
                    c[j] = cj;
                }, true);
                return maxc;
            }
            if (p === Number.POSITIVE_INFINITY || p === "inf") {
                // norm(x) = the largest row sum
                var r = []; // result
                var maxr = 0; // skip zeros since abs(0) == 0
                x.forEach(function(value, index) {
                    var i = index[0];
                    var ri = add(r[i] || 0, abs(value));
                    if (larger(ri, maxr)) maxr = ri;
                    r[i] = ri;
                }, true);
                return maxr;
            }
            if (p === "fro") {
                // norm(x) = sqrt(sum(diag(x'x)))
                var fro = 0;
                x.forEach(function(value, index) {
                    fro = add(fro, multiply(value, conj(value)));
                });
                return abs(sqrt(fro));
            }
            if (p === 2) // not implemented
            throw new Error("Unsupported parameter value, missing implementation of matrix singular value decomposition");
             // invalid parameter value
            throw new Error("Unsupported parameter value");
        }
    }
    return norm;
});

});

parcelRegister("9LrdT", function(module, exports) {

$parcel$export(module.exports, "createNot", function () { return $71bd9ecd84c3fbdb$export$8dbfb388cd6a8853; });

var $e04i1 = parcelRequire("e04i1");

var $2mPYl = parcelRequire("2mPYl");

var $fAJNv = parcelRequire("fAJNv");
var $71bd9ecd84c3fbdb$var$name = "not";
var $71bd9ecd84c3fbdb$var$dependencies = [
    "typed"
];
var $71bd9ecd84c3fbdb$export$8dbfb388cd6a8853 = /* #__PURE__ */ (0, $2mPYl.factory)($71bd9ecd84c3fbdb$var$name, $71bd9ecd84c3fbdb$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Logical `not`. Flips boolean value of a given parameter.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.not(x)
   *
   * Examples:
   *
   *    math.not(2)      // returns false
   *    math.not(0)      // returns true
   *    math.not(true)   // returns false
   *
   *    a = [2, -7, 0]
   *    math.not(a)      // returns [false, false, true]
   *
   * See also:
   *
   *    and, or, xor
   *
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x First value to check
   * @return {boolean | Array | Matrix}
   *            Returns true when input is a zero or empty value.
   */ var not = typed($71bd9ecd84c3fbdb$var$name, {
        number: (0, $fAJNv.notNumber),
        Complex: function Complex(x) {
            return x.re === 0 && x.im === 0;
        },
        BigNumber: function BigNumber(x) {
            return x.isZero() || x.isNaN();
        },
        Unit: function Unit(x) {
            return x.value !== null ? not(x.value) : true;
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, not);
        }
    });
    return not;
});

});

parcelRegister("4jogG", function(module, exports) {

$parcel$export(module.exports, "createNthRoot", function () { return $323bc2e247be66c0$export$964e38ef60b1ac68; });

var $2mPYl = parcelRequire("2mPYl");

var $gIOYU = parcelRequire("gIOYU");

var $cITNv = parcelRequire("cITNv");

var $9INF1 = parcelRequire("9INF1");

var $cZfrH = parcelRequire("cZfrH");

var $1bBLS = parcelRequire("1bBLS");

var $iHnaT = parcelRequire("iHnaT");

var $6fCew = parcelRequire("6fCew");
var $323bc2e247be66c0$var$name = "nthRoot";
var $323bc2e247be66c0$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "BigNumber"
];
var $323bc2e247be66c0$export$964e38ef60b1ac68 = /* #__PURE__ */ (0, $2mPYl.factory)($323bc2e247be66c0$var$name, $323bc2e247be66c0$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, equalScalar = _ref.equalScalar, _BigNumber = _ref.BigNumber;
    var algorithm01 = (0, $gIOYU.createAlgorithm01)({
        typed: typed
    });
    var algorithm02 = (0, $cITNv.createAlgorithm02)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm06 = (0, $9INF1.createAlgorithm06)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm11 = (0, $cZfrH.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $1bBLS.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $iHnaT.createAlgorithm14)({
        typed: typed
    });
    /**
   * Calculate the nth root of a value.
   * The principal nth root of a positive real number A, is the positive real
   * solution of the equation
   *
   *     x^root = A
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *     math.nthRoot(a)
   *     math.nthRoot(a, root)
   *
   * Examples:
   *
   *     math.nthRoot(9, 2)    // returns 3, as 3^2 == 9
   *     math.sqrt(9)          // returns 3, as 3^2 == 9
   *     math.nthRoot(64, 3)   // returns 4, as 4^3 == 64
   *
   * See also:
   *
   *     sqrt, pow
   *
   * @param {number | BigNumber | Array | Matrix | Complex} a
   *              Value for which to calculate the nth root
   * @param {number | BigNumber} [root=2]    The root.
   * @return {number | Complex | Array | Matrix} Returns the nth root of `a`
   */ var complexErr = "Complex number not supported in function nthRoot. Use nthRoots instead.";
    var nthRoot = typed($323bc2e247be66c0$var$name, {
        number: function number(x) {
            return (0, $6fCew.nthRootNumber)(x, 2);
        },
        "number, number": (0, $6fCew.nthRootNumber),
        BigNumber: function BigNumber(x) {
            return _bigNthRoot(x, new _BigNumber(2));
        },
        Complex: function Complex(x) {
            throw new Error(complexErr);
        },
        "Complex, number": function ComplexNumber(x, y) {
            throw new Error(complexErr);
        },
        "BigNumber, BigNumber": _bigNthRoot,
        "Array | Matrix": function ArrayMatrix(x) {
            return nthRoot(x, 2);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            // density must be one (no zeros in matrix)
            if (y.density() === 1) // sparse + sparse
            return algorithm06(x, y, nthRoot);
            else // throw exception
            throw new Error("Root must be non-zero");
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, nthRoot, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            // density must be one (no zeros in matrix)
            if (y.density() === 1) // dense + sparse
            return algorithm01(x, y, nthRoot, false);
            else // throw exception
            throw new Error("Root must be non-zero");
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, nthRoot);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return nthRoot(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return nthRoot(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return nthRoot(x, matrix(y));
        },
        "SparseMatrix, number | BigNumber": function SparseMatrixNumberBigNumber(x, y) {
            return algorithm11(x, y, nthRoot, false);
        },
        "DenseMatrix, number | BigNumber": function DenseMatrixNumberBigNumber(x, y) {
            return algorithm14(x, y, nthRoot, false);
        },
        "number | BigNumber, SparseMatrix": function numberBigNumberSparseMatrix(x, y) {
            // density must be one (no zeros in matrix)
            if (y.density() === 1) // sparse - scalar
            return algorithm11(y, x, nthRoot, true);
            else // throw exception
            throw new Error("Root must be non-zero");
        },
        "number | BigNumber, DenseMatrix": function numberBigNumberDenseMatrix(x, y) {
            return algorithm14(y, x, nthRoot, true);
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(x, y) {
            // use matrix implementation
            return nthRoot(matrix(x), y).valueOf();
        },
        "number | BigNumber, Array": function numberBigNumberArray(x, y) {
            // use matrix implementation
            return nthRoot(x, matrix(y)).valueOf();
        }
    });
    return nthRoot;
    /**
   * Calculate the nth root of a for BigNumbers, solve x^root == a
   * https://rosettacode.org/wiki/Nth_root#JavaScript
   * @param {BigNumber} a
   * @param {BigNumber} root
   * @private
   */ function _bigNthRoot(a, root) {
        var precision = _BigNumber.precision;
        var Big = _BigNumber.clone({
            precision: precision + 2
        });
        var zero = new _BigNumber(0);
        var one = new Big(1);
        var inv = root.isNegative();
        if (inv) root = root.neg();
        if (root.isZero()) throw new Error("Root must be non-zero");
        if (a.isNegative() && !root.abs().mod(2).equals(1)) throw new Error("Root must be odd when a is negative.");
         // edge cases zero and infinity
        if (a.isZero()) return inv ? new Big(Infinity) : 0;
        if (!a.isFinite()) return inv ? zero : a;
        var x = a.abs().pow(one.div(root)); // If a < 0, we require that root is an odd integer,
        // so (-1) ^ (1/root) = -1
        x = a.isNeg() ? x.neg() : x;
        return new _BigNumber((inv ? one.div(x) : x).toPrecision(precision));
    }
});
var $323bc2e247be66c0$export$f098cf3c4ef0f7ef = /* #__PURE__ */ (0, $2mPYl.factory)($323bc2e247be66c0$var$name, [
    "typed"
], function(_ref2) {
    var typed = _ref2.typed;
    return typed($323bc2e247be66c0$var$name, {
        number: (0, $6fCew.nthRootNumber),
        "number, number": (0, $6fCew.nthRootNumber)
    });
});

});

parcelRegister("VnIhn", function(module, exports) {

$parcel$export(module.exports, "createNthRoots", function () { return $0ac7b7ee1e73fe7b$export$36e27b45d2aa738c; });

var $2mPYl = parcelRequire("2mPYl");
var $0ac7b7ee1e73fe7b$var$name = "nthRoots";
var $0ac7b7ee1e73fe7b$var$dependencies = [
    "config",
    "typed",
    "divideScalar",
    "Complex"
];
var $0ac7b7ee1e73fe7b$export$36e27b45d2aa738c = /* #__PURE__ */ (0, $2mPYl.factory)($0ac7b7ee1e73fe7b$var$name, $0ac7b7ee1e73fe7b$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, divideScalar = _ref.divideScalar, Complex = _ref.Complex;
    /**
   * Calculate the nth roots of a value.
   * An nth root of a positive real number A,
   * is a positive real solution of the equation "x^root = A".
   * This function returns an array of complex values.
   *
   * Syntax:
   *
   *    math.nthRoots(x)
   *    math.nthRoots(x, root)
   *
   * Examples:
   *
   *    math.nthRoots(1)
   *    // returns [
   *    //   {re: 1, im: 0},
   *    //   {re: -1, im: 0}
   *    // ]
   *    nthRoots(1, 3)
   *    // returns [
   *    //   { re: 1, im: 0 },
   *    //   { re: -0.4999999999999998, im: 0.8660254037844387 },
   *    //   { re: -0.5000000000000004, im: -0.8660254037844385 }
   *    ]
   *
   * See also:
   *
   *    nthRoot, pow, sqrt
   *
   * @param {number | BigNumber | Fraction | Complex | Array | Matrix} x Number to be rounded
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix}            Rounded value
   */ var nthRoots = typed($0ac7b7ee1e73fe7b$var$name, {
        Complex: function Complex(x) {
            return _nthComplexRoots(x, 2);
        },
        "Complex, number": _nthComplexRoots
    });
    /**
   * Each function here returns a real multiple of i as a Complex value.
   * @param  {number} val
   * @return {Complex} val, i*val, -val or -i*val for index 0, 1, 2, 3
   */ // This is used to fix float artifacts for zero-valued components.
    var _calculateExactResult = [
        function realPos(val) {
            return new Complex(val, 0);
        },
        function imagPos(val) {
            return new Complex(0, val);
        },
        function realNeg(val) {
            return new Complex(-val, 0);
        },
        function imagNeg(val) {
            return new Complex(0, -val);
        }
    ];
    /**
   * Calculate the nth root of a Complex Number a using De Movire's Theorem.
   * @param  {Complex} a
   * @param  {number} root
   * @return {Array} array of n Complex Roots
   */ function _nthComplexRoots(a, root) {
        if (root < 0) throw new Error("Root must be greater than zero");
        if (root === 0) throw new Error("Root must be non-zero");
        if (root % 1 !== 0) throw new Error("Root must be an integer");
        if (a === 0 || a.abs() === 0) return [
            new Complex(0, 0)
        ];
        var aIsNumeric = typeof a === "number";
        var offset; // determine the offset (argument of a)/(pi/2)
        if (aIsNumeric || a.re === 0 || a.im === 0) {
            if (aIsNumeric) offset = 2 * +(a < 0); // numeric value on the real axis
            else if (a.im === 0) offset = 2 * +(a.re < 0); // complex value on the real axis
            else offset = 2 * +(a.im < 0) + 1; // complex value on the imaginary axis
        }
        var arg = a.arg();
        var abs = a.abs();
        var roots = [];
        var r = Math.pow(abs, 1 / root);
        for(var k = 0; k < root; k++){
            var halfPiFactor = (offset + 4 * k) / root;
            /**
       * If (offset + 4*k)/root is an integral multiple of pi/2
       * then we can produce a more exact result.
       */ if (halfPiFactor === Math.round(halfPiFactor)) {
                roots.push(_calculateExactResult[halfPiFactor % 4](r));
                continue;
            }
            roots.push(new Complex({
                r: r,
                phi: (arg + 2 * Math.PI * k) / root
            }));
        }
        return roots;
    }
    return nthRoots;
});

});

parcelRegister("aQkjJ", function(module, exports) {

$parcel$export(module.exports, "createNumber", function () { return $7e4e854838a959d7$export$763ee9f6477981ab; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");
var $7e4e854838a959d7$var$name = "number";
var $7e4e854838a959d7$var$dependencies = [
    "typed"
];
var $7e4e854838a959d7$export$763ee9f6477981ab = /* #__PURE__ */ (0, $2mPYl.factory)($7e4e854838a959d7$var$name, $7e4e854838a959d7$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Create a number or convert a string, boolean, or unit to a number.
   * When value is a matrix, all elements will be converted to number.
   *
   * Syntax:
   *
   *    math.number(value)
   *    math.number(unit, valuelessUnit)
   *
   * Examples:
   *
   *    math.number(2)                         // returns number 2
   *    math.number('7.2')                     // returns number 7.2
   *    math.number(true)                      // returns number 1
   *    math.number([true, false, true, true]) // returns [1, 0, 1, 1]
   *    math.number(math.unit('52cm'), 'm')    // returns 0.52
   *
   * See also:
   *
   *    bignumber, boolean, complex, index, matrix, string, unit
   *
   * @param {string | number | BigNumber | Fraction | boolean | Array | Matrix | Unit | null} [value]  Value to be converted
   * @param {Unit | string} [valuelessUnit] A valueless unit, used to convert a unit to a number
   * @return {number | Array | Matrix} The created number
   */ var number = typed("number", {
        "": function _() {
            return 0;
        },
        number: function number(x) {
            return x;
        },
        string: function string(x) {
            if (x === "NaN") return NaN;
            var num = Number(x);
            if (isNaN(num)) throw new SyntaxError('String "' + x + '" is no valid number');
            return num;
        },
        BigNumber: function BigNumber(x) {
            return x.toNumber();
        },
        Fraction: function Fraction(x) {
            return x.valueOf();
        },
        Unit: function Unit(x) {
            throw new Error("Second argument with valueless unit expected");
        },
        "null": function _null(x) {
            return 0;
        },
        "Unit, string | Unit": function UnitStringUnit(unit, valuelessUnit) {
            return unit.toNumber(valuelessUnit);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, number);
        }
    }); // reviver function to parse a JSON object like:
    //
    //     {"mathjs":"number","value":"2.3"}
    //
    // into a number 2.3
    number.fromJSON = function(json) {
        return parseFloat(json.value);
    };
    return number;
});

});

parcelRegister("v3afu", function(module, exports) {

$parcel$export(module.exports, "createNumeric", function () { return $05d559bae6d773d1$export$e3cf2d123164e554; });

var $1amHZ = parcelRequire("1amHZ");

var $2mPYl = parcelRequire("2mPYl");

var $rJyG2 = parcelRequire("rJyG2");
var $05d559bae6d773d1$var$name = "numeric";
var $05d559bae6d773d1$var$dependencies = [
    "number",
    "?bignumber",
    "?fraction"
];
var $05d559bae6d773d1$export$e3cf2d123164e554 = /* #__PURE__ */ (0, $2mPYl.factory)($05d559bae6d773d1$var$name, $05d559bae6d773d1$var$dependencies, function(_ref) {
    var _number = _ref.number, bignumber = _ref.bignumber, fraction = _ref.fraction;
    var validInputTypes = {
        string: true,
        number: true,
        BigNumber: true,
        Fraction: true
    }; // Load the conversion functions for each output type
    var validOutputTypes = {
        number: function number(x) {
            return _number(x);
        },
        BigNumber: bignumber ? function(x) {
            return bignumber(x);
        } : (0, $rJyG2.noBignumber),
        Fraction: fraction ? function(x) {
            return fraction(x);
        } : (0, $rJyG2.noFraction)
    };
    /**
   * Convert a numeric input to a specific numeric type: number, BigNumber, or Fraction.
   *
   * Syntax:
   *
   *    math.numeric(x)
   *
   * Examples:
   *
   *    math.numeric('4')                           // returns number 4
   *    math.numeric('4', 'number')                 // returns number 4
   *    math.numeric('4', 'BigNumber')              // returns BigNumber 4
   *    math.numeric('4', 'Fraction')               // returns Fraction 4
   *    math.numeric(4, 'Fraction')                 // returns Fraction 4
   *    math.numeric(math.fraction(2, 5), 'number') // returns number 0.4
   *
   * See also:
   *
   *    number, fraction, bignumber, string, format
   *
   * @param {string | number | BigNumber | Fraction } value
   *              A numeric value or a string containing a numeric value
   * @param {string} outputType
   *              Desired numeric output type.
   *              Available values: 'number', 'BigNumber', or 'Fraction'
   * @return {number | BigNumber | Fraction}
   *              Returns an instance of the numeric in the requested type
   */ return function numeric(value, outputType) {
        var inputType = (0, $1amHZ.typeOf)(value);
        if (!(inputType in validInputTypes)) throw new TypeError("Cannot convert " + value + ' of type "' + inputType + '"; valid input types are ' + Object.keys(validInputTypes).join(", "));
        if (!(outputType in validOutputTypes)) throw new TypeError("Cannot convert " + value + ' to type "' + outputType + '"; valid output types are ' + Object.keys(validOutputTypes).join(", "));
        if (outputType === inputType) return value;
        else return validOutputTypes[outputType](value);
    };
});

});

parcelRegister("hyyaM", function(module, exports) {

$parcel$export(module.exports, "createOnes", function () { return $cc801ea87faca66b$export$f524a435b9c16a90; });

var $1amHZ = parcelRequire("1amHZ");

var $kFRKb = parcelRequire("kFRKb");

var $5WdrK = parcelRequire("5WdrK");

var $2mPYl = parcelRequire("2mPYl");
var $cc801ea87faca66b$var$name = "ones";
var $cc801ea87faca66b$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "BigNumber"
];
var $cc801ea87faca66b$export$f524a435b9c16a90 = /* #__PURE__ */ (0, $2mPYl.factory)($cc801ea87faca66b$var$name, $cc801ea87faca66b$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, matrix = _ref.matrix, BigNumber = _ref.BigNumber;
    /**
   * Create a matrix filled with ones. The created matrix can have one or
   * multiple dimensions.
   *
   * Syntax:
   *
   *    math.ones(m)
   *    math.ones(m, format)
   *    math.ones(m, n)
   *    math.ones(m, n, format)
   *    math.ones([m, n])
   *    math.ones([m, n], format)
   *    math.ones([m, n, p, ...])
   *    math.ones([m, n, p, ...], format)
   *
   * Examples:
   *
   *    math.ones(3)                   // returns [1, 1, 1]
   *    math.ones(3, 2)                // returns [[1, 1], [1, 1], [1, 1]]
   *    math.ones(3, 2, 'dense')       // returns Dense Matrix [[1, 1], [1, 1], [1, 1]]
   *
   *    const A = [[1, 2, 3], [4, 5, 6]]
   *    math.ones(math.size(A))       // returns [[1, 1, 1], [1, 1, 1]]
   *
   * See also:
   *
   *    zeros, identity, size, range
   *
   * @param {...number | Array} size    The size of each dimension of the matrix
   * @param {string} [format]           The Matrix storage format
   *
   * @return {Array | Matrix | number}  A matrix filled with ones
   */ return typed("ones", {
        "": function _() {
            return config.matrix === "Array" ? _ones([]) : _ones([], "default");
        },
        // math.ones(m, n, p, ..., format)
        // TODO: more accurate signature '...number | BigNumber, string' as soon as typed-function supports this
        "...number | BigNumber | string": function numberBigNumberString(size) {
            var last = size[size.length - 1];
            if (typeof last === "string") {
                var format = size.pop();
                return _ones(size, format);
            } else if (config.matrix === "Array") return _ones(size);
            else return _ones(size, "default");
        },
        Array: _ones,
        Matrix: function Matrix(size) {
            var format = size.storage();
            return _ones(size.valueOf(), format);
        },
        "Array | Matrix, string": function ArrayMatrixString(size, format) {
            return _ones(size.valueOf(), format);
        }
    });
    /**
   * Create an Array or Matrix with ones
   * @param {Array} size
   * @param {string} [format='default']
   * @return {Array | Matrix}
   * @private
   */ function _ones(size, format) {
        var hasBigNumbers = _normalize(size);
        var defaultValue = hasBigNumbers ? new BigNumber(1) : 1;
        _validate(size);
        if (format) {
            // return a matrix
            var m = matrix(format);
            if (size.length > 0) return m.resize(size, defaultValue);
            return m;
        } else {
            // return an Array
            var arr = [];
            if (size.length > 0) return (0, $5WdrK.resize)(arr, size, defaultValue);
            return arr;
        }
    } // replace BigNumbers with numbers, returns true if size contained BigNumbers
    function _normalize(size) {
        var hasBigNumbers = false;
        size.forEach(function(value, index, arr) {
            if ((0, $1amHZ.isBigNumber)(value)) {
                hasBigNumbers = true;
                arr[index] = value.toNumber();
            }
        });
        return hasBigNumbers;
    } // validate arguments
    function _validate(size) {
        size.forEach(function(value) {
            if (typeof value !== "number" || !(0, $kFRKb.isInteger)(value) || value < 0) throw new Error("Parameters in function ones must be positive integers");
        });
    }
});

});

parcelRegister("dfJfX", function(module, exports) {

$parcel$export(module.exports, "createOr", function () { return $9a5fc807cb0aac2e$export$3d19b09907d6fd4a; });

var $jaKH8 = parcelRequire("jaKH8");

var $dNuvz = parcelRequire("dNuvz");

var $1bBLS = parcelRequire("1bBLS");

var $iHnaT = parcelRequire("iHnaT");

var $6XnjD = parcelRequire("6XnjD");

var $2mPYl = parcelRequire("2mPYl");

var $fAJNv = parcelRequire("fAJNv");
var $9a5fc807cb0aac2e$var$name = "or";
var $9a5fc807cb0aac2e$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "DenseMatrix"
];
var $9a5fc807cb0aac2e$export$3d19b09907d6fd4a = /* #__PURE__ */ (0, $2mPYl.factory)($9a5fc807cb0aac2e$var$name, $9a5fc807cb0aac2e$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, equalScalar = _ref.equalScalar, DenseMatrix = _ref.DenseMatrix;
    var algorithm03 = (0, $jaKH8.createAlgorithm03)({
        typed: typed
    });
    var algorithm05 = (0, $6XnjD.createAlgorithm05)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm12 = (0, $dNuvz.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $1bBLS.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $iHnaT.createAlgorithm14)({
        typed: typed
    });
    /**
   * Logical `or`. Test if at least one value is defined with a nonzero/nonempty value.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.or(x, y)
   *
   * Examples:
   *
   *    math.or(2, 4)   // returns true
   *
   *    a = [2, 5, 0]
   *    b = [0, 22, 0]
   *    c = 0
   *
   *    math.or(a, b)   // returns [true, true, false]
   *    math.or(b, c)   // returns [false, true, false]
   *
   * See also:
   *
   *    and, not, xor
   *
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x First value to check
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} y Second value to check
   * @return {boolean | Array | Matrix}
   *            Returns true when one of the inputs is defined with a nonzero/nonempty value.
   */ var or = typed($9a5fc807cb0aac2e$var$name, {
        "number, number": (0, $fAJNv.orNumber),
        "Complex, Complex": function ComplexComplex(x, y) {
            return x.re !== 0 || x.im !== 0 || y.re !== 0 || y.im !== 0;
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return !x.isZero() && !x.isNaN() || !y.isZero() && !y.isNaN();
        },
        "Unit, Unit": function UnitUnit(x, y) {
            return or(x.value || 0, y.value || 0);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm05(x, y, or);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, or, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, or, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, or);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return or(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return or(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return or(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, or, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, or, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, or, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, or, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, or, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, or, true).valueOf();
        }
    });
    return or;
});

});

parcelRegister("5v3G9", function(module, exports) {

$parcel$export(module.exports, "createPartitionSelect", function () { return $4012b3912b698052$export$47c1a746705f5c42; });

var $1amHZ = parcelRequire("1amHZ");

var $kFRKb = parcelRequire("kFRKb");

var $2mPYl = parcelRequire("2mPYl");
var $4012b3912b698052$var$name = "partitionSelect";
var $4012b3912b698052$var$dependencies = [
    "typed",
    "isNumeric",
    "isNaN",
    "compare"
];
var $4012b3912b698052$export$47c1a746705f5c42 = /* #__PURE__ */ (0, $2mPYl.factory)($4012b3912b698052$var$name, $4012b3912b698052$var$dependencies, function(_ref) {
    var typed = _ref.typed, isNumeric = _ref.isNumeric, isNaN = _ref.isNaN, compare = _ref.compare;
    var asc = compare;
    var desc = function desc(a, b) {
        return -compare(a, b);
    };
    /**
   * Partition-based selection of an array or 1D matrix.
   * Will find the kth smallest value, and mutates the input array.
   * Uses Quickselect.
   *
   * Syntax:
   *
   *    math.partitionSelect(x, k)
   *    math.partitionSelect(x, k, compare)
   *
   * Examples:
   *
   *    math.partitionSelect([5, 10, 1], 2)           // returns 10
   *    math.partitionSelect(['C', 'B', 'A', 'D'], 1) // returns 'B'
   *
   *    function sortByLength (a, b) {
   *      return a.length - b.length
   *    }
   *    math.partitionSelect(['Langdon', 'Tom', 'Sara'], 2, sortByLength) // returns 'Langdon'
   *
   * See also:
   *
   *    sort
   *
   * @param {Matrix | Array} x    A one dimensional matrix or array to sort
   * @param {Number} k            The kth smallest value to be retrieved zero-based index
   * @param {Function | 'asc' | 'desc'} [compare='asc']
   *        An optional comparator function. The function is called as
   *        `compare(a, b)`, and must return 1 when a > b, -1 when a < b,
   *        and 0 when a == b.
   * @return {*} Returns the kth lowest value.
   */ return typed($4012b3912b698052$var$name, {
        "Array | Matrix, number": function ArrayMatrixNumber(x, k) {
            return _partitionSelect(x, k, asc);
        },
        "Array | Matrix, number, string": function ArrayMatrixNumberString(x, k, compare) {
            if (compare === "asc") return _partitionSelect(x, k, asc);
            else if (compare === "desc") return _partitionSelect(x, k, desc);
            else throw new Error('Compare string must be "asc" or "desc"');
        },
        "Array | Matrix, number, function": _partitionSelect
    });
    function _partitionSelect(x, k, compare) {
        if (!(0, $kFRKb.isInteger)(k) || k < 0) throw new Error("k must be a non-negative integer");
        if ((0, $1amHZ.isMatrix)(x)) {
            var size = x.size();
            if (size.length > 1) throw new Error("Only one dimensional matrices supported");
            return quickSelect(x.valueOf(), k, compare);
        }
        if (Array.isArray(x)) return quickSelect(x, k, compare);
    }
    /**
   * Quickselect algorithm.
   * Code adapted from:
   * https://blog.teamleadnet.com/2012/07/quick-select-algorithm-find-kth-element.html
   *
   * @param {Array} arr
   * @param {Number} k
   * @param {Function} compare
   * @private
   */ function quickSelect(arr, k, compare) {
        if (k >= arr.length) throw new Error("k out of bounds");
         // check for NaN values since these can cause an infinite while loop
        for(var i = 0; i < arr.length; i++){
            if (isNumeric(arr[i]) && isNaN(arr[i])) return arr[i]; // return NaN
        }
        var from = 0;
        var to = arr.length - 1; // if from == to we reached the kth element
        while(from < to){
            var r = from;
            var w = to;
            var pivot = arr[Math.floor(Math.random() * (to - from + 1)) + from]; // stop if the reader and writer meets
            while(r < w)// arr[r] >= pivot
            if (compare(arr[r], pivot) >= 0) {
                // put the large values at the end
                var tmp = arr[w];
                arr[w] = arr[r];
                arr[r] = tmp;
                --w;
            } else // the value is smaller than the pivot, skip
            ++r;
             // if we stepped up (r++) we need to step one down (arr[r] > pivot)
            if (compare(arr[r], pivot) > 0) --r;
             // the r pointer is on the end of the first k elements
            if (k <= r) to = r;
            else from = r + 1;
        }
        return arr[k];
    }
});

});

parcelRegister("aY2pj", function(module, exports) {

$parcel$export(module.exports, "createPermutations", function () { return $7fc16002d5daa027$export$1d58d7915914cc9c; });

var $kFRKb = parcelRequire("kFRKb");

var $kzt53 = parcelRequire("kzt53");

var $2mPYl = parcelRequire("2mPYl");
var $7fc16002d5daa027$var$name = "permutations";
var $7fc16002d5daa027$var$dependencies = [
    "typed",
    "factorial"
];
var $7fc16002d5daa027$export$1d58d7915914cc9c = /* #__PURE__ */ (0, $2mPYl.factory)($7fc16002d5daa027$var$name, $7fc16002d5daa027$var$dependencies, function(_ref) {
    var typed = _ref.typed, factorial = _ref.factorial;
    /**
   * Compute the number of ways of obtaining an ordered subset of `k` elements
   * from a set of `n` elements.
   *
   * Permutations only takes integer arguments.
   * The following condition must be enforced: k <= n.
   *
   * Syntax:
   *
   *     math.permutations(n)
   *     math.permutations(n, k)
   *
   * Examples:
   *
   *    math.permutations(5)     // 120
   *    math.permutations(5, 3)  // 60
   *
   * See also:
   *
   *    combinations, combinationsWithRep, factorial
   *
   * @param {number | BigNumber} n   The number of objects in total
   * @param {number | BigNumber} [k] The number of objects in the subset
   * @return {number | BigNumber}    The number of permutations
   */ return typed($7fc16002d5daa027$var$name, {
        "number | BigNumber": factorial,
        "number, number": function numberNumber(n, k) {
            if (!(0, $kFRKb.isInteger)(n) || n < 0) throw new TypeError("Positive integer value expected in function permutations");
            if (!(0, $kFRKb.isInteger)(k) || k < 0) throw new TypeError("Positive integer value expected in function permutations");
            if (k > n) throw new TypeError("second argument k must be less than or equal to first argument n");
             // Permute n objects, k at a time
            return (0, $kzt53.product)(n - k + 1, n);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(n, k) {
            var result, i;
            if (!$7fc16002d5daa027$var$isPositiveInteger(n) || !$7fc16002d5daa027$var$isPositiveInteger(k)) throw new TypeError("Positive integer value expected in function permutations");
            if (k.gt(n)) throw new TypeError("second argument k must be less than or equal to first argument n");
            var one = n.mul(0).add(1);
            result = one;
            for(i = n.minus(k).plus(1); i.lte(n); i = i.plus(1))result = result.times(i);
            return result;
        } // TODO: implement support for collection in permutations
    });
});
/**
 * Test whether BigNumber n is a positive integer
 * @param {BigNumber} n
 * @returns {boolean} isPositiveInteger
 */ function $7fc16002d5daa027$var$isPositiveInteger(n) {
    return n.isInteger() && n.gte(0);
}

});

parcelRegister("dlWMO", function(module, exports) {

$parcel$export(module.exports, "createPickRandom", function () { return $9b8ad640fb7c0ac7$export$fbe25b9f25feec34; });

var $2mPYl = parcelRequire("2mPYl");

var $1amHZ = parcelRequire("1amHZ");

var $5WdrK = parcelRequire("5WdrK");

var $kWMJ7 = parcelRequire("kWMJ7");
var $9b8ad640fb7c0ac7$var$name = "pickRandom";
var $9b8ad640fb7c0ac7$var$dependencies = [
    "typed",
    "config",
    "?on"
];
var $9b8ad640fb7c0ac7$export$fbe25b9f25feec34 = /* #__PURE__ */ (0, $2mPYl.factory)($9b8ad640fb7c0ac7$var$name, $9b8ad640fb7c0ac7$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, on = _ref.on;
    // seeded pseudo random number generator
    var rng = (0, $kWMJ7.createRng)(config.randomSeed);
    if (on) on("config", function(curr, prev) {
        if (curr.randomSeed !== prev.randomSeed) rng = (0, $kWMJ7.createRng)(curr.randomSeed);
    });
    /**
   * Random pick one or more values from a one dimensional array.
   * Array elements are picked using a random function with uniform or weighted distribution.
   *
   * Syntax:
   *
   *     math.pickRandom(array)
   *     math.pickRandom(array, number)
   *     math.pickRandom(array, weights)
   *     math.pickRandom(array, number, weights)
   *     math.pickRandom(array, weights, number)
   *
   * Examples:
   *
   *     math.pickRandom([3, 6, 12, 2])                  // returns one of the values in the array
   *     math.pickRandom([3, 6, 12, 2], 2)               // returns an array of two of the values in the array
   *     math.pickRandom([3, 6, 12, 2], [1, 3, 2, 1])    // returns one of the values in the array with weighted distribution
   *     math.pickRandom([3, 6, 12, 2], 2, [1, 3, 2, 1]) // returns an array of two of the values in the array with weighted distribution
   *     math.pickRandom([3, 6, 12, 2], [1, 3, 2, 1], 2) // returns an array of two of the values in the array with weighted distribution
   *
   * See also:
   *
   *     random, randomInt
   *
   * @param {Array | Matrix} array     A one dimensional array
   * @param {Int} number               An int or float
   * @param {Array | Matrix} weights   An array of ints or floats
   * @return {number | Array}          Returns a single random value from array when number is 1 or undefined.
   *                                   Returns an array with the configured number of elements when number is > 1.
   */ return typed({
        "Array | Matrix": function ArrayMatrix(possibles) {
            return _pickRandom(possibles);
        },
        "Array | Matrix, number": function ArrayMatrixNumber(possibles, number) {
            return _pickRandom(possibles, number, undefined);
        },
        "Array | Matrix, Array": function ArrayMatrixArray(possibles, weights) {
            return _pickRandom(possibles, undefined, weights);
        },
        "Array | Matrix, Array | Matrix, number": function ArrayMatrixArrayMatrixNumber(possibles, weights, number) {
            return _pickRandom(possibles, number, weights);
        },
        "Array | Matrix, number, Array | Matrix": function ArrayMatrixNumberArrayMatrix(possibles, number, weights) {
            return _pickRandom(possibles, number, weights);
        }
    });
    function _pickRandom(possibles, number, weights) {
        var single = typeof number === "undefined";
        if (single) number = 1;
        possibles = possibles.valueOf(); // get Array
        if (weights) weights = weights.valueOf(); // get Array
        if ((0, $5WdrK.arraySize)(possibles).length > 1) throw new Error("Only one dimensional vectors supported");
        var totalWeights = 0;
        if (typeof weights !== "undefined") {
            if (weights.length !== possibles.length) throw new Error("Weights must have the same length as possibles");
            for(var i = 0, len = weights.length; i < len; i++){
                if (!(0, $1amHZ.isNumber)(weights[i]) || weights[i] < 0) throw new Error("Weights must be an array of positive numbers");
                totalWeights += weights[i];
            }
        }
        var length = possibles.length;
        if (length === 0) return [];
        else if (number >= length) return number > 1 ? possibles : possibles[0];
        var result = [];
        var pick;
        while(result.length < number){
            if (typeof weights === "undefined") pick = possibles[Math.floor(rng() * length)];
            else {
                var randKey = rng() * totalWeights;
                for(var _i = 0, _len = possibles.length; _i < _len; _i++){
                    randKey -= weights[_i];
                    if (randKey < 0) {
                        pick = possibles[_i];
                        break;
                    }
                }
            }
            if (result.indexOf(pick) === -1) result.push(pick);
        }
        return single ? result[0] : result; // TODO: return matrix when input was a matrix
    // TODO: add support for multi dimensional matrices
    }
});

});
parcelRegister("kWMJ7", function(module, exports) {

$parcel$export(module.exports, "createRng", function () { return $f3ff058f404aefbc$export$eaf9227667332084; });
// create a random seed here to prevent an infinite loop from seed-random
// inside the factory. Reason is that math.random is defined as a getter/setter
// and seed-random generates a seed from the local entropy by reading every
// defined object including `math` itself. That means that whilst getting
// math.random, it tries to get math.random, etc... an infinite loop.
// See https://github.com/ForbesLindesay/seed-random/issues/6

var $7hLqv = parcelRequire("7hLqv");
var $f3ff058f404aefbc$var$singletonRandom = /* #__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7hLqv)))();
function $f3ff058f404aefbc$export$eaf9227667332084(randomSeed) {
    var random; // create a new random generator with given seed
    function setSeed(seed) {
        random = seed === null ? $f3ff058f404aefbc$var$singletonRandom : (0, (/*@__PURE__*/$parcel$interopDefault($7hLqv)))(String(seed));
    } // initialize a seeded pseudo random number generator with config's random seed
    setSeed(randomSeed); // wrapper function so the rng can be updated via generator
    function rng() {
        return random();
    }
    return rng;
}

});
parcelRegister("7hLqv", function(module, exports) {
"use strict";
var $54dee8d4d257b1a4$var$width = 256; // each RC4 output is 0 <= x < 256
var $54dee8d4d257b1a4$var$chunks = 6; // at least six RC4 outputs for each double
var $54dee8d4d257b1a4$var$digits = 52; // there are 52 significant digits in a double
var $54dee8d4d257b1a4$var$pool = []; // pool: entropy pool starts empty
var $54dee8d4d257b1a4$var$GLOBAL = typeof $parcel$global === "undefined" ? window : $parcel$global;
//
// The following constants are related to IEEE 754 limits.
//
var $54dee8d4d257b1a4$var$startdenom = Math.pow($54dee8d4d257b1a4$var$width, $54dee8d4d257b1a4$var$chunks), $54dee8d4d257b1a4$var$significance = Math.pow(2, $54dee8d4d257b1a4$var$digits), $54dee8d4d257b1a4$var$overflow = $54dee8d4d257b1a4$var$significance * 2, $54dee8d4d257b1a4$var$mask = $54dee8d4d257b1a4$var$width - 1;
var $54dee8d4d257b1a4$var$oldRandom = Math.random;
//
// seedrandom()
// This is the seedrandom function described above.
//
module.exports = function(seed, options) {
    if (options && options.global === true) {
        options.global = false;
        Math.random = module.exports(seed, options);
        options.global = true;
        return Math.random;
    }
    var use_entropy = options && options.entropy || false;
    var key = [];
    // Flatten the seed string or build one from local entropy if needed.
    var shortseed = $54dee8d4d257b1a4$var$mixkey($54dee8d4d257b1a4$var$flatten(use_entropy ? [
        seed,
        $54dee8d4d257b1a4$var$tostring($54dee8d4d257b1a4$var$pool)
    ] : 0 in arguments ? seed : $54dee8d4d257b1a4$var$autoseed(), 3), key);
    // Use the seed to initialize an ARC4 generator.
    var arc4 = new $54dee8d4d257b1a4$var$ARC4(key);
    // Mix the randomness into accumulated entropy.
    $54dee8d4d257b1a4$var$mixkey($54dee8d4d257b1a4$var$tostring(arc4.S), $54dee8d4d257b1a4$var$pool);
    // Override Math.random
    // This function returns a random double in [0, 1) that contains
    // randomness in every bit of the mantissa of the IEEE 754 value.
    return function() {
        var n = arc4.g($54dee8d4d257b1a4$var$chunks), d = $54dee8d4d257b1a4$var$startdenom, x = 0; //   and no 'extra last byte'.
        while(n < $54dee8d4d257b1a4$var$significance){
            n = (n + x) * $54dee8d4d257b1a4$var$width; //   shifting numerator and
            d *= $54dee8d4d257b1a4$var$width; //   denominator and generating a
            x = arc4.g(1); //   new least-significant-byte.
        }
        while(n >= $54dee8d4d257b1a4$var$overflow){
            n /= 2; //   last byte, shift everything
            d /= 2; //   right using integer Math until
            x >>>= 1; //   we have exactly the desired bits.
        }
        return (n + x) / d; // Form the number within [0, 1).
    };
};
module.exports.resetGlobal = function() {
    Math.random = $54dee8d4d257b1a4$var$oldRandom;
};
//
// ARC4
//
// An ARC4 implementation.  The constructor takes a key in the form of
// an array of at most (width) integers that should be 0 <= x < (width).
//
// The g(count) method returns a pseudorandom integer that concatenates
// the next (count) outputs from ARC4.  Its return value is a number x
// that is in the range 0 <= x < (width ^ count).
//
/** @constructor */ function $54dee8d4d257b1a4$var$ARC4(key) {
    var t, keylen = key.length, me = this, i = 0, j = me.i = me.j = 0, s = me.S = [];
    // The empty key [] is treated as [0].
    if (!keylen) key = [
        keylen++
    ];
    // Set up S using the standard key scheduling algorithm.
    while(i < $54dee8d4d257b1a4$var$width)s[i] = i++;
    for(i = 0; i < $54dee8d4d257b1a4$var$width; i++){
        s[i] = s[j = $54dee8d4d257b1a4$var$mask & j + key[i % keylen] + (t = s[i])];
        s[j] = t;
    }
    // The "g" method returns the next (count) outputs as one number.
    (me.g = function(count) {
        // Using instance members instead of closure state nearly doubles speed.
        var t, r = 0, i = me.i, j = me.j, s = me.S;
        while(count--){
            t = s[i = $54dee8d4d257b1a4$var$mask & i + 1];
            r = r * $54dee8d4d257b1a4$var$width + s[$54dee8d4d257b1a4$var$mask & (s[i] = s[j = $54dee8d4d257b1a4$var$mask & j + t]) + (s[j] = t)];
        }
        me.i = i;
        me.j = j;
        return r;
    // For robust unpredictability discard an initial batch of values.
    // See http://www.rsa.com/rsalabs/node.asp?id=2009
    })($54dee8d4d257b1a4$var$width);
}
//
// flatten()
// Converts an object tree to nested arrays of strings.
//
function $54dee8d4d257b1a4$var$flatten(obj, depth) {
    var result = [], typ = (typeof obj)[0], prop;
    if (depth && typ == "o") {
        for(prop in obj)try {
            result.push($54dee8d4d257b1a4$var$flatten(obj[prop], depth - 1));
        } catch (e) {}
    }
    return result.length ? result : typ == "s" ? obj : obj + "\0";
}
//
// mixkey()
// Mixes a string seed into a key that is an array of integers, and
// returns a shortened string seed that is equivalent to the result key.
//
function $54dee8d4d257b1a4$var$mixkey(seed, key) {
    var stringseed = seed + "", smear, j = 0;
    while(j < stringseed.length)key[$54dee8d4d257b1a4$var$mask & j] = $54dee8d4d257b1a4$var$mask & (smear ^= key[$54dee8d4d257b1a4$var$mask & j] * 19) + stringseed.charCodeAt(j++);
    return $54dee8d4d257b1a4$var$tostring(key);
}
//
// autoseed()
// Returns an object for autoseeding, using window.crypto if available.
//
/** @param {Uint8Array=} seed */ function $54dee8d4d257b1a4$var$autoseed(seed) {
    try {
        $54dee8d4d257b1a4$var$GLOBAL.crypto.getRandomValues(seed = new Uint8Array($54dee8d4d257b1a4$var$width));
        return $54dee8d4d257b1a4$var$tostring(seed);
    } catch (e) {
        return [
            +new Date,
            $54dee8d4d257b1a4$var$GLOBAL,
            $54dee8d4d257b1a4$var$GLOBAL.navigator && $54dee8d4d257b1a4$var$GLOBAL.navigator.plugins,
            $54dee8d4d257b1a4$var$GLOBAL.screen,
            $54dee8d4d257b1a4$var$tostring($54dee8d4d257b1a4$var$pool)
        ];
    }
}
//
// tostring()
// Converts an array of charcodes to a string
//
function $54dee8d4d257b1a4$var$tostring(a) {
    return String.fromCharCode.apply(0, a);
}
//
// When seedrandom.js is loaded, we immediately mix a few bits
// from the built-in RNG into the entropy pool.  Because we do
// not want to intefere with determinstic PRNG state later,
// seedrandom will not call Math.random on its own again after
// initialization.
//
$54dee8d4d257b1a4$var$mixkey(Math.random(), $54dee8d4d257b1a4$var$pool);

});



parcelRegister("4xcq3", function(module, exports) {

$parcel$export(module.exports, "createPow", function () { return $34d3e0b5fcafdd09$export$9c94d2d08a8d8146; });

var $2mPYl = parcelRequire("2mPYl");

var $kFRKb = parcelRequire("kFRKb");

var $5WdrK = parcelRequire("5WdrK");

var $6fCew = parcelRequire("6fCew");
var $34d3e0b5fcafdd09$var$name = "pow";
var $34d3e0b5fcafdd09$var$dependencies = [
    "typed",
    "config",
    "identity",
    "multiply",
    "matrix",
    "fraction",
    "number",
    "Complex"
];
var $34d3e0b5fcafdd09$export$9c94d2d08a8d8146 = /* #__PURE__ */ (0, $2mPYl.factory)($34d3e0b5fcafdd09$var$name, $34d3e0b5fcafdd09$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, identity = _ref.identity, multiply = _ref.multiply, matrix = _ref.matrix, number = _ref.number, fraction = _ref.fraction, Complex = _ref.Complex;
    /**
   * Calculates the power of x to y, `x ^ y`.
   * Matrix exponentiation is supported for square matrices `x`, and positive
   * integer exponents `y`.
   *
   * For cubic roots of negative numbers, the function returns the principal
   * root by default. In order to let the function return the real root,
   * math.js can be configured with `math.config({predictable: true})`.
   * To retrieve all cubic roots of a value, use `math.cbrt(x, true)`.
   *
   * Syntax:
   *
   *    math.pow(x, y)
   *
   * Examples:
   *
   *    math.pow(2, 3)               // returns number 8
   *
   *    const a = math.complex(2, 3)
   *    math.pow(a, 2)                // returns Complex -5 + 12i
   *
   *    const b = [[1, 2], [4, 3]]
   *    math.pow(b, 2)               // returns Array [[9, 8], [16, 17]]
   *
   * See also:
   *
   *    multiply, sqrt, cbrt, nthRoot
   *
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x  The base
   * @param  {number | BigNumber | Complex} y                          The exponent
   * @return {number | BigNumber | Complex | Array | Matrix} The value of `x` to the power `y`
   */ return typed($34d3e0b5fcafdd09$var$name, {
        "number, number": _pow,
        "Complex, Complex": function ComplexComplex(x, y) {
            return x.pow(y);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            if (y.isInteger() || x >= 0 || config.predictable) return x.pow(y);
            else return new Complex(x.toNumber(), 0).pow(y.toNumber(), 0);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            if (y.d !== 1) {
                if (config.predictable) throw new Error("Function pow does not support non-integer exponents for fractions.");
                else return _pow(x.valueOf(), y.valueOf());
            } else return x.pow(y);
        },
        "Array, number": _powArray,
        "Array, BigNumber": function ArrayBigNumber(x, y) {
            return _powArray(x, y.toNumber());
        },
        "Matrix, number": _powMatrix,
        "Matrix, BigNumber": function MatrixBigNumber(x, y) {
            return _powMatrix(x, y.toNumber());
        },
        "Unit, number | BigNumber": function UnitNumberBigNumber(x, y) {
            return x.pow(y);
        }
    });
    /**
   * Calculates the power of x to y, x^y, for two numbers.
   * @param {number} x
   * @param {number} y
   * @return {number | Complex} res
   * @private
   */ function _pow(x, y) {
        // Alternatively could define a 'realmode' config option or something, but
        // 'predictable' will work for now
        if (config.predictable && !(0, $kFRKb.isInteger)(y) && x < 0) // Check to see if y can be represented as a fraction
        try {
            var yFrac = fraction(y);
            var yNum = number(yFrac);
            if (y === yNum || Math.abs((y - yNum) / y) < 1e-14) {
                if (yFrac.d % 2 === 1) return (yFrac.n % 2 === 0 ? 1 : -1) * Math.pow(-x, y);
            }
        } catch (ex) {} // fraction() throws an error if y is Infinity, etc.
         // **for predictable mode** x^Infinity === NaN if x < -1
        // N.B. this behavour is different from `Math.pow` which gives
        // (-2)^Infinity === Infinity
        if (config.predictable && (x < -1 && y === Infinity || x > -1 && x < 0 && y === -Infinity)) return NaN;
        if ((0, $kFRKb.isInteger)(y) || x >= 0 || config.predictable) return (0, $6fCew.powNumber)(x, y);
        else {
            // TODO: the following infinity checks are duplicated from powNumber. Deduplicate this somehow
            // x^Infinity === 0 if -1 < x < 1
            // A real number 0 is returned instead of complex(0)
            if (x * x < 1 && y === Infinity || x * x > 1 && y === -Infinity) return 0;
            return new Complex(x, 0).pow(y, 0);
        }
    }
    /**
   * Calculate the power of a 2d array
   * @param {Array} x     must be a 2 dimensional, square matrix
   * @param {number} y    a positive, integer value
   * @returns {Array}
   * @private
   */ function _powArray(x, y) {
        if (!(0, $kFRKb.isInteger)(y) || y < 0) throw new TypeError("For A^b, b must be a positive integer (value is " + y + ")");
         // verify that A is a 2 dimensional square matrix
        var s = (0, $5WdrK.arraySize)(x);
        if (s.length !== 2) throw new Error("For A^b, A must be 2 dimensional (A has " + s.length + " dimensions)");
        if (s[0] !== s[1]) throw new Error("For A^b, A must be square (size is " + s[0] + "x" + s[1] + ")");
        var res = identity(s[0]).valueOf();
        var px = x;
        while(y >= 1){
            if ((y & 1) === 1) res = multiply(px, res);
            y >>= 1;
            px = multiply(px, px);
        }
        return res;
    }
    /**
   * Calculate the power of a 2d matrix
   * @param {Matrix} x     must be a 2 dimensional, square matrix
   * @param {number} y    a positive, integer value
   * @returns {Matrix}
   * @private
   */ function _powMatrix(x, y) {
        return matrix(_powArray(x.valueOf(), y));
    }
});

});

parcelRegister("k1d7p", function(module, exports) {

$parcel$export(module.exports, "createPrint", function () { return $e92e13ae65c52602$export$ea4b9d9569ff81cc; });

var $6NxuJ = parcelRequire("6NxuJ");

var $1amHZ = parcelRequire("1amHZ");

var $2mPYl = parcelRequire("2mPYl");
var $e92e13ae65c52602$var$name = "print";
var $e92e13ae65c52602$var$dependencies = [
    "typed"
];
var $e92e13ae65c52602$export$ea4b9d9569ff81cc = /* #__PURE__ */ (0, $2mPYl.factory)($e92e13ae65c52602$var$name, $e92e13ae65c52602$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Interpolate values into a string template.
   *
   * Syntax:
   *
   *     math.print(template, values)
   *     math.print(template, values, precision)
   *     math.print(template, values, options)
   *
   * Example usage:
   *
   *     // the following outputs: 'Lucy is 5 years old'
   *     math.print('Lucy is $age years old', {age: 5})
   *
   *     // the following outputs: 'The value of pi is 3.141592654'
   *     math.print('The value of pi is $pi', {pi: math.pi}, 10)
   *
   *     // the following outputs: 'hello Mary! The date is 2013-03-23'
   *     math.print('Hello $user.name! The date is $date', {
   *       user: {
   *         name: 'Mary',
   *       },
   *       date: new Date(2013, 2, 23).toISOString().substring(0, 10)
   *     })
   *
   *     // the following outputs: 'My favorite fruits are apples and bananas !'
   *     math.print('My favorite fruits are $0 and $1 !', [
   *       'apples',
   *       'bananas'
   *     ])
   *
   * See also:
   *
   *     format
   *
   * @param {string} template           A string containing variable placeholders.
   * @param {Object | Array | Matrix}   values An object or array containing variables
   *                                    which will be filled in in the template.
   * @param {number | Object} [options] Formatting options,
   *                                    or the number of digits to format numbers.
   *                                    See function math.format for a description
   *                                    of all options.
   * @return {string} Interpolated string
   */ return typed($e92e13ae65c52602$var$name, {
        // note: Matrix will be converted automatically to an Array
        "string, Object | Array": $e92e13ae65c52602$var$_print,
        "string, Object | Array, number | Object": $e92e13ae65c52602$var$_print
    });
});
/**
 * Interpolate values into a string template.
 * @param {string} template
 * @param {Object} values
 * @param {number | Object} [options]
 * @returns {string} Interpolated string
 * @private
 */ function $e92e13ae65c52602$var$_print(template, values, options) {
    return template.replace(/\$([\w.]+)/g, function(original, key) {
        var keys = key.split(".");
        var value = values[keys.shift()];
        while(keys.length && value !== undefined){
            var k = keys.shift();
            value = k ? value[k] : value + ".";
        }
        if (value !== undefined) {
            if (!(0, $1amHZ.isString)(value)) return (0, $6NxuJ.format)(value, options);
            else return value;
        }
        return original;
    });
}

});

parcelRegister("3fJbS", function(module, exports) {

$parcel$export(module.exports, "createProd", function () { return $25e5d3bdf4665794$export$60310f756e9cfd41; });

var $e04i1 = parcelRequire("e04i1");

var $2mPYl = parcelRequire("2mPYl");

var $l16bl = parcelRequire("l16bl");
var $25e5d3bdf4665794$var$name = "prod";
var $25e5d3bdf4665794$var$dependencies = [
    "typed",
    "multiply"
];
var $25e5d3bdf4665794$export$60310f756e9cfd41 = /* #__PURE__ */ (0, $2mPYl.factory)($25e5d3bdf4665794$var$name, $25e5d3bdf4665794$var$dependencies, function(_ref) {
    var typed = _ref.typed, multiply = _ref.multiply;
    /**
   * Compute the product of a matrix or a list with values.
   * In case of a (multi dimensional) array or matrix, the sum of all
   * elements will be calculated.
   *
   * Syntax:
   *
   *     math.prod(a, b, c, ...)
   *     math.prod(A)
   *
   * Examples:
   *
   *     math.multiply(2, 3)           // returns 6
   *     math.prod(2, 3)               // returns 6
   *     math.prod(2, 3, 4)            // returns 24
   *     math.prod([2, 3, 4])          // returns 24
   *     math.prod([[2, 5], [4, 3]])   // returns 120
   *
   * See also:
   *
   *    mean, median, min, max, sum, std, variance
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The product of all values
   */ return typed($25e5d3bdf4665794$var$name, {
        // prod([a, b, c, d, ...])
        "Array | Matrix": _prod,
        // prod([a, b, c, d, ...], dim)
        "Array | Matrix, number | BigNumber": function ArrayMatrixNumberBigNumber(array, dim) {
            // TODO: implement prod(A, dim)
            throw new Error("prod(A, dim) is not yet supported"); // return reduce(arguments[0], arguments[1], math.prod)
        },
        // prod(a, b, c, d, ...)
        "...": function _(args) {
            return _prod(args);
        }
    });
    /**
   * Recursively calculate the product of an n-dimensional array
   * @param {Array} array
   * @return {number} prod
   * @private
   */ function _prod(array) {
        var prod;
        (0, $e04i1.deepForEach)(array, function(value) {
            try {
                prod = prod === undefined ? value : multiply(prod, value);
            } catch (err) {
                throw (0, $l16bl.improveErrorMessage)(err, "prod", value);
            }
        });
        if (prod === undefined) throw new Error("Cannot calculate prod of an empty array");
        return prod;
    }
});

});

parcelRegister("7Hu1z", function(module, exports) {

$parcel$export(module.exports, "createQr", function () { return $59b3d6c179105a1e$export$39b52312ba2c4d03; });

var $2mPYl = parcelRequire("2mPYl");
function $59b3d6c179105a1e$var$_extends() {
    $59b3d6c179105a1e$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $59b3d6c179105a1e$var$_extends.apply(this, arguments);
}
var $59b3d6c179105a1e$var$name = "qr";
var $59b3d6c179105a1e$var$dependencies = [
    "typed",
    "matrix",
    "zeros",
    "identity",
    "isZero",
    "equal",
    "sign",
    "sqrt",
    "conj",
    "unaryMinus",
    "addScalar",
    "divideScalar",
    "multiplyScalar",
    "subtract",
    "complex"
];
var $59b3d6c179105a1e$export$39b52312ba2c4d03 = /* #__PURE__ */ (0, $2mPYl.factory)($59b3d6c179105a1e$var$name, $59b3d6c179105a1e$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, zeros = _ref.zeros, identity = _ref.identity, isZero = _ref.isZero, equal = _ref.equal, sign = _ref.sign, sqrt = _ref.sqrt, conj = _ref.conj, unaryMinus = _ref.unaryMinus, addScalar = _ref.addScalar, divideScalar = _ref.divideScalar, multiplyScalar = _ref.multiplyScalar, subtract = _ref.subtract, complex = _ref.complex;
    /**
   * Calculate the Matrix QR decomposition. Matrix `A` is decomposed in
   * two matrices (`Q`, `R`) where `Q` is an
   * orthogonal matrix and `R` is an upper triangular matrix.
   *
   * Syntax:
   *
   *    math.qr(A)
   *
   * Example:
   *
   *    const m = [
   *      [1, -1,  4],
   *      [1,  4, -2],
   *      [1,  4,  2],
   *      [1,  -1, 0]
   *    ]
   *    const result = math.qr(m)
   *    // r = {
   *    //   Q: [
   *    //     [0.5, -0.5,   0.5],
   *    //     [0.5,  0.5,  -0.5],
   *    //     [0.5,  0.5,   0.5],
   *    //     [0.5, -0.5,  -0.5],
   *    //   ],
   *    //   R: [
   *    //     [2, 3,  2],
   *    //     [0, 5, -2],
   *    //     [0, 0,  4],
   *    //     [0, 0,  0]
   *    //   ]
   *    // }
   *
   * See also:
   *
   *    lup, lusolve
   *
   * @param {Matrix | Array} A    A two dimensional matrix or array
   * for which to get the QR decomposition.
   *
   * @return {{Q: Array | Matrix, R: Array | Matrix}} Q: the orthogonal
   * matrix and R: the upper triangular matrix
   */ return $59b3d6c179105a1e$var$_extends(typed($59b3d6c179105a1e$var$name, {
        DenseMatrix: function DenseMatrix(m) {
            return _denseQR(m);
        },
        SparseMatrix: function SparseMatrix(m) {
            return _sparseQR(m);
        },
        Array: function Array(a) {
            // create dense matrix from array
            var m = matrix(a); // lup, use matrix implementation
            var r = _denseQR(m); // result
            return {
                Q: r.Q.valueOf(),
                R: r.R.valueOf()
            };
        }
    }), {
        _denseQRimpl: _denseQRimpl
    });
    function _denseQRimpl(m) {
        // rows & columns (m x n)
        var rows = m._size[0]; // m
        var cols = m._size[1]; // n
        var Q = identity([
            rows
        ], "dense");
        var Qdata = Q._data;
        var R = m.clone();
        var Rdata = R._data; // vars
        var i, j, k;
        var w = zeros([
            rows
        ], "");
        for(k = 0; k < Math.min(cols, rows); ++k){
            /*
       * **k-th Household matrix**
       *
       * The matrix I - 2*v*transpose(v)
       * x     = first column of A
       * x1    = first element of x
       * alpha = x1 / |x1| * |x|
       * e1    = tranpose([1, 0, 0, ...])
       * u     = x - alpha * e1
       * v     = u / |u|
       *
       * Household matrix = I - 2 * v * tranpose(v)
       *
       *  * Initially Q = I and R = A.
       *  * Household matrix is a reflection in a plane normal to v which
       *    will zero out all but the top right element in R.
       *  * Appplying reflection to both Q and R will not change product.
       *  * Repeat this process on the (1,1) minor to get R as an upper
       *    triangular matrix.
       *  * Reflections leave the magnitude of the columns of Q unchanged
       *    so Q remains othoganal.
       *
       */ var pivot = Rdata[k][k];
            var sgn = unaryMinus(equal(pivot, 0) ? 1 : sign(pivot));
            var conjSgn = conj(sgn);
            var alphaSquared = 0;
            for(i = k; i < rows; i++)alphaSquared = addScalar(alphaSquared, multiplyScalar(Rdata[i][k], conj(Rdata[i][k])));
            var alpha = multiplyScalar(sgn, sqrt(alphaSquared));
            if (!isZero(alpha)) {
                // first element in vector u
                var u1 = subtract(pivot, alpha); // w = v * u1 / |u|    (only elements k to (rows-1) are used)
                w[k] = 1;
                for(i = k + 1; i < rows; i++)w[i] = divideScalar(Rdata[i][k], u1);
                 // tau = - conj(u1 / alpha)
                var tau = unaryMinus(conj(divideScalar(u1, alpha)));
                var s = void 0;
                /*
         * tau and w have been choosen so that
         *
         * 2 * v * tranpose(v) = tau * w * tranpose(w)
         */ /*
         * -- calculate R = R - tau * w * tranpose(w) * R --
         * Only do calculation with rows k to (rows-1)
         * Additionally columns 0 to (k-1) will not be changed by this
         *   multiplication so do not bother recalculating them
         */ for(j = k; j < cols; j++){
                    s = 0.0; // calculate jth element of [tranpose(w) * R]
                    for(i = k; i < rows; i++)s = addScalar(s, multiplyScalar(conj(w[i]), Rdata[i][j]));
                     // calculate the jth element of [tau * transpose(w) * R]
                    s = multiplyScalar(s, tau);
                    for(i = k; i < rows; i++)Rdata[i][j] = multiplyScalar(subtract(Rdata[i][j], multiplyScalar(w[i], s)), conjSgn);
                }
                /*
         * -- calculate Q = Q - tau * Q * w * transpose(w) --
         * Q is a square matrix (rows x rows)
         * Only do calculation with columns k to (rows-1)
         * Additionally rows 0 to (k-1) will not be changed by this
         *   multiplication so do not bother recalculating them
         */ for(i = 0; i < rows; i++){
                    s = 0.0; // calculate ith element of [Q * w]
                    for(j = k; j < rows; j++)s = addScalar(s, multiplyScalar(Qdata[i][j], w[j]));
                     // calculate the ith element of [tau * Q * w]
                    s = multiplyScalar(s, tau);
                    for(j = k; j < rows; ++j)Qdata[i][j] = divideScalar(subtract(Qdata[i][j], multiplyScalar(s, conj(w[j]))), conjSgn);
                }
            }
        } // return matrices
        return {
            Q: Q,
            R: R,
            toString: function toString() {
                return "Q: " + this.Q.toString() + "\nR: " + this.R.toString();
            }
        };
    }
    function _denseQR(m) {
        var ret = _denseQRimpl(m);
        var Rdata = ret.R._data;
        if (m._data.length > 0) {
            var zero = Rdata[0][0].type === "Complex" ? complex(0) : 0;
            for(var i = 0; i < Rdata.length; ++i)for(var j = 0; j < i && j < (Rdata[0] || []).length; ++j)Rdata[i][j] = zero;
        }
        return ret;
    }
    function _sparseQR(m) {
        throw new Error("qr not implemented for sparse matrices yet");
    }
});

});

parcelRegister("2V5Tl", function(module, exports) {

$parcel$export(module.exports, "createQuantileSeq", function () { return $220579975ec87d2b$export$524607d17ea053e9; });

var $1amHZ = parcelRequire("1amHZ");

var $kFRKb = parcelRequire("kFRKb");

var $5WdrK = parcelRequire("5WdrK");

var $2mPYl = parcelRequire("2mPYl");
var $220579975ec87d2b$var$name = "quantileSeq";
var $220579975ec87d2b$var$dependencies = [
    "typed",
    "add",
    "multiply",
    "partitionSelect",
    "compare"
];
var $220579975ec87d2b$export$524607d17ea053e9 = /* #__PURE__ */ (0, $2mPYl.factory)($220579975ec87d2b$var$name, $220579975ec87d2b$var$dependencies, function(_ref) {
    var typed = _ref.typed, add = _ref.add, multiply = _ref.multiply, partitionSelect = _ref.partitionSelect, compare = _ref.compare;
    /**
   * Compute the prob order quantile of a matrix or a list with values.
   * The sequence is sorted and the middle value is returned.
   * Supported types of sequence values are: Number, BigNumber, Unit
   * Supported types of probability are: Number, BigNumber
   *
   * In case of a (multi dimensional) array or matrix, the prob order quantile
   * of all elements will be calculated.
   *
   * Syntax:
   *
   *     math.quantileSeq(A, prob[, sorted])
   *     math.quantileSeq(A, [prob1, prob2, ...][, sorted])
   *     math.quantileSeq(A, N[, sorted])
   *
   * Examples:
   *
   *     math.quantileSeq([3, -1, 5, 7], 0.5)         // returns 4
   *     math.quantileSeq([3, -1, 5, 7], [1/3, 2/3])  // returns [3, 5]
   *     math.quantileSeq([3, -1, 5, 7], 2)           // returns [3, 5]
   *     math.quantileSeq([-1, 3, 5, 7], 0.5, true)   // returns 4
   *
   * See also:
   *
   *     median, mean, min, max, sum, prod, std, variance
   *
   * @param {Array, Matrix} data                A single matrix or Array
   * @param {Number, BigNumber, Array} probOrN  prob is the order of the quantile, while N is
   *                                            the amount of evenly distributed steps of
   *                                            probabilities; only one of these options can
   *                                            be provided
   * @param {Boolean} sorted=false              is data sorted in ascending order
   * @return {Number, BigNumber, Unit, Array}   Quantile(s)
   */ function quantileSeq(data, probOrN, sorted) {
        var probArr, dataArr, one;
        if (arguments.length < 2 || arguments.length > 3) throw new SyntaxError("Function quantileSeq requires two or three parameters");
        if ((0, $1amHZ.isCollection)(data)) {
            sorted = sorted || false;
            if (typeof sorted === "boolean") {
                dataArr = data.valueOf();
                if ((0, $1amHZ.isNumber)(probOrN)) {
                    if (probOrN < 0) throw new Error("N/prob must be non-negative");
                    if (probOrN <= 1) // quantileSeq([a, b, c, d, ...], prob[,sorted])
                    return _quantileSeq(dataArr, probOrN, sorted);
                    if (probOrN > 1) {
                        // quantileSeq([a, b, c, d, ...], N[,sorted])
                        if (!(0, $kFRKb.isInteger)(probOrN)) throw new Error("N must be a positive integer");
                        var nPlusOne = probOrN + 1;
                        probArr = new Array(probOrN);
                        for(var i = 0; i < probOrN;)probArr[i] = _quantileSeq(dataArr, ++i / nPlusOne, sorted);
                        return probArr;
                    }
                }
                if ((0, $1amHZ.isBigNumber)(probOrN)) {
                    var BigNumber = probOrN.constructor;
                    if (probOrN.isNegative()) throw new Error("N/prob must be non-negative");
                    one = new BigNumber(1);
                    if (probOrN.lte(one)) // quantileSeq([a, b, c, d, ...], prob[,sorted])
                    return new BigNumber(_quantileSeq(dataArr, probOrN, sorted));
                    if (probOrN.gt(one)) {
                        // quantileSeq([a, b, c, d, ...], N[,sorted])
                        if (!probOrN.isInteger()) throw new Error("N must be a positive integer");
                         // largest possible Array length is 2^32-1
                        // 2^32 < 10^15, thus safe conversion guaranteed
                        var intN = probOrN.toNumber();
                        if (intN > 4294967295) throw new Error("N must be less than or equal to 2^32-1, as that is the maximum length of an Array");
                        var _nPlusOne = new BigNumber(intN + 1);
                        probArr = new Array(intN);
                        for(var _i = 0; _i < intN;)probArr[_i] = new BigNumber(_quantileSeq(dataArr, new BigNumber(++_i).div(_nPlusOne), sorted));
                        return probArr;
                    }
                }
                if (Array.isArray(probOrN)) {
                    // quantileSeq([a, b, c, d, ...], [prob1, prob2, ...][,sorted])
                    probArr = new Array(probOrN.length);
                    for(var _i2 = 0; _i2 < probArr.length; ++_i2){
                        var currProb = probOrN[_i2];
                        if ((0, $1amHZ.isNumber)(currProb)) {
                            if (currProb < 0 || currProb > 1) throw new Error("Probability must be between 0 and 1, inclusive");
                        } else if ((0, $1amHZ.isBigNumber)(currProb)) {
                            one = new currProb.constructor(1);
                            if (currProb.isNegative() || currProb.gt(one)) throw new Error("Probability must be between 0 and 1, inclusive");
                        } else throw new TypeError("Unexpected type of argument in function quantileSeq"); // FIXME: becomes redundant when converted to typed-function
                        probArr[_i2] = _quantileSeq(dataArr, currProb, sorted);
                    }
                    return probArr;
                }
                throw new TypeError("Unexpected type of argument in function quantileSeq"); // FIXME: becomes redundant when converted to typed-function
            }
            throw new TypeError("Unexpected type of argument in function quantileSeq"); // FIXME: becomes redundant when converted to typed-function
        }
        throw new TypeError("Unexpected type of argument in function quantileSeq"); // FIXME: becomes redundant when converted to typed-function
    }
    /**
   * Calculate the prob order quantile of an n-dimensional array.
   *
   * @param {Array} array
   * @param {Number, BigNumber} prob
   * @param {Boolean} sorted
   * @return {Number, BigNumber, Unit} prob order quantile
   * @private
   */ function _quantileSeq(array, prob, sorted) {
        var flat = (0, $5WdrK.flatten)(array);
        var len = flat.length;
        if (len === 0) throw new Error("Cannot calculate quantile of an empty sequence");
        if ((0, $1amHZ.isNumber)(prob)) {
            var _index = prob * (len - 1);
            var _fracPart = _index % 1;
            if (_fracPart === 0) {
                var value = sorted ? flat[_index] : partitionSelect(flat, _index);
                validate(value);
                return value;
            }
            var _integerPart = Math.floor(_index);
            var _left;
            var _right;
            if (sorted) {
                _left = flat[_integerPart];
                _right = flat[_integerPart + 1];
            } else {
                _right = partitionSelect(flat, _integerPart + 1); // max of partition is kth largest
                _left = flat[_integerPart];
                for(var i = 0; i < _integerPart; ++i)if (compare(flat[i], _left) > 0) _left = flat[i];
            }
            validate(_left);
            validate(_right); // Q(prob) = (1-f)*A[floor(index)] + f*A[floor(index)+1]
            return add(multiply(_left, 1 - _fracPart), multiply(_right, _fracPart));
        } // If prob is a BigNumber
        var index = prob.times(len - 1);
        if (index.isInteger()) {
            index = index.toNumber();
            var _value = sorted ? flat[index] : partitionSelect(flat, index);
            validate(_value);
            return _value;
        }
        var integerPart = index.floor();
        var fracPart = index.minus(integerPart);
        var integerPartNumber = integerPart.toNumber();
        var left;
        var right;
        if (sorted) {
            left = flat[integerPartNumber];
            right = flat[integerPartNumber + 1];
        } else {
            right = partitionSelect(flat, integerPartNumber + 1); // max of partition is kth largest
            left = flat[integerPartNumber];
            for(var _i3 = 0; _i3 < integerPartNumber; ++_i3)if (compare(flat[_i3], left) > 0) left = flat[_i3];
        }
        validate(left);
        validate(right); // Q(prob) = (1-f)*A[floor(index)] + f*A[floor(index)+1]
        var one = new fracPart.constructor(1);
        return add(multiply(left, one.minus(fracPart)), multiply(right, fracPart));
    }
    /**
   * Check if array value types are valid, throw error otherwise.
   * @param {number | BigNumber | Unit} x
   * @param {number | BigNumber | Unit} x
   * @private
   */ var validate = typed({
        "number | BigNumber | Unit": function numberBigNumberUnit(x) {
            return x;
        }
    });
    return quantileSeq;
});

});

parcelRegister("hmmXX", function(module, exports) {

$parcel$export(module.exports, "createRandom", function () { return $ca364e536dc74043$export$5c03d20f483e909a; });

var $2mPYl = parcelRequire("2mPYl");

var $1amHZ = parcelRequire("1amHZ");

var $kWMJ7 = parcelRequire("kWMJ7");

var $gtKEf = parcelRequire("gtKEf");
var $ca364e536dc74043$var$name = "random";
var $ca364e536dc74043$var$dependencies = [
    "typed",
    "config",
    "?on"
];
var $ca364e536dc74043$export$5c03d20f483e909a = /* #__PURE__ */ (0, $2mPYl.factory)($ca364e536dc74043$var$name, $ca364e536dc74043$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, on = _ref.on;
    // seeded pseudo random number generator
    var rng = (0, $kWMJ7.createRng)(config.randomSeed);
    if (on) on("config", function(curr, prev) {
        if (curr.randomSeed !== prev.randomSeed) rng = (0, $kWMJ7.createRng)(curr.randomSeed);
    });
    /**
   * Return a random number larger or equal to `min` and smaller than `max`
   * using a uniform distribution.
   *
   * Syntax:
   *
   *     math.random()                // generate a random number between 0 and 1
   *     math.random(max)             // generate a random number between 0 and max
   *     math.random(min, max)        // generate a random number between min and max
   *     math.random(size)            // generate a matrix with random numbers between 0 and 1
   *     math.random(size, max)       // generate a matrix with random numbers between 0 and max
   *     math.random(size, min, max)  // generate a matrix with random numbers between min and max
   *
   * Examples:
   *
   *     math.random()       // returns a random number between 0 and 1
   *     math.random(100)    // returns a random number between 0 and 100
   *     math.random(30, 40) // returns a random number between 30 and 40
   *     math.random([2, 3]) // returns a 2x3 matrix with random numbers between 0 and 1
   *
   * See also:
   *
   *     randomInt, pickRandom
   *
   * @param {Array | Matrix} [size] If provided, an array or matrix with given
   *                                size and filled with random values is returned
   * @param {number} [min]  Minimum boundary for the random value, included
   * @param {number} [max]  Maximum boundary for the random value, excluded
   * @return {number | Array | Matrix} A random number
   */ return typed($ca364e536dc74043$var$name, {
        "": function _() {
            return _random(0, 1);
        },
        number: function number(max) {
            return _random(0, max);
        },
        "number, number": function numberNumber(min, max) {
            return _random(min, max);
        },
        "Array | Matrix": function ArrayMatrix(size) {
            return _randomMatrix(size, 0, 1);
        },
        "Array | Matrix, number": function ArrayMatrixNumber(size, max) {
            return _randomMatrix(size, 0, max);
        },
        "Array | Matrix, number, number": function ArrayMatrixNumberNumber(size, min, max) {
            return _randomMatrix(size, min, max);
        }
    });
    function _randomMatrix(size, min, max) {
        var res = (0, $gtKEf.randomMatrix)(size.valueOf(), function() {
            return _random(min, max);
        });
        return (0, $1amHZ.isMatrix)(size) ? size.create(res) : res;
    }
    function _random(min, max) {
        return min + rng() * (max - min);
    }
}); // number only implementation of random, no matrix support
var $ca364e536dc74043$export$267a132af241f602 = /* #__PURE__ */ (0, $2mPYl.factory)($ca364e536dc74043$var$name, [
    "typed",
    "config",
    "?on"
], function(_ref2) {
    var typed = _ref2.typed, config = _ref2.config, on = _ref2.on, matrix = _ref2.matrix;
    // seeded pseudo random number generator1
    var rng = (0, $kWMJ7.createRng)(config.randomSeed);
    if (on) on("config", function(curr, prev) {
        if (curr.randomSeed !== prev.randomSeed) rng = (0, $kWMJ7.createRng)(curr.randomSeed);
    });
    return typed($ca364e536dc74043$var$name, {
        "": function _() {
            return _random(0, 1);
        },
        number: function number(max) {
            return _random(0, max);
        },
        "number, number": function numberNumber(min, max) {
            return _random(min, max);
        }
    });
    function _random(min, max) {
        return min + rng() * (max - min);
    }
});

});
parcelRegister("gtKEf", function(module, exports) {

$parcel$export(module.exports, "randomMatrix", function () { return $bff38a255809e0e9$export$6549281d357a44ec; });
/**
 * This is a util function for generating a random matrix recursively.
 * @param {number[]} size
 * @param {function} random
 * @returns {Array}
 */ function $bff38a255809e0e9$export$6549281d357a44ec(size, random) {
    var data = [];
    size = size.slice(0);
    if (size.length > 1) for(var i = 0, length = size.shift(); i < length; i++)data.push($bff38a255809e0e9$export$6549281d357a44ec(size, random));
    else for(var _i = 0, _length = size.shift(); _i < _length; _i++)data.push(random());
    return data;
}

});


parcelRegister("bzpJA", function(module, exports) {

$parcel$export(module.exports, "createRandomInt", function () { return $86c6ecdf2dba88c3$export$e158da47ae479dd4; });

var $2mPYl = parcelRequire("2mPYl");

var $gtKEf = parcelRequire("gtKEf");

var $kWMJ7 = parcelRequire("kWMJ7");

var $1amHZ = parcelRequire("1amHZ");
var $86c6ecdf2dba88c3$var$name = "randomInt";
var $86c6ecdf2dba88c3$var$dependencies = [
    "typed",
    "config",
    "?on"
];
var $86c6ecdf2dba88c3$export$e158da47ae479dd4 = /* #__PURE__ */ (0, $2mPYl.factory)($86c6ecdf2dba88c3$var$name, $86c6ecdf2dba88c3$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, on = _ref.on;
    // seeded pseudo random number generator
    var rng = (0, $kWMJ7.createRng)(config.randomSeed);
    if (on) on("config", function(curr, prev) {
        if (curr.randomSeed !== prev.randomSeed) rng = (0, $kWMJ7.createRng)(curr.randomSeed);
    });
    /**
   * Return a random integer number larger or equal to `min` and smaller than `max`
   * using a uniform distribution.
   *
   * Syntax:
   *
   *     math.randomInt()                // generate a random integer between 0 and 1
   *     math.randomInt(max)             // generate a random integer between 0 and max
   *     math.randomInt(min, max)        // generate a random integer between min and max
   *     math.randomInt(size)            // generate a matrix with random integer between 0 and 1
   *     math.randomInt(size, max)       // generate a matrix with random integer between 0 and max
   *     math.randomInt(size, min, max)  // generate a matrix with random integer between min and max
   *
   * Examples:
   *
   *     math.randomInt(100)    // returns a random integer between 0 and 100
   *     math.randomInt(30, 40) // returns a random integer between 30 and 40
   *     math.randomInt([2, 3]) // returns a 2x3 matrix with random integers between 0 and 1
   *
   * See also:
   *
   *     random, pickRandom
   *
   * @param {Array | Matrix} [size] If provided, an array or matrix with given
   *                                size and filled with random values is returned
   * @param {number} [min]  Minimum boundary for the random value, included
   * @param {number} [max]  Maximum boundary for the random value, excluded
   * @return {number | Array | Matrix} A random integer value
   */ return typed($86c6ecdf2dba88c3$var$name, {
        "": function _() {
            return _randomInt(0, 1);
        },
        number: function number(max) {
            return _randomInt(0, max);
        },
        "number, number": function numberNumber(min, max) {
            return _randomInt(min, max);
        },
        "Array | Matrix": function ArrayMatrix(size) {
            return _randomIntMatrix(size, 0, 1);
        },
        "Array | Matrix, number": function ArrayMatrixNumber(size, max) {
            return _randomIntMatrix(size, 0, max);
        },
        "Array | Matrix, number, number": function ArrayMatrixNumberNumber(size, min, max) {
            return _randomIntMatrix(size, min, max);
        }
    });
    function _randomIntMatrix(size, min, max) {
        var res = (0, $gtKEf.randomMatrix)(size.valueOf(), function() {
            return _randomInt(min, max);
        });
        return (0, $1amHZ.isMatrix)(size) ? size.create(res) : res;
    }
    function _randomInt(min, max) {
        return Math.floor(min + rng() * (max - min));
    }
});

});

parcelRegister("8KyMk", function(module, exports) {

$parcel$export(module.exports, "createRangeClass", function () { return $65ed98dfcbc1f85f$export$e87cc8d3f29c5e1b; });

var $1amHZ = parcelRequire("1amHZ");

var $kFRKb = parcelRequire("kFRKb");

var $2mPYl = parcelRequire("2mPYl");
var $65ed98dfcbc1f85f$var$name = "Range";
var $65ed98dfcbc1f85f$var$dependencies = [];
var $65ed98dfcbc1f85f$export$e87cc8d3f29c5e1b = /* #__PURE__ */ (0, $2mPYl.factory)($65ed98dfcbc1f85f$var$name, $65ed98dfcbc1f85f$var$dependencies, function() {
    /**
   * Create a range. A range has a start, step, and end, and contains functions
   * to iterate over the range.
   *
   * A range can be constructed as:
   *
   *     const range = new Range(start, end)
   *     const range = new Range(start, end, step)
   *
   * To get the result of the range:
   *     range.forEach(function (x) {
   *         console.log(x)
   *     })
   *     range.map(function (x) {
   *         return math.sin(x)
   *     })
   *     range.toArray()
   *
   * Example usage:
   *
   *     const c = new Range(2, 6)       // 2:1:5
   *     c.toArray()                     // [2, 3, 4, 5]
   *     const d = new Range(2, -3, -1)  // 2:-1:-2
   *     d.toArray()                     // [2, 1, 0, -1, -2]
   *
   * @class Range
   * @constructor Range
   * @param {number} start  included lower bound
   * @param {number} end    excluded upper bound
   * @param {number} [step] step size, default value is 1
   */ function Range(start, end, step) {
        if (!(this instanceof Range)) throw new SyntaxError("Constructor must be called with the new operator");
        var hasStart = start !== null && start !== undefined;
        var hasEnd = end !== null && end !== undefined;
        var hasStep = step !== null && step !== undefined;
        if (hasStart) {
            if ((0, $1amHZ.isBigNumber)(start)) start = start.toNumber();
            else if (typeof start !== "number") throw new TypeError("Parameter start must be a number");
        }
        if (hasEnd) {
            if ((0, $1amHZ.isBigNumber)(end)) end = end.toNumber();
            else if (typeof end !== "number") throw new TypeError("Parameter end must be a number");
        }
        if (hasStep) {
            if ((0, $1amHZ.isBigNumber)(step)) step = step.toNumber();
            else if (typeof step !== "number") throw new TypeError("Parameter step must be a number");
        }
        this.start = hasStart ? parseFloat(start) : 0;
        this.end = hasEnd ? parseFloat(end) : 0;
        this.step = hasStep ? parseFloat(step) : 1;
    }
    /**
   * Attach type information
   */ Range.prototype.type = "Range";
    Range.prototype.isRange = true;
    /**
   * Parse a string into a range,
   * The string contains the start, optional step, and end, separated by a colon.
   * If the string does not contain a valid range, null is returned.
   * For example str='0:2:11'.
   * @memberof Range
   * @param {string} str
   * @return {Range | null} range
   */ Range.parse = function(str) {
        if (typeof str !== "string") return null;
        var args = str.split(":");
        var nums = args.map(function(arg) {
            return parseFloat(arg);
        });
        var invalid = nums.some(function(num) {
            return isNaN(num);
        });
        if (invalid) return null;
        switch(nums.length){
            case 2:
                return new Range(nums[0], nums[1]);
            case 3:
                return new Range(nums[0], nums[2], nums[1]);
            default:
                return null;
        }
    };
    /**
   * Create a clone of the range
   * @return {Range} clone
   */ Range.prototype.clone = function() {
        return new Range(this.start, this.end, this.step);
    };
    /**
   * Retrieve the size of the range.
   * Returns an array containing one number, the number of elements in the range.
   * @memberof Range
   * @returns {number[]} size
   */ Range.prototype.size = function() {
        var len = 0;
        var start = this.start;
        var step = this.step;
        var end = this.end;
        var diff = end - start;
        if ((0, $kFRKb.sign)(step) === (0, $kFRKb.sign)(diff)) len = Math.ceil(diff / step);
        else if (diff === 0) len = 0;
        if (isNaN(len)) len = 0;
        return [
            len
        ];
    };
    /**
   * Calculate the minimum value in the range
   * @memberof Range
   * @return {number | undefined} min
   */ Range.prototype.min = function() {
        var size = this.size()[0];
        if (size > 0) {
            if (this.step > 0) // positive step
            return this.start;
            else // negative step
            return this.start + (size - 1) * this.step;
        } else return undefined;
    };
    /**
   * Calculate the maximum value in the range
   * @memberof Range
   * @return {number | undefined} max
   */ Range.prototype.max = function() {
        var size = this.size()[0];
        if (size > 0) {
            if (this.step > 0) // positive step
            return this.start + (size - 1) * this.step;
            else // negative step
            return this.start;
        } else return undefined;
    };
    /**
   * Execute a callback function for each value in the range.
   * @memberof Range
   * @param {function} callback   The callback method is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Range being traversed.
   */ Range.prototype.forEach = function(callback) {
        var x = this.start;
        var step = this.step;
        var end = this.end;
        var i = 0;
        if (step > 0) while(x < end){
            callback(x, [
                i
            ], this);
            x += step;
            i++;
        }
        else if (step < 0) while(x > end){
            callback(x, [
                i
            ], this);
            x += step;
            i++;
        }
    };
    /**
   * Execute a callback function for each value in the Range, and return the
   * results as an array
   * @memberof Range
   * @param {function} callback   The callback method is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   * @returns {Array} array
   */ Range.prototype.map = function(callback) {
        var array = [];
        this.forEach(function(value, index, obj) {
            array[index[0]] = callback(value, index, obj);
        });
        return array;
    };
    /**
   * Create an Array with a copy of the Ranges data
   * @memberof Range
   * @returns {Array} array
   */ Range.prototype.toArray = function() {
        var array = [];
        this.forEach(function(value, index) {
            array[index[0]] = value;
        });
        return array;
    };
    /**
   * Get the primitive value of the Range, a one dimensional array
   * @memberof Range
   * @returns {Array} array
   */ Range.prototype.valueOf = function() {
        // TODO: implement a caching mechanism for range.valueOf()
        return this.toArray();
    };
    /**
   * Get a string representation of the range, with optional formatting options.
   * Output is formatted as 'start:step:end', for example '2:6' or '0:0.2:11'
   * @memberof Range
   * @param {Object | number | function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @returns {string} str
   */ Range.prototype.format = function(options) {
        var str = (0, $kFRKb.format)(this.start, options);
        if (this.step !== 1) str += ":" + (0, $kFRKb.format)(this.step, options);
        str += ":" + (0, $kFRKb.format)(this.end, options);
        return str;
    };
    /**
   * Get a string representation of the range.
   * @memberof Range
   * @returns {string}
   */ Range.prototype.toString = function() {
        return this.format();
    };
    /**
   * Get a JSON representation of the range
   * @memberof Range
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "Range", "start": 2, "end": 4, "step": 1}`
   */ Range.prototype.toJSON = function() {
        return {
            mathjs: "Range",
            start: this.start,
            end: this.end,
            step: this.step
        };
    };
    /**
   * Instantiate a Range from a JSON object
   * @memberof Range
   * @param {Object} json A JSON object structured as:
   *                      `{"mathjs": "Range", "start": 2, "end": 4, "step": 1}`
   * @return {Range}
   */ Range.fromJSON = function(json) {
        return new Range(json.start, json.end, json.step);
    };
    return Range;
}, {
    isClass: true
});

});

parcelRegister("arz0k", function(module, exports) {

$parcel$export(module.exports, "createRe", function () { return $79a79424b611815b$export$803e46d0de790dbf; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");
var $79a79424b611815b$var$name = "re";
var $79a79424b611815b$var$dependencies = [
    "typed"
];
var $79a79424b611815b$export$803e46d0de790dbf = /* #__PURE__ */ (0, $2mPYl.factory)($79a79424b611815b$var$name, $79a79424b611815b$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Get the real part of a complex number.
   * For a complex number `a + bi`, the function returns `a`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.re(x)
   *
   * Examples:
   *
   *    const a = math.complex(2, 3)
   *    math.re(a)                     // returns number 2
   *    math.im(a)                     // returns number 3
   *
   *    math.re(math.complex('-5.2i')) // returns number 0
   *    math.re(math.complex(2.4))     // returns number 2.4
   *
   * See also:
   *
   *    im, conj, abs, arg
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            A complex number or array with complex numbers
   * @return {number | BigNumber | Array | Matrix} The real part of x
   */ var re = typed($79a79424b611815b$var$name, {
        number: function number(x) {
            return x;
        },
        BigNumber: function BigNumber(x) {
            return x;
        },
        Complex: function Complex(x) {
            return x.re;
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, re);
        }
    });
    return re;
});

});

parcelRegister("ifoxr", function(module, exports) {

$parcel$export(module.exports, "createReplacer", function () { return $d48ca9816d8feb04$export$481a522c866104eb; });

var $2mPYl = parcelRequire("2mPYl");
var $d48ca9816d8feb04$var$name = "replacer";
var $d48ca9816d8feb04$var$dependencies = [];
var $d48ca9816d8feb04$export$481a522c866104eb = /* #__PURE__ */ (0, $2mPYl.factory)($d48ca9816d8feb04$var$name, $d48ca9816d8feb04$var$dependencies, function() {
    /**
   * Stringify data types into their JSON representation.
   * Most data types can be serialized using their `.toJSON` method,
   * but not all, for example the number `Infinity`. For these cases you have
   * to use the replacer. Example usage:
   *
   *     JSON.stringify([2, Infinity], math.replacer)
   *
   * @param {string} key
   * @param {*} value
   * @returns {*} Returns the replaced object
   */ return function replacer(key, value) {
        // the numeric values Infinitiy, -Infinity, and NaN cannot be serialized to JSON
        if (typeof value === "number" && (!isFinite(value) || isNaN(value))) return {
            mathjs: "number",
            value: String(value)
        };
        return value;
    };
});

});

parcelRegister("kLs7z", function(module, exports) {

$parcel$export(module.exports, "createReshape", function () { return $f1de02b24f11dedc$export$76c9752f34fb3440; });

var $5WdrK = parcelRequire("5WdrK");

var $2mPYl = parcelRequire("2mPYl");
var $f1de02b24f11dedc$var$name = "reshape";
var $f1de02b24f11dedc$var$dependencies = [
    "typed",
    "isInteger",
    "matrix"
];
var $f1de02b24f11dedc$export$76c9752f34fb3440 = /* #__PURE__ */ (0, $2mPYl.factory)($f1de02b24f11dedc$var$name, $f1de02b24f11dedc$var$dependencies, function(_ref) {
    var typed = _ref.typed, isInteger = _ref.isInteger, matrix = _ref.matrix;
    /**
   * Reshape a multi dimensional array to fit the specified dimensions
   *
   * Syntax:
   *
   *     math.reshape(x, sizes)
   *
   * Examples:
   *
   *     math.reshape([1, 2, 3, 4, 5, 6], [2, 3])
   *     // returns Array  [[1, 2, 3], [4, 5, 6]]
   *
   *     math.reshape([[1, 2], [3, 4]], [1, 4])
   *     // returns Array  [[1, 2, 3, 4]]
   *
   *     math.reshape([[1, 2], [3, 4]], [4])
   *     // returns Array [1, 2, 3, 4]
   *
   *     const x = math.matrix([1, 2, 3, 4, 5, 6, 7, 8])
   *     math.reshape(x, [2, 2, 2])
   *     // returns Matrix [[[1, 2], [3, 4]], [[5, 6], [7, 8]]]
   *
   * See also:
   *
   *     size, squeeze, resize
   *
   * @param {Array | Matrix | *} x  Matrix to be reshaped
   * @param {number[]} sizes        One dimensional array with integral sizes for
   *                                each dimension
   *
   * @return {* | Array | Matrix}   A reshaped clone of matrix `x`
   *
   * @throws {TypeError}            If `sizes` does not contain solely integers
   * @throws {DimensionError}       If the product of the new dimension sizes does
   *                                not equal that of the old ones
   */ return typed($f1de02b24f11dedc$var$name, {
        "Matrix, Array": function MatrixArray(x, sizes) {
            if (x.reshape) return x.reshape(sizes);
            else return matrix((0, $5WdrK.reshape)(x.valueOf(), sizes));
        },
        "Array, Array": function ArrayArray(x, sizes) {
            sizes.forEach(function(size) {
                if (!isInteger(size)) throw new TypeError("Invalid size for dimension: " + size);
            });
            return (0, $5WdrK.reshape)(x, sizes);
        }
    });
});

});

parcelRegister("62UxD", function(module, exports) {

$parcel$export(module.exports, "createResize", function () { return $466ec9f152b56406$export$58909557046ca413; });

var $1amHZ = parcelRequire("1amHZ");

var $hy7Bx = parcelRequire("hy7Bx");

var $j3yMF = parcelRequire("j3yMF");

var $kFRKb = parcelRequire("kFRKb");

var $6NxuJ = parcelRequire("6NxuJ");

var $7ITGG = parcelRequire("7ITGG");

var $5WdrK = parcelRequire("5WdrK");

var $2mPYl = parcelRequire("2mPYl");
var $466ec9f152b56406$var$name = "resize";
var $466ec9f152b56406$var$dependencies = [
    "config",
    "matrix"
];
var $466ec9f152b56406$export$58909557046ca413 = /* #__PURE__ */ (0, $2mPYl.factory)($466ec9f152b56406$var$name, $466ec9f152b56406$var$dependencies, function(_ref) {
    var config = _ref.config, matrix = _ref.matrix;
    /**
   * Resize a matrix
   *
   * Syntax:
   *
   *     math.resize(x, size)
   *     math.resize(x, size, defaultValue)
   *
   * Examples:
   *
   *     math.resize([1, 2, 3, 4, 5], [3]) // returns Array  [1, 2, 3]
   *     math.resize([1, 2, 3], [5], 0)    // returns Array  [1, 2, 3, 0, 0]
   *     math.resize(2, [2, 3], 0)         // returns Matrix [[2, 0, 0], [0, 0, 0]]
   *     math.resize("hello", [8], "!")    // returns string 'hello!!!'
   *
   * See also:
   *
   *     size, squeeze, subset, reshape
   *
   * @param {Array | Matrix | *} x             Matrix to be resized
   * @param {Array | Matrix} size              One dimensional array with numbers
   * @param {number | string} [defaultValue=0] Zero by default, except in
   *                                           case of a string, in that case
   *                                           defaultValue = ' '
   * @return {* | Array | Matrix} A resized clone of matrix `x`
   */ // TODO: rework resize to a typed-function
    return function resize(x, size, defaultValue) {
        if (arguments.length !== 2 && arguments.length !== 3) throw new (0, $j3yMF.ArgumentsError)("resize", arguments.length, 2, 3);
        if ((0, $1amHZ.isMatrix)(size)) size = size.valueOf(); // get Array
        if ((0, $1amHZ.isBigNumber)(size[0])) // convert bignumbers to numbers
        size = size.map(function(value) {
            return !(0, $1amHZ.isBigNumber)(value) ? value : value.toNumber();
        });
         // check x is a Matrix
        if ((0, $1amHZ.isMatrix)(x)) // use optimized matrix implementation, return copy
        return x.resize(size, defaultValue, true);
        if (typeof x === "string") // resize string
        return _resizeString(x, size, defaultValue);
         // check result should be a matrix
        var asMatrix = Array.isArray(x) ? false : config.matrix !== "Array";
        if (size.length === 0) {
            // output a scalar
            while(Array.isArray(x))x = x[0];
            return (0, $7ITGG.clone)(x);
        } else {
            // output an array/matrix
            if (!Array.isArray(x)) x = [
                x
            ];
            x = (0, $7ITGG.clone)(x);
            var res = (0, $5WdrK.resize)(x, size, defaultValue);
            return asMatrix ? matrix(res) : res;
        }
    };
    /**
   * Resize a string
   * @param {string} str
   * @param {number[]} size
   * @param {string} [defaultChar=' ']
   * @private
   */ function _resizeString(str, size, defaultChar) {
        if (defaultChar !== undefined) {
            if (typeof defaultChar !== "string" || defaultChar.length !== 1) throw new TypeError("Single character expected as defaultValue");
        } else defaultChar = " ";
        if (size.length !== 1) throw new (0, $hy7Bx.DimensionError)(size.length, 1);
        var len = size[0];
        if (typeof len !== "number" || !(0, $kFRKb.isInteger)(len)) throw new TypeError("Invalid size, must contain positive integers (size: " + (0, $6NxuJ.format)(size) + ")");
        if (str.length > len) return str.substring(0, len);
        else if (str.length < len) {
            var res = str;
            for(var i = 0, ii = len - str.length; i < ii; i++)res += defaultChar;
            return res;
        } else return str;
    }
});

});
parcelRegister("j3yMF", function(module, exports) {

$parcel$export(module.exports, "ArgumentsError", function () { return $ddf94786645a7a51$export$f27c2c74ddc37d80; });
/**
 * Create a syntax error with the message:
 *     'Wrong number of arguments in function <fn> (<count> provided, <min>-<max> expected)'
 * @param {string} fn     Function name
 * @param {number} count  Actual argument count
 * @param {number} min    Minimum required argument count
 * @param {number} [max]  Maximum required argument count
 * @extends Error
 */ function $ddf94786645a7a51$export$f27c2c74ddc37d80(fn, count, min, max) {
    if (!(this instanceof $ddf94786645a7a51$export$f27c2c74ddc37d80)) throw new SyntaxError("Constructor must be called with the new operator");
    this.fn = fn;
    this.count = count;
    this.min = min;
    this.max = max;
    this.message = "Wrong number of arguments in function " + fn + " (" + count + " provided, " + min + (max !== undefined && max !== null ? "-" + max : "") + " expected)";
    this.stack = new Error().stack;
}
$ddf94786645a7a51$export$f27c2c74ddc37d80.prototype = new Error();
$ddf94786645a7a51$export$f27c2c74ddc37d80.prototype.constructor = Error;
$ddf94786645a7a51$export$f27c2c74ddc37d80.prototype.name = "ArgumentsError";
$ddf94786645a7a51$export$f27c2c74ddc37d80.prototype.isArgumentsError = true;

});


parcelRegister("jzXAX", function(module, exports) {

$parcel$export(module.exports, "createResultSet", function () { return $e40f83861e6d737f$export$dfb3187f1c4e3bbe; });

var $2mPYl = parcelRequire("2mPYl");
var $e40f83861e6d737f$var$name = "ResultSet";
var $e40f83861e6d737f$var$dependencies = [];
var $e40f83861e6d737f$export$dfb3187f1c4e3bbe = /* #__PURE__ */ (0, $2mPYl.factory)($e40f83861e6d737f$var$name, $e40f83861e6d737f$var$dependencies, function() {
    /**
   * A ResultSet contains a list or results
   * @class ResultSet
   * @param {Array} entries
   * @constructor ResultSet
   */ function ResultSet(entries) {
        if (!(this instanceof ResultSet)) throw new SyntaxError("Constructor must be called with the new operator");
        this.entries = entries || [];
    }
    /**
   * Attach type information
   */ ResultSet.prototype.type = "ResultSet";
    ResultSet.prototype.isResultSet = true;
    /**
   * Returns the array with results hold by this ResultSet
   * @memberof ResultSet
   * @returns {Array} entries
   */ ResultSet.prototype.valueOf = function() {
        return this.entries;
    };
    /**
   * Returns the stringified results of the ResultSet
   * @memberof ResultSet
   * @returns {string} string
   */ ResultSet.prototype.toString = function() {
        return "[" + this.entries.join(", ") + "]";
    };
    /**
   * Get a JSON representation of the ResultSet
   * @memberof ResultSet
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "ResultSet", "entries": [...]}`
   */ ResultSet.prototype.toJSON = function() {
        return {
            mathjs: "ResultSet",
            entries: this.entries
        };
    };
    /**
   * Instantiate a ResultSet from a JSON object
   * @memberof ResultSet
   * @param {Object} json  A JSON object structured as:
   *                       `{"mathjs": "ResultSet", "entries": [...]}`
   * @return {ResultSet}
   */ ResultSet.fromJSON = function(json) {
        return new ResultSet(json.entries);
    };
    return ResultSet;
}, {
    isClass: true
});

});

parcelRegister("cyEyv", function(module, exports) {

$parcel$export(module.exports, "createRightArithShift", function () { return $92481e852bec49f0$export$ef742376390cbf7; });

var $1Jf3Z = parcelRequire("1Jf3Z");

var $cITNv = parcelRequire("cITNv");

var $cZfrH = parcelRequire("cZfrH");

var $1bBLS = parcelRequire("1bBLS");

var $iHnaT = parcelRequire("iHnaT");

var $gIOYU = parcelRequire("gIOYU");

var $1rFP6 = parcelRequire("1rFP6");

var $4gqxn = parcelRequire("4gqxn");

var $2mPYl = parcelRequire("2mPYl");

var $gVfmZ = parcelRequire("gVfmZ");
var $92481e852bec49f0$var$name = "rightArithShift";
var $92481e852bec49f0$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "zeros",
    "DenseMatrix"
];
var $92481e852bec49f0$export$ef742376390cbf7 = /* #__PURE__ */ (0, $2mPYl.factory)($92481e852bec49f0$var$name, $92481e852bec49f0$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, equalScalar = _ref.equalScalar, zeros = _ref.zeros, DenseMatrix = _ref.DenseMatrix;
    var algorithm01 = (0, $gIOYU.createAlgorithm01)({
        typed: typed
    });
    var algorithm02 = (0, $cITNv.createAlgorithm02)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm08 = (0, $4gqxn.createAlgorithm08)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm10 = (0, $1rFP6.createAlgorithm10)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm11 = (0, $cZfrH.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $1bBLS.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $iHnaT.createAlgorithm14)({
        typed: typed
    });
    /**
   * Bitwise right arithmetic shift of a value x by y number of bits, `x >> y`.
   * For matrices, the function is evaluated element wise.
   * For units, the function is evaluated on the best prefix base.
   *
   * Syntax:
   *
   *    math.rightArithShift(x, y)
   *
   * Examples:
   *
   *    math.rightArithShift(4, 2)               // returns number 1
   *
   *    math.rightArithShift([16, -32, 64], 4)   // returns Array [1, -2, 3]
   *
   * See also:
   *
   *    bitAnd, bitNot, bitOr, bitXor, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | Array | Matrix} x Value to be shifted
   * @param  {number | BigNumber} y Amount of shifts
   * @return {number | BigNumber | Array | Matrix} `x` sign-filled shifted right `y` times
   */ var rightArithShift = typed($92481e852bec49f0$var$name, {
        "number, number": (0, $gVfmZ.rightArithShiftNumber),
        "BigNumber, BigNumber": (0, $1Jf3Z.rightArithShiftBigNumber),
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm08(x, y, rightArithShift, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, rightArithShift, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm01(x, y, rightArithShift, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, rightArithShift);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return rightArithShift(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return rightArithShift(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return rightArithShift(x, matrix(y));
        },
        "SparseMatrix, number | BigNumber": function SparseMatrixNumberBigNumber(x, y) {
            // check scalar
            if (equalScalar(y, 0)) return x.clone();
            return algorithm11(x, y, rightArithShift, false);
        },
        "DenseMatrix, number | BigNumber": function DenseMatrixNumberBigNumber(x, y) {
            // check scalar
            if (equalScalar(y, 0)) return x.clone();
            return algorithm14(x, y, rightArithShift, false);
        },
        "number | BigNumber, SparseMatrix": function numberBigNumberSparseMatrix(x, y) {
            // check scalar
            if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
            return algorithm10(y, x, rightArithShift, true);
        },
        "number | BigNumber, DenseMatrix": function numberBigNumberDenseMatrix(x, y) {
            // check scalar
            if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
            return algorithm14(y, x, rightArithShift, true);
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(x, y) {
            // use matrix implementation
            return rightArithShift(matrix(x), y).valueOf();
        },
        "number | BigNumber, Array": function numberBigNumberArray(x, y) {
            // use matrix implementation
            return rightArithShift(x, matrix(y)).valueOf();
        }
    });
    return rightArithShift;
});

});

parcelRegister("lprSh", function(module, exports) {

$parcel$export(module.exports, "createRightLogShift", function () { return $f9618e1681bc044d$export$2dd001e9fd66adcd; });

var $cITNv = parcelRequire("cITNv");

var $cZfrH = parcelRequire("cZfrH");

var $1bBLS = parcelRequire("1bBLS");

var $iHnaT = parcelRequire("iHnaT");

var $gIOYU = parcelRequire("gIOYU");

var $1rFP6 = parcelRequire("1rFP6");

var $4gqxn = parcelRequire("4gqxn");

var $2mPYl = parcelRequire("2mPYl");

var $gVfmZ = parcelRequire("gVfmZ");
var $f9618e1681bc044d$var$name = "rightLogShift";
var $f9618e1681bc044d$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "zeros",
    "DenseMatrix"
];
var $f9618e1681bc044d$export$2dd001e9fd66adcd = /* #__PURE__ */ (0, $2mPYl.factory)($f9618e1681bc044d$var$name, $f9618e1681bc044d$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, equalScalar = _ref.equalScalar, zeros = _ref.zeros, DenseMatrix = _ref.DenseMatrix;
    var algorithm01 = (0, $gIOYU.createAlgorithm01)({
        typed: typed
    });
    var algorithm02 = (0, $cITNv.createAlgorithm02)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm08 = (0, $4gqxn.createAlgorithm08)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm10 = (0, $1rFP6.createAlgorithm10)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm11 = (0, $cZfrH.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $1bBLS.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $iHnaT.createAlgorithm14)({
        typed: typed
    });
    /**
   * Bitwise right logical shift of value x by y number of bits, `x >>> y`.
   * For matrices, the function is evaluated element wise.
   * For units, the function is evaluated on the best prefix base.
   *
   * Syntax:
   *
   *    math.rightLogShift(x, y)
   *
   * Examples:
   *
   *    math.rightLogShift(4, 2)               // returns number 1
   *
   *    math.rightLogShift([16, -32, 64], 4)   // returns Array [1, 2, 3]
   *
   * See also:
   *
   *    bitAnd, bitNot, bitOr, bitXor, leftShift, rightLogShift
   *
   * @param  {number | Array | Matrix} x Value to be shifted
   * @param  {number} y Amount of shifts
   * @return {number | Array | Matrix} `x` zero-filled shifted right `y` times
   */ var rightLogShift = typed($f9618e1681bc044d$var$name, {
        "number, number": (0, $gVfmZ.rightLogShiftNumber),
        // 'BigNumber, BigNumber': ..., // TODO: implement BigNumber support for rightLogShift
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm08(x, y, rightLogShift, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, rightLogShift, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm01(x, y, rightLogShift, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, rightLogShift);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return rightLogShift(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return rightLogShift(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return rightLogShift(x, matrix(y));
        },
        "SparseMatrix, number | BigNumber": function SparseMatrixNumberBigNumber(x, y) {
            // check scalar
            if (equalScalar(y, 0)) return x.clone();
            return algorithm11(x, y, rightLogShift, false);
        },
        "DenseMatrix, number | BigNumber": function DenseMatrixNumberBigNumber(x, y) {
            // check scalar
            if (equalScalar(y, 0)) return x.clone();
            return algorithm14(x, y, rightLogShift, false);
        },
        "number | BigNumber, SparseMatrix": function numberBigNumberSparseMatrix(x, y) {
            // check scalar
            if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
            return algorithm10(y, x, rightLogShift, true);
        },
        "number | BigNumber, DenseMatrix": function numberBigNumberDenseMatrix(x, y) {
            // check scalar
            if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
            return algorithm14(y, x, rightLogShift, true);
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(x, y) {
            // use matrix implementation
            return rightLogShift(matrix(x), y).valueOf();
        },
        "number | BigNumber, Array": function numberBigNumberArray(x, y) {
            // use matrix implementation
            return rightLogShift(x, matrix(y)).valueOf();
        }
    });
    return rightLogShift;
});

});

parcelRegister("dO1oA", function(module, exports) {

$parcel$export(module.exports, "createRound", function () { return $a0d106ff6d5faa53$export$c41ddfead54b1fbc; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");

var $kFRKb = parcelRequire("kFRKb");

var $cZfrH = parcelRequire("cZfrH");

var $dNuvz = parcelRequire("dNuvz");

var $iHnaT = parcelRequire("iHnaT");

var $6fCew = parcelRequire("6fCew");
function $a0d106ff6d5faa53$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a0d106ff6d5faa53$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $a0d106ff6d5faa53$var$ownKeys(Object(source), true).forEach(function(key) {
            $a0d106ff6d5faa53$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $a0d106ff6d5faa53$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a0d106ff6d5faa53$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $a0d106ff6d5faa53$var$NO_INT = "Number of decimals in function round must be an integer";
var $a0d106ff6d5faa53$var$name = "round";
var $a0d106ff6d5faa53$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "zeros",
    "BigNumber",
    "DenseMatrix"
];
var $a0d106ff6d5faa53$export$c41ddfead54b1fbc = /* #__PURE__ */ (0, $2mPYl.factory)($a0d106ff6d5faa53$var$name, $a0d106ff6d5faa53$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, equalScalar = _ref.equalScalar, zeros = _ref.zeros, BigNumber = _ref.BigNumber, DenseMatrix = _ref.DenseMatrix;
    var algorithm11 = (0, $cZfrH.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm12 = (0, $dNuvz.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm14 = (0, $iHnaT.createAlgorithm14)({
        typed: typed
    });
    /**
   * Round a value towards the nearest integer.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.round(x)
   *    math.round(x, n)
   *
   * Examples:
   *
   *    math.round(3.2)              // returns number 3
   *    math.round(3.8)              // returns number 4
   *    math.round(-4.2)             // returns number -4
   *    math.round(-4.7)             // returns number -5
   *    math.round(math.pi, 3)       // returns number 3.142
   *    math.round(123.45678, 2)     // returns number 123.46
   *
   *    const c = math.complex(3.2, -2.7)
   *    math.round(c)                // returns Complex 3 - 3i
   *
   *    math.round([3.2, 3.8, -4.7]) // returns Array [3, 4, -5]
   *
   * See also:
   *
   *    ceil, fix, floor
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix} x  Number to be rounded
   * @param  {number | BigNumber | Array} [n=0]                            Number of decimals
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix} Rounded value
   */ var round = typed($a0d106ff6d5faa53$var$name, $a0d106ff6d5faa53$var$_objectSpread($a0d106ff6d5faa53$var$_objectSpread({}, $a0d106ff6d5faa53$var$roundNumberSignatures), {}, {
        Complex: function Complex(x) {
            return x.round();
        },
        "Complex, number": function ComplexNumber(x, n) {
            if (n % 1) throw new TypeError($a0d106ff6d5faa53$var$NO_INT);
            return x.round(n);
        },
        "Complex, BigNumber": function ComplexBigNumber(x, n) {
            if (!n.isInteger()) throw new TypeError($a0d106ff6d5faa53$var$NO_INT);
            var _n = n.toNumber();
            return x.round(_n);
        },
        "number, BigNumber": function numberBigNumber(x, n) {
            if (!n.isInteger()) throw new TypeError($a0d106ff6d5faa53$var$NO_INT);
            return new BigNumber(x).toDecimalPlaces(n.toNumber());
        },
        BigNumber: function BigNumber(x) {
            return x.toDecimalPlaces(0);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, n) {
            if (!n.isInteger()) throw new TypeError($a0d106ff6d5faa53$var$NO_INT);
            return x.toDecimalPlaces(n.toNumber());
        },
        Fraction: function Fraction(x) {
            return x.round();
        },
        "Fraction, number": function FractionNumber(x, n) {
            if (n % 1) throw new TypeError($a0d106ff6d5faa53$var$NO_INT);
            return x.round(n);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since round(0) = 0
            return (0, $e04i1.deepMap)(x, round, true);
        },
        "SparseMatrix, number | BigNumber": function SparseMatrixNumberBigNumber(x, y) {
            return algorithm11(x, y, round, false);
        },
        "DenseMatrix, number | BigNumber": function DenseMatrixNumberBigNumber(x, y) {
            return algorithm14(x, y, round, false);
        },
        "number | Complex | BigNumber, SparseMatrix": function numberComplexBigNumberSparseMatrix(x, y) {
            // check scalar is zero
            if (equalScalar(x, 0)) // do not execute algorithm, result will be a zero matrix
            return zeros(y.size(), y.storage());
            return algorithm12(y, x, round, true);
        },
        "number | Complex | BigNumber, DenseMatrix": function numberComplexBigNumberDenseMatrix(x, y) {
            // check scalar is zero
            if (equalScalar(x, 0)) // do not execute algorithm, result will be a zero matrix
            return zeros(y.size(), y.storage());
            return algorithm14(y, x, round, true);
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, round, false).valueOf();
        },
        "number | Complex | BigNumber, Array": function numberComplexBigNumberArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, round, true).valueOf();
        }
    }));
    return round;
});
var $a0d106ff6d5faa53$var$roundNumberSignatures = {
    number: (0, $6fCew.roundNumber),
    "number, number": function numberNumber(x, n) {
        if (!(0, $kFRKb.isInteger)(n)) throw new TypeError($a0d106ff6d5faa53$var$NO_INT);
        if (n < 0 || n > 15) throw new Error("Number of decimals in function round must be in te range of 0-15");
        return (0, $6fCew.roundNumber)(x, n);
    }
};
var $a0d106ff6d5faa53$export$ee2894e1239ff693 = /* #__PURE__ */ (0, $2mPYl.factory)($a0d106ff6d5faa53$var$name, [
    "typed"
], function(_ref2) {
    var typed = _ref2.typed;
    return typed($a0d106ff6d5faa53$var$name, $a0d106ff6d5faa53$var$roundNumberSignatures);
});

});

parcelRegister("lDVE4", function(module, exports) {

$parcel$export(module.exports, "createSec", function () { return $fc19f4a583464c70$export$5c169ecd5c25a09e; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");

var $2F5hp = parcelRequire("2F5hp");
var $fc19f4a583464c70$var$name = "sec";
var $fc19f4a583464c70$var$dependencies = [
    "typed",
    "BigNumber"
];
var $fc19f4a583464c70$export$5c169ecd5c25a09e = /* #__PURE__ */ (0, $2mPYl.factory)($fc19f4a583464c70$var$name, $fc19f4a583464c70$var$dependencies, function(_ref) {
    var typed = _ref.typed, _BigNumber = _ref.BigNumber;
    /**
   * Calculate the secant of a value, defined as `sec(x) = 1/cos(x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.sec(x)
   *
   * Examples:
   *
   *    math.sec(2)      // returns number -2.4029979617223822
   *    1 / math.cos(2)  // returns number -2.4029979617223822
   *
   * See also:
   *
   *    cos, csc, cot
   *
   * @param {number | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Secant of x
   */ var sec = typed($fc19f4a583464c70$var$name, {
        number: (0, $2F5hp.secNumber),
        Complex: function Complex(x) {
            return x.sec();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x.cos());
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function sec is no angle");
            return sec(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, sec);
        }
    });
    return sec;
});

});

parcelRegister("8OkRr", function(module, exports) {

$parcel$export(module.exports, "createSech", function () { return $66a32cc55b8fd339$export$97a0cf2b7d31f38b; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");

var $2F5hp = parcelRequire("2F5hp");
var $66a32cc55b8fd339$var$name = "sech";
var $66a32cc55b8fd339$var$dependencies = [
    "typed",
    "BigNumber"
];
var $66a32cc55b8fd339$export$97a0cf2b7d31f38b = /* #__PURE__ */ (0, $2mPYl.factory)($66a32cc55b8fd339$var$name, $66a32cc55b8fd339$var$dependencies, function(_ref) {
    var typed = _ref.typed, _BigNumber = _ref.BigNumber;
    /**
   * Calculate the hyperbolic secant of a value,
   * defined as `sech(x) = 1 / cosh(x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.sech(x)
   *
   * Examples:
   *
   *    // sech(x) = 1/ cosh(x)
   *    math.sech(0.5)       // returns 0.886818883970074
   *    1 / math.cosh(0.5)   // returns 0.886818883970074
   *
   * See also:
   *
   *    cosh, csch, coth
   *
   * @param {number | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic secant of x
   */ var sech = typed($66a32cc55b8fd339$var$name, {
        number: (0, $2F5hp.sechNumber),
        Complex: function Complex(x) {
            return x.sech();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x.cosh());
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function sech is no angle");
            return sech(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, sech);
        }
    });
    return sech;
});

});

parcelRegister("k2AKL", function(module, exports) {

$parcel$export(module.exports, "createSetCartesian", function () { return $e97081021758b205$export$9fa12a9d198718c8; });

var $5WdrK = parcelRequire("5WdrK");

var $2mPYl = parcelRequire("2mPYl");
var $e97081021758b205$var$name = "setCartesian";
var $e97081021758b205$var$dependencies = [
    "typed",
    "size",
    "subset",
    "compareNatural",
    "Index",
    "DenseMatrix"
];
var $e97081021758b205$export$9fa12a9d198718c8 = /* #__PURE__ */ (0, $2mPYl.factory)($e97081021758b205$var$name, $e97081021758b205$var$dependencies, function(_ref) {
    var typed = _ref.typed, size = _ref.size, subset = _ref.subset, compareNatural = _ref.compareNatural, Index = _ref.Index, DenseMatrix = _ref.DenseMatrix;
    /**
   * Create the cartesian product of two (multi)sets.
   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
   *
   * Syntax:
   *
   *    math.setCartesian(set1, set2)
   *
   * Examples:
   *
   *    math.setCartesian([1, 2], [3, 4])        // returns [[1, 3], [1, 4], [2, 3], [2, 4]]
   *
   * See also:
   *
   *    setUnion, setIntersect, setDifference, setPowerset
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {Array | Matrix}    The cartesian product of two (multi)sets
   */ return typed($e97081021758b205$var$name, {
        "Array | Matrix, Array | Matrix": function ArrayMatrixArrayMatrix(a1, a2) {
            var result = [];
            if (subset(size(a1), new Index(0)) !== 0 && subset(size(a2), new Index(0)) !== 0) {
                // if any of them is empty, return empty
                var b1 = (0, $5WdrK.flatten)(Array.isArray(a1) ? a1 : a1.toArray()).sort(compareNatural);
                var b2 = (0, $5WdrK.flatten)(Array.isArray(a2) ? a2 : a2.toArray()).sort(compareNatural);
                result = [];
                for(var i = 0; i < b1.length; i++)for(var j = 0; j < b2.length; j++)result.push([
                    b1[i],
                    b2[j]
                ]);
            } // return an array, if both inputs were arrays
            if (Array.isArray(a1) && Array.isArray(a2)) return result;
             // return a matrix otherwise
            return new DenseMatrix(result);
        }
    });
});

});

parcelRegister("4ngij", function(module, exports) {

$parcel$export(module.exports, "createSetDifference", function () { return $32f5f324179d2e80$export$d81c0f9dab86d854; });

var $5WdrK = parcelRequire("5WdrK");

var $2mPYl = parcelRequire("2mPYl");
var $32f5f324179d2e80$var$name = "setDifference";
var $32f5f324179d2e80$var$dependencies = [
    "typed",
    "size",
    "subset",
    "compareNatural",
    "Index",
    "DenseMatrix"
];
var $32f5f324179d2e80$export$d81c0f9dab86d854 = /* #__PURE__ */ (0, $2mPYl.factory)($32f5f324179d2e80$var$name, $32f5f324179d2e80$var$dependencies, function(_ref) {
    var typed = _ref.typed, size = _ref.size, subset = _ref.subset, compareNatural = _ref.compareNatural, Index = _ref.Index, DenseMatrix = _ref.DenseMatrix;
    /**
   * Create the difference of two (multi)sets: every element of set1, that is not the element of set2.
   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
   *
   * Syntax:
   *
   *    math.setDifference(set1, set2)
   *
   * Examples:
   *
   *    math.setDifference([1, 2, 3, 4], [3, 4, 5, 6])            // returns [1, 2]
   *    math.setDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])    // returns [1, 2]
   *
   * See also:
   *
   *    setUnion, setIntersect, setSymDifference
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {Array | Matrix}    The difference of two (multi)sets
   */ return typed($32f5f324179d2e80$var$name, {
        "Array | Matrix, Array | Matrix": function ArrayMatrixArrayMatrix(a1, a2) {
            var result;
            if (subset(size(a1), new Index(0)) === 0) // empty-anything=empty
            result = [];
            else if (subset(size(a2), new Index(0)) === 0) // anything-empty=anything
            return (0, $5WdrK.flatten)(a1.toArray());
            else {
                var b1 = (0, $5WdrK.identify)((0, $5WdrK.flatten)(Array.isArray(a1) ? a1 : a1.toArray()).sort(compareNatural));
                var b2 = (0, $5WdrK.identify)((0, $5WdrK.flatten)(Array.isArray(a2) ? a2 : a2.toArray()).sort(compareNatural));
                result = [];
                var inb2;
                for(var i = 0; i < b1.length; i++){
                    inb2 = false;
                    for(var j = 0; j < b2.length; j++)if (compareNatural(b1[i].value, b2[j].value) === 0 && b1[i].identifier === b2[j].identifier) {
                        // the identifier is always a decimal int
                        inb2 = true;
                        break;
                    }
                    if (!inb2) result.push(b1[i]);
                }
            } // return an array, if both inputs were arrays
            if (Array.isArray(a1) && Array.isArray(a2)) return (0, $5WdrK.generalize)(result);
             // return a matrix otherwise
            return new DenseMatrix((0, $5WdrK.generalize)(result));
        }
    });
});

});

parcelRegister("bBOHk", function(module, exports) {

$parcel$export(module.exports, "createSetDistinct", function () { return $873a79f0c495dafe$export$c149680b9d8f2963; });

var $5WdrK = parcelRequire("5WdrK");

var $2mPYl = parcelRequire("2mPYl");
var $873a79f0c495dafe$var$name = "setDistinct";
var $873a79f0c495dafe$var$dependencies = [
    "typed",
    "size",
    "subset",
    "compareNatural",
    "Index",
    "DenseMatrix"
];
var $873a79f0c495dafe$export$c149680b9d8f2963 = /* #__PURE__ */ (0, $2mPYl.factory)($873a79f0c495dafe$var$name, $873a79f0c495dafe$var$dependencies, function(_ref) {
    var typed = _ref.typed, size = _ref.size, subset = _ref.subset, compareNatural = _ref.compareNatural, Index = _ref.Index, DenseMatrix = _ref.DenseMatrix;
    /**
   * Collect the distinct elements of a multiset.
   * A multi-dimension array will be converted to a single-dimension array before the operation.
   *
   * Syntax:
   *
   *    math.setDistinct(set)
   *
   * Examples:
   *
   *    math.setDistinct([1, 1, 1, 2, 2, 3])        // returns [1, 2, 3]
   *
   * See also:
   *
   *    setMultiplicity
   *
   * @param {Array | Matrix}    a  A multiset
   * @return {Array | Matrix}    A set containing the distinc elements of the multiset
   */ return typed($873a79f0c495dafe$var$name, {
        "Array | Matrix": function ArrayMatrix(a) {
            var result;
            if (subset(size(a), new Index(0)) === 0) // if empty, return empty
            result = [];
            else {
                var b = (0, $5WdrK.flatten)(Array.isArray(a) ? a : a.toArray()).sort(compareNatural);
                result = [];
                result.push(b[0]);
                for(var i = 1; i < b.length; i++)if (compareNatural(b[i], b[i - 1]) !== 0) result.push(b[i]);
            } // return an array, if the input was an array
            if (Array.isArray(a)) return result;
             // return a matrix otherwise
            return new DenseMatrix(result);
        }
    });
});

});

parcelRegister("2Il54", function(module, exports) {

$parcel$export(module.exports, "createSetIntersect", function () { return $1fa00b0d6c9fe22a$export$b20ee2bdfbf6defd; });

var $5WdrK = parcelRequire("5WdrK");

var $2mPYl = parcelRequire("2mPYl");
var $1fa00b0d6c9fe22a$var$name = "setIntersect";
var $1fa00b0d6c9fe22a$var$dependencies = [
    "typed",
    "size",
    "subset",
    "compareNatural",
    "Index",
    "DenseMatrix"
];
var $1fa00b0d6c9fe22a$export$b20ee2bdfbf6defd = /* #__PURE__ */ (0, $2mPYl.factory)($1fa00b0d6c9fe22a$var$name, $1fa00b0d6c9fe22a$var$dependencies, function(_ref) {
    var typed = _ref.typed, size = _ref.size, subset = _ref.subset, compareNatural = _ref.compareNatural, Index = _ref.Index, DenseMatrix = _ref.DenseMatrix;
    /**
   * Create the intersection of two (multi)sets.
   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
   *
   * Syntax:
   *
   *    math.setIntersect(set1, set2)
   *
   * Examples:
   *
   *    math.setIntersect([1, 2, 3, 4], [3, 4, 5, 6])            // returns [3, 4]
   *    math.setIntersect([[1, 2], [3, 4]], [[3, 4], [5, 6]])    // returns [3, 4]
   *
   * See also:
   *
   *    setUnion, setDifference
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {Array | Matrix}    The intersection of two (multi)sets
   */ return typed($1fa00b0d6c9fe22a$var$name, {
        "Array | Matrix, Array | Matrix": function ArrayMatrixArrayMatrix(a1, a2) {
            var result;
            if (subset(size(a1), new Index(0)) === 0 || subset(size(a2), new Index(0)) === 0) // of any of them is empty, return empty
            result = [];
            else {
                var b1 = (0, $5WdrK.identify)((0, $5WdrK.flatten)(Array.isArray(a1) ? a1 : a1.toArray()).sort(compareNatural));
                var b2 = (0, $5WdrK.identify)((0, $5WdrK.flatten)(Array.isArray(a2) ? a2 : a2.toArray()).sort(compareNatural));
                result = [];
                for(var i = 0; i < b1.length; i++){
                    for(var j = 0; j < b2.length; j++)if (compareNatural(b1[i].value, b2[j].value) === 0 && b1[i].identifier === b2[j].identifier) {
                        // the identifier is always a decimal int
                        result.push(b1[i]);
                        break;
                    }
                }
            } // return an array, if both inputs were arrays
            if (Array.isArray(a1) && Array.isArray(a2)) return (0, $5WdrK.generalize)(result);
             // return a matrix otherwise
            return new DenseMatrix((0, $5WdrK.generalize)(result));
        }
    });
});

});

parcelRegister("itVHz", function(module, exports) {

$parcel$export(module.exports, "createSetIsSubset", function () { return $d747b1c6803a3d40$export$40ad73493b9f8712; });

var $5WdrK = parcelRequire("5WdrK");

var $2mPYl = parcelRequire("2mPYl");
var $d747b1c6803a3d40$var$name = "setIsSubset";
var $d747b1c6803a3d40$var$dependencies = [
    "typed",
    "size",
    "subset",
    "compareNatural",
    "Index"
];
var $d747b1c6803a3d40$export$40ad73493b9f8712 = /* #__PURE__ */ (0, $2mPYl.factory)($d747b1c6803a3d40$var$name, $d747b1c6803a3d40$var$dependencies, function(_ref) {
    var typed = _ref.typed, size = _ref.size, subset = _ref.subset, compareNatural = _ref.compareNatural, Index = _ref.Index;
    /**
   * Check whether a (multi)set is a subset of another (multi)set. (Every element of set1 is the element of set2.)
   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
   *
   * Syntax:
   *
   *    math.setIsSubset(set1, set2)
   *
   * Examples:
   *
   *    math.setIsSubset([1, 2], [3, 4, 5, 6])        // returns false
   *    math.setIsSubset([3, 4], [3, 4, 5, 6])        // returns true
   *
   * See also:
   *
   *    setUnion, setIntersect, setDifference
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {boolean}            true | false
   */ return typed($d747b1c6803a3d40$var$name, {
        "Array | Matrix, Array | Matrix": function ArrayMatrixArrayMatrix(a1, a2) {
            if (subset(size(a1), new Index(0)) === 0) // empty is a subset of anything
            return true;
            else if (subset(size(a2), new Index(0)) === 0) // anything is not a subset of empty
            return false;
            var b1 = (0, $5WdrK.identify)((0, $5WdrK.flatten)(Array.isArray(a1) ? a1 : a1.toArray()).sort(compareNatural));
            var b2 = (0, $5WdrK.identify)((0, $5WdrK.flatten)(Array.isArray(a2) ? a2 : a2.toArray()).sort(compareNatural));
            var inb2;
            for(var i = 0; i < b1.length; i++){
                inb2 = false;
                for(var j = 0; j < b2.length; j++)if (compareNatural(b1[i].value, b2[j].value) === 0 && b1[i].identifier === b2[j].identifier) {
                    // the identifier is always a decimal int
                    inb2 = true;
                    break;
                }
                if (inb2 === false) return false;
            }
            return true;
        }
    });
});

});

parcelRegister("crsqy", function(module, exports) {

$parcel$export(module.exports, "createSetMultiplicity", function () { return $90ee0ebdcd7016b6$export$d1f961d649e525df; });

var $5WdrK = parcelRequire("5WdrK");

var $2mPYl = parcelRequire("2mPYl");
var $90ee0ebdcd7016b6$var$name = "setMultiplicity";
var $90ee0ebdcd7016b6$var$dependencies = [
    "typed",
    "size",
    "subset",
    "compareNatural",
    "Index"
];
var $90ee0ebdcd7016b6$export$d1f961d649e525df = /* #__PURE__ */ (0, $2mPYl.factory)($90ee0ebdcd7016b6$var$name, $90ee0ebdcd7016b6$var$dependencies, function(_ref) {
    var typed = _ref.typed, size = _ref.size, subset = _ref.subset, compareNatural = _ref.compareNatural, Index = _ref.Index;
    /**
   * Count the multiplicity of an element in a multiset.
   * A multi-dimension array will be converted to a single-dimension array before the operation.
   *
   * Syntax:
   *
   *    math.setMultiplicity(element, set)
   *
   * Examples:
   *
   *    math.setMultiplicity(1, [1, 2, 2, 4])    // returns 1
   *    math.setMultiplicity(2, [1, 2, 2, 4])    // returns 2
   *
   * See also:
   *
   *    setDistinct, setSize
   *
   * @param {number | BigNumber | Fraction | Complex} e  An element in the multiset
   * @param {Array | Matrix}     a  A multiset
   * @return {number}            The number of how many times the multiset contains the element
   */ return typed($90ee0ebdcd7016b6$var$name, {
        "number | BigNumber | Fraction | Complex, Array | Matrix": function numberBigNumberFractionComplexArrayMatrix(e, a) {
            if (subset(size(a), new Index(0)) === 0) // if empty, return 0
            return 0;
            var b = (0, $5WdrK.flatten)(Array.isArray(a) ? a : a.toArray());
            var count = 0;
            for(var i = 0; i < b.length; i++)if (compareNatural(b[i], e) === 0) count++;
            return count;
        }
    });
});

});

parcelRegister("7iBA0", function(module, exports) {

$parcel$export(module.exports, "createSetPowerset", function () { return $55075d697e53e84e$export$55c6b5cb0b0637db; });

var $5WdrK = parcelRequire("5WdrK");

var $2mPYl = parcelRequire("2mPYl");
var $55075d697e53e84e$var$name = "setPowerset";
var $55075d697e53e84e$var$dependencies = [
    "typed",
    "size",
    "subset",
    "compareNatural",
    "Index"
];
var $55075d697e53e84e$export$55c6b5cb0b0637db = /* #__PURE__ */ (0, $2mPYl.factory)($55075d697e53e84e$var$name, $55075d697e53e84e$var$dependencies, function(_ref) {
    var typed = _ref.typed, size = _ref.size, subset = _ref.subset, compareNatural = _ref.compareNatural, Index = _ref.Index;
    /**
   * Create the powerset of a (multi)set. (The powerset contains very possible subsets of a (multi)set.)
   * A multi-dimension array will be converted to a single-dimension array before the operation.
   *
   * Syntax:
   *
   *    math.setPowerset(set)
   *
   * Examples:
   *
   *    math.setPowerset([1, 2, 3])        // returns [[], [1], [2], [3], [1, 2], [1, 3], [2, 3], [1, 2, 3]]
   *
   * See also:
   *
   *    setCartesian
   *
   * @param {Array | Matrix}    a  A (multi)set
   * @return {Array}    The powerset of the (multi)set
   */ return typed($55075d697e53e84e$var$name, {
        "Array | Matrix": function ArrayMatrix(a) {
            if (subset(size(a), new Index(0)) === 0) // if empty, return empty
            return [];
            var b = (0, $5WdrK.flatten)(Array.isArray(a) ? a : a.toArray()).sort(compareNatural);
            var result = [];
            var number = 0;
            while(number.toString(2).length <= b.length){
                result.push(_subset(b, number.toString(2).split("").reverse()));
                number++;
            } // can not return a matrix, because of the different size of the subarrays
            return _sort(result);
        }
    }); // create subset
    function _subset(array, bitarray) {
        var result = [];
        for(var i = 0; i < bitarray.length; i++)if (bitarray[i] === "1") result.push(array[i]);
        return result;
    } // sort subsests by length
    function _sort(array) {
        var temp = [];
        for(var i = array.length - 1; i > 0; i--){
            for(var j = 0; j < i; j++)if (array[j].length > array[j + 1].length) {
                temp = array[j];
                array[j] = array[j + 1];
                array[j + 1] = temp;
            }
        }
        return array;
    }
});

});

parcelRegister("i22NM", function(module, exports) {

$parcel$export(module.exports, "createSetSize", function () { return $d20a9646e414dbf6$export$55134310fc79366a; });

var $5WdrK = parcelRequire("5WdrK");

var $2mPYl = parcelRequire("2mPYl");
var $d20a9646e414dbf6$var$name = "setSize";
var $d20a9646e414dbf6$var$dependencies = [
    "typed",
    "compareNatural"
];
var $d20a9646e414dbf6$export$55134310fc79366a = /* #__PURE__ */ (0, $2mPYl.factory)($d20a9646e414dbf6$var$name, $d20a9646e414dbf6$var$dependencies, function(_ref) {
    var typed = _ref.typed, compareNatural = _ref.compareNatural;
    /**
   * Count the number of elements of a (multi)set. When a second parameter is 'true', count only the unique values.
   * A multi-dimension array will be converted to a single-dimension array before the operation.
   *
   * Syntax:
   *
   *    math.setSize(set)
   *    math.setSize(set, unique)
   *
   * Examples:
   *
   *    math.setSize([1, 2, 2, 4])          // returns 4
   *    math.setSize([1, 2, 2, 4], true)    // returns 3
   *
   * See also:
   *
   *    setUnion, setIntersect, setDifference
   *
   * @param {Array | Matrix}    a  A multiset
   * @return {number}            The number of elements of the (multi)set
   */ return typed($d20a9646e414dbf6$var$name, {
        "Array | Matrix": function ArrayMatrix(a) {
            return Array.isArray(a) ? (0, $5WdrK.flatten)(a).length : (0, $5WdrK.flatten)(a.toArray()).length;
        },
        "Array | Matrix, boolean": function ArrayMatrixBoolean(a, unique) {
            if (unique === false || a.length === 0) return Array.isArray(a) ? (0, $5WdrK.flatten)(a).length : (0, $5WdrK.flatten)(a.toArray()).length;
            else {
                var b = (0, $5WdrK.flatten)(Array.isArray(a) ? a : a.toArray()).sort(compareNatural);
                var count = 1;
                for(var i = 1; i < b.length; i++)if (compareNatural(b[i], b[i - 1]) !== 0) count++;
                return count;
            }
        }
    });
});

});

parcelRegister("5pxQQ", function(module, exports) {

$parcel$export(module.exports, "createSetSymDifference", function () { return $3f098bb3e6576b9f$export$4a9a0ead2012bfc4; });

var $5WdrK = parcelRequire("5WdrK");

var $2mPYl = parcelRequire("2mPYl");
var $3f098bb3e6576b9f$var$name = "setSymDifference";
var $3f098bb3e6576b9f$var$dependencies = [
    "typed",
    "size",
    "concat",
    "subset",
    "setDifference",
    "Index"
];
var $3f098bb3e6576b9f$export$4a9a0ead2012bfc4 = /* #__PURE__ */ (0, $2mPYl.factory)($3f098bb3e6576b9f$var$name, $3f098bb3e6576b9f$var$dependencies, function(_ref) {
    var typed = _ref.typed, size = _ref.size, concat = _ref.concat, subset = _ref.subset, setDifference = _ref.setDifference, Index = _ref.Index;
    /**
   * Create the symmetric difference of two (multi)sets.
   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
   *
   * Syntax:
   *
   *    math.setSymDifference(set1, set2)
   *
   * Examples:
   *
   *    math.setSymDifference([1, 2, 3, 4], [3, 4, 5, 6])            // returns [1, 2, 5, 6]
   *    math.setSymDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])    // returns [1, 2, 5, 6]
   *
   * See also:
   *
   *    setUnion, setIntersect, setDifference
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {Array | Matrix}    The symmetric difference of two (multi)sets
   */ return typed($3f098bb3e6576b9f$var$name, {
        "Array | Matrix, Array | Matrix": function ArrayMatrixArrayMatrix(a1, a2) {
            if (subset(size(a1), new Index(0)) === 0) // if any of them is empty, return the other one
            return (0, $5WdrK.flatten)(a2);
            else if (subset(size(a2), new Index(0)) === 0) return (0, $5WdrK.flatten)(a1);
            var b1 = (0, $5WdrK.flatten)(a1);
            var b2 = (0, $5WdrK.flatten)(a2);
            return concat(setDifference(b1, b2), setDifference(b2, b1));
        }
    });
});

});

parcelRegister("eJPWT", function(module, exports) {

$parcel$export(module.exports, "createSetUnion", function () { return $abad909b35a797f9$export$fbdfd2054d37f888; });

var $5WdrK = parcelRequire("5WdrK");

var $2mPYl = parcelRequire("2mPYl");
var $abad909b35a797f9$var$name = "setUnion";
var $abad909b35a797f9$var$dependencies = [
    "typed",
    "size",
    "concat",
    "subset",
    "setIntersect",
    "setSymDifference",
    "Index"
];
var $abad909b35a797f9$export$fbdfd2054d37f888 = /* #__PURE__ */ (0, $2mPYl.factory)($abad909b35a797f9$var$name, $abad909b35a797f9$var$dependencies, function(_ref) {
    var typed = _ref.typed, size = _ref.size, concat = _ref.concat, subset = _ref.subset, setIntersect = _ref.setIntersect, setSymDifference = _ref.setSymDifference, Index = _ref.Index;
    /**
   * Create the union of two (multi)sets.
   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
   *
   * Syntax:
   *
   *    math.setUnion(set1, set2)
   *
   * Examples:
   *
   *    math.setUnion([1, 2, 3, 4], [3, 4, 5, 6])            // returns [1, 2, 3, 4, 5, 6]
   *    math.setUnion([[1, 2], [3, 4]], [[3, 4], [5, 6]])    // returns [1, 2, 3, 4, 5, 6]
   *
   * See also:
   *
   *    setIntersect, setDifference
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {Array | Matrix}    The union of two (multi)sets
   */ return typed($abad909b35a797f9$var$name, {
        "Array | Matrix, Array | Matrix": function ArrayMatrixArrayMatrix(a1, a2) {
            if (subset(size(a1), new Index(0)) === 0) // if any of them is empty, return the other one
            return (0, $5WdrK.flatten)(a2);
            else if (subset(size(a2), new Index(0)) === 0) return (0, $5WdrK.flatten)(a1);
            var b1 = (0, $5WdrK.flatten)(a1);
            var b2 = (0, $5WdrK.flatten)(a2);
            return concat(setSymDifference(b1, b2), setIntersect(b1, b2));
        }
    });
});

});

parcelRegister("aI8OJ", function(module, exports) {

$parcel$export(module.exports, "createSign", function () { return $7cc4da606b4ec013$export$45df7cae684751af; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");

var $6fCew = parcelRequire("6fCew");
var $7cc4da606b4ec013$var$name = "sign";
var $7cc4da606b4ec013$var$dependencies = [
    "typed",
    "BigNumber",
    "Fraction",
    "complex"
];
var $7cc4da606b4ec013$export$45df7cae684751af = /* #__PURE__ */ (0, $2mPYl.factory)($7cc4da606b4ec013$var$name, $7cc4da606b4ec013$var$dependencies, function(_ref) {
    var typed = _ref.typed, _BigNumber = _ref.BigNumber, complex = _ref.complex, _Fraction = _ref.Fraction;
    /**
   * Compute the sign of a value. The sign of a value x is:
   *
   * -  1 when x > 0
   * - -1 when x < 0
   * -  0 when x == 0
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.sign(x)
   *
   * Examples:
   *
   *    math.sign(3.5)               // returns 1
   *    math.sign(-4.2)              // returns -1
   *    math.sign(0)                 // returns 0
   *
   *    math.sign([3, 5, -2, 0, 2])  // returns [1, 1, -1, 0, 1]
   *
   * See also:
   *
   *    abs
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix | Unit} x
   *            The number for which to determine the sign
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix | Unit}e
   *            The sign of `x`
   */ var sign = typed($7cc4da606b4ec013$var$name, {
        number: (0, $6fCew.signNumber),
        Complex: function Complex(x) {
            return x.im === 0 ? complex((0, $6fCew.signNumber)(x.re)) : x.sign();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(x.cmp(0));
        },
        Fraction: function Fraction(x) {
            return new _Fraction(x.s, 1);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since sign(0) = 0
            return (0, $e04i1.deepMap)(x, sign, true);
        },
        Unit: function Unit(x) {
            return sign(x.value);
        }
    });
    return sign;
});

});

parcelRegister("aLTLB", function(module, exports) {

$parcel$export(module.exports, "createSin", function () { return $7d798d4cf7991399$export$4b4fac44ef379cae; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");
var $7d798d4cf7991399$var$name = "sin";
var $7d798d4cf7991399$var$dependencies = [
    "typed"
];
var $7d798d4cf7991399$export$4b4fac44ef379cae = /* #__PURE__ */ (0, $2mPYl.factory)($7d798d4cf7991399$var$name, $7d798d4cf7991399$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Calculate the sine of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.sin(x)
   *
   * Examples:
   *
   *    math.sin(2)                      // returns number 0.9092974268256813
   *    math.sin(math.pi / 4)            // returns number 0.7071067811865475
   *    math.sin(math.unit(90, 'deg'))   // returns number 1
   *    math.sin(math.unit(30, 'deg'))   // returns number 0.5
   *
   *    const angle = 0.2
   *    math.pow(math.sin(angle), 2) + math.pow(math.cos(angle), 2) // returns number ~1
   *
   * See also:
   *
   *    cos, tan
   *
   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | BigNumber | Complex | Array | Matrix} Sine of x
   */ var sin = typed($7d798d4cf7991399$var$name, {
        number: Math.sin,
        Complex: function Complex(x) {
            return x.sin();
        },
        BigNumber: function BigNumber(x) {
            return x.sin();
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function sin is no angle");
            return sin(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since sin(0) = 0
            return (0, $e04i1.deepMap)(x, sin, true);
        }
    });
    return sin;
});

});

parcelRegister("hsMTl", function(module, exports) {

$parcel$export(module.exports, "createSinh", function () { return $cb6afa10d56a1a96$export$c3a62182c56878d5; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");

var $2F5hp = parcelRequire("2F5hp");
var $cb6afa10d56a1a96$var$name = "sinh";
var $cb6afa10d56a1a96$var$dependencies = [
    "typed"
];
var $cb6afa10d56a1a96$export$c3a62182c56878d5 = /* #__PURE__ */ (0, $2mPYl.factory)($cb6afa10d56a1a96$var$name, $cb6afa10d56a1a96$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Calculate the hyperbolic sine of a value,
   * defined as `sinh(x) = 1/2 * (exp(x) - exp(-x))`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.sinh(x)
   *
   * Examples:
   *
   *    math.sinh(0.5)       // returns number 0.5210953054937474
   *
   * See also:
   *
   *    cosh, tanh
   *
   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | BigNumber | Complex | Array | Matrix} Hyperbolic sine of x
   */ var sinh = typed($cb6afa10d56a1a96$var$name, {
        number: (0, $2F5hp.sinhNumber),
        Complex: function Complex(x) {
            return x.sinh();
        },
        BigNumber: function BigNumber(x) {
            return x.sinh();
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function sinh is no angle");
            return sinh(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since sinh(0) = 0
            return (0, $e04i1.deepMap)(x, sinh, true);
        }
    });
    return sinh;
});

});

parcelRegister("75QEb", function(module, exports) {

$parcel$export(module.exports, "createSize", function () { return $52a1d6a35b9a663b$export$9151c23a59ce3fb6; });

var $5WdrK = parcelRequire("5WdrK");

var $2mPYl = parcelRequire("2mPYl");

var $rJyG2 = parcelRequire("rJyG2");
var $52a1d6a35b9a663b$var$name = "size";
var $52a1d6a35b9a663b$var$dependencies = [
    "typed",
    "config",
    "?matrix"
];
var $52a1d6a35b9a663b$export$9151c23a59ce3fb6 = /* #__PURE__ */ (0, $2mPYl.factory)($52a1d6a35b9a663b$var$name, $52a1d6a35b9a663b$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, matrix = _ref.matrix;
    /**
   * Calculate the size of a matrix or scalar.
   *
   * Syntax:
   *
   *     math.size(x)
   *
   * Examples:
   *
   *     math.size(2.3)                  // returns []
   *     math.size('hello world')        // returns [11]
   *
   *     const A = [[1, 2, 3], [4, 5, 6]]
   *     math.size(A)                    // returns [2, 3]
   *     math.size(math.range(1,6))      // returns [5]
   *
   * See also:
   *
   *     resize, squeeze, subset
   *
   * @param {boolean | number | Complex | Unit | string | Array | Matrix} x  A matrix
   * @return {Array | Matrix} A vector with size of `x`.
   */ return typed($52a1d6a35b9a663b$var$name, {
        Matrix: function Matrix(x) {
            return x.create(x.size());
        },
        Array: (0, $5WdrK.arraySize),
        string: function string(x) {
            return config.matrix === "Array" ? [
                x.length
            ] : matrix([
                x.length
            ]);
        },
        "number | Complex | BigNumber | Unit | boolean | null": function numberComplexBigNumberUnitBooleanNull(x) {
            // scalar
            return config.matrix === "Array" ? [] : matrix ? matrix([]) : (0, $rJyG2.noMatrix)();
        }
    });
});

});

parcelRegister("6lgyq", function(module, exports) {

$parcel$export(module.exports, "createSlu", function () { return $49e18b8ea71c39c5$export$e44ac9822ce417ae; });

var $kFRKb = parcelRequire("kFRKb");

var $2mPYl = parcelRequire("2mPYl");

var $iq0Wa = parcelRequire("iq0Wa");

var $8C9u6 = parcelRequire("8C9u6");
var $49e18b8ea71c39c5$var$name = "slu";
var $49e18b8ea71c39c5$var$dependencies = [
    "typed",
    "abs",
    "add",
    "multiply",
    "transpose",
    "divideScalar",
    "subtract",
    "larger",
    "largerEq",
    "SparseMatrix"
];
var $49e18b8ea71c39c5$export$e44ac9822ce417ae = /* #__PURE__ */ (0, $2mPYl.factory)($49e18b8ea71c39c5$var$name, $49e18b8ea71c39c5$var$dependencies, function(_ref) {
    var typed = _ref.typed, abs = _ref.abs, add = _ref.add, multiply = _ref.multiply, transpose = _ref.transpose, divideScalar = _ref.divideScalar, subtract = _ref.subtract, larger = _ref.larger, largerEq = _ref.largerEq, SparseMatrix = _ref.SparseMatrix;
    var csSqr = (0, $iq0Wa.createCsSqr)({
        add: add,
        multiply: multiply,
        transpose: transpose
    });
    var csLu = (0, $8C9u6.createCsLu)({
        abs: abs,
        divideScalar: divideScalar,
        multiply: multiply,
        subtract: subtract,
        larger: larger,
        largerEq: largerEq,
        SparseMatrix: SparseMatrix
    });
    /**
   * Calculate the Sparse Matrix LU decomposition with full pivoting. Sparse Matrix `A` is decomposed in two matrices (`L`, `U`) and two permutation vectors (`pinv`, `q`) where
   *
   * `P * A * Q = L * U`
   *
   * Syntax:
   *
   *    math.slu(A, order, threshold)
   *
   * Examples:
   *
   *    const A = math.sparse([[4,3], [6, 3]])
   *    math.slu(A, 1, 0.001)
   *    // returns:
   *    // {
   *    //   L: [[1, 0], [1.5, 1]]
   *    //   U: [[4, 3], [0, -1.5]]
   *    //   p: [0, 1]
   *    //   q: [0, 1]
   *    // }
   *
   * See also:
   *
   *    lup, lsolve, usolve, lusolve
   *
   * @param {SparseMatrix} A              A two dimensional sparse matrix for which to get the LU decomposition.
   * @param {Number}       order          The Symbolic Ordering and Analysis order:
   *                                       0 - Natural ordering, no permutation vector q is returned
   *                                       1 - Matrix must be square, symbolic ordering and analisis is performed on M = A + A'
   *                                       2 - Symbolic ordering and analisis is performed on M = A' * A. Dense columns from A' are dropped, A recreated from A'.
   *                                           This is appropriatefor LU factorization of unsymmetric matrices.
   *                                       3 - Symbolic ordering and analisis is performed on M = A' * A. This is best used for LU factorization is matrix M has no dense rows.
   *                                           A dense row is a row with more than 10*sqr(columns) entries.
   * @param {Number}       threshold       Partial pivoting threshold (1 for partial pivoting)
   *
   * @return {Object} The lower triangular matrix, the upper triangular matrix and the permutation vectors.
   */ return typed($49e18b8ea71c39c5$var$name, {
        "SparseMatrix, number, number": function SparseMatrixNumberNumber(a, order, threshold) {
            // verify order
            if (!(0, $kFRKb.isInteger)(order) || order < 0 || order > 3) throw new Error("Symbolic Ordering and Analysis order must be an integer number in the interval [0, 3]");
             // verify threshold
            if (threshold < 0 || threshold > 1) throw new Error("Partial pivoting threshold must be a number from 0 to 1");
             // perform symbolic ordering and analysis
            var s = csSqr(order, a, false); // perform lu decomposition
            var f = csLu(a, s, threshold); // return decomposition
            return {
                L: f.L,
                U: f.U,
                p: f.pinv,
                q: s.q,
                toString: function toString() {
                    return "L: " + this.L.toString() + "\nU: " + this.U.toString() + "\np: " + this.p.toString() + (this.q ? "\nq: " + this.q.toString() : "") + "\n";
                }
            };
        }
    });
});

});
parcelRegister("iq0Wa", function(module, exports) {

$parcel$export(module.exports, "createCsSqr", function () { return $d68b61c99e71eb1f$export$4d3f338d9cfe48c1; });

var $4Ni9J = parcelRequire("4Ni9J");

var $8mZMJ = parcelRequire("8mZMJ");

var $bY8vS = parcelRequire("bY8vS");

var $hrQ2l = parcelRequire("hrQ2l");

var $bcpI5 = parcelRequire("bcpI5");

var $2mPYl = parcelRequire("2mPYl");
var $d68b61c99e71eb1f$var$name = "csSqr";
var $d68b61c99e71eb1f$var$dependencies = [
    "add",
    "multiply",
    "transpose"
];
var $d68b61c99e71eb1f$export$4d3f338d9cfe48c1 = /* #__PURE__ */ (0, $2mPYl.factory)($d68b61c99e71eb1f$var$name, $d68b61c99e71eb1f$var$dependencies, function(_ref) {
    var add = _ref.add, multiply = _ref.multiply, transpose = _ref.transpose;
    var csAmd = (0, $hrQ2l.createCsAmd)({
        add: add,
        multiply: multiply,
        transpose: transpose
    });
    var csCounts = (0, $bcpI5.createCsCounts)({
        transpose: transpose
    });
    /**
   * Symbolic ordering and analysis for QR and LU decompositions.
   *
   * @param {Number}  order           The ordering strategy (see csAmd for more details)
   * @param {Matrix}  a               The A matrix
   * @param {boolean} qr              Symbolic ordering and analysis for QR decomposition (true) or
   *                                  symbolic ordering and analysis for LU decomposition (false)
   *
   * @return {Object}                 The Symbolic ordering and analysis for matrix A
   *
   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
   */ return function csSqr(order, a, qr) {
        // a arrays
        var aptr = a._ptr;
        var asize = a._size; // columns
        var n = asize[1]; // vars
        var k; // symbolic analysis result
        var s = {}; // fill-reducing ordering
        s.q = csAmd(order, a); // validate results
        if (order && !s.q) return null;
         // QR symbolic analysis
        if (qr) {
            // apply permutations if needed
            var c = order ? (0, $4Ni9J.csPermute)(a, null, s.q, 0) : a; // etree of C'*C, where C=A(:,q)
            s.parent = (0, $bY8vS.csEtree)(c, 1); // post order elimination tree
            var post = (0, $8mZMJ.csPost)(s.parent, n); // col counts chol(C'*C)
            s.cp = csCounts(c, s.parent, post, 1); // check we have everything needed to calculate number of nonzero elements
            if (c && s.parent && s.cp && _vcount(c, s)) // calculate number of nonzero elements
            for(s.unz = 0, k = 0; k < n; k++)s.unz += s.cp[k];
        } else {
            // for LU factorization only, guess nnz(L) and nnz(U)
            s.unz = 4 * aptr[n] + n;
            s.lnz = s.unz;
        } // return result S
        return s;
    };
    /**
   * Compute nnz(V) = s.lnz, s.pinv, s.leftmost, s.m2 from A and s.parent
   */ function _vcount(a, s) {
        // a arrays
        var aptr = a._ptr;
        var aindex = a._index;
        var asize = a._size; // rows & columns
        var m = asize[0];
        var n = asize[1]; // initialize s arrays
        s.pinv = []; // (m + n)
        s.leftmost = []; // (m)
        // vars
        var parent = s.parent;
        var pinv = s.pinv;
        var leftmost = s.leftmost; // workspace, next: first m entries, head: next n entries, tail: next n entries, nque: next n entries
        var w = []; // (m + 3 * n)
        var next = 0;
        var head = m;
        var tail = m + n;
        var nque = m + 2 * n; // vars
        var i, k, p, p0, p1; // initialize w
        for(k = 0; k < n; k++){
            // queue k is empty
            w[head + k] = -1;
            w[tail + k] = -1;
            w[nque + k] = 0;
        } // initialize row arrays
        for(i = 0; i < m; i++)leftmost[i] = -1;
         // loop columns backwards
        for(k = n - 1; k >= 0; k--)// values & index for column k
        for(p0 = aptr[k], p1 = aptr[k + 1], p = p0; p < p1; p++)// leftmost[i] = min(find(A(i,:)))
        leftmost[aindex[p]] = k;
         // scan rows in reverse order
        for(i = m - 1; i >= 0; i--){
            // row i is not yet ordered
            pinv[i] = -1;
            k = leftmost[i]; // check row i is empty
            if (k === -1) continue;
             // first row in queue k
            if (w[nque + k]++ === 0) w[tail + k] = i;
             // put i at head of queue k
            w[next + i] = w[head + k];
            w[head + k] = i;
        }
        s.lnz = 0;
        s.m2 = m; // find row permutation and nnz(V)
        for(k = 0; k < n; k++){
            // remove row i from queue k
            i = w[head + k]; // count V(k,k) as nonzero
            s.lnz++; // add a fictitious row
            if (i < 0) i = s.m2++;
             // associate row i with V(:,k)
            pinv[i] = k; // skip if V(k+1:m,k) is empty
            if (--nque[k] <= 0) continue;
             // nque[k] is nnz (V(k+1:m,k))
            s.lnz += w[nque + k]; // move all rows to parent of k
            var pa = parent[k];
            if (pa !== -1) {
                if (w[nque + pa] === 0) w[tail + pa] = w[tail + k];
                w[next + w[tail + k]] = w[head + pa];
                w[head + pa] = w[next + i];
                w[nque + pa] += w[nque + k];
            }
        }
        for(i = 0; i < m; i++)if (pinv[i] < 0) pinv[i] = k++;
        return true;
    }
});

});
parcelRegister("4Ni9J", function(module, exports) {

$parcel$export(module.exports, "csPermute", function () { return $37d9d265dfee9ddc$export$76070a0ecffd0bb2; });
/**
 * Permutes a sparse matrix C = P * A * Q
 *
 * @param {SparseMatrix}  a         The Matrix A
 * @param {Array}   pinv            The row permutation vector
 * @param {Array}   q               The column permutation vector
 * @param {boolean} values          Create a pattern matrix (false), values and pattern otherwise
 *
 * @return {Matrix}                 C = P * A * Q, null on error
 *
 * Reference: http://faculty.cse.tamu.edu/davis/publications.html
 */ function $37d9d265dfee9ddc$export$76070a0ecffd0bb2(a, pinv, q, values) {
    // a arrays
    var avalues = a._values;
    var aindex = a._index;
    var aptr = a._ptr;
    var asize = a._size;
    var adt = a._datatype; // rows & columns
    var m = asize[0];
    var n = asize[1]; // c arrays
    var cvalues = values && a._values ? [] : null;
    var cindex = []; // (aptr[n])
    var cptr = []; // (n + 1)
    // initialize vars
    var nz = 0; // loop columns
    for(var k = 0; k < n; k++){
        // column k of C is column q[k] of A
        cptr[k] = nz; // apply column permutation
        var j = q ? q[k] : k; // loop values in column j of A
        for(var t0 = aptr[j], t1 = aptr[j + 1], t = t0; t < t1; t++){
            // row i of A is row pinv[i] of C
            var r = pinv ? pinv[aindex[t]] : aindex[t]; // index
            cindex[nz] = r; // check we need to populate values
            if (cvalues) cvalues[nz] = avalues[t];
             // increment number of nonzero elements
            nz++;
        }
    } // finalize the last column of C
    cptr[n] = nz; // return C matrix
    return a.createSparseMatrix({
        values: cvalues,
        index: cindex,
        ptr: cptr,
        size: [
            m,
            n
        ],
        datatype: adt
    });
}

});

parcelRegister("8mZMJ", function(module, exports) {

$parcel$export(module.exports, "csPost", function () { return $61804dfec5d4a60d$export$90626b0a5705891a; });

var $22MvU = parcelRequire("22MvU");
function $61804dfec5d4a60d$export$90626b0a5705891a(parent, n) {
    // check inputs
    if (!parent) return null;
     // vars
    var k = 0;
    var j; // allocate result
    var post = []; // (n)
    // workspace, head: first n entries, next: next n entries, stack: last n entries
    var w = []; // (3 * n)
    var head = 0;
    var next = n;
    var stack = 2 * n; // initialize workspace
    for(j = 0; j < n; j++)// empty linked lists
    w[head + j] = -1;
     // traverse nodes in reverse order
    for(j = n - 1; j >= 0; j--){
        // check j is a root
        if (parent[j] === -1) continue;
         // add j to list of its parent
        w[next + j] = w[head + parent[j]];
        w[head + parent[j]] = j;
    } // loop nodes
    for(j = 0; j < n; j++){
        // skip j if it is not a root
        if (parent[j] !== -1) continue;
         // depth-first search
        k = (0, $22MvU.csTdfs)(j, k, w, head, next, post, stack);
    }
    return post;
}

});
parcelRegister("22MvU", function(module, exports) {

$parcel$export(module.exports, "csTdfs", function () { return $17d166770e50a37e$export$18e42241aee7902a; });
/**
 * Depth-first search and postorder of a tree rooted at node j
 *
 * @param {Number}  j               The tree node
 * @param {Number}  k
 * @param {Array}   w               The workspace array
 * @param {Number}  head            The index offset within the workspace for the head array
 * @param {Number}  next            The index offset within the workspace for the next array
 * @param {Array}   post            The post ordering array
 * @param {Number}  stack           The index offset within the workspace for the stack array
 *
 * Reference: http://faculty.cse.tamu.edu/davis/publications.html
 */ function $17d166770e50a37e$export$18e42241aee7902a(j, k, w, head, next, post, stack) {
    // variables
    var top = 0; // place j on the stack
    w[stack] = j; // while (stack is not empty)
    while(top >= 0){
        // p = top of stack
        var p = w[stack + top]; // i = youngest child of p
        var i = w[head + p];
        if (i === -1) {
            // p has no unordered children left
            top--; // node p is the kth postordered node
            post[k++] = p;
        } else {
            // remove i from children of p
            w[head + p] = w[next + i]; // increment top
            ++top; // start dfs on child node i
            w[stack + top] = i;
        }
    }
    return k;
}

});


parcelRegister("bY8vS", function(module, exports) {

$parcel$export(module.exports, "csEtree", function () { return $8b6be6dc477c9715$export$720e2a9a0fdebf8c; });
/**
 * Computes the elimination tree of Matrix A (using triu(A)) or the
 * elimination tree of A'A without forming A'A.
 *
 * @param {Matrix}  a               The A Matrix
 * @param {boolean} ata             A value of true the function computes the etree of A'A
 *
 * Reference: http://faculty.cse.tamu.edu/davis/publications.html
 */ function $8b6be6dc477c9715$export$720e2a9a0fdebf8c(a, ata) {
    // check inputs
    if (!a) return null;
     // a arrays
    var aindex = a._index;
    var aptr = a._ptr;
    var asize = a._size; // rows & columns
    var m = asize[0];
    var n = asize[1]; // allocate result
    var parent = []; // (n)
    // allocate workspace
    var w = []; // (n + (ata ? m : 0))
    var ancestor = 0; // first n entries in w
    var prev = n; // last m entries (ata = true)
    var i, inext; // check we are calculating A'A
    if (ata) // initialize workspace
    for(i = 0; i < m; i++)w[prev + i] = -1;
     // loop columns
    for(var k = 0; k < n; k++){
        // node k has no parent yet
        parent[k] = -1; // nor does k have an ancestor
        w[ancestor + k] = -1; // values in column k
        for(var p0 = aptr[k], p1 = aptr[k + 1], p = p0; p < p1; p++){
            // row
            var r = aindex[p]; // node
            i = ata ? w[prev + r] : r; // traverse from i to k
            for(; i !== -1 && i < k; i = inext){
                // inext = ancestor of i
                inext = w[ancestor + i]; // path compression
                w[ancestor + i] = k; // check no anc., parent is k
                if (inext === -1) parent[i] = k;
            }
            if (ata) w[prev + r] = k;
        }
    }
    return parent;
}

});

parcelRegister("hrQ2l", function(module, exports) {

$parcel$export(module.exports, "createCsAmd", function () { return $cb3d52b64ef0f868$export$485230eb48878637; });

var $2mPYl = parcelRequire("2mPYl");

var $hOpbU = parcelRequire("hOpbU");

var $2Igi4 = parcelRequire("2Igi4");

var $22MvU = parcelRequire("22MvU");
var $cb3d52b64ef0f868$var$name = "csAmd";
var $cb3d52b64ef0f868$var$dependencies = [
    "add",
    "multiply",
    "transpose"
];
var $cb3d52b64ef0f868$export$485230eb48878637 = /* #__PURE__ */ (0, $2mPYl.factory)($cb3d52b64ef0f868$var$name, $cb3d52b64ef0f868$var$dependencies, function(_ref) {
    var add = _ref.add, multiply = _ref.multiply, transpose = _ref.transpose;
    /**
   * Approximate minimum degree ordering. The minimum degree algorithm is a widely used
   * heuristic for finding a permutation P so that P*A*P' has fewer nonzeros in its factorization
   * than A. It is a gready method that selects the sparsest pivot row and column during the course
   * of a right looking sparse Cholesky factorization.
   *
   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
   *
   * @param {Number} order    0: Natural, 1: Cholesky, 2: LU, 3: QR
   * @param {Matrix} m        Sparse Matrix
   */ return function csAmd(order, a) {
        // check input parameters
        if (!a || order <= 0 || order > 3) return null;
         // a matrix arrays
        var asize = a._size; // rows and columns
        var m = asize[0];
        var n = asize[1]; // initialize vars
        var lemax = 0; // dense threshold
        var dense = Math.max(16, 10 * Math.sqrt(n));
        dense = Math.min(n - 2, dense); // create target matrix C
        var cm = _createTargetMatrix(order, a, m, n, dense); // drop diagonal entries
        (0, $hOpbU.csFkeep)(cm, _diag, null); // C matrix arrays
        var cindex = cm._index;
        var cptr = cm._ptr; // number of nonzero elements in C
        var cnz = cptr[n]; // allocate result (n+1)
        var P = []; // create workspace (8 * (n + 1))
        var W = [];
        var len = 0; // first n + 1 entries
        var nv = n + 1; // next n + 1 entries
        var next = 2 * (n + 1); // next n + 1 entries
        var head = 3 * (n + 1); // next n + 1 entries
        var elen = 4 * (n + 1); // next n + 1 entries
        var degree = 5 * (n + 1); // next n + 1 entries
        var w = 6 * (n + 1); // next n + 1 entries
        var hhead = 7 * (n + 1); // last n + 1 entries
        // use P as workspace for last
        var last = P; // initialize quotient graph
        var mark = _initializeQuotientGraph(n, cptr, W, len, head, last, next, hhead, nv, w, elen, degree); // initialize degree lists
        var nel = _initializeDegreeLists(n, cptr, W, degree, elen, w, dense, nv, head, last, next); // minimum degree node
        var mindeg = 0; // vars
        var i, j, k, k1, k2, e, pj, ln, nvi, pk, eln, p1, p2, pn, h, d; // while (selecting pivots) do
        while(nel < n){
            // select node of minimum approximate degree. amd() is now ready to start eliminating the graph. It first
            // finds a node k of minimum degree and removes it from its degree list. The variable nel keeps track of thow
            // many nodes have been eliminated.
            for(k = -1; mindeg < n && (k = W[head + mindeg]) === -1; mindeg++);
            if (W[next + k] !== -1) last[W[next + k]] = -1;
             // remove k from degree list
            W[head + mindeg] = W[next + k]; // elenk = |Ek|
            var elenk = W[elen + k]; // # of nodes k represents
            var nvk = W[nv + k]; // W[nv + k] nodes of A eliminated
            nel += nvk; // Construct a new element. The new element Lk is constructed in place if |Ek| = 0. nv[i] is
            // negated for all nodes i in Lk to flag them as members of this set. Each node i is removed from the
            // degree lists. All elements e in Ek are absorved into element k.
            var dk = 0; // flag k as in Lk
            W[nv + k] = -nvk;
            var p = cptr[k]; // do in place if W[elen + k] === 0
            var pk1 = elenk === 0 ? p : cnz;
            var pk2 = pk1;
            for(k1 = 1; k1 <= elenk + 1; k1++){
                if (k1 > elenk) {
                    // search the nodes in k
                    e = k; // list of nodes starts at cindex[pj]
                    pj = p; // length of list of nodes in k
                    ln = W[len + k] - elenk;
                } else {
                    // search the nodes in e
                    e = cindex[p++];
                    pj = cptr[e]; // length of list of nodes in e
                    ln = W[len + e];
                }
                for(k2 = 1; k2 <= ln; k2++){
                    i = cindex[pj++]; // check  node i dead, or seen
                    if ((nvi = W[nv + i]) <= 0) continue;
                     // W[degree + Lk] += size of node i
                    dk += nvi; // negate W[nv + i] to denote i in Lk
                    W[nv + i] = -nvi; // place i in Lk
                    cindex[pk2++] = i;
                    if (W[next + i] !== -1) last[W[next + i]] = last[i];
                     // check we need to remove i from degree list
                    if (last[i] !== -1) W[next + last[i]] = W[next + i];
                    else W[head + W[degree + i]] = W[next + i];
                }
                if (e !== k) {
                    // absorb e into k
                    cptr[e] = (0, $2Igi4.csFlip)(k); // e is now a dead element
                    W[w + e] = 0;
                }
            } // cindex[cnz...nzmax] is free
            if (elenk !== 0) cnz = pk2;
             // external degree of k - |Lk\i|
            W[degree + k] = dk; // element k is in cindex[pk1..pk2-1]
            cptr[k] = pk1;
            W[len + k] = pk2 - pk1; // k is now an element
            W[elen + k] = -2; // Find set differences. The scan1 function now computes the set differences |Le \ Lk| for all elements e. At the start of the
            // scan, no entry in the w array is greater than or equal to mark.
            // clear w if necessary
            mark = _wclear(mark, lemax, W, w, n); // scan 1: find |Le\Lk|
            for(pk = pk1; pk < pk2; pk++){
                i = cindex[pk]; // check if W[elen + i] empty, skip it
                if ((eln = W[elen + i]) <= 0) continue;
                 // W[nv + i] was negated
                nvi = -W[nv + i];
                var wnvi = mark - nvi; // scan Ei
                for(p = cptr[i], p1 = cptr[i] + eln - 1; p <= p1; p++){
                    e = cindex[p];
                    if (W[w + e] >= mark) // decrement |Le\Lk|
                    W[w + e] -= nvi;
                    else if (W[w + e] !== 0) // ensure e is a live element, 1st time e seen in scan 1
                    W[w + e] = W[degree + e] + wnvi;
                }
            } // degree update
            // The second pass computes the approximate degree di, prunes the sets Ei and Ai, and computes a hash
            // function h(i) for all nodes in Lk.
            // scan2: degree update
            for(pk = pk1; pk < pk2; pk++){
                // consider node i in Lk
                i = cindex[pk];
                p1 = cptr[i];
                p2 = p1 + W[elen + i] - 1;
                pn = p1; // scan Ei
                for(h = 0, d = 0, p = p1; p <= p2; p++){
                    e = cindex[p]; // check e is an unabsorbed element
                    if (W[w + e] !== 0) {
                        // dext = |Le\Lk|
                        var dext = W[w + e] - mark;
                        if (dext > 0) {
                            // sum up the set differences
                            d += dext; // keep e in Ei
                            cindex[pn++] = e; // compute the hash of node i
                            h += e;
                        } else {
                            // aggressive absorb. e->k
                            cptr[e] = (0, $2Igi4.csFlip)(k); // e is a dead element
                            W[w + e] = 0;
                        }
                    }
                } // W[elen + i] = |Ei|
                W[elen + i] = pn - p1 + 1;
                var p3 = pn;
                var p4 = p1 + W[len + i]; // prune edges in Ai
                for(p = p2 + 1; p < p4; p++){
                    j = cindex[p]; // check node j dead or in Lk
                    var nvj = W[nv + j];
                    if (nvj <= 0) continue;
                     // degree(i) += |j|
                    d += nvj; // place j in node list of i
                    cindex[pn++] = j; // compute hash for node i
                    h += j;
                } // check for mass elimination
                if (d === 0) {
                    // absorb i into k
                    cptr[i] = (0, $2Igi4.csFlip)(k);
                    nvi = -W[nv + i]; // |Lk| -= |i|
                    dk -= nvi; // |k| += W[nv + i]
                    nvk += nvi;
                    nel += nvi;
                    W[nv + i] = 0; // node i is dead
                    W[elen + i] = -1;
                } else {
                    // update degree(i)
                    W[degree + i] = Math.min(W[degree + i], d); // move first node to end
                    cindex[pn] = cindex[p3]; // move 1st el. to end of Ei
                    cindex[p3] = cindex[p1]; // add k as 1st element in of Ei
                    cindex[p1] = k; // new len of adj. list of node i
                    W[len + i] = pn - p1 + 1; // finalize hash of i
                    h = (h < 0 ? -h : h) % n; // place i in hash bucket
                    W[next + i] = W[hhead + h];
                    W[hhead + h] = i; // save hash of i in last[i]
                    last[i] = h;
                }
            } // finalize |Lk|
            W[degree + k] = dk;
            lemax = Math.max(lemax, dk); // clear w
            mark = _wclear(mark + lemax, lemax, W, w, n); // Supernode detection. Supernode detection relies on the hash function h(i) computed for each node i.
            // If two nodes have identical adjacency lists, their hash functions wil be identical.
            for(pk = pk1; pk < pk2; pk++){
                i = cindex[pk]; // check i is dead, skip it
                if (W[nv + i] >= 0) continue;
                 // scan hash bucket of node i
                h = last[i];
                i = W[hhead + h]; // hash bucket will be empty
                W[hhead + h] = -1;
                for(; i !== -1 && W[next + i] !== -1; i = W[next + i], mark++){
                    ln = W[len + i];
                    eln = W[elen + i];
                    for(p = cptr[i] + 1; p <= cptr[i] + ln - 1; p++)W[w + cindex[p]] = mark;
                    var jlast = i; // compare i with all j
                    for(j = W[next + i]; j !== -1;){
                        var ok = W[len + j] === ln && W[elen + j] === eln;
                        for(p = cptr[j] + 1; ok && p <= cptr[j] + ln - 1; p++)// compare i and j
                        if (W[w + cindex[p]] !== mark) ok = 0;
                         // check i and j are identical
                        if (ok) {
                            // absorb j into i
                            cptr[j] = (0, $2Igi4.csFlip)(i);
                            W[nv + i] += W[nv + j];
                            W[nv + j] = 0; // node j is dead
                            W[elen + j] = -1; // delete j from hash bucket
                            j = W[next + j];
                            W[next + jlast] = j;
                        } else {
                            // j and i are different
                            jlast = j;
                            j = W[next + j];
                        }
                    }
                }
            } // Finalize new element. The elimination of node k is nearly complete. All nodes i in Lk are scanned one last time.
            // Node i is removed from Lk if it is dead. The flagged status of nv[i] is cleared.
            for(p = pk1, pk = pk1; pk < pk2; pk++){
                i = cindex[pk]; // check  i is dead, skip it
                if ((nvi = -W[nv + i]) <= 0) continue;
                 // restore W[nv + i]
                W[nv + i] = nvi; // compute external degree(i)
                d = W[degree + i] + dk - nvi;
                d = Math.min(d, n - nel - nvi);
                if (W[head + d] !== -1) last[W[head + d]] = i;
                 // put i back in degree list
                W[next + i] = W[head + d];
                last[i] = -1;
                W[head + d] = i; // find new minimum degree
                mindeg = Math.min(mindeg, d);
                W[degree + i] = d; // place i in Lk
                cindex[p++] = i;
            } // # nodes absorbed into k
            W[nv + k] = nvk; // length of adj list of element k
            if ((W[len + k] = p - pk1) === 0) {
                // k is a root of the tree
                cptr[k] = -1; // k is now a dead element
                W[w + k] = 0;
            }
            if (elenk !== 0) // free unused space in Lk
            cnz = p;
        } // Postordering. The elimination is complete, but no permutation has been computed. All that is left
        // of the graph is the assembly tree (ptr) and a set of dead nodes and elements (i is a dead node if
        // nv[i] is zero and a dead element if nv[i] > 0). It is from this information only that the final permutation
        // is computed. The tree is restored by unflipping all of ptr.
        // fix assembly tree
        for(i = 0; i < n; i++)cptr[i] = (0, $2Igi4.csFlip)(cptr[i]);
        for(j = 0; j <= n; j++)W[head + j] = -1;
         // place unordered nodes in lists
        for(j = n; j >= 0; j--){
            // skip if j is an element
            if (W[nv + j] > 0) continue;
             // place j in list of its parent
            W[next + j] = W[head + cptr[j]];
            W[head + cptr[j]] = j;
        } // place elements in lists
        for(e = n; e >= 0; e--){
            // skip unless e is an element
            if (W[nv + e] <= 0) continue;
            if (cptr[e] !== -1) {
                // place e in list of its parent
                W[next + e] = W[head + cptr[e]];
                W[head + cptr[e]] = e;
            }
        } // postorder the assembly tree
        for(k = 0, i = 0; i <= n; i++)if (cptr[i] === -1) k = (0, $22MvU.csTdfs)(i, k, W, head, next, P, w);
         // remove last item in array
        P.splice(P.length - 1, 1); // return P
        return P;
    };
    /**
   * Creates the matrix that will be used by the approximate minimum degree ordering algorithm. The function accepts the matrix M as input and returns a permutation
   * vector P. The amd algorithm operates on a symmetrix matrix, so one of three symmetric matrices is formed.
   *
   * Order: 0
   *   A natural ordering P=null matrix is returned.
   *
   * Order: 1
   *   Matrix must be square. This is appropriate for a Cholesky or LU factorization.
   *   P = M + M'
   *
   * Order: 2
   *   Dense columns from M' are dropped, M recreated from M'. This is appropriatefor LU factorization of unsymmetric matrices.
   *   P = M' * M
   *
   * Order: 3
   *   This is best used for QR factorization or LU factorization is matrix M has no dense rows. A dense row is a row with more than 10*sqr(columns) entries.
   *   P = M' * M
   */ function _createTargetMatrix(order, a, m, n, dense) {
        // compute A'
        var at = transpose(a); // check order = 1, matrix must be square
        if (order === 1 && n === m) // C = A + A'
        return add(a, at);
         // check order = 2, drop dense columns from M'
        if (order === 2) {
            // transpose arrays
            var tindex = at._index;
            var tptr = at._ptr; // new column index
            var p2 = 0; // loop A' columns (rows)
            for(var j = 0; j < m; j++){
                // column j of AT starts here
                var p = tptr[j]; // new column j starts here
                tptr[j] = p2; // skip dense col j
                if (tptr[j + 1] - p > dense) continue;
                 // map rows in column j of A
                for(var p1 = tptr[j + 1]; p < p1; p++)tindex[p2++] = tindex[p];
            } // finalize AT
            tptr[m] = p2; // recreate A from new transpose matrix
            a = transpose(at); // use A' * A
            return multiply(at, a);
        } // use A' * A, square or rectangular matrix
        return multiply(at, a);
    }
    /**
   * Initialize quotient graph. There are four kind of nodes and elements that must be represented:
   *
   *  - A live node is a node i (or a supernode) that has not been selected as a pivot nad has not been merged into another supernode.
   *  - A dead node i is one that has been removed from the graph, having been absorved into r = flip(ptr[i]).
   *  - A live element e is one that is in the graph, having been formed when node e was selected as the pivot.
   *  - A dead element e is one that has benn absorved into a subsequent element s = flip(ptr[e]).
   */ function _initializeQuotientGraph(n, cptr, W, len, head, last, next, hhead, nv, w, elen, degree) {
        // Initialize quotient graph
        for(var k = 0; k < n; k++)W[len + k] = cptr[k + 1] - cptr[k];
        W[len + n] = 0; // initialize workspace
        for(var i = 0; i <= n; i++){
            // degree list i is empty
            W[head + i] = -1;
            last[i] = -1;
            W[next + i] = -1; // hash list i is empty
            W[hhead + i] = -1; // node i is just one node
            W[nv + i] = 1; // node i is alive
            W[w + i] = 1; // Ek of node i is empty
            W[elen + i] = 0; // degree of node i
            W[degree + i] = W[len + i];
        } // clear w
        var mark = _wclear(0, 0, W, w, n); // n is a dead element
        W[elen + n] = -2; // n is a root of assembly tree
        cptr[n] = -1; // n is a dead element
        W[w + n] = 0; // return mark
        return mark;
    }
    /**
   * Initialize degree lists. Each node is placed in its degree lists. Nodes of zero degree are eliminated immediately. Nodes with
   * degree >= dense are alsol eliminated and merged into a placeholder node n, a dead element. Thes nodes will appera last in the
   * output permutation p.
   */ function _initializeDegreeLists(n, cptr, W, degree, elen, w, dense, nv, head, last, next) {
        // result
        var nel = 0; // loop columns
        for(var i = 0; i < n; i++){
            // degree @ i
            var d = W[degree + i]; // check node i is empty
            if (d === 0) {
                // element i is dead
                W[elen + i] = -2;
                nel++; // i is a root of assembly tree
                cptr[i] = -1;
                W[w + i] = 0;
            } else if (d > dense) {
                // absorb i into element n
                W[nv + i] = 0; // node i is dead
                W[elen + i] = -1;
                nel++;
                cptr[i] = (0, $2Igi4.csFlip)(n);
                W[nv + n]++;
            } else {
                var h = W[head + d];
                if (h !== -1) last[h] = i;
                 // put node i in degree list d
                W[next + i] = W[head + d];
                W[head + d] = i;
            }
        }
        return nel;
    }
    function _wclear(mark, lemax, W, w, n) {
        if (mark < 2 || mark + lemax < 0) {
            for(var k = 0; k < n; k++)if (W[w + k] !== 0) W[w + k] = 1;
            mark = 2;
        } // at this point, W [0..n-1] < mark holds
        return mark;
    }
    function _diag(i, j) {
        return i !== j;
    }
});

});
parcelRegister("hOpbU", function(module, exports) {

$parcel$export(module.exports, "csFkeep", function () { return $cf7aa59a982653c2$export$9453433d9395b8cb; });
/**
 * Keeps entries in the matrix when the callback function returns true, removes the entry otherwise
 *
 * @param {Matrix}   a              The sparse matrix
 * @param {function} callback       The callback function, function will be invoked with the following args:
 *                                    - The entry row
 *                                    - The entry column
 *                                    - The entry value
 *                                    - The state parameter
 * @param {any}      other          The state
 *
 * @return                          The number of nonzero elements in the matrix
 *
 * Reference: http://faculty.cse.tamu.edu/davis/publications.html
 */ function $cf7aa59a982653c2$export$9453433d9395b8cb(a, callback, other) {
    // a arrays
    var avalues = a._values;
    var aindex = a._index;
    var aptr = a._ptr;
    var asize = a._size; // columns
    var n = asize[1]; // nonzero items
    var nz = 0; // loop columns
    for(var j = 0; j < n; j++){
        // get current location of col j
        var p = aptr[j]; // record new location of col j
        aptr[j] = nz;
        for(; p < aptr[j + 1]; p++)// check we need to keep this item
        if (callback(aindex[p], j, avalues ? avalues[p] : 1, other)) {
            // keep A(i,j)
            aindex[nz] = aindex[p]; // check we need to process values (pattern only)
            if (avalues) avalues[nz] = avalues[p];
             // increment nonzero items
            nz++;
        }
    } // finalize A
    aptr[n] = nz; // trim arrays
    aindex.splice(nz, aindex.length - nz); // check we need to process values (pattern only)
    if (avalues) avalues.splice(nz, avalues.length - nz);
     // return number of nonzero items
    return nz;
}

});

parcelRegister("2Igi4", function(module, exports) {

$parcel$export(module.exports, "csFlip", function () { return $1f9c53c81ecba679$export$d405b3d9168b83fa; });
/**
 * This function "flips" its input about the integer -1.
 *
 * @param {Number}  i               The value to flip
 *
 * Reference: http://faculty.cse.tamu.edu/davis/publications.html
 */ function $1f9c53c81ecba679$export$d405b3d9168b83fa(i) {
    // flip the value
    return -i - 2;
}

});


parcelRegister("bcpI5", function(module, exports) {

$parcel$export(module.exports, "createCsCounts", function () { return $8274c2335b51e62d$export$1feb4fbda2abf3b3; });

var $2mPYl = parcelRequire("2mPYl");

var $ar4Fv = parcelRequire("ar4Fv");
var $8274c2335b51e62d$var$name = "csCounts";
var $8274c2335b51e62d$var$dependencies = [
    "transpose"
];
var $8274c2335b51e62d$export$1feb4fbda2abf3b3 = /* #__PURE__ */ (0, $2mPYl.factory)($8274c2335b51e62d$var$name, $8274c2335b51e62d$var$dependencies, function(_ref) {
    var transpose = _ref.transpose;
    /**
   * Computes the column counts using the upper triangular part of A.
   * It transposes A internally, none of the input parameters are modified.
   *
   * @param {Matrix} a           The sparse matrix A
   *
   * @param {Matrix} ata         Count the columns of A'A instead
   *
   * @return                     An array of size n of the column counts or null on error
   *
   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
   */ return function(a, parent, post, ata) {
        // check inputs
        if (!a || !parent || !post) return null;
         // a matrix arrays
        var asize = a._size; // rows and columns
        var m = asize[0];
        var n = asize[1]; // variables
        var i, j, k, J, p, p0, p1; // workspace size
        var s = 4 * n + (ata ? n + m + 1 : 0); // allocate workspace
        var w = []; // (s)
        var ancestor = 0; // first n entries
        var maxfirst = n; // next n entries
        var prevleaf = 2 * n; // next n entries
        var first = 3 * n; // next n entries
        var head = 4 * n; // next n + 1 entries (used when ata is true)
        var next = 5 * n + 1; // last entries in workspace
        // clear workspace w[0..s-1]
        for(k = 0; k < s; k++)w[k] = -1;
         // allocate result
        var colcount = []; // (n)
        // AT = A'
        var at = transpose(a); // at arrays
        var tindex = at._index;
        var tptr = at._ptr; // find w[first + j]
        for(k = 0; k < n; k++){
            j = post[k]; // colcount[j]=1 if j is a leaf
            colcount[j] = w[first + j] === -1 ? 1 : 0;
            for(; j !== -1 && w[first + j] === -1; j = parent[j])w[first + j] = k;
        } // initialize ata if needed
        if (ata) {
            // invert post
            for(k = 0; k < n; k++)w[post[k]] = k;
             // loop rows (columns in AT)
            for(i = 0; i < m; i++){
                // values in column i of AT
                for(k = n, p0 = tptr[i], p1 = tptr[i + 1], p = p0; p < p1; p++)k = Math.min(k, w[tindex[p]]);
                 // place row i in linked list k
                w[next + i] = w[head + k];
                w[head + k] = i;
            }
        } // each node in its own set
        for(i = 0; i < n; i++)w[ancestor + i] = i;
        for(k = 0; k < n; k++){
            // j is the kth node in postordered etree
            j = post[k]; // check j is not a root
            if (parent[j] !== -1) colcount[parent[j]]--;
             // J=j for LL'=A case
            for(J = ata ? w[head + k] : j; J !== -1; J = ata ? w[next + J] : -1)for(p = tptr[J]; p < tptr[J + 1]; p++){
                i = tindex[p];
                var r = (0, $ar4Fv.csLeaf)(i, j, w, first, maxfirst, prevleaf, ancestor); // check A(i,j) is in skeleton
                if (r.jleaf >= 1) colcount[j]++;
                 // check account for overlap in q
                if (r.jleaf === 2) colcount[r.q]--;
            }
            if (parent[j] !== -1) w[ancestor + j] = parent[j];
        } // sum up colcount's of each child
        for(j = 0; j < n; j++)if (parent[j] !== -1) colcount[parent[j]] += colcount[j];
        return colcount;
    };
});

});
parcelRegister("ar4Fv", function(module, exports) {

$parcel$export(module.exports, "csLeaf", function () { return $79900c0ba7b84f1c$export$e5adc9884f74ac27; });
/**
 * This function determines if j is a leaf of the ith row subtree.
 * Consider A(i,j), node j in ith row subtree and return lca(jprev,j)
 *
 * @param {Number}  i               The ith row subtree
 * @param {Number}  j               The node to test
 * @param {Array}   w               The workspace array
 * @param {Number}  first           The index offset within the workspace for the first array
 * @param {Number}  maxfirst        The index offset within the workspace for the maxfirst array
 * @param {Number}  prevleaf        The index offset within the workspace for the prevleaf array
 * @param {Number}  ancestor        The index offset within the workspace for the ancestor array
 *
 * @return {Object}
 *
 * Reference: http://faculty.cse.tamu.edu/davis/publications.html
 */ function $79900c0ba7b84f1c$export$e5adc9884f74ac27(i, j, w, first, maxfirst, prevleaf, ancestor) {
    var s, sparent; // our result
    var jleaf = 0;
    var q; // check j is a leaf
    if (i <= j || w[first + j] <= w[maxfirst + i]) return -1;
     // update max first[j] seen so far
    w[maxfirst + i] = w[first + j]; // jprev = previous leaf of ith subtree
    var jprev = w[prevleaf + i];
    w[prevleaf + i] = j; // check j is first or subsequent leaf
    if (jprev === -1) {
        // 1st leaf, q = root of ith subtree
        jleaf = 1;
        q = i;
    } else {
        // update jleaf
        jleaf = 2; // q = least common ancester (jprev,j)
        for(q = jprev; q !== w[ancestor + q]; q = w[ancestor + q]);
        for(s = jprev; s !== q; s = sparent){
            // path compression
            sparent = w[ancestor + s];
            w[ancestor + s] = q;
        }
    }
    return {
        jleaf: jleaf,
        q: q
    };
}

});



parcelRegister("8C9u6", function(module, exports) {

$parcel$export(module.exports, "createCsLu", function () { return $64593abf3173bc1f$export$5487b5fadeacd2f6; });

var $2mPYl = parcelRequire("2mPYl");

var $1LnTZ = parcelRequire("1LnTZ");
var $64593abf3173bc1f$var$name = "csLu";
var $64593abf3173bc1f$var$dependencies = [
    "abs",
    "divideScalar",
    "multiply",
    "subtract",
    "larger",
    "largerEq",
    "SparseMatrix"
];
var $64593abf3173bc1f$export$5487b5fadeacd2f6 = /* #__PURE__ */ (0, $2mPYl.factory)($64593abf3173bc1f$var$name, $64593abf3173bc1f$var$dependencies, function(_ref) {
    var abs = _ref.abs, divideScalar = _ref.divideScalar, multiply = _ref.multiply, subtract = _ref.subtract, larger = _ref.larger, largerEq = _ref.largerEq, SparseMatrix = _ref.SparseMatrix;
    var csSpsolve = (0, $1LnTZ.createCsSpsolve)({
        divideScalar: divideScalar,
        multiply: multiply,
        subtract: subtract
    });
    /**
   * Computes the numeric LU factorization of the sparse matrix A. Implements a Left-looking LU factorization
   * algorithm that computes L and U one column at a tume. At the kth step, it access columns 1 to k-1 of L
   * and column k of A. Given the fill-reducing column ordering q (see parameter s) computes L, U and pinv so
   * L * U = A(p, q), where p is the inverse of pinv.
   *
   * @param {Matrix}  m               The A Matrix to factorize
   * @param {Object}  s               The symbolic analysis from csSqr(). Provides the fill-reducing
   *                                  column ordering q
   * @param {Number}  tol             Partial pivoting threshold (1 for partial pivoting)
   *
   * @return {Number}                 The numeric LU factorization of A or null
   *
   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
   */ return function csLu(m, s, tol) {
        // validate input
        if (!m) return null;
         // m arrays
        var size = m._size; // columns
        var n = size[1]; // symbolic analysis result
        var q;
        var lnz = 100;
        var unz = 100; // update symbolic analysis parameters
        if (s) {
            q = s.q;
            lnz = s.lnz || lnz;
            unz = s.unz || unz;
        } // L arrays
        var lvalues = []; // (lnz)
        var lindex = []; // (lnz)
        var lptr = []; // (n + 1)
        // L
        var L = new SparseMatrix({
            values: lvalues,
            index: lindex,
            ptr: lptr,
            size: [
                n,
                n
            ]
        }); // U arrays
        var uvalues = []; // (unz)
        var uindex = []; // (unz)
        var uptr = []; // (n + 1)
        // U
        var U = new SparseMatrix({
            values: uvalues,
            index: uindex,
            ptr: uptr,
            size: [
                n,
                n
            ]
        }); // inverse of permutation vector
        var pinv = []; // (n)
        // vars
        var i, p; // allocate arrays
        var x = []; // (n)
        var xi = []; // (2 * n)
        // initialize variables
        for(i = 0; i < n; i++){
            // clear workspace
            x[i] = 0; // no rows pivotal yet
            pinv[i] = -1; // no cols of L yet
            lptr[i + 1] = 0;
        } // reset number of nonzero elements in L and U
        lnz = 0;
        unz = 0; // compute L(:,k) and U(:,k)
        for(var k = 0; k < n; k++){
            // update ptr
            lptr[k] = lnz;
            uptr[k] = unz; // apply column permutations if needed
            var col = q ? q[k] : k; // solve triangular system, x = L\A(:,col)
            var top = csSpsolve(L, m, col, xi, x, pinv, 1); // find pivot
            var ipiv = -1;
            var a = -1; // loop xi[] from top -> n
            for(p = top; p < n; p++){
                // x[i] is nonzero
                i = xi[p]; // check row i is not yet pivotal
                if (pinv[i] < 0) {
                    // absolute value of x[i]
                    var xabs = abs(x[i]); // check absoulte value is greater than pivot value
                    if (larger(xabs, a)) {
                        // largest pivot candidate so far
                        a = xabs;
                        ipiv = i;
                    }
                } else {
                    // x(i) is the entry U(pinv[i],k)
                    uindex[unz] = pinv[i];
                    uvalues[unz++] = x[i];
                }
            } // validate we found a valid pivot
            if (ipiv === -1 || a <= 0) return null;
             // update actual pivot column, give preference to diagonal value
            if (pinv[col] < 0 && largerEq(abs(x[col]), multiply(a, tol))) ipiv = col;
             // the chosen pivot
            var pivot = x[ipiv]; // last entry in U(:,k) is U(k,k)
            uindex[unz] = k;
            uvalues[unz++] = pivot; // ipiv is the kth pivot row
            pinv[ipiv] = k; // first entry in L(:,k) is L(k,k) = 1
            lindex[lnz] = ipiv;
            lvalues[lnz++] = 1; // L(k+1:n,k) = x / pivot
            for(p = top; p < n; p++){
                // row
                i = xi[p]; // check x(i) is an entry in L(:,k)
                if (pinv[i] < 0) {
                    // save unpermuted row in L
                    lindex[lnz] = i; // scale pivot column
                    lvalues[lnz++] = divideScalar(x[i], pivot);
                } // x[0..n-1] = 0 for next k
                x[i] = 0;
            }
        } // update ptr
        lptr[n] = lnz;
        uptr[n] = unz; // fix row indices of L for final pinv
        for(p = 0; p < lnz; p++)lindex[p] = pinv[lindex[p]];
         // trim arrays
        lvalues.splice(lnz, lvalues.length - lnz);
        lindex.splice(lnz, lindex.length - lnz);
        uvalues.splice(unz, uvalues.length - unz);
        uindex.splice(unz, uindex.length - unz); // return LU factor
        return {
            L: L,
            U: U,
            pinv: pinv
        };
    };
});

});
parcelRegister("1LnTZ", function(module, exports) {

$parcel$export(module.exports, "createCsSpsolve", function () { return $148cb8ae7924e389$export$517933164557054f; });

var $9i9G3 = parcelRequire("9i9G3");

var $2mPYl = parcelRequire("2mPYl");
var $148cb8ae7924e389$var$name = "csSpsolve";
var $148cb8ae7924e389$var$dependencies = [
    "divideScalar",
    "multiply",
    "subtract"
];
var $148cb8ae7924e389$export$517933164557054f = /* #__PURE__ */ (0, $2mPYl.factory)($148cb8ae7924e389$var$name, $148cb8ae7924e389$var$dependencies, function(_ref) {
    var divideScalar = _ref.divideScalar, multiply = _ref.multiply, subtract = _ref.subtract;
    /**
   * The function csSpsolve() computes the solution to G * x = bk, where bk is the
   * kth column of B. When lo is true, the function assumes G = L is lower triangular with the
   * diagonal entry as the first entry in each column. When lo is true, the function assumes G = U
   * is upper triangular with the diagonal entry as the last entry in each column.
   *
   * @param {Matrix}  g               The G matrix
   * @param {Matrix}  b               The B matrix
   * @param {Number}  k               The kth column in B
   * @param {Array}   xi              The nonzero pattern xi[top] .. xi[n - 1], an array of size = 2 * n
   *                                  The first n entries is the nonzero pattern, the last n entries is the stack
   * @param {Array}   x               The soluton to the linear system G * x = b
   * @param {Array}   pinv            The inverse row permutation vector, must be null for L * x = b
   * @param {boolean} lo              The lower (true) upper triangular (false) flag
   *
   * @return {Number}                 The index for the nonzero pattern
   *
   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
   */ return function csSpsolve(g, b, k, xi, x, pinv, lo) {
        // g arrays
        var gvalues = g._values;
        var gindex = g._index;
        var gptr = g._ptr;
        var gsize = g._size; // columns
        var n = gsize[1]; // b arrays
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr; // vars
        var p, p0, p1, q; // xi[top..n-1] = csReach(B(:,k))
        var top = (0, $9i9G3.csReach)(g, b, k, xi, pinv); // clear x
        for(p = top; p < n; p++)x[xi[p]] = 0;
         // scatter b
        for(p0 = bptr[k], p1 = bptr[k + 1], p = p0; p < p1; p++)x[bindex[p]] = bvalues[p];
         // loop columns
        for(var px = top; px < n; px++){
            // x array index for px
            var j = xi[px]; // apply permutation vector (U x = b), j maps to column J of G
            var J = pinv ? pinv[j] : j; // check column J is empty
            if (J < 0) continue;
             // column value indeces in G, p0 <= p < p1
            p0 = gptr[J];
            p1 = gptr[J + 1]; // x(j) /= G(j,j)
            x[j] = divideScalar(x[j], gvalues[lo ? p0 : p1 - 1]); // first entry L(j,j)
            p = lo ? p0 + 1 : p0;
            q = lo ? p1 : p1 - 1; // loop
            for(; p < q; p++){
                // row
                var i = gindex[p]; // x(i) -= G(i,j) * x(j)
                x[i] = subtract(x[i], multiply(gvalues[p], x[j]));
            }
        } // return top of stack
        return top;
    };
});

});
parcelRegister("9i9G3", function(module, exports) {

$parcel$export(module.exports, "csReach", function () { return $6c3d4d3196e7812c$export$125cefbcd149ec98; });

var $eD7gp = parcelRequire("eD7gp");

var $2B8u9 = parcelRequire("2B8u9");

var $jIyCW = parcelRequire("jIyCW");
function $6c3d4d3196e7812c$export$125cefbcd149ec98(g, b, k, xi, pinv) {
    // g arrays
    var gptr = g._ptr;
    var gsize = g._size; // b arrays
    var bindex = b._index;
    var bptr = b._ptr; // columns
    var n = gsize[1]; // vars
    var p, p0, p1; // initialize top
    var top = n; // loop column indeces in B
    for(p0 = bptr[k], p1 = bptr[k + 1], p = p0; p < p1; p++){
        // node i
        var i = bindex[p]; // check node i is marked
        if (!(0, $eD7gp.csMarked)(gptr, i)) // start a dfs at unmarked node i
        top = (0, $jIyCW.csDfs)(i, g, top, xi, pinv);
    } // loop columns from top -> n - 1
    for(p = top; p < n; p++)// restore G
    (0, $2B8u9.csMark)(gptr, xi[p]);
    return top;
}

});
parcelRegister("eD7gp", function(module, exports) {

$parcel$export(module.exports, "csMarked", function () { return $aa6a579bfb0cbfb6$export$f0d640c1b5bfa3e; });
/**
 * Checks if the node at w[j] is marked
 *
 * @param {Array}   w               The array
 * @param {Number}  j               The array index
 *
 * Reference: http://faculty.cse.tamu.edu/davis/publications.html
 */ function $aa6a579bfb0cbfb6$export$f0d640c1b5bfa3e(w, j) {
    // check node is marked
    return w[j] < 0;
}

});

parcelRegister("2B8u9", function(module, exports) {

$parcel$export(module.exports, "csMark", function () { return $1e459e7b0202fc8f$export$53b20e7656f0b914; });

var $2Igi4 = parcelRequire("2Igi4");
function $1e459e7b0202fc8f$export$53b20e7656f0b914(w, j) {
    // mark w[j]
    w[j] = (0, $2Igi4.csFlip)(w[j]);
}

});

parcelRegister("jIyCW", function(module, exports) {

$parcel$export(module.exports, "csDfs", function () { return $e5acfc9d8702661f$export$c913fe476af3832b; });

var $eD7gp = parcelRequire("eD7gp");

var $2B8u9 = parcelRequire("2B8u9");

var $7Q9KV = parcelRequire("7Q9KV");
function $e5acfc9d8702661f$export$c913fe476af3832b(j, g, top, xi, pinv) {
    // g arrays
    var index = g._index;
    var ptr = g._ptr;
    var size = g._size; // columns
    var n = size[1]; // vars
    var i, p, p2; // initialize head
    var head = 0; // initialize the recursion stack
    xi[0] = j; // loop
    while(head >= 0){
        // get j from the top of the recursion stack
        j = xi[head]; // apply permutation vector
        var jnew = pinv ? pinv[j] : j; // check node j is marked
        if (!(0, $eD7gp.csMarked)(ptr, j)) {
            // mark node j as visited
            (0, $2B8u9.csMark)(ptr, j); // update stack (last n entries in xi)
            xi[n + head] = jnew < 0 ? 0 : (0, $7Q9KV.csUnflip)(ptr[jnew]);
        } // node j done if no unvisited neighbors
        var done = 1; // examine all neighbors of j, stack (last n entries in xi)
        for(p = xi[n + head], p2 = jnew < 0 ? 0 : (0, $7Q9KV.csUnflip)(ptr[jnew + 1]); p < p2; p++){
            // consider neighbor node i
            i = index[p]; // check we have visited node i, skip it
            if ((0, $eD7gp.csMarked)(ptr, i)) continue;
             // pause depth-first search of node j, update stack (last n entries in xi)
            xi[n + head] = p; // start dfs at node i
            xi[++head] = i; // node j is not done
            done = 0; // break, to start dfs(i)
            break;
        } // check depth-first search at node j is done
        if (done) {
            // remove j from the recursion stack
            head--; // and place in the output stack
            xi[--top] = j;
        }
    }
    return top;
}

});
parcelRegister("7Q9KV", function(module, exports) {

$parcel$export(module.exports, "csUnflip", function () { return $5b54f507bf4a73d1$export$8b1bf205e2e76d92; });

var $2Igi4 = parcelRequire("2Igi4");
function $5b54f507bf4a73d1$export$8b1bf205e2e76d92(i) {
    // flip the value if it is negative
    return i < 0 ? (0, $2Igi4.csFlip)(i) : i;
}

});






parcelRegister("kZ6Yc", function(module, exports) {

$parcel$export(module.exports, "createSmaller", function () { return $f46ee93f6c657907$export$6b477d90b957f03e; });

var $ijobM = parcelRequire("ijobM");

var $kFRKb = parcelRequire("kFRKb");

var $2mPYl = parcelRequire("2mPYl");

var $jaKH8 = parcelRequire("jaKH8");

var $awGkR = parcelRequire("awGkR");

var $dNuvz = parcelRequire("dNuvz");

var $iHnaT = parcelRequire("iHnaT");

var $1bBLS = parcelRequire("1bBLS");
var $f46ee93f6c657907$var$name = "smaller";
var $f46ee93f6c657907$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "DenseMatrix"
];
var $f46ee93f6c657907$export$6b477d90b957f03e = /* #__PURE__ */ (0, $2mPYl.factory)($f46ee93f6c657907$var$name, $f46ee93f6c657907$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, matrix = _ref.matrix, DenseMatrix = _ref.DenseMatrix;
    var algorithm03 = (0, $jaKH8.createAlgorithm03)({
        typed: typed
    });
    var algorithm07 = (0, $awGkR.createAlgorithm07)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $dNuvz.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $1bBLS.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $iHnaT.createAlgorithm14)({
        typed: typed
    });
    /**
   * Test whether value x is smaller than y.
   *
   * The function returns true when x is smaller than y and the relative
   * difference between x and y is smaller than the configured epsilon. The
   * function cannot be used to compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.smaller(x, y)
   *
   * Examples:
   *
   *    math.smaller(2, 3)            // returns true
   *    math.smaller(5, 2 * 2)        // returns false
   *
   *    const a = math.unit('5 cm')
   *    const b = math.unit('2 inch')
   *    math.smaller(a, b)            // returns true
   *
   * See also:
   *
   *    equal, unequal, smallerEq, smaller, smallerEq, compare
   *
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the x is smaller than y, else returns false
   */ var smaller = typed($f46ee93f6c657907$var$name, {
        "boolean, boolean": function booleanBoolean(x, y) {
            return x < y;
        },
        "number, number": function numberNumber(x, y) {
            return x < y && !(0, $kFRKb.nearlyEqual)(x, y, config.epsilon);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.lt(y) && !(0, $ijobM.nearlyEqual)(x, y, config.epsilon);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.compare(y) === -1;
        },
        "Complex, Complex": function ComplexComplex(x, y) {
            throw new TypeError("No ordering relation is defined for complex numbers");
        },
        "Unit, Unit": function UnitUnit(x, y) {
            if (!x.equalBase(y)) throw new Error("Cannot compare units with different base");
            return smaller(x.value, y.value);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, smaller);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, smaller, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, smaller, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, smaller);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return smaller(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return smaller(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return smaller(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, smaller, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, smaller, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, smaller, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, smaller, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, smaller, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, smaller, true).valueOf();
        }
    });
    return smaller;
});
var $f46ee93f6c657907$export$4f82e7db4d803209 = /* #__PURE__ */ (0, $2mPYl.factory)($f46ee93f6c657907$var$name, [
    "typed",
    "config"
], function(_ref2) {
    var typed = _ref2.typed, config = _ref2.config;
    return typed($f46ee93f6c657907$var$name, {
        "number, number": function numberNumber(x, y) {
            return x < y && !(0, $kFRKb.nearlyEqual)(x, y, config.epsilon);
        }
    });
});

});

parcelRegister("hYYhh", function(module, exports) {

$parcel$export(module.exports, "createSmallerEq", function () { return $d176cc27adb6ded2$export$e1b2fff975be9083; });

var $ijobM = parcelRequire("ijobM");

var $kFRKb = parcelRequire("kFRKb");

var $2mPYl = parcelRequire("2mPYl");

var $jaKH8 = parcelRequire("jaKH8");

var $awGkR = parcelRequire("awGkR");

var $dNuvz = parcelRequire("dNuvz");

var $iHnaT = parcelRequire("iHnaT");

var $1bBLS = parcelRequire("1bBLS");
var $d176cc27adb6ded2$var$name = "smallerEq";
var $d176cc27adb6ded2$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "DenseMatrix"
];
var $d176cc27adb6ded2$export$e1b2fff975be9083 = /* #__PURE__ */ (0, $2mPYl.factory)($d176cc27adb6ded2$var$name, $d176cc27adb6ded2$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, matrix = _ref.matrix, DenseMatrix = _ref.DenseMatrix;
    var algorithm03 = (0, $jaKH8.createAlgorithm03)({
        typed: typed
    });
    var algorithm07 = (0, $awGkR.createAlgorithm07)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $dNuvz.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $1bBLS.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $iHnaT.createAlgorithm14)({
        typed: typed
    });
    /**
   * Test whether value x is smaller or equal to y.
   *
   * The function returns true when x is smaller than y or the relative
   * difference between x and y is smaller than the configured epsilon. The
   * function cannot be used to compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.smallerEq(x, y)
   *
   * Examples:
   *
   *    math.smaller(1 + 2, 3)        // returns false
   *    math.smallerEq(1 + 2, 3)      // returns true
   *
   * See also:
   *
   *    equal, unequal, smaller, larger, largerEq, compare
   *
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the x is smaller than y, else returns false
   */ var smallerEq = typed($d176cc27adb6ded2$var$name, {
        "boolean, boolean": function booleanBoolean(x, y) {
            return x <= y;
        },
        "number, number": function numberNumber(x, y) {
            return x <= y || (0, $kFRKb.nearlyEqual)(x, y, config.epsilon);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.lte(y) || (0, $ijobM.nearlyEqual)(x, y, config.epsilon);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.compare(y) !== 1;
        },
        "Complex, Complex": function ComplexComplex() {
            throw new TypeError("No ordering relation is defined for complex numbers");
        },
        "Unit, Unit": function UnitUnit(x, y) {
            if (!x.equalBase(y)) throw new Error("Cannot compare units with different base");
            return smallerEq(x.value, y.value);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, smallerEq);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, smallerEq, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, smallerEq, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, smallerEq);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return smallerEq(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return smallerEq(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return smallerEq(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, smallerEq, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, smallerEq, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, smallerEq, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, smallerEq, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, smallerEq, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, smallerEq, true).valueOf();
        }
    });
    return smallerEq;
});
var $d176cc27adb6ded2$export$78c24428429985da = /* #__PURE__ */ (0, $2mPYl.factory)($d176cc27adb6ded2$var$name, [
    "typed",
    "config"
], function(_ref2) {
    var typed = _ref2.typed, config = _ref2.config;
    return typed($d176cc27adb6ded2$var$name, {
        "number, number": function numberNumber(x, y) {
            return x <= y || (0, $kFRKb.nearlyEqual)(x, y, config.epsilon);
        }
    });
});

});

parcelRegister("iF8zF", function(module, exports) {

$parcel$export(module.exports, "createSort", function () { return $d962b5050fd55188$export$10463693a2093403; });

var $5WdrK = parcelRequire("5WdrK");

var $2mPYl = parcelRequire("2mPYl");
var $d962b5050fd55188$var$name = "sort";
var $d962b5050fd55188$var$dependencies = [
    "typed",
    "matrix",
    "compare",
    "compareNatural"
];
var $d962b5050fd55188$export$10463693a2093403 = /* #__PURE__ */ (0, $2mPYl.factory)($d962b5050fd55188$var$name, $d962b5050fd55188$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, compare = _ref.compare, compareNatural = _ref.compareNatural;
    var compareAsc = compare;
    var compareDesc = function compareDesc(a, b) {
        return -compare(a, b);
    };
    /**
   * Sort the items in a matrix.
   *
   * Syntax:
   *
   *    math.sort(x)
   *    math.sort(x, compare)
   *
   * Examples:
   *
   *    math.sort([5, 10, 1]) // returns [1, 5, 10]
   *    math.sort(['C', 'B', 'A', 'D'], math.compareNatural)
   *    // returns ['A', 'B', 'C', 'D']
   *
   *    function sortByLength (a, b) {
   *      return a.length - b.length
   *    }
   *    math.sort(['Langdon', 'Tom', 'Sara'], sortByLength)
   *    // returns ['Tom', 'Sara', 'Langdon']
   *
   * See also:
   *
   *    filter, forEach, map, compare, compareNatural
   *
   * @param {Matrix | Array} x    A one dimensional matrix or array to sort
   * @param {Function | 'asc' | 'desc' | 'natural'} [compare='asc']
   *        An optional _comparator function or name. The function is called as
   *        `compare(a, b)`, and must return 1 when a > b, -1 when a < b,
   *        and 0 when a == b.
   * @return {Matrix | Array} Returns the sorted matrix.
   */ return typed($d962b5050fd55188$var$name, {
        Array: function Array(x) {
            _arrayIsVector(x);
            return x.sort(compareAsc);
        },
        Matrix: function Matrix(x) {
            _matrixIsVector(x);
            return matrix(x.toArray().sort(compareAsc), x.storage());
        },
        "Array, function": function ArrayFunction(x, _comparator) {
            _arrayIsVector(x);
            return x.sort(_comparator);
        },
        "Matrix, function": function MatrixFunction(x, _comparator) {
            _matrixIsVector(x);
            return matrix(x.toArray().sort(_comparator), x.storage());
        },
        "Array, string": function ArrayString(x, order) {
            _arrayIsVector(x);
            return x.sort(_comparator(order));
        },
        "Matrix, string": function MatrixString(x, order) {
            _matrixIsVector(x);
            return matrix(x.toArray().sort(_comparator(order)), x.storage());
        }
    });
    /**
   * Get the comparator for given order ('asc', 'desc', 'natural')
   * @param {'asc' | 'desc' | 'natural'} order
   * @return {Function} Returns a _comparator function
   */ function _comparator(order) {
        if (order === "asc") return compareAsc;
        else if (order === "desc") return compareDesc;
        else if (order === "natural") return compareNatural;
        else throw new Error('String "asc", "desc", or "natural" expected');
    }
    /**
   * Validate whether an array is one dimensional
   * Throws an error when this is not the case
   * @param {Array} array
   * @private
   */ function _arrayIsVector(array) {
        if ((0, $5WdrK.arraySize)(array).length !== 1) throw new Error("One dimensional array expected");
    }
    /**
   * Validate whether a matrix is one dimensional
   * Throws an error when this is not the case
   * @param {Matrix} matrix
   * @private
   */ function _matrixIsVector(matrix) {
        if (matrix.size().length !== 1) throw new Error("One dimensional matrix expected");
    }
});

});

parcelRegister("kqnlZ", function(module, exports) {

$parcel$export(module.exports, "createSpaClass", function () { return $ede859ea3e5c5214$export$5e37e847685a0540; });

var $2mPYl = parcelRequire("2mPYl");
var $ede859ea3e5c5214$var$name = "Spa";
var $ede859ea3e5c5214$var$dependencies = [
    "addScalar",
    "equalScalar",
    "FibonacciHeap"
];
var $ede859ea3e5c5214$export$5e37e847685a0540 = /* #__PURE__ */ (0, $2mPYl.factory)($ede859ea3e5c5214$var$name, $ede859ea3e5c5214$var$dependencies, function(_ref) {
    var addScalar = _ref.addScalar, equalScalar = _ref.equalScalar, FibonacciHeap = _ref.FibonacciHeap;
    /**
   * An ordered Sparse Accumulator is a representation for a sparse vector that includes a dense array
   * of the vector elements and an ordered list of non-zero elements.
   */ function Spa() {
        if (!(this instanceof Spa)) throw new SyntaxError("Constructor must be called with the new operator");
         // allocate vector, TODO use typed arrays
        this._values = [];
        this._heap = new FibonacciHeap();
    }
    /**
   * Attach type information
   */ Spa.prototype.type = "Spa";
    Spa.prototype.isSpa = true;
    /**
   * Set the value for index i.
   *
   * @param {number} i                       The index
   * @param {number | BigNumber | Complex}   The value at index i
   */ Spa.prototype.set = function(i, v) {
        // check we have a value @ i
        if (!this._values[i]) {
            // insert in heap
            var node = this._heap.insert(i, v); // set the value @ i
            this._values[i] = node;
        } else // update the value @ i
        this._values[i].value = v;
    };
    Spa.prototype.get = function(i) {
        var node = this._values[i];
        if (node) return node.value;
        return 0;
    };
    Spa.prototype.accumulate = function(i, v) {
        // node @ i
        var node = this._values[i];
        if (!node) {
            // insert in heap
            node = this._heap.insert(i, v); // initialize value
            this._values[i] = node;
        } else // accumulate value
        node.value = addScalar(node.value, v);
    };
    Spa.prototype.forEach = function(from, to, callback) {
        // references
        var heap = this._heap;
        var values = this._values; // nodes
        var nodes = []; // node with minimum key, save it
        var node = heap.extractMinimum();
        if (node) nodes.push(node);
         // extract nodes from heap (ordered)
        while(node && node.key <= to){
            // check it is in range
            if (node.key >= from) // check value is not zero
            {
                if (!equalScalar(node.value, 0)) // invoke callback
                callback(node.key, node.value, this);
            } // extract next node, save it
            node = heap.extractMinimum();
            if (node) nodes.push(node);
        } // reinsert all nodes in heap
        for(var i = 0; i < nodes.length; i++){
            // current node
            var n = nodes[i]; // insert node in heap
            node = heap.insert(n.key, n.value); // update values
            values[node.key] = node;
        }
    };
    Spa.prototype.swap = function(i, j) {
        // node @ i and j
        var nodei = this._values[i];
        var nodej = this._values[j]; // check we need to insert indeces
        if (!nodei && nodej) {
            // insert in heap
            nodei = this._heap.insert(i, nodej.value); // remove from heap
            this._heap.remove(nodej); // set values
            this._values[i] = nodei;
            this._values[j] = undefined;
        } else if (nodei && !nodej) {
            // insert in heap
            nodej = this._heap.insert(j, nodei.value); // remove from heap
            this._heap.remove(nodei); // set values
            this._values[j] = nodej;
            this._values[i] = undefined;
        } else if (nodei && nodej) {
            // swap values
            var v = nodei.value;
            nodei.value = nodej.value;
            nodej.value = v;
        }
    };
    return Spa;
}, {
    isClass: true
});

});

parcelRegister("7A2Ci", function(module, exports) {

$parcel$export(module.exports, "createSparse", function () { return $584decd464dc53d9$export$89ff03fdb3964a99; });

var $2mPYl = parcelRequire("2mPYl");
var $584decd464dc53d9$var$name = "sparse";
var $584decd464dc53d9$var$dependencies = [
    "typed",
    "SparseMatrix"
];
var $584decd464dc53d9$export$89ff03fdb3964a99 = /* #__PURE__ */ (0, $2mPYl.factory)($584decd464dc53d9$var$name, $584decd464dc53d9$var$dependencies, function(_ref) {
    var typed = _ref.typed, SparseMatrix = _ref.SparseMatrix;
    /**
   * Create a Sparse Matrix. The function creates a new `math.Matrix` object from
   * an `Array`. A Matrix has utility functions to manipulate the data in the
   * matrix, like getting the size and getting or setting values in the matrix.
   *
   * Syntax:
   *
   *    math.sparse()               // creates an empty sparse matrix.
   *    math.sparse(data)           // creates a sparse matrix with initial data.
   *    math.sparse(data, 'number') // creates a sparse matrix with initial data, number datatype.
   *
   * Examples:
   *
   *    let m = math.sparse([[1, 2], [3, 4]])
   *    m.size()                        // Array [2, 2]
   *    m.resize([3, 2], 5)
   *    m.valueOf()                     // Array [[1, 2], [3, 4], [5, 5]]
   *    m.get([1, 0])                    // number 3
   *
   * See also:
   *
   *    bignumber, boolean, complex, index, number, string, unit, matrix
   *
   * @param {Array | Matrix} [data]    A two dimensional array
   *
   * @return {Matrix} The created matrix
   */ return typed($584decd464dc53d9$var$name, {
        "": function _() {
            return new SparseMatrix([]);
        },
        string: function string(datatype) {
            return new SparseMatrix([], datatype);
        },
        "Array | Matrix": function ArrayMatrix(data) {
            return new SparseMatrix(data);
        },
        "Array | Matrix, string": function ArrayMatrixString(data, datatype) {
            return new SparseMatrix(data, datatype);
        }
    });
});

});

parcelRegister("2fv1z", function(module, exports) {

$parcel$export(module.exports, "createSparseMatrixClass", function () { return $1a350c4426878b47$export$a783ce8f6a98b2e5; });

var $1amHZ = parcelRequire("1amHZ");

var $kFRKb = parcelRequire("kFRKb");

var $6NxuJ = parcelRequire("6NxuJ");

var $7ITGG = parcelRequire("7ITGG");

var $5WdrK = parcelRequire("5WdrK");

var $2mPYl = parcelRequire("2mPYl");

var $hy7Bx = parcelRequire("hy7Bx");
var $1a350c4426878b47$var$name = "SparseMatrix";
var $1a350c4426878b47$var$dependencies = [
    "typed",
    "equalScalar",
    "Matrix"
];
var $1a350c4426878b47$export$a783ce8f6a98b2e5 = /* #__PURE__ */ (0, $2mPYl.factory)($1a350c4426878b47$var$name, $1a350c4426878b47$var$dependencies, function(_ref) {
    var typed = _ref.typed, equalScalar = _ref.equalScalar, Matrix = _ref.Matrix;
    /**
   * Sparse Matrix implementation. This type implements a Compressed Column Storage format
   * for sparse matrices.
   * @class SparseMatrix
   */ function SparseMatrix(data, datatype) {
        if (!(this instanceof SparseMatrix)) throw new SyntaxError("Constructor must be called with the new operator");
        if (datatype && !(0, $1amHZ.isString)(datatype)) throw new Error("Invalid datatype: " + datatype);
        if ((0, $1amHZ.isMatrix)(data)) // create from matrix
        _createFromMatrix(this, data, datatype);
        else if (data && (0, $1amHZ.isArray)(data.index) && (0, $1amHZ.isArray)(data.ptr) && (0, $1amHZ.isArray)(data.size)) {
            // initialize fields
            this._values = data.values;
            this._index = data.index;
            this._ptr = data.ptr;
            this._size = data.size;
            this._datatype = datatype || data.datatype;
        } else if ((0, $1amHZ.isArray)(data)) // create from array
        _createFromArray(this, data, datatype);
        else if (data) // unsupported type
        throw new TypeError("Unsupported type of data (" + (0, $1amHZ.typeOf)(data) + ")");
        else {
            // nothing provided
            this._values = [];
            this._index = [];
            this._ptr = [
                0
            ];
            this._size = [
                0,
                0
            ];
            this._datatype = datatype;
        }
    }
    function _createFromMatrix(matrix, source, datatype) {
        // check matrix type
        if (source.type === "SparseMatrix") {
            // clone arrays
            matrix._values = source._values ? (0, $7ITGG.clone)(source._values) : undefined;
            matrix._index = (0, $7ITGG.clone)(source._index);
            matrix._ptr = (0, $7ITGG.clone)(source._ptr);
            matrix._size = (0, $7ITGG.clone)(source._size);
            matrix._datatype = datatype || source._datatype;
        } else // build from matrix data
        _createFromArray(matrix, source.valueOf(), datatype || source._datatype);
    }
    function _createFromArray(matrix, data, datatype) {
        // initialize fields
        matrix._values = [];
        matrix._index = [];
        matrix._ptr = [];
        matrix._datatype = datatype; // discover rows & columns, do not use math.size() to avoid looping array twice
        var rows = data.length;
        var columns = 0; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0;
        if ((0, $1amHZ.isString)(datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [
                datatype,
                datatype
            ]) || equalScalar; // convert 0 to the same datatype
            zero = typed.convert(0, datatype);
        } // check we have rows (empty array)
        if (rows > 0) {
            // column index
            var j = 0;
            do {
                // store pointer to values index
                matrix._ptr.push(matrix._index.length); // loop rows
                for(var i = 0; i < rows; i++){
                    // current row
                    var row = data[i]; // check row is an array
                    if ((0, $1amHZ.isArray)(row)) {
                        // update columns if needed (only on first column)
                        if (j === 0 && columns < row.length) columns = row.length;
                         // check row has column
                        if (j < row.length) {
                            // value
                            var v = row[j]; // check value != 0
                            if (!eq(v, zero)) {
                                // store value
                                matrix._values.push(v); // index
                                matrix._index.push(i);
                            }
                        }
                    } else {
                        // update columns if needed (only on first column)
                        if (j === 0 && columns < 1) columns = 1;
                         // check value != 0 (row is a scalar)
                        if (!eq(row, zero)) {
                            // store value
                            matrix._values.push(row); // index
                            matrix._index.push(i);
                        }
                    }
                } // increment index
                j++;
            }while (j < columns);
        } // store number of values in ptr
        matrix._ptr.push(matrix._index.length); // size
        matrix._size = [
            rows,
            columns
        ];
    }
    SparseMatrix.prototype = new Matrix();
    /**
   * Create a new SparseMatrix
   */ SparseMatrix.prototype.createSparseMatrix = function(data, datatype) {
        return new SparseMatrix(data, datatype);
    };
    /**
   * Attach type information
   */ SparseMatrix.prototype.type = "SparseMatrix";
    SparseMatrix.prototype.isSparseMatrix = true;
    /**
   * Get the matrix type
   *
   * Usage:
   *    const matrixType = matrix.getDataType()  // retrieves the matrix type
   *
   * @memberOf SparseMatrix
   * @return {string}   type information; if multiple types are found from the Matrix, it will return "mixed"
   */ SparseMatrix.prototype.getDataType = function() {
        return (0, $5WdrK.getArrayDataType)(this._values, (0, $1amHZ.typeOf));
    };
    /**
   * Get the storage format used by the matrix.
   *
   * Usage:
   *     const format = matrix.storage()   // retrieve storage format
   *
   * @memberof SparseMatrix
   * @return {string}           The storage format.
   */ SparseMatrix.prototype.storage = function() {
        return "sparse";
    };
    /**
   * Get the datatype of the data stored in the matrix.
   *
   * Usage:
   *     const format = matrix.datatype()    // retrieve matrix datatype
   *
   * @memberof SparseMatrix
   * @return {string}           The datatype.
   */ SparseMatrix.prototype.datatype = function() {
        return this._datatype;
    };
    /**
   * Create a new SparseMatrix
   * @memberof SparseMatrix
   * @param {Array} data
   * @param {string} [datatype]
   */ SparseMatrix.prototype.create = function(data, datatype) {
        return new SparseMatrix(data, datatype);
    };
    /**
   * Get the matrix density.
   *
   * Usage:
   *     const density = matrix.density()                   // retrieve matrix density
   *
   * @memberof SparseMatrix
   * @return {number}           The matrix density.
   */ SparseMatrix.prototype.density = function() {
        // rows & columns
        var rows = this._size[0];
        var columns = this._size[1]; // calculate density
        return rows !== 0 && columns !== 0 ? this._index.length / (rows * columns) : 0;
    };
    /**
   * Get a subset of the matrix, or replace a subset of the matrix.
   *
   * Usage:
   *     const subset = matrix.subset(index)               // retrieve subset
   *     const value = matrix.subset(index, replacement)   // replace subset
   *
   * @memberof SparseMatrix
   * @param {Index} index
   * @param {Array | Matrix | *} [replacement]
   * @param {*} [defaultValue=0]      Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be filled with zeros.
   */ SparseMatrix.prototype.subset = function(index, replacement, defaultValue) {
        // check it is a pattern matrix
        if (!this._values) throw new Error("Cannot invoke subset on a Pattern only matrix");
         // check arguments
        switch(arguments.length){
            case 1:
                return _getsubset(this, index);
            // intentional fall through
            case 2:
            case 3:
                return _setsubset(this, index, replacement, defaultValue);
            default:
                throw new SyntaxError("Wrong number of arguments");
        }
    };
    function _getsubset(matrix, idx) {
        // check idx
        if (!(0, $1amHZ.isIndex)(idx)) throw new TypeError("Invalid index");
        var isScalar = idx.isScalar();
        if (isScalar) // return a scalar
        return matrix.get(idx.min());
         // validate dimensions
        var size = idx.size();
        if (size.length !== matrix._size.length) throw new (0, $hy7Bx.DimensionError)(size.length, matrix._size.length);
         // vars
        var i, ii, k, kk; // validate if any of the ranges in the index is out of range
        var min = idx.min();
        var max = idx.max();
        for(i = 0, ii = matrix._size.length; i < ii; i++){
            (0, $5WdrK.validateIndex)(min[i], matrix._size[i]);
            (0, $5WdrK.validateIndex)(max[i], matrix._size[i]);
        } // matrix arrays
        var mvalues = matrix._values;
        var mindex = matrix._index;
        var mptr = matrix._ptr; // rows & columns dimensions for result matrix
        var rows = idx.dimension(0);
        var columns = idx.dimension(1); // workspace & permutation vector
        var w = [];
        var pv = []; // loop rows in resulting matrix
        rows.forEach(function(i, r) {
            // update permutation vector
            pv[i] = r[0]; // mark i in workspace
            w[i] = true;
        }); // result matrix arrays
        var values = mvalues ? [] : undefined;
        var index = [];
        var ptr = []; // loop columns in result matrix
        columns.forEach(function(j) {
            // update ptr
            ptr.push(index.length); // loop values in column j
            for(k = mptr[j], kk = mptr[j + 1]; k < kk; k++){
                // row
                i = mindex[k]; // check row is in result matrix
                if (w[i] === true) {
                    // push index
                    index.push(pv[i]); // check we need to process values
                    if (values) values.push(mvalues[k]);
                }
            }
        }); // update ptr
        ptr.push(index.length); // return matrix
        return new SparseMatrix({
            values: values,
            index: index,
            ptr: ptr,
            size: size,
            datatype: matrix._datatype
        });
    }
    function _setsubset(matrix, index, submatrix, defaultValue) {
        // check index
        if (!index || index.isIndex !== true) throw new TypeError("Invalid index");
         // get index size and check whether the index contains a single value
        var iSize = index.size();
        var isScalar = index.isScalar(); // calculate the size of the submatrix, and convert it into an Array if needed
        var sSize;
        if ((0, $1amHZ.isMatrix)(submatrix)) {
            // submatrix size
            sSize = submatrix.size(); // use array representation
            submatrix = submatrix.toArray();
        } else // get submatrix size (array, scalar)
        sSize = (0, $5WdrK.arraySize)(submatrix);
         // check index is a scalar
        if (isScalar) {
            // verify submatrix is a scalar
            if (sSize.length !== 0) throw new TypeError("Scalar expected");
             // set value
            matrix.set(index.min(), submatrix, defaultValue);
        } else {
            // validate dimensions, index size must be one or two dimensions
            if (iSize.length !== 1 && iSize.length !== 2) throw new (0, $hy7Bx.DimensionError)(iSize.length, matrix._size.length, "<");
             // check submatrix and index have the same dimensions
            if (sSize.length < iSize.length) {
                // calculate number of missing outer dimensions
                var i = 0;
                var outer = 0;
                while(iSize[i] === 1 && sSize[i] === 1)i++;
                while(iSize[i] === 1){
                    outer++;
                    i++;
                } // unsqueeze both outer and inner dimensions
                submatrix = (0, $5WdrK.unsqueeze)(submatrix, iSize.length, outer, sSize);
            } // check whether the size of the submatrix matches the index size
            if (!(0, $7ITGG.deepStrictEqual)(iSize, sSize)) throw new (0, $hy7Bx.DimensionError)(iSize, sSize, ">");
             // offsets
            var x0 = index.min()[0];
            var y0 = index.min()[1]; // submatrix rows and columns
            var m = sSize[0];
            var n = sSize[1]; // loop submatrix
            for(var x = 0; x < m; x++)// loop columns
            for(var y = 0; y < n; y++){
                // value at i, j
                var v = submatrix[x][y]; // invoke set (zero value will remove entry from matrix)
                matrix.set([
                    x + x0,
                    y + y0
                ], v, defaultValue);
            }
        }
        return matrix;
    }
    /**
   * Get a single element from the matrix.
   * @memberof SparseMatrix
   * @param {number[]} index   Zero-based index
   * @return {*} value
   */ SparseMatrix.prototype.get = function(index) {
        if (!(0, $1amHZ.isArray)(index)) throw new TypeError("Array expected");
        if (index.length !== this._size.length) throw new (0, $hy7Bx.DimensionError)(index.length, this._size.length);
         // check it is a pattern matrix
        if (!this._values) throw new Error("Cannot invoke get on a Pattern only matrix");
         // row and column
        var i = index[0];
        var j = index[1]; // check i, j are valid
        (0, $5WdrK.validateIndex)(i, this._size[0]);
        (0, $5WdrK.validateIndex)(j, this._size[1]); // find value index
        var k = _getValueIndex(i, this._ptr[j], this._ptr[j + 1], this._index); // check k is prior to next column k and it is in the correct row
        if (k < this._ptr[j + 1] && this._index[k] === i) return this._values[k];
        return 0;
    };
    /**
   * Replace a single element in the matrix.
   * @memberof SparseMatrix
   * @param {number[]} index   Zero-based index
   * @param {*} v
   * @param {*} [defaultValue]        Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be set to zero.
   * @return {SparseMatrix} self
   */ SparseMatrix.prototype.set = function(index, v, defaultValue) {
        if (!(0, $1amHZ.isArray)(index)) throw new TypeError("Array expected");
        if (index.length !== this._size.length) throw new (0, $hy7Bx.DimensionError)(index.length, this._size.length);
         // check it is a pattern matrix
        if (!this._values) throw new Error("Cannot invoke set on a Pattern only matrix");
         // row and column
        var i = index[0];
        var j = index[1]; // rows & columns
        var rows = this._size[0];
        var columns = this._size[1]; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0;
        if ((0, $1amHZ.isString)(this._datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [
                this._datatype,
                this._datatype
            ]) || equalScalar; // convert 0 to the same datatype
            zero = typed.convert(0, this._datatype);
        } // check we need to resize matrix
        if (i > rows - 1 || j > columns - 1) {
            // resize matrix
            _resize(this, Math.max(i + 1, rows), Math.max(j + 1, columns), defaultValue); // update rows & columns
            rows = this._size[0];
            columns = this._size[1];
        } // check i, j are valid
        (0, $5WdrK.validateIndex)(i, rows);
        (0, $5WdrK.validateIndex)(j, columns); // find value index
        var k = _getValueIndex(i, this._ptr[j], this._ptr[j + 1], this._index); // check k is prior to next column k and it is in the correct row
        if (k < this._ptr[j + 1] && this._index[k] === i) {
            // check value != 0
            if (!eq(v, zero)) // update value
            this._values[k] = v;
            else // remove value from matrix
            _remove(k, j, this._values, this._index, this._ptr);
        } else // insert value @ (i, j)
        _insert(k, i, j, v, this._values, this._index, this._ptr);
        return this;
    };
    function _getValueIndex(i, top, bottom, index) {
        // check row is on the bottom side
        if (bottom - top === 0) return bottom;
         // loop rows [top, bottom[
        for(var r = top; r < bottom; r++){
            // check we found value index
            if (index[r] === i) return r;
        } // we did not find row
        return top;
    }
    function _remove(k, j, values, index, ptr) {
        // remove value @ k
        values.splice(k, 1);
        index.splice(k, 1); // update pointers
        for(var x = j + 1; x < ptr.length; x++)ptr[x]--;
    }
    function _insert(k, i, j, v, values, index, ptr) {
        // insert value
        values.splice(k, 0, v); // update row for k
        index.splice(k, 0, i); // update column pointers
        for(var x = j + 1; x < ptr.length; x++)ptr[x]++;
    }
    /**
   * Resize the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (resize in place).
   *
   * @memberof SparseMatrix
   * @param {number[]} size           The new size the matrix should have.
   * @param {*} [defaultValue=0]      Default value, filled in on new entries.
   *                                  If not provided, the matrix elements will
   *                                  be filled with zeros.
   * @param {boolean} [copy]          Return a resized copy of the matrix
   *
   * @return {Matrix}                 The resized matrix
   */ SparseMatrix.prototype.resize = function(size, defaultValue, copy) {
        // validate arguments
        if (!(0, $1amHZ.isArray)(size)) throw new TypeError("Array expected");
        if (size.length !== 2) throw new Error("Only two dimensions matrix are supported");
         // check sizes
        size.forEach(function(value) {
            if (!(0, $1amHZ.isNumber)(value) || !(0, $kFRKb.isInteger)(value) || value < 0) throw new TypeError("Invalid size, must contain positive integers (size: " + (0, $6NxuJ.format)(size) + ")");
        }); // matrix to resize
        var m = copy ? this.clone() : this; // resize matrix
        return _resize(m, size[0], size[1], defaultValue);
    };
    function _resize(matrix, rows, columns, defaultValue) {
        // value to insert at the time of growing matrix
        var value = defaultValue || 0; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0;
        if ((0, $1amHZ.isString)(matrix._datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [
                matrix._datatype,
                matrix._datatype
            ]) || equalScalar; // convert 0 to the same datatype
            zero = typed.convert(0, matrix._datatype); // convert value to the same datatype
            value = typed.convert(value, matrix._datatype);
        } // should we insert the value?
        var ins = !eq(value, zero); // old columns and rows
        var r = matrix._size[0];
        var c = matrix._size[1];
        var i, j, k; // check we need to increase columns
        if (columns > c) {
            // loop new columns
            for(j = c; j < columns; j++){
                // update matrix._ptr for current column
                matrix._ptr[j] = matrix._values.length; // check we need to insert matrix._values
                if (ins) // loop rows
                for(i = 0; i < r; i++){
                    // add new matrix._values
                    matrix._values.push(value); // update matrix._index
                    matrix._index.push(i);
                }
            } // store number of matrix._values in matrix._ptr
            matrix._ptr[columns] = matrix._values.length;
        } else if (columns < c) {
            // truncate matrix._ptr
            matrix._ptr.splice(columns + 1, c - columns); // truncate matrix._values and matrix._index
            matrix._values.splice(matrix._ptr[columns], matrix._values.length);
            matrix._index.splice(matrix._ptr[columns], matrix._index.length);
        } // update columns
        c = columns; // check we need to increase rows
        if (rows > r) // check we have to insert values
        {
            if (ins) {
                // inserts
                var n = 0; // loop columns
                for(j = 0; j < c; j++){
                    // update matrix._ptr for current column
                    matrix._ptr[j] = matrix._ptr[j] + n; // where to insert matrix._values
                    k = matrix._ptr[j + 1] + n; // pointer
                    var p = 0; // loop new rows, initialize pointer
                    for(i = r; i < rows; i++, p++){
                        // add value
                        matrix._values.splice(k + p, 0, value); // update matrix._index
                        matrix._index.splice(k + p, 0, i); // increment inserts
                        n++;
                    }
                } // store number of matrix._values in matrix._ptr
                matrix._ptr[c] = matrix._values.length;
            }
        } else if (rows < r) {
            // deletes
            var d = 0; // loop columns
            for(j = 0; j < c; j++){
                // update matrix._ptr for current column
                matrix._ptr[j] = matrix._ptr[j] - d; // where matrix._values start for next column
                var k0 = matrix._ptr[j];
                var k1 = matrix._ptr[j + 1] - d; // loop matrix._index
                for(k = k0; k < k1; k++){
                    // row
                    i = matrix._index[k]; // check we need to delete value and matrix._index
                    if (i > rows - 1) {
                        // remove value
                        matrix._values.splice(k, 1); // remove item from matrix._index
                        matrix._index.splice(k, 1); // increase deletes
                        d++;
                    }
                }
            } // update matrix._ptr for current column
            matrix._ptr[j] = matrix._values.length;
        } // update matrix._size
        matrix._size[0] = rows;
        matrix._size[1] = columns; // return matrix
        return matrix;
    }
    /**
   * Reshape the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (reshape in place).
   *
   * NOTE: This might be better suited to copy by default, instead of modifying
   *       in place. For now, it operates in place to remain consistent with
   *       resize().
   *
   * @memberof SparseMatrix
   * @param {number[]} size           The new size the matrix should have.
   * @param {boolean} [copy]          Return a reshaped copy of the matrix
   *
   * @return {Matrix}                 The reshaped matrix
   */ SparseMatrix.prototype.reshape = function(size, copy) {
        // validate arguments
        if (!(0, $1amHZ.isArray)(size)) throw new TypeError("Array expected");
        if (size.length !== 2) throw new Error("Sparse matrices can only be reshaped in two dimensions");
         // check sizes
        size.forEach(function(value) {
            if (!(0, $1amHZ.isNumber)(value) || !(0, $kFRKb.isInteger)(value) || value < 0) throw new TypeError("Invalid size, must contain positive integers (size: " + (0, $6NxuJ.format)(size) + ")");
        }); // m * n must not change
        if (this._size[0] * this._size[1] !== size[0] * size[1]) throw new Error("Reshaping sparse matrix will result in the wrong number of elements");
         // matrix to reshape
        var m = copy ? this.clone() : this; // return unchanged if the same shape
        if (this._size[0] === size[0] && this._size[1] === size[1]) return m;
         // Convert to COO format (generate a column index)
        var colIndex = [];
        for(var i = 0; i < m._ptr.length; i++)for(var j = 0; j < m._ptr[i + 1] - m._ptr[i]; j++)colIndex.push(i);
         // Clone the values array
        var values = m._values.slice(); // Clone the row index array
        var rowIndex = m._index.slice(); // Transform the (row, column) indices
        for(var _i = 0; _i < m._index.length; _i++){
            var r1 = rowIndex[_i];
            var c1 = colIndex[_i];
            var flat = r1 * m._size[1] + c1;
            colIndex[_i] = flat % size[1];
            rowIndex[_i] = Math.floor(flat / size[1]);
        } // Now reshaping is supposed to preserve the row-major order, BUT these sparse matrices are stored
        // in column-major order, so we have to reorder the value array now. One option is to use a multisort,
        // sorting several arrays based on some other array.
        // OR, we could easily just:
        // 1. Remove all values from the matrix
        m._values.length = 0;
        m._index.length = 0;
        m._ptr.length = size[1] + 1;
        m._size = size.slice();
        for(var _i2 = 0; _i2 < m._ptr.length; _i2++)m._ptr[_i2] = 0;
         // 2. Re-insert all elements in the proper order (simplified code from SparseMatrix.prototype.set)
        // This step is probably the most time-consuming
        for(var h = 0; h < values.length; h++){
            var _i3 = rowIndex[h];
            var _j = colIndex[h];
            var v = values[h];
            var k = _getValueIndex(_i3, m._ptr[_j], m._ptr[_j + 1], m._index);
            _insert(k, _i3, _j, v, m._values, m._index, m._ptr);
        } // The value indices are inserted out of order, but apparently that's... still OK?
        return m;
    };
    /**
   * Create a clone of the matrix
   * @memberof SparseMatrix
   * @return {SparseMatrix} clone
   */ SparseMatrix.prototype.clone = function() {
        var m = new SparseMatrix({
            values: this._values ? (0, $7ITGG.clone)(this._values) : undefined,
            index: (0, $7ITGG.clone)(this._index),
            ptr: (0, $7ITGG.clone)(this._ptr),
            size: (0, $7ITGG.clone)(this._size),
            datatype: this._datatype
        });
        return m;
    };
    /**
   * Retrieve the size of the matrix.
   * @memberof SparseMatrix
   * @returns {number[]} size
   */ SparseMatrix.prototype.size = function() {
        return this._size.slice(0); // copy the Array
    };
    /**
   * Create a new matrix with the results of the callback function executed on
   * each entry of the matrix.
   * @memberof SparseMatrix
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   * @param {boolean} [skipZeros] Invoke callback function for non-zero values only.
   *
   * @return {SparseMatrix} matrix
   */ SparseMatrix.prototype.map = function(callback, skipZeros) {
        // check it is a pattern matrix
        if (!this._values) throw new Error("Cannot invoke map on a Pattern only matrix");
         // matrix instance
        var me = this; // rows and columns
        var rows = this._size[0];
        var columns = this._size[1]; // invoke callback
        var invoke = function invoke(v, i, j) {
            // invoke callback
            return callback(v, [
                i,
                j
            ], me);
        }; // invoke _map
        return _map(this, 0, rows - 1, 0, columns - 1, invoke, skipZeros);
    };
    /**
   * Create a new matrix with the results of the callback function executed on the interval
   * [minRow..maxRow, minColumn..maxColumn].
   */ function _map(matrix, minRow, maxRow, minColumn, maxColumn, callback, skipZeros) {
        // result arrays
        var values = [];
        var index = [];
        var ptr = []; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0;
        if ((0, $1amHZ.isString)(matrix._datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [
                matrix._datatype,
                matrix._datatype
            ]) || equalScalar; // convert 0 to the same datatype
            zero = typed.convert(0, matrix._datatype);
        } // invoke callback
        var invoke = function invoke(v, x, y) {
            // invoke callback
            v = callback(v, x, y); // check value != 0
            if (!eq(v, zero)) {
                // store value
                values.push(v); // index
                index.push(x);
            }
        }; // loop columns
        for(var j = minColumn; j <= maxColumn; j++){
            // store pointer to values index
            ptr.push(values.length); // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = matrix._ptr[j];
            var k1 = matrix._ptr[j + 1];
            if (skipZeros) // loop k within [k0, k1[
            for(var k = k0; k < k1; k++){
                // row index
                var i = matrix._index[k]; // check i is in range
                if (i >= minRow && i <= maxRow) // value @ k
                invoke(matrix._values[k], i - minRow, j - minColumn);
            }
            else {
                // create a cache holding all defined values
                var _values = {};
                for(var _k = k0; _k < k1; _k++){
                    var _i4 = matrix._index[_k];
                    _values[_i4] = matrix._values[_k];
                } // loop over all rows (indexes can be unordered so we can't use that),
                // and either read the value or zero
                for(var _i5 = minRow; _i5 <= maxRow; _i5++){
                    var value = _i5 in _values ? _values[_i5] : 0;
                    invoke(value, _i5 - minRow, j - minColumn);
                }
            }
        } // store number of values in ptr
        ptr.push(values.length); // return sparse matrix
        return new SparseMatrix({
            values: values,
            index: index,
            ptr: ptr,
            size: [
                maxRow - minRow + 1,
                maxColumn - minColumn + 1
            ]
        });
    }
    /**
   * Execute a callback function on each entry of the matrix.
   * @memberof SparseMatrix
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   * @param {boolean} [skipZeros] Invoke callback function for non-zero values only.
   */ SparseMatrix.prototype.forEach = function(callback, skipZeros) {
        // check it is a pattern matrix
        if (!this._values) throw new Error("Cannot invoke forEach on a Pattern only matrix");
         // matrix instance
        var me = this; // rows and columns
        var rows = this._size[0];
        var columns = this._size[1]; // loop columns
        for(var j = 0; j < columns; j++){
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = this._ptr[j];
            var k1 = this._ptr[j + 1];
            if (skipZeros) // loop k within [k0, k1[
            for(var k = k0; k < k1; k++){
                // row index
                var i = this._index[k]; // value @ k
                callback(this._values[k], [
                    i,
                    j
                ], me);
            }
            else {
                // create a cache holding all defined values
                var values = {};
                for(var _k2 = k0; _k2 < k1; _k2++){
                    var _i6 = this._index[_k2];
                    values[_i6] = this._values[_k2];
                } // loop over all rows (indexes can be unordered so we can't use that),
                // and either read the value or zero
                for(var _i7 = 0; _i7 < rows; _i7++){
                    var value = _i7 in values ? values[_i7] : 0;
                    callback(value, [
                        _i7,
                        j
                    ], me);
                }
            }
        }
    };
    /**
   * Create an Array with a copy of the data of the SparseMatrix
   * @memberof SparseMatrix
   * @returns {Array} array
   */ SparseMatrix.prototype.toArray = function() {
        return _toArray(this._values, this._index, this._ptr, this._size, true);
    };
    /**
   * Get the primitive value of the SparseMatrix: a two dimensions array
   * @memberof SparseMatrix
   * @returns {Array} array
   */ SparseMatrix.prototype.valueOf = function() {
        return _toArray(this._values, this._index, this._ptr, this._size, false);
    };
    function _toArray(values, index, ptr, size, copy) {
        // rows and columns
        var rows = size[0];
        var columns = size[1]; // result
        var a = []; // vars
        var i, j; // initialize array
        for(i = 0; i < rows; i++){
            a[i] = [];
            for(j = 0; j < columns; j++)a[i][j] = 0;
        } // loop columns
        for(j = 0; j < columns; j++){
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = ptr[j];
            var k1 = ptr[j + 1]; // loop k within [k0, k1[
            for(var k = k0; k < k1; k++){
                // row index
                i = index[k]; // set value (use one for pattern matrix)
                a[i][j] = values ? copy ? (0, $7ITGG.clone)(values[k]) : values[k] : 1;
            }
        }
        return a;
    }
    /**
   * Get a string representation of the matrix, with optional formatting options.
   * @memberof SparseMatrix
   * @param {Object | number | Function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @returns {string} str
   */ SparseMatrix.prototype.format = function(options) {
        // rows and columns
        var rows = this._size[0];
        var columns = this._size[1]; // density
        var density = this.density(); // rows & columns
        var str = "Sparse Matrix [" + (0, $6NxuJ.format)(rows, options) + " x " + (0, $6NxuJ.format)(columns, options) + "] density: " + (0, $6NxuJ.format)(density, options) + "\n"; // loop columns
        for(var j = 0; j < columns; j++){
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = this._ptr[j];
            var k1 = this._ptr[j + 1]; // loop k within [k0, k1[
            for(var k = k0; k < k1; k++){
                // row index
                var i = this._index[k]; // append value
                str += "\n    (" + (0, $6NxuJ.format)(i, options) + ", " + (0, $6NxuJ.format)(j, options) + ") ==> " + (this._values ? (0, $6NxuJ.format)(this._values[k], options) : "X");
            }
        }
        return str;
    };
    /**
   * Get a string representation of the matrix
   * @memberof SparseMatrix
   * @returns {string} str
   */ SparseMatrix.prototype.toString = function() {
        return (0, $6NxuJ.format)(this.toArray());
    };
    /**
   * Get a JSON representation of the matrix
   * @memberof SparseMatrix
   * @returns {Object}
   */ SparseMatrix.prototype.toJSON = function() {
        return {
            mathjs: "SparseMatrix",
            values: this._values,
            index: this._index,
            ptr: this._ptr,
            size: this._size,
            datatype: this._datatype
        };
    };
    /**
   * Get the kth Matrix diagonal.
   *
   * @memberof SparseMatrix
   * @param {number | BigNumber} [k=0]     The kth diagonal where the vector will retrieved.
   *
   * @returns {Matrix}                     The matrix vector with the diagonal values.
   */ SparseMatrix.prototype.diagonal = function(k) {
        // validate k if any
        if (k) {
            // convert BigNumber to a number
            if ((0, $1amHZ.isBigNumber)(k)) k = k.toNumber();
             // is must be an integer
            if (!(0, $1amHZ.isNumber)(k) || !(0, $kFRKb.isInteger)(k)) throw new TypeError("The parameter k must be an integer number");
        } else // default value
        k = 0;
        var kSuper = k > 0 ? k : 0;
        var kSub = k < 0 ? -k : 0; // rows & columns
        var rows = this._size[0];
        var columns = this._size[1]; // number diagonal values
        var n = Math.min(rows - kSub, columns - kSuper); // diagonal arrays
        var values = [];
        var index = [];
        var ptr = []; // initial ptr value
        ptr[0] = 0; // loop columns
        for(var j = kSuper; j < columns && values.length < n; j++){
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = this._ptr[j];
            var k1 = this._ptr[j + 1]; // loop x within [k0, k1[
            for(var x = k0; x < k1; x++){
                // row index
                var i = this._index[x]; // check row
                if (i === j - kSuper + kSub) {
                    // value on this column
                    values.push(this._values[x]); // store row
                    index[values.length - 1] = i - kSub; // exit loop
                    break;
                }
            }
        } // close ptr
        ptr.push(values.length); // return matrix
        return new SparseMatrix({
            values: values,
            index: index,
            ptr: ptr,
            size: [
                n,
                1
            ]
        });
    };
    /**
   * Generate a matrix from a JSON object
   * @memberof SparseMatrix
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "SparseMatrix", "values": [], "index": [], "ptr": [], "size": []}`,
   *                       where mathjs is optional
   * @returns {SparseMatrix}
   */ SparseMatrix.fromJSON = function(json) {
        return new SparseMatrix(json);
    };
    /**
   * Create a diagonal matrix.
   *
   * @memberof SparseMatrix
   * @param {Array} size                       The matrix size.
   * @param {number | Array | Matrix } value   The values for the diagonal.
   * @param {number | BigNumber} [k=0]         The kth diagonal where the vector will be filled in.
   * @param {number} [defaultValue]            The default value for non-diagonal
   * @param {string} [datatype]                The Matrix datatype, values must be of this datatype.
   *
   * @returns {SparseMatrix}
   */ SparseMatrix.diagonal = function(size, value, k, defaultValue, datatype) {
        if (!(0, $1amHZ.isArray)(size)) throw new TypeError("Array expected, size parameter");
        if (size.length !== 2) throw new Error("Only two dimensions matrix are supported");
         // map size & validate
        size = size.map(function(s) {
            // check it is a big number
            if ((0, $1amHZ.isBigNumber)(s)) // convert it
            s = s.toNumber();
             // validate arguments
            if (!(0, $1amHZ.isNumber)(s) || !(0, $kFRKb.isInteger)(s) || s < 1) throw new Error("Size values must be positive integers");
            return s;
        }); // validate k if any
        if (k) {
            // convert BigNumber to a number
            if ((0, $1amHZ.isBigNumber)(k)) k = k.toNumber();
             // is must be an integer
            if (!(0, $1amHZ.isNumber)(k) || !(0, $kFRKb.isInteger)(k)) throw new TypeError("The parameter k must be an integer number");
        } else // default value
        k = 0;
         // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0;
        if ((0, $1amHZ.isString)(datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [
                datatype,
                datatype
            ]) || equalScalar; // convert 0 to the same datatype
            zero = typed.convert(0, datatype);
        }
        var kSuper = k > 0 ? k : 0;
        var kSub = k < 0 ? -k : 0; // rows and columns
        var rows = size[0];
        var columns = size[1]; // number of non-zero items
        var n = Math.min(rows - kSub, columns - kSuper); // value extraction function
        var _value; // check value
        if ((0, $1amHZ.isArray)(value)) {
            // validate array
            if (value.length !== n) // number of values in array must be n
            throw new Error("Invalid value array length");
             // define function
            _value = function _value(i) {
                // return value @ i
                return value[i];
            };
        } else if ((0, $1amHZ.isMatrix)(value)) {
            // matrix size
            var ms = value.size(); // validate matrix
            if (ms.length !== 1 || ms[0] !== n) // number of values in array must be n
            throw new Error("Invalid matrix length");
             // define function
            _value = function _value(i) {
                // return value @ i
                return value.get([
                    i
                ]);
            };
        } else // define function
        _value = function _value() {
            // return value
            return value;
        };
         // create arrays
        var values = [];
        var index = [];
        var ptr = []; // loop items
        for(var j = 0; j < columns; j++){
            // number of rows with value
            ptr.push(values.length); // diagonal index
            var i = j - kSuper; // check we need to set diagonal value
            if (i >= 0 && i < n) {
                // get value @ i
                var v = _value(i); // check for zero
                if (!eq(v, zero)) {
                    // column
                    index.push(i + kSub); // add value
                    values.push(v);
                }
            }
        } // last value should be number of values
        ptr.push(values.length); // create SparseMatrix
        return new SparseMatrix({
            values: values,
            index: index,
            ptr: ptr,
            size: [
                rows,
                columns
            ]
        });
    };
    /**
   * Swap rows i and j in Matrix.
   *
   * @memberof SparseMatrix
   * @param {number} i       Matrix row index 1
   * @param {number} j       Matrix row index 2
   *
   * @return {Matrix}        The matrix reference
   */ SparseMatrix.prototype.swapRows = function(i, j) {
        // check index
        if (!(0, $1amHZ.isNumber)(i) || !(0, $kFRKb.isInteger)(i) || !(0, $1amHZ.isNumber)(j) || !(0, $kFRKb.isInteger)(j)) throw new Error("Row index must be positive integers");
         // check dimensions
        if (this._size.length !== 2) throw new Error("Only two dimensional matrix is supported");
         // validate index
        (0, $5WdrK.validateIndex)(i, this._size[0]);
        (0, $5WdrK.validateIndex)(j, this._size[0]); // swap rows
        SparseMatrix._swapRows(i, j, this._size[1], this._values, this._index, this._ptr); // return current instance
        return this;
    };
    /**
   * Loop rows with data in column j.
   *
   * @param {number} j            Column
   * @param {Array} values        Matrix values
   * @param {Array} index         Matrix row indeces
   * @param {Array} ptr           Matrix column pointers
   * @param {Function} callback   Callback function invoked for every row in column j
   */ SparseMatrix._forEachRow = function(j, values, index, ptr, callback) {
        // indeces for column j
        var k0 = ptr[j];
        var k1 = ptr[j + 1]; // loop
        for(var k = k0; k < k1; k++)// invoke callback
        callback(index[k], values[k]);
    };
    /**
   * Swap rows x and y in Sparse Matrix data structures.
   *
   * @param {number} x         Matrix row index 1
   * @param {number} y         Matrix row index 2
   * @param {number} columns   Number of columns in matrix
   * @param {Array} values     Matrix values
   * @param {Array} index      Matrix row indeces
   * @param {Array} ptr        Matrix column pointers
   */ SparseMatrix._swapRows = function(x, y, columns, values, index, ptr) {
        // loop columns
        for(var j = 0; j < columns; j++){
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = ptr[j];
            var k1 = ptr[j + 1]; // find value index @ x
            var kx = _getValueIndex(x, k0, k1, index); // find value index @ x
            var ky = _getValueIndex(y, k0, k1, index); // check both rows exist in matrix
            if (kx < k1 && ky < k1 && index[kx] === x && index[ky] === y) {
                // swap values (check for pattern matrix)
                if (values) {
                    var v = values[kx];
                    values[kx] = values[ky];
                    values[ky] = v;
                } // next column
                continue;
            } // check x row exist & no y row
            if (kx < k1 && index[kx] === x && (ky >= k1 || index[ky] !== y)) {
                // value @ x (check for pattern matrix)
                var vx = values ? values[kx] : undefined; // insert value @ y
                index.splice(ky, 0, y);
                if (values) values.splice(ky, 0, vx);
                 // remove value @ x (adjust array index if needed)
                index.splice(ky <= kx ? kx + 1 : kx, 1);
                if (values) values.splice(ky <= kx ? kx + 1 : kx, 1);
                 // next column
                continue;
            } // check y row exist & no x row
            if (ky < k1 && index[ky] === y && (kx >= k1 || index[kx] !== x)) {
                // value @ y (check for pattern matrix)
                var vy = values ? values[ky] : undefined; // insert value @ x
                index.splice(kx, 0, x);
                if (values) values.splice(kx, 0, vy);
                 // remove value @ y (adjust array index if needed)
                index.splice(kx <= ky ? ky + 1 : ky, 1);
                if (values) values.splice(kx <= ky ? ky + 1 : ky, 1);
            }
        }
    };
    return SparseMatrix;
}, {
    isClass: true
});

});

parcelRegister("6WD2R", function(module, exports) {

$parcel$export(module.exports, "createSplitUnit", function () { return $50e6726e09fe9543$export$a9f61753ee14ea96; });

var $2mPYl = parcelRequire("2mPYl");
var $50e6726e09fe9543$var$name = "splitUnit";
var $50e6726e09fe9543$var$dependencies = [
    "typed"
];
var $50e6726e09fe9543$export$a9f61753ee14ea96 = /* #__PURE__ */ (0, $2mPYl.factory)($50e6726e09fe9543$var$name, $50e6726e09fe9543$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Split a unit in an array of units whose sum is equal to the original unit.
   *
   * Syntax:
   *
   *     splitUnit(unit: Unit, parts: Array.<Unit>)
   *
   * Example:
   *
   *     math.splitUnit(new Unit(1, 'm'), ['feet', 'inch'])
   *     // [ 3 feet, 3.3700787401575 inch ]
   *
   * See also:
   *
   *     unit
   *
   * @param {Array} [parts] An array of strings or valueless units.
   * @return {Array} An array of units.
   */ return typed($50e6726e09fe9543$var$name, {
        "Unit, Array": function UnitArray(unit, parts) {
            return unit.splitUnit(parts);
        }
    });
});

});

parcelRegister("ielEK", function(module, exports) {

$parcel$export(module.exports, "createSqrt", function () { return $d45a55447e42d17f$export$eb18ce1988c5f19c; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");
var $d45a55447e42d17f$var$name = "sqrt";
var $d45a55447e42d17f$var$dependencies = [
    "config",
    "typed",
    "Complex"
];
var $d45a55447e42d17f$export$eb18ce1988c5f19c = /* #__PURE__ */ (0, $2mPYl.factory)($d45a55447e42d17f$var$name, $d45a55447e42d17f$var$dependencies, function(_ref) {
    var config = _ref.config, typed = _ref.typed, Complex = _ref.Complex;
    /**
   * Calculate the square root of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.sqrt(x)
   *
   * Examples:
   *
   *    math.sqrt(25)                // returns 5
   *    math.square(5)               // returns 25
   *    math.sqrt(-4)                // returns Complex 2i
   *
   * See also:
   *
   *    square, multiply, cube, cbrt, sqrtm
   *
   * @param {number | BigNumber | Complex | Array | Matrix | Unit} x
   *            Value for which to calculate the square root.
   * @return {number | BigNumber | Complex | Array | Matrix | Unit}
   *            Returns the square root of `x`
   */ var sqrt = typed("sqrt", {
        number: _sqrtNumber,
        Complex: function Complex(x) {
            return x.sqrt();
        },
        BigNumber: function BigNumber(x) {
            if (!x.isNegative() || config.predictable) return x.sqrt();
            else // negative value -> downgrade to number to do complex value computation
            return _sqrtNumber(x.toNumber());
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since sqrt(0) = 0
            return (0, $e04i1.deepMap)(x, sqrt, true);
        },
        Unit: function Unit(x) {
            // Someday will work for complex units when they are implemented
            return x.pow(0.5);
        }
    });
    /**
   * Calculate sqrt for a number
   * @param {number} x
   * @returns {number | Complex} Returns the square root of x
   * @private
   */ function _sqrtNumber(x) {
        if (isNaN(x)) return NaN;
        else if (x >= 0 || config.predictable) return Math.sqrt(x);
        else return new Complex(x, 0).sqrt();
    }
    return sqrt;
});

});

parcelRegister("i3llS", function(module, exports) {

$parcel$export(module.exports, "createSqrtm", function () { return $d24911d6a3bf95c7$export$71d0f952576e7511; });

var $1amHZ = parcelRequire("1amHZ");

var $6NxuJ = parcelRequire("6NxuJ");

var $5WdrK = parcelRequire("5WdrK");

var $2mPYl = parcelRequire("2mPYl");
var $d24911d6a3bf95c7$var$name = "sqrtm";
var $d24911d6a3bf95c7$var$dependencies = [
    "typed",
    "abs",
    "add",
    "multiply",
    "sqrt",
    "subtract",
    "inv",
    "size",
    "max",
    "identity"
];
var $d24911d6a3bf95c7$export$71d0f952576e7511 = /* #__PURE__ */ (0, $2mPYl.factory)($d24911d6a3bf95c7$var$name, $d24911d6a3bf95c7$var$dependencies, function(_ref) {
    var typed = _ref.typed, abs = _ref.abs, add = _ref.add, multiply = _ref.multiply, sqrt = _ref.sqrt, subtract = _ref.subtract, inv = _ref.inv, size = _ref.size, max = _ref.max, identity = _ref.identity;
    /**
   * Calculate the principal square root of a square matrix.
   * The principal square root matrix `X` of another matrix `A` is such that `X * X = A`.
   *
   * https://en.wikipedia.org/wiki/Square_root_of_a_matrix
   *
   * Syntax:
   *
   *     X = math.sqrtm(A)
   *
   * Examples:
   *
   *     math.sqrtm([[1, 2], [3, 4]]) // returns [[-2, 1], [1.5, -0.5]]
   *
   * See also:
   *
   *     sqrt, pow
   *
   * @param  {Array | Matrix} A   The square matrix `A`
   * @return {Array | Matrix}     The principal square root of matrix `A`
   */ var sqrtm = typed($d24911d6a3bf95c7$var$name, {
        "Array | Matrix": function ArrayMatrix(A) {
            var size = (0, $1amHZ.isMatrix)(A) ? A.size() : (0, $5WdrK.arraySize)(A);
            switch(size.length){
                case 1:
                    // Single element Array | Matrix
                    if (size[0] === 1) return sqrt(A);
                    else throw new RangeError("Matrix must be square (size: " + (0, $6NxuJ.format)(size) + ")");
                case 2:
                    // Two-dimensional Array | Matrix
                    var rows = size[0];
                    var cols = size[1];
                    if (rows === cols) return _denmanBeavers(A);
                    else throw new RangeError("Matrix must be square (size: " + (0, $6NxuJ.format)(size) + ")");
            }
        }
    });
    var _maxIterations = 1e3;
    var _tolerance = 1e-6;
    /**
   * Calculate the principal square root matrix using the Denman–Beavers iterative method
   *
   * https://en.wikipedia.org/wiki/Square_root_of_a_matrix#By_Denman–Beavers_iteration
   *
   * @param  {Array | Matrix} A   The square matrix `A`
   * @return {Array | Matrix}     The principal square root of matrix `A`
   * @private
   */ function _denmanBeavers(A) {
        var error;
        var iterations = 0;
        var Y = A;
        var Z = identity(size(A));
        do {
            var Yk = Y;
            Y = multiply(0.5, add(Yk, inv(Z)));
            Z = multiply(0.5, add(Z, inv(Yk)));
            error = max(abs(subtract(Y, Yk)));
            if (error > _tolerance && ++iterations > _maxIterations) throw new Error("computing square root of matrix: iterative method could not converge");
        }while (error > _tolerance);
        return Y;
    }
    return sqrtm;
});

});

parcelRegister("50AXM", function(module, exports) {

$parcel$export(module.exports, "createSquare", function () { return $3a599ff7fed0da69$export$4ba960a63f731b0b; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");

var $6fCew = parcelRequire("6fCew");
var $3a599ff7fed0da69$var$name = "square";
var $3a599ff7fed0da69$var$dependencies = [
    "typed"
];
var $3a599ff7fed0da69$export$4ba960a63f731b0b = /* #__PURE__ */ (0, $2mPYl.factory)($3a599ff7fed0da69$var$name, $3a599ff7fed0da69$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Compute the square of a value, `x * x`.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.square(x)
   *
   * Examples:
   *
   *    math.square(2)           // returns number 4
   *    math.square(3)           // returns number 9
   *    math.pow(3, 2)           // returns number 9
   *    math.multiply(3, 3)      // returns number 9
   *
   *    math.square([1, 2, 3, 4])  // returns Array [1, 4, 9, 16]
   *
   * See also:
   *
   *    multiply, cube, sqrt, pow
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix | Unit} x
   *            Number for which to calculate the square
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix | Unit}
   *            Squared value
   */ var square = typed($3a599ff7fed0da69$var$name, {
        number: (0, $6fCew.squareNumber),
        Complex: function Complex(x) {
            return x.mul(x);
        },
        BigNumber: function BigNumber(x) {
            return x.times(x);
        },
        Fraction: function Fraction(x) {
            return x.mul(x);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since square(0) = 0
            return (0, $e04i1.deepMap)(x, square, true);
        },
        Unit: function Unit(x) {
            return x.pow(2);
        }
    });
    return square;
});

});

parcelRegister("2KWps", function(module, exports) {

$parcel$export(module.exports, "createSqueeze", function () { return $201d2f97f4ff940d$export$1a885844ffd505a4; });

var $7ITGG = parcelRequire("7ITGG");

var $5WdrK = parcelRequire("5WdrK");

var $2mPYl = parcelRequire("2mPYl");
var $201d2f97f4ff940d$var$name = "squeeze";
var $201d2f97f4ff940d$var$dependencies = [
    "typed",
    "matrix"
];
var $201d2f97f4ff940d$export$1a885844ffd505a4 = /* #__PURE__ */ (0, $2mPYl.factory)($201d2f97f4ff940d$var$name, $201d2f97f4ff940d$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix;
    /**
   * Squeeze a matrix, remove inner and outer singleton dimensions from a matrix.
   *
   * Syntax:
   *
   *     math.squeeze(x)
   *
   * Examples:
   *
   *     math.squeeze([3])           // returns 3
   *     math.squeeze([[3]])         // returns 3
   *
   *     const A = math.zeros(3, 1)    // returns [[0], [0], [0]] (size 3x1)
   *     math.squeeze(A)             // returns [0, 0, 0] (size 3)
   *
   *     const B = math.zeros(1, 3)    // returns [[0, 0, 0]] (size 1x3)
   *     math.squeeze(B)             // returns [0, 0, 0] (size 3)
   *
   *     // only inner and outer dimensions are removed
   *     const C = math.zeros(2, 1, 3) // returns [[[0, 0, 0]], [[0, 0, 0]]] (size 2x1x3)
   *     math.squeeze(C)             // returns [[[0, 0, 0]], [[0, 0, 0]]] (size 2x1x3)
   *
   * See also:
   *
   *     subset
   *
   * @param {Matrix | Array} x      Matrix to be squeezed
   * @return {Matrix | Array} Squeezed matrix
   */ return typed($201d2f97f4ff940d$var$name, {
        Array: function Array1(x) {
            return (0, $5WdrK.squeeze)((0, $7ITGG.clone)(x));
        },
        Matrix: function Matrix(x) {
            var res = (0, $5WdrK.squeeze)(x.toArray()); // FIXME: return the same type of matrix as the input
            return Array.isArray(res) ? matrix(res) : res;
        },
        any: function any(x) {
            // scalar
            return (0, $7ITGG.clone)(x);
        }
    });
});

});

parcelRegister("81hN6", function(module, exports) {

$parcel$export(module.exports, "createStirlingS2", function () { return $5d6c37a20521d0b1$export$18813d136a9b83d0; });

var $2mPYl = parcelRequire("2mPYl");
var $5d6c37a20521d0b1$var$name = "stirlingS2";
var $5d6c37a20521d0b1$var$dependencies = [
    "typed",
    "addScalar",
    "subtract",
    "multiplyScalar",
    "divideScalar",
    "pow",
    "factorial",
    "combinations",
    "isNegative",
    "isInteger",
    "larger"
];
var $5d6c37a20521d0b1$export$18813d136a9b83d0 = /* #__PURE__ */ (0, $2mPYl.factory)($5d6c37a20521d0b1$var$name, $5d6c37a20521d0b1$var$dependencies, function(_ref) {
    var typed = _ref.typed, addScalar = _ref.addScalar, subtract = _ref.subtract, multiplyScalar = _ref.multiplyScalar, divideScalar = _ref.divideScalar, pow = _ref.pow, factorial = _ref.factorial, combinations = _ref.combinations, isNegative = _ref.isNegative, isInteger = _ref.isInteger, larger = _ref.larger;
    /**
   * The Stirling numbers of the second kind, counts the number of ways to partition
   * a set of n labelled objects into k nonempty unlabelled subsets.
   * stirlingS2 only takes integer arguments.
   * The following condition must be enforced: k <= n.
   *
   *  If n = k or k = 1, then s(n,k) = 1
   *
   * Syntax:
   *
   *   math.stirlingS2(n, k)
   *
   * Examples:
   *
   *    math.stirlingS2(5, 3) //returns 25
   *
   * See also:
   *
   *    bellNumbers
   *
   * @param {Number | BigNumber} n    Total number of objects in the set
   * @param {Number | BigNumber} k    Number of objects in the subset
   * @return {Number | BigNumber}     S(n,k)
   */ return typed($5d6c37a20521d0b1$var$name, {
        "number | BigNumber, number | BigNumber": function numberBigNumberNumberBigNumber(n, k) {
            if (!isInteger(n) || isNegative(n) || !isInteger(k) || isNegative(k)) throw new TypeError("Non-negative integer value expected in function stirlingS2");
            else if (larger(k, n)) throw new TypeError("k must be less than or equal to n in function stirlingS2");
             // 1/k! Sum(i=0 -> k) [(-1)^(k-i)*C(k,j)* i^n]
            var kFactorial = factorial(k);
            var result = 0;
            for(var i = 0; i <= k; i++){
                var negativeOne = pow(-1, subtract(k, i));
                var kChooseI = combinations(k, i);
                var iPower = pow(i, n);
                result = addScalar(result, multiplyScalar(multiplyScalar(kChooseI, iPower), negativeOne));
            }
            return divideScalar(result, kFactorial);
        }
    });
});

});

parcelRegister("gPj2C", function(module, exports) {

$parcel$export(module.exports, "createString", function () { return $c4002dfa68fd84ac$export$b2cf5914f5f18823; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");

var $kFRKb = parcelRequire("kFRKb");
var $c4002dfa68fd84ac$var$name = "string";
var $c4002dfa68fd84ac$var$dependencies = [
    "typed"
];
var $c4002dfa68fd84ac$export$b2cf5914f5f18823 = /* #__PURE__ */ (0, $2mPYl.factory)($c4002dfa68fd84ac$var$name, $c4002dfa68fd84ac$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Create a string or convert any object into a string.
   * Elements of Arrays and Matrices are processed element wise.
   *
   * Syntax:
   *
   *    math.string(value)
   *
   * Examples:
   *
   *    math.string(4.2)               // returns string '4.2'
   *    math.string(math.complex(3, 2) // returns string '3 + 2i'
   *
   *    const u = math.unit(5, 'km')
   *    math.string(u.to('m'))         // returns string '5000 m'
   *
   *    math.string([true, false])     // returns ['true', 'false']
   *
   * See also:
   *
   *    bignumber, boolean, complex, index, matrix, number, unit
   *
   * @param {* | Array | Matrix | null} [value]  A value to convert to a string
   * @return {string | Array | Matrix} The created string
   */ var string = typed($c4002dfa68fd84ac$var$name, {
        "": function _() {
            return "";
        },
        number: (0, $kFRKb.format),
        "null": function _null(x) {
            return "null";
        },
        "boolean": function boolean(x) {
            return x + "";
        },
        string: function string(x) {
            return x;
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, string);
        },
        any: function any(x) {
            return String(x);
        }
    });
    return string;
});

});

parcelRegister("fFD0Y", function(module, exports) {

$parcel$export(module.exports, "createSubtract", function () { return $b688f2d8cb0e1a81$export$cd7a6c131b18ab16; });

var $2mPYl = parcelRequire("2mPYl");

var $hy7Bx = parcelRequire("hy7Bx");

var $gIOYU = parcelRequire("gIOYU");

var $jaKH8 = parcelRequire("jaKH8");

var $6XnjD = parcelRequire("6XnjD");

var $1rFP6 = parcelRequire("1rFP6");

var $1bBLS = parcelRequire("1bBLS");

var $iHnaT = parcelRequire("iHnaT");
var $b688f2d8cb0e1a81$var$name = "subtract";
var $b688f2d8cb0e1a81$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "addScalar",
    "unaryMinus",
    "DenseMatrix"
];
var $b688f2d8cb0e1a81$export$cd7a6c131b18ab16 = /* #__PURE__ */ (0, $2mPYl.factory)($b688f2d8cb0e1a81$var$name, $b688f2d8cb0e1a81$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, equalScalar = _ref.equalScalar, addScalar = _ref.addScalar, unaryMinus = _ref.unaryMinus, DenseMatrix = _ref.DenseMatrix;
    // TODO: split function subtract in two: subtract and subtractScalar
    var algorithm01 = (0, $gIOYU.createAlgorithm01)({
        typed: typed
    });
    var algorithm03 = (0, $jaKH8.createAlgorithm03)({
        typed: typed
    });
    var algorithm05 = (0, $6XnjD.createAlgorithm05)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm10 = (0, $1rFP6.createAlgorithm10)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $1bBLS.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $iHnaT.createAlgorithm14)({
        typed: typed
    });
    /**
   * Subtract two values, `x - y`.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.subtract(x, y)
   *
   * Examples:
   *
   *    math.subtract(5.3, 2)        // returns number 3.3
   *
   *    const a = math.complex(2, 3)
   *    const b = math.complex(4, 1)
   *    math.subtract(a, b)          // returns Complex -2 + 2i
   *
   *    math.subtract([5, 7, 4], 4)  // returns Array [1, 3, 0]
   *
   *    const c = math.unit('2.1 km')
   *    const d = math.unit('500m')
   *    math.subtract(c, d)          // returns Unit 1.6 km
   *
   * See also:
   *
   *    add
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x
   *            Initial value
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y
   *            Value to subtract from `x`
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}
   *            Subtraction of `x` and `y`
   */ var subtract = typed($b688f2d8cb0e1a81$var$name, {
        "number, number": function numberNumber(x, y) {
            return x - y;
        },
        "Complex, Complex": function ComplexComplex(x, y) {
            return x.sub(y);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.minus(y);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.sub(y);
        },
        "Unit, Unit": function UnitUnit(x, y) {
            if (x.value === null) throw new Error("Parameter x contains a unit with undefined value");
            if (y.value === null) throw new Error("Parameter y contains a unit with undefined value");
            if (!x.equalBase(y)) throw new Error("Units do not match");
            var res = x.clone();
            res.value = subtract(res.value, y.value);
            res.fixPrefix = false;
            return res;
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            $b688f2d8cb0e1a81$var$checkEqualDimensions(x, y);
            return algorithm05(x, y, subtract);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            $b688f2d8cb0e1a81$var$checkEqualDimensions(x, y);
            return algorithm03(y, x, subtract, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            $b688f2d8cb0e1a81$var$checkEqualDimensions(x, y);
            return algorithm01(x, y, subtract, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            $b688f2d8cb0e1a81$var$checkEqualDimensions(x, y);
            return algorithm13(x, y, subtract);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return subtract(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return subtract(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return subtract(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm10(x, unaryMinus(y), addScalar);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, subtract);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm10(y, x, subtract, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, subtract, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, subtract, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, subtract, true).valueOf();
        }
    });
    return subtract;
});
/**
 * Check whether matrix x and y have the same number of dimensions.
 * Throws a DimensionError when dimensions are not equal
 * @param {Matrix} x
 * @param {Matrix} y
 */ function $b688f2d8cb0e1a81$var$checkEqualDimensions(x, y) {
    var xsize = x.size();
    var ysize = y.size();
    if (xsize.length !== ysize.length) throw new (0, $hy7Bx.DimensionError)(xsize.length, ysize.length);
}

});

parcelRegister("4O9gL", function(module, exports) {

$parcel$export(module.exports, "createTan", function () { return $380305a9f7f04c4b$export$b61ad4f38fd9301d; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");
var $380305a9f7f04c4b$var$name = "tan";
var $380305a9f7f04c4b$var$dependencies = [
    "typed"
];
var $380305a9f7f04c4b$export$b61ad4f38fd9301d = /* #__PURE__ */ (0, $2mPYl.factory)($380305a9f7f04c4b$var$name, $380305a9f7f04c4b$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Calculate the tangent of a value. `tan(x)` is equal to `sin(x) / cos(x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.tan(x)
   *
   * Examples:
   *
   *    math.tan(0.5)                    // returns number 0.5463024898437905
   *    math.sin(0.5) / math.cos(0.5)    // returns number 0.5463024898437905
   *    math.tan(math.pi / 4)            // returns number 1
   *    math.tan(math.unit(45, 'deg'))   // returns number 1
   *
   * See also:
   *
   *    atan, sin, cos
   *
   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | BigNumber | Complex | Array | Matrix} Tangent of x
   */ var tan = typed($380305a9f7f04c4b$var$name, {
        number: Math.tan,
        Complex: function Complex(x) {
            return x.tan();
        },
        BigNumber: function BigNumber(x) {
            return x.tan();
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function tan is no angle");
            return tan(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since tan(0) = 0
            return (0, $e04i1.deepMap)(x, tan, true);
        }
    });
    return tan;
});

});

parcelRegister("fQa2o", function(module, exports) {

$parcel$export(module.exports, "createTanh", function () { return $b8837f9fedf7e90e$export$e1f66a5bda779194; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");

var $kFRKb = parcelRequire("kFRKb");
var $b8837f9fedf7e90e$var$name = "tanh";
var $b8837f9fedf7e90e$var$dependencies = [
    "typed"
];
var $b8837f9fedf7e90e$export$e1f66a5bda779194 = /* #__PURE__ */ (0, $2mPYl.factory)($b8837f9fedf7e90e$var$name, $b8837f9fedf7e90e$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Calculate the hyperbolic tangent of a value,
   * defined as `tanh(x) = (exp(2 * x) - 1) / (exp(2 * x) + 1)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.tanh(x)
   *
   * Examples:
   *
   *    // tanh(x) = sinh(x) / cosh(x) = 1 / coth(x)
   *    math.tanh(0.5)                   // returns 0.46211715726000974
   *    math.sinh(0.5) / math.cosh(0.5)  // returns 0.46211715726000974
   *    1 / math.coth(0.5)               // returns 0.46211715726000974
   *
   * See also:
   *
   *    sinh, cosh, coth
   *
   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | BigNumber | Complex | Array | Matrix} Hyperbolic tangent of x
   */ var tanh = typed("tanh", {
        number: (0, $kFRKb.tanh),
        Complex: function Complex(x) {
            return x.tanh();
        },
        BigNumber: function BigNumber(x) {
            return x.tanh();
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function tanh is no angle");
            return tanh(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since tanh(0) = 0
            return (0, $e04i1.deepMap)(x, tanh, true);
        }
    });
    return tanh;
});

});

parcelRegister("ezKv2", function(module, exports) {

$parcel$export(module.exports, "createTo", function () { return $a9c8676a3b9f1616$export$6e6c19ceb4cd6856; });

var $2mPYl = parcelRequire("2mPYl");

var $1bBLS = parcelRequire("1bBLS");

var $iHnaT = parcelRequire("iHnaT");
var $a9c8676a3b9f1616$var$name = "to";
var $a9c8676a3b9f1616$var$dependencies = [
    "typed",
    "matrix"
];
var $a9c8676a3b9f1616$export$6e6c19ceb4cd6856 = /* #__PURE__ */ (0, $2mPYl.factory)($a9c8676a3b9f1616$var$name, $a9c8676a3b9f1616$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix;
    var algorithm13 = (0, $1bBLS.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $iHnaT.createAlgorithm14)({
        typed: typed
    });
    /**
   * Change the unit of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.to(x, unit)
   *
   * Examples:
   *
   *    math.to(math.unit('2 inch'), 'cm')                   // returns Unit 5.08 cm
   *    math.to(math.unit('2 inch'), math.unit(null, 'cm'))  // returns Unit 5.08 cm
   *    math.to(math.unit(16, 'bytes'), 'bits')              // returns Unit 128 bits
   *
   * See also:
   *
   *    unit
   *
   * @param {Unit | Array | Matrix} x     The unit to be converted.
   * @param {Unit | Array | Matrix} unit  New unit. Can be a string like "cm"
   *                                      or a unit without value.
   * @return {Unit | Array | Matrix} value with changed, fixed unit.
   */ var to = typed($a9c8676a3b9f1616$var$name, {
        "Unit, Unit | string": function UnitUnitString(x, unit) {
            return x.to(unit);
        },
        "Matrix, Matrix": function MatrixMatrix(x, y) {
            // SparseMatrix does not support Units
            return algorithm13(x, y, to);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return to(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return to(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return to(x, matrix(y));
        },
        "Matrix, any": function MatrixAny(x, y) {
            // SparseMatrix does not support Units
            return algorithm14(x, y, to, false);
        },
        "any, Matrix": function anyMatrix(x, y) {
            // SparseMatrix does not support Units
            return algorithm14(y, x, to, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, to, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, to, true).valueOf();
        }
    });
    return to;
});

});

parcelRegister("7Cwki", function(module, exports) {

$parcel$export(module.exports, "createTrace", function () { return $58c528579d5d2e14$export$acff8254414be03b; });

var $7ITGG = parcelRequire("7ITGG");

var $6NxuJ = parcelRequire("6NxuJ");

var $2mPYl = parcelRequire("2mPYl");
var $58c528579d5d2e14$var$name = "trace";
var $58c528579d5d2e14$var$dependencies = [
    "typed",
    "matrix",
    "add"
];
var $58c528579d5d2e14$export$acff8254414be03b = /* #__PURE__ */ (0, $2mPYl.factory)($58c528579d5d2e14$var$name, $58c528579d5d2e14$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, add = _ref.add;
    /**
   * Calculate the trace of a matrix: the sum of the elements on the main
   * diagonal of a square matrix.
   *
   * Syntax:
   *
   *    math.trace(x)
   *
   * Examples:
   *
   *    math.trace([[1, 2], [3, 4]]) // returns 5
   *
   *    const A = [
   *      [1, 2, 3],
   *      [-1, 2, 3],
   *      [2, 0, 3]
   *    ]
   *    math.trace(A) // returns 6
   *
   * See also:
   *
   *    diag
   *
   * @param {Array | Matrix} x  A matrix
   *
   * @return {number} The trace of `x`
   */ return typed("trace", {
        Array: function _arrayTrace(x) {
            // use dense matrix implementation
            return _denseTrace(matrix(x));
        },
        SparseMatrix: _sparseTrace,
        DenseMatrix: _denseTrace,
        any: (0, $7ITGG.clone)
    });
    function _denseTrace(m) {
        // matrix size & data
        var size = m._size;
        var data = m._data; // process dimensions
        switch(size.length){
            case 1:
                // vector
                if (size[0] === 1) // return data[0]
                return (0, $7ITGG.clone)(data[0]);
                throw new RangeError("Matrix must be square (size: " + (0, $6NxuJ.format)(size) + ")");
            case 2:
                // two dimensional
                var rows = size[0];
                var cols = size[1];
                if (rows === cols) {
                    // calulate sum
                    var sum = 0; // loop diagonal
                    for(var i = 0; i < rows; i++)sum = add(sum, data[i][i]);
                     // return trace
                    return sum;
                } else throw new RangeError("Matrix must be square (size: " + (0, $6NxuJ.format)(size) + ")");
            default:
                // multi dimensional
                throw new RangeError("Matrix must be two dimensional (size: " + (0, $6NxuJ.format)(size) + ")");
        }
    }
    function _sparseTrace(m) {
        // matrix arrays
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr;
        var size = m._size; // check dimensions
        var rows = size[0];
        var columns = size[1]; // matrix must be square
        if (rows === columns) {
            // calulate sum
            var sum = 0; // check we have data (avoid looping columns)
            if (values.length > 0) // loop columns
            for(var j = 0; j < columns; j++){
                // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
                var k0 = ptr[j];
                var k1 = ptr[j + 1]; // loop k within [k0, k1[
                for(var k = k0; k < k1; k++){
                    // row index
                    var i = index[k]; // check row
                    if (i === j) {
                        // accumulate value
                        sum = add(sum, values[k]); // exit loop
                        break;
                    }
                    if (i > j) break;
                }
            }
             // return trace
            return sum;
        }
        throw new RangeError("Matrix must be square (size: " + (0, $6NxuJ.format)(size) + ")");
    }
});

});

parcelRegister("cIf9i", function(module, exports) {

$parcel$export(module.exports, "createTranspose", function () { return $941558605b8f78c5$export$9a8c88485f8f638b; });

var $7ITGG = parcelRequire("7ITGG");

var $6NxuJ = parcelRequire("6NxuJ");

var $2mPYl = parcelRequire("2mPYl");
var $941558605b8f78c5$var$name = "transpose";
var $941558605b8f78c5$var$dependencies = [
    "typed",
    "matrix"
];
var $941558605b8f78c5$export$9a8c88485f8f638b = /* #__PURE__ */ (0, $2mPYl.factory)($941558605b8f78c5$var$name, $941558605b8f78c5$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix;
    /**
   * Transpose a matrix. All values of the matrix are reflected over its
   * main diagonal. Only applicable to two dimensional matrices containing
   * a vector (i.e. having size `[1,n]` or `[n,1]`). One dimensional
   * vectors and scalars return the input unchanged.
   *
   * Syntax:
   *
   *     math.transpose(x)
   *
   * Examples:
   *
   *     const A = [[1, 2, 3], [4, 5, 6]]
   *     math.transpose(A)               // returns [[1, 4], [2, 5], [3, 6]]
   *
   * See also:
   *
   *     diag, inv, subset, squeeze
   *
   * @param {Array | Matrix} x  Matrix to be transposed
   * @return {Array | Matrix}   The transposed matrix
   */ var transpose = typed("transpose", {
        Array: function Array(x) {
            // use dense matrix implementation
            return transpose(matrix(x)).valueOf();
        },
        Matrix: function Matrix(x) {
            // matrix size
            var size = x.size(); // result
            var c; // process dimensions
            switch(size.length){
                case 1:
                    // vector
                    c = x.clone();
                    break;
                case 2:
                    // rows and columns
                    var rows = size[0];
                    var columns = size[1]; // check columns
                    if (columns === 0) // throw exception
                    throw new RangeError("Cannot transpose a 2D matrix with no columns (size: " + (0, $6NxuJ.format)(size) + ")");
                     // process storage format
                    switch(x.storage()){
                        case "dense":
                            c = _denseTranspose(x, rows, columns);
                            break;
                        case "sparse":
                            c = _sparseTranspose(x, rows, columns);
                            break;
                    }
                    break;
                default:
                    // multi dimensional
                    throw new RangeError("Matrix must be a vector or two dimensional (size: " + (0, $6NxuJ.format)(this._size) + ")");
            }
            return c;
        },
        // scalars
        any: function any(x) {
            return (0, $7ITGG.clone)(x);
        }
    });
    function _denseTranspose(m, rows, columns) {
        // matrix array
        var data = m._data; // transposed matrix data
        var transposed = [];
        var transposedRow; // loop columns
        for(var j = 0; j < columns; j++){
            // initialize row
            transposedRow = transposed[j] = []; // loop rows
            for(var i = 0; i < rows; i++)// set data
            transposedRow[i] = (0, $7ITGG.clone)(data[i][j]);
        } // return matrix
        return m.createDenseMatrix({
            data: transposed,
            size: [
                columns,
                rows
            ],
            datatype: m._datatype
        });
    }
    function _sparseTranspose(m, rows, columns) {
        // matrix arrays
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr; // result matrices
        var cvalues = values ? [] : undefined;
        var cindex = [];
        var cptr = []; // row counts
        var w = [];
        for(var x = 0; x < rows; x++)w[x] = 0;
         // vars
        var p, l, j; // loop values in matrix
        for(p = 0, l = index.length; p < l; p++)// number of values in row
        w[index[p]]++;
         // cumulative sum
        var sum = 0; // initialize cptr with the cummulative sum of row counts
        for(var i = 0; i < rows; i++){
            // update cptr
            cptr.push(sum); // update sum
            sum += w[i]; // update w
            w[i] = cptr[i];
        } // update cptr
        cptr.push(sum); // loop columns
        for(j = 0; j < columns; j++)// values & index in column
        for(var k0 = ptr[j], k1 = ptr[j + 1], k = k0; k < k1; k++){
            // C values & index
            var q = w[index[k]]++; // C[j, i] = A[i, j]
            cindex[q] = j; // check we need to process values (pattern matrix)
            if (values) cvalues[q] = (0, $7ITGG.clone)(values[k]);
        }
         // return matrix
        return m.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                columns,
                rows
            ],
            datatype: m._datatype
        });
    }
    return transpose;
});

});

parcelRegister("4nRyY", function(module, exports) {

$parcel$export(module.exports, "createTyped", function () { return $3312dbe96a52fe31$export$8597b5d47504f989; });
/**
 * Create a typed-function which checks the types of the arguments and
 * can match them against multiple provided signatures. The typed-function
 * automatically converts inputs in order to find a matching signature.
 * Typed functions throw informative errors in case of wrong input arguments.
 *
 * See the library [typed-function](https://github.com/josdejong/typed-function)
 * for detailed documentation.
 *
 * Syntax:
 *
 *     math.typed(name, signatures) : function
 *     math.typed(signatures) : function
 *
 * Examples:
 *
 *     // create a typed function with multiple types per argument (type union)
 *     const fn2 = typed({
 *       'number | boolean': function (b) {
 *         return 'b is a number or boolean'
 *       },
 *       'string, number | boolean': function (a, b) {
 *         return 'a is a string, b is a number or boolean'
 *       }
 *     })
 *
 *     // create a typed function with an any type argument
 *     const log = typed({
 *       'string, any': function (event, data) {
 *         console.log('event: ' + event + ', data: ' + JSON.stringify(data))
 *       }
 *     })
 *
 * @param {string} [name]                          Optional name for the typed-function
 * @param {Object<string, function>} signatures   Object with one or multiple function signatures
 * @returns {function} The created typed-function.
 */ 
var $1amHZ = parcelRequire("1amHZ");

var $1tdRV = parcelRequire("1tdRV");

var $kFRKb = parcelRequire("kFRKb");

var $2mPYl = parcelRequire("2mPYl");
var $3312dbe96a52fe31$var$_createTyped2 = function _createTyped() {
    // initially, return the original instance of typed-function
    // consecutively, return a new instance from typed.create.
    $3312dbe96a52fe31$var$_createTyped2 = (0, (/*@__PURE__*/$parcel$interopDefault($1tdRV))).create;
    return 0, (/*@__PURE__*/$parcel$interopDefault($1tdRV));
};
var $3312dbe96a52fe31$var$dependencies = [
    "?BigNumber",
    "?Complex",
    "?DenseMatrix",
    "?Fraction"
];
var $3312dbe96a52fe31$export$8597b5d47504f989 = /* #__PURE__ */ (0, $2mPYl.factory)("typed", $3312dbe96a52fe31$var$dependencies, function createTyped(_ref) {
    var BigNumber = _ref.BigNumber, Complex = _ref.Complex, DenseMatrix = _ref.DenseMatrix, Fraction = _ref.Fraction;
    // TODO: typed-function must be able to silently ignore signatures with unknown data types
    // get a new instance of typed-function
    var typed = $3312dbe96a52fe31$var$_createTyped2(); // define all types. The order of the types determines in which order function
    // arguments are type-checked (so for performance it's important to put the
    // most used types first).
    typed.types = [
        {
            name: "number",
            test: (0, $1amHZ.isNumber)
        },
        {
            name: "Complex",
            test: (0, $1amHZ.isComplex)
        },
        {
            name: "BigNumber",
            test: (0, $1amHZ.isBigNumber)
        },
        {
            name: "Fraction",
            test: (0, $1amHZ.isFraction)
        },
        {
            name: "Unit",
            test: (0, $1amHZ.isUnit)
        },
        {
            name: "string",
            test: (0, $1amHZ.isString)
        },
        {
            name: "Chain",
            test: (0, $1amHZ.isChain)
        },
        {
            name: "Array",
            test: (0, $1amHZ.isArray)
        },
        {
            name: "Matrix",
            test: (0, $1amHZ.isMatrix)
        },
        {
            name: "DenseMatrix",
            test: (0, $1amHZ.isDenseMatrix)
        },
        {
            name: "SparseMatrix",
            test: (0, $1amHZ.isSparseMatrix)
        },
        {
            name: "Range",
            test: (0, $1amHZ.isRange)
        },
        {
            name: "Index",
            test: (0, $1amHZ.isIndex)
        },
        {
            name: "boolean",
            test: (0, $1amHZ.isBoolean)
        },
        {
            name: "ResultSet",
            test: (0, $1amHZ.isResultSet)
        },
        {
            name: "Help",
            test: (0, $1amHZ.isHelp)
        },
        {
            name: "function",
            test: (0, $1amHZ.isFunction)
        },
        {
            name: "Date",
            test: (0, $1amHZ.isDate)
        },
        {
            name: "RegExp",
            test: (0, $1amHZ.isRegExp)
        },
        {
            name: "null",
            test: (0, $1amHZ.isNull)
        },
        {
            name: "undefined",
            test: (0, $1amHZ.isUndefined)
        },
        {
            name: "AccessorNode",
            test: (0, $1amHZ.isAccessorNode)
        },
        {
            name: "ArrayNode",
            test: (0, $1amHZ.isArrayNode)
        },
        {
            name: "AssignmentNode",
            test: (0, $1amHZ.isAssignmentNode)
        },
        {
            name: "BlockNode",
            test: (0, $1amHZ.isBlockNode)
        },
        {
            name: "ConditionalNode",
            test: (0, $1amHZ.isConditionalNode)
        },
        {
            name: "ConstantNode",
            test: (0, $1amHZ.isConstantNode)
        },
        {
            name: "FunctionNode",
            test: (0, $1amHZ.isFunctionNode)
        },
        {
            name: "FunctionAssignmentNode",
            test: (0, $1amHZ.isFunctionAssignmentNode)
        },
        {
            name: "IndexNode",
            test: (0, $1amHZ.isIndexNode)
        },
        {
            name: "Node",
            test: (0, $1amHZ.isNode)
        },
        {
            name: "ObjectNode",
            test: (0, $1amHZ.isObjectNode)
        },
        {
            name: "OperatorNode",
            test: (0, $1amHZ.isOperatorNode)
        },
        {
            name: "ParenthesisNode",
            test: (0, $1amHZ.isParenthesisNode)
        },
        {
            name: "RangeNode",
            test: (0, $1amHZ.isRangeNode)
        },
        {
            name: "SymbolNode",
            test: (0, $1amHZ.isSymbolNode)
        },
        {
            name: "Object",
            test: (0, $1amHZ.isObject)
        } // order 'Object' last, it matches on other classes too
    ];
    typed.conversions = [
        {
            from: "number",
            to: "BigNumber",
            convert: function convert(x) {
                if (!BigNumber) $3312dbe96a52fe31$var$throwNoBignumber(x);
                 // note: conversion from number to BigNumber can fail if x has >15 digits
                if ((0, $kFRKb.digits)(x) > 15) throw new TypeError("Cannot implicitly convert a number with >15 significant digits to BigNumber (value: " + x + "). " + "Use function bignumber(x) to convert to BigNumber.");
                return new BigNumber(x);
            }
        },
        {
            from: "number",
            to: "Complex",
            convert: function convert(x) {
                if (!Complex) $3312dbe96a52fe31$var$throwNoComplex(x);
                return new Complex(x, 0);
            }
        },
        {
            from: "number",
            to: "string",
            convert: function convert(x) {
                return x + "";
            }
        },
        {
            from: "BigNumber",
            to: "Complex",
            convert: function convert(x) {
                if (!Complex) $3312dbe96a52fe31$var$throwNoComplex(x);
                return new Complex(x.toNumber(), 0);
            }
        },
        {
            from: "Fraction",
            to: "BigNumber",
            convert: function convert(x) {
                throw new TypeError("Cannot implicitly convert a Fraction to BigNumber or vice versa. Use function bignumber(x) to convert to BigNumber or fraction(x) to convert to Fraction.");
            }
        },
        {
            from: "Fraction",
            to: "Complex",
            convert: function convert(x) {
                if (!Complex) $3312dbe96a52fe31$var$throwNoComplex(x);
                return new Complex(x.valueOf(), 0);
            }
        },
        {
            from: "number",
            to: "Fraction",
            convert: function convert(x) {
                if (!Fraction) $3312dbe96a52fe31$var$throwNoFraction(x);
                var f = new Fraction(x);
                if (f.valueOf() !== x) throw new TypeError("Cannot implicitly convert a number to a Fraction when there will be a loss of precision (value: " + x + "). " + "Use function fraction(x) to convert to Fraction.");
                return f;
            }
        },
        {
            // FIXME: add conversion from Fraction to number, for example for `sqrt(fraction(1,3))`
            //  from: 'Fraction',
            //  to: 'number',
            //  convert: function (x) {
            //    return x.valueOf()
            //  }
            // }, {
            from: "string",
            to: "number",
            convert: function convert(x) {
                var n = Number(x);
                if (isNaN(n)) throw new Error('Cannot convert "' + x + '" to a number');
                return n;
            }
        },
        {
            from: "string",
            to: "BigNumber",
            convert: function convert(x) {
                if (!BigNumber) $3312dbe96a52fe31$var$throwNoBignumber(x);
                try {
                    return new BigNumber(x);
                } catch (err) {
                    throw new Error('Cannot convert "' + x + '" to BigNumber');
                }
            }
        },
        {
            from: "string",
            to: "Fraction",
            convert: function convert(x) {
                if (!Fraction) $3312dbe96a52fe31$var$throwNoFraction(x);
                try {
                    return new Fraction(x);
                } catch (err) {
                    throw new Error('Cannot convert "' + x + '" to Fraction');
                }
            }
        },
        {
            from: "string",
            to: "Complex",
            convert: function convert(x) {
                if (!Complex) $3312dbe96a52fe31$var$throwNoComplex(x);
                try {
                    return new Complex(x);
                } catch (err) {
                    throw new Error('Cannot convert "' + x + '" to Complex');
                }
            }
        },
        {
            from: "boolean",
            to: "number",
            convert: function convert(x) {
                return +x;
            }
        },
        {
            from: "boolean",
            to: "BigNumber",
            convert: function convert(x) {
                if (!BigNumber) $3312dbe96a52fe31$var$throwNoBignumber(x);
                return new BigNumber(+x);
            }
        },
        {
            from: "boolean",
            to: "Fraction",
            convert: function convert(x) {
                if (!Fraction) $3312dbe96a52fe31$var$throwNoFraction(x);
                return new Fraction(+x);
            }
        },
        {
            from: "boolean",
            to: "string",
            convert: function convert(x) {
                return String(x);
            }
        },
        {
            from: "Array",
            to: "Matrix",
            convert: function convert(array) {
                if (!DenseMatrix) $3312dbe96a52fe31$var$throwNoMatrix();
                return new DenseMatrix(array);
            }
        },
        {
            from: "Matrix",
            to: "Array",
            convert: function convert(matrix) {
                return matrix.valueOf();
            }
        }
    ];
    return typed;
});
function $3312dbe96a52fe31$var$throwNoBignumber(x) {
    throw new Error("Cannot convert value ".concat(x, " into a BigNumber: no class 'BigNumber' provided"));
}
function $3312dbe96a52fe31$var$throwNoComplex(x) {
    throw new Error("Cannot convert value ".concat(x, " into a Complex number: no class 'Complex' provided"));
}
function $3312dbe96a52fe31$var$throwNoMatrix() {
    throw new Error("Cannot convert array into a Matrix: no class 'DenseMatrix' provided");
}
function $3312dbe96a52fe31$var$throwNoFraction(x) {
    throw new Error("Cannot convert value ".concat(x, " into a Fraction, no class 'Fraction' provided."));
}

});
parcelRegister("1tdRV", function(module, exports) {
/**
 * typed-function
 *
 * Type checking for JavaScript functions
 *
 * https://github.com/josdejong/typed-function
 */ "use strict";
(function(root, factory) {
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([], factory);
    else // OldNode. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like OldNode.
    module.exports = factory();
})(module.exports, function() {
    function ok() {
        return true;
    }
    function notOk() {
        return false;
    }
    function undef() {
        return undefined;
    }
    /**
   * @typedef {{
   *   params: Param[],
   *   fn: function
   * }} Signature
   *
   * @typedef {{
   *   types: Type[],
   *   restParam: boolean
   * }} Param
   *
   * @typedef {{
   *   name: string,
   *   typeIndex: number,
   *   test: function,
   *   conversion?: ConversionDef,
   *   conversionIndex: number,
   * }} Type
   *
   * @typedef {{
   *   from: string,
   *   to: string,
   *   convert: function (*) : *
   * }} ConversionDef
   *
   * @typedef {{
   *   name: string,
   *   test: function(*) : boolean
   * }} TypeDef
   */ // create a new instance of typed-function
    function create() {
        // data type tests
        var _types = [
            {
                name: "number",
                test: function(x) {
                    return typeof x === "number";
                }
            },
            {
                name: "string",
                test: function(x) {
                    return typeof x === "string";
                }
            },
            {
                name: "boolean",
                test: function(x) {
                    return typeof x === "boolean";
                }
            },
            {
                name: "Function",
                test: function(x) {
                    return typeof x === "function";
                }
            },
            {
                name: "Array",
                test: Array.isArray
            },
            {
                name: "Date",
                test: function(x) {
                    return x instanceof Date;
                }
            },
            {
                name: "RegExp",
                test: function(x) {
                    return x instanceof RegExp;
                }
            },
            {
                name: "Object",
                test: function(x) {
                    return typeof x === "object" && x !== null && x.constructor === Object;
                }
            },
            {
                name: "null",
                test: function(x) {
                    return x === null;
                }
            },
            {
                name: "undefined",
                test: function(x) {
                    return x === undefined;
                }
            }
        ];
        var anyType = {
            name: "any",
            test: ok
        };
        // types which need to be ignored
        var _ignore = [];
        // type conversions
        var _conversions = [];
        // This is a temporary object, will be replaced with a typed function at the end
        var typed = {
            types: _types,
            conversions: _conversions,
            ignore: _ignore
        };
        /**
     * Find the test function for a type
     * @param {String} typeName
     * @return {TypeDef} Returns the type definition when found,
     *                    Throws a TypeError otherwise
     */ function findTypeByName(typeName) {
            var entry = findInArray(typed.types, function(entry) {
                return entry.name === typeName;
            });
            if (entry) return entry;
            if (typeName === "any") return anyType;
            var hint = findInArray(typed.types, function(entry) {
                return entry.name.toLowerCase() === typeName.toLowerCase();
            });
            throw new TypeError('Unknown type "' + typeName + '"' + (hint ? '. Did you mean "' + hint.name + '"?' : ""));
        }
        /**
     * Find the index of a type definition. Handles special case 'any'
     * @param {TypeDef} type
     * @return {number}
     */ function findTypeIndex(type) {
            if (type === anyType) return 999;
            return typed.types.indexOf(type);
        }
        /**
     * Find a type that matches a value.
     * @param {*} value
     * @return {string} Returns the name of the first type for which
     *                  the type test matches the value.
     */ function findTypeName(value) {
            var entry = findInArray(typed.types, function(entry) {
                return entry.test(value);
            });
            if (entry) return entry.name;
            throw new TypeError("Value has unknown type. Value: " + value);
        }
        /**
     * Find a specific signature from a (composed) typed function, for example:
     *
     *   typed.find(fn, ['number', 'string'])
     *   typed.find(fn, 'number, string')
     *
     * Function find only only works for exact matches.
     *
     * @param {Function} fn                   A typed-function
     * @param {string | string[]} signature   Signature to be found, can be
     *                                        an array or a comma separated string.
     * @return {Function}                     Returns the matching signature, or
     *                                        throws an error when no signature
     *                                        is found.
     */ function find(fn, signature) {
            if (!fn.signatures) throw new TypeError("Function is no typed-function");
            // normalize input
            var arr;
            if (typeof signature === "string") {
                arr = signature.split(",");
                for(var i = 0; i < arr.length; i++)arr[i] = arr[i].trim();
            } else if (Array.isArray(signature)) arr = signature;
            else throw new TypeError("String array or a comma separated string expected");
            var str = arr.join(",");
            // find an exact match
            var match = fn.signatures[str];
            if (match) return match;
            // TODO: extend find to match non-exact signatures
            throw new TypeError("Signature not found (signature: " + (fn.name || "unnamed") + "(" + arr.join(", ") + "))");
        }
        /**
     * Convert a given value to another data type.
     * @param {*} value
     * @param {string} type
     */ function convert(value, type) {
            var from = findTypeName(value);
            // check conversion is needed
            if (type === from) return value;
            for(var i = 0; i < typed.conversions.length; i++){
                var conversion = typed.conversions[i];
                if (conversion.from === from && conversion.to === type) return conversion.convert(value);
            }
            throw new Error("Cannot convert from " + from + " to " + type);
        }
        /**
     * Stringify parameters in a normalized way
     * @param {Param[]} params
     * @return {string}
     */ function stringifyParams(params) {
            return params.map(function(param) {
                var typeNames = param.types.map(getTypeName);
                return (param.restParam ? "..." : "") + typeNames.join("|");
            }).join(",");
        }
        /**
     * Parse a parameter, like "...number | boolean"
     * @param {string} param
     * @param {ConversionDef[]} conversions
     * @return {Param} param
     */ function parseParam(param, conversions) {
            var restParam = param.indexOf("...") === 0;
            var types = !restParam ? param : param.length > 3 ? param.slice(3) : "any";
            var typeNames = types.split("|").map(trim).filter(notEmpty).filter(notIgnore);
            var matchingConversions = filterConversions(conversions, typeNames);
            var exactTypes = typeNames.map(function(typeName) {
                var type = findTypeByName(typeName);
                return {
                    name: typeName,
                    typeIndex: findTypeIndex(type),
                    test: type.test,
                    conversion: null,
                    conversionIndex: -1
                };
            });
            var convertibleTypes = matchingConversions.map(function(conversion) {
                var type = findTypeByName(conversion.from);
                return {
                    name: conversion.from,
                    typeIndex: findTypeIndex(type),
                    test: type.test,
                    conversion: conversion,
                    conversionIndex: conversions.indexOf(conversion)
                };
            });
            return {
                types: exactTypes.concat(convertibleTypes),
                restParam: restParam
            };
        }
        /**
     * Parse a signature with comma separated parameters,
     * like "number | boolean, ...string"
     * @param {string} signature
     * @param {function} fn
     * @param {ConversionDef[]} conversions
     * @return {Signature | null} signature
     */ function parseSignature(signature, fn, conversions) {
            var params = [];
            if (signature.trim() !== "") params = signature.split(",").map(trim).map(function(param, index, array) {
                var parsedParam = parseParam(param, conversions);
                if (parsedParam.restParam && index !== array.length - 1) throw new SyntaxError('Unexpected rest parameter "' + param + '": ' + "only allowed for the last parameter");
                return parsedParam;
            });
            if (params.some(isInvalidParam)) // invalid signature: at least one parameter has no types
            // (they may have been filtered)
            return null;
            return {
                params: params,
                fn: fn
            };
        }
        /**
     * Test whether a set of params contains a restParam
     * @param {Param[]} params
     * @return {boolean} Returns true when the last parameter is a restParam
     */ function hasRestParam(params) {
            var param = last(params);
            return param ? param.restParam : false;
        }
        /**
     * Test whether a parameter contains conversions
     * @param {Param} param
     * @return {boolean} Returns true when at least one of the parameters
     *                   contains a conversion.
     */ function hasConversions(param) {
            return param.types.some(function(type) {
                return type.conversion != null;
            });
        }
        /**
     * Create a type test for a single parameter, which can have one or multiple
     * types.
     * @param {Param} param
     * @return {function(x: *) : boolean} Returns a test function
     */ function compileTest(param) {
            if (!param || param.types.length === 0) // nothing to do
            return ok;
            else if (param.types.length === 1) return findTypeByName(param.types[0].name).test;
            else if (param.types.length === 2) {
                var test0 = findTypeByName(param.types[0].name).test;
                var test1 = findTypeByName(param.types[1].name).test;
                return function or(x) {
                    return test0(x) || test1(x);
                };
            } else {
                var tests = param.types.map(function(type) {
                    return findTypeByName(type.name).test;
                });
                return function or(x) {
                    for(var i = 0; i < tests.length; i++){
                        if (tests[i](x)) return true;
                    }
                    return false;
                };
            }
        }
        /**
     * Create a test for all parameters of a signature
     * @param {Param[]} params
     * @return {function(args: Array<*>) : boolean}
     */ function compileTests(params) {
            var tests, test0, test1;
            if (hasRestParam(params)) {
                // variable arguments like '...number'
                tests = initial(params).map(compileTest);
                var varIndex = tests.length;
                var lastTest = compileTest(last(params));
                var testRestParam = function(args) {
                    for(var i = varIndex; i < args.length; i++){
                        if (!lastTest(args[i])) return false;
                    }
                    return true;
                };
                return function testArgs(args) {
                    for(var i = 0; i < tests.length; i++){
                        if (!tests[i](args[i])) return false;
                    }
                    return testRestParam(args) && args.length >= varIndex + 1;
                };
            } else {
                // no variable arguments
                if (params.length === 0) return function testArgs(args) {
                    return args.length === 0;
                };
                else if (params.length === 1) {
                    test0 = compileTest(params[0]);
                    return function testArgs(args) {
                        return test0(args[0]) && args.length === 1;
                    };
                } else if (params.length === 2) {
                    test0 = compileTest(params[0]);
                    test1 = compileTest(params[1]);
                    return function testArgs(args) {
                        return test0(args[0]) && test1(args[1]) && args.length === 2;
                    };
                } else {
                    tests = params.map(compileTest);
                    return function testArgs(args) {
                        for(var i = 0; i < tests.length; i++){
                            if (!tests[i](args[i])) return false;
                        }
                        return args.length === tests.length;
                    };
                }
            }
        }
        /**
     * Find the parameter at a specific index of a signature.
     * Handles rest parameters.
     * @param {Signature} signature
     * @param {number} index
     * @return {Param | null} Returns the matching parameter when found,
     *                        null otherwise.
     */ function getParamAtIndex(signature, index) {
            return index < signature.params.length ? signature.params[index] : hasRestParam(signature.params) ? last(signature.params) : null;
        }
        /**
     * Get all type names of a parameter
     * @param {Signature} signature
     * @param {number} index
     * @param {boolean} excludeConversions
     * @return {string[]} Returns an array with type names
     */ function getExpectedTypeNames(signature, index, excludeConversions) {
            var param = getParamAtIndex(signature, index);
            var types = param ? excludeConversions ? param.types.filter(isExactType) : param.types : [];
            return types.map(getTypeName);
        }
        /**
     * Returns the name of a type
     * @param {Type} type
     * @return {string} Returns the type name
     */ function getTypeName(type) {
            return type.name;
        }
        /**
     * Test whether a type is an exact type or conversion
     * @param {Type} type
     * @return {boolean} Returns true when
     */ function isExactType(type) {
            return type.conversion === null || type.conversion === undefined;
        }
        /**
     * Helper function for creating error messages: create an array with
     * all available types on a specific argument index.
     * @param {Signature[]} signatures
     * @param {number} index
     * @return {string[]} Returns an array with available types
     */ function mergeExpectedParams(signatures, index) {
            var typeNames = uniq(flatMap(signatures, function(signature) {
                return getExpectedTypeNames(signature, index, false);
            }));
            return typeNames.indexOf("any") !== -1 ? [
                "any"
            ] : typeNames;
        }
        /**
     * Create
     * @param {string} name             The name of the function
     * @param {array.<*>} args          The actual arguments passed to the function
     * @param {Signature[]} signatures  A list with available signatures
     * @return {TypeError} Returns a type error with additional data
     *                     attached to it in the property `data`
     */ function createError(name, args, signatures) {
            var err, expected;
            var _name = name || "unnamed";
            // test for wrong type at some index
            var matchingSignatures = signatures;
            var index;
            for(index = 0; index < args.length; index++){
                var nextMatchingDefs = matchingSignatures.filter(function(signature) {
                    var test = compileTest(getParamAtIndex(signature, index));
                    return (index < signature.params.length || hasRestParam(signature.params)) && test(args[index]);
                });
                if (nextMatchingDefs.length === 0) {
                    // no matching signatures anymore, throw error "wrong type"
                    expected = mergeExpectedParams(matchingSignatures, index);
                    if (expected.length > 0) {
                        var actualType = findTypeName(args[index]);
                        err = new TypeError("Unexpected type of argument in function " + _name + " (expected: " + expected.join(" or ") + ", actual: " + actualType + ", index: " + index + ")");
                        err.data = {
                            category: "wrongType",
                            fn: _name,
                            index: index,
                            actual: actualType,
                            expected: expected
                        };
                        return err;
                    }
                } else matchingSignatures = nextMatchingDefs;
            }
            // test for too few arguments
            var lengths = matchingSignatures.map(function(signature) {
                return hasRestParam(signature.params) ? Infinity : signature.params.length;
            });
            if (args.length < Math.min.apply(null, lengths)) {
                expected = mergeExpectedParams(matchingSignatures, index);
                err = new TypeError("Too few arguments in function " + _name + " (expected: " + expected.join(" or ") + ", index: " + args.length + ")");
                err.data = {
                    category: "tooFewArgs",
                    fn: _name,
                    index: args.length,
                    expected: expected
                };
                return err;
            }
            // test for too many arguments
            var maxLength = Math.max.apply(null, lengths);
            if (args.length > maxLength) {
                err = new TypeError("Too many arguments in function " + _name + " (expected: " + maxLength + ", actual: " + args.length + ")");
                err.data = {
                    category: "tooManyArgs",
                    fn: _name,
                    index: args.length,
                    expectedLength: maxLength
                };
                return err;
            }
            err = new TypeError('Arguments of type "' + args.join(", ") + '" do not match any of the defined signatures of function ' + _name + ".");
            err.data = {
                category: "mismatch",
                actual: args.map(findTypeName)
            };
            return err;
        }
        /**
     * Find the lowest index of all exact types of a parameter (no conversions)
     * @param {Param} param
     * @return {number} Returns the index of the lowest type in typed.types
     */ function getLowestTypeIndex(param) {
            var min = 999;
            for(var i = 0; i < param.types.length; i++)if (isExactType(param.types[i])) min = Math.min(min, param.types[i].typeIndex);
            return min;
        }
        /**
     * Find the lowest index of the conversion of all types of the parameter
     * having a conversion
     * @param {Param} param
     * @return {number} Returns the lowest index of the conversions of this type
     */ function getLowestConversionIndex(param) {
            var min = 999;
            for(var i = 0; i < param.types.length; i++)if (!isExactType(param.types[i])) min = Math.min(min, param.types[i].conversionIndex);
            return min;
        }
        /**
     * Compare two params
     * @param {Param} param1
     * @param {Param} param2
     * @return {number} returns a negative number when param1 must get a lower
     *                  index than param2, a positive number when the opposite,
     *                  or zero when both are equal
     */ function compareParams(param1, param2) {
            var c;
            // compare having a rest parameter or not
            c = param1.restParam - param2.restParam;
            if (c !== 0) return c;
            // compare having conversions or not
            c = hasConversions(param1) - hasConversions(param2);
            if (c !== 0) return c;
            // compare the index of the types
            c = getLowestTypeIndex(param1) - getLowestTypeIndex(param2);
            if (c !== 0) return c;
            // compare the index of any conversion
            return getLowestConversionIndex(param1) - getLowestConversionIndex(param2);
        }
        /**
     * Compare two signatures
     * @param {Signature} signature1
     * @param {Signature} signature2
     * @return {number} returns a negative number when param1 must get a lower
     *                  index than param2, a positive number when the opposite,
     *                  or zero when both are equal
     */ function compareSignatures(signature1, signature2) {
            var len = Math.min(signature1.params.length, signature2.params.length);
            var i;
            var c;
            // compare whether the params have conversions at all or not
            c = signature1.params.some(hasConversions) - signature2.params.some(hasConversions);
            if (c !== 0) return c;
            // next compare whether the params have conversions one by one
            for(i = 0; i < len; i++){
                c = hasConversions(signature1.params[i]) - hasConversions(signature2.params[i]);
                if (c !== 0) return c;
            }
            // compare the types of the params one by one
            for(i = 0; i < len; i++){
                c = compareParams(signature1.params[i], signature2.params[i]);
                if (c !== 0) return c;
            }
            // compare the number of params
            return signature1.params.length - signature2.params.length;
        }
        /**
     * Get params containing all types that can be converted to the defined types.
     *
     * @param {ConversionDef[]} conversions
     * @param {string[]} typeNames
     * @return {ConversionDef[]} Returns the conversions that are available
     *                        for every type (if any)
     */ function filterConversions(conversions, typeNames) {
            var matches = {};
            conversions.forEach(function(conversion) {
                if (typeNames.indexOf(conversion.from) === -1 && typeNames.indexOf(conversion.to) !== -1 && !matches[conversion.from]) matches[conversion.from] = conversion;
            });
            return Object.keys(matches).map(function(from) {
                return matches[from];
            });
        }
        /**
     * Preprocess arguments before calling the original function:
     * - if needed convert the parameters
     * - in case of rest parameters, move the rest parameters into an Array
     * @param {Param[]} params
     * @param {function} fn
     * @return {function} Returns a wrapped function
     */ function compileArgsPreprocessing(params, fn) {
            var fnConvert = fn;
            // TODO: can we make this wrapper function smarter/simpler?
            if (params.some(hasConversions)) {
                var restParam = hasRestParam(params);
                var compiledConversions = params.map(compileArgConversion);
                fnConvert = function convertArgs() {
                    var args = [];
                    var last = restParam ? arguments.length - 1 : arguments.length;
                    for(var i = 0; i < last; i++)args[i] = compiledConversions[i](arguments[i]);
                    if (restParam) args[last] = arguments[last].map(compiledConversions[last]);
                    return fn.apply(null, args);
                };
            }
            var fnPreprocess = fnConvert;
            if (hasRestParam(params)) {
                var offset = params.length - 1;
                fnPreprocess = function preprocessRestParams() {
                    return fnConvert.apply(null, slice(arguments, 0, offset).concat([
                        slice(arguments, offset)
                    ]));
                };
            }
            return fnPreprocess;
        }
        /**
     * Compile conversion for a parameter to the right type
     * @param {Param} param
     * @return {function} Returns the wrapped function that will convert arguments
     *
     */ function compileArgConversion(param) {
            var test0, test1, conversion0, conversion1;
            var tests = [];
            var conversions = [];
            param.types.forEach(function(type) {
                if (type.conversion) {
                    tests.push(findTypeByName(type.conversion.from).test);
                    conversions.push(type.conversion.convert);
                }
            });
            // create optimized conversion functions depending on the number of conversions
            switch(conversions.length){
                case 0:
                    return function convertArg(arg) {
                        return arg;
                    };
                case 1:
                    test0 = tests[0];
                    conversion0 = conversions[0];
                    return function convertArg(arg) {
                        if (test0(arg)) return conversion0(arg);
                        return arg;
                    };
                case 2:
                    test0 = tests[0];
                    test1 = tests[1];
                    conversion0 = conversions[0];
                    conversion1 = conversions[1];
                    return function convertArg(arg) {
                        if (test0(arg)) return conversion0(arg);
                        if (test1(arg)) return conversion1(arg);
                        return arg;
                    };
                default:
                    return function convertArg(arg) {
                        for(var i = 0; i < conversions.length; i++){
                            if (tests[i](arg)) return conversions[i](arg);
                        }
                        return arg;
                    };
            }
        }
        /**
     * Convert an array with signatures into a map with signatures,
     * where signatures with union types are split into separate signatures
     *
     * Throws an error when there are conflicting types
     *
     * @param {Signature[]} signatures
     * @return {Object.<string, function>}  Returns a map with signatures
     *                                      as key and the original function
     *                                      of this signature as value.
     */ function createSignaturesMap(signatures) {
            var signaturesMap = {};
            signatures.forEach(function(signature) {
                if (!signature.params.some(hasConversions)) splitParams(signature.params, true).forEach(function(params) {
                    signaturesMap[stringifyParams(params)] = signature.fn;
                });
            });
            return signaturesMap;
        }
        /**
     * Split params with union types in to separate params.
     *
     * For example:
     *
     *     splitParams([['Array', 'Object'], ['string', 'RegExp'])
     *     // returns:
     *     // [
     *     //   ['Array', 'string'],
     *     //   ['Array', 'RegExp'],
     *     //   ['Object', 'string'],
     *     //   ['Object', 'RegExp']
     *     // ]
     *
     * @param {Param[]} params
     * @param {boolean} ignoreConversionTypes
     * @return {Param[]}
     */ function splitParams(params, ignoreConversionTypes) {
            function _splitParams(params, index, types) {
                if (index < params.length) {
                    var param = params[index];
                    var filteredTypes = ignoreConversionTypes ? param.types.filter(isExactType) : param.types;
                    var typeGroups;
                    if (param.restParam) {
                        // split the types of a rest parameter in two:
                        // one with only exact types, and one with exact types and conversions
                        var exactTypes = filteredTypes.filter(isExactType);
                        typeGroups = exactTypes.length < filteredTypes.length ? [
                            exactTypes,
                            filteredTypes
                        ] : [
                            filteredTypes
                        ];
                    } else // split all the types of a regular parameter into one type per group
                    typeGroups = filteredTypes.map(function(type) {
                        return [
                            type
                        ];
                    });
                    // recurse over the groups with types
                    return flatMap(typeGroups, function(typeGroup) {
                        return _splitParams(params, index + 1, types.concat([
                            typeGroup
                        ]));
                    });
                } else {
                    // we've reached the end of the parameters. Now build a new Param
                    var splittedParams = types.map(function(type, typeIndex) {
                        return {
                            types: type,
                            restParam: typeIndex === params.length - 1 && hasRestParam(params)
                        };
                    });
                    return [
                        splittedParams
                    ];
                }
            }
            return _splitParams(params, 0, []);
        }
        /**
     * Test whether two signatures have a conflicting signature
     * @param {Signature} signature1
     * @param {Signature} signature2
     * @return {boolean} Returns true when the signatures conflict, false otherwise.
     */ function hasConflictingParams(signature1, signature2) {
            var ii = Math.max(signature1.params.length, signature2.params.length);
            for(var i = 0; i < ii; i++){
                var typesNames1 = getExpectedTypeNames(signature1, i, true);
                var typesNames2 = getExpectedTypeNames(signature2, i, true);
                if (!hasOverlap(typesNames1, typesNames2)) return false;
            }
            var len1 = signature1.params.length;
            var len2 = signature2.params.length;
            var restParam1 = hasRestParam(signature1.params);
            var restParam2 = hasRestParam(signature2.params);
            return restParam1 ? restParam2 ? len1 === len2 : len2 >= len1 : restParam2 ? len1 >= len2 : len1 === len2;
        }
        /**
     * Create a typed function
     * @param {String} name               The name for the typed function
     * @param {Object.<string, function>} signaturesMap
     *                                    An object with one or
     *                                    multiple signatures as key, and the
     *                                    function corresponding to the
     *                                    signature as value.
     * @return {function}  Returns the created typed function.
     */ function createTypedFunction(name, signaturesMap) {
            if (Object.keys(signaturesMap).length === 0) throw new SyntaxError("No signatures provided");
            // parse the signatures, and check for conflicts
            var parsedSignatures = [];
            Object.keys(signaturesMap).map(function(signature) {
                return parseSignature(signature, signaturesMap[signature], typed.conversions);
            }).filter(notNull).forEach(function(parsedSignature) {
                // check whether this parameter conflicts with already parsed signatures
                var conflictingSignature = findInArray(parsedSignatures, function(s) {
                    return hasConflictingParams(s, parsedSignature);
                });
                if (conflictingSignature) throw new TypeError('Conflicting signatures "' + stringifyParams(conflictingSignature.params) + '" and "' + stringifyParams(parsedSignature.params) + '".');
                parsedSignatures.push(parsedSignature);
            });
            // split and filter the types of the signatures, and then order them
            var signatures = flatMap(parsedSignatures, function(parsedSignature) {
                var params = parsedSignature ? splitParams(parsedSignature.params, false) : [];
                return params.map(function(params) {
                    return {
                        params: params,
                        fn: parsedSignature.fn
                    };
                });
            }).filter(notNull);
            signatures.sort(compareSignatures);
            // we create a highly optimized checks for the first couple of signatures with max 2 arguments
            var ok0 = signatures[0] && signatures[0].params.length <= 2 && !hasRestParam(signatures[0].params);
            var ok1 = signatures[1] && signatures[1].params.length <= 2 && !hasRestParam(signatures[1].params);
            var ok2 = signatures[2] && signatures[2].params.length <= 2 && !hasRestParam(signatures[2].params);
            var ok3 = signatures[3] && signatures[3].params.length <= 2 && !hasRestParam(signatures[3].params);
            var ok4 = signatures[4] && signatures[4].params.length <= 2 && !hasRestParam(signatures[4].params);
            var ok5 = signatures[5] && signatures[5].params.length <= 2 && !hasRestParam(signatures[5].params);
            var allOk = ok0 && ok1 && ok2 && ok3 && ok4 && ok5;
            // compile the tests
            var tests = signatures.map(function(signature) {
                return compileTests(signature.params);
            });
            var test00 = ok0 ? compileTest(signatures[0].params[0]) : notOk;
            var test10 = ok1 ? compileTest(signatures[1].params[0]) : notOk;
            var test20 = ok2 ? compileTest(signatures[2].params[0]) : notOk;
            var test30 = ok3 ? compileTest(signatures[3].params[0]) : notOk;
            var test40 = ok4 ? compileTest(signatures[4].params[0]) : notOk;
            var test50 = ok5 ? compileTest(signatures[5].params[0]) : notOk;
            var test01 = ok0 ? compileTest(signatures[0].params[1]) : notOk;
            var test11 = ok1 ? compileTest(signatures[1].params[1]) : notOk;
            var test21 = ok2 ? compileTest(signatures[2].params[1]) : notOk;
            var test31 = ok3 ? compileTest(signatures[3].params[1]) : notOk;
            var test41 = ok4 ? compileTest(signatures[4].params[1]) : notOk;
            var test51 = ok5 ? compileTest(signatures[5].params[1]) : notOk;
            // compile the functions
            var fns = signatures.map(function(signature) {
                return compileArgsPreprocessing(signature.params, signature.fn);
            });
            var fn0 = ok0 ? fns[0] : undef;
            var fn1 = ok1 ? fns[1] : undef;
            var fn2 = ok2 ? fns[2] : undef;
            var fn3 = ok3 ? fns[3] : undef;
            var fn4 = ok4 ? fns[4] : undef;
            var fn5 = ok5 ? fns[5] : undef;
            var len0 = ok0 ? signatures[0].params.length : -1;
            var len1 = ok1 ? signatures[1].params.length : -1;
            var len2 = ok2 ? signatures[2].params.length : -1;
            var len3 = ok3 ? signatures[3].params.length : -1;
            var len4 = ok4 ? signatures[4].params.length : -1;
            var len5 = ok5 ? signatures[5].params.length : -1;
            // simple and generic, but also slow
            var iStart = allOk ? 6 : 0;
            var iEnd = signatures.length;
            var generic = function generic() {
                "use strict";
                for(var i = iStart; i < iEnd; i++){
                    if (tests[i](arguments)) return fns[i].apply(null, arguments);
                }
                throw createError(name, arguments, signatures);
            };
            // create the typed function
            // fast, specialized version. Falls back to the slower, generic one if needed
            var fn = function fn(arg0, arg1) {
                "use strict";
                if (arguments.length === len0 && test00(arg0) && test01(arg1)) return fn0.apply(null, arguments);
                if (arguments.length === len1 && test10(arg0) && test11(arg1)) return fn1.apply(null, arguments);
                if (arguments.length === len2 && test20(arg0) && test21(arg1)) return fn2.apply(null, arguments);
                if (arguments.length === len3 && test30(arg0) && test31(arg1)) return fn3.apply(null, arguments);
                if (arguments.length === len4 && test40(arg0) && test41(arg1)) return fn4.apply(null, arguments);
                if (arguments.length === len5 && test50(arg0) && test51(arg1)) return fn5.apply(null, arguments);
                return generic.apply(null, arguments);
            };
            // attach name the typed function
            try {
                Object.defineProperty(fn, "name", {
                    value: name
                });
            } catch (err) {
            // old browsers do not support Object.defineProperty and some don't support setting the name property
            // the function name is not essential for the functioning, it's mostly useful for debugging,
            // so it's fine to have unnamed functions.
            }
            // attach signatures to the function
            fn.signatures = createSignaturesMap(signatures);
            return fn;
        }
        /**
     * Test whether a type should be NOT be ignored
     * @param {string} typeName
     * @return {boolean}
     */ function notIgnore(typeName) {
            return typed.ignore.indexOf(typeName) === -1;
        }
        /**
     * trim a string
     * @param {string} str
     * @return {string}
     */ function trim(str) {
            return str.trim();
        }
        /**
     * Test whether a string is not empty
     * @param {string} str
     * @return {boolean}
     */ function notEmpty(str) {
            return !!str;
        }
        /**
     * test whether a value is not strict equal to null
     * @param {*} value
     * @return {boolean}
     */ function notNull(value) {
            return value !== null;
        }
        /**
     * Test whether a parameter has no types defined
     * @param {Param} param
     * @return {boolean}
     */ function isInvalidParam(param) {
            return param.types.length === 0;
        }
        /**
     * Return all but the last items of an array
     * @param {Array} arr
     * @return {Array}
     */ function initial(arr) {
            return arr.slice(0, arr.length - 1);
        }
        /**
     * return the last item of an array
     * @param {Array} arr
     * @return {*}
     */ function last(arr) {
            return arr[arr.length - 1];
        }
        /**
     * Slice an array or function Arguments
     * @param {Array | Arguments | IArguments} arr
     * @param {number} start
     * @param {number} [end]
     * @return {Array}
     */ function slice(arr, start, end) {
            return Array.prototype.slice.call(arr, start, end);
        }
        /**
     * Test whether an array contains some item
     * @param {Array} array
     * @param {*} item
     * @return {boolean} Returns true if array contains item, false if not.
     */ function contains(array, item) {
            return array.indexOf(item) !== -1;
        }
        /**
     * Test whether two arrays have overlapping items
     * @param {Array} array1
     * @param {Array} array2
     * @return {boolean} Returns true when at least one item exists in both arrays
     */ function hasOverlap(array1, array2) {
            for(var i = 0; i < array1.length; i++){
                if (contains(array2, array1[i])) return true;
            }
            return false;
        }
        /**
     * Return the first item from an array for which test(arr[i]) returns true
     * @param {Array} arr
     * @param {function} test
     * @return {* | undefined} Returns the first matching item
     *                         or undefined when there is no match
     */ function findInArray(arr, test) {
            for(var i = 0; i < arr.length; i++){
                if (test(arr[i])) return arr[i];
            }
            return undefined;
        }
        /**
     * Filter unique items of an array with strings
     * @param {string[]} arr
     * @return {string[]}
     */ function uniq(arr) {
            var entries = {};
            for(var i = 0; i < arr.length; i++)entries[arr[i]] = true;
            return Object.keys(entries);
        }
        /**
     * Flat map the result invoking a callback for every item in an array.
     * https://gist.github.com/samgiles/762ee337dff48623e729
     * @param {Array} arr
     * @param {function} callback
     * @return {Array}
     */ function flatMap(arr, callback) {
            return Array.prototype.concat.apply([], arr.map(callback));
        }
        /**
     * Retrieve the function name from a set of typed functions,
     * and check whether the name of all functions match (if given)
     * @param {function[]} fns
     */ function getName(fns) {
            var name = "";
            for(var i = 0; i < fns.length; i++){
                var fn = fns[i];
                // check whether the names are the same when defined
                if ((typeof fn.signatures === "object" || typeof fn.signature === "string") && fn.name !== "") {
                    if (name === "") name = fn.name;
                    else if (name !== fn.name) {
                        var err = new Error("Function names do not match (expected: " + name + ", actual: " + fn.name + ")");
                        err.data = {
                            actual: fn.name,
                            expected: name
                        };
                        throw err;
                    }
                }
            }
            return name;
        }
        // extract and merge all signatures of a list with typed functions
        function extractSignatures(fns) {
            var err;
            var signaturesMap = {};
            function validateUnique(_signature, _fn) {
                if (signaturesMap.hasOwnProperty(_signature) && _fn !== signaturesMap[_signature]) {
                    err = new Error('Signature "' + _signature + '" is defined twice');
                    err.data = {
                        signature: _signature
                    };
                    throw err;
                // else: both signatures point to the same function, that's fine
                }
            }
            for(var i = 0; i < fns.length; i++){
                var fn = fns[i];
                // test whether this is a typed-function
                if (typeof fn.signatures === "object") {
                    // merge the signatures
                    for(var signature in fn.signatures)if (fn.signatures.hasOwnProperty(signature)) {
                        validateUnique(signature, fn.signatures[signature]);
                        signaturesMap[signature] = fn.signatures[signature];
                    }
                } else if (typeof fn.signature === "string") {
                    validateUnique(fn.signature, fn);
                    signaturesMap[fn.signature] = fn;
                } else {
                    err = new TypeError("Function is no typed-function (index: " + i + ")");
                    err.data = {
                        index: i
                    };
                    throw err;
                }
            }
            return signaturesMap;
        }
        typed = createTypedFunction("typed", {
            "string, Object": createTypedFunction,
            "Object": function(signaturesMap) {
                // find existing name
                var fns = [];
                for(var signature in signaturesMap)if (signaturesMap.hasOwnProperty(signature)) fns.push(signaturesMap[signature]);
                var name = getName(fns);
                return createTypedFunction(name, signaturesMap);
            },
            "...Function": function(fns) {
                return createTypedFunction(getName(fns), extractSignatures(fns));
            },
            "string, ...Function": function(name, fns) {
                return createTypedFunction(name, extractSignatures(fns));
            }
        });
        typed.create = create;
        typed.types = _types;
        typed.conversions = _conversions;
        typed.ignore = _ignore;
        typed.convert = convert;
        typed.find = find;
        /**
     * add a type
     * @param {{name: string, test: function}} type
     * @param {boolean} [beforeObjectTest=true]
     *                          If true, the new test will be inserted before
     *                          the test with name 'Object' (if any), since
     *                          tests for Object match Array and classes too.
     */ typed.addType = function(type, beforeObjectTest) {
            if (!type || typeof type.name !== "string" || typeof type.test !== "function") throw new TypeError("Object with properties {name: string, test: function} expected");
            if (beforeObjectTest !== false) {
                for(var i = 0; i < typed.types.length; i++)if (typed.types[i].name === "Object") {
                    typed.types.splice(i, 0, type);
                    return;
                }
            }
            typed.types.push(type);
        };
        // add a conversion
        typed.addConversion = function(conversion) {
            if (!conversion || typeof conversion.from !== "string" || typeof conversion.to !== "string" || typeof conversion.convert !== "function") throw new TypeError("Object with properties {from: string, to: string, convert: function} expected");
            typed.conversions.push(conversion);
        };
        return typed;
    }
    return create();
});

});


parcelRegister("bLADv", function(module, exports) {

$parcel$export(module.exports, "createTypeOf", function () { return $891080a7b9afd364$export$d7acf116afef7b4d; });

var $2mPYl = parcelRequire("2mPYl");

var $1amHZ = parcelRequire("1amHZ");

var $kcYaK = parcelRequire("kcYaK");
var $891080a7b9afd364$var$name = "typeOf";
var $891080a7b9afd364$var$dependencies = [
    "typed"
];
var $891080a7b9afd364$export$d7acf116afef7b4d = /* #__PURE__ */ (0, $2mPYl.factory)($891080a7b9afd364$var$name, $891080a7b9afd364$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Determine the type of a variable.
   *
   * Function `typeOf` recognizes the following types of objects:
   *
   * Object                 | Returns       | Example
   * ---------------------- | ------------- | ------------------------------------------
   * null                   | `'null'`      | `math.typeOf(null)`
   * number                 | `'number'`    | `math.typeOf(3.5)`
   * boolean                | `'boolean'`   | `math.typeOf(true)`
   * string                 | `'string'`    | `math.typeOf('hello world')`
   * Array                  | `'Array'`     | `math.typeOf([1, 2, 3])`
   * Date                   | `'Date'`      | `math.typeOf(new Date())`
   * Function               | `'Function'`  | `math.typeOf(function () {})`
   * Object                 | `'Object'`    | `math.typeOf({a: 2, b: 3})`
   * RegExp                 | `'RegExp'`    | `math.typeOf(/a regexp/)`
   * undefined              | `'undefined'` | `math.typeOf(undefined)`
   * math.BigNumber         | `'BigNumber'` | `math.typeOf(math.bignumber('2.3e500'))`
   * math.Chain             | `'Chain'`     | `math.typeOf(math.chain(2))`
   * math.Complex           | `'Complex'`   | `math.typeOf(math.complex(2, 3))`
   * math.Fraction          | `'Fraction'`  | `math.typeOf(math.fraction(1, 3))`
   * math.Help              | `'Help'`      | `math.typeOf(math.help('sqrt'))`
   * math.Help              | `'Help'`      | `math.typeOf(math.help('sqrt'))`
   * math.Index             | `'Index'`     | `math.typeOf(math.index(1, 3))`
   * math.Matrix            | `'Matrix'`    | `math.typeOf(math.matrix([[1,2], [3, 4]]))`
   * math.Range             | `'Range'`     | `math.typeOf(math.range(0, 10))`
   * math.ResultSet         | `'ResultSet'` | `math.typeOf(math.evaluate('a=2\nb=3'))`
   * math.Unit              | `'Unit'`      | `math.typeOf(math.unit('45 deg'))`
   * math.AccessorNode            | `'AccessorNode'`            | `math.typeOf(math.parse('A[2]'))`
   * math.ArrayNode               | `'ArrayNode'`               | `math.typeOf(math.parse('[1,2,3]'))`
   * math.AssignmentNode          | `'AssignmentNode'`          | `math.typeOf(math.parse('x=2'))`
   * math.BlockNode               | `'BlockNode'`               | `math.typeOf(math.parse('a=2; b=3'))`
   * math.ConditionalNode         | `'ConditionalNode'`         | `math.typeOf(math.parse('x<0 ? -x : x'))`
   * math.ConstantNode            | `'ConstantNode'`            | `math.typeOf(math.parse('2.3'))`
   * math.FunctionAssignmentNode  | `'FunctionAssignmentNode'`  | `math.typeOf(math.parse('f(x)=x^2'))`
   * math.FunctionNode            | `'FunctionNode'`            | `math.typeOf(math.parse('sqrt(4)'))`
   * math.IndexNode               | `'IndexNode'`               | `math.typeOf(math.parse('A[2]').index)`
   * math.ObjectNode              | `'ObjectNode'`              | `math.typeOf(math.parse('{a:2}'))`
   * math.ParenthesisNode         | `'ParenthesisNode'`         | `math.typeOf(math.parse('(2+3)'))`
   * math.RangeNode               | `'RangeNode'`               | `math.typeOf(math.parse('1:10'))`
   * math.SymbolNode              | `'SymbolNode'`              | `math.typeOf(math.parse('x'))`
   *
   * Syntax:
   *
   *    math.typeOf(x)
   *
   * Examples:
   *
   *    math.typeOf(3.5)                     // returns 'number'
   *    math.typeOf(math.complex('2-4i'))    // returns 'Complex'
   *    math.typeOf(math.unit('45 deg'))     // returns 'Unit'
   *    math.typeOf('hello world')           // returns 'string'
   *
   * @param {*} x     The variable for which to test the type.
   * @return {string} Returns the name of the type. Primitive types are lower case,
   *                  non-primitive types are upper-camel-case.
   *                  For example 'number', 'string', 'Array', 'Date'.
   */ return typed($891080a7b9afd364$var$name, {
        any: (0, $1amHZ.typeOf)
    });
}); // For backward compatibility, deprecated since version 6.0.0. Date: 2018-11-06
var $891080a7b9afd364$export$4f3eb3292c67e51a = /* #__PURE__ */ (0, $2mPYl.factory)("typeof", [], function() {
    return function() {
        (0, $kcYaK.warnOnce)('Function "typeof" has been renamed to "typeOf" in v6.0.0, please use the new function instead.');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return (0, $1amHZ.typeOf).apply((0, $1amHZ.typeOf), args);
    };
});

});

parcelRegister("9eOSV", function(module, exports) {

$parcel$export(module.exports, "createUnaryMinus", function () { return $6b9ce484aa470b55$export$939e1be6e134f392; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");

var $6fCew = parcelRequire("6fCew");
var $6b9ce484aa470b55$var$name = "unaryMinus";
var $6b9ce484aa470b55$var$dependencies = [
    "typed"
];
var $6b9ce484aa470b55$export$939e1be6e134f392 = /* #__PURE__ */ (0, $2mPYl.factory)($6b9ce484aa470b55$var$name, $6b9ce484aa470b55$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Inverse the sign of a value, apply a unary minus operation.
   *
   * For matrices, the function is evaluated element wise. Boolean values and
   * strings will be converted to a number. For complex numbers, both real and
   * complex value are inverted.
   *
   * Syntax:
   *
   *    math.unaryMinus(x)
   *
   * Examples:
   *
   *    math.unaryMinus(3.5)      // returns -3.5
   *    math.unaryMinus(-4.2)     // returns 4.2
   *
   * See also:
   *
   *    add, subtract, unaryPlus
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x Number to be inverted.
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} Returns the value with inverted sign.
   */ var unaryMinus = typed($6b9ce484aa470b55$var$name, {
        number: (0, $6fCew.unaryMinusNumber),
        Complex: function Complex(x) {
            return x.neg();
        },
        BigNumber: function BigNumber(x) {
            return x.neg();
        },
        Fraction: function Fraction(x) {
            return x.neg();
        },
        Unit: function Unit(x) {
            var res = x.clone();
            res.value = unaryMinus(x.value);
            return res;
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since unaryMinus(0) = 0
            return (0, $e04i1.deepMap)(x, unaryMinus, true);
        } // TODO: add support for string
    });
    return unaryMinus;
});

});

parcelRegister("hP7lt", function(module, exports) {

$parcel$export(module.exports, "createUnaryPlus", function () { return $cf9ce5bc5277b11d$export$cb425222dc08ff4e; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");

var $6fCew = parcelRequire("6fCew");
var $cf9ce5bc5277b11d$var$name = "unaryPlus";
var $cf9ce5bc5277b11d$var$dependencies = [
    "typed",
    "config",
    "BigNumber"
];
var $cf9ce5bc5277b11d$export$cb425222dc08ff4e = /* #__PURE__ */ (0, $2mPYl.factory)($cf9ce5bc5277b11d$var$name, $cf9ce5bc5277b11d$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, BigNumber = _ref.BigNumber;
    /**
   * Unary plus operation.
   * Boolean values and strings will be converted to a number, numeric values will be returned as is.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.unaryPlus(x)
   *
   * Examples:
   *
   *    math.unaryPlus(3.5)      // returns 3.5
   *    math.unaryPlus(1)     // returns 1
   *
   * See also:
   *
   *    unaryMinus, add, subtract
   *
   * @param  {number | BigNumber | Fraction | string | Complex | Unit | Array | Matrix} x
   *            Input value
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}
   *            Returns the input value when numeric, converts to a number when input is non-numeric.
   */ var unaryPlus = typed($cf9ce5bc5277b11d$var$name, {
        number: (0, $6fCew.unaryPlusNumber),
        Complex: function Complex(x) {
            return x; // complex numbers are immutable
        },
        BigNumber: function BigNumber(x) {
            return x; // bignumbers are immutable
        },
        Fraction: function Fraction(x) {
            return x; // fractions are immutable
        },
        Unit: function Unit(x) {
            return x.clone();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since unaryPlus(0) = 0
            return (0, $e04i1.deepMap)(x, unaryPlus, true);
        },
        "boolean | string": function booleanString(x) {
            // convert to a number or bignumber
            return config.number === "BigNumber" ? new BigNumber(+x) : +x;
        }
    });
    return unaryPlus;
});

});

parcelRegister("6XBRu", function(module, exports) {

$parcel$export(module.exports, "createUnequal", function () { return $51159f4e371f3497$export$833e6c382e279d04; });

var $2mPYl = parcelRequire("2mPYl");

var $jaKH8 = parcelRequire("jaKH8");

var $awGkR = parcelRequire("awGkR");

var $dNuvz = parcelRequire("dNuvz");

var $iHnaT = parcelRequire("iHnaT");

var $1bBLS = parcelRequire("1bBLS");
var $51159f4e371f3497$var$name = "unequal";
var $51159f4e371f3497$var$dependencies = [
    "typed",
    "config",
    "equalScalar",
    "matrix",
    "DenseMatrix"
];
var $51159f4e371f3497$export$833e6c382e279d04 = /* #__PURE__ */ (0, $2mPYl.factory)($51159f4e371f3497$var$name, $51159f4e371f3497$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, equalScalar = _ref.equalScalar, matrix = _ref.matrix, DenseMatrix = _ref.DenseMatrix;
    var algorithm03 = (0, $jaKH8.createAlgorithm03)({
        typed: typed
    });
    var algorithm07 = (0, $awGkR.createAlgorithm07)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $dNuvz.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $1bBLS.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $iHnaT.createAlgorithm14)({
        typed: typed
    });
    /**
   * Test whether two values are unequal.
   *
   * The function tests whether the relative difference between x and y is
   * larger than the configured epsilon. The function cannot be used to compare
   * values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * In case of complex numbers, x.re must unequal y.re, or x.im must unequal y.im.
   * Strings are compared by their numerical value.
   *
   * Values `null` and `undefined` are compared strictly, thus `null` is unequal
   * with everything except `null`, and `undefined` is unequal with everything
   * except `undefined`.
   *
   * Syntax:
   *
   *    math.unequal(x, y)
   *
   * Examples:
   *
   *    math.unequal(2 + 2, 3)       // returns true
   *    math.unequal(2 + 2, 4)       // returns false
   *
   *    const a = math.unit('50 cm')
   *    const b = math.unit('5 m')
   *    math.unequal(a, b)           // returns false
   *
   *    const c = [2, 5, 1]
   *    const d = [2, 7, 1]
   *
   *    math.unequal(c, d)           // returns [false, true, false]
   *    math.deepEqual(c, d)         // returns false
   *
   *    math.unequal(0, null)        // returns true
   * See also:
   *
   *    equal, deepEqual, smaller, smallerEq, larger, largerEq, compare
   *
   * @param  {number | BigNumber | Fraction | boolean | Complex | Unit | string | Array | Matrix | undefined} x First value to compare
   * @param  {number | BigNumber | Fraction | boolean | Complex | Unit | string | Array | Matrix | undefined} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the compared values are unequal, else returns false
   */ var unequal = typed("unequal", {
        "any, any": function anyAny(x, y) {
            // strict equality for null and undefined?
            if (x === null) return y !== null;
            if (y === null) return x !== null;
            if (x === undefined) return y !== undefined;
            if (y === undefined) return x !== undefined;
            return _unequal(x, y);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, _unequal);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, _unequal, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, _unequal, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, _unequal);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return unequal(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return unequal(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return unequal(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, _unequal, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, _unequal, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, _unequal, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, _unequal, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, _unequal, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, _unequal, true).valueOf();
        }
    });
    function _unequal(x, y) {
        return !equalScalar(x, y);
    }
    return unequal;
});
var $51159f4e371f3497$export$b0b3dad01e54080b = (0, $2mPYl.factory)($51159f4e371f3497$var$name, [
    "typed",
    "equalScalar"
], function(_ref2) {
    var typed = _ref2.typed, equalScalar = _ref2.equalScalar;
    return typed($51159f4e371f3497$var$name, {
        "any, any": function anyAny(x, y) {
            // strict equality for null and undefined?
            if (x === null) return y !== null;
            if (y === null) return x !== null;
            if (x === undefined) return y !== undefined;
            if (y === undefined) return x !== undefined;
            return !equalScalar(x, y);
        }
    });
});

});

parcelRegister("iT8TK", function(module, exports) {

$parcel$export(module.exports, "createUnitClass", function () { return $dc04440ac59b18c7$export$3ad06557a3ac7a63; });

var $1amHZ = parcelRequire("1amHZ");

var $2mPYl = parcelRequire("2mPYl");

var $6NxuJ = parcelRequire("6NxuJ");

var $7ITGG = parcelRequire("7ITGG");

var $4zk7D = parcelRequire("4zk7D");
function $dc04440ac59b18c7$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $dc04440ac59b18c7$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $dc04440ac59b18c7$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $dc04440ac59b18c7$var$_typeof(obj);
}
function $dc04440ac59b18c7$var$_extends() {
    $dc04440ac59b18c7$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dc04440ac59b18c7$var$_extends.apply(this, arguments);
}
var $dc04440ac59b18c7$var$name = "Unit";
var $dc04440ac59b18c7$var$dependencies = [
    "?on",
    "config",
    "addScalar",
    "subtract",
    "multiplyScalar",
    "divideScalar",
    "pow",
    "abs",
    "fix",
    "round",
    "equal",
    "isNumeric",
    "format",
    "number",
    "Complex",
    "BigNumber",
    "Fraction"
];
var $dc04440ac59b18c7$export$3ad06557a3ac7a63 = /* #__PURE__ */ (0, $2mPYl.factory)($dc04440ac59b18c7$var$name, $dc04440ac59b18c7$var$dependencies, function(_ref) {
    var on = _ref.on, config = _ref.config, addScalar = _ref.addScalar, subtract = _ref.subtract, multiplyScalar = _ref.multiplyScalar, divideScalar = _ref.divideScalar, pow = _ref.pow, abs = _ref.abs, fix = _ref.fix, round = _ref.round, equal = _ref.equal, isNumeric = _ref.isNumeric, format = _ref.format, number = _ref.number, Complex = _ref.Complex, _BigNumber = _ref.BigNumber, _Fraction = _ref.Fraction;
    var toNumber = number;
    /**
   * A unit can be constructed in the following ways:
   *
   *     const a = new Unit(value, name)
   *     const b = new Unit(null, name)
   *     const c = Unit.parse(str)
   *
   * Example usage:
   *
   *     const a = new Unit(5, 'cm')               // 50 mm
   *     const b = Unit.parse('23 kg')             // 23 kg
   *     const c = math.in(a, new Unit(null, 'm')  // 0.05 m
   *     const d = new Unit(9.81, "m/s^2")         // 9.81 m/s^2
   *
   * @class Unit
   * @constructor Unit
   * @param {number | BigNumber | Fraction | Complex | boolean} [value]  A value like 5.2
   * @param {string} [name]   A unit name like "cm" or "inch", or a derived unit of the form: "u1[^ex1] [u2[^ex2] ...] [/ u3[^ex3] [u4[^ex4]]]", such as "kg m^2/s^2", where each unit appearing after the forward slash is taken to be in the denominator. "kg m^2 s^-2" is a synonym and is also acceptable. Any of the units can include a prefix.
   */ function Unit(value, name) {
        if (!(this instanceof Unit)) throw new Error("Constructor must be called with the new operator");
        if (!(value === null || value === undefined || isNumeric(value) || (0, $1amHZ.isComplex)(value))) throw new TypeError("First parameter in Unit constructor must be number, BigNumber, Fraction, Complex, or undefined");
        if (name !== undefined && (typeof name !== "string" || name === "")) throw new TypeError("Second parameter in Unit constructor must be a string");
        if (name !== undefined) {
            var u = Unit.parse(name);
            this.units = u.units;
            this.dimensions = u.dimensions;
        } else {
            this.units = [
                {
                    unit: UNIT_NONE,
                    prefix: PREFIXES.NONE,
                    // link to a list with supported prefixes
                    power: 0
                }
            ];
            this.dimensions = [];
            for(var i = 0; i < BASE_DIMENSIONS.length; i++)this.dimensions[i] = 0;
        }
        this.value = value !== undefined && value !== null ? this._normalize(value) : null;
        this.fixPrefix = false; // if true, function format will not search for the
        // best prefix but leave it as initially provided.
        // fixPrefix is set true by the method Unit.to
        // The justification behind this is that if the constructor is explicitly called,
        // the caller wishes the units to be returned exactly as he supplied.
        this.skipAutomaticSimplification = true;
    }
    /**
   * Attach type information
   */ Unit.prototype.type = "Unit";
    Unit.prototype.isUnit = true; // private variables and functions for the Unit parser
    var text, index, c;
    function skipWhitespace() {
        while(c === " " || c === "	")next();
    }
    function isDigitDot(c) {
        return c >= "0" && c <= "9" || c === ".";
    }
    function isDigit(c) {
        return c >= "0" && c <= "9";
    }
    function next() {
        index++;
        c = text.charAt(index);
    }
    function revert(oldIndex) {
        index = oldIndex;
        c = text.charAt(index);
    }
    function parseNumber() {
        var number = "";
        var oldIndex = index;
        if (c === "+") next();
        else if (c === "-") {
            number += c;
            next();
        }
        if (!isDigitDot(c)) {
            // a + or - must be followed by a digit
            revert(oldIndex);
            return null;
        } // get number, can have a single dot
        if (c === ".") {
            number += c;
            next();
            if (!isDigit(c)) {
                // this is no legal number, it is just a dot
                revert(oldIndex);
                return null;
            }
        } else {
            while(isDigit(c)){
                number += c;
                next();
            }
            if (c === ".") {
                number += c;
                next();
            }
        }
        while(isDigit(c)){
            number += c;
            next();
        } // check for exponential notation like "2.3e-4" or "1.23e50"
        if (c === "E" || c === "e") {
            // The grammar branches here. This could either be part of an exponent or the start of a unit that begins with the letter e, such as "4exabytes"
            var tentativeNumber = "";
            var tentativeIndex = index;
            tentativeNumber += c;
            next();
            if (c === "+" || c === "-") {
                tentativeNumber += c;
                next();
            } // Scientific notation MUST be followed by an exponent (otherwise we assume it is not scientific notation)
            if (!isDigit(c)) {
                // The e or E must belong to something else, so return the number without the e or E.
                revert(tentativeIndex);
                return number;
            } // We can now safely say that this is scientific notation.
            number = number + tentativeNumber;
            while(isDigit(c)){
                number += c;
                next();
            }
        }
        return number;
    }
    function parseUnit() {
        var unitName = ""; // Alphanumeric characters only; matches [a-zA-Z0-9]
        var code = text.charCodeAt(index);
        while(code >= 48 && code <= 57 || code >= 65 && code <= 90 || code >= 97 && code <= 122){
            unitName += c;
            next();
            code = text.charCodeAt(index);
        } // Must begin with [a-zA-Z]
        code = unitName.charCodeAt(0);
        if (code >= 65 && code <= 90 || code >= 97 && code <= 122) return unitName || null;
        else return null;
    }
    function parseCharacter(toFind) {
        if (c === toFind) {
            next();
            return toFind;
        } else return null;
    }
    /**
   * Parse a string into a unit. The value of the unit is parsed as number,
   * BigNumber, or Fraction depending on the math.js config setting `number`.
   *
   * Throws an exception if the provided string does not contain a valid unit or
   * cannot be parsed.
   * @memberof Unit
   * @param {string} str        A string like "5.2 inch", "4e2 cm/s^2"
   * @return {Unit} unit
   */ Unit.parse = function(str, options) {
        options = options || {};
        text = str;
        index = -1;
        c = "";
        if (typeof text !== "string") throw new TypeError("Invalid argument in Unit.parse, string expected");
        var unit = new Unit();
        unit.units = [];
        var powerMultiplierCurrent = 1;
        var expectingUnit = false; // A unit should follow this pattern:
        // [number] ...[ [*/] unit[^number] ]
        // unit[^number] ... [ [*/] unit[^number] ]
        // Rules:
        // number is any floating point number.
        // unit is any alphanumeric string beginning with an alpha. Units with names like e3 should be avoided because they look like the exponent of a floating point number!
        // The string may optionally begin with a number.
        // Each unit may optionally be followed by ^number.
        // Whitespace or a forward slash is recommended between consecutive units, although the following technically is parseable:
        //   2m^2kg/s^2
        // it is not good form. If a unit starts with e, then it could be confused as a floating point number:
        //   4erg
        next();
        skipWhitespace(); // Optional number at the start of the string
        var valueStr = parseNumber();
        var value = null;
        if (valueStr) {
            if (config.number === "BigNumber") value = new _BigNumber(valueStr);
            else if (config.number === "Fraction") try {
                // not all numbers can be turned in Fractions, for example very small numbers not
                value = new _Fraction(valueStr);
            } catch (err) {
                value = parseFloat(valueStr);
            }
            else // number
            value = parseFloat(valueStr);
            skipWhitespace(); // Whitespace is not required here
            // handle multiplication or division right after the value, like '1/s'
            if (parseCharacter("*")) {
                powerMultiplierCurrent = 1;
                expectingUnit = true;
            } else if (parseCharacter("/")) {
                powerMultiplierCurrent = -1;
                expectingUnit = true;
            }
        } // Stack to keep track of powerMultipliers applied to each parentheses group
        var powerMultiplierStack = []; // Running product of all elements in powerMultiplierStack
        var powerMultiplierStackProduct = 1;
        while(true){
            skipWhitespace(); // Check for and consume opening parentheses, pushing powerMultiplierCurrent to the stack
            // A '(' will always appear directly before a unit.
            while(c === "("){
                powerMultiplierStack.push(powerMultiplierCurrent);
                powerMultiplierStackProduct *= powerMultiplierCurrent;
                powerMultiplierCurrent = 1;
                next();
                skipWhitespace();
            } // Is there something here?
            var uStr = void 0;
            if (c) {
                var oldC = c;
                uStr = parseUnit();
                if (uStr === null) throw new SyntaxError('Unexpected "' + oldC + '" in "' + text + '" at index ' + index.toString());
            } else break;
             // Verify the unit exists and get the prefix (if any)
            var res = _findUnit(uStr);
            if (res === null) // Unit not found.
            throw new SyntaxError('Unit "' + uStr + '" not found.');
            var power = powerMultiplierCurrent * powerMultiplierStackProduct; // Is there a "^ number"?
            skipWhitespace();
            if (parseCharacter("^")) {
                skipWhitespace();
                var p = parseNumber();
                if (p === null) // No valid number found for the power!
                throw new SyntaxError('In "' + str + '", "^" must be followed by a floating-point number');
                power *= p;
            } // Add the unit to the list
            unit.units.push({
                unit: res.unit,
                prefix: res.prefix,
                power: power
            });
            for(var i = 0; i < BASE_DIMENSIONS.length; i++)unit.dimensions[i] += (res.unit.dimensions[i] || 0) * power;
             // Check for and consume closing parentheses, popping from the stack.
            // A ')' will always follow a unit.
            skipWhitespace();
            while(c === ")"){
                if (powerMultiplierStack.length === 0) throw new SyntaxError('Unmatched ")" in "' + text + '" at index ' + index.toString());
                powerMultiplierStackProduct /= powerMultiplierStack.pop();
                next();
                skipWhitespace();
            } // "*" and "/" should mean we are expecting something to come next.
            // Is there a forward slash? If so, negate powerMultiplierCurrent. The next unit or paren group is in the denominator.
            expectingUnit = false;
            if (parseCharacter("*")) {
                // explicit multiplication
                powerMultiplierCurrent = 1;
                expectingUnit = true;
            } else if (parseCharacter("/")) {
                // division
                powerMultiplierCurrent = -1;
                expectingUnit = true;
            } else // implicit multiplication
            powerMultiplierCurrent = 1;
             // Replace the unit into the auto unit system
            if (res.unit.base) {
                var baseDim = res.unit.base.key;
                UNIT_SYSTEMS.auto[baseDim] = {
                    unit: res.unit,
                    prefix: res.prefix
                };
            }
        } // Has the string been entirely consumed?
        skipWhitespace();
        if (c) throw new SyntaxError('Could not parse: "' + str + '"');
         // Is there a trailing slash?
        if (expectingUnit) throw new SyntaxError('Trailing characters: "' + str + '"');
         // Is the parentheses stack empty?
        if (powerMultiplierStack.length !== 0) throw new SyntaxError('Unmatched "(" in "' + text + '"');
         // Are there any units at all?
        if (unit.units.length === 0 && !options.allowNoUnits) throw new SyntaxError('"' + str + '" contains no units');
        unit.value = value !== undefined ? unit._normalize(value) : null;
        return unit;
    };
    /**
   * create a copy of this unit
   * @memberof Unit
   * @return {Unit} Returns a cloned version of the unit
   */ Unit.prototype.clone = function() {
        var unit = new Unit();
        unit.fixPrefix = this.fixPrefix;
        unit.skipAutomaticSimplification = this.skipAutomaticSimplification;
        unit.value = (0, $7ITGG.clone)(this.value);
        unit.dimensions = this.dimensions.slice(0);
        unit.units = [];
        for(var i = 0; i < this.units.length; i++){
            unit.units[i] = {};
            for(var p in this.units[i])if ((0, $7ITGG.hasOwnProperty)(this.units[i], p)) unit.units[i][p] = this.units[i][p];
        }
        return unit;
    };
    /**
   * Return whether the unit is derived (such as m/s, or cm^2, but not N)
   * @memberof Unit
   * @return {boolean} True if the unit is derived
   */ Unit.prototype._isDerived = function() {
        if (this.units.length === 0) return false;
        return this.units.length > 1 || Math.abs(this.units[0].power - 1.0) > 1e-15;
    };
    /**
   * Normalize a value, based on its currently set unit(s)
   * @memberof Unit
   * @param {number | BigNumber | Fraction | boolean} value
   * @return {number | BigNumber | Fraction | boolean} normalized value
   * @private
   */ Unit.prototype._normalize = function(value) {
        var unitValue, unitOffset, unitPower, unitPrefixValue;
        var convert;
        if (value === null || value === undefined || this.units.length === 0) return value;
        else if (this._isDerived()) {
            // This is a derived unit, so do not apply offsets.
            // For example, with J kg^-1 degC^-1 you would NOT want to apply the offset.
            var res = value;
            convert = Unit._getNumberConverter((0, $1amHZ.typeOf)(value)); // convert to Fraction or BigNumber if needed
            for(var i = 0; i < this.units.length; i++){
                unitValue = convert(this.units[i].unit.value);
                unitPrefixValue = convert(this.units[i].prefix.value);
                unitPower = convert(this.units[i].power);
                res = multiplyScalar(res, pow(multiplyScalar(unitValue, unitPrefixValue), unitPower));
            }
            return res;
        } else {
            // This is a single unit of power 1, like kg or degC
            convert = Unit._getNumberConverter((0, $1amHZ.typeOf)(value)); // convert to Fraction or BigNumber if needed
            unitValue = convert(this.units[0].unit.value);
            unitOffset = convert(this.units[0].unit.offset);
            unitPrefixValue = convert(this.units[0].prefix.value);
            return multiplyScalar(addScalar(value, unitOffset), multiplyScalar(unitValue, unitPrefixValue));
        }
    };
    /**
   * Denormalize a value, based on its currently set unit(s)
   * @memberof Unit
   * @param {number} value
   * @param {number} [prefixValue]    Optional prefix value to be used (ignored if this is a derived unit)
   * @return {number} denormalized value
   * @private
   */ Unit.prototype._denormalize = function(value, prefixValue) {
        var unitValue, unitOffset, unitPower, unitPrefixValue;
        var convert;
        if (value === null || value === undefined || this.units.length === 0) return value;
        else if (this._isDerived()) {
            // This is a derived unit, so do not apply offsets.
            // For example, with J kg^-1 degC^-1 you would NOT want to apply the offset.
            // Also, prefixValue is ignored--but we will still use the prefix value stored in each unit, since kg is usually preferable to g unless the user decides otherwise.
            var res = value;
            convert = Unit._getNumberConverter((0, $1amHZ.typeOf)(value)); // convert to Fraction or BigNumber if needed
            for(var i = 0; i < this.units.length; i++){
                unitValue = convert(this.units[i].unit.value);
                unitPrefixValue = convert(this.units[i].prefix.value);
                unitPower = convert(this.units[i].power);
                res = divideScalar(res, pow(multiplyScalar(unitValue, unitPrefixValue), unitPower));
            }
            return res;
        } else {
            // This is a single unit of power 1, like kg or degC
            convert = Unit._getNumberConverter((0, $1amHZ.typeOf)(value)); // convert to Fraction or BigNumber if needed
            unitValue = convert(this.units[0].unit.value);
            unitPrefixValue = convert(this.units[0].prefix.value);
            unitOffset = convert(this.units[0].unit.offset);
            if (prefixValue === undefined || prefixValue === null) return subtract(divideScalar(divideScalar(value, unitValue), unitPrefixValue), unitOffset);
            else return subtract(divideScalar(divideScalar(value, unitValue), prefixValue), unitOffset);
        }
    };
    /**
   * Find a unit from a string
   * @memberof Unit
   * @param {string} str              A string like 'cm' or 'inch'
   * @returns {Object | null} result  When found, an object with fields unit and
   *                                  prefix is returned. Else, null is returned.
   * @private
   */ function _findUnit(str) {
        // First, match units names exactly. For example, a user could define 'mm' as 10^-4 m, which is silly, but then we would want 'mm' to match the user-defined unit.
        if ((0, $7ITGG.hasOwnProperty)(UNITS, str)) {
            var unit = UNITS[str];
            var prefix = unit.prefixes[""];
            return {
                unit: unit,
                prefix: prefix
            };
        }
        for(var _name in UNITS){
            if ((0, $7ITGG.hasOwnProperty)(UNITS, _name)) {
                if ((0, $6NxuJ.endsWith)(str, _name)) {
                    var _unit = UNITS[_name];
                    var prefixLen = str.length - _name.length;
                    var prefixName = str.substring(0, prefixLen);
                    var _prefix = (0, $7ITGG.hasOwnProperty)(_unit.prefixes, prefixName) ? _unit.prefixes[prefixName] : undefined;
                    if (_prefix !== undefined) // store unit, prefix, and value
                    return {
                        unit: _unit,
                        prefix: _prefix
                    };
                }
            }
        }
        return null;
    }
    /**
   * Test if the given expression is a unit.
   * The unit can have a prefix but cannot have a value.
   * @memberof Unit
   * @param {string} name   A string to be tested whether it is a value less unit.
   *                        The unit can have prefix, like "cm"
   * @return {boolean}      true if the given string is a unit
   */ Unit.isValuelessUnit = function(name) {
        return _findUnit(name) !== null;
    };
    /**
   * check if this unit has given base unit
   * If this unit is a derived unit, this will ALWAYS return false, since by definition base units are not derived.
   * @memberof Unit
   * @param {BASE_UNITS | string | undefined} base
   */ Unit.prototype.hasBase = function(base) {
        if (typeof base === "string") base = BASE_UNITS[base];
        if (!base) return false;
         // All dimensions must be the same
        for(var i = 0; i < BASE_DIMENSIONS.length; i++){
            if (Math.abs((this.dimensions[i] || 0) - (base.dimensions[i] || 0)) > 1e-12) return false;
        }
        return true;
    };
    /**
   * Check if this unit has a base or bases equal to another base or bases
   * For derived units, the exponent on each base also must match
   * @memberof Unit
   * @param {Unit} other
   * @return {boolean} true if equal base
   */ Unit.prototype.equalBase = function(other) {
        // All dimensions must be the same
        for(var i = 0; i < BASE_DIMENSIONS.length; i++){
            if (Math.abs((this.dimensions[i] || 0) - (other.dimensions[i] || 0)) > 1e-12) return false;
        }
        return true;
    };
    /**
   * Check if this unit equals another unit
   * @memberof Unit
   * @param {Unit} other
   * @return {boolean} true if both units are equal
   */ Unit.prototype.equals = function(other) {
        return this.equalBase(other) && equal(this.value, other.value);
    };
    /**
   * Multiply this unit with another one
   * @memberof Unit
   * @param {Unit} other
   * @return {Unit} product of this unit and the other unit
   */ Unit.prototype.multiply = function(other) {
        var res = this.clone();
        for(var i = 0; i < BASE_DIMENSIONS.length; i++)// Dimensions arrays may be of different lengths. Default to 0.
        res.dimensions[i] = (this.dimensions[i] || 0) + (other.dimensions[i] || 0);
         // Append other's units list onto res
        for(var _i = 0; _i < other.units.length; _i++){
            // Make a deep copy
            var inverted = {};
            for(var key in other.units[_i])inverted[key] = other.units[_i][key];
            res.units.push(inverted);
        } // If at least one operand has a value, then the result should also have a value
        if (this.value !== null || other.value !== null) {
            var valThis = this.value === null ? this._normalize(1) : this.value;
            var valOther = other.value === null ? other._normalize(1) : other.value;
            res.value = multiplyScalar(valThis, valOther);
        } else res.value = null;
        res.skipAutomaticSimplification = false;
        return getNumericIfUnitless(res);
    };
    /**
   * Divide this unit by another one
   * @memberof Unit
   * @param {Unit} other
   * @return {Unit} result of dividing this unit by the other unit
   */ Unit.prototype.divide = function(other) {
        var res = this.clone();
        for(var i = 0; i < BASE_DIMENSIONS.length; i++)// Dimensions arrays may be of different lengths. Default to 0.
        res.dimensions[i] = (this.dimensions[i] || 0) - (other.dimensions[i] || 0);
         // Invert and append other's units list onto res
        for(var _i2 = 0; _i2 < other.units.length; _i2++){
            // Make a deep copy
            var inverted = {};
            for(var key in other.units[_i2])inverted[key] = other.units[_i2][key];
            inverted.power = -inverted.power;
            res.units.push(inverted);
        } // If at least one operand has a value, the result should have a value
        if (this.value !== null || other.value !== null) {
            var valThis = this.value === null ? this._normalize(1) : this.value;
            var valOther = other.value === null ? other._normalize(1) : other.value;
            res.value = divideScalar(valThis, valOther);
        } else res.value = null;
        res.skipAutomaticSimplification = false;
        return getNumericIfUnitless(res);
    };
    /**
   * Calculate the power of a unit
   * @memberof Unit
   * @param {number | Fraction | BigNumber} p
   * @returns {Unit}      The result: this^p
   */ Unit.prototype.pow = function(p) {
        var res = this.clone();
        for(var i = 0; i < BASE_DIMENSIONS.length; i++)// Dimensions arrays may be of different lengths. Default to 0.
        res.dimensions[i] = (this.dimensions[i] || 0) * p;
         // Adjust the power of each unit in the list
        for(var _i3 = 0; _i3 < res.units.length; _i3++)res.units[_i3].power *= p;
        if (res.value !== null) res.value = pow(res.value, p); // only allow numeric output, we don't want to return a Complex number
        else res.value = null;
        res.skipAutomaticSimplification = false;
        return getNumericIfUnitless(res);
    };
    /**
   * Return the numeric value of this unit if it is dimensionless, has a value, and config.predictable == false; or the original unit otherwise
   * @param {Unit} unit
   * @returns {number | Fraction | BigNumber | Unit}  The numeric value of the unit if conditions are met, or the original unit otherwise
   */ function getNumericIfUnitless(unit) {
        if (unit.equalBase(BASE_UNITS.NONE) && unit.value !== null && !config.predictable) return unit.value;
        else return unit;
    }
    /**
   * Calculate the absolute value of a unit
   * @memberof Unit
   * @param {number | Fraction | BigNumber} x
   * @returns {Unit}      The result: |x|, absolute value of x
   */ Unit.prototype.abs = function() {
        // This gives correct, but unexpected, results for units with an offset.
        // For example, abs(-283.15 degC) = -263.15 degC !!!
        var ret = this.clone();
        ret.value = ret.value !== null ? abs(ret.value) : null;
        for(var i in ret.units)if (ret.units[i].unit.name === "VA" || ret.units[i].unit.name === "VAR") ret.units[i].unit = UNITS.W;
        return ret;
    };
    /**
   * Convert the unit to a specific unit name.
   * @memberof Unit
   * @param {string | Unit} valuelessUnit   A unit without value. Can have prefix, like "cm"
   * @returns {Unit} Returns a clone of the unit with a fixed prefix and unit.
   */ Unit.prototype.to = function(valuelessUnit) {
        var other;
        var value = this.value === null ? this._normalize(1) : this.value;
        if (typeof valuelessUnit === "string") {
            // other = new Unit(null, valuelessUnit)
            other = Unit.parse(valuelessUnit);
            if (!this.equalBase(other)) throw new Error("Units do not match ('".concat(other.toString(), "' != '").concat(this.toString(), "')"));
            if (other.value !== null) throw new Error("Cannot convert to a unit with a value");
            other.value = (0, $7ITGG.clone)(value);
            other.fixPrefix = true;
            other.skipAutomaticSimplification = true;
            return other;
        } else if ((0, $1amHZ.isUnit)(valuelessUnit)) {
            if (!this.equalBase(valuelessUnit)) throw new Error("Units do not match ('".concat(valuelessUnit.toString(), "' != '").concat(this.toString(), "')"));
            if (valuelessUnit.value !== null) throw new Error("Cannot convert to a unit with a value");
            other = valuelessUnit.clone();
            other.value = (0, $7ITGG.clone)(value);
            other.fixPrefix = true;
            other.skipAutomaticSimplification = true;
            return other;
        } else throw new Error("String or Unit expected as parameter");
    };
    /**
   * Return the value of the unit when represented with given valueless unit
   * @memberof Unit
   * @param {string | Unit} valuelessUnit    For example 'cm' or 'inch'
   * @return {number} Returns the unit value as number.
   */ // TODO: deprecate Unit.toNumber? It's always better to use toNumeric
    Unit.prototype.toNumber = function(valuelessUnit) {
        return toNumber(this.toNumeric(valuelessUnit));
    };
    /**
   * Return the value of the unit in the original numeric type
   * @memberof Unit
   * @param {string | Unit} valuelessUnit    For example 'cm' or 'inch'
   * @return {number | BigNumber | Fraction} Returns the unit value
   */ Unit.prototype.toNumeric = function(valuelessUnit) {
        var other;
        if (valuelessUnit) // Allow getting the numeric value without converting to a different unit
        other = this.to(valuelessUnit);
        else other = this.clone();
        if (other._isDerived() || other.units.length === 0) return other._denormalize(other.value);
        else return other._denormalize(other.value, other.units[0].prefix.value);
    };
    /**
   * Get a string representation of the unit.
   * @memberof Unit
   * @return {string}
   */ Unit.prototype.toString = function() {
        return this.format();
    };
    /**
   * Get a JSON representation of the unit
   * @memberof Unit
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "Unit", "value": 2, "unit": "cm", "fixPrefix": false}`
   */ Unit.prototype.toJSON = function() {
        return {
            mathjs: "Unit",
            value: this._denormalize(this.value),
            unit: this.formatUnits(),
            fixPrefix: this.fixPrefix
        };
    };
    /**
   * Instantiate a Unit from a JSON object
   * @memberof Unit
   * @param {Object} json  A JSON object structured as:
   *                       `{"mathjs": "Unit", "value": 2, "unit": "cm", "fixPrefix": false}`
   * @return {Unit}
   */ Unit.fromJSON = function(json) {
        var unit = new Unit(json.value, json.unit);
        unit.fixPrefix = json.fixPrefix || false;
        return unit;
    };
    /**
   * Returns the string representation of the unit.
   * @memberof Unit
   * @return {string}
   */ Unit.prototype.valueOf = Unit.prototype.toString;
    /**
   * Simplify this Unit's unit list and return a new Unit with the simplified list.
   * The returned Unit will contain a list of the "best" units for formatting.
   */ Unit.prototype.simplify = function() {
        var ret = this.clone();
        var proposedUnitList = []; // Search for a matching base
        var matchingBase;
        for(var key in currentUnitSystem)if (ret.hasBase(BASE_UNITS[key])) {
            matchingBase = key;
            break;
        }
        if (matchingBase === "NONE") ret.units = [];
        else {
            var matchingUnit;
            if (matchingBase) // Does the unit system have a matching unit?
            {
                if ((0, $7ITGG.hasOwnProperty)(currentUnitSystem, matchingBase)) matchingUnit = currentUnitSystem[matchingBase];
            }
            if (matchingUnit) ret.units = [
                {
                    unit: matchingUnit.unit,
                    prefix: matchingUnit.prefix,
                    power: 1.0
                }
            ];
            else {
                // Multiple units or units with powers are formatted like this:
                // 5 (kg m^2) / (s^3 mol)
                // Build an representation from the base units of the current unit system
                var missingBaseDim = false;
                for(var i = 0; i < BASE_DIMENSIONS.length; i++){
                    var baseDim = BASE_DIMENSIONS[i];
                    if (Math.abs(ret.dimensions[i] || 0) > 1e-12) {
                        if ((0, $7ITGG.hasOwnProperty)(currentUnitSystem, baseDim)) proposedUnitList.push({
                            unit: currentUnitSystem[baseDim].unit,
                            prefix: currentUnitSystem[baseDim].prefix,
                            power: ret.dimensions[i] || 0
                        });
                        else missingBaseDim = true;
                    }
                } // Is the proposed unit list "simpler" than the existing one?
                if (proposedUnitList.length < ret.units.length && !missingBaseDim) // Replace this unit list with the proposed list
                ret.units = proposedUnitList;
            }
        }
        return ret;
    };
    /**
   * Returns a new Unit in the SI system with the same value as this one
   */ Unit.prototype.toSI = function() {
        var ret = this.clone();
        var proposedUnitList = []; // Multiple units or units with powers are formatted like this:
        // 5 (kg m^2) / (s^3 mol)
        // Build an representation from the base units of the SI unit system
        for(var i = 0; i < BASE_DIMENSIONS.length; i++){
            var baseDim = BASE_DIMENSIONS[i];
            if (Math.abs(ret.dimensions[i] || 0) > 1e-12) {
                if ((0, $7ITGG.hasOwnProperty)(UNIT_SYSTEMS.si, baseDim)) proposedUnitList.push({
                    unit: UNIT_SYSTEMS.si[baseDim].unit,
                    prefix: UNIT_SYSTEMS.si[baseDim].prefix,
                    power: ret.dimensions[i] || 0
                });
                else throw new Error("Cannot express custom unit " + baseDim + " in SI units");
            }
        } // Replace this unit list with the proposed list
        ret.units = proposedUnitList;
        ret.fixPrefix = true;
        ret.skipAutomaticSimplification = true;
        return ret;
    };
    /**
   * Get a string representation of the units of this Unit, without the value. The unit list is formatted as-is without first being simplified.
   * @memberof Unit
   * @return {string}
   */ Unit.prototype.formatUnits = function() {
        var strNum = "";
        var strDen = "";
        var nNum = 0;
        var nDen = 0;
        for(var i = 0; i < this.units.length; i++){
            if (this.units[i].power > 0) {
                nNum++;
                strNum += " " + this.units[i].prefix.name + this.units[i].unit.name;
                if (Math.abs(this.units[i].power - 1.0) > 1e-15) strNum += "^" + this.units[i].power;
            } else if (this.units[i].power < 0) nDen++;
        }
        if (nDen > 0) {
            for(var _i4 = 0; _i4 < this.units.length; _i4++)if (this.units[_i4].power < 0) {
                if (nNum > 0) {
                    strDen += " " + this.units[_i4].prefix.name + this.units[_i4].unit.name;
                    if (Math.abs(this.units[_i4].power + 1.0) > 1e-15) strDen += "^" + -this.units[_i4].power;
                } else {
                    strDen += " " + this.units[_i4].prefix.name + this.units[_i4].unit.name;
                    strDen += "^" + this.units[_i4].power;
                }
            }
        } // Remove leading " "
        strNum = strNum.substr(1);
        strDen = strDen.substr(1); // Add parans for better copy/paste back into evaluate, for example, or for better pretty print formatting
        if (nNum > 1 && nDen > 0) strNum = "(" + strNum + ")";
        if (nDen > 1 && nNum > 0) strDen = "(" + strDen + ")";
        var str = strNum;
        if (nNum > 0 && nDen > 0) str += " / ";
        str += strDen;
        return str;
    };
    /**
   * Get a string representation of the Unit, with optional formatting options.
   * @memberof Unit
   * @param {Object | number | Function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @return {string}
   */ Unit.prototype.format = function(options) {
        // Simplfy the unit list, unless it is valueless or was created directly in the
        // constructor or as the result of to or toSI
        var simp = this.skipAutomaticSimplification || this.value === null ? this.clone() : this.simplify(); // Apply some custom logic for handling VA and VAR. The goal is to express the value of the unit as a real value, if possible. Otherwise, use a real-valued unit instead of a complex-valued one.
        var isImaginary = false;
        if (typeof simp.value !== "undefined" && simp.value !== null && (0, $1amHZ.isComplex)(simp.value)) // TODO: Make this better, for example, use relative magnitude of re and im rather than absolute
        isImaginary = Math.abs(simp.value.re) < 1e-14;
        for(var i in simp.units)if (simp.units[i].unit) {
            if (simp.units[i].unit.name === "VA" && isImaginary) simp.units[i].unit = UNITS.VAR;
            else if (simp.units[i].unit.name === "VAR" && !isImaginary) simp.units[i].unit = UNITS.VA;
        }
         // Now apply the best prefix
        // Units must have only one unit and not have the fixPrefix flag set
        if (simp.units.length === 1 && !simp.fixPrefix) // Units must have integer powers, otherwise the prefix will change the
        // outputted value by not-an-integer-power-of-ten
        {
            if (Math.abs(simp.units[0].power - Math.round(simp.units[0].power)) < 1e-14) // Apply the best prefix
            simp.units[0].prefix = simp._bestPrefix();
        }
        var value = simp._denormalize(simp.value);
        var str = simp.value !== null ? format(value, options || {}) : "";
        var unitStr = simp.formatUnits();
        if (simp.value && (0, $1amHZ.isComplex)(simp.value)) str = "(" + str + ")"; // Surround complex values with ( ) to enable better parsing
        if (unitStr.length > 0 && str.length > 0) str += " ";
        str += unitStr;
        return str;
    };
    /**
   * Calculate the best prefix using current value.
   * @memberof Unit
   * @returns {Object} prefix
   * @private
   */ Unit.prototype._bestPrefix = function() {
        if (this.units.length !== 1) throw new Error("Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!");
        if (Math.abs(this.units[0].power - Math.round(this.units[0].power)) >= 1e-14) throw new Error("Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!");
         // find the best prefix value (resulting in the value of which
        // the absolute value of the log10 is closest to zero,
        // though with a little offset of 1.2 for nicer values: you get a
        // sequence 1mm 100mm 500mm 0.6m 1m 10m 100m 500m 0.6km 1km ...
        // Note: the units value can be any numeric type, but to find the best
        // prefix it's enough to work with limited precision of a regular number
        // Update: using mathjs abs since we also allow complex numbers
        var absValue = this.value !== null ? abs(this.value) : 0;
        var absUnitValue = abs(this.units[0].unit.value);
        var bestPrefix = this.units[0].prefix;
        if (absValue === 0) return bestPrefix;
        var power = this.units[0].power;
        var bestDiff = Math.log(absValue / Math.pow(bestPrefix.value * absUnitValue, power)) / Math.LN10 - 1.2;
        if (bestDiff > -2.200001 && bestDiff < 1.800001) return bestPrefix; // Allow the original prefix
        bestDiff = Math.abs(bestDiff);
        var prefixes = this.units[0].unit.prefixes;
        for(var p in prefixes)if ((0, $7ITGG.hasOwnProperty)(prefixes, p)) {
            var prefix = prefixes[p];
            if (prefix.scientific) {
                var diff = Math.abs(Math.log(absValue / Math.pow(prefix.value * absUnitValue, power)) / Math.LN10 - 1.2);
                if (diff < bestDiff || diff === bestDiff && prefix.name.length < bestPrefix.name.length) {
                    // choose the prefix with the smallest diff, or if equal, choose the one
                    // with the shortest name (can happen with SHORTLONG for example)
                    bestPrefix = prefix;
                    bestDiff = diff;
                }
            }
        }
        return bestPrefix;
    };
    /**
   * Returns an array of units whose sum is equal to this unit
   * @memberof Unit
   * @param {Array} [parts] An array of strings or valueless units.
   *
   *   Example:
   *
   *   const u = new Unit(1, 'm')
   *   u.splitUnit(['feet', 'inch'])
   *     [ 3 feet, 3.3700787401575 inch ]
   *
   * @return {Array} An array of units.
   */ Unit.prototype.splitUnit = function(parts) {
        var x = this.clone();
        var ret = [];
        for(var i = 0; i < parts.length; i++){
            // Convert x to the requested unit
            x = x.to(parts[i]);
            if (i === parts.length - 1) break; // Get the numeric value of this unit
            var xNumeric = x.toNumeric(); // Check to see if xNumeric is nearly equal to an integer,
            // since fix can incorrectly round down if there is round-off error
            var xRounded = round(xNumeric);
            var xFixed = void 0;
            var isNearlyEqual = equal(xRounded, xNumeric);
            if (isNearlyEqual) xFixed = xRounded;
            else xFixed = fix(x.toNumeric());
            var y = new Unit(xFixed, parts[i].toString());
            ret.push(y);
            x = subtract(x, y);
        } // This little bit fixes a bug where the remainder should be 0 but is a little bit off.
        // But instead of comparing x, the remainder, with zero--we will compare the sum of
        // all the parts so far with the original value. If they are nearly equal,
        // we set the remainder to 0.
        var testSum = 0;
        for(var _i5 = 0; _i5 < ret.length; _i5++)testSum = addScalar(testSum, ret[_i5].value);
        if (equal(testSum, this.value)) x.value = 0;
        ret.push(x);
        return ret;
    };
    var PREFIXES = {
        NONE: {
            "": {
                name: "",
                value: 1,
                scientific: true
            }
        },
        SHORT: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            da: {
                name: "da",
                value: 1e1,
                scientific: false
            },
            h: {
                name: "h",
                value: 1e2,
                scientific: false
            },
            k: {
                name: "k",
                value: 1e3,
                scientific: true
            },
            M: {
                name: "M",
                value: 1e6,
                scientific: true
            },
            G: {
                name: "G",
                value: 1e9,
                scientific: true
            },
            T: {
                name: "T",
                value: 1e12,
                scientific: true
            },
            P: {
                name: "P",
                value: 1e15,
                scientific: true
            },
            E: {
                name: "E",
                value: 1e18,
                scientific: true
            },
            Z: {
                name: "Z",
                value: 1e21,
                scientific: true
            },
            Y: {
                name: "Y",
                value: 1e24,
                scientific: true
            },
            d: {
                name: "d",
                value: 1e-1,
                scientific: false
            },
            c: {
                name: "c",
                value: 1e-2,
                scientific: false
            },
            m: {
                name: "m",
                value: 1e-3,
                scientific: true
            },
            u: {
                name: "u",
                value: 1e-6,
                scientific: true
            },
            n: {
                name: "n",
                value: 1e-9,
                scientific: true
            },
            p: {
                name: "p",
                value: 1e-12,
                scientific: true
            },
            f: {
                name: "f",
                value: 1e-15,
                scientific: true
            },
            a: {
                name: "a",
                value: 1e-18,
                scientific: true
            },
            z: {
                name: "z",
                value: 1e-21,
                scientific: true
            },
            y: {
                name: "y",
                value: 1e-24,
                scientific: true
            }
        },
        LONG: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            deca: {
                name: "deca",
                value: 1e1,
                scientific: false
            },
            hecto: {
                name: "hecto",
                value: 1e2,
                scientific: false
            },
            kilo: {
                name: "kilo",
                value: 1e3,
                scientific: true
            },
            mega: {
                name: "mega",
                value: 1e6,
                scientific: true
            },
            giga: {
                name: "giga",
                value: 1e9,
                scientific: true
            },
            tera: {
                name: "tera",
                value: 1e12,
                scientific: true
            },
            peta: {
                name: "peta",
                value: 1e15,
                scientific: true
            },
            exa: {
                name: "exa",
                value: 1e18,
                scientific: true
            },
            zetta: {
                name: "zetta",
                value: 1e21,
                scientific: true
            },
            yotta: {
                name: "yotta",
                value: 1e24,
                scientific: true
            },
            deci: {
                name: "deci",
                value: 1e-1,
                scientific: false
            },
            centi: {
                name: "centi",
                value: 1e-2,
                scientific: false
            },
            milli: {
                name: "milli",
                value: 1e-3,
                scientific: true
            },
            micro: {
                name: "micro",
                value: 1e-6,
                scientific: true
            },
            nano: {
                name: "nano",
                value: 1e-9,
                scientific: true
            },
            pico: {
                name: "pico",
                value: 1e-12,
                scientific: true
            },
            femto: {
                name: "femto",
                value: 1e-15,
                scientific: true
            },
            atto: {
                name: "atto",
                value: 1e-18,
                scientific: true
            },
            zepto: {
                name: "zepto",
                value: 1e-21,
                scientific: true
            },
            yocto: {
                name: "yocto",
                value: 1e-24,
                scientific: true
            }
        },
        SQUARED: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            da: {
                name: "da",
                value: 1e2,
                scientific: false
            },
            h: {
                name: "h",
                value: 1e4,
                scientific: false
            },
            k: {
                name: "k",
                value: 1e6,
                scientific: true
            },
            M: {
                name: "M",
                value: 1e12,
                scientific: true
            },
            G: {
                name: "G",
                value: 1e18,
                scientific: true
            },
            T: {
                name: "T",
                value: 1e24,
                scientific: true
            },
            P: {
                name: "P",
                value: 1e30,
                scientific: true
            },
            E: {
                name: "E",
                value: 1e36,
                scientific: true
            },
            Z: {
                name: "Z",
                value: 1e42,
                scientific: true
            },
            Y: {
                name: "Y",
                value: 1e48,
                scientific: true
            },
            d: {
                name: "d",
                value: 1e-2,
                scientific: false
            },
            c: {
                name: "c",
                value: 1e-4,
                scientific: false
            },
            m: {
                name: "m",
                value: 1e-6,
                scientific: true
            },
            u: {
                name: "u",
                value: 1e-12,
                scientific: true
            },
            n: {
                name: "n",
                value: 1e-18,
                scientific: true
            },
            p: {
                name: "p",
                value: 1e-24,
                scientific: true
            },
            f: {
                name: "f",
                value: 1e-30,
                scientific: true
            },
            a: {
                name: "a",
                value: 1e-36,
                scientific: true
            },
            z: {
                name: "z",
                value: 1e-42,
                scientific: true
            },
            y: {
                name: "y",
                value: 1e-48,
                scientific: true
            }
        },
        CUBIC: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            da: {
                name: "da",
                value: 1e3,
                scientific: false
            },
            h: {
                name: "h",
                value: 1e6,
                scientific: false
            },
            k: {
                name: "k",
                value: 1e9,
                scientific: true
            },
            M: {
                name: "M",
                value: 1e18,
                scientific: true
            },
            G: {
                name: "G",
                value: 1e27,
                scientific: true
            },
            T: {
                name: "T",
                value: 1e36,
                scientific: true
            },
            P: {
                name: "P",
                value: 1e45,
                scientific: true
            },
            E: {
                name: "E",
                value: 1e54,
                scientific: true
            },
            Z: {
                name: "Z",
                value: 1e63,
                scientific: true
            },
            Y: {
                name: "Y",
                value: 1e72,
                scientific: true
            },
            d: {
                name: "d",
                value: 1e-3,
                scientific: false
            },
            c: {
                name: "c",
                value: 1e-6,
                scientific: false
            },
            m: {
                name: "m",
                value: 1e-9,
                scientific: true
            },
            u: {
                name: "u",
                value: 1e-18,
                scientific: true
            },
            n: {
                name: "n",
                value: 1e-27,
                scientific: true
            },
            p: {
                name: "p",
                value: 1e-36,
                scientific: true
            },
            f: {
                name: "f",
                value: 1e-45,
                scientific: true
            },
            a: {
                name: "a",
                value: 1e-54,
                scientific: true
            },
            z: {
                name: "z",
                value: 1e-63,
                scientific: true
            },
            y: {
                name: "y",
                value: 1e-72,
                scientific: true
            }
        },
        BINARY_SHORT_SI: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            k: {
                name: "k",
                value: 1e3,
                scientific: true
            },
            M: {
                name: "M",
                value: 1e6,
                scientific: true
            },
            G: {
                name: "G",
                value: 1e9,
                scientific: true
            },
            T: {
                name: "T",
                value: 1e12,
                scientific: true
            },
            P: {
                name: "P",
                value: 1e15,
                scientific: true
            },
            E: {
                name: "E",
                value: 1e18,
                scientific: true
            },
            Z: {
                name: "Z",
                value: 1e21,
                scientific: true
            },
            Y: {
                name: "Y",
                value: 1e24,
                scientific: true
            }
        },
        BINARY_SHORT_IEC: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            Ki: {
                name: "Ki",
                value: 1024,
                scientific: true
            },
            Mi: {
                name: "Mi",
                value: Math.pow(1024, 2),
                scientific: true
            },
            Gi: {
                name: "Gi",
                value: Math.pow(1024, 3),
                scientific: true
            },
            Ti: {
                name: "Ti",
                value: Math.pow(1024, 4),
                scientific: true
            },
            Pi: {
                name: "Pi",
                value: Math.pow(1024, 5),
                scientific: true
            },
            Ei: {
                name: "Ei",
                value: Math.pow(1024, 6),
                scientific: true
            },
            Zi: {
                name: "Zi",
                value: Math.pow(1024, 7),
                scientific: true
            },
            Yi: {
                name: "Yi",
                value: Math.pow(1024, 8),
                scientific: true
            }
        },
        BINARY_LONG_SI: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            kilo: {
                name: "kilo",
                value: 1e3,
                scientific: true
            },
            mega: {
                name: "mega",
                value: 1e6,
                scientific: true
            },
            giga: {
                name: "giga",
                value: 1e9,
                scientific: true
            },
            tera: {
                name: "tera",
                value: 1e12,
                scientific: true
            },
            peta: {
                name: "peta",
                value: 1e15,
                scientific: true
            },
            exa: {
                name: "exa",
                value: 1e18,
                scientific: true
            },
            zetta: {
                name: "zetta",
                value: 1e21,
                scientific: true
            },
            yotta: {
                name: "yotta",
                value: 1e24,
                scientific: true
            }
        },
        BINARY_LONG_IEC: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            kibi: {
                name: "kibi",
                value: 1024,
                scientific: true
            },
            mebi: {
                name: "mebi",
                value: Math.pow(1024, 2),
                scientific: true
            },
            gibi: {
                name: "gibi",
                value: Math.pow(1024, 3),
                scientific: true
            },
            tebi: {
                name: "tebi",
                value: Math.pow(1024, 4),
                scientific: true
            },
            pebi: {
                name: "pebi",
                value: Math.pow(1024, 5),
                scientific: true
            },
            exi: {
                name: "exi",
                value: Math.pow(1024, 6),
                scientific: true
            },
            zebi: {
                name: "zebi",
                value: Math.pow(1024, 7),
                scientific: true
            },
            yobi: {
                name: "yobi",
                value: Math.pow(1024, 8),
                scientific: true
            }
        },
        BTU: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            MM: {
                name: "MM",
                value: 1e6,
                scientific: true
            }
        }
    };
    PREFIXES.SHORTLONG = $dc04440ac59b18c7$var$_extends({}, PREFIXES.SHORT, PREFIXES.LONG);
    PREFIXES.BINARY_SHORT = $dc04440ac59b18c7$var$_extends({}, PREFIXES.BINARY_SHORT_SI, PREFIXES.BINARY_SHORT_IEC);
    PREFIXES.BINARY_LONG = $dc04440ac59b18c7$var$_extends({}, PREFIXES.BINARY_LONG_SI, PREFIXES.BINARY_LONG_IEC);
    /* Internally, each unit is represented by a value and a dimension array. The elements of the dimensions array have the following meaning:
   * Index  Dimension
   * -----  ---------
   *   0    Length
   *   1    Mass
   *   2    Time
   *   3    Current
   *   4    Temperature
   *   5    Luminous intensity
   *   6    Amount of substance
   *   7    Angle
   *   8    Bit (digital)
   * For example, the unit "298.15 K" is a pure temperature and would have a value of 298.15 and a dimension array of [0, 0, 0, 0, 1, 0, 0, 0, 0]. The unit "1 cal / (gm °C)" can be written in terms of the 9 fundamental dimensions as [length^2] / ([time^2] * [temperature]), and would a value of (after conversion to SI) 4184.0 and a dimensions array of [2, 0, -2, 0, -1, 0, 0, 0, 0].
   *
   */ var BASE_DIMENSIONS = [
        "MASS",
        "LENGTH",
        "TIME",
        "CURRENT",
        "TEMPERATURE",
        "LUMINOUS_INTENSITY",
        "AMOUNT_OF_SUBSTANCE",
        "ANGLE",
        "BIT"
    ];
    var BASE_UNITS = {
        NONE: {
            dimensions: [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        MASS: {
            dimensions: [
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        LENGTH: {
            dimensions: [
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        TIME: {
            dimensions: [
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        CURRENT: {
            dimensions: [
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0
            ]
        },
        TEMPERATURE: {
            dimensions: [
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0
            ]
        },
        LUMINOUS_INTENSITY: {
            dimensions: [
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0
            ]
        },
        AMOUNT_OF_SUBSTANCE: {
            dimensions: [
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0
            ]
        },
        FORCE: {
            dimensions: [
                1,
                1,
                -2,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        SURFACE: {
            dimensions: [
                0,
                2,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        VOLUME: {
            dimensions: [
                0,
                3,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ENERGY: {
            dimensions: [
                1,
                2,
                -2,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        POWER: {
            dimensions: [
                1,
                2,
                -3,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        PRESSURE: {
            dimensions: [
                1,
                -1,
                -2,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_CHARGE: {
            dimensions: [
                0,
                0,
                1,
                1,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_CAPACITANCE: {
            dimensions: [
                -1,
                -2,
                4,
                2,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_POTENTIAL: {
            dimensions: [
                1,
                2,
                -3,
                -1,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_RESISTANCE: {
            dimensions: [
                1,
                2,
                -3,
                -2,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_INDUCTANCE: {
            dimensions: [
                1,
                2,
                -2,
                -2,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_CONDUCTANCE: {
            dimensions: [
                -1,
                -2,
                3,
                2,
                0,
                0,
                0,
                0,
                0
            ]
        },
        MAGNETIC_FLUX: {
            dimensions: [
                1,
                2,
                -2,
                -1,
                0,
                0,
                0,
                0,
                0
            ]
        },
        MAGNETIC_FLUX_DENSITY: {
            dimensions: [
                1,
                0,
                -2,
                -1,
                0,
                0,
                0,
                0,
                0
            ]
        },
        FREQUENCY: {
            dimensions: [
                0,
                0,
                -1,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ANGLE: {
            dimensions: [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0
            ]
        },
        BIT: {
            dimensions: [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1
            ]
        }
    };
    for(var key in BASE_UNITS)BASE_UNITS[key].key = key;
    var BASE_UNIT_NONE = {};
    var UNIT_NONE = {
        name: "",
        base: BASE_UNIT_NONE,
        value: 1,
        offset: 0,
        dimensions: BASE_DIMENSIONS.map(function(x) {
            return 0;
        })
    };
    var UNITS = {
        // length
        meter: {
            name: "meter",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        inch: {
            name: "inch",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.0254,
            offset: 0
        },
        foot: {
            name: "foot",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.3048,
            offset: 0
        },
        yard: {
            name: "yard",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.9144,
            offset: 0
        },
        mile: {
            name: "mile",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 1609.344,
            offset: 0
        },
        link: {
            name: "link",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.201168,
            offset: 0
        },
        rod: {
            name: "rod",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 5.0292,
            offset: 0
        },
        chain: {
            name: "chain",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 20.1168,
            offset: 0
        },
        angstrom: {
            name: "angstrom",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 1e-10,
            offset: 0
        },
        m: {
            name: "m",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        "in": {
            name: "in",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.0254,
            offset: 0
        },
        ft: {
            name: "ft",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.3048,
            offset: 0
        },
        yd: {
            name: "yd",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.9144,
            offset: 0
        },
        mi: {
            name: "mi",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 1609.344,
            offset: 0
        },
        li: {
            name: "li",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.201168,
            offset: 0
        },
        rd: {
            name: "rd",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 5.029210,
            offset: 0
        },
        ch: {
            name: "ch",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 20.1168,
            offset: 0
        },
        mil: {
            name: "mil",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.0000254,
            offset: 0
        },
        // 1/1000 inch
        // Surface
        m2: {
            name: "m2",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.SQUARED,
            value: 1,
            offset: 0
        },
        sqin: {
            name: "sqin",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 0.00064516,
            offset: 0
        },
        // 645.16 mm2
        sqft: {
            name: "sqft",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 0.09290304,
            offset: 0
        },
        // 0.09290304 m2
        sqyd: {
            name: "sqyd",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 0.83612736,
            offset: 0
        },
        // 0.83612736 m2
        sqmi: {
            name: "sqmi",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 2589988.110336,
            offset: 0
        },
        // 2.589988110336 km2
        sqrd: {
            name: "sqrd",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 25.29295,
            offset: 0
        },
        // 25.29295 m2
        sqch: {
            name: "sqch",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 404.6873,
            offset: 0
        },
        // 404.6873 m2
        sqmil: {
            name: "sqmil",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 6.4516e-10,
            offset: 0
        },
        // 6.4516 * 10^-10 m2
        acre: {
            name: "acre",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 4046.86,
            offset: 0
        },
        // 4046.86 m2
        hectare: {
            name: "hectare",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 10000,
            offset: 0
        },
        // 10000 m2
        // Volume
        m3: {
            name: "m3",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.CUBIC,
            value: 1,
            offset: 0
        },
        L: {
            name: "L",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.SHORT,
            value: 0.001,
            offset: 0
        },
        // litre
        l: {
            name: "l",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.SHORT,
            value: 0.001,
            offset: 0
        },
        // litre
        litre: {
            name: "litre",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.LONG,
            value: 0.001,
            offset: 0
        },
        cuin: {
            name: "cuin",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 1.6387064e-5,
            offset: 0
        },
        // 1.6387064e-5 m3
        cuft: {
            name: "cuft",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.028316846592,
            offset: 0
        },
        // 28.316 846 592 L
        cuyd: {
            name: "cuyd",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.764554857984,
            offset: 0
        },
        // 764.554 857 984 L
        teaspoon: {
            name: "teaspoon",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.000005,
            offset: 0
        },
        // 5 mL
        tablespoon: {
            name: "tablespoon",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.000015,
            offset: 0
        },
        // 15 mL
        // {name: 'cup', base: BASE_UNITS.VOLUME, prefixes: PREFIXES.NONE, value: 0.000240, offset: 0}, // 240 mL  // not possible, we have already another cup
        drop: {
            name: "drop",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 5e-8,
            offset: 0
        },
        // 0.05 mL = 5e-8 m3
        gtt: {
            name: "gtt",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 5e-8,
            offset: 0
        },
        // 0.05 mL = 5e-8 m3
        // Liquid volume
        minim: {
            name: "minim",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.00000006161152,
            offset: 0
        },
        // 0.06161152 mL
        fluiddram: {
            name: "fluiddram",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0000036966911,
            offset: 0
        },
        // 3.696691 mL
        fluidounce: {
            name: "fluidounce",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.00002957353,
            offset: 0
        },
        // 29.57353 mL
        gill: {
            name: "gill",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0001182941,
            offset: 0
        },
        // 118.2941 mL
        cc: {
            name: "cc",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 1e-6,
            offset: 0
        },
        // 1e-6 L
        cup: {
            name: "cup",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0002365882,
            offset: 0
        },
        // 236.5882 mL
        pint: {
            name: "pint",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0004731765,
            offset: 0
        },
        // 473.1765 mL
        quart: {
            name: "quart",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0009463529,
            offset: 0
        },
        // 946.3529 mL
        gallon: {
            name: "gallon",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.003785412,
            offset: 0
        },
        // 3.785412 L
        beerbarrel: {
            name: "beerbarrel",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.1173478,
            offset: 0
        },
        // 117.3478 L
        oilbarrel: {
            name: "oilbarrel",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.1589873,
            offset: 0
        },
        // 158.9873 L
        hogshead: {
            name: "hogshead",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.2384810,
            offset: 0
        },
        // 238.4810 L
        // {name: 'min', base: BASE_UNITS.VOLUME, prefixes: PREFIXES.NONE, value: 0.00000006161152, offset: 0}, // 0.06161152 mL // min is already in use as minute
        fldr: {
            name: "fldr",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0000036966911,
            offset: 0
        },
        // 3.696691 mL
        floz: {
            name: "floz",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.00002957353,
            offset: 0
        },
        // 29.57353 mL
        gi: {
            name: "gi",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0001182941,
            offset: 0
        },
        // 118.2941 mL
        cp: {
            name: "cp",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0002365882,
            offset: 0
        },
        // 236.5882 mL
        pt: {
            name: "pt",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0004731765,
            offset: 0
        },
        // 473.1765 mL
        qt: {
            name: "qt",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0009463529,
            offset: 0
        },
        // 946.3529 mL
        gal: {
            name: "gal",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.003785412,
            offset: 0
        },
        // 3.785412 L
        bbl: {
            name: "bbl",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.1173478,
            offset: 0
        },
        // 117.3478 L
        obl: {
            name: "obl",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.1589873,
            offset: 0
        },
        // 158.9873 L
        // {name: 'hogshead', base: BASE_UNITS.VOLUME, prefixes: PREFIXES.NONE, value: 0.2384810, offset: 0}, // 238.4810 L // TODO: hh?
        // Mass
        g: {
            name: "g",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.SHORT,
            value: 0.001,
            offset: 0
        },
        gram: {
            name: "gram",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.LONG,
            value: 0.001,
            offset: 0
        },
        ton: {
            name: "ton",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.SHORT,
            value: 907.18474,
            offset: 0
        },
        t: {
            name: "t",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.SHORT,
            value: 1000,
            offset: 0
        },
        tonne: {
            name: "tonne",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.LONG,
            value: 1000,
            offset: 0
        },
        grain: {
            name: "grain",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 64.79891e-6,
            offset: 0
        },
        dram: {
            name: "dram",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 1.7718451953125e-3,
            offset: 0
        },
        ounce: {
            name: "ounce",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 28.349523125e-3,
            offset: 0
        },
        poundmass: {
            name: "poundmass",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 453.59237e-3,
            offset: 0
        },
        hundredweight: {
            name: "hundredweight",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 45.359237,
            offset: 0
        },
        stick: {
            name: "stick",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 115e-3,
            offset: 0
        },
        stone: {
            name: "stone",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 6.35029318,
            offset: 0
        },
        gr: {
            name: "gr",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 64.79891e-6,
            offset: 0
        },
        dr: {
            name: "dr",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 1.7718451953125e-3,
            offset: 0
        },
        oz: {
            name: "oz",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 28.349523125e-3,
            offset: 0
        },
        lbm: {
            name: "lbm",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 453.59237e-3,
            offset: 0
        },
        cwt: {
            name: "cwt",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 45.359237,
            offset: 0
        },
        // Time
        s: {
            name: "s",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        min: {
            name: "min",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 60,
            offset: 0
        },
        h: {
            name: "h",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 3600,
            offset: 0
        },
        second: {
            name: "second",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        sec: {
            name: "sec",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        minute: {
            name: "minute",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 60,
            offset: 0
        },
        hour: {
            name: "hour",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 3600,
            offset: 0
        },
        day: {
            name: "day",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 86400,
            offset: 0
        },
        week: {
            name: "week",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 604800,
            offset: 0
        },
        month: {
            name: "month",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 2629800,
            // 1/12th of Julian year
            offset: 0
        },
        year: {
            name: "year",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 31557600,
            // Julian year
            offset: 0
        },
        decade: {
            name: "decade",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 315576000,
            // Julian decade
            offset: 0
        },
        century: {
            name: "century",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 3155760000,
            // Julian century
            offset: 0
        },
        millennium: {
            name: "millennium",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 31557600000,
            // Julian millennium
            offset: 0
        },
        // Frequency
        hertz: {
            name: "Hertz",
            base: BASE_UNITS.FREQUENCY,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0,
            reciprocal: true
        },
        Hz: {
            name: "Hz",
            base: BASE_UNITS.FREQUENCY,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0,
            reciprocal: true
        },
        // Angle
        rad: {
            name: "rad",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        radian: {
            name: "radian",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        // deg = rad / (2*pi) * 360 = rad / 0.017453292519943295769236907684888
        deg: {
            name: "deg",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.SHORT,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        degree: {
            name: "degree",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.LONG,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        // grad = rad / (2*pi) * 400  = rad / 0.015707963267948966192313216916399
        grad: {
            name: "grad",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.SHORT,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        gradian: {
            name: "gradian",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.LONG,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        // cycle = rad / (2*pi) = rad / 6.2831853071795864769252867665793
        cycle: {
            name: "cycle",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.NONE,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        // arcsec = rad / (3600 * (360 / 2 * pi)) = rad / 0.0000048481368110953599358991410235795
        arcsec: {
            name: "arcsec",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.NONE,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        // arcmin = rad / (60 * (360 / 2 * pi)) = rad / 0.00029088820866572159615394846141477
        arcmin: {
            name: "arcmin",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.NONE,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        // Electric current
        A: {
            name: "A",
            base: BASE_UNITS.CURRENT,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        ampere: {
            name: "ampere",
            base: BASE_UNITS.CURRENT,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        // Temperature
        // K(C) = °C + 273.15
        // K(F) = (°F + 459.67) / 1.8
        // K(R) = °R / 1.8
        K: {
            name: "K",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1,
            offset: 0
        },
        degC: {
            name: "degC",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1,
            offset: 273.15
        },
        degF: {
            name: "degF",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1 / 1.8,
            offset: 459.67
        },
        degR: {
            name: "degR",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1 / 1.8,
            offset: 0
        },
        kelvin: {
            name: "kelvin",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1,
            offset: 0
        },
        celsius: {
            name: "celsius",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1,
            offset: 273.15
        },
        fahrenheit: {
            name: "fahrenheit",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1 / 1.8,
            offset: 459.67
        },
        rankine: {
            name: "rankine",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1 / 1.8,
            offset: 0
        },
        // amount of substance
        mol: {
            name: "mol",
            base: BASE_UNITS.AMOUNT_OF_SUBSTANCE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        mole: {
            name: "mole",
            base: BASE_UNITS.AMOUNT_OF_SUBSTANCE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        // luminous intensity
        cd: {
            name: "cd",
            base: BASE_UNITS.LUMINOUS_INTENSITY,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        candela: {
            name: "candela",
            base: BASE_UNITS.LUMINOUS_INTENSITY,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        // TODO: units STERADIAN
        // {name: 'sr', base: BASE_UNITS.STERADIAN, prefixes: PREFIXES.NONE, value: 1, offset: 0},
        // {name: 'steradian', base: BASE_UNITS.STERADIAN, prefixes: PREFIXES.NONE, value: 1, offset: 0},
        // Force
        N: {
            name: "N",
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        newton: {
            name: "newton",
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        dyn: {
            name: "dyn",
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.SHORT,
            value: 0.00001,
            offset: 0
        },
        dyne: {
            name: "dyne",
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.LONG,
            value: 0.00001,
            offset: 0
        },
        lbf: {
            name: "lbf",
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.NONE,
            value: 4.4482216152605,
            offset: 0
        },
        poundforce: {
            name: "poundforce",
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.NONE,
            value: 4.4482216152605,
            offset: 0
        },
        kip: {
            name: "kip",
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.LONG,
            value: 4448.2216,
            offset: 0
        },
        // Energy
        J: {
            name: "J",
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        joule: {
            name: "joule",
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        erg: {
            name: "erg",
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.NONE,
            value: 1e-7,
            offset: 0
        },
        Wh: {
            name: "Wh",
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.SHORT,
            value: 3600,
            offset: 0
        },
        BTU: {
            name: "BTU",
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.BTU,
            value: 1055.05585262,
            offset: 0
        },
        eV: {
            name: "eV",
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.SHORT,
            value: 1.602176565e-19,
            offset: 0
        },
        electronvolt: {
            name: "electronvolt",
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.LONG,
            value: 1.602176565e-19,
            offset: 0
        },
        // Power
        W: {
            name: "W",
            base: BASE_UNITS.POWER,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        watt: {
            name: "watt",
            base: BASE_UNITS.POWER,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        hp: {
            name: "hp",
            base: BASE_UNITS.POWER,
            prefixes: PREFIXES.NONE,
            value: 745.6998715386,
            offset: 0
        },
        // Electrical power units
        VAR: {
            name: "VAR",
            base: BASE_UNITS.POWER,
            prefixes: PREFIXES.SHORT,
            value: Complex.I,
            offset: 0
        },
        VA: {
            name: "VA",
            base: BASE_UNITS.POWER,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Pressure
        Pa: {
            name: "Pa",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        psi: {
            name: "psi",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 6894.75729276459,
            offset: 0
        },
        atm: {
            name: "atm",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 101325,
            offset: 0
        },
        bar: {
            name: "bar",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.SHORTLONG,
            value: 100000,
            offset: 0
        },
        torr: {
            name: "torr",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 133.322,
            offset: 0
        },
        mmHg: {
            name: "mmHg",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 133.322,
            offset: 0
        },
        mmH2O: {
            name: "mmH2O",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 9.80665,
            offset: 0
        },
        cmH2O: {
            name: "cmH2O",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 98.0665,
            offset: 0
        },
        // Electric charge
        coulomb: {
            name: "coulomb",
            base: BASE_UNITS.ELECTRIC_CHARGE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        C: {
            name: "C",
            base: BASE_UNITS.ELECTRIC_CHARGE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Electric capacitance
        farad: {
            name: "farad",
            base: BASE_UNITS.ELECTRIC_CAPACITANCE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        F: {
            name: "F",
            base: BASE_UNITS.ELECTRIC_CAPACITANCE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Electric potential
        volt: {
            name: "volt",
            base: BASE_UNITS.ELECTRIC_POTENTIAL,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        V: {
            name: "V",
            base: BASE_UNITS.ELECTRIC_POTENTIAL,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Electric resistance
        ohm: {
            name: "ohm",
            base: BASE_UNITS.ELECTRIC_RESISTANCE,
            prefixes: PREFIXES.SHORTLONG,
            // Both Mohm and megaohm are acceptable
            value: 1,
            offset: 0
        },
        /*
     * Unicode breaks in browsers if charset is not specified
    Ω: {
      name: 'Ω',
      base: BASE_UNITS.ELECTRIC_RESISTANCE,
      prefixes: PREFIXES.SHORT,
      value: 1,
      offset: 0
    },
    */ // Electric inductance
        henry: {
            name: "henry",
            base: BASE_UNITS.ELECTRIC_INDUCTANCE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        H: {
            name: "H",
            base: BASE_UNITS.ELECTRIC_INDUCTANCE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Electric conductance
        siemens: {
            name: "siemens",
            base: BASE_UNITS.ELECTRIC_CONDUCTANCE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        S: {
            name: "S",
            base: BASE_UNITS.ELECTRIC_CONDUCTANCE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Magnetic flux
        weber: {
            name: "weber",
            base: BASE_UNITS.MAGNETIC_FLUX,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        Wb: {
            name: "Wb",
            base: BASE_UNITS.MAGNETIC_FLUX,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Magnetic flux density
        tesla: {
            name: "tesla",
            base: BASE_UNITS.MAGNETIC_FLUX_DENSITY,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        T: {
            name: "T",
            base: BASE_UNITS.MAGNETIC_FLUX_DENSITY,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Binary
        b: {
            name: "b",
            base: BASE_UNITS.BIT,
            prefixes: PREFIXES.BINARY_SHORT,
            value: 1,
            offset: 0
        },
        bits: {
            name: "bits",
            base: BASE_UNITS.BIT,
            prefixes: PREFIXES.BINARY_LONG,
            value: 1,
            offset: 0
        },
        B: {
            name: "B",
            base: BASE_UNITS.BIT,
            prefixes: PREFIXES.BINARY_SHORT,
            value: 8,
            offset: 0
        },
        bytes: {
            name: "bytes",
            base: BASE_UNITS.BIT,
            prefixes: PREFIXES.BINARY_LONG,
            value: 8,
            offset: 0
        }
    }; // aliases (formerly plurals)
    var ALIASES = {
        meters: "meter",
        inches: "inch",
        feet: "foot",
        yards: "yard",
        miles: "mile",
        links: "link",
        rods: "rod",
        chains: "chain",
        angstroms: "angstrom",
        lt: "l",
        litres: "litre",
        liter: "litre",
        liters: "litre",
        teaspoons: "teaspoon",
        tablespoons: "tablespoon",
        minims: "minim",
        fluiddrams: "fluiddram",
        fluidounces: "fluidounce",
        gills: "gill",
        cups: "cup",
        pints: "pint",
        quarts: "quart",
        gallons: "gallon",
        beerbarrels: "beerbarrel",
        oilbarrels: "oilbarrel",
        hogsheads: "hogshead",
        gtts: "gtt",
        grams: "gram",
        tons: "ton",
        tonnes: "tonne",
        grains: "grain",
        drams: "dram",
        ounces: "ounce",
        poundmasses: "poundmass",
        hundredweights: "hundredweight",
        sticks: "stick",
        lb: "lbm",
        lbs: "lbm",
        kips: "kip",
        acres: "acre",
        hectares: "hectare",
        sqfeet: "sqft",
        sqyard: "sqyd",
        sqmile: "sqmi",
        sqmiles: "sqmi",
        mmhg: "mmHg",
        mmh2o: "mmH2O",
        cmh2o: "cmH2O",
        seconds: "second",
        secs: "second",
        minutes: "minute",
        mins: "minute",
        hours: "hour",
        hr: "hour",
        hrs: "hour",
        days: "day",
        weeks: "week",
        months: "month",
        years: "year",
        decades: "decade",
        centuries: "century",
        millennia: "millennium",
        hertz: "hertz",
        radians: "radian",
        degrees: "degree",
        gradians: "gradian",
        cycles: "cycle",
        arcsecond: "arcsec",
        arcseconds: "arcsec",
        arcminute: "arcmin",
        arcminutes: "arcmin",
        BTUs: "BTU",
        watts: "watt",
        joules: "joule",
        amperes: "ampere",
        coulombs: "coulomb",
        volts: "volt",
        ohms: "ohm",
        farads: "farad",
        webers: "weber",
        teslas: "tesla",
        electronvolts: "electronvolt",
        moles: "mole",
        bit: "bits",
        "byte": "bytes"
    };
    /**
   * Calculate the values for the angle units.
   * Value is calculated as number or BigNumber depending on the configuration
   * @param {{number: 'number' | 'BigNumber'}} config
   */ function calculateAngleValues(config) {
        if (config.number === "BigNumber") {
            var pi = (0, $4zk7D.createBigNumberPi)(_BigNumber);
            UNITS.rad.value = new _BigNumber(1);
            UNITS.deg.value = pi.div(180); // 2 * pi / 360
            UNITS.grad.value = pi.div(200); // 2 * pi / 400
            UNITS.cycle.value = pi.times(2); // 2 * pi
            UNITS.arcsec.value = pi.div(648000); // 2 * pi / 360 / 3600
            UNITS.arcmin.value = pi.div(10800); // 2 * pi / 360 / 60
        } else {
            // number
            UNITS.rad.value = 1;
            UNITS.deg.value = Math.PI / 180; // 2 * pi / 360
            UNITS.grad.value = Math.PI / 200; // 2 * pi / 400
            UNITS.cycle.value = Math.PI * 2; // 2 * pi
            UNITS.arcsec.value = Math.PI / 648000; // 2 * pi / 360 / 3600
            UNITS.arcmin.value = Math.PI / 10800; // 2 * pi / 360 / 60
        } // copy to the full names of the angles
        UNITS.radian.value = UNITS.rad.value;
        UNITS.degree.value = UNITS.deg.value;
        UNITS.gradian.value = UNITS.grad.value;
    } // apply the angle values now
    calculateAngleValues(config);
    if (on) // recalculate the values on change of configuration
    on("config", function(curr, prev) {
        if (curr.number !== prev.number) calculateAngleValues(curr);
    });
    /**
   * A unit system is a set of dimensionally independent base units plus a set of derived units, formed by multiplication and division of the base units, that are by convention used with the unit system.
   * A user perhaps could issue a command to select a preferred unit system, or use the default (see below).
   * Auto unit system: The default unit system is updated on the fly anytime a unit is parsed. The corresponding unit in the default unit system is updated, so that answers are given in the same units the user supplies.
   */ var UNIT_SYSTEMS = {
        si: {
            // Base units
            NONE: {
                unit: UNIT_NONE,
                prefix: PREFIXES.NONE[""]
            },
            LENGTH: {
                unit: UNITS.m,
                prefix: PREFIXES.SHORT[""]
            },
            MASS: {
                unit: UNITS.g,
                prefix: PREFIXES.SHORT.k
            },
            TIME: {
                unit: UNITS.s,
                prefix: PREFIXES.SHORT[""]
            },
            CURRENT: {
                unit: UNITS.A,
                prefix: PREFIXES.SHORT[""]
            },
            TEMPERATURE: {
                unit: UNITS.K,
                prefix: PREFIXES.SHORT[""]
            },
            LUMINOUS_INTENSITY: {
                unit: UNITS.cd,
                prefix: PREFIXES.SHORT[""]
            },
            AMOUNT_OF_SUBSTANCE: {
                unit: UNITS.mol,
                prefix: PREFIXES.SHORT[""]
            },
            ANGLE: {
                unit: UNITS.rad,
                prefix: PREFIXES.SHORT[""]
            },
            BIT: {
                unit: UNITS.bits,
                prefix: PREFIXES.SHORT[""]
            },
            // Derived units
            FORCE: {
                unit: UNITS.N,
                prefix: PREFIXES.SHORT[""]
            },
            ENERGY: {
                unit: UNITS.J,
                prefix: PREFIXES.SHORT[""]
            },
            POWER: {
                unit: UNITS.W,
                prefix: PREFIXES.SHORT[""]
            },
            PRESSURE: {
                unit: UNITS.Pa,
                prefix: PREFIXES.SHORT[""]
            },
            ELECTRIC_CHARGE: {
                unit: UNITS.C,
                prefix: PREFIXES.SHORT[""]
            },
            ELECTRIC_CAPACITANCE: {
                unit: UNITS.F,
                prefix: PREFIXES.SHORT[""]
            },
            ELECTRIC_POTENTIAL: {
                unit: UNITS.V,
                prefix: PREFIXES.SHORT[""]
            },
            ELECTRIC_RESISTANCE: {
                unit: UNITS.ohm,
                prefix: PREFIXES.SHORT[""]
            },
            ELECTRIC_INDUCTANCE: {
                unit: UNITS.H,
                prefix: PREFIXES.SHORT[""]
            },
            ELECTRIC_CONDUCTANCE: {
                unit: UNITS.S,
                prefix: PREFIXES.SHORT[""]
            },
            MAGNETIC_FLUX: {
                unit: UNITS.Wb,
                prefix: PREFIXES.SHORT[""]
            },
            MAGNETIC_FLUX_DENSITY: {
                unit: UNITS.T,
                prefix: PREFIXES.SHORT[""]
            },
            FREQUENCY: {
                unit: UNITS.Hz,
                prefix: PREFIXES.SHORT[""]
            }
        }
    }; // Clone to create the other unit systems
    UNIT_SYSTEMS.cgs = JSON.parse(JSON.stringify(UNIT_SYSTEMS.si));
    UNIT_SYSTEMS.cgs.LENGTH = {
        unit: UNITS.m,
        prefix: PREFIXES.SHORT.c
    };
    UNIT_SYSTEMS.cgs.MASS = {
        unit: UNITS.g,
        prefix: PREFIXES.SHORT[""]
    };
    UNIT_SYSTEMS.cgs.FORCE = {
        unit: UNITS.dyn,
        prefix: PREFIXES.SHORT[""]
    };
    UNIT_SYSTEMS.cgs.ENERGY = {
        unit: UNITS.erg,
        prefix: PREFIXES.NONE[""]
    }; // there are wholly 4 unique cgs systems for electricity and magnetism,
    // so let's not worry about it unless somebody complains
    UNIT_SYSTEMS.us = JSON.parse(JSON.stringify(UNIT_SYSTEMS.si));
    UNIT_SYSTEMS.us.LENGTH = {
        unit: UNITS.ft,
        prefix: PREFIXES.NONE[""]
    };
    UNIT_SYSTEMS.us.MASS = {
        unit: UNITS.lbm,
        prefix: PREFIXES.NONE[""]
    };
    UNIT_SYSTEMS.us.TEMPERATURE = {
        unit: UNITS.degF,
        prefix: PREFIXES.NONE[""]
    };
    UNIT_SYSTEMS.us.FORCE = {
        unit: UNITS.lbf,
        prefix: PREFIXES.NONE[""]
    };
    UNIT_SYSTEMS.us.ENERGY = {
        unit: UNITS.BTU,
        prefix: PREFIXES.BTU[""]
    };
    UNIT_SYSTEMS.us.POWER = {
        unit: UNITS.hp,
        prefix: PREFIXES.NONE[""]
    };
    UNIT_SYSTEMS.us.PRESSURE = {
        unit: UNITS.psi,
        prefix: PREFIXES.NONE[""]
    }; // Add additional unit systems here.
    // Choose a unit system to seed the auto unit system.
    UNIT_SYSTEMS.auto = JSON.parse(JSON.stringify(UNIT_SYSTEMS.si)); // Set the current unit system
    var currentUnitSystem = UNIT_SYSTEMS.auto;
    /**
   * Set a unit system for formatting derived units.
   * @param {string} [name] The name of the unit system.
   */ Unit.setUnitSystem = function(name) {
        if ((0, $7ITGG.hasOwnProperty)(UNIT_SYSTEMS, name)) currentUnitSystem = UNIT_SYSTEMS[name];
        else throw new Error("Unit system " + name + " does not exist. Choices are: " + Object.keys(UNIT_SYSTEMS).join(", "));
    };
    /**
   * Return the current unit system.
   * @return {string} The current unit system.
   */ Unit.getUnitSystem = function() {
        for(var _key in UNIT_SYSTEMS){
            if (UNIT_SYSTEMS[_key] === currentUnitSystem) return _key;
        }
    };
    /**
   * Converters to convert from number to an other numeric type like BigNumber
   * or Fraction
   */ Unit.typeConverters = {
        BigNumber: function BigNumber(x) {
            return new _BigNumber(x + ""); // stringify to prevent constructor error
        },
        Fraction: function Fraction(x) {
            return new _Fraction(x);
        },
        Complex: function Complex(x) {
            return x;
        },
        number: function number(x) {
            return x;
        }
    };
    /**
   * Retrieve the right convertor function corresponding with the type
   * of provided exampleValue.
   *
   * @param {string} type   A string 'number', 'BigNumber', or 'Fraction'
   *                        In case of an unknown type,
   * @return {Function}
   */ Unit._getNumberConverter = function(type) {
        if (!Unit.typeConverters[type]) throw new TypeError('Unsupported type "' + type + '"');
        return Unit.typeConverters[type];
    }; // Add dimensions to each built-in unit
    for(var _key2 in UNITS){
        var unit = UNITS[_key2];
        unit.dimensions = unit.base.dimensions;
    } // Create aliases
    for(var _name2 in ALIASES)if ((0, $7ITGG.hasOwnProperty)(ALIASES, _name2)) {
        var _unit2 = UNITS[ALIASES[_name2]];
        var alias = {};
        for(var _key3 in _unit2)if ((0, $7ITGG.hasOwnProperty)(_unit2, _key3)) alias[_key3] = _unit2[_key3];
        alias.name = _name2;
        UNITS[_name2] = alias;
    }
    function assertUnitNameIsValid(name) {
        for(var i = 0; i < name.length; i++){
            var _c = name.charAt(i);
            var isValidAlpha = function isValidAlpha(p) {
                return /^[a-zA-Z]$/.test(p);
            };
            var _isDigit = function _isDigit(c) {
                return c >= "0" && c <= "9";
            };
            if (i === 0 && !isValidAlpha(_c)) throw new Error('Invalid unit name (must begin with alpha character): "' + name + '"');
            if (i > 0 && !(isValidAlpha(_c) || _isDigit(_c))) throw new Error('Invalid unit name (only alphanumeric characters are allowed): "' + name + '"');
        }
    }
    /**
   * Wrapper around createUnitSingle.
   * Example:
   *  createUnit({
   *    foo: { },
   *    bar: {
   *      definition: 'kg/foo',
   *      aliases: ['ba', 'barr', 'bars'],
   *      offset: 200
   *    },
   *    baz: '4 bar'
   *  },
   *  {
   *    override: true
   *  })
   * @param {object} obj      Object map. Each key becomes a unit which is defined by its value.
   * @param {object} options
   */ Unit.createUnit = function(obj, options) {
        if ($dc04440ac59b18c7$var$_typeof(obj) !== "object") throw new TypeError("createUnit expects first parameter to be of type 'Object'");
         // Remove all units and aliases we are overriding
        if (options && options.override) for(var _key4 in obj){
            if ((0, $7ITGG.hasOwnProperty)(obj, _key4)) Unit.deleteUnit(_key4);
            if (obj[_key4].aliases) for(var i = 0; i < obj[_key4].aliases.length; i++)Unit.deleteUnit(obj[_key4].aliases[i]);
        }
         // TODO: traverse multiple times until all units have been added
        var lastUnit;
        for(var _key5 in obj)if ((0, $7ITGG.hasOwnProperty)(obj, _key5)) lastUnit = Unit.createUnitSingle(_key5, obj[_key5]);
        return lastUnit;
    };
    /**
   * Create a user-defined unit and register it with the Unit type.
   * Example:
   *  createUnitSingle('knot', '0.514444444 m/s')
   *  createUnitSingle('acre', new Unit(43560, 'ft^2'))
   *
   * @param {string} name      The name of the new unit. Must be unique. Example: 'knot'
   * @param {string, Unit, Object} definition      Definition of the unit in terms
   * of existing units. For example, '0.514444444 m / s'. Can be a Unit, a string,
   * or an Object. If an Object, may have the following properties:
   *   - definition {string|Unit} The definition of this unit.
   *   - prefixes {string} "none", "short", "long", "binary_short", or "binary_long".
   *     The default is "none".
   *   - aliases {Array} Array of strings. Example: ['knots', 'kt', 'kts']
   *   - offset {Numeric} An offset to apply when converting from the unit. For
   *     example, the offset for celsius is 273.15 and the offset for farhenheit
   *     is 459.67. Default is 0.
   *   - baseName {string} If the unit's dimension does not match that of any other
   *     base unit, the name of the newly create base unit. Otherwise, this property
   *     has no effect.
   *
   * @param {Object} options   (optional) An object containing any of the following
   * properties:
   *   - override {boolean} Whether this unit should be allowed to override existing
   *     units.
   *
   * @return {Unit}
   */ Unit.createUnitSingle = function(name, obj, options) {
        if (typeof obj === "undefined" || obj === null) obj = {};
        if (typeof name !== "string") throw new TypeError("createUnitSingle expects first parameter to be of type 'string'");
         // Check collisions with existing units
        if ((0, $7ITGG.hasOwnProperty)(UNITS, name)) throw new Error('Cannot create unit "' + name + '": a unit with that name already exists');
         // TODO: Validate name for collisions with other built-in functions (like abs or cos, for example), and for acceptable variable names. For example, '42' is probably not a valid unit. Nor is '%', since it is also an operator.
        assertUnitNameIsValid(name);
        var defUnit = null; // The Unit from which the new unit will be created.
        var aliases = [];
        var offset = 0;
        var definition;
        var prefixes;
        var baseName;
        if (obj && obj.type === "Unit") defUnit = obj.clone();
        else if (typeof obj === "string") {
            if (obj !== "") definition = obj;
        } else if ($dc04440ac59b18c7$var$_typeof(obj) === "object") {
            definition = obj.definition;
            prefixes = obj.prefixes;
            offset = obj.offset;
            baseName = obj.baseName;
            if (obj.aliases) aliases = obj.aliases.valueOf(); // aliases could be a Matrix, so convert to Array
        } else throw new TypeError('Cannot create unit "' + name + '" from "' + obj.toString() + '": expecting "string" or "Unit" or "Object"');
        if (aliases) for(var i = 0; i < aliases.length; i++){
            if ((0, $7ITGG.hasOwnProperty)(UNITS, aliases[i])) throw new Error('Cannot create alias "' + aliases[i] + '": a unit with that name already exists');
        }
        if (definition && typeof definition === "string" && !defUnit) try {
            defUnit = Unit.parse(definition, {
                allowNoUnits: true
            });
        } catch (ex) {
            ex.message = 'Could not create unit "' + name + '" from "' + definition + '": ' + ex.message;
            throw ex;
        }
        else if (definition && definition.type === "Unit") defUnit = definition.clone();
        aliases = aliases || [];
        offset = offset || 0;
        if (prefixes && prefixes.toUpperCase) prefixes = PREFIXES[prefixes.toUpperCase()] || PREFIXES.NONE;
        else prefixes = PREFIXES.NONE;
         // If defUnit is null, it is because the user did not
        // specify a defintion. So create a new base dimension.
        var newUnit = {};
        if (!defUnit) {
            // Add a new base dimension
            baseName = baseName || name + "_STUFF"; // foo --> foo_STUFF, or the essence of foo
            if (BASE_DIMENSIONS.indexOf(baseName) >= 0) throw new Error('Cannot create new base unit "' + name + '": a base unit with that name already exists (and cannot be overridden)');
            BASE_DIMENSIONS.push(baseName); // Push 0 onto existing base units
            for(var b in BASE_UNITS)if ((0, $7ITGG.hasOwnProperty)(BASE_UNITS, b)) BASE_UNITS[b].dimensions[BASE_DIMENSIONS.length - 1] = 0;
             // Add the new base unit
            var newBaseUnit = {
                dimensions: []
            };
            for(var _i6 = 0; _i6 < BASE_DIMENSIONS.length; _i6++)newBaseUnit.dimensions[_i6] = 0;
            newBaseUnit.dimensions[BASE_DIMENSIONS.length - 1] = 1;
            newBaseUnit.key = baseName;
            BASE_UNITS[baseName] = newBaseUnit;
            newUnit = {
                name: name,
                value: 1,
                dimensions: BASE_UNITS[baseName].dimensions.slice(0),
                prefixes: prefixes,
                offset: offset,
                base: BASE_UNITS[baseName]
            };
            currentUnitSystem[baseName] = {
                unit: newUnit,
                prefix: PREFIXES.NONE[""]
            };
        } else {
            newUnit = {
                name: name,
                value: defUnit.value,
                dimensions: defUnit.dimensions.slice(0),
                prefixes: prefixes,
                offset: offset
            }; // Create a new base if no matching base exists
            var anyMatch = false;
            for(var _i7 in BASE_UNITS)if ((0, $7ITGG.hasOwnProperty)(BASE_UNITS, _i7)) {
                var match = true;
                for(var j = 0; j < BASE_DIMENSIONS.length; j++)if (Math.abs((newUnit.dimensions[j] || 0) - (BASE_UNITS[_i7].dimensions[j] || 0)) > 1e-12) {
                    match = false;
                    break;
                }
                if (match) {
                    anyMatch = true;
                    newUnit.base = BASE_UNITS[_i7];
                    break;
                }
            }
            if (!anyMatch) {
                baseName = baseName || name + "_STUFF"; // foo --> foo_STUFF, or the essence of foo
                // Add the new base unit
                var _newBaseUnit = {
                    dimensions: defUnit.dimensions.slice(0)
                };
                _newBaseUnit.key = baseName;
                BASE_UNITS[baseName] = _newBaseUnit;
                currentUnitSystem[baseName] = {
                    unit: newUnit,
                    prefix: PREFIXES.NONE[""]
                };
                newUnit.base = BASE_UNITS[baseName];
            }
        }
        Unit.UNITS[name] = newUnit;
        for(var _i8 = 0; _i8 < aliases.length; _i8++){
            var aliasName = aliases[_i8];
            var _alias = {};
            for(var _key6 in newUnit)if ((0, $7ITGG.hasOwnProperty)(newUnit, _key6)) _alias[_key6] = newUnit[_key6];
            _alias.name = aliasName;
            Unit.UNITS[aliasName] = _alias;
        }
        return new Unit(null, name);
    };
    Unit.deleteUnit = function(name) {
        delete Unit.UNITS[name];
    }; // expose arrays with prefixes, dimensions, units, systems
    Unit.PREFIXES = PREFIXES;
    Unit.BASE_DIMENSIONS = BASE_DIMENSIONS;
    Unit.BASE_UNITS = BASE_UNITS;
    Unit.UNIT_SYSTEMS = UNIT_SYSTEMS;
    Unit.UNITS = UNITS;
    return Unit;
}, {
    isClass: true
});

});

parcelRegister("baZLo", function(module, exports) {

$parcel$export(module.exports, "createUnitFunction", function () { return $823089cf63077e7a$export$17074f98b69d2545; });

var $2mPYl = parcelRequire("2mPYl");

var $e04i1 = parcelRequire("e04i1");
var $823089cf63077e7a$var$name = "unit";
var $823089cf63077e7a$var$dependencies = [
    "typed",
    "Unit"
]; // This function is named createUnitFunction to prevent a naming conflict with createUnit
var $823089cf63077e7a$export$17074f98b69d2545 = /* #__PURE__ */ (0, $2mPYl.factory)($823089cf63077e7a$var$name, $823089cf63077e7a$var$dependencies, function(_ref) {
    var typed = _ref.typed, Unit = _ref.Unit;
    /**
   * Create a unit. Depending on the passed arguments, the function
   * will create and return a new math.Unit object.
   * When a matrix is provided, all elements will be converted to units.
   *
   * Syntax:
   *
   *     math.unit(unit : string)
   *     math.unit(value : number, unit : string)
   *
   * Examples:
   *
   *    const a = math.unit(5, 'cm')    // returns Unit 50 mm
   *    const b = math.unit('23 kg')    // returns Unit 23 kg
   *    a.to('m')                       // returns Unit 0.05 m
   *
   * See also:
   *
   *    bignumber, boolean, complex, index, matrix, number, string, createUnit
   *
   * @param {* | Array | Matrix} args   A number and unit.
   * @return {Unit | Array | Matrix}    The created unit
   */ var unit = typed($823089cf63077e7a$var$name, {
        Unit: function Unit(x) {
            return x.clone();
        },
        string: function string(x) {
            if (Unit.isValuelessUnit(x)) return new Unit(null, x); // a pure unit
            return Unit.parse(x, {
                allowNoUnits: true
            }); // a unit with value, like '5cm'
        },
        "number | BigNumber | Fraction | Complex, string": function numberBigNumberFractionComplexString(value, unit) {
            return new Unit(value, unit);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $e04i1.deepMap)(x, unit);
        }
    });
    return unit;
});

});

parcelRegister("3oCz3", function(module, exports) {

$parcel$export(module.exports, "createUsolve", function () { return $27918711c0b2bb32$export$f652f5e8e3e838da; });

var $2mPYl = parcelRequire("2mPYl");

var $9AqV5 = parcelRequire("9AqV5");
var $27918711c0b2bb32$var$name = "usolve";
var $27918711c0b2bb32$var$dependencies = [
    "typed",
    "matrix",
    "divideScalar",
    "multiplyScalar",
    "subtract",
    "equalScalar",
    "DenseMatrix"
];
var $27918711c0b2bb32$export$f652f5e8e3e838da = /* #__PURE__ */ (0, $2mPYl.factory)($27918711c0b2bb32$var$name, $27918711c0b2bb32$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, divideScalar = _ref.divideScalar, multiplyScalar = _ref.multiplyScalar, subtract = _ref.subtract, equalScalar = _ref.equalScalar, DenseMatrix = _ref.DenseMatrix;
    var solveValidation = (0, $9AqV5.createSolveValidation)({
        DenseMatrix: DenseMatrix
    });
    /**
   * Solves the linear equation system by backward substitution. Matrix must be an upper triangular matrix.
   *
   * `U * x = b`
   *
   * Syntax:
   *
   *    math.usolve(U, b)
   *
   * Examples:
   *
   *    const a = [[-2, 3], [2, 1]]
   *    const b = [11, 9]
   *    const x = usolve(a, b)  // [[8], [9]]
   *
   * See also:
   *
   *    lup, slu, usolve, lusolve
   *
   * @param {Matrix, Array} U       A N x N matrix or array (U)
   * @param {Matrix, Array} b       A column vector with the b values
   *
   * @return {DenseMatrix | Array}  A column vector with the linear system solution (x)
   */ return typed($27918711c0b2bb32$var$name, {
        "SparseMatrix, Array | Matrix": function SparseMatrixArrayMatrix(m, b) {
            // process matrix
            return _sparseBackwardSubstitution(m, b);
        },
        "DenseMatrix, Array | Matrix": function DenseMatrixArrayMatrix(m, b) {
            // process matrix
            return _denseBackwardSubstitution(m, b);
        },
        "Array, Array | Matrix": function ArrayArrayMatrix(a, b) {
            // create dense matrix from array
            var m = matrix(a); // use matrix implementation
            var r = _denseBackwardSubstitution(m, b); // result
            return r.valueOf();
        }
    });
    function _denseBackwardSubstitution(m, b) {
        // validate matrix and vector, return copy of column vector b
        b = solveValidation(m, b, true); // column vector data
        var bdata = b._data; // rows & columns
        var rows = m._size[0];
        var columns = m._size[1]; // result
        var x = []; // arrays
        var data = m._data; // backward solve m * x = b, loop columns (backwards)
        for(var j = columns - 1; j >= 0; j--){
            // b[j]
            var bj = bdata[j][0] || 0; // x[j]
            var xj = void 0; // backward substitution (outer product) avoids inner looping when bj === 0
            if (!equalScalar(bj, 0)) {
                // value @ [j, j]
                var vjj = data[j][j]; // check vjj
                if (equalScalar(vjj, 0)) // system cannot be solved
                throw new Error("Linear system cannot be solved since matrix is singular");
                 // calculate xj
                xj = divideScalar(bj, vjj); // loop rows
                for(var i = j - 1; i >= 0; i--)// update copy of b
                bdata[i] = [
                    subtract(bdata[i][0] || 0, multiplyScalar(xj, data[i][j]))
                ];
            } else // zero value @ j
            xj = 0;
             // update x
            x[j] = [
                xj
            ];
        } // return column vector
        return new DenseMatrix({
            data: x,
            size: [
                rows,
                1
            ]
        });
    }
    function _sparseBackwardSubstitution(m, b) {
        // validate matrix and vector, return copy of column vector b
        b = solveValidation(m, b, true); // column vector data
        var bdata = b._data; // rows & columns
        var rows = m._size[0];
        var columns = m._size[1]; // matrix arrays
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr; // vars
        var i, k; // result
        var x = []; // backward solve m * x = b, loop columns (backwards)
        for(var j = columns - 1; j >= 0; j--){
            // b[j]
            var bj = bdata[j][0] || 0; // backward substitution (outer product) avoids inner looping when bj === 0
            if (!equalScalar(bj, 0)) {
                // value @ [j, j]
                var vjj = 0; // upper triangular matrix values & index (column j)
                var jvalues = [];
                var jindex = []; // first & last indeces in column
                var f = ptr[j];
                var l = ptr[j + 1]; // values in column, find value @ [j, j], loop backwards
                for(k = l - 1; k >= f; k--){
                    // row
                    i = index[k]; // check row
                    if (i === j) // update vjj
                    vjj = values[k];
                    else if (i < j) {
                        // store upper triangular
                        jvalues.push(values[k]);
                        jindex.push(i);
                    }
                } // at this point we must have a value @ [j, j]
                if (equalScalar(vjj, 0)) // system cannot be solved, there is no value @ [j, j]
                throw new Error("Linear system cannot be solved since matrix is singular");
                 // calculate xj
                var xj = divideScalar(bj, vjj); // loop upper triangular
                for(k = 0, l = jindex.length; k < l; k++){
                    // row
                    i = jindex[k]; // update copy of b
                    bdata[i] = [
                        subtract(bdata[i][0], multiplyScalar(xj, jvalues[k]))
                    ];
                } // update x
                x[j] = [
                    xj
                ];
            } else // update x
            x[j] = [
                0
            ];
        } // return vector
        return new DenseMatrix({
            data: x,
            size: [
                rows,
                1
            ]
        });
    }
});

});

parcelRegister("3cHKt", function(module, exports) {

$parcel$export(module.exports, "createXgcd", function () { return $25546da520fbbf3c$export$de8cbd18c98bf9d5; });

var $2mPYl = parcelRequire("2mPYl");

var $6fCew = parcelRequire("6fCew");
var $25546da520fbbf3c$var$name = "xgcd";
var $25546da520fbbf3c$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "BigNumber"
];
var $25546da520fbbf3c$export$de8cbd18c98bf9d5 = /* #__PURE__ */ (0, $2mPYl.factory)($25546da520fbbf3c$var$name, $25546da520fbbf3c$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, matrix = _ref.matrix, BigNumber = _ref.BigNumber;
    /**
   * Calculate the extended greatest common divisor for two values.
   * See https://en.wikipedia.org/wiki/Extended_Euclidean_algorithm.
   *
   * Syntax:
   *
   *    math.xgcd(a, b)
   *
   * Examples:
   *
   *    math.xgcd(8, 12)             // returns [4, -1, 1]
   *    math.gcd(8, 12)              // returns 4
   *    math.xgcd(36163, 21199)      // returns [1247, -7, 12]
   *
   * See also:
   *
   *    gcd, lcm
   *
   * @param {number | BigNumber} a  An integer number
   * @param {number | BigNumber} b  An integer number
   * @return {Array}              Returns an array containing 3 integers `[div, m, n]`
   *                              where `div = gcd(a, b)` and `a*m + b*n = div`
   */ return typed($25546da520fbbf3c$var$name, {
        "number, number": function numberNumber(a, b) {
            var res = (0, $6fCew.xgcdNumber)(a, b);
            return config.matrix === "Array" ? res : matrix(res);
        },
        "BigNumber, BigNumber": _xgcdBigNumber // TODO: implement support for Fraction
    });
    /**
   * Calculate xgcd for two BigNumbers
   * @param {BigNumber} a
   * @param {BigNumber} b
   * @return {BigNumber[]} result
   * @private
   */ function _xgcdBigNumber(a, b) {
        // source: https://en.wikipedia.org/wiki/Extended_Euclidean_algorithm
        var t;
        var q;
        var r;
        var zero = new BigNumber(0);
        var one = new BigNumber(1);
        var x = zero;
        var lastx = one;
        var y = one;
        var lasty = zero;
        if (!a.isInt() || !b.isInt()) throw new Error("Parameters in function xgcd must be integer numbers");
        while(!b.isZero()){
            q = a.div(b).floor();
            r = a.mod(b);
            t = x;
            x = lastx.minus(q.times(x));
            lastx = t;
            t = y;
            y = lasty.minus(q.times(y));
            lasty = t;
            a = b;
            b = r;
        }
        var res;
        if (a.lt(zero)) res = [
            a.neg(),
            lastx.neg(),
            lasty.neg()
        ];
        else res = [
            a,
            !a.isZero() ? lastx : 0,
            lasty
        ];
        return config.matrix === "Array" ? res : matrix(res);
    }
});

});

parcelRegister("4BDvJ", function(module, exports) {

$parcel$export(module.exports, "createXor", function () { return $35a9442a4a7ec3bb$export$a2b8cab2c7385f0e; });

var $jaKH8 = parcelRequire("jaKH8");

var $awGkR = parcelRequire("awGkR");

var $dNuvz = parcelRequire("dNuvz");

var $1bBLS = parcelRequire("1bBLS");

var $iHnaT = parcelRequire("iHnaT");

var $2mPYl = parcelRequire("2mPYl");

var $fAJNv = parcelRequire("fAJNv");
var $35a9442a4a7ec3bb$var$name = "xor";
var $35a9442a4a7ec3bb$var$dependencies = [
    "typed",
    "matrix",
    "DenseMatrix"
];
var $35a9442a4a7ec3bb$export$a2b8cab2c7385f0e = /* #__PURE__ */ (0, $2mPYl.factory)($35a9442a4a7ec3bb$var$name, $35a9442a4a7ec3bb$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, DenseMatrix = _ref.DenseMatrix;
    var algorithm03 = (0, $jaKH8.createAlgorithm03)({
        typed: typed
    });
    var algorithm07 = (0, $awGkR.createAlgorithm07)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $dNuvz.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $1bBLS.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $iHnaT.createAlgorithm14)({
        typed: typed
    });
    /**
   * Logical `xor`. Test whether one and only one value is defined with a nonzero/nonempty value.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.xor(x, y)
   *
   * Examples:
   *
   *    math.xor(2, 4)   // returns false
   *
   *    a = [2, 0, 0]
   *    b = [2, 7, 0]
   *    c = 0
   *
   *    math.xor(a, b)   // returns [false, true, false]
   *    math.xor(a, c)   // returns [true, false, false]
   *
   * See also:
   *
   *    and, not, or
   *
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x First value to check
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} y Second value to check
   * @return {boolean | Array | Matrix}
   *            Returns true when one and only one input is defined with a nonzero/nonempty value.
   */ var xor = typed($35a9442a4a7ec3bb$var$name, {
        "number, number": (0, $fAJNv.xorNumber),
        "Complex, Complex": function ComplexComplex(x, y) {
            return (x.re !== 0 || x.im !== 0) !== (y.re !== 0 || y.im !== 0);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return (!x.isZero() && !x.isNaN()) !== (!y.isZero() && !y.isNaN());
        },
        "Unit, Unit": function UnitUnit(x, y) {
            return xor(x.value || 0, y.value || 0);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, xor);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, xor, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, xor, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, xor);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return xor(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return xor(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return xor(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, xor, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, xor, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, xor, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, xor, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, xor, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, xor, true).valueOf();
        }
    });
    return xor;
});

});

parcelRegister("fcSN4", function(module, exports) {

$parcel$export(module.exports, "createZeros", function () { return $b1227a40e95f4efc$export$13096c1635fe6e3d; });

var $1amHZ = parcelRequire("1amHZ");

var $kFRKb = parcelRequire("kFRKb");

var $5WdrK = parcelRequire("5WdrK");

var $2mPYl = parcelRequire("2mPYl");
var $b1227a40e95f4efc$var$name = "zeros";
var $b1227a40e95f4efc$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "BigNumber"
];
var $b1227a40e95f4efc$export$13096c1635fe6e3d = /* #__PURE__ */ (0, $2mPYl.factory)($b1227a40e95f4efc$var$name, $b1227a40e95f4efc$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, matrix = _ref.matrix, BigNumber = _ref.BigNumber;
    /**
   * Create a matrix filled with zeros. The created matrix can have one or
   * multiple dimensions.
   *
   * Syntax:
   *
   *    math.zeros(m)
   *    math.zeros(m, format)
   *    math.zeros(m, n)
   *    math.zeros(m, n, format)
   *    math.zeros([m, n])
   *    math.zeros([m, n], format)
   *
   * Examples:
   *
   *    math.zeros(3)                  // returns [0, 0, 0]
   *    math.zeros(3, 2)               // returns [[0, 0], [0, 0], [0, 0]]
   *    math.zeros(3, 'dense')         // returns [0, 0, 0]
   *
   *    const A = [[1, 2, 3], [4, 5, 6]]
   *    math.zeros(math.size(A))       // returns [[0, 0, 0], [0, 0, 0]]
   *
   * See also:
   *
   *    ones, identity, size, range
   *
   * @param {...number | Array} size    The size of each dimension of the matrix
   * @param {string} [format]           The Matrix storage format
   *
   * @return {Array | Matrix}           A matrix filled with zeros
   */ return typed($b1227a40e95f4efc$var$name, {
        "": function _() {
            return config.matrix === "Array" ? _zeros([]) : _zeros([], "default");
        },
        // math.zeros(m, n, p, ..., format)
        // TODO: more accurate signature '...number | BigNumber, string' as soon as typed-function supports this
        "...number | BigNumber | string": function numberBigNumberString(size) {
            var last = size[size.length - 1];
            if (typeof last === "string") {
                var format = size.pop();
                return _zeros(size, format);
            } else if (config.matrix === "Array") return _zeros(size);
            else return _zeros(size, "default");
        },
        Array: _zeros,
        Matrix: function Matrix(size) {
            var format = size.storage();
            return _zeros(size.valueOf(), format);
        },
        "Array | Matrix, string": function ArrayMatrixString(size, format) {
            return _zeros(size.valueOf(), format);
        }
    });
    /**
   * Create an Array or Matrix with zeros
   * @param {Array} size
   * @param {string} [format='default']
   * @return {Array | Matrix}
   * @private
   */ function _zeros(size, format) {
        var hasBigNumbers = _normalize(size);
        var defaultValue = hasBigNumbers ? new BigNumber(0) : 0;
        _validate(size);
        if (format) {
            // return a matrix
            var m = matrix(format);
            if (size.length > 0) return m.resize(size, defaultValue);
            return m;
        } else {
            // return an Array
            var arr = [];
            if (size.length > 0) return (0, $5WdrK.resize)(arr, size, defaultValue);
            return arr;
        }
    } // replace BigNumbers with numbers, returns true if size contained BigNumbers
    function _normalize(size) {
        var hasBigNumbers = false;
        size.forEach(function(value, index, arr) {
            if ((0, $1amHZ.isBigNumber)(value)) {
                hasBigNumbers = true;
                arr[index] = value.toNumber();
            }
        });
        return hasBigNumbers;
    } // validate arguments
    function _validate(size) {
        size.forEach(function(value) {
            if (typeof value !== "number" || !(0, $kFRKb.isInteger)(value) || value < 0) throw new Error("Parameters in function zeros must be positive integers");
        });
    }
}); // TODO: zeros contains almost the same code as ones. Reuse this?

});




parcelRegister("1oGzi", function(module, exports) {

$parcel$export(module.exports, "ParseNumber", function () { return $10490d8917ae9469$export$24ec6072c2ea194f; });

var $lHDBd = parcelRequire("lHDBd");


var $3arU6 = parcelRequire("3arU6");

var $1BTI2 = parcelRequire("1BTI2");

var $aTUKb = parcelRequire("aTUKb");

var $iVCd9 = parcelRequire("iVCd9");
parcelRequire("cwjKY");
const $10490d8917ae9469$export$24ec6072c2ea194f = (valueString)=>{
    if ([
        null,
        undefined,
        ""
    ].includes(valueString)) return valueString;
    try {
        // Check if the string contains mathematical operators
        if (/[+\-*/()^]/.test(valueString)) {
            // Get the current locale based on organisation country
            const locale = (0, (/*@__PURE__*/$parcel$interopDefault($3arU6))).findCountryLocales((0, $aTUKb.constantCase)(((0, $1BTI2.default) === null || (0, $1BTI2.default) === void 0 ? void 0 : (0, $1BTI2.default).organisationCountry) || "us"))[0];
            // Create number parser for the current locale
            const parser = new (0, $lHDBd.NumberParser)(locale, {
                style: "decimal"
            });
            // Regular expression to match numbers and operators
            // This regex captures numbers (possibly with decimal separators or thousands separators)
            // and operators separately
            const regex = /(\d[\d.,]*)|([-+*/()^])/g;
            // Process the string to replace localized numbers with standard format
            let standardizedExpression = "";
            let lastIndex = 0;
            let match;
            const expression = String(valueString);
            // Use regex to find all numbers and operators
            while((match = regex.exec(expression)) !== null){
                // If there's text between the last match and this one, add it to result
                if (match.index > lastIndex) standardizedExpression += expression.substring(lastIndex, match.index);
                if (match[1]) // This is a number - parse it according to locale
                try {
                    const parsedNumber = parser.parse(match[1]);
                    standardizedExpression += parsedNumber;
                } catch (e) {
                    // If parsing fails, keep the original number string
                    standardizedExpression += match[1];
                }
                else if (match[2]) // This is an operator - keep it as is
                standardizedExpression += match[2];
                lastIndex = regex.lastIndex;
            }
            // Add any remaining text after the last match
            if (lastIndex < expression.length) standardizedExpression += expression.substring(lastIndex);
            // Evaluate the standardized expression
            return (0, $iVCd9.evaluate)(standardizedExpression);
        } else {
            // If there are no operators, just parse the number normally
            const parser = new (0, $lHDBd.NumberParser)((0, (/*@__PURE__*/$parcel$interopDefault($3arU6))).findCountryLocales((0, $aTUKb.constantCase)(((0, $1BTI2.default) === null || (0, $1BTI2.default) === void 0 ? void 0 : (0, $1BTI2.default).organisationCountry) || "us"))[0], {
                style: "decimal"
            });
            return parser.parse(String(valueString));
        }
    } catch (e) {
        // If all else fails, return the original string
        return valueString;
    }
};

});

parcelRegister("2ZA1t", function(module, exports) {

$parcel$export(module.exports, "ParsePercent", function () { return $22dd38a4308c047b$export$604adb49655d900d; });

var $lHDBd = parcelRequire("lHDBd");


var $3arU6 = parcelRequire("3arU6");

var $1BTI2 = parcelRequire("1BTI2");

var $aTUKb = parcelRequire("aTUKb");
const $22dd38a4308c047b$export$604adb49655d900d = (valueString, decimals = 2)=>{
    const parser = new (0, $lHDBd.NumberParser)((0, (/*@__PURE__*/$parcel$interopDefault($3arU6))).findCountryLocales((0, $aTUKb.constantCase)(((0, $1BTI2.default) === null || (0, $1BTI2.default) === void 0 ? void 0 : (0, $1BTI2.default).organisationCountry) || "us"))[0], {
        style: "percent",
        maximumFractionDigits: decimals
    });
    return parser.parse(String(valueString));
};

});

parcelRegister("amISd", function(module, exports) {

$parcel$export(module.exports, "NumberInputContainer", function () { return $78bec461d2f71614$export$ae998795933d2dd9; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("eBwNQ");
parcelRequire("jbmdS");

var $e64Mn = parcelRequire("e64Mn");

var $e8Hda = parcelRequire("e8Hda");

var $8JX5d = parcelRequire("8JX5d");

var $2MXkj = parcelRequire("2MXkj");
var $78bec461d2f71614$export$ae998795933d2dd9 = (0, (/*@__PURE__*/$parcel$interopDefault($e64Mn)))({
    propTypes: {
        value: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).number,
        allowNegative: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).bool,
        allowNull: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).bool,
        // Should have either `onChange` or `action` (which uses `actionMixin`).
        onChange: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).func,
        formatFunc: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).func,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).any,
        isEditable: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).bool,
        nullReadOnlyValue: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).any
    },
    mixins: [
        (0, $8JX5d.numberInputContainerMixin)()
    ],
    getDefaultProps: function() {
        return {
            isEditable: true,
            formatFunc: (n)=>(0, $e8Hda.isNumber)(n) ? n.toFixed(2) : "",
            allowNegative: false,
            allowNull: false
        };
    },
    render: function() {
        let { isEditable: isEditable, nullReadOnlyValue: nullReadOnlyValue, value: value, style: style, formatFunc: _formatFunc, onChange: _onChange, onBlur: _onBlur, actionArgs: _actionArgs, executeActionOn: _executeActionOn, allowNull: _allowNull, allowNegative: _allowNegative, ...props } = this.props;
        if (!isEditable && value == null) value = nullReadOnlyValue;
        else value = this.state.value;
        const defaultStyles = {
            textAlign: "right"
        };
        const disabledStyles = {
            border: "none",
            boxShadow: "none"
        };
        const errorStyles = {
            color: "#dc2d11",
            border: "2px solid #dc2d11"
        };
        return /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
            className: "input-base",
            autoComplete: "off",
            ref: "input",
            type: "text",
            disabled: !isEditable,
            style: {
                ...defaultStyles,
                // `isValid` comes from `numberInputContainerMixin`
                ...isEditable && value !== "" && !this.isValid(value) ? errorStyles : {},
                ...!isEditable ? disabledStyles : {},
                ...style
            },
            value: value || "",
            onBlur: this.handleBlur,
            onChange: this.handleChange,
            onKeyPress: this.handleKeyPress,
            ...props
        });
    }
});

});
parcelRegister("e64Mn", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $jbmdS = parcelRequire("jbmdS");

var $downE = parcelRequire("downE");
if (typeof $jbmdS === "undefined") throw Error("create-react-class could not find the React object. If you are using script tags, make sure that React is being loaded before create-react-class.");
// Hack to grab NoopUpdateQueue from isomorphic React
var $a43555504cafda90$var$ReactNoopUpdateQueue = new $jbmdS.Component().updater;
module.exports = $downE($jbmdS.Component, $jbmdS.isValidElement, $a43555504cafda90$var$ReactNoopUpdateQueue);

});
parcelRegister("downE", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $9NZe5 = parcelRequire("9NZe5");
// -- Inlined from fbjs --
var $9c06a257e875e1d7$var$emptyObject = {};
var $9c06a257e875e1d7$var$validateFormat = function validateFormat(format) {};
function $9c06a257e875e1d7$var$_invariant(condition, format, a, b, c, d, e, f) {
    $9c06a257e875e1d7$var$validateFormat(format);
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
}
var $9c06a257e875e1d7$var$warning = function() {};
var $9c06a257e875e1d7$var$printWarning;
// /-- Inlined from fbjs --
var $9c06a257e875e1d7$var$MIXINS_KEY = "mixins";
// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function $9c06a257e875e1d7$var$identity(fn) {
    return fn;
}
var $9c06a257e875e1d7$var$ReactPropTypeLocationNames;
$9c06a257e875e1d7$var$ReactPropTypeLocationNames = {};
function $9c06a257e875e1d7$var$factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
    /**
   * Policies that describe methods in `ReactClassInterface`.
   */ var injectedMixins = [];
    /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */ var ReactClassInterface = {
        /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */ mixins: "DEFINE_MANY",
        /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */ statics: "DEFINE_MANY",
        /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */ propTypes: "DEFINE_MANY",
        /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */ contextTypes: "DEFINE_MANY",
        /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */ childContextTypes: "DEFINE_MANY",
        // ==== Definition methods ====
        /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */ getDefaultProps: "DEFINE_MANY_MERGED",
        /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */ getInitialState: "DEFINE_MANY_MERGED",
        /**
     * @return {object}
     * @optional
     */ getChildContext: "DEFINE_MANY_MERGED",
        /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */ render: "DEFINE_ONCE",
        // ==== Delegate methods ====
        /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */ componentWillMount: "DEFINE_MANY",
        /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */ componentDidMount: "DEFINE_MANY",
        /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */ componentWillReceiveProps: "DEFINE_MANY",
        /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */ shouldComponentUpdate: "DEFINE_ONCE",
        /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */ componentWillUpdate: "DEFINE_MANY",
        /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */ componentDidUpdate: "DEFINE_MANY",
        /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */ componentWillUnmount: "DEFINE_MANY",
        /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */ UNSAFE_componentWillMount: "DEFINE_MANY",
        /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */ UNSAFE_componentWillReceiveProps: "DEFINE_MANY",
        /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */ UNSAFE_componentWillUpdate: "DEFINE_MANY",
        // ==== Advanced methods ====
        /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */ updateComponent: "OVERRIDE_BASE"
    };
    /**
   * Similar to ReactClassInterface but for static methods.
   */ var ReactClassStaticInterface = {
        /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */ getDerivedStateFromProps: "DEFINE_MANY_MERGED"
    };
    /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */ var RESERVED_SPEC_KEYS = {
        displayName: function(Constructor, displayName) {
            Constructor.displayName = displayName;
        },
        mixins: function(Constructor, mixins) {
            if (mixins) for(var i = 0; i < mixins.length; i++)mixSpecIntoComponent(Constructor, mixins[i]);
        },
        childContextTypes: function(Constructor, childContextTypes) {
            Constructor.childContextTypes = $9NZe5({}, Constructor.childContextTypes, childContextTypes);
        },
        contextTypes: function(Constructor, contextTypes) {
            Constructor.contextTypes = $9NZe5({}, Constructor.contextTypes, contextTypes);
        },
        /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */ getDefaultProps: function(Constructor, getDefaultProps) {
            if (Constructor.getDefaultProps) Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
            else Constructor.getDefaultProps = getDefaultProps;
        },
        propTypes: function(Constructor, propTypes) {
            Constructor.propTypes = $9NZe5({}, Constructor.propTypes, propTypes);
        },
        statics: function(Constructor, statics) {
            mixStaticSpecIntoComponent(Constructor, statics);
        },
        autobind: function() {}
    };
    function validateTypeDef(Constructor, typeDef, location) {
        for(var propName in typeDef)typeDef.hasOwnProperty(propName);
    }
    function validateMethodOverride(isAlreadyDefined, name) {
        var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
        // Disallow overriding of base class methods unless explicitly allowed.
        if (ReactClassMixin.hasOwnProperty(name)) $9c06a257e875e1d7$var$_invariant(specPolicy === "OVERRIDE_BASE", "ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.", name);
        // Disallow defining methods more than once unless explicitly allowed.
        if (isAlreadyDefined) $9c06a257e875e1d7$var$_invariant(specPolicy === "DEFINE_MANY" || specPolicy === "DEFINE_MANY_MERGED", "ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.", name);
    }
    /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */ function mixSpecIntoComponent(Constructor, spec) {
        if (!spec) {
            var typeofSpec, isMixinValid;
            return;
        }
        $9c06a257e875e1d7$var$_invariant(typeof spec !== "function", "ReactClass: You're attempting to use a component class or function as a mixin. Instead, just use a regular object.");
        $9c06a257e875e1d7$var$_invariant(!isValidElement(spec), "ReactClass: You're attempting to use a component as a mixin. Instead, just use a regular object.");
        var proto = Constructor.prototype;
        var autoBindPairs = proto.__reactAutoBindPairs;
        // By handling mixins before any other properties, we ensure the same
        // chaining order is applied to methods with DEFINE_MANY policy, whether
        // mixins are listed before or after these methods in the spec.
        if (spec.hasOwnProperty($9c06a257e875e1d7$var$MIXINS_KEY)) RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
        for(var name in spec){
            if (!spec.hasOwnProperty(name)) continue;
            if (name === $9c06a257e875e1d7$var$MIXINS_KEY) continue;
            var property = spec[name];
            var isAlreadyDefined = proto.hasOwnProperty(name);
            validateMethodOverride(isAlreadyDefined, name);
            if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) RESERVED_SPEC_KEYS[name](Constructor, property);
            else {
                // Setup methods on prototype:
                // The following member methods should not be automatically bound:
                // 1. Expected ReactClass methods (in the "interface").
                // 2. Overridden methods (that were mixed in).
                var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
                var isFunction = typeof property === "function";
                var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
                if (shouldAutoBind) {
                    autoBindPairs.push(name, property);
                    proto[name] = property;
                } else if (isAlreadyDefined) {
                    var specPolicy = ReactClassInterface[name];
                    // These cases should already be caught by validateMethodOverride.
                    $9c06a257e875e1d7$var$_invariant(isReactClassMethod && (specPolicy === "DEFINE_MANY_MERGED" || specPolicy === "DEFINE_MANY"), "ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.", specPolicy, name);
                    // For methods which are defined more than once, call the existing
                    // methods before calling the new property, merging if appropriate.
                    if (specPolicy === "DEFINE_MANY_MERGED") proto[name] = createMergedResultFunction(proto[name], property);
                    else if (specPolicy === "DEFINE_MANY") proto[name] = createChainedFunction(proto[name], property);
                } else proto[name] = property;
            }
        }
    }
    function mixStaticSpecIntoComponent(Constructor, statics) {
        if (!statics) return;
        for(var name in statics){
            var property = statics[name];
            if (!statics.hasOwnProperty(name)) continue;
            var isReserved = name in RESERVED_SPEC_KEYS;
            $9c06a257e875e1d7$var$_invariant(!isReserved, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name);
            var isAlreadyDefined = name in Constructor;
            if (isAlreadyDefined) {
                var specPolicy = ReactClassStaticInterface.hasOwnProperty(name) ? ReactClassStaticInterface[name] : null;
                $9c06a257e875e1d7$var$_invariant(specPolicy === "DEFINE_MANY_MERGED", "ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.", name);
                Constructor[name] = createMergedResultFunction(Constructor[name], property);
                return;
            }
            Constructor[name] = property;
        }
    }
    /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */ function mergeIntoWithNoDuplicateKeys(one, two) {
        $9c06a257e875e1d7$var$_invariant(one && two && typeof one === "object" && typeof two === "object", "mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.");
        for(var key in two)if (two.hasOwnProperty(key)) {
            $9c06a257e875e1d7$var$_invariant(one[key] === undefined, "mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.", key);
            one[key] = two[key];
        }
        return one;
    }
    /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */ function createMergedResultFunction(one, two) {
        return function mergedResult() {
            var a = one.apply(this, arguments);
            var b = two.apply(this, arguments);
            if (a == null) return b;
            else if (b == null) return a;
            var c = {};
            mergeIntoWithNoDuplicateKeys(c, a);
            mergeIntoWithNoDuplicateKeys(c, b);
            return c;
        };
    }
    /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */ function createChainedFunction(one, two) {
        return function chainedFunction() {
            one.apply(this, arguments);
            two.apply(this, arguments);
        };
    }
    /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */ function bindAutoBindMethod(component, method) {
        var boundMethod = method.bind(component);
        var componentName, _bind;
        return boundMethod;
    }
    /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */ function bindAutoBindMethods(component) {
        var pairs = component.__reactAutoBindPairs;
        for(var i = 0; i < pairs.length; i += 2){
            var autoBindKey = pairs[i];
            var method = pairs[i + 1];
            component[autoBindKey] = bindAutoBindMethod(component, method);
        }
    }
    var IsMountedPreMixin = {
        componentDidMount: function() {
            this.__isMounted = true;
        }
    };
    var IsMountedPostMixin = {
        componentWillUnmount: function() {
            this.__isMounted = false;
        }
    };
    /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */ var ReactClassMixin = {
        /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */ replaceState: function(newState, callback) {
            this.updater.enqueueReplaceState(this, newState, callback);
        },
        /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */ isMounted: function() {
            return !!this.__isMounted;
        }
    };
    var ReactClassComponent = function() {};
    $9NZe5(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
    /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */ function createClass(spec) {
        // To keep our warnings more understandable, we'll use a little hack here to
        // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
        // unnecessarily identify a class without displayName as 'Constructor'.
        var Constructor = $9c06a257e875e1d7$var$identity(function(props, context, updater) {
            // Wire up auto-binding
            if (this.__reactAutoBindPairs.length) bindAutoBindMethods(this);
            this.props = props;
            this.context = context;
            this.refs = $9c06a257e875e1d7$var$emptyObject;
            this.updater = updater || ReactNoopUpdateQueue;
            this.state = null;
            // ReactClasses doesn't have constructors. Instead, they use the
            // getInitialState and componentWillMount methods for initialization.
            var initialState = this.getInitialState ? this.getInitialState() : null;
            $9c06a257e875e1d7$var$_invariant(typeof initialState === "object" && !Array.isArray(initialState), "%s.getInitialState(): must return an object or null", Constructor.displayName || "ReactCompositeComponent");
            this.state = initialState;
        });
        Constructor.prototype = new ReactClassComponent();
        Constructor.prototype.constructor = Constructor;
        Constructor.prototype.__reactAutoBindPairs = [];
        injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
        mixSpecIntoComponent(Constructor, IsMountedPreMixin);
        mixSpecIntoComponent(Constructor, spec);
        mixSpecIntoComponent(Constructor, IsMountedPostMixin);
        // Initialize the defaultProps property after all mixins have been merged.
        if (Constructor.getDefaultProps) Constructor.defaultProps = Constructor.getDefaultProps();
        $9c06a257e875e1d7$var$_invariant(Constructor.prototype.render, "createClass(...): Class specification must implement a `render` method.");
        // Reduce time spent doing lookups by setting these on the prototype.
        for(var methodName in ReactClassInterface)if (!Constructor.prototype[methodName]) Constructor.prototype[methodName] = null;
        return Constructor;
    }
    return createClass;
}
module.exports = $9c06a257e875e1d7$var$factory;

});
parcelRegister("9NZe5", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $72382ee5a3d7f0eb$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72382ee5a3d7f0eb$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $72382ee5a3d7f0eb$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $72382ee5a3d7f0eb$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $72382ee5a3d7f0eb$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $72382ee5a3d7f0eb$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $72382ee5a3d7f0eb$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($72382ee5a3d7f0eb$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($72382ee5a3d7f0eb$var$getOwnPropertySymbols) {
            symbols = $72382ee5a3d7f0eb$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($72382ee5a3d7f0eb$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});



parcelRegister("e8Hda", function(module, exports) {

$parcel$export(module.exports, "formatMinutes", function () { return $a4b354eea0138046$export$30c35cbf580cab77; });
$parcel$export(module.exports, "parseTime", function () { return $a4b354eea0138046$export$c9698ec7f05a07e1; });
$parcel$export(module.exports, "formatPercentage0", function () { return $a4b354eea0138046$export$4918778803e89c4; });
$parcel$export(module.exports, "isNumber", function () { return $a4b354eea0138046$export$7e4aa119212bc614; });
$parcel$export(module.exports, "formatNumber2", function () { return $a4b354eea0138046$export$36c108163051f3e0; });
$parcel$export(module.exports, "middleOfThree", function () { return $a4b354eea0138046$export$2ce6e9dde12d591b; });
$parcel$export(module.exports, "mergeProps", function () { return $a4b354eea0138046$export$9d1611c77c2fe928; });
$parcel$export(module.exports, "camelCaseToSentence", function () { return $a4b354eea0138046$export$c3fa14697779f87e; });
$parcel$export(module.exports, "parsesToFloat", function () { return $a4b354eea0138046$export$369fdd9044fcc096; });
$parcel$export(module.exports, "caseInsensitiveContains", function () { return $a4b354eea0138046$export$d2d3cbaff945f607; });
$parcel$export(module.exports, "numberTimeStringToMinutes", function () { return $a4b354eea0138046$export$8e9d747dacc29f35; });
$parcel$export(module.exports, "numMinutesToTimeString", function () { return $a4b354eea0138046$export$f84278ec39fddb19; });
/* @flow */ 
var $61Ea1 = parcelRequire("61Ea1");

var $8mgS6 = parcelRequire("8mgS6");
parcelRequire("eBwNQ");
var $eQdr1 = parcelRequire("eQdr1");

var $jbmdS = parcelRequire("jbmdS");

var $e64Mn = parcelRequire("e64Mn");

var $02LyB = parcelRequire("02LyB");

var $l7CP3 = parcelRequire("l7CP3");

var $2MXkj = parcelRequire("2MXkj");

var $gN0TC = parcelRequire("gN0TC");
function $a4b354eea0138046$export$89a7e74069fbb7af(obj) {
    var str = [];
    for(var p in obj)if (obj.hasOwnProperty(p)) {
        var val = obj[p];
        if (val == null) val = "";
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(val));
    }
    return str.join("&");
}
var $a4b354eea0138046$export$d2b052e7b4be1756 = (0, (/*@__PURE__*/$parcel$interopDefault($e64Mn)))({
    /**
   * `selectedName` should be managed by the parent (via `onClick`) and be set
   * to the `name` of the selected `ToggleButton` of the group in question.
   * When a `ToggleButton` is clicked, the `onClick` handler is called with the
   * value of the  `name` property being the only argument.
   */ propTypes: {
        name: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).string.isRequired,
        selectedName: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).string.isRequired,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).string.isRequired,
        onClick: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).func.isRequired
    },
    getInitialState: function() {
        return {};
    },
    render: function() {
        return /*#__PURE__*/ (0, $61Ea1.jsxs)("label", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))({
                btn: true,
                "btn-primary": true,
                active: this.props.selectedName === this.props.name
            }),
            onClick: this.handleClick,
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
                    type: "radio",
                    name: "options",
                    autoComplete: "off"
                }),
                this.props.label
            ]
        });
    },
    handleClick: function() {
        this.props.onClick(this.props.name);
    }
});
var $a4b354eea0138046$export$931cbfb6bfb85fc = (0, (/*@__PURE__*/$parcel$interopDefault($e64Mn)))({
    propTypes: {
        items: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).array.isRequired,
        renderMenuItem: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).func.isRequired,
        renderSelectedItem: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).func.isRequired,
        value: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).any,
        onChange: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).func.isRequired,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).object
    },
    getDefaultProps: function() {
        return {
            style: {}
        };
    },
    render: function() {
        var self = this;
        if (this.props.style.paddingLeft == null) this.props.style.paddingLeft = 0;
        return /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
            className: "btn",
            style: this.props.style,
            children: /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                className: "dropdown",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("button", {
                        className: "btn btn-default dropdown-toggle",
                        type: "button",
                        "data-toggle": "dropdown",
                        "aria-expanded": "true",
                        children: [
                            self.props.renderSelectedItem(self.props.value),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                className: "caret"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("ul", {
                        className: "dropdown-menu",
                        role: "menu",
                        "aria-labelledby": "dropdownMenu1",
                        children: self.props.items.map(function(item, index) {
                            return /*#__PURE__*/ (0, $61Ea1.jsx)("li", {
                                role: "presentation",
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)("a", {
                                    href: "js/void",
                                    onClick: function() {
                                        self.props.onChange(item);
                                    },
                                    style: {
                                        color: "black"
                                    },
                                    children: self.props.renderMenuItem(item)
                                })
                            }, index);
                        })
                    })
                ]
            })
        });
    }
});
var $a4b354eea0138046$export$8afccc1c0f0dfc45 = (0, (/*@__PURE__*/$parcel$interopDefault($e64Mn)))({
    propTypes: {
        // "top" and "left" are also doable but we just haven't supported those with css yet.
        orientation: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).oneOf([
            "bottom",
            "right",
            "block"
        ]),
        message: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).any.isRequired,
        arrowProps: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).object
    },
    getDefaultProps: function() {
        return {
            arrowProps: {}
        };
    },
    render: function() {
        let { orientation: orientation, message: message, arrowProps: arrowProps, className: className, ...props } = this.props;
        return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("popover", "error-message-popover", orientation, className),
            ...props,
            children: [
                orientation != null ? /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    className: "arrow",
                    ...arrowProps
                }) : null,
                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    className: "popover-content",
                    children: message
                })
            ]
        });
    }
});
function $a4b354eea0138046$export$8f72f92bbe1a7cfc(d) {
    if (d == null) return null;
    else return (0, (/*@__PURE__*/$parcel$interopDefault($8mgS6)))(d, "YYYY-MM-DD");
}
function $a4b354eea0138046$export$588937bcd60ade55(s) {
    if (s.indexOf("+") >= 0) return (0, (/*@__PURE__*/$parcel$interopDefault($8mgS6)))(s, "YYYY-MM-DDTHH:mm:ssZ");
    else return (0, (/*@__PURE__*/$parcel$interopDefault($8mgS6)))(s, "YYYY-MM-DDTHH:mm:ss");
}
function $a4b354eea0138046$export$30c35cbf580cab77(totalMinutes) {
    let hours = Math.floor(totalMinutes / 60);
    let minutes = totalMinutes % 60;
    return hours + ":" + (minutes < 10 ? "0" : "") + minutes;
}
function $a4b354eea0138046$export$c9698ec7f05a07e1(timeText) {
    /**
   * Returns `null` if `timeText` isn't in a recognised time format.
   */ let hours, minutes;
    if (timeText == null) return 0;
    if (timeText.length > 0) {
        if (timeText.match(/^\d{1,2}$/)) {
            // If they enter just a number then that's a number of hours.
            hours = parseInt(timeText);
            minutes = 0;
        } else if (timeText.match(/^(\d{0,2})[.,](\d{1,2})?$/)) {
            // Regular "hh.mm" time.
            let parts = [
                RegExp.$1,
                RegExp.$2
            ];
            hours = parts[0] !== "" ? parseInt(parts[0]) : 0;
            minutes = parts[1] !== "" ? parseInt(parts[1]) : 0;
            if (minutes < 10 && parts[1].length === 1) minutes *= 10;
            minutes = minutes / 100 * 60;
        } else if (timeText.match(/^(\d{0,10})[:](\d{1,10})?$/)) {
            // Regular "hh:mm" or "hh.mm" time.
            let parts = [
                RegExp.$1,
                RegExp.$2
            ];
            hours = parts[0] !== "" ? parseInt(parts[0]) : 0;
            // We decided that eg. "3:3" should be interpreted as "3:30".  Also "3:"
            // should be "3:00". But obviously "3:06" should not be "3:60" etc.
            //
            // So:
            // "3:" -> 3:00
            // "3:0" -> 3:00
            // "3:00" -> 3:00
            // "3:01" -> 3:01
            // "3:1" -> 3:10
            // "3:5" -> 3:50
            // "3:6" -> 3:06
            // "3:9" -> 3:09
            minutes = parts[1] !== "" ? parseInt(parts[1]) : 0;
            if (minutes < 6 && parts[1].length === 1) minutes *= 10;
        } else return 0;
    } else return 0;
    return hours * 60 + minutes;
}
const $a4b354eea0138046$export$e4936eab6cf48196 = class {
    constructor(options){
        this.component = options.component;
        this.stateVar = options.stateVar;
    }
    handleFieldChangeValue(fieldName, value) {
        this.component.state[this.stateVar][fieldName] = value;
        var newState = {};
        newState[this.stateVar] = this.component.state[this.stateVar];
        this.component.setState(newState);
        this.component._validate();
    }
    handleFieldChange(fieldName, event) {
        this.handleFieldChangeValue(fieldName, event.target.value);
    }
    getHandleFunc(fieldName) {
        var self = this;
        return function(event) {
            self.handleFieldChange(fieldName, event);
        };
    }
};
function $a4b354eea0138046$export$b9efc2a2f4df02ec(component, variable) {
    function updateState(val) {
        var s = {};
        s[variable] = val;
        component.setState(s);
    }
    return {
        onMouseOver: function() {
            updateState(true);
        },
        onMouseOut: function() {
            updateState(false);
        }
    };
}
function $a4b354eea0138046$export$e73c8bd0f20705a(prefix = "") {
    // http://stackoverflow.com/a/8809472/223486
    var d = new Date().getTime();
    var uuid = String(prefix) + "-" + (0, (/*@__PURE__*/$parcel$interopDefault($gN0TC)))();
    // + 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    //   var r = (d + Math.random()*16)%16 | 0;
    //   d = Math.floor(d/16);
    //   return (c=='x' ? r : (r&0x3|0x8)).toString(16);
    // });
    return uuid;
}
function $a4b354eea0138046$export$4918778803e89c4(num, { ifNull: ifNull = null } = {}) {
    if (!$a4b354eea0138046$export$7e4aa119212bc614(num)) return ifNull;
    else return Math.round(num) + "%";
}
function $a4b354eea0138046$export$4ffa315feef661a5(num, { ifNull: ifNull = null } = {}) {
    if (!$a4b354eea0138046$export$7e4aa119212bc614(num)) return ifNull;
    else return Math.round(num * 100) / 100 + "%";
}
function $a4b354eea0138046$export$5d19f6df0759cd52(num, { ifNull: ifNull = null } = {}) {
    if (!$a4b354eea0138046$export$7e4aa119212bc614(num)) return ifNull;
    return Math.round(num);
}
function $a4b354eea0138046$export$2f5fa8a9e6c033e3(num, n, { ifNull: ifNull = null } = {}) {
    /**
   * >>> formatNumber1(2)
   * "2"
   *
   * >>> formatNumber1(2.011111)
   * "2.0"
   */ if (!$a4b354eea0138046$export$7e4aa119212bc614(num)) return ifNull;
    let f = num.toFixed(n);
    let shouldChop = true;
    let ix = f.indexOf(".");
    if (ix !== -1) {
        for(let i = ix + 1; i < f.length; i++)if (f[i] !== "0") {
            shouldChop = false;
            break;
        }
    }
    if (shouldChop) f = f.substr(0, f.length - n - 1);
    return f;
}
function $a4b354eea0138046$export$ccce9119a8543e33(num, { ifNull: ifNull = null } = {}) {
    /**
   * >>> formatNumber1(2)
   * "2"
   *
   * >>> formatNumber1(2.011111)
   * "2.0"
   */ return $a4b354eea0138046$export$2f5fa8a9e6c033e3(num, 1, {
        ifNull: ifNull
    });
}
function $a4b354eea0138046$export$36c108163051f3e0(num, { ifNull: ifNull = null } = {}) {
    /**
   * >>> formatNumber2(2)
   * "2"
   *
   * >>> formatNumber2(2.011111)
   * "2.01"
   */ return $a4b354eea0138046$export$2f5fa8a9e6c033e3(num, 2, {
        ifNull: ifNull
    });
}
function $a4b354eea0138046$export$d716cefd47d84056(num, n, { ifNull: ifNull = null } = {}) {
    if (!$a4b354eea0138046$export$7e4aa119212bc614(num)) return ifNull;
    let p = Math.pow(10, n);
    return Math.round(num * p) / p;
}
function $a4b354eea0138046$export$665cf93617f845c9(num, { ifNull: ifNull = null } = {}) {
    return $a4b354eea0138046$export$5d19f6df0759cd52(num, {
        ifNull: ifNull
    }) + "h";
}
function $a4b354eea0138046$export$9f31de9e2b781ab3(value, singular, plural = null) {
    return `${value} ${value === 1 ? singular : plural != null ? plural : singular + "s"}`;
}
function $a4b354eea0138046$export$4365868ff9ac7d1a(event, svg) {
    /**
   * `event`: a React event (I think)
   * `svg`: an SVG DOM node.
   */ let p;
    if (svg.createSVGPoint) {
        var point = svg.createSVGPoint();
        point.x = event.clientX;
        point.y = event.clientY;
        point = point.matrixTransform(svg.getScreenCTM().inverse());
        p = [
            point.x,
            point.y
        ];
    } else {
        let rect = svg.getBoundingClientRect();
        p = [
            event.clientX - rect.left - svg.clientLeft,
            event.clientY - rect.top - svg.clientTop
        ];
    }
    // TODO-merge figure out when clipping is/isn't appropriate (check scrolling
    // / panning).
    var clip = true;
    if (clip) {
        let rect = svg.getBoundingClientRect();
        p[0] = $a4b354eea0138046$export$2ce6e9dde12d591b(0, p[0], rect.width);
        p[1] = $a4b354eea0138046$export$2ce6e9dde12d591b(0, p[1], rect.height);
    }
    return p;
}
function $a4b354eea0138046$var$getEventCoordsRelativeToElement(event, element) {
    if (element.tagName === "svg") return $a4b354eea0138046$export$4365868ff9ac7d1a(event, element);
    else {
        var rect = element.getBoundingClientRect();
        return [
            event.clientX - rect.left,
            event.clientY - rect.top
        ];
    }
}
function $a4b354eea0138046$export$842a2cf37af977e1(n, m) {
    /**
   * `mod` function that works sensibly for negative numbers (Javascript `%` operator doesn't).
   * http://stackoverflow.com/questions/4467539/javascript-modulo-not-behaving
   */ return (n % m + m) % m;
}
function $a4b354eea0138046$export$cc5ff271ec8e6438(f) {
    return function(...args) {
        let r = f(...args);
        /* eslint-disable no-console */ console.log("called", f.name, args, r);
        /* eslint-enable no-console */ return r;
    };
}
function $a4b354eea0138046$export$db107f8bf21fa6e([start1, end1], [start2, end2]) {
    /**
   * If there is no intersection, return `null`.
   * If the intersection has no beginning, the intersection start is `null`.
   * If the intersection has no end, the intersection end is `null`.
   */ if (start2 != null && end1 != null && start2 > end1 || start1 != null && end2 != null && start1 > end2) return null;
    function normalise(a) {
        if (a === Infinity || a === -Infinity) return null;
        else return a;
    }
    return [
        normalise(Math.max(start1 != null ? start1 : -Infinity, start2 != null ? start2 : -Infinity)),
        normalise(Math.min(end1 != null ? end1 : Infinity, end2 != null ? end2 : Infinity))
    ];
}
function $a4b354eea0138046$export$608ff0ad3171e64a(list1, list2, keyFunc1, keyFunc2, combineFunc) {
    let i = 0, j = 0, l1 = list1.length, l2 = list2.length;
    let r = [];
    while(i < l1 && j < l2){
        let key1 = keyFunc1(list1[i]);
        let key2 = keyFunc2(list2[j]);
        if (key1 < key2) r.push(combineFunc(key1, list1[i], list2[Math.max(j - 1, 0)]));
        else if (key1 == key2) r.push(combineFunc(key2, list1[i], list2[j]));
        else r.push(combineFunc(key2, list1[Math.max(i - 1, 0)], list2[j]));
        if (key1 <= key2) i++;
        if (key1 >= key2) j++;
    }
    while(i < l1){
        r.push(combineFunc(keyFunc1(list1[i]), list1[i], list2[Math.max(j - 1, 0)]));
        i++;
    }
    while(j < l2){
        r.push(combineFunc(keyFunc2(list2[j]), list1[Math.max(i - 1, 0)], list2[j]));
        j++;
    }
    return r;
}
function $a4b354eea0138046$export$9d1611c77c2fe928(...propsDicts) {
    function mergeProps1(props1, props2) {
        let { style: style1, className: className1, ...props1Rest } = props1 || {};
        let { style: style2, className: className2, ...props2Rest } = props2 || {};
        return {
            style: {
                ...style1,
                ...style2
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(className1, className2),
            ...props1Rest,
            ...props2Rest
        };
    }
    let result = propsDicts.reduce(mergeProps1, {});
    if (result.className === "") delete result.className;
    if ((0, $eQdr1.default).isEmpty(result.style)) delete result.style;
    return result;
}
function $a4b354eea0138046$export$ef0ce4c99ed038b8(d1, d2, mergeFunc) {
    let r = {};
    (0, $eQdr1.default).each(d1, function(v, k) {
        r[k] = mergeFunc(k, v, d2[k]);
    });
    (0, $eQdr1.default).each(d2, function(v, k) {
        if (!d1.hasOwnProperty(k)) r[k] = mergeFunc(k, undefined, v);
    });
    return r;
}
function $a4b354eea0138046$export$e853e2f473efea6f(d1, d2, mergeFunc) {
    /**
   * Analogous to `mergeDicts` but works with `Immutable.Map` objects.  Note
   * that (in addition to having different argument order both in the arguments
   * passed to `mergeMaps` and the arguments `mergeMaps` passes to
   * `mergeFunc`), this function is semantically different to
   * `Immutable.Map.mergeWith` in that `mergeFunc` is always called for every
   * value in either map, whereas `mergeWith` only calls its callback for
   * values that exist in both maps, making it impossible to catch them.
   */ return d1.withMutations(function(d1) {
        d1.forEach(function(v, k) {
            d1.set(k, mergeFunc(k, v, d2.get(k)));
        });
        d2.forEach(function(v, k) {
            if (!d1.has(k)) d1.set(k, mergeFunc(k, undefined, v));
        });
    });
}
function $a4b354eea0138046$export$cd4885c072542d0a(flexProp) {
    /**
   * >>> prefixFlex("1 1 auto")
   * {flex: "1 1 auto", WebkitFlex: "1 1 auto"}
   */ return {
        flex: flexProp,
        WebkitFlex: flexProp
    };
}
function $a4b354eea0138046$export$f59899712d962a6d() {
    /**
  * Mixin.
  *
  * Usage:
     let MyComponentWithHover = CreateReactClass({
      mixins: [hoverState()],
       render: function() {
        return (
          <div
              {...this.getHoverHandlers()}
              style={{backgroundColor: this.state.isHovered ? 'red' : 'blue'}}
            I am blue if hovered and red otherwise.
          </div>
        );
      }
    });
  */ return {
        getInitialState: function() {
            return {
                isHovered: false
            };
        },
        getHoverHandlers: function() {
            return {
                onMouseEnter: this.handleMouseEnter,
                onMouseLeave: this.handleMouseLeave
            };
        },
        handleMouseEnter: function() {
            this.setState({
                isHovered: true
            });
        },
        handleMouseLeave: function() {
            this.setState({
                isHovered: false
            });
        }
    };
}
function $a4b354eea0138046$export$de363e709c412c8a(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
        previous = options.leading === false ? 0 : (0, $eQdr1.default).now();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
    };
    var throttled = function() {
        var now = (0, $eQdr1.default).now();
        if (!previous && options.leading === false) previous = now;
        var remaining = wait - (now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(later, remaining);
        return result;
    };
    throttled.cancel = function() {
        clearTimeout(timeout);
        previous = 0;
        timeout = context = args = null;
    };
    return throttled;
}
const $a4b354eea0138046$export$b8504afd6311b292 = class {
    constructor({ getSvgNodeFunc: getSvgNodeFunc, callback: callback, mouseUpCallback: mouseUpCallback = null, throttleMs: throttleMs = null } = {}){
        this.getSvgNodeFunc = getSvgNodeFunc;
        this.callback = callback;
        this.mouseUpCallback = mouseUpCallback;
        this.throttleMs = throttleMs;
    }
    getMouseEventProperties(getArgs) {
        if (!(0, $eQdr1.default).isFunction(getArgs)) getArgs = function() {
            return getArgs;
        };
        let self = this;
        return {
            onMouseDown: function(e) {
                self.getArgs = getArgs;
                self.handleMouseDown(e);
            }
        };
    }
    getEventCoordsRelativeToElement(e) {
        return $a4b354eea0138046$var$getEventCoordsRelativeToElement(e, this.getSvgNodeFunc());
    }
    handleMouseDown(e) {
        let self = this;
        // Only care about left click.
        if (e.button !== 0) return;
        var position = this.getEventCoordsRelativeToElement(e);
        this.mouseDown = true;
        this.mousePosition = {
            x: position[0],
            y: position[1]
        };
        this.throttled = $a4b354eea0138046$export$de363e709c412c8a(function(e) {
            self.handleMouseMove(e);
        }, this.throttleMs);
        var $body = window.$("body");
        // If the user moves the mouse quickly, it will easily be able to move
        // outside the slider area, but we don't want that to stop the scroll
        // events from happening.  So attach the mousemove event to the `body`
        // element, making sure to clear it on mouseup.
        $body.one("mouseup", function(e) {
            $body.off("mousemove", self.throttled);
            self.handleMouseUp(e);
        });
        $body.on("mousemove", self.throttled);
        e.preventDefault();
        e.stopPropagation();
    }
    handleMouseMove(e, args) {
        if (this.mouseDown) {
            let position = this.getEventCoordsRelativeToElement(e);
            let newPosition = {
                x: position[0],
                y: position[1]
            };
            let args = this.getArgs();
            this.callback(newPosition, this.mousePosition, args);
            this.mousePosition = newPosition;
        }
        e.preventDefault();
        e.stopPropagation();
    }
    handleMouseUp(e) {
        if (this.throttled) this.throttled.cancel();
        this.mouseDown = false;
        e.preventDefault();
        e.stopPropagation();
        if (this.mouseUpCallback != null) this.mouseUpCallback();
    }
};
const $a4b354eea0138046$export$b25b355fca609f64 = class {
    constructor(secondCallback){
        this.fpsTimestamp = +new Date();
        this.frameCount = 0;
        this.fps = 0;
        this.secondCallback = secondCallback;
    }
    frame() {
        this.frameCount++;
        var newTimestamp = +new Date();
        if (newTimestamp - this.fpsTimestamp >= 1000) {
            this.fps = this.frameCount;
            this.secondCallback(this.fps);
            this.fpsTimestamp = newTimestamp;
            this.frameCount = 0;
        }
    }
};
function $a4b354eea0138046$export$b730691daab32e4b(arr, n, callback) {
    for(var i = 0, l = arr.length; i < l; i += n)callback(arr[i], i);
}
function $a4b354eea0138046$export$98945f78de306a65(arr, n, callback) {
    var newArr = [];
    $a4b354eea0138046$export$b730691daab32e4b(arr, n, function(r, i) {
        newArr.push(callback(r, i));
    });
    return newArr;
}
function $a4b354eea0138046$export$2eb2f647f68055d1(data, xFunc, y1Func, y2Func) {
    /**
   * Similar to d3.svg.area(), but optimised for having long horizontal line segments.
   *
   * So where d3.svg.area() might give you something like:
   *  L100,50
   *  L101,50
   *  L102,50
   *  L103,50
   *  ...
   *  L110,50
   *
   * makeAreaPath will give you:
   * L100,50
   * L110,50
   *
   * This may or may not be a worthwhile performance optimisation.
   */ var points = [];
    function addPoint(x, y) {
        if (points.length >= 2 && y === points[points.length - 1][1] && y === points[points.length - 2][1]) points[points.length - 1][0] = x;
        else points.push([
            x,
            y
        ]);
    }
    data.forEach(function(m, i) {
        addPoint(xFunc(m, i), y1Func(m, i));
    });
    for(var i = data.length - 1; i >= 0; i--){
        var m = data[i];
        addPoint(xFunc(m, i), y2Func(m, i));
    }
    return points.map(function(p, i) {
        return `${i === 0 ? "M" : "L"} ${p[0]},${p[1]}`;
    }).join("");
}
function $a4b354eea0138046$export$8a63f25cc62965f1(arr) {
    let s = 0;
    for (let item of arr)s += item;
    return s;
}
function $a4b354eea0138046$export$2ce6e9dde12d591b(a, b, c) {
    if (b < a) return a;
    if (b > c) return c;
    return b;
}
function $a4b354eea0138046$export$23f4ae204700ea29(arr) {
    var smallest = null, biggest = null;
    arr.forEach(function(i) {
        if (smallest == null || i < smallest) smallest = i;
        if (biggest == null || i > biggest) biggest = i;
    });
    return [
        smallest,
        biggest
    ];
}
function $a4b354eea0138046$export$36d5e0d2b514f546(n) {
    /**
   * 1 -> 1
   * 12 -> 12
   * 123 -> 123
   * 1234 -> 1234
   * 12345 -> 12.3k
   * 123456 -> 123k
   * 1234567 -> 1.23m
   * 12345678 -> 12.3m
   * 123456789 -> 123m
   * 1234567890 -> 1.23b
   * 12345678901 -> 12.3b
   * 123456789012 -> 123b
   * 1234567890123 -> 1234b
   * 12345678901234 -> 12345b
   * ...
   */ const suffixes = [
        "k",
        "m",
        "b"
    ];
    if (n < 0) return "-" + $a4b354eea0138046$export$36d5e0d2b514f546(-n);
    var s = Math.round(n).toString();
    var l = s.length;
    if (l <= 4) return s;
    else if (l > suffixes.length * 3 + 3) return s.substr(0, l - suffixes.length * 3) + suffixes[suffixes.length - 1];
    var decimalPointIndex = l % 3 || null;
    var suffix = suffixes[Math.floor((s.length - 4) / 3)];
    let s1;
    if (decimalPointIndex != null) s1 = s.substr(0, decimalPointIndex) + "." + s.substring(decimalPointIndex, 3);
    else s1 = s.substr(0, 3);
    return s1 + suffix;
}
function $a4b354eea0138046$export$cc7ed463489839e3([innerStart, innerEnd], [outerStartBefore, outerEndBefore], [outerStartAfter, outerEndAfter]) {
    /**
   * Before
   *      o-------------------o   (outerStartBefore, outerEndBefore)
   *         o------o             (innerStart, innerEnd)
   *
   * User drags outer range:
   *
   *      o------------------->>>>o   (outerStartAfter, outerEndAfter)
   *         o------o                 (innerStart, innerEnd)
   *
   * How should we transform the inner shape so the overall shape
   * looks the same?:
   *
   *      o-----------------------o   (outerStartAfter, outerEndAfter)
   *         o------>>o               (innerStartAfter, innerEndAfter)
   *
   * We return [innerStartAfter, innerEndAfter]
   */ if (outerStartBefore === outerEndBefore) return [
        outerStartAfter,
        outerEndAfter
    ];
    function transformPoint(val) {
        return outerStartAfter + (val - outerStartBefore) / (outerEndBefore - outerStartBefore) * (outerEndAfter - outerStartAfter);
    }
    return [
        transformPoint(innerStart),
        transformPoint(innerEnd)
    ];
}
function $a4b354eea0138046$export$c3fa14697779f87e(s) {
    /**
  >>> camelCaseToSentence("onHold")
  "On Hold"
   >>> camelCaseToSentence("potential"))
  "Potential"
  */ return s.replace(/./g, function(c, i) {
        if (i === 0) return c.toUpperCase();
        else if (c === c.toUpperCase()) return " " + c;
        else return c;
    });
}
function $a4b354eea0138046$export$c59b3f64f66861bb(s) {
    return s.replace(/./g, (c)=>(c === c.toUpperCase() ? "_" : "") + c.toUpperCase());
}
function $a4b354eea0138046$export$3d6d4d87d9f78e80(s) {
    return s[0].toUpperCase() + s.substr(1);
}
function $a4b354eea0138046$export$536cd9e170c45ee9(dct, key, defaultValue) {
    if (dct[key] == null) dct[key] = defaultValue;
    return dct[key];
}
function $a4b354eea0138046$export$b5948ee077d5937f(dct, key, modifierFunc, defaultValue) {
    dct[key] = modifierFunc($a4b354eea0138046$export$536cd9e170c45ee9(dct, key, defaultValue));
}
function $a4b354eea0138046$export$3f063810d7bf01bd(lst, grouperFunc, keyFunc) {
    /**
  * >>> myGroupBy(<objects>, <function>, <function>)
  *
   [
    {
      grouper: grouperFunc(<object1>),
      items: [<all the objects for which grouperFunc(o) === grouperFunc(object1)],
    },
    {
      grouper: grouperFunc(<object2>),
      items: [<all the objects for which grouperFunc(o) === grouperFunc(object2)],
    },
    ...
  ]
   `keyFunc` is just a function that takes a result of calling
  `grouperFunc` on an item in `lst` and turns it into a unique string.
   Note that this function does *not* assume that `lst` is already sorted in
  any particular way.
  */ var d = {};
    var out = [];
    for (let item of lst){
        var grouper = grouperFunc(item);
        var key = keyFunc(grouper);
        if (d[key] == null) {
            d[key] = {
                grouper: grouper,
                items: []
            };
            out.push(d[key]);
        }
        d[key].items.push(item);
    }
    return out;
}
var $a4b354eea0138046$export$cbd1a71eaec89d7d = (0, (/*@__PURE__*/$parcel$interopDefault($e64Mn)))({
    propTypes: {
        align: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).string.isRequired
    },
    render: function() {
        return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            style: {
                display: "table",
                width: "100%",
                height: "100%",
                tableLayout: "fixed",
                ...this.props.style
            },
            children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    display: "table-cell",
                    width: "100%",
                    height: "100%",
                    verticalAlign: this.props.align,
                    ...this.props.innerStyle
                },
                children: this.props.children
            })
        });
    }
});
function $a4b354eea0138046$export$53487a654b5bdb58(a, b) {
    /**
   * `a` and `b` are either null or objects that have a `name` property.
   *
   * Use this to sort by name, putting null values at the end.
   */ if (a == null && b == null) return 0;
    if (a == null && b != null) return 1;
    if (a != null && b == null) return -1;
    return a.name.localeCompare(b.name);
}
function $a4b354eea0138046$export$480a63919daf0d9f(a, b) {
    return (a != null ? +a.toDate() : 0) - (b != null ? +b.toDate() : 0);
}
function $a4b354eea0138046$export$ffec9d95a62fbc09(...args) {
    /**
  * A comparator function is a function that takes two arguments and returns a
  * negative number if the first should be ordered before the second, zero if
  * they are equal, and a positive number if the first should be ordered after
  * the second.
  *
  * `compareMultiple` takes any number of comparator functions and returns a
  * comparator that tries those functions in sequence until one of them
  * returns nonzero, and then returns that value.
  *
  * eg:
    >>> [[3, 1], [2, 2], [2, 1]].sort(compareMultiple(
         (a, b) => a[0] - b[0],
         (a, b) => a[1] - b[1]
       ))
   [[2, 1], [2, 2], [3, 1]]
    One extra thing is that the comparator functions passed in can return `null`
   to denote "I already know these two objects are equal; don't continue to the
   other comparators" rather than zero, which denotes "I don't yet know how these
   objects should be ordered with respect to one another".
  */ return function(a, b) {
        for(var i = 0; i < args.length - 1; i++){
            var val = args[i](a, b);
            if (val == null) return 0;
            else if (val !== 0) return val;
        }
        return args[args.length - 1](a, b);
    };
}
function $a4b354eea0138046$export$7e4aa119212bc614(ob) {
    return (0, $eQdr1.default).isNumber(ob) && !isNaN(ob) && isFinite(ob);
}
function $a4b354eea0138046$export$e1fe2eb830813601(ob) {
    return (0, $eQdr1.default).isString(ob) && ob !== "";
}
function $a4b354eea0138046$export$2ad0182371401ea4(val) {
    return val == null || val === "" || (0, $eQdr1.default).isNumber(parseFloat(val));
}
function $a4b354eea0138046$export$a287f47fed4544b8(val) {
    return (0, $eQdr1.default).isNumber(val) && val % 1 === 0;
}
function $a4b354eea0138046$export$c7d3d1f96a700512(arr, cmp) {
    var arrWithIndexes = arr.map(function(d, i) {
        return {
            item: d,
            index: i
        };
    });
    arrWithIndexes.sort(function(a, b) {
        var r = cmp(a.item, b.item);
        if (r !== 0) return r;
        else return a.index - b.index;
    });
    return arrWithIndexes.map((d)=>d.item);
}
function $a4b354eea0138046$export$ebb29a1de2bc5702(ob) {
    /**
   * >>> trueKeys({a: true, b: false})
   * ['a']
   */ var keys = [];
    (0, $eQdr1.default).each(ob, function(v, k) {
        if (v === true) keys.push(k);
    });
    return keys;
}
function $a4b354eea0138046$export$d224121420685233(arr, keyFunc, valueFunc) {
    let d = {};
    arr.forEach(function(item) {
        d[keyFunc(item)] = valueFunc(item);
    });
    return d;
}
function $a4b354eea0138046$export$8b47e1074e3d69e0(s) {
    return s != null && s.match(/^\d+$/) != null;
}
function $a4b354eea0138046$export$369fdd9044fcc096(s) {
    /**
   * Is `s` a string that is *just* a float (not just a string that starts with a float
   * and might have crap attached to the end). For this function we do not consider
   * exponential format to be valid, hence check for the 'e' character in the regexp.
   * Negative numbers are accepted though.
   *
   * Adapted from http://stackoverflow.com/a/1830547/223486
   */ return s != null && s !== "" && !/[\se]/i.test(s) && !isNaN(s);
}
function $a4b354eea0138046$export$1cc6de4b443ff73d(...args) {
    for(var i = 0, l = args.length; i < l; i++){
        let val = args[i];
        if (val != null) return val;
    }
}
function $a4b354eea0138046$export$45505e1f18813a(arr, func, filter) {
    if (filter == null || filter === "") return arr;
    else {
        var lower = filter.toLowerCase();
        return arr.filter((item)=>func(item).toLowerCase().match(lower));
    }
}
function $a4b354eea0138046$export$5b6e4109d15a5a72(expr, msg = null) {
    /* eslint-disable no-console */ if (msg != null) console.log(msg, expr);
    else console.log(expr);
    return expr;
/* eslint-enable no-console */ }
function $a4b354eea0138046$export$4d9e7a1c098df5e2(s) {
    return s != null && s !== "";
}
var $a4b354eea0138046$var$emailRegexp = /\S+@\S+\.\S+/;
function $a4b354eea0138046$export$7fbbfbca30081d0(email) {
    return $a4b354eea0138046$var$emailRegexp.test(email);
}
function $a4b354eea0138046$export$e90fb89750dba83f(s) {
    // http://stackoverflow.com/a/1830844/223486
    return !isNaN(parseFloat(s)) && isFinite(s);
}
function $a4b354eea0138046$export$1a6c67a2768025be(s) {
    return s == null || s === "" || $a4b354eea0138046$export$e90fb89750dba83f(s);
}
function $a4b354eea0138046$export$b077fa9fbdb7164c(ob, props) {
    let o = ob;
    for (let p of props){
        if (o == null) return null;
        o = o[p];
    }
    return o;
}
function $a4b354eea0138046$export$923d6aa3031a214e(d) {
    return d.clone().startOf("day").subtract(d.isoWeekday() - 1, "days");
}
function $a4b354eea0138046$export$6ea683876c36b8d2(d1, d2) {
    return $a4b354eea0138046$export$923d6aa3031a214e(d1).isSame($a4b354eea0138046$export$923d6aa3031a214e(d2));
}
function $a4b354eea0138046$export$ded41c4035377ae6({ items: items, newTotal: newTotal, get: get, set: set }) {
    /**
   * `items` is a list of arbitrary objects.
   *
   * Set the "total" of `items` to `newTotal`, where `get` is a function that
   * takes an item in the list and returns its value used to calculate the
   * total, and `set` takes an item and a value and sets the item's value to
   * the new value.
   *
   * If the sum of `items` before the call is positive, the items
   * are each multiplied by the same factor so the proportion remains the same.
   * Otherwise, all the values are set to the same number.
   */ let oldTotal = $a4b354eea0138046$export$8a63f25cc62965f1(items.map(get));
    if (oldTotal > 0) {
        let factor = newTotal / oldTotal;
        items.forEach(function(i) {
            set(i, get(i) * factor);
        });
    } else items.forEach(function(i) {
        set(i, newTotal / items.length);
    });
    return items;
}
function $a4b354eea0138046$export$d2d3cbaff945f607(haystack, needle) {
    return haystack.toUpperCase().indexOf(needle.toUpperCase()) >= 0;
}
function $a4b354eea0138046$export$e8726b15032ee6a8(haystack, needle) {
    return haystack.toUpperCase().indexOf(needle.toUpperCase()) === 0;
}
function $a4b354eea0138046$export$7f93652efe7e8f8c(ob) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).isValidElement(ob)) return ob;
    else return /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
        children: ob
    });
}
function* $a4b354eea0138046$export$782383ea69cc6c28(dict) {
    for(let k in dict)if (dict.hasOwnProperty(k)) yield [
        k,
        dict[k]
    ];
}
function* $a4b354eea0138046$export$45a3175d55604f4(iterable) {
    /**
   * Behaves like Python's `enumerate` function.
   */ let i = 0;
    for (const x of iterable){
        yield [
            i,
            x
        ];
        i++;
    }
}
function* $a4b354eea0138046$export$675f7606d6db1b29(iterable, pred) {
    for (let [i, item] of $a4b354eea0138046$export$45a3175d55604f4(iterable))if (pred(item, i)) yield item;
}
function* $a4b354eea0138046$export$b2517b0ab3a58435(iterable, mapper) {
    for (let [i, item] of $a4b354eea0138046$export$45a3175d55604f4(iterable))yield mapper(item, i);
}
function* $a4b354eea0138046$export$e08e3b67e392101e(...iterables) {
    for (let iterable of iterables)yield* iterable;
}
function* $a4b354eea0138046$export$c849644d5c08230c(...iterables) {
    let iters = iterables.map((i)=>i[Symbol.iterator]());
    while(true){
        const is = iters.map((i)=>i.next());
        if ((0, $eQdr1.default).any(is, (i)=>i.done)) return;
        yield is.map((i)=>i.value);
    }
}
function* $a4b354eea0138046$export$6d3e77a8a54e8f53(m1, m2) {
    let m = m1.clone();
    while(!m.isAfter(m2)){
        yield m;
        m = m.clone().add(1, "day");
    }
}
function $a4b354eea0138046$export$25f88d3e73d4a72a(d1, d2) {
    /**
   * `d1` and `d2` are `Immutable.Map` instances.
   * Returns `false` if any key exists in both maps but with different values,
   * `true` otherwise.
   */ for (let [k, v] of d1){
        if (d2.has(k) && !(0, (/*@__PURE__*/$parcel$interopDefault($l7CP3))).is(d2.get(k), v)) return false;
    }
    return true;
}
function* $a4b354eea0138046$export$d02631cccf789723(a, b) {
    if (b == null) {
        b = a;
        a = 0;
    }
    for(let i = a; i < b; i++)yield i;
}
function $a4b354eea0138046$export$afd09ce65dc4508b(iterable) {
    let d = {};
    for (let [key, val] of iterable)d[key] = val;
    return d;
}
function $a4b354eea0138046$export$a49e633488bd5a28(ob1, ob2) {
    if (ob1 == null && ob2 == null) return true;
    if (ob1 == null || ob2 == null) return false;
    if (ob1.constructor !== ob2.constructor) return false;
    if (ob1.id != null && ob2.id === ob1.id) return true;
    if (ob1.uuid != null && ob2.uuid === ob1.uuid) return true;
    return false;
}
function $a4b354eea0138046$export$7266649f72a0dbb6(f) {
    /**
   * Decorator for debugging performance.
   */ return function(...args) {
        const t1 = (0, (/*@__PURE__*/$parcel$interopDefault($8mgS6)))();
        const r = f(...args);
        const t2 = (0, (/*@__PURE__*/$parcel$interopDefault($8mgS6)))();
        const diff = t2.diff(t1);
        if (diff > 500) /* eslint-disable no-console */ console.log("args", args, "diff", diff);
        return r;
    };
}
function $a4b354eea0138046$export$d00b56ff2d620eb9(error) {
    /**
  * Convenience function you can use in the middle of an expression.
  eg:
  let a = (this.a != null) ? this.a
   : (this.b != null) ? this.b
   : raiseError(new Error("Should have had either a or b");
  */ throw error;
}
const $a4b354eea0138046$export$7ca38dca1f51ae70 = {
    /**
   * Mixin that's basically the same as react-router's (deprecated) Lifecycle
   * mixin (at least for the leave hook).
   */ contextTypes: {
        router: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).object.isRequired
    },
    componentDidMount: function() {
        this.context.router.setRouteLeaveHook(this.props.route, this.routerWillLeave);
    }
};
function $a4b354eea0138046$export$23fe7b6f9a263c6c() {
    try {
        throw new Error();
    } catch (e) {
        /* eslint-disable no-console */ console.log(e.stack);
    /* eslint-enable no-console */ }
}
function $a4b354eea0138046$export$8bf7aba4a9e09055(errorType) {
    /**
   * Throw an exception class and get a correct stack trace.
   *
   * Use
   *
   *    throwError(MyErrorClass)
   *
   * instead of
   *
   *    throw new MyErrorClass();
   */ let error = new Error();
    let exception = new Proxy(new errorType(), {
        get: function(ob, prop) {
            return error[prop];
        }
    });
    exception.name = errorType.name;
    throw exception;
}
function $a4b354eea0138046$export$575af9153aa1f5a6(...percentages) {
    let p = parseFloat(percentages[0]);
    for(let i = 1; i < percentages.length; i++)p += parseFloat(percentages[i]);
    return p + "%";
}
function $a4b354eea0138046$export$882a9460c4d248f6(...percentages) {
    let p = parseFloat(percentages[0]);
    for(let i = 1; i < percentages.length; i++)p -= parseFloat(percentages[i]);
    return p + "%";
}
const $a4b354eea0138046$export$985327fcac726f47 = (val)=>{
    let [, hours, minutes, ampm] = val.match(/([1-2][0-4]|0?[1-9])[\s*[:.,]\s*]?([0-5][0-9])?\s*([AaPp][Mm])?/) || [];
    hours = parseInt(hours || 0);
    minutes = parseInt(minutes || 0);
    ampm = ampm || "";
    if (ampm.toLowerCase() === "pm" && hours < 12) hours += 12;
    if (ampm.toLowerCase() === "am" && hours === 12) hours = 0;
    return hours + minutes / 60;
};
const $a4b354eea0138046$export$8e9d747dacc29f35 = (val)=>{
    let [, hours, minutes, ampm] = val.match(/([1-2][0-4]|0?[1-9])[\s*[:.,]\s*]?([0-5][0-9])?\s*([AaPp][Mm])?/) || [];
    hours = parseInt(hours || 0);
    minutes = parseInt(minutes || 0);
    ampm = ampm || "";
    if (ampm.toLowerCase() === "pm" && hours < 12) hours += 12;
    if (ampm.toLowerCase() === "am" && hours === 12) hours = 0;
    return hours * 60 + minutes;
};
const $a4b354eea0138046$export$f84278ec39fddb19 = (numMins)=>{
    const pm = numMins >= 720;
    if (numMins >= 780) numMins -= 720;
    const hours = Math.floor(numMins / 60);
    const mins = numMins - hours * 60;
    return `${hours}:${String(mins).padStart(2, "0")}${pm ? "pm" : "am"}`;
};

});
parcelRegister("l7CP3", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    var SLICE$0 = Array.prototype.slice;
    function createClass(ctor, superClass) {
        if (superClass) ctor.prototype = Object.create(superClass.prototype);
        ctor.prototype.constructor = ctor;
    }
    function Iterable(value) {
        return isIterable(value) ? value : Seq(value);
    }
    createClass(KeyedIterable, Iterable);
    function KeyedIterable(value) {
        return isKeyed(value) ? value : KeyedSeq(value);
    }
    createClass(IndexedIterable, Iterable);
    function IndexedIterable(value) {
        return isIndexed(value) ? value : IndexedSeq(value);
    }
    createClass(SetIterable, Iterable);
    function SetIterable(value) {
        return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
    }
    function isIterable(maybeIterable) {
        return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
    }
    function isKeyed(maybeKeyed) {
        return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
    }
    function isIndexed(maybeIndexed) {
        return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
    }
    function isAssociative(maybeAssociative) {
        return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
    }
    function isOrdered(maybeOrdered) {
        return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
    }
    Iterable.isIterable = isIterable;
    Iterable.isKeyed = isKeyed;
    Iterable.isIndexed = isIndexed;
    Iterable.isAssociative = isAssociative;
    Iterable.isOrdered = isOrdered;
    Iterable.Keyed = KeyedIterable;
    Iterable.Indexed = IndexedIterable;
    Iterable.Set = SetIterable;
    var IS_ITERABLE_SENTINEL = "@@__IMMUTABLE_ITERABLE__@@";
    var IS_KEYED_SENTINEL = "@@__IMMUTABLE_KEYED__@@";
    var IS_INDEXED_SENTINEL = "@@__IMMUTABLE_INDEXED__@@";
    var IS_ORDERED_SENTINEL = "@@__IMMUTABLE_ORDERED__@@";
    // Used for setting prototype methods that IE8 chokes on.
    var DELETE = "delete";
    // Constants describing the size of trie nodes.
    var SHIFT = 5; // Resulted in best performance after ______?
    var SIZE = 1 << SHIFT;
    var MASK = SIZE - 1;
    // A consistent shared value representing "not set" which equals nothing other
    // than itself, and nothing that could be provided externally.
    var NOT_SET = {};
    // Boolean references, Rough equivalent of `bool &`.
    var CHANGE_LENGTH = {
        value: false
    };
    var DID_ALTER = {
        value: false
    };
    function MakeRef(ref) {
        ref.value = false;
        return ref;
    }
    function SetRef(ref) {
        ref && (ref.value = true);
    }
    // A function which returns a value representing an "owner" for transient writes
    // to tries. The return value will only ever equal itself, and will not equal
    // the return of any subsequent call of this function.
    function OwnerID() {}
    // http://jsperf.com/copy-array-inline
    function arrCopy(arr, offset) {
        offset = offset || 0;
        var len = Math.max(0, arr.length - offset);
        var newArr = new Array(len);
        for(var ii = 0; ii < len; ii++)newArr[ii] = arr[ii + offset];
        return newArr;
    }
    function ensureSize(iter) {
        if (iter.size === undefined) iter.size = iter.__iterate(returnTrue);
        return iter.size;
    }
    function wrapIndex(iter, index) {
        // This implements "is array index" which the ECMAString spec defines as:
        //
        //     A String property name P is an array index if and only if
        //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
        //     to 2^32−1.
        //
        // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
        if (typeof index !== "number") {
            var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
            if ("" + uint32Index !== index || uint32Index === 4294967295) return NaN;
            index = uint32Index;
        }
        return index < 0 ? ensureSize(iter) + index : index;
    }
    function returnTrue() {
        return true;
    }
    function wholeSlice(begin, end, size) {
        return (begin === 0 || size !== undefined && begin <= -size) && (end === undefined || size !== undefined && end >= size);
    }
    function resolveBegin(begin, size) {
        return resolveIndex(begin, size, 0);
    }
    function resolveEnd(end, size) {
        return resolveIndex(end, size, size);
    }
    function resolveIndex(index, size, defaultIndex) {
        return index === undefined ? defaultIndex : index < 0 ? Math.max(0, size + index) : size === undefined ? index : Math.min(size, index);
    }
    /* global Symbol */ var ITERATE_KEYS = 0;
    var ITERATE_VALUES = 1;
    var ITERATE_ENTRIES = 2;
    var REAL_ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
    function Iterator(next) {
        this.next = next;
    }
    Iterator.prototype.toString = function() {
        return "[Iterator]";
    };
    Iterator.KEYS = ITERATE_KEYS;
    Iterator.VALUES = ITERATE_VALUES;
    Iterator.ENTRIES = ITERATE_ENTRIES;
    Iterator.prototype.inspect = Iterator.prototype.toSource = function() {
        return this.toString();
    };
    Iterator.prototype[ITERATOR_SYMBOL] = function() {
        return this;
    };
    function iteratorValue(type, k, v, iteratorResult) {
        var value = type === 0 ? k : type === 1 ? v : [
            k,
            v
        ];
        iteratorResult ? iteratorResult.value = value : iteratorResult = {
            value: value,
            done: false
        };
        return iteratorResult;
    }
    function iteratorDone() {
        return {
            value: undefined,
            done: true
        };
    }
    function hasIterator(maybeIterable) {
        return !!getIteratorFn(maybeIterable);
    }
    function isIterator(maybeIterator) {
        return maybeIterator && typeof maybeIterator.next === "function";
    }
    function getIterator(iterable) {
        var iteratorFn = getIteratorFn(iterable);
        return iteratorFn && iteratorFn.call(iterable);
    }
    function getIteratorFn(iterable) {
        var iteratorFn = iterable && (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL] || iterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === "function") return iteratorFn;
    }
    function isArrayLike(value) {
        return value && typeof value.length === "number";
    }
    createClass(Seq, Iterable);
    function Seq(value) {
        return value === null || value === undefined ? emptySequence() : isIterable(value) ? value.toSeq() : seqFromValue(value);
    }
    Seq.of = function() {
        return Seq(arguments);
    };
    Seq.prototype.toSeq = function() {
        return this;
    };
    Seq.prototype.toString = function() {
        return this.__toString("Seq {", "}");
    };
    Seq.prototype.cacheResult = function() {
        if (!this._cache && this.__iterateUncached) {
            this._cache = this.entrySeq().toArray();
            this.size = this._cache.length;
        }
        return this;
    };
    // abstract __iterateUncached(fn, reverse)
    Seq.prototype.__iterate = function(fn, reverse) {
        return seqIterate(this, fn, reverse, true);
    };
    // abstract __iteratorUncached(type, reverse)
    Seq.prototype.__iterator = function(type, reverse) {
        return seqIterator(this, type, reverse, true);
    };
    createClass(KeyedSeq, Seq);
    function KeyedSeq(value) {
        return value === null || value === undefined ? emptySequence().toKeyedSeq() : isIterable(value) ? isKeyed(value) ? value.toSeq() : value.fromEntrySeq() : keyedSeqFromValue(value);
    }
    KeyedSeq.prototype.toKeyedSeq = function() {
        return this;
    };
    createClass(IndexedSeq, Seq);
    function IndexedSeq(value) {
        return value === null || value === undefined ? emptySequence() : !isIterable(value) ? indexedSeqFromValue(value) : isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
    }
    IndexedSeq.of = function() {
        return IndexedSeq(arguments);
    };
    IndexedSeq.prototype.toIndexedSeq = function() {
        return this;
    };
    IndexedSeq.prototype.toString = function() {
        return this.__toString("Seq [", "]");
    };
    IndexedSeq.prototype.__iterate = function(fn, reverse) {
        return seqIterate(this, fn, reverse, false);
    };
    IndexedSeq.prototype.__iterator = function(type, reverse) {
        return seqIterator(this, type, reverse, false);
    };
    createClass(SetSeq, Seq);
    function SetSeq(value) {
        return (value === null || value === undefined ? emptySequence() : !isIterable(value) ? indexedSeqFromValue(value) : isKeyed(value) ? value.entrySeq() : value).toSetSeq();
    }
    SetSeq.of = function() {
        return SetSeq(arguments);
    };
    SetSeq.prototype.toSetSeq = function() {
        return this;
    };
    Seq.isSeq = isSeq;
    Seq.Keyed = KeyedSeq;
    Seq.Set = SetSeq;
    Seq.Indexed = IndexedSeq;
    var IS_SEQ_SENTINEL = "@@__IMMUTABLE_SEQ__@@";
    Seq.prototype[IS_SEQ_SENTINEL] = true;
    createClass(ArraySeq, IndexedSeq);
    function ArraySeq(array) {
        this._array = array;
        this.size = array.length;
    }
    ArraySeq.prototype.get = function(index, notSetValue) {
        return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };
    ArraySeq.prototype.__iterate = function(fn, reverse) {
        var array = this._array;
        var maxIndex = array.length - 1;
        for(var ii = 0; ii <= maxIndex; ii++){
            if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) return ii + 1;
        }
        return ii;
    };
    ArraySeq.prototype.__iterator = function(type, reverse) {
        var array = this._array;
        var maxIndex = array.length - 1;
        var ii = 0;
        return new Iterator(function() {
            return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++]);
        });
    };
    createClass(ObjectSeq, KeyedSeq);
    function ObjectSeq(object) {
        var keys = Object.keys(object);
        this._object = object;
        this._keys = keys;
        this.size = keys.length;
    }
    ObjectSeq.prototype.get = function(key, notSetValue) {
        if (notSetValue !== undefined && !this.has(key)) return notSetValue;
        return this._object[key];
    };
    ObjectSeq.prototype.has = function(key) {
        return this._object.hasOwnProperty(key);
    };
    ObjectSeq.prototype.__iterate = function(fn, reverse) {
        var object = this._object;
        var keys = this._keys;
        var maxIndex = keys.length - 1;
        for(var ii = 0; ii <= maxIndex; ii++){
            var key = keys[reverse ? maxIndex - ii : ii];
            if (fn(object[key], key, this) === false) return ii + 1;
        }
        return ii;
    };
    ObjectSeq.prototype.__iterator = function(type, reverse) {
        var object = this._object;
        var keys = this._keys;
        var maxIndex = keys.length - 1;
        var ii = 0;
        return new Iterator(function() {
            var key = keys[reverse ? maxIndex - ii : ii];
            return ii++ > maxIndex ? iteratorDone() : iteratorValue(type, key, object[key]);
        });
    };
    ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
    createClass(IterableSeq, IndexedSeq);
    function IterableSeq(iterable) {
        this._iterable = iterable;
        this.size = iterable.length || iterable.size;
    }
    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var iterable = this._iterable;
        var iterator = getIterator(iterable);
        var iterations = 0;
        if (isIterator(iterator)) {
            var step;
            while(!(step = iterator.next()).done){
                if (fn(step.value, iterations++, this) === false) break;
            }
        }
        return iterations;
    };
    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterable = this._iterable;
        var iterator = getIterator(iterable);
        if (!isIterator(iterator)) return new Iterator(iteratorDone);
        var iterations = 0;
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, iterations++, step.value);
        });
    };
    createClass(IteratorSeq, IndexedSeq);
    function IteratorSeq(iterator) {
        this._iterator = iterator;
        this._iteratorCache = [];
    }
    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var iterator = this._iterator;
        var cache = this._iteratorCache;
        var iterations = 0;
        while(iterations < cache.length){
            if (fn(cache[iterations], iterations++, this) === false) return iterations;
        }
        var step;
        while(!(step = iterator.next()).done){
            var val = step.value;
            cache[iterations] = val;
            if (fn(val, iterations++, this) === false) break;
        }
        return iterations;
    };
    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = this._iterator;
        var cache = this._iteratorCache;
        var iterations = 0;
        return new Iterator(function() {
            if (iterations >= cache.length) {
                var step = iterator.next();
                if (step.done) return step;
                cache[iterations] = step.value;
            }
            return iteratorValue(type, iterations, cache[iterations++]);
        });
    };
    // # pragma Helper functions
    function isSeq(maybeSeq) {
        return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
    }
    var EMPTY_SEQ;
    function emptySequence() {
        return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
    }
    function keyedSeqFromValue(value) {
        var seq = Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() : isIterator(value) ? new IteratorSeq(value).fromEntrySeq() : hasIterator(value) ? new IterableSeq(value).fromEntrySeq() : typeof value === "object" ? new ObjectSeq(value) : undefined;
        if (!seq) throw new TypeError("Expected Array or iterable object of [k, v] entries, or keyed object: " + value);
        return seq;
    }
    function indexedSeqFromValue(value) {
        var seq = maybeIndexedSeqFromValue(value);
        if (!seq) throw new TypeError("Expected Array or iterable object of values: " + value);
        return seq;
    }
    function seqFromValue(value) {
        var seq = maybeIndexedSeqFromValue(value) || typeof value === "object" && new ObjectSeq(value);
        if (!seq) throw new TypeError("Expected Array or iterable object of values, or keyed object: " + value);
        return seq;
    }
    function maybeIndexedSeqFromValue(value) {
        return isArrayLike(value) ? new ArraySeq(value) : isIterator(value) ? new IteratorSeq(value) : hasIterator(value) ? new IterableSeq(value) : undefined;
    }
    function seqIterate(seq, fn, reverse, useKeys) {
        var cache = seq._cache;
        if (cache) {
            var maxIndex = cache.length - 1;
            for(var ii = 0; ii <= maxIndex; ii++){
                var entry = cache[reverse ? maxIndex - ii : ii];
                if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) return ii + 1;
            }
            return ii;
        }
        return seq.__iterateUncached(fn, reverse);
    }
    function seqIterator(seq, type, reverse, useKeys) {
        var cache = seq._cache;
        if (cache) {
            var maxIndex = cache.length - 1;
            var ii = 0;
            return new Iterator(function() {
                var entry = cache[reverse ? maxIndex - ii : ii];
                return ii++ > maxIndex ? iteratorDone() : iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
            });
        }
        return seq.__iteratorUncached(type, reverse);
    }
    function fromJS(json, converter) {
        return converter ? fromJSWith(converter, json, "", {
            "": json
        }) : fromJSDefault(json);
    }
    function fromJSWith(converter, json, key, parentJSON) {
        if (Array.isArray(json)) return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k) {
            return fromJSWith(converter, v, k, json);
        }));
        if (isPlainObj(json)) return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k) {
            return fromJSWith(converter, v, k, json);
        }));
        return json;
    }
    function fromJSDefault(json) {
        if (Array.isArray(json)) return IndexedSeq(json).map(fromJSDefault).toList();
        if (isPlainObj(json)) return KeyedSeq(json).map(fromJSDefault).toMap();
        return json;
    }
    function isPlainObj(value) {
        return value && (value.constructor === Object || value.constructor === undefined);
    }
    /**
   * An extension of the "same-value" algorithm as [described for use by ES6 Map
   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
   *
   * NaN is considered the same as NaN, however -0 and 0 are considered the same
   * value, which is different from the algorithm described by
   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
   *
   * This is extended further to allow Objects to describe the values they
   * represent, by way of `valueOf` or `equals` (and `hashCode`).
   *
   * Note: because of this extension, the key equality of Immutable.Map and the
   * value equality of Immutable.Set will differ from ES6 Map and Set.
   *
   * ### Defining custom values
   *
   * The easiest way to describe the value an object represents is by implementing
   * `valueOf`. For example, `Date` represents a value by returning a unix
   * timestamp for `valueOf`:
   *
   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
   *     var date2 = new Date(1234567890000);
   *     date1.valueOf(); // 1234567890000
   *     assert( date1 !== date2 );
   *     assert( Immutable.is( date1, date2 ) );
   *
   * Note: overriding `valueOf` may have other implications if you use this object
   * where JavaScript expects a primitive, such as implicit string coercion.
   *
   * For more complex types, especially collections, implementing `valueOf` may
   * not be performant. An alternative is to implement `equals` and `hashCode`.
   *
   * `equals` takes another object, presumably of similar type, and returns true
   * if the it is equal. Equality is symmetrical, so the same result should be
   * returned if this and the argument are flipped.
   *
   *     assert( a.equals(b) === b.equals(a) );
   *
   * `hashCode` returns a 32bit integer number representing the object which will
   * be used to determine how to store the value object in a Map or Set. You must
   * provide both or neither methods, one must not exist without the other.
   *
   * Also, an important relationship between these methods must be upheld: if two
   * values are equal, they *must* return the same hashCode. If the values are not
   * equal, they might have the same hashCode; this is called a hash collision,
   * and while undesirable for performance reasons, it is acceptable.
   *
   *     if (a.equals(b)) {
   *       assert( a.hashCode() === b.hashCode() );
   *     }
   *
   * All Immutable collections implement `equals` and `hashCode`.
   *
   */ function is(valueA, valueB) {
        if (valueA === valueB || valueA !== valueA && valueB !== valueB) return true;
        if (!valueA || !valueB) return false;
        if (typeof valueA.valueOf === "function" && typeof valueB.valueOf === "function") {
            valueA = valueA.valueOf();
            valueB = valueB.valueOf();
            if (valueA === valueB || valueA !== valueA && valueB !== valueB) return true;
            if (!valueA || !valueB) return false;
        }
        if (typeof valueA.equals === "function" && typeof valueB.equals === "function" && valueA.equals(valueB)) return true;
        return false;
    }
    function deepEqual(a, b) {
        if (a === b) return true;
        if (!isIterable(b) || a.size !== undefined && b.size !== undefined && a.size !== b.size || a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash || isKeyed(a) !== isKeyed(b) || isIndexed(a) !== isIndexed(b) || isOrdered(a) !== isOrdered(b)) return false;
        if (a.size === 0 && b.size === 0) return true;
        var notAssociative = !isAssociative(a);
        if (isOrdered(a)) {
            var entries = a.entries();
            return b.every(function(v, k) {
                var entry = entries.next().value;
                return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
            }) && entries.next().done;
        }
        var flipped = false;
        if (a.size === undefined) {
            if (b.size === undefined) {
                if (typeof a.cacheResult === "function") a.cacheResult();
            } else {
                flipped = true;
                var _ = a;
                a = b;
                b = _;
            }
        }
        var allEqual = true;
        var bSize = b.__iterate(function(v, k) {
            if (notAssociative ? !a.has(v) : flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
                allEqual = false;
                return false;
            }
        });
        return allEqual && a.size === bSize;
    }
    createClass(Repeat, IndexedSeq);
    function Repeat(value, times) {
        if (!(this instanceof Repeat)) return new Repeat(value, times);
        this._value = value;
        this.size = times === undefined ? Infinity : Math.max(0, times);
        if (this.size === 0) {
            if (EMPTY_REPEAT) return EMPTY_REPEAT;
            EMPTY_REPEAT = this;
        }
    }
    Repeat.prototype.toString = function() {
        if (this.size === 0) return "Repeat []";
        return "Repeat [ " + this._value + " " + this.size + " times ]";
    };
    Repeat.prototype.get = function(index, notSetValue) {
        return this.has(index) ? this._value : notSetValue;
    };
    Repeat.prototype.includes = function(searchValue) {
        return is(this._value, searchValue);
    };
    Repeat.prototype.slice = function(begin, end) {
        var size = this.size;
        return wholeSlice(begin, end, size) ? this : new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };
    Repeat.prototype.reverse = function() {
        return this;
    };
    Repeat.prototype.indexOf = function(searchValue) {
        if (is(this._value, searchValue)) return 0;
        return -1;
    };
    Repeat.prototype.lastIndexOf = function(searchValue) {
        if (is(this._value, searchValue)) return this.size;
        return -1;
    };
    Repeat.prototype.__iterate = function(fn, reverse) {
        for(var ii = 0; ii < this.size; ii++){
            if (fn(this._value, ii, this) === false) return ii + 1;
        }
        return ii;
    };
    Repeat.prototype.__iterator = function(type, reverse) {
        var this$0 = this;
        var ii = 0;
        return new Iterator(function() {
            return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone();
        });
    };
    Repeat.prototype.equals = function(other) {
        return other instanceof Repeat ? is(this._value, other._value) : deepEqual(other);
    };
    var EMPTY_REPEAT;
    function invariant(condition, error) {
        if (!condition) throw new Error(error);
    }
    createClass(Range, IndexedSeq);
    function Range(start, end, step) {
        if (!(this instanceof Range)) return new Range(start, end, step);
        invariant(step !== 0, "Cannot step a Range by 0");
        start = start || 0;
        if (end === undefined) end = Infinity;
        step = step === undefined ? 1 : Math.abs(step);
        if (end < start) step = -step;
        this._start = start;
        this._end = end;
        this._step = step;
        this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
        if (this.size === 0) {
            if (EMPTY_RANGE) return EMPTY_RANGE;
            EMPTY_RANGE = this;
        }
    }
    Range.prototype.toString = function() {
        if (this.size === 0) return "Range []";
        return "Range [ " + this._start + "..." + this._end + (this._step !== 1 ? " by " + this._step : "") + " ]";
    };
    Range.prototype.get = function(index, notSetValue) {
        return this.has(index) ? this._start + wrapIndex(this, index) * this._step : notSetValue;
    };
    Range.prototype.includes = function(searchValue) {
        var possibleIndex = (searchValue - this._start) / this._step;
        return possibleIndex >= 0 && possibleIndex < this.size && possibleIndex === Math.floor(possibleIndex);
    };
    Range.prototype.slice = function(begin, end) {
        if (wholeSlice(begin, end, this.size)) return this;
        begin = resolveBegin(begin, this.size);
        end = resolveEnd(end, this.size);
        if (end <= begin) return new Range(0, 0);
        return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };
    Range.prototype.indexOf = function(searchValue) {
        var offsetValue = searchValue - this._start;
        if (offsetValue % this._step === 0) {
            var index = offsetValue / this._step;
            if (index >= 0 && index < this.size) return index;
        }
        return -1;
    };
    Range.prototype.lastIndexOf = function(searchValue) {
        return this.indexOf(searchValue);
    };
    Range.prototype.__iterate = function(fn, reverse) {
        var maxIndex = this.size - 1;
        var step = this._step;
        var value = reverse ? this._start + maxIndex * step : this._start;
        for(var ii = 0; ii <= maxIndex; ii++){
            if (fn(value, ii, this) === false) return ii + 1;
            value += reverse ? -step : step;
        }
        return ii;
    };
    Range.prototype.__iterator = function(type, reverse) {
        var maxIndex = this.size - 1;
        var step = this._step;
        var value = reverse ? this._start + maxIndex * step : this._start;
        var ii = 0;
        return new Iterator(function() {
            var v = value;
            value += reverse ? -step : step;
            return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
        });
    };
    Range.prototype.equals = function(other) {
        return other instanceof Range ? this._start === other._start && this._end === other._end && this._step === other._step : deepEqual(this, other);
    };
    var EMPTY_RANGE;
    createClass(Collection, Iterable);
    function Collection() {
        throw TypeError("Abstract");
    }
    createClass(KeyedCollection, Collection);
    function KeyedCollection() {}
    createClass(IndexedCollection, Collection);
    function IndexedCollection() {}
    createClass(SetCollection, Collection);
    function SetCollection() {}
    Collection.Keyed = KeyedCollection;
    Collection.Indexed = IndexedCollection;
    Collection.Set = SetCollection;
    var imul = typeof Math.imul === "function" && Math.imul(0xffffffff, 2) === -2 ? Math.imul : function imul(a, b) {
        a = a | 0; // int
        b = b | 0; // int
        var c = a & 0xffff;
        var d = b & 0xffff;
        // Shift by 0 fixes the sign on the high part.
        return c * d + ((a >>> 16) * d + c * (b >>> 16) << 16 >>> 0) | 0; // int
    };
    // v8 has an optimization for storing 31-bit signed numbers.
    // Values which have either 00 or 11 as the high order bits qualify.
    // This function drops the highest order bit in a signed number, maintaining
    // the sign bit.
    function smi(i32) {
        return i32 >>> 1 & 0x40000000 | i32 & 0xBFFFFFFF;
    }
    function hash(o) {
        if (o === false || o === null || o === undefined) return 0;
        if (typeof o.valueOf === "function") {
            o = o.valueOf();
            if (o === false || o === null || o === undefined) return 0;
        }
        if (o === true) return 1;
        var type = typeof o;
        if (type === "number") {
            if (o !== o || o === Infinity) return 0;
            var h = o | 0;
            if (h !== o) h ^= o * 0xFFFFFFFF;
            while(o > 0xFFFFFFFF){
                o /= 0xFFFFFFFF;
                h ^= o;
            }
            return smi(h);
        }
        if (type === "string") return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
        if (typeof o.hashCode === "function") return o.hashCode();
        if (type === "object") return hashJSObj(o);
        if (typeof o.toString === "function") return hashString(o.toString());
        throw new Error("Value type " + type + " cannot be hashed.");
    }
    function cachedHashString(string) {
        var hash = stringHashCache[string];
        if (hash === undefined) {
            hash = hashString(string);
            if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
                STRING_HASH_CACHE_SIZE = 0;
                stringHashCache = {};
            }
            STRING_HASH_CACHE_SIZE++;
            stringHashCache[string] = hash;
        }
        return hash;
    }
    // http://jsperf.com/hashing-strings
    function hashString(string) {
        // This is the hash from JVM
        // The hash code for a string is computed as
        // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
        // where s[i] is the ith character of the string and n is the length of
        // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
        // (exclusive) by dropping high bits.
        var hash = 0;
        for(var ii = 0; ii < string.length; ii++)hash = 31 * hash + string.charCodeAt(ii) | 0;
        return smi(hash);
    }
    function hashJSObj(obj) {
        var hash;
        if (usingWeakMap) {
            hash = weakMap.get(obj);
            if (hash !== undefined) return hash;
        }
        hash = obj[UID_HASH_KEY];
        if (hash !== undefined) return hash;
        if (!canDefineProperty) {
            hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
            if (hash !== undefined) return hash;
            hash = getIENodeHash(obj);
            if (hash !== undefined) return hash;
        }
        hash = ++objHashUID;
        if (objHashUID & 0x40000000) objHashUID = 0;
        if (usingWeakMap) weakMap.set(obj, hash);
        else if (isExtensible !== undefined && isExtensible(obj) === false) throw new Error("Non-extensible objects are not allowed as keys.");
        else if (canDefineProperty) Object.defineProperty(obj, UID_HASH_KEY, {
            "enumerable": false,
            "configurable": false,
            "writable": false,
            "value": hash
        });
        else if (obj.propertyIsEnumerable !== undefined && obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
            // Since we can't define a non-enumerable property on the object
            // we'll hijack one of the less-used non-enumerable properties to
            // save our hash on it. Since this is a function it will not show up in
            // `JSON.stringify` which is what we want.
            obj.propertyIsEnumerable = function() {
                return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
            };
            obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
        } else if (obj.nodeType !== undefined) // At this point we couldn't get the IE `uniqueID` to use as a hash
        // and we couldn't use a non-enumerable property to exploit the
        // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
        // itself.
        obj[UID_HASH_KEY] = hash;
        else throw new Error("Unable to set a non-enumerable property on object.");
        return hash;
    }
    // Get references to ES5 object methods.
    var isExtensible = Object.isExtensible;
    // True if Object.defineProperty works as expected. IE8 fails this test.
    var canDefineProperty = function() {
        try {
            Object.defineProperty({}, "@", {});
            return true;
        } catch (e) {
            return false;
        }
    }();
    // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
    // and avoid memory leaks from the IE cloneNode bug.
    function getIENodeHash(node) {
        if (node && node.nodeType > 0) switch(node.nodeType){
            case 1:
                return node.uniqueID;
            case 9:
                return node.documentElement && node.documentElement.uniqueID;
        }
    }
    // If possible, use a WeakMap.
    var usingWeakMap = typeof WeakMap === "function";
    var weakMap;
    if (usingWeakMap) weakMap = new WeakMap();
    var objHashUID = 0;
    var UID_HASH_KEY = "__immutablehash__";
    if (typeof Symbol === "function") UID_HASH_KEY = Symbol(UID_HASH_KEY);
    var STRING_HASH_CACHE_MIN_STRLEN = 16;
    var STRING_HASH_CACHE_MAX_SIZE = 255;
    var STRING_HASH_CACHE_SIZE = 0;
    var stringHashCache = {};
    function assertNotInfinite(size) {
        invariant(size !== Infinity, "Cannot perform this action with an infinite size.");
    }
    createClass(Map, KeyedCollection);
    // @pragma Construction
    function Map(value) {
        return value === null || value === undefined ? emptyMap() : isMap(value) && !isOrdered(value) ? value : emptyMap().withMutations(function(map) {
            var iter = KeyedIterable(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v, k) {
                return map.set(k, v);
            });
        });
    }
    Map.of = function() {
        var keyValues = SLICE$0.call(arguments, 0);
        return emptyMap().withMutations(function(map) {
            for(var i = 0; i < keyValues.length; i += 2){
                if (i + 1 >= keyValues.length) throw new Error("Missing value for key: " + keyValues[i]);
                map.set(keyValues[i], keyValues[i + 1]);
            }
        });
    };
    Map.prototype.toString = function() {
        return this.__toString("Map {", "}");
    };
    // @pragma Access
    Map.prototype.get = function(k, notSetValue) {
        return this._root ? this._root.get(0, undefined, k, notSetValue) : notSetValue;
    };
    // @pragma Modification
    Map.prototype.set = function(k, v) {
        return updateMap(this, k, v);
    };
    Map.prototype.setIn = function(keyPath, v) {
        return this.updateIn(keyPath, NOT_SET, function() {
            return v;
        });
    };
    Map.prototype.remove = function(k) {
        return updateMap(this, k, NOT_SET);
    };
    Map.prototype.deleteIn = function(keyPath) {
        return this.updateIn(keyPath, function() {
            return NOT_SET;
        });
    };
    Map.prototype.update = function(k, notSetValue, updater) {
        return arguments.length === 1 ? k(this) : this.updateIn([
            k
        ], notSetValue, updater);
    };
    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
        if (!updater) {
            updater = notSetValue;
            notSetValue = undefined;
        }
        var updatedValue = updateInDeepMap(this, forceIterator(keyPath), notSetValue, updater);
        return updatedValue === NOT_SET ? undefined : updatedValue;
    };
    Map.prototype.clear = function() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._root = null;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyMap();
    };
    // @pragma Composition
    Map.prototype.merge = function() {
        return mergeIntoMapWith(this, undefined, arguments);
    };
    Map.prototype.mergeWith = function(merger) {
        var iters = SLICE$0.call(arguments, 1);
        return mergeIntoMapWith(this, merger, iters);
    };
    Map.prototype.mergeIn = function(keyPath) {
        var iters = SLICE$0.call(arguments, 1);
        return this.updateIn(keyPath, emptyMap(), function(m) {
            return typeof m.merge === "function" ? m.merge.apply(m, iters) : iters[iters.length - 1];
        });
    };
    Map.prototype.mergeDeep = function() {
        return mergeIntoMapWith(this, deepMerger, arguments);
    };
    Map.prototype.mergeDeepWith = function(merger) {
        var iters = SLICE$0.call(arguments, 1);
        return mergeIntoMapWith(this, deepMergerWith(merger), iters);
    };
    Map.prototype.mergeDeepIn = function(keyPath) {
        var iters = SLICE$0.call(arguments, 1);
        return this.updateIn(keyPath, emptyMap(), function(m) {
            return typeof m.mergeDeep === "function" ? m.mergeDeep.apply(m, iters) : iters[iters.length - 1];
        });
    };
    Map.prototype.sort = function(comparator) {
        // Late binding
        return OrderedMap(sortFactory(this, comparator));
    };
    Map.prototype.sortBy = function(mapper, comparator) {
        // Late binding
        return OrderedMap(sortFactory(this, comparator, mapper));
    };
    // @pragma Mutability
    Map.prototype.withMutations = function(fn) {
        var mutable = this.asMutable();
        fn(mutable);
        return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
    };
    Map.prototype.asMutable = function() {
        return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
    };
    Map.prototype.asImmutable = function() {
        return this.__ensureOwner();
    };
    Map.prototype.wasAltered = function() {
        return this.__altered;
    };
    Map.prototype.__iterator = function(type, reverse) {
        return new MapIterator(this, type, reverse);
    };
    Map.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        var iterations = 0;
        this._root && this._root.iterate(function(entry) {
            iterations++;
            return fn(entry[1], entry[0], this$0);
        }, reverse);
        return iterations;
    };
    Map.prototype.__ensureOwner = function(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return makeMap(this.size, this._root, ownerID, this.__hash);
    };
    function isMap(maybeMap) {
        return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
    }
    Map.isMap = isMap;
    var IS_MAP_SENTINEL = "@@__IMMUTABLE_MAP__@@";
    var MapPrototype = Map.prototype;
    MapPrototype[IS_MAP_SENTINEL] = true;
    MapPrototype[DELETE] = MapPrototype.remove;
    MapPrototype.removeIn = MapPrototype.deleteIn;
    // #pragma Trie Nodes
    function ArrayMapNode(ownerID, entries) {
        this.ownerID = ownerID;
        this.entries = entries;
    }
    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
        var entries = this.entries;
        for(var ii = 0, len = entries.length; ii < len; ii++){
            if (is(key, entries[ii][0])) return entries[ii][1];
        }
        return notSetValue;
    };
    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
        var removed = value === NOT_SET;
        var entries = this.entries;
        var idx = 0;
        for(var len = entries.length; idx < len; idx++){
            if (is(key, entries[idx][0])) break;
        }
        var exists = idx < len;
        if (exists ? entries[idx][1] === value : removed) return this;
        SetRef(didAlter);
        (removed || !exists) && SetRef(didChangeSize);
        if (removed && entries.length === 1) return; // undefined
        if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) return createNodes(ownerID, entries, key, value);
        var isEditable = ownerID && ownerID === this.ownerID;
        var newEntries = isEditable ? entries : arrCopy(entries);
        if (exists) {
            if (removed) idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
            else newEntries[idx] = [
                key,
                value
            ];
        } else newEntries.push([
            key,
            value
        ]);
        if (isEditable) {
            this.entries = newEntries;
            return this;
        }
        return new ArrayMapNode(ownerID, newEntries);
    };
    function BitmapIndexedNode(ownerID, bitmap, nodes) {
        this.ownerID = ownerID;
        this.bitmap = bitmap;
        this.nodes = nodes;
    }
    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
        if (keyHash === undefined) keyHash = hash(key);
        var bit = 1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK);
        var bitmap = this.bitmap;
        return (bitmap & bit) === 0 ? notSetValue : this.nodes[popCount(bitmap & bit - 1)].get(shift + SHIFT, keyHash, key, notSetValue);
    };
    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
        if (keyHash === undefined) keyHash = hash(key);
        var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
        var bit = 1 << keyHashFrag;
        var bitmap = this.bitmap;
        var exists = (bitmap & bit) !== 0;
        if (!exists && value === NOT_SET) return this;
        var idx = popCount(bitmap & bit - 1);
        var nodes = this.nodes;
        var node = exists ? nodes[idx] : undefined;
        var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
        if (newNode === node) return this;
        if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
        if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) return nodes[idx ^ 1];
        if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) return newNode;
        var isEditable = ownerID && ownerID === this.ownerID;
        var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
        var newNodes = exists ? newNode ? setIn(nodes, idx, newNode, isEditable) : spliceOut(nodes, idx, isEditable) : spliceIn(nodes, idx, newNode, isEditable);
        if (isEditable) {
            this.bitmap = newBitmap;
            this.nodes = newNodes;
            return this;
        }
        return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
    };
    function HashArrayMapNode(ownerID, count, nodes) {
        this.ownerID = ownerID;
        this.count = count;
        this.nodes = nodes;
    }
    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
        if (keyHash === undefined) keyHash = hash(key);
        var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
        var node = this.nodes[idx];
        return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
    };
    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
        if (keyHash === undefined) keyHash = hash(key);
        var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
        var removed = value === NOT_SET;
        var nodes = this.nodes;
        var node = nodes[idx];
        if (removed && !node) return this;
        var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
        if (newNode === node) return this;
        var newCount = this.count;
        if (!node) newCount++;
        else if (!newNode) {
            newCount--;
            if (newCount < MIN_HASH_ARRAY_MAP_SIZE) return packNodes(ownerID, nodes, newCount, idx);
        }
        var isEditable = ownerID && ownerID === this.ownerID;
        var newNodes = setIn(nodes, idx, newNode, isEditable);
        if (isEditable) {
            this.count = newCount;
            this.nodes = newNodes;
            return this;
        }
        return new HashArrayMapNode(ownerID, newCount, newNodes);
    };
    function HashCollisionNode(ownerID, keyHash, entries) {
        this.ownerID = ownerID;
        this.keyHash = keyHash;
        this.entries = entries;
    }
    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
        var entries = this.entries;
        for(var ii = 0, len = entries.length; ii < len; ii++){
            if (is(key, entries[ii][0])) return entries[ii][1];
        }
        return notSetValue;
    };
    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
        if (keyHash === undefined) keyHash = hash(key);
        var removed = value === NOT_SET;
        if (keyHash !== this.keyHash) {
            if (removed) return this;
            SetRef(didAlter);
            SetRef(didChangeSize);
            return mergeIntoNode(this, ownerID, shift, keyHash, [
                key,
                value
            ]);
        }
        var entries = this.entries;
        var idx = 0;
        for(var len = entries.length; idx < len; idx++){
            if (is(key, entries[idx][0])) break;
        }
        var exists = idx < len;
        if (exists ? entries[idx][1] === value : removed) return this;
        SetRef(didAlter);
        (removed || !exists) && SetRef(didChangeSize);
        if (removed && len === 2) return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
        var isEditable = ownerID && ownerID === this.ownerID;
        var newEntries = isEditable ? entries : arrCopy(entries);
        if (exists) {
            if (removed) idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
            else newEntries[idx] = [
                key,
                value
            ];
        } else newEntries.push([
            key,
            value
        ]);
        if (isEditable) {
            this.entries = newEntries;
            return this;
        }
        return new HashCollisionNode(ownerID, this.keyHash, newEntries);
    };
    function ValueNode(ownerID, keyHash, entry) {
        this.ownerID = ownerID;
        this.keyHash = keyHash;
        this.entry = entry;
    }
    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
        return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
    };
    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
        var removed = value === NOT_SET;
        var keyMatch = is(key, this.entry[0]);
        if (keyMatch ? value === this.entry[1] : removed) return this;
        SetRef(didAlter);
        if (removed) {
            SetRef(didChangeSize);
            return; // undefined
        }
        if (keyMatch) {
            if (ownerID && ownerID === this.ownerID) {
                this.entry[1] = value;
                return this;
            }
            return new ValueNode(ownerID, this.keyHash, [
                key,
                value
            ]);
        }
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, hash(key), [
            key,
            value
        ]);
    };
    // #pragma Iterators
    ArrayMapNode.prototype.iterate = HashCollisionNode.prototype.iterate = function(fn, reverse) {
        var entries = this.entries;
        for(var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++){
            if (fn(entries[reverse ? maxIndex - ii : ii]) === false) return false;
        }
    };
    BitmapIndexedNode.prototype.iterate = HashArrayMapNode.prototype.iterate = function(fn, reverse) {
        var nodes = this.nodes;
        for(var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++){
            var node = nodes[reverse ? maxIndex - ii : ii];
            if (node && node.iterate(fn, reverse) === false) return false;
        }
    };
    ValueNode.prototype.iterate = function(fn, reverse) {
        return fn(this.entry);
    };
    createClass(MapIterator, Iterator);
    function MapIterator(map, type, reverse) {
        this._type = type;
        this._reverse = reverse;
        this._stack = map._root && mapIteratorFrame(map._root);
    }
    MapIterator.prototype.next = function() {
        var type = this._type;
        var stack = this._stack;
        while(stack){
            var node = stack.node;
            var index = stack.index++;
            var maxIndex;
            if (node.entry) {
                if (index === 0) return mapIteratorValue(type, node.entry);
            } else if (node.entries) {
                maxIndex = node.entries.length - 1;
                if (index <= maxIndex) return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
            } else {
                maxIndex = node.nodes.length - 1;
                if (index <= maxIndex) {
                    var subNode = node.nodes[this._reverse ? maxIndex - index : index];
                    if (subNode) {
                        if (subNode.entry) return mapIteratorValue(type, subNode.entry);
                        stack = this._stack = mapIteratorFrame(subNode, stack);
                    }
                    continue;
                }
            }
            stack = this._stack = this._stack.__prev;
        }
        return iteratorDone();
    };
    function mapIteratorValue(type, entry) {
        return iteratorValue(type, entry[0], entry[1]);
    }
    function mapIteratorFrame(node, prev) {
        return {
            node: node,
            index: 0,
            __prev: prev
        };
    }
    function makeMap(size, root, ownerID, hash) {
        var map = Object.create(MapPrototype);
        map.size = size;
        map._root = root;
        map.__ownerID = ownerID;
        map.__hash = hash;
        map.__altered = false;
        return map;
    }
    var EMPTY_MAP;
    function emptyMap() {
        return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
    }
    function updateMap(map, k, v) {
        var newRoot;
        var newSize;
        if (!map._root) {
            if (v === NOT_SET) return map;
            newSize = 1;
            newRoot = new ArrayMapNode(map.__ownerID, [
                [
                    k,
                    v
                ]
            ]);
        } else {
            var didChangeSize = MakeRef(CHANGE_LENGTH);
            var didAlter = MakeRef(DID_ALTER);
            newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
            if (!didAlter.value) return map;
            newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
        }
        if (map.__ownerID) {
            map.size = newSize;
            map._root = newRoot;
            map.__hash = undefined;
            map.__altered = true;
            return map;
        }
        return newRoot ? makeMap(newSize, newRoot) : emptyMap();
    }
    function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
        if (!node) {
            if (value === NOT_SET) return node;
            SetRef(didAlter);
            SetRef(didChangeSize);
            return new ValueNode(ownerID, keyHash, [
                key,
                value
            ]);
        }
        return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
    }
    function isLeafNode(node) {
        return node.constructor === ValueNode || node.constructor === HashCollisionNode;
    }
    function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
        if (node.keyHash === keyHash) return new HashCollisionNode(ownerID, keyHash, [
            node.entry,
            entry
        ]);
        var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
        var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
        var newNode;
        var nodes = idx1 === idx2 ? [
            mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)
        ] : (newNode = new ValueNode(ownerID, keyHash, entry), idx1 < idx2 ? [
            node,
            newNode
        ] : [
            newNode,
            node
        ]);
        return new BitmapIndexedNode(ownerID, 1 << idx1 | 1 << idx2, nodes);
    }
    function createNodes(ownerID, entries, key, value) {
        if (!ownerID) ownerID = new OwnerID();
        var node = new ValueNode(ownerID, hash(key), [
            key,
            value
        ]);
        for(var ii = 0; ii < entries.length; ii++){
            var entry = entries[ii];
            node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
        }
        return node;
    }
    function packNodes(ownerID, nodes, count, excluding) {
        var bitmap = 0;
        var packedII = 0;
        var packedNodes = new Array(count);
        for(var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1){
            var node = nodes[ii];
            if (node !== undefined && ii !== excluding) {
                bitmap |= bit;
                packedNodes[packedII++] = node;
            }
        }
        return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
    }
    function expandNodes(ownerID, nodes, bitmap, including, node) {
        var count = 0;
        var expandedNodes = new Array(SIZE);
        for(var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1)expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
        expandedNodes[including] = node;
        return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
    }
    function mergeIntoMapWith(map, merger, iterables) {
        var iters = [];
        for(var ii = 0; ii < iterables.length; ii++){
            var value = iterables[ii];
            var iter = KeyedIterable(value);
            if (!isIterable(value)) iter = iter.map(function(v) {
                return fromJS(v);
            });
            iters.push(iter);
        }
        return mergeIntoCollectionWith(map, merger, iters);
    }
    function deepMerger(existing, value, key) {
        return existing && existing.mergeDeep && isIterable(value) ? existing.mergeDeep(value) : is(existing, value) ? existing : value;
    }
    function deepMergerWith(merger) {
        return function(existing, value, key) {
            if (existing && existing.mergeDeepWith && isIterable(value)) return existing.mergeDeepWith(merger, value);
            var nextValue = merger(existing, value, key);
            return is(existing, nextValue) ? existing : nextValue;
        };
    }
    function mergeIntoCollectionWith(collection, merger, iters) {
        iters = iters.filter(function(x) {
            return x.size !== 0;
        });
        if (iters.length === 0) return collection;
        if (collection.size === 0 && !collection.__ownerID && iters.length === 1) return collection.constructor(iters[0]);
        return collection.withMutations(function(collection) {
            var mergeIntoMap = merger ? function(value, key) {
                collection.update(key, NOT_SET, function(existing) {
                    return existing === NOT_SET ? value : merger(existing, value, key);
                });
            } : function(value, key) {
                collection.set(key, value);
            };
            for(var ii = 0; ii < iters.length; ii++)iters[ii].forEach(mergeIntoMap);
        });
    }
    function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
        var isNotSet = existing === NOT_SET;
        var step = keyPathIter.next();
        if (step.done) {
            var existingValue = isNotSet ? notSetValue : existing;
            var newValue = updater(existingValue);
            return newValue === existingValue ? existing : newValue;
        }
        invariant(isNotSet || existing && existing.set, "invalid keyPath");
        var key = step.value;
        var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
        var nextUpdated = updateInDeepMap(nextExisting, keyPathIter, notSetValue, updater);
        return nextUpdated === nextExisting ? existing : nextUpdated === NOT_SET ? existing.remove(key) : (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
    }
    function popCount(x) {
        x = x - (x >> 1 & 0x55555555);
        x = (x & 0x33333333) + (x >> 2 & 0x33333333);
        x = x + (x >> 4) & 0x0f0f0f0f;
        x = x + (x >> 8);
        x = x + (x >> 16);
        return x & 0x7f;
    }
    function setIn(array, idx, val, canEdit) {
        var newArray = canEdit ? array : arrCopy(array);
        newArray[idx] = val;
        return newArray;
    }
    function spliceIn(array, idx, val, canEdit) {
        var newLen = array.length + 1;
        if (canEdit && idx + 1 === newLen) {
            array[idx] = val;
            return array;
        }
        var newArray = new Array(newLen);
        var after = 0;
        for(var ii = 0; ii < newLen; ii++)if (ii === idx) {
            newArray[ii] = val;
            after = -1;
        } else newArray[ii] = array[ii + after];
        return newArray;
    }
    function spliceOut(array, idx, canEdit) {
        var newLen = array.length - 1;
        if (canEdit && idx === newLen) {
            array.pop();
            return array;
        }
        var newArray = new Array(newLen);
        var after = 0;
        for(var ii = 0; ii < newLen; ii++){
            if (ii === idx) after = 1;
            newArray[ii] = array[ii + after];
        }
        return newArray;
    }
    var MAX_ARRAY_MAP_SIZE = SIZE / 4;
    var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
    var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
    createClass(List, IndexedCollection);
    // @pragma Construction
    function List(value) {
        var empty = emptyList();
        if (value === null || value === undefined) return empty;
        if (isList(value)) return value;
        var iter = IndexedIterable(value);
        var size = iter.size;
        if (size === 0) return empty;
        assertNotInfinite(size);
        if (size > 0 && size < SIZE) return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
        return empty.withMutations(function(list) {
            list.setSize(size);
            iter.forEach(function(v, i) {
                return list.set(i, v);
            });
        });
    }
    List.of = function() {
        return this(arguments);
    };
    List.prototype.toString = function() {
        return this.__toString("List [", "]");
    };
    // @pragma Access
    List.prototype.get = function(index, notSetValue) {
        index = wrapIndex(this, index);
        if (index >= 0 && index < this.size) {
            index += this._origin;
            var node = listNodeFor(this, index);
            return node && node.array[index & MASK];
        }
        return notSetValue;
    };
    // @pragma Modification
    List.prototype.set = function(index, value) {
        return updateList(this, index, value);
    };
    List.prototype.remove = function(index) {
        return !this.has(index) ? this : index === 0 ? this.shift() : index === this.size - 1 ? this.pop() : this.splice(index, 1);
    };
    List.prototype.insert = function(index, value) {
        return this.splice(index, 0, value);
    };
    List.prototype.clear = function() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = this._origin = this._capacity = 0;
            this._level = SHIFT;
            this._root = this._tail = null;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyList();
    };
    List.prototype.push = function() {
        var values = arguments;
        var oldSize = this.size;
        return this.withMutations(function(list) {
            setListBounds(list, 0, oldSize + values.length);
            for(var ii = 0; ii < values.length; ii++)list.set(oldSize + ii, values[ii]);
        });
    };
    List.prototype.pop = function() {
        return setListBounds(this, 0, -1);
    };
    List.prototype.unshift = function() {
        var values = arguments;
        return this.withMutations(function(list) {
            setListBounds(list, -values.length);
            for(var ii = 0; ii < values.length; ii++)list.set(ii, values[ii]);
        });
    };
    List.prototype.shift = function() {
        return setListBounds(this, 1);
    };
    // @pragma Composition
    List.prototype.merge = function() {
        return mergeIntoListWith(this, undefined, arguments);
    };
    List.prototype.mergeWith = function(merger) {
        var iters = SLICE$0.call(arguments, 1);
        return mergeIntoListWith(this, merger, iters);
    };
    List.prototype.mergeDeep = function() {
        return mergeIntoListWith(this, deepMerger, arguments);
    };
    List.prototype.mergeDeepWith = function(merger) {
        var iters = SLICE$0.call(arguments, 1);
        return mergeIntoListWith(this, deepMergerWith(merger), iters);
    };
    List.prototype.setSize = function(size) {
        return setListBounds(this, 0, size);
    };
    // @pragma Iteration
    List.prototype.slice = function(begin, end) {
        var size = this.size;
        if (wholeSlice(begin, end, size)) return this;
        return setListBounds(this, resolveBegin(begin, size), resolveEnd(end, size));
    };
    List.prototype.__iterator = function(type, reverse) {
        var index = 0;
        var values = iterateList(this, reverse);
        return new Iterator(function() {
            var value = values();
            return value === DONE ? iteratorDone() : iteratorValue(type, index++, value);
        });
    };
    List.prototype.__iterate = function(fn, reverse) {
        var index = 0;
        var values = iterateList(this, reverse);
        var value;
        while((value = values()) !== DONE){
            if (fn(value, index++, this) === false) break;
        }
        return index;
    };
    List.prototype.__ensureOwner = function(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            this.__ownerID = ownerID;
            return this;
        }
        return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };
    function isList(maybeList) {
        return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
    }
    List.isList = isList;
    var IS_LIST_SENTINEL = "@@__IMMUTABLE_LIST__@@";
    var ListPrototype = List.prototype;
    ListPrototype[IS_LIST_SENTINEL] = true;
    ListPrototype[DELETE] = ListPrototype.remove;
    ListPrototype.setIn = MapPrototype.setIn;
    ListPrototype.deleteIn = ListPrototype.removeIn = MapPrototype.removeIn;
    ListPrototype.update = MapPrototype.update;
    ListPrototype.updateIn = MapPrototype.updateIn;
    ListPrototype.mergeIn = MapPrototype.mergeIn;
    ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
    ListPrototype.withMutations = MapPrototype.withMutations;
    ListPrototype.asMutable = MapPrototype.asMutable;
    ListPrototype.asImmutable = MapPrototype.asImmutable;
    ListPrototype.wasAltered = MapPrototype.wasAltered;
    function VNode(array, ownerID) {
        this.array = array;
        this.ownerID = ownerID;
    }
    // TODO: seems like these methods are very similar
    VNode.prototype.removeBefore = function(ownerID, level, index) {
        if (index === level ? 1 << level : this.array.length === 0) return this;
        var originIndex = index >>> level & MASK;
        if (originIndex >= this.array.length) return new VNode([], ownerID);
        var removingFirst = originIndex === 0;
        var newChild;
        if (level > 0) {
            var oldChild = this.array[originIndex];
            newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
            if (newChild === oldChild && removingFirst) return this;
        }
        if (removingFirst && !newChild) return this;
        var editable = editableVNode(this, ownerID);
        if (!removingFirst) for(var ii = 0; ii < originIndex; ii++)editable.array[ii] = undefined;
        if (newChild) editable.array[originIndex] = newChild;
        return editable;
    };
    VNode.prototype.removeAfter = function(ownerID, level, index) {
        if (index === (level ? 1 << level : 0) || this.array.length === 0) return this;
        var sizeIndex = index - 1 >>> level & MASK;
        if (sizeIndex >= this.array.length) return this;
        var newChild;
        if (level > 0) {
            var oldChild = this.array[sizeIndex];
            newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
            if (newChild === oldChild && sizeIndex === this.array.length - 1) return this;
        }
        var editable = editableVNode(this, ownerID);
        editable.array.splice(sizeIndex + 1);
        if (newChild) editable.array[sizeIndex] = newChild;
        return editable;
    };
    var DONE = {};
    function iterateList(list, reverse) {
        var left = list._origin;
        var right = list._capacity;
        var tailPos = getTailOffset(right);
        var tail = list._tail;
        return iterateNodeOrLeaf(list._root, list._level, 0);
        function iterateNodeOrLeaf(node, level, offset) {
            return level === 0 ? iterateLeaf(node, offset) : iterateNode(node, level, offset);
        }
        function iterateLeaf(node, offset) {
            var array = offset === tailPos ? tail && tail.array : node && node.array;
            var from = offset > left ? 0 : left - offset;
            var to = right - offset;
            if (to > SIZE) to = SIZE;
            return function() {
                if (from === to) return DONE;
                var idx = reverse ? --to : from++;
                return array && array[idx];
            };
        }
        function iterateNode(node, level, offset) {
            var values;
            var array = node && node.array;
            var from = offset > left ? 0 : left - offset >> level;
            var to = (right - offset >> level) + 1;
            if (to > SIZE) to = SIZE;
            return function() {
                do {
                    if (values) {
                        var value = values();
                        if (value !== DONE) return value;
                        values = null;
                    }
                    if (from === to) return DONE;
                    var idx = reverse ? --to : from++;
                    values = iterateNodeOrLeaf(array && array[idx], level - SHIFT, offset + (idx << level));
                }while (true);
            };
        }
    }
    function makeList(origin, capacity, level, root, tail, ownerID, hash) {
        var list = Object.create(ListPrototype);
        list.size = capacity - origin;
        list._origin = origin;
        list._capacity = capacity;
        list._level = level;
        list._root = root;
        list._tail = tail;
        list.__ownerID = ownerID;
        list.__hash = hash;
        list.__altered = false;
        return list;
    }
    var EMPTY_LIST;
    function emptyList() {
        return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
    }
    function updateList(list, index, value) {
        index = wrapIndex(list, index);
        if (index !== index) return list;
        if (index >= list.size || index < 0) return list.withMutations(function(list) {
            index < 0 ? setListBounds(list, index).set(0, value) : setListBounds(list, 0, index + 1).set(index, value);
        });
        index += list._origin;
        var newTail = list._tail;
        var newRoot = list._root;
        var didAlter = MakeRef(DID_ALTER);
        if (index >= getTailOffset(list._capacity)) newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
        else newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
        if (!didAlter.value) return list;
        if (list.__ownerID) {
            list._root = newRoot;
            list._tail = newTail;
            list.__hash = undefined;
            list.__altered = true;
            return list;
        }
        return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
    }
    function updateVNode(node, ownerID, level, index, value, didAlter) {
        var idx = index >>> level & MASK;
        var nodeHas = node && idx < node.array.length;
        if (!nodeHas && value === undefined) return node;
        var newNode;
        if (level > 0) {
            var lowerNode = node && node.array[idx];
            var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
            if (newLowerNode === lowerNode) return node;
            newNode = editableVNode(node, ownerID);
            newNode.array[idx] = newLowerNode;
            return newNode;
        }
        if (nodeHas && node.array[idx] === value) return node;
        SetRef(didAlter);
        newNode = editableVNode(node, ownerID);
        if (value === undefined && idx === newNode.array.length - 1) newNode.array.pop();
        else newNode.array[idx] = value;
        return newNode;
    }
    function editableVNode(node, ownerID) {
        if (ownerID && node && ownerID === node.ownerID) return node;
        return new VNode(node ? node.array.slice() : [], ownerID);
    }
    function listNodeFor(list, rawIndex) {
        if (rawIndex >= getTailOffset(list._capacity)) return list._tail;
        if (rawIndex < 1 << list._level + SHIFT) {
            var node = list._root;
            var level = list._level;
            while(node && level > 0){
                node = node.array[rawIndex >>> level & MASK];
                level -= SHIFT;
            }
            return node;
        }
    }
    function setListBounds(list, begin, end) {
        // Sanitize begin & end using this shorthand for ToInt32(argument)
        // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
        if (begin !== undefined) begin = begin | 0;
        if (end !== undefined) end = end | 0;
        var owner = list.__ownerID || new OwnerID();
        var oldOrigin = list._origin;
        var oldCapacity = list._capacity;
        var newOrigin = oldOrigin + begin;
        var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
        if (newOrigin === oldOrigin && newCapacity === oldCapacity) return list;
        // If it's going to end after it starts, it's empty.
        if (newOrigin >= newCapacity) return list.clear();
        var newLevel = list._level;
        var newRoot = list._root;
        // New origin might need creating a higher root.
        var offsetShift = 0;
        while(newOrigin + offsetShift < 0){
            newRoot = new VNode(newRoot && newRoot.array.length ? [
                undefined,
                newRoot
            ] : [], owner);
            newLevel += SHIFT;
            offsetShift += 1 << newLevel;
        }
        if (offsetShift) {
            newOrigin += offsetShift;
            oldOrigin += offsetShift;
            newCapacity += offsetShift;
            oldCapacity += offsetShift;
        }
        var oldTailOffset = getTailOffset(oldCapacity);
        var newTailOffset = getTailOffset(newCapacity);
        // New size might need creating a higher root.
        while(newTailOffset >= 1 << newLevel + SHIFT){
            newRoot = new VNode(newRoot && newRoot.array.length ? [
                newRoot
            ] : [], owner);
            newLevel += SHIFT;
        }
        // Locate or create the new tail.
        var oldTail = list._tail;
        var newTail = newTailOffset < oldTailOffset ? listNodeFor(list, newCapacity - 1) : newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
        // Merge Tail into tree.
        if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
            newRoot = editableVNode(newRoot, owner);
            var node = newRoot;
            for(var level = newLevel; level > SHIFT; level -= SHIFT){
                var idx = oldTailOffset >>> level & MASK;
                node = node.array[idx] = editableVNode(node.array[idx], owner);
            }
            node.array[oldTailOffset >>> SHIFT & MASK] = oldTail;
        }
        // If the size has been reduced, there's a chance the tail needs to be trimmed.
        if (newCapacity < oldCapacity) newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
        // If the new origin is within the tail, then we do not need a root.
        if (newOrigin >= newTailOffset) {
            newOrigin -= newTailOffset;
            newCapacity -= newTailOffset;
            newLevel = SHIFT;
            newRoot = null;
            newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
        // Otherwise, if the root has been trimmed, garbage collect.
        } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
            offsetShift = 0;
            // Identify the new top root node of the subtree of the old root.
            while(newRoot){
                var beginIndex = newOrigin >>> newLevel & MASK;
                if (beginIndex !== newTailOffset >>> newLevel & MASK) break;
                if (beginIndex) offsetShift += (1 << newLevel) * beginIndex;
                newLevel -= SHIFT;
                newRoot = newRoot.array[beginIndex];
            }
            // Trim the new sides of the new root.
            if (newRoot && newOrigin > oldOrigin) newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
            if (newRoot && newTailOffset < oldTailOffset) newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
            if (offsetShift) {
                newOrigin -= offsetShift;
                newCapacity -= offsetShift;
            }
        }
        if (list.__ownerID) {
            list.size = newCapacity - newOrigin;
            list._origin = newOrigin;
            list._capacity = newCapacity;
            list._level = newLevel;
            list._root = newRoot;
            list._tail = newTail;
            list.__hash = undefined;
            list.__altered = true;
            return list;
        }
        return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
    }
    function mergeIntoListWith(list, merger, iterables) {
        var iters = [];
        var maxSize = 0;
        for(var ii = 0; ii < iterables.length; ii++){
            var value = iterables[ii];
            var iter = IndexedIterable(value);
            if (iter.size > maxSize) maxSize = iter.size;
            if (!isIterable(value)) iter = iter.map(function(v) {
                return fromJS(v);
            });
            iters.push(iter);
        }
        if (maxSize > list.size) list = list.setSize(maxSize);
        return mergeIntoCollectionWith(list, merger, iters);
    }
    function getTailOffset(size) {
        return size < SIZE ? 0 : size - 1 >>> SHIFT << SHIFT;
    }
    createClass(OrderedMap, Map);
    // @pragma Construction
    function OrderedMap(value) {
        return value === null || value === undefined ? emptyOrderedMap() : isOrderedMap(value) ? value : emptyOrderedMap().withMutations(function(map) {
            var iter = KeyedIterable(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v, k) {
                return map.set(k, v);
            });
        });
    }
    OrderedMap.of = function() {
        return this(arguments);
    };
    OrderedMap.prototype.toString = function() {
        return this.__toString("OrderedMap {", "}");
    };
    // @pragma Access
    OrderedMap.prototype.get = function(k, notSetValue) {
        var index = this._map.get(k);
        return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };
    // @pragma Modification
    OrderedMap.prototype.clear = function() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._map.clear();
            this._list.clear();
            return this;
        }
        return emptyOrderedMap();
    };
    OrderedMap.prototype.set = function(k, v) {
        return updateOrderedMap(this, k, v);
    };
    OrderedMap.prototype.remove = function(k) {
        return updateOrderedMap(this, k, NOT_SET);
    };
    OrderedMap.prototype.wasAltered = function() {
        return this._map.wasAltered() || this._list.wasAltered();
    };
    OrderedMap.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        return this._list.__iterate(function(entry) {
            return entry && fn(entry[1], entry[0], this$0);
        }, reverse);
    };
    OrderedMap.prototype.__iterator = function(type, reverse) {
        return this._list.fromEntrySeq().__iterator(type, reverse);
    };
    OrderedMap.prototype.__ensureOwner = function(ownerID) {
        if (ownerID === this.__ownerID) return this;
        var newMap = this._map.__ensureOwner(ownerID);
        var newList = this._list.__ensureOwner(ownerID);
        if (!ownerID) {
            this.__ownerID = ownerID;
            this._map = newMap;
            this._list = newList;
            return this;
        }
        return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };
    function isOrderedMap(maybeOrderedMap) {
        return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
    }
    OrderedMap.isOrderedMap = isOrderedMap;
    OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
    OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
    function makeOrderedMap(map, list, ownerID, hash) {
        var omap = Object.create(OrderedMap.prototype);
        omap.size = map ? map.size : 0;
        omap._map = map;
        omap._list = list;
        omap.__ownerID = ownerID;
        omap.__hash = hash;
        return omap;
    }
    var EMPTY_ORDERED_MAP;
    function emptyOrderedMap() {
        return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
    }
    function updateOrderedMap(omap, k, v) {
        var map = omap._map;
        var list = omap._list;
        var i = map.get(k);
        var has = i !== undefined;
        var newMap;
        var newList;
        if (v === NOT_SET) {
            if (!has) return omap;
            if (list.size >= SIZE && list.size >= map.size * 2) {
                newList = list.filter(function(entry, idx) {
                    return entry !== undefined && i !== idx;
                });
                newMap = newList.toKeyedSeq().map(function(entry) {
                    return entry[0];
                }).flip().toMap();
                if (omap.__ownerID) newMap.__ownerID = newList.__ownerID = omap.__ownerID;
            } else {
                newMap = map.remove(k);
                newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
            }
        } else if (has) {
            if (v === list.get(i)[1]) return omap;
            newMap = map;
            newList = list.set(i, [
                k,
                v
            ]);
        } else {
            newMap = map.set(k, list.size);
            newList = list.set(list.size, [
                k,
                v
            ]);
        }
        if (omap.__ownerID) {
            omap.size = newMap.size;
            omap._map = newMap;
            omap._list = newList;
            omap.__hash = undefined;
            return omap;
        }
        return makeOrderedMap(newMap, newList);
    }
    createClass(ToKeyedSequence, KeyedSeq);
    function ToKeyedSequence(indexed, useKeys) {
        this._iter = indexed;
        this._useKeys = useKeys;
        this.size = indexed.size;
    }
    ToKeyedSequence.prototype.get = function(key, notSetValue) {
        return this._iter.get(key, notSetValue);
    };
    ToKeyedSequence.prototype.has = function(key) {
        return this._iter.has(key);
    };
    ToKeyedSequence.prototype.valueSeq = function() {
        return this._iter.valueSeq();
    };
    ToKeyedSequence.prototype.reverse = function() {
        var this$0 = this;
        var reversedSequence = reverseFactory(this, true);
        if (!this._useKeys) reversedSequence.valueSeq = function() {
            return this$0._iter.toSeq().reverse();
        };
        return reversedSequence;
    };
    ToKeyedSequence.prototype.map = function(mapper, context) {
        var this$0 = this;
        var mappedSequence = mapFactory(this, mapper, context);
        if (!this._useKeys) mappedSequence.valueSeq = function() {
            return this$0._iter.toSeq().map(mapper, context);
        };
        return mappedSequence;
    };
    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        var ii;
        return this._iter.__iterate(this._useKeys ? function(v, k) {
            return fn(v, k, this$0);
        } : (ii = reverse ? resolveSize(this) : 0, function(v) {
            return fn(v, reverse ? --ii : ii++, this$0);
        }), reverse);
    };
    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
        if (this._useKeys) return this._iter.__iterator(type, reverse);
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        var ii = reverse ? resolveSize(this) : 0;
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, reverse ? --ii : ii++, step.value, step);
        });
    };
    ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
    createClass(ToIndexedSequence, IndexedSeq);
    function ToIndexedSequence(iter) {
        this._iter = iter;
        this.size = iter.size;
    }
    ToIndexedSequence.prototype.includes = function(value) {
        return this._iter.includes(value);
    };
    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        var iterations = 0;
        return this._iter.__iterate(function(v) {
            return fn(v, iterations++, this$0);
        }, reverse);
    };
    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        var iterations = 0;
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, iterations++, step.value, step);
        });
    };
    createClass(ToSetSequence, SetSeq);
    function ToSetSequence(iter) {
        this._iter = iter;
        this.size = iter.size;
    }
    ToSetSequence.prototype.has = function(key) {
        return this._iter.includes(key);
    };
    ToSetSequence.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        return this._iter.__iterate(function(v) {
            return fn(v, v, this$0);
        }, reverse);
    };
    ToSetSequence.prototype.__iterator = function(type, reverse) {
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, step.value, step.value, step);
        });
    };
    createClass(FromEntriesSequence, KeyedSeq);
    function FromEntriesSequence(entries) {
        this._iter = entries;
        this.size = entries.size;
    }
    FromEntriesSequence.prototype.entrySeq = function() {
        return this._iter.toSeq();
    };
    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        return this._iter.__iterate(function(entry) {
            // Check if entry exists first so array access doesn't throw for holes
            // in the parent iteration.
            if (entry) {
                validateEntry(entry);
                var indexedIterable = isIterable(entry);
                return fn(indexedIterable ? entry.get(1) : entry[1], indexedIterable ? entry.get(0) : entry[0], this$0);
            }
        }, reverse);
    };
    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        return new Iterator(function() {
            while(true){
                var step = iterator.next();
                if (step.done) return step;
                var entry = step.value;
                // Check if entry exists first so array access doesn't throw for holes
                // in the parent iteration.
                if (entry) {
                    validateEntry(entry);
                    var indexedIterable = isIterable(entry);
                    return iteratorValue(type, indexedIterable ? entry.get(0) : entry[0], indexedIterable ? entry.get(1) : entry[1], step);
                }
            }
        });
    };
    ToIndexedSequence.prototype.cacheResult = ToKeyedSequence.prototype.cacheResult = ToSetSequence.prototype.cacheResult = FromEntriesSequence.prototype.cacheResult = cacheResultThrough;
    function flipFactory(iterable) {
        var flipSequence = makeSequence(iterable);
        flipSequence._iter = iterable;
        flipSequence.size = iterable.size;
        flipSequence.flip = function() {
            return iterable;
        };
        flipSequence.reverse = function() {
            var reversedSequence = iterable.reverse.apply(this); // super.reverse()
            reversedSequence.flip = function() {
                return iterable.reverse();
            };
            return reversedSequence;
        };
        flipSequence.has = function(key) {
            return iterable.includes(key);
        };
        flipSequence.includes = function(key) {
            return iterable.has(key);
        };
        flipSequence.cacheResult = cacheResultThrough;
        flipSequence.__iterateUncached = function(fn, reverse) {
            var this$0 = this;
            return iterable.__iterate(function(v, k) {
                return fn(k, v, this$0) !== false;
            }, reverse);
        };
        flipSequence.__iteratorUncached = function(type, reverse) {
            if (type === ITERATE_ENTRIES) {
                var iterator = iterable.__iterator(type, reverse);
                return new Iterator(function() {
                    var step = iterator.next();
                    if (!step.done) {
                        var k = step.value[0];
                        step.value[0] = step.value[1];
                        step.value[1] = k;
                    }
                    return step;
                });
            }
            return iterable.__iterator(type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES, reverse);
        };
        return flipSequence;
    }
    function mapFactory(iterable, mapper, context) {
        var mappedSequence = makeSequence(iterable);
        mappedSequence.size = iterable.size;
        mappedSequence.has = function(key) {
            return iterable.has(key);
        };
        mappedSequence.get = function(key, notSetValue) {
            var v = iterable.get(key, NOT_SET);
            return v === NOT_SET ? notSetValue : mapper.call(context, v, key, iterable);
        };
        mappedSequence.__iterateUncached = function(fn, reverse) {
            var this$0 = this;
            return iterable.__iterate(function(v, k, c) {
                return fn(mapper.call(context, v, k, c), k, this$0) !== false;
            }, reverse);
        };
        mappedSequence.__iteratorUncached = function(type, reverse) {
            var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
            return new Iterator(function() {
                var step = iterator.next();
                if (step.done) return step;
                var entry = step.value;
                var key = entry[0];
                return iteratorValue(type, key, mapper.call(context, entry[1], key, iterable), step);
            });
        };
        return mappedSequence;
    }
    function reverseFactory(iterable, useKeys) {
        var reversedSequence = makeSequence(iterable);
        reversedSequence._iter = iterable;
        reversedSequence.size = iterable.size;
        reversedSequence.reverse = function() {
            return iterable;
        };
        if (iterable.flip) reversedSequence.flip = function() {
            var flipSequence = flipFactory(iterable);
            flipSequence.reverse = function() {
                return iterable.flip();
            };
            return flipSequence;
        };
        reversedSequence.get = function(key, notSetValue) {
            return iterable.get(useKeys ? key : -1 - key, notSetValue);
        };
        reversedSequence.has = function(key) {
            return iterable.has(useKeys ? key : -1 - key);
        };
        reversedSequence.includes = function(value) {
            return iterable.includes(value);
        };
        reversedSequence.cacheResult = cacheResultThrough;
        reversedSequence.__iterate = function(fn, reverse) {
            var this$0 = this;
            return iterable.__iterate(function(v, k) {
                return fn(v, k, this$0);
            }, !reverse);
        };
        reversedSequence.__iterator = function(type, reverse) {
            return iterable.__iterator(type, !reverse);
        };
        return reversedSequence;
    }
    function filterFactory(iterable, predicate, context, useKeys) {
        var filterSequence = makeSequence(iterable);
        if (useKeys) {
            filterSequence.has = function(key) {
                var v = iterable.get(key, NOT_SET);
                return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
            };
            filterSequence.get = function(key, notSetValue) {
                var v = iterable.get(key, NOT_SET);
                return v !== NOT_SET && predicate.call(context, v, key, iterable) ? v : notSetValue;
            };
        }
        filterSequence.__iterateUncached = function(fn, reverse) {
            var this$0 = this;
            var iterations = 0;
            iterable.__iterate(function(v, k, c) {
                if (predicate.call(context, v, k, c)) {
                    iterations++;
                    return fn(v, useKeys ? k : iterations - 1, this$0);
                }
            }, reverse);
            return iterations;
        };
        filterSequence.__iteratorUncached = function(type, reverse) {
            var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
            var iterations = 0;
            return new Iterator(function() {
                while(true){
                    var step = iterator.next();
                    if (step.done) return step;
                    var entry = step.value;
                    var key = entry[0];
                    var value = entry[1];
                    if (predicate.call(context, value, key, iterable)) return iteratorValue(type, useKeys ? key : iterations++, value, step);
                }
            });
        };
        return filterSequence;
    }
    function countByFactory(iterable, grouper, context) {
        var groups = Map().asMutable();
        iterable.__iterate(function(v, k) {
            groups.update(grouper.call(context, v, k, iterable), 0, function(a) {
                return a + 1;
            });
        });
        return groups.asImmutable();
    }
    function groupByFactory(iterable, grouper, context) {
        var isKeyedIter = isKeyed(iterable);
        var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
        iterable.__iterate(function(v, k) {
            groups.update(grouper.call(context, v, k, iterable), function(a) {
                return a = a || [], a.push(isKeyedIter ? [
                    k,
                    v
                ] : v), a;
            });
        });
        var coerce = iterableClass(iterable);
        return groups.map(function(arr) {
            return reify(iterable, coerce(arr));
        });
    }
    function sliceFactory(iterable, begin, end, useKeys) {
        var originalSize = iterable.size;
        // Sanitize begin & end using this shorthand for ToInt32(argument)
        // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
        if (begin !== undefined) begin = begin | 0;
        if (end !== undefined) {
            if (end === Infinity) end = originalSize;
            else end = end | 0;
        }
        if (wholeSlice(begin, end, originalSize)) return iterable;
        var resolvedBegin = resolveBegin(begin, originalSize);
        var resolvedEnd = resolveEnd(end, originalSize);
        // begin or end will be NaN if they were provided as negative numbers and
        // this iterable's size is unknown. In that case, cache first so there is
        // a known size and these do not resolve to NaN.
        if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
        // Note: resolvedEnd is undefined when the original sequence's length is
        // unknown and this slice did not supply an end and should contain all
        // elements after resolvedBegin.
        // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
        var resolvedSize = resolvedEnd - resolvedBegin;
        var sliceSize;
        if (resolvedSize === resolvedSize) sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
        var sliceSeq = makeSequence(iterable);
        // If iterable.size is undefined, the size of the realized sliceSeq is
        // unknown at this point unless the number of items to slice is 0
        sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
        if (!useKeys && isSeq(iterable) && sliceSize >= 0) sliceSeq.get = function(index, notSetValue) {
            index = wrapIndex(this, index);
            return index >= 0 && index < sliceSize ? iterable.get(index + resolvedBegin, notSetValue) : notSetValue;
        };
        sliceSeq.__iterateUncached = function(fn, reverse) {
            var this$0 = this;
            if (sliceSize === 0) return 0;
            if (reverse) return this.cacheResult().__iterate(fn, reverse);
            var skipped = 0;
            var isSkipping = true;
            var iterations = 0;
            iterable.__iterate(function(v, k) {
                if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
                    iterations++;
                    return fn(v, useKeys ? k : iterations - 1, this$0) !== false && iterations !== sliceSize;
                }
            });
            return iterations;
        };
        sliceSeq.__iteratorUncached = function(type, reverse) {
            if (sliceSize !== 0 && reverse) return this.cacheResult().__iterator(type, reverse);
            // Don't bother instantiating parent iterator if taking 0.
            var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
            var skipped = 0;
            var iterations = 0;
            return new Iterator(function() {
                while(skipped++ < resolvedBegin)iterator.next();
                if (++iterations > sliceSize) return iteratorDone();
                var step = iterator.next();
                if (useKeys || type === ITERATE_VALUES) return step;
                else if (type === ITERATE_KEYS) return iteratorValue(type, iterations - 1, undefined, step);
                else return iteratorValue(type, iterations - 1, step.value[1], step);
            });
        };
        return sliceSeq;
    }
    function takeWhileFactory(iterable, predicate, context) {
        var takeSequence = makeSequence(iterable);
        takeSequence.__iterateUncached = function(fn, reverse) {
            var this$0 = this;
            if (reverse) return this.cacheResult().__iterate(fn, reverse);
            var iterations = 0;
            iterable.__iterate(function(v, k, c) {
                return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0);
            });
            return iterations;
        };
        takeSequence.__iteratorUncached = function(type, reverse) {
            var this$0 = this;
            if (reverse) return this.cacheResult().__iterator(type, reverse);
            var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
            var iterating = true;
            return new Iterator(function() {
                if (!iterating) return iteratorDone();
                var step = iterator.next();
                if (step.done) return step;
                var entry = step.value;
                var k = entry[0];
                var v = entry[1];
                if (!predicate.call(context, v, k, this$0)) {
                    iterating = false;
                    return iteratorDone();
                }
                return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
            });
        };
        return takeSequence;
    }
    function skipWhileFactory(iterable, predicate, context, useKeys) {
        var skipSequence = makeSequence(iterable);
        skipSequence.__iterateUncached = function(fn, reverse) {
            var this$0 = this;
            if (reverse) return this.cacheResult().__iterate(fn, reverse);
            var isSkipping = true;
            var iterations = 0;
            iterable.__iterate(function(v, k, c) {
                if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
                    iterations++;
                    return fn(v, useKeys ? k : iterations - 1, this$0);
                }
            });
            return iterations;
        };
        skipSequence.__iteratorUncached = function(type, reverse) {
            var this$0 = this;
            if (reverse) return this.cacheResult().__iterator(type, reverse);
            var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
            var skipping = true;
            var iterations = 0;
            return new Iterator(function() {
                var step, k, v;
                do {
                    step = iterator.next();
                    if (step.done) {
                        if (useKeys || type === ITERATE_VALUES) return step;
                        else if (type === ITERATE_KEYS) return iteratorValue(type, iterations++, undefined, step);
                        else return iteratorValue(type, iterations++, step.value[1], step);
                    }
                    var entry = step.value;
                    k = entry[0];
                    v = entry[1];
                    skipping && (skipping = predicate.call(context, v, k, this$0));
                }while (skipping);
                return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
            });
        };
        return skipSequence;
    }
    function concatFactory(iterable, values) {
        var isKeyedIterable = isKeyed(iterable);
        var iters = [
            iterable
        ].concat(values).map(function(v) {
            if (!isIterable(v)) v = isKeyedIterable ? keyedSeqFromValue(v) : indexedSeqFromValue(Array.isArray(v) ? v : [
                v
            ]);
            else if (isKeyedIterable) v = KeyedIterable(v);
            return v;
        }).filter(function(v) {
            return v.size !== 0;
        });
        if (iters.length === 0) return iterable;
        if (iters.length === 1) {
            var singleton = iters[0];
            if (singleton === iterable || isKeyedIterable && isKeyed(singleton) || isIndexed(iterable) && isIndexed(singleton)) return singleton;
        }
        var concatSeq = new ArraySeq(iters);
        if (isKeyedIterable) concatSeq = concatSeq.toKeyedSeq();
        else if (!isIndexed(iterable)) concatSeq = concatSeq.toSetSeq();
        concatSeq = concatSeq.flatten(true);
        concatSeq.size = iters.reduce(function(sum, seq) {
            if (sum !== undefined) {
                var size = seq.size;
                if (size !== undefined) return sum + size;
            }
        }, 0);
        return concatSeq;
    }
    function flattenFactory(iterable, depth, useKeys) {
        var flatSequence = makeSequence(iterable);
        flatSequence.__iterateUncached = function(fn, reverse) {
            var iterations = 0;
            var stopped = false;
            function flatDeep(iter, currentDepth) {
                var this$0 = this;
                iter.__iterate(function(v, k) {
                    if ((!depth || currentDepth < depth) && isIterable(v)) flatDeep(v, currentDepth + 1);
                    else if (fn(v, useKeys ? k : iterations++, this$0) === false) stopped = true;
                    return !stopped;
                }, reverse);
            }
            flatDeep(iterable, 0);
            return iterations;
        };
        flatSequence.__iteratorUncached = function(type, reverse) {
            var iterator = iterable.__iterator(type, reverse);
            var stack = [];
            var iterations = 0;
            return new Iterator(function() {
                while(iterator){
                    var step = iterator.next();
                    if (step.done !== false) {
                        iterator = stack.pop();
                        continue;
                    }
                    var v = step.value;
                    if (type === ITERATE_ENTRIES) v = v[1];
                    if ((!depth || stack.length < depth) && isIterable(v)) {
                        stack.push(iterator);
                        iterator = v.__iterator(type, reverse);
                    } else return useKeys ? step : iteratorValue(type, iterations++, v, step);
                }
                return iteratorDone();
            });
        };
        return flatSequence;
    }
    function flatMapFactory(iterable, mapper, context) {
        var coerce = iterableClass(iterable);
        return iterable.toSeq().map(function(v, k) {
            return coerce(mapper.call(context, v, k, iterable));
        }).flatten(true);
    }
    function interposeFactory(iterable, separator) {
        var interposedSequence = makeSequence(iterable);
        interposedSequence.size = iterable.size && iterable.size * 2 - 1;
        interposedSequence.__iterateUncached = function(fn, reverse) {
            var this$0 = this;
            var iterations = 0;
            iterable.__iterate(function(v, k) {
                return (!iterations || fn(separator, iterations++, this$0) !== false) && fn(v, iterations++, this$0) !== false;
            }, reverse);
            return iterations;
        };
        interposedSequence.__iteratorUncached = function(type, reverse) {
            var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
            var iterations = 0;
            var step;
            return new Iterator(function() {
                if (!step || iterations % 2) {
                    step = iterator.next();
                    if (step.done) return step;
                }
                return iterations % 2 ? iteratorValue(type, iterations++, separator) : iteratorValue(type, iterations++, step.value, step);
            });
        };
        return interposedSequence;
    }
    function sortFactory(iterable, comparator, mapper) {
        if (!comparator) comparator = defaultComparator;
        var isKeyedIterable = isKeyed(iterable);
        var index = 0;
        var entries = iterable.toSeq().map(function(v, k) {
            return [
                k,
                v,
                index++,
                mapper ? mapper(v, k, iterable) : v
            ];
        }).toArray();
        entries.sort(function(a, b) {
            return comparator(a[3], b[3]) || a[2] - b[2];
        }).forEach(isKeyedIterable ? function(v, i) {
            entries[i].length = 2;
        } : function(v, i) {
            entries[i] = v[1];
        });
        return isKeyedIterable ? KeyedSeq(entries) : isIndexed(iterable) ? IndexedSeq(entries) : SetSeq(entries);
    }
    function maxFactory(iterable, comparator, mapper) {
        if (!comparator) comparator = defaultComparator;
        if (mapper) {
            var entry = iterable.toSeq().map(function(v, k) {
                return [
                    v,
                    mapper(v, k, iterable)
                ];
            }).reduce(function(a, b) {
                return maxCompare(comparator, a[1], b[1]) ? b : a;
            });
            return entry && entry[0];
        } else return iterable.reduce(function(a, b) {
            return maxCompare(comparator, a, b) ? b : a;
        });
    }
    function maxCompare(comparator, a, b) {
        var comp = comparator(b, a);
        // b is considered the new max if the comparator declares them equal, but
        // they are not equal and b is in fact a nullish value.
        return comp === 0 && b !== a && (b === undefined || b === null || b !== b) || comp > 0;
    }
    function zipWithFactory(keyIter, zipper, iters) {
        var zipSequence = makeSequence(keyIter);
        zipSequence.size = new ArraySeq(iters).map(function(i) {
            return i.size;
        }).min();
        // Note: this a generic base implementation of __iterate in terms of
        // __iterator which may be more generically useful in the future.
        zipSequence.__iterate = function(fn, reverse) {
            /* generic:
      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        iterations++;
        if (fn(step.value[1], step.value[0], this) === false) {
          break;
        }
      }
      return iterations;
      */ // indexed:
            var iterator = this.__iterator(ITERATE_VALUES, reverse);
            var step;
            var iterations = 0;
            while(!(step = iterator.next()).done){
                if (fn(step.value, iterations++, this) === false) break;
            }
            return iterations;
        };
        zipSequence.__iteratorUncached = function(type, reverse) {
            var iterators = iters.map(function(i) {
                return i = Iterable(i), getIterator(reverse ? i.reverse() : i);
            });
            var iterations = 0;
            var isDone = false;
            return new Iterator(function() {
                var steps;
                if (!isDone) {
                    steps = iterators.map(function(i) {
                        return i.next();
                    });
                    isDone = steps.some(function(s) {
                        return s.done;
                    });
                }
                if (isDone) return iteratorDone();
                return iteratorValue(type, iterations++, zipper.apply(null, steps.map(function(s) {
                    return s.value;
                })));
            });
        };
        return zipSequence;
    }
    // #pragma Helper Functions
    function reify(iter, seq) {
        return isSeq(iter) ? seq : iter.constructor(seq);
    }
    function validateEntry(entry) {
        if (entry !== Object(entry)) throw new TypeError("Expected [K, V] tuple: " + entry);
    }
    function resolveSize(iter) {
        assertNotInfinite(iter.size);
        return ensureSize(iter);
    }
    function iterableClass(iterable) {
        return isKeyed(iterable) ? KeyedIterable : isIndexed(iterable) ? IndexedIterable : SetIterable;
    }
    function makeSequence(iterable) {
        return Object.create((isKeyed(iterable) ? KeyedSeq : isIndexed(iterable) ? IndexedSeq : SetSeq).prototype);
    }
    function cacheResultThrough() {
        if (this._iter.cacheResult) {
            this._iter.cacheResult();
            this.size = this._iter.size;
            return this;
        } else return Seq.prototype.cacheResult.call(this);
    }
    function defaultComparator(a, b) {
        return a > b ? 1 : a < b ? -1 : 0;
    }
    function forceIterator(keyPath) {
        var iter = getIterator(keyPath);
        if (!iter) {
            // Array might not be iterable in this environment, so we need a fallback
            // to our wrapped type.
            if (!isArrayLike(keyPath)) throw new TypeError("Expected iterable or array-like: " + keyPath);
            iter = getIterator(Iterable(keyPath));
        }
        return iter;
    }
    createClass(Record, KeyedCollection);
    function Record(defaultValues, name) {
        var hasInitialized;
        var RecordType = function Record(values) {
            if (values instanceof RecordType) return values;
            if (!(this instanceof RecordType)) return new RecordType(values);
            if (!hasInitialized) {
                hasInitialized = true;
                var keys = Object.keys(defaultValues);
                setProps(RecordTypePrototype, keys);
                RecordTypePrototype.size = keys.length;
                RecordTypePrototype._name = name;
                RecordTypePrototype._keys = keys;
                RecordTypePrototype._defaultValues = defaultValues;
            }
            this._map = Map(values);
        };
        var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
        RecordTypePrototype.constructor = RecordType;
        return RecordType;
    }
    Record.prototype.toString = function() {
        return this.__toString(recordName(this) + " {", "}");
    };
    // @pragma Access
    Record.prototype.has = function(k) {
        return this._defaultValues.hasOwnProperty(k);
    };
    Record.prototype.get = function(k, notSetValue) {
        if (!this.has(k)) return notSetValue;
        var defaultVal = this._defaultValues[k];
        return this._map ? this._map.get(k, defaultVal) : defaultVal;
    };
    // @pragma Modification
    Record.prototype.clear = function() {
        if (this.__ownerID) {
            this._map && this._map.clear();
            return this;
        }
        var RecordType = this.constructor;
        return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
    };
    Record.prototype.set = function(k, v) {
        if (!this.has(k)) throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
        if (this._map && !this._map.has(k)) {
            var defaultVal = this._defaultValues[k];
            if (v === defaultVal) return this;
        }
        var newMap = this._map && this._map.set(k, v);
        if (this.__ownerID || newMap === this._map) return this;
        return makeRecord(this, newMap);
    };
    Record.prototype.remove = function(k) {
        if (!this.has(k)) return this;
        var newMap = this._map && this._map.remove(k);
        if (this.__ownerID || newMap === this._map) return this;
        return makeRecord(this, newMap);
    };
    Record.prototype.wasAltered = function() {
        return this._map.wasAltered();
    };
    Record.prototype.__iterator = function(type, reverse) {
        var this$0 = this;
        return KeyedIterable(this._defaultValues).map(function(_, k) {
            return this$0.get(k);
        }).__iterator(type, reverse);
    };
    Record.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        return KeyedIterable(this._defaultValues).map(function(_, k) {
            return this$0.get(k);
        }).__iterate(fn, reverse);
    };
    Record.prototype.__ensureOwner = function(ownerID) {
        if (ownerID === this.__ownerID) return this;
        var newMap = this._map && this._map.__ensureOwner(ownerID);
        if (!ownerID) {
            this.__ownerID = ownerID;
            this._map = newMap;
            return this;
        }
        return makeRecord(this, newMap, ownerID);
    };
    var RecordPrototype = Record.prototype;
    RecordPrototype[DELETE] = RecordPrototype.remove;
    RecordPrototype.deleteIn = RecordPrototype.removeIn = MapPrototype.removeIn;
    RecordPrototype.merge = MapPrototype.merge;
    RecordPrototype.mergeWith = MapPrototype.mergeWith;
    RecordPrototype.mergeIn = MapPrototype.mergeIn;
    RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
    RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
    RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
    RecordPrototype.setIn = MapPrototype.setIn;
    RecordPrototype.update = MapPrototype.update;
    RecordPrototype.updateIn = MapPrototype.updateIn;
    RecordPrototype.withMutations = MapPrototype.withMutations;
    RecordPrototype.asMutable = MapPrototype.asMutable;
    RecordPrototype.asImmutable = MapPrototype.asImmutable;
    function makeRecord(likeRecord, map, ownerID) {
        var record = Object.create(Object.getPrototypeOf(likeRecord));
        record._map = map;
        record.__ownerID = ownerID;
        return record;
    }
    function recordName(record) {
        return record._name || record.constructor.name || "Record";
    }
    function setProps(prototype, names) {
        try {
            names.forEach(setProp.bind(undefined, prototype));
        } catch (error) {
        // Object.defineProperty failed. Probably IE8.
        }
    }
    function setProp(prototype, name) {
        Object.defineProperty(prototype, name, {
            get: function() {
                return this.get(name);
            },
            set: function(value) {
                invariant(this.__ownerID, "Cannot set on an immutable record.");
                this.set(name, value);
            }
        });
    }
    createClass(Set, SetCollection);
    // @pragma Construction
    function Set(value) {
        return value === null || value === undefined ? emptySet() : isSet(value) && !isOrdered(value) ? value : emptySet().withMutations(function(set) {
            var iter = SetIterable(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v) {
                return set.add(v);
            });
        });
    }
    Set.of = function() {
        return this(arguments);
    };
    Set.fromKeys = function(value) {
        return this(KeyedIterable(value).keySeq());
    };
    Set.prototype.toString = function() {
        return this.__toString("Set {", "}");
    };
    // @pragma Access
    Set.prototype.has = function(value) {
        return this._map.has(value);
    };
    // @pragma Modification
    Set.prototype.add = function(value) {
        return updateSet(this, this._map.set(value, true));
    };
    Set.prototype.remove = function(value) {
        return updateSet(this, this._map.remove(value));
    };
    Set.prototype.clear = function() {
        return updateSet(this, this._map.clear());
    };
    // @pragma Composition
    Set.prototype.union = function() {
        var iters = SLICE$0.call(arguments, 0);
        iters = iters.filter(function(x) {
            return x.size !== 0;
        });
        if (iters.length === 0) return this;
        if (this.size === 0 && !this.__ownerID && iters.length === 1) return this.constructor(iters[0]);
        return this.withMutations(function(set) {
            for(var ii = 0; ii < iters.length; ii++)SetIterable(iters[ii]).forEach(function(value) {
                return set.add(value);
            });
        });
    };
    Set.prototype.intersect = function() {
        var iters = SLICE$0.call(arguments, 0);
        if (iters.length === 0) return this;
        iters = iters.map(function(iter) {
            return SetIterable(iter);
        });
        var originalSet = this;
        return this.withMutations(function(set) {
            originalSet.forEach(function(value) {
                if (!iters.every(function(iter) {
                    return iter.includes(value);
                })) set.remove(value);
            });
        });
    };
    Set.prototype.subtract = function() {
        var iters = SLICE$0.call(arguments, 0);
        if (iters.length === 0) return this;
        iters = iters.map(function(iter) {
            return SetIterable(iter);
        });
        var originalSet = this;
        return this.withMutations(function(set) {
            originalSet.forEach(function(value) {
                if (iters.some(function(iter) {
                    return iter.includes(value);
                })) set.remove(value);
            });
        });
    };
    Set.prototype.merge = function() {
        return this.union.apply(this, arguments);
    };
    Set.prototype.mergeWith = function(merger) {
        var iters = SLICE$0.call(arguments, 1);
        return this.union.apply(this, iters);
    };
    Set.prototype.sort = function(comparator) {
        // Late binding
        return OrderedSet(sortFactory(this, comparator));
    };
    Set.prototype.sortBy = function(mapper, comparator) {
        // Late binding
        return OrderedSet(sortFactory(this, comparator, mapper));
    };
    Set.prototype.wasAltered = function() {
        return this._map.wasAltered();
    };
    Set.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        return this._map.__iterate(function(_, k) {
            return fn(k, k, this$0);
        }, reverse);
    };
    Set.prototype.__iterator = function(type, reverse) {
        return this._map.map(function(_, k) {
            return k;
        }).__iterator(type, reverse);
    };
    Set.prototype.__ensureOwner = function(ownerID) {
        if (ownerID === this.__ownerID) return this;
        var newMap = this._map.__ensureOwner(ownerID);
        if (!ownerID) {
            this.__ownerID = ownerID;
            this._map = newMap;
            return this;
        }
        return this.__make(newMap, ownerID);
    };
    function isSet(maybeSet) {
        return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
    }
    Set.isSet = isSet;
    var IS_SET_SENTINEL = "@@__IMMUTABLE_SET__@@";
    var SetPrototype = Set.prototype;
    SetPrototype[IS_SET_SENTINEL] = true;
    SetPrototype[DELETE] = SetPrototype.remove;
    SetPrototype.mergeDeep = SetPrototype.merge;
    SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
    SetPrototype.withMutations = MapPrototype.withMutations;
    SetPrototype.asMutable = MapPrototype.asMutable;
    SetPrototype.asImmutable = MapPrototype.asImmutable;
    SetPrototype.__empty = emptySet;
    SetPrototype.__make = makeSet;
    function updateSet(set, newMap) {
        if (set.__ownerID) {
            set.size = newMap.size;
            set._map = newMap;
            return set;
        }
        return newMap === set._map ? set : newMap.size === 0 ? set.__empty() : set.__make(newMap);
    }
    function makeSet(map, ownerID) {
        var set = Object.create(SetPrototype);
        set.size = map ? map.size : 0;
        set._map = map;
        set.__ownerID = ownerID;
        return set;
    }
    var EMPTY_SET;
    function emptySet() {
        return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
    }
    createClass(OrderedSet, Set);
    // @pragma Construction
    function OrderedSet(value) {
        return value === null || value === undefined ? emptyOrderedSet() : isOrderedSet(value) ? value : emptyOrderedSet().withMutations(function(set) {
            var iter = SetIterable(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v) {
                return set.add(v);
            });
        });
    }
    OrderedSet.of = function() {
        return this(arguments);
    };
    OrderedSet.fromKeys = function(value) {
        return this(KeyedIterable(value).keySeq());
    };
    OrderedSet.prototype.toString = function() {
        return this.__toString("OrderedSet {", "}");
    };
    function isOrderedSet(maybeOrderedSet) {
        return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
    }
    OrderedSet.isOrderedSet = isOrderedSet;
    var OrderedSetPrototype = OrderedSet.prototype;
    OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
    OrderedSetPrototype.__empty = emptyOrderedSet;
    OrderedSetPrototype.__make = makeOrderedSet;
    function makeOrderedSet(map, ownerID) {
        var set = Object.create(OrderedSetPrototype);
        set.size = map ? map.size : 0;
        set._map = map;
        set.__ownerID = ownerID;
        return set;
    }
    var EMPTY_ORDERED_SET;
    function emptyOrderedSet() {
        return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
    }
    createClass(Stack, IndexedCollection);
    // @pragma Construction
    function Stack(value) {
        return value === null || value === undefined ? emptyStack() : isStack(value) ? value : emptyStack().unshiftAll(value);
    }
    Stack.of = function() {
        return this(arguments);
    };
    Stack.prototype.toString = function() {
        return this.__toString("Stack [", "]");
    };
    // @pragma Access
    Stack.prototype.get = function(index, notSetValue) {
        var head = this._head;
        index = wrapIndex(this, index);
        while(head && index--)head = head.next;
        return head ? head.value : notSetValue;
    };
    Stack.prototype.peek = function() {
        return this._head && this._head.value;
    };
    // @pragma Modification
    Stack.prototype.push = function() {
        if (arguments.length === 0) return this;
        var newSize = this.size + arguments.length;
        var head = this._head;
        for(var ii = arguments.length - 1; ii >= 0; ii--)head = {
            value: arguments[ii],
            next: head
        };
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    Stack.prototype.pushAll = function(iter) {
        iter = IndexedIterable(iter);
        if (iter.size === 0) return this;
        assertNotInfinite(iter.size);
        var newSize = this.size;
        var head = this._head;
        iter.reverse().forEach(function(value) {
            newSize++;
            head = {
                value: value,
                next: head
            };
        });
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    Stack.prototype.pop = function() {
        return this.slice(1);
    };
    Stack.prototype.unshift = function() {
        return this.push.apply(this, arguments);
    };
    Stack.prototype.unshiftAll = function(iter) {
        return this.pushAll(iter);
    };
    Stack.prototype.shift = function() {
        return this.pop.apply(this, arguments);
    };
    Stack.prototype.clear = function() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._head = undefined;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyStack();
    };
    Stack.prototype.slice = function(begin, end) {
        if (wholeSlice(begin, end, this.size)) return this;
        var resolvedBegin = resolveBegin(begin, this.size);
        var resolvedEnd = resolveEnd(end, this.size);
        if (resolvedEnd !== this.size) // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
        var newSize = this.size - resolvedBegin;
        var head = this._head;
        while(resolvedBegin--)head = head.next;
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    // @pragma Mutability
    Stack.prototype.__ensureOwner = function(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return makeStack(this.size, this._head, ownerID, this.__hash);
    };
    // @pragma Iteration
    Stack.prototype.__iterate = function(fn, reverse) {
        if (reverse) return this.reverse().__iterate(fn);
        var iterations = 0;
        var node = this._head;
        while(node){
            if (fn(node.value, iterations++, this) === false) break;
            node = node.next;
        }
        return iterations;
    };
    Stack.prototype.__iterator = function(type, reverse) {
        if (reverse) return this.reverse().__iterator(type);
        var iterations = 0;
        var node = this._head;
        return new Iterator(function() {
            if (node) {
                var value = node.value;
                node = node.next;
                return iteratorValue(type, iterations++, value);
            }
            return iteratorDone();
        });
    };
    function isStack(maybeStack) {
        return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
    }
    Stack.isStack = isStack;
    var IS_STACK_SENTINEL = "@@__IMMUTABLE_STACK__@@";
    var StackPrototype = Stack.prototype;
    StackPrototype[IS_STACK_SENTINEL] = true;
    StackPrototype.withMutations = MapPrototype.withMutations;
    StackPrototype.asMutable = MapPrototype.asMutable;
    StackPrototype.asImmutable = MapPrototype.asImmutable;
    StackPrototype.wasAltered = MapPrototype.wasAltered;
    function makeStack(size, head, ownerID, hash) {
        var map = Object.create(StackPrototype);
        map.size = size;
        map._head = head;
        map.__ownerID = ownerID;
        map.__hash = hash;
        map.__altered = false;
        return map;
    }
    var EMPTY_STACK;
    function emptyStack() {
        return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
    }
    /**
   * Contributes additional methods to a constructor
   */ function mixin(ctor, methods) {
        var keyCopier = function(key) {
            ctor.prototype[key] = methods[key];
        };
        Object.keys(methods).forEach(keyCopier);
        Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(methods).forEach(keyCopier);
        return ctor;
    }
    Iterable.Iterator = Iterator;
    mixin(Iterable, {
        // ### Conversion to other types
        toArray: function() {
            assertNotInfinite(this.size);
            var array = new Array(this.size || 0);
            this.valueSeq().__iterate(function(v, i) {
                array[i] = v;
            });
            return array;
        },
        toIndexedSeq: function() {
            return new ToIndexedSequence(this);
        },
        toJS: function() {
            return this.toSeq().map(function(value) {
                return value && typeof value.toJS === "function" ? value.toJS() : value;
            }).__toJS();
        },
        toJSON: function() {
            return this.toSeq().map(function(value) {
                return value && typeof value.toJSON === "function" ? value.toJSON() : value;
            }).__toJS();
        },
        toKeyedSeq: function() {
            return new ToKeyedSequence(this, true);
        },
        toMap: function() {
            // Use Late Binding here to solve the circular dependency.
            return Map(this.toKeyedSeq());
        },
        toObject: function() {
            assertNotInfinite(this.size);
            var object = {};
            this.__iterate(function(v, k) {
                object[k] = v;
            });
            return object;
        },
        toOrderedMap: function() {
            // Use Late Binding here to solve the circular dependency.
            return OrderedMap(this.toKeyedSeq());
        },
        toOrderedSet: function() {
            // Use Late Binding here to solve the circular dependency.
            return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
        },
        toSet: function() {
            // Use Late Binding here to solve the circular dependency.
            return Set(isKeyed(this) ? this.valueSeq() : this);
        },
        toSetSeq: function() {
            return new ToSetSequence(this);
        },
        toSeq: function() {
            return isIndexed(this) ? this.toIndexedSeq() : isKeyed(this) ? this.toKeyedSeq() : this.toSetSeq();
        },
        toStack: function() {
            // Use Late Binding here to solve the circular dependency.
            return Stack(isKeyed(this) ? this.valueSeq() : this);
        },
        toList: function() {
            // Use Late Binding here to solve the circular dependency.
            return List(isKeyed(this) ? this.valueSeq() : this);
        },
        // ### Common JavaScript methods and properties
        toString: function() {
            return "[Iterable]";
        },
        __toString: function(head, tail) {
            if (this.size === 0) return head + tail;
            return head + " " + this.toSeq().map(this.__toStringMapper).join(", ") + " " + tail;
        },
        // ### ES6 Collection methods (ES6 Array and Map)
        concat: function() {
            var values = SLICE$0.call(arguments, 0);
            return reify(this, concatFactory(this, values));
        },
        includes: function(searchValue) {
            return this.some(function(value) {
                return is(value, searchValue);
            });
        },
        entries: function() {
            return this.__iterator(ITERATE_ENTRIES);
        },
        every: function(predicate, context) {
            assertNotInfinite(this.size);
            var returnValue = true;
            this.__iterate(function(v, k, c) {
                if (!predicate.call(context, v, k, c)) {
                    returnValue = false;
                    return false;
                }
            });
            return returnValue;
        },
        filter: function(predicate, context) {
            return reify(this, filterFactory(this, predicate, context, true));
        },
        find: function(predicate, context, notSetValue) {
            var entry = this.findEntry(predicate, context);
            return entry ? entry[1] : notSetValue;
        },
        forEach: function(sideEffect, context) {
            assertNotInfinite(this.size);
            return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
        },
        join: function(separator) {
            assertNotInfinite(this.size);
            separator = separator !== undefined ? "" + separator : ",";
            var joined = "";
            var isFirst = true;
            this.__iterate(function(v) {
                isFirst ? isFirst = false : joined += separator;
                joined += v !== null && v !== undefined ? v.toString() : "";
            });
            return joined;
        },
        keys: function() {
            return this.__iterator(ITERATE_KEYS);
        },
        map: function(mapper, context) {
            return reify(this, mapFactory(this, mapper, context));
        },
        reduce: function(reducer, initialReduction, context) {
            assertNotInfinite(this.size);
            var reduction;
            var useFirst;
            if (arguments.length < 2) useFirst = true;
            else reduction = initialReduction;
            this.__iterate(function(v, k, c) {
                if (useFirst) {
                    useFirst = false;
                    reduction = v;
                } else reduction = reducer.call(context, reduction, v, k, c);
            });
            return reduction;
        },
        reduceRight: function(reducer, initialReduction, context) {
            var reversed = this.toKeyedSeq().reverse();
            return reversed.reduce.apply(reversed, arguments);
        },
        reverse: function() {
            return reify(this, reverseFactory(this, true));
        },
        slice: function(begin, end) {
            return reify(this, sliceFactory(this, begin, end, true));
        },
        some: function(predicate, context) {
            return !this.every(not(predicate), context);
        },
        sort: function(comparator) {
            return reify(this, sortFactory(this, comparator));
        },
        values: function() {
            return this.__iterator(ITERATE_VALUES);
        },
        // ### More sequential methods
        butLast: function() {
            return this.slice(0, -1);
        },
        isEmpty: function() {
            return this.size !== undefined ? this.size === 0 : !this.some(function() {
                return true;
            });
        },
        count: function(predicate, context) {
            return ensureSize(predicate ? this.toSeq().filter(predicate, context) : this);
        },
        countBy: function(grouper, context) {
            return countByFactory(this, grouper, context);
        },
        equals: function(other) {
            return deepEqual(this, other);
        },
        entrySeq: function() {
            var iterable = this;
            if (iterable._cache) // We cache as an entries array, so we can just return the cache!
            return new ArraySeq(iterable._cache);
            var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
            entriesSequence.fromEntrySeq = function() {
                return iterable.toSeq();
            };
            return entriesSequence;
        },
        filterNot: function(predicate, context) {
            return this.filter(not(predicate), context);
        },
        findEntry: function(predicate, context, notSetValue) {
            var found = notSetValue;
            this.__iterate(function(v, k, c) {
                if (predicate.call(context, v, k, c)) {
                    found = [
                        k,
                        v
                    ];
                    return false;
                }
            });
            return found;
        },
        findKey: function(predicate, context) {
            var entry = this.findEntry(predicate, context);
            return entry && entry[0];
        },
        findLast: function(predicate, context, notSetValue) {
            return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
        },
        findLastEntry: function(predicate, context, notSetValue) {
            return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
        },
        findLastKey: function(predicate, context) {
            return this.toKeyedSeq().reverse().findKey(predicate, context);
        },
        first: function() {
            return this.find(returnTrue);
        },
        flatMap: function(mapper, context) {
            return reify(this, flatMapFactory(this, mapper, context));
        },
        flatten: function(depth) {
            return reify(this, flattenFactory(this, depth, true));
        },
        fromEntrySeq: function() {
            return new FromEntriesSequence(this);
        },
        get: function(searchKey, notSetValue) {
            return this.find(function(_, key) {
                return is(key, searchKey);
            }, undefined, notSetValue);
        },
        getIn: function(searchKeyPath, notSetValue) {
            var nested = this;
            // Note: in an ES6 environment, we would prefer:
            // for (var key of searchKeyPath) {
            var iter = forceIterator(searchKeyPath);
            var step;
            while(!(step = iter.next()).done){
                var key = step.value;
                nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
                if (nested === NOT_SET) return notSetValue;
            }
            return nested;
        },
        groupBy: function(grouper, context) {
            return groupByFactory(this, grouper, context);
        },
        has: function(searchKey) {
            return this.get(searchKey, NOT_SET) !== NOT_SET;
        },
        hasIn: function(searchKeyPath) {
            return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
        },
        isSubset: function(iter) {
            iter = typeof iter.includes === "function" ? iter : Iterable(iter);
            return this.every(function(value) {
                return iter.includes(value);
            });
        },
        isSuperset: function(iter) {
            iter = typeof iter.isSubset === "function" ? iter : Iterable(iter);
            return iter.isSubset(this);
        },
        keyOf: function(searchValue) {
            return this.findKey(function(value) {
                return is(value, searchValue);
            });
        },
        keySeq: function() {
            return this.toSeq().map(keyMapper).toIndexedSeq();
        },
        last: function() {
            return this.toSeq().reverse().first();
        },
        lastKeyOf: function(searchValue) {
            return this.toKeyedSeq().reverse().keyOf(searchValue);
        },
        max: function(comparator) {
            return maxFactory(this, comparator);
        },
        maxBy: function(mapper, comparator) {
            return maxFactory(this, comparator, mapper);
        },
        min: function(comparator) {
            return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
        },
        minBy: function(mapper, comparator) {
            return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
        },
        rest: function() {
            return this.slice(1);
        },
        skip: function(amount) {
            return this.slice(Math.max(0, amount));
        },
        skipLast: function(amount) {
            return reify(this, this.toSeq().reverse().skip(amount).reverse());
        },
        skipWhile: function(predicate, context) {
            return reify(this, skipWhileFactory(this, predicate, context, true));
        },
        skipUntil: function(predicate, context) {
            return this.skipWhile(not(predicate), context);
        },
        sortBy: function(mapper, comparator) {
            return reify(this, sortFactory(this, comparator, mapper));
        },
        take: function(amount) {
            return this.slice(0, Math.max(0, amount));
        },
        takeLast: function(amount) {
            return reify(this, this.toSeq().reverse().take(amount).reverse());
        },
        takeWhile: function(predicate, context) {
            return reify(this, takeWhileFactory(this, predicate, context));
        },
        takeUntil: function(predicate, context) {
            return this.takeWhile(not(predicate), context);
        },
        valueSeq: function() {
            return this.toIndexedSeq();
        },
        // ### Hashable Object
        hashCode: function() {
            return this.__hash || (this.__hash = hashIterable(this));
        }
    });
    // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
    // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
    // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
    // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
    var IterablePrototype = Iterable.prototype;
    IterablePrototype[IS_ITERABLE_SENTINEL] = true;
    IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
    IterablePrototype.__toJS = IterablePrototype.toArray;
    IterablePrototype.__toStringMapper = quoteString;
    IterablePrototype.inspect = IterablePrototype.toSource = function() {
        return this.toString();
    };
    IterablePrototype.chain = IterablePrototype.flatMap;
    IterablePrototype.contains = IterablePrototype.includes;
    mixin(KeyedIterable, {
        // ### More sequential methods
        flip: function() {
            return reify(this, flipFactory(this));
        },
        mapEntries: function(mapper, context) {
            var this$0 = this;
            var iterations = 0;
            return reify(this, this.toSeq().map(function(v, k) {
                return mapper.call(context, [
                    k,
                    v
                ], iterations++, this$0);
            }).fromEntrySeq());
        },
        mapKeys: function(mapper, context) {
            var this$0 = this;
            return reify(this, this.toSeq().flip().map(function(k, v) {
                return mapper.call(context, k, v, this$0);
            }).flip());
        }
    });
    var KeyedIterablePrototype = KeyedIterable.prototype;
    KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
    KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
    KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
    KeyedIterablePrototype.__toStringMapper = function(v, k) {
        return JSON.stringify(k) + ": " + quoteString(v);
    };
    mixin(IndexedIterable, {
        // ### Conversion to other types
        toKeyedSeq: function() {
            return new ToKeyedSequence(this, false);
        },
        // ### ES6 Collection methods (ES6 Array and Map)
        filter: function(predicate, context) {
            return reify(this, filterFactory(this, predicate, context, false));
        },
        findIndex: function(predicate, context) {
            var entry = this.findEntry(predicate, context);
            return entry ? entry[0] : -1;
        },
        indexOf: function(searchValue) {
            var key = this.keyOf(searchValue);
            return key === undefined ? -1 : key;
        },
        lastIndexOf: function(searchValue) {
            var key = this.lastKeyOf(searchValue);
            return key === undefined ? -1 : key;
        },
        reverse: function() {
            return reify(this, reverseFactory(this, false));
        },
        slice: function(begin, end) {
            return reify(this, sliceFactory(this, begin, end, false));
        },
        splice: function(index, removeNum /*, ...values*/ ) {
            var numArgs = arguments.length;
            removeNum = Math.max(removeNum | 0, 0);
            if (numArgs === 0 || numArgs === 2 && !removeNum) return this;
            // If index is negative, it should resolve relative to the size of the
            // collection. However size may be expensive to compute if not cached, so
            // only call count() if the number is in fact negative.
            index = resolveBegin(index, index < 0 ? this.count() : this.size);
            var spliced = this.slice(0, index);
            return reify(this, numArgs === 1 ? spliced : spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum)));
        },
        // ### More collection methods
        findLastIndex: function(predicate, context) {
            var entry = this.findLastEntry(predicate, context);
            return entry ? entry[0] : -1;
        },
        first: function() {
            return this.get(0);
        },
        flatten: function(depth) {
            return reify(this, flattenFactory(this, depth, false));
        },
        get: function(index, notSetValue) {
            index = wrapIndex(this, index);
            return index < 0 || this.size === Infinity || this.size !== undefined && index > this.size ? notSetValue : this.find(function(_, key) {
                return key === index;
            }, undefined, notSetValue);
        },
        has: function(index) {
            index = wrapIndex(this, index);
            return index >= 0 && (this.size !== undefined ? this.size === Infinity || index < this.size : this.indexOf(index) !== -1);
        },
        interpose: function(separator) {
            return reify(this, interposeFactory(this, separator));
        },
        interleave: function() {
            var iterables = [
                this
            ].concat(arrCopy(arguments));
            var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
            var interleaved = zipped.flatten(true);
            if (zipped.size) interleaved.size = zipped.size * iterables.length;
            return reify(this, interleaved);
        },
        keySeq: function() {
            return Range(0, this.size);
        },
        last: function() {
            return this.get(-1);
        },
        skipWhile: function(predicate, context) {
            return reify(this, skipWhileFactory(this, predicate, context, false));
        },
        zip: function() {
            var iterables = [
                this
            ].concat(arrCopy(arguments));
            return reify(this, zipWithFactory(this, defaultZipper, iterables));
        },
        zipWith: function(zipper /*, ...iterables */ ) {
            var iterables = arrCopy(arguments);
            iterables[0] = this;
            return reify(this, zipWithFactory(this, zipper, iterables));
        }
    });
    IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
    IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
    mixin(SetIterable, {
        // ### ES6 Collection methods (ES6 Array and Map)
        get: function(value, notSetValue) {
            return this.has(value) ? value : notSetValue;
        },
        includes: function(value) {
            return this.has(value);
        },
        // ### More sequential methods
        keySeq: function() {
            return this.valueSeq();
        }
    });
    SetIterable.prototype.has = IterablePrototype.includes;
    SetIterable.prototype.contains = SetIterable.prototype.includes;
    // Mixin subclasses
    mixin(KeyedSeq, KeyedIterable.prototype);
    mixin(IndexedSeq, IndexedIterable.prototype);
    mixin(SetSeq, SetIterable.prototype);
    mixin(KeyedCollection, KeyedIterable.prototype);
    mixin(IndexedCollection, IndexedIterable.prototype);
    mixin(SetCollection, SetIterable.prototype);
    // #pragma Helper functions
    function keyMapper(v, k) {
        return k;
    }
    function entryMapper(v, k) {
        return [
            k,
            v
        ];
    }
    function not(predicate) {
        return function() {
            return !predicate.apply(this, arguments);
        };
    }
    function neg(predicate) {
        return function() {
            return -predicate.apply(this, arguments);
        };
    }
    function quoteString(value) {
        return typeof value === "string" ? JSON.stringify(value) : String(value);
    }
    function defaultZipper() {
        return arrCopy(arguments);
    }
    function defaultNegComparator(a, b) {
        return a < b ? 1 : a > b ? -1 : 0;
    }
    function hashIterable(iterable) {
        if (iterable.size === Infinity) return 0;
        var ordered = isOrdered(iterable);
        var keyed = isKeyed(iterable);
        var h = ordered ? 1 : 0;
        var size = iterable.__iterate(keyed ? ordered ? function(v, k) {
            h = 31 * h + hashMerge(hash(v), hash(k)) | 0;
        } : function(v, k) {
            h = h + hashMerge(hash(v), hash(k)) | 0;
        } : ordered ? function(v) {
            h = 31 * h + hash(v) | 0;
        } : function(v) {
            h = h + hash(v) | 0;
        });
        return murmurHashOfSize(size, h);
    }
    function murmurHashOfSize(size, h) {
        h = imul(h, 0xCC9E2D51);
        h = imul(h << 15 | h >>> -15, 0x1B873593);
        h = imul(h << 13 | h >>> -13, 5);
        h = (h + 0xE6546B64 | 0) ^ size;
        h = imul(h ^ h >>> 16, 0x85EBCA6B);
        h = imul(h ^ h >>> 13, 0xC2B2AE35);
        h = smi(h ^ h >>> 16);
        return h;
    }
    function hashMerge(a, b) {
        return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
    }
    var Immutable = {
        Iterable: Iterable,
        Seq: Seq,
        Collection: Collection,
        Map: Map,
        OrderedMap: OrderedMap,
        List: List,
        Stack: Stack,
        Set: Set,
        OrderedSet: OrderedSet,
        Record: Record,
        Range: Range,
        Repeat: Repeat,
        is: is,
        fromJS: fromJS
    };
    return Immutable;
});

});

parcelRegister("2MXkj", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $207e1580ce2d117e$var$ReactIs, $207e1580ce2d117e$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("i0REB"))();

});
parcelRegister("i0REB", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $dzB8n = parcelRequire("dzB8n");
function $d1d1d8a14bceeb20$var$emptyFunction() {}
function $d1d1d8a14bceeb20$var$emptyFunctionWithReset() {}
$d1d1d8a14bceeb20$var$emptyFunctionWithReset.resetWarningCache = $d1d1d8a14bceeb20$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $dzB8n) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $d1d1d8a14bceeb20$var$emptyFunctionWithReset,
        resetWarningCache: $d1d1d8a14bceeb20$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("dzB8n", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $9e1b5953bf5c2bbd$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $9e1b5953bf5c2bbd$var$ReactPropTypesSecret;

});




parcelRegister("8JX5d", function(module, exports) {

$parcel$export(module.exports, "numberInputContainerMixin", function () { return $65d05b64c3056331$export$9fea7d9ed57891d2; });
parcelRequire("jbmdS");
parcelRequire("e64Mn");

var $e8Hda = parcelRequire("e8Hda");

var $2MXkj = parcelRequire("2MXkj");

var $iVCd9 = parcelRequire("iVCd9");
function $65d05b64c3056331$export$9fea7d9ed57891d2() {
    /**
   * Used both for `NumberInputContainer` and `AutosizeNumber`. Might be better
   * to have a generic component that uses can use <input> or <AutosizeInput>
   * in `render`.
   */ function executeAction(event) {
        // Delegates to the `executeAction` method defined by `actionMixin` (which
        // is assumed to have also been mixed in by the component that mixed in
        // `numberInputContainerMixin`).
        let allowNull = this.props.allowNull;
        let val = parseNumberInput(event.target.value);
        if ((0, $e8Hda.parsesToFloat)(val) || allowNull && val === "") {
            let floatVal = allowNull ? parseFloat(val) || "" : parseFloat(val);
            if (this.props.action != null) this.executeAction(floatVal);
            else if (this.props.onChange != null) this.props.onChange(floatVal);
        }
    }
    function parseNumberInput(str) {
        try {
            return $iVCd9.evaluate(str) != undefined ? $iVCd9.evaluate(str) : "";
        } catch (e) {
            //if math.eval fails just pass string
            return $65d05b64c3056331$var$withoutCommas(str);
        }
    }
    return {
        propTypes: {
            executeActionOn: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).oneOf([
                "change",
                "blur"
            ]).isRequired
        },
        getDefaultProps: function() {
            return {
                executeActionOn: "change"
            };
        },
        componentWillMount: function() {
            this.setState({
                value: this.props.formatFunc(this.props.value)
            });
            this._executeAction = executeAction.bind(this);
        },
        componentWillReceiveProps: function(newProps) {
            if (document.activeElement !== this.refs.input) this.setState({
                value: this.props.formatFunc(newProps.value)
            });
        },
        handleBlur: function(event) {
            let val = parseNumberInput(event.target.value);
            if ((0, $e8Hda.isNumber)(val) || this.props.allowNull && val === "") {
                this.setState({
                    value: this.props.formatFunc(val)
                });
                if (this.props.onBlur != null) this.props.onBlur(val);
                this._executeAction(event);
            }
        },
        handleChange: function(event) {
            this.setState({
                value: event.target.value
            });
            if (this.props.executeActionOn === "change") {
                let val = $65d05b64c3056331$var$withoutCommas(event.target.value);
                if (this.isValid(val)) {
                    let floatVal = parseFloat(val);
                    if (this.props.action != null) this.executeAction(floatVal);
                    else this.props.onChange(floatVal);
                }
            }
        },
        handleKeyPress: function(event) {
            if (event.key === "Enter") this.refs.input.blur();
        },
        isValid: function(s) {
            if (this.props.allowNegative) return (0, $e8Hda.parsesToFloat)(s);
            else return (0, $e8Hda.parsesToFloat)(s) && s[0] !== "-";
        }
    };
}
function $65d05b64c3056331$var$withoutCommas(s) {
    return s.replace(/,/g, "");
}

});


parcelRegister("c86dX", function(module, exports) {

$parcel$export(module.exports, "MultiSelect", function () { return $02476779609d10c6$export$1e7dfd31545b5809; });
$parcel$export(module.exports, "ContactMultiselect", function () { return $02476779609d10c6$export$f9f8f6b0e5f1c453; });
$parcel$export(module.exports, "CostCentreMultiselect", function () { return $02476779609d10c6$export$ef8707dd53afea2f; });
$parcel$export(module.exports, "StaffMultiselect", function () { return $02476779609d10c6$export$f96d64fc1a4b19e2; });
$parcel$export(module.exports, "RoleMultiselect", function () { return $02476779609d10c6$export$801e8b331eb2dab1; });
$parcel$export(module.exports, "ProjectMultiselect", function () { return $02476779609d10c6$export$7a235d80d83c6a8e; });
$parcel$export(module.exports, "PhaseMultiselect", function () { return $02476779609d10c6$export$a4a08043e3ebad40; });
$parcel$export(module.exports, "StatusMultiselect", function () { return $02476779609d10c6$export$2976fe8217f8bc8b; });
$parcel$export(module.exports, "OverheadMultiselect", function () { return $02476779609d10c6$export$813f87fed43da137; });
$parcel$export(module.exports, "TaskMultiselect", function () { return $02476779609d10c6$export$b4641764ee571138; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("jbmdS");

var $bhvQG = parcelRequire("bhvQG");

var $eNcHX = parcelRequire("eNcHX");

var $htkeB = parcelRequire("htkeB");

var $eat5C = parcelRequire("eat5C");

var $XoImS = parcelRequire("XoImS");

var $bxXv3 = parcelRequire("bxXv3");

var $ikffN = parcelRequire("ikffN");

var $gJT7h = parcelRequire("gJT7h");

var $cfp1m = parcelRequire("cfp1m");

var $6OUQ7 = parcelRequire("6OUQ7");

var $keGWP = parcelRequire("keGWP");

var $1UDCR = parcelRequire("1UDCR");
const $02476779609d10c6$var$statusOrder = [
    "active",
    "prospective",
    "onHold",
    "archived"
];
const $02476779609d10c6$export$1e7dfd31545b5809 = ({ selectedOptions: selectedOptions = [], options: options = [], onChange: onChange = ()=>null, searchMatcher: searchMatcher, optionLabel: optionLabel, optionValue: optionValue, groupBy: groupBy, ...props })=>{
    selectedOptions = selectedOptions || [];
    options = options || [];
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6OUQ7.default), {
        selectedOptions: [
            ...selectedOptions
        ],
        options: [
            ...options
        ],
        getOptionLabel: optionLabel,
        getOptionValue: optionValue,
        onChange: onChange,
        filter: searchMatcher,
        groupBy: groupBy,
        ...props
    });
};
const $02476779609d10c6$export$f9f8f6b0e5f1c453 = ({ selectedContacts: selectedContacts, contactOptions: contactOptions, onChange: onChange, ...props })=>{
    let options = contactOptions || (0, $bhvQG.default).contacts;
    return /*#__PURE__*/ (0, $61Ea1.jsx)($02476779609d10c6$export$1e7dfd31545b5809, {
        selectedOptions: selectedContacts,
        onChange: onChange,
        options: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).orderBy(options, [
            "label"
        ], [
            "asc"
        ]),
        optionLabel: (c)=>c === null || c === void 0 ? void 0 : c.label,
        optionValue: (sm)=>sm === null || sm === void 0 ? void 0 : sm.id,
        searchMatcher: (c, text)=>{
            var _c$label, _c$label$toLowerCase, _c$label$toLowerCase$, _c$label$toLowerCase$2;
            return c === null || c === void 0 ? void 0 : (_c$label = c.label) === null || _c$label === void 0 ? void 0 : (_c$label$toLowerCase = _c$label.toLowerCase) === null || _c$label$toLowerCase === void 0 ? void 0 : (_c$label$toLowerCase$ = _c$label$toLowerCase.call(_c$label)) === null || _c$label$toLowerCase$ === void 0 ? void 0 : (_c$label$toLowerCase$2 = _c$label$toLowerCase$.match) === null || _c$label$toLowerCase$2 === void 0 ? void 0 : _c$label$toLowerCase$2.call(_c$label$toLowerCase$, text.toLowerCase());
        },
        ...props
    });
};
const $02476779609d10c6$export$ef8707dd53afea2f = ({ selectedCostCentres: selectedCostCentres, costCentreOptions: costCentreOptions, onChange: onChange, ...props })=>{
    let options = costCentreOptions || (0, $eNcHX.default).costCentres;
    return /*#__PURE__*/ (0, $61Ea1.jsx)($02476779609d10c6$export$1e7dfd31545b5809, {
        selectedOptions: selectedCostCentres,
        onChange: onChange,
        options: [
            ...(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).orderBy(options, [
                "name"
            ], [
                "asc"
            ])
        ],
        optionLabel: (cc)=>cc === null || cc === void 0 ? void 0 : cc.name,
        optionValue: (sm)=>sm === null || sm === void 0 ? void 0 : sm.id,
        searchMatcher: (cc, text)=>{
            var _cc$name, _cc$name$toLowerCase, _cc$name$toLowerCase$, _cc$name$toLowerCase$2;
            return cc === null || cc === void 0 ? void 0 : (_cc$name = cc.name) === null || _cc$name === void 0 ? void 0 : (_cc$name$toLowerCase = _cc$name.toLowerCase) === null || _cc$name$toLowerCase === void 0 ? void 0 : (_cc$name$toLowerCase$ = _cc$name$toLowerCase.call(_cc$name)) === null || _cc$name$toLowerCase$ === void 0 ? void 0 : (_cc$name$toLowerCase$2 = _cc$name$toLowerCase$.match) === null || _cc$name$toLowerCase$2 === void 0 ? void 0 : _cc$name$toLowerCase$2.call(_cc$name$toLowerCase$, text.toLowerCase());
        },
        ...props
    });
};
const $02476779609d10c6$export$f96d64fc1a4b19e2 = ({ selectedStaffMembers: selectedStaffMembers, staffOptions: staffOptions, onChange: onChange, ...props })=>{
    let options = staffOptions || (0, $htkeB.default).staffs;
    return /*#__PURE__*/ (0, $61Ea1.jsx)($02476779609d10c6$export$1e7dfd31545b5809, {
        selectedOptions: selectedStaffMembers,
        onChange: onChange,
        options: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).orderBy(options, [
            "fullName"
        ], [
            "asc"
        ]),
        optionLabel: (sm)=>sm === null || sm === void 0 ? void 0 : sm.fullName,
        optionValue: (sm)=>sm === null || sm === void 0 ? void 0 : sm.id,
        groupBy: (sm)=>sm.isArchived ? "Archived" : "Active",
        sortGroups: (a, b)=>a.label === "Archived" ? 1 : -1,
        searchMatcher: (sm, text)=>{
            var _sm$fullName, _sm$fullName$toLowerC, _sm$fullName$toLowerC2, _sm$fullName$toLowerC3;
            return sm === null || sm === void 0 ? void 0 : (_sm$fullName = sm.fullName) === null || _sm$fullName === void 0 ? void 0 : (_sm$fullName$toLowerC = _sm$fullName.toLowerCase) === null || _sm$fullName$toLowerC === void 0 ? void 0 : (_sm$fullName$toLowerC2 = _sm$fullName$toLowerC.call(_sm$fullName)) === null || _sm$fullName$toLowerC2 === void 0 ? void 0 : (_sm$fullName$toLowerC3 = _sm$fullName$toLowerC2.match) === null || _sm$fullName$toLowerC3 === void 0 ? void 0 : _sm$fullName$toLowerC3.call(_sm$fullName$toLowerC2, text.toLowerCase());
        },
        ...props
    });
};
const $02476779609d10c6$export$801e8b331eb2dab1 = ({ selectedRoles: selectedRoles, roleOptions: roleOptions, onChange: onChange, ...props })=>{
    let options = roleOptions || (0, $bxXv3.default).roles;
    return /*#__PURE__*/ (0, $61Ea1.jsx)($02476779609d10c6$export$1e7dfd31545b5809, {
        selectedOptions: selectedRoles,
        onChange: onChange,
        options: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).orderBy(options, [
            "name"
        ], [
            "asc"
        ]),
        optionLabel: (sm)=>sm === null || sm === void 0 ? void 0 : sm.name,
        optionValue: (sm)=>sm === null || sm === void 0 ? void 0 : sm.id,
        groupBy: (sm)=>sm.isArchived ? "Archived" : "Active",
        sortGroups: (a, b)=>a.label === "Archived" ? 1 : -1,
        searchMatcher: (sm, text)=>{
            var _sm$name, _sm$name$toLowerCase, _sm$name$toLowerCase$, _sm$name$toLowerCase$2;
            return sm === null || sm === void 0 ? void 0 : (_sm$name = sm.name) === null || _sm$name === void 0 ? void 0 : (_sm$name$toLowerCase = _sm$name.toLowerCase) === null || _sm$name$toLowerCase === void 0 ? void 0 : (_sm$name$toLowerCase$ = _sm$name$toLowerCase.call(_sm$name)) === null || _sm$name$toLowerCase$ === void 0 ? void 0 : (_sm$name$toLowerCase$2 = _sm$name$toLowerCase$.match) === null || _sm$name$toLowerCase$2 === void 0 ? void 0 : _sm$name$toLowerCase$2.call(_sm$name$toLowerCase$, text.toLowerCase());
        },
        ...props
    });
};
const $02476779609d10c6$export$7a235d80d83c6a8e = ({ selectedProjects: selectedProjects, projectOptions: projectOptions, onChange: onChange, ...props })=>{
    let options = projectOptions || (0, $gJT7h.default).projects;
    return /*#__PURE__*/ (0, $61Ea1.jsx)($02476779609d10c6$export$1e7dfd31545b5809, {
        selectedOptions: selectedProjects,
        onChange: onChange,
        options: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).orderBy(options, [
            "title"
        ], [
            "asc"
        ]),
        optionLabel: (sm)=>sm === null || sm === void 0 ? void 0 : sm.title,
        optionValue: (sm)=>sm === null || sm === void 0 ? void 0 : sm.id,
        groupBy: (sm)=>sm.status,
        sortGroups: (a, b)=>{
            return $02476779609d10c6$var$statusOrder.indexOf(a.label) - $02476779609d10c6$var$statusOrder.indexOf(b.label);
        },
        searchMatcher: (sm, text)=>{
            var _sm$title, _sm$title$toLowerCase, _sm$title$toLowerCase2, _sm$title$toLowerCase3;
            return sm === null || sm === void 0 ? void 0 : (_sm$title = sm.title) === null || _sm$title === void 0 ? void 0 : (_sm$title$toLowerCase = _sm$title.toLowerCase) === null || _sm$title$toLowerCase === void 0 ? void 0 : (_sm$title$toLowerCase2 = _sm$title$toLowerCase.call(_sm$title)) === null || _sm$title$toLowerCase2 === void 0 ? void 0 : (_sm$title$toLowerCase3 = _sm$title$toLowerCase2.match) === null || _sm$title$toLowerCase3 === void 0 ? void 0 : _sm$title$toLowerCase3.call(_sm$title$toLowerCase2, text.toLowerCase());
        },
        ...props
    });
};
const $02476779609d10c6$export$a4a08043e3ebad40 = ({ selectedPhases: selectedPhases, phaseOptions: phaseOptions, onChange: onChange, ...props })=>{
    let options = phaseOptions || (0, $XoImS.default).phases;
    return /*#__PURE__*/ (0, $61Ea1.jsx)($02476779609d10c6$export$1e7dfd31545b5809, {
        selectedOptions: selectedPhases,
        onChange: onChange,
        options: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).orderBy(options, [
            "title"
        ], [
            "asc"
        ]),
        optionLabel: (sm)=>sm === null || sm === void 0 ? void 0 : sm.title,
        optionValue: (sm)=>sm === null || sm === void 0 ? void 0 : sm.id,
        groupBy: (sm)=>sm.status,
        sortGroups: (a, b)=>{
            return $02476779609d10c6$var$statusOrder.indexOf(a.label) - $02476779609d10c6$var$statusOrder.indexOf(b.label);
        },
        searchMatcher: (sm, text)=>sm.title.toLowerCase().match(text.toLowerCase()),
        ...props
    });
};
const $02476779609d10c6$export$2976fe8217f8bc8b = ({ selectedStatuses: selectedStatuses, onChange: onChange, placeholderLabel: placeholderLabel, ...props })=>{
    var _selectedStatuses;
    (_selectedStatuses = selectedStatuses) !== null && _selectedStatuses !== void 0 ? _selectedStatuses : selectedStatuses = [];
    return /*#__PURE__*/ (0, $61Ea1.jsx)($02476779609d10c6$export$1e7dfd31545b5809, {
        selectedOptions: selectedStatuses.map((s)=>({
                value: s
            })),
        onChange: (options)=>onChange(options.map((o)=>o.value)),
        options: [
            {
                value: "active"
            },
            {
                value: "onHold"
            },
            {
                value: "prospective"
            },
            {
                value: "archived"
            }
        ],
        // sort={(c) => c.label}
        optionLabel: (o)=>(0, $ikffN.capitalCase)(String((o === null || o === void 0 ? void 0 : o.value) || "")),
        optionValue: (o)=>o.value,
        ...props
    });
};
const $02476779609d10c6$export$5ebd5a69c40fb058 = ({ selectedExpenses: selectedExpenses, onChange: onChange, placeholderLabel: placeholderLabel, ...props })=>{
    var _selectedExpenses;
    (_selectedExpenses = selectedExpenses) !== null && _selectedExpenses !== void 0 ? _selectedExpenses : selectedExpenses = [];
    return /*#__PURE__*/ (0, $61Ea1.jsx)($02476779609d10c6$export$1e7dfd31545b5809, {
        selectedOptions: selectedExpenses.map((e)=>({
                value: e
            })),
        onChange: (options)=>onChange(options.map((o)=>o.value)),
        options: [
            ...new Set((0, $cfp1m.default).projectExpenses.map((e)=>e.name))
        ].map((e)=>({
                value: e
            })),
        // sort={(c) => c.label}
        optionLabel: (s)=>(0, $ikffN.capitalCase)(String((s === null || s === void 0 ? void 0 : s.value) || "")),
        optionValue: (o)=>o.value,
        ...props
    });
};
const $02476779609d10c6$export$813f87fed43da137 = ({ selectedExpenses: selectedExpenses, expenseOptions: expenseOptions, onChange: onChange, ...props })=>{
    let options = expenseOptions || (0, $1UDCR.default).overheadExpenses;
    const optionsByName = options.reduce((acc, expense)=>{
        var _expense$name, _expense$name2;
        if (acc[(_expense$name = expense.name) === null || _expense$name === void 0 ? void 0 : _expense$name.toLowerCase()]) return acc;
        acc[(_expense$name2 = expense.name) === null || _expense$name2 === void 0 ? void 0 : _expense$name2.toLowerCase()] = expense;
        return acc;
    }, {});
    options = Object.values(optionsByName);
    return /*#__PURE__*/ (0, $61Ea1.jsx)($02476779609d10c6$export$1e7dfd31545b5809, {
        selectedOptions: selectedExpenses,
        onChange: onChange,
        options: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).orderBy(options, [
            "name"
        ], [
            "asc"
        ]),
        optionLabel: (sm)=>sm === null || sm === void 0 ? void 0 : sm.name,
        optionValue: (sm)=>sm === null || sm === void 0 ? void 0 : sm.id,
        searchMatcher: (sm, text)=>sm.title.toLowerCase().match(text.toLowerCase()),
        ...props
    });
};
const $02476779609d10c6$export$b4641764ee571138 = ({ selectedTasks: selectedTasks, taskOptions: taskOptions, onChange: onChange, ...props })=>{
    let options = taskOptions || (0, $keGWP.default).tasks;
    return /*#__PURE__*/ (0, $61Ea1.jsx)($02476779609d10c6$export$1e7dfd31545b5809, {
        selectedOptions: selectedTasks,
        onChange: onChange,
        options: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).orderBy(options, [
            "title"
        ], [
            "asc"
        ]),
        optionLabel: (sm)=>sm === null || sm === void 0 ? void 0 : sm.title,
        optionValue: (sm)=>sm === null || sm === void 0 ? void 0 : sm.id,
        searchMatcher: (sm, text)=>{
            var _sm$name2;
            return (_sm$name2 = sm.name) === null || _sm$name2 === void 0 ? void 0 : _sm$name2.toLowerCase().match(text.toLowerCase());
        },
        ...props
    });
};
var $02476779609d10c6$export$2e2bcd8739ae039 = {
    status: $02476779609d10c6$export$2976fe8217f8bc8b
};

});
parcelRegister("6OUQ7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f7380c02f7b1515$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $fDDh6 = parcelRequire("fDDh6");
var $caw0M = parcelRequire("caw0M");

var $5pDMg = parcelRequire("5pDMg");
function $4f7380c02f7b1515$var$arrayMove(array, from, to) {
    const slicedArray = array.slice();
    slicedArray.splice(to < 0 ? array.length + to : to, 0, slicedArray.splice(from, 1)[0]);
    return slicedArray;
}
const $4f7380c02f7b1515$var$SortableMultiValue = (0, $5pDMg.SortableElement)((props)=>{
    const onMouseDown = (e)=>{
        e.preventDefault();
        e.stopPropagation();
    };
    const innerProps = {
        ...props.innerProps,
        onMouseDown: onMouseDown
    };
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fDDh6.c).MultiValue, {
        ...props,
        innerProps: innerProps
    });
});
const $4f7380c02f7b1515$var$SortableMultiValueLabel = (0, $5pDMg.SortableHandle)((props)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $fDDh6.c).MultiValueLabel, {
        ...props
    }));
const $4f7380c02f7b1515$var$SortableSelect = (0, $5pDMg.SortableContainer)((0, $caw0M.default));
function $4f7380c02f7b1515$export$2e2bcd8739ae039({ selectedOptions: selectedOptions, options: options, onChange: onChange, groupBy: groupBy, sortGroups: sortGroups, styles: styles, ...props }) {
    const [menuIsOpen, setMenuIsOpen] = (0, $jbmdS.useState)(false);
    const selectRef = (0, $jbmdS.useRef)(null);
    const getGroupedAndSortedOptions = ()=>{
        if (!groupBy) return options;
        const groupedOptions = Object.entries(options.reduce((groups, option)=>{
            const groupKey = groupBy(option);
            groups[groupKey] = groups[groupKey] || [];
            groups[groupKey].push(option);
            return groups;
        }, {})).map(([groupLabel, groupOptions])=>({
                label: groupLabel,
                options: groupOptions
            }));
        return sortGroups ? groupedOptions.sort(sortGroups) : groupedOptions;
    };
    const onSortEnd = ({ oldIndex: oldIndex, newIndex: newIndex })=>{
        const newValue = $4f7380c02f7b1515$var$arrayMove(selectedOptions, oldIndex, newIndex);
        onChange(newValue);
    };
    const customStyles = {
        control: (provided)=>({
                ...provided,
                position: "relative"
            }),
        menu: (provided)=>{
            if (!selectRef.current) return provided;
            const { bottom: bottom, left: left, width: width } = selectRef.current.getBoundingClientRect();
            return {
                ...provided,
                position: "fixed",
                top: `${bottom}px`,
                left: `${left}px`,
                width: `${width}px`,
                zIndex: 9999
            };
        }
    };
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        ref: selectRef,
        className: props.className,
        styles: {
            ...styles || {},
            ...customStyles
        },
        children: /*#__PURE__*/ (0, $61Ea1.jsx)($4f7380c02f7b1515$var$SortableSelect, {
            useDragHandle: true,
            axis: "xy",
            onSortEnd: onSortEnd,
            distance: 4,
            getHelperDimensions: ({ node: node })=>node.getBoundingClientRect(),
            isMulti: true,
            options: getGroupedAndSortedOptions(),
            value: selectedOptions,
            onChange: onChange,
            components: {
                MultiValue: $4f7380c02f7b1515$var$SortableMultiValue,
                MultiValueLabel: $4f7380c02f7b1515$var$SortableMultiValueLabel
            },
            closeMenuOnSelect: false,
            isClearable: false,
            styles: {
                ...styles || {},
                ...customStyles
            },
            menuIsOpen: menuIsOpen,
            onMenuOpen: ()=>setMenuIsOpen(true),
            onMenuClose: ()=>setMenuIsOpen(false),
            ...props
        })
    });
}

});
parcelRegister("fDDh6", function(module, exports) {

$parcel$export(module.exports, "J", function () { return $b628f6b755e7c0e4$export$b4171a6734a65d42; });
$parcel$export(module.exports, "E", function () { return $b628f6b755e7c0e4$export$a9c23c6ac3fc3eca; });
$parcel$export(module.exports, "H", function () { return $b628f6b755e7c0e4$export$7f8ddf7c7c20b3cd; });
$parcel$export(module.exports, "G", function () { return $b628f6b755e7c0e4$export$2329c99376c9d0a4; });
$parcel$export(module.exports, "I", function () { return $b628f6b755e7c0e4$export$9bb611d729802a56; });
$parcel$export(module.exports, "z", function () { return $b628f6b755e7c0e4$export$df995fae86a55f06; });
$parcel$export(module.exports, "A", function () { return $b628f6b755e7c0e4$export$ebd11618f299a286; });
$parcel$export(module.exports, "s", function () { return $b628f6b755e7c0e4$export$2408f22a0fab9ae5; });
$parcel$export(module.exports, "K", function () { return $b628f6b755e7c0e4$export$3466f893ebf79586; });
$parcel$export(module.exports, "D", function () { return $b628f6b755e7c0e4$export$96f57966bedc81b4; });
$parcel$export(module.exports, "C", function () { return $b628f6b755e7c0e4$export$e7094788287c5e9b; });
$parcel$export(module.exports, "B", function () { return $b628f6b755e7c0e4$export$ef35774e6d314e91; });
$parcel$export(module.exports, "r", function () { return $b628f6b755e7c0e4$export$43caf9889c228507; });
$parcel$export(module.exports, "m", function () { return $b628f6b755e7c0e4$export$953cecd6e717a553; });
$parcel$export(module.exports, "M", function () { return $b628f6b755e7c0e4$export$3a1a48c8f6ef640e; });
$parcel$export(module.exports, "n", function () { return $b628f6b755e7c0e4$export$7ccc53e8f1e7dfc5; });
$parcel$export(module.exports, "u", function () { return $b628f6b755e7c0e4$export$3b14a55fb2447963; });
$parcel$export(module.exports, "k", function () { return $b628f6b755e7c0e4$export$342063e11d6c3cad; });
$parcel$export(module.exports, "o", function () { return $b628f6b755e7c0e4$export$ae1af26003f05816; });
$parcel$export(module.exports, "b", function () { return $b628f6b755e7c0e4$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "y", function () { return $b628f6b755e7c0e4$export$4a5767248b18ef41; });
$parcel$export(module.exports, "i", function () { return $b628f6b755e7c0e4$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "e", function () { return $b628f6b755e7c0e4$export$f1e1789686576879; });
$parcel$export(module.exports, "a", function () { return $b628f6b755e7c0e4$export$407448d2b89b1813; });
$parcel$export(module.exports, "h", function () { return $b628f6b755e7c0e4$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "l", function () { return $b628f6b755e7c0e4$export$882b5998b3b9117c; });
$parcel$export(module.exports, "d", function () { return $b628f6b755e7c0e4$export$4368d992c4eafac0; });
$parcel$export(module.exports, "g", function () { return $b628f6b755e7c0e4$export$39b482c5e57630a8; });
$parcel$export(module.exports, "f", function () { return $b628f6b755e7c0e4$export$2d1720544b23b823; });
$parcel$export(module.exports, "j", function () { return $b628f6b755e7c0e4$export$35e795649ee09318; });
$parcel$export(module.exports, "p", function () { return $b628f6b755e7c0e4$export$ffb5f4729a158638; });
$parcel$export(module.exports, "q", function () { return $b628f6b755e7c0e4$export$9e5f44173e64f162; });
$parcel$export(module.exports, "t", function () { return $b628f6b755e7c0e4$export$625550452a3fa3ec; });
$parcel$export(module.exports, "v", function () { return $b628f6b755e7c0e4$export$90a7f3efeed30595; });
$parcel$export(module.exports, "w", function () { return $b628f6b755e7c0e4$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "x", function () { return $b628f6b755e7c0e4$export$d141bba7fdc215a3; });
$parcel$export(module.exports, "c", function () { return $b628f6b755e7c0e4$export$db3b6bfb95261072; });
$parcel$export(module.exports, "F", function () { return $b628f6b755e7c0e4$export$d66501df72047452; });

var $lv6ip = parcelRequire("lv6ip");

var $7i29i = parcelRequire("7i29i");

var $BPPBq = parcelRequire("BPPBq");

var $CZyex = parcelRequire("CZyex");

var $ccQt4 = parcelRequire("ccQt4");

var $jncUt = parcelRequire("jncUt");

var $10Tcw = parcelRequire("10Tcw");

var $8K2NM = parcelRequire("8K2NM");

var $jbmdS = parcelRequire("jbmdS");

var $jCNM0 = parcelRequire("jCNM0");

var $gIRV7 = parcelRequire("gIRV7");

var $7S5UH = parcelRequire("7S5UH");
var $b628f6b755e7c0e4$var$_excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $b628f6b755e7c0e4$export$b4171a6734a65d42 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $b628f6b755e7c0e4$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === "-") return prefix + name;
    else return prefix + "__" + name;
}
function $b628f6b755e7c0e4$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($b628f6b755e7c0e4$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(" ");
}
// ==============================
// Clean Value
// ==============================
var $b628f6b755e7c0e4$export$7f8ddf7c7c20b3cd = function cleanValue(value) {
    if ($b628f6b755e7c0e4$var$isArray(value)) return value.filter(Boolean);
    if ((0, $jncUt.default)(value) === "object" && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $b628f6b755e7c0e4$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $ccQt4.default)(props, $b628f6b755e7c0e4$var$_excluded$4);
    return (0, $lv6ip.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $b628f6b755e7c0e4$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $b628f6b755e7c0e4$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === "string") return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $b628f6b755e7c0e4$export$2329c99376c9d0a4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $b628f6b755e7c0e4$var$normalizedHeight(el) {
    if ($b628f6b755e7c0e4$export$2329c99376c9d0a4(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $b628f6b755e7c0e4$var$getScrollTop(el) {
    if ($b628f6b755e7c0e4$export$2329c99376c9d0a4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $b628f6b755e7c0e4$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($b628f6b755e7c0e4$export$2329c99376c9d0a4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $b628f6b755e7c0e4$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === "absolute";
    var overflowRx = /(auto|scroll)/;
    if (style.position === "fixed") return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === "static") continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $b628f6b755e7c0e4$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $b628f6b755e7c0e4$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $b628f6b755e7c0e4$export$b4171a6734a65d42;
    var start = $b628f6b755e7c0e4$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $b628f6b755e7c0e4$var$easeOutCubic(currentTime, start, change, duration);
        $b628f6b755e7c0e4$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $b628f6b755e7c0e4$export$9bb611d729802a56(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $b628f6b755e7c0e4$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $b628f6b755e7c0e4$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $b628f6b755e7c0e4$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $b628f6b755e7c0e4$export$df995fae86a55f06() {
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $b628f6b755e7c0e4$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $b628f6b755e7c0e4$var$passiveOptionAccessed = false;
var $b628f6b755e7c0e4$var$options = {
    get passive () {
        return $b628f6b755e7c0e4$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $b628f6b755e7c0e4$var$w = typeof window !== "undefined" ? window : {};
if ($b628f6b755e7c0e4$var$w.addEventListener && $b628f6b755e7c0e4$var$w.removeEventListener) {
    $b628f6b755e7c0e4$var$w.addEventListener("p", $b628f6b755e7c0e4$export$b4171a6734a65d42, $b628f6b755e7c0e4$var$options);
    $b628f6b755e7c0e4$var$w.removeEventListener("p", $b628f6b755e7c0e4$export$b4171a6734a65d42, false);
}
var $b628f6b755e7c0e4$export$2408f22a0fab9ae5 = $b628f6b755e7c0e4$var$passiveOptionAccessed;
function $b628f6b755e7c0e4$export$3466f893ebf79586(item) {
    return item != null;
}
function $b628f6b755e7c0e4$var$isArray(arg) {
    return Array.isArray(arg);
}
function $b628f6b755e7c0e4$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $b628f6b755e7c0e4$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $b628f6b755e7c0e4$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $b628f6b755e7c0e4$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $CZyex.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $CZyex.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $b628f6b755e7c0e4$var$_excluded$3 = [
    "children",
    "innerProps"
], $b628f6b755e7c0e4$var$_excluded2$1 = [
    "children",
    "innerProps"
];
function $b628f6b755e7c0e4$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $b628f6b755e7c0e4$var$getScrollParent(menuEl);
    var defaultState = {
        placement: "bottom",
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $b628f6b755e7c0e4$var$normalizedHeight(scrollParent);
    var scrollTop = $b628f6b755e7c0e4$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case "auto":
        case "bottom":
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $b628f6b755e7c0e4$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $b628f6b755e7c0e4$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: "bottom",
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === "auto" || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === "bottom") {
                if (shouldScroll) $b628f6b755e7c0e4$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case "top":
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: "top",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $b628f6b755e7c0e4$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $b628f6b755e7c0e4$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error('Invalid placement provided "'.concat(preferredPlacement, '".'));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $b628f6b755e7c0e4$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: "top",
        top: "bottom"
    };
    return placement ? placementToCSSProp[placement] : "bottom";
}
var $b628f6b755e7c0e4$var$coercePlacement = function coercePlacement(p) {
    return p === "auto" ? "bottom" : p;
};
var $b628f6b755e7c0e4$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $lv6ip.default)((_objectSpread2 = {
        label: "menu"
    }, (0, $8K2NM.default)(_objectSpread2, $b628f6b755e7c0e4$var$alignToControl(placement), "100%"), (0, $8K2NM.default)(_objectSpread2, "position", "absolute"), (0, $8K2NM.default)(_objectSpread2, "width", "100%"), (0, $8K2NM.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $b628f6b755e7c0e4$var$PortalPlacementContext = /*#__PURE__*/ (0, $jbmdS.createContext)(null);
// NOTE: internal only
var $b628f6b755e7c0e4$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $jbmdS.useContext)($b628f6b755e7c0e4$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $jbmdS.useRef)(null);
    var _useState = (0, $jbmdS.useState)(maxMenuHeight), _useState2 = (0, $CZyex.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $jbmdS.useState)(null), _useState4 = (0, $CZyex.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $7S5UH.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === "fixed";
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $b628f6b755e7c0e4$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $lv6ip.default)((0, $lv6ip.default)({}, props), {}, {
            placement: placement || $b628f6b755e7c0e4$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $b628f6b755e7c0e4$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $BPPBq.jsx)("div", (0, $7i29i.default)({}, $b628f6b755e7c0e4$var$getStyleProps(props, "menu", {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var $b628f6b755e7c0e4$var$Menu$1 = $b628f6b755e7c0e4$var$Menu;
// ==============================
// Menu List
// ==============================
var $b628f6b755e7c0e4$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $lv6ip.default)({
        maxHeight: maxHeight,
        overflowY: "auto",
        position: "relative",
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: "touch"
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $b628f6b755e7c0e4$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $BPPBq.jsx)("div", (0, $7i29i.default)({}, $b628f6b755e7c0e4$var$getStyleProps(props, "menuList", {
        "menu-list": true,
        "menu-list--is-multi": isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $b628f6b755e7c0e4$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $lv6ip.default)({
        textAlign: "center"
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $b628f6b755e7c0e4$export$3b14a55fb2447963 = $b628f6b755e7c0e4$var$noticeCSS;
var $b628f6b755e7c0e4$export$342063e11d6c3cad = $b628f6b755e7c0e4$var$noticeCSS;
var $b628f6b755e7c0e4$var$NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? "No options" : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, $ccQt4.default)(_ref6, $b628f6b755e7c0e4$var$_excluded$3);
    return (0, $BPPBq.jsx)("div", (0, $7i29i.default)({}, $b628f6b755e7c0e4$var$getStyleProps((0, $lv6ip.default)((0, $lv6ip.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "noOptionsMessage", {
        "menu-notice": true,
        "menu-notice--no-options": true
    }), innerProps), children);
};
var $b628f6b755e7c0e4$var$LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? "Loading..." : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, $ccQt4.default)(_ref7, $b628f6b755e7c0e4$var$_excluded2$1);
    return (0, $BPPBq.jsx)("div", (0, $7i29i.default)({}, $b628f6b755e7c0e4$var$getStyleProps((0, $lv6ip.default)((0, $lv6ip.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "loadingMessage", {
        "menu-notice": true,
        "menu-notice--loading": true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var $b628f6b755e7c0e4$export$ae1af26003f05816 = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $b628f6b755e7c0e4$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $jbmdS.useRef)(null);
    var cleanupRef = (0, $jbmdS.useRef)(null);
    var _useState5 = (0, $jbmdS.useState)($b628f6b755e7c0e4$var$coercePlacement(menuPlacement)), _useState6 = (0, $CZyex.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $jbmdS.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $jbmdS.useState)(null), _useState8 = (0, $CZyex.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $jbmdS.useCallback)(function() {
        if (!controlElement) return;
        var rect = $b628f6b755e7c0e4$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === "fixed" ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $7S5UH.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $jbmdS.useCallback)(function() {
        if (typeof cleanupRef.current === "function") {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $gIRV7.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: "ResizeObserver" in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $7S5UH.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $jbmdS.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== "fixed" || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $BPPBq.jsx)("div", (0, $7i29i.default)({
        ref: setMenuPortalElement
    }, $b628f6b755e7c0e4$var$getStyleProps((0, $lv6ip.default)((0, $lv6ip.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), "menuPortal", {
        "menu-portal": true
    }), innerProps), children);
    return (0, $BPPBq.jsx)($b628f6b755e7c0e4$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $jCNM0.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $b628f6b755e7c0e4$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: "container",
        direction: isRtl ? "rtl" : undefined,
        pointerEvents: isDisabled ? "none" : undefined,
        // cancel mouse events when disabled
        position: "relative"
    };
};
var $b628f6b755e7c0e4$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $BPPBq.jsx)("div", (0, $7i29i.default)({}, $b628f6b755e7c0e4$var$getStyleProps(props, "container", {
        "--is-disabled": isDisabled,
        "--is-rtl": isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $b628f6b755e7c0e4$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $lv6ip.default)({
        alignItems: "center",
        display: isMulti && hasValue && controlShouldRenderValue ? "flex" : "grid",
        flex: 1,
        flexWrap: "wrap",
        WebkitOverflowScrolling: "touch",
        position: "relative",
        overflow: "hidden"
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $b628f6b755e7c0e4$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $BPPBq.jsx)("div", (0, $7i29i.default)({}, $b628f6b755e7c0e4$var$getStyleProps(props, "valueContainer", {
        "value-container": true,
        "value-container--is-multi": isMulti,
        "value-container--has-value": hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $b628f6b755e7c0e4$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: "center",
        alignSelf: "stretch",
        display: "flex",
        flexShrink: 0
    };
};
var $b628f6b755e7c0e4$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $BPPBq.jsx)("div", (0, $7i29i.default)({}, $b628f6b755e7c0e4$var$getStyleProps(props, "indicatorsContainer", {
        indicators: true
    }), innerProps), children);
};
var $b628f6b755e7c0e4$var$_templateObject;
var $b628f6b755e7c0e4$var$_excluded$2 = [
    "size"
], $b628f6b755e7c0e4$var$_excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function $b628f6b755e7c0e4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $b628f6b755e7c0e4$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $b628f6b755e7c0e4$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $ccQt4.default)(_ref, $b628f6b755e7c0e4$var$_excluded$2);
    return (0, $BPPBq.jsx)("svg", (0, $7i29i.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $b628f6b755e7c0e4$var$_ref2
    }, props));
};
var $b628f6b755e7c0e4$var$CrossIcon = function CrossIcon(props) {
    return (0, $BPPBq.jsx)($b628f6b755e7c0e4$var$Svg, (0, $7i29i.default)({
        size: 20
    }, props), (0, $BPPBq.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $b628f6b755e7c0e4$var$DownChevron = function DownChevron(props) {
    return (0, $BPPBq.jsx)($b628f6b755e7c0e4$var$Svg, (0, $7i29i.default)({
        size: 20
    }, props), (0, $BPPBq.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $b628f6b755e7c0e4$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $lv6ip.default)({
        label: "indicatorContainer",
        display: "flex",
        transition: "color 150ms"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ":hover": {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $b628f6b755e7c0e4$export$f1e1789686576879 = $b628f6b755e7c0e4$var$baseCSS;
var $b628f6b755e7c0e4$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $BPPBq.jsx)("div", (0, $7i29i.default)({}, $b628f6b755e7c0e4$var$getStyleProps(props, "dropdownIndicator", {
        indicator: true,
        "dropdown-indicator": true
    }), innerProps), children || (0, $BPPBq.jsx)($b628f6b755e7c0e4$var$DownChevron, null));
};
var $b628f6b755e7c0e4$export$407448d2b89b1813 = $b628f6b755e7c0e4$var$baseCSS;
var $b628f6b755e7c0e4$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $BPPBq.jsx)("div", (0, $7i29i.default)({}, $b628f6b755e7c0e4$var$getStyleProps(props, "clearIndicator", {
        indicator: true,
        "clear-indicator": true
    }), innerProps), children || (0, $BPPBq.jsx)($b628f6b755e7c0e4$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $b628f6b755e7c0e4$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $lv6ip.default)({
        label: "indicatorSeparator",
        alignSelf: "stretch",
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $b628f6b755e7c0e4$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $BPPBq.jsx)("span", (0, $7i29i.default)({}, innerProps, $b628f6b755e7c0e4$var$getStyleProps(props, "indicatorSeparator", {
        "indicator-separator": true
    })));
};
// ==============================
// Loading
// ==============================
var $b628f6b755e7c0e4$var$loadingDotAnimations = (0, $BPPBq.keyframes)($b628f6b755e7c0e4$var$_templateObject || ($b628f6b755e7c0e4$var$_templateObject = (0, $10Tcw.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $b628f6b755e7c0e4$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $lv6ip.default)({
        label: "loadingIndicator",
        display: "flex",
        transition: "color 150ms",
        alignSelf: "center",
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: "center",
        verticalAlign: "middle"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $b628f6b755e7c0e4$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $BPPBq.jsx)("span", {
        css: /*#__PURE__*/ (0, $BPPBq.css)({
            animation: "".concat($b628f6b755e7c0e4$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: "currentColor",
            borderRadius: "1em",
            display: "inline-block",
            marginLeft: offset ? "1em" : undefined,
            height: "1em",
            verticalAlign: "top",
            width: "1em"
        }, "", "")
    });
};
var $b628f6b755e7c0e4$var$LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, $ccQt4.default)(_ref7, $b628f6b755e7c0e4$var$_excluded2);
    return (0, $BPPBq.jsx)("div", (0, $7i29i.default)({}, $b628f6b755e7c0e4$var$getStyleProps((0, $lv6ip.default)((0, $lv6ip.default)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), "loadingIndicator", {
        indicator: true,
        "loading-indicator": true
    }), innerProps), (0, $BPPBq.jsx)($b628f6b755e7c0e4$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $BPPBq.jsx)($b628f6b755e7c0e4$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $BPPBq.jsx)($b628f6b755e7c0e4$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var $b628f6b755e7c0e4$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $lv6ip.default)({
        label: "control",
        alignItems: "center",
        cursor: "default",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        minHeight: spacing.controlHeight,
        outline: "0 !important",
        position: "relative",
        transition: "all 100ms"
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: "solid",
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        "&:hover": {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $b628f6b755e7c0e4$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $BPPBq.jsx)("div", (0, $7i29i.default)({
        ref: innerRef
    }, $b628f6b755e7c0e4$var$getStyleProps(props, "control", {
        control: true,
        "control--is-disabled": isDisabled,
        "control--is-focused": isFocused,
        "control--menu-is-open": menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var $b628f6b755e7c0e4$var$Control$1 = $b628f6b755e7c0e4$var$Control;
var $b628f6b755e7c0e4$var$_excluded$1 = [
    "data"
];
var $b628f6b755e7c0e4$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $b628f6b755e7c0e4$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $BPPBq.jsx)("div", (0, $7i29i.default)({}, $b628f6b755e7c0e4$var$getStyleProps(props, "group", {
        group: true
    }), innerProps), (0, $BPPBq.jsx)(Heading, (0, $7i29i.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $BPPBq.jsx)("div", null, children));
};
var $b628f6b755e7c0e4$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $lv6ip.default)({
        label: "group",
        cursor: "default",
        display: "block"
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: "75%",
        fontWeight: 500,
        marginBottom: "0.25em",
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: "uppercase"
    });
};
var $b628f6b755e7c0e4$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $b628f6b755e7c0e4$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $ccQt4.default)(_cleanCommonProps, $b628f6b755e7c0e4$var$_excluded$1);
    return (0, $BPPBq.jsx)("div", (0, $7i29i.default)({}, $b628f6b755e7c0e4$var$getStyleProps(props, "groupHeading", {
        "group-heading": true
    }), innerProps));
};
var $b628f6b755e7c0e4$var$Group$1 = $b628f6b755e7c0e4$var$Group;
var $b628f6b755e7c0e4$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $b628f6b755e7c0e4$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $lv6ip.default)((0, $lv6ip.default)({
        visibility: isDisabled ? "hidden" : "visible",
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? "translateZ(0)" : ""
    }, $b628f6b755e7c0e4$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $b628f6b755e7c0e4$var$spacingStyle = {
    gridArea: "1 / 2",
    font: "inherit",
    minWidth: "2px",
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $b628f6b755e7c0e4$var$containerStyle = {
    flex: "1 1 auto",
    display: "inline-grid",
    gridArea: "1 / 1 / 2 / 3",
    gridTemplateColumns: "0 min-content",
    "&:after": (0, $lv6ip.default)({
        content: 'attr(data-value) " "',
        visibility: "hidden",
        whiteSpace: "pre"
    }, $b628f6b755e7c0e4$var$spacingStyle)
};
var $b628f6b755e7c0e4$var$inputStyle = function inputStyle(isHidden) {
    return (0, $lv6ip.default)({
        label: "input",
        color: "inherit",
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: "100%"
    }, $b628f6b755e7c0e4$var$spacingStyle);
};
var $b628f6b755e7c0e4$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $b628f6b755e7c0e4$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $ccQt4.default)(_cleanCommonProps, $b628f6b755e7c0e4$var$_excluded);
    return (0, $BPPBq.jsx)("div", (0, $7i29i.default)({}, $b628f6b755e7c0e4$var$getStyleProps(props, "input", {
        "input-container": true
    }), {
        "data-value": value || ""
    }), (0, $BPPBq.jsx)("input", (0, $7i29i.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $b628f6b755e7c0e4$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $b628f6b755e7c0e4$var$Input$1 = $b628f6b755e7c0e4$var$Input;
var $b628f6b755e7c0e4$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $lv6ip.default)({
        label: "multiValue",
        display: "flex",
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $b628f6b755e7c0e4$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $lv6ip.default)({
        overflow: "hidden",
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? "ellipsis" : undefined,
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: "85%",
        padding: 3,
        paddingLeft: 6
    });
};
var $b628f6b755e7c0e4$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $lv6ip.default)({
        alignItems: "center",
        display: "flex"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ":hover": {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $b628f6b755e7c0e4$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $BPPBq.jsx)("div", innerProps, children);
};
var $b628f6b755e7c0e4$var$MultiValueContainer = $b628f6b755e7c0e4$var$MultiValueGeneric;
var $b628f6b755e7c0e4$var$MultiValueLabel = $b628f6b755e7c0e4$var$MultiValueGeneric;
function $b628f6b755e7c0e4$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $BPPBq.jsx)("div", (0, $7i29i.default)({
        role: "button"
    }, innerProps), children || (0, $BPPBq.jsx)($b628f6b755e7c0e4$var$CrossIcon, {
        size: 14
    }));
}
var $b628f6b755e7c0e4$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $BPPBq.jsx)(Container, {
        data: data,
        innerProps: (0, $lv6ip.default)((0, $lv6ip.default)({}, $b628f6b755e7c0e4$var$getStyleProps(props, "multiValue", {
            "multi-value": true,
            "multi-value--is-disabled": isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $BPPBq.jsx)(Label, {
        data: data,
        innerProps: (0, $lv6ip.default)({}, $b628f6b755e7c0e4$var$getStyleProps(props, "multiValueLabel", {
            "multi-value__label": true
        })),
        selectProps: selectProps
    }, children), (0, $BPPBq.jsx)(Remove, {
        data: data,
        innerProps: (0, $lv6ip.default)((0, $lv6ip.default)({}, $b628f6b755e7c0e4$var$getStyleProps(props, "multiValueRemove", {
            "multi-value__remove": true
        })), {}, {
            "aria-label": "Remove ".concat(children || "option")
        }, removeProps),
        selectProps: selectProps
    }));
};
var $b628f6b755e7c0e4$var$MultiValue$1 = $b628f6b755e7c0e4$var$MultiValue;
var $b628f6b755e7c0e4$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $lv6ip.default)({
        label: "option",
        cursor: "default",
        display: "block",
        fontSize: "inherit",
        width: "100%",
        userSelect: "none",
        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : "transparent",
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : "inherit",
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ":active": {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $b628f6b755e7c0e4$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $BPPBq.jsx)("div", (0, $7i29i.default)({}, $b628f6b755e7c0e4$var$getStyleProps(props, "option", {
        option: true,
        "option--is-disabled": isDisabled,
        "option--is-focused": isFocused,
        "option--is-selected": isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $b628f6b755e7c0e4$var$Option$1 = $b628f6b755e7c0e4$var$Option;
var $b628f6b755e7c0e4$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $lv6ip.default)({
        label: "placeholder",
        gridArea: "1 / 1 / 2 / 3"
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $b628f6b755e7c0e4$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $BPPBq.jsx)("div", (0, $7i29i.default)({}, $b628f6b755e7c0e4$var$getStyleProps(props, "placeholder", {
        placeholder: true
    }), innerProps), children);
};
var $b628f6b755e7c0e4$var$Placeholder$1 = $b628f6b755e7c0e4$var$Placeholder;
var $b628f6b755e7c0e4$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $lv6ip.default)({
        label: "singleValue",
        gridArea: "1 / 1 / 2 / 3",
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $b628f6b755e7c0e4$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $BPPBq.jsx)("div", (0, $7i29i.default)({}, $b628f6b755e7c0e4$var$getStyleProps(props, "singleValue", {
        "single-value": true,
        "single-value--is-disabled": isDisabled
    }), innerProps), children);
};
var $b628f6b755e7c0e4$var$SingleValue$1 = $b628f6b755e7c0e4$var$SingleValue;
var $b628f6b755e7c0e4$export$db3b6bfb95261072 = {
    ClearIndicator: $b628f6b755e7c0e4$var$ClearIndicator,
    Control: $b628f6b755e7c0e4$var$Control$1,
    DropdownIndicator: $b628f6b755e7c0e4$var$DropdownIndicator,
    DownChevron: $b628f6b755e7c0e4$var$DownChevron,
    CrossIcon: $b628f6b755e7c0e4$var$CrossIcon,
    Group: $b628f6b755e7c0e4$var$Group$1,
    GroupHeading: $b628f6b755e7c0e4$var$GroupHeading,
    IndicatorsContainer: $b628f6b755e7c0e4$var$IndicatorsContainer,
    IndicatorSeparator: $b628f6b755e7c0e4$var$IndicatorSeparator,
    Input: $b628f6b755e7c0e4$var$Input$1,
    LoadingIndicator: $b628f6b755e7c0e4$var$LoadingIndicator,
    Menu: $b628f6b755e7c0e4$var$Menu$1,
    MenuList: $b628f6b755e7c0e4$var$MenuList,
    MenuPortal: $b628f6b755e7c0e4$var$MenuPortal,
    LoadingMessage: $b628f6b755e7c0e4$var$LoadingMessage,
    NoOptionsMessage: $b628f6b755e7c0e4$var$NoOptionsMessage,
    MultiValue: $b628f6b755e7c0e4$var$MultiValue$1,
    MultiValueContainer: $b628f6b755e7c0e4$var$MultiValueContainer,
    MultiValueLabel: $b628f6b755e7c0e4$var$MultiValueLabel,
    MultiValueRemove: $b628f6b755e7c0e4$var$MultiValueRemove,
    Option: $b628f6b755e7c0e4$var$Option$1,
    Placeholder: $b628f6b755e7c0e4$var$Placeholder$1,
    SelectContainer: $b628f6b755e7c0e4$var$SelectContainer,
    SingleValue: $b628f6b755e7c0e4$var$SingleValue$1,
    ValueContainer: $b628f6b755e7c0e4$var$ValueContainer
};
var $b628f6b755e7c0e4$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $lv6ip.default)((0, $lv6ip.default)({}, $b628f6b755e7c0e4$export$db3b6bfb95261072), props.components);
};

});
parcelRegister("BPPBq", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $071ba96eab6785b1$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $071ba96eab6785b1$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $071ba96eab6785b1$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "jsx", function () { return $071ba96eab6785b1$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("kjYAx")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("kjYAx")).w; });

var $kjYAx = parcelRequire("kjYAx");

var $jbmdS = parcelRequire("jbmdS");

var $fvFHh = parcelRequire("fvFHh");

var $cqJqj = parcelRequire("cqJqj");

var $lkbnQ = parcelRequire("lkbnQ");
parcelRequire("bMPPJ");
parcelRequire("u6wRM");
parcelRequire("4O5LI");

parcelRequire("3RaBm");
var $071ba96eab6785b1$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $kjYAx.h).call(props, "css")) return $jbmdS.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $kjYAx.E);
    createElementArgArray[1] = (0, $kjYAx.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $jbmdS.createElement.apply(null, createElementArgArray);
};
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $071ba96eab6785b1$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $kjYAx.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $lkbnQ.serializeStyles)([
        styles
    ], undefined, $jbmdS.useContext((0, $kjYAx.T)));
    if (!(0, $kjYAx.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $jbmdS.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $jbmdS.useRef();
    (0, $cqJqj.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $cqJqj.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $fvFHh.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
/* import type { Interpolation, SerializedStyles } from '@emotion/utils' */ function $071ba96eab6785b1$export$dbf350e5966cf602() /*: SerializedStyles */ {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $lkbnQ.serializeStyles)(args);
}
/*
type Keyframes = {|
  name: string,
  styles: string,
  anim: 1,
  toString: () => string
|} & string
*/ var $071ba96eab6785b1$export$d25ddfdf17c3ad3e = function /*: Keyframes */ keyframes() {
    var insertable = $071ba96eab6785b1$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
/*
type ClassNameArg =
  | string
  | boolean
  | { [key: string]: boolean }
  | Array<ClassNameArg>
  | null
  | void
*/ var $071ba96eab6785b1$var$classnames = function /*: string */ classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $071ba96eab6785b1$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $fvFHh.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $071ba96eab6785b1$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $cqJqj.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = "";
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $fvFHh.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $kjYAx.i) && res !== undefined) rules += res;
        }
        if (!(0, $kjYAx.i)) return rules;
    });
    if (!(0, $kjYAx.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $jbmdS.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(" "), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
/*
type Props = {
  children: ({
    css: (...args: any) => string,
    cx: (...args: Array<ClassNameArg>) => string,
    theme: Object
  }) => React.Node
} */ var $071ba96eab6785b1$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $kjYAx.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $kjYAx.a)) throw new Error("css can only be used during render");
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $lkbnQ.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $fvFHh.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $kjYAx.a)) throw new Error("cx can only be used during render");
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $071ba96eab6785b1$var$merge(cache.registered, css, $071ba96eab6785b1$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $jbmdS.useContext((0, $kjYAx.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $jbmdS.createElement($jbmdS.Fragment, null, /*#__PURE__*/ $jbmdS.createElement($071ba96eab6785b1$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});

parcelRegister("10Tcw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0bd09c4faa2dd4e1$export$2e2bcd8739ae039; });
function $0bd09c4faa2dd4e1$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}

});

parcelRegister("gIRV7", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", function () { return $c2ca94d86797561b$export$deee3a793edee05f; });
$parcel$export(module.exports, "offset", function () { return $c2ca94d86797561b$export$cc800923e997bb8; });
$parcel$export(module.exports, "autoPlacement", function () { return $c2ca94d86797561b$export$91fb6ecbd551914; });
$parcel$export(module.exports, "shift", function () { return $c2ca94d86797561b$export$fba63a578e423eb; });
$parcel$export(module.exports, "flip", function () { return $c2ca94d86797561b$export$8a83211c878a3f1f; });
$parcel$export(module.exports, "size", function () { return $c2ca94d86797561b$export$346677f925de839c; });
$parcel$export(module.exports, "hide", function () { return $c2ca94d86797561b$export$fe8985bb6374093c; });
$parcel$export(module.exports, "arrow", function () { return $c2ca94d86797561b$export$f2120bbfa5450bd2; });
$parcel$export(module.exports, "inline", function () { return $c2ca94d86797561b$export$18c8ad048e32c7d5; });
$parcel$export(module.exports, "limitShift", function () { return $c2ca94d86797561b$export$7bf07e38f3dc4b69; });
$parcel$export(module.exports, "computePosition", function () { return $c2ca94d86797561b$export$48a53dcb22e581d0; });

var $8biOO = parcelRequire("8biOO");
var $5Sy7m = parcelRequire("5Sy7m");

var $5Sy7m = parcelRequire("5Sy7m");

var $gtIJY = parcelRequire("gtIJY");
function $c2ca94d86797561b$var$getCssDimensions(element) {
    const css = (0, $gtIJY.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $gtIJY.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $5Sy7m.round)(width) !== offsetWidth || (0, $5Sy7m.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $c2ca94d86797561b$var$unwrapElement(element) {
    return !(0, $gtIJY.isElement)(element) ? element.contextElement : element;
}
function $c2ca94d86797561b$var$getScale(element) {
    const domElement = $c2ca94d86797561b$var$unwrapElement(element);
    if (!(0, $gtIJY.isHTMLElement)(domElement)) return (0, $5Sy7m.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $c2ca94d86797561b$var$getCssDimensions(domElement);
    let x = ($ ? (0, $5Sy7m.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $5Sy7m.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $c2ca94d86797561b$var$noOffsets = /*#__PURE__*/ (0, $5Sy7m.createCoords)(0);
function $c2ca94d86797561b$var$getVisualOffsets(element) {
    const win = (0, $gtIJY.getWindow)(element);
    if (!(0, $gtIJY.isWebKit)() || !win.visualViewport) return $c2ca94d86797561b$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $c2ca94d86797561b$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $gtIJY.getWindow)(element)) return false;
    return isFixed;
}
function $c2ca94d86797561b$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $c2ca94d86797561b$var$unwrapElement(element);
    let scale = (0, $5Sy7m.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $gtIJY.isElement)(offsetParent)) scale = $c2ca94d86797561b$var$getScale(offsetParent);
        } else scale = $c2ca94d86797561b$var$getScale(element);
    }
    const visualOffsets = $c2ca94d86797561b$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $c2ca94d86797561b$var$getVisualOffsets(domElement) : (0, $5Sy7m.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $gtIJY.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $gtIJY.isElement)(offsetParent) ? (0, $gtIJY.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $gtIJY.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $c2ca94d86797561b$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $gtIJY.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $gtIJY.getWindow)(currentIFrame);
            currentIFrame = (0, $gtIJY.getFrameElement)(currentWin);
        }
    }
    return (0, $5Sy7m.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $c2ca94d86797561b$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === "fixed";
    const documentElement = (0, $gtIJY.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $gtIJY.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $5Sy7m.createCoords)(1);
    const offsets = (0, $5Sy7m.createCoords)(0);
    const isOffsetParentAnElement = (0, $gtIJY.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $gtIJY.getNodeName)(offsetParent) !== "body" || (0, $gtIJY.isOverflowElement)(documentElement)) scroll = (0, $gtIJY.getNodeScroll)(offsetParent);
        if ((0, $gtIJY.isHTMLElement)(offsetParent)) {
            const offsetRect = $c2ca94d86797561b$var$getBoundingClientRect(offsetParent);
            scale = $c2ca94d86797561b$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $c2ca94d86797561b$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $c2ca94d86797561b$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $gtIJY.getNodeScroll)(element).scrollLeft;
    if (!rect) return $c2ca94d86797561b$var$getBoundingClientRect((0, $gtIJY.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $c2ca94d86797561b$var$getDocumentRect(element) {
    const html = (0, $gtIJY.getDocumentElement)(element);
    const scroll = (0, $gtIJY.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $5Sy7m.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $5Sy7m.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $c2ca94d86797561b$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $gtIJY.getComputedStyle)(body).direction === "rtl") x += (0, $5Sy7m.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $c2ca94d86797561b$var$getViewportRect(element, strategy) {
    const win = (0, $gtIJY.getWindow)(element);
    const html = (0, $gtIJY.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $gtIJY.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $c2ca94d86797561b$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $c2ca94d86797561b$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $gtIJY.isHTMLElement)(element) ? $c2ca94d86797561b$var$getScale(element) : (0, $5Sy7m.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $c2ca94d86797561b$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $c2ca94d86797561b$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $c2ca94d86797561b$var$getDocumentRect((0, $gtIJY.getDocumentElement)(element));
    else if ((0, $gtIJY.isElement)(clippingAncestor)) rect = $c2ca94d86797561b$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $c2ca94d86797561b$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $5Sy7m.rectToClientRect)(rect);
}
function $c2ca94d86797561b$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $gtIJY.getParentNode)(element);
    if (parentNode === stopNode || !(0, $gtIJY.isElement)(parentNode) || (0, $gtIJY.isLastTraversableNode)(parentNode)) return false;
    return (0, $gtIJY.getComputedStyle)(parentNode).position === "fixed" || $c2ca94d86797561b$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $c2ca94d86797561b$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $gtIJY.getOverflowAncestors)(element, [], false).filter((el)=>(0, $gtIJY.isElement)(el) && (0, $gtIJY.getNodeName)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $gtIJY.getComputedStyle)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $gtIJY.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $gtIJY.isElement)(currentNode) && !(0, $gtIJY.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $gtIJY.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $gtIJY.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $gtIJY.isOverflowElement)(currentNode) && !currentNodeIsContaining && $c2ca94d86797561b$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $gtIJY.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $c2ca94d86797561b$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? (0, $gtIJY.isTopLayer)(element) ? [] : $c2ca94d86797561b$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $c2ca94d86797561b$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $5Sy7m.max)(rect.top, accRect.top);
        accRect.right = (0, $5Sy7m.min)(rect.right, accRect.right);
        accRect.bottom = (0, $5Sy7m.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $5Sy7m.max)(rect.left, accRect.left);
        return accRect;
    }, $c2ca94d86797561b$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $c2ca94d86797561b$var$getDimensions(element) {
    const { width: width, height: height } = $c2ca94d86797561b$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $c2ca94d86797561b$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $gtIJY.isHTMLElement)(offsetParent);
    const documentElement = (0, $gtIJY.getDocumentElement)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $c2ca94d86797561b$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $5Sy7m.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $gtIJY.getNodeName)(offsetParent) !== "body" || (0, $gtIJY.isOverflowElement)(documentElement)) scroll = (0, $gtIJY.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $c2ca94d86797561b$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $c2ca94d86797561b$var$getWindowScrollBarX(documentElement);
    }
    let htmlX = 0;
    let htmlY = 0;
    if (documentElement && !isOffsetParentAnElement && !isFixed) {
        const htmlRect = documentElement.getBoundingClientRect();
        htmlY = htmlRect.top + scroll.scrollTop;
        htmlX = htmlRect.left + scroll.scrollLeft - // RTL <body> scrollbar.
        $c2ca94d86797561b$var$getWindowScrollBarX(documentElement, htmlRect);
    }
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlX;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlY;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $c2ca94d86797561b$var$isStaticPositioned(element) {
    return (0, $gtIJY.getComputedStyle)(element).position === "static";
}
function $c2ca94d86797561b$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $gtIJY.isHTMLElement)(element) || (0, $gtIJY.getComputedStyle)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $gtIJY.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $c2ca94d86797561b$var$getOffsetParent(element, polyfill) {
    const win = (0, $gtIJY.getWindow)(element);
    if ((0, $gtIJY.isTopLayer)(element)) return win;
    if (!(0, $gtIJY.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $gtIJY.getParentNode)(element);
        while(svgOffsetParent && !(0, $gtIJY.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $gtIJY.isElement)(svgOffsetParent) && !$c2ca94d86797561b$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $gtIJY.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $c2ca94d86797561b$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $gtIJY.isTableElement)(offsetParent) && $c2ca94d86797561b$var$isStaticPositioned(offsetParent))offsetParent = $c2ca94d86797561b$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $gtIJY.isLastTraversableNode)(offsetParent) && $c2ca94d86797561b$var$isStaticPositioned(offsetParent) && !(0, $gtIJY.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $gtIJY.getContainingBlock)(element) || win;
}
const $c2ca94d86797561b$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $c2ca94d86797561b$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $c2ca94d86797561b$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $c2ca94d86797561b$var$isRTL(element) {
    return (0, $gtIJY.getComputedStyle)(element).direction === "rtl";
}
const $c2ca94d86797561b$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $c2ca94d86797561b$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $gtIJY.getDocumentElement,
    getClippingRect: $c2ca94d86797561b$var$getClippingRect,
    getOffsetParent: $c2ca94d86797561b$var$getOffsetParent,
    getElementRects: $c2ca94d86797561b$var$getElementRects,
    getClientRects: $c2ca94d86797561b$var$getClientRects,
    getDimensions: $c2ca94d86797561b$var$getDimensions,
    getScale: $c2ca94d86797561b$var$getScale,
    isElement: $gtIJY.isElement,
    isRTL: $c2ca94d86797561b$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $c2ca94d86797561b$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $gtIJY.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $5Sy7m.floor)(top);
        const insetRight = (0, $5Sy7m.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $5Sy7m.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $5Sy7m.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $5Sy7m.max)(0, (0, $5Sy7m.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $c2ca94d86797561b$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $c2ca94d86797561b$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $gtIJY.getOverflowAncestors)(referenceEl) : [],
        ...(0, $gtIJY.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $c2ca94d86797561b$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $c2ca94d86797561b$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $c2ca94d86797561b$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $c2ca94d86797561b$export$37b6bde19b108ecc = (0, $8biOO.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $c2ca94d86797561b$export$cc800923e997bb8 = (0, $8biOO.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $c2ca94d86797561b$export$91fb6ecbd551914 = (0, $8biOO.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $c2ca94d86797561b$export$fba63a578e423eb = (0, $8biOO.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $c2ca94d86797561b$export$8a83211c878a3f1f = (0, $8biOO.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $c2ca94d86797561b$export$346677f925de839c = (0, $8biOO.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $c2ca94d86797561b$export$fe8985bb6374093c = (0, $8biOO.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $c2ca94d86797561b$export$f2120bbfa5450bd2 = (0, $8biOO.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $c2ca94d86797561b$export$18c8ad048e32c7d5 = (0, $8biOO.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $c2ca94d86797561b$export$7bf07e38f3dc4b69 = (0, $8biOO.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $c2ca94d86797561b$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $c2ca94d86797561b$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $8biOO.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("8biOO", function(module, exports) {

$parcel$export(module.exports, "computePosition", function () { return $5f4df2c71b9d4451$export$48a53dcb22e581d0; });
$parcel$export(module.exports, "detectOverflow", function () { return $5f4df2c71b9d4451$export$37b6bde19b108ecc; });
$parcel$export(module.exports, "arrow", function () { return $5f4df2c71b9d4451$export$f2120bbfa5450bd2; });
$parcel$export(module.exports, "autoPlacement", function () { return $5f4df2c71b9d4451$export$91fb6ecbd551914; });
$parcel$export(module.exports, "flip", function () { return $5f4df2c71b9d4451$export$8a83211c878a3f1f; });
$parcel$export(module.exports, "hide", function () { return $5f4df2c71b9d4451$export$fe8985bb6374093c; });
$parcel$export(module.exports, "inline", function () { return $5f4df2c71b9d4451$export$18c8ad048e32c7d5; });
$parcel$export(module.exports, "offset", function () { return $5f4df2c71b9d4451$export$cc800923e997bb8; });
$parcel$export(module.exports, "shift", function () { return $5f4df2c71b9d4451$export$fba63a578e423eb; });
$parcel$export(module.exports, "limitShift", function () { return $5f4df2c71b9d4451$export$7bf07e38f3dc4b69; });
$parcel$export(module.exports, "size", function () { return $5f4df2c71b9d4451$export$346677f925de839c; });
$parcel$export(module.exports, "rectToClientRect", function () { return (parcelRequire("5Sy7m")).rectToClientRect; });

var $5Sy7m = parcelRequire("5Sy7m");
function $5f4df2c71b9d4451$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $5Sy7m.getSideAxis)(placement);
    const alignmentAxis = (0, $5Sy7m.getAlignmentAxis)(placement);
    const alignLength = (0, $5Sy7m.getAxisLength)(alignmentAxis);
    const side = (0, $5Sy7m.getSide)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $5Sy7m.getAlignment)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $5f4df2c71b9d4451$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $5f4df2c71b9d4451$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $5f4df2c71b9d4451$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $5f4df2c71b9d4451$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $5Sy7m.evaluate)(options, state);
    const paddingObject = (0, $5Sy7m.getPaddingObject)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $5Sy7m.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $5Sy7m.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $5f4df2c71b9d4451$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $5Sy7m.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $5Sy7m.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $5Sy7m.getAlignmentAxis)(placement);
            const length = (0, $5Sy7m.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $5Sy7m.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $5Sy7m.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $5Sy7m.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $5Sy7m.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $5f4df2c71b9d4451$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $5Sy7m.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $5Sy7m.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $5Sy7m.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $5Sy7m.getAlignment)(placement) === alignment || (autoAlignment ? (0, $5Sy7m.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $5f4df2c71b9d4451$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $5Sy7m.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $5Sy7m.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $5Sy7m.placements) ? $5f4df2c71b9d4451$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $5f4df2c71b9d4451$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $5Sy7m.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $5Sy7m.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $5Sy7m.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $5Sy7m.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $5f4df2c71b9d4451$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $5Sy7m.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $5Sy7m.getSide)(placement);
            const initialSideAxis = (0, $5Sy7m.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $5Sy7m.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $5Sy7m.getOppositePlacement)(initialPlacement)
            ] : (0, $5Sy7m.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $5Sy7m.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $5f4df2c71b9d4451$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $5Sy7m.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $5Sy7m.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === "y";
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $5f4df2c71b9d4451$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $5f4df2c71b9d4451$var$isAnySideFullyClipped(overflow) {
    return (0, $5Sy7m.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $5f4df2c71b9d4451$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = (0, $5Sy7m.evaluate)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $5f4df2c71b9d4451$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $5f4df2c71b9d4451$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $5f4df2c71b9d4451$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $5f4df2c71b9d4451$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $5f4df2c71b9d4451$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $5f4df2c71b9d4451$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $5f4df2c71b9d4451$var$getBoundingRect(rects) {
    const minX = (0, $5Sy7m.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $5Sy7m.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $5Sy7m.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $5Sy7m.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $5f4df2c71b9d4451$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $5Sy7m.rectToClientRect)($5f4df2c71b9d4451$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $5f4df2c71b9d4451$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $5Sy7m.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $5f4df2c71b9d4451$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $5Sy7m.rectToClientRect)($5f4df2c71b9d4451$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $5Sy7m.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $5Sy7m.getSideAxis)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $5Sy7m.getSide)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $5Sy7m.getSide)(placement) === "left";
                    const maxRight = (0, $5Sy7m.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $5Sy7m.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $5f4df2c71b9d4451$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $5Sy7m.getSide)(placement);
    const alignment = (0, $5Sy7m.getAlignment)(placement);
    const isVertical = (0, $5Sy7m.getSideAxis)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $5Sy7m.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $5f4df2c71b9d4451$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $5f4df2c71b9d4451$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $5f4df2c71b9d4451$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $5Sy7m.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $5f4df2c71b9d4451$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $5Sy7m.getSideAxis)((0, $5Sy7m.getSide)(placement));
            const mainAxis = (0, $5Sy7m.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $5Sy7m.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $5Sy7m.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $5f4df2c71b9d4451$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $5Sy7m.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $5Sy7m.getSideAxis)(placement);
            const mainAxis = (0, $5Sy7m.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $5Sy7m.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $5Sy7m.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $5f4df2c71b9d4451$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $5Sy7m.evaluate)(options, state);
            const overflow = await $5f4df2c71b9d4451$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $5Sy7m.getSide)(placement);
            const alignment = (0, $5Sy7m.getAlignment)(placement);
            const isYAxis = (0, $5Sy7m.getSideAxis)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $5Sy7m.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $5Sy7m.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $5Sy7m.max)(overflow.left, 0);
                const xMax = (0, $5Sy7m.max)(overflow.right, 0);
                const yMin = (0, $5Sy7m.max)(overflow.top, 0);
                const yMax = (0, $5Sy7m.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $5Sy7m.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $5Sy7m.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("5Sy7m", function(module, exports) {

$parcel$export(module.exports, "sides", function () { return $447c75fb5dca6391$export$832b6fa47fa053d2; });
$parcel$export(module.exports, "placements", function () { return $447c75fb5dca6391$export$803cd8101b6c182b; });
$parcel$export(module.exports, "min", function () { return $447c75fb5dca6391$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "max", function () { return $447c75fb5dca6391$export$8960430cfd85939f; });
$parcel$export(module.exports, "round", function () { return $447c75fb5dca6391$export$2077e0241d6afd3c; });
$parcel$export(module.exports, "floor", function () { return $447c75fb5dca6391$export$a3fe094919f356fd; });
$parcel$export(module.exports, "createCoords", function () { return $447c75fb5dca6391$export$a397704b5e280835; });
$parcel$export(module.exports, "clamp", function () { return $447c75fb5dca6391$export$7d15b64cf5a3a4c4; });
$parcel$export(module.exports, "evaluate", function () { return $447c75fb5dca6391$export$fef61f332f2c0afc; });
$parcel$export(module.exports, "getSide", function () { return $447c75fb5dca6391$export$3c915306cb7fc97a; });
$parcel$export(module.exports, "getAlignment", function () { return $447c75fb5dca6391$export$f0989780f32bfcda; });
$parcel$export(module.exports, "getOppositeAxis", function () { return $447c75fb5dca6391$export$8a000a963141ac32; });
$parcel$export(module.exports, "getAxisLength", function () { return $447c75fb5dca6391$export$320bd9d53520c68a; });
$parcel$export(module.exports, "getSideAxis", function () { return $447c75fb5dca6391$export$f28e8f882010718a; });
$parcel$export(module.exports, "getAlignmentAxis", function () { return $447c75fb5dca6391$export$2b57e0052a6d6d4c; });
$parcel$export(module.exports, "getAlignmentSides", function () { return $447c75fb5dca6391$export$be42861551f17911; });
$parcel$export(module.exports, "getOppositePlacement", function () { return $447c75fb5dca6391$export$9c5e28bad23365fa; });
$parcel$export(module.exports, "getExpandedPlacements", function () { return $447c75fb5dca6391$export$496432a3699e50b1; });
$parcel$export(module.exports, "getOppositeAlignmentPlacement", function () { return $447c75fb5dca6391$export$2b182c584985588b; });
$parcel$export(module.exports, "getOppositeAxisPlacements", function () { return $447c75fb5dca6391$export$a9b6fb18fd92c3ec; });
$parcel$export(module.exports, "getPaddingObject", function () { return $447c75fb5dca6391$export$598c291c29bc2e71; });
$parcel$export(module.exports, "rectToClientRect", function () { return $447c75fb5dca6391$export$ee05aea0aeecbad4; });
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $447c75fb5dca6391$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $447c75fb5dca6391$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $447c75fb5dca6391$export$803cd8101b6c182b = /*#__PURE__*/ $447c75fb5dca6391$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $447c75fb5dca6391$export$27b07d8a310ed8b5[0], side + "-" + $447c75fb5dca6391$export$27b07d8a310ed8b5[1]), []);
const $447c75fb5dca6391$export$96ec731ed4dcb222 = Math.min;
const $447c75fb5dca6391$export$8960430cfd85939f = Math.max;
const $447c75fb5dca6391$export$2077e0241d6afd3c = Math.round;
const $447c75fb5dca6391$export$a3fe094919f356fd = Math.floor;
const $447c75fb5dca6391$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $447c75fb5dca6391$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $447c75fb5dca6391$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $447c75fb5dca6391$export$7d15b64cf5a3a4c4(start, value, end) {
    return $447c75fb5dca6391$export$8960430cfd85939f(start, $447c75fb5dca6391$export$96ec731ed4dcb222(value, end));
}
function $447c75fb5dca6391$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $447c75fb5dca6391$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $447c75fb5dca6391$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $447c75fb5dca6391$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $447c75fb5dca6391$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $447c75fb5dca6391$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($447c75fb5dca6391$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $447c75fb5dca6391$export$2b57e0052a6d6d4c(placement) {
    return $447c75fb5dca6391$export$8a000a963141ac32($447c75fb5dca6391$export$f28e8f882010718a(placement));
}
function $447c75fb5dca6391$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $447c75fb5dca6391$export$f0989780f32bfcda(placement);
    const alignmentAxis = $447c75fb5dca6391$export$2b57e0052a6d6d4c(placement);
    const length = $447c75fb5dca6391$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $447c75fb5dca6391$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $447c75fb5dca6391$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $447c75fb5dca6391$export$496432a3699e50b1(placement) {
    const oppositePlacement = $447c75fb5dca6391$export$9c5e28bad23365fa(placement);
    return [
        $447c75fb5dca6391$export$2b182c584985588b(placement),
        oppositePlacement,
        $447c75fb5dca6391$export$2b182c584985588b(oppositePlacement)
    ];
}
function $447c75fb5dca6391$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$447c75fb5dca6391$var$oppositeAlignmentMap[alignment]);
}
function $447c75fb5dca6391$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $447c75fb5dca6391$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $447c75fb5dca6391$export$f0989780f32bfcda(placement);
    let list = $447c75fb5dca6391$var$getSideList($447c75fb5dca6391$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($447c75fb5dca6391$export$2b182c584985588b));
    }
    return list;
}
function $447c75fb5dca6391$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$447c75fb5dca6391$var$oppositeSideMap[side]);
}
function $447c75fb5dca6391$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $447c75fb5dca6391$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $447c75fb5dca6391$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $447c75fb5dca6391$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});


parcelRegister("gtIJY", function(module, exports) {

$parcel$export(module.exports, "getNodeName", function () { return $bff20f51302fa30a$export$651544f548703224; });
$parcel$export(module.exports, "getWindow", function () { return $bff20f51302fa30a$export$38b2d434cce3ea22; });
$parcel$export(module.exports, "getDocumentElement", function () { return $bff20f51302fa30a$export$e495491855dc5418; });
$parcel$export(module.exports, "isElement", function () { return $bff20f51302fa30a$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $bff20f51302fa30a$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isOverflowElement", function () { return $bff20f51302fa30a$export$989e911fa9af580a; });
$parcel$export(module.exports, "getComputedStyle", function () { return $bff20f51302fa30a$export$3735103072e4a80; });
$parcel$export(module.exports, "isTableElement", function () { return $bff20f51302fa30a$export$71535ffaa902797f; });
$parcel$export(module.exports, "isTopLayer", function () { return $bff20f51302fa30a$export$89e651af02346cd4; });
$parcel$export(module.exports, "isContainingBlock", function () { return $bff20f51302fa30a$export$d6c4e8150c35fed1; });
$parcel$export(module.exports, "isWebKit", function () { return $bff20f51302fa30a$export$78551043582a6a98; });
$parcel$export(module.exports, "getContainingBlock", function () { return $bff20f51302fa30a$export$940d8225183e1404; });
$parcel$export(module.exports, "getParentNode", function () { return $bff20f51302fa30a$export$4e12058fc4d51d56; });
$parcel$export(module.exports, "isLastTraversableNode", function () { return $bff20f51302fa30a$export$d1162fb0b6d4cd51; });
$parcel$export(module.exports, "getNodeScroll", function () { return $bff20f51302fa30a$export$dc8fc79fa2800137; });
$parcel$export(module.exports, "getOverflowAncestors", function () { return $bff20f51302fa30a$export$3b57c1601291186b; });
$parcel$export(module.exports, "getFrameElement", function () { return $bff20f51302fa30a$export$7bf1f8740e3e34af; });
function $bff20f51302fa30a$var$hasWindow() {
    return typeof window !== "undefined";
}
function $bff20f51302fa30a$export$651544f548703224(node) {
    if ($bff20f51302fa30a$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $bff20f51302fa30a$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $bff20f51302fa30a$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($bff20f51302fa30a$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $bff20f51302fa30a$export$8ee0fc9ee280b4ee(value) {
    if (!$bff20f51302fa30a$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $bff20f51302fa30a$export$38b2d434cce3ea22(value).Node;
}
function $bff20f51302fa30a$export$45a5e7f76e0caa8d(value) {
    if (!$bff20f51302fa30a$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $bff20f51302fa30a$export$38b2d434cce3ea22(value).Element;
}
function $bff20f51302fa30a$export$1b3bfaa9684536aa(value) {
    if (!$bff20f51302fa30a$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $bff20f51302fa30a$export$38b2d434cce3ea22(value).HTMLElement;
}
function $bff20f51302fa30a$export$af51f0f06c0f328a(value) {
    if (!$bff20f51302fa30a$var$hasWindow() || typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $bff20f51302fa30a$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $bff20f51302fa30a$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $bff20f51302fa30a$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $bff20f51302fa30a$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($bff20f51302fa30a$export$651544f548703224(element));
}
function $bff20f51302fa30a$export$89e651af02346cd4(element) {
    return [
        ":popover-open",
        ":modal"
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $bff20f51302fa30a$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $bff20f51302fa30a$export$78551043582a6a98();
    const css = $bff20f51302fa30a$export$45a5e7f76e0caa8d(elementOrCss) ? $bff20f51302fa30a$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $bff20f51302fa30a$export$940d8225183e1404(element) {
    let currentNode = $bff20f51302fa30a$export$4e12058fc4d51d56(element);
    while($bff20f51302fa30a$export$1b3bfaa9684536aa(currentNode) && !$bff20f51302fa30a$export$d1162fb0b6d4cd51(currentNode)){
        if ($bff20f51302fa30a$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($bff20f51302fa30a$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $bff20f51302fa30a$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $bff20f51302fa30a$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $bff20f51302fa30a$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($bff20f51302fa30a$export$651544f548703224(node));
}
function $bff20f51302fa30a$export$3735103072e4a80(element) {
    return $bff20f51302fa30a$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $bff20f51302fa30a$export$dc8fc79fa2800137(element) {
    if ($bff20f51302fa30a$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $bff20f51302fa30a$export$4e12058fc4d51d56(node) {
    if ($bff20f51302fa30a$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $bff20f51302fa30a$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $bff20f51302fa30a$export$e495491855dc5418(node);
    return $bff20f51302fa30a$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $bff20f51302fa30a$export$7cd01a57c8ca906c(node) {
    const parentNode = $bff20f51302fa30a$export$4e12058fc4d51d56(node);
    if ($bff20f51302fa30a$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($bff20f51302fa30a$export$1b3bfaa9684536aa(parentNode) && $bff20f51302fa30a$export$989e911fa9af580a(parentNode)) return parentNode;
    return $bff20f51302fa30a$export$7cd01a57c8ca906c(parentNode);
}
function $bff20f51302fa30a$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $bff20f51302fa30a$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $bff20f51302fa30a$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $bff20f51302fa30a$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $bff20f51302fa30a$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $bff20f51302fa30a$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $bff20f51302fa30a$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $bff20f51302fa30a$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

});


parcelRegister("7S5UH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5bb229de59bab058$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");
var $5bb229de59bab058$var$index = (0, $jbmdS.useLayoutEffect);
var $5bb229de59bab058$export$2e2bcd8739ae039 = $5bb229de59bab058$var$index;

});


parcelRegister("caw0M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8dbf400e3b1a2bb7$export$2e2bcd8739ae039; });

var $5EIrF = parcelRequire("5EIrF");

var $7i29i = parcelRequire("7i29i");

var $jbmdS = parcelRequire("jbmdS");

var $gxSAi = parcelRequire("gxSAi");

var $kjYAx = parcelRequire("kjYAx");

var $bMPPJ = parcelRequire("bMPPJ");

var $fDDh6 = parcelRequire("fDDh6");
parcelRequire("bNHQV");
parcelRequire("8ABWE");
parcelRequire("2edOn");
parcelRequire("keWlZ");
parcelRequire("czJCt");
parcelRequire("khSB6");
parcelRequire("5iFfU");
parcelRequire("b5KuC");

parcelRequire("2HGGA");
parcelRequire("jqlgK");
parcelRequire("bPsra");
parcelRequire("jCNM0");

parcelRequire("7S5UH");
var $8dbf400e3b1a2bb7$var$StateManagedSelect = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $5EIrF.u)(props);
    return /*#__PURE__*/ $jbmdS.createElement((0, $gxSAi.S), (0, $7i29i.default)({
        ref: ref
    }, baseSelectProps));
});
var $8dbf400e3b1a2bb7$export$2e2bcd8739ae039 = $8dbf400e3b1a2bb7$var$StateManagedSelect;
var $8dbf400e3b1a2bb7$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $jbmdS.useMemo)(function() {
        return (0, $bMPPJ.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $jbmdS.createElement((0, $kjYAx.C), {
        value: emotionCache
    }, children);
};

});
parcelRegister("5EIrF", function(module, exports) {

$parcel$export(module.exports, "u", function () { return $41e32a0eca30d320$export$3b14a55fb2447963; });

var $lv6ip = parcelRequire("lv6ip");

var $CZyex = parcelRequire("CZyex");

var $ccQt4 = parcelRequire("ccQt4");

var $jbmdS = parcelRequire("jbmdS");
var $41e32a0eca30d320$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $41e32a0eca30d320$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? "" : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $ccQt4.default)(_ref, $41e32a0eca30d320$var$_excluded);
    var _useState = (0, $jbmdS.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $CZyex.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $jbmdS.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $CZyex.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $jbmdS.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $CZyex.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $jbmdS.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === "function") propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $jbmdS.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === "function") newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $jbmdS.useCallback)(function() {
        if (typeof propsOnMenuOpen === "function") propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $jbmdS.useCallback)(function() {
        if (typeof propsOnMenuClose === "function") propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $lv6ip.default)((0, $lv6ip.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});

parcelRegister("gxSAi", function(module, exports) {

$parcel$export(module.exports, "S", function () { return $c0ba11bf56eaee76$export$25ce5a424b770e84; });

var $7i29i = parcelRequire("7i29i");

var $lv6ip = parcelRequire("lv6ip");

var $3GVdq = parcelRequire("3GVdq");

var $jj5jQ = parcelRequire("jj5jQ");

var $1N4zm = parcelRequire("1N4zm");

var $gRFRo = parcelRequire("gRFRo");

var $huwkX = parcelRequire("huwkX");

var $jbmdS = parcelRequire("jbmdS");

var $fDDh6 = parcelRequire("fDDh6");

var $BPPBq = parcelRequire("BPPBq");

var $34S1T = parcelRequire("34S1T");

var $ccQt4 = parcelRequire("ccQt4");
function $c0ba11bf56eaee76$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $c0ba11bf56eaee76$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $c0ba11bf56eaee76$var$A11yText = function A11yText(props) {
    return (0, $BPPBq.jsx)("span", (0, $7i29i.default)({
        css: $c0ba11bf56eaee76$var$_ref
    }, props));
};
var $c0ba11bf56eaee76$var$A11yText$1 = $c0ba11bf56eaee76$var$A11yText;
var $c0ba11bf56eaee76$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
        switch(context){
            case "menu":
                return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ", press Tab to select the option and exit the menu" : "", ".");
            case "input":
                return isInitialFocus ? "".concat(props["aria-label"] || "Select", " is focused ").concat(isSearchable ? ",type to refine list" : "", ", press Down to open the menu, ").concat(isMulti ? " press left to focus selected values" : "") : "";
            case "value":
                return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
            default:
                return "";
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? "" : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case "deselect-option":
            case "pop-value":
            case "remove-value":
                return "option ".concat(label, ", deselected.");
            case "clear":
                return "All selected options have been cleared.";
            case "initial-input-focus":
                return "option".concat(labels.length > 1 ? "s" : "", " ").concat(labels.join(","), ", selected.");
            case "select-option":
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return "";
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? "" : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice = props.isAppleDevice;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : "";
        };
        if (context === "value" && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === "menu" && isAppleDevice) {
            var disabled = isDisabled ? " disabled" : "";
            var status = "".concat(isSelected ? " selected" : "").concat(disabled);
            return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return "";
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? " for search term " + inputValue : "", ".");
    }
};
var $c0ba11bf56eaee76$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id, isAppleDevice = props.isAppleDevice;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
    var ariaLabel = selectProps["aria-label"];
    var ariaLive = selectProps["aria-live"];
    // Update aria live message configuration when prop changes
    var messages = (0, $jbmdS.useMemo)(function() {
        return (0, $lv6ip.default)((0, $lv6ip.default)({}, $c0ba11bf56eaee76$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $jbmdS.useMemo)(function() {
        var message = "";
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : "";
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $lv6ip.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $jbmdS.useMemo)(function() {
        var focusMsg = "";
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? "menu" : "value",
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    var ariaResults = (0, $jbmdS.useMemo)(function() {
        var resultsMsg = "";
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus";
    var ariaGuidance = (0, $jbmdS.useMemo)(function() {
        var guidanceMsg = "";
        if (messages.guidance) {
            var context = focusedValue ? "value" : menuIsOpen ? "menu" : "input";
            guidanceMsg = messages.guidance({
                "aria-label": ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    var ScreenReaderText = (0, $BPPBq.jsx)((0, $jbmdS.Fragment), null, (0, $BPPBq.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $BPPBq.jsx)("span", {
        id: "aria-focused"
    }, ariaFocused), (0, $BPPBq.jsx)("span", {
        id: "aria-results"
    }, ariaResults), (0, $BPPBq.jsx)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return (0, $BPPBq.jsx)((0, $jbmdS.Fragment), null, (0, $BPPBq.jsx)($c0ba11bf56eaee76$var$A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $BPPBq.jsx)($c0ba11bf56eaee76$var$A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $c0ba11bf56eaee76$var$LiveRegion$1 = $c0ba11bf56eaee76$var$LiveRegion;
var $c0ba11bf56eaee76$var$diacritics = [
    {
        base: "A",
        letters: "A\u24B6\uFF21\xc0\xc1\xc2\u1EA6\u1EA4\u1EAA\u1EA8\xc3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xc4\u01DE\u1EA2\xc5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: "AA",
        letters: "\uA732"
    },
    {
        base: "AE",
        letters: "\xc6\u01FC\u01E2"
    },
    {
        base: "AO",
        letters: "\uA734"
    },
    {
        base: "AU",
        letters: "\uA736"
    },
    {
        base: "AV",
        letters: "\uA738\uA73A"
    },
    {
        base: "AY",
        letters: "\uA73C"
    },
    {
        base: "B",
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: "C",
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xc7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: "D",
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: "DZ",
        letters: "\u01F1\u01C4"
    },
    {
        base: "Dz",
        letters: "\u01F2\u01C5"
    },
    {
        base: "E",
        letters: "E\u24BA\uFF25\xc8\xc9\xca\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xcb\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: "F",
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: "G",
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: "H",
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: "I",
        letters: "I\u24BE\uFF29\xcc\xcd\xce\u0128\u012A\u012C\u0130\xcf\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: "J",
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: "K",
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: "L",
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: "LJ",
        letters: "\u01C7"
    },
    {
        base: "Lj",
        letters: "\u01C8"
    },
    {
        base: "M",
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: "N",
        letters: "N\u24C3\uFF2E\u01F8\u0143\xd1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: "NJ",
        letters: "\u01CA"
    },
    {
        base: "Nj",
        letters: "\u01CB"
    },
    {
        base: "O",
        letters: "O\u24C4\uFF2F\xd2\xd3\xd4\u1ED2\u1ED0\u1ED6\u1ED4\xd5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xd6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xd8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: "OI",
        letters: "\u01A2"
    },
    {
        base: "OO",
        letters: "\uA74E"
    },
    {
        base: "OU",
        letters: "\u0222"
    },
    {
        base: "P",
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: "Q",
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: "R",
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: "S",
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: "T",
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: "TZ",
        letters: "\uA728"
    },
    {
        base: "U",
        letters: "U\u24CA\uFF35\xd9\xda\xdb\u0168\u1E78\u016A\u1E7A\u016C\xdc\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: "V",
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: "VY",
        letters: "\uA760"
    },
    {
        base: "W",
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: "X",
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: "Y",
        letters: "Y\u24CE\uFF39\u1EF2\xdd\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: "Z",
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: "a",
        letters: "a\u24D0\uFF41\u1E9A\xe0\xe1\xe2\u1EA7\u1EA5\u1EAB\u1EA9\xe3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xe4\u01DF\u1EA3\xe5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: "aa",
        letters: "\uA733"
    },
    {
        base: "ae",
        letters: "\xe6\u01FD\u01E3"
    },
    {
        base: "ao",
        letters: "\uA735"
    },
    {
        base: "au",
        letters: "\uA737"
    },
    {
        base: "av",
        letters: "\uA739\uA73B"
    },
    {
        base: "ay",
        letters: "\uA73D"
    },
    {
        base: "b",
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: "c",
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xe7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: "d",
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: "dz",
        letters: "\u01F3\u01C6"
    },
    {
        base: "e",
        letters: "e\u24D4\uFF45\xe8\xe9\xea\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xeb\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: "f",
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: "g",
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: "h",
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: "hv",
        letters: "\u0195"
    },
    {
        base: "i",
        letters: "i\u24D8\uFF49\xec\xed\xee\u0129\u012B\u012D\xef\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: "j",
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: "k",
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: "l",
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: "lj",
        letters: "\u01C9"
    },
    {
        base: "m",
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: "n",
        letters: "n\u24DD\uFF4E\u01F9\u0144\xf1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: "nj",
        letters: "\u01CC"
    },
    {
        base: "o",
        letters: "o\u24DE\uFF4F\xf2\xf3\xf4\u1ED3\u1ED1\u1ED7\u1ED5\xf5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xf6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xf8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: "oi",
        letters: "\u01A3"
    },
    {
        base: "ou",
        letters: "\u0223"
    },
    {
        base: "oo",
        letters: "\uA74F"
    },
    {
        base: "p",
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: "q",
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: "r",
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: "s",
        letters: "s\u24E2\uFF53\xdf\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: "t",
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: "tz",
        letters: "\uA729"
    },
    {
        base: "u",
        letters: "u\u24E4\uFF55\xf9\xfa\xfb\u0169\u1E79\u016B\u1E7B\u016D\xfc\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: "v",
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: "vy",
        letters: "\uA761"
    },
    {
        base: "w",
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: "x",
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: "y",
        letters: "y\u24E8\uFF59\u1EF3\xfd\u0177\u1EF9\u0233\u1E8F\xff\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: "z",
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $c0ba11bf56eaee76$var$anyDiacritic = new RegExp("[" + $c0ba11bf56eaee76$var$diacritics.map(function(d) {
    return d.letters;
}).join("") + "]", "g");
var $c0ba11bf56eaee76$var$diacriticToBase = {};
for(var $c0ba11bf56eaee76$var$i = 0; $c0ba11bf56eaee76$var$i < $c0ba11bf56eaee76$var$diacritics.length; $c0ba11bf56eaee76$var$i++){
    var $c0ba11bf56eaee76$var$diacritic = $c0ba11bf56eaee76$var$diacritics[$c0ba11bf56eaee76$var$i];
    for(var $c0ba11bf56eaee76$var$j = 0; $c0ba11bf56eaee76$var$j < $c0ba11bf56eaee76$var$diacritic.letters.length; $c0ba11bf56eaee76$var$j++)$c0ba11bf56eaee76$var$diacriticToBase[$c0ba11bf56eaee76$var$diacritic.letters[$c0ba11bf56eaee76$var$j]] = $c0ba11bf56eaee76$var$diacritic.base;
}
var $c0ba11bf56eaee76$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($c0ba11bf56eaee76$var$anyDiacritic, function(match) {
        return $c0ba11bf56eaee76$var$diacriticToBase[match];
    });
};
var $c0ba11bf56eaee76$var$memoizedStripDiacriticsForInput = (0, $34S1T.default)($c0ba11bf56eaee76$var$stripDiacritics);
var $c0ba11bf56eaee76$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, "");
};
var $c0ba11bf56eaee76$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $c0ba11bf56eaee76$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $lv6ip.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $c0ba11bf56eaee76$var$defaultStringify,
            trim: true,
            matchFrom: "any"
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $c0ba11bf56eaee76$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $c0ba11bf56eaee76$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $c0ba11bf56eaee76$var$memoizedStripDiacriticsForInput(input);
            candidate = $c0ba11bf56eaee76$var$stripDiacritics(candidate);
        }
        return matchFrom === "start" ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $c0ba11bf56eaee76$var$_excluded = [
    "innerRef"
];
function $c0ba11bf56eaee76$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $ccQt4.default)(_ref, $c0ba11bf56eaee76$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $fDDh6.r)(props, "onExited", "in", "enter", "exit", "appear");
    return (0, $BPPBq.jsx)("input", (0, $7i29i.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $BPPBq.css)({
            label: "dummyInput",
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: "transparent",
            fontSize: "inherit",
            gridArea: "1 / 1 / 2 / 3",
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: "transparent",
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: "relative",
            transform: "scale(.01)"
        }, "", "")
    }));
}
var $c0ba11bf56eaee76$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $c0ba11bf56eaee76$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $jbmdS.useRef)(false);
    var isTop = (0, $jbmdS.useRef)(false);
    var touchStart = (0, $jbmdS.useRef)(0);
    var scrollTarget = (0, $jbmdS.useRef)(null);
    var handleEventDelta = (0, $jbmdS.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $c0ba11bf56eaee76$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $jbmdS.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $jbmdS.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $jbmdS.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $jbmdS.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $fDDh6.s) ? {
            passive: false
        } : false;
        el.addEventListener("wheel", onWheel, notPassive);
        el.addEventListener("touchstart", onTouchStart, notPassive);
        el.addEventListener("touchmove", onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $jbmdS.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener("wheel", onWheel, false);
        el.removeEventListener("touchstart", onTouchStart, false);
        el.removeEventListener("touchmove", onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $jbmdS.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $c0ba11bf56eaee76$var$STYLE_KEYS = [
    "boxSizing",
    "height",
    "overflow",
    "paddingRight",
    "position"
];
var $c0ba11bf56eaee76$var$LOCK_STYLES = {
    boxSizing: "border-box",
    // account for possible declaration `width: 100%;` on body
    overflow: "hidden",
    position: "relative",
    height: "100%"
};
function $c0ba11bf56eaee76$var$preventTouchMove(e) {
    if (e.cancelable) e.preventDefault();
}
function $c0ba11bf56eaee76$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $c0ba11bf56eaee76$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $c0ba11bf56eaee76$var$isTouchDevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
}
var $c0ba11bf56eaee76$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $c0ba11bf56eaee76$var$activeScrollLocks = 0;
var $c0ba11bf56eaee76$var$listenerOptions = {
    capture: false,
    passive: false
};
function $c0ba11bf56eaee76$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $jbmdS.useRef)({});
    var scrollTarget = (0, $jbmdS.useRef)(null);
    var addScrollLock = (0, $jbmdS.useCallback)(function(touchScrollTarget) {
        if (!$c0ba11bf56eaee76$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $c0ba11bf56eaee76$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $c0ba11bf56eaee76$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($c0ba11bf56eaee76$var$LOCK_STYLES).forEach(function(key) {
                var val = $c0ba11bf56eaee76$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $c0ba11bf56eaee76$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener("touchmove", $c0ba11bf56eaee76$var$preventTouchMove, $c0ba11bf56eaee76$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener("touchstart", $c0ba11bf56eaee76$var$preventInertiaScroll, $c0ba11bf56eaee76$var$listenerOptions);
                touchScrollTarget.addEventListener("touchmove", $c0ba11bf56eaee76$var$allowTouchMove, $c0ba11bf56eaee76$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $c0ba11bf56eaee76$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $jbmdS.useCallback)(function(touchScrollTarget) {
        if (!$c0ba11bf56eaee76$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $c0ba11bf56eaee76$var$activeScrollLocks = Math.max($c0ba11bf56eaee76$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $c0ba11bf56eaee76$var$activeScrollLocks < 1) $c0ba11bf56eaee76$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $c0ba11bf56eaee76$var$isTouchDevice()) {
            target.removeEventListener("touchmove", $c0ba11bf56eaee76$var$preventTouchMove, $c0ba11bf56eaee76$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener("touchstart", $c0ba11bf56eaee76$var$preventInertiaScroll, $c0ba11bf56eaee76$var$listenerOptions);
                touchScrollTarget.removeEventListener("touchmove", $c0ba11bf56eaee76$var$allowTouchMove, $c0ba11bf56eaee76$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $jbmdS.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $c0ba11bf56eaee76$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $c0ba11bf56eaee76$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var $c0ba11bf56eaee76$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $c0ba11bf56eaee76$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $c0ba11bf56eaee76$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $c0ba11bf56eaee76$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $BPPBq.jsx)((0, $jbmdS.Fragment), null, lockEnabled && (0, $BPPBq.jsx)("div", {
        onClick: $c0ba11bf56eaee76$var$blurSelectInput,
        css: $c0ba11bf56eaee76$var$_ref2$1
    }), children(targetRef));
}
function $c0ba11bf56eaee76$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $c0ba11bf56eaee76$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $c0ba11bf56eaee76$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $BPPBq.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $c0ba11bf56eaee76$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $c0ba11bf56eaee76$var$RequiredInput$1 = $c0ba11bf56eaee76$var$RequiredInput;
/// <reference types="user-agent-data-types" />
function $c0ba11bf56eaee76$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== "undefined" && window.navigator != null ? re.test(((_window$navigator$use = window.navigator["userAgentData"]) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $c0ba11bf56eaee76$var$isIPhone() {
    return $c0ba11bf56eaee76$var$testPlatform(/^iPhone/i);
}
function $c0ba11bf56eaee76$var$isMac() {
    return $c0ba11bf56eaee76$var$testPlatform(/^Mac/i);
}
function $c0ba11bf56eaee76$var$isIPad() {
    return $c0ba11bf56eaee76$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $c0ba11bf56eaee76$var$isMac() && navigator.maxTouchPoints > 1;
}
function $c0ba11bf56eaee76$var$isIOS() {
    return $c0ba11bf56eaee76$var$isIPhone() || $c0ba11bf56eaee76$var$isIPad();
}
function $c0ba11bf56eaee76$var$isAppleDevice() {
    return $c0ba11bf56eaee76$var$isMac() || $c0ba11bf56eaee76$var$isIOS();
}
var $c0ba11bf56eaee76$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $c0ba11bf56eaee76$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $c0ba11bf56eaee76$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $c0ba11bf56eaee76$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $c0ba11bf56eaee76$var$defaultStyles = {
    clearIndicator: (0, $fDDh6.a),
    container: (0, $fDDh6.b),
    control: (0, $fDDh6.d),
    dropdownIndicator: (0, $fDDh6.e),
    group: (0, $fDDh6.g),
    groupHeading: (0, $fDDh6.f),
    indicatorsContainer: (0, $fDDh6.i),
    indicatorSeparator: (0, $fDDh6.h),
    input: (0, $fDDh6.j),
    loadingIndicator: (0, $fDDh6.l),
    loadingMessage: (0, $fDDh6.k),
    menu: (0, $fDDh6.m),
    menuList: (0, $fDDh6.n),
    menuPortal: (0, $fDDh6.o),
    multiValue: (0, $fDDh6.p),
    multiValueLabel: (0, $fDDh6.q),
    multiValueRemove: (0, $fDDh6.t),
    noOptionsMessage: (0, $fDDh6.u),
    option: (0, $fDDh6.v),
    placeholder: (0, $fDDh6.w),
    singleValue: (0, $fDDh6.x),
    valueContainer: (0, $fDDh6.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $c0ba11bf56eaee76$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $lv6ip.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $c0ba11bf56eaee76$var$colors = {
    primary: "#2684FF",
    primary75: "#4C9AFF",
    primary50: "#B2D4FF",
    primary25: "#DEEBFF",
    danger: "#DE350B",
    dangerLight: "#FFBDAD",
    neutral0: "hsl(0, 0%, 100%)",
    neutral5: "hsl(0, 0%, 95%)",
    neutral10: "hsl(0, 0%, 90%)",
    neutral20: "hsl(0, 0%, 80%)",
    neutral30: "hsl(0, 0%, 70%)",
    neutral40: "hsl(0, 0%, 60%)",
    neutral50: "hsl(0, 0%, 50%)",
    neutral60: "hsl(0, 0%, 40%)",
    neutral70: "hsl(0, 0%, 30%)",
    neutral80: "hsl(0, 0%, 20%)",
    neutral90: "hsl(0, 0%, 10%)"
};
var $c0ba11bf56eaee76$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $c0ba11bf56eaee76$var$baseUnit = 4;
// The minimum height of the control
var $c0ba11bf56eaee76$var$controlHeight = 38;
// The amount of space between the control and menu */
var $c0ba11bf56eaee76$var$menuGutter = $c0ba11bf56eaee76$var$baseUnit * 2;
var $c0ba11bf56eaee76$var$spacing = {
    baseUnit: $c0ba11bf56eaee76$var$baseUnit,
    controlHeight: $c0ba11bf56eaee76$var$controlHeight,
    menuGutter: $c0ba11bf56eaee76$var$menuGutter
};
var $c0ba11bf56eaee76$export$4368d992c4eafac0 = {
    borderRadius: $c0ba11bf56eaee76$var$borderRadius,
    colors: $c0ba11bf56eaee76$var$colors,
    spacing: $c0ba11bf56eaee76$var$spacing
};
var $c0ba11bf56eaee76$export$407448d2b89b1813 = {
    "aria-live": "polite",
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $fDDh6.z)(),
    captureMenuScroll: !(0, $fDDh6.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $c0ba11bf56eaee76$export$db3b6bfb95261072(),
    formatGroupLabel: $c0ba11bf56eaee76$var$formatGroupLabel,
    getOptionLabel: $c0ba11bf56eaee76$export$8b22cf2602fb60ce,
    getOptionValue: $c0ba11bf56eaee76$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $c0ba11bf56eaee76$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return "Loading...";
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: "bottom",
    menuPosition: "absolute",
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $fDDh6.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return "No options";
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: "Select...",
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? "s" : "", " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $c0ba11bf56eaee76$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $c0ba11bf56eaee76$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $c0ba11bf56eaee76$var$_isOptionSelected(props, option, selectValue);
    var label = $c0ba11bf56eaee76$var$getOptionLabel(props, option);
    var value = $c0ba11bf56eaee76$var$getOptionValue(props, option);
    return {
        type: "option",
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $c0ba11bf56eaee76$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ("options" in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $c0ba11bf56eaee76$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $c0ba11bf56eaee76$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: "group",
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $c0ba11bf56eaee76$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $c0ba11bf56eaee76$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $fDDh6.K));
}
function $c0ba11bf56eaee76$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, $huwkX.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $c0ba11bf56eaee76$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, $huwkX.default)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $c0ba11bf56eaee76$var$buildFocusableOptions(props, selectValue) {
    return $c0ba11bf56eaee76$var$buildFocusableOptionsFromCategorizedOptions($c0ba11bf56eaee76$var$buildCategorizedOptions(props, selectValue));
}
function $c0ba11bf56eaee76$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? "" : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$c0ba11bf56eaee76$var$shouldHideSelectedOptions(props) || !isSelected) && $c0ba11bf56eaee76$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $c0ba11bf56eaee76$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $c0ba11bf56eaee76$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $c0ba11bf56eaee76$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $c0ba11bf56eaee76$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $c0ba11bf56eaee76$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $c0ba11bf56eaee76$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === "function" ? props.isOptionDisabled(option, selectValue) : false;
}
function $c0ba11bf56eaee76$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === "function") return props.isOptionSelected(option, selectValue);
    var candidate = $c0ba11bf56eaee76$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $c0ba11bf56eaee76$var$getOptionValue(props, i) === candidate;
    });
}
function $c0ba11bf56eaee76$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $c0ba11bf56eaee76$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $c0ba11bf56eaee76$var$instanceId = 1;
var $c0ba11bf56eaee76$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $1N4zm.default)(Select, _Component);
    var _super = (0, $gRFRo.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $3GVdq.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ""
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.isAppleDevice = $c0ba11bf56eaee76$var$isAppleDevice();
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange("", {
                action: "set-value",
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $fDDh6.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), "deselect-option", newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $fDDh6.B)([].concat((0, $huwkX.default)(selectValue), [
                    newValue
                ])), "select-option", newValue);
                else _this.setValue((0, $fDDh6.C)(newValue), "select-option");
            } else {
                _this.ariaOnChange((0, $fDDh6.C)(newValue), {
                    action: "select-option",
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $fDDh6.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "remove-value",
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $fDDh6.D)(_this.props.isMulti, [], null), {
                action: "clear",
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $fDDh6.D)(isMulti, newValueArray, newValueArray[0] || null);
            if (lastSelectedValue) _this.onChange(newValue, {
                action: "pop-value",
                removedValue: lastSelectedValue
            });
        };
        _this.getFocusedOptionId = function(focusedOption) {
            return $c0ba11bf56eaee76$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        };
        _this.getFocusableOptionsWithIds = function() {
            return $c0ba11bf56eaee76$var$buildFocusableOptionsWithIds($c0ba11bf56eaee76$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId("option"));
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $fDDh6.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $c0ba11bf56eaee76$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $c0ba11bf56eaee76$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $c0ba11bf56eaee76$var$defaultStyles[key](props, unstyled);
            base.boxSizing = "border-box";
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $fDDh6.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $c0ba11bf56eaee76$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $c0ba11bf56eaee76$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $lv6ip.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu("first");
            } else if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") _this.onMenuClose();
            if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu("first");
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === "touchend") _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === "boolean") {
                if (event.target instanceof HTMLElement && (0, $fDDh6.G)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === "function") {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: "input-change",
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu("first");
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange("", {
                action: "input-blur",
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $c0ba11bf56eaee76$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === "function") {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case "ArrowLeft":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("previous");
                    break;
                case "ArrowRight":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("next");
                    break;
                case "Delete":
                case "Backspace":
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case "Tab":
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case "Enter":
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case "Escape":
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange("", {
                            action: "menu-close",
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case " ":
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu("first");
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case "ArrowUp":
                    if (menuIsOpen) _this.focusOption("up");
                    else _this.openMenu("last");
                    break;
                case "ArrowDown":
                    if (menuIsOpen) _this.focusOption("down");
                    else _this.openMenu("first");
                    break;
                case "PageUp":
                    if (!menuIsOpen) return;
                    _this.focusOption("pageup");
                    break;
                case "PageDown":
                    if (!menuIsOpen) return;
                    _this.focusOption("pagedown");
                    break;
                case "Home":
                    if (!menuIsOpen) return;
                    _this.focusOption("first");
                    break;
                case "End":
                    if (!menuIsOpen) return;
                    _this.focusOption("last");
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.state.instancePrefix = "react-select-" + (_this.props.instanceId || ++$c0ba11bf56eaee76$var$instanceId);
        _this.state.selectValue = (0, $fDDh6.H)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $c0ba11bf56eaee76$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, $jj5jQ.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener("scroll", this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $fDDh6.I)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $fDDh6.I)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener("scroll", this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange("", {
                    action: "menu-close",
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === "first" ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex],
                    focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case "previous":
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case "next":
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "first";
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === "up") nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === "down") nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === "pageup") {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === "pagedown") {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === "last") nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $c0ba11bf56eaee76$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === "function") return this.props.theme($c0ba11bf56eaee76$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $lv6ip.default)((0, $lv6ip.default)({}, $c0ba11bf56eaee76$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $c0ba11bf56eaee76$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $c0ba11bf56eaee76$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $c0ba11bf56eaee76$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === "function") {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener("compositionstart", this.onCompositionStart, false);
                    document.addEventListener("compositionend", this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("compositionstart", this.onCompositionStart);
                    document.removeEventListener("compositionend", this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener("touchstart", this.onTouchStart, false);
                    document.addEventListener("touchmove", this.onTouchMove, false);
                    document.addEventListener("touchend", this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("touchstart", this.onTouchStart);
                    document.removeEventListener("touchmove", this.onTouchMove);
                    document.removeEventListener("touchend", this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId("input");
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $lv6ip.default)((0, $lv6ip.default)((0, $lv6ip.default)({
                    "aria-autocomplete": "list",
                    "aria-expanded": menuIsOpen,
                    "aria-haspopup": true,
                    "aria-errormessage": this.props["aria-errormessage"],
                    "aria-invalid": this.props["aria-invalid"],
                    "aria-label": this.props["aria-label"],
                    "aria-labelledby": this.props["aria-labelledby"],
                    "aria-required": required,
                    role: "combobox",
                    "aria-activedescendant": this.isAppleDevice ? undefined : this.state.focusedOptionId || ""
                }, menuIsOpen && {
                    "aria-controls": this.getElementId("listbox")
                }), !isSearchable && {
                    "aria-readonly": true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus" && {
                    "aria-describedby": this.getElementId("live-region")
                } : {
                    "aria-describedby": this.getElementId("placeholder")
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $jbmdS.createElement($c0ba11bf56eaee76$var$DummyInput, (0, $7i29i.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $fDDh6.J),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $jbmdS.createElement(Input, (0, $7i29i.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $jbmdS.createElement(Placeholder, (0, $7i29i.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId("placeholder")
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $jbmdS.createElement(MultiValue, (0, $7i29i.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, "value"));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $jbmdS.createElement(SingleValue, (0, $7i29i.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, "value"));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $jbmdS.createElement(ClearIndicator, (0, $7i29i.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $jbmdS.createElement(LoadingIndicator, (0, $7i29i.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $jbmdS.createElement(IndicatorSeparator, (0, $7i29i.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $jbmdS.createElement(DropdownIndicator, (0, $7i29i.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId("option"), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1,
                        role: "option",
                        "aria-selected": _this4.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
                    };
                    return /*#__PURE__*/ $jbmdS.createElement(Option, (0, $7i29i.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, "menu"));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === "group") {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId("group"), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $jbmdS.createElement(Group, (0, $7i29i.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === "option") return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $jbmdS.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $jbmdS.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $jbmdS.createElement((0, $fDDh6.M), (0, $7i29i.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $jbmdS.createElement(Menu, (0, $7i29i.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $jbmdS.createElement($c0ba11bf56eaee76$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $jbmdS.createElement(MenuList, (0, $7i29i.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: {
                                role: "listbox",
                                "aria-multiselectable": commonProps.isMulti,
                                id: _this4.getElementId("listbox")
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === "fixed" ? /*#__PURE__*/ $jbmdS.createElement(MenuPortal, (0, $7i29i.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $jbmdS.createElement($c0ba11bf56eaee76$var$RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $jbmdS.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $jbmdS.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $jbmdS.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $jbmdS.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : "";
                    return /*#__PURE__*/ $jbmdS.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $jbmdS.createElement($c0ba11bf56eaee76$var$LiveRegion$1, (0, $7i29i.default)({}, commonProps, {
                    id: this.getElementId("live-region"),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions,
                    isAppleDevice: this.isAppleDevice
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $jbmdS.createElement(SelectContainer, (0, $7i29i.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $jbmdS.createElement(Control, (0, $7i29i.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $jbmdS.createElement(ValueContainer, (0, $7i29i.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $jbmdS.createElement(IndicatorsContainer, (0, $7i29i.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $fDDh6.H)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $c0ba11bf56eaee76$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $c0ba11bf56eaee76$var$buildFocusableOptionsWithIds($c0ba11bf56eaee76$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $c0ba11bf56eaee76$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $c0ba11bf56eaee76$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $c0ba11bf56eaee76$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $fDDh6.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: "initial-input-focus"
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus") newAriaSelection = null;
                return (0, $lv6ip.default)((0, $lv6ip.default)((0, $lv6ip.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $jbmdS.Component));
$c0ba11bf56eaee76$export$25ce5a424b770e84.defaultProps = $c0ba11bf56eaee76$export$407448d2b89b1813;

});
parcelRegister("34S1T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23dba7efe32f606c$export$2e2bcd8739ae039; });
var $23dba7efe32f606c$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $23dba7efe32f606c$var$isEqual(first, second) {
    if (first === second) return true;
    if ($23dba7efe32f606c$var$safeIsNaN(first) && $23dba7efe32f606c$var$safeIsNaN(second)) return true;
    return false;
}
function $23dba7efe32f606c$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$23dba7efe32f606c$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $23dba7efe32f606c$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $23dba7efe32f606c$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});


parcelRegister("bNHQV", function(module, exports) {

var $bPsra = parcelRequire("bPsra");
function $8976498e7b57c814$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8976498e7b57c814$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8976498e7b57c814$var$ownKeys(Object(t), !0).forEach(function(r) {
            $bPsra(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8976498e7b57c814$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
module.exports = $8976498e7b57c814$var$_objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("bPsra", function(module, exports) {

var $jF6NM = parcelRequire("jF6NM");
function $89ca8428c354c0aa$var$_defineProperty(e, r, t) {
    return (r = $jF6NM(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $89ca8428c354c0aa$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("jF6NM", function(module, exports) {

var $2HGGA = parcelRequire("2HGGA");
var $e5071f5ae0ae163d$var$_typeof = $2HGGA.default;

var $7vfIr = parcelRequire("7vfIr");
function $e5071f5ae0ae163d$var$toPropertyKey(t) {
    var i = $7vfIr(t, "string");
    return "symbol" == $e5071f5ae0ae163d$var$_typeof(i) ? i : i + "";
}
module.exports = $e5071f5ae0ae163d$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2HGGA", function(module, exports) {
function $1f80b5792cf4544c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $1f80b5792cf4544c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $1f80b5792cf4544c$var$_typeof(o);
}
module.exports = $1f80b5792cf4544c$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("7vfIr", function(module, exports) {

var $2HGGA = parcelRequire("2HGGA");
var $57679e7b73ecf1b2$var$_typeof = $2HGGA.default;
function $57679e7b73ecf1b2$var$toPrimitive(t, r) {
    if ("object" != $57679e7b73ecf1b2$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $57679e7b73ecf1b2$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $57679e7b73ecf1b2$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("8ABWE", function(module, exports) {

var $3G2ea = parcelRequire("3G2ea");

var $67ZNF = parcelRequire("67ZNF");

var $4Wp5D = parcelRequire("4Wp5D");

var $inYX5 = parcelRequire("inYX5");
function $640f1e9cbf541038$var$_slicedToArray(r, e) {
    return $3G2ea(r) || $67ZNF(r, e) || $4Wp5D(r, e) || $inYX5();
}
module.exports = $640f1e9cbf541038$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("3G2ea", function(module, exports) {
function $2ad705b33b6d5524$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $2ad705b33b6d5524$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("67ZNF", function(module, exports) {
function $476355b75c3a386e$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $476355b75c3a386e$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("4Wp5D", function(module, exports) {

var $lfDku = parcelRequire("lfDku");
function $39900a8dad3aa88e$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $lfDku(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $lfDku(r, a) : void 0;
    }
}
module.exports = $39900a8dad3aa88e$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("lfDku", function(module, exports) {
function $f78981b7d4af29d3$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $f78981b7d4af29d3$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("inYX5", function(module, exports) {
function $d629a7c11826e203$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $d629a7c11826e203$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("2edOn", function(module, exports) {

var $gCHEX = parcelRequire("gCHEX");
function $19f79a40f8fa4c61$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $gCHEX(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $19f79a40f8fa4c61$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("gCHEX", function(module, exports) {
function $c1a20fdb792f5fa6$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $c1a20fdb792f5fa6$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("keWlZ", function(module, exports) {
function $ebc261461dcc200b$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $ebc261461dcc200b$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("czJCt", function(module, exports) {

var $jF6NM = parcelRequire("jF6NM");
function $927c24027dd8d24e$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $jF6NM(o.key), o);
    }
}
function $927c24027dd8d24e$var$_createClass(e, r, t) {
    return r && $927c24027dd8d24e$var$_defineProperties(e.prototype, r), t && $927c24027dd8d24e$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $927c24027dd8d24e$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("khSB6", function(module, exports) {

var $idteB = parcelRequire("idteB");
function $ec4fbf130869522a$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $idteB(t, e);
}
module.exports = $ec4fbf130869522a$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("idteB", function(module, exports) {
function $d4301e43f54de6b8$var$_setPrototypeOf(t, e) {
    return module.exports = $d4301e43f54de6b8$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $d4301e43f54de6b8$var$_setPrototypeOf(t, e);
}
module.exports = $d4301e43f54de6b8$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("5iFfU", function(module, exports) {

var $aVHto = parcelRequire("aVHto");

var $kSIKA = parcelRequire("kSIKA");

var $fCodG = parcelRequire("fCodG");
function $3dbea2b73d911eee$var$_createSuper(t) {
    var r = $kSIKA();
    return function() {
        var e, o = $aVHto(t);
        if (r) {
            var s = $aVHto(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return $fCodG(this, e);
    };
}
module.exports = $3dbea2b73d911eee$var$_createSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("aVHto", function(module, exports) {
function $7f50f31f872e57a0$var$_getPrototypeOf(t) {
    return module.exports = $7f50f31f872e57a0$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $7f50f31f872e57a0$var$_getPrototypeOf(t);
}
module.exports = $7f50f31f872e57a0$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kSIKA", function(module, exports) {
function $f33b90493671c553$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (module.exports = $f33b90493671c553$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $f33b90493671c553$var$_isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fCodG", function(module, exports) {

var $2HGGA = parcelRequire("2HGGA");
var $b5ed312a6741046f$var$_typeof = $2HGGA.default;

var $eMCnv = parcelRequire("eMCnv");
function $b5ed312a6741046f$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $b5ed312a6741046f$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $eMCnv(t);
}
module.exports = $b5ed312a6741046f$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("eMCnv", function(module, exports) {
function $ac33517f0f68de8e$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $ac33517f0f68de8e$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("b5KuC", function(module, exports) {

var $lp7Mm = parcelRequire("lp7Mm");

var $jP5cR = parcelRequire("jP5cR");

var $4Wp5D = parcelRequire("4Wp5D");

var $gcFFy = parcelRequire("gcFFy");
function $813439daa5af063f$var$_toConsumableArray(r) {
    return $lp7Mm(r) || $jP5cR(r) || $4Wp5D(r) || $gcFFy();
}
module.exports = $813439daa5af063f$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("lp7Mm", function(module, exports) {

var $lfDku = parcelRequire("lfDku");
function $f951f77fb6173abe$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $lfDku(r);
}
module.exports = $f951f77fb6173abe$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("jP5cR", function(module, exports) {
function $e6e6d19f42fbee69$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $e6e6d19f42fbee69$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("gcFFy", function(module, exports) {
function $bcbe16f411cafecc$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $bcbe16f411cafecc$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("jqlgK", function(module, exports) {
function $e240f19eadd4abcf$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
module.exports = $e240f19eadd4abcf$var$_taggedTemplateLiteral, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("5pDMg", function(module, exports) {

$parcel$export(module.exports, "SortableHandle", function () { return $3f0e2481a90db00a$export$680929e2aec3ce89; });
$parcel$export(module.exports, "SortableContainer", function () { return $3f0e2481a90db00a$export$a4b10e5599330dd0; });
$parcel$export(module.exports, "SortableElement", function () { return $3f0e2481a90db00a$export$58d1e4fb0d207bf7; });

var $7i29i = parcelRequire("7i29i");

var $CZyex = parcelRequire("CZyex");

var $3upWL = parcelRequire("3upWL");

var $3GVdq = parcelRequire("3GVdq");

var $jj5jQ = parcelRequire("jj5jQ");

var $ibb6t = parcelRequire("ibb6t");

var $dO7bG = parcelRequire("dO7bG");

var $1N4zm = parcelRequire("1N4zm");

var $br3Qu = parcelRequire("br3Qu");

var $8K2NM = parcelRequire("8K2NM");

var $jbmdS = parcelRequire("jbmdS");

var $jCNM0 = parcelRequire("jCNM0");

var $liDpN = parcelRequire("liDpN");

var $huwkX = parcelRequire("huwkX");

var $2MXkj = parcelRequire("2MXkj");
var $3f0e2481a90db00a$var$Manager = function() {
    function Manager() {
        (0, $3GVdq.default)(this, Manager);
        (0, $8K2NM.default)(this, "refs", {});
    }
    (0, $jj5jQ.default)(Manager, [
        {
            key: "add",
            value: function add(collection, ref) {
                if (!this.refs[collection]) this.refs[collection] = [];
                this.refs[collection].push(ref);
            }
        },
        {
            key: "remove",
            value: function remove(collection, ref) {
                var index = this.getIndex(collection, ref);
                if (index !== -1) this.refs[collection].splice(index, 1);
            }
        },
        {
            key: "isActive",
            value: function isActive() {
                return this.active;
            }
        },
        {
            key: "getActive",
            value: function getActive() {
                var _this = this;
                return this.refs[this.active.collection].find(function(_ref) {
                    var node = _ref.node;
                    return node.sortableInfo.index == _this.active.index;
                });
            }
        },
        {
            key: "getIndex",
            value: function getIndex(collection, ref) {
                return this.refs[collection].indexOf(ref);
            }
        },
        {
            key: "getOrderedRefs",
            value: function getOrderedRefs() {
                var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.active.collection;
                return this.refs[collection].sort($3f0e2481a90db00a$var$sortByIndex);
            }
        }
    ]);
    return Manager;
}();
function $3f0e2481a90db00a$var$sortByIndex(_ref2, _ref3) {
    var index1 = _ref2.node.sortableInfo.index;
    var index2 = _ref3.node.sortableInfo.index;
    return index1 - index2;
}
function $3f0e2481a90db00a$export$5d49d615ad5ea2b0(array, from, to) {
    array = array.slice();
    array.splice(to < 0 ? array.length + to : to, 0, array.splice(from, 1)[0]);
    return array;
}
function $3f0e2481a90db00a$var$omit(obj, keysToOmit) {
    return Object.keys(obj).reduce(function(acc, key) {
        if (keysToOmit.indexOf(key) === -1) acc[key] = obj[key];
        return acc;
    }, {});
}
var $3f0e2481a90db00a$var$events = {
    end: [
        "touchend",
        "touchcancel",
        "mouseup"
    ],
    move: [
        "touchmove",
        "mousemove"
    ],
    start: [
        "touchstart",
        "mousedown"
    ]
};
var $3f0e2481a90db00a$var$vendorPrefix = function() {
    if (typeof window === "undefined" || typeof document === "undefined") return "";
    var styles = window.getComputedStyle(document.documentElement, "") || [
        "-moz-hidden-iframe"
    ];
    var pre = (Array.prototype.slice.call(styles).join("").match(/-(moz|webkit|ms)-/) || styles.OLink === "" && [
        "",
        "o"
    ])[1];
    switch(pre){
        case "ms":
            return "ms";
        default:
            return pre && pre.length ? pre[0].toUpperCase() + pre.substr(1) : "";
    }
}();
function $3f0e2481a90db00a$var$setInlineStyles(node, styles) {
    Object.keys(styles).forEach(function(key) {
        node.style[key] = styles[key];
    });
}
function $3f0e2481a90db00a$var$setTranslate3d(node, translate) {
    node.style["".concat($3f0e2481a90db00a$var$vendorPrefix, "Transform")] = translate == null ? "" : "translate3d(".concat(translate.x, "px,").concat(translate.y, "px,0)");
}
function $3f0e2481a90db00a$var$setTransitionDuration(node, duration) {
    node.style["".concat($3f0e2481a90db00a$var$vendorPrefix, "TransitionDuration")] = duration == null ? "" : "".concat(duration, "ms");
}
function $3f0e2481a90db00a$var$closest(el, fn) {
    while(el){
        if (fn(el)) return el;
        el = el.parentNode;
    }
    return null;
}
function $3f0e2481a90db00a$var$limit(min, max, value1) {
    return Math.max(min, Math.min(value1, max));
}
function $3f0e2481a90db00a$var$getPixelValue(stringValue) {
    if (stringValue.substr(-2) === "px") return parseFloat(stringValue);
    return 0;
}
function $3f0e2481a90db00a$var$getElementMargin(element) {
    var style = window.getComputedStyle(element);
    return {
        bottom: $3f0e2481a90db00a$var$getPixelValue(style.marginBottom),
        left: $3f0e2481a90db00a$var$getPixelValue(style.marginLeft),
        right: $3f0e2481a90db00a$var$getPixelValue(style.marginRight),
        top: $3f0e2481a90db00a$var$getPixelValue(style.marginTop)
    };
}
function $3f0e2481a90db00a$var$provideDisplayName(prefix, Component$$1) {
    var componentName = Component$$1.displayName || Component$$1.name;
    return componentName ? "".concat(prefix, "(").concat(componentName, ")") : prefix;
}
function $3f0e2481a90db00a$var$getScrollAdjustedBoundingClientRect(node, scrollDelta) {
    var boundingClientRect = node.getBoundingClientRect();
    return {
        top: boundingClientRect.top + scrollDelta.top,
        left: boundingClientRect.left + scrollDelta.left
    };
}
function $3f0e2481a90db00a$var$getPosition(event) {
    if (event.touches && event.touches.length) return {
        x: event.touches[0].pageX,
        y: event.touches[0].pageY
    };
    else if (event.changedTouches && event.changedTouches.length) return {
        x: event.changedTouches[0].pageX,
        y: event.changedTouches[0].pageY
    };
    else return {
        x: event.pageX,
        y: event.pageY
    };
}
function $3f0e2481a90db00a$var$isTouchEvent(event) {
    return event.touches && event.touches.length || event.changedTouches && event.changedTouches.length;
}
function $3f0e2481a90db00a$var$getEdgeOffset(node, parent) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        left: 0,
        top: 0
    };
    if (!node) return undefined;
    var nodeOffset = {
        left: offset.left + node.offsetLeft,
        top: offset.top + node.offsetTop
    };
    if (node.parentNode === parent) return nodeOffset;
    return $3f0e2481a90db00a$var$getEdgeOffset(node.parentNode, parent, nodeOffset);
}
function $3f0e2481a90db00a$var$getTargetIndex(newIndex, prevIndex, oldIndex) {
    if (newIndex < oldIndex && newIndex > prevIndex) return newIndex - 1;
    else if (newIndex > oldIndex && newIndex < prevIndex) return newIndex + 1;
    else return newIndex;
}
function $3f0e2481a90db00a$var$getLockPixelOffset(_ref) {
    var lockOffset = _ref.lockOffset, width = _ref.width, height = _ref.height;
    var offsetX = lockOffset;
    var offsetY = lockOffset;
    var unit = "px";
    if (typeof lockOffset === "string") {
        var match = /^[+-]?\d*(?:\.\d*)?(px|%)$/.exec(lockOffset);
        (0, (/*@__PURE__*/$parcel$interopDefault($liDpN)))(match !== null, 'lockOffset value should be a number or a string of a number followed by "px" or "%". Given %s', lockOffset);
        offsetX = parseFloat(lockOffset);
        offsetY = parseFloat(lockOffset);
        unit = match[1];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($liDpN)))(isFinite(offsetX) && isFinite(offsetY), "lockOffset value should be a finite. Given %s", lockOffset);
    if (unit === "%") {
        offsetX = offsetX * width / 100;
        offsetY = offsetY * height / 100;
    }
    return {
        x: offsetX,
        y: offsetY
    };
}
function $3f0e2481a90db00a$var$getLockPixelOffsets(_ref2) {
    var height = _ref2.height, width = _ref2.width, lockOffset = _ref2.lockOffset;
    var offsets = Array.isArray(lockOffset) ? lockOffset : [
        lockOffset,
        lockOffset
    ];
    (0, (/*@__PURE__*/$parcel$interopDefault($liDpN)))(offsets.length === 2, "lockOffset prop of SortableContainer should be a single value or an array of exactly two values. Given %s", lockOffset);
    var _offsets = (0, $CZyex.default)(offsets, 2), minLockOffset = _offsets[0], maxLockOffset = _offsets[1];
    return [
        $3f0e2481a90db00a$var$getLockPixelOffset({
            height: height,
            lockOffset: minLockOffset,
            width: width
        }),
        $3f0e2481a90db00a$var$getLockPixelOffset({
            height: height,
            lockOffset: maxLockOffset,
            width: width
        })
    ];
}
function $3f0e2481a90db00a$var$isScrollable(el) {
    var computedStyle = window.getComputedStyle(el);
    var overflowRegex = /(auto|scroll)/;
    var properties = [
        "overflow",
        "overflowX",
        "overflowY"
    ];
    return properties.find(function(property) {
        return overflowRegex.test(computedStyle[property]);
    });
}
function $3f0e2481a90db00a$var$getScrollingParent(el) {
    if (!(el instanceof HTMLElement)) return null;
    else if ($3f0e2481a90db00a$var$isScrollable(el)) return el;
    else return $3f0e2481a90db00a$var$getScrollingParent(el.parentNode);
}
function $3f0e2481a90db00a$var$getContainerGridGap(element) {
    var style = window.getComputedStyle(element);
    if (style.display === "grid") return {
        x: $3f0e2481a90db00a$var$getPixelValue(style.gridColumnGap),
        y: $3f0e2481a90db00a$var$getPixelValue(style.gridRowGap)
    };
    return {
        x: 0,
        y: 0
    };
}
var $3f0e2481a90db00a$var$KEYCODE = {
    TAB: 9,
    ESC: 27,
    SPACE: 32,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40
};
var $3f0e2481a90db00a$var$NodeType = {
    Anchor: "A",
    Button: "BUTTON",
    Canvas: "CANVAS",
    Input: "INPUT",
    Option: "OPTION",
    Textarea: "TEXTAREA",
    Select: "SELECT"
};
function $3f0e2481a90db00a$var$cloneNode(node) {
    var selector = "input, textarea, select, canvas, [contenteditable]";
    var fields = node.querySelectorAll(selector);
    var clonedNode = node.cloneNode(true);
    var clonedFields = (0, $huwkX.default)(clonedNode.querySelectorAll(selector));
    clonedFields.forEach(function(field, i) {
        if (field.type !== "file") field.value = fields[i].value;
        if (field.type === "radio" && field.name) field.name = "__sortableClone__".concat(field.name);
        if (field.tagName === $3f0e2481a90db00a$var$NodeType.Canvas && fields[i].width > 0 && fields[i].height > 0) {
            var destCtx = field.getContext("2d");
            destCtx.drawImage(fields[i], 0, 0);
        }
    });
    return clonedNode;
}
function $3f0e2481a90db00a$export$680929e2aec3ce89(WrappedComponent) {
    var _class, _temp;
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        withRef: false
    };
    return _temp = _class = function(_React$Component) {
        (0, $1N4zm.default)(WithSortableHandle, _React$Component);
        function WithSortableHandle() {
            var _getPrototypeOf2;
            var _this;
            (0, $3GVdq.default)(this, WithSortableHandle);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = (0, $ibb6t.default)(this, (_getPrototypeOf2 = (0, $dO7bG.default)(WithSortableHandle)).call.apply(_getPrototypeOf2, [
                this
            ].concat(args)));
            (0, $8K2NM.default)((0, $br3Qu.default)((0, $br3Qu.default)(_this)), "wrappedInstance", (0, $jbmdS.createRef)());
            return _this;
        }
        (0, $jj5jQ.default)(WithSortableHandle, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var node = (0, $jCNM0.findDOMNode)(this);
                    node.sortableHandle = true;
                }
            },
            {
                key: "getWrappedInstance",
                value: function getWrappedInstance() {
                    (0, (/*@__PURE__*/$parcel$interopDefault($liDpN)))(config.withRef, "To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableHandle() call");
                    return this.wrappedInstance.current;
                }
            },
            {
                key: "render",
                value: function render() {
                    var ref = config.withRef ? this.wrappedInstance : null;
                    return (0, $jbmdS.createElement)(WrappedComponent, (0, $7i29i.default)({
                        ref: ref
                    }, this.props));
                }
            }
        ]);
        return WithSortableHandle;
    }((0, $jbmdS.Component)), (0, $8K2NM.default)(_class, "displayName", $3f0e2481a90db00a$var$provideDisplayName("sortableHandle", WrappedComponent)), _temp;
}
function $3f0e2481a90db00a$var$isSortableHandle(node) {
    return node.sortableHandle != null;
}
var $3f0e2481a90db00a$var$AutoScroller = function() {
    function AutoScroller(container, onScrollCallback) {
        (0, $3GVdq.default)(this, AutoScroller);
        this.container = container;
        this.onScrollCallback = onScrollCallback;
    }
    (0, $jj5jQ.default)(AutoScroller, [
        {
            key: "clear",
            value: function clear() {
                if (this.interval == null) return;
                clearInterval(this.interval);
                this.interval = null;
            }
        },
        {
            key: "update",
            value: function update(_ref) {
                var _this = this;
                var translate = _ref.translate, minTranslate = _ref.minTranslate, maxTranslate = _ref.maxTranslate, width = _ref.width, height = _ref.height;
                var direction = {
                    x: 0,
                    y: 0
                };
                var speed = {
                    x: 1,
                    y: 1
                };
                var acceleration = {
                    x: 10,
                    y: 10
                };
                var _this$container = this.container, scrollTop = _this$container.scrollTop, scrollLeft = _this$container.scrollLeft, scrollHeight = _this$container.scrollHeight, scrollWidth = _this$container.scrollWidth, clientHeight = _this$container.clientHeight, clientWidth = _this$container.clientWidth;
                var isTop = scrollTop === 0;
                var isBottom = scrollHeight - scrollTop - clientHeight === 0;
                var isLeft = scrollLeft === 0;
                var isRight = scrollWidth - scrollLeft - clientWidth === 0;
                if (translate.y >= maxTranslate.y - height / 2 && !isBottom) {
                    direction.y = 1;
                    speed.y = acceleration.y * Math.abs((maxTranslate.y - height / 2 - translate.y) / height);
                } else if (translate.x >= maxTranslate.x - width / 2 && !isRight) {
                    direction.x = 1;
                    speed.x = acceleration.x * Math.abs((maxTranslate.x - width / 2 - translate.x) / width);
                } else if (translate.y <= minTranslate.y + height / 2 && !isTop) {
                    direction.y = -1;
                    speed.y = acceleration.y * Math.abs((translate.y - height / 2 - minTranslate.y) / height);
                } else if (translate.x <= minTranslate.x + width / 2 && !isLeft) {
                    direction.x = -1;
                    speed.x = acceleration.x * Math.abs((translate.x - width / 2 - minTranslate.x) / width);
                }
                if (this.interval) {
                    this.clear();
                    this.isAutoScrolling = false;
                }
                if (direction.x !== 0 || direction.y !== 0) this.interval = setInterval(function() {
                    _this.isAutoScrolling = true;
                    var offset = {
                        left: speed.x * direction.x,
                        top: speed.y * direction.y
                    };
                    _this.container.scrollTop += offset.top;
                    _this.container.scrollLeft += offset.left;
                    _this.onScrollCallback(offset);
                }, 5);
            }
        }
    ]);
    return AutoScroller;
}();
function $3f0e2481a90db00a$var$defaultGetHelperDimensions(_ref) {
    var node = _ref.node;
    return {
        height: node.offsetHeight,
        width: node.offsetWidth
    };
}
function $3f0e2481a90db00a$var$defaultShouldCancelStart(event) {
    var interactiveElements = [
        $3f0e2481a90db00a$var$NodeType.Input,
        $3f0e2481a90db00a$var$NodeType.Textarea,
        $3f0e2481a90db00a$var$NodeType.Select,
        $3f0e2481a90db00a$var$NodeType.Option,
        $3f0e2481a90db00a$var$NodeType.Button
    ];
    if (interactiveElements.indexOf(event.target.tagName) !== -1) return true;
    if ($3f0e2481a90db00a$var$closest(event.target, function(el) {
        return el.contentEditable === "true";
    })) return true;
    return false;
}
var $3f0e2481a90db00a$var$propTypes = {
    axis: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).oneOf([
        "x",
        "y",
        "xy"
    ]),
    contentWindow: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).any,
    disableAutoscroll: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).bool,
    distance: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).number,
    getContainer: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).func,
    getHelperDimensions: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).func,
    helperClass: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).string,
    helperContainer: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).func,
        typeof HTMLElement === "undefined" ? (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).any : (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).instanceOf(HTMLElement)
    ]),
    hideSortableGhost: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).bool,
    keyboardSortingTransitionDuration: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).number,
    lockAxis: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).string,
    lockOffset: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).string
        ]))
    ]),
    lockToContainerEdges: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).bool,
    onSortEnd: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).func,
    onSortMove: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).func,
    onSortOver: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).func,
    onSortStart: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).func,
    pressDelay: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).number,
    pressThreshold: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).number,
    keyCodes: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).shape({
        lift: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).number),
        drop: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).number),
        cancel: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).number),
        up: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).number),
        down: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).number)
    }),
    shouldCancelStart: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).func,
    transitionDuration: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).number,
    updateBeforeSortStart: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).func,
    useDragHandle: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).bool,
    useWindowAsScrollContainer: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).bool
};
var $3f0e2481a90db00a$var$defaultKeyCodes = {
    lift: [
        $3f0e2481a90db00a$var$KEYCODE.SPACE
    ],
    drop: [
        $3f0e2481a90db00a$var$KEYCODE.SPACE
    ],
    cancel: [
        $3f0e2481a90db00a$var$KEYCODE.ESC
    ],
    up: [
        $3f0e2481a90db00a$var$KEYCODE.UP,
        $3f0e2481a90db00a$var$KEYCODE.LEFT
    ],
    down: [
        $3f0e2481a90db00a$var$KEYCODE.DOWN,
        $3f0e2481a90db00a$var$KEYCODE.RIGHT
    ]
};
var $3f0e2481a90db00a$var$defaultProps = {
    axis: "y",
    disableAutoscroll: false,
    distance: 0,
    getHelperDimensions: $3f0e2481a90db00a$var$defaultGetHelperDimensions,
    hideSortableGhost: true,
    lockOffset: "50%",
    lockToContainerEdges: false,
    pressDelay: 0,
    pressThreshold: 5,
    keyCodes: $3f0e2481a90db00a$var$defaultKeyCodes,
    shouldCancelStart: $3f0e2481a90db00a$var$defaultShouldCancelStart,
    transitionDuration: 300,
    useWindowAsScrollContainer: false
};
var $3f0e2481a90db00a$var$omittedProps = Object.keys($3f0e2481a90db00a$var$propTypes);
function $3f0e2481a90db00a$var$validateProps(props) {
    (0, (/*@__PURE__*/$parcel$interopDefault($liDpN)))(!(props.distance && props.pressDelay), "Attempted to set both `pressDelay` and `distance` on SortableContainer, you may only use one or the other, not both at the same time.");
}
function $3f0e2481a90db00a$var$_finallyRethrows(body, finalizer) {
    try {
        var result = body();
    } catch (e) {
        return finalizer(true, e);
    }
    if (result && result.then) return result.then(finalizer.bind(null, false), finalizer.bind(null, true));
    return finalizer(false, value);
}
var $3f0e2481a90db00a$var$SortableContext = (0, $jbmdS.createContext)({
    manager: {}
});
function $3f0e2481a90db00a$export$a4b10e5599330dd0(WrappedComponent) {
    var _class, _temp;
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        withRef: false
    };
    return _temp = _class = function(_React$Component) {
        (0, $1N4zm.default)(WithSortableContainer, _React$Component);
        function WithSortableContainer(props) {
            var _this;
            (0, $3GVdq.default)(this, WithSortableContainer);
            _this = (0, $ibb6t.default)(this, (0, $dO7bG.default)(WithSortableContainer).call(this, props));
            (0, $8K2NM.default)((0, $br3Qu.default)((0, $br3Qu.default)(_this)), "state", {});
            (0, $8K2NM.default)((0, $br3Qu.default)((0, $br3Qu.default)(_this)), "handleStart", function(event) {
                var _this$props = _this.props, distance = _this$props.distance, shouldCancelStart = _this$props.shouldCancelStart;
                if (event.button === 2 || shouldCancelStart(event)) return;
                _this.touched = true;
                _this.position = $3f0e2481a90db00a$var$getPosition(event);
                var node = $3f0e2481a90db00a$var$closest(event.target, function(el) {
                    return el.sortableInfo != null;
                });
                if (node && node.sortableInfo && _this.nodeIsChild(node) && !_this.state.sorting) {
                    var useDragHandle = _this.props.useDragHandle;
                    var _node$sortableInfo = node.sortableInfo, index = _node$sortableInfo.index, collection = _node$sortableInfo.collection, disabled = _node$sortableInfo.disabled;
                    if (disabled) return;
                    if (useDragHandle && !$3f0e2481a90db00a$var$closest(event.target, $3f0e2481a90db00a$var$isSortableHandle)) return;
                    _this.manager.active = {
                        collection: collection,
                        index: index
                    };
                    if (!$3f0e2481a90db00a$var$isTouchEvent(event) && event.target.tagName === $3f0e2481a90db00a$var$NodeType.Anchor) event.preventDefault();
                    if (!distance) {
                        if (_this.props.pressDelay === 0) _this.handlePress(event);
                        else _this.pressTimer = setTimeout(function() {
                            return _this.handlePress(event);
                        }, _this.props.pressDelay);
                    }
                }
            });
            (0, $8K2NM.default)((0, $br3Qu.default)((0, $br3Qu.default)(_this)), "nodeIsChild", function(node) {
                return node.sortableInfo.manager === _this.manager;
            });
            (0, $8K2NM.default)((0, $br3Qu.default)((0, $br3Qu.default)(_this)), "handleMove", function(event) {
                var _this$props2 = _this.props, distance = _this$props2.distance, pressThreshold = _this$props2.pressThreshold;
                if (!_this.state.sorting && _this.touched && !_this._awaitingUpdateBeforeSortStart) {
                    var position = $3f0e2481a90db00a$var$getPosition(event);
                    var delta = {
                        x: _this.position.x - position.x,
                        y: _this.position.y - position.y
                    };
                    var combinedDelta = Math.abs(delta.x) + Math.abs(delta.y);
                    _this.delta = delta;
                    if (!distance && (!pressThreshold || combinedDelta >= pressThreshold)) {
                        clearTimeout(_this.cancelTimer);
                        _this.cancelTimer = setTimeout(_this.cancel, 0);
                    } else if (distance && combinedDelta >= distance && _this.manager.isActive()) _this.handlePress(event);
                }
            });
            (0, $8K2NM.default)((0, $br3Qu.default)((0, $br3Qu.default)(_this)), "handleEnd", function() {
                _this.touched = false;
                _this.cancel();
            });
            (0, $8K2NM.default)((0, $br3Qu.default)((0, $br3Qu.default)(_this)), "cancel", function() {
                var distance = _this.props.distance;
                var sorting = _this.state.sorting;
                if (!sorting) {
                    if (!distance) clearTimeout(_this.pressTimer);
                    _this.manager.active = null;
                }
            });
            (0, $8K2NM.default)((0, $br3Qu.default)((0, $br3Qu.default)(_this)), "handlePress", function(event) {
                try {
                    var active = _this.manager.getActive();
                    var _temp6 = function() {
                        if (active) {
                            var _temp7 = function _temp7() {
                                var index = _node.sortableInfo.index;
                                var margin = $3f0e2481a90db00a$var$getElementMargin(_node);
                                var gridGap = $3f0e2481a90db00a$var$getContainerGridGap(_this.container);
                                var containerBoundingRect = _this.scrollContainer.getBoundingClientRect();
                                var dimensions = _getHelperDimensions({
                                    index: index,
                                    node: _node,
                                    collection: _collection
                                });
                                _this.node = _node;
                                _this.margin = margin;
                                _this.gridGap = gridGap;
                                _this.width = dimensions.width;
                                _this.height = dimensions.height;
                                _this.marginOffset = {
                                    x: _this.margin.left + _this.margin.right + _this.gridGap.x,
                                    y: Math.max(_this.margin.top, _this.margin.bottom, _this.gridGap.y)
                                };
                                _this.boundingClientRect = _node.getBoundingClientRect();
                                _this.containerBoundingRect = containerBoundingRect;
                                _this.index = index;
                                _this.newIndex = index;
                                _this.axis = {
                                    x: _axis.indexOf("x") >= 0,
                                    y: _axis.indexOf("y") >= 0
                                };
                                _this.offsetEdge = $3f0e2481a90db00a$var$getEdgeOffset(_node, _this.container);
                                if (_isKeySorting) _this.initialOffset = $3f0e2481a90db00a$var$getPosition((0, $3upWL.default)({}, event, {
                                    pageX: _this.boundingClientRect.left,
                                    pageY: _this.boundingClientRect.top
                                }));
                                else _this.initialOffset = $3f0e2481a90db00a$var$getPosition(event);
                                _this.initialScroll = {
                                    left: _this.scrollContainer.scrollLeft,
                                    top: _this.scrollContainer.scrollTop
                                };
                                _this.initialWindowScroll = {
                                    left: window.pageXOffset,
                                    top: window.pageYOffset
                                };
                                _this.helper = _this.helperContainer.appendChild($3f0e2481a90db00a$var$cloneNode(_node));
                                $3f0e2481a90db00a$var$setInlineStyles(_this.helper, {
                                    boxSizing: "border-box",
                                    height: "".concat(_this.height, "px"),
                                    left: "".concat(_this.boundingClientRect.left - margin.left, "px"),
                                    pointerEvents: "none",
                                    position: "fixed",
                                    top: "".concat(_this.boundingClientRect.top - margin.top, "px"),
                                    width: "".concat(_this.width, "px")
                                });
                                if (_isKeySorting) _this.helper.focus();
                                if (_hideSortableGhost) {
                                    _this.sortableGhost = _node;
                                    $3f0e2481a90db00a$var$setInlineStyles(_node, {
                                        opacity: 0,
                                        visibility: "hidden"
                                    });
                                }
                                _this.minTranslate = {};
                                _this.maxTranslate = {};
                                if (_isKeySorting) {
                                    var _ref = _useWindowAsScrollContainer ? {
                                        top: 0,
                                        left: 0,
                                        width: _this.contentWindow.innerWidth,
                                        height: _this.contentWindow.innerHeight
                                    } : _this.containerBoundingRect, containerTop = _ref.top, containerLeft = _ref.left, containerWidth = _ref.width, containerHeight = _ref.height;
                                    var containerBottom = containerTop + containerHeight;
                                    var containerRight = containerLeft + containerWidth;
                                    if (_this.axis.x) {
                                        _this.minTranslate.x = containerLeft - _this.boundingClientRect.left;
                                        _this.maxTranslate.x = containerRight - (_this.boundingClientRect.left + _this.width);
                                    }
                                    if (_this.axis.y) {
                                        _this.minTranslate.y = containerTop - _this.boundingClientRect.top;
                                        _this.maxTranslate.y = containerBottom - (_this.boundingClientRect.top + _this.height);
                                    }
                                } else {
                                    if (_this.axis.x) {
                                        _this.minTranslate.x = (_useWindowAsScrollContainer ? 0 : containerBoundingRect.left) - _this.boundingClientRect.left - _this.width / 2;
                                        _this.maxTranslate.x = (_useWindowAsScrollContainer ? _this.contentWindow.innerWidth : containerBoundingRect.left + containerBoundingRect.width) - _this.boundingClientRect.left - _this.width / 2;
                                    }
                                    if (_this.axis.y) {
                                        _this.minTranslate.y = (_useWindowAsScrollContainer ? 0 : containerBoundingRect.top) - _this.boundingClientRect.top - _this.height / 2;
                                        _this.maxTranslate.y = (_useWindowAsScrollContainer ? _this.contentWindow.innerHeight : containerBoundingRect.top + containerBoundingRect.height) - _this.boundingClientRect.top - _this.height / 2;
                                    }
                                }
                                if (_helperClass) _helperClass.split(" ").forEach(function(className) {
                                    return _this.helper.classList.add(className);
                                });
                                _this.listenerNode = event.touches ? event.target : _this.contentWindow;
                                if (_isKeySorting) {
                                    _this.listenerNode.addEventListener("wheel", _this.handleKeyEnd, true);
                                    _this.listenerNode.addEventListener("mousedown", _this.handleKeyEnd, true);
                                    _this.listenerNode.addEventListener("keydown", _this.handleKeyDown);
                                } else {
                                    $3f0e2481a90db00a$var$events.move.forEach(function(eventName) {
                                        return _this.listenerNode.addEventListener(eventName, _this.handleSortMove, false);
                                    });
                                    $3f0e2481a90db00a$var$events.end.forEach(function(eventName) {
                                        return _this.listenerNode.addEventListener(eventName, _this.handleSortEnd, false);
                                    });
                                }
                                _this.setState({
                                    sorting: true,
                                    sortingIndex: index
                                });
                                if (_onSortStart) _onSortStart({
                                    node: _node,
                                    index: index,
                                    collection: _collection,
                                    isKeySorting: _isKeySorting,
                                    nodes: _this.manager.getOrderedRefs(),
                                    helper: _this.helper
                                }, event);
                                if (_isKeySorting) _this.keyMove(0);
                            };
                            var _this$props3 = _this.props, _axis = _this$props3.axis, _getHelperDimensions = _this$props3.getHelperDimensions, _helperClass = _this$props3.helperClass, _hideSortableGhost = _this$props3.hideSortableGhost, updateBeforeSortStart = _this$props3.updateBeforeSortStart, _onSortStart = _this$props3.onSortStart, _useWindowAsScrollContainer = _this$props3.useWindowAsScrollContainer;
                            var _node = active.node, _collection = active.collection;
                            var _isKeySorting = _this.manager.isKeySorting;
                            var _temp8 = function() {
                                if (typeof updateBeforeSortStart === "function") {
                                    _this._awaitingUpdateBeforeSortStart = true;
                                    var _temp9 = $3f0e2481a90db00a$var$_finallyRethrows(function() {
                                        var index = _node.sortableInfo.index;
                                        return Promise.resolve(updateBeforeSortStart({
                                            collection: _collection,
                                            index: index,
                                            node: _node,
                                            isKeySorting: _isKeySorting
                                        }, event)).then(function() {});
                                    }, function(_wasThrown, _result) {
                                        _this._awaitingUpdateBeforeSortStart = false;
                                        if (_wasThrown) throw _result;
                                        return _result;
                                    });
                                    if (_temp9 && _temp9.then) return _temp9.then(function() {});
                                }
                            }();
                            return _temp8 && _temp8.then ? _temp8.then(_temp7) : _temp7(_temp8);
                        }
                    }();
                    return Promise.resolve(_temp6 && _temp6.then ? _temp6.then(function() {}) : void 0);
                } catch (e) {
                    return Promise.reject(e);
                }
            });
            (0, $8K2NM.default)((0, $br3Qu.default)((0, $br3Qu.default)(_this)), "handleSortMove", function(event) {
                var onSortMove = _this.props.onSortMove;
                if (typeof event.preventDefault === "function" && event.cancelable) event.preventDefault();
                _this.updateHelperPosition(event);
                _this.animateNodes();
                _this.autoscroll();
                if (onSortMove) onSortMove(event);
            });
            (0, $8K2NM.default)((0, $br3Qu.default)((0, $br3Qu.default)(_this)), "handleSortEnd", function(event) {
                var _this$props4 = _this.props, hideSortableGhost = _this$props4.hideSortableGhost, onSortEnd = _this$props4.onSortEnd;
                var _this$manager = _this.manager, collection = _this$manager.active.collection, isKeySorting = _this$manager.isKeySorting;
                var nodes = _this.manager.getOrderedRefs();
                if (_this.listenerNode) {
                    if (isKeySorting) {
                        _this.listenerNode.removeEventListener("wheel", _this.handleKeyEnd, true);
                        _this.listenerNode.removeEventListener("mousedown", _this.handleKeyEnd, true);
                        _this.listenerNode.removeEventListener("keydown", _this.handleKeyDown);
                    } else {
                        $3f0e2481a90db00a$var$events.move.forEach(function(eventName) {
                            return _this.listenerNode.removeEventListener(eventName, _this.handleSortMove);
                        });
                        $3f0e2481a90db00a$var$events.end.forEach(function(eventName) {
                            return _this.listenerNode.removeEventListener(eventName, _this.handleSortEnd);
                        });
                    }
                }
                _this.helper.parentNode.removeChild(_this.helper);
                if (hideSortableGhost && _this.sortableGhost) $3f0e2481a90db00a$var$setInlineStyles(_this.sortableGhost, {
                    opacity: "",
                    visibility: ""
                });
                for(var i = 0, len = nodes.length; i < len; i++){
                    var _node2 = nodes[i];
                    var el = _node2.node;
                    _node2.edgeOffset = null;
                    _node2.boundingClientRect = null;
                    $3f0e2481a90db00a$var$setTranslate3d(el, null);
                    $3f0e2481a90db00a$var$setTransitionDuration(el, null);
                    _node2.translate = null;
                }
                _this.autoScroller.clear();
                _this.manager.active = null;
                _this.manager.isKeySorting = false;
                _this.setState({
                    sorting: false,
                    sortingIndex: null
                });
                if (typeof onSortEnd === "function") onSortEnd({
                    collection: collection,
                    newIndex: _this.newIndex,
                    oldIndex: _this.index,
                    isKeySorting: isKeySorting,
                    nodes: nodes
                }, event);
                _this.touched = false;
            });
            (0, $8K2NM.default)((0, $br3Qu.default)((0, $br3Qu.default)(_this)), "autoscroll", function() {
                var disableAutoscroll = _this.props.disableAutoscroll;
                var isKeySorting = _this.manager.isKeySorting;
                if (disableAutoscroll) {
                    _this.autoScroller.clear();
                    return;
                }
                if (isKeySorting) {
                    var translate = (0, $3upWL.default)({}, _this.translate);
                    var scrollX = 0;
                    var scrollY = 0;
                    if (_this.axis.x) {
                        translate.x = Math.min(_this.maxTranslate.x, Math.max(_this.minTranslate.x, _this.translate.x));
                        scrollX = _this.translate.x - translate.x;
                    }
                    if (_this.axis.y) {
                        translate.y = Math.min(_this.maxTranslate.y, Math.max(_this.minTranslate.y, _this.translate.y));
                        scrollY = _this.translate.y - translate.y;
                    }
                    _this.translate = translate;
                    $3f0e2481a90db00a$var$setTranslate3d(_this.helper, _this.translate);
                    _this.scrollContainer.scrollLeft += scrollX;
                    _this.scrollContainer.scrollTop += scrollY;
                    return;
                }
                _this.autoScroller.update({
                    height: _this.height,
                    maxTranslate: _this.maxTranslate,
                    minTranslate: _this.minTranslate,
                    translate: _this.translate,
                    width: _this.width
                });
            });
            (0, $8K2NM.default)((0, $br3Qu.default)((0, $br3Qu.default)(_this)), "onAutoScroll", function(offset) {
                _this.translate.x += offset.left;
                _this.translate.y += offset.top;
                _this.animateNodes();
            });
            (0, $8K2NM.default)((0, $br3Qu.default)((0, $br3Qu.default)(_this)), "handleKeyDown", function(event) {
                var keyCode = event.keyCode;
                var _this$props5 = _this.props, shouldCancelStart = _this$props5.shouldCancelStart, _this$props5$keyCodes = _this$props5.keyCodes, customKeyCodes = _this$props5$keyCodes === void 0 ? {} : _this$props5$keyCodes;
                var keyCodes = (0, $3upWL.default)({}, $3f0e2481a90db00a$var$defaultKeyCodes, customKeyCodes);
                if (_this.manager.active && !_this.manager.isKeySorting || !_this.manager.active && (!keyCodes.lift.includes(keyCode) || shouldCancelStart(event) || !_this.isValidSortingTarget(event))) return;
                event.stopPropagation();
                event.preventDefault();
                if (keyCodes.lift.includes(keyCode) && !_this.manager.active) _this.keyLift(event);
                else if (keyCodes.drop.includes(keyCode) && _this.manager.active) _this.keyDrop(event);
                else if (keyCodes.cancel.includes(keyCode)) {
                    _this.newIndex = _this.manager.active.index;
                    _this.keyDrop(event);
                } else if (keyCodes.up.includes(keyCode)) _this.keyMove(-1);
                else if (keyCodes.down.includes(keyCode)) _this.keyMove(1);
            });
            (0, $8K2NM.default)((0, $br3Qu.default)((0, $br3Qu.default)(_this)), "keyLift", function(event) {
                var target = event.target;
                var node = $3f0e2481a90db00a$var$closest(target, function(el) {
                    return el.sortableInfo != null;
                });
                var _node$sortableInfo2 = node.sortableInfo, index = _node$sortableInfo2.index, collection = _node$sortableInfo2.collection;
                _this.initialFocusedNode = target;
                _this.manager.isKeySorting = true;
                _this.manager.active = {
                    index: index,
                    collection: collection
                };
                _this.handlePress(event);
            });
            (0, $8K2NM.default)((0, $br3Qu.default)((0, $br3Qu.default)(_this)), "keyMove", function(shift) {
                var nodes = _this.manager.getOrderedRefs();
                var lastIndex = nodes[nodes.length - 1].node.sortableInfo.index;
                var newIndex = _this.newIndex + shift;
                var prevIndex = _this.newIndex;
                if (newIndex < 0 || newIndex > lastIndex) return;
                _this.prevIndex = prevIndex;
                _this.newIndex = newIndex;
                var targetIndex = $3f0e2481a90db00a$var$getTargetIndex(_this.newIndex, _this.prevIndex, _this.index);
                var target = nodes.find(function(_ref2) {
                    var node = _ref2.node;
                    return node.sortableInfo.index === targetIndex;
                });
                var targetNode = target.node;
                var scrollDelta = _this.containerScrollDelta;
                var targetBoundingClientRect = target.boundingClientRect || $3f0e2481a90db00a$var$getScrollAdjustedBoundingClientRect(targetNode, scrollDelta);
                var targetTranslate = target.translate || {
                    x: 0,
                    y: 0
                };
                var targetPosition = {
                    top: targetBoundingClientRect.top + targetTranslate.y - scrollDelta.top,
                    left: targetBoundingClientRect.left + targetTranslate.x - scrollDelta.left
                };
                var shouldAdjustForSize = prevIndex < newIndex;
                var sizeAdjustment = {
                    x: shouldAdjustForSize && _this.axis.x ? targetNode.offsetWidth - _this.width : 0,
                    y: shouldAdjustForSize && _this.axis.y ? targetNode.offsetHeight - _this.height : 0
                };
                _this.handleSortMove({
                    pageX: targetPosition.left + sizeAdjustment.x,
                    pageY: targetPosition.top + sizeAdjustment.y,
                    ignoreTransition: shift === 0
                });
            });
            (0, $8K2NM.default)((0, $br3Qu.default)((0, $br3Qu.default)(_this)), "keyDrop", function(event) {
                _this.handleSortEnd(event);
                if (_this.initialFocusedNode) _this.initialFocusedNode.focus();
            });
            (0, $8K2NM.default)((0, $br3Qu.default)((0, $br3Qu.default)(_this)), "handleKeyEnd", function(event) {
                if (_this.manager.active) _this.keyDrop(event);
            });
            (0, $8K2NM.default)((0, $br3Qu.default)((0, $br3Qu.default)(_this)), "isValidSortingTarget", function(event) {
                var useDragHandle = _this.props.useDragHandle;
                var target = event.target;
                var node = $3f0e2481a90db00a$var$closest(target, function(el) {
                    return el.sortableInfo != null;
                });
                return node && node.sortableInfo && !node.sortableInfo.disabled && (useDragHandle ? $3f0e2481a90db00a$var$isSortableHandle(target) : target.sortableInfo);
            });
            var manager = new $3f0e2481a90db00a$var$Manager();
            $3f0e2481a90db00a$var$validateProps(props);
            _this.manager = manager;
            _this.wrappedInstance = (0, $jbmdS.createRef)();
            _this.sortableContextValue = {
                manager: manager
            };
            _this.events = {
                end: _this.handleEnd,
                move: _this.handleMove,
                start: _this.handleStart
            };
            return _this;
        }
        (0, $jj5jQ.default)(WithSortableContainer, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _this2 = this;
                    var useWindowAsScrollContainer = this.props.useWindowAsScrollContainer;
                    var container = this.getContainer();
                    Promise.resolve(container).then(function(containerNode) {
                        _this2.container = containerNode;
                        _this2.document = _this2.container.ownerDocument || document;
                        var contentWindow = _this2.props.contentWindow || _this2.document.defaultView || window;
                        _this2.contentWindow = typeof contentWindow === "function" ? contentWindow() : contentWindow;
                        _this2.scrollContainer = useWindowAsScrollContainer ? _this2.document.scrollingElement || _this2.document.documentElement : $3f0e2481a90db00a$var$getScrollingParent(_this2.container) || _this2.container;
                        _this2.autoScroller = new $3f0e2481a90db00a$var$AutoScroller(_this2.scrollContainer, _this2.onAutoScroll);
                        Object.keys(_this2.events).forEach(function(key) {
                            return $3f0e2481a90db00a$var$events[key].forEach(function(eventName) {
                                return _this2.container.addEventListener(eventName, _this2.events[key], false);
                            });
                        });
                        _this2.container.addEventListener("keydown", _this2.handleKeyDown);
                    });
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    var _this3 = this;
                    if (this.helper && this.helper.parentNode) this.helper.parentNode.removeChild(this.helper);
                    if (!this.container) return;
                    Object.keys(this.events).forEach(function(key) {
                        return $3f0e2481a90db00a$var$events[key].forEach(function(eventName) {
                            return _this3.container.removeEventListener(eventName, _this3.events[key]);
                        });
                    });
                    this.container.removeEventListener("keydown", this.handleKeyDown);
                }
            },
            {
                key: "updateHelperPosition",
                value: function updateHelperPosition(event) {
                    var _this$props6 = this.props, lockAxis = _this$props6.lockAxis, lockOffset = _this$props6.lockOffset, lockToContainerEdges = _this$props6.lockToContainerEdges, transitionDuration = _this$props6.transitionDuration, _this$props6$keyboard = _this$props6.keyboardSortingTransitionDuration, keyboardSortingTransitionDuration = _this$props6$keyboard === void 0 ? transitionDuration : _this$props6$keyboard;
                    var isKeySorting = this.manager.isKeySorting;
                    var ignoreTransition = event.ignoreTransition;
                    var offset = $3f0e2481a90db00a$var$getPosition(event);
                    var translate = {
                        x: offset.x - this.initialOffset.x,
                        y: offset.y - this.initialOffset.y
                    };
                    translate.y -= window.pageYOffset - this.initialWindowScroll.top;
                    translate.x -= window.pageXOffset - this.initialWindowScroll.left;
                    this.translate = translate;
                    if (lockToContainerEdges) {
                        var _getLockPixelOffsets = $3f0e2481a90db00a$var$getLockPixelOffsets({
                            height: this.height,
                            lockOffset: lockOffset,
                            width: this.width
                        }), _getLockPixelOffsets2 = (0, $CZyex.default)(_getLockPixelOffsets, 2), minLockOffset = _getLockPixelOffsets2[0], maxLockOffset = _getLockPixelOffsets2[1];
                        var minOffset = {
                            x: this.width / 2 - minLockOffset.x,
                            y: this.height / 2 - minLockOffset.y
                        };
                        var maxOffset = {
                            x: this.width / 2 - maxLockOffset.x,
                            y: this.height / 2 - maxLockOffset.y
                        };
                        translate.x = $3f0e2481a90db00a$var$limit(this.minTranslate.x + minOffset.x, this.maxTranslate.x - maxOffset.x, translate.x);
                        translate.y = $3f0e2481a90db00a$var$limit(this.minTranslate.y + minOffset.y, this.maxTranslate.y - maxOffset.y, translate.y);
                    }
                    if (lockAxis === "x") translate.y = 0;
                    else if (lockAxis === "y") translate.x = 0;
                    if (isKeySorting && keyboardSortingTransitionDuration && !ignoreTransition) $3f0e2481a90db00a$var$setTransitionDuration(this.helper, keyboardSortingTransitionDuration);
                    $3f0e2481a90db00a$var$setTranslate3d(this.helper, translate);
                }
            },
            {
                key: "animateNodes",
                value: function animateNodes() {
                    var _this$props7 = this.props, transitionDuration = _this$props7.transitionDuration, hideSortableGhost = _this$props7.hideSortableGhost, onSortOver = _this$props7.onSortOver;
                    var containerScrollDelta = this.containerScrollDelta, windowScrollDelta = this.windowScrollDelta;
                    var nodes = this.manager.getOrderedRefs();
                    var sortingOffset = {
                        left: this.offsetEdge.left + this.translate.x + containerScrollDelta.left,
                        top: this.offsetEdge.top + this.translate.y + containerScrollDelta.top
                    };
                    var isKeySorting = this.manager.isKeySorting;
                    var prevIndex = this.newIndex;
                    this.newIndex = null;
                    for(var i = 0, len = nodes.length; i < len; i++){
                        var _node3 = nodes[i].node;
                        var index = _node3.sortableInfo.index;
                        var width = _node3.offsetWidth;
                        var height = _node3.offsetHeight;
                        var offset = {
                            height: this.height > height ? height / 2 : this.height / 2,
                            width: this.width > width ? width / 2 : this.width / 2
                        };
                        var mustShiftBackward = isKeySorting && index > this.index && index <= prevIndex;
                        var mustShiftForward = isKeySorting && index < this.index && index >= prevIndex;
                        var translate = {
                            x: 0,
                            y: 0
                        };
                        var edgeOffset = nodes[i].edgeOffset;
                        if (!edgeOffset) {
                            edgeOffset = $3f0e2481a90db00a$var$getEdgeOffset(_node3, this.container);
                            nodes[i].edgeOffset = edgeOffset;
                            if (isKeySorting) nodes[i].boundingClientRect = $3f0e2481a90db00a$var$getScrollAdjustedBoundingClientRect(_node3, containerScrollDelta);
                        }
                        var nextNode = i < nodes.length - 1 && nodes[i + 1];
                        var prevNode = i > 0 && nodes[i - 1];
                        if (nextNode && !nextNode.edgeOffset) {
                            nextNode.edgeOffset = $3f0e2481a90db00a$var$getEdgeOffset(nextNode.node, this.container);
                            if (isKeySorting) nextNode.boundingClientRect = $3f0e2481a90db00a$var$getScrollAdjustedBoundingClientRect(nextNode.node, containerScrollDelta);
                        }
                        if (index === this.index) {
                            if (hideSortableGhost) {
                                this.sortableGhost = _node3;
                                $3f0e2481a90db00a$var$setInlineStyles(_node3, {
                                    opacity: 0,
                                    visibility: "hidden"
                                });
                            }
                            continue;
                        }
                        if (transitionDuration) $3f0e2481a90db00a$var$setTransitionDuration(_node3, transitionDuration);
                        if (this.axis.x) {
                            if (this.axis.y) {
                                if (mustShiftForward || index < this.index && (sortingOffset.left + windowScrollDelta.left - offset.width <= edgeOffset.left && sortingOffset.top + windowScrollDelta.top <= edgeOffset.top + offset.height || sortingOffset.top + windowScrollDelta.top + offset.height <= edgeOffset.top)) {
                                    translate.x = this.width + this.marginOffset.x;
                                    if (edgeOffset.left + translate.x > this.containerBoundingRect.width - offset.width) {
                                        if (nextNode) {
                                            translate.x = nextNode.edgeOffset.left - edgeOffset.left;
                                            translate.y = nextNode.edgeOffset.top - edgeOffset.top;
                                        }
                                    }
                                    if (this.newIndex === null) this.newIndex = index;
                                } else if (mustShiftBackward || index > this.index && (sortingOffset.left + windowScrollDelta.left + offset.width >= edgeOffset.left && sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top || sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top + height)) {
                                    translate.x = -(this.width + this.marginOffset.x);
                                    if (edgeOffset.left + translate.x < this.containerBoundingRect.left + offset.width) {
                                        if (prevNode) {
                                            translate.x = prevNode.edgeOffset.left - edgeOffset.left;
                                            translate.y = prevNode.edgeOffset.top - edgeOffset.top;
                                        }
                                    }
                                    this.newIndex = index;
                                }
                            } else {
                                if (mustShiftBackward || index > this.index && sortingOffset.left + windowScrollDelta.left + offset.width >= edgeOffset.left) {
                                    translate.x = -(this.width + this.marginOffset.x);
                                    this.newIndex = index;
                                } else if (mustShiftForward || index < this.index && sortingOffset.left + windowScrollDelta.left <= edgeOffset.left + offset.width) {
                                    translate.x = this.width + this.marginOffset.x;
                                    if (this.newIndex == null) this.newIndex = index;
                                }
                            }
                        } else if (this.axis.y) {
                            if (mustShiftBackward || index > this.index && sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top) {
                                translate.y = -(this.height + this.marginOffset.y);
                                this.newIndex = index;
                            } else if (mustShiftForward || index < this.index && sortingOffset.top + windowScrollDelta.top <= edgeOffset.top + offset.height) {
                                translate.y = this.height + this.marginOffset.y;
                                if (this.newIndex == null) this.newIndex = index;
                            }
                        }
                        $3f0e2481a90db00a$var$setTranslate3d(_node3, translate);
                        nodes[i].translate = translate;
                    }
                    if (this.newIndex == null) this.newIndex = this.index;
                    if (isKeySorting) this.newIndex = prevIndex;
                    var oldIndex = isKeySorting ? this.prevIndex : prevIndex;
                    if (onSortOver && this.newIndex !== oldIndex) onSortOver({
                        collection: this.manager.active.collection,
                        index: this.index,
                        newIndex: this.newIndex,
                        oldIndex: oldIndex,
                        isKeySorting: isKeySorting,
                        nodes: nodes,
                        helper: this.helper
                    });
                }
            },
            {
                key: "getWrappedInstance",
                value: function getWrappedInstance() {
                    (0, (/*@__PURE__*/$parcel$interopDefault($liDpN)))(config.withRef, "To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableContainer() call");
                    return this.wrappedInstance.current;
                }
            },
            {
                key: "getContainer",
                value: function getContainer() {
                    var getContainer = this.props.getContainer;
                    if (typeof getContainer !== "function") return (0, $jCNM0.findDOMNode)(this);
                    return getContainer(config.withRef ? this.getWrappedInstance() : undefined);
                }
            },
            {
                key: "render",
                value: function render() {
                    var ref = config.withRef ? this.wrappedInstance : null;
                    return (0, $jbmdS.createElement)($3f0e2481a90db00a$var$SortableContext.Provider, {
                        value: this.sortableContextValue
                    }, (0, $jbmdS.createElement)(WrappedComponent, (0, $7i29i.default)({
                        ref: ref
                    }, $3f0e2481a90db00a$var$omit(this.props, $3f0e2481a90db00a$var$omittedProps))));
                }
            },
            {
                key: "helperContainer",
                get: function get() {
                    var helperContainer = this.props.helperContainer;
                    if (typeof helperContainer === "function") return helperContainer();
                    return this.props.helperContainer || this.document.body;
                }
            },
            {
                key: "containerScrollDelta",
                get: function get() {
                    var useWindowAsScrollContainer = this.props.useWindowAsScrollContainer;
                    if (useWindowAsScrollContainer) return {
                        left: 0,
                        top: 0
                    };
                    return {
                        left: this.scrollContainer.scrollLeft - this.initialScroll.left,
                        top: this.scrollContainer.scrollTop - this.initialScroll.top
                    };
                }
            },
            {
                key: "windowScrollDelta",
                get: function get() {
                    return {
                        left: this.contentWindow.pageXOffset - this.initialWindowScroll.left,
                        top: this.contentWindow.pageYOffset - this.initialWindowScroll.top
                    };
                }
            }
        ]);
        return WithSortableContainer;
    }((0, $jbmdS.Component)), (0, $8K2NM.default)(_class, "displayName", $3f0e2481a90db00a$var$provideDisplayName("sortableList", WrappedComponent)), (0, $8K2NM.default)(_class, "defaultProps", $3f0e2481a90db00a$var$defaultProps), (0, $8K2NM.default)(_class, "propTypes", $3f0e2481a90db00a$var$propTypes), _temp;
}
var $3f0e2481a90db00a$var$propTypes$1 = {
    index: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).number.isRequired,
    collection: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).string
    ]),
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).bool
};
var $3f0e2481a90db00a$var$omittedProps$1 = Object.keys($3f0e2481a90db00a$var$propTypes$1);
function $3f0e2481a90db00a$export$58d1e4fb0d207bf7(WrappedComponent) {
    var _class, _temp;
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        withRef: false
    };
    return _temp = _class = function(_React$Component) {
        (0, $1N4zm.default)(WithSortableElement, _React$Component);
        function WithSortableElement() {
            var _getPrototypeOf2;
            var _this;
            (0, $3GVdq.default)(this, WithSortableElement);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = (0, $ibb6t.default)(this, (_getPrototypeOf2 = (0, $dO7bG.default)(WithSortableElement)).call.apply(_getPrototypeOf2, [
                this
            ].concat(args)));
            (0, $8K2NM.default)((0, $br3Qu.default)((0, $br3Qu.default)(_this)), "wrappedInstance", (0, $jbmdS.createRef)());
            return _this;
        }
        (0, $jj5jQ.default)(WithSortableElement, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.register();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    if (this.node) {
                        if (prevProps.index !== this.props.index) this.node.sortableInfo.index = this.props.index;
                        if (prevProps.disabled !== this.props.disabled) this.node.sortableInfo.disabled = this.props.disabled;
                    }
                    if (prevProps.collection !== this.props.collection) {
                        this.unregister(prevProps.collection);
                        this.register();
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.unregister();
                }
            },
            {
                key: "register",
                value: function register() {
                    var _this$props = this.props, collection = _this$props.collection, disabled = _this$props.disabled, index = _this$props.index;
                    var node = (0, $jCNM0.findDOMNode)(this);
                    node.sortableInfo = {
                        collection: collection,
                        disabled: disabled,
                        index: index,
                        manager: this.context.manager
                    };
                    this.node = node;
                    this.ref = {
                        node: node
                    };
                    this.context.manager.add(collection, this.ref);
                }
            },
            {
                key: "unregister",
                value: function unregister() {
                    var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.collection;
                    this.context.manager.remove(collection, this.ref);
                }
            },
            {
                key: "getWrappedInstance",
                value: function getWrappedInstance() {
                    (0, (/*@__PURE__*/$parcel$interopDefault($liDpN)))(config.withRef, "To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableElement() call");
                    return this.wrappedInstance.current;
                }
            },
            {
                key: "render",
                value: function render() {
                    var ref = config.withRef ? this.wrappedInstance : null;
                    return (0, $jbmdS.createElement)(WrappedComponent, (0, $7i29i.default)({
                        ref: ref
                    }, $3f0e2481a90db00a$var$omit(this.props, $3f0e2481a90db00a$var$omittedProps$1)));
                }
            }
        ]);
        return WithSortableElement;
    }((0, $jbmdS.Component)), (0, $8K2NM.default)(_class, "displayName", $3f0e2481a90db00a$var$provideDisplayName("sortableElement", WrappedComponent)), (0, $8K2NM.default)(_class, "contextType", $3f0e2481a90db00a$var$SortableContext), (0, $8K2NM.default)(_class, "propTypes", $3f0e2481a90db00a$var$propTypes$1), (0, $8K2NM.default)(_class, "defaultProps", {
        collection: 0
    }), _temp;
}

});
parcelRegister("3upWL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28a84cf0f5a58187$export$2e2bcd8739ae039; });

var $8K2NM = parcelRequire("8K2NM");
function $28a84cf0f5a58187$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? Object(arguments[r]) : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), o.forEach(function(r) {
            (0, $8K2NM.default)(e, r, t[r]);
        });
    }
    return e;
}

});

parcelRegister("liDpN", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $f819da6bac04e356$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = $f819da6bac04e356$var$invariant;

});




parcelRegister("52dEm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3aa7ba3d26d9c56f$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("jbmdS");
parcelRequire("eat5C");

var $gN0TC = parcelRequire("gN0TC");

var $02LyB = parcelRequire("02LyB");
var $3aa7ba3d26d9c56f$export$2e2bcd8739ae039 = ({ id: id, label: label, disabled: disabled = false, labelPosition: labelPosition = "right", valueLink: valueLink, value: value, indeterminate: indeterminate = false, onChange: onChange, onClick: onClick, className: className = "", style: style, variant: variant, ...props })=>{
    id = id != null ? id : "coincraft-checkbox-" + (0, (/*@__PURE__*/$parcel$interopDefault($gN0TC)))();
    value = valueLink != null ? valueLink.value : value;
    indeterminate = value === "indeterminate";
    value = value === "indeterminate" ? false : value;
    let checkbox = /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
        className: "coincraft-checkbox__input",
        id: id,
        type: "checkbox",
        checked: value || "",
        disabled: disabled,
        onChange: (event)=>{
            if (!disabled) {
                if (valueLink != null) valueLink.requestChange(event.target.checked);
                else onChange(event.target.checked, event);
            }
        },
        onClick: onClick,
        style: {
            cursor: "pointer"
        },
        tabIndex: "0",
        ref: (input)=>{
            if (input) input.indeterminate = indeterminate;
        }
    });
    label = label != null ? /*#__PURE__*/ (0, $61Ea1.jsx)("label", {
        htmlFor: id,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("text-sm", labelPosition === "right" ? "ml-2.5" : "mr-2.5", variant === "secondary" ? "text-444" : "text-white"),
        children: label
    }) : null;
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: `coincraft-checkbox ${className}`,
        style: {
            display: "inline-block",
            ...style
        },
        children: labelPosition === "right" ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            className: "inline-flex items-center",
            children: [
                checkbox,
                label
            ]
        }) : /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            className: "inline-flex items-center",
            children: [
                label,
                checkbox
            ]
        })
    });
};

});

parcelRegister("7GQic", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $599504ddc6737d4a$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("jbmdS");
parcelRequire("eat5C");

var $e8Hda = parcelRequire("e8Hda");

var $cIuPI = parcelRequire("cIuPI");

parcelRequire("1BTI2");

var $fJ4T4 = parcelRequire("fJ4T4");

var $8oaA5 = parcelRequire("8oaA5");

var $lFhEr = parcelRequire("lFhEr");

var $6l4Jp = parcelRequire("6l4Jp");

var $02LyB = parcelRequire("02LyB");
(0, (/*@__PURE__*/$parcel$interopDefault($6l4Jp)))((0, (/*@__PURE__*/$parcel$interopDefault($lFhEr))));
var $599504ddc6737d4a$export$2e2bcd8739ae039 = ({ isEditable: isEditable = true, value: value, onChange: onChange, dropLeft: dropLeft = false, min: min, max: max, actionArgs: actionArgs, isValid: isValid = true, tableStyle: tableStyle, ...props })=>{
    if (isEditable) {
        if (dropLeft) props = (0, $e8Hda.mergeProps)({
            className: "rw-dropleft"
        }, props);
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $cIuPI.DateTimePicker), {
            id: "dt",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("!text-sm !text-[#555]", !isValid ? "invalid-date-picker" : "", tableStyle),
            time: false,
            format: (d)=>(0, $fJ4T4.FormatDate)(d, {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit"
                }),
            value: value,
            onChange: (newDate)=>{
                var val = newDate != null ? newDate : null;
                onChange(val);
            },
            parse: (0, $8oaA5.ParseDate),
            // react-widgets DateTimePicker doesn't work properly if you pass `null`
            // here (esp. `max`).
            min: min || new Date(1970, 0, 1),
            max: max || new Date(2069, 11, 30),
            ...props
        });
    } else // Yes, moment.js format strings are different to the format strings
    // accepted by `DateTimePicker`.
    return /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
        children: value != null ? (0, $fJ4T4.FormatDate)(value, {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        }) : "(None)"
    });
};

});
parcelRegister("cIuPI", function(module, exports) {
"use strict";
var $942182eaa17fcebe$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $zY9w6 = parcelRequire("zY9w6");









module.exports = $942182eaa17fcebe$var$_extends({}, $zY9w6, {
    DropdownList: (parcelRequire("RNpNh")),
    Combobox: (parcelRequire("fiBfu")),
    Calendar: (parcelRequire("l3yHc")),
    DateTimePicker: (parcelRequire("hpuAs")),
    NumberPicker: (parcelRequire("aKsZE")),
    Multiselect: (parcelRequire("iVgcb")),
    SelectList: (parcelRequire("61e4p")),
    utils: {
        ReplaceTransitionGroup: (parcelRequire("7v7AH")),
        SlideTransition: (parcelRequire("abgZr"))
    }
});

});
parcelRegister("zY9w6", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $aCqSx = parcelRequire("aCqSx");
var $06c1ee0829b0cff5$var$_configuration2 = $06c1ee0829b0cff5$var$_interopRequireDefault($aCqSx);

var $7fTd5 = parcelRequire("7fTd5");
var $06c1ee0829b0cff5$var$localizers = $06c1ee0829b0cff5$var$_interopRequireWildcard($7fTd5);
function $06c1ee0829b0cff5$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $06c1ee0829b0cff5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = {
    setAnimate: function setAnimate(animatefn) {
        $06c1ee0829b0cff5$var$_configuration2.default.animate = animatefn;
    },
    setLocalizers: function setLocalizers(_ref) {
        var date = _ref.date, number = _ref.number;
        date && this.setDateLocalizer(date);
        number && this.setNumberLocalizer(number);
    },
    setDateLocalizer: $06c1ee0829b0cff5$var$localizers.setDate,
    setNumberLocalizer: $06c1ee0829b0cff5$var$localizers.setNumber
};
module.exports = module.exports["default"];

});
parcelRegister("aCqSx", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $klzuc = parcelRequire("klzuc");
var $7bb24d897fac11b5$var$_animate2 = $7bb24d897fac11b5$var$_interopRequireDefault($klzuc);
function $7bb24d897fac11b5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = {
    animate: $7bb24d897fac11b5$var$_animate2.default
};
module.exports = module.exports["default"];

});
parcelRegister("klzuc", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $ed014b9f6982f343$var$animate;

var $iTlHi = parcelRequire("iTlHi");
var $ed014b9f6982f343$var$_hyphenate2 = $ed014b9f6982f343$var$_interopRequireDefault($iTlHi);

var $bpvMx = parcelRequire("bpvMx");
var $ed014b9f6982f343$var$_style2 = $ed014b9f6982f343$var$_interopRequireDefault($bpvMx);

var $jEy7a = parcelRequire("jEy7a");
var $ed014b9f6982f343$var$_on2 = $ed014b9f6982f343$var$_interopRequireDefault($jEy7a);

var $7RyUb = parcelRequire("7RyUb");
var $ed014b9f6982f343$var$_off2 = $ed014b9f6982f343$var$_interopRequireDefault($7RyUb);

var $bOX1H = parcelRequire("bOX1H");
var $ed014b9f6982f343$var$_properties2 = $ed014b9f6982f343$var$_interopRequireDefault($bOX1H);
function $ed014b9f6982f343$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $ed014b9f6982f343$var$has = Object.prototype.hasOwnProperty, $ed014b9f6982f343$var$reset = {}, $ed014b9f6982f343$var$TRANSLATION_MAP = {
    left: "translateX",
    right: "translateX",
    top: "translateY",
    bottom: "translateY"
};
$ed014b9f6982f343$var$reset[$ed014b9f6982f343$var$_properties2.default.property] = $ed014b9f6982f343$var$reset[$ed014b9f6982f343$var$_properties2.default.duration] = $ed014b9f6982f343$var$reset[$ed014b9f6982f343$var$_properties2.default.delay] = $ed014b9f6982f343$var$reset[$ed014b9f6982f343$var$_properties2.default.timing] = "";
$ed014b9f6982f343$var$animate.endEvent = $ed014b9f6982f343$var$_properties2.default.end;
$ed014b9f6982f343$var$animate.transform = $ed014b9f6982f343$var$_properties2.default.transform;
$ed014b9f6982f343$var$animate.TRANSLATION_MAP = $ed014b9f6982f343$var$TRANSLATION_MAP;
// super lean animate function for transitions
// doesn't support all translations to keep it matching the jquery API
/**
 * code in part from: Zepto 1.1.4 | zeptojs.com/license
 */ function $ed014b9f6982f343$var$animate(node, properties, duration, easing, callback) {
    var cssProperties = [], fakeEvent = {
        target: node,
        currentTarget: node
    }, cssValues = {}, transforms = "", fired;
    if (typeof easing === "function") callback = easing, easing = null;
    if (!$ed014b9f6982f343$var$_properties2.default.end) duration = 0;
    if (duration === undefined) duration = 200;
    for(var key in properties)if ($ed014b9f6982f343$var$has.call(properties, key)) {
        if (/(top|bottom)/.test(key)) transforms += $ed014b9f6982f343$var$TRANSLATION_MAP[key] + "(" + properties[key] + ") ";
        else {
            cssValues[key] = properties[key];
            cssProperties.push((0, $ed014b9f6982f343$var$_hyphenate2.default)(key));
        }
    }
    if (transforms) {
        cssValues[$ed014b9f6982f343$var$_properties2.default.transform] = transforms;
        cssProperties.push($ed014b9f6982f343$var$_properties2.default.transform);
    }
    if (duration > 0) {
        cssValues[$ed014b9f6982f343$var$_properties2.default.property] = cssProperties.join(", ");
        cssValues[$ed014b9f6982f343$var$_properties2.default.duration] = duration / 1000 + "s";
        cssValues[$ed014b9f6982f343$var$_properties2.default.delay] = "0s";
        cssValues[$ed014b9f6982f343$var$_properties2.default.timing] = easing || "linear";
        (0, $ed014b9f6982f343$var$_on2.default)(node, $ed014b9f6982f343$var$_properties2.default.end, done);
        setTimeout(function() {
            if (!fired) done(fakeEvent);
        }, duration + 500);
    }
    node.clientLeft; // trigger page reflow
    (0, $ed014b9f6982f343$var$_style2.default)(node, cssValues);
    if (duration <= 0) setTimeout(done.bind(null, fakeEvent), 0);
    return {
        cancel: function cancel() {
            if (fired) return;
            fired = true;
            (0, $ed014b9f6982f343$var$_off2.default)(node, $ed014b9f6982f343$var$_properties2.default.end, done);
            (0, $ed014b9f6982f343$var$_style2.default)(node, $ed014b9f6982f343$var$reset);
        }
    };
    function done(event) {
        if (event.target !== event.currentTarget) return;
        fired = true;
        (0, $ed014b9f6982f343$var$_off2.default)(event.target, $ed014b9f6982f343$var$_properties2.default.end, done);
        (0, $ed014b9f6982f343$var$_style2.default)(node, $ed014b9f6982f343$var$reset);
        callback && callback.call(this);
    }
}
module.exports = module.exports["default"];

});
parcelRegister("iTlHi", function(module, exports) {
"use strict";
var $dc0e31af4c869be5$var$rUpper = /([A-Z])/g;
module.exports = function hyphenate(string) {
    return string.replace($dc0e31af4c869be5$var$rUpper, "-$1").toLowerCase();
};

});

parcelRegister("bpvMx", function(module, exports) {
"use strict";

var $l6Vee = parcelRequire("l6Vee");

var $2UCQc = parcelRequire("2UCQc");

var $kktvB = parcelRequire("kktvB");

var $72Yks = parcelRequire("72Yks");
var $84eaaebb43d2ce1d$var$has = Object.prototype.hasOwnProperty;
module.exports = function style(node, property, value) {
    var css = "", props = property;
    if (typeof property === "string") {
        if (value === undefined) return node.style[$l6Vee(property)] || $kktvB(node).getPropertyValue($2UCQc(property));
        else (props = {})[property] = value;
    }
    for(var key in props)if ($84eaaebb43d2ce1d$var$has.call(props, key)) !props[key] && props[key] !== 0 ? $72Yks(node, $2UCQc(key)) : css += $2UCQc(key) + ":" + props[key] + ";";
    node.style.cssText += ";" + css;
};

});
parcelRegister("l6Vee", function(module, exports) {
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
 */ "use strict";

var $aHTRS = parcelRequire("aHTRS");
var $f5e68ce9565902f9$var$msPattern = /^-ms-/;
module.exports = function camelizeStyleName(string) {
    return $aHTRS(string.replace($f5e68ce9565902f9$var$msPattern, "ms-"));
};

});
parcelRegister("aHTRS", function(module, exports) {
"use strict";
var $7cb941bd4a309f99$var$rHyphen = /-(.)/g;
module.exports = function camelize(string) {
    return string.replace($7cb941bd4a309f99$var$rHyphen, function(_, chr) {
        return chr.toUpperCase();
    });
};

});


parcelRegister("2UCQc", function(module, exports) {
/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ "use strict";

var $iTlHi = parcelRequire("iTlHi");
var $21eef0b650d5546b$var$msPattern = /^ms-/;
module.exports = function hyphenateStyleName(string) {
    return $iTlHi(string).replace($21eef0b650d5546b$var$msPattern, "-ms-");
};

});

parcelRegister("kktvB", function(module, exports) {
"use strict";

var $5iLKY = parcelRequire("5iLKY");

var $l6Vee = parcelRequire("l6Vee");
var $eccc90bf3928b49b$var$_utilCamelizeStyle2 = $5iLKY.interopRequireDefault($l6Vee);
var $eccc90bf3928b49b$var$rposition = /^(top|right|bottom|left)$/;
var $eccc90bf3928b49b$var$rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
module.exports = function _getComputedStyle(node) {
    if (!node) throw new TypeError("No Element passed to `getComputedStyle()`");
    var doc = node.ownerDocument;
    return "defaultView" in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
        getPropertyValue: function getPropertyValue(prop) {
            var style = node.style;
            prop = (0, $eccc90bf3928b49b$var$_utilCamelizeStyle2["default"])(prop);
            if (prop == "float") prop = "styleFloat";
            var current = node.currentStyle[prop] || null;
            if (current == null && style && style[prop]) current = style[prop];
            if ($eccc90bf3928b49b$var$rnumnonpx.test(current) && !$eccc90bf3928b49b$var$rposition.test(prop)) {
                // Remember the original values
                var left = style.left;
                var runStyle = node.runtimeStyle;
                var rsLeft = runStyle && runStyle.left;
                // Put in the new values to get a computed value out
                if (rsLeft) runStyle.left = node.currentStyle.left;
                style.left = prop === "fontSize" ? "1em" : current;
                current = style.pixelLeft + "px";
                // Revert the changed values
                style.left = left;
                if (rsLeft) runStyle.left = rsLeft;
            }
            return current;
        }
    };
};

});
parcelRegister("5iLKY", function(module, exports) {
(function(root, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports"
    ], factory);
    else factory(module.exports);
})(module.exports, function(global) {
    var babelHelpers = global;
    babelHelpers.interopRequireDefault = function(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    };
    babelHelpers._extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
});

});


parcelRegister("72Yks", function(module, exports) {
"use strict";
module.exports = function removeStyle(node, key) {
    return "removeProperty" in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
};

});


parcelRegister("jEy7a", function(module, exports) {
"use strict";

var $uyd6r = parcelRequire("uyd6r");
var $e4ec3736de64a899$var$on = function on() {};
if ($uyd6r) $e4ec3736de64a899$var$on = function() {
    if (document.addEventListener) return function(node, eventName, handler, capture) {
        return node.addEventListener(eventName, handler, capture || false);
    };
    else if (document.attachEvent) return function(node, eventName, handler) {
        return node.attachEvent("on" + eventName, handler);
    };
}();
module.exports = $e4ec3736de64a899$var$on;

});
parcelRegister("uyd6r", function(module, exports) {
"use strict";
module.exports = !!(typeof window !== "undefined" && window.document && window.document.createElement);

});


parcelRegister("7RyUb", function(module, exports) {
"use strict";

var $uyd6r = parcelRequire("uyd6r");
var $5b988f13dd7f02e5$var$off = function off() {};
if ($uyd6r) $5b988f13dd7f02e5$var$off = function() {
    if (document.addEventListener) return function(node, eventName, handler, capture) {
        return node.removeEventListener(eventName, handler, capture || false);
    };
    else if (document.attachEvent) return function(node, eventName, handler) {
        return node.detachEvent("on" + eventName, handler);
    };
}();
module.exports = $5b988f13dd7f02e5$var$off;

});

parcelRegister("bOX1H", function(module, exports) {
"use strict";

var $uyd6r = parcelRequire("uyd6r");
var $89b226a3258c8d65$var$has = Object.prototype.hasOwnProperty, $89b226a3258c8d65$var$transform = "transform", $89b226a3258c8d65$var$transition = {}, $89b226a3258c8d65$var$transitionTiming, $89b226a3258c8d65$var$transitionDuration, $89b226a3258c8d65$var$transitionProperty, $89b226a3258c8d65$var$transitionDelay;
if ($uyd6r) {
    $89b226a3258c8d65$var$transition = $89b226a3258c8d65$var$getTransitionProperties();
    $89b226a3258c8d65$var$transform = $89b226a3258c8d65$var$transition.prefix + $89b226a3258c8d65$var$transform;
    $89b226a3258c8d65$var$transitionProperty = $89b226a3258c8d65$var$transition.prefix + "transition-property";
    $89b226a3258c8d65$var$transitionDuration = $89b226a3258c8d65$var$transition.prefix + "transition-duration";
    $89b226a3258c8d65$var$transitionDelay = $89b226a3258c8d65$var$transition.prefix + "transition-delay";
    $89b226a3258c8d65$var$transitionTiming = $89b226a3258c8d65$var$transition.prefix + "transition-timing-function";
}
module.exports = {
    transform: $89b226a3258c8d65$var$transform,
    end: $89b226a3258c8d65$var$transition.end,
    property: $89b226a3258c8d65$var$transitionProperty,
    timing: $89b226a3258c8d65$var$transitionTiming,
    delay: $89b226a3258c8d65$var$transitionDelay,
    duration: $89b226a3258c8d65$var$transitionDuration
};
function $89b226a3258c8d65$var$getTransitionProperties() {
    var endEvent, prefix = "", transitions = {
        O: "otransitionend",
        Moz: "transitionend",
        Webkit: "webkitTransitionEnd",
        ms: "MSTransitionEnd"
    };
    var element = document.createElement("div");
    for(var vendor in transitions)if ($89b226a3258c8d65$var$has.call(transitions, vendor)) {
        if (element.style[vendor + "TransitionProperty"] !== undefined) {
            prefix = "-" + vendor.toLowerCase() + "-";
            endEvent = transitions[vendor];
            break;
        }
    }
    if (!endEvent && element.style.transitionProperty !== undefined) endEvent = "transitionend";
    return {
        end: endEvent,
        prefix: prefix
    };
}

});



parcelRegister("7fTd5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $5484c2aab8750ad9$export$1e511d4a378977f5; }, function (v) { return $5484c2aab8750ad9$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "date", function () { return $5484c2aab8750ad9$export$324d90190a8b822a; }, function (v) { return $5484c2aab8750ad9$export$324d90190a8b822a = v; });
$parcel$export(module.exports, "number", function () { return $5484c2aab8750ad9$export$98e628dec113755e; }, function (v) { return $5484c2aab8750ad9$export$98e628dec113755e = v; });
$parcel$export(module.exports, "setNumber", function () { return $5484c2aab8750ad9$export$96a94ca0e6838874; }, function (v) { return $5484c2aab8750ad9$export$96a94ca0e6838874 = v; });
$parcel$export(module.exports, "setDate", function () { return $5484c2aab8750ad9$export$566174fa40823587; }, function (v) { return $5484c2aab8750ad9$export$566174fa40823587 = v; });
$parcel$export(module.exports, "default", function () { return $5484c2aab8750ad9$export$2e2bcd8739ae039; }, function (v) { return $5484c2aab8750ad9$export$2e2bcd8739ae039 = v; });
var $5484c2aab8750ad9$export$1e511d4a378977f5;
var $5484c2aab8750ad9$export$324d90190a8b822a;
var $5484c2aab8750ad9$export$98e628dec113755e;
var $5484c2aab8750ad9$export$96a94ca0e6838874;
var $5484c2aab8750ad9$export$566174fa40823587;
var $5484c2aab8750ad9$export$2e2bcd8739ae039;
"use strict";
$5484c2aab8750ad9$export$1e511d4a378977f5 = true;
$5484c2aab8750ad9$export$324d90190a8b822a = $5484c2aab8750ad9$export$98e628dec113755e = $5484c2aab8750ad9$export$96a94ca0e6838874 = undefined;
$5484c2aab8750ad9$export$566174fa40823587 = $5484c2aab8750ad9$var$setDate;

var $liDpN = parcelRequire("liDpN");
var $5484c2aab8750ad9$var$_invariant2 = $5484c2aab8750ad9$var$_interopRequireDefault($liDpN);
parcelRequire("4ELyG");

var $2MXkj = parcelRequire("2MXkj");
var $5484c2aab8750ad9$var$_propTypes2 = $5484c2aab8750ad9$var$_interopRequireDefault($2MXkj);
function $5484c2aab8750ad9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $5484c2aab8750ad9$var$localePropType = $5484c2aab8750ad9$var$_propTypes2.default.oneOfType([
    $5484c2aab8750ad9$var$_propTypes2.default.string,
    $5484c2aab8750ad9$var$_propTypes2.default.func
]);
var $5484c2aab8750ad9$var$REQUIRED_NUMBER_FORMATS = [
    "default"
];
var $5484c2aab8750ad9$var$REQUIRED_DATE_FORMATS = [
    "default",
    "date",
    "time",
    "header",
    "footer",
    "dayOfMonth",
    "month",
    "year",
    "decade",
    "century"
];
function $5484c2aab8750ad9$var$_format(localizer, formatter, value, format, culture) {
    var result = typeof format === "function" ? format(value, culture, localizer) : formatter.call(localizer, value, format, culture);
    (0, $5484c2aab8750ad9$var$_invariant2.default)(result == null || typeof result === "string", "`localizer format(..)` must return a string, null, or undefined");
    return result;
}
function $5484c2aab8750ad9$var$checkFormats(requiredFormats, formats) {}
var $5484c2aab8750ad9$var$_numberLocalizer = $5484c2aab8750ad9$var$createWrapper("NumberPicker");
function $5484c2aab8750ad9$var$setNumber(_ref) {
    var _format2 = _ref.format, _parse = _ref.parse, _ref$decimalChar = _ref.decimalChar, decimalChar = _ref$decimalChar === undefined ? function() {
        return ".";
    } : _ref$decimalChar, _ref$precision = _ref.precision, precision = _ref$precision === undefined ? function() {
        return null;
    } : _ref$precision, formats = _ref.formats, propType = _ref.propType;
    (0, $5484c2aab8750ad9$var$_invariant2.default)(typeof _format2 === "function", "number localizer `format(..)` must be a function");
    (0, $5484c2aab8750ad9$var$_invariant2.default)(typeof _parse === "function", "number localizer `parse(..)` must be a function");
    $5484c2aab8750ad9$var$checkFormats($5484c2aab8750ad9$var$REQUIRED_NUMBER_FORMATS, formats);
    formats.editFormat = formats.editFormat || function(str) {
        return parseFloat(str);
    };
    $5484c2aab8750ad9$var$_numberLocalizer = {
        formats: formats,
        precision: precision,
        decimalChar: decimalChar,
        propType: propType || $5484c2aab8750ad9$var$localePropType,
        format: function format(value, str, culture) {
            return $5484c2aab8750ad9$var$_format(this, _format2, value, str, culture);
        },
        parse: function parse(value, culture, format) {
            var result = _parse.call(this, value, culture, format);
            (0, $5484c2aab8750ad9$var$_invariant2.default)(result == null || typeof result === "number", "number localizer `parse(..)` must return a number, null, or undefined");
            return result;
        }
    };
}
$5484c2aab8750ad9$export$96a94ca0e6838874 = $5484c2aab8750ad9$var$setNumber;
var $5484c2aab8750ad9$var$_dateLocalizer = $5484c2aab8750ad9$var$createWrapper("DateTimePicker");
function $5484c2aab8750ad9$var$setDate(spec) {
    (0, $5484c2aab8750ad9$var$_invariant2.default)(typeof spec.format === "function", "date localizer `format(..)` must be a function");
    (0, $5484c2aab8750ad9$var$_invariant2.default)(typeof spec.parse === "function", "date localizer `parse(..)` must be a function");
    (0, $5484c2aab8750ad9$var$_invariant2.default)(typeof spec.firstOfWeek === "function", "date localizer `firstOfWeek(..)` must be a function");
    $5484c2aab8750ad9$var$checkFormats($5484c2aab8750ad9$var$REQUIRED_DATE_FORMATS, spec.formats);
    $5484c2aab8750ad9$var$_dateLocalizer = {
        formats: spec.formats,
        propType: spec.propType || $5484c2aab8750ad9$var$localePropType,
        startOfWeek: spec.firstOfWeek,
        format: function format(value, str, culture) {
            return $5484c2aab8750ad9$var$_format(this, spec.format, value, str, culture);
        },
        parse: function parse(value, culture) {
            var result = spec.parse.call(this, value, culture);
            (0, $5484c2aab8750ad9$var$_invariant2.default)(result == null || result instanceof Date && !isNaN(result.getTime()), "date localizer `parse(..)` must return a valid Date, null, or undefined");
            return result;
        }
    };
}
var $5484c2aab8750ad9$var$number = $5484c2aab8750ad9$export$98e628dec113755e = {
    propType: function propType() {
        var _numberLocalizer2;
        return (_numberLocalizer2 = $5484c2aab8750ad9$var$_numberLocalizer).propType.apply(_numberLocalizer2, arguments);
    },
    getFormat: function getFormat(key, format) {
        return format || $5484c2aab8750ad9$var$_numberLocalizer.formats[key];
    },
    parse: function parse() {
        var _numberLocalizer3;
        return (_numberLocalizer3 = $5484c2aab8750ad9$var$_numberLocalizer).parse.apply(_numberLocalizer3, arguments);
    },
    format: function format() {
        var _numberLocalizer4;
        return (_numberLocalizer4 = $5484c2aab8750ad9$var$_numberLocalizer).format.apply(_numberLocalizer4, arguments);
    },
    decimalChar: function decimalChar() {
        var _numberLocalizer5;
        return (_numberLocalizer5 = $5484c2aab8750ad9$var$_numberLocalizer).decimalChar.apply(_numberLocalizer5, arguments);
    },
    precision: function precision() {
        var _numberLocalizer6;
        return (_numberLocalizer6 = $5484c2aab8750ad9$var$_numberLocalizer).precision.apply(_numberLocalizer6, arguments);
    }
};
var $5484c2aab8750ad9$var$date = $5484c2aab8750ad9$export$324d90190a8b822a = {
    propType: function propType() {
        var _dateLocalizer2;
        return (_dateLocalizer2 = $5484c2aab8750ad9$var$_dateLocalizer).propType.apply(_dateLocalizer2, arguments);
    },
    getFormat: function getFormat(key, format) {
        return format || $5484c2aab8750ad9$var$_dateLocalizer.formats[key];
    },
    parse: function parse() {
        var _dateLocalizer3;
        return (_dateLocalizer3 = $5484c2aab8750ad9$var$_dateLocalizer).parse.apply(_dateLocalizer3, arguments);
    },
    format: function format() {
        var _dateLocalizer4;
        return (_dateLocalizer4 = $5484c2aab8750ad9$var$_dateLocalizer).format.apply(_dateLocalizer4, arguments);
    },
    startOfWeek: function startOfWeek() {
        var _dateLocalizer5;
        return (_dateLocalizer5 = $5484c2aab8750ad9$var$_dateLocalizer).startOfWeek.apply(_dateLocalizer5, arguments);
    }
};
$5484c2aab8750ad9$export$2e2bcd8739ae039 = {
    number: $5484c2aab8750ad9$var$number,
    date: $5484c2aab8750ad9$var$date
};
function $5484c2aab8750ad9$var$createWrapper() {
    var dummy = {};
    return dummy;
}

});
parcelRegister("4ELyG", function(module, exports) {
"use strict";
var $363fc9fa9f15ed64$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $363fc9fa9f15ed64$var$idCount = 0;
var $363fc9fa9f15ed64$var$_ = module.exports = {
    has: $363fc9fa9f15ed64$var$has,
    result: function result(value) {
        for(var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return typeof value === "function" ? value.apply(undefined, args) : value;
    },
    isShallowEqual: function isShallowEqual(a, b) {
        if (a === b) return true;
        if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
        if ((typeof a === "undefined" ? "undefined" : $363fc9fa9f15ed64$var$_typeof(a)) !== "object" && (typeof b === "undefined" ? "undefined" : $363fc9fa9f15ed64$var$_typeof(b)) !== "object") return a === b;
        if ((typeof a === "undefined" ? "undefined" : $363fc9fa9f15ed64$var$_typeof(a)) !== (typeof b === "undefined" ? "undefined" : $363fc9fa9f15ed64$var$_typeof(b))) return false;
        return $363fc9fa9f15ed64$var$shallowEqual(a, b);
    },
    transform: function transform(obj, cb, seed) {
        $363fc9fa9f15ed64$var$_.each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
        return seed;
    },
    each: function each(obj, cb, thisArg) {
        if (Array.isArray(obj)) return obj.forEach(cb, thisArg);
        for(var key in obj)if ($363fc9fa9f15ed64$var$has(obj, key)) cb.call(thisArg, obj[key], key, obj);
    },
    pick: function pick(obj, keys) {
        keys = [].concat(keys);
        return $363fc9fa9f15ed64$var$_.transform(obj, function(mapped, val, key) {
            if (keys.indexOf(key) !== -1) mapped[key] = val;
        }, {});
    },
    pickProps: function pickProps(props, componentClass) {
        return $363fc9fa9f15ed64$var$_.pick(props, Object.keys(componentClass.propTypes));
    },
    omit: function omit(obj, keys) {
        keys = [].concat(keys);
        return $363fc9fa9f15ed64$var$_.transform(obj, function(mapped, val, key) {
            if (keys.indexOf(key) === -1) mapped[key] = val;
        }, {});
    },
    omitOwnProps: function omitOwnProps(component) {
        for(var _len2 = arguments.length, others = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)others[_key2 - 1] = arguments[_key2];
        var keys = others.reduce(function(arr, compClass) {
            return arr.concat(Object.keys(compClass.propTypes));
        }, Object.keys(component.constructor.propTypes));
        return $363fc9fa9f15ed64$var$_.omit(component.props, keys);
    },
    find: function find(arr, cb, thisArg) {
        var result;
        if (Array.isArray(arr)) {
            arr.every(function(val, idx) {
                if (cb.call(thisArg, val, idx, arr)) return result = val, false;
                return true;
            });
            return result;
        } else for(var key in arr)if ($363fc9fa9f15ed64$var$has(arr, key)) {
            if (cb.call(thisArg, arr[key], key, arr)) return arr[key];
        }
    },
    chunk: function chunk(array, chunkSize) {
        var index = 0, length = array ? array.length : 0, result = [];
        chunkSize = Math.max(+chunkSize || 1, 1);
        while(index < length)result.push(array.slice(index, index += chunkSize));
        return result;
    },
    splat: function splat(obj) {
        return obj == null ? [] : [].concat(obj);
    },
    noop: function noop() {},
    uniqueId: function uniqueId(prefix) {
        return "" + ((prefix == null ? "" : prefix) + ++$363fc9fa9f15ed64$var$idCount);
    }
};
function $363fc9fa9f15ed64$var$has(o, k) {
    return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
}
function $363fc9fa9f15ed64$var$eql(a, b) {
    return a === b;
}
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 */ function $363fc9fa9f15ed64$var$shallowEqual(objA, objB) {
    if (objA == null || objB == null) return false;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!$363fc9fa9f15ed64$var$has(objB, keysA[i]) || !$363fc9fa9f15ed64$var$eql(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});



parcelRegister("RNpNh", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $0a1b4825ca2df89c$var$_desc, $0a1b4825ca2df89c$var$_value, $0a1b4825ca2df89c$var$_obj;
var $0a1b4825ca2df89c$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $jbmdS = parcelRequire("jbmdS");
var $0a1b4825ca2df89c$var$_react2 = $0a1b4825ca2df89c$var$_interopRequireDefault($jbmdS);

var $2MXkj = parcelRequire("2MXkj");
var $0a1b4825ca2df89c$var$_propTypes2 = $0a1b4825ca2df89c$var$_interopRequireDefault($2MXkj);

var $e64Mn = parcelRequire("e64Mn");
var $0a1b4825ca2df89c$var$_createReactClass2 = $0a1b4825ca2df89c$var$_interopRequireDefault($e64Mn);

var $4ToXx = parcelRequire("4ToXx");
var $0a1b4825ca2df89c$var$_activeElement2 = $0a1b4825ca2df89c$var$_interopRequireDefault($4ToXx);

var $6s6kw = parcelRequire("6s6kw");
var $0a1b4825ca2df89c$var$_contains2 = $0a1b4825ca2df89c$var$_interopRequireDefault($6s6kw);

var $02LyB = parcelRequire("02LyB");
var $0a1b4825ca2df89c$var$_classnames2 = $0a1b4825ca2df89c$var$_interopRequireDefault($02LyB);

var $4ELyG = parcelRequire("4ELyG");
var $0a1b4825ca2df89c$var$_3 = $0a1b4825ca2df89c$var$_interopRequireDefault($4ELyG);

var $ikauB = parcelRequire("ikauB");
var $0a1b4825ca2df89c$var$_Widget2 = $0a1b4825ca2df89c$var$_interopRequireDefault($ikauB);

var $il45H = parcelRequire("il45H");
var $0a1b4825ca2df89c$var$_Input2 = $0a1b4825ca2df89c$var$_interopRequireDefault($il45H);

var $7Zb8H = parcelRequire("7Zb8H");
var $0a1b4825ca2df89c$var$_Select2 = $0a1b4825ca2df89c$var$_interopRequireDefault($7Zb8H);

var $htaAL = parcelRequire("htaAL");
var $0a1b4825ca2df89c$var$_DropdownListInput2 = $0a1b4825ca2df89c$var$_interopRequireDefault($htaAL);

var $iXqdK = parcelRequire("iXqdK");
var $0a1b4825ca2df89c$var$_Popup2 = $0a1b4825ca2df89c$var$_interopRequireDefault($iXqdK);

var $gl4B1 = parcelRequire("gl4B1");
var $0a1b4825ca2df89c$var$_compat2 = $0a1b4825ca2df89c$var$_interopRequireDefault($gl4B1);

var $iMXz6 = parcelRequire("iMXz6");
var $0a1b4825ca2df89c$var$_propTypes4 = $0a1b4825ca2df89c$var$_interopRequireDefault($iMXz6);

var $dPmvq = parcelRequire("dPmvq");
var $0a1b4825ca2df89c$var$_List2 = $0a1b4825ca2df89c$var$_interopRequireDefault($dPmvq);

var $kNt4v = parcelRequire("kNt4v");
var $0a1b4825ca2df89c$var$_ListGroupable2 = $0a1b4825ca2df89c$var$_interopRequireDefault($kNt4v);

var $eqJK2 = parcelRequire("eqJK2");
var $0a1b4825ca2df89c$var$_validateListInterface2 = $0a1b4825ca2df89c$var$_interopRequireDefault($eqJK2);

var $12xR0 = parcelRequire("12xR0");
var $0a1b4825ca2df89c$var$_uncontrollable2 = $0a1b4825ca2df89c$var$_interopRequireDefault($12xR0);

var $3gVwc = parcelRequire("3gVwc");

var $cQuVG = parcelRequire("cQuVG");

var $9yNJk = parcelRequire("9yNJk");
function $0a1b4825ca2df89c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0a1b4825ca2df89c$var$_applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object["keys"](descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ("value" in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object["defineProperty"](target, property, desc);
        desc = null;
    }
    return desc;
}
var $0a1b4825ca2df89c$var$result = $0a1b4825ca2df89c$var$_3.default.result;
var $0a1b4825ca2df89c$var$propTypes = $0a1b4825ca2df89c$var$_extends({}, $0a1b4825ca2df89c$var$_Popup2.default.propTypes, {
    //-- controlled props -----------
    value: $0a1b4825ca2df89c$var$_propTypes2.default.any,
    onChange: $0a1b4825ca2df89c$var$_propTypes2.default.func,
    open: $0a1b4825ca2df89c$var$_propTypes2.default.bool,
    onToggle: $0a1b4825ca2df89c$var$_propTypes2.default.func,
    //------------------------------------
    data: $0a1b4825ca2df89c$var$_propTypes2.default.array,
    valueField: $0a1b4825ca2df89c$var$_propTypes2.default.string,
    textField: $0a1b4825ca2df89c$var$_propTypes4.default.accessor,
    valueComponent: $0a1b4825ca2df89c$var$_propTypes4.default.elementType,
    itemComponent: $0a1b4825ca2df89c$var$_propTypes4.default.elementType,
    listComponent: $0a1b4825ca2df89c$var$_propTypes4.default.elementType,
    groupComponent: $0a1b4825ca2df89c$var$_propTypes4.default.elementType,
    groupBy: $0a1b4825ca2df89c$var$_propTypes4.default.accessor,
    onSelect: $0a1b4825ca2df89c$var$_propTypes2.default.func,
    searchTerm: $0a1b4825ca2df89c$var$_propTypes2.default.string,
    onSearch: $0a1b4825ca2df89c$var$_propTypes2.default.func,
    busy: $0a1b4825ca2df89c$var$_propTypes2.default.bool,
    delay: $0a1b4825ca2df89c$var$_propTypes2.default.number,
    dropUp: $0a1b4825ca2df89c$var$_propTypes2.default.bool,
    duration: $0a1b4825ca2df89c$var$_propTypes2.default.number,
    disabled: $0a1b4825ca2df89c$var$_propTypes4.default.disabled.acceptsArray,
    readOnly: $0a1b4825ca2df89c$var$_propTypes4.default.readOnly.acceptsArray,
    messages: $0a1b4825ca2df89c$var$_propTypes2.default.shape({
        open: $0a1b4825ca2df89c$var$_propTypes4.default.message,
        emptyList: $0a1b4825ca2df89c$var$_propTypes4.default.message,
        emptyFilter: $0a1b4825ca2df89c$var$_propTypes4.default.message,
        filterPlaceholder: $0a1b4825ca2df89c$var$_propTypes4.default.message
    })
});








var $0a1b4825ca2df89c$var$DropdownList = (0, $0a1b4825ca2df89c$var$_createReactClass2.default)(($0a1b4825ca2df89c$var$_obj = {
    displayName: "DropdownList",
    mixins: [
        (parcelRequire("7Hmlb")),
        (parcelRequire("gYehs")),
        (parcelRequire("7xDAs")),
        (parcelRequire("asC0i")),
        (parcelRequire("602jV")),
        (parcelRequire("h64ZC")),
        (parcelRequire("aU65n"))(),
        (parcelRequire("eC1mP"))({
            didHandle: function didHandle(focused) {
                if (!focused) this.close();
            }
        })
    ],
    propTypes: $0a1b4825ca2df89c$var$propTypes,
    getDefaultProps: function getDefaultProps() {
        return {
            delay: 500,
            value: "",
            open: false,
            data: [],
            searchTerm: "",
            messages: $0a1b4825ca2df89c$var$msgs(),
            ariaActiveDescendantKey: "dropdownlist"
        };
    },
    getInitialState: function getInitialState() {
        var _props = this.props, open = _props.open, filter = _props.filter, value = _props.value, data = _props.data, searchTerm = _props.searchTerm, valueField = _props.valueField;
        var processed = filter ? this.filter(data, searchTerm) : data, initialIdx = (0, $3gVwc.dataIndexOf)(data, value, valueField);
        return {
            filteredData: open && filter ? processed : null,
            selectedItem: processed[initialIdx],
            focusedItem: processed[initialIdx] || data[0]
        };
    },
    componentDidUpdate: function componentDidUpdate() {
        this.refs.list && (0, $0a1b4825ca2df89c$var$_validateListInterface2.default)(this.refs.list);
    },
    componentWillReceiveProps: function componentWillReceiveProps(props) {
        var open = props.open, filter = props.filter, value = props.value, data = props.data, searchTerm = props.searchTerm, valueField = props.valueField;
        var processed = filter ? this.filter(data, searchTerm) : data, idx = (0, $3gVwc.dataIndexOf)(data, value, valueField);
        this.setState({
            filteredData: open && filter ? processed : null,
            selectedItem: processed[idx],
            focusedItem: processed[!~idx ? 0 : idx]
        });
    },
    renderFilter: function renderFilter(messages) {
        var _this = this;
        return $0a1b4825ca2df89c$var$_react2.default.createElement("div", {
            ref: "filterWrapper",
            className: "rw-filter-input"
        }, $0a1b4825ca2df89c$var$_react2.default.createElement($0a1b4825ca2df89c$var$_Select2.default, {
            component: "span",
            icon: "search"
        }), $0a1b4825ca2df89c$var$_react2.default.createElement($0a1b4825ca2df89c$var$_Input2.default, {
            ref: "filter",
            value: this.props.searchTerm,
            placeholder: $0a1b4825ca2df89c$var$_3.default.result(messages.filterPlaceholder, this.props),
            onChange: function onChange(e) {
                return (0, $9yNJk.notify)(_this.props.onSearch, e.target.value);
            }
        }));
    },
    renderList: function renderList(List, id, messages) {
        var _props2 = this.props, open = _props2.open, filter = _props2.filter, data = _props2.data;
        var _state = this.state, selectedItem = _state.selectedItem, focusedItem = _state.focusedItem;
        var listProps = $0a1b4825ca2df89c$var$_3.default.pickProps(this.props, List);
        var items = this._data();
        return $0a1b4825ca2df89c$var$_react2.default.createElement("div", null, filter && this.renderFilter(messages), $0a1b4825ca2df89c$var$_react2.default.createElement(List, $0a1b4825ca2df89c$var$_extends({}, listProps, {
            ref: "list",
            id: id,
            data: items,
            "aria-live": open && "polite",
            "aria-labelledby": (0, $9yNJk.instanceId)(this),
            "aria-hidden": !this.props.open,
            selected: selectedItem,
            focused: open ? focusedItem : null,
            onSelect: this.handleSelect,
            onMove: this._scrollTo,
            messages: {
                emptyList: data.length ? messages.emptyFilter : messages.emptyList
            }
        })));
    },
    render: function render() {
        var _this2 = this;
        var _props3 = this.props, className = _props3.className, tabIndex = _props3.tabIndex, duration = _props3.duration, valueField = _props3.valueField, textField = _props3.textField, groupBy = _props3.groupBy, messages = _props3.messages, data = _props3.data, busy = _props3.busy, dropUp = _props3.dropUp, placeholder = _props3.placeholder, value = _props3.value, open = _props3.open, valueComponent = _props3.valueComponent, List = _props3.listComponent;
        List = List || groupBy && $0a1b4825ca2df89c$var$_ListGroupable2.default || $0a1b4825ca2df89c$var$_List2.default;
        var focused = this.state.focused;
        var disabled = (0, $cQuVG.isDisabled)(this.props), readOnly = (0, $cQuVG.isReadOnly)(this.props), valueItem = (0, $3gVwc.dataItem)(data, value, valueField) // take value from the raw data
        , listID = (0, $9yNJk.instanceId)(this, "__listbox");
        var elementProps = $0a1b4825ca2df89c$var$_extends($0a1b4825ca2df89c$var$_3.default.omitOwnProps(this, List), {
            role: "combobox",
            tabIndex: tabIndex || 0,
            "aria-owns": listID,
            "aria-expanded": !!open,
            "aria-haspopup": true,
            "aria-busy": !!busy,
            "aria-live": !open && "polite",
            "aria-autocomplete": "list",
            "aria-disabled": disabled,
            "aria-readonly": readOnly
        });
        var shouldRenderPopup = open || (0, $9yNJk.isFirstFocusedRender)(this);
        messages = $0a1b4825ca2df89c$var$msgs(messages);
        return $0a1b4825ca2df89c$var$_react2.default.createElement($0a1b4825ca2df89c$var$_Widget2.default, $0a1b4825ca2df89c$var$_extends({}, elementProps, {
            ref: "input",
            className: (0, $0a1b4825ca2df89c$var$_classnames2.default)(className, "rw-dropdownlist"),
            open: open,
            dropUp: dropUp,
            focused: focused,
            disabled: disabled,
            readOnly: readOnly,
            onBlur: this.handleBlur,
            onFocus: this.handleFocus,
            onClick: this.handleClick,
            onKeyDown: this.handleKeyDown,
            onKeyPress: this.handleKeyPress
        }), $0a1b4825ca2df89c$var$_react2.default.createElement($0a1b4825ca2df89c$var$_Select2.default, {
            busy: busy,
            icon: "caret-down",
            component: "span",
            className: "rw-dropdownlist-picker",
            label: $0a1b4825ca2df89c$var$result(messages.open, this.props)
        }), $0a1b4825ca2df89c$var$_react2.default.createElement($0a1b4825ca2df89c$var$_DropdownListInput2.default, {
            value: valueItem,
            textField: textField,
            placeholder: placeholder,
            valueComponent: valueComponent
        }), shouldRenderPopup && $0a1b4825ca2df89c$var$_react2.default.createElement($0a1b4825ca2df89c$var$_Popup2.default, {
            open: open,
            dropUp: dropUp,
            duration: duration,
            onOpen: function onOpen() {
                return _this2.focus();
            },
            onOpening: function onOpening() {
                return _this2.refs.list.forceUpdate();
            }
        }, this.renderList(List, listID, messages)));
    },
    handleSelect: function handleSelect(data) {
        this.close();
        (0, $9yNJk.notify)(this.props.onSelect, data);
        this.change(data);
        this.focus(this);
    },
    handleClick: function handleClick(e) {
        var wrapper = this.refs.filterWrapper;
        if (!this.props.filter || !this.props.open) this.toggle();
        else if (!(0, $0a1b4825ca2df89c$var$_contains2.default)($0a1b4825ca2df89c$var$_compat2.default.findDOMNode(wrapper), e.target)) this.close();
        (0, $9yNJk.notify)(this.props.onClick, e);
    },
    handleKeyDown: function handleKeyDown(e) {
        var _this3 = this;
        var key = e.key, alt = e.altKey, list = this.refs.list, filtering = this.props.filter, focusedItem = this.state.focusedItem, selectedItem = this.state.selectedItem, isOpen = this.props.open, closeWithFocus = function closeWithFocus() {
            _this3.close(), $0a1b4825ca2df89c$var$_compat2.default.findDOMNode(_this3).focus();
        };
        (0, $9yNJk.notify)(this.props.onKeyDown, [
            e
        ]);
        var change = function change(item, fromList) {
            if (item == null) return;
            fromList ? _this3.handleSelect(item) : _this3.change(item);
        };
        if (e.defaultPrevented) return;
        if (key === "End") {
            e.preventDefault();
            if (isOpen) this.setState({
                focusedItem: list.last()
            });
            else change(list.last());
        } else if (key === "Home") {
            e.preventDefault();
            if (isOpen) this.setState({
                focusedItem: list.first()
            });
            else change(list.first());
        } else if (key === "Escape" && isOpen) {
            e.preventDefault();
            closeWithFocus();
        } else if ((key === "Enter" || key === " " && !filtering) && isOpen) {
            e.preventDefault();
            change(this.state.focusedItem, true);
        } else if (key === " " && !filtering && !isOpen) {
            e.preventDefault();
            this.open();
        } else if (key === "ArrowDown") {
            if (alt) this.open();
            else if (isOpen) this.setState({
                focusedItem: list.next(focusedItem)
            });
            else change(list.next(selectedItem));
            e.preventDefault();
        } else if (key === "ArrowUp") {
            if (alt) closeWithFocus();
            else if (isOpen) this.setState({
                focusedItem: list.prev(focusedItem)
            });
            else change(list.prev(selectedItem));
            e.preventDefault();
        }
    },
    handleKeyPress: function handleKeyPress(e) {
        var _this4 = this;
        (0, $9yNJk.notify)(this.props.onKeyPress, [
            e
        ]);
        if (e.defaultPrevented) return;
        if (!(this.props.filter && this.props.open)) this.search(String.fromCharCode(e.which), function(item) {
            _this4._mounted && _this4.props.open ? _this4.setState({
                focusedItem: item
            }) : item && _this4.change(item);
        });
    },
    change: function change(data) {
        if (!(0, $3gVwc.valueMatcher)(data, this.props.value, this.props.valueField)) {
            (0, $9yNJk.notify)(this.props.onChange, data);
            (0, $9yNJk.notify)(this.props.onSearch, "");
            this.close();
        }
    },
    focus: function focus(target) {
        var _props4 = this.props, filter = _props4.filter, open = _props4.open;
        var inst = target || (filter && open ? this.refs.filter : this.refs.input);
        inst = $0a1b4825ca2df89c$var$_compat2.default.findDOMNode(inst);
        if ((0, $0a1b4825ca2df89c$var$_activeElement2.default)() !== inst) inst.focus();
    },
    _data: function _data() {
        return this.state.filteredData || this.props.data.concat();
    },
    search: function search(character, cb) {
        var _this5 = this;
        var word = ((this._searchTerm || "") + character).toLowerCase();
        if (!character) return;
        this._searchTerm = word;
        this.setTimeout("search", function() {
            var list = _this5.refs.list, key = _this5.props.open ? "focusedItem" : "selectedItem", item = list.next(_this5.state[key], word);
            _this5._searchTerm = "";
            if (item) cb(item);
        }, this.props.delay);
    },
    open: function open() {
        (0, $9yNJk.notify)(this.props.onToggle, true);
    },
    close: function close() {
        (0, $9yNJk.notify)(this.props.onToggle, false);
    },
    toggle: function toggle() {
        this.props.open ? this.close() : this.open();
    }
}, $0a1b4825ca2df89c$var$_applyDecoratedDescriptor($0a1b4825ca2df89c$var$_obj, "handleSelect", [
    $cQuVG.widgetEditable
], Object.getOwnPropertyDescriptor($0a1b4825ca2df89c$var$_obj, "handleSelect"), $0a1b4825ca2df89c$var$_obj), $0a1b4825ca2df89c$var$_applyDecoratedDescriptor($0a1b4825ca2df89c$var$_obj, "handleClick", [
    $cQuVG.widgetEditable
], Object.getOwnPropertyDescriptor($0a1b4825ca2df89c$var$_obj, "handleClick"), $0a1b4825ca2df89c$var$_obj), $0a1b4825ca2df89c$var$_applyDecoratedDescriptor($0a1b4825ca2df89c$var$_obj, "handleKeyDown", [
    $cQuVG.widgetEditable
], Object.getOwnPropertyDescriptor($0a1b4825ca2df89c$var$_obj, "handleKeyDown"), $0a1b4825ca2df89c$var$_obj), $0a1b4825ca2df89c$var$_applyDecoratedDescriptor($0a1b4825ca2df89c$var$_obj, "handleKeyPress", [
    $cQuVG.widgetEditable
], Object.getOwnPropertyDescriptor($0a1b4825ca2df89c$var$_obj, "handleKeyPress"), $0a1b4825ca2df89c$var$_obj), $0a1b4825ca2df89c$var$_obj));
function $0a1b4825ca2df89c$var$msgs(msgs) {
    return $0a1b4825ca2df89c$var$_extends({
        open: "open dropdown",
        filterPlaceholder: "",
        emptyList: "There are no items in this list",
        emptyFilter: "The filter returned no results"
    }, msgs);
}
module.exports.default = (0, $0a1b4825ca2df89c$var$_uncontrollable2.default)($0a1b4825ca2df89c$var$DropdownList, {
    open: "onToggle",
    value: "onChange",
    searchTerm: "onSearch"
}, [
    "focus"
]);
module.exports = module.exports["default"];

});
parcelRegister("4ToXx", function(module, exports) {
"use strict";

var $5iLKY = parcelRequire("5iLKY");
module.exports.__esModule = true;
/**
 * document.activeElement
 */ module.exports["default"] = $38ffa8e026714772$var$activeElement;

var $aYFuH = parcelRequire("aYFuH");
var $38ffa8e026714772$var$_ownerDocument2 = $5iLKY.interopRequireDefault($aYFuH);
function $38ffa8e026714772$var$activeElement() {
    var doc = arguments[0] === undefined ? document : arguments[0];
    try {
        return doc.activeElement;
    } catch (e) {}
}
module.exports = module.exports["default"];

});
parcelRegister("aYFuH", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = $7fdfb1e04dfbda65$var$ownerDocument;
function $7fdfb1e04dfbda65$var$ownerDocument(node) {
    return node && node.ownerDocument || document;
}
module.exports = module.exports["default"];

});


parcelRegister("6s6kw", function(module, exports) {
"use strict";

var $uyd6r = parcelRequire("uyd6r");
var $4b2a449f0d920bb6$var$contains = function() {
    var root = $uyd6r && document.documentElement;
    return root && root.contains ? function(context, node) {
        return context.contains(node);
    } : root && root.compareDocumentPosition ? function(context, node) {
        return context === node || !!(context.compareDocumentPosition(node) & 16);
    } : function(context, node) {
        if (node) do {
            if (node === context) return true;
        }while (node = node.parentNode);
        return false;
    };
}();
module.exports = $4b2a449f0d920bb6$var$contains;

});

parcelRegister("ikauB", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $d5723bd65a03a14b$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $d5723bd65a03a14b$var$_class, $d5723bd65a03a14b$var$_temp;

var $jbmdS = parcelRequire("jbmdS");
var $d5723bd65a03a14b$var$_react2 = $d5723bd65a03a14b$var$_interopRequireDefault($jbmdS);

var $2MXkj = parcelRequire("2MXkj");
var $d5723bd65a03a14b$var$_propTypes2 = $d5723bd65a03a14b$var$_interopRequireDefault($2MXkj);

var $02LyB = parcelRequire("02LyB");
var $d5723bd65a03a14b$var$_classnames2 = $d5723bd65a03a14b$var$_interopRequireDefault($02LyB);
function $d5723bd65a03a14b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d5723bd65a03a14b$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $d5723bd65a03a14b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d5723bd65a03a14b$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $d5723bd65a03a14b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $d5723bd65a03a14b$var$Widget = ($d5723bd65a03a14b$var$_temp = $d5723bd65a03a14b$var$_class = function(_React$Component) {
    $d5723bd65a03a14b$var$_inherits(Widget, _React$Component);
    function Widget() {
        $d5723bd65a03a14b$var$_classCallCheck(this, Widget);
        return $d5723bd65a03a14b$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }
    Widget.prototype.render = function render() {
        var _props = this.props, className = _props.className, tabIndex = _props.tabIndex, open = _props.open, dropUp = _props.dropUp, disabled = _props.disabled, readOnly = _props.readOnly, focused = _props.focused, props = $d5723bd65a03a14b$var$_objectWithoutProperties(_props, [
            "className",
            "tabIndex",
            "open",
            "dropUp",
            "disabled",
            "readOnly",
            "focused"
        ]);
        var isRtl = !!this.context.isRtl;
        var openClass = "rw-open" + (dropUp ? "-up" : "");
        tabIndex = tabIndex != null ? tabIndex : "-1";
        return $d5723bd65a03a14b$var$_react2.default.createElement("div", $d5723bd65a03a14b$var$_extends({}, props, {
            tabIndex: tabIndex,
            className: (0, $d5723bd65a03a14b$var$_classnames2.default)(className, "rw-widget", isRtl && "rw-rtl", open && openClass, focused && "rw-state-focus", disabled && "rw-state-disabled", readOnly && "rw-state-readonly")
        }));
    };
    return Widget;
}($d5723bd65a03a14b$var$_react2.default.Component), $d5723bd65a03a14b$var$_class.propTypes = {
    tabIndex: $d5723bd65a03a14b$var$_propTypes2.default.node,
    focused: $d5723bd65a03a14b$var$_propTypes2.default.bool,
    disabled: $d5723bd65a03a14b$var$_propTypes2.default.bool,
    readOnly: $d5723bd65a03a14b$var$_propTypes2.default.bool,
    open: $d5723bd65a03a14b$var$_propTypes2.default.bool,
    dropUp: $d5723bd65a03a14b$var$_propTypes2.default.bool
}, $d5723bd65a03a14b$var$_class.contextTypes = {
    isRtl: $d5723bd65a03a14b$var$_propTypes2.default.bool
}, $d5723bd65a03a14b$var$_temp);
module.exports.default = $d5723bd65a03a14b$var$Widget;
module.exports = module.exports["default"];

});

parcelRegister("il45H", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $d59d5c878d2e24f2$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $jbmdS = parcelRequire("jbmdS");
var $d59d5c878d2e24f2$var$_react2 = $d59d5c878d2e24f2$var$_interopRequireDefault($jbmdS);

var $02LyB = parcelRequire("02LyB");
var $d59d5c878d2e24f2$var$_classnames2 = $d59d5c878d2e24f2$var$_interopRequireDefault($02LyB);
function $d59d5c878d2e24f2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d59d5c878d2e24f2$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $d59d5c878d2e24f2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d59d5c878d2e24f2$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $d59d5c878d2e24f2$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $d59d5c878d2e24f2$var$Input = function(_React$Component) {
    $d59d5c878d2e24f2$var$_inherits(Input, _React$Component);
    function Input() {
        $d59d5c878d2e24f2$var$_classCallCheck(this, Input);
        return $d59d5c878d2e24f2$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }
    Input.prototype.render = function render() {
        var _props = this.props, className = _props.className, disabled = _props.disabled, readOnly = _props.readOnly, value = _props.value, tabIndex = _props.tabIndex, _props$component = _props.component, Component = _props$component === undefined ? "input" : _props$component, props = $d59d5c878d2e24f2$var$_objectWithoutProperties(_props, [
            "className",
            "disabled",
            "readOnly",
            "value",
            "tabIndex",
            "component"
        ]);
        return $d59d5c878d2e24f2$var$_react2.default.createElement(Component, $d59d5c878d2e24f2$var$_extends({}, props, {
            type: "text",
            tabIndex: tabIndex || 0,
            autoComplete: "off",
            disabled: disabled,
            readOnly: readOnly,
            "aria-disabled": disabled,
            "aria-readonly": readOnly,
            value: value == null ? "" : value,
            className: (0, $d59d5c878d2e24f2$var$_classnames2.default)(className, "rw-input")
        }));
    };
    return Input;
}($d59d5c878d2e24f2$var$_react2.default.Component);
module.exports.default = $d59d5c878d2e24f2$var$Input;
module.exports = module.exports["default"];

});

parcelRegister("7Zb8H", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $5d06deefa8fe8bde$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $jbmdS = parcelRequire("jbmdS");
var $5d06deefa8fe8bde$var$_react2 = $5d06deefa8fe8bde$var$_interopRequireDefault($jbmdS);

var $02LyB = parcelRequire("02LyB");
var $5d06deefa8fe8bde$var$_classnames2 = $5d06deefa8fe8bde$var$_interopRequireDefault($02LyB);

var $lPWfx = parcelRequire("lPWfx");
var $5d06deefa8fe8bde$var$_Button2 = $5d06deefa8fe8bde$var$_interopRequireDefault($lPWfx);
function $5d06deefa8fe8bde$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5d06deefa8fe8bde$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $5d06deefa8fe8bde$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5d06deefa8fe8bde$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $5d06deefa8fe8bde$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $5d06deefa8fe8bde$var$Select = function(_React$Component) {
    $5d06deefa8fe8bde$var$_inherits(Select, _React$Component);
    function Select() {
        $5d06deefa8fe8bde$var$_classCallCheck(this, Select);
        return $5d06deefa8fe8bde$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }
    Select.prototype.render = function render() {
        var _props = this.props, className = _props.className, props = $5d06deefa8fe8bde$var$_objectWithoutProperties(_props, [
            "className"
        ]);
        return $5d06deefa8fe8bde$var$_react2.default.createElement($5d06deefa8fe8bde$var$_Button2.default, $5d06deefa8fe8bde$var$_extends({}, props, {
            className: (0, $5d06deefa8fe8bde$var$_classnames2.default)(className, "rw-select")
        }));
    };
    return Select;
}($5d06deefa8fe8bde$var$_react2.default.Component);
module.exports.default = $5d06deefa8fe8bde$var$Select;
module.exports = module.exports["default"];

});
parcelRegister("lPWfx", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $fe5b8b8a86595104$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $jbmdS = parcelRequire("jbmdS");
var $fe5b8b8a86595104$var$_react2 = $fe5b8b8a86595104$var$_interopRequireDefault($jbmdS);

var $02LyB = parcelRequire("02LyB");
var $fe5b8b8a86595104$var$_classnames2 = $fe5b8b8a86595104$var$_interopRequireDefault($02LyB);
function $fe5b8b8a86595104$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fe5b8b8a86595104$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $fe5b8b8a86595104$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $fe5b8b8a86595104$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $fe5b8b8a86595104$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $fe5b8b8a86595104$var$Button = function(_React$Component) {
    $fe5b8b8a86595104$var$_inherits(Button, _React$Component);
    function Button() {
        $fe5b8b8a86595104$var$_classCallCheck(this, Button);
        return $fe5b8b8a86595104$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }
    Button.prototype.render = function render() {
        var _props = this.props, className = _props.className, disabled = _props.disabled, label = _props.label, icon = _props.icon, busy = _props.busy, active = _props.active, children = _props.children, _props$component = _props.component, Tag = _props$component === undefined ? "button" : _props$component, props = $fe5b8b8a86595104$var$_objectWithoutProperties(_props, [
            "className",
            "disabled",
            "label",
            "icon",
            "busy",
            "active",
            "children",
            "component"
        ]);
        var type = props.type;
        if (Tag === "button") type = type || "button";
        return $fe5b8b8a86595104$var$_react2.default.createElement(Tag, $fe5b8b8a86595104$var$_extends({}, props, {
            tabIndex: "-1",
            title: label,
            type: type,
            disabled: disabled,
            "aria-disabled": disabled,
            "aria-label": label,
            className: (0, $fe5b8b8a86595104$var$_classnames2.default)(className, "rw-btn", active && !disabled && "rw-state-active")
        }), icon && $fe5b8b8a86595104$var$_react2.default.createElement("span", {
            "aria-hidden": true,
            className: (0, $fe5b8b8a86595104$var$_classnames2.default)("rw-i", "rw-i-" + icon, busy && "rw-loading")
        }), children);
    };
    return Button;
}($fe5b8b8a86595104$var$_react2.default.Component);
module.exports.default = $fe5b8b8a86595104$var$Button;
module.exports = module.exports["default"];

});


parcelRegister("htaAL", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $cb7d5c7137de9fbd$var$_class, $cb7d5c7137de9fbd$var$_temp;

var $jbmdS = parcelRequire("jbmdS");
var $cb7d5c7137de9fbd$var$_react2 = $cb7d5c7137de9fbd$var$_interopRequireDefault($jbmdS);

var $2MXkj = parcelRequire("2MXkj");
var $cb7d5c7137de9fbd$var$_propTypes2 = $cb7d5c7137de9fbd$var$_interopRequireDefault($2MXkj);

var $iMXz6 = parcelRequire("iMXz6");
var $cb7d5c7137de9fbd$var$_propTypes4 = $cb7d5c7137de9fbd$var$_interopRequireDefault($iMXz6);

var $3gVwc = parcelRequire("3gVwc");
function $cb7d5c7137de9fbd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cb7d5c7137de9fbd$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $cb7d5c7137de9fbd$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $cb7d5c7137de9fbd$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $cb7d5c7137de9fbd$var$DropdownListInput = ($cb7d5c7137de9fbd$var$_temp = $cb7d5c7137de9fbd$var$_class = function(_React$Component) {
    $cb7d5c7137de9fbd$var$_inherits(DropdownListInput, _React$Component);
    function DropdownListInput() {
        $cb7d5c7137de9fbd$var$_classCallCheck(this, DropdownListInput);
        return $cb7d5c7137de9fbd$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }
    DropdownListInput.prototype.render = function render() {
        var _props = this.props, placeholder = _props.placeholder, value = _props.value, textField = _props.textField, Component = _props.valueComponent;
        return $cb7d5c7137de9fbd$var$_react2.default.createElement("div", {
            className: "rw-input"
        }, !value && placeholder ? $cb7d5c7137de9fbd$var$_react2.default.createElement("span", {
            className: "rw-placeholder"
        }, placeholder) : Component ? $cb7d5c7137de9fbd$var$_react2.default.createElement(Component, {
            item: value
        }) : (0, $3gVwc.dataText)(value, textField));
    };
    return DropdownListInput;
}($cb7d5c7137de9fbd$var$_react2.default.Component), $cb7d5c7137de9fbd$var$_class.propTypes = {
    value: $cb7d5c7137de9fbd$var$_propTypes2.default.any,
    placeholder: $cb7d5c7137de9fbd$var$_propTypes2.default.string,
    textField: $cb7d5c7137de9fbd$var$_propTypes4.default.accessor,
    valueComponent: $cb7d5c7137de9fbd$var$_propTypes4.default.elementType
}, $cb7d5c7137de9fbd$var$_temp);
module.exports.default = $cb7d5c7137de9fbd$var$DropdownListInput;
module.exports = module.exports["default"];

});
parcelRegister("iMXz6", function(module, exports) {
"use strict";

var $jbmdS = parcelRequire("jbmdS");
var $dadaea10fb503e43$var$_react2 = $dadaea10fb503e43$var$_interopRequireDefault($jbmdS);

var $2MXkj = parcelRequire("2MXkj");
var $dadaea10fb503e43$var$_propTypes2 = $dadaea10fb503e43$var$_interopRequireDefault($2MXkj);

var $7fTd5 = parcelRequire("7fTd5");
var $dadaea10fb503e43$var$_localizers2 = $dadaea10fb503e43$var$_interopRequireDefault($7fTd5);

var $f8Des = parcelRequire("f8Des");
var $dadaea10fb503e43$var$_filter2 = $dadaea10fb503e43$var$_interopRequireDefault($f8Des);
function $dadaea10fb503e43$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $dadaea10fb503e43$var$filterTypes = Object.keys($dadaea10fb503e43$var$_filter2.default).filter(function(i) {
    return i !== "filter";
});
function $dadaea10fb503e43$var$getInteractionPropType(key) {
    var types = [
        $dadaea10fb503e43$var$_propTypes2.default.bool,
        $dadaea10fb503e43$var$_propTypes2.default.oneOf([
            key
        ])
    ], propType = $dadaea10fb503e43$var$_propTypes2.default.oneOfType(types);
    propType.acceptsArray = $dadaea10fb503e43$var$_propTypes2.default.oneOfType(types.concat($dadaea10fb503e43$var$_propTypes2.default.array));
    return propType;
}
module.exports = {
    elementType: $dadaea10fb503e43$var$createChainableTypeChecker(function(props, propName, componentName) {
        if (typeof props[propName] !== "function") {
            if ($dadaea10fb503e43$var$_react2.default.isValidElement(props[propName])) return new Error("Invalid prop `" + propName + "` specified in  `" + componentName + "`." + " Expected an Element `type`, not an actual Element");
            if (typeof props[propName] !== "string") return new Error("Invalid prop `" + propName + "` specified in  `" + componentName + "`." + " Expected an Element `type` such as a tag name or return value of createReactClass(...)");
        }
        return null;
    }),
    numberFormat: $dadaea10fb503e43$var$createChainableTypeChecker(function() {
        var _localizers$number;
        return (_localizers$number = $dadaea10fb503e43$var$_localizers2.default.number).propType.apply(_localizers$number, arguments);
    }),
    dateFormat: $dadaea10fb503e43$var$createChainableTypeChecker(function() {
        var _localizers$date;
        return (_localizers$date = $dadaea10fb503e43$var$_localizers2.default.date).propType.apply(_localizers$date, arguments);
    }),
    disabled: $dadaea10fb503e43$var$getInteractionPropType("disabled"),
    readOnly: $dadaea10fb503e43$var$getInteractionPropType("readOnly"),
    accessor: $dadaea10fb503e43$var$_propTypes2.default.oneOfType([
        $dadaea10fb503e43$var$_propTypes2.default.string,
        $dadaea10fb503e43$var$_propTypes2.default.func
    ]),
    message: $dadaea10fb503e43$var$_propTypes2.default.oneOfType([
        $dadaea10fb503e43$var$_propTypes2.default.node,
        $dadaea10fb503e43$var$_propTypes2.default.string
    ]),
    filter: $dadaea10fb503e43$var$_propTypes2.default.oneOfType([
        $dadaea10fb503e43$var$_propTypes2.default.func,
        $dadaea10fb503e43$var$_propTypes2.default.bool,
        $dadaea10fb503e43$var$_propTypes2.default.oneOf($dadaea10fb503e43$var$filterTypes)
    ])
};
function $dadaea10fb503e43$var$createChainableTypeChecker(validate) {
    function checkType(isRequired, props, propName, componentName) {
        componentName = componentName || "<<anonymous>>";
        for(var _len = arguments.length, args = Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++)args[_key - 4] = arguments[_key];
        if (props[propName] == null) {
            if (isRequired) return new Error("Required prop `" + propName + "` was not specified in  `" + componentName + "`.");
        } else return validate.apply(undefined, [
            props,
            propName,
            componentName
        ].concat(args));
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}

});
parcelRegister("f8Des", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $b0560912536d49bb$var$common = {
    eq: function eq(a, b) {
        return a === b;
    },
    neq: function neq(a, b) {
        return a !== b;
    },
    gt: function gt(a, b) {
        return a > b;
    },
    gte: function gte(a, b) {
        return a >= b;
    },
    lt: function lt(a, b) {
        return a < b;
    },
    lte: function lte(a, b) {
        return a <= b;
    },
    contains: function contains(a, b) {
        return a.indexOf(b) !== -1;
    },
    startsWith: function startsWith(a, b) {
        return a.lastIndexOf(b, 0) === 0;
    },
    endsWith: function endsWith(a, b) {
        var pos = a.length - b.length, lastIndex = a.indexOf(b, pos);
        return lastIndex !== -1 && lastIndex === pos;
    }
};
module.exports.default = $b0560912536d49bb$var$common;
module.exports = module.exports["default"];

});


parcelRegister("3gVwc", function(module, exports) {

$parcel$export(module.exports, "dataValue", function () { return $261f7babace6c98b$export$5b778755b18e3df6; }, function (v) { return $261f7babace6c98b$export$5b778755b18e3df6 = v; });
$parcel$export(module.exports, "dataText", function () { return $261f7babace6c98b$export$681c486861d21a35; }, function (v) { return $261f7babace6c98b$export$681c486861d21a35 = v; });
$parcel$export(module.exports, "dataIndexOf", function () { return $261f7babace6c98b$export$cbe71908c8876c47; }, function (v) { return $261f7babace6c98b$export$cbe71908c8876c47 = v; });
$parcel$export(module.exports, "valueMatcher", function () { return $261f7babace6c98b$export$7ea29c9eab6647da; }, function (v) { return $261f7babace6c98b$export$7ea29c9eab6647da = v; });
$parcel$export(module.exports, "dataItem", function () { return $261f7babace6c98b$export$d45376104c4ecf1a; }, function (v) { return $261f7babace6c98b$export$d45376104c4ecf1a = v; });
var $261f7babace6c98b$export$1e511d4a378977f5;
var $261f7babace6c98b$export$5b778755b18e3df6;
var $261f7babace6c98b$export$681c486861d21a35;
var $261f7babace6c98b$export$cbe71908c8876c47;
var $261f7babace6c98b$export$7ea29c9eab6647da;
var $261f7babace6c98b$export$d45376104c4ecf1a;
"use strict";
$261f7babace6c98b$export$1e511d4a378977f5 = true;
var $261f7babace6c98b$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
$261f7babace6c98b$export$5b778755b18e3df6 = $261f7babace6c98b$var$dataValue;
$261f7babace6c98b$export$681c486861d21a35 = $261f7babace6c98b$var$dataText;
$261f7babace6c98b$export$cbe71908c8876c47 = $261f7babace6c98b$var$dataIndexOf;
$261f7babace6c98b$export$7ea29c9eab6647da = $261f7babace6c98b$var$valueMatcher;
$261f7babace6c98b$export$d45376104c4ecf1a = $261f7babace6c98b$var$dataItem;

var $4ELyG = parcelRequire("4ELyG");
function $261f7babace6c98b$var$accessor(data, field) {
    var value = data;
    if (typeof field === "function") value = field(data);
    else if (data == null) value = data;
    else if (typeof field === "string" && (typeof data === "undefined" ? "undefined" : $261f7babace6c98b$var$_typeof(data)) === "object" && field in data) value = data[field];
    return value;
}
function $261f7babace6c98b$var$dataValue(item, valueField) {
    return valueField && item && (0, $4ELyG.has)(item, valueField) ? item[valueField] : item;
}
function $261f7babace6c98b$var$dataText(item, textField) {
    var value = $261f7babace6c98b$var$accessor(item, textField);
    return value == null ? "" : value + "";
}
function $261f7babace6c98b$var$dataIndexOf(data, item, valueField) {
    var idx = -1, len = data.length, isValueEqual = function isValueEqual(datum) {
        return $261f7babace6c98b$var$valueMatcher(item, datum, valueField);
    };
    while(++idx < len){
        var datum = data[idx];
        if (datum === item || isValueEqual(datum)) return idx;
    }
    return -1;
}
/**
 * I don't know that the shallow equal makes sense here but am too afraid to
 * remove it.
 */ function $261f7babace6c98b$var$valueMatcher(a, b, valueField) {
    return (0, $4ELyG.isShallowEqual)($261f7babace6c98b$var$dataValue(a, valueField), $261f7babace6c98b$var$dataValue(b, valueField));
}
function $261f7babace6c98b$var$dataItem(data, item, valueField) {
    var idx = $261f7babace6c98b$var$dataIndexOf(data, $261f7babace6c98b$var$dataValue(item, valueField), valueField);
    if (idx !== -1) return data[idx];
    return item;
}

});


parcelRegister("iXqdK", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $dcd213955db0094b$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $dcd213955db0094b$var$_OVERFLOW;

var $jbmdS = parcelRequire("jbmdS");
var $dcd213955db0094b$var$_react2 = $dcd213955db0094b$var$_interopRequireDefault($jbmdS);

var $2MXkj = parcelRequire("2MXkj");
var $dcd213955db0094b$var$_propTypes2 = $dcd213955db0094b$var$_interopRequireDefault($2MXkj);

var $e64Mn = parcelRequire("e64Mn");
var $dcd213955db0094b$var$_createReactClass2 = $dcd213955db0094b$var$_interopRequireDefault($e64Mn);

var $4ELyG = parcelRequire("4ELyG");
var $dcd213955db0094b$var$_3 = $dcd213955db0094b$var$_interopRequireDefault($4ELyG);

var $bpvMx = parcelRequire("bpvMx");
var $dcd213955db0094b$var$_style2 = $dcd213955db0094b$var$_interopRequireDefault($bpvMx);

var $a2abb = parcelRequire("a2abb");
var $dcd213955db0094b$var$_height2 = $dcd213955db0094b$var$_interopRequireDefault($a2abb);

var $l6Vee = parcelRequire("l6Vee");
var $dcd213955db0094b$var$_camelizeStyle2 = $dcd213955db0094b$var$_interopRequireDefault($l6Vee);

var $aCqSx = parcelRequire("aCqSx");
var $dcd213955db0094b$var$_configuration2 = $dcd213955db0094b$var$_interopRequireDefault($aCqSx);

var $02LyB = parcelRequire("02LyB");
var $dcd213955db0094b$var$_classnames2 = $dcd213955db0094b$var$_interopRequireDefault($02LyB);

var $gl4B1 = parcelRequire("gl4B1");
var $dcd213955db0094b$var$_compat2 = $dcd213955db0094b$var$_interopRequireDefault($gl4B1);
function $dcd213955db0094b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $dcd213955db0094b$var$transform = (0, $dcd213955db0094b$var$_camelizeStyle2.default)($dcd213955db0094b$var$_configuration2.default.animate.transform);
var $dcd213955db0094b$var$CLOSING = 0, $dcd213955db0094b$var$CLOSED = 1, $dcd213955db0094b$var$OPENING = 2, $dcd213955db0094b$var$OPEN = 3;
function $dcd213955db0094b$var$properties(prop, value) {
    var _ref, _ref2;
    var TRANSLATION_MAP = $dcd213955db0094b$var$_configuration2.default.animate.TRANSLATION_MAP;
    if (TRANSLATION_MAP && TRANSLATION_MAP[prop]) return _ref = {}, _ref[$dcd213955db0094b$var$transform] = TRANSLATION_MAP[prop] + "(" + value + ")", _ref;
    return _ref2 = {}, _ref2[prop] = value, _ref2;
}
var $dcd213955db0094b$var$OVERFLOW = ($dcd213955db0094b$var$_OVERFLOW = {}, $dcd213955db0094b$var$_OVERFLOW[$dcd213955db0094b$var$CLOSED] = "hidden", $dcd213955db0094b$var$_OVERFLOW[$dcd213955db0094b$var$CLOSING] = "hidden", $dcd213955db0094b$var$_OVERFLOW[$dcd213955db0094b$var$OPENING] = "hidden", $dcd213955db0094b$var$_OVERFLOW);
var $dcd213955db0094b$var$propTypes = {
    open: $dcd213955db0094b$var$_propTypes2.default.bool,
    dropUp: $dcd213955db0094b$var$_propTypes2.default.bool,
    duration: $dcd213955db0094b$var$_propTypes2.default.number,
    onClosing: $dcd213955db0094b$var$_propTypes2.default.func,
    onOpening: $dcd213955db0094b$var$_propTypes2.default.func,
    onClose: $dcd213955db0094b$var$_propTypes2.default.func,
    onOpen: $dcd213955db0094b$var$_propTypes2.default.func
};
module.exports.default = (0, $dcd213955db0094b$var$_createReactClass2.default)({
    displayName: "Popup",
    propTypes: $dcd213955db0094b$var$propTypes,
    getInitialState: function getInitialState() {
        return {
            initialRender: true,
            status: this.props.open ? $dcd213955db0094b$var$OPENING : $dcd213955db0094b$var$CLOSED
        };
    },
    getDefaultProps: function getDefaultProps() {
        return {
            duration: 200,
            open: false,
            onClosing: function onClosing() {},
            onOpening: function onOpening() {},
            onClose: function onClose() {},
            onOpen: function onOpen() {}
        };
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        this.setState({
            contentChanged: $dcd213955db0094b$var$childKey(nextProps.children) !== $dcd213955db0094b$var$childKey(this.props.children)
        });
    },
    componentDidMount: function componentDidMount() {
        var _this = this;
        var isOpen = this.state.status === $dcd213955db0094b$var$OPENING;
        $dcd213955db0094b$var$_compat2.default.batchedUpdates(function() {
            _this.setState({
                initialRender: false
            });
            if (isOpen) _this.open();
        });
    },
    componentDidUpdate: function componentDidUpdate(pvProps) {
        var closing = pvProps.open && !this.props.open, opening = !pvProps.open && this.props.open, open = this.props.open, status = this.state.status;
        if (!!pvProps.dropUp !== !!this.props.dropUp) {
            this.cancelNextCallback();
            if (status === $dcd213955db0094b$var$OPENING) this.open();
            if (status === $dcd213955db0094b$var$CLOSING) this.close();
            return;
        }
        if (opening) this.open();
        else if (closing) this.close();
        else if (open) {
            // this.height() returns a floating point number with the desired height
            // for this popup. Because of potential rounding errors in floating point
            // aritmetic we must allow an error margin when comparing to the current
            // state, otherwise we can end up in an infinite loop where the height
            // is never exactly equal to our target value.
            var height = this.height(), diff = Math.abs(height - this.state.height);
            if (isNaN(diff) || diff > 0.1) this.setState({
                height: height
            });
        }
    },
    render: function render() {
        var _props = this.props, className = _props.className, dropUp = _props.dropUp, style = _props.style, _state = this.state, status = _state.status, height = _state.height;
        var overflow = $dcd213955db0094b$var$OVERFLOW[status] || "visible", display = status === $dcd213955db0094b$var$CLOSED ? "none" : "block";
        return $dcd213955db0094b$var$_react2.default.createElement("div", {
            style: $dcd213955db0094b$var$_extends({
                display: display,
                overflow: overflow,
                height: height
            }, style),
            className: (0, $dcd213955db0094b$var$_classnames2.default)(className, "rw-popup-container", dropUp && "rw-dropup", this.isTransitioning() && "rw-popup-animating")
        }, this.renderChildren());
    },
    renderChildren: function renderChildren() {
        if (!this.props.children) return $dcd213955db0094b$var$_react2.default.createElement("span", {
            className: "rw-popup rw-widget"
        });
        var offset = this.getOffsetForStatus(this.state.status), child = $dcd213955db0094b$var$_react2.default.Children.only(this.props.children);
        return (0, $jbmdS.cloneElement)(child, {
            style: $dcd213955db0094b$var$_extends({}, child.props.style, offset, {
                position: this.isTransitioning() ? "absolute" : undefined
            }),
            className: (0, $dcd213955db0094b$var$_classnames2.default)(child.props.className, "rw-popup rw-widget")
        });
    },
    open: function open() {
        var _this2 = this;
        this.cancelNextCallback();
        var el = $dcd213955db0094b$var$_compat2.default.findDOMNode(this).firstChild, height = this.height();
        this.props.onOpening();
        this.safeSetState({
            status: $dcd213955db0094b$var$OPENING,
            height: height
        }, function() {
            var offset = _this2.getOffsetForStatus($dcd213955db0094b$var$OPEN), duration = _this2.props.duration;
            _this2.animate(el, offset, duration, "ease", function() {
                _this2.safeSetState({
                    status: $dcd213955db0094b$var$OPEN
                }, function() {
                    _this2.props.onOpen();
                });
            });
        });
    },
    close: function close() {
        var _this3 = this;
        this.cancelNextCallback();
        var el = $dcd213955db0094b$var$_compat2.default.findDOMNode(this).firstChild, height = this.height();
        this.props.onClosing();
        this.safeSetState({
            status: $dcd213955db0094b$var$CLOSING,
            height: height
        }, function() {
            var offset = _this3.getOffsetForStatus($dcd213955db0094b$var$CLOSED), duration = _this3.props.duration;
            _this3.animate(el, offset, duration, "ease", function() {
                return _this3.safeSetState({
                    status: $dcd213955db0094b$var$CLOSED
                }, function() {
                    _this3.props.onClose();
                });
            });
        });
    },
    getOffsetForStatus: function getOffsetForStatus(status) {
        var _CLOSED$CLOSING$OPENI;
        if (this.state.initialRender) return {};
        var _in = $dcd213955db0094b$var$properties("top", this.props.dropUp ? "100%" : "-100%"), out = $dcd213955db0094b$var$properties("top", 0);
        return (_CLOSED$CLOSING$OPENI = {}, _CLOSED$CLOSING$OPENI[$dcd213955db0094b$var$CLOSED] = _in, _CLOSED$CLOSING$OPENI[$dcd213955db0094b$var$CLOSING] = out, _CLOSED$CLOSING$OPENI[$dcd213955db0094b$var$OPENING] = _in, _CLOSED$CLOSING$OPENI[$dcd213955db0094b$var$OPEN] = out, _CLOSED$CLOSING$OPENI)[status] || {};
    },
    height: function height() {
        var container = $dcd213955db0094b$var$_compat2.default.findDOMNode(this), content = container.firstChild, margin = parseInt((0, $dcd213955db0094b$var$_style2.default)(content, "margin-top"), 10) + parseInt((0, $dcd213955db0094b$var$_style2.default)(content, "margin-bottom"), 10);
        var old = container.style.display, height = void 0;
        container.style.display = "block";
        height = ((0, $dcd213955db0094b$var$_height2.default)(content) || 0) + (isNaN(margin) ? 0 : margin);
        container.style.display = old;
        return height;
    },
    isTransitioning: function isTransitioning() {
        return this.state.status === $dcd213955db0094b$var$OPENING || this.state.status === $dcd213955db0094b$var$CLOSED;
    },
    animate: function animate(el, props, dur, easing, cb) {
        this._transition = $dcd213955db0094b$var$_configuration2.default.animate(el, props, dur, easing, this.setNextCallback(cb));
    },
    cancelNextCallback: function cancelNextCallback() {
        if (this._transition && this._transition.cancel) {
            this._transition.cancel();
            this._transition = null;
        }
        if (this.nextCallback) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    },
    safeSetState: function safeSetState(nextState, callback) {
        this.setState(nextState, this.setNextCallback(callback));
    },
    setNextCallback: function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            return active = false;
        };
        return this.nextCallback;
    }
});
function $dcd213955db0094b$var$childKey(children) {
    var nextChildMapping = $dcd213955db0094b$var$_react2.default.Children.map(children, function(c) {
        return c;
    });
    for(var key in nextChildMapping)return key;
}
module.exports = module.exports["default"];

});
parcelRegister("a2abb", function(module, exports) {
"use strict";

var $bAUeB = parcelRequire("bAUeB");

var $c8UPi = parcelRequire("c8UPi");
module.exports = function height(node, client) {
    var win = $c8UPi(node);
    return win ? win.innerHeight : client ? node.clientHeight : $bAUeB(node).height;
};

});
parcelRegister("bAUeB", function(module, exports) {
"use strict";

var $6s6kw = parcelRequire("6s6kw");

var $c8UPi = parcelRequire("c8UPi");

var $aYFuH = parcelRequire("aYFuH");
module.exports = function offset(node) {
    var doc = $aYFuH(node), win = $c8UPi(doc), docElem = doc && doc.documentElement, box = {
        top: 0,
        left: 0,
        height: 0,
        width: 0
    };
    if (!doc) return;
    // Make sure it's not a disconnected DOM node
    if (!$6s6kw(docElem, node)) return box;
    if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect();
    if (box.width || box.height) box = {
        top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
        left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
        width: (box.width == null ? node.offsetWidth : box.width) || 0,
        height: (box.height == null ? node.offsetHeight : box.height) || 0
    };
    return box;
};

});
parcelRegister("c8UPi", function(module, exports) {
"use strict";
module.exports = function getWindow(node) {
    return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
};

});



parcelRegister("gl4B1", function(module, exports) {
"use strict";

var $jbmdS = parcelRequire("jbmdS");
var $0311d76c3f3f14af$var$_react2 = $0311d76c3f3f14af$var$_interopRequireDefault($jbmdS);

var $jCNM0 = parcelRequire("jCNM0");
var $0311d76c3f3f14af$var$_reactDom2 = $0311d76c3f3f14af$var$_interopRequireDefault($jCNM0);
function $0311d76c3f3f14af$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $0311d76c3f3f14af$var$_version = $0311d76c3f3f14af$var$_react2.default.version.split(".").map(parseFloat);
module.exports = {
    version: function version() {
        return $0311d76c3f3f14af$var$_version;
    },
    findDOMNode: function findDOMNode(component) {
        return $0311d76c3f3f14af$var$_reactDom2.default.findDOMNode(component);
    },
    batchedUpdates: function batchedUpdates(cb) {
        $0311d76c3f3f14af$var$_reactDom2.default.unstable_batchedUpdates(cb);
    }
};

});


parcelRegister("dPmvq", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $a1117eff45d42c64$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $jbmdS = parcelRequire("jbmdS");
var $a1117eff45d42c64$var$_react2 = $a1117eff45d42c64$var$_interopRequireDefault($jbmdS);

var $2MXkj = parcelRequire("2MXkj");
var $a1117eff45d42c64$var$_propTypes2 = $a1117eff45d42c64$var$_interopRequireDefault($2MXkj);

var $e64Mn = parcelRequire("e64Mn");
var $a1117eff45d42c64$var$_createReactClass2 = $a1117eff45d42c64$var$_interopRequireDefault($e64Mn);

var $iSbaG = parcelRequire("iSbaG");
var $a1117eff45d42c64$var$_ListOption2 = $a1117eff45d42c64$var$_interopRequireDefault($iSbaG);

var $iMXz6 = parcelRequire("iMXz6");
var $a1117eff45d42c64$var$_propTypes4 = $a1117eff45d42c64$var$_interopRequireDefault($iMXz6);

var $gl4B1 = parcelRequire("gl4B1");
var $a1117eff45d42c64$var$_compat2 = $a1117eff45d42c64$var$_interopRequireDefault($gl4B1);

var $02LyB = parcelRequire("02LyB");
var $a1117eff45d42c64$var$_classnames2 = $a1117eff45d42c64$var$_interopRequireDefault($02LyB);

var $4ELyG = parcelRequire("4ELyG");
var $a1117eff45d42c64$var$_3 = $a1117eff45d42c64$var$_interopRequireDefault($4ELyG);

var $3gVwc = parcelRequire("3gVwc");

var $9yNJk = parcelRequire("9yNJk");

var $cQuVG = parcelRequire("cQuVG");
function $a1117eff45d42c64$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a1117eff45d42c64$var$optionId = function optionId(id, idx) {
    return id + "__option__" + idx;
};


module.exports.default = (0, $a1117eff45d42c64$var$_createReactClass2.default)({
    displayName: "List",
    mixins: [
        (parcelRequire("jmabG")),
        (parcelRequire("aU65n"))()
    ],
    propTypes: {
        data: $a1117eff45d42c64$var$_propTypes2.default.array,
        onSelect: $a1117eff45d42c64$var$_propTypes2.default.func,
        onMove: $a1117eff45d42c64$var$_propTypes2.default.func,
        optionComponent: $a1117eff45d42c64$var$_propTypes4.default.elementType,
        itemComponent: $a1117eff45d42c64$var$_propTypes4.default.elementType,
        selected: $a1117eff45d42c64$var$_propTypes2.default.any,
        focused: $a1117eff45d42c64$var$_propTypes2.default.any,
        valueField: $a1117eff45d42c64$var$_propTypes4.default.accessor,
        textField: $a1117eff45d42c64$var$_propTypes4.default.accessor,
        disabled: $a1117eff45d42c64$var$_propTypes4.default.disabled.acceptsArray,
        readOnly: $a1117eff45d42c64$var$_propTypes4.default.readOnly.acceptsArray,
        messages: $a1117eff45d42c64$var$_propTypes2.default.shape({
            emptyList: $a1117eff45d42c64$var$_propTypes4.default.message
        })
    },
    getDefaultProps: function getDefaultProps() {
        return {
            onSelect: function onSelect() {},
            optionComponent: $a1117eff45d42c64$var$_ListOption2.default,
            ariaActiveDescendantKey: "list",
            data: [],
            messages: {
                emptyList: "There are no items in this list"
            }
        };
    },
    componentDidMount: function componentDidMount() {
        this.move();
    },
    componentDidUpdate: function componentDidUpdate() {
        var _props = this.props, data = _props.data, focused = _props.focused, idx = data.indexOf(focused), activeId = $a1117eff45d42c64$var$optionId((0, $9yNJk.instanceId)(this), idx);
        this.ariaActiveDescendant(idx !== -1 ? activeId : null);
        this.move();
    },
    render: function render() {
        var _this = this;
        var _props2 = this.props, className = _props2.className, role = _props2.role, data = _props2.data, textField = _props2.textField, valueField = _props2.valueField, focused = _props2.focused, selected = _props2.selected, messages = _props2.messages, onSelect = _props2.onSelect, ItemComponent = _props2.itemComponent, Option = _props2.optionComponent;
        var id = (0, $9yNJk.instanceId)(this), items = void 0;
        var elementProps = $a1117eff45d42c64$var$_3.default.omitOwnProps(this);
        items = !data.length ? $a1117eff45d42c64$var$_react2.default.createElement("li", {
            className: "rw-list-empty"
        }, $a1117eff45d42c64$var$_3.default.result(messages.emptyList, this.props)) : data.map(function(item, idx) {
            var currentId = $a1117eff45d42c64$var$optionId(id, idx), isDisabled = (0, $cQuVG.isDisabledItem)(item, _this.props), isReadOnly = (0, $cQuVG.isReadOnlyItem)(item, _this.props);
            return $a1117eff45d42c64$var$_react2.default.createElement(Option, {
                key: "item_" + idx,
                id: currentId,
                dataItem: item,
                disabled: isDisabled,
                readOnly: isReadOnly,
                focused: focused === item,
                selected: selected === item,
                onClick: isDisabled || isReadOnly ? undefined : onSelect.bind(null, item)
            }, ItemComponent ? $a1117eff45d42c64$var$_react2.default.createElement(ItemComponent, {
                item: item,
                value: (0, $3gVwc.dataValue)(item, valueField),
                text: (0, $3gVwc.dataText)(item, textField),
                disabled: isDisabled,
                readOnly: isReadOnly
            }) : (0, $3gVwc.dataText)(item, textField));
        });
        return $a1117eff45d42c64$var$_react2.default.createElement("ul", $a1117eff45d42c64$var$_extends({
            id: id,
            tabIndex: "-1",
            className: (0, $a1117eff45d42c64$var$_classnames2.default)(className, "rw-list"),
            role: role === undefined ? "listbox" : role
        }, elementProps), items);
    },
    _data: function _data() {
        return this.props.data;
    },
    move: function move() {
        var list = $a1117eff45d42c64$var$_compat2.default.findDOMNode(this), idx = this._data().indexOf(this.props.focused), selected = list.children[idx];
        if (!selected) return;
        (0, $9yNJk.notify)(this.props.onMove, [
            selected,
            list,
            this.props.focused
        ]);
    }
});
module.exports = module.exports["default"];

});
parcelRegister("iSbaG", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $dbd5ef8193bdfed3$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $jbmdS = parcelRequire("jbmdS");
var $dbd5ef8193bdfed3$var$_react2 = $dbd5ef8193bdfed3$var$_interopRequireDefault($jbmdS);

var $2MXkj = parcelRequire("2MXkj");
var $dbd5ef8193bdfed3$var$_propTypes2 = $dbd5ef8193bdfed3$var$_interopRequireDefault($2MXkj);

var $e64Mn = parcelRequire("e64Mn");
var $dbd5ef8193bdfed3$var$_createReactClass2 = $dbd5ef8193bdfed3$var$_interopRequireDefault($e64Mn);

var $02LyB = parcelRequire("02LyB");
var $dbd5ef8193bdfed3$var$_classnames2 = $dbd5ef8193bdfed3$var$_interopRequireDefault($02LyB);

var $4ELyG = parcelRequire("4ELyG");
var $dbd5ef8193bdfed3$var$_3 = $dbd5ef8193bdfed3$var$_interopRequireDefault($4ELyG);
function $dbd5ef8193bdfed3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $dbd5ef8193bdfed3$var$ListOption = (0, $dbd5ef8193bdfed3$var$_createReactClass2.default)({
    displayName: "ListOption",
    propTypes: {
        dataItem: $dbd5ef8193bdfed3$var$_propTypes2.default.any,
        focused: $dbd5ef8193bdfed3$var$_propTypes2.default.bool,
        selected: $dbd5ef8193bdfed3$var$_propTypes2.default.bool,
        disabled: $dbd5ef8193bdfed3$var$_propTypes2.default.bool,
        readOnly: $dbd5ef8193bdfed3$var$_propTypes2.default.bool
    },
    render: function render() {
        var _props = this.props, className = _props.className, children = _props.children, focused = _props.focused, selected = _props.selected, disabled = _props.disabled, readOnly = _props.readOnly;
        var props = $dbd5ef8193bdfed3$var$_3.default.omitOwnProps(this);
        var classes = {
            "rw-state-focus": focused,
            "rw-state-selected": selected,
            "rw-state-disabled": disabled,
            "rw-state-readonly": readOnly
        };
        return $dbd5ef8193bdfed3$var$_react2.default.createElement("li", $dbd5ef8193bdfed3$var$_extends({
            role: "option",
            tabIndex: !(disabled || readOnly) ? "-1" : undefined,
            "aria-selected": !!selected,
            className: (0, $dbd5ef8193bdfed3$var$_classnames2.default)("rw-list-option", className, classes)
        }, props), children);
    }
});
module.exports.default = $dbd5ef8193bdfed3$var$ListOption;
module.exports = module.exports["default"];

});

parcelRegister("9yNJk", function(module, exports) {

$parcel$export(module.exports, "notify", function () { return $6f5ddd60ab8d36eb$export$5e14cdade93d6f7b; }, function (v) { return $6f5ddd60ab8d36eb$export$5e14cdade93d6f7b = v; });
$parcel$export(module.exports, "instanceId", function () { return $6f5ddd60ab8d36eb$export$ccd86612c5e58cc1; }, function (v) { return $6f5ddd60ab8d36eb$export$ccd86612c5e58cc1 = v; });
$parcel$export(module.exports, "isFirstFocusedRender", function () { return $6f5ddd60ab8d36eb$export$bd6a1ea09c5c68cd; }, function (v) { return $6f5ddd60ab8d36eb$export$bd6a1ea09c5c68cd = v; });
var $6f5ddd60ab8d36eb$export$1e511d4a378977f5;
var $6f5ddd60ab8d36eb$export$5e14cdade93d6f7b;
var $6f5ddd60ab8d36eb$export$ccd86612c5e58cc1;
var $6f5ddd60ab8d36eb$export$bd6a1ea09c5c68cd;
"use strict";
$6f5ddd60ab8d36eb$export$1e511d4a378977f5 = true;
$6f5ddd60ab8d36eb$export$5e14cdade93d6f7b = $6f5ddd60ab8d36eb$var$notify;
$6f5ddd60ab8d36eb$export$ccd86612c5e58cc1 = $6f5ddd60ab8d36eb$var$instanceId;
$6f5ddd60ab8d36eb$export$bd6a1ea09c5c68cd = $6f5ddd60ab8d36eb$var$isFirstFocusedRender;

var $4ELyG = parcelRequire("4ELyG");
function $6f5ddd60ab8d36eb$var$notify(handler, args) {
    handler && handler.apply(null, [].concat(args));
}
function $6f5ddd60ab8d36eb$var$instanceId(component) {
    var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    component.__id || (component.__id = (0, $4ELyG.uniqueId)("rw_"));
    return (component.props.id || component.__id) + suffix;
}
function $6f5ddd60ab8d36eb$var$isFirstFocusedRender(component) {
    return component._firstFocus || component.state.focused && (component._firstFocus = true);
}

});

parcelRegister("cQuVG", function(module, exports) {

$parcel$export(module.exports, "widgetEditable", function () { return $95a2554f3999104f$export$7c01345218365f30; }, function (v) { return $95a2554f3999104f$export$7c01345218365f30 = v; });
$parcel$export(module.exports, "widgetEnabled", function () { return $95a2554f3999104f$export$18bcbbf0c0ffc49a; }, function (v) { return $95a2554f3999104f$export$18bcbbf0c0ffc49a = v; });
$parcel$export(module.exports, "isDisabled", function () { return $95a2554f3999104f$export$30e0dc115df457ed; }, function (v) { return $95a2554f3999104f$export$30e0dc115df457ed = v; });
$parcel$export(module.exports, "isReadOnly", function () { return $95a2554f3999104f$export$2498094d90b6ac72; }, function (v) { return $95a2554f3999104f$export$2498094d90b6ac72 = v; });
$parcel$export(module.exports, "isDisabledItem", function () { return $95a2554f3999104f$export$f4ef2e7dd004d142; }, function (v) { return $95a2554f3999104f$export$f4ef2e7dd004d142 = v; });
$parcel$export(module.exports, "isReadOnlyItem", function () { return $95a2554f3999104f$export$afabd9ff1a0663e5; }, function (v) { return $95a2554f3999104f$export$afabd9ff1a0663e5 = v; });
$parcel$export(module.exports, "contains", function () { return $95a2554f3999104f$export$2344b14b097df817; }, function (v) { return $95a2554f3999104f$export$2344b14b097df817 = v; });
var $95a2554f3999104f$export$1e511d4a378977f5;
var $95a2554f3999104f$export$7c01345218365f30;
var $95a2554f3999104f$export$18bcbbf0c0ffc49a;
var $95a2554f3999104f$export$30e0dc115df457ed;
var $95a2554f3999104f$export$2498094d90b6ac72;
var $95a2554f3999104f$export$f4ef2e7dd004d142;
var $95a2554f3999104f$export$afabd9ff1a0663e5;
var $95a2554f3999104f$export$2344b14b097df817;
var $95a2554f3999104f$export$d947e5f4f4c48d48;
"use strict";
$95a2554f3999104f$export$1e511d4a378977f5 = true;
$95a2554f3999104f$export$7c01345218365f30 = $95a2554f3999104f$export$18bcbbf0c0ffc49a = undefined;
$95a2554f3999104f$export$30e0dc115df457ed = $95a2554f3999104f$var$isDisabled;
$95a2554f3999104f$export$2498094d90b6ac72 = $95a2554f3999104f$var$isReadOnly;
$95a2554f3999104f$export$f4ef2e7dd004d142 = $95a2554f3999104f$var$isDisabledItem;
$95a2554f3999104f$export$afabd9ff1a0663e5 = $95a2554f3999104f$var$isReadOnlyItem;
$95a2554f3999104f$export$2344b14b097df817 = $95a2554f3999104f$var$contains;
$95a2554f3999104f$export$d947e5f4f4c48d48 = $95a2554f3999104f$var$move;

var $3gVwc = parcelRequire("3gVwc");
function $95a2554f3999104f$var$isDisabled(props) {
    return props.disabled === true || props.disabled === "disabled";
}
function $95a2554f3999104f$var$isReadOnly(props) {
    return props.readOnly === true || props.readOnly === "readOnly";
}
function $95a2554f3999104f$var$isDisabledItem(item, props) {
    return $95a2554f3999104f$var$isDisabled(props) || $95a2554f3999104f$var$contains(item, props.disabled, props.valueField);
}
function $95a2554f3999104f$var$isReadOnlyItem(item, props) {
    return $95a2554f3999104f$var$isReadOnly(props) || $95a2554f3999104f$var$contains(item, props.readOnly, props.valueField);
}
function $95a2554f3999104f$var$contains(item, values, valueField) {
    return Array.isArray(values) ? values.some(function(value) {
        return (0, $3gVwc.valueMatcher)(item, value, valueField);
    }) : (0, $3gVwc.valueMatcher)(item, values, valueField);
}
function $95a2554f3999104f$var$move(dir, item, props, list) {
    var isDisabledOrReadonly = function isDisabledOrReadonly(item) {
        return $95a2554f3999104f$var$isDisabledItem(item, props) || $95a2554f3999104f$var$isReadOnlyItem(item, props);
    }, stop = dir === "next" ? list.last() : list.first(), next = list[dir](item);
    while(next !== stop && isDisabledOrReadonly(next))next = list[dir](next);
    return isDisabledOrReadonly(next) ? item : next;
}
var $95a2554f3999104f$var$widgetEnabled = $95a2554f3999104f$export$18bcbbf0c0ffc49a = $95a2554f3999104f$var$interactionDecorator(true);
var $95a2554f3999104f$var$widgetEditable = $95a2554f3999104f$export$7c01345218365f30 = $95a2554f3999104f$var$interactionDecorator(false);
function $95a2554f3999104f$var$interactionDecorator(disabledOnly) {
    function wrap(method) {
        return function decoratedMethod() {
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            if (!($95a2554f3999104f$var$isDisabled(this.props) || !disabledOnly && $95a2554f3999104f$var$isReadOnly(this.props))) return method.apply(this, args);
        };
    }
    return function decorate(target, key, desc) {
        if (desc.initializer) {
            var init = desc.initializer;
            desc.initializer = function() {
                return wrap(init());
            };
        } else desc.value = wrap(desc.value);
        return desc;
    };
}

});

parcelRegister("jmabG", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $f8Des = parcelRequire("f8Des");
var $e177f96910c95642$var$_filter2 = $e177f96910c95642$var$_interopRequireDefault($f8Des);

var $3gVwc = parcelRequire("3gVwc");

var $iMXz6 = parcelRequire("iMXz6");
var $e177f96910c95642$var$_propTypes2 = $e177f96910c95642$var$_interopRequireDefault($iMXz6);

var $cQuVG = parcelRequire("cQuVG");
function $e177f96910c95642$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e177f96910c95642$var$EMPTY_VALUE = {};
var $e177f96910c95642$var$isDisabledOrReadonly = function isDisabledOrReadonly(item, props) {
    return (0, $cQuVG.isDisabledItem)(item, props) || (0, $cQuVG.isReadOnlyItem)(item, props);
};
module.exports.default = {
    propTypes: {
        textField: $e177f96910c95642$var$_propTypes2.default.accessor,
        valueField: $e177f96910c95642$var$_propTypes2.default.accessor,
        disabled: $e177f96910c95642$var$_propTypes2.default.disabled.acceptsArray,
        readOnly: $e177f96910c95642$var$_propTypes2.default.readOnly.acceptsArray
    },
    first: function first() {
        return this.next($e177f96910c95642$var$EMPTY_VALUE);
    },
    last: function last() {
        var data = this._data(), item = data[data.length - 1];
        return $e177f96910c95642$var$isDisabledOrReadonly(item, this.props) ? this.prev(item) : item;
    },
    prev: function prev(item, word) {
        var data = this._data(), nextIdx = data.indexOf(item), matches = $e177f96910c95642$var$matcher(word, item, this.props.textField);
        if (nextIdx < 0 || nextIdx == null) nextIdx = 0;
        nextIdx--;
        while(nextIdx > -1 && ($e177f96910c95642$var$isDisabledOrReadonly(data[nextIdx], this.props) || !matches(data[nextIdx])))nextIdx--;
        return nextIdx >= 0 ? data[nextIdx] : item;
    },
    next: function next(item, word) {
        var data = this._data(), nextIdx = data.indexOf(item) + 1, len = data.length, matches = $e177f96910c95642$var$matcher(word, item, this.props.textField);
        while(nextIdx < len && ($e177f96910c95642$var$isDisabledOrReadonly(data[nextIdx], this.props) || !matches(data[nextIdx])))nextIdx++;
        return nextIdx < len ? data[nextIdx] : item;
    }
};
function $e177f96910c95642$var$matcher(word, item, textField) {
    if (!word) return function() {
        return true;
    };
    word = word.toLowerCase();
    return function(item) {
        return $e177f96910c95642$var$_filter2.default.startsWith((0, $3gVwc.dataText)(item, textField).toLowerCase(), word);
    };
}
module.exports = module.exports["default"];

});

parcelRegister("aU65n", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = function(nodeOrComponent) {
    var reconcileChildren = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $7f03dad31f7cc444$var$defaultReconcile;
    return {
        propTypes: {
            ariaActiveDescendantKey: $7f03dad31f7cc444$var$_propTypes2.default.string.isRequired
        },
        contextTypes: {
            activeDescendants: $7f03dad31f7cc444$var$shape
        },
        childContextTypes: {
            activeDescendants: $7f03dad31f7cc444$var$shape
        },
        ariaActiveDescendant: function ariaActiveDescendant(id) {
            var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.ariaActiveDescendantKey;
            var activeDescendants = this.context.activeDescendants;
            var current = this.__ariaActiveDescendantId;
            if (id === undefined) return current;
            id = reconcileChildren.call(this, key, id);
            if (id === undefined) id = current;
            else {
                this.__ariaActiveDescendantId = id;
                $7f03dad31f7cc444$var$flushAriaToNode(id, nodeOrComponent, this);
            }
            activeDescendants && activeDescendants.reconcile(key, id);
        },
        getChildContext: function getChildContext() {
            var _this = this;
            return this._context || (this._context = {
                activeDescendants: {
                    reconcile: function reconcile(key, id) {
                        return _this.ariaActiveDescendant(id, key);
                    }
                }
            });
        }
    };
};

var $2MXkj = parcelRequire("2MXkj");
var $7f03dad31f7cc444$var$_propTypes2 = $7f03dad31f7cc444$var$_interopRequireDefault($2MXkj);

var $gl4B1 = parcelRequire("gl4B1");
var $7f03dad31f7cc444$var$_compat2 = $7f03dad31f7cc444$var$_interopRequireDefault($gl4B1);
function $7f03dad31f7cc444$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $7f03dad31f7cc444$var$shape = $7f03dad31f7cc444$var$_propTypes2.default.shape({
    //setActive: PropTypes.func,
    reconcile: $7f03dad31f7cc444$var$_propTypes2.default.func
});
function $7f03dad31f7cc444$var$defaultReconcile(key, id) {
    return id;
}
function $7f03dad31f7cc444$var$flushAriaToNode(id, nodeOrComponent, ctx) {
    var node = typeof nodeOrComponent === "function" ? nodeOrComponent(ctx) : typeof nodeOrComponent === "string" ? ctx.refs[nodeOrComponent] : ctx;
    if (node) {
        if (id) $7f03dad31f7cc444$var$_compat2.default.findDOMNode(node).setAttribute("aria-activedescendant", id);
        else $7f03dad31f7cc444$var$_compat2.default.findDOMNode(node).removeAttribute("aria-activedescendant");
    }
}
module.exports = module.exports["default"];

});


parcelRegister("kNt4v", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $f23eef483e1cbab7$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $jbmdS = parcelRequire("jbmdS");
var $f23eef483e1cbab7$var$_react2 = $f23eef483e1cbab7$var$_interopRequireDefault($jbmdS);

var $2MXkj = parcelRequire("2MXkj");
var $f23eef483e1cbab7$var$_propTypes2 = $f23eef483e1cbab7$var$_interopRequireDefault($2MXkj);

var $e64Mn = parcelRequire("e64Mn");
var $f23eef483e1cbab7$var$_createReactClass2 = $f23eef483e1cbab7$var$_interopRequireDefault($e64Mn);

var $iSbaG = parcelRequire("iSbaG");
var $f23eef483e1cbab7$var$_ListOption2 = $f23eef483e1cbab7$var$_interopRequireDefault($iSbaG);

var $iMXz6 = parcelRequire("iMXz6");
var $f23eef483e1cbab7$var$_propTypes4 = $f23eef483e1cbab7$var$_interopRequireDefault($iMXz6);

var $gl4B1 = parcelRequire("gl4B1");
var $f23eef483e1cbab7$var$_compat2 = $f23eef483e1cbab7$var$_interopRequireDefault($gl4B1);

var $02LyB = parcelRequire("02LyB");
var $f23eef483e1cbab7$var$_classnames2 = $f23eef483e1cbab7$var$_interopRequireDefault($02LyB);

var $4ELyG = parcelRequire("4ELyG");
var $f23eef483e1cbab7$var$_3 = $f23eef483e1cbab7$var$_interopRequireDefault($4ELyG);

var $3xaXj = parcelRequire("3xaXj");
var $f23eef483e1cbab7$var$_warning2 = $f23eef483e1cbab7$var$_interopRequireDefault($3xaXj);

var $3gVwc = parcelRequire("3gVwc");

var $9yNJk = parcelRequire("9yNJk");

var $cQuVG = parcelRequire("cQuVG");
function $f23eef483e1cbab7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $f23eef483e1cbab7$var$optionId = function optionId(id, idx) {
    return id + "__option__" + idx;
};


module.exports.default = (0, $f23eef483e1cbab7$var$_createReactClass2.default)({
    displayName: "List",
    mixins: [
        (parcelRequire("jmabG")),
        (parcelRequire("aU65n"))()
    ],
    propTypes: {
        data: $f23eef483e1cbab7$var$_propTypes2.default.array,
        onSelect: $f23eef483e1cbab7$var$_propTypes2.default.func,
        onMove: $f23eef483e1cbab7$var$_propTypes2.default.func,
        optionComponent: $f23eef483e1cbab7$var$_propTypes4.default.elementType,
        itemComponent: $f23eef483e1cbab7$var$_propTypes4.default.elementType,
        groupComponent: $f23eef483e1cbab7$var$_propTypes4.default.elementType,
        selected: $f23eef483e1cbab7$var$_propTypes2.default.any,
        focused: $f23eef483e1cbab7$var$_propTypes2.default.any,
        valueField: $f23eef483e1cbab7$var$_propTypes4.default.accessor,
        textField: $f23eef483e1cbab7$var$_propTypes4.default.accessor,
        disabled: $f23eef483e1cbab7$var$_propTypes4.default.disabled.acceptsArray,
        readOnly: $f23eef483e1cbab7$var$_propTypes4.default.readOnly.acceptsArray,
        groupBy: $f23eef483e1cbab7$var$_propTypes4.default.accessor,
        messages: $f23eef483e1cbab7$var$_propTypes2.default.shape({
            emptyList: $f23eef483e1cbab7$var$_propTypes4.default.message
        })
    },
    getDefaultProps: function getDefaultProps() {
        return {
            onSelect: function onSelect() {},
            data: [],
            optionComponent: $f23eef483e1cbab7$var$_ListOption2.default,
            ariaActiveDescendantKey: "groupedList",
            messages: {
                emptyList: "There are no items in this list"
            }
        };
    },
    getInitialState: function getInitialState() {
        var keys = [];
        return {
            groups: this._group(this.props.groupBy, this.props.data, keys),
            sortedKeys: keys
        };
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        var keys = [];
        if (nextProps.data !== this.props.data || nextProps.groupBy !== this.props.groupBy) this.setState({
            groups: this._group(nextProps.groupBy, nextProps.data, keys),
            sortedKeys: keys
        });
    },
    componentDidMount: function componentDidMount() {
        this.move();
    },
    componentDidUpdate: function componentDidUpdate() {
        this.ariaActiveDescendant(this._currentActiveID);
        this.move();
    },
    render: function render() {
        var _this = this;
        var _props = this.props, className = _props.className, role = _props.role, data = _props.data, messages = _props.messages;
        var _state = this.state, sortedKeys = _state.sortedKeys, groups = _state.groups;
        var elementProps = $f23eef483e1cbab7$var$_3.default.omitOwnProps(this);
        var items = [], idx = -1, group = void 0;
        var id = (0, $9yNJk.instanceId)(this);
        this._currentActiveID = null;
        if (data.length) items = sortedKeys.reduce(function(items, key) {
            group = groups[key];
            items.push(_this._renderGroupHeader(key));
            for(var itemIdx = 0; itemIdx < group.length; itemIdx++)items.push(_this._renderItem(key, group[itemIdx], ++idx));
            return items;
        }, []);
        else items = $f23eef483e1cbab7$var$_react2.default.createElement("li", {
            className: "rw-list-empty"
        }, $f23eef483e1cbab7$var$_3.default.result(messages.emptyList, this.props));
        return $f23eef483e1cbab7$var$_react2.default.createElement("ul", $f23eef483e1cbab7$var$_extends({
            ref: "scrollable",
            id: id,
            tabIndex: "-1",
            className: (0, $f23eef483e1cbab7$var$_classnames2.default)(className, "rw-list", "rw-list-grouped"),
            role: role === undefined ? "listbox" : role
        }, elementProps), items);
    },
    _renderGroupHeader: function _renderGroupHeader(group) {
        var GroupComponent = this.props.groupComponent, id = (0, $9yNJk.instanceId)(this);
        return $f23eef483e1cbab7$var$_react2.default.createElement("li", {
            key: "item_" + group,
            tabIndex: "-1",
            role: "separator",
            id: id + "_group_" + group,
            className: "rw-list-optgroup"
        }, GroupComponent ? $f23eef483e1cbab7$var$_react2.default.createElement(GroupComponent, {
            item: group
        }) : group);
    },
    _renderItem: function _renderItem(group, item, idx) {
        var _props2 = this.props, focused = _props2.focused, selected = _props2.selected, onSelect = _props2.onSelect, textField = _props2.textField, valueField = _props2.valueField, ItemComponent = _props2.itemComponent, Option = _props2.optionComponent;
        var currentID = $f23eef483e1cbab7$var$optionId((0, $9yNJk.instanceId)(this), idx), isDisabled = (0, $cQuVG.isDisabledItem)(item, this.props), isReadOnly = (0, $cQuVG.isReadOnlyItem)(item, this.props);
        if (focused === item) this._currentActiveID = currentID;
        return $f23eef483e1cbab7$var$_react2.default.createElement(Option, {
            key: "item_" + group + "_" + idx,
            id: currentID,
            dataItem: item,
            focused: focused === item,
            selected: selected === item,
            disabled: isDisabled,
            readOnly: isReadOnly,
            onClick: isDisabled || isReadOnly ? undefined : onSelect.bind(null, item)
        }, ItemComponent ? $f23eef483e1cbab7$var$_react2.default.createElement(ItemComponent, {
            item: item,
            value: (0, $3gVwc.dataValue)(item, valueField),
            text: (0, $3gVwc.dataText)(item, textField),
            disabled: isDisabled,
            readOnly: isReadOnly
        }) : (0, $3gVwc.dataText)(item, textField));
    },
    _isIndexOf: function _isIndexOf(idx, item) {
        return this.props.data[idx] === item;
    },
    _group: function _group(groupBy, data, keys) {
        var iter = typeof groupBy === "function" ? groupBy : function(item) {
            return item[groupBy];
        };
        // the keys array ensures that groups are rendered in the order they came in
        // which means that if you sort the data array it will render sorted,
        // so long as you also sorted by group
        keys = keys || [];
        (0, $f23eef483e1cbab7$var$_warning2.default)(typeof groupBy !== "string" || !data.length || $f23eef483e1cbab7$var$_3.default.has(data[0], groupBy), "[React Widgets] You seem to be trying to group this list by a " + ("property `" + groupBy + "` that doesn't exist in the dataset items, this may be a typo"));
        return data.reduce(function(grps, item) {
            var group = iter(item);
            $f23eef483e1cbab7$var$_3.default.has(grps, group) ? grps[group].push(item) : (keys.push(group), grps[group] = [
                item
            ]);
            return grps;
        }, {});
    },
    _data: function _data() {
        var groups = this.state.groups;
        return this.state.sortedKeys.reduce(function(flat, grp) {
            return flat.concat(groups[grp]);
        }, []);
    },
    move: function move() {
        var selected = this.getItemDOMNode(this.props.focused);
        if (!selected) return;
        (0, $9yNJk.notify)(this.props.onMove, [
            selected,
            $f23eef483e1cbab7$var$_compat2.default.findDOMNode(this),
            this.props.focused
        ]);
    },
    getItemDOMNode: function getItemDOMNode(item) {
        var list = $f23eef483e1cbab7$var$_compat2.default.findDOMNode(this), groups = this.state.groups, idx = -1, itemIdx, child;
        this.state.sortedKeys.some(function(group) {
            itemIdx = groups[group].indexOf(item);
            idx++;
            if (itemIdx !== -1) return !!(child = list.children[idx + itemIdx + 1]);
            idx += groups[group].length;
        });
        return child;
    }
});
module.exports = module.exports["default"];

});
parcelRegister("3xaXj", function(module, exports) {
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $292cf3bc47008c68$var$warning = function() {};
module.exports = $292cf3bc47008c68$var$warning;

});


parcelRegister("eqJK2", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $a816f9b663e7daa1$var$validateListComponent;

var $liDpN = parcelRequire("liDpN");
var $a816f9b663e7daa1$var$_invariant2 = $a816f9b663e7daa1$var$_interopRequireDefault($liDpN);
function $a816f9b663e7daa1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a816f9b663e7daa1$var$METHODS = [
    "next",
    "prev",
    "first",
    "last"
];
function $a816f9b663e7daa1$var$validateListComponent(list) {}
module.exports = module.exports["default"];

});

parcelRegister("12xR0", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $cFaxq = parcelRequire("cFaxq");
var $0c203d09d846997a$var$_createUncontrollable2 = $0c203d09d846997a$var$_interopRequireDefault($cFaxq);
function $0c203d09d846997a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $0c203d09d846997a$var$mixin = {
    shouldComponentUpdate: function shouldComponentUpdate() {
        //let the forceUpdate trigger the update
        return !this._notifying;
    }
};
function $0c203d09d846997a$var$set(component, propName, handler, value, args) {
    if (handler) {
        component._notifying = true;
        handler.call.apply(handler, [
            component,
            value
        ].concat(args));
        component._notifying = false;
    }
    component._values[propName] = value;
    if (!component.unmounted) component.forceUpdate();
}
module.exports.default = (0, $0c203d09d846997a$var$_createUncontrollable2.default)($0c203d09d846997a$var$mixin, $0c203d09d846997a$var$set);
module.exports = module.exports["default"];

});
parcelRegister("cFaxq", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $93817d06964a7fcb$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
module.exports.default = $93817d06964a7fcb$var$createUncontrollable;

var $jbmdS = parcelRequire("jbmdS");
var $93817d06964a7fcb$var$_react2 = $93817d06964a7fcb$var$_interopRequireDefault($jbmdS);

var $liDpN = parcelRequire("liDpN");
var $93817d06964a7fcb$var$_invariant2 = $93817d06964a7fcb$var$_interopRequireDefault($liDpN);

var $45puj = parcelRequire("45puj");
var $93817d06964a7fcb$var$utils = $93817d06964a7fcb$var$_interopRequireWildcard($45puj);
function $93817d06964a7fcb$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $93817d06964a7fcb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $93817d06964a7fcb$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $93817d06964a7fcb$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $93817d06964a7fcb$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $93817d06964a7fcb$var$createUncontrollable(mixin, set) {
    return uncontrollable;
    function uncontrollable(Component, controlledValues) {
        var _class, _temp;
        var methods = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        var displayName = Component.displayName || Component.name || "Component", basePropTypes = $93817d06964a7fcb$var$utils.getType(Component).propTypes, isCompositeComponent = $93817d06964a7fcb$var$utils.isReactComponent(Component), controlledProps = Object.keys(controlledValues), propTypes;
        var OMIT_PROPS = [
            "valueLink",
            "checkedLink"
        ].concat(controlledProps.map($93817d06964a7fcb$var$utils.defaultKey));
        propTypes = $93817d06964a7fcb$var$utils.uncontrolledPropTypes(controlledValues, basePropTypes, displayName);
        (0, $93817d06964a7fcb$var$_invariant2.default)(isCompositeComponent || !methods.length, "[uncontrollable] stateless function components cannot pass through methods because they have no associated instances. Check component: " + displayName + ", " + "attempting to pass through methods: " + methods.join(", "));
        methods = $93817d06964a7fcb$var$utils.transform(methods, function(obj, method) {
            obj[method] = function() {
                var _refs$inner;
                return (_refs$inner = this.refs.inner)[method].apply(_refs$inner, arguments);
            };
        }, {});
        var component = (_temp = _class = function(_React$Component) {
            $93817d06964a7fcb$var$_inherits(component, _React$Component);
            function component() {
                $93817d06964a7fcb$var$_classCallCheck(this, component);
                return $93817d06964a7fcb$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
            }
            component.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
                for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return !mixin.shouldComponentUpdate || mixin.shouldComponentUpdate.apply(this, args);
            };
            component.prototype.componentWillMount = function componentWillMount() {
                var _this2 = this;
                var props = this.props;
                this._values = {};
                controlledProps.forEach(function(key) {
                    _this2._values[key] = props[$93817d06964a7fcb$var$utils.defaultKey(key)];
                });
            };
            /**
       * If a prop switches from controlled to Uncontrolled
       * reset its value to the defaultValue
       */ component.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
                var _this3 = this;
                var props = this.props;
                if (mixin.componentWillReceiveProps) mixin.componentWillReceiveProps.call(this, nextProps);
                controlledProps.forEach(function(key) {
                    if ($93817d06964a7fcb$var$utils.getValue(nextProps, key) === undefined && $93817d06964a7fcb$var$utils.getValue(props, key) !== undefined) _this3._values[key] = nextProps[$93817d06964a7fcb$var$utils.defaultKey(key)];
                });
            };
            component.prototype.componentWillUnmount = function componentWillUnmount() {
                this.unmounted = true;
            };
            component.prototype.getControlledInstance = function getControlledInstance() {
                return this.refs.inner;
            };
            component.prototype.render = function render() {
                var _this4 = this;
                var newProps = {}, props = omitProps(this.props);
                $93817d06964a7fcb$var$utils.each(controlledValues, function(handle, propName) {
                    var linkPropName = $93817d06964a7fcb$var$utils.getLinkName(propName), prop = _this4.props[propName];
                    if (linkPropName && !isProp(_this4.props, propName) && isProp(_this4.props, linkPropName)) prop = _this4.props[linkPropName].value;
                    newProps[propName] = prop !== undefined ? prop : _this4._values[propName];
                    newProps[handle] = setAndNotify.bind(_this4, propName);
                });
                newProps = $93817d06964a7fcb$var$_extends({}, props, newProps, {
                    ref: isCompositeComponent ? "inner" : null
                });
                return $93817d06964a7fcb$var$_react2.default.createElement(Component, newProps);
            };
            return component;
        }($93817d06964a7fcb$var$_react2.default.Component), _class.displayName = "Uncontrolled(" + displayName + ")", _class.propTypes = propTypes, _temp);
        $93817d06964a7fcb$var$_extends(component.prototype, methods);
        component.ControlledComponent = Component;
        /**
     * useful when wrapping a Component and you want to control
     * everything
     */ component.deferControlTo = function(newComponent) {
            var additions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var nextMethods = arguments[2];
            return uncontrollable(newComponent, $93817d06964a7fcb$var$_extends({}, controlledValues, additions), nextMethods);
        };
        return component;
        function setAndNotify(propName, value) {
            var linkName = $93817d06964a7fcb$var$utils.getLinkName(propName), handler = this.props[controlledValues[propName]];
            if (linkName && isProp(this.props, linkName) && !handler) handler = this.props[linkName].requestChange;
            for(var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)args[_key2 - 2] = arguments[_key2];
            set(this, propName, handler, value, args);
        }
        function isProp(props, prop) {
            return props[prop] !== undefined;
        }
        function omitProps(props) {
            var result = {};
            $93817d06964a7fcb$var$utils.each(props, function(value, key) {
                if (OMIT_PROPS.indexOf(key) === -1) result[key] = value;
            });
            return result;
        }
    }
}
module.exports = module.exports["default"];

});
parcelRegister("45puj", function(module, exports) {

$parcel$export(module.exports, "__esModule", function () { return $2f9b666cf1993d61$export$1e511d4a378977f5; }, function (v) { return $2f9b666cf1993d61$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "version", function () { return $2f9b666cf1993d61$export$83d89fbfd8236492; }, function (v) { return $2f9b666cf1993d61$export$83d89fbfd8236492 = v; });
$parcel$export(module.exports, "uncontrolledPropTypes", function () { return $2f9b666cf1993d61$export$8abd944bed26e726; }, function (v) { return $2f9b666cf1993d61$export$8abd944bed26e726 = v; });
$parcel$export(module.exports, "getType", function () { return $2f9b666cf1993d61$export$e2b5c5db9e2009fd; }, function (v) { return $2f9b666cf1993d61$export$e2b5c5db9e2009fd = v; });
$parcel$export(module.exports, "getValue", function () { return $2f9b666cf1993d61$export$bf7199a9ebcb84a9; }, function (v) { return $2f9b666cf1993d61$export$bf7199a9ebcb84a9 = v; });
$parcel$export(module.exports, "getLinkName", function () { return $2f9b666cf1993d61$export$7b848b49fe0c4510; }, function (v) { return $2f9b666cf1993d61$export$7b848b49fe0c4510 = v; });
$parcel$export(module.exports, "defaultKey", function () { return $2f9b666cf1993d61$export$26cbf8c37e721e67; }, function (v) { return $2f9b666cf1993d61$export$26cbf8c37e721e67 = v; });
$parcel$export(module.exports, "chain", function () { return $2f9b666cf1993d61$export$e08e3b67e392101e; }, function (v) { return $2f9b666cf1993d61$export$e08e3b67e392101e = v; });
$parcel$export(module.exports, "transform", function () { return $2f9b666cf1993d61$export$51186ad6e864892a; }, function (v) { return $2f9b666cf1993d61$export$51186ad6e864892a = v; });
$parcel$export(module.exports, "each", function () { return $2f9b666cf1993d61$export$79b2f7037acddd43; }, function (v) { return $2f9b666cf1993d61$export$79b2f7037acddd43 = v; });
$parcel$export(module.exports, "has", function () { return $2f9b666cf1993d61$export$a4f4bb6b1453fff5; }, function (v) { return $2f9b666cf1993d61$export$a4f4bb6b1453fff5 = v; });
$parcel$export(module.exports, "isReactComponent", function () { return $2f9b666cf1993d61$export$51d570c6883e4310; }, function (v) { return $2f9b666cf1993d61$export$51d570c6883e4310 = v; });
var $2f9b666cf1993d61$export$1e511d4a378977f5;
var $2f9b666cf1993d61$export$83d89fbfd8236492;
var $2f9b666cf1993d61$export$8abd944bed26e726;
var $2f9b666cf1993d61$export$e2b5c5db9e2009fd;
var $2f9b666cf1993d61$export$bf7199a9ebcb84a9;
var $2f9b666cf1993d61$export$7b848b49fe0c4510;
var $2f9b666cf1993d61$export$26cbf8c37e721e67;
var $2f9b666cf1993d61$export$e08e3b67e392101e;
var $2f9b666cf1993d61$export$51186ad6e864892a;
var $2f9b666cf1993d61$export$79b2f7037acddd43;
var $2f9b666cf1993d61$export$a4f4bb6b1453fff5;
var $2f9b666cf1993d61$export$51d570c6883e4310;
"use strict";
$2f9b666cf1993d61$export$1e511d4a378977f5 = true;
$2f9b666cf1993d61$export$83d89fbfd8236492 = undefined;
$2f9b666cf1993d61$export$8abd944bed26e726 = $2f9b666cf1993d61$var$uncontrolledPropTypes;
$2f9b666cf1993d61$export$e2b5c5db9e2009fd = $2f9b666cf1993d61$var$getType;
$2f9b666cf1993d61$export$bf7199a9ebcb84a9 = $2f9b666cf1993d61$var$getValue;
$2f9b666cf1993d61$export$7b848b49fe0c4510 = $2f9b666cf1993d61$var$getLinkName;
$2f9b666cf1993d61$export$26cbf8c37e721e67 = $2f9b666cf1993d61$var$defaultKey;
$2f9b666cf1993d61$export$e08e3b67e392101e = $2f9b666cf1993d61$var$chain;
$2f9b666cf1993d61$export$51186ad6e864892a = $2f9b666cf1993d61$var$transform;
$2f9b666cf1993d61$export$79b2f7037acddd43 = $2f9b666cf1993d61$var$each;
$2f9b666cf1993d61$export$a4f4bb6b1453fff5 = $2f9b666cf1993d61$var$has;
$2f9b666cf1993d61$export$51d570c6883e4310 = $2f9b666cf1993d61$var$isReactComponent;

var $jbmdS = parcelRequire("jbmdS");
var $2f9b666cf1993d61$var$_react2 = $2f9b666cf1993d61$var$_interopRequireDefault($jbmdS);

var $liDpN = parcelRequire("liDpN");
var $2f9b666cf1993d61$var$_invariant2 = $2f9b666cf1993d61$var$_interopRequireDefault($liDpN);
function $2f9b666cf1993d61$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2f9b666cf1993d61$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to " + "`" + name + "` without an `" + handler + "` handler. This will render a read-only field. " + "If the field should be mutable use `" + $2f9b666cf1993d61$var$defaultKey(propName) + "`. Otherwise, set `" + handler + "`");
        }
    };
}
function $2f9b666cf1993d61$var$uncontrolledPropTypes(controlledValues, basePropTypes, displayName) {
    var propTypes = {};
    return propTypes;
}
var $2f9b666cf1993d61$var$version = $2f9b666cf1993d61$export$83d89fbfd8236492 = $2f9b666cf1993d61$var$_react2.default.version.split(".").map(parseFloat);
function $2f9b666cf1993d61$var$getType(component) {
    if ($2f9b666cf1993d61$var$version[0] >= 15 || $2f9b666cf1993d61$var$version[0] === 0 && $2f9b666cf1993d61$var$version[1] >= 13) return component;
    return component.type;
}
function $2f9b666cf1993d61$var$getValue(props, name) {
    var linkPropName = $2f9b666cf1993d61$var$getLinkName(name);
    if (linkPropName && !$2f9b666cf1993d61$var$isProp(props, name) && $2f9b666cf1993d61$var$isProp(props, linkPropName)) return props[linkPropName].value;
    return props[name];
}
function $2f9b666cf1993d61$var$isProp(props, prop) {
    return props[prop] !== undefined;
}
function $2f9b666cf1993d61$var$getLinkName(name) {
    return name === "value" ? "valueLink" : name === "checked" ? "checkedLink" : null;
}
function $2f9b666cf1993d61$var$defaultKey(key) {
    return "default" + key.charAt(0).toUpperCase() + key.substr(1);
}
function $2f9b666cf1993d61$var$chain(thisArg, a, b) {
    return function chainedFunction() {
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        a && a.call.apply(a, [
            thisArg
        ].concat(args));
        b && b.call.apply(b, [
            thisArg
        ].concat(args));
    };
}
function $2f9b666cf1993d61$var$transform(obj, cb, seed) {
    $2f9b666cf1993d61$var$each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
    return seed;
}
function $2f9b666cf1993d61$var$each(obj, cb, thisArg) {
    if (Array.isArray(obj)) return obj.forEach(cb, thisArg);
    for(var key in obj)if ($2f9b666cf1993d61$var$has(obj, key)) cb.call(thisArg, obj[key], key, obj);
}
function $2f9b666cf1993d61$var$has(o, k) {
    return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
}
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */ function $2f9b666cf1993d61$var$isReactComponent(component) {
    return !!(component && component.prototype && component.prototype.isReactComponent);
}

});



parcelRegister("7Hmlb", function(module, exports) {
"use strict";

var $4ELyG = parcelRequire("4ELyG");
var $59ade0ec399b4ca9$var$has = $4ELyG.has;
module.exports = {
    componentWillUnmount: function componentWillUnmount() {
        var timers = this._timers || {};
        this._unmounted = true;
        for(var k in timers)if ($59ade0ec399b4ca9$var$has(timers, k)) this.clearTimeout(k);
    },
    clearTimeout: function clearTimeout(key) {
        var timers = this._timers || {};
        window.clearTimeout(timers[key]);
    },
    setTimeout: function setTimeout(key, cb, duration) {
        var _this = this;
        var timers = this._timers || (this._timers = Object.create(null));
        if (this._unmounted) return;
        this.clearTimeout(key);
        timers[key] = window.setTimeout(function() {
            if (!_this._unmounted) cb();
        }, duration);
    }
};

});

parcelRegister("gYehs", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $2MXkj = parcelRequire("2MXkj");
var $c5ad53c0e4d9213d$var$_propTypes2 = $c5ad53c0e4d9213d$var$_interopRequireDefault($2MXkj);

var $jCNM0 = parcelRequire("jCNM0");
function $c5ad53c0e4d9213d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = {
    propTypes: {
        autoFocus: $c5ad53c0e4d9213d$var$_propTypes2.default.bool
    },
    componentDidMount: function componentDidMount() {
        var autoFocus = this.props.autoFocus;
        if (autoFocus) this.focus ? this.focus() : (0, $jCNM0.findDOMNode)(this).focus();
    }
};
module.exports = module.exports["default"];

});

parcelRegister("7xDAs", function(module, exports) {
"use strict";

var $4ELyG = parcelRequire("4ELyG");
//backport PureRenderEqual
module.exports = {
    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
        return !$4ELyG.isShallowEqual(this.props, nextProps) || !$4ELyG.isShallowEqual(this.state, nextState);
    }
};

});

parcelRegister("asC0i", function(module, exports) {
"use strict";

var $2MXkj = parcelRequire("2MXkj");
var $79d9ffac593bf8cb$var$_propTypes2 = $79d9ffac593bf8cb$var$_interopRequireDefault($2MXkj);

var $f8Des = parcelRequire("f8Des");
var $79d9ffac593bf8cb$var$_filter2 = $79d9ffac593bf8cb$var$_interopRequireDefault($f8Des);

var $iMXz6 = parcelRequire("iMXz6");
var $79d9ffac593bf8cb$var$_propTypes4 = $79d9ffac593bf8cb$var$_interopRequireDefault($iMXz6);

var $3gVwc = parcelRequire("3gVwc");
function $79d9ffac593bf8cb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $79d9ffac593bf8cb$var$dflt = function dflt(f) {
    return f === true ? "startsWith" : f ? f : "eq";
};
module.exports = {
    propTypes: {
        data: $79d9ffac593bf8cb$var$_propTypes2.default.array,
        value: $79d9ffac593bf8cb$var$_propTypes2.default.any,
        filter: $79d9ffac593bf8cb$var$_propTypes4.default.filter,
        caseSensitive: $79d9ffac593bf8cb$var$_propTypes2.default.bool,
        minLength: $79d9ffac593bf8cb$var$_propTypes2.default.number
    },
    getDefaultProps: function getDefaultProps() {
        return {
            caseSensitive: false,
            minLength: 1
        };
    },
    filterIndexOf: function filterIndexOf(items, searchTerm) {
        var idx = -1, matches = typeof this.props.filter === "function" ? this.props.filter : $79d9ffac593bf8cb$var$getFilter($79d9ffac593bf8cb$var$_filter2.default[$79d9ffac593bf8cb$var$dflt(this.props.filter)], searchTerm, this);
        if (!searchTerm || !searchTerm.trim() || this.props.filter && searchTerm.length < (this.props.minLength || 1)) return -1;
        items.every(function(item, i) {
            if (matches(item, searchTerm, i)) return idx = i, false;
            return true;
        });
        return idx;
    },
    filter: function filter(items, searchTerm) {
        var matches = typeof this.props.filter === "string" ? $79d9ffac593bf8cb$var$getFilter($79d9ffac593bf8cb$var$_filter2.default[this.props.filter], searchTerm, this) : this.props.filter;
        if (!matches || !searchTerm || !searchTerm.trim() || searchTerm.length < (this.props.minLength || 1)) return items;
        return items.filter(function(item, idx) {
            return matches(item, searchTerm, idx);
        });
    }
};
function $79d9ffac593bf8cb$var$getFilter(matcher, searchTerm, ctx) {
    searchTerm = !ctx.props.caseSensitive ? searchTerm.toLowerCase() : searchTerm;
    return function(item) {
        var val = (0, $3gVwc.dataText)(item, ctx.props.textField);
        if (!ctx.props.caseSensitive) val = val.toLowerCase();
        return matcher(val, searchTerm);
    };
}

});

parcelRegister("602jV", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $43Waz = parcelRequire("43Waz");
var $45e48af007fa1f2c$var$_scrollTo3 = $45e48af007fa1f2c$var$_interopRequireDefault($43Waz);
function $45e48af007fa1f2c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = {
    _scrollTo: function _scrollTo(selected, list, focused) {
        var state = this._scrollState || (this._scrollState = {}), handler = this.props.onMove, lastVisible = state.visible, lastItem = state.focused, shown, changed;
        state.visible = !(!list.offsetWidth || !list.offsetHeight);
        state.focused = focused;
        changed = lastItem !== focused;
        shown = state.visible && !lastVisible;
        if (shown || state.visible && changed) {
            if (handler) handler(selected, list, focused);
            else {
                state.scrollCancel && state.scrollCancel();
                state.scrollCancel = (0, $45e48af007fa1f2c$var$_scrollTo3.default)(selected, list);
            }
        }
    }
};
module.exports = module.exports["default"];

});
parcelRegister("43Waz", function(module, exports) {
"use strict";

var $bAUeB = parcelRequire("bAUeB");

var $a2abb = parcelRequire("a2abb");

var $1BQ9X = parcelRequire("1BQ9X");

var $3fJEw = parcelRequire("3fJEw");

var $c8eDJ = parcelRequire("c8eDJ");

var $c8UPi = parcelRequire("c8UPi");
module.exports = function scrollTo(selected, scrollParent) {
    var offset = $bAUeB(selected), poff = {
        top: 0,
        left: 0
    }, list, listScrollTop, selectedTop, isWin, selectedHeight, listHeight, bottom;
    if (!selected) return;
    list = scrollParent || $1BQ9X(selected);
    isWin = $c8UPi(list);
    listScrollTop = $3fJEw(list);
    listHeight = $a2abb(list, true);
    isWin = $c8UPi(list);
    if (!isWin) poff = $bAUeB(list);
    offset = {
        top: offset.top - poff.top,
        left: offset.left - poff.left,
        height: offset.height,
        width: offset.width
    };
    selectedHeight = offset.height;
    selectedTop = offset.top + (isWin ? 0 : listScrollTop);
    bottom = selectedTop + selectedHeight;
    listScrollTop = listScrollTop > selectedTop ? selectedTop : bottom > listScrollTop + listHeight ? bottom - listHeight : listScrollTop;
    var id = $c8eDJ(function() {
        return $3fJEw(list, listScrollTop);
    });
    return function() {
        return $c8eDJ.cancel(id);
    };
};

});
parcelRegister("1BQ9X", function(module, exports) {
"use strict";

var $bpvMx = parcelRequire("bpvMx");

var $a2abb = parcelRequire("a2abb");
module.exports = function scrollPrarent(node) {
    var position = $bpvMx(node, "position"), excludeStatic = position === "absolute", ownerDoc = node.ownerDocument;
    if (position === "fixed") return ownerDoc || document;
    while((node = node.parentNode) && node.nodeType !== 9){
        var isStatic = excludeStatic && $bpvMx(node, "position") === "static", style = $bpvMx(node, "overflow") + $bpvMx(node, "overflow-y") + $bpvMx(node, "overflow-x");
        if (isStatic) continue;
        if (/(auto|scroll)/.test(style) && $a2abb(node) < node.scrollHeight) return node;
    }
    return document;
};

});

parcelRegister("3fJEw", function(module, exports) {
"use strict";

var $c8UPi = parcelRequire("c8UPi");
module.exports = function scrollTop(node, val) {
    var win = $c8UPi(node);
    if (val === undefined) return win ? "pageYOffset" in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
    if (win) win.scrollTo("pageXOffset" in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);
    else node.scrollTop = val;
};

});

parcelRegister("c8eDJ", function(module, exports) {
"use strict";

var $uyd6r = parcelRequire("uyd6r");
var $8d51968da9fa797a$var$vendors = [
    "",
    "webkit",
    "moz",
    "o",
    "ms"
], $8d51968da9fa797a$var$cancel = "clearTimeout", $8d51968da9fa797a$var$raf = $8d51968da9fa797a$var$fallback, $8d51968da9fa797a$var$compatRaf;
var $8d51968da9fa797a$var$getKey = function getKey(vendor, k) {
    return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + "AnimationFrame";
};
if ($uyd6r) $8d51968da9fa797a$var$vendors.some(function(vendor) {
    var rafKey = $8d51968da9fa797a$var$getKey(vendor, "request");
    if (rafKey in window) {
        $8d51968da9fa797a$var$cancel = $8d51968da9fa797a$var$getKey(vendor, "cancel");
        return $8d51968da9fa797a$var$raf = function(cb) {
            return window[rafKey](cb);
        };
    }
});
/* https://github.com/component/raf */ var $8d51968da9fa797a$var$prev = new Date().getTime();
function $8d51968da9fa797a$var$fallback(fn) {
    var curr = new Date().getTime(), ms = Math.max(0, 16 - (curr - $8d51968da9fa797a$var$prev)), req = setTimeout(fn, ms);
    $8d51968da9fa797a$var$prev = curr;
    return req;
}
$8d51968da9fa797a$var$compatRaf = function(cb) {
    return $8d51968da9fa797a$var$raf(cb);
};
$8d51968da9fa797a$var$compatRaf.cancel = function(id) {
    return window[$8d51968da9fa797a$var$cancel](id);
};
module.exports = $8d51968da9fa797a$var$compatRaf;

});



parcelRegister("h64ZC", function(module, exports) {
"use strict";

var $2MXkj = parcelRequire("2MXkj");
module.exports = {
    propTypes: {
        isRtl: $2MXkj.bool
    },
    contextTypes: {
        isRtl: $2MXkj.bool
    },
    childContextTypes: {
        isRtl: $2MXkj.bool
    },
    getChildContext: function getChildContext() {
        return {
            isRtl: !!(this.props.isRtl || this.context && this.context.isRtl)
        };
    },
    isRtl: function isRtl() {
        return !!(this.props.isRtl || this.context && this.context.isRtl);
    }
};

});

parcelRegister("eC1mP", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $aa35acc685085069$var$FocusMixin;

var $9yNJk = parcelRequire("9yNJk");

var $cQuVG = parcelRequire("cQuVG");

var $gl4B1 = parcelRequire("gl4B1");
var $aa35acc685085069$var$_compat2 = $aa35acc685085069$var$_interopRequireDefault($gl4B1);
function $aa35acc685085069$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $aa35acc685085069$var$_applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object["keys"](descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ("value" in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object["defineProperty"](target, property, desc);
        desc = null;
    }
    return desc;
}
function $aa35acc685085069$var$FocusMixin(_ref) {
    var _desc, _value, _obj;
    var willHandle = _ref.willHandle, didHandle = _ref.didHandle;
    function _handleFocus(inst, focused, event) {
        var handler = inst.props[focused ? "onFocus" : "onBlur"];
        if (handler && event) event.persist();
        if (willHandle && willHandle.call(inst, focused, event) === false) return;
        inst.setTimeout("focus", function() {
            $aa35acc685085069$var$_compat2.default.batchedUpdates(function() {
                if (didHandle) didHandle.call(inst, focused, event);
                if (focused !== inst.state.focused) {
                    (0, $9yNJk.notify)(handler, event);
                    if (inst._mounted) inst.setState({
                        focused: focused
                    });
                }
            });
        });
    }
    return _obj = {
        handleBlur: function handleBlur(event) {
            _handleFocus(this, false, event);
        },
        handleFocus: function handleFocus(event) {
            _handleFocus(this, true, event);
        },
        componentDidMount: function componentDidMount() {
            this._mounted = true;
        },
        componentWillUnmount: function componentWillUnmount() {
            this._mounted = false;
        }
    }, $aa35acc685085069$var$_applyDecoratedDescriptor(_obj, "handleBlur", [
        $cQuVG.widgetEnabled
    ], Object.getOwnPropertyDescriptor(_obj, "handleBlur"), _obj), $aa35acc685085069$var$_applyDecoratedDescriptor(_obj, "handleFocus", [
        $cQuVG.widgetEnabled
    ], Object.getOwnPropertyDescriptor(_obj, "handleFocus"), _obj), _obj;
}
module.exports = module.exports["default"];

});


parcelRegister("fiBfu", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $b2356e460e0ad06a$var$_desc, $b2356e460e0ad06a$var$_value, $b2356e460e0ad06a$var$_obj;
var $b2356e460e0ad06a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $jbmdS = parcelRequire("jbmdS");
var $b2356e460e0ad06a$var$_react2 = $b2356e460e0ad06a$var$_interopRequireDefault($jbmdS);

var $2MXkj = parcelRequire("2MXkj");
var $b2356e460e0ad06a$var$_propTypes2 = $b2356e460e0ad06a$var$_interopRequireDefault($2MXkj);

var $e64Mn = parcelRequire("e64Mn");
var $b2356e460e0ad06a$var$_createReactClass2 = $b2356e460e0ad06a$var$_interopRequireDefault($e64Mn);

var $02LyB = parcelRequire("02LyB");
var $b2356e460e0ad06a$var$_classnames2 = $b2356e460e0ad06a$var$_interopRequireDefault($02LyB);

var $4ELyG = parcelRequire("4ELyG");
var $b2356e460e0ad06a$var$_3 = $b2356e460e0ad06a$var$_interopRequireDefault($4ELyG);

var $f8Des = parcelRequire("f8Des");
var $b2356e460e0ad06a$var$_filter2 = $b2356e460e0ad06a$var$_interopRequireDefault($f8Des);

var $ikauB = parcelRequire("ikauB");
var $b2356e460e0ad06a$var$_Widget2 = $b2356e460e0ad06a$var$_interopRequireDefault($ikauB);

var $iXqdK = parcelRequire("iXqdK");
var $b2356e460e0ad06a$var$_Popup2 = $b2356e460e0ad06a$var$_interopRequireDefault($iXqdK);

var $7Zb8H = parcelRequire("7Zb8H");
var $b2356e460e0ad06a$var$_Select2 = $b2356e460e0ad06a$var$_interopRequireDefault($7Zb8H);

var $iQRjr = parcelRequire("iQRjr");
var $b2356e460e0ad06a$var$_ComboboxInput2 = $b2356e460e0ad06a$var$_interopRequireDefault($iQRjr);

var $gl4B1 = parcelRequire("gl4B1");
var $b2356e460e0ad06a$var$_compat2 = $b2356e460e0ad06a$var$_interopRequireDefault($gl4B1);

var $iMXz6 = parcelRequire("iMXz6");
var $b2356e460e0ad06a$var$_propTypes4 = $b2356e460e0ad06a$var$_interopRequireDefault($iMXz6);

var $dPmvq = parcelRequire("dPmvq");
var $b2356e460e0ad06a$var$_List2 = $b2356e460e0ad06a$var$_interopRequireDefault($dPmvq);

var $kNt4v = parcelRequire("kNt4v");
var $b2356e460e0ad06a$var$_ListGroupable2 = $b2356e460e0ad06a$var$_interopRequireDefault($kNt4v);

var $eqJK2 = parcelRequire("eqJK2");
var $b2356e460e0ad06a$var$_validateListInterface2 = $b2356e460e0ad06a$var$_interopRequireDefault($eqJK2);

var $12xR0 = parcelRequire("12xR0");
var $b2356e460e0ad06a$var$_uncontrollable2 = $b2356e460e0ad06a$var$_interopRequireDefault($12xR0);

var $3gVwc = parcelRequire("3gVwc");

var $cQuVG = parcelRequire("cQuVG");

var $9yNJk = parcelRequire("9yNJk");
function $b2356e460e0ad06a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b2356e460e0ad06a$var$_applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object["keys"](descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ("value" in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object["defineProperty"](target, property, desc);
        desc = null;
    }
    return desc;
}
var $b2356e460e0ad06a$var$defaultSuggest = function defaultSuggest(f) {
    return f === true ? "startsWith" : f ? f : "eq";
};
var $b2356e460e0ad06a$var$propTypes = $b2356e460e0ad06a$var$_extends({}, $b2356e460e0ad06a$var$_Popup2.default.propTypes, {
    //-- controlled props -----------
    value: $b2356e460e0ad06a$var$_propTypes2.default.any,
    onChange: $b2356e460e0ad06a$var$_propTypes2.default.func,
    open: $b2356e460e0ad06a$var$_propTypes2.default.bool,
    onToggle: $b2356e460e0ad06a$var$_propTypes2.default.func,
    //------------------------------------
    itemComponent: $b2356e460e0ad06a$var$_propTypes4.default.elementType,
    listComponent: $b2356e460e0ad06a$var$_propTypes4.default.elementType,
    groupComponent: $b2356e460e0ad06a$var$_propTypes4.default.elementType,
    groupBy: $b2356e460e0ad06a$var$_propTypes4.default.accessor,
    data: $b2356e460e0ad06a$var$_propTypes2.default.array,
    valueField: $b2356e460e0ad06a$var$_propTypes2.default.string,
    textField: $b2356e460e0ad06a$var$_propTypes4.default.accessor,
    name: $b2356e460e0ad06a$var$_propTypes2.default.string,
    onSelect: $b2356e460e0ad06a$var$_propTypes2.default.func,
    autoFocus: $b2356e460e0ad06a$var$_propTypes2.default.bool,
    disabled: $b2356e460e0ad06a$var$_propTypes4.default.disabled.acceptsArray,
    readOnly: $b2356e460e0ad06a$var$_propTypes4.default.readOnly.acceptsArray,
    suggest: $b2356e460e0ad06a$var$_propTypes4.default.filter,
    filter: $b2356e460e0ad06a$var$_propTypes4.default.filter,
    busy: $b2356e460e0ad06a$var$_propTypes2.default.bool,
    dropUp: $b2356e460e0ad06a$var$_propTypes2.default.bool,
    duration: $b2356e460e0ad06a$var$_propTypes2.default.number,
    delay: $b2356e460e0ad06a$var$_propTypes2.default.number,
    placeholder: $b2356e460e0ad06a$var$_propTypes2.default.string,
    "aria-labelledby": $b2356e460e0ad06a$var$_propTypes2.default.string,
    "aria-describedby": $b2356e460e0ad06a$var$_propTypes2.default.string,
    messages: $b2356e460e0ad06a$var$_propTypes2.default.shape({
        open: $b2356e460e0ad06a$var$_propTypes4.default.message,
        emptyList: $b2356e460e0ad06a$var$_propTypes4.default.message,
        emptyFilter: $b2356e460e0ad06a$var$_propTypes4.default.message
    })
});






var $b2356e460e0ad06a$var$ComboBox = (0, $b2356e460e0ad06a$var$_createReactClass2.default)(($b2356e460e0ad06a$var$_obj = {
    displayName: "ComboBox",
    mixins: [
        (parcelRequire("7Hmlb")),
        (parcelRequire("asC0i")),
        (parcelRequire("602jV")),
        (parcelRequire("h64ZC")),
        (parcelRequire("aU65n"))("input"),
        (parcelRequire("eC1mP"))({
            willHandle: function willHandle(focused) {
                // not suggesting anymore
                !focused && this.refs.input.accept();
            },
            didHandle: function didHandle(focused) {
                if (!focused) this.close();
            }
        })
    ],
    propTypes: $b2356e460e0ad06a$var$propTypes,
    getInitialState: function getInitialState() {
        var _props = this.props, value = _props.value, data = _props.data, valueField = _props.valueField, items = this.process(data, value), idx = (0, $3gVwc.dataIndexOf)(items, value, valueField);
        return {
            selectedItem: items[idx],
            focusedItem: items[!~idx ? 0 : idx],
            processedData: items,
            open: false
        };
    },
    getDefaultProps: function getDefaultProps() {
        return {
            data: [],
            value: "",
            open: false,
            suggest: false,
            filter: false,
            delay: 500,
            messages: $b2356e460e0ad06a$var$msgs(),
            ariaActiveDescendantKey: "combobox"
        };
    },
    componentDidUpdate: function componentDidUpdate() {
        this.refs.list && (0, $b2356e460e0ad06a$var$_validateListInterface2.default)(this.refs.list);
    },
    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
        var isSuggesting = this.refs.input && this.refs.input.isSuggesting(), stateChanged = !$b2356e460e0ad06a$var$_3.default.isShallowEqual(nextState, this.state), valueChanged = !$b2356e460e0ad06a$var$_3.default.isShallowEqual(nextProps, this.props);
        return isSuggesting || stateChanged || valueChanged;
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        var value = nextProps.value, data = nextProps.data, valueField = nextProps.valueField, textField = nextProps.textField;
        var rawIdx = (0, $3gVwc.dataIndexOf)(data, value, valueField), valueItem = rawIdx === -1 ? nextProps.value : nextProps.data[rawIdx], isSuggesting = this.refs.input && this.refs.input.isSuggesting();
        var items = this.process(nextProps.data, nextProps.value, (rawIdx === -1 || isSuggesting) && (0, $3gVwc.dataText)(valueItem, textField));
        var idx = (0, $3gVwc.dataIndexOf)(items, value, valueField), focused = this.filterIndexOf(items, (0, $3gVwc.dataText)(valueItem, textField));
        this._searchTerm = "";
        this.setState({
            processedData: items,
            selectedItem: items[idx],
            focusedItem: items[idx === -1 ? focused !== -1 ? focused : 0 // focus the closest match
             : idx]
        });
    },
    renderInput: function renderInput(listID) {
        var _props2 = this.props, suggest = _props2.suggest, filter = _props2.filter, textField = _props2.textField, busy = _props2.busy, name = _props2.name, data = _props2.data, value = _props2.value, valueField = _props2.valueField, autoFocus = _props2.autoFocus, tabIndex = _props2.tabIndex, disabled = _props2.disabled, readOnly = _props2.readOnly, placeholder = _props2.placeholder, open = _props2.open, ariaLabelledby = _props2["aria-labelledby"], ariaDescribedby = _props2["aria-describedby"];
        var valueItem = (0, $3gVwc.dataItem)(data, value, valueField); // take value from the raw data
        var completeType = suggest ? filter ? "both" : "inline" : filter ? "list" : "";
        return $b2356e460e0ad06a$var$_react2.default.createElement($b2356e460e0ad06a$var$_ComboboxInput2.default, {
            ref: "input",
            id: (0, $9yNJk.instanceId)(this, "_input"),
            autoFocus: autoFocus,
            tabIndex: tabIndex,
            suggest: suggest,
            name: name,
            role: "combobox",
            disabled: disabled,
            readOnly: readOnly,
            "aria-owns": listID,
            "aria-busy": !!busy,
            "aria-autocomplete": completeType,
            "aria-expanded": open,
            "aria-haspopup": true,
            "aria-describedby": ariaDescribedby,
            "aria-labelledby": ariaLabelledby,
            placeholder: placeholder,
            value: (0, $3gVwc.dataText)(valueItem, textField),
            onChange: this.handleInputChange,
            onKeyDown: this.handleInputKeyDown
        });
    },
    renderList: function renderList(List, id, messages) {
        var _props3 = this.props, open = _props3.open, data = _props3.data;
        var _state = this.state, selectedItem = _state.selectedItem, focusedItem = _state.focusedItem;
        var listProps = $b2356e460e0ad06a$var$_3.default.pickProps(this.props, List);
        var items = this._data();
        return $b2356e460e0ad06a$var$_react2.default.createElement(List, $b2356e460e0ad06a$var$_extends({
            ref: "list"
        }, listProps, {
            id: id,
            data: items,
            selected: selectedItem,
            focused: focusedItem,
            "aria-hidden": !open,
            "aria-labelledby": (0, $9yNJk.instanceId)(this),
            "aria-live": open && "polite",
            onSelect: this.handleSelect,
            onMove: this._scrollTo,
            messages: {
                emptyList: data.length ? messages.emptyFilter : messages.emptyList
            }
        }));
    },
    render: function render() {
        var _this = this;
        var _props4 = this.props, className = _props4.className, duration = _props4.duration, groupBy = _props4.groupBy, messages = _props4.messages, busy = _props4.busy, dropUp = _props4.dropUp, open = _props4.open, List = _props4.listComponent;
        var focused = this.state.focused;
        var disabled = (0, $cQuVG.isDisabled)(this.props), readOnly = (0, $cQuVG.isReadOnly)(this.props), listID = (0, $9yNJk.instanceId)(this, "_listbox");
        List = List || groupBy && $b2356e460e0ad06a$var$_ListGroupable2.default || $b2356e460e0ad06a$var$_List2.default;
        var elementProps = $b2356e460e0ad06a$var$_3.default.omitOwnProps(this, List);
        var shouldRenderPopup = open || (0, $9yNJk.isFirstFocusedRender)(this);
        messages = $b2356e460e0ad06a$var$msgs(messages);
        return $b2356e460e0ad06a$var$_react2.default.createElement($b2356e460e0ad06a$var$_Widget2.default, $b2356e460e0ad06a$var$_extends({}, elementProps, {
            open: open,
            dropUp: dropUp,
            focused: focused,
            disabled: disabled,
            readOnly: readOnly,
            onBlur: this.handleBlur,
            onFocus: this.handleFocus,
            onKeyDown: this.handleKeyDown,
            className: (0, $b2356e460e0ad06a$var$_classnames2.default)(className, "rw-combobox")
        }), $b2356e460e0ad06a$var$_react2.default.createElement($b2356e460e0ad06a$var$_Select2.default, {
            onClick: this.toggle,
            disabled: !!(disabled || readOnly),
            busy: busy,
            icon: "caret-down",
            label: $b2356e460e0ad06a$var$_3.default.result(messages.open, this.props)
        }), this.renderInput(listID), shouldRenderPopup && $b2356e460e0ad06a$var$_react2.default.createElement($b2356e460e0ad06a$var$_Popup2.default, {
            open: open,
            dropUp: dropUp,
            duration: duration,
            onOpening: function onOpening() {
                return _this.refs.list.forceUpdate();
            }
        }, $b2356e460e0ad06a$var$_react2.default.createElement("div", null, this.renderList(List, listID, messages))));
    },
    handleSelect: function handleSelect(data) {
        this.close();
        (0, $9yNJk.notify)(this.props.onSelect, data);
        this.change(data);
        this.focus();
    },
    handleInputKeyDown: function handleInputKeyDown(e) {
        this._deleting = e.key === "Backspace" || e.key === "Delete";
        this._isTyping = true;
    },
    handleInputChange: function handleInputChange(e) {
        var _props5 = this.props, data = _props5.data, textField = _props5.textField;
        var shouldSuggest = !!this.props.suggest, strVal = e.target.value, suggestion;
        suggestion = this._deleting || !shouldSuggest ? strVal : this.suggest(this._data(), strVal);
        suggestion = suggestion || strVal;
        data = $b2356e460e0ad06a$var$_3.default.find(data, function(item) {
            return (0, $3gVwc.dataText)(item, textField).toLowerCase() === suggestion.toLowerCase();
        });
        this.change(!this._deleting && data ? data : strVal, true);
        this.open();
    },
    focus: function focus() {
        this.refs.input && this.refs.input.focus();
    },
    handleKeyDown: function handleKeyDown(e) {
        var self = this, key = e.key, alt = e.altKey, list = this.refs.list, focusedItem = this.state.focusedItem, selectedItem = this.state.selectedItem, isOpen = this.props.open;
        (0, $9yNJk.notify)(this.props.onKeyDown, [
            e
        ]);
        if (e.defaultPrevented) return;
        if (key === "End") {
            if (isOpen) this.setState({
                focusedItem: list.last()
            });
            else select(list.last(), true);
        } else if (key === "Home") {
            if (isOpen) this.setState({
                focusedItem: list.first()
            });
            else select(list.first(), true);
        } else if (key === "Escape" && isOpen) this.close();
        else if (key === "Enter" && isOpen) {
            e.preventDefault();
            select(this.state.focusedItem, true);
        } else if (key === "ArrowDown") {
            if (alt) this.open();
            else if (isOpen) this.setState({
                focusedItem: list.next(focusedItem)
            });
            else select(list.next(selectedItem), true);
        } else if (key === "ArrowUp") {
            if (alt) this.close();
            else if (isOpen) this.setState({
                focusedItem: list.prev(focusedItem)
            });
            else select(list.prev(selectedItem), true);
        }
        function select(item, fromList) {
            if (!item) return self.change($b2356e460e0ad06a$var$_compat2.default.findDOMNode(self.refs.input).value, false);
            self.refs.input.accept(true); //removes caret
            if (fromList) return self.handleSelect(item);
            self.change(item, false);
        }
    },
    change: function change(data, typing) {
        this._typedChange = !!typing;
        (0, $9yNJk.notify)(this.props.onChange, data);
    },
    open: function open() {
        if (!this.props.open) (0, $9yNJk.notify)(this.props.onToggle, true);
    },
    close: function close() {
        if (this.props.open) (0, $9yNJk.notify)(this.props.onToggle, false);
    },
    toggle: function toggle() {
        this.focus();
        this.props.open ? this.close() : this.open();
    },
    suggest: function suggest(data, value) {
        var _props6 = this.props, textField = _props6.textField, suggest = _props6.suggest, minLength = _props6.minLength;
        var word = (0, $3gVwc.dataText)(value, textField), suggestion;
        suggest = $b2356e460e0ad06a$var$defaultSuggest(suggest);
        if (!(word || "").trim() || word.length < (minLength || 1)) return "";
        suggestion = typeof value === "string" ? $b2356e460e0ad06a$var$_3.default.find(data, $b2356e460e0ad06a$var$getFilter(suggest, word, textField)) : value;
        if (suggestion && (!this.state || !this.state.deleting)) return (0, $3gVwc.dataText)(suggestion, textField);
        return "";
    },
    _data: function _data() {
        return this.state.processedData;
    },
    process: function process(data, values, searchTerm) {
        if (this.props.filter && searchTerm) data = this.filter(data, searchTerm);
        return data;
    }
}, $b2356e460e0ad06a$var$_applyDecoratedDescriptor($b2356e460e0ad06a$var$_obj, "handleSelect", [
    $cQuVG.widgetEditable
], Object.getOwnPropertyDescriptor($b2356e460e0ad06a$var$_obj, "handleSelect"), $b2356e460e0ad06a$var$_obj), $b2356e460e0ad06a$var$_applyDecoratedDescriptor($b2356e460e0ad06a$var$_obj, "handleKeyDown", [
    $cQuVG.widgetEditable
], Object.getOwnPropertyDescriptor($b2356e460e0ad06a$var$_obj, "handleKeyDown"), $b2356e460e0ad06a$var$_obj), $b2356e460e0ad06a$var$_applyDecoratedDescriptor($b2356e460e0ad06a$var$_obj, "toggle", [
    $cQuVG.widgetEditable
], Object.getOwnPropertyDescriptor($b2356e460e0ad06a$var$_obj, "toggle"), $b2356e460e0ad06a$var$_obj), $b2356e460e0ad06a$var$_obj));
module.exports.default = (0, $b2356e460e0ad06a$var$_uncontrollable2.default)($b2356e460e0ad06a$var$ComboBox, {
    open: "onToggle",
    value: "onChange"
}, [
    "focus"
]);
function $b2356e460e0ad06a$var$msgs(msgs) {
    return $b2356e460e0ad06a$var$_extends({
        open: "open combobox",
        emptyList: "There are no items in this list",
        emptyFilter: "The filter returned no results"
    }, msgs);
}
function $b2356e460e0ad06a$var$getFilter(suggest, word, textField) {
    return typeof suggest === "string" ? function(item) {
        return $b2356e460e0ad06a$var$_filter2.default[suggest]((0, $3gVwc.dataText)(item, textField).toLowerCase(), word.toLowerCase());
    } : function(item) {
        return suggest(item, word);
    };
}
module.exports = module.exports["default"];

});
parcelRegister("iQRjr", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $db96701b8ebeea8b$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $jbmdS = parcelRequire("jbmdS");
var $db96701b8ebeea8b$var$_react2 = $db96701b8ebeea8b$var$_interopRequireDefault($jbmdS);

var $2MXkj = parcelRequire("2MXkj");
var $db96701b8ebeea8b$var$_propTypes2 = $db96701b8ebeea8b$var$_interopRequireDefault($2MXkj);

var $e64Mn = parcelRequire("e64Mn");
var $db96701b8ebeea8b$var$_createReactClass2 = $db96701b8ebeea8b$var$_interopRequireDefault($e64Mn);

var $4ELyG = parcelRequire("4ELyG");
var $db96701b8ebeea8b$var$_3 = $db96701b8ebeea8b$var$_interopRequireDefault($4ELyG);

var $36SWv = parcelRequire("36SWv");
var $db96701b8ebeea8b$var$_caret2 = $db96701b8ebeea8b$var$_interopRequireDefault($36SWv);

var $gl4B1 = parcelRequire("gl4B1");
var $db96701b8ebeea8b$var$_compat2 = $db96701b8ebeea8b$var$_interopRequireDefault($gl4B1);

var $il45H = parcelRequire("il45H");
var $db96701b8ebeea8b$var$_Input2 = $db96701b8ebeea8b$var$_interopRequireDefault($il45H);
function $db96701b8ebeea8b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $db96701b8ebeea8b$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
module.exports.default = (0, $db96701b8ebeea8b$var$_createReactClass2.default)({
    displayName: "ComboboxInput",
    propTypes: {
        value: $db96701b8ebeea8b$var$_propTypes2.default.string,
        suggest: $db96701b8ebeea8b$var$_propTypes2.default.bool,
        onChange: $db96701b8ebeea8b$var$_propTypes2.default.func.isRequired
    },
    componentDidUpdate: function componentDidUpdate() {
        var input = $db96701b8ebeea8b$var$_compat2.default.findDOMNode(this), val = this.props.value;
        if (this.isSuggesting()) {
            var start = val.toLowerCase().indexOf(this._last.toLowerCase()) + this._last.length, end = val.length - start;
            if (start >= 0) (0, $db96701b8ebeea8b$var$_caret2.default)(input, start, start + end);
        }
    },
    getDefaultProps: function getDefaultProps() {
        return {
            value: ""
        };
    },
    render: function render() {
        var _props = this.props, onKeyDown = _props.onKeyDown, props = $db96701b8ebeea8b$var$_objectWithoutProperties(_props, [
            "onKeyDown"
        ]);
        delete props.suggest;
        return $db96701b8ebeea8b$var$_react2.default.createElement($db96701b8ebeea8b$var$_Input2.default, $db96701b8ebeea8b$var$_extends({}, props, {
            onKeyDown: onKeyDown,
            onChange: this.handleChange
        }));
    },
    isSuggesting: function isSuggesting() {
        var val = this.props.value, isSuggestion = this._last != null && val.toLowerCase().indexOf(this._last.toLowerCase()) !== -1;
        return this.props.suggest && isSuggestion;
    },
    accept: function accept(removeCaret) {
        var val = $db96701b8ebeea8b$var$_compat2.default.findDOMNode(this).value || "", end = val.length;
        this._last = null;
        removeCaret && (0, $db96701b8ebeea8b$var$_caret2.default)($db96701b8ebeea8b$var$_compat2.default.findDOMNode(this), end, end);
    },
    handleChange: function handleChange(e) {
        var val = e.target.value, pl = !!this.props.placeholder;
        // IE fires input events when setting/unsetting placeholders.
        // issue #112
        if (pl && !val && val === (this.props.value || "")) return;
        this._last = val;
        this.props.onChange(e, val);
    },
    focus: function focus() {
        $db96701b8ebeea8b$var$_compat2.default.findDOMNode(this).focus();
    }
});
module.exports = module.exports["default"];

});
parcelRegister("36SWv", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $243c8d14f7681c7e$var$caret;
/*eslint-disable no-empty */ function $243c8d14f7681c7e$var$caret(el, start, end) {
    if (start === undefined) return $243c8d14f7681c7e$var$get(el);
    $243c8d14f7681c7e$var$set(el, start, end);
}
function $243c8d14f7681c7e$var$get(el) {
    var start, end, rangeEl, clone;
    if (el.selectionStart !== undefined) {
        start = el.selectionStart;
        end = el.selectionEnd;
    } else try {
        el.focus();
        rangeEl = el.createTextRange();
        clone = rangeEl.duplicate();
        rangeEl.moveToBookmark(document.selection.createRange().getBookmark());
        clone.setEndPoint("EndToStart", rangeEl);
        start = clone.text.length;
        end = start + rangeEl.text.length;
    } catch (e) {}
    return {
        start: start,
        end: end
    };
}
function $243c8d14f7681c7e$var$set(el, start, end) {
    var rangeEl;
    try {
        if (el.selectionStart !== undefined) {
            el.focus();
            el.setSelectionRange(start, end);
        } else {
            el.focus();
            rangeEl = el.createTextRange();
            rangeEl.collapse(true);
            rangeEl.moveStart("character", start);
            rangeEl.moveEnd("character", end - start);
            rangeEl.select();
        }
    } catch (e) {}
}
module.exports = module.exports["default"];

});



parcelRegister("l3yHc", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $f544caa87f1f5546$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $f544caa87f1f5546$var$_VIEW, $f544caa87f1f5546$var$_OPPOSITE_DIRECTION, $f544caa87f1f5546$var$_MULTIPLIER, $f544caa87f1f5546$var$_desc, $f544caa87f1f5546$var$_value2, $f544caa87f1f5546$var$_obj; //values, omit

var $jbmdS = parcelRequire("jbmdS");
var $f544caa87f1f5546$var$_react2 = $f544caa87f1f5546$var$_interopRequireDefault($jbmdS);

var $2MXkj = parcelRequire("2MXkj");
var $f544caa87f1f5546$var$_propTypes2 = $f544caa87f1f5546$var$_interopRequireDefault($2MXkj);

var $e64Mn = parcelRequire("e64Mn");
var $f544caa87f1f5546$var$_createReactClass2 = $f544caa87f1f5546$var$_interopRequireDefault($e64Mn);

var $02LyB = parcelRequire("02LyB");
var $f544caa87f1f5546$var$_classnames2 = $f544caa87f1f5546$var$_interopRequireDefault($02LyB);

var $gl4B1 = parcelRequire("gl4B1");
var $f544caa87f1f5546$var$_compat2 = $f544caa87f1f5546$var$_interopRequireDefault($gl4B1);

var $ikauB = parcelRequire("ikauB");
var $f544caa87f1f5546$var$_Widget2 = $f544caa87f1f5546$var$_interopRequireDefault($ikauB);

var $b40MY = parcelRequire("b40MY");
var $f544caa87f1f5546$var$_Header2 = $f544caa87f1f5546$var$_interopRequireDefault($b40MY);

var $kN3mU = parcelRequire("kN3mU");
var $f544caa87f1f5546$var$_Footer2 = $f544caa87f1f5546$var$_interopRequireDefault($kN3mU);

var $cdebc = parcelRequire("cdebc");
var $f544caa87f1f5546$var$_Month2 = $f544caa87f1f5546$var$_interopRequireDefault($cdebc);

var $bYFQH = parcelRequire("bYFQH");
var $f544caa87f1f5546$var$_Year2 = $f544caa87f1f5546$var$_interopRequireDefault($bYFQH);

var $bitaB = parcelRequire("bitaB");
var $f544caa87f1f5546$var$_Decade2 = $f544caa87f1f5546$var$_interopRequireDefault($bitaB);

var $98flU = parcelRequire("98flU");
var $f544caa87f1f5546$var$_Century2 = $f544caa87f1f5546$var$_interopRequireDefault($98flU);

var $7fTd5 = parcelRequire("7fTd5");

var $iMXz6 = parcelRequire("iMXz6");
var $f544caa87f1f5546$var$_propTypes4 = $f544caa87f1f5546$var$_interopRequireDefault($iMXz6);

var $12xR0 = parcelRequire("12xR0");
var $f544caa87f1f5546$var$_uncontrollable2 = $f544caa87f1f5546$var$_interopRequireDefault($12xR0);

var $abgZr = parcelRequire("abgZr");
var $f544caa87f1f5546$var$_SlideTransition2 = $f544caa87f1f5546$var$_interopRequireDefault($abgZr);

var $bXvdn = parcelRequire("bXvdn");
var $f544caa87f1f5546$var$_dates2 = $f544caa87f1f5546$var$_interopRequireDefault($bXvdn);

var $7XXyP = parcelRequire("7XXyP");
var $f544caa87f1f5546$var$constants = $f544caa87f1f5546$var$_interopRequireWildcard($7XXyP);

var $4ELyG = parcelRequire("4ELyG");
var $f544caa87f1f5546$var$_3 = $f544caa87f1f5546$var$_interopRequireDefault($4ELyG);

var $9yNJk = parcelRequire("9yNJk");

var $cQuVG = parcelRequire("cQuVG");
function $f544caa87f1f5546$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $f544caa87f1f5546$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f544caa87f1f5546$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $f544caa87f1f5546$var$_applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object["keys"](descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ("value" in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object["defineProperty"](target, property, desc);
        desc = null;
    }
    return desc;
}
var $f544caa87f1f5546$var$dir = $f544caa87f1f5546$var$constants.directions, $f544caa87f1f5546$var$values = function values(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
}, $f544caa87f1f5546$var$invert = function invert(obj) {
    return $f544caa87f1f5546$var$_3.default.transform(obj, function(o, val, key) {
        o[val] = key;
    }, {});
};
var $f544caa87f1f5546$var$views = $f544caa87f1f5546$var$constants.calendarViews, $f544caa87f1f5546$var$VIEW_OPTIONS = $f544caa87f1f5546$var$values($f544caa87f1f5546$var$views), $f544caa87f1f5546$var$ALT_VIEW = $f544caa87f1f5546$var$invert($f544caa87f1f5546$var$constants.calendarViewHierarchy), $f544caa87f1f5546$var$NEXT_VIEW = $f544caa87f1f5546$var$constants.calendarViewHierarchy, $f544caa87f1f5546$var$VIEW_UNIT = $f544caa87f1f5546$var$constants.calendarViewUnits, $f544caa87f1f5546$var$VIEW = ($f544caa87f1f5546$var$_VIEW = {}, $f544caa87f1f5546$var$_VIEW[$f544caa87f1f5546$var$views.MONTH] = $f544caa87f1f5546$var$_Month2.default, $f544caa87f1f5546$var$_VIEW[$f544caa87f1f5546$var$views.YEAR] = $f544caa87f1f5546$var$_Year2.default, $f544caa87f1f5546$var$_VIEW[$f544caa87f1f5546$var$views.DECADE] = $f544caa87f1f5546$var$_Decade2.default, $f544caa87f1f5546$var$_VIEW[$f544caa87f1f5546$var$views.CENTURY] = $f544caa87f1f5546$var$_Century2.default, $f544caa87f1f5546$var$_VIEW);
var $f544caa87f1f5546$var$ARROWS_TO_DIRECTION = {
    ArrowDown: $f544caa87f1f5546$var$dir.DOWN,
    ArrowUp: $f544caa87f1f5546$var$dir.UP,
    ArrowRight: $f544caa87f1f5546$var$dir.RIGHT,
    ArrowLeft: $f544caa87f1f5546$var$dir.LEFT
};
var $f544caa87f1f5546$var$OPPOSITE_DIRECTION = ($f544caa87f1f5546$var$_OPPOSITE_DIRECTION = {}, $f544caa87f1f5546$var$_OPPOSITE_DIRECTION[$f544caa87f1f5546$var$dir.LEFT] = $f544caa87f1f5546$var$dir.RIGHT, $f544caa87f1f5546$var$_OPPOSITE_DIRECTION[$f544caa87f1f5546$var$dir.RIGHT] = $f544caa87f1f5546$var$dir.LEFT, $f544caa87f1f5546$var$_OPPOSITE_DIRECTION);
var $f544caa87f1f5546$var$MULTIPLIER = ($f544caa87f1f5546$var$_MULTIPLIER = {}, $f544caa87f1f5546$var$_MULTIPLIER[$f544caa87f1f5546$var$views.YEAR] = 1, $f544caa87f1f5546$var$_MULTIPLIER[$f544caa87f1f5546$var$views.DECADE] = 10, $f544caa87f1f5546$var$_MULTIPLIER[$f544caa87f1f5546$var$views.CENTURY] = 100, $f544caa87f1f5546$var$_MULTIPLIER);
var $f544caa87f1f5546$var$format = function format(props, f) {
    return $7fTd5.date.getFormat(f, props[f + "Format"]);
};
var $f544caa87f1f5546$var$propTypes = {
    disabled: $f544caa87f1f5546$var$_propTypes4.default.disabled,
    readOnly: $f544caa87f1f5546$var$_propTypes4.default.readOnly,
    onChange: $f544caa87f1f5546$var$_propTypes2.default.func,
    value: $f544caa87f1f5546$var$_propTypes2.default.instanceOf(Date),
    min: $f544caa87f1f5546$var$_propTypes2.default.instanceOf(Date),
    max: $f544caa87f1f5546$var$_propTypes2.default.instanceOf(Date),
    currentDate: $f544caa87f1f5546$var$_propTypes2.default.instanceOf(Date),
    onCurrentDateChange: $f544caa87f1f5546$var$_propTypes2.default.func,
    view: $f544caa87f1f5546$var$_propTypes2.default.oneOf($f544caa87f1f5546$var$VIEW_OPTIONS),
    initialView: $f544caa87f1f5546$var$_propTypes2.default.oneOf($f544caa87f1f5546$var$VIEW_OPTIONS),
    finalView: function finalView(props, propName, componentName) {
        for(var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)args[_key - 3] = arguments[_key];
        var err = $f544caa87f1f5546$var$_propTypes2.default.oneOf($f544caa87f1f5546$var$VIEW_OPTIONS).apply(undefined, [
            props,
            propName,
            componentName
        ].concat(args));
        if (err) return err;
        if ($f544caa87f1f5546$var$VIEW_OPTIONS.indexOf(props[propName]) < $f544caa87f1f5546$var$VIEW_OPTIONS.indexOf(props.initialView)) return new Error(("The `" + propName + "` prop: `" + props[propName] + "` cannot be 'lower' than the `initialView`\n        prop. This creates a range that cannot be rendered.").replace(/\n\t/g, ""));
    },
    onViewChange: $f544caa87f1f5546$var$_propTypes2.default.func,
    onNavigate: $f544caa87f1f5546$var$_propTypes2.default.func,
    culture: $f544caa87f1f5546$var$_propTypes2.default.string,
    footer: $f544caa87f1f5546$var$_propTypes2.default.bool,
    dayComponent: $f544caa87f1f5546$var$_propTypes4.default.elementType,
    headerFormat: $f544caa87f1f5546$var$_propTypes4.default.dateFormat,
    footerFormat: $f544caa87f1f5546$var$_propTypes4.default.dateFormat,
    dayFormat: $f544caa87f1f5546$var$_propTypes4.default.dateFormat,
    dateFormat: $f544caa87f1f5546$var$_propTypes4.default.dateFormat,
    monthFormat: $f544caa87f1f5546$var$_propTypes4.default.dateFormat,
    yearFormat: $f544caa87f1f5546$var$_propTypes4.default.dateFormat,
    decadeFormat: $f544caa87f1f5546$var$_propTypes4.default.dateFormat,
    centuryFormat: $f544caa87f1f5546$var$_propTypes4.default.dateFormat,
    messages: $f544caa87f1f5546$var$_propTypes2.default.shape({
        moveBack: $f544caa87f1f5546$var$_propTypes2.default.string,
        moveForward: $f544caa87f1f5546$var$_propTypes2.default.string
    })
};






var $f544caa87f1f5546$var$Calendar = (0, $f544caa87f1f5546$var$_createReactClass2.default)(($f544caa87f1f5546$var$_obj = {
    displayName: "Calendar",
    mixins: [
        (parcelRequire("7Hmlb")),
        (parcelRequire("gYehs")),
        (parcelRequire("7xDAs")),
        (parcelRequire("h64ZC")),
        (parcelRequire("aU65n"))(),
        (parcelRequire("eC1mP"))({
            willHandle: function willHandle() {
                if (+this.props.tabIndex === -1) return false;
            }
        })
    ],
    propTypes: $f544caa87f1f5546$var$propTypes,
    getInitialState: function getInitialState() {
        return {
            selectedIndex: 0,
            view: this.props.initialView || "month"
        };
    },
    getDefaultProps: function getDefaultProps() {
        return {
            value: null,
            min: new Date(1900, 0, 1),
            max: new Date(2099, 11, 31),
            currentDate: new Date(),
            initialView: "month",
            finalView: "century",
            tabIndex: "0",
            footer: false,
            ariaActiveDescendantKey: "calendar",
            messages: $f544caa87f1f5546$var$msgs({})
        };
    },
    componentWillMount: function componentWillMount() {
        this.changeCurrentDate(this.props.value);
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        var bottom = $f544caa87f1f5546$var$VIEW_OPTIONS.indexOf(nextProps.initialView), top = $f544caa87f1f5546$var$VIEW_OPTIONS.indexOf(nextProps.finalView), current = $f544caa87f1f5546$var$VIEW_OPTIONS.indexOf(this.state.view), view = this.state.view, val = this.inRangeValue(nextProps.value);
        if (current < bottom) this.setState({
            view: view = nextProps.initialView
        });
        else if (current > top) this.setState({
            view: view = nextProps.finalView
        });
        //if the value changes reset views to the new one
        if (!$f544caa87f1f5546$var$_dates2.default.eq(val, $f544caa87f1f5546$var$dateOrNull(this.props.value), $f544caa87f1f5546$var$VIEW_UNIT[view])) this.changeCurrentDate(val, nextProps.currentDate);
    },
    render: function render() {
        var _this = this;
        var _props = this.props, className = _props.className, value = _props.value, footerFormat = _props.footerFormat, disabled = _props.disabled, readOnly = _props.readOnly, finalView = _props.finalView, footer = _props.footer, messages = _props.messages, min = _props.min, max = _props.max, culture = _props.culture, duration = _props.duration, tabIndex = _props.tabIndex, currentDate = _props.currentDate;
        var _state = this.state, view = _state.view, slideDirection = _state.slideDirection, focused = _state.focused;
        var View = $f544caa87f1f5546$var$VIEW[view], unit = $f544caa87f1f5546$var$VIEW_UNIT[view], todaysDate = new Date(), todayNotInRange = !$f544caa87f1f5546$var$_dates2.default.inRange(todaysDate, min, max, view);
        unit = unit === "day" ? "date" : unit;
        var viewID = (0, $9yNJk.instanceId)(this, "_calendar"), labelID = (0, $9yNJk.instanceId)(this, "_calendar_label"), key = view + "_" + $f544caa87f1f5546$var$_dates2.default[view](currentDate);
        var elementProps = $f544caa87f1f5546$var$_3.default.omitOwnProps(this), viewProps = $f544caa87f1f5546$var$_3.default.pickProps(this.props, View);
        var isDisabled = disabled || readOnly;
        messages = $f544caa87f1f5546$var$msgs(this.props.messages);
        return $f544caa87f1f5546$var$_react2.default.createElement($f544caa87f1f5546$var$_Widget2.default, $f544caa87f1f5546$var$_extends({}, elementProps, {
            role: "group",
            focused: focused,
            disabled: disabled,
            readOnly: readOnly,
            tabIndex: tabIndex || 0,
            onBlur: this.handleBlur,
            onFocus: this.handleFocus,
            onKeyDown: this.handleKeyDown,
            className: (0, $f544caa87f1f5546$var$_classnames2.default)(className, "rw-calendar")
        }), $f544caa87f1f5546$var$_react2.default.createElement($f544caa87f1f5546$var$_Header2.default, {
            label: this._label(),
            labelId: labelID,
            messages: messages,
            upDisabled: isDisabled || view === finalView,
            prevDisabled: isDisabled || !$f544caa87f1f5546$var$_dates2.default.inRange(this.nextDate($f544caa87f1f5546$var$dir.LEFT), min, max, view),
            nextDisabled: isDisabled || !$f544caa87f1f5546$var$_dates2.default.inRange(this.nextDate($f544caa87f1f5546$var$dir.RIGHT), min, max, view),
            onViewChange: this.navigate.bind(null, $f544caa87f1f5546$var$dir.UP, null),
            onMoveLeft: this.navigate.bind(null, $f544caa87f1f5546$var$dir.LEFT, null),
            onMoveRight: this.navigate.bind(null, $f544caa87f1f5546$var$dir.RIGHT, null)
        }), $f544caa87f1f5546$var$_react2.default.createElement($f544caa87f1f5546$var$_SlideTransition2.default, {
            ref: "animation",
            duration: duration,
            direction: slideDirection,
            onAnimate: function onAnimate() {
                return focused && _this.focus();
            }
        }, $f544caa87f1f5546$var$_react2.default.createElement(View, $f544caa87f1f5546$var$_extends({}, viewProps, {
            key: key,
            id: viewID,
            value: value,
            today: todaysDate,
            focused: currentDate,
            onChange: this.change,
            onKeyDown: this.handleKeyDown,
            "aria-labelledby": labelID,
            ariaActiveDescendantKey: "calendarView"
        }))), footer && $f544caa87f1f5546$var$_react2.default.createElement($f544caa87f1f5546$var$_Footer2.default, {
            value: todaysDate,
            format: footerFormat,
            culture: culture,
            disabled: disabled || todayNotInRange,
            readOnly: readOnly,
            onClick: this.select
        }));
    },
    navigate: function navigate(direction, date) {
        var view = this.state.view, slideDir = direction === $f544caa87f1f5546$var$dir.LEFT || direction === $f544caa87f1f5546$var$dir.UP ? "right" : "left";
        if (!date) date = [
            $f544caa87f1f5546$var$dir.LEFT,
            $f544caa87f1f5546$var$dir.RIGHT
        ].indexOf(direction) !== -1 ? this.nextDate(direction) : this.props.currentDate;
        if (direction === $f544caa87f1f5546$var$dir.DOWN) view = $f544caa87f1f5546$var$ALT_VIEW[view] || view;
        if (direction === $f544caa87f1f5546$var$dir.UP) view = $f544caa87f1f5546$var$NEXT_VIEW[view] || view;
        if (this.isValidView(view) && $f544caa87f1f5546$var$_dates2.default.inRange(date, this.props.min, this.props.max, view)) {
            (0, $9yNJk.notify)(this.props.onNavigate, [
                date,
                slideDir,
                view
            ]);
            this.focus(true);
            this.changeCurrentDate(date);
            this.setState({
                slideDirection: slideDir,
                view: view
            });
        }
    },
    focus: function focus() {
        if (+this.props.tabIndex > -1) $f544caa87f1f5546$var$_compat2.default.findDOMNode(this).focus();
    },
    change: function change(date) {
        if (this.state.view === this.props.initialView) {
            this.changeCurrentDate(date);
            (0, $9yNJk.notify)(this.props.onChange, date);
            this.focus();
            return;
        }
        this.navigate($f544caa87f1f5546$var$dir.DOWN, date);
    },
    changeCurrentDate: function changeCurrentDate(date) {
        var currentDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.currentDate;
        var inRangeDate = this.inRangeValue(date ? new Date(date) : currentDate);
        if ($f544caa87f1f5546$var$_dates2.default.eq(inRangeDate, $f544caa87f1f5546$var$dateOrNull(currentDate), $f544caa87f1f5546$var$VIEW_UNIT[this.state.view])) return;
        (0, $9yNJk.notify)(this.props.onCurrentDateChange, inRangeDate);
    },
    select: function select(date) {
        var view = this.props.initialView, slideDir = view !== this.state.view || $f544caa87f1f5546$var$_dates2.default.gt(date, this.state.currentDate) ? "left" // move down to a the view
         : "right";
        (0, $9yNJk.notify)(this.props.onChange, date);
        if (this.isValidView(view) && $f544caa87f1f5546$var$_dates2.default.inRange(date, this.props.min, this.props.max, view)) {
            this.focus();
            this.changeCurrentDate(date);
            this.setState({
                slideDirection: slideDir,
                view: view
            });
        }
    },
    nextDate: function nextDate(direction) {
        var method = direction === $f544caa87f1f5546$var$dir.LEFT ? "subtract" : "add", view = this.state.view, unit = view === $f544caa87f1f5546$var$views.MONTH ? view : $f544caa87f1f5546$var$views.YEAR, multi = $f544caa87f1f5546$var$MULTIPLIER[view] || 1;
        return $f544caa87f1f5546$var$_dates2.default[method](this.props.currentDate, 1 * multi, unit);
    },
    handleKeyDown: function handleKeyDown(e) {
        var ctrl = e.ctrlKey, key = e.key, direction = $f544caa87f1f5546$var$ARROWS_TO_DIRECTION[key], current = this.props.currentDate, view = this.state.view, unit = $f544caa87f1f5546$var$VIEW_UNIT[view], currentDate = current;
        if (key === "Enter") {
            e.preventDefault();
            return this.change(current);
        }
        if (direction) {
            if (ctrl) {
                e.preventDefault();
                this.navigate(direction);
            } else {
                if (this.isRtl() && $f544caa87f1f5546$var$OPPOSITE_DIRECTION[direction]) direction = $f544caa87f1f5546$var$OPPOSITE_DIRECTION[direction];
                currentDate = $f544caa87f1f5546$var$_dates2.default.move(currentDate, this.props.min, this.props.max, view, direction);
                if (!$f544caa87f1f5546$var$_dates2.default.eq(current, currentDate, unit)) {
                    e.preventDefault();
                    if ($f544caa87f1f5546$var$_dates2.default.gt(currentDate, current, view)) this.navigate($f544caa87f1f5546$var$dir.RIGHT, currentDate);
                    else if ($f544caa87f1f5546$var$_dates2.default.lt(currentDate, current, view)) this.navigate($f544caa87f1f5546$var$dir.LEFT, currentDate);
                    else this.changeCurrentDate(currentDate);
                }
            }
        }
        (0, $9yNJk.notify)(this.props.onKeyDown, [
            e
        ]);
    },
    _label: function _label() {
        var _props2 = this.props, culture = _props2.culture, props = $f544caa87f1f5546$var$_objectWithoutProperties(_props2, [
            "culture"
        ]), view = this.state.view, dt = this.props.currentDate;
        if (view === "month") return $7fTd5.date.format(dt, $f544caa87f1f5546$var$format(props, "header"), culture);
        else if (view === "year") return $7fTd5.date.format(dt, $f544caa87f1f5546$var$format(props, "year"), culture);
        else if (view === "decade") return $7fTd5.date.format($f544caa87f1f5546$var$_dates2.default.startOf(dt, "decade"), $f544caa87f1f5546$var$format(props, "decade"), culture);
        else if (view === "century") return $7fTd5.date.format($f544caa87f1f5546$var$_dates2.default.startOf(dt, "century"), $f544caa87f1f5546$var$format(props, "century"), culture);
    },
    inRangeValue: function inRangeValue(_value) {
        var value = $f544caa87f1f5546$var$dateOrNull(_value);
        if (value === null) return value;
        return $f544caa87f1f5546$var$_dates2.default.max($f544caa87f1f5546$var$_dates2.default.min(value, this.props.max), this.props.min);
    },
    isValidView: function isValidView(next) {
        var bottom = $f544caa87f1f5546$var$VIEW_OPTIONS.indexOf(this.props.initialView), top = $f544caa87f1f5546$var$VIEW_OPTIONS.indexOf(this.props.finalView), current = $f544caa87f1f5546$var$VIEW_OPTIONS.indexOf(next);
        return current >= bottom && current <= top;
    }
}, $f544caa87f1f5546$var$_applyDecoratedDescriptor($f544caa87f1f5546$var$_obj, "navigate", [
    $cQuVG.widgetEditable
], Object.getOwnPropertyDescriptor($f544caa87f1f5546$var$_obj, "navigate"), $f544caa87f1f5546$var$_obj), $f544caa87f1f5546$var$_applyDecoratedDescriptor($f544caa87f1f5546$var$_obj, "change", [
    $cQuVG.widgetEditable
], Object.getOwnPropertyDescriptor($f544caa87f1f5546$var$_obj, "change"), $f544caa87f1f5546$var$_obj), $f544caa87f1f5546$var$_applyDecoratedDescriptor($f544caa87f1f5546$var$_obj, "select", [
    $cQuVG.widgetEditable
], Object.getOwnPropertyDescriptor($f544caa87f1f5546$var$_obj, "select"), $f544caa87f1f5546$var$_obj), $f544caa87f1f5546$var$_applyDecoratedDescriptor($f544caa87f1f5546$var$_obj, "handleKeyDown", [
    $cQuVG.widgetEditable
], Object.getOwnPropertyDescriptor($f544caa87f1f5546$var$_obj, "handleKeyDown"), $f544caa87f1f5546$var$_obj), $f544caa87f1f5546$var$_obj));
function $f544caa87f1f5546$var$dateOrNull(dt) {
    if (dt && !isNaN(dt.getTime())) return dt;
    return null;
}
function $f544caa87f1f5546$var$msgs(msgs) {
    return $f544caa87f1f5546$var$_extends({
        moveBack: "navigate back",
        moveForward: "navigate forward"
    }, msgs);
}
module.exports.default = (0, $f544caa87f1f5546$var$_uncontrollable2.default)($f544caa87f1f5546$var$Calendar, {
    value: "onChange",
    currentDate: "onCurrentDateChange",
    view: "onViewChange"
}, [
    "focus"
]);
module.exports = module.exports["default"];

});
parcelRegister("b40MY", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $jbmdS = parcelRequire("jbmdS");
var $80e0ae1054720390$var$_react2 = $80e0ae1054720390$var$_interopRequireDefault($jbmdS);

var $2MXkj = parcelRequire("2MXkj");
var $80e0ae1054720390$var$_propTypes2 = $80e0ae1054720390$var$_interopRequireDefault($2MXkj);

var $e64Mn = parcelRequire("e64Mn");
var $80e0ae1054720390$var$_createReactClass2 = $80e0ae1054720390$var$_interopRequireDefault($e64Mn);

var $lPWfx = parcelRequire("lPWfx");
var $80e0ae1054720390$var$_Button2 = $80e0ae1054720390$var$_interopRequireDefault($lPWfx);
function $80e0ae1054720390$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}


module.exports.default = (0, $80e0ae1054720390$var$_createReactClass2.default)({
    displayName: "Header",
    propTypes: {
        label: $80e0ae1054720390$var$_propTypes2.default.string.isRequired,
        labelId: $80e0ae1054720390$var$_propTypes2.default.string,
        upDisabled: $80e0ae1054720390$var$_propTypes2.default.bool.isRequired,
        prevDisabled: $80e0ae1054720390$var$_propTypes2.default.bool.isRequired,
        nextDisabled: $80e0ae1054720390$var$_propTypes2.default.bool.isRequired,
        onViewChange: $80e0ae1054720390$var$_propTypes2.default.func.isRequired,
        onMoveLeft: $80e0ae1054720390$var$_propTypes2.default.func.isRequired,
        onMoveRight: $80e0ae1054720390$var$_propTypes2.default.func.isRequired,
        messages: $80e0ae1054720390$var$_propTypes2.default.shape({
            moveBack: $80e0ae1054720390$var$_propTypes2.default.string,
            moveForward: $80e0ae1054720390$var$_propTypes2.default.string
        })
    },
    mixins: [
        (parcelRequire("7xDAs")),
        (parcelRequire("8BrGQ"))
    ],
    getDefaultProps: function getDefaultProps() {
        return {
            messages: {
                moveBack: "navigate back",
                moveForward: "navigate forward"
            }
        };
    },
    render: function render() {
        var _props = this.props, messages = _props.messages, label = _props.label, labelId = _props.labelId, onMoveRight = _props.onMoveRight, onMoveLeft = _props.onMoveLeft, onViewChange = _props.onViewChange, prevDisabled = _props.prevDisabled, upDisabled = _props.upDisabled, nextDisabled = _props.nextDisabled;
        var rtl = this.isRtl();
        return $80e0ae1054720390$var$_react2.default.createElement("div", {
            className: "rw-header"
        }, $80e0ae1054720390$var$_react2.default.createElement($80e0ae1054720390$var$_Button2.default, {
            className: "rw-btn-left",
            onClick: onMoveLeft,
            disabled: prevDisabled,
            label: messages.moveBack,
            icon: "caret-" + (rtl ? "right" : "left")
        }), $80e0ae1054720390$var$_react2.default.createElement($80e0ae1054720390$var$_Button2.default, {
            id: labelId,
            onClick: onViewChange,
            className: "rw-btn-view",
            disabled: upDisabled,
            "aria-live": "polite",
            "aria-atomic": "true"
        }, label), $80e0ae1054720390$var$_react2.default.createElement($80e0ae1054720390$var$_Button2.default, {
            className: "rw-btn-right",
            onClick: onMoveRight,
            disabled: nextDisabled,
            label: messages.moveForward,
            icon: "caret-" + (rtl ? "left" : "right")
        }));
    }
});
module.exports = module.exports["default"];

});
parcelRegister("8BrGQ", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $2MXkj = parcelRequire("2MXkj");
var $6437421b37456f2d$var$_propTypes2 = $6437421b37456f2d$var$_interopRequireDefault($2MXkj);
function $6437421b37456f2d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = {
    contextTypes: {
        isRtl: $6437421b37456f2d$var$_propTypes2.default.bool
    },
    isRtl: function isRtl() {
        return !!this.context.isRtl;
    }
};
module.exports = module.exports["default"];

});


parcelRegister("kN3mU", function(module, exports) {
"use strict";

var $jbmdS = parcelRequire("jbmdS");
var $f22aff27eb682b77$var$_react2 = $f22aff27eb682b77$var$_interopRequireDefault($jbmdS);

var $e64Mn = parcelRequire("e64Mn");
var $f22aff27eb682b77$var$_createReactClass2 = $f22aff27eb682b77$var$_interopRequireDefault($e64Mn);

var $lPWfx = parcelRequire("lPWfx");
var $f22aff27eb682b77$var$_Button2 = $f22aff27eb682b77$var$_interopRequireDefault($lPWfx);

var $7fTd5 = parcelRequire("7fTd5");
function $f22aff27eb682b77$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $f22aff27eb682b77$var$format = function format(props) {
    return $7fTd5.date.getFormat("footer", props.format);
};
module.exports = (0, $f22aff27eb682b77$var$_createReactClass2.default)({
    displayName: "Footer",
    render: function render() {
        var _props = this.props, disabled = _props.disabled, readOnly = _props.readOnly, value = _props.value;
        return $f22aff27eb682b77$var$_react2.default.createElement("div", {
            className: "rw-footer"
        }, $f22aff27eb682b77$var$_react2.default.createElement($f22aff27eb682b77$var$_Button2.default, {
            disabled: !!(disabled || readOnly),
            onClick: this.props.onClick.bind(null, value)
        }, $7fTd5.date.format(value, $f22aff27eb682b77$var$format(this.props), this.props.culture)));
    }
});

});

parcelRegister("cdebc", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $jbmdS = parcelRequire("jbmdS");
var $8e41b2b204d7c833$var$_react2 = $8e41b2b204d7c833$var$_interopRequireDefault($jbmdS);

var $2MXkj = parcelRequire("2MXkj");
var $8e41b2b204d7c833$var$_propTypes2 = $8e41b2b204d7c833$var$_interopRequireDefault($2MXkj);

var $e64Mn = parcelRequire("e64Mn");
var $8e41b2b204d7c833$var$_createReactClass2 = $8e41b2b204d7c833$var$_interopRequireDefault($e64Mn);

var $juDQe = parcelRequire("juDQe");
var $8e41b2b204d7c833$var$_CalendarView2 = $8e41b2b204d7c833$var$_interopRequireDefault($juDQe);

var $bXvdn = parcelRequire("bXvdn");
var $8e41b2b204d7c833$var$_dates2 = $8e41b2b204d7c833$var$_interopRequireDefault($bXvdn);

var $7fTd5 = parcelRequire("7fTd5");

var $iMXz6 = parcelRequire("iMXz6");
var $8e41b2b204d7c833$var$_propTypes4 = $8e41b2b204d7c833$var$_interopRequireDefault($iMXz6);

var $4ELyG = parcelRequire("4ELyG");
var $8e41b2b204d7c833$var$_3 = $8e41b2b204d7c833$var$_interopRequireDefault($4ELyG);

var $9yNJk = parcelRequire("9yNJk");
function $8e41b2b204d7c833$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8e41b2b204d7c833$var$dayFormat = function dayFormat(props) {
    return $7fTd5.date.getFormat("weekday", props.dayFormat);
}, $8e41b2b204d7c833$var$dateFormat = function dateFormat(props) {
    return $7fTd5.date.getFormat("dayOfMonth", props.dateFormat);
};
var $8e41b2b204d7c833$var$optionId = function optionId(id, date) {
    return id + "__month_" + $8e41b2b204d7c833$var$_dates2.default.month(date) + "-" + $8e41b2b204d7c833$var$_dates2.default.date(date);
};
var $8e41b2b204d7c833$var$propTypes = {
    culture: $8e41b2b204d7c833$var$_propTypes2.default.string,
    today: $8e41b2b204d7c833$var$_propTypes2.default.instanceOf(Date),
    value: $8e41b2b204d7c833$var$_propTypes2.default.instanceOf(Date),
    focused: $8e41b2b204d7c833$var$_propTypes2.default.instanceOf(Date),
    min: $8e41b2b204d7c833$var$_propTypes2.default.instanceOf(Date),
    max: $8e41b2b204d7c833$var$_propTypes2.default.instanceOf(Date),
    onChange: $8e41b2b204d7c833$var$_propTypes2.default.func.isRequired,
    dayComponent: $8e41b2b204d7c833$var$_propTypes4.default.elementType,
    dayFormat: $8e41b2b204d7c833$var$_propTypes4.default.dateFormat,
    dateFormat: $8e41b2b204d7c833$var$_propTypes4.default.dateFormat
};
var $8e41b2b204d7c833$var$isEqual = function isEqual(dateA, dateB) {
    return $8e41b2b204d7c833$var$_dates2.default.eq(dateA, dateB, "day");
};


var $8e41b2b204d7c833$var$MonthView = (0, $8e41b2b204d7c833$var$_createReactClass2.default)({
    displayName: "MonthView",
    statics: {
        isEqual: $8e41b2b204d7c833$var$isEqual
    },
    mixins: [
        (parcelRequire("8BrGQ")),
        (parcelRequire("aU65n"))()
    ],
    propTypes: $8e41b2b204d7c833$var$propTypes,
    componentDidUpdate: function componentDidUpdate() {
        var activeId = $8e41b2b204d7c833$var$optionId((0, $9yNJk.instanceId)(this), this.props.focused);
        this.ariaActiveDescendant(activeId, null);
    },
    render: function render() {
        var _props = this.props, focused = _props.focused, culture = _props.culture, month = $8e41b2b204d7c833$var$_dates2.default.visibleDays(focused, culture), rows = $8e41b2b204d7c833$var$_3.default.chunk(month, 7);
        return $8e41b2b204d7c833$var$_react2.default.createElement($8e41b2b204d7c833$var$_CalendarView2.default, $8e41b2b204d7c833$var$_3.default.omitOwnProps(this), $8e41b2b204d7c833$var$_react2.default.createElement("thead", null, $8e41b2b204d7c833$var$_react2.default.createElement("tr", null, this.renderHeaders(rows[0], $8e41b2b204d7c833$var$dayFormat(this.props), culture))), $8e41b2b204d7c833$var$_react2.default.createElement("tbody", null, rows.map(this.renderRow)));
    },
    renderRow: function renderRow(row, rowIdx) {
        var _this = this;
        var _props2 = this.props, focused = _props2.focused, today = _props2.today, disabled = _props2.disabled, onChange = _props2.onChange, value = _props2.value, culture = _props2.culture, min = _props2.min, max = _props2.max, Day = _props2.dayComponent, id = (0, $9yNJk.instanceId)(this), labelFormat = $7fTd5.date.getFormat("footer");
        return $8e41b2b204d7c833$var$_react2.default.createElement($8e41b2b204d7c833$var$_CalendarView2.default.Row, {
            key: rowIdx
        }, row.map(function(date, colIdx) {
            var formattedDate = $7fTd5.date.format(date, $8e41b2b204d7c833$var$dateFormat(_this.props), culture), label = $7fTd5.date.format(date, labelFormat, culture);
            return $8e41b2b204d7c833$var$_react2.default.createElement($8e41b2b204d7c833$var$_CalendarView2.default.Cell, {
                key: colIdx,
                id: $8e41b2b204d7c833$var$optionId(id, date),
                label: label,
                date: date,
                now: today,
                min: min,
                max: max,
                unit: "day",
                viewUnit: "month",
                onChange: onChange,
                focused: focused,
                selected: value,
                disabled: disabled
            }, Day ? $8e41b2b204d7c833$var$_react2.default.createElement(Day, {
                date: date,
                label: formattedDate
            }) : formattedDate);
        }));
    },
    renderHeaders: function renderHeaders(week, format, culture) {
        return week.map(function(date) {
            return $8e41b2b204d7c833$var$_react2.default.createElement("th", {
                key: "header_" + $8e41b2b204d7c833$var$_dates2.default.weekday(date, undefined, $7fTd5.date.startOfWeek(culture))
            }, $7fTd5.date.format(date, format, culture));
        });
    }
});
module.exports.default = $8e41b2b204d7c833$var$MonthView;
module.exports = module.exports["default"];

});
parcelRegister("juDQe", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $e30fb95b01710ecd$var$_class, $e30fb95b01710ecd$var$_temp2;
var $e30fb95b01710ecd$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $jbmdS = parcelRequire("jbmdS");
var $e30fb95b01710ecd$var$_react2 = $e30fb95b01710ecd$var$_interopRequireDefault($jbmdS);

var $2MXkj = parcelRequire("2MXkj");
var $e30fb95b01710ecd$var$_propTypes2 = $e30fb95b01710ecd$var$_interopRequireDefault($2MXkj);

var $02LyB = parcelRequire("02LyB");
var $e30fb95b01710ecd$var$_classnames2 = $e30fb95b01710ecd$var$_interopRequireDefault($02LyB);

var $bXvdn = parcelRequire("bXvdn");
var $e30fb95b01710ecd$var$_dates2 = $e30fb95b01710ecd$var$_interopRequireDefault($bXvdn);
function $e30fb95b01710ecd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e30fb95b01710ecd$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e30fb95b01710ecd$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $e30fb95b01710ecd$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $e30fb95b01710ecd$var$VIEW_UNITS = [
    "month",
    "year",
    "decade",
    "century"
];
function $e30fb95b01710ecd$var$clamp(date, min, max) {
    return $e30fb95b01710ecd$var$_dates2.default.max($e30fb95b01710ecd$var$_dates2.default.min(date, max), min);
}
var $e30fb95b01710ecd$var$CalendarView = function(_React$Component) {
    $e30fb95b01710ecd$var$_inherits(CalendarView, _React$Component);
    function CalendarView() {
        $e30fb95b01710ecd$var$_classCallCheck(this, CalendarView);
        return $e30fb95b01710ecd$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }
    CalendarView.prototype.render = function render() {
        var className = this.props.className;
        return $e30fb95b01710ecd$var$_react2.default.createElement("table", $e30fb95b01710ecd$var$_extends({}, this.props, {
            role: "grid",
            tabIndex: "-1",
            className: (0, $e30fb95b01710ecd$var$_classnames2.default)(className, "rw-nav-view", "rw-calendar-grid")
        }));
    };
    return CalendarView;
}($e30fb95b01710ecd$var$_react2.default.Component);
var $e30fb95b01710ecd$var$CalendarViewCell = ($e30fb95b01710ecd$var$_temp2 = $e30fb95b01710ecd$var$_class = function(_React$Component2) {
    $e30fb95b01710ecd$var$_inherits(CalendarViewCell, _React$Component2);
    function CalendarViewCell() {
        var _temp, _this2, _ret;
        $e30fb95b01710ecd$var$_classCallCheck(this, CalendarViewCell);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this2 = $e30fb95b01710ecd$var$_possibleConstructorReturn(this, _React$Component2.call.apply(_React$Component2, [
            this
        ].concat(args))), _this2), _this2.handleChange = function() {
            var _this2$props = _this2.props, onChange = _this2$props.onChange, min = _this2$props.min, max = _this2$props.max, date = _this2$props.date;
            onChange($e30fb95b01710ecd$var$clamp(date, min, max));
        }, _temp), $e30fb95b01710ecd$var$_possibleConstructorReturn(_this2, _ret);
    }
    CalendarViewCell.prototype.isEqual = function isEqual(date) {
        return $e30fb95b01710ecd$var$_dates2.default.eq(this.props.date, date, this.props.unit);
    };
    CalendarViewCell.prototype.isEmpty = function isEmpty() {
        var _props = this.props, unit = _props.unit, min = _props.min, max = _props.max, date = _props.date;
        return !$e30fb95b01710ecd$var$_dates2.default.inRange(date, min, max, unit);
    };
    CalendarViewCell.prototype.isNow = function isNow() {
        return this.isEqual(this.props.now);
    };
    CalendarViewCell.prototype.isFocused = function isFocused() {
        return this.isEqual(this.props.focused);
    };
    CalendarViewCell.prototype.isSelected = function isSelected() {
        return this.isEqual(this.props.selected);
    };
    CalendarViewCell.prototype.isOffView = function isOffView() {
        var _props2 = this.props, viewUnit = _props2.viewUnit, focused = _props2.focused, date = _props2.date;
        return viewUnit && $e30fb95b01710ecd$var$_dates2.default[viewUnit](date) !== $e30fb95b01710ecd$var$_dates2.default[viewUnit](focused);
    };
    CalendarViewCell.prototype.render = function render() {
        var _props3 = this.props, children = _props3.children, id = _props3.id, label = _props3.label, disabled = _props3.disabled;
        if (this.isEmpty()) return $e30fb95b01710ecd$var$_react2.default.createElement("td", {
            className: "rw-empty-cell",
            role: "presentation"
        }, "\xa0");
        return $e30fb95b01710ecd$var$_react2.default.createElement("td", {
            role: "gridcell",
            id: id,
            title: label,
            "aria-label": label,
            "aria-readonly": disabled,
            "aria-selected": this.isSelected()
        }, $e30fb95b01710ecd$var$_react2.default.createElement("span", {
            "aria-labelledby": id,
            onClick: this.handleChange,
            className: (0, $e30fb95b01710ecd$var$_classnames2.default)("rw-btn", this.isNow() && "rw-now", this.isOffView() && "rw-off-range", this.isFocused() && "rw-state-focus", this.isSelected() && "rw-state-selected")
        }, children));
    };
    return CalendarViewCell;
}($e30fb95b01710ecd$var$_react2.default.Component), $e30fb95b01710ecd$var$_class.propTypes = {
    id: $e30fb95b01710ecd$var$_propTypes2.default.string,
    label: $e30fb95b01710ecd$var$_propTypes2.default.string,
    today: $e30fb95b01710ecd$var$_propTypes2.default.instanceOf(Date),
    selected: $e30fb95b01710ecd$var$_propTypes2.default.instanceOf(Date),
    focused: $e30fb95b01710ecd$var$_propTypes2.default.instanceOf(Date),
    min: $e30fb95b01710ecd$var$_propTypes2.default.instanceOf(Date),
    max: $e30fb95b01710ecd$var$_propTypes2.default.instanceOf(Date),
    unit: $e30fb95b01710ecd$var$_propTypes2.default.oneOf([
        "day"
    ].concat($e30fb95b01710ecd$var$VIEW_UNITS)),
    viewUnit: $e30fb95b01710ecd$var$_propTypes2.default.oneOf($e30fb95b01710ecd$var$VIEW_UNITS),
    onChange: $e30fb95b01710ecd$var$_propTypes2.default.func.isRequired
}, $e30fb95b01710ecd$var$_temp2);
$e30fb95b01710ecd$var$CalendarView.Row = function(props) {
    return $e30fb95b01710ecd$var$_react2.default.createElement("tr", $e30fb95b01710ecd$var$_extends({
        role: "row"
    }, props));
};
$e30fb95b01710ecd$var$CalendarView.Cell = $e30fb95b01710ecd$var$CalendarViewCell;
module.exports.default = $e30fb95b01710ecd$var$CalendarView;
module.exports = module.exports["default"];

});
parcelRegister("bXvdn", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $8b4d6b04580e3155$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $ijNLd = parcelRequire("ijNLd");
var $8b4d6b04580e3155$var$_dateArithmetic2 = $8b4d6b04580e3155$var$_interopRequireDefault($ijNLd);

var $7XXyP = parcelRequire("7XXyP");

var $7fTd5 = parcelRequire("7fTd5");
function $8b4d6b04580e3155$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8b4d6b04580e3155$var$dates = $8b4d6b04580e3155$var$_extends({}, $8b4d6b04580e3155$var$_dateArithmetic2.default, {
    parse: function parse(date, format, culture) {
        return $7fTd5.date.parse(date, format, culture);
    },
    format: function format(date, _format, culture) {
        return $7fTd5.date.format(date, _format, culture);
    },
    monthsInYear: function monthsInYear(year) {
        var months = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ], date = new Date(year, 0, 1);
        return months.map(function(i) {
            return $8b4d6b04580e3155$var$dates.month(date, i);
        });
    },
    firstVisibleDay: function firstVisibleDay(date, culture) {
        var firstOfMonth = $8b4d6b04580e3155$var$dates.startOf(date, "month");
        return $8b4d6b04580e3155$var$dates.startOf(firstOfMonth, "week", $7fTd5.date.startOfWeek(culture));
    },
    lastVisibleDay: function lastVisibleDay(date, culture) {
        var endOfMonth = $8b4d6b04580e3155$var$dates.endOf(date, "month");
        return $8b4d6b04580e3155$var$dates.endOf(endOfMonth, "week", $7fTd5.date.startOfWeek(culture));
    },
    visibleDays: function visibleDays(date, culture) {
        var current = $8b4d6b04580e3155$var$dates.firstVisibleDay(date, culture), last = $8b4d6b04580e3155$var$dates.lastVisibleDay(date, culture), days = [];
        while($8b4d6b04580e3155$var$dates.lte(current, last, "day")){
            days.push(current);
            current = $8b4d6b04580e3155$var$dates.add(current, 1, "day");
        }
        return days;
    },
    move: function move(date, min, max, unit, direction) {
        var isMonth = unit === "month", isUpOrDown = direction === $7XXyP.directions.UP || direction === $7XXyP.directions.DOWN, rangeUnit = $7XXyP.calendarViewUnits[unit], addUnit = isMonth && isUpOrDown ? "week" : $7XXyP.calendarViewUnits[unit], amount = isMonth || !isUpOrDown ? 1 : 4, newDate;
        if (direction === $7XXyP.directions.UP || direction === $7XXyP.directions.LEFT) amount *= -1;
        newDate = $8b4d6b04580e3155$var$dates.add(date, amount, addUnit);
        return $8b4d6b04580e3155$var$dates.inRange(newDate, min, max, rangeUnit) ? newDate : date;
    },
    merge: function merge(date, time, defaultDate) {
        if (time == null && date == null) return null;
        if (time == null) time = defaultDate || new Date();
        if (date == null) date = defaultDate || new Date();
        date = $8b4d6b04580e3155$var$dates.startOf(date, "day");
        date = $8b4d6b04580e3155$var$dates.hours(date, $8b4d6b04580e3155$var$dates.hours(time));
        date = $8b4d6b04580e3155$var$dates.minutes(date, $8b4d6b04580e3155$var$dates.minutes(time));
        date = $8b4d6b04580e3155$var$dates.seconds(date, $8b4d6b04580e3155$var$dates.seconds(time));
        return $8b4d6b04580e3155$var$dates.milliseconds(date, $8b4d6b04580e3155$var$dates.milliseconds(time));
    },
    sameMonth: function sameMonth(dateA, dateB) {
        return $8b4d6b04580e3155$var$dates.eq(dateA, dateB, "month");
    },
    today: function today() {
        return this.startOf(new Date(), "day");
    },
    yesterday: function yesterday() {
        return this.add(this.startOf(new Date(), "day"), -1, "day");
    },
    tomorrow: function tomorrow() {
        return this.add(this.startOf(new Date(), "day"), 1, "day");
    }
});
module.exports.default = $8b4d6b04580e3155$var$dates;
module.exports = module.exports["default"];

});
parcelRegister("ijNLd", function(module, exports) {
var $d56099c0a2e487a3$var$MILI = "milliseconds", $d56099c0a2e487a3$var$SECONDS = "seconds", $d56099c0a2e487a3$var$MINUTES = "minutes", $d56099c0a2e487a3$var$HOURS = "hours", $d56099c0a2e487a3$var$DAY = "day", $d56099c0a2e487a3$var$WEEK = "week", $d56099c0a2e487a3$var$MONTH = "month", $d56099c0a2e487a3$var$YEAR = "year", $d56099c0a2e487a3$var$DECADE = "decade", $d56099c0a2e487a3$var$CENTURY = "century";
var $d56099c0a2e487a3$var$dates = module.exports = {
    add: function(date, num, unit) {
        date = new Date(date);
        switch(unit){
            case $d56099c0a2e487a3$var$MILI:
            case $d56099c0a2e487a3$var$SECONDS:
            case $d56099c0a2e487a3$var$MINUTES:
            case $d56099c0a2e487a3$var$HOURS:
            case $d56099c0a2e487a3$var$YEAR:
                return $d56099c0a2e487a3$var$dates[unit](date, $d56099c0a2e487a3$var$dates[unit](date) + num);
            case $d56099c0a2e487a3$var$DAY:
                return $d56099c0a2e487a3$var$dates.date(date, $d56099c0a2e487a3$var$dates.date(date) + num);
            case $d56099c0a2e487a3$var$WEEK:
                return $d56099c0a2e487a3$var$dates.date(date, $d56099c0a2e487a3$var$dates.date(date) + 7 * num);
            case $d56099c0a2e487a3$var$MONTH:
                return $d56099c0a2e487a3$var$monthMath(date, num);
            case $d56099c0a2e487a3$var$DECADE:
                return $d56099c0a2e487a3$var$dates.year(date, $d56099c0a2e487a3$var$dates.year(date) + num * 10);
            case $d56099c0a2e487a3$var$CENTURY:
                return $d56099c0a2e487a3$var$dates.year(date, $d56099c0a2e487a3$var$dates.year(date) + num * 100);
        }
        throw new TypeError('Invalid units: "' + unit + '"');
    },
    subtract: function(date, num, unit) {
        return $d56099c0a2e487a3$var$dates.add(date, -num, unit);
    },
    startOf: function(date, unit, firstOfWeek) {
        date = new Date(date);
        switch(unit){
            case "century":
            case "decade":
            case "year":
                date = $d56099c0a2e487a3$var$dates.month(date, 0);
            case "month":
                date = $d56099c0a2e487a3$var$dates.date(date, 1);
            case "week":
            case "day":
                date = $d56099c0a2e487a3$var$dates.hours(date, 0);
            case "hours":
                date = $d56099c0a2e487a3$var$dates.minutes(date, 0);
            case "minutes":
                date = $d56099c0a2e487a3$var$dates.seconds(date, 0);
            case "seconds":
                date = $d56099c0a2e487a3$var$dates.milliseconds(date, 0);
        }
        if (unit === $d56099c0a2e487a3$var$DECADE) date = $d56099c0a2e487a3$var$dates.subtract(date, $d56099c0a2e487a3$var$dates.year(date) % 10, "year");
        if (unit === $d56099c0a2e487a3$var$CENTURY) date = $d56099c0a2e487a3$var$dates.subtract(date, $d56099c0a2e487a3$var$dates.year(date) % 100, "year");
        if (unit === $d56099c0a2e487a3$var$WEEK) date = $d56099c0a2e487a3$var$dates.weekday(date, 0, firstOfWeek);
        return date;
    },
    endOf: function(date, unit, firstOfWeek) {
        date = new Date(date);
        date = $d56099c0a2e487a3$var$dates.startOf(date, unit, firstOfWeek);
        date = $d56099c0a2e487a3$var$dates.add(date, 1, unit);
        date = $d56099c0a2e487a3$var$dates.subtract(date, 1, $d56099c0a2e487a3$var$MILI);
        return date;
    },
    eq: $d56099c0a2e487a3$var$createComparer(function(a, b) {
        return a === b;
    }),
    neq: $d56099c0a2e487a3$var$createComparer(function(a, b) {
        return a !== b;
    }),
    gt: $d56099c0a2e487a3$var$createComparer(function(a, b) {
        return a > b;
    }),
    gte: $d56099c0a2e487a3$var$createComparer(function(a, b) {
        return a >= b;
    }),
    lt: $d56099c0a2e487a3$var$createComparer(function(a, b) {
        return a < b;
    }),
    lte: $d56099c0a2e487a3$var$createComparer(function(a, b) {
        return a <= b;
    }),
    min: function() {
        return new Date(Math.min.apply(Math, arguments));
    },
    max: function() {
        return new Date(Math.max.apply(Math, arguments));
    },
    inRange: function(day, min, max, unit) {
        unit = unit || "day";
        return (!min || $d56099c0a2e487a3$var$dates.gte(day, min, unit)) && (!max || $d56099c0a2e487a3$var$dates.lte(day, max, unit));
    },
    milliseconds: $d56099c0a2e487a3$var$createAccessor("Milliseconds"),
    seconds: $d56099c0a2e487a3$var$createAccessor("Seconds"),
    minutes: $d56099c0a2e487a3$var$createAccessor("Minutes"),
    hours: $d56099c0a2e487a3$var$createAccessor("Hours"),
    day: $d56099c0a2e487a3$var$createAccessor("Day"),
    date: $d56099c0a2e487a3$var$createAccessor("Date"),
    month: $d56099c0a2e487a3$var$createAccessor("Month"),
    year: $d56099c0a2e487a3$var$createAccessor("FullYear"),
    decade: function(date, val) {
        return val === undefined ? $d56099c0a2e487a3$var$dates.year($d56099c0a2e487a3$var$dates.startOf(date, $d56099c0a2e487a3$var$DECADE)) : $d56099c0a2e487a3$var$dates.add(date, val + 10, $d56099c0a2e487a3$var$YEAR);
    },
    century: function(date, val) {
        return val === undefined ? $d56099c0a2e487a3$var$dates.year($d56099c0a2e487a3$var$dates.startOf(date, $d56099c0a2e487a3$var$CENTURY)) : $d56099c0a2e487a3$var$dates.add(date, val + 100, $d56099c0a2e487a3$var$YEAR);
    },
    weekday: function(date, val, firstDay) {
        var weekday = ($d56099c0a2e487a3$var$dates.day(date) + 7 - (firstDay || 0)) % 7;
        return val === undefined ? weekday : $d56099c0a2e487a3$var$dates.add(date, val - weekday, $d56099c0a2e487a3$var$DAY);
    },
    diff: function(date1, date2, unit, asFloat) {
        var dividend, divisor, result;
        switch(unit){
            case $d56099c0a2e487a3$var$MILI:
            case $d56099c0a2e487a3$var$SECONDS:
            case $d56099c0a2e487a3$var$MINUTES:
            case $d56099c0a2e487a3$var$HOURS:
            case $d56099c0a2e487a3$var$DAY:
            case $d56099c0a2e487a3$var$WEEK:
                dividend = date2.getTime() - date1.getTime();
                break;
            case $d56099c0a2e487a3$var$MONTH:
            case $d56099c0a2e487a3$var$YEAR:
            case $d56099c0a2e487a3$var$DECADE:
            case $d56099c0a2e487a3$var$CENTURY:
                dividend = ($d56099c0a2e487a3$var$dates.year(date2) - $d56099c0a2e487a3$var$dates.year(date1)) * 12 + $d56099c0a2e487a3$var$dates.month(date2) - $d56099c0a2e487a3$var$dates.month(date1);
                break;
            default:
                throw new TypeError('Invalid units: "' + unit + '"');
        }
        switch(unit){
            case $d56099c0a2e487a3$var$MILI:
                divisor = 1;
                break;
            case $d56099c0a2e487a3$var$SECONDS:
                divisor = 1000;
                break;
            case $d56099c0a2e487a3$var$MINUTES:
                divisor = 60000;
                break;
            case $d56099c0a2e487a3$var$HOURS:
                divisor = 3600000;
                break;
            case $d56099c0a2e487a3$var$DAY:
                divisor = 86400000;
                break;
            case $d56099c0a2e487a3$var$WEEK:
                divisor = 604800000;
                break;
            case $d56099c0a2e487a3$var$MONTH:
                divisor = 1;
                break;
            case $d56099c0a2e487a3$var$YEAR:
                divisor = 12;
                break;
            case $d56099c0a2e487a3$var$DECADE:
                divisor = 120;
                break;
            case $d56099c0a2e487a3$var$CENTURY:
                divisor = 1200;
                break;
            default:
                throw new TypeError('Invalid units: "' + unit + '"');
        }
        result = dividend / divisor;
        return asFloat ? result : $d56099c0a2e487a3$var$absoluteFloor(result);
    }
};
function $d56099c0a2e487a3$var$absoluteFloor(number) {
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}
function $d56099c0a2e487a3$var$monthMath(date, val) {
    var current = $d56099c0a2e487a3$var$dates.month(date), newMonth = current + val;
    date = $d56099c0a2e487a3$var$dates.month(date, newMonth);
    while(newMonth < 0)newMonth = 12 + newMonth;
    //month rollover
    if ($d56099c0a2e487a3$var$dates.month(date) !== newMonth % 12) date = $d56099c0a2e487a3$var$dates.date(date, 0) //move to last of month
    ;
    return date;
}
function $d56099c0a2e487a3$var$createAccessor(method) {
    return function(date, val) {
        if (val === undefined) return date["get" + method]();
        date = new Date(date);
        date["set" + method](val);
        return date;
    };
}
function $d56099c0a2e487a3$var$createComparer(operator) {
    return function(a, b, unit) {
        return operator(+$d56099c0a2e487a3$var$dates.startOf(a, unit), +$d56099c0a2e487a3$var$dates.startOf(b, unit));
    };
}

});

parcelRegister("7XXyP", function(module, exports) {

$parcel$export(module.exports, "__esModule", function () { return $5ccc3e9ed030848f$export$1e511d4a378977f5; }, function (v) { return $5ccc3e9ed030848f$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "directions", function () { return $5ccc3e9ed030848f$export$8fc1e0a9d795944b; }, function (v) { return $5ccc3e9ed030848f$export$8fc1e0a9d795944b = v; });
$parcel$export(module.exports, "datePopups", function () { return $5ccc3e9ed030848f$export$cd7f3c697ad73093; }, function (v) { return $5ccc3e9ed030848f$export$cd7f3c697ad73093 = v; });
$parcel$export(module.exports, "calendarViews", function () { return $5ccc3e9ed030848f$export$94782752c77b2346; }, function (v) { return $5ccc3e9ed030848f$export$94782752c77b2346 = v; });
$parcel$export(module.exports, "calendarViewHierarchy", function () { return $5ccc3e9ed030848f$export$abfd20dcf220b491; }, function (v) { return $5ccc3e9ed030848f$export$abfd20dcf220b491 = v; });
$parcel$export(module.exports, "calendarViewUnits", function () { return $5ccc3e9ed030848f$export$46e217f41366f998; }, function (v) { return $5ccc3e9ed030848f$export$46e217f41366f998 = v; });
var $5ccc3e9ed030848f$export$1e511d4a378977f5;
var $5ccc3e9ed030848f$export$8fc1e0a9d795944b;
var $5ccc3e9ed030848f$export$cd7f3c697ad73093;
var $5ccc3e9ed030848f$export$94782752c77b2346;
var $5ccc3e9ed030848f$export$abfd20dcf220b491;
var $5ccc3e9ed030848f$export$46e217f41366f998;
"use strict";
$5ccc3e9ed030848f$export$1e511d4a378977f5 = true;
var $5ccc3e9ed030848f$var$_calendarViewHierarch, $5ccc3e9ed030848f$var$_calendarViewUnits;
var $5ccc3e9ed030848f$var$views = {
    MONTH: "month",
    YEAR: "year",
    DECADE: "decade",
    CENTURY: "century"
};
var $5ccc3e9ed030848f$var$directions = $5ccc3e9ed030848f$export$8fc1e0a9d795944b = {
    LEFT: "LEFT",
    RIGHT: "RIGHT",
    UP: "UP",
    DOWN: "DOWN"
};
var $5ccc3e9ed030848f$var$datePopups = $5ccc3e9ed030848f$export$cd7f3c697ad73093 = {
    TIME: "time",
    CALENDAR: "calendar"
};
var $5ccc3e9ed030848f$var$calendarViews = $5ccc3e9ed030848f$export$94782752c77b2346 = $5ccc3e9ed030848f$var$views;
var $5ccc3e9ed030848f$var$calendarViewHierarchy = $5ccc3e9ed030848f$export$abfd20dcf220b491 = ($5ccc3e9ed030848f$var$_calendarViewHierarch = {}, $5ccc3e9ed030848f$var$_calendarViewHierarch[$5ccc3e9ed030848f$var$views.MONTH] = $5ccc3e9ed030848f$var$views.YEAR, $5ccc3e9ed030848f$var$_calendarViewHierarch[$5ccc3e9ed030848f$var$views.YEAR] = $5ccc3e9ed030848f$var$views.DECADE, $5ccc3e9ed030848f$var$_calendarViewHierarch[$5ccc3e9ed030848f$var$views.DECADE] = $5ccc3e9ed030848f$var$views.CENTURY, $5ccc3e9ed030848f$var$_calendarViewHierarch);
var $5ccc3e9ed030848f$var$calendarViewUnits = $5ccc3e9ed030848f$export$46e217f41366f998 = ($5ccc3e9ed030848f$var$_calendarViewUnits = {}, $5ccc3e9ed030848f$var$_calendarViewUnits[$5ccc3e9ed030848f$var$views.MONTH] = "day", $5ccc3e9ed030848f$var$_calendarViewUnits[$5ccc3e9ed030848f$var$views.YEAR] = $5ccc3e9ed030848f$var$views.MONTH, $5ccc3e9ed030848f$var$_calendarViewUnits[$5ccc3e9ed030848f$var$views.DECADE] = $5ccc3e9ed030848f$var$views.YEAR, $5ccc3e9ed030848f$var$_calendarViewUnits[$5ccc3e9ed030848f$var$views.CENTURY] = $5ccc3e9ed030848f$var$views.DECADE, $5ccc3e9ed030848f$var$_calendarViewUnits);

});




parcelRegister("bYFQH", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $jbmdS = parcelRequire("jbmdS");
var $8b85c2a25bc2023c$var$_react2 = $8b85c2a25bc2023c$var$_interopRequireDefault($jbmdS);

var $2MXkj = parcelRequire("2MXkj");
var $8b85c2a25bc2023c$var$_propTypes2 = $8b85c2a25bc2023c$var$_interopRequireDefault($2MXkj);

var $e64Mn = parcelRequire("e64Mn");
var $8b85c2a25bc2023c$var$_createReactClass2 = $8b85c2a25bc2023c$var$_interopRequireDefault($e64Mn);

var $juDQe = parcelRequire("juDQe");
var $8b85c2a25bc2023c$var$_CalendarView2 = $8b85c2a25bc2023c$var$_interopRequireDefault($juDQe);

var $bXvdn = parcelRequire("bXvdn");
var $8b85c2a25bc2023c$var$_dates2 = $8b85c2a25bc2023c$var$_interopRequireDefault($bXvdn);

var $7fTd5 = parcelRequire("7fTd5");

var $4ELyG = parcelRequire("4ELyG");
var $8b85c2a25bc2023c$var$_3 = $8b85c2a25bc2023c$var$_interopRequireDefault($4ELyG);

var $iMXz6 = parcelRequire("iMXz6");
var $8b85c2a25bc2023c$var$_propTypes4 = $8b85c2a25bc2023c$var$_interopRequireDefault($iMXz6);

var $9yNJk = parcelRequire("9yNJk");
function $8b85c2a25bc2023c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8b85c2a25bc2023c$var$format = function format(props) {
    return $7fTd5.date.getFormat("month", props.monthFormat);
};
var $8b85c2a25bc2023c$var$propTypes = {
    culture: $8b85c2a25bc2023c$var$_propTypes2.default.string,
    today: $8b85c2a25bc2023c$var$_propTypes2.default.instanceOf(Date),
    value: $8b85c2a25bc2023c$var$_propTypes2.default.instanceOf(Date),
    focused: $8b85c2a25bc2023c$var$_propTypes2.default.instanceOf(Date),
    min: $8b85c2a25bc2023c$var$_propTypes2.default.instanceOf(Date),
    max: $8b85c2a25bc2023c$var$_propTypes2.default.instanceOf(Date),
    onChange: $8b85c2a25bc2023c$var$_propTypes2.default.func.isRequired,
    monthFormat: $8b85c2a25bc2023c$var$_propTypes4.default.dateFormat
};
var $8b85c2a25bc2023c$var$optionId = function optionId(id, date) {
    return id + "__year_" + $8b85c2a25bc2023c$var$_dates2.default.year(date) + "-" + $8b85c2a25bc2023c$var$_dates2.default.month(date);
};


var $8b85c2a25bc2023c$var$YearView = (0, $8b85c2a25bc2023c$var$_createReactClass2.default)({
    displayName: "YearView",
    mixins: [
        (parcelRequire("8BrGQ")),
        (parcelRequire("aU65n"))()
    ],
    propTypes: $8b85c2a25bc2023c$var$propTypes,
    componentDidUpdate: function componentDidUpdate() {
        var activeId = $8b85c2a25bc2023c$var$optionId((0, $9yNJk.instanceId)(this), this.props.focused);
        this.ariaActiveDescendant(activeId);
    },
    render: function render() {
        var focused = this.props.focused, months = $8b85c2a25bc2023c$var$_dates2.default.monthsInYear($8b85c2a25bc2023c$var$_dates2.default.year(focused));
        return $8b85c2a25bc2023c$var$_react2.default.createElement($8b85c2a25bc2023c$var$_CalendarView2.default, $8b85c2a25bc2023c$var$_3.default.omitOwnProps(this), $8b85c2a25bc2023c$var$_react2.default.createElement("tbody", null, $8b85c2a25bc2023c$var$_3.default.chunk(months, 4).map(this.renderRow)));
    },
    renderRow: function renderRow(row, rowIdx) {
        var _this = this;
        var _props = this.props, focused = _props.focused, disabled = _props.disabled, onChange = _props.onChange, value = _props.value, today = _props.today, culture = _props.culture, min = _props.min, max = _props.max;
        var id = (0, $9yNJk.instanceId)(this), labelFormat = $7fTd5.date.getFormat("header");
        return $8b85c2a25bc2023c$var$_react2.default.createElement($8b85c2a25bc2023c$var$_CalendarView2.default.Row, {
            key: rowIdx
        }, row.map(function(date, colIdx) {
            var label = $7fTd5.date.format(date, labelFormat, culture);
            return $8b85c2a25bc2023c$var$_react2.default.createElement($8b85c2a25bc2023c$var$_CalendarView2.default.Cell, {
                key: colIdx,
                id: $8b85c2a25bc2023c$var$optionId(id, date),
                label: label,
                date: date,
                now: today,
                min: min,
                max: max,
                unit: "month",
                onChange: onChange,
                focused: focused,
                selected: value,
                disabled: disabled
            }, $7fTd5.date.format(date, $8b85c2a25bc2023c$var$format(_this.props), culture));
        }));
    }
});
module.exports.default = $8b85c2a25bc2023c$var$YearView;
module.exports = module.exports["default"];

});

parcelRegister("bitaB", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $jbmdS = parcelRequire("jbmdS");
var $839800b9b0b54657$var$_react2 = $839800b9b0b54657$var$_interopRequireDefault($jbmdS);

var $2MXkj = parcelRequire("2MXkj");
var $839800b9b0b54657$var$_propTypes2 = $839800b9b0b54657$var$_interopRequireDefault($2MXkj);

var $e64Mn = parcelRequire("e64Mn");
var $839800b9b0b54657$var$_createReactClass2 = $839800b9b0b54657$var$_interopRequireDefault($e64Mn);

var $juDQe = parcelRequire("juDQe");
var $839800b9b0b54657$var$_CalendarView2 = $839800b9b0b54657$var$_interopRequireDefault($juDQe);

var $bXvdn = parcelRequire("bXvdn");
var $839800b9b0b54657$var$_dates2 = $839800b9b0b54657$var$_interopRequireDefault($bXvdn);

var $7fTd5 = parcelRequire("7fTd5");

var $4ELyG = parcelRequire("4ELyG");
var $839800b9b0b54657$var$_3 = $839800b9b0b54657$var$_interopRequireDefault($4ELyG);

var $iMXz6 = parcelRequire("iMXz6");
var $839800b9b0b54657$var$_propTypes4 = $839800b9b0b54657$var$_interopRequireDefault($iMXz6);

var $9yNJk = parcelRequire("9yNJk");
function $839800b9b0b54657$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $839800b9b0b54657$var$propTypes = {
    culture: $839800b9b0b54657$var$_propTypes2.default.string,
    today: $839800b9b0b54657$var$_propTypes2.default.instanceOf(Date),
    value: $839800b9b0b54657$var$_propTypes2.default.instanceOf(Date),
    focused: $839800b9b0b54657$var$_propTypes2.default.instanceOf(Date),
    min: $839800b9b0b54657$var$_propTypes2.default.instanceOf(Date),
    max: $839800b9b0b54657$var$_propTypes2.default.instanceOf(Date),
    onChange: $839800b9b0b54657$var$_propTypes2.default.func.isRequired,
    yearFormat: $839800b9b0b54657$var$_propTypes4.default.dateFormat
};
var $839800b9b0b54657$var$optionId = function optionId(id, date) {
    return id + "__decade_" + $839800b9b0b54657$var$_dates2.default.year(date);
};



module.exports.default = (0, $839800b9b0b54657$var$_createReactClass2.default)({
    displayName: "DecadeView",
    mixins: [
        (parcelRequire("7xDAs")),
        (parcelRequire("8BrGQ")),
        (parcelRequire("aU65n"))()
    ],
    propTypes: $839800b9b0b54657$var$propTypes,
    componentDidUpdate: function componentDidUpdate() {
        var activeId = $839800b9b0b54657$var$optionId((0, $9yNJk.instanceId)(this), this.props.focused);
        this.ariaActiveDescendant(activeId);
    },
    render: function render() {
        var focused = this.props.focused;
        return $839800b9b0b54657$var$_react2.default.createElement($839800b9b0b54657$var$_CalendarView2.default, $839800b9b0b54657$var$_3.default.omitOwnProps(this), $839800b9b0b54657$var$_react2.default.createElement("tbody", null, $839800b9b0b54657$var$_3.default.chunk($839800b9b0b54657$var$getDecadeYears(focused), 4).map(this.renderRow)));
    },
    renderRow: function renderRow(row, rowIdx) {
        var _props = this.props, focused = _props.focused, disabled = _props.disabled, onChange = _props.onChange, yearFormat = _props.yearFormat, value = _props.value, today = _props.today, culture = _props.culture, min = _props.min, max = _props.max;
        var id = (0, $9yNJk.instanceId)(this);
        return $839800b9b0b54657$var$_react2.default.createElement($839800b9b0b54657$var$_CalendarView2.default.Row, {
            key: rowIdx
        }, row.map(function(date, colIdx) {
            var label = $7fTd5.date.format(date, $7fTd5.date.getFormat("year", yearFormat), culture);
            return $839800b9b0b54657$var$_react2.default.createElement($839800b9b0b54657$var$_CalendarView2.default.Cell, {
                key: colIdx,
                unit: "year",
                id: $839800b9b0b54657$var$optionId(id, date),
                label: label,
                date: date,
                now: today,
                min: min,
                max: max,
                onChange: onChange,
                focused: focused,
                selected: value,
                disabled: disabled
            }, label);
        }));
    }
});
function $839800b9b0b54657$var$getDecadeYears(_date) {
    var days = [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ], date = $839800b9b0b54657$var$_dates2.default.add($839800b9b0b54657$var$_dates2.default.startOf(_date, "decade"), -2, "year");
    return days.map(function() {
        return date = $839800b9b0b54657$var$_dates2.default.add(date, 1, "year");
    });
}
module.exports = module.exports["default"];

});

parcelRegister("98flU", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $jbmdS = parcelRequire("jbmdS");
var $6a60c5172c1b7d3a$var$_react2 = $6a60c5172c1b7d3a$var$_interopRequireDefault($jbmdS);

var $2MXkj = parcelRequire("2MXkj");
var $6a60c5172c1b7d3a$var$_propTypes2 = $6a60c5172c1b7d3a$var$_interopRequireDefault($2MXkj);

var $e64Mn = parcelRequire("e64Mn");
var $6a60c5172c1b7d3a$var$_createReactClass2 = $6a60c5172c1b7d3a$var$_interopRequireDefault($e64Mn);

var $juDQe = parcelRequire("juDQe");
var $6a60c5172c1b7d3a$var$_CalendarView2 = $6a60c5172c1b7d3a$var$_interopRequireDefault($juDQe);

var $bXvdn = parcelRequire("bXvdn");
var $6a60c5172c1b7d3a$var$_dates2 = $6a60c5172c1b7d3a$var$_interopRequireDefault($bXvdn);

var $7fTd5 = parcelRequire("7fTd5");

var $4ELyG = parcelRequire("4ELyG");
var $6a60c5172c1b7d3a$var$_3 = $6a60c5172c1b7d3a$var$_interopRequireDefault($4ELyG);

var $iMXz6 = parcelRequire("iMXz6");
var $6a60c5172c1b7d3a$var$_propTypes4 = $6a60c5172c1b7d3a$var$_interopRequireDefault($iMXz6);

var $9yNJk = parcelRequire("9yNJk");
function $6a60c5172c1b7d3a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6a60c5172c1b7d3a$var$format = function format(props) {
    return $7fTd5.date.getFormat("decade", props.decadeFormat);
};
var $6a60c5172c1b7d3a$var$optionId = function optionId(id, date) {
    return id + "__century_" + $6a60c5172c1b7d3a$var$_dates2.default.year(date);
};
var $6a60c5172c1b7d3a$var$propTypes = {
    culture: $6a60c5172c1b7d3a$var$_propTypes2.default.string,
    today: $6a60c5172c1b7d3a$var$_propTypes2.default.instanceOf(Date),
    value: $6a60c5172c1b7d3a$var$_propTypes2.default.instanceOf(Date),
    focused: $6a60c5172c1b7d3a$var$_propTypes2.default.instanceOf(Date),
    min: $6a60c5172c1b7d3a$var$_propTypes2.default.instanceOf(Date),
    max: $6a60c5172c1b7d3a$var$_propTypes2.default.instanceOf(Date),
    onChange: $6a60c5172c1b7d3a$var$_propTypes2.default.func.isRequired,
    decadeFormat: $6a60c5172c1b7d3a$var$_propTypes4.default.dateFormat
};



module.exports.default = (0, $6a60c5172c1b7d3a$var$_createReactClass2.default)({
    displayName: "CenturyView",
    mixins: [
        (parcelRequire("7xDAs")),
        (parcelRequire("8BrGQ")),
        (parcelRequire("aU65n"))()
    ],
    propTypes: $6a60c5172c1b7d3a$var$propTypes,
    componentDidUpdate: function componentDidUpdate() {
        var activeId = $6a60c5172c1b7d3a$var$optionId((0, $9yNJk.instanceId)(this), this.props.focused);
        this.ariaActiveDescendant(activeId);
    },
    render: function render() {
        var focused = this.props.focused;
        return $6a60c5172c1b7d3a$var$_react2.default.createElement($6a60c5172c1b7d3a$var$_CalendarView2.default, $6a60c5172c1b7d3a$var$_3.default.omitOwnProps(this), $6a60c5172c1b7d3a$var$_react2.default.createElement("tbody", null, $6a60c5172c1b7d3a$var$_3.default.chunk($6a60c5172c1b7d3a$var$getCenturyDecades(focused), 4).map(this.renderRow)));
    },
    renderRow: function renderRow(row, rowIdx) {
        var _this = this;
        var _props = this.props, focused = _props.focused, disabled = _props.disabled, onChange = _props.onChange, value = _props.value, today = _props.today, culture = _props.culture, min = _props.min, max = _props.max;
        var id = (0, $9yNJk.instanceId)(this, "_century");
        return $6a60c5172c1b7d3a$var$_react2.default.createElement($6a60c5172c1b7d3a$var$_CalendarView2.default.Row, {
            key: rowIdx
        }, row.map(function(date, colIdx) {
            var label = $7fTd5.date.format($6a60c5172c1b7d3a$var$_dates2.default.startOf(date, "decade"), $6a60c5172c1b7d3a$var$format(_this.props), culture);
            return $6a60c5172c1b7d3a$var$_react2.default.createElement($6a60c5172c1b7d3a$var$_CalendarView2.default.Cell, {
                key: colIdx,
                unit: "decade",
                id: $6a60c5172c1b7d3a$var$optionId(id, date),
                label: label,
                date: date,
                now: today,
                min: min,
                max: max,
                onChange: onChange,
                focused: focused,
                selected: value,
                disabled: disabled
            }, label);
        }));
    }
});
function $6a60c5172c1b7d3a$var$getCenturyDecades(_date) {
    var days = [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ], date = $6a60c5172c1b7d3a$var$_dates2.default.add($6a60c5172c1b7d3a$var$_dates2.default.startOf(_date, "century"), -20, "year");
    return days.map(function() {
        return date = $6a60c5172c1b7d3a$var$_dates2.default.add(date, 10, "year");
    });
}
module.exports = module.exports["default"];

});

parcelRegister("abgZr", function(module, exports) {
"use strict";
var $76981c5824ee035c$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $jbmdS = parcelRequire("jbmdS");
var $76981c5824ee035c$var$_react2 = $76981c5824ee035c$var$_interopRequireDefault($jbmdS);

var $2MXkj = parcelRequire("2MXkj");
var $76981c5824ee035c$var$_propTypes2 = $76981c5824ee035c$var$_interopRequireDefault($2MXkj);

var $e64Mn = parcelRequire("e64Mn");
var $76981c5824ee035c$var$_createReactClass2 = $76981c5824ee035c$var$_interopRequireDefault($e64Mn);

var $7v7AH = parcelRequire("7v7AH");
var $76981c5824ee035c$var$_ReplaceTransitionGroup2 = $76981c5824ee035c$var$_interopRequireDefault($7v7AH);

var $gl4B1 = parcelRequire("gl4B1");
var $76981c5824ee035c$var$_compat2 = $76981c5824ee035c$var$_interopRequireDefault($gl4B1);

var $bpvMx = parcelRequire("bpvMx");
var $76981c5824ee035c$var$_style2 = $76981c5824ee035c$var$_interopRequireDefault($bpvMx);

var $e40cq = parcelRequire("e40cq");
var $76981c5824ee035c$var$_width2 = $76981c5824ee035c$var$_interopRequireDefault($e40cq);

var $aCqSx = parcelRequire("aCqSx");
var $76981c5824ee035c$var$_configuration2 = $76981c5824ee035c$var$_interopRequireDefault($aCqSx);

var $4ELyG = parcelRequire("4ELyG");
var $76981c5824ee035c$var$_3 = $76981c5824ee035c$var$_interopRequireDefault($4ELyG);
function $76981c5824ee035c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $76981c5824ee035c$var$SlideChildGroup = (0, $76981c5824ee035c$var$_createReactClass2.default)({
    displayName: "SlideChildGroup",
    propTypes: {
        direction: $76981c5824ee035c$var$_propTypes2.default.oneOf([
            "left",
            "right"
        ]),
        duration: $76981c5824ee035c$var$_propTypes2.default.number
    },
    componentWillEnter: function componentWillEnter(done) {
        var _this = this;
        var node = $76981c5824ee035c$var$_compat2.default.findDOMNode(this), width = (0, $76981c5824ee035c$var$_width2.default)(node), direction = this.props.direction;
        width = direction === "left" ? width : -width;
        this.ORGINAL_POSITION = node.style.position;
        (0, $76981c5824ee035c$var$_style2.default)(node, {
            position: "absolute",
            left: width + "px",
            top: 0
        });
        $76981c5824ee035c$var$_configuration2.default.animate(node, {
            left: 0
        }, this.props.duration, function() {
            (0, $76981c5824ee035c$var$_style2.default)(node, {
                position: _this.ORGINAL_POSITION,
                overflow: "hidden"
            });
            _this.ORGINAL_POSITION = null;
            done && done();
        });
    },
    componentWillLeave: function componentWillLeave(done) {
        var _this2 = this;
        var node = $76981c5824ee035c$var$_compat2.default.findDOMNode(this), width = (0, $76981c5824ee035c$var$_width2.default)(node), direction = this.props.direction;
        width = direction === "left" ? -width : width;
        this.ORGINAL_POSITION = node.style.position;
        (0, $76981c5824ee035c$var$_style2.default)(node, {
            position: "absolute",
            top: 0,
            left: 0
        });
        $76981c5824ee035c$var$_configuration2.default.animate(node, {
            left: width + "px"
        }, this.props.duration, function() {
            (0, $76981c5824ee035c$var$_style2.default)(node, {
                position: _this2.ORGINAL_POSITION,
                overflow: "hidden"
            });
            _this2.ORGINAL_POSITION = null;
            done && done();
        });
    },
    render: function render() {
        return $76981c5824ee035c$var$_react2.default.Children.only(this.props.children);
    }
});
module.exports = (0, $76981c5824ee035c$var$_createReactClass2.default)({
    displayName: "exports",
    propTypes: {
        direction: $76981c5824ee035c$var$_propTypes2.default.oneOf([
            "left",
            "right"
        ]),
        duration: $76981c5824ee035c$var$_propTypes2.default.number
    },
    getDefaultProps: function getDefaultProps() {
        return {
            direction: "left",
            duration: 250
        };
    },
    _wrapChild: function _wrapChild(child, ref) {
        return $76981c5824ee035c$var$_react2.default.createElement($76981c5824ee035c$var$SlideChildGroup, {
            key: child.key,
            ref: ref,
            direction: this.props.direction,
            duration: this.props.duration
        }, child);
    },
    render: function render() {
        var _props = this.props, style = _props.style, children = _props.children;
        style = $76981c5824ee035c$var$_extends({}, style, {
            position: "relative",
            overflow: "hidden"
        });
        return $76981c5824ee035c$var$_react2.default.createElement($76981c5824ee035c$var$_ReplaceTransitionGroup2.default, $76981c5824ee035c$var$_extends({}, $76981c5824ee035c$var$_3.default.omitOwnProps(this), {
            ref: "container",
            component: "div",
            childFactory: this._wrapChild,
            style: style
        }), children);
    }
});

});
parcelRegister("7v7AH", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $jbmdS = parcelRequire("jbmdS");
var $0168cba12d3c3e20$var$_react2 = $0168cba12d3c3e20$var$_interopRequireDefault($jbmdS);

var $2MXkj = parcelRequire("2MXkj");
var $0168cba12d3c3e20$var$_propTypes2 = $0168cba12d3c3e20$var$_interopRequireDefault($2MXkj);

var $e64Mn = parcelRequire("e64Mn");
var $0168cba12d3c3e20$var$_createReactClass2 = $0168cba12d3c3e20$var$_interopRequireDefault($e64Mn);

var $bpvMx = parcelRequire("bpvMx");
var $0168cba12d3c3e20$var$_style2 = $0168cba12d3c3e20$var$_interopRequireDefault($bpvMx);

var $a2abb = parcelRequire("a2abb");
var $0168cba12d3c3e20$var$_height2 = $0168cba12d3c3e20$var$_interopRequireDefault($a2abb);

var $e40cq = parcelRequire("e40cq");
var $0168cba12d3c3e20$var$_width2 = $0168cba12d3c3e20$var$_interopRequireDefault($e40cq);

var $gl4B1 = parcelRequire("gl4B1");
var $0168cba12d3c3e20$var$_compat2 = $0168cba12d3c3e20$var$_interopRequireDefault($gl4B1);

var $4ELyG = parcelRequire("4ELyG");
var $0168cba12d3c3e20$var$_3 = $0168cba12d3c3e20$var$_interopRequireDefault($4ELyG);
function $0168cba12d3c3e20$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * A streamlined version of TransitionGroup built for managing at most two active children
 * also provides additional hooks for animation start/end
 * https://github.com/facebook/react/blob/master/src/addons/transitions/ReactTransitionGroup.js
 * relevent code is licensed accordingly
 */ function $0168cba12d3c3e20$var$getChild(children) {
    return $0168cba12d3c3e20$var$_react2.default.Children.only(children);
}
function $0168cba12d3c3e20$var$key(child) {
    return child && child.key;
}
module.exports.default = (0, $0168cba12d3c3e20$var$_createReactClass2.default)({
    displayName: "ReplaceTransitionGroup",
    propTypes: {
        component: $0168cba12d3c3e20$var$_propTypes2.default.oneOfType([
            $0168cba12d3c3e20$var$_propTypes2.default.element,
            $0168cba12d3c3e20$var$_propTypes2.default.string
        ]),
        childFactory: $0168cba12d3c3e20$var$_propTypes2.default.func,
        onAnimating: $0168cba12d3c3e20$var$_propTypes2.default.func,
        onAnimate: $0168cba12d3c3e20$var$_propTypes2.default.func
    },
    getDefaultProps: function getDefaultProps() {
        return {
            component: "span",
            childFactory: function childFactory(a) {
                return a;
            },
            onAnimating: $0168cba12d3c3e20$var$_3.default.noop,
            onAnimate: $0168cba12d3c3e20$var$_3.default.noop
        };
    },
    getInitialState: function getInitialState() {
        return {
            children: $0168cba12d3c3e20$var$_3.default.splat(this.props.children)
        };
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        var nextChild = $0168cba12d3c3e20$var$getChild(nextProps.children), stack = this.state.children.slice(), next = stack[1], last = stack[0];
        var isLastChild = last && $0168cba12d3c3e20$var$key(last) === $0168cba12d3c3e20$var$key(nextChild), isNextChild = next && $0168cba12d3c3e20$var$key(next) === $0168cba12d3c3e20$var$key(nextChild);
        //no children
        if (!last) {
            stack.push(nextChild);
            this.entering = nextChild;
        } else if (last && !next && !isLastChild) {
            //new child
            stack.push(nextChild);
            this.leaving = last;
            this.entering = nextChild;
        } else if (last && next && !isLastChild && !isNextChild) {
            // the child is not the current one, exit the current one, add the new one
            //  - shift the stack down
            stack.shift();
            stack.push(nextChild);
            this.leaving = next;
            this.entering = nextChild;
        } else if (isLastChild) stack.splice(0, 1, nextChild);
        else if (isNextChild) stack.splice(1, 1, nextChild);
        if (this.state.children[0] !== stack[0] || this.state.children[1] !== stack[1]) this.setState({
            children: stack
        });
    },
    componentWillMount: function componentWillMount() {
        this.animatingKeys = {};
        this.leaving = null;
        this.entering = null;
    },
    componentDidMount: function componentDidMount() {
        this._mounted = true;
    },
    componentWillUnmount: function componentWillUnmount() {
        this._mounted = false;
    },
    componentDidUpdate: function componentDidUpdate() {
        var entering = this.entering, leaving = this.leaving, first = this.refs[$0168cba12d3c3e20$var$key(entering) || $0168cba12d3c3e20$var$key(leaving)], node = $0168cba12d3c3e20$var$_compat2.default.findDOMNode(this), el = first && $0168cba12d3c3e20$var$_compat2.default.findDOMNode(first);
        if (el) (0, $0168cba12d3c3e20$var$_style2.default)(node, {
            overflow: "hidden",
            height: (0, $0168cba12d3c3e20$var$_height2.default)(el) + "px",
            width: (0, $0168cba12d3c3e20$var$_width2.default)(el) + "px"
        });
        this.props.onAnimating();
        this.entering = null;
        this.leaving = null;
        if (entering) this.performEnter($0168cba12d3c3e20$var$key(entering));
        if (leaving) this.performLeave($0168cba12d3c3e20$var$key(leaving));
    },
    performEnter: function performEnter(key) {
        var component = this.refs[key];
        if (!component) return;
        this.animatingKeys[key] = true;
        if (component.componentWillEnter) component.componentWillEnter(this._handleDoneEntering.bind(this, key));
        else this._handleDoneEntering(key);
    },
    _tryFinish: function _tryFinish() {
        if (this.isTransitioning()) return;
        if (this._mounted) (0, $0168cba12d3c3e20$var$_style2.default)($0168cba12d3c3e20$var$_compat2.default.findDOMNode(this), {
            overflow: "visible",
            height: "",
            width: ""
        });
        this.props.onAnimate();
    },
    _handleDoneEntering: function _handleDoneEntering(enterkey) {
        var component = this.refs[enterkey];
        if (component && component.componentDidEnter) component.componentDidEnter();
        delete this.animatingKeys[enterkey];
        if ($0168cba12d3c3e20$var$key(this.props.children) !== enterkey) this.performLeave(enterkey); // This was removed before it had fully entered. Remove it.
        this._tryFinish();
    },
    performLeave: function performLeave(key) {
        var component = this.refs[key];
        if (!component) return;
        this.animatingKeys[key] = true;
        if (component.componentWillLeave) component.componentWillLeave(this._handleDoneLeaving.bind(this, key));
        else this._handleDoneLeaving(key);
    },
    _handleDoneLeaving: function _handleDoneLeaving(leavekey) {
        var component = this.refs[leavekey];
        if (component && component.componentDidLeave) component.componentDidLeave();
        delete this.animatingKeys[leavekey];
        if ($0168cba12d3c3e20$var$key(this.props.children) === leavekey) this.performEnter(leavekey); // This entered again before it fully left. Add it again.
        else if (this._mounted) this.setState({
            children: this.state.children.filter(function(c) {
                return $0168cba12d3c3e20$var$key(c) !== leavekey;
            })
        });
        this._tryFinish();
    },
    isTransitioning: function isTransitioning() {
        return !!Object.keys(this.animatingKeys).length;
    },
    render: function render() {
        var _this = this;
        var Component = this.props.component;
        return $0168cba12d3c3e20$var$_react2.default.createElement(Component, $0168cba12d3c3e20$var$_3.default.omitOwnProps(this), this.state.children.map(function(c) {
            return _this.props.childFactory(c, $0168cba12d3c3e20$var$key(c));
        }));
    }
});
module.exports = module.exports["default"];

});
parcelRegister("e40cq", function(module, exports) {
"use strict";

var $bAUeB = parcelRequire("bAUeB");

var $c8UPi = parcelRequire("c8UPi");
module.exports = function width(node, client) {
    var win = $c8UPi(node);
    return win ? win.innerWidth : client ? node.clientWidth : $bAUeB(node).width;
};

});




parcelRegister("hpuAs", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $cacc7f6a18800fc6$var$_desc, $cacc7f6a18800fc6$var$_value, $cacc7f6a18800fc6$var$_obj;
var $cacc7f6a18800fc6$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
}; //pick, omit, has

var $jbmdS = parcelRequire("jbmdS");
var $cacc7f6a18800fc6$var$_react2 = $cacc7f6a18800fc6$var$_interopRequireDefault($jbmdS);

var $2MXkj = parcelRequire("2MXkj");
var $cacc7f6a18800fc6$var$_propTypes2 = $cacc7f6a18800fc6$var$_interopRequireDefault($2MXkj);

var $e64Mn = parcelRequire("e64Mn");
var $cacc7f6a18800fc6$var$_createReactClass2 = $cacc7f6a18800fc6$var$_interopRequireDefault($e64Mn);

var $liDpN = parcelRequire("liDpN");
var $cacc7f6a18800fc6$var$_invariant2 = $cacc7f6a18800fc6$var$_interopRequireDefault($liDpN);

var $4ToXx = parcelRequire("4ToXx");
var $cacc7f6a18800fc6$var$_activeElement2 = $cacc7f6a18800fc6$var$_interopRequireDefault($4ToXx);

var $02LyB = parcelRequire("02LyB");
var $cacc7f6a18800fc6$var$_classnames2 = $cacc7f6a18800fc6$var$_interopRequireDefault($02LyB);

var $gl4B1 = parcelRequire("gl4B1");
var $cacc7f6a18800fc6$var$_compat2 = $cacc7f6a18800fc6$var$_interopRequireDefault($gl4B1);

var $4ELyG = parcelRequire("4ELyG");
var $cacc7f6a18800fc6$var$_3 = $cacc7f6a18800fc6$var$_interopRequireDefault($4ELyG);

var $bXvdn = parcelRequire("bXvdn");
var $cacc7f6a18800fc6$var$_dates2 = $cacc7f6a18800fc6$var$_interopRequireDefault($bXvdn);

var $7fTd5 = parcelRequire("7fTd5");

var $7XXyP = parcelRequire("7XXyP");

var $ikauB = parcelRequire("ikauB");
var $cacc7f6a18800fc6$var$_Widget2 = $cacc7f6a18800fc6$var$_interopRequireDefault($ikauB);

var $iXqdK = parcelRequire("iXqdK");
var $cacc7f6a18800fc6$var$_Popup2 = $cacc7f6a18800fc6$var$_interopRequireDefault($iXqdK);

var $l3yHc = parcelRequire("l3yHc");
var $cacc7f6a18800fc6$var$_Calendar2 = $cacc7f6a18800fc6$var$_interopRequireDefault($l3yHc);

var $fMyJu = parcelRequire("fMyJu");
var $cacc7f6a18800fc6$var$_TimeList2 = $cacc7f6a18800fc6$var$_interopRequireDefault($fMyJu);

var $3SpYr = parcelRequire("3SpYr");
var $cacc7f6a18800fc6$var$_DateTimePickerInput2 = $cacc7f6a18800fc6$var$_interopRequireDefault($3SpYr);

var $lPWfx = parcelRequire("lPWfx");
var $cacc7f6a18800fc6$var$_Button2 = $cacc7f6a18800fc6$var$_interopRequireDefault($lPWfx);

var $iMXz6 = parcelRequire("iMXz6");
var $cacc7f6a18800fc6$var$_propTypes4 = $cacc7f6a18800fc6$var$_interopRequireDefault($iMXz6);

var $12xR0 = parcelRequire("12xR0");
var $cacc7f6a18800fc6$var$_uncontrollable2 = $cacc7f6a18800fc6$var$_interopRequireDefault($12xR0);

var $cQuVG = parcelRequire("cQuVG");

var $9yNJk = parcelRequire("9yNJk");
function $cacc7f6a18800fc6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cacc7f6a18800fc6$var$_applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object["keys"](descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ("value" in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object["defineProperty"](target, property, desc);
        desc = null;
    }
    return desc;
}
var $cacc7f6a18800fc6$var$Calendar = $cacc7f6a18800fc6$var$_Calendar2.default.ControlledComponent;
var $cacc7f6a18800fc6$var$viewEnum = Object.keys($7XXyP.calendarViews).map(function(k) {
    return $7XXyP.calendarViews[k];
});
var $cacc7f6a18800fc6$var$propTypes = $cacc7f6a18800fc6$var$_extends({}, $cacc7f6a18800fc6$var$Calendar.propTypes, {
    //-- controlled props -----------
    value: $cacc7f6a18800fc6$var$_propTypes2.default.instanceOf(Date),
    onChange: $cacc7f6a18800fc6$var$_propTypes2.default.func,
    open: $cacc7f6a18800fc6$var$_propTypes2.default.oneOf([
        false,
        $7XXyP.datePopups.TIME,
        $7XXyP.datePopups.CALENDAR
    ]),
    onToggle: $cacc7f6a18800fc6$var$_propTypes2.default.func,
    currentDate: $cacc7f6a18800fc6$var$_propTypes2.default.instanceOf(Date),
    onCurrentDateChange: $cacc7f6a18800fc6$var$_propTypes2.default.func,
    //------------------------------------
    onSelect: $cacc7f6a18800fc6$var$_propTypes2.default.func,
    min: $cacc7f6a18800fc6$var$_propTypes2.default.instanceOf(Date),
    max: $cacc7f6a18800fc6$var$_propTypes2.default.instanceOf(Date),
    culture: $cacc7f6a18800fc6$var$_propTypes2.default.string,
    format: $cacc7f6a18800fc6$var$_propTypes4.default.dateFormat,
    timeFormat: $cacc7f6a18800fc6$var$_propTypes4.default.dateFormat,
    editFormat: $cacc7f6a18800fc6$var$_propTypes4.default.dateFormat,
    calendar: $cacc7f6a18800fc6$var$_propTypes2.default.bool,
    time: $cacc7f6a18800fc6$var$_propTypes2.default.bool,
    timeComponent: $cacc7f6a18800fc6$var$_propTypes4.default.elementType,
    //popup
    dropUp: $cacc7f6a18800fc6$var$_propTypes2.default.bool,
    duration: $cacc7f6a18800fc6$var$_propTypes2.default.number,
    placeholder: $cacc7f6a18800fc6$var$_propTypes2.default.string,
    name: $cacc7f6a18800fc6$var$_propTypes2.default.string,
    initialView: $cacc7f6a18800fc6$var$_propTypes2.default.oneOf($cacc7f6a18800fc6$var$viewEnum),
    finalView: $cacc7f6a18800fc6$var$_propTypes2.default.oneOf($cacc7f6a18800fc6$var$viewEnum),
    autoFocus: $cacc7f6a18800fc6$var$_propTypes2.default.bool,
    disabled: $cacc7f6a18800fc6$var$_propTypes4.default.disabled,
    readOnly: $cacc7f6a18800fc6$var$_propTypes4.default.readOnly,
    parse: $cacc7f6a18800fc6$var$_propTypes2.default.oneOfType([
        $cacc7f6a18800fc6$var$_propTypes2.default.arrayOf($cacc7f6a18800fc6$var$_propTypes2.default.string),
        $cacc7f6a18800fc6$var$_propTypes2.default.string,
        $cacc7f6a18800fc6$var$_propTypes2.default.func
    ]),
    "aria-labelledby": $cacc7f6a18800fc6$var$_propTypes2.default.string,
    "aria-describedby": $cacc7f6a18800fc6$var$_propTypes2.default.string,
    messages: $cacc7f6a18800fc6$var$_propTypes2.default.shape({
        calendarButton: $cacc7f6a18800fc6$var$_propTypes2.default.string,
        timeButton: $cacc7f6a18800fc6$var$_propTypes2.default.string
    })
});






var $cacc7f6a18800fc6$var$DateTimePicker = (0, $cacc7f6a18800fc6$var$_createReactClass2.default)(($cacc7f6a18800fc6$var$_obj = {
    displayName: "DateTimePicker",
    mixins: [
        (parcelRequire("7Hmlb")),
        (parcelRequire("7xDAs")),
        (parcelRequire("602jV")),
        (parcelRequire("h64ZC")),
        (parcelRequire("eC1mP"))({
            didHandle: function didHandle(focused) {
                if (!focused) this.close();
            }
        }),
        (parcelRequire("aU65n"))("valueInput", function(key, id) {
            var open = this.props.open, current = this.ariaActiveDescendant(), calIsActive = open === $7XXyP.datePopups.CALENDAR && key === "calendar", timeIsActive = open === $7XXyP.datePopups.TIME && key === "timelist";
            if (!current || timeIsActive || calIsActive) return id;
        })
    ],
    propTypes: $cacc7f6a18800fc6$var$propTypes,
    getInitialState: function getInitialState() {
        return {
            focused: false
        };
    },
    getDefaultProps: function getDefaultProps() {
        return {
            value: null,
            currentDate: new Date(),
            min: new Date(1900, 0, 1),
            max: new Date(2099, 11, 31),
            calendar: true,
            time: true,
            open: false,
            //calendar override
            footer: true,
            messages: {
                calendarButton: "Select Date",
                timeButton: "Select Time"
            },
            ariaActiveDescendantKey: "dropdownlist"
        };
    },
    renderInput: function renderInput(id, owns) {
        var _props = this.props, open = _props.open, value = _props.value, editFormat = _props.editFormat, culture = _props.culture, busy = _props.busy, placeholder = _props.placeholder, disabled = _props.disabled, readOnly = _props.readOnly, name = _props.name, tabIndex = _props.tabIndex, autoFocus = _props.autoFocus, ariaLabelledby = _props["aria-labelledby"], ariaDescribedby = _props["aria-describedby"];
        var focused = this.state.focused;
        return $cacc7f6a18800fc6$var$_react2.default.createElement($cacc7f6a18800fc6$var$_DateTimePickerInput2.default, {
            id: id,
            ref: "valueInput",
            role: "combobox",
            name: name,
            tabIndex: tabIndex,
            autoFocus: autoFocus,
            placeholder: placeholder,
            disabled: disabled,
            readOnly: readOnly,
            value: value,
            format: $cacc7f6a18800fc6$var$getFormat(this.props),
            editFormat: editFormat,
            editing: focused,
            culture: culture,
            parse: this._parse,
            onChange: this.handleChange,
            "aria-haspopup": true,
            "aria-labelledby": ariaLabelledby,
            "aria-describedby": ariaDescribedby,
            "aria-expanded": !!open,
            "aria-busy": !!busy,
            "aria-owns": owns
        });
    },
    renderButtons: function renderButtons(messages) {
        var _props2 = this.props, calendar = _props2.calendar, time = _props2.time, disabled = _props2.disabled, readOnly = _props2.readOnly;
        if (!calendar && !time) return null;
        return $cacc7f6a18800fc6$var$_react2.default.createElement("span", {
            className: "rw-select"
        }, calendar && $cacc7f6a18800fc6$var$_react2.default.createElement($cacc7f6a18800fc6$var$_Button2.default, {
            icon: "calendar",
            className: "rw-btn-calendar",
            label: messages.calendarButton,
            disabled: !!(disabled || readOnly),
            onClick: this._click.bind(null, $7XXyP.datePopups.CALENDAR)
        }), time && $cacc7f6a18800fc6$var$_react2.default.createElement($cacc7f6a18800fc6$var$_Button2.default, {
            icon: "clock-o",
            className: "rw-btn-time",
            label: messages.timeButton,
            disabled: !!(disabled || readOnly),
            onClick: this._click.bind(null, $7XXyP.datePopups.TIME)
        }));
    },
    renderCalendar: function renderCalendar(id, inputID) {
        var _this = this;
        var _props3 = this.props, open = _props3.open, value = _props3.value, duration = _props3.duration, dropUp = _props3.dropUp;
        var calendarProps = $cacc7f6a18800fc6$var$_3.default.pickProps(this.props, $cacc7f6a18800fc6$var$Calendar);
        return $cacc7f6a18800fc6$var$_react2.default.createElement($cacc7f6a18800fc6$var$_Popup2.default, {
            dropUp: dropUp,
            duration: duration,
            open: open === $7XXyP.datePopups.CALENDAR,
            className: "rw-calendar-popup"
        }, $cacc7f6a18800fc6$var$_react2.default.createElement($cacc7f6a18800fc6$var$Calendar, $cacc7f6a18800fc6$var$_extends({}, calendarProps, {
            ref: "calPopup",
            id: id,
            tabIndex: "-1",
            value: value,
            autoFocus: false,
            onChange: this.handleDateSelect,
            onNavigate: function onNavigate() {
                return _this.focus();
            },
            currentDate: this.props.currentDate,
            onCurrentDateChange: this.props.onCurrentDateChange,
            "aria-hidden": !open,
            "aria-live": "polite",
            "aria-labelledby": inputID,
            ariaActiveDescendantKey: "calendar"
        })));
    },
    renderTimeList: function renderTimeList(id, inputID) {
        var _this2 = this;
        var _props4 = this.props, open = _props4.open, value = _props4.value, duration = _props4.duration, dropUp = _props4.dropUp, calendar = _props4.calendar, timeFormat = _props4.timeFormat, timeComponent = _props4.timeComponent;
        var timeListProps = $cacc7f6a18800fc6$var$_3.default.pickProps(this.props, $cacc7f6a18800fc6$var$_TimeList2.default);
        return $cacc7f6a18800fc6$var$_react2.default.createElement($cacc7f6a18800fc6$var$_Popup2.default, {
            dropUp: dropUp,
            duration: duration,
            open: open === $7XXyP.datePopups.TIME,
            onOpening: function onOpening() {
                return _this2.refs.timePopup.forceUpdate();
            }
        }, $cacc7f6a18800fc6$var$_react2.default.createElement("div", null, $cacc7f6a18800fc6$var$_react2.default.createElement($cacc7f6a18800fc6$var$_TimeList2.default, $cacc7f6a18800fc6$var$_extends({}, timeListProps, {
            ref: "timePopup",
            id: id,
            format: timeFormat,
            value: $cacc7f6a18800fc6$var$dateOrNull(value),
            onMove: this._scrollTo,
            onSelect: this.handleTimeSelect,
            preserveDate: !!calendar,
            itemComponent: timeComponent,
            "aria-labelledby": inputID,
            "aria-live": open && "polite",
            "aria-hidden": !open,
            ariaActiveDescendantKey: "timelist"
        }))));
    },
    render: function render() {
        var _props5 = this.props, className = _props5.className, calendar = _props5.calendar, time = _props5.time, open = _props5.open, messages = _props5.messages, disabled = _props5.disabled, readOnly = _props5.readOnly, dropUp = _props5.dropUp;
        var focused = this.state.focused;
        var inputID = (0, $9yNJk.instanceId)(this, "_input"), timeListID = (0, $9yNJk.instanceId)(this, "_time_listbox"), dateListID = (0, $9yNJk.instanceId)(this, "_cal"), owns = "";
        var elementProps = $cacc7f6a18800fc6$var$_3.default.omitOwnProps(this, $cacc7f6a18800fc6$var$Calendar, $cacc7f6a18800fc6$var$_TimeList2.default);
        var shouldRenderList = open || (0, $9yNJk.isFirstFocusedRender)(this);
        if (calendar) owns += dateListID;
        if (time) owns += " " + timeListID;
        return $cacc7f6a18800fc6$var$_react2.default.createElement($cacc7f6a18800fc6$var$_Widget2.default, $cacc7f6a18800fc6$var$_extends({}, elementProps, {
            open: !!open,
            dropUp: dropUp,
            focused: focused,
            disabled: disabled,
            readOnly: readOnly,
            onBlur: this.handleBlur,
            onFocus: this.handleFocus,
            onKeyDown: this.handleKeyDown,
            onKeyPress: this.handleKeyPress,
            className: (0, $cacc7f6a18800fc6$var$_classnames2.default)(className, "rw-datetimepicker", calendar && time && "rw-has-both", !calendar && !time && "rw-has-neither")
        }), this.renderInput(inputID, owns.trim()), this.renderButtons(messages), shouldRenderList && this.renderTimeList(timeListID, inputID), shouldRenderList && this.renderCalendar(dateListID, inputID));
    },
    handleChange: function handleChange(date, str, constrain) {
        var _props6 = this.props, onChange = _props6.onChange, value = _props6.value;
        if (constrain) date = this.inRangeValue(date);
        if (onChange) {
            if (date == null || value == null) {
                if (date != value) onChange(date, str);
            } else if (!$cacc7f6a18800fc6$var$_dates2.default.eq(date, value)) onChange(date, str);
        }
    },
    handleKeyDown: function handleKeyDown(e) {
        var _props7 = this.props, open = _props7.open, calendar = _props7.calendar, time = _props7.time;
        (0, $9yNJk.notify)(this.props.onKeyDown, [
            e
        ]);
        if (e.defaultPrevented) return;
        if (e.key === "Escape" && open) this.close();
        else if (e.altKey) {
            e.preventDefault();
            if (e.key === "ArrowDown") {
                if (calendar && time) this.open(open === $7XXyP.datePopups.CALENDAR ? $7XXyP.datePopups.TIME : $7XXyP.datePopups.CALENDAR);
                else if (time) this.open($7XXyP.datePopups.TIME);
                else if (calendar) this.open($7XXyP.datePopups.CALENDAR);
            } else if (e.key === "ArrowUp") this.close();
        } else if (open) {
            if (open === $7XXyP.datePopups.CALENDAR) this.refs.calPopup.handleKeyDown(e);
            if (open === $7XXyP.datePopups.TIME) this.refs.timePopup.handleKeyDown(e);
        }
    },
    handleKeyPress: function handleKeyPress(e) {
        (0, $9yNJk.notify)(this.props.onKeyPress, [
            e
        ]);
        if (e.defaultPrevented) return;
        if (this.props.open === $7XXyP.datePopups.TIME) this.refs.timePopup.handleKeyPress(e);
    },
    focus: function focus() {
        var valueInput = this.refs.valueInput;
        if (valueInput && (0, $cacc7f6a18800fc6$var$_activeElement2.default)() !== $cacc7f6a18800fc6$var$_compat2.default.findDOMNode(valueInput)) valueInput.focus();
    },
    handleDateSelect: function handleDateSelect(date) {
        var format = $cacc7f6a18800fc6$var$getFormat(this.props), dateTime = $cacc7f6a18800fc6$var$_dates2.default.merge(date, this.props.value, this.props.currentDate), dateStr = $cacc7f6a18800fc6$var$formatDate(date, format, this.props.culture);
        this.close();
        (0, $9yNJk.notify)(this.props.onSelect, [
            dateTime,
            dateStr
        ]);
        this.handleChange(dateTime, dateStr, true);
        this.focus();
    },
    handleTimeSelect: function handleTimeSelect(datum) {
        var format = $cacc7f6a18800fc6$var$getFormat(this.props), dateTime = $cacc7f6a18800fc6$var$_dates2.default.merge(this.props.value, datum.date, this.props.currentDate), dateStr = $cacc7f6a18800fc6$var$formatDate(datum.date, format, this.props.culture);
        this.close();
        (0, $9yNJk.notify)(this.props.onSelect, [
            dateTime,
            dateStr
        ]);
        this.handleChange(dateTime, dateStr, true);
        this.focus();
    },
    _click: function _click(view, e) {
        this.focus();
        this.toggle(view, e);
    },
    _parse: function _parse(string) {
        var format = $cacc7f6a18800fc6$var$getFormat(this.props, true), editFormat = this.props.editFormat, parse = this.props.parse, formats = [];
        if (typeof parse === "function") return parse(string, this.props.culture);
        if (typeof format === "string") formats.push(format);
        if (typeof editFormat === "string") formats.push(editFormat);
        if (parse) formats = formats.concat(this.props.parse);
        (0, $cacc7f6a18800fc6$var$_invariant2.default)(formats.length, "React Widgets: there are no specified `parse` formats provided and the `format` prop is a function. the DateTimePicker is unable to parse `%s` into a dateTime, please provide either a parse function or Globalize.js compatible string for `format`", string);
        return $cacc7f6a18800fc6$var$formatsParser(formats, this.props.culture, string);
    },
    toggle: function toggle(view) {
        this.props.open ? this.props.open !== view ? this.open(view) : this.close(view) : this.open(view);
    },
    open: function open(view) {
        if (this.props.open !== view && this.props[view] === true) (0, $9yNJk.notify)(this.props.onToggle, view);
    },
    close: function close() {
        if (this.props.open) (0, $9yNJk.notify)(this.props.onToggle, false);
    },
    inRangeValue: function inRangeValue(value) {
        if (value == null) return value;
        return $cacc7f6a18800fc6$var$_dates2.default.max($cacc7f6a18800fc6$var$_dates2.default.min(value, this.props.max), this.props.min);
    }
}, $cacc7f6a18800fc6$var$_applyDecoratedDescriptor($cacc7f6a18800fc6$var$_obj, "handleChange", [
    $cQuVG.widgetEditable
], Object.getOwnPropertyDescriptor($cacc7f6a18800fc6$var$_obj, "handleChange"), $cacc7f6a18800fc6$var$_obj), $cacc7f6a18800fc6$var$_applyDecoratedDescriptor($cacc7f6a18800fc6$var$_obj, "handleKeyDown", [
    $cQuVG.widgetEditable
], Object.getOwnPropertyDescriptor($cacc7f6a18800fc6$var$_obj, "handleKeyDown"), $cacc7f6a18800fc6$var$_obj), $cacc7f6a18800fc6$var$_applyDecoratedDescriptor($cacc7f6a18800fc6$var$_obj, "handleKeyPress", [
    $cQuVG.widgetEditable
], Object.getOwnPropertyDescriptor($cacc7f6a18800fc6$var$_obj, "handleKeyPress"), $cacc7f6a18800fc6$var$_obj), $cacc7f6a18800fc6$var$_applyDecoratedDescriptor($cacc7f6a18800fc6$var$_obj, "handleDateSelect", [
    $cQuVG.widgetEditable
], Object.getOwnPropertyDescriptor($cacc7f6a18800fc6$var$_obj, "handleDateSelect"), $cacc7f6a18800fc6$var$_obj), $cacc7f6a18800fc6$var$_applyDecoratedDescriptor($cacc7f6a18800fc6$var$_obj, "handleTimeSelect", [
    $cQuVG.widgetEditable
], Object.getOwnPropertyDescriptor($cacc7f6a18800fc6$var$_obj, "handleTimeSelect"), $cacc7f6a18800fc6$var$_obj), $cacc7f6a18800fc6$var$_applyDecoratedDescriptor($cacc7f6a18800fc6$var$_obj, "_click", [
    $cQuVG.widgetEditable
], Object.getOwnPropertyDescriptor($cacc7f6a18800fc6$var$_obj, "_click"), $cacc7f6a18800fc6$var$_obj), $cacc7f6a18800fc6$var$_obj));
module.exports.default = (0, $cacc7f6a18800fc6$var$_uncontrollable2.default)($cacc7f6a18800fc6$var$DateTimePicker, {
    open: "onToggle",
    value: "onChange",
    currentDate: "onCurrentDateChange"
}, [
    "focus"
]);
function $cacc7f6a18800fc6$var$getFormat(props) {
    var cal = props[$7XXyP.datePopups.CALENDAR] != null ? props.calendar : true, time = props[$7XXyP.datePopups.TIME] != null ? props.time : true;
    return props.format ? props.format : cal && time || !cal && !time ? $7fTd5.date.getFormat("default") : $7fTd5.date.getFormat(cal ? "date" : "time");
}
function $cacc7f6a18800fc6$var$formatDate(date, format, culture) {
    var val = "";
    if (date instanceof Date && !isNaN(date.getTime())) val = $7fTd5.date.format(date, format, culture);
    return val;
}
function $cacc7f6a18800fc6$var$formatsParser(formats, culture, str) {
    var date;
    for(var i = 0; i < formats.length; i++){
        date = $7fTd5.date.parse(str, formats[i], culture);
        if (date) return date;
    }
    return null;
}
function $cacc7f6a18800fc6$var$dateOrNull(dt) {
    if (dt && !isNaN(dt.getTime())) return dt;
    return null;
}
module.exports = module.exports["default"];

});
parcelRegister("fMyJu", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $b7d647e3cd0557f1$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $jbmdS = parcelRequire("jbmdS");
var $b7d647e3cd0557f1$var$_react2 = $b7d647e3cd0557f1$var$_interopRequireDefault($jbmdS);

var $2MXkj = parcelRequire("2MXkj");
var $b7d647e3cd0557f1$var$_propTypes2 = $b7d647e3cd0557f1$var$_interopRequireDefault($2MXkj);

var $e64Mn = parcelRequire("e64Mn");
var $b7d647e3cd0557f1$var$_createReactClass2 = $b7d647e3cd0557f1$var$_interopRequireDefault($e64Mn);

var $bXvdn = parcelRequire("bXvdn");
var $b7d647e3cd0557f1$var$_dates3 = $b7d647e3cd0557f1$var$_interopRequireDefault($bXvdn);

var $dPmvq = parcelRequire("dPmvq");
var $b7d647e3cd0557f1$var$_List2 = $b7d647e3cd0557f1$var$_interopRequireDefault($dPmvq);

var $7fTd5 = parcelRequire("7fTd5");

var $iMXz6 = parcelRequire("iMXz6");
var $b7d647e3cd0557f1$var$_propTypes4 = $b7d647e3cd0557f1$var$_interopRequireDefault($iMXz6);

var $4ELyG = parcelRequire("4ELyG");
var $b7d647e3cd0557f1$var$_3 = $b7d647e3cd0557f1$var$_interopRequireDefault($4ELyG);
function $b7d647e3cd0557f1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b7d647e3cd0557f1$var$format = function format(props) {
    return $7fTd5.date.getFormat("time", props.format);
};

module.exports.default = (0, $b7d647e3cd0557f1$var$_createReactClass2.default)({
    displayName: "TimeList",
    propTypes: {
        value: $b7d647e3cd0557f1$var$_propTypes2.default.instanceOf(Date),
        step: $b7d647e3cd0557f1$var$_propTypes2.default.number,
        min: $b7d647e3cd0557f1$var$_propTypes2.default.instanceOf(Date),
        max: $b7d647e3cd0557f1$var$_propTypes2.default.instanceOf(Date),
        currentDate: $b7d647e3cd0557f1$var$_propTypes2.default.instanceOf(Date),
        itemComponent: $b7d647e3cd0557f1$var$_propTypes4.default.elementType,
        format: $b7d647e3cd0557f1$var$_propTypes4.default.dateFormat,
        onSelect: $b7d647e3cd0557f1$var$_propTypes2.default.func,
        preserveDate: $b7d647e3cd0557f1$var$_propTypes2.default.bool,
        culture: $b7d647e3cd0557f1$var$_propTypes2.default.string,
        delay: $b7d647e3cd0557f1$var$_propTypes2.default.number
    },
    mixins: [
        (parcelRequire("7Hmlb"))
    ],
    getDefaultProps: function getDefaultProps() {
        return {
            step: 30,
            onSelect: function onSelect() {},
            min: new Date(1900, 0, 1),
            max: new Date(2099, 11, 31),
            preserveDate: true,
            delay: 300,
            ariaActiveDescendantKey: "timelist"
        };
    },
    getInitialState: function getInitialState() {
        var data = this._dates(this.props), focusedItem = this._closestDate(data, this.props.value || this.props.currentDate);
        return {
            focusedItem: focusedItem || data[0],
            dates: data
        };
    },
    componentDidMount: function componentDidMount() {
        this._mounted = true;
    },
    componentWillUnmount: function componentWillUnmount() {
        this._mounted = false;
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        var data = this._dates(nextProps), focusedItem = this._closestDate(data, nextProps.value || this.props.currentDate), valChanged = !$b7d647e3cd0557f1$var$_dates3.default.eq(nextProps.value, this.props.value, "minutes"), minChanged = !$b7d647e3cd0557f1$var$_dates3.default.eq(nextProps.min, this.props.min, "minutes"), maxChanged = !$b7d647e3cd0557f1$var$_dates3.default.eq(nextProps.max, this.props.max, "minutes"), localeChanged = this.props.format !== nextProps.format || this.props.culture !== nextProps.culture;
        if (valChanged || minChanged || maxChanged || localeChanged) this.setState({
            focusedItem: focusedItem || data[0],
            dates: data
        });
    },
    render: function render() {
        var _props = this.props, value = _props.value, onSelect = _props.onSelect, itemComponent = _props.itemComponent;
        var times = this.state.dates, date = this._closestDate(times, value);
        return $b7d647e3cd0557f1$var$_react2.default.createElement($b7d647e3cd0557f1$var$_List2.default, $b7d647e3cd0557f1$var$_extends({}, $b7d647e3cd0557f1$var$_3.default.omitOwnProps(this), {
            ref: "list",
            data: times,
            textField: "label",
            valueField: "date",
            selected: date,
            onSelect: onSelect,
            focused: this.state.focusedItem,
            itemComponent: itemComponent
        }));
    },
    _closestDate: function _closestDate(times, date) {
        var roundTo = 60000 * this.props.step, inst = null, label;
        if (!date) return null;
        date = new Date(Math.floor(date.getTime() / roundTo) * roundTo);
        label = $7fTd5.date.format(date, $b7d647e3cd0557f1$var$format(this.props), this.props.culture);
        times.some(function(time) {
            if (time.label === label) return inst = time;
        });
        return inst;
    },
    _data: function _data() {
        return this.state.dates;
    },
    _dates: function _dates(props) {
        var times = [], i = 0, values = this._dateValues(props), start = values.min, startDay = $b7d647e3cd0557f1$var$_dates3.default.date(start);
        while($b7d647e3cd0557f1$var$_dates3.default.date(start) === startDay && $b7d647e3cd0557f1$var$_dates3.default.lte(start, values.max)){
            i++;
            times.push({
                date: start,
                label: $7fTd5.date.format(start, $b7d647e3cd0557f1$var$format(props), props.culture)
            });
            start = $b7d647e3cd0557f1$var$_dates3.default.add(start, props.step || 30, "minutes");
        }
        return times;
    },
    _dateValues: function _dateValues(props) {
        var value = props.value || props.currentDate || $b7d647e3cd0557f1$var$_dates3.default.today(), useDate = props.preserveDate, min = props.min, max = props.max, start, end;
        //compare just the time regradless of whether they fall on the same day
        if (!useDate) {
            start = $b7d647e3cd0557f1$var$_dates3.default.startOf($b7d647e3cd0557f1$var$_dates3.default.merge(new Date(), min, props.currentDate), "minutes");
            end = $b7d647e3cd0557f1$var$_dates3.default.startOf($b7d647e3cd0557f1$var$_dates3.default.merge(new Date(), max, props.currentDate), "minutes");
            if ($b7d647e3cd0557f1$var$_dates3.default.lte(end, start) && $b7d647e3cd0557f1$var$_dates3.default.gt(max, min, "day")) end = $b7d647e3cd0557f1$var$_dates3.default.tomorrow();
            return {
                min: start,
                max: end
            };
        }
        start = $b7d647e3cd0557f1$var$_dates3.default.today();
        end = $b7d647e3cd0557f1$var$_dates3.default.tomorrow();
        //date parts are equal
        return {
            min: $b7d647e3cd0557f1$var$_dates3.default.eq(value, min, "day") ? $b7d647e3cd0557f1$var$_dates3.default.merge(start, min, props.currentDate) : start,
            max: $b7d647e3cd0557f1$var$_dates3.default.eq(value, max, "day") ? $b7d647e3cd0557f1$var$_dates3.default.merge(start, max, props.currentDate) : end
        };
    },
    handleKeyDown: function handleKeyDown(e) {
        var key = e.key, focusedItem = this.state.focusedItem, list = this.refs.list;
        if (key === "End") {
            e.preventDefault();
            this.setState({
                focusedItem: list.last()
            });
        } else if (key === "Home") {
            e.preventDefault();
            this.setState({
                focusedItem: list.first()
            });
        } else if (key === "Enter") this.props.onSelect(focusedItem);
        else if (key === "ArrowDown") {
            e.preventDefault();
            this.setState({
                focusedItem: list.next(focusedItem)
            });
        } else if (key === "ArrowUp") {
            e.preventDefault();
            this.setState({
                focusedItem: list.prev(focusedItem)
            });
        }
    },
    handleKeyPress: function handleKeyPress(e) {
        var _this = this;
        e.preventDefault();
        this.search(String.fromCharCode(e.which), function(item) {
            _this._mounted && _this.setState({
                focusedItem: item
            });
        });
    },
    scrollTo: function scrollTo() {
        this.refs.list.move && this.refs.list.move();
    },
    search: function search(character, cb) {
        var _this2 = this;
        var word = ((this._searchTerm || "") + character).toLowerCase();
        this._searchTerm = word;
        this.setTimeout("search", function() {
            var list = _this2.refs.list, item = list.next(_this2.state.focusedItem, word);
            _this2._searchTerm = "";
            if (item) cb(item);
        }, this.props.delay);
    }
});
module.exports = module.exports["default"];

});

parcelRegister("3SpYr", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $2d2a901ae2b8b97e$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $jbmdS = parcelRequire("jbmdS");
var $2d2a901ae2b8b97e$var$_react2 = $2d2a901ae2b8b97e$var$_interopRequireDefault($jbmdS);

var $2MXkj = parcelRequire("2MXkj");
var $2d2a901ae2b8b97e$var$_propTypes2 = $2d2a901ae2b8b97e$var$_interopRequireDefault($2MXkj);

var $e64Mn = parcelRequire("e64Mn");
var $2d2a901ae2b8b97e$var$_createReactClass2 = $2d2a901ae2b8b97e$var$_interopRequireDefault($e64Mn);

var $4ELyG = parcelRequire("4ELyG");
var $2d2a901ae2b8b97e$var$_3 = $2d2a901ae2b8b97e$var$_interopRequireDefault($4ELyG);

var $il45H = parcelRequire("il45H");
var $2d2a901ae2b8b97e$var$_Input2 = $2d2a901ae2b8b97e$var$_interopRequireDefault($il45H);

var $gl4B1 = parcelRequire("gl4B1");
var $2d2a901ae2b8b97e$var$_compat2 = $2d2a901ae2b8b97e$var$_interopRequireDefault($gl4B1);

var $7fTd5 = parcelRequire("7fTd5");

var $iMXz6 = parcelRequire("iMXz6");
var $2d2a901ae2b8b97e$var$_propTypes4 = $2d2a901ae2b8b97e$var$_interopRequireDefault($iMXz6);
function $2d2a901ae2b8b97e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = (0, $2d2a901ae2b8b97e$var$_createReactClass2.default)({
    displayName: "DateTimePickerInput",
    propTypes: {
        format: $2d2a901ae2b8b97e$var$_propTypes4.default.dateFormat.isRequired,
        editing: $2d2a901ae2b8b97e$var$_propTypes2.default.bool,
        editFormat: $2d2a901ae2b8b97e$var$_propTypes4.default.dateFormat,
        parse: $2d2a901ae2b8b97e$var$_propTypes2.default.func.isRequired,
        value: $2d2a901ae2b8b97e$var$_propTypes2.default.instanceOf(Date),
        onChange: $2d2a901ae2b8b97e$var$_propTypes2.default.func.isRequired,
        culture: $2d2a901ae2b8b97e$var$_propTypes2.default.string
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        var value = nextProps.value, editing = nextProps.editing, editFormat = nextProps.editFormat, format = nextProps.format, culture = nextProps.culture;
        this.setState({
            textValue: $2d2a901ae2b8b97e$var$formatDate(value, editing && editFormat ? editFormat : format, culture)
        });
    },
    getInitialState: function getInitialState() {
        var _props = this.props, value = _props.value, editing = _props.editing, editFormat = _props.editFormat, format = _props.format, culture = _props.culture;
        return {
            textValue: $2d2a901ae2b8b97e$var$formatDate(value, editing && editFormat ? editFormat : format, culture)
        };
    },
    render: function render() {
        var _props2 = this.props, disabled = _props2.disabled, readOnly = _props2.readOnly;
        var textValue = this.state.textValue;
        var props = $2d2a901ae2b8b97e$var$_3.default.omitOwnProps(this);
        return $2d2a901ae2b8b97e$var$_react2.default.createElement($2d2a901ae2b8b97e$var$_Input2.default, $2d2a901ae2b8b97e$var$_extends({}, props, {
            type: "text",
            value: textValue,
            disabled: disabled,
            readOnly: readOnly,
            onChange: this.handleChange,
            onBlur: this.handleBlur
        }));
    },
    handleChange: function handleChange(_ref) {
        var value = _ref.target.value;
        this._needsFlush = true;
        this.setState({
            textValue: value
        });
    },
    handleBlur: function handleBlur(event) {
        var _props3 = this.props, format = _props3.format, culture = _props3.culture, parse = _props3.parse, onChange = _props3.onChange, onBlur = _props3.onBlur;
        onBlur && onBlur(event);
        if (this._needsFlush) {
            var date = parse(event.target.value);
            this._needsFlush = false;
            onChange(date, $2d2a901ae2b8b97e$var$formatDate(date, format, culture));
        }
    },
    focus: function focus() {
        $2d2a901ae2b8b97e$var$_compat2.default.findDOMNode(this).focus();
    }
});
function $2d2a901ae2b8b97e$var$isValid(d) {
    return !isNaN(d.getTime());
}
function $2d2a901ae2b8b97e$var$formatDate(date, format, culture) {
    var val = "";
    if (date instanceof Date && $2d2a901ae2b8b97e$var$isValid(date)) val = $7fTd5.date.format(date, format, culture);
    return val;
}
module.exports = module.exports["default"];

});


parcelRegister("aKsZE", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $7d34b0bf902f9eed$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $7d34b0bf902f9eed$var$_desc, $7d34b0bf902f9eed$var$_value, $7d34b0bf902f9eed$var$_obj;

var $jbmdS = parcelRequire("jbmdS");
var $7d34b0bf902f9eed$var$_react2 = $7d34b0bf902f9eed$var$_interopRequireDefault($jbmdS);

var $2MXkj = parcelRequire("2MXkj");
var $7d34b0bf902f9eed$var$_propTypes2 = $7d34b0bf902f9eed$var$_interopRequireDefault($2MXkj);

var $e64Mn = parcelRequire("e64Mn");
var $7d34b0bf902f9eed$var$_createReactClass2 = $7d34b0bf902f9eed$var$_interopRequireDefault($e64Mn);

var $02LyB = parcelRequire("02LyB");
var $7d34b0bf902f9eed$var$_classnames2 = $7d34b0bf902f9eed$var$_interopRequireDefault($02LyB);

var $4ELyG = parcelRequire("4ELyG");
var $7d34b0bf902f9eed$var$_3 = $7d34b0bf902f9eed$var$_interopRequireDefault($4ELyG);

var $gl4B1 = parcelRequire("gl4B1");
var $7d34b0bf902f9eed$var$_compat2 = $7d34b0bf902f9eed$var$_interopRequireDefault($gl4B1);

var $iMXz6 = parcelRequire("iMXz6");
var $7d34b0bf902f9eed$var$_propTypes4 = $7d34b0bf902f9eed$var$_interopRequireDefault($iMXz6);

var $12xR0 = parcelRequire("12xR0");
var $7d34b0bf902f9eed$var$_uncontrollable2 = $7d34b0bf902f9eed$var$_interopRequireDefault($12xR0);

var $7XXyP = parcelRequire("7XXyP");

var $cMV7f = parcelRequire("cMV7f");
var $7d34b0bf902f9eed$var$_repeater2 = $7d34b0bf902f9eed$var$_interopRequireDefault($cMV7f);

var $7fTd5 = parcelRequire("7fTd5");

var $eHN4r = parcelRequire("eHN4r");
var $7d34b0bf902f9eed$var$_NumberInput2 = $7d34b0bf902f9eed$var$_interopRequireDefault($eHN4r);

var $lPWfx = parcelRequire("lPWfx");
var $7d34b0bf902f9eed$var$_Button2 = $7d34b0bf902f9eed$var$_interopRequireDefault($lPWfx);

var $cQuVG = parcelRequire("cQuVG");

var $9yNJk = parcelRequire("9yNJk");
function $7d34b0bf902f9eed$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7d34b0bf902f9eed$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $7d34b0bf902f9eed$var$_applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object["keys"](descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ("value" in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object["defineProperty"](target, property, desc);
        desc = null;
    }
    return desc;
}
var $7d34b0bf902f9eed$var$format = function format(props) {
    return $7fTd5.number.getFormat("default", props.format);
};
var $7d34b0bf902f9eed$var$propTypes = {
    // -- controlled props -----------
    value: $7d34b0bf902f9eed$var$_propTypes2.default.number,
    onChange: $7d34b0bf902f9eed$var$_propTypes2.default.func,
    //------------------------------------
    min: $7d34b0bf902f9eed$var$_propTypes2.default.number,
    max: $7d34b0bf902f9eed$var$_propTypes2.default.number,
    step: $7d34b0bf902f9eed$var$_propTypes2.default.number,
    precision: $7d34b0bf902f9eed$var$_propTypes2.default.number,
    culture: $7d34b0bf902f9eed$var$_propTypes2.default.string,
    format: $7d34b0bf902f9eed$var$_propTypes4.default.numberFormat,
    name: $7d34b0bf902f9eed$var$_propTypes2.default.string,
    parse: $7d34b0bf902f9eed$var$_propTypes2.default.func,
    autoFocus: $7d34b0bf902f9eed$var$_propTypes2.default.bool,
    disabled: $7d34b0bf902f9eed$var$_propTypes4.default.disabled,
    readOnly: $7d34b0bf902f9eed$var$_propTypes4.default.readOnly,
    messages: $7d34b0bf902f9eed$var$_propTypes2.default.shape({
        increment: $7d34b0bf902f9eed$var$_propTypes2.default.string,
        decrement: $7d34b0bf902f9eed$var$_propTypes2.default.string
    }),
    placeholder: $7d34b0bf902f9eed$var$_propTypes2.default.string
};




var $7d34b0bf902f9eed$var$NumberPicker = (0, $7d34b0bf902f9eed$var$_createReactClass2.default)(($7d34b0bf902f9eed$var$_obj = {
    displayName: "NumberPicker",
    mixins: [
        (parcelRequire("7Hmlb")),
        (parcelRequire("7xDAs")),
        (parcelRequire("h64ZC")),
        (parcelRequire("eC1mP"))({
            willHandle: function willHandle(focused) {
                if (focused) this.focus();
            }
        })
    ],
    propTypes: $7d34b0bf902f9eed$var$propTypes,
    getDefaultProps: function getDefaultProps() {
        return {
            value: null,
            open: false,
            min: -Infinity,
            max: Infinity,
            step: 1,
            messages: {
                increment: "increment value",
                decrement: "decrement value"
            }
        };
    },
    getInitialState: function getInitialState() {
        return {
            focused: false,
            active: false
        };
    },
    render: function render() {
        var _this = this;
        var _$omitOwnProps = $7d34b0bf902f9eed$var$_3.default.omitOwnProps(this), className = _$omitOwnProps.className, onKeyPress = _$omitOwnProps.onKeyPress, onKeyUp = _$omitOwnProps.onKeyUp, props = $7d34b0bf902f9eed$var$_objectWithoutProperties(_$omitOwnProps, [
            "className",
            "onKeyPress",
            "onKeyUp"
        ]);
        var val = this.constrainValue(this.props.value);
        return $7d34b0bf902f9eed$var$_react2.default.createElement("div", $7d34b0bf902f9eed$var$_extends({}, props, {
            ref: "element",
            onKeyDown: this._keyDown,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            tabIndex: "-1",
            className: (0, $7d34b0bf902f9eed$var$_classnames2.default)(className, "rw-numberpicker", "rw-widget", {
                "rw-state-focus": this.state.focused,
                "rw-state-disabled": this.props.disabled,
                "rw-state-readonly": this.props.readOnly,
                "rw-rtl": this.isRtl()
            })
        }), $7d34b0bf902f9eed$var$_react2.default.createElement("span", {
            className: "rw-select"
        }, $7d34b0bf902f9eed$var$_react2.default.createElement($7d34b0bf902f9eed$var$_Button2.default, {
            icon: "caret-up",
            onClick: this.handleFocus,
            label: this.props.messages.increment,
            active: this.state.active === $7XXyP.directions.UP,
            disabled: val === this.props.max || this.props.disabled,
            onMouseUp: function onMouseUp() {
                return _this.handleMouseUp($7XXyP.directions.UP);
            },
            onMouseDown: function onMouseDown() {
                return _this.handleMouseDown($7XXyP.directions.UP);
            },
            onMouseLeave: function onMouseLeave() {
                return _this.handleMouseUp($7XXyP.directions.UP);
            }
        }), $7d34b0bf902f9eed$var$_react2.default.createElement($7d34b0bf902f9eed$var$_Button2.default, {
            icon: "caret-down",
            onClick: this.handleFocus,
            label: this.props.messages.decrement,
            active: this.state.active === $7XXyP.directions.DOWN,
            disabled: val === this.props.min || this.props.disabled,
            onMouseUp: function onMouseUp() {
                return _this.handleMouseUp($7XXyP.directions.DOWN);
            },
            onMouseDown: function onMouseDown() {
                return _this.handleMouseDown($7XXyP.directions.DOWN);
            },
            onMouseLeave: function onMouseLeave() {
                return _this.handleMouseUp($7XXyP.directions.DOWN);
            }
        })), $7d34b0bf902f9eed$var$_react2.default.createElement($7d34b0bf902f9eed$var$_NumberInput2.default, {
            ref: "input",
            tabIndex: props.tabIndex,
            placeholder: this.props.placeholder,
            value: val,
            autoFocus: this.props.autoFocus,
            editing: this.state.focused,
            format: this.props.format,
            parse: this.props.parse,
            name: this.props.name,
            role: "spinbutton",
            min: this.props.min,
            "aria-valuenow": val,
            "aria-valuemin": isFinite(this.props.min) ? this.props.min : null,
            "aria-valuemax": isFinite(this.props.max) ? this.props.max : null,
            "aria-disabled": this.props.disabled,
            "aria-readonly": this.props.readonly,
            disabled: this.props.disabled,
            readOnly: this.props.readOnly,
            onChange: this.change,
            onKeyPress: onKeyPress,
            onKeyUp: onKeyUp
        }));
    },
    handleMouseDown: function handleMouseDown(dir) {
        var method = dir === $7XXyP.directions.UP ? this.increment : this.decrement;
        this.setState({
            active: dir
        });
        var val = method.call(this);
        if (!(dir === $7XXyP.directions.UP && val === this.props.max || dir === $7XXyP.directions.DOWN && val === this.props.min)) {
            if (!this._cancelRepeater) this._cancelRepeater = (0, $7d34b0bf902f9eed$var$_repeater2.default)(this.handleMouseDown.bind(null, dir));
        } else this.handleMouseUp();
    },
    handleMouseUp: function handleMouseUp() {
        this.setState({
            active: false
        });
        this._cancelRepeater && this._cancelRepeater();
        this._cancelRepeater = null;
    },
    _keyDown: function _keyDown(e) {
        var key = e.key;
        (0, $9yNJk.notify)(this.props.onKeyDown, [
            e
        ]);
        if (e.defaultPrevented) return;
        if (key === "End" && isFinite(this.props.max)) this.change(this.props.max);
        else if (key === "Home" && isFinite(this.props.min)) this.change(this.props.min);
        else if (key === "ArrowDown") {
            e.preventDefault();
            this.decrement();
        } else if (key === "ArrowUp") {
            e.preventDefault();
            this.increment();
        }
    },
    focus: function focus() {
        $7d34b0bf902f9eed$var$_compat2.default.findDOMNode(this.refs.input).focus();
    },
    increment: function increment() {
        return this.step(this.props.step);
    },
    decrement: function decrement() {
        return this.step(-this.props.step);
    },
    step: function step(amount) {
        var value = (this.props.value || 0) + amount;
        var decimals = this.props.precision != null ? this.props.precision : $7fTd5.number.precision($7d34b0bf902f9eed$var$format(this.props));
        this.change(decimals != null ? $7d34b0bf902f9eed$var$round(value, decimals) : value);
        return value;
    },
    change: function change(val) {
        val = this.constrainValue(val);
        if (this.props.value !== val) (0, $9yNJk.notify)(this.props.onChange, val);
    },
    constrainValue: function constrainValue(value) {
        var max = this.props.max == null ? Infinity : this.props.max, min = this.props.min == null ? -Infinity : this.props.min;
        if (value == null || value === "") return null;
        return Math.max(Math.min(value, max), min);
    }
}, $7d34b0bf902f9eed$var$_applyDecoratedDescriptor($7d34b0bf902f9eed$var$_obj, "handleMouseDown", [
    $cQuVG.widgetEditable
], Object.getOwnPropertyDescriptor($7d34b0bf902f9eed$var$_obj, "handleMouseDown"), $7d34b0bf902f9eed$var$_obj), $7d34b0bf902f9eed$var$_applyDecoratedDescriptor($7d34b0bf902f9eed$var$_obj, "handleMouseUp", [
    $cQuVG.widgetEditable
], Object.getOwnPropertyDescriptor($7d34b0bf902f9eed$var$_obj, "handleMouseUp"), $7d34b0bf902f9eed$var$_obj), $7d34b0bf902f9eed$var$_applyDecoratedDescriptor($7d34b0bf902f9eed$var$_obj, "_keyDown", [
    $cQuVG.widgetEditable
], Object.getOwnPropertyDescriptor($7d34b0bf902f9eed$var$_obj, "_keyDown"), $7d34b0bf902f9eed$var$_obj), $7d34b0bf902f9eed$var$_obj));
module.exports.default = (0, $7d34b0bf902f9eed$var$_uncontrollable2.default)($7d34b0bf902f9eed$var$NumberPicker, {
    value: "onChange"
}, [
    "focus"
]);
// thank you kendo ui core
// https://github.com/telerik/kendo-ui-core/blob/master/src/kendo.core.js#L1036
function $7d34b0bf902f9eed$var$round(value, precision) {
    precision = precision || 0;
    value = ("" + value).split("e");
    value = Math.round(+(value[0] + "e" + (value[1] ? +value[1] + precision : precision)));
    value = ("" + value).split("e");
    value = +(value[0] + "e" + (value[1] ? +value[1] - precision : -precision));
    return value.toFixed(precision);
}
module.exports = module.exports["default"];

});
parcelRegister("cMV7f", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $94f645bd739f74da$var$Repeater;
// my tests in ie11/chrome/FF indicate that keyDown repeats
// at about 35ms+/- 5ms after an initial 500ms delay. callback fires on the leading edge
function $94f645bd739f74da$var$Repeater(callback) {
    var id, cancel = function cancel() {
        return clearInterval(id);
    };
    id = setInterval(function() {
        cancel();
        id = setInterval(callback, 35);
        callback(); //fire after everything in case the user cancels on the first call
    }, 500);
    return cancel;
}
module.exports = module.exports["default"];

});

parcelRegister("eHN4r", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $ab4b253933dd43ff$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $jbmdS = parcelRequire("jbmdS");
var $ab4b253933dd43ff$var$_react2 = $ab4b253933dd43ff$var$_interopRequireDefault($jbmdS);

var $2MXkj = parcelRequire("2MXkj");
var $ab4b253933dd43ff$var$_propTypes2 = $ab4b253933dd43ff$var$_interopRequireDefault($2MXkj);

var $e64Mn = parcelRequire("e64Mn");
var $ab4b253933dd43ff$var$_createReactClass2 = $ab4b253933dd43ff$var$_interopRequireDefault($e64Mn);

var $4ELyG = parcelRequire("4ELyG");
var $ab4b253933dd43ff$var$_3 = $ab4b253933dd43ff$var$_interopRequireDefault($4ELyG);

var $iMXz6 = parcelRequire("iMXz6");
var $ab4b253933dd43ff$var$_propTypes4 = $ab4b253933dd43ff$var$_interopRequireDefault($iMXz6);

var $7fTd5 = parcelRequire("7fTd5");
function $ab4b253933dd43ff$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $ab4b253933dd43ff$var$getFormat = function getFormat(props) {
    return $7fTd5.number.getFormat("default", props.format);
};
var $ab4b253933dd43ff$var$propTypes = {
    value: $ab4b253933dd43ff$var$_propTypes2.default.number,
    editing: $ab4b253933dd43ff$var$_propTypes2.default.bool,
    placeholder: $ab4b253933dd43ff$var$_propTypes2.default.string,
    format: $ab4b253933dd43ff$var$_propTypes4.default.numberFormat,
    parse: $ab4b253933dd43ff$var$_propTypes2.default.func,
    culture: $ab4b253933dd43ff$var$_propTypes2.default.string,
    min: $ab4b253933dd43ff$var$_propTypes2.default.number,
    onChange: $ab4b253933dd43ff$var$_propTypes2.default.func.isRequired,
    onKeyDown: $ab4b253933dd43ff$var$_propTypes2.default.func
};
module.exports.default = (0, $ab4b253933dd43ff$var$_createReactClass2.default)({
    displayName: "NumberPickerInput",
    propTypes: $ab4b253933dd43ff$var$propTypes,
    getDefaultProps: function getDefaultProps() {
        return {
            value: null,
            editing: false
        };
    },
    getDefaultState: function getDefaultState() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
        var value = props.value, decimal = $7fTd5.number.decimalChar(null, props.culture), format = $ab4b253933dd43ff$var$getFormat(props);
        if (value == null || isNaN(props.value)) value = "";
        else value = props.editing ? ("" + value).replace(".", decimal) : $7fTd5.number.format(value, format, props.culture);
        return {
            stringValue: "" + value
        };
    },
    getInitialState: function getInitialState() {
        return this.getDefaultState();
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        this.setState(this.getDefaultState(nextProps));
    },
    render: function render() {
        var value = this.state.stringValue;
        var props = $ab4b253933dd43ff$var$_3.default.omitOwnProps(this);
        return $ab4b253933dd43ff$var$_react2.default.createElement("input", $ab4b253933dd43ff$var$_extends({}, props, {
            type: "text",
            className: "rw-input",
            onChange: this._change,
            onBlur: this._finish,
            "aria-disabled": this.props.disabled,
            "aria-readonly": this.props.readOnly,
            disabled: this.props.disabled,
            readOnly: this.props.readOnly,
            placeholder: this.props.placeholder,
            value: value
        }));
    },
    _change: function _change(e) {
        var val = e.target.value, number = this._parse(e.target.value);
        var isIntermediate = this.isIntermediateValue(number, val);
        if (val == null || val.trim() === "") {
            this.current("");
            return this.props.onChange(null);
        }
        if (!isIntermediate) {
            if (number !== this.props.value) return this.props.onChange(number);
        } else this.current(e.target.value);
    },
    _finish: function _finish() {
        var str = this.state.stringValue, number = this._parse(str);
        // if number is below the min
        // we need to flush low values and decimal stops, onBlur means i'm done inputing
        if (this.isIntermediateValue(number, str)) {
            if (isNaN(number)) number = null;
            this.props.onChange(number);
        }
    },
    _parse: function _parse(strVal) {
        var culture = this.props.culture, delimChar = $7fTd5.number.decimalChar(null, culture), userParse = this.props.parse;
        if (userParse) return userParse(strVal, culture);
        strVal = strVal.replace(delimChar, ".");
        strVal = parseFloat(strVal);
        return strVal;
    },
    isIntermediateValue: function isIntermediateValue(num, str) {
        return !!(num < this.props.min || this.isSign(str) || this.isAtDelimiter(num, str) || this.isPaddedZeros(str));
    },
    isSign: function isSign(val) {
        return (val || "").trim() === "-";
    },
    isPaddedZeros: function isPaddedZeros(str) {
        var localeChar = $7fTd5.number.decimalChar(null, this.props.culture);
        var _str$split = str.split(localeChar), _ = _str$split[0], decimals = _str$split[1];
        return !!(decimals && decimals.match(/0+$/));
    },
    isAtDelimiter: function isAtDelimiter(num, str) {
        var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props;
        var localeChar = $7fTd5.number.decimalChar(null, props.culture), lastIndex = str.length - 1, char;
        if (str.length < 1) return false;
        char = str[lastIndex];
        return !!(char === localeChar && str.indexOf(char) === lastIndex);
    },
    isValid: function isValid(num) {
        if (typeof num !== "number" || isNaN(num)) return false;
        return num >= this.props.min;
    },
    //this intermediate state is for when one runs into the decimal or are typing the number
    current: function current(stringValue) {
        this.setState({
            stringValue: stringValue
        });
    }
});
module.exports = module.exports["default"];

});


parcelRegister("iVgcb", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $dc6a1cf13ac56ff3$var$_desc, $dc6a1cf13ac56ff3$var$_value, $dc6a1cf13ac56ff3$var$_obj;
var $dc6a1cf13ac56ff3$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $jbmdS = parcelRequire("jbmdS");
var $dc6a1cf13ac56ff3$var$_react2 = $dc6a1cf13ac56ff3$var$_interopRequireDefault($jbmdS);

var $2MXkj = parcelRequire("2MXkj");
var $dc6a1cf13ac56ff3$var$_propTypes2 = $dc6a1cf13ac56ff3$var$_interopRequireDefault($2MXkj);

var $e64Mn = parcelRequire("e64Mn");
var $dc6a1cf13ac56ff3$var$_createReactClass2 = $dc6a1cf13ac56ff3$var$_interopRequireDefault($e64Mn);

var $02LyB = parcelRequire("02LyB");
var $dc6a1cf13ac56ff3$var$_classnames2 = $dc6a1cf13ac56ff3$var$_interopRequireDefault($02LyB);

var $4ELyG = parcelRequire("4ELyG");
var $dc6a1cf13ac56ff3$var$_3 = $dc6a1cf13ac56ff3$var$_interopRequireDefault($4ELyG);

var $12xR0 = parcelRequire("12xR0");
var $dc6a1cf13ac56ff3$var$_uncontrollable2 = $dc6a1cf13ac56ff3$var$_interopRequireDefault($12xR0);

var $ikauB = parcelRequire("ikauB");
var $dc6a1cf13ac56ff3$var$_Widget2 = $dc6a1cf13ac56ff3$var$_interopRequireDefault($ikauB);

var $iXqdK = parcelRequire("iXqdK");
var $dc6a1cf13ac56ff3$var$_Popup2 = $dc6a1cf13ac56ff3$var$_interopRequireDefault($iXqdK);

var $hbvQc = parcelRequire("hbvQc");
var $dc6a1cf13ac56ff3$var$_MultiselectInput2 = $dc6a1cf13ac56ff3$var$_interopRequireDefault($hbvQc);

var $e9cbu = parcelRequire("e9cbu");
var $dc6a1cf13ac56ff3$var$_MultiselectTagList2 = $dc6a1cf13ac56ff3$var$_interopRequireDefault($e9cbu);

var $iMXz6 = parcelRequire("iMXz6");
var $dc6a1cf13ac56ff3$var$_propTypes4 = $dc6a1cf13ac56ff3$var$_interopRequireDefault($iMXz6);

var $dPmvq = parcelRequire("dPmvq");
var $dc6a1cf13ac56ff3$var$_List2 = $dc6a1cf13ac56ff3$var$_interopRequireDefault($dPmvq);

var $kNt4v = parcelRequire("kNt4v");
var $dc6a1cf13ac56ff3$var$_ListGroupable2 = $dc6a1cf13ac56ff3$var$_interopRequireDefault($kNt4v);

var $eqJK2 = parcelRequire("eqJK2");
var $dc6a1cf13ac56ff3$var$_validateListInterface2 = $dc6a1cf13ac56ff3$var$_interopRequireDefault($eqJK2);

var $3gVwc = parcelRequire("3gVwc");

var $cQuVG = parcelRequire("cQuVG");

var $9yNJk = parcelRequire("9yNJk");
function $dc6a1cf13ac56ff3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $dc6a1cf13ac56ff3$var$_applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object["keys"](descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ("value" in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object["defineProperty"](target, property, desc);
        desc = null;
    }
    return desc;
}
var $dc6a1cf13ac56ff3$var$compatCreate = function compatCreate(props, msgs) {
    return typeof msgs.createNew === "function" ? msgs.createNew(props) : [
        $dc6a1cf13ac56ff3$var$_react2.default.createElement("strong", {
            key: "dumb"
        }, '"' + props.searchTerm + '"'),
        " " + msgs.createNew
    ];
};
var $dc6a1cf13ac56ff3$var$splat = $dc6a1cf13ac56ff3$var$_3.default.splat;
var $dc6a1cf13ac56ff3$var$propTypes = $dc6a1cf13ac56ff3$var$_extends({}, $dc6a1cf13ac56ff3$var$_Popup2.default.propTypes, {
    data: $dc6a1cf13ac56ff3$var$_propTypes2.default.array,
    //-- controlled props --
    value: $dc6a1cf13ac56ff3$var$_propTypes2.default.array,
    onChange: $dc6a1cf13ac56ff3$var$_propTypes2.default.func,
    searchTerm: $dc6a1cf13ac56ff3$var$_propTypes2.default.string,
    onSearch: $dc6a1cf13ac56ff3$var$_propTypes2.default.func,
    open: $dc6a1cf13ac56ff3$var$_propTypes2.default.bool,
    onToggle: $dc6a1cf13ac56ff3$var$_propTypes2.default.func,
    //-------------------------------------------
    valueField: $dc6a1cf13ac56ff3$var$_propTypes2.default.string,
    textField: $dc6a1cf13ac56ff3$var$_propTypes4.default.accessor,
    tagComponent: $dc6a1cf13ac56ff3$var$_propTypes4.default.elementType,
    itemComponent: $dc6a1cf13ac56ff3$var$_propTypes4.default.elementType,
    listComponent: $dc6a1cf13ac56ff3$var$_propTypes4.default.elementType,
    groupComponent: $dc6a1cf13ac56ff3$var$_propTypes4.default.elementType,
    groupBy: $dc6a1cf13ac56ff3$var$_propTypes4.default.accessor,
    createComponent: $dc6a1cf13ac56ff3$var$_propTypes4.default.elementType,
    onSelect: $dc6a1cf13ac56ff3$var$_propTypes2.default.func,
    onCreate: $dc6a1cf13ac56ff3$var$_propTypes2.default.oneOfType([
        $dc6a1cf13ac56ff3$var$_propTypes2.default.oneOf([
            false
        ]),
        $dc6a1cf13ac56ff3$var$_propTypes2.default.func
    ]),
    inputSize: $dc6a1cf13ac56ff3$var$_propTypes2.default.func,
    busy: $dc6a1cf13ac56ff3$var$_propTypes2.default.bool,
    dropUp: $dc6a1cf13ac56ff3$var$_propTypes2.default.bool,
    placeholder: $dc6a1cf13ac56ff3$var$_propTypes2.default.string,
    autoFocus: $dc6a1cf13ac56ff3$var$_propTypes2.default.bool,
    disabled: $dc6a1cf13ac56ff3$var$_propTypes4.default.disabled.acceptsArray,
    readOnly: $dc6a1cf13ac56ff3$var$_propTypes4.default.readOnly.acceptsArray,
    messages: $dc6a1cf13ac56ff3$var$_propTypes2.default.shape({
        open: $dc6a1cf13ac56ff3$var$_propTypes4.default.message,
        emptyList: $dc6a1cf13ac56ff3$var$_propTypes4.default.message,
        emptyFilter: $dc6a1cf13ac56ff3$var$_propTypes4.default.message,
        createNew: $dc6a1cf13ac56ff3$var$_propTypes4.default.message
    })
});






var $dc6a1cf13ac56ff3$var$Multiselect = (0, $dc6a1cf13ac56ff3$var$_createReactClass2.default)(($dc6a1cf13ac56ff3$var$_obj = {
    displayName: "Multiselect",
    mixins: [
        (parcelRequire("7Hmlb")),
        (parcelRequire("asC0i")),
        (parcelRequire("602jV")),
        (parcelRequire("h64ZC")),
        (parcelRequire("eC1mP"))({
            willHandle: function willHandle(focused) {
                focused && this.focus();
            },
            didHandle: function didHandle(focused) {
                if (!focused) this.close();
                if (!focused && this.refs.tagList) this.setState({
                    focusedTag: null
                });
                if (focused && !this.props.open) this.open();
            }
        }),
        (parcelRequire("aU65n"))("input", function(key, id) {
            var myKey = this.props.ariaActiveDescendantKey;
            var createIsActive = (!this._data().length || this.state.focusedItem === null) && key === myKey;
            var tagIsActive = this.state.focusedTag != null && key === "taglist";
            var listIsActive = this.state.focusedTag == null && key === "list";
            if (createIsActive || tagIsActive || listIsActive) return id;
        })
    ],
    propTypes: $dc6a1cf13ac56ff3$var$propTypes,
    getDefaultProps: function getDefaultProps() {
        return {
            data: [],
            filter: "startsWith",
            value: [],
            open: false,
            searchTerm: "",
            ariaActiveDescendantKey: "multiselect",
            messages: {
                createNew: "(create new tag)",
                emptyList: "There are no items in this list",
                emptyFilter: "The filter returned no results",
                tagsLabel: "selected items",
                selectedItems: "selected items",
                noneSelected: "no selected items",
                removeLabel: "remove selected item"
            }
        };
    },
    getInitialState: function getInitialState() {
        var _props = this.props, data = _props.data, value = _props.value, valueField = _props.valueField, searchTerm = _props.searchTerm, dataItems = $dc6a1cf13ac56ff3$var$splat(value).map(function(item) {
            return (0, $3gVwc.dataItem)(data, item, valueField);
        }), processedData = this.process(data, dataItems, searchTerm);
        return {
            focusedTag: null,
            focusedItem: processedData[0],
            processedData: processedData,
            dataItems: dataItems
        };
    },
    componentDidUpdate: function componentDidUpdate() {
        this.ariaActiveDescendant((0, $9yNJk.instanceId)(this, "__createlist_option"));
        this.refs.list && (0, $dc6a1cf13ac56ff3$var$_validateListInterface2.default)(this.refs.list);
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        var data = nextProps.data, value = nextProps.value, valueField = nextProps.valueField, searchTerm = nextProps.searchTerm, values = $dc6a1cf13ac56ff3$var$_3.default.splat(value), current = this.state.focusedItem, items = this.process(data, values, searchTerm);
        this.setState({
            processedData: items,
            focusedItem: items.indexOf(current) === -1 ? items[0] : current,
            dataItems: values.map(function(item) {
                return (0, $3gVwc.dataItem)(data, item, valueField);
            })
        });
    },
    renderCreateItem: function renderCreateItem(id, messages) {
        var _this = this;
        var searchTerm = this.props.searchTerm;
        var focusedItem = this.state.focusedItem;
        var createIsFocused = !this._data().length || focusedItem === null;
        var optionID = (0, $9yNJk.instanceId)(this, "__createlist_option");
        return $dc6a1cf13ac56ff3$var$_react2.default.createElement("ul", {
            id: id,
            role: "listbox",
            className: "rw-list rw-multiselect-create-tag"
        }, $dc6a1cf13ac56ff3$var$_react2.default.createElement("li", {
            id: optionID,
            role: "option",
            onClick: function onClick() {
                return _this.handleCreate(searchTerm);
            },
            className: (0, $dc6a1cf13ac56ff3$var$_classnames2.default)("rw-list-option", "rw-create-list-option", createIsFocused && "rw-state-focus")
        }, $dc6a1cf13ac56ff3$var$compatCreate(this.props, messages)));
    },
    renderInput: function renderInput(owns) {
        var _props2 = this.props, searchTerm = _props2.searchTerm, maxLength = _props2.maxLength, tabIndex = _props2.tabIndex, busy = _props2.busy, open = _props2.open, disabled = _props2.disabled, readOnly = _props2.readOnly;
        return $dc6a1cf13ac56ff3$var$_react2.default.createElement($dc6a1cf13ac56ff3$var$_MultiselectInput2.default, {
            ref: "input",
            tabIndex: tabIndex || 0,
            role: "listbox",
            "aria-expanded": !!open,
            "aria-busy": !!busy,
            autoFocus: this.props.autoFocus,
            "aria-owns": owns,
            "aria-haspopup": true,
            value: searchTerm,
            maxLength: maxLength,
            disabled: disabled === true,
            readOnly: readOnly === true,
            placeholder: this.getPlaceholder(),
            inputSize: this.props.inputSize,
            onKeyDown: this.handleSearchKeyDown,
            onKeyUp: this.handleSearchKeyUp,
            onChange: this.handleInputChange,
            onClick: this.handleInputInteraction,
            onTouchEnd: this.handleInputInteraction
        });
    },
    renderList: function renderList(List, id, messages) {
        var _props3 = this.props, open = _props3.open, disabled = _props3.disabled, readOnly = _props3.readOnly;
        var focusedItem = this.state.focusedItem;
        var listProps = $dc6a1cf13ac56ff3$var$_3.default.pickProps(this.props, List);
        var items = this._data();
        return $dc6a1cf13ac56ff3$var$_react2.default.createElement(List, $dc6a1cf13ac56ff3$var$_extends({
            ref: "list",
            key: 0
        }, listProps, {
            readOnly: readOnly,
            disabled: disabled,
            id: id,
            "aria-live": "polite",
            "aria-labelledby": (0, $9yNJk.instanceId)(this),
            "aria-hidden": !open,
            ariaActiveDescendantKey: "list",
            data: items,
            focused: focusedItem,
            onSelect: this.handleSelect,
            onMove: this._scrollTo,
            messages: {
                emptyList: this._lengthWithoutValues ? messages.emptyFilter : messages.emptyList
            }
        }));
    },
    renderNotificationArea: function renderNotificationArea(id, messages) {
        var textField = this.props.textField;
        var _state = this.state, focused = _state.focused, dataItems = _state.dataItems;
        return $dc6a1cf13ac56ff3$var$_react2.default.createElement("span", {
            id: id,
            role: "status",
            className: "rw-sr",
            "aria-live": "assertive",
            "aria-atomic": "true",
            "aria-relevant": "additions removals text"
        }, focused && (dataItems.length ? messages.selectedItems + ": " + dataItems.map(function(item) {
            return (0, $3gVwc.dataText)(item, textField);
        }).join(", ") : messages.noneSelected));
    },
    renderTags: function renderTags(id, messages) {
        var _props4 = this.props, disabled = _props4.disabled, readOnly = _props4.readOnly, valueField = _props4.valueField, textField = _props4.textField;
        var _state2 = this.state, focusedTag = _state2.focusedTag, dataItems = _state2.dataItems;
        var Component = this.props.tagComponent;
        return $dc6a1cf13ac56ff3$var$_react2.default.createElement($dc6a1cf13ac56ff3$var$_MultiselectTagList2.default, {
            ref: "tagList",
            id: id,
            valueField: valueField,
            textField: textField,
            "aria-label": messages.tagsLabel,
            value: dataItems,
            focused: focusedTag,
            disabled: disabled,
            readOnly: readOnly,
            onDelete: this.handleDelete,
            valueComponent: Component,
            ariaActiveDescendantKey: "taglist"
        });
    },
    render: function render() {
        var _this2 = this;
        var _props5 = this.props, className = _props5.className, groupBy = _props5.groupBy, messages = _props5.messages, busy = _props5.busy, dropUp = _props5.dropUp, open = _props5.open, duration = _props5.duration, disabled = _props5.disabled, readOnly = _props5.readOnly, List = _props5.listComponent;
        var _state3 = this.state, focused = _state3.focused, dataItems = _state3.dataItems;
        List = List || groupBy && $dc6a1cf13ac56ff3$var$_ListGroupable2.default || $dc6a1cf13ac56ff3$var$_List2.default;
        var elementProps = $dc6a1cf13ac56ff3$var$_3.default.omitOwnProps(this, List);
        var shouldRenderTags = !!dataItems.length, shouldRenderPopup = (0, $9yNJk.isFirstFocusedRender)(this) || open, shouldShowCreate = this.shouldShowCreate();
        var tagsID = (0, $9yNJk.instanceId)(this, "_taglist"), listID = (0, $9yNJk.instanceId)(this, "__listbox"), createID = (0, $9yNJk.instanceId)(this, "__createlist"), notifyID = (0, $9yNJk.instanceId)(this, "__notify");
        var inputOwns = listID + " " + notifyID + " " + (shouldRenderTags ? tagsID : "") + (shouldShowCreate ? createID : "");
        messages = $dc6a1cf13ac56ff3$var$msgs(messages);
        return $dc6a1cf13ac56ff3$var$_react2.default.createElement($dc6a1cf13ac56ff3$var$_Widget2.default, $dc6a1cf13ac56ff3$var$_extends({}, elementProps, {
            id: (0, $9yNJk.instanceId)(this),
            open: open,
            dropUp: dropUp,
            focused: focused,
            disabled: disabled === true,
            readOnly: readOnly === true,
            onKeyDown: this.handleKeyDown,
            onBlur: this.handleBlur,
            onFocus: this.handleFocus,
            onTouchEnd: this.handleFocus,
            className: (0, $dc6a1cf13ac56ff3$var$_classnames2.default)(className, "rw-multiselect")
        }), this.renderNotificationArea(notifyID, messages), $dc6a1cf13ac56ff3$var$_react2.default.createElement("div", {
            className: "rw-multiselect-wrapper"
        }, busy && $dc6a1cf13ac56ff3$var$_react2.default.createElement("span", {
            className: "rw-i rw-loading"
        }), shouldRenderTags && this.renderTags(tagsID, messages), this.renderInput(inputOwns)), shouldRenderPopup && $dc6a1cf13ac56ff3$var$_react2.default.createElement($dc6a1cf13ac56ff3$var$_Popup2.default, {
            dropUp: dropUp,
            open: open,
            duration: duration,
            onOpening: function onOpening() {
                return _this2.refs.list.forceUpdate();
            }
        }, $dc6a1cf13ac56ff3$var$_react2.default.createElement("div", null, this.renderList(List, listID, messages), shouldShowCreate && this.renderCreateItem(createID, messages))));
    },
    _data: function _data() {
        return this.state.processedData;
    },
    handleDelete: function handleDelete(value) {
        this.focus();
        this.change(this.state.dataItems.filter(function(d) {
            return d !== value;
        }));
    },
    handleSearchKeyDown: function handleSearchKeyDown(e) {
        if (e.key === "Backspace" && e.target.value && !this._deletingText) this._deletingText = true;
    },
    handleSearchKeyUp: function handleSearchKeyUp(e) {
        if (e.key === "Backspace" && this._deletingText) this._deletingText = false;
    },
    handleInputChange: function handleInputChange(e) {
        (0, $9yNJk.notify)(this.props.onSearch, [
            e.target.value
        ]);
        this.open();
    },
    handleInputInteraction: function handleInputInteraction() {
        this.open();
    },
    handleSelect: function handleSelect(data) {
        if (data === undefined) {
            if (this.props.onCreate) this.handleCreate(this.props.searchTerm);
            return;
        }
        (0, $9yNJk.notify)(this.props.onSelect, data);
        this.change(this.state.dataItems.concat(data));
        this.close();
        this.focus();
    },
    handleCreate: function handleCreate(tag) {
        if (tag.trim() === "") return;
        (0, $9yNJk.notify)(this.props.onCreate, tag);
        this.props.searchTerm && (0, $9yNJk.notify)(this.props.onSearch, [
            ""
        ]);
        this.close();
        this.focus();
    },
    handleKeyDown: function handleKeyDown(e) {
        var key = e.key, keyCode = e.keyCode, altKey = e.altKey, ctrlKey = e.ctrlKey, noSearch = !this.props.searchTerm && !this._deletingText, isOpen = this.props.open;
        var _state4 = this.state, focusedTag = _state4.focusedTag, focusedItem = _state4.focusedItem;
        var _refs = this.refs, list = _refs.list, tagList = _refs.tagList;
        var nullTag = {
            focusedTag: null
        };
        (0, $9yNJk.notify)(this.props.onKeyDown, [
            e
        ]);
        if (e.defaultPrevented) return;
        if (key === "ArrowDown") {
            var next = list.next(focusedItem), creating = this.shouldShowCreate() && focusedItem === next || focusedItem === null;
            next = creating ? null : next;
            e.preventDefault();
            if (isOpen) this.setState($dc6a1cf13ac56ff3$var$_extends({
                focusedItem: next
            }, nullTag));
            else this.open();
        } else if (key === "ArrowUp") {
            var prev = focusedItem === null ? list.last() : list.prev(focusedItem);
            e.preventDefault();
            if (altKey) this.close();
            else if (isOpen) this.setState($dc6a1cf13ac56ff3$var$_extends({
                focusedItem: prev
            }, nullTag));
        } else if (key === "End") {
            e.preventDefault();
            if (isOpen) this.setState($dc6a1cf13ac56ff3$var$_extends({
                focusedItem: list.last()
            }, nullTag));
            else tagList && this.setState({
                focusedTag: tagList.last()
            });
        } else if (key === "Home") {
            e.preventDefault();
            if (isOpen) this.setState($dc6a1cf13ac56ff3$var$_extends({
                focusedItem: list.first()
            }, nullTag));
            else tagList && this.setState({
                focusedTag: tagList.first()
            });
        } else if (isOpen && keyCode === 13) {
            // using keyCode to ignore enter for japanese IME
            e.preventDefault();
            ctrlKey && this.props.onCreate || focusedItem === null ? this.handleCreate(this.props.searchTerm) : this.handleSelect(this.state.focusedItem);
        } else if (key === "Escape") isOpen ? this.close() : tagList && this.setState(nullTag);
        else if (noSearch && key === "ArrowLeft") tagList && this.setState({
            focusedTag: tagList.prev(focusedTag)
        });
        else if (noSearch && key === "ArrowRight") tagList && this.setState({
            focusedTag: tagList.next(focusedTag)
        });
        else if (noSearch && key === "Delete") tagList && tagList.remove(focusedTag);
        else if (noSearch && key === "Backspace") tagList && tagList.removeNext();
    },
    change: function change(data) {
        (0, $9yNJk.notify)(this.props.onChange, [
            data
        ]);
        (0, $9yNJk.notify)(this.props.onSearch, [
            ""
        ]);
    },
    focus: function focus() {
        this.refs.input && this.refs.input.focus();
    },
    open: function open() {
        if (!this.props.open) (0, $9yNJk.notify)(this.props.onToggle, true);
    },
    close: function close() {
        (0, $9yNJk.notify)(this.props.onToggle, false);
    },
    toggle: function toggle() {
        this.props.open ? this.close() : this.open();
    },
    process: function process(data, values, searchTerm) {
        var valueField = this.props.valueField;
        var items = data.filter(function(i) {
            return !values.some(function(v) {
                return (0, $3gVwc.valueMatcher)(i, v, valueField);
            });
        });
        this._lengthWithoutValues = items.length;
        if (searchTerm) items = this.filter(items, searchTerm);
        return items;
    },
    shouldShowCreate: function shouldShowCreate() {
        var _props6 = this.props, textField = _props6.textField, searchTerm = _props6.searchTerm, onCreate = _props6.onCreate, caseSensitive = _props6.caseSensitive;
        if (!onCreate || !searchTerm) return false;
        var lower = function lower(text) {
            return caseSensitive ? text : text.toLowerCase();
        };
        var eq = function eq(v) {
            return lower((0, $3gVwc.dataText)(v, textField)) === lower(searchTerm);
        };
        // if there is an exact match on textFields: "john" => { name: "john" }, don't show
        return !this._data().some(eq) && !this.state.dataItems.some(eq);
    },
    getPlaceholder: function getPlaceholder() {
        return (this.props.value || []).length ? "" : this.props.placeholder || "";
    }
}, $dc6a1cf13ac56ff3$var$_applyDecoratedDescriptor($dc6a1cf13ac56ff3$var$_obj, "handleInputInteraction", [
    $cQuVG.widgetEditable
], Object.getOwnPropertyDescriptor($dc6a1cf13ac56ff3$var$_obj, "handleInputInteraction"), $dc6a1cf13ac56ff3$var$_obj), $dc6a1cf13ac56ff3$var$_applyDecoratedDescriptor($dc6a1cf13ac56ff3$var$_obj, "handleSelect", [
    $cQuVG.widgetEditable
], Object.getOwnPropertyDescriptor($dc6a1cf13ac56ff3$var$_obj, "handleSelect"), $dc6a1cf13ac56ff3$var$_obj), $dc6a1cf13ac56ff3$var$_applyDecoratedDescriptor($dc6a1cf13ac56ff3$var$_obj, "handleCreate", [
    $cQuVG.widgetEditable
], Object.getOwnPropertyDescriptor($dc6a1cf13ac56ff3$var$_obj, "handleCreate"), $dc6a1cf13ac56ff3$var$_obj), $dc6a1cf13ac56ff3$var$_applyDecoratedDescriptor($dc6a1cf13ac56ff3$var$_obj, "handleKeyDown", [
    $cQuVG.widgetEditable
], Object.getOwnPropertyDescriptor($dc6a1cf13ac56ff3$var$_obj, "handleKeyDown"), $dc6a1cf13ac56ff3$var$_obj), $dc6a1cf13ac56ff3$var$_applyDecoratedDescriptor($dc6a1cf13ac56ff3$var$_obj, "change", [
    $cQuVG.widgetEditable
], Object.getOwnPropertyDescriptor($dc6a1cf13ac56ff3$var$_obj, "change"), $dc6a1cf13ac56ff3$var$_obj), $dc6a1cf13ac56ff3$var$_obj));
function $dc6a1cf13ac56ff3$var$msgs(msgs) {
    return $dc6a1cf13ac56ff3$var$_extends({
        createNew: "(create new tag)",
        emptyList: "There are no items in this list",
        emptyFilter: "The filter returned no results",
        tagsLabel: "selected items",
        selectedItems: "selected items",
        removeLabel: "remove selected item"
    }, msgs);
}
module.exports.default = (0, $dc6a1cf13ac56ff3$var$_uncontrollable2.default)($dc6a1cf13ac56ff3$var$Multiselect, {
    open: "onToggle",
    value: "onChange",
    searchTerm: "onSearch"
}, [
    "focus"
]);
module.exports = module.exports["default"];

});
parcelRegister("hbvQc", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $c82c29af02f67949$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $c82c29af02f67949$var$_class, $c82c29af02f67949$var$_temp;

var $jbmdS = parcelRequire("jbmdS");
var $c82c29af02f67949$var$_react2 = $c82c29af02f67949$var$_interopRequireDefault($jbmdS);

var $2MXkj = parcelRequire("2MXkj");
var $c82c29af02f67949$var$_propTypes2 = $c82c29af02f67949$var$_interopRequireDefault($2MXkj);

var $4ELyG = parcelRequire("4ELyG");
var $c82c29af02f67949$var$_3 = $c82c29af02f67949$var$_interopRequireDefault($4ELyG);

var $gl4B1 = parcelRequire("gl4B1");
var $c82c29af02f67949$var$_compat2 = $c82c29af02f67949$var$_interopRequireDefault($gl4B1);

var $iMXz6 = parcelRequire("iMXz6");
var $c82c29af02f67949$var$_propTypes4 = $c82c29af02f67949$var$_interopRequireDefault($iMXz6);
function $c82c29af02f67949$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c82c29af02f67949$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $c82c29af02f67949$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c82c29af02f67949$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $c82c29af02f67949$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $c82c29af02f67949$var$MultiselectInput = ($c82c29af02f67949$var$_temp = $c82c29af02f67949$var$_class = function(_React$Component) {
    $c82c29af02f67949$var$_inherits(MultiselectInput, _React$Component);
    function MultiselectInput() {
        $c82c29af02f67949$var$_classCallCheck(this, MultiselectInput);
        return $c82c29af02f67949$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }
    MultiselectInput.prototype.render = function render() {
        var _props = this.props, disabled = _props.disabled, readOnly = _props.readOnly, placeholder = _props.placeholder, onChange = _props.onChange, value = _props.value, props = $c82c29af02f67949$var$_objectWithoutProperties(_props, [
            "disabled",
            "readOnly",
            "placeholder",
            "onChange",
            "value"
        ]);
        var size = props.inputSize ? props.inputSize(value || placeholder) : Math.max((value || placeholder).length, 1) + 1;
        var elementProps = $c82c29af02f67949$var$_3.default.omitOwnProps(this);
        return $c82c29af02f67949$var$_react2.default.createElement("input", $c82c29af02f67949$var$_extends({}, elementProps, {
            size: size,
            className: "rw-input",
            autoComplete: "off",
            "aria-disabled": disabled,
            "aria-readonly": readOnly,
            disabled: disabled,
            readOnly: readOnly,
            placeholder: placeholder,
            onChange: onChange,
            value: value
        }));
    };
    MultiselectInput.prototype.focus = function focus() {
        $c82c29af02f67949$var$_compat2.default.findDOMNode(this).focus();
    };
    return MultiselectInput;
}($c82c29af02f67949$var$_react2.default.Component), $c82c29af02f67949$var$_class.propTypes = {
    value: $c82c29af02f67949$var$_propTypes2.default.string,
    placeholder: $c82c29af02f67949$var$_propTypes2.default.string,
    maxLength: $c82c29af02f67949$var$_propTypes2.default.number,
    inputSize: $c82c29af02f67949$var$_propTypes2.default.func,
    onChange: $c82c29af02f67949$var$_propTypes2.default.func.isRequired,
    disabled: $c82c29af02f67949$var$_propTypes4.default.disabled,
    readOnly: $c82c29af02f67949$var$_propTypes4.default.readOnly
}, $c82c29af02f67949$var$_temp);
module.exports.default = $c82c29af02f67949$var$MultiselectInput;
module.exports = module.exports["default"];

});

parcelRegister("e9cbu", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $a4cb5b83b94610ad$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $jbmdS = parcelRequire("jbmdS");
var $a4cb5b83b94610ad$var$_react2 = $a4cb5b83b94610ad$var$_interopRequireDefault($jbmdS);

var $2MXkj = parcelRequire("2MXkj");
var $a4cb5b83b94610ad$var$_propTypes2 = $a4cb5b83b94610ad$var$_interopRequireDefault($2MXkj);

var $e64Mn = parcelRequire("e64Mn");
var $a4cb5b83b94610ad$var$_createReactClass2 = $a4cb5b83b94610ad$var$_interopRequireDefault($e64Mn);

var $4ELyG = parcelRequire("4ELyG");
var $a4cb5b83b94610ad$var$_3 = $a4cb5b83b94610ad$var$_interopRequireDefault($4ELyG);

var $02LyB = parcelRequire("02LyB");
var $a4cb5b83b94610ad$var$_classnames2 = $a4cb5b83b94610ad$var$_interopRequireDefault($02LyB);

var $iMXz6 = parcelRequire("iMXz6");
var $a4cb5b83b94610ad$var$_propTypes4 = $a4cb5b83b94610ad$var$_interopRequireDefault($iMXz6);

var $9yNJk = parcelRequire("9yNJk");

var $3gVwc = parcelRequire("3gVwc");

var $cQuVG = parcelRequire("cQuVG");
function $a4cb5b83b94610ad$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a4cb5b83b94610ad$var$optionId = function optionId(id, idx) {
    return id + "__option__" + idx;
};


module.exports.default = (0, $a4cb5b83b94610ad$var$_createReactClass2.default)({
    displayName: "MultiselectTagList",
    mixins: [
        (parcelRequire("7xDAs")),
        (parcelRequire("aU65n"))()
    ],
    propTypes: {
        value: $a4cb5b83b94610ad$var$_propTypes2.default.array,
        focused: $a4cb5b83b94610ad$var$_propTypes2.default.number,
        valueField: $a4cb5b83b94610ad$var$_propTypes2.default.string,
        textField: $a4cb5b83b94610ad$var$_propTypes4.default.accessor,
        onDelete: $a4cb5b83b94610ad$var$_propTypes2.default.func.isRequired,
        valueComponent: $a4cb5b83b94610ad$var$_propTypes2.default.func,
        disabled: $a4cb5b83b94610ad$var$_propTypes4.default.disabled.acceptsArray,
        readOnly: $a4cb5b83b94610ad$var$_propTypes4.default.readOnly.acceptsArray
    },
    getDefaultProps: function getDefaultProps() {
        return {
            ariaActiveDescendantKey: "taglist"
        };
    },
    componentDidUpdate: function componentDidUpdate() {
        var focused = this.props.focused, activeId = $a4cb5b83b94610ad$var$optionId((0, $9yNJk.instanceId)(this), focused);
        this.ariaActiveDescendant(focused == null || (0, $cQuVG.isDisabledItem)(focused, this.props) ? null : activeId);
    },
    render: function render() {
        var _this = this;
        var _props = this.props, focused = _props.focused, value = _props.value, textField = _props.textField, ValueComponent = _props.valueComponent;
        var id = (0, $9yNJk.instanceId)(this);
        var props = $a4cb5b83b94610ad$var$_3.default.omitOwnProps(this);
        return $a4cb5b83b94610ad$var$_react2.default.createElement("ul", $a4cb5b83b94610ad$var$_extends({}, props, {
            role: "listbox",
            tabIndex: "-1",
            className: "rw-multiselect-taglist"
        }), value.map(function(item, i) {
            var isDisabled = (0, $cQuVG.isDisabledItem)(item, _this.props), isReadonly = (0, $cQuVG.isReadOnlyItem)(item, _this.props), isFocused = !isDisabled && focused === i, currentID = $a4cb5b83b94610ad$var$optionId(id, i);
            return $a4cb5b83b94610ad$var$_react2.default.createElement("li", {
                key: i,
                id: currentID,
                tabIndex: "-1",
                role: "option",
                className: (0, $a4cb5b83b94610ad$var$_classnames2.default)({
                    "rw-state-focus": isFocused,
                    "rw-state-disabled": isDisabled,
                    "rw-state-readonly": isReadonly
                })
            }, ValueComponent ? $a4cb5b83b94610ad$var$_react2.default.createElement(ValueComponent, {
                item: item
            }) : (0, $3gVwc.dataText)(item, textField), $a4cb5b83b94610ad$var$_react2.default.createElement("span", {
                tabIndex: "-1",
                onClick: !(isDisabled || isReadonly) ? _this._delete.bind(null, item) : undefined,
                "aria-disabled": isDisabled,
                "aria-label": "Unselect",
                disabled: isDisabled
            }, $a4cb5b83b94610ad$var$_react2.default.createElement("span", {
                className: "rw-tag-btn",
                "aria-hidden": "true"
            }, "\xd7")));
        }));
    },
    _delete: function _delete(val) {
        this.props.onDelete(val);
    },
    remove: function remove(idx) {
        var val = this.props.value[idx];
        if (val && !((0, $cQuVG.isDisabledItem)(val, this.props) || (0, $cQuVG.isReadOnlyItem)(val, this.props))) this.props.onDelete(val);
    },
    removeNext: function removeNext() {
        var val = this.props.value[this.props.value.length - 1];
        if (val && !((0, $cQuVG.isDisabledItem)(val, this.props) || (0, $cQuVG.isReadOnlyItem)(val, this.props))) this.props.onDelete(val);
    },
    clear: function clear() {
        this.setState({
            focused: null
        });
    },
    first: function first() {
        var idx = 0, value = this.props.value, l = value.length;
        while(idx < l && (0, $cQuVG.isDisabledItem)(value[idx], this.props))idx++;
        return idx !== l ? idx : null;
    },
    last: function last() {
        var value = this.props.value, idx = value.length - 1;
        while(idx > -1 && (0, $cQuVG.isDisabledItem)(value[idx], this.props))idx--;
        return idx >= 0 ? idx : null;
    },
    next: function next(current) {
        var nextIdx = current + 1, value = this.props.value, l = value.length;
        while(nextIdx < l && (0, $cQuVG.isDisabledItem)(nextIdx, this.props))nextIdx++;
        if (current === null || nextIdx >= l) return null;
        return nextIdx;
    },
    prev: function prev(current) {
        var nextIdx = current, value = this.props.value;
        if (nextIdx === null || nextIdx === 0) nextIdx = value.length;
        nextIdx--;
        while(nextIdx > -1 && (0, $cQuVG.isDisabledItem)(value[nextIdx], this.props))nextIdx--;
        return nextIdx >= 0 ? nextIdx : null;
    }
});
module.exports = module.exports["default"];

});


parcelRegister("61e4p", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $461dc01f80e49c7a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $461dc01f80e49c7a$var$_desc, $461dc01f80e49c7a$var$_value, $461dc01f80e49c7a$var$_obj;

var $jbmdS = parcelRequire("jbmdS");
var $461dc01f80e49c7a$var$_react2 = $461dc01f80e49c7a$var$_interopRequireDefault($jbmdS);

var $2MXkj = parcelRequire("2MXkj");
var $461dc01f80e49c7a$var$_propTypes2 = $461dc01f80e49c7a$var$_interopRequireDefault($2MXkj);

var $e64Mn = parcelRequire("e64Mn");
var $461dc01f80e49c7a$var$_createReactClass2 = $461dc01f80e49c7a$var$_interopRequireDefault($e64Mn);

var $4ELyG = parcelRequire("4ELyG");
var $461dc01f80e49c7a$var$_3 = $461dc01f80e49c7a$var$_interopRequireDefault($4ELyG);

var $02LyB = parcelRequire("02LyB");
var $461dc01f80e49c7a$var$_classnames2 = $461dc01f80e49c7a$var$_interopRequireDefault($02LyB);

var $12xR0 = parcelRequire("12xR0");
var $461dc01f80e49c7a$var$_uncontrollable2 = $461dc01f80e49c7a$var$_interopRequireDefault($12xR0);

var $gl4B1 = parcelRequire("gl4B1");
var $461dc01f80e49c7a$var$_compat2 = $461dc01f80e49c7a$var$_interopRequireDefault($gl4B1);

var $iMXz6 = parcelRequire("iMXz6");
var $461dc01f80e49c7a$var$_propTypes4 = $461dc01f80e49c7a$var$_interopRequireDefault($iMXz6);

var $dPmvq = parcelRequire("dPmvq");
var $461dc01f80e49c7a$var$_List2 = $461dc01f80e49c7a$var$_interopRequireDefault($dPmvq);

var $kNt4v = parcelRequire("kNt4v");
var $461dc01f80e49c7a$var$_ListGroupable2 = $461dc01f80e49c7a$var$_interopRequireDefault($kNt4v);

var $iSbaG = parcelRequire("iSbaG");
var $461dc01f80e49c7a$var$_ListOption2 = $461dc01f80e49c7a$var$_interopRequireDefault($iSbaG);

var $ikauB = parcelRequire("ikauB");
var $461dc01f80e49c7a$var$_Widget2 = $461dc01f80e49c7a$var$_interopRequireDefault($ikauB);

var $eqJK2 = parcelRequire("eqJK2");
var $461dc01f80e49c7a$var$_validateListInterface2 = $461dc01f80e49c7a$var$_interopRequireDefault($eqJK2);

var $43Waz = parcelRequire("43Waz");
var $461dc01f80e49c7a$var$_scrollTo3 = $461dc01f80e49c7a$var$_interopRequireDefault($43Waz);

var $3gVwc = parcelRequire("3gVwc");

var $cQuVG = parcelRequire("cQuVG");

var $9yNJk = parcelRequire("9yNJk");
function $461dc01f80e49c7a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $461dc01f80e49c7a$var$_applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object["keys"](descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ("value" in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object["defineProperty"](target, property, desc);
        desc = null;
    }
    return desc;
}
var $461dc01f80e49c7a$var$find = $461dc01f80e49c7a$var$_3.default.find;
var $461dc01f80e49c7a$var$propTypes = {
    data: $461dc01f80e49c7a$var$_propTypes2.default.array,
    value: $461dc01f80e49c7a$var$_propTypes2.default.oneOfType([
        $461dc01f80e49c7a$var$_propTypes2.default.any,
        $461dc01f80e49c7a$var$_propTypes2.default.array
    ]),
    onChange: $461dc01f80e49c7a$var$_propTypes2.default.func,
    onMove: $461dc01f80e49c7a$var$_propTypes2.default.func,
    multiple: $461dc01f80e49c7a$var$_propTypes2.default.bool,
    itemComponent: $461dc01f80e49c7a$var$_propTypes4.default.elementType,
    listComponent: $461dc01f80e49c7a$var$_propTypes4.default.elementType,
    valueField: $461dc01f80e49c7a$var$_propTypes2.default.string,
    textField: $461dc01f80e49c7a$var$_propTypes4.default.accessor,
    busy: $461dc01f80e49c7a$var$_propTypes2.default.bool,
    filter: $461dc01f80e49c7a$var$_propTypes2.default.string,
    delay: $461dc01f80e49c7a$var$_propTypes2.default.number,
    disabled: $461dc01f80e49c7a$var$_propTypes4.default.disabled.acceptsArray,
    readOnly: $461dc01f80e49c7a$var$_propTypes4.default.readOnly.acceptsArray,
    messages: $461dc01f80e49c7a$var$_propTypes2.default.shape({
        emptyList: $461dc01f80e49c7a$var$_propTypes2.default.string
    })
};
function $461dc01f80e49c7a$var$getFirstValue(props) {
    var data = props.data, value = props.value, valueField = props.valueField;
    value = $461dc01f80e49c7a$var$_3.default.splat(value);
    if (value.length) return $461dc01f80e49c7a$var$find(data, function(d) {
        return (0, $3gVwc.dataIndexOf)(value, d, valueField) !== -1;
    }) || null;
    return null;
}





var $461dc01f80e49c7a$var$SelectList = (0, $461dc01f80e49c7a$var$_createReactClass2.default)(($461dc01f80e49c7a$var$_obj = {
    displayName: "SelectList",
    propTypes: $461dc01f80e49c7a$var$propTypes,
    mixins: [
        (parcelRequire("7Hmlb")),
        (parcelRequire("gYehs")),
        (parcelRequire("h64ZC")),
        (parcelRequire("aU65n"))(),
        (parcelRequire("eC1mP"))({
            didHandle: function didHandle(focused) {
                // the rigamarole here is to avoid flicker went clicking an item and
                // gaining focus at the same time.
                if (focused !== this.state.focused) {
                    if (!focused) this.setState({
                        focusedItem: null
                    });
                    else if (focused && !this._clicking) this.setState({
                        focusedItem: $461dc01f80e49c7a$var$getFirstValue(this.props)
                    });
                    this._clicking = false;
                }
            }
        })
    ],
    getDefaultProps: function getDefaultProps() {
        return {
            delay: 250,
            value: [],
            data: [],
            ariaActiveDescendantKey: "selectlist",
            messages: {
                emptyList: "There are no items in this list"
            }
        };
    },
    getDefaultState: function getDefaultState(props) {
        var data = props.data, value = props.value, valueField = props.valueField, multiple = props.multiple;
        return {
            dataItems: multiple && $461dc01f80e49c7a$var$_3.default.splat(value).map(function(item) {
                return (0, $3gVwc.dataItem)(data, item, valueField);
            })
        };
    },
    getInitialState: function getInitialState() {
        var state = this.getDefaultState(this.props);
        state.ListItem = $461dc01f80e49c7a$var$getListItem(this);
        return state;
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        return this.setState(this.getDefaultState(nextProps));
    },
    componentDidMount: function componentDidMount() {
        (0, $461dc01f80e49c7a$var$_validateListInterface2.default)(this.refs.list);
    },
    render: function render() {
        var _props = this.props, className = _props.className, tabIndex = _props.tabIndex, busy = _props.busy, groupBy = _props.groupBy, List = _props.listComponent;
        List = List || groupBy && $461dc01f80e49c7a$var$_ListGroupable2.default || $461dc01f80e49c7a$var$_List2.default;
        var elementProps = $461dc01f80e49c7a$var$_3.default.omitOwnProps(this, List);
        var listProps = $461dc01f80e49c7a$var$_3.default.pickProps(this.props, List);
        var _state = this.state, ListItem = _state.ListItem, focusedItem = _state.focusedItem, focused = _state.focused;
        var items = this._data();
        focusedItem = focused && !(0, $cQuVG.isDisabled)(this.props) && !(0, $cQuVG.isReadOnly)(this.props) && focusedItem;
        return $461dc01f80e49c7a$var$_react2.default.createElement($461dc01f80e49c7a$var$_Widget2.default, $461dc01f80e49c7a$var$_extends({}, elementProps, {
            onBlur: this.handleBlur,
            onFocus: this.handleFocus,
            onKeyDown: this.handleKeyDown,
            onKeyPress: this.handleKeyPress,
            disabled: (0, $cQuVG.isDisabled)(this.props),
            readOnly: (0, $cQuVG.isReadOnly)(this.props),
            role: "radiogroup",
            "aria-busy": !!busy,
            className: (0, $461dc01f80e49c7a$var$_classnames2.default)(className, "rw-selectlist", busy && "rw-loading-mask")
        }), $461dc01f80e49c7a$var$_react2.default.createElement(List, $461dc01f80e49c7a$var$_extends({}, listProps, {
            ref: "list",
            role: "radiogroup",
            tabIndex: tabIndex || "0",
            id: (0, $9yNJk.instanceId)(this, "_listbox"),
            data: items,
            focused: focusedItem,
            optionComponent: ListItem,
            itemComponent: this.props.itemComponent,
            onMove: this._scrollTo
        })));
    },
    _scrollTo: function _scrollTo(selected, list) {
        var handler = this.props.onMove;
        if (handler) handler(selected, list);
        else {
            this._scrollCancel && this._scrollCancel();
            // default behavior is to scroll the whole page not just the widget
            this._scrollCancel = (0, $461dc01f80e49c7a$var$_scrollTo3.default)(selected);
        }
    },
    handleKeyDown: function handleKeyDown(e) {
        var _this = this;
        var key = e.key, _props2 = this.props, valueField = _props2.valueField, multiple = _props2.multiple, list = this.refs.list, focusedItem = this.state.focusedItem;
        var change = function change(item) {
            if (item) _this.handleChange(item, multiple ? !(0, $cQuVG.contains)(item, _this._values(), valueField) // toggle value
             : true);
        };
        (0, $9yNJk.notify)(this.props.onKeyDown, [
            e
        ]);
        if (e.defaultPrevented) return;
        if (key === "End") {
            e.preventDefault();
            focusedItem = list.last();
            this.setState({
                focusedItem: focusedItem
            });
            if (!multiple) change(focusedItem);
        } else if (key === "Home") {
            e.preventDefault();
            focusedItem = list.first();
            this.setState({
                focusedItem: focusedItem
            });
            if (!multiple) change(focusedItem);
        } else if (key === "Enter" || key === " ") {
            e.preventDefault();
            change(focusedItem);
        } else if (key === "ArrowDown" || key === "ArrowRight") {
            e.preventDefault();
            focusedItem = list.next(focusedItem);
            this.setState({
                focusedItem: focusedItem
            });
            if (!multiple) change(focusedItem);
        } else if (key === "ArrowUp" || key === "ArrowLeft") {
            e.preventDefault();
            focusedItem = list.prev(focusedItem);
            this.setState({
                focusedItem: focusedItem
            });
            if (!multiple) change(focusedItem);
        } else if (multiple && e.keyCode === 65 && e.ctrlKey) {
            e.preventDefault();
            this.selectAll();
        }
    },
    handleKeyPress: function handleKeyPress(e) {
        (0, $9yNJk.notify)(this.props.onKeyPress, [
            e
        ]);
        if (e.defaultPrevented) return;
        this.search(String.fromCharCode(e.which));
    },
    focus: function focus() {
        $461dc01f80e49c7a$var$_compat2.default.findDOMNode(this.refs.list).focus();
    },
    selectAll: function selectAll() {
        var _this2 = this;
        var _props3 = this.props, disabled = _props3.disabled, readOnly = _props3.readOnly, valueField = _props3.valueField, values = this.state.dataItems, data = this._data(), blacklist;
        disabled = disabled || readOnly;
        disabled = Array.isArray(disabled) ? disabled : [];
        //disabled values that are not selected
        blacklist = disabled.filter(function(v) {
            return !(0, $cQuVG.contains)(v, values, valueField);
        });
        data = data.filter(function(v) {
            return !(0, $cQuVG.contains)(v, blacklist, valueField);
        });
        if (data.length === values.length) {
            data = disabled.filter(function(item) {
                return (0, $cQuVG.contains)(item, values, valueField);
            });
            data = data.map(function(item) {
                return (0, $3gVwc.dataItem)(_this2._data(), item, valueField);
            });
        }
        (0, $9yNJk.notify)(this.props.onChange, [
            data
        ]);
    },
    handleChange: function handleChange(item, checked) {
        var multiple = this.props.multiple, values = this.state.dataItems;
        multiple = !!multiple;
        this.clearTimeout("focusedItem");
        this.setState({
            focusedItem: item
        });
        if (!multiple) return (0, $9yNJk.notify)(this.props.onChange, checked ? item : null);
        values = checked ? values.concat(item) : values.filter(function(v) {
            return v !== item;
        });
        (0, $9yNJk.notify)(this.props.onChange, [
            values || []
        ]);
    },
    search: function search(character) {
        var _this3 = this;
        var word = ((this._searchTerm || "") + character).toLowerCase(), list = this.refs.list, multiple = this.props.multiple;
        if (!character) return;
        this._searchTerm = word;
        this.setTimeout("search", function() {
            var focusedItem = list.next(_this3.state.focusedItem, word);
            _this3._searchTerm = "";
            if (focusedItem) !multiple ? _this3.handleChange(focusedItem, true) : _this3.setState({
                focusedItem: focusedItem
            });
        }, this.props.delay);
    },
    _data: function _data() {
        return this.props.data;
    },
    _values: function _values() {
        return this.props.multiple ? this.state.dataItems : this.props.value;
    }
}, $461dc01f80e49c7a$var$_applyDecoratedDescriptor($461dc01f80e49c7a$var$_obj, "handleKeyDown", [
    $cQuVG.widgetEditable
], Object.getOwnPropertyDescriptor($461dc01f80e49c7a$var$_obj, "handleKeyDown"), $461dc01f80e49c7a$var$_obj), $461dc01f80e49c7a$var$_applyDecoratedDescriptor($461dc01f80e49c7a$var$_obj, "handleKeyPress", [
    $cQuVG.widgetEditable
], Object.getOwnPropertyDescriptor($461dc01f80e49c7a$var$_obj, "handleKeyPress"), $461dc01f80e49c7a$var$_obj), $461dc01f80e49c7a$var$_obj));
function $461dc01f80e49c7a$var$getListItem(parent) {
    return (0, $461dc01f80e49c7a$var$_createReactClass2.default)({
        displayName: "SelectItem",
        handleChange: function handleChange(e) {
            var _props4 = this.props, disabled = _props4.disabled, readonly = _props4.readonly, dataItem = _props4.dataItem;
            if (!disabled && !readonly) parent.handleChange(dataItem, e.target.checked);
        },
        handleMouseDown: function handleMouseDown() {
            parent._clicking = true;
        },
        render: function render() {
            var _props5 = this.props, children = _props5.children, disabled = _props5.disabled, readonly = _props5.readonly, item = _props5.dataItem;
            var _parent$props = parent.props, multiple = _parent$props.multiple, _parent$props$name = _parent$props.name, name = _parent$props$name === undefined ? (0, $9yNJk.instanceId)(parent, "_name") : _parent$props$name;
            var checked = (0, $cQuVG.contains)(item, parent._values(), parent.props.valueField), type = multiple ? "checkbox" : "radio";
            return $461dc01f80e49c7a$var$_react2.default.createElement($461dc01f80e49c7a$var$_ListOption2.default, $461dc01f80e49c7a$var$_extends({}, this.props, {
                role: type,
                "aria-checked": !!checked
            }), $461dc01f80e49c7a$var$_react2.default.createElement("label", {
                onMouseDown: this.handleMouseDown
            }, $461dc01f80e49c7a$var$_react2.default.createElement("input", {
                name: name,
                type: type,
                tabIndex: "-1",
                role: "presentation",
                checked: checked,
                disabled: disabled || readonly,
                onChange: this.handleChange
            }), children));
        }
    });
}
module.exports.default = (0, $461dc01f80e49c7a$var$_uncontrollable2.default)($461dc01f80e49c7a$var$SelectList, {
    value: "onChange"
}, [
    "selectAll",
    "focus"
]);
module.exports = module.exports["default"];

});


parcelRegister("8oaA5", function(module, exports) {

$parcel$export(module.exports, "ParseDate", function () { return $61b8c5c5c168dc60$export$b00030cc143c3fde; });


var $3arU6 = parcelRequire("3arU6");

var $fJ4T4 = parcelRequire("fJ4T4");

var $4hBm1 = parcelRequire("4hBm1");

var $aBC3c = parcelRequire("aBC3c");

var $1BTI2 = parcelRequire("1BTI2");

var $aTUKb = parcelRequire("aTUKb");
const $61b8c5c5c168dc60$var$knownDate = new Date(2015, 10, 30);
const $61b8c5c5c168dc60$var$knownFormat = ()=>(0, $fJ4T4.FormatDate)($61b8c5c5c168dc60$var$knownDate, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
    });
const $61b8c5c5c168dc60$var$knownYearFormat = ()=>(0, $fJ4T4.FormatDate)($61b8c5c5c168dc60$var$knownDate, {
        year: "numeric"
    });
const $61b8c5c5c168dc60$var$knownMonthFormat = ()=>(0, $fJ4T4.FormatDate)($61b8c5c5c168dc60$var$knownDate, {
        month: "2-digit"
    });
const $61b8c5c5c168dc60$var$knownDayFormat = ()=>(0, $fJ4T4.FormatDate)($61b8c5c5c168dc60$var$knownDate, {
        day: "2-digit"
    });
const $61b8c5c5c168dc60$var$knownFormatWithoutNumbers = ()=>$61b8c5c5c168dc60$var$knownFormat().replace($61b8c5c5c168dc60$var$knownYearFormat(), "#").replace($61b8c5c5c168dc60$var$knownMonthFormat(), "#").replace($61b8c5c5c168dc60$var$knownDayFormat(), "#");
const $61b8c5c5c168dc60$var$defaultSeparator = ()=>$61b8c5c5c168dc60$var$knownFormatWithoutNumbers().split("#")[1];
const $61b8c5c5c168dc60$var$defaultFormat = ()=>$61b8c5c5c168dc60$var$knownFormat().replace($61b8c5c5c168dc60$var$knownYearFormat(), "yyyy").replace($61b8c5c5c168dc60$var$knownMonthFormat(), "MM").replace($61b8c5c5c168dc60$var$knownDayFormat(), "dd");
const $61b8c5c5c168dc60$var$supportedSeparators = ()=>{
    const seps = [
        "/",
        ".",
        "-",
        " ",
        ". ",
        ",",
        ", ",
        ". ."
    ];
    if (!seps.includes($61b8c5c5c168dc60$var$defaultSeparator())) seps.unshift($61b8c5c5c168dc60$var$defaultSeparator());
    return seps;
};
const $61b8c5c5c168dc60$var$supportedYears = [
    "yyyy",
    "yy"
];
const $61b8c5c5c168dc60$var$supportedMonths = [
    "MM",
    "M",
    "MMM",
    "MMMM"
];
const $61b8c5c5c168dc60$var$supportedDays = [
    "dd",
    "d"
];
// all combinations of defaultFormat replacing year, month, day, and separators with supported formats
const $61b8c5c5c168dc60$var$supportedFormats = ()=>$61b8c5c5c168dc60$var$supportedYears.flatMap((year)=>{
        return $61b8c5c5c168dc60$var$supportedMonths.flatMap((month)=>{
            return $61b8c5c5c168dc60$var$supportedDays.flatMap((day)=>{
                return $61b8c5c5c168dc60$var$supportedSeparators().map((separator)=>{
                    return $61b8c5c5c168dc60$var$defaultFormat().replace("yyyy", year).replace("MM", month).replace("dd", day).replaceAll($61b8c5c5c168dc60$var$defaultSeparator(), separator);
                });
            });
        });
    });
const $61b8c5c5c168dc60$export$b00030cc143c3fde = (valueString)=>{
    if (!valueString) return null;
    // Get all supported separators for checking trailing characters
    const allSeparators = $61b8c5c5c168dc60$var$supportedSeparators();
    // Pre-process valueString to handle formats with trailing separators
    let valueToProcess = valueString.trim();
    // Check if string ends with any of the supported separators
    let trimmed = false;
    for (const separator of allSeparators)if (separator.trim() && valueToProcess.endsWith(separator.trim())) {
        valueToProcess = valueToProcess.slice(0, -separator.trim().length).trim();
        trimmed = true;
        break;
    }
    const localeString = (0, (/*@__PURE__*/$parcel$interopDefault($3arU6))).findCountryLocales((0, $aTUKb.constantCase)(((0, $1BTI2.default) === null || (0, $1BTI2.default) === void 0 ? void 0 : (0, $1BTI2.default).organisationCountry) || "us"))[0];
    const localeLang = localeString.split("-")[0];
    const localeCountry = localeString.split("-")[1];
    const locale = $aBC3c[localeLang + localeCountry] || $aBC3c[localeLang];
    // Try with both original and processed value
    const valuesToTry = [
        valueString
    ];
    if (trimmed) valuesToTry.push(valueToProcess);
    for (const value of valuesToTry)for (let formatString of $61b8c5c5c168dc60$var$supportedFormats()){
        const params = [
            value,
            formatString,
            new Date()
        ];
        if (locale) params.push({
            locale: locale
        });
        const date = (0, $4hBm1.parse)(...params);
        if (!isNaN(date) && date.getFullYear() > 1900) return date;
    }
    return null;
};

});
parcelRegister("aBC3c", function(module, exports) {
"use strict";

var $75fJY = parcelRequire("75fJY");
Object.keys($75fJY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $75fJY[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $75fJY[key];
        }
    });
});

var $iB1EY = parcelRequire("iB1EY");
Object.keys($iB1EY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iB1EY[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iB1EY[key];
        }
    });
});

var $c9j4W = parcelRequire("c9j4W");
Object.keys($c9j4W).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $c9j4W[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $c9j4W[key];
        }
    });
});

var $gUJT0 = parcelRequire("gUJT0");
Object.keys($gUJT0).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gUJT0[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gUJT0[key];
        }
    });
});

var $hrEJZ = parcelRequire("hrEJZ");
Object.keys($hrEJZ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hrEJZ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hrEJZ[key];
        }
    });
});

var $dGc5a = parcelRequire("dGc5a");
Object.keys($dGc5a).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dGc5a[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dGc5a[key];
        }
    });
});

var $5Z0sO = parcelRequire("5Z0sO");
Object.keys($5Z0sO).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5Z0sO[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5Z0sO[key];
        }
    });
});

var $k4c9Z = parcelRequire("k4c9Z");
Object.keys($k4c9Z).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $k4c9Z[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $k4c9Z[key];
        }
    });
});

var $6pIwp = parcelRequire("6pIwp");
Object.keys($6pIwp).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6pIwp[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6pIwp[key];
        }
    });
});

var $45Kkz = parcelRequire("45Kkz");
Object.keys($45Kkz).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $45Kkz[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $45Kkz[key];
        }
    });
});

var $1UmQw = parcelRequire("1UmQw");
Object.keys($1UmQw).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1UmQw[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1UmQw[key];
        }
    });
});

var $7P3UA = parcelRequire("7P3UA");
Object.keys($7P3UA).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7P3UA[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7P3UA[key];
        }
    });
});

var $eiUuc = parcelRequire("eiUuc");
Object.keys($eiUuc).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eiUuc[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eiUuc[key];
        }
    });
});

var $50In8 = parcelRequire("50In8");
Object.keys($50In8).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $50In8[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $50In8[key];
        }
    });
});

var $8YT4X = parcelRequire("8YT4X");
Object.keys($8YT4X).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8YT4X[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8YT4X[key];
        }
    });
});

var $blQNa = parcelRequire("blQNa");
Object.keys($blQNa).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $blQNa[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $blQNa[key];
        }
    });
});

var $i1bz1 = parcelRequire("i1bz1");
Object.keys($i1bz1).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $i1bz1[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $i1bz1[key];
        }
    });
});

var $dLzgU = parcelRequire("dLzgU");
Object.keys($dLzgU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dLzgU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dLzgU[key];
        }
    });
});

var $krzq3 = parcelRequire("krzq3");
Object.keys($krzq3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $krzq3[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $krzq3[key];
        }
    });
});

var $1EeVN = parcelRequire("1EeVN");
Object.keys($1EeVN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1EeVN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1EeVN[key];
        }
    });
});

var $8o3oF = parcelRequire("8o3oF");
Object.keys($8o3oF).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8o3oF[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8o3oF[key];
        }
    });
});

var $96hKD = parcelRequire("96hKD");
Object.keys($96hKD).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $96hKD[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $96hKD[key];
        }
    });
});

var $lxYKU = parcelRequire("lxYKU");
Object.keys($lxYKU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lxYKU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lxYKU[key];
        }
    });
});

var $flpZ5 = parcelRequire("flpZ5");
Object.keys($flpZ5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $flpZ5[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $flpZ5[key];
        }
    });
});

var $LxiZ6 = parcelRequire("LxiZ6");
Object.keys($LxiZ6).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $LxiZ6[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $LxiZ6[key];
        }
    });
});

var $kwR0A = parcelRequire("kwR0A");
Object.keys($kwR0A).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kwR0A[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kwR0A[key];
        }
    });
});

var $3ucwE = parcelRequire("3ucwE");
Object.keys($3ucwE).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3ucwE[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3ucwE[key];
        }
    });
});

var $kRuMi = parcelRequire("kRuMi");
Object.keys($kRuMi).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kRuMi[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kRuMi[key];
        }
    });
});

var $b72Sc = parcelRequire("b72Sc");
Object.keys($b72Sc).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $b72Sc[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b72Sc[key];
        }
    });
});

var $9O0sC = parcelRequire("9O0sC");
Object.keys($9O0sC).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9O0sC[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9O0sC[key];
        }
    });
});

var $hRHn5 = parcelRequire("hRHn5");
Object.keys($hRHn5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hRHn5[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hRHn5[key];
        }
    });
});

var $iTJJk = parcelRequire("iTJJk");
Object.keys($iTJJk).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iTJJk[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iTJJk[key];
        }
    });
});

var $aGtfR = parcelRequire("aGtfR");
Object.keys($aGtfR).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aGtfR[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aGtfR[key];
        }
    });
});

var $drQoH = parcelRequire("drQoH");
Object.keys($drQoH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $drQoH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $drQoH[key];
        }
    });
});

var $8XSC8 = parcelRequire("8XSC8");
Object.keys($8XSC8).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8XSC8[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8XSC8[key];
        }
    });
});

var $fdZui = parcelRequire("fdZui");
Object.keys($fdZui).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fdZui[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fdZui[key];
        }
    });
});

var $aQH0S = parcelRequire("aQH0S");
Object.keys($aQH0S).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aQH0S[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aQH0S[key];
        }
    });
});

var $4smXQ = parcelRequire("4smXQ");
Object.keys($4smXQ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4smXQ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4smXQ[key];
        }
    });
});

var $47ObL = parcelRequire("47ObL");
Object.keys($47ObL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $47ObL[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $47ObL[key];
        }
    });
});

var $fKqaE = parcelRequire("fKqaE");
Object.keys($fKqaE).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fKqaE[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fKqaE[key];
        }
    });
});

var $ba3un = parcelRequire("ba3un");
Object.keys($ba3un).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ba3un[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ba3un[key];
        }
    });
});

var $7YFiI = parcelRequire("7YFiI");
Object.keys($7YFiI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7YFiI[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7YFiI[key];
        }
    });
});

var $17UrZ = parcelRequire("17UrZ");
Object.keys($17UrZ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $17UrZ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $17UrZ[key];
        }
    });
});

var $3uK0z = parcelRequire("3uK0z");
Object.keys($3uK0z).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3uK0z[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3uK0z[key];
        }
    });
});

var $ebKVG = parcelRequire("ebKVG");
Object.keys($ebKVG).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ebKVG[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ebKVG[key];
        }
    });
});

var $1TdKR = parcelRequire("1TdKR");
Object.keys($1TdKR).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1TdKR[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1TdKR[key];
        }
    });
});

var $2bmSz = parcelRequire("2bmSz");
Object.keys($2bmSz).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2bmSz[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2bmSz[key];
        }
    });
});

var $kg90j = parcelRequire("kg90j");
Object.keys($kg90j).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kg90j[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kg90j[key];
        }
    });
});

var $hjGsR = parcelRequire("hjGsR");
Object.keys($hjGsR).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hjGsR[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hjGsR[key];
        }
    });
});

var $awu3F = parcelRequire("awu3F");
Object.keys($awu3F).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $awu3F[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $awu3F[key];
        }
    });
});

var $6aJlu = parcelRequire("6aJlu");
Object.keys($6aJlu).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6aJlu[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6aJlu[key];
        }
    });
});

var $ivRxc = parcelRequire("ivRxc");
Object.keys($ivRxc).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ivRxc[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ivRxc[key];
        }
    });
});

var $fkxck = parcelRequire("fkxck");
Object.keys($fkxck).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fkxck[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fkxck[key];
        }
    });
});

var $4Fbjg = parcelRequire("4Fbjg");
Object.keys($4Fbjg).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4Fbjg[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4Fbjg[key];
        }
    });
});

var $jCNiJ = parcelRequire("jCNiJ");
Object.keys($jCNiJ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jCNiJ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jCNiJ[key];
        }
    });
});

var $jVdzN = parcelRequire("jVdzN");
Object.keys($jVdzN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jVdzN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jVdzN[key];
        }
    });
});

var $cJ91V = parcelRequire("cJ91V");
Object.keys($cJ91V).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cJ91V[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cJ91V[key];
        }
    });
});

var $7mIvA = parcelRequire("7mIvA");
Object.keys($7mIvA).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7mIvA[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7mIvA[key];
        }
    });
});

var $68KUH = parcelRequire("68KUH");
Object.keys($68KUH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $68KUH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $68KUH[key];
        }
    });
});

var $1kI6g = parcelRequire("1kI6g");
Object.keys($1kI6g).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1kI6g[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1kI6g[key];
        }
    });
});

var $5JNRl = parcelRequire("5JNRl");
Object.keys($5JNRl).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5JNRl[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5JNRl[key];
        }
    });
});

var $6rRIb = parcelRequire("6rRIb");
Object.keys($6rRIb).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6rRIb[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6rRIb[key];
        }
    });
});

var $lXx8J = parcelRequire("lXx8J");
Object.keys($lXx8J).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lXx8J[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lXx8J[key];
        }
    });
});

var $3Y3po = parcelRequire("3Y3po");
Object.keys($3Y3po).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3Y3po[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3Y3po[key];
        }
    });
});

var $jBftv = parcelRequire("jBftv");
Object.keys($jBftv).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jBftv[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jBftv[key];
        }
    });
});

var $f1vsR = parcelRequire("f1vsR");
Object.keys($f1vsR).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $f1vsR[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $f1vsR[key];
        }
    });
});

var $jEuu3 = parcelRequire("jEuu3");
Object.keys($jEuu3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jEuu3[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jEuu3[key];
        }
    });
});

var $d7rm6 = parcelRequire("d7rm6");
Object.keys($d7rm6).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $d7rm6[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d7rm6[key];
        }
    });
});

var $1ewID = parcelRequire("1ewID");
Object.keys($1ewID).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1ewID[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1ewID[key];
        }
    });
});

var $jWADl = parcelRequire("jWADl");
Object.keys($jWADl).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jWADl[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jWADl[key];
        }
    });
});

var $dVW0I = parcelRequire("dVW0I");
Object.keys($dVW0I).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dVW0I[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dVW0I[key];
        }
    });
});

var $5dgYM = parcelRequire("5dgYM");
Object.keys($5dgYM).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5dgYM[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5dgYM[key];
        }
    });
});

var $7dlru = parcelRequire("7dlru");
Object.keys($7dlru).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7dlru[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7dlru[key];
        }
    });
});

var $d6ZAI = parcelRequire("d6ZAI");
Object.keys($d6ZAI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $d6ZAI[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d6ZAI[key];
        }
    });
});

var $8aBN0 = parcelRequire("8aBN0");
Object.keys($8aBN0).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8aBN0[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8aBN0[key];
        }
    });
});

var $jHr4l = parcelRequire("jHr4l");
Object.keys($jHr4l).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jHr4l[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jHr4l[key];
        }
    });
});

var $2Ry8i = parcelRequire("2Ry8i");
Object.keys($2Ry8i).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2Ry8i[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2Ry8i[key];
        }
    });
});

var $iw4hM = parcelRequire("iw4hM");
Object.keys($iw4hM).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iw4hM[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iw4hM[key];
        }
    });
});

var $8ZuGh = parcelRequire("8ZuGh");
Object.keys($8ZuGh).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8ZuGh[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8ZuGh[key];
        }
    });
});

var $34wYM = parcelRequire("34wYM");
Object.keys($34wYM).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $34wYM[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $34wYM[key];
        }
    });
});

var $ggfYx = parcelRequire("ggfYx");
Object.keys($ggfYx).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ggfYx[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ggfYx[key];
        }
    });
});

var $iSx94 = parcelRequire("iSx94");
Object.keys($iSx94).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iSx94[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iSx94[key];
        }
    });
});

var $2WcFN = parcelRequire("2WcFN");
Object.keys($2WcFN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2WcFN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2WcFN[key];
        }
    });
});

var $flEHO = parcelRequire("flEHO");
Object.keys($flEHO).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $flEHO[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $flEHO[key];
        }
    });
});

var $2geFg = parcelRequire("2geFg");
Object.keys($2geFg).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2geFg[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2geFg[key];
        }
    });
});

var $lHi3Y = parcelRequire("lHi3Y");
Object.keys($lHi3Y).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lHi3Y[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lHi3Y[key];
        }
    });
});

var $9m9Hc = parcelRequire("9m9Hc");
Object.keys($9m9Hc).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9m9Hc[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9m9Hc[key];
        }
    });
});

var $3QtxD = parcelRequire("3QtxD");
Object.keys($3QtxD).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3QtxD[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3QtxD[key];
        }
    });
});

var $3zsoC = parcelRequire("3zsoC");
Object.keys($3zsoC).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3zsoC[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3zsoC[key];
        }
    });
});

var $8bQsB = parcelRequire("8bQsB");
Object.keys($8bQsB).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8bQsB[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8bQsB[key];
        }
    });
});

var $g4E2d = parcelRequire("g4E2d");
Object.keys($g4E2d).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $g4E2d[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $g4E2d[key];
        }
    });
});

var $bZSlM = parcelRequire("bZSlM");
Object.keys($bZSlM).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bZSlM[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bZSlM[key];
        }
    });
});

var $fd6CF = parcelRequire("fd6CF");
Object.keys($fd6CF).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fd6CF[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fd6CF[key];
        }
    });
});

var $3G5Zh = parcelRequire("3G5Zh");
Object.keys($3G5Zh).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3G5Zh[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3G5Zh[key];
        }
    });
});

var $cMffX = parcelRequire("cMffX");
Object.keys($cMffX).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cMffX[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cMffX[key];
        }
    });
});

});
parcelRegister("75fJY", function(module, exports) {

$parcel$export(module.exports, "af", function () { return $528535c1793e5288$export$c9170ad7d4cd7e57; }, function (v) { return $528535c1793e5288$export$c9170ad7d4cd7e57 = v; });
var $528535c1793e5288$export$c9170ad7d4cd7e57;
"use strict";
$528535c1793e5288$export$c9170ad7d4cd7e57 = void 0;

var $kzZ3K = parcelRequire("kzZ3K");

var $7we1l = parcelRequire("7we1l");

var $iODjo = parcelRequire("iODjo");

var $8VW9T = parcelRequire("8VW9T");

var $kBgyD = parcelRequire("kBgyD");
/**
 * @category Locales
 * @summary Afrikaans locale.
 * @language Afrikaans
 * @iso-639-2 afr
 * @author Marnus Weststrate [@marnusw](https://github.com/marnusw)
 */ const $528535c1793e5288$var$af = $528535c1793e5288$export$c9170ad7d4cd7e57 = {
    code: "af",
    formatDistance: $kzZ3K.formatDistance,
    formatLong: $7we1l.formatLong,
    formatRelative: $iODjo.formatRelative,
    localize: $8VW9T.localize,
    match: $kBgyD.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("kzZ3K", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $efb670abcc52add6$export$2c14ff85d6318973; }, function (v) { return $efb670abcc52add6$export$2c14ff85d6318973 = v; });
var $efb670abcc52add6$export$2c14ff85d6318973;
"use strict";
$efb670abcc52add6$export$2c14ff85d6318973 = void 0;
const $efb670abcc52add6$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minder as 'n sekonde",
        other: "minder as {{count}} sekondes"
    },
    xSeconds: {
        one: "1 sekonde",
        other: "{{count}} sekondes"
    },
    halfAMinute: "'n halwe minuut",
    lessThanXMinutes: {
        one: "minder as 'n minuut",
        other: "minder as {{count}} minute"
    },
    xMinutes: {
        one: "'n minuut",
        other: "{{count}} minute"
    },
    aboutXHours: {
        one: "ongeveer 1 uur",
        other: "ongeveer {{count}} ure"
    },
    xHours: {
        one: "1 uur",
        other: "{{count}} ure"
    },
    xDays: {
        one: "1 dag",
        other: "{{count}} dae"
    },
    aboutXWeeks: {
        one: "ongeveer 1 week",
        other: "ongeveer {{count}} weke"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weke"
    },
    aboutXMonths: {
        one: "ongeveer 1 maand",
        other: "ongeveer {{count}} maande"
    },
    xMonths: {
        one: "1 maand",
        other: "{{count}} maande"
    },
    aboutXYears: {
        one: "ongeveer 1 jaar",
        other: "ongeveer {{count}} jaar"
    },
    xYears: {
        one: "1 jaar",
        other: "{{count}} jaar"
    },
    overXYears: {
        one: "meer as 1 jaar",
        other: "meer as {{count}} jaar"
    },
    almostXYears: {
        one: "byna 1 jaar",
        other: "byna {{count}} jaar"
    }
};
const $efb670abcc52add6$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $efb670abcc52add6$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "oor " + result;
        else return result + " gelede";
    }
    return result;
};
$efb670abcc52add6$export$2c14ff85d6318973 = $efb670abcc52add6$var$formatDistance;

});

parcelRegister("7we1l", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $579665c46f406e7d$export$cbf60ecb96cbb82f; }, function (v) { return $579665c46f406e7d$export$cbf60ecb96cbb82f = v; });
var $579665c46f406e7d$export$cbf60ecb96cbb82f;
"use strict";
$579665c46f406e7d$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $579665c46f406e7d$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "yyyy/MM/dd"
};
const $579665c46f406e7d$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $579665c46f406e7d$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $579665c46f406e7d$var$formatLong = $579665c46f406e7d$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $579665c46f406e7d$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $579665c46f406e7d$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $579665c46f406e7d$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("iODjo", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $db2b6404baca855f$export$8fbbfd65594f46a0; }, function (v) { return $db2b6404baca855f$export$8fbbfd65594f46a0 = v; });
var $db2b6404baca855f$export$8fbbfd65594f46a0;
"use strict";
$db2b6404baca855f$export$8fbbfd65594f46a0 = void 0;
const $db2b6404baca855f$var$formatRelativeLocale = {
    lastWeek: "'verlede' eeee 'om' p",
    yesterday: "'gister om' p",
    today: "'vandag om' p",
    tomorrow: "'m\xf4re om' p",
    nextWeek: "eeee 'om' p",
    other: "P"
};
const $db2b6404baca855f$var$formatRelative = (token, _date, _baseDate, _options)=>$db2b6404baca855f$var$formatRelativeLocale[token];
$db2b6404baca855f$export$8fbbfd65594f46a0 = $db2b6404baca855f$var$formatRelative;

});

parcelRegister("8VW9T", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $6810c2aa4e5fb897$export$b3bd0bc58e36cd63; }, function (v) { return $6810c2aa4e5fb897$export$b3bd0bc58e36cd63 = v; });
var $6810c2aa4e5fb897$export$b3bd0bc58e36cd63;
"use strict";
$6810c2aa4e5fb897$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $6810c2aa4e5fb897$var$eraValues = {
    narrow: [
        "vC",
        "nC"
    ],
    abbreviated: [
        "vC",
        "nC"
    ],
    wide: [
        "voor Christus",
        "na Christus"
    ]
};
const $6810c2aa4e5fb897$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1ste kwartaal",
        "2de kwartaal",
        "3de kwartaal",
        "4de kwartaal"
    ]
};
const $6810c2aa4e5fb897$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mrt",
        "Apr",
        "Mei",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Des"
    ],
    wide: [
        "Januarie",
        "Februarie",
        "Maart",
        "April",
        "Mei",
        "Junie",
        "Julie",
        "Augustus",
        "September",
        "Oktober",
        "November",
        "Desember"
    ]
};
const $6810c2aa4e5fb897$var$dayValues = {
    narrow: [
        "S",
        "M",
        "D",
        "W",
        "D",
        "V",
        "S"
    ],
    short: [
        "So",
        "Ma",
        "Di",
        "Wo",
        "Do",
        "Vr",
        "Sa"
    ],
    abbreviated: [
        "Son",
        "Maa",
        "Din",
        "Woe",
        "Don",
        "Vry",
        "Sat"
    ],
    wide: [
        "Sondag",
        "Maandag",
        "Dinsdag",
        "Woensdag",
        "Donderdag",
        "Vrydag",
        "Saterdag"
    ]
};
const $6810c2aa4e5fb897$var$dayPeriodValues = {
    narrow: {
        am: "vm",
        pm: "nm",
        midnight: "middernag",
        noon: "middaguur",
        morning: "oggend",
        afternoon: "middag",
        evening: "laat middag",
        night: "aand"
    },
    abbreviated: {
        am: "vm",
        pm: "nm",
        midnight: "middernag",
        noon: "middaguur",
        morning: "oggend",
        afternoon: "middag",
        evening: "laat middag",
        night: "aand"
    },
    wide: {
        am: "vm",
        pm: "nm",
        midnight: "middernag",
        noon: "middaguur",
        morning: "oggend",
        afternoon: "middag",
        evening: "laat middag",
        night: "aand"
    }
};
const $6810c2aa4e5fb897$var$formattingDayPeriodValues = {
    narrow: {
        am: "vm",
        pm: "nm",
        midnight: "middernag",
        noon: "uur die middag",
        morning: "uur die oggend",
        afternoon: "uur die middag",
        evening: "uur die aand",
        night: "uur die aand"
    },
    abbreviated: {
        am: "vm",
        pm: "nm",
        midnight: "middernag",
        noon: "uur die middag",
        morning: "uur die oggend",
        afternoon: "uur die middag",
        evening: "uur die aand",
        night: "uur die aand"
    },
    wide: {
        am: "vm",
        pm: "nm",
        midnight: "middernag",
        noon: "uur die middag",
        morning: "uur die oggend",
        afternoon: "uur die middag",
        evening: "uur die aand",
        night: "uur die aand"
    }
};
const $6810c2aa4e5fb897$var$ordinalNumber = (dirtyNumber)=>{
    const number = Number(dirtyNumber);
    const rem100 = number % 100;
    if (rem100 < 20) switch(rem100){
        case 1:
        case 8:
            return number + "ste";
        default:
            return number + "de";
    }
    return number + "ste";
};
const $6810c2aa4e5fb897$var$localize = $6810c2aa4e5fb897$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $6810c2aa4e5fb897$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $6810c2aa4e5fb897$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $6810c2aa4e5fb897$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $6810c2aa4e5fb897$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $6810c2aa4e5fb897$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $6810c2aa4e5fb897$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $6810c2aa4e5fb897$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("kBgyD", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $eff41b5c63ee8146$export$4659b591c19bdf3d; }, function (v) { return $eff41b5c63ee8146$export$4659b591c19bdf3d = v; });
var $eff41b5c63ee8146$export$4659b591c19bdf3d;
"use strict";
$eff41b5c63ee8146$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $eff41b5c63ee8146$var$matchOrdinalNumberPattern = /^(\d+)(ste|de)?/i;
const $eff41b5c63ee8146$var$parseOrdinalNumberPattern = /\d+/i;
const $eff41b5c63ee8146$var$matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?C\.?)/,
    wide: /^((voor|na) Christus)/
};
const $eff41b5c63ee8146$var$parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
const $eff41b5c63ee8146$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234](st|d)e kwartaal/i
};
const $eff41b5c63ee8146$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $eff41b5c63ee8146$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(Jan|Feb|Mrt|Apr|Mei|Jun|Jul|Aug|Sep|Okt|Nov|Dec)\.?/i,
    wide: /^(Januarie|Februarie|Maart|April|Mei|Junie|Julie|Augustus|September|Oktober|November|Desember)/i
};
const $eff41b5c63ee8146$var$parseMonthPatterns = {
    narrow: [
        /^J/i,
        /^F/i,
        /^M/i,
        /^A/i,
        /^M/i,
        /^J/i,
        /^J/i,
        /^A/i,
        /^S/i,
        /^O/i,
        /^N/i,
        /^D/i
    ],
    any: [
        /^Jan/i,
        /^Feb/i,
        /^Mrt/i,
        /^Apr/i,
        /^Mei/i,
        /^Jun/i,
        /^Jul/i,
        /^Aug/i,
        /^Sep/i,
        /^Okt/i,
        /^Nov/i,
        /^Dec/i
    ]
};
const $eff41b5c63ee8146$var$matchDayPatterns = {
    narrow: /^[smdwv]/i,
    short: /^(So|Ma|Di|Wo|Do|Vr|Sa)/i,
    abbreviated: /^(Son|Maa|Din|Woe|Don|Vry|Sat)/i,
    wide: /^(Sondag|Maandag|Dinsdag|Woensdag|Donderdag|Vrydag|Saterdag)/i
};
const $eff41b5c63ee8146$var$parseDayPatterns = {
    narrow: [
        /^S/i,
        /^M/i,
        /^D/i,
        /^W/i,
        /^D/i,
        /^V/i,
        /^S/i
    ],
    any: [
        /^So/i,
        /^Ma/i,
        /^Di/i,
        /^Wo/i,
        /^Do/i,
        /^Vr/i,
        /^Sa/i
    ]
};
const $eff41b5c63ee8146$var$matchDayPeriodPatterns = {
    any: /^(vm|nm|middernag|(?:uur )?die (oggend|middag|aand))/i
};
const $eff41b5c63ee8146$var$parseDayPeriodPatterns = {
    any: {
        am: /^vm/i,
        pm: /^nm/i,
        midnight: /^middernag/i,
        noon: /^middaguur/i,
        morning: /oggend/i,
        afternoon: /middag/i,
        evening: /laat middag/i,
        night: /aand/i
    }
};
const $eff41b5c63ee8146$var$match = $eff41b5c63ee8146$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $eff41b5c63ee8146$var$matchOrdinalNumberPattern,
        parsePattern: $eff41b5c63ee8146$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $eff41b5c63ee8146$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $eff41b5c63ee8146$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $eff41b5c63ee8146$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $eff41b5c63ee8146$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $eff41b5c63ee8146$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $eff41b5c63ee8146$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $eff41b5c63ee8146$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $eff41b5c63ee8146$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $eff41b5c63ee8146$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $eff41b5c63ee8146$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("iB1EY", function(module, exports) {

$parcel$export(module.exports, "ar", function () { return $d89cf84ccee14698$export$d24c54395ce0c509; }, function (v) { return $d89cf84ccee14698$export$d24c54395ce0c509 = v; });
var $d89cf84ccee14698$export$d24c54395ce0c509;
"use strict";
$d89cf84ccee14698$export$d24c54395ce0c509 = void 0;

var $ll6cU = parcelRequire("ll6cU");

var $fva9U = parcelRequire("fva9U");

var $iAA9Q = parcelRequire("iAA9Q");

var $bLToD = parcelRequire("bLToD");

var $bvuBo = parcelRequire("bvuBo");
/**
 * @category Locales
 * @summary Arabic locale (Modern Standard Arabic - Al-fussha).
 * @language Modern Standard Arabic
 * @iso-639-2 ara
 * @author Abdallah Hassan [@AbdallahAHO](https://github.com/AbdallahAHO)
 * @author Koussay Haj Kacem [@essana3](https://github.com/essana3)
 */ const $d89cf84ccee14698$var$ar = $d89cf84ccee14698$export$d24c54395ce0c509 = {
    code: "ar",
    formatDistance: $ll6cU.formatDistance,
    formatLong: $fva9U.formatLong,
    formatRelative: $iAA9Q.formatRelative,
    localize: $bLToD.localize,
    match: $bvuBo.match,
    options: {
        weekStartsOn: 6 /* Saturday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("ll6cU", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $f8905fc0896c7e09$export$2c14ff85d6318973; }, function (v) { return $f8905fc0896c7e09$export$2c14ff85d6318973 = v; });
var $f8905fc0896c7e09$export$2c14ff85d6318973;
"use strict";
$f8905fc0896c7e09$export$2c14ff85d6318973 = void 0;
const $f8905fc0896c7e09$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u064A\u062A\u0627\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u0627\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u0627\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u0627\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639\u0627 \u062A\u0642\u0631\u064A\u0628\u0627"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u0627\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639\u0627"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627",
        other: "{{count}} \u0634\u0647\u0631\u0627 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u0627\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631\u0627"
    },
    aboutXYears: {
        one: "\u0633\u0646\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0646\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0633\u0646\u0648\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0646\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0633\u0646\u0629 \u0648\u0627\u062D\u062F",
        two: "\u0633\u0646\u062A\u0627\u0646",
        threeToTen: "{{count}} \u0633\u0646\u0648\u0627\u062A",
        other: "{{count}} \u0633\u0646\u0629"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u0629",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u0648\u0627\u062A",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u0629"
    },
    almostXYears: {
        one: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 \u0633\u0646\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 {{count}} \u0633\u0646\u0648\u0627\u062A",
        other: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 {{count}} \u0633\u0646\u0629"
    }
};
const $f8905fc0896c7e09$var$formatDistance = (token, count, options)=>{
    const usageGroup = $f8905fc0896c7e09$var$formatDistanceLocale[token];
    let result;
    if (typeof usageGroup === "string") result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace("{{count}}", String(count));
    else result = usageGroup.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
$f8905fc0896c7e09$export$2c14ff85d6318973 = $f8905fc0896c7e09$var$formatDistance;

});

parcelRegister("fva9U", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $b491a195a1ebb766$export$cbf60ecb96cbb82f; }, function (v) { return $b491a195a1ebb766$export$cbf60ecb96cbb82f = v; });
var $b491a195a1ebb766$export$cbf60ecb96cbb82f;
"use strict";
$b491a195a1ebb766$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $b491a195a1ebb766$var$dateFormats = {
    full: "EEEE\u060C do MMMM y",
    long: "do MMMM y",
    medium: "d MMM y",
    short: "dd/MM/yyyy"
};
const $b491a195a1ebb766$var$timeFormats = {
    full: "HH:mm:ss",
    long: "HH:mm:ss",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $b491a195a1ebb766$var$dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $b491a195a1ebb766$var$formatLong = $b491a195a1ebb766$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $b491a195a1ebb766$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $b491a195a1ebb766$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $b491a195a1ebb766$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("iAA9Q", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $d887a2fd8a080d6b$export$8fbbfd65594f46a0; }, function (v) { return $d887a2fd8a080d6b$export$8fbbfd65594f46a0 = v; });
var $d887a2fd8a080d6b$export$8fbbfd65594f46a0;
"use strict";
$d887a2fd8a080d6b$export$8fbbfd65594f46a0 = void 0;
const $d887a2fd8a080d6b$var$formatRelativeLocale = {
    lastWeek: "eeee '\u0627\u0644\u0645\u0627\u0636\u064A \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    yesterday: "'\u0627\u0644\u0623\u0645\u0633 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    tomorrow: "'\u063A\u062F\u0627 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    nextWeek: "eeee '\u0627\u0644\u0642\u0627\u062F\u0645 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    other: "P"
};
const $d887a2fd8a080d6b$var$formatRelative = (token)=>$d887a2fd8a080d6b$var$formatRelativeLocale[token];
$d887a2fd8a080d6b$export$8fbbfd65594f46a0 = $d887a2fd8a080d6b$var$formatRelative;

});

parcelRegister("bLToD", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $891f0e122007941c$export$b3bd0bc58e36cd63; }, function (v) { return $891f0e122007941c$export$b3bd0bc58e36cd63 = v; });
var $891f0e122007941c$export$b3bd0bc58e36cd63;
"use strict";
$891f0e122007941c$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $891f0e122007941c$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
const $891f0e122007941c$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
const $891f0e122007941c$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
const $891f0e122007941c$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
const $891f0e122007941c$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    }
};
const $891f0e122007941c$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    }
};
const $891f0e122007941c$var$ordinalNumber = (num)=>String(num);
const $891f0e122007941c$var$localize = $891f0e122007941c$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $891f0e122007941c$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $891f0e122007941c$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $891f0e122007941c$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $891f0e122007941c$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $891f0e122007941c$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $891f0e122007941c$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $891f0e122007941c$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("bvuBo", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $860a53ec386e5292$export$4659b591c19bdf3d; }, function (v) { return $860a53ec386e5292$export$4659b591c19bdf3d = v; });
var $860a53ec386e5292$export$4659b591c19bdf3d;
"use strict";
$860a53ec386e5292$export$4659b591c19bdf3d = void 0;

var $8RZeP = parcelRequire("8RZeP");

var $kQYK9 = parcelRequire("kQYK9");
const $860a53ec386e5292$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $860a53ec386e5292$var$parseOrdinalNumberPattern = /\d+/i;
const $860a53ec386e5292$var$matchEraPatterns = {
    narrow: /[قب]/,
    abbreviated: /[قب]\.م\./,
    wide: /(قبل|بعد) الميلاد/
};
const $860a53ec386e5292$var$parseEraPatterns = {
    any: [
        /قبل/,
        /بعد/
    ]
};
const $860a53ec386e5292$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /ر[1234]/,
    wide: /الربع (الأول|الثاني|الثالث|الرابع)/
};
const $860a53ec386e5292$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $860a53ec386e5292$var$matchMonthPatterns = {
    narrow: /^[أيفمسند]/,
    abbreviated: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
    wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
const $860a53ec386e5292$var$parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ي/i,
        /^ي/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^يناير/i,
        /^فبراير/i,
        /^مارس/i,
        /^أبريل/i,
        /^مايو/i,
        /^يونيو/i,
        /^يوليو/i,
        /^أغسطس/i,
        /^سبتمبر/i,
        /^أكتوبر/i,
        /^نوفمبر/i,
        /^ديسمبر/i
    ]
};
const $860a53ec386e5292$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
const $860a53ec386e5292$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
const $860a53ec386e5292$var$matchDayPeriodPatterns = {
    narrow: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/,
    any: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/
};
const $860a53ec386e5292$var$parseDayPeriodPatterns = {
    any: {
        am: /^ص/,
        pm: /^م/,
        midnight: /منتصف الليل/,
        noon: /الظهر/,
        afternoon: /بعد الظهر/,
        morning: /في الصباح/,
        evening: /في المساء/,
        night: /في الليل/
    }
};
const $860a53ec386e5292$var$match = $860a53ec386e5292$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $860a53ec386e5292$var$matchOrdinalNumberPattern,
        parsePattern: $860a53ec386e5292$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $860a53ec386e5292$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $860a53ec386e5292$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $860a53ec386e5292$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $860a53ec386e5292$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $860a53ec386e5292$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $860a53ec386e5292$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $860a53ec386e5292$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $860a53ec386e5292$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $860a53ec386e5292$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $860a53ec386e5292$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("c9j4W", function(module, exports) {

$parcel$export(module.exports, "arDZ", function () { return $8d851ff2398ea245$export$f30a46e7176f7a; }, function (v) { return $8d851ff2398ea245$export$f30a46e7176f7a = v; });
var $8d851ff2398ea245$export$f30a46e7176f7a;
"use strict";
$8d851ff2398ea245$export$f30a46e7176f7a = void 0;

var $2ursK = parcelRequire("2ursK");

var $hGWxu = parcelRequire("hGWxu");

var $jh6nr = parcelRequire("jh6nr");

var $6PCMt = parcelRequire("6PCMt");

var $cCTkf = parcelRequire("cCTkf");
/**
 * @category Locales
 * @summary Arabic locale (Algerian Arabic).
 * @language Algerian Arabic
 * @iso-639-2 ara
 * @author Badreddine Boumaza [@badre429](https://github.com/badre429)
 * @author Ahmed ElShahat [@elshahat](https://github.com/elshahat)
 */ const $8d851ff2398ea245$var$arDZ = $8d851ff2398ea245$export$f30a46e7176f7a = {
    code: "ar-DZ",
    formatDistance: $2ursK.formatDistance,
    formatLong: $hGWxu.formatLong,
    formatRelative: $jh6nr.formatRelative,
    localize: $6PCMt.localize,
    match: $cCTkf.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("2ursK", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $1d03af9b0e0b4721$export$2c14ff85d6318973; }, function (v) { return $1d03af9b0e0b4721$export$2c14ff85d6318973 = v; });
var $1d03af9b0e0b4721$export$2c14ff85d6318973;
"use strict";
$1d03af9b0e0b4721$export$2c14ff85d6318973 = void 0;
const $1d03af9b0e0b4721$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    }
};
const $1d03af9b0e0b4721$var$formatDistance = (token, count, options)=>{
    options = options || {};
    const usageGroup = $1d03af9b0e0b4721$var$formatDistanceLocale[token];
    let result;
    if (typeof usageGroup === "string") result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace("{{count}}", String(count));
    else result = usageGroup.other.replace("{{count}}", String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
$1d03af9b0e0b4721$export$2c14ff85d6318973 = $1d03af9b0e0b4721$var$formatDistance;

});

parcelRegister("hGWxu", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $ce13c4926b3ef67d$export$cbf60ecb96cbb82f; }, function (v) { return $ce13c4926b3ef67d$export$cbf60ecb96cbb82f = v; });
var $ce13c4926b3ef67d$export$cbf60ecb96cbb82f;
"use strict";
$ce13c4926b3ef67d$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $ce13c4926b3ef67d$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $ce13c4926b3ef67d$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $ce13c4926b3ef67d$var$dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $ce13c4926b3ef67d$var$formatLong = $ce13c4926b3ef67d$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $ce13c4926b3ef67d$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $ce13c4926b3ef67d$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $ce13c4926b3ef67d$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("jh6nr", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $e0848d3918883fb0$export$8fbbfd65594f46a0; }, function (v) { return $e0848d3918883fb0$export$8fbbfd65594f46a0 = v; });
var $e0848d3918883fb0$export$8fbbfd65594f46a0;
"use strict";
$e0848d3918883fb0$export$8fbbfd65594f46a0 = void 0;
const $e0848d3918883fb0$var$formatRelativeLocale = {
    lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
    yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
    tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
    nextWeek: "eeee '\u0639\u0646\u062F' p",
    other: "P"
};
const $e0848d3918883fb0$var$formatRelative = (token, _date, _baseDate, _options)=>{
    return $e0848d3918883fb0$var$formatRelativeLocale[token];
};
$e0848d3918883fb0$export$8fbbfd65594f46a0 = $e0848d3918883fb0$var$formatRelative;

});

parcelRegister("6PCMt", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $4f95968ed2414809$export$b3bd0bc58e36cd63; }, function (v) { return $4f95968ed2414809$export$b3bd0bc58e36cd63 = v; });
var $4f95968ed2414809$export$b3bd0bc58e36cd63;
"use strict";
$4f95968ed2414809$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $4f95968ed2414809$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
const $4f95968ed2414809$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
const $4f95968ed2414809$var$monthValues = {
    narrow: [
        "\u062C",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u062C",
        "\u062C",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u062C\u0627\u0646\u0640",
        "\u0641\u064A\u0641\u0640",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0640",
        "\u062C\u0648\u0627\u0646\u0640",
        "\u062C\u0648\u064A\u0640",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0641\u0640",
        "\u062F\u064A\u0633\u0640"
    ],
    wide: [
        "\u062C\u0627\u0646\u0641\u064A",
        "\u0641\u064A\u0641\u0631\u064A",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u062C\u0648\u0627\u0646",
        "\u062C\u0648\u064A\u0644\u064A\u0629",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
const $4f95968ed2414809$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u0640",
        "\u062B\u0644\u0627",
        "\u0623\u0631\u0628\u0640",
        "\u062E\u0645\u064A\u0640",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
const $4f95968ed2414809$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
const $4f95968ed2414809$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
const $4f95968ed2414809$var$ordinalNumber = (dirtyNumber)=>{
    return String(dirtyNumber);
};
const $4f95968ed2414809$var$localize = $4f95968ed2414809$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $4f95968ed2414809$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $4f95968ed2414809$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $4f95968ed2414809$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>Number(quarter) - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $4f95968ed2414809$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $4f95968ed2414809$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $4f95968ed2414809$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $4f95968ed2414809$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("cCTkf", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $9313f32518aa1c56$export$4659b591c19bdf3d; }, function (v) { return $9313f32518aa1c56$export$4659b591c19bdf3d = v; });
var $9313f32518aa1c56$export$4659b591c19bdf3d;
"use strict";
$9313f32518aa1c56$export$4659b591c19bdf3d = void 0;

var $8RZeP = parcelRequire("8RZeP");

var $kQYK9 = parcelRequire("kQYK9");
const $9313f32518aa1c56$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $9313f32518aa1c56$var$parseOrdinalNumberPattern = /\d+/i;
const $9313f32518aa1c56$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
    wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
const $9313f32518aa1c56$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
const $9313f32518aa1c56$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ر[1234]/i,
    wide: /^الربع [1234]/i
};
const $9313f32518aa1c56$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $9313f32518aa1c56$var$matchMonthPatterns = {
    narrow: /^[جفمأسند]/i,
    abbreviated: /^(جان|فيف|مار|أفر|ماي|جوا|جوي|أوت|سبت|أكت|نوف|ديس)/i,
    wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/i
};
const $9313f32518aa1c56$var$parseMonthPatterns = {
    narrow: [
        /^ج/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ج/i,
        /^ج/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^جان/i,
        /^فيف/i,
        /^مار/i,
        /^أفر/i,
        /^ماي/i,
        /^جوا/i,
        /^جوي/i,
        /^أوت/i,
        /^سبت/i,
        /^أكت/i,
        /^نوف/i,
        /^ديس/i
    ]
};
const $9313f32518aa1c56$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
const $9313f32518aa1c56$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
const $9313f32518aa1c56$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $9313f32518aa1c56$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $9313f32518aa1c56$var$match = $9313f32518aa1c56$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $9313f32518aa1c56$var$matchOrdinalNumberPattern,
        parsePattern: $9313f32518aa1c56$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $9313f32518aa1c56$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9313f32518aa1c56$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $9313f32518aa1c56$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9313f32518aa1c56$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>Number(index) + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $9313f32518aa1c56$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9313f32518aa1c56$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $9313f32518aa1c56$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9313f32518aa1c56$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $9313f32518aa1c56$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $9313f32518aa1c56$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("gUJT0", function(module, exports) {

$parcel$export(module.exports, "arEG", function () { return $c5057858519aff83$export$121716977511c975; }, function (v) { return $c5057858519aff83$export$121716977511c975 = v; });
var $c5057858519aff83$export$121716977511c975;
"use strict";
$c5057858519aff83$export$121716977511c975 = void 0;

var $jjCTQ = parcelRequire("jjCTQ");

var $ehMk3 = parcelRequire("ehMk3");

var $crYMH = parcelRequire("crYMH");

var $7aRm9 = parcelRequire("7aRm9");

var $cWDOt = parcelRequire("cWDOt");
/**
 * @category Locales
 * @summary Arabic locale (Egypt).
 * @language Arabic
 * @iso-639-2 ara
 * @author AbdAllah AbdElFattah [@AbdAllahAbdElFattah13](https://github.com/AbdAllahAbdElFattah13)
 */ const $c5057858519aff83$var$arEG = $c5057858519aff83$export$121716977511c975 = {
    code: "ar-EG",
    formatDistance: $jjCTQ.formatDistance,
    formatLong: $ehMk3.formatLong,
    formatRelative: $crYMH.formatRelative,
    localize: $7aRm9.localize,
    match: $cWDOt.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("jjCTQ", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $e0fdf75b24853540$export$2c14ff85d6318973; }, function (v) { return $e0fdf75b24853540$export$2c14ff85d6318973 = v; });
var $e0fdf75b24853540$export$2c14ff85d6318973;
"use strict";
$e0fdf75b24853540$export$2c14ff85d6318973 = void 0;
const $e0fdf75b24853540$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629",
        two: "\u062B\u0627\u0646\u064A\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0633\u0627\u0639\u0629",
        two: "\u062D\u0648\u0627\u0644\u064A \u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0627\u0639\u0629"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0623\u0633\u0628\u0648\u0639",
        two: "\u062D\u0648\u0627\u0644\u064A \u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0634\u0647\u0631",
        two: "\u062D\u0648\u0627\u0644\u064A \u0634\u0647\u0631\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0623\u0634\u0647\u0631",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0634\u0647\u0631"
    },
    xMonths: {
        one: "\u0634\u0647\u0631",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0633\u0646\u0629",
        two: "\u062D\u0648\u0627\u0644\u064A \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0646\u064A\u0646",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0646\u0629"
    },
    xYears: {
        one: "\u0639\u0627\u0645",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u0629",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u064A\u0646",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u0629"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u064B\u0627",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u064B\u0627",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u064B\u0627",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u064B\u0627"
    }
};
const $e0fdf75b24853540$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $e0fdf75b24853540$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2) result = tokenValue.two;
    else if (count <= 10) result = tokenValue.threeToTen.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return `\u{641}\u{64A} \u{62E}\u{644}\u{627}\u{644} ${result}`;
        else return `\u{645}\u{646}\u{630} ${result}`;
    }
    return result;
};
$e0fdf75b24853540$export$2c14ff85d6318973 = $e0fdf75b24853540$var$formatDistance;

});

parcelRegister("ehMk3", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $a668230d232883dd$export$cbf60ecb96cbb82f; }, function (v) { return $a668230d232883dd$export$cbf60ecb96cbb82f = v; });
var $a668230d232883dd$export$cbf60ecb96cbb82f;
"use strict";
$a668230d232883dd$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $a668230d232883dd$var$dateFormats = {
    full: "EEEE\u060C do MMMM y",
    long: "do MMMM y",
    medium: "dd/MMM/y",
    short: "d/MM/y"
};
const $a668230d232883dd$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $a668230d232883dd$var$dateTimeFormats = {
    full: "{{date}} '\u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    long: "{{date}} '\u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $a668230d232883dd$var$formatLong = $a668230d232883dd$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $a668230d232883dd$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $a668230d232883dd$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $a668230d232883dd$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("crYMH", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $9107282b249fc123$export$8fbbfd65594f46a0; }, function (v) { return $9107282b249fc123$export$8fbbfd65594f46a0 = v; });
var $9107282b249fc123$export$8fbbfd65594f46a0;
"use strict";
$9107282b249fc123$export$8fbbfd65594f46a0 = void 0;
const $9107282b249fc123$var$formatRelativeLocale = {
    lastWeek: "eeee '\u0627\u0644\u0644\u064A \u062C\u0627\u064A \u0627\u0644\u0633\u0627\u0639\u0629' p",
    yesterday: "'\u0625\u0645\u0628\u0627\u0631\u062D \u0627\u0644\u0633\u0627\u0639\u0629' p",
    today: "'\u0627\u0644\u0646\u0647\u0627\u0631\u062F\u0629 \u0627\u0644\u0633\u0627\u0639\u0629' p",
    tomorrow: "'\u0628\u0643\u0631\u0629 \u0627\u0644\u0633\u0627\u0639\u0629' p",
    nextWeek: "eeee '\u0627\u0644\u0633\u0627\u0639\u0629' p",
    other: "P"
};
const $9107282b249fc123$var$formatRelative = (token, _date, _baseDate, _options)=>$9107282b249fc123$var$formatRelativeLocale[token];
$9107282b249fc123$export$8fbbfd65594f46a0 = $9107282b249fc123$var$formatRelative;

});

parcelRegister("7aRm9", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $5392daffa865a1f1$export$b3bd0bc58e36cd63; }, function (v) { return $5392daffa865a1f1$export$b3bd0bc58e36cd63 = v; });
var $5392daffa865a1f1$export$b3bd0bc58e36cd63;
"use strict";
$5392daffa865a1f1$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $5392daffa865a1f1$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645",
        "\u0628.\u0645"
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
const $5392daffa865a1f1$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
const $5392daffa865a1f1$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627",
        "\u0641\u0628\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u0640",
        "\u064A\u0648\u0644\u0640",
        "\u0623\u063A\u0633\u0640",
        "\u0633\u0628\u062A\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0641\u0640",
        "\u062F\u064A\u0633\u0640"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
const $5392daffa865a1f1$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
const $5392daffa865a1f1$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
const $5392daffa865a1f1$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
const $5392daffa865a1f1$var$ordinalNumber = (dirtyNumber, _options)=>{
    return String(dirtyNumber);
};
const $5392daffa865a1f1$var$localize = $5392daffa865a1f1$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $5392daffa865a1f1$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $5392daffa865a1f1$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $5392daffa865a1f1$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $5392daffa865a1f1$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $5392daffa865a1f1$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $5392daffa865a1f1$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $5392daffa865a1f1$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("cWDOt", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $96c9c8d9d69b9920$export$4659b591c19bdf3d; }, function (v) { return $96c9c8d9d69b9920$export$4659b591c19bdf3d = v; });
var $96c9c8d9d69b9920$export$4659b591c19bdf3d;
"use strict";
$96c9c8d9d69b9920$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $96c9c8d9d69b9920$var$matchOrdinalNumberPattern = /^(\d+)/;
const $96c9c8d9d69b9920$var$parseOrdinalNumberPattern = /\d+/i;
const $96c9c8d9d69b9920$var$matchEraPatterns = {
    narrow: /^(ق|ب)/g,
    abbreviated: /^(ق.م|ب.م)/g,
    wide: /^(قبل الميلاد|بعد الميلاد)/g
};
const $96c9c8d9d69b9920$var$parseEraPatterns = {
    any: [
        /^ق/g,
        /^ب/g
    ]
};
const $96c9c8d9d69b9920$var$matchQuarterPatterns = {
    narrow: /^[1234]/,
    abbreviated: /^ر[1234]/,
    wide: /^الربع (الأول|الثاني|الثالث|الرابع)/
};
const $96c9c8d9d69b9920$var$parseQuarterPatterns = {
    wide: [
        /الربع الأول/,
        /الربع الثاني/,
        /الربع الثالث/,
        /الربع الرابع/
    ],
    any: [
        /1/,
        /2/,
        /3/,
        /4/
    ]
};
const $96c9c8d9d69b9920$var$matchMonthPatterns = {
    narrow: /^(ي|ف|م|أ|س|ن|د)/,
    abbreviated: /^(ينا|فبر|مارس|أبريل|مايو|يونـ|يولـ|أغسـ|سبتـ|أكتـ|نوفـ|ديسـ)/,
    wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
const $96c9c8d9d69b9920$var$parseMonthPatterns = {
    narrow: [
        /^ي/,
        /^ف/,
        /^م/,
        /^أ/,
        /^م/,
        /^ي/,
        /^ي/,
        /^أ/,
        /^س/,
        /^أ/,
        /^ن/,
        /^د/
    ],
    any: [
        /^ينا/,
        /^فبر/,
        /^مارس/,
        /^أبريل/,
        /^مايو/,
        /^يون/,
        /^يول/,
        /^أغس/,
        /^سبت/,
        /^أكت/,
        /^نوف/,
        /^ديس/
    ]
};
const $96c9c8d9d69b9920$var$matchDayPatterns = {
    narrow: /^(ح|ن|ث|ر|خ|ج|س)/,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
    abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/
};
const $96c9c8d9d69b9920$var$parseDayPatterns = {
    narrow: [
        /^ح/,
        /^ن/,
        /^ث/,
        /^ر/,
        /^خ/,
        /^ج/,
        /^س/
    ],
    any: [
        /أحد/,
        /اثنين/,
        /ثلاثاء/,
        /أربعاء/,
        /خميس/,
        /جمعة/,
        /سبت/
    ]
};
const $96c9c8d9d69b9920$var$matchDayPeriodPatterns = {
    narrow: /^(ص|م|ن|ظ|في الصباح|بعد الظهر|في المساء|في الليل)/,
    abbreviated: /^(ص|م|نصف الليل|ظهراً|في الصباح|بعد الظهر|في المساء|في الليل)/,
    wide: /^(ص|م|نصف الليل|في الصباح|ظهراً|بعد الظهر|في المساء|في الليل)/,
    any: /^(ص|م|صباح|ظهر|مساء|ليل)/
};
const $96c9c8d9d69b9920$var$parseDayPeriodPatterns = {
    any: {
        am: /^ص/,
        pm: /^م/,
        midnight: /^ن/,
        noon: /^ظ/,
        morning: /^ص/,
        afternoon: /^بعد/,
        evening: /^م/,
        night: /^ل/
    }
};
const $96c9c8d9d69b9920$var$match = $96c9c8d9d69b9920$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $96c9c8d9d69b9920$var$matchOrdinalNumberPattern,
        parsePattern: $96c9c8d9d69b9920$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $96c9c8d9d69b9920$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $96c9c8d9d69b9920$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $96c9c8d9d69b9920$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $96c9c8d9d69b9920$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $96c9c8d9d69b9920$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $96c9c8d9d69b9920$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $96c9c8d9d69b9920$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $96c9c8d9d69b9920$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $96c9c8d9d69b9920$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $96c9c8d9d69b9920$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("hrEJZ", function(module, exports) {

$parcel$export(module.exports, "arMA", function () { return $cb348f93d2565f74$export$6cd16787de86607; }, function (v) { return $cb348f93d2565f74$export$6cd16787de86607 = v; });
var $cb348f93d2565f74$export$6cd16787de86607;
"use strict";
$cb348f93d2565f74$export$6cd16787de86607 = void 0;

var $6tOza = parcelRequire("6tOza");

var $bwMHb = parcelRequire("bwMHb");

var $hkRuC = parcelRequire("hkRuC");

var $dvlpO = parcelRequire("dvlpO");

var $8fr4W = parcelRequire("8fr4W");
/**
 * @category Locales
 * @summary Arabic locale (Moroccan Arabic).
 * @language Moroccan Arabic
 * @iso-639-2 ara
 * @author Achraf Rrami [@rramiachraf](https://github.com/rramiachraf)
 */ const $cb348f93d2565f74$var$arMA = $cb348f93d2565f74$export$6cd16787de86607 = {
    code: "ar-MA",
    formatDistance: $6tOza.formatDistance,
    formatLong: $bwMHb.formatLong,
    formatRelative: $hkRuC.formatRelative,
    localize: $dvlpO.localize,
    match: $8fr4W.match,
    options: {
        // Monday is 1
        weekStartsOn: 1,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("6tOza", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $4b7cace3ae52aa9b$export$2c14ff85d6318973; }, function (v) { return $4b7cace3ae52aa9b$export$2c14ff85d6318973 = v; });
var $4b7cace3ae52aa9b$export$2c14ff85d6318973;
"use strict";
$4b7cace3ae52aa9b$export$2c14ff85d6318973 = void 0;
const $4b7cace3ae52aa9b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    }
};
const $4b7cace3ae52aa9b$var$formatDistance = (token, count, options)=>{
    options = options || {};
    const usageGroup = $4b7cace3ae52aa9b$var$formatDistanceLocale[token];
    let result;
    if (typeof usageGroup === "string") result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace("{{count}}", String(count));
    else result = usageGroup.other.replace("{{count}}", String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
$4b7cace3ae52aa9b$export$2c14ff85d6318973 = $4b7cace3ae52aa9b$var$formatDistance;

});

parcelRegister("bwMHb", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $864874cd37c76040$export$cbf60ecb96cbb82f; }, function (v) { return $864874cd37c76040$export$cbf60ecb96cbb82f = v; });
var $864874cd37c76040$export$cbf60ecb96cbb82f;
"use strict";
$864874cd37c76040$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $864874cd37c76040$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $864874cd37c76040$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $864874cd37c76040$var$dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $864874cd37c76040$var$formatLong = $864874cd37c76040$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $864874cd37c76040$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $864874cd37c76040$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $864874cd37c76040$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("hkRuC", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $c9edcc8208d26481$export$8fbbfd65594f46a0; }, function (v) { return $c9edcc8208d26481$export$8fbbfd65594f46a0 = v; });
var $c9edcc8208d26481$export$8fbbfd65594f46a0;
"use strict";
$c9edcc8208d26481$export$8fbbfd65594f46a0 = void 0;
const $c9edcc8208d26481$var$formatRelativeLocale = {
    lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
    yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
    tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
    nextWeek: "eeee '\u0639\u0646\u062F' p",
    other: "P"
};
const $c9edcc8208d26481$var$formatRelative = (token, _date, _baseDate, _options)=>{
    return $c9edcc8208d26481$var$formatRelativeLocale[token];
};
$c9edcc8208d26481$export$8fbbfd65594f46a0 = $c9edcc8208d26481$var$formatRelative;

});

parcelRegister("dvlpO", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $9d4ec83da4e7de6d$export$b3bd0bc58e36cd63; }, function (v) { return $9d4ec83da4e7de6d$export$b3bd0bc58e36cd63 = v; });
var $9d4ec83da4e7de6d$export$b3bd0bc58e36cd63;
"use strict";
$9d4ec83da4e7de6d$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $9d4ec83da4e7de6d$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
const $9d4ec83da4e7de6d$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
const $9d4ec83da4e7de6d$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u063A",
        "\u0634",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627",
        "\u0641\u0628\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u064A\u0648\u0646\u0640",
        "\u064A\u0648\u0644\u0640",
        "\u063A\u0634\u062A",
        "\u0634\u062A\u0646\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0646\u0640",
        "\u062F\u062C\u0646\u0640"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648\u0632",
        "\u063A\u0634\u062A",
        "\u0634\u062A\u0646\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0646\u0628\u0631",
        "\u062F\u062C\u0646\u0628\u0631"
    ]
};
const $9d4ec83da4e7de6d$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u0640",
        "\u062B\u0644\u0627",
        "\u0623\u0631\u0628\u0640",
        "\u062E\u0645\u064A\u0640",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0625\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
const $9d4ec83da4e7de6d$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
const $9d4ec83da4e7de6d$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
const $9d4ec83da4e7de6d$var$ordinalNumber = (dirtyNumber)=>{
    return String(dirtyNumber);
};
const $9d4ec83da4e7de6d$var$localize = $9d4ec83da4e7de6d$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $9d4ec83da4e7de6d$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $9d4ec83da4e7de6d$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $9d4ec83da4e7de6d$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>Number(quarter) - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $9d4ec83da4e7de6d$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $9d4ec83da4e7de6d$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $9d4ec83da4e7de6d$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $9d4ec83da4e7de6d$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("8fr4W", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $6014bab6edc25f14$export$4659b591c19bdf3d; }, function (v) { return $6014bab6edc25f14$export$4659b591c19bdf3d = v; });
var $6014bab6edc25f14$export$4659b591c19bdf3d;
"use strict";
$6014bab6edc25f14$export$4659b591c19bdf3d = void 0;

var $8RZeP = parcelRequire("8RZeP");

var $kQYK9 = parcelRequire("kQYK9");
const $6014bab6edc25f14$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $6014bab6edc25f14$var$parseOrdinalNumberPattern = /\d+/i;
const $6014bab6edc25f14$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
    wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
const $6014bab6edc25f14$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
const $6014bab6edc25f14$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ر[1234]/i,
    wide: /^الربع [1234]/i
};
const $6014bab6edc25f14$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $6014bab6edc25f14$var$matchMonthPatterns = {
    narrow: /^[يفمأمسند]/i,
    abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i,
    wide: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i
};
const $6014bab6edc25f14$var$parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ي/i,
        /^ي/i,
        /^غ/i,
        /^ش/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^ين/i,
        /^فب/i,
        /^مار/i,
        /^أب/i,
        /^ماي/i,
        /^يون/i,
        /^يول/i,
        /^غشت/i,
        /^ش/i,
        /^أك/i,
        /^ن/i,
        /^د/i
    ]
};
const $6014bab6edc25f14$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|إثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|إثن|ثلا|أرب|خمي|جمعة|سبت)/i,
    wide: /^(الأحد|الإثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
const $6014bab6edc25f14$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الإثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^إث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
const $6014bab6edc25f14$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $6014bab6edc25f14$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $6014bab6edc25f14$var$match = $6014bab6edc25f14$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $6014bab6edc25f14$var$matchOrdinalNumberPattern,
        parsePattern: $6014bab6edc25f14$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $6014bab6edc25f14$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6014bab6edc25f14$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $6014bab6edc25f14$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6014bab6edc25f14$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>Number(index) + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $6014bab6edc25f14$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6014bab6edc25f14$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $6014bab6edc25f14$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6014bab6edc25f14$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $6014bab6edc25f14$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $6014bab6edc25f14$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("dGc5a", function(module, exports) {

$parcel$export(module.exports, "arSA", function () { return $9f5891e2d51bbf33$export$f6f6c9668e179f08; }, function (v) { return $9f5891e2d51bbf33$export$f6f6c9668e179f08 = v; });
var $9f5891e2d51bbf33$export$f6f6c9668e179f08;
"use strict";
$9f5891e2d51bbf33$export$f6f6c9668e179f08 = void 0;

var $50221 = parcelRequire("50221");

var $5B39p = parcelRequire("5B39p");

var $9Dv34 = parcelRequire("9Dv34");

var $4elc1 = parcelRequire("4elc1");

var $crj4M = parcelRequire("crj4M");
/**
 * @category Locales
 * @summary Arabic locale (Sauid Arabic).
 * @language Arabic
 * @iso-639-2 ara
 * @author Dhaifallah Alwadani [@dalwadani](https://github.com/dalwadani)
 */ const $9f5891e2d51bbf33$var$arSA = $9f5891e2d51bbf33$export$f6f6c9668e179f08 = {
    code: "ar-SA",
    formatDistance: $50221.formatDistance,
    formatLong: $5B39p.formatLong,
    formatRelative: $9Dv34.formatRelative,
    localize: $4elc1.localize,
    match: $crj4M.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("50221", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $3a3e874355bf7743$export$2c14ff85d6318973; }, function (v) { return $3a3e874355bf7743$export$2c14ff85d6318973 = v; });
var $3a3e874355bf7743$export$2c14ff85d6318973;
"use strict";
$3a3e874355bf7743$export$2c14ff85d6318973 = void 0;
const $3a3e874355bf7743$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    }
};
const $3a3e874355bf7743$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $3a3e874355bf7743$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2) result = tokenValue.two;
    else if (count <= 10) result = tokenValue.threeToTen.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
$3a3e874355bf7743$export$2c14ff85d6318973 = $3a3e874355bf7743$var$formatDistance;

});

parcelRegister("5B39p", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $4132da219f5ede5c$export$cbf60ecb96cbb82f; }, function (v) { return $4132da219f5ede5c$export$cbf60ecb96cbb82f = v; });
var $4132da219f5ede5c$export$cbf60ecb96cbb82f;
"use strict";
$4132da219f5ede5c$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $4132da219f5ede5c$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $4132da219f5ede5c$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $4132da219f5ede5c$var$dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $4132da219f5ede5c$var$formatLong = $4132da219f5ede5c$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $4132da219f5ede5c$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $4132da219f5ede5c$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $4132da219f5ede5c$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("9Dv34", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $703fd7249035a228$export$8fbbfd65594f46a0; }, function (v) { return $703fd7249035a228$export$8fbbfd65594f46a0 = v; });
var $703fd7249035a228$export$8fbbfd65594f46a0;
"use strict";
$703fd7249035a228$export$8fbbfd65594f46a0 = void 0;
const $703fd7249035a228$var$formatRelativeLocale = {
    lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
    yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
    tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
    nextWeek: "eeee '\u0639\u0646\u062F' p",
    other: "P"
};
const $703fd7249035a228$var$formatRelative = (token, _date, _baseDate, _options)=>$703fd7249035a228$var$formatRelativeLocale[token];
$703fd7249035a228$export$8fbbfd65594f46a0 = $703fd7249035a228$var$formatRelative;

});

parcelRegister("4elc1", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $3148e8af3e72d925$export$b3bd0bc58e36cd63; }, function (v) { return $3148e8af3e72d925$export$b3bd0bc58e36cd63 = v; });
var $3148e8af3e72d925$export$b3bd0bc58e36cd63;
"use strict";
$3148e8af3e72d925$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $3148e8af3e72d925$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
const $3148e8af3e72d925$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
const $3148e8af3e72d925$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627",
        "\u0641\u0628\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u0640",
        "\u064A\u0648\u0644\u0640",
        "\u0623\u063A\u0633\u0640",
        "\u0633\u0628\u062A\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0641\u0640",
        "\u062F\u064A\u0633\u0640"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
const $3148e8af3e72d925$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u0640",
        "\u062B\u0644\u0627",
        "\u0623\u0631\u0628\u0640",
        "\u062E\u0645\u064A\u0640",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
const $3148e8af3e72d925$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
const $3148e8af3e72d925$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
const $3148e8af3e72d925$var$ordinalNumber = (dirtyNumber)=>{
    return String(dirtyNumber);
};
const $3148e8af3e72d925$var$localize = $3148e8af3e72d925$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $3148e8af3e72d925$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $3148e8af3e72d925$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $3148e8af3e72d925$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $3148e8af3e72d925$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $3148e8af3e72d925$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $3148e8af3e72d925$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $3148e8af3e72d925$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("crj4M", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $90e6cdbfd3020efc$export$4659b591c19bdf3d; }, function (v) { return $90e6cdbfd3020efc$export$4659b591c19bdf3d = v; });
var $90e6cdbfd3020efc$export$4659b591c19bdf3d;
"use strict";
$90e6cdbfd3020efc$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $90e6cdbfd3020efc$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $90e6cdbfd3020efc$var$parseOrdinalNumberPattern = /\d+/i;
const $90e6cdbfd3020efc$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
    wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
const $90e6cdbfd3020efc$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
const $90e6cdbfd3020efc$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ر[1234]/i,
    wide: /^الربع [1234]/i
};
const $90e6cdbfd3020efc$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $90e6cdbfd3020efc$var$matchMonthPatterns = {
    narrow: /^[يفمأمسند]/i,
    abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i,
    wide: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i
};
const $90e6cdbfd3020efc$var$parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ي/i,
        /^ي/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^ين/i,
        /^ف/i,
        /^مار/i,
        /^أب/i,
        /^ماي/i,
        /^يون/i,
        /^يول/i,
        /^أغ/i,
        /^س/i,
        /^أك/i,
        /^ن/i,
        /^د/i
    ]
};
const $90e6cdbfd3020efc$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
const $90e6cdbfd3020efc$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
const $90e6cdbfd3020efc$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $90e6cdbfd3020efc$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $90e6cdbfd3020efc$var$match = $90e6cdbfd3020efc$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $90e6cdbfd3020efc$var$matchOrdinalNumberPattern,
        parsePattern: $90e6cdbfd3020efc$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $90e6cdbfd3020efc$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $90e6cdbfd3020efc$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $90e6cdbfd3020efc$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $90e6cdbfd3020efc$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $90e6cdbfd3020efc$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $90e6cdbfd3020efc$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $90e6cdbfd3020efc$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $90e6cdbfd3020efc$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $90e6cdbfd3020efc$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $90e6cdbfd3020efc$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("5Z0sO", function(module, exports) {

$parcel$export(module.exports, "arTN", function () { return $45b30254863eb94b$export$79b362f080eb24d6; }, function (v) { return $45b30254863eb94b$export$79b362f080eb24d6 = v; });
var $45b30254863eb94b$export$79b362f080eb24d6;
"use strict";
$45b30254863eb94b$export$79b362f080eb24d6 = void 0;

var $ahMGe = parcelRequire("ahMGe");

var $j1rQA = parcelRequire("j1rQA");

var $aKR0i = parcelRequire("aKR0i");

var $g51cE = parcelRequire("g51cE");

var $9QKPS = parcelRequire("9QKPS");
/**
 * @category Locales
 * @summary Arabic locale (Tunisian Arabic).
 * @language Arabic
 * @iso-639-2 ara
 * @author Koussay Haj Kacem [@essana3](https://github.com/essana3)
 */ const $45b30254863eb94b$var$arTN = $45b30254863eb94b$export$79b362f080eb24d6 = {
    code: "ar-TN",
    formatDistance: $ahMGe.formatDistance,
    formatLong: $j1rQA.formatLong,
    formatRelative: $aKR0i.formatRelative,
    localize: $g51cE.localize,
    match: $9QKPS.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("ahMGe", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $77d140ccf034a3c6$export$2c14ff85d6318973; }, function (v) { return $77d140ccf034a3c6$export$2c14ff85d6318973 = v; });
var $77d140ccf034a3c6$export$2c14ff85d6318973;
"use strict";
$77d140ccf034a3c6$export$2c14ff85d6318973 = void 0;
const $77d140ccf034a3c6$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u0632\u0648\u0632 \u062B\u0648\u0627\u0646\u064A",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629",
        two: "\u0632\u0648\u0632 \u062B\u0648\u0627\u0646\u064A",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0633\u0648\u0627\u064A\u0639 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0648\u0627\u064A\u0639",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u0646\u0647\u0627\u0631",
        two: "\u0646\u0647\u0627\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u062C\u0645\u0639\u0629 \u062A\u0642\u0631\u064A\u0628",
        two: "\u062C\u0645\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u062C\u0645\u0627\u0639 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u062C\u0645\u0639\u0629 \u062A\u0642\u0631\u064A\u0628"
    },
    xWeeks: {
        one: "\u062C\u0645\u0639\u0629",
        two: "\u062C\u0645\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062C\u0645\u0627\u0639",
        other: "{{count}} \u062C\u0645\u0639\u0629"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631\u0629 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628"
    },
    xMonths: {
        one: "\u0634\u0647\u0631",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631\u0629",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628"
    },
    xYears: {
        one: "\u0639\u0627\u0645",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628"
    }
};
const $77d140ccf034a3c6$var$formatDistance = (token, count, options)=>{
    const usageGroup = $77d140ccf034a3c6$var$formatDistanceLocale[token];
    let result;
    if (typeof usageGroup === "string") result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace("{{count}}", String(count));
    else result = usageGroup.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A " + result;
        else return "\u0639\u0646\u062F\u0648 " + result;
    }
    return result;
};
$77d140ccf034a3c6$export$2c14ff85d6318973 = $77d140ccf034a3c6$var$formatDistance;

});

parcelRegister("j1rQA", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $dd93b62e80f728c2$export$cbf60ecb96cbb82f; }, function (v) { return $dd93b62e80f728c2$export$cbf60ecb96cbb82f = v; });
var $dd93b62e80f728c2$export$cbf60ecb96cbb82f;
"use strict";
$dd93b62e80f728c2$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $dd93b62e80f728c2$var$dateFormats = {
    full: "EEEE\u060C do MMMM y",
    long: "do MMMM y",
    medium: "d MMM y",
    short: "dd/MM/yyyy"
};
const $dd93b62e80f728c2$var$timeFormats = {
    full: "HH:mm:ss",
    long: "HH:mm:ss",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $dd93b62e80f728c2$var$dateTimeFormats = {
    full: "{{date}} '\u0645\u0639' {{time}}",
    long: "{{date}} '\u0645\u0639' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $dd93b62e80f728c2$var$formatLong = $dd93b62e80f728c2$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $dd93b62e80f728c2$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $dd93b62e80f728c2$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $dd93b62e80f728c2$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("aKR0i", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $7d4750b9bd926077$export$8fbbfd65594f46a0; }, function (v) { return $7d4750b9bd926077$export$8fbbfd65594f46a0 = v; });
var $7d4750b9bd926077$export$8fbbfd65594f46a0;
"use strict";
$7d4750b9bd926077$export$8fbbfd65594f46a0 = void 0;
const $7d4750b9bd926077$var$formatRelativeLocale = {
    lastWeek: "eeee '\u0625\u0644\u064A \u0641\u0627\u062A \u0645\u0639' p",
    yesterday: "'\u0627\u0644\u0628\u0627\u0631\u062D \u0645\u0639' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0645\u0639' p",
    tomorrow: "'\u063A\u062F\u0648\u0629 \u0645\u0639' p",
    nextWeek: "eeee '\u0627\u0644\u062C\u0645\u0639\u0629 \u0627\u0644\u062C\u0627\u064A\u0629 \u0645\u0639' p '\u0646\u0647\u0627\u0631'",
    other: "P"
};
const $7d4750b9bd926077$var$formatRelative = (token)=>$7d4750b9bd926077$var$formatRelativeLocale[token];
$7d4750b9bd926077$export$8fbbfd65594f46a0 = $7d4750b9bd926077$var$formatRelative;

});

parcelRegister("g51cE", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $bb4e0be4670dbf88$export$b3bd0bc58e36cd63; }, function (v) { return $bb4e0be4670dbf88$export$b3bd0bc58e36cd63 = v; });
var $bb4e0be4670dbf88$export$b3bd0bc58e36cd63;
"use strict";
$bb4e0be4670dbf88$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $bb4e0be4670dbf88$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
const $bb4e0be4670dbf88$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
const $bb4e0be4670dbf88$var$monthValues = {
    narrow: [
        "\u062F",
        "\u0646",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u062C",
        "\u062C",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u0641",
        "\u062C"
    ],
    abbreviated: [
        "\u062C\u0627\u0646\u0641\u064A",
        "\u0641\u064A\u0641\u0631\u064A",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u062C\u0648\u0627\u0646",
        "\u062C\u0648\u064A\u0644\u064A\u0629",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ],
    wide: [
        "\u062C\u0627\u0646\u0641\u064A",
        "\u0641\u064A\u0641\u0631\u064A",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u062C\u0648\u0627\u0646",
        "\u062C\u0648\u064A\u0644\u064A\u0629",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
const $bb4e0be4670dbf88$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
const $bb4e0be4670dbf88$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    }
};
const $bb4e0be4670dbf88$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    }
};
const $bb4e0be4670dbf88$var$ordinalNumber = (num)=>String(num);
const $bb4e0be4670dbf88$var$localize = $bb4e0be4670dbf88$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $bb4e0be4670dbf88$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $bb4e0be4670dbf88$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $bb4e0be4670dbf88$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $bb4e0be4670dbf88$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $bb4e0be4670dbf88$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $bb4e0be4670dbf88$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $bb4e0be4670dbf88$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("9QKPS", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $72bd4cfda844a172$export$4659b591c19bdf3d; }, function (v) { return $72bd4cfda844a172$export$4659b591c19bdf3d = v; });
var $72bd4cfda844a172$export$4659b591c19bdf3d;
"use strict";
$72bd4cfda844a172$export$4659b591c19bdf3d = void 0;

var $8RZeP = parcelRequire("8RZeP");

var $kQYK9 = parcelRequire("kQYK9");
const $72bd4cfda844a172$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $72bd4cfda844a172$var$parseOrdinalNumberPattern = /\d+/i;
const $72bd4cfda844a172$var$matchEraPatterns = {
    narrow: /[قب]/,
    abbreviated: /[قب]\.م\./,
    wide: /(قبل|بعد) الميلاد/
};
const $72bd4cfda844a172$var$parseEraPatterns = {
    any: [
        /قبل/,
        /بعد/
    ]
};
const $72bd4cfda844a172$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /ر[1234]/,
    wide: /الربع (الأول|الثاني|الثالث|الرابع)/
};
const $72bd4cfda844a172$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $72bd4cfda844a172$var$matchMonthPatterns = {
    narrow: /^[جفمأسند]/,
    abbreviated: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
    wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
const $72bd4cfda844a172$var$parseMonthPatterns = {
    narrow: [
        /^ج/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ج/i,
        /^ج/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^جانفي/i,
        /^فيفري/i,
        /^مارس/i,
        /^أفريل/i,
        /^ماي/i,
        /^جوان/i,
        /^جويلية/i,
        /^أوت/i,
        /^سبتمبر/i,
        /^أكتوبر/i,
        /^نوفمبر/i,
        /^ديسمبر/i
    ]
};
const $72bd4cfda844a172$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
const $72bd4cfda844a172$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
const $72bd4cfda844a172$var$matchDayPeriodPatterns = {
    narrow: /^(ص|ع|ن ل|ل|(في|مع) (صباح|قايلة|عشية|ليل))/,
    any: /^([صع]|نص الليل|قايلة|(في|مع) (صباح|قايلة|عشية|ليل))/
};
const $72bd4cfda844a172$var$parseDayPeriodPatterns = {
    any: {
        am: /^ص/,
        pm: /^ع/,
        midnight: /نص الليل/,
        noon: /قايلة/,
        afternoon: /بعد القايلة/,
        morning: /صباح/,
        evening: /عشية/,
        night: /ليل/
    }
};
const $72bd4cfda844a172$var$match = $72bd4cfda844a172$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $72bd4cfda844a172$var$matchOrdinalNumberPattern,
        parsePattern: $72bd4cfda844a172$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $72bd4cfda844a172$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $72bd4cfda844a172$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $72bd4cfda844a172$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $72bd4cfda844a172$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $72bd4cfda844a172$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $72bd4cfda844a172$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $72bd4cfda844a172$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $72bd4cfda844a172$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $72bd4cfda844a172$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $72bd4cfda844a172$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("k4c9Z", function(module, exports) {

$parcel$export(module.exports, "az", function () { return $e9bd9d210138454e$export$3d12bd131bb975d1; }, function (v) { return $e9bd9d210138454e$export$3d12bd131bb975d1 = v; });
var $e9bd9d210138454e$export$3d12bd131bb975d1;
"use strict";
$e9bd9d210138454e$export$3d12bd131bb975d1 = void 0;

var $hq2U6 = parcelRequire("hq2U6");

var $8C5ZS = parcelRequire("8C5ZS");

var $9VsYp = parcelRequire("9VsYp");

var $bEbJ2 = parcelRequire("bEbJ2");

var $c00ye = parcelRequire("c00ye");
/**
 * @category Locales
 * @summary Azerbaijani locale.
 * @language Azerbaijani
 * @iso-639-2 aze
 */ const $e9bd9d210138454e$var$az = $e9bd9d210138454e$export$3d12bd131bb975d1 = {
    code: "az",
    formatDistance: $hq2U6.formatDistance,
    formatLong: $8C5ZS.formatLong,
    formatRelative: $9VsYp.formatRelative,
    localize: $bEbJ2.localize,
    match: $c00ye.match,
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("hq2U6", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $cae71e04010b0b74$export$2c14ff85d6318973; }, function (v) { return $cae71e04010b0b74$export$2c14ff85d6318973 = v; });
var $cae71e04010b0b74$export$2c14ff85d6318973;
"use strict";
$cae71e04010b0b74$export$2c14ff85d6318973 = void 0;
const $cae71e04010b0b74$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "bir saniy\u0259d\u0259n az",
        other: "{{count}} bir saniy\u0259d\u0259n az"
    },
    xSeconds: {
        one: "1 saniy\u0259",
        other: "{{count}} saniy\u0259"
    },
    halfAMinute: "yar\u0131m d\u0259qiq\u0259",
    lessThanXMinutes: {
        one: "bir d\u0259qiq\u0259d\u0259n az",
        other: "{{count}} bir d\u0259qiq\u0259d\u0259n az"
    },
    xMinutes: {
        one: "bir d\u0259qiq\u0259",
        other: "{{count}} d\u0259qiq\u0259"
    },
    aboutXHours: {
        one: "t\u0259xmin\u0259n 1 saat",
        other: "t\u0259xmin\u0259n {{count}} saat"
    },
    xHours: {
        one: "1 saat",
        other: "{{count}} saat"
    },
    xDays: {
        one: "1 g\xfcn",
        other: "{{count}} g\xfcn"
    },
    aboutXWeeks: {
        one: "t\u0259xmin\u0259n 1 h\u0259ft\u0259",
        other: "t\u0259xmin\u0259n {{count}} h\u0259ft\u0259"
    },
    xWeeks: {
        one: "1 h\u0259ft\u0259",
        other: "{{count}} h\u0259ft\u0259"
    },
    aboutXMonths: {
        one: "t\u0259xmin\u0259n 1 ay",
        other: "t\u0259xmin\u0259n {{count}} ay"
    },
    xMonths: {
        one: "1 ay",
        other: "{{count}} ay"
    },
    aboutXYears: {
        one: "t\u0259xmin\u0259n 1 il",
        other: "t\u0259xmin\u0259n {{count}} il"
    },
    xYears: {
        one: "1 il",
        other: "{{count}} il"
    },
    overXYears: {
        one: "1 ild\u0259n \xe7ox",
        other: "{{count}} ild\u0259n \xe7ox"
    },
    almostXYears: {
        one: "dem\u0259k olar ki 1 il",
        other: "dem\u0259k olar ki {{count}} il"
    }
};
const $cae71e04010b0b74$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $cae71e04010b0b74$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " sonra";
        else return result + " \u0259vv\u0259l";
    }
    return result;
};
$cae71e04010b0b74$export$2c14ff85d6318973 = $cae71e04010b0b74$var$formatDistance;

});

parcelRegister("8C5ZS", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $64568638f42437ef$export$cbf60ecb96cbb82f; }, function (v) { return $64568638f42437ef$export$cbf60ecb96cbb82f = v; });
var $64568638f42437ef$export$cbf60ecb96cbb82f;
"use strict";
$64568638f42437ef$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $64568638f42437ef$var$dateFormats = {
    full: "EEEE, do MMMM y 'il'",
    long: "do MMMM y 'il'",
    medium: "d MMM y 'il'",
    short: "dd.MM.yyyy"
};
const $64568638f42437ef$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $64568638f42437ef$var$dateTimeFormats = {
    full: "{{date}} {{time}} - 'd\u0259'",
    long: "{{date}} {{time}} - 'd\u0259'",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $64568638f42437ef$var$formatLong = $64568638f42437ef$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $64568638f42437ef$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $64568638f42437ef$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $64568638f42437ef$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("9VsYp", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $739fe970c3e3c1c3$export$8fbbfd65594f46a0; }, function (v) { return $739fe970c3e3c1c3$export$8fbbfd65594f46a0 = v; });
var $739fe970c3e3c1c3$export$8fbbfd65594f46a0;
"use strict";
$739fe970c3e3c1c3$export$8fbbfd65594f46a0 = void 0;
const $739fe970c3e3c1c3$var$formatRelativeLocale = {
    lastWeek: "'sonuncu' eeee p -'d\u0259'",
    yesterday: "'d\xfcn\u0259n' p -'d\u0259'",
    today: "'bug\xfcn' p -'d\u0259'",
    tomorrow: "'sabah' p -'d\u0259'",
    nextWeek: "eeee p -'d\u0259'",
    other: "P"
};
const $739fe970c3e3c1c3$var$formatRelative = (token, _date, _baseDate, _options)=>$739fe970c3e3c1c3$var$formatRelativeLocale[token];
$739fe970c3e3c1c3$export$8fbbfd65594f46a0 = $739fe970c3e3c1c3$var$formatRelative;

});

parcelRegister("bEbJ2", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $87ac868938e24b1a$export$b3bd0bc58e36cd63; }, function (v) { return $87ac868938e24b1a$export$b3bd0bc58e36cd63 = v; });
var $87ac868938e24b1a$export$b3bd0bc58e36cd63;
"use strict";
$87ac868938e24b1a$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $87ac868938e24b1a$var$eraValues = {
    narrow: [
        "e.\u0259",
        "b.e"
    ],
    abbreviated: [
        "e.\u0259",
        "b.e"
    ],
    wide: [
        "eram\u0131zdan \u0259vv\u0259l",
        "bizim era"
    ]
};
const $87ac868938e24b1a$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1ci kvartal",
        "2ci kvartal",
        "3c\xfc kvartal",
        "4c\xfc kvartal"
    ]
};
const $87ac868938e24b1a$var$monthValues = {
    narrow: [
        "Y",
        "F",
        "M",
        "A",
        "M",
        "\u0130",
        "\u0130",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Yan",
        "Fev",
        "Mar",
        "Apr",
        "May",
        "\u0130yun",
        "\u0130yul",
        "Avq",
        "Sen",
        "Okt",
        "Noy",
        "Dek"
    ],
    wide: [
        "Yanvar",
        "Fevral",
        "Mart",
        "Aprel",
        "May",
        "\u0130yun",
        "\u0130yul",
        "Avqust",
        "Sentyabr",
        "Oktyabr",
        "Noyabr",
        "Dekabr"
    ]
};
const $87ac868938e24b1a$var$dayValues = {
    narrow: [
        "B.",
        "B.e",
        "\xc7.a",
        "\xc7.",
        "C.a",
        "C.",
        "\u015E."
    ],
    short: [
        "B.",
        "B.e",
        "\xc7.a",
        "\xc7.",
        "C.a",
        "C.",
        "\u015E."
    ],
    abbreviated: [
        "Baz",
        "Baz.e",
        "\xc7\u0259r.a",
        "\xc7\u0259r",
        "C\xfcm.a",
        "C\xfcm",
        "\u015E\u0259"
    ],
    wide: [
        "Bazar",
        "Bazar ert\u0259si",
        "\xc7\u0259r\u015F\u0259nb\u0259 ax\u015Fam\u0131",
        "\xc7\u0259r\u015F\u0259nb\u0259",
        "C\xfcm\u0259 ax\u015Fam\u0131",
        "C\xfcm\u0259",
        "\u015E\u0259nb\u0259"
    ]
};
const $87ac868938e24b1a$var$dayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    }
};
const $87ac868938e24b1a$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    }
};
const $87ac868938e24b1a$var$suffixes = {
    1: "-inci",
    5: "-inci",
    8: "-inci",
    70: "-inci",
    80: "-inci",
    2: "-nci",
    7: "-nci",
    20: "-nci",
    50: "-nci",
    3: "-\xfcnc\xfc",
    4: "-\xfcnc\xfc",
    100: "-\xfcnc\xfc",
    6: "-nc\u0131",
    9: "-uncu",
    10: "-uncu",
    30: "-uncu",
    60: "-\u0131nc\u0131",
    90: "-\u0131nc\u0131"
};
const $87ac868938e24b1a$var$getSuffix = (number)=>{
    if (number === 0) // special case for zero
    return number + "-\u0131nc\u0131";
    const a = number % 10;
    const b = number % 100 - a;
    const c = number >= 100 ? 100 : null;
    if ($87ac868938e24b1a$var$suffixes[a]) return $87ac868938e24b1a$var$suffixes[a];
    else if ($87ac868938e24b1a$var$suffixes[b]) return $87ac868938e24b1a$var$suffixes[b];
    else if (c !== null) return $87ac868938e24b1a$var$suffixes[c];
    return "";
};
const $87ac868938e24b1a$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    const suffix = $87ac868938e24b1a$var$getSuffix(number);
    return number + suffix;
};
const $87ac868938e24b1a$var$localize = $87ac868938e24b1a$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $87ac868938e24b1a$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $87ac868938e24b1a$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $87ac868938e24b1a$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $87ac868938e24b1a$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $87ac868938e24b1a$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $87ac868938e24b1a$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $87ac868938e24b1a$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("c00ye", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $8bc5e98fc2634b7d$export$4659b591c19bdf3d; }, function (v) { return $8bc5e98fc2634b7d$export$4659b591c19bdf3d = v; });
var $8bc5e98fc2634b7d$export$4659b591c19bdf3d;
"use strict";
$8bc5e98fc2634b7d$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $8bc5e98fc2634b7d$var$matchOrdinalNumberPattern = /^(\d+)(-?(ci|inci|nci|uncu|üncü|ncı))?/i;
const $8bc5e98fc2634b7d$var$parseOrdinalNumberPattern = /\d+/i;
const $8bc5e98fc2634b7d$var$matchEraPatterns = {
    narrow: /^(b|a)$/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)$/i,
    wide: /^(bizim eradan əvvəl|bizim era)$/i
};
const $8bc5e98fc2634b7d$var$parseEraPatterns = {
    any: [
        /^b$/i,
        /^(a|c)$/i
    ]
};
const $8bc5e98fc2634b7d$var$matchQuarterPatterns = {
    narrow: /^[1234]$/i,
    abbreviated: /^K[1234]$/i,
    wide: /^[1234](ci)? kvartal$/i
};
const $8bc5e98fc2634b7d$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $8bc5e98fc2634b7d$var$matchMonthPatterns = {
    narrow: /^[(?-i)yfmaisond]$/i,
    abbreviated: /^(Yan|Fev|Mar|Apr|May|İyun|İyul|Avq|Sen|Okt|Noy|Dek)$/i,
    wide: /^(Yanvar|Fevral|Mart|Aprel|May|İyun|İyul|Avgust|Sentyabr|Oktyabr|Noyabr|Dekabr)$/i
};
const $8bc5e98fc2634b7d$var$parseMonthPatterns = {
    narrow: [
        /^[(?-i)y]$/i,
        /^[(?-i)f]$/i,
        /^[(?-i)m]$/i,
        /^[(?-i)a]$/i,
        /^[(?-i)m]$/i,
        /^[(?-i)i]$/i,
        /^[(?-i)i]$/i,
        /^[(?-i)a]$/i,
        /^[(?-i)s]$/i,
        /^[(?-i)o]$/i,
        /^[(?-i)n]$/i,
        /^[(?-i)d]$/i
    ],
    abbreviated: [
        /^Yan$/i,
        /^Fev$/i,
        /^Mar$/i,
        /^Apr$/i,
        /^May$/i,
        /^İyun$/i,
        /^İyul$/i,
        /^Avg$/i,
        /^Sen$/i,
        /^Okt$/i,
        /^Noy$/i,
        /^Dek$/i
    ],
    wide: [
        /^Yanvar$/i,
        /^Fevral$/i,
        /^Mart$/i,
        /^Aprel$/i,
        /^May$/i,
        /^İyun$/i,
        /^İyul$/i,
        /^Avgust$/i,
        /^Sentyabr$/i,
        /^Oktyabr$/i,
        /^Noyabr$/i,
        /^Dekabr$/i
    ]
};
const $8bc5e98fc2634b7d$var$matchDayPatterns = {
    narrow: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
    short: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
    abbreviated: /^(Baz\.e|Çər|Çər\.a|Cüm|Cüm\.a|Şə)$/i,
    wide: /^(Bazar|Bazar ertəsi|Çərşənbə axşamı|Çərşənbə|Cümə axşamı|Cümə|Şənbə)$/i
};
const $8bc5e98fc2634b7d$var$parseDayPatterns = {
    narrow: [
        /^B\.$/i,
        /^B\.e$/i,
        /^Ç\.a$/i,
        /^Ç\.$/i,
        /^C\.a$/i,
        /^C\.$/i,
        /^Ş\.$/i
    ],
    abbreviated: [
        /^Baz$/i,
        /^Baz\.e$/i,
        /^Çər\.a$/i,
        /^Çər$/i,
        /^Cüm\.a$/i,
        /^Cüm$/i,
        /^Şə$/i
    ],
    wide: [
        /^Bazar$/i,
        /^Bazar ertəsi$/i,
        /^Çərşənbə axşamı$/i,
        /^Çərşənbə$/i,
        /^Cümə axşamı$/i,
        /^Cümə$/i,
        /^Şənbə$/i
    ],
    any: [
        /^B\.$/i,
        /^B\.e$/i,
        /^Ç\.a$/i,
        /^Ç\.$/i,
        /^C\.a$/i,
        /^C\.$/i,
        /^Ş\.$/i
    ]
};
const $8bc5e98fc2634b7d$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i,
    any: /^(am|pm|a\.m\.|p\.m\.|AM|PM|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i
};
const $8bc5e98fc2634b7d$var$parseDayPeriodPatterns = {
    any: {
        am: /^a$/i,
        pm: /^p$/i,
        midnight: /^gecəyarı$/i,
        noon: /^gün$/i,
        morning: /səhər$/i,
        afternoon: /gündüz$/i,
        evening: /axşam$/i,
        night: /gecə$/i
    }
};
const $8bc5e98fc2634b7d$var$match = $8bc5e98fc2634b7d$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $8bc5e98fc2634b7d$var$matchOrdinalNumberPattern,
        parsePattern: $8bc5e98fc2634b7d$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $8bc5e98fc2634b7d$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8bc5e98fc2634b7d$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $8bc5e98fc2634b7d$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8bc5e98fc2634b7d$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $8bc5e98fc2634b7d$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8bc5e98fc2634b7d$var$parseMonthPatterns,
        defaultParseWidth: "narrow"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $8bc5e98fc2634b7d$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8bc5e98fc2634b7d$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $8bc5e98fc2634b7d$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $8bc5e98fc2634b7d$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("6pIwp", function(module, exports) {

$parcel$export(module.exports, "be", function () { return $4ab79cf549257e2e$export$51b138e5a065c2bb; }, function (v) { return $4ab79cf549257e2e$export$51b138e5a065c2bb = v; });
var $4ab79cf549257e2e$export$51b138e5a065c2bb;
"use strict";
$4ab79cf549257e2e$export$51b138e5a065c2bb = void 0;

var $kCdBJ = parcelRequire("kCdBJ");

var $eRRmX = parcelRequire("eRRmX");

var $hiICV = parcelRequire("hiICV");

var $gzsFv = parcelRequire("gzsFv");

var $4zU0M = parcelRequire("4zU0M");
/**
 * @category Locales
 * @summary Belarusian locale.
 * @language Belarusian
 * @iso-639-2 bel
 * @author Kiryl Anokhin [@alyrik](https://github.com/alyrik)
 * @author Martin Wind [@arvigeus](https://github.com/mawi12345)
 */ const $4ab79cf549257e2e$var$be = $4ab79cf549257e2e$export$51b138e5a065c2bb = {
    code: "be",
    formatDistance: $kCdBJ.formatDistance,
    formatLong: $eRRmX.formatLong,
    formatRelative: $hiICV.formatRelative,
    localize: $gzsFv.localize,
    match: $4zU0M.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("kCdBJ", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $f021e969a86357f9$export$2c14ff85d6318973; }, function (v) { return $f021e969a86357f9$export$2c14ff85d6318973 = v; });
var $f021e969a86357f9$export$2c14ff85d6318973;
"use strict";
$f021e969a86357f9$export$2c14ff85d6318973 = void 0;
function $f021e969a86357f9$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    const rem10 = count % 10;
    const rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace("{{count}}", String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace("{{count}}", String(count));
    else return scheme.pluralGenitive.replace("{{count}}", String(count));
}
function $f021e969a86357f9$var$buildLocalizeTokenFn(scheme) {
    return (count, options)=>{
        if (options && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $f021e969a86357f9$var$declension(scheme.future, count);
                else return "\u043F\u0440\u0430\u0437 " + $f021e969a86357f9$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $f021e969a86357f9$var$declension(scheme.past, count);
                else return $f021e969a86357f9$var$declension(scheme.regular, count) + " \u0442\u0430\u043C\u0443";
            }
        } else return $f021e969a86357f9$var$declension(scheme.regular, count);
    };
}
const $f021e969a86357f9$var$halfAMinute = (_, options)=>{
    if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u043F\u0440\u0430\u0437 \u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
        else return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443";
    }
    return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
};
const $f021e969a86357f9$var$formatDistanceLocale = {
    lessThanXSeconds: $f021e969a86357f9$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: $f021e969a86357f9$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: $f021e969a86357f9$var$halfAMinute,
    lessThanXMinutes: $f021e969a86357f9$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    xMinutes: $f021e969a86357f9$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    aboutXHours: $f021e969a86357f9$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xHours: $f021e969a86357f9$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xDays: $f021e969a86357f9$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0437\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u0456",
            pluralGenitive: "{{count}} \u0434\u0437\u0451\u043D"
        }
    }),
    aboutXWeeks: $f021e969a86357f9$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0442\u044B\u0434\u043D\u0456",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0442\u044B\u0434\u043D\u044F\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0442\u044B\u0434\u043D\u044F\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0442\u044B\u0434\u0437\u0435\u043D\u044C",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0442\u044B\u0434\u043D\u0456",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0442\u044B\u0434\u043D\u044F\u045E"
        }
    }),
    xWeeks: $f021e969a86357f9$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0442\u044B\u0434\u0437\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0442\u044B\u0434\u043D\u0456",
            pluralGenitive: "{{count}} \u0442\u044B\u0434\u043D\u044F\u045E"
        }
    }),
    aboutXMonths: $f021e969a86357f9$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    xMonths: $f021e969a86357f9$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    aboutXYears: $f021e969a86357f9$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    xYears: $f021e969a86357f9$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    overXYears: $f021e969a86357f9$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    almostXYears: $f021e969a86357f9$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    })
};
const $f021e969a86357f9$var$formatDistance = (token, count, options)=>{
    options = options || {};
    return $f021e969a86357f9$var$formatDistanceLocale[token](count, options);
};
$f021e969a86357f9$export$2c14ff85d6318973 = $f021e969a86357f9$var$formatDistance;

});

parcelRegister("eRRmX", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $ad2f69f76f3378ac$export$cbf60ecb96cbb82f; }, function (v) { return $ad2f69f76f3378ac$export$cbf60ecb96cbb82f = v; });
var $ad2f69f76f3378ac$export$cbf60ecb96cbb82f;
"use strict";
$ad2f69f76f3378ac$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $ad2f69f76f3378ac$var$dateFormats = {
    full: "EEEE, d MMMM y '\u0433.'",
    long: "d MMMM y '\u0433.'",
    medium: "d MMM y '\u0433.'",
    short: "dd.MM.y"
};
const $ad2f69f76f3378ac$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $ad2f69f76f3378ac$var$dateTimeFormats = {
    any: "{{date}}, {{time}}"
};
const $ad2f69f76f3378ac$var$formatLong = $ad2f69f76f3378ac$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $ad2f69f76f3378ac$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $ad2f69f76f3378ac$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $ad2f69f76f3378ac$var$dateTimeFormats,
        defaultWidth: "any"
    })
};

});

parcelRegister("hiICV", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $c986bc16546898ba$export$8fbbfd65594f46a0; }, function (v) { return $c986bc16546898ba$export$8fbbfd65594f46a0 = v; });
var $c986bc16546898ba$export$8fbbfd65594f46a0;
"use strict";
$c986bc16546898ba$export$8fbbfd65594f46a0 = void 0;

var $9VRW1 = parcelRequire("9VRW1");

var $eimnm = parcelRequire("eimnm");
const $c986bc16546898ba$var$accusativeWeekdays = [
    "\u043D\u044F\u0434\u0437\u0435\u043B\u044E",
    "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
    "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
    "\u0441\u0435\u0440\u0430\u0434\u0443",
    "\u0447\u0430\u0446\u0432\u0435\u0440",
    "\u043F\u044F\u0442\u043D\u0456\u0446\u0443",
    "\u0441\u0443\u0431\u043E\u0442\u0443"
];
function $c986bc16546898ba$var$lastWeek(day) {
    const weekday = $c986bc16546898ba$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u044B " + weekday + " \u0430' p";
    }
}
function $c986bc16546898ba$var$thisWeek(day) {
    const weekday = $c986bc16546898ba$var$accusativeWeekdays[day];
    return "'\u0443 " + weekday + " \u0430' p";
}
function $c986bc16546898ba$var$nextWeek(day) {
    const weekday = $c986bc16546898ba$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u044B " + weekday + " \u0430' p";
    }
}
const $c986bc16546898ba$var$lastWeekFormat = (dirtyDate, baseDate, options)=>{
    const date = (0, $eimnm.toDate)(dirtyDate);
    const day = date.getDay();
    if ((0, $9VRW1.isSameWeek)(date, baseDate, options)) return $c986bc16546898ba$var$thisWeek(day);
    else return $c986bc16546898ba$var$lastWeek(day);
};
const $c986bc16546898ba$var$nextWeekFormat = (dirtyDate, baseDate, options)=>{
    const date = (0, $eimnm.toDate)(dirtyDate);
    const day = date.getDay();
    if ((0, $9VRW1.isSameWeek)(date, baseDate, options)) return $c986bc16546898ba$var$thisWeek(day);
    else return $c986bc16546898ba$var$nextWeek(day);
};
const $c986bc16546898ba$var$formatRelativeLocale = {
    lastWeek: $c986bc16546898ba$var$lastWeekFormat,
    yesterday: "'\u0443\u0447\u043E\u0440\u0430 \u0430' p",
    today: "'\u0441\u0451\u043D\u043D\u044F \u0430' p",
    tomorrow: "'\u0437\u0430\u045E\u0442\u0440\u0430 \u0430' p",
    nextWeek: $c986bc16546898ba$var$nextWeekFormat,
    other: "P"
};
const $c986bc16546898ba$var$formatRelative = (token, date, baseDate, options)=>{
    const format = $c986bc16546898ba$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
$c986bc16546898ba$export$8fbbfd65594f46a0 = $c986bc16546898ba$var$formatRelative;

});

parcelRegister("gzsFv", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $c106272c4bec2fbd$export$b3bd0bc58e36cd63; }, function (v) { return $c106272c4bec2fbd$export$b3bd0bc58e36cd63 = v; });
var $c106272c4bec2fbd$export$b3bd0bc58e36cd63;
"use strict";
$c106272c4bec2fbd$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $c106272c4bec2fbd$var$eraValues = {
    narrow: [
        "\u0434\u0430 \u043D.\u044D.",
        "\u043D.\u044D."
    ],
    abbreviated: [
        "\u0434\u0430 \u043D. \u044D.",
        "\u043D. \u044D."
    ],
    wide: [
        "\u0434\u0430 \u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B",
        "\u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B"
    ]
};
const $c106272c4bec2fbd$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-\u044B \u043A\u0432.",
        "2-\u0456 \u043A\u0432.",
        "3-\u0456 \u043A\u0432.",
        "4-\u044B \u043A\u0432."
    ],
    wide: [
        "1-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
const $c106272c4bec2fbd$var$monthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u041C",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u043C\u0430\u0439",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044C",
        "\u043B\u044E\u0442\u044B",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A",
        "\u043C\u0430\u0439",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044C",
        "\u043B\u0456\u043F\u0435\u043D\u044C",
        "\u0436\u043D\u0456\u0432\u0435\u043D\u044C",
        "\u0432\u0435\u0440\u0430\u0441\u0435\u043D\u044C",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434",
        "\u0441\u043D\u0435\u0436\u0430\u043D\u044C"
    ]
};
const $c106272c4bec2fbd$var$formattingMonthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u041C",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u043C\u0430\u044F",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044F",
        "\u043B\u044E\u0442\u0430\u0433\u0430",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A\u0430",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A\u0430",
        "\u043C\u0430\u044F",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044F",
        "\u043B\u0456\u043F\u0435\u043D\u044F",
        "\u0436\u043D\u0456\u045E\u043D\u044F",
        "\u0432\u0435\u0440\u0430\u0441\u043D\u044F",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A\u0430",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434\u0430",
        "\u0441\u043D\u0435\u0436\u043D\u044F"
    ]
};
const $c106272c4bec2fbd$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0410",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0430\u045E",
        "\u0441\u0440",
        "\u0447\u0446",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u044F\u0434\u0437",
        "\u043F\u0430\u043D",
        "\u0430\u045E\u0442",
        "\u0441\u0435\u0440",
        "\u0447\u0430\u0446",
        "\u043F\u044F\u0442",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u044F\u0434\u0437\u0435\u043B\u044F",
        "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
        "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
        "\u0441\u0435\u0440\u0430\u0434\u0430",
        "\u0447\u0430\u0446\u0432\u0435\u0440",
        "\u043F\u044F\u0442\u043D\u0456\u0446\u0430",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
const $c106272c4bec2fbd$var$dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u0430",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0430\u0440",
        night: "\u043D\u043E\u0447"
    }
};
const $c106272c4bec2fbd$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u044B",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0430\u0440\u0430",
        night: "\u043D\u043E\u0447\u044B"
    }
};
const $c106272c4bec2fbd$var$ordinalNumber = (dirtyNumber, options)=>{
    const unit = String(options?.unit);
    const number = Number(dirtyNumber);
    let suffix;
    /** Though it's an incorrect ordinal form of a date we use it here for consistency with other similar locales (ru, uk)
   *  For date-month combinations should be used `d` formatter.
   *  Correct:   `d MMMM` (4 верасня)
   *  Incorrect: `do MMMM` (4-га верасня)
   *
   *  But following the consistency leads to mistakes for literal uses of `do` formatter (ordinal day of month).
   *  So for phrase "5th day of month" (`do дзень месяца`)
   *  library will produce:            `5-га дзень месяца`
   *  but correct spelling should be:  `5-ы дзень месяца`
   *
   *  So I guess there should be a stand-alone and a formatting version of "day of month" formatters
   */ if (unit === "date") suffix = "-\u0433\u0430";
    else if (unit === "hour" || unit === "minute" || unit === "second") suffix = "-\u044F";
    else suffix = (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? "-\u0456" : "-\u044B";
    return number + suffix;
};
const $c106272c4bec2fbd$var$localize = $c106272c4bec2fbd$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $c106272c4bec2fbd$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $c106272c4bec2fbd$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $c106272c4bec2fbd$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $c106272c4bec2fbd$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $c106272c4bec2fbd$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $c106272c4bec2fbd$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $c106272c4bec2fbd$var$dayPeriodValues,
        defaultWidth: "any",
        formattingValues: $c106272c4bec2fbd$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("4zU0M", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $3555e110418c9f84$export$4659b591c19bdf3d; }, function (v) { return $3555e110418c9f84$export$4659b591c19bdf3d = v; });
var $3555e110418c9f84$export$4659b591c19bdf3d;
"use strict";
$3555e110418c9f84$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $3555e110418c9f84$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i;
const $3555e110418c9f84$var$parseOrdinalNumberPattern = /\d+/i;
const $3555e110418c9f84$var$matchEraPatterns = {
    narrow: /^((да )?н\.?\s?э\.?)/i,
    abbreviated: /^((да )?н\.?\s?э\.?)/i,
    wide: /^(да нашай эры|нашай эры|наша эра)/i
};
const $3555e110418c9f84$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
const $3555e110418c9f84$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
    wide: /^[1234](-?[ыі]?)? квартал/i
};
const $3555e110418c9f84$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $3555e110418c9f84$var$matchMonthPatterns = {
    narrow: /^[слкмчжв]/i,
    abbreviated: /^(студз|лют|сак|крас|ма[йя]|чэрв|ліп|жн|вер|кастр|ліст|снеж)\.?/i,
    wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|ма[йя]|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|снеж(ань|ня))/i
};
const $3555e110418c9f84$var$parseMonthPatterns = {
    narrow: [
        /^с/i,
        /^л/i,
        /^с/i,
        /^к/i,
        /^м/i,
        /^ч/i,
        /^л/i,
        /^ж/i,
        /^в/i,
        /^к/i,
        /^л/i,
        /^с/i
    ],
    any: [
        /^ст/i,
        /^лю/i,
        /^са/i,
        /^кр/i,
        /^ма/i,
        /^ч/i,
        /^ліп/i,
        /^ж/i,
        /^в/i,
        /^ка/i,
        /^ліс/i,
        /^сн/i
    ]
};
const $3555e110418c9f84$var$matchDayPatterns = {
    narrow: /^[нпасч]/i,
    short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
    abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцв|чац|птн|пят|суб).?/i,
    wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацв(ер|ярга)|пятніц[аы]|субот[аы])/i
};
const $3555e110418c9f84$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^а/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н/i,
        /^п[ан]/i,
        /^а/i,
        /^с[ер]/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
const $3555e110418c9f84$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
};
const $3555e110418c9f84$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^поўн/i,
        noon: /^поўд/i,
        morning: /^р/i,
        afternoon: /^д[зн]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
const $3555e110418c9f84$var$match = $3555e110418c9f84$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $3555e110418c9f84$var$matchOrdinalNumberPattern,
        parsePattern: $3555e110418c9f84$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $3555e110418c9f84$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3555e110418c9f84$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $3555e110418c9f84$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3555e110418c9f84$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $3555e110418c9f84$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3555e110418c9f84$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $3555e110418c9f84$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3555e110418c9f84$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $3555e110418c9f84$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3555e110418c9f84$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("45Kkz", function(module, exports) {

$parcel$export(module.exports, "beTarask", function () { return $2fab91602aed91c8$export$af663c27a971be30; }, function (v) { return $2fab91602aed91c8$export$af663c27a971be30 = v; });
var $2fab91602aed91c8$export$af663c27a971be30;
"use strict";
$2fab91602aed91c8$export$af663c27a971be30 = void 0;

var $dMxRy = parcelRequire("dMxRy");

var $5jLz5 = parcelRequire("5jLz5");

var $5Ev7I = parcelRequire("5Ev7I");

var $b58LJ = parcelRequire("b58LJ");

var $aFtsG = parcelRequire("aFtsG");
/**
 * @category Locales
 * @summary Belarusian Classic locale.
 * @language Belarusian Classic
 * @iso-639-2 bel
 * @author Ryhor Nopears [@nopears](https://github.com/nopears)
 */ const $2fab91602aed91c8$var$beTarask = $2fab91602aed91c8$export$af663c27a971be30 = {
    code: "be-tarask",
    formatDistance: $dMxRy.formatDistance,
    formatLong: $5jLz5.formatLong,
    formatRelative: $5Ev7I.formatRelative,
    localize: $b58LJ.localize,
    match: $aFtsG.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("dMxRy", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $a08a067e0e91b86f$export$2c14ff85d6318973; }, function (v) { return $a08a067e0e91b86f$export$2c14ff85d6318973 = v; });
var $a08a067e0e91b86f$export$2c14ff85d6318973;
"use strict";
$a08a067e0e91b86f$export$2c14ff85d6318973 = void 0;
function $a08a067e0e91b86f$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    const rem10 = count % 10;
    const rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace("{{count}}", String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace("{{count}}", String(count));
    else return scheme.pluralGenitive.replace("{{count}}", String(count));
}
function $a08a067e0e91b86f$var$buildLocalizeTokenFn(scheme) {
    return (count, options)=>{
        if (options && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $a08a067e0e91b86f$var$declension(scheme.future, count);
                else return "\u043F\u0440\u0430\u0437 " + $a08a067e0e91b86f$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $a08a067e0e91b86f$var$declension(scheme.past, count);
                else return $a08a067e0e91b86f$var$declension(scheme.regular, count) + " \u0442\u0430\u043C\u0443";
            }
        } else return $a08a067e0e91b86f$var$declension(scheme.regular, count);
    };
}
const $a08a067e0e91b86f$var$halfAMinute = (_, options)=>{
    if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u043F\u0440\u0430\u0437 \u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
        else return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443";
    }
    return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
};
const $a08a067e0e91b86f$var$formatDistanceLocale = {
    lessThanXSeconds: $a08a067e0e91b86f$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: $a08a067e0e91b86f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: $a08a067e0e91b86f$var$halfAMinute,
    lessThanXMinutes: $a08a067e0e91b86f$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    xMinutes: $a08a067e0e91b86f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    aboutXHours: $a08a067e0e91b86f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xHours: $a08a067e0e91b86f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xDays: $a08a067e0e91b86f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0437\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u0456",
            pluralGenitive: "{{count}} \u0434\u0437\u0451\u043D"
        }
    }),
    aboutXWeeks: $a08a067e0e91b86f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0442\u044B\u0434\u043D\u0456",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0442\u044B\u0434\u043D\u044F\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0442\u044B\u0434\u043D\u044F\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0442\u044B\u0434\u0437\u0435\u043D\u044C",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0442\u044B\u0434\u043D\u0456",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0442\u044B\u0434\u043D\u044F\u045E"
        }
    }),
    xWeeks: $a08a067e0e91b86f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0442\u044B\u0434\u0437\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0442\u044B\u0434\u043D\u0456",
            pluralGenitive: "{{count}} \u0442\u044B\u0434\u043D\u044F\u045E"
        }
    }),
    aboutXMonths: $a08a067e0e91b86f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    xMonths: $a08a067e0e91b86f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    aboutXYears: $a08a067e0e91b86f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    xYears: $a08a067e0e91b86f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    overXYears: $a08a067e0e91b86f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    almostXYears: $a08a067e0e91b86f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    })
};
const $a08a067e0e91b86f$var$formatDistance = (token, count, options)=>{
    options = options || {};
    return $a08a067e0e91b86f$var$formatDistanceLocale[token](count, options);
};
$a08a067e0e91b86f$export$2c14ff85d6318973 = $a08a067e0e91b86f$var$formatDistance;

});

parcelRegister("5jLz5", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $3df39f82415a168a$export$cbf60ecb96cbb82f; }, function (v) { return $3df39f82415a168a$export$cbf60ecb96cbb82f = v; });
var $3df39f82415a168a$export$cbf60ecb96cbb82f;
"use strict";
$3df39f82415a168a$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $3df39f82415a168a$var$dateFormats = {
    full: "EEEE, d MMMM y '\u0433.'",
    long: "d MMMM y '\u0433.'",
    medium: "d MMM y '\u0433.'",
    short: "dd.MM.y"
};
const $3df39f82415a168a$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $3df39f82415a168a$var$dateTimeFormats = {
    any: "{{date}}, {{time}}"
};
const $3df39f82415a168a$var$formatLong = $3df39f82415a168a$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $3df39f82415a168a$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $3df39f82415a168a$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $3df39f82415a168a$var$dateTimeFormats,
        defaultWidth: "any"
    })
};

});

parcelRegister("5Ev7I", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $41d8d4a00bbb6423$export$8fbbfd65594f46a0; }, function (v) { return $41d8d4a00bbb6423$export$8fbbfd65594f46a0 = v; });
var $41d8d4a00bbb6423$export$8fbbfd65594f46a0;
"use strict";
$41d8d4a00bbb6423$export$8fbbfd65594f46a0 = void 0;

var $9VRW1 = parcelRequire("9VRW1");

var $eimnm = parcelRequire("eimnm");
const $41d8d4a00bbb6423$var$accusativeWeekdays = [
    "\u043D\u044F\u0434\u0437\u0435\u043B\u044E",
    "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
    "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
    "\u0441\u0435\u0440\u0430\u0434\u0443",
    "\u0447\u0430\u0446\u044C\u0432\u0435\u0440",
    "\u043F\u044F\u0442\u043D\u0456\u0446\u0443",
    "\u0441\u0443\u0431\u043E\u0442\u0443"
];
function $41d8d4a00bbb6423$var$lastWeek(day) {
    const weekday = $41d8d4a00bbb6423$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u044B " + weekday + " \u0430' p";
    }
}
function $41d8d4a00bbb6423$var$thisWeek(day) {
    const weekday = $41d8d4a00bbb6423$var$accusativeWeekdays[day];
    return "'\u0443 " + weekday + " \u0430' p";
}
function $41d8d4a00bbb6423$var$nextWeek(day) {
    const weekday = $41d8d4a00bbb6423$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u044B " + weekday + " \u0430' p";
    }
}
const $41d8d4a00bbb6423$var$lastWeekFormat = (dirtyDate, baseDate, options)=>{
    const date = (0, $eimnm.toDate)(dirtyDate);
    const day = date.getDay();
    if ((0, $9VRW1.isSameWeek)(date, baseDate, options)) return $41d8d4a00bbb6423$var$thisWeek(day);
    else return $41d8d4a00bbb6423$var$lastWeek(day);
};
const $41d8d4a00bbb6423$var$nextWeekFormat = (dirtyDate, baseDate, options)=>{
    const date = (0, $eimnm.toDate)(dirtyDate);
    const day = date.getDay();
    if ((0, $9VRW1.isSameWeek)(date, baseDate, options)) return $41d8d4a00bbb6423$var$thisWeek(day);
    else return $41d8d4a00bbb6423$var$nextWeek(day);
};
const $41d8d4a00bbb6423$var$formatRelativeLocale = {
    lastWeek: $41d8d4a00bbb6423$var$lastWeekFormat,
    yesterday: "'\u0443\u0447\u043E\u0440\u0430 \u0430' p",
    today: "'\u0441\u0451\u043D\u044C\u043D\u044F \u0430' p",
    tomorrow: "'\u0437\u0430\u045E\u0442\u0440\u0430 \u0430' p",
    nextWeek: $41d8d4a00bbb6423$var$nextWeekFormat,
    other: "P"
};
const $41d8d4a00bbb6423$var$formatRelative = (token, date, baseDate, options)=>{
    const format = $41d8d4a00bbb6423$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
$41d8d4a00bbb6423$export$8fbbfd65594f46a0 = $41d8d4a00bbb6423$var$formatRelative;

});

parcelRegister("b58LJ", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $8116f6a749281043$export$b3bd0bc58e36cd63; }, function (v) { return $8116f6a749281043$export$b3bd0bc58e36cd63 = v; });
var $8116f6a749281043$export$b3bd0bc58e36cd63;
"use strict";
$8116f6a749281043$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $8116f6a749281043$var$eraValues = {
    narrow: [
        "\u0434\u0430 \u043D.\u044D.",
        "\u043D.\u044D."
    ],
    abbreviated: [
        "\u0434\u0430 \u043D. \u044D.",
        "\u043D. \u044D."
    ],
    wide: [
        "\u0434\u0430 \u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B",
        "\u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B"
    ]
};
const $8116f6a749281043$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-\u044B \u043A\u0432.",
        "2-\u0456 \u043A\u0432.",
        "3-\u0456 \u043A\u0432.",
        "4-\u044B \u043A\u0432."
    ],
    wide: [
        "1-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
const $8116f6a749281043$var$monthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u044C\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044C",
        "\u043B\u044E\u0442\u044B",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A",
        "\u0442\u0440\u0430\u0432\u0435\u043D\u044C",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044C",
        "\u043B\u0456\u043F\u0435\u043D\u044C",
        "\u0436\u043D\u0456\u0432\u0435\u043D\u044C",
        "\u0432\u0435\u0440\u0430\u0441\u0435\u043D\u044C",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434",
        "\u0441\u044C\u043D\u0435\u0436\u0430\u043D\u044C"
    ]
};
const $8116f6a749281043$var$formattingMonthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u044C\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044F",
        "\u043B\u044E\u0442\u0430\u0433\u0430",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A\u0430",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A\u0430",
        "\u0442\u0440\u0430\u045E\u043D\u044F",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044F",
        "\u043B\u0456\u043F\u0435\u043D\u044F",
        "\u0436\u043D\u0456\u045E\u043D\u044F",
        "\u0432\u0435\u0440\u0430\u0441\u043D\u044F",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A\u0430",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434\u0430",
        "\u0441\u044C\u043D\u0435\u0436\u043D\u044F"
    ]
};
const $8116f6a749281043$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0410",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0430\u045E",
        "\u0441\u0440",
        "\u0447\u0446",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u044F\u0434\u0437",
        "\u043F\u0430\u043D",
        "\u0430\u045E\u0442",
        "\u0441\u0435\u0440",
        "\u0447\u0430\u0446\u044C",
        "\u043F\u044F\u0442",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u044F\u0434\u0437\u0435\u043B\u044F",
        "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
        "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
        "\u0441\u0435\u0440\u0430\u0434\u0430",
        "\u0447\u0430\u0446\u044C\u0432\u0435\u0440",
        "\u043F\u044F\u0442\u043D\u0456\u0446\u0430",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
const $8116f6a749281043$var$dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u0430",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0430\u0440",
        night: "\u043D\u043E\u0447"
    }
};
const $8116f6a749281043$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u044B",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0430\u0440\u0430",
        night: "\u043D\u043E\u0447\u044B"
    }
};
const $8116f6a749281043$var$ordinalNumber = (dirtyNumber, options)=>{
    const unit = String(options?.unit);
    const number = Number(dirtyNumber);
    let suffix;
    /** Though it's an incorrect ordinal form of a date we use it here for consistency with other similar locales (ru, uk)
   *  For date-month combinations should be used `d` formatter.
   *  Correct:   `d MMMM` (4 верасня)
   *  Incorrect: `do MMMM` (4-га верасня)
   *
   *  But following the consistency leads to mistakes for literal uses of `do` formatter (ordinal day of month).
   *  So for phrase "5th day of month" (`do дзень месяца`)
   *  library will produce:            `5-га дзень месяца`
   *  but correct spelling should be:  `5-ы дзень месяца`
   *
   *  So I guess there should be a stand-alone and a formatting version of "day of month" formatters
   */ if (unit === "date") suffix = "-\u0433\u0430";
    else if (unit === "hour" || unit === "minute" || unit === "second") suffix = "-\u044F";
    else suffix = (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? "-\u0456" : "-\u044B";
    return number + suffix;
};
const $8116f6a749281043$var$localize = $8116f6a749281043$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $8116f6a749281043$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $8116f6a749281043$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $8116f6a749281043$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $8116f6a749281043$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $8116f6a749281043$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $8116f6a749281043$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $8116f6a749281043$var$dayPeriodValues,
        defaultWidth: "any",
        formattingValues: $8116f6a749281043$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("aFtsG", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $7c449631ce277330$export$4659b591c19bdf3d; }, function (v) { return $7c449631ce277330$export$4659b591c19bdf3d = v; });
var $7c449631ce277330$export$4659b591c19bdf3d;
"use strict";
$7c449631ce277330$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $7c449631ce277330$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i;
const $7c449631ce277330$var$parseOrdinalNumberPattern = /\d+/i;
const $7c449631ce277330$var$matchEraPatterns = {
    narrow: /^((да )?н\.?\s?э\.?)/i,
    abbreviated: /^((да )?н\.?\s?э\.?)/i,
    wide: /^(да нашай эры|нашай эры|наша эра)/i
};
const $7c449631ce277330$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
const $7c449631ce277330$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
    wide: /^[1234](-?[ыі]?)? квартал/i
};
const $7c449631ce277330$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $7c449631ce277330$var$matchMonthPatterns = {
    narrow: /^[слкмчжв]/i,
    abbreviated: /^(студз|лют|сак|крас|тр(ав)?|чэрв|ліп|жн|вер|кастр|ліст|сьнеж)\.?/i,
    wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|тра(вень|ўня)|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|сьнеж(ань|ня))/i
};
const $7c449631ce277330$var$parseMonthPatterns = {
    narrow: [
        /^с/i,
        /^л/i,
        /^с/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^л/i,
        /^ж/i,
        /^в/i,
        /^к/i,
        /^л/i,
        /^с/i
    ],
    any: [
        /^ст/i,
        /^лю/i,
        /^са/i,
        /^кр/i,
        /^тр/i,
        /^ч/i,
        /^ліп/i,
        /^ж/i,
        /^в/i,
        /^ка/i,
        /^ліс/i,
        /^сн/i
    ]
};
const $7c449631ce277330$var$matchDayPatterns = {
    narrow: /^[нпасч]/i,
    short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
    abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцьв|чаць|птн|пят|суб).?/i,
    wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацьв(ер|ярга)|пятніц[аы]|субот[аы])/i
};
const $7c449631ce277330$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^а/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н/i,
        /^п[ан]/i,
        /^а/i,
        /^с[ер]/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
const $7c449631ce277330$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
};
const $7c449631ce277330$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^поўн/i,
        noon: /^поўд/i,
        morning: /^р/i,
        afternoon: /^д[зн]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
const $7c449631ce277330$var$match = $7c449631ce277330$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $7c449631ce277330$var$matchOrdinalNumberPattern,
        parsePattern: $7c449631ce277330$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $7c449631ce277330$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7c449631ce277330$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $7c449631ce277330$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7c449631ce277330$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $7c449631ce277330$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7c449631ce277330$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $7c449631ce277330$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7c449631ce277330$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $7c449631ce277330$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7c449631ce277330$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("1UmQw", function(module, exports) {

$parcel$export(module.exports, "bg", function () { return $163cbe25b3c4c85b$export$136fd86de524d3c2; }, function (v) { return $163cbe25b3c4c85b$export$136fd86de524d3c2 = v; });
var $163cbe25b3c4c85b$export$136fd86de524d3c2;
"use strict";
$163cbe25b3c4c85b$export$136fd86de524d3c2 = void 0;

var $l8Hqx = parcelRequire("l8Hqx");

var $3ppth = parcelRequire("3ppth");

var $9rASh = parcelRequire("9rASh");

var $34jJz = parcelRequire("34jJz");

var $jiXXP = parcelRequire("jiXXP");
/**
 * @category Locales
 * @summary Bulgarian locale.
 * @language Bulgarian
 * @iso-639-2 bul
 * @author Nikolay Stoynov [@arvigeus](https://github.com/arvigeus)
 * @author Tsvetan Ovedenski [@fintara](https://github.com/fintara)
 */ const $163cbe25b3c4c85b$var$bg = $163cbe25b3c4c85b$export$136fd86de524d3c2 = {
    code: "bg",
    formatDistance: $l8Hqx.formatDistance,
    formatLong: $3ppth.formatLong,
    formatRelative: $9rASh.formatRelative,
    localize: $34jJz.localize,
    match: $jiXXP.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("l8Hqx", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $f63c080b62a75c9b$export$2c14ff85d6318973; }, function (v) { return $f63c080b62a75c9b$export$2c14ff85d6318973 = v; });
var $f63c080b62a75c9b$export$2c14ff85d6318973;
"use strict";
$f63c080b62a75c9b$export$2c14ff85d6318973 = void 0;
const $f63c080b62a75c9b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    xSeconds: {
        one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    halfAMinute: "\u043F\u043E\u043B\u043E\u0432\u0438\u043D \u043C\u0438\u043D\u0443\u0442\u0430",
    lessThanXMinutes: {
        one: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 {{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    xMinutes: {
        one: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    aboutXHours: {
        one: "\u043E\u043A\u043E\u043B\u043E \u0447\u0430\u0441",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u0430"
    },
    xHours: {
        one: "1 \u0447\u0430\u0441",
        other: "{{count}} \u0447\u0430\u0441\u0430"
    },
    xDays: {
        one: "1 \u0434\u0435\u043D",
        other: "{{count}} \u0434\u043D\u0438"
    },
    aboutXWeeks: {
        one: "\u043E\u043A\u043E\u043B\u043E \u0441\u0435\u0434\u043C\u0438\u0446\u0430",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0441\u0435\u0434\u043C\u0438\u0446\u0438"
    },
    xWeeks: {
        one: "1 \u0441\u0435\u0434\u043C\u0438\u0446\u0430",
        other: "{{count}} \u0441\u0435\u0434\u043C\u0438\u0446\u0438"
    },
    aboutXMonths: {
        one: "\u043E\u043A\u043E\u043B\u043E \u043C\u0435\u0441\u0435\u0446",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0430"
    },
    xMonths: {
        one: "1 \u043C\u0435\u0441\u0435\u0446",
        other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0430"
    },
    aboutXYears: {
        one: "\u043E\u043A\u043E\u043B\u043E \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    xYears: {
        one: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    overXYears: {
        one: "\u043D\u0430\u0434 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043D\u0430\u0434 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    almostXYears: {
        one: "\u043F\u043E\u0447\u0442\u0438 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    }
};
const $f63c080b62a75c9b$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $f63c080b62a75c9b$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0441\u043B\u0435\u0434 " + result;
        else return "\u043F\u0440\u0435\u0434\u0438 " + result;
    }
    return result;
};
$f63c080b62a75c9b$export$2c14ff85d6318973 = $f63c080b62a75c9b$var$formatDistance;

});

parcelRegister("3ppth", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $27b776f557be9e19$export$cbf60ecb96cbb82f; }, function (v) { return $27b776f557be9e19$export$cbf60ecb96cbb82f = v; });
var $27b776f557be9e19$export$cbf60ecb96cbb82f;
"use strict";
$27b776f557be9e19$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $27b776f557be9e19$var$dateFormats = {
    full: "EEEE, dd MMMM yyyy",
    long: "dd MMMM yyyy",
    medium: "dd MMM yyyy",
    short: "dd/MM/yyyy"
};
const $27b776f557be9e19$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "H:mm"
};
const $27b776f557be9e19$var$dateTimeFormats = {
    any: "{{date}} {{time}}"
};
const $27b776f557be9e19$var$formatLong = $27b776f557be9e19$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $27b776f557be9e19$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $27b776f557be9e19$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $27b776f557be9e19$var$dateTimeFormats,
        defaultWidth: "any"
    })
};

});

parcelRegister("9rASh", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $6e033d27c99ee323$export$8fbbfd65594f46a0; }, function (v) { return $6e033d27c99ee323$export$8fbbfd65594f46a0 = v; });
var $6e033d27c99ee323$export$8fbbfd65594f46a0;
"use strict";
$6e033d27c99ee323$export$8fbbfd65594f46a0 = void 0;

var $9VRW1 = parcelRequire("9VRW1");

var $eimnm = parcelRequire("eimnm");
// Adapted from the `ru` translation
const $6e033d27c99ee323$var$weekdays = [
    "\u043D\u0435\u0434\u0435\u043B\u044F",
    "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
    "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0441\u0440\u044F\u0434\u0430",
    "\u0447\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A",
    "\u043F\u0435\u0442\u044A\u043A",
    "\u0441\u044A\u0431\u043E\u0442\u0430"
];
function $6e033d27c99ee323$var$lastWeek(day) {
    const weekday = $6e033d27c99ee323$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u043C\u0438\u043D\u0430\u043B\u0430\u0442\u0430 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u043C\u0438\u043D\u0430\u043B\u0438\u044F " + weekday + " \u0432' p";
    }
}
function $6e033d27c99ee323$var$thisWeek(day) {
    const weekday = $6e033d27c99ee323$var$weekdays[day];
    if (day === 2 /* Tue */ ) return "'\u0432\u044A\u0432 " + weekday + " \u0432' p";
    else return "'\u0432 " + weekday + " \u0432' p";
}
function $6e033d27c99ee323$var$nextWeek(day) {
    const weekday = $6e033d27c99ee323$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0430\u0442\u0430 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0438\u044F " + weekday + " \u0432' p";
    }
}
const $6e033d27c99ee323$var$lastWeekFormatToken = (dirtyDate, baseDate, options)=>{
    const date = (0, $eimnm.toDate)(dirtyDate);
    const day = date.getDay();
    if ((0, $9VRW1.isSameWeek)(date, baseDate, options)) return $6e033d27c99ee323$var$thisWeek(day);
    else return $6e033d27c99ee323$var$lastWeek(day);
};
const $6e033d27c99ee323$var$nextWeekFormatToken = (dirtyDate, baseDate, options)=>{
    const date = (0, $eimnm.toDate)(dirtyDate);
    const day = date.getDay();
    if ((0, $9VRW1.isSameWeek)(date, baseDate, options)) return $6e033d27c99ee323$var$thisWeek(day);
    else return $6e033d27c99ee323$var$nextWeek(day);
};
const $6e033d27c99ee323$var$formatRelativeLocale = {
    lastWeek: $6e033d27c99ee323$var$lastWeekFormatToken,
    yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432' p",
    today: "'\u0434\u043D\u0435\u0441 \u0432' p",
    tomorrow: "'\u0443\u0442\u0440\u0435 \u0432' p",
    nextWeek: $6e033d27c99ee323$var$nextWeekFormatToken,
    other: "P"
};
const $6e033d27c99ee323$var$formatRelative = (token, date, baseDate, options)=>{
    const format = $6e033d27c99ee323$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
$6e033d27c99ee323$export$8fbbfd65594f46a0 = $6e033d27c99ee323$var$formatRelative;

});

parcelRegister("34jJz", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $23c10d9359963010$export$b3bd0bc58e36cd63; }, function (v) { return $23c10d9359963010$export$b3bd0bc58e36cd63 = v; });
var $23c10d9359963010$export$b3bd0bc58e36cd63;
"use strict";
$23c10d9359963010$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $23c10d9359963010$var$eraValues = {
    narrow: [
        "\u043F\u0440.\u043D.\u0435.",
        "\u043D.\u0435."
    ],
    abbreviated: [
        "\u043F\u0440\u0435\u0434\u0438 \u043D. \u0435.",
        "\u043D. \u0435."
    ],
    wide: [
        "\u043F\u0440\u0435\u0434\u0438 \u043D\u043E\u0432\u0430\u0442\u0430 \u0435\u0440\u0430",
        "\u043D\u043E\u0432\u0430\u0442\u0430 \u0435\u0440\u0430"
    ]
};
const $23c10d9359963010$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-\u0432\u043E \u0442\u0440\u0438\u043C\u0435\u0441.",
        "2-\u0440\u043E \u0442\u0440\u0438\u043C\u0435\u0441.",
        "3-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441.",
        "4-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441."
    ],
    wide: [
        "1-\u0432\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435",
        "2-\u0440\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435",
        "3-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435",
        "4-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435"
    ]
};
const $23c10d9359963010$var$monthValues = {
    abbreviated: [
        "\u044F\u043D\u0443",
        "\u0444\u0435\u0432",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0439",
        "\u044E\u043D\u0438",
        "\u044E\u043B\u0438",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0435",
        "\u0434\u0435\u043A"
    ],
    wide: [
        "\u044F\u043D\u0443\u0430\u0440\u0438",
        "\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0439",
        "\u044E\u043D\u0438",
        "\u044E\u043B\u0438",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438",
        "\u043E\u043A\u0442\u043E\u043C\u0432\u0440\u0438",
        "\u043D\u043E\u0435\u043C\u0432\u0440\u0438",
        "\u0434\u0435\u043A\u0435\u043C\u0432\u0440\u0438"
    ]
};
const $23c10d9359963010$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0432\u0442\u043E",
        "\u0441\u0440\u044F",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u044A\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0435\u043B\u044F",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
        "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
        "\u0441\u0440\u044F\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A",
        "\u043F\u0435\u0442\u044A\u043A",
        "\u0441\u044A\u0431\u043E\u0442\u0430"
    ]
};
const $23c10d9359963010$var$dayPeriodValues = {
    wide: {
        am: "\u043F\u0440\u0435\u0434\u0438 \u043E\u0431\u044F\u0434",
        pm: "\u0441\u043B\u0435\u0434 \u043E\u0431\u044F\u0434",
        midnight: "\u0432 \u043F\u043E\u043B\u0443\u043D\u043E\u0449",
        noon: "\u043D\u0430 \u043E\u0431\u044F\u0434",
        morning: "\u0441\u0443\u0442\u0440\u0438\u043D\u0442\u0430",
        afternoon: "\u0441\u043B\u0435\u0434\u043E\u0431\u0435\u0434",
        evening: "\u0432\u0435\u0447\u0435\u0440\u0442\u0430",
        night: "\u043F\u0440\u0435\u0437 \u043D\u043E\u0449\u0442\u0430"
    }
};
function $23c10d9359963010$var$isFeminine(unit) {
    return unit === "year" || unit === "week" || unit === "minute" || unit === "second";
}
function $23c10d9359963010$var$isNeuter(unit) {
    return unit === "quarter";
}
function $23c10d9359963010$var$numberWithSuffix(number, unit, masculine, feminine, neuter) {
    const suffix = $23c10d9359963010$var$isNeuter(unit) ? neuter : $23c10d9359963010$var$isFeminine(unit) ? feminine : masculine;
    return number + "-" + suffix;
}
const $23c10d9359963010$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    const unit = options?.unit;
    if (number === 0) return $23c10d9359963010$var$numberWithSuffix(0, unit, "\u0435\u0432", "\u0435\u0432\u0430", "\u0435\u0432\u043E");
    else if (number % 1000 === 0) return $23c10d9359963010$var$numberWithSuffix(number, unit, "\u0435\u043D", "\u043D\u0430", "\u043D\u043E");
    else if (number % 100 === 0) return $23c10d9359963010$var$numberWithSuffix(number, unit, "\u0442\u0435\u043D", "\u0442\u043D\u0430", "\u0442\u043D\u043E");
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return $23c10d9359963010$var$numberWithSuffix(number, unit, "\u0432\u0438", "\u0432\u0430", "\u0432\u043E");
        case 2:
            return $23c10d9359963010$var$numberWithSuffix(number, unit, "\u0440\u0438", "\u0440\u0430", "\u0440\u043E");
        case 7:
        case 8:
            return $23c10d9359963010$var$numberWithSuffix(number, unit, "\u043C\u0438", "\u043C\u0430", "\u043C\u043E");
    }
    return $23c10d9359963010$var$numberWithSuffix(number, unit, "\u0442\u0438", "\u0442\u0430", "\u0442\u043E");
};
const $23c10d9359963010$var$localize = $23c10d9359963010$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $23c10d9359963010$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $23c10d9359963010$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $23c10d9359963010$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $23c10d9359963010$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $23c10d9359963010$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $23c10d9359963010$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};

});

parcelRegister("jiXXP", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $e0de365b49426449$export$4659b591c19bdf3d; }, function (v) { return $e0de365b49426449$export$4659b591c19bdf3d = v; });
var $e0de365b49426449$export$4659b591c19bdf3d;
"use strict";
$e0de365b49426449$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $e0de365b49426449$var$matchOrdinalNumberPattern = /^(\d+)(-?[врмт][аи]|-?т?(ен|на)|-?(ев|ева))?/i;
const $e0de365b49426449$var$parseOrdinalNumberPattern = /\d+/i;
const $e0de365b49426449$var$matchEraPatterns = {
    narrow: /^((пр)?н\.?\s?е\.?)/i,
    abbreviated: /^((пр)?н\.?\s?е\.?)/i,
    wide: /^(преди новата ера|новата ера|нова ера)/i
};
const $e0de365b49426449$var$parseEraPatterns = {
    any: [
        /^п/i,
        /^н/i
    ]
};
const $e0de365b49426449$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[врт]?o?)? тримес.?/i,
    wide: /^[1234](-?[врт]?о?)? тримесечие/i
};
const $e0de365b49426449$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $e0de365b49426449$var$matchDayPatterns = {
    narrow: /^[нпвсч]/i,
    short: /^(нд|пн|вт|ср|чт|пт|сб)/i,
    abbreviated: /^(нед|пон|вто|сря|чет|пет|съб)/i,
    wide: /^(неделя|понеделник|вторник|сряда|четвъртък|петък|събота)/i
};
const $e0de365b49426449$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н[ед]/i,
        /^п[он]/i,
        /^вт/i,
        /^ср/i,
        /^ч[ет]/i,
        /^п[ет]/i,
        /^с[ъб]/i
    ]
};
const $e0de365b49426449$var$matchMonthPatterns = {
    abbreviated: /^(яну|фев|мар|апр|май|юни|юли|авг|сеп|окт|ное|дек)/i,
    wide: /^(януари|февруари|март|април|май|юни|юли|август|септември|октомври|ноември|декември)/i
};
const $e0de365b49426449$var$parseMonthPatterns = {
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^май/i,
        /^юн/i,
        /^юл/i,
        /^ав/i,
        /^се/i,
        /^окт/i,
        /^но/i,
        /^де/i
    ]
};
const $e0de365b49426449$var$matchDayPeriodPatterns = {
    any: /^(преди о|след о|в по|на о|през|веч|сут|следо)/i
};
const $e0de365b49426449$var$parseDayPeriodPatterns = {
    any: {
        am: /^преди о/i,
        pm: /^след о/i,
        midnight: /^в пол/i,
        noon: /^на об/i,
        morning: /^сут/i,
        afternoon: /^следо/i,
        evening: /^веч/i,
        night: /^през н/i
    }
};
const $e0de365b49426449$var$match = $e0de365b49426449$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $e0de365b49426449$var$matchOrdinalNumberPattern,
        parsePattern: $e0de365b49426449$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e0de365b49426449$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e0de365b49426449$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e0de365b49426449$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e0de365b49426449$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e0de365b49426449$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e0de365b49426449$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e0de365b49426449$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e0de365b49426449$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e0de365b49426449$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $e0de365b49426449$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("7P3UA", function(module, exports) {

$parcel$export(module.exports, "bn", function () { return $5b2054a01bb40282$export$acf3ba20e47771d; }, function (v) { return $5b2054a01bb40282$export$acf3ba20e47771d = v; });
var $5b2054a01bb40282$export$acf3ba20e47771d;
"use strict";
$5b2054a01bb40282$export$acf3ba20e47771d = void 0;

var $lrCzN = parcelRequire("lrCzN");

var $cGNNh = parcelRequire("cGNNh");

var $gZ1cj = parcelRequire("gZ1cj");

var $9Oj6Y = parcelRequire("9Oj6Y");

var $51FaJ = parcelRequire("51FaJ");
/**
 * @category Locales
 * @summary Bengali locale.
 * @language Bengali
 * @iso-639-2 ben
 * @author Touhidur Rahman [@touhidrahman](https://github.com/touhidrahman)
 * @author Farhad Yasir [@nutboltu](https://github.com/nutboltu)
 */ const $5b2054a01bb40282$var$bn = $5b2054a01bb40282$export$acf3ba20e47771d = {
    code: "bn",
    formatDistance: $lrCzN.formatDistance,
    formatLong: $cGNNh.formatLong,
    formatRelative: $gZ1cj.formatRelative,
    localize: $9Oj6Y.localize,
    match: $51FaJ.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("lrCzN", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $f9ca0b0cd3df4795$export$2c14ff85d6318973; }, function (v) { return $f9ca0b0cd3df4795$export$2c14ff85d6318973 = v; });
var $f9ca0b0cd3df4795$export$2c14ff85d6318973;
"use strict";
$f9ca0b0cd3df4795$export$2c14ff85d6318973 = void 0;

var $9Oj6Y = parcelRequire("9Oj6Y");
const $f9ca0b0cd3df4795$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1"
    },
    xSeconds: {
        one: "\u09E7 \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
        other: "{{count}} \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1"
    },
    halfAMinute: "\u0986\u09A7 \u09AE\u09BF\u09A8\u09BF\u099F",
    lessThanXMinutes: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AE\u09BF\u09A8\u09BF\u099F",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AE\u09BF\u09A8\u09BF\u099F"
    },
    xMinutes: {
        one: "\u09E7 \u09AE\u09BF\u09A8\u09BF\u099F",
        other: "{{count}} \u09AE\u09BF\u09A8\u09BF\u099F"
    },
    aboutXHours: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u0998\u09A8\u09CD\u099F\u09BE",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u0998\u09A8\u09CD\u099F\u09BE"
    },
    xHours: {
        one: "\u09E7 \u0998\u09A8\u09CD\u099F\u09BE",
        other: "{{count}} \u0998\u09A8\u09CD\u099F\u09BE"
    },
    xDays: {
        one: "\u09E7 \u09A6\u09BF\u09A8",
        other: "{{count}} \u09A6\u09BF\u09A8"
    },
    aboutXWeeks: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9"
    },
    xWeeks: {
        one: "\u09E7 \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9",
        other: "{{count}} \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9"
    },
    aboutXMonths: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AE\u09BE\u09B8",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AE\u09BE\u09B8"
    },
    xMonths: {
        one: "\u09E7 \u09AE\u09BE\u09B8",
        other: "{{count}} \u09AE\u09BE\u09B8"
    },
    aboutXYears: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AC\u099B\u09B0",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AC\u099B\u09B0"
    },
    xYears: {
        one: "\u09E7 \u09AC\u099B\u09B0",
        other: "{{count}} \u09AC\u099B\u09B0"
    },
    overXYears: {
        one: "\u09E7 \u09AC\u099B\u09B0\u09C7\u09B0 \u09AC\u09C7\u09B6\u09BF",
        other: "{{count}} \u09AC\u099B\u09B0\u09C7\u09B0 \u09AC\u09C7\u09B6\u09BF"
    },
    almostXYears: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AC\u099B\u09B0",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AC\u099B\u09B0"
    }
};
const $f9ca0b0cd3df4795$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $f9ca0b0cd3df4795$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", (0, $9Oj6Y.numberToLocale)(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " \u098F\u09B0 \u09AE\u09A7\u09CD\u09AF\u09C7";
        else return result + " \u0986\u0997\u09C7";
    }
    return result;
};
$f9ca0b0cd3df4795$export$2c14ff85d6318973 = $f9ca0b0cd3df4795$var$formatDistance;

});
parcelRegister("9Oj6Y", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $72479bb86b17c7f9$export$b3bd0bc58e36cd63; }, function (v) { return $72479bb86b17c7f9$export$b3bd0bc58e36cd63 = v; });
$parcel$export(module.exports, "numberToLocale", function () { return $72479bb86b17c7f9$export$3e1d599946644f03; }, function (v) { return $72479bb86b17c7f9$export$3e1d599946644f03 = v; });
var $72479bb86b17c7f9$export$b3bd0bc58e36cd63;
var $72479bb86b17c7f9$export$3e1d599946644f03;
"use strict";
$72479bb86b17c7f9$export$b3bd0bc58e36cd63 = void 0;
$72479bb86b17c7f9$export$3e1d599946644f03 = $72479bb86b17c7f9$var$numberToLocale;

var $4Zr7l = parcelRequire("4Zr7l");
const $72479bb86b17c7f9$var$numberValues = {
    locale: {
        1: "\u09E7",
        2: "\u09E8",
        3: "\u09E9",
        4: "\u09EA",
        5: "\u09EB",
        6: "\u09EC",
        7: "\u09ED",
        8: "\u09EE",
        9: "\u09EF",
        0: "\u09E6"
    },
    number: {
        "\u09E7": "1",
        "\u09E8": "2",
        "\u09E9": "3",
        "\u09EA": "4",
        "\u09EB": "5",
        "\u09EC": "6",
        "\u09ED": "7",
        "\u09EE": "8",
        "\u09EF": "9",
        "\u09E6": "0"
    }
};
const $72479bb86b17c7f9$var$eraValues = {
    narrow: [
        "\u0996\u09CD\u09B0\u09BF\u0983\u09AA\u09C2\u0983",
        "\u0996\u09CD\u09B0\u09BF\u0983"
    ],
    abbreviated: [
        "\u0996\u09CD\u09B0\u09BF\u0983\u09AA\u09C2\u09B0\u09CD\u09AC",
        "\u0996\u09CD\u09B0\u09BF\u0983"
    ],
    wide: [
        "\u0996\u09CD\u09B0\u09BF\u09B8\u09CD\u099F\u09AA\u09C2\u09B0\u09CD\u09AC",
        "\u0996\u09CD\u09B0\u09BF\u09B8\u09CD\u099F\u09BE\u09AC\u09CD\u09A6"
    ]
};
const $72479bb86b17c7f9$var$quarterValues = {
    narrow: [
        "\u09E7",
        "\u09E8",
        "\u09E9",
        "\u09EA"
    ],
    abbreviated: [
        "\u09E7\u09A4\u09CD\u09B0\u09C8",
        "\u09E8\u09A4\u09CD\u09B0\u09C8",
        "\u09E9\u09A4\u09CD\u09B0\u09C8",
        "\u09EA\u09A4\u09CD\u09B0\u09C8"
    ],
    wide: [
        "\u09E7\u09AE \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995",
        "\u09E8\u09DF \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995",
        "\u09E9\u09DF \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995",
        "\u09EA\u09B0\u09CD\u09A5 \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995"
    ]
};
const $72479bb86b17c7f9$var$monthValues = {
    narrow: [
        "\u099C\u09BE\u09A8\u09C1",
        "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1",
        "\u09AE\u09BE\u09B0\u09CD\u099A",
        "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
        "\u09AE\u09C7",
        "\u099C\u09C1\u09A8",
        "\u099C\u09C1\u09B2\u09BE\u0987",
        "\u0986\u0997\u09B8\u09CD\u099F",
        "\u09B8\u09C7\u09AA\u09CD\u099F",
        "\u0985\u0995\u09CD\u099F\u09CB",
        "\u09A8\u09AD\u09C7",
        "\u09A1\u09BF\u09B8\u09C7"
    ],
    abbreviated: [
        "\u099C\u09BE\u09A8\u09C1",
        "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1",
        "\u09AE\u09BE\u09B0\u09CD\u099A",
        "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
        "\u09AE\u09C7",
        "\u099C\u09C1\u09A8",
        "\u099C\u09C1\u09B2\u09BE\u0987",
        "\u0986\u0997\u09B8\u09CD\u099F",
        "\u09B8\u09C7\u09AA\u09CD\u099F",
        "\u0985\u0995\u09CD\u099F\u09CB",
        "\u09A8\u09AD\u09C7",
        "\u09A1\u09BF\u09B8\u09C7"
    ],
    wide: [
        "\u099C\u09BE\u09A8\u09C1\u09DF\u09BE\u09B0\u09BF",
        "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1\u09DF\u09BE\u09B0\u09BF",
        "\u09AE\u09BE\u09B0\u09CD\u099A",
        "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
        "\u09AE\u09C7",
        "\u099C\u09C1\u09A8",
        "\u099C\u09C1\u09B2\u09BE\u0987",
        "\u0986\u0997\u09B8\u09CD\u099F",
        "\u09B8\u09C7\u09AA\u09CD\u099F\u09C7\u09AE\u09CD\u09AC\u09B0",
        "\u0985\u0995\u09CD\u099F\u09CB\u09AC\u09B0",
        "\u09A8\u09AD\u09C7\u09AE\u09CD\u09AC\u09B0",
        "\u09A1\u09BF\u09B8\u09C7\u09AE\u09CD\u09AC\u09B0"
    ]
};
const $72479bb86b17c7f9$var$dayValues = {
    narrow: [
        "\u09B0",
        "\u09B8\u09CB",
        "\u09AE",
        "\u09AC\u09C1",
        "\u09AC\u09C3",
        "\u09B6\u09C1",
        "\u09B6"
    ],
    short: [
        "\u09B0\u09AC\u09BF",
        "\u09B8\u09CB\u09AE",
        "\u09AE\u0999\u09CD\u0997\u09B2",
        "\u09AC\u09C1\u09A7",
        "\u09AC\u09C3\u09B9",
        "\u09B6\u09C1\u0995\u09CD\u09B0",
        "\u09B6\u09A8\u09BF"
    ],
    abbreviated: [
        "\u09B0\u09AC\u09BF",
        "\u09B8\u09CB\u09AE",
        "\u09AE\u0999\u09CD\u0997\u09B2",
        "\u09AC\u09C1\u09A7",
        "\u09AC\u09C3\u09B9",
        "\u09B6\u09C1\u0995\u09CD\u09B0",
        "\u09B6\u09A8\u09BF"
    ],
    wide: [
        "\u09B0\u09AC\u09BF\u09AC\u09BE\u09B0",
        "\u09B8\u09CB\u09AE\u09AC\u09BE\u09B0",
        "\u09AE\u0999\u09CD\u0997\u09B2\u09AC\u09BE\u09B0",
        "\u09AC\u09C1\u09A7\u09AC\u09BE\u09B0",
        "\u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF\u09AC\u09BE\u09B0 ",
        "\u09B6\u09C1\u0995\u09CD\u09B0\u09AC\u09BE\u09B0",
        "\u09B6\u09A8\u09BF\u09AC\u09BE\u09B0"
    ]
};
const $72479bb86b17c7f9$var$dayPeriodValues = {
    narrow: {
        am: "\u09AA\u09C2",
        pm: "\u0985\u09AA",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    abbreviated: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    wide: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    }
};
const $72479bb86b17c7f9$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u09AA\u09C2",
        pm: "\u0985\u09AA",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    abbreviated: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    wide: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    }
};
function $72479bb86b17c7f9$var$dateOrdinalNumber(number, localeNumber) {
    if (number > 18 && number <= 31) return localeNumber + "\u09B6\u09C7";
    else switch(number){
        case 1:
            return localeNumber + "\u09B2\u09BE";
        case 2:
        case 3:
            return localeNumber + "\u09B0\u09BE";
        case 4:
            return localeNumber + "\u09A0\u09BE";
        default:
            return localeNumber + "\u0987";
    }
}
const $72479bb86b17c7f9$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    const localeNumber = $72479bb86b17c7f9$var$numberToLocale(number);
    const unit = options?.unit;
    if (unit === "date") return $72479bb86b17c7f9$var$dateOrdinalNumber(number, localeNumber);
    if (number > 10 || number === 0) return localeNumber + "\u09A4\u09AE";
    const rem10 = number % 10;
    switch(rem10){
        case 2:
        case 3:
            return localeNumber + "\u09DF";
        case 4:
            return localeNumber + "\u09B0\u09CD\u09A5";
        case 6:
            return localeNumber + "\u09B7\u09CD\u09A0";
        default:
            return localeNumber + "\u09AE";
    }
};
// function localeToNumber(locale: string): number {
//   const enNumber = locale.toString().replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
//     return numberValues.number[match as keyof typeof numberValues.number]
//   })
//   return Number(enNumber)
// }
function $72479bb86b17c7f9$var$numberToLocale(enNumber) {
    return enNumber.toString().replace(/\d/g, function(match) {
        return $72479bb86b17c7f9$var$numberValues.locale[match];
    });
}
const $72479bb86b17c7f9$var$localize = $72479bb86b17c7f9$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $72479bb86b17c7f9$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $72479bb86b17c7f9$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $72479bb86b17c7f9$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $72479bb86b17c7f9$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $72479bb86b17c7f9$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $72479bb86b17c7f9$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $72479bb86b17c7f9$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});


parcelRegister("cGNNh", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $93d0085066285150$export$cbf60ecb96cbb82f; }, function (v) { return $93d0085066285150$export$cbf60ecb96cbb82f = v; });
var $93d0085066285150$export$cbf60ecb96cbb82f;
"use strict";
$93d0085066285150$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $93d0085066285150$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $93d0085066285150$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $93d0085066285150$var$dateTimeFormats = {
    full: "{{date}} {{time}} '\u09B8\u09AE\u09DF'",
    long: "{{date}} {{time}} '\u09B8\u09AE\u09DF'",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $93d0085066285150$var$formatLong = $93d0085066285150$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $93d0085066285150$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $93d0085066285150$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $93d0085066285150$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("gZ1cj", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $c5d345afaf45f095$export$8fbbfd65594f46a0; }, function (v) { return $c5d345afaf45f095$export$8fbbfd65594f46a0 = v; });
var $c5d345afaf45f095$export$8fbbfd65594f46a0;
"use strict";
$c5d345afaf45f095$export$8fbbfd65594f46a0 = void 0;
const $c5d345afaf45f095$var$formatRelativeLocale = {
    lastWeek: "'\u0997\u09A4' eeee '\u09B8\u09AE\u09DF' p",
    yesterday: "'\u0997\u09A4\u0995\u09BE\u09B2' '\u09B8\u09AE\u09DF' p",
    today: "'\u0986\u099C' '\u09B8\u09AE\u09DF' p",
    tomorrow: "'\u0986\u0997\u09BE\u09AE\u09C0\u0995\u09BE\u09B2' '\u09B8\u09AE\u09DF' p",
    nextWeek: "eeee '\u09B8\u09AE\u09DF' p",
    other: "P"
};
const $c5d345afaf45f095$var$formatRelative = (token, _date, _baseDate, _options)=>$c5d345afaf45f095$var$formatRelativeLocale[token];
$c5d345afaf45f095$export$8fbbfd65594f46a0 = $c5d345afaf45f095$var$formatRelative;

});

parcelRegister("51FaJ", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $3a8cfba43ce4fd2d$export$4659b591c19bdf3d; }, function (v) { return $3a8cfba43ce4fd2d$export$4659b591c19bdf3d = v; });
var $3a8cfba43ce4fd2d$export$4659b591c19bdf3d;
"use strict";
$3a8cfba43ce4fd2d$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $3a8cfba43ce4fd2d$var$matchOrdinalNumberPattern = /^(\d+)(ম|য়|র্থ|ষ্ঠ|শে|ই|তম)?/i;
const $3a8cfba43ce4fd2d$var$parseOrdinalNumberPattern = /\d+/i;
const $3a8cfba43ce4fd2d$var$matchEraPatterns = {
    narrow: /^(খ্রিঃপূঃ|খ্রিঃ)/i,
    abbreviated: /^(খ্রিঃপূর্ব|খ্রিঃ)/i,
    wide: /^(খ্রিস্টপূর্ব|খ্রিস্টাব্দ)/i
};
const $3a8cfba43ce4fd2d$var$parseEraPatterns = {
    narrow: [
        /^খ্রিঃপূঃ/i,
        /^খ্রিঃ/i
    ],
    abbreviated: [
        /^খ্রিঃপূর্ব/i,
        /^খ্রিঃ/i
    ],
    wide: [
        /^খ্রিস্টপূর্ব/i,
        /^খ্রিস্টাব্দ/i
    ]
};
const $3a8cfba43ce4fd2d$var$matchQuarterPatterns = {
    narrow: /^[১২৩৪]/i,
    abbreviated: /^[১২৩৪]ত্রৈ/i,
    wide: /^[১২৩৪](ম|য়|র্থ)? ত্রৈমাসিক/i
};
const $3a8cfba43ce4fd2d$var$parseQuarterPatterns = {
    any: [
        /১/i,
        /২/i,
        /৩/i,
        /৪/i
    ]
};
const $3a8cfba43ce4fd2d$var$matchMonthPatterns = {
    narrow: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
    abbreviated: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
    wide: /^(জানুয়ারি|ফেব্রুয়ারি|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্টেম্বর|অক্টোবর|নভেম্বর|ডিসেম্বর)/i
};
const $3a8cfba43ce4fd2d$var$parseMonthPatterns = {
    any: [
        /^জানু/i,
        /^ফেব্রু/i,
        /^মার্চ/i,
        /^এপ্রিল/i,
        /^মে/i,
        /^জুন/i,
        /^জুলাই/i,
        /^আগস্ট/i,
        /^সেপ্ট/i,
        /^অক্টো/i,
        /^নভে/i,
        /^ডিসে/i
    ]
};
const $3a8cfba43ce4fd2d$var$matchDayPatterns = {
    narrow: /^(র|সো|ম|বু|বৃ|শু|শ)+/i,
    short: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
    abbreviated: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
    wide: /^(রবিবার|সোমবার|মঙ্গলবার|বুধবার|বৃহস্পতিবার |শুক্রবার|শনিবার)+/i
};
const $3a8cfba43ce4fd2d$var$parseDayPatterns = {
    narrow: [
        /^র/i,
        /^সো/i,
        /^ম/i,
        /^বু/i,
        /^বৃ/i,
        /^শু/i,
        /^শ/i
    ],
    short: [
        /^রবি/i,
        /^সোম/i,
        /^মঙ্গল/i,
        /^বুধ/i,
        /^বৃহ/i,
        /^শুক্র/i,
        /^শনি/i
    ],
    abbreviated: [
        /^রবি/i,
        /^সোম/i,
        /^মঙ্গল/i,
        /^বুধ/i,
        /^বৃহ/i,
        /^শুক্র/i,
        /^শনি/i
    ],
    wide: [
        /^রবিবার/i,
        /^সোমবার/i,
        /^মঙ্গলবার/i,
        /^বুধবার/i,
        /^বৃহস্পতিবার /i,
        /^শুক্রবার/i,
        /^শনিবার/i
    ]
};
const $3a8cfba43ce4fd2d$var$matchDayPeriodPatterns = {
    narrow: /^(পূ|অপ|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
    abbreviated: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
    wide: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i
};
const $3a8cfba43ce4fd2d$var$parseDayPeriodPatterns = {
    any: {
        am: /^পূ/i,
        pm: /^অপ/i,
        midnight: /^মধ্যরাত/i,
        noon: /^মধ্যাহ্ন/i,
        morning: /সকাল/i,
        afternoon: /বিকাল/i,
        evening: /সন্ধ্যা/i,
        night: /রাত/i
    }
};
const $3a8cfba43ce4fd2d$var$match = $3a8cfba43ce4fd2d$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $3a8cfba43ce4fd2d$var$matchOrdinalNumberPattern,
        parsePattern: $3a8cfba43ce4fd2d$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $3a8cfba43ce4fd2d$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3a8cfba43ce4fd2d$var$parseEraPatterns,
        defaultParseWidth: "wide"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $3a8cfba43ce4fd2d$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3a8cfba43ce4fd2d$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $3a8cfba43ce4fd2d$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3a8cfba43ce4fd2d$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $3a8cfba43ce4fd2d$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3a8cfba43ce4fd2d$var$parseDayPatterns,
        defaultParseWidth: "wide"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $3a8cfba43ce4fd2d$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3a8cfba43ce4fd2d$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("eiUuc", function(module, exports) {

$parcel$export(module.exports, "bs", function () { return $a69e901a5a72e5c3$export$4e222d082f82ee97; }, function (v) { return $a69e901a5a72e5c3$export$4e222d082f82ee97 = v; });
var $a69e901a5a72e5c3$export$4e222d082f82ee97;
"use strict";
$a69e901a5a72e5c3$export$4e222d082f82ee97 = void 0;

var $5T8cr = parcelRequire("5T8cr");

var $2D2eW = parcelRequire("2D2eW");

var $jwVhj = parcelRequire("jwVhj");

var $iOYVc = parcelRequire("iOYVc");

var $acUMj = parcelRequire("acUMj");
/**
 * @category Locales
 * @summary Bosnian locale.
 * @language Bosnian
 * @iso-639-2 bos
 * @author Branislav Lazić [@branislavlazic](https://github.com/branislavlazic)
 */ const $a69e901a5a72e5c3$var$bs = $a69e901a5a72e5c3$export$4e222d082f82ee97 = {
    code: "bs",
    formatDistance: $5T8cr.formatDistance,
    formatLong: $2D2eW.formatLong,
    formatRelative: $jwVhj.formatRelative,
    localize: $iOYVc.localize,
    match: $acUMj.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("5T8cr", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $4498731ce714234f$export$2c14ff85d6318973; }, function (v) { return $4498731ce714234f$export$2c14ff85d6318973 = v; });
var $4498731ce714234f$export$2c14ff85d6318973;
"use strict";
$4498731ce714234f$export$2c14ff85d6318973 = void 0;
const $4498731ce714234f$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: "manje od 1 sekunde",
            withPrepositionAgo: "manje od 1 sekunde",
            withPrepositionIn: "manje od 1 sekundu"
        },
        dual: "manje od {{count}} sekunde",
        other: "manje od {{count}} sekundi"
    },
    xSeconds: {
        one: {
            standalone: "1 sekunda",
            withPrepositionAgo: "1 sekunde",
            withPrepositionIn: "1 sekundu"
        },
        dual: "{{count}} sekunde",
        other: "{{count}} sekundi"
    },
    halfAMinute: "pola minute",
    lessThanXMinutes: {
        one: {
            standalone: "manje od 1 minute",
            withPrepositionAgo: "manje od 1 minute",
            withPrepositionIn: "manje od 1 minutu"
        },
        dual: "manje od {{count}} minute",
        other: "manje od {{count}} minuta"
    },
    xMinutes: {
        one: {
            standalone: "1 minuta",
            withPrepositionAgo: "1 minute",
            withPrepositionIn: "1 minutu"
        },
        dual: "{{count}} minute",
        other: "{{count}} minuta"
    },
    aboutXHours: {
        one: {
            standalone: "oko 1 sat",
            withPrepositionAgo: "oko 1 sat",
            withPrepositionIn: "oko 1 sat"
        },
        dual: "oko {{count}} sata",
        other: "oko {{count}} sati"
    },
    xHours: {
        one: {
            standalone: "1 sat",
            withPrepositionAgo: "1 sat",
            withPrepositionIn: "1 sat"
        },
        dual: "{{count}} sata",
        other: "{{count}} sati"
    },
    xDays: {
        one: {
            standalone: "1 dan",
            withPrepositionAgo: "1 dan",
            withPrepositionIn: "1 dan"
        },
        dual: "{{count}} dana",
        other: "{{count}} dana"
    },
    aboutXWeeks: {
        one: {
            standalone: "oko 1 sedmicu",
            withPrepositionAgo: "oko 1 sedmicu",
            withPrepositionIn: "oko 1 sedmicu"
        },
        dual: "oko {{count}} sedmice",
        other: "oko {{count}} sedmice"
    },
    xWeeks: {
        one: {
            standalone: "1 sedmicu",
            withPrepositionAgo: "1 sedmicu",
            withPrepositionIn: "1 sedmicu"
        },
        dual: "{{count}} sedmice",
        other: "{{count}} sedmice"
    },
    aboutXMonths: {
        one: {
            standalone: "oko 1 mjesec",
            withPrepositionAgo: "oko 1 mjesec",
            withPrepositionIn: "oko 1 mjesec"
        },
        dual: "oko {{count}} mjeseca",
        other: "oko {{count}} mjeseci"
    },
    xMonths: {
        one: {
            standalone: "1 mjesec",
            withPrepositionAgo: "1 mjesec",
            withPrepositionIn: "1 mjesec"
        },
        dual: "{{count}} mjeseca",
        other: "{{count}} mjeseci"
    },
    aboutXYears: {
        one: {
            standalone: "oko 1 godinu",
            withPrepositionAgo: "oko 1 godinu",
            withPrepositionIn: "oko 1 godinu"
        },
        dual: "oko {{count}} godine",
        other: "oko {{count}} godina"
    },
    xYears: {
        one: {
            standalone: "1 godina",
            withPrepositionAgo: "1 godine",
            withPrepositionIn: "1 godinu"
        },
        dual: "{{count}} godine",
        other: "{{count}} godina"
    },
    overXYears: {
        one: {
            standalone: "preko 1 godinu",
            withPrepositionAgo: "preko 1 godinu",
            withPrepositionIn: "preko 1 godinu"
        },
        dual: "preko {{count}} godine",
        other: "preko {{count}} godina"
    },
    almostXYears: {
        one: {
            standalone: "gotovo 1 godinu",
            withPrepositionAgo: "gotovo 1 godinu",
            withPrepositionIn: "gotovo 1 godinu"
        },
        dual: "gotovo {{count}} godine",
        other: "gotovo {{count}} godina"
    }
};
const $4498731ce714234f$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $4498731ce714234f$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) {
        if (options?.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== "1" // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "za " + result;
        else return "prije " + result;
    }
    return result;
};
$4498731ce714234f$export$2c14ff85d6318973 = $4498731ce714234f$var$formatDistance;

});

parcelRegister("2D2eW", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $1ea0f6197d5a9a61$export$cbf60ecb96cbb82f; }, function (v) { return $1ea0f6197d5a9a61$export$cbf60ecb96cbb82f = v; });
var $1ea0f6197d5a9a61$export$cbf60ecb96cbb82f;
"use strict";
$1ea0f6197d5a9a61$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $1ea0f6197d5a9a61$var$dateFormats = {
    full: "EEEE, d. MMMM yyyy.",
    long: "d. MMMM yyyy.",
    medium: "d. MMM yy.",
    short: "dd. MM. yy."
};
const $1ea0f6197d5a9a61$var$timeFormats = {
    full: "HH:mm:ss (zzzz)",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $1ea0f6197d5a9a61$var$dateTimeFormats = {
    full: "{{date}} 'u' {{time}}",
    long: "{{date}} 'u' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $1ea0f6197d5a9a61$var$formatLong = $1ea0f6197d5a9a61$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $1ea0f6197d5a9a61$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $1ea0f6197d5a9a61$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $1ea0f6197d5a9a61$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("jwVhj", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $e37d6fbae5e13154$export$8fbbfd65594f46a0; }, function (v) { return $e37d6fbae5e13154$export$8fbbfd65594f46a0 = v; });
var $e37d6fbae5e13154$export$8fbbfd65594f46a0;
"use strict";
$e37d6fbae5e13154$export$8fbbfd65594f46a0 = void 0;
const $e37d6fbae5e13154$var$formatRelativeLocale = {
    lastWeek: (date)=>{
        switch(date.getDay()){
            case 0:
                return "'pro\u0161le nedjelje u' p";
            case 3:
                return "'pro\u0161le srijede u' p";
            case 6:
                return "'pro\u0161le subote u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    yesterday: "'ju\u010De u' p",
    today: "'danas u' p",
    tomorrow: "'sutra u' p",
    nextWeek: (date)=>{
        switch(date.getDay()){
            case 0:
                return "'sljede\u0107e nedjelje u' p";
            case 3:
                return "'sljede\u0107u srijedu u' p";
            case 6:
                return "'sljede\u0107u subotu u' p";
            default:
                return "'sljede\u0107i' EEEE 'u' p";
        }
    },
    other: "P"
};
const $e37d6fbae5e13154$var$formatRelative = (token, date, _baseDate, _options)=>{
    const format = $e37d6fbae5e13154$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
$e37d6fbae5e13154$export$8fbbfd65594f46a0 = $e37d6fbae5e13154$var$formatRelative;

});

parcelRegister("iOYVc", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $db3c27425f69ace7$export$b3bd0bc58e36cd63; }, function (v) { return $db3c27425f69ace7$export$b3bd0bc58e36cd63 = v; });
var $db3c27425f69ace7$export$b3bd0bc58e36cd63;
"use strict";
$db3c27425f69ace7$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $db3c27425f69ace7$var$eraValues = {
    narrow: [
        "pr.n.e.",
        "AD"
    ],
    abbreviated: [
        "pr. Hr.",
        "po. Hr."
    ],
    wide: [
        "Prije Hrista",
        "Poslije Hrista"
    ]
};
const $db3c27425f69ace7$var$quarterValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4."
    ],
    abbreviated: [
        "1. kv.",
        "2. kv.",
        "3. kv.",
        "4. kv."
    ],
    wide: [
        "1. kvartal",
        "2. kvartal",
        "3. kvartal",
        "4. kvartal"
    ]
};
const $db3c27425f69ace7$var$monthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "jan",
        "feb",
        "mar",
        "apr",
        "maj",
        "jun",
        "jul",
        "avg",
        "sep",
        "okt",
        "nov",
        "dec"
    ],
    wide: [
        "januar",
        "februar",
        "mart",
        "april",
        "maj",
        "juni",
        "juli",
        "avgust",
        "septembar",
        "oktobar",
        "novembar",
        "decembar"
    ]
};
const $db3c27425f69ace7$var$formattingMonthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "jan",
        "feb",
        "mar",
        "apr",
        "maj",
        "jun",
        "jul",
        "avg",
        "sep",
        "okt",
        "nov",
        "dec"
    ],
    wide: [
        "januar",
        "februar",
        "mart",
        "april",
        "maj",
        "juni",
        "juli",
        "avgust",
        "septembar",
        "oktobar",
        "novembar",
        "decembar"
    ]
};
const $db3c27425f69ace7$var$dayValues = {
    narrow: [
        "N",
        "P",
        "U",
        "S",
        "\u010C",
        "P",
        "S"
    ],
    short: [
        "ned",
        "pon",
        "uto",
        "sre",
        "\u010Det",
        "pet",
        "sub"
    ],
    abbreviated: [
        "ned",
        "pon",
        "uto",
        "sre",
        "\u010Det",
        "pet",
        "sub"
    ],
    wide: [
        "nedjelja",
        "ponedjeljak",
        "utorak",
        "srijeda",
        "\u010Detvrtak",
        "petak",
        "subota"
    ]
};
const $db3c27425f69ace7$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "poslije podne",
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
const $db3c27425f69ace7$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "poslije podne",
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
const $db3c27425f69ace7$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return String(number) + ".";
};
const $db3c27425f69ace7$var$localize = $db3c27425f69ace7$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $db3c27425f69ace7$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $db3c27425f69ace7$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $db3c27425f69ace7$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $db3c27425f69ace7$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $db3c27425f69ace7$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $db3c27425f69ace7$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $db3c27425f69ace7$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $db3c27425f69ace7$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("acUMj", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $76e7115aff3d30ad$export$4659b591c19bdf3d; }, function (v) { return $76e7115aff3d30ad$export$4659b591c19bdf3d = v; });
var $76e7115aff3d30ad$export$4659b591c19bdf3d;
"use strict";
$76e7115aff3d30ad$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $76e7115aff3d30ad$var$matchOrdinalNumberPattern = /^(\d+)\./i;
const $76e7115aff3d30ad$var$parseOrdinalNumberPattern = /\d+/i;
const $76e7115aff3d30ad$var$matchEraPatterns = {
    narrow: /^(pr\.n\.e\.|AD)/i,
    abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
    wide: /^(Prije Hrista|prije nove ere|Poslije Hrista|nova era)/i
};
const $76e7115aff3d30ad$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|nova)/i
    ]
};
const $76e7115aff3d30ad$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?kv\.?/i,
    wide: /^[1234]\. kvartal/i
};
const $76e7115aff3d30ad$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $76e7115aff3d30ad$var$matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
    wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(juni|juna)|(juli|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
};
const $76e7115aff3d30ad$var$parseMonthPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^avg/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $76e7115aff3d30ad$var$matchDayPatterns = {
    narrow: /^[npusčc]/i,
    short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
};
const $76e7115aff3d30ad$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $76e7115aff3d30ad$var$matchDayPeriodPatterns = {
    any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|poslije podne|ujutru)/i
};
const $76e7115aff3d30ad$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(poslije\s|po)+podne/i,
        evening: /(uvece|uveče)/i,
        night: /(nocu|noću)/i
    }
};
const $76e7115aff3d30ad$var$match = $76e7115aff3d30ad$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $76e7115aff3d30ad$var$matchOrdinalNumberPattern,
        parsePattern: $76e7115aff3d30ad$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $76e7115aff3d30ad$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $76e7115aff3d30ad$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $76e7115aff3d30ad$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $76e7115aff3d30ad$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $76e7115aff3d30ad$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $76e7115aff3d30ad$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $76e7115aff3d30ad$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $76e7115aff3d30ad$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $76e7115aff3d30ad$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $76e7115aff3d30ad$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("50In8", function(module, exports) {

$parcel$export(module.exports, "ca", function () { return $3a5f5f3ae3df47a2$export$89e9012e902952b6; }, function (v) { return $3a5f5f3ae3df47a2$export$89e9012e902952b6 = v; });
var $3a5f5f3ae3df47a2$export$89e9012e902952b6;
"use strict";
$3a5f5f3ae3df47a2$export$89e9012e902952b6 = void 0;

var $fPETu = parcelRequire("fPETu");

var $86Zqn = parcelRequire("86Zqn");

var $9LGE1 = parcelRequire("9LGE1");

var $4Hd25 = parcelRequire("4Hd25");

var $ji1Uj = parcelRequire("ji1Uj");
/**
 * @category Locales
 * @summary Catalan locale.
 * @language Catalan
 * @iso-639-2 cat
 * @author Guillermo Grau [@guigrpa](https://github.com/guigrpa)
 * @author Alex Vizcaino [@avizcaino](https://github.com/avizcaino)
 */ const $3a5f5f3ae3df47a2$var$ca = $3a5f5f3ae3df47a2$export$89e9012e902952b6 = {
    code: "ca",
    formatDistance: $fPETu.formatDistance,
    formatLong: $86Zqn.formatLong,
    formatRelative: $9LGE1.formatRelative,
    localize: $4Hd25.localize,
    match: $ji1Uj.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("fPETu", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $b86b571fc68e1eec$export$2c14ff85d6318973; }, function (v) { return $b86b571fc68e1eec$export$2c14ff85d6318973 = v; });
var $b86b571fc68e1eec$export$2c14ff85d6318973;
"use strict";
$b86b571fc68e1eec$export$2c14ff85d6318973 = void 0;
/**
 * Davant de les xifres que es diuen amb vocal inicial, 1 i 11, s'apostrofen els articles el i la i la preposició de igual que si estiguessin escrits amb lletres.
 *    l'1 de juliol ('l'u')
 *    l'11 de novembre ('l'onze')
 *    l'11a clàusula del contracte ('l'onzena')
 *    la contractació d'11 jugadors ('d'onze')
 *    l'aval d'11.000 socis ('d'onze mil')
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=apostrofaci%25F3+davant+xifres&action=Principal&method=detall_completa&numPagina=1&idHit=11236&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=11236&titol=apostrofaci%F3%20davant%20de%20xifres%20%2F%20apostrofaci%F3%20davant%20de%201%20i%2011&numeroResultat=1&clickLink=detall&tipusCerca=cerca.normes
 */ const $b86b571fc68e1eec$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menys d'un segon",
        eleven: "menys d'onze segons",
        other: "menys de {{count}} segons"
    },
    xSeconds: {
        one: "1 segon",
        other: "{{count}} segons"
    },
    halfAMinute: "mig minut",
    lessThanXMinutes: {
        one: "menys d'un minut",
        eleven: "menys d'onze minuts",
        other: "menys de {{count}} minuts"
    },
    xMinutes: {
        one: "1 minut",
        other: "{{count}} minuts"
    },
    aboutXHours: {
        one: "aproximadament una hora",
        other: "aproximadament {{count}} hores"
    },
    xHours: {
        one: "1 hora",
        other: "{{count}} hores"
    },
    xDays: {
        one: "1 dia",
        other: "{{count}} dies"
    },
    aboutXWeeks: {
        one: "aproximadament una setmana",
        other: "aproximadament {{count}} setmanes"
    },
    xWeeks: {
        one: "1 setmana",
        other: "{{count}} setmanes"
    },
    aboutXMonths: {
        one: "aproximadament un mes",
        other: "aproximadament {{count}} mesos"
    },
    xMonths: {
        one: "1 mes",
        other: "{{count}} mesos"
    },
    aboutXYears: {
        one: "aproximadament un any",
        other: "aproximadament {{count}} anys"
    },
    xYears: {
        one: "1 any",
        other: "{{count}} anys"
    },
    overXYears: {
        one: "m\xe9s d'un any",
        eleven: "m\xe9s d'onze anys",
        other: "m\xe9s de {{count}} anys"
    },
    almostXYears: {
        one: "gaireb\xe9 un any",
        other: "gaireb\xe9 {{count}} anys"
    }
};
const $b86b571fc68e1eec$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $b86b571fc68e1eec$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 11 && tokenValue.eleven) result = tokenValue.eleven;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "en " + result;
        else return "fa " + result;
    }
    return result;
};
$b86b571fc68e1eec$export$2c14ff85d6318973 = $b86b571fc68e1eec$var$formatDistance;

});

parcelRegister("86Zqn", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $5e7e87e68a562c76$export$cbf60ecb96cbb82f; }, function (v) { return $5e7e87e68a562c76$export$cbf60ecb96cbb82f = v; });
var $5e7e87e68a562c76$export$cbf60ecb96cbb82f;
"use strict";
$5e7e87e68a562c76$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $5e7e87e68a562c76$var$dateFormats = {
    full: "EEEE, d 'de' MMMM y",
    long: "d 'de' MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
const $5e7e87e68a562c76$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $5e7e87e68a562c76$var$dateTimeFormats = {
    full: "{{date}} 'a les' {{time}}",
    long: "{{date}} 'a les' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $5e7e87e68a562c76$var$formatLong = $5e7e87e68a562c76$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $5e7e87e68a562c76$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $5e7e87e68a562c76$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $5e7e87e68a562c76$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("9LGE1", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $71c9952db2c0d7d8$export$8fbbfd65594f46a0; }, function (v) { return $71c9952db2c0d7d8$export$8fbbfd65594f46a0 = v; });
var $71c9952db2c0d7d8$export$8fbbfd65594f46a0;
"use strict";
$71c9952db2c0d7d8$export$8fbbfd65594f46a0 = void 0;
const $71c9952db2c0d7d8$var$formatRelativeLocale = {
    lastWeek: "'el' eeee 'passat a la' LT",
    yesterday: "'ahir a la' p",
    today: "'avui a la' p",
    tomorrow: "'dem\xe0 a la' p",
    nextWeek: "eeee 'a la' p",
    other: "P"
};
const $71c9952db2c0d7d8$var$formatRelativeLocalePlural = {
    lastWeek: "'el' eeee 'passat a les' p",
    yesterday: "'ahir a les' p",
    today: "'avui a les' p",
    tomorrow: "'dem\xe0 a les' p",
    nextWeek: "eeee 'a les' p",
    other: "P"
};
const $71c9952db2c0d7d8$var$formatRelative = (token, date, _baseDate, _options)=>{
    if (date.getHours() !== 1) return $71c9952db2c0d7d8$var$formatRelativeLocalePlural[token];
    return $71c9952db2c0d7d8$var$formatRelativeLocale[token];
};
$71c9952db2c0d7d8$export$8fbbfd65594f46a0 = $71c9952db2c0d7d8$var$formatRelative;

});

parcelRegister("4Hd25", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $36b5499b784802e7$export$b3bd0bc58e36cd63; }, function (v) { return $36b5499b784802e7$export$b3bd0bc58e36cd63 = v; });
var $36b5499b784802e7$export$b3bd0bc58e36cd63;
"use strict";
$36b5499b784802e7$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
/**
 * General information
 * Reference: https://aplicacions.llengua.gencat.cat
 * Reference: https://www.uoc.edu/portal/ca/servei-linguistic/convencions/abreviacions/simbols/simbols-habituals.html
 */ /**
 * Abans de Crist: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abans+de+crist&action=Principal&method=detall_completa&numPagina=1&idHit=6876&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=6876&titol=abans%20de%20Crist%20(abreviatura)%20/%20abans%20de%20Crist%20(sigla)&numeroResultat=1&clickLink=detall&tipusCerca=cerca.fitxes
 * Desprest de Crist: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=despr%E9s+de+crist&action=Principal&method=detall_completa&numPagina=1&idHit=6879&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=6879&titol=despr%E9s%20de%20Crist%20(sigla)%20/%20despr%E9s%20de%20Crist%20(abreviatura)&numeroResultat=1&clickLink=detall&tipusCerca=cerca.fitxes
 */ const $36b5499b784802e7$var$eraValues = {
    narrow: [
        "aC",
        "dC"
    ],
    abbreviated: [
        "a. de C.",
        "d. de C."
    ],
    wide: [
        "abans de Crist",
        "despr\xe9s de Crist"
    ]
};
const $36b5499b784802e7$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1r trimestre",
        "2n trimestre",
        "3r trimestre",
        "4t trimestre"
    ]
};
/**
 * Dins d'un text convé fer servir la forma sencera dels mesos, ja que sempre és més clar el mot sencer que l'abreviatura, encara que aquesta sigui força coneguda.
 * Cal reservar, doncs, les abreviatures per a les llistes o classificacions, els gràfics, les taules o quadres estadístics, els textos publicitaris, etc.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abreviacions+mesos&action=Principal&method=detall_completa&numPagina=1&idHit=8402&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=8402&titol=abreviatures%20dels%20mesos%20de%20l%27any&numeroResultat=5&clickLink=detall&tipusCerca=cerca.fitxes
 */ const $36b5499b784802e7$var$monthValues = {
    narrow: [
        "GN",
        "FB",
        "M\xc7",
        "AB",
        "MG",
        "JN",
        "JL",
        "AG",
        "ST",
        "OC",
        "NV",
        "DS"
    ],
    /**
   * Les abreviatures dels mesos de l'any es formen seguint una de les normes generals de formació d'abreviatures.
   * S'escriu la primera síl·laba i les consonants de la síl·laba següent anteriors a la primera vocal.
   * Els mesos de març, maig i juny no s'abreugen perquè són paraules d'una sola síl·laba.
   */ abbreviated: [
        "gen.",
        "febr.",
        "mar\xe7",
        "abr.",
        "maig",
        "juny",
        "jul.",
        "ag.",
        "set.",
        "oct.",
        "nov.",
        "des."
    ],
    wide: [
        "gener",
        "febrer",
        "mar\xe7",
        "abril",
        "maig",
        "juny",
        "juliol",
        "agost",
        "setembre",
        "octubre",
        "novembre",
        "desembre"
    ]
};
/**
 * Les abreviatures dels dies de la setmana comencen totes amb la lletra d.
 * Tot seguit porten la consonant següent a la i, excepte en el cas de dimarts, dimecres i diumenge, en què aquesta consonant és la m i, per tant, hi podria haver confusió.
 * Per evitar-ho, s'ha substituït la m per una t (en el cas de dimarts), una c (en el cas de dimecres) i una g (en el cas de diumenge), respectivament.
 *
 * Seguint la norma general d'ús de les abreviatures, les dels dies de la setmana sempre porten punt final.
 * Igualment, van amb la primera lletra en majúscula quan la paraula sencera també hi aniria.
 * En canvi, van amb la primera lletra en minúscula quan la inicial de la paraula sencera també hi aniria.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abreviatures+dies&action=Principal&method=detall_completa&numPagina=1&idHit=8387&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=8387&titol=abreviatures%20dels%20dies%20de%20la%20setmana&numeroResultat=1&clickLink=detall&tipusCerca=cerca.tot
 */ const $36b5499b784802e7$var$dayValues = {
    narrow: [
        "dg.",
        "dl.",
        "dt.",
        "dm.",
        "dj.",
        "dv.",
        "ds."
    ],
    short: [
        "dg.",
        "dl.",
        "dt.",
        "dm.",
        "dj.",
        "dv.",
        "ds."
    ],
    abbreviated: [
        "dg.",
        "dl.",
        "dt.",
        "dm.",
        "dj.",
        "dv.",
        "ds."
    ],
    wide: [
        "diumenge",
        "dilluns",
        "dimarts",
        "dimecres",
        "dijous",
        "divendres",
        "dissabte"
    ]
};
/**
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?action=Principal&method=detall&input_cercar=parts+del+dia&numPagina=1&database=FITXES_PUB&idFont=12801&idHit=12801&tipusFont=Fitxes+de+l%27Optimot&numeroResultat=1&databases_avansada=&categories_avansada=&clickLink=detall&titol=Nom+de+les+parts+del+dia&tematica=&tipusCerca=cerca.fitxes
 */ const $36b5499b784802e7$var$dayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "mitjanit",
        noon: "migdia",
        morning: "mat\xed",
        afternoon: "tarda",
        evening: "vespre",
        night: "nit"
    },
    abbreviated: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "mitjanit",
        noon: "migdia",
        morning: "mat\xed",
        afternoon: "tarda",
        evening: "vespre",
        night: "nit"
    },
    wide: {
        am: "ante meridiem",
        pm: "post meridiem",
        midnight: "mitjanit",
        noon: "migdia",
        morning: "mat\xed",
        afternoon: "tarda",
        evening: "vespre",
        night: "nit"
    }
};
const $36b5499b784802e7$var$formattingDayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "de la mitjanit",
        noon: "del migdia",
        morning: "del mat\xed",
        afternoon: "de la tarda",
        evening: "del vespre",
        night: "de la nit"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "de la mitjanit",
        noon: "del migdia",
        morning: "del mat\xed",
        afternoon: "de la tarda",
        evening: "del vespre",
        night: "de la nit"
    },
    wide: {
        am: "ante meridiem",
        pm: "post meridiem",
        midnight: "de la mitjanit",
        noon: "del migdia",
        morning: "del mat\xed",
        afternoon: "de la tarda",
        evening: "del vespre",
        night: "de la nit"
    }
};
/**
 * Quan van en singular, els nombres ordinals es representen, en forma d’abreviatura, amb la xifra seguida de l’última lletra del mot desplegat.
 * És optatiu posar punt després de la lletra.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/pdf/abrevia.pdf#page=18
 */ const $36b5499b784802e7$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "r";
        case 2:
            return number + "n";
        case 3:
            return number + "r";
        case 4:
            return number + "t";
    }
    return number + "\xe8";
};
const $36b5499b784802e7$var$localize = $36b5499b784802e7$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $36b5499b784802e7$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $36b5499b784802e7$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $36b5499b784802e7$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $36b5499b784802e7$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $36b5499b784802e7$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $36b5499b784802e7$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $36b5499b784802e7$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("ji1Uj", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $e0b12d80163e1c77$export$4659b591c19bdf3d; }, function (v) { return $e0b12d80163e1c77$export$4659b591c19bdf3d = v; });
var $e0b12d80163e1c77$export$4659b591c19bdf3d;
"use strict";
$e0b12d80163e1c77$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $e0b12d80163e1c77$var$matchOrdinalNumberPattern = /^(\d+)(è|r|n|r|t)?/i;
const $e0b12d80163e1c77$var$parseOrdinalNumberPattern = /\d+/i;
const $e0b12d80163e1c77$var$matchEraPatterns = {
    narrow: /^(aC|dC)/i,
    abbreviated: /^(a. de C.|d. de C.)/i,
    wide: /^(abans de Crist|despr[eé]s de Crist)/i
};
const $e0b12d80163e1c77$var$parseEraPatterns = {
    narrow: [
        /^aC/i,
        /^dC/i
    ],
    abbreviated: [
        /^(a. de C.)/i,
        /^(d. de C.)/i
    ],
    wide: [
        /^(abans de Crist)/i,
        /^(despr[eé]s de Crist)/i
    ]
};
const $e0b12d80163e1c77$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](è|r|n|r|t)? trimestre/i
};
const $e0b12d80163e1c77$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $e0b12d80163e1c77$var$matchMonthPatterns = {
    narrow: /^(GN|FB|MÇ|AB|MG|JN|JL|AG|ST|OC|NV|DS)/i,
    abbreviated: /^(gen.|febr.|març|abr.|maig|juny|jul.|ag.|set.|oct.|nov.|des.)/i,
    wide: /^(gener|febrer|març|abril|maig|juny|juliol|agost|setembre|octubre|novembre|desembre)/i
};
const $e0b12d80163e1c77$var$parseMonthPatterns = {
    narrow: [
        /^GN/i,
        /^FB/i,
        /^MÇ/i,
        /^AB/i,
        /^MG/i,
        /^JN/i,
        /^JL/i,
        /^AG/i,
        /^ST/i,
        /^OC/i,
        /^NV/i,
        /^DS/i
    ],
    abbreviated: [
        /^gen./i,
        /^febr./i,
        /^març/i,
        /^abr./i,
        /^maig/i,
        /^juny/i,
        /^jul./i,
        /^ag./i,
        /^set./i,
        /^oct./i,
        /^nov./i,
        /^des./i
    ],
    wide: [
        /^gener/i,
        /^febrer/i,
        /^març/i,
        /^abril/i,
        /^maig/i,
        /^juny/i,
        /^juliol/i,
        /^agost/i,
        /^setembre/i,
        /^octubre/i,
        /^novembre/i,
        /^desembre/i
    ]
};
const $e0b12d80163e1c77$var$matchDayPatterns = {
    narrow: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
    short: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
    abbreviated: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
    wide: /^(diumenge|dilluns|dimarts|dimecres|dijous|divendres|dissabte)/i
};
const $e0b12d80163e1c77$var$parseDayPatterns = {
    narrow: [
        /^dg./i,
        /^dl./i,
        /^dt./i,
        /^dm./i,
        /^dj./i,
        /^dv./i,
        /^ds./i
    ],
    abbreviated: [
        /^dg./i,
        /^dl./i,
        /^dt./i,
        /^dm./i,
        /^dj./i,
        /^dv./i,
        /^ds./i
    ],
    wide: [
        /^diumenge/i,
        /^dilluns/i,
        /^dimarts/i,
        /^dimecres/i,
        /^dijous/i,
        /^divendres/i,
        /^disssabte/i
    ]
};
const $e0b12d80163e1c77$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(del|de la) (matí|tarda|vespre|nit))/i,
    abbreviated: /^([ap]\.?\s?m\.?|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i,
    wide: /^(ante meridiem|post meridiem|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i
};
const $e0b12d80163e1c77$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mitjanit/i,
        noon: /^migdia/i,
        morning: /matí/i,
        afternoon: /tarda/i,
        evening: /vespre/i,
        night: /nit/i
    }
};
const $e0b12d80163e1c77$var$match = $e0b12d80163e1c77$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $e0b12d80163e1c77$var$matchOrdinalNumberPattern,
        parsePattern: $e0b12d80163e1c77$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e0b12d80163e1c77$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e0b12d80163e1c77$var$parseEraPatterns,
        defaultParseWidth: "wide"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e0b12d80163e1c77$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e0b12d80163e1c77$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e0b12d80163e1c77$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e0b12d80163e1c77$var$parseMonthPatterns,
        defaultParseWidth: "wide"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e0b12d80163e1c77$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e0b12d80163e1c77$var$parseDayPatterns,
        defaultParseWidth: "wide"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e0b12d80163e1c77$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e0b12d80163e1c77$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("8YT4X", function(module, exports) {

$parcel$export(module.exports, "ckb", function () { return $689ea6e24c8705cd$export$c045140574fce5cd; }, function (v) { return $689ea6e24c8705cd$export$c045140574fce5cd = v; });
var $689ea6e24c8705cd$export$c045140574fce5cd;
"use strict";
$689ea6e24c8705cd$export$c045140574fce5cd = void 0;

var $63PPk = parcelRequire("63PPk");

var $3jn7m = parcelRequire("3jn7m");

var $j8CGQ = parcelRequire("j8CGQ");

var $2j4W4 = parcelRequire("2j4W4");

var $ekJ6j = parcelRequire("ekJ6j");
/**
 * @type {Locale}
 * @category Locales
 * @summary Central Kurdish locale.
 * @language Central Kurdish
 * @iso-639-2 kur
 * @author Revan Sarbast [@Revan99]{@link https://github.com/Revan99}
 */ const $689ea6e24c8705cd$var$ckb = $689ea6e24c8705cd$export$c045140574fce5cd = {
    code: "ckb",
    formatDistance: $63PPk.formatDistance,
    formatLong: $3jn7m.formatLong,
    formatRelative: $j8CGQ.formatRelative,
    localize: $2j4W4.localize,
    match: $ekJ6j.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("63PPk", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $469b39a3ebbda090$export$2c14ff85d6318973; }, function (v) { return $469b39a3ebbda090$export$2c14ff85d6318973 = v; });
var $469b39a3ebbda090$export$2c14ff85d6318973;
"use strict";
$469b39a3ebbda090$export$2c14ff85d6318973 = void 0;
const $469b39a3ebbda090$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u06A9\u06D5\u0645\u062A\u0631 \u0644\u06D5 \u06CC\u06D5\u06A9 \u0686\u0631\u06A9\u06D5",
        other: "\u06A9\u06D5\u0645\u062A\u0631 \u0644\u06D5 {{count}} \u0686\u0631\u06A9\u06D5"
    },
    xSeconds: {
        one: "1 \u0686\u0631\u06A9\u06D5",
        other: "{{count}} \u0686\u0631\u06A9\u06D5"
    },
    halfAMinute: "\u0646\u06CC\u0648 \u06A9\u0627\u062A\u0698\u0645\u06CE\u0631",
    lessThanXMinutes: {
        one: "\u06A9\u06D5\u0645\u062A\u0631 \u0644\u06D5 \u06CC\u06D5\u06A9 \u062E\u0648\u0644\u06D5\u06A9",
        other: "\u06A9\u06D5\u0645\u062A\u0631 \u0644\u06D5 {{count}} \u062E\u0648\u0644\u06D5\u06A9"
    },
    xMinutes: {
        one: "1 \u062E\u0648\u0644\u06D5\u06A9",
        other: "{{count}} \u062E\u0648\u0644\u06D5\u06A9"
    },
    aboutXHours: {
        one: "\u062F\u06D5\u0648\u0631\u0648\u0628\u06D5\u0631\u06CC 1 \u06A9\u0627\u062A\u0698\u0645\u06CE\u0631",
        other: "\u062F\u06D5\u0648\u0631\u0648\u0628\u06D5\u0631\u06CC {{count}} \u06A9\u0627\u062A\u0698\u0645\u06CE\u0631"
    },
    xHours: {
        one: "1 \u06A9\u0627\u062A\u0698\u0645\u06CE\u0631",
        other: "{{count}} \u06A9\u0627\u062A\u0698\u0645\u06CE\u0631"
    },
    xDays: {
        one: "1 \u0695\u06C6\u0698",
        other: "{{count}} \u0698\u06C6\u0698"
    },
    aboutXWeeks: {
        one: "\u062F\u06D5\u0648\u0631\u0648\u0628\u06D5\u0631\u06CC 1 \u0647\u06D5\u0641\u062A\u06D5",
        other: "\u062F\u0648\u0631\u0648\u0628\u06D5\u0631\u06CC {{count}} \u0647\u06D5\u0641\u062A\u06D5"
    },
    xWeeks: {
        one: "1 \u0647\u06D5\u0641\u062A\u06D5",
        other: "{{count}} \u0647\u06D5\u0641\u062A\u06D5"
    },
    aboutXMonths: {
        one: "\u062F\u0627\u0648\u0631\u0648\u0628\u06D5\u0631\u06CC 1 \u0645\u0627\u0646\u06AF",
        other: "\u062F\u06D5\u0648\u0631\u0648\u0628\u06D5\u0631\u06CC {{count}} \u0645\u0627\u0646\u06AF"
    },
    xMonths: {
        one: "1 \u0645\u0627\u0646\u06AF",
        other: "{{count}} \u0645\u0627\u0646\u06AF"
    },
    aboutXYears: {
        one: "\u062F\u06D5\u0648\u0631\u0648\u0628\u06D5\u0631\u06CC  1 \u0633\u0627\u06B5",
        other: "\u062F\u06D5\u0648\u0631\u0648\u0628\u06D5\u0631\u06CC {{count}} \u0633\u0627\u06B5"
    },
    xYears: {
        one: "1 \u0633\u0627\u06B5",
        other: "{{count}} \u0633\u0627\u06B5"
    },
    overXYears: {
        one: "\u0632\u06CC\u0627\u062A\u0631 \u0644\u06D5 \u0633\u0627\u06B5\u06CE\u06A9",
        other: "\u0632\u06CC\u0627\u062A\u0631 \u0644\u06D5 {{count}} \u0633\u0627\u06B5"
    },
    almostXYears: {
        one: "\u0628\u06D5\u0646\u0632\u06CC\u06A9\u06D5\u06CC\u06CC \u0633\u0627\u06B5\u06CE\u06A9  ",
        other: "\u0628\u06D5\u0646\u0632\u06CC\u06A9\u06D5\u06CC\u06CC {{count}} \u0633\u0627\u06B5"
    }
};
const $469b39a3ebbda090$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $469b39a3ebbda090$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0644\u06D5 \u0645\u0627\u0648\u06D5\u06CC " + result + "\u062F\u0627";
        else return result + "\u067E\u06CE\u0634 \u0626\u06CE\u0633\u062A\u0627";
    }
    return result;
};
$469b39a3ebbda090$export$2c14ff85d6318973 = $469b39a3ebbda090$var$formatDistance;

});

parcelRegister("3jn7m", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $269514253d735689$export$cbf60ecb96cbb82f; }, function (v) { return $269514253d735689$export$cbf60ecb96cbb82f = v; });
var $269514253d735689$export$cbf60ecb96cbb82f;
"use strict";
$269514253d735689$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $269514253d735689$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $269514253d735689$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $269514253d735689$var$dateTimeFormats = {
    full: "{{date}} '\u06A9\u0627\u062A\u0698\u0645\u06CE\u0631' {{time}}",
    long: "{{date}} '\u06A9\u0627\u062A\u0698\u0645\u06CE\u0631' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $269514253d735689$var$formatLong = $269514253d735689$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $269514253d735689$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $269514253d735689$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $269514253d735689$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("j8CGQ", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $deecc6bcc4d01c8a$export$8fbbfd65594f46a0; }, function (v) { return $deecc6bcc4d01c8a$export$8fbbfd65594f46a0 = v; });
var $deecc6bcc4d01c8a$export$8fbbfd65594f46a0;
"use strict";
$deecc6bcc4d01c8a$export$8fbbfd65594f46a0 = void 0;
const $deecc6bcc4d01c8a$var$formatRelativeLocale = {
    lastWeek: "'\u0647\u06D5\u0641\u062A\u06D5\u06CC \u0695\u0627\u0628\u0631\u062F\u0648\u0648' eeee '\u06A9\u0627\u062A\u0698\u0645\u06CE\u0631' p",
    yesterday: "'\u062F\u0648\u06CE\u0646\u06CE \u06A9\u0627\u062A\u0698\u0645\u06CE\u0631' p",
    today: "'\u0626\u06D5\u0645\u0695\u06C6 \u06A9\u0627\u062A\u0698\u0645\u06CE\u0631' p",
    tomorrow: "'\u0628\u06D5\u06CC\u0627\u0646\u06CC \u06A9\u0627\u062A\u0698\u0645\u06CE\u0631' p",
    nextWeek: "eeee '\u06A9\u0627\u062A\u0698\u0645\u06CE\u0631' p",
    other: "P"
};
const $deecc6bcc4d01c8a$var$formatRelative = (token, _date, _baseDate, _options)=>$deecc6bcc4d01c8a$var$formatRelativeLocale[token];
$deecc6bcc4d01c8a$export$8fbbfd65594f46a0 = $deecc6bcc4d01c8a$var$formatRelative;

});

parcelRegister("2j4W4", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $1ae12f3d94e6bb5a$export$b3bd0bc58e36cd63; }, function (v) { return $1ae12f3d94e6bb5a$export$b3bd0bc58e36cd63 = v; });
var $1ae12f3d94e6bb5a$export$b3bd0bc58e36cd63;
"use strict";
$1ae12f3d94e6bb5a$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $1ae12f3d94e6bb5a$var$eraValues = {
    narrow: [
        "\u067E",
        "\u062F"
    ],
    abbreviated: [
        "\u067E-\u0632",
        "\u062F-\u0632"
    ],
    wide: [
        "\u067E\u06CE\u0634 \u0632\u0627\u06CC\u0646",
        "\u062F\u0648\u0627\u06CC \u0632\u0627\u06CC\u0646"
    ]
};
const $1ae12f3d94e6bb5a$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u06861\u0645",
        "\u06862\u0645",
        "\u06863\u0645",
        "\u06864\u0645"
    ],
    wide: [
        "\u0686\u0627\u0631\u06D5\u06AF\u06CC \u06CC\u06D5\u06A9\u06D5\u0645",
        "\u0686\u0627\u0631\u06D5\u06AF\u06CC \u062F\u0648\u0648\u06D5\u0645",
        "\u0686\u0627\u0631\u06D5\u06AF\u06CC \u0633\u06CE\u06CC\u06D5\u0645",
        "\u0686\u0627\u0631\u06D5\u06AF\u06CC \u0686\u0648\u0627\u0631\u06D5\u0645"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $1ae12f3d94e6bb5a$var$monthValues = {
    narrow: [
        "\u06A9-\u062F",
        "\u0634",
        "\u0626\u0627",
        "\u0646",
        "\u0645",
        "\u062D",
        "\u062A",
        "\u0626\u0627",
        "\u0626\u06D5",
        "\u062A\u0634-\u06CC",
        "\u062A\u0634-\u062F",
        "\u06A9-\u06CC"
    ],
    abbreviated: [
        "\u06A9\u0627\u0646-\u062F\u0648\u0648",
        "\u0634\u0648\u0628",
        "\u0626\u0627\u062F",
        "\u0646\u06CC\u0633",
        "\u0645\u0627\u06CC\u0633",
        "\u062D\u0648\u0632",
        "\u062A\u06D5\u0645",
        "\u0626\u0627\u0628",
        "\u0626\u06D5\u0644",
        "\u062A\u0634-\u06CC\u06D5\u06A9",
        "\u062A\u0634-\u062F\u0648\u0648",
        "\u06A9\u0627\u0646-\u06CC\u06D5\u06A9"
    ],
    wide: [
        "\u06A9\u0627\u0646\u0648\u0648\u0646\u06CC \u062F\u0648\u0648\u06D5\u0645",
        "\u0634\u0648\u0628\u0627\u062A",
        "\u0626\u0627\u062F\u0627\u0631",
        "\u0646\u06CC\u0633\u0627\u0646",
        "\u0645\u0627\u06CC\u0633",
        "\u062D\u0648\u0632\u06D5\u06CC\u0631\u0627\u0646",
        "\u062A\u06D5\u0645\u0645\u0648\u0632",
        "\u0626\u0627\u0628",
        "\u0626\u06D5\u06CC\u0644\u0648\u0644",
        "\u062A\u0634\u0631\u06CC\u0646\u06CC \u06CC\u06D5\u06A9\u06D5\u0645",
        "\u062A\u0634\u0631\u06CC\u0646\u06CC \u062F\u0648\u0648\u06D5\u0645",
        "\u06A9\u0627\u0646\u0648\u0648\u0646\u06CC \u06CC\u06D5\u06A9\u06D5\u0645"
    ]
};
const $1ae12f3d94e6bb5a$var$dayValues = {
    narrow: [
        "\u06CC-\u0634",
        "\u062F-\u0634",
        "\u0633-\u0634",
        "\u0686-\u0634",
        "\u067E-\u0634",
        "\u0647\u06D5",
        "\u0634"
    ],
    short: [
        "\u06CC\u06D5-\u0634\u06D5",
        "\u062F\u0648\u0648-\u0634\u06D5",
        "\u0633\u06CE-\u0634\u06D5",
        "\u0686\u0648-\u0634\u06D5",
        "\u067E\u06CE-\u0634\u06D5",
        "\u0647\u06D5\u06CC",
        "\u0634\u06D5"
    ],
    abbreviated: [
        "\u06CC\u06D5\u06A9-\u0634\u06D5\u0645",
        "\u062F\u0648\u0648-\u0634\u06D5\u0645",
        "\u0633\u06CE-\u0634\u06D5\u0645",
        "\u0686\u0648\u0627\u0631-\u0634\u06D5\u0645",
        "\u067E\u06CE\u0646\u062C-\u0634\u06D5\u0645",
        "\u0647\u06D5\u06CC\u0646\u06CC",
        "\u0634\u06D5\u0645\u06D5"
    ],
    wide: [
        "\u06CC\u06D5\u06A9 \u0634\u06D5\u0645\u06D5",
        "\u062F\u0648\u0648 \u0634\u06D5\u0645\u06D5",
        "\u0633\u06CE \u0634\u06D5\u0645\u06D5",
        "\u0686\u0648\u0627\u0631 \u0634\u06D5\u0645\u06D5",
        "\u067E\u06CE\u0646\u062C \u0634\u06D5\u0645\u06D5",
        "\u0647\u06D5\u06CC\u0646\u06CC",
        "\u0634\u06D5\u0645\u06D5"
    ]
};
const $1ae12f3d94e6bb5a$var$dayPeriodValues = {
    narrow: {
        am: "\u067E",
        pm: "\u062F",
        midnight: "\u0646-\u0634",
        noon: "\u0646",
        morning: "\u0628\u06D5\u06CC\u0627\u0646\u06CC",
        afternoon: "\u062F\u0648\u0627\u06CC \u0646\u06CC\u0648\u06D5\u0695\u06C6",
        evening: "\u0626\u06CE\u0648\u0627\u0631\u06D5",
        night: "\u0634\u06D5\u0648"
    },
    abbreviated: {
        am: "\u067E-\u0646",
        pm: "\u062F-\u0646",
        midnight: "\u0646\u06CC\u0648\u06D5 \u0634\u06D5\u0648",
        noon: "\u0646\u06CC\u0648\u06D5\u0695\u06C6",
        morning: "\u0628\u06D5\u06CC\u0627\u0646\u06CC",
        afternoon: "\u062F\u0648\u0627\u06CC \u0646\u06CC\u0648\u06D5\u0695\u06C6",
        evening: "\u0626\u06CE\u0648\u0627\u0631\u06D5",
        night: "\u0634\u06D5\u0648"
    },
    wide: {
        am: "\u067E\u06CE\u0634 \u0646\u06CC\u0648\u06D5\u0695\u06C6",
        pm: "\u062F\u0648\u0627\u06CC \u0646\u06CC\u0648\u06D5\u0695\u06C6",
        midnight: "\u0646\u06CC\u0648\u06D5 \u0634\u06D5\u0648",
        noon: "\u0646\u06CC\u0648\u06D5\u0695\u06C6",
        morning: "\u0628\u06D5\u06CC\u0627\u0646\u06CC",
        afternoon: "\u062F\u0648\u0627\u06CC \u0646\u06CC\u0648\u06D5\u0695\u06C6",
        evening: "\u0626\u06CE\u0648\u0627\u0631\u06D5",
        night: "\u0634\u06D5\u0648"
    }
};
const $1ae12f3d94e6bb5a$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u067E",
        pm: "\u062F",
        midnight: "\u0646-\u0634",
        noon: "\u0646",
        morning: "\u0644\u06D5 \u0628\u06D5\u06CC\u0627\u0646\u06CC\u062F\u0627",
        afternoon: "\u0644\u06D5 \u062F\u0648\u0627\u06CC \u0646\u06CC\u0648\u06D5\u0695\u06C6\u062F\u0627",
        evening: "\u0644\u06D5 \u0626\u06CE\u0648\u0627\u0631\u06D5\u062F\u0627",
        night: "\u0644\u06D5 \u0634\u06D5\u0648\u062F\u0627"
    },
    abbreviated: {
        am: "\u067E-\u0646",
        pm: "\u062F-\u0646",
        midnight: "\u0646\u06CC\u0648\u06D5 \u0634\u06D5\u0648",
        noon: "\u0646\u06CC\u0648\u06D5\u0695\u06C6",
        morning: "\u0644\u06D5 \u0628\u06D5\u06CC\u0627\u0646\u06CC\u062F\u0627",
        afternoon: "\u0644\u06D5 \u062F\u0648\u0627\u06CC \u0646\u06CC\u0648\u06D5\u0695\u06C6\u062F\u0627",
        evening: "\u0644\u06D5 \u0626\u06CE\u0648\u0627\u0631\u06D5\u062F\u0627",
        night: "\u0644\u06D5 \u0634\u06D5\u0648\u062F\u0627"
    },
    wide: {
        am: "\u067E\u06CE\u0634 \u0646\u06CC\u0648\u06D5\u0695\u06C6",
        pm: "\u062F\u0648\u0627\u06CC \u0646\u06CC\u0648\u06D5\u0695\u06C6",
        midnight: "\u0646\u06CC\u0648\u06D5 \u0634\u06D5\u0648",
        noon: "\u0646\u06CC\u0648\u06D5\u0695\u06C6",
        morning: "\u0644\u06D5 \u0628\u06D5\u06CC\u0627\u0646\u06CC\u062F\u0627",
        afternoon: "\u0644\u06D5 \u062F\u0648\u0627\u06CC \u0646\u06CC\u0648\u06D5\u0695\u06C6\u062F\u0627",
        evening: "\u0644\u06D5 \u0626\u06CE\u0648\u0627\u0631\u06D5\u062F\u0627",
        night: "\u0644\u06D5 \u0634\u06D5\u0648\u062F\u0627"
    }
};
const $1ae12f3d94e6bb5a$var$ordinalNumber = (dirtyNumber, _options)=>{
    return String(dirtyNumber);
};
const $1ae12f3d94e6bb5a$var$localize = $1ae12f3d94e6bb5a$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $1ae12f3d94e6bb5a$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $1ae12f3d94e6bb5a$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $1ae12f3d94e6bb5a$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $1ae12f3d94e6bb5a$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $1ae12f3d94e6bb5a$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $1ae12f3d94e6bb5a$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $1ae12f3d94e6bb5a$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("ekJ6j", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $a6f5eb0725509e8c$export$4659b591c19bdf3d; }, function (v) { return $a6f5eb0725509e8c$export$4659b591c19bdf3d = v; });
var $a6f5eb0725509e8c$export$4659b591c19bdf3d;
"use strict";
$a6f5eb0725509e8c$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $a6f5eb0725509e8c$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $a6f5eb0725509e8c$var$parseOrdinalNumberPattern = /\d+/i;
const $a6f5eb0725509e8c$var$matchEraPatterns = {
    narrow: /^(پ|د)/i,
    abbreviated: /^(پ-ز|د.ز)/i,
    wide: /^(پێش زاین| دوای زاین)/i
};
const $a6f5eb0725509e8c$var$parseEraPatterns = {
    any: [
        /^د/g,
        /^پ/g
    ]
};
const $a6f5eb0725509e8c$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^م[1234]چ/i,
    wide: /^(یەکەم|دووەم|سێیەم| چوارەم) (چارەگی)? quarter/i
};
const $a6f5eb0725509e8c$var$parseQuarterPatterns = {
    wide: [
        /چارەگی یەکەم/,
        /چارەگی دووەم/,
        /چارەگی سيیەم/,
        /چارەگی چوارەم/
    ],
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $a6f5eb0725509e8c$var$matchMonthPatterns = {
    narrow: /^(ک-د|ش|ئا|ن|م|ح|ت|ئە|تش-ی|تش-د|ک-ی)/i,
    abbreviated: /^(کان-دوو|شوب|ئاد|نیس|مایس|حوز|تەم|ئاب|ئەل|تش-یەک|تش-دوو|کان-یەک)/i,
    wide: /^(کانوونی دووەم|شوبات|ئادار|نیسان|مایس|حوزەیران|تەمموز|ئاب|ئەیلول|تشرینی یەکەم|تشرینی دووەم|کانوونی یەکەم)/i
};
const $a6f5eb0725509e8c$var$parseMonthPatterns = {
    narrow: [
        /^ک-د/i,
        /^ش/i,
        /^ئا/i,
        /^ن/i,
        /^م/i,
        /^ح/i,
        /^ت/i,
        /^ئا/i,
        /^ئە/i,
        /^تش-ی/i,
        /^تش-د/i,
        /^ک-ی/i
    ],
    any: [
        /^کان-دوو/i,
        /^شوب/i,
        /^ئاد/i,
        /^نیس/i,
        /^مایس/i,
        /^حوز/i,
        /^تەم/i,
        /^ئاب/i,
        /^ئەل/i,
        /^تش-یەک/i,
        /^تش-دوو/i,
        /^|کان-یەک/i
    ]
};
const $a6f5eb0725509e8c$var$matchDayPatterns = {
    narrow: /^(ش|ی|د|س|چ|پ|هە)/i,
    short: /^(یە-شە|دوو-شە|سێ-شە|چو-شە|پێ-شە|هە|شە)/i,
    abbreviated: /^(یەک-شەم|دوو-شەم|سێ-شەم|چوار-شەم|پێنخ-شەم|هەینی|شەمە)/i,
    wide: /^(یەک شەمە|دوو شەمە|سێ شەمە|چوار شەمە|پێنج شەمە|هەینی|شەمە)/i
};
const $a6f5eb0725509e8c$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $a6f5eb0725509e8c$var$matchDayPeriodPatterns = {
    narrow: /^(پ|د|ن-ش|ن| (بەیانی|دوای نیوەڕۆ|ئێوارە|شەو))/i,
    abbreviated: /^(پ-ن|د-ن|نیوە شەو|نیوەڕۆ|بەیانی|دوای نیوەڕۆ|ئێوارە|شەو)/,
    wide: /^(پێش نیوەڕۆ|دوای نیوەڕۆ|نیوەڕۆ|نیوە شەو|لەبەیانیدا|لەدواینیوەڕۆدا|لە ئێوارەدا|لە شەودا)/,
    any: /^(پ|د|بەیانی|نیوەڕۆ|ئێوارە|شەو)/
};
const $a6f5eb0725509e8c$var$parseDayPeriodPatterns = {
    any: {
        am: /^د/i,
        pm: /^پ/i,
        midnight: /^ن-ش/i,
        noon: /^ن/i,
        morning: /بەیانی/i,
        afternoon: /دواینیوەڕۆ/i,
        evening: /ئێوارە/i,
        night: /شەو/i
    }
};
const $a6f5eb0725509e8c$var$match = $a6f5eb0725509e8c$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $a6f5eb0725509e8c$var$matchOrdinalNumberPattern,
        parsePattern: $a6f5eb0725509e8c$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $a6f5eb0725509e8c$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a6f5eb0725509e8c$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $a6f5eb0725509e8c$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a6f5eb0725509e8c$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $a6f5eb0725509e8c$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a6f5eb0725509e8c$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $a6f5eb0725509e8c$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a6f5eb0725509e8c$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $a6f5eb0725509e8c$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $a6f5eb0725509e8c$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("blQNa", function(module, exports) {

$parcel$export(module.exports, "cs", function () { return $843a9b48f84221a4$export$bde1ed0f60b38f2f; }, function (v) { return $843a9b48f84221a4$export$bde1ed0f60b38f2f = v; });
var $843a9b48f84221a4$export$bde1ed0f60b38f2f;
"use strict";
$843a9b48f84221a4$export$bde1ed0f60b38f2f = void 0;

var $lwRqL = parcelRequire("lwRqL");

var $l3kfQ = parcelRequire("l3kfQ");

var $h8oiJ = parcelRequire("h8oiJ");

var $3LY80 = parcelRequire("3LY80");

var $9xtWg = parcelRequire("9xtWg");
/**
 * @category Locales
 * @summary Czech locale.
 * @language Czech
 * @iso-639-2 ces
 * @author David Rus [@davidrus](https://github.com/davidrus)
 * @author Pavel Hrách [@SilenY](https://github.com/SilenY)
 * @author Jozef Bíroš [@JozefBiros](https://github.com/JozefBiros)
 */ const $843a9b48f84221a4$var$cs = $843a9b48f84221a4$export$bde1ed0f60b38f2f = {
    code: "cs",
    formatDistance: $lwRqL.formatDistance,
    formatLong: $l3kfQ.formatLong,
    formatRelative: $h8oiJ.formatRelative,
    localize: $3LY80.localize,
    match: $9xtWg.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("lwRqL", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $fac608607cc67b02$export$2c14ff85d6318973; }, function (v) { return $fac608607cc67b02$export$2c14ff85d6318973 = v; });
var $fac608607cc67b02$export$2c14ff85d6318973;
"use strict";
$fac608607cc67b02$export$2c14ff85d6318973 = void 0;
const $fac608607cc67b02$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            regular: "m\xe9n\u011B ne\u017E 1 sekunda",
            past: "p\u0159ed m\xe9n\u011B ne\u017E 1 sekundou",
            future: "za m\xe9n\u011B ne\u017E 1 sekundu"
        },
        few: {
            regular: "m\xe9n\u011B ne\u017E {{count}} sekundy",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} sekundami",
            future: "za m\xe9n\u011B ne\u017E {{count}} sekundy"
        },
        many: {
            regular: "m\xe9n\u011B ne\u017E {{count}} sekund",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} sekundami",
            future: "za m\xe9n\u011B ne\u017E {{count}} sekund"
        }
    },
    xSeconds: {
        one: {
            regular: "1 sekunda",
            past: "p\u0159ed 1 sekundou",
            future: "za 1 sekundu"
        },
        few: {
            regular: "{{count}} sekundy",
            past: "p\u0159ed {{count}} sekundami",
            future: "za {{count}} sekundy"
        },
        many: {
            regular: "{{count}} sekund",
            past: "p\u0159ed {{count}} sekundami",
            future: "za {{count}} sekund"
        }
    },
    halfAMinute: {
        type: "other",
        other: {
            regular: "p\u016Fl minuty",
            past: "p\u0159ed p\u016Fl minutou",
            future: "za p\u016Fl minuty"
        }
    },
    lessThanXMinutes: {
        one: {
            regular: "m\xe9n\u011B ne\u017E 1 minuta",
            past: "p\u0159ed m\xe9n\u011B ne\u017E 1 minutou",
            future: "za m\xe9n\u011B ne\u017E 1 minutu"
        },
        few: {
            regular: "m\xe9n\u011B ne\u017E {{count}} minuty",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} minutami",
            future: "za m\xe9n\u011B ne\u017E {{count}} minuty"
        },
        many: {
            regular: "m\xe9n\u011B ne\u017E {{count}} minut",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} minutami",
            future: "za m\xe9n\u011B ne\u017E {{count}} minut"
        }
    },
    xMinutes: {
        one: {
            regular: "1 minuta",
            past: "p\u0159ed 1 minutou",
            future: "za 1 minutu"
        },
        few: {
            regular: "{{count}} minuty",
            past: "p\u0159ed {{count}} minutami",
            future: "za {{count}} minuty"
        },
        many: {
            regular: "{{count}} minut",
            past: "p\u0159ed {{count}} minutami",
            future: "za {{count}} minut"
        }
    },
    aboutXHours: {
        one: {
            regular: "p\u0159ibli\u017En\u011B 1 hodina",
            past: "p\u0159ibli\u017En\u011B p\u0159ed 1 hodinou",
            future: "p\u0159ibli\u017En\u011B za 1 hodinu"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} hodiny",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} hodinami",
            future: "p\u0159ibli\u017En\u011B za {{count}} hodiny"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} hodin",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} hodinami",
            future: "p\u0159ibli\u017En\u011B za {{count}} hodin"
        }
    },
    xHours: {
        one: {
            regular: "1 hodina",
            past: "p\u0159ed 1 hodinou",
            future: "za 1 hodinu"
        },
        few: {
            regular: "{{count}} hodiny",
            past: "p\u0159ed {{count}} hodinami",
            future: "za {{count}} hodiny"
        },
        many: {
            regular: "{{count}} hodin",
            past: "p\u0159ed {{count}} hodinami",
            future: "za {{count}} hodin"
        }
    },
    xDays: {
        one: {
            regular: "1 den",
            past: "p\u0159ed 1 dnem",
            future: "za 1 den"
        },
        few: {
            regular: "{{count}} dny",
            past: "p\u0159ed {{count}} dny",
            future: "za {{count}} dny"
        },
        many: {
            regular: "{{count}} dn\xed",
            past: "p\u0159ed {{count}} dny",
            future: "za {{count}} dn\xed"
        }
    },
    aboutXWeeks: {
        one: {
            regular: "p\u0159ibli\u017En\u011B 1 t\xfdden",
            past: "p\u0159ibli\u017En\u011B p\u0159ed 1 t\xfddnem",
            future: "p\u0159ibli\u017En\u011B za 1 t\xfdden"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} t\xfddny",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} t\xfddny",
            future: "p\u0159ibli\u017En\u011B za {{count}} t\xfddny"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} t\xfddn\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} t\xfddny",
            future: "p\u0159ibli\u017En\u011B za {{count}} t\xfddn\u016F"
        }
    },
    xWeeks: {
        one: {
            regular: "1 t\xfdden",
            past: "p\u0159ed 1 t\xfddnem",
            future: "za 1 t\xfdden"
        },
        few: {
            regular: "{{count}} t\xfddny",
            past: "p\u0159ed {{count}} t\xfddny",
            future: "za {{count}} t\xfddny"
        },
        many: {
            regular: "{{count}} t\xfddn\u016F",
            past: "p\u0159ed {{count}} t\xfddny",
            future: "za {{count}} t\xfddn\u016F"
        }
    },
    aboutXMonths: {
        one: {
            regular: "p\u0159ibli\u017En\u011B 1 m\u011Bs\xedc",
            past: "p\u0159ibli\u017En\u011B p\u0159ed 1 m\u011Bs\xedcem",
            future: "p\u0159ibli\u017En\u011B za 1 m\u011Bs\xedc"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} m\u011Bs\xedce",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} m\u011Bs\xedci",
            future: "p\u0159ibli\u017En\u011B za {{count}} m\u011Bs\xedce"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} m\u011Bs\xedc\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} m\u011Bs\xedci",
            future: "p\u0159ibli\u017En\u011B za {{count}} m\u011Bs\xedc\u016F"
        }
    },
    xMonths: {
        one: {
            regular: "1 m\u011Bs\xedc",
            past: "p\u0159ed 1 m\u011Bs\xedcem",
            future: "za 1 m\u011Bs\xedc"
        },
        few: {
            regular: "{{count}} m\u011Bs\xedce",
            past: "p\u0159ed {{count}} m\u011Bs\xedci",
            future: "za {{count}} m\u011Bs\xedce"
        },
        many: {
            regular: "{{count}} m\u011Bs\xedc\u016F",
            past: "p\u0159ed {{count}} m\u011Bs\xedci",
            future: "za {{count}} m\u011Bs\xedc\u016F"
        }
    },
    aboutXYears: {
        one: {
            regular: "p\u0159ibli\u017En\u011B 1 rok",
            past: "p\u0159ibli\u017En\u011B p\u0159ed 1 rokem",
            future: "p\u0159ibli\u017En\u011B za 1 rok"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} roky",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} roky",
            future: "p\u0159ibli\u017En\u011B za {{count}} roky"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} rok\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} roky",
            future: "p\u0159ibli\u017En\u011B za {{count}} rok\u016F"
        }
    },
    xYears: {
        one: {
            regular: "1 rok",
            past: "p\u0159ed 1 rokem",
            future: "za 1 rok"
        },
        few: {
            regular: "{{count}} roky",
            past: "p\u0159ed {{count}} roky",
            future: "za {{count}} roky"
        },
        many: {
            regular: "{{count}} rok\u016F",
            past: "p\u0159ed {{count}} roky",
            future: "za {{count}} rok\u016F"
        }
    },
    overXYears: {
        one: {
            regular: "v\xedce ne\u017E 1 rok",
            past: "p\u0159ed v\xedce ne\u017E 1 rokem",
            future: "za v\xedce ne\u017E 1 rok"
        },
        few: {
            regular: "v\xedce ne\u017E {{count}} roky",
            past: "p\u0159ed v\xedce ne\u017E {{count}} roky",
            future: "za v\xedce ne\u017E {{count}} roky"
        },
        many: {
            regular: "v\xedce ne\u017E {{count}} rok\u016F",
            past: "p\u0159ed v\xedce ne\u017E {{count}} roky",
            future: "za v\xedce ne\u017E {{count}} rok\u016F"
        }
    },
    almostXYears: {
        one: {
            regular: "skoro 1 rok",
            past: "skoro p\u0159ed 1 rokem",
            future: "skoro za 1 rok"
        },
        few: {
            regular: "skoro {{count}} roky",
            past: "skoro p\u0159ed {{count}} roky",
            future: "skoro za {{count}} roky"
        },
        many: {
            regular: "skoro {{count}} rok\u016F",
            past: "skoro p\u0159ed {{count}} roky",
            future: "skoro za {{count}} rok\u016F"
        }
    }
};
const $fac608607cc67b02$var$formatDistance = (token, count, options)=>{
    let pluralResult;
    const tokenValue = $fac608607cc67b02$var$formatDistanceLocale[token];
    // cs pluralization
    if (tokenValue.type === "other") pluralResult = tokenValue.other;
    else if (count === 1) pluralResult = tokenValue.one;
    else if (count > 1 && count < 5) pluralResult = tokenValue.few;
    else pluralResult = tokenValue.many;
    // times
    const suffixExist = options?.addSuffix === true;
    const comparison = options?.comparison;
    let timeResult;
    if (suffixExist && comparison === -1) timeResult = pluralResult.past;
    else if (suffixExist && comparison === 1) timeResult = pluralResult.future;
    else timeResult = pluralResult.regular;
    return timeResult.replace("{{count}}", String(count));
};
$fac608607cc67b02$export$2c14ff85d6318973 = $fac608607cc67b02$var$formatDistance;

});

parcelRegister("l3kfQ", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $f53996ef1c534682$export$cbf60ecb96cbb82f; }, function (v) { return $f53996ef1c534682$export$cbf60ecb96cbb82f = v; });
var $f53996ef1c534682$export$cbf60ecb96cbb82f;
"use strict";
$f53996ef1c534682$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $f53996ef1c534682$var$dateFormats = {
    full: "EEEE, d. MMMM yyyy",
    long: "d. MMMM yyyy",
    medium: "d. M. yyyy",
    short: "dd.MM.yyyy"
};
const $f53996ef1c534682$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $f53996ef1c534682$var$dateTimeFormats = {
    full: "{{date}} 'v' {{time}}",
    long: "{{date}} 'v' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $f53996ef1c534682$var$formatLong = $f53996ef1c534682$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $f53996ef1c534682$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $f53996ef1c534682$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $f53996ef1c534682$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("h8oiJ", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $c79608b5cb5601fb$export$8fbbfd65594f46a0; }, function (v) { return $c79608b5cb5601fb$export$8fbbfd65594f46a0 = v; });
var $c79608b5cb5601fb$export$8fbbfd65594f46a0;
"use strict";
$c79608b5cb5601fb$export$8fbbfd65594f46a0 = void 0;
const $c79608b5cb5601fb$var$accusativeWeekdays = [
    "ned\u011Bli",
    "pond\u011Bl\xed",
    "\xfater\xfd",
    "st\u0159edu",
    "\u010Dtvrtek",
    "p\xe1tek",
    "sobotu"
];
const $c79608b5cb5601fb$var$formatRelativeLocale = {
    lastWeek: "'posledn\xed' eeee 've' p",
    yesterday: "'v\u010Dera v' p",
    today: "'dnes v' p",
    tomorrow: "'z\xedtra v' p",
    nextWeek: (date)=>{
        const day = date.getDay();
        return "'v " + $c79608b5cb5601fb$var$accusativeWeekdays[day] + " o' p";
    },
    other: "P"
};
const $c79608b5cb5601fb$var$formatRelative = (token, date)=>{
    const format = $c79608b5cb5601fb$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
$c79608b5cb5601fb$export$8fbbfd65594f46a0 = $c79608b5cb5601fb$var$formatRelative;

});

parcelRegister("3LY80", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $2bf4671595409a64$export$b3bd0bc58e36cd63; }, function (v) { return $2bf4671595409a64$export$b3bd0bc58e36cd63 = v; });
var $2bf4671595409a64$export$b3bd0bc58e36cd63;
"use strict";
$2bf4671595409a64$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $2bf4671595409a64$var$eraValues = {
    narrow: [
        "p\u0159. n. l.",
        "n. l."
    ],
    abbreviated: [
        "p\u0159. n. l.",
        "n. l."
    ],
    wide: [
        "p\u0159ed na\u0161\xedm letopo\u010Dtem",
        "na\u0161eho letopo\u010Dtu"
    ]
};
const $2bf4671595409a64$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1. \u010Dtvrtlet\xed",
        "2. \u010Dtvrtlet\xed",
        "3. \u010Dtvrtlet\xed",
        "4. \u010Dtvrtlet\xed"
    ],
    wide: [
        "1. \u010Dtvrtlet\xed",
        "2. \u010Dtvrtlet\xed",
        "3. \u010Dtvrtlet\xed",
        "4. \u010Dtvrtlet\xed"
    ]
};
const $2bf4671595409a64$var$monthValues = {
    narrow: [
        "L",
        "\xda",
        "B",
        "D",
        "K",
        "\u010C",
        "\u010C",
        "S",
        "Z",
        "\u0158",
        "L",
        "P"
    ],
    abbreviated: [
        "led",
        "\xfano",
        "b\u0159e",
        "dub",
        "kv\u011B",
        "\u010Dvn",
        "\u010Dvc",
        "srp",
        "z\xe1\u0159",
        "\u0159\xedj",
        "lis",
        "pro"
    ],
    wide: [
        "leden",
        "\xfanor",
        "b\u0159ezen",
        "duben",
        "kv\u011Bten",
        "\u010Derven",
        "\u010Dervenec",
        "srpen",
        "z\xe1\u0159\xed",
        "\u0159\xedjen",
        "listopad",
        "prosinec"
    ]
};
const $2bf4671595409a64$var$formattingMonthValues = {
    narrow: [
        "L",
        "\xda",
        "B",
        "D",
        "K",
        "\u010C",
        "\u010C",
        "S",
        "Z",
        "\u0158",
        "L",
        "P"
    ],
    abbreviated: [
        "led",
        "\xfano",
        "b\u0159e",
        "dub",
        "kv\u011B",
        "\u010Dvn",
        "\u010Dvc",
        "srp",
        "z\xe1\u0159",
        "\u0159\xedj",
        "lis",
        "pro"
    ],
    wide: [
        "ledna",
        "\xfanora",
        "b\u0159ezna",
        "dubna",
        "kv\u011Btna",
        "\u010Dervna",
        "\u010Dervence",
        "srpna",
        "z\xe1\u0159\xed",
        "\u0159\xedjna",
        "listopadu",
        "prosince"
    ]
};
const $2bf4671595409a64$var$dayValues = {
    narrow: [
        "ne",
        "po",
        "\xfat",
        "st",
        "\u010Dt",
        "p\xe1",
        "so"
    ],
    short: [
        "ne",
        "po",
        "\xfat",
        "st",
        "\u010Dt",
        "p\xe1",
        "so"
    ],
    abbreviated: [
        "ned",
        "pon",
        "\xfate",
        "st\u0159",
        "\u010Dtv",
        "p\xe1t",
        "sob"
    ],
    wide: [
        "ned\u011Ble",
        "pond\u011Bl\xed",
        "\xfater\xfd",
        "st\u0159eda",
        "\u010Dtvrtek",
        "p\xe1tek",
        "sobota"
    ]
};
const $2bf4671595409a64$var$dayPeriodValues = {
    narrow: {
        am: "dop.",
        pm: "odp.",
        midnight: "p\u016Flnoc",
        noon: "poledne",
        morning: "r\xe1no",
        afternoon: "odpoledne",
        evening: "ve\u010Der",
        night: "noc"
    },
    abbreviated: {
        am: "dop.",
        pm: "odp.",
        midnight: "p\u016Flnoc",
        noon: "poledne",
        morning: "r\xe1no",
        afternoon: "odpoledne",
        evening: "ve\u010Der",
        night: "noc"
    },
    wide: {
        am: "dopoledne",
        pm: "odpoledne",
        midnight: "p\u016Flnoc",
        noon: "poledne",
        morning: "r\xe1no",
        afternoon: "odpoledne",
        evening: "ve\u010Der",
        night: "noc"
    }
};
const $2bf4671595409a64$var$formattingDayPeriodValues = {
    narrow: {
        am: "dop.",
        pm: "odp.",
        midnight: "p\u016Flnoc",
        noon: "poledne",
        morning: "r\xe1no",
        afternoon: "odpoledne",
        evening: "ve\u010Der",
        night: "noc"
    },
    abbreviated: {
        am: "dop.",
        pm: "odp.",
        midnight: "p\u016Flnoc",
        noon: "poledne",
        morning: "r\xe1no",
        afternoon: "odpoledne",
        evening: "ve\u010Der",
        night: "noc"
    },
    wide: {
        am: "dopoledne",
        pm: "odpoledne",
        midnight: "p\u016Flnoc",
        noon: "poledne",
        morning: "r\xe1no",
        afternoon: "odpoledne",
        evening: "ve\u010Der",
        night: "noc"
    }
};
const $2bf4671595409a64$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $2bf4671595409a64$var$localize = $2bf4671595409a64$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $2bf4671595409a64$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $2bf4671595409a64$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $2bf4671595409a64$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $2bf4671595409a64$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $2bf4671595409a64$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $2bf4671595409a64$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $2bf4671595409a64$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $2bf4671595409a64$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("9xtWg", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $6f1e6b4fa6e6f193$export$4659b591c19bdf3d; }, function (v) { return $6f1e6b4fa6e6f193$export$4659b591c19bdf3d = v; });
var $6f1e6b4fa6e6f193$export$4659b591c19bdf3d;
"use strict";
$6f1e6b4fa6e6f193$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $6f1e6b4fa6e6f193$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
const $6f1e6b4fa6e6f193$var$parseOrdinalNumberPattern = /\d+/i;
const $6f1e6b4fa6e6f193$var$matchEraPatterns = {
    narrow: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
    abbreviated: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
    wide: /^(p[řr](\.|ed) Kristem|p[řr](\.|ed) na[šs][íi]m letopo[čc]tem|po Kristu|na[šs]eho letopo[čc]tu)/i
};
const $6f1e6b4fa6e6f193$var$parseEraPatterns = {
    any: [
        /^p[řr]/i,
        /^(po|n)/i
    ]
};
const $6f1e6b4fa6e6f193$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\. [čc]tvrtlet[íi]/i,
    wide: /^[1234]\. [čc]tvrtlet[íi]/i
};
const $6f1e6b4fa6e6f193$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $6f1e6b4fa6e6f193$var$matchMonthPatterns = {
    narrow: /^[lúubdkčcszřrlp]/i,
    abbreviated: /^(led|[úu]no|b[řr]e|dub|kv[ěe]|[čc]vn|[čc]vc|srp|z[áa][řr]|[řr][íi]j|lis|pro)/i,
    wide: /^(leden|ledna|[úu]nora?|b[řr]ezen|b[řr]ezna|duben|dubna|kv[ěe]ten|kv[ěe]tna|[čc]erven(ec|ce)?|[čc]ervna|srpen|srpna|z[áa][řr][íi]|[řr][íi]jen|[řr][íi]jna|listopad(a|u)?|prosinec|prosince)/i
};
const $6f1e6b4fa6e6f193$var$parseMonthPatterns = {
    narrow: [
        /^l/i,
        /^[úu]/i,
        /^b/i,
        /^d/i,
        /^k/i,
        /^[čc]/i,
        /^[čc]/i,
        /^s/i,
        /^z/i,
        /^[řr]/i,
        /^l/i,
        /^p/i
    ],
    any: [
        /^led/i,
        /^[úu]n/i,
        /^b[řr]e/i,
        /^dub/i,
        /^kv[ěe]/i,
        /^[čc]vn|[čc]erven(?!\w)|[čc]ervna/i,
        /^[čc]vc|[čc]erven(ec|ce)/i,
        /^srp/i,
        /^z[áa][řr]/i,
        /^[řr][íi]j/i,
        /^lis/i,
        /^pro/i
    ]
};
const $6f1e6b4fa6e6f193$var$matchDayPatterns = {
    narrow: /^[npuúsčps]/i,
    short: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
    abbreviated: /^(ned|pon|[úu]te|st[rř]|[čc]tv|p[áa]t|sob)/i,
    wide: /^(ned[ěe]le|pond[ěe]l[íi]|[úu]ter[ýy]|st[řr]eda|[čc]tvrtek|p[áa]tek|sobota)/i
};
const $6f1e6b4fa6e6f193$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^[úu]/i,
        /^s/i,
        /^[čc]/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^ne/i,
        /^po/i,
        /^[úu]t/i,
        /^st/i,
        /^[čc]t/i,
        /^p[áa]/i,
        /^so/i
    ]
};
const $6f1e6b4fa6e6f193$var$matchDayPeriodPatterns = {
    any: /^dopoledne|dop\.?|odpoledne|odp\.?|p[ůu]lnoc|poledne|r[áa]no|odpoledne|ve[čc]er|(v )?noci?/i
};
const $6f1e6b4fa6e6f193$var$parseDayPeriodPatterns = {
    any: {
        am: /^dop/i,
        pm: /^odp/i,
        midnight: /^p[ůu]lnoc/i,
        noon: /^poledne/i,
        morning: /r[áa]no/i,
        afternoon: /odpoledne/i,
        evening: /ve[čc]er/i,
        night: /noc/i
    }
};
const $6f1e6b4fa6e6f193$var$match = $6f1e6b4fa6e6f193$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $6f1e6b4fa6e6f193$var$matchOrdinalNumberPattern,
        parsePattern: $6f1e6b4fa6e6f193$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $6f1e6b4fa6e6f193$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6f1e6b4fa6e6f193$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $6f1e6b4fa6e6f193$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6f1e6b4fa6e6f193$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $6f1e6b4fa6e6f193$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6f1e6b4fa6e6f193$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $6f1e6b4fa6e6f193$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6f1e6b4fa6e6f193$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $6f1e6b4fa6e6f193$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $6f1e6b4fa6e6f193$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("i1bz1", function(module, exports) {

$parcel$export(module.exports, "cy", function () { return $d1e14a5a17eb3cfb$export$aea64bc1b6f8f415; }, function (v) { return $d1e14a5a17eb3cfb$export$aea64bc1b6f8f415 = v; });
var $d1e14a5a17eb3cfb$export$aea64bc1b6f8f415;
"use strict";
$d1e14a5a17eb3cfb$export$aea64bc1b6f8f415 = void 0;

var $hio3Y = parcelRequire("hio3Y");

var $8pRqF = parcelRequire("8pRqF");

var $kxnYp = parcelRequire("kxnYp");

var $6XPpp = parcelRequire("6XPpp");

var $auf7c = parcelRequire("auf7c");
/**
 * @category Locales
 * @summary Welsh locale.
 * @language Welsh
 * @iso-639-2 cym
 * @author Elwyn Malethan [@elmomalmo](https://github.com/elmomalmo)
 */ const $d1e14a5a17eb3cfb$var$cy = $d1e14a5a17eb3cfb$export$aea64bc1b6f8f415 = {
    code: "cy",
    formatDistance: $hio3Y.formatDistance,
    formatLong: $8pRqF.formatLong,
    formatRelative: $kxnYp.formatRelative,
    localize: $6XPpp.localize,
    match: $auf7c.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("hio3Y", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $c976c8830e39d1ed$export$2c14ff85d6318973; }, function (v) { return $c976c8830e39d1ed$export$2c14ff85d6318973 = v; });
var $c976c8830e39d1ed$export$2c14ff85d6318973;
"use strict";
$c976c8830e39d1ed$export$2c14ff85d6318973 = void 0;
const $c976c8830e39d1ed$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "llai na eiliad",
        other: "llai na {{count}} eiliad"
    },
    xSeconds: {
        one: "1 eiliad",
        other: "{{count}} eiliad"
    },
    halfAMinute: "hanner munud",
    lessThanXMinutes: {
        one: "llai na munud",
        two: "llai na 2 funud",
        other: "llai na {{count}} munud"
    },
    xMinutes: {
        one: "1 munud",
        two: "2 funud",
        other: "{{count}} munud"
    },
    aboutXHours: {
        one: "tua 1 awr",
        other: "tua {{count}} awr"
    },
    xHours: {
        one: "1 awr",
        other: "{{count}} awr"
    },
    xDays: {
        one: "1 diwrnod",
        two: "2 ddiwrnod",
        other: "{{count}} diwrnod"
    },
    aboutXWeeks: {
        one: "tua 1 wythnos",
        two: "tua pythefnos",
        other: "tua {{count}} wythnos"
    },
    xWeeks: {
        one: "1 wythnos",
        two: "pythefnos",
        other: "{{count}} wythnos"
    },
    aboutXMonths: {
        one: "tua 1 mis",
        two: "tua 2 fis",
        other: "tua {{count}} mis"
    },
    xMonths: {
        one: "1 mis",
        two: "2 fis",
        other: "{{count}} mis"
    },
    aboutXYears: {
        one: "tua 1 flwyddyn",
        two: "tua 2 flynedd",
        other: "tua {{count}} mlynedd"
    },
    xYears: {
        one: "1 flwyddyn",
        two: "2 flynedd",
        other: "{{count}} mlynedd"
    },
    overXYears: {
        one: "dros 1 flwyddyn",
        two: "dros 2 flynedd",
        other: "dros {{count}} mlynedd"
    },
    almostXYears: {
        one: "bron 1 flwyddyn",
        two: "bron 2 flynedd",
        other: "bron {{count}} mlynedd"
    }
};
const $c976c8830e39d1ed$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $c976c8830e39d1ed$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2 && !!tokenValue.two) result = tokenValue.two;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "mewn " + result;
        else return result + " yn \xf4l";
    }
    return result;
};
$c976c8830e39d1ed$export$2c14ff85d6318973 = $c976c8830e39d1ed$var$formatDistance;

});

parcelRegister("8pRqF", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $620a1a73e0c88b8e$export$cbf60ecb96cbb82f; }, function (v) { return $620a1a73e0c88b8e$export$cbf60ecb96cbb82f = v; });
var $620a1a73e0c88b8e$export$cbf60ecb96cbb82f;
"use strict";
$620a1a73e0c88b8e$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $620a1a73e0c88b8e$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
};
const $620a1a73e0c88b8e$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $620a1a73e0c88b8e$var$dateTimeFormats = {
    full: "{{date}} 'am' {{time}}",
    long: "{{date}} 'am' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $620a1a73e0c88b8e$var$formatLong = $620a1a73e0c88b8e$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $620a1a73e0c88b8e$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $620a1a73e0c88b8e$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $620a1a73e0c88b8e$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("kxnYp", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $ef397c55b4e57fcf$export$8fbbfd65594f46a0; }, function (v) { return $ef397c55b4e57fcf$export$8fbbfd65594f46a0 = v; });
var $ef397c55b4e57fcf$export$8fbbfd65594f46a0;
"use strict";
$ef397c55b4e57fcf$export$8fbbfd65594f46a0 = void 0;
const $ef397c55b4e57fcf$var$formatRelativeLocale = {
    lastWeek: "eeee 'diwethaf am' p",
    yesterday: "'ddoe am' p",
    today: "'heddiw am' p",
    tomorrow: "'yfory am' p",
    nextWeek: "eeee 'am' p",
    other: "P"
};
const $ef397c55b4e57fcf$var$formatRelative = (token, _date, _baseDate, _options)=>$ef397c55b4e57fcf$var$formatRelativeLocale[token];
$ef397c55b4e57fcf$export$8fbbfd65594f46a0 = $ef397c55b4e57fcf$var$formatRelative;

});

parcelRegister("6XPpp", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $51202182a4871da2$export$b3bd0bc58e36cd63; }, function (v) { return $51202182a4871da2$export$b3bd0bc58e36cd63 = v; });
var $51202182a4871da2$export$b3bd0bc58e36cd63;
"use strict";
$51202182a4871da2$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $51202182a4871da2$var$eraValues = {
    narrow: [
        "C",
        "O"
    ],
    abbreviated: [
        "CC",
        "OC"
    ],
    wide: [
        "Cyn Crist",
        "Ar \xf4l Crist"
    ]
};
const $51202182a4871da2$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Ch1",
        "Ch2",
        "Ch3",
        "Ch4"
    ],
    wide: [
        "Chwarter 1af",
        "2ail chwarter",
        "3ydd chwarter",
        "4ydd chwarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $51202182a4871da2$var$monthValues = {
    narrow: [
        "I",
        "Ch",
        "Ma",
        "E",
        "Mi",
        "Me",
        "G",
        "A",
        "Md",
        "H",
        "T",
        "Rh"
    ],
    abbreviated: [
        "Ion",
        "Chwe",
        "Maw",
        "Ebr",
        "Mai",
        "Meh",
        "Gor",
        "Aws",
        "Med",
        "Hyd",
        "Tach",
        "Rhag"
    ],
    wide: [
        "Ionawr",
        "Chwefror",
        "Mawrth",
        "Ebrill",
        "Mai",
        "Mehefin",
        "Gorffennaf",
        "Awst",
        "Medi",
        "Hydref",
        "Tachwedd",
        "Rhagfyr"
    ]
};
const $51202182a4871da2$var$dayValues = {
    narrow: [
        "S",
        "Ll",
        "M",
        "M",
        "I",
        "G",
        "S"
    ],
    short: [
        "Su",
        "Ll",
        "Ma",
        "Me",
        "Ia",
        "Gw",
        "Sa"
    ],
    abbreviated: [
        "Sul",
        "Llun",
        "Maw",
        "Mer",
        "Iau",
        "Gwe",
        "Sad"
    ],
    wide: [
        "dydd Sul",
        "dydd Llun",
        "dydd Mawrth",
        "dydd Mercher",
        "dydd Iau",
        "dydd Gwener",
        "dydd Sadwrn"
    ]
};
const $51202182a4871da2$var$dayPeriodValues = {
    narrow: {
        am: "b",
        pm: "h",
        midnight: "hn",
        noon: "hd",
        morning: "bore",
        afternoon: "prynhawn",
        evening: "gyda'r nos",
        night: "nos"
    },
    abbreviated: {
        am: "yb",
        pm: "yh",
        midnight: "hanner nos",
        noon: "hanner dydd",
        morning: "bore",
        afternoon: "prynhawn",
        evening: "gyda'r nos",
        night: "nos"
    },
    wide: {
        am: "y.b.",
        pm: "y.h.",
        midnight: "hanner nos",
        noon: "hanner dydd",
        morning: "bore",
        afternoon: "prynhawn",
        evening: "gyda'r nos",
        night: "nos"
    }
};
const $51202182a4871da2$var$formattingDayPeriodValues = {
    narrow: {
        am: "b",
        pm: "h",
        midnight: "hn",
        noon: "hd",
        morning: "yn y bore",
        afternoon: "yn y prynhawn",
        evening: "gyda'r nos",
        night: "yn y nos"
    },
    abbreviated: {
        am: "yb",
        pm: "yh",
        midnight: "hanner nos",
        noon: "hanner dydd",
        morning: "yn y bore",
        afternoon: "yn y prynhawn",
        evening: "gyda'r nos",
        night: "yn y nos"
    },
    wide: {
        am: "y.b.",
        pm: "y.h.",
        midnight: "hanner nos",
        noon: "hanner dydd",
        morning: "yn y bore",
        afternoon: "yn y prynhawn",
        evening: "gyda'r nos",
        night: "yn y nos"
    }
};
const $51202182a4871da2$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    if (number < 20) switch(number){
        case 0:
            return number + "fed";
        case 1:
            return number + "af";
        case 2:
            return number + "ail";
        case 3:
        case 4:
            return number + "ydd";
        case 5:
        case 6:
            return number + "ed";
        case 7:
        case 8:
        case 9:
        case 10:
        case 12:
        case 15:
        case 18:
            return number + "fed";
        case 11:
        case 13:
        case 14:
        case 16:
        case 17:
        case 19:
            return number + "eg";
    }
    else if (number >= 50 && number <= 60 || number === 80 || number >= 100) return number + "fed";
    return number + "ain";
};
const $51202182a4871da2$var$localize = $51202182a4871da2$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $51202182a4871da2$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $51202182a4871da2$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $51202182a4871da2$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $51202182a4871da2$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $51202182a4871da2$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $51202182a4871da2$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $51202182a4871da2$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("auf7c", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $7a286e44b80da7f5$export$4659b591c19bdf3d; }, function (v) { return $7a286e44b80da7f5$export$4659b591c19bdf3d = v; });
var $7a286e44b80da7f5$export$4659b591c19bdf3d;
"use strict";
$7a286e44b80da7f5$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $7a286e44b80da7f5$var$matchOrdinalNumberPattern = /^(\d+)(af|ail|ydd|ed|fed|eg|ain)?/i;
const $7a286e44b80da7f5$var$parseOrdinalNumberPattern = /\d+/i;
const $7a286e44b80da7f5$var$matchEraPatterns = {
    narrow: /^(c|o)/i,
    abbreviated: /^(c\.?\s?c\.?|o\.?\s?c\.?)/i,
    wide: /^(cyn christ|ar ôl crist|ar ol crist)/i
};
const $7a286e44b80da7f5$var$parseEraPatterns = {
    wide: [
        /^c/i,
        /^(ar ôl crist|ar ol crist)/i
    ],
    any: [
        /^c/i,
        /^o/i
    ]
};
const $7a286e44b80da7f5$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ch[1234]/i,
    wide: /^(chwarter 1af)|([234](ail|ydd)? chwarter)/i
};
const $7a286e44b80da7f5$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $7a286e44b80da7f5$var$matchMonthPatterns = {
    narrow: /^(i|ch|m|e|g|a|h|t|rh)/i,
    abbreviated: /^(ion|chwe|maw|ebr|mai|meh|gor|aws|med|hyd|tach|rhag)/i,
    wide: /^(ionawr|chwefror|mawrth|ebrill|mai|mehefin|gorffennaf|awst|medi|hydref|tachwedd|rhagfyr)/i
};
const $7a286e44b80da7f5$var$parseMonthPatterns = {
    narrow: [
        /^i/i,
        /^ch/i,
        /^m/i,
        /^e/i,
        /^m/i,
        /^m/i,
        /^g/i,
        /^a/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^rh/i
    ],
    any: [
        /^io/i,
        /^ch/i,
        /^maw/i,
        /^e/i,
        /^mai/i,
        /^meh/i,
        /^g/i,
        /^a/i,
        /^med/i,
        /^h/i,
        /^t/i,
        /^rh/i
    ]
};
const $7a286e44b80da7f5$var$matchDayPatterns = {
    narrow: /^(s|ll|m|i|g)/i,
    short: /^(su|ll|ma|me|ia|gw|sa)/i,
    abbreviated: /^(sul|llun|maw|mer|iau|gwe|sad)/i,
    wide: /^dydd (sul|llun|mawrth|mercher|iau|gwener|sadwrn)/i
};
const $7a286e44b80da7f5$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^ll/i,
        /^m/i,
        /^m/i,
        /^i/i,
        /^g/i,
        /^s/i
    ],
    wide: [
        /^dydd su/i,
        /^dydd ll/i,
        /^dydd ma/i,
        /^dydd me/i,
        /^dydd i/i,
        /^dydd g/i,
        /^dydd sa/i
    ],
    any: [
        /^su/i,
        /^ll/i,
        /^ma/i,
        /^me/i,
        /^i/i,
        /^g/i,
        /^sa/i
    ]
};
const $7a286e44b80da7f5$var$matchDayPeriodPatterns = {
    narrow: /^(b|h|hn|hd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i,
    any: /^(y\.?\s?[bh]\.?|hanner nos|hanner dydd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i
};
const $7a286e44b80da7f5$var$parseDayPeriodPatterns = {
    any: {
        am: /^b|(y\.?\s?b\.?)/i,
        pm: /^h|(y\.?\s?h\.?)|(yr hwyr)/i,
        midnight: /^hn|hanner nos/i,
        noon: /^hd|hanner dydd/i,
        morning: /bore/i,
        afternoon: /prynhawn/i,
        evening: /^gyda'r nos$/i,
        night: /blah/i
    }
};
const $7a286e44b80da7f5$var$match = $7a286e44b80da7f5$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $7a286e44b80da7f5$var$matchOrdinalNumberPattern,
        parsePattern: $7a286e44b80da7f5$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $7a286e44b80da7f5$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7a286e44b80da7f5$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $7a286e44b80da7f5$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7a286e44b80da7f5$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $7a286e44b80da7f5$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7a286e44b80da7f5$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $7a286e44b80da7f5$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7a286e44b80da7f5$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $7a286e44b80da7f5$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $7a286e44b80da7f5$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("dLzgU", function(module, exports) {

$parcel$export(module.exports, "da", function () { return $a05b06669ffc2851$export$8c8450b83b664ba4; }, function (v) { return $a05b06669ffc2851$export$8c8450b83b664ba4 = v; });
var $a05b06669ffc2851$export$8c8450b83b664ba4;
"use strict";
$a05b06669ffc2851$export$8c8450b83b664ba4 = void 0;

var $eHXpe = parcelRequire("eHXpe");

var $bEO62 = parcelRequire("bEO62");

var $chLM1 = parcelRequire("chLM1");

var $gcsbQ = parcelRequire("gcsbQ");

var $3j8Lk = parcelRequire("3j8Lk");
/**
 * @category Locales
 * @summary Danish locale.
 * @language Danish
 * @iso-639-2 dan
 * @author Mathias Wøbbe [@MathiasKandelborg](https://github.com/MathiasKandelborg)
 * @author Anders B. Hansen [@Andersbiha](https://github.com/Andersbiha)
 * @author [@kgram](https://github.com/kgram)
 * @author [@stefanbugge](https://github.com/stefanbugge)
 */ const $a05b06669ffc2851$var$da = $a05b06669ffc2851$export$8c8450b83b664ba4 = {
    code: "da",
    formatDistance: $eHXpe.formatDistance,
    formatLong: $bEO62.formatLong,
    formatRelative: $chLM1.formatRelative,
    localize: $gcsbQ.localize,
    match: $3j8Lk.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("eHXpe", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $ab53299e39ca861b$export$2c14ff85d6318973; }, function (v) { return $ab53299e39ca861b$export$2c14ff85d6318973 = v; });
var $ab53299e39ca861b$export$2c14ff85d6318973;
"use strict";
$ab53299e39ca861b$export$2c14ff85d6318973 = void 0;
const $ab53299e39ca861b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre end \xe9t sekund",
        other: "mindre end {{count}} sekunder"
    },
    xSeconds: {
        one: "1 sekund",
        other: "{{count}} sekunder"
    },
    halfAMinute: "\xe9t halvt minut",
    lessThanXMinutes: {
        one: "mindre end \xe9t minut",
        other: "mindre end {{count}} minutter"
    },
    xMinutes: {
        one: "1 minut",
        other: "{{count}} minutter"
    },
    aboutXHours: {
        one: "cirka 1 time",
        other: "cirka {{count}} timer"
    },
    xHours: {
        one: "1 time",
        other: "{{count}} timer"
    },
    xDays: {
        one: "1 dag",
        other: "{{count}} dage"
    },
    aboutXWeeks: {
        one: "cirka 1 uge",
        other: "cirka {{count}} uger"
    },
    xWeeks: {
        one: "1 uge",
        other: "{{count}} uger"
    },
    aboutXMonths: {
        one: "cirka 1 m\xe5ned",
        other: "cirka {{count}} m\xe5neder"
    },
    xMonths: {
        one: "1 m\xe5ned",
        other: "{{count}} m\xe5neder"
    },
    aboutXYears: {
        one: "cirka 1 \xe5r",
        other: "cirka {{count}} \xe5r"
    },
    xYears: {
        one: "1 \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over 1 \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "n\xe6sten 1 \xe5r",
        other: "n\xe6sten {{count}} \xe5r"
    }
};
const $ab53299e39ca861b$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $ab53299e39ca861b$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "om " + result;
        else return result + " siden";
    }
    return result;
};
$ab53299e39ca861b$export$2c14ff85d6318973 = $ab53299e39ca861b$var$formatDistance;

});

parcelRegister("bEO62", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $87ca4a3dfb745787$export$cbf60ecb96cbb82f; }, function (v) { return $87ca4a3dfb745787$export$cbf60ecb96cbb82f = v; });
var $87ca4a3dfb745787$export$cbf60ecb96cbb82f;
"use strict";
$87ca4a3dfb745787$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $87ca4a3dfb745787$var$dateFormats = {
    full: "EEEE 'den' d. MMMM y",
    long: "d. MMMM y",
    medium: "d. MMM y",
    short: "dd/MM/y"
};
const $87ca4a3dfb745787$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $87ca4a3dfb745787$var$dateTimeFormats = {
    full: "{{date}} 'kl'. {{time}}",
    long: "{{date}} 'kl'. {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $87ca4a3dfb745787$var$formatLong = $87ca4a3dfb745787$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $87ca4a3dfb745787$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $87ca4a3dfb745787$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $87ca4a3dfb745787$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("chLM1", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $8f1c216854e6d40f$export$8fbbfd65594f46a0; }, function (v) { return $8f1c216854e6d40f$export$8fbbfd65594f46a0 = v; });
var $8f1c216854e6d40f$export$8fbbfd65594f46a0;
"use strict";
$8f1c216854e6d40f$export$8fbbfd65594f46a0 = void 0;
const $8f1c216854e6d40f$var$formatRelativeLocale = {
    lastWeek: "'sidste' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "'p\xe5' eeee 'kl.' p",
    other: "P"
};
const $8f1c216854e6d40f$var$formatRelative = (token, _date, _baseDate, _options)=>$8f1c216854e6d40f$var$formatRelativeLocale[token];
$8f1c216854e6d40f$export$8fbbfd65594f46a0 = $8f1c216854e6d40f$var$formatRelative;

});

parcelRegister("gcsbQ", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $bcb3a242f57912ee$export$b3bd0bc58e36cd63; }, function (v) { return $bcb3a242f57912ee$export$b3bd0bc58e36cd63 = v; });
var $bcb3a242f57912ee$export$b3bd0bc58e36cd63;
"use strict";
$bcb3a242f57912ee$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $bcb3a242f57912ee$var$eraValues = {
    narrow: [
        "fvt",
        "vt"
    ],
    abbreviated: [
        "f.v.t.",
        "v.t."
    ],
    wide: [
        "f\xf8r vesterlandsk tidsregning",
        "vesterlandsk tidsregning"
    ]
};
const $bcb3a242f57912ee$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1. kvt.",
        "2. kvt.",
        "3. kvt.",
        "4. kvt."
    ],
    wide: [
        "1. kvartal",
        "2. kvartal",
        "3. kvartal",
        "4. kvartal"
    ]
};
const $bcb3a242f57912ee$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mar.",
        "apr.",
        "maj",
        "jun.",
        "jul.",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "januar",
        "februar",
        "marts",
        "april",
        "maj",
        "juni",
        "juli",
        "august",
        "september",
        "oktober",
        "november",
        "december"
    ]
};
// Note that 'Days - abbreviated - Formatting' has periods at the end.
// https://www.unicode.org/cldr/charts/32/summary/da.html#1760
// This makes grammatical sense in danish, as most abbreviations have periods.
const $bcb3a242f57912ee$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "O",
        "T",
        "F",
        "L"
    ],
    short: [
        "s\xf8",
        "ma",
        "ti",
        "on",
        "to",
        "fr",
        "l\xf8"
    ],
    abbreviated: [
        "s\xf8n.",
        "man.",
        "tir.",
        "ons.",
        "tor.",
        "fre.",
        "l\xf8r."
    ],
    wide: [
        "s\xf8ndag",
        "mandag",
        "tirsdag",
        "onsdag",
        "torsdag",
        "fredag",
        "l\xf8rdag"
    ]
};
const $bcb3a242f57912ee$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "midnat",
        noon: "middag",
        morning: "morgen",
        afternoon: "eftermiddag",
        evening: "aften",
        night: "nat"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnat",
        noon: "middag",
        morning: "morgen",
        afternoon: "eftermiddag",
        evening: "aften",
        night: "nat"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnat",
        noon: "middag",
        morning: "morgen",
        afternoon: "eftermiddag",
        evening: "aften",
        night: "nat"
    }
};
const $bcb3a242f57912ee$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "midnat",
        noon: "middag",
        morning: "om morgenen",
        afternoon: "om eftermiddagen",
        evening: "om aftenen",
        night: "om natten"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnat",
        noon: "middag",
        morning: "om morgenen",
        afternoon: "om eftermiddagen",
        evening: "om aftenen",
        night: "om natten"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnat",
        noon: "middag",
        morning: "om morgenen",
        afternoon: "om eftermiddagen",
        evening: "om aftenen",
        night: "om natten"
    }
};
const $bcb3a242f57912ee$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $bcb3a242f57912ee$var$localize = $bcb3a242f57912ee$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $bcb3a242f57912ee$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $bcb3a242f57912ee$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $bcb3a242f57912ee$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $bcb3a242f57912ee$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $bcb3a242f57912ee$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $bcb3a242f57912ee$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $bcb3a242f57912ee$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("3j8Lk", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $2689f17805f1ce04$export$4659b591c19bdf3d; }, function (v) { return $2689f17805f1ce04$export$4659b591c19bdf3d = v; });
var $2689f17805f1ce04$export$4659b591c19bdf3d;
"use strict";
$2689f17805f1ce04$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $2689f17805f1ce04$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
const $2689f17805f1ce04$var$parseOrdinalNumberPattern = /\d+/i;
const $2689f17805f1ce04$var$matchEraPatterns = {
    narrow: /^(fKr|fvt|eKr|vt)/i,
    abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
    wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
};
const $2689f17805f1ce04$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^(v|e)/i
    ]
};
const $2689f17805f1ce04$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]. kvt\./i,
    wide: /^[1234]\.? kvartal/i
};
const $2689f17805f1ce04$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $2689f17805f1ce04$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
};
const $2689f17805f1ce04$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $2689f17805f1ce04$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
const $2689f17805f1ce04$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^o/i,
        /^t/i,
        /^f/i,
        /^l/i
    ],
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
const $2689f17805f1ce04$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
    any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
};
const $2689f17805f1ce04$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /midnat/i,
        noon: /middag/i,
        morning: /morgen/i,
        afternoon: /eftermiddag/i,
        evening: /aften/i,
        night: /nat/i
    }
};
const $2689f17805f1ce04$var$match = $2689f17805f1ce04$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $2689f17805f1ce04$var$matchOrdinalNumberPattern,
        parsePattern: $2689f17805f1ce04$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $2689f17805f1ce04$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2689f17805f1ce04$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $2689f17805f1ce04$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2689f17805f1ce04$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $2689f17805f1ce04$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2689f17805f1ce04$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $2689f17805f1ce04$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2689f17805f1ce04$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $2689f17805f1ce04$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $2689f17805f1ce04$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("krzq3", function(module, exports) {

$parcel$export(module.exports, "de", function () { return $ee21cdc2a38dd9ee$export$2fa162a495d26869; }, function (v) { return $ee21cdc2a38dd9ee$export$2fa162a495d26869 = v; });
var $ee21cdc2a38dd9ee$export$2fa162a495d26869;
"use strict";
$ee21cdc2a38dd9ee$export$2fa162a495d26869 = void 0;

var $kWtjq = parcelRequire("kWtjq");

var $a3c6A = parcelRequire("a3c6A");

var $dmaSa = parcelRequire("dmaSa");

var $jFBPb = parcelRequire("jFBPb");

var $adBMI = parcelRequire("adBMI");
/**
 * @category Locales
 * @summary German locale.
 * @language German
 * @iso-639-2 deu
 * @author Thomas Eilmsteiner [@DeMuu](https://github.com/DeMuu)
 * @author Asia [@asia-t](https://github.com/asia-t)
 * @author Van Vuong Ngo [@vanvuongngo](https://github.com/vanvuongngo)
 * @author RomanErnst [@pex](https://github.com/pex)
 * @author Philipp Keck [@Philipp91](https://github.com/Philipp91)
 */ const $ee21cdc2a38dd9ee$var$de = $ee21cdc2a38dd9ee$export$2fa162a495d26869 = {
    code: "de",
    formatDistance: $kWtjq.formatDistance,
    formatLong: $a3c6A.formatLong,
    formatRelative: $dmaSa.formatRelative,
    localize: $jFBPb.localize,
    match: $adBMI.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("kWtjq", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $f3eff63e289924a8$export$2c14ff85d6318973; }, function (v) { return $f3eff63e289924a8$export$2c14ff85d6318973 = v; });
var $f3eff63e289924a8$export$2c14ff85d6318973;
"use strict";
$f3eff63e289924a8$export$2c14ff85d6318973 = void 0;
const $f3eff63e289924a8$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "weniger als 1 Sekunde",
            other: "weniger als {{count}} Sekunden"
        },
        withPreposition: {
            one: "weniger als 1 Sekunde",
            other: "weniger als {{count}} Sekunden"
        }
    },
    xSeconds: {
        standalone: {
            one: "1 Sekunde",
            other: "{{count}} Sekunden"
        },
        withPreposition: {
            one: "1 Sekunde",
            other: "{{count}} Sekunden"
        }
    },
    halfAMinute: {
        standalone: "eine halbe Minute",
        withPreposition: "einer halben Minute"
    },
    lessThanXMinutes: {
        standalone: {
            one: "weniger als 1 Minute",
            other: "weniger als {{count}} Minuten"
        },
        withPreposition: {
            one: "weniger als 1 Minute",
            other: "weniger als {{count}} Minuten"
        }
    },
    xMinutes: {
        standalone: {
            one: "1 Minute",
            other: "{{count}} Minuten"
        },
        withPreposition: {
            one: "1 Minute",
            other: "{{count}} Minuten"
        }
    },
    aboutXHours: {
        standalone: {
            one: "etwa 1 Stunde",
            other: "etwa {{count}} Stunden"
        },
        withPreposition: {
            one: "etwa 1 Stunde",
            other: "etwa {{count}} Stunden"
        }
    },
    xHours: {
        standalone: {
            one: "1 Stunde",
            other: "{{count}} Stunden"
        },
        withPreposition: {
            one: "1 Stunde",
            other: "{{count}} Stunden"
        }
    },
    xDays: {
        standalone: {
            one: "1 Tag",
            other: "{{count}} Tage"
        },
        withPreposition: {
            one: "1 Tag",
            other: "{{count}} Tagen"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "etwa 1 Woche",
            other: "etwa {{count}} Wochen"
        },
        withPreposition: {
            one: "etwa 1 Woche",
            other: "etwa {{count}} Wochen"
        }
    },
    xWeeks: {
        standalone: {
            one: "1 Woche",
            other: "{{count}} Wochen"
        },
        withPreposition: {
            one: "1 Woche",
            other: "{{count}} Wochen"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "etwa 1 Monat",
            other: "etwa {{count}} Monate"
        },
        withPreposition: {
            one: "etwa 1 Monat",
            other: "etwa {{count}} Monaten"
        }
    },
    xMonths: {
        standalone: {
            one: "1 Monat",
            other: "{{count}} Monate"
        },
        withPreposition: {
            one: "1 Monat",
            other: "{{count}} Monaten"
        }
    },
    aboutXYears: {
        standalone: {
            one: "etwa 1 Jahr",
            other: "etwa {{count}} Jahre"
        },
        withPreposition: {
            one: "etwa 1 Jahr",
            other: "etwa {{count}} Jahren"
        }
    },
    xYears: {
        standalone: {
            one: "1 Jahr",
            other: "{{count}} Jahre"
        },
        withPreposition: {
            one: "1 Jahr",
            other: "{{count}} Jahren"
        }
    },
    overXYears: {
        standalone: {
            one: "mehr als 1 Jahr",
            other: "mehr als {{count}} Jahre"
        },
        withPreposition: {
            one: "mehr als 1 Jahr",
            other: "mehr als {{count}} Jahren"
        }
    },
    almostXYears: {
        standalone: {
            one: "fast 1 Jahr",
            other: "fast {{count}} Jahre"
        },
        withPreposition: {
            one: "fast 1 Jahr",
            other: "fast {{count}} Jahren"
        }
    }
};
const $f3eff63e289924a8$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = options?.addSuffix ? $f3eff63e289924a8$var$formatDistanceLocale[token].withPreposition : $f3eff63e289924a8$var$formatDistanceLocale[token].standalone;
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return "vor " + result;
    }
    return result;
};
$f3eff63e289924a8$export$2c14ff85d6318973 = $f3eff63e289924a8$var$formatDistance;

});

parcelRegister("a3c6A", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $7513930d0fba53b6$export$cbf60ecb96cbb82f; }, function (v) { return $7513930d0fba53b6$export$cbf60ecb96cbb82f = v; });
var $7513930d0fba53b6$export$cbf60ecb96cbb82f;
"use strict";
$7513930d0fba53b6$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
// DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008
const $7513930d0fba53b6$var$dateFormats = {
    full: "EEEE, do MMMM y",
    long: "do MMMM y",
    medium: "do MMM y",
    short: "dd.MM.y"
};
const $7513930d0fba53b6$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $7513930d0fba53b6$var$dateTimeFormats = {
    full: "{{date}} 'um' {{time}}",
    long: "{{date}} 'um' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $7513930d0fba53b6$var$formatLong = $7513930d0fba53b6$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $7513930d0fba53b6$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $7513930d0fba53b6$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $7513930d0fba53b6$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("dmaSa", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $9b95c38adac87a8c$export$8fbbfd65594f46a0; }, function (v) { return $9b95c38adac87a8c$export$8fbbfd65594f46a0 = v; });
var $9b95c38adac87a8c$export$8fbbfd65594f46a0;
"use strict";
$9b95c38adac87a8c$export$8fbbfd65594f46a0 = void 0;
const $9b95c38adac87a8c$var$formatRelativeLocale = {
    lastWeek: "'letzten' eeee 'um' p",
    yesterday: "'gestern um' p",
    today: "'heute um' p",
    tomorrow: "'morgen um' p",
    nextWeek: "eeee 'um' p",
    other: "P"
};
const $9b95c38adac87a8c$var$formatRelative = (token, _date, _baseDate, _options)=>$9b95c38adac87a8c$var$formatRelativeLocale[token];
$9b95c38adac87a8c$export$8fbbfd65594f46a0 = $9b95c38adac87a8c$var$formatRelative;

});

parcelRegister("jFBPb", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $e51f2fd154d58a64$export$b3bd0bc58e36cd63; }, function (v) { return $e51f2fd154d58a64$export$b3bd0bc58e36cd63 = v; });
var $e51f2fd154d58a64$export$b3bd0bc58e36cd63;
"use strict";
$e51f2fd154d58a64$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $e51f2fd154d58a64$var$eraValues = {
    narrow: [
        "v.Chr.",
        "n.Chr."
    ],
    abbreviated: [
        "v.Chr.",
        "n.Chr."
    ],
    wide: [
        "vor Christus",
        "nach Christus"
    ]
};
const $e51f2fd154d58a64$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. Quartal",
        "2. Quartal",
        "3. Quartal",
        "4. Quartal"
    ]
};
// Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $e51f2fd154d58a64$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "M\xe4r",
        "Apr",
        "Mai",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Dez"
    ],
    wide: [
        "Januar",
        "Februar",
        "M\xe4rz",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember"
    ]
};
// https://st.unicode.org/cldr-apps/v#/de/Gregorian/
const $e51f2fd154d58a64$var$formattingMonthValues = {
    narrow: $e51f2fd154d58a64$var$monthValues.narrow,
    abbreviated: [
        "Jan.",
        "Feb.",
        "M\xe4rz",
        "Apr.",
        "Mai",
        "Juni",
        "Juli",
        "Aug.",
        "Sep.",
        "Okt.",
        "Nov.",
        "Dez."
    ],
    wide: $e51f2fd154d58a64$var$monthValues.wide
};
const $e51f2fd154d58a64$var$dayValues = {
    narrow: [
        "S",
        "M",
        "D",
        "M",
        "D",
        "F",
        "S"
    ],
    short: [
        "So",
        "Mo",
        "Di",
        "Mi",
        "Do",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "So.",
        "Mo.",
        "Di.",
        "Mi.",
        "Do.",
        "Fr.",
        "Sa."
    ],
    wide: [
        "Sonntag",
        "Montag",
        "Dienstag",
        "Mittwoch",
        "Donnerstag",
        "Freitag",
        "Samstag"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/de.html#1881
const $e51f2fd154d58a64$var$dayPeriodValues = {
    narrow: {
        am: "vm.",
        pm: "nm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachm.",
        evening: "Abend",
        night: "Nacht"
    },
    abbreviated: {
        am: "vorm.",
        pm: "nachm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachmittag",
        evening: "Abend",
        night: "Nacht"
    },
    wide: {
        am: "vormittags",
        pm: "nachmittags",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachmittag",
        evening: "Abend",
        night: "Nacht"
    }
};
const $e51f2fd154d58a64$var$formattingDayPeriodValues = {
    narrow: {
        am: "vm.",
        pm: "nm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachm.",
        evening: "abends",
        night: "nachts"
    },
    abbreviated: {
        am: "vorm.",
        pm: "nachm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachmittags",
        evening: "abends",
        night: "nachts"
    },
    wide: {
        am: "vormittags",
        pm: "nachmittags",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachmittags",
        evening: "abends",
        night: "nachts"
    }
};
const $e51f2fd154d58a64$var$ordinalNumber = (dirtyNumber)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $e51f2fd154d58a64$var$localize = $e51f2fd154d58a64$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $e51f2fd154d58a64$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $e51f2fd154d58a64$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $e51f2fd154d58a64$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $e51f2fd154d58a64$var$monthValues,
        formattingValues: $e51f2fd154d58a64$var$formattingMonthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $e51f2fd154d58a64$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $e51f2fd154d58a64$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $e51f2fd154d58a64$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("adBMI", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $77086d888cb47557$export$4659b591c19bdf3d; }, function (v) { return $77086d888cb47557$export$4659b591c19bdf3d = v; });
var $77086d888cb47557$export$4659b591c19bdf3d;
"use strict";
$77086d888cb47557$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $77086d888cb47557$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
const $77086d888cb47557$var$parseOrdinalNumberPattern = /\d+/i;
const $77086d888cb47557$var$matchEraPatterns = {
    narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
};
const $77086d888cb47557$var$parseEraPatterns = {
    any: [
        /^v/i,
        /^n/i
    ]
};
const $77086d888cb47557$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? Quartal/i
};
const $77086d888cb47557$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $77086d888cb47557$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
    wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
};
const $77086d888cb47557$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^j[aä]/i,
        /^f/i,
        /^mär/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $77086d888cb47557$var$matchDayPatterns = {
    narrow: /^[smdmf]/i,
    short: /^(so|mo|di|mi|do|fr|sa)/i,
    abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
    wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
};
const $77086d888cb47557$var$parseDayPatterns = {
    any: [
        /^so/i,
        /^mo/i,
        /^di/i,
        /^mi/i,
        /^do/i,
        /^f/i,
        /^sa/i
    ]
};
const $77086d888cb47557$var$matchDayPeriodPatterns = {
    narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
};
const $77086d888cb47557$var$parseDayPeriodPatterns = {
    any: {
        am: /^v/i,
        pm: /^n/i,
        midnight: /^Mitte/i,
        noon: /^Mitta/i,
        morning: /morgens/i,
        afternoon: /nachmittags/i,
        evening: /abends/i,
        night: /nachts/i
    }
};
const $77086d888cb47557$var$match = $77086d888cb47557$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $77086d888cb47557$var$matchOrdinalNumberPattern,
        parsePattern: $77086d888cb47557$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $77086d888cb47557$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $77086d888cb47557$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $77086d888cb47557$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $77086d888cb47557$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $77086d888cb47557$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $77086d888cb47557$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $77086d888cb47557$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $77086d888cb47557$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $77086d888cb47557$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $77086d888cb47557$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("1EeVN", function(module, exports) {

$parcel$export(module.exports, "deAT", function () { return $13351beaa06a5a52$export$4de28f36c5657e35; }, function (v) { return $13351beaa06a5a52$export$4de28f36c5657e35 = v; });
var $13351beaa06a5a52$export$4de28f36c5657e35;
"use strict";
$13351beaa06a5a52$export$4de28f36c5657e35 = void 0;

var $kWtjq = parcelRequire("kWtjq");

var $a3c6A = parcelRequire("a3c6A");

var $dmaSa = parcelRequire("dmaSa");

var $adBMI = parcelRequire("adBMI");

var $k4JcO = parcelRequire("k4JcO");
/**
 * @category Locales
 * @summary German locale (Austria).
 * @language German
 * @iso-639-2 deu
 * @author Christoph Tobias Stenglein [@cstenglein](https://github.com/cstenglein)
 */ const $13351beaa06a5a52$var$deAT = $13351beaa06a5a52$export$4de28f36c5657e35 = {
    code: "de-AT",
    formatDistance: $kWtjq.formatDistance,
    formatLong: $a3c6A.formatLong,
    formatRelative: $dmaSa.formatRelative,
    localize: $k4JcO.localize,
    match: $adBMI.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("k4JcO", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $e9d73f43b35c45a4$export$b3bd0bc58e36cd63; }, function (v) { return $e9d73f43b35c45a4$export$b3bd0bc58e36cd63 = v; });
var $e9d73f43b35c45a4$export$b3bd0bc58e36cd63;
"use strict";
$e9d73f43b35c45a4$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $e9d73f43b35c45a4$var$eraValues = {
    narrow: [
        "v.Chr.",
        "n.Chr."
    ],
    abbreviated: [
        "v.Chr.",
        "n.Chr."
    ],
    wide: [
        "vor Christus",
        "nach Christus"
    ]
};
const $e9d73f43b35c45a4$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. Quartal",
        "2. Quartal",
        "3. Quartal",
        "4. Quartal"
    ]
};
// Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $e9d73f43b35c45a4$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "J\xe4n",
        "Feb",
        "M\xe4r",
        "Apr",
        "Mai",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Dez"
    ],
    wide: [
        "J\xe4nner",
        "Februar",
        "M\xe4rz",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember"
    ]
};
// https://st.unicode.org/cldr-apps/v#/de_AT/Gregorian/
const $e9d73f43b35c45a4$var$formattingMonthValues = {
    narrow: $e9d73f43b35c45a4$var$monthValues.narrow,
    abbreviated: [
        "J\xe4n.",
        "Feb.",
        "M\xe4rz",
        "Apr.",
        "Mai",
        "Juni",
        "Juli",
        "Aug.",
        "Sep.",
        "Okt.",
        "Nov.",
        "Dez."
    ],
    wide: $e9d73f43b35c45a4$var$monthValues.wide
};
const $e9d73f43b35c45a4$var$dayValues = {
    narrow: [
        "S",
        "M",
        "D",
        "M",
        "D",
        "F",
        "S"
    ],
    short: [
        "So",
        "Mo",
        "Di",
        "Mi",
        "Do",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "So.",
        "Mo.",
        "Di.",
        "Mi.",
        "Do.",
        "Fr.",
        "Sa."
    ],
    wide: [
        "Sonntag",
        "Montag",
        "Dienstag",
        "Mittwoch",
        "Donnerstag",
        "Freitag",
        "Samstag"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/de.html#1881
const $e9d73f43b35c45a4$var$dayPeriodValues = {
    narrow: {
        am: "vm.",
        pm: "nm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachm.",
        evening: "Abend",
        night: "Nacht"
    },
    abbreviated: {
        am: "vorm.",
        pm: "nachm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachmittag",
        evening: "Abend",
        night: "Nacht"
    },
    wide: {
        am: "vormittags",
        pm: "nachmittags",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachmittag",
        evening: "Abend",
        night: "Nacht"
    }
};
const $e9d73f43b35c45a4$var$formattingDayPeriodValues = {
    narrow: {
        am: "vm.",
        pm: "nm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachm.",
        evening: "abends",
        night: "nachts"
    },
    abbreviated: {
        am: "vorm.",
        pm: "nachm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachmittags",
        evening: "abends",
        night: "nachts"
    },
    wide: {
        am: "vormittags",
        pm: "nachmittags",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachmittags",
        evening: "abends",
        night: "nachts"
    }
};
const $e9d73f43b35c45a4$var$ordinalNumber = (dirtyNumber)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $e9d73f43b35c45a4$var$localize = $e9d73f43b35c45a4$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $e9d73f43b35c45a4$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $e9d73f43b35c45a4$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $e9d73f43b35c45a4$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $e9d73f43b35c45a4$var$monthValues,
        formattingValues: $e9d73f43b35c45a4$var$formattingMonthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $e9d73f43b35c45a4$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $e9d73f43b35c45a4$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $e9d73f43b35c45a4$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});


parcelRegister("8o3oF", function(module, exports) {

$parcel$export(module.exports, "el", function () { return $61b333293852ba93$export$c3da0dad1b44eea9; }, function (v) { return $61b333293852ba93$export$c3da0dad1b44eea9 = v; });
var $61b333293852ba93$export$c3da0dad1b44eea9;
"use strict";
$61b333293852ba93$export$c3da0dad1b44eea9 = void 0;

var $laLQu = parcelRequire("laLQu");

var $btR2N = parcelRequire("btR2N");

var $bcP91 = parcelRequire("bcP91");

var $9PdIs = parcelRequire("9PdIs");

var $6jVp1 = parcelRequire("6jVp1");
/**
 * @category Locales
 * @summary Greek locale.
 * @language Greek
 * @iso-639-2 ell
 * @author Fanis Katsimpas [@fanixk](https://github.com/fanixk)
 * @author Theodoros Orfanidis [@teoulas](https://github.com/teoulas)
 */ const $61b333293852ba93$var$el = $61b333293852ba93$export$c3da0dad1b44eea9 = {
    code: "el",
    formatDistance: $laLQu.formatDistance,
    formatLong: $btR2N.formatLong,
    formatRelative: $bcP91.formatRelative,
    localize: $9PdIs.localize,
    match: $6jVp1.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("laLQu", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $f69fa54daf9a567d$export$2c14ff85d6318973; }, function (v) { return $f69fa54daf9a567d$export$2c14ff85d6318973 = v; });
var $f69fa54daf9a567d$export$2c14ff85d6318973;
"use strict";
$f69fa54daf9a567d$export$2c14ff85d6318973 = void 0;
const $f69fa54daf9a567d$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC \u03AD\u03BD\u03B1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
        other: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {{count}} \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1"
    },
    xSeconds: {
        one: "1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
        other: "{{count}} \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1"
    },
    halfAMinute: "\u03BC\u03B9\u03C3\u03CC \u03BB\u03B5\u03C0\u03C4\u03CC",
    lessThanXMinutes: {
        one: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC \u03AD\u03BD\u03B1 \u03BB\u03B5\u03C0\u03C4\u03CC",
        other: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {{count}} \u03BB\u03B5\u03C0\u03C4\u03AC"
    },
    xMinutes: {
        one: "1 \u03BB\u03B5\u03C0\u03C4\u03CC",
        other: "{{count}} \u03BB\u03B5\u03C0\u03C4\u03AC"
    },
    aboutXHours: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03CE\u03C1\u03B1",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03CE\u03C1\u03B5\u03C2"
    },
    xHours: {
        one: "1 \u03CE\u03C1\u03B1",
        other: "{{count}} \u03CE\u03C1\u03B5\u03C2"
    },
    xDays: {
        one: "1 \u03B7\u03BC\u03AD\u03C1\u03B1",
        other: "{{count}} \u03B7\u03BC\u03AD\u03C1\u03B5\u03C2"
    },
    aboutXWeeks: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2"
    },
    xWeeks: {
        one: "1 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1",
        other: "{{count}} \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2"
    },
    aboutXMonths: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03BC\u03AE\u03BD\u03B1\u03C2",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03BC\u03AE\u03BD\u03B5\u03C2"
    },
    xMonths: {
        one: "1 \u03BC\u03AE\u03BD\u03B1\u03C2",
        other: "{{count}} \u03BC\u03AE\u03BD\u03B5\u03C2"
    },
    aboutXYears: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    },
    xYears: {
        one: "1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "{{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    },
    overXYears: {
        one: "\u03C0\u03AC\u03BD\u03C9 \u03B1\u03C0\u03CC 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "\u03C0\u03AC\u03BD\u03C9 \u03B1\u03C0\u03CC {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    },
    almostXYears: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    }
};
const $f69fa54daf9a567d$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $f69fa54daf9a567d$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u03C3\u03B5 " + result;
        else return result + " \u03C0\u03C1\u03B9\u03BD";
    }
    return result;
};
$f69fa54daf9a567d$export$2c14ff85d6318973 = $f69fa54daf9a567d$var$formatDistance;

});

parcelRegister("btR2N", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $85bb8c974631d592$export$cbf60ecb96cbb82f; }, function (v) { return $85bb8c974631d592$export$cbf60ecb96cbb82f = v; });
var $85bb8c974631d592$export$cbf60ecb96cbb82f;
"use strict";
$85bb8c974631d592$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $85bb8c974631d592$var$dateFormats = {
    full: "EEEE, d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "d/M/yy"
};
const $85bb8c974631d592$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $85bb8c974631d592$var$dateTimeFormats = {
    full: "{{date}} - {{time}}",
    long: "{{date}} - {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $85bb8c974631d592$var$formatLong = $85bb8c974631d592$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $85bb8c974631d592$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $85bb8c974631d592$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $85bb8c974631d592$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("bcP91", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $82887cf1ae2abb35$export$8fbbfd65594f46a0; }, function (v) { return $82887cf1ae2abb35$export$8fbbfd65594f46a0 = v; });
var $82887cf1ae2abb35$export$8fbbfd65594f46a0;
"use strict";
$82887cf1ae2abb35$export$8fbbfd65594f46a0 = void 0;
const $82887cf1ae2abb35$var$formatRelativeLocale = {
    lastWeek: (date)=>{
        switch(date.getDay()){
            case 6:
                return "'\u03C4\u03BF \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03BF' eeee '\u03C3\u03C4\u03B9\u03C2' p";
            default:
                return "'\u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7' eeee '\u03C3\u03C4\u03B9\u03C2' p";
        }
    },
    yesterday: "'\u03C7\u03B8\u03B5\u03C2 \u03C3\u03C4\u03B9\u03C2' p",
    today: "'\u03C3\u03AE\u03BC\u03B5\u03C1\u03B1 \u03C3\u03C4\u03B9\u03C2' p",
    tomorrow: "'\u03B1\u03CD\u03C1\u03B9\u03BF \u03C3\u03C4\u03B9\u03C2' p",
    nextWeek: "eeee '\u03C3\u03C4\u03B9\u03C2' p",
    other: "P"
};
const $82887cf1ae2abb35$var$formatRelative = (token, date)=>{
    const format = $82887cf1ae2abb35$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
$82887cf1ae2abb35$export$8fbbfd65594f46a0 = $82887cf1ae2abb35$var$formatRelative;

});

parcelRegister("9PdIs", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $72738438092d6ed7$export$b3bd0bc58e36cd63; }, function (v) { return $72738438092d6ed7$export$b3bd0bc58e36cd63 = v; });
var $72738438092d6ed7$export$b3bd0bc58e36cd63;
"use strict";
$72738438092d6ed7$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $72738438092d6ed7$var$eraValues = {
    narrow: [
        "\u03C0\u03A7",
        "\u03BC\u03A7"
    ],
    abbreviated: [
        "\u03C0.\u03A7.",
        "\u03BC.\u03A7."
    ],
    wide: [
        "\u03C0\u03C1\u03BF \u03A7\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD",
        "\u03BC\u03B5\u03C4\u03AC \u03A7\u03C1\u03B9\u03C3\u03C4\u03CC\u03BD"
    ]
};
const $72738438092d6ed7$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u03A41",
        "\u03A42",
        "\u03A43",
        "\u03A44"
    ],
    wide: [
        "1\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF",
        "2\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF",
        "3\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF",
        "4\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF"
    ]
};
const $72738438092d6ed7$var$monthValues = {
    narrow: [
        "\u0399",
        "\u03A6",
        "\u039C",
        "\u0391",
        "\u039C",
        "\u0399",
        "\u0399",
        "\u0391",
        "\u03A3",
        "\u039F",
        "\u039D",
        "\u0394"
    ],
    abbreviated: [
        "\u0399\u03B1\u03BD",
        "\u03A6\u03B5\u03B2",
        "\u039C\u03AC\u03C1",
        "\u0391\u03C0\u03C1",
        "\u039C\u03AC\u03B9",
        "\u0399\u03BF\u03CD\u03BD",
        "\u0399\u03BF\u03CD\u03BB",
        "\u0391\u03CD\u03B3",
        "\u03A3\u03B5\u03C0",
        "\u039F\u03BA\u03C4",
        "\u039D\u03BF\u03AD",
        "\u0394\u03B5\u03BA"
    ],
    wide: [
        "\u0399\u03B1\u03BD\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2",
        "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2",
        "\u039C\u03AC\u03C1\u03C4\u03B9\u03BF\u03C2",
        "\u0391\u03C0\u03C1\u03AF\u03BB\u03B9\u03BF\u03C2",
        "\u039C\u03AC\u03B9\u03BF\u03C2",
        "\u0399\u03BF\u03CD\u03BD\u03B9\u03BF\u03C2",
        "\u0399\u03BF\u03CD\u03BB\u03B9\u03BF\u03C2",
        "\u0391\u03CD\u03B3\u03BF\u03C5\u03C3\u03C4\u03BF\u03C2",
        "\u03A3\u03B5\u03C0\u03C4\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2",
        "\u039F\u03BA\u03C4\u03CE\u03B2\u03C1\u03B9\u03BF\u03C2",
        "\u039D\u03BF\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2",
        "\u0394\u03B5\u03BA\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2"
    ]
};
const $72738438092d6ed7$var$formattingMonthValues = {
    narrow: [
        "\u0399",
        "\u03A6",
        "\u039C",
        "\u0391",
        "\u039C",
        "\u0399",
        "\u0399",
        "\u0391",
        "\u03A3",
        "\u039F",
        "\u039D",
        "\u0394"
    ],
    abbreviated: [
        "\u0399\u03B1\u03BD",
        "\u03A6\u03B5\u03B2",
        "\u039C\u03B1\u03C1",
        "\u0391\u03C0\u03C1",
        "\u039C\u03B1\u0390",
        "\u0399\u03BF\u03C5\u03BD",
        "\u0399\u03BF\u03C5\u03BB",
        "\u0391\u03C5\u03B3",
        "\u03A3\u03B5\u03C0",
        "\u039F\u03BA\u03C4",
        "\u039D\u03BF\u03B5",
        "\u0394\u03B5\u03BA"
    ],
    wide: [
        "\u0399\u03B1\u03BD\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5",
        "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5",
        "\u039C\u03B1\u03C1\u03C4\u03AF\u03BF\u03C5",
        "\u0391\u03C0\u03C1\u03B9\u03BB\u03AF\u03BF\u03C5",
        "\u039C\u03B1\u0390\u03BF\u03C5",
        "\u0399\u03BF\u03C5\u03BD\u03AF\u03BF\u03C5",
        "\u0399\u03BF\u03C5\u03BB\u03AF\u03BF\u03C5",
        "\u0391\u03C5\u03B3\u03BF\u03CD\u03C3\u03C4\u03BF\u03C5",
        "\u03A3\u03B5\u03C0\u03C4\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5",
        "\u039F\u03BA\u03C4\u03C9\u03B2\u03C1\u03AF\u03BF\u03C5",
        "\u039D\u03BF\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5",
        "\u0394\u03B5\u03BA\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5"
    ]
};
const $72738438092d6ed7$var$dayValues = {
    narrow: [
        "\u039A",
        "\u0394",
        "T",
        "\u03A4",
        "\u03A0",
        "\u03A0",
        "\u03A3"
    ],
    short: [
        "\u039A\u03C5",
        "\u0394\u03B5",
        "\u03A4\u03C1",
        "\u03A4\u03B5",
        "\u03A0\u03AD",
        "\u03A0\u03B1",
        "\u03A3\u03AC"
    ],
    abbreviated: [
        "\u039A\u03C5\u03C1",
        "\u0394\u03B5\u03C5",
        "\u03A4\u03C1\u03AF",
        "\u03A4\u03B5\u03C4",
        "\u03A0\u03AD\u03BC",
        "\u03A0\u03B1\u03C1",
        "\u03A3\u03AC\u03B2"
    ],
    wide: [
        "\u039A\u03C5\u03C1\u03B9\u03B1\u03BA\u03AE",
        "\u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1",
        "\u03A4\u03C1\u03AF\u03C4\u03B7",
        "\u03A4\u03B5\u03C4\u03AC\u03C1\u03C4\u03B7",
        "\u03A0\u03AD\u03BC\u03C0\u03C4\u03B7",
        "\u03A0\u03B1\u03C1\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE",
        "\u03A3\u03AC\u03B2\u03B2\u03B1\u03C4\u03BF"
    ]
};
const $72738438092d6ed7$var$dayPeriodValues = {
    narrow: {
        am: "\u03C0\u03BC",
        pm: "\u03BC\u03BC",
        midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
        noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
        morning: "\u03C0\u03C1\u03C9\u03AF",
        afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
        evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
        night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
    },
    abbreviated: {
        am: "\u03C0.\u03BC.",
        pm: "\u03BC.\u03BC.",
        midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
        noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
        morning: "\u03C0\u03C1\u03C9\u03AF",
        afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
        evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
        night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
    },
    wide: {
        am: "\u03C0.\u03BC.",
        pm: "\u03BC.\u03BC.",
        midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
        noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
        morning: "\u03C0\u03C1\u03C9\u03AF",
        afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
        evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
        night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
    }
};
const $72738438092d6ed7$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    const unit = options?.unit;
    let suffix;
    if (unit === "year" || unit === "month") suffix = "\u03BF\u03C2";
    else if (unit === "week" || unit === "dayOfYear" || unit === "day" || unit === "hour" || unit === "date") suffix = "\u03B7";
    else suffix = "\u03BF";
    return number + suffix;
};
const $72738438092d6ed7$var$localize = $72738438092d6ed7$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $72738438092d6ed7$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $72738438092d6ed7$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $72738438092d6ed7$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $72738438092d6ed7$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $72738438092d6ed7$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $72738438092d6ed7$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $72738438092d6ed7$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};

});

parcelRegister("6jVp1", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $49a10b5d5a51c09a$export$4659b591c19bdf3d; }, function (v) { return $49a10b5d5a51c09a$export$4659b591c19bdf3d = v; });
var $49a10b5d5a51c09a$export$4659b591c19bdf3d;
"use strict";
$49a10b5d5a51c09a$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $49a10b5d5a51c09a$var$matchOrdinalNumberPattern = /^(\d+)(ος|η|ο)?/i;
const $49a10b5d5a51c09a$var$parseOrdinalNumberPattern = /\d+/i;
const $49a10b5d5a51c09a$var$matchEraPatterns = {
    narrow: /^(πΧ|μΧ)/i,
    abbreviated: /^(π\.?\s?χ\.?|π\.?\s?κ\.?\s?χ\.?|μ\.?\s?χ\.?|κ\.?\s?χ\.?)/i,
    wide: /^(προ Χριστο(ύ|υ)|πριν απ(ό|ο) την Κοιν(ή|η) Χρονολογ(ί|ι)α|μετ(ά|α) Χριστ(ό|ο)ν|Κοιν(ή|η) Χρονολογ(ί|ι)α)/i
};
const $49a10b5d5a51c09a$var$parseEraPatterns = {
    any: [
        /^π/i,
        /^(μ|κ)/i
    ]
};
const $49a10b5d5a51c09a$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^τ[1234]/i,
    wide: /^[1234]ο? τρ(ί|ι)μηνο/i
};
const $49a10b5d5a51c09a$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $49a10b5d5a51c09a$var$matchMonthPatterns = {
    narrow: /^[ιφμαμιιασονδ]/i,
    abbreviated: /^(ιαν|φεβ|μ[άα]ρ|απρ|μ[άα][ιΐ]|ιο[ύυ]ν|ιο[ύυ]λ|α[ύυ]γ|σεπ|οκτ|νο[έε]|δεκ)/i,
    wide: /^(μ[άα][ιΐ]|α[ύυ]γο[υύ]στ)(ος|ου)|(ιανου[άα]ρ|φεβρου[άα]ρ|μ[άα]ρτ|απρ[ίι]λ|ιο[ύυ]ν|ιο[ύυ]λ|σεπτ[έε]μβρ|οκτ[ώω]βρ|νο[έε]μβρ|δεκ[έε]μβρ)(ιος|ίου)/i
};
const $49a10b5d5a51c09a$var$parseMonthPatterns = {
    narrow: [
        /^ι/i,
        /^φ/i,
        /^μ/i,
        /^α/i,
        /^μ/i,
        /^ι/i,
        /^ι/i,
        /^α/i,
        /^σ/i,
        /^ο/i,
        /^ν/i,
        /^δ/i
    ],
    any: [
        /^ια/i,
        /^φ/i,
        /^μ[άα]ρ/i,
        /^απ/i,
        /^μ[άα][ιΐ]/i,
        /^ιο[ύυ]ν/i,
        /^ιο[ύυ]λ/i,
        /^α[ύυ]/i,
        /^σ/i,
        /^ο/i,
        /^ν/i,
        /^δ/i
    ]
};
const $49a10b5d5a51c09a$var$matchDayPatterns = {
    narrow: /^[κδτπσ]/i,
    short: /^(κυ|δε|τρ|τε|π[εέ]|π[αά]|σ[αά])/i,
    abbreviated: /^(κυρ|δευ|τρι|τετ|πεμ|παρ|σαβ)/i,
    wide: /^(κυριακ(ή|η)|δευτ(έ|ε)ρα|τρ(ί|ι)τη|τετ(ά|α)ρτη|π(έ|ε)μπτη|παρασκευ(ή|η)|σ(ά|α)ββατο)/i
};
const $49a10b5d5a51c09a$var$parseDayPatterns = {
    narrow: [
        /^κ/i,
        /^δ/i,
        /^τ/i,
        /^τ/i,
        /^π/i,
        /^π/i,
        /^σ/i
    ],
    any: [
        /^κ/i,
        /^δ/i,
        /^τρ/i,
        /^τε/i,
        /^π[εέ]/i,
        /^π[αά]/i,
        /^σ/i
    ]
};
const $49a10b5d5a51c09a$var$matchDayPeriodPatterns = {
    narrow: /^(πμ|μμ|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i,
    any: /^([πμ]\.?\s?μ\.?|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i
};
const $49a10b5d5a51c09a$var$parseDayPeriodPatterns = {
    any: {
        am: /^πμ|π\.\s?μ\./i,
        pm: /^μμ|μ\.\s?μ\./i,
        midnight: /^μεσάν/i,
        noon: /^μεσημ(έ|ε)/i,
        morning: /πρω(ί|ι)/i,
        afternoon: /απ(ό|ο)γευμα/i,
        evening: /βρ(ά|α)δυ/i,
        night: /ν(ύ|υ)χτα/i
    }
};
const $49a10b5d5a51c09a$var$match = $49a10b5d5a51c09a$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $49a10b5d5a51c09a$var$matchOrdinalNumberPattern,
        parsePattern: $49a10b5d5a51c09a$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $49a10b5d5a51c09a$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $49a10b5d5a51c09a$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $49a10b5d5a51c09a$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $49a10b5d5a51c09a$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $49a10b5d5a51c09a$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $49a10b5d5a51c09a$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $49a10b5d5a51c09a$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $49a10b5d5a51c09a$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $49a10b5d5a51c09a$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $49a10b5d5a51c09a$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("96hKD", function(module, exports) {

$parcel$export(module.exports, "enAU", function () { return $6a02719ce9951f96$export$6f7b98a3ca24eeee; }, function (v) { return $6a02719ce9951f96$export$6f7b98a3ca24eeee = v; });
var $6a02719ce9951f96$export$6f7b98a3ca24eeee;
"use strict";
$6a02719ce9951f96$export$6f7b98a3ca24eeee = void 0;

var $lSIny = parcelRequire("lSIny");

var $aW1Ix = parcelRequire("aW1Ix");

var $afvyp = parcelRequire("afvyp");

var $fSY2H = parcelRequire("fSY2H");

var $2cOek = parcelRequire("2cOek");
/**
 * @category Locales
 * @summary English locale (Australia).
 * @language English
 * @iso-639-2 eng
 * @author Julien Malige [@JulienMalige](https://github.com/JulienMalige)
 */ const $6a02719ce9951f96$var$enAU = $6a02719ce9951f96$export$6f7b98a3ca24eeee = {
    code: "en-AU",
    formatDistance: $lSIny.formatDistance,
    formatLong: $aW1Ix.formatLong,
    formatRelative: $afvyp.formatRelative,
    localize: $fSY2H.localize,
    match: $2cOek.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("aW1Ix", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $7f60a734ec37d2e5$export$cbf60ecb96cbb82f; }, function (v) { return $7f60a734ec37d2e5$export$cbf60ecb96cbb82f = v; });
var $7f60a734ec37d2e5$export$cbf60ecb96cbb82f;
"use strict";
$7f60a734ec37d2e5$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $7f60a734ec37d2e5$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
};
const $7f60a734ec37d2e5$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $7f60a734ec37d2e5$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $7f60a734ec37d2e5$var$formatLong = $7f60a734ec37d2e5$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $7f60a734ec37d2e5$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $7f60a734ec37d2e5$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $7f60a734ec37d2e5$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});


parcelRegister("lxYKU", function(module, exports) {

$parcel$export(module.exports, "enCA", function () { return $fafbced09d3aabe6$export$965481d0ea2ba235; }, function (v) { return $fafbced09d3aabe6$export$965481d0ea2ba235 = v; });
var $fafbced09d3aabe6$export$965481d0ea2ba235;
"use strict";
$fafbced09d3aabe6$export$965481d0ea2ba235 = void 0;

var $afvyp = parcelRequire("afvyp");

var $fSY2H = parcelRequire("fSY2H");

var $2cOek = parcelRequire("2cOek");

var $ks1bu = parcelRequire("ks1bu");

var $io4zj = parcelRequire("io4zj");
/**
 * @category Locales
 * @summary English locale (Canada).
 * @language English
 * @iso-639-2 eng
 * @author Mark Owsiak [@markowsiak](https://github.com/markowsiak)
 * @author Marco Imperatore [@mimperatore](https://github.com/mimperatore)
 */ const $fafbced09d3aabe6$var$enCA = $fafbced09d3aabe6$export$965481d0ea2ba235 = {
    code: "en-CA",
    formatDistance: $ks1bu.formatDistance,
    formatLong: $io4zj.formatLong,
    formatRelative: $afvyp.formatRelative,
    localize: $fSY2H.localize,
    match: $2cOek.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("ks1bu", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $ee3757587db0f8b4$export$2c14ff85d6318973; }, function (v) { return $ee3757587db0f8b4$export$2c14ff85d6318973 = v; });
var $ee3757587db0f8b4$export$2c14ff85d6318973;
"use strict";
$ee3757587db0f8b4$export$2c14ff85d6318973 = void 0;
const $ee3757587db0f8b4$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "a second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "a minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about an hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "an hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "a day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about a week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "a week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about a month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "a month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about a year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "a year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over a year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost a year",
        other: "almost {{count}} years"
    }
};
const $ee3757587db0f8b4$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $ee3757587db0f8b4$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
$ee3757587db0f8b4$export$2c14ff85d6318973 = $ee3757587db0f8b4$var$formatDistance;

});

parcelRegister("io4zj", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $d62e031a2e8d0700$export$cbf60ecb96cbb82f; }, function (v) { return $d62e031a2e8d0700$export$cbf60ecb96cbb82f = v; });
var $d62e031a2e8d0700$export$cbf60ecb96cbb82f;
"use strict";
$d62e031a2e8d0700$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $d62e031a2e8d0700$var$dateFormats = {
    full: "EEEE, MMMM do, yyyy",
    long: "MMMM do, yyyy",
    medium: "MMM d, yyyy",
    short: "yyyy-MM-dd"
};
const $d62e031a2e8d0700$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $d62e031a2e8d0700$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $d62e031a2e8d0700$var$formatLong = $d62e031a2e8d0700$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $d62e031a2e8d0700$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $d62e031a2e8d0700$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $d62e031a2e8d0700$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});


parcelRegister("flpZ5", function(module, exports) {

$parcel$export(module.exports, "enGB", function () { return $b2bcf923074d80ab$export$1d08ac19b34481d5; }, function (v) { return $b2bcf923074d80ab$export$1d08ac19b34481d5 = v; });
var $b2bcf923074d80ab$export$1d08ac19b34481d5;
"use strict";
$b2bcf923074d80ab$export$1d08ac19b34481d5 = void 0;

var $lSIny = parcelRequire("lSIny");

var $afvyp = parcelRequire("afvyp");

var $fSY2H = parcelRequire("fSY2H");

var $2cOek = parcelRequire("2cOek");

var $dH3ST = parcelRequire("dH3ST");
/**
 * @category Locales
 * @summary English locale (United Kingdom).
 * @language English
 * @iso-639-2 eng
 * @author Alex [@glintik](https://github.com/glintik)
 */ const $b2bcf923074d80ab$var$enGB = $b2bcf923074d80ab$export$1d08ac19b34481d5 = {
    code: "en-GB",
    formatDistance: $lSIny.formatDistance,
    formatLong: $dH3ST.formatLong,
    formatRelative: $afvyp.formatRelative,
    localize: $fSY2H.localize,
    match: $2cOek.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("dH3ST", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $9f824ddb494332e6$export$cbf60ecb96cbb82f; }, function (v) { return $9f824ddb494332e6$export$cbf60ecb96cbb82f = v; });
var $9f824ddb494332e6$export$cbf60ecb96cbb82f;
"use strict";
$9f824ddb494332e6$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $9f824ddb494332e6$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
};
const $9f824ddb494332e6$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $9f824ddb494332e6$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $9f824ddb494332e6$var$formatLong = $9f824ddb494332e6$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $9f824ddb494332e6$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $9f824ddb494332e6$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $9f824ddb494332e6$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});


parcelRegister("LxiZ6", function(module, exports) {

$parcel$export(module.exports, "enIE", function () { return $08ee399ed9f58d0d$export$cc1aa062f801d69e; }, function (v) { return $08ee399ed9f58d0d$export$cc1aa062f801d69e = v; });
var $08ee399ed9f58d0d$export$cc1aa062f801d69e;
"use strict";
$08ee399ed9f58d0d$export$cc1aa062f801d69e = void 0;

var $lSIny = parcelRequire("lSIny");

var $afvyp = parcelRequire("afvyp");

var $fSY2H = parcelRequire("fSY2H");

var $2cOek = parcelRequire("2cOek");

var $dH3ST = parcelRequire("dH3ST");
/**
 * @category Locales
 * @summary English locale (Ireland).
 * @language English
 * @iso-639-2 eng
 * @author Tetiana [@tan75](https://github.com/tan75)
 */ const $08ee399ed9f58d0d$var$enIE = $08ee399ed9f58d0d$export$cc1aa062f801d69e = {
    code: "en-IE",
    formatDistance: $lSIny.formatDistance,
    formatLong: $dH3ST.formatLong,
    formatRelative: $afvyp.formatRelative,
    localize: $fSY2H.localize,
    match: $2cOek.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});

parcelRegister("kwR0A", function(module, exports) {

$parcel$export(module.exports, "enIN", function () { return $ef1fea2bbbaa4f54$export$c9cb94638a6621e; }, function (v) { return $ef1fea2bbbaa4f54$export$c9cb94638a6621e = v; });
var $ef1fea2bbbaa4f54$export$c9cb94638a6621e;
"use strict";
$ef1fea2bbbaa4f54$export$c9cb94638a6621e = void 0;

var $lSIny = parcelRequire("lSIny");

var $afvyp = parcelRequire("afvyp");

var $fSY2H = parcelRequire("fSY2H");

var $2cOek = parcelRequire("2cOek");

var $5NoKx = parcelRequire("5NoKx");
/**
 * @category Locales
 * @summary English locale (India).
 * @language English
 * @iso-639-2 eng
 * @author Galeel Bhasha Satthar [@gbhasha](https://github.com/gbhasha)
 */ const $ef1fea2bbbaa4f54$var$enIN = $ef1fea2bbbaa4f54$export$c9cb94638a6621e = {
    code: "en-IN",
    formatDistance: $lSIny.formatDistance,
    formatLong: $5NoKx.formatLong,
    formatRelative: $afvyp.formatRelative,
    localize: $fSY2H.localize,
    match: $2cOek.match,
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("5NoKx", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $4384ba1657ceb317$export$cbf60ecb96cbb82f; }, function (v) { return $4384ba1657ceb317$export$cbf60ecb96cbb82f = v; });
var $4384ba1657ceb317$export$cbf60ecb96cbb82f;
"use strict";
$4384ba1657ceb317$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $4384ba1657ceb317$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM, yyyy",
    medium: "d MMM, yyyy",
    short: "dd/MM/yyyy"
};
const $4384ba1657ceb317$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $4384ba1657ceb317$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $4384ba1657ceb317$var$formatLong = $4384ba1657ceb317$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $4384ba1657ceb317$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $4384ba1657ceb317$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $4384ba1657ceb317$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});


parcelRegister("3ucwE", function(module, exports) {

$parcel$export(module.exports, "enNZ", function () { return $289de3c2c4e7eacd$export$2bdafeb919fd632b; }, function (v) { return $289de3c2c4e7eacd$export$2bdafeb919fd632b = v; });
var $289de3c2c4e7eacd$export$2bdafeb919fd632b;
"use strict";
$289de3c2c4e7eacd$export$2bdafeb919fd632b = void 0;

var $lSIny = parcelRequire("lSIny");

var $afvyp = parcelRequire("afvyp");

var $fSY2H = parcelRequire("fSY2H");

var $2cOek = parcelRequire("2cOek");

var $9vzXW = parcelRequire("9vzXW");
/**
 * @category Locales
 * @summary English locale (New Zealand).
 * @language English
 * @iso-639-2 eng
 * @author Murray Lucas [@muntact](https://github.com/muntact)
 */ const $289de3c2c4e7eacd$var$enNZ = $289de3c2c4e7eacd$export$2bdafeb919fd632b = {
    code: "en-NZ",
    formatDistance: $lSIny.formatDistance,
    formatLong: $9vzXW.formatLong,
    formatRelative: $afvyp.formatRelative,
    localize: $fSY2H.localize,
    match: $2cOek.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("9vzXW", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $6ec2e8592b6b0239$export$cbf60ecb96cbb82f; }, function (v) { return $6ec2e8592b6b0239$export$cbf60ecb96cbb82f = v; });
var $6ec2e8592b6b0239$export$cbf60ecb96cbb82f;
"use strict";
$6ec2e8592b6b0239$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $6ec2e8592b6b0239$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
};
const $6ec2e8592b6b0239$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $6ec2e8592b6b0239$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $6ec2e8592b6b0239$var$formatLong = $6ec2e8592b6b0239$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $6ec2e8592b6b0239$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $6ec2e8592b6b0239$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $6ec2e8592b6b0239$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});


parcelRegister("b72Sc", function(module, exports) {

$parcel$export(module.exports, "enZA", function () { return $817293b7dde8f952$export$61b66188632c07cb; }, function (v) { return $817293b7dde8f952$export$61b66188632c07cb = v; });
var $817293b7dde8f952$export$61b66188632c07cb;
"use strict";
$817293b7dde8f952$export$61b66188632c07cb = void 0;

var $lSIny = parcelRequire("lSIny");

var $afvyp = parcelRequire("afvyp");

var $fSY2H = parcelRequire("fSY2H");

var $2cOek = parcelRequire("2cOek");

var $5pMUa = parcelRequire("5pMUa");
/**
 * @category Locales
 * @summary English locale (South Africa).
 * @language English
 * @iso-639-2 eng
 * @author Shaila Kavrakova [@shaykav](https://github.com/shaykav)
 */ const $817293b7dde8f952$var$enZA = $817293b7dde8f952$export$61b66188632c07cb = {
    code: "en-ZA",
    formatDistance: $lSIny.formatDistance,
    formatLong: $5pMUa.formatLong,
    formatRelative: $afvyp.formatRelative,
    localize: $fSY2H.localize,
    match: $2cOek.match,
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("5pMUa", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $3f1539072ba80c6a$export$cbf60ecb96cbb82f; }, function (v) { return $3f1539072ba80c6a$export$cbf60ecb96cbb82f = v; });
var $3f1539072ba80c6a$export$cbf60ecb96cbb82f;
"use strict";
$3f1539072ba80c6a$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $3f1539072ba80c6a$var$dateFormats = {
    full: "EEEE, dd MMMM yyyy",
    long: "dd MMMM yyyy",
    medium: "dd MMM yyyy",
    short: "yyyy/MM/dd"
};
const $3f1539072ba80c6a$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $3f1539072ba80c6a$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $3f1539072ba80c6a$var$formatLong = $3f1539072ba80c6a$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $3f1539072ba80c6a$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $3f1539072ba80c6a$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $3f1539072ba80c6a$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});


parcelRegister("9O0sC", function(module, exports) {

$parcel$export(module.exports, "eo", function () { return $7239240664f12465$export$9e6f8948b1b2764c; }, function (v) { return $7239240664f12465$export$9e6f8948b1b2764c = v; });
var $7239240664f12465$export$9e6f8948b1b2764c;
"use strict";
$7239240664f12465$export$9e6f8948b1b2764c = void 0;

var $4r6Uq = parcelRequire("4r6Uq");

var $313cP = parcelRequire("313cP");

var $d789E = parcelRequire("d789E");

var $itGcb = parcelRequire("itGcb");

var $5GYxC = parcelRequire("5GYxC");
/**
 * @category Locales
 * @summary Esperanto locale.
 * @language Esperanto
 * @iso-639-2 epo
 * @author date-fns
 */ const $7239240664f12465$var$eo = $7239240664f12465$export$9e6f8948b1b2764c = {
    code: "eo",
    formatDistance: $4r6Uq.formatDistance,
    formatLong: $313cP.formatLong,
    formatRelative: $d789E.formatRelative,
    localize: $itGcb.localize,
    match: $5GYxC.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("4r6Uq", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $33af0b0dc28bd785$export$2c14ff85d6318973; }, function (v) { return $33af0b0dc28bd785$export$2c14ff85d6318973 = v; });
var $33af0b0dc28bd785$export$2c14ff85d6318973;
"use strict";
$33af0b0dc28bd785$export$2c14ff85d6318973 = void 0;
const $33af0b0dc28bd785$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "malpli ol sekundo",
        other: "malpli ol {{count}} sekundoj"
    },
    xSeconds: {
        one: "1 sekundo",
        other: "{{count}} sekundoj"
    },
    halfAMinute: "duonminuto",
    lessThanXMinutes: {
        one: "malpli ol minuto",
        other: "malpli ol {{count}} minutoj"
    },
    xMinutes: {
        one: "1 minuto",
        other: "{{count}} minutoj"
    },
    aboutXHours: {
        one: "proksimume 1 horo",
        other: "proksimume {{count}} horoj"
    },
    xHours: {
        one: "1 horo",
        other: "{{count}} horoj"
    },
    xDays: {
        one: "1 tago",
        other: "{{count}} tagoj"
    },
    aboutXMonths: {
        one: "proksimume 1 monato",
        other: "proksimume {{count}} monatoj"
    },
    xWeeks: {
        one: "1 semajno",
        other: "{{count}} semajnoj"
    },
    aboutXWeeks: {
        one: "proksimume 1 semajno",
        other: "proksimume {{count}} semajnoj"
    },
    xMonths: {
        one: "1 monato",
        other: "{{count}} monatoj"
    },
    aboutXYears: {
        one: "proksimume 1 jaro",
        other: "proksimume {{count}} jaroj"
    },
    xYears: {
        one: "1 jaro",
        other: "{{count}} jaroj"
    },
    overXYears: {
        one: "pli ol 1 jaro",
        other: "pli ol {{count}} jaroj"
    },
    almostXYears: {
        one: "preska\u016D 1 jaro",
        other: "preska\u016D {{count}} jaroj"
    }
};
const $33af0b0dc28bd785$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $33af0b0dc28bd785$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options?.comparison && options.comparison > 0) return "post " + result;
        else return "anta\u016D " + result;
    }
    return result;
};
$33af0b0dc28bd785$export$2c14ff85d6318973 = $33af0b0dc28bd785$var$formatDistance;

});

parcelRegister("313cP", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $2323f3beaf937bd4$export$cbf60ecb96cbb82f; }, function (v) { return $2323f3beaf937bd4$export$cbf60ecb96cbb82f = v; });
var $2323f3beaf937bd4$export$cbf60ecb96cbb82f;
"use strict";
$2323f3beaf937bd4$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $2323f3beaf937bd4$var$dateFormats = {
    full: "EEEE, do 'de' MMMM y",
    long: "y-MMMM-dd",
    medium: "y-MMM-dd",
    short: "yyyy-MM-dd"
};
const $2323f3beaf937bd4$var$timeFormats = {
    full: "Ho 'horo kaj' m:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $2323f3beaf937bd4$var$dateTimeFormats = {
    any: "{{date}} {{time}}"
};
const $2323f3beaf937bd4$var$formatLong = $2323f3beaf937bd4$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $2323f3beaf937bd4$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $2323f3beaf937bd4$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $2323f3beaf937bd4$var$dateTimeFormats,
        defaultWidth: "any"
    })
};

});

parcelRegister("d789E", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $98c24126beda095a$export$8fbbfd65594f46a0; }, function (v) { return $98c24126beda095a$export$8fbbfd65594f46a0 = v; });
var $98c24126beda095a$export$8fbbfd65594f46a0;
"use strict";
$98c24126beda095a$export$8fbbfd65594f46a0 = void 0;
const $98c24126beda095a$var$formatRelativeLocale = {
    lastWeek: "'pasinta' eeee 'je' p",
    yesterday: "'hiera\u016D je' p",
    today: "'hodia\u016D je' p",
    tomorrow: "'morga\u016D je' p",
    nextWeek: "eeee 'je' p",
    other: "P"
};
const $98c24126beda095a$var$formatRelative = (token, _date, _baseDate, _options)=>$98c24126beda095a$var$formatRelativeLocale[token];
$98c24126beda095a$export$8fbbfd65594f46a0 = $98c24126beda095a$var$formatRelative;

});

parcelRegister("itGcb", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $d73baa8eddbedb89$export$b3bd0bc58e36cd63; }, function (v) { return $d73baa8eddbedb89$export$b3bd0bc58e36cd63 = v; });
var $d73baa8eddbedb89$export$b3bd0bc58e36cd63;
"use strict";
$d73baa8eddbedb89$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $d73baa8eddbedb89$var$eraValues = {
    narrow: [
        "aK",
        "pK"
    ],
    abbreviated: [
        "a.K.E.",
        "p.K.E."
    ],
    wide: [
        "anta\u016D Komuna Erao",
        "Komuna Erao"
    ]
};
const $d73baa8eddbedb89$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1-a kvaronjaro",
        "2-a kvaronjaro",
        "3-a kvaronjaro",
        "4-a kvaronjaro"
    ]
};
const $d73baa8eddbedb89$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan",
        "feb",
        "mar",
        "apr",
        "maj",
        "jun",
        "jul",
        "a\u016Dg",
        "sep",
        "okt",
        "nov",
        "dec"
    ],
    wide: [
        "januaro",
        "februaro",
        "marto",
        "aprilo",
        "majo",
        "junio",
        "julio",
        "a\u016Dgusto",
        "septembro",
        "oktobro",
        "novembro",
        "decembro"
    ]
};
const $d73baa8eddbedb89$var$dayValues = {
    narrow: [
        "D",
        "L",
        "M",
        "M",
        "\u0134",
        "V",
        "S"
    ],
    short: [
        "di",
        "lu",
        "ma",
        "me",
        "\u0135a",
        "ve",
        "sa"
    ],
    abbreviated: [
        "dim",
        "lun",
        "mar",
        "mer",
        "\u0135a\u016D",
        "ven",
        "sab"
    ],
    wide: [
        "diman\u0109o",
        "lundo",
        "mardo",
        "merkredo",
        "\u0135a\u016Ddo",
        "vendredo",
        "sabato"
    ]
};
const $d73baa8eddbedb89$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "noktomezo",
        noon: "tagmezo",
        morning: "matene",
        afternoon: "posttagmeze",
        evening: "vespere",
        night: "nokte"
    },
    abbreviated: {
        am: "a.t.m.",
        pm: "p.t.m.",
        midnight: "noktomezo",
        noon: "tagmezo",
        morning: "matene",
        afternoon: "posttagmeze",
        evening: "vespere",
        night: "nokte"
    },
    wide: {
        am: "anta\u016Dtagmeze",
        pm: "posttagmeze",
        midnight: "noktomezo",
        noon: "tagmezo",
        morning: "matene",
        afternoon: "posttagmeze",
        evening: "vespere",
        night: "nokte"
    }
};
const $d73baa8eddbedb89$var$ordinalNumber = (dirtyNumber)=>{
    const number = Number(dirtyNumber);
    return number + "-a";
};
const $d73baa8eddbedb89$var$localize = $d73baa8eddbedb89$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $d73baa8eddbedb89$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $d73baa8eddbedb89$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $d73baa8eddbedb89$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $d73baa8eddbedb89$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $d73baa8eddbedb89$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $d73baa8eddbedb89$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};

});

parcelRegister("5GYxC", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $424fd63afffd2fbd$export$4659b591c19bdf3d; }, function (v) { return $424fd63afffd2fbd$export$4659b591c19bdf3d = v; });
var $424fd63afffd2fbd$export$4659b591c19bdf3d;
"use strict";
$424fd63afffd2fbd$export$4659b591c19bdf3d = void 0;

var $8RZeP = parcelRequire("8RZeP");

var $kQYK9 = parcelRequire("kQYK9");
const $424fd63afffd2fbd$var$matchOrdinalNumberPattern = /^(\d+)(-?a)?/i;
const $424fd63afffd2fbd$var$parseOrdinalNumberPattern = /\d+/i;
const $424fd63afffd2fbd$var$matchEraPatterns = {
    narrow: /^([ap]k)/i,
    abbreviated: /^([ap]\.?\s?k\.?\s?e\.?)/i,
    wide: /^((antaǔ |post )?komuna erao)/i
};
const $424fd63afffd2fbd$var$parseEraPatterns = {
    any: [
        /^a/i,
        /^[kp]/i
    ]
};
const $424fd63afffd2fbd$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^k[1234]/i,
    wide: /^[1234](-?a)? kvaronjaro/i
};
const $424fd63afffd2fbd$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $424fd63afffd2fbd$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|a(ŭ|ux|uh|u)g|sep|okt|nov|dec)/i,
    wide: /^(januaro|februaro|marto|aprilo|majo|junio|julio|a(ŭ|ux|uh|u)gusto|septembro|oktobro|novembro|decembro)/i
};
const $424fd63afffd2fbd$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^a(u|ŭ)/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $424fd63afffd2fbd$var$matchDayPatterns = {
    narrow: /^[dlmĵjvs]/i,
    short: /^(di|lu|ma|me|(ĵ|jx|jh|j)a|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)|ven|sab)/i,
    wide: /^(diman(ĉ|cx|ch|c)o|lundo|mardo|merkredo|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)do|vendredo|sabato)/i
};
const $424fd63afffd2fbd$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^(j|ĵ)/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^me/i,
        /^(j|ĵ)/i,
        /^v/i,
        /^s/i
    ]
};
const $424fd63afffd2fbd$var$matchDayPeriodPatterns = {
    narrow: /^([ap]|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
    abbreviated: /^([ap][.\s]?t[.\s]?m[.\s]?|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
    wide: /^(anta(ŭ|ux)tagmez|posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo]/i
};
const $424fd63afffd2fbd$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^noktom/i,
        noon: /^t/i,
        morning: /^m/i,
        afternoon: /^posttagmeze/i,
        evening: /^v/i,
        night: /^n/i
    }
};
const $424fd63afffd2fbd$var$match = $424fd63afffd2fbd$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $424fd63afffd2fbd$var$matchOrdinalNumberPattern,
        parsePattern: $424fd63afffd2fbd$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $424fd63afffd2fbd$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $424fd63afffd2fbd$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $424fd63afffd2fbd$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $424fd63afffd2fbd$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $424fd63afffd2fbd$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $424fd63afffd2fbd$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $424fd63afffd2fbd$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $424fd63afffd2fbd$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $424fd63afffd2fbd$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $424fd63afffd2fbd$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("hRHn5", function(module, exports) {

$parcel$export(module.exports, "es", function () { return $d019078fdc0d2c73$export$ca5e4045a55e76d2; }, function (v) { return $d019078fdc0d2c73$export$ca5e4045a55e76d2 = v; });
var $d019078fdc0d2c73$export$ca5e4045a55e76d2;
"use strict";
$d019078fdc0d2c73$export$ca5e4045a55e76d2 = void 0;

var $3CrxY = parcelRequire("3CrxY");

var $6xCmI = parcelRequire("6xCmI");

var $fjqmI = parcelRequire("fjqmI");

var $gn6Ul = parcelRequire("gn6Ul");

var $2Hp31 = parcelRequire("2Hp31");
/**
 * @category Locales
 * @summary Spanish locale.
 * @language Spanish
 * @iso-639-2 spa
 * @author Juan Angosto [@juanangosto](https://github.com/juanangosto)
 * @author Guillermo Grau [@guigrpa](https://github.com/guigrpa)
 * @author Fernando Agüero [@fjaguero](https://github.com/fjaguero)
 * @author Gastón Haro [@harogaston](https://github.com/harogaston)
 * @author Yago Carballo [@YagoCarballo](https://github.com/YagoCarballo)
 */ const $d019078fdc0d2c73$var$es = $d019078fdc0d2c73$export$ca5e4045a55e76d2 = {
    code: "es",
    formatDistance: $3CrxY.formatDistance,
    formatLong: $6xCmI.formatLong,
    formatRelative: $fjqmI.formatRelative,
    localize: $gn6Ul.localize,
    match: $2Hp31.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("3CrxY", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $2a2a49f1742eae22$export$2c14ff85d6318973; }, function (v) { return $2a2a49f1742eae22$export$2c14ff85d6318973 = v; });
var $2a2a49f1742eae22$export$2c14ff85d6318973;
"use strict";
$2a2a49f1742eae22$export$2c14ff85d6318973 = void 0;
const $2a2a49f1742eae22$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menos de un segundo",
        other: "menos de {{count}} segundos"
    },
    xSeconds: {
        one: "1 segundo",
        other: "{{count}} segundos"
    },
    halfAMinute: "medio minuto",
    lessThanXMinutes: {
        one: "menos de un minuto",
        other: "menos de {{count}} minutos"
    },
    xMinutes: {
        one: "1 minuto",
        other: "{{count}} minutos"
    },
    aboutXHours: {
        one: "alrededor de 1 hora",
        other: "alrededor de {{count}} horas"
    },
    xHours: {
        one: "1 hora",
        other: "{{count}} horas"
    },
    xDays: {
        one: "1 d\xeda",
        other: "{{count}} d\xedas"
    },
    aboutXWeeks: {
        one: "alrededor de 1 semana",
        other: "alrededor de {{count}} semanas"
    },
    xWeeks: {
        one: "1 semana",
        other: "{{count}} semanas"
    },
    aboutXMonths: {
        one: "alrededor de 1 mes",
        other: "alrededor de {{count}} meses"
    },
    xMonths: {
        one: "1 mes",
        other: "{{count}} meses"
    },
    aboutXYears: {
        one: "alrededor de 1 a\xf1o",
        other: "alrededor de {{count}} a\xf1os"
    },
    xYears: {
        one: "1 a\xf1o",
        other: "{{count}} a\xf1os"
    },
    overXYears: {
        one: "m\xe1s de 1 a\xf1o",
        other: "m\xe1s de {{count}} a\xf1os"
    },
    almostXYears: {
        one: "casi 1 a\xf1o",
        other: "casi {{count}} a\xf1os"
    }
};
const $2a2a49f1742eae22$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $2a2a49f1742eae22$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "en " + result;
        else return "hace " + result;
    }
    return result;
};
$2a2a49f1742eae22$export$2c14ff85d6318973 = $2a2a49f1742eae22$var$formatDistance;

});

parcelRegister("6xCmI", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $4c3395b78da7bd69$export$cbf60ecb96cbb82f; }, function (v) { return $4c3395b78da7bd69$export$cbf60ecb96cbb82f = v; });
var $4c3395b78da7bd69$export$cbf60ecb96cbb82f;
"use strict";
$4c3395b78da7bd69$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $4c3395b78da7bd69$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
const $4c3395b78da7bd69$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $4c3395b78da7bd69$var$dateTimeFormats = {
    full: "{{date}} 'a las' {{time}}",
    long: "{{date}} 'a las' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $4c3395b78da7bd69$var$formatLong = $4c3395b78da7bd69$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $4c3395b78da7bd69$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $4c3395b78da7bd69$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $4c3395b78da7bd69$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("fjqmI", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $b25d14fef90008cb$export$8fbbfd65594f46a0; }, function (v) { return $b25d14fef90008cb$export$8fbbfd65594f46a0 = v; });
var $b25d14fef90008cb$export$8fbbfd65594f46a0;
"use strict";
$b25d14fef90008cb$export$8fbbfd65594f46a0 = void 0;
const $b25d14fef90008cb$var$formatRelativeLocale = {
    lastWeek: "'el' eeee 'pasado a la' p",
    yesterday: "'ayer a la' p",
    today: "'hoy a la' p",
    tomorrow: "'ma\xf1ana a la' p",
    nextWeek: "eeee 'a la' p",
    other: "P"
};
const $b25d14fef90008cb$var$formatRelativeLocalePlural = {
    lastWeek: "'el' eeee 'pasado a las' p",
    yesterday: "'ayer a las' p",
    today: "'hoy a las' p",
    tomorrow: "'ma\xf1ana a las' p",
    nextWeek: "eeee 'a las' p",
    other: "P"
};
const $b25d14fef90008cb$var$formatRelative = (token, date, _baseDate, _options)=>{
    if (date.getHours() !== 1) return $b25d14fef90008cb$var$formatRelativeLocalePlural[token];
    else return $b25d14fef90008cb$var$formatRelativeLocale[token];
};
$b25d14fef90008cb$export$8fbbfd65594f46a0 = $b25d14fef90008cb$var$formatRelative;

});

parcelRegister("gn6Ul", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $beb4270b8a440f36$export$b3bd0bc58e36cd63; }, function (v) { return $beb4270b8a440f36$export$b3bd0bc58e36cd63 = v; });
var $beb4270b8a440f36$export$b3bd0bc58e36cd63;
"use strict";
$beb4270b8a440f36$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $beb4270b8a440f36$var$eraValues = {
    narrow: [
        "AC",
        "DC"
    ],
    abbreviated: [
        "AC",
        "DC"
    ],
    wide: [
        "antes de cristo",
        "despu\xe9s de cristo"
    ]
};
const $beb4270b8a440f36$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
const $beb4270b8a440f36$var$monthValues = {
    narrow: [
        "e",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic"
    ],
    wide: [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre"
    ]
};
const $beb4270b8a440f36$var$dayValues = {
    narrow: [
        "d",
        "l",
        "m",
        "m",
        "j",
        "v",
        "s"
    ],
    short: [
        "do",
        "lu",
        "ma",
        "mi",
        "ju",
        "vi",
        "s\xe1"
    ],
    abbreviated: [
        "dom",
        "lun",
        "mar",
        "mi\xe9",
        "jue",
        "vie",
        "s\xe1b"
    ],
    wide: [
        "domingo",
        "lunes",
        "martes",
        "mi\xe9rcoles",
        "jueves",
        "viernes",
        "s\xe1bado"
    ]
};
const $beb4270b8a440f36$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "ma\xf1ana",
        afternoon: "tarde",
        evening: "tarde",
        night: "noche"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "ma\xf1ana",
        afternoon: "tarde",
        evening: "tarde",
        night: "noche"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "ma\xf1ana",
        afternoon: "tarde",
        evening: "tarde",
        night: "noche"
    }
};
const $beb4270b8a440f36$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "de la ma\xf1ana",
        afternoon: "de la tarde",
        evening: "de la tarde",
        night: "de la noche"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "de la ma\xf1ana",
        afternoon: "de la tarde",
        evening: "de la tarde",
        night: "de la noche"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "de la ma\xf1ana",
        afternoon: "de la tarde",
        evening: "de la tarde",
        night: "de la noche"
    }
};
const $beb4270b8a440f36$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + "\xba";
};
const $beb4270b8a440f36$var$localize = $beb4270b8a440f36$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $beb4270b8a440f36$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $beb4270b8a440f36$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $beb4270b8a440f36$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>Number(quarter) - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $beb4270b8a440f36$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $beb4270b8a440f36$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $beb4270b8a440f36$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $beb4270b8a440f36$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("2Hp31", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $1f7306e0db4bc723$export$4659b591c19bdf3d; }, function (v) { return $1f7306e0db4bc723$export$4659b591c19bdf3d = v; });
var $1f7306e0db4bc723$export$4659b591c19bdf3d;
"use strict";
$1f7306e0db4bc723$export$4659b591c19bdf3d = void 0;

var $8RZeP = parcelRequire("8RZeP");

var $kQYK9 = parcelRequire("kQYK9");
const $1f7306e0db4bc723$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
const $1f7306e0db4bc723$var$parseOrdinalNumberPattern = /\d+/i;
const $1f7306e0db4bc723$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
};
const $1f7306e0db4bc723$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes de la era com[uú]n)/i,
        /^(despu[eé]s de cristo|era com[uú]n)/i
    ]
};
const $1f7306e0db4bc723$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
const $1f7306e0db4bc723$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $1f7306e0db4bc723$var$matchMonthPatterns = {
    narrow: /^[efmajsond]/i,
    abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
    wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
};
const $1f7306e0db4bc723$var$parseMonthPatterns = {
    narrow: [
        /^e/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^en/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^sep/i,
        /^oct/i,
        /^nov/i,
        /^dic/i
    ]
};
const $1f7306e0db4bc723$var$matchDayPatterns = {
    narrow: /^[dlmjvs]/i,
    short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
    abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
    wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
};
const $1f7306e0db4bc723$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^do/i,
        /^lu/i,
        /^ma/i,
        /^mi/i,
        /^ju/i,
        /^vi/i,
        /^sa/i
    ]
};
const $1f7306e0db4bc723$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
    any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
};
const $1f7306e0db4bc723$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /^md/i,
        morning: /mañana/i,
        afternoon: /tarde/i,
        evening: /tarde/i,
        night: /noche/i
    }
};
const $1f7306e0db4bc723$var$match = $1f7306e0db4bc723$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $1f7306e0db4bc723$var$matchOrdinalNumberPattern,
        parsePattern: $1f7306e0db4bc723$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $1f7306e0db4bc723$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1f7306e0db4bc723$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $1f7306e0db4bc723$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1f7306e0db4bc723$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $1f7306e0db4bc723$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1f7306e0db4bc723$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $1f7306e0db4bc723$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1f7306e0db4bc723$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $1f7306e0db4bc723$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $1f7306e0db4bc723$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("iTJJk", function(module, exports) {

$parcel$export(module.exports, "et", function () { return $dc20d61c2acb3ecd$export$457177dcde8472be; }, function (v) { return $dc20d61c2acb3ecd$export$457177dcde8472be = v; });
var $dc20d61c2acb3ecd$export$457177dcde8472be;
"use strict";
$dc20d61c2acb3ecd$export$457177dcde8472be = void 0;

var $el4L5 = parcelRequire("el4L5");

var $9MyVF = parcelRequire("9MyVF");

var $c4UoK = parcelRequire("c4UoK");

var $9GrlO = parcelRequire("9GrlO");

var $cw2FY = parcelRequire("cw2FY");
/**
 * @category Locales
 * @summary Estonian locale.
 * @language Estonian
 * @iso-639-2 est
 * @author Priit Hansen [@HansenPriit](https://github.com/priithansen)
 */ const $dc20d61c2acb3ecd$var$et = $dc20d61c2acb3ecd$export$457177dcde8472be = {
    code: "et",
    formatDistance: $el4L5.formatDistance,
    formatLong: $9MyVF.formatLong,
    formatRelative: $c4UoK.formatRelative,
    localize: $9GrlO.localize,
    match: $cw2FY.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("el4L5", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $a706b7c6f99d86f6$export$2c14ff85d6318973; }, function (v) { return $a706b7c6f99d86f6$export$2c14ff85d6318973 = v; });
var $a706b7c6f99d86f6$export$2c14ff85d6318973;
"use strict";
$a706b7c6f99d86f6$export$2c14ff85d6318973 = void 0;
const $a706b7c6f99d86f6$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "v\xe4hem kui \xfcks sekund",
            other: "v\xe4hem kui {{count}} sekundit"
        },
        withPreposition: {
            one: "v\xe4hem kui \xfche sekundi",
            other: "v\xe4hem kui {{count}} sekundi"
        }
    },
    xSeconds: {
        standalone: {
            one: "\xfcks sekund",
            other: "{{count}} sekundit"
        },
        withPreposition: {
            one: "\xfche sekundi",
            other: "{{count}} sekundi"
        }
    },
    halfAMinute: {
        standalone: "pool minutit",
        withPreposition: "poole minuti"
    },
    lessThanXMinutes: {
        standalone: {
            one: "v\xe4hem kui \xfcks minut",
            other: "v\xe4hem kui {{count}} minutit"
        },
        withPreposition: {
            one: "v\xe4hem kui \xfche minuti",
            other: "v\xe4hem kui {{count}} minuti"
        }
    },
    xMinutes: {
        standalone: {
            one: "\xfcks minut",
            other: "{{count}} minutit"
        },
        withPreposition: {
            one: "\xfche minuti",
            other: "{{count}} minuti"
        }
    },
    aboutXHours: {
        standalone: {
            one: "umbes \xfcks tund",
            other: "umbes {{count}} tundi"
        },
        withPreposition: {
            one: "umbes \xfche tunni",
            other: "umbes {{count}} tunni"
        }
    },
    xHours: {
        standalone: {
            one: "\xfcks tund",
            other: "{{count}} tundi"
        },
        withPreposition: {
            one: "\xfche tunni",
            other: "{{count}} tunni"
        }
    },
    xDays: {
        standalone: {
            one: "\xfcks p\xe4ev",
            other: "{{count}} p\xe4eva"
        },
        withPreposition: {
            one: "\xfche p\xe4eva",
            other: "{{count}} p\xe4eva"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "umbes \xfcks n\xe4dal",
            other: "umbes {{count}} n\xe4dalat"
        },
        withPreposition: {
            one: "umbes \xfche n\xe4dala",
            other: "umbes {{count}} n\xe4dala"
        }
    },
    xWeeks: {
        standalone: {
            one: "\xfcks n\xe4dal",
            other: "{{count}} n\xe4dalat"
        },
        withPreposition: {
            one: "\xfche n\xe4dala",
            other: "{{count}} n\xe4dala"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "umbes \xfcks kuu",
            other: "umbes {{count}} kuud"
        },
        withPreposition: {
            one: "umbes \xfche kuu",
            other: "umbes {{count}} kuu"
        }
    },
    xMonths: {
        standalone: {
            one: "\xfcks kuu",
            other: "{{count}} kuud"
        },
        withPreposition: {
            one: "\xfche kuu",
            other: "{{count}} kuu"
        }
    },
    aboutXYears: {
        standalone: {
            one: "umbes \xfcks aasta",
            other: "umbes {{count}} aastat"
        },
        withPreposition: {
            one: "umbes \xfche aasta",
            other: "umbes {{count}} aasta"
        }
    },
    xYears: {
        standalone: {
            one: "\xfcks aasta",
            other: "{{count}} aastat"
        },
        withPreposition: {
            one: "\xfche aasta",
            other: "{{count}} aasta"
        }
    },
    overXYears: {
        standalone: {
            one: "rohkem kui \xfcks aasta",
            other: "rohkem kui {{count}} aastat"
        },
        withPreposition: {
            one: "rohkem kui \xfche aasta",
            other: "rohkem kui {{count}} aasta"
        }
    },
    almostXYears: {
        standalone: {
            one: "peaaegu \xfcks aasta",
            other: "peaaegu {{count}} aastat"
        },
        withPreposition: {
            one: "peaaegu \xfche aasta",
            other: "peaaegu {{count}} aasta"
        }
    }
};
const $a706b7c6f99d86f6$var$formatDistance = (token, count, options)=>{
    const usageGroup = options?.addSuffix ? $a706b7c6f99d86f6$var$formatDistanceLocale[token].withPreposition : $a706b7c6f99d86f6$var$formatDistanceLocale[token].standalone;
    let result;
    if (typeof usageGroup === "string") result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else result = usageGroup.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " p\xe4rast";
        else return result + " eest";
    }
    return result;
};
$a706b7c6f99d86f6$export$2c14ff85d6318973 = $a706b7c6f99d86f6$var$formatDistance;

});

parcelRegister("9MyVF", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $71f3b0efdeb5b079$export$cbf60ecb96cbb82f; }, function (v) { return $71f3b0efdeb5b079$export$cbf60ecb96cbb82f = v; });
var $71f3b0efdeb5b079$export$cbf60ecb96cbb82f;
"use strict";
$71f3b0efdeb5b079$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $71f3b0efdeb5b079$var$dateFormats = {
    full: "EEEE, d. MMMM y",
    long: "d. MMMM y",
    medium: "d. MMM y",
    short: "dd.MM.y"
};
const $71f3b0efdeb5b079$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $71f3b0efdeb5b079$var$dateTimeFormats = {
    full: "{{date}} 'kell' {{time}}",
    long: "{{date}} 'kell' {{time}}",
    medium: "{{date}}. {{time}}",
    short: "{{date}}. {{time}}"
};
const $71f3b0efdeb5b079$var$formatLong = $71f3b0efdeb5b079$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $71f3b0efdeb5b079$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $71f3b0efdeb5b079$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $71f3b0efdeb5b079$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("c4UoK", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $8cb19b40abf81733$export$8fbbfd65594f46a0; }, function (v) { return $8cb19b40abf81733$export$8fbbfd65594f46a0 = v; });
var $8cb19b40abf81733$export$8fbbfd65594f46a0;
"use strict";
$8cb19b40abf81733$export$8fbbfd65594f46a0 = void 0;
const $8cb19b40abf81733$var$formatRelativeLocale = {
    lastWeek: "'eelmine' eeee 'kell' p",
    yesterday: "'eile kell' p",
    today: "'t\xe4na kell' p",
    tomorrow: "'homme kell' p",
    nextWeek: "'j\xe4rgmine' eeee 'kell' p",
    other: "P"
};
const $8cb19b40abf81733$var$formatRelative = (token, _date, _baseDate, _options)=>$8cb19b40abf81733$var$formatRelativeLocale[token];
$8cb19b40abf81733$export$8fbbfd65594f46a0 = $8cb19b40abf81733$var$formatRelative;

});

parcelRegister("9GrlO", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $70cd40949cfc5f0d$export$b3bd0bc58e36cd63; }, function (v) { return $70cd40949cfc5f0d$export$b3bd0bc58e36cd63 = v; });
var $70cd40949cfc5f0d$export$b3bd0bc58e36cd63;
"use strict";
$70cd40949cfc5f0d$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $70cd40949cfc5f0d$var$eraValues = {
    narrow: [
        "e.m.a",
        "m.a.j"
    ],
    abbreviated: [
        "e.m.a",
        "m.a.j"
    ],
    wide: [
        "enne meie ajaarvamist",
        "meie ajaarvamise j\xe4rgi"
    ]
};
const $70cd40949cfc5f0d$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1. kvartal",
        "2. kvartal",
        "3. kvartal",
        "4. kvartal"
    ]
};
const $70cd40949cfc5f0d$var$monthValues = {
    narrow: [
        "J",
        "V",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jaan",
        "veebr",
        "m\xe4rts",
        "apr",
        "mai",
        "juuni",
        "juuli",
        "aug",
        "sept",
        "okt",
        "nov",
        "dets"
    ],
    wide: [
        "jaanuar",
        "veebruar",
        "m\xe4rts",
        "aprill",
        "mai",
        "juuni",
        "juuli",
        "august",
        "september",
        "oktoober",
        "november",
        "detsember"
    ]
};
const $70cd40949cfc5f0d$var$dayValues = {
    narrow: [
        "P",
        "E",
        "T",
        "K",
        "N",
        "R",
        "L"
    ],
    short: [
        "P",
        "E",
        "T",
        "K",
        "N",
        "R",
        "L"
    ],
    abbreviated: [
        "p\xfchap.",
        "esmasp.",
        "teisip.",
        "kolmap.",
        "neljap.",
        "reede.",
        "laup."
    ],
    wide: [
        "p\xfchap\xe4ev",
        "esmasp\xe4ev",
        "teisip\xe4ev",
        "kolmap\xe4ev",
        "neljap\xe4ev",
        "reede",
        "laup\xe4ev"
    ]
};
const $70cd40949cfc5f0d$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: "hommik",
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: "hommik",
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: "hommik",
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    }
};
const $70cd40949cfc5f0d$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: "hommikul",
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: "hommikul",
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: "hommikul",
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    }
};
const $70cd40949cfc5f0d$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $70cd40949cfc5f0d$var$localize = $70cd40949cfc5f0d$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $70cd40949cfc5f0d$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $70cd40949cfc5f0d$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $70cd40949cfc5f0d$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $70cd40949cfc5f0d$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $70cd40949cfc5f0d$var$monthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $70cd40949cfc5f0d$var$dayValues,
        defaultWidth: "wide",
        formattingValues: $70cd40949cfc5f0d$var$dayValues,
        defaultFormattingWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $70cd40949cfc5f0d$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $70cd40949cfc5f0d$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("cw2FY", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $91ca8c98a004e6df$export$4659b591c19bdf3d; }, function (v) { return $91ca8c98a004e6df$export$4659b591c19bdf3d = v; });
var $91ca8c98a004e6df$export$4659b591c19bdf3d;
"use strict";
$91ca8c98a004e6df$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $91ca8c98a004e6df$var$matchOrdinalNumberPattern = /^\d+\./i;
const $91ca8c98a004e6df$var$parseOrdinalNumberPattern = /\d+/i;
const $91ca8c98a004e6df$var$matchEraPatterns = {
    narrow: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
    abbreviated: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
    wide: /^(enne meie ajaarvamist|meie ajaarvamise järgi|enne Kristust|pärast Kristust)/i
};
const $91ca8c98a004e6df$var$parseEraPatterns = {
    any: [
        /^e/i,
        /^(m|p)/i
    ]
};
const $91ca8c98a004e6df$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
const $91ca8c98a004e6df$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $91ca8c98a004e6df$var$matchMonthPatterns = {
    narrow: /^[jvmasond]/i,
    abbreviated: /^(jaan|veebr|märts|apr|mai|juuni|juuli|aug|sept|okt|nov|dets)/i,
    wide: /^(jaanuar|veebruar|märts|aprill|mai|juuni|juuli|august|september|oktoober|november|detsember)/i
};
const $91ca8c98a004e6df$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^v/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^v/i,
        /^mär/i,
        /^ap/i,
        /^mai/i,
        /^juun/i,
        /^juul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $91ca8c98a004e6df$var$matchDayPatterns = {
    narrow: /^[petknrl]/i,
    short: /^[petknrl]/i,
    abbreviated: /^(püh?|esm?|tei?|kolm?|nel?|ree?|laup?)\.?/i,
    wide: /^(pühapäev|esmaspäev|teisipäev|kolmapäev|neljapäev|reede|laupäev)/i
};
const $91ca8c98a004e6df$var$parseDayPatterns = {
    any: [
        /^p/i,
        /^e/i,
        /^t/i,
        /^k/i,
        /^n/i,
        /^r/i,
        /^l/i
    ]
};
const $91ca8c98a004e6df$var$matchDayPeriodPatterns = {
    any: /^(am|pm|keskööl?|keskpäev(al)?|hommik(ul)?|pärastlõunal?|õhtul?|öö(sel)?)/i
};
const $91ca8c98a004e6df$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^keskö/i,
        noon: /^keskp/i,
        morning: /hommik/i,
        afternoon: /pärastlõuna/i,
        evening: /õhtu/i,
        night: /öö/i
    }
};
const $91ca8c98a004e6df$var$match = $91ca8c98a004e6df$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $91ca8c98a004e6df$var$matchOrdinalNumberPattern,
        parsePattern: $91ca8c98a004e6df$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $91ca8c98a004e6df$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $91ca8c98a004e6df$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $91ca8c98a004e6df$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $91ca8c98a004e6df$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $91ca8c98a004e6df$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $91ca8c98a004e6df$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $91ca8c98a004e6df$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $91ca8c98a004e6df$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $91ca8c98a004e6df$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $91ca8c98a004e6df$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("aGtfR", function(module, exports) {

$parcel$export(module.exports, "eu", function () { return $7c7485046f9a424b$export$2f4e8cc3c5ca4de9; }, function (v) { return $7c7485046f9a424b$export$2f4e8cc3c5ca4de9 = v; });
var $7c7485046f9a424b$export$2f4e8cc3c5ca4de9;
"use strict";
$7c7485046f9a424b$export$2f4e8cc3c5ca4de9 = void 0;

var $dSDOM = parcelRequire("dSDOM");

var $elzL1 = parcelRequire("elzL1");

var $aaSxt = parcelRequire("aaSxt");

var $atJAS = parcelRequire("atJAS");

var $jMzA5 = parcelRequire("jMzA5");
/**
 * @category Locales
 * @summary Basque locale.
 * @language Basque
 * @iso-639-2 eus
 * @author Jacob Söderblom [@JacobSoderblom](https://github.com/JacobSoderblom)
 */ const $7c7485046f9a424b$var$eu = $7c7485046f9a424b$export$2f4e8cc3c5ca4de9 = {
    code: "eu",
    formatDistance: $dSDOM.formatDistance,
    formatLong: $elzL1.formatLong,
    formatRelative: $aaSxt.formatRelative,
    localize: $atJAS.localize,
    match: $jMzA5.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("dSDOM", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $a1af3484d9bedc3d$export$2c14ff85d6318973; }, function (v) { return $a1af3484d9bedc3d$export$2c14ff85d6318973 = v; });
var $a1af3484d9bedc3d$export$2c14ff85d6318973;
"use strict";
$a1af3484d9bedc3d$export$2c14ff85d6318973 = void 0;
const $a1af3484d9bedc3d$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "segundo bat baino gutxiago",
        other: "{{count}} segundo baino gutxiago"
    },
    xSeconds: {
        one: "1 segundo",
        other: "{{count}} segundo"
    },
    halfAMinute: "minutu erdi",
    lessThanXMinutes: {
        one: "minutu bat baino gutxiago",
        other: "{{count}} minutu baino gutxiago"
    },
    xMinutes: {
        one: "1 minutu",
        other: "{{count}} minutu"
    },
    aboutXHours: {
        one: "1 ordu gutxi gorabehera",
        other: "{{count}} ordu gutxi gorabehera"
    },
    xHours: {
        one: "1 ordu",
        other: "{{count}} ordu"
    },
    xDays: {
        one: "1 egun",
        other: "{{count}} egun"
    },
    aboutXWeeks: {
        one: "aste 1 inguru",
        other: "{{count}} aste inguru"
    },
    xWeeks: {
        one: "1 aste",
        other: "{{count}} astean"
    },
    aboutXMonths: {
        one: "1 hilabete gutxi gorabehera",
        other: "{{count}} hilabete gutxi gorabehera"
    },
    xMonths: {
        one: "1 hilabete",
        other: "{{count}} hilabete"
    },
    aboutXYears: {
        one: "1 urte gutxi gorabehera",
        other: "{{count}} urte gutxi gorabehera"
    },
    xYears: {
        one: "1 urte",
        other: "{{count}} urte"
    },
    overXYears: {
        one: "1 urte baino gehiago",
        other: "{{count}} urte baino gehiago"
    },
    almostXYears: {
        one: "ia 1 urte",
        other: "ia {{count}} urte"
    }
};
const $a1af3484d9bedc3d$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $a1af3484d9bedc3d$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "en " + result;
        else return "duela " + result;
    }
    return result;
};
$a1af3484d9bedc3d$export$2c14ff85d6318973 = $a1af3484d9bedc3d$var$formatDistance;

});

parcelRegister("elzL1", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $a71ec382cf8529e4$export$cbf60ecb96cbb82f; }, function (v) { return $a71ec382cf8529e4$export$cbf60ecb96cbb82f = v; });
var $a71ec382cf8529e4$export$cbf60ecb96cbb82f;
"use strict";
$a71ec382cf8529e4$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $a71ec382cf8529e4$var$dateFormats = {
    full: "EEEE, y'ko' MMMM'ren' d'a' y'ren'",
    long: "y'ko' MMMM'ren' d'a'",
    medium: "y MMM d",
    short: "yy/MM/dd"
};
const $a71ec382cf8529e4$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $a71ec382cf8529e4$var$dateTimeFormats = {
    full: "{{date}} 'tan' {{time}}",
    long: "{{date}} 'tan' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $a71ec382cf8529e4$var$formatLong = $a71ec382cf8529e4$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $a71ec382cf8529e4$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $a71ec382cf8529e4$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $a71ec382cf8529e4$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("aaSxt", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $768524dac29445ad$export$8fbbfd65594f46a0; }, function (v) { return $768524dac29445ad$export$8fbbfd65594f46a0 = v; });
var $768524dac29445ad$export$8fbbfd65594f46a0;
"use strict";
$768524dac29445ad$export$8fbbfd65594f46a0 = void 0;
const $768524dac29445ad$var$formatRelativeLocale = {
    lastWeek: "'joan den' eeee, LT",
    yesterday: "'atzo,' p",
    today: "'gaur,' p",
    tomorrow: "'bihar,' p",
    nextWeek: "eeee, p",
    other: "P"
};
const $768524dac29445ad$var$formatRelativeLocalePlural = {
    lastWeek: "'joan den' eeee, p",
    yesterday: "'atzo,' p",
    today: "'gaur,' p",
    tomorrow: "'bihar,' p",
    nextWeek: "eeee, p",
    other: "P"
};
const $768524dac29445ad$var$formatRelative = (token, date)=>{
    if (date.getHours() !== 1) return $768524dac29445ad$var$formatRelativeLocalePlural[token];
    return $768524dac29445ad$var$formatRelativeLocale[token];
};
$768524dac29445ad$export$8fbbfd65594f46a0 = $768524dac29445ad$var$formatRelative;

});

parcelRegister("atJAS", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $7a0ffac4e7ea9110$export$b3bd0bc58e36cd63; }, function (v) { return $7a0ffac4e7ea9110$export$b3bd0bc58e36cd63 = v; });
var $7a0ffac4e7ea9110$export$b3bd0bc58e36cd63;
"use strict";
$7a0ffac4e7ea9110$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $7a0ffac4e7ea9110$var$eraValues = {
    narrow: [
        "k.a.",
        "k.o."
    ],
    abbreviated: [
        "k.a.",
        "k.o."
    ],
    wide: [
        "kristo aurretik",
        "kristo ondoren"
    ]
};
const $7a0ffac4e7ea9110$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1H",
        "2H",
        "3H",
        "4H"
    ],
    wide: [
        "1. hiruhilekoa",
        "2. hiruhilekoa",
        "3. hiruhilekoa",
        "4. hiruhilekoa"
    ]
};
const $7a0ffac4e7ea9110$var$monthValues = {
    narrow: [
        "u",
        "o",
        "m",
        "a",
        "m",
        "e",
        "u",
        "a",
        "i",
        "u",
        "a",
        "a"
    ],
    abbreviated: [
        "urt",
        "ots",
        "mar",
        "api",
        "mai",
        "eka",
        "uzt",
        "abu",
        "ira",
        "urr",
        "aza",
        "abe"
    ],
    wide: [
        "urtarrila",
        "otsaila",
        "martxoa",
        "apirila",
        "maiatza",
        "ekaina",
        "uztaila",
        "abuztua",
        "iraila",
        "urria",
        "azaroa",
        "abendua"
    ]
};
const $7a0ffac4e7ea9110$var$dayValues = {
    narrow: [
        "i",
        "a",
        "a",
        "a",
        "o",
        "o",
        "l"
    ],
    short: [
        "ig",
        "al",
        "as",
        "az",
        "og",
        "or",
        "lr"
    ],
    abbreviated: [
        "iga",
        "ast",
        "ast",
        "ast",
        "ost",
        "ost",
        "lar"
    ],
    wide: [
        "igandea",
        "astelehena",
        "asteartea",
        "asteazkena",
        "osteguna",
        "ostirala",
        "larunbata"
    ]
};
const $7a0ffac4e7ea9110$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "ge",
        noon: "eg",
        morning: "goiza",
        afternoon: "arratsaldea",
        evening: "arratsaldea",
        night: "gaua"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "gauerdia",
        noon: "eguerdia",
        morning: "goiza",
        afternoon: "arratsaldea",
        evening: "arratsaldea",
        night: "gaua"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "gauerdia",
        noon: "eguerdia",
        morning: "goiza",
        afternoon: "arratsaldea",
        evening: "arratsaldea",
        night: "gaua"
    }
};
const $7a0ffac4e7ea9110$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "ge",
        noon: "eg",
        morning: "goizean",
        afternoon: "arratsaldean",
        evening: "arratsaldean",
        night: "gauean"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "gauerdia",
        noon: "eguerdia",
        morning: "goizean",
        afternoon: "arratsaldean",
        evening: "arratsaldean",
        night: "gauean"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "gauerdia",
        noon: "eguerdia",
        morning: "goizean",
        afternoon: "arratsaldean",
        evening: "arratsaldean",
        night: "gauean"
    }
};
const $7a0ffac4e7ea9110$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $7a0ffac4e7ea9110$var$localize = $7a0ffac4e7ea9110$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $7a0ffac4e7ea9110$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $7a0ffac4e7ea9110$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $7a0ffac4e7ea9110$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $7a0ffac4e7ea9110$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $7a0ffac4e7ea9110$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $7a0ffac4e7ea9110$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $7a0ffac4e7ea9110$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("jMzA5", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $e66e19ad82f32ddc$export$4659b591c19bdf3d; }, function (v) { return $e66e19ad82f32ddc$export$4659b591c19bdf3d = v; });
var $e66e19ad82f32ddc$export$4659b591c19bdf3d;
"use strict";
$e66e19ad82f32ddc$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $e66e19ad82f32ddc$var$matchOrdinalNumberPattern = /^(\d+)(.)?/i;
const $e66e19ad82f32ddc$var$parseOrdinalNumberPattern = /\d+/i;
const $e66e19ad82f32ddc$var$matchEraPatterns = {
    narrow: /^(k.a.|k.o.)/i,
    abbreviated: /^(k.a.|k.o.)/i,
    wide: /^(kristo aurretik|kristo ondoren)/i
};
const $e66e19ad82f32ddc$var$parseEraPatterns = {
    narrow: [
        /^k.a./i,
        /^k.o./i
    ],
    abbreviated: [
        /^(k.a.)/i,
        /^(k.o.)/i
    ],
    wide: [
        /^(kristo aurretik)/i,
        /^(kristo ondoren)/i
    ]
};
const $e66e19ad82f32ddc$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]H/i,
    wide: /^[1234](.)? hiruhilekoa/i
};
const $e66e19ad82f32ddc$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $e66e19ad82f32ddc$var$matchMonthPatterns = {
    narrow: /^[uomaei]/i,
    abbreviated: /^(urt|ots|mar|api|mai|eka|uzt|abu|ira|urr|aza|abe)/i,
    wide: /^(urtarrila|otsaila|martxoa|apirila|maiatza|ekaina|uztaila|abuztua|iraila|urria|azaroa|abendua)/i
};
const $e66e19ad82f32ddc$var$parseMonthPatterns = {
    narrow: [
        /^u/i,
        /^o/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^e/i,
        /^u/i,
        /^a/i,
        /^i/i,
        /^u/i,
        /^a/i,
        /^a/i
    ],
    any: [
        /^urt/i,
        /^ots/i,
        /^mar/i,
        /^api/i,
        /^mai/i,
        /^eka/i,
        /^uzt/i,
        /^abu/i,
        /^ira/i,
        /^urr/i,
        /^aza/i,
        /^abe/i
    ]
};
const $e66e19ad82f32ddc$var$matchDayPatterns = {
    narrow: /^[iaol]/i,
    short: /^(ig|al|as|az|og|or|lr)/i,
    abbreviated: /^(iga|ast|ast|ast|ost|ost|lar)/i,
    wide: /^(igandea|astelehena|asteartea|asteazkena|osteguna|ostirala|larunbata)/i
};
const $e66e19ad82f32ddc$var$parseDayPatterns = {
    narrow: [
        /^i/i,
        /^a/i,
        /^a/i,
        /^a/i,
        /^o/i,
        /^o/i,
        /^l/i
    ],
    short: [
        /^ig/i,
        /^al/i,
        /^as/i,
        /^az/i,
        /^og/i,
        /^or/i,
        /^lr/i
    ],
    abbreviated: [
        /^iga/i,
        /^ast/i,
        /^ast/i,
        /^ast/i,
        /^ost/i,
        /^ost/i,
        /^lar/i
    ],
    wide: [
        /^igandea/i,
        /^astelehena/i,
        /^asteartea/i,
        /^asteazkena/i,
        /^osteguna/i,
        /^ostirala/i,
        /^larunbata/i
    ]
};
const $e66e19ad82f32ddc$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|ge|eg|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i,
    any: /^([ap]\.?\s?m\.?|gauerdia|eguerdia|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i
};
const $e66e19ad82f32ddc$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^ge/i,
        noon: /^eg/i,
        morning: /goiz/i,
        afternoon: /arratsaldea/i,
        evening: /arratsaldea/i,
        night: /gau/i
    },
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^gauerdia/i,
        noon: /^eguerdia/i,
        morning: /goiz/i,
        afternoon: /arratsaldea/i,
        evening: /arratsaldea/i,
        night: /gau/i
    }
};
const $e66e19ad82f32ddc$var$match = $e66e19ad82f32ddc$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $e66e19ad82f32ddc$var$matchOrdinalNumberPattern,
        parsePattern: $e66e19ad82f32ddc$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e66e19ad82f32ddc$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e66e19ad82f32ddc$var$parseEraPatterns,
        defaultParseWidth: "wide"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e66e19ad82f32ddc$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e66e19ad82f32ddc$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e66e19ad82f32ddc$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e66e19ad82f32ddc$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e66e19ad82f32ddc$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e66e19ad82f32ddc$var$parseDayPatterns,
        defaultParseWidth: "wide"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e66e19ad82f32ddc$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $e66e19ad82f32ddc$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("drQoH", function(module, exports) {

$parcel$export(module.exports, "faIR", function () { return $9ca67100ebf7c9c9$export$355e05e1e35701f3; }, function (v) { return $9ca67100ebf7c9c9$export$355e05e1e35701f3 = v; });
var $9ca67100ebf7c9c9$export$355e05e1e35701f3;
"use strict";
$9ca67100ebf7c9c9$export$355e05e1e35701f3 = void 0;

var $cTaa2 = parcelRequire("cTaa2");

var $3qhUJ = parcelRequire("3qhUJ");

var $9ELcZ = parcelRequire("9ELcZ");

var $6keoA = parcelRequire("6keoA");

var $fqHCy = parcelRequire("fqHCy");
/**
 * @category Locales
 * @summary Persian/Farsi locale (Iran).
 * @language Persian
 * @iso-639-2 ira
 * @author Morteza Ziyae [@mort3za](https://github.com/mort3za)
 */ const $9ca67100ebf7c9c9$var$faIR = $9ca67100ebf7c9c9$export$355e05e1e35701f3 = {
    code: "fa-IR",
    formatDistance: $cTaa2.formatDistance,
    formatLong: $3qhUJ.formatLong,
    formatRelative: $9ELcZ.formatRelative,
    localize: $6keoA.localize,
    match: $fqHCy.match,
    options: {
        weekStartsOn: 6 /* Saturday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("cTaa2", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $962280d3930a69a2$export$2c14ff85d6318973; }, function (v) { return $962280d3930a69a2$export$2c14ff85d6318973 = v; });
var $962280d3930a69a2$export$2c14ff85d6318973;
"use strict";
$962280d3930a69a2$export$2c14ff85d6318973 = void 0;
const $962280d3930a69a2$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u06A9\u0645\u062A\u0631 \u0627\u0632 \u06CC\u06A9 \u062B\u0627\u0646\u06CC\u0647",
        other: "\u06A9\u0645\u062A\u0631 \u0627\u0632 {{count}} \u062B\u0627\u0646\u06CC\u0647"
    },
    xSeconds: {
        one: "1 \u062B\u0627\u0646\u06CC\u0647",
        other: "{{count}} \u062B\u0627\u0646\u06CC\u0647"
    },
    halfAMinute: "\u0646\u06CC\u0645 \u062F\u0642\u06CC\u0642\u0647",
    lessThanXMinutes: {
        one: "\u06A9\u0645\u062A\u0631 \u0627\u0632 \u06CC\u06A9 \u062F\u0642\u06CC\u0642\u0647",
        other: "\u06A9\u0645\u062A\u0631 \u0627\u0632 {{count}} \u062F\u0642\u06CC\u0642\u0647"
    },
    xMinutes: {
        one: "1 \u062F\u0642\u06CC\u0642\u0647",
        other: "{{count}} \u062F\u0642\u06CC\u0642\u0647"
    },
    aboutXHours: {
        one: "\u062D\u062F\u0648\u062F 1 \u0633\u0627\u0639\u062A",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0633\u0627\u0639\u062A"
    },
    xHours: {
        one: "1 \u0633\u0627\u0639\u062A",
        other: "{{count}} \u0633\u0627\u0639\u062A"
    },
    xDays: {
        one: "1 \u0631\u0648\u0632",
        other: "{{count}} \u0631\u0648\u0632"
    },
    aboutXWeeks: {
        one: "\u062D\u062F\u0648\u062F 1 \u0647\u0641\u062A\u0647",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0647\u0641\u062A\u0647"
    },
    xWeeks: {
        one: "1 \u0647\u0641\u062A\u0647",
        other: "{{count}} \u0647\u0641\u062A\u0647"
    },
    aboutXMonths: {
        one: "\u062D\u062F\u0648\u062F 1 \u0645\u0627\u0647",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0645\u0627\u0647"
    },
    xMonths: {
        one: "1 \u0645\u0627\u0647",
        other: "{{count}} \u0645\u0627\u0647"
    },
    aboutXYears: {
        one: "\u062D\u062F\u0648\u062F 1 \u0633\u0627\u0644",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0633\u0627\u0644"
    },
    xYears: {
        one: "1 \u0633\u0627\u0644",
        other: "{{count}} \u0633\u0627\u0644"
    },
    overXYears: {
        one: "\u0628\u06CC\u0634\u062A\u0631 \u0627\u0632 1 \u0633\u0627\u0644",
        other: "\u0628\u06CC\u0634\u062A\u0631 \u0627\u0632 {{count}} \u0633\u0627\u0644"
    },
    almostXYears: {
        one: "\u0646\u0632\u062F\u06CC\u06A9 1 \u0633\u0627\u0644",
        other: "\u0646\u0632\u062F\u06CC\u06A9 {{count}} \u0633\u0627\u0644"
    }
};
const $962280d3930a69a2$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $962280d3930a69a2$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u062F\u0631 " + result;
        else return result + " \u0642\u0628\u0644";
    }
    return result;
};
$962280d3930a69a2$export$2c14ff85d6318973 = $962280d3930a69a2$var$formatDistance;

});

parcelRegister("3qhUJ", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $27e1b22a9dabd913$export$cbf60ecb96cbb82f; }, function (v) { return $27e1b22a9dabd913$export$cbf60ecb96cbb82f = v; });
var $27e1b22a9dabd913$export$cbf60ecb96cbb82f;
"use strict";
$27e1b22a9dabd913$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $27e1b22a9dabd913$var$dateFormats = {
    full: "EEEE do MMMM y",
    long: "do MMMM y",
    medium: "d MMM y",
    short: "yyyy/MM/dd"
};
const $27e1b22a9dabd913$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $27e1b22a9dabd913$var$dateTimeFormats = {
    full: "{{date}} '\u062F\u0631' {{time}}",
    long: "{{date}} '\u062F\u0631' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $27e1b22a9dabd913$var$formatLong = $27e1b22a9dabd913$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $27e1b22a9dabd913$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $27e1b22a9dabd913$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $27e1b22a9dabd913$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("9ELcZ", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $707c781ca5625c47$export$8fbbfd65594f46a0; }, function (v) { return $707c781ca5625c47$export$8fbbfd65594f46a0 = v; });
var $707c781ca5625c47$export$8fbbfd65594f46a0;
"use strict";
$707c781ca5625c47$export$8fbbfd65594f46a0 = void 0;
const $707c781ca5625c47$var$formatRelativeLocale = {
    lastWeek: "eeee '\u06AF\u0630\u0634\u062A\u0647 \u062F\u0631' p",
    yesterday: "'\u062F\u06CC\u0631\u0648\u0632 \u062F\u0631' p",
    today: "'\u0627\u0645\u0631\u0648\u0632 \u062F\u0631' p",
    tomorrow: "'\u0641\u0631\u062F\u0627 \u062F\u0631' p",
    nextWeek: "eeee '\u062F\u0631' p",
    other: "P"
};
const $707c781ca5625c47$var$formatRelative = (token, _date, _baseDate, _options)=>$707c781ca5625c47$var$formatRelativeLocale[token];
$707c781ca5625c47$export$8fbbfd65594f46a0 = $707c781ca5625c47$var$formatRelative;

});

parcelRegister("6keoA", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $49afc6fafdde5600$export$b3bd0bc58e36cd63; }, function (v) { return $49afc6fafdde5600$export$b3bd0bc58e36cd63 = v; });
var $49afc6fafdde5600$export$b3bd0bc58e36cd63;
"use strict";
$49afc6fafdde5600$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $49afc6fafdde5600$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0632 \u0645\u06CC\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0632 \u0645\u06CC\u0644\u0627\u062F"
    ]
};
const $49afc6fafdde5600$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u0633\u200C\u06451",
        "\u0633\u200C\u06452",
        "\u0633\u200C\u06453",
        "\u0633\u200C\u06454"
    ],
    wide: [
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 1",
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 2",
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 3",
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 4"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $49afc6fafdde5600$var$monthValues = {
    narrow: [
        "\u0698",
        "\u0641",
        "\u0645",
        "\u0622",
        "\u0645",
        "\u062C",
        "\u062C",
        "\u0622",
        "\u0633",
        "\u0627",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u0698\u0627\u0646\u0640",
        "\u0641\u0648\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0622\u067E\u0631",
        "\u0645\u06CC",
        "\u062C\u0648\u0646",
        "\u062C\u0648\u0644\u0640",
        "\u0622\u06AF\u0648",
        "\u0633\u067E\u062A\u0640",
        "\u0627\u06A9\u062A\u0640",
        "\u0646\u0648\u0627\u0645\u0640",
        "\u062F\u0633\u0627\u0645\u0640"
    ],
    wide: [
        "\u0698\u0627\u0646\u0648\u06CC\u0647",
        "\u0641\u0648\u0631\u06CC\u0647",
        "\u0645\u0627\u0631\u0633",
        "\u0622\u067E\u0631\u06CC\u0644",
        "\u0645\u06CC",
        "\u062C\u0648\u0646",
        "\u062C\u0648\u0644\u0627\u06CC",
        "\u0622\u06AF\u0648\u0633\u062A",
        "\u0633\u067E\u062A\u0627\u0645\u0628\u0631",
        "\u0627\u06A9\u062A\u0628\u0631",
        "\u0646\u0648\u0627\u0645\u0628\u0631",
        "\u062F\u0633\u0627\u0645\u0628\u0631"
    ]
};
const $49afc6fafdde5600$var$dayValues = {
    narrow: [
        "\u06CC",
        "\u062F",
        "\u0633",
        "\u0686",
        "\u067E",
        "\u062C",
        "\u0634"
    ],
    short: [
        "1\u0634",
        "2\u0634",
        "3\u0634",
        "4\u0634",
        "5\u0634",
        "\u062C",
        "\u0634"
    ],
    abbreviated: [
        "\u06CC\u06A9\u0634\u0646\u0628\u0647",
        "\u062F\u0648\u0634\u0646\u0628\u0647",
        "\u0633\u0647\u200C\u0634\u0646\u0628\u0647",
        "\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647",
        "\u067E\u0646\u062C\u0634\u0646\u0628\u0647",
        "\u062C\u0645\u0639\u0647",
        "\u0634\u0646\u0628\u0647"
    ],
    wide: [
        "\u06CC\u06A9\u0634\u0646\u0628\u0647",
        "\u062F\u0648\u0634\u0646\u0628\u0647",
        "\u0633\u0647\u200C\u0634\u0646\u0628\u0647",
        "\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647",
        "\u067E\u0646\u062C\u0634\u0646\u0628\u0647",
        "\u062C\u0645\u0639\u0647",
        "\u0634\u0646\u0628\u0647"
    ]
};
const $49afc6fafdde5600$var$dayPeriodValues = {
    narrow: {
        am: "\u0642",
        pm: "\u0628",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635",
        afternoon: "\u0628.\u0638.",
        evening: "\u0639",
        night: "\u0634"
    },
    abbreviated: {
        am: "\u0642.\u0638.",
        pm: "\u0628.\u0638.",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    },
    wide: {
        am: "\u0642\u0628\u0644\u200C\u0627\u0632\u0638\u0647\u0631",
        pm: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    }
};
const $49afc6fafdde5600$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0642",
        pm: "\u0628",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635",
        afternoon: "\u0628.\u0638.",
        evening: "\u0639",
        night: "\u0634"
    },
    abbreviated: {
        am: "\u0642.\u0638.",
        pm: "\u0628.\u0638.",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    },
    wide: {
        am: "\u0642\u0628\u0644\u200C\u0627\u0632\u0638\u0647\u0631",
        pm: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    }
};
const $49afc6fafdde5600$var$ordinalNumber = (dirtyNumber, _options)=>{
    return String(dirtyNumber);
};
const $49afc6fafdde5600$var$localize = $49afc6fafdde5600$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $49afc6fafdde5600$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $49afc6fafdde5600$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $49afc6fafdde5600$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $49afc6fafdde5600$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $49afc6fafdde5600$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $49afc6fafdde5600$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $49afc6fafdde5600$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("fqHCy", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $b3bb1eeca91148fd$export$4659b591c19bdf3d; }, function (v) { return $b3bb1eeca91148fd$export$4659b591c19bdf3d = v; });
var $b3bb1eeca91148fd$export$4659b591c19bdf3d;
"use strict";
$b3bb1eeca91148fd$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $b3bb1eeca91148fd$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $b3bb1eeca91148fd$var$parseOrdinalNumberPattern = /\d+/i;
const $b3bb1eeca91148fd$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?د\.?\s?م\.?|م\.?\s?|د\.?\s?م\.?)/i,
    wide: /^(قبل از میلاد|قبل از دوران مشترک|میلادی|دوران مشترک|بعد از میلاد)/i
};
const $b3bb1eeca91148fd$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
const $b3bb1eeca91148fd$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^س‌م[1234]/i,
    wide: /^سه‌ماهه [1234]/i
};
const $b3bb1eeca91148fd$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $b3bb1eeca91148fd$var$matchMonthPatterns = {
    narrow: /^[جژفمآاماسند]/i,
    abbreviated: /^(جنو|ژانـ|ژانویه|فوریه|فور|مارس|آوریل|آپر|مه|می|ژوئن|جون|جول|جولـ|ژوئیه|اوت|آگو|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نوامـ|دسامبر|دسامـ|دسم)/i,
    wide: /^(ژانویه|جنوری|فبروری|فوریه|مارچ|مارس|آپریل|اپریل|ایپریل|آوریل|مه|می|ژوئن|جون|جولای|ژوئیه|آگست|اگست|آگوست|اوت|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نومبر|دسامبر|دسمبر)/i
};
const $b3bb1eeca91148fd$var$parseMonthPatterns = {
    narrow: [
        /^(ژ|ج)/i,
        /^ف/i,
        /^م/i,
        /^(آ|ا)/i,
        /^م/i,
        /^(ژ|ج)/i,
        /^(ج|ژ)/i,
        /^(آ|ا)/i,
        /^س/i,
        /^ا/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^ژا/i,
        /^ف/i,
        /^ما/i,
        /^آپ/i,
        /^(می|مه)/i,
        /^(ژوئن|جون)/i,
        /^(ژوئی|جول)/i,
        /^(اوت|آگ)/i,
        /^س/i,
        /^(اوک|اک)/i,
        /^ن/i,
        /^د/i
    ]
};
const $b3bb1eeca91148fd$var$matchDayPatterns = {
    narrow: /^[شیدسچپج]/i,
    short: /^(ش|ج|1ش|2ش|3ش|4ش|5ش)/i,
    abbreviated: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i,
    wide: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i
};
const $b3bb1eeca91148fd$var$parseDayPatterns = {
    narrow: [
        /^ی/i,
        /^دو/i,
        /^س/i,
        /^چ/i,
        /^پ/i,
        /^ج/i,
        /^ش/i
    ],
    any: [
        /^(ی|1ش|یکشنبه)/i,
        /^(د|2ش|دوشنبه)/i,
        /^(س|3ش|سه‌شنبه)/i,
        /^(چ|4ش|چهارشنبه)/i,
        /^(پ|5ش|پنجشنبه)/i,
        /^(ج|جمعه)/i,
        /^(ش|شنبه)/i
    ]
};
const $b3bb1eeca91148fd$var$matchDayPeriodPatterns = {
    narrow: /^(ب|ق|ن|ظ|ص|ب.ظ.|ع|ش)/i,
    abbreviated: /^(ق.ظ.|ب.ظ.|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i,
    wide: /^(قبل‌ازظهر|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i
};
const $b3bb1eeca91148fd$var$parseDayPeriodPatterns = {
    any: {
        am: /^(ق|ق.ظ.|قبل‌ازظهر)/i,
        pm: /^(ب|ب.ظ.|بعدازظهر)/i,
        midnight: /^(‌نیمه‌شب|ن)/i,
        noon: /^(ظ|ظهر)/i,
        morning: /(ص|صبح)/i,
        afternoon: /(ب|ب.ظ.|بعدازظهر)/i,
        evening: /(ع|عصر)/i,
        night: /(ش|شب)/i
    }
};
const $b3bb1eeca91148fd$var$match = $b3bb1eeca91148fd$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $b3bb1eeca91148fd$var$matchOrdinalNumberPattern,
        parsePattern: $b3bb1eeca91148fd$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $b3bb1eeca91148fd$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b3bb1eeca91148fd$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $b3bb1eeca91148fd$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b3bb1eeca91148fd$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $b3bb1eeca91148fd$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b3bb1eeca91148fd$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $b3bb1eeca91148fd$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b3bb1eeca91148fd$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $b3bb1eeca91148fd$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b3bb1eeca91148fd$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("8XSC8", function(module, exports) {

$parcel$export(module.exports, "fi", function () { return $686e32a0902c9443$export$ed5179c818622fb; }, function (v) { return $686e32a0902c9443$export$ed5179c818622fb = v; });
var $686e32a0902c9443$export$ed5179c818622fb;
"use strict";
$686e32a0902c9443$export$ed5179c818622fb = void 0;

var $10daN = parcelRequire("10daN");

var $4fnQQ = parcelRequire("4fnQQ");

var $k0ezr = parcelRequire("k0ezr");

var $iD1n1 = parcelRequire("iD1n1");

var $devse = parcelRequire("devse");
/**
 * @category Locales
 * @summary Finnish locale.
 * @language Finnish
 * @iso-639-2 fin
 * @author Pyry-Samuli Lahti [@Pyppe](https://github.com/Pyppe)
 * @author Edo Rivai [@mikolajgrzyb](https://github.com/mikolajgrzyb)
 * @author Samu Juvonen [@sjuvonen](https://github.com/sjuvonen)
 */ const $686e32a0902c9443$var$fi = $686e32a0902c9443$export$ed5179c818622fb = {
    code: "fi",
    formatDistance: $10daN.formatDistance,
    formatLong: $4fnQQ.formatLong,
    formatRelative: $k0ezr.formatRelative,
    localize: $iD1n1.localize,
    match: $devse.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("10daN", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $0bb0027013c10a00$export$2c14ff85d6318973; }, function (v) { return $0bb0027013c10a00$export$2c14ff85d6318973 = v; });
var $0bb0027013c10a00$export$2c14ff85d6318973;
"use strict";
$0bb0027013c10a00$export$2c14ff85d6318973 = void 0;
function $0bb0027013c10a00$var$futureSeconds(text) {
    return text.replace(/sekuntia?/, "sekunnin");
}
function $0bb0027013c10a00$var$futureMinutes(text) {
    return text.replace(/minuuttia?/, "minuutin");
}
function $0bb0027013c10a00$var$futureHours(text) {
    return text.replace(/tuntia?/, "tunnin");
}
function $0bb0027013c10a00$var$futureDays(text) {
    return text.replace(/päivää?/, "p\xe4iv\xe4n");
}
function $0bb0027013c10a00$var$futureWeeks(text) {
    return text.replace(/(viikko|viikkoa)/, "viikon");
}
function $0bb0027013c10a00$var$futureMonths(text) {
    return text.replace(/(kuukausi|kuukautta)/, "kuukauden");
}
function $0bb0027013c10a00$var$futureYears(text) {
    return text.replace(/(vuosi|vuotta)/, "vuoden");
}
const $0bb0027013c10a00$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "alle sekunti",
        other: "alle {{count}} sekuntia",
        futureTense: $0bb0027013c10a00$var$futureSeconds
    },
    xSeconds: {
        one: "sekunti",
        other: "{{count}} sekuntia",
        futureTense: $0bb0027013c10a00$var$futureSeconds
    },
    halfAMinute: {
        one: "puoli minuuttia",
        other: "puoli minuuttia",
        futureTense: (_text)=>"puolen minuutin"
    },
    lessThanXMinutes: {
        one: "alle minuutti",
        other: "alle {{count}} minuuttia",
        futureTense: $0bb0027013c10a00$var$futureMinutes
    },
    xMinutes: {
        one: "minuutti",
        other: "{{count}} minuuttia",
        futureTense: $0bb0027013c10a00$var$futureMinutes
    },
    aboutXHours: {
        one: "noin tunti",
        other: "noin {{count}} tuntia",
        futureTense: $0bb0027013c10a00$var$futureHours
    },
    xHours: {
        one: "tunti",
        other: "{{count}} tuntia",
        futureTense: $0bb0027013c10a00$var$futureHours
    },
    xDays: {
        one: "p\xe4iv\xe4",
        other: "{{count}} p\xe4iv\xe4\xe4",
        futureTense: $0bb0027013c10a00$var$futureDays
    },
    aboutXWeeks: {
        one: "noin viikko",
        other: "noin {{count}} viikkoa",
        futureTense: $0bb0027013c10a00$var$futureWeeks
    },
    xWeeks: {
        one: "viikko",
        other: "{{count}} viikkoa",
        futureTense: $0bb0027013c10a00$var$futureWeeks
    },
    aboutXMonths: {
        one: "noin kuukausi",
        other: "noin {{count}} kuukautta",
        futureTense: $0bb0027013c10a00$var$futureMonths
    },
    xMonths: {
        one: "kuukausi",
        other: "{{count}} kuukautta",
        futureTense: $0bb0027013c10a00$var$futureMonths
    },
    aboutXYears: {
        one: "noin vuosi",
        other: "noin {{count}} vuotta",
        futureTense: $0bb0027013c10a00$var$futureYears
    },
    xYears: {
        one: "vuosi",
        other: "{{count}} vuotta",
        futureTense: $0bb0027013c10a00$var$futureYears
    },
    overXYears: {
        one: "yli vuosi",
        other: "yli {{count}} vuotta",
        futureTense: $0bb0027013c10a00$var$futureYears
    },
    almostXYears: {
        one: "l\xe4hes vuosi",
        other: "l\xe4hes {{count}} vuotta",
        futureTense: $0bb0027013c10a00$var$futureYears
    }
};
const $0bb0027013c10a00$var$formatDistance = (token, count, options)=>{
    const tokenValue = $0bb0027013c10a00$var$formatDistanceLocale[token];
    const result = count === 1 ? tokenValue.one : tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return tokenValue.futureTense(result) + " kuluttua";
        else return result + " sitten";
    }
    return result;
};
$0bb0027013c10a00$export$2c14ff85d6318973 = $0bb0027013c10a00$var$formatDistance;

});

parcelRegister("4fnQQ", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $317b10826df1cdd3$export$cbf60ecb96cbb82f; }, function (v) { return $317b10826df1cdd3$export$cbf60ecb96cbb82f = v; });
var $317b10826df1cdd3$export$cbf60ecb96cbb82f;
"use strict";
$317b10826df1cdd3$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $317b10826df1cdd3$var$dateFormats = {
    full: "eeee d. MMMM y",
    long: "d. MMMM y",
    medium: "d. MMM y",
    short: "d.M.y"
};
const $317b10826df1cdd3$var$timeFormats = {
    full: "HH.mm.ss zzzz",
    long: "HH.mm.ss z",
    medium: "HH.mm.ss",
    short: "HH.mm"
};
const $317b10826df1cdd3$var$dateTimeFormats = {
    full: "{{date}} 'klo' {{time}}",
    long: "{{date}} 'klo' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $317b10826df1cdd3$var$formatLong = $317b10826df1cdd3$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $317b10826df1cdd3$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $317b10826df1cdd3$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $317b10826df1cdd3$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("k0ezr", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $e8ff1c24dd513a00$export$8fbbfd65594f46a0; }, function (v) { return $e8ff1c24dd513a00$export$8fbbfd65594f46a0 = v; });
var $e8ff1c24dd513a00$export$8fbbfd65594f46a0;
"use strict";
$e8ff1c24dd513a00$export$8fbbfd65594f46a0 = void 0;
const $e8ff1c24dd513a00$var$formatRelativeLocale = {
    lastWeek: "'viime' eeee 'klo' p",
    yesterday: "'eilen klo' p",
    today: "'t\xe4n\xe4\xe4n klo' p",
    tomorrow: "'huomenna klo' p",
    nextWeek: "'ensi' eeee 'klo' p",
    other: "P"
};
const $e8ff1c24dd513a00$var$formatRelative = (token, _date, _baseDate, _options)=>$e8ff1c24dd513a00$var$formatRelativeLocale[token];
$e8ff1c24dd513a00$export$8fbbfd65594f46a0 = $e8ff1c24dd513a00$var$formatRelative;

});

parcelRegister("iD1n1", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $d8fcee9e348c559b$export$b3bd0bc58e36cd63; }, function (v) { return $d8fcee9e348c559b$export$b3bd0bc58e36cd63 = v; });
var $d8fcee9e348c559b$export$b3bd0bc58e36cd63;
"use strict";
$d8fcee9e348c559b$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $d8fcee9e348c559b$var$eraValues = {
    narrow: [
        "eaa.",
        "jaa."
    ],
    abbreviated: [
        "eaa.",
        "jaa."
    ],
    wide: [
        "ennen ajanlaskun alkua",
        "j\xe4lkeen ajanlaskun alun"
    ]
};
const $d8fcee9e348c559b$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. kvartaali",
        "2. kvartaali",
        "3. kvartaali",
        "4. kvartaali"
    ]
};
const $d8fcee9e348c559b$var$monthValues = {
    narrow: [
        "T",
        "H",
        "M",
        "H",
        "T",
        "K",
        "H",
        "E",
        "S",
        "L",
        "M",
        "J"
    ],
    abbreviated: [
        "tammi",
        "helmi",
        "maalis",
        "huhti",
        "touko",
        "kes\xe4",
        "hein\xe4",
        "elo",
        "syys",
        "loka",
        "marras",
        "joulu"
    ],
    wide: [
        "tammikuu",
        "helmikuu",
        "maaliskuu",
        "huhtikuu",
        "toukokuu",
        "kes\xe4kuu",
        "hein\xe4kuu",
        "elokuu",
        "syyskuu",
        "lokakuu",
        "marraskuu",
        "joulukuu"
    ]
};
const $d8fcee9e348c559b$var$formattingMonthValues = {
    narrow: $d8fcee9e348c559b$var$monthValues.narrow,
    abbreviated: $d8fcee9e348c559b$var$monthValues.abbreviated,
    wide: [
        "tammikuuta",
        "helmikuuta",
        "maaliskuuta",
        "huhtikuuta",
        "toukokuuta",
        "kes\xe4kuuta",
        "hein\xe4kuuta",
        "elokuuta",
        "syyskuuta",
        "lokakuuta",
        "marraskuuta",
        "joulukuuta"
    ]
};
const $d8fcee9e348c559b$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "K",
        "T",
        "P",
        "L"
    ],
    short: [
        "su",
        "ma",
        "ti",
        "ke",
        "to",
        "pe",
        "la"
    ],
    abbreviated: [
        "sunn.",
        "maan.",
        "tiis.",
        "kesk.",
        "torst.",
        "perj.",
        "la"
    ],
    wide: [
        "sunnuntai",
        "maanantai",
        "tiistai",
        "keskiviikko",
        "torstai",
        "perjantai",
        "lauantai"
    ]
};
const $d8fcee9e348c559b$var$formattingDayValues = {
    narrow: $d8fcee9e348c559b$var$dayValues.narrow,
    short: $d8fcee9e348c559b$var$dayValues.short,
    abbreviated: $d8fcee9e348c559b$var$dayValues.abbreviated,
    wide: [
        "sunnuntaina",
        "maanantaina",
        "tiistaina",
        "keskiviikkona",
        "torstaina",
        "perjantaina",
        "lauantaina"
    ]
};
const $d8fcee9e348c559b$var$dayPeriodValues = {
    narrow: {
        am: "ap",
        pm: "ip",
        midnight: "keskiy\xf6",
        noon: "keskip\xe4iv\xe4",
        morning: "ap",
        afternoon: "ip",
        evening: "illalla",
        night: "y\xf6ll\xe4"
    },
    abbreviated: {
        am: "ap",
        pm: "ip",
        midnight: "keskiy\xf6",
        noon: "keskip\xe4iv\xe4",
        morning: "ap",
        afternoon: "ip",
        evening: "illalla",
        night: "y\xf6ll\xe4"
    },
    wide: {
        am: "ap",
        pm: "ip",
        midnight: "keskiy\xf6ll\xe4",
        noon: "keskip\xe4iv\xe4ll\xe4",
        morning: "aamup\xe4iv\xe4ll\xe4",
        afternoon: "iltap\xe4iv\xe4ll\xe4",
        evening: "illalla",
        night: "y\xf6ll\xe4"
    }
};
const $d8fcee9e348c559b$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $d8fcee9e348c559b$var$localize = $d8fcee9e348c559b$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $d8fcee9e348c559b$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $d8fcee9e348c559b$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $d8fcee9e348c559b$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $d8fcee9e348c559b$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $d8fcee9e348c559b$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $d8fcee9e348c559b$var$dayValues,
        defaultWidth: "wide",
        formattingValues: $d8fcee9e348c559b$var$formattingDayValues,
        defaultFormattingWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $d8fcee9e348c559b$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};

});

parcelRegister("devse", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $9a24fb5c5c7b2640$export$4659b591c19bdf3d; }, function (v) { return $9a24fb5c5c7b2640$export$4659b591c19bdf3d = v; });
var $9a24fb5c5c7b2640$export$4659b591c19bdf3d;
"use strict";
$9a24fb5c5c7b2640$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $9a24fb5c5c7b2640$var$matchOrdinalNumberPattern = /^(\d+)(\.)/i;
const $9a24fb5c5c7b2640$var$parseOrdinalNumberPattern = /\d+/i;
const $9a24fb5c5c7b2640$var$matchEraPatterns = {
    narrow: /^(e|j)/i,
    abbreviated: /^(eaa.|jaa.)/i,
    wide: /^(ennen ajanlaskun alkua|jälkeen ajanlaskun alun)/i
};
const $9a24fb5c5c7b2640$var$parseEraPatterns = {
    any: [
        /^e/i,
        /^j/i
    ]
};
const $9a24fb5c5c7b2640$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]\.? kvartaali/i
};
const $9a24fb5c5c7b2640$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $9a24fb5c5c7b2640$var$matchMonthPatterns = {
    narrow: /^[thmkeslj]/i,
    abbreviated: /^(tammi|helmi|maalis|huhti|touko|kesä|heinä|elo|syys|loka|marras|joulu)/i,
    wide: /^(tammikuu|helmikuu|maaliskuu|huhtikuu|toukokuu|kesäkuu|heinäkuu|elokuu|syyskuu|lokakuu|marraskuu|joulukuu)(ta)?/i
};
const $9a24fb5c5c7b2640$var$parseMonthPatterns = {
    narrow: [
        /^t/i,
        /^h/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^k/i,
        /^h/i,
        /^e/i,
        /^s/i,
        /^l/i,
        /^m/i,
        /^j/i
    ],
    any: [
        /^ta/i,
        /^hel/i,
        /^maa/i,
        /^hu/i,
        /^to/i,
        /^k/i,
        /^hei/i,
        /^e/i,
        /^s/i,
        /^l/i,
        /^mar/i,
        /^j/i
    ]
};
const $9a24fb5c5c7b2640$var$matchDayPatterns = {
    narrow: /^[smtkpl]/i,
    short: /^(su|ma|ti|ke|to|pe|la)/i,
    abbreviated: /^(sunn.|maan.|tiis.|kesk.|torst.|perj.|la)/i,
    wide: /^(sunnuntai|maanantai|tiistai|keskiviikko|torstai|perjantai|lauantai)(na)?/i
};
const $9a24fb5c5c7b2640$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^k/i,
        /^t/i,
        /^p/i,
        /^l/i
    ],
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^k/i,
        /^to/i,
        /^p/i,
        /^l/i
    ]
};
const $9a24fb5c5c7b2640$var$matchDayPeriodPatterns = {
    narrow: /^(ap|ip|keskiyö|keskipäivä|aamupäivällä|iltapäivällä|illalla|yöllä)/i,
    any: /^(ap|ip|keskiyöllä|keskipäivällä|aamupäivällä|iltapäivällä|illalla|yöllä)/i
};
const $9a24fb5c5c7b2640$var$parseDayPeriodPatterns = {
    any: {
        am: /^ap/i,
        pm: /^ip/i,
        midnight: /^keskiyö/i,
        noon: /^keskipäivä/i,
        morning: /aamupäivällä/i,
        afternoon: /iltapäivällä/i,
        evening: /illalla/i,
        night: /yöllä/i
    }
};
const $9a24fb5c5c7b2640$var$match = $9a24fb5c5c7b2640$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $9a24fb5c5c7b2640$var$matchOrdinalNumberPattern,
        parsePattern: $9a24fb5c5c7b2640$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $9a24fb5c5c7b2640$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9a24fb5c5c7b2640$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $9a24fb5c5c7b2640$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9a24fb5c5c7b2640$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $9a24fb5c5c7b2640$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9a24fb5c5c7b2640$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $9a24fb5c5c7b2640$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9a24fb5c5c7b2640$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $9a24fb5c5c7b2640$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $9a24fb5c5c7b2640$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("fdZui", function(module, exports) {

$parcel$export(module.exports, "fr", function () { return $b157c41a07d2d535$export$acb2a88f7d552ebf; }, function (v) { return $b157c41a07d2d535$export$acb2a88f7d552ebf = v; });
var $b157c41a07d2d535$export$acb2a88f7d552ebf;
"use strict";
$b157c41a07d2d535$export$acb2a88f7d552ebf = void 0;

var $4msrG = parcelRequire("4msrG");

var $eto4Q = parcelRequire("eto4Q");

var $tB9VV = parcelRequire("tB9VV");

var $8CQWz = parcelRequire("8CQWz");

var $hd7t1 = parcelRequire("hd7t1");
/**
 * @category Locales
 * @summary French locale.
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau](https://github.com/izeau)
 * @author François B [@fbonzon](https://github.com/fbonzon)
 */ const $b157c41a07d2d535$var$fr = $b157c41a07d2d535$export$acb2a88f7d552ebf = {
    code: "fr",
    formatDistance: $4msrG.formatDistance,
    formatLong: $eto4Q.formatLong,
    formatRelative: $tB9VV.formatRelative,
    localize: $8CQWz.localize,
    match: $hd7t1.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("4msrG", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $32cf482e45577d79$export$2c14ff85d6318973; }, function (v) { return $32cf482e45577d79$export$2c14ff85d6318973 = v; });
var $32cf482e45577d79$export$2c14ff85d6318973;
"use strict";
$32cf482e45577d79$export$2c14ff85d6318973 = void 0;
const $32cf482e45577d79$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "moins d\u2019une seconde",
        other: "moins de {{count}} secondes"
    },
    xSeconds: {
        one: "1 seconde",
        other: "{{count}} secondes"
    },
    halfAMinute: "30 secondes",
    lessThanXMinutes: {
        one: "moins d\u2019une minute",
        other: "moins de {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "environ 1 heure",
        other: "environ {{count}} heures"
    },
    xHours: {
        one: "1 heure",
        other: "{{count}} heures"
    },
    xDays: {
        one: "1 jour",
        other: "{{count}} jours"
    },
    aboutXWeeks: {
        one: "environ 1 semaine",
        other: "environ {{count}} semaines"
    },
    xWeeks: {
        one: "1 semaine",
        other: "{{count}} semaines"
    },
    aboutXMonths: {
        one: "environ 1 mois",
        other: "environ {{count}} mois"
    },
    xMonths: {
        one: "1 mois",
        other: "{{count}} mois"
    },
    aboutXYears: {
        one: "environ 1 an",
        other: "environ {{count}} ans"
    },
    xYears: {
        one: "1 an",
        other: "{{count}} ans"
    },
    overXYears: {
        one: "plus d\u2019un an",
        other: "plus de {{count}} ans"
    },
    almostXYears: {
        one: "presqu\u2019un an",
        other: "presque {{count}} ans"
    }
};
const $32cf482e45577d79$var$formatDistance = (token, count, options)=>{
    let result;
    const form = $32cf482e45577d79$var$formatDistanceLocale[token];
    if (typeof form === "string") result = form;
    else if (count === 1) result = form.one;
    else result = form.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "dans " + result;
        else return "il y a " + result;
    }
    return result;
};
$32cf482e45577d79$export$2c14ff85d6318973 = $32cf482e45577d79$var$formatDistance;

});

parcelRegister("eto4Q", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $a896735b882dc634$export$cbf60ecb96cbb82f; }, function (v) { return $a896735b882dc634$export$cbf60ecb96cbb82f = v; });
var $a896735b882dc634$export$cbf60ecb96cbb82f;
"use strict";
$a896735b882dc634$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $a896735b882dc634$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
const $a896735b882dc634$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $a896735b882dc634$var$dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $a896735b882dc634$var$formatLong = $a896735b882dc634$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $a896735b882dc634$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $a896735b882dc634$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $a896735b882dc634$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("tB9VV", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $058f88980885ea6d$export$8fbbfd65594f46a0; }, function (v) { return $058f88980885ea6d$export$8fbbfd65594f46a0 = v; });
var $058f88980885ea6d$export$8fbbfd65594f46a0;
"use strict";
$058f88980885ea6d$export$8fbbfd65594f46a0 = void 0;
const $058f88980885ea6d$var$formatRelativeLocale = {
    lastWeek: "eeee 'dernier \xe0' p",
    yesterday: "'hier \xe0' p",
    today: "'aujourd\u2019hui \xe0' p",
    tomorrow: "'demain \xe0' p'",
    nextWeek: "eeee 'prochain \xe0' p",
    other: "P"
};
const $058f88980885ea6d$var$formatRelative = (token, _date, _baseDate, _options)=>$058f88980885ea6d$var$formatRelativeLocale[token];
$058f88980885ea6d$export$8fbbfd65594f46a0 = $058f88980885ea6d$var$formatRelative;

});

parcelRegister("8CQWz", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $647af0df3d9cca13$export$b3bd0bc58e36cd63; }, function (v) { return $647af0df3d9cca13$export$b3bd0bc58e36cd63 = v; });
var $647af0df3d9cca13$export$b3bd0bc58e36cd63;
"use strict";
$647af0df3d9cca13$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $647af0df3d9cca13$var$eraValues = {
    narrow: [
        "av. J.-C",
        "ap. J.-C"
    ],
    abbreviated: [
        "av. J.-C",
        "ap. J.-C"
    ],
    wide: [
        "avant J\xe9sus-Christ",
        "apr\xe8s J\xe9sus-Christ"
    ]
};
const $647af0df3d9cca13$var$quarterValues = {
    narrow: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    abbreviated: [
        "1er trim.",
        "2\xe8me trim.",
        "3\xe8me trim.",
        "4\xe8me trim."
    ],
    wide: [
        "1er trimestre",
        "2\xe8me trimestre",
        "3\xe8me trimestre",
        "4\xe8me trimestre"
    ]
};
const $647af0df3d9cca13$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "janv.",
        "f\xe9vr.",
        "mars",
        "avr.",
        "mai",
        "juin",
        "juil.",
        "ao\xfbt",
        "sept.",
        "oct.",
        "nov.",
        "d\xe9c."
    ],
    wide: [
        "janvier",
        "f\xe9vrier",
        "mars",
        "avril",
        "mai",
        "juin",
        "juillet",
        "ao\xfbt",
        "septembre",
        "octobre",
        "novembre",
        "d\xe9cembre"
    ]
};
const $647af0df3d9cca13$var$dayValues = {
    narrow: [
        "D",
        "L",
        "M",
        "M",
        "J",
        "V",
        "S"
    ],
    short: [
        "di",
        "lu",
        "ma",
        "me",
        "je",
        "ve",
        "sa"
    ],
    abbreviated: [
        "dim.",
        "lun.",
        "mar.",
        "mer.",
        "jeu.",
        "ven.",
        "sam."
    ],
    wide: [
        "dimanche",
        "lundi",
        "mardi",
        "mercredi",
        "jeudi",
        "vendredi",
        "samedi"
    ]
};
const $647af0df3d9cca13$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "mat.",
        afternoon: "ap.m.",
        evening: "soir",
        night: "mat."
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "matin",
        afternoon: "apr\xe8s-midi",
        evening: "soir",
        night: "matin"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "du matin",
        afternoon: "de l\u2019apr\xe8s-midi",
        evening: "du soir",
        night: "du matin"
    }
};
const $647af0df3d9cca13$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    const unit = options?.unit;
    if (number === 0) return "0";
    const feminineUnits = [
        "year",
        "week",
        "hour",
        "minute",
        "second"
    ];
    let suffix;
    if (number === 1) suffix = unit && feminineUnits.includes(unit) ? "\xe8re" : "er";
    else suffix = "\xe8me";
    return number + suffix;
};
const $647af0df3d9cca13$var$LONG_MONTHS_TOKENS = [
    "MMM",
    "MMMM"
];
const $647af0df3d9cca13$var$localize = $647af0df3d9cca13$export$b3bd0bc58e36cd63 = {
    preprocessor: (date, parts)=>{
        // Replaces the `do` tokens with `d` when used with long month tokens and the day of the month is greater than one.
        // Use case "do MMMM" => 1er août, 29 août
        // see https://github.com/date-fns/date-fns/issues/1391
        if (date.getDate() === 1) return parts;
        const hasLongMonthToken = parts.some((part)=>part.isToken && $647af0df3d9cca13$var$LONG_MONTHS_TOKENS.includes(part.value));
        if (!hasLongMonthToken) return parts;
        return parts.map((part)=>part.isToken && part.value === "do" ? {
                isToken: true,
                value: "d"
            } : part);
    },
    ordinalNumber: $647af0df3d9cca13$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $647af0df3d9cca13$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $647af0df3d9cca13$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $647af0df3d9cca13$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $647af0df3d9cca13$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $647af0df3d9cca13$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};

});

parcelRegister("hd7t1", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $c879715e98746ff4$export$4659b591c19bdf3d; }, function (v) { return $c879715e98746ff4$export$4659b591c19bdf3d = v; });
var $c879715e98746ff4$export$4659b591c19bdf3d;
"use strict";
$c879715e98746ff4$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $c879715e98746ff4$var$matchOrdinalNumberPattern = /^(\d+)(ième|ère|ème|er|e)?/i;
const $c879715e98746ff4$var$parseOrdinalNumberPattern = /\d+/i;
const $c879715e98746ff4$var$matchEraPatterns = {
    narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
    abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
};
const $c879715e98746ff4$var$parseEraPatterns = {
    any: [
        /^av/i,
        /^ap/i
    ]
};
const $c879715e98746ff4$var$matchQuarterPatterns = {
    narrow: /^T?[1234]/i,
    abbreviated: /^[1234](er|ème|e)? trim\.?/i,
    wide: /^[1234](er|ème|e)? trimestre/i
};
const $c879715e98746ff4$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $c879715e98746ff4$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
    wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
};
const $c879715e98746ff4$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^av/i,
        /^ma/i,
        /^juin/i,
        /^juil/i,
        /^ao/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $c879715e98746ff4$var$matchDayPatterns = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|lu|ma|me|je|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
    wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
};
const $c879715e98746ff4$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^di/i,
        /^lu/i,
        /^ma/i,
        /^me/i,
        /^je/i,
        /^ve/i,
        /^sa/i
    ]
};
const $c879715e98746ff4$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
    any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
};
const $c879715e98746ff4$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /soir/i,
        night: /nuit/i
    }
};
const $c879715e98746ff4$var$match = $c879715e98746ff4$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $c879715e98746ff4$var$matchOrdinalNumberPattern,
        parsePattern: $c879715e98746ff4$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $c879715e98746ff4$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c879715e98746ff4$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $c879715e98746ff4$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c879715e98746ff4$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $c879715e98746ff4$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c879715e98746ff4$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $c879715e98746ff4$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c879715e98746ff4$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $c879715e98746ff4$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $c879715e98746ff4$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("aQH0S", function(module, exports) {

$parcel$export(module.exports, "frCA", function () { return $7e6020345c1cdf49$export$ba0a7939fd366aec; }, function (v) { return $7e6020345c1cdf49$export$ba0a7939fd366aec = v; });
var $7e6020345c1cdf49$export$ba0a7939fd366aec;
"use strict";
$7e6020345c1cdf49$export$ba0a7939fd366aec = void 0;

var $4msrG = parcelRequire("4msrG");

var $tB9VV = parcelRequire("tB9VV");

var $8CQWz = parcelRequire("8CQWz");

var $hd7t1 = parcelRequire("hd7t1");

var $k07av = parcelRequire("k07av");
// Unique for fr-CA
/**
 * @category Locales
 * @summary French locale (Canada).
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau](https://github.com/izeau)
 * @author François B [@fbonzon](https://github.com/fbonzon)
 * @author Gabriele Petrioli [@gpetrioli](https://github.com/gpetrioli)
 */ const $7e6020345c1cdf49$var$frCA = $7e6020345c1cdf49$export$ba0a7939fd366aec = {
    code: "fr-CA",
    formatDistance: $4msrG.formatDistance,
    formatLong: $k07av.formatLong,
    formatRelative: $tB9VV.formatRelative,
    localize: $8CQWz.localize,
    match: $hd7t1.match,
    // Unique for fr-CA
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("k07av", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $e8f95e4064e0cf02$export$cbf60ecb96cbb82f; }, function (v) { return $e8f95e4064e0cf02$export$cbf60ecb96cbb82f = v; });
var $e8f95e4064e0cf02$export$cbf60ecb96cbb82f;
"use strict";
$e8f95e4064e0cf02$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $e8f95e4064e0cf02$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "yy-MM-dd"
};
const $e8f95e4064e0cf02$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $e8f95e4064e0cf02$var$dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $e8f95e4064e0cf02$var$formatLong = $e8f95e4064e0cf02$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $e8f95e4064e0cf02$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $e8f95e4064e0cf02$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $e8f95e4064e0cf02$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});


parcelRegister("4smXQ", function(module, exports) {

$parcel$export(module.exports, "frCH", function () { return $33eb972b4ecdfa64$export$5ca9c7dd526fb524; }, function (v) { return $33eb972b4ecdfa64$export$5ca9c7dd526fb524 = v; });
var $33eb972b4ecdfa64$export$5ca9c7dd526fb524;
"use strict";
$33eb972b4ecdfa64$export$5ca9c7dd526fb524 = void 0;

var $4msrG = parcelRequire("4msrG");

var $8CQWz = parcelRequire("8CQWz");

var $hd7t1 = parcelRequire("hd7t1");

var $blbC4 = parcelRequire("blbC4");

var $erY0y = parcelRequire("erY0y");
// Unique for fr-CH
/**
 * @category Locales
 * @summary French locale (Switzerland).
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau](https://github.com/izeau)
 * @author François B [@fbonzon](https://github.com/fbonzon)
 * @author Van Vuong Ngo [@vanvuongngo](https://github.com/vanvuongngo)
 * @author Alex Hoeing [@dcbn](https://github.com/dcbn)
 */ const $33eb972b4ecdfa64$var$frCH = $33eb972b4ecdfa64$export$5ca9c7dd526fb524 = {
    code: "fr-CH",
    formatDistance: $4msrG.formatDistance,
    formatLong: $blbC4.formatLong,
    formatRelative: $erY0y.formatRelative,
    localize: $8CQWz.localize,
    match: $hd7t1.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("blbC4", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $841aa9fd87121b31$export$cbf60ecb96cbb82f; }, function (v) { return $841aa9fd87121b31$export$cbf60ecb96cbb82f = v; });
var $841aa9fd87121b31$export$cbf60ecb96cbb82f;
"use strict";
$841aa9fd87121b31$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $841aa9fd87121b31$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd.MM.y"
};
const $841aa9fd87121b31$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $841aa9fd87121b31$var$dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $841aa9fd87121b31$var$formatLong = $841aa9fd87121b31$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $841aa9fd87121b31$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $841aa9fd87121b31$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $841aa9fd87121b31$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("erY0y", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $a85222a700481acd$export$8fbbfd65594f46a0; }, function (v) { return $a85222a700481acd$export$8fbbfd65594f46a0 = v; });
var $a85222a700481acd$export$8fbbfd65594f46a0;
"use strict";
$a85222a700481acd$export$8fbbfd65594f46a0 = void 0;
const $a85222a700481acd$var$formatRelativeLocale = {
    lastWeek: "eeee 'la semaine derni\xe8re \xe0' p",
    yesterday: "'hier \xe0' p",
    today: "'aujourd\u2019hui \xe0' p",
    tomorrow: "'demain \xe0' p'",
    nextWeek: "eeee 'la semaine prochaine \xe0' p",
    other: "P"
};
const $a85222a700481acd$var$formatRelative = (token, _date, _baseDate, _options)=>$a85222a700481acd$var$formatRelativeLocale[token];
$a85222a700481acd$export$8fbbfd65594f46a0 = $a85222a700481acd$var$formatRelative;

});


parcelRegister("47ObL", function(module, exports) {

$parcel$export(module.exports, "fy", function () { return $300ebf54aa7fe8bb$export$c0dcd1f2238f086d; }, function (v) { return $300ebf54aa7fe8bb$export$c0dcd1f2238f086d = v; });
var $300ebf54aa7fe8bb$export$c0dcd1f2238f086d;
"use strict";
$300ebf54aa7fe8bb$export$c0dcd1f2238f086d = void 0;

var $78K3W = parcelRequire("78K3W");

var $5WXIN = parcelRequire("5WXIN");

var $hBrB5 = parcelRequire("hBrB5");

var $atyKZ = parcelRequire("atyKZ");

var $cRxTr = parcelRequire("cRxTr");
/**
 * @category Locales
 * @summary Western Frisian locale (Netherlands).
 * @language West Frisian
 * @iso-639-2 fry
 * @author Damon Asberg [@damon02](https://github.com/damon02)
 */ const $300ebf54aa7fe8bb$var$fy = $300ebf54aa7fe8bb$export$c0dcd1f2238f086d = {
    code: "fy",
    formatDistance: $78K3W.formatDistance,
    formatLong: $5WXIN.formatLong,
    formatRelative: $hBrB5.formatRelative,
    localize: $atyKZ.localize,
    match: $cRxTr.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("78K3W", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $532d02d0020239bc$export$2c14ff85d6318973; }, function (v) { return $532d02d0020239bc$export$2c14ff85d6318973 = v; });
var $532d02d0020239bc$export$2c14ff85d6318973;
"use strict";
$532d02d0020239bc$export$2c14ff85d6318973 = void 0;
const $532d02d0020239bc$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minder as 1 sekonde",
        other: "minder as {{count}} sekonden"
    },
    xSeconds: {
        one: "1 sekonde",
        other: "{{count}} sekonden"
    },
    halfAMinute: "oardel min\xfat",
    lessThanXMinutes: {
        one: "minder as 1 min\xfat",
        other: "minder as {{count}} minuten"
    },
    xMinutes: {
        one: "1 min\xfat",
        other: "{{count}} minuten"
    },
    aboutXHours: {
        one: "sawat 1 oere",
        other: "sawat {{count}} oere"
    },
    xHours: {
        one: "1 oere",
        other: "{{count}} oere"
    },
    xDays: {
        one: "1 dei",
        other: "{{count}} dagen"
    },
    aboutXWeeks: {
        one: "sawat 1 wike",
        other: "sawat {{count}} wiken"
    },
    xWeeks: {
        one: "1 wike",
        other: "{{count}} wiken"
    },
    aboutXMonths: {
        one: "sawat 1 moanne",
        other: "sawat {{count}} moannen"
    },
    xMonths: {
        one: "1 moanne",
        other: "{{count}} moannen"
    },
    aboutXYears: {
        one: "sawat 1 jier",
        other: "sawat {{count}} jier"
    },
    xYears: {
        one: "1 jier",
        other: "{{count}} jier"
    },
    overXYears: {
        one: "mear as 1 jier",
        other: "mear as {{count}}s jier"
    },
    almostXYears: {
        one: "hast 1 jier",
        other: "hast {{count}} jier"
    }
};
const $532d02d0020239bc$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $532d02d0020239bc$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "oer " + result;
        else return result + " lyn";
    }
    return result;
};
$532d02d0020239bc$export$2c14ff85d6318973 = $532d02d0020239bc$var$formatDistance;

});

parcelRegister("5WXIN", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $4550b1f68404a8cd$export$cbf60ecb96cbb82f; }, function (v) { return $4550b1f68404a8cd$export$cbf60ecb96cbb82f = v; });
var $4550b1f68404a8cd$export$cbf60ecb96cbb82f;
"use strict";
$4550b1f68404a8cd$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $4550b1f68404a8cd$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd-MM-y"
};
const $4550b1f68404a8cd$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $4550b1f68404a8cd$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $4550b1f68404a8cd$var$formatLong = $4550b1f68404a8cd$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $4550b1f68404a8cd$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $4550b1f68404a8cd$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $4550b1f68404a8cd$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("hBrB5", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $cd0b4c9a344d1f02$export$8fbbfd65594f46a0; }, function (v) { return $cd0b4c9a344d1f02$export$8fbbfd65594f46a0 = v; });
var $cd0b4c9a344d1f02$export$8fbbfd65594f46a0;
"use strict";
$cd0b4c9a344d1f02$export$8fbbfd65594f46a0 = void 0;
const $cd0b4c9a344d1f02$var$formatRelativeLocale = {
    lastWeek: "'\xf4fr\xfbne' eeee 'om' p",
    yesterday: "'juster om' p",
    today: "'hjoed om' p",
    tomorrow: "'moarn om' p",
    nextWeek: "eeee 'om' p",
    other: "P"
};
const $cd0b4c9a344d1f02$var$formatRelative = (token, _date, _baseDate, _options)=>$cd0b4c9a344d1f02$var$formatRelativeLocale[token];
$cd0b4c9a344d1f02$export$8fbbfd65594f46a0 = $cd0b4c9a344d1f02$var$formatRelative;

});

parcelRegister("atyKZ", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $7a0792d3a833316d$export$b3bd0bc58e36cd63; }, function (v) { return $7a0792d3a833316d$export$b3bd0bc58e36cd63 = v; });
var $7a0792d3a833316d$export$b3bd0bc58e36cd63;
"use strict";
$7a0792d3a833316d$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $7a0792d3a833316d$var$eraValues = {
    narrow: [
        "f.K.",
        "n.K."
    ],
    abbreviated: [
        "f.Kr.",
        "n.Kr."
    ],
    wide: [
        "foar Kristus",
        "nei Kristus"
    ]
};
const $7a0792d3a833316d$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1e fearnsjier",
        "2e fearnsjier",
        "3e fearnsjier",
        "4e fearnsjier"
    ]
};
const $7a0792d3a833316d$var$monthValues = {
    narrow: [
        "j",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mrt.",
        "apr.",
        "mai.",
        "jun.",
        "jul.",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "des."
    ],
    wide: [
        "jannewaris",
        "febrewaris",
        "maart",
        "april",
        "maaie",
        "juny",
        "july",
        "augustus",
        "septimber",
        "oktober",
        "novimber",
        "desimber"
    ]
};
const $7a0792d3a833316d$var$dayValues = {
    narrow: [
        "s",
        "m",
        "t",
        "w",
        "t",
        "f",
        "s"
    ],
    short: [
        "si",
        "mo",
        "ti",
        "wo",
        "to",
        "fr",
        "so"
    ],
    abbreviated: [
        "snein",
        "moa",
        "tii",
        "woa",
        "ton",
        "fre",
        "sneon"
    ],
    wide: [
        "snein",
        "moandei",
        "tiisdei",
        "woansdei",
        "tongersdei",
        "freed",
        "sneon"
    ]
};
const $7a0792d3a833316d$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "middei",
        morning: "moarns",
        afternoon: "middeis",
        evening: "j\xfbns",
        night: "nachts"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "middei",
        morning: "moarns",
        afternoon: "middeis",
        evening: "j\xfbns",
        night: "nachts"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "middei",
        morning: "moarns",
        afternoon: "middeis",
        evening: "j\xfbns",
        night: "nachts"
    }
};
const $7a0792d3a833316d$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + "e";
};
const $7a0792d3a833316d$var$localize = $7a0792d3a833316d$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $7a0792d3a833316d$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $7a0792d3a833316d$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $7a0792d3a833316d$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $7a0792d3a833316d$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $7a0792d3a833316d$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $7a0792d3a833316d$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};

});

parcelRegister("cRxTr", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $95d4b9c9091b4c1b$export$4659b591c19bdf3d; }, function (v) { return $95d4b9c9091b4c1b$export$4659b591c19bdf3d = v; });
var $95d4b9c9091b4c1b$export$4659b591c19bdf3d;
"use strict";
$95d4b9c9091b4c1b$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $95d4b9c9091b4c1b$var$matchOrdinalNumberPattern = /^(\d+)e?/i;
const $95d4b9c9091b4c1b$var$parseOrdinalNumberPattern = /\d+/i;
const $95d4b9c9091b4c1b$var$matchEraPatterns = {
    narrow: /^([fn]\.? ?K\.?)/,
    abbreviated: /^([fn]\. ?Kr\.?)/,
    wide: /^((foar|nei) Kristus)/
};
const $95d4b9c9091b4c1b$var$parseEraPatterns = {
    any: [
        /^f/,
        /^n/
    ]
};
const $95d4b9c9091b4c1b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e fearnsjier/i
};
const $95d4b9c9091b4c1b$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $95d4b9c9091b4c1b$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mai.|jun.|jul.|aug.|sep.|okt.|nov.|des.)/i,
    wide: /^(jannewaris|febrewaris|maart|april|maaie|juny|july|augustus|septimber|oktober|novimber|desimber)/i
};
const $95d4b9c9091b4c1b$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^des/i
    ]
};
const $95d4b9c9091b4c1b$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(si|mo|ti|wo|to|fr|so)/i,
    abbreviated: /^(snein|moa|tii|woa|ton|fre|sneon)/i,
    wide: /^(snein|moandei|tiisdei|woansdei|tongersdei|freed|sneon)/i
};
const $95d4b9c9091b4c1b$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^sn/i,
        /^mo/i,
        /^ti/i,
        /^wo/i,
        /^to/i,
        /^fr/i,
        /^sn/i
    ]
};
const $95d4b9c9091b4c1b$var$matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|middeis|moarns|middei|jûns|nachts)/i
};
const $95d4b9c9091b4c1b$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^middei/i,
        morning: /moarns/i,
        afternoon: /^middeis/i,
        evening: /jûns/i,
        night: /nachts/i
    }
};
const $95d4b9c9091b4c1b$var$match = $95d4b9c9091b4c1b$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $95d4b9c9091b4c1b$var$matchOrdinalNumberPattern,
        parsePattern: $95d4b9c9091b4c1b$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $95d4b9c9091b4c1b$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $95d4b9c9091b4c1b$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $95d4b9c9091b4c1b$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $95d4b9c9091b4c1b$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $95d4b9c9091b4c1b$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $95d4b9c9091b4c1b$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $95d4b9c9091b4c1b$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $95d4b9c9091b4c1b$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $95d4b9c9091b4c1b$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $95d4b9c9091b4c1b$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("fKqaE", function(module, exports) {

$parcel$export(module.exports, "gd", function () { return $b76f73e4610491af$export$64ad7087a50b462f; }, function (v) { return $b76f73e4610491af$export$64ad7087a50b462f = v; });
var $b76f73e4610491af$export$64ad7087a50b462f;
"use strict";
$b76f73e4610491af$export$64ad7087a50b462f = void 0;

var $kIqqN = parcelRequire("kIqqN");

var $a1QWK = parcelRequire("a1QWK");

var $ld9Yq = parcelRequire("ld9Yq");

var $cXJ4h = parcelRequire("cXJ4h");

var $53ELD = parcelRequire("53ELD");
/**
 * @category Locales
 * @summary Scottish Gaelic.
 * @language Scottish Gaelic
 * @iso-639-2 gla
 * @author Lee Driscoll [@leedriscoll](https://github.com/leedriscoll)
 */ const $b76f73e4610491af$var$gd = $b76f73e4610491af$export$64ad7087a50b462f = {
    code: "gd",
    formatDistance: $kIqqN.formatDistance,
    formatLong: $a1QWK.formatLong,
    formatRelative: $ld9Yq.formatRelative,
    localize: $cXJ4h.localize,
    match: $53ELD.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("kIqqN", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $f14c6b64cf0409b5$export$2c14ff85d6318973; }, function (v) { return $f14c6b64cf0409b5$export$2c14ff85d6318973 = v; });
var $f14c6b64cf0409b5$export$2c14ff85d6318973;
"use strict";
$f14c6b64cf0409b5$export$2c14ff85d6318973 = void 0;
const $f14c6b64cf0409b5$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "nas lugha na diog",
        other: "nas lugha na {{count}} diogan"
    },
    xSeconds: {
        one: "1 diog",
        two: "2 dhiog",
        twenty: "20 diog",
        other: "{{count}} diogan"
    },
    halfAMinute: "leth mhionaid",
    lessThanXMinutes: {
        one: "nas lugha na mionaid",
        other: "nas lugha na {{count}} mionaidean"
    },
    xMinutes: {
        one: "1 mionaid",
        two: "2 mhionaid",
        twenty: "20 mionaid",
        other: "{{count}} mionaidean"
    },
    aboutXHours: {
        one: "mu uair de th\xecde",
        other: "mu {{count}} uairean de th\xecde"
    },
    xHours: {
        one: "1 uair de th\xecde",
        two: "2 uair de th\xecde",
        twenty: "20 uair de th\xecde",
        other: "{{count}} uairean de th\xecde"
    },
    xDays: {
        one: "1 l\xe0",
        other: "{{count}} l\xe0"
    },
    aboutXWeeks: {
        one: "mu 1 seachdain",
        other: "mu {{count}} seachdainean"
    },
    xWeeks: {
        one: "1 seachdain",
        other: "{{count}} seachdainean"
    },
    aboutXMonths: {
        one: "mu mh\xecos",
        other: "mu {{count}} m\xecosan"
    },
    xMonths: {
        one: "1 m\xecos",
        other: "{{count}} m\xecosan"
    },
    aboutXYears: {
        one: "mu bhliadhna",
        other: "mu {{count}} bliadhnaichean"
    },
    xYears: {
        one: "1 bhliadhna",
        other: "{{count}} bliadhna"
    },
    overXYears: {
        one: "c\xf2rr is bliadhna",
        other: "c\xf2rr is {{count}} bliadhnaichean"
    },
    almostXYears: {
        one: "cha mh\xf2r bliadhna",
        other: "cha mh\xf2r {{count}} bliadhnaichean"
    }
};
const $f14c6b64cf0409b5$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $f14c6b64cf0409b5$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2 && !!tokenValue.two) result = tokenValue.two;
    else if (count === 20 && !!tokenValue.twenty) result = tokenValue.twenty;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "ann an " + result;
        else return "o chionn " + result;
    }
    return result;
};
$f14c6b64cf0409b5$export$2c14ff85d6318973 = $f14c6b64cf0409b5$var$formatDistance;

});

parcelRegister("a1QWK", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $74d31175d03e8f63$export$cbf60ecb96cbb82f; }, function (v) { return $74d31175d03e8f63$export$cbf60ecb96cbb82f = v; });
var $74d31175d03e8f63$export$cbf60ecb96cbb82f;
"use strict";
$74d31175d03e8f63$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $74d31175d03e8f63$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $74d31175d03e8f63$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $74d31175d03e8f63$var$dateTimeFormats = {
    full: "{{date}} 'aig' {{time}}",
    long: "{{date}} 'aig' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $74d31175d03e8f63$var$formatLong = $74d31175d03e8f63$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $74d31175d03e8f63$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $74d31175d03e8f63$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $74d31175d03e8f63$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("ld9Yq", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $f7128c6e068de95d$export$8fbbfd65594f46a0; }, function (v) { return $f7128c6e068de95d$export$8fbbfd65594f46a0 = v; });
var $f7128c6e068de95d$export$8fbbfd65594f46a0;
"use strict";
$f7128c6e068de95d$export$8fbbfd65594f46a0 = void 0;
const $f7128c6e068de95d$var$formatRelativeLocale = {
    lastWeek: "'mu dheireadh' eeee 'aig' p",
    yesterday: "'an-d\xe8 aig' p",
    today: "'an-diugh aig' p",
    tomorrow: "'a-m\xe0ireach aig' p",
    nextWeek: "eeee 'aig' p",
    other: "P"
};
const $f7128c6e068de95d$var$formatRelative = (token, _date, _baseDate, _options)=>$f7128c6e068de95d$var$formatRelativeLocale[token];
$f7128c6e068de95d$export$8fbbfd65594f46a0 = $f7128c6e068de95d$var$formatRelative;

});

parcelRegister("cXJ4h", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $96fdf4470c3e96b2$export$b3bd0bc58e36cd63; }, function (v) { return $96fdf4470c3e96b2$export$b3bd0bc58e36cd63 = v; });
var $96fdf4470c3e96b2$export$b3bd0bc58e36cd63;
"use strict";
$96fdf4470c3e96b2$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $96fdf4470c3e96b2$var$eraValues = {
    narrow: [
        "R",
        "A"
    ],
    abbreviated: [
        "RC",
        "AD"
    ],
    wide: [
        "ro Chr\xecosta",
        "anno domini"
    ]
};
const $96fdf4470c3e96b2$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "C1",
        "C2",
        "C3",
        "C4"
    ],
    wide: [
        "a' chiad chairteal",
        "an d\xe0rna cairteal",
        "an treas cairteal",
        "an ceathramh cairteal"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $96fdf4470c3e96b2$var$monthValues = {
    narrow: [
        "F",
        "G",
        "M",
        "G",
        "C",
        "\xd2",
        "I",
        "L",
        "S",
        "D",
        "S",
        "D"
    ],
    abbreviated: [
        "Faoi",
        "Gear",
        "M\xe0rt",
        "Gibl",
        "C\xe8it",
        "\xd2gmh",
        "Iuch",
        "L\xf9n",
        "Sult",
        "D\xe0mh",
        "Samh",
        "D\xf9bh"
    ],
    wide: [
        "Am Faoilleach",
        "An Gearran",
        "Am M\xe0rt",
        "An Giblean",
        "An C\xe8itean",
        "An t-\xd2gmhios",
        "An t-Iuchar",
        "An L\xf9nastal",
        "An t-Sultain",
        "An D\xe0mhair",
        "An t-Samhain",
        "An D\xf9bhlachd"
    ]
};
const $96fdf4470c3e96b2$var$dayValues = {
    narrow: [
        "D",
        "L",
        "M",
        "C",
        "A",
        "H",
        "S"
    ],
    short: [
        "D\xf2",
        "Lu",
        "M\xe0",
        "Ci",
        "Ar",
        "Ha",
        "Sa"
    ],
    abbreviated: [
        "Did",
        "Dil",
        "Dim",
        "Dic",
        "Dia",
        "Dih",
        "Dis"
    ],
    wide: [
        "Did\xf2mhnaich",
        "Diluain",
        "Dim\xe0irt",
        "Diciadain",
        "Diardaoin",
        "Dihaoine",
        "Disathairne"
    ]
};
const $96fdf4470c3e96b2$var$dayPeriodValues = {
    narrow: {
        am: "m",
        pm: "f",
        midnight: "m.o.",
        noon: "m.l.",
        morning: "madainn",
        afternoon: "feasgar",
        evening: "feasgar",
        night: "oidhche"
    },
    abbreviated: {
        am: "M.",
        pm: "F.",
        midnight: "meadhan oidhche",
        noon: "meadhan l\xe0",
        morning: "madainn",
        afternoon: "feasgar",
        evening: "feasgar",
        night: "oidhche"
    },
    wide: {
        am: "m.",
        pm: "f.",
        midnight: "meadhan oidhche",
        noon: "meadhan l\xe0",
        morning: "madainn",
        afternoon: "feasgar",
        evening: "feasgar",
        night: "oidhche"
    }
};
const $96fdf4470c3e96b2$var$formattingDayPeriodValues = {
    narrow: {
        am: "m",
        pm: "f",
        midnight: "m.o.",
        noon: "m.l.",
        morning: "sa mhadainn",
        afternoon: "feasgar",
        evening: "feasgar",
        night: "air an oidhche"
    },
    abbreviated: {
        am: "M.",
        pm: "F.",
        midnight: "meadhan oidhche",
        noon: "meadhan l\xe0",
        morning: "sa mhadainn",
        afternoon: "feasgar",
        evening: "feasgar",
        night: "air an oidhche"
    },
    wide: {
        am: "m.",
        pm: "f.",
        midnight: "meadhan oidhche",
        noon: "meadhan l\xe0",
        morning: "sa mhadainn",
        afternoon: "feasgar",
        evening: "feasgar",
        night: "air an oidhche"
    }
};
const $96fdf4470c3e96b2$var$ordinalNumber = (dirtyNumber)=>{
    const number = Number(dirtyNumber);
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "d";
        case 2:
            return number + "na";
    }
    if (rem100 === 12) return number + "na";
    return number + "mh";
};
const $96fdf4470c3e96b2$var$localize = $96fdf4470c3e96b2$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $96fdf4470c3e96b2$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $96fdf4470c3e96b2$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $96fdf4470c3e96b2$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $96fdf4470c3e96b2$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $96fdf4470c3e96b2$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $96fdf4470c3e96b2$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $96fdf4470c3e96b2$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("53ELD", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $3aecdb1d752a8839$export$4659b591c19bdf3d; }, function (v) { return $3aecdb1d752a8839$export$4659b591c19bdf3d = v; });
var $3aecdb1d752a8839$export$4659b591c19bdf3d;
"use strict";
$3aecdb1d752a8839$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $3aecdb1d752a8839$var$matchOrdinalNumberPattern = /^(\d+)(d|na|tr|mh)?/i;
const $3aecdb1d752a8839$var$parseOrdinalNumberPattern = /\d+/i;
const $3aecdb1d752a8839$var$matchEraPatterns = {
    narrow: /^(r|a)/i,
    abbreviated: /^(r\.?\s?c\.?|r\.?\s?a\.?\s?c\.?|a\.?\s?d\.?|a\.?\s?c\.?)/i,
    wide: /^(ro Chrìosta|ron aois choitchinn|anno domini|aois choitcheann)/i
};
const $3aecdb1d752a8839$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $3aecdb1d752a8839$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^c[1234]/i,
    wide: /^[1234](cd|na|tr|mh)? cairteal/i
};
const $3aecdb1d752a8839$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $3aecdb1d752a8839$var$matchMonthPatterns = {
    narrow: /^[fgmcòilsd]/i,
    abbreviated: /^(faoi|gear|màrt|gibl|cèit|ògmh|iuch|lùn|sult|dàmh|samh|dùbh)/i,
    wide: /^(am faoilleach|an gearran|am màrt|an giblean|an cèitean|an t-Ògmhios|an t-Iuchar|an lùnastal|an t-Sultain|an dàmhair|an t-Samhain|an dùbhlachd)/i
};
const $3aecdb1d752a8839$var$parseMonthPatterns = {
    narrow: [
        /^f/i,
        /^g/i,
        /^m/i,
        /^g/i,
        /^c/i,
        /^ò/i,
        /^i/i,
        /^l/i,
        /^s/i,
        /^d/i,
        /^s/i,
        /^d/i
    ],
    any: [
        /^fa/i,
        /^ge/i,
        /^mà/i,
        /^gi/i,
        /^c/i,
        /^ò/i,
        /^i/i,
        /^l/i,
        /^su/i,
        /^d/i,
        /^sa/i,
        /^d/i
    ]
};
const $3aecdb1d752a8839$var$matchDayPatterns = {
    narrow: /^[dlmcahs]/i,
    short: /^(dò|lu|mà|ci|ar|ha|sa)/i,
    abbreviated: /^(did|dil|dim|dic|dia|dih|dis)/i,
    wide: /^(didòmhnaich|diluain|dimàirt|diciadain|diardaoin|dihaoine|disathairne)/i
};
const $3aecdb1d752a8839$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^c/i,
        /^a/i,
        /^h/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^c/i,
        /^a/i,
        /^h/i,
        /^s/i
    ]
};
const $3aecdb1d752a8839$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(san|aig) (madainn|feasgar|feasgar|oidhche))/i,
    any: /^([ap]\.?\s?m\.?|meadhan oidhche|meadhan là|(san|aig) (madainn|feasgar|feasgar|oidhche))/i
};
const $3aecdb1d752a8839$var$parseDayPeriodPatterns = {
    any: {
        am: /^m/i,
        pm: /^f/i,
        midnight: /^meadhan oidhche/i,
        noon: /^meadhan là/i,
        morning: /sa mhadainn/i,
        afternoon: /feasgar/i,
        evening: /feasgar/i,
        night: /air an oidhche/i
    }
};
const $3aecdb1d752a8839$var$match = $3aecdb1d752a8839$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $3aecdb1d752a8839$var$matchOrdinalNumberPattern,
        parsePattern: $3aecdb1d752a8839$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $3aecdb1d752a8839$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3aecdb1d752a8839$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $3aecdb1d752a8839$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3aecdb1d752a8839$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $3aecdb1d752a8839$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3aecdb1d752a8839$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $3aecdb1d752a8839$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3aecdb1d752a8839$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $3aecdb1d752a8839$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $3aecdb1d752a8839$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("ba3un", function(module, exports) {

$parcel$export(module.exports, "gl", function () { return $820355b7d081e855$export$5822a9d0880a5d82; }, function (v) { return $820355b7d081e855$export$5822a9d0880a5d82 = v; });
var $820355b7d081e855$export$5822a9d0880a5d82;
"use strict";
$820355b7d081e855$export$5822a9d0880a5d82 = void 0;

var $6mgnQ = parcelRequire("6mgnQ");

var $2jxsu = parcelRequire("2jxsu");

var $eDH5e = parcelRequire("eDH5e");

var $eKIzO = parcelRequire("eKIzO");

var $8uoXe = parcelRequire("8uoXe");
/**
 * @category Locales
 * @summary Galician locale.
 * @language Galician
 * @iso-639-2 glg
 * @author Alberto Doval - Cocodin Technology[@cocodinTech](https://github.com/cocodinTech)
 * @author Fidel Pita [@fidelpita](https://github.com/fidelpita)
 */ const $820355b7d081e855$var$gl = $820355b7d081e855$export$5822a9d0880a5d82 = {
    code: "gl",
    formatDistance: $6mgnQ.formatDistance,
    formatLong: $2jxsu.formatLong,
    formatRelative: $eDH5e.formatRelative,
    localize: $eKIzO.localize,
    match: $8uoXe.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("6mgnQ", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $4a118194307cac18$export$2c14ff85d6318973; }, function (v) { return $4a118194307cac18$export$2c14ff85d6318973 = v; });
var $4a118194307cac18$export$2c14ff85d6318973;
"use strict";
$4a118194307cac18$export$2c14ff85d6318973 = void 0;
const $4a118194307cac18$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menos dun segundo",
        other: "menos de {{count}} segundos"
    },
    xSeconds: {
        one: "1 segundo",
        other: "{{count}} segundos"
    },
    halfAMinute: "medio minuto",
    lessThanXMinutes: {
        one: "menos dun minuto",
        other: "menos de {{count}} minutos"
    },
    xMinutes: {
        one: "1 minuto",
        other: "{{count}} minutos"
    },
    aboutXHours: {
        one: "arredor dunha hora",
        other: "arredor de {{count}} horas"
    },
    xHours: {
        one: "1 hora",
        other: "{{count}} horas"
    },
    xDays: {
        one: "1 d\xeda",
        other: "{{count}} d\xedas"
    },
    aboutXWeeks: {
        one: "arredor dunha semana",
        other: "arredor de {{count}} semanas"
    },
    xWeeks: {
        one: "1 semana",
        other: "{{count}} semanas"
    },
    aboutXMonths: {
        one: "arredor de 1 mes",
        other: "arredor de {{count}} meses"
    },
    xMonths: {
        one: "1 mes",
        other: "{{count}} meses"
    },
    aboutXYears: {
        one: "arredor dun ano",
        other: "arredor de {{count}} anos"
    },
    xYears: {
        one: "1 ano",
        other: "{{count}} anos"
    },
    overXYears: {
        one: "m\xe1is dun ano",
        other: "m\xe1is de {{count}} anos"
    },
    almostXYears: {
        one: "case un ano",
        other: "case {{count}} anos"
    }
};
const $4a118194307cac18$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $4a118194307cac18$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "en " + result;
        else return "hai " + result;
    }
    return result;
};
$4a118194307cac18$export$2c14ff85d6318973 = $4a118194307cac18$var$formatDistance;

});

parcelRegister("2jxsu", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $1af74f440bf77724$export$cbf60ecb96cbb82f; }, function (v) { return $1af74f440bf77724$export$cbf60ecb96cbb82f = v; });
var $1af74f440bf77724$export$cbf60ecb96cbb82f;
"use strict";
$1af74f440bf77724$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $1af74f440bf77724$var$dateFormats = {
    full: "EEEE, d 'de' MMMM y",
    long: "d 'de' MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
const $1af74f440bf77724$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $1af74f440bf77724$var$dateTimeFormats = {
    full: "{{date}} '\xe1s' {{time}}",
    long: "{{date}} '\xe1s' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $1af74f440bf77724$var$formatLong = $1af74f440bf77724$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $1af74f440bf77724$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $1af74f440bf77724$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $1af74f440bf77724$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("eDH5e", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $aa8620b02926b628$export$8fbbfd65594f46a0; }, function (v) { return $aa8620b02926b628$export$8fbbfd65594f46a0 = v; });
var $aa8620b02926b628$export$8fbbfd65594f46a0;
"use strict";
$aa8620b02926b628$export$8fbbfd65594f46a0 = void 0;
const $aa8620b02926b628$var$formatRelativeLocale = {
    lastWeek: "'o' eeee 'pasado \xe1' LT",
    yesterday: "'onte \xe1' p",
    today: "'hoxe \xe1' p",
    tomorrow: "'ma\xf1\xe1 \xe1' p",
    nextWeek: "eeee '\xe1' p",
    other: "P"
};
const $aa8620b02926b628$var$formatRelativeLocalePlural = {
    lastWeek: "'o' eeee 'pasado \xe1s' p",
    yesterday: "'onte \xe1s' p",
    today: "'hoxe \xe1s' p",
    tomorrow: "'ma\xf1\xe1 \xe1s' p",
    nextWeek: "eeee '\xe1s' p",
    other: "P"
};
const $aa8620b02926b628$var$formatRelative = (token, date, _baseDate, _options)=>{
    if (date.getHours() !== 1) return $aa8620b02926b628$var$formatRelativeLocalePlural[token];
    return $aa8620b02926b628$var$formatRelativeLocale[token];
};
$aa8620b02926b628$export$8fbbfd65594f46a0 = $aa8620b02926b628$var$formatRelative;

});

parcelRegister("eKIzO", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $abd7f08d03cba75a$export$b3bd0bc58e36cd63; }, function (v) { return $abd7f08d03cba75a$export$b3bd0bc58e36cd63 = v; });
var $abd7f08d03cba75a$export$b3bd0bc58e36cd63;
"use strict";
$abd7f08d03cba75a$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $abd7f08d03cba75a$var$eraValues = {
    narrow: [
        "AC",
        "DC"
    ],
    abbreviated: [
        "AC",
        "DC"
    ],
    wide: [
        "antes de cristo",
        "despois de cristo"
    ]
};
const $abd7f08d03cba75a$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
const $abd7f08d03cba75a$var$monthValues = {
    narrow: [
        "e",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "xan",
        "feb",
        "mar",
        "abr",
        "mai",
        "xun",
        "xul",
        "ago",
        "set",
        "out",
        "nov",
        "dec"
    ],
    wide: [
        "xaneiro",
        "febreiro",
        "marzo",
        "abril",
        "maio",
        "xu\xf1o",
        "xullo",
        "agosto",
        "setembro",
        "outubro",
        "novembro",
        "decembro"
    ]
};
const $abd7f08d03cba75a$var$dayValues = {
    narrow: [
        "d",
        "l",
        "m",
        "m",
        "j",
        "v",
        "s"
    ],
    short: [
        "do",
        "lu",
        "ma",
        "me",
        "xo",
        "ve",
        "sa"
    ],
    abbreviated: [
        "dom",
        "lun",
        "mar",
        "mer",
        "xov",
        "ven",
        "sab"
    ],
    wide: [
        "domingo",
        "luns",
        "martes",
        "m\xe9rcores",
        "xoves",
        "venres",
        "s\xe1bado"
    ]
};
const $abd7f08d03cba75a$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "ma\xf1\xe1",
        afternoon: "tarde",
        evening: "tarde",
        night: "noite"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "medianoite",
        noon: "mediod\xeda",
        morning: "ma\xf1\xe1",
        afternoon: "tarde",
        evening: "tardi\xf1a",
        night: "noite"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "medianoite",
        noon: "mediod\xeda",
        morning: "ma\xf1\xe1",
        afternoon: "tarde",
        evening: "tardi\xf1a",
        night: "noite"
    }
};
const $abd7f08d03cba75a$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "da ma\xf1\xe1",
        afternoon: "da tarde",
        evening: "da tardi\xf1a",
        night: "da noite"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "medianoite",
        noon: "mediod\xeda",
        morning: "da ma\xf1\xe1",
        afternoon: "da tarde",
        evening: "da tardi\xf1a",
        night: "da noite"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "medianoite",
        noon: "mediod\xeda",
        morning: "da ma\xf1\xe1",
        afternoon: "da tarde",
        evening: "da tardi\xf1a",
        night: "da noite"
    }
};
const $abd7f08d03cba75a$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + "\xba";
};
const $abd7f08d03cba75a$var$localize = $abd7f08d03cba75a$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $abd7f08d03cba75a$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $abd7f08d03cba75a$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $abd7f08d03cba75a$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $abd7f08d03cba75a$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $abd7f08d03cba75a$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $abd7f08d03cba75a$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $abd7f08d03cba75a$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("8uoXe", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $62e47b7a69a9531a$export$4659b591c19bdf3d; }, function (v) { return $62e47b7a69a9531a$export$4659b591c19bdf3d = v; });
var $62e47b7a69a9531a$export$4659b591c19bdf3d;
"use strict";
$62e47b7a69a9531a$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $62e47b7a69a9531a$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
const $62e47b7a69a9531a$var$parseOrdinalNumberPattern = /\d+/i;
const $62e47b7a69a9531a$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes da era com[uú]n|despois de cristo|era com[uú]n)/i
};
const $62e47b7a69a9531a$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes da era com[uú]n)/i,
        /^(despois de cristo|era com[uú]n)/i
    ]
};
const $62e47b7a69a9531a$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
const $62e47b7a69a9531a$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $62e47b7a69a9531a$var$matchMonthPatterns = {
    narrow: /^[xfmasond]/i,
    abbreviated: /^(xan|feb|mar|abr|mai|xun|xul|ago|set|out|nov|dec)/i,
    wide: /^(xaneiro|febreiro|marzo|abril|maio|xuño|xullo|agosto|setembro|outubro|novembro|decembro)/i
};
const $62e47b7a69a9531a$var$parseMonthPatterns = {
    narrow: [
        /^x/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^x/i,
        /^x/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^xan/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^mai/i,
        /^xun/i,
        /^xul/i,
        /^ago/i,
        /^set/i,
        /^out/i,
        /^nov/i,
        /^dec/i
    ]
};
const $62e47b7a69a9531a$var$matchDayPatterns = {
    narrow: /^[dlmxvs]/i,
    short: /^(do|lu|ma|me|xo|ve|sa)/i,
    abbreviated: /^(dom|lun|mar|mer|xov|ven|sab)/i,
    wide: /^(domingo|luns|martes|m[eé]rcores|xoves|venres|s[áa]bado)/i
};
const $62e47b7a69a9531a$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^x/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^do/i,
        /^lu/i,
        /^ma/i,
        /^me/i,
        /^xo/i,
        /^ve/i,
        /^sa/i
    ]
};
const $62e47b7a69a9531a$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(da|[aá]s) (mañ[aá]|tarde|noite))/i,
    any: /^([ap]\.?\s?m\.?|medianoite|mediod[ií]a|(da|[aá]s) (mañ[aá]|tarde|noite))/i
};
const $62e47b7a69a9531a$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /^md/i,
        morning: /mañ[aá]/i,
        afternoon: /tarde/i,
        evening: /tardiña/i,
        night: /noite/i
    }
};
const $62e47b7a69a9531a$var$match = $62e47b7a69a9531a$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $62e47b7a69a9531a$var$matchOrdinalNumberPattern,
        parsePattern: $62e47b7a69a9531a$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $62e47b7a69a9531a$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $62e47b7a69a9531a$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $62e47b7a69a9531a$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $62e47b7a69a9531a$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $62e47b7a69a9531a$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $62e47b7a69a9531a$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $62e47b7a69a9531a$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $62e47b7a69a9531a$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $62e47b7a69a9531a$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $62e47b7a69a9531a$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("7YFiI", function(module, exports) {

$parcel$export(module.exports, "gu", function () { return $5cee2c81c76b7576$export$85e91b8206de11f6; }, function (v) { return $5cee2c81c76b7576$export$85e91b8206de11f6 = v; });
var $5cee2c81c76b7576$export$85e91b8206de11f6;
"use strict";
$5cee2c81c76b7576$export$85e91b8206de11f6 = void 0;

var $fb3QD = parcelRequire("fb3QD");

var $5p4K2 = parcelRequire("5p4K2");

var $9uTcs = parcelRequire("9uTcs");

var $akQhE = parcelRequire("akQhE");

var $igwXu = parcelRequire("igwXu");
/**
 * @category Locales
 * @summary Gujarati locale (India).
 * @language Gujarati
 * @iso-639-2 guj
 * @author Manaday Mavani [@ManadayM](https://github.com/manadaym)
 */ const $5cee2c81c76b7576$var$gu = $5cee2c81c76b7576$export$85e91b8206de11f6 = {
    code: "gu",
    formatDistance: $fb3QD.formatDistance,
    formatLong: $5p4K2.formatLong,
    formatRelative: $9uTcs.formatRelative,
    localize: $akQhE.localize,
    match: $igwXu.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("fb3QD", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $b0cade38e7b5e268$export$2c14ff85d6318973; }, function (v) { return $b0cade38e7b5e268$export$2c14ff85d6318973 = v; });
var $b0cade38e7b5e268$export$2c14ff85d6318973;
"use strict";
$b0cade38e7b5e268$export$2c14ff85d6318973 = void 0;
// Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
const $b0cade38e7b5e268$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0AB9\u0AAE\u0AA3\u0ABE\u0A82",
        other: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AB8\u0AC7\u0A95\u0A82\u0AA1"
    },
    xSeconds: {
        one: "1 \u0AB8\u0AC7\u0A95\u0A82\u0AA1",
        other: "{{count}} \u0AB8\u0AC7\u0A95\u0A82\u0AA1"
    },
    halfAMinute: "\u0A85\u0AA1\u0AA7\u0AC0 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
    lessThanXMinutes: {
        one: "\u0A86 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
        other: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F"
    },
    xMinutes: {
        one: "1 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
        other: "{{count}} \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F"
    },
    aboutXHours: {
        one: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 1 \u0A95\u0AB2\u0ABE\u0A95",
        other: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0A95\u0AB2\u0ABE\u0A95"
    },
    xHours: {
        one: "1 \u0A95\u0AB2\u0ABE\u0A95",
        other: "{{count}} \u0A95\u0AB2\u0ABE\u0A95"
    },
    xDays: {
        one: "1 \u0AA6\u0ABF\u0AB5\u0AB8",
        other: "{{count}} \u0AA6\u0ABF\u0AB5\u0AB8"
    },
    aboutXWeeks: {
        one: "\u0A86\u0AB6\u0AB0\u0AC7 1 \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0AC1\u0A82",
        other: "\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0ABE"
    },
    xWeeks: {
        one: "1 \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0AC1\u0A82",
        other: "{{count}} \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0ABE"
    },
    aboutXMonths: {
        one: "\u0A86\u0AB6\u0AB0\u0AC7 1 \u0AAE\u0AB9\u0ABF\u0AA8\u0ACB",
        other: "\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AAE\u0AB9\u0ABF\u0AA8\u0ABE"
    },
    xMonths: {
        one: "1 \u0AAE\u0AB9\u0ABF\u0AA8\u0ACB",
        other: "{{count}} \u0AAE\u0AB9\u0ABF\u0AA8\u0ABE"
    },
    aboutXYears: {
        one: "\u0A86\u0AB6\u0AB0\u0AC7 1 \u0AB5\u0AB0\u0ACD\u0AB7",
        other: "\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
    },
    xYears: {
        one: "1 \u0AB5\u0AB0\u0ACD\u0AB7",
        other: "{{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
    },
    overXYears: {
        one: "1 \u0AB5\u0AB0\u0ACD\u0AB7\u0AA5\u0AC0 \u0AB5\u0AA7\u0AC1",
        other: "{{count}} \u0AB5\u0AB0\u0ACD\u0AB7\u0AA5\u0AC0 \u0AB5\u0AA7\u0AC1"
    },
    almostXYears: {
        one: "\u0AB2\u0A97\u0AAD\u0A97 1 \u0AB5\u0AB0\u0ACD\u0AB7",
        other: "\u0AB2\u0A97\u0AAD\u0A97 {{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
    }
};
const $b0cade38e7b5e268$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $b0cade38e7b5e268$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u0AAE\u0ABE\u0A82";
        else return result + " \u0AAA\u0AB9\u0AC7\u0AB2\u0ABE\u0A82";
    }
    return result;
};
$b0cade38e7b5e268$export$2c14ff85d6318973 = $b0cade38e7b5e268$var$formatDistance;

});

parcelRegister("5p4K2", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $3ef2f71aa265e8d6$export$cbf60ecb96cbb82f; }, function (v) { return $3ef2f71aa265e8d6$export$cbf60ecb96cbb82f = v; });
var $3ef2f71aa265e8d6$export$cbf60ecb96cbb82f;
"use strict";
$3ef2f71aa265e8d6$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
//Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
const $3ef2f71aa265e8d6$var$dateFormats = {
    full: "EEEE, d MMMM, y",
    long: "d MMMM, y",
    medium: "d MMM, y",
    short: "d/M/yy"
};
const $3ef2f71aa265e8d6$var$timeFormats = {
    full: "hh:mm:ss a zzzz",
    long: "hh:mm:ss a z",
    medium: "hh:mm:ss a",
    short: "hh:mm a"
};
const $3ef2f71aa265e8d6$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $3ef2f71aa265e8d6$var$formatLong = $3ef2f71aa265e8d6$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $3ef2f71aa265e8d6$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $3ef2f71aa265e8d6$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $3ef2f71aa265e8d6$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("9uTcs", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $6ea1bbf1fe8c659d$export$8fbbfd65594f46a0; }, function (v) { return $6ea1bbf1fe8c659d$export$8fbbfd65594f46a0 = v; });
var $6ea1bbf1fe8c659d$export$8fbbfd65594f46a0;
"use strict";
$6ea1bbf1fe8c659d$export$8fbbfd65594f46a0 = void 0;
// Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
const $6ea1bbf1fe8c659d$var$formatRelativeLocale = {
    lastWeek: "'\u0AAA\u0ABE\u0A9B\u0AB2\u0ABE' eeee p",
    yesterday: "'\u0A97\u0A88\u0A95\u0ABE\u0AB2\u0AC7' p",
    today: "'\u0A86\u0A9C\u0AC7' p",
    tomorrow: "'\u0A86\u0AB5\u0AA4\u0AC0\u0A95\u0ABE\u0AB2\u0AC7' p",
    nextWeek: "eeee p",
    other: "P"
};
const $6ea1bbf1fe8c659d$var$formatRelative = (token, _date, _baseDate, _options)=>$6ea1bbf1fe8c659d$var$formatRelativeLocale[token];
$6ea1bbf1fe8c659d$export$8fbbfd65594f46a0 = $6ea1bbf1fe8c659d$var$formatRelative;

});

parcelRegister("akQhE", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $78645416214a891e$export$b3bd0bc58e36cd63; }, function (v) { return $78645416214a891e$export$b3bd0bc58e36cd63 = v; });
var $78645416214a891e$export$b3bd0bc58e36cd63;
"use strict";
$78645416214a891e$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1621 - #1630
const $78645416214a891e$var$eraValues = {
    narrow: [
        "\u0A88\u0AB8\u0AAA\u0AC2",
        "\u0A88\u0AB8"
    ],
    abbreviated: [
        "\u0A88.\u0AB8.\u0AAA\u0AC2\u0AB0\u0ACD\u0AB5\u0AC7",
        "\u0A88.\u0AB8."
    ],
    wide: [
        "\u0A88\u0AB8\u0AB5\u0AC0\u0AB8\u0AA8 \u0AAA\u0AC2\u0AB0\u0ACD\u0AB5\u0AC7",
        "\u0A88\u0AB8\u0AB5\u0AC0\u0AB8\u0AA8"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1631 - #1654
const $78645416214a891e$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1\u0AB2\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8",
        "2\u0A9C\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8",
        "3\u0A9C\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8",
        "4\u0AA5\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1655 - #1726
const $78645416214a891e$var$monthValues = {
    narrow: [
        "\u0A9C\u0ABE",
        "\u0AAB\u0AC7",
        "\u0AAE\u0ABE",
        "\u0A8F",
        "\u0AAE\u0AC7",
        "\u0A9C\u0AC2",
        "\u0A9C\u0AC1",
        "\u0A93",
        "\u0AB8",
        "\u0A93",
        "\u0AA8",
        "\u0AA1\u0ABF"
    ],
    abbreviated: [
        "\u0A9C\u0ABE\u0AA8\u0ACD\u0AAF\u0AC1",
        "\u0AAB\u0AC7\u0AAC\u0ACD\u0AB0\u0AC1",
        "\u0AAE\u0ABE\u0AB0\u0ACD\u0A9A",
        "\u0A8F\u0AAA\u0ACD\u0AB0\u0ABF\u0AB2",
        "\u0AAE\u0AC7",
        "\u0A9C\u0AC2\u0AA8",
        "\u0A9C\u0AC1\u0AB2\u0ABE\u0A88",
        "\u0A91\u0A97\u0AB8\u0ACD\u0A9F",
        "\u0AB8\u0AAA\u0ACD\u0A9F\u0AC7",
        "\u0A93\u0A95\u0ACD\u0A9F\u0ACB",
        "\u0AA8\u0AB5\u0AC7",
        "\u0AA1\u0ABF\u0AB8\u0AC7"
    ],
    wide: [
        "\u0A9C\u0ABE\u0AA8\u0ACD\u0AAF\u0AC1\u0A86\u0AB0\u0AC0",
        "\u0AAB\u0AC7\u0AAC\u0ACD\u0AB0\u0AC1\u0A86\u0AB0\u0AC0",
        "\u0AAE\u0ABE\u0AB0\u0ACD\u0A9A",
        "\u0A8F\u0AAA\u0ACD\u0AB0\u0ABF\u0AB2",
        "\u0AAE\u0AC7",
        "\u0A9C\u0AC2\u0AA8",
        "\u0A9C\u0AC1\u0AB2\u0ABE\u0A87",
        "\u0A93\u0A97\u0AB8\u0ACD\u0A9F",
        "\u0AB8\u0AAA\u0ACD\u0A9F\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0",
        "\u0A93\u0A95\u0ACD\u0A9F\u0ACB\u0AAC\u0AB0",
        "\u0AA8\u0AB5\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0",
        "\u0AA1\u0ABF\u0AB8\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1727 - #1768
const $78645416214a891e$var$dayValues = {
    narrow: [
        "\u0AB0",
        "\u0AB8\u0ACB",
        "\u0AAE\u0A82",
        "\u0AAC\u0AC1",
        "\u0A97\u0AC1",
        "\u0AB6\u0AC1",
        "\u0AB6"
    ],
    short: [
        "\u0AB0",
        "\u0AB8\u0ACB",
        "\u0AAE\u0A82",
        "\u0AAC\u0AC1",
        "\u0A97\u0AC1",
        "\u0AB6\u0AC1",
        "\u0AB6"
    ],
    abbreviated: [
        "\u0AB0\u0AB5\u0ABF",
        "\u0AB8\u0ACB\u0AAE",
        "\u0AAE\u0A82\u0A97\u0AB3",
        "\u0AAC\u0AC1\u0AA7",
        "\u0A97\u0AC1\u0AB0\u0AC1",
        "\u0AB6\u0AC1\u0A95\u0ACD\u0AB0",
        "\u0AB6\u0AA8\u0ABF"
    ],
    wide: [
        "\u0AB0\u0AB5\u0ABF\u0AB5\u0ABE\u0AB0" /* Sunday */ ,
        "\u0AB8\u0ACB\u0AAE\u0AB5\u0ABE\u0AB0" /* Monday */ ,
        "\u0AAE\u0A82\u0A97\u0AB3\u0AB5\u0ABE\u0AB0" /* Tuesday */ ,
        "\u0AAC\u0AC1\u0AA7\u0AB5\u0ABE\u0AB0" /* Wednesday */ ,
        "\u0A97\u0AC1\u0AB0\u0AC1\u0AB5\u0ABE\u0AB0" /* Thursday */ ,
        "\u0AB6\u0AC1\u0A95\u0ACD\u0AB0\u0AB5\u0ABE\u0AB0" /* Friday */ ,
        "\u0AB6\u0AA8\u0ABF\u0AB5\u0ABE\u0AB0" /* Saturday */ 
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1783 - #1824
const $78645416214a891e$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "\u0AAE.\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC.",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    }
};
const $78645416214a891e$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "\u0AAE.\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    }
};
const $78645416214a891e$var$ordinalNumber = (dirtyNumber, _options)=>{
    return String(dirtyNumber);
};
const $78645416214a891e$var$localize = $78645416214a891e$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $78645416214a891e$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $78645416214a891e$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $78645416214a891e$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $78645416214a891e$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $78645416214a891e$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $78645416214a891e$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $78645416214a891e$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("igwXu", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $036e812f6faab088$export$4659b591c19bdf3d; }, function (v) { return $036e812f6faab088$export$4659b591c19bdf3d = v; });
var $036e812f6faab088$export$4659b591c19bdf3d;
"use strict";
$036e812f6faab088$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $036e812f6faab088$var$matchOrdinalNumberPattern = /^(\d+)(લ|જ|થ|ઠ્ઠ|મ)?/i;
const $036e812f6faab088$var$parseOrdinalNumberPattern = /\d+/i;
const $036e812f6faab088$var$matchEraPatterns = {
    narrow: /^(ઈસપૂ|ઈસ)/i,
    abbreviated: /^(ઈ\.સ\.પૂર્વે|ઈ\.સ\.)/i,
    wide: /^(ઈસવીસન\sપૂર્વે|ઈસવીસન)/i
};
const $036e812f6faab088$var$parseEraPatterns = {
    any: [
        /^ઈસપૂ/i,
        /^ઈસ/i
    ]
};
const $036e812f6faab088$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](લો|જો|થો)? ત્રિમાસ/i
};
const $036e812f6faab088$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $036e812f6faab088$var$matchMonthPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[જાફેમાએમેજૂજુઓસઓનડિ]/i,
    abbreviated: /^(જાન્યુ|ફેબ્રુ|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઈ|ઑગસ્ટ|સપ્ટે|ઓક્ટો|નવે|ડિસે)/i,
    wide: /^(જાન્યુઆરી|ફેબ્રુઆરી|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઇ|ઓગસ્ટ|સપ્ટેમ્બર|ઓક્ટોબર|નવેમ્બર|ડિસેમ્બર)/i
};
const $036e812f6faab088$var$parseMonthPatterns = {
    narrow: [
        /^જા/i,
        /^ફે/i,
        /^મા/i,
        /^એ/i,
        /^મે/i,
        /^જૂ/i,
        /^જુ/i,
        /^ઑગ/i,
        /^સ/i,
        /^ઓક્ટો/i,
        /^ન/i,
        /^ડિ/i
    ],
    any: [
        /^જા/i,
        /^ફે/i,
        /^મા/i,
        /^એ/i,
        /^મે/i,
        /^જૂ/i,
        /^જુ/i,
        /^ઑગ/i,
        /^સ/i,
        /^ઓક્ટો/i,
        /^ન/i,
        /^ડિ/i
    ]
};
const $036e812f6faab088$var$matchDayPatterns = {
    narrow: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
    short: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
    abbreviated: /^(રવિ|સોમ|મંગળ|બુધ|ગુરુ|શુક્ર|શનિ)/i,
    wide: /^(રવિવાર|સોમવાર|મંગળવાર|બુધવાર|ગુરુવાર|શુક્રવાર|શનિવાર)/i
};
const $036e812f6faab088$var$parseDayPatterns = {
    narrow: [
        /^ર/i,
        /^સો/i,
        /^મં/i,
        /^બુ/i,
        /^ગુ/i,
        /^શુ/i,
        /^શ/i
    ],
    any: [
        /^ર/i,
        /^સો/i,
        /^મં/i,
        /^બુ/i,
        /^ગુ/i,
        /^શુ/i,
        /^શ/i
    ]
};
const $036e812f6faab088$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|મ\.?|સ|બ|સાં|રા)/i,
    any: /^(a|p|મ\.?|સ|બ|સાં|રા)/i
};
const $036e812f6faab088$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^મ\.?/i,
        noon: /^બ/i,
        morning: /સ/i,
        afternoon: /બ/i,
        evening: /સાં/i,
        night: /રા/i
    }
};
const $036e812f6faab088$var$match = $036e812f6faab088$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $036e812f6faab088$var$matchOrdinalNumberPattern,
        parsePattern: $036e812f6faab088$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $036e812f6faab088$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $036e812f6faab088$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $036e812f6faab088$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $036e812f6faab088$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $036e812f6faab088$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $036e812f6faab088$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $036e812f6faab088$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $036e812f6faab088$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $036e812f6faab088$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $036e812f6faab088$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("17UrZ", function(module, exports) {

$parcel$export(module.exports, "he", function () { return $0d223bc0ab24709c$export$10cc7d172bb7969; }, function (v) { return $0d223bc0ab24709c$export$10cc7d172bb7969 = v; });
var $0d223bc0ab24709c$export$10cc7d172bb7969;
"use strict";
$0d223bc0ab24709c$export$10cc7d172bb7969 = void 0;

var $fv6lo = parcelRequire("fv6lo");

var $8VwvM = parcelRequire("8VwvM");

var $lkTEb = parcelRequire("lkTEb");

var $dEjLg = parcelRequire("dEjLg");

var $iL90C = parcelRequire("iL90C");
/**
 * @category Locales
 * @summary Hebrew locale.
 * @language Hebrew
 * @iso-639-2 heb
 * @author Nir Lahad [@nirlah](https://github.com/nirlah)
 */ const $0d223bc0ab24709c$var$he = $0d223bc0ab24709c$export$10cc7d172bb7969 = {
    code: "he",
    formatDistance: $fv6lo.formatDistance,
    formatLong: $8VwvM.formatLong,
    formatRelative: $lkTEb.formatRelative,
    localize: $dEjLg.localize,
    match: $iL90C.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("fv6lo", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $b48eac0dbaf25a8b$export$2c14ff85d6318973; }, function (v) { return $b48eac0dbaf25a8b$export$2c14ff85d6318973 = v; });
var $b48eac0dbaf25a8b$export$2c14ff85d6318973;
"use strict";
$b48eac0dbaf25a8b$export$2c14ff85d6318973 = void 0;
const $b48eac0dbaf25a8b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05E0\u05D9\u05D9\u05D4",
        two: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05EA\u05D9 \u05E9\u05E0\u05D9\u05D5\u05EA",
        other: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05BE{{count}} \u05E9\u05E0\u05D9\u05D5\u05EA"
    },
    xSeconds: {
        one: "\u05E9\u05E0\u05D9\u05D9\u05D4",
        two: "\u05E9\u05EA\u05D9 \u05E9\u05E0\u05D9\u05D5\u05EA",
        other: "{{count}} \u05E9\u05E0\u05D9\u05D5\u05EA"
    },
    halfAMinute: "\u05D7\u05E6\u05D9 \u05D3\u05E7\u05D4",
    lessThanXMinutes: {
        one: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05D3\u05E7\u05D4",
        two: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05EA\u05D9 \u05D3\u05E7\u05D5\u05EA",
        other: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05BE{{count}} \u05D3\u05E7\u05D5\u05EA"
    },
    xMinutes: {
        one: "\u05D3\u05E7\u05D4",
        two: "\u05E9\u05EA\u05D9 \u05D3\u05E7\u05D5\u05EA",
        other: "{{count}} \u05D3\u05E7\u05D5\u05EA"
    },
    aboutXHours: {
        one: "\u05DB\u05E9\u05E2\u05D4",
        two: "\u05DB\u05E9\u05E2\u05EA\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05E9\u05E2\u05D5\u05EA"
    },
    xHours: {
        one: "\u05E9\u05E2\u05D4",
        two: "\u05E9\u05E2\u05EA\u05D9\u05D9\u05DD",
        other: "{{count}} \u05E9\u05E2\u05D5\u05EA"
    },
    xDays: {
        one: "\u05D9\u05D5\u05DD",
        two: "\u05D9\u05D5\u05DE\u05D9\u05D9\u05DD",
        other: "{{count}} \u05D9\u05DE\u05D9\u05DD"
    },
    aboutXWeeks: {
        one: "\u05DB\u05E9\u05D1\u05D5\u05E2",
        two: "\u05DB\u05E9\u05D1\u05D5\u05E2\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05E9\u05D1\u05D5\u05E2\u05D5\u05EA"
    },
    xWeeks: {
        one: "\u05E9\u05D1\u05D5\u05E2",
        two: "\u05E9\u05D1\u05D5\u05E2\u05D9\u05D9\u05DD",
        other: "{{count}} \u05E9\u05D1\u05D5\u05E2\u05D5\u05EA"
    },
    aboutXMonths: {
        one: "\u05DB\u05D7\u05D5\u05D3\u05E9",
        two: "\u05DB\u05D7\u05D5\u05D3\u05E9\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05D7\u05D5\u05D3\u05E9\u05D9\u05DD"
    },
    xMonths: {
        one: "\u05D7\u05D5\u05D3\u05E9",
        two: "\u05D7\u05D5\u05D3\u05E9\u05D9\u05D9\u05DD",
        other: "{{count}} \u05D7\u05D5\u05D3\u05E9\u05D9\u05DD"
    },
    aboutXYears: {
        one: "\u05DB\u05E9\u05E0\u05D4",
        two: "\u05DB\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05E9\u05E0\u05D9\u05DD"
    },
    xYears: {
        one: "\u05E9\u05E0\u05D4",
        two: "\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "{{count}} \u05E9\u05E0\u05D9\u05DD"
    },
    overXYears: {
        one: "\u05D9\u05D5\u05EA\u05E8 \u05DE\u05E9\u05E0\u05D4",
        two: "\u05D9\u05D5\u05EA\u05E8 \u05DE\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "\u05D9\u05D5\u05EA\u05E8 \u05DE\u05BE{{count}} \u05E9\u05E0\u05D9\u05DD"
    },
    almostXYears: {
        one: "\u05DB\u05DE\u05E2\u05D8 \u05E9\u05E0\u05D4",
        two: "\u05DB\u05DE\u05E2\u05D8 \u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "\u05DB\u05DE\u05E2\u05D8 {{count}} \u05E9\u05E0\u05D9\u05DD"
    }
};
const $b48eac0dbaf25a8b$var$formatDistance = (token, count, options)=>{
    // Return word instead of `in one day` or `one day ago`
    if (token === "xDays" && options?.addSuffix && count <= 2) {
        if (options.comparison && options.comparison > 0) return count === 1 ? "\u05DE\u05D7\u05E8" : "\u05DE\u05D7\u05E8\u05EA\u05D9\u05D9\u05DD";
        return count === 1 ? "\u05D0\u05EA\u05DE\u05D5\u05DC" : "\u05E9\u05DC\u05E9\u05D5\u05DD";
    }
    let result;
    const tokenValue = $b48eac0dbaf25a8b$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2) result = tokenValue.two;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u05D1\u05E2\u05D5\u05D3 " + result;
        else return "\u05DC\u05E4\u05E0\u05D9 " + result;
    }
    return result;
};
$b48eac0dbaf25a8b$export$2c14ff85d6318973 = $b48eac0dbaf25a8b$var$formatDistance;

});

parcelRegister("8VwvM", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $67fcddbb4eb4b8c4$export$cbf60ecb96cbb82f; }, function (v) { return $67fcddbb4eb4b8c4$export$cbf60ecb96cbb82f = v; });
var $67fcddbb4eb4b8c4$export$cbf60ecb96cbb82f;
"use strict";
$67fcddbb4eb4b8c4$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $67fcddbb4eb4b8c4$var$dateFormats = {
    full: "EEEE, d \u05D1MMMM y",
    long: "d \u05D1MMMM y",
    medium: "d \u05D1MMM y",
    short: "d.M.y"
};
const $67fcddbb4eb4b8c4$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $67fcddbb4eb4b8c4$var$dateTimeFormats = {
    full: "{{date}} '\u05D1\u05E9\u05E2\u05D4' {{time}}",
    long: "{{date}} '\u05D1\u05E9\u05E2\u05D4' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $67fcddbb4eb4b8c4$var$formatLong = $67fcddbb4eb4b8c4$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $67fcddbb4eb4b8c4$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $67fcddbb4eb4b8c4$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $67fcddbb4eb4b8c4$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("lkTEb", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $f886a1932388d2c1$export$8fbbfd65594f46a0; }, function (v) { return $f886a1932388d2c1$export$8fbbfd65594f46a0 = v; });
var $f886a1932388d2c1$export$8fbbfd65594f46a0;
"use strict";
$f886a1932388d2c1$export$8fbbfd65594f46a0 = void 0;
const $f886a1932388d2c1$var$formatRelativeLocale = {
    lastWeek: "eeee '\u05E9\u05E2\u05D1\u05E8 \u05D1\u05E9\u05E2\u05D4' p",
    yesterday: "'\u05D0\u05EA\u05DE\u05D5\u05DC \u05D1\u05E9\u05E2\u05D4' p",
    today: "'\u05D4\u05D9\u05D5\u05DD \u05D1\u05E9\u05E2\u05D4' p",
    tomorrow: "'\u05DE\u05D7\u05E8 \u05D1\u05E9\u05E2\u05D4' p",
    nextWeek: "eeee '\u05D1\u05E9\u05E2\u05D4' p",
    other: "P"
};
const $f886a1932388d2c1$var$formatRelative = (token, _date, _baseDate, _options)=>$f886a1932388d2c1$var$formatRelativeLocale[token];
$f886a1932388d2c1$export$8fbbfd65594f46a0 = $f886a1932388d2c1$var$formatRelative;

});

parcelRegister("dEjLg", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $9efe56f879e4836c$export$b3bd0bc58e36cd63; }, function (v) { return $9efe56f879e4836c$export$b3bd0bc58e36cd63 = v; });
var $9efe56f879e4836c$export$b3bd0bc58e36cd63;
"use strict";
$9efe56f879e4836c$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $9efe56f879e4836c$var$eraValues = {
    narrow: [
        "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E1",
        "\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"
    ],
    abbreviated: [
        "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E1",
        "\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"
    ],
    wide: [
        "\u05DC\u05E4\u05E0\u05D9 \u05D4\u05E1\u05E4\u05D9\u05E8\u05D4",
        "\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"
    ]
};
const $9efe56f879e4836c$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "\u05E8\u05D1\u05E2\u05D5\u05DF 1",
        "\u05E8\u05D1\u05E2\u05D5\u05DF 2",
        "\u05E8\u05D1\u05E2\u05D5\u05DF 3",
        "\u05E8\u05D1\u05E2\u05D5\u05DF 4"
    ]
};
const $9efe56f879e4836c$var$monthValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12"
    ],
    abbreviated: [
        "\u05D9\u05E0\u05D5\u05F3",
        "\u05E4\u05D1\u05E8\u05F3",
        "\u05DE\u05E8\u05E5",
        "\u05D0\u05E4\u05E8\u05F3",
        "\u05DE\u05D0\u05D9",
        "\u05D9\u05D5\u05E0\u05D9",
        "\u05D9\u05D5\u05DC\u05D9",
        "\u05D0\u05D5\u05D2\u05F3",
        "\u05E1\u05E4\u05D8\u05F3",
        "\u05D0\u05D5\u05E7\u05F3",
        "\u05E0\u05D5\u05D1\u05F3",
        "\u05D3\u05E6\u05DE\u05F3"
    ],
    wide: [
        "\u05D9\u05E0\u05D5\u05D0\u05E8",
        "\u05E4\u05D1\u05E8\u05D5\u05D0\u05E8",
        "\u05DE\u05E8\u05E5",
        "\u05D0\u05E4\u05E8\u05D9\u05DC",
        "\u05DE\u05D0\u05D9",
        "\u05D9\u05D5\u05E0\u05D9",
        "\u05D9\u05D5\u05DC\u05D9",
        "\u05D0\u05D5\u05D2\u05D5\u05E1\u05D8",
        "\u05E1\u05E4\u05D8\u05DE\u05D1\u05E8",
        "\u05D0\u05D5\u05E7\u05D8\u05D5\u05D1\u05E8",
        "\u05E0\u05D5\u05D1\u05DE\u05D1\u05E8",
        "\u05D3\u05E6\u05DE\u05D1\u05E8"
    ]
};
const $9efe56f879e4836c$var$dayValues = {
    narrow: [
        "\u05D0\u05F3",
        "\u05D1\u05F3",
        "\u05D2\u05F3",
        "\u05D3\u05F3",
        "\u05D4\u05F3",
        "\u05D5\u05F3",
        "\u05E9\u05F3"
    ],
    short: [
        "\u05D0\u05F3",
        "\u05D1\u05F3",
        "\u05D2\u05F3",
        "\u05D3\u05F3",
        "\u05D4\u05F3",
        "\u05D5\u05F3",
        "\u05E9\u05F3"
    ],
    abbreviated: [
        "\u05D9\u05D5\u05DD \u05D0\u05F3",
        "\u05D9\u05D5\u05DD \u05D1\u05F3",
        "\u05D9\u05D5\u05DD \u05D2\u05F3",
        "\u05D9\u05D5\u05DD \u05D3\u05F3",
        "\u05D9\u05D5\u05DD \u05D4\u05F3",
        "\u05D9\u05D5\u05DD \u05D5\u05F3",
        "\u05E9\u05D1\u05EA"
    ],
    wide: [
        "\u05D9\u05D5\u05DD \u05E8\u05D0\u05E9\u05D5\u05DF",
        "\u05D9\u05D5\u05DD \u05E9\u05E0\u05D9",
        "\u05D9\u05D5\u05DD \u05E9\u05DC\u05D9\u05E9\u05D9",
        "\u05D9\u05D5\u05DD \u05E8\u05D1\u05D9\u05E2\u05D9",
        "\u05D9\u05D5\u05DD \u05D7\u05DE\u05D9\u05E9\u05D9",
        "\u05D9\u05D5\u05DD \u05E9\u05D9\u05E9\u05D9",
        "\u05D9\u05D5\u05DD \u05E9\u05D1\u05EA"
    ]
};
const $9efe56f879e4836c$var$dayPeriodValues = {
    narrow: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05E2\u05E8\u05D1",
        night: "\u05DC\u05D9\u05DC\u05D4"
    },
    abbreviated: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05E2\u05E8\u05D1",
        night: "\u05DC\u05D9\u05DC\u05D4"
    },
    wide: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05E2\u05E8\u05D1",
        night: "\u05DC\u05D9\u05DC\u05D4"
    }
};
const $9efe56f879e4836c$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D1\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05D1\u05E2\u05E8\u05D1",
        night: "\u05D1\u05DC\u05D9\u05DC\u05D4"
    },
    abbreviated: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05D1\u05E2\u05E8\u05D1",
        night: "\u05D1\u05DC\u05D9\u05DC\u05D4"
    },
    wide: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05D1\u05E2\u05E8\u05D1",
        night: "\u05D1\u05DC\u05D9\u05DC\u05D4"
    }
};
const $9efe56f879e4836c$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    // We only show words till 10
    if (number <= 0 || number > 10) return String(number);
    const unit = String(options?.unit);
    const isFemale = [
        "year",
        "hour",
        "minute",
        "second"
    ].indexOf(unit) >= 0;
    const male = [
        "\u05E8\u05D0\u05E9\u05D5\u05DF",
        "\u05E9\u05E0\u05D9",
        "\u05E9\u05DC\u05D9\u05E9\u05D9",
        "\u05E8\u05D1\u05D9\u05E2\u05D9",
        "\u05D7\u05DE\u05D9\u05E9\u05D9",
        "\u05E9\u05D9\u05E9\u05D9",
        "\u05E9\u05D1\u05D9\u05E2\u05D9",
        "\u05E9\u05DE\u05D9\u05E0\u05D9",
        "\u05EA\u05E9\u05D9\u05E2\u05D9",
        "\u05E2\u05E9\u05D9\u05E8\u05D9"
    ];
    const female = [
        "\u05E8\u05D0\u05E9\u05D5\u05E0\u05D4",
        "\u05E9\u05E0\u05D9\u05D9\u05D4",
        "\u05E9\u05DC\u05D9\u05E9\u05D9\u05EA",
        "\u05E8\u05D1\u05D9\u05E2\u05D9\u05EA",
        "\u05D7\u05DE\u05D9\u05E9\u05D9\u05EA",
        "\u05E9\u05D9\u05E9\u05D9\u05EA",
        "\u05E9\u05D1\u05D9\u05E2\u05D9\u05EA",
        "\u05E9\u05DE\u05D9\u05E0\u05D9\u05EA",
        "\u05EA\u05E9\u05D9\u05E2\u05D9\u05EA",
        "\u05E2\u05E9\u05D9\u05E8\u05D9\u05EA"
    ];
    const index = number - 1;
    return isFemale ? female[index] : male[index];
};
const $9efe56f879e4836c$var$localize = $9efe56f879e4836c$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $9efe56f879e4836c$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $9efe56f879e4836c$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $9efe56f879e4836c$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $9efe56f879e4836c$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $9efe56f879e4836c$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $9efe56f879e4836c$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $9efe56f879e4836c$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("iL90C", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $da839ac31268d965$export$4659b591c19bdf3d; }, function (v) { return $da839ac31268d965$export$4659b591c19bdf3d = v; });
var $da839ac31268d965$export$4659b591c19bdf3d;
"use strict";
$da839ac31268d965$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $da839ac31268d965$var$matchOrdinalNumberPattern = /^(\d+|(ראשון|שני|שלישי|רביעי|חמישי|שישי|שביעי|שמיני|תשיעי|עשירי|ראשונה|שנייה|שלישית|רביעית|חמישית|שישית|שביעית|שמינית|תשיעית|עשירית))/i;
const $da839ac31268d965$var$parseOrdinalNumberPattern = /^(\d+|רא|שנ|של|רב|ח|שי|שב|שמ|ת|ע)/i;
const $da839ac31268d965$var$matchEraPatterns = {
    narrow: /^ל(ספירה|פנה״ס)/i,
    abbreviated: /^ל(ספירה|פנה״ס)/i,
    wide: /^ל(פני ה)?ספירה/i
};
const $da839ac31268d965$var$parseEraPatterns = {
    any: [
        /^לפ/i,
        /^לס/i
    ]
};
const $da839ac31268d965$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^רבעון [1234]/i
};
const $da839ac31268d965$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $da839ac31268d965$var$matchMonthPatterns = {
    narrow: /^\d+/i,
    abbreviated: /^(ינו|פבר|מרץ|אפר|מאי|יוני|יולי|אוג|ספט|אוק|נוב|דצמ)׳?/i,
    wide: /^(ינואר|פברואר|מרץ|אפריל|מאי|יוני|יולי|אוגוסט|ספטמבר|אוקטובר|נובמבר|דצמבר)/i
};
const $da839ac31268d965$var$parseMonthPatterns = {
    narrow: [
        /^1$/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ינ/i,
        /^פ/i,
        /^מר/i,
        /^אפ/i,
        /^מא/i,
        /^יונ/i,
        /^יול/i,
        /^אוג/i,
        /^ס/i,
        /^אוק/i,
        /^נ/i,
        /^ד/i
    ]
};
const $da839ac31268d965$var$matchDayPatterns = {
    narrow: /^[אבגדהוש]׳/i,
    short: /^[אבגדהוש]׳/i,
    abbreviated: /^(שבת|יום (א|ב|ג|ד|ה|ו)׳)/i,
    wide: /^יום (ראשון|שני|שלישי|רביעי|חמישי|שישי|שבת)/i
};
const $da839ac31268d965$var$parseDayPatterns = {
    abbreviated: [
        /א׳$/i,
        /ב׳$/i,
        /ג׳$/i,
        /ד׳$/i,
        /ה׳$/i,
        /ו׳$/i,
        /^ש/i
    ],
    wide: [
        /ן$/i,
        /ני$/i,
        /לישי$/i,
        /עי$/i,
        /מישי$/i,
        /שישי$/i,
        /ת$/i
    ],
    any: [
        /^א/i,
        /^ב/i,
        /^ג/i,
        /^ד/i,
        /^ה/i,
        /^ו/i,
        /^ש/i
    ]
};
const $da839ac31268d965$var$matchDayPeriodPatterns = {
    any: /^(אחר ה|ב)?(חצות|צהריים|בוקר|ערב|לילה|אחה״צ|לפנה״צ)/i
};
const $da839ac31268d965$var$parseDayPeriodPatterns = {
    any: {
        am: /^לפ/i,
        pm: /^אחה/i,
        midnight: /^ח/i,
        noon: /^צ/i,
        morning: /בוקר/i,
        afternoon: /בצ|אחר/i,
        evening: /ערב/i,
        night: /לילה/i
    }
};
const $da839ac31268d965$var$ordinalName = [
    "\u05E8\u05D0",
    "\u05E9\u05E0",
    "\u05E9\u05DC",
    "\u05E8\u05D1",
    "\u05D7",
    "\u05E9\u05D9",
    "\u05E9\u05D1",
    "\u05E9\u05DE",
    "\u05EA",
    "\u05E2"
];
const $da839ac31268d965$var$match = $da839ac31268d965$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $da839ac31268d965$var$matchOrdinalNumberPattern,
        parsePattern: $da839ac31268d965$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>{
            const number = parseInt(value, 10);
            return isNaN(number) ? $da839ac31268d965$var$ordinalName.indexOf(value) + 1 : number;
        }
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $da839ac31268d965$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $da839ac31268d965$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $da839ac31268d965$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $da839ac31268d965$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $da839ac31268d965$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $da839ac31268d965$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $da839ac31268d965$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $da839ac31268d965$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $da839ac31268d965$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $da839ac31268d965$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("3uK0z", function(module, exports) {

$parcel$export(module.exports, "hi", function () { return $28b7dcaf6bd1d068$export$43bde67df112d15b; }, function (v) { return $28b7dcaf6bd1d068$export$43bde67df112d15b = v; });
var $28b7dcaf6bd1d068$export$43bde67df112d15b;
"use strict";
$28b7dcaf6bd1d068$export$43bde67df112d15b = void 0;

var $iYyym = parcelRequire("iYyym");

var $568r9 = parcelRequire("568r9");

var $9Tw5c = parcelRequire("9Tw5c");

var $eSLUr = parcelRequire("eSLUr");

var $lhuAO = parcelRequire("lhuAO");
/**
 * @category Locales
 * @summary Hindi locale (India).
 * @language Hindi
 * @iso-639-2 hin
 * @author Mukesh Mandiwal [@mukeshmandiwal](https://github.com/mukeshmandiwal)
 */ const $28b7dcaf6bd1d068$var$hi = $28b7dcaf6bd1d068$export$43bde67df112d15b = {
    code: "hi",
    formatDistance: $iYyym.formatDistance,
    formatLong: $568r9.formatLong,
    formatRelative: $9Tw5c.formatRelative,
    localize: $eSLUr.localize,
    match: $lhuAO.match,
    options: {
        weekStartsOn: 0 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("iYyym", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $dd08a229da6bb846$export$2c14ff85d6318973; }, function (v) { return $dd08a229da6bb846$export$2c14ff85d6318973 = v; });
var $dd08a229da6bb846$export$2c14ff85d6318973;
"use strict";
$dd08a229da6bb846$export$2c14ff85d6318973 = void 0;

var $eSLUr = parcelRequire("eSLUr");
// Source: https://www.unicode.org/cldr/charts/32/summary/hi.html
const $dd08a229da6bb846$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0967 \u0938\u0947\u0915\u0902\u0921 \u0938\u0947 \u0915\u092E",
        other: "{{count}} \u0938\u0947\u0915\u0902\u0921 \u0938\u0947 \u0915\u092E"
    },
    xSeconds: {
        one: "\u0967 \u0938\u0947\u0915\u0902\u0921",
        other: "{{count}} \u0938\u0947\u0915\u0902\u0921"
    },
    halfAMinute: "\u0906\u0927\u093E \u092E\u093F\u0928\u091F",
    lessThanXMinutes: {
        one: "\u0967 \u092E\u093F\u0928\u091F \u0938\u0947 \u0915\u092E",
        other: "{{count}} \u092E\u093F\u0928\u091F \u0938\u0947 \u0915\u092E"
    },
    xMinutes: {
        one: "\u0967 \u092E\u093F\u0928\u091F",
        other: "{{count}} \u092E\u093F\u0928\u091F"
    },
    aboutXHours: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0918\u0902\u091F\u093E",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0918\u0902\u091F\u0947"
    },
    xHours: {
        one: "\u0967 \u0918\u0902\u091F\u093E",
        other: "{{count}} \u0918\u0902\u091F\u0947"
    },
    xDays: {
        one: "\u0967 \u0926\u093F\u0928",
        other: "{{count}} \u0926\u093F\u0928"
    },
    aboutXWeeks: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0938\u092A\u094D\u0924\u093E\u0939",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0938\u092A\u094D\u0924\u093E\u0939"
    },
    xWeeks: {
        one: "\u0967 \u0938\u092A\u094D\u0924\u093E\u0939",
        other: "{{count}} \u0938\u092A\u094D\u0924\u093E\u0939"
    },
    aboutXMonths: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u092E\u0939\u0940\u0928\u093E",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u092E\u0939\u0940\u0928\u0947"
    },
    xMonths: {
        one: "\u0967 \u092E\u0939\u0940\u0928\u093E",
        other: "{{count}} \u092E\u0939\u0940\u0928\u0947"
    },
    aboutXYears: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0935\u0930\u094D\u0937",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0935\u0930\u094D\u0937"
    },
    xYears: {
        one: "\u0967 \u0935\u0930\u094D\u0937",
        other: "{{count}} \u0935\u0930\u094D\u0937"
    },
    overXYears: {
        one: "\u0967 \u0935\u0930\u094D\u0937 \u0938\u0947 \u0905\u0927\u093F\u0915",
        other: "{{count}} \u0935\u0930\u094D\u0937 \u0938\u0947 \u0905\u0927\u093F\u0915"
    },
    almostXYears: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0935\u0930\u094D\u0937",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0935\u0930\u094D\u0937"
    }
};
const $dd08a229da6bb846$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $dd08a229da6bb846$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", (0, $eSLUr.numberToLocale)(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u092E\u0947 ";
        else return result + " \u092A\u0939\u0932\u0947";
    }
    return result;
};
$dd08a229da6bb846$export$2c14ff85d6318973 = $dd08a229da6bb846$var$formatDistance;

});
parcelRegister("eSLUr", function(module, exports) {

$parcel$export(module.exports, "localeToNumber", function () { return $ad5b45a210a3f69d$export$b431cabd737c2a; }, function (v) { return $ad5b45a210a3f69d$export$b431cabd737c2a = v; });
$parcel$export(module.exports, "localize", function () { return $ad5b45a210a3f69d$export$b3bd0bc58e36cd63; }, function (v) { return $ad5b45a210a3f69d$export$b3bd0bc58e36cd63 = v; });
$parcel$export(module.exports, "numberToLocale", function () { return $ad5b45a210a3f69d$export$3e1d599946644f03; }, function (v) { return $ad5b45a210a3f69d$export$3e1d599946644f03 = v; });
var $ad5b45a210a3f69d$export$b431cabd737c2a;
var $ad5b45a210a3f69d$export$b3bd0bc58e36cd63;
var $ad5b45a210a3f69d$export$3e1d599946644f03;
"use strict";
$ad5b45a210a3f69d$export$b431cabd737c2a = $ad5b45a210a3f69d$var$localeToNumber;
$ad5b45a210a3f69d$export$b3bd0bc58e36cd63 = void 0;
$ad5b45a210a3f69d$export$3e1d599946644f03 = $ad5b45a210a3f69d$var$numberToLocale;

var $4Zr7l = parcelRequire("4Zr7l");
const $ad5b45a210a3f69d$var$numberValues = {
    locale: {
        1: "\u0967",
        2: "\u0968",
        3: "\u0969",
        4: "\u096A",
        5: "\u096B",
        6: "\u096C",
        7: "\u096D",
        8: "\u096E",
        9: "\u096F",
        0: "\u0966"
    },
    number: {
        "\u0967": "1",
        "\u0968": "2",
        "\u0969": "3",
        "\u096A": "4",
        "\u096B": "5",
        "\u096C": "6",
        "\u096D": "7",
        "\u096E": "8",
        "\u096F": "9",
        "\u0966": "0"
    }
};
// CLDR #1585 - #1592
const $ad5b45a210a3f69d$var$eraValues = {
    narrow: [
        "\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935",
        "\u0908\u0938\u094D\u0935\u0940"
    ],
    abbreviated: [
        "\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935",
        "\u0908\u0938\u094D\u0935\u0940"
    ],
    wide: [
        "\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935",
        "\u0908\u0938\u0935\u0940 \u0938\u0928"
    ]
};
// CLDR #1593 - #1616
const $ad5b45a210a3f69d$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u0924\u093F1",
        "\u0924\u093F2",
        "\u0924\u093F3",
        "\u0924\u093F4"
    ],
    wide: [
        "\u092A\u0939\u0932\u0940 \u0924\u093F\u092E\u093E\u0939\u0940",
        "\u0926\u0942\u0938\u0930\u0940 \u0924\u093F\u092E\u093E\u0939\u0940",
        "\u0924\u0940\u0938\u0930\u0940 \u0924\u093F\u092E\u093E\u0939\u0940",
        "\u091A\u094C\u0925\u0940 \u0924\u093F\u092E\u093E\u0939\u0940"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
// https://www.unicode.org/cldr/charts/32/summary/hi.html
// CLDR #1617 - #1688
const $ad5b45a210a3f69d$var$monthValues = {
    narrow: [
        "\u091C",
        "\u092B\u093C",
        "\u092E\u093E",
        "\u0905",
        "\u092E\u0908",
        "\u091C\u0942",
        "\u091C\u0941",
        "\u0905\u0917",
        "\u0938\u093F",
        "\u0905\u0915\u094D\u091F\u0942",
        "\u0928",
        "\u0926\u093F"
    ],
    abbreviated: [
        "\u091C\u0928",
        "\u092B\u093C\u0930",
        "\u092E\u093E\u0930\u094D\u091A",
        "\u0905\u092A\u094D\u0930\u0948\u0932",
        "\u092E\u0908",
        "\u091C\u0942\u0928",
        "\u091C\u0941\u0932",
        "\u0905\u0917",
        "\u0938\u093F\u0924",
        "\u0905\u0915\u094D\u091F\u0942",
        "\u0928\u0935",
        "\u0926\u093F\u0938"
    ],
    wide: [
        "\u091C\u0928\u0935\u0930\u0940",
        "\u092B\u093C\u0930\u0935\u0930\u0940",
        "\u092E\u093E\u0930\u094D\u091A",
        "\u0905\u092A\u094D\u0930\u0948\u0932",
        "\u092E\u0908",
        "\u091C\u0942\u0928",
        "\u091C\u0941\u0932\u093E\u0908",
        "\u0905\u0917\u0938\u094D\u0924",
        "\u0938\u093F\u0924\u0902\u092C\u0930",
        "\u0905\u0915\u094D\u091F\u0942\u092C\u0930",
        "\u0928\u0935\u0902\u092C\u0930",
        "\u0926\u093F\u0938\u0902\u092C\u0930"
    ]
};
// CLDR #1689 - #1744
const $ad5b45a210a3f69d$var$dayValues = {
    narrow: [
        "\u0930",
        "\u0938\u094B",
        "\u092E\u0902",
        "\u092C\u0941",
        "\u0917\u0941",
        "\u0936\u0941",
        "\u0936"
    ],
    short: [
        "\u0930",
        "\u0938\u094B",
        "\u092E\u0902",
        "\u092C\u0941",
        "\u0917\u0941",
        "\u0936\u0941",
        "\u0936"
    ],
    abbreviated: [
        "\u0930\u0935\u093F",
        "\u0938\u094B\u092E",
        "\u092E\u0902\u0917\u0932",
        "\u092C\u0941\u0927",
        "\u0917\u0941\u0930\u0941",
        "\u0936\u0941\u0915\u094D\u0930",
        "\u0936\u0928\u093F"
    ],
    wide: [
        "\u0930\u0935\u093F\u0935\u093E\u0930",
        "\u0938\u094B\u092E\u0935\u093E\u0930",
        "\u092E\u0902\u0917\u0932\u0935\u093E\u0930",
        "\u092C\u0941\u0927\u0935\u093E\u0930",
        "\u0917\u0941\u0930\u0941\u0935\u093E\u0930",
        "\u0936\u0941\u0915\u094D\u0930\u0935\u093E\u0930",
        "\u0936\u0928\u093F\u0935\u093E\u0930"
    ]
};
const $ad5b45a210a3f69d$var$dayPeriodValues = {
    narrow: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    abbreviated: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    wide: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    }
};
const $ad5b45a210a3f69d$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    abbreviated: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    wide: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    }
};
const $ad5b45a210a3f69d$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return $ad5b45a210a3f69d$var$numberToLocale(number);
};
function $ad5b45a210a3f69d$var$localeToNumber(locale) {
    const enNumber = locale.toString().replace(/[१२३४५६७८९०]/g, function(match) {
        return $ad5b45a210a3f69d$var$numberValues.number[match];
    });
    return Number(enNumber);
}
function $ad5b45a210a3f69d$var$numberToLocale(enNumber) {
    return enNumber.toString().replace(/\d/g, function(match) {
        return $ad5b45a210a3f69d$var$numberValues.locale[match];
    });
}
const $ad5b45a210a3f69d$var$localize = $ad5b45a210a3f69d$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $ad5b45a210a3f69d$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $ad5b45a210a3f69d$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $ad5b45a210a3f69d$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $ad5b45a210a3f69d$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $ad5b45a210a3f69d$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $ad5b45a210a3f69d$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $ad5b45a210a3f69d$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});


parcelRegister("568r9", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $3b640eaaac12b899$export$cbf60ecb96cbb82f; }, function (v) { return $3b640eaaac12b899$export$cbf60ecb96cbb82f = v; });
var $3b640eaaac12b899$export$cbf60ecb96cbb82f;
"use strict";
$3b640eaaac12b899$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $3b640eaaac12b899$var$dateFormats = {
    full: "EEEE, do MMMM, y",
    long: "do MMMM, y",
    medium: "d MMM, y",
    short: "dd/MM/yyyy"
};
const $3b640eaaac12b899$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $3b640eaaac12b899$var$dateTimeFormats = {
    full: "{{date}} '\u0915\u094B' {{time}}",
    long: "{{date}} '\u0915\u094B' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $3b640eaaac12b899$var$formatLong = $3b640eaaac12b899$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $3b640eaaac12b899$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $3b640eaaac12b899$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $3b640eaaac12b899$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("9Tw5c", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $734223140fdf1e49$export$8fbbfd65594f46a0; }, function (v) { return $734223140fdf1e49$export$8fbbfd65594f46a0 = v; });
var $734223140fdf1e49$export$8fbbfd65594f46a0;
"use strict";
$734223140fdf1e49$export$8fbbfd65594f46a0 = void 0;
const $734223140fdf1e49$var$formatRelativeLocale = {
    lastWeek: "'\u092A\u093F\u091B\u0932\u0947' eeee p",
    yesterday: "'\u0915\u0932' p",
    today: "'\u0906\u091C' p",
    tomorrow: "'\u0915\u0932' p",
    nextWeek: "eeee '\u0915\u094B' p",
    other: "P"
};
const $734223140fdf1e49$var$formatRelative = (token, _date, _baseDate, _options)=>$734223140fdf1e49$var$formatRelativeLocale[token];
$734223140fdf1e49$export$8fbbfd65594f46a0 = $734223140fdf1e49$var$formatRelative;

});

parcelRegister("lhuAO", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $f7e2ea91edaf63ac$export$4659b591c19bdf3d; }, function (v) { return $f7e2ea91edaf63ac$export$4659b591c19bdf3d = v; });
var $f7e2ea91edaf63ac$export$4659b591c19bdf3d;
"use strict";
$f7e2ea91edaf63ac$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");

var $eSLUr = parcelRequire("eSLUr");
const $f7e2ea91edaf63ac$var$matchOrdinalNumberPattern = /^[०१२३४५६७८९]+/i;
const $f7e2ea91edaf63ac$var$parseOrdinalNumberPattern = /^[०१२३४५६७८९]+/i;
const $f7e2ea91edaf63ac$var$matchEraPatterns = {
    narrow: /^(ईसा-पूर्व|ईस्वी)/i,
    abbreviated: /^(ईसा\.?\s?पूर्व\.?|ईसा\.?)/i,
    wide: /^(ईसा-पूर्व|ईसवी पूर्व|ईसवी सन|ईसवी)/i
};
const $f7e2ea91edaf63ac$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $f7e2ea91edaf63ac$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ति[1234]/i,
    wide: /^[1234](पहली|दूसरी|तीसरी|चौथी)? तिमाही/i
};
const $f7e2ea91edaf63ac$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $f7e2ea91edaf63ac$var$matchMonthPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[जफ़माअप्मईजूनजुअगसिअक्तनदि]/i,
    abbreviated: /^(जन|फ़र|मार्च|अप्|मई|जून|जुल|अग|सित|अक्तू|नव|दिस)/i,
    wide: /^(जनवरी|फ़रवरी|मार्च|अप्रैल|मई|जून|जुलाई|अगस्त|सितंबर|अक्तूबर|नवंबर|दिसंबर)/i
};
const $f7e2ea91edaf63ac$var$parseMonthPatterns = {
    narrow: [
        /^ज/i,
        /^फ़/i,
        /^मा/i,
        /^अप्/i,
        /^मई/i,
        /^जू/i,
        /^जु/i,
        /^अग/i,
        /^सि/i,
        /^अक्तू/i,
        /^न/i,
        /^दि/i
    ],
    any: [
        /^जन/i,
        /^फ़/i,
        /^मा/i,
        /^अप्/i,
        /^मई/i,
        /^जू/i,
        /^जु/i,
        /^अग/i,
        /^सि/i,
        /^अक्तू/i,
        /^नव/i,
        /^दिस/i
    ]
};
const $f7e2ea91edaf63ac$var$matchDayPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[रविसोममंगलबुधगुरुशुक्रशनि]/i,
    short: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
    abbreviated: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
    wide: /^(रविवार|सोमवार|मंगलवार|बुधवार|गुरुवार|शुक्रवार|शनिवार)/i
};
const $f7e2ea91edaf63ac$var$parseDayPatterns = {
    narrow: [
        /^रवि/i,
        /^सोम/i,
        /^मंगल/i,
        /^बुध/i,
        /^गुरु/i,
        /^शुक्र/i,
        /^शनि/i
    ],
    any: [
        /^रवि/i,
        /^सोम/i,
        /^मंगल/i,
        /^बुध/i,
        /^गुरु/i,
        /^शुक्र/i,
        /^शनि/i
    ]
};
const $f7e2ea91edaf63ac$var$matchDayPeriodPatterns = {
    narrow: /^(पू|अ|म|द.\?|सु|दो|शा|रा)/i,
    any: /^(पूर्वाह्न|अपराह्न|म|द.\?|सु|दो|शा|रा)/i
};
const $f7e2ea91edaf63ac$var$parseDayPeriodPatterns = {
    any: {
        am: /^पूर्वाह्न/i,
        pm: /^अपराह्न/i,
        midnight: /^मध्य/i,
        noon: /^दो/i,
        morning: /सु/i,
        afternoon: /दो/i,
        evening: /शा/i,
        night: /रा/i
    }
};
const $f7e2ea91edaf63ac$var$match = $f7e2ea91edaf63ac$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $f7e2ea91edaf63ac$var$matchOrdinalNumberPattern,
        parsePattern: $f7e2ea91edaf63ac$var$parseOrdinalNumberPattern,
        valueCallback: $eSLUr.localeToNumber
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $f7e2ea91edaf63ac$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f7e2ea91edaf63ac$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $f7e2ea91edaf63ac$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f7e2ea91edaf63ac$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $f7e2ea91edaf63ac$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f7e2ea91edaf63ac$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $f7e2ea91edaf63ac$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f7e2ea91edaf63ac$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $f7e2ea91edaf63ac$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $f7e2ea91edaf63ac$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("ebKVG", function(module, exports) {

$parcel$export(module.exports, "hr", function () { return $a5467efc3681af4d$export$b4adb3f464574dcf; }, function (v) { return $a5467efc3681af4d$export$b4adb3f464574dcf = v; });
var $a5467efc3681af4d$export$b4adb3f464574dcf;
"use strict";
$a5467efc3681af4d$export$b4adb3f464574dcf = void 0;

var $9anOr = parcelRequire("9anOr");

var $khIvc = parcelRequire("khIvc");

var $a83bf = parcelRequire("a83bf");

var $fC0c6 = parcelRequire("fC0c6");

var $gUL8f = parcelRequire("gUL8f");
/**
 * @category Locales
 * @summary Croatian locale.
 * @language Croatian
 * @iso-639-2 hrv
 * @author Matija Marohnić [@silvenon](https://github.com/silvenon)
 * @author Manico [@manico](https://github.com/manico)
 * @author Ivan Jeržabek [@jerzabek](https://github.com/jerzabek)
 */ const $a5467efc3681af4d$var$hr = $a5467efc3681af4d$export$b4adb3f464574dcf = {
    code: "hr",
    formatDistance: $9anOr.formatDistance,
    formatLong: $khIvc.formatLong,
    formatRelative: $a83bf.formatRelative,
    localize: $fC0c6.localize,
    match: $gUL8f.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("9anOr", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $6ac784e57eb80bc6$export$2c14ff85d6318973; }, function (v) { return $6ac784e57eb80bc6$export$2c14ff85d6318973 = v; });
var $6ac784e57eb80bc6$export$2c14ff85d6318973;
"use strict";
$6ac784e57eb80bc6$export$2c14ff85d6318973 = void 0;
const $6ac784e57eb80bc6$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: "manje od 1 sekunde",
            withPrepositionAgo: "manje od 1 sekunde",
            withPrepositionIn: "manje od 1 sekundu"
        },
        dual: "manje od {{count}} sekunde",
        other: "manje od {{count}} sekundi"
    },
    xSeconds: {
        one: {
            standalone: "1 sekunda",
            withPrepositionAgo: "1 sekunde",
            withPrepositionIn: "1 sekundu"
        },
        dual: "{{count}} sekunde",
        other: "{{count}} sekundi"
    },
    halfAMinute: "pola minute",
    lessThanXMinutes: {
        one: {
            standalone: "manje od 1 minute",
            withPrepositionAgo: "manje od 1 minute",
            withPrepositionIn: "manje od 1 minutu"
        },
        dual: "manje od {{count}} minute",
        other: "manje od {{count}} minuta"
    },
    xMinutes: {
        one: {
            standalone: "1 minuta",
            withPrepositionAgo: "1 minute",
            withPrepositionIn: "1 minutu"
        },
        dual: "{{count}} minute",
        other: "{{count}} minuta"
    },
    aboutXHours: {
        one: {
            standalone: "oko 1 sat",
            withPrepositionAgo: "oko 1 sat",
            withPrepositionIn: "oko 1 sat"
        },
        dual: "oko {{count}} sata",
        other: "oko {{count}} sati"
    },
    xHours: {
        one: {
            standalone: "1 sat",
            withPrepositionAgo: "1 sat",
            withPrepositionIn: "1 sat"
        },
        dual: "{{count}} sata",
        other: "{{count}} sati"
    },
    xDays: {
        one: {
            standalone: "1 dan",
            withPrepositionAgo: "1 dan",
            withPrepositionIn: "1 dan"
        },
        dual: "{{count}} dana",
        other: "{{count}} dana"
    },
    aboutXWeeks: {
        one: {
            standalone: "oko 1 tjedan",
            withPrepositionAgo: "oko 1 tjedan",
            withPrepositionIn: "oko 1 tjedan"
        },
        dual: "oko {{count}} tjedna",
        other: "oko {{count}} tjedana"
    },
    xWeeks: {
        one: {
            standalone: "1 tjedan",
            withPrepositionAgo: "1 tjedan",
            withPrepositionIn: "1 tjedan"
        },
        dual: "{{count}} tjedna",
        other: "{{count}} tjedana"
    },
    aboutXMonths: {
        one: {
            standalone: "oko 1 mjesec",
            withPrepositionAgo: "oko 1 mjesec",
            withPrepositionIn: "oko 1 mjesec"
        },
        dual: "oko {{count}} mjeseca",
        other: "oko {{count}} mjeseci"
    },
    xMonths: {
        one: {
            standalone: "1 mjesec",
            withPrepositionAgo: "1 mjesec",
            withPrepositionIn: "1 mjesec"
        },
        dual: "{{count}} mjeseca",
        other: "{{count}} mjeseci"
    },
    aboutXYears: {
        one: {
            standalone: "oko 1 godinu",
            withPrepositionAgo: "oko 1 godinu",
            withPrepositionIn: "oko 1 godinu"
        },
        dual: "oko {{count}} godine",
        other: "oko {{count}} godina"
    },
    xYears: {
        one: {
            standalone: "1 godina",
            withPrepositionAgo: "1 godine",
            withPrepositionIn: "1 godinu"
        },
        dual: "{{count}} godine",
        other: "{{count}} godina"
    },
    overXYears: {
        one: {
            standalone: "preko 1 godinu",
            withPrepositionAgo: "preko 1 godinu",
            withPrepositionIn: "preko 1 godinu"
        },
        dual: "preko {{count}} godine",
        other: "preko {{count}} godina"
    },
    almostXYears: {
        one: {
            standalone: "gotovo 1 godinu",
            withPrepositionAgo: "gotovo 1 godinu",
            withPrepositionIn: "gotovo 1 godinu"
        },
        dual: "gotovo {{count}} godine",
        other: "gotovo {{count}} godina"
    }
};
const $6ac784e57eb80bc6$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $6ac784e57eb80bc6$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) {
        if (options?.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== "1" // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "za " + result;
        else return "prije " + result;
    }
    return result;
};
$6ac784e57eb80bc6$export$2c14ff85d6318973 = $6ac784e57eb80bc6$var$formatDistance;

});

parcelRegister("khIvc", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $ec47ea67d726ebca$export$cbf60ecb96cbb82f; }, function (v) { return $ec47ea67d726ebca$export$cbf60ecb96cbb82f = v; });
var $ec47ea67d726ebca$export$cbf60ecb96cbb82f;
"use strict";
$ec47ea67d726ebca$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $ec47ea67d726ebca$var$dateFormats = {
    full: "EEEE, d. MMMM y.",
    long: "d. MMMM y.",
    medium: "d. MMM y.",
    short: "dd. MM. y."
};
const $ec47ea67d726ebca$var$timeFormats = {
    full: "HH:mm:ss (zzzz)",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $ec47ea67d726ebca$var$dateTimeFormats = {
    full: "{{date}} 'u' {{time}}",
    long: "{{date}} 'u' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $ec47ea67d726ebca$var$formatLong = $ec47ea67d726ebca$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $ec47ea67d726ebca$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $ec47ea67d726ebca$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $ec47ea67d726ebca$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("a83bf", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $75fd1e473544356e$export$8fbbfd65594f46a0; }, function (v) { return $75fd1e473544356e$export$8fbbfd65594f46a0 = v; });
var $75fd1e473544356e$export$8fbbfd65594f46a0;
"use strict";
$75fd1e473544356e$export$8fbbfd65594f46a0 = void 0;
const $75fd1e473544356e$var$formatRelativeLocale = {
    lastWeek: (date)=>{
        switch(date.getDay()){
            case 0:
                return "'pro\u0161lu nedjelju u' p";
            case 3:
                return "'pro\u0161lu srijedu u' p";
            case 6:
                return "'pro\u0161lu subotu u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    yesterday: "'ju\u010Der u' p",
    today: "'danas u' p",
    tomorrow: "'sutra u' p",
    nextWeek: (date)=>{
        switch(date.getDay()){
            case 0:
                return "'idu\u0107u nedjelju u' p";
            case 3:
                return "'idu\u0107u srijedu u' p";
            case 6:
                return "'idu\u0107u subotu u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    other: "P"
};
const $75fd1e473544356e$var$formatRelative = (token, date, _baseDate, _options)=>{
    const format = $75fd1e473544356e$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
$75fd1e473544356e$export$8fbbfd65594f46a0 = $75fd1e473544356e$var$formatRelative;

});

parcelRegister("fC0c6", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $b5da8e33b69e8009$export$b3bd0bc58e36cd63; }, function (v) { return $b5da8e33b69e8009$export$b3bd0bc58e36cd63 = v; });
var $b5da8e33b69e8009$export$b3bd0bc58e36cd63;
"use strict";
$b5da8e33b69e8009$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $b5da8e33b69e8009$var$eraValues = {
    narrow: [
        "pr.n.e.",
        "AD"
    ],
    abbreviated: [
        "pr. Kr.",
        "po. Kr."
    ],
    wide: [
        "Prije Krista",
        "Poslije Krista"
    ]
};
const $b5da8e33b69e8009$var$quarterValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4."
    ],
    abbreviated: [
        "1. kv.",
        "2. kv.",
        "3. kv.",
        "4. kv."
    ],
    wide: [
        "1. kvartal",
        "2. kvartal",
        "3. kvartal",
        "4. kvartal"
    ]
};
const $b5da8e33b69e8009$var$monthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "sij",
        "velj",
        "o\u017Eu",
        "tra",
        "svi",
        "lip",
        "srp",
        "kol",
        "ruj",
        "lis",
        "stu",
        "pro"
    ],
    wide: [
        "sije\u010Danj",
        "velja\u010Da",
        "o\u017Eujak",
        "travanj",
        "svibanj",
        "lipanj",
        "srpanj",
        "kolovoz",
        "rujan",
        "listopad",
        "studeni",
        "prosinac"
    ]
};
const $b5da8e33b69e8009$var$formattingMonthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "sij",
        "velj",
        "o\u017Eu",
        "tra",
        "svi",
        "lip",
        "srp",
        "kol",
        "ruj",
        "lis",
        "stu",
        "pro"
    ],
    wide: [
        "sije\u010Dnja",
        "velja\u010De",
        "o\u017Eujka",
        "travnja",
        "svibnja",
        "lipnja",
        "srpnja",
        "kolovoza",
        "rujna",
        "listopada",
        "studenog",
        "prosinca"
    ]
};
const $b5da8e33b69e8009$var$dayValues = {
    narrow: [
        "N",
        "P",
        "U",
        "S",
        "\u010C",
        "P",
        "S"
    ],
    short: [
        "ned",
        "pon",
        "uto",
        "sri",
        "\u010Det",
        "pet",
        "sub"
    ],
    abbreviated: [
        "ned",
        "pon",
        "uto",
        "sri",
        "\u010Det",
        "pet",
        "sub"
    ],
    wide: [
        "nedjelja",
        "ponedjeljak",
        "utorak",
        "srijeda",
        "\u010Detvrtak",
        "petak",
        "subota"
    ]
};
const $b5da8e33b69e8009$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutro",
        afternoon: "popodne",
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutro",
        afternoon: "popodne",
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutro",
        afternoon: "poslije podne",
        evening: "nave\u010Der",
        night: "no\u0107u"
    }
};
const $b5da8e33b69e8009$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutro",
        afternoon: "popodne",
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutro",
        afternoon: "popodne",
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutro",
        afternoon: "poslije podne",
        evening: "nave\u010Der",
        night: "no\u0107u"
    }
};
const $b5da8e33b69e8009$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $b5da8e33b69e8009$var$localize = $b5da8e33b69e8009$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $b5da8e33b69e8009$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $b5da8e33b69e8009$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $b5da8e33b69e8009$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $b5da8e33b69e8009$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $b5da8e33b69e8009$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $b5da8e33b69e8009$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $b5da8e33b69e8009$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $b5da8e33b69e8009$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("gUL8f", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $c5066fbc062f8645$export$4659b591c19bdf3d; }, function (v) { return $c5066fbc062f8645$export$4659b591c19bdf3d = v; });
var $c5066fbc062f8645$export$4659b591c19bdf3d;
"use strict";
$c5066fbc062f8645$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $c5066fbc062f8645$var$matchOrdinalNumberPattern = /^(\d+)\./i;
const $c5066fbc062f8645$var$parseOrdinalNumberPattern = /\d+/i;
const $c5066fbc062f8645$var$matchEraPatterns = {
    narrow: /^(pr\.n\.e\.|AD)/i,
    abbreviated: /^(pr\.\s?Kr\.|po\.\s?Kr\.)/i,
    wide: /^(Prije Krista|prije nove ere|Poslije Krista|nova era)/i
};
const $c5066fbc062f8645$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|nova)/i
    ]
};
const $c5066fbc062f8645$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?kv\.?/i,
    wide: /^[1234]\. kvartal/i
};
const $c5066fbc062f8645$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $c5066fbc062f8645$var$matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(sij|velj|(ožu|ozu)|tra|svi|lip|srp|kol|ruj|lis|stu|pro)/i,
    wide: /^((siječanj|siječnja|sijecanj|sijecnja)|(veljača|veljače|veljaca|veljace)|(ožujak|ožujka|ozujak|ozujka)|(travanj|travnja)|(svibanj|svibnja)|(lipanj|lipnja)|(srpanj|srpnja)|(kolovoz|kolovoza)|(rujan|rujna)|(listopad|listopada)|(studeni|studenog)|(prosinac|prosinca))/i
};
const $c5066fbc062f8645$var$parseMonthPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i,
        /8/i,
        /9/i,
        /10/i,
        /11/i,
        /12/i
    ],
    abbreviated: [
        /^sij/i,
        /^velj/i,
        /^(ožu|ozu)/i,
        /^tra/i,
        /^svi/i,
        /^lip/i,
        /^srp/i,
        /^kol/i,
        /^ruj/i,
        /^lis/i,
        /^stu/i,
        /^pro/i
    ],
    wide: [
        /^sij/i,
        /^velj/i,
        /^(ožu|ozu)/i,
        /^tra/i,
        /^svi/i,
        /^lip/i,
        /^srp/i,
        /^kol/i,
        /^ruj/i,
        /^lis/i,
        /^stu/i,
        /^pro/i
    ]
};
const $c5066fbc062f8645$var$matchDayPatterns = {
    narrow: /^[npusčc]/i,
    short: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
    abbreviated: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
    wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
};
const $c5066fbc062f8645$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $c5066fbc062f8645$var$matchDayPeriodPatterns = {
    any: /^(am|pm|ponoc|ponoć|(po)?podne|navecer|navečer|noću|poslije podne|ujutro)/i
};
const $c5066fbc062f8645$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(poslije\s|po)+podne/i,
        evening: /(navece|naveče)/i,
        night: /(nocu|noću)/i
    }
};
const $c5066fbc062f8645$var$match = $c5066fbc062f8645$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $c5066fbc062f8645$var$matchOrdinalNumberPattern,
        parsePattern: $c5066fbc062f8645$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $c5066fbc062f8645$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c5066fbc062f8645$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $c5066fbc062f8645$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c5066fbc062f8645$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $c5066fbc062f8645$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c5066fbc062f8645$var$parseMonthPatterns,
        defaultParseWidth: "wide"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $c5066fbc062f8645$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c5066fbc062f8645$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $c5066fbc062f8645$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $c5066fbc062f8645$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("1TdKR", function(module, exports) {

$parcel$export(module.exports, "ht", function () { return $160598e771c2fade$export$f1db1a98c1e73c14; }, function (v) { return $160598e771c2fade$export$f1db1a98c1e73c14 = v; });
var $160598e771c2fade$export$f1db1a98c1e73c14;
"use strict";
$160598e771c2fade$export$f1db1a98c1e73c14 = void 0;

var $hoAOn = parcelRequire("hoAOn");

var $8n3kp = parcelRequire("8n3kp");

var $djtG9 = parcelRequire("djtG9");

var $9dB3v = parcelRequire("9dB3v");

var $ljClf = parcelRequire("ljClf");
/**
 * @category Locales
 * @summary Haitian Creole locale.
 * @language Haitian Creole
 * @iso-639-2 hat
 * @author Rubens Mariuzzo [@rmariuzzo](https://github.com/rmariuzzo)
 * @author Watson Marcelain [@watsongm24](https://github.com/watsongm24)
 */ const $160598e771c2fade$var$ht = $160598e771c2fade$export$f1db1a98c1e73c14 = {
    code: "ht",
    formatDistance: $hoAOn.formatDistance,
    formatLong: $8n3kp.formatLong,
    formatRelative: $djtG9.formatRelative,
    localize: $9dB3v.localize,
    match: $ljClf.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("hoAOn", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $caa13b92c75e2d66$export$2c14ff85d6318973; }, function (v) { return $caa13b92c75e2d66$export$2c14ff85d6318973 = v; });
var $caa13b92c75e2d66$export$2c14ff85d6318973;
"use strict";
$caa13b92c75e2d66$export$2c14ff85d6318973 = void 0;
const $caa13b92c75e2d66$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mwens pase yon segond",
        other: "mwens pase {{count}} segond"
    },
    xSeconds: {
        one: "1 segond",
        other: "{{count}} segond"
    },
    halfAMinute: "30 segond",
    lessThanXMinutes: {
        one: "mwens pase yon minit",
        other: "mwens pase {{count}} minit"
    },
    xMinutes: {
        one: "1 minit",
        other: "{{count}} minit"
    },
    aboutXHours: {
        one: "anviwon in\xe8",
        other: "anviwon {{count}} \xe8"
    },
    xHours: {
        one: "1 l\xe8",
        other: "{{count}} l\xe8"
    },
    xDays: {
        one: "1 jou",
        other: "{{count}} jou"
    },
    aboutXWeeks: {
        one: "anviwon 1 sem\xe8n",
        other: "anviwon {{count}} sem\xe8n"
    },
    xWeeks: {
        one: "1 sem\xe8n",
        other: "{{count}} sem\xe8n"
    },
    aboutXMonths: {
        one: "anviwon 1 mwa",
        other: "anviwon {{count}} mwa"
    },
    xMonths: {
        one: "1 mwa",
        other: "{{count}} mwa"
    },
    aboutXYears: {
        one: "anviwon 1 an",
        other: "anviwon {{count}} an"
    },
    xYears: {
        one: "1 an",
        other: "{{count}} an"
    },
    overXYears: {
        one: "plis pase 1 an",
        other: "plis pase {{count}} an"
    },
    almostXYears: {
        one: "pr\xe8ske 1 an",
        other: "pr\xe8ske {{count}} an"
    }
};
const $caa13b92c75e2d66$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $caa13b92c75e2d66$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "nan " + result;
        else return "sa f\xe8 " + result;
    }
    return result;
};
$caa13b92c75e2d66$export$2c14ff85d6318973 = $caa13b92c75e2d66$var$formatDistance;

});

parcelRegister("8n3kp", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $61830da381efc37b$export$cbf60ecb96cbb82f; }, function (v) { return $61830da381efc37b$export$cbf60ecb96cbb82f = v; });
var $61830da381efc37b$export$cbf60ecb96cbb82f;
"use strict";
$61830da381efc37b$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $61830da381efc37b$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
const $61830da381efc37b$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $61830da381efc37b$var$dateTimeFormats = {
    full: "{{date}} 'nan l\xe8' {{time}}",
    long: "{{date}} 'nan l\xe8' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $61830da381efc37b$var$formatLong = $61830da381efc37b$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $61830da381efc37b$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $61830da381efc37b$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $61830da381efc37b$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("djtG9", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $9b14124e832cace6$export$8fbbfd65594f46a0; }, function (v) { return $9b14124e832cace6$export$8fbbfd65594f46a0 = v; });
var $9b14124e832cace6$export$8fbbfd65594f46a0;
"use strict";
$9b14124e832cace6$export$8fbbfd65594f46a0 = void 0;
const $9b14124e832cace6$var$formatRelativeLocale = {
    lastWeek: "eeee 'pase nan l\xe8' p",
    yesterday: "'y\xe8 nan l\xe8' p",
    today: "'jodi a' p",
    tomorrow: "'demen nan l\xe8' p'",
    nextWeek: "eeee 'pwochen nan l\xe8' p",
    other: "P"
};
const $9b14124e832cace6$var$formatRelative = (token, _date, _baseDate, _options)=>$9b14124e832cace6$var$formatRelativeLocale[token];
$9b14124e832cace6$export$8fbbfd65594f46a0 = $9b14124e832cace6$var$formatRelative;

});

parcelRegister("9dB3v", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $6b62126780a8904a$export$b3bd0bc58e36cd63; }, function (v) { return $6b62126780a8904a$export$b3bd0bc58e36cd63 = v; });
var $6b62126780a8904a$export$b3bd0bc58e36cd63;
"use strict";
$6b62126780a8904a$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $6b62126780a8904a$var$eraValues = {
    narrow: [
        "av. J.-K",
        "ap. J.-K"
    ],
    abbreviated: [
        "av. J.-K",
        "ap. J.-K"
    ],
    wide: [
        "anvan Jezi Kris",
        "apre Jezi Kris"
    ]
};
const $6b62126780a8904a$var$quarterValues = {
    narrow: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    abbreviated: [
        "1ye trim.",
        "2y\xe8m trim.",
        "3y\xe8m trim.",
        "4y\xe8m trim."
    ],
    wide: [
        "1ye trim\xe8s",
        "2y\xe8m trim\xe8s",
        "3y\xe8m trim\xe8s",
        "4y\xe8m trim\xe8s"
    ]
};
const $6b62126780a8904a$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "O",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "janv.",
        "fevr.",
        "mas",
        "avr.",
        "me",
        "jen",
        "jiy\xe8",
        "out",
        "sept.",
        "okt.",
        "nov.",
        "des."
    ],
    wide: [
        "janvye",
        "fevrye",
        "mas",
        "avril",
        "me",
        "jen",
        "jiy\xe8",
        "out",
        "septanm",
        "okt\xf2b",
        "novanm",
        "desanm"
    ]
};
const $6b62126780a8904a$var$dayValues = {
    narrow: [
        "D",
        "L",
        "M",
        "M",
        "J",
        "V",
        "S"
    ],
    short: [
        "di",
        "le",
        "ma",
        "m\xe8",
        "je",
        "va",
        "sa"
    ],
    abbreviated: [
        "dim.",
        "len.",
        "mad.",
        "m\xe8k.",
        "jed.",
        "van.",
        "sam."
    ],
    wide: [
        "dimanch",
        "lendi",
        "madi",
        "m\xe8kredi",
        "jedi",
        "vandredi",
        "samdi"
    ]
};
const $6b62126780a8904a$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "minwit",
        noon: "midi",
        morning: "mat.",
        afternoon: "ap.m.",
        evening: "swa",
        night: "mat."
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "minwit",
        noon: "midi",
        morning: "maten",
        afternoon: "apr\xe8midi",
        evening: "swa",
        night: "maten"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "minwit",
        noon: "midi",
        morning: "nan maten",
        afternoon: "nan apr\xe8midi",
        evening: "nan asw\xe8",
        night: "nan maten"
    }
};
const $6b62126780a8904a$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    if (number === 0) return String(number);
    const suffix = number === 1 ? "ye" : "y\xe8m";
    return number + suffix;
};
const $6b62126780a8904a$var$localize = $6b62126780a8904a$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $6b62126780a8904a$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $6b62126780a8904a$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $6b62126780a8904a$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $6b62126780a8904a$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $6b62126780a8904a$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $6b62126780a8904a$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};

});

parcelRegister("ljClf", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $f8491d294e6deac4$export$4659b591c19bdf3d; }, function (v) { return $f8491d294e6deac4$export$4659b591c19bdf3d = v; });
var $f8491d294e6deac4$export$4659b591c19bdf3d;
"use strict";
$f8491d294e6deac4$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $f8491d294e6deac4$var$matchOrdinalNumberPattern = /^(\d+)(ye|yèm)?/i;
const $f8491d294e6deac4$var$parseOrdinalNumberPattern = /\d+/i;
const $f8491d294e6deac4$var$matchEraPatterns = {
    narrow: /^(av\.J\.K|ap\.J\.K|ap\.J\.-K)/i,
    abbreviated: /^(av\.J\.-K|av\.J-K|apr\.J\.-K|apr\.J-K|ap\.J-K)/i,
    wide: /^(avan Jezi Kris|apre Jezi Kris)/i
};
const $f8491d294e6deac4$var$parseEraPatterns = {
    any: [
        /^av/i,
        /^ap/i
    ]
};
const $f8491d294e6deac4$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^t[1234]/i,
    wide: /^[1234](ye|yèm)? trimès/i
};
const $f8491d294e6deac4$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $f8491d294e6deac4$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|fevr|mas|avr|me|jen|jiyè|out|sept|okt|nov|des)\.?/i,
    wide: /^(janvye|fevrye|mas|avril|me|jen|jiyè|out|septanm|oktòb|novanm|desanm)/i
};
const $f8491d294e6deac4$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^o/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^ma/i,
        /^av/i,
        /^me/i,
        /^je/i,
        /^ji/i,
        /^ou/i,
        /^s/i,
        /^ok/i,
        /^n/i,
        /^d/i
    ]
};
const $f8491d294e6deac4$var$matchDayPatterns = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|le|ma|me|je|va|sa)/i,
    abbreviated: /^(dim|len|mad|mèk|jed|van|sam)\.?/i,
    wide: /^(dimanch|lendi|madi|mèkredi|jedi|vandredi|samdi)/i
};
const $f8491d294e6deac4$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^di/i,
        /^le/i,
        /^ma/i,
        /^mè/i,
        /^je/i,
        /^va/i,
        /^sa/i
    ]
};
const $f8491d294e6deac4$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|minwit|midi|mat\.?|ap\.?m\.?|swa)/i,
    any: /^([ap]\.?\s?m\.?|nan maten|nan aprèmidi|nan aswè)/i
};
const $f8491d294e6deac4$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /sw/i,
        night: /nwit/i
    }
};
const $f8491d294e6deac4$var$match = $f8491d294e6deac4$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $f8491d294e6deac4$var$matchOrdinalNumberPattern,
        parsePattern: $f8491d294e6deac4$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $f8491d294e6deac4$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f8491d294e6deac4$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $f8491d294e6deac4$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f8491d294e6deac4$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $f8491d294e6deac4$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f8491d294e6deac4$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $f8491d294e6deac4$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f8491d294e6deac4$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $f8491d294e6deac4$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $f8491d294e6deac4$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("2bmSz", function(module, exports) {

$parcel$export(module.exports, "hu", function () { return $196e5b2d93c7476b$export$9901d21957972d53; }, function (v) { return $196e5b2d93c7476b$export$9901d21957972d53 = v; });
var $196e5b2d93c7476b$export$9901d21957972d53;
"use strict";
$196e5b2d93c7476b$export$9901d21957972d53 = void 0;

var $6VeVb = parcelRequire("6VeVb");

var $6exO5 = parcelRequire("6exO5");

var $63fiR = parcelRequire("63fiR");

var $034vG = parcelRequire("034vG");

var $lOpD9 = parcelRequire("lOpD9");
/**
 * @category Locales
 * @summary Hungarian locale.
 * @language Hungarian
 * @iso-639-2 hun
 * @author Pavlo Shpak [@pshpak](https://github.com/pshpak)
 * @author Eduardo Pardo [@eduardopsll](https://github.com/eduardopsll)
 * @author Zoltan Szepesi [@twodcube](https://github.com/twodcube)
 */ const $196e5b2d93c7476b$var$hu = $196e5b2d93c7476b$export$9901d21957972d53 = {
    code: "hu",
    formatDistance: $6VeVb.formatDistance,
    formatLong: $6exO5.formatLong,
    formatRelative: $63fiR.formatRelative,
    localize: $034vG.localize,
    match: $lOpD9.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("6VeVb", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $50a3a400798cb968$export$2c14ff85d6318973; }, function (v) { return $50a3a400798cb968$export$2c14ff85d6318973 = v; });
var $50a3a400798cb968$export$2c14ff85d6318973;
"use strict";
$50a3a400798cb968$export$2c14ff85d6318973 = void 0;
const $50a3a400798cb968$var$translations = {
    about: "k\xf6r\xfclbel\xfcl",
    over: "t\xf6bb mint",
    almost: "majdnem",
    lessthan: "kevesebb mint"
};
const $50a3a400798cb968$var$withoutSuffixes = {
    xseconds: " m\xe1sodperc",
    halfaminute: "f\xe9l perc",
    xminutes: " perc",
    xhours: " \xf3ra",
    xdays: " nap",
    xweeks: " h\xe9t",
    xmonths: " h\xf3nap",
    xyears: " \xe9v"
};
const $50a3a400798cb968$var$withSuffixes = {
    xseconds: {
        "-1": " m\xe1sodperccel ezel\u0151tt",
        1: " m\xe1sodperc m\xfalva",
        0: " m\xe1sodperce"
    },
    halfaminute: {
        "-1": "f\xe9l perccel ezel\u0151tt",
        1: "f\xe9l perc m\xfalva",
        0: "f\xe9l perce"
    },
    xminutes: {
        "-1": " perccel ezel\u0151tt",
        1: " perc m\xfalva",
        0: " perce"
    },
    xhours: {
        "-1": " \xf3r\xe1val ezel\u0151tt",
        1: " \xf3ra m\xfalva",
        0: " \xf3r\xe1ja"
    },
    xdays: {
        "-1": " nappal ezel\u0151tt",
        1: " nap m\xfalva",
        0: " napja"
    },
    xweeks: {
        "-1": " h\xe9ttel ezel\u0151tt",
        1: " h\xe9t m\xfalva",
        0: " hete"
    },
    xmonths: {
        "-1": " h\xf3nappal ezel\u0151tt",
        1: " h\xf3nap m\xfalva",
        0: " h\xf3napja"
    },
    xyears: {
        "-1": " \xe9vvel ezel\u0151tt",
        1: " \xe9v m\xfalva",
        0: " \xe9ve"
    }
};
const $50a3a400798cb968$var$formatDistance = (token, count, options)=>{
    const adverb = token.match(/about|over|almost|lessthan/i);
    const unit = adverb ? token.replace(adverb[0], "") : token;
    const addSuffix = options?.addSuffix === true;
    const key = unit.toLowerCase();
    const comparison = options?.comparison || 0;
    const translated = addSuffix ? $50a3a400798cb968$var$withSuffixes[key][comparison] : $50a3a400798cb968$var$withoutSuffixes[key];
    let result = key === "halfaminute" ? translated : count + translated;
    if (adverb) {
        const adv = adverb[0].toLowerCase();
        result = $50a3a400798cb968$var$translations[adv] + " " + result;
    }
    return result;
};
$50a3a400798cb968$export$2c14ff85d6318973 = $50a3a400798cb968$var$formatDistance;

});

parcelRegister("6exO5", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $489e4636c5fd8800$export$cbf60ecb96cbb82f; }, function (v) { return $489e4636c5fd8800$export$cbf60ecb96cbb82f = v; });
var $489e4636c5fd8800$export$cbf60ecb96cbb82f;
"use strict";
$489e4636c5fd8800$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $489e4636c5fd8800$var$dateFormats = {
    full: "y. MMMM d., EEEE",
    long: "y. MMMM d.",
    medium: "y. MMM d.",
    short: "y. MM. dd."
};
const $489e4636c5fd8800$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $489e4636c5fd8800$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $489e4636c5fd8800$var$formatLong = $489e4636c5fd8800$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $489e4636c5fd8800$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $489e4636c5fd8800$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $489e4636c5fd8800$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("63fiR", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $467ee4c47da8b4a0$export$8fbbfd65594f46a0; }, function (v) { return $467ee4c47da8b4a0$export$8fbbfd65594f46a0 = v; });
var $467ee4c47da8b4a0$export$8fbbfd65594f46a0;
"use strict";
$467ee4c47da8b4a0$export$8fbbfd65594f46a0 = void 0;
const $467ee4c47da8b4a0$var$accusativeWeekdays = [
    "vas\xe1rnap",
    "h\xe9tf\u0151n",
    "kedden",
    "szerd\xe1n",
    "cs\xfct\xf6rt\xf6k\xf6n",
    "p\xe9nteken",
    "szombaton"
];
function $467ee4c47da8b4a0$var$week(isFuture) {
    return (date)=>{
        const weekday = $467ee4c47da8b4a0$var$accusativeWeekdays[date.getDay()];
        const prefix = isFuture ? "" : "'m\xfalt' ";
        return `${prefix}'${weekday}' p'-kor'`;
    };
}
const $467ee4c47da8b4a0$var$formatRelativeLocale = {
    lastWeek: $467ee4c47da8b4a0$var$week(false),
    yesterday: "'tegnap' p'-kor'",
    today: "'ma' p'-kor'",
    tomorrow: "'holnap' p'-kor'",
    nextWeek: $467ee4c47da8b4a0$var$week(true),
    other: "P"
};
const $467ee4c47da8b4a0$var$formatRelative = (token, date)=>{
    const format = $467ee4c47da8b4a0$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
$467ee4c47da8b4a0$export$8fbbfd65594f46a0 = $467ee4c47da8b4a0$var$formatRelative;

});

parcelRegister("034vG", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $0093c7816a99b307$export$b3bd0bc58e36cd63; }, function (v) { return $0093c7816a99b307$export$b3bd0bc58e36cd63 = v; });
var $0093c7816a99b307$export$b3bd0bc58e36cd63;
"use strict";
$0093c7816a99b307$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $0093c7816a99b307$var$eraValues = {
    narrow: [
        "ie.",
        "isz."
    ],
    abbreviated: [
        "i. e.",
        "i. sz."
    ],
    wide: [
        "Krisztus el\u0151tt",
        "id\u0151sz\xe1m\xedt\xe1sunk szerint"
    ]
};
const $0093c7816a99b307$var$quarterValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4."
    ],
    abbreviated: [
        "1. n.\xe9v",
        "2. n.\xe9v",
        "3. n.\xe9v",
        "4. n.\xe9v"
    ],
    wide: [
        "1. negyed\xe9v",
        "2. negyed\xe9v",
        "3. negyed\xe9v",
        "4. negyed\xe9v"
    ]
};
const $0093c7816a99b307$var$formattingQuarterValues = {
    narrow: [
        "I.",
        "II.",
        "III.",
        "IV."
    ],
    abbreviated: [
        "I. n.\xe9v",
        "II. n.\xe9v",
        "III. n.\xe9v",
        "IV. n.\xe9v"
    ],
    wide: [
        "I. negyed\xe9v",
        "II. negyed\xe9v",
        "III. negyed\xe9v",
        "IV. negyed\xe9v"
    ]
};
const $0093c7816a99b307$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "\xc1",
        "M",
        "J",
        "J",
        "A",
        "Sz",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "febr.",
        "m\xe1rc.",
        "\xe1pr.",
        "m\xe1j.",
        "j\xfan.",
        "j\xfal.",
        "aug.",
        "szept.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "janu\xe1r",
        "febru\xe1r",
        "m\xe1rcius",
        "\xe1prilis",
        "m\xe1jus",
        "j\xfanius",
        "j\xfalius",
        "augusztus",
        "szeptember",
        "okt\xf3ber",
        "november",
        "december"
    ]
};
const $0093c7816a99b307$var$dayValues = {
    narrow: [
        "V",
        "H",
        "K",
        "Sz",
        "Cs",
        "P",
        "Sz"
    ],
    short: [
        "V",
        "H",
        "K",
        "Sze",
        "Cs",
        "P",
        "Szo"
    ],
    abbreviated: [
        "V",
        "H",
        "K",
        "Sze",
        "Cs",
        "P",
        "Szo"
    ],
    wide: [
        "vas\xe1rnap",
        "h\xe9tf\u0151",
        "kedd",
        "szerda",
        "cs\xfct\xf6rt\xf6k",
        "p\xe9ntek",
        "szombat"
    ]
};
const $0093c7816a99b307$var$dayPeriodValues = {
    narrow: {
        am: "de.",
        pm: "du.",
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: "reggel",
        afternoon: "du.",
        evening: "este",
        night: "\xe9jjel"
    },
    abbreviated: {
        am: "de.",
        pm: "du.",
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: "reggel",
        afternoon: "du.",
        evening: "este",
        night: "\xe9jjel"
    },
    wide: {
        am: "de.",
        pm: "du.",
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: "reggel",
        afternoon: "d\xe9lut\xe1n",
        evening: "este",
        night: "\xe9jjel"
    }
};
const $0093c7816a99b307$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $0093c7816a99b307$var$localize = $0093c7816a99b307$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $0093c7816a99b307$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $0093c7816a99b307$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $0093c7816a99b307$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1,
        formattingValues: $0093c7816a99b307$var$formattingQuarterValues,
        defaultFormattingWidth: "wide"
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $0093c7816a99b307$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $0093c7816a99b307$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $0093c7816a99b307$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};

});

parcelRegister("lOpD9", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $fe122625ea6b1eda$export$4659b591c19bdf3d; }, function (v) { return $fe122625ea6b1eda$export$4659b591c19bdf3d = v; });
var $fe122625ea6b1eda$export$4659b591c19bdf3d;
"use strict";
$fe122625ea6b1eda$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $fe122625ea6b1eda$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
const $fe122625ea6b1eda$var$parseOrdinalNumberPattern = /\d+/i;
const $fe122625ea6b1eda$var$matchEraPatterns = {
    narrow: /^(ie\.|isz\.)/i,
    abbreviated: /^(i\.\s?e\.?|b?\s?c\s?e|i\.\s?sz\.?)/i,
    wide: /^(Krisztus előtt|időszámításunk előtt|időszámításunk szerint|i\. sz\.)/i
};
const $fe122625ea6b1eda$var$parseEraPatterns = {
    narrow: [
        /ie/i,
        /isz/i
    ],
    abbreviated: [
        /^(i\.?\s?e\.?|b\s?ce)/i,
        /^(i\.?\s?sz\.?|c\s?e)/i
    ],
    any: [
        /előtt/i,
        /(szerint|i. sz.)/i
    ]
};
const $fe122625ea6b1eda$var$matchQuarterPatterns = {
    narrow: /^[1234]\.?/i,
    abbreviated: /^[1234]?\.?\s?n\.év/i,
    wide: /^([1234]|I|II|III|IV)?\.?\s?negyedév/i
};
const $fe122625ea6b1eda$var$parseQuarterPatterns = {
    any: [
        /1|I$/i,
        /2|II$/i,
        /3|III/i,
        /4|IV/i
    ]
};
const $fe122625ea6b1eda$var$matchMonthPatterns = {
    narrow: /^[jfmaásond]|sz/i,
    abbreviated: /^(jan\.?|febr\.?|márc\.?|ápr\.?|máj\.?|jún\.?|júl\.?|aug\.?|szept\.?|okt\.?|nov\.?|dec\.?)/i,
    wide: /^(január|február|március|április|május|június|július|augusztus|szeptember|október|november|december)/i
};
const $fe122625ea6b1eda$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a|á/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s|sz/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^már/i,
        /^áp/i,
        /^máj/i,
        /^jún/i,
        /^júl/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $fe122625ea6b1eda$var$matchDayPatterns = {
    narrow: /^([vhkpc]|sz|cs|sz)/i,
    short: /^([vhkp]|sze|cs|szo)/i,
    abbreviated: /^([vhkp]|sze|cs|szo)/i,
    wide: /^(vasárnap|hétfő|kedd|szerda|csütörtök|péntek|szombat)/i
};
const $fe122625ea6b1eda$var$parseDayPatterns = {
    narrow: [
        /^v/i,
        /^h/i,
        /^k/i,
        /^sz/i,
        /^c/i,
        /^p/i,
        /^sz/i
    ],
    any: [
        /^v/i,
        /^h/i,
        /^k/i,
        /^sze/i,
        /^c/i,
        /^p/i,
        /^szo/i
    ]
};
const $fe122625ea6b1eda$var$matchDayPeriodPatterns = {
    any: /^((de|du)\.?|éjfél|délután|dél|reggel|este|éjjel)/i
};
const $fe122625ea6b1eda$var$parseDayPeriodPatterns = {
    any: {
        am: /^de\.?/i,
        pm: /^du\.?/i,
        midnight: /^éjf/i,
        noon: /^dé/i,
        morning: /reg/i,
        afternoon: /^délu\.?/i,
        evening: /es/i,
        night: /éjj/i
    }
};
const $fe122625ea6b1eda$var$match = $fe122625ea6b1eda$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $fe122625ea6b1eda$var$matchOrdinalNumberPattern,
        parsePattern: $fe122625ea6b1eda$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $fe122625ea6b1eda$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fe122625ea6b1eda$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $fe122625ea6b1eda$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fe122625ea6b1eda$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $fe122625ea6b1eda$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fe122625ea6b1eda$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $fe122625ea6b1eda$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fe122625ea6b1eda$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $fe122625ea6b1eda$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $fe122625ea6b1eda$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("kg90j", function(module, exports) {

$parcel$export(module.exports, "hy", function () { return $ebfc494a46a853a0$export$2fe4a56bcaea74cb; }, function (v) { return $ebfc494a46a853a0$export$2fe4a56bcaea74cb = v; });
var $ebfc494a46a853a0$export$2fe4a56bcaea74cb;
"use strict";
$ebfc494a46a853a0$export$2fe4a56bcaea74cb = void 0;

var $8Oz4Q = parcelRequire("8Oz4Q");

var $5rF5i = parcelRequire("5rF5i");

var $hvZZ8 = parcelRequire("hvZZ8");

var $2RipV = parcelRequire("2RipV");

var $4kbqx = parcelRequire("4kbqx");
/**
 * @category Locales
 * @summary Armenian locale
 * @language Armenian
 * @iso-639-2 arm
 * @author Alex Igityan [@alexigityan](https://github.com/alexigityan)
 */ const $ebfc494a46a853a0$var$hy = $ebfc494a46a853a0$export$2fe4a56bcaea74cb = {
    code: "hy",
    formatDistance: $8Oz4Q.formatDistance,
    formatLong: $5rF5i.formatLong,
    formatRelative: $hvZZ8.formatRelative,
    localize: $2RipV.localize,
    match: $4kbqx.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("8Oz4Q", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $66ae33d6f8026387$export$2c14ff85d6318973; }, function (v) { return $66ae33d6f8026387$export$2c14ff85d6318973 = v; });
var $66ae33d6f8026387$export$2c14ff85d6318973;
"use strict";
$66ae33d6f8026387$export$2c14ff85d6318973 = void 0;
const $66ae33d6f8026387$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 1 \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
        other: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 {{count}} \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576"
    },
    xSeconds: {
        one: "1 \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
        other: "{{count}} \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576"
    },
    halfAMinute: "\u056F\u0565\u057D \u0580\u0578\u057A\u0565",
    lessThanXMinutes: {
        one: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 1 \u0580\u0578\u057A\u0565",
        other: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 {{count}} \u0580\u0578\u057A\u0565"
    },
    xMinutes: {
        one: "1 \u0580\u0578\u057A\u0565",
        other: "{{count}} \u0580\u0578\u057A\u0565"
    },
    aboutXHours: {
        one: "\u0574\u0578\u057F 1 \u056A\u0561\u0574",
        other: "\u0574\u0578\u057F {{count}} \u056A\u0561\u0574"
    },
    xHours: {
        one: "1 \u056A\u0561\u0574",
        other: "{{count}} \u056A\u0561\u0574"
    },
    xDays: {
        one: "1 \u0585\u0580",
        other: "{{count}} \u0585\u0580"
    },
    aboutXWeeks: {
        one: "\u0574\u0578\u057F 1 \u0577\u0561\u0562\u0561\u0569",
        other: "\u0574\u0578\u057F {{count}} \u0577\u0561\u0562\u0561\u0569"
    },
    xWeeks: {
        one: "1 \u0577\u0561\u0562\u0561\u0569",
        other: "{{count}} \u0577\u0561\u0562\u0561\u0569"
    },
    aboutXMonths: {
        one: "\u0574\u0578\u057F 1 \u0561\u0574\u056B\u057D",
        other: "\u0574\u0578\u057F {{count}} \u0561\u0574\u056B\u057D"
    },
    xMonths: {
        one: "1 \u0561\u0574\u056B\u057D",
        other: "{{count}} \u0561\u0574\u056B\u057D"
    },
    aboutXYears: {
        one: "\u0574\u0578\u057F 1 \u057F\u0561\u0580\u056B",
        other: "\u0574\u0578\u057F {{count}} \u057F\u0561\u0580\u056B"
    },
    xYears: {
        one: "1 \u057F\u0561\u0580\u056B",
        other: "{{count}} \u057F\u0561\u0580\u056B"
    },
    overXYears: {
        one: "\u0561\u057E\u0565\u056C\u056B \u0584\u0561\u0576 1 \u057F\u0561\u0580\u056B",
        other: "\u0561\u057E\u0565\u056C\u056B \u0584\u0561\u0576 {{count}} \u057F\u0561\u0580\u056B"
    },
    almostXYears: {
        one: "\u0570\u0561\u0574\u0561\u0580\u0575\u0561 1 \u057F\u0561\u0580\u056B",
        other: "\u0570\u0561\u0574\u0561\u0580\u0575\u0561 {{count}} \u057F\u0561\u0580\u056B"
    }
};
const $66ae33d6f8026387$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $66ae33d6f8026387$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " \u0570\u0565\u057F\u0578";
        else return result + " \u0561\u057C\u0561\u057B";
    }
    return result;
};
$66ae33d6f8026387$export$2c14ff85d6318973 = $66ae33d6f8026387$var$formatDistance;

});

parcelRegister("5rF5i", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $3f6f57db0ff769f4$export$cbf60ecb96cbb82f; }, function (v) { return $3f6f57db0ff769f4$export$cbf60ecb96cbb82f = v; });
var $3f6f57db0ff769f4$export$cbf60ecb96cbb82f;
"use strict";
$3f6f57db0ff769f4$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $3f6f57db0ff769f4$var$dateFormats = {
    full: "d MMMM, y, EEEE",
    long: "d MMMM, y",
    medium: "d MMM, y",
    short: "dd.MM.yyyy"
};
const $3f6f57db0ff769f4$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $3f6f57db0ff769f4$var$dateTimeFormats = {
    full: "{{date}} '\u056A\u2024'{{time}}",
    long: "{{date}} '\u056A\u2024'{{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $3f6f57db0ff769f4$var$formatLong = $3f6f57db0ff769f4$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $3f6f57db0ff769f4$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $3f6f57db0ff769f4$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $3f6f57db0ff769f4$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("hvZZ8", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $cc0569decd23376d$export$8fbbfd65594f46a0; }, function (v) { return $cc0569decd23376d$export$8fbbfd65594f46a0 = v; });
var $cc0569decd23376d$export$8fbbfd65594f46a0;
"use strict";
$cc0569decd23376d$export$8fbbfd65594f46a0 = void 0;
const $cc0569decd23376d$var$formatRelativeLocale = {
    lastWeek: "'\u0576\u0561\u056D\u0578\u0580\u0564' eeee p'\u058A\u056B\u0576'",
    yesterday: "'\u0565\u0580\u0565\u056F' p'\u058A\u056B\u0576'",
    today: "'\u0561\u0575\u057D\u0585\u0580' p'\u058A\u056B\u0576'",
    tomorrow: "'\u057E\u0561\u0572\u0568' p'\u058A\u056B\u0576'",
    nextWeek: "'\u0570\u0561\u057B\u0578\u0580\u0564' eeee p'\u058A\u056B\u0576'",
    other: "P"
};
const $cc0569decd23376d$var$formatRelative = (token, _date, _baseDate, _options)=>$cc0569decd23376d$var$formatRelativeLocale[token];
$cc0569decd23376d$export$8fbbfd65594f46a0 = $cc0569decd23376d$var$formatRelative;

});

parcelRegister("2RipV", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $214ed140a03d527f$export$b3bd0bc58e36cd63; }, function (v) { return $214ed140a03d527f$export$b3bd0bc58e36cd63 = v; });
var $214ed140a03d527f$export$b3bd0bc58e36cd63;
"use strict";
$214ed140a03d527f$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $214ed140a03d527f$var$eraValues = {
    narrow: [
        "\u0554",
        "\u0544"
    ],
    abbreviated: [
        "\u0554\u0531",
        "\u0544\u0539"
    ],
    wide: [
        "\u0554\u0580\u056B\u057D\u057F\u0578\u057D\u056B\u0581 \u0561\u057C\u0561\u057B",
        "\u0544\u0565\u0580 \u0569\u057E\u0561\u0580\u056F\u0578\u0582\u0569\u0575\u0561\u0576"
    ]
};
const $214ed140a03d527f$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u05541",
        "\u05542",
        "\u05543",
        "\u05544"
    ],
    wide: [
        "1\u058A\u056B\u0576 \u0584\u0561\u057C\u0578\u0580\u0564",
        "2\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564",
        "3\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564",
        "4\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564"
    ]
};
const $214ed140a03d527f$var$monthValues = {
    narrow: [
        "\u0540",
        "\u0553",
        "\u0544",
        "\u0531",
        "\u0544",
        "\u0540",
        "\u0540",
        "\u0555",
        "\u054D",
        "\u0540",
        "\u0546",
        "\u0534"
    ],
    abbreviated: [
        "\u0570\u0578\u0582\u0576",
        "\u0583\u0565\u057F",
        "\u0574\u0561\u0580",
        "\u0561\u057A\u0580",
        "\u0574\u0561\u0575",
        "\u0570\u0578\u0582\u0576",
        "\u0570\u0578\u0582\u056C",
        "\u0585\u0563\u057D",
        "\u057D\u0565\u057A",
        "\u0570\u0578\u056F",
        "\u0576\u0578\u0575",
        "\u0564\u0565\u056F"
    ],
    wide: [
        "\u0570\u0578\u0582\u0576\u057E\u0561\u0580",
        "\u0583\u0565\u057F\u0580\u057E\u0561\u0580",
        "\u0574\u0561\u0580\u057F",
        "\u0561\u057A\u0580\u056B\u056C",
        "\u0574\u0561\u0575\u056B\u057D",
        "\u0570\u0578\u0582\u0576\u056B\u057D",
        "\u0570\u0578\u0582\u056C\u056B\u057D",
        "\u0585\u0563\u0578\u057D\u057F\u0578\u057D",
        "\u057D\u0565\u057A\u057F\u0565\u0574\u0562\u0565\u0580",
        "\u0570\u0578\u056F\u057F\u0565\u0574\u0562\u0565\u0580",
        "\u0576\u0578\u0575\u0565\u0574\u0562\u0565\u0580",
        "\u0564\u0565\u056F\u057F\u0565\u0574\u0562\u0565\u0580"
    ]
};
const $214ed140a03d527f$var$dayValues = {
    narrow: [
        "\u053F",
        "\u0535",
        "\u0535",
        "\u0549",
        "\u0540",
        "\u0548",
        "\u0547"
    ],
    short: [
        "\u056F\u0580",
        "\u0565\u0580",
        "\u0565\u0584",
        "\u0579\u0584",
        "\u0570\u0563",
        "\u0578\u0582\u0580",
        "\u0577\u0562"
    ],
    abbreviated: [
        "\u056F\u056B\u0580",
        "\u0565\u0580\u056F",
        "\u0565\u0580\u0584",
        "\u0579\u0578\u0580",
        "\u0570\u0576\u0563",
        "\u0578\u0582\u0580\u0562",
        "\u0577\u0561\u0562"
    ],
    wide: [
        "\u056F\u056B\u0580\u0561\u056F\u056B",
        "\u0565\u0580\u056F\u0578\u0582\u0577\u0561\u0562\u0569\u056B",
        "\u0565\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B",
        "\u0579\u0578\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B",
        "\u0570\u056B\u0576\u0563\u0577\u0561\u0562\u0569\u056B",
        "\u0578\u0582\u0580\u0562\u0561\u0569",
        "\u0577\u0561\u0562\u0561\u0569"
    ]
};
const $214ed140a03d527f$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "\u056F\u0565\u057D\u0563\u0577",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F",
        afternoon: "\u0581\u0565\u0580\u0565\u056F",
        evening: "\u0565\u0580\u0565\u056F\u0578",
        night: "\u0563\u056B\u0577\u0565\u0580"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F",
        afternoon: "\u0581\u0565\u0580\u0565\u056F",
        evening: "\u0565\u0580\u0565\u056F\u0578",
        night: "\u0563\u056B\u0577\u0565\u0580"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F",
        afternoon: "\u0581\u0565\u0580\u0565\u056F",
        evening: "\u0565\u0580\u0565\u056F\u0578",
        night: "\u0563\u056B\u0577\u0565\u0580"
    }
};
const $214ed140a03d527f$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "\u056F\u0565\u057D\u0563\u0577",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
        afternoon: "\u0581\u0565\u0580\u0565\u056F\u0568",
        evening: "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
        night: "\u0563\u056B\u0577\u0565\u0580\u0568"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580\u056B\u0576",
        noon: "\u056F\u0565\u057D\u0585\u0580\u056B\u0576",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
        afternoon: "\u0581\u0565\u0580\u0565\u056F\u0568",
        evening: "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
        night: "\u0563\u056B\u0577\u0565\u0580\u0568"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580\u056B\u0576",
        noon: "\u056F\u0565\u057D\u0585\u0580\u056B\u0576",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
        afternoon: "\u0581\u0565\u0580\u0565\u056F\u0568",
        evening: "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
        night: "\u0563\u056B\u0577\u0565\u0580\u0568"
    }
};
const $214ed140a03d527f$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 < 10) {
        if (rem100 % 10 === 1) return number + "\u058A\u056B\u0576";
    }
    return number + "\u058A\u0580\u0564";
};
const $214ed140a03d527f$var$localize = $214ed140a03d527f$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $214ed140a03d527f$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $214ed140a03d527f$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $214ed140a03d527f$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $214ed140a03d527f$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $214ed140a03d527f$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $214ed140a03d527f$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $214ed140a03d527f$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("4kbqx", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $3261e4db2ed612cc$export$4659b591c19bdf3d; }, function (v) { return $3261e4db2ed612cc$export$4659b591c19bdf3d = v; });
var $3261e4db2ed612cc$export$4659b591c19bdf3d;
"use strict";
$3261e4db2ed612cc$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $3261e4db2ed612cc$var$matchOrdinalNumberPattern = /^(\d+)((-|֊)?(ին|րդ))?/i;
const $3261e4db2ed612cc$var$parseOrdinalNumberPattern = /\d+/i;
const $3261e4db2ed612cc$var$matchEraPatterns = {
    narrow: /^(Ք|Մ)/i,
    abbreviated: /^(Ք\.?\s?Ա\.?|Մ\.?\s?Թ\.?\s?Ա\.?|Մ\.?\s?Թ\.?|Ք\.?\s?Հ\.?)/i,
    wide: /^(քրիստոսից առաջ|մեր թվարկությունից առաջ|մեր թվարկության|քրիստոսից հետո)/i
};
const $3261e4db2ed612cc$var$parseEraPatterns = {
    any: [
        /^ք/i,
        /^մ/i
    ]
};
const $3261e4db2ed612cc$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ք[1234]/i,
    wide: /^[1234]((-|֊)?(ին|րդ)) քառորդ/i
};
const $3261e4db2ed612cc$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $3261e4db2ed612cc$var$matchMonthPatterns = {
    narrow: /^[հփմաօսնդ]/i,
    abbreviated: /^(հուն|փետ|մար|ապր|մայ|հուն|հուլ|օգս|սեպ|հոկ|նոյ|դեկ)/i,
    wide: /^(հունվար|փետրվար|մարտ|ապրիլ|մայիս|հունիս|հուլիս|օգոստոս|սեպտեմբեր|հոկտեմբեր|նոյեմբեր|դեկտեմբեր)/i
};
const $3261e4db2ed612cc$var$parseMonthPatterns = {
    narrow: [
        /^հ/i,
        /^փ/i,
        /^մ/i,
        /^ա/i,
        /^մ/i,
        /^հ/i,
        /^հ/i,
        /^օ/i,
        /^ս/i,
        /^հ/i,
        /^ն/i,
        /^դ/i
    ],
    any: [
        /^հու/i,
        /^փ/i,
        /^մար/i,
        /^ա/i,
        /^մայ/i,
        /^հուն/i,
        /^հուլ/i,
        /^օ/i,
        /^ս/i,
        /^հոկ/i,
        /^ն/i,
        /^դ/i
    ]
};
const $3261e4db2ed612cc$var$matchDayPatterns = {
    narrow: /^[եչհոշկ]/i,
    short: /^(կր|եր|եք|չք|հգ|ուր|շբ)/i,
    abbreviated: /^(կիր|երկ|երք|չոր|հնգ|ուրբ|շաբ)/i,
    wide: /^(կիրակի|երկուշաբթի|երեքշաբթի|չորեքշաբթի|հինգշաբթի|ուրբաթ|շաբաթ)/i
};
const $3261e4db2ed612cc$var$parseDayPatterns = {
    narrow: [
        /^կ/i,
        /^ե/i,
        /^ե/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ],
    short: [
        /^կ/i,
        /^եր/i,
        /^եք/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ],
    abbreviated: [
        /^կ/i,
        /^երկ/i,
        /^երք/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ],
    wide: [
        /^կ/i,
        /^երկ/i,
        /^երե/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ]
};
const $3261e4db2ed612cc$var$matchDayPeriodPatterns = {
    narrow: /^([ap]|կեսգշ|կեսօր|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i,
    any: /^([ap]\.?\s?m\.?|կեսգիշեր(ին)?|կեսօր(ին)?|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i
};
const $3261e4db2ed612cc$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /կեսգիշեր/i,
        noon: /կեսօր/i,
        morning: /առավոտ/i,
        afternoon: /ցերեկ/i,
        evening: /երեկո/i,
        night: /գիշեր/i
    }
};
const $3261e4db2ed612cc$var$match = $3261e4db2ed612cc$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $3261e4db2ed612cc$var$matchOrdinalNumberPattern,
        parsePattern: $3261e4db2ed612cc$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $3261e4db2ed612cc$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3261e4db2ed612cc$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $3261e4db2ed612cc$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3261e4db2ed612cc$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $3261e4db2ed612cc$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3261e4db2ed612cc$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $3261e4db2ed612cc$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3261e4db2ed612cc$var$parseDayPatterns,
        defaultParseWidth: "wide"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $3261e4db2ed612cc$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $3261e4db2ed612cc$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("hjGsR", function(module, exports) {

$parcel$export(module.exports, "id", function () { return $c9b52698b23d0b1b$export$d560c7e4a29451c2; }, function (v) { return $c9b52698b23d0b1b$export$d560c7e4a29451c2 = v; });
var $c9b52698b23d0b1b$export$d560c7e4a29451c2;
"use strict";
$c9b52698b23d0b1b$export$d560c7e4a29451c2 = void 0;

var $73WxD = parcelRequire("73WxD");

var $eoOJ1 = parcelRequire("eoOJ1");

var $fJq8u = parcelRequire("fJq8u");

var $ekn7v = parcelRequire("ekn7v");

var $ek5FJ = parcelRequire("ek5FJ");
/**
 * @category Locales
 * @summary Indonesian locale.
 * @language Indonesian
 * @iso-639-2 ind
 * @author Rahmat Budiharso [@rbudiharso](https://github.com/rbudiharso)
 * @author Benget Nata [@bentinata](https://github.com/bentinata)
 * @author Budi Irawan [@deerawan](https://github.com/deerawan)
 * @author Try Ajitiono [@imballinst](https://github.com/imballinst)
 */ const $c9b52698b23d0b1b$var$id = $c9b52698b23d0b1b$export$d560c7e4a29451c2 = {
    code: "id",
    formatDistance: $73WxD.formatDistance,
    formatLong: $eoOJ1.formatLong,
    formatRelative: $fJq8u.formatRelative,
    localize: $ekn7v.localize,
    match: $ek5FJ.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("73WxD", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $5246395007699ea9$export$2c14ff85d6318973; }, function (v) { return $5246395007699ea9$export$2c14ff85d6318973 = v; });
var $5246395007699ea9$export$2c14ff85d6318973;
"use strict";
$5246395007699ea9$export$2c14ff85d6318973 = void 0;
const $5246395007699ea9$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "kurang dari 1 detik",
        other: "kurang dari {{count}} detik"
    },
    xSeconds: {
        one: "1 detik",
        other: "{{count}} detik"
    },
    halfAMinute: "setengah menit",
    lessThanXMinutes: {
        one: "kurang dari 1 menit",
        other: "kurang dari {{count}} menit"
    },
    xMinutes: {
        one: "1 menit",
        other: "{{count}} menit"
    },
    aboutXHours: {
        one: "sekitar 1 jam",
        other: "sekitar {{count}} jam"
    },
    xHours: {
        one: "1 jam",
        other: "{{count}} jam"
    },
    xDays: {
        one: "1 hari",
        other: "{{count}} hari"
    },
    aboutXWeeks: {
        one: "sekitar 1 minggu",
        other: "sekitar {{count}} minggu"
    },
    xWeeks: {
        one: "1 minggu",
        other: "{{count}} minggu"
    },
    aboutXMonths: {
        one: "sekitar 1 bulan",
        other: "sekitar {{count}} bulan"
    },
    xMonths: {
        one: "1 bulan",
        other: "{{count}} bulan"
    },
    aboutXYears: {
        one: "sekitar 1 tahun",
        other: "sekitar {{count}} tahun"
    },
    xYears: {
        one: "1 tahun",
        other: "{{count}} tahun"
    },
    overXYears: {
        one: "lebih dari 1 tahun",
        other: "lebih dari {{count}} tahun"
    },
    almostXYears: {
        one: "hampir 1 tahun",
        other: "hampir {{count}} tahun"
    }
};
const $5246395007699ea9$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $5246395007699ea9$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "dalam waktu " + result;
        else return result + " yang lalu";
    }
    return result;
};
$5246395007699ea9$export$2c14ff85d6318973 = $5246395007699ea9$var$formatDistance;

});

parcelRegister("eoOJ1", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $a7baa7847c8af708$export$cbf60ecb96cbb82f; }, function (v) { return $a7baa7847c8af708$export$cbf60ecb96cbb82f = v; });
var $a7baa7847c8af708$export$cbf60ecb96cbb82f;
"use strict";
$a7baa7847c8af708$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $a7baa7847c8af708$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "d/M/yyyy"
};
const $a7baa7847c8af708$var$timeFormats = {
    full: "HH.mm.ss",
    long: "HH.mm.ss",
    medium: "HH.mm",
    short: "HH.mm"
};
const $a7baa7847c8af708$var$dateTimeFormats = {
    full: "{{date}} 'pukul' {{time}}",
    long: "{{date}} 'pukul' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $a7baa7847c8af708$var$formatLong = $a7baa7847c8af708$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $a7baa7847c8af708$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $a7baa7847c8af708$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $a7baa7847c8af708$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("fJq8u", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $b73f5509eb138fd2$export$8fbbfd65594f46a0; }, function (v) { return $b73f5509eb138fd2$export$8fbbfd65594f46a0 = v; });
var $b73f5509eb138fd2$export$8fbbfd65594f46a0;
"use strict";
$b73f5509eb138fd2$export$8fbbfd65594f46a0 = void 0;
const $b73f5509eb138fd2$var$formatRelativeLocale = {
    lastWeek: "eeee 'lalu pukul' p",
    yesterday: "'Kemarin pukul' p",
    today: "'Hari ini pukul' p",
    tomorrow: "'Besok pukul' p",
    nextWeek: "eeee 'pukul' p",
    other: "P"
};
const $b73f5509eb138fd2$var$formatRelative = (token, _date, _baseDate, _options)=>$b73f5509eb138fd2$var$formatRelativeLocale[token];
$b73f5509eb138fd2$export$8fbbfd65594f46a0 = $b73f5509eb138fd2$var$formatRelative;

});

parcelRegister("ekn7v", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $a6e4de1ba8d84cd9$export$b3bd0bc58e36cd63; }, function (v) { return $a6e4de1ba8d84cd9$export$b3bd0bc58e36cd63 = v; });
var $a6e4de1ba8d84cd9$export$b3bd0bc58e36cd63;
"use strict";
$a6e4de1ba8d84cd9$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
// All data for localization are taken from this page
// https://www.unicode.org/cldr/charts/32/summary/id.html
const $a6e4de1ba8d84cd9$var$eraValues = {
    narrow: [
        "SM",
        "M"
    ],
    abbreviated: [
        "SM",
        "M"
    ],
    wide: [
        "Sebelum Masehi",
        "Masehi"
    ]
};
const $a6e4de1ba8d84cd9$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "Kuartal ke-1",
        "Kuartal ke-2",
        "Kuartal ke-3",
        "Kuartal ke-4"
    ]
};
// Note: in Indonesian, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $a6e4de1ba8d84cd9$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "Mei",
        "Jun",
        "Jul",
        "Agt",
        "Sep",
        "Okt",
        "Nov",
        "Des"
    ],
    wide: [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember"
    ]
};
const $a6e4de1ba8d84cd9$var$dayValues = {
    narrow: [
        "M",
        "S",
        "S",
        "R",
        "K",
        "J",
        "S"
    ],
    short: [
        "Min",
        "Sen",
        "Sel",
        "Rab",
        "Kam",
        "Jum",
        "Sab"
    ],
    abbreviated: [
        "Min",
        "Sen",
        "Sel",
        "Rab",
        "Kam",
        "Jum",
        "Sab"
    ],
    wide: [
        "Minggu",
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jumat",
        "Sabtu"
    ]
};
const $a6e4de1ba8d84cd9$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "siang",
        evening: "sore",
        night: "malam"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "siang",
        evening: "sore",
        night: "malam"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "siang",
        evening: "sore",
        night: "malam"
    }
};
const $a6e4de1ba8d84cd9$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "siang",
        evening: "sore",
        night: "malam"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "siang",
        evening: "sore",
        night: "malam"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "siang",
        evening: "sore",
        night: "malam"
    }
};
const $a6e4de1ba8d84cd9$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // Can't use "pertama", "kedua" because can't be parsed
    return "ke-" + number;
};
const $a6e4de1ba8d84cd9$var$localize = $a6e4de1ba8d84cd9$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $a6e4de1ba8d84cd9$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $a6e4de1ba8d84cd9$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $a6e4de1ba8d84cd9$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $a6e4de1ba8d84cd9$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $a6e4de1ba8d84cd9$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $a6e4de1ba8d84cd9$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $a6e4de1ba8d84cd9$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("ek5FJ", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $a6d7554e1df787a3$export$4659b591c19bdf3d; }, function (v) { return $a6d7554e1df787a3$export$4659b591c19bdf3d = v; });
var $a6d7554e1df787a3$export$4659b591c19bdf3d;
"use strict";
$a6d7554e1df787a3$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $a6d7554e1df787a3$var$matchOrdinalNumberPattern = /^ke-(\d+)?/i;
const $a6d7554e1df787a3$var$parseOrdinalNumberPattern = /\d+/i;
const $a6d7554e1df787a3$var$matchEraPatterns = {
    narrow: /^(sm|m)/i,
    abbreviated: /^(s\.?\s?m\.?|s\.?\s?e\.?\s?u\.?|m\.?|e\.?\s?u\.?)/i,
    wide: /^(sebelum masehi|sebelum era umum|masehi|era umum)/i
};
const $a6d7554e1df787a3$var$parseEraPatterns = {
    any: [
        /^s/i,
        /^(m|e)/i
    ]
};
const $a6d7554e1df787a3$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K-?\s[1234]/i,
    wide: /^Kuartal ke-?\s?[1234]/i
};
const $a6d7554e1df787a3$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $a6d7554e1df787a3$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|mei|jun|jul|agt|sep|okt|nov|des)/i,
    wide: /^(januari|februari|maret|april|mei|juni|juli|agustus|september|oktober|november|desember)/i
};
const $a6d7554e1df787a3$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^ma/i,
        /^ap/i,
        /^me/i,
        /^jun/i,
        /^jul/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $a6d7554e1df787a3$var$matchDayPatterns = {
    narrow: /^[srkjm]/i,
    short: /^(min|sen|sel|rab|kam|jum|sab)/i,
    abbreviated: /^(min|sen|sel|rab|kam|jum|sab)/i,
    wide: /^(minggu|senin|selasa|rabu|kamis|jumat|sabtu)/i
};
const $a6d7554e1df787a3$var$parseDayPatterns = {
    narrow: [
        /^m/i,
        /^s/i,
        /^s/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^s/i
    ],
    any: [
        /^m/i,
        /^sen/i,
        /^sel/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^sa/i
    ]
};
const $a6d7554e1df787a3$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|tengah m|tengah h|(di(\swaktu)?) (pagi|siang|sore|malam))/i,
    any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|(di(\swaktu)?) (pagi|siang|sore|malam))/i
};
const $a6d7554e1df787a3$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^pm/i,
        midnight: /^tengah m/i,
        noon: /^tengah h/i,
        morning: /pagi/i,
        afternoon: /siang/i,
        evening: /sore/i,
        night: /malam/i
    }
};
const $a6d7554e1df787a3$var$match = $a6d7554e1df787a3$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $a6d7554e1df787a3$var$matchOrdinalNumberPattern,
        parsePattern: $a6d7554e1df787a3$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $a6d7554e1df787a3$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a6d7554e1df787a3$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $a6d7554e1df787a3$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a6d7554e1df787a3$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $a6d7554e1df787a3$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a6d7554e1df787a3$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $a6d7554e1df787a3$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a6d7554e1df787a3$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $a6d7554e1df787a3$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $a6d7554e1df787a3$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("awu3F", function(module, exports) {

$parcel$export(module.exports, "is", function () { return $7a94357c2c7c08c5$export$226b3eccf92c9ed9; }, function (v) { return $7a94357c2c7c08c5$export$226b3eccf92c9ed9 = v; });
var $7a94357c2c7c08c5$export$226b3eccf92c9ed9;
"use strict";
$7a94357c2c7c08c5$export$226b3eccf92c9ed9 = void 0;

var $iVkqe = parcelRequire("iVkqe");

var $ipZAc = parcelRequire("ipZAc");

var $dCpoA = parcelRequire("dCpoA");

var $5OWs3 = parcelRequire("5OWs3");

var $4FxJS = parcelRequire("4FxJS");
/**
 * @category Locales
 * @summary Icelandic locale.
 * @language Icelandic
 * @iso-639-2 isl
 * @author Derek Blank [@derekblank](https://github.com/derekblank)
 * @author Arnór Ýmir [@lamayg](https://github.com/lamayg)
 */ const $7a94357c2c7c08c5$var$is = $7a94357c2c7c08c5$export$226b3eccf92c9ed9 = {
    code: "is",
    formatDistance: $iVkqe.formatDistance,
    formatLong: $ipZAc.formatLong,
    formatRelative: $dCpoA.formatRelative,
    localize: $5OWs3.localize,
    match: $4FxJS.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("iVkqe", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $dc6d6449e7ec1780$export$2c14ff85d6318973; }, function (v) { return $dc6d6449e7ec1780$export$2c14ff85d6318973 = v; });
var $dc6d6449e7ec1780$export$2c14ff85d6318973;
"use strict";
$dc6d6449e7ec1780$export$2c14ff85d6318973 = void 0;
const $dc6d6449e7ec1780$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minna en 1 sek\xfanda",
        other: "minna en {{count}} sek\xfandur"
    },
    xSeconds: {
        one: "1 sek\xfanda",
        other: "{{count}} sek\xfandur"
    },
    halfAMinute: "h\xe1lf m\xedn\xfata",
    lessThanXMinutes: {
        one: "minna en 1 m\xedn\xfata",
        other: "minna en {{count}} m\xedn\xfatur"
    },
    xMinutes: {
        one: "1 m\xedn\xfata",
        other: "{{count}} m\xedn\xfatur"
    },
    aboutXHours: {
        one: "u.\xfe.b. 1 klukkustund",
        other: "u.\xfe.b. {{count}} klukkustundir"
    },
    xHours: {
        one: "1 klukkustund",
        other: "{{count}} klukkustundir"
    },
    xDays: {
        one: "1 dagur",
        other: "{{count}} dagar"
    },
    aboutXWeeks: {
        one: "um viku",
        other: "um {{count}} vikur"
    },
    xWeeks: {
        one: "1 viku",
        other: "{{count}} vikur"
    },
    aboutXMonths: {
        one: "u.\xfe.b. 1 m\xe1nu\xf0ur",
        other: "u.\xfe.b. {{count}} m\xe1nu\xf0ir"
    },
    xMonths: {
        one: "1 m\xe1nu\xf0ur",
        other: "{{count}} m\xe1nu\xf0ir"
    },
    aboutXYears: {
        one: "u.\xfe.b. 1 \xe1r",
        other: "u.\xfe.b. {{count}} \xe1r"
    },
    xYears: {
        one: "1 \xe1r",
        other: "{{count}} \xe1r"
    },
    overXYears: {
        one: "meira en 1 \xe1r",
        other: "meira en {{count}} \xe1r"
    },
    almostXYears: {
        one: "n\xe6stum 1 \xe1r",
        other: "n\xe6stum {{count}} \xe1r"
    }
};
const $dc6d6449e7ec1780$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $dc6d6449e7ec1780$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\xed " + result;
        else return result + " s\xed\xf0an";
    }
    return result;
};
$dc6d6449e7ec1780$export$2c14ff85d6318973 = $dc6d6449e7ec1780$var$formatDistance;

});

parcelRegister("ipZAc", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $d68a54de44ca0554$export$cbf60ecb96cbb82f; }, function (v) { return $d68a54de44ca0554$export$cbf60ecb96cbb82f = v; });
var $d68a54de44ca0554$export$cbf60ecb96cbb82f;
"use strict";
$d68a54de44ca0554$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $d68a54de44ca0554$var$dateFormats = {
    full: "EEEE, do MMMM y",
    long: "do MMMM y",
    medium: "do MMM y",
    short: "d.MM.y"
};
const $d68a54de44ca0554$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $d68a54de44ca0554$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $d68a54de44ca0554$var$formatLong = $d68a54de44ca0554$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $d68a54de44ca0554$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $d68a54de44ca0554$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $d68a54de44ca0554$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("dCpoA", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $9ea286021a8c0525$export$8fbbfd65594f46a0; }, function (v) { return $9ea286021a8c0525$export$8fbbfd65594f46a0 = v; });
var $9ea286021a8c0525$export$8fbbfd65594f46a0;
"use strict";
$9ea286021a8c0525$export$8fbbfd65594f46a0 = void 0;
const $9ea286021a8c0525$var$formatRelativeLocale = {
    lastWeek: "'s\xed\xf0asta' dddd 'kl.' p",
    yesterday: "'\xed g\xe6r kl.' p",
    today: "'\xed dag kl.' p",
    tomorrow: "'\xe1 morgun kl.' p",
    nextWeek: "dddd 'kl.' p",
    other: "P"
};
const $9ea286021a8c0525$var$formatRelative = (token, _date, _baseDate, _options)=>$9ea286021a8c0525$var$formatRelativeLocale[token];
$9ea286021a8c0525$export$8fbbfd65594f46a0 = $9ea286021a8c0525$var$formatRelative;

});

parcelRegister("5OWs3", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $43cef688215be694$export$b3bd0bc58e36cd63; }, function (v) { return $43cef688215be694$export$b3bd0bc58e36cd63 = v; });
var $43cef688215be694$export$b3bd0bc58e36cd63;
"use strict";
$43cef688215be694$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $43cef688215be694$var$eraValues = {
    narrow: [
        "f.Kr.",
        "e.Kr."
    ],
    abbreviated: [
        "f.Kr.",
        "e.Kr."
    ],
    wide: [
        "fyrir Krist",
        "eftir Krist"
    ]
};
const $43cef688215be694$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1F",
        "2F",
        "3F",
        "4F"
    ],
    wide: [
        "1. fj\xf3r\xf0ungur",
        "2. fj\xf3r\xf0ungur",
        "3. fj\xf3r\xf0ungur",
        "4. fj\xf3r\xf0ungur"
    ]
};
const $43cef688215be694$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "\xc1",
        "S",
        "\xd3",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mars",
        "apr\xedl",
        "ma\xed",
        "j\xfan\xed",
        "j\xfal\xed",
        "\xe1g\xfast",
        "sept.",
        "okt.",
        "n\xf3v.",
        "des."
    ],
    wide: [
        "jan\xfaar",
        "febr\xfaar",
        "mars",
        "apr\xedl",
        "ma\xed",
        "j\xfan\xed",
        "j\xfal\xed",
        "\xe1g\xfast",
        "september",
        "okt\xf3ber",
        "n\xf3vember",
        "desember"
    ]
};
const $43cef688215be694$var$dayValues = {
    narrow: [
        "S",
        "M",
        "\xde",
        "M",
        "F",
        "F",
        "L"
    ],
    short: [
        "Su",
        "M\xe1",
        "\xder",
        "Mi",
        "Fi",
        "F\xf6",
        "La"
    ],
    abbreviated: [
        "sun.",
        "m\xe1n.",
        "\xferi.",
        "mi\xf0.",
        "fim.",
        "f\xf6s.",
        "lau."
    ],
    wide: [
        "sunnudagur",
        "m\xe1nudagur",
        "\xferi\xf0judagur",
        "mi\xf0vikudagur",
        "fimmtudagur",
        "f\xf6studagur",
        "laugardagur"
    ]
};
const $43cef688215be694$var$dayPeriodValues = {
    narrow: {
        am: "f",
        pm: "e",
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: "morgunn",
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    },
    abbreviated: {
        am: "f.h.",
        pm: "e.h.",
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: "morgunn",
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    },
    wide: {
        am: "fyrir h\xe1degi",
        pm: "eftir h\xe1degi",
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: "morgunn",
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    }
};
const $43cef688215be694$var$formattingDayPeriodValues = {
    narrow: {
        am: "f",
        pm: "e",
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    },
    abbreviated: {
        am: "f.h.",
        pm: "e.h.",
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    },
    wide: {
        am: "fyrir h\xe1degi",
        pm: "eftir h\xe1degi",
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    }
};
const $43cef688215be694$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $43cef688215be694$var$localize = $43cef688215be694$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $43cef688215be694$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $43cef688215be694$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $43cef688215be694$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $43cef688215be694$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $43cef688215be694$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $43cef688215be694$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $43cef688215be694$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("4FxJS", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $366529979d60e58d$export$4659b591c19bdf3d; }, function (v) { return $366529979d60e58d$export$4659b591c19bdf3d = v; });
var $366529979d60e58d$export$4659b591c19bdf3d;
"use strict";
$366529979d60e58d$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $366529979d60e58d$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
const $366529979d60e58d$var$parseOrdinalNumberPattern = /\d+(\.)?/i;
const $366529979d60e58d$var$matchEraPatterns = {
    narrow: /^(f\.Kr\.|e\.Kr\.)/i,
    abbreviated: /^(f\.Kr\.|e\.Kr\.)/i,
    wide: /^(fyrir Krist|eftir Krist)/i
};
const $366529979d60e58d$var$parseEraPatterns = {
    any: [
        /^(f\.Kr\.)/i,
        /^(e\.Kr\.)/i
    ]
};
const $366529979d60e58d$var$matchQuarterPatterns = {
    narrow: /^[1234]\.?/i,
    abbreviated: /^q[1234]\.?/i,
    wide: /^[1234]\.? fjórðungur/i
};
const $366529979d60e58d$var$parseQuarterPatterns = {
    any: [
        /1\.?/i,
        /2\.?/i,
        /3\.?/i,
        /4\.?/i
    ]
};
const $366529979d60e58d$var$matchMonthPatterns = {
    narrow: /^[jfmásónd]/i,
    abbreviated: /^(jan\.|feb\.|mars\.|apríl\.|maí|júní|júlí|águst|sep\.|oct\.|nov\.|dec\.)/i,
    wide: /^(januar|febrúar|mars|apríl|maí|júní|júlí|águst|september|október|nóvember|desember)/i
};
const $366529979d60e58d$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^á/i,
        /^s/i,
        /^ó/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maí/i,
        /^jún/i,
        /^júl/i,
        /^áu/i,
        /^s/i,
        /^ó/i,
        /^n/i,
        /^d/i
    ]
};
const $366529979d60e58d$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|má|þr|mi|fi|fö|la)/i,
    abbreviated: /^(sun|mán|þri|mið|fim|fös|lau)\.?/i,
    wide: /^(sunnudagur|mánudagur|þriðjudagur|miðvikudagur|fimmtudagur|föstudagur|laugardagur)/i
};
const $366529979d60e58d$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^þ/i,
        /^m/i,
        /^f/i,
        /^f/i,
        /^l/i
    ],
    any: [
        /^su/i,
        /^má/i,
        /^þr/i,
        /^mi/i,
        /^fi/i,
        /^fö/i,
        /^la/i
    ]
};
const $366529979d60e58d$var$matchDayPeriodPatterns = {
    narrow: /^(f|e|síðdegis|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i,
    any: /^(fyrir hádegi|eftir hádegi|[ef]\.?h\.?|síðdegis|morgunn|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i
};
const $366529979d60e58d$var$parseDayPeriodPatterns = {
    any: {
        am: /^f/i,
        pm: /^e/i,
        midnight: /^mi/i,
        noon: /^há/i,
        morning: /morgunn/i,
        afternoon: /síðdegi/i,
        evening: /kvöld/i,
        night: /nótt/i
    }
};
const $366529979d60e58d$var$match = $366529979d60e58d$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $366529979d60e58d$var$matchOrdinalNumberPattern,
        parsePattern: $366529979d60e58d$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $366529979d60e58d$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $366529979d60e58d$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $366529979d60e58d$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $366529979d60e58d$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $366529979d60e58d$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $366529979d60e58d$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $366529979d60e58d$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $366529979d60e58d$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $366529979d60e58d$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $366529979d60e58d$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("6aJlu", function(module, exports) {

$parcel$export(module.exports, "it", function () { return $47e6d9f213a6b64c$export$3486a10f30cf1ee4; }, function (v) { return $47e6d9f213a6b64c$export$3486a10f30cf1ee4 = v; });
var $47e6d9f213a6b64c$export$3486a10f30cf1ee4;
"use strict";
$47e6d9f213a6b64c$export$3486a10f30cf1ee4 = void 0;

var $eCReJ = parcelRequire("eCReJ");

var $11pv1 = parcelRequire("11pv1");

var $eiMvS = parcelRequire("eiMvS");

var $eO0X6 = parcelRequire("eO0X6");

var $5ovf5 = parcelRequire("5ovf5");
/**
 * @category Locales
 * @summary Italian locale.
 * @language Italian
 * @iso-639-2 ita
 * @author Alberto Restifo [@albertorestifo](https://github.com/albertorestifo)
 * @author Giovanni Polimeni [@giofilo](https://github.com/giofilo)
 * @author Vincenzo Carrese [@vin-car](https://github.com/vin-car)
 */ const $47e6d9f213a6b64c$var$it = $47e6d9f213a6b64c$export$3486a10f30cf1ee4 = {
    code: "it",
    formatDistance: $eCReJ.formatDistance,
    formatLong: $11pv1.formatLong,
    formatRelative: $eiMvS.formatRelative,
    localize: $eO0X6.localize,
    match: $5ovf5.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("eCReJ", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $aa5de8fdd7bc85b9$export$2c14ff85d6318973; }, function (v) { return $aa5de8fdd7bc85b9$export$2c14ff85d6318973 = v; });
var $aa5de8fdd7bc85b9$export$2c14ff85d6318973;
"use strict";
$aa5de8fdd7bc85b9$export$2c14ff85d6318973 = void 0;
const $aa5de8fdd7bc85b9$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "meno di un secondo",
        other: "meno di {{count}} secondi"
    },
    xSeconds: {
        one: "un secondo",
        other: "{{count}} secondi"
    },
    halfAMinute: "alcuni secondi",
    lessThanXMinutes: {
        one: "meno di un minuto",
        other: "meno di {{count}} minuti"
    },
    xMinutes: {
        one: "un minuto",
        other: "{{count}} minuti"
    },
    aboutXHours: {
        one: "circa un'ora",
        other: "circa {{count}} ore"
    },
    xHours: {
        one: "un'ora",
        other: "{{count}} ore"
    },
    xDays: {
        one: "un giorno",
        other: "{{count}} giorni"
    },
    aboutXWeeks: {
        one: "circa una settimana",
        other: "circa {{count}} settimane"
    },
    xWeeks: {
        one: "una settimana",
        other: "{{count}} settimane"
    },
    aboutXMonths: {
        one: "circa un mese",
        other: "circa {{count}} mesi"
    },
    xMonths: {
        one: "un mese",
        other: "{{count}} mesi"
    },
    aboutXYears: {
        one: "circa un anno",
        other: "circa {{count}} anni"
    },
    xYears: {
        one: "un anno",
        other: "{{count}} anni"
    },
    overXYears: {
        one: "pi\xf9 di un anno",
        other: "pi\xf9 di {{count}} anni"
    },
    almostXYears: {
        one: "quasi un anno",
        other: "quasi {{count}} anni"
    }
};
const $aa5de8fdd7bc85b9$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $aa5de8fdd7bc85b9$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "tra " + result;
        else return result + " fa";
    }
    return result;
};
$aa5de8fdd7bc85b9$export$2c14ff85d6318973 = $aa5de8fdd7bc85b9$var$formatDistance;

});

parcelRegister("11pv1", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $0be9aa146371a3cf$export$cbf60ecb96cbb82f; }, function (v) { return $0be9aa146371a3cf$export$cbf60ecb96cbb82f = v; });
var $0be9aa146371a3cf$export$cbf60ecb96cbb82f;
"use strict";
$0be9aa146371a3cf$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $0be9aa146371a3cf$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
const $0be9aa146371a3cf$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $0be9aa146371a3cf$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $0be9aa146371a3cf$var$formatLong = $0be9aa146371a3cf$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $0be9aa146371a3cf$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $0be9aa146371a3cf$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $0be9aa146371a3cf$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("eiMvS", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $a69860cf2c5ef7df$export$8fbbfd65594f46a0; }, function (v) { return $a69860cf2c5ef7df$export$8fbbfd65594f46a0 = v; });
var $a69860cf2c5ef7df$export$8fbbfd65594f46a0;
"use strict";
$a69860cf2c5ef7df$export$8fbbfd65594f46a0 = void 0;

var $9VRW1 = parcelRequire("9VRW1");
const $a69860cf2c5ef7df$var$weekdays = [
    "domenica",
    "luned\xec",
    "marted\xec",
    "mercoled\xec",
    "gioved\xec",
    "venerd\xec",
    "sabato"
];
function $a69860cf2c5ef7df$var$lastWeek(day) {
    switch(day){
        case 0:
            return "'domenica scorsa alle' p";
        default:
            return "'" + $a69860cf2c5ef7df$var$weekdays[day] + " scorso alle' p";
    }
}
function $a69860cf2c5ef7df$var$thisWeek(day) {
    return "'" + $a69860cf2c5ef7df$var$weekdays[day] + " alle' p";
}
function $a69860cf2c5ef7df$var$nextWeek(day) {
    switch(day){
        case 0:
            return "'domenica prossima alle' p";
        default:
            return "'" + $a69860cf2c5ef7df$var$weekdays[day] + " prossimo alle' p";
    }
}
const $a69860cf2c5ef7df$var$formatRelativeLocale = {
    lastWeek: (date, baseDate, options)=>{
        const day = date.getDay();
        if ((0, $9VRW1.isSameWeek)(date, baseDate, options)) return $a69860cf2c5ef7df$var$thisWeek(day);
        else return $a69860cf2c5ef7df$var$lastWeek(day);
    },
    yesterday: "'ieri alle' p",
    today: "'oggi alle' p",
    tomorrow: "'domani alle' p",
    nextWeek: (date, baseDate, options)=>{
        const day = date.getDay();
        if ((0, $9VRW1.isSameWeek)(date, baseDate, options)) return $a69860cf2c5ef7df$var$thisWeek(day);
        else return $a69860cf2c5ef7df$var$nextWeek(day);
    },
    other: "P"
};
const $a69860cf2c5ef7df$var$formatRelative = (token, date, baseDate, options)=>{
    const format = $a69860cf2c5ef7df$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
$a69860cf2c5ef7df$export$8fbbfd65594f46a0 = $a69860cf2c5ef7df$var$formatRelative;

});

parcelRegister("eO0X6", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $ac76795327591bb7$export$b3bd0bc58e36cd63; }, function (v) { return $ac76795327591bb7$export$b3bd0bc58e36cd63 = v; });
var $ac76795327591bb7$export$b3bd0bc58e36cd63;
"use strict";
$ac76795327591bb7$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $ac76795327591bb7$var$eraValues = {
    narrow: [
        "aC",
        "dC"
    ],
    abbreviated: [
        "a.C.",
        "d.C."
    ],
    wide: [
        "avanti Cristo",
        "dopo Cristo"
    ]
};
const $ac76795327591bb7$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
const $ac76795327591bb7$var$monthValues = {
    narrow: [
        "G",
        "F",
        "M",
        "A",
        "M",
        "G",
        "L",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "gen",
        "feb",
        "mar",
        "apr",
        "mag",
        "giu",
        "lug",
        "ago",
        "set",
        "ott",
        "nov",
        "dic"
    ],
    wide: [
        "gennaio",
        "febbraio",
        "marzo",
        "aprile",
        "maggio",
        "giugno",
        "luglio",
        "agosto",
        "settembre",
        "ottobre",
        "novembre",
        "dicembre"
    ]
};
const $ac76795327591bb7$var$dayValues = {
    narrow: [
        "D",
        "L",
        "M",
        "M",
        "G",
        "V",
        "S"
    ],
    short: [
        "dom",
        "lun",
        "mar",
        "mer",
        "gio",
        "ven",
        "sab"
    ],
    abbreviated: [
        "dom",
        "lun",
        "mar",
        "mer",
        "gio",
        "ven",
        "sab"
    ],
    wide: [
        "domenica",
        "luned\xec",
        "marted\xec",
        "mercoled\xec",
        "gioved\xec",
        "venerd\xec",
        "sabato"
    ]
};
const $ac76795327591bb7$var$dayPeriodValues = {
    narrow: {
        am: "m.",
        pm: "p.",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "mattina",
        afternoon: "pomeriggio",
        evening: "sera",
        night: "notte"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "mattina",
        afternoon: "pomeriggio",
        evening: "sera",
        night: "notte"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "mattina",
        afternoon: "pomeriggio",
        evening: "sera",
        night: "notte"
    }
};
const $ac76795327591bb7$var$formattingDayPeriodValues = {
    narrow: {
        am: "m.",
        pm: "p.",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "di mattina",
        afternoon: "del pomeriggio",
        evening: "di sera",
        night: "di notte"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "di mattina",
        afternoon: "del pomeriggio",
        evening: "di sera",
        night: "di notte"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "di mattina",
        afternoon: "del pomeriggio",
        evening: "di sera",
        night: "di notte"
    }
};
const $ac76795327591bb7$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return String(number);
};
const $ac76795327591bb7$var$localize = $ac76795327591bb7$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $ac76795327591bb7$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $ac76795327591bb7$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $ac76795327591bb7$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $ac76795327591bb7$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $ac76795327591bb7$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $ac76795327591bb7$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $ac76795327591bb7$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("5ovf5", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $01037982f6d24575$export$4659b591c19bdf3d; }, function (v) { return $01037982f6d24575$export$4659b591c19bdf3d = v; });
var $01037982f6d24575$export$4659b591c19bdf3d;
"use strict";
$01037982f6d24575$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $01037982f6d24575$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
const $01037982f6d24575$var$parseOrdinalNumberPattern = /\d+/i;
const $01037982f6d24575$var$matchEraPatterns = {
    narrow: /^(aC|dC)/i,
    abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
    wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
};
const $01037982f6d24575$var$parseEraPatterns = {
    any: [
        /^a/i,
        /^(d|e)/i
    ]
};
const $01037982f6d24575$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^t[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
const $01037982f6d24575$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $01037982f6d24575$var$matchMonthPatterns = {
    narrow: /^[gfmalsond]/i,
    abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
    wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
};
const $01037982f6d24575$var$parseMonthPatterns = {
    narrow: [
        /^g/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^g/i,
        /^l/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ge/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mag/i,
        /^gi/i,
        /^l/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $01037982f6d24575$var$matchDayPatterns = {
    narrow: /^[dlmgvs]/i,
    short: /^(do|lu|ma|me|gi|ve|sa)/i,
    abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
    wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
};
const $01037982f6d24575$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^g/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^me/i,
        /^g/i,
        /^v/i,
        /^s/i
    ]
};
const $01037982f6d24575$var$matchDayPeriodPatterns = {
    narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
    any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
};
const $01037982f6d24575$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mezza/i,
        noon: /^mezzo/i,
        morning: /mattina/i,
        afternoon: /pomeriggio/i,
        evening: /sera/i,
        night: /notte/i
    }
};
const $01037982f6d24575$var$match = $01037982f6d24575$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $01037982f6d24575$var$matchOrdinalNumberPattern,
        parsePattern: $01037982f6d24575$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $01037982f6d24575$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $01037982f6d24575$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $01037982f6d24575$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $01037982f6d24575$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $01037982f6d24575$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $01037982f6d24575$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $01037982f6d24575$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $01037982f6d24575$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $01037982f6d24575$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $01037982f6d24575$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("ivRxc", function(module, exports) {

$parcel$export(module.exports, "itCH", function () { return $d7a4a6131b64873c$export$a3f860f37034c31a; }, function (v) { return $d7a4a6131b64873c$export$a3f860f37034c31a = v; });
var $d7a4a6131b64873c$export$a3f860f37034c31a;
"use strict";
$d7a4a6131b64873c$export$a3f860f37034c31a = void 0;

var $eCReJ = parcelRequire("eCReJ");

var $eiMvS = parcelRequire("eiMvS");

var $eO0X6 = parcelRequire("eO0X6");

var $5ovf5 = parcelRequire("5ovf5");

var $gh4hQ = parcelRequire("gh4hQ");
/**
 * @category Locales
 * @summary Italian locale (Switzerland).
 * @language Italian
 * @iso-639-2 ita
 * @author Mike Peyer [@maic66](https://github.com/maic66)
 */ const $d7a4a6131b64873c$var$itCH = $d7a4a6131b64873c$export$a3f860f37034c31a = {
    code: "it-CH",
    formatDistance: $eCReJ.formatDistance,
    formatLong: $gh4hQ.formatLong,
    formatRelative: $eiMvS.formatRelative,
    localize: $eO0X6.localize,
    match: $5ovf5.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("gh4hQ", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $bd918f20baedffbd$export$cbf60ecb96cbb82f; }, function (v) { return $bd918f20baedffbd$export$cbf60ecb96cbb82f = v; });
var $bd918f20baedffbd$export$cbf60ecb96cbb82f;
"use strict";
$bd918f20baedffbd$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $bd918f20baedffbd$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd.MM.y"
};
const $bd918f20baedffbd$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $bd918f20baedffbd$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $bd918f20baedffbd$var$formatLong = $bd918f20baedffbd$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $bd918f20baedffbd$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $bd918f20baedffbd$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $bd918f20baedffbd$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});


parcelRegister("fkxck", function(module, exports) {

$parcel$export(module.exports, "ja", function () { return $b29279a8b0647e61$export$8c6f505e9474ce90; }, function (v) { return $b29279a8b0647e61$export$8c6f505e9474ce90 = v; });
var $b29279a8b0647e61$export$8c6f505e9474ce90;
"use strict";
$b29279a8b0647e61$export$8c6f505e9474ce90 = void 0;

var $cPNsj = parcelRequire("cPNsj");

var $gQRd1 = parcelRequire("gQRd1");

var $7iQ0c = parcelRequire("7iQ0c");

var $71nzx = parcelRequire("71nzx");

var $dc0WG = parcelRequire("dc0WG");
/**
 * @category Locales
 * @summary Japanese locale.
 * @language Japanese
 * @iso-639-2 jpn
 * @author Thomas Eilmsteiner [@DeMuu](https://github.com/DeMuu)
 * @author Yamagishi Kazutoshi [@ykzts](https://github.com/ykzts)
 * @author Luca Ban [@mesqueeb](https://github.com/mesqueeb)
 * @author Terrence Lam [@skyuplam](https://github.com/skyuplam)
 * @author Taiki IKeda [@so99ynoodles](https://github.com/so99ynoodles)
 */ const $b29279a8b0647e61$var$ja = $b29279a8b0647e61$export$8c6f505e9474ce90 = {
    code: "ja",
    formatDistance: $cPNsj.formatDistance,
    formatLong: $gQRd1.formatLong,
    formatRelative: $7iQ0c.formatRelative,
    localize: $71nzx.localize,
    match: $dc0WG.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("cPNsj", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $95809c5396641ebf$export$2c14ff85d6318973; }, function (v) { return $95809c5396641ebf$export$2c14ff85d6318973 = v; });
var $95809c5396641ebf$export$2c14ff85d6318973;
"use strict";
$95809c5396641ebf$export$2c14ff85d6318973 = void 0;
const $95809c5396641ebf$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1\u79D2\u672A\u6E80",
        other: "{{count}}\u79D2\u672A\u6E80",
        oneWithSuffix: "\u7D041\u79D2",
        otherWithSuffix: "\u7D04{{count}}\u79D2"
    },
    xSeconds: {
        one: "1\u79D2",
        other: "{{count}}\u79D2"
    },
    halfAMinute: "30\u79D2",
    lessThanXMinutes: {
        one: "1\u5206\u672A\u6E80",
        other: "{{count}}\u5206\u672A\u6E80",
        oneWithSuffix: "\u7D041\u5206",
        otherWithSuffix: "\u7D04{{count}}\u5206"
    },
    xMinutes: {
        one: "1\u5206",
        other: "{{count}}\u5206"
    },
    aboutXHours: {
        one: "\u7D041\u6642\u9593",
        other: "\u7D04{{count}}\u6642\u9593"
    },
    xHours: {
        one: "1\u6642\u9593",
        other: "{{count}}\u6642\u9593"
    },
    xDays: {
        one: "1\u65E5",
        other: "{{count}}\u65E5"
    },
    aboutXWeeks: {
        one: "\u7D041\u9031\u9593",
        other: "\u7D04{{count}}\u9031\u9593"
    },
    xWeeks: {
        one: "1\u9031\u9593",
        other: "{{count}}\u9031\u9593"
    },
    aboutXMonths: {
        one: "\u7D041\u304B\u6708",
        other: "\u7D04{{count}}\u304B\u6708"
    },
    xMonths: {
        one: "1\u304B\u6708",
        other: "{{count}}\u304B\u6708"
    },
    aboutXYears: {
        one: "\u7D041\u5E74",
        other: "\u7D04{{count}}\u5E74"
    },
    xYears: {
        one: "1\u5E74",
        other: "{{count}}\u5E74"
    },
    overXYears: {
        one: "1\u5E74\u4EE5\u4E0A",
        other: "{{count}}\u5E74\u4EE5\u4E0A"
    },
    almostXYears: {
        one: "1\u5E74\u8FD1\u304F",
        other: "{{count}}\u5E74\u8FD1\u304F"
    }
};
const $95809c5396641ebf$var$formatDistance = (token, count, options)=>{
    options = options || {};
    let result;
    const tokenValue = $95809c5396641ebf$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) {
        if (options.addSuffix && tokenValue.oneWithSuffix) result = tokenValue.oneWithSuffix;
        else result = tokenValue.one;
    } else if (options.addSuffix && tokenValue.otherWithSuffix) result = tokenValue.otherWithSuffix.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5F8C";
        else return result + "\u524D";
    }
    return result;
};
$95809c5396641ebf$export$2c14ff85d6318973 = $95809c5396641ebf$var$formatDistance;

});

parcelRegister("gQRd1", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $c44ac6dd8f2ba2a0$export$cbf60ecb96cbb82f; }, function (v) { return $c44ac6dd8f2ba2a0$export$cbf60ecb96cbb82f = v; });
var $c44ac6dd8f2ba2a0$export$cbf60ecb96cbb82f;
"use strict";
$c44ac6dd8f2ba2a0$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $c44ac6dd8f2ba2a0$var$dateFormats = {
    full: "y\u5E74M\u6708d\u65E5EEEE",
    long: "y\u5E74M\u6708d\u65E5",
    medium: "y/MM/dd",
    short: "y/MM/dd"
};
const $c44ac6dd8f2ba2a0$var$timeFormats = {
    full: "H\u6642mm\u5206ss\u79D2 zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $c44ac6dd8f2ba2a0$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $c44ac6dd8f2ba2a0$var$formatLong = $c44ac6dd8f2ba2a0$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $c44ac6dd8f2ba2a0$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $c44ac6dd8f2ba2a0$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $c44ac6dd8f2ba2a0$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("7iQ0c", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $55128d656bee4c55$export$8fbbfd65594f46a0; }, function (v) { return $55128d656bee4c55$export$8fbbfd65594f46a0 = v; });
var $55128d656bee4c55$export$8fbbfd65594f46a0;
"use strict";
$55128d656bee4c55$export$8fbbfd65594f46a0 = void 0;
const $55128d656bee4c55$var$formatRelativeLocale = {
    lastWeek: "\u5148\u9031\u306Eeeee\u306Ep",
    yesterday: "\u6628\u65E5\u306Ep",
    today: "\u4ECA\u65E5\u306Ep",
    tomorrow: "\u660E\u65E5\u306Ep",
    nextWeek: "\u7FCC\u9031\u306Eeeee\u306Ep",
    other: "P"
};
const $55128d656bee4c55$var$formatRelative = (token, _date, _baseDate, _options)=>{
    return $55128d656bee4c55$var$formatRelativeLocale[token];
};
$55128d656bee4c55$export$8fbbfd65594f46a0 = $55128d656bee4c55$var$formatRelative;

});

parcelRegister("71nzx", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $51cae95da331b469$export$b3bd0bc58e36cd63; }, function (v) { return $51cae95da331b469$export$b3bd0bc58e36cd63 = v; });
var $51cae95da331b469$export$b3bd0bc58e36cd63;
"use strict";
$51cae95da331b469$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $51cae95da331b469$var$eraValues = {
    narrow: [
        "BC",
        "AC"
    ],
    abbreviated: [
        "\u7D00\u5143\u524D",
        "\u897F\u66A6"
    ],
    wide: [
        "\u7D00\u5143\u524D",
        "\u897F\u66A6"
    ]
};
const $51cae95da331b469$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "\u7B2C1\u56DB\u534A\u671F",
        "\u7B2C2\u56DB\u534A\u671F",
        "\u7B2C3\u56DB\u534A\u671F",
        "\u7B2C4\u56DB\u534A\u671F"
    ]
};
const $51cae95da331b469$var$monthValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ]
};
const $51cae95da331b469$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    short: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    abbreviated: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    wide: [
        "\u65E5\u66DC\u65E5",
        "\u6708\u66DC\u65E5",
        "\u706B\u66DC\u65E5",
        "\u6C34\u66DC\u65E5",
        "\u6728\u66DC\u65E5",
        "\u91D1\u66DC\u65E5",
        "\u571F\u66DC\u65E5"
    ]
};
const $51cae95da331b469$var$dayPeriodValues = {
    narrow: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    abbreviated: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    wide: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    }
};
const $51cae95da331b469$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    abbreviated: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    wide: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    }
};
const $51cae95da331b469$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    const unit = String(options?.unit);
    switch(unit){
        case "year":
            return `${number}\u{5E74}`;
        case "quarter":
            return `\u{7B2C}${number}\u{56DB}\u{534A}\u{671F}`;
        case "month":
            return `${number}\u{6708}`;
        case "week":
            return `\u{7B2C}${number}\u{9031}`;
        case "date":
            return `${number}\u{65E5}`;
        case "hour":
            return `${number}\u{6642}`;
        case "minute":
            return `${number}\u{5206}`;
        case "second":
            return `${number}\u{79D2}`;
        default:
            return `${number}`;
    }
};
const $51cae95da331b469$var$localize = $51cae95da331b469$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $51cae95da331b469$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $51cae95da331b469$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $51cae95da331b469$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>Number(quarter) - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $51cae95da331b469$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $51cae95da331b469$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $51cae95da331b469$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $51cae95da331b469$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("dc0WG", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $99ad211cbe8b62af$export$4659b591c19bdf3d; }, function (v) { return $99ad211cbe8b62af$export$4659b591c19bdf3d = v; });
var $99ad211cbe8b62af$export$4659b591c19bdf3d;
"use strict";
$99ad211cbe8b62af$export$4659b591c19bdf3d = void 0;

var $8RZeP = parcelRequire("8RZeP");

var $kQYK9 = parcelRequire("kQYK9");
const $99ad211cbe8b62af$var$matchOrdinalNumberPattern = /^第?\d+(年|四半期|月|週|日|時|分|秒)?/i;
const $99ad211cbe8b62af$var$parseOrdinalNumberPattern = /\d+/i;
const $99ad211cbe8b62af$var$matchEraPatterns = {
    narrow: /^(B\.?C\.?|A\.?D\.?)/i,
    abbreviated: /^(紀元[前後]|西暦)/i,
    wide: /^(紀元[前後]|西暦)/i
};
const $99ad211cbe8b62af$var$parseEraPatterns = {
    narrow: [
        /^B/i,
        /^A/i
    ],
    any: [
        /^(紀元前)/i,
        /^(西暦|紀元後)/i
    ]
};
const $99ad211cbe8b62af$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^Q[1234]/i,
    wide: /^第[1234一二三四１２３４]四半期/i
};
const $99ad211cbe8b62af$var$parseQuarterPatterns = {
    any: [
        /(1|一|１)/i,
        /(2|二|２)/i,
        /(3|三|３)/i,
        /(4|四|４)/i
    ]
};
const $99ad211cbe8b62af$var$matchMonthPatterns = {
    narrow: /^([123456789]|1[012])/,
    abbreviated: /^([123456789]|1[012])月/i,
    wide: /^([123456789]|1[012])月/i
};
const $99ad211cbe8b62af$var$parseMonthPatterns = {
    any: [
        /^1\D/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
const $99ad211cbe8b62af$var$matchDayPatterns = {
    narrow: /^[日月火水木金土]/,
    short: /^[日月火水木金土]/,
    abbreviated: /^[日月火水木金土]/,
    wide: /^[日月火水木金土]曜日/
};
const $99ad211cbe8b62af$var$parseDayPatterns = {
    any: [
        /^日/,
        /^月/,
        /^火/,
        /^水/,
        /^木/,
        /^金/,
        /^土/
    ]
};
const $99ad211cbe8b62af$var$matchDayPeriodPatterns = {
    any: /^(AM|PM|午前|午後|正午|深夜|真夜中|夜|朝)/i
};
const $99ad211cbe8b62af$var$parseDayPeriodPatterns = {
    any: {
        am: /^(A|午前)/i,
        pm: /^(P|午後)/i,
        midnight: /^深夜|真夜中/i,
        noon: /^正午/i,
        morning: /^朝/i,
        afternoon: /^午後/i,
        evening: /^夜/i,
        night: /^深夜/i
    }
};
const $99ad211cbe8b62af$var$match = $99ad211cbe8b62af$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $99ad211cbe8b62af$var$matchOrdinalNumberPattern,
        parsePattern: $99ad211cbe8b62af$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $99ad211cbe8b62af$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $99ad211cbe8b62af$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $99ad211cbe8b62af$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $99ad211cbe8b62af$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $99ad211cbe8b62af$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $99ad211cbe8b62af$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $99ad211cbe8b62af$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $99ad211cbe8b62af$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $99ad211cbe8b62af$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $99ad211cbe8b62af$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("4Fbjg", function(module, exports) {

$parcel$export(module.exports, "jaHira", function () { return $3653c39ccd4a1749$export$f0ae70b1ccde4a97; }, function (v) { return $3653c39ccd4a1749$export$f0ae70b1ccde4a97 = v; });
var $3653c39ccd4a1749$export$f0ae70b1ccde4a97;
"use strict";
$3653c39ccd4a1749$export$f0ae70b1ccde4a97 = void 0;

var $5gLMY = parcelRequire("5gLMY");

var $bLzm6 = parcelRequire("bLzm6");

var $fVPUn = parcelRequire("fVPUn");

var $6fLz7 = parcelRequire("6fLz7");

var $7hpsS = parcelRequire("7hpsS");
/**
 * @category Locales
 * @summary Japanese (Hiragana) locale.
 * @language Japanese (Hiragana)
 * @iso-639-2 jpn
 * @author Eri Hiramatsu [@Eritutteo](https://github.com/Eritutteo)
 */ const $3653c39ccd4a1749$var$jaHira = $3653c39ccd4a1749$export$f0ae70b1ccde4a97 = {
    code: "ja-Hira",
    formatDistance: $5gLMY.formatDistance,
    formatLong: $bLzm6.formatLong,
    formatRelative: $fVPUn.formatRelative,
    localize: $6fLz7.localize,
    match: $7hpsS.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("5gLMY", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $3d63843b320bcdc7$export$2c14ff85d6318973; }, function (v) { return $3d63843b320bcdc7$export$2c14ff85d6318973 = v; });
var $3d63843b320bcdc7$export$2c14ff85d6318973;
"use strict";
$3d63843b320bcdc7$export$2c14ff85d6318973 = void 0;
const $3d63843b320bcdc7$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1\u3073\u3087\u3046\u307F\u307E\u3093",
        other: "{{count}}\u3073\u3087\u3046\u307F\u307E\u3093",
        oneWithSuffix: "\u3084\u304F1\u3073\u3087\u3046",
        otherWithSuffix: "\u3084\u304F{{count}}\u3073\u3087\u3046"
    },
    xSeconds: {
        one: "1\u3073\u3087\u3046",
        other: "{{count}}\u3073\u3087\u3046"
    },
    halfAMinute: "30\u3073\u3087\u3046",
    lessThanXMinutes: {
        one: "1\u3077\u3093\u307F\u307E\u3093",
        other: "{{count}}\u3075\u3093\u307F\u307E\u3093",
        oneWithSuffix: "\u3084\u304F1\u3077\u3093",
        otherWithSuffix: "\u3084\u304F{{count}}\u3075\u3093"
    },
    xMinutes: {
        one: "1\u3077\u3093",
        other: "{{count}}\u3075\u3093"
    },
    aboutXHours: {
        one: "\u3084\u304F1\u3058\u304B\u3093",
        other: "\u3084\u304F{{count}}\u3058\u304B\u3093"
    },
    xHours: {
        one: "1\u3058\u304B\u3093",
        other: "{{count}}\u3058\u304B\u3093"
    },
    xDays: {
        one: "1\u306B\u3061",
        other: "{{count}}\u306B\u3061"
    },
    aboutXWeeks: {
        one: "\u3084\u304F1\u3057\u3085\u3046\u304B\u3093",
        other: "\u3084\u304F{{count}}\u3057\u3085\u3046\u304B\u3093"
    },
    xWeeks: {
        one: "1\u3057\u3085\u3046\u304B\u3093",
        other: "{{count}}\u3057\u3085\u3046\u304B\u3093"
    },
    aboutXMonths: {
        one: "\u3084\u304F1\u304B\u3052\u3064",
        other: "\u3084\u304F{{count}}\u304B\u3052\u3064"
    },
    xMonths: {
        one: "1\u304B\u3052\u3064",
        other: "{{count}}\u304B\u3052\u3064"
    },
    aboutXYears: {
        one: "\u3084\u304F1\u306D\u3093",
        other: "\u3084\u304F{{count}}\u306D\u3093"
    },
    xYears: {
        one: "1\u306D\u3093",
        other: "{{count}}\u306D\u3093"
    },
    overXYears: {
        one: "1\u306D\u3093\u3044\u3058\u3087\u3046",
        other: "{{count}}\u306D\u3093\u3044\u3058\u3087\u3046"
    },
    almostXYears: {
        one: "1\u306D\u3093\u3061\u304B\u304F",
        other: "{{count}}\u306D\u3093\u3061\u304B\u304F"
    }
};
const $3d63843b320bcdc7$var$formatDistance = (token, count, options)=>{
    options = options || {};
    let result;
    const tokenValue = $3d63843b320bcdc7$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) {
        if (options.addSuffix && tokenValue.oneWithSuffix) result = tokenValue.oneWithSuffix;
        else result = tokenValue.one;
    } else if (options.addSuffix && tokenValue.otherWithSuffix) result = tokenValue.otherWithSuffix.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u3042\u3068";
        else return result + "\u307E\u3048";
    }
    return result;
};
$3d63843b320bcdc7$export$2c14ff85d6318973 = $3d63843b320bcdc7$var$formatDistance;

});

parcelRegister("bLzm6", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $890f8257d3812b17$export$cbf60ecb96cbb82f; }, function (v) { return $890f8257d3812b17$export$cbf60ecb96cbb82f = v; });
var $890f8257d3812b17$export$cbf60ecb96cbb82f;
"use strict";
$890f8257d3812b17$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $890f8257d3812b17$var$dateFormats = {
    full: "y\u306D\u3093M\u304C\u3064d\u306B\u3061EEEE",
    long: "y\u306D\u3093M\u304C\u3064d\u306B\u3061",
    medium: "y/MM/dd",
    short: "y/MM/dd"
};
const $890f8257d3812b17$var$timeFormats = {
    full: "H\u3058mm\u3075\u3093ss\u3073\u3087\u3046 zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $890f8257d3812b17$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $890f8257d3812b17$var$formatLong = $890f8257d3812b17$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $890f8257d3812b17$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $890f8257d3812b17$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $890f8257d3812b17$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("fVPUn", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $b99471c646b79e56$export$8fbbfd65594f46a0; }, function (v) { return $b99471c646b79e56$export$8fbbfd65594f46a0 = v; });
var $b99471c646b79e56$export$8fbbfd65594f46a0;
"use strict";
$b99471c646b79e56$export$8fbbfd65594f46a0 = void 0;
const $b99471c646b79e56$var$formatRelativeLocale = {
    lastWeek: "\u305B\u3093\u3057\u3085\u3046\u306Eeeee\u306Ep",
    yesterday: "\u304D\u306E\u3046\u306Ep",
    today: "\u304D\u3087\u3046\u306Ep",
    tomorrow: "\u3042\u3057\u305F\u306Ep",
    nextWeek: "\u3088\u304F\u3057\u3085\u3046\u306Eeeee\u306Ep",
    other: "P"
};
const $b99471c646b79e56$var$formatRelative = (token, _date, _baseDate, _options)=>{
    return $b99471c646b79e56$var$formatRelativeLocale[token];
};
$b99471c646b79e56$export$8fbbfd65594f46a0 = $b99471c646b79e56$var$formatRelative;

});

parcelRegister("6fLz7", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $48d90a4a81445ecb$export$b3bd0bc58e36cd63; }, function (v) { return $48d90a4a81445ecb$export$b3bd0bc58e36cd63 = v; });
var $48d90a4a81445ecb$export$b3bd0bc58e36cd63;
"use strict";
$48d90a4a81445ecb$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $48d90a4a81445ecb$var$eraValues = {
    narrow: [
        "BC",
        "AC"
    ],
    abbreviated: [
        "\u304D\u3052\u3093\u305C\u3093",
        "\u305B\u3044\u308C\u304D"
    ],
    wide: [
        "\u304D\u3052\u3093\u305C\u3093",
        "\u305B\u3044\u308C\u304D"
    ]
};
const $48d90a4a81445ecb$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "\u3060\u30441\u3057\u306F\u3093\u304D",
        "\u3060\u30442\u3057\u306F\u3093\u304D",
        "\u3060\u30443\u3057\u306F\u3093\u304D",
        "\u3060\u30444\u3057\u306F\u3093\u304D"
    ]
};
const $48d90a4a81445ecb$var$monthValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12"
    ],
    abbreviated: [
        "1\u304C\u3064",
        "2\u304C\u3064",
        "3\u304C\u3064",
        "4\u304C\u3064",
        "5\u304C\u3064",
        "6\u304C\u3064",
        "7\u304C\u3064",
        "8\u304C\u3064",
        "9\u304C\u3064",
        "10\u304C\u3064",
        "11\u304C\u3064",
        "12\u304C\u3064"
    ],
    wide: [
        "1\u304C\u3064",
        "2\u304C\u3064",
        "3\u304C\u3064",
        "4\u304C\u3064",
        "5\u304C\u3064",
        "6\u304C\u3064",
        "7\u304C\u3064",
        "8\u304C\u3064",
        "9\u304C\u3064",
        "10\u304C\u3064",
        "11\u304C\u3064",
        "12\u304C\u3064"
    ]
};
const $48d90a4a81445ecb$var$dayValues = {
    narrow: [
        "\u306B\u3061",
        "\u3052\u3064",
        "\u304B",
        "\u3059\u3044",
        "\u3082\u304F",
        "\u304D\u3093",
        "\u3069"
    ],
    short: [
        "\u306B\u3061",
        "\u3052\u3064",
        "\u304B",
        "\u3059\u3044",
        "\u3082\u304F",
        "\u304D\u3093",
        "\u3069"
    ],
    abbreviated: [
        "\u306B\u3061",
        "\u3052\u3064",
        "\u304B",
        "\u3059\u3044",
        "\u3082\u304F",
        "\u304D\u3093",
        "\u3069"
    ],
    wide: [
        "\u306B\u3061\u3088\u3046\u3073",
        "\u3052\u3064\u3088\u3046\u3073",
        "\u304B\u3088\u3046\u3073",
        "\u3059\u3044\u3088\u3046\u3073",
        "\u3082\u304F\u3088\u3046\u3073",
        "\u304D\u3093\u3088\u3046\u3073",
        "\u3069\u3088\u3046\u3073"
    ]
};
const $48d90a4a81445ecb$var$dayPeriodValues = {
    narrow: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    abbreviated: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    wide: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    }
};
const $48d90a4a81445ecb$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    abbreviated: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    wide: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    }
};
const $48d90a4a81445ecb$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    const unit = String(options?.unit);
    switch(unit){
        case "year":
            return `${number}\u{306D}\u{3093}`;
        case "quarter":
            return `\u{3060}\u{3044}${number}\u{3057}\u{306F}\u{3093}\u{304D}`;
        case "month":
            return `${number}\u{304C}\u{3064}`;
        case "week":
            return `\u{3060}\u{3044}${number}\u{3057}\u{3085}\u{3046}`;
        case "date":
            return `${number}\u{306B}\u{3061}`;
        case "hour":
            return `${number}\u{3058}`;
        case "minute":
            return `${number}\u{3075}\u{3093}`;
        case "second":
            return `${number}\u{3073}\u{3087}\u{3046}`;
        default:
            return `${number}`;
    }
};
const $48d90a4a81445ecb$var$localize = $48d90a4a81445ecb$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $48d90a4a81445ecb$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $48d90a4a81445ecb$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $48d90a4a81445ecb$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>Number(quarter) - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $48d90a4a81445ecb$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $48d90a4a81445ecb$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $48d90a4a81445ecb$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $48d90a4a81445ecb$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("7hpsS", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $54cddfb1fc8879e4$export$4659b591c19bdf3d; }, function (v) { return $54cddfb1fc8879e4$export$4659b591c19bdf3d = v; });
var $54cddfb1fc8879e4$export$4659b591c19bdf3d;
"use strict";
$54cddfb1fc8879e4$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $54cddfb1fc8879e4$var$matchOrdinalNumberPattern = /^だ?い?\d+(ねん|しはんき|がつ|しゅう|にち|じ|ふん|びょう)?/i;
const $54cddfb1fc8879e4$var$parseOrdinalNumberPattern = /\d+/i;
const $54cddfb1fc8879e4$var$matchEraPatterns = {
    narrow: /^(B\.?C\.?|A\.?D\.?)/i,
    abbreviated: /^(きげん[前後]|せいれき)/i,
    wide: /^(きげん[前後]|せいれき)/i
};
const $54cddfb1fc8879e4$var$parseEraPatterns = {
    narrow: [
        /^B/i,
        /^A/i
    ],
    any: [
        /^(きげんぜん)/i,
        /^(せいれき|きげんご)/i
    ]
};
const $54cddfb1fc8879e4$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^Q[1234]/i,
    wide: /^だい[1234一二三四１２３４]しはんき/i
};
const $54cddfb1fc8879e4$var$parseQuarterPatterns = {
    any: [
        /(1|一|１)/i,
        /(2|二|２)/i,
        /(3|三|３)/i,
        /(4|四|４)/i
    ]
};
const $54cddfb1fc8879e4$var$matchMonthPatterns = {
    narrow: /^([123456789]|1[012])/,
    abbreviated: /^([123456789]|1[012])がつ/i,
    wide: /^([123456789]|1[012])がつ/i
};
const $54cddfb1fc8879e4$var$parseMonthPatterns = {
    any: [
        /^1\D/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
const $54cddfb1fc8879e4$var$matchDayPatterns = {
    narrow: /^(にち|げつ|か|すい|もく|きん|ど)/,
    short: /^(にち|げつ|か|すい|もく|きん|ど)/,
    abbreviated: /^(にち|げつ|か|すい|もく|きん|ど)/,
    wide: /^(にち|げつ|か|すい|もく|きん|ど)ようび/
};
const $54cddfb1fc8879e4$var$parseDayPatterns = {
    any: [
        /^にち/,
        /^げつ/,
        /^か/,
        /^すい/,
        /^もく/,
        /^きん/,
        /^ど/
    ]
};
const $54cddfb1fc8879e4$var$matchDayPeriodPatterns = {
    any: /^(AM|PM|ごぜん|ごご|しょうご|しんや|まよなか|よる|あさ)/i
};
const $54cddfb1fc8879e4$var$parseDayPeriodPatterns = {
    any: {
        am: /^(A|ごぜん)/i,
        pm: /^(P|ごご)/i,
        midnight: /^しんや|まよなか/i,
        noon: /^しょうご/i,
        morning: /^あさ/i,
        afternoon: /^ごご/i,
        evening: /^よる/i,
        night: /^しんや/i
    }
};
const $54cddfb1fc8879e4$var$match = $54cddfb1fc8879e4$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $54cddfb1fc8879e4$var$matchOrdinalNumberPattern,
        parsePattern: $54cddfb1fc8879e4$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $54cddfb1fc8879e4$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $54cddfb1fc8879e4$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $54cddfb1fc8879e4$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $54cddfb1fc8879e4$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $54cddfb1fc8879e4$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $54cddfb1fc8879e4$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $54cddfb1fc8879e4$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $54cddfb1fc8879e4$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $54cddfb1fc8879e4$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $54cddfb1fc8879e4$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("jCNiJ", function(module, exports) {

$parcel$export(module.exports, "ka", function () { return $e497cf1e07165095$export$b20f780fa2c7402; }, function (v) { return $e497cf1e07165095$export$b20f780fa2c7402 = v; });
var $e497cf1e07165095$export$b20f780fa2c7402;
"use strict";
$e497cf1e07165095$export$b20f780fa2c7402 = void 0;

var $6k5DG = parcelRequire("6k5DG");

var $iVit4 = parcelRequire("iVit4");

var $3rRT5 = parcelRequire("3rRT5");

var $cPv4Z = parcelRequire("cPv4Z");

var $jkpUQ = parcelRequire("jkpUQ");
/**
 * @category Locales
 * @summary Georgian locale.
 * @language Georgian
 * @iso-639-2 geo
 * @author Lado Lomidze [@Landish](https://github.com/Landish)
 * @author Nick Shvelidze [@shvelo](https://github.com/shvelo)
 */ const $e497cf1e07165095$var$ka = $e497cf1e07165095$export$b20f780fa2c7402 = {
    code: "ka",
    formatDistance: $6k5DG.formatDistance,
    formatLong: $iVit4.formatLong,
    formatRelative: $3rRT5.formatRelative,
    localize: $cPv4Z.localize,
    match: $jkpUQ.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("6k5DG", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $49a8fc236c1fc403$export$2c14ff85d6318973; }, function (v) { return $49a8fc236c1fc403$export$2c14ff85d6318973 = v; });
var $49a8fc236c1fc403$export$2c14ff85d6318973;
"use strict";
$49a8fc236c1fc403$export$2c14ff85d6318973 = void 0;
const $49a8fc236c1fc403$var$formatDistanceLocale = {
    lessThanXSeconds: {
        past: "{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8",
        future: "{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10E8\u10D8"
    },
    xSeconds: {
        past: "{{count}} \u10EC\u10D0\u10DB\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D0\u10DB\u10D8",
        future: "{{count}} \u10EC\u10D0\u10DB\u10E8\u10D8"
    },
    halfAMinute: {
        past: "\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10D8",
        future: "\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10E8\u10D8"
    },
    lessThanXMinutes: {
        past: "{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8",
        future: "{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10E8\u10D8"
    },
    xMinutes: {
        past: "{{count}} \u10EC\u10E3\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10E3\u10D7\u10D8",
        future: "{{count}} \u10EC\u10E3\u10D7\u10E8\u10D8"
    },
    aboutXHours: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10D8",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10E8\u10D8"
    },
    xHours: {
        past: "{{count}} \u10E1\u10D0\u10D0\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10E1\u10D0\u10D0\u10D7\u10D8",
        future: "{{count}} \u10E1\u10D0\u10D0\u10D7\u10E8\u10D8"
    },
    xDays: {
        past: "{{count}} \u10D3\u10E6\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10D3\u10E6\u10D4",
        future: "{{count}} \u10D3\u10E6\u10D4\u10E8\u10D8"
    },
    aboutXWeeks: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E8\u10D8"
    },
    xWeeks: {
        past: "{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E1 \u10D9\u10D5\u10D8\u10E0\u10D0",
        present: "{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0",
        future: "{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E8\u10D8"
    },
    aboutXMonths: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D4",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D4\u10E8\u10D8"
    },
    xMonths: {
        past: "{{count}} \u10D7\u10D5\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10D7\u10D5\u10D4",
        future: "{{count}} \u10D7\u10D5\u10D4\u10E8\u10D8"
    },
    aboutXYears: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10D4\u10DA\u10D8",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
    },
    xYears: {
        past: "{{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D4\u10DA\u10D8",
        future: "{{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
    },
    overXYears: {
        past: "{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8",
        future: "{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2"
    },
    almostXYears: {
        past: "\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10D4\u10DA\u10D8",
        future: "\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
    }
};
const $49a8fc236c1fc403$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $49a8fc236c1fc403$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (options?.addSuffix && options.comparison && options.comparison > 0) result = tokenValue.future.replace("{{count}}", String(count));
    else if (options?.addSuffix) result = tokenValue.past.replace("{{count}}", String(count));
    else result = tokenValue.present.replace("{{count}}", String(count));
    return result;
};
$49a8fc236c1fc403$export$2c14ff85d6318973 = $49a8fc236c1fc403$var$formatDistance;

});

parcelRegister("iVit4", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $dc6be02d9f32e1da$export$cbf60ecb96cbb82f; }, function (v) { return $dc6be02d9f32e1da$export$cbf60ecb96cbb82f = v; });
var $dc6be02d9f32e1da$export$cbf60ecb96cbb82f;
"use strict";
$dc6be02d9f32e1da$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $dc6be02d9f32e1da$var$dateFormats = {
    full: "EEEE, do MMMM, y",
    long: "do, MMMM, y",
    medium: "d, MMM, y",
    short: "dd/MM/yyyy"
};
const $dc6be02d9f32e1da$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $dc6be02d9f32e1da$var$dateTimeFormats = {
    full: "{{date}} {{time}}'-\u10D6\u10D4'",
    long: "{{date}} {{time}}'-\u10D6\u10D4'",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $dc6be02d9f32e1da$var$formatLong = $dc6be02d9f32e1da$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $dc6be02d9f32e1da$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $dc6be02d9f32e1da$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $dc6be02d9f32e1da$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("3rRT5", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $282db1a6840c0272$export$8fbbfd65594f46a0; }, function (v) { return $282db1a6840c0272$export$8fbbfd65594f46a0 = v; });
var $282db1a6840c0272$export$8fbbfd65594f46a0;
"use strict";
$282db1a6840c0272$export$8fbbfd65594f46a0 = void 0;
const $282db1a6840c0272$var$formatRelativeLocale = {
    lastWeek: "'\u10EC\u10D8\u10DC\u10D0' eeee p'-\u10D6\u10D4'",
    yesterday: "'\u10D2\u10E3\u10E8\u10D8\u10DC' p'-\u10D6\u10D4'",
    today: "'\u10D3\u10E6\u10D4\u10E1' p'-\u10D6\u10D4'",
    tomorrow: "'\u10EE\u10D5\u10D0\u10DA' p'-\u10D6\u10D4'",
    nextWeek: "'\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8' eeee p'-\u10D6\u10D4'",
    other: "P"
};
const $282db1a6840c0272$var$formatRelative = (token, _date, _baseDate, _options)=>$282db1a6840c0272$var$formatRelativeLocale[token];
$282db1a6840c0272$export$8fbbfd65594f46a0 = $282db1a6840c0272$var$formatRelative;

});

parcelRegister("cPv4Z", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $95725b3456a4d534$export$b3bd0bc58e36cd63; }, function (v) { return $95725b3456a4d534$export$b3bd0bc58e36cd63 = v; });
var $95725b3456a4d534$export$b3bd0bc58e36cd63;
"use strict";
$95725b3456a4d534$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $95725b3456a4d534$var$eraValues = {
    narrow: [
        "\u10E9.\u10EC-\u10DB\u10D3\u10D4",
        "\u10E9.\u10EC"
    ],
    abbreviated: [
        "\u10E9\u10D5.\u10EC-\u10DB\u10D3\u10D4",
        "\u10E9\u10D5.\u10EC"
    ],
    wide: [
        "\u10E9\u10D5\u10D4\u10DC\u10E1 \u10EC\u10D4\u10DA\u10D7\u10D0\u10E6\u10E0\u10D8\u10EA\u10EE\u10D5\u10D0\u10DB\u10D3\u10D4",
        "\u10E9\u10D5\u10D4\u10DC\u10D8 \u10EC\u10D4\u10DA\u10D7\u10D0\u10E6\u10E0\u10D8\u10EA\u10EE\u10D5\u10D8\u10D7"
    ]
};
const $95725b3456a4d534$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-\u10DA\u10D8 \u10D9\u10D5",
        "2-\u10D4 \u10D9\u10D5",
        "3-\u10D4 \u10D9\u10D5",
        "4-\u10D4 \u10D9\u10D5"
    ],
    wide: [
        "1-\u10DA\u10D8 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8",
        "2-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8",
        "3-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8",
        "4-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $95725b3456a4d534$var$monthValues = {
    narrow: [
        "\u10D8\u10D0",
        "\u10D7\u10D4",
        "\u10DB\u10D0",
        "\u10D0\u10DE",
        "\u10DB\u10E1",
        "\u10D5\u10DC",
        "\u10D5\u10DA",
        "\u10D0\u10D2",
        "\u10E1\u10D4",
        "\u10DD\u10E5",
        "\u10DC\u10DD",
        "\u10D3\u10D4"
    ],
    abbreviated: [
        "\u10D8\u10D0\u10DC",
        "\u10D7\u10D4\u10D1",
        "\u10DB\u10D0\u10E0",
        "\u10D0\u10DE\u10E0",
        "\u10DB\u10D0\u10D8",
        "\u10D8\u10D5\u10DC",
        "\u10D8\u10D5\u10DA",
        "\u10D0\u10D2\u10D5",
        "\u10E1\u10D4\u10E5",
        "\u10DD\u10E5\u10E2",
        "\u10DC\u10DD\u10D4",
        "\u10D3\u10D4\u10D9"
    ],
    wide: [
        "\u10D8\u10D0\u10DC\u10D5\u10D0\u10E0\u10D8",
        "\u10D7\u10D4\u10D1\u10D4\u10E0\u10D5\u10D0\u10DA\u10D8",
        "\u10DB\u10D0\u10E0\u10E2\u10D8",
        "\u10D0\u10DE\u10E0\u10D8\u10DA\u10D8",
        "\u10DB\u10D0\u10D8\u10E1\u10D8",
        "\u10D8\u10D5\u10DC\u10D8\u10E1\u10D8",
        "\u10D8\u10D5\u10DA\u10D8\u10E1\u10D8",
        "\u10D0\u10D2\u10D5\u10D8\u10E1\u10E2\u10DD",
        "\u10E1\u10D4\u10E5\u10E2\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8",
        "\u10DD\u10E5\u10E2\u10DD\u10DB\u10D1\u10D4\u10E0\u10D8",
        "\u10DC\u10DD\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8",
        "\u10D3\u10D4\u10D9\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8"
    ]
};
const $95725b3456a4d534$var$dayValues = {
    narrow: [
        "\u10D9\u10D5",
        "\u10DD\u10E0",
        "\u10E1\u10D0",
        "\u10DD\u10D7",
        "\u10EE\u10E3",
        "\u10DE\u10D0",
        "\u10E8\u10D0"
    ],
    short: [
        "\u10D9\u10D5\u10D8",
        "\u10DD\u10E0\u10E8",
        "\u10E1\u10D0\u10DB",
        "\u10DD\u10D7\u10EE",
        "\u10EE\u10E3\u10D7",
        "\u10DE\u10D0\u10E0",
        "\u10E8\u10D0\u10D1"
    ],
    abbreviated: [
        "\u10D9\u10D5\u10D8",
        "\u10DD\u10E0\u10E8",
        "\u10E1\u10D0\u10DB",
        "\u10DD\u10D7\u10EE",
        "\u10EE\u10E3\u10D7",
        "\u10DE\u10D0\u10E0",
        "\u10E8\u10D0\u10D1"
    ],
    wide: [
        "\u10D9\u10D5\u10D8\u10E0\u10D0",
        "\u10DD\u10E0\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10E1\u10D0\u10DB\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10DD\u10D7\u10EE\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10EE\u10E3\u10D7\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10DE\u10D0\u10E0\u10D0\u10E1\u10D9\u10D4\u10D5\u10D8",
        "\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8"
    ]
};
const $95725b3456a4d534$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
        morning: "\u10D3\u10D8\u10DA\u10D0",
        afternoon: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        night: "\u10E6\u10D0\u10DB\u10D4"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
        morning: "\u10D3\u10D8\u10DA\u10D0",
        afternoon: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        night: "\u10E6\u10D0\u10DB\u10D4"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
        morning: "\u10D3\u10D8\u10DA\u10D0",
        afternoon: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        night: "\u10E6\u10D0\u10DB\u10D4"
    }
};
const $95725b3456a4d534$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
        morning: "\u10D3\u10D8\u10DA\u10D8\u10D7",
        afternoon: "\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
        night: "\u10E6\u10D0\u10DB\u10D8\u10D7"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
        morning: "\u10D3\u10D8\u10DA\u10D8\u10D7",
        afternoon: "\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
        night: "\u10E6\u10D0\u10DB\u10D8\u10D7"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
        morning: "\u10D3\u10D8\u10DA\u10D8\u10D7",
        afternoon: "\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
        night: "\u10E6\u10D0\u10DB\u10D8\u10D7"
    }
};
const $95725b3456a4d534$var$ordinalNumber = (dirtyNumber)=>{
    const number = Number(dirtyNumber);
    if (number === 1) return number + "-\u10DA\u10D8";
    return number + "-\u10D4";
};
const $95725b3456a4d534$var$localize = $95725b3456a4d534$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $95725b3456a4d534$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $95725b3456a4d534$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $95725b3456a4d534$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $95725b3456a4d534$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $95725b3456a4d534$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $95725b3456a4d534$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $95725b3456a4d534$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("jkpUQ", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $e123fcf255ba9600$export$4659b591c19bdf3d; }, function (v) { return $e123fcf255ba9600$export$4659b591c19bdf3d = v; });
var $e123fcf255ba9600$export$4659b591c19bdf3d;
"use strict";
$e123fcf255ba9600$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $e123fcf255ba9600$var$matchOrdinalNumberPattern = /^(\d+)(-ლი|-ე)?/i;
const $e123fcf255ba9600$var$parseOrdinalNumberPattern = /\d+/i;
const $e123fcf255ba9600$var$matchEraPatterns = {
    narrow: /^(ჩვ?\.წ)/i,
    abbreviated: /^(ჩვ?\.წ)/i,
    wide: /^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე|ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i
};
const $e123fcf255ba9600$var$parseEraPatterns = {
    any: [
        /^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე)/i,
        /^(ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i
    ]
};
const $e123fcf255ba9600$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]-(ლი|ე)? კვ/i,
    wide: /^[1234]-(ლი|ე)? კვარტალი/i
};
const $e123fcf255ba9600$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $e123fcf255ba9600$var$matchMonthPatterns = {
    any: /^(ია|თე|მა|აპ|მს|ვნ|ვლ|აგ|სე|ოქ|ნო|დე)/i
};
const $e123fcf255ba9600$var$parseMonthPatterns = {
    any: [
        /^ია/i,
        /^თ/i,
        /^მარ/i,
        /^აპ/i,
        /^მაი/i,
        /^ი?ვნ/i,
        /^ი?ვლ/i,
        /^აგ/i,
        /^ს/i,
        /^ო/i,
        /^ნ/i,
        /^დ/i
    ]
};
const $e123fcf255ba9600$var$matchDayPatterns = {
    narrow: /^(კვ|ორ|სა|ოთ|ხუ|პა|შა)/i,
    short: /^(კვი|ორშ|სამ|ოთხ|ხუთ|პარ|შაბ)/i,
    wide: /^(კვირა|ორშაბათი|სამშაბათი|ოთხშაბათი|ხუთშაბათი|პარასკევი|შაბათი)/i
};
const $e123fcf255ba9600$var$parseDayPatterns = {
    any: [
        /^კვ/i,
        /^ორ/i,
        /^სა/i,
        /^ოთ/i,
        /^ხუ/i,
        /^პა/i,
        /^შა/i
    ]
};
const $e123fcf255ba9600$var$matchDayPeriodPatterns = {
    any: /^([ap]\.?\s?m\.?|შუაღ|დილ)/i
};
const $e123fcf255ba9600$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^შუაღ/i,
        noon: /^შუადღ/i,
        morning: /^დილ/i,
        afternoon: /ნაშუადღევს/i,
        evening: /საღამო/i,
        night: /ღამ/i
    }
};
const $e123fcf255ba9600$var$match = $e123fcf255ba9600$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $e123fcf255ba9600$var$matchOrdinalNumberPattern,
        parsePattern: $e123fcf255ba9600$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e123fcf255ba9600$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e123fcf255ba9600$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e123fcf255ba9600$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e123fcf255ba9600$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e123fcf255ba9600$var$matchMonthPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $e123fcf255ba9600$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e123fcf255ba9600$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e123fcf255ba9600$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e123fcf255ba9600$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $e123fcf255ba9600$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("jVdzN", function(module, exports) {

$parcel$export(module.exports, "kk", function () { return $e80ddf2a5c5ea77b$export$4b04b6f14f77e727; }, function (v) { return $e80ddf2a5c5ea77b$export$4b04b6f14f77e727 = v; });
var $e80ddf2a5c5ea77b$export$4b04b6f14f77e727;
"use strict";
$e80ddf2a5c5ea77b$export$4b04b6f14f77e727 = void 0;

var $5CH0u = parcelRequire("5CH0u");

var $1ArdE = parcelRequire("1ArdE");

var $f4XMO = parcelRequire("f4XMO");

var $dWa2V = parcelRequire("dWa2V");

var $3pKyP = parcelRequire("3pKyP");
/**
 * @category Locales
 * @summary Kazakh locale.
 * @language Kazakh
 * @iso-639-2 kaz
 * @author Nikita Bayev [@drugoi](https://github.com/drugoi)
 */ const $e80ddf2a5c5ea77b$var$kk = $e80ddf2a5c5ea77b$export$4b04b6f14f77e727 = {
    code: "kk",
    formatDistance: $5CH0u.formatDistance,
    formatLong: $1ArdE.formatLong,
    formatRelative: $f4XMO.formatRelative,
    localize: $dWa2V.localize,
    match: $3pKyP.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("5CH0u", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $4181dca2701f1f62$export$2c14ff85d6318973; }, function (v) { return $4181dca2701f1f62$export$2c14ff85d6318973 = v; });
var $4181dca2701f1f62$export$2c14ff85d6318973;
"use strict";
$4181dca2701f1f62$export$2c14ff85d6318973 = void 0;
const $4181dca2701f1f62$var$formatDistanceLocale = {
    lessThanXSeconds: {
        regular: {
            one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437"
        },
        future: {
            one: "\u0431\u0456\u0440 \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xSeconds: {
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D"
        },
        future: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    halfAMinute: (options)=>{
        if (options?.addSuffix) {
            if (options.comparison && options.comparison > 0) return "\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442 \u0456\u0448\u0456\u043D\u0434\u0435";
            else return "\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D";
        }
        return "\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442";
    },
    lessThanXMinutes: {
        regular: {
            one: "1 \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437"
        },
        future: {
            one: "\u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C ",
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C"
        }
    },
    xMinutes: {
        regular: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        past: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D"
        },
        future: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    aboutXHours: {
        regular: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442"
        },
        future: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xHours: {
        regular: {
            singularNominative: "{{count}} \u0441\u0430\u0493\u0430\u0442",
            singularGenitive: "{{count}} \u0441\u0430\u0493\u0430\u0442",
            pluralGenitive: "{{count}} \u0441\u0430\u0493\u0430\u0442"
        }
    },
    xDays: {
        regular: {
            singularNominative: "{{count}} \u043A\u04AF\u043D",
            singularGenitive: "{{count}} \u043A\u04AF\u043D",
            pluralGenitive: "{{count}} \u043A\u04AF\u043D"
        },
        future: {
            singularNominative: "{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    aboutXWeeks: {
        type: "weeks",
        one: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D 1 \u0430\u043F\u0442\u0430",
        other: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u043F\u0442\u0430"
    },
    xWeeks: {
        type: "weeks",
        one: "1 \u0430\u043F\u0442\u0430",
        other: "{{count}} \u0430\u043F\u0442\u0430"
    },
    aboutXMonths: {
        regular: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439"
        },
        future: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xMonths: {
        regular: {
            singularNominative: "{{count}} \u0430\u0439",
            singularGenitive: "{{count}} \u0430\u0439",
            pluralGenitive: "{{count}} \u0430\u0439"
        }
    },
    aboutXYears: {
        regular: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B"
        },
        future: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xYears: {
        regular: {
            singularNominative: "{{count}} \u0436\u044B\u043B",
            singularGenitive: "{{count}} \u0436\u044B\u043B",
            pluralGenitive: "{{count}} \u0436\u044B\u043B"
        },
        future: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    overXYears: {
        regular: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C"
        },
        future: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C"
        }
    },
    almostXYears: {
        regular: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D"
        },
        future: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    }
};
function $4181dca2701f1f62$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one && count === 1) return scheme.one;
    const rem10 = count % 10;
    const rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace("{{count}}", String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace("{{count}}", String(count));
    else return scheme.pluralGenitive.replace("{{count}}", String(count));
}
const $4181dca2701f1f62$var$formatDistance = (token, count, options)=>{
    const tokenValue = $4181dca2701f1f62$var$formatDistanceLocale[token];
    if (typeof tokenValue === "function") return tokenValue(options);
    if (tokenValue.type === "weeks") return count === 1 ? tokenValue.one : tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) {
            if (tokenValue.future) return $4181dca2701f1f62$var$declension(tokenValue.future, count);
            else return $4181dca2701f1f62$var$declension(tokenValue.regular, count) + " \u043A\u0435\u0439\u0456\u043D";
        } else {
            if (tokenValue.past) return $4181dca2701f1f62$var$declension(tokenValue.past, count);
            else return $4181dca2701f1f62$var$declension(tokenValue.regular, count) + " \u0431\u04B1\u0440\u044B\u043D";
        }
    } else return $4181dca2701f1f62$var$declension(tokenValue.regular, count);
};
$4181dca2701f1f62$export$2c14ff85d6318973 = $4181dca2701f1f62$var$formatDistance;

});

parcelRegister("1ArdE", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $127e4463d959039a$export$cbf60ecb96cbb82f; }, function (v) { return $127e4463d959039a$export$cbf60ecb96cbb82f = v; });
var $127e4463d959039a$export$cbf60ecb96cbb82f;
"use strict";
$127e4463d959039a$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $127e4463d959039a$var$dateFormats = {
    full: "EEEE, do MMMM y '\u0436.'",
    long: "do MMMM y '\u0436.'",
    medium: "d MMM y '\u0436.'",
    short: "dd.MM.yyyy"
};
const $127e4463d959039a$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $127e4463d959039a$var$dateTimeFormats = {
    any: "{{date}}, {{time}}"
};
const $127e4463d959039a$var$formatLong = $127e4463d959039a$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $127e4463d959039a$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $127e4463d959039a$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $127e4463d959039a$var$dateTimeFormats,
        defaultWidth: "any"
    })
};

});

parcelRegister("f4XMO", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $afa59b0e798ad5c2$export$8fbbfd65594f46a0; }, function (v) { return $afa59b0e798ad5c2$export$8fbbfd65594f46a0 = v; });
var $afa59b0e798ad5c2$export$8fbbfd65594f46a0;
"use strict";
$afa59b0e798ad5c2$export$8fbbfd65594f46a0 = void 0;

var $9VRW1 = parcelRequire("9VRW1");
const $afa59b0e798ad5c2$var$accusativeWeekdays = [
    "\u0436\u0435\u043A\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0434\u04AF\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0441\u0435\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0441\u04D9\u0440\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0431\u0435\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0436\u04B1\u043C\u0430\u0434\u0430",
    "\u0441\u0435\u043D\u0431\u0456\u0434\u0435"
];
function $afa59b0e798ad5c2$var$lastWeek(day) {
    const weekday = $afa59b0e798ad5c2$var$accusativeWeekdays[day];
    return "'\u04E9\u0442\u043A\u0435\u043D " + weekday + " \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
}
function $afa59b0e798ad5c2$var$thisWeek(day) {
    const weekday = $afa59b0e798ad5c2$var$accusativeWeekdays[day];
    return "'" + weekday + " \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
}
function $afa59b0e798ad5c2$var$nextWeek(day) {
    const weekday = $afa59b0e798ad5c2$var$accusativeWeekdays[day];
    return "'\u043A\u0435\u043B\u0435\u0441\u0456 " + weekday + " \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
}
const $afa59b0e798ad5c2$var$formatRelativeLocale = {
    lastWeek: (date, baseDate, options)=>{
        const day = date.getDay();
        if ((0, $9VRW1.isSameWeek)(date, baseDate, options)) return $afa59b0e798ad5c2$var$thisWeek(day);
        else return $afa59b0e798ad5c2$var$lastWeek(day);
    },
    yesterday: "'\u043A\u0435\u0448\u0435 \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
    today: "'\u0431\u04AF\u0433\u0456\u043D \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
    tomorrow: "'\u0435\u0440\u0442\u0435\u04A3 \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
    nextWeek: (date, baseDate, options)=>{
        const day = date.getDay();
        if ((0, $9VRW1.isSameWeek)(date, baseDate, options)) return $afa59b0e798ad5c2$var$thisWeek(day);
        else return $afa59b0e798ad5c2$var$nextWeek(day);
    },
    other: "P"
};
const $afa59b0e798ad5c2$var$formatRelative = (token, date, baseDate, options)=>{
    const format = $afa59b0e798ad5c2$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
$afa59b0e798ad5c2$export$8fbbfd65594f46a0 = $afa59b0e798ad5c2$var$formatRelative;

});

parcelRegister("dWa2V", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $a2587c18c2108226$export$b3bd0bc58e36cd63; }, function (v) { return $a2587c18c2108226$export$b3bd0bc58e36cd63 = v; });
var $a2587c18c2108226$export$b3bd0bc58e36cd63;
"use strict";
$a2587c18c2108226$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $a2587c18c2108226$var$eraValues = {
    narrow: [
        "\u0431.\u0437.\u0434.",
        "\u0431.\u0437."
    ],
    abbreviated: [
        "\u0431.\u0437.\u0434.",
        "\u0431.\u0437."
    ],
    wide: [
        "\u0431\u0456\u0437\u0434\u0456\u04A3 \u0437\u0430\u043C\u0430\u043D\u044B\u043C\u044B\u0437\u0493\u0430 \u0434\u0435\u0439\u0456\u043D",
        "\u0431\u0456\u0437\u0434\u0456\u04A3 \u0437\u0430\u043C\u0430\u043D\u044B\u043C\u044B\u0437"
    ]
};
const $a2587c18c2108226$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-\u0448\u0456 \u0442\u043E\u049B.",
        "2-\u0448\u0456 \u0442\u043E\u049B.",
        "3-\u0448\u0456 \u0442\u043E\u049B.",
        "4-\u0448\u0456 \u0442\u043E\u049B."
    ],
    wide: [
        "1-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D",
        "2-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D",
        "3-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D",
        "4-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D"
    ]
};
const $a2587c18c2108226$var$monthValues = {
    narrow: [
        "\u049A",
        "\u0410",
        "\u041D",
        "\u0421",
        "\u041C",
        "\u041C",
        "\u0428",
        "\u0422",
        "\u049A",
        "\u049A",
        "\u049A",
        "\u0416"
    ],
    abbreviated: [
        "\u049B\u0430\u04A3",
        "\u0430\u049B\u043F",
        "\u043D\u0430\u0443",
        "\u0441\u04D9\u0443",
        "\u043C\u0430\u043C",
        "\u043C\u0430\u0443",
        "\u0448\u0456\u043B",
        "\u0442\u0430\u043C",
        "\u049B\u044B\u0440",
        "\u049B\u0430\u0437",
        "\u049B\u0430\u0440",
        "\u0436\u0435\u043B"
    ],
    wide: [
        "\u049B\u0430\u04A3\u0442\u0430\u0440",
        "\u0430\u049B\u043F\u0430\u043D",
        "\u043D\u0430\u0443\u0440\u044B\u0437",
        "\u0441\u04D9\u0443\u0456\u0440",
        "\u043C\u0430\u043C\u044B\u0440",
        "\u043C\u0430\u0443\u0441\u044B\u043C",
        "\u0448\u0456\u043B\u0434\u0435",
        "\u0442\u0430\u043C\u044B\u0437",
        "\u049B\u044B\u0440\u043A\u04AF\u0439\u0435\u043A",
        "\u049B\u0430\u0437\u0430\u043D",
        "\u049B\u0430\u0440\u0430\u0448\u0430",
        "\u0436\u0435\u043B\u0442\u043E\u049B\u0441\u0430\u043D"
    ]
};
const $a2587c18c2108226$var$formattingMonthValues = {
    narrow: [
        "\u049A",
        "\u0410",
        "\u041D",
        "\u0421",
        "\u041C",
        "\u041C",
        "\u0428",
        "\u0422",
        "\u049A",
        "\u049A",
        "\u049A",
        "\u0416"
    ],
    abbreviated: [
        "\u049B\u0430\u04A3",
        "\u0430\u049B\u043F",
        "\u043D\u0430\u0443",
        "\u0441\u04D9\u0443",
        "\u043C\u0430\u043C",
        "\u043C\u0430\u0443",
        "\u0448\u0456\u043B",
        "\u0442\u0430\u043C",
        "\u049B\u044B\u0440",
        "\u049B\u0430\u0437",
        "\u049B\u0430\u0440",
        "\u0436\u0435\u043B"
    ],
    wide: [
        "\u049B\u0430\u04A3\u0442\u0430\u0440",
        "\u0430\u049B\u043F\u0430\u043D",
        "\u043D\u0430\u0443\u0440\u044B\u0437",
        "\u0441\u04D9\u0443\u0456\u0440",
        "\u043C\u0430\u043C\u044B\u0440",
        "\u043C\u0430\u0443\u0441\u044B\u043C",
        "\u0448\u0456\u043B\u0434\u0435",
        "\u0442\u0430\u043C\u044B\u0437",
        "\u049B\u044B\u0440\u043A\u04AF\u0439\u0435\u043A",
        "\u049B\u0430\u0437\u0430\u043D",
        "\u049B\u0430\u0440\u0430\u0448\u0430",
        "\u0436\u0435\u043B\u0442\u043E\u049B\u0441\u0430\u043D"
    ]
};
const $a2587c18c2108226$var$dayValues = {
    narrow: [
        "\u0416",
        "\u0414",
        "\u0421",
        "\u0421",
        "\u0411",
        "\u0416",
        "\u0421"
    ],
    short: [
        "\u0436\u0441",
        "\u0434\u0441",
        "\u0441\u0441",
        "\u0441\u0440",
        "\u0431\u0441",
        "\u0436\u043C",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u0436\u0441",
        "\u0434\u0441",
        "\u0441\u0441",
        "\u0441\u0440",
        "\u0431\u0441",
        "\u0436\u043C",
        "\u0441\u0431"
    ],
    wide: [
        "\u0436\u0435\u043A\u0441\u0435\u043D\u0431\u0456",
        "\u0434\u04AF\u0439\u0441\u0435\u043D\u0431\u0456",
        "\u0441\u0435\u0439\u0441\u0435\u043D\u0431\u0456",
        "\u0441\u04D9\u0440\u0441\u0435\u043D\u0431\u0456",
        "\u0431\u0435\u0439\u0441\u0435\u043D\u0431\u0456",
        "\u0436\u04B1\u043C\u0430",
        "\u0441\u0435\u043D\u0431\u0456"
    ]
};
const $a2587c18c2108226$var$dayPeriodValues = {
    narrow: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B",
        noon: "\u0442\u04AF\u0441",
        morning: "\u0442\u0430\u04A3",
        afternoon: "\u043A\u04AF\u043D\u0434\u0456\u0437",
        evening: "\u043A\u0435\u0448",
        night: "\u0442\u04AF\u043D"
    },
    wide: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B",
        noon: "\u0442\u04AF\u0441",
        morning: "\u0442\u0430\u04A3",
        afternoon: "\u043A\u04AF\u043D\u0434\u0456\u0437",
        evening: "\u043A\u0435\u0448",
        night: "\u0442\u04AF\u043D"
    }
};
const $a2587c18c2108226$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B\u043D\u0434\u0430",
        noon: "\u0442\u04AF\u0441",
        morning: "\u0442\u0430\u04A3",
        afternoon: "\u043A\u04AF\u043D",
        evening: "\u043A\u0435\u0448",
        night: "\u0442\u04AF\u043D"
    },
    wide: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B\u043D\u0434\u0430",
        noon: "\u0442\u04AF\u0441\u0442\u0435",
        morning: "\u0442\u0430\u04A3\u0435\u0440\u0442\u0435\u04A3",
        afternoon: "\u043A\u04AF\u043D\u0434\u0456\u0437",
        evening: "\u043A\u0435\u0448\u0442\u0435",
        night: "\u0442\u04AF\u043D\u0434\u0435"
    }
};
const $a2587c18c2108226$var$suffixes = {
    0: "-\u0448\u0456",
    1: "-\u0448\u0456",
    2: "-\u0448\u0456",
    3: "-\u0448\u0456",
    4: "-\u0448\u0456",
    5: "-\u0448\u0456",
    6: "-\u0448\u044B",
    7: "-\u0448\u0456",
    8: "-\u0448\u0456",
    9: "-\u0448\u044B",
    10: "-\u0448\u044B",
    20: "-\u0448\u044B",
    30: "-\u0448\u044B",
    40: "-\u0448\u044B",
    50: "-\u0448\u0456",
    60: "-\u0448\u044B",
    70: "-\u0448\u0456",
    80: "-\u0448\u0456",
    90: "-\u0448\u044B",
    100: "-\u0448\u0456"
};
const $a2587c18c2108226$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    const mod10 = number % 10;
    const b = number >= 100 ? 100 : null;
    const suffix = $a2587c18c2108226$var$suffixes[number] || $a2587c18c2108226$var$suffixes[mod10] || b && $a2587c18c2108226$var$suffixes[b] || "";
    return number + suffix;
};
const $a2587c18c2108226$var$localize = $a2587c18c2108226$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $a2587c18c2108226$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $a2587c18c2108226$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $a2587c18c2108226$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $a2587c18c2108226$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $a2587c18c2108226$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $a2587c18c2108226$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $a2587c18c2108226$var$dayPeriodValues,
        defaultWidth: "any",
        formattingValues: $a2587c18c2108226$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("3pKyP", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $27c7d2dfee116b54$export$4659b591c19bdf3d; }, function (v) { return $27c7d2dfee116b54$export$4659b591c19bdf3d = v; });
var $27c7d2dfee116b54$export$4659b591c19bdf3d;
"use strict";
$27c7d2dfee116b54$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $27c7d2dfee116b54$var$matchOrdinalNumberPattern = /^(\d+)(-?(ші|шы))?/i;
const $27c7d2dfee116b54$var$parseOrdinalNumberPattern = /\d+/i;
const $27c7d2dfee116b54$var$matchEraPatterns = {
    narrow: /^((б )?з\.?\s?д\.?)/i,
    abbreviated: /^((б )?з\.?\s?д\.?)/i,
    wide: /^(біздің заманымызға дейін|біздің заманымыз|біздің заманымыздан)/i
};
const $27c7d2dfee116b54$var$parseEraPatterns = {
    any: [
        /^б/i,
        /^з/i
    ]
};
const $27c7d2dfee116b54$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?ші)? тоқ.?/i,
    wide: /^[1234](-?ші)? тоқсан/i
};
const $27c7d2dfee116b54$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $27c7d2dfee116b54$var$matchMonthPatterns = {
    narrow: /^(қ|а|н|с|м|мау|ш|т|қыр|қаз|қар|ж)/i,
    abbreviated: /^(қаң|ақп|нау|сәу|мам|мау|шіл|там|қыр|қаз|қар|жел)/i,
    wide: /^(қаңтар|ақпан|наурыз|сәуір|мамыр|маусым|шілде|тамыз|қыркүйек|қазан|қараша|желтоқсан)/i
};
const $27c7d2dfee116b54$var$parseMonthPatterns = {
    narrow: [
        /^қ/i,
        /^а/i,
        /^н/i,
        /^с/i,
        /^м/i,
        /^м/i,
        /^ш/i,
        /^т/i,
        /^қ/i,
        /^қ/i,
        /^қ/i,
        /^ж/i
    ],
    abbreviated: [
        /^қаң/i,
        /^ақп/i,
        /^нау/i,
        /^сәу/i,
        /^мам/i,
        /^мау/i,
        /^шіл/i,
        /^там/i,
        /^қыр/i,
        /^қаз/i,
        /^қар/i,
        /^жел/i
    ],
    any: [
        /^қ/i,
        /^а/i,
        /^н/i,
        /^с/i,
        /^м/i,
        /^м/i,
        /^ш/i,
        /^т/i,
        /^қ/i,
        /^қ/i,
        /^қ/i,
        /^ж/i
    ]
};
const $27c7d2dfee116b54$var$matchDayPatterns = {
    narrow: /^(ж|д|с|с|б|ж|с)/i,
    short: /^(жс|дс|сс|ср|бс|жм|сб)/i,
    wide: /^(жексенбі|дүйсенбі|сейсенбі|сәрсенбі|бейсенбі|жұма|сенбі)/i
};
const $27c7d2dfee116b54$var$parseDayPatterns = {
    narrow: [
        /^ж/i,
        /^д/i,
        /^с/i,
        /^с/i,
        /^б/i,
        /^ж/i,
        /^с/i
    ],
    short: [
        /^жс/i,
        /^дс/i,
        /^сс/i,
        /^ср/i,
        /^бс/i,
        /^жм/i,
        /^сб/i
    ],
    any: [
        /^ж[ек]/i,
        /^д[үй]/i,
        /^сe[й]/i,
        /^сә[р]/i,
        /^б[ей]/i,
        /^ж[ұм]/i,
        /^се[н]/i
    ]
};
const $27c7d2dfee116b54$var$matchDayPeriodPatterns = {
    narrow: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
    wide: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
    any: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i
};
const $27c7d2dfee116b54$var$parseDayPeriodPatterns = {
    any: {
        am: /^ТД/i,
        pm: /^ТК/i,
        midnight: /^түн орта/i,
        noon: /^күндіз/i,
        morning: /таң/i,
        afternoon: /түс/i,
        evening: /кеш/i,
        night: /түн/i
    }
};
const $27c7d2dfee116b54$var$match = $27c7d2dfee116b54$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $27c7d2dfee116b54$var$matchOrdinalNumberPattern,
        parsePattern: $27c7d2dfee116b54$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $27c7d2dfee116b54$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $27c7d2dfee116b54$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $27c7d2dfee116b54$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $27c7d2dfee116b54$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $27c7d2dfee116b54$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $27c7d2dfee116b54$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $27c7d2dfee116b54$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $27c7d2dfee116b54$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $27c7d2dfee116b54$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $27c7d2dfee116b54$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("cJ91V", function(module, exports) {

$parcel$export(module.exports, "km", function () { return $9440b1309eff637f$export$476a5568f36fcaf3; }, function (v) { return $9440b1309eff637f$export$476a5568f36fcaf3 = v; });
var $9440b1309eff637f$export$476a5568f36fcaf3;
"use strict";
$9440b1309eff637f$export$476a5568f36fcaf3 = void 0;

var $evJ1q = parcelRequire("evJ1q");

var $90tMI = parcelRequire("90tMI");

var $doCm9 = parcelRequire("doCm9");

var $kLtQs = parcelRequire("kLtQs");

var $lXoXX = parcelRequire("lXoXX");
/**
 * @category Locales
 * @summary Khmer locale (Cambodian).
 * @language Khmer
 * @iso-639-2 khm
 * @author Seanghay Yath [@seanghay](https://github.com/seanghay)
 */ const $9440b1309eff637f$var$km = $9440b1309eff637f$export$476a5568f36fcaf3 = {
    code: "km",
    formatDistance: $evJ1q.formatDistance,
    formatLong: $90tMI.formatLong,
    formatRelative: $doCm9.formatRelative,
    localize: $kLtQs.localize,
    match: $lXoXX.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("evJ1q", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $a906e264d0ad5ce4$export$2c14ff85d6318973; }, function (v) { return $a906e264d0ad5ce4$export$2c14ff85d6318973 = v; });
var $a906e264d0ad5ce4$export$2c14ff85d6318973;
"use strict";
$a906e264d0ad5ce4$export$2c14ff85d6318973 = void 0;
const $a906e264d0ad5ce4$var$formatDistanceLocale = {
    lessThanXSeconds: "\u178F\u17B7\u1785\u1787\u17B6\u1784 {{count}} \u179C\u17B7\u1793\u17B6\u1791\u17B8",
    xSeconds: "{{count}} \u179C\u17B7\u1793\u17B6\u1791\u17B8",
    halfAMinute: "\u1780\u1793\u17D2\u179B\u17C7\u1793\u17B6\u1791\u17B8",
    lessThanXMinutes: "\u178F\u17B7\u1785\u1787\u17B6\u1784 {{count}} \u1793\u17B6\u1791\u17B8",
    xMinutes: "{{count}} \u1793\u17B6\u1791\u17B8",
    aboutXHours: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u1798\u17C9\u17C4\u1784",
    xHours: "{{count}} \u1798\u17C9\u17C4\u1784",
    xDays: "{{count}} \u1790\u17D2\u1784\u17C3",
    aboutXWeeks: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u179F\u1794\u17D2\u178F\u17B6\u17A0\u17CD",
    xWeeks: "{{count}} \u179F\u1794\u17D2\u178F\u17B6\u17A0\u17CD",
    aboutXMonths: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u1781\u17C2",
    xMonths: "{{count}} \u1781\u17C2",
    aboutXYears: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u1786\u17D2\u1793\u17B6\u17C6",
    xYears: "{{count}} \u1786\u17D2\u1793\u17B6\u17C6",
    overXYears: "\u1787\u17B6\u1784 {{count}} \u1786\u17D2\u1793\u17B6\u17C6",
    almostXYears: "\u1787\u17B7\u178F {{count}} \u1786\u17D2\u1793\u17B6\u17C6"
};
const $a906e264d0ad5ce4$var$formatDistance = (token, count, options)=>{
    const tokenValue = $a906e264d0ad5ce4$var$formatDistanceLocale[token];
    let result = tokenValue;
    if (typeof count === "number") result = result.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u1780\u17D2\u1793\u17BB\u1784\u179A\u1799\u17C8\u1796\u17C1\u179B " + result;
        else return result + "\u1798\u17BB\u1793";
    }
    return result;
};
$a906e264d0ad5ce4$export$2c14ff85d6318973 = $a906e264d0ad5ce4$var$formatDistance;

});

parcelRegister("90tMI", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $68eb37c4dc9cea4e$export$cbf60ecb96cbb82f; }, function (v) { return $68eb37c4dc9cea4e$export$cbf60ecb96cbb82f = v; });
var $68eb37c4dc9cea4e$export$cbf60ecb96cbb82f;
"use strict";
$68eb37c4dc9cea4e$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $68eb37c4dc9cea4e$var$dateFormats = {
    full: "EEEE do MMMM y",
    long: "do MMMM y",
    medium: "d MMM y",
    short: "dd/MM/yyyy"
};
const $68eb37c4dc9cea4e$var$timeFormats = {
    full: "h:mm:ss a",
    long: "h:mm:ss a",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $68eb37c4dc9cea4e$var$dateTimeFormats = {
    full: "{{date}} '\u1798\u17C9\u17C4\u1784' {{time}}",
    long: "{{date}} '\u1798\u17C9\u17C4\u1784' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $68eb37c4dc9cea4e$var$formatLong = $68eb37c4dc9cea4e$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $68eb37c4dc9cea4e$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $68eb37c4dc9cea4e$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $68eb37c4dc9cea4e$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("doCm9", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $9c0b450034bf5314$export$8fbbfd65594f46a0; }, function (v) { return $9c0b450034bf5314$export$8fbbfd65594f46a0 = v; });
var $9c0b450034bf5314$export$8fbbfd65594f46a0;
"use strict";
$9c0b450034bf5314$export$8fbbfd65594f46a0 = void 0;
const $9c0b450034bf5314$var$formatRelativeLocale = {
    lastWeek: "'\u1790\u17D2\u1784\u17C3'eeee'\u179F\u200B\u1794\u17D2\u178F\u17B6\u200B\u17A0\u17CD\u200B\u1798\u17BB\u1793\u1798\u17C9\u17C4\u1784' p",
    yesterday: "'\u1798\u17D2\u179F\u17B7\u179B\u1798\u17B7\u1789\u1793\u17C5\u1798\u17C9\u17C4\u1784' p",
    today: "'\u1790\u17D2\u1784\u17C3\u1793\u17C1\u17C7\u1798\u17C9\u17C4\u1784' p",
    tomorrow: "'\u1790\u17D2\u1784\u17C3\u179F\u17D2\u17A2\u17C2\u1780\u1798\u17C9\u17C4\u1784' p",
    nextWeek: "'\u1790\u17D2\u1784\u17C3'eeee'\u179F\u200B\u1794\u17D2\u178F\u17B6\u200B\u17A0\u17CD\u200B\u1780\u17D2\u179A\u17C4\u1799\u1798\u17C9\u17C4\u1784' p",
    other: "P"
};
const $9c0b450034bf5314$var$formatRelative = (token, _date, _baseDate, _options)=>$9c0b450034bf5314$var$formatRelativeLocale[token];
$9c0b450034bf5314$export$8fbbfd65594f46a0 = $9c0b450034bf5314$var$formatRelative;

});

parcelRegister("kLtQs", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $f1df590ec3d90e70$export$b3bd0bc58e36cd63; }, function (v) { return $f1df590ec3d90e70$export$b3bd0bc58e36cd63 = v; });
var $f1df590ec3d90e70$export$b3bd0bc58e36cd63;
"use strict";
$f1df590ec3d90e70$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $f1df590ec3d90e70$var$eraValues = {
    narrow: [
        "\u1798.\u1782\u179F",
        "\u1782\u179F"
    ],
    abbreviated: [
        "\u1798\u17BB\u1793\u1782.\u179F",
        "\u1782.\u179F"
    ],
    wide: [
        "\u1798\u17BB\u1793\u1782\u17D2\u179A\u17B7\u179F\u17D2\u178F\u179F\u1780\u179A\u17B6\u1787",
        "\u1793\u17C3\u1782\u17D2\u179A\u17B7\u179F\u17D2\u178F\u179F\u1780\u179A\u17B6\u1787"
    ]
};
const $f1df590ec3d90e70$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 1",
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 2",
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 3",
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 4"
    ]
};
const $f1df590ec3d90e70$var$monthValues = {
    narrow: [
        "\u1798.\u1780",
        "\u1780.\u1798",
        "\u1798\u17B7",
        "\u1798.\u179F",
        "\u17A7.\u179F",
        "\u1798.\u1790",
        "\u1780.\u178A",
        "\u179F\u17B8",
        "\u1780\u1789",
        "\u178F\u17BB",
        "\u179C\u17B7",
        "\u1792"
    ],
    abbreviated: [
        "\u1798\u1780\u179A\u17B6",
        "\u1780\u17BB\u1798\u17D2\u1797\u17C8",
        "\u1798\u17B8\u1793\u17B6",
        "\u1798\u17C1\u179F\u17B6",
        "\u17A7\u179F\u1797\u17B6",
        "\u1798\u17B7\u1790\u17BB\u1793\u17B6",
        "\u1780\u1780\u17D2\u1780\u178A\u17B6",
        "\u179F\u17B8\u17A0\u17B6",
        "\u1780\u1789\u17D2\u1789\u17B6",
        "\u178F\u17BB\u179B\u17B6",
        "\u179C\u17B7\u1785\u17D2\u1786\u17B7\u1780\u17B6",
        "\u1792\u17D2\u1793\u17BC"
    ],
    wide: [
        "\u1798\u1780\u179A\u17B6",
        "\u1780\u17BB\u1798\u17D2\u1797\u17C8",
        "\u1798\u17B8\u1793\u17B6",
        "\u1798\u17C1\u179F\u17B6",
        "\u17A7\u179F\u1797\u17B6",
        "\u1798\u17B7\u1790\u17BB\u1793\u17B6",
        "\u1780\u1780\u17D2\u1780\u178A\u17B6",
        "\u179F\u17B8\u17A0\u17B6",
        "\u1780\u1789\u17D2\u1789\u17B6",
        "\u178F\u17BB\u179B\u17B6",
        "\u179C\u17B7\u1785\u17D2\u1786\u17B7\u1780\u17B6",
        "\u1792\u17D2\u1793\u17BC"
    ]
};
const $f1df590ec3d90e70$var$dayValues = {
    narrow: [
        "\u17A2\u17B6",
        "\u1785",
        "\u17A2",
        "\u1796",
        "\u1796\u17D2\u179A",
        "\u179F\u17BB",
        "\u179F"
    ],
    short: [
        "\u17A2\u17B6",
        "\u1785",
        "\u17A2",
        "\u1796",
        "\u1796\u17D2\u179A",
        "\u179F\u17BB",
        "\u179F"
    ],
    abbreviated: [
        "\u17A2\u17B6",
        "\u1785",
        "\u17A2",
        "\u1796",
        "\u1796\u17D2\u179A",
        "\u179F\u17BB",
        "\u179F"
    ],
    wide: [
        "\u17A2\u17B6\u1791\u17B7\u178F\u17D2\u1799",
        "\u1785\u1793\u17D2\u1791",
        "\u17A2\u1784\u17D2\u1782\u17B6\u179A",
        "\u1796\u17BB\u1792",
        "\u1796\u17D2\u179A\u17A0\u179F\u17D2\u1794\u178F\u17B7\u17CD",
        "\u179F\u17BB\u1780\u17D2\u179A",
        "\u179F\u17C5\u179A\u17CD"
    ]
};
const $f1df590ec3d90e70$var$dayPeriodValues = {
    narrow: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    abbreviated: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    wide: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    }
};
const $f1df590ec3d90e70$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    abbreviated: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    wide: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    }
};
const $f1df590ec3d90e70$var$ordinalNumber = (dirtyNumber, _)=>{
    const number = Number(dirtyNumber);
    return number.toString();
};
const $f1df590ec3d90e70$var$localize = $f1df590ec3d90e70$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $f1df590ec3d90e70$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $f1df590ec3d90e70$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $f1df590ec3d90e70$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $f1df590ec3d90e70$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $f1df590ec3d90e70$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $f1df590ec3d90e70$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $f1df590ec3d90e70$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("lXoXX", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $ffc27965d3b9d467$export$4659b591c19bdf3d; }, function (v) { return $ffc27965d3b9d467$export$4659b591c19bdf3d = v; });
var $ffc27965d3b9d467$export$4659b591c19bdf3d;
"use strict";
$ffc27965d3b9d467$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $ffc27965d3b9d467$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $ffc27965d3b9d467$var$parseOrdinalNumberPattern = /\d+/i;
const $ffc27965d3b9d467$var$matchEraPatterns = {
    narrow: /^(ម\.)?គស/i,
    abbreviated: /^(មុន)?គ\.ស/i,
    wide: /^(មុន|នៃ)គ្រិស្តសករាជ/i
};
const $ffc27965d3b9d467$var$parseEraPatterns = {
    any: [
        /^(ម|មុន)គ\.?ស/i,
        /^(នៃ)?គ\.?ស/i
    ]
};
const $ffc27965d3b9d467$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^(ត្រីមាស)(ទី)?\s?[1234]/i
};
const $ffc27965d3b9d467$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $ffc27965d3b9d467$var$matchMonthPatterns = {
    narrow: /^(ម\.ក|ក\.ម|មិ|ម\.ស|ឧ\.ស|ម\.ថ|ក\.ដ|សី|កញ|តុ|វិ|ធ)/i,
    abbreviated: /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i,
    wide: /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i
};
const $ffc27965d3b9d467$var$parseMonthPatterns = {
    narrow: [
        /^ម\.ក/i,
        /^ក\.ម/i,
        /^មិ/i,
        /^ម\.ស/i,
        /^ឧ\.ស/i,
        /^ម\.ថ/i,
        /^ក\.ដ/i,
        /^សី/i,
        /^កញ/i,
        /^តុ/i,
        /^វិ/i,
        /^ធ/i
    ],
    any: [
        /^មក/i,
        /^កុ/i,
        /^មីន/i,
        /^មេ/i,
        /^ឧស/i,
        /^មិថ/i,
        /^កក/i,
        /^សី/i,
        /^កញ/i,
        /^តុ/i,
        /^វិច/i,
        /^ធ/i
    ]
};
const $ffc27965d3b9d467$var$matchDayPatterns = {
    narrow: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
    short: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
    abbreviated: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
    wide: /^(អាទិត្យ|ចន្ទ|អង្គារ|ពុធ|ព្រហស្បតិ៍|សុក្រ|សៅរ៍)/i
};
const $ffc27965d3b9d467$var$parseDayPatterns = {
    narrow: [
        /^អា/i,
        /^ច/i,
        /^អ/i,
        /^ព/i,
        /^ព្រ/i,
        /^សុ/i,
        /^ស/i
    ],
    any: [
        /^អា/i,
        /^ច/i,
        /^អ/i,
        /^ព/i,
        /^ព្រ/i,
        /^សុ/i,
        /^សៅ/i
    ]
};
const $ffc27965d3b9d467$var$matchDayPeriodPatterns = {
    narrow: /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i,
    any: /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i
};
const $ffc27965d3b9d467$var$parseDayPeriodPatterns = {
    any: {
        am: /^ព្រឹក/i,
        pm: /^ល្ងាច/i,
        midnight: /^ពេលកណ្ដាលអធ្រាត្រ/i,
        noon: /^ពេលថ្ងៃត្រង់/i,
        morning: /ពេលព្រឹក/i,
        afternoon: /ពេលរសៀល/i,
        evening: /ពេលល្ងាច/i,
        night: /ពេលយប់/i
    }
};
const $ffc27965d3b9d467$var$match = $ffc27965d3b9d467$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $ffc27965d3b9d467$var$matchOrdinalNumberPattern,
        parsePattern: $ffc27965d3b9d467$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $ffc27965d3b9d467$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ffc27965d3b9d467$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $ffc27965d3b9d467$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ffc27965d3b9d467$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $ffc27965d3b9d467$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ffc27965d3b9d467$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $ffc27965d3b9d467$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ffc27965d3b9d467$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $ffc27965d3b9d467$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $ffc27965d3b9d467$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("7mIvA", function(module, exports) {

$parcel$export(module.exports, "kn", function () { return $55cd1cf0a80c62e2$export$85d70026956e40a0; }, function (v) { return $55cd1cf0a80c62e2$export$85d70026956e40a0 = v; });
var $55cd1cf0a80c62e2$export$85d70026956e40a0;
"use strict";
$55cd1cf0a80c62e2$export$85d70026956e40a0 = void 0;

var $dnEZV = parcelRequire("dnEZV");

var $aUaHf = parcelRequire("aUaHf");

var $bCfhZ = parcelRequire("bCfhZ");

var $gmyZp = parcelRequire("gmyZp");

var $dc15y = parcelRequire("dc15y");
/**
 * @category Locales
 * @summary Kannada locale (India).
 * @language Kannada
 * @iso-639-2 kan
 * @author Manjunatha Gouli [@developergouli](https://github.com/developergouli)
 */ const $55cd1cf0a80c62e2$var$kn = $55cd1cf0a80c62e2$export$85d70026956e40a0 = {
    code: "kn",
    formatDistance: $dnEZV.formatDistance,
    formatLong: $aUaHf.formatLong,
    formatRelative: $bCfhZ.formatRelative,
    localize: $gmyZp.localize,
    match: $dc15y.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("dnEZV", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $9bdd39a943309f79$export$2c14ff85d6318973; }, function (v) { return $9bdd39a943309f79$export$2c14ff85d6318973 = v; });
var $9bdd39a943309f79$export$2c14ff85d6318973;
"use strict";
$9bdd39a943309f79$export$2c14ff85d6318973 = void 0;
// note: no implementation for weeks
const $9bdd39a943309f79$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            default: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        }
    },
    xSeconds: {
        one: {
            default: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD",
            future: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0CA8\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CC1\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    halfAMinute: {
        other: {
            default: "\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7",
            future: "\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    lessThanXMinutes: {
        one: {
            default: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        }
    },
    xMinutes: {
        one: {
            default: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7",
            future: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    aboutXHours: {
        one: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6\u0CAF\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xHours: {
        one: {
            default: "1 \u0C97\u0C82\u0C9F\u0CC6",
            future: "1 \u0C97\u0C82\u0C9F\u0CC6\u0CAF\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0C97\u0C82\u0C9F\u0CC6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xDays: {
        one: {
            default: "1 \u0CA6\u0CBF\u0CA8",
            future: "1 \u0CA6\u0CBF\u0CA8\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CA6\u0CBF\u0CA8\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    // TODO
    // aboutXWeeks: {},
    // TODO
    // xWeeks: {},
    aboutXMonths: {
        one: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xMonths: {
        one: {
            default: "1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    aboutXYears: {
        one: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xYears: {
        one: {
            default: "1 \u0CB5\u0CB0\u0CCD\u0CB7",
            future: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    overXYears: {
        one: {
            default: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6",
            future: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6",
            past: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6",
            future: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6",
            past: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6"
        }
    },
    almostXYears: {
        one: {
            default: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            future: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF"
        },
        other: {
            default: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            future: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF"
        }
    }
};
function $9bdd39a943309f79$var$getResultByTense(parentToken, options) {
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return parentToken.future;
        else return parentToken.past;
    }
    return parentToken.default;
}
const $9bdd39a943309f79$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $9bdd39a943309f79$var$formatDistanceLocale[token];
    if (tokenValue.one && count === 1) result = $9bdd39a943309f79$var$getResultByTense(tokenValue.one, options);
    else result = $9bdd39a943309f79$var$getResultByTense(tokenValue.other, options);
    return result.replace("{{count}}", String(count));
};
$9bdd39a943309f79$export$2c14ff85d6318973 = $9bdd39a943309f79$var$formatDistance;

});

parcelRegister("aUaHf", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $7f076e7a64b3f184$export$cbf60ecb96cbb82f; }, function (v) { return $7f076e7a64b3f184$export$cbf60ecb96cbb82f = v; });
var $7f076e7a64b3f184$export$cbf60ecb96cbb82f;
"use strict";
$7f076e7a64b3f184$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
// Reference: https://www.unicode.org/cldr/charts/32/summary/kn.html
const $7f076e7a64b3f184$var$dateFormats = {
    full: "EEEE, MMMM d, y",
    long: "MMMM d, y",
    medium: "MMM d, y",
    short: "d/M/yy"
};
const $7f076e7a64b3f184$var$timeFormats = {
    full: "hh:mm:ss a zzzz",
    long: "hh:mm:ss a z",
    medium: "hh:mm:ss a",
    short: "hh:mm a"
};
const $7f076e7a64b3f184$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $7f076e7a64b3f184$var$formatLong = $7f076e7a64b3f184$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $7f076e7a64b3f184$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $7f076e7a64b3f184$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $7f076e7a64b3f184$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("bCfhZ", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $874f1a729bc8a20e$export$8fbbfd65594f46a0; }, function (v) { return $874f1a729bc8a20e$export$8fbbfd65594f46a0 = v; });
var $874f1a729bc8a20e$export$8fbbfd65594f46a0;
"use strict";
$874f1a729bc8a20e$export$8fbbfd65594f46a0 = void 0;
const $874f1a729bc8a20e$var$formatRelativeLocale = {
    lastWeek: "'\u0C95\u0CB3\u0CC6\u0CA6' eeee p '\u0C95\u0CCD\u0C95\u0CC6'",
    yesterday: "'\u0CA8\u0CBF\u0CA8\u0CCD\u0CA8\u0CC6' p '\u0C95\u0CCD\u0C95\u0CC6'",
    today: "'\u0C87\u0C82\u0CA6\u0CC1' p '\u0C95\u0CCD\u0C95\u0CC6'",
    tomorrow: "'\u0CA8\u0CBE\u0CB3\u0CC6' p '\u0C95\u0CCD\u0C95\u0CC6'",
    nextWeek: "eeee p '\u0C95\u0CCD\u0C95\u0CC6'",
    other: "P"
};
const $874f1a729bc8a20e$var$formatRelative = (token, _date, _baseDate, _options)=>$874f1a729bc8a20e$var$formatRelativeLocale[token];
$874f1a729bc8a20e$export$8fbbfd65594f46a0 = $874f1a729bc8a20e$var$formatRelative;

});

parcelRegister("gmyZp", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $be99d79ea13ed51e$export$b3bd0bc58e36cd63; }, function (v) { return $be99d79ea13ed51e$export$b3bd0bc58e36cd63 = v; });
var $be99d79ea13ed51e$export$b3bd0bc58e36cd63;
"use strict";
$be99d79ea13ed51e$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
// Reference: https://www.unicode.org/cldr/charts/32/summary/kn.html
const $be99d79ea13ed51e$var$eraValues = {
    narrow: [
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CAA\u0CC2",
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CB6"
    ],
    abbreviated: [
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CAA\u0CC2",
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CB6"
    ],
    wide: [
        "\u0C95\u0CCD\u0CB0\u0CBF\u0CB8\u0CCD\u0CA4 \u0CAA\u0CC2\u0CB0\u0CCD\u0CB5",
        "\u0C95\u0CCD\u0CB0\u0CBF\u0CB8\u0CCD\u0CA4 \u0CB6\u0C95"
    ]
};
const $be99d79ea13ed51e$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u0CA4\u0CCD\u0CB0\u0CC8 1",
        "\u0CA4\u0CCD\u0CB0\u0CC8 2",
        "\u0CA4\u0CCD\u0CB0\u0CC8 3",
        "\u0CA4\u0CCD\u0CB0\u0CC8 4"
    ],
    wide: [
        "1\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95",
        "2\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95",
        "3\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95",
        "4\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95"
    ]
};
// CLDR #1646 - #1717
const $be99d79ea13ed51e$var$monthValues = {
    narrow: [
        "\u0C9C",
        "\u0CAB\u0CC6",
        "\u0CAE\u0CBE",
        "\u0C8F",
        "\u0CAE\u0CC7",
        "\u0C9C\u0CC2",
        "\u0C9C\u0CC1",
        "\u0C86",
        "\u0CB8\u0CC6",
        "\u0C85",
        "\u0CA8",
        "\u0CA1\u0CBF"
    ],
    abbreviated: [
        "\u0C9C\u0CA8",
        "\u0CAB\u0CC6\u0CAC\u0CCD\u0CB0",
        "\u0CAE\u0CBE\u0CB0\u0CCD\u0C9A\u0CCD",
        "\u0C8F\u0CAA\u0CCD\u0CB0\u0CBF",
        "\u0CAE\u0CC7",
        "\u0C9C\u0CC2\u0CA8\u0CCD",
        "\u0C9C\u0CC1\u0CB2\u0CC8",
        "\u0C86\u0C97",
        "\u0CB8\u0CC6\u0CAA\u0CCD\u0C9F\u0CC6\u0C82",
        "\u0C85\u0C95\u0CCD\u0C9F\u0CCB",
        "\u0CA8\u0CB5\u0CC6\u0C82",
        "\u0CA1\u0CBF\u0CB8\u0CC6\u0C82"
    ],
    wide: [
        "\u0C9C\u0CA8\u0CB5\u0CB0\u0CBF",
        "\u0CAB\u0CC6\u0CAC\u0CCD\u0CB0\u0CB5\u0CB0\u0CBF",
        "\u0CAE\u0CBE\u0CB0\u0CCD\u0C9A\u0CCD",
        "\u0C8F\u0CAA\u0CCD\u0CB0\u0CBF\u0CB2\u0CCD",
        "\u0CAE\u0CC7",
        "\u0C9C\u0CC2\u0CA8\u0CCD",
        "\u0C9C\u0CC1\u0CB2\u0CC8",
        "\u0C86\u0C97\u0CB8\u0CCD\u0C9F\u0CCD",
        "\u0CB8\u0CC6\u0CAA\u0CCD\u0C9F\u0CC6\u0C82\u0CAC\u0CB0\u0CCD",
        "\u0C85\u0C95\u0CCD\u0C9F\u0CCB\u0CAC\u0CB0\u0CCD",
        "\u0CA8\u0CB5\u0CC6\u0C82\u0CAC\u0CB0\u0CCD",
        "\u0CA1\u0CBF\u0CB8\u0CC6\u0C82\u0CAC\u0CB0\u0CCD"
    ]
};
// CLDR #1718 - #1773
const $be99d79ea13ed51e$var$dayValues = {
    narrow: [
        "\u0CAD\u0CBE",
        "\u0CB8\u0CCB",
        "\u0CAE\u0C82",
        "\u0CAC\u0CC1",
        "\u0C97\u0CC1",
        "\u0CB6\u0CC1",
        "\u0CB6"
    ],
    short: [
        "\u0CAD\u0CBE\u0CA8\u0CC1",
        "\u0CB8\u0CCB\u0CAE",
        "\u0CAE\u0C82\u0C97\u0CB3",
        "\u0CAC\u0CC1\u0CA7",
        "\u0C97\u0CC1\u0CB0\u0CC1",
        "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0",
        "\u0CB6\u0CA8\u0CBF"
    ],
    abbreviated: [
        "\u0CAD\u0CBE\u0CA8\u0CC1",
        "\u0CB8\u0CCB\u0CAE",
        "\u0CAE\u0C82\u0C97\u0CB3",
        "\u0CAC\u0CC1\u0CA7",
        "\u0C97\u0CC1\u0CB0\u0CC1",
        "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0",
        "\u0CB6\u0CA8\u0CBF"
    ],
    wide: [
        "\u0CAD\u0CBE\u0CA8\u0CC1\u0CB5\u0CBE\u0CB0",
        "\u0CB8\u0CCB\u0CAE\u0CB5\u0CBE\u0CB0",
        "\u0CAE\u0C82\u0C97\u0CB3\u0CB5\u0CBE\u0CB0",
        "\u0CAC\u0CC1\u0CA7\u0CB5\u0CBE\u0CB0",
        "\u0C97\u0CC1\u0CB0\u0CC1\u0CB5\u0CBE\u0CB0",
        "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0\u0CB5\u0CBE\u0CB0",
        "\u0CB6\u0CA8\u0CBF\u0CB5\u0CBE\u0CB0"
    ]
};
// CLDR #1774 - #1815
const $be99d79ea13ed51e$var$dayPeriodValues = {
    narrow: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CB9\u0CCD\u0CA8",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CB9\u0CCD\u0CA8",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    abbreviated: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    wide: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    }
};
const $be99d79ea13ed51e$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0CAA\u0CC2",
        pm: "\u0C85",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    abbreviated: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF \u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    wide: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF \u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    }
};
const $be99d79ea13ed51e$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + "\u0CA8\u0CC7";
};
const $be99d79ea13ed51e$var$localize = $be99d79ea13ed51e$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $be99d79ea13ed51e$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $be99d79ea13ed51e$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $be99d79ea13ed51e$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $be99d79ea13ed51e$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $be99d79ea13ed51e$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $be99d79ea13ed51e$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $be99d79ea13ed51e$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("dc15y", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $99ad3d85639e23d5$export$4659b591c19bdf3d; }, function (v) { return $99ad3d85639e23d5$export$4659b591c19bdf3d = v; });
var $99ad3d85639e23d5$export$4659b591c19bdf3d;
"use strict";
$99ad3d85639e23d5$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $99ad3d85639e23d5$var$matchOrdinalNumberPattern = /^(\d+)(ನೇ|ನೆ)?/i;
const $99ad3d85639e23d5$var$parseOrdinalNumberPattern = /\d+/i;
const $99ad3d85639e23d5$var$matchEraPatterns = {
    narrow: /^(ಕ್ರಿ.ಪೂ|ಕ್ರಿ.ಶ)/i,
    abbreviated: /^(ಕ್ರಿ\.?\s?ಪೂ\.?|ಕ್ರಿ\.?\s?ಶ\.?|ಪ್ರ\.?\s?ಶ\.?)/i,
    wide: /^(ಕ್ರಿಸ್ತ ಪೂರ್ವ|ಕ್ರಿಸ್ತ ಶಕ|ಪ್ರಸಕ್ತ ಶಕ)/i
};
const $99ad3d85639e23d5$var$parseEraPatterns = {
    any: [
        /^ಪೂ/i,
        /^(ಶ|ಪ್ರ)/i
    ]
};
const $99ad3d85639e23d5$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ತ್ರೈ[1234]|ತ್ರೈ [1234]| [1234]ತ್ರೈ/i,
    wide: /^[1234](ನೇ)? ತ್ರೈಮಾಸಿಕ/i
};
const $99ad3d85639e23d5$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $99ad3d85639e23d5$var$matchMonthPatterns = {
    narrow: /^(ಜೂ|ಜು|ಜ|ಫೆ|ಮಾ|ಏ|ಮೇ|ಆ|ಸೆ|ಅ|ನ|ಡಿ)/i,
    abbreviated: /^(ಜನ|ಫೆಬ್ರ|ಮಾರ್ಚ್|ಏಪ್ರಿ|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗ|ಸೆಪ್ಟೆಂ|ಅಕ್ಟೋ|ನವೆಂ|ಡಿಸೆಂ)/i,
    wide: /^(ಜನವರಿ|ಫೆಬ್ರವರಿ|ಮಾರ್ಚ್|ಏಪ್ರಿಲ್|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗಸ್ಟ್|ಸೆಪ್ಟೆಂಬರ್|ಅಕ್ಟೋಬರ್|ನವೆಂಬರ್|ಡಿಸೆಂಬರ್)/i
};
const $99ad3d85639e23d5$var$parseMonthPatterns = {
    narrow: [
        /^ಜ$/i,
        /^ಫೆ/i,
        /^ಮಾ/i,
        /^ಏ/i,
        /^ಮೇ/i,
        /^ಜೂ/i,
        /^ಜು$/i,
        /^ಆ/i,
        /^ಸೆ/i,
        /^ಅ/i,
        /^ನ/i,
        /^ಡಿ/i
    ],
    any: [
        /^ಜನ/i,
        /^ಫೆ/i,
        /^ಮಾ/i,
        /^ಏ/i,
        /^ಮೇ/i,
        /^ಜೂನ್/i,
        /^ಜುಲೈ/i,
        /^ಆ/i,
        /^ಸೆ/i,
        /^ಅ/i,
        /^ನ/i,
        /^ಡಿ/i
    ]
};
const $99ad3d85639e23d5$var$matchDayPatterns = {
    narrow: /^(ಭಾ|ಸೋ|ಮ|ಬು|ಗು|ಶು|ಶ)/i,
    short: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
    abbreviated: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
    wide: /^(ಭಾನುವಾರ|ಸೋಮವಾರ|ಮಂಗಳವಾರ|ಬುಧವಾರ|ಗುರುವಾರ|ಶುಕ್ರವಾರ|ಶನಿವಾರ)/i
};
const $99ad3d85639e23d5$var$parseDayPatterns = {
    narrow: [
        /^ಭಾ/i,
        /^ಸೋ/i,
        /^ಮ/i,
        /^ಬು/i,
        /^ಗು/i,
        /^ಶು/i,
        /^ಶ/i
    ],
    any: [
        /^ಭಾ/i,
        /^ಸೋ/i,
        /^ಮ/i,
        /^ಬು/i,
        /^ಗು/i,
        /^ಶು/i,
        /^ಶ/i
    ]
};
const $99ad3d85639e23d5$var$matchDayPeriodPatterns = {
    narrow: /^(ಪೂ|ಅ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i,
    any: /^(ಪೂರ್ವಾಹ್ನ|ಅಪರಾಹ್ನ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i
};
const $99ad3d85639e23d5$var$parseDayPeriodPatterns = {
    any: {
        am: /^ಪೂ/i,
        pm: /^ಅ/i,
        midnight: /ಮಧ್ಯರಾತ್ರಿ/i,
        noon: /ಮಧ್ಯಾನ್ಹ/i,
        morning: /ಬೆಳಗ್ಗೆ/i,
        afternoon: /ಮಧ್ಯಾನ್ಹ/i,
        evening: /ಸಂಜೆ/i,
        night: /ರಾತ್ರಿ/i
    }
};
const $99ad3d85639e23d5$var$match = $99ad3d85639e23d5$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $99ad3d85639e23d5$var$matchOrdinalNumberPattern,
        parsePattern: $99ad3d85639e23d5$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $99ad3d85639e23d5$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $99ad3d85639e23d5$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $99ad3d85639e23d5$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $99ad3d85639e23d5$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $99ad3d85639e23d5$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $99ad3d85639e23d5$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $99ad3d85639e23d5$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $99ad3d85639e23d5$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $99ad3d85639e23d5$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $99ad3d85639e23d5$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("68KUH", function(module, exports) {

$parcel$export(module.exports, "ko", function () { return $4787e17ed600cf8c$export$798cf677954c9533; }, function (v) { return $4787e17ed600cf8c$export$798cf677954c9533 = v; });
var $4787e17ed600cf8c$export$798cf677954c9533;
"use strict";
$4787e17ed600cf8c$export$798cf677954c9533 = void 0;

var $3ezMU = parcelRequire("3ezMU");

var $KRh5U = parcelRequire("KRh5U");

var $g2pYe = parcelRequire("g2pYe");

var $4YWyk = parcelRequire("4YWyk");

var $lRdcz = parcelRequire("lRdcz");
/**
 * @category Locales
 * @summary Korean locale.
 * @language Korean
 * @iso-639-2 kor
 * @author Hong Chulju [@angdev](https://github.com/angdev)
 * @author Lee Seoyoen [@iamssen](https://github.com/iamssen)
 * @author Taiki IKeda [@so99ynoodles](https://github.com/so99ynoodles)
 */ const $4787e17ed600cf8c$var$ko = $4787e17ed600cf8c$export$798cf677954c9533 = {
    code: "ko",
    formatDistance: $3ezMU.formatDistance,
    formatLong: $KRh5U.formatLong,
    formatRelative: $g2pYe.formatRelative,
    localize: $4YWyk.localize,
    match: $lRdcz.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("3ezMU", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $25ae70a4ffc2e24f$export$2c14ff85d6318973; }, function (v) { return $25ae70a4ffc2e24f$export$2c14ff85d6318973 = v; });
var $25ae70a4ffc2e24f$export$2c14ff85d6318973;
"use strict";
$25ae70a4ffc2e24f$export$2c14ff85d6318973 = void 0;
const $25ae70a4ffc2e24f$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1\uCD08 \uBBF8\uB9CC",
        other: "{{count}}\uCD08 \uBBF8\uB9CC"
    },
    xSeconds: {
        one: "1\uCD08",
        other: "{{count}}\uCD08"
    },
    halfAMinute: "30\uCD08",
    lessThanXMinutes: {
        one: "1\uBD84 \uBBF8\uB9CC",
        other: "{{count}}\uBD84 \uBBF8\uB9CC"
    },
    xMinutes: {
        one: "1\uBD84",
        other: "{{count}}\uBD84"
    },
    aboutXHours: {
        one: "\uC57D 1\uC2DC\uAC04",
        other: "\uC57D {{count}}\uC2DC\uAC04"
    },
    xHours: {
        one: "1\uC2DC\uAC04",
        other: "{{count}}\uC2DC\uAC04"
    },
    xDays: {
        one: "1\uC77C",
        other: "{{count}}\uC77C"
    },
    aboutXWeeks: {
        one: "\uC57D 1\uC8FC",
        other: "\uC57D {{count}}\uC8FC"
    },
    xWeeks: {
        one: "1\uC8FC",
        other: "{{count}}\uC8FC"
    },
    aboutXMonths: {
        one: "\uC57D 1\uAC1C\uC6D4",
        other: "\uC57D {{count}}\uAC1C\uC6D4"
    },
    xMonths: {
        one: "1\uAC1C\uC6D4",
        other: "{{count}}\uAC1C\uC6D4"
    },
    aboutXYears: {
        one: "\uC57D 1\uB144",
        other: "\uC57D {{count}}\uB144"
    },
    xYears: {
        one: "1\uB144",
        other: "{{count}}\uB144"
    },
    overXYears: {
        one: "1\uB144 \uC774\uC0C1",
        other: "{{count}}\uB144 \uC774\uC0C1"
    },
    almostXYears: {
        one: "\uAC70\uC758 1\uB144",
        other: "\uAC70\uC758 {{count}}\uB144"
    }
};
const $25ae70a4ffc2e24f$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $25ae70a4ffc2e24f$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " \uD6C4";
        else return result + " \uC804";
    }
    return result;
};
$25ae70a4ffc2e24f$export$2c14ff85d6318973 = $25ae70a4ffc2e24f$var$formatDistance;

});

parcelRegister("KRh5U", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $08cd9f3dbd793927$export$cbf60ecb96cbb82f; }, function (v) { return $08cd9f3dbd793927$export$cbf60ecb96cbb82f = v; });
var $08cd9f3dbd793927$export$cbf60ecb96cbb82f;
"use strict";
$08cd9f3dbd793927$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $08cd9f3dbd793927$var$dateFormats = {
    full: "y\uB144 M\uC6D4 d\uC77C EEEE",
    long: "y\uB144 M\uC6D4 d\uC77C",
    medium: "y.MM.dd",
    short: "y.MM.dd"
};
const $08cd9f3dbd793927$var$timeFormats = {
    full: "a H\uC2DC mm\uBD84 ss\uCD08 zzzz",
    long: "a H:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $08cd9f3dbd793927$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $08cd9f3dbd793927$var$formatLong = $08cd9f3dbd793927$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $08cd9f3dbd793927$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $08cd9f3dbd793927$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $08cd9f3dbd793927$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("g2pYe", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $bad0fa73715ace46$export$8fbbfd65594f46a0; }, function (v) { return $bad0fa73715ace46$export$8fbbfd65594f46a0 = v; });
var $bad0fa73715ace46$export$8fbbfd65594f46a0;
"use strict";
$bad0fa73715ace46$export$8fbbfd65594f46a0 = void 0;
const $bad0fa73715ace46$var$formatRelativeLocale = {
    lastWeek: "'\uC9C0\uB09C' eeee p",
    yesterday: "'\uC5B4\uC81C' p",
    today: "'\uC624\uB298' p",
    tomorrow: "'\uB0B4\uC77C' p",
    nextWeek: "'\uB2E4\uC74C' eeee p",
    other: "P"
};
const $bad0fa73715ace46$var$formatRelative = (token, _date, _baseDate, _options)=>$bad0fa73715ace46$var$formatRelativeLocale[token];
$bad0fa73715ace46$export$8fbbfd65594f46a0 = $bad0fa73715ace46$var$formatRelative;

});

parcelRegister("4YWyk", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $3a0a2f5722ddd9b9$export$b3bd0bc58e36cd63; }, function (v) { return $3a0a2f5722ddd9b9$export$b3bd0bc58e36cd63 = v; });
var $3a0a2f5722ddd9b9$export$b3bd0bc58e36cd63;
"use strict";
$3a0a2f5722ddd9b9$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $3a0a2f5722ddd9b9$var$eraValues = {
    narrow: [
        "BC",
        "AD"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "\uAE30\uC6D0\uC804",
        "\uC11C\uAE30"
    ]
};
const $3a0a2f5722ddd9b9$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1\uBD84\uAE30",
        "2\uBD84\uAE30",
        "3\uBD84\uAE30",
        "4\uBD84\uAE30"
    ]
};
const $3a0a2f5722ddd9b9$var$monthValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12"
    ],
    abbreviated: [
        "1\uC6D4",
        "2\uC6D4",
        "3\uC6D4",
        "4\uC6D4",
        "5\uC6D4",
        "6\uC6D4",
        "7\uC6D4",
        "8\uC6D4",
        "9\uC6D4",
        "10\uC6D4",
        "11\uC6D4",
        "12\uC6D4"
    ],
    wide: [
        "1\uC6D4",
        "2\uC6D4",
        "3\uC6D4",
        "4\uC6D4",
        "5\uC6D4",
        "6\uC6D4",
        "7\uC6D4",
        "8\uC6D4",
        "9\uC6D4",
        "10\uC6D4",
        "11\uC6D4",
        "12\uC6D4"
    ]
};
const $3a0a2f5722ddd9b9$var$dayValues = {
    narrow: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    short: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    abbreviated: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    wide: [
        "\uC77C\uC694\uC77C",
        "\uC6D4\uC694\uC77C",
        "\uD654\uC694\uC77C",
        "\uC218\uC694\uC77C",
        "\uBAA9\uC694\uC77C",
        "\uAE08\uC694\uC77C",
        "\uD1A0\uC694\uC77C"
    ]
};
const $3a0a2f5722ddd9b9$var$dayPeriodValues = {
    narrow: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    abbreviated: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    wide: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    }
};
const $3a0a2f5722ddd9b9$var$formattingDayPeriodValues = {
    narrow: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    abbreviated: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    wide: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    }
};
const $3a0a2f5722ddd9b9$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    const unit = String(options?.unit);
    switch(unit){
        case "minute":
        case "second":
            return String(number);
        case "date":
            return number + "\uC77C";
        default:
            return number + "\uBC88\uC9F8";
    }
};
const $3a0a2f5722ddd9b9$var$localize = $3a0a2f5722ddd9b9$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $3a0a2f5722ddd9b9$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $3a0a2f5722ddd9b9$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $3a0a2f5722ddd9b9$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $3a0a2f5722ddd9b9$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $3a0a2f5722ddd9b9$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $3a0a2f5722ddd9b9$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $3a0a2f5722ddd9b9$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("lRdcz", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $fe98c9d41f4b302a$export$4659b591c19bdf3d; }, function (v) { return $fe98c9d41f4b302a$export$4659b591c19bdf3d = v; });
var $fe98c9d41f4b302a$export$4659b591c19bdf3d;
"use strict";
$fe98c9d41f4b302a$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $fe98c9d41f4b302a$var$matchOrdinalNumberPattern = /^(\d+)(일|번째)?/i;
const $fe98c9d41f4b302a$var$parseOrdinalNumberPattern = /\d+/i;
const $fe98c9d41f4b302a$var$matchEraPatterns = {
    narrow: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(기원전|서기)/i
};
const $fe98c9d41f4b302a$var$parseEraPatterns = {
    any: [
        /^(bc|기원전)/i,
        /^(ad|서기)/i
    ]
};
const $fe98c9d41f4b302a$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]사?분기/i
};
const $fe98c9d41f4b302a$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $fe98c9d41f4b302a$var$matchMonthPatterns = {
    narrow: /^(1[012]|[123456789])/,
    abbreviated: /^(1[012]|[123456789])월/i,
    wide: /^(1[012]|[123456789])월/i
};
const $fe98c9d41f4b302a$var$parseMonthPatterns = {
    any: [
        /^1월?$/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
const $fe98c9d41f4b302a$var$matchDayPatterns = {
    narrow: /^[일월화수목금토]/,
    short: /^[일월화수목금토]/,
    abbreviated: /^[일월화수목금토]/,
    wide: /^[일월화수목금토]요일/
};
const $fe98c9d41f4b302a$var$parseDayPatterns = {
    any: [
        /^일/,
        /^월/,
        /^화/,
        /^수/,
        /^목/,
        /^금/,
        /^토/
    ]
};
const $fe98c9d41f4b302a$var$matchDayPeriodPatterns = {
    any: /^(am|pm|오전|오후|자정|정오|아침|저녁|밤)/i
};
const $fe98c9d41f4b302a$var$parseDayPeriodPatterns = {
    any: {
        am: /^(am|오전)/i,
        pm: /^(pm|오후)/i,
        midnight: /^자정/i,
        noon: /^정오/i,
        morning: /^아침/i,
        afternoon: /^오후/i,
        evening: /^저녁/i,
        night: /^밤/i
    }
};
const $fe98c9d41f4b302a$var$match = $fe98c9d41f4b302a$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $fe98c9d41f4b302a$var$matchOrdinalNumberPattern,
        parsePattern: $fe98c9d41f4b302a$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $fe98c9d41f4b302a$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fe98c9d41f4b302a$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $fe98c9d41f4b302a$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fe98c9d41f4b302a$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $fe98c9d41f4b302a$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fe98c9d41f4b302a$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $fe98c9d41f4b302a$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fe98c9d41f4b302a$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $fe98c9d41f4b302a$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $fe98c9d41f4b302a$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("1kI6g", function(module, exports) {

$parcel$export(module.exports, "lb", function () { return $0f89de08ecb8f19c$export$736eba5cc491e759; }, function (v) { return $0f89de08ecb8f19c$export$736eba5cc491e759 = v; });
var $0f89de08ecb8f19c$export$736eba5cc491e759;
"use strict";
$0f89de08ecb8f19c$export$736eba5cc491e759 = void 0;

var $b8oPk = parcelRequire("b8oPk");

var $9d1yU = parcelRequire("9d1yU");

var $8VvPC = parcelRequire("8VvPC");

var $7S41H = parcelRequire("7S41H");

var $c2Ds5 = parcelRequire("c2Ds5");
/**
 * @category Locales
 * @summary Luxembourgish locale.
 * @language Luxembourgish
 * @iso-639-2 ltz
 * @author Daniel Waxweiler [@dwaxweiler](https://github.com/dwaxweiler)
 */ const $0f89de08ecb8f19c$var$lb = $0f89de08ecb8f19c$export$736eba5cc491e759 = {
    code: "lb",
    formatDistance: $b8oPk.formatDistance,
    formatLong: $9d1yU.formatLong,
    formatRelative: $8VvPC.formatRelative,
    localize: $7S41H.localize,
    match: $c2Ds5.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("b8oPk", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $81b3b323ecf703e6$export$2c14ff85d6318973; }, function (v) { return $81b3b323ecf703e6$export$2c14ff85d6318973 = v; });
var $81b3b323ecf703e6$export$2c14ff85d6318973;
"use strict";
$81b3b323ecf703e6$export$2c14ff85d6318973 = void 0;
const $81b3b323ecf703e6$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "manner w\xe9i eng Sekonn",
            other: "manner w\xe9i {{count}} Sekonnen"
        },
        withPreposition: {
            one: "manner w\xe9i enger Sekonn",
            other: "manner w\xe9i {{count}} Sekonnen"
        }
    },
    xSeconds: {
        standalone: {
            one: "eng Sekonn",
            other: "{{count}} Sekonnen"
        },
        withPreposition: {
            one: "enger Sekonn",
            other: "{{count}} Sekonnen"
        }
    },
    halfAMinute: {
        standalone: "eng hallef Minutt",
        withPreposition: "enger hallwer Minutt"
    },
    lessThanXMinutes: {
        standalone: {
            one: "manner w\xe9i eng Minutt",
            other: "manner w\xe9i {{count}} Minutten"
        },
        withPreposition: {
            one: "manner w\xe9i enger Minutt",
            other: "manner w\xe9i {{count}} Minutten"
        }
    },
    xMinutes: {
        standalone: {
            one: "eng Minutt",
            other: "{{count}} Minutten"
        },
        withPreposition: {
            one: "enger Minutt",
            other: "{{count}} Minutten"
        }
    },
    aboutXHours: {
        standalone: {
            one: "ongef\xe9ier eng Stonn",
            other: "ongef\xe9ier {{count}} Stonnen"
        },
        withPreposition: {
            one: "ongef\xe9ier enger Stonn",
            other: "ongef\xe9ier {{count}} Stonnen"
        }
    },
    xHours: {
        standalone: {
            one: "eng Stonn",
            other: "{{count}} Stonnen"
        },
        withPreposition: {
            one: "enger Stonn",
            other: "{{count}} Stonnen"
        }
    },
    xDays: {
        standalone: {
            one: "een Dag",
            other: "{{count}} Deeg"
        },
        withPreposition: {
            one: "engem Dag",
            other: "{{count}} Deeg"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "ongef\xe9ier eng Woch",
            other: "ongef\xe9ier {{count}} Wochen"
        },
        withPreposition: {
            one: "ongef\xe9ier enger Woche",
            other: "ongef\xe9ier {{count}} Wochen"
        }
    },
    xWeeks: {
        standalone: {
            one: "eng Woch",
            other: "{{count}} Wochen"
        },
        withPreposition: {
            one: "enger Woch",
            other: "{{count}} Wochen"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "ongef\xe9ier ee Mount",
            other: "ongef\xe9ier {{count}} M\xe9int"
        },
        withPreposition: {
            one: "ongef\xe9ier engem Mount",
            other: "ongef\xe9ier {{count}} M\xe9int"
        }
    },
    xMonths: {
        standalone: {
            one: "ee Mount",
            other: "{{count}} M\xe9int"
        },
        withPreposition: {
            one: "engem Mount",
            other: "{{count}} M\xe9int"
        }
    },
    aboutXYears: {
        standalone: {
            one: "ongef\xe9ier ee Joer",
            other: "ongef\xe9ier {{count}} Joer"
        },
        withPreposition: {
            one: "ongef\xe9ier engem Joer",
            other: "ongef\xe9ier {{count}} Joer"
        }
    },
    xYears: {
        standalone: {
            one: "ee Joer",
            other: "{{count}} Joer"
        },
        withPreposition: {
            one: "engem Joer",
            other: "{{count}} Joer"
        }
    },
    overXYears: {
        standalone: {
            one: "m\xe9i w\xe9i ee Joer",
            other: "m\xe9i w\xe9i {{count}} Joer"
        },
        withPreposition: {
            one: "m\xe9i w\xe9i engem Joer",
            other: "m\xe9i w\xe9i {{count}} Joer"
        }
    },
    almostXYears: {
        standalone: {
            one: "bal ee Joer",
            other: "bal {{count}} Joer"
        },
        withPreposition: {
            one: "bal engem Joer",
            other: "bal {{count}} Joer"
        }
    }
};
const $81b3b323ecf703e6$var$EXCEPTION_CONSONANTS = [
    "d",
    "h",
    "n",
    "t",
    "z"
];
const $81b3b323ecf703e6$var$VOWELS = [
    "a,",
    "e",
    "i",
    "o",
    "u"
];
const $81b3b323ecf703e6$var$DIGITS_SPOKEN_N_NEEDED = [
    0,
    1,
    2,
    3,
    8,
    9
];
const $81b3b323ecf703e6$var$FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED = [
    40,
    50,
    60,
    70
];
// Eifeler Regel
function $81b3b323ecf703e6$var$isFinalNNeeded(nextWords) {
    const firstLetter = nextWords.charAt(0).toLowerCase();
    if ($81b3b323ecf703e6$var$VOWELS.indexOf(firstLetter) != -1 || $81b3b323ecf703e6$var$EXCEPTION_CONSONANTS.indexOf(firstLetter) != -1) return true;
    // Numbers would need to converted into words for checking.
    // Therefore, I have listed the digits that require a preceeding n with a few exceptions.
    const firstWord = nextWords.split(" ")[0];
    const number = parseInt(firstWord);
    if (!isNaN(number) && $81b3b323ecf703e6$var$DIGITS_SPOKEN_N_NEEDED.indexOf(number % 10) != -1 && $81b3b323ecf703e6$var$FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED.indexOf(parseInt(firstWord.substring(0, 2))) == -1) return true;
    // Omit other checks as they are not expected here.
    return false;
}
const $81b3b323ecf703e6$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $81b3b323ecf703e6$var$formatDistanceLocale[token];
    const usageGroup = options?.addSuffix ? tokenValue.withPreposition : tokenValue.standalone;
    if (typeof usageGroup === "string") result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else result = usageGroup.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "a" + ($81b3b323ecf703e6$var$isFinalNNeeded(result) ? "n" : "") + " " + result;
        else return "viru" + ($81b3b323ecf703e6$var$isFinalNNeeded(result) ? "n" : "") + " " + result;
    }
    return result;
};
$81b3b323ecf703e6$export$2c14ff85d6318973 = $81b3b323ecf703e6$var$formatDistance;

});

parcelRegister("9d1yU", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $6b468a264d3830bc$export$cbf60ecb96cbb82f; }, function (v) { return $6b468a264d3830bc$export$cbf60ecb96cbb82f = v; });
var $6b468a264d3830bc$export$cbf60ecb96cbb82f;
"use strict";
$6b468a264d3830bc$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
// DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008
const $6b468a264d3830bc$var$dateFormats = {
    full: "EEEE, do MMMM y",
    long: "do MMMM y",
    medium: "do MMM y",
    short: "dd.MM.yy"
};
const $6b468a264d3830bc$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $6b468a264d3830bc$var$dateTimeFormats = {
    full: "{{date}} 'um' {{time}}",
    long: "{{date}} 'um' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $6b468a264d3830bc$var$formatLong = $6b468a264d3830bc$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $6b468a264d3830bc$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $6b468a264d3830bc$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $6b468a264d3830bc$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("8VvPC", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $67fc56afd75fee28$export$8fbbfd65594f46a0; }, function (v) { return $67fc56afd75fee28$export$8fbbfd65594f46a0 = v; });
var $67fc56afd75fee28$export$8fbbfd65594f46a0;
"use strict";
$67fc56afd75fee28$export$8fbbfd65594f46a0 = void 0;
const $67fc56afd75fee28$var$formatRelativeLocale = {
    lastWeek: (date)=>{
        const day = date.getDay();
        let result = "'l\xe4schte";
        if (day === 2 || day === 4) // Eifeler Regel: Add an n before the consonant d; Here "Dënschdeg" "and Donneschde".
        result += "n";
        result += "' eeee 'um' p";
        return result;
    },
    yesterday: "'g\xebschter um' p",
    today: "'haut um' p",
    tomorrow: "'moien um' p",
    nextWeek: "eeee 'um' p",
    other: "P"
};
const $67fc56afd75fee28$var$formatRelative = (token, date, _baseDate, _options)=>{
    const format = $67fc56afd75fee28$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
$67fc56afd75fee28$export$8fbbfd65594f46a0 = $67fc56afd75fee28$var$formatRelative;

});

parcelRegister("7S41H", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $5bb0b321780f512d$export$b3bd0bc58e36cd63; }, function (v) { return $5bb0b321780f512d$export$b3bd0bc58e36cd63 = v; });
var $5bb0b321780f512d$export$b3bd0bc58e36cd63;
"use strict";
$5bb0b321780f512d$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $5bb0b321780f512d$var$eraValues = {
    narrow: [
        "v.Chr.",
        "n.Chr."
    ],
    abbreviated: [
        "v.Chr.",
        "n.Chr."
    ],
    wide: [
        "viru Christus",
        "no Christus"
    ]
};
const $5bb0b321780f512d$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. Quartal",
        "2. Quartal",
        "3. Quartal",
        "4. Quartal"
    ]
};
const $5bb0b321780f512d$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "M\xe4e",
        "Abr",
        "Mee",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Dez"
    ],
    wide: [
        "Januar",
        "Februar",
        "M\xe4erz",
        "Abr\xebll",
        "Mee",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember"
    ]
};
const $5bb0b321780f512d$var$dayValues = {
    narrow: [
        "S",
        "M",
        "D",
        "M",
        "D",
        "F",
        "S"
    ],
    short: [
        "So",
        "M\xe9",
        "D\xeb",
        "M\xeb",
        "Do",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "So.",
        "M\xe9.",
        "D\xeb.",
        "M\xeb.",
        "Do.",
        "Fr.",
        "Sa."
    ],
    wide: [
        "Sonndeg",
        "M\xe9indeg",
        "D\xebnschdeg",
        "M\xebttwoch",
        "Donneschdeg",
        "Freideg",
        "Samschdeg"
    ]
};
const $5bb0b321780f512d$var$dayPeriodValues = {
    narrow: {
        am: "mo.",
        pm: "nom\xeb.",
        midnight: "M\xebtternuecht",
        noon: "M\xebtteg",
        morning: "Moien",
        afternoon: "Nom\xebtteg",
        evening: "Owend",
        night: "Nuecht"
    },
    abbreviated: {
        am: "moies",
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "M\xebtteg",
        morning: "Moien",
        afternoon: "Nom\xebtteg",
        evening: "Owend",
        night: "Nuecht"
    },
    wide: {
        am: "moies",
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "M\xebtteg",
        morning: "Moien",
        afternoon: "Nom\xebtteg",
        evening: "Owend",
        night: "Nuecht"
    }
};
const $5bb0b321780f512d$var$formattingDayPeriodValues = {
    narrow: {
        am: "mo.",
        pm: "nom.",
        midnight: "M\xebtternuecht",
        noon: "m\xebttes",
        morning: "moies",
        afternoon: "nom\xebttes",
        evening: "owes",
        night: "nuets"
    },
    abbreviated: {
        am: "moies",
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "m\xebttes",
        morning: "moies",
        afternoon: "nom\xebttes",
        evening: "owes",
        night: "nuets"
    },
    wide: {
        am: "moies",
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "m\xebttes",
        morning: "moies",
        afternoon: "nom\xebttes",
        evening: "owes",
        night: "nuets"
    }
};
const $5bb0b321780f512d$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $5bb0b321780f512d$var$localize = $5bb0b321780f512d$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $5bb0b321780f512d$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $5bb0b321780f512d$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $5bb0b321780f512d$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $5bb0b321780f512d$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $5bb0b321780f512d$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $5bb0b321780f512d$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $5bb0b321780f512d$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("c2Ds5", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $8c44464df320eef5$export$4659b591c19bdf3d; }, function (v) { return $8c44464df320eef5$export$4659b591c19bdf3d = v; });
var $8c44464df320eef5$export$4659b591c19bdf3d;
"use strict";
$8c44464df320eef5$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $8c44464df320eef5$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
const $8c44464df320eef5$var$parseOrdinalNumberPattern = /\d+/i;
const $8c44464df320eef5$var$matchEraPatterns = {
    narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    wide: /^(viru Christus|virun eiser Zäitrechnung|no Christus|eiser Zäitrechnung)/i
};
const $8c44464df320eef5$var$parseEraPatterns = {
    any: [
        /^v/i,
        /^n/i
    ]
};
const $8c44464df320eef5$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? Quartal/i
};
const $8c44464df320eef5$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $8c44464df320eef5$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mäe|abr|mee|jun|jul|aug|sep|okt|nov|dez)/i,
    wide: /^(januar|februar|mäerz|abrëll|mee|juni|juli|august|september|oktober|november|dezember)/i
};
const $8c44464df320eef5$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mä/i,
        /^ab/i,
        /^me/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $8c44464df320eef5$var$matchDayPatterns = {
    narrow: /^[smdf]/i,
    short: /^(so|mé|dë|më|do|fr|sa)/i,
    abbreviated: /^(son?|méi?|dën?|mët?|don?|fre?|sam?)\.?/i,
    wide: /^(sonndeg|méindeg|dënschdeg|mëttwoch|donneschdeg|freideg|samschdeg)/i
};
const $8c44464df320eef5$var$parseDayPatterns = {
    any: [
        /^so/i,
        /^mé/i,
        /^dë/i,
        /^më/i,
        /^do/i,
        /^f/i,
        /^sa/i
    ]
};
const $8c44464df320eef5$var$matchDayPeriodPatterns = {
    narrow: /^(mo\.?|nomë\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
    abbreviated: /^(moi\.?|nomët\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
    wide: /^(moies|nomëttes|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i
};
const $8c44464df320eef5$var$parseDayPeriodPatterns = {
    any: {
        am: /^m/i,
        pm: /^n/i,
        midnight: /^Mëtter/i,
        noon: /^mëttes/i,
        morning: /moies/i,
        afternoon: /nomëttes/i,
        evening: /owes/i,
        night: /nuets/i
    }
};
const $8c44464df320eef5$var$match = $8c44464df320eef5$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $8c44464df320eef5$var$matchOrdinalNumberPattern,
        parsePattern: $8c44464df320eef5$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $8c44464df320eef5$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8c44464df320eef5$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $8c44464df320eef5$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8c44464df320eef5$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $8c44464df320eef5$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8c44464df320eef5$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $8c44464df320eef5$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8c44464df320eef5$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $8c44464df320eef5$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8c44464df320eef5$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("5JNRl", function(module, exports) {

$parcel$export(module.exports, "lt", function () { return $42d7d4bd7d97e697$export$b961576059b7aeb6; }, function (v) { return $42d7d4bd7d97e697$export$b961576059b7aeb6 = v; });
var $42d7d4bd7d97e697$export$b961576059b7aeb6;
"use strict";
$42d7d4bd7d97e697$export$b961576059b7aeb6 = void 0;

var $2o5Tn = parcelRequire("2o5Tn");

var $6KQs1 = parcelRequire("6KQs1");

var $fnOWK = parcelRequire("fnOWK");

var $clxm6 = parcelRequire("clxm6");

var $jjtnf = parcelRequire("jjtnf");
/**
 * @category Locales
 * @summary Lithuanian locale.
 * @language Lithuanian
 * @iso-639-2 lit
 * @author Pavlo Shpak [@pshpak](https://github.com/pshpak)
 * @author Eduardo Pardo [@eduardopsll](https://github.com/eduardopsll)
 */ const $42d7d4bd7d97e697$var$lt = $42d7d4bd7d97e697$export$b961576059b7aeb6 = {
    code: "lt",
    formatDistance: $2o5Tn.formatDistance,
    formatLong: $6KQs1.formatLong,
    formatRelative: $fnOWK.formatRelative,
    localize: $clxm6.localize,
    match: $jjtnf.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("2o5Tn", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $1bd264b7ea519619$export$2c14ff85d6318973; }, function (v) { return $1bd264b7ea519619$export$2c14ff85d6318973 = v; });
var $1bd264b7ea519619$export$2c14ff85d6318973;
"use strict";
$1bd264b7ea519619$export$2c14ff85d6318973 = void 0;
const $1bd264b7ea519619$var$translations = {
    xseconds_other: "sekund\u0117_sekund\u017Ei\u0173_sekundes",
    xminutes_one: "minut\u0117_minut\u0117s_minut\u0119",
    xminutes_other: "minut\u0117s_minu\u010Di\u0173_minutes",
    xhours_one: "valanda_valandos_valand\u0105",
    xhours_other: "valandos_valand\u0173_valandas",
    xdays_one: "diena_dienos_dien\u0105",
    xdays_other: "dienos_dien\u0173_dienas",
    xweeks_one: "savait\u0117_savait\u0117s_savait\u0119",
    xweeks_other: "savait\u0117s_savai\u010Di\u0173_savaites",
    xmonths_one: "m\u0117nuo_m\u0117nesio_m\u0117nes\u012F",
    xmonths_other: "m\u0117nesiai_m\u0117nesi\u0173_m\u0117nesius",
    xyears_one: "metai_met\u0173_metus",
    xyears_other: "metai_met\u0173_metus",
    about: "apie",
    over: "daugiau nei",
    almost: "beveik",
    lessthan: "ma\u017Eiau nei"
};
const $1bd264b7ea519619$var$translateSeconds = (_number, addSuffix, _key, isFuture)=>{
    if (!addSuffix) return "kelios sekund\u0117s";
    else return isFuture ? "keli\u0173 sekund\u017Ei\u0173" : "kelias sekundes";
};
const $1bd264b7ea519619$var$translateSingular = (_number, addSuffix, key, isFuture)=>{
    return !addSuffix ? $1bd264b7ea519619$var$forms(key)[0] : isFuture ? $1bd264b7ea519619$var$forms(key)[1] : $1bd264b7ea519619$var$forms(key)[2];
};
const $1bd264b7ea519619$var$translate = (number, addSuffix, key, isFuture)=>{
    const result = number + " ";
    if (number === 1) return result + $1bd264b7ea519619$var$translateSingular(number, addSuffix, key, isFuture);
    else if (!addSuffix) return result + ($1bd264b7ea519619$var$special(number) ? $1bd264b7ea519619$var$forms(key)[1] : $1bd264b7ea519619$var$forms(key)[0]);
    else {
        if (isFuture) return result + $1bd264b7ea519619$var$forms(key)[1];
        else return result + ($1bd264b7ea519619$var$special(number) ? $1bd264b7ea519619$var$forms(key)[1] : $1bd264b7ea519619$var$forms(key)[2]);
    }
};
function $1bd264b7ea519619$var$special(number) {
    return number % 10 === 0 || number > 10 && number < 20;
}
function $1bd264b7ea519619$var$forms(key) {
    return $1bd264b7ea519619$var$translations[key].split("_");
}
const $1bd264b7ea519619$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: $1bd264b7ea519619$var$translateSeconds,
        other: $1bd264b7ea519619$var$translate
    },
    xSeconds: {
        one: $1bd264b7ea519619$var$translateSeconds,
        other: $1bd264b7ea519619$var$translate
    },
    halfAMinute: "pus\u0117 minut\u0117s",
    lessThanXMinutes: {
        one: $1bd264b7ea519619$var$translateSingular,
        other: $1bd264b7ea519619$var$translate
    },
    xMinutes: {
        one: $1bd264b7ea519619$var$translateSingular,
        other: $1bd264b7ea519619$var$translate
    },
    aboutXHours: {
        one: $1bd264b7ea519619$var$translateSingular,
        other: $1bd264b7ea519619$var$translate
    },
    xHours: {
        one: $1bd264b7ea519619$var$translateSingular,
        other: $1bd264b7ea519619$var$translate
    },
    xDays: {
        one: $1bd264b7ea519619$var$translateSingular,
        other: $1bd264b7ea519619$var$translate
    },
    aboutXWeeks: {
        one: $1bd264b7ea519619$var$translateSingular,
        other: $1bd264b7ea519619$var$translate
    },
    xWeeks: {
        one: $1bd264b7ea519619$var$translateSingular,
        other: $1bd264b7ea519619$var$translate
    },
    aboutXMonths: {
        one: $1bd264b7ea519619$var$translateSingular,
        other: $1bd264b7ea519619$var$translate
    },
    xMonths: {
        one: $1bd264b7ea519619$var$translateSingular,
        other: $1bd264b7ea519619$var$translate
    },
    aboutXYears: {
        one: $1bd264b7ea519619$var$translateSingular,
        other: $1bd264b7ea519619$var$translate
    },
    xYears: {
        one: $1bd264b7ea519619$var$translateSingular,
        other: $1bd264b7ea519619$var$translate
    },
    overXYears: {
        one: $1bd264b7ea519619$var$translateSingular,
        other: $1bd264b7ea519619$var$translate
    },
    almostXYears: {
        one: $1bd264b7ea519619$var$translateSingular,
        other: $1bd264b7ea519619$var$translate
    }
};
const $1bd264b7ea519619$var$formatDistance = (token, count, options)=>{
    const adverb = token.match(/about|over|almost|lessthan/i);
    const unit = adverb ? token.replace(adverb[0], "") : token;
    const isFuture = options?.comparison !== undefined && options.comparison > 0;
    let result;
    const tokenValue = $1bd264b7ea519619$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one(count, options?.addSuffix === true, unit.toLowerCase() + "_one", isFuture);
    else result = tokenValue.other(count, options?.addSuffix === true, unit.toLowerCase() + "_other", isFuture);
    if (adverb) {
        const key = adverb[0].toLowerCase();
        result = $1bd264b7ea519619$var$translations[key] + " " + result;
    }
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "po " + result;
        else return "prie\u0161 " + result;
    }
    return result;
};
$1bd264b7ea519619$export$2c14ff85d6318973 = $1bd264b7ea519619$var$formatDistance;

});

parcelRegister("6KQs1", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $4eafb9a655362d61$export$cbf60ecb96cbb82f; }, function (v) { return $4eafb9a655362d61$export$cbf60ecb96cbb82f = v; });
var $4eafb9a655362d61$export$cbf60ecb96cbb82f;
"use strict";
$4eafb9a655362d61$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $4eafb9a655362d61$var$dateFormats = {
    full: "y 'm'. MMMM d 'd'., EEEE",
    long: "y 'm'. MMMM d 'd'.",
    medium: "y-MM-dd",
    short: "y-MM-dd"
};
const $4eafb9a655362d61$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $4eafb9a655362d61$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $4eafb9a655362d61$var$formatLong = $4eafb9a655362d61$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $4eafb9a655362d61$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $4eafb9a655362d61$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $4eafb9a655362d61$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("fnOWK", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $b33085f0d90d3cee$export$8fbbfd65594f46a0; }, function (v) { return $b33085f0d90d3cee$export$8fbbfd65594f46a0 = v; });
var $b33085f0d90d3cee$export$8fbbfd65594f46a0;
"use strict";
$b33085f0d90d3cee$export$8fbbfd65594f46a0 = void 0;
const $b33085f0d90d3cee$var$formatRelativeLocale = {
    lastWeek: "'Pra\u0117jus\u012F' eeee p",
    yesterday: "'Vakar' p",
    today: "'\u0160iandien' p",
    tomorrow: "'Rytoj' p",
    nextWeek: "eeee p",
    other: "P"
};
const $b33085f0d90d3cee$var$formatRelative = (token, _date, _baseDate, _options)=>$b33085f0d90d3cee$var$formatRelativeLocale[token];
$b33085f0d90d3cee$export$8fbbfd65594f46a0 = $b33085f0d90d3cee$var$formatRelative;

});

parcelRegister("clxm6", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $8fd151eb36e042a9$export$b3bd0bc58e36cd63; }, function (v) { return $8fd151eb36e042a9$export$b3bd0bc58e36cd63 = v; });
var $8fd151eb36e042a9$export$b3bd0bc58e36cd63;
"use strict";
$8fd151eb36e042a9$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $8fd151eb36e042a9$var$eraValues = {
    narrow: [
        "pr. Kr.",
        "po Kr."
    ],
    abbreviated: [
        "pr. Kr.",
        "po Kr."
    ],
    wide: [
        "prie\u0161 Krist\u0173",
        "po Kristaus"
    ]
};
const $8fd151eb36e042a9$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "I ketv.",
        "II ketv.",
        "III ketv.",
        "IV ketv."
    ],
    wide: [
        "I ketvirtis",
        "II ketvirtis",
        "III ketvirtis",
        "IV ketvirtis"
    ]
};
const $8fd151eb36e042a9$var$formattingQuarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "I k.",
        "II k.",
        "III k.",
        "IV k."
    ],
    wide: [
        "I ketvirtis",
        "II ketvirtis",
        "III ketvirtis",
        "IV ketvirtis"
    ]
};
const $8fd151eb36e042a9$var$monthValues = {
    narrow: [
        "S",
        "V",
        "K",
        "B",
        "G",
        "B",
        "L",
        "R",
        "R",
        "S",
        "L",
        "G"
    ],
    abbreviated: [
        "saus.",
        "vas.",
        "kov.",
        "bal.",
        "geg.",
        "bir\u017E.",
        "liep.",
        "rugp.",
        "rugs.",
        "spal.",
        "lapkr.",
        "gruod."
    ],
    wide: [
        "sausis",
        "vasaris",
        "kovas",
        "balandis",
        "gegu\u017E\u0117",
        "bir\u017Eelis",
        "liepa",
        "rugpj\u016Btis",
        "rugs\u0117jis",
        "spalis",
        "lapkritis",
        "gruodis"
    ]
};
const $8fd151eb36e042a9$var$formattingMonthValues = {
    narrow: [
        "S",
        "V",
        "K",
        "B",
        "G",
        "B",
        "L",
        "R",
        "R",
        "S",
        "L",
        "G"
    ],
    abbreviated: [
        "saus.",
        "vas.",
        "kov.",
        "bal.",
        "geg.",
        "bir\u017E.",
        "liep.",
        "rugp.",
        "rugs.",
        "spal.",
        "lapkr.",
        "gruod."
    ],
    wide: [
        "sausio",
        "vasario",
        "kovo",
        "baland\u017Eio",
        "gegu\u017E\u0117s",
        "bir\u017Eelio",
        "liepos",
        "rugpj\u016B\u010Dio",
        "rugs\u0117jo",
        "spalio",
        "lapkri\u010Dio",
        "gruod\u017Eio"
    ]
};
const $8fd151eb36e042a9$var$dayValues = {
    narrow: [
        "S",
        "P",
        "A",
        "T",
        "K",
        "P",
        "\u0160"
    ],
    short: [
        "Sk",
        "Pr",
        "An",
        "Tr",
        "Kt",
        "Pn",
        "\u0160t"
    ],
    abbreviated: [
        "sk",
        "pr",
        "an",
        "tr",
        "kt",
        "pn",
        "\u0161t"
    ],
    wide: [
        "sekmadienis",
        "pirmadienis",
        "antradienis",
        "tre\u010Diadienis",
        "ketvirtadienis",
        "penktadienis",
        "\u0161e\u0161tadienis"
    ]
};
const $8fd151eb36e042a9$var$formattingDayValues = {
    narrow: [
        "S",
        "P",
        "A",
        "T",
        "K",
        "P",
        "\u0160"
    ],
    short: [
        "Sk",
        "Pr",
        "An",
        "Tr",
        "Kt",
        "Pn",
        "\u0160t"
    ],
    abbreviated: [
        "sk",
        "pr",
        "an",
        "tr",
        "kt",
        "pn",
        "\u0161t"
    ],
    wide: [
        "sekmadien\u012F",
        "pirmadien\u012F",
        "antradien\u012F",
        "tre\u010Diadien\u012F",
        "ketvirtadien\u012F",
        "penktadien\u012F",
        "\u0161e\u0161tadien\u012F"
    ]
};
const $8fd151eb36e042a9$var$dayPeriodValues = {
    narrow: {
        am: "pr. p.",
        pm: "pop.",
        midnight: "vidurnaktis",
        noon: "vidurdienis",
        morning: "rytas",
        afternoon: "diena",
        evening: "vakaras",
        night: "naktis"
    },
    abbreviated: {
        am: "prie\u0161piet",
        pm: "popiet",
        midnight: "vidurnaktis",
        noon: "vidurdienis",
        morning: "rytas",
        afternoon: "diena",
        evening: "vakaras",
        night: "naktis"
    },
    wide: {
        am: "prie\u0161piet",
        pm: "popiet",
        midnight: "vidurnaktis",
        noon: "vidurdienis",
        morning: "rytas",
        afternoon: "diena",
        evening: "vakaras",
        night: "naktis"
    }
};
const $8fd151eb36e042a9$var$formattingDayPeriodValues = {
    narrow: {
        am: "pr. p.",
        pm: "pop.",
        midnight: "vidurnaktis",
        noon: "perpiet",
        morning: "rytas",
        afternoon: "popiet\u0117",
        evening: "vakaras",
        night: "naktis"
    },
    abbreviated: {
        am: "prie\u0161piet",
        pm: "popiet",
        midnight: "vidurnaktis",
        noon: "perpiet",
        morning: "rytas",
        afternoon: "popiet\u0117",
        evening: "vakaras",
        night: "naktis"
    },
    wide: {
        am: "prie\u0161piet",
        pm: "popiet",
        midnight: "vidurnaktis",
        noon: "perpiet",
        morning: "rytas",
        afternoon: "popiet\u0117",
        evening: "vakaras",
        night: "naktis"
    }
};
const $8fd151eb36e042a9$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + "-oji";
};
const $8fd151eb36e042a9$var$localize = $8fd151eb36e042a9$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $8fd151eb36e042a9$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $8fd151eb36e042a9$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $8fd151eb36e042a9$var$quarterValues,
        defaultWidth: "wide",
        formattingValues: $8fd151eb36e042a9$var$formattingQuarterValues,
        defaultFormattingWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $8fd151eb36e042a9$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $8fd151eb36e042a9$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $8fd151eb36e042a9$var$dayValues,
        defaultWidth: "wide",
        formattingValues: $8fd151eb36e042a9$var$formattingDayValues,
        defaultFormattingWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $8fd151eb36e042a9$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $8fd151eb36e042a9$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("jjtnf", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $e0f693c0276b709f$export$4659b591c19bdf3d; }, function (v) { return $e0f693c0276b709f$export$4659b591c19bdf3d = v; });
var $e0f693c0276b709f$export$4659b591c19bdf3d;
"use strict";
$e0f693c0276b709f$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $e0f693c0276b709f$var$matchOrdinalNumberPattern = /^(\d+)(-oji)?/i;
const $e0f693c0276b709f$var$parseOrdinalNumberPattern = /\d+/i;
const $e0f693c0276b709f$var$matchEraPatterns = {
    narrow: /^p(r|o)\.?\s?(kr\.?|me)/i,
    abbreviated: /^(pr\.\s?(kr\.|m\.\s?e\.)|po\s?kr\.|mūsų eroje)/i,
    wide: /^(prieš Kristų|prieš mūsų erą|po Kristaus|mūsų eroje)/i
};
const $e0f693c0276b709f$var$parseEraPatterns = {
    wide: [
        /prieš/i,
        /(po|mūsų)/i
    ],
    any: [
        /^pr/i,
        /^(po|m)/i
    ]
};
const $e0f693c0276b709f$var$matchQuarterPatterns = {
    narrow: /^([1234])/i,
    abbreviated: /^(I|II|III|IV)\s?ketv?\.?/i,
    wide: /^(I|II|III|IV)\s?ketvirtis/i
};
const $e0f693c0276b709f$var$parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /I$/i,
        /II$/i,
        /III/i,
        /IV/i
    ]
};
const $e0f693c0276b709f$var$matchMonthPatterns = {
    narrow: /^[svkbglr]/i,
    abbreviated: /^(saus\.|vas\.|kov\.|bal\.|geg\.|birž\.|liep\.|rugp\.|rugs\.|spal\.|lapkr\.|gruod\.)/i,
    wide: /^(sausi(s|o)|vasari(s|o)|kov(a|o)s|balandž?i(s|o)|gegužės?|birželi(s|o)|liep(a|os)|rugpjū(t|č)i(s|o)|rugsėj(is|o)|spali(s|o)|lapkri(t|č)i(s|o)|gruodž?i(s|o))/i
};
const $e0f693c0276b709f$var$parseMonthPatterns = {
    narrow: [
        /^s/i,
        /^v/i,
        /^k/i,
        /^b/i,
        /^g/i,
        /^b/i,
        /^l/i,
        /^r/i,
        /^r/i,
        /^s/i,
        /^l/i,
        /^g/i
    ],
    any: [
        /^saus/i,
        /^vas/i,
        /^kov/i,
        /^bal/i,
        /^geg/i,
        /^birž/i,
        /^liep/i,
        /^rugp/i,
        /^rugs/i,
        /^spal/i,
        /^lapkr/i,
        /^gruod/i
    ]
};
const $e0f693c0276b709f$var$matchDayPatterns = {
    narrow: /^[spatkš]/i,
    short: /^(sk|pr|an|tr|kt|pn|št)/i,
    abbreviated: /^(sk|pr|an|tr|kt|pn|št)/i,
    wide: /^(sekmadien(is|į)|pirmadien(is|į)|antradien(is|į)|trečiadien(is|į)|ketvirtadien(is|į)|penktadien(is|į)|šeštadien(is|į))/i
};
const $e0f693c0276b709f$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^p/i,
        /^a/i,
        /^t/i,
        /^k/i,
        /^p/i,
        /^š/i
    ],
    wide: [
        /^se/i,
        /^pi/i,
        /^an/i,
        /^tr/i,
        /^ke/i,
        /^pe/i,
        /^še/i
    ],
    any: [
        /^sk/i,
        /^pr/i,
        /^an/i,
        /^tr/i,
        /^kt/i,
        /^pn/i,
        /^št/i
    ]
};
const $e0f693c0276b709f$var$matchDayPeriodPatterns = {
    narrow: /^(pr.\s?p.|pop.|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i,
    any: /^(priešpiet|popiet$|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i
};
const $e0f693c0276b709f$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^pr/i,
        pm: /^pop./i,
        midnight: /^vidurnaktis/i,
        noon: /^(vidurdienis|perp)/i,
        morning: /rytas/i,
        afternoon: /(die|popietė)/i,
        evening: /vakaras/i,
        night: /naktis/i
    },
    any: {
        am: /^pr/i,
        pm: /^popiet$/i,
        midnight: /^vidurnaktis/i,
        noon: /^(vidurdienis|perp)/i,
        morning: /rytas/i,
        afternoon: /(die|popietė)/i,
        evening: /vakaras/i,
        night: /naktis/i
    }
};
const $e0f693c0276b709f$var$match = $e0f693c0276b709f$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $e0f693c0276b709f$var$matchOrdinalNumberPattern,
        parsePattern: $e0f693c0276b709f$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e0f693c0276b709f$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e0f693c0276b709f$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e0f693c0276b709f$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e0f693c0276b709f$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e0f693c0276b709f$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e0f693c0276b709f$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e0f693c0276b709f$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e0f693c0276b709f$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e0f693c0276b709f$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $e0f693c0276b709f$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("6rRIb", function(module, exports) {

$parcel$export(module.exports, "lv", function () { return $4b1eedb42479af6d$export$54ca4d1eb7926f1; }, function (v) { return $4b1eedb42479af6d$export$54ca4d1eb7926f1 = v; });
var $4b1eedb42479af6d$export$54ca4d1eb7926f1;
"use strict";
$4b1eedb42479af6d$export$54ca4d1eb7926f1 = void 0;

var $4xlOb = parcelRequire("4xlOb");

var $5c2NO = parcelRequire("5c2NO");

var $k6s9m = parcelRequire("k6s9m");

var $dmNev = parcelRequire("dmNev");

var $5vnd1 = parcelRequire("5vnd1");
/**
 * @category Locales
 * @summary Latvian locale (Latvia).
 * @language Latvian
 * @iso-639-2 lav
 * @author Rūdolfs Puķītis [@prudolfs](https://github.com/prudolfs)
 */ const $4b1eedb42479af6d$var$lv = $4b1eedb42479af6d$export$54ca4d1eb7926f1 = {
    code: "lv",
    formatDistance: $4xlOb.formatDistance,
    formatLong: $5c2NO.formatLong,
    formatRelative: $k6s9m.formatRelative,
    localize: $dmNev.localize,
    match: $5vnd1.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("4xlOb", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $34db292a94eba6c8$export$2c14ff85d6318973; }, function (v) { return $34db292a94eba6c8$export$2c14ff85d6318973 = v; });
var $34db292a94eba6c8$export$2c14ff85d6318973;
"use strict";
$34db292a94eba6c8$export$2c14ff85d6318973 = void 0;
function $34db292a94eba6c8$var$buildLocalizeTokenFn(schema) {
    return (count, options)=>{
        if (count === 1) {
            if (options?.addSuffix) return schema.one[0].replace("{{time}}", schema.one[2]);
            else return schema.one[0].replace("{{time}}", schema.one[1]);
        } else {
            const rem = count % 10 === 1 && count % 100 !== 11;
            if (options?.addSuffix) return schema.other[0].replace("{{time}}", rem ? schema.other[3] : schema.other[4]).replace("{{count}}", String(count));
            else return schema.other[0].replace("{{time}}", rem ? schema.other[1] : schema.other[2]).replace("{{count}}", String(count));
        }
    };
}
const $34db292a94eba6c8$var$formatDistanceLocale = {
    lessThanXSeconds: $34db292a94eba6c8$var$buildLocalizeTokenFn({
        one: [
            "maz\u0101k par {{time}}",
            "sekundi",
            "sekundi"
        ],
        other: [
            "maz\u0101k nek\u0101 {{count}} {{time}}",
            "sekunde",
            "sekundes",
            "sekundes",
            "sekund\u0113m"
        ]
    }),
    xSeconds: $34db292a94eba6c8$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "sekunde",
            "sekundes"
        ],
        other: [
            "{{count}} {{time}}",
            "sekunde",
            "sekundes",
            "sekundes",
            "sekund\u0113m"
        ]
    }),
    halfAMinute: (_count, options)=>{
        if (options?.addSuffix) return "pusmin\u016Btes";
        else return "pusmin\u016Bte";
    },
    lessThanXMinutes: $34db292a94eba6c8$var$buildLocalizeTokenFn({
        one: [
            "maz\u0101k par {{time}}",
            "min\u016Bti",
            "min\u016Bti"
        ],
        other: [
            "maz\u0101k nek\u0101 {{count}} {{time}}",
            "min\u016Bte",
            "min\u016Btes",
            "min\u016Btes",
            "min\u016Bt\u0113m"
        ]
    }),
    xMinutes: $34db292a94eba6c8$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "min\u016Bte",
            "min\u016Btes"
        ],
        other: [
            "{{count}} {{time}}",
            "min\u016Bte",
            "min\u016Btes",
            "min\u016Btes",
            "min\u016Bt\u0113m"
        ]
    }),
    aboutXHours: $34db292a94eba6c8$var$buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            "stunda",
            "stundas"
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            "stunda",
            "stundas",
            "stundas",
            "stund\u0101m"
        ]
    }),
    xHours: $34db292a94eba6c8$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "stunda",
            "stundas"
        ],
        other: [
            "{{count}} {{time}}",
            "stunda",
            "stundas",
            "stundas",
            "stund\u0101m"
        ]
    }),
    xDays: $34db292a94eba6c8$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "diena",
            "dienas"
        ],
        other: [
            "{{count}} {{time}}",
            "diena",
            "dienas",
            "dienas",
            "dien\u0101m"
        ]
    }),
    aboutXWeeks: $34db292a94eba6c8$var$buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cas"
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cu",
            "ned\u0113\u013Cas",
            "ned\u0113\u013C\u0101m"
        ]
    }),
    xWeeks: $34db292a94eba6c8$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cas"
        ],
        other: [
            "{{count}} {{time}}",
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cu",
            "ned\u0113\u013Cas",
            "ned\u0113\u013C\u0101m"
        ]
    }),
    aboutXMonths: $34db292a94eba6c8$var$buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            "m\u0113nesis",
            "m\u0113ne\u0161a"
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            "m\u0113nesis",
            "m\u0113ne\u0161i",
            "m\u0113ne\u0161a",
            "m\u0113ne\u0161iem"
        ]
    }),
    xMonths: $34db292a94eba6c8$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "m\u0113nesis",
            "m\u0113ne\u0161a"
        ],
        other: [
            "{{count}} {{time}}",
            "m\u0113nesis",
            "m\u0113ne\u0161i",
            "m\u0113ne\u0161a",
            "m\u0113ne\u0161iem"
        ]
    }),
    aboutXYears: $34db292a94eba6c8$var$buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            "gads",
            "gada"
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            "gads",
            "gadi",
            "gada",
            "gadiem"
        ]
    }),
    xYears: $34db292a94eba6c8$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "gads",
            "gada"
        ],
        other: [
            "{{count}} {{time}}",
            "gads",
            "gadi",
            "gada",
            "gadiem"
        ]
    }),
    overXYears: $34db292a94eba6c8$var$buildLocalizeTokenFn({
        one: [
            "ilg\u0101k par 1 {{time}}",
            "gadu",
            "gadu"
        ],
        other: [
            "vair\u0101k nek\u0101 {{count}} {{time}}",
            "gads",
            "gadi",
            "gada",
            "gadiem"
        ]
    }),
    almostXYears: $34db292a94eba6c8$var$buildLocalizeTokenFn({
        one: [
            "gandr\u012Bz 1 {{time}}",
            "gads",
            "gada"
        ],
        other: [
            "vair\u0101k nek\u0101 {{count}} {{time}}",
            "gads",
            "gadi",
            "gada",
            "gadiem"
        ]
    })
};
const $34db292a94eba6c8$var$formatDistance = (token, count, options)=>{
    const result = $34db292a94eba6c8$var$formatDistanceLocale[token](count, options);
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "p\u0113c " + result;
        else return "pirms " + result;
    }
    return result;
};
$34db292a94eba6c8$export$2c14ff85d6318973 = $34db292a94eba6c8$var$formatDistance;

});

parcelRegister("5c2NO", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $3c803f38d67741d1$export$cbf60ecb96cbb82f; }, function (v) { return $3c803f38d67741d1$export$cbf60ecb96cbb82f = v; });
var $3c803f38d67741d1$export$cbf60ecb96cbb82f;
"use strict";
$3c803f38d67741d1$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $3c803f38d67741d1$var$dateFormats = {
    full: "EEEE, y. 'gada' d. MMMM",
    long: "y. 'gada' d. MMMM",
    medium: "dd.MM.y.",
    short: "dd.MM.y."
};
const $3c803f38d67741d1$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $3c803f38d67741d1$var$dateTimeFormats = {
    full: "{{date}} 'plkst.' {{time}}",
    long: "{{date}} 'plkst.' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $3c803f38d67741d1$var$formatLong = $3c803f38d67741d1$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $3c803f38d67741d1$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $3c803f38d67741d1$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $3c803f38d67741d1$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("k6s9m", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $ea2a342f83626d5d$export$8fbbfd65594f46a0; }, function (v) { return $ea2a342f83626d5d$export$8fbbfd65594f46a0 = v; });
var $ea2a342f83626d5d$export$8fbbfd65594f46a0;
"use strict";
$ea2a342f83626d5d$export$8fbbfd65594f46a0 = void 0;

var $9VRW1 = parcelRequire("9VRW1");
const $ea2a342f83626d5d$var$weekdays = [
    "sv\u0113tdien\u0101",
    "pirmdien\u0101",
    "otrdien\u0101",
    "tre\u0161dien\u0101",
    "ceturtdien\u0101",
    "piektdien\u0101",
    "sestdien\u0101"
];
const $ea2a342f83626d5d$var$formatRelativeLocale = {
    lastWeek: (date, baseDate, options)=>{
        if ((0, $9VRW1.isSameWeek)(date, baseDate, options)) return "eeee 'plkst.' p";
        const weekday = $ea2a342f83626d5d$var$weekdays[date.getDay()];
        return "'Pag\u0101ju\u0161\u0101 " + weekday + " plkst.' p";
    },
    yesterday: "'Vakar plkst.' p",
    today: "'\u0160odien plkst.' p",
    tomorrow: "'R\u012Bt plkst.' p",
    nextWeek: (date, baseDate, options)=>{
        if ((0, $9VRW1.isSameWeek)(date, baseDate, options)) return "eeee 'plkst.' p";
        const weekday = $ea2a342f83626d5d$var$weekdays[date.getDay()];
        return "'N\u0101kamaj\u0101 " + weekday + " plkst.' p";
    },
    other: "P"
};
const $ea2a342f83626d5d$var$formatRelative = (token, date, baseDate, options)=>{
    const format = $ea2a342f83626d5d$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
$ea2a342f83626d5d$export$8fbbfd65594f46a0 = $ea2a342f83626d5d$var$formatRelative;

});

parcelRegister("dmNev", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $9bb3851720dfdbc9$export$b3bd0bc58e36cd63; }, function (v) { return $9bb3851720dfdbc9$export$b3bd0bc58e36cd63 = v; });
var $9bb3851720dfdbc9$export$b3bd0bc58e36cd63;
"use strict";
$9bb3851720dfdbc9$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $9bb3851720dfdbc9$var$eraValues = {
    narrow: [
        "p.m.\u0113",
        "m.\u0113"
    ],
    abbreviated: [
        "p. m. \u0113.",
        "m. \u0113."
    ],
    wide: [
        "pirms m\u016Bsu \u0113ras",
        "m\u016Bsu \u0113r\u0101"
    ]
};
const $9bb3851720dfdbc9$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1. cet.",
        "2. cet.",
        "3. cet.",
        "4. cet."
    ],
    wide: [
        "pirmais ceturksnis",
        "otrais ceturksnis",
        "tre\u0161ais ceturksnis",
        "ceturtais ceturksnis"
    ]
};
const $9bb3851720dfdbc9$var$formattingQuarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1. cet.",
        "2. cet.",
        "3. cet.",
        "4. cet."
    ],
    wide: [
        "pirmaj\u0101 ceturksn\u012B",
        "otraj\u0101 ceturksn\u012B",
        "tre\u0161aj\u0101 ceturksn\u012B",
        "ceturtaj\u0101 ceturksn\u012B"
    ]
};
const $9bb3851720dfdbc9$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "janv.",
        "febr.",
        "marts",
        "apr.",
        "maijs",
        "j\u016Bn.",
        "j\u016Bl.",
        "aug.",
        "sept.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "janv\u0101ris",
        "febru\u0101ris",
        "marts",
        "apr\u012Blis",
        "maijs",
        "j\u016Bnijs",
        "j\u016Blijs",
        "augusts",
        "septembris",
        "oktobris",
        "novembris",
        "decembris"
    ]
};
const $9bb3851720dfdbc9$var$formattingMonthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "janv.",
        "febr.",
        "mart\u0101",
        "apr.",
        "maijs",
        "j\u016Bn.",
        "j\u016Bl.",
        "aug.",
        "sept.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "janv\u0101r\u012B",
        "febru\u0101r\u012B",
        "mart\u0101",
        "apr\u012Bl\u012B",
        "maij\u0101",
        "j\u016Bnij\u0101",
        "j\u016Blij\u0101",
        "august\u0101",
        "septembr\u012B",
        "oktobr\u012B",
        "novembr\u012B",
        "decembr\u012B"
    ]
};
const $9bb3851720dfdbc9$var$dayValues = {
    narrow: [
        "S",
        "P",
        "O",
        "T",
        "C",
        "P",
        "S"
    ],
    short: [
        "Sv",
        "P",
        "O",
        "T",
        "C",
        "Pk",
        "S"
    ],
    abbreviated: [
        "sv\u0113td.",
        "pirmd.",
        "otrd.",
        "tre\u0161d.",
        "ceturtd.",
        "piektd.",
        "sestd."
    ],
    wide: [
        "sv\u0113tdiena",
        "pirmdiena",
        "otrdiena",
        "tre\u0161diena",
        "ceturtdiena",
        "piektdiena",
        "sestdiena"
    ]
};
const $9bb3851720dfdbc9$var$formattingDayValues = {
    narrow: [
        "S",
        "P",
        "O",
        "T",
        "C",
        "P",
        "S"
    ],
    short: [
        "Sv",
        "P",
        "O",
        "T",
        "C",
        "Pk",
        "S"
    ],
    abbreviated: [
        "sv\u0113td.",
        "pirmd.",
        "otrd.",
        "tre\u0161d.",
        "ceturtd.",
        "piektd.",
        "sestd."
    ],
    wide: [
        "sv\u0113tdien\u0101",
        "pirmdien\u0101",
        "otrdien\u0101",
        "tre\u0161dien\u0101",
        "ceturtdien\u0101",
        "piektdien\u0101",
        "sestdien\u0101"
    ]
};
const $9bb3851720dfdbc9$var$dayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "pusn.",
        noon: "pusd.",
        morning: "r\u012Bts",
        afternoon: "diena",
        evening: "vakars",
        night: "nakts"
    },
    abbreviated: {
        am: "am",
        pm: "pm",
        midnight: "pusn.",
        noon: "pusd.",
        morning: "r\u012Bts",
        afternoon: "p\u0113cpusd.",
        evening: "vakars",
        night: "nakts"
    },
    wide: {
        am: "am",
        pm: "pm",
        midnight: "pusnakts",
        noon: "pusdienlaiks",
        morning: "r\u012Bts",
        afternoon: "p\u0113cpusdiena",
        evening: "vakars",
        night: "nakts"
    }
};
const $9bb3851720dfdbc9$var$formattingDayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "pusn.",
        noon: "pusd.",
        morning: "r\u012Bt\u0101",
        afternoon: "dien\u0101",
        evening: "vakar\u0101",
        night: "nakt\u012B"
    },
    abbreviated: {
        am: "am",
        pm: "pm",
        midnight: "pusn.",
        noon: "pusd.",
        morning: "r\u012Bt\u0101",
        afternoon: "p\u0113cpusd.",
        evening: "vakar\u0101",
        night: "nakt\u012B"
    },
    wide: {
        am: "am",
        pm: "pm",
        midnight: "pusnakt\u012B",
        noon: "pusdienlaik\u0101",
        morning: "r\u012Bt\u0101",
        afternoon: "p\u0113cpusdien\u0101",
        evening: "vakar\u0101",
        night: "nakt\u012B"
    }
};
const $9bb3851720dfdbc9$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $9bb3851720dfdbc9$var$localize = $9bb3851720dfdbc9$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $9bb3851720dfdbc9$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $9bb3851720dfdbc9$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $9bb3851720dfdbc9$var$quarterValues,
        defaultWidth: "wide",
        formattingValues: $9bb3851720dfdbc9$var$formattingQuarterValues,
        defaultFormattingWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $9bb3851720dfdbc9$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $9bb3851720dfdbc9$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $9bb3851720dfdbc9$var$dayValues,
        defaultWidth: "wide",
        formattingValues: $9bb3851720dfdbc9$var$formattingDayValues,
        defaultFormattingWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $9bb3851720dfdbc9$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $9bb3851720dfdbc9$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("5vnd1", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $4021d9d670b76158$export$4659b591c19bdf3d; }, function (v) { return $4021d9d670b76158$export$4659b591c19bdf3d = v; });
var $4021d9d670b76158$export$4659b591c19bdf3d;
"use strict";
$4021d9d670b76158$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $4021d9d670b76158$var$matchOrdinalNumberPattern = /^(\d+)\./i;
const $4021d9d670b76158$var$parseOrdinalNumberPattern = /\d+/i;
const $4021d9d670b76158$var$matchEraPatterns = {
    narrow: /^(p\.m\.ē|m\.ē)/i,
    abbreviated: /^(p\. m\. ē\.|m\. ē\.)/i,
    wide: /^(pirms mūsu ēras|mūsu ērā)/i
};
const $4021d9d670b76158$var$parseEraPatterns = {
    any: [
        /^p/i,
        /^m/i
    ]
};
const $4021d9d670b76158$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](\. cet\.)/i,
    wide: /^(pirma(is|jā)|otra(is|jā)|treša(is|jā)|ceturta(is|jā)) ceturksn(is|ī)/i
};
const $4021d9d670b76158$var$parseQuarterPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i
    ],
    abbreviated: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i
    ],
    wide: [
        /^p/i,
        /^o/i,
        /^t/i,
        /^c/i
    ]
};
const $4021d9d670b76158$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv\.|febr\.|marts|apr\.|maijs|jūn\.|jūl\.|aug\.|sept\.|okt\.|nov\.|dec\.)/i,
    wide: /^(janvār(is|ī)|februār(is|ī)|mart[sā]|aprīl(is|ī)|maij[sā]|jūnij[sā]|jūlij[sā]|august[sā]|septembr(is|ī)|oktobr(is|ī)|novembr(is|ī)|decembr(is|ī))/i
};
const $4021d9d670b76158$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jūn/i,
        /^jūl/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $4021d9d670b76158$var$matchDayPatterns = {
    narrow: /^[spotc]/i,
    short: /^(sv|pi|o|t|c|pk|s)/i,
    abbreviated: /^(svētd\.|pirmd\.|otrd.\|trešd\.|ceturtd\.|piektd\.|sestd\.)/i,
    wide: /^(svētdien(a|ā)|pirmdien(a|ā)|otrdien(a|ā)|trešdien(a|ā)|ceturtdien(a|ā)|piektdien(a|ā)|sestdien(a|ā))/i
};
const $4021d9d670b76158$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^p/i,
        /^o/i,
        /^t/i,
        /^c/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^sv/i,
        /^pi/i,
        /^o/i,
        /^t/i,
        /^c/i,
        /^p/i,
        /^se/i
    ]
};
const $4021d9d670b76158$var$matchDayPeriodPatterns = {
    narrow: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|dien(a|ā)|vakar(s|ā)|nakt(s|ī))/,
    abbreviated: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|pēcpusd\.|vakar(s|ā)|nakt(s|ī))/,
    wide: /^(am|pm|pusnakt(s|ī)|pusdienlaik(s|ā)|rīt(s|ā)|pēcpusdien(a|ā)|vakar(s|ā)|nakt(s|ī))/i
};
const $4021d9d670b76158$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^pusn/i,
        noon: /^pusd/i,
        morning: /^r/i,
        afternoon: /^(d|pēc)/i,
        evening: /^v/i,
        night: /^n/i
    }
};
const $4021d9d670b76158$var$match = $4021d9d670b76158$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $4021d9d670b76158$var$matchOrdinalNumberPattern,
        parsePattern: $4021d9d670b76158$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $4021d9d670b76158$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4021d9d670b76158$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $4021d9d670b76158$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4021d9d670b76158$var$parseQuarterPatterns,
        defaultParseWidth: "wide",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $4021d9d670b76158$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4021d9d670b76158$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $4021d9d670b76158$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4021d9d670b76158$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $4021d9d670b76158$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4021d9d670b76158$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("lXx8J", function(module, exports) {

$parcel$export(module.exports, "mk", function () { return $ffc8d08c19416c8a$export$ad7cae49b56e2eb8; }, function (v) { return $ffc8d08c19416c8a$export$ad7cae49b56e2eb8 = v; });
var $ffc8d08c19416c8a$export$ad7cae49b56e2eb8;
"use strict";
$ffc8d08c19416c8a$export$ad7cae49b56e2eb8 = void 0;

var $bd5ap = parcelRequire("bd5ap");

var $3nVhu = parcelRequire("3nVhu");

var $dLt58 = parcelRequire("dLt58");

var $8GGvF = parcelRequire("8GGvF");

var $fKnie = parcelRequire("fKnie");
/**
 * @category Locales
 * @summary Macedonian locale.
 * @language Macedonian
 * @iso-639-2 mkd
 * @author Petar Vlahu [@vlahupetar](https://github.com/vlahupetar)
 * @author Altrim Beqiri [@altrim](https://github.com/altrim)
 */ const $ffc8d08c19416c8a$var$mk = $ffc8d08c19416c8a$export$ad7cae49b56e2eb8 = {
    code: "mk",
    formatDistance: $bd5ap.formatDistance,
    formatLong: $3nVhu.formatLong,
    formatRelative: $dLt58.formatRelative,
    localize: $8GGvF.localize,
    match: $fKnie.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("bd5ap", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $8294eaa86e45b6d7$export$2c14ff85d6318973; }, function (v) { return $8294eaa86e45b6d7$export$2c14ff85d6318973 = v; });
var $8294eaa86e45b6d7$export$2c14ff85d6318973;
"use strict";
$8294eaa86e45b6d7$export$2c14ff85d6318973 = void 0;
const $8294eaa86e45b6d7$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    xSeconds: {
        one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    halfAMinute: "\u043F\u043E\u043B\u043E\u0432\u0438\u043D\u0430 \u043C\u0438\u043D\u0443\u0442\u0430",
    lessThanXMinutes: {
        one: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    xMinutes: {
        one: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    aboutXHours: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u0447\u0430\u0441",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u0447\u0430\u0441\u0430"
    },
    xHours: {
        one: "1 \u0447\u0430\u0441",
        other: "{{count}} \u0447\u0430\u0441\u0430"
    },
    xDays: {
        one: "1 \u0434\u0435\u043D",
        other: "{{count}} \u0434\u0435\u043D\u0430"
    },
    aboutXWeeks: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u043D\u0435\u0434\u0435\u043B\u0430",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    xWeeks: {
        one: "1 \u043D\u0435\u0434\u0435\u043B\u0430",
        other: "{{count}} \u043D\u0435\u0434\u0435\u043B\u0438"
    },
    aboutXMonths: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u043C\u0435\u0441\u0435\u0446",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u043D\u0435\u0434\u0435\u043B\u0438"
    },
    xMonths: {
        one: "1 \u043C\u0435\u0441\u0435\u0446",
        other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    aboutXYears: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    xYears: {
        one: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    overXYears: {
        one: "\u043F\u043E\u0432\u0435\u045C\u0435 \u043E\u0434 1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043F\u043E\u0432\u0435\u045C\u0435 \u043E\u0434 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    almostXYears: {
        one: "\u0431\u0435\u0437\u043C\u0430\u043B\u043A\u0443 1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u0431\u0435\u0437\u043C\u0430\u043B\u043A\u0443 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    }
};
const $8294eaa86e45b6d7$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $8294eaa86e45b6d7$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0437\u0430 " + result;
        else return "\u043F\u0440\u0435\u0434 " + result;
    }
    return result;
};
$8294eaa86e45b6d7$export$2c14ff85d6318973 = $8294eaa86e45b6d7$var$formatDistance;

});

parcelRegister("3nVhu", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $276ff3ee6c596872$export$cbf60ecb96cbb82f; }, function (v) { return $276ff3ee6c596872$export$cbf60ecb96cbb82f = v; });
var $276ff3ee6c596872$export$cbf60ecb96cbb82f;
"use strict";
$276ff3ee6c596872$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $276ff3ee6c596872$var$dateFormats = {
    full: "EEEE, dd MMMM yyyy",
    long: "dd MMMM yyyy",
    medium: "dd MMM yyyy",
    short: "dd/MM/yyyy"
};
const $276ff3ee6c596872$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "H:mm"
};
const $276ff3ee6c596872$var$dateTimeFormats = {
    any: "{{date}} {{time}}"
};
const $276ff3ee6c596872$var$formatLong = $276ff3ee6c596872$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $276ff3ee6c596872$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $276ff3ee6c596872$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $276ff3ee6c596872$var$dateTimeFormats,
        defaultWidth: "any"
    })
};

});

parcelRegister("dLt58", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $a056392f95b2a716$export$8fbbfd65594f46a0; }, function (v) { return $a056392f95b2a716$export$8fbbfd65594f46a0 = v; });
var $a056392f95b2a716$export$8fbbfd65594f46a0;
"use strict";
$a056392f95b2a716$export$8fbbfd65594f46a0 = void 0;

var $9VRW1 = parcelRequire("9VRW1");
const $a056392f95b2a716$var$weekdays = [
    "\u043D\u0435\u0434\u0435\u043B\u0430",
    "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
    "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0441\u0440\u0435\u0434\u0430",
    "\u0447\u0435\u0442\u0432\u0440\u0442\u043E\u043A",
    "\u043F\u0435\u0442\u043E\u043A",
    "\u0441\u0430\u0431\u043E\u0442\u0430"
];
function $a056392f95b2a716$var$lastWeek(day) {
    const weekday = $a056392f95b2a716$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u043C\u0438\u043D\u0430\u0442\u0430\u0442\u0430 " + weekday + " \u0432\u043E' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u043C\u0438\u043D\u0430\u0442\u0438\u043E\u0442 " + weekday + " \u0432\u043E' p";
    }
}
function $a056392f95b2a716$var$thisWeek(day) {
    const weekday = $a056392f95b2a716$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u043E\u0432\u0430 " + weekday + " \u0432o' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u043E\u0432\u043E\u0458 " + weekday + " \u0432o' p";
    }
}
function $a056392f95b2a716$var$nextWeek(day) {
    const weekday = $a056392f95b2a716$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u0441\u043B\u0435\u0434\u043D\u0430\u0442\u0430 " + weekday + " \u0432o' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u0441\u043B\u0435\u0434\u043D\u0438\u043E\u0442 " + weekday + " \u0432o' p";
    }
}
const $a056392f95b2a716$var$formatRelativeLocale = {
    lastWeek: (date, baseDate, options)=>{
        const day = date.getDay();
        if ((0, $9VRW1.isSameWeek)(date, baseDate, options)) return $a056392f95b2a716$var$thisWeek(day);
        else return $a056392f95b2a716$var$lastWeek(day);
    },
    yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432\u043E' p",
    today: "'\u0434\u0435\u043D\u0435\u0441 \u0432\u043E' p",
    tomorrow: "'\u0443\u0442\u0440\u0435 \u0432\u043E' p",
    nextWeek: (date, baseDate, options)=>{
        const day = date.getDay();
        if ((0, $9VRW1.isSameWeek)(date, baseDate, options)) return $a056392f95b2a716$var$thisWeek(day);
        else return $a056392f95b2a716$var$nextWeek(day);
    },
    other: "P"
};
const $a056392f95b2a716$var$formatRelative = (token, date, baseDate, options)=>{
    const format = $a056392f95b2a716$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
$a056392f95b2a716$export$8fbbfd65594f46a0 = $a056392f95b2a716$var$formatRelative;

});

parcelRegister("8GGvF", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $6533388314d9c90c$export$b3bd0bc58e36cd63; }, function (v) { return $6533388314d9c90c$export$b3bd0bc58e36cd63 = v; });
var $6533388314d9c90c$export$b3bd0bc58e36cd63;
"use strict";
$6533388314d9c90c$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $6533388314d9c90c$var$eraValues = {
    narrow: [
        "\u043F\u0440.\u043D.\u0435.",
        "\u043D.\u0435."
    ],
    abbreviated: [
        "\u043F\u0440\u0435\u0434 \u043D. \u0435.",
        "\u043D. \u0435."
    ],
    wide: [
        "\u043F\u0440\u0435\u0434 \u043D\u0430\u0448\u0430\u0442\u0430 \u0435\u0440\u0430",
        "\u043D\u0430\u0448\u0430\u0442\u0430 \u0435\u0440\u0430"
    ]
};
const $6533388314d9c90c$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-\u0432\u0438 \u043A\u0432.",
        "2-\u0440\u0438 \u043A\u0432.",
        "3-\u0442\u0438 \u043A\u0432.",
        "4-\u0442\u0438 \u043A\u0432."
    ],
    wide: [
        "1-\u0432\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0440\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0442\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0442\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
const $6533388314d9c90c$var$monthValues = {
    abbreviated: [
        "\u0458\u0430\u043D",
        "\u0444\u0435\u0432",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F\u0442",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0435\u043C",
        "\u0434\u0435\u043A"
    ],
    wide: [
        "\u0458\u0430\u043D\u0443\u0430\u0440\u0438",
        "\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D\u0438",
        "\u0458\u0443\u043B\u0438",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438",
        "\u043E\u043A\u0442\u043E\u043C\u0432\u0440\u0438",
        "\u043D\u043E\u0435\u043C\u0432\u0440\u0438",
        "\u0434\u0435\u043A\u0435\u043C\u0432\u0440\u0438"
    ]
};
const $6533388314d9c90c$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0435",
        "\u043F\u043E",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0435",
        "\u043F\u0435",
        "\u0441\u0430"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0432\u0442\u043E",
        "\u0441\u0440\u0435",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u0430\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0435\u043B\u0430",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
        "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
        "\u0441\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0440\u0442\u043E\u043A",
        "\u043F\u0435\u0442\u043E\u043A",
        "\u0441\u0430\u0431\u043E\u0442\u0430"
    ]
};
const $6533388314d9c90c$var$dayPeriodValues = {
    wide: {
        am: "\u043F\u0440\u0435\u0442\u043F\u043B\u0430\u0434\u043D\u0435",
        pm: "\u043F\u043E\u043F\u043B\u0430\u0434\u043D\u0435",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u045C",
        noon: "\u043D\u0430\u043F\u043B\u0430\u0434\u043D\u0435",
        morning: "\u043D\u0430\u0443\u0442\u0440\u043E",
        afternoon: "\u043F\u043E\u043F\u043B\u0430\u0434\u043D\u0435",
        evening: "\u043D\u0430\u0432\u0435\u0447\u0435\u0440",
        night: "\u043D\u043E\u045C\u0435"
    }
};
const $6533388314d9c90c$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "-\u0432\u0438";
        case 2:
            return number + "-\u0440\u0438";
        case 7:
        case 8:
            return number + "-\u043C\u0438";
    }
    return number + "-\u0442\u0438";
};
const $6533388314d9c90c$var$localize = $6533388314d9c90c$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $6533388314d9c90c$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $6533388314d9c90c$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $6533388314d9c90c$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $6533388314d9c90c$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $6533388314d9c90c$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $6533388314d9c90c$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};

});

parcelRegister("fKnie", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $b76d386339d5dfe2$export$4659b591c19bdf3d; }, function (v) { return $b76d386339d5dfe2$export$4659b591c19bdf3d = v; });
var $b76d386339d5dfe2$export$4659b591c19bdf3d;
"use strict";
$b76d386339d5dfe2$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $b76d386339d5dfe2$var$matchOrdinalNumberPattern = /^(\d+)(-?[врмт][и])?/i;
const $b76d386339d5dfe2$var$parseOrdinalNumberPattern = /\d+/i;
const $b76d386339d5dfe2$var$matchEraPatterns = {
    narrow: /^((пр)?н\.?\s?е\.?)/i,
    abbreviated: /^((пр)?н\.?\s?е\.?)/i,
    wide: /^(пред нашата ера|нашата ера)/i
};
const $b76d386339d5dfe2$var$parseEraPatterns = {
    any: [
        /^п/i,
        /^н/i
    ]
};
const $b76d386339d5dfe2$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[врт]?и?)? кв.?/i,
    wide: /^[1234](-?[врт]?и?)? квартал/i
};
const $b76d386339d5dfe2$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $b76d386339d5dfe2$var$matchDayPatterns = {
    narrow: /^[нпвсч]/i,
    short: /^(не|по|вт|ср|че|пе|са)/i,
    abbreviated: /^(нед|пон|вто|сре|чет|пет|саб)/i,
    wide: /^(недела|понеделник|вторник|среда|четврток|петок|сабота)/i
};
const $b76d386339d5dfe2$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н[ед]/i,
        /^п[он]/i,
        /^вт/i,
        /^ср/i,
        /^ч[ет]/i,
        /^п[ет]/i,
        /^с[аб]/i
    ]
};
const $b76d386339d5dfe2$var$matchMonthPatterns = {
    abbreviated: /^(јан|фев|мар|апр|мај|јун|јул|авг|сеп|окт|ноем|дек)/i,
    wide: /^(јануари|февруари|март|април|мај|јуни|јули|август|септември|октомври|ноември|декември)/i
};
const $b76d386339d5dfe2$var$parseMonthPatterns = {
    any: [
        /^ја/i,
        /^Ф/i,
        /^мар/i,
        /^ап/i,
        /^мај/i,
        /^јун/i,
        /^јул/i,
        /^ав/i,
        /^се/i,
        /^окт/i,
        /^но/i,
        /^де/i
    ]
};
const $b76d386339d5dfe2$var$matchDayPeriodPatterns = {
    any: /^(претп|попл|полноќ|утро|пладне|вечер|ноќ)/i
};
const $b76d386339d5dfe2$var$parseDayPeriodPatterns = {
    any: {
        am: /претпладне/i,
        pm: /попладне/i,
        midnight: /полноќ/i,
        noon: /напладне/i,
        morning: /наутро/i,
        afternoon: /попладне/i,
        evening: /навечер/i,
        night: /ноќе/i
    }
};
const $b76d386339d5dfe2$var$match = $b76d386339d5dfe2$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $b76d386339d5dfe2$var$matchOrdinalNumberPattern,
        parsePattern: $b76d386339d5dfe2$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $b76d386339d5dfe2$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b76d386339d5dfe2$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $b76d386339d5dfe2$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b76d386339d5dfe2$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $b76d386339d5dfe2$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b76d386339d5dfe2$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $b76d386339d5dfe2$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b76d386339d5dfe2$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $b76d386339d5dfe2$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $b76d386339d5dfe2$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("3Y3po", function(module, exports) {

$parcel$export(module.exports, "mn", function () { return $2e399e91a54d4239$export$e78c44be168181dc; }, function (v) { return $2e399e91a54d4239$export$e78c44be168181dc = v; });
var $2e399e91a54d4239$export$e78c44be168181dc;
"use strict";
$2e399e91a54d4239$export$e78c44be168181dc = void 0;

var $1x8rz = parcelRequire("1x8rz");

var $eQ2ix = parcelRequire("eQ2ix");

var $3uhg8 = parcelRequire("3uhg8");

var $4FybC = parcelRequire("4FybC");

var $inuC1 = parcelRequire("inuC1");
/**
 * @category Locales
 * @summary Mongolian locale.
 * @language Mongolian
 * @iso-639-2 mon
 * @author Bilguun Ochirbat [@bilguun0203](https://github.com/bilguun0203)
 */ const $2e399e91a54d4239$var$mn = $2e399e91a54d4239$export$e78c44be168181dc = {
    code: "mn",
    formatDistance: $1x8rz.formatDistance,
    formatLong: $eQ2ix.formatLong,
    formatRelative: $3uhg8.formatRelative,
    localize: $4FybC.localize,
    match: $inuC1.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("1x8rz", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $11df6c3dc4eeb60a$export$2c14ff85d6318973; }, function (v) { return $11df6c3dc4eeb60a$export$2c14ff85d6318973 = v; });
var $11df6c3dc4eeb60a$export$2c14ff85d6318973;
"use strict";
$11df6c3dc4eeb60a$export$2c14ff85d6318973 = void 0;
const $11df6c3dc4eeb60a$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0441\u0435\u043A\u0443\u043D\u0434 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439"
    },
    xSeconds: {
        one: "1 \u0441\u0435\u043A\u0443\u043D\u0434",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
    },
    halfAMinute: "\u0445\u0430\u0433\u0430\u0441 \u043C\u0438\u043D\u0443\u0442",
    lessThanXMinutes: {
        one: "\u043C\u0438\u043D\u0443\u0442 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439"
    },
    xMinutes: {
        one: "1 \u043C\u0438\u043D\u0443\u0442",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442"
    },
    aboutXHours: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0446\u0430\u0433",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0446\u0430\u0433"
    },
    xHours: {
        one: "1 \u0446\u0430\u0433",
        other: "{{count}} \u0446\u0430\u0433"
    },
    xDays: {
        one: "1 \u04E9\u0434\u04E9\u0440",
        other: "{{count}} \u04E9\u0434\u04E9\u0440"
    },
    aboutXWeeks: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433"
    },
    xWeeks: {
        one: "1 \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433",
        other: "{{count}} \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433"
    },
    aboutXMonths: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0441\u0430\u0440",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0441\u0430\u0440"
    },
    xMonths: {
        one: "1 \u0441\u0430\u0440",
        other: "{{count}} \u0441\u0430\u0440"
    },
    aboutXYears: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0436\u0438\u043B",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0436\u0438\u043B"
    },
    xYears: {
        one: "1 \u0436\u0438\u043B",
        other: "{{count}} \u0436\u0438\u043B"
    },
    overXYears: {
        one: "1 \u0436\u0438\u043B \u0433\u0430\u0440\u0430\u043D",
        other: "{{count}} \u0436\u0438\u043B \u0433\u0430\u0440\u0430\u043D"
    },
    almostXYears: {
        one: "\u0431\u0430\u0440\u0430\u0433 1 \u0436\u0438\u043B",
        other: "\u0431\u0430\u0440\u0430\u0433 {{count}} \u0436\u0438\u043B"
    }
};
const $11df6c3dc4eeb60a$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $11df6c3dc4eeb60a$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        /**
     * Append genitive case
     */ const words = result.split(" ");
        const lastword = words.pop();
        result = words.join(" ");
        switch(lastword){
            case "\u0441\u0435\u043A\u0443\u043D\u0434":
                result += " \u0441\u0435\u043A\u0443\u043D\u0434\u0438\u0439\u043D";
                break;
            case "\u043C\u0438\u043D\u0443\u0442":
                result += " \u043C\u0438\u043D\u0443\u0442\u044B\u043D";
                break;
            case "\u0446\u0430\u0433":
                result += " \u0446\u0430\u0433\u0438\u0439\u043D";
                break;
            case "\u04E9\u0434\u04E9\u0440":
                result += " \u04E9\u0434\u0440\u0438\u0439\u043D";
                break;
            case "\u0441\u0430\u0440":
                result += " \u0441\u0430\u0440\u044B\u043D";
                break;
            case "\u0436\u0438\u043B":
                result += " \u0436\u0438\u043B\u0438\u0439\u043D";
                break;
            case "\u0445\u043E\u043D\u043E\u0433":
                result += " \u0445\u043E\u043D\u043E\u0433\u0438\u0439\u043D";
                break;
            case "\u0433\u0430\u0440\u0430\u043D":
                result += " \u0433\u0430\u0440\u0430\u043D\u044B";
                break;
            case "\u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439":
                result += " \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439 \u0445\u0443\u0433\u0430\u0446\u0430\u0430\u043D\u044B";
                break;
            default:
                result += lastword + "-\u043D";
        }
        if (options.comparison && options.comparison > 0) return result + " \u0434\u0430\u0440\u0430\u0430";
        else return result + " \u04E9\u043C\u043D\u04E9";
    }
    return result;
};
$11df6c3dc4eeb60a$export$2c14ff85d6318973 = $11df6c3dc4eeb60a$var$formatDistance;

});

parcelRegister("eQ2ix", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $acd7b45b831883fc$export$cbf60ecb96cbb82f; }, function (v) { return $acd7b45b831883fc$export$cbf60ecb96cbb82f = v; });
var $acd7b45b831883fc$export$cbf60ecb96cbb82f;
"use strict";
$acd7b45b831883fc$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $acd7b45b831883fc$var$dateFormats = {
    full: "y '\u043E\u043D\u044B' MMMM'\u044B\u043D' d, EEEE '\u0433\u0430\u0440\u0430\u0433'",
    long: "y '\u043E\u043D\u044B' MMMM'\u044B\u043D' d",
    medium: "y '\u043E\u043D\u044B' MMM'\u044B\u043D' d",
    short: "y.MM.dd"
};
const $acd7b45b831883fc$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $acd7b45b831883fc$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $acd7b45b831883fc$var$formatLong = $acd7b45b831883fc$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $acd7b45b831883fc$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $acd7b45b831883fc$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $acd7b45b831883fc$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("3uhg8", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $28a18fc2235141d7$export$8fbbfd65594f46a0; }, function (v) { return $28a18fc2235141d7$export$8fbbfd65594f46a0 = v; });
var $28a18fc2235141d7$export$8fbbfd65594f46a0;
"use strict";
$28a18fc2235141d7$export$8fbbfd65594f46a0 = void 0;
const $28a18fc2235141d7$var$formatRelativeLocale = {
    lastWeek: "'\u04E9\u043D\u0433\u04E9\u0440\u0441\u04E9\u043D' eeee '\u0433\u0430\u0440\u0430\u0433\u0438\u0439\u043D' p '\u0446\u0430\u0433\u0442'",
    yesterday: "'\u04E9\u0447\u0438\u0433\u0434\u04E9\u0440' p '\u0446\u0430\u0433\u0442'",
    today: "'\u04E9\u043D\u04E9\u04E9\u0434\u04E9\u0440' p '\u0446\u0430\u0433\u0442'",
    tomorrow: "'\u043C\u0430\u0440\u0433\u0430\u0430\u0448' p '\u0446\u0430\u0433\u0442'",
    nextWeek: "'\u0438\u0440\u044D\u0445' eeee '\u0433\u0430\u0440\u0430\u0433\u0438\u0439\u043D' p '\u0446\u0430\u0433\u0442'",
    other: "P"
};
const $28a18fc2235141d7$var$formatRelative = (token, _date, _baseDate, _options)=>$28a18fc2235141d7$var$formatRelativeLocale[token];
$28a18fc2235141d7$export$8fbbfd65594f46a0 = $28a18fc2235141d7$var$formatRelative;

});

parcelRegister("4FybC", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $3665827c6ec56f30$export$b3bd0bc58e36cd63; }, function (v) { return $3665827c6ec56f30$export$b3bd0bc58e36cd63 = v; });
var $3665827c6ec56f30$export$b3bd0bc58e36cd63;
"use strict";
$3665827c6ec56f30$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $3665827c6ec56f30$var$eraValues = {
    narrow: [
        "\u041D\u0422\u04E8",
        "\u041D\u0422"
    ],
    abbreviated: [
        "\u041D\u0422\u04E8",
        "\u041D\u0422"
    ],
    wide: [
        "\u043D\u0438\u0439\u0442\u0438\u0439\u043D \u0442\u043E\u043E\u043B\u043B\u044B\u043D \u04E9\u043C\u043D\u04E9\u0445",
        "\u043D\u0438\u0439\u0442\u0438\u0439\u043D \u0442\u043E\u043E\u043B\u043B\u044B\u043D"
    ]
};
const $3665827c6ec56f30$var$quarterValues = {
    narrow: [
        "I",
        "II",
        "III",
        "IV"
    ],
    abbreviated: [
        "I \u0443\u043B\u0438\u0440\u0430\u043B",
        "II \u0443\u043B\u0438\u0440\u0430\u043B",
        "III \u0443\u043B\u0438\u0440\u0430\u043B",
        "IV \u0443\u043B\u0438\u0440\u0430\u043B"
    ],
    wide: [
        "1-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B",
        "2-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B",
        "3-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B",
        "4-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $3665827c6ec56f30$var$monthValues = {
    narrow: [
        "I",
        "II",
        "III",
        "IV",
        "V",
        "VI",
        "VII",
        "VIII",
        "IX",
        "X",
        "XI",
        "XII"
    ],
    abbreviated: [
        "1-\u0440 \u0441\u0430\u0440",
        "2-\u0440 \u0441\u0430\u0440",
        "3-\u0440 \u0441\u0430\u0440",
        "4-\u0440 \u0441\u0430\u0440",
        "5-\u0440 \u0441\u0430\u0440",
        "6-\u0440 \u0441\u0430\u0440",
        "7-\u0440 \u0441\u0430\u0440",
        "8-\u0440 \u0441\u0430\u0440",
        "9-\u0440 \u0441\u0430\u0440",
        "10-\u0440 \u0441\u0430\u0440",
        "11-\u0440 \u0441\u0430\u0440",
        "12-\u0440 \u0441\u0430\u0440"
    ],
    wide: [
        "\u041D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0425\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0413\u0443\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0414\u04E9\u0440\u04E9\u0432\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0422\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0417\u0443\u0440\u0433\u0430\u0430\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0414\u043E\u043B\u043E\u043E\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u041D\u0430\u0439\u043C\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0415\u0441\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0410\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0410\u0440\u0432\u0430\u043D\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0410\u0440\u0432\u0430\u043D \u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440"
    ]
};
const $3665827c6ec56f30$var$formattingMonthValues = {
    narrow: [
        "I",
        "II",
        "III",
        "IV",
        "V",
        "VI",
        "VII",
        "VIII",
        "IX",
        "X",
        "XI",
        "XII"
    ],
    abbreviated: [
        "1-\u0440 \u0441\u0430\u0440",
        "2-\u0440 \u0441\u0430\u0440",
        "3-\u0440 \u0441\u0430\u0440",
        "4-\u0440 \u0441\u0430\u0440",
        "5-\u0440 \u0441\u0430\u0440",
        "6-\u0440 \u0441\u0430\u0440",
        "7-\u0440 \u0441\u0430\u0440",
        "8-\u0440 \u0441\u0430\u0440",
        "9-\u0440 \u0441\u0430\u0440",
        "10-\u0440 \u0441\u0430\u0440",
        "11-\u0440 \u0441\u0430\u0440",
        "12-\u0440 \u0441\u0430\u0440"
    ],
    wide: [
        "\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0433\u0443\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0434\u04E9\u0440\u04E9\u0432\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0442\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0437\u0443\u0440\u0433\u0430\u0430\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0434\u043E\u043B\u043E\u043E\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u043D\u0430\u0439\u043C\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0435\u0441\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0430\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0430\u0440\u0432\u0430\u043D\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0430\u0440\u0432\u0430\u043D \u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440"
    ]
};
const $3665827c6ec56f30$var$dayValues = {
    narrow: [
        "\u041D",
        "\u0414",
        "\u041C",
        "\u041B",
        "\u041F",
        "\u0411",
        "\u0411"
    ],
    short: [
        "\u041D\u044F",
        "\u0414\u0430",
        "\u041C\u044F",
        "\u041B\u0445",
        "\u041F\u04AF",
        "\u0411\u0430",
        "\u0411\u044F"
    ],
    abbreviated: [
        "\u041D\u044F\u043C",
        "\u0414\u0430\u0432",
        "\u041C\u044F\u0433",
        "\u041B\u0445\u0430",
        "\u041F\u04AF\u0440",
        "\u0411\u0430\u0430",
        "\u0411\u044F\u043C"
    ],
    wide: [
        "\u041D\u044F\u043C",
        "\u0414\u0430\u0432\u0430\u0430",
        "\u041C\u044F\u0433\u043C\u0430\u0440",
        "\u041B\u0445\u0430\u0433\u0432\u0430",
        "\u041F\u04AF\u0440\u044D\u0432",
        "\u0411\u0430\u0430\u0441\u0430\u043D",
        "\u0411\u044F\u043C\u0431\u0430"
    ]
};
const $3665827c6ec56f30$var$formattingDayValues = {
    narrow: [
        "\u041D",
        "\u0414",
        "\u041C",
        "\u041B",
        "\u041F",
        "\u0411",
        "\u0411"
    ],
    short: [
        "\u041D\u044F",
        "\u0414\u0430",
        "\u041C\u044F",
        "\u041B\u0445",
        "\u041F\u04AF",
        "\u0411\u0430",
        "\u0411\u044F"
    ],
    abbreviated: [
        "\u041D\u044F\u043C",
        "\u0414\u0430\u0432",
        "\u041C\u044F\u0433",
        "\u041B\u0445\u0430",
        "\u041F\u04AF\u0440",
        "\u0411\u0430\u0430",
        "\u0411\u044F\u043C"
    ],
    wide: [
        "\u043D\u044F\u043C",
        "\u0434\u0430\u0432\u0430\u0430",
        "\u043C\u044F\u0433\u043C\u0430\u0440",
        "\u043B\u0445\u0430\u0433\u0432\u0430",
        "\u043F\u04AF\u0440\u044D\u0432",
        "\u0431\u0430\u0430\u0441\u0430\u043D",
        "\u0431\u044F\u043C\u0431\u0430"
    ]
};
const $3665827c6ec56f30$var$dayPeriodValues = {
    narrow: {
        am: "\u04AF.\u04E9.",
        pm: "\u04AF.\u0445.",
        midnight: "\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
        noon: "\u04AF\u0434 \u0434\u0443\u043D\u0434",
        morning: "\u04E9\u0433\u043B\u04E9\u04E9",
        afternoon: "\u04E9\u0434\u04E9\u0440",
        evening: "\u043E\u0440\u043E\u0439",
        night: "\u0448\u04E9\u043D\u04E9"
    },
    abbreviated: {
        am: "\u04AF.\u04E9.",
        pm: "\u04AF.\u0445.",
        midnight: "\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
        noon: "\u04AF\u0434 \u0434\u0443\u043D\u0434",
        morning: "\u04E9\u0433\u043B\u04E9\u04E9",
        afternoon: "\u04E9\u0434\u04E9\u0440",
        evening: "\u043E\u0440\u043E\u0439",
        night: "\u0448\u04E9\u043D\u04E9"
    },
    wide: {
        am: "\u04AF.\u04E9.",
        pm: "\u04AF.\u0445.",
        midnight: "\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
        noon: "\u04AF\u0434 \u0434\u0443\u043D\u0434",
        morning: "\u04E9\u0433\u043B\u04E9\u04E9",
        afternoon: "\u04E9\u0434\u04E9\u0440",
        evening: "\u043E\u0440\u043E\u0439",
        night: "\u0448\u04E9\u043D\u04E9"
    }
};
const $3665827c6ec56f30$var$ordinalNumber = (dirtyNumber, _options)=>{
    return String(dirtyNumber);
};
const $3665827c6ec56f30$var$localize = $3665827c6ec56f30$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $3665827c6ec56f30$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $3665827c6ec56f30$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $3665827c6ec56f30$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $3665827c6ec56f30$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $3665827c6ec56f30$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $3665827c6ec56f30$var$dayValues,
        defaultWidth: "wide",
        formattingValues: $3665827c6ec56f30$var$formattingDayValues,
        defaultFormattingWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $3665827c6ec56f30$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};

});

parcelRegister("inuC1", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $0373e7b997b93329$export$4659b591c19bdf3d; }, function (v) { return $0373e7b997b93329$export$4659b591c19bdf3d = v; });
var $0373e7b997b93329$export$4659b591c19bdf3d;
"use strict";
$0373e7b997b93329$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $0373e7b997b93329$var$matchOrdinalNumberPattern = /\d+/i;
const $0373e7b997b93329$var$parseOrdinalNumberPattern = /\d+/i;
const $0373e7b997b93329$var$matchEraPatterns = {
    narrow: /^(нтө|нт)/i,
    abbreviated: /^(нтө|нт)/i,
    wide: /^(нийтийн тооллын өмнө|нийтийн тооллын)/i
};
const $0373e7b997b93329$var$parseEraPatterns = {
    any: [
        /^(нтө|нийтийн тооллын өмнө)/i,
        /^(нт|нийтийн тооллын)/i
    ]
};
const $0373e7b997b93329$var$matchQuarterPatterns = {
    narrow: /^(iv|iii|ii|i)/i,
    abbreviated: /^(iv|iii|ii|i) улирал/i,
    wide: /^[1-4]-р улирал/i
};
const $0373e7b997b93329$var$parseQuarterPatterns = {
    any: [
        /^(i(\s|$)|1)/i,
        /^(ii(\s|$)|2)/i,
        /^(iii(\s|$)|3)/i,
        /^(iv(\s|$)|4)/i
    ]
};
const $0373e7b997b93329$var$matchMonthPatterns = {
    narrow: /^(xii|xi|x|ix|viii|vii|vi|v|iv|iii|ii|i)/i,
    abbreviated: /^(1-р сар|2-р сар|3-р сар|4-р сар|5-р сар|6-р сар|7-р сар|8-р сар|9-р сар|10-р сар|11-р сар|12-р сар)/i,
    wide: /^(нэгдүгээр сар|хоёрдугаар сар|гуравдугаар сар|дөрөвдүгээр сар|тавдугаар сар|зургаадугаар сар|долоодугаар сар|наймдугаар сар|есдүгээр сар|аравдугаар сар|арван нэгдүгээр сар|арван хоёрдугаар сар)/i
};
const $0373e7b997b93329$var$parseMonthPatterns = {
    narrow: [
        /^i$/i,
        /^ii$/i,
        /^iii$/i,
        /^iv$/i,
        /^v$/i,
        /^vi$/i,
        /^vii$/i,
        /^viii$/i,
        /^ix$/i,
        /^x$/i,
        /^xi$/i,
        /^xii$/i
    ],
    any: [
        /^(1|нэгдүгээр)/i,
        /^(2|хоёрдугаар)/i,
        /^(3|гуравдугаар)/i,
        /^(4|дөрөвдүгээр)/i,
        /^(5|тавдугаар)/i,
        /^(6|зургаадугаар)/i,
        /^(7|долоодугаар)/i,
        /^(8|наймдугаар)/i,
        /^(9|есдүгээр)/i,
        /^(10|аравдугаар)/i,
        /^(11|арван нэгдүгээр)/i,
        /^(12|арван хоёрдугаар)/i
    ]
};
const $0373e7b997b93329$var$matchDayPatterns = {
    narrow: /^[ндмлпбб]/i,
    short: /^(ня|да|мя|лх|пү|ба|бя)/i,
    abbreviated: /^(ням|дав|мяг|лха|пүр|баа|бям)/i,
    wide: /^(ням|даваа|мягмар|лхагва|пүрэв|баасан|бямба)/i
};
const $0373e7b997b93329$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^д/i,
        /^м/i,
        /^л/i,
        /^п/i,
        /^б/i,
        /^б/i
    ],
    any: [
        /^ня/i,
        /^да/i,
        /^мя/i,
        /^лх/i,
        /^пү/i,
        /^ба/i,
        /^бя/i
    ]
};
const $0373e7b997b93329$var$matchDayPeriodPatterns = {
    narrow: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i,
    any: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i
};
const $0373e7b997b93329$var$parseDayPeriodPatterns = {
    any: {
        am: /^ү\.ө\./i,
        pm: /^ү\.х\./i,
        midnight: /^шөнө дунд/i,
        noon: /^үд дунд/i,
        morning: /өглөө/i,
        afternoon: /өдөр/i,
        evening: /орой/i,
        night: /шөнө/i
    }
};
const $0373e7b997b93329$var$match = $0373e7b997b93329$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $0373e7b997b93329$var$matchOrdinalNumberPattern,
        parsePattern: $0373e7b997b93329$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $0373e7b997b93329$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0373e7b997b93329$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $0373e7b997b93329$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0373e7b997b93329$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $0373e7b997b93329$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0373e7b997b93329$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $0373e7b997b93329$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0373e7b997b93329$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $0373e7b997b93329$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $0373e7b997b93329$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("jBftv", function(module, exports) {

$parcel$export(module.exports, "ms", function () { return $e44d7a044c395a97$export$5dd2165da01bec80; }, function (v) { return $e44d7a044c395a97$export$5dd2165da01bec80 = v; });
var $e44d7a044c395a97$export$5dd2165da01bec80;
"use strict";
$e44d7a044c395a97$export$5dd2165da01bec80 = void 0;

var $kVImi = parcelRequire("kVImi");

var $1F29I = parcelRequire("1F29I");

var $a29ND = parcelRequire("a29ND");

var $hcx5r = parcelRequire("hcx5r");

var $9iE6c = parcelRequire("9iE6c");
/**
 * @category Locales
 * @summary Malay locale.
 * @language Malay
 * @iso-639-2 msa
 * @author Ruban Selvarajah [@Zyten](https://github.com/Zyten)
 */ const $e44d7a044c395a97$var$ms = $e44d7a044c395a97$export$5dd2165da01bec80 = {
    code: "ms",
    formatDistance: $kVImi.formatDistance,
    formatLong: $1F29I.formatLong,
    formatRelative: $a29ND.formatRelative,
    localize: $hcx5r.localize,
    match: $9iE6c.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("kVImi", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $f3cb8a361096d9cc$export$2c14ff85d6318973; }, function (v) { return $f3cb8a361096d9cc$export$2c14ff85d6318973 = v; });
var $f3cb8a361096d9cc$export$2c14ff85d6318973;
"use strict";
$f3cb8a361096d9cc$export$2c14ff85d6318973 = void 0;
const $f3cb8a361096d9cc$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "kurang dari 1 saat",
        other: "kurang dari {{count}} saat"
    },
    xSeconds: {
        one: "1 saat",
        other: "{{count}} saat"
    },
    halfAMinute: "setengah minit",
    lessThanXMinutes: {
        one: "kurang dari 1 minit",
        other: "kurang dari {{count}} minit"
    },
    xMinutes: {
        one: "1 minit",
        other: "{{count}} minit"
    },
    aboutXHours: {
        one: "sekitar 1 jam",
        other: "sekitar {{count}} jam"
    },
    xHours: {
        one: "1 jam",
        other: "{{count}} jam"
    },
    xDays: {
        one: "1 hari",
        other: "{{count}} hari"
    },
    aboutXWeeks: {
        one: "sekitar 1 minggu",
        other: "sekitar {{count}} minggu"
    },
    xWeeks: {
        one: "1 minggu",
        other: "{{count}} minggu"
    },
    aboutXMonths: {
        one: "sekitar 1 bulan",
        other: "sekitar {{count}} bulan"
    },
    xMonths: {
        one: "1 bulan",
        other: "{{count}} bulan"
    },
    aboutXYears: {
        one: "sekitar 1 tahun",
        other: "sekitar {{count}} tahun"
    },
    xYears: {
        one: "1 tahun",
        other: "{{count}} tahun"
    },
    overXYears: {
        one: "lebih dari 1 tahun",
        other: "lebih dari {{count}} tahun"
    },
    almostXYears: {
        one: "hampir 1 tahun",
        other: "hampir {{count}} tahun"
    }
};
const $f3cb8a361096d9cc$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $f3cb8a361096d9cc$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "dalam masa " + result;
        else return result + " yang lalu";
    }
    return result;
};
$f3cb8a361096d9cc$export$2c14ff85d6318973 = $f3cb8a361096d9cc$var$formatDistance;

});

parcelRegister("1F29I", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $135b4ad9f9efbd73$export$cbf60ecb96cbb82f; }, function (v) { return $135b4ad9f9efbd73$export$cbf60ecb96cbb82f = v; });
var $135b4ad9f9efbd73$export$cbf60ecb96cbb82f;
"use strict";
$135b4ad9f9efbd73$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $135b4ad9f9efbd73$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "d/M/yyyy"
};
const $135b4ad9f9efbd73$var$timeFormats = {
    full: "HH.mm.ss",
    long: "HH.mm.ss",
    medium: "HH.mm",
    short: "HH.mm"
};
const $135b4ad9f9efbd73$var$dateTimeFormats = {
    full: "{{date}} 'pukul' {{time}}",
    long: "{{date}} 'pukul' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $135b4ad9f9efbd73$var$formatLong = $135b4ad9f9efbd73$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $135b4ad9f9efbd73$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $135b4ad9f9efbd73$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $135b4ad9f9efbd73$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("a29ND", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $74e1b145b2e591d7$export$8fbbfd65594f46a0; }, function (v) { return $74e1b145b2e591d7$export$8fbbfd65594f46a0 = v; });
var $74e1b145b2e591d7$export$8fbbfd65594f46a0;
"use strict";
$74e1b145b2e591d7$export$8fbbfd65594f46a0 = void 0;
const $74e1b145b2e591d7$var$formatRelativeLocale = {
    lastWeek: "eeee 'lepas pada jam' p",
    yesterday: "'Semalam pada jam' p",
    today: "'Hari ini pada jam' p",
    tomorrow: "'Esok pada jam' p",
    nextWeek: "eeee 'pada jam' p",
    other: "P"
};
const $74e1b145b2e591d7$var$formatRelative = (token, _date, _baseDate, _options)=>$74e1b145b2e591d7$var$formatRelativeLocale[token];
$74e1b145b2e591d7$export$8fbbfd65594f46a0 = $74e1b145b2e591d7$var$formatRelative;

});

parcelRegister("hcx5r", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $c85d39040fe0d42d$export$b3bd0bc58e36cd63; }, function (v) { return $c85d39040fe0d42d$export$b3bd0bc58e36cd63 = v; });
var $c85d39040fe0d42d$export$b3bd0bc58e36cd63;
"use strict";
$c85d39040fe0d42d$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
// Most data for localization are taken from this page
// https://www.unicode.org/cldr/charts/32/summary/ms.html
const $c85d39040fe0d42d$var$eraValues = {
    narrow: [
        "SM",
        "M"
    ],
    abbreviated: [
        "SM",
        "M"
    ],
    wide: [
        "Sebelum Masihi",
        "Masihi"
    ]
};
const $c85d39040fe0d42d$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "S1",
        "S2",
        "S3",
        "S4"
    ],
    wide: [
        "Suku pertama",
        "Suku kedua",
        "Suku ketiga",
        "Suku keempat"
    ]
};
// Note: in Malay, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $c85d39040fe0d42d$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "O",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mac",
        "Apr",
        "Mei",
        "Jun",
        "Jul",
        "Ogo",
        "Sep",
        "Okt",
        "Nov",
        "Dis"
    ],
    wide: [
        "Januari",
        "Februari",
        "Mac",
        "April",
        "Mei",
        "Jun",
        "Julai",
        "Ogos",
        "September",
        "Oktober",
        "November",
        "Disember"
    ]
};
const $c85d39040fe0d42d$var$dayValues = {
    narrow: [
        "A",
        "I",
        "S",
        "R",
        "K",
        "J",
        "S"
    ],
    short: [
        "Ahd",
        "Isn",
        "Sel",
        "Rab",
        "Kha",
        "Jum",
        "Sab"
    ],
    abbreviated: [
        "Ahd",
        "Isn",
        "Sel",
        "Rab",
        "Kha",
        "Jum",
        "Sab"
    ],
    wide: [
        "Ahad",
        "Isnin",
        "Selasa",
        "Rabu",
        "Khamis",
        "Jumaat",
        "Sabtu"
    ]
};
const $c85d39040fe0d42d$var$dayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "tgh malam",
        noon: "tgh hari",
        morning: "pagi",
        afternoon: "tengah hari",
        evening: "petang",
        night: "malam"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "tengah hari",
        evening: "petang",
        night: "malam"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "tengah hari",
        evening: "petang",
        night: "malam"
    }
};
const $c85d39040fe0d42d$var$formattingDayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "tengah hari",
        evening: "petang",
        night: "malam"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "tengah hari",
        evening: "petang",
        night: "malam"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "tengah hari",
        evening: "petang",
        night: "malam"
    }
};
const $c85d39040fe0d42d$var$ordinalNumber = (dirtyNumber, _options)=>{
    // Can't use "pertama", "kedua" because can't be parsed
    return "ke-" + Number(dirtyNumber);
};
const $c85d39040fe0d42d$var$localize = $c85d39040fe0d42d$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $c85d39040fe0d42d$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $c85d39040fe0d42d$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $c85d39040fe0d42d$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $c85d39040fe0d42d$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $c85d39040fe0d42d$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $c85d39040fe0d42d$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $c85d39040fe0d42d$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("9iE6c", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $6c54e64df8795c12$export$4659b591c19bdf3d; }, function (v) { return $6c54e64df8795c12$export$4659b591c19bdf3d = v; });
var $6c54e64df8795c12$export$4659b591c19bdf3d;
"use strict";
$6c54e64df8795c12$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $6c54e64df8795c12$var$matchOrdinalNumberPattern = /^ke-(\d+)?/i;
const $6c54e64df8795c12$var$parseOrdinalNumberPattern = /petama|\d+/i;
const $6c54e64df8795c12$var$matchEraPatterns = {
    narrow: /^(sm|m)/i,
    abbreviated: /^(s\.?\s?m\.?|m\.?)/i,
    wide: /^(sebelum masihi|masihi)/i
};
const $6c54e64df8795c12$var$parseEraPatterns = {
    any: [
        /^s/i,
        /^(m)/i
    ]
};
const $6c54e64df8795c12$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^S[1234]/i,
    wide: /Suku (pertama|kedua|ketiga|keempat)/i
};
const $6c54e64df8795c12$var$parseQuarterPatterns = {
    any: [
        /pertama|1/i,
        /kedua|2/i,
        /ketiga|3/i,
        /keempat|4/i
    ]
};
const $6c54e64df8795c12$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mac|apr|mei|jun|jul|ogo|sep|okt|nov|dis)/i,
    wide: /^(januari|februari|mac|april|mei|jun|julai|ogos|september|oktober|november|disember)/i
};
const $6c54e64df8795c12$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^o/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^ma/i,
        /^ap/i,
        /^me/i,
        /^jun/i,
        /^jul/i,
        /^og/i,
        /^s/i,
        /^ok/i,
        /^n/i,
        /^d/i
    ]
};
const $6c54e64df8795c12$var$matchDayPatterns = {
    narrow: /^[aisrkj]/i,
    short: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
    abbreviated: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
    wide: /^(ahad|isnin|selasa|rabu|khamis|jumaat|sabtu)/i
};
const $6c54e64df8795c12$var$parseDayPatterns = {
    narrow: [
        /^a/i,
        /^i/i,
        /^s/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^s/i
    ],
    any: [
        /^a/i,
        /^i/i,
        /^se/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^sa/i
    ]
};
const $6c54e64df8795c12$var$matchDayPeriodPatterns = {
    narrow: /^(am|pm|tengah malam|tengah hari|pagi|petang|malam)/i,
    any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|pagi|petang|malam)/i
};
const $6c54e64df8795c12$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^pm/i,
        midnight: /^tengah m/i,
        noon: /^tengah h/i,
        morning: /pa/i,
        afternoon: /tengah h/i,
        evening: /pe/i,
        night: /m/i
    }
};
const $6c54e64df8795c12$var$match = $6c54e64df8795c12$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $6c54e64df8795c12$var$matchOrdinalNumberPattern,
        parsePattern: $6c54e64df8795c12$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $6c54e64df8795c12$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6c54e64df8795c12$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $6c54e64df8795c12$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6c54e64df8795c12$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $6c54e64df8795c12$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6c54e64df8795c12$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $6c54e64df8795c12$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6c54e64df8795c12$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $6c54e64df8795c12$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $6c54e64df8795c12$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("f1vsR", function(module, exports) {

$parcel$export(module.exports, "mt", function () { return $aeff5b33e95be79d$export$f2a459ff55c00db5; }, function (v) { return $aeff5b33e95be79d$export$f2a459ff55c00db5 = v; });
var $aeff5b33e95be79d$export$f2a459ff55c00db5;
"use strict";
$aeff5b33e95be79d$export$f2a459ff55c00db5 = void 0;

var $eCGFL = parcelRequire("eCGFL");

var $a6ttz = parcelRequire("a6ttz");

var $1911v = parcelRequire("1911v");

var $chr8o = parcelRequire("chr8o");

var $juCVt = parcelRequire("juCVt");
/**
 * @category Locales
 * @summary Maltese locale.
 * @language Maltese
 * @iso-639-2 mlt
 * @author Andras Matzon [@amatzon](@link https://github.com/amatzon)
 * @author Bryan Borg [@bryanMt](@link https://github.com/bryanMt)
 */ const $aeff5b33e95be79d$var$mt = $aeff5b33e95be79d$export$f2a459ff55c00db5 = {
    code: "mt",
    formatDistance: $eCGFL.formatDistance,
    formatLong: $a6ttz.formatLong,
    formatRelative: $1911v.formatRelative,
    localize: $chr8o.localize,
    match: $juCVt.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("eCGFL", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $aa55b731ad1119f2$export$2c14ff85d6318973; }, function (v) { return $aa55b731ad1119f2$export$2c14ff85d6318973 = v; });
var $aa55b731ad1119f2$export$2c14ff85d6318973;
"use strict";
$aa55b731ad1119f2$export$2c14ff85d6318973 = void 0;
const $aa55b731ad1119f2$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "inqas minn sekonda",
        other: "inqas minn {{count}} sekondi"
    },
    xSeconds: {
        one: "sekonda",
        other: "{{count}} sekondi"
    },
    halfAMinute: "nofs minuta",
    lessThanXMinutes: {
        one: "inqas minn minuta",
        other: "inqas minn {{count}} minuti"
    },
    xMinutes: {
        one: "minuta",
        other: "{{count}} minuti"
    },
    aboutXHours: {
        one: "madwar sieg\u0127a",
        other: "madwar {{count}} sieg\u0127at"
    },
    xHours: {
        one: "sieg\u0127a",
        other: "{{count}} sieg\u0127at"
    },
    xDays: {
        one: "\u0121urnata",
        other: "{{count}} \u0121ranet"
    },
    aboutXWeeks: {
        one: "madwar \u0121img\u0127a",
        other: "madwar {{count}} \u0121img\u0127at"
    },
    xWeeks: {
        one: "\u0121img\u0127a",
        other: "{{count}} \u0121img\u0127at"
    },
    aboutXMonths: {
        one: "madwar xahar",
        other: "madwar {{count}} xhur"
    },
    xMonths: {
        one: "xahar",
        other: "{{count}} xhur"
    },
    aboutXYears: {
        one: "madwar sena",
        two: "madwar sentejn",
        other: "madwar {{count}} snin"
    },
    xYears: {
        one: "sena",
        two: "sentejn",
        other: "{{count}} snin"
    },
    overXYears: {
        one: "aktar minn sena",
        two: "aktar minn sentejn",
        other: "aktar minn {{count}} snin"
    },
    almostXYears: {
        one: "kwa\u017Ci sena",
        two: "kwa\u017Ci sentejn",
        other: "kwa\u017Ci {{count}} snin"
    }
};
const $aa55b731ad1119f2$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $aa55b731ad1119f2$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2 && tokenValue.two) result = tokenValue.two;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "f'" + result;
        else return result + " ilu";
    }
    return result;
};
$aa55b731ad1119f2$export$2c14ff85d6318973 = $aa55b731ad1119f2$var$formatDistance;

});

parcelRegister("a6ttz", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $75b1543bc02ae3b4$export$cbf60ecb96cbb82f; }, function (v) { return $75b1543bc02ae3b4$export$cbf60ecb96cbb82f = v; });
var $75b1543bc02ae3b4$export$cbf60ecb96cbb82f;
"use strict";
$75b1543bc02ae3b4$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $75b1543bc02ae3b4$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
};
const $75b1543bc02ae3b4$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $75b1543bc02ae3b4$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $75b1543bc02ae3b4$var$formatLong = $75b1543bc02ae3b4$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $75b1543bc02ae3b4$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $75b1543bc02ae3b4$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $75b1543bc02ae3b4$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("1911v", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $0d576cecc01043c1$export$8fbbfd65594f46a0; }, function (v) { return $0d576cecc01043c1$export$8fbbfd65594f46a0 = v; });
var $0d576cecc01043c1$export$8fbbfd65594f46a0;
"use strict";
$0d576cecc01043c1$export$8fbbfd65594f46a0 = void 0;
const $0d576cecc01043c1$var$formatRelativeLocale = {
    lastWeek: "eeee 'li g\u0127adda' 'fil-'p",
    yesterday: "'Il-biera\u0127 fil-'p",
    today: "'Illum fil-'p",
    tomorrow: "'G\u0127ada fil-'p",
    nextWeek: "eeee 'fil-'p",
    other: "P"
};
const $0d576cecc01043c1$var$formatRelative = (token, _date, _baseDate, _options)=>$0d576cecc01043c1$var$formatRelativeLocale[token];
$0d576cecc01043c1$export$8fbbfd65594f46a0 = $0d576cecc01043c1$var$formatRelative;

});

parcelRegister("chr8o", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $8f0c1ee3e5148cbf$export$b3bd0bc58e36cd63; }, function (v) { return $8f0c1ee3e5148cbf$export$b3bd0bc58e36cd63 = v; });
var $8f0c1ee3e5148cbf$export$b3bd0bc58e36cd63;
"use strict";
$8f0c1ee3e5148cbf$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $8f0c1ee3e5148cbf$var$eraValues = {
    narrow: [
        "Q",
        "W"
    ],
    abbreviated: [
        "QK",
        "WK"
    ],
    wide: [
        "qabel Kristu",
        "wara Kristu"
    ]
};
const $8f0c1ee3e5148cbf$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1. kwart",
        "2. kwart",
        "3. kwart",
        "4. kwart"
    ]
};
const $8f0c1ee3e5148cbf$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "\u0120",
        "L",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Fra",
        "Mar",
        "Apr",
        "Mej",
        "\u0120un",
        "Lul",
        "Aww",
        "Set",
        "Ott",
        "Nov",
        "Di\u010B"
    ],
    wide: [
        "Jannar",
        "Frar",
        "Marzu",
        "April",
        "Mejju",
        "\u0120unju",
        "Lulju",
        "Awwissu",
        "Settembru",
        "Ottubru",
        "Novembru",
        "Di\u010Bembru"
    ]
};
const $8f0c1ee3e5148cbf$var$dayValues = {
    narrow: [
        "\u0126",
        "T",
        "T",
        "E",
        "\u0126",
        "\u0120",
        "S"
    ],
    short: [
        "\u0126a",
        "Tn",
        "Tl",
        "Er",
        "\u0126a",
        "\u0120i",
        "Si"
    ],
    abbreviated: [
        "\u0126ad",
        "Tne",
        "Tli",
        "Erb",
        "\u0126am",
        "\u0120im",
        "Sib"
    ],
    wide: [
        "Il-\u0126add",
        "It-Tnejn",
        "It-Tlieta",
        "L-Erbg\u0127a",
        "Il-\u0126amis",
        "Il-\u0120img\u0127a",
        "Is-Sibt"
    ]
};
const $8f0c1ee3e5148cbf$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "nofsillejl",
        noon: "nofsinhar",
        morning: "g\u0127odwa",
        afternoon: "wara nofsinhar",
        evening: "filg\u0127axija",
        night: "lejl"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "nofsillejl",
        noon: "nofsinhar",
        morning: "g\u0127odwa",
        afternoon: "wara nofsinhar",
        evening: "filg\u0127axija",
        night: "lejl"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "nofsillejl",
        noon: "nofsinhar",
        morning: "g\u0127odwa",
        afternoon: "wara nofsinhar",
        evening: "filg\u0127axija",
        night: "lejl"
    }
};
const $8f0c1ee3e5148cbf$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "f'nofsillejl",
        noon: "f'nofsinhar",
        morning: "filg\u0127odu",
        afternoon: "wara nofsinhar",
        evening: "filg\u0127axija",
        night: "billejl"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "f'nofsillejl",
        noon: "f'nofsinhar",
        morning: "filg\u0127odu",
        afternoon: "wara nofsinhar",
        evening: "filg\u0127axija",
        night: "billejl"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "f'nofsillejl",
        noon: "f'nofsinhar",
        morning: "filg\u0127odu",
        afternoon: "wara nofsinhar",
        evening: "filg\u0127axija",
        night: "billejl"
    }
};
const $8f0c1ee3e5148cbf$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + "\xba";
};
const $8f0c1ee3e5148cbf$var$localize = $8f0c1ee3e5148cbf$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $8f0c1ee3e5148cbf$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $8f0c1ee3e5148cbf$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $8f0c1ee3e5148cbf$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $8f0c1ee3e5148cbf$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $8f0c1ee3e5148cbf$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $8f0c1ee3e5148cbf$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $8f0c1ee3e5148cbf$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("juCVt", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $e30f0391f23f8a22$export$4659b591c19bdf3d; }, function (v) { return $e30f0391f23f8a22$export$4659b591c19bdf3d = v; });
var $e30f0391f23f8a22$export$4659b591c19bdf3d;
"use strict";
$e30f0391f23f8a22$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $e30f0391f23f8a22$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
const $e30f0391f23f8a22$var$parseOrdinalNumberPattern = /\d+/i;
const $e30f0391f23f8a22$var$matchEraPatterns = {
    narrow: /^(q|w)/i,
    abbreviated: /^(q\.?\s?k\.?|b\.?\s?c\.?\s?e\.?|w\.?\s?k\.?)/i,
    wide: /^(qabel kristu|before common era|wara kristu|common era)/i
};
const $e30f0391f23f8a22$var$parseEraPatterns = {
    any: [
        /^(q|b)/i,
        /^(w|c)/i
    ]
};
const $e30f0391f23f8a22$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^k[1234]/i,
    wide: /^[1234](\.)? kwart/i
};
const $e30f0391f23f8a22$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $e30f0391f23f8a22$var$matchMonthPatterns = {
    narrow: /^[jfmaglsond]/i,
    abbreviated: /^(jan|fra|mar|apr|mej|ġun|lul|aww|set|ott|nov|diċ)/i,
    wide: /^(jannar|frar|marzu|april|mejju|ġunju|lulju|awwissu|settembru|ottubru|novembru|diċembru)/i
};
const $e30f0391f23f8a22$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^ġ/i,
        /^l/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mej/i,
        /^ġ/i,
        /^l/i,
        /^aw/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $e30f0391f23f8a22$var$matchDayPatterns = {
    narrow: /^[ħteġs]/i,
    short: /^(ħa|tn|tl|er|ħa|ġi|si)/i,
    abbreviated: /^(ħad|tne|tli|erb|ħam|ġim|sib)/i,
    wide: /^(il-ħadd|it-tnejn|it-tlieta|l-erbgħa|il-ħamis|il-ġimgħa|is-sibt)/i
};
const $e30f0391f23f8a22$var$parseDayPatterns = {
    narrow: [
        /^ħ/i,
        /^t/i,
        /^t/i,
        /^e/i,
        /^ħ/i,
        /^ġ/i,
        /^s/i
    ],
    any: [
        /^(il-)?ħad/i,
        /^(it-)?tn/i,
        /^(it-)?tl/i,
        /^(l-)?er/i,
        /^(il-)?ham/i,
        /^(il-)?ġi/i,
        /^(is-)?si/i
    ]
};
const $e30f0391f23f8a22$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i,
    any: /^([ap]\.?\s?m\.?|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i
};
const $e30f0391f23f8a22$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^f'nofsillejl/i,
        noon: /^f'nofsinhar/i,
        morning: /għodwa/i,
        afternoon: /wara(\s.*)nofsinhar/i,
        evening: /filgħaxija/i,
        night: /lejl/i
    }
};
const $e30f0391f23f8a22$var$match = $e30f0391f23f8a22$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $e30f0391f23f8a22$var$matchOrdinalNumberPattern,
        parsePattern: $e30f0391f23f8a22$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e30f0391f23f8a22$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e30f0391f23f8a22$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e30f0391f23f8a22$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e30f0391f23f8a22$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e30f0391f23f8a22$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e30f0391f23f8a22$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e30f0391f23f8a22$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e30f0391f23f8a22$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e30f0391f23f8a22$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $e30f0391f23f8a22$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("jEuu3", function(module, exports) {

$parcel$export(module.exports, "nb", function () { return $e4e96629881d9ac4$export$38ef0e3f791a121e; }, function (v) { return $e4e96629881d9ac4$export$38ef0e3f791a121e = v; });
var $e4e96629881d9ac4$export$38ef0e3f791a121e;
"use strict";
$e4e96629881d9ac4$export$38ef0e3f791a121e = void 0;

var $7WqjM = parcelRequire("7WqjM");

var $8rnmM = parcelRequire("8rnmM");

var $6aA5S = parcelRequire("6aA5S");

var $jwIlK = parcelRequire("jwIlK");

var $6ONHj = parcelRequire("6ONHj");
/**
 * @category Locales
 * @summary Norwegian Bokmål locale.
 * @language Norwegian Bokmål
 * @iso-639-2 nob
 * @author Hans-Kristian Koren [@Hanse](https://github.com/Hanse)
 * @author Mikolaj Grzyb [@mikolajgrzyb](https://github.com/mikolajgrzyb)
 * @author Dag Stuan [@dagstuan](https://github.com/dagstuan)
 */ const $e4e96629881d9ac4$var$nb = $e4e96629881d9ac4$export$38ef0e3f791a121e = {
    code: "nb",
    formatDistance: $7WqjM.formatDistance,
    formatLong: $8rnmM.formatLong,
    formatRelative: $6aA5S.formatRelative,
    localize: $jwIlK.localize,
    match: $6ONHj.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("7WqjM", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $5c825d692546b073$export$2c14ff85d6318973; }, function (v) { return $5c825d692546b073$export$2c14ff85d6318973 = v; });
var $5c825d692546b073$export$2c14ff85d6318973;
"use strict";
$5c825d692546b073$export$2c14ff85d6318973 = void 0;
const $5c825d692546b073$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre enn ett sekund",
        other: "mindre enn {{count}} sekunder"
    },
    xSeconds: {
        one: "ett sekund",
        other: "{{count}} sekunder"
    },
    halfAMinute: "et halvt minutt",
    lessThanXMinutes: {
        one: "mindre enn ett minutt",
        other: "mindre enn {{count}} minutter"
    },
    xMinutes: {
        one: "ett minutt",
        other: "{{count}} minutter"
    },
    aboutXHours: {
        one: "omtrent en time",
        other: "omtrent {{count}} timer"
    },
    xHours: {
        one: "en time",
        other: "{{count}} timer"
    },
    xDays: {
        one: "en dag",
        other: "{{count}} dager"
    },
    aboutXWeeks: {
        one: "omtrent en uke",
        other: "omtrent {{count}} uker"
    },
    xWeeks: {
        one: "en uke",
        other: "{{count}} uker"
    },
    aboutXMonths: {
        one: "omtrent en m\xe5ned",
        other: "omtrent {{count}} m\xe5neder"
    },
    xMonths: {
        one: "en m\xe5ned",
        other: "{{count}} m\xe5neder"
    },
    aboutXYears: {
        one: "omtrent ett \xe5r",
        other: "omtrent {{count}} \xe5r"
    },
    xYears: {
        one: "ett \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over ett \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "nesten ett \xe5r",
        other: "nesten {{count}} \xe5r"
    }
};
const $5c825d692546b073$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $5c825d692546b073$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "om " + result;
        else return result + " siden";
    }
    return result;
};
$5c825d692546b073$export$2c14ff85d6318973 = $5c825d692546b073$var$formatDistance;

});

parcelRegister("8rnmM", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $6252f874daf76e48$export$cbf60ecb96cbb82f; }, function (v) { return $6252f874daf76e48$export$cbf60ecb96cbb82f = v; });
var $6252f874daf76e48$export$cbf60ecb96cbb82f;
"use strict";
$6252f874daf76e48$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $6252f874daf76e48$var$dateFormats = {
    full: "EEEE d. MMMM y",
    long: "d. MMMM y",
    medium: "d. MMM y",
    short: "dd.MM.y"
};
const $6252f874daf76e48$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $6252f874daf76e48$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $6252f874daf76e48$var$formatLong = $6252f874daf76e48$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $6252f874daf76e48$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $6252f874daf76e48$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $6252f874daf76e48$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("6aA5S", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $0128c4d9cd61098f$export$8fbbfd65594f46a0; }, function (v) { return $0128c4d9cd61098f$export$8fbbfd65594f46a0 = v; });
var $0128c4d9cd61098f$export$8fbbfd65594f46a0;
"use strict";
$0128c4d9cd61098f$export$8fbbfd65594f46a0 = void 0;
const $0128c4d9cd61098f$var$formatRelativeLocale = {
    lastWeek: "'forrige' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: "P"
};
const $0128c4d9cd61098f$var$formatRelative = (token, _date, _baseDate, _options)=>$0128c4d9cd61098f$var$formatRelativeLocale[token];
$0128c4d9cd61098f$export$8fbbfd65594f46a0 = $0128c4d9cd61098f$var$formatRelative;

});

parcelRegister("jwIlK", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $e37368679e25956b$export$b3bd0bc58e36cd63; }, function (v) { return $e37368679e25956b$export$b3bd0bc58e36cd63 = v; });
var $e37368679e25956b$export$b3bd0bc58e36cd63;
"use strict";
$e37368679e25956b$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $e37368679e25956b$var$eraValues = {
    narrow: [
        "f.Kr.",
        "e.Kr."
    ],
    abbreviated: [
        "f.Kr.",
        "e.Kr."
    ],
    wide: [
        "f\xf8r Kristus",
        "etter Kristus"
    ]
};
const $e37368679e25956b$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. kvartal",
        "2. kvartal",
        "3. kvartal",
        "4. kvartal"
    ]
};
const $e37368679e25956b$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mars",
        "apr.",
        "mai",
        "juni",
        "juli",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "des."
    ],
    wide: [
        "januar",
        "februar",
        "mars",
        "april",
        "mai",
        "juni",
        "juli",
        "august",
        "september",
        "oktober",
        "november",
        "desember"
    ]
};
const $e37368679e25956b$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "O",
        "T",
        "F",
        "L"
    ],
    short: [
        "s\xf8",
        "ma",
        "ti",
        "on",
        "to",
        "fr",
        "l\xf8"
    ],
    abbreviated: [
        "s\xf8n",
        "man",
        "tir",
        "ons",
        "tor",
        "fre",
        "l\xf8r"
    ],
    wide: [
        "s\xf8ndag",
        "mandag",
        "tirsdag",
        "onsdag",
        "torsdag",
        "fredag",
        "l\xf8rdag"
    ]
};
const $e37368679e25956b$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    },
    abbreviated: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morgenen",
        afternoon: "p\xe5 ettermiddagen",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    }
};
const $e37368679e25956b$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $e37368679e25956b$var$localize = $e37368679e25956b$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $e37368679e25956b$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $e37368679e25956b$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $e37368679e25956b$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $e37368679e25956b$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $e37368679e25956b$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $e37368679e25956b$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};

});

parcelRegister("6ONHj", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $4f6df681cd972c2e$export$4659b591c19bdf3d; }, function (v) { return $4f6df681cd972c2e$export$4659b591c19bdf3d = v; });
var $4f6df681cd972c2e$export$4659b591c19bdf3d;
"use strict";
$4f6df681cd972c2e$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $4f6df681cd972c2e$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
const $4f6df681cd972c2e$var$parseOrdinalNumberPattern = /\d+/i;
const $4f6df681cd972c2e$var$matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
};
const $4f6df681cd972c2e$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^e/i
    ]
};
const $4f6df681cd972c2e$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
const $4f6df681cd972c2e$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $4f6df681cd972c2e$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
    wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
};
const $4f6df681cd972c2e$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $4f6df681cd972c2e$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(sø|ma|ti|on|to|fr|lø)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
const $4f6df681cd972c2e$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
const $4f6df681cd972c2e$var$matchDayPeriodPatterns = {
    narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
    any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
};
const $4f6df681cd972c2e$var$parseDayPeriodPatterns = {
    any: {
        am: /^a(\.?\s?m\.?)?$/i,
        pm: /^p(\.?\s?m\.?)?$/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgen/i,
        afternoon: /ettermiddag/i,
        evening: /kveld/i,
        night: /natt/i
    }
};
const $4f6df681cd972c2e$var$match = $4f6df681cd972c2e$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $4f6df681cd972c2e$var$matchOrdinalNumberPattern,
        parsePattern: $4f6df681cd972c2e$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $4f6df681cd972c2e$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4f6df681cd972c2e$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $4f6df681cd972c2e$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4f6df681cd972c2e$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $4f6df681cd972c2e$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4f6df681cd972c2e$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $4f6df681cd972c2e$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4f6df681cd972c2e$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $4f6df681cd972c2e$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $4f6df681cd972c2e$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("d7rm6", function(module, exports) {

$parcel$export(module.exports, "nl", function () { return $98d1260d7c0fe272$export$9c64ee4d84d79ce1; }, function (v) { return $98d1260d7c0fe272$export$9c64ee4d84d79ce1 = v; });
var $98d1260d7c0fe272$export$9c64ee4d84d79ce1;
"use strict";
$98d1260d7c0fe272$export$9c64ee4d84d79ce1 = void 0;

var $1lAWn = parcelRequire("1lAWn");

var $eun7z = parcelRequire("eun7z");

var $mkNtN = parcelRequire("mkNtN");

var $gTTYq = parcelRequire("gTTYq");

var $83rXT = parcelRequire("83rXT");
/**
 * @category Locales
 * @summary Dutch locale.
 * @language Dutch
 * @iso-639-2 nld
 * @author Jorik Tangelder [@jtangelder](https://github.com/jtangelder)
 * @author Ruben Stolk [@rubenstolk](https://github.com/rubenstolk)
 * @author Lode Vanhove [@bitcrumb](https://github.com/bitcrumb)
 * @author Edo Rivai [@edorivai](https://github.com/edorivai)
 * @author Niels Keurentjes [@curry684](https://github.com/curry684)
 * @author Stefan Vermaas [@stefanvermaas](https://github.com/stefanvermaas)
 */ const $98d1260d7c0fe272$var$nl = $98d1260d7c0fe272$export$9c64ee4d84d79ce1 = {
    code: "nl",
    formatDistance: $1lAWn.formatDistance,
    formatLong: $eun7z.formatLong,
    formatRelative: $mkNtN.formatRelative,
    localize: $gTTYq.localize,
    match: $83rXT.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("1lAWn", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $0fb4683e016fd628$export$2c14ff85d6318973; }, function (v) { return $0fb4683e016fd628$export$2c14ff85d6318973 = v; });
var $0fb4683e016fd628$export$2c14ff85d6318973;
"use strict";
$0fb4683e016fd628$export$2c14ff85d6318973 = void 0;
const $0fb4683e016fd628$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minder dan een seconde",
        other: "minder dan {{count}} seconden"
    },
    xSeconds: {
        one: "1 seconde",
        other: "{{count}} seconden"
    },
    halfAMinute: "een halve minuut",
    lessThanXMinutes: {
        one: "minder dan een minuut",
        other: "minder dan {{count}} minuten"
    },
    xMinutes: {
        one: "een minuut",
        other: "{{count}} minuten"
    },
    aboutXHours: {
        one: "ongeveer 1 uur",
        other: "ongeveer {{count}} uur"
    },
    xHours: {
        one: "1 uur",
        other: "{{count}} uur"
    },
    xDays: {
        one: "1 dag",
        other: "{{count}} dagen"
    },
    aboutXWeeks: {
        one: "ongeveer 1 week",
        other: "ongeveer {{count}} weken"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weken"
    },
    aboutXMonths: {
        one: "ongeveer 1 maand",
        other: "ongeveer {{count}} maanden"
    },
    xMonths: {
        one: "1 maand",
        other: "{{count}} maanden"
    },
    aboutXYears: {
        one: "ongeveer 1 jaar",
        other: "ongeveer {{count}} jaar"
    },
    xYears: {
        one: "1 jaar",
        other: "{{count}} jaar"
    },
    overXYears: {
        one: "meer dan 1 jaar",
        other: "meer dan {{count}} jaar"
    },
    almostXYears: {
        one: "bijna 1 jaar",
        other: "bijna {{count}} jaar"
    }
};
const $0fb4683e016fd628$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $0fb4683e016fd628$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "over " + result;
        else return result + " geleden";
    }
    return result;
};
$0fb4683e016fd628$export$2c14ff85d6318973 = $0fb4683e016fd628$var$formatDistance;

});

parcelRegister("eun7z", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $a8c5cd6974e95c75$export$cbf60ecb96cbb82f; }, function (v) { return $a8c5cd6974e95c75$export$cbf60ecb96cbb82f = v; });
var $a8c5cd6974e95c75$export$cbf60ecb96cbb82f;
"use strict";
$a8c5cd6974e95c75$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $a8c5cd6974e95c75$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd-MM-y"
};
const $a8c5cd6974e95c75$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $a8c5cd6974e95c75$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $a8c5cd6974e95c75$var$formatLong = $a8c5cd6974e95c75$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $a8c5cd6974e95c75$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $a8c5cd6974e95c75$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $a8c5cd6974e95c75$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("mkNtN", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $0432300d335dcf3b$export$8fbbfd65594f46a0; }, function (v) { return $0432300d335dcf3b$export$8fbbfd65594f46a0 = v; });
var $0432300d335dcf3b$export$8fbbfd65594f46a0;
"use strict";
$0432300d335dcf3b$export$8fbbfd65594f46a0 = void 0;
const $0432300d335dcf3b$var$formatRelativeLocale = {
    lastWeek: "'afgelopen' eeee 'om' p",
    yesterday: "'gisteren om' p",
    today: "'vandaag om' p",
    tomorrow: "'morgen om' p",
    nextWeek: "eeee 'om' p",
    other: "P"
};
const $0432300d335dcf3b$var$formatRelative = (token, _date, _baseDate, _options)=>$0432300d335dcf3b$var$formatRelativeLocale[token];
$0432300d335dcf3b$export$8fbbfd65594f46a0 = $0432300d335dcf3b$var$formatRelative;

});

parcelRegister("gTTYq", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $c4dd339c0c67acbc$export$b3bd0bc58e36cd63; }, function (v) { return $c4dd339c0c67acbc$export$b3bd0bc58e36cd63 = v; });
var $c4dd339c0c67acbc$export$b3bd0bc58e36cd63;
"use strict";
$c4dd339c0c67acbc$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $c4dd339c0c67acbc$var$eraValues = {
    narrow: [
        "v.C.",
        "n.C."
    ],
    abbreviated: [
        "v.Chr.",
        "n.Chr."
    ],
    wide: [
        "voor Christus",
        "na Christus"
    ]
};
const $c4dd339c0c67acbc$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1e kwartaal",
        "2e kwartaal",
        "3e kwartaal",
        "4e kwartaal"
    ]
};
const $c4dd339c0c67acbc$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mrt.",
        "apr.",
        "mei",
        "jun.",
        "jul.",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "januari",
        "februari",
        "maart",
        "april",
        "mei",
        "juni",
        "juli",
        "augustus",
        "september",
        "oktober",
        "november",
        "december"
    ]
};
const $c4dd339c0c67acbc$var$dayValues = {
    narrow: [
        "Z",
        "M",
        "D",
        "W",
        "D",
        "V",
        "Z"
    ],
    short: [
        "zo",
        "ma",
        "di",
        "wo",
        "do",
        "vr",
        "za"
    ],
    abbreviated: [
        "zon",
        "maa",
        "din",
        "woe",
        "don",
        "vri",
        "zat"
    ],
    wide: [
        "zondag",
        "maandag",
        "dinsdag",
        "woensdag",
        "donderdag",
        "vrijdag",
        "zaterdag"
    ]
};
const $c4dd339c0c67acbc$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middaguur",
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middaguur",
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middaguur",
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    }
};
const $c4dd339c0c67acbc$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + "e";
};
const $c4dd339c0c67acbc$var$localize = $c4dd339c0c67acbc$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $c4dd339c0c67acbc$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $c4dd339c0c67acbc$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $c4dd339c0c67acbc$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $c4dd339c0c67acbc$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $c4dd339c0c67acbc$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $c4dd339c0c67acbc$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};

});

parcelRegister("83rXT", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $5dd44bce0ef79ac0$export$4659b591c19bdf3d; }, function (v) { return $5dd44bce0ef79ac0$export$4659b591c19bdf3d = v; });
var $5dd44bce0ef79ac0$export$4659b591c19bdf3d;
"use strict";
$5dd44bce0ef79ac0$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $5dd44bce0ef79ac0$var$matchOrdinalNumberPattern = /^(\d+)e?/i;
const $5dd44bce0ef79ac0$var$parseOrdinalNumberPattern = /\d+/i;
const $5dd44bce0ef79ac0$var$matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?Chr\.?)/,
    wide: /^((voor|na) Christus)/
};
const $5dd44bce0ef79ac0$var$parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
const $5dd44bce0ef79ac0$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e kwartaal/i
};
const $5dd44bce0ef79ac0$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $5dd44bce0ef79ac0$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
const $5dd44bce0ef79ac0$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mei/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^dec/i
    ]
};
const $5dd44bce0ef79ac0$var$matchDayPatterns = {
    narrow: /^[zmdwv]/i,
    short: /^(zo|ma|di|wo|do|vr|za)/i,
    abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
    wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
const $5dd44bce0ef79ac0$var$parseDayPatterns = {
    narrow: [
        /^z/i,
        /^m/i,
        /^d/i,
        /^w/i,
        /^d/i,
        /^v/i,
        /^z/i
    ],
    any: [
        /^zo/i,
        /^ma/i,
        /^di/i,
        /^wo/i,
        /^do/i,
        /^vr/i,
        /^za/i
    ]
};
const $5dd44bce0ef79ac0$var$matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
const $5dd44bce0ef79ac0$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^het middaguur/i,
        morning: /ochtend/i,
        afternoon: /middag/i,
        evening: /avond/i,
        night: /nacht/i
    }
};
const $5dd44bce0ef79ac0$var$match = $5dd44bce0ef79ac0$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $5dd44bce0ef79ac0$var$matchOrdinalNumberPattern,
        parsePattern: $5dd44bce0ef79ac0$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $5dd44bce0ef79ac0$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5dd44bce0ef79ac0$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $5dd44bce0ef79ac0$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5dd44bce0ef79ac0$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $5dd44bce0ef79ac0$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5dd44bce0ef79ac0$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $5dd44bce0ef79ac0$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5dd44bce0ef79ac0$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $5dd44bce0ef79ac0$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $5dd44bce0ef79ac0$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("1ewID", function(module, exports) {

$parcel$export(module.exports, "nlBE", function () { return $0e607a8aa9540575$export$3fc71760fcd6c40e; }, function (v) { return $0e607a8aa9540575$export$3fc71760fcd6c40e = v; });
var $0e607a8aa9540575$export$3fc71760fcd6c40e;
"use strict";
$0e607a8aa9540575$export$3fc71760fcd6c40e = void 0;

var $kvJIH = parcelRequire("kvJIH");

var $k0HNE = parcelRequire("k0HNE");

var $aq1pr = parcelRequire("aq1pr");

var $badbo = parcelRequire("badbo");

var $lTQrE = parcelRequire("lTQrE");
/**
 * @category Locales
 * @summary Dutch locale.
 * @language Dutch
 * @iso-639-2 nld
 * @author Jorik Tangelder [@jtangelder](https://github.com/jtangelder)
 * @author Ruben Stolk [@rubenstolk](https://github.com/rubenstolk)
 * @author Lode Vanhove [@bitcrumb](https://github.com/bitcrumb)
 * @author Alex Hoeing [@dcbn](https://github.com/dcbn)
 */ const $0e607a8aa9540575$var$nlBE = $0e607a8aa9540575$export$3fc71760fcd6c40e = {
    code: "nl-BE",
    formatDistance: $kvJIH.formatDistance,
    formatLong: $k0HNE.formatLong,
    formatRelative: $aq1pr.formatRelative,
    localize: $badbo.localize,
    match: $lTQrE.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("kvJIH", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $eeea2af13c370779$export$2c14ff85d6318973; }, function (v) { return $eeea2af13c370779$export$2c14ff85d6318973 = v; });
var $eeea2af13c370779$export$2c14ff85d6318973;
"use strict";
$eeea2af13c370779$export$2c14ff85d6318973 = void 0;
const $eeea2af13c370779$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minder dan een seconde",
        other: "minder dan {{count}} seconden"
    },
    xSeconds: {
        one: "1 seconde",
        other: "{{count}} seconden"
    },
    halfAMinute: "een halve minuut",
    lessThanXMinutes: {
        one: "minder dan een minuut",
        other: "minder dan {{count}} minuten"
    },
    xMinutes: {
        one: "een minuut",
        other: "{{count}} minuten"
    },
    aboutXHours: {
        one: "ongeveer 1 uur",
        other: "ongeveer {{count}} uur"
    },
    xHours: {
        one: "1 uur",
        other: "{{count}} uur"
    },
    xDays: {
        one: "1 dag",
        other: "{{count}} dagen"
    },
    aboutXWeeks: {
        one: "ongeveer 1 week",
        other: "ongeveer {{count}} weken"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weken"
    },
    aboutXMonths: {
        one: "ongeveer 1 maand",
        other: "ongeveer {{count}} maanden"
    },
    xMonths: {
        one: "1 maand",
        other: "{{count}} maanden"
    },
    aboutXYears: {
        one: "ongeveer 1 jaar",
        other: "ongeveer {{count}} jaar"
    },
    xYears: {
        one: "1 jaar",
        other: "{{count}} jaar"
    },
    overXYears: {
        one: "meer dan 1 jaar",
        other: "meer dan {{count}} jaar"
    },
    almostXYears: {
        one: "bijna 1 jaar",
        other: "bijna {{count}} jaar"
    }
};
const $eeea2af13c370779$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $eeea2af13c370779$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "over " + result;
        else return result + " geleden";
    }
    return result;
};
$eeea2af13c370779$export$2c14ff85d6318973 = $eeea2af13c370779$var$formatDistance;

});

parcelRegister("k0HNE", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $e915c875acfd1af8$export$cbf60ecb96cbb82f; }, function (v) { return $e915c875acfd1af8$export$cbf60ecb96cbb82f = v; });
var $e915c875acfd1af8$export$cbf60ecb96cbb82f;
"use strict";
$e915c875acfd1af8$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $e915c875acfd1af8$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd.MM.y"
};
const $e915c875acfd1af8$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $e915c875acfd1af8$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $e915c875acfd1af8$var$formatLong = $e915c875acfd1af8$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $e915c875acfd1af8$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $e915c875acfd1af8$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $e915c875acfd1af8$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("aq1pr", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $795d6cf743f25999$export$8fbbfd65594f46a0; }, function (v) { return $795d6cf743f25999$export$8fbbfd65594f46a0 = v; });
var $795d6cf743f25999$export$8fbbfd65594f46a0;
"use strict";
$795d6cf743f25999$export$8fbbfd65594f46a0 = void 0;
const $795d6cf743f25999$var$formatRelativeLocale = {
    lastWeek: "'vorige' eeee 'om' p",
    yesterday: "'gisteren om' p",
    today: "'vandaag om' p",
    tomorrow: "'morgen om' p",
    nextWeek: "eeee 'om' p",
    other: "P"
};
const $795d6cf743f25999$var$formatRelative = (token, _date, _baseDate, _options)=>$795d6cf743f25999$var$formatRelativeLocale[token];
$795d6cf743f25999$export$8fbbfd65594f46a0 = $795d6cf743f25999$var$formatRelative;

});

parcelRegister("badbo", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $820adab806978326$export$b3bd0bc58e36cd63; }, function (v) { return $820adab806978326$export$b3bd0bc58e36cd63 = v; });
var $820adab806978326$export$b3bd0bc58e36cd63;
"use strict";
$820adab806978326$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $820adab806978326$var$eraValues = {
    narrow: [
        "v.C.",
        "n.C."
    ],
    abbreviated: [
        "v.Chr.",
        "n.Chr."
    ],
    wide: [
        "voor Christus",
        "na Christus"
    ]
};
const $820adab806978326$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1e kwartaal",
        "2e kwartaal",
        "3e kwartaal",
        "4e kwartaal"
    ]
};
const $820adab806978326$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mrt.",
        "apr.",
        "mei",
        "jun.",
        "jul.",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "januari",
        "februari",
        "maart",
        "april",
        "mei",
        "juni",
        "juli",
        "augustus",
        "september",
        "oktober",
        "november",
        "december"
    ]
};
const $820adab806978326$var$dayValues = {
    narrow: [
        "Z",
        "M",
        "D",
        "W",
        "D",
        "V",
        "Z"
    ],
    short: [
        "zo",
        "ma",
        "di",
        "wo",
        "do",
        "vr",
        "za"
    ],
    abbreviated: [
        "zon",
        "maa",
        "din",
        "woe",
        "don",
        "vri",
        "zat"
    ],
    wide: [
        "zondag",
        "maandag",
        "dinsdag",
        "woensdag",
        "donderdag",
        "vrijdag",
        "zaterdag"
    ]
};
const $820adab806978326$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middag",
        morning: "'s ochtends",
        afternoon: "'s namiddags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middag",
        morning: "'s ochtends",
        afternoon: "'s namiddags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middag",
        morning: "'s ochtends",
        afternoon: "'s namiddags",
        evening: "'s avonds",
        night: "'s nachts"
    }
};
const $820adab806978326$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + "e";
};
const $820adab806978326$var$localize = $820adab806978326$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $820adab806978326$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $820adab806978326$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $820adab806978326$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $820adab806978326$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $820adab806978326$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $820adab806978326$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};

});

parcelRegister("lTQrE", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $ff176a807746e0e1$export$4659b591c19bdf3d; }, function (v) { return $ff176a807746e0e1$export$4659b591c19bdf3d = v; });
var $ff176a807746e0e1$export$4659b591c19bdf3d;
"use strict";
$ff176a807746e0e1$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $ff176a807746e0e1$var$matchOrdinalNumberPattern = /^(\d+)e?/i;
const $ff176a807746e0e1$var$parseOrdinalNumberPattern = /\d+/i;
const $ff176a807746e0e1$var$matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?Chr\.?)/,
    wide: /^((voor|na) Christus)/
};
const $ff176a807746e0e1$var$parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
const $ff176a807746e0e1$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e kwartaal/i
};
const $ff176a807746e0e1$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $ff176a807746e0e1$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
const $ff176a807746e0e1$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mei/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^dec/i
    ]
};
const $ff176a807746e0e1$var$matchDayPatterns = {
    narrow: /^[zmdwv]/i,
    short: /^(zo|ma|di|wo|do|vr|za)/i,
    abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
    wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
const $ff176a807746e0e1$var$parseDayPatterns = {
    narrow: [
        /^z/i,
        /^m/i,
        /^d/i,
        /^w/i,
        /^d/i,
        /^v/i,
        /^z/i
    ],
    any: [
        /^zo/i,
        /^ma/i,
        /^di/i,
        /^wo/i,
        /^do/i,
        /^vr/i,
        /^za/i
    ]
};
const $ff176a807746e0e1$var$matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
const $ff176a807746e0e1$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^het middaguur/i,
        morning: /ochtend/i,
        afternoon: /middag/i,
        evening: /avond/i,
        night: /nacht/i
    }
};
const $ff176a807746e0e1$var$match = $ff176a807746e0e1$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $ff176a807746e0e1$var$matchOrdinalNumberPattern,
        parsePattern: $ff176a807746e0e1$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $ff176a807746e0e1$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ff176a807746e0e1$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $ff176a807746e0e1$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ff176a807746e0e1$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $ff176a807746e0e1$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ff176a807746e0e1$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $ff176a807746e0e1$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ff176a807746e0e1$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $ff176a807746e0e1$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $ff176a807746e0e1$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("jWADl", function(module, exports) {

$parcel$export(module.exports, "nn", function () { return $e84fd9bf31a624c0$export$5581105212343b35; }, function (v) { return $e84fd9bf31a624c0$export$5581105212343b35 = v; });
var $e84fd9bf31a624c0$export$5581105212343b35;
"use strict";
$e84fd9bf31a624c0$export$5581105212343b35 = void 0;

var $40apF = parcelRequire("40apF");

var $6aB8X = parcelRequire("6aB8X");

var $fKAQX = parcelRequire("fKAQX");

var $kvDSl = parcelRequire("kvDSl");

var $9NkUe = parcelRequire("9NkUe");
/**
 * @category Locales
 * @summary Norwegian Nynorsk locale.
 * @language Norwegian Nynorsk
 * @iso-639-2 nno
 * @author Mats Byrkjeland [@draperunner](https://github.com/draperunner)
 */ const $e84fd9bf31a624c0$var$nn = $e84fd9bf31a624c0$export$5581105212343b35 = {
    code: "nn",
    formatDistance: $40apF.formatDistance,
    formatLong: $6aB8X.formatLong,
    formatRelative: $fKAQX.formatRelative,
    localize: $kvDSl.localize,
    match: $9NkUe.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("40apF", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $2e9f3d49f8ca8a68$export$2c14ff85d6318973; }, function (v) { return $2e9f3d49f8ca8a68$export$2c14ff85d6318973 = v; });
var $2e9f3d49f8ca8a68$export$2c14ff85d6318973;
"use strict";
$2e9f3d49f8ca8a68$export$2c14ff85d6318973 = void 0;
const $2e9f3d49f8ca8a68$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre enn eitt sekund",
        other: "mindre enn {{count}} sekund"
    },
    xSeconds: {
        one: "eitt sekund",
        other: "{{count}} sekund"
    },
    halfAMinute: "eit halvt minutt",
    lessThanXMinutes: {
        one: "mindre enn eitt minutt",
        other: "mindre enn {{count}} minutt"
    },
    xMinutes: {
        one: "eitt minutt",
        other: "{{count}} minutt"
    },
    aboutXHours: {
        one: "omtrent ein time",
        other: "omtrent {{count}} timar"
    },
    xHours: {
        one: "ein time",
        other: "{{count}} timar"
    },
    xDays: {
        one: "ein dag",
        other: "{{count}} dagar"
    },
    aboutXWeeks: {
        one: "omtrent ei veke",
        other: "omtrent {{count}} veker"
    },
    xWeeks: {
        one: "ei veke",
        other: "{{count}} veker"
    },
    aboutXMonths: {
        one: "omtrent ein m\xe5nad",
        other: "omtrent {{count}} m\xe5nader"
    },
    xMonths: {
        one: "ein m\xe5nad",
        other: "{{count}} m\xe5nader"
    },
    aboutXYears: {
        one: "omtrent eitt \xe5r",
        other: "omtrent {{count}} \xe5r"
    },
    xYears: {
        one: "eitt \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over eitt \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "nesten eitt \xe5r",
        other: "nesten {{count}} \xe5r"
    }
};
const $2e9f3d49f8ca8a68$var$wordMapping = [
    "null",
    "ein",
    "to",
    "tre",
    "fire",
    "fem",
    "seks",
    "sju",
    "\xe5tte",
    "ni",
    "ti",
    "elleve",
    "tolv"
];
const $2e9f3d49f8ca8a68$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $2e9f3d49f8ca8a68$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count < 13 ? $2e9f3d49f8ca8a68$var$wordMapping[count] : String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "om " + result;
        else return result + " sidan";
    }
    return result;
};
$2e9f3d49f8ca8a68$export$2c14ff85d6318973 = $2e9f3d49f8ca8a68$var$formatDistance;

});

parcelRegister("6aB8X", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $47e07d2c7e6f345c$export$cbf60ecb96cbb82f; }, function (v) { return $47e07d2c7e6f345c$export$cbf60ecb96cbb82f = v; });
var $47e07d2c7e6f345c$export$cbf60ecb96cbb82f;
"use strict";
$47e07d2c7e6f345c$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $47e07d2c7e6f345c$var$dateFormats = {
    full: "EEEE d. MMMM y",
    long: "d. MMMM y",
    medium: "d. MMM y",
    short: "dd.MM.y"
};
const $47e07d2c7e6f345c$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $47e07d2c7e6f345c$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $47e07d2c7e6f345c$var$formatLong = $47e07d2c7e6f345c$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $47e07d2c7e6f345c$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $47e07d2c7e6f345c$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $47e07d2c7e6f345c$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("fKAQX", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $b777bd2d5d8e83ca$export$8fbbfd65594f46a0; }, function (v) { return $b777bd2d5d8e83ca$export$8fbbfd65594f46a0 = v; });
var $b777bd2d5d8e83ca$export$8fbbfd65594f46a0;
"use strict";
$b777bd2d5d8e83ca$export$8fbbfd65594f46a0 = void 0;
const $b777bd2d5d8e83ca$var$formatRelativeLocale = {
    lastWeek: "'f\xf8rre' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgon kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: "P"
};
const $b777bd2d5d8e83ca$var$formatRelative = (token, _date, _baseDate, _options)=>$b777bd2d5d8e83ca$var$formatRelativeLocale[token];
$b777bd2d5d8e83ca$export$8fbbfd65594f46a0 = $b777bd2d5d8e83ca$var$formatRelative;

});

parcelRegister("kvDSl", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $eee5a258e88d8c94$export$b3bd0bc58e36cd63; }, function (v) { return $eee5a258e88d8c94$export$b3bd0bc58e36cd63 = v; });
var $eee5a258e88d8c94$export$b3bd0bc58e36cd63;
"use strict";
$eee5a258e88d8c94$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $eee5a258e88d8c94$var$eraValues = {
    narrow: [
        "f.Kr.",
        "e.Kr."
    ],
    abbreviated: [
        "f.Kr.",
        "e.Kr."
    ],
    wide: [
        "f\xf8r Kristus",
        "etter Kristus"
    ]
};
const $eee5a258e88d8c94$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. kvartal",
        "2. kvartal",
        "3. kvartal",
        "4. kvartal"
    ]
};
const $eee5a258e88d8c94$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mars",
        "apr.",
        "mai",
        "juni",
        "juli",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "des."
    ],
    wide: [
        "januar",
        "februar",
        "mars",
        "april",
        "mai",
        "juni",
        "juli",
        "august",
        "september",
        "oktober",
        "november",
        "desember"
    ]
};
const $eee5a258e88d8c94$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "O",
        "T",
        "F",
        "L"
    ],
    short: [
        "su",
        "m\xe5",
        "ty",
        "on",
        "to",
        "fr",
        "lau"
    ],
    abbreviated: [
        "sun",
        "m\xe5n",
        "tys",
        "ons",
        "tor",
        "fre",
        "laur"
    ],
    wide: [
        "sundag",
        "m\xe5ndag",
        "tysdag",
        "onsdag",
        "torsdag",
        "fredag",
        "laurdag"
    ]
};
const $eee5a258e88d8c94$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natta"
    },
    abbreviated: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natta"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morgonen",
        afternoon: "p\xe5 ettermiddagen",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natta"
    }
};
const $eee5a258e88d8c94$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $eee5a258e88d8c94$var$localize = $eee5a258e88d8c94$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $eee5a258e88d8c94$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $eee5a258e88d8c94$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $eee5a258e88d8c94$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $eee5a258e88d8c94$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $eee5a258e88d8c94$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $eee5a258e88d8c94$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};

});

parcelRegister("9NkUe", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $7218e822393eb638$export$4659b591c19bdf3d; }, function (v) { return $7218e822393eb638$export$4659b591c19bdf3d = v; });
var $7218e822393eb638$export$4659b591c19bdf3d;
"use strict";
$7218e822393eb638$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $7218e822393eb638$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
const $7218e822393eb638$var$parseOrdinalNumberPattern = /\d+/i;
const $7218e822393eb638$var$matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
};
const $7218e822393eb638$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^e/i
    ]
};
const $7218e822393eb638$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
const $7218e822393eb638$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $7218e822393eb638$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
    wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
};
const $7218e822393eb638$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $7218e822393eb638$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(su|må|ty|on|to|fr|la)/i,
    abbreviated: /^(sun|mån|tys|ons|tor|fre|laur)/i,
    wide: /^(sundag|måndag|tysdag|onsdag|torsdag|fredag|laurdag)/i
};
const $7218e822393eb638$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ty/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
const $7218e822393eb638$var$matchDayPeriodPatterns = {
    narrow: /^(midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta)|[ap])/i,
    any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta))/i
};
const $7218e822393eb638$var$parseDayPeriodPatterns = {
    any: {
        am: /^a(\.?\s?m\.?)?$/i,
        pm: /^p(\.?\s?m\.?)?$/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgon/i,
        afternoon: /ettermiddag/i,
        evening: /kveld/i,
        night: /natt/i
    }
};
const $7218e822393eb638$var$match = $7218e822393eb638$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $7218e822393eb638$var$matchOrdinalNumberPattern,
        parsePattern: $7218e822393eb638$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $7218e822393eb638$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7218e822393eb638$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $7218e822393eb638$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7218e822393eb638$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $7218e822393eb638$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7218e822393eb638$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $7218e822393eb638$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7218e822393eb638$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $7218e822393eb638$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $7218e822393eb638$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("dVW0I", function(module, exports) {

$parcel$export(module.exports, "oc", function () { return $a24d98f0721da353$export$35a3191dac31414; }, function (v) { return $a24d98f0721da353$export$35a3191dac31414 = v; });
var $a24d98f0721da353$export$35a3191dac31414;
"use strict";
$a24d98f0721da353$export$35a3191dac31414 = void 0;

var $l3Qxw = parcelRequire("l3Qxw");

var $2vsbo = parcelRequire("2vsbo");

var $8Msa2 = parcelRequire("8Msa2");

var $cBb5a = parcelRequire("cBb5a");

var $dRwgN = parcelRequire("dRwgN");
/**
 * @category Locales
 * @summary Occitan locale.
 * @language Occitan
 * @iso-639-2 oci
 * @author Quentin PAGÈS
 */ const $a24d98f0721da353$var$oc = $a24d98f0721da353$export$35a3191dac31414 = {
    code: "oc",
    formatDistance: $l3Qxw.formatDistance,
    formatLong: $2vsbo.formatLong,
    formatRelative: $8Msa2.formatRelative,
    localize: $cBb5a.localize,
    match: $dRwgN.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("l3Qxw", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $f552a20f28b77eaa$export$2c14ff85d6318973; }, function (v) { return $f552a20f28b77eaa$export$2c14ff85d6318973 = v; });
var $f552a20f28b77eaa$export$2c14ff85d6318973;
"use strict";
$f552a20f28b77eaa$export$2c14ff85d6318973 = void 0;
const $f552a20f28b77eaa$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mens d\u2019una segonda",
        other: "mens de {{count}} segondas"
    },
    xSeconds: {
        one: "1 segonda",
        other: "{{count}} segondas"
    },
    halfAMinute: "30 segondas",
    lessThanXMinutes: {
        one: "mens d\u2019una minuta",
        other: "mens de {{count}} minutas"
    },
    xMinutes: {
        one: "1 minuta",
        other: "{{count}} minutas"
    },
    aboutXHours: {
        one: "environ 1 ora",
        other: "environ {{count}} oras"
    },
    xHours: {
        one: "1 ora",
        other: "{{count}} oras"
    },
    xDays: {
        one: "1 jorn",
        other: "{{count}} jorns"
    },
    aboutXWeeks: {
        one: "environ 1 setmana",
        other: "environ {{count}} setmanas"
    },
    xWeeks: {
        one: "1 setmana",
        other: "{{count}} setmanas"
    },
    aboutXMonths: {
        one: "environ 1 mes",
        other: "environ {{count}} meses"
    },
    xMonths: {
        one: "1 mes",
        other: "{{count}} meses"
    },
    aboutXYears: {
        one: "environ 1 an",
        other: "environ {{count}} ans"
    },
    xYears: {
        one: "1 an",
        other: "{{count}} ans"
    },
    overXYears: {
        one: "mai d\u2019un an",
        other: "mai de {{count}} ans"
    },
    almostXYears: {
        one: "gaireben un an",
        other: "gaireben {{count}} ans"
    }
};
const $f552a20f28b77eaa$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $f552a20f28b77eaa$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "d\u2019aqu\xed " + result;
        else return "fa " + result;
    }
    return result;
};
$f552a20f28b77eaa$export$2c14ff85d6318973 = $f552a20f28b77eaa$var$formatDistance;

});

parcelRegister("2vsbo", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $1d345684e56da5bd$export$cbf60ecb96cbb82f; }, function (v) { return $1d345684e56da5bd$export$cbf60ecb96cbb82f = v; });
var $1d345684e56da5bd$export$cbf60ecb96cbb82f;
"use strict";
$1d345684e56da5bd$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $1d345684e56da5bd$var$dateFormats = {
    full: "EEEE d 'de' MMMM y",
    long: "d 'de' MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
const $1d345684e56da5bd$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $1d345684e56da5bd$var$dateTimeFormats = {
    full: "{{date}} 'a' {{time}}",
    long: "{{date}} 'a' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $1d345684e56da5bd$var$formatLong = $1d345684e56da5bd$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $1d345684e56da5bd$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $1d345684e56da5bd$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $1d345684e56da5bd$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("8Msa2", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $6648a691849596d2$export$8fbbfd65594f46a0; }, function (v) { return $6648a691849596d2$export$8fbbfd65594f46a0 = v; });
var $6648a691849596d2$export$8fbbfd65594f46a0;
"use strict";
$6648a691849596d2$export$8fbbfd65594f46a0 = void 0;
const $6648a691849596d2$var$formatRelativeLocale = {
    lastWeek: "eeee 'passat a' p",
    yesterday: "'i\xe8r a' p",
    today: "'u\xe8i a' p",
    tomorrow: "'deman a' p",
    nextWeek: "eeee 'a' p",
    other: "P"
};
const $6648a691849596d2$var$formatRelative = (token, _date, _baseDate, _options)=>$6648a691849596d2$var$formatRelativeLocale[token];
$6648a691849596d2$export$8fbbfd65594f46a0 = $6648a691849596d2$var$formatRelative;

});

parcelRegister("cBb5a", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $92c18975030ba628$export$b3bd0bc58e36cd63; }, function (v) { return $92c18975030ba628$export$b3bd0bc58e36cd63 = v; });
var $92c18975030ba628$export$b3bd0bc58e36cd63;
"use strict";
$92c18975030ba628$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $92c18975030ba628$var$eraValues = {
    narrow: [
        "ab. J.C.",
        "apr. J.C."
    ],
    abbreviated: [
        "ab. J.C.",
        "apr. J.C."
    ],
    wide: [
        "abans J\xe8sus-Crist",
        "apr\xe8s J\xe8sus-Crist"
    ]
};
const $92c18975030ba628$var$quarterValues = {
    narrow: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    abbreviated: [
        "1\xe8r trim.",
        "2nd trim.",
        "3en trim.",
        "4en trim."
    ],
    wide: [
        "1\xe8r trim\xe8stre",
        "2nd trim\xe8stre",
        "3en trim\xe8stre",
        "4en trim\xe8stre"
    ]
};
const $92c18975030ba628$var$monthValues = {
    narrow: [
        "GN",
        "FB",
        "M\xc7",
        "AB",
        "MA",
        "JN",
        "JL",
        "AG",
        "ST",
        "OC",
        "NV",
        "DC"
    ],
    abbreviated: [
        "gen.",
        "febr.",
        "mar\xe7",
        "abr.",
        "mai",
        "junh",
        "jul.",
        "ag.",
        "set.",
        "oct.",
        "nov.",
        "dec."
    ],
    wide: [
        "geni\xe8r",
        "febri\xe8r",
        "mar\xe7",
        "abril",
        "mai",
        "junh",
        "julhet",
        "agost",
        "setembre",
        "oct\xf2bre",
        "novembre",
        "decembre"
    ]
};
const $92c18975030ba628$var$dayValues = {
    narrow: [
        "dg.",
        "dl.",
        "dm.",
        "dc.",
        "dj.",
        "dv.",
        "ds."
    ],
    short: [
        "dg.",
        "dl.",
        "dm.",
        "dc.",
        "dj.",
        "dv.",
        "ds."
    ],
    abbreviated: [
        "dg.",
        "dl.",
        "dm.",
        "dc.",
        "dj.",
        "dv.",
        "ds."
    ],
    wide: [
        "dimenge",
        "diluns",
        "dimars",
        "dim\xe8cres",
        "dij\xf2us",
        "divendres",
        "dissabte"
    ]
};
const $92c18975030ba628$var$dayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: "matin",
        afternoon: "apr\xe8p-mi\xe8gjorn",
        evening: "v\xe8spre",
        night: "nu\xe8ch"
    },
    abbreviated: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: "matin",
        afternoon: "apr\xe8p-mi\xe8gjorn",
        evening: "v\xe8spre",
        night: "nu\xe8ch"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: "matin",
        afternoon: "apr\xe8p-mi\xe8gjorn",
        evening: "v\xe8spre",
        night: "nu\xe8ch"
    }
};
const $92c18975030ba628$var$formattingDayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: "del matin",
        afternoon: "de l\u2019apr\xe8p-mi\xe8gjorn",
        evening: "del ser",
        night: "de la nu\xe8ch"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: "del matin",
        afternoon: "de l\u2019apr\xe8p-mi\xe8gjorn",
        evening: "del ser",
        night: "de la nu\xe8ch"
    },
    wide: {
        am: "ante meridiem",
        pm: "post meridiem",
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: "del matin",
        afternoon: "de l\u2019apr\xe8p-mi\xe8gjorn",
        evening: "del ser",
        night: "de la nu\xe8ch"
    }
};
const $92c18975030ba628$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    const unit = options?.unit;
    let ordinal;
    switch(number){
        case 1:
            ordinal = "\xe8r";
            break;
        case 2:
            ordinal = "nd";
            break;
        default:
            ordinal = "en";
    }
    // feminine for year, week, hour, minute, second
    if (unit === "year" || unit === "week" || unit === "hour" || unit === "minute" || unit === "second") ordinal += "a";
    return number + ordinal;
};
const $92c18975030ba628$var$localize = $92c18975030ba628$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $92c18975030ba628$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $92c18975030ba628$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $92c18975030ba628$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $92c18975030ba628$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $92c18975030ba628$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $92c18975030ba628$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $92c18975030ba628$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("dRwgN", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $a17941b4824a3165$export$4659b591c19bdf3d; }, function (v) { return $a17941b4824a3165$export$4659b591c19bdf3d = v; });
var $a17941b4824a3165$export$4659b591c19bdf3d;
"use strict";
$a17941b4824a3165$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $a17941b4824a3165$var$matchOrdinalNumberPattern = /^(\d+)(èr|nd|en)?[a]?/i;
const $a17941b4824a3165$var$parseOrdinalNumberPattern = /\d+/i;
const $a17941b4824a3165$var$matchEraPatterns = {
    narrow: /^(ab\.J\.C|apr\.J\.C|apr\.J\.-C)/i,
    abbreviated: /^(ab\.J\.-C|ab\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(abans Jèsus-Crist|après Jèsus-Crist)/i
};
const $a17941b4824a3165$var$parseEraPatterns = {
    any: [
        /^ab/i,
        /^ap/i
    ]
};
const $a17941b4824a3165$var$matchQuarterPatterns = {
    narrow: /^T[1234]/i,
    abbreviated: /^[1234](èr|nd|en)? trim\.?/i,
    wide: /^[1234](èr|nd|en)? trimèstre/i
};
const $a17941b4824a3165$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $a17941b4824a3165$var$matchMonthPatterns = {
    narrow: /^(GN|FB|MÇ|AB|MA|JN|JL|AG|ST|OC|NV|DC)/i,
    abbreviated: /^(gen|febr|març|abr|mai|junh|jul|ag|set|oct|nov|dec)\.?/i,
    wide: /^(genièr|febrièr|març|abril|mai|junh|julhet|agost|setembre|octòbre|novembre|decembre)/i
};
const $a17941b4824a3165$var$parseMonthPatterns = {
    any: [
        /^g/i,
        /^f/i,
        /^ma[r?]|MÇ/i,
        /^ab/i,
        /^ma[i?]/i,
        /^ju[n?]|JN/i,
        /^ju[l?]|JL/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $a17941b4824a3165$var$matchDayPatterns = {
    narrow: /^d[glmcjvs]\.?/i,
    short: /^d[glmcjvs]\.?/i,
    abbreviated: /^d[glmcjvs]\.?/i,
    wide: /^(dimenge|diluns|dimars|dimècres|dijòus|divendres|dissabte)/i
};
const $a17941b4824a3165$var$parseDayPatterns = {
    narrow: [
        /^dg/i,
        /^dl/i,
        /^dm/i,
        /^dc/i,
        /^dj/i,
        /^dv/i,
        /^ds/i
    ],
    short: [
        /^dg/i,
        /^dl/i,
        /^dm/i,
        /^dc/i,
        /^dj/i,
        /^dv/i,
        /^ds/i
    ],
    abbreviated: [
        /^dg/i,
        /^dl/i,
        /^dm/i,
        /^dc/i,
        /^dj/i,
        /^dv/i,
        /^ds/i
    ],
    any: [
        /^dg|dime/i,
        /^dl|dil/i,
        /^dm|dima/i,
        /^dc|dimè/i,
        /^dj|dij/i,
        /^dv|div/i,
        /^ds|dis/i
    ]
};
const $a17941b4824a3165$var$matchDayPeriodPatterns = {
    any: /(^(a\.?m|p\.?m))|(ante meridiem|post meridiem)|((del |de la |de l’)(matin|aprèp-miègjorn|vèspre|ser|nuèch))/i
};
const $a17941b4824a3165$var$parseDayPeriodPatterns = {
    any: {
        am: /(^a)|ante meridiem/i,
        pm: /(^p)|post meridiem/i,
        midnight: /^mièj/i,
        noon: /^mièg/i,
        morning: /matin/i,
        afternoon: /aprèp-miègjorn/i,
        evening: /vèspre|ser/i,
        night: /nuèch/i
    }
};
const $a17941b4824a3165$var$match = $a17941b4824a3165$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $a17941b4824a3165$var$matchOrdinalNumberPattern,
        parsePattern: $a17941b4824a3165$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $a17941b4824a3165$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a17941b4824a3165$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $a17941b4824a3165$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a17941b4824a3165$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $a17941b4824a3165$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a17941b4824a3165$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $a17941b4824a3165$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a17941b4824a3165$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $a17941b4824a3165$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $a17941b4824a3165$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("5dgYM", function(module, exports) {

$parcel$export(module.exports, "pl", function () { return $3cbb566747d94e6f$export$6ea5311eda92944f; }, function (v) { return $3cbb566747d94e6f$export$6ea5311eda92944f = v; });
var $3cbb566747d94e6f$export$6ea5311eda92944f;
"use strict";
$3cbb566747d94e6f$export$6ea5311eda92944f = void 0;

var $6SPe6 = parcelRequire("6SPe6");

var $j4RDj = parcelRequire("j4RDj");

var $k8iUd = parcelRequire("k8iUd");

var $4fdia = parcelRequire("4fdia");

var $jYlc3 = parcelRequire("jYlc3");
/**
 * @category Locales
 * @summary Polish locale.
 * @language Polish
 * @iso-639-2 pol
 * @author Mateusz Derks [@ertrzyiks](https://github.com/ertrzyiks)
 * @author Just RAG [@justrag](https://github.com/justrag)
 * @author Mikolaj Grzyb [@mikolajgrzyb](https://github.com/mikolajgrzyb)
 * @author Mateusz Tokarski [@mutisz](https://github.com/mutisz)
 */ const $3cbb566747d94e6f$var$pl = $3cbb566747d94e6f$export$6ea5311eda92944f = {
    code: "pl",
    formatDistance: $6SPe6.formatDistance,
    formatLong: $j4RDj.formatLong,
    formatRelative: $k8iUd.formatRelative,
    localize: $4fdia.localize,
    match: $jYlc3.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("6SPe6", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $502f85b4f9132a30$export$2c14ff85d6318973; }, function (v) { return $502f85b4f9132a30$export$2c14ff85d6318973 = v; });
var $502f85b4f9132a30$export$2c14ff85d6318973;
"use strict";
$502f85b4f9132a30$export$2c14ff85d6318973 = void 0;
const $502f85b4f9132a30$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            regular: "mniej ni\u017C sekunda",
            past: "mniej ni\u017C sekund\u0119",
            future: "mniej ni\u017C sekund\u0119"
        },
        twoFour: "mniej ni\u017C {{count}} sekundy",
        other: "mniej ni\u017C {{count}} sekund"
    },
    xSeconds: {
        one: {
            regular: "sekunda",
            past: "sekund\u0119",
            future: "sekund\u0119"
        },
        twoFour: "{{count}} sekundy",
        other: "{{count}} sekund"
    },
    halfAMinute: {
        one: "p\xf3\u0142 minuty",
        twoFour: "p\xf3\u0142 minuty",
        other: "p\xf3\u0142 minuty"
    },
    lessThanXMinutes: {
        one: {
            regular: "mniej ni\u017C minuta",
            past: "mniej ni\u017C minut\u0119",
            future: "mniej ni\u017C minut\u0119"
        },
        twoFour: "mniej ni\u017C {{count}} minuty",
        other: "mniej ni\u017C {{count}} minut"
    },
    xMinutes: {
        one: {
            regular: "minuta",
            past: "minut\u0119",
            future: "minut\u0119"
        },
        twoFour: "{{count}} minuty",
        other: "{{count}} minut"
    },
    aboutXHours: {
        one: {
            regular: "oko\u0142o godziny",
            past: "oko\u0142o godziny",
            future: "oko\u0142o godzin\u0119"
        },
        twoFour: "oko\u0142o {{count}} godziny",
        other: "oko\u0142o {{count}} godzin"
    },
    xHours: {
        one: {
            regular: "godzina",
            past: "godzin\u0119",
            future: "godzin\u0119"
        },
        twoFour: "{{count}} godziny",
        other: "{{count}} godzin"
    },
    xDays: {
        one: {
            regular: "dzie\u0144",
            past: "dzie\u0144",
            future: "1 dzie\u0144"
        },
        twoFour: "{{count}} dni",
        other: "{{count}} dni"
    },
    aboutXWeeks: {
        one: "oko\u0142o tygodnia",
        twoFour: "oko\u0142o {{count}} tygodni",
        other: "oko\u0142o {{count}} tygodni"
    },
    xWeeks: {
        one: "tydzie\u0144",
        twoFour: "{{count}} tygodnie",
        other: "{{count}} tygodni"
    },
    aboutXMonths: {
        one: "oko\u0142o miesi\u0105c",
        twoFour: "oko\u0142o {{count}} miesi\u0105ce",
        other: "oko\u0142o {{count}} miesi\u0119cy"
    },
    xMonths: {
        one: "miesi\u0105c",
        twoFour: "{{count}} miesi\u0105ce",
        other: "{{count}} miesi\u0119cy"
    },
    aboutXYears: {
        one: "oko\u0142o rok",
        twoFour: "oko\u0142o {{count}} lata",
        other: "oko\u0142o {{count}} lat"
    },
    xYears: {
        one: "rok",
        twoFour: "{{count}} lata",
        other: "{{count}} lat"
    },
    overXYears: {
        one: "ponad rok",
        twoFour: "ponad {{count}} lata",
        other: "ponad {{count}} lat"
    },
    almostXYears: {
        one: "prawie rok",
        twoFour: "prawie {{count}} lata",
        other: "prawie {{count}} lat"
    }
};
function $502f85b4f9132a30$var$declensionGroup(scheme, count) {
    if (count === 1) return scheme.one;
    const rem100 = count % 100;
    // ends with 11-20
    if (rem100 <= 20 && rem100 > 10) return scheme.other;
    const rem10 = rem100 % 10;
    // ends with 2, 3, 4
    if (rem10 >= 2 && rem10 <= 4) return scheme.twoFour;
    return scheme.other;
}
function $502f85b4f9132a30$var$declension(scheme, count, time) {
    const group = $502f85b4f9132a30$var$declensionGroup(scheme, count);
    const finalText = typeof group === "string" ? group : group[time];
    return finalText.replace("{{count}}", String(count));
}
const $502f85b4f9132a30$var$formatDistance = (token, count, options)=>{
    const scheme = $502f85b4f9132a30$var$formatDistanceLocale[token];
    if (!options?.addSuffix) return $502f85b4f9132a30$var$declension(scheme, count, "regular");
    if (options.comparison && options.comparison > 0) return "za " + $502f85b4f9132a30$var$declension(scheme, count, "future");
    else return $502f85b4f9132a30$var$declension(scheme, count, "past") + " temu";
};
$502f85b4f9132a30$export$2c14ff85d6318973 = $502f85b4f9132a30$var$formatDistance;

});

parcelRegister("j4RDj", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $de37fe6f30bdfc19$export$cbf60ecb96cbb82f; }, function (v) { return $de37fe6f30bdfc19$export$cbf60ecb96cbb82f = v; });
var $de37fe6f30bdfc19$export$cbf60ecb96cbb82f;
"use strict";
$de37fe6f30bdfc19$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $de37fe6f30bdfc19$var$dateFormats = {
    full: "EEEE, do MMMM y",
    long: "do MMMM y",
    medium: "do MMM y",
    short: "dd.MM.y"
};
const $de37fe6f30bdfc19$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $de37fe6f30bdfc19$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $de37fe6f30bdfc19$var$formatLong = $de37fe6f30bdfc19$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $de37fe6f30bdfc19$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $de37fe6f30bdfc19$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $de37fe6f30bdfc19$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("k8iUd", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $ea83384e12f34a5f$export$8fbbfd65594f46a0; }, function (v) { return $ea83384e12f34a5f$export$8fbbfd65594f46a0 = v; });
var $ea83384e12f34a5f$export$8fbbfd65594f46a0;
"use strict";
$ea83384e12f34a5f$export$8fbbfd65594f46a0 = void 0;

var $9VRW1 = parcelRequire("9VRW1");
const $ea83384e12f34a5f$var$adjectivesLastWeek = {
    masculine: "ostatni",
    feminine: "ostatnia"
};
const $ea83384e12f34a5f$var$adjectivesThisWeek = {
    masculine: "ten",
    feminine: "ta"
};
const $ea83384e12f34a5f$var$adjectivesNextWeek = {
    masculine: "nast\u0119pny",
    feminine: "nast\u0119pna"
};
const $ea83384e12f34a5f$var$dayGrammaticalGender = {
    0: "feminine",
    1: "masculine",
    2: "masculine",
    3: "feminine",
    4: "masculine",
    5: "masculine",
    6: "feminine"
};
function $ea83384e12f34a5f$var$dayAndTimeWithAdjective(token, date, baseDate, options) {
    let adjectives;
    if ((0, $9VRW1.isSameWeek)(date, baseDate, options)) adjectives = $ea83384e12f34a5f$var$adjectivesThisWeek;
    else if (token === "lastWeek") adjectives = $ea83384e12f34a5f$var$adjectivesLastWeek;
    else if (token === "nextWeek") adjectives = $ea83384e12f34a5f$var$adjectivesNextWeek;
    else throw new Error(`Cannot determine adjectives for token ${token}`);
    const day = date.getDay();
    const grammaticalGender = $ea83384e12f34a5f$var$dayGrammaticalGender[day];
    const adjective = adjectives[grammaticalGender];
    return `'${adjective}' eeee 'o' p`;
}
const $ea83384e12f34a5f$var$formatRelativeLocale = {
    lastWeek: $ea83384e12f34a5f$var$dayAndTimeWithAdjective,
    yesterday: "'wczoraj o' p",
    today: "'dzisiaj o' p",
    tomorrow: "'jutro o' p",
    nextWeek: $ea83384e12f34a5f$var$dayAndTimeWithAdjective,
    other: "P"
};
const $ea83384e12f34a5f$var$formatRelative = (token, date, baseDate, options)=>{
    const format = $ea83384e12f34a5f$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(token, date, baseDate, options);
    return format;
};
$ea83384e12f34a5f$export$8fbbfd65594f46a0 = $ea83384e12f34a5f$var$formatRelative;

});

parcelRegister("4fdia", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $3172dfab1c4c095e$export$b3bd0bc58e36cd63; }, function (v) { return $3172dfab1c4c095e$export$b3bd0bc58e36cd63 = v; });
var $3172dfab1c4c095e$export$b3bd0bc58e36cd63;
"use strict";
$3172dfab1c4c095e$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $3172dfab1c4c095e$var$eraValues = {
    narrow: [
        "p.n.e.",
        "n.e."
    ],
    abbreviated: [
        "p.n.e.",
        "n.e."
    ],
    wide: [
        "przed nasz\u0105 er\u0105",
        "naszej ery"
    ]
};
const $3172dfab1c4c095e$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "I kw.",
        "II kw.",
        "III kw.",
        "IV kw."
    ],
    wide: [
        "I kwarta\u0142",
        "II kwarta\u0142",
        "III kwarta\u0142",
        "IV kwarta\u0142"
    ]
};
const $3172dfab1c4c095e$var$monthValues = {
    narrow: [
        "S",
        "L",
        "M",
        "K",
        "M",
        "C",
        "L",
        "S",
        "W",
        "P",
        "L",
        "G"
    ],
    abbreviated: [
        "sty",
        "lut",
        "mar",
        "kwi",
        "maj",
        "cze",
        "lip",
        "sie",
        "wrz",
        "pa\u017A",
        "lis",
        "gru"
    ],
    wide: [
        "stycze\u0144",
        "luty",
        "marzec",
        "kwiecie\u0144",
        "maj",
        "czerwiec",
        "lipiec",
        "sierpie\u0144",
        "wrzesie\u0144",
        "pa\u017Adziernik",
        "listopad",
        "grudzie\u0144"
    ]
};
const $3172dfab1c4c095e$var$monthFormattingValues = {
    narrow: [
        "s",
        "l",
        "m",
        "k",
        "m",
        "c",
        "l",
        "s",
        "w",
        "p",
        "l",
        "g"
    ],
    abbreviated: [
        "sty",
        "lut",
        "mar",
        "kwi",
        "maj",
        "cze",
        "lip",
        "sie",
        "wrz",
        "pa\u017A",
        "lis",
        "gru"
    ],
    wide: [
        "stycznia",
        "lutego",
        "marca",
        "kwietnia",
        "maja",
        "czerwca",
        "lipca",
        "sierpnia",
        "wrze\u015Bnia",
        "pa\u017Adziernika",
        "listopada",
        "grudnia"
    ]
};
const $3172dfab1c4c095e$var$dayValues = {
    narrow: [
        "N",
        "P",
        "W",
        "\u015A",
        "C",
        "P",
        "S"
    ],
    short: [
        "nie",
        "pon",
        "wto",
        "\u015Bro",
        "czw",
        "pi\u0105",
        "sob"
    ],
    abbreviated: [
        "niedz.",
        "pon.",
        "wt.",
        "\u015Br.",
        "czw.",
        "pt.",
        "sob."
    ],
    wide: [
        "niedziela",
        "poniedzia\u0142ek",
        "wtorek",
        "\u015Broda",
        "czwartek",
        "pi\u0105tek",
        "sobota"
    ]
};
const $3172dfab1c4c095e$var$dayFormattingValues = {
    narrow: [
        "n",
        "p",
        "w",
        "\u015B",
        "c",
        "p",
        "s"
    ],
    short: [
        "nie",
        "pon",
        "wto",
        "\u015Bro",
        "czw",
        "pi\u0105",
        "sob"
    ],
    abbreviated: [
        "niedz.",
        "pon.",
        "wt.",
        "\u015Br.",
        "czw.",
        "pt.",
        "sob."
    ],
    wide: [
        "niedziela",
        "poniedzia\u0142ek",
        "wtorek",
        "\u015Broda",
        "czwartek",
        "pi\u0105tek",
        "sobota"
    ]
};
const $3172dfab1c4c095e$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "p\xf3\u0142n.",
        noon: "po\u0142",
        morning: "rano",
        afternoon: "popo\u0142.",
        evening: "wiecz.",
        night: "noc"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "p\xf3\u0142noc",
        noon: "po\u0142udnie",
        morning: "rano",
        afternoon: "popo\u0142udnie",
        evening: "wiecz\xf3r",
        night: "noc"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "p\xf3\u0142noc",
        noon: "po\u0142udnie",
        morning: "rano",
        afternoon: "popo\u0142udnie",
        evening: "wiecz\xf3r",
        night: "noc"
    }
};
const $3172dfab1c4c095e$var$dayPeriodFormattingValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "o p\xf3\u0142n.",
        noon: "w po\u0142.",
        morning: "rano",
        afternoon: "po po\u0142.",
        evening: "wiecz.",
        night: "w nocy"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "o p\xf3\u0142nocy",
        noon: "w po\u0142udnie",
        morning: "rano",
        afternoon: "po po\u0142udniu",
        evening: "wieczorem",
        night: "w nocy"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "o p\xf3\u0142nocy",
        noon: "w po\u0142udnie",
        morning: "rano",
        afternoon: "po po\u0142udniu",
        evening: "wieczorem",
        night: "w nocy"
    }
};
const $3172dfab1c4c095e$var$ordinalNumber = (dirtyNumber, _options)=>{
    return String(dirtyNumber);
};
const $3172dfab1c4c095e$var$localize = $3172dfab1c4c095e$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $3172dfab1c4c095e$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $3172dfab1c4c095e$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $3172dfab1c4c095e$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $3172dfab1c4c095e$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $3172dfab1c4c095e$var$monthFormattingValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $3172dfab1c4c095e$var$dayValues,
        defaultWidth: "wide",
        formattingValues: $3172dfab1c4c095e$var$dayFormattingValues,
        defaultFormattingWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $3172dfab1c4c095e$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $3172dfab1c4c095e$var$dayPeriodFormattingValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("jYlc3", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $e8a40f808f455045$export$4659b591c19bdf3d; }, function (v) { return $e8a40f808f455045$export$4659b591c19bdf3d = v; });
var $e8a40f808f455045$export$4659b591c19bdf3d;
"use strict";
$e8a40f808f455045$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $e8a40f808f455045$var$matchOrdinalNumberPattern = /^(\d+)?/i;
const $e8a40f808f455045$var$parseOrdinalNumberPattern = /\d+/i;
const $e8a40f808f455045$var$matchEraPatterns = {
    narrow: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
    abbreviated: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
    wide: /^(przed\s*nasz(ą|a)\s*er(ą|a)|naszej\s*ery)/i
};
const $e8a40f808f455045$var$parseEraPatterns = {
    any: [
        /^p/i,
        /^n/i
    ]
};
const $e8a40f808f455045$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^(I|II|III|IV)\s*kw\.?/i,
    wide: /^(I|II|III|IV)\s*kwarta(ł|l)/i
};
const $e8a40f808f455045$var$parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /^I kw/i,
        /^II kw/i,
        /^III kw/i,
        /^IV kw/i
    ]
};
const $e8a40f808f455045$var$matchMonthPatterns = {
    narrow: /^[slmkcwpg]/i,
    abbreviated: /^(sty|lut|mar|kwi|maj|cze|lip|sie|wrz|pa(ź|z)|lis|gru)/i,
    wide: /^(stycznia|stycze(ń|n)|lutego|luty|marca|marzec|kwietnia|kwiecie(ń|n)|maja|maj|czerwca|czerwiec|lipca|lipiec|sierpnia|sierpie(ń|n)|wrze(ś|s)nia|wrzesie(ń|n)|pa(ź|z)dziernika|pa(ź|z)dziernik|listopada|listopad|grudnia|grudzie(ń|n))/i
};
const $e8a40f808f455045$var$parseMonthPatterns = {
    narrow: [
        /^s/i,
        /^l/i,
        /^m/i,
        /^k/i,
        /^m/i,
        /^c/i,
        /^l/i,
        /^s/i,
        /^w/i,
        /^p/i,
        /^l/i,
        /^g/i
    ],
    any: [
        /^st/i,
        /^lu/i,
        /^mar/i,
        /^k/i,
        /^maj/i,
        /^c/i,
        /^lip/i,
        /^si/i,
        /^w/i,
        /^p/i,
        /^lis/i,
        /^g/i
    ]
};
const $e8a40f808f455045$var$matchDayPatterns = {
    narrow: /^[npwścs]/i,
    short: /^(nie|pon|wto|(ś|s)ro|czw|pi(ą|a)|sob)/i,
    abbreviated: /^(niedz|pon|wt|(ś|s)r|czw|pt|sob)\.?/i,
    wide: /^(niedziela|poniedzia(ł|l)ek|wtorek|(ś|s)roda|czwartek|pi(ą|a)tek|sobota)/i
};
const $e8a40f808f455045$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^w/i,
        /^ś/i,
        /^c/i,
        /^p/i,
        /^s/i
    ],
    abbreviated: [
        /^n/i,
        /^po/i,
        /^w/i,
        /^(ś|s)r/i,
        /^c/i,
        /^pt/i,
        /^so/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^w/i,
        /^(ś|s)r/i,
        /^c/i,
        /^pi/i,
        /^so/i
    ]
};
const $e8a40f808f455045$var$matchDayPeriodPatterns = {
    narrow: /^(^a$|^p$|pó(ł|l)n\.?|o\s*pó(ł|l)n\.?|po(ł|l)\.?|w\s*po(ł|l)\.?|po\s*po(ł|l)\.?|rano|wiecz\.?|noc|w\s*nocy)/i,
    any: /^(am|pm|pó(ł|l)noc|o\s*pó(ł|l)nocy|po(ł|l)udnie|w\s*po(ł|l)udnie|popo(ł|l)udnie|po\s*po(ł|l)udniu|rano|wieczór|wieczorem|noc|w\s*nocy)/i
};
const $e8a40f808f455045$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^a$/i,
        pm: /^p$/i,
        midnight: /pó(ł|l)n/i,
        noon: /po(ł|l)/i,
        morning: /rano/i,
        afternoon: /po\s*po(ł|l)/i,
        evening: /wiecz/i,
        night: /noc/i
    },
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /pó(ł|l)n/i,
        noon: /po(ł|l)/i,
        morning: /rano/i,
        afternoon: /po\s*po(ł|l)/i,
        evening: /wiecz/i,
        night: /noc/i
    }
};
const $e8a40f808f455045$var$match = $e8a40f808f455045$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $e8a40f808f455045$var$matchOrdinalNumberPattern,
        parsePattern: $e8a40f808f455045$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e8a40f808f455045$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e8a40f808f455045$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e8a40f808f455045$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e8a40f808f455045$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e8a40f808f455045$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e8a40f808f455045$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e8a40f808f455045$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e8a40f808f455045$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e8a40f808f455045$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $e8a40f808f455045$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("7dlru", function(module, exports) {

$parcel$export(module.exports, "pt", function () { return $540a614f2f5a150a$export$84175d5f1cb4e39d; }, function (v) { return $540a614f2f5a150a$export$84175d5f1cb4e39d = v; });
var $540a614f2f5a150a$export$84175d5f1cb4e39d;
"use strict";
$540a614f2f5a150a$export$84175d5f1cb4e39d = void 0;

var $kf5SH = parcelRequire("kf5SH");

var $3EBUH = parcelRequire("3EBUH");

var $bzeJZ = parcelRequire("bzeJZ");

var $3LdFW = parcelRequire("3LdFW");

var $caBHz = parcelRequire("caBHz");
/**
 * @category Locales
 * @summary Portuguese locale.
 * @language Portuguese
 * @iso-639-2 por
 * @author Dário Freire [@dfreire](https://github.com/dfreire)
 * @author Adrián de la Rosa [@adrm](https://github.com/adrm)
 */ const $540a614f2f5a150a$var$pt = $540a614f2f5a150a$export$84175d5f1cb4e39d = {
    code: "pt",
    formatDistance: $kf5SH.formatDistance,
    formatLong: $3EBUH.formatLong,
    formatRelative: $bzeJZ.formatRelative,
    localize: $3LdFW.localize,
    match: $caBHz.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("kf5SH", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $ebc9c5459e4b963b$export$2c14ff85d6318973; }, function (v) { return $ebc9c5459e4b963b$export$2c14ff85d6318973 = v; });
var $ebc9c5459e4b963b$export$2c14ff85d6318973;
"use strict";
$ebc9c5459e4b963b$export$2c14ff85d6318973 = void 0;
const $ebc9c5459e4b963b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menos de um segundo",
        other: "menos de {{count}} segundos"
    },
    xSeconds: {
        one: "1 segundo",
        other: "{{count}} segundos"
    },
    halfAMinute: "meio minuto",
    lessThanXMinutes: {
        one: "menos de um minuto",
        other: "menos de {{count}} minutos"
    },
    xMinutes: {
        one: "1 minuto",
        other: "{{count}} minutos"
    },
    aboutXHours: {
        one: "aproximadamente 1 hora",
        other: "aproximadamente {{count}} horas"
    },
    xHours: {
        one: "1 hora",
        other: "{{count}} horas"
    },
    xDays: {
        one: "1 dia",
        other: "{{count}} dias"
    },
    aboutXWeeks: {
        one: "aproximadamente 1 semana",
        other: "aproximadamente {{count}} semanas"
    },
    xWeeks: {
        one: "1 semana",
        other: "{{count}} semanas"
    },
    aboutXMonths: {
        one: "aproximadamente 1 m\xeas",
        other: "aproximadamente {{count}} meses"
    },
    xMonths: {
        one: "1 m\xeas",
        other: "{{count}} meses"
    },
    aboutXYears: {
        one: "aproximadamente 1 ano",
        other: "aproximadamente {{count}} anos"
    },
    xYears: {
        one: "1 ano",
        other: "{{count}} anos"
    },
    overXYears: {
        one: "mais de 1 ano",
        other: "mais de {{count}} anos"
    },
    almostXYears: {
        one: "quase 1 ano",
        other: "quase {{count}} anos"
    }
};
const $ebc9c5459e4b963b$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $ebc9c5459e4b963b$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "daqui a " + result;
        else return "h\xe1 " + result;
    }
    return result;
};
$ebc9c5459e4b963b$export$2c14ff85d6318973 = $ebc9c5459e4b963b$var$formatDistance;

});

parcelRegister("3EBUH", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $2a92846186c39a60$export$cbf60ecb96cbb82f; }, function (v) { return $2a92846186c39a60$export$cbf60ecb96cbb82f = v; });
var $2a92846186c39a60$export$cbf60ecb96cbb82f;
"use strict";
$2a92846186c39a60$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $2a92846186c39a60$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d 'de' MMM 'de' y",
    short: "dd/MM/y"
};
const $2a92846186c39a60$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $2a92846186c39a60$var$dateTimeFormats = {
    full: "{{date}} '\xe0s' {{time}}",
    long: "{{date}} '\xe0s' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $2a92846186c39a60$var$formatLong = $2a92846186c39a60$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $2a92846186c39a60$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $2a92846186c39a60$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $2a92846186c39a60$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("bzeJZ", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $86be65cb620d0305$export$8fbbfd65594f46a0; }, function (v) { return $86be65cb620d0305$export$8fbbfd65594f46a0 = v; });
var $86be65cb620d0305$export$8fbbfd65594f46a0;
"use strict";
$86be65cb620d0305$export$8fbbfd65594f46a0 = void 0;
const $86be65cb620d0305$var$formatRelativeLocale = {
    lastWeek: (date)=>{
        const weekday = date.getDay();
        const last = weekday === 0 || weekday === 6 ? "\xfaltimo" : "\xfaltima";
        return "'" + last + "' eeee '\xe0s' p";
    },
    yesterday: "'ontem \xe0s' p",
    today: "'hoje \xe0s' p",
    tomorrow: "'amanh\xe3 \xe0s' p",
    nextWeek: "eeee '\xe0s' p",
    other: "P"
};
const $86be65cb620d0305$var$formatRelative = (token, date, _baseDate, _options)=>{
    const format = $86be65cb620d0305$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
$86be65cb620d0305$export$8fbbfd65594f46a0 = $86be65cb620d0305$var$formatRelative;

});

parcelRegister("3LdFW", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $2bd05e8b400a8528$export$b3bd0bc58e36cd63; }, function (v) { return $2bd05e8b400a8528$export$b3bd0bc58e36cd63 = v; });
var $2bd05e8b400a8528$export$b3bd0bc58e36cd63;
"use strict";
$2bd05e8b400a8528$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $2bd05e8b400a8528$var$eraValues = {
    narrow: [
        "aC",
        "dC"
    ],
    abbreviated: [
        "a.C.",
        "d.C."
    ],
    wide: [
        "antes de Cristo",
        "depois de Cristo"
    ]
};
const $2bd05e8b400a8528$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
const $2bd05e8b400a8528$var$monthValues = {
    narrow: [
        "j",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "jan",
        "fev",
        "mar",
        "abr",
        "mai",
        "jun",
        "jul",
        "ago",
        "set",
        "out",
        "nov",
        "dez"
    ],
    wide: [
        "janeiro",
        "fevereiro",
        "mar\xe7o",
        "abril",
        "maio",
        "junho",
        "julho",
        "agosto",
        "setembro",
        "outubro",
        "novembro",
        "dezembro"
    ]
};
const $2bd05e8b400a8528$var$dayValues = {
    narrow: [
        "d",
        "s",
        "t",
        "q",
        "q",
        "s",
        "s"
    ],
    short: [
        "dom",
        "seg",
        "ter",
        "qua",
        "qui",
        "sex",
        "s\xe1b"
    ],
    abbreviated: [
        "dom",
        "seg",
        "ter",
        "qua",
        "qui",
        "sex",
        "s\xe1b"
    ],
    wide: [
        "domingo",
        "segunda-feira",
        "ter\xe7a-feira",
        "quarta-feira",
        "quinta-feira",
        "sexta-feira",
        "s\xe1bado"
    ]
};
const $2bd05e8b400a8528$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "noite",
        night: "madrugada"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "noite",
        night: "madrugada"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "noite",
        night: "madrugada"
    }
};
const $2bd05e8b400a8528$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da noite",
        night: "da madrugada"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da noite",
        night: "da madrugada"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da noite",
        night: "da madrugada"
    }
};
const $2bd05e8b400a8528$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + "\xba";
};
const $2bd05e8b400a8528$var$localize = $2bd05e8b400a8528$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $2bd05e8b400a8528$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $2bd05e8b400a8528$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $2bd05e8b400a8528$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $2bd05e8b400a8528$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $2bd05e8b400a8528$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $2bd05e8b400a8528$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $2bd05e8b400a8528$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("caBHz", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $8dc3aa034f866b13$export$4659b591c19bdf3d; }, function (v) { return $8dc3aa034f866b13$export$4659b591c19bdf3d = v; });
var $8dc3aa034f866b13$export$4659b591c19bdf3d;
"use strict";
$8dc3aa034f866b13$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $8dc3aa034f866b13$var$matchOrdinalNumberPattern = /^(\d+)(º|ª)?/i;
const $8dc3aa034f866b13$var$parseOrdinalNumberPattern = /\d+/i;
const $8dc3aa034f866b13$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
};
const $8dc3aa034f866b13$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes da era comum)/i,
        /^(depois de cristo|era comum)/i
    ]
};
const $8dc3aa034f866b13$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º|ª)? trimestre/i
};
const $8dc3aa034f866b13$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $8dc3aa034f866b13$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
const $8dc3aa034f866b13$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ab/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $8dc3aa034f866b13$var$matchDayPatterns = {
    narrow: /^[dstq]/i,
    short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
};
const $8dc3aa034f866b13$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^s/i,
        /^t/i,
        /^q/i,
        /^q/i,
        /^s/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^seg/i,
        /^t/i,
        /^qua/i,
        /^qui/i,
        /^sex/i,
        /^s[áa]/i
    ]
};
const $8dc3aa034f866b13$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
    any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
};
const $8dc3aa034f866b13$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^meia/i,
        noon: /^meio/i,
        morning: /manh[ãa]/i,
        afternoon: /tarde/i,
        evening: /noite/i,
        night: /madrugada/i
    }
};
const $8dc3aa034f866b13$var$match = $8dc3aa034f866b13$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $8dc3aa034f866b13$var$matchOrdinalNumberPattern,
        parsePattern: $8dc3aa034f866b13$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $8dc3aa034f866b13$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8dc3aa034f866b13$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $8dc3aa034f866b13$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8dc3aa034f866b13$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $8dc3aa034f866b13$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8dc3aa034f866b13$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $8dc3aa034f866b13$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8dc3aa034f866b13$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $8dc3aa034f866b13$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $8dc3aa034f866b13$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("d6ZAI", function(module, exports) {

$parcel$export(module.exports, "ptBR", function () { return $98bb9c9ad59b3dca$export$93dd81123f5ddbcd; }, function (v) { return $98bb9c9ad59b3dca$export$93dd81123f5ddbcd = v; });
var $98bb9c9ad59b3dca$export$93dd81123f5ddbcd;
"use strict";
$98bb9c9ad59b3dca$export$93dd81123f5ddbcd = void 0;

var $aw0Nu = parcelRequire("aw0Nu");

var $8YvRi = parcelRequire("8YvRi");

var $4xEy0 = parcelRequire("4xEy0");

var $bWGk7 = parcelRequire("bWGk7");

var $gYqH5 = parcelRequire("gYqH5");
/**
 * @category Locales
 * @summary Portuguese locale (Brazil).
 * @language Portuguese
 * @iso-639-2 por
 * @author Lucas Duailibe [@duailibe](https://github.com/duailibe)
 * @author Yago Carballo [@yagocarballo](https://github.com/YagoCarballo)
 */ const $98bb9c9ad59b3dca$var$ptBR = $98bb9c9ad59b3dca$export$93dd81123f5ddbcd = {
    code: "pt-BR",
    formatDistance: $aw0Nu.formatDistance,
    formatLong: $8YvRi.formatLong,
    formatRelative: $4xEy0.formatRelative,
    localize: $bWGk7.localize,
    match: $gYqH5.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("aw0Nu", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $7a7d82d434156928$export$2c14ff85d6318973; }, function (v) { return $7a7d82d434156928$export$2c14ff85d6318973 = v; });
var $7a7d82d434156928$export$2c14ff85d6318973;
"use strict";
$7a7d82d434156928$export$2c14ff85d6318973 = void 0;
const $7a7d82d434156928$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menos de um segundo",
        other: "menos de {{count}} segundos"
    },
    xSeconds: {
        one: "1 segundo",
        other: "{{count}} segundos"
    },
    halfAMinute: "meio minuto",
    lessThanXMinutes: {
        one: "menos de um minuto",
        other: "menos de {{count}} minutos"
    },
    xMinutes: {
        one: "1 minuto",
        other: "{{count}} minutos"
    },
    aboutXHours: {
        one: "cerca de 1 hora",
        other: "cerca de {{count}} horas"
    },
    xHours: {
        one: "1 hora",
        other: "{{count}} horas"
    },
    xDays: {
        one: "1 dia",
        other: "{{count}} dias"
    },
    aboutXWeeks: {
        one: "cerca de 1 semana",
        other: "cerca de {{count}} semanas"
    },
    xWeeks: {
        one: "1 semana",
        other: "{{count}} semanas"
    },
    aboutXMonths: {
        one: "cerca de 1 m\xeas",
        other: "cerca de {{count}} meses"
    },
    xMonths: {
        one: "1 m\xeas",
        other: "{{count}} meses"
    },
    aboutXYears: {
        one: "cerca de 1 ano",
        other: "cerca de {{count}} anos"
    },
    xYears: {
        one: "1 ano",
        other: "{{count}} anos"
    },
    overXYears: {
        one: "mais de 1 ano",
        other: "mais de {{count}} anos"
    },
    almostXYears: {
        one: "quase 1 ano",
        other: "quase {{count}} anos"
    }
};
const $7a7d82d434156928$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $7a7d82d434156928$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "em " + result;
        else return "h\xe1 " + result;
    }
    return result;
};
$7a7d82d434156928$export$2c14ff85d6318973 = $7a7d82d434156928$var$formatDistance;

});

parcelRegister("8YvRi", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $688ca3c3c6d18b05$export$cbf60ecb96cbb82f; }, function (v) { return $688ca3c3c6d18b05$export$cbf60ecb96cbb82f = v; });
var $688ca3c3c6d18b05$export$cbf60ecb96cbb82f;
"use strict";
$688ca3c3c6d18b05$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $688ca3c3c6d18b05$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d MMM y",
    short: "dd/MM/yyyy"
};
const $688ca3c3c6d18b05$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $688ca3c3c6d18b05$var$dateTimeFormats = {
    full: "{{date}} '\xe0s' {{time}}",
    long: "{{date}} '\xe0s' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $688ca3c3c6d18b05$var$formatLong = $688ca3c3c6d18b05$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $688ca3c3c6d18b05$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $688ca3c3c6d18b05$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $688ca3c3c6d18b05$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("4xEy0", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $34e9b26140239cc2$export$8fbbfd65594f46a0; }, function (v) { return $34e9b26140239cc2$export$8fbbfd65594f46a0 = v; });
var $34e9b26140239cc2$export$8fbbfd65594f46a0;
"use strict";
$34e9b26140239cc2$export$8fbbfd65594f46a0 = void 0;
const $34e9b26140239cc2$var$formatRelativeLocale = {
    lastWeek: (date)=>{
        const weekday = date.getDay();
        const last = weekday === 0 || weekday === 6 ? "\xfaltimo" : "\xfaltima";
        return "'" + last + "' eeee '\xe0s' p";
    },
    yesterday: "'ontem \xe0s' p",
    today: "'hoje \xe0s' p",
    tomorrow: "'amanh\xe3 \xe0s' p",
    nextWeek: "eeee '\xe0s' p",
    other: "P"
};
const $34e9b26140239cc2$var$formatRelative = (token, date, _baseDate, _options)=>{
    const format = $34e9b26140239cc2$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
$34e9b26140239cc2$export$8fbbfd65594f46a0 = $34e9b26140239cc2$var$formatRelative;

});

parcelRegister("bWGk7", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $8b25f1134fe95472$export$b3bd0bc58e36cd63; }, function (v) { return $8b25f1134fe95472$export$b3bd0bc58e36cd63 = v; });
var $8b25f1134fe95472$export$b3bd0bc58e36cd63;
"use strict";
$8b25f1134fe95472$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $8b25f1134fe95472$var$eraValues = {
    narrow: [
        "AC",
        "DC"
    ],
    abbreviated: [
        "AC",
        "DC"
    ],
    wide: [
        "antes de cristo",
        "depois de cristo"
    ]
};
const $8b25f1134fe95472$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
const $8b25f1134fe95472$var$monthValues = {
    narrow: [
        "j",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "jan",
        "fev",
        "mar",
        "abr",
        "mai",
        "jun",
        "jul",
        "ago",
        "set",
        "out",
        "nov",
        "dez"
    ],
    wide: [
        "janeiro",
        "fevereiro",
        "mar\xe7o",
        "abril",
        "maio",
        "junho",
        "julho",
        "agosto",
        "setembro",
        "outubro",
        "novembro",
        "dezembro"
    ]
};
const $8b25f1134fe95472$var$dayValues = {
    narrow: [
        "D",
        "S",
        "T",
        "Q",
        "Q",
        "S",
        "S"
    ],
    short: [
        "dom",
        "seg",
        "ter",
        "qua",
        "qui",
        "sex",
        "sab"
    ],
    abbreviated: [
        "domingo",
        "segunda",
        "ter\xe7a",
        "quarta",
        "quinta",
        "sexta",
        "s\xe1bado"
    ],
    wide: [
        "domingo",
        "segunda-feira",
        "ter\xe7a-feira",
        "quarta-feira",
        "quinta-feira",
        "sexta-feira",
        "s\xe1bado"
    ]
};
const $8b25f1134fe95472$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "tarde",
        night: "noite"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "tarde",
        night: "noite"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "tarde",
        night: "noite"
    }
};
const $8b25f1134fe95472$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da tarde",
        night: "da noite"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da tarde",
        night: "da noite"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da tarde",
        night: "da noite"
    }
};
const $8b25f1134fe95472$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    if (options?.unit === "week") return number + "\xaa";
    return number + "\xba";
};
const $8b25f1134fe95472$var$localize = $8b25f1134fe95472$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $8b25f1134fe95472$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $8b25f1134fe95472$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $8b25f1134fe95472$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $8b25f1134fe95472$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $8b25f1134fe95472$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $8b25f1134fe95472$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $8b25f1134fe95472$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("gYqH5", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $c5b6f4cb0a5e2c2d$export$4659b591c19bdf3d; }, function (v) { return $c5b6f4cb0a5e2c2d$export$4659b591c19bdf3d = v; });
var $c5b6f4cb0a5e2c2d$export$4659b591c19bdf3d;
"use strict";
$c5b6f4cb0a5e2c2d$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $c5b6f4cb0a5e2c2d$var$matchOrdinalNumberPattern = /^(\d+)[ºªo]?/i;
const $c5b6f4cb0a5e2c2d$var$parseOrdinalNumberPattern = /\d+/i;
const $c5b6f4cb0a5e2c2d$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
    wide: /^(antes de cristo|depois de cristo)/i
};
const $c5b6f4cb0a5e2c2d$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^antes de cristo/i,
        /^depois de cristo/i
    ]
};
const $c5b6f4cb0a5e2c2d$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
const $c5b6f4cb0a5e2c2d$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $c5b6f4cb0a5e2c2d$var$matchMonthPatterns = {
    narrow: /^[jfmajsond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
const $c5b6f4cb0a5e2c2d$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^fev/i,
        /^mar/i,
        /^abr/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^set/i,
        /^out/i,
        /^nov/i,
        /^dez/i
    ]
};
const $c5b6f4cb0a5e2c2d$var$matchDayPatterns = {
    narrow: /^(dom|[23456]ª?|s[aá]b)/i,
    short: /^(dom|[23456]ª?|s[aá]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
    wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
};
const $c5b6f4cb0a5e2c2d$var$parseDayPatterns = {
    short: [
        /^d/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^s[aá]/i
    ],
    narrow: [
        /^d/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^s[aá]/i
    ],
    any: [
        /^d/i,
        /^seg/i,
        /^t/i,
        /^qua/i,
        /^qui/i,
        /^sex/i,
        /^s[aá]b/i
    ]
};
const $c5b6f4cb0a5e2c2d$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
    any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
};
const $c5b6f4cb0a5e2c2d$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn|^meia[-\s]noite/i,
        noon: /^md|^meio[-\s]dia/i,
        morning: /manhã/i,
        afternoon: /tarde/i,
        evening: /tarde/i,
        night: /noite/i
    }
};
const $c5b6f4cb0a5e2c2d$var$match = $c5b6f4cb0a5e2c2d$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $c5b6f4cb0a5e2c2d$var$matchOrdinalNumberPattern,
        parsePattern: $c5b6f4cb0a5e2c2d$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $c5b6f4cb0a5e2c2d$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c5b6f4cb0a5e2c2d$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $c5b6f4cb0a5e2c2d$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c5b6f4cb0a5e2c2d$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $c5b6f4cb0a5e2c2d$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c5b6f4cb0a5e2c2d$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $c5b6f4cb0a5e2c2d$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c5b6f4cb0a5e2c2d$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $c5b6f4cb0a5e2c2d$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $c5b6f4cb0a5e2c2d$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("8aBN0", function(module, exports) {

$parcel$export(module.exports, "ro", function () { return $5f2c92126c038206$export$ea30ec7f37fb148d; }, function (v) { return $5f2c92126c038206$export$ea30ec7f37fb148d = v; });
var $5f2c92126c038206$export$ea30ec7f37fb148d;
"use strict";
$5f2c92126c038206$export$ea30ec7f37fb148d = void 0;

var $25TCA = parcelRequire("25TCA");

var $c2MzI = parcelRequire("c2MzI");

var $fKXwR = parcelRequire("fKXwR");

var $esedZ = parcelRequire("esedZ");

var $laAFz = parcelRequire("laAFz");
/**
 * @category Locales
 * @summary Romanian locale.
 * @language Romanian
 * @iso-639-2 ron
 * @author Sergiu Munteanu [@jsergiu](https://github.com/jsergiu)
 * @author Adrian Ocneanu [@aocneanu](https://github.com/aocneanu)
 * @author Mihai Ocneanu [@gandesc](https://github.com/gandesc)
 */ const $5f2c92126c038206$var$ro = $5f2c92126c038206$export$ea30ec7f37fb148d = {
    code: "ro",
    formatDistance: $25TCA.formatDistance,
    formatLong: $c2MzI.formatLong,
    formatRelative: $fKXwR.formatRelative,
    localize: $esedZ.localize,
    match: $laAFz.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("25TCA", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $186731a6c47bd5fb$export$2c14ff85d6318973; }, function (v) { return $186731a6c47bd5fb$export$2c14ff85d6318973 = v; });
var $186731a6c47bd5fb$export$2c14ff85d6318973;
"use strict";
$186731a6c47bd5fb$export$2c14ff85d6318973 = void 0;
const $186731a6c47bd5fb$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mai pu\u021Bin de o secund\u0103",
        other: "mai pu\u021Bin de {{count}} secunde"
    },
    xSeconds: {
        one: "1 secund\u0103",
        other: "{{count}} secunde"
    },
    halfAMinute: "jum\u0103tate de minut",
    lessThanXMinutes: {
        one: "mai pu\u021Bin de un minut",
        other: "mai pu\u021Bin de {{count}} minute"
    },
    xMinutes: {
        one: "1 minut",
        other: "{{count}} minute"
    },
    aboutXHours: {
        one: "circa 1 or\u0103",
        other: "circa {{count}} ore"
    },
    xHours: {
        one: "1 or\u0103",
        other: "{{count}} ore"
    },
    xDays: {
        one: "1 zi",
        other: "{{count}} zile"
    },
    aboutXWeeks: {
        one: "circa o s\u0103pt\u0103m\xe2n\u0103",
        other: "circa {{count}} s\u0103pt\u0103m\xe2ni"
    },
    xWeeks: {
        one: "1 s\u0103pt\u0103m\xe2n\u0103",
        other: "{{count}} s\u0103pt\u0103m\xe2ni"
    },
    aboutXMonths: {
        one: "circa 1 lun\u0103",
        other: "circa {{count}} luni"
    },
    xMonths: {
        one: "1 lun\u0103",
        other: "{{count}} luni"
    },
    aboutXYears: {
        one: "circa 1 an",
        other: "circa {{count}} ani"
    },
    xYears: {
        one: "1 an",
        other: "{{count}} ani"
    },
    overXYears: {
        one: "peste 1 an",
        other: "peste {{count}} ani"
    },
    almostXYears: {
        one: "aproape 1 an",
        other: "aproape {{count}} ani"
    }
};
const $186731a6c47bd5fb$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $186731a6c47bd5fb$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\xeen " + result;
        else return result + " \xeen urm\u0103";
    }
    return result;
};
$186731a6c47bd5fb$export$2c14ff85d6318973 = $186731a6c47bd5fb$var$formatDistance;

});

parcelRegister("c2MzI", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $8c4b59e9621926ca$export$cbf60ecb96cbb82f; }, function (v) { return $8c4b59e9621926ca$export$cbf60ecb96cbb82f = v; });
var $8c4b59e9621926ca$export$cbf60ecb96cbb82f;
"use strict";
$8c4b59e9621926ca$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $8c4b59e9621926ca$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd.MM.yyyy"
};
const $8c4b59e9621926ca$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $8c4b59e9621926ca$var$dateTimeFormats = {
    full: "{{date}} 'la' {{time}}",
    long: "{{date}} 'la' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $8c4b59e9621926ca$var$formatLong = $8c4b59e9621926ca$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $8c4b59e9621926ca$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $8c4b59e9621926ca$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $8c4b59e9621926ca$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("fKXwR", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $b789542332714a80$export$8fbbfd65594f46a0; }, function (v) { return $b789542332714a80$export$8fbbfd65594f46a0 = v; });
var $b789542332714a80$export$8fbbfd65594f46a0;
"use strict";
$b789542332714a80$export$8fbbfd65594f46a0 = void 0;
const $b789542332714a80$var$formatRelativeLocale = {
    lastWeek: "eeee 'trecut\u0103 la' p",
    yesterday: "'ieri la' p",
    today: "'ast\u0103zi la' p",
    tomorrow: "'m\xe2ine la' p",
    nextWeek: "eeee 'viitoare la' p",
    other: "P"
};
const $b789542332714a80$var$formatRelative = (token, _date, _baseDate, _options)=>$b789542332714a80$var$formatRelativeLocale[token];
$b789542332714a80$export$8fbbfd65594f46a0 = $b789542332714a80$var$formatRelative;

});

parcelRegister("esedZ", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $a85eb6f054f3552d$export$b3bd0bc58e36cd63; }, function (v) { return $a85eb6f054f3552d$export$b3bd0bc58e36cd63 = v; });
var $a85eb6f054f3552d$export$b3bd0bc58e36cd63;
"use strict";
$a85eb6f054f3552d$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $a85eb6f054f3552d$var$eraValues = {
    narrow: [
        "\xce",
        "D"
    ],
    abbreviated: [
        "\xce.d.C.",
        "D.C."
    ],
    wide: [
        "\xcenainte de Cristos",
        "Dup\u0103 Cristos"
    ]
};
const $a85eb6f054f3552d$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "primul trimestru",
        "al doilea trimestru",
        "al treilea trimestru",
        "al patrulea trimestru"
    ]
};
const $a85eb6f054f3552d$var$monthValues = {
    narrow: [
        "I",
        "F",
        "M",
        "A",
        "M",
        "I",
        "I",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "ian",
        "feb",
        "mar",
        "apr",
        "mai",
        "iun",
        "iul",
        "aug",
        "sep",
        "oct",
        "noi",
        "dec"
    ],
    wide: [
        "ianuarie",
        "februarie",
        "martie",
        "aprilie",
        "mai",
        "iunie",
        "iulie",
        "august",
        "septembrie",
        "octombrie",
        "noiembrie",
        "decembrie"
    ]
};
const $a85eb6f054f3552d$var$dayValues = {
    narrow: [
        "d",
        "l",
        "m",
        "m",
        "j",
        "v",
        "s"
    ],
    short: [
        "du",
        "lu",
        "ma",
        "mi",
        "jo",
        "vi",
        "s\xe2"
    ],
    abbreviated: [
        "dum",
        "lun",
        "mar",
        "mie",
        "joi",
        "vin",
        "s\xe2m"
    ],
    wide: [
        "duminic\u0103",
        "luni",
        "mar\u021Bi",
        "miercuri",
        "joi",
        "vineri",
        "s\xe2mb\u0103t\u0103"
    ]
};
const $a85eb6f054f3552d$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "ami",
        morning: "dim",
        afternoon: "da",
        evening: "s",
        night: "n"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: "noapte"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: "noapte"
    }
};
const $a85eb6f054f3552d$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: "noapte"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: "noapte"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: "noapte"
    }
};
const $a85eb6f054f3552d$var$ordinalNumber = (dirtyNumber, _options)=>{
    return String(dirtyNumber);
};
const $a85eb6f054f3552d$var$localize = $a85eb6f054f3552d$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $a85eb6f054f3552d$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $a85eb6f054f3552d$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $a85eb6f054f3552d$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $a85eb6f054f3552d$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $a85eb6f054f3552d$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $a85eb6f054f3552d$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $a85eb6f054f3552d$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("laAFz", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $f696f9f45e7e304f$export$4659b591c19bdf3d; }, function (v) { return $f696f9f45e7e304f$export$4659b591c19bdf3d = v; });
var $f696f9f45e7e304f$export$4659b591c19bdf3d;
"use strict";
$f696f9f45e7e304f$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $f696f9f45e7e304f$var$matchOrdinalNumberPattern = /^(\d+)?/i;
const $f696f9f45e7e304f$var$parseOrdinalNumberPattern = /\d+/i;
const $f696f9f45e7e304f$var$matchEraPatterns = {
    narrow: /^(Î|D)/i,
    abbreviated: /^(Î\.?\s?d\.?\s?C\.?|Î\.?\s?e\.?\s?n\.?|D\.?\s?C\.?|e\.?\s?n\.?)/i,
    wide: /^(Înainte de Cristos|Înaintea erei noastre|După Cristos|Era noastră)/i
};
const $f696f9f45e7e304f$var$parseEraPatterns = {
    any: [
        /^ÎC/i,
        /^DC/i
    ],
    wide: [
        /^(Înainte de Cristos|Înaintea erei noastre)/i,
        /^(După Cristos|Era noastră)/i
    ]
};
const $f696f9f45e7e304f$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^trimestrul [1234]/i
};
const $f696f9f45e7e304f$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $f696f9f45e7e304f$var$matchMonthPatterns = {
    narrow: /^[ifmaasond]/i,
    abbreviated: /^(ian|feb|mar|apr|mai|iun|iul|aug|sep|oct|noi|dec)/i,
    wide: /^(ianuarie|februarie|martie|aprilie|mai|iunie|iulie|august|septembrie|octombrie|noiembrie|decembrie)/i
};
const $f696f9f45e7e304f$var$parseMonthPatterns = {
    narrow: [
        /^i/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^i/i,
        /^i/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ia/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^iun/i,
        /^iul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $f696f9f45e7e304f$var$matchDayPatterns = {
    narrow: /^[dlmjvs]/i,
    short: /^(d|l|ma|mi|j|v|s)/i,
    abbreviated: /^(dum|lun|mar|mie|jo|vi|sâ)/i,
    wide: /^(duminica|luni|marţi|miercuri|joi|vineri|sâmbătă)/i
};
const $f696f9f45e7e304f$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^mi/i,
        /^j/i,
        /^v/i,
        /^s/i
    ]
};
const $f696f9f45e7e304f$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|a|(dimineaţa|după-amiaza|seara|noaptea))/i,
    any: /^([ap]\.?\s?m\.?|miezul nopții|amiaza|(dimineaţa|după-amiaza|seara|noaptea))/i
};
const $f696f9f45e7e304f$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /amiaza/i,
        morning: /dimineaţa/i,
        afternoon: /după-amiaza/i,
        evening: /seara/i,
        night: /noaptea/i
    }
};
const $f696f9f45e7e304f$var$match = $f696f9f45e7e304f$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $f696f9f45e7e304f$var$matchOrdinalNumberPattern,
        parsePattern: $f696f9f45e7e304f$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $f696f9f45e7e304f$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f696f9f45e7e304f$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $f696f9f45e7e304f$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f696f9f45e7e304f$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $f696f9f45e7e304f$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f696f9f45e7e304f$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $f696f9f45e7e304f$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f696f9f45e7e304f$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $f696f9f45e7e304f$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $f696f9f45e7e304f$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("jHr4l", function(module, exports) {

$parcel$export(module.exports, "ru", function () { return $e57707d4cf8e391f$export$cf48009033a0126b; }, function (v) { return $e57707d4cf8e391f$export$cf48009033a0126b = v; });
var $e57707d4cf8e391f$export$cf48009033a0126b;
"use strict";
$e57707d4cf8e391f$export$cf48009033a0126b = void 0;

var $aPlct = parcelRequire("aPlct");

var $chPdi = parcelRequire("chPdi");

var $jBN6o = parcelRequire("jBN6o");

var $13kQ5 = parcelRequire("13kQ5");

var $lJ6j5 = parcelRequire("lJ6j5");
/**
 * @category Locales
 * @summary Russian locale.
 * @language Russian
 * @iso-639-2 rus
 * @author Sasha Koss [@kossnocorp](https://github.com/kossnocorp)
 * @author Lesha Koss [@leshakoss](https://github.com/leshakoss)
 */ const $e57707d4cf8e391f$var$ru = $e57707d4cf8e391f$export$cf48009033a0126b = {
    code: "ru",
    formatDistance: $aPlct.formatDistance,
    formatLong: $chPdi.formatLong,
    formatRelative: $jBN6o.formatRelative,
    localize: $13kQ5.localize,
    match: $lJ6j5.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("aPlct", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $7e1f1cb64c11e3d6$export$2c14ff85d6318973; }, function (v) { return $7e1f1cb64c11e3d6$export$2c14ff85d6318973 = v; });
var $7e1f1cb64c11e3d6$export$2c14ff85d6318973;
"use strict";
$7e1f1cb64c11e3d6$export$2c14ff85d6318973 = void 0;
function $7e1f1cb64c11e3d6$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    const rem10 = count % 10;
    const rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace("{{count}}", String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace("{{count}}", String(count));
    else return scheme.pluralGenitive.replace("{{count}}", String(count));
}
function $7e1f1cb64c11e3d6$var$buildLocalizeTokenFn(scheme) {
    return (count, options)=>{
        if (options?.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $7e1f1cb64c11e3d6$var$declension(scheme.future, count);
                else return "\u0447\u0435\u0440\u0435\u0437 " + $7e1f1cb64c11e3d6$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $7e1f1cb64c11e3d6$var$declension(scheme.past, count);
                else return $7e1f1cb64c11e3d6$var$declension(scheme.regular, count) + " \u043D\u0430\u0437\u0430\u0434";
            }
        } else return $7e1f1cb64c11e3d6$var$declension(scheme.regular, count);
    };
}
const $7e1f1cb64c11e3d6$var$formatDistanceLocale = {
    lessThanXSeconds: $7e1f1cb64c11e3d6$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435 \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: $7e1f1cb64c11e3d6$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u043D\u0430\u0437\u0430\u0434",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u043D\u0430\u0437\u0430\u0434",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u043D\u0430\u0437\u0430\u0434"
        },
        future: {
            singularNominative: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: (_count, options)=>{
        if (options?.addSuffix) {
            if (options.comparison && options.comparison > 0) return "\u0447\u0435\u0440\u0435\u0437 \u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B";
            else return "\u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434";
        }
        return "\u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B";
    },
    lessThanXMinutes: $7e1f1cb64c11e3d6$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435 \u043C\u0438\u043D\u0443\u0442\u044B",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        future: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u043C\u0438\u043D\u0443\u0442\u0443",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u0443",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442"
        }
    }),
    xMinutes: $7e1f1cb64c11e3d6$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0430",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        past: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0443 \u043D\u0430\u0437\u0430\u0434",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u043D\u0430\u0437\u0430\u0434"
        },
        future: {
            singularNominative: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u0443",
            singularGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442"
        }
    }),
    aboutXHours: $7e1f1cb64c11e3d6$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u043E\u0432",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u043E\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441\u043E\u0432"
        }
    }),
    xHours: $7e1f1cb64c11e3d6$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0447\u0430\u0441",
            singularGenitive: "{{count}} \u0447\u0430\u0441\u0430",
            pluralGenitive: "{{count}} \u0447\u0430\u0441\u043E\u0432"
        }
    }),
    xDays: $7e1f1cb64c11e3d6$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u044F",
            pluralGenitive: "{{count}} \u0434\u043D\u0435\u0439"
        }
    }),
    aboutXWeeks: $7e1f1cb64c11e3d6$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u044C",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u044E",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        }
    }),
    xWeeks: $7e1f1cb64c11e3d6$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043D\u0435\u0434\u0435\u043B\u044F",
            singularGenitive: "{{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            pluralGenitive: "{{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        }
    }),
    aboutXMonths: $7e1f1cb64c11e3d6$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        }
    }),
    xMonths: $7e1f1cb64c11e3d6$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        }
    }),
    aboutXYears: $7e1f1cb64c11e3d6$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043B\u0435\u0442",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    }),
    xYears: $7e1f1cb64c11e3d6$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "{{count}} \u043B\u0435\u0442"
        }
    }),
    overXYears: $7e1f1cb64c11e3d6$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u043B\u0435\u0442",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    }),
    almostXYears: $7e1f1cb64c11e3d6$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    })
};
const $7e1f1cb64c11e3d6$var$formatDistance = (token, count, options)=>{
    return $7e1f1cb64c11e3d6$var$formatDistanceLocale[token](count, options);
};
$7e1f1cb64c11e3d6$export$2c14ff85d6318973 = $7e1f1cb64c11e3d6$var$formatDistance;

});

parcelRegister("chPdi", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $8f1ecc843c5637aa$export$cbf60ecb96cbb82f; }, function (v) { return $8f1ecc843c5637aa$export$cbf60ecb96cbb82f = v; });
var $8f1ecc843c5637aa$export$cbf60ecb96cbb82f;
"use strict";
$8f1ecc843c5637aa$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $8f1ecc843c5637aa$var$dateFormats = {
    full: "EEEE, d MMMM y '\u0433.'",
    long: "d MMMM y '\u0433.'",
    medium: "d MMM y '\u0433.'",
    short: "dd.MM.y"
};
const $8f1ecc843c5637aa$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $8f1ecc843c5637aa$var$dateTimeFormats = {
    any: "{{date}}, {{time}}"
};
const $8f1ecc843c5637aa$var$formatLong = $8f1ecc843c5637aa$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $8f1ecc843c5637aa$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $8f1ecc843c5637aa$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $8f1ecc843c5637aa$var$dateTimeFormats,
        defaultWidth: "any"
    })
};

});

parcelRegister("jBN6o", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $e4678fad293460d9$export$8fbbfd65594f46a0; }, function (v) { return $e4678fad293460d9$export$8fbbfd65594f46a0 = v; });
var $e4678fad293460d9$export$8fbbfd65594f46a0;
"use strict";
$e4678fad293460d9$export$8fbbfd65594f46a0 = void 0;

var $9VRW1 = parcelRequire("9VRW1");
const $e4678fad293460d9$var$accusativeWeekdays = [
    "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
    "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
    "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0441\u0440\u0435\u0434\u0443",
    "\u0447\u0435\u0442\u0432\u0435\u0440\u0433",
    "\u043F\u044F\u0442\u043D\u0438\u0446\u0443",
    "\u0441\u0443\u0431\u0431\u043E\u0442\u0443"
];
function $e4678fad293460d9$var$lastWeek(day) {
    const weekday = $e4678fad293460d9$var$accusativeWeekdays[day];
    switch(day){
        case 0:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u043E\u0435 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u044B\u0439 " + weekday + " \u0432' p";
        case 3:
        case 5:
        case 6:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u0443\u044E " + weekday + " \u0432' p";
    }
}
function $e4678fad293460d9$var$thisWeek(day) {
    const weekday = $e4678fad293460d9$var$accusativeWeekdays[day];
    if (day === 2 /* Tue */ ) return "'\u0432\u043E " + weekday + " \u0432' p";
    else return "'\u0432 " + weekday + " \u0432' p";
}
function $e4678fad293460d9$var$nextWeek(day) {
    const weekday = $e4678fad293460d9$var$accusativeWeekdays[day];
    switch(day){
        case 0:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0435 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 " + weekday + " \u0432' p";
        case 3:
        case 5:
        case 6:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0443\u044E " + weekday + " \u0432' p";
    }
}
const $e4678fad293460d9$var$formatRelativeLocale = {
    lastWeek: (date, baseDate, options)=>{
        const day = date.getDay();
        if ((0, $9VRW1.isSameWeek)(date, baseDate, options)) return $e4678fad293460d9$var$thisWeek(day);
        else return $e4678fad293460d9$var$lastWeek(day);
    },
    yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432' p",
    today: "'\u0441\u0435\u0433\u043E\u0434\u043D\u044F \u0432' p",
    tomorrow: "'\u0437\u0430\u0432\u0442\u0440\u0430 \u0432' p",
    nextWeek: (date, baseDate, options)=>{
        const day = date.getDay();
        if ((0, $9VRW1.isSameWeek)(date, baseDate, options)) return $e4678fad293460d9$var$thisWeek(day);
        else return $e4678fad293460d9$var$nextWeek(day);
    },
    other: "P"
};
const $e4678fad293460d9$var$formatRelative = (token, date, baseDate, options)=>{
    const format = $e4678fad293460d9$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
$e4678fad293460d9$export$8fbbfd65594f46a0 = $e4678fad293460d9$var$formatRelative;

});

parcelRegister("13kQ5", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $0c463c7615950c14$export$b3bd0bc58e36cd63; }, function (v) { return $0c463c7615950c14$export$b3bd0bc58e36cd63 = v; });
var $0c463c7615950c14$export$b3bd0bc58e36cd63;
"use strict";
$0c463c7615950c14$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $0c463c7615950c14$var$eraValues = {
    narrow: [
        "\u0434\u043E \u043D.\u044D.",
        "\u043D.\u044D."
    ],
    abbreviated: [
        "\u0434\u043E \u043D. \u044D.",
        "\u043D. \u044D."
    ],
    wide: [
        "\u0434\u043E \u043D\u0430\u0448\u0435\u0439 \u044D\u0440\u044B",
        "\u043D\u0430\u0448\u0435\u0439 \u044D\u0440\u044B"
    ]
};
const $0c463c7615950c14$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-\u0439 \u043A\u0432.",
        "2-\u0439 \u043A\u0432.",
        "3-\u0439 \u043A\u0432.",
        "4-\u0439 \u043A\u0432."
    ],
    wide: [
        "1-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
const $0c463c7615950c14$var$monthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432.",
        "\u0444\u0435\u0432.",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440.",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D\u044C",
        "\u0438\u044E\u043B\u044C",
        "\u0430\u0432\u0433.",
        "\u0441\u0435\u043D\u0442.",
        "\u043E\u043A\u0442.",
        "\u043D\u043E\u044F\u0431.",
        "\u0434\u0435\u043A."
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440\u044C",
        "\u0444\u0435\u0432\u0440\u0430\u043B\u044C",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0435\u043B\u044C",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D\u044C",
        "\u0438\u044E\u043B\u044C",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C",
        "\u043E\u043A\u0442\u044F\u0431\u0440\u044C",
        "\u043D\u043E\u044F\u0431\u0440\u044C",
        "\u0434\u0435\u043A\u0430\u0431\u0440\u044C"
    ]
};
const $0c463c7615950c14$var$formattingMonthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432.",
        "\u0444\u0435\u0432.",
        "\u043C\u0430\u0440.",
        "\u0430\u043F\u0440.",
        "\u043C\u0430\u044F",
        "\u0438\u044E\u043D.",
        "\u0438\u044E\u043B.",
        "\u0430\u0432\u0433.",
        "\u0441\u0435\u043D\u0442.",
        "\u043E\u043A\u0442.",
        "\u043D\u043E\u044F\u0431.",
        "\u0434\u0435\u043A."
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440\u044F",
        "\u0444\u0435\u0432\u0440\u0430\u043B\u044F",
        "\u043C\u0430\u0440\u0442\u0430",
        "\u0430\u043F\u0440\u0435\u043B\u044F",
        "\u043C\u0430\u044F",
        "\u0438\u044E\u043D\u044F",
        "\u0438\u044E\u043B\u044F",
        "\u0430\u0432\u0433\u0443\u0441\u0442\u0430",
        "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044F",
        "\u043E\u043A\u0442\u044F\u0431\u0440\u044F",
        "\u043D\u043E\u044F\u0431\u0440\u044F",
        "\u0434\u0435\u043A\u0430\u0431\u0440\u044F"
    ]
};
const $0c463c7615950c14$var$dayValues = {
    narrow: [
        "\u0412",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u0432\u0441",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u0432\u0441\u043A",
        "\u043F\u043D\u0434",
        "\u0432\u0442\u0440",
        "\u0441\u0440\u0434",
        "\u0447\u0442\u0432",
        "\u043F\u0442\u043D",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
        "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
        "\u0441\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0435\u0440\u0433",
        "\u043F\u044F\u0442\u043D\u0438\u0446\u0430",
        "\u0441\u0443\u0431\u0431\u043E\u0442\u0430"
    ]
};
const $0c463c7615950c14$var$dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044C"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044C"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u0447\u044C",
        noon: "\u043F\u043E\u043B\u0434\u0435\u043D\u044C",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0435\u0440",
        night: "\u043D\u043E\u0447\u044C"
    }
};
const $0c463c7615950c14$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0438"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0438"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u0447\u044C",
        noon: "\u043F\u043E\u043B\u0434\u0435\u043D\u044C",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0435\u0440\u0430",
        night: "\u043D\u043E\u0447\u0438"
    }
};
const $0c463c7615950c14$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    const unit = options?.unit;
    let suffix;
    if (unit === "date") suffix = "-\u0435";
    else if (unit === "week" || unit === "minute" || unit === "second") suffix = "-\u044F";
    else suffix = "-\u0439";
    return number + suffix;
};
const $0c463c7615950c14$var$localize = $0c463c7615950c14$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $0c463c7615950c14$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $0c463c7615950c14$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $0c463c7615950c14$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $0c463c7615950c14$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $0c463c7615950c14$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $0c463c7615950c14$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $0c463c7615950c14$var$dayPeriodValues,
        defaultWidth: "any",
        formattingValues: $0c463c7615950c14$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("lJ6j5", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $fd12b1569283fb08$export$4659b591c19bdf3d; }, function (v) { return $fd12b1569283fb08$export$4659b591c19bdf3d = v; });
var $fd12b1569283fb08$export$4659b591c19bdf3d;
"use strict";
$fd12b1569283fb08$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $fd12b1569283fb08$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i;
const $fd12b1569283fb08$var$parseOrdinalNumberPattern = /\d+/i;
const $fd12b1569283fb08$var$matchEraPatterns = {
    narrow: /^((до )?н\.?\s?э\.?)/i,
    abbreviated: /^((до )?н\.?\s?э\.?)/i,
    wide: /^(до нашей эры|нашей эры|наша эра)/i
};
const $fd12b1569283fb08$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
const $fd12b1569283fb08$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
    wide: /^[1234](-?[ыои]?й?)? квартал/i
};
const $fd12b1569283fb08$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $fd12b1569283fb08$var$matchMonthPatterns = {
    narrow: /^[яфмаисонд]/i,
    abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
    wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
};
const $fd12b1569283fb08$var$parseMonthPatterns = {
    narrow: [
        /^я/i,
        /^ф/i,
        /^м/i,
        /^а/i,
        /^м/i,
        /^и/i,
        /^и/i,
        /^а/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^я/i
    ],
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^ав/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
const $fd12b1569283fb08$var$matchDayPatterns = {
    narrow: /^[впсч]/i,
    short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
    abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
    wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
};
const $fd12b1569283fb08$var$parseDayPatterns = {
    narrow: [
        /^в/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^в[ос]/i,
        /^п[он]/i,
        /^в/i,
        /^ср/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
const $fd12b1569283fb08$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
    abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
    wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
};
const $fd12b1569283fb08$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^полн/i,
        noon: /^полд/i,
        morning: /^у/i,
        afternoon: /^д[ен]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
const $fd12b1569283fb08$var$match = $fd12b1569283fb08$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $fd12b1569283fb08$var$matchOrdinalNumberPattern,
        parsePattern: $fd12b1569283fb08$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $fd12b1569283fb08$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fd12b1569283fb08$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $fd12b1569283fb08$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fd12b1569283fb08$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $fd12b1569283fb08$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fd12b1569283fb08$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $fd12b1569283fb08$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fd12b1569283fb08$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $fd12b1569283fb08$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fd12b1569283fb08$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("2Ry8i", function(module, exports) {

$parcel$export(module.exports, "se", function () { return $215b0211acc033b0$export$6362df887b441e93; }, function (v) { return $215b0211acc033b0$export$6362df887b441e93 = v; });
var $215b0211acc033b0$export$6362df887b441e93;
"use strict";
$215b0211acc033b0$export$6362df887b441e93 = void 0;

var $h1Me5 = parcelRequire("h1Me5");

var $4iGLq = parcelRequire("4iGLq");

var $8rn6R = parcelRequire("8rn6R");

var $i987i = parcelRequire("i987i");

var $4af33 = parcelRequire("4af33");
/**
 * @category Locales
 * @summary Northern Sámi locale.
 * @language Northern Sámi
 * @iso-639-2 sme
 * @author Audun Rundberg [@audunru](https://github.com/audunru)
 */ const $215b0211acc033b0$var$se = $215b0211acc033b0$export$6362df887b441e93 = {
    code: "se",
    formatDistance: $h1Me5.formatDistance,
    formatLong: $4iGLq.formatLong,
    formatRelative: $8rn6R.formatRelative,
    localize: $i987i.localize,
    match: $4af33.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("h1Me5", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $c657f068725503b3$export$2c14ff85d6318973; }, function (v) { return $c657f068725503b3$export$2c14ff85d6318973 = v; });
var $c657f068725503b3$export$2c14ff85d6318973;
"use strict";
$c657f068725503b3$export$2c14ff85d6318973 = void 0;
const $c657f068725503b3$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "unnit go ovtta sekundda",
        other: "unnit go {{count}} sekundda"
    },
    xSeconds: {
        one: "sekundda",
        other: "{{count}} sekundda"
    },
    halfAMinute: "bealle minuhta",
    lessThanXMinutes: {
        one: "unnit go bealle minuhta",
        other: "unnit go {{count}} minuhta"
    },
    xMinutes: {
        one: "minuhta",
        other: "{{count}} minuhta"
    },
    aboutXHours: {
        one: "sullii ovtta diimmu",
        other: "sullii {{count}} diimmu"
    },
    xHours: {
        one: "diimmu",
        other: "{{count}} diimmu"
    },
    xDays: {
        one: "beaivvi",
        other: "{{count}} beaivvi"
    },
    aboutXWeeks: {
        one: "sullii ovtta vahku",
        other: "sullii {{count}} vahku"
    },
    xWeeks: {
        one: "vahku",
        other: "{{count}} vahku"
    },
    aboutXMonths: {
        one: "sullii ovtta m\xe1nu",
        other: "sullii {{count}} m\xe1nu"
    },
    xMonths: {
        one: "m\xe1nu",
        other: "{{count}} m\xe1nu"
    },
    aboutXYears: {
        one: "sullii ovtta jagi",
        other: "sullii {{count}} jagi"
    },
    xYears: {
        one: "jagi",
        other: "{{count}} jagi"
    },
    overXYears: {
        one: "guhkit go jagi",
        other: "guhkit go {{count}} jagi"
    },
    almostXYears: {
        one: "measta jagi",
        other: "measta {{count}} jagi"
    }
};
const $c657f068725503b3$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $c657f068725503b3$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "geah\u010Den " + result;
        else return result + " \xe1igi";
    }
    return result;
};
$c657f068725503b3$export$2c14ff85d6318973 = $c657f068725503b3$var$formatDistance;

});

parcelRegister("4iGLq", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $321a03dd8744834f$export$cbf60ecb96cbb82f; }, function (v) { return $321a03dd8744834f$export$cbf60ecb96cbb82f = v; });
var $321a03dd8744834f$export$cbf60ecb96cbb82f;
"use strict";
$321a03dd8744834f$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $321a03dd8744834f$var$dateFormats = {
    full: "EEEE MMMM d. 'b.' y",
    long: "MMMM d. 'b.' y",
    medium: "MMM d. 'b.' y",
    short: "dd.MM.y"
};
const $321a03dd8744834f$var$timeFormats = {
    full: "'dii.' HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $321a03dd8744834f$var$dateTimeFormats = {
    full: "{{date}} 'dii.' {{time}}",
    long: "{{date}} 'dii.' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $321a03dd8744834f$var$formatLong = $321a03dd8744834f$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $321a03dd8744834f$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $321a03dd8744834f$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $321a03dd8744834f$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("8rn6R", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $6252c5765a80920b$export$8fbbfd65594f46a0; }, function (v) { return $6252c5765a80920b$export$8fbbfd65594f46a0 = v; });
var $6252c5765a80920b$export$8fbbfd65594f46a0;
"use strict";
$6252c5765a80920b$export$8fbbfd65594f46a0 = void 0;
const $6252c5765a80920b$var$formatRelativeLocale = {
    lastWeek: "'ovddit' eeee 'dii.' p",
    yesterday: "'ikte dii.' p",
    today: "'odne dii.' p",
    tomorrow: "'ihtin dii.' p",
    nextWeek: "EEEE 'dii.' p",
    other: "P"
};
const $6252c5765a80920b$var$formatRelative = (token, _date, _baseDate, _options)=>$6252c5765a80920b$var$formatRelativeLocale[token];
$6252c5765a80920b$export$8fbbfd65594f46a0 = $6252c5765a80920b$var$formatRelative;

});

parcelRegister("i987i", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $d35f5d102e861f3b$export$b3bd0bc58e36cd63; }, function (v) { return $d35f5d102e861f3b$export$b3bd0bc58e36cd63 = v; });
var $d35f5d102e861f3b$export$b3bd0bc58e36cd63;
"use strict";
$d35f5d102e861f3b$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $d35f5d102e861f3b$var$eraValues = {
    narrow: [
        "o.Kr.",
        "m.Kr."
    ],
    abbreviated: [
        "o.Kr.",
        "m.Kr."
    ],
    wide: [
        "ovdal Kristusa",
        "ma\u014B\u014Bel Kristusa"
    ]
};
const $d35f5d102e861f3b$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. kvart\xe1la",
        "2. kvart\xe1la",
        "3. kvart\xe1la",
        "4. kvart\xe1la"
    ]
};
const $d35f5d102e861f3b$var$monthValues = {
    narrow: [
        "O",
        "G",
        "N",
        "C",
        "M",
        "G",
        "S",
        "B",
        "\u010C",
        "G",
        "S",
        "J"
    ],
    abbreviated: [
        "o\u0111\u0111a",
        "guov",
        "njuk",
        "cuo",
        "mies",
        "geas",
        "suoi",
        "borg",
        "\u010Dak\u010D",
        "golg",
        "sk\xe1b",
        "juov"
    ],
    wide: [
        "o\u0111\u0111ajagem\xe1nnu",
        "guovvam\xe1nnu",
        "njuk\u010Dam\xe1nnu",
        "cuo\u014Bom\xe1nnu",
        "miessem\xe1nnu",
        "geassem\xe1nnu",
        "suoidnem\xe1nnu",
        "borgem\xe1nnu",
        "\u010Dak\u010Dam\xe1nnu",
        "golggotm\xe1nnu",
        "sk\xe1bmam\xe1nnu",
        "juovlam\xe1nnu"
    ]
};
const $d35f5d102e861f3b$var$dayValues = {
    narrow: [
        "S",
        "V",
        "M",
        "G",
        "D",
        "B",
        "L"
    ],
    short: [
        "sotn",
        "vuos",
        "ma\u014B",
        "gask",
        "duor",
        "bear",
        "l\xe1v"
    ],
    abbreviated: [
        "sotn",
        "vuos",
        "ma\u014B",
        "gask",
        "duor",
        "bear",
        "l\xe1v"
    ],
    wide: [
        "sotnabeaivi",
        "vuoss\xe1rga",
        "ma\u014B\u014Beb\xe1rga",
        "gaskavahkku",
        "duorastat",
        "bearjadat",
        "l\xe1vvardat"
    ]
};
const $d35f5d102e861f3b$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "gaskaidja",
        noon: "gaskabeaivi",
        morning: "i\u0111\u0111es",
        afternoon: "ma\u014B\u014Bel gaska.",
        evening: "eahkes",
        night: "ihkku"
    },
    abbreviated: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "gaskaidja",
        noon: "gaskabeaivvi",
        morning: "i\u0111\u0111es",
        afternoon: "ma\u014B\u014Bel gaskabea.",
        evening: "eahkes",
        night: "ihkku"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "gaskaidja",
        noon: "gaskabeavvi",
        morning: "i\u0111\u0111es",
        afternoon: "ma\u014B\u014Bel gaskabeaivvi",
        evening: "eahkes",
        night: "ihkku"
    }
};
const $d35f5d102e861f3b$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $d35f5d102e861f3b$var$localize = $d35f5d102e861f3b$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $d35f5d102e861f3b$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $d35f5d102e861f3b$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $d35f5d102e861f3b$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $d35f5d102e861f3b$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $d35f5d102e861f3b$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $d35f5d102e861f3b$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};

});

parcelRegister("4af33", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $3083c4de47b4ac6e$export$4659b591c19bdf3d; }, function (v) { return $3083c4de47b4ac6e$export$4659b591c19bdf3d = v; });
var $3083c4de47b4ac6e$export$4659b591c19bdf3d;
"use strict";
$3083c4de47b4ac6e$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $3083c4de47b4ac6e$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
const $3083c4de47b4ac6e$var$parseOrdinalNumberPattern = /\d+/i;
const $3083c4de47b4ac6e$var$matchEraPatterns = {
    narrow: /^(o\.? ?Kr\.?|m\.? ?Kr\.?)/i,
    abbreviated: /^(o\.? ?Kr\.?|m\.? ?Kr\.?)/i,
    wide: /^(ovdal Kristusa|ovdal min áiggi|maŋŋel Kristusa|min áigi)/i
};
const $3083c4de47b4ac6e$var$parseEraPatterns = {
    any: [
        /^o/i,
        /^m/i
    ]
};
const $3083c4de47b4ac6e$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? kvartála/i
};
const $3083c4de47b4ac6e$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $3083c4de47b4ac6e$var$matchMonthPatterns = {
    narrow: /^[ogncmsbčj]/i,
    abbreviated: /^(ođđa|guov|njuk|cuo|mies|geas|suoi|borg|čakč|golg|skáb|juov)\.?/i,
    wide: /^(ođđajagemánnu|guovvamánnu|njukčamánnu|cuoŋománnu|miessemánnu|geassemánnu|suoidnemánnu|borgemánnu|čakčamánnu|golggotmánnu|skábmamánnu|juovlamánnu)/i
};
const $3083c4de47b4ac6e$var$parseMonthPatterns = {
    narrow: [
        /^o/i,
        /^g/i,
        /^n/i,
        /^c/i,
        /^m/i,
        /^g/i,
        /^s/i,
        /^b/i,
        /^č/i,
        /^g/i,
        /^s/i,
        /^j/i
    ],
    any: [
        /^o/i,
        /^gu/i,
        /^n/i,
        /^c/i,
        /^m/i,
        /^ge/i,
        /^su/i,
        /^b/i,
        /^č/i,
        /^go/i,
        /^sk/i,
        /^j/i
    ]
};
const $3083c4de47b4ac6e$var$matchDayPatterns = {
    narrow: /^[svmgdbl]/i,
    short: /^(sotn|vuos|maŋ|gask|duor|bear|láv)/i,
    abbreviated: /^(sotn|vuos|maŋ|gask|duor|bear|láv)/i,
    wide: /^(sotnabeaivi|vuossárga|maŋŋebárga|gaskavahkku|duorastat|bearjadat|lávvardat)/i
};
const $3083c4de47b4ac6e$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^v/i,
        /^m/i,
        /^g/i,
        /^d/i,
        /^b/i,
        /^l/i
    ]
};
const $3083c4de47b4ac6e$var$matchDayPeriodPatterns = {
    narrow: /^(gaskaidja|gaskabeaivvi|(på) (iđđes|maŋŋel gaskabeaivvi|eahkes|ihkku)|[ap])/i,
    any: /^([ap]\.?\s?m\.?|gaskaidja|gaskabeaivvi|(på) (iđđes|maŋŋel gaskabeaivvi|eahkes|ihkku))/i
};
const $3083c4de47b4ac6e$var$parseDayPeriodPatterns = {
    any: {
        am: /^a(\.?\s?m\.?)?$/i,
        pm: /^p(\.?\s?m\.?)?$/i,
        midnight: /^gaskai/i,
        noon: /^gaskab/i,
        morning: /iđđes/i,
        afternoon: /maŋŋel gaskabeaivvi/i,
        evening: /eahkes/i,
        night: /ihkku/i
    }
};
const $3083c4de47b4ac6e$var$match = $3083c4de47b4ac6e$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $3083c4de47b4ac6e$var$matchOrdinalNumberPattern,
        parsePattern: $3083c4de47b4ac6e$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $3083c4de47b4ac6e$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3083c4de47b4ac6e$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $3083c4de47b4ac6e$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3083c4de47b4ac6e$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $3083c4de47b4ac6e$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3083c4de47b4ac6e$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $3083c4de47b4ac6e$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3083c4de47b4ac6e$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $3083c4de47b4ac6e$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $3083c4de47b4ac6e$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("iw4hM", function(module, exports) {

$parcel$export(module.exports, "sk", function () { return $d7ae8a38e3a0b4c6$export$d608fa5b5bfd2021; }, function (v) { return $d7ae8a38e3a0b4c6$export$d608fa5b5bfd2021 = v; });
var $d7ae8a38e3a0b4c6$export$d608fa5b5bfd2021;
"use strict";
$d7ae8a38e3a0b4c6$export$d608fa5b5bfd2021 = void 0;

var $kAXmK = parcelRequire("kAXmK");

var $frU4Y = parcelRequire("frU4Y");

var $hCPJt = parcelRequire("hCPJt");

var $1hW0e = parcelRequire("1hW0e");

var $3TT0k = parcelRequire("3TT0k");
/**
 * @category Locales
 * @summary Slovak locale.
 * @language Slovak
 * @iso-639-2 slk
 * @author Marek Suscak [@mareksuscak](https://github.com/mareksuscak)
 */ const $d7ae8a38e3a0b4c6$var$sk = $d7ae8a38e3a0b4c6$export$d608fa5b5bfd2021 = {
    code: "sk",
    formatDistance: $kAXmK.formatDistance,
    formatLong: $frU4Y.formatLong,
    formatRelative: $hCPJt.formatRelative,
    localize: $1hW0e.localize,
    match: $3TT0k.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("kAXmK", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $efe5384a331d3e83$export$2c14ff85d6318973; }, function (v) { return $efe5384a331d3e83$export$2c14ff85d6318973 = v; });
var $efe5384a331d3e83$export$2c14ff85d6318973;
"use strict";
$efe5384a331d3e83$export$2c14ff85d6318973 = void 0;
function $efe5384a331d3e83$var$declensionGroup(scheme, count) {
    if (count === 1 && scheme.one) return scheme.one;
    if (count >= 2 && count <= 4 && scheme.twoFour) return scheme.twoFour;
    // if count === null || count === 0 || count >= 5
    return scheme.other;
}
function $efe5384a331d3e83$var$declension(scheme, count, time) {
    const group = $efe5384a331d3e83$var$declensionGroup(scheme, count);
    const finalText = group[time];
    return finalText.replace("{{count}}", String(count));
}
function $efe5384a331d3e83$var$extractPreposition(token) {
    const result = [
        "lessThan",
        "about",
        "over",
        "almost"
    ].filter(function(preposition) {
        return !!token.match(new RegExp("^" + preposition));
    });
    return result[0];
}
function $efe5384a331d3e83$var$prefixPreposition(preposition) {
    let translation = "";
    if (preposition === "almost") translation = "takmer";
    if (preposition === "about") translation = "pribli\u017Ene";
    return translation.length > 0 ? translation + " " : "";
}
function $efe5384a331d3e83$var$suffixPreposition(preposition) {
    let translation = "";
    if (preposition === "lessThan") translation = "menej ne\u017E";
    if (preposition === "over") translation = "viac ne\u017E";
    return translation.length > 0 ? translation + " " : "";
}
function $efe5384a331d3e83$var$lowercaseFirstLetter(string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
}
const $efe5384a331d3e83$var$formatDistanceLocale = {
    xSeconds: {
        one: {
            present: "sekunda",
            past: "sekundou",
            future: "sekundu"
        },
        twoFour: {
            present: "{{count}} sekundy",
            past: "{{count}} sekundami",
            future: "{{count}} sekundy"
        },
        other: {
            present: "{{count}} sek\xfand",
            past: "{{count}} sekundami",
            future: "{{count}} sek\xfand"
        }
    },
    halfAMinute: {
        other: {
            present: "pol min\xfaty",
            past: "pol min\xfatou",
            future: "pol min\xfaty"
        }
    },
    xMinutes: {
        one: {
            present: "min\xfata",
            past: "min\xfatou",
            future: "min\xfatu"
        },
        twoFour: {
            present: "{{count}} min\xfaty",
            past: "{{count}} min\xfatami",
            future: "{{count}} min\xfaty"
        },
        other: {
            present: "{{count}} min\xfat",
            past: "{{count}} min\xfatami",
            future: "{{count}} min\xfat"
        }
    },
    xHours: {
        one: {
            present: "hodina",
            past: "hodinou",
            future: "hodinu"
        },
        twoFour: {
            present: "{{count}} hodiny",
            past: "{{count}} hodinami",
            future: "{{count}} hodiny"
        },
        other: {
            present: "{{count}} hod\xedn",
            past: "{{count}} hodinami",
            future: "{{count}} hod\xedn"
        }
    },
    xDays: {
        one: {
            present: "de\u0148",
            past: "d\u0148om",
            future: "de\u0148"
        },
        twoFour: {
            present: "{{count}} dni",
            past: "{{count}} d\u0148ami",
            future: "{{count}} dni"
        },
        other: {
            present: "{{count}} dn\xed",
            past: "{{count}} d\u0148ami",
            future: "{{count}} dn\xed"
        }
    },
    xWeeks: {
        one: {
            present: "t\xfd\u017Ede\u0148",
            past: "t\xfd\u017Ed\u0148om",
            future: "t\xfd\u017Ede\u0148"
        },
        twoFour: {
            present: "{{count}} t\xfd\u017Edne",
            past: "{{count}} t\xfd\u017Ed\u0148ami",
            future: "{{count}} t\xfd\u017Edne"
        },
        other: {
            present: "{{count}} t\xfd\u017Ed\u0148ov",
            past: "{{count}} t\xfd\u017Ed\u0148ami",
            future: "{{count}} t\xfd\u017Ed\u0148ov"
        }
    },
    xMonths: {
        one: {
            present: "mesiac",
            past: "mesiacom",
            future: "mesiac"
        },
        twoFour: {
            present: "{{count}} mesiace",
            past: "{{count}} mesiacmi",
            future: "{{count}} mesiace"
        },
        other: {
            present: "{{count}} mesiacov",
            past: "{{count}} mesiacmi",
            future: "{{count}} mesiacov"
        }
    },
    xYears: {
        one: {
            present: "rok",
            past: "rokom",
            future: "rok"
        },
        twoFour: {
            present: "{{count}} roky",
            past: "{{count}} rokmi",
            future: "{{count}} roky"
        },
        other: {
            present: "{{count}} rokov",
            past: "{{count}} rokmi",
            future: "{{count}} rokov"
        }
    }
};
const $efe5384a331d3e83$var$formatDistance = (token, count, options)=>{
    const preposition = $efe5384a331d3e83$var$extractPreposition(token) || "";
    const key = $efe5384a331d3e83$var$lowercaseFirstLetter(token.substring(preposition.length));
    const scheme = $efe5384a331d3e83$var$formatDistanceLocale[key];
    if (!options?.addSuffix) return $efe5384a331d3e83$var$prefixPreposition(preposition) + $efe5384a331d3e83$var$suffixPreposition(preposition) + $efe5384a331d3e83$var$declension(scheme, count, "present");
    if (options.comparison && options.comparison > 0) return $efe5384a331d3e83$var$prefixPreposition(preposition) + "o " + $efe5384a331d3e83$var$suffixPreposition(preposition) + $efe5384a331d3e83$var$declension(scheme, count, "future");
    else return $efe5384a331d3e83$var$prefixPreposition(preposition) + "pred " + $efe5384a331d3e83$var$suffixPreposition(preposition) + $efe5384a331d3e83$var$declension(scheme, count, "past");
};
$efe5384a331d3e83$export$2c14ff85d6318973 = $efe5384a331d3e83$var$formatDistance;

});

parcelRegister("frU4Y", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $b3f4e0cc5fbabb6d$export$cbf60ecb96cbb82f; }, function (v) { return $b3f4e0cc5fbabb6d$export$cbf60ecb96cbb82f = v; });
var $b3f4e0cc5fbabb6d$export$cbf60ecb96cbb82f;
"use strict";
$b3f4e0cc5fbabb6d$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1986
const $b3f4e0cc5fbabb6d$var$dateFormats = {
    full: "EEEE d. MMMM y",
    long: "d. MMMM y",
    medium: "d. M. y",
    short: "d. M. y"
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#2149
const $b3f4e0cc5fbabb6d$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1994
const $b3f4e0cc5fbabb6d$var$dateTimeFormats = {
    full: "{{date}}, {{time}}",
    long: "{{date}}, {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}} {{time}}"
};
const $b3f4e0cc5fbabb6d$var$formatLong = $b3f4e0cc5fbabb6d$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $b3f4e0cc5fbabb6d$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $b3f4e0cc5fbabb6d$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $b3f4e0cc5fbabb6d$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("hCPJt", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $cd4e1d42b6381e35$export$8fbbfd65594f46a0; }, function (v) { return $cd4e1d42b6381e35$export$8fbbfd65594f46a0 = v; });
var $cd4e1d42b6381e35$export$8fbbfd65594f46a0;
"use strict";
$cd4e1d42b6381e35$export$8fbbfd65594f46a0 = void 0;

var $9VRW1 = parcelRequire("9VRW1");
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1308
const $cd4e1d42b6381e35$var$accusativeWeekdays = [
    "nede\u013Eu",
    "pondelok",
    "utorok",
    "stredu",
    "\u0161tvrtok",
    "piatok",
    "sobotu"
];
function $cd4e1d42b6381e35$var$lastWeek(day) {
    const weekday = $cd4e1d42b6381e35$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        /* Sun */ case 3:
        /* Wed */ case 6 /* Sat */ :
            return "'minul\xfa " + weekday + " o' p";
        default:
            return "'minul\xfd' eeee 'o' p";
    }
}
function $cd4e1d42b6381e35$var$thisWeek(day) {
    const weekday = $cd4e1d42b6381e35$var$accusativeWeekdays[day];
    if (day === 4 /* Thu */ ) return "'vo' eeee 'o' p";
    else return "'v " + weekday + " o' p";
}
function $cd4e1d42b6381e35$var$nextWeek(day) {
    const weekday = $cd4e1d42b6381e35$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        /* Sun */ case 4:
        /* Wed */ case 6 /* Sat */ :
            return "'bud\xfacu " + weekday + " o' p";
        default:
            return "'bud\xfaci' eeee 'o' p";
    }
}
const $cd4e1d42b6381e35$var$formatRelativeLocale = {
    lastWeek: (date, baseDate, options)=>{
        const day = date.getDay();
        if ((0, $9VRW1.isSameWeek)(date, baseDate, options)) return $cd4e1d42b6381e35$var$thisWeek(day);
        else return $cd4e1d42b6381e35$var$lastWeek(day);
    },
    yesterday: "'v\u010Dera o' p",
    today: "'dnes o' p",
    tomorrow: "'zajtra o' p",
    nextWeek: (date, baseDate, options)=>{
        const day = date.getDay();
        if ((0, $9VRW1.isSameWeek)(date, baseDate, options)) return $cd4e1d42b6381e35$var$thisWeek(day);
        else return $cd4e1d42b6381e35$var$nextWeek(day);
    },
    other: "P"
};
const $cd4e1d42b6381e35$var$formatRelative = (token, date, baseDate, options)=>{
    const format = $cd4e1d42b6381e35$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
$cd4e1d42b6381e35$export$8fbbfd65594f46a0 = $cd4e1d42b6381e35$var$formatRelative;

});

parcelRegister("1hW0e", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $0f045f19323e755b$export$b3bd0bc58e36cd63; }, function (v) { return $0f045f19323e755b$export$b3bd0bc58e36cd63 = v; });
var $0f045f19323e755b$export$b3bd0bc58e36cd63;
"use strict";
$0f045f19323e755b$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1772
const $0f045f19323e755b$var$eraValues = {
    narrow: [
        "pred Kr.",
        "po Kr."
    ],
    abbreviated: [
        "pred Kr.",
        "po Kr."
    ],
    wide: [
        "pred Kristom",
        "po Kristovi"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1780
const $0f045f19323e755b$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. \u0161tvr\u0165rok",
        "2. \u0161tvr\u0165rok",
        "3. \u0161tvr\u0165rok",
        "4. \u0161tvr\u0165rok"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1804
const $0f045f19323e755b$var$monthValues = {
    narrow: [
        "j",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "jan",
        "feb",
        "mar",
        "apr",
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        "aug",
        "sep",
        "okt",
        "nov",
        "dec"
    ],
    wide: [
        "janu\xe1r",
        "febru\xe1r",
        "marec",
        "apr\xedl",
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        "august",
        "september",
        "okt\xf3ber",
        "november",
        "december"
    ]
};
const $0f045f19323e755b$var$formattingMonthValues = {
    narrow: [
        "j",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "jan",
        "feb",
        "mar",
        "apr",
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        "aug",
        "sep",
        "okt",
        "nov",
        "dec"
    ],
    wide: [
        "janu\xe1ra",
        "febru\xe1ra",
        "marca",
        "apr\xedla",
        "m\xe1ja",
        "j\xfana",
        "j\xfala",
        "augusta",
        "septembra",
        "okt\xf3bra",
        "novembra",
        "decembra"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1876
const $0f045f19323e755b$var$dayValues = {
    narrow: [
        "n",
        "p",
        "u",
        "s",
        "\u0161",
        "p",
        "s"
    ],
    short: [
        "ne",
        "po",
        "ut",
        "st",
        "\u0161t",
        "pi",
        "so"
    ],
    abbreviated: [
        "ne",
        "po",
        "ut",
        "st",
        "\u0161t",
        "pi",
        "so"
    ],
    wide: [
        "nede\u013Ea",
        "pondelok",
        "utorok",
        "streda",
        "\u0161tvrtok",
        "piatok",
        "sobota"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1932
const $0f045f19323e755b$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "poln.",
        noon: "pol.",
        morning: "r\xe1no",
        afternoon: "pop.",
        evening: "ve\u010D.",
        night: "noc"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "poln.",
        noon: "pol.",
        morning: "r\xe1no",
        afternoon: "popol.",
        evening: "ve\u010Der",
        night: "noc"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "polnoc",
        noon: "poludnie",
        morning: "r\xe1no",
        afternoon: "popoludnie",
        evening: "ve\u010Der",
        night: "noc"
    }
};
const $0f045f19323e755b$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "o poln.",
        noon: "nap.",
        morning: "r\xe1no",
        afternoon: "pop.",
        evening: "ve\u010D.",
        night: "v n."
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "o poln.",
        noon: "napol.",
        morning: "r\xe1no",
        afternoon: "popol.",
        evening: "ve\u010Der",
        night: "v noci"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "o polnoci",
        noon: "napoludnie",
        morning: "r\xe1no",
        afternoon: "popoludn\xed",
        evening: "ve\u010Der",
        night: "v noci"
    }
};
const $0f045f19323e755b$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $0f045f19323e755b$var$localize = $0f045f19323e755b$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $0f045f19323e755b$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $0f045f19323e755b$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $0f045f19323e755b$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $0f045f19323e755b$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $0f045f19323e755b$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $0f045f19323e755b$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $0f045f19323e755b$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $0f045f19323e755b$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("3TT0k", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $2d712cdb275a082d$export$4659b591c19bdf3d; }, function (v) { return $2d712cdb275a082d$export$4659b591c19bdf3d = v; });
var $2d712cdb275a082d$export$4659b591c19bdf3d;
"use strict";
$2d712cdb275a082d$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $2d712cdb275a082d$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
const $2d712cdb275a082d$var$parseOrdinalNumberPattern = /\d+/i;
const $2d712cdb275a082d$var$matchEraPatterns = {
    narrow: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
    abbreviated: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
    wide: /^(pred Kristom|pred na[šs][íi]m letopo[čc]tom|po Kristovi|n[áa][šs]ho letopo[čc]tu)/i
};
const $2d712cdb275a082d$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|n)/i
    ]
};
const $2d712cdb275a082d$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]\. [šs]tvr[ťt]rok/i
};
const $2d712cdb275a082d$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $2d712cdb275a082d$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|m[áa]j|j[úu]n|j[úu]l|aug|sep|okt|nov|dec)/i,
    wide: /^(janu[áa]ra?|febru[áa]ra?|(marec|marca)|apr[íi]la?|m[áa]ja?|j[úu]na?|j[úu]la?|augusta?|(september|septembra)|(okt[óo]ber|okt[óo]bra)|(november|novembra)|(december|decembra))/i
};
const $2d712cdb275a082d$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^m[áa]j/i,
        /^j[úu]n/i,
        /^j[úu]l/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $2d712cdb275a082d$var$matchDayPatterns = {
    narrow: /^[npusšp]/i,
    short: /^(ne|po|ut|st|št|pi|so)/i,
    abbreviated: /^(ne|po|ut|st|št|pi|so)/i,
    wide: /^(nede[ľl]a|pondelok|utorok|streda|[šs]tvrtok|piatok|sobota])/i
};
const $2d712cdb275a082d$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^u/i,
        /^s/i,
        /^š/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^u/i,
        /^st/i,
        /^(št|stv)/i,
        /^pi/i,
        /^so/i
    ]
};
const $2d712cdb275a082d$var$matchDayPeriodPatterns = {
    narrow: /^(am|pm|(o )?poln\.?|(nap\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]\.?|(v n\.?|noc))/i,
    abbreviated: /^(am|pm|(o )?poln\.?|(napol\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]er|(v )?noci?)/i,
    any: /^(am|pm|(o )?polnoci?|(na)?poludnie|r[áa]no|popoludn(ie|í|i)|ve[čc]er|(v )?noci?)/i
};
const $2d712cdb275a082d$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /poln/i,
        noon: /^(nap|(na)?pol(\.|u))/i,
        morning: /^r[áa]no/i,
        afternoon: /^pop/i,
        evening: /^ve[čc]/i,
        night: /^(noc|v n\.)/i
    }
};
const $2d712cdb275a082d$var$match = $2d712cdb275a082d$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $2d712cdb275a082d$var$matchOrdinalNumberPattern,
        parsePattern: $2d712cdb275a082d$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $2d712cdb275a082d$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2d712cdb275a082d$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $2d712cdb275a082d$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2d712cdb275a082d$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $2d712cdb275a082d$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2d712cdb275a082d$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $2d712cdb275a082d$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2d712cdb275a082d$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $2d712cdb275a082d$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $2d712cdb275a082d$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("8ZuGh", function(module, exports) {

$parcel$export(module.exports, "sl", function () { return $68bbd1d018459b0a$export$c48c9775cb5125a6; }, function (v) { return $68bbd1d018459b0a$export$c48c9775cb5125a6 = v; });
var $68bbd1d018459b0a$export$c48c9775cb5125a6;
"use strict";
$68bbd1d018459b0a$export$c48c9775cb5125a6 = void 0;

var $cy5aq = parcelRequire("cy5aq");

var $bcjRU = parcelRequire("bcjRU");

var $bw5lF = parcelRequire("bw5lF");

var $40Ko6 = parcelRequire("40Ko6");

var $68Bx5 = parcelRequire("68Bx5");
/**
 * @category Locales
 * @summary Slovenian locale.
 * @language Slovenian
 * @iso-639-2 slv
 * @author Adam Stradovnik [@Neoglyph](https://github.com/Neoglyph)
 * @author Mato Žgajner [@mzgajner](https://github.com/mzgajner)
 */ const $68bbd1d018459b0a$var$sl = $68bbd1d018459b0a$export$c48c9775cb5125a6 = {
    code: "sl",
    formatDistance: $cy5aq.formatDistance,
    formatLong: $bcjRU.formatLong,
    formatRelative: $bw5lF.formatRelative,
    localize: $40Ko6.localize,
    match: $68Bx5.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("cy5aq", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $922cab1c7dff6eb8$export$2c14ff85d6318973; }, function (v) { return $922cab1c7dff6eb8$export$2c14ff85d6318973 = v; });
var $922cab1c7dff6eb8$export$2c14ff85d6318973;
"use strict";
$922cab1c7dff6eb8$export$2c14ff85d6318973 = void 0;
function $922cab1c7dff6eb8$var$isPluralType(val) {
    return val.one !== undefined;
}
const $922cab1c7dff6eb8$var$formatDistanceLocale = {
    lessThanXSeconds: {
        present: {
            one: "manj kot {{count}} sekunda",
            two: "manj kot {{count}} sekundi",
            few: "manj kot {{count}} sekunde",
            other: "manj kot {{count}} sekund"
        },
        past: {
            one: "manj kot {{count}} sekundo",
            two: "manj kot {{count}} sekundama",
            few: "manj kot {{count}} sekundami",
            other: "manj kot {{count}} sekundami"
        },
        future: {
            one: "manj kot {{count}} sekundo",
            two: "manj kot {{count}} sekundi",
            few: "manj kot {{count}} sekunde",
            other: "manj kot {{count}} sekund"
        }
    },
    xSeconds: {
        present: {
            one: "{{count}} sekunda",
            two: "{{count}} sekundi",
            few: "{{count}} sekunde",
            other: "{{count}} sekund"
        },
        past: {
            one: "{{count}} sekundo",
            two: "{{count}} sekundama",
            few: "{{count}} sekundami",
            other: "{{count}} sekundami"
        },
        future: {
            one: "{{count}} sekundo",
            two: "{{count}} sekundi",
            few: "{{count}} sekunde",
            other: "{{count}} sekund"
        }
    },
    halfAMinute: "pol minute",
    lessThanXMinutes: {
        present: {
            one: "manj kot {{count}} minuta",
            two: "manj kot {{count}} minuti",
            few: "manj kot {{count}} minute",
            other: "manj kot {{count}} minut"
        },
        past: {
            one: "manj kot {{count}} minuto",
            two: "manj kot {{count}} minutama",
            few: "manj kot {{count}} minutami",
            other: "manj kot {{count}} minutami"
        },
        future: {
            one: "manj kot {{count}} minuto",
            two: "manj kot {{count}} minuti",
            few: "manj kot {{count}} minute",
            other: "manj kot {{count}} minut"
        }
    },
    xMinutes: {
        present: {
            one: "{{count}} minuta",
            two: "{{count}} minuti",
            few: "{{count}} minute",
            other: "{{count}} minut"
        },
        past: {
            one: "{{count}} minuto",
            two: "{{count}} minutama",
            few: "{{count}} minutami",
            other: "{{count}} minutami"
        },
        future: {
            one: "{{count}} minuto",
            two: "{{count}} minuti",
            few: "{{count}} minute",
            other: "{{count}} minut"
        }
    },
    aboutXHours: {
        present: {
            one: "pribli\u017Eno {{count}} ura",
            two: "pribli\u017Eno {{count}} uri",
            few: "pribli\u017Eno {{count}} ure",
            other: "pribli\u017Eno {{count}} ur"
        },
        past: {
            one: "pribli\u017Eno {{count}} uro",
            two: "pribli\u017Eno {{count}} urama",
            few: "pribli\u017Eno {{count}} urami",
            other: "pribli\u017Eno {{count}} urami"
        },
        future: {
            one: "pribli\u017Eno {{count}} uro",
            two: "pribli\u017Eno {{count}} uri",
            few: "pribli\u017Eno {{count}} ure",
            other: "pribli\u017Eno {{count}} ur"
        }
    },
    xHours: {
        present: {
            one: "{{count}} ura",
            two: "{{count}} uri",
            few: "{{count}} ure",
            other: "{{count}} ur"
        },
        past: {
            one: "{{count}} uro",
            two: "{{count}} urama",
            few: "{{count}} urami",
            other: "{{count}} urami"
        },
        future: {
            one: "{{count}} uro",
            two: "{{count}} uri",
            few: "{{count}} ure",
            other: "{{count}} ur"
        }
    },
    xDays: {
        present: {
            one: "{{count}} dan",
            two: "{{count}} dni",
            few: "{{count}} dni",
            other: "{{count}} dni"
        },
        past: {
            one: "{{count}} dnem",
            two: "{{count}} dnevoma",
            few: "{{count}} dnevi",
            other: "{{count}} dnevi"
        },
        future: {
            one: "{{count}} dan",
            two: "{{count}} dni",
            few: "{{count}} dni",
            other: "{{count}} dni"
        }
    },
    // no tenses for weeks?
    aboutXWeeks: {
        one: "pribli\u017Eno {{count}} teden",
        two: "pribli\u017Eno {{count}} tedna",
        few: "pribli\u017Eno {{count}} tedne",
        other: "pribli\u017Eno {{count}} tednov"
    },
    // no tenses for weeks?
    xWeeks: {
        one: "{{count}} teden",
        two: "{{count}} tedna",
        few: "{{count}} tedne",
        other: "{{count}} tednov"
    },
    aboutXMonths: {
        present: {
            one: "pribli\u017Eno {{count}} mesec",
            two: "pribli\u017Eno {{count}} meseca",
            few: "pribli\u017Eno {{count}} mesece",
            other: "pribli\u017Eno {{count}} mesecev"
        },
        past: {
            one: "pribli\u017Eno {{count}} mesecem",
            two: "pribli\u017Eno {{count}} mesecema",
            few: "pribli\u017Eno {{count}} meseci",
            other: "pribli\u017Eno {{count}} meseci"
        },
        future: {
            one: "pribli\u017Eno {{count}} mesec",
            two: "pribli\u017Eno {{count}} meseca",
            few: "pribli\u017Eno {{count}} mesece",
            other: "pribli\u017Eno {{count}} mesecev"
        }
    },
    xMonths: {
        present: {
            one: "{{count}} mesec",
            two: "{{count}} meseca",
            few: "{{count}} meseci",
            other: "{{count}} mesecev"
        },
        past: {
            one: "{{count}} mesecem",
            two: "{{count}} mesecema",
            few: "{{count}} meseci",
            other: "{{count}} meseci"
        },
        future: {
            one: "{{count}} mesec",
            two: "{{count}} meseca",
            few: "{{count}} mesece",
            other: "{{count}} mesecev"
        }
    },
    aboutXYears: {
        present: {
            one: "pribli\u017Eno {{count}} leto",
            two: "pribli\u017Eno {{count}} leti",
            few: "pribli\u017Eno {{count}} leta",
            other: "pribli\u017Eno {{count}} let"
        },
        past: {
            one: "pribli\u017Eno {{count}} letom",
            two: "pribli\u017Eno {{count}} letoma",
            few: "pribli\u017Eno {{count}} leti",
            other: "pribli\u017Eno {{count}} leti"
        },
        future: {
            one: "pribli\u017Eno {{count}} leto",
            two: "pribli\u017Eno {{count}} leti",
            few: "pribli\u017Eno {{count}} leta",
            other: "pribli\u017Eno {{count}} let"
        }
    },
    xYears: {
        present: {
            one: "{{count}} leto",
            two: "{{count}} leti",
            few: "{{count}} leta",
            other: "{{count}} let"
        },
        past: {
            one: "{{count}} letom",
            two: "{{count}} letoma",
            few: "{{count}} leti",
            other: "{{count}} leti"
        },
        future: {
            one: "{{count}} leto",
            two: "{{count}} leti",
            few: "{{count}} leta",
            other: "{{count}} let"
        }
    },
    overXYears: {
        present: {
            one: "ve\u010D kot {{count}} leto",
            two: "ve\u010D kot {{count}} leti",
            few: "ve\u010D kot {{count}} leta",
            other: "ve\u010D kot {{count}} let"
        },
        past: {
            one: "ve\u010D kot {{count}} letom",
            two: "ve\u010D kot {{count}} letoma",
            few: "ve\u010D kot {{count}} leti",
            other: "ve\u010D kot {{count}} leti"
        },
        future: {
            one: "ve\u010D kot {{count}} leto",
            two: "ve\u010D kot {{count}} leti",
            few: "ve\u010D kot {{count}} leta",
            other: "ve\u010D kot {{count}} let"
        }
    },
    almostXYears: {
        present: {
            one: "skoraj {{count}} leto",
            two: "skoraj {{count}} leti",
            few: "skoraj {{count}} leta",
            other: "skoraj {{count}} let"
        },
        past: {
            one: "skoraj {{count}} letom",
            two: "skoraj {{count}} letoma",
            few: "skoraj {{count}} leti",
            other: "skoraj {{count}} leti"
        },
        future: {
            one: "skoraj {{count}} leto",
            two: "skoraj {{count}} leti",
            few: "skoraj {{count}} leta",
            other: "skoraj {{count}} let"
        }
    }
};
function $922cab1c7dff6eb8$var$getFormFromCount(count) {
    switch(count % 100){
        case 1:
            return "one";
        case 2:
            return "two";
        case 3:
        case 4:
            return "few";
        default:
            return "other";
    }
}
const $922cab1c7dff6eb8$var$formatDistance = (token, count, options)=>{
    let result = "";
    let tense = "present";
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) {
            tense = "future";
            result = "\u010Dez ";
        } else {
            tense = "past";
            result = "pred ";
        }
    }
    const tokenValue = $922cab1c7dff6eb8$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result += tokenValue;
    else {
        const form = $922cab1c7dff6eb8$var$getFormFromCount(count);
        if ($922cab1c7dff6eb8$var$isPluralType(tokenValue)) result += tokenValue[form].replace("{{count}}", String(count));
        else result += tokenValue[tense][form].replace("{{count}}", String(count));
    }
    return result;
};
$922cab1c7dff6eb8$export$2c14ff85d6318973 = $922cab1c7dff6eb8$var$formatDistance;

});

parcelRegister("bcjRU", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $82703a2ae0a350fe$export$cbf60ecb96cbb82f; }, function (v) { return $82703a2ae0a350fe$export$cbf60ecb96cbb82f = v; });
var $82703a2ae0a350fe$export$cbf60ecb96cbb82f;
"use strict";
$82703a2ae0a350fe$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $82703a2ae0a350fe$var$dateFormats = {
    full: "EEEE, dd. MMMM y",
    long: "dd. MMMM y",
    medium: "d. MMM y",
    short: "d. MM. yy"
};
const $82703a2ae0a350fe$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $82703a2ae0a350fe$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $82703a2ae0a350fe$var$formatLong = $82703a2ae0a350fe$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $82703a2ae0a350fe$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $82703a2ae0a350fe$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $82703a2ae0a350fe$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("bw5lF", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $8626d4f11b4dd341$export$8fbbfd65594f46a0; }, function (v) { return $8626d4f11b4dd341$export$8fbbfd65594f46a0 = v; });
var $8626d4f11b4dd341$export$8fbbfd65594f46a0;
"use strict";
$8626d4f11b4dd341$export$8fbbfd65594f46a0 = void 0;
const $8626d4f11b4dd341$var$formatRelativeLocale = {
    lastWeek: (date)=>{
        const day = date.getDay();
        switch(day){
            case 0:
                return "'prej\u0161njo nedeljo ob' p";
            case 3:
                return "'prej\u0161njo sredo ob' p";
            case 6:
                return "'prej\u0161njo soboto ob' p";
            default:
                return "'prej\u0161nji' EEEE 'ob' p";
        }
    },
    yesterday: "'v\u010Deraj ob' p",
    today: "'danes ob' p",
    tomorrow: "'jutri ob' p",
    nextWeek: (date)=>{
        const day = date.getDay();
        switch(day){
            case 0:
                return "'naslednjo nedeljo ob' p";
            case 3:
                return "'naslednjo sredo ob' p";
            case 6:
                return "'naslednjo soboto ob' p";
            default:
                return "'naslednji' EEEE 'ob' p";
        }
    },
    other: "P"
};
const $8626d4f11b4dd341$var$formatRelative = (token, date, _baseDate, _options)=>{
    const format = $8626d4f11b4dd341$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
$8626d4f11b4dd341$export$8fbbfd65594f46a0 = $8626d4f11b4dd341$var$formatRelative;

});

parcelRegister("40Ko6", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $2ebb2529d1d36364$export$b3bd0bc58e36cd63; }, function (v) { return $2ebb2529d1d36364$export$b3bd0bc58e36cd63 = v; });
var $2ebb2529d1d36364$export$b3bd0bc58e36cd63;
"use strict";
$2ebb2529d1d36364$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $2ebb2529d1d36364$var$eraValues = {
    narrow: [
        "pr. n. \u0161t.",
        "po n. \u0161t."
    ],
    abbreviated: [
        "pr. n. \u0161t.",
        "po n. \u0161t."
    ],
    wide: [
        "pred na\u0161im \u0161tetjem",
        "po na\u0161em \u0161tetju"
    ]
};
const $2ebb2529d1d36364$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1. \u010Det.",
        "2. \u010Det.",
        "3. \u010Det.",
        "4. \u010Det."
    ],
    wide: [
        "1. \u010Detrtletje",
        "2. \u010Detrtletje",
        "3. \u010Detrtletje",
        "4. \u010Detrtletje"
    ]
};
const $2ebb2529d1d36364$var$monthValues = {
    narrow: [
        "j",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mar.",
        "apr.",
        "maj",
        "jun.",
        "jul.",
        "avg.",
        "sep.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "januar",
        "februar",
        "marec",
        "april",
        "maj",
        "junij",
        "julij",
        "avgust",
        "september",
        "oktober",
        "november",
        "december"
    ]
};
const $2ebb2529d1d36364$var$dayValues = {
    narrow: [
        "n",
        "p",
        "t",
        "s",
        "\u010D",
        "p",
        "s"
    ],
    short: [
        "ned.",
        "pon.",
        "tor.",
        "sre.",
        "\u010Det.",
        "pet.",
        "sob."
    ],
    abbreviated: [
        "ned.",
        "pon.",
        "tor.",
        "sre.",
        "\u010Det.",
        "pet.",
        "sob."
    ],
    wide: [
        "nedelja",
        "ponedeljek",
        "torek",
        "sreda",
        "\u010Detrtek",
        "petek",
        "sobota"
    ]
};
const $2ebb2529d1d36364$var$dayPeriodValues = {
    narrow: {
        am: "d",
        pm: "p",
        midnight: "24.00",
        noon: "12.00",
        morning: "j",
        afternoon: "p",
        evening: "v",
        night: "n"
    },
    abbreviated: {
        am: "dop.",
        pm: "pop.",
        midnight: "poln.",
        noon: "pold.",
        morning: "jut.",
        afternoon: "pop.",
        evening: "ve\u010D.",
        night: "no\u010D"
    },
    wide: {
        am: "dop.",
        pm: "pop.",
        midnight: "polno\u010D",
        noon: "poldne",
        morning: "jutro",
        afternoon: "popoldne",
        evening: "ve\u010Der",
        night: "no\u010D"
    }
};
const $2ebb2529d1d36364$var$formattingDayPeriodValues = {
    narrow: {
        am: "d",
        pm: "p",
        midnight: "24.00",
        noon: "12.00",
        morning: "zj",
        afternoon: "p",
        evening: "zv",
        night: "po"
    },
    abbreviated: {
        am: "dop.",
        pm: "pop.",
        midnight: "opoln.",
        noon: "opold.",
        morning: "zjut.",
        afternoon: "pop.",
        evening: "zve\u010D.",
        night: "pono\u010Di"
    },
    wide: {
        am: "dop.",
        pm: "pop.",
        midnight: "opolno\u010Di",
        noon: "opoldne",
        morning: "zjutraj",
        afternoon: "popoldan",
        evening: "zve\u010Der",
        night: "pono\u010Di"
    }
};
const $2ebb2529d1d36364$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $2ebb2529d1d36364$var$localize = $2ebb2529d1d36364$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $2ebb2529d1d36364$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $2ebb2529d1d36364$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $2ebb2529d1d36364$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $2ebb2529d1d36364$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $2ebb2529d1d36364$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $2ebb2529d1d36364$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $2ebb2529d1d36364$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("68Bx5", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $47809aa1b410bd28$export$4659b591c19bdf3d; }, function (v) { return $47809aa1b410bd28$export$4659b591c19bdf3d = v; });
var $47809aa1b410bd28$export$4659b591c19bdf3d;
"use strict";
$47809aa1b410bd28$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $47809aa1b410bd28$var$matchOrdinalNumberPattern = /^(\d+)\./i;
const $47809aa1b410bd28$var$parseOrdinalNumberPattern = /\d+/i;
const $47809aa1b410bd28$var$matchEraPatterns = {
    abbreviated: /^(pr\. n\. št\.|po n\. št\.)/i,
    wide: /^(pred Kristusom|pred na[sš]im [sš]tetjem|po Kristusu|po na[sš]em [sš]tetju|na[sš]ega [sš]tetja)/i
};
const $47809aa1b410bd28$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|na[sš]em)/i
    ]
};
const $47809aa1b410bd28$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?[čc]et\.?/i,
    wide: /^[1234]\. [čc]etrtletje/i
};
const $47809aa1b410bd28$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $47809aa1b410bd28$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan\.|feb\.|mar\.|apr\.|maj|jun\.|jul\.|avg\.|sep\.|okt\.|nov\.|dec\.)/i,
    wide: /^(januar|februar|marec|april|maj|junij|julij|avgust|september|oktober|november|december)/i
};
const $47809aa1b410bd28$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    abbreviated: [
        /^ja/i,
        /^fe/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^av/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    wide: [
        /^ja/i,
        /^fe/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^av/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $47809aa1b410bd28$var$matchDayPatterns = {
    narrow: /^[nptsčc]/i,
    short: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
    abbreviated: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
    wide: /^(nedelja|ponedeljek|torek|sreda|[cč]etrtek|petek|sobota)/i
};
const $47809aa1b410bd28$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^t/i,
        /^s/i,
        /^[cč]/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^t/i,
        /^sr/i,
        /^[cč]/i,
        /^pe/i,
        /^so/i
    ]
};
const $47809aa1b410bd28$var$matchDayPeriodPatterns = {
    narrow: /^(d|po?|z?v|n|z?j|24\.00|12\.00)/i,
    any: /^(dop\.|pop\.|o?poln(\.|o[cč]i?)|o?pold(\.|ne)|z?ve[cč](\.|er)|(po)?no[cč]i?|popold(ne|an)|jut(\.|ro)|zjut(\.|raj))/i
};
const $47809aa1b410bd28$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^d/i,
        pm: /^p/i,
        midnight: /^24/i,
        noon: /^12/i,
        morning: /^(z?j)/i,
        afternoon: /^p/i,
        evening: /^(z?v)/i,
        night: /^(n|po)/i
    },
    any: {
        am: /^dop\./i,
        pm: /^pop\./i,
        midnight: /^o?poln/i,
        noon: /^o?pold/i,
        morning: /j/i,
        afternoon: /^pop\./i,
        evening: /^z?ve/i,
        night: /(po)?no/i
    }
};
const $47809aa1b410bd28$var$match = $47809aa1b410bd28$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $47809aa1b410bd28$var$matchOrdinalNumberPattern,
        parsePattern: $47809aa1b410bd28$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $47809aa1b410bd28$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $47809aa1b410bd28$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $47809aa1b410bd28$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $47809aa1b410bd28$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $47809aa1b410bd28$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $47809aa1b410bd28$var$parseMonthPatterns,
        defaultParseWidth: "wide"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $47809aa1b410bd28$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $47809aa1b410bd28$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $47809aa1b410bd28$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $47809aa1b410bd28$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("34wYM", function(module, exports) {

$parcel$export(module.exports, "sq", function () { return $23cb53d791b3f298$export$a8157a6a5eefedbe; }, function (v) { return $23cb53d791b3f298$export$a8157a6a5eefedbe = v; });
var $23cb53d791b3f298$export$a8157a6a5eefedbe;
"use strict";
$23cb53d791b3f298$export$a8157a6a5eefedbe = void 0;

var $75Nho = parcelRequire("75Nho");

var $9DtBx = parcelRequire("9DtBx");

var $dOaAJ = parcelRequire("dOaAJ");

var $gTsif = parcelRequire("gTsif");

var $jYHaW = parcelRequire("jYHaW");
/**
 * @category Locales
 * @summary Albanian locale.
 * @language Shqip
 * @iso-639-2 sqi
 * @author Ardit Dine [@arditdine](https://github.com/arditdine)
 */ const $23cb53d791b3f298$var$sq = $23cb53d791b3f298$export$a8157a6a5eefedbe = {
    code: "sq",
    formatDistance: $75Nho.formatDistance,
    formatLong: $9DtBx.formatLong,
    formatRelative: $dOaAJ.formatRelative,
    localize: $gTsif.localize,
    match: $jYHaW.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("75Nho", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $529f39f01b5cf6a7$export$2c14ff85d6318973; }, function (v) { return $529f39f01b5cf6a7$export$2c14ff85d6318973 = v; });
var $529f39f01b5cf6a7$export$2c14ff85d6318973;
"use strict";
$529f39f01b5cf6a7$export$2c14ff85d6318973 = void 0;
const $529f39f01b5cf6a7$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "m\xeb pak se nj\xeb sekond\xeb",
        other: "m\xeb pak se {{count}} sekonda"
    },
    xSeconds: {
        one: "1 sekond\xeb",
        other: "{{count}} sekonda"
    },
    halfAMinute: "gjys\xebm minuti",
    lessThanXMinutes: {
        one: "m\xeb pak se nj\xeb minute",
        other: "m\xeb pak se {{count}} minuta"
    },
    xMinutes: {
        one: "1 minut\xeb",
        other: "{{count}} minuta"
    },
    aboutXHours: {
        one: "rreth 1 or\xeb",
        other: "rreth {{count}} or\xeb"
    },
    xHours: {
        one: "1 or\xeb",
        other: "{{count}} or\xeb"
    },
    xDays: {
        one: "1 dit\xeb",
        other: "{{count}} dit\xeb"
    },
    aboutXWeeks: {
        one: "rreth 1 jav\xeb",
        other: "rreth {{count}} jav\xeb"
    },
    xWeeks: {
        one: "1 jav\xeb",
        other: "{{count}} jav\xeb"
    },
    aboutXMonths: {
        one: "rreth 1 muaj",
        other: "rreth {{count}} muaj"
    },
    xMonths: {
        one: "1 muaj",
        other: "{{count}} muaj"
    },
    aboutXYears: {
        one: "rreth 1 vit",
        other: "rreth {{count}} vite"
    },
    xYears: {
        one: "1 vit",
        other: "{{count}} vite"
    },
    overXYears: {
        one: "mbi 1 vit",
        other: "mbi {{count}} vite"
    },
    almostXYears: {
        one: "pothuajse 1 vit",
        other: "pothuajse {{count}} vite"
    }
};
const $529f39f01b5cf6a7$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $529f39f01b5cf6a7$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "n\xeb " + result;
        else return result + " m\xeb par\xeb";
    }
    return result;
};
$529f39f01b5cf6a7$export$2c14ff85d6318973 = $529f39f01b5cf6a7$var$formatDistance;

});

parcelRegister("9DtBx", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $703eb865df745fce$export$cbf60ecb96cbb82f; }, function (v) { return $703eb865df745fce$export$cbf60ecb96cbb82f = v; });
var $703eb865df745fce$export$cbf60ecb96cbb82f;
"use strict";
$703eb865df745fce$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $703eb865df745fce$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $703eb865df745fce$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $703eb865df745fce$var$dateTimeFormats = {
    full: "{{date}} 'n\xeb' {{time}}",
    long: "{{date}} 'n\xeb' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $703eb865df745fce$var$formatLong = $703eb865df745fce$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $703eb865df745fce$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $703eb865df745fce$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $703eb865df745fce$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("dOaAJ", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $a0d8291c084d180d$export$8fbbfd65594f46a0; }, function (v) { return $a0d8291c084d180d$export$8fbbfd65594f46a0 = v; });
var $a0d8291c084d180d$export$8fbbfd65594f46a0;
"use strict";
$a0d8291c084d180d$export$8fbbfd65594f46a0 = void 0;
const $a0d8291c084d180d$var$formatRelativeLocale = {
    lastWeek: "'t\xeb' eeee 'e shkuar n\xeb' p",
    yesterday: "'dje n\xeb' p",
    today: "'sot n\xeb' p",
    tomorrow: "'nes\xebr n\xeb' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $a0d8291c084d180d$var$formatRelative = (token, _date, _baseDate, _options)=>$a0d8291c084d180d$var$formatRelativeLocale[token];
$a0d8291c084d180d$export$8fbbfd65594f46a0 = $a0d8291c084d180d$var$formatRelative;

});

parcelRegister("gTsif", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $c4c7badd17a83064$export$b3bd0bc58e36cd63; }, function (v) { return $c4c7badd17a83064$export$b3bd0bc58e36cd63 = v; });
var $c4c7badd17a83064$export$b3bd0bc58e36cd63;
"use strict";
$c4c7badd17a83064$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $c4c7badd17a83064$var$eraValues = {
    narrow: [
        "P",
        "M"
    ],
    abbreviated: [
        "PK",
        "MK"
    ],
    wide: [
        "Para Krishtit",
        "Mbas Krishtit"
    ]
};
const $c4c7badd17a83064$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "4-mujori I",
        "4-mujori II",
        "4-mujori III",
        "4-mujori IV"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $c4c7badd17a83064$var$monthValues = {
    narrow: [
        "J",
        "S",
        "M",
        "P",
        "M",
        "Q",
        "K",
        "G",
        "S",
        "T",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Shk",
        "Mar",
        "Pri",
        "Maj",
        "Qer",
        "Kor",
        "Gus",
        "Sht",
        "Tet",
        "N\xebn",
        "Dhj"
    ],
    wide: [
        "Janar",
        "Shkurt",
        "Mars",
        "Prill",
        "Maj",
        "Qershor",
        "Korrik",
        "Gusht",
        "Shtator",
        "Tetor",
        "N\xebntor",
        "Dhjetor"
    ]
};
const $c4c7badd17a83064$var$dayValues = {
    narrow: [
        "D",
        "H",
        "M",
        "M",
        "E",
        "P",
        "S"
    ],
    short: [
        "Di",
        "H\xeb",
        "Ma",
        "M\xeb",
        "En",
        "Pr",
        "Sh"
    ],
    abbreviated: [
        "Die",
        "H\xebn",
        "Mar",
        "M\xebr",
        "Enj",
        "Pre",
        "Sht"
    ],
    wide: [
        "Diel\xeb",
        "H\xebn\xeb",
        "Mart\xeb",
        "M\xebrkur\xeb",
        "Enjte",
        "Premte",
        "Shtun\xeb"
    ]
};
const $c4c7badd17a83064$var$dayPeriodValues = {
    narrow: {
        am: "p",
        pm: "m",
        midnight: "m",
        noon: "d",
        morning: "m\xebngjes",
        afternoon: "dite",
        evening: "mbr\xebmje",
        night: "nat\xeb"
    },
    abbreviated: {
        am: "PD",
        pm: "MD",
        midnight: "mesn\xebt\xeb",
        noon: "drek",
        morning: "m\xebngjes",
        afternoon: "mbasdite",
        evening: "mbr\xebmje",
        night: "nat\xeb"
    },
    wide: {
        am: "p.d.",
        pm: "m.d.",
        midnight: "mesn\xebt\xeb",
        noon: "drek",
        morning: "m\xebngjes",
        afternoon: "mbasdite",
        evening: "mbr\xebmje",
        night: "nat\xeb"
    }
};
const $c4c7badd17a83064$var$formattingDayPeriodValues = {
    narrow: {
        am: "p",
        pm: "m",
        midnight: "m",
        noon: "d",
        morning: "n\xeb m\xebngjes",
        afternoon: "n\xeb mbasdite",
        evening: "n\xeb mbr\xebmje",
        night: "n\xeb mesnat\xeb"
    },
    abbreviated: {
        am: "PD",
        pm: "MD",
        midnight: "mesnat\xeb",
        noon: "drek",
        morning: "n\xeb m\xebngjes",
        afternoon: "n\xeb mbasdite",
        evening: "n\xeb mbr\xebmje",
        night: "n\xeb mesnat\xeb"
    },
    wide: {
        am: "p.d.",
        pm: "m.d.",
        midnight: "mesnat\xeb",
        noon: "drek",
        morning: "n\xeb m\xebngjes",
        afternoon: "n\xeb mbasdite",
        evening: "n\xeb mbr\xebmje",
        night: "n\xeb mesnat\xeb"
    }
};
const $c4c7badd17a83064$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    if (options?.unit === "hour") return String(number);
    if (number === 1) return number + "-r\xeb";
    if (number === 4) return number + "t";
    return number + "-t\xeb";
};
const $c4c7badd17a83064$var$localize = $c4c7badd17a83064$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $c4c7badd17a83064$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $c4c7badd17a83064$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $c4c7badd17a83064$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $c4c7badd17a83064$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $c4c7badd17a83064$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $c4c7badd17a83064$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $c4c7badd17a83064$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("jYHaW", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $e8b51caf63f0904f$export$4659b591c19bdf3d; }, function (v) { return $e8b51caf63f0904f$export$4659b591c19bdf3d = v; });
var $e8b51caf63f0904f$export$4659b591c19bdf3d;
"use strict";
$e8b51caf63f0904f$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $e8b51caf63f0904f$var$matchOrdinalNumberPattern = /^(\d+)(-rë|-të|t|)?/i;
const $e8b51caf63f0904f$var$parseOrdinalNumberPattern = /\d+/i;
const $e8b51caf63f0904f$var$matchEraPatterns = {
    narrow: /^(p|m)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(para krishtit|mbas krishtit)/i
};
const $e8b51caf63f0904f$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(p|m)/i
    ]
};
const $e8b51caf63f0904f$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]-mujori (i{1,3}|iv)/i
};
const $e8b51caf63f0904f$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $e8b51caf63f0904f$var$matchMonthPatterns = {
    narrow: /^[jsmpqkftnd]/i,
    abbreviated: /^(jan|shk|mar|pri|maj|qer|kor|gus|sht|tet|nën|dhj)/i,
    wide: /^(janar|shkurt|mars|prill|maj|qershor|korrik|gusht|shtator|tetor|nëntor|dhjetor)/i
};
const $e8b51caf63f0904f$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^s/i,
        /^m/i,
        /^p/i,
        /^m/i,
        /^q/i,
        /^k/i,
        /^g/i,
        /^s/i,
        /^t/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^shk/i,
        /^mar/i,
        /^pri/i,
        /^maj/i,
        /^qer/i,
        /^kor/i,
        /^gu/i,
        /^sht/i,
        /^tet/i,
        /^n/i,
        /^d/i
    ]
};
const $e8b51caf63f0904f$var$matchDayPatterns = {
    narrow: /^[dhmeps]/i,
    short: /^(di|hë|ma|më|en|pr|sh)/i,
    abbreviated: /^(die|hën|mar|mër|enj|pre|sht)/i,
    wide: /^(dielë|hënë|martë|mërkurë|enjte|premte|shtunë)/i
};
const $e8b51caf63f0904f$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^h/i,
        /^m/i,
        /^m/i,
        /^e/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^h/i,
        /^ma/i,
        /^më/i,
        /^e/i,
        /^p/i,
        /^s/i
    ]
};
const $e8b51caf63f0904f$var$matchDayPeriodPatterns = {
    narrow: /^(p|m|me|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i,
    any: /^([pm]\.?\s?d\.?|drek|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i
};
const $e8b51caf63f0904f$var$parseDayPeriodPatterns = {
    any: {
        am: /^p/i,
        pm: /^m/i,
        midnight: /^me/i,
        noon: /^dr/i,
        morning: /mëngjes/i,
        afternoon: /mbasdite/i,
        evening: /mbrëmje/i,
        night: /natë/i
    }
};
const $e8b51caf63f0904f$var$match = $e8b51caf63f0904f$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $e8b51caf63f0904f$var$matchOrdinalNumberPattern,
        parsePattern: $e8b51caf63f0904f$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e8b51caf63f0904f$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e8b51caf63f0904f$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e8b51caf63f0904f$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e8b51caf63f0904f$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e8b51caf63f0904f$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e8b51caf63f0904f$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e8b51caf63f0904f$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e8b51caf63f0904f$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e8b51caf63f0904f$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $e8b51caf63f0904f$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("ggfYx", function(module, exports) {

$parcel$export(module.exports, "sr", function () { return $bd6a885d0388696d$export$187592e8a03966af; }, function (v) { return $bd6a885d0388696d$export$187592e8a03966af = v; });
var $bd6a885d0388696d$export$187592e8a03966af;
"use strict";
$bd6a885d0388696d$export$187592e8a03966af = void 0;

var $lUNyh = parcelRequire("lUNyh");

var $4nEwn = parcelRequire("4nEwn");

var $5n107 = parcelRequire("5n107");

var $03F2T = parcelRequire("03F2T");

var $llsgO = parcelRequire("llsgO");
/**
 * @category Locales
 * @summary Serbian cyrillic locale.
 * @language Serbian
 * @iso-639-2 srp
 * @author Igor Radivojević [@rogyvoje](https://github.com/rogyvoje)
 */ const $bd6a885d0388696d$var$sr = $bd6a885d0388696d$export$187592e8a03966af = {
    code: "sr",
    formatDistance: $lUNyh.formatDistance,
    formatLong: $4nEwn.formatLong,
    formatRelative: $5n107.formatRelative,
    localize: $03F2T.localize,
    match: $llsgO.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("lUNyh", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $ff4543eb89b3efb7$export$2c14ff85d6318973; }, function (v) { return $ff4543eb89b3efb7$export$2c14ff85d6318973 = v; });
var $ff4543eb89b3efb7$export$2c14ff85d6318973;
"use strict";
$ff4543eb89b3efb7$export$2c14ff85d6318973 = void 0;
const $ff4543eb89b3efb7$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
            withPrepositionAgo: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
            withPrepositionIn: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0443"
        },
        dual: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
        other: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    xSeconds: {
        one: {
            standalone: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            withPrepositionAgo: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
            withPrepositionIn: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0443"
        },
        dual: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    halfAMinute: "\u043F\u043E\u043B\u0430 \u043C\u0438\u043D\u0443\u0442\u0435",
    lessThanXMinutes: {
        one: {
            standalone: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0435",
            withPrepositionAgo: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0435",
            withPrepositionIn: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0443"
        },
        dual: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0435",
        other: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0430"
    },
    xMinutes: {
        one: {
            standalone: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
            withPrepositionAgo: "1 \u043C\u0438\u043D\u0443\u0442\u0435",
            withPrepositionIn: "1 \u043C\u0438\u043D\u0443\u0442\u0443"
        },
        dual: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0435",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0430"
    },
    aboutXHours: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u0441\u0430\u0442",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u0441\u0430\u0442",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u0441\u0430\u0442"
        },
        dual: "\u043E\u043A\u043E {{count}} \u0441\u0430\u0442\u0430",
        other: "\u043E\u043A\u043E {{count}} \u0441\u0430\u0442\u0438"
    },
    xHours: {
        one: {
            standalone: "1 \u0441\u0430\u0442",
            withPrepositionAgo: "1 \u0441\u0430\u0442",
            withPrepositionIn: "1 \u0441\u0430\u0442"
        },
        dual: "{{count}} \u0441\u0430\u0442\u0430",
        other: "{{count}} \u0441\u0430\u0442\u0438"
    },
    xDays: {
        one: {
            standalone: "1 \u0434\u0430\u043D",
            withPrepositionAgo: "1 \u0434\u0430\u043D",
            withPrepositionIn: "1 \u0434\u0430\u043D"
        },
        dual: "{{count}} \u0434\u0430\u043D\u0430",
        other: "{{count}} \u0434\u0430\u043D\u0430"
    },
    aboutXWeeks: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443"
        },
        dual: "\u043E\u043A\u043E {{count}} \u043D\u0435\u0434\u0435\u0459\u0435",
        other: "\u043E\u043A\u043E {{count}} \u043D\u0435\u0434\u0435\u0459\u0435"
    },
    xWeeks: {
        one: {
            standalone: "1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionAgo: "1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionIn: "1 \u043D\u0435\u0434\u0435\u0459\u0443"
        },
        dual: "{{count}} \u043D\u0435\u0434\u0435\u0459\u0435",
        other: "{{count}} \u043D\u0435\u0434\u0435\u0459\u0435"
    },
    aboutXMonths: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446"
        },
        dual: "\u043E\u043A\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0430",
        other: "\u043E\u043A\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    xMonths: {
        one: {
            standalone: "1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionAgo: "1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionIn: "1 \u043C\u0435\u0441\u0435\u0446"
        },
        dual: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0430",
        other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    aboutXYears: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "\u043E\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "\u043E\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    },
    xYears: {
        one: {
            standalone: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
            withPrepositionAgo: "1 \u0433\u043E\u0434\u0438\u043D\u0435",
            withPrepositionIn: "1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    },
    overXYears: {
        one: {
            standalone: "\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionAgo: "\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionIn: "\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "\u043F\u0440\u0435\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "\u043F\u0440\u0435\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    },
    almostXYears: {
        one: {
            standalone: "\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionAgo: "\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionIn: "\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "\u0433\u043E\u0442\u043E\u0432\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "\u0433\u043E\u0442\u043E\u0432\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    }
};
const $ff4543eb89b3efb7$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $ff4543eb89b3efb7$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) {
        if (options?.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== "1" // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0437\u0430 " + result;
        else return "\u043F\u0440\u0435 " + result;
    }
    return result;
};
$ff4543eb89b3efb7$export$2c14ff85d6318973 = $ff4543eb89b3efb7$var$formatDistance;

});

parcelRegister("4nEwn", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $3308be0f5b260a22$export$cbf60ecb96cbb82f; }, function (v) { return $3308be0f5b260a22$export$cbf60ecb96cbb82f = v; });
var $3308be0f5b260a22$export$cbf60ecb96cbb82f;
"use strict";
$3308be0f5b260a22$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $3308be0f5b260a22$var$dateFormats = {
    full: "EEEE, d. MMMM yyyy.",
    long: "d. MMMM yyyy.",
    medium: "d. MMM yy.",
    short: "dd. MM. yy."
};
const $3308be0f5b260a22$var$timeFormats = {
    full: "HH:mm:ss (zzzz)",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $3308be0f5b260a22$var$dateTimeFormats = {
    full: "{{date}} '\u0443' {{time}}",
    long: "{{date}} '\u0443' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $3308be0f5b260a22$var$formatLong = $3308be0f5b260a22$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $3308be0f5b260a22$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $3308be0f5b260a22$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $3308be0f5b260a22$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("5n107", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $3e8fe0843604f474$export$8fbbfd65594f46a0; }, function (v) { return $3e8fe0843604f474$export$8fbbfd65594f46a0 = v; });
var $3e8fe0843604f474$export$8fbbfd65594f46a0;
"use strict";
$3e8fe0843604f474$export$8fbbfd65594f46a0 = void 0;
const $3e8fe0843604f474$var$formatRelativeLocale = {
    lastWeek: (date)=>{
        const day = date.getDay();
        switch(day){
            case 0:
                return "'\u043F\u0440\u043E\u0448\u043B\u0435 \u043D\u0435\u0434\u0435\u0459\u0435 \u0443' p";
            case 3:
                return "'\u043F\u0440\u043E\u0448\u043B\u0435 \u0441\u0440\u0435\u0434\u0435 \u0443' p";
            case 6:
                return "'\u043F\u0440\u043E\u0448\u043B\u0435 \u0441\u0443\u0431\u043E\u0442\u0435 \u0443' p";
            default:
                return "'\u043F\u0440\u043E\u0448\u043B\u0438' EEEE '\u0443' p";
        }
    },
    yesterday: "'\u0458\u0443\u0447\u0435 \u0443' p",
    today: "'\u0434\u0430\u043D\u0430\u0441 \u0443' p",
    tomorrow: "'\u0441\u0443\u0442\u0440\u0430 \u0443' p",
    nextWeek: (date)=>{
        const day = date.getDay();
        switch(day){
            case 0:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0435 \u043D\u0435\u0434\u0435\u0459\u0435 \u0443' p";
            case 3:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0443 \u0441\u0440\u0435\u0434\u0443 \u0443' p";
            case 6:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0443 \u0441\u0443\u0431\u043E\u0442\u0443 \u0443' p";
            default:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0438' EEEE '\u0443' p";
        }
    },
    other: "P"
};
const $3e8fe0843604f474$var$formatRelative = (token, date, _baseDate, _options)=>{
    const format = $3e8fe0843604f474$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
$3e8fe0843604f474$export$8fbbfd65594f46a0 = $3e8fe0843604f474$var$formatRelative;

});

parcelRegister("03F2T", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $00b01ebf8627de14$export$b3bd0bc58e36cd63; }, function (v) { return $00b01ebf8627de14$export$b3bd0bc58e36cd63 = v; });
var $00b01ebf8627de14$export$b3bd0bc58e36cd63;
"use strict";
$00b01ebf8627de14$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $00b01ebf8627de14$var$eraValues = {
    narrow: [
        "\u043F\u0440.\u043D.\u0435.",
        "\u0410\u0414"
    ],
    abbreviated: [
        "\u043F\u0440. \u0425\u0440.",
        "\u043F\u043E. \u0425\u0440."
    ],
    wide: [
        "\u041F\u0440\u0435 \u0425\u0440\u0438\u0441\u0442\u0430",
        "\u041F\u043E\u0441\u043B\u0435 \u0425\u0440\u0438\u0441\u0442\u0430"
    ]
};
const $00b01ebf8627de14$var$quarterValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4."
    ],
    abbreviated: [
        "1. \u043A\u0432.",
        "2. \u043A\u0432.",
        "3. \u043A\u0432.",
        "4. \u043A\u0432."
    ],
    wide: [
        "1. \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2. \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3. \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4. \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
const $00b01ebf8627de14$var$monthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "\u0458\u0430\u043D",
        "\u0444\u0435\u0431",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0432",
        "\u0434\u0435\u0446"
    ],
    wide: [
        "\u0458\u0430\u043D\u0443\u0430\u0440",
        "\u0444\u0435\u0431\u0440\u0443\u0430\u0440",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0431\u0430\u0440",
        "\u043E\u043A\u0442\u043E\u0431\u0430\u0440",
        "\u043D\u043E\u0432\u0435\u043C\u0431\u0430\u0440",
        "\u0434\u0435\u0446\u0435\u043C\u0431\u0430\u0440"
    ]
};
const $00b01ebf8627de14$var$formattingMonthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "\u0458\u0430\u043D",
        "\u0444\u0435\u0431",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0432",
        "\u0434\u0435\u0446"
    ],
    wide: [
        "\u0458\u0430\u043D\u0443\u0430\u0440",
        "\u0444\u0435\u0431\u0440\u0443\u0430\u0440",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0431\u0430\u0440",
        "\u043E\u043A\u0442\u043E\u0431\u0430\u0440",
        "\u043D\u043E\u0432\u0435\u043C\u0431\u0430\u0440",
        "\u0434\u0435\u0446\u0435\u043C\u0431\u0430\u0440"
    ]
};
const $00b01ebf8627de14$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0423",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0443\u0442\u043E",
        "\u0441\u0440\u0435",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u0443\u0431"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0443\u0442\u043E",
        "\u0441\u0440\u0435",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0435\u0459\u0430",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u0459\u0430\u043A",
        "\u0443\u0442\u043E\u0440\u0430\u043A",
        "\u0441\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0440\u0442\u0430\u043A",
        "\u043F\u0435\u0442\u0430\u043A",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
const $00b01ebf8627de14$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0410\u041C",
        pm: "\u041F\u041C",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    abbreviated: {
        am: "\u0410\u041C",
        pm: "\u041F\u041C",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    }
};
const $00b01ebf8627de14$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    }
};
const $00b01ebf8627de14$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $00b01ebf8627de14$var$localize = $00b01ebf8627de14$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $00b01ebf8627de14$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $00b01ebf8627de14$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $00b01ebf8627de14$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $00b01ebf8627de14$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $00b01ebf8627de14$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $00b01ebf8627de14$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $00b01ebf8627de14$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $00b01ebf8627de14$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("llsgO", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $f8a17cfc80ce5416$export$4659b591c19bdf3d; }, function (v) { return $f8a17cfc80ce5416$export$4659b591c19bdf3d = v; });
var $f8a17cfc80ce5416$export$4659b591c19bdf3d;
"use strict";
$f8a17cfc80ce5416$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $f8a17cfc80ce5416$var$matchOrdinalNumberPattern = /^(\d+)\./i;
const $f8a17cfc80ce5416$var$parseOrdinalNumberPattern = /\d+/i;
const $f8a17cfc80ce5416$var$matchEraPatterns = {
    narrow: /^(пр\.н\.е\.|АД)/i,
    abbreviated: /^(пр\.\s?Хр\.|по\.\s?Хр\.)/i,
    wide: /^(Пре Христа|пре нове ере|После Христа|нова ера)/i
};
const $f8a17cfc80ce5416$var$parseEraPatterns = {
    any: [
        /^пр/i,
        /^(по|нова)/i
    ]
};
const $f8a17cfc80ce5416$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?кв\.?/i,
    wide: /^[1234]\. квартал/i
};
const $f8a17cfc80ce5416$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $f8a17cfc80ce5416$var$matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(јан|феб|мар|апр|мај|јун|јул|авг|сеп|окт|нов|дец)/i,
    wide: /^((јануар|јануара)|(фебруар|фебруара)|(март|марта)|(април|априла)|(мја|маја)|(јун|јуна)|(јул|јула)|(август|августа)|(септембар|септембра)|(октобар|октобра)|(новембар|новембра)|(децембар|децембра))/i
};
const $f8a17cfc80ce5416$var$parseMonthPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ја/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^мај/i,
        /^јун/i,
        /^јул/i,
        /^авг/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
const $f8a17cfc80ce5416$var$matchDayPatterns = {
    narrow: /^[пусчн]/i,
    short: /^(нед|пон|уто|сре|чет|пет|суб)/i,
    abbreviated: /^(нед|пон|уто|сре|чет|пет|суб)/i,
    wide: /^(недеља|понедељак|уторак|среда|четвртак|петак|субота)/i
};
const $f8a17cfc80ce5416$var$parseDayPatterns = {
    narrow: [
        /^п/i,
        /^у/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i,
        /^н/i
    ],
    any: [
        /^нед/i,
        /^пон/i,
        /^уто/i,
        /^сре/i,
        /^чет/i,
        /^пет/i,
        /^суб/i
    ]
};
const $f8a17cfc80ce5416$var$matchDayPeriodPatterns = {
    any: /^(ам|пм|поноћ|(по)?подне|увече|ноћу|после подне|ујутру)/i
};
const $f8a17cfc80ce5416$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^поно/i,
        noon: /^под/i,
        morning: /ујутру/i,
        afternoon: /(после\s|по)+подне/i,
        evening: /(увече)/i,
        night: /(ноћу)/i
    }
};
const $f8a17cfc80ce5416$var$match = $f8a17cfc80ce5416$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $f8a17cfc80ce5416$var$matchOrdinalNumberPattern,
        parsePattern: $f8a17cfc80ce5416$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $f8a17cfc80ce5416$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f8a17cfc80ce5416$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $f8a17cfc80ce5416$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f8a17cfc80ce5416$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $f8a17cfc80ce5416$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f8a17cfc80ce5416$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $f8a17cfc80ce5416$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f8a17cfc80ce5416$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $f8a17cfc80ce5416$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $f8a17cfc80ce5416$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("iSx94", function(module, exports) {

$parcel$export(module.exports, "srLatn", function () { return $dbe6fb177d5601ac$export$dd0ad751d91f231a; }, function (v) { return $dbe6fb177d5601ac$export$dd0ad751d91f231a = v; });
var $dbe6fb177d5601ac$export$dd0ad751d91f231a;
"use strict";
$dbe6fb177d5601ac$export$dd0ad751d91f231a = void 0;

var $6FpUI = parcelRequire("6FpUI");

var $8lszp = parcelRequire("8lszp");

var $9pP56 = parcelRequire("9pP56");

var $gg2E7 = parcelRequire("gg2E7");

var $e3VoG = parcelRequire("e3VoG");
/**
 * @category Locales
 * @summary Serbian latin locale.
 * @language Serbian
 * @iso-639-2 srp
 * @author Igor Radivojević [@rogyvoje](https://github.com/rogyvoje)
 */ const $dbe6fb177d5601ac$var$srLatn = $dbe6fb177d5601ac$export$dd0ad751d91f231a = {
    code: "sr-Latn",
    formatDistance: $6FpUI.formatDistance,
    formatLong: $8lszp.formatLong,
    formatRelative: $9pP56.formatRelative,
    localize: $gg2E7.localize,
    match: $e3VoG.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("6FpUI", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $4daaac5c171bc3f1$export$2c14ff85d6318973; }, function (v) { return $4daaac5c171bc3f1$export$2c14ff85d6318973 = v; });
var $4daaac5c171bc3f1$export$2c14ff85d6318973;
"use strict";
$4daaac5c171bc3f1$export$2c14ff85d6318973 = void 0;
const $4daaac5c171bc3f1$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: "manje od 1 sekunde",
            withPrepositionAgo: "manje od 1 sekunde",
            withPrepositionIn: "manje od 1 sekundu"
        },
        dual: "manje od {{count}} sekunde",
        other: "manje od {{count}} sekundi"
    },
    xSeconds: {
        one: {
            standalone: "1 sekunda",
            withPrepositionAgo: "1 sekunde",
            withPrepositionIn: "1 sekundu"
        },
        dual: "{{count}} sekunde",
        other: "{{count}} sekundi"
    },
    halfAMinute: "pola minute",
    lessThanXMinutes: {
        one: {
            standalone: "manje od 1 minute",
            withPrepositionAgo: "manje od 1 minute",
            withPrepositionIn: "manje od 1 minutu"
        },
        dual: "manje od {{count}} minute",
        other: "manje od {{count}} minuta"
    },
    xMinutes: {
        one: {
            standalone: "1 minuta",
            withPrepositionAgo: "1 minute",
            withPrepositionIn: "1 minutu"
        },
        dual: "{{count}} minute",
        other: "{{count}} minuta"
    },
    aboutXHours: {
        one: {
            standalone: "oko 1 sat",
            withPrepositionAgo: "oko 1 sat",
            withPrepositionIn: "oko 1 sat"
        },
        dual: "oko {{count}} sata",
        other: "oko {{count}} sati"
    },
    xHours: {
        one: {
            standalone: "1 sat",
            withPrepositionAgo: "1 sat",
            withPrepositionIn: "1 sat"
        },
        dual: "{{count}} sata",
        other: "{{count}} sati"
    },
    xDays: {
        one: {
            standalone: "1 dan",
            withPrepositionAgo: "1 dan",
            withPrepositionIn: "1 dan"
        },
        dual: "{{count}} dana",
        other: "{{count}} dana"
    },
    aboutXWeeks: {
        one: {
            standalone: "oko 1 nedelju",
            withPrepositionAgo: "oko 1 nedelju",
            withPrepositionIn: "oko 1 nedelju"
        },
        dual: "oko {{count}} nedelje",
        other: "oko {{count}} nedelje"
    },
    xWeeks: {
        one: {
            standalone: "1 nedelju",
            withPrepositionAgo: "1 nedelju",
            withPrepositionIn: "1 nedelju"
        },
        dual: "{{count}} nedelje",
        other: "{{count}} nedelje"
    },
    aboutXMonths: {
        one: {
            standalone: "oko 1 mesec",
            withPrepositionAgo: "oko 1 mesec",
            withPrepositionIn: "oko 1 mesec"
        },
        dual: "oko {{count}} meseca",
        other: "oko {{count}} meseci"
    },
    xMonths: {
        one: {
            standalone: "1 mesec",
            withPrepositionAgo: "1 mesec",
            withPrepositionIn: "1 mesec"
        },
        dual: "{{count}} meseca",
        other: "{{count}} meseci"
    },
    aboutXYears: {
        one: {
            standalone: "oko 1 godinu",
            withPrepositionAgo: "oko 1 godinu",
            withPrepositionIn: "oko 1 godinu"
        },
        dual: "oko {{count}} godine",
        other: "oko {{count}} godina"
    },
    xYears: {
        one: {
            standalone: "1 godina",
            withPrepositionAgo: "1 godine",
            withPrepositionIn: "1 godinu"
        },
        dual: "{{count}} godine",
        other: "{{count}} godina"
    },
    overXYears: {
        one: {
            standalone: "preko 1 godinu",
            withPrepositionAgo: "preko 1 godinu",
            withPrepositionIn: "preko 1 godinu"
        },
        dual: "preko {{count}} godine",
        other: "preko {{count}} godina"
    },
    almostXYears: {
        one: {
            standalone: "gotovo 1 godinu",
            withPrepositionAgo: "gotovo 1 godinu",
            withPrepositionIn: "gotovo 1 godinu"
        },
        dual: "gotovo {{count}} godine",
        other: "gotovo {{count}} godina"
    }
};
const $4daaac5c171bc3f1$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $4daaac5c171bc3f1$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) {
        if (options?.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== "1" // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "za " + result;
        else return "pre " + result;
    }
    return result;
};
$4daaac5c171bc3f1$export$2c14ff85d6318973 = $4daaac5c171bc3f1$var$formatDistance;

});

parcelRegister("8lszp", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $61367253dcb3c792$export$cbf60ecb96cbb82f; }, function (v) { return $61367253dcb3c792$export$cbf60ecb96cbb82f = v; });
var $61367253dcb3c792$export$cbf60ecb96cbb82f;
"use strict";
$61367253dcb3c792$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $61367253dcb3c792$var$dateFormats = {
    full: "EEEE, d. MMMM yyyy.",
    long: "d. MMMM yyyy.",
    medium: "d. MMM yy.",
    short: "dd. MM. yy."
};
const $61367253dcb3c792$var$timeFormats = {
    full: "HH:mm:ss (zzzz)",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $61367253dcb3c792$var$dateTimeFormats = {
    full: "{{date}} 'u' {{time}}",
    long: "{{date}} 'u' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $61367253dcb3c792$var$formatLong = $61367253dcb3c792$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $61367253dcb3c792$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $61367253dcb3c792$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $61367253dcb3c792$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("9pP56", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $6dae12835acbfdd4$export$8fbbfd65594f46a0; }, function (v) { return $6dae12835acbfdd4$export$8fbbfd65594f46a0 = v; });
var $6dae12835acbfdd4$export$8fbbfd65594f46a0;
"use strict";
$6dae12835acbfdd4$export$8fbbfd65594f46a0 = void 0;
const $6dae12835acbfdd4$var$formatRelativeLocale = {
    lastWeek: (date)=>{
        switch(date.getDay()){
            case 0:
                return "'pro\u0161le nedelje u' p";
            case 3:
                return "'pro\u0161le srede u' p";
            case 6:
                return "'pro\u0161le subote u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    yesterday: "'ju\u010De u' p",
    today: "'danas u' p",
    tomorrow: "'sutra u' p",
    nextWeek: (date)=>{
        switch(date.getDay()){
            case 0:
                return "'slede\u0107e nedelje u' p";
            case 3:
                return "'slede\u0107u sredu u' p";
            case 6:
                return "'slede\u0107u subotu u' p";
            default:
                return "'slede\u0107i' EEEE 'u' p";
        }
    },
    other: "P"
};
const $6dae12835acbfdd4$var$formatRelative = (token, date, _baseDate, _options)=>{
    const format = $6dae12835acbfdd4$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
$6dae12835acbfdd4$export$8fbbfd65594f46a0 = $6dae12835acbfdd4$var$formatRelative;

});

parcelRegister("gg2E7", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $bd60316fc9708125$export$b3bd0bc58e36cd63; }, function (v) { return $bd60316fc9708125$export$b3bd0bc58e36cd63 = v; });
var $bd60316fc9708125$export$b3bd0bc58e36cd63;
"use strict";
$bd60316fc9708125$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $bd60316fc9708125$var$eraValues = {
    narrow: [
        "pr.n.e.",
        "AD"
    ],
    abbreviated: [
        "pr. Hr.",
        "po. Hr."
    ],
    wide: [
        "Pre Hrista",
        "Posle Hrista"
    ]
};
const $bd60316fc9708125$var$quarterValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4."
    ],
    abbreviated: [
        "1. kv.",
        "2. kv.",
        "3. kv.",
        "4. kv."
    ],
    wide: [
        "1. kvartal",
        "2. kvartal",
        "3. kvartal",
        "4. kvartal"
    ]
};
const $bd60316fc9708125$var$monthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "jan",
        "feb",
        "mar",
        "apr",
        "maj",
        "jun",
        "jul",
        "avg",
        "sep",
        "okt",
        "nov",
        "dec"
    ],
    wide: [
        "januar",
        "februar",
        "mart",
        "april",
        "maj",
        "jun",
        "jul",
        "avgust",
        "septembar",
        "oktobar",
        "novembar",
        "decembar"
    ]
};
const $bd60316fc9708125$var$formattingMonthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "jan",
        "feb",
        "mar",
        "apr",
        "maj",
        "jun",
        "jul",
        "avg",
        "sep",
        "okt",
        "nov",
        "dec"
    ],
    wide: [
        "januar",
        "februar",
        "mart",
        "april",
        "maj",
        "jun",
        "jul",
        "avgust",
        "septembar",
        "oktobar",
        "novembar",
        "decembar"
    ]
};
const $bd60316fc9708125$var$dayValues = {
    narrow: [
        "N",
        "P",
        "U",
        "S",
        "\u010C",
        "P",
        "S"
    ],
    short: [
        "ned",
        "pon",
        "uto",
        "sre",
        "\u010Det",
        "pet",
        "sub"
    ],
    abbreviated: [
        "ned",
        "pon",
        "uto",
        "sre",
        "\u010Det",
        "pet",
        "sub"
    ],
    wide: [
        "nedelja",
        "ponedeljak",
        "utorak",
        "sreda",
        "\u010Detvrtak",
        "petak",
        "subota"
    ]
};
const $bd60316fc9708125$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "posle podne",
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
const $bd60316fc9708125$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "posle podne",
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
const $bd60316fc9708125$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $bd60316fc9708125$var$localize = $bd60316fc9708125$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $bd60316fc9708125$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $bd60316fc9708125$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $bd60316fc9708125$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $bd60316fc9708125$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $bd60316fc9708125$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $bd60316fc9708125$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $bd60316fc9708125$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $bd60316fc9708125$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("e3VoG", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $a3cdde5c2a0fd9a6$export$4659b591c19bdf3d; }, function (v) { return $a3cdde5c2a0fd9a6$export$4659b591c19bdf3d = v; });
var $a3cdde5c2a0fd9a6$export$4659b591c19bdf3d;
"use strict";
$a3cdde5c2a0fd9a6$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $a3cdde5c2a0fd9a6$var$matchOrdinalNumberPattern = /^(\d+)\./i;
const $a3cdde5c2a0fd9a6$var$parseOrdinalNumberPattern = /\d+/i;
const $a3cdde5c2a0fd9a6$var$matchEraPatterns = {
    narrow: /^(pr\.n\.e\.|AD)/i,
    abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
    wide: /^(Pre Hrista|pre nove ere|Posle Hrista|nova era)/i
};
const $a3cdde5c2a0fd9a6$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|nova)/i
    ]
};
const $a3cdde5c2a0fd9a6$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?kv\.?/i,
    wide: /^[1234]\. kvartal/i
};
const $a3cdde5c2a0fd9a6$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $a3cdde5c2a0fd9a6$var$matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
    wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(jun|juna)|(jul|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
};
const $a3cdde5c2a0fd9a6$var$parseMonthPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^avg/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $a3cdde5c2a0fd9a6$var$matchDayPatterns = {
    narrow: /^[npusčc]/i,
    short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    wide: /^(nedelja|ponedeljak|utorak|sreda|(četvrtak|cetvrtak)|petak|subota)/i
};
const $a3cdde5c2a0fd9a6$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $a3cdde5c2a0fd9a6$var$matchDayPeriodPatterns = {
    any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|posle podne|ujutru)/i
};
const $a3cdde5c2a0fd9a6$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(posle\s|po)+podne/i,
        evening: /(uvece|uveče)/i,
        night: /(nocu|noću)/i
    }
};
const $a3cdde5c2a0fd9a6$var$match = $a3cdde5c2a0fd9a6$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $a3cdde5c2a0fd9a6$var$matchOrdinalNumberPattern,
        parsePattern: $a3cdde5c2a0fd9a6$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $a3cdde5c2a0fd9a6$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a3cdde5c2a0fd9a6$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $a3cdde5c2a0fd9a6$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a3cdde5c2a0fd9a6$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $a3cdde5c2a0fd9a6$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a3cdde5c2a0fd9a6$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $a3cdde5c2a0fd9a6$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a3cdde5c2a0fd9a6$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $a3cdde5c2a0fd9a6$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $a3cdde5c2a0fd9a6$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("2WcFN", function(module, exports) {

$parcel$export(module.exports, "sv", function () { return $223ad431d84ff1fa$export$65540e5f7f6e7dce; }, function (v) { return $223ad431d84ff1fa$export$65540e5f7f6e7dce = v; });
var $223ad431d84ff1fa$export$65540e5f7f6e7dce;
"use strict";
$223ad431d84ff1fa$export$65540e5f7f6e7dce = void 0;

var $hHAJw = parcelRequire("hHAJw");

var $eCHvD = parcelRequire("eCHvD");

var $gMfOw = parcelRequire("gMfOw");

var $8oh5R = parcelRequire("8oh5R");

var $ctvw5 = parcelRequire("ctvw5");
/**
 * @category Locales
 * @summary Swedish locale.
 * @language Swedish
 * @iso-639-2 swe
 * @author Johannes Ulén [@ejulen](https://github.com/ejulen)
 * @author Alexander Nanberg [@alexandernanberg](https://github.com/alexandernanberg)
 * @author Henrik Andersson [@limelights](https://github.com/limelights)
 */ const $223ad431d84ff1fa$var$sv = $223ad431d84ff1fa$export$65540e5f7f6e7dce = {
    code: "sv",
    formatDistance: $hHAJw.formatDistance,
    formatLong: $eCHvD.formatLong,
    formatRelative: $gMfOw.formatRelative,
    localize: $8oh5R.localize,
    match: $ctvw5.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("hHAJw", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $ce32f2449a0632e8$export$2c14ff85d6318973; }, function (v) { return $ce32f2449a0632e8$export$2c14ff85d6318973 = v; });
var $ce32f2449a0632e8$export$2c14ff85d6318973;
"use strict";
$ce32f2449a0632e8$export$2c14ff85d6318973 = void 0;
const $ce32f2449a0632e8$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre \xe4n en sekund",
        other: "mindre \xe4n {{count}} sekunder"
    },
    xSeconds: {
        one: "en sekund",
        other: "{{count}} sekunder"
    },
    halfAMinute: "en halv minut",
    lessThanXMinutes: {
        one: "mindre \xe4n en minut",
        other: "mindre \xe4n {{count}} minuter"
    },
    xMinutes: {
        one: "en minut",
        other: "{{count}} minuter"
    },
    aboutXHours: {
        one: "ungef\xe4r en timme",
        other: "ungef\xe4r {{count}} timmar"
    },
    xHours: {
        one: "en timme",
        other: "{{count}} timmar"
    },
    xDays: {
        one: "en dag",
        other: "{{count}} dagar"
    },
    aboutXWeeks: {
        one: "ungef\xe4r en vecka",
        other: "ungef\xe4r {{count}} veckor"
    },
    xWeeks: {
        one: "en vecka",
        other: "{{count}} veckor"
    },
    aboutXMonths: {
        one: "ungef\xe4r en m\xe5nad",
        other: "ungef\xe4r {{count}} m\xe5nader"
    },
    xMonths: {
        one: "en m\xe5nad",
        other: "{{count}} m\xe5nader"
    },
    aboutXYears: {
        one: "ungef\xe4r ett \xe5r",
        other: "ungef\xe4r {{count}} \xe5r"
    },
    xYears: {
        one: "ett \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "\xf6ver ett \xe5r",
        other: "\xf6ver {{count}} \xe5r"
    },
    almostXYears: {
        one: "n\xe4stan ett \xe5r",
        other: "n\xe4stan {{count}} \xe5r"
    }
};
const $ce32f2449a0632e8$var$wordMapping = [
    "noll",
    "en",
    "tv\xe5",
    "tre",
    "fyra",
    "fem",
    "sex",
    "sju",
    "\xe5tta",
    "nio",
    "tio",
    "elva",
    "tolv"
];
const $ce32f2449a0632e8$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $ce32f2449a0632e8$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count < 13 ? $ce32f2449a0632e8$var$wordMapping[count] : String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "om " + result;
        else return result + " sedan";
    }
    return result;
};
$ce32f2449a0632e8$export$2c14ff85d6318973 = $ce32f2449a0632e8$var$formatDistance;

});

parcelRegister("eCHvD", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $aa565d5826ad60d0$export$cbf60ecb96cbb82f; }, function (v) { return $aa565d5826ad60d0$export$cbf60ecb96cbb82f = v; });
var $aa565d5826ad60d0$export$cbf60ecb96cbb82f;
"use strict";
$aa565d5826ad60d0$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $aa565d5826ad60d0$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "y-MM-dd"
};
const $aa565d5826ad60d0$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $aa565d5826ad60d0$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $aa565d5826ad60d0$var$formatLong = $aa565d5826ad60d0$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $aa565d5826ad60d0$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $aa565d5826ad60d0$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $aa565d5826ad60d0$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("gMfOw", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $c36d655975bfdaa9$export$8fbbfd65594f46a0; }, function (v) { return $c36d655975bfdaa9$export$8fbbfd65594f46a0 = v; });
var $c36d655975bfdaa9$export$8fbbfd65594f46a0;
"use strict";
$c36d655975bfdaa9$export$8fbbfd65594f46a0 = void 0;
const $c36d655975bfdaa9$var$formatRelativeLocale = {
    lastWeek: "'i' EEEE's kl.' p",
    yesterday: "'ig\xe5r kl.' p",
    today: "'idag kl.' p",
    tomorrow: "'imorgon kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: "P"
};
const $c36d655975bfdaa9$var$formatRelative = (token, _date, _baseDate, _options)=>$c36d655975bfdaa9$var$formatRelativeLocale[token];
$c36d655975bfdaa9$export$8fbbfd65594f46a0 = $c36d655975bfdaa9$var$formatRelative;

});

parcelRegister("8oh5R", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $61bdd3080897d96e$export$b3bd0bc58e36cd63; }, function (v) { return $61bdd3080897d96e$export$b3bd0bc58e36cd63 = v; });
var $61bdd3080897d96e$export$b3bd0bc58e36cd63;
"use strict";
$61bdd3080897d96e$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $61bdd3080897d96e$var$eraValues = {
    narrow: [
        "f.Kr.",
        "e.Kr."
    ],
    abbreviated: [
        "f.Kr.",
        "e.Kr."
    ],
    wide: [
        "f\xf6re Kristus",
        "efter Kristus"
    ]
};
const $61bdd3080897d96e$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1:a kvartalet",
        "2:a kvartalet",
        "3:e kvartalet",
        "4:e kvartalet"
    ]
};
const $61bdd3080897d96e$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mars",
        "apr.",
        "maj",
        "juni",
        "juli",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "januari",
        "februari",
        "mars",
        "april",
        "maj",
        "juni",
        "juli",
        "augusti",
        "september",
        "oktober",
        "november",
        "december"
    ]
};
const $61bdd3080897d96e$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "O",
        "T",
        "F",
        "L"
    ],
    short: [
        "s\xf6",
        "m\xe5",
        "ti",
        "on",
        "to",
        "fr",
        "l\xf6"
    ],
    abbreviated: [
        "s\xf6n",
        "m\xe5n",
        "tis",
        "ons",
        "tors",
        "fre",
        "l\xf6r"
    ],
    wide: [
        "s\xf6ndag",
        "m\xe5ndag",
        "tisdag",
        "onsdag",
        "torsdag",
        "fredag",
        "l\xf6rdag"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sv.html#1888
const $61bdd3080897d96e$var$dayPeriodValues = {
    narrow: {
        am: "fm",
        pm: "em",
        midnight: "midnatt",
        noon: "middag",
        morning: "morg.",
        afternoon: "efterm.",
        evening: "kv\xe4ll",
        night: "natt"
    },
    abbreviated: {
        am: "f.m.",
        pm: "e.m.",
        midnight: "midnatt",
        noon: "middag",
        morning: "morgon",
        afternoon: "efterm.",
        evening: "kv\xe4ll",
        night: "natt"
    },
    wide: {
        am: "f\xf6rmiddag",
        pm: "eftermiddag",
        midnight: "midnatt",
        noon: "middag",
        morning: "morgon",
        afternoon: "eftermiddag",
        evening: "kv\xe4ll",
        night: "natt"
    }
};
const $61bdd3080897d96e$var$formattingDayPeriodValues = {
    narrow: {
        am: "fm",
        pm: "em",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 efterm.",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    },
    abbreviated: {
        am: "fm",
        pm: "em",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 efterm.",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    },
    wide: {
        am: "fm",
        pm: "em",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morgonen",
        afternoon: "p\xe5 eftermiddagen",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    }
};
const $61bdd3080897d96e$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
        case 2:
            return number + ":a";
    }
    return number + ":e";
};
const $61bdd3080897d96e$var$localize = $61bdd3080897d96e$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $61bdd3080897d96e$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $61bdd3080897d96e$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $61bdd3080897d96e$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $61bdd3080897d96e$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $61bdd3080897d96e$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $61bdd3080897d96e$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $61bdd3080897d96e$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("ctvw5", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $9150a401de06cdd4$export$4659b591c19bdf3d; }, function (v) { return $9150a401de06cdd4$export$4659b591c19bdf3d = v; });
var $9150a401de06cdd4$export$4659b591c19bdf3d;
"use strict";
$9150a401de06cdd4$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $9150a401de06cdd4$var$matchOrdinalNumberPattern = /^(\d+)(:a|:e)?/i;
const $9150a401de06cdd4$var$parseOrdinalNumberPattern = /\d+/i;
const $9150a401de06cdd4$var$matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
};
const $9150a401de06cdd4$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^[ev]/i
    ]
};
const $9150a401de06cdd4$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](:a|:e)? kvartalet/i
};
const $9150a401de06cdd4$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $9150a401de06cdd4$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
    wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
};
const $9150a401de06cdd4$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $9150a401de06cdd4$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(sö|må|ti|on|to|fr|lö)/i,
    abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
    wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
};
const $9150a401de06cdd4$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
const $9150a401de06cdd4$var$matchDayPeriodPatterns = {
    any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
};
const $9150a401de06cdd4$var$parseDayPeriodPatterns = {
    any: {
        am: /^f/i,
        pm: /^e/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgon/i,
        afternoon: /eftermiddag/i,
        evening: /kväll/i,
        night: /natt/i
    }
};
const $9150a401de06cdd4$var$match = $9150a401de06cdd4$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $9150a401de06cdd4$var$matchOrdinalNumberPattern,
        parsePattern: $9150a401de06cdd4$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $9150a401de06cdd4$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9150a401de06cdd4$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $9150a401de06cdd4$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9150a401de06cdd4$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $9150a401de06cdd4$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9150a401de06cdd4$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $9150a401de06cdd4$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9150a401de06cdd4$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $9150a401de06cdd4$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $9150a401de06cdd4$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("flEHO", function(module, exports) {

$parcel$export(module.exports, "ta", function () { return $b2c8647a74aa91dc$export$d4b02e284d602eb2; }, function (v) { return $b2c8647a74aa91dc$export$d4b02e284d602eb2 = v; });
var $b2c8647a74aa91dc$export$d4b02e284d602eb2;
"use strict";
$b2c8647a74aa91dc$export$d4b02e284d602eb2 = void 0;

var $dxFOb = parcelRequire("dxFOb");

var $DaZ22 = parcelRequire("DaZ22");

var $dnXwu = parcelRequire("dnXwu");

var $5uleJ = parcelRequire("5uleJ");

var $aU1WP = parcelRequire("aU1WP");
/**
 * @category Locales
 * @summary Tamil locale (India).
 * @language Tamil
 * @iso-639-2 tam
 * @author Sibiraj [@sibiraj-s](https://github.com/sibiraj-s)
 */ const $b2c8647a74aa91dc$var$ta = $b2c8647a74aa91dc$export$d4b02e284d602eb2 = {
    code: "ta",
    formatDistance: $dxFOb.formatDistance,
    formatLong: $DaZ22.formatLong,
    formatRelative: $dnXwu.formatRelative,
    localize: $5uleJ.localize,
    match: $aU1WP.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("dxFOb", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $9dbec9b1401cfc19$export$2c14ff85d6318973; }, function (v) { return $9dbec9b1401cfc19$export$2c14ff85d6318973 = v; });
var $9dbec9b1401cfc19$export$2c14ff85d6318973;
"use strict";
$9dbec9b1401cfc19$export$2c14ff85d6318973 = void 0;
function $9dbec9b1401cfc19$var$isPluralType(val) {
    return val.one !== undefined;
}
const $9dbec9b1401cfc19$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            default: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1 \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xSeconds: {
        one: {
            default: "1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF",
            in: "1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0BAF\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BB5\u0BBF\u0BA8\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BB5\u0BBF\u0BA8\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    halfAMinute: {
        default: "\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD",
        in: "\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
        ago: "\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
    },
    lessThanXMinutes: {
        one: {
            default: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xMinutes: {
        one: {
            default: "1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD",
            in: "1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXHours: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD"
        }
    },
    xHours: {
        one: {
            default: "1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xDays: {
        one: {
            default: "1 \u0BA8\u0BBE\u0BB3\u0BCD",
            in: "1 \u0BA8\u0BBE\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BA8\u0BBE\u0BB3\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXWeeks: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xWeeks: {
        one: {
            default: "1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD",
            in: "1 \u0BB5\u0BBE\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXMonths: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xMonths: {
        one: {
            default: "1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD",
            in: "1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXYears: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xYears: {
        one: {
            default: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
            in: "1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    overXYears: {
        one: {
            default: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC7\u0BB2\u0BCD",
            in: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0BAE\u0BC7\u0BB2\u0BBE\u0B95",
            ago: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0BAE\u0BC7\u0BB2\u0BBE\u0B95",
            in: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    almostXYears: {
        one: {
            default: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
            in: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
            ago: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
            in: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    }
};
const $9dbec9b1401cfc19$var$formatDistance = (token, count, options)=>{
    const tense = options?.addSuffix ? options.comparison && options.comparison > 0 ? "in" : "ago" : "default";
    const tokenValue = $9dbec9b1401cfc19$var$formatDistanceLocale[token];
    if (!$9dbec9b1401cfc19$var$isPluralType(tokenValue)) return tokenValue[tense];
    if (count === 1) return tokenValue.one[tense];
    else return tokenValue.other[tense].replace("{{count}}", String(count));
};
$9dbec9b1401cfc19$export$2c14ff85d6318973 = $9dbec9b1401cfc19$var$formatDistance;

});

parcelRegister("DaZ22", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $075c29b44e847c76$export$cbf60ecb96cbb82f; }, function (v) { return $075c29b44e847c76$export$cbf60ecb96cbb82f = v; });
var $075c29b44e847c76$export$cbf60ecb96cbb82f;
"use strict";
$075c29b44e847c76$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
// Ref: https://www.unicode.org/cldr/charts/32/summary/ta.html
// CLDR #1846 - #1849
const $075c29b44e847c76$var$dateFormats = {
    full: "EEEE, d MMMM, y",
    long: "d MMMM, y",
    medium: "d MMM, y",
    short: "d/M/yy"
};
// CLDR #1850 - #1853
const $075c29b44e847c76$var$timeFormats = {
    full: "a h:mm:ss zzzz",
    long: "a h:mm:ss z",
    medium: "a h:mm:ss",
    short: "a h:mm"
};
const $075c29b44e847c76$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $075c29b44e847c76$var$formatLong = $075c29b44e847c76$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $075c29b44e847c76$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $075c29b44e847c76$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $075c29b44e847c76$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("dnXwu", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $9beb9862e965f8be$export$8fbbfd65594f46a0; }, function (v) { return $9beb9862e965f8be$export$8fbbfd65594f46a0 = v; });
var $9beb9862e965f8be$export$8fbbfd65594f46a0;
"use strict";
$9beb9862e965f8be$export$8fbbfd65594f46a0 = void 0;
const $9beb9862e965f8be$var$formatRelativeLocale = {
    lastWeek: "'\u0B95\u0B9F\u0BA8\u0BCD\u0BA4' eeee p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    yesterday: "'\u0BA8\u0BC7\u0BB1\u0BCD\u0BB1\u0BC1 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    today: "'\u0B87\u0BA9\u0BCD\u0BB1\u0BC1 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    tomorrow: "'\u0BA8\u0BBE\u0BB3\u0BC8 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    nextWeek: "eeee p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    other: "P"
};
const $9beb9862e965f8be$var$formatRelative = (token, _date, _baseDate, _options)=>$9beb9862e965f8be$var$formatRelativeLocale[token];
$9beb9862e965f8be$export$8fbbfd65594f46a0 = $9beb9862e965f8be$var$formatRelative;

});

parcelRegister("5uleJ", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $3ff03a3e403eaa86$export$b3bd0bc58e36cd63; }, function (v) { return $3ff03a3e403eaa86$export$b3bd0bc58e36cd63 = v; });
var $3ff03a3e403eaa86$export$b3bd0bc58e36cd63;
"use strict";
$3ff03a3e403eaa86$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
// Ref: https://www.unicode.org/cldr/charts/32/summary/ta.html
const $3ff03a3e403eaa86$var$eraValues = {
    narrow: [
        "\u0B95\u0BBF.\u0BAE\u0BC1.",
        "\u0B95\u0BBF.\u0BAA\u0BBF."
    ],
    abbreviated: [
        "\u0B95\u0BBF.\u0BAE\u0BC1.",
        "\u0B95\u0BBF.\u0BAA\u0BBF."
    ],
    wide: [
        "\u0B95\u0BBF\u0BB1\u0BBF\u0BB8\u0BCD\u0BA4\u0BC1\u0BB5\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD",
        "\u0B85\u0BA9\u0BCD\u0BA9\u0BCB \u0B9F\u0BCB\u0BAE\u0BBF\u0BA9\u0BBF"
    ]
};
const $3ff03a3e403eaa86$var$quarterValues = {
    // CLDR #1644 - #1647
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    // CLDR #1636 - #1639
    abbreviated: [
        "\u0B95\u0BBE\u0BB2\u0BBE.1",
        "\u0B95\u0BBE\u0BB2\u0BBE.2",
        "\u0B95\u0BBE\u0BB2\u0BBE.3",
        "\u0B95\u0BBE\u0BB2\u0BBE.4"
    ],
    // CLDR #1628 - #1631
    wide: [
        "\u0B92\u0BA9\u0BCD\u0BB1\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1",
        "\u0B87\u0BB0\u0BA3\u0BCD\u0B9F\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1",
        "\u0BAE\u0BC2\u0BA9\u0BCD\u0BB1\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1",
        "\u0BA8\u0BBE\u0BA9\u0BCD\u0B95\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1"
    ]
};
const $3ff03a3e403eaa86$var$monthValues = {
    // CLDR #700 - #711
    narrow: [
        "\u0B9C",
        "\u0BAA\u0BBF",
        "\u0BAE\u0BBE",
        "\u0B8F",
        "\u0BAE\u0BC7",
        "\u0B9C\u0BC2",
        "\u0B9C\u0BC2",
        "\u0B86",
        "\u0B9A\u0BC6",
        "\u0B85",
        "\u0BA8",
        "\u0B9F\u0BBF"
    ],
    // CLDR #1676 - #1687
    abbreviated: [
        "\u0B9C\u0BA9.",
        "\u0BAA\u0BBF\u0BAA\u0BCD.",
        "\u0BAE\u0BBE\u0BB0\u0BCD.",
        "\u0B8F\u0BAA\u0BCD.",
        "\u0BAE\u0BC7",
        "\u0B9C\u0BC2\u0BA9\u0BCD",
        "\u0B9C\u0BC2\u0BB2\u0BC8",
        "\u0B86\u0B95.",
        "\u0B9A\u0BC6\u0BAA\u0BCD.",
        "\u0B85\u0B95\u0BCD.",
        "\u0BA8\u0BB5.",
        "\u0B9F\u0BBF\u0B9A."
    ],
    // CLDR #1652 - #1663
    wide: [
        "\u0B9C\u0BA9\u0BB5\u0BB0\u0BBF",
        "\u0BAA\u0BBF\u0BAA\u0BCD\u0BB0\u0BB5\u0BB0\u0BBF",
        "\u0BAE\u0BBE\u0BB0\u0BCD\u0B9A\u0BCD",
        "\u0B8F\u0BAA\u0BCD\u0BB0\u0BB2\u0BCD",
        "\u0BAE\u0BC7",
        "\u0B9C\u0BC2\u0BA9\u0BCD",
        "\u0B9C\u0BC2\u0BB2\u0BC8",
        "\u0B86\u0B95\u0BB8\u0BCD\u0B9F\u0BCD",
        "\u0B9A\u0BC6\u0BAA\u0BCD\u0B9F\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD",
        "\u0B85\u0B95\u0BCD\u0B9F\u0BCB\u0BAA\u0BB0\u0BCD",
        "\u0BA8\u0BB5\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD",
        "\u0B9F\u0BBF\u0B9A\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD"
    ]
};
const $3ff03a3e403eaa86$var$dayValues = {
    // CLDR #1766 - #1772
    narrow: [
        "\u0B9E\u0BBE",
        "\u0BA4\u0BBF",
        "\u0B9A\u0BC6",
        "\u0BAA\u0BC1",
        "\u0BB5\u0BBF",
        "\u0BB5\u0BC6",
        "\u0B9A"
    ],
    // CLDR #1752 - #1758
    short: [
        "\u0B9E\u0BBE",
        "\u0BA4\u0BBF",
        "\u0B9A\u0BC6",
        "\u0BAA\u0BC1",
        "\u0BB5\u0BBF",
        "\u0BB5\u0BC6",
        "\u0B9A"
    ],
    // CLDR #1738 - #1744
    abbreviated: [
        "\u0B9E\u0BBE\u0BAF\u0BBF.",
        "\u0BA4\u0BBF\u0B99\u0BCD.",
        "\u0B9A\u0BC6\u0BB5\u0BCD.",
        "\u0BAA\u0BC1\u0BA4.",
        "\u0BB5\u0BBF\u0BAF\u0BBE.",
        "\u0BB5\u0BC6\u0BB3\u0BCD.",
        "\u0B9A\u0BA9\u0BBF"
    ],
    // CLDR #1724 - #1730
    wide: [
        "\u0B9E\u0BBE\u0BAF\u0BBF\u0BB1\u0BC1",
        "\u0BA4\u0BBF\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
        "\u0B9A\u0BC6\u0BB5\u0BCD\u0BB5\u0BBE\u0BAF\u0BCD",
        "\u0BAA\u0BC1\u0BA4\u0BA9\u0BCD",
        "\u0BB5\u0BBF\u0BAF\u0BBE\u0BB4\u0BA9\u0BCD",
        "\u0BB5\u0BC6\u0BB3\u0BCD\u0BB3\u0BBF",
        "\u0B9A\u0BA9\u0BBF"
    ]
};
// CLDR #1780 - #1845
const $3ff03a3e403eaa86$var$dayPeriodValues = {
    narrow: {
        am: "\u0BAE\u0BC1.\u0BAA",
        pm: "\u0BAA\u0BBF.\u0BAA",
        midnight: "\u0BA8\u0BB3\u0BCD.",
        noon: "\u0BA8\u0BA3\u0BCD.",
        morning: "\u0B95\u0BBE.",
        afternoon: "\u0BAE\u0BA4\u0BBF.",
        evening: "\u0BAE\u0BBE.",
        night: "\u0B87\u0BB0."
    },
    abbreviated: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    },
    wide: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    }
};
// CLDR #1780 - #1845
const $3ff03a3e403eaa86$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0BAE\u0BC1.\u0BAA",
        pm: "\u0BAA\u0BBF.\u0BAA",
        midnight: "\u0BA8\u0BB3\u0BCD.",
        noon: "\u0BA8\u0BA3\u0BCD.",
        morning: "\u0B95\u0BBE.",
        afternoon: "\u0BAE\u0BA4\u0BBF.",
        evening: "\u0BAE\u0BBE.",
        night: "\u0B87\u0BB0."
    },
    abbreviated: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    },
    wide: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    }
};
const $3ff03a3e403eaa86$var$ordinalNumber = (dirtyNumber, _options)=>{
    return String(dirtyNumber);
};
const $3ff03a3e403eaa86$var$localize = $3ff03a3e403eaa86$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $3ff03a3e403eaa86$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $3ff03a3e403eaa86$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $3ff03a3e403eaa86$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $3ff03a3e403eaa86$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $3ff03a3e403eaa86$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $3ff03a3e403eaa86$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $3ff03a3e403eaa86$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("aU1WP", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $7f00a52b023204a2$export$4659b591c19bdf3d; }, function (v) { return $7f00a52b023204a2$export$4659b591c19bdf3d = v; });
var $7f00a52b023204a2$export$4659b591c19bdf3d;
"use strict";
$7f00a52b023204a2$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $7f00a52b023204a2$var$matchOrdinalNumberPattern = /^(\d+)(வது)?/i;
const $7f00a52b023204a2$var$parseOrdinalNumberPattern = /\d+/i;
const $7f00a52b023204a2$var$matchEraPatterns = {
    narrow: /^(கி.மு.|கி.பி.)/i,
    abbreviated: /^(கி\.?\s?மு\.?|கி\.?\s?பி\.?)/,
    wide: /^(கிறிஸ்துவுக்கு\sமுன்|அன்னோ\sடோமினி)/i
};
const $7f00a52b023204a2$var$parseEraPatterns = {
    any: [
        /கி\.?\s?மு\.?/,
        /கி\.?\s?பி\.?/
    ]
};
const $7f00a52b023204a2$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^காலா.[1234]/i,
    wide: /^(ஒன்றாம்|இரண்டாம்|மூன்றாம்|நான்காம்) காலாண்டு/i
};
const $7f00a52b023204a2$var$parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /(1|காலா.1|ஒன்றாம்)/i,
        /(2|காலா.2|இரண்டாம்)/i,
        /(3|காலா.3|மூன்றாம்)/i,
        /(4|காலா.4|நான்காம்)/i
    ]
};
const $7f00a52b023204a2$var$matchMonthPatterns = {
    narrow: /^(ஜ|பி|மா|ஏ|மே|ஜூ|ஆ|செ|அ|ந|டி)$/i,
    abbreviated: /^(ஜன.|பிப்.|மார்.|ஏப்.|மே|ஜூன்|ஜூலை|ஆக.|செப்.|அக்.|நவ.|டிச.)/i,
    wide: /^(ஜனவரி|பிப்ரவரி|மார்ச்|ஏப்ரல்|மே|ஜூன்|ஜூலை|ஆகஸ்ட்|செப்டம்பர்|அக்டோபர்|நவம்பர்|டிசம்பர்)/i
};
const $7f00a52b023204a2$var$parseMonthPatterns = {
    narrow: [
        /^ஜ$/i,
        /^பி/i,
        /^மா/i,
        /^ஏ/i,
        /^மே/i,
        /^ஜூ/i,
        /^ஜூ/i,
        /^ஆ/i,
        /^செ/i,
        /^அ/i,
        /^ந/i,
        /^டி/i
    ],
    any: [
        /^ஜன/i,
        /^பி/i,
        /^மா/i,
        /^ஏ/i,
        /^மே/i,
        /^ஜூன்/i,
        /^ஜூலை/i,
        /^ஆ/i,
        /^செ/i,
        /^அ/i,
        /^ந/i,
        /^டி/i
    ]
};
const $7f00a52b023204a2$var$matchDayPatterns = {
    narrow: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
    short: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
    abbreviated: /^(ஞாயி.|திங்.|செவ்.|புத.|வியா.|வெள்.|சனி)/i,
    wide: /^(ஞாயிறு|திங்கள்|செவ்வாய்|புதன்|வியாழன்|வெள்ளி|சனி)/i
};
const $7f00a52b023204a2$var$parseDayPatterns = {
    narrow: [
        /^ஞா/i,
        /^தி/i,
        /^செ/i,
        /^பு/i,
        /^வி/i,
        /^வெ/i,
        /^ச/i
    ],
    any: [
        /^ஞா/i,
        /^தி/i,
        /^செ/i,
        /^பு/i,
        /^வி/i,
        /^வெ/i,
        /^ச/i
    ]
};
const $7f00a52b023204a2$var$matchDayPeriodPatterns = {
    narrow: /^(மு.ப|பி.ப|நள்|நண்|காலை|மதியம்|மாலை|இரவு)/i,
    any: /^(மு.ப|பி.ப|முற்பகல்|பிற்பகல்|நள்ளிரவு|நண்பகல்|காலை|மதியம்|மாலை|இரவு)/i
};
const $7f00a52b023204a2$var$parseDayPeriodPatterns = {
    any: {
        am: /^மு/i,
        pm: /^பி/i,
        midnight: /^நள்/i,
        noon: /^நண்/i,
        morning: /காலை/i,
        afternoon: /மதியம்/i,
        evening: /மாலை/i,
        night: /இரவு/i
    }
};
const $7f00a52b023204a2$var$match = $7f00a52b023204a2$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $7f00a52b023204a2$var$matchOrdinalNumberPattern,
        parsePattern: $7f00a52b023204a2$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $7f00a52b023204a2$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7f00a52b023204a2$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $7f00a52b023204a2$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7f00a52b023204a2$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $7f00a52b023204a2$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7f00a52b023204a2$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $7f00a52b023204a2$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7f00a52b023204a2$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $7f00a52b023204a2$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $7f00a52b023204a2$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("2geFg", function(module, exports) {

$parcel$export(module.exports, "te", function () { return $1a587377d3a72704$export$dfb0c08939807f45; }, function (v) { return $1a587377d3a72704$export$dfb0c08939807f45 = v; });
var $1a587377d3a72704$export$dfb0c08939807f45;
"use strict";
$1a587377d3a72704$export$dfb0c08939807f45 = void 0;

var $4pHGt = parcelRequire("4pHGt");

var $34voc = parcelRequire("34voc");

var $avsLr = parcelRequire("avsLr");

var $8hbgU = parcelRequire("8hbgU");

var $ed1ZW = parcelRequire("ed1ZW");
/**
 * @category Locales
 * @summary Telugu locale
 * @language Telugu
 * @iso-639-2 tel
 * @author Kranthi Lakum [@kranthilakum](https://github.com/kranthilakum)
 */ const $1a587377d3a72704$var$te = $1a587377d3a72704$export$dfb0c08939807f45 = {
    code: "te",
    formatDistance: $4pHGt.formatDistance,
    formatLong: $34voc.formatLong,
    formatRelative: $avsLr.formatRelative,
    localize: $8hbgU.localize,
    match: $ed1ZW.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("4pHGt", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $336b61fc3ce0cb34$export$2c14ff85d6318973; }, function (v) { return $336b61fc3ce0cb34$export$2c14ff85d6318973 = v; });
var $336b61fc3ce0cb34$export$2c14ff85d6318973;
"use strict";
$336b61fc3ce0cb34$export$2c14ff85d6318973 = void 0;
// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
const $336b61fc3ce0cb34$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "\u0C38\u0C46\u0C15\u0C28\u0C41 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35",
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35"
        },
        withPreposition: {
            one: "\u0C38\u0C46\u0C15\u0C28\u0C41",
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
        }
    },
    xSeconds: {
        standalone: {
            one: "\u0C12\u0C15 \u0C38\u0C46\u0C15\u0C28\u0C41",
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C38\u0C46\u0C15\u0C28\u0C41",
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
        }
    },
    halfAMinute: {
        standalone: "\u0C05\u0C30 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
        withPreposition: "\u0C05\u0C30 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02"
    },
    lessThanXMinutes: {
        standalone: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35",
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32"
        }
    },
    xMinutes: {
        standalone: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32"
        }
    },
    aboutXHours: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C17\u0C02\u0C1F",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C17\u0C02\u0C1F\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C17\u0C02\u0C1F",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C17\u0C02\u0C1F\u0C32"
        }
    },
    xHours: {
        standalone: {
            one: "\u0C12\u0C15 \u0C17\u0C02\u0C1F",
            other: "{{count}} \u0C17\u0C02\u0C1F\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C17\u0C02\u0C1F",
            other: "{{count}} \u0C17\u0C02\u0C1F\u0C32"
        }
    },
    xDays: {
        standalone: {
            one: "\u0C12\u0C15 \u0C30\u0C4B\u0C1C\u0C41",
            other: "{{count}} \u0C30\u0C4B\u0C1C\u0C41\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C30\u0C4B\u0C1C\u0C41",
            other: "{{count}} \u0C30\u0C4B\u0C1C\u0C41\u0C32"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C32"
        }
    },
    xWeeks: {
        standalone: {
            one: "\u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "{{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "{{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C32"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C28\u0C46\u0C32",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C28\u0C46\u0C32\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C28\u0C46\u0C32",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C28\u0C46\u0C32\u0C32"
        }
    },
    xMonths: {
        standalone: {
            one: "\u0C12\u0C15 \u0C28\u0C46\u0C32",
            other: "{{count}} \u0C28\u0C46\u0C32\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C28\u0C46\u0C32",
            other: "{{count}} \u0C28\u0C46\u0C32\u0C32"
        }
    },
    aboutXYears: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    },
    xYears: {
        standalone: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    },
    overXYears: {
        standalone: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02 \u0C2A\u0C48\u0C17\u0C3E",
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C15\u0C41 \u0C2A\u0C48\u0C17\u0C3E"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    },
    almostXYears: {
        standalone: {
            one: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    }
};
const $336b61fc3ce0cb34$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = options?.addSuffix ? $336b61fc3ce0cb34$var$formatDistanceLocale[token].withPreposition : $336b61fc3ce0cb34$var$formatDistanceLocale[token].standalone;
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u0C32\u0C4B";
        else return result + " \u0C15\u0C4D\u0C30\u0C3F\u0C24\u0C02";
    }
    return result;
};
$336b61fc3ce0cb34$export$2c14ff85d6318973 = $336b61fc3ce0cb34$var$formatDistance;

});

parcelRegister("34voc", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $23ca180fd21d4ea9$export$cbf60ecb96cbb82f; }, function (v) { return $23ca180fd21d4ea9$export$cbf60ecb96cbb82f = v; });
var $23ca180fd21d4ea9$export$cbf60ecb96cbb82f;
"use strict";
$23ca180fd21d4ea9$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
// CLDR #1807 - #1811
const $23ca180fd21d4ea9$var$dateFormats = {
    full: "d, MMMM y, EEEE",
    long: "d MMMM, y",
    medium: "d MMM, y",
    short: "dd-MM-yy"
};
// CLDR #1807 - #1811
const $23ca180fd21d4ea9$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
// CLDR #1815 - #1818
const $23ca180fd21d4ea9$var$dateTimeFormats = {
    full: "{{date}} {{time}}'\u0C15\u0C3F'",
    long: "{{date}} {{time}}'\u0C15\u0C3F'",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $23ca180fd21d4ea9$var$formatLong = $23ca180fd21d4ea9$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $23ca180fd21d4ea9$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $23ca180fd21d4ea9$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $23ca180fd21d4ea9$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("avsLr", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $7a631c9473cd00e0$export$8fbbfd65594f46a0; }, function (v) { return $7a631c9473cd00e0$export$8fbbfd65594f46a0 = v; });
var $7a631c9473cd00e0$export$8fbbfd65594f46a0;
"use strict";
$7a631c9473cd00e0$export$8fbbfd65594f46a0 = void 0;
// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
const $7a631c9473cd00e0$var$formatRelativeLocale = {
    lastWeek: "'\u0C17\u0C24' eeee p",
    yesterday: "'\u0C28\u0C3F\u0C28\u0C4D\u0C28' p",
    today: "'\u0C08 \u0C30\u0C4B\u0C1C\u0C41' p",
    tomorrow: "'\u0C30\u0C47\u0C2A\u0C41' p",
    nextWeek: "'\u0C24\u0C26\u0C41\u0C2A\u0C30\u0C3F' eeee p",
    other: "P"
};
const $7a631c9473cd00e0$var$formatRelative = (token, _date, _baseDate, _options)=>$7a631c9473cd00e0$var$formatRelativeLocale[token];
$7a631c9473cd00e0$export$8fbbfd65594f46a0 = $7a631c9473cd00e0$var$formatRelative;

});

parcelRegister("8hbgU", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $6068a79a5271c2fa$export$b3bd0bc58e36cd63; }, function (v) { return $6068a79a5271c2fa$export$b3bd0bc58e36cd63 = v; });
var $6068a79a5271c2fa$export$b3bd0bc58e36cd63;
"use strict";
$6068a79a5271c2fa$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
// Source: https://dsal.uchicago.edu/dictionaries/brown/
// CLDR #1605 - #1608
const $6068a79a5271c2fa$var$eraValues = {
    narrow: [
        "\u0C15\u0C4D\u0C30\u0C40.\u0C2A\u0C42.",
        "\u0C15\u0C4D\u0C30\u0C40.\u0C36."
    ],
    abbreviated: [
        "\u0C15\u0C4D\u0C30\u0C40.\u0C2A\u0C42.",
        "\u0C15\u0C4D\u0C30\u0C40.\u0C36."
    ],
    wide: [
        "\u0C15\u0C4D\u0C30\u0C40\u0C38\u0C4D\u0C24\u0C41 \u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C02",
        "\u0C15\u0C4D\u0C30\u0C40\u0C38\u0C4D\u0C24\u0C41\u0C36\u0C15\u0C02"
    ]
};
// CLDR #1613 - #1628
const $6068a79a5271c2fa$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u0C24\u0C4D\u0C30\u0C481",
        "\u0C24\u0C4D\u0C30\u0C482",
        "\u0C24\u0C4D\u0C30\u0C483",
        "\u0C24\u0C4D\u0C30\u0C484"
    ],
    wide: [
        "1\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02",
        "2\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02",
        "3\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02",
        "4\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02"
    ]
};
// CLDR #1637 - #1708
const $6068a79a5271c2fa$var$monthValues = {
    narrow: [
        "\u0C1C",
        "\u0C2B\u0C3F",
        "\u0C2E\u0C3E",
        "\u0C0F",
        "\u0C2E\u0C47",
        "\u0C1C\u0C42",
        "\u0C1C\u0C41",
        "\u0C06",
        "\u0C38\u0C46",
        "\u0C05",
        "\u0C28",
        "\u0C21\u0C3F"
    ],
    abbreviated: [
        "\u0C1C\u0C28",
        "\u0C2B\u0C3F\u0C2C\u0C4D\u0C30",
        "\u0C2E\u0C3E\u0C30\u0C4D\u0C1A\u0C3F",
        "\u0C0F\u0C2A\u0C4D\u0C30\u0C3F",
        "\u0C2E\u0C47",
        "\u0C1C\u0C42\u0C28\u0C4D",
        "\u0C1C\u0C41\u0C32\u0C48",
        "\u0C06\u0C17",
        "\u0C38\u0C46\u0C2A\u0C4D\u0C1F\u0C46\u0C02",
        "\u0C05\u0C15\u0C4D\u0C1F\u0C4B",
        "\u0C28\u0C35\u0C02",
        "\u0C21\u0C3F\u0C38\u0C46\u0C02"
    ],
    wide: [
        "\u0C1C\u0C28\u0C35\u0C30\u0C3F",
        "\u0C2B\u0C3F\u0C2C\u0C4D\u0C30\u0C35\u0C30\u0C3F",
        "\u0C2E\u0C3E\u0C30\u0C4D\u0C1A\u0C3F",
        "\u0C0F\u0C2A\u0C4D\u0C30\u0C3F\u0C32\u0C4D",
        "\u0C2E\u0C47",
        "\u0C1C\u0C42\u0C28\u0C4D",
        "\u0C1C\u0C41\u0C32\u0C48",
        "\u0C06\u0C17\u0C38\u0C4D\u0C1F\u0C41",
        "\u0C38\u0C46\u0C2A\u0C4D\u0C1F\u0C46\u0C02\u0C2C\u0C30\u0C4D",
        "\u0C05\u0C15\u0C4D\u0C1F\u0C4B\u0C2C\u0C30\u0C4D",
        "\u0C28\u0C35\u0C02\u0C2C\u0C30\u0C4D",
        "\u0C21\u0C3F\u0C38\u0C46\u0C02\u0C2C\u0C30\u0C4D"
    ]
};
// CLDR #1709 - #1764
const $6068a79a5271c2fa$var$dayValues = {
    narrow: [
        "\u0C06",
        "\u0C38\u0C4B",
        "\u0C2E",
        "\u0C2C\u0C41",
        "\u0C17\u0C41",
        "\u0C36\u0C41",
        "\u0C36"
    ],
    short: [
        "\u0C06\u0C26\u0C3F",
        "\u0C38\u0C4B\u0C2E",
        "\u0C2E\u0C02\u0C17\u0C33",
        "\u0C2C\u0C41\u0C27",
        "\u0C17\u0C41\u0C30\u0C41",
        "\u0C36\u0C41\u0C15\u0C4D\u0C30",
        "\u0C36\u0C28\u0C3F"
    ],
    abbreviated: [
        "\u0C06\u0C26\u0C3F",
        "\u0C38\u0C4B\u0C2E",
        "\u0C2E\u0C02\u0C17\u0C33",
        "\u0C2C\u0C41\u0C27",
        "\u0C17\u0C41\u0C30\u0C41",
        "\u0C36\u0C41\u0C15\u0C4D\u0C30",
        "\u0C36\u0C28\u0C3F"
    ],
    wide: [
        "\u0C06\u0C26\u0C3F\u0C35\u0C3E\u0C30\u0C02",
        "\u0C38\u0C4B\u0C2E\u0C35\u0C3E\u0C30\u0C02",
        "\u0C2E\u0C02\u0C17\u0C33\u0C35\u0C3E\u0C30\u0C02",
        "\u0C2C\u0C41\u0C27\u0C35\u0C3E\u0C30\u0C02",
        "\u0C17\u0C41\u0C30\u0C41\u0C35\u0C3E\u0C30\u0C02",
        "\u0C36\u0C41\u0C15\u0C4D\u0C30\u0C35\u0C3E\u0C30\u0C02",
        "\u0C36\u0C28\u0C3F\u0C35\u0C3E\u0C30\u0C02"
    ]
};
// CLDR #1767 - #1806
const $6068a79a5271c2fa$var$dayPeriodValues = {
    narrow: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    abbreviated: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    wide: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    }
};
const $6068a79a5271c2fa$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    abbreviated: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    wide: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    }
};
const $6068a79a5271c2fa$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + "\u0C35";
};
const $6068a79a5271c2fa$var$localize = $6068a79a5271c2fa$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $6068a79a5271c2fa$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $6068a79a5271c2fa$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $6068a79a5271c2fa$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $6068a79a5271c2fa$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $6068a79a5271c2fa$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $6068a79a5271c2fa$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $6068a79a5271c2fa$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("ed1ZW", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $a583d4615d74fc82$export$4659b591c19bdf3d; }, function (v) { return $a583d4615d74fc82$export$4659b591c19bdf3d = v; });
var $a583d4615d74fc82$export$4659b591c19bdf3d;
"use strict";
$a583d4615d74fc82$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $a583d4615d74fc82$var$matchOrdinalNumberPattern = /^(\d+)(వ)?/i;
const $a583d4615d74fc82$var$parseOrdinalNumberPattern = /\d+/i;
const $a583d4615d74fc82$var$matchEraPatterns = {
    narrow: /^(క్రీ\.పూ\.|క్రీ\.శ\.)/i,
    abbreviated: /^(క్రీ\.?\s?పూ\.?|ప్ర\.?\s?శ\.?\s?పూ\.?|క్రీ\.?\s?శ\.?|సా\.?\s?శ\.?)/i,
    wide: /^(క్రీస్తు పూర్వం|ప్రస్తుత శకానికి పూర్వం|క్రీస్తు శకం|ప్రస్తుత శకం)/i
};
const $a583d4615d74fc82$var$parseEraPatterns = {
    any: [
        /^(పూ|శ)/i,
        /^సా/i
    ]
};
const $a583d4615d74fc82$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^త్రై[1234]/i,
    wide: /^[1234](వ)? త్రైమాసికం/i
};
const $a583d4615d74fc82$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $a583d4615d74fc82$var$matchMonthPatterns = {
    narrow: /^(జూ|జు|జ|ఫి|మా|ఏ|మే|ఆ|సె|అ|న|డి)/i,
    abbreviated: /^(జన|ఫిబ్ర|మార్చి|ఏప్రి|మే|జూన్|జులై|ఆగ|సెప్|అక్టో|నవ|డిసె)/i,
    wide: /^(జనవరి|ఫిబ్రవరి|మార్చి|ఏప్రిల్|మే|జూన్|జులై|ఆగస్టు|సెప్టెంబర్|అక్టోబర్|నవంబర్|డిసెంబర్)/i
};
const $a583d4615d74fc82$var$parseMonthPatterns = {
    narrow: [
        /^జ/i,
        /^ఫి/i,
        /^మా/i,
        /^ఏ/i,
        /^మే/i,
        /^జూ/i,
        /^జు/i,
        /^ఆ/i,
        /^సె/i,
        /^అ/i,
        /^న/i,
        /^డి/i
    ],
    any: [
        /^జన/i,
        /^ఫి/i,
        /^మా/i,
        /^ఏ/i,
        /^మే/i,
        /^జూన్/i,
        /^జులై/i,
        /^ఆగ/i,
        /^సె/i,
        /^అ/i,
        /^న/i,
        /^డి/i
    ]
};
const $a583d4615d74fc82$var$matchDayPatterns = {
    narrow: /^(ఆ|సో|మ|బు|గు|శు|శ)/i,
    short: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
    abbreviated: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
    wide: /^(ఆదివారం|సోమవారం|మంగళవారం|బుధవారం|గురువారం|శుక్రవారం|శనివారం)/i
};
const $a583d4615d74fc82$var$parseDayPatterns = {
    narrow: [
        /^ఆ/i,
        /^సో/i,
        /^మ/i,
        /^బు/i,
        /^గు/i,
        /^శు/i,
        /^శ/i
    ],
    any: [
        /^ఆది/i,
        /^సోమ/i,
        /^మం/i,
        /^బుధ/i,
        /^గురు/i,
        /^శుక్ర/i,
        /^శని/i
    ]
};
const $a583d4615d74fc82$var$matchDayPeriodPatterns = {
    narrow: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i,
    any: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i
};
const $a583d4615d74fc82$var$parseDayPeriodPatterns = {
    any: {
        am: /^పూర్వాహ్నం/i,
        pm: /^అపరాహ్నం/i,
        midnight: /^అర్ధ/i,
        noon: /^మిట్ట/i,
        morning: /ఉదయం/i,
        afternoon: /మధ్యాహ్నం/i,
        evening: /సాయంత్రం/i,
        night: /రాత్రి/i
    }
};
const $a583d4615d74fc82$var$match = $a583d4615d74fc82$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $a583d4615d74fc82$var$matchOrdinalNumberPattern,
        parsePattern: $a583d4615d74fc82$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $a583d4615d74fc82$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a583d4615d74fc82$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $a583d4615d74fc82$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a583d4615d74fc82$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $a583d4615d74fc82$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a583d4615d74fc82$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $a583d4615d74fc82$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a583d4615d74fc82$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $a583d4615d74fc82$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $a583d4615d74fc82$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("lHi3Y", function(module, exports) {

$parcel$export(module.exports, "th", function () { return $fcbba017d59844c3$export$d657bc098992a431; }, function (v) { return $fcbba017d59844c3$export$d657bc098992a431 = v; });
var $fcbba017d59844c3$export$d657bc098992a431;
"use strict";
$fcbba017d59844c3$export$d657bc098992a431 = void 0;

var $4PnX2 = parcelRequire("4PnX2");

var $e8jeh = parcelRequire("e8jeh");

var $kiRfM = parcelRequire("kiRfM");

var $aBf2s = parcelRequire("aBf2s");

var $jn4IB = parcelRequire("jn4IB");
/**
 * @category Locales
 * @summary Thai locale.
 * @language Thai
 * @iso-639-2 tha
 * @author Athiwat Hirunworawongkun [@athivvat](https://github.com/athivvat)
 * @author [@hawkup](https://github.com/hawkup)
 * @author  Jirawat I. [@nodtem66](https://github.com/nodtem66)
 */ const $fcbba017d59844c3$var$th = $fcbba017d59844c3$export$d657bc098992a431 = {
    code: "th",
    formatDistance: $4PnX2.formatDistance,
    formatLong: $e8jeh.formatLong,
    formatRelative: $kiRfM.formatRelative,
    localize: $aBf2s.localize,
    match: $jn4IB.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("4PnX2", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $383e810a6ecaa6ea$export$2c14ff85d6318973; }, function (v) { return $383e810a6ecaa6ea$export$2c14ff85d6318973 = v; });
var $383e810a6ecaa6ea$export$2c14ff85d6318973;
"use strict";
$383e810a6ecaa6ea$export$2c14ff85d6318973 = void 0;
const $383e810a6ecaa6ea$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 1 \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35",
        other: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35"
    },
    xSeconds: {
        one: "1 \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35",
        other: "{{count}} \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35"
    },
    halfAMinute: "\u0E04\u0E23\u0E36\u0E48\u0E07\u0E19\u0E32\u0E17\u0E35",
    lessThanXMinutes: {
        one: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 1 \u0E19\u0E32\u0E17\u0E35",
        other: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E19\u0E32\u0E17\u0E35"
    },
    xMinutes: {
        one: "1 \u0E19\u0E32\u0E17\u0E35",
        other: "{{count}} \u0E19\u0E32\u0E17\u0E35"
    },
    aboutXHours: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07"
    },
    xHours: {
        one: "1 \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07",
        other: "{{count}} \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07"
    },
    xDays: {
        one: "1 \u0E27\u0E31\u0E19",
        other: "{{count}} \u0E27\u0E31\u0E19"
    },
    aboutXWeeks: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C"
    },
    xWeeks: {
        one: "1 \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C",
        other: "{{count}} \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C"
    },
    aboutXMonths: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E40\u0E14\u0E37\u0E2D\u0E19",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E40\u0E14\u0E37\u0E2D\u0E19"
    },
    xMonths: {
        one: "1 \u0E40\u0E14\u0E37\u0E2D\u0E19",
        other: "{{count}} \u0E40\u0E14\u0E37\u0E2D\u0E19"
    },
    aboutXYears: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E1B\u0E35",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E1B\u0E35"
    },
    xYears: {
        one: "1 \u0E1B\u0E35",
        other: "{{count}} \u0E1B\u0E35"
    },
    overXYears: {
        one: "\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 1 \u0E1B\u0E35",
        other: "\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E1B\u0E35"
    },
    almostXYears: {
        one: "\u0E40\u0E01\u0E37\u0E2D\u0E1A 1 \u0E1B\u0E35",
        other: "\u0E40\u0E01\u0E37\u0E2D\u0E1A {{count}} \u0E1B\u0E35"
    }
};
const $383e810a6ecaa6ea$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $383e810a6ecaa6ea$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) {
            if (token === "halfAMinute") return "\u0E43\u0E19" + result;
            else return "\u0E43\u0E19 " + result;
        } else return result + "\u0E17\u0E35\u0E48\u0E1C\u0E48\u0E32\u0E19\u0E21\u0E32";
    }
    return result;
};
$383e810a6ecaa6ea$export$2c14ff85d6318973 = $383e810a6ecaa6ea$var$formatDistance;

});

parcelRegister("e8jeh", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $a4a0ba9bfb51bb75$export$cbf60ecb96cbb82f; }, function (v) { return $a4a0ba9bfb51bb75$export$cbf60ecb96cbb82f = v; });
var $a4a0ba9bfb51bb75$export$cbf60ecb96cbb82f;
"use strict";
$a4a0ba9bfb51bb75$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $a4a0ba9bfb51bb75$var$dateFormats = {
    full: "\u0E27\u0E31\u0E19EEEE\u0E17\u0E35\u0E48 do MMMM y",
    long: "do MMMM y",
    medium: "d MMM y",
    short: "dd/MM/yyyy"
};
const $a4a0ba9bfb51bb75$var$timeFormats = {
    full: "H:mm:ss \u0E19. zzzz",
    long: "H:mm:ss \u0E19. z",
    medium: "H:mm:ss \u0E19.",
    short: "H:mm \u0E19."
};
const $a4a0ba9bfb51bb75$var$dateTimeFormats = {
    full: "{{date}} '\u0E40\u0E27\u0E25\u0E32' {{time}}",
    long: "{{date}} '\u0E40\u0E27\u0E25\u0E32' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $a4a0ba9bfb51bb75$var$formatLong = $a4a0ba9bfb51bb75$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $a4a0ba9bfb51bb75$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $a4a0ba9bfb51bb75$var$timeFormats,
        defaultWidth: "medium"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $a4a0ba9bfb51bb75$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("kiRfM", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $ec7ecc1c25085188$export$8fbbfd65594f46a0; }, function (v) { return $ec7ecc1c25085188$export$8fbbfd65594f46a0 = v; });
var $ec7ecc1c25085188$export$8fbbfd65594f46a0;
"use strict";
$ec7ecc1c25085188$export$8fbbfd65594f46a0 = void 0;
const $ec7ecc1c25085188$var$formatRelativeLocale = {
    lastWeek: "eeee'\u0E17\u0E35\u0E48\u0E41\u0E25\u0E49\u0E27\u0E40\u0E27\u0E25\u0E32' p",
    yesterday: "'\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E27\u0E32\u0E19\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
    today: "'\u0E27\u0E31\u0E19\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
    tomorrow: "'\u0E1E\u0E23\u0E38\u0E48\u0E07\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
    nextWeek: "eeee '\u0E40\u0E27\u0E25\u0E32' p",
    other: "P"
};
const $ec7ecc1c25085188$var$formatRelative = (token, _date, _baseDate, _options)=>$ec7ecc1c25085188$var$formatRelativeLocale[token];
$ec7ecc1c25085188$export$8fbbfd65594f46a0 = $ec7ecc1c25085188$var$formatRelative;

});

parcelRegister("aBf2s", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $7b790677fc0db274$export$b3bd0bc58e36cd63; }, function (v) { return $7b790677fc0db274$export$b3bd0bc58e36cd63 = v; });
var $7b790677fc0db274$export$b3bd0bc58e36cd63;
"use strict";
$7b790677fc0db274$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $7b790677fc0db274$var$eraValues = {
    narrow: [
        "B",
        "\u0E04\u0E28"
    ],
    abbreviated: [
        "BC",
        "\u0E04.\u0E28."
    ],
    wide: [
        "\u0E1B\u0E35\u0E01\u0E48\u0E2D\u0E19\u0E04\u0E23\u0E34\u0E2A\u0E15\u0E01\u0E32\u0E25",
        "\u0E04\u0E23\u0E34\u0E2A\u0E15\u0E4C\u0E28\u0E31\u0E01\u0E23\u0E32\u0E0A"
    ]
};
const $7b790677fc0db274$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E41\u0E23\u0E01",
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E2D\u0E07",
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E32\u0E21",
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E35\u0E48"
    ]
};
const $7b790677fc0db274$var$dayValues = {
    narrow: [
        "\u0E2D\u0E32.",
        "\u0E08.",
        "\u0E2D.",
        "\u0E1E.",
        "\u0E1E\u0E24.",
        "\u0E28.",
        "\u0E2A."
    ],
    short: [
        "\u0E2D\u0E32.",
        "\u0E08.",
        "\u0E2D.",
        "\u0E1E.",
        "\u0E1E\u0E24.",
        "\u0E28.",
        "\u0E2A."
    ],
    abbreviated: [
        "\u0E2D\u0E32.",
        "\u0E08.",
        "\u0E2D.",
        "\u0E1E.",
        "\u0E1E\u0E24.",
        "\u0E28.",
        "\u0E2A."
    ],
    wide: [
        "\u0E2D\u0E32\u0E17\u0E34\u0E15\u0E22\u0E4C",
        "\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C",
        "\u0E2D\u0E31\u0E07\u0E04\u0E32\u0E23",
        "\u0E1E\u0E38\u0E18",
        "\u0E1E\u0E24\u0E2B\u0E31\u0E2A\u0E1A\u0E14\u0E35",
        "\u0E28\u0E38\u0E01\u0E23\u0E4C",
        "\u0E40\u0E2A\u0E32\u0E23\u0E4C"
    ]
};
const $7b790677fc0db274$var$monthValues = {
    narrow: [
        "\u0E21.\u0E04.",
        "\u0E01.\u0E1E.",
        "\u0E21\u0E35.\u0E04.",
        "\u0E40\u0E21.\u0E22.",
        "\u0E1E.\u0E04.",
        "\u0E21\u0E34.\u0E22.",
        "\u0E01.\u0E04.",
        "\u0E2A.\u0E04.",
        "\u0E01.\u0E22.",
        "\u0E15.\u0E04.",
        "\u0E1E.\u0E22.",
        "\u0E18.\u0E04."
    ],
    abbreviated: [
        "\u0E21.\u0E04.",
        "\u0E01.\u0E1E.",
        "\u0E21\u0E35.\u0E04.",
        "\u0E40\u0E21.\u0E22.",
        "\u0E1E.\u0E04.",
        "\u0E21\u0E34.\u0E22.",
        "\u0E01.\u0E04.",
        "\u0E2A.\u0E04.",
        "\u0E01.\u0E22.",
        "\u0E15.\u0E04.",
        "\u0E1E.\u0E22.",
        "\u0E18.\u0E04."
    ],
    wide: [
        "\u0E21\u0E01\u0E23\u0E32\u0E04\u0E21",
        "\u0E01\u0E38\u0E21\u0E20\u0E32\u0E1E\u0E31\u0E19\u0E18\u0E4C",
        "\u0E21\u0E35\u0E19\u0E32\u0E04\u0E21",
        "\u0E40\u0E21\u0E29\u0E32\u0E22\u0E19",
        "\u0E1E\u0E24\u0E29\u0E20\u0E32\u0E04\u0E21",
        "\u0E21\u0E34\u0E16\u0E38\u0E19\u0E32\u0E22\u0E19",
        "\u0E01\u0E23\u0E01\u0E0E\u0E32\u0E04\u0E21",
        "\u0E2A\u0E34\u0E07\u0E2B\u0E32\u0E04\u0E21",
        "\u0E01\u0E31\u0E19\u0E22\u0E32\u0E22\u0E19",
        "\u0E15\u0E38\u0E25\u0E32\u0E04\u0E21",
        "\u0E1E\u0E24\u0E28\u0E08\u0E34\u0E01\u0E32\u0E22\u0E19",
        "\u0E18\u0E31\u0E19\u0E27\u0E32\u0E04\u0E21"
    ]
};
const $7b790677fc0db274$var$dayPeriodValues = {
    narrow: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E1A\u0E48\u0E32\u0E22",
        evening: "\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    abbreviated: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E1A\u0E48\u0E32\u0E22",
        evening: "\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    wide: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E1A\u0E48\u0E32\u0E22",
        evening: "\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    }
};
const $7b790677fc0db274$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
        evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    abbreviated: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
        evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    wide: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
        evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    }
};
const $7b790677fc0db274$var$ordinalNumber = (dirtyNumber, _options)=>{
    return String(dirtyNumber);
};
const $7b790677fc0db274$var$localize = $7b790677fc0db274$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $7b790677fc0db274$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $7b790677fc0db274$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $7b790677fc0db274$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $7b790677fc0db274$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $7b790677fc0db274$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $7b790677fc0db274$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $7b790677fc0db274$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("jn4IB", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $e1a3d3428c218dee$export$4659b591c19bdf3d; }, function (v) { return $e1a3d3428c218dee$export$4659b591c19bdf3d = v; });
var $e1a3d3428c218dee$export$4659b591c19bdf3d;
"use strict";
$e1a3d3428c218dee$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $e1a3d3428c218dee$var$matchOrdinalNumberPattern = /^\d+/i;
const $e1a3d3428c218dee$var$parseOrdinalNumberPattern = /\d+/i;
const $e1a3d3428c218dee$var$matchEraPatterns = {
    narrow: /^([bB]|[aA]|คศ)/i,
    abbreviated: /^([bB]\.?\s?[cC]\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?|ค\.?ศ\.?)/i,
    wide: /^(ก่อนคริสตกาล|คริสต์ศักราช|คริสตกาล)/i
};
const $e1a3d3428c218dee$var$parseEraPatterns = {
    any: [
        /^[bB]/i,
        /^(^[aA]|ค\.?ศ\.?|คริสตกาล|คริสต์ศักราช|)/i
    ]
};
const $e1a3d3428c218dee$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^ไตรมาส(ที่)? ?[1234]/i
};
const $e1a3d3428c218dee$var$parseQuarterPatterns = {
    any: [
        /(1|แรก|หนึ่ง)/i,
        /(2|สอง)/i,
        /(3|สาม)/i,
        /(4|สี่)/i
    ]
};
const $e1a3d3428c218dee$var$matchMonthPatterns = {
    narrow: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?)/i,
    abbreviated: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?')/i,
    wide: /^(มกราคม|กุมภาพันธ์|มีนาคม|เมษายน|พฤษภาคม|มิถุนายน|กรกฎาคม|สิงหาคม|กันยายน|ตุลาคม|พฤศจิกายน|ธันวาคม)/i
};
const $e1a3d3428c218dee$var$parseMonthPatterns = {
    wide: [
        /^มก/i,
        /^กุม/i,
        /^มี/i,
        /^เม/i,
        /^พฤษ/i,
        /^มิ/i,
        /^กรก/i,
        /^ส/i,
        /^กัน/i,
        /^ต/i,
        /^พฤศ/i,
        /^ธ/i
    ],
    any: [
        /^ม\.?ค\.?/i,
        /^ก\.?พ\.?/i,
        /^มี\.?ค\.?/i,
        /^เม\.?ย\.?/i,
        /^พ\.?ค\.?/i,
        /^มิ\.?ย\.?/i,
        /^ก\.?ค\.?/i,
        /^ส\.?ค\.?/i,
        /^ก\.?ย\.?/i,
        /^ต\.?ค\.?/i,
        /^พ\.?ย\.?/i,
        /^ธ\.?ค\.?/i
    ]
};
const $e1a3d3428c218dee$var$matchDayPatterns = {
    narrow: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
    short: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
    abbreviated: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
    wide: /^(อาทิตย์|จันทร์|อังคาร|พุธ|พฤหัสบดี|ศุกร์|เสาร์)/i
};
const $e1a3d3428c218dee$var$parseDayPatterns = {
    wide: [
        /^อา/i,
        /^จั/i,
        /^อั/i,
        /^พุธ/i,
        /^พฤ/i,
        /^ศ/i,
        /^เส/i
    ],
    any: [
        /^อา/i,
        /^จ/i,
        /^อ/i,
        /^พ(?!ฤ)/i,
        /^พฤ/i,
        /^ศ/i,
        /^ส/i
    ]
};
const $e1a3d3428c218dee$var$matchDayPeriodPatterns = {
    any: /^(ก่อนเที่ยง|หลังเที่ยง|เที่ยงคืน|เที่ยง|(ตอน.*?)?.*(เที่ยง|เช้า|บ่าย|เย็น|กลางคืน))/i
};
const $e1a3d3428c218dee$var$parseDayPeriodPatterns = {
    any: {
        am: /^ก่อนเที่ยง/i,
        pm: /^หลังเที่ยง/i,
        midnight: /^เที่ยงคืน/i,
        noon: /^เที่ยง/i,
        morning: /เช้า/i,
        afternoon: /บ่าย/i,
        evening: /เย็น/i,
        night: /กลางคืน/i
    }
};
const $e1a3d3428c218dee$var$match = $e1a3d3428c218dee$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $e1a3d3428c218dee$var$matchOrdinalNumberPattern,
        parsePattern: $e1a3d3428c218dee$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e1a3d3428c218dee$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e1a3d3428c218dee$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e1a3d3428c218dee$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e1a3d3428c218dee$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e1a3d3428c218dee$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e1a3d3428c218dee$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e1a3d3428c218dee$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e1a3d3428c218dee$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $e1a3d3428c218dee$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $e1a3d3428c218dee$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("9m9Hc", function(module, exports) {

$parcel$export(module.exports, "tr", function () { return $6cfdb08276afd76f$export$72451b88a72ad9c2; }, function (v) { return $6cfdb08276afd76f$export$72451b88a72ad9c2 = v; });
var $6cfdb08276afd76f$export$72451b88a72ad9c2;
"use strict";
$6cfdb08276afd76f$export$72451b88a72ad9c2 = void 0;

var $3vyNs = parcelRequire("3vyNs");

var $g9IOo = parcelRequire("g9IOo");

var $1QQWc = parcelRequire("1QQWc");

var $dNQ1y = parcelRequire("dNQ1y");

var $fxH6O = parcelRequire("fxH6O");
/**
 * @category Locales
 * @summary Turkish locale.
 * @language Turkish
 * @iso-639-2 tur
 * @author Alpcan Aydın [@alpcanaydin](https://github.com/alpcanaydin)
 * @author Berkay Sargın [@berkaey](https://github.com/berkaey)
 * @author Fatih Bulut [@bulutfatih](https://github.com/bulutfatih)
 * @author Ismail Demirbilek [@dbtek](https://github.com/dbtek)
 * @author İsmail Kayar [@ikayar](https://github.com/ikayar)
 *
 *
 */ const $6cfdb08276afd76f$var$tr = $6cfdb08276afd76f$export$72451b88a72ad9c2 = {
    code: "tr",
    formatDistance: $3vyNs.formatDistance,
    formatLong: $g9IOo.formatLong,
    formatRelative: $1QQWc.formatRelative,
    localize: $dNQ1y.localize,
    match: $fxH6O.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("3vyNs", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $28df423e2dbdf43e$export$2c14ff85d6318973; }, function (v) { return $28df423e2dbdf43e$export$2c14ff85d6318973 = v; });
var $28df423e2dbdf43e$export$2c14ff85d6318973;
"use strict";
$28df423e2dbdf43e$export$2c14ff85d6318973 = void 0;
const $28df423e2dbdf43e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "bir saniyeden az",
        other: "{{count}} saniyeden az"
    },
    xSeconds: {
        one: "1 saniye",
        other: "{{count}} saniye"
    },
    halfAMinute: "yar\u0131m dakika",
    lessThanXMinutes: {
        one: "bir dakikadan az",
        other: "{{count}} dakikadan az"
    },
    xMinutes: {
        one: "1 dakika",
        other: "{{count}} dakika"
    },
    aboutXHours: {
        one: "yakla\u015F\u0131k 1 saat",
        other: "yakla\u015F\u0131k {{count}} saat"
    },
    xHours: {
        one: "1 saat",
        other: "{{count}} saat"
    },
    xDays: {
        one: "1 g\xfcn",
        other: "{{count}} g\xfcn"
    },
    aboutXWeeks: {
        one: "yakla\u015F\u0131k 1 hafta",
        other: "yakla\u015F\u0131k {{count}} hafta"
    },
    xWeeks: {
        one: "1 hafta",
        other: "{{count}} hafta"
    },
    aboutXMonths: {
        one: "yakla\u015F\u0131k 1 ay",
        other: "yakla\u015F\u0131k {{count}} ay"
    },
    xMonths: {
        one: "1 ay",
        other: "{{count}} ay"
    },
    aboutXYears: {
        one: "yakla\u015F\u0131k 1 y\u0131l",
        other: "yakla\u015F\u0131k {{count}} y\u0131l"
    },
    xYears: {
        one: "1 y\u0131l",
        other: "{{count}} y\u0131l"
    },
    overXYears: {
        one: "1 y\u0131ldan fazla",
        other: "{{count}} y\u0131ldan fazla"
    },
    almostXYears: {
        one: "neredeyse 1 y\u0131l",
        other: "neredeyse {{count}} y\u0131l"
    }
};
const $28df423e2dbdf43e$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $28df423e2dbdf43e$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " sonra";
        else return result + " \xf6nce";
    }
    return result;
};
$28df423e2dbdf43e$export$2c14ff85d6318973 = $28df423e2dbdf43e$var$formatDistance;

});

parcelRegister("g9IOo", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $bc303f510a1fb427$export$cbf60ecb96cbb82f; }, function (v) { return $bc303f510a1fb427$export$cbf60ecb96cbb82f = v; });
var $bc303f510a1fb427$export$cbf60ecb96cbb82f;
"use strict";
$bc303f510a1fb427$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $bc303f510a1fb427$var$dateFormats = {
    full: "d MMMM y EEEE",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd.MM.yyyy"
};
const $bc303f510a1fb427$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $bc303f510a1fb427$var$dateTimeFormats = {
    full: "{{date}} 'saat' {{time}}",
    long: "{{date}} 'saat' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $bc303f510a1fb427$var$formatLong = $bc303f510a1fb427$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $bc303f510a1fb427$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $bc303f510a1fb427$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $bc303f510a1fb427$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("1QQWc", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $1593b619db0f696d$export$8fbbfd65594f46a0; }, function (v) { return $1593b619db0f696d$export$8fbbfd65594f46a0 = v; });
var $1593b619db0f696d$export$8fbbfd65594f46a0;
"use strict";
$1593b619db0f696d$export$8fbbfd65594f46a0 = void 0;
const $1593b619db0f696d$var$formatRelativeLocale = {
    lastWeek: "'ge\xe7en hafta' eeee 'saat' p",
    yesterday: "'d\xfcn saat' p",
    today: "'bug\xfcn saat' p",
    tomorrow: "'yar\u0131n saat' p",
    nextWeek: "eeee 'saat' p",
    other: "P"
};
const $1593b619db0f696d$var$formatRelative = (token, _date, _baseDate, _options)=>$1593b619db0f696d$var$formatRelativeLocale[token];
$1593b619db0f696d$export$8fbbfd65594f46a0 = $1593b619db0f696d$var$formatRelative;

});

parcelRegister("dNQ1y", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $a0c834dc57ed93ca$export$b3bd0bc58e36cd63; }, function (v) { return $a0c834dc57ed93ca$export$b3bd0bc58e36cd63 = v; });
var $a0c834dc57ed93ca$export$b3bd0bc58e36cd63;
"use strict";
$a0c834dc57ed93ca$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $a0c834dc57ed93ca$var$eraValues = {
    narrow: [
        "M\xd6",
        "MS"
    ],
    abbreviated: [
        "M\xd6",
        "MS"
    ],
    wide: [
        "Milattan \xd6nce",
        "Milattan Sonra"
    ]
};
const $a0c834dc57ed93ca$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1\xc7",
        "2\xc7",
        "3\xc7",
        "4\xc7"
    ],
    wide: [
        "\u0130lk \xe7eyrek",
        "\u0130kinci \xc7eyrek",
        "\xdc\xe7\xfcnc\xfc \xe7eyrek",
        "Son \xe7eyrek"
    ]
};
const $a0c834dc57ed93ca$var$monthValues = {
    narrow: [
        "O",
        "\u015E",
        "M",
        "N",
        "M",
        "H",
        "T",
        "A",
        "E",
        "E",
        "K",
        "A"
    ],
    abbreviated: [
        "Oca",
        "\u015Eub",
        "Mar",
        "Nis",
        "May",
        "Haz",
        "Tem",
        "A\u011Fu",
        "Eyl",
        "Eki",
        "Kas",
        "Ara"
    ],
    wide: [
        "Ocak",
        "\u015Eubat",
        "Mart",
        "Nisan",
        "May\u0131s",
        "Haziran",
        "Temmuz",
        "A\u011Fustos",
        "Eyl\xfcl",
        "Ekim",
        "Kas\u0131m",
        "Aral\u0131k"
    ]
};
const $a0c834dc57ed93ca$var$dayValues = {
    narrow: [
        "P",
        "P",
        "S",
        "\xc7",
        "P",
        "C",
        "C"
    ],
    short: [
        "Pz",
        "Pt",
        "Sa",
        "\xc7a",
        "Pe",
        "Cu",
        "Ct"
    ],
    abbreviated: [
        "Paz",
        "Pzt",
        "Sal",
        "\xc7ar",
        "Per",
        "Cum",
        "Cts"
    ],
    wide: [
        "Pazar",
        "Pazartesi",
        "Sal\u0131",
        "\xc7ar\u015Famba",
        "Per\u015Fembe",
        "Cuma",
        "Cumartesi"
    ]
};
const $a0c834dc57ed93ca$var$dayPeriodValues = {
    narrow: {
        am: "\xf6\xf6",
        pm: "\xf6s",
        midnight: "gy",
        noon: "\xf6",
        morning: "sa",
        afternoon: "\xf6s",
        evening: "ak",
        night: "ge"
    },
    abbreviated: {
        am: "\xd6\xd6",
        pm: "\xd6S",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Fle",
        morning: "sabah",
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Fam",
        night: "gece"
    },
    wide: {
        am: "\xd6.\xd6.",
        pm: "\xd6.S.",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Fle",
        morning: "sabah",
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Fam",
        night: "gece"
    }
};
const $a0c834dc57ed93ca$var$formattingDayPeriodValues = {
    narrow: {
        am: "\xf6\xf6",
        pm: "\xf6s",
        midnight: "gy",
        noon: "\xf6",
        morning: "sa",
        afternoon: "\xf6s",
        evening: "ak",
        night: "ge"
    },
    abbreviated: {
        am: "\xd6\xd6",
        pm: "\xd6S",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Flen",
        morning: "sabahleyin",
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Famleyin",
        night: "geceleyin"
    },
    wide: {
        am: "\xf6.\xf6.",
        pm: "\xf6.s.",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Flen",
        morning: "sabahleyin",
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Famleyin",
        night: "geceleyin"
    }
};
const $a0c834dc57ed93ca$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $a0c834dc57ed93ca$var$localize = $a0c834dc57ed93ca$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $a0c834dc57ed93ca$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $a0c834dc57ed93ca$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $a0c834dc57ed93ca$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>Number(quarter) - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $a0c834dc57ed93ca$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $a0c834dc57ed93ca$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $a0c834dc57ed93ca$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $a0c834dc57ed93ca$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("fxH6O", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $b50b609ba43abb6e$export$4659b591c19bdf3d; }, function (v) { return $b50b609ba43abb6e$export$4659b591c19bdf3d = v; });
var $b50b609ba43abb6e$export$4659b591c19bdf3d;
"use strict";
$b50b609ba43abb6e$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $b50b609ba43abb6e$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
const $b50b609ba43abb6e$var$parseOrdinalNumberPattern = /\d+/i;
const $b50b609ba43abb6e$var$matchEraPatterns = {
    narrow: /^(mö|ms)/i,
    abbreviated: /^(mö|ms)/i,
    wide: /^(milattan önce|milattan sonra)/i
};
const $b50b609ba43abb6e$var$parseEraPatterns = {
    any: [
        /(^mö|^milattan önce)/i,
        /(^ms|^milattan sonra)/i
    ]
};
const $b50b609ba43abb6e$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]ç/i,
    wide: /^((i|İ)lk|(i|İ)kinci|üçüncü|son) çeyrek/i
};
const $b50b609ba43abb6e$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    abbreviated: [
        /1ç/i,
        /2ç/i,
        /3ç/i,
        /4ç/i
    ],
    wide: [
        /^(i|İ)lk çeyrek/i,
        /(i|İ)kinci çeyrek/i,
        /üçüncü çeyrek/i,
        /son çeyrek/i
    ]
};
const $b50b609ba43abb6e$var$matchMonthPatterns = {
    narrow: /^[oşmnhtaek]/i,
    abbreviated: /^(oca|şub|mar|nis|may|haz|tem|ağu|eyl|eki|kas|ara)/i,
    wide: /^(ocak|şubat|mart|nisan|mayıs|haziran|temmuz|ağustos|eylül|ekim|kasım|aralık)/i
};
const $b50b609ba43abb6e$var$parseMonthPatterns = {
    narrow: [
        /^o/i,
        /^ş/i,
        /^m/i,
        /^n/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^a/i,
        /^e/i,
        /^e/i,
        /^k/i,
        /^a/i
    ],
    any: [
        /^o/i,
        /^ş/i,
        /^mar/i,
        /^n/i,
        /^may/i,
        /^h/i,
        /^t/i,
        /^ağ/i,
        /^ey/i,
        /^ek/i,
        /^k/i,
        /^ar/i
    ]
};
const $b50b609ba43abb6e$var$matchDayPatterns = {
    narrow: /^[psçc]/i,
    short: /^(pz|pt|sa|ça|pe|cu|ct)/i,
    abbreviated: /^(paz|pzt|sal|çar|per|cum|cts)/i,
    wide: /^(pazar(?!tesi)|pazartesi|salı|çarşamba|perşembe|cuma(?!rtesi)|cumartesi)/i
};
const $b50b609ba43abb6e$var$parseDayPatterns = {
    narrow: [
        /^p/i,
        /^p/i,
        /^s/i,
        /^ç/i,
        /^p/i,
        /^c/i,
        /^c/i
    ],
    any: [
        /^pz/i,
        /^pt/i,
        /^sa/i,
        /^ça/i,
        /^pe/i,
        /^cu/i,
        /^ct/i
    ],
    wide: [
        /^pazar(?!tesi)/i,
        /^pazartesi/i,
        /^salı/i,
        /^çarşamba/i,
        /^perşembe/i,
        /^cuma(?!rtesi)/i,
        /^cumartesi/i
    ]
};
const $b50b609ba43abb6e$var$matchDayPeriodPatterns = {
    narrow: /^(öö|ös|gy|ö|sa|ös|ak|ge)/i,
    any: /^(ö\.?\s?[ös]\.?|öğleden sonra|gece yarısı|öğle|(sabah|öğ|akşam|gece)(leyin))/i
};
const $b50b609ba43abb6e$var$parseDayPeriodPatterns = {
    any: {
        am: /^ö\.?ö\.?/i,
        pm: /^ö\.?s\.?/i,
        midnight: /^(gy|gece yarısı)/i,
        noon: /^öğ/i,
        morning: /^sa/i,
        afternoon: /^öğleden sonra/i,
        evening: /^ak/i,
        night: /^ge/i
    }
};
const $b50b609ba43abb6e$var$match = $b50b609ba43abb6e$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $b50b609ba43abb6e$var$matchOrdinalNumberPattern,
        parsePattern: $b50b609ba43abb6e$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $b50b609ba43abb6e$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b50b609ba43abb6e$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $b50b609ba43abb6e$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b50b609ba43abb6e$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $b50b609ba43abb6e$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b50b609ba43abb6e$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $b50b609ba43abb6e$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b50b609ba43abb6e$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $b50b609ba43abb6e$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $b50b609ba43abb6e$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("3QtxD", function(module, exports) {

$parcel$export(module.exports, "ug", function () { return $2ccd24bbddc9b5ca$export$9ba1309004beb64a; }, function (v) { return $2ccd24bbddc9b5ca$export$9ba1309004beb64a = v; });
var $2ccd24bbddc9b5ca$export$9ba1309004beb64a;
"use strict";
$2ccd24bbddc9b5ca$export$9ba1309004beb64a = void 0;

var $3ZTDf = parcelRequire("3ZTDf");

var $4Obxb = parcelRequire("4Obxb");

var $dvcAH = parcelRequire("dvcAH");

var $dSlCo = parcelRequire("dSlCo");

var $62G8Z = parcelRequire("62G8Z");
/**
 * @category Locales
 * @summary Uighur locale
 * @language Uighur
 * @iso-639-2 uig
 * @author Abduwaly M. [@abduwaly](https://github.com/abduwaly)
 */ const $2ccd24bbddc9b5ca$var$ug = $2ccd24bbddc9b5ca$export$9ba1309004beb64a = {
    code: "ug",
    formatDistance: $3ZTDf.formatDistance,
    formatLong: $4Obxb.formatLong,
    formatRelative: $dvcAH.formatRelative,
    localize: $dSlCo.localize,
    match: $62G8Z.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("3ZTDf", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $2e9238f50e451351$export$2c14ff85d6318973; }, function (v) { return $2e9238f50e451351$export$2c14ff85d6318973 = v; });
var $2e9238f50e451351$export$2c14ff85d6318973;
"use strict";
$2e9238f50e451351$export$2c14ff85d6318973 = void 0;
const $2e9238f50e451351$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0628\u0649\u0631 \u0633\u0649\u0643\u06C7\u0646\u062A \u0626\u0649\u0686\u0649\u062F\u06D5",
        other: "\u0633\u0649\u0643\u06C7\u0646\u062A \u0626\u0649\u0686\u0649\u062F\u06D5 {{count}}"
    },
    xSeconds: {
        one: "\u0628\u0649\u0631 \u0633\u0649\u0643\u06C7\u0646\u062A",
        other: "\u0633\u0649\u0643\u06C7\u0646\u062A {{count}}"
    },
    halfAMinute: "\u064A\u0649\u0631\u0649\u0645 \u0645\u0649\u0646\u06C7\u062A",
    lessThanXMinutes: {
        one: "\u0628\u0649\u0631 \u0645\u0649\u0646\u06C7\u062A \u0626\u0649\u0686\u0649\u062F\u06D5",
        other: "\u0645\u0649\u0646\u06C7\u062A \u0626\u0649\u0686\u0649\u062F\u06D5 {{count}}"
    },
    xMinutes: {
        one: "\u0628\u0649\u0631 \u0645\u0649\u0646\u06C7\u062A",
        other: "\u0645\u0649\u0646\u06C7\u062A {{count}}"
    },
    aboutXHours: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u0633\u0627\u0626\u06D5\u062A",
        other: "\u0633\u0627\u0626\u06D5\u062A {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xHours: {
        one: "\u0628\u0649\u0631 \u0633\u0627\u0626\u06D5\u062A",
        other: "\u0633\u0627\u0626\u06D5\u062A {{count}}"
    },
    xDays: {
        one: "\u0628\u0649\u0631 \u0643\u06C8\u0646",
        other: "\u0643\u06C8\u0646 {{count}}"
    },
    aboutXWeeks: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631\u06BE\u06D5\u067E\u062A\u06D5",
        other: "\u06BE\u06D5\u067E\u062A\u06D5 {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xWeeks: {
        one: "\u0628\u0649\u0631\u06BE\u06D5\u067E\u062A\u06D5",
        other: "\u06BE\u06D5\u067E\u062A\u06D5 {{count}}"
    },
    aboutXMonths: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u0626\u0627\u064A",
        other: "\u0626\u0627\u064A {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xMonths: {
        one: "\u0628\u0649\u0631 \u0626\u0627\u064A",
        other: "\u0626\u0627\u064A {{count}}"
    },
    aboutXYears: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u064A\u0649\u0644",
        other: "\u064A\u0649\u0644 {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xYears: {
        one: "\u0628\u0649\u0631 \u064A\u0649\u0644",
        other: "\u064A\u0649\u0644 {{count}}"
    },
    overXYears: {
        one: "\u0628\u0649\u0631 \u064A\u0649\u0644\u062F\u0649\u0646 \u0626\u0627\u0631\u062A\u06C7\u0642",
        other: "\u064A\u0649\u0644\u062F\u0649\u0646 \u0626\u0627\u0631\u062A\u06C7\u0642 {{count}}"
    },
    almostXYears: {
        one: "\u0626\u0627\u0633\u0627\u0633\u06D5\u0646 \u0628\u0649\u0631 \u064A\u0649\u0644",
        other: "\u064A\u0649\u0644 {{count}} \u0626\u0627\u0633\u0627\u0633\u06D5\u0646"
    }
};
const $2e9238f50e451351$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $2e9238f50e451351$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result;
        else return result + " \u0628\u0648\u0644\u062F\u0649";
    }
    return result;
};
$2e9238f50e451351$export$2c14ff85d6318973 = $2e9238f50e451351$var$formatDistance;

});

parcelRegister("4Obxb", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $3804c75dadf6c13c$export$cbf60ecb96cbb82f; }, function (v) { return $3804c75dadf6c13c$export$cbf60ecb96cbb82f = v; });
var $3804c75dadf6c13c$export$cbf60ecb96cbb82f;
"use strict";
$3804c75dadf6c13c$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $3804c75dadf6c13c$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $3804c75dadf6c13c$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $3804c75dadf6c13c$var$dateTimeFormats = {
    full: "{{date}} '\u062F\u06D5' {{time}}",
    long: "{{date}} '\u062F\u06D5' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $3804c75dadf6c13c$var$formatLong = $3804c75dadf6c13c$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $3804c75dadf6c13c$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $3804c75dadf6c13c$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $3804c75dadf6c13c$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("dvcAH", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $9d47efe26f411eb2$export$8fbbfd65594f46a0; }, function (v) { return $9d47efe26f411eb2$export$8fbbfd65594f46a0 = v; });
var $9d47efe26f411eb2$export$8fbbfd65594f46a0;
"use strict";
$9d47efe26f411eb2$export$8fbbfd65594f46a0 = void 0;
const $9d47efe26f411eb2$var$formatRelativeLocale = {
    lastWeek: "'\u0626\u200D\u06C6\u062A\u0643\u06D5\u0646' eeee '\u062F\u06D5' p",
    yesterday: "'\u062A\u06C8\u0646\u06C8\u06AF\u06C8\u0646 \u062F\u06D5' p",
    today: "'\u0628\u06C8\u06AF\u06C8\u0646 \u062F\u06D5' p",
    tomorrow: "'\u0626\u06D5\u062A\u06D5 \u062F\u06D5' p",
    nextWeek: "eeee '\u062F\u06D5' p",
    other: "P"
};
const $9d47efe26f411eb2$var$formatRelative = (token, _date, _baseDate, _options)=>$9d47efe26f411eb2$var$formatRelativeLocale[token];
$9d47efe26f411eb2$export$8fbbfd65594f46a0 = $9d47efe26f411eb2$var$formatRelative;

});

parcelRegister("dSlCo", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $a1a1166cf6998b63$export$b3bd0bc58e36cd63; }, function (v) { return $a1a1166cf6998b63$export$b3bd0bc58e36cd63 = v; });
var $a1a1166cf6998b63$export$b3bd0bc58e36cd63;
"use strict";
$a1a1166cf6998b63$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $a1a1166cf6998b63$var$eraValues = {
    narrow: [
        "\u0628",
        "\u0643"
    ],
    abbreviated: [
        "\u0628",
        "\u0643"
    ],
    wide: [
        "\u0645\u0649\u064A\u0644\u0627\u062F\u0649\u062F\u0649\u0646 \u0628\u06C7\u0631\u06C7\u0646",
        "\u0645\u0649\u064A\u0644\u0627\u062F\u0649\u062F\u0649\u0646 \u0643\u0649\u064A\u0649\u0646"
    ]
};
const $a1a1166cf6998b63$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1",
        "2",
        "3",
        "4"
    ],
    wide: [
        "\u0628\u0649\u0631\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643",
        "\u0626\u0649\u0643\u0643\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643",
        "\u0626\u06C8\u0686\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643",
        "\u062A\u06C6\u062A\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $a1a1166cf6998b63$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0627",
        "\u0645",
        "\u0649",
        "\u0649",
        "\u0627",
        "\u0633",
        "\u06C6",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0627\u0646\u06CB\u0627\u0631",
        "\u0641\u06D0\u06CB\u0649\u0631\u0627\u0644",
        "\u0645\u0627\u0631\u062A",
        "\u0626\u0627\u067E\u0631\u0649\u0644",
        "\u0645\u0627\u064A",
        "\u0626\u0649\u064A\u06C7\u0646",
        "\u0626\u0649\u064A\u0648\u0644",
        "\u0626\u0627\u06CB\u063A\u06C7\u0633\u062A",
        "\u0633\u0649\u0646\u062A\u06D5\u0628\u0649\u0631",
        "\u0626\u06C6\u0643\u062A\u06D5\u0628\u0649\u0631",
        "\u0646\u0648\u064A\u0627\u0628\u0649\u0631",
        "\u062F\u0649\u0643\u0627\u0628\u0649\u0631"
    ],
    wide: [
        "\u064A\u0627\u0646\u06CB\u0627\u0631",
        "\u0641\u06D0\u06CB\u0649\u0631\u0627\u0644",
        "\u0645\u0627\u0631\u062A",
        "\u0626\u0627\u067E\u0631\u0649\u0644",
        "\u0645\u0627\u064A",
        "\u0626\u0649\u064A\u06C7\u0646",
        "\u0626\u0649\u064A\u0648\u0644",
        "\u0626\u0627\u06CB\u063A\u06C7\u0633\u062A",
        "\u0633\u0649\u0646\u062A\u06D5\u0628\u0649\u0631",
        "\u0626\u06C6\u0643\u062A\u06D5\u0628\u0649\u0631",
        "\u0646\u0648\u064A\u0627\u0628\u0649\u0631",
        "\u062F\u0649\u0643\u0627\u0628\u0649\u0631"
    ]
};
const $a1a1166cf6998b63$var$dayValues = {
    narrow: [
        "\u064A",
        "\u062F",
        "\u0633",
        "\u0686",
        "\u067E",
        "\u062C",
        "\u0634"
    ],
    short: [
        "\u064A",
        "\u062F",
        "\u0633",
        "\u0686",
        "\u067E",
        "\u062C",
        "\u0634"
    ],
    abbreviated: [
        "\u064A\u06D5\u0643\u0634\u06D5\u0646\u0628\u06D5",
        "\u062F\u06C8\u0634\u06D5\u0646\u0628\u06D5",
        "\u0633\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u0686\u0627\u0631\u0634\u06D5\u0646\u0628\u06D5",
        "\u067E\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u062C\u06C8\u0645\u06D5",
        "\u0634\u06D5\u0646\u0628\u06D5"
    ],
    wide: [
        "\u064A\u06D5\u0643\u0634\u06D5\u0646\u0628\u06D5",
        "\u062F\u06C8\u0634\u06D5\u0646\u0628\u06D5",
        "\u0633\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u0686\u0627\u0631\u0634\u06D5\u0646\u0628\u06D5",
        "\u067E\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u062C\u06C8\u0645\u06D5",
        "\u0634\u06D5\u0646\u0628\u06D5"
    ]
};
const $a1a1166cf6998b63$var$dayPeriodValues = {
    narrow: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0649\u0645",
        night: "\u0643\u0649\u0686\u06D5"
    },
    abbreviated: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0649\u0645",
        night: "\u0643\u0649\u0686\u06D5"
    },
    wide: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0649\u0645",
        night: "\u0643\u0649\u0686\u06D5"
    }
};
const $a1a1166cf6998b63$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
        night: "\u0643\u0649\u0686\u0649\u062F\u06D5"
    },
    abbreviated: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
        night: "\u0643\u0649\u0686\u0649\u062F\u06D5"
    },
    wide: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
        night: "\u0643\u0649\u0686\u0649\u062F\u06D5"
    }
};
const $a1a1166cf6998b63$var$ordinalNumber = (dirtyNumber, _options)=>{
    return String(dirtyNumber);
};
const $a1a1166cf6998b63$var$localize = $a1a1166cf6998b63$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $a1a1166cf6998b63$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $a1a1166cf6998b63$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $a1a1166cf6998b63$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $a1a1166cf6998b63$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $a1a1166cf6998b63$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $a1a1166cf6998b63$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $a1a1166cf6998b63$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("62G8Z", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $46639ee4cec005da$export$4659b591c19bdf3d; }, function (v) { return $46639ee4cec005da$export$4659b591c19bdf3d = v; });
var $46639ee4cec005da$export$4659b591c19bdf3d;
"use strict";
$46639ee4cec005da$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $46639ee4cec005da$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $46639ee4cec005da$var$parseOrdinalNumberPattern = /\d+/i;
const $46639ee4cec005da$var$matchEraPatterns = {
    narrow: /^(ب|ك)/i,
    wide: /^(مىيلادىدىن بۇرۇن|مىيلادىدىن كىيىن)/i
};
const $46639ee4cec005da$var$parseEraPatterns = {
    any: [
        /^بۇرۇن/i,
        /^كىيىن/i
    ]
};
const $46639ee4cec005da$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^چ[1234]/i,
    wide: /^چارەك [1234]/i
};
const $46639ee4cec005da$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $46639ee4cec005da$var$matchMonthPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[يفمئامئ‍ئاسۆند]/i,
    abbreviated: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i,
    wide: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i
};
const $46639ee4cec005da$var$parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^ا/i,
        /^م/i,
        /^ى‍/i,
        /^ى‍/i,
        /^ا‍/i,
        /^س/i,
        /^ۆ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^يان/i,
        /^فېۋ/i,
        /^مار/i,
        /^ئاپ/i,
        /^ماي/i,
        /^ئىيۇن/i,
        /^ئىيول/i,
        /^ئاۋ/i,
        /^سىن/i,
        /^ئۆك/i,
        /^نوي/i,
        /^دىك/i
    ]
};
const $46639ee4cec005da$var$matchDayPatterns = {
    narrow: /^[دسچپجشي]/i,
    short: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
    abbreviated: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
    wide: /^(يەكشەنبە|دۈشەنبە|سەيشەنبە|چارشەنبە|پەيشەنبە|جۈمە|شەنبە)/i
};
const $46639ee4cec005da$var$parseDayPatterns = {
    narrow: [
        /^ي/i,
        /^د/i,
        /^س/i,
        /^چ/i,
        /^پ/i,
        /^ج/i,
        /^ش/i
    ],
    any: [
        /^ي/i,
        /^د/i,
        /^س/i,
        /^چ/i,
        /^پ/i,
        /^ج/i,
        /^ش/i
    ]
};
const $46639ee4cec005da$var$matchDayPeriodPatterns = {
    narrow: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i,
    any: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i
};
const $46639ee4cec005da$var$parseDayPeriodPatterns = {
    any: {
        am: /^ئە/i,
        pm: /^چ/i,
        midnight: /^ك/i,
        noon: /^چ/i,
        morning: /ئەتىگەن/i,
        afternoon: /چۈشتىن كىيىن/i,
        evening: /ئاخشىم/i,
        night: /كىچە/i
    }
};
const $46639ee4cec005da$var$match = $46639ee4cec005da$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $46639ee4cec005da$var$matchOrdinalNumberPattern,
        parsePattern: $46639ee4cec005da$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $46639ee4cec005da$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $46639ee4cec005da$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $46639ee4cec005da$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $46639ee4cec005da$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $46639ee4cec005da$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $46639ee4cec005da$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $46639ee4cec005da$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $46639ee4cec005da$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $46639ee4cec005da$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $46639ee4cec005da$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("3zsoC", function(module, exports) {

$parcel$export(module.exports, "uk", function () { return $299aaad4b0e088b6$export$312745a8a3013c00; }, function (v) { return $299aaad4b0e088b6$export$312745a8a3013c00 = v; });
var $299aaad4b0e088b6$export$312745a8a3013c00;
"use strict";
$299aaad4b0e088b6$export$312745a8a3013c00 = void 0;

var $bKMvM = parcelRequire("bKMvM");

var $k6cOx = parcelRequire("k6cOx");

var $jWsBC = parcelRequire("jWsBC");

var $2j3P4 = parcelRequire("2j3P4");

var $gN3h8 = parcelRequire("gN3h8");
/**
 * @category Locales
 * @summary Ukrainian locale.
 * @language Ukrainian
 * @iso-639-2 ukr
 * @author Andrii Korzh [@korzhyk](https://github.com/korzhyk)
 * @author Andriy Shcherbyak [@shcherbyakdev](https://github.com/shcherbyakdev)
 */ const $299aaad4b0e088b6$var$uk = $299aaad4b0e088b6$export$312745a8a3013c00 = {
    code: "uk",
    formatDistance: $bKMvM.formatDistance,
    formatLong: $k6cOx.formatLong,
    formatRelative: $jWsBC.formatRelative,
    localize: $2j3P4.localize,
    match: $gN3h8.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("bKMvM", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $88e99ef84913377f$export$2c14ff85d6318973; }, function (v) { return $88e99ef84913377f$export$2c14ff85d6318973 = v; });
var $88e99ef84913377f$export$2c14ff85d6318973;
"use strict";
$88e99ef84913377f$export$2c14ff85d6318973 = void 0;
function $88e99ef84913377f$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    const rem10 = count % 10;
    const rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace("{{count}}", String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace("{{count}}", String(count));
    else return scheme.pluralGenitive.replace("{{count}}", String(count));
}
function $88e99ef84913377f$var$buildLocalizeTokenFn(scheme) {
    return (count, options)=>{
        if (options && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $88e99ef84913377f$var$declension(scheme.future, count);
                else return "\u0437\u0430 " + $88e99ef84913377f$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $88e99ef84913377f$var$declension(scheme.past, count);
                else return $88e99ef84913377f$var$declension(scheme.regular, count) + " \u0442\u043E\u043C\u0443";
            }
        } else return $88e99ef84913377f$var$declension(scheme.regular, count);
    };
}
const $88e99ef84913377f$var$halfAtMinute = (_, options)=>{
    if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0437\u0430 \u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438";
        else return "\u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438 \u0442\u043E\u043C\u0443";
    }
    return "\u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438";
};
const $88e99ef84913377f$var$formatDistanceLocale = {
    lessThanXSeconds: $88e99ef84913377f$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448\u0435 \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: $88e99ef84913377f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u043E\u043C\u0443",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438 \u0442\u043E\u043C\u0443",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u043E\u043C\u0443"
        },
        future: {
            singularNominative: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: $88e99ef84913377f$var$halfAtMinute,
    lessThanXMinutes: $88e99ef84913377f$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448\u0435 \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        }
    }),
    xMinutes: $88e99ef84913377f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0430",
            singularGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443 \u0442\u043E\u043C\u0443",
            singularGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438 \u0442\u043E\u043C\u0443",
            pluralGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D \u0442\u043E\u043C\u0443"
        },
        future: {
            singularNominative: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularGenitive: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        }
    }),
    aboutXHours: $88e99ef84913377f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D"
        }
    }),
    xHours: $88e99ef84913377f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0443",
            singularGenitive: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            pluralGenitive: "{{count}} \u0433\u043E\u0434\u0438\u043D"
        }
    }),
    xDays: $88e99ef84913377f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043Di",
            pluralGenitive: "{{count}} \u0434\u043D\u0456\u0432"
        }
    }),
    aboutXWeeks: $88e99ef84913377f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u044F",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u043D\u0456",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        }
    }),
    xWeeks: $88e99ef84913377f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0442\u0438\u0436\u043D\u0456",
            pluralGenitive: "{{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        }
    }),
    aboutXMonths: $88e99ef84913377f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u044F",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u044C",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u0456",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        }
    }),
    xMonths: $88e99ef84913377f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0456\u0441\u044F\u0446\u044C",
            singularGenitive: "{{count}} \u043C\u0456\u0441\u044F\u0446\u0456",
            pluralGenitive: "{{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        }
    }),
    aboutXYears: $88e99ef84913377f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0443",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    }),
    xYears: $88e99ef84913377f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0440\u0456\u043A",
            singularGenitive: "{{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "{{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    }),
    overXYears: $88e99ef84913377f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0443",
            singularGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432",
            pluralGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
            singularNominative: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    }),
    almostXYears: $88e99ef84913377f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
            singularNominative: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    })
};
const $88e99ef84913377f$var$formatDistance = (token, count, options)=>{
    options = options || {};
    return $88e99ef84913377f$var$formatDistanceLocale[token](count, options);
};
$88e99ef84913377f$export$2c14ff85d6318973 = $88e99ef84913377f$var$formatDistance;

});

parcelRegister("k6cOx", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $ea1e4ec9fc7f4f05$export$cbf60ecb96cbb82f; }, function (v) { return $ea1e4ec9fc7f4f05$export$cbf60ecb96cbb82f = v; });
var $ea1e4ec9fc7f4f05$export$cbf60ecb96cbb82f;
"use strict";
$ea1e4ec9fc7f4f05$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $ea1e4ec9fc7f4f05$var$dateFormats = {
    full: "EEEE, do MMMM y '\u0440.'",
    long: "do MMMM y '\u0440.'",
    medium: "d MMM y '\u0440.'",
    short: "dd.MM.y"
};
const $ea1e4ec9fc7f4f05$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $ea1e4ec9fc7f4f05$var$dateTimeFormats = {
    full: "{{date}} '\u043E' {{time}}",
    long: "{{date}} '\u043E' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $ea1e4ec9fc7f4f05$var$formatLong = $ea1e4ec9fc7f4f05$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $ea1e4ec9fc7f4f05$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $ea1e4ec9fc7f4f05$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $ea1e4ec9fc7f4f05$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("jWsBC", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $e8499f9bf15474de$export$8fbbfd65594f46a0; }, function (v) { return $e8499f9bf15474de$export$8fbbfd65594f46a0 = v; });
var $e8499f9bf15474de$export$8fbbfd65594f46a0;
"use strict";
$e8499f9bf15474de$export$8fbbfd65594f46a0 = void 0;

var $9VRW1 = parcelRequire("9VRW1");

var $eimnm = parcelRequire("eimnm");
const $e8499f9bf15474de$var$accusativeWeekdays = [
    "\u043D\u0435\u0434\u0456\u043B\u044E",
    "\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A",
    "\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A",
    "\u0441\u0435\u0440\u0435\u0434\u0443",
    "\u0447\u0435\u0442\u0432\u0435\u0440",
    "\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044E",
    "\u0441\u0443\u0431\u043E\u0442\u0443"
];
function $e8499f9bf15474de$var$lastWeek(day) {
    const weekday = $e8499f9bf15474de$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043C\u0438\u043D\u0443\u043B\u0443 " + weekday + " \u043E' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043C\u0438\u043D\u0443\u043B\u0438\u0439 " + weekday + " \u043E' p";
    }
}
function $e8499f9bf15474de$var$thisWeek(day) {
    const weekday = $e8499f9bf15474de$var$accusativeWeekdays[day];
    return "'\u0443 " + weekday + " \u043E' p";
}
function $e8499f9bf15474de$var$nextWeek(day) {
    const weekday = $e8499f9bf15474de$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443 " + weekday + " \u043E' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439 " + weekday + " \u043E' p";
    }
}
const $e8499f9bf15474de$var$lastWeekFormat = (dirtyDate, baseDate, options)=>{
    const date = (0, $eimnm.toDate)(dirtyDate);
    const day = date.getDay();
    if ((0, $9VRW1.isSameWeek)(date, baseDate, options)) return $e8499f9bf15474de$var$thisWeek(day);
    else return $e8499f9bf15474de$var$lastWeek(day);
};
const $e8499f9bf15474de$var$nextWeekFormat = (dirtyDate, baseDate, options)=>{
    const date = (0, $eimnm.toDate)(dirtyDate);
    const day = date.getDay();
    if ((0, $9VRW1.isSameWeek)(date, baseDate, options)) return $e8499f9bf15474de$var$thisWeek(day);
    else return $e8499f9bf15474de$var$nextWeek(day);
};
const $e8499f9bf15474de$var$formatRelativeLocale = {
    lastWeek: $e8499f9bf15474de$var$lastWeekFormat,
    yesterday: "'\u0432\u0447\u043E\u0440\u0430 \u043E' p",
    today: "'\u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456 \u043E' p",
    tomorrow: "'\u0437\u0430\u0432\u0442\u0440\u0430 \u043E' p",
    nextWeek: $e8499f9bf15474de$var$nextWeekFormat,
    other: "P"
};
const $e8499f9bf15474de$var$formatRelative = (token, date, baseDate, options)=>{
    const format = $e8499f9bf15474de$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
$e8499f9bf15474de$export$8fbbfd65594f46a0 = $e8499f9bf15474de$var$formatRelative;

});

parcelRegister("2j3P4", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $1ae0523b5444d75d$export$b3bd0bc58e36cd63; }, function (v) { return $1ae0523b5444d75d$export$b3bd0bc58e36cd63 = v; });
var $1ae0523b5444d75d$export$b3bd0bc58e36cd63;
"use strict";
$1ae0523b5444d75d$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $1ae0523b5444d75d$var$eraValues = {
    narrow: [
        "\u0434\u043E \u043D.\u0435.",
        "\u043D.\u0435."
    ],
    abbreviated: [
        "\u0434\u043E \u043D. \u0435.",
        "\u043D. \u0435."
    ],
    wide: [
        "\u0434\u043E \u043D\u0430\u0448\u043E\u0457 \u0435\u0440\u0438",
        "\u043D\u0430\u0448\u043E\u0457 \u0435\u0440\u0438"
    ]
};
const $1ae0523b5444d75d$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-\u0439 \u043A\u0432.",
        "2-\u0439 \u043A\u0432.",
        "3-\u0439 \u043A\u0432.",
        "4-\u0439 \u043A\u0432."
    ],
    wide: [
        "1-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
const $1ae0523b5444d75d$var$monthValues = {
    // ДСТУ 3582:2013
    narrow: [
        "\u0421",
        "\u041B",
        "\u0411",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0421",
        "\u0412",
        "\u0416",
        "\u041B",
        "\u0413"
    ],
    abbreviated: [
        "\u0441\u0456\u0447.",
        "\u043B\u044E\u0442.",
        "\u0431\u0435\u0440\u0435\u0437.",
        "\u043A\u0432\u0456\u0442.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u0435\u0440\u0432.",
        "\u043B\u0438\u043F.",
        "\u0441\u0435\u0440\u043F.",
        "\u0432\u0435\u0440\u0435\u0441.",
        "\u0436\u043E\u0432\u0442.",
        "\u043B\u0438\u0441\u0442\u043E\u043F.",
        "\u0433\u0440\u0443\u0434."
    ],
    wide: [
        "\u0441\u0456\u0447\u0435\u043D\u044C",
        "\u043B\u044E\u0442\u0438\u0439",
        "\u0431\u0435\u0440\u0435\u0437\u0435\u043D\u044C",
        "\u043A\u0432\u0456\u0442\u0435\u043D\u044C",
        "\u0442\u0440\u0430\u0432\u0435\u043D\u044C",
        "\u0447\u0435\u0440\u0432\u0435\u043D\u044C",
        "\u043B\u0438\u043F\u0435\u043D\u044C",
        "\u0441\u0435\u0440\u043F\u0435\u043D\u044C",
        "\u0432\u0435\u0440\u0435\u0441\u0435\u043D\u044C",
        "\u0436\u043E\u0432\u0442\u0435\u043D\u044C",
        "\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434",
        "\u0433\u0440\u0443\u0434\u0435\u043D\u044C"
    ]
};
const $1ae0523b5444d75d$var$formattingMonthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0411",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0421",
        "\u0412",
        "\u0416",
        "\u041B",
        "\u0413"
    ],
    abbreviated: [
        "\u0441\u0456\u0447.",
        "\u043B\u044E\u0442.",
        "\u0431\u0435\u0440\u0435\u0437.",
        "\u043A\u0432\u0456\u0442.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u0435\u0440\u0432.",
        "\u043B\u0438\u043F.",
        "\u0441\u0435\u0440\u043F.",
        "\u0432\u0435\u0440\u0435\u0441.",
        "\u0436\u043E\u0432\u0442.",
        "\u043B\u0438\u0441\u0442\u043E\u043F.",
        "\u0433\u0440\u0443\u0434."
    ],
    wide: [
        "\u0441\u0456\u0447\u043D\u044F",
        "\u043B\u044E\u0442\u043E\u0433\u043E",
        "\u0431\u0435\u0440\u0435\u0437\u043D\u044F",
        "\u043A\u0432\u0456\u0442\u043D\u044F",
        "\u0442\u0440\u0430\u0432\u043D\u044F",
        "\u0447\u0435\u0440\u0432\u043D\u044F",
        "\u043B\u0438\u043F\u043D\u044F",
        "\u0441\u0435\u0440\u043F\u043D\u044F",
        "\u0432\u0435\u0440\u0435\u0441\u043D\u044F",
        "\u0436\u043E\u0432\u0442\u043D\u044F",
        "\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434\u0430",
        "\u0433\u0440\u0443\u0434\u043D\u044F"
    ]
};
const $1ae0523b5444d75d$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0432\u0456\u0432",
        "\u0441\u0435\u0440",
        "\u0447\u0442\u0432",
        "\u043F\u0442\u043D",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0456\u043B\u044F",
        "\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A",
        "\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A",
        "\u0441\u0435\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0435\u0440",
        "\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044F",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
const $1ae0523b5444d75d$var$dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u0456\u0447"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u0456\u0447"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D\u0456\u0447",
        noon: "\u043F\u043E\u043B\u0443\u0434\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0456\u0440",
        night: "\u043D\u0456\u0447"
    }
};
const $1ae0523b5444d75d$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D\u0456\u0447",
        noon: "\u043F\u043E\u043B\u0443\u0434\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
    }
};
const $1ae0523b5444d75d$var$ordinalNumber = (dirtyNumber, options)=>{
    const unit = String(options?.unit);
    const number = Number(dirtyNumber);
    let suffix;
    if (unit === "date") {
        if (number === 3 || number === 23) suffix = "-\u0454";
        else suffix = "-\u0435";
    } else if (unit === "minute" || unit === "second" || unit === "hour") suffix = "-\u0430";
    else suffix = "-\u0439";
    return number + suffix;
};
const $1ae0523b5444d75d$var$localize = $1ae0523b5444d75d$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $1ae0523b5444d75d$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $1ae0523b5444d75d$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $1ae0523b5444d75d$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $1ae0523b5444d75d$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $1ae0523b5444d75d$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $1ae0523b5444d75d$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $1ae0523b5444d75d$var$dayPeriodValues,
        defaultWidth: "any",
        formattingValues: $1ae0523b5444d75d$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("gN3h8", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $c393c35aecf235ec$export$4659b591c19bdf3d; }, function (v) { return $c393c35aecf235ec$export$4659b591c19bdf3d = v; });
var $c393c35aecf235ec$export$4659b591c19bdf3d;
"use strict";
$c393c35aecf235ec$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $c393c35aecf235ec$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|й|є|а|я))?/i;
const $c393c35aecf235ec$var$parseOrdinalNumberPattern = /\d+/i;
const $c393c35aecf235ec$var$matchEraPatterns = {
    narrow: /^((до )?н\.?\s?е\.?)/i,
    abbreviated: /^((до )?н\.?\s?е\.?)/i,
    wide: /^(до нашої ери|нашої ери|наша ера)/i
};
const $c393c35aecf235ec$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
const $c393c35aecf235ec$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[иі]?й?)? кв.?/i,
    wide: /^[1234](-?[иі]?й?)? квартал/i
};
const $c393c35aecf235ec$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $c393c35aecf235ec$var$matchMonthPatterns = {
    narrow: /^[слбктчвжг]/i,
    abbreviated: /^(січ|лют|бер(ез)?|квіт|трав|черв|лип|серп|вер(ес)?|жовт|лис(топ)?|груд)\.?/i,
    wide: /^(січень|січня|лютий|лютого|березень|березня|квітень|квітня|травень|травня|червня|червень|липень|липня|серпень|серпня|вересень|вересня|жовтень|жовтня|листопад[а]?|грудень|грудня)/i
};
const $c393c35aecf235ec$var$parseMonthPatterns = {
    narrow: [
        /^с/i,
        /^л/i,
        /^б/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^л/i,
        /^с/i,
        /^в/i,
        /^ж/i,
        /^л/i,
        /^г/i
    ],
    any: [
        /^сі/i,
        /^лю/i,
        /^б/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^лип/i,
        /^се/i,
        /^в/i,
        /^ж/i,
        /^лис/i,
        /^г/i
    ]
};
const $c393c35aecf235ec$var$matchDayPatterns = {
    narrow: /^[нпвсч]/i,
    short: /^(нд|пн|вт|ср|чт|пт|сб)\.?/i,
    abbreviated: /^(нед|пон|вів|сер|че?тв|птн?|суб)\.?/i,
    wide: /^(неділ[яі]|понеділ[ок][ка]|вівтор[ок][ка]|серед[аи]|четвер(га)?|п\W*?ятниц[яі]|субот[аи])/i
};
const $c393c35aecf235ec$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н/i,
        /^п[он]/i,
        /^в/i,
        /^с[ер]/i,
        /^ч/i,
        /^п\W*?[ят]/i,
        /^с[уб]/i
    ]
};
const $c393c35aecf235ec$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
    abbreviated: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
    wide: /^([дп]п|північ|полудень|ранок|ранку|день|дня|вечір|вечора|ніч|ночі)/i
};
const $c393c35aecf235ec$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^півн/i,
        noon: /^пол/i,
        morning: /^р/i,
        afternoon: /^д[ен]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
const $c393c35aecf235ec$var$match = $c393c35aecf235ec$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $c393c35aecf235ec$var$matchOrdinalNumberPattern,
        parsePattern: $c393c35aecf235ec$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $c393c35aecf235ec$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c393c35aecf235ec$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $c393c35aecf235ec$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c393c35aecf235ec$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $c393c35aecf235ec$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c393c35aecf235ec$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $c393c35aecf235ec$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c393c35aecf235ec$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $c393c35aecf235ec$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c393c35aecf235ec$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("8bQsB", function(module, exports) {

$parcel$export(module.exports, "uz", function () { return $5f680b5309f49805$export$461e3962c82dff4f; }, function (v) { return $5f680b5309f49805$export$461e3962c82dff4f = v; });
var $5f680b5309f49805$export$461e3962c82dff4f;
"use strict";
$5f680b5309f49805$export$461e3962c82dff4f = void 0;

var $79UN6 = parcelRequire("79UN6");

var $gGaJ5 = parcelRequire("gGaJ5");

var $glo0L = parcelRequire("glo0L");

var $2Xme0 = parcelRequire("2Xme0");

var $k7uhP = parcelRequire("k7uhP");
/**
 * @category Locales
 * @summary Uzbek locale.
 * @language Uzbek
 * @iso-639-2 uzb
 * @author Mukhammadali [@mukhammadali](https://github.com/Mukhammadali)
 */ const $5f680b5309f49805$var$uz = $5f680b5309f49805$export$461e3962c82dff4f = {
    code: "uz",
    formatDistance: $79UN6.formatDistance,
    formatLong: $gGaJ5.formatLong,
    formatRelative: $glo0L.formatRelative,
    localize: $2Xme0.localize,
    match: $k7uhP.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("79UN6", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $53656d25b3d39d66$export$2c14ff85d6318973; }, function (v) { return $53656d25b3d39d66$export$2c14ff85d6318973 = v; });
var $53656d25b3d39d66$export$2c14ff85d6318973;
"use strict";
$53656d25b3d39d66$export$2c14ff85d6318973 = void 0;
const $53656d25b3d39d66$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "sekunddan kam",
        other: "{{count}} sekunddan kam"
    },
    xSeconds: {
        one: "1 sekund",
        other: "{{count}} sekund"
    },
    halfAMinute: "yarim minut",
    lessThanXMinutes: {
        one: "bir minutdan kam",
        other: "{{count}} minutdan kam"
    },
    xMinutes: {
        one: "1 minut",
        other: "{{count}} minut"
    },
    aboutXHours: {
        one: "tahminan 1 soat",
        other: "tahminan {{count}} soat"
    },
    xHours: {
        one: "1 soat",
        other: "{{count}} soat"
    },
    xDays: {
        one: "1 kun",
        other: "{{count}} kun"
    },
    aboutXWeeks: {
        one: "tahminan 1 hafta",
        other: "tahminan {{count}} hafta"
    },
    xWeeks: {
        one: "1 hafta",
        other: "{{count}} hafta"
    },
    aboutXMonths: {
        one: "tahminan 1 oy",
        other: "tahminan {{count}} oy"
    },
    xMonths: {
        one: "1 oy",
        other: "{{count}} oy"
    },
    aboutXYears: {
        one: "tahminan 1 yil",
        other: "tahminan {{count}} yil"
    },
    xYears: {
        one: "1 yil",
        other: "{{count}} yil"
    },
    overXYears: {
        one: "1 yildan ko'p",
        other: "{{count}} yildan ko'p"
    },
    almostXYears: {
        one: "deyarli 1 yil",
        other: "deyarli {{count}} yil"
    }
};
const $53656d25b3d39d66$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $53656d25b3d39d66$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " dan keyin";
        else return result + " oldin";
    }
    return result;
};
$53656d25b3d39d66$export$2c14ff85d6318973 = $53656d25b3d39d66$var$formatDistance;

});

parcelRegister("gGaJ5", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $c248e396094a9fa6$export$cbf60ecb96cbb82f; }, function (v) { return $c248e396094a9fa6$export$cbf60ecb96cbb82f = v; });
var $c248e396094a9fa6$export$cbf60ecb96cbb82f;
"use strict";
$c248e396094a9fa6$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $c248e396094a9fa6$var$dateFormats = {
    full: "EEEE, do MMMM, y",
    long: "do MMMM, y",
    medium: "d MMM, y",
    short: "dd/MM/yyyy"
};
const $c248e396094a9fa6$var$timeFormats = {
    full: "h:mm:ss zzzz",
    long: "h:mm:ss z",
    medium: "h:mm:ss",
    short: "h:mm"
};
const $c248e396094a9fa6$var$dateTimeFormats = {
    any: "{{date}}, {{time}}"
};
const $c248e396094a9fa6$var$formatLong = $c248e396094a9fa6$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $c248e396094a9fa6$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $c248e396094a9fa6$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $c248e396094a9fa6$var$dateTimeFormats,
        defaultWidth: "any"
    })
};

});

parcelRegister("glo0L", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $be613ba2567be3a7$export$8fbbfd65594f46a0; }, function (v) { return $be613ba2567be3a7$export$8fbbfd65594f46a0 = v; });
var $be613ba2567be3a7$export$8fbbfd65594f46a0;
"use strict";
$be613ba2567be3a7$export$8fbbfd65594f46a0 = void 0;
const $be613ba2567be3a7$var$formatRelativeLocale = {
    lastWeek: "'oldingi' eeee p 'da'",
    yesterday: "'kecha' p 'da'",
    today: "'bugun' p 'da'",
    tomorrow: "'ertaga' p 'da'",
    nextWeek: "eeee p 'da'",
    other: "P"
};
const $be613ba2567be3a7$var$formatRelative = (token, _date, _baseDate, _options)=>$be613ba2567be3a7$var$formatRelativeLocale[token];
$be613ba2567be3a7$export$8fbbfd65594f46a0 = $be613ba2567be3a7$var$formatRelative;

});

parcelRegister("2Xme0", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $227254e2051cc81c$export$b3bd0bc58e36cd63; }, function (v) { return $227254e2051cc81c$export$b3bd0bc58e36cd63 = v; });
var $227254e2051cc81c$export$b3bd0bc58e36cd63;
"use strict";
$227254e2051cc81c$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $227254e2051cc81c$var$eraValues = {
    narrow: [
        "M.A",
        "M."
    ],
    abbreviated: [
        "M.A",
        "M."
    ],
    wide: [
        "Miloddan Avvalgi",
        "Milodiy"
    ]
};
const $227254e2051cc81c$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "CH.1",
        "CH.2",
        "CH.3",
        "CH.4"
    ],
    wide: [
        "1-chi chorak",
        "2-chi chorak",
        "3-chi chorak",
        "4-chi chorak"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $227254e2051cc81c$var$monthValues = {
    narrow: [
        "Y",
        "F",
        "M",
        "A",
        "M",
        "I",
        "I",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Yan",
        "Fev",
        "Mar",
        "Apr",
        "May",
        "Iyun",
        "Iyul",
        "Avg",
        "Sen",
        "Okt",
        "Noy",
        "Dek"
    ],
    wide: [
        "Yanvar",
        "Fevral",
        "Mart",
        "Aprel",
        "May",
        "Iyun",
        "Iyul",
        "Avgust",
        "Sentabr",
        "Oktabr",
        "Noyabr",
        "Dekabr"
    ]
};
const $227254e2051cc81c$var$dayValues = {
    narrow: [
        "Y",
        "D",
        "S",
        "CH",
        "P",
        "J",
        "SH"
    ],
    short: [
        "Ya",
        "Du",
        "Se",
        "Cho",
        "Pa",
        "Ju",
        "Sha"
    ],
    abbreviated: [
        "Yak",
        "Dush",
        "Sesh",
        "Chor",
        "Pay",
        "Jum",
        "Shan"
    ],
    wide: [
        "Yakshanba",
        "Dushanba",
        "Seshanba",
        "Chorshanba",
        "Payshanba",
        "Juma",
        "Shanba"
    ]
};
const $227254e2051cc81c$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "y.t",
        noon: "p.",
        morning: "ertalab",
        afternoon: "tushdan keyin",
        evening: "kechqurun",
        night: "tun"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "yarim tun",
        noon: "peshin",
        morning: "ertalab",
        afternoon: "tushdan keyin",
        evening: "kechqurun",
        night: "tun"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "yarim tun",
        noon: "peshin",
        morning: "ertalab",
        afternoon: "tushdan keyin",
        evening: "kechqurun",
        night: "tun"
    }
};
const $227254e2051cc81c$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "y.t",
        noon: "p.",
        morning: "ertalab",
        afternoon: "tushdan keyin",
        evening: "kechqurun",
        night: "tun"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "yarim tun",
        noon: "peshin",
        morning: "ertalab",
        afternoon: "tushdan keyin",
        evening: "kechqurun",
        night: "tun"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "yarim tun",
        noon: "peshin",
        morning: "ertalab",
        afternoon: "tushdan keyin",
        evening: "kechqurun",
        night: "tun"
    }
};
const $227254e2051cc81c$var$ordinalNumber = (dirtyNumber, _options)=>{
    return String(dirtyNumber);
};
const $227254e2051cc81c$var$localize = $227254e2051cc81c$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $227254e2051cc81c$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $227254e2051cc81c$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $227254e2051cc81c$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $227254e2051cc81c$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $227254e2051cc81c$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $227254e2051cc81c$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $227254e2051cc81c$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("k7uhP", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $ea5bf463db60db9b$export$4659b591c19bdf3d; }, function (v) { return $ea5bf463db60db9b$export$4659b591c19bdf3d = v; });
var $ea5bf463db60db9b$export$4659b591c19bdf3d;
"use strict";
$ea5bf463db60db9b$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $ea5bf463db60db9b$var$matchOrdinalNumberPattern = /^(\d+)(chi)?/i;
const $ea5bf463db60db9b$var$parseOrdinalNumberPattern = /\d+/i;
const $ea5bf463db60db9b$var$matchEraPatterns = {
    narrow: /^(m\.a|m\.)/i,
    abbreviated: /^(m\.a\.?\s?m\.?)/i,
    wide: /^(miloddan avval|miloddan keyin)/i
};
const $ea5bf463db60db9b$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $ea5bf463db60db9b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](chi)? chorak/i
};
const $ea5bf463db60db9b$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $ea5bf463db60db9b$var$matchMonthPatterns = {
    narrow: /^[yfmasond]/i,
    abbreviated: /^(yan|fev|mar|apr|may|iyun|iyul|avg|sen|okt|noy|dek)/i,
    wide: /^(yanvar|fevral|mart|aprel|may|iyun|iyul|avgust|sentabr|oktabr|noyabr|dekabr)/i
};
const $ea5bf463db60db9b$var$parseMonthPatterns = {
    narrow: [
        /^y/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^i/i,
        /^i/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ya/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^iyun/i,
        /^iyul/i,
        /^av/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $ea5bf463db60db9b$var$matchDayPatterns = {
    narrow: /^[ydschj]/i,
    short: /^(ya|du|se|cho|pa|ju|sha)/i,
    abbreviated: /^(yak|dush|sesh|chor|pay|jum|shan)/i,
    wide: /^(yakshanba|dushanba|seshanba|chorshanba|payshanba|juma|shanba)/i
};
const $ea5bf463db60db9b$var$parseDayPatterns = {
    narrow: [
        /^y/i,
        /^d/i,
        /^s/i,
        /^ch/i,
        /^p/i,
        /^j/i,
        /^sh/i
    ],
    any: [
        /^ya/i,
        /^d/i,
        /^se/i,
        /^ch/i,
        /^p/i,
        /^j/i,
        /^sh/i
    ]
};
const $ea5bf463db60db9b$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|y\.t|p| (ertalab|tushdan keyin|kechqurun|tun))/i,
    any: /^([ap]\.?\s?m\.?|yarim tun|peshin| (ertalab|tushdan keyin|kechqurun|tun))/i
};
const $ea5bf463db60db9b$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^y\.t/i,
        noon: /^pe/i,
        morning: /ertalab/i,
        afternoon: /tushdan keyin/i,
        evening: /kechqurun/i,
        night: /tun/i
    }
};
const $ea5bf463db60db9b$var$match = $ea5bf463db60db9b$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $ea5bf463db60db9b$var$matchOrdinalNumberPattern,
        parsePattern: $ea5bf463db60db9b$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $ea5bf463db60db9b$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ea5bf463db60db9b$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $ea5bf463db60db9b$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ea5bf463db60db9b$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $ea5bf463db60db9b$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ea5bf463db60db9b$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $ea5bf463db60db9b$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ea5bf463db60db9b$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $ea5bf463db60db9b$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $ea5bf463db60db9b$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("g4E2d", function(module, exports) {

$parcel$export(module.exports, "uzCyrl", function () { return $bb3c132680de61f1$export$fe32212c9efceff7; }, function (v) { return $bb3c132680de61f1$export$fe32212c9efceff7 = v; });
var $bb3c132680de61f1$export$fe32212c9efceff7;
"use strict";
$bb3c132680de61f1$export$fe32212c9efceff7 = void 0;

var $fFjZA = parcelRequire("fFjZA");

var $l1frn = parcelRequire("l1frn");

var $7arKP = parcelRequire("7arKP");

var $21n68 = parcelRequire("21n68");

var $146p5 = parcelRequire("146p5");
/**
 * @category Locales
 * @summary Uzbek Cyrillic locale.
 * @language Uzbek
 * @iso-639-2 uzb
 * @author Kamronbek Shodmonov [@kamronbek28](https://github.com/kamronbek28)
 */ const $bb3c132680de61f1$var$uzCyrl = $bb3c132680de61f1$export$fe32212c9efceff7 = {
    code: "uz-Cyrl",
    formatDistance: $fFjZA.formatDistance,
    formatLong: $l1frn.formatLong,
    formatRelative: $7arKP.formatRelative,
    localize: $21n68.localize,
    match: $146p5.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("fFjZA", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $b67a316acc08dcd3$export$2c14ff85d6318973; }, function (v) { return $b67a316acc08dcd3$export$2c14ff85d6318973 = v; });
var $b67a316acc08dcd3$export$2c14ff85d6318973;
"use strict";
$b67a316acc08dcd3$export$2c14ff85d6318973 = void 0;
const $b67a316acc08dcd3$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1 \u0441\u043E\u043D\u0438\u044F\u0434\u0430\u043D \u043A\u0430\u043C",
        other: "{{count}} \u0441\u043E\u043D\u0438\u044F\u0434\u0430\u043D \u043A\u0430\u043C"
    },
    xSeconds: {
        one: "1 \u0441\u043E\u043D\u0438\u044F",
        other: "{{count}} \u0441\u043E\u043D\u0438\u044F"
    },
    halfAMinute: "\u044F\u0440\u0438\u043C \u0434\u0430\u049B\u0438\u049B\u0430",
    lessThanXMinutes: {
        one: "1 \u0434\u0430\u049B\u0438\u049B\u0430\u0434\u0430\u043D \u043A\u0430\u043C",
        other: "{{count}} \u0434\u0430\u049B\u0438\u049B\u0430\u0434\u0430\u043D \u043A\u0430\u043C"
    },
    xMinutes: {
        one: "1 \u0434\u0430\u049B\u0438\u049B\u0430",
        other: "{{count}} \u0434\u0430\u049B\u0438\u049B\u0430"
    },
    aboutXHours: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u0441\u043E\u0430\u0442",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u0441\u043E\u0430\u0442"
    },
    xHours: {
        one: "1 \u0441\u043E\u0430\u0442",
        other: "{{count}} \u0441\u043E\u0430\u0442"
    },
    xDays: {
        one: "1 \u043A\u0443\u043D",
        other: "{{count}} \u043A\u0443\u043D"
    },
    aboutXWeeks: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u0445\u0430\u0444\u0442\u0430",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u0445\u0430\u0444\u0442\u0430"
    },
    xWeeks: {
        one: "1 \u0445\u0430\u0444\u0442\u0430",
        other: "{{count}} \u0445\u0430\u0444\u0442\u0430"
    },
    aboutXMonths: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u043E\u0439",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u043E\u0439"
    },
    xMonths: {
        one: "1 \u043E\u0439",
        other: "{{count}} \u043E\u0439"
    },
    aboutXYears: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u0439\u0438\u043B",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u0439\u0438\u043B"
    },
    xYears: {
        one: "1 \u0439\u0438\u043B",
        other: "{{count}} \u0439\u0438\u043B"
    },
    overXYears: {
        one: "1 \u0439\u0438\u043B\u0434\u0430\u043D \u043A\u045E\u043F",
        other: "{{count}} \u0439\u0438\u043B\u0434\u0430\u043D \u043A\u045E\u043F"
    },
    almostXYears: {
        one: "\u0434\u0435\u044F\u0440\u043B\u0438 1 \u0439\u0438\u043B",
        other: "\u0434\u0435\u044F\u0440\u043B\u0438 {{count}} \u0439\u0438\u043B"
    }
};
const $b67a316acc08dcd3$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $b67a316acc08dcd3$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u0434\u0430\u043D \u043A\u0435\u0439\u0438\u043D";
        else return result + " \u043E\u043B\u0434\u0438\u043D";
    }
    return result;
};
$b67a316acc08dcd3$export$2c14ff85d6318973 = $b67a316acc08dcd3$var$formatDistance;

});

parcelRegister("l1frn", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $f4d5ab1fdfd5a450$export$cbf60ecb96cbb82f; }, function (v) { return $f4d5ab1fdfd5a450$export$cbf60ecb96cbb82f = v; });
var $f4d5ab1fdfd5a450$export$cbf60ecb96cbb82f;
"use strict";
$f4d5ab1fdfd5a450$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $f4d5ab1fdfd5a450$var$dateFormats = {
    full: "EEEE, do MMMM, y",
    long: "do MMMM, y",
    medium: "d MMM, y",
    short: "dd/MM/yyyy"
};
const $f4d5ab1fdfd5a450$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $f4d5ab1fdfd5a450$var$dateTimeFormats = {
    any: "{{date}}, {{time}}"
};
const $f4d5ab1fdfd5a450$var$formatLong = $f4d5ab1fdfd5a450$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $f4d5ab1fdfd5a450$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $f4d5ab1fdfd5a450$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $f4d5ab1fdfd5a450$var$dateTimeFormats,
        defaultWidth: "any"
    })
};

});

parcelRegister("7arKP", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $537efefd6039dd0a$export$8fbbfd65594f46a0; }, function (v) { return $537efefd6039dd0a$export$8fbbfd65594f46a0 = v; });
var $537efefd6039dd0a$export$8fbbfd65594f46a0;
"use strict";
$537efefd6039dd0a$export$8fbbfd65594f46a0 = void 0;
const $537efefd6039dd0a$var$formatRelativeLocale = {
    lastWeek: "'\u045E\u0442\u0433\u0430\u043D' eeee p '\u0434\u0430'",
    yesterday: "'\u043A\u0435\u0447\u0430' p '\u0434\u0430'",
    today: "'\u0431\u0443\u0433\u0443\u043D' p '\u0434\u0430'",
    tomorrow: "'\u044D\u0440\u0442\u0430\u0433\u0430' p '\u0434\u0430'",
    nextWeek: "eeee p '\u0434\u0430'",
    other: "P"
};
const $537efefd6039dd0a$var$formatRelative = (token, _date, _baseDate, _options)=>$537efefd6039dd0a$var$formatRelativeLocale[token];
$537efefd6039dd0a$export$8fbbfd65594f46a0 = $537efefd6039dd0a$var$formatRelative;

});

parcelRegister("21n68", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $178d978f888ef25d$export$b3bd0bc58e36cd63; }, function (v) { return $178d978f888ef25d$export$b3bd0bc58e36cd63 = v; });
var $178d978f888ef25d$export$b3bd0bc58e36cd63;
"use strict";
$178d978f888ef25d$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $178d978f888ef25d$var$eraValues = {
    narrow: [
        "\u041C.\u0410",
        "\u041C"
    ],
    abbreviated: [
        "\u041C.\u0410",
        "\u041C"
    ],
    wide: [
        "\u041C\u0438\u043B\u043E\u0434\u0434\u0430\u043D \u0410\u0432\u0432\u0430\u043B\u0433\u0438",
        "\u041C\u0438\u043B\u043E\u0434\u0438\u0439"
    ]
};
const $178d978f888ef25d$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-\u0447\u043E\u0440.",
        "2-\u0447\u043E\u0440.",
        "3-\u0447\u043E\u0440.",
        "4-\u0447\u043E\u0440."
    ],
    wide: [
        "1-\u0447\u043E\u0440\u0430\u043A",
        "2-\u0447\u043E\u0440\u0430\u043A",
        "3-\u0447\u043E\u0440\u0430\u043A",
        "4-\u0447\u043E\u0440\u0430\u043A"
    ]
};
const $178d978f888ef25d$var$monthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432",
        "\u0444\u0435\u0432",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D",
        "\u0438\u044E\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043D",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u044F",
        "\u0434\u0435\u043A"
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440",
        "\u0444\u0435\u0432\u0440\u0430\u043B",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0435\u043B",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D",
        "\u0438\u044E\u043B",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043D\u0442\u0430\u0431\u0440",
        "\u043E\u043A\u0442\u0430\u0431\u0440",
        "\u043D\u043E\u044F\u0431\u0440",
        "\u0434\u0435\u043A\u0430\u0431\u0440"
    ]
};
const $178d978f888ef25d$var$dayValues = {
    narrow: [
        "\u042F",
        "\u0414",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0416",
        "\u0428"
    ],
    short: [
        "\u044F\u043A",
        "\u0434\u0443",
        "\u0441\u0435",
        "\u0447\u043E",
        "\u043F\u0430",
        "\u0436\u0443",
        "\u0448\u0430"
    ],
    abbreviated: [
        "\u044F\u043A\u0448",
        "\u0434\u0443\u0448",
        "\u0441\u0435\u0448",
        "\u0447\u043E\u0440",
        "\u043F\u0430\u0439",
        "\u0436\u0443\u043C",
        "\u0448\u0430\u043D"
    ],
    wide: [
        "\u044F\u043A\u0448\u0430\u043D\u0431\u0430",
        "\u0434\u0443\u0448\u0430\u043D\u0431\u0430",
        "\u0441\u0435\u0448\u0430\u043D\u0431\u0430",
        "\u0447\u043E\u0440\u0448\u0430\u043D\u0431\u0430",
        "\u043F\u0430\u0439\u0448\u0430\u043D\u0431\u0430",
        "\u0436\u0443\u043C\u0430",
        "\u0448\u0430\u043D\u0431\u0430"
    ]
};
const $178d978f888ef25d$var$dayPeriodValues = {
    any: {
        am: "\u041F.\u041E.",
        pm: "\u041F.\u041A.",
        midnight: "\u044F\u0440\u0438\u043C \u0442\u0443\u043D",
        noon: "\u043F\u0435\u0448\u0438\u043D",
        morning: "\u044D\u0440\u0442\u0430\u043B\u0430\u0431",
        afternoon: "\u043F\u0435\u0448\u0438\u043D\u0434\u0430\u043D \u043A\u0435\u0439\u0438\u043D",
        evening: "\u043A\u0435\u0447\u0430\u0441\u0438",
        night: "\u0442\u0443\u043D"
    }
};
const $178d978f888ef25d$var$formattingDayPeriodValues = {
    any: {
        am: "\u041F.\u041E.",
        pm: "\u041F.\u041A.",
        midnight: "\u044F\u0440\u0438\u043C \u0442\u0443\u043D",
        noon: "\u043F\u0435\u0448\u0438\u043D",
        morning: "\u044D\u0440\u0442\u0430\u043B\u0430\u0431",
        afternoon: "\u043F\u0435\u0448\u0438\u043D\u0434\u0430\u043D \u043A\u0435\u0439\u0438\u043D",
        evening: "\u043A\u0435\u0447\u0430\u0441\u0438",
        night: "\u0442\u0443\u043D"
    }
};
const $178d978f888ef25d$var$ordinalNumber = (dirtyNumber, _options)=>{
    return String(dirtyNumber);
};
const $178d978f888ef25d$var$localize = $178d978f888ef25d$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $178d978f888ef25d$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $178d978f888ef25d$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $178d978f888ef25d$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $178d978f888ef25d$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $178d978f888ef25d$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $178d978f888ef25d$var$dayPeriodValues,
        defaultWidth: "any",
        formattingValues: $178d978f888ef25d$var$formattingDayPeriodValues,
        defaultFormattingWidth: "any"
    })
};

});

parcelRegister("146p5", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $0c6b21cc4eaa9747$export$4659b591c19bdf3d; }, function (v) { return $0c6b21cc4eaa9747$export$4659b591c19bdf3d = v; });
var $0c6b21cc4eaa9747$export$4659b591c19bdf3d;
"use strict";
$0c6b21cc4eaa9747$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $0c6b21cc4eaa9747$var$matchOrdinalNumberPattern = /^(\d+)(чи)?/i;
const $0c6b21cc4eaa9747$var$parseOrdinalNumberPattern = /\d+/i;
const $0c6b21cc4eaa9747$var$matchEraPatterns = {
    narrow: /^(м\.а|м\.)/i,
    abbreviated: /^(м\.а|м\.)/i,
    wide: /^(милоддан аввал|милоддан кейин)/i
};
const $0c6b21cc4eaa9747$var$parseEraPatterns = {
    any: [
        /^м/i,
        /^а/i
    ]
};
const $0c6b21cc4eaa9747$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]-чор./i,
    wide: /^[1234]-чорак/i
};
const $0c6b21cc4eaa9747$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $0c6b21cc4eaa9747$var$matchMonthPatterns = {
    narrow: /^[яфмамииасонд]/i,
    abbreviated: /^(янв|фев|мар|апр|май|июн|июл|авг|сен|окт|ноя|дек)/i,
    wide: /^(январ|феврал|март|апрел|май|июн|июл|август|сентабр|октабр|ноябр|декабр)/i
};
const $0c6b21cc4eaa9747$var$parseMonthPatterns = {
    narrow: [
        /^я/i,
        /^ф/i,
        /^м/i,
        /^а/i,
        /^м/i,
        /^и/i,
        /^и/i,
        /^а/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ],
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^май/i,
        /^июн/i,
        /^июл/i,
        /^ав/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
const $0c6b21cc4eaa9747$var$matchDayPatterns = {
    narrow: /^[ядсчпжш]/i,
    short: /^(як|ду|се|чо|па|жу|ша)/i,
    abbreviated: /^(якш|душ|сеш|чор|пай|жум|шан)/i,
    wide: /^(якшанба|душанба|сешанба|чоршанба|пайшанба|жума|шанба)/i
};
const $0c6b21cc4eaa9747$var$parseDayPatterns = {
    narrow: [
        /^я/i,
        /^д/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^ж/i,
        /^ш/i
    ],
    any: [
        /^як/i,
        /^ду/i,
        /^се/i,
        /^чор/i,
        /^пай/i,
        /^жу/i,
        /^шан/i
    ]
};
const $0c6b21cc4eaa9747$var$matchDayPeriodPatterns = {
    any: /^(п\.о\.|п\.к\.|ярим тун|пешиндан кейин|(эрталаб|пешиндан кейин|кечаси|тун))/i
};
const $0c6b21cc4eaa9747$var$parseDayPeriodPatterns = {
    any: {
        am: /^п\.о\./i,
        pm: /^п\.к\./i,
        midnight: /^ярим тун/i,
        noon: /^пешиндан кейин/i,
        morning: /эрталаб/i,
        afternoon: /пешиндан кейин/i,
        evening: /кечаси/i,
        night: /тун/i
    }
};
const $0c6b21cc4eaa9747$var$match = $0c6b21cc4eaa9747$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $0c6b21cc4eaa9747$var$matchOrdinalNumberPattern,
        parsePattern: $0c6b21cc4eaa9747$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $0c6b21cc4eaa9747$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0c6b21cc4eaa9747$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $0c6b21cc4eaa9747$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0c6b21cc4eaa9747$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $0c6b21cc4eaa9747$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0c6b21cc4eaa9747$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $0c6b21cc4eaa9747$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0c6b21cc4eaa9747$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $0c6b21cc4eaa9747$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $0c6b21cc4eaa9747$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("bZSlM", function(module, exports) {

$parcel$export(module.exports, "vi", function () { return $8bbf8d124e3b3384$export$e3786bf10a8abdf2; }, function (v) { return $8bbf8d124e3b3384$export$e3786bf10a8abdf2 = v; });
var $8bbf8d124e3b3384$export$e3786bf10a8abdf2;
"use strict";
$8bbf8d124e3b3384$export$e3786bf10a8abdf2 = void 0;

var $hJB5d = parcelRequire("hJB5d");

var $1iE1o = parcelRequire("1iE1o");

var $joUFi = parcelRequire("joUFi");

var $kMpij = parcelRequire("kMpij");

var $asb1J = parcelRequire("asb1J");
/**
 * @category Locales
 * @summary Vietnamese locale (Vietnam).
 * @language Vietnamese
 * @iso-639-2 vie
 * @author Thanh Tran [@trongthanh](https://github.com/trongthanh)
 * @author Leroy Hopson [@lihop](https://github.com/lihop)
 */ const $8bbf8d124e3b3384$var$vi = $8bbf8d124e3b3384$export$e3786bf10a8abdf2 = {
    code: "vi",
    formatDistance: $hJB5d.formatDistance,
    formatLong: $1iE1o.formatLong,
    formatRelative: $joUFi.formatRelative,
    localize: $kMpij.localize,
    match: $asb1J.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1 /* First week of new year contains Jan 1st  */ 
    }
};

});
parcelRegister("hJB5d", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $ce9367970c52374e$export$2c14ff85d6318973; }, function (v) { return $ce9367970c52374e$export$2c14ff85d6318973 = v; });
var $ce9367970c52374e$export$2c14ff85d6318973;
"use strict";
$ce9367970c52374e$export$2c14ff85d6318973 = void 0;
const $ce9367970c52374e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "d\u01B0\u1EDBi 1 gi\xe2y",
        other: "d\u01B0\u1EDBi {{count}} gi\xe2y"
    },
    xSeconds: {
        one: "1 gi\xe2y",
        other: "{{count}} gi\xe2y"
    },
    halfAMinute: "n\u1EEDa ph\xfat",
    lessThanXMinutes: {
        one: "d\u01B0\u1EDBi 1 ph\xfat",
        other: "d\u01B0\u1EDBi {{count}} ph\xfat"
    },
    xMinutes: {
        one: "1 ph\xfat",
        other: "{{count}} ph\xfat"
    },
    aboutXHours: {
        one: "kho\u1EA3ng 1 gi\u1EDD",
        other: "kho\u1EA3ng {{count}} gi\u1EDD"
    },
    xHours: {
        one: "1 gi\u1EDD",
        other: "{{count}} gi\u1EDD"
    },
    xDays: {
        one: "1 ng\xe0y",
        other: "{{count}} ng\xe0y"
    },
    aboutXWeeks: {
        one: "kho\u1EA3ng 1 tu\u1EA7n",
        other: "kho\u1EA3ng {{count}} tu\u1EA7n"
    },
    xWeeks: {
        one: "1 tu\u1EA7n",
        other: "{{count}} tu\u1EA7n"
    },
    aboutXMonths: {
        one: "kho\u1EA3ng 1 th\xe1ng",
        other: "kho\u1EA3ng {{count}} th\xe1ng"
    },
    xMonths: {
        one: "1 th\xe1ng",
        other: "{{count}} th\xe1ng"
    },
    aboutXYears: {
        one: "kho\u1EA3ng 1 n\u0103m",
        other: "kho\u1EA3ng {{count}} n\u0103m"
    },
    xYears: {
        one: "1 n\u0103m",
        other: "{{count}} n\u0103m"
    },
    overXYears: {
        one: "h\u01A1n 1 n\u0103m",
        other: "h\u01A1n {{count}} n\u0103m"
    },
    almostXYears: {
        one: "g\u1EA7n 1 n\u0103m",
        other: "g\u1EA7n {{count}} n\u0103m"
    }
};
const $ce9367970c52374e$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $ce9367970c52374e$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " n\u1EEFa";
        else return result + " tr\u01B0\u1EDBc";
    }
    return result;
};
$ce9367970c52374e$export$2c14ff85d6318973 = $ce9367970c52374e$var$formatDistance;

});

parcelRegister("1iE1o", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $0f268452f551d59a$export$cbf60ecb96cbb82f; }, function (v) { return $0f268452f551d59a$export$cbf60ecb96cbb82f = v; });
var $0f268452f551d59a$export$cbf60ecb96cbb82f;
"use strict";
$0f268452f551d59a$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $0f268452f551d59a$var$dateFormats = {
    // thứ Sáu, ngày 25 tháng 08 năm 2017
    full: "EEEE, 'ng\xe0y' d MMMM 'n\u0103m' y",
    // ngày 25 tháng 08 năm 2017
    long: "'ng\xe0y' d MMMM 'n\u0103m' y",
    // 25 thg 08 năm 2017
    medium: "d MMM 'n\u0103m' y",
    // 25/08/2017
    short: "dd/MM/y"
};
const $0f268452f551d59a$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $0f268452f551d59a$var$dateTimeFormats = {
    // thứ Sáu, ngày 25 tháng 08 năm 2017 23:25:59
    full: "{{date}} {{time}}",
    // ngày 25 tháng 08 năm 2017 23:25
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $0f268452f551d59a$var$formatLong = $0f268452f551d59a$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $0f268452f551d59a$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $0f268452f551d59a$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $0f268452f551d59a$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("joUFi", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $e1fc36b81077f53b$export$8fbbfd65594f46a0; }, function (v) { return $e1fc36b81077f53b$export$8fbbfd65594f46a0 = v; });
var $e1fc36b81077f53b$export$8fbbfd65594f46a0;
"use strict";
$e1fc36b81077f53b$export$8fbbfd65594f46a0 = void 0;
const $e1fc36b81077f53b$var$formatRelativeLocale = {
    lastWeek: "eeee 'tu\u1EA7n tr\u01B0\u1EDBc v\xe0o l\xfac' p",
    yesterday: "'h\xf4m qua v\xe0o l\xfac' p",
    today: "'h\xf4m nay v\xe0o l\xfac' p",
    tomorrow: "'ng\xe0y mai v\xe0o l\xfac' p",
    nextWeek: "eeee 't\u1EDBi v\xe0o l\xfac' p",
    other: "P"
};
const $e1fc36b81077f53b$var$formatRelative = (token, _date, _baseDate, _options)=>$e1fc36b81077f53b$var$formatRelativeLocale[token];
$e1fc36b81077f53b$export$8fbbfd65594f46a0 = $e1fc36b81077f53b$var$formatRelative;

});

parcelRegister("kMpij", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $f20be946ce1a7361$export$b3bd0bc58e36cd63; }, function (v) { return $f20be946ce1a7361$export$b3bd0bc58e36cd63 = v; });
var $f20be946ce1a7361$export$b3bd0bc58e36cd63;
"use strict";
$f20be946ce1a7361$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
// Vietnamese locale reference: http://www.localeplanet.com/icu/vi-VN/index.html
// Capitalization reference: http://hcmup.edu.vn/index.php?option=com_content&view=article&id=4106%3Avit-hoa-trong-vn-bn-hanh-chinh&catid=2345%3Atham-kho&Itemid=4103&lang=vi&site=134
const $f20be946ce1a7361$var$eraValues = {
    narrow: [
        "TCN",
        "SCN"
    ],
    abbreviated: [
        "tr\u01B0\u1EDBc CN",
        "sau CN"
    ],
    wide: [
        "tr\u01B0\u1EDBc C\xf4ng Nguy\xean",
        "sau C\xf4ng Nguy\xean"
    ]
};
const $f20be946ce1a7361$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "Qu\xfd 1",
        "Qu\xfd 2",
        "Qu\xfd 3",
        "Qu\xfd 4"
    ]
};
const $f20be946ce1a7361$var$formattingQuarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    // I notice many news outlet use this "quý II/2018"
    wide: [
        "qu\xfd I",
        "qu\xfd II",
        "qu\xfd III",
        "qu\xfd IV"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $f20be946ce1a7361$var$monthValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12"
    ],
    abbreviated: [
        "Thg 1",
        "Thg 2",
        "Thg 3",
        "Thg 4",
        "Thg 5",
        "Thg 6",
        "Thg 7",
        "Thg 8",
        "Thg 9",
        "Thg 10",
        "Thg 11",
        "Thg 12"
    ],
    wide: [
        "Th\xe1ng M\u1ED9t",
        "Th\xe1ng Hai",
        "Th\xe1ng Ba",
        "Th\xe1ng T\u01B0",
        "Th\xe1ng N\u0103m",
        "Th\xe1ng S\xe1u",
        "Th\xe1ng B\u1EA3y",
        "Th\xe1ng T\xe1m",
        "Th\xe1ng Ch\xedn",
        "Th\xe1ng M\u01B0\u1EDDi",
        "Th\xe1ng M\u01B0\u1EDDi M\u1ED9t",
        "Th\xe1ng M\u01B0\u1EDDi Hai"
    ]
};
// In Vietnamese date formatting, month number less than 10 expected to have leading zero
const $f20be946ce1a7361$var$formattingMonthValues = {
    narrow: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12"
    ],
    abbreviated: [
        "thg 1",
        "thg 2",
        "thg 3",
        "thg 4",
        "thg 5",
        "thg 6",
        "thg 7",
        "thg 8",
        "thg 9",
        "thg 10",
        "thg 11",
        "thg 12"
    ],
    wide: [
        "th\xe1ng 01",
        "th\xe1ng 02",
        "th\xe1ng 03",
        "th\xe1ng 04",
        "th\xe1ng 05",
        "th\xe1ng 06",
        "th\xe1ng 07",
        "th\xe1ng 08",
        "th\xe1ng 09",
        "th\xe1ng 10",
        "th\xe1ng 11",
        "th\xe1ng 12"
    ]
};
const $f20be946ce1a7361$var$dayValues = {
    narrow: [
        "CN",
        "T2",
        "T3",
        "T4",
        "T5",
        "T6",
        "T7"
    ],
    short: [
        "CN",
        "Th 2",
        "Th 3",
        "Th 4",
        "Th 5",
        "Th 6",
        "Th 7"
    ],
    abbreviated: [
        "CN",
        "Th\u1EE9 2",
        "Th\u1EE9 3",
        "Th\u1EE9 4",
        "Th\u1EE9 5",
        "Th\u1EE9 6",
        "Th\u1EE9 7"
    ],
    wide: [
        "Ch\u1EE7 Nh\u1EADt",
        "Th\u1EE9 Hai",
        "Th\u1EE9 Ba",
        "Th\u1EE9 T\u01B0",
        "Th\u1EE9 N\u0103m",
        "Th\u1EE9 S\xe1u",
        "Th\u1EE9 B\u1EA3y"
    ]
};
// Vietnamese are used to AM/PM borrowing from English, hence `narrow` and
// `abbreviated` are just like English but I'm leaving the `wide`
// format being localized with abbreviations found in some systems (SÁng / CHiều);
// however, personally, I don't think `Chiều` sounds appropriate for `PM`
const $f20be946ce1a7361$var$dayPeriodValues = {
    // narrow date period is extremely rare in Vietnamese
    // I used abbreviated form for noon, morning and afternoon
    // which are regconizable by Vietnamese, others cannot be any shorter
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr",
        morning: "sg",
        afternoon: "ch",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr\u01B0a",
        morning: "s\xe1ng",
        afternoon: "chi\u1EC1u",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    wide: {
        am: "SA",
        pm: "CH",
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr\u01B0a",
        morning: "s\xe1ng",
        afternoon: "chi\u1EC1u",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    }
};
const $f20be946ce1a7361$var$formattingDayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr",
        morning: "sg",
        afternoon: "ch",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr\u01B0a",
        morning: "s\xe1ng",
        afternoon: "chi\u1EC1u",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    wide: {
        am: "SA",
        pm: "CH",
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "gi\u1EEFa tr\u01B0a",
        morning: "v\xe0o bu\u1ED5i s\xe1ng",
        afternoon: "v\xe0o bu\u1ED5i chi\u1EC1u",
        evening: "v\xe0o bu\u1ED5i t\u1ED1i",
        night: "v\xe0o ban \u0111\xeam"
    }
};
const $f20be946ce1a7361$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    const unit = options?.unit;
    if (unit === "quarter") // many news outlets use "quý I"...
    switch(number){
        case 1:
            return "I";
        case 2:
            return "II";
        case 3:
            return "III";
        case 4:
            return "IV";
    }
    else if (unit === "day") // day of week in Vietnamese has ordinal number meaning,
    // so we should use them, else it'll sound weird
    switch(number){
        case 1:
            return "th\u1EE9 2"; // meaning 2nd day but it's the first day of the week :D
        case 2:
            return "th\u1EE9 3"; // meaning 3rd day
        case 3:
            return "th\u1EE9 4"; // meaning 4th day and so on
        case 4:
            return "th\u1EE9 5";
        case 5:
            return "th\u1EE9 6";
        case 6:
            return "th\u1EE9 7";
        case 7:
            return "ch\u1EE7 nh\u1EADt"; // meaning Sunday, there's no 8th day :D
    }
    else if (unit === "week") {
        if (number === 1) return "th\u1EE9 nh\u1EA5t";
        else return "th\u1EE9 " + number;
    } else if (unit === "dayOfYear") {
        if (number === 1) return "\u0111\u1EA7u ti\xean";
        else return "th\u1EE9 " + number;
    }
    // there are no different forms of ordinal numbers in Vietnamese
    return String(number);
};
const $f20be946ce1a7361$var$localize = $f20be946ce1a7361$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $f20be946ce1a7361$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $f20be946ce1a7361$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $f20be946ce1a7361$var$quarterValues,
        defaultWidth: "wide",
        formattingValues: $f20be946ce1a7361$var$formattingQuarterValues,
        defaultFormattingWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $f20be946ce1a7361$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $f20be946ce1a7361$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $f20be946ce1a7361$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $f20be946ce1a7361$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $f20be946ce1a7361$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("asb1J", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $79c5129a2a5d0d03$export$4659b591c19bdf3d; }, function (v) { return $79c5129a2a5d0d03$export$4659b591c19bdf3d = v; });
var $79c5129a2a5d0d03$export$4659b591c19bdf3d;
"use strict";
$79c5129a2a5d0d03$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $79c5129a2a5d0d03$var$matchOrdinalNumberPattern = /^(\d+)/i;
const $79c5129a2a5d0d03$var$parseOrdinalNumberPattern = /\d+/i;
const $79c5129a2a5d0d03$var$matchEraPatterns = {
    narrow: /^(tcn|scn)/i,
    abbreviated: /^(trước CN|sau CN)/i,
    wide: /^(trước Công Nguyên|sau Công Nguyên)/i
};
const $79c5129a2a5d0d03$var$parseEraPatterns = {
    any: [
        /^t/i,
        /^s/i
    ]
};
const $79c5129a2a5d0d03$var$matchQuarterPatterns = {
    narrow: /^([1234]|i{1,3}v?)/i,
    abbreviated: /^q([1234]|i{1,3}v?)/i,
    wide: /^quý ([1234]|i{1,3}v?)/i
};
const $79c5129a2a5d0d03$var$parseQuarterPatterns = {
    any: [
        /(1|i)$/i,
        /(2|ii)$/i,
        /(3|iii)$/i,
        /(4|iv)$/i
    ]
};
const $79c5129a2a5d0d03$var$matchMonthPatterns = {
    // month number may contain leading 0, 'thg' prefix may have space, underscore or empty before number
    // note the order of '1' since it is a sub-string of '10', so must be lower priority
    narrow: /^(0?[2-9]|10|11|12|0?1)/i,
    // note the order of 'thg 1' since it is sub-string of 'thg 10', so must be lower priority
    abbreviated: /^thg[ _]?(0?[1-9](?!\d)|10|11|12)/i,
    // note the order of 'Mười' since it is sub-string of Mười Một, so must be lower priority
    wide: /^tháng ?(Một|Hai|Ba|Tư|Năm|Sáu|Bảy|Tám|Chín|Mười|Mười ?Một|Mười ?Hai|0?[1-9](?!\d)|10|11|12)/i
};
const $79c5129a2a5d0d03$var$parseMonthPatterns = {
    narrow: [
        /0?1$/i,
        /0?2/i,
        /3/,
        /4/,
        /5/,
        /6/,
        /7/,
        /8/,
        /9/,
        /10/,
        /11/,
        /12/
    ],
    abbreviated: [
        /^thg[ _]?0?1(?!\d)/i,
        /^thg[ _]?0?2/i,
        /^thg[ _]?0?3/i,
        /^thg[ _]?0?4/i,
        /^thg[ _]?0?5/i,
        /^thg[ _]?0?6/i,
        /^thg[ _]?0?7/i,
        /^thg[ _]?0?8/i,
        /^thg[ _]?0?9/i,
        /^thg[ _]?10/i,
        /^thg[ _]?11/i,
        /^thg[ _]?12/i
    ],
    wide: [
        /^tháng ?(Một|0?1(?!\d))/i,
        /^tháng ?(Hai|0?2)/i,
        /^tháng ?(Ba|0?3)/i,
        /^tháng ?(Tư|0?4)/i,
        /^tháng ?(Năm|0?5)/i,
        /^tháng ?(Sáu|0?6)/i,
        /^tháng ?(Bảy|0?7)/i,
        /^tháng ?(Tám|0?8)/i,
        /^tháng ?(Chín|0?9)/i,
        /^tháng ?(Mười|10)/i,
        /^tháng ?(Mười ?Một|11)/i,
        /^tháng ?(Mười ?Hai|12)/i
    ]
};
const $79c5129a2a5d0d03$var$matchDayPatterns = {
    narrow: /^(CN|T2|T3|T4|T5|T6|T7)/i,
    short: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
    abbreviated: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
    wide: /^(Chủ ?Nhật|Chúa ?Nhật|thứ ?Hai|thứ ?Ba|thứ ?Tư|thứ ?Năm|thứ ?Sáu|thứ ?Bảy)/i
};
const $79c5129a2a5d0d03$var$parseDayPatterns = {
    narrow: [
        /CN/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i
    ],
    short: [
        /CN/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i
    ],
    abbreviated: [
        /CN/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i
    ],
    wide: [
        /(Chủ|Chúa) ?Nhật/i,
        /Hai/i,
        /Ba/i,
        /Tư/i,
        /Năm/i,
        /Sáu/i,
        /Bảy/i
    ]
};
const $79c5129a2a5d0d03$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
    abbreviated: /^(am|pm|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
    wide: /^(ch[^i]*|sa|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i
};
const $79c5129a2a5d0d03$var$parseDayPeriodPatterns = {
    any: {
        am: /^(a|sa)/i,
        pm: /^(p|ch[^i]*)/i,
        midnight: /nửa đêm/i,
        noon: /trưa/i,
        morning: /sáng/i,
        afternoon: /chiều/i,
        evening: /tối/i,
        night: /^đêm/i
    }
};
const $79c5129a2a5d0d03$var$match = $79c5129a2a5d0d03$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $79c5129a2a5d0d03$var$matchOrdinalNumberPattern,
        parsePattern: $79c5129a2a5d0d03$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $79c5129a2a5d0d03$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $79c5129a2a5d0d03$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $79c5129a2a5d0d03$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $79c5129a2a5d0d03$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $79c5129a2a5d0d03$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $79c5129a2a5d0d03$var$parseMonthPatterns,
        defaultParseWidth: "wide"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $79c5129a2a5d0d03$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $79c5129a2a5d0d03$var$parseDayPatterns,
        defaultParseWidth: "wide"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $79c5129a2a5d0d03$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $79c5129a2a5d0d03$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("fd6CF", function(module, exports) {

$parcel$export(module.exports, "zhCN", function () { return $b12d350d396b4a5a$export$836e793ad054f4a7; }, function (v) { return $b12d350d396b4a5a$export$836e793ad054f4a7 = v; });
var $b12d350d396b4a5a$export$836e793ad054f4a7;
"use strict";
$b12d350d396b4a5a$export$836e793ad054f4a7 = void 0;

var $5xQWI = parcelRequire("5xQWI");

var $8pl4E = parcelRequire("8pl4E");

var $cyhym = parcelRequire("cyhym");

var $2QZtX = parcelRequire("2QZtX");

var $bAVIY = parcelRequire("bAVIY");
/**
 * @category Locales
 * @summary Chinese Simplified locale.
 * @language Chinese Simplified
 * @iso-639-2 zho
 * @author Changyu Geng [@KingMario](https://github.com/KingMario)
 * @author Song Shuoyun [@fnlctrl](https://github.com/fnlctrl)
 * @author sabrinaM [@sabrinamiao](https://github.com/sabrinamiao)
 * @author Carney Wu [@cubicwork](https://github.com/cubicwork)
 * @author Terrence Lam [@skyuplam](https://github.com/skyuplam)
 */ const $b12d350d396b4a5a$var$zhCN = $b12d350d396b4a5a$export$836e793ad054f4a7 = {
    code: "zh-CN",
    formatDistance: $5xQWI.formatDistance,
    formatLong: $8pl4E.formatLong,
    formatRelative: $cyhym.formatRelative,
    localize: $2QZtX.localize,
    match: $bAVIY.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("5xQWI", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $40991acd5a38ffaf$export$2c14ff85d6318973; }, function (v) { return $40991acd5a38ffaf$export$2c14ff85d6318973 = v; });
var $40991acd5a38ffaf$export$2c14ff85d6318973;
"use strict";
$40991acd5a38ffaf$export$2c14ff85d6318973 = void 0;
const $40991acd5a38ffaf$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u4E0D\u5230 1 \u79D2",
        other: "\u4E0D\u5230 {{count}} \u79D2"
    },
    xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
    },
    halfAMinute: "\u534A\u5206\u949F",
    lessThanXMinutes: {
        one: "\u4E0D\u5230 1 \u5206\u949F",
        other: "\u4E0D\u5230 {{count}} \u5206\u949F"
    },
    xMinutes: {
        one: "1 \u5206\u949F",
        other: "{{count}} \u5206\u949F"
    },
    xHours: {
        one: "1 \u5C0F\u65F6",
        other: "{{count}} \u5C0F\u65F6"
    },
    aboutXHours: {
        one: "\u5927\u7EA6 1 \u5C0F\u65F6",
        other: "\u5927\u7EA6 {{count}} \u5C0F\u65F6"
    },
    xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
    },
    aboutXWeeks: {
        one: "\u5927\u7EA6 1 \u4E2A\u661F\u671F",
        other: "\u5927\u7EA6 {{count}} \u4E2A\u661F\u671F"
    },
    xWeeks: {
        one: "1 \u4E2A\u661F\u671F",
        other: "{{count}} \u4E2A\u661F\u671F"
    },
    aboutXMonths: {
        one: "\u5927\u7EA6 1 \u4E2A\u6708",
        other: "\u5927\u7EA6 {{count}} \u4E2A\u6708"
    },
    xMonths: {
        one: "1 \u4E2A\u6708",
        other: "{{count}} \u4E2A\u6708"
    },
    aboutXYears: {
        one: "\u5927\u7EA6 1 \u5E74",
        other: "\u5927\u7EA6 {{count}} \u5E74"
    },
    xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
    },
    overXYears: {
        one: "\u8D85\u8FC7 1 \u5E74",
        other: "\u8D85\u8FC7 {{count}} \u5E74"
    },
    almostXYears: {
        one: "\u5C06\u8FD1 1 \u5E74",
        other: "\u5C06\u8FD1 {{count}} \u5E74"
    }
};
const $40991acd5a38ffaf$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $40991acd5a38ffaf$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5185";
        else return result + "\u524D";
    }
    return result;
};
$40991acd5a38ffaf$export$2c14ff85d6318973 = $40991acd5a38ffaf$var$formatDistance;

});

parcelRegister("8pl4E", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $61f101690507b193$export$cbf60ecb96cbb82f; }, function (v) { return $61f101690507b193$export$cbf60ecb96cbb82f = v; });
var $61f101690507b193$export$cbf60ecb96cbb82f;
"use strict";
$61f101690507b193$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $61f101690507b193$var$dateFormats = {
    full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
    long: "y'\u5E74'M'\u6708'd'\u65E5'",
    medium: "yyyy-MM-dd",
    short: "yy-MM-dd"
};
const $61f101690507b193$var$timeFormats = {
    full: "zzzz a h:mm:ss",
    long: "z a h:mm:ss",
    medium: "a h:mm:ss",
    short: "a h:mm"
};
const $61f101690507b193$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $61f101690507b193$var$formatLong = $61f101690507b193$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $61f101690507b193$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $61f101690507b193$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $61f101690507b193$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("cyhym", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $923646bc9b6bfd4c$export$8fbbfd65594f46a0; }, function (v) { return $923646bc9b6bfd4c$export$8fbbfd65594f46a0 = v; });
var $923646bc9b6bfd4c$export$8fbbfd65594f46a0;
"use strict";
$923646bc9b6bfd4c$export$8fbbfd65594f46a0 = void 0;

var $9VRW1 = parcelRequire("9VRW1");
function $923646bc9b6bfd4c$var$checkWeek(date, baseDate, options) {
    const baseFormat = "eeee p";
    if ((0, $9VRW1.isSameWeek)(date, baseDate, options)) return baseFormat; // in same week
    else if (date.getTime() > baseDate.getTime()) return "'\u4E0B\u4E2A'" + baseFormat; // in next week
    return "'\u4E0A\u4E2A'" + baseFormat; // in last week
}
const $923646bc9b6bfd4c$var$formatRelativeLocale = {
    lastWeek: $923646bc9b6bfd4c$var$checkWeek,
    yesterday: "'\u6628\u5929' p",
    today: "'\u4ECA\u5929' p",
    tomorrow: "'\u660E\u5929' p",
    nextWeek: $923646bc9b6bfd4c$var$checkWeek,
    other: "PP p"
};
const $923646bc9b6bfd4c$var$formatRelative = (token, date, baseDate, options)=>{
    const format = $923646bc9b6bfd4c$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
$923646bc9b6bfd4c$export$8fbbfd65594f46a0 = $923646bc9b6bfd4c$var$formatRelative;

});

parcelRegister("2QZtX", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $214021319a87337b$export$b3bd0bc58e36cd63; }, function (v) { return $214021319a87337b$export$b3bd0bc58e36cd63 = v; });
var $214021319a87337b$export$b3bd0bc58e36cd63;
"use strict";
$214021319a87337b$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $214021319a87337b$var$eraValues = {
    narrow: [
        "\u524D",
        "\u516C\u5143"
    ],
    abbreviated: [
        "\u524D",
        "\u516C\u5143"
    ],
    wide: [
        "\u516C\u5143\u524D",
        "\u516C\u5143"
    ]
};
const $214021319a87337b$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u7B2C\u4E00\u5B63",
        "\u7B2C\u4E8C\u5B63",
        "\u7B2C\u4E09\u5B63",
        "\u7B2C\u56DB\u5B63"
    ],
    wide: [
        "\u7B2C\u4E00\u5B63\u5EA6",
        "\u7B2C\u4E8C\u5B63\u5EA6",
        "\u7B2C\u4E09\u5B63\u5EA6",
        "\u7B2C\u56DB\u5B63\u5EA6"
    ]
};
const $214021319a87337b$var$monthValues = {
    narrow: [
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341",
        "\u5341\u4E00",
        "\u5341\u4E8C"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
const $214021319a87337b$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    short: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    abbreviated: [
        "\u5468\u65E5",
        "\u5468\u4E00",
        "\u5468\u4E8C",
        "\u5468\u4E09",
        "\u5468\u56DB",
        "\u5468\u4E94",
        "\u5468\u516D"
    ],
    wide: [
        "\u661F\u671F\u65E5",
        "\u661F\u671F\u4E00",
        "\u661F\u671F\u4E8C",
        "\u661F\u671F\u4E09",
        "\u661F\u671F\u56DB",
        "\u661F\u671F\u4E94",
        "\u661F\u671F\u516D"
    ]
};
const $214021319a87337b$var$dayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    }
};
const $214021319a87337b$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    }
};
const $214021319a87337b$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    switch(options?.unit){
        case "date":
            return number.toString() + "\u65E5";
        case "hour":
            return number.toString() + "\u65F6";
        case "minute":
            return number.toString() + "\u5206";
        case "second":
            return number.toString() + "\u79D2";
        default:
            return "\u7B2C " + number.toString();
    }
};
const $214021319a87337b$var$localize = $214021319a87337b$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $214021319a87337b$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $214021319a87337b$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $214021319a87337b$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $214021319a87337b$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $214021319a87337b$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $214021319a87337b$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $214021319a87337b$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("bAVIY", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $870fd55c355427dc$export$4659b591c19bdf3d; }, function (v) { return $870fd55c355427dc$export$4659b591c19bdf3d = v; });
var $870fd55c355427dc$export$4659b591c19bdf3d;
"use strict";
$870fd55c355427dc$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $870fd55c355427dc$var$matchOrdinalNumberPattern = /^(第\s*)?\d+(日|时|分|秒)?/i;
const $870fd55c355427dc$var$parseOrdinalNumberPattern = /\d+/i;
const $870fd55c355427dc$var$matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
const $870fd55c355427dc$var$parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
const $870fd55c355427dc$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]刻/i,
    wide: /^第[一二三四]刻钟/i
};
const $870fd55c355427dc$var$parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
const $870fd55c355427dc$var$matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
const $870fd55c355427dc$var$parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
const $870fd55c355427dc$var$matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^周[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
const $870fd55c355427dc$var$parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
const $870fd55c355427dc$var$matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨|)/i
};
const $870fd55c355427dc$var$parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
const $870fd55c355427dc$var$match = $870fd55c355427dc$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $870fd55c355427dc$var$matchOrdinalNumberPattern,
        parsePattern: $870fd55c355427dc$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $870fd55c355427dc$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $870fd55c355427dc$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $870fd55c355427dc$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $870fd55c355427dc$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $870fd55c355427dc$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $870fd55c355427dc$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $870fd55c355427dc$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $870fd55c355427dc$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $870fd55c355427dc$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $870fd55c355427dc$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("3G5Zh", function(module, exports) {

$parcel$export(module.exports, "zhHK", function () { return $2ad9f049ebea7777$export$2099e693528da242; }, function (v) { return $2ad9f049ebea7777$export$2099e693528da242 = v; });
var $2ad9f049ebea7777$export$2099e693528da242;
"use strict";
$2ad9f049ebea7777$export$2099e693528da242 = void 0;

var $fdjlr = parcelRequire("fdjlr");

var $49Djx = parcelRequire("49Djx");

var $heH9c = parcelRequire("heH9c");

var $FWIjD = parcelRequire("FWIjD");

var $aB0Yd = parcelRequire("aB0Yd");
/**
 * @category Locales
 * @summary Chinese Traditional locale.
 * @language Chinese Traditional
 * @iso-639-2 zho
 * @author Gary Ip [@gaplo](https://github.com/gaplo)
 */ const $2ad9f049ebea7777$var$zhHK = $2ad9f049ebea7777$export$2099e693528da242 = {
    code: "zh-HK",
    formatDistance: $fdjlr.formatDistance,
    formatLong: $49Djx.formatLong,
    formatRelative: $heH9c.formatRelative,
    localize: $FWIjD.localize,
    match: $aB0Yd.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("fdjlr", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $b13713670130df2c$export$2c14ff85d6318973; }, function (v) { return $b13713670130df2c$export$2c14ff85d6318973 = v; });
var $b13713670130df2c$export$2c14ff85d6318973;
"use strict";
$b13713670130df2c$export$2c14ff85d6318973 = void 0;
const $b13713670130df2c$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u5C11\u65BC 1 \u79D2",
        other: "\u5C11\u65BC {{count}} \u79D2"
    },
    xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
    },
    halfAMinute: "\u534A\u5206\u9418",
    lessThanXMinutes: {
        one: "\u5C11\u65BC 1 \u5206\u9418",
        other: "\u5C11\u65BC {{count}} \u5206\u9418"
    },
    xMinutes: {
        one: "1 \u5206\u9418",
        other: "{{count}} \u5206\u9418"
    },
    xHours: {
        one: "1 \u5C0F\u6642",
        other: "{{count}} \u5C0F\u6642"
    },
    aboutXHours: {
        one: "\u5927\u7D04 1 \u5C0F\u6642",
        other: "\u5927\u7D04 {{count}} \u5C0F\u6642"
    },
    xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
    },
    aboutXWeeks: {
        one: "\u5927\u7D04 1 \u500B\u661F\u671F",
        other: "\u5927\u7D04 {{count}} \u500B\u661F\u671F"
    },
    xWeeks: {
        one: "1 \u500B\u661F\u671F",
        other: "{{count}} \u500B\u661F\u671F"
    },
    aboutXMonths: {
        one: "\u5927\u7D04 1 \u500B\u6708",
        other: "\u5927\u7D04 {{count}} \u500B\u6708"
    },
    xMonths: {
        one: "1 \u500B\u6708",
        other: "{{count}} \u500B\u6708"
    },
    aboutXYears: {
        one: "\u5927\u7D04 1 \u5E74",
        other: "\u5927\u7D04 {{count}} \u5E74"
    },
    xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
    },
    overXYears: {
        one: "\u8D85\u904E 1 \u5E74",
        other: "\u8D85\u904E {{count}} \u5E74"
    },
    almostXYears: {
        one: "\u5C07\u8FD1 1 \u5E74",
        other: "\u5C07\u8FD1 {{count}} \u5E74"
    }
};
const $b13713670130df2c$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $b13713670130df2c$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5167";
        else return result + "\u524D";
    }
    return result;
};
$b13713670130df2c$export$2c14ff85d6318973 = $b13713670130df2c$var$formatDistance;

});

parcelRegister("49Djx", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $30667fac3fc2cec3$export$cbf60ecb96cbb82f; }, function (v) { return $30667fac3fc2cec3$export$cbf60ecb96cbb82f = v; });
var $30667fac3fc2cec3$export$cbf60ecb96cbb82f;
"use strict";
$30667fac3fc2cec3$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $30667fac3fc2cec3$var$dateFormats = {
    full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
    long: "y'\u5E74'M'\u6708'd'\u65E5'",
    medium: "yyyy-MM-dd",
    short: "yy-MM-dd"
};
const $30667fac3fc2cec3$var$timeFormats = {
    full: "zzzz a h:mm:ss",
    long: "z a h:mm:ss",
    medium: "a h:mm:ss",
    short: "a h:mm"
};
const $30667fac3fc2cec3$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $30667fac3fc2cec3$var$formatLong = $30667fac3fc2cec3$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $30667fac3fc2cec3$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $30667fac3fc2cec3$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $30667fac3fc2cec3$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("heH9c", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $c8c5369ffa742ede$export$8fbbfd65594f46a0; }, function (v) { return $c8c5369ffa742ede$export$8fbbfd65594f46a0 = v; });
var $c8c5369ffa742ede$export$8fbbfd65594f46a0;
"use strict";
$c8c5369ffa742ede$export$8fbbfd65594f46a0 = void 0;
const $c8c5369ffa742ede$var$formatRelativeLocale = {
    lastWeek: "'\u4E0A\u500B'eeee p",
    yesterday: "'\u6628\u5929' p",
    today: "'\u4ECA\u5929' p",
    tomorrow: "'\u660E\u5929' p",
    nextWeek: "'\u4E0B\u500B'eeee p",
    other: "P"
};
const $c8c5369ffa742ede$var$formatRelative = (token, _date, _baseDate, _options)=>$c8c5369ffa742ede$var$formatRelativeLocale[token];
$c8c5369ffa742ede$export$8fbbfd65594f46a0 = $c8c5369ffa742ede$var$formatRelative;

});

parcelRegister("FWIjD", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $07e15fc8177c1f13$export$b3bd0bc58e36cd63; }, function (v) { return $07e15fc8177c1f13$export$b3bd0bc58e36cd63 = v; });
var $07e15fc8177c1f13$export$b3bd0bc58e36cd63;
"use strict";
$07e15fc8177c1f13$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $07e15fc8177c1f13$var$eraValues = {
    narrow: [
        "\u524D",
        "\u516C\u5143"
    ],
    abbreviated: [
        "\u524D",
        "\u516C\u5143"
    ],
    wide: [
        "\u516C\u5143\u524D",
        "\u516C\u5143"
    ]
};
const $07e15fc8177c1f13$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u7B2C\u4E00\u5B63",
        "\u7B2C\u4E8C\u5B63",
        "\u7B2C\u4E09\u5B63",
        "\u7B2C\u56DB\u5B63"
    ],
    wide: [
        "\u7B2C\u4E00\u5B63\u5EA6",
        "\u7B2C\u4E8C\u5B63\u5EA6",
        "\u7B2C\u4E09\u5B63\u5EA6",
        "\u7B2C\u56DB\u5B63\u5EA6"
    ]
};
const $07e15fc8177c1f13$var$monthValues = {
    narrow: [
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341",
        "\u5341\u4E00",
        "\u5341\u4E8C"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
const $07e15fc8177c1f13$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    short: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    abbreviated: [
        "\u9031\u65E5",
        "\u9031\u4E00",
        "\u9031\u4E8C",
        "\u9031\u4E09",
        "\u9031\u56DB",
        "\u9031\u4E94",
        "\u9031\u516D"
    ],
    wide: [
        "\u661F\u671F\u65E5",
        "\u661F\u671F\u4E00",
        "\u661F\u671F\u4E8C",
        "\u661F\u671F\u4E09",
        "\u661F\u671F\u56DB",
        "\u661F\u671F\u4E94",
        "\u661F\u671F\u516D"
    ]
};
const $07e15fc8177c1f13$var$dayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u5348\u591C",
        noon: "\u664C",
        morning: "\u65E9",
        afternoon: "\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    }
};
const $07e15fc8177c1f13$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u5348\u591C",
        noon: "\u664C",
        morning: "\u65E9",
        afternoon: "\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    }
};
const $07e15fc8177c1f13$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    switch(options?.unit){
        case "date":
            return number + "\u65E5";
        case "hour":
            return number + "\u6642";
        case "minute":
            return number + "\u5206";
        case "second":
            return number + "\u79D2";
        default:
            return "\u7B2C " + number;
    }
};
const $07e15fc8177c1f13$var$localize = $07e15fc8177c1f13$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $07e15fc8177c1f13$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $07e15fc8177c1f13$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $07e15fc8177c1f13$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $07e15fc8177c1f13$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $07e15fc8177c1f13$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $07e15fc8177c1f13$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $07e15fc8177c1f13$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("aB0Yd", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $7b6e1cbb70261b3f$export$4659b591c19bdf3d; }, function (v) { return $7b6e1cbb70261b3f$export$4659b591c19bdf3d = v; });
var $7b6e1cbb70261b3f$export$4659b591c19bdf3d;
"use strict";
$7b6e1cbb70261b3f$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $7b6e1cbb70261b3f$var$matchOrdinalNumberPattern = /^(第\s*)?\d+(日|時|分|秒)?/i;
const $7b6e1cbb70261b3f$var$parseOrdinalNumberPattern = /\d+/i;
const $7b6e1cbb70261b3f$var$matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
const $7b6e1cbb70261b3f$var$parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
const $7b6e1cbb70261b3f$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]季/i,
    wide: /^第[一二三四]季度/i
};
const $7b6e1cbb70261b3f$var$parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
const $7b6e1cbb70261b3f$var$matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
const $7b6e1cbb70261b3f$var$parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
const $7b6e1cbb70261b3f$var$matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^週[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
const $7b6e1cbb70261b3f$var$parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
const $7b6e1cbb70261b3f$var$matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
};
const $7b6e1cbb70261b3f$var$parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
const $7b6e1cbb70261b3f$var$match = $7b6e1cbb70261b3f$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $7b6e1cbb70261b3f$var$matchOrdinalNumberPattern,
        parsePattern: $7b6e1cbb70261b3f$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $7b6e1cbb70261b3f$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7b6e1cbb70261b3f$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $7b6e1cbb70261b3f$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7b6e1cbb70261b3f$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $7b6e1cbb70261b3f$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7b6e1cbb70261b3f$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $7b6e1cbb70261b3f$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7b6e1cbb70261b3f$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $7b6e1cbb70261b3f$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $7b6e1cbb70261b3f$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("cMffX", function(module, exports) {

$parcel$export(module.exports, "zhTW", function () { return $94d5cd510d5ed49e$export$3991fdf1bb6f66b9; }, function (v) { return $94d5cd510d5ed49e$export$3991fdf1bb6f66b9 = v; });
var $94d5cd510d5ed49e$export$3991fdf1bb6f66b9;
"use strict";
$94d5cd510d5ed49e$export$3991fdf1bb6f66b9 = void 0;

var $douza = parcelRequire("douza");

var $8YEd3 = parcelRequire("8YEd3");

var $o9vXm = parcelRequire("o9vXm");

var $9HLy3 = parcelRequire("9HLy3");

var $5VkCG = parcelRequire("5VkCG");
/**
 * @category Locales
 * @summary Chinese Traditional locale.
 * @language Chinese Traditional
 * @iso-639-2 zho
 * @author tonypai [@tpai](https://github.com/tpai)
 * @author Jack Hsu [@jackhsu978](https://github.com/jackhsu978)
 * @author Terrence Lam [@skyuplam](https://github.com/skyuplam)
 */ const $94d5cd510d5ed49e$var$zhTW = $94d5cd510d5ed49e$export$3991fdf1bb6f66b9 = {
    code: "zh-TW",
    formatDistance: $douza.formatDistance,
    formatLong: $8YEd3.formatLong,
    formatRelative: $o9vXm.formatRelative,
    localize: $9HLy3.localize,
    match: $5VkCG.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("douza", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $9c053a0b5afef9d0$export$2c14ff85d6318973; }, function (v) { return $9c053a0b5afef9d0$export$2c14ff85d6318973 = v; });
var $9c053a0b5afef9d0$export$2c14ff85d6318973;
"use strict";
$9c053a0b5afef9d0$export$2c14ff85d6318973 = void 0;
const $9c053a0b5afef9d0$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u5C11\u65BC 1 \u79D2",
        other: "\u5C11\u65BC {{count}} \u79D2"
    },
    xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
    },
    halfAMinute: "\u534A\u5206\u9418",
    lessThanXMinutes: {
        one: "\u5C11\u65BC 1 \u5206\u9418",
        other: "\u5C11\u65BC {{count}} \u5206\u9418"
    },
    xMinutes: {
        one: "1 \u5206\u9418",
        other: "{{count}} \u5206\u9418"
    },
    xHours: {
        one: "1 \u5C0F\u6642",
        other: "{{count}} \u5C0F\u6642"
    },
    aboutXHours: {
        one: "\u5927\u7D04 1 \u5C0F\u6642",
        other: "\u5927\u7D04 {{count}} \u5C0F\u6642"
    },
    xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
    },
    aboutXWeeks: {
        one: "\u5927\u7D04 1 \u500B\u661F\u671F",
        other: "\u5927\u7D04 {{count}} \u500B\u661F\u671F"
    },
    xWeeks: {
        one: "1 \u500B\u661F\u671F",
        other: "{{count}} \u500B\u661F\u671F"
    },
    aboutXMonths: {
        one: "\u5927\u7D04 1 \u500B\u6708",
        other: "\u5927\u7D04 {{count}} \u500B\u6708"
    },
    xMonths: {
        one: "1 \u500B\u6708",
        other: "{{count}} \u500B\u6708"
    },
    aboutXYears: {
        one: "\u5927\u7D04 1 \u5E74",
        other: "\u5927\u7D04 {{count}} \u5E74"
    },
    xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
    },
    overXYears: {
        one: "\u8D85\u904E 1 \u5E74",
        other: "\u8D85\u904E {{count}} \u5E74"
    },
    almostXYears: {
        one: "\u5C07\u8FD1 1 \u5E74",
        other: "\u5C07\u8FD1 {{count}} \u5E74"
    }
};
const $9c053a0b5afef9d0$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $9c053a0b5afef9d0$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5167";
        else return result + "\u524D";
    }
    return result;
};
$9c053a0b5afef9d0$export$2c14ff85d6318973 = $9c053a0b5afef9d0$var$formatDistance;

});

parcelRegister("8YEd3", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $68931e19cc96ec25$export$cbf60ecb96cbb82f; }, function (v) { return $68931e19cc96ec25$export$cbf60ecb96cbb82f = v; });
var $68931e19cc96ec25$export$cbf60ecb96cbb82f;
"use strict";
$68931e19cc96ec25$export$cbf60ecb96cbb82f = void 0;

var $2jgV2 = parcelRequire("2jgV2");
const $68931e19cc96ec25$var$dateFormats = {
    full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
    long: "y'\u5E74'M'\u6708'd'\u65E5'",
    medium: "yyyy-MM-dd",
    short: "yy-MM-dd"
};
const $68931e19cc96ec25$var$timeFormats = {
    full: "zzzz a h:mm:ss",
    long: "z a h:mm:ss",
    medium: "a h:mm:ss",
    short: "a h:mm"
};
const $68931e19cc96ec25$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $68931e19cc96ec25$var$formatLong = $68931e19cc96ec25$export$cbf60ecb96cbb82f = {
    date: (0, $2jgV2.buildFormatLongFn)({
        formats: $68931e19cc96ec25$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2jgV2.buildFormatLongFn)({
        formats: $68931e19cc96ec25$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2jgV2.buildFormatLongFn)({
        formats: $68931e19cc96ec25$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("o9vXm", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $04899f5f4db130be$export$8fbbfd65594f46a0; }, function (v) { return $04899f5f4db130be$export$8fbbfd65594f46a0 = v; });
var $04899f5f4db130be$export$8fbbfd65594f46a0;
"use strict";
$04899f5f4db130be$export$8fbbfd65594f46a0 = void 0;
const $04899f5f4db130be$var$formatRelativeLocale = {
    lastWeek: "'\u4E0A\u500B'eeee p",
    yesterday: "'\u6628\u5929' p",
    today: "'\u4ECA\u5929' p",
    tomorrow: "'\u660E\u5929' p",
    nextWeek: "'\u4E0B\u500B'eeee p",
    other: "P"
};
const $04899f5f4db130be$var$formatRelative = (token, _date, _baseDate, _options)=>$04899f5f4db130be$var$formatRelativeLocale[token];
$04899f5f4db130be$export$8fbbfd65594f46a0 = $04899f5f4db130be$var$formatRelative;

});

parcelRegister("9HLy3", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $710d0352b896c197$export$b3bd0bc58e36cd63; }, function (v) { return $710d0352b896c197$export$b3bd0bc58e36cd63 = v; });
var $710d0352b896c197$export$b3bd0bc58e36cd63;
"use strict";
$710d0352b896c197$export$b3bd0bc58e36cd63 = void 0;

var $4Zr7l = parcelRequire("4Zr7l");
const $710d0352b896c197$var$eraValues = {
    narrow: [
        "\u524D",
        "\u516C\u5143"
    ],
    abbreviated: [
        "\u524D",
        "\u516C\u5143"
    ],
    wide: [
        "\u516C\u5143\u524D",
        "\u516C\u5143"
    ]
};
const $710d0352b896c197$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u7B2C\u4E00\u523B",
        "\u7B2C\u4E8C\u523B",
        "\u7B2C\u4E09\u523B",
        "\u7B2C\u56DB\u523B"
    ],
    wide: [
        "\u7B2C\u4E00\u523B\u9418",
        "\u7B2C\u4E8C\u523B\u9418",
        "\u7B2C\u4E09\u523B\u9418",
        "\u7B2C\u56DB\u523B\u9418"
    ]
};
const $710d0352b896c197$var$monthValues = {
    narrow: [
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341",
        "\u5341\u4E00",
        "\u5341\u4E8C"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
const $710d0352b896c197$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    short: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    abbreviated: [
        "\u9031\u65E5",
        "\u9031\u4E00",
        "\u9031\u4E8C",
        "\u9031\u4E09",
        "\u9031\u56DB",
        "\u9031\u4E94",
        "\u9031\u516D"
    ],
    wide: [
        "\u661F\u671F\u65E5",
        "\u661F\u671F\u4E00",
        "\u661F\u671F\u4E8C",
        "\u661F\u671F\u4E09",
        "\u661F\u671F\u56DB",
        "\u661F\u671F\u4E94",
        "\u661F\u671F\u516D"
    ]
};
const $710d0352b896c197$var$dayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    }
};
const $710d0352b896c197$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    }
};
const $710d0352b896c197$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    switch(options?.unit){
        case "date":
            return number + "\u65E5";
        case "hour":
            return number + "\u6642";
        case "minute":
            return number + "\u5206";
        case "second":
            return number + "\u79D2";
        default:
            return "\u7B2C " + number;
    }
};
const $710d0352b896c197$var$localize = $710d0352b896c197$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $710d0352b896c197$var$ordinalNumber,
    era: (0, $4Zr7l.buildLocalizeFn)({
        values: $710d0352b896c197$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4Zr7l.buildLocalizeFn)({
        values: $710d0352b896c197$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4Zr7l.buildLocalizeFn)({
        values: $710d0352b896c197$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4Zr7l.buildLocalizeFn)({
        values: $710d0352b896c197$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4Zr7l.buildLocalizeFn)({
        values: $710d0352b896c197$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $710d0352b896c197$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("5VkCG", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $450245ebf589a8de$export$4659b591c19bdf3d; }, function (v) { return $450245ebf589a8de$export$4659b591c19bdf3d = v; });
var $450245ebf589a8de$export$4659b591c19bdf3d;
"use strict";
$450245ebf589a8de$export$4659b591c19bdf3d = void 0;

var $kQYK9 = parcelRequire("kQYK9");

var $8RZeP = parcelRequire("8RZeP");
const $450245ebf589a8de$var$matchOrdinalNumberPattern = /^(第\s*)?\d+(日|時|分|秒)?/i;
const $450245ebf589a8de$var$parseOrdinalNumberPattern = /\d+/i;
const $450245ebf589a8de$var$matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
const $450245ebf589a8de$var$parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
const $450245ebf589a8de$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]刻/i,
    wide: /^第[一二三四]刻鐘/i
};
const $450245ebf589a8de$var$parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
const $450245ebf589a8de$var$matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
const $450245ebf589a8de$var$parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
const $450245ebf589a8de$var$matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^週[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
const $450245ebf589a8de$var$parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
const $450245ebf589a8de$var$matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
};
const $450245ebf589a8de$var$parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
const $450245ebf589a8de$var$match = $450245ebf589a8de$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8RZeP.buildMatchPatternFn)({
        matchPattern: $450245ebf589a8de$var$matchOrdinalNumberPattern,
        parsePattern: $450245ebf589a8de$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $450245ebf589a8de$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $450245ebf589a8de$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $450245ebf589a8de$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $450245ebf589a8de$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $450245ebf589a8de$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $450245ebf589a8de$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $450245ebf589a8de$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $450245ebf589a8de$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $kQYK9.buildMatchFn)({
        matchPatterns: $450245ebf589a8de$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $450245ebf589a8de$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});




parcelRegister("lFhEr", function(module, exports) {
/*!
 * Globalize
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 */ (function(window, undefined) {
    var Globalize, // private variables
    regexHex, regexInfinity, regexParseFloat, regexTrim, // private JavaScript utility functions
    arrayIndexOf, endsWith, extend, isArray, isFunction, isObject, startsWith, trim, truncate, zeroPad, // private Globalization utility functions
    appendPreOrPostMatch, expandFormat, formatDate, formatNumber, getTokenRegExp, getEra, getEraYear, parseExact, parseNegativePattern;
    // Global variable (Globalize) or CommonJS module (globalize)
    Globalize = function(cultureSelector) {
        return new Globalize.prototype.init(cultureSelector);
    };
    // Assume CommonJS
    module.exports = Globalize;
    Globalize.cultures = {};
    Globalize.prototype = {
        constructor: Globalize,
        init: function(cultureSelector) {
            this.cultures = Globalize.cultures;
            this.cultureSelector = cultureSelector;
            return this;
        }
    };
    Globalize.prototype.init.prototype = Globalize.prototype;
    // 1. When defining a culture, all fields are required except the ones stated as optional.
    // 2. Each culture should have a ".calendars" object with at least one calendar named "standard"
    //    which serves as the default calendar in use by that culture.
    // 3. Each culture should have a ".calendar" object which is the current calendar being used,
    //    it may be dynamically changed at any time to one of the calendars in ".calendars".
    Globalize.cultures["default"] = {
        // A unique name for the culture in the form <language code>-<country/region code>
        name: "en",
        // the name of the culture in the english language
        englishName: "English",
        // the name of the culture in its own language
        nativeName: "English",
        // whether the culture uses right-to-left text
        isRTL: false,
        // "language" is used for so-called "specific" cultures.
        // For example, the culture "es-CL" means "Spanish, in Chili".
        // It represents the Spanish-speaking culture as it is in Chili,
        // which might have different formatting rules or even translations
        // than Spanish in Spain. A "neutral" culture is one that is not
        // specific to a region. For example, the culture "es" is the generic
        // Spanish culture, which may be a more generalized version of the language
        // that may or may not be what a specific culture expects.
        // For a specific culture like "es-CL", the "language" field refers to the
        // neutral, generic culture information for the language it is using.
        // This is not always a simple matter of the string before the dash.
        // For example, the "zh-Hans" culture is netural (Simplified Chinese).
        // And the "zh-SG" culture is Simplified Chinese in Singapore, whose lanugage
        // field is "zh-CHS", not "zh".
        // This field should be used to navigate from a specific culture to it's
        // more general, neutral culture. If a culture is already as general as it
        // can get, the language may refer to itself.
        language: "en",
        // numberFormat defines general number formatting rules, like the digits in
        // each grouping, the group separator, and how negative numbers are displayed.
        numberFormat: {
            // [negativePattern]
            // Note, numberFormat.pattern has no "positivePattern" unlike percent and currency,
            // but is still defined as an array for consistency with them.
            //   negativePattern: one of "(n)|-n|- n|n-|n -"
            pattern: [
                "-n"
            ],
            // number of decimal places normally shown
            decimals: 2,
            // string that separates number groups, as in 1,000,000
            ",": ",",
            // string that separates a number from the fractional portion, as in 1.99
            ".": ".",
            // array of numbers indicating the size of each number group.
            // TODO: more detailed description and example
            groupSizes: [
                3
            ],
            // symbol used for positive numbers
            "+": "+",
            // symbol used for negative numbers
            "-": "-",
            // symbol used for NaN (Not-A-Number)
            "NaN": "NaN",
            // symbol used for Negative Infinity
            negativeInfinity: "-Infinity",
            // symbol used for Positive Infinity
            positiveInfinity: "Infinity",
            percent: {
                // [negativePattern, positivePattern]
                //   negativePattern: one of "-n %|-n%|-%n|%-n|%n-|n-%|n%-|-% n|n %-|% n-|% -n|n- %"
                //   positivePattern: one of "n %|n%|%n|% n"
                pattern: [
                    "-n %",
                    "n %"
                ],
                // number of decimal places normally shown
                decimals: 2,
                // array of numbers indicating the size of each number group.
                // TODO: more detailed description and example
                groupSizes: [
                    3
                ],
                // string that separates number groups, as in 1,000,000
                ",": ",",
                // string that separates a number from the fractional portion, as in 1.99
                ".": ".",
                // symbol used to represent a percentage
                symbol: "%"
            },
            currency: {
                // [negativePattern, positivePattern]
                //   negativePattern: one of "($n)|-$n|$-n|$n-|(n$)|-n$|n-$|n$-|-n $|-$ n|n $-|$ n-|$ -n|n- $|($ n)|(n $)"
                //   positivePattern: one of "$n|n$|$ n|n $"
                pattern: [
                    "($n)",
                    "$n"
                ],
                // number of decimal places normally shown
                decimals: 2,
                // array of numbers indicating the size of each number group.
                // TODO: more detailed description and example
                groupSizes: [
                    3
                ],
                // string that separates number groups, as in 1,000,000
                ",": ",",
                // string that separates a number from the fractional portion, as in 1.99
                ".": ".",
                // symbol used to represent currency
                symbol: "$"
            }
        },
        // calendars defines all the possible calendars used by this culture.
        // There should be at least one defined with name "standard", and is the default
        // calendar used by the culture.
        // A calendar contains information about how dates are formatted, information about
        // the calendar's eras, a standard set of the date formats,
        // translations for day and month names, and if the calendar is not based on the Gregorian
        // calendar, conversion functions to and from the Gregorian calendar.
        calendars: {
            standard: {
                // name that identifies the type of calendar this is
                name: "Gregorian_USEnglish",
                // separator of parts of a date (e.g. "/" in 11/05/1955)
                "/": "/",
                // separator of parts of a time (e.g. ":" in 05:44 PM)
                ":": ":",
                // the first day of the week (0 = Sunday, 1 = Monday, etc)
                firstDay: 0,
                days: {
                    // full day names
                    names: [
                        "Sunday",
                        "Monday",
                        "Tuesday",
                        "Wednesday",
                        "Thursday",
                        "Friday",
                        "Saturday"
                    ],
                    // abbreviated day names
                    namesAbbr: [
                        "Sun",
                        "Mon",
                        "Tue",
                        "Wed",
                        "Thu",
                        "Fri",
                        "Sat"
                    ],
                    // shortest day names
                    namesShort: [
                        "Su",
                        "Mo",
                        "Tu",
                        "We",
                        "Th",
                        "Fr",
                        "Sa"
                    ]
                },
                months: {
                    // full month names (13 months for lunar calendards -- 13th month should be "" if not lunar)
                    names: [
                        "January",
                        "February",
                        "March",
                        "April",
                        "May",
                        "June",
                        "July",
                        "August",
                        "September",
                        "October",
                        "November",
                        "December",
                        ""
                    ],
                    // abbreviated month names
                    namesAbbr: [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec",
                        ""
                    ]
                },
                // AM and PM designators in one of these forms:
                // The usual view, and the upper and lower case versions
                //   [ standard, lowercase, uppercase ]
                // The culture does not use AM or PM (likely all standard date formats use 24 hour time)
                //   null
                AM: [
                    "AM",
                    "am",
                    "AM"
                ],
                PM: [
                    "PM",
                    "pm",
                    "PM"
                ],
                eras: [
                    // eras in reverse chronological order.
                    // name: the name of the era in this culture (e.g. A.D., C.E.)
                    // start: when the era starts in ticks (gregorian, gmt), null if it is the earliest supported era.
                    // offset: offset in years from gregorian calendar
                    {
                        "name": "A.D.",
                        "start": null,
                        "offset": 0
                    }
                ],
                // when a two digit year is given, it will never be parsed as a four digit
                // year greater than this year (in the appropriate era for the culture)
                // Set it as a full year (e.g. 2029) or use an offset format starting from
                // the current year: "+19" would correspond to 2029 if the current year 2010.
                twoDigitYearMax: 2029,
                // set of predefined date and time patterns used by the culture
                // these represent the format someone in this culture would expect
                // to see given the portions of the date that are shown.
                patterns: {
                    // short date pattern
                    d: "M/d/yyyy",
                    // long date pattern
                    D: "dddd, MMMM dd, yyyy",
                    // short time pattern
                    t: "h:mm tt",
                    // long time pattern
                    T: "h:mm:ss tt",
                    // long date, short time pattern
                    f: "dddd, MMMM dd, yyyy h:mm tt",
                    // long date, long time pattern
                    F: "dddd, MMMM dd, yyyy h:mm:ss tt",
                    // month/day pattern
                    M: "MMMM dd",
                    // month/year pattern
                    Y: "yyyy MMMM",
                    // S is a sortable format that does not vary by culture
                    S: "yyyy'-'MM'-'dd'T'HH':'mm':'ss"
                }
            }
        },
        // For localized strings
        messages: {}
    };
    Globalize.cultures["default"].calendar = Globalize.cultures["default"].calendars.standard;
    Globalize.cultures.en = Globalize.cultures["default"];
    Globalize.cultureSelector = "en";
    //
    // private variables
    //
    regexHex = /^0x[a-f0-9]+$/i;
    regexInfinity = /^[+\-]?infinity$/i;
    regexParseFloat = /^[+\-]?\d*\.?\d*(e[+\-]?\d+)?$/;
    regexTrim = /^\s+|\s+$/g;
    //
    // private JavaScript utility functions
    //
    arrayIndexOf = function(array, item) {
        if (array.indexOf) return array.indexOf(item);
        for(var i = 0, length = array.length; i < length; i++){
            if (array[i] === item) return i;
        }
        return -1;
    };
    endsWith = function(value, pattern) {
        return value.substr(value.length - pattern.length) === pattern;
    };
    extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            target = arguments[1] || {};
            // skip the boolean and the target
            i = 2;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                src = target[name];
                copy = options[name];
                // Prevent never-ending loop
                if (target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (isObject(copy) || (copyIsArray = isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && isArray(src) ? src : [];
                    } else clone = src && isObject(src) ? src : {};
                    // Never move original objects, clone them
                    target[name] = extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    isArray = Array.isArray || function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    isFunction = function(obj) {
        return Object.prototype.toString.call(obj) === "[object Function]";
    };
    isObject = function(obj) {
        return Object.prototype.toString.call(obj) === "[object Object]";
    };
    startsWith = function(value, pattern) {
        return value.indexOf(pattern) === 0;
    };
    trim = function(value) {
        return (value + "").replace(regexTrim, "");
    };
    truncate = function(value) {
        if (isNaN(value)) return NaN;
        return Math[value < 0 ? "ceil" : "floor"](value);
    };
    zeroPad = function(str, count, left) {
        var l;
        for(l = str.length; l < count; l += 1)str = left ? "0" + str : str + "0";
        return str;
    };
    //
    // private Globalization utility functions
    //
    appendPreOrPostMatch = function(preMatch, strings) {
        // appends pre- and post- token match strings while removing escaped characters.
        // Returns a single quote count which is used to determine if the token occurs
        // in a string literal.
        var quoteCount = 0, escaped = false;
        for(var i = 0, il = preMatch.length; i < il; i++){
            var c = preMatch.charAt(i);
            switch(c){
                case "'":
                    if (escaped) strings.push("'");
                    else quoteCount++;
                    escaped = false;
                    break;
                case "\\":
                    if (escaped) strings.push("\\");
                    escaped = !escaped;
                    break;
                default:
                    strings.push(c);
                    escaped = false;
                    break;
            }
        }
        return quoteCount;
    };
    expandFormat = function(cal, format) {
        // expands unspecified or single character date formats into the full pattern.
        format = format || "F";
        var pattern, patterns = cal.patterns, len = format.length;
        if (len === 1) {
            pattern = patterns[format];
            if (!pattern) throw "Invalid date format string '" + format + "'.";
            format = pattern;
        } else if (len === 2 && format.charAt(0) === "%") // %X escape format -- intended as a custom format string that is only one character, not a built-in format.
        format = format.charAt(1);
        return format;
    };
    formatDate = function(value, format, culture) {
        var cal = culture.calendar, convert = cal.convert, ret;
        if (!format || !format.length || format === "i") {
            if (culture && culture.name.length) {
                if (convert) // non-gregorian calendar, so we cannot use built-in toLocaleString()
                ret = formatDate(value, cal.patterns.F, culture);
                else {
                    var eraDate = new Date(value.getTime()), era = getEra(value, cal.eras);
                    eraDate.setFullYear(getEraYear(value, cal, era));
                    ret = eraDate.toLocaleString();
                }
            } else ret = value.toString();
            return ret;
        }
        var eras = cal.eras, sortable = format === "s";
        format = expandFormat(cal, format);
        // Start with an empty string
        ret = [];
        var hour, zeros = [
            "0",
            "00",
            "000"
        ], foundDay, checkedDay, dayPartRegExp = /([^d]|^)(d|dd)([^d]|$)/g, quoteCount = 0, tokenRegExp = getTokenRegExp(), converted;
        function padZeros(num, c) {
            var r, s = num + "";
            if (c > 1 && s.length < c) {
                r = zeros[c - 2] + s;
                return r.substr(r.length - c, c);
            } else r = s;
            return r;
        }
        function hasDay() {
            if (foundDay || checkedDay) return foundDay;
            foundDay = dayPartRegExp.test(format);
            checkedDay = true;
            return foundDay;
        }
        function getPart(date, part) {
            if (converted) return converted[part];
            switch(part){
                case 0:
                    return date.getFullYear();
                case 1:
                    return date.getMonth();
                case 2:
                    return date.getDate();
                default:
                    throw "Invalid part value " + part;
            }
        }
        if (!sortable && convert) converted = convert.fromGregorian(value);
        for(;;){
            // Save the current index
            var index = tokenRegExp.lastIndex, // Look for the next pattern
            ar = tokenRegExp.exec(format);
            // Append the text before the pattern (or the end of the string if not found)
            var preMatch = format.slice(index, ar ? ar.index : format.length);
            quoteCount += appendPreOrPostMatch(preMatch, ret);
            if (!ar) break;
            // do not replace any matches that occur inside a string literal.
            if (quoteCount % 2) {
                ret.push(ar[0]);
                continue;
            }
            var current = ar[0], clength = current.length;
            switch(current){
                case "ddd":
                //Day of the week, as a three-letter abbreviation
                case "dddd":
                    // Day of the week, using the full name
                    var names = clength === 3 ? cal.days.namesAbbr : cal.days.names;
                    ret.push(names[value.getDay()]);
                    break;
                case "d":
                // Day of month, without leading zero for single-digit days
                case "dd":
                    // Day of month, with leading zero for single-digit days
                    foundDay = true;
                    ret.push(padZeros(getPart(value, 2), clength));
                    break;
                case "MMM":
                // Month, as a three-letter abbreviation
                case "MMMM":
                    // Month, using the full name
                    var part = getPart(value, 1);
                    ret.push(cal.monthsGenitive && hasDay() ? cal.monthsGenitive[clength === 3 ? "namesAbbr" : "names"][part] : cal.months[clength === 3 ? "namesAbbr" : "names"][part]);
                    break;
                case "M":
                // Month, as digits, with no leading zero for single-digit months
                case "MM":
                    // Month, as digits, with leading zero for single-digit months
                    ret.push(padZeros(getPart(value, 1) + 1, clength));
                    break;
                case "y":
                // Year, as two digits, but with no leading zero for years less than 10
                case "yy":
                // Year, as two digits, with leading zero for years less than 10
                case "yyyy":
                    // Year represented by four full digits
                    part = converted ? converted[0] : getEraYear(value, cal, getEra(value, eras), sortable);
                    if (clength < 4) part = part % 100;
                    ret.push(padZeros(part, clength));
                    break;
                case "h":
                // Hours with no leading zero for single-digit hours, using 12-hour clock
                case "hh":
                    // Hours with leading zero for single-digit hours, using 12-hour clock
                    hour = value.getHours() % 12;
                    if (hour === 0) hour = 12;
                    ret.push(padZeros(hour, clength));
                    break;
                case "H":
                // Hours with no leading zero for single-digit hours, using 24-hour clock
                case "HH":
                    // Hours with leading zero for single-digit hours, using 24-hour clock
                    ret.push(padZeros(value.getHours(), clength));
                    break;
                case "m":
                // Minutes with no leading zero for single-digit minutes
                case "mm":
                    // Minutes with leading zero for single-digit minutes
                    ret.push(padZeros(value.getMinutes(), clength));
                    break;
                case "s":
                // Seconds with no leading zero for single-digit seconds
                case "ss":
                    // Seconds with leading zero for single-digit seconds
                    ret.push(padZeros(value.getSeconds(), clength));
                    break;
                case "t":
                // One character am/pm indicator ("a" or "p")
                case "tt":
                    // Multicharacter am/pm indicator
                    part = value.getHours() < 12 ? cal.AM ? cal.AM[0] : " " : cal.PM ? cal.PM[0] : " ";
                    ret.push(clength === 1 ? part.charAt(0) : part);
                    break;
                case "f":
                // Deciseconds
                case "ff":
                // Centiseconds
                case "fff":
                    // Milliseconds
                    ret.push(padZeros(value.getMilliseconds(), 3).substr(0, clength));
                    break;
                case "z":
                // Time zone offset, no leading zero
                case "zz":
                    // Time zone offset with leading zero
                    hour = value.getTimezoneOffset() / 60;
                    ret.push((hour <= 0 ? "+" : "-") + padZeros(Math.floor(Math.abs(hour)), clength));
                    break;
                case "zzz":
                    // Time zone offset with leading zero
                    hour = value.getTimezoneOffset() / 60;
                    ret.push((hour <= 0 ? "+" : "-") + padZeros(Math.floor(Math.abs(hour)), 2) + // Hard coded ":" separator, rather than using cal.TimeSeparator
                    // Repeated here for consistency, plus ":" was already assumed in date parsing.
                    ":" + padZeros(Math.abs(value.getTimezoneOffset() % 60), 2));
                    break;
                case "g":
                case "gg":
                    if (cal.eras) ret.push(cal.eras[getEra(value, eras)].name);
                    break;
                case "/":
                    ret.push(cal["/"]);
                    break;
                default:
                    throw "Invalid date format pattern '" + current + "'.";
            }
        }
        return ret.join("");
    };
    // formatNumber
    (function() {
        var expandNumber;
        expandNumber = function(number, precision, formatInfo) {
            var groupSizes = formatInfo.groupSizes, curSize = groupSizes[0], curGroupIndex = 1, factor = Math.pow(10, precision), rounded = Math.round(number * factor) / factor;
            if (!isFinite(rounded)) rounded = number;
            number = rounded;
            var numberString = number + "", right = "", split = numberString.split(/e/i), exponent = split.length > 1 ? parseInt(split[1], 10) : 0;
            numberString = split[0];
            split = numberString.split(".");
            numberString = split[0];
            right = split.length > 1 ? split[1] : "";
            var l;
            if (exponent > 0) {
                right = zeroPad(right, exponent, false);
                numberString += right.slice(0, exponent);
                right = right.substr(exponent);
            } else if (exponent < 0) {
                exponent = -exponent;
                numberString = zeroPad(numberString, exponent + 1, true);
                right = numberString.slice(-exponent, numberString.length) + right;
                numberString = numberString.slice(0, -exponent);
            }
            if (precision > 0) right = formatInfo["."] + (right.length > precision ? right.slice(0, precision) : zeroPad(right, precision));
            else right = "";
            var stringIndex = numberString.length - 1, sep = formatInfo[","], ret = "";
            while(stringIndex >= 0){
                if (curSize === 0 || curSize > stringIndex) return numberString.slice(0, stringIndex + 1) + (ret.length ? sep + ret + right : right);
                ret = numberString.slice(stringIndex - curSize + 1, stringIndex + 1) + (ret.length ? sep + ret : "");
                stringIndex -= curSize;
                if (curGroupIndex < groupSizes.length) {
                    curSize = groupSizes[curGroupIndex];
                    curGroupIndex++;
                }
            }
            return numberString.slice(0, stringIndex + 1) + sep + ret + right;
        };
        formatNumber = function(value, format, culture) {
            if (!isFinite(value)) {
                if (value === Infinity) return culture.numberFormat.positiveInfinity;
                if (value === -Infinity) return culture.numberFormat.negativeInfinity;
                return culture.numberFormat["NaN"];
            }
            if (!format || format === "i") return culture.name.length ? value.toLocaleString() : value.toString();
            format = format || "D";
            var nf = culture.numberFormat, number = Math.abs(value), precision = -1, pattern;
            if (format.length > 1) precision = parseInt(format.slice(1), 10);
            var current = format.charAt(0).toUpperCase(), formatInfo;
            switch(current){
                case "D":
                    pattern = "n";
                    number = truncate(number);
                    if (precision !== -1) number = zeroPad("" + number, precision, true);
                    if (value < 0) number = "-" + number;
                    break;
                case "N":
                    formatInfo = nf;
                /* falls through */ case "C":
                    formatInfo = formatInfo || nf.currency;
                /* falls through */ case "P":
                    formatInfo = formatInfo || nf.percent;
                    pattern = value < 0 ? formatInfo.pattern[0] : formatInfo.pattern[1] || "n";
                    if (precision === -1) precision = formatInfo.decimals;
                    number = expandNumber(number * (current === "P" ? 100 : 1), precision, formatInfo);
                    break;
                default:
                    throw "Bad number format specifier: " + current;
            }
            var patternParts = /n|\$|-|%/g, ret = "";
            for(;;){
                var index = patternParts.lastIndex, ar = patternParts.exec(pattern);
                ret += pattern.slice(index, ar ? ar.index : pattern.length);
                if (!ar) break;
                switch(ar[0]){
                    case "n":
                        ret += number;
                        break;
                    case "$":
                        ret += nf.currency.symbol;
                        break;
                    case "-":
                        // don't make 0 negative
                        if (/[1-9]/.test(number)) ret += nf["-"];
                        break;
                    case "%":
                        ret += nf.percent.symbol;
                        break;
                }
            }
            return ret;
        };
    })();
    getTokenRegExp = function() {
        // regular expression for matching date and time tokens in format strings.
        return /\/|dddd|ddd|dd|d|MMMM|MMM|MM|M|yyyy|yy|y|hh|h|HH|H|mm|m|ss|s|tt|t|fff|ff|f|zzz|zz|z|gg|g/g;
    };
    getEra = function(date, eras) {
        if (!eras) return 0;
        var start, ticks = date.getTime();
        for(var i = 0, l = eras.length; i < l; i++){
            start = eras[i].start;
            if (start === null || ticks >= start) return i;
        }
        return 0;
    };
    getEraYear = function(date, cal, era, sortable) {
        var year = date.getFullYear();
        if (!sortable && cal.eras) // convert normal gregorian year to era-shifted gregorian
        // year by subtracting the era offset
        year -= cal.eras[era].offset;
        return year;
    };
    // parseExact
    (function() {
        var expandYear, getDayIndex, getMonthIndex, getParseRegExp, outOfRange, toUpper, toUpperArray;
        expandYear = function(cal, year) {
            // expands 2-digit year into 4 digits.
            if (year < 100) {
                var now = new Date(), era = getEra(now), curr = getEraYear(now, cal, era), twoDigitYearMax = cal.twoDigitYearMax;
                twoDigitYearMax = typeof twoDigitYearMax === "string" ? new Date().getFullYear() % 100 + parseInt(twoDigitYearMax, 10) : twoDigitYearMax;
                year += curr - curr % 100;
                if (year > twoDigitYearMax) year -= 100;
            }
            return year;
        };
        getDayIndex = function(cal, value, abbr) {
            var ret, days = cal.days, upperDays = cal._upperDays;
            if (!upperDays) cal._upperDays = upperDays = [
                toUpperArray(days.names),
                toUpperArray(days.namesAbbr),
                toUpperArray(days.namesShort)
            ];
            value = toUpper(value);
            if (abbr) {
                ret = arrayIndexOf(upperDays[1], value);
                if (ret === -1) ret = arrayIndexOf(upperDays[2], value);
            } else ret = arrayIndexOf(upperDays[0], value);
            return ret;
        };
        getMonthIndex = function(cal, value, abbr) {
            var months = cal.months, monthsGen = cal.monthsGenitive || cal.months, upperMonths = cal._upperMonths, upperMonthsGen = cal._upperMonthsGen;
            if (!upperMonths) {
                cal._upperMonths = upperMonths = [
                    toUpperArray(months.names),
                    toUpperArray(months.namesAbbr)
                ];
                cal._upperMonthsGen = upperMonthsGen = [
                    toUpperArray(monthsGen.names),
                    toUpperArray(monthsGen.namesAbbr)
                ];
            }
            value = toUpper(value);
            var i = arrayIndexOf(abbr ? upperMonths[1] : upperMonths[0], value);
            if (i < 0) i = arrayIndexOf(abbr ? upperMonthsGen[1] : upperMonthsGen[0], value);
            return i;
        };
        getParseRegExp = function(cal, format) {
            // converts a format string into a regular expression with groups that
            // can be used to extract date fields from a date string.
            // check for a cached parse regex.
            var re = cal._parseRegExp;
            if (!re) cal._parseRegExp = re = {};
            else {
                var reFormat = re[format];
                if (reFormat) return reFormat;
            }
            // expand single digit formats, then escape regular expression characters.
            var expFormat = expandFormat(cal, format).replace(/([\^\$\.\*\+\?\|\[\]\(\)\{\}])/g, "\\\\$1"), regexp = [
                "^"
            ], groups = [], index = 0, quoteCount = 0, tokenRegExp = getTokenRegExp(), match;
            // iterate through each date token found.
            while((match = tokenRegExp.exec(expFormat)) !== null){
                var preMatch = expFormat.slice(index, match.index);
                index = tokenRegExp.lastIndex;
                // don't replace any matches that occur inside a string literal.
                quoteCount += appendPreOrPostMatch(preMatch, regexp);
                if (quoteCount % 2) {
                    regexp.push(match[0]);
                    continue;
                }
                // add a regex group for the token.
                var m = match[0], len = m.length, add;
                switch(m){
                    case "dddd":
                    case "ddd":
                    case "MMMM":
                    case "MMM":
                    case "gg":
                    case "g":
                        add = "(\\D+)";
                        break;
                    case "tt":
                    case "t":
                        add = "(\\D*)";
                        break;
                    case "yyyy":
                    case "fff":
                    case "ff":
                    case "f":
                        add = "(\\d{" + len + "})";
                        break;
                    case "dd":
                    case "d":
                    case "MM":
                    case "M":
                    case "yy":
                    case "y":
                    case "HH":
                    case "H":
                    case "hh":
                    case "h":
                    case "mm":
                    case "m":
                    case "ss":
                    case "s":
                        add = "(\\d\\d?)";
                        break;
                    case "zzz":
                        add = "([+-]?\\d\\d?:\\d{2})";
                        break;
                    case "zz":
                    case "z":
                        add = "([+-]?\\d\\d?)";
                        break;
                    case "/":
                        add = "(\\/)";
                        break;
                    default:
                        throw "Invalid date format pattern '" + m + "'.";
                }
                if (add) regexp.push(add);
                groups.push(match[0]);
            }
            appendPreOrPostMatch(expFormat.slice(index), regexp);
            regexp.push("$");
            // allow whitespace to differ when matching formats.
            var regexpStr = regexp.join("").replace(/\s+/g, "\\s+"), parseRegExp = {
                "regExp": regexpStr,
                "groups": groups
            };
            // cache the regex for this format.
            return re[format] = parseRegExp;
        };
        outOfRange = function(value, low, high) {
            return value < low || value > high;
        };
        toUpper = function(value) {
            // "he-IL" has non-breaking space in weekday names.
            return value.split("\xa0").join(" ").toUpperCase();
        };
        toUpperArray = function(arr) {
            var results = [];
            for(var i = 0, l = arr.length; i < l; i++)results[i] = toUpper(arr[i]);
            return results;
        };
        parseExact = function(value, format, culture) {
            // try to parse the date string by matching against the format string
            // while using the specified culture for date field names.
            value = trim(value);
            var cal = culture.calendar, // convert date formats into regular expressions with groupings.
            // use the regexp to determine the input format and extract the date fields.
            parseInfo = getParseRegExp(cal, format), match = new RegExp(parseInfo.regExp).exec(value);
            if (match === null) return null;
            // found a date format that matches the input.
            var groups = parseInfo.groups, era = null, year = null, month = null, date = null, weekDay = null, hour = 0, hourOffset, min = 0, sec = 0, msec = 0, tzMinOffset = null, pmHour = false;
            // iterate the format groups to extract and set the date fields.
            for(var j = 0, jl = groups.length; j < jl; j++){
                var matchGroup = match[j + 1];
                if (matchGroup) {
                    var current = groups[j], clength = current.length, matchInt = parseInt(matchGroup, 10);
                    switch(current){
                        case "dd":
                        case "d":
                            // Day of month.
                            date = matchInt;
                            // check that date is generally in valid range, also checking overflow below.
                            if (outOfRange(date, 1, 31)) return null;
                            break;
                        case "MMM":
                        case "MMMM":
                            month = getMonthIndex(cal, matchGroup, clength === 3);
                            if (outOfRange(month, 0, 11)) return null;
                            break;
                        case "M":
                        case "MM":
                            // Month.
                            month = matchInt - 1;
                            if (outOfRange(month, 0, 11)) return null;
                            break;
                        case "y":
                        case "yy":
                        case "yyyy":
                            year = clength < 4 ? expandYear(cal, matchInt) : matchInt;
                            if (outOfRange(year, 0, 9999)) return null;
                            break;
                        case "h":
                        case "hh":
                            // Hours (12-hour clock).
                            hour = matchInt;
                            if (hour === 12) hour = 0;
                            if (outOfRange(hour, 0, 11)) return null;
                            break;
                        case "H":
                        case "HH":
                            // Hours (24-hour clock).
                            hour = matchInt;
                            if (outOfRange(hour, 0, 23)) return null;
                            break;
                        case "m":
                        case "mm":
                            // Minutes.
                            min = matchInt;
                            if (outOfRange(min, 0, 59)) return null;
                            break;
                        case "s":
                        case "ss":
                            // Seconds.
                            sec = matchInt;
                            if (outOfRange(sec, 0, 59)) return null;
                            break;
                        case "tt":
                        case "t":
                            // AM/PM designator.
                            // see if it is standard, upper, or lower case PM. If not, ensure it is at least one of
                            // the AM tokens. If not, fail the parse for this format.
                            pmHour = cal.PM && (matchGroup === cal.PM[0] || matchGroup === cal.PM[1] || matchGroup === cal.PM[2]);
                            if (!pmHour && (!cal.AM || matchGroup !== cal.AM[0] && matchGroup !== cal.AM[1] && matchGroup !== cal.AM[2])) return null;
                            break;
                        case "f":
                        // Deciseconds.
                        case "ff":
                        // Centiseconds.
                        case "fff":
                            // Milliseconds.
                            msec = matchInt * Math.pow(10, 3 - clength);
                            if (outOfRange(msec, 0, 999)) return null;
                            break;
                        case "ddd":
                        // Day of week.
                        case "dddd":
                            // Day of week.
                            weekDay = getDayIndex(cal, matchGroup, clength === 3);
                            if (outOfRange(weekDay, 0, 6)) return null;
                            break;
                        case "zzz":
                            // Time zone offset in +/- hours:min.
                            var offsets = matchGroup.split(/:/);
                            if (offsets.length !== 2) return null;
                            hourOffset = parseInt(offsets[0], 10);
                            if (outOfRange(hourOffset, -12, 13)) return null;
                            var minOffset = parseInt(offsets[1], 10);
                            if (outOfRange(minOffset, 0, 59)) return null;
                            tzMinOffset = hourOffset * 60 + (startsWith(matchGroup, "-") ? -minOffset : minOffset);
                            break;
                        case "z":
                        case "zz":
                            // Time zone offset in +/- hours.
                            hourOffset = matchInt;
                            if (outOfRange(hourOffset, -12, 13)) return null;
                            tzMinOffset = hourOffset * 60;
                            break;
                        case "g":
                        case "gg":
                            var eraName = matchGroup;
                            if (!eraName || !cal.eras) return null;
                            eraName = trim(eraName.toLowerCase());
                            for(var i = 0, l = cal.eras.length; i < l; i++)if (eraName === cal.eras[i].name.toLowerCase()) {
                                era = i;
                                break;
                            }
                            // could not find an era with that name
                            if (era === null) return null;
                            break;
                    }
                }
            }
            var result = new Date(), defaultYear, convert = cal.convert;
            defaultYear = convert ? convert.fromGregorian(result)[0] : result.getFullYear();
            if (year === null) year = defaultYear;
            else if (cal.eras) // year must be shifted to normal gregorian year
            // but not if year was not specified, its already normal gregorian
            // per the main if clause above.
            year += cal.eras[era || 0].offset;
            // set default day and month to 1 and January, so if unspecified, these are the defaults
            // instead of the current day/month.
            if (month === null) month = 0;
            if (date === null) date = 1;
            // now have year, month, and date, but in the culture's calendar.
            // convert to gregorian if necessary
            if (convert) {
                result = convert.toGregorian(year, month, date);
                // conversion failed, must be an invalid match
                if (result === null) return null;
            } else {
                // have to set year, month and date together to avoid overflow based on current date.
                result.setFullYear(year, month, date);
                // check to see if date overflowed for specified month (only checked 1-31 above).
                if (result.getDate() !== date) return null;
                // invalid day of week.
                if (weekDay !== null && result.getDay() !== weekDay) return null;
            }
            // if pm designator token was found make sure the hours fit the 24-hour clock.
            if (pmHour && hour < 12) hour += 12;
            result.setHours(hour, min, sec, msec);
            if (tzMinOffset !== null) {
                // adjust timezone to utc before applying local offset.
                var adjustedMin = result.getMinutes() - (tzMinOffset + result.getTimezoneOffset());
                // Safari limits hours and minutes to the range of -127 to 127.  We need to use setHours
                // to ensure both these fields will not exceed this range.	adjustedMin will range
                // somewhere between -1440 and 1500, so we only need to split this into hours.
                result.setHours(result.getHours() + parseInt(adjustedMin / 60, 10), adjustedMin % 60);
            }
            return result;
        };
    })();
    parseNegativePattern = function(value, nf, negativePattern) {
        var neg = nf["-"], pos = nf["+"], ret;
        switch(negativePattern){
            case "n -":
                neg = " " + neg;
                pos = " " + pos;
            /* falls through */ case "n-":
                if (endsWith(value, neg)) ret = [
                    "-",
                    value.substr(0, value.length - neg.length)
                ];
                else if (endsWith(value, pos)) ret = [
                    "+",
                    value.substr(0, value.length - pos.length)
                ];
                break;
            case "- n":
                neg += " ";
                pos += " ";
            /* falls through */ case "-n":
                if (startsWith(value, neg)) ret = [
                    "-",
                    value.substr(neg.length)
                ];
                else if (startsWith(value, pos)) ret = [
                    "+",
                    value.substr(pos.length)
                ];
                break;
            case "(n)":
                if (startsWith(value, "(") && endsWith(value, ")")) ret = [
                    "-",
                    value.substr(1, value.length - 2)
                ];
                break;
        }
        return ret || [
            "",
            value
        ];
    };
    //
    // public instance functions
    //
    Globalize.prototype.findClosestCulture = function(cultureSelector) {
        return Globalize.findClosestCulture.call(this, cultureSelector);
    };
    Globalize.prototype.format = function(value, format, cultureSelector) {
        return Globalize.format.call(this, value, format, cultureSelector);
    };
    Globalize.prototype.localize = function(key, cultureSelector) {
        return Globalize.localize.call(this, key, cultureSelector);
    };
    Globalize.prototype.parseInt = function(value, radix, cultureSelector) {
        return Globalize.parseInt.call(this, value, radix, cultureSelector);
    };
    Globalize.prototype.parseFloat = function(value, radix, cultureSelector) {
        return Globalize.parseFloat.call(this, value, radix, cultureSelector);
    };
    Globalize.prototype.culture = function(cultureSelector) {
        return Globalize.culture.call(this, cultureSelector);
    };
    //
    // public singleton functions
    //
    Globalize.addCultureInfo = function(cultureName, baseCultureName, info) {
        var base = {}, isNew = false;
        if (typeof cultureName !== "string") {
            // cultureName argument is optional string. If not specified, assume info is first
            // and only argument. Specified info deep-extends current culture.
            info = cultureName;
            cultureName = this.culture().name;
            base = this.cultures[cultureName];
        } else if (typeof baseCultureName !== "string") {
            // baseCultureName argument is optional string. If not specified, assume info is second
            // argument. Specified info deep-extends specified culture.
            // If specified culture does not exist, create by deep-extending default
            info = baseCultureName;
            isNew = this.cultures[cultureName] == null;
            base = this.cultures[cultureName] || this.cultures["default"];
        } else {
            // cultureName and baseCultureName specified. Assume a new culture is being created
            // by deep-extending an specified base culture
            isNew = true;
            base = this.cultures[baseCultureName];
        }
        this.cultures[cultureName] = extend(true, {}, base, info);
        // Make the standard calendar the current culture if it's a new culture
        if (isNew) this.cultures[cultureName].calendar = this.cultures[cultureName].calendars.standard;
    };
    Globalize.findClosestCulture = function(name) {
        var match;
        if (!name) return this.findClosestCulture(this.cultureSelector) || this.cultures["default"];
        if (typeof name === "string") name = name.split(",");
        if (isArray(name)) {
            var lang, cultures = this.cultures, list = name, i, l = list.length, prioritized = [];
            for(i = 0; i < l; i++){
                name = trim(list[i]);
                var pri, parts = name.split(";");
                lang = trim(parts[0]);
                if (parts.length === 1) pri = 1;
                else {
                    name = trim(parts[1]);
                    if (name.indexOf("q=") === 0) {
                        name = name.substr(2);
                        pri = parseFloat(name);
                        pri = isNaN(pri) ? 0 : pri;
                    } else pri = 1;
                }
                prioritized.push({
                    lang: lang,
                    pri: pri
                });
            }
            prioritized.sort(function(a, b) {
                if (a.pri < b.pri) return 1;
                else if (a.pri > b.pri) return -1;
                return 0;
            });
            // exact match
            for(i = 0; i < l; i++){
                lang = prioritized[i].lang;
                match = cultures[lang];
                if (match) return match;
            }
            // neutral language match
            for(i = 0; i < l; i++){
                lang = prioritized[i].lang;
                do {
                    var index = lang.lastIndexOf("-");
                    if (index === -1) break;
                    // strip off the last part. e.g. en-US => en
                    lang = lang.substr(0, index);
                    match = cultures[lang];
                    if (match) return match;
                }while (1);
            }
            // last resort: match first culture using that language
            for(i = 0; i < l; i++){
                lang = prioritized[i].lang;
                for(var cultureKey in cultures){
                    var culture = cultures[cultureKey];
                    if (culture.language == lang) return culture;
                }
            }
        } else if (typeof name === "object") return name;
        return match || null;
    };
    Globalize.format = function(value, format, cultureSelector) {
        var culture = this.findClosestCulture(cultureSelector);
        if (value instanceof Date) value = formatDate(value, format, culture);
        else if (typeof value === "number") value = formatNumber(value, format, culture);
        return value;
    };
    Globalize.localize = function(key, cultureSelector) {
        return this.findClosestCulture(cultureSelector).messages[key] || this.cultures["default"].messages[key];
    };
    Globalize.parseDate = function(value, formats, culture) {
        culture = this.findClosestCulture(culture);
        var date, prop, patterns;
        if (formats) {
            if (typeof formats === "string") formats = [
                formats
            ];
            if (formats.length) for(var i = 0, l = formats.length; i < l; i++){
                var format = formats[i];
                if (format) {
                    date = parseExact(value, format, culture);
                    if (date) break;
                }
            }
        } else {
            patterns = culture.calendar.patterns;
            for(prop in patterns){
                date = parseExact(value, patterns[prop], culture);
                if (date) break;
            }
        }
        return date || null;
    };
    Globalize.parseInt = function(value, radix, cultureSelector) {
        return truncate(Globalize.parseFloat(value, radix, cultureSelector));
    };
    Globalize.parseFloat = function(value, radix, cultureSelector) {
        // radix argument is optional
        if (typeof radix !== "number") {
            cultureSelector = radix;
            radix = 10;
        }
        var culture = this.findClosestCulture(cultureSelector);
        var ret = NaN, nf = culture.numberFormat;
        if (value.indexOf(culture.numberFormat.currency.symbol) > -1) {
            // remove currency symbol
            value = value.replace(culture.numberFormat.currency.symbol, "");
            // replace decimal seperator
            value = value.replace(culture.numberFormat.currency["."], culture.numberFormat["."]);
        }
        //Remove percentage character from number string before parsing
        if (value.indexOf(culture.numberFormat.percent.symbol) > -1) value = value.replace(culture.numberFormat.percent.symbol, "");
        // remove spaces: leading, trailing and between - and number. Used for negative currency pt-BR
        value = value.replace(/ /g, "");
        // allow infinity or hexidecimal
        if (regexInfinity.test(value)) ret = parseFloat(value);
        else if (!radix && regexHex.test(value)) ret = parseInt(value, 16);
        else {
            // determine sign and number
            var signInfo = parseNegativePattern(value, nf, nf.pattern[0]), sign = signInfo[0], num = signInfo[1];
            // #44 - try parsing as "(n)"
            if (sign === "" && nf.pattern[0] !== "(n)") {
                signInfo = parseNegativePattern(value, nf, "(n)");
                sign = signInfo[0];
                num = signInfo[1];
            }
            // try parsing as "-n"
            if (sign === "" && nf.pattern[0] !== "-n") {
                signInfo = parseNegativePattern(value, nf, "-n");
                sign = signInfo[0];
                num = signInfo[1];
            }
            sign = sign || "+";
            // determine exponent and number
            var exponent, intAndFraction, exponentPos = num.indexOf("e");
            if (exponentPos < 0) exponentPos = num.indexOf("E");
            if (exponentPos < 0) {
                intAndFraction = num;
                exponent = null;
            } else {
                intAndFraction = num.substr(0, exponentPos);
                exponent = num.substr(exponentPos + 1);
            }
            // determine decimal position
            var integer, fraction, decSep = nf["."], decimalPos = intAndFraction.indexOf(decSep);
            if (decimalPos < 0) {
                integer = intAndFraction;
                fraction = null;
            } else {
                integer = intAndFraction.substr(0, decimalPos);
                fraction = intAndFraction.substr(decimalPos + decSep.length);
            }
            // handle groups (e.g. 1,000,000)
            var groupSep = nf[","];
            integer = integer.split(groupSep).join("");
            var altGroupSep = groupSep.replace(/\u00A0/g, " ");
            if (groupSep !== altGroupSep) integer = integer.split(altGroupSep).join("");
            // build a natively parsable number string
            var p = sign + integer;
            if (fraction !== null) p += "." + fraction;
            if (exponent !== null) {
                // exponent itself may have a number patternd
                var expSignInfo = parseNegativePattern(exponent, nf, "-n");
                p += "e" + (expSignInfo[0] || "+") + expSignInfo[1];
            }
            if (regexParseFloat.test(p)) ret = parseFloat(p);
        }
        return ret;
    };
    Globalize.culture = function(cultureSelector) {
        // setter
        if (typeof cultureSelector !== "undefined") this.cultureSelector = cultureSelector;
        // getter
        return this.findClosestCulture(cultureSelector) || this.cultures["default"];
    };
})(module.exports);

});

parcelRegister("6l4Jp", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $49d85fce820726db$var$globalizeLocalizers;

var $2MXkj = parcelRequire("2MXkj");
var $49d85fce820726db$var$_propTypes2 = $49d85fce820726db$var$_interopRequireDefault($2MXkj);

var $zY9w6 = parcelRequire("zY9w6");
var $49d85fce820726db$var$_configure2 = $49d85fce820726db$var$_interopRequireDefault($zY9w6);
function $49d85fce820726db$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $49d85fce820726db$var$endOfDecade(date) {
    date = new Date(date);
    date.setFullYear(date.getFullYear() + 10);
    date.setMilliseconds(date.getMilliseconds() - 1);
    return date;
}
function $49d85fce820726db$var$endOfCentury(date) {
    date = new Date(date);
    date.setFullYear(date.getFullYear() + 100);
    date.setMilliseconds(date.getMilliseconds() - 1);
    return date;
}
function $49d85fce820726db$var$globalizeLocalizers(globalize) {
    var localizers = globalize.locale && !globalize.cultures ? $49d85fce820726db$var$newGlobalize(globalize) : $49d85fce820726db$var$oldGlobalize(globalize);
    $49d85fce820726db$var$_configure2.default.setLocalizers(localizers);
    return localizers;
}
function $49d85fce820726db$var$newGlobalize(globalize) {
    var locale = function locale(culture) {
        return culture ? globalize(culture) : globalize;
    };
    var date = {
        formats: {
            date: {
                date: "short"
            },
            time: {
                time: "short"
            },
            default: {
                datetime: "medium"
            },
            header: "MMMM yyyy",
            footer: {
                date: "full"
            },
            weekday: "eeeeee",
            dayOfMonth: "dd",
            month: "MMM",
            year: "yyyy",
            decade: function decade(dt, culture, l) {
                return l.format(dt, l.formats.year, culture) + " - " + l.format($49d85fce820726db$var$endOfDecade(dt), l.formats.year, culture);
            },
            century: function century(dt, culture, l) {
                return l.format(dt, l.formats.year, culture) + " - " + l.format($49d85fce820726db$var$endOfCentury(dt), l.formats.year, culture);
            }
        },
        propType: $49d85fce820726db$var$_propTypes2.default.oneOfType([
            $49d85fce820726db$var$_propTypes2.default.string,
            $49d85fce820726db$var$_propTypes2.default.object,
            $49d85fce820726db$var$_propTypes2.default.func
        ]),
        firstOfWeek: function firstOfWeek(culture) {
            var date = new Date();
            //cldr-data doesn't seem to be zero based
            var localeDay = Math.max(parseInt(locale(culture).formatDate(date, {
                raw: "e"
            }), 10) - 1, 0);
            return Math.abs(date.getDay() - localeDay);
        },
        parse: function parse(value, format, culture) {
            format = typeof format === "string" ? {
                raw: format
            } : format;
            return locale(culture).parseDate(value, format);
        },
        format: function format(value, _format, culture) {
            _format = typeof _format === "string" ? {
                raw: _format
            } : _format;
            return locale(culture).formatDate(value, _format);
        }
    };
    var number = {
        formats: {
            default: {
                maximumFractionDigits: 0
            }
        },
        propType: $49d85fce820726db$var$_propTypes2.default.oneOfType([
            $49d85fce820726db$var$_propTypes2.default.object,
            $49d85fce820726db$var$_propTypes2.default.func
        ]),
        // TODO major bump consistent ordering
        parse: function parse(value, culture) {
            return locale(culture).parseNumber(value);
        },
        format: function format(value, _format2, culture) {
            if (value == null) return value;
            if (_format2 && _format2.currency) return locale(culture).formatCurrency(value, _format2.currency, _format2);
            return locale(culture).formatNumber(value, _format2);
        },
        decimalChar: function decimalChar(format, culture) {
            var str = this.format(1.1, {
                raw: "0.0"
            }, culture);
            return str[str.length - 2] || ".";
        },
        precision: function precision(format) {
            return !format || format.maximumFractionDigits == null ? null : format.maximumFractionDigits;
        }
    };
    return {
        date: date,
        number: number
    };
}
function $49d85fce820726db$var$oldGlobalize(globalize) {
    var shortNames = Object.create(null);
    function getCulture(culture) {
        return culture ? globalize.findClosestCulture(culture) : globalize.culture();
    }
    function firstOfWeek(culture) {
        culture = getCulture(culture);
        return culture && culture.calendar.firstDay || 0;
    }
    function shortDay(dayOfTheWeek) {
        var culture = getCulture(arguments[1]), name = culture.name, days = function days() {
            return culture.calendar.days.namesShort.slice();
        };
        var names = shortNames[name] || (shortNames[name] = days());
        return names[dayOfTheWeek.getDay()];
    }
    var date = {
        formats: {
            date: "d",
            time: "t",
            default: "f",
            header: "MMMM yyyy",
            footer: "D",
            weekday: shortDay,
            dayOfMonth: "dd",
            month: "MMM",
            year: "yyyy",
            decade: function decade(dt, culture, l) {
                return l.format(dt, l.formats.year, culture) + " - " + l.format($49d85fce820726db$var$endOfDecade(dt), l.formats.year, culture);
            },
            century: function century(dt, culture, l) {
                return l.format(dt, l.formats.year, culture) + " - " + l.format($49d85fce820726db$var$endOfCentury(dt), l.formats.year, culture);
            }
        },
        firstOfWeek: firstOfWeek,
        parse: function parse(value, format, culture) {
            return globalize.parseDate(value, format, culture);
        },
        format: function format(value, _format3, culture) {
            return globalize.format(value, _format3, culture);
        }
    };
    function formatData(format, _culture) {
        var culture = getCulture(_culture), numFormat = culture.numberFormat;
        if (typeof format === "string") {
            if (format.indexOf("p") !== -1) numFormat = numFormat.percent;
            if (format.indexOf("c") !== -1) numFormat = numFormat.curency;
        }
        return numFormat;
    }
    var number = {
        formats: {
            default: "D"
        },
        // TODO major bump consistent ordering
        parse: function parse(value, culture) {
            return globalize.parseFloat(value, 10, culture);
        },
        format: function format(value, _format4, culture) {
            return globalize.format(value, _format4, culture);
        },
        decimalChar: function decimalChar(format, culture) {
            var data = formatData(format, culture);
            return data["."] || ".";
        },
        precision: function precision(format, _culture) {
            var data = formatData(format, _culture);
            if (typeof format === "string" && format.length > 1) return parseFloat(format.substr(1));
            return data ? data.decimals : null;
        }
    };
    return {
        date: date,
        number: number
    };
}
module.exports = module.exports["default"];

});


parcelRegister("foLWS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b35e4a81c04da112$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $eat5C = parcelRequire("eat5C");

var $1EEMt = parcelRequire("1EEMt");
const $b35e4a81c04da112$var$TextInput = ({ value: value, onChange: onChange, onBlur: onBlur, isEditable: isEditable = true, isValid: isValid = true, nullReadOnlyValue: nullReadOnlyValue, style: style, formatter: formatter, parser: parser, ...props })=>{
    const errorStyles = {
        color: "#dc2d11",
        border: "2px solid #dc2d11"
    };
    const [inputValue, setInputValue] = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useState(formatter ? formatter(value) : value);
    const handleChange = (event)=>{
        setInputValue(event.target.value);
        const parsedVal = parser ? parser(event.target.value) : event.target.value;
        onChange && onChange(parsedVal);
    };
    const handleBlur = (event)=>{
        // Format the value when the input loses focus
        const parsedVal = parser ? parser(event.target.value) : event.target.value;
        const formattedValue = formatter ? formatter(parsedVal) : parsedVal;
        setInputValue(formattedValue);
        onBlur && onBlur(parsedVal);
    };
    const inputRef = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useRef(null);
    (0, $jbmdS.useEffect)(()=>{
        if ((inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === document.activeElement) return;
        setInputValue(formatter ? formatter(value) : value);
    }, [
        value
    ]);
    if (isEditable) return /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
        type: "text",
        className: "input-base",
        value: inputValue || "",
        style: {
            padding: "0.5rem",
            ...!isValid ? errorStyles : {},
            ...style
        },
        onChange: handleChange,
        onBlur: handleBlur,
        ref: inputRef,
        ...props
    });
    else {
        if (value == null && nullReadOnlyValue != null) {
            if ((0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).isString(nullReadOnlyValue)) return /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                style: {
                    ...style
                },
                children: nullReadOnlyValue
            });
            else return nullReadOnlyValue;
        } else return /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
            style: {
                ...style
            },
            children: inputValue
        });
    }
};
var $b35e4a81c04da112$export$2e2bcd8739ae039 = (0, $1EEMt.observer)($b35e4a81c04da112$var$TextInput);

});

parcelRegister("y5iig", function(module, exports) {

$parcel$export(module.exports, "HoursInput", function () { return $06674861655bc253$export$1f7201f597f5f219; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $02LyB = parcelRequire("02LyB");

var $e8Hda = parcelRequire("e8Hda");

var $2MXkj = parcelRequire("2MXkj");
const $06674861655bc253$export$1f7201f597f5f219 = ({ value: value, className: className, onChange: onChange, isEditable: isEditable = true, style: style })=>{
    const [val, setVal] = (0, $jbmdS.useState)(formatFunc(value));
    const [validTimeValue, setValidTimeValue] = (0, $jbmdS.useState)(value);
    const inputRef = (0, $jbmdS.useRef)(null);
    (0, $jbmdS.useEffect)(()=>{
        if (document.activeElement !== inputRef.current) setVal(formatFunc(value));
    }, [
        value
    ]);
    const handleChange = (event)=>{
        let text = event.target.value;
        setVal(text);
        let time = (0, $e8Hda.parseTime)(text) || 0;
        if (time != null) setValidTimeValue(time);
        onChange(time);
    };
    const handleBlur = ()=>{
        let [time, isValid] = parseFunc(val);
        if (isValid) setVal(formatFunc(time));
        else setVal(formatFunc(validTimeValue));
    };
    const handleFocus = ()=>{
        // Select the text box's contents on focus. For some reason if we don't
        // do this in a $timeout the contents are momentarily selected and then
        // deselected.
        setTimeout(()=>{
            let node = inputRef.current;
            if (node === document.activeElement) node.select();
        });
    };
    const handleKeyUp = (event)=>{
        let [currentVal, isValid] = parseFunc(val);
        if (isValid) {
            let newTime = null;
            if (event.keyCode === 38) // Up arrow: + 15 minutes
            newTime = currentVal + 15;
            else if (event.keyCode === 40) // Down arrow: - 15 minutes
            {
                if (currentVal >= 15) newTime = currentVal - 15;
            }
            if (newTime != null) {
                setVal(formatFunc(newTime));
                setValidTimeValue(newTime);
                onChange(newTime);
            }
        }
    };
    let [_, isValid] = parseFunc(val);
    if (isEditable) return /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
        ref: inputRef,
        type: "text",
        value: val || "",
        onKeyUp: handleKeyUp,
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(className, {
            classNameInvalid: !isValid
        }),
        disabled: !isEditable,
        style: {
            textAlign: "right",
            ...style
        }
    });
    else return /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
        children: val
    });
    function formatFunc(n) {
        return (0, $e8Hda.isNumber)(n) ? (0, $e8Hda.formatMinutes)(n) : n;
    }
    function parseFunc(text) {
        let time = (0, $e8Hda.parseTime)(text);
        return [
            time,
            time != null
        ];
    }
};
$06674861655bc253$export$1f7201f597f5f219.propTypes = {
    value: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).number,
        // Valid state
        (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).string // Invalid state
    ]).isRequired,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).any,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).func.isRequired,
    isEditable: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).bool,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).object
};

});

parcelRegister("eriOD", function(module, exports) {

$parcel$export(module.exports, "TimePicker", function () { return $264a3ec64606d496$export$5f876910ea565cd3; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $g4OKd = parcelRequire("g4OKd");

var $enJk6 = parcelRequire("enJk6");

var $uOjok = parcelRequire("uOjok");

var $95Evz = parcelRequire("95Evz");
"use client";
function $264a3ec64606d496$export$5f876910ea565cd3({ value: value, onChange: onChange, disabled: disabled, className: className }) {
    var _disabled;
    (_disabled = disabled) !== null && _disabled !== void 0 ? _disabled : disabled = false;
    const [period, setPeriod] = $jbmdS.useState((0, $uOjok.getPeriod)(value));
    const minuteRef = $jbmdS.useRef(null);
    const hourRef = $jbmdS.useRef(null);
    const periodRef = $jbmdS.useRef(null);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: (0, $95Evz.cn)("flex items-end gap-2", className),
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "grid gap-1 text-center",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $g4OKd.TimePickerInput), {
                    picker: "12hours",
                    period: period,
                    date: value,
                    setDate: onChange,
                    disabled: disabled,
                    ref: hourRef,
                    onRightFocus: ()=>{
                        var _minuteRef$current;
                        return (_minuteRef$current = minuteRef.current) === null || _minuteRef$current === void 0 ? void 0 : _minuteRef$current.focus();
                    }
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "grid gap-1 text-center",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $g4OKd.TimePickerInput), {
                    picker: "minutes",
                    id: "minutes12",
                    date: value,
                    setDate: onChange,
                    disabled: disabled,
                    ref: minuteRef,
                    onLeftFocus: ()=>{
                        var _hourRef$current;
                        return (_hourRef$current = hourRef.current) === null || _hourRef$current === void 0 ? void 0 : _hourRef$current.focus();
                    },
                    onRightFocus: ()=>{
                        var _periodRef$current;
                        return (_periodRef$current = periodRef.current) === null || _periodRef$current === void 0 ? void 0 : _periodRef$current.focus();
                    }
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "grid gap-1 text-center",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $enJk6.TimePeriodSelect), {
                    period: period,
                    setPeriod: setPeriod,
                    date: value,
                    setDate: onChange,
                    disabled: disabled,
                    ref: periodRef,
                    onLeftFocus: ()=>{
                        var _minuteRef$current2;
                        return (_minuteRef$current2 = minuteRef.current) === null || _minuteRef$current2 === void 0 ? void 0 : _minuteRef$current2.focus();
                    }
                })
            })
        ]
    });
}

});
parcelRegister("g4OKd", function(module, exports) {

$parcel$export(module.exports, "TimePickerInput", function () { return $98bc8f8d64e1c253$export$48da62ef549a4fb8; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $2YJBX = parcelRequire("2YJBX");

var $95Evz = parcelRequire("95Evz");

var $uOjok = parcelRequire("uOjok");
const $98bc8f8d64e1c253$export$48da62ef549a4fb8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).forwardRef(({ className: className, type: type = "tel", value: value, id: id, name: name, date: date = new Date(new Date().setHours(0, 0, 0, 0)), setDate: setDate, onChange: onChange, onKeyDown: onKeyDown, picker: picker, period: period, onLeftFocus: onLeftFocus, onRightFocus: onRightFocus, ...props }, ref)=>{
    const [flag, setFlag] = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useState(false);
    const [prevIntKey, setPrevIntKey] = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useState("0");
    /**
   * allow the user to enter the second digit within 2 seconds
   * otherwise start again with entering first digit
   */ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useEffect(()=>{
        if (flag) {
            const timer = setTimeout(()=>{
                setFlag(false);
            }, 2000);
            return ()=>clearTimeout(timer);
        }
    }, [
        flag
    ]);
    const calculatedValue = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useMemo(()=>{
        return (0, $uOjok.getDateByType)(date, picker);
    }, [
        date,
        picker
    ]);
    const calculateNewValue = (key)=>{
        /*
     * If picker is '12hours' and the first digit is 0, then the second digit is automatically set to 1.
     * The second entered digit will break the condition and the value will be set to 10-12.
     */ if (picker === "12hours") {
            if (flag && calculatedValue.slice(1, 2) === "1" && prevIntKey === "0") return "0" + key;
        }
        return !flag ? "0" + key : calculatedValue.slice(1, 2) + key;
    };
    const handleKeyDown = (e)=>{
        if (e.key === "Tab") return;
        e.preventDefault();
        if (e.key === "ArrowRight") onRightFocus === null || onRightFocus === void 0 || onRightFocus();
        if (e.key === "ArrowLeft") onLeftFocus === null || onLeftFocus === void 0 || onLeftFocus();
        if ([
            "ArrowUp",
            "ArrowDown"
        ].includes(e.key)) {
            const step = e.key === "ArrowUp" ? 1 : -1;
            const newValue = (0, $uOjok.getArrowByType)(calculatedValue, step, picker);
            if (flag) setFlag(false);
            const tempDate = new Date(date);
            setDate((0, $uOjok.setDateByType)(tempDate, newValue, picker, period));
        }
        if (e.key >= "0" && e.key <= "9") {
            if (picker === "12hours") setPrevIntKey(e.key);
            const newValue = calculateNewValue(e.key);
            if (flag) onRightFocus === null || onRightFocus === void 0 || onRightFocus();
            setFlag((prev)=>!prev);
            const tempDate = new Date(date);
            setDate((0, $uOjok.setDateByType)(tempDate, newValue, picker, period));
        }
    };
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $2YJBX.Input), {
        ref: ref,
        id: id || picker,
        name: name || picker,
        className: (0, $95Evz.cn)("w-[48px] text-center", className),
        value: value || calculatedValue,
        onChange: (e)=>{
            e.preventDefault();
            onChange === null || onChange === void 0 || onChange(e);
        },
        type: type,
        inputMode: "decimal",
        onKeyDown: (e)=>{
            onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
            handleKeyDown(e);
        },
        ...props
    });
});
$98bc8f8d64e1c253$export$48da62ef549a4fb8.displayName = "TimePickerInput";

});
parcelRegister("2YJBX", function(module, exports) {

$parcel$export(module.exports, "Input", function () { return $1c3b2cc93df65142$export$f5b8910cec6cf069; });
$parcel$export(module.exports, "InputWithLabel", function () { return $1c3b2cc93df65142$export$cc1ef317067e4e4b; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $Yha9m = parcelRequire("Yha9m");

var $5XMpG = parcelRequire("5XMpG");
const $1c3b2cc93df65142$export$f5b8910cec6cf069 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, type: type, suffix: suffix, prefix: prefix, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "relative flex items-center",
        children: [
            prefix && /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                className: "absolute left-0 text-sm text-muted-foreground",
                children: prefix
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
                type: type,
                className: (0, $Yha9m.cn)("flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50", suffix && "pr-10", className),
                ref: ref,
                ...props
            }),
            suffix && /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                className: "absolute right-3 text-sm text-muted-foreground",
                children: suffix
            })
        ]
    });
});
$1c3b2cc93df65142$export$f5b8910cec6cf069.displayName = "Input";
const $1c3b2cc93df65142$export$cc1ef317067e4e4b = /*#__PURE__*/ $jbmdS.forwardRef(({ label: label, containerClassName: containerClassName, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: (0, $Yha9m.cn)("flex flex-col", containerClassName),
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5XMpG.Label), {
                className: "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
                children: label
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)($1c3b2cc93df65142$export$f5b8910cec6cf069, {
                ref: ref,
                ...props
            })
        ]
    });
});
$1c3b2cc93df65142$export$cc1ef317067e4e4b.displayName = "InputWithLabel";

});
parcelRegister("Yha9m", function(module, exports) {

$parcel$export(module.exports, "cn", function () { return $15afba837b563160$export$1343a74baacb0543; });

var $dWgPS = parcelRequire("dWgPS");

var $k9bkX = parcelRequire("k9bkX");
function $15afba837b563160$export$1343a74baacb0543(...inputs) {
    return (0, $k9bkX.twMerge)((0, $dWgPS.clsx)(inputs));
}

});
parcelRegister("dWgPS", function(module, exports) {

$parcel$export(module.exports, "clsx", function () { return $01fcfd9607f279ba$export$4f5d2d50c9deca37; });
$parcel$export(module.exports, "default", function () { return $01fcfd9607f279ba$export$2e2bcd8739ae039; });
function $01fcfd9607f279ba$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $01fcfd9607f279ba$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $01fcfd9607f279ba$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $01fcfd9607f279ba$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $01fcfd9607f279ba$export$2e2bcd8739ae039 = $01fcfd9607f279ba$export$4f5d2d50c9deca37;

});

parcelRegister("k9bkX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: "Module"
});
const $eaad713b70a056bd$var$CLASS_PART_SEPARATOR = "-";
const $eaad713b70a056bd$var$createClassGroupUtils = (config)=>{
    const classMap = $eaad713b70a056bd$var$createClassMap(config);
    const { conflictingClassGroups: conflictingClassGroups, conflictingClassGroupModifiers: conflictingClassGroupModifiers } = config;
    const getClassGroupId = (className)=>{
        const classParts = className.split($eaad713b70a056bd$var$CLASS_PART_SEPARATOR);
        // Classes like `-inset-1` produce an empty string as first classPart. We assume that classes for negative values are used correctly and remove it from classParts.
        if (classParts[0] === "" && classParts.length !== 1) classParts.shift();
        return $eaad713b70a056bd$var$getGroupRecursive(classParts, classMap) || $eaad713b70a056bd$var$getGroupIdForArbitraryProperty(className);
    };
    const getConflictingClassGroupIds = (classGroupId, hasPostfixModifier)=>{
        const conflicts = conflictingClassGroups[classGroupId] || [];
        if (hasPostfixModifier && conflictingClassGroupModifiers[classGroupId]) return [
            ...conflicts,
            ...conflictingClassGroupModifiers[classGroupId]
        ];
        return conflicts;
    };
    return {
        getClassGroupId: getClassGroupId,
        getConflictingClassGroupIds: getConflictingClassGroupIds
    };
};
const $eaad713b70a056bd$var$getGroupRecursive = (classParts, classPartObject)=>{
    if (classParts.length === 0) return classPartObject.classGroupId;
    const currentClassPart = classParts[0];
    const nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
    const classGroupFromNextClassPart = nextClassPartObject ? $eaad713b70a056bd$var$getGroupRecursive(classParts.slice(1), nextClassPartObject) : undefined;
    if (classGroupFromNextClassPart) return classGroupFromNextClassPart;
    if (classPartObject.validators.length === 0) return undefined;
    const classRest = classParts.join($eaad713b70a056bd$var$CLASS_PART_SEPARATOR);
    return classPartObject.validators.find(({ validator: validator })=>validator(classRest))?.classGroupId;
};
const $eaad713b70a056bd$var$arbitraryPropertyRegex = /^\[(.+)\]$/;
const $eaad713b70a056bd$var$getGroupIdForArbitraryProperty = (className)=>{
    if ($eaad713b70a056bd$var$arbitraryPropertyRegex.test(className)) {
        const arbitraryPropertyClassName = $eaad713b70a056bd$var$arbitraryPropertyRegex.exec(className)[1];
        const property = arbitraryPropertyClassName?.substring(0, arbitraryPropertyClassName.indexOf(":"));
        if (property) // I use two dots here because one dot is used as prefix for class groups in plugins
        return "arbitrary.." + property;
    }
};
/**
 * Exported for testing only
 */ const $eaad713b70a056bd$var$createClassMap = (config)=>{
    const { theme: theme, prefix: prefix } = config;
    const classMap = {
        nextPart: new Map(),
        validators: []
    };
    const prefixedClassGroupEntries = $eaad713b70a056bd$var$getPrefixedClassGroupEntries(Object.entries(config.classGroups), prefix);
    prefixedClassGroupEntries.forEach(([classGroupId, classGroup])=>{
        $eaad713b70a056bd$var$processClassesRecursively(classGroup, classMap, classGroupId, theme);
    });
    return classMap;
};
const $eaad713b70a056bd$var$processClassesRecursively = (classGroup, classPartObject, classGroupId, theme)=>{
    classGroup.forEach((classDefinition)=>{
        if (typeof classDefinition === "string") {
            const classPartObjectToEdit = classDefinition === "" ? classPartObject : $eaad713b70a056bd$var$getPart(classPartObject, classDefinition);
            classPartObjectToEdit.classGroupId = classGroupId;
            return;
        }
        if (typeof classDefinition === "function") {
            if ($eaad713b70a056bd$var$isThemeGetter(classDefinition)) {
                $eaad713b70a056bd$var$processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
                return;
            }
            classPartObject.validators.push({
                validator: classDefinition,
                classGroupId: classGroupId
            });
            return;
        }
        Object.entries(classDefinition).forEach(([key, classGroup])=>{
            $eaad713b70a056bd$var$processClassesRecursively(classGroup, $eaad713b70a056bd$var$getPart(classPartObject, key), classGroupId, theme);
        });
    });
};
const $eaad713b70a056bd$var$getPart = (classPartObject, path)=>{
    let currentClassPartObject = classPartObject;
    path.split($eaad713b70a056bd$var$CLASS_PART_SEPARATOR).forEach((pathPart)=>{
        if (!currentClassPartObject.nextPart.has(pathPart)) currentClassPartObject.nextPart.set(pathPart, {
            nextPart: new Map(),
            validators: []
        });
        currentClassPartObject = currentClassPartObject.nextPart.get(pathPart);
    });
    return currentClassPartObject;
};
const $eaad713b70a056bd$var$isThemeGetter = (func)=>func.isThemeGetter;
const $eaad713b70a056bd$var$getPrefixedClassGroupEntries = (classGroupEntries, prefix)=>{
    if (!prefix) return classGroupEntries;
    return classGroupEntries.map(([classGroupId, classGroup])=>{
        const prefixedClassGroup = classGroup.map((classDefinition)=>{
            if (typeof classDefinition === "string") return prefix + classDefinition;
            if (typeof classDefinition === "object") return Object.fromEntries(Object.entries(classDefinition).map(([key, value])=>[
                    prefix + key,
                    value
                ]));
            return classDefinition;
        });
        return [
            classGroupId,
            prefixedClassGroup
        ];
    });
};
// LRU cache inspired from hashlru (https://github.com/dominictarr/hashlru/blob/v1.0.4/index.js) but object replaced with Map to improve performance
const $eaad713b70a056bd$var$createLruCache = (maxCacheSize)=>{
    if (maxCacheSize < 1) return {
        get: ()=>undefined,
        set: ()=>{}
    };
    let cacheSize = 0;
    let cache = new Map();
    let previousCache = new Map();
    const update = (key, value)=>{
        cache.set(key, value);
        cacheSize++;
        if (cacheSize > maxCacheSize) {
            cacheSize = 0;
            previousCache = cache;
            cache = new Map();
        }
    };
    return {
        get (key) {
            let value = cache.get(key);
            if (value !== undefined) return value;
            if ((value = previousCache.get(key)) !== undefined) {
                update(key, value);
                return value;
            }
        },
        set (key, value) {
            if (cache.has(key)) cache.set(key, value);
            else update(key, value);
        }
    };
};
const $eaad713b70a056bd$var$IMPORTANT_MODIFIER = "!";
const $eaad713b70a056bd$var$createParseClassName = (config)=>{
    const { separator: separator, experimentalParseClassName: experimentalParseClassName } = config;
    const isSeparatorSingleCharacter = separator.length === 1;
    const firstSeparatorCharacter = separator[0];
    const separatorLength = separator.length;
    // parseClassName inspired by https://github.com/tailwindlabs/tailwindcss/blob/v3.2.2/src/util/splitAtTopLevelOnly.js
    const parseClassName = (className)=>{
        const modifiers = [];
        let bracketDepth = 0;
        let modifierStart = 0;
        let postfixModifierPosition;
        for(let index = 0; index < className.length; index++){
            let currentCharacter = className[index];
            if (bracketDepth === 0) {
                if (currentCharacter === firstSeparatorCharacter && (isSeparatorSingleCharacter || className.slice(index, index + separatorLength) === separator)) {
                    modifiers.push(className.slice(modifierStart, index));
                    modifierStart = index + separatorLength;
                    continue;
                }
                if (currentCharacter === "/") {
                    postfixModifierPosition = index;
                    continue;
                }
            }
            if (currentCharacter === "[") bracketDepth++;
            else if (currentCharacter === "]") bracketDepth--;
        }
        const baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.substring(modifierStart);
        const hasImportantModifier = baseClassNameWithImportantModifier.startsWith($eaad713b70a056bd$var$IMPORTANT_MODIFIER);
        const baseClassName = hasImportantModifier ? baseClassNameWithImportantModifier.substring(1) : baseClassNameWithImportantModifier;
        const maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : undefined;
        return {
            modifiers: modifiers,
            hasImportantModifier: hasImportantModifier,
            baseClassName: baseClassName,
            maybePostfixModifierPosition: maybePostfixModifierPosition
        };
    };
    if (experimentalParseClassName) return (className)=>experimentalParseClassName({
            className: className,
            parseClassName: parseClassName
        });
    return parseClassName;
};
/**
 * Sorts modifiers according to following schema:
 * - Predefined modifiers are sorted alphabetically
 * - When an arbitrary variant appears, it must be preserved which modifiers are before and after it
 */ const $eaad713b70a056bd$var$sortModifiers = (modifiers)=>{
    if (modifiers.length <= 1) return modifiers;
    const sortedModifiers = [];
    let unsortedModifiers = [];
    modifiers.forEach((modifier)=>{
        const isArbitraryVariant = modifier[0] === "[";
        if (isArbitraryVariant) {
            sortedModifiers.push(...unsortedModifiers.sort(), modifier);
            unsortedModifiers = [];
        } else unsortedModifiers.push(modifier);
    });
    sortedModifiers.push(...unsortedModifiers.sort());
    return sortedModifiers;
};
const $eaad713b70a056bd$var$createConfigUtils = (config)=>({
        cache: $eaad713b70a056bd$var$createLruCache(config.cacheSize),
        parseClassName: $eaad713b70a056bd$var$createParseClassName(config),
        ...$eaad713b70a056bd$var$createClassGroupUtils(config)
    });
const $eaad713b70a056bd$var$SPLIT_CLASSES_REGEX = /\s+/;
const $eaad713b70a056bd$var$mergeClassList = (classList, configUtils)=>{
    const { parseClassName: parseClassName, getClassGroupId: getClassGroupId, getConflictingClassGroupIds: getConflictingClassGroupIds } = configUtils;
    /**
   * Set of classGroupIds in following format:
   * `{importantModifier}{variantModifiers}{classGroupId}`
   * @example 'float'
   * @example 'hover:focus:bg-color'
   * @example 'md:!pr'
   */ const classGroupsInConflict = [];
    const classNames = classList.trim().split($eaad713b70a056bd$var$SPLIT_CLASSES_REGEX);
    let result = "";
    for(let index = classNames.length - 1; index >= 0; index -= 1){
        const originalClassName = classNames[index];
        const { modifiers: modifiers, hasImportantModifier: hasImportantModifier, baseClassName: baseClassName, maybePostfixModifierPosition: maybePostfixModifierPosition } = parseClassName(originalClassName);
        let hasPostfixModifier = Boolean(maybePostfixModifierPosition);
        let classGroupId = getClassGroupId(hasPostfixModifier ? baseClassName.substring(0, maybePostfixModifierPosition) : baseClassName);
        if (!classGroupId) {
            if (!hasPostfixModifier) {
                // Not a Tailwind class
                result = originalClassName + (result.length > 0 ? " " + result : result);
                continue;
            }
            classGroupId = getClassGroupId(baseClassName);
            if (!classGroupId) {
                // Not a Tailwind class
                result = originalClassName + (result.length > 0 ? " " + result : result);
                continue;
            }
            hasPostfixModifier = false;
        }
        const variantModifier = $eaad713b70a056bd$var$sortModifiers(modifiers).join(":");
        const modifierId = hasImportantModifier ? variantModifier + $eaad713b70a056bd$var$IMPORTANT_MODIFIER : variantModifier;
        const classId = modifierId + classGroupId;
        if (classGroupsInConflict.includes(classId)) continue;
        classGroupsInConflict.push(classId);
        const conflictGroups = getConflictingClassGroupIds(classGroupId, hasPostfixModifier);
        for(let i = 0; i < conflictGroups.length; ++i){
            const group = conflictGroups[i];
            classGroupsInConflict.push(modifierId + group);
        }
        // Tailwind class not in conflict
        result = originalClassName + (result.length > 0 ? " " + result : result);
    }
    return result;
};
/**
 * The code in this file is copied from https://github.com/lukeed/clsx and modified to suit the needs of tailwind-merge better.
 *
 * Specifically:
 * - Runtime code from https://github.com/lukeed/clsx/blob/v1.2.1/src/index.js
 * - TypeScript types from https://github.com/lukeed/clsx/blob/v1.2.1/clsx.d.ts
 *
 * Original code has MIT license: Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)
 */ function $eaad713b70a056bd$var$twJoin() {
    let index = 0;
    let argument;
    let resolvedValue;
    let string = "";
    while(index < arguments.length){
        if (argument = arguments[index++]) {
            if (resolvedValue = $eaad713b70a056bd$var$toValue(argument)) {
                string && (string += " ");
                string += resolvedValue;
            }
        }
    }
    return string;
}
const $eaad713b70a056bd$var$toValue = (mix)=>{
    if (typeof mix === "string") return mix;
    let resolvedValue;
    let string = "";
    for(let k = 0; k < mix.length; k++){
        if (mix[k]) {
            if (resolvedValue = $eaad713b70a056bd$var$toValue(mix[k])) {
                string && (string += " ");
                string += resolvedValue;
            }
        }
    }
    return string;
};
function $eaad713b70a056bd$var$createTailwindMerge(createConfigFirst, ...createConfigRest) {
    let configUtils;
    let cacheGet;
    let cacheSet;
    let functionToCall = initTailwindMerge;
    function initTailwindMerge(classList) {
        const config = createConfigRest.reduce((previousConfig, createConfigCurrent)=>createConfigCurrent(previousConfig), createConfigFirst());
        configUtils = $eaad713b70a056bd$var$createConfigUtils(config);
        cacheGet = configUtils.cache.get;
        cacheSet = configUtils.cache.set;
        functionToCall = tailwindMerge;
        return tailwindMerge(classList);
    }
    function tailwindMerge(classList) {
        const cachedResult = cacheGet(classList);
        if (cachedResult) return cachedResult;
        const result = $eaad713b70a056bd$var$mergeClassList(classList, configUtils);
        cacheSet(classList, result);
        return result;
    }
    return function callTailwindMerge() {
        return functionToCall($eaad713b70a056bd$var$twJoin.apply(null, arguments));
    };
}
const $eaad713b70a056bd$var$fromTheme = (key)=>{
    const themeGetter = (theme)=>theme[key] || [];
    themeGetter.isThemeGetter = true;
    return themeGetter;
};
const $eaad713b70a056bd$var$arbitraryValueRegex = /^\[(?:([a-z-]+):)?(.+)\]$/i;
const $eaad713b70a056bd$var$fractionRegex = /^\d+\/\d+$/;
const $eaad713b70a056bd$var$stringLengths = /*#__PURE__*/ new Set([
    "px",
    "full",
    "screen"
]);
const $eaad713b70a056bd$var$tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
const $eaad713b70a056bd$var$lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
const $eaad713b70a056bd$var$colorFunctionRegex = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/;
// Shadow always begins with x and y offset separated by underscore optionally prepended by inset
const $eaad713b70a056bd$var$shadowRegex = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
const $eaad713b70a056bd$var$imageRegex = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
const $eaad713b70a056bd$var$isLength = (value)=>$eaad713b70a056bd$var$isNumber(value) || $eaad713b70a056bd$var$stringLengths.has(value) || $eaad713b70a056bd$var$fractionRegex.test(value);
const $eaad713b70a056bd$var$isArbitraryLength = (value)=>$eaad713b70a056bd$var$getIsArbitraryValue(value, "length", $eaad713b70a056bd$var$isLengthOnly);
const $eaad713b70a056bd$var$isNumber = (value)=>Boolean(value) && !Number.isNaN(Number(value));
const $eaad713b70a056bd$var$isArbitraryNumber = (value)=>$eaad713b70a056bd$var$getIsArbitraryValue(value, "number", $eaad713b70a056bd$var$isNumber);
const $eaad713b70a056bd$var$isInteger = (value)=>Boolean(value) && Number.isInteger(Number(value));
const $eaad713b70a056bd$var$isPercent = (value)=>value.endsWith("%") && $eaad713b70a056bd$var$isNumber(value.slice(0, -1));
const $eaad713b70a056bd$var$isArbitraryValue = (value)=>$eaad713b70a056bd$var$arbitraryValueRegex.test(value);
const $eaad713b70a056bd$var$isTshirtSize = (value)=>$eaad713b70a056bd$var$tshirtUnitRegex.test(value);
const $eaad713b70a056bd$var$sizeLabels = /*#__PURE__*/ new Set([
    "length",
    "size",
    "percentage"
]);
const $eaad713b70a056bd$var$isArbitrarySize = (value)=>$eaad713b70a056bd$var$getIsArbitraryValue(value, $eaad713b70a056bd$var$sizeLabels, $eaad713b70a056bd$var$isNever);
const $eaad713b70a056bd$var$isArbitraryPosition = (value)=>$eaad713b70a056bd$var$getIsArbitraryValue(value, "position", $eaad713b70a056bd$var$isNever);
const $eaad713b70a056bd$var$imageLabels = /*#__PURE__*/ new Set([
    "image",
    "url"
]);
const $eaad713b70a056bd$var$isArbitraryImage = (value)=>$eaad713b70a056bd$var$getIsArbitraryValue(value, $eaad713b70a056bd$var$imageLabels, $eaad713b70a056bd$var$isImage);
const $eaad713b70a056bd$var$isArbitraryShadow = (value)=>$eaad713b70a056bd$var$getIsArbitraryValue(value, "", $eaad713b70a056bd$var$isShadow);
const $eaad713b70a056bd$var$isAny = ()=>true;
const $eaad713b70a056bd$var$getIsArbitraryValue = (value, label, testValue)=>{
    const result = $eaad713b70a056bd$var$arbitraryValueRegex.exec(value);
    if (result) {
        if (result[1]) return typeof label === "string" ? result[1] === label : label.has(result[1]);
        return testValue(result[2]);
    }
    return false;
};
const $eaad713b70a056bd$var$isLengthOnly = (value)=>// `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
    // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
    // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
    $eaad713b70a056bd$var$lengthUnitRegex.test(value) && !$eaad713b70a056bd$var$colorFunctionRegex.test(value);
const $eaad713b70a056bd$var$isNever = ()=>false;
const $eaad713b70a056bd$var$isShadow = (value)=>$eaad713b70a056bd$var$shadowRegex.test(value);
const $eaad713b70a056bd$var$isImage = (value)=>$eaad713b70a056bd$var$imageRegex.test(value);
const $eaad713b70a056bd$var$validators = /*#__PURE__*/ Object.defineProperty({
    __proto__: null,
    isAny: $eaad713b70a056bd$var$isAny,
    isArbitraryImage: $eaad713b70a056bd$var$isArbitraryImage,
    isArbitraryLength: $eaad713b70a056bd$var$isArbitraryLength,
    isArbitraryNumber: $eaad713b70a056bd$var$isArbitraryNumber,
    isArbitraryPosition: $eaad713b70a056bd$var$isArbitraryPosition,
    isArbitraryShadow: $eaad713b70a056bd$var$isArbitraryShadow,
    isArbitrarySize: $eaad713b70a056bd$var$isArbitrarySize,
    isArbitraryValue: $eaad713b70a056bd$var$isArbitraryValue,
    isInteger: $eaad713b70a056bd$var$isInteger,
    isLength: $eaad713b70a056bd$var$isLength,
    isNumber: $eaad713b70a056bd$var$isNumber,
    isPercent: $eaad713b70a056bd$var$isPercent,
    isTshirtSize: $eaad713b70a056bd$var$isTshirtSize
}, Symbol.toStringTag, {
    value: "Module"
});
const $eaad713b70a056bd$var$getDefaultConfig = ()=>{
    const colors = $eaad713b70a056bd$var$fromTheme("colors");
    const spacing = $eaad713b70a056bd$var$fromTheme("spacing");
    const blur = $eaad713b70a056bd$var$fromTheme("blur");
    const brightness = $eaad713b70a056bd$var$fromTheme("brightness");
    const borderColor = $eaad713b70a056bd$var$fromTheme("borderColor");
    const borderRadius = $eaad713b70a056bd$var$fromTheme("borderRadius");
    const borderSpacing = $eaad713b70a056bd$var$fromTheme("borderSpacing");
    const borderWidth = $eaad713b70a056bd$var$fromTheme("borderWidth");
    const contrast = $eaad713b70a056bd$var$fromTheme("contrast");
    const grayscale = $eaad713b70a056bd$var$fromTheme("grayscale");
    const hueRotate = $eaad713b70a056bd$var$fromTheme("hueRotate");
    const invert = $eaad713b70a056bd$var$fromTheme("invert");
    const gap = $eaad713b70a056bd$var$fromTheme("gap");
    const gradientColorStops = $eaad713b70a056bd$var$fromTheme("gradientColorStops");
    const gradientColorStopPositions = $eaad713b70a056bd$var$fromTheme("gradientColorStopPositions");
    const inset = $eaad713b70a056bd$var$fromTheme("inset");
    const margin = $eaad713b70a056bd$var$fromTheme("margin");
    const opacity = $eaad713b70a056bd$var$fromTheme("opacity");
    const padding = $eaad713b70a056bd$var$fromTheme("padding");
    const saturate = $eaad713b70a056bd$var$fromTheme("saturate");
    const scale = $eaad713b70a056bd$var$fromTheme("scale");
    const sepia = $eaad713b70a056bd$var$fromTheme("sepia");
    const skew = $eaad713b70a056bd$var$fromTheme("skew");
    const space = $eaad713b70a056bd$var$fromTheme("space");
    const translate = $eaad713b70a056bd$var$fromTheme("translate");
    const getOverscroll = ()=>[
            "auto",
            "contain",
            "none"
        ];
    const getOverflow = ()=>[
            "auto",
            "hidden",
            "clip",
            "visible",
            "scroll"
        ];
    const getSpacingWithAutoAndArbitrary = ()=>[
            "auto",
            $eaad713b70a056bd$var$isArbitraryValue,
            spacing
        ];
    const getSpacingWithArbitrary = ()=>[
            $eaad713b70a056bd$var$isArbitraryValue,
            spacing
        ];
    const getLengthWithEmptyAndArbitrary = ()=>[
            "",
            $eaad713b70a056bd$var$isLength,
            $eaad713b70a056bd$var$isArbitraryLength
        ];
    const getNumberWithAutoAndArbitrary = ()=>[
            "auto",
            $eaad713b70a056bd$var$isNumber,
            $eaad713b70a056bd$var$isArbitraryValue
        ];
    const getPositions = ()=>[
            "bottom",
            "center",
            "left",
            "left-bottom",
            "left-top",
            "right",
            "right-bottom",
            "right-top",
            "top"
        ];
    const getLineStyles = ()=>[
            "solid",
            "dashed",
            "dotted",
            "double",
            "none"
        ];
    const getBlendModes = ()=>[
            "normal",
            "multiply",
            "screen",
            "overlay",
            "darken",
            "lighten",
            "color-dodge",
            "color-burn",
            "hard-light",
            "soft-light",
            "difference",
            "exclusion",
            "hue",
            "saturation",
            "color",
            "luminosity"
        ];
    const getAlign = ()=>[
            "start",
            "end",
            "center",
            "between",
            "around",
            "evenly",
            "stretch"
        ];
    const getZeroAndEmpty = ()=>[
            "",
            "0",
            $eaad713b70a056bd$var$isArbitraryValue
        ];
    const getBreaks = ()=>[
            "auto",
            "avoid",
            "all",
            "avoid-page",
            "page",
            "left",
            "right",
            "column"
        ];
    const getNumberAndArbitrary = ()=>[
            $eaad713b70a056bd$var$isNumber,
            $eaad713b70a056bd$var$isArbitraryValue
        ];
    return {
        cacheSize: 500,
        separator: ":",
        theme: {
            colors: [
                $eaad713b70a056bd$var$isAny
            ],
            spacing: [
                $eaad713b70a056bd$var$isLength,
                $eaad713b70a056bd$var$isArbitraryLength
            ],
            blur: [
                "none",
                "",
                $eaad713b70a056bd$var$isTshirtSize,
                $eaad713b70a056bd$var$isArbitraryValue
            ],
            brightness: getNumberAndArbitrary(),
            borderColor: [
                colors
            ],
            borderRadius: [
                "none",
                "",
                "full",
                $eaad713b70a056bd$var$isTshirtSize,
                $eaad713b70a056bd$var$isArbitraryValue
            ],
            borderSpacing: getSpacingWithArbitrary(),
            borderWidth: getLengthWithEmptyAndArbitrary(),
            contrast: getNumberAndArbitrary(),
            grayscale: getZeroAndEmpty(),
            hueRotate: getNumberAndArbitrary(),
            invert: getZeroAndEmpty(),
            gap: getSpacingWithArbitrary(),
            gradientColorStops: [
                colors
            ],
            gradientColorStopPositions: [
                $eaad713b70a056bd$var$isPercent,
                $eaad713b70a056bd$var$isArbitraryLength
            ],
            inset: getSpacingWithAutoAndArbitrary(),
            margin: getSpacingWithAutoAndArbitrary(),
            opacity: getNumberAndArbitrary(),
            padding: getSpacingWithArbitrary(),
            saturate: getNumberAndArbitrary(),
            scale: getNumberAndArbitrary(),
            sepia: getZeroAndEmpty(),
            skew: getNumberAndArbitrary(),
            space: getSpacingWithArbitrary(),
            translate: getSpacingWithArbitrary()
        },
        classGroups: {
            // Layout
            /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */ aspect: [
                {
                    aspect: [
                        "auto",
                        "square",
                        "video",
                        $eaad713b70a056bd$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */ container: [
                "container"
            ],
            /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */ columns: [
                {
                    columns: [
                        $eaad713b70a056bd$var$isTshirtSize
                    ]
                }
            ],
            /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */ "break-after": [
                {
                    "break-after": getBreaks()
                }
            ],
            /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */ "break-before": [
                {
                    "break-before": getBreaks()
                }
            ],
            /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */ "break-inside": [
                {
                    "break-inside": [
                        "auto",
                        "avoid",
                        "avoid-page",
                        "avoid-column"
                    ]
                }
            ],
            /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */ "box-decoration": [
                {
                    "box-decoration": [
                        "slice",
                        "clone"
                    ]
                }
            ],
            /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */ box: [
                {
                    box: [
                        "border",
                        "content"
                    ]
                }
            ],
            /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */ display: [
                "block",
                "inline-block",
                "inline",
                "flex",
                "inline-flex",
                "table",
                "inline-table",
                "table-caption",
                "table-cell",
                "table-column",
                "table-column-group",
                "table-footer-group",
                "table-header-group",
                "table-row-group",
                "table-row",
                "flow-root",
                "grid",
                "inline-grid",
                "contents",
                "list-item",
                "hidden"
            ],
            /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */ float: [
                {
                    float: [
                        "right",
                        "left",
                        "none",
                        "start",
                        "end"
                    ]
                }
            ],
            /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */ clear: [
                {
                    clear: [
                        "left",
                        "right",
                        "both",
                        "none",
                        "start",
                        "end"
                    ]
                }
            ],
            /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */ isolation: [
                "isolate",
                "isolation-auto"
            ],
            /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */ "object-fit": [
                {
                    object: [
                        "contain",
                        "cover",
                        "fill",
                        "none",
                        "scale-down"
                    ]
                }
            ],
            /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */ "object-position": [
                {
                    object: [
                        ...getPositions(),
                        $eaad713b70a056bd$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */ overflow: [
                {
                    overflow: getOverflow()
                }
            ],
            /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */ "overflow-x": [
                {
                    "overflow-x": getOverflow()
                }
            ],
            /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */ "overflow-y": [
                {
                    "overflow-y": getOverflow()
                }
            ],
            /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ overscroll: [
                {
                    overscroll: getOverscroll()
                }
            ],
            /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ "overscroll-x": [
                {
                    "overscroll-x": getOverscroll()
                }
            ],
            /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ "overscroll-y": [
                {
                    "overscroll-y": getOverscroll()
                }
            ],
            /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */ position: [
                "static",
                "fixed",
                "absolute",
                "relative",
                "sticky"
            ],
            /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ inset: [
                {
                    inset: [
                        inset
                    ]
                }
            ],
            /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ "inset-x": [
                {
                    "inset-x": [
                        inset
                    ]
                }
            ],
            /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ "inset-y": [
                {
                    "inset-y": [
                        inset
                    ]
                }
            ],
            /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ start: [
                {
                    start: [
                        inset
                    ]
                }
            ],
            /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ end: [
                {
                    end: [
                        inset
                    ]
                }
            ],
            /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ top: [
                {
                    top: [
                        inset
                    ]
                }
            ],
            /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ right: [
                {
                    right: [
                        inset
                    ]
                }
            ],
            /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ bottom: [
                {
                    bottom: [
                        inset
                    ]
                }
            ],
            /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ left: [
                {
                    left: [
                        inset
                    ]
                }
            ],
            /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */ visibility: [
                "visible",
                "invisible",
                "collapse"
            ],
            /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */ z: [
                {
                    z: [
                        "auto",
                        $eaad713b70a056bd$var$isInteger,
                        $eaad713b70a056bd$var$isArbitraryValue
                    ]
                }
            ],
            // Flexbox and Grid
            /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */ basis: [
                {
                    basis: getSpacingWithAutoAndArbitrary()
                }
            ],
            /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */ "flex-direction": [
                {
                    flex: [
                        "row",
                        "row-reverse",
                        "col",
                        "col-reverse"
                    ]
                }
            ],
            /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */ "flex-wrap": [
                {
                    flex: [
                        "wrap",
                        "wrap-reverse",
                        "nowrap"
                    ]
                }
            ],
            /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */ flex: [
                {
                    flex: [
                        "1",
                        "auto",
                        "initial",
                        "none",
                        $eaad713b70a056bd$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */ grow: [
                {
                    grow: getZeroAndEmpty()
                }
            ],
            /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */ shrink: [
                {
                    shrink: getZeroAndEmpty()
                }
            ],
            /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */ order: [
                {
                    order: [
                        "first",
                        "last",
                        "none",
                        $eaad713b70a056bd$var$isInteger,
                        $eaad713b70a056bd$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */ "grid-cols": [
                {
                    "grid-cols": [
                        $eaad713b70a056bd$var$isAny
                    ]
                }
            ],
            /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-start-end": [
                {
                    col: [
                        "auto",
                        {
                            span: [
                                "full",
                                $eaad713b70a056bd$var$isInteger,
                                $eaad713b70a056bd$var$isArbitraryValue
                            ]
                        },
                        $eaad713b70a056bd$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-start": [
                {
                    "col-start": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-end": [
                {
                    "col-end": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */ "grid-rows": [
                {
                    "grid-rows": [
                        $eaad713b70a056bd$var$isAny
                    ]
                }
            ],
            /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-start-end": [
                {
                    row: [
                        "auto",
                        {
                            span: [
                                $eaad713b70a056bd$var$isInteger,
                                $eaad713b70a056bd$var$isArbitraryValue
                            ]
                        },
                        $eaad713b70a056bd$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-start": [
                {
                    "row-start": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-end": [
                {
                    "row-end": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */ "grid-flow": [
                {
                    "grid-flow": [
                        "row",
                        "col",
                        "dense",
                        "row-dense",
                        "col-dense"
                    ]
                }
            ],
            /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */ "auto-cols": [
                {
                    "auto-cols": [
                        "auto",
                        "min",
                        "max",
                        "fr",
                        $eaad713b70a056bd$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */ "auto-rows": [
                {
                    "auto-rows": [
                        "auto",
                        "min",
                        "max",
                        "fr",
                        $eaad713b70a056bd$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */ gap: [
                {
                    gap: [
                        gap
                    ]
                }
            ],
            /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */ "gap-x": [
                {
                    "gap-x": [
                        gap
                    ]
                }
            ],
            /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */ "gap-y": [
                {
                    "gap-y": [
                        gap
                    ]
                }
            ],
            /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */ "justify-content": [
                {
                    justify: [
                        "normal",
                        ...getAlign()
                    ]
                }
            ],
            /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */ "justify-items": [
                {
                    "justify-items": [
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */ "justify-self": [
                {
                    "justify-self": [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */ "align-content": [
                {
                    content: [
                        "normal",
                        ...getAlign(),
                        "baseline"
                    ]
                }
            ],
            /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */ "align-items": [
                {
                    items: [
                        "start",
                        "end",
                        "center",
                        "baseline",
                        "stretch"
                    ]
                }
            ],
            /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */ "align-self": [
                {
                    self: [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch",
                        "baseline"
                    ]
                }
            ],
            /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */ "place-content": [
                {
                    "place-content": [
                        ...getAlign(),
                        "baseline"
                    ]
                }
            ],
            /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */ "place-items": [
                {
                    "place-items": [
                        "start",
                        "end",
                        "center",
                        "baseline",
                        "stretch"
                    ]
                }
            ],
            /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */ "place-self": [
                {
                    "place-self": [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            // Spacing
            /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */ p: [
                {
                    p: [
                        padding
                    ]
                }
            ],
            /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */ px: [
                {
                    px: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */ py: [
                {
                    py: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */ ps: [
                {
                    ps: [
                        padding
                    ]
                }
            ],
            /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */ pe: [
                {
                    pe: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */ pt: [
                {
                    pt: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */ pr: [
                {
                    pr: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */ pb: [
                {
                    pb: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */ pl: [
                {
                    pl: [
                        padding
                    ]
                }
            ],
            /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */ m: [
                {
                    m: [
                        margin
                    ]
                }
            ],
            /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */ mx: [
                {
                    mx: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */ my: [
                {
                    my: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */ ms: [
                {
                    ms: [
                        margin
                    ]
                }
            ],
            /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */ me: [
                {
                    me: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */ mt: [
                {
                    mt: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */ mr: [
                {
                    mr: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */ mb: [
                {
                    mb: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */ ml: [
                {
                    ml: [
                        margin
                    ]
                }
            ],
            /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */ "space-x": [
                {
                    "space-x": [
                        space
                    ]
                }
            ],
            /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */ "space-x-reverse": [
                "space-x-reverse"
            ],
            /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */ "space-y": [
                {
                    "space-y": [
                        space
                    ]
                }
            ],
            /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */ "space-y-reverse": [
                "space-y-reverse"
            ],
            // Sizing
            /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */ w: [
                {
                    w: [
                        "auto",
                        "min",
                        "max",
                        "fit",
                        "svw",
                        "lvw",
                        "dvw",
                        $eaad713b70a056bd$var$isArbitraryValue,
                        spacing
                    ]
                }
            ],
            /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */ "min-w": [
                {
                    "min-w": [
                        $eaad713b70a056bd$var$isArbitraryValue,
                        spacing,
                        "min",
                        "max",
                        "fit"
                    ]
                }
            ],
            /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */ "max-w": [
                {
                    "max-w": [
                        $eaad713b70a056bd$var$isArbitraryValue,
                        spacing,
                        "none",
                        "full",
                        "min",
                        "max",
                        "fit",
                        "prose",
                        {
                            screen: [
                                $eaad713b70a056bd$var$isTshirtSize
                            ]
                        },
                        $eaad713b70a056bd$var$isTshirtSize
                    ]
                }
            ],
            /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */ h: [
                {
                    h: [
                        $eaad713b70a056bd$var$isArbitraryValue,
                        spacing,
                        "auto",
                        "min",
                        "max",
                        "fit",
                        "svh",
                        "lvh",
                        "dvh"
                    ]
                }
            ],
            /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */ "min-h": [
                {
                    "min-h": [
                        $eaad713b70a056bd$var$isArbitraryValue,
                        spacing,
                        "min",
                        "max",
                        "fit",
                        "svh",
                        "lvh",
                        "dvh"
                    ]
                }
            ],
            /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */ "max-h": [
                {
                    "max-h": [
                        $eaad713b70a056bd$var$isArbitraryValue,
                        spacing,
                        "min",
                        "max",
                        "fit",
                        "svh",
                        "lvh",
                        "dvh"
                    ]
                }
            ],
            /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */ size: [
                {
                    size: [
                        $eaad713b70a056bd$var$isArbitraryValue,
                        spacing,
                        "auto",
                        "min",
                        "max",
                        "fit"
                    ]
                }
            ],
            // Typography
            /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */ "font-size": [
                {
                    text: [
                        "base",
                        $eaad713b70a056bd$var$isTshirtSize,
                        $eaad713b70a056bd$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */ "font-smoothing": [
                "antialiased",
                "subpixel-antialiased"
            ],
            /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */ "font-style": [
                "italic",
                "not-italic"
            ],
            /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */ "font-weight": [
                {
                    font: [
                        "thin",
                        "extralight",
                        "light",
                        "normal",
                        "medium",
                        "semibold",
                        "bold",
                        "extrabold",
                        "black",
                        $eaad713b70a056bd$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */ "font-family": [
                {
                    font: [
                        $eaad713b70a056bd$var$isAny
                    ]
                }
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-normal": [
                "normal-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-ordinal": [
                "ordinal"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-slashed-zero": [
                "slashed-zero"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-figure": [
                "lining-nums",
                "oldstyle-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-spacing": [
                "proportional-nums",
                "tabular-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-fraction": [
                "diagonal-fractions",
                "stacked-fractons"
            ],
            /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */ tracking: [
                {
                    tracking: [
                        "tighter",
                        "tight",
                        "normal",
                        "wide",
                        "wider",
                        "widest",
                        $eaad713b70a056bd$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */ "line-clamp": [
                {
                    "line-clamp": [
                        "none",
                        $eaad713b70a056bd$var$isNumber,
                        $eaad713b70a056bd$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */ leading: [
                {
                    leading: [
                        "none",
                        "tight",
                        "snug",
                        "normal",
                        "relaxed",
                        "loose",
                        $eaad713b70a056bd$var$isLength,
                        $eaad713b70a056bd$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */ "list-image": [
                {
                    "list-image": [
                        "none",
                        $eaad713b70a056bd$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */ "list-style-type": [
                {
                    list: [
                        "none",
                        "disc",
                        "decimal",
                        $eaad713b70a056bd$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */ "list-style-position": [
                {
                    list: [
                        "inside",
                        "outside"
                    ]
                }
            ],
            /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */ "placeholder-color": [
                {
                    placeholder: [
                        colors
                    ]
                }
            ],
            /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */ "placeholder-opacity": [
                {
                    "placeholder-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */ "text-alignment": [
                {
                    text: [
                        "left",
                        "center",
                        "right",
                        "justify",
                        "start",
                        "end"
                    ]
                }
            ],
            /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */ "text-color": [
                {
                    text: [
                        colors
                    ]
                }
            ],
            /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */ "text-opacity": [
                {
                    "text-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */ "text-decoration": [
                "underline",
                "overline",
                "line-through",
                "no-underline"
            ],
            /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */ "text-decoration-style": [
                {
                    decoration: [
                        ...getLineStyles(),
                        "wavy"
                    ]
                }
            ],
            /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */ "text-decoration-thickness": [
                {
                    decoration: [
                        "auto",
                        "from-font",
                        $eaad713b70a056bd$var$isLength,
                        $eaad713b70a056bd$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */ "underline-offset": [
                {
                    "underline-offset": [
                        "auto",
                        $eaad713b70a056bd$var$isLength,
                        $eaad713b70a056bd$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */ "text-decoration-color": [
                {
                    decoration: [
                        colors
                    ]
                }
            ],
            /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */ "text-transform": [
                "uppercase",
                "lowercase",
                "capitalize",
                "normal-case"
            ],
            /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */ "text-overflow": [
                "truncate",
                "text-ellipsis",
                "text-clip"
            ],
            /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */ "text-wrap": [
                {
                    text: [
                        "wrap",
                        "nowrap",
                        "balance",
                        "pretty"
                    ]
                }
            ],
            /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */ indent: [
                {
                    indent: getSpacingWithArbitrary()
                }
            ],
            /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */ "vertical-align": [
                {
                    align: [
                        "baseline",
                        "top",
                        "middle",
                        "bottom",
                        "text-top",
                        "text-bottom",
                        "sub",
                        "super",
                        $eaad713b70a056bd$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */ whitespace: [
                {
                    whitespace: [
                        "normal",
                        "nowrap",
                        "pre",
                        "pre-line",
                        "pre-wrap",
                        "break-spaces"
                    ]
                }
            ],
            /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */ break: [
                {
                    break: [
                        "normal",
                        "words",
                        "all",
                        "keep"
                    ]
                }
            ],
            /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */ hyphens: [
                {
                    hyphens: [
                        "none",
                        "manual",
                        "auto"
                    ]
                }
            ],
            /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */ content: [
                {
                    content: [
                        "none",
                        $eaad713b70a056bd$var$isArbitraryValue
                    ]
                }
            ],
            // Backgrounds
            /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */ "bg-attachment": [
                {
                    bg: [
                        "fixed",
                        "local",
                        "scroll"
                    ]
                }
            ],
            /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */ "bg-clip": [
                {
                    "bg-clip": [
                        "border",
                        "padding",
                        "content",
                        "text"
                    ]
                }
            ],
            /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */ "bg-opacity": [
                {
                    "bg-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */ "bg-origin": [
                {
                    "bg-origin": [
                        "border",
                        "padding",
                        "content"
                    ]
                }
            ],
            /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */ "bg-position": [
                {
                    bg: [
                        ...getPositions(),
                        $eaad713b70a056bd$var$isArbitraryPosition
                    ]
                }
            ],
            /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */ "bg-repeat": [
                {
                    bg: [
                        "no-repeat",
                        {
                            repeat: [
                                "",
                                "x",
                                "y",
                                "round",
                                "space"
                            ]
                        }
                    ]
                }
            ],
            /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */ "bg-size": [
                {
                    bg: [
                        "auto",
                        "cover",
                        "contain",
                        $eaad713b70a056bd$var$isArbitrarySize
                    ]
                }
            ],
            /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */ "bg-image": [
                {
                    bg: [
                        "none",
                        {
                            "gradient-to": [
                                "t",
                                "tr",
                                "r",
                                "br",
                                "b",
                                "bl",
                                "l",
                                "tl"
                            ]
                        },
                        $eaad713b70a056bd$var$isArbitraryImage
                    ]
                }
            ],
            /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */ "bg-color": [
                {
                    bg: [
                        colors
                    ]
                }
            ],
            /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-from-pos": [
                {
                    from: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-via-pos": [
                {
                    via: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-to-pos": [
                {
                    to: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-from": [
                {
                    from: [
                        gradientColorStops
                    ]
                }
            ],
            /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-via": [
                {
                    via: [
                        gradientColorStops
                    ]
                }
            ],
            /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-to": [
                {
                    to: [
                        gradientColorStops
                    ]
                }
            ],
            // Borders
            /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */ rounded: [
                {
                    rounded: [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-s": [
                {
                    "rounded-s": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-e": [
                {
                    "rounded-e": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-t": [
                {
                    "rounded-t": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-r": [
                {
                    "rounded-r": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-b": [
                {
                    "rounded-b": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-l": [
                {
                    "rounded-l": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-ss": [
                {
                    "rounded-ss": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-se": [
                {
                    "rounded-se": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-ee": [
                {
                    "rounded-ee": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-es": [
                {
                    "rounded-es": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-tl": [
                {
                    "rounded-tl": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-tr": [
                {
                    "rounded-tr": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-br": [
                {
                    "rounded-br": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-bl": [
                {
                    "rounded-bl": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w": [
                {
                    border: [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-x": [
                {
                    "border-x": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-y": [
                {
                    "border-y": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-s": [
                {
                    "border-s": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-e": [
                {
                    "border-e": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-t": [
                {
                    "border-t": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-r": [
                {
                    "border-r": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-b": [
                {
                    "border-b": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-l": [
                {
                    "border-l": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */ "border-opacity": [
                {
                    "border-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */ "border-style": [
                {
                    border: [
                        ...getLineStyles(),
                        "hidden"
                    ]
                }
            ],
            /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-x": [
                {
                    "divide-x": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-x-reverse": [
                "divide-x-reverse"
            ],
            /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-y": [
                {
                    "divide-y": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-y-reverse": [
                "divide-y-reverse"
            ],
            /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */ "divide-opacity": [
                {
                    "divide-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */ "divide-style": [
                {
                    divide: getLineStyles()
                }
            ],
            /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color": [
                {
                    border: [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-x": [
                {
                    "border-x": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-y": [
                {
                    "border-y": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-s": [
                {
                    "border-s": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-e": [
                {
                    "border-e": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-t": [
                {
                    "border-t": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-r": [
                {
                    "border-r": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-b": [
                {
                    "border-b": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-l": [
                {
                    "border-l": [
                        borderColor
                    ]
                }
            ],
            /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */ "divide-color": [
                {
                    divide: [
                        borderColor
                    ]
                }
            ],
            /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */ "outline-style": [
                {
                    outline: [
                        "",
                        ...getLineStyles()
                    ]
                }
            ],
            /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */ "outline-offset": [
                {
                    "outline-offset": [
                        $eaad713b70a056bd$var$isLength,
                        $eaad713b70a056bd$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */ "outline-w": [
                {
                    outline: [
                        $eaad713b70a056bd$var$isLength,
                        $eaad713b70a056bd$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */ "outline-color": [
                {
                    outline: [
                        colors
                    ]
                }
            ],
            /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */ "ring-w": [
                {
                    ring: getLengthWithEmptyAndArbitrary()
                }
            ],
            /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */ "ring-w-inset": [
                "ring-inset"
            ],
            /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */ "ring-color": [
                {
                    ring: [
                        colors
                    ]
                }
            ],
            /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */ "ring-opacity": [
                {
                    "ring-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */ "ring-offset-w": [
                {
                    "ring-offset": [
                        $eaad713b70a056bd$var$isLength,
                        $eaad713b70a056bd$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */ "ring-offset-color": [
                {
                    "ring-offset": [
                        colors
                    ]
                }
            ],
            // Effects
            /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */ shadow: [
                {
                    shadow: [
                        "",
                        "inner",
                        "none",
                        $eaad713b70a056bd$var$isTshirtSize,
                        $eaad713b70a056bd$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */ "shadow-color": [
                {
                    shadow: [
                        $eaad713b70a056bd$var$isAny
                    ]
                }
            ],
            /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */ opacity: [
                {
                    opacity: [
                        opacity
                    ]
                }
            ],
            /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */ "mix-blend": [
                {
                    "mix-blend": [
                        ...getBlendModes(),
                        "plus-lighter",
                        "plus-darker"
                    ]
                }
            ],
            /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */ "bg-blend": [
                {
                    "bg-blend": getBlendModes()
                }
            ],
            // Filters
            /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */ filter: [
                {
                    filter: [
                        "",
                        "none"
                    ]
                }
            ],
            /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */ blur: [
                {
                    blur: [
                        blur
                    ]
                }
            ],
            /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */ brightness: [
                {
                    brightness: [
                        brightness
                    ]
                }
            ],
            /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */ contrast: [
                {
                    contrast: [
                        contrast
                    ]
                }
            ],
            /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */ "drop-shadow": [
                {
                    "drop-shadow": [
                        "",
                        "none",
                        $eaad713b70a056bd$var$isTshirtSize,
                        $eaad713b70a056bd$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */ grayscale: [
                {
                    grayscale: [
                        grayscale
                    ]
                }
            ],
            /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */ "hue-rotate": [
                {
                    "hue-rotate": [
                        hueRotate
                    ]
                }
            ],
            /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */ invert: [
                {
                    invert: [
                        invert
                    ]
                }
            ],
            /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */ saturate: [
                {
                    saturate: [
                        saturate
                    ]
                }
            ],
            /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */ sepia: [
                {
                    sepia: [
                        sepia
                    ]
                }
            ],
            /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */ "backdrop-filter": [
                {
                    "backdrop-filter": [
                        "",
                        "none"
                    ]
                }
            ],
            /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */ "backdrop-blur": [
                {
                    "backdrop-blur": [
                        blur
                    ]
                }
            ],
            /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */ "backdrop-brightness": [
                {
                    "backdrop-brightness": [
                        brightness
                    ]
                }
            ],
            /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */ "backdrop-contrast": [
                {
                    "backdrop-contrast": [
                        contrast
                    ]
                }
            ],
            /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */ "backdrop-grayscale": [
                {
                    "backdrop-grayscale": [
                        grayscale
                    ]
                }
            ],
            /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */ "backdrop-hue-rotate": [
                {
                    "backdrop-hue-rotate": [
                        hueRotate
                    ]
                }
            ],
            /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */ "backdrop-invert": [
                {
                    "backdrop-invert": [
                        invert
                    ]
                }
            ],
            /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */ "backdrop-opacity": [
                {
                    "backdrop-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */ "backdrop-saturate": [
                {
                    "backdrop-saturate": [
                        saturate
                    ]
                }
            ],
            /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */ "backdrop-sepia": [
                {
                    "backdrop-sepia": [
                        sepia
                    ]
                }
            ],
            // Tables
            /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */ "border-collapse": [
                {
                    border: [
                        "collapse",
                        "separate"
                    ]
                }
            ],
            /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing": [
                {
                    "border-spacing": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing-x": [
                {
                    "border-spacing-x": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing-y": [
                {
                    "border-spacing-y": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */ "table-layout": [
                {
                    table: [
                        "auto",
                        "fixed"
                    ]
                }
            ],
            /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */ caption: [
                {
                    caption: [
                        "top",
                        "bottom"
                    ]
                }
            ],
            // Transitions and Animation
            /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */ transition: [
                {
                    transition: [
                        "none",
                        "all",
                        "",
                        "colors",
                        "opacity",
                        "shadow",
                        "transform",
                        $eaad713b70a056bd$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */ duration: [
                {
                    duration: getNumberAndArbitrary()
                }
            ],
            /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */ ease: [
                {
                    ease: [
                        "linear",
                        "in",
                        "out",
                        "in-out",
                        $eaad713b70a056bd$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */ delay: [
                {
                    delay: getNumberAndArbitrary()
                }
            ],
            /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */ animate: [
                {
                    animate: [
                        "none",
                        "spin",
                        "ping",
                        "pulse",
                        "bounce",
                        $eaad713b70a056bd$var$isArbitraryValue
                    ]
                }
            ],
            // Transforms
            /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */ transform: [
                {
                    transform: [
                        "",
                        "gpu",
                        "none"
                    ]
                }
            ],
            /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */ scale: [
                {
                    scale: [
                        scale
                    ]
                }
            ],
            /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */ "scale-x": [
                {
                    "scale-x": [
                        scale
                    ]
                }
            ],
            /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */ "scale-y": [
                {
                    "scale-y": [
                        scale
                    ]
                }
            ],
            /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */ rotate: [
                {
                    rotate: [
                        $eaad713b70a056bd$var$isInteger,
                        $eaad713b70a056bd$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */ "translate-x": [
                {
                    "translate-x": [
                        translate
                    ]
                }
            ],
            /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */ "translate-y": [
                {
                    "translate-y": [
                        translate
                    ]
                }
            ],
            /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */ "skew-x": [
                {
                    "skew-x": [
                        skew
                    ]
                }
            ],
            /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */ "skew-y": [
                {
                    "skew-y": [
                        skew
                    ]
                }
            ],
            /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */ "transform-origin": [
                {
                    origin: [
                        "center",
                        "top",
                        "top-right",
                        "right",
                        "bottom-right",
                        "bottom",
                        "bottom-left",
                        "left",
                        "top-left",
                        $eaad713b70a056bd$var$isArbitraryValue
                    ]
                }
            ],
            // Interactivity
            /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */ accent: [
                {
                    accent: [
                        "auto",
                        colors
                    ]
                }
            ],
            /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */ appearance: [
                {
                    appearance: [
                        "none",
                        "auto"
                    ]
                }
            ],
            /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */ cursor: [
                {
                    cursor: [
                        "auto",
                        "default",
                        "pointer",
                        "wait",
                        "text",
                        "move",
                        "help",
                        "not-allowed",
                        "none",
                        "context-menu",
                        "progress",
                        "cell",
                        "crosshair",
                        "vertical-text",
                        "alias",
                        "copy",
                        "no-drop",
                        "grab",
                        "grabbing",
                        "all-scroll",
                        "col-resize",
                        "row-resize",
                        "n-resize",
                        "e-resize",
                        "s-resize",
                        "w-resize",
                        "ne-resize",
                        "nw-resize",
                        "se-resize",
                        "sw-resize",
                        "ew-resize",
                        "ns-resize",
                        "nesw-resize",
                        "nwse-resize",
                        "zoom-in",
                        "zoom-out",
                        $eaad713b70a056bd$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */ "caret-color": [
                {
                    caret: [
                        colors
                    ]
                }
            ],
            /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */ "pointer-events": [
                {
                    "pointer-events": [
                        "none",
                        "auto"
                    ]
                }
            ],
            /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */ resize: [
                {
                    resize: [
                        "none",
                        "y",
                        "x",
                        ""
                    ]
                }
            ],
            /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */ "scroll-behavior": [
                {
                    scroll: [
                        "auto",
                        "smooth"
                    ]
                }
            ],
            /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-m": [
                {
                    "scroll-m": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mx": [
                {
                    "scroll-mx": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-my": [
                {
                    "scroll-my": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-ms": [
                {
                    "scroll-ms": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-me": [
                {
                    "scroll-me": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mt": [
                {
                    "scroll-mt": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mr": [
                {
                    "scroll-mr": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mb": [
                {
                    "scroll-mb": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-ml": [
                {
                    "scroll-ml": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-p": [
                {
                    "scroll-p": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-px": [
                {
                    "scroll-px": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-py": [
                {
                    "scroll-py": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-ps": [
                {
                    "scroll-ps": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pe": [
                {
                    "scroll-pe": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pt": [
                {
                    "scroll-pt": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pr": [
                {
                    "scroll-pr": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pb": [
                {
                    "scroll-pb": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pl": [
                {
                    "scroll-pl": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */ "snap-align": [
                {
                    snap: [
                        "start",
                        "end",
                        "center",
                        "align-none"
                    ]
                }
            ],
            /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */ "snap-stop": [
                {
                    snap: [
                        "normal",
                        "always"
                    ]
                }
            ],
            /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ "snap-type": [
                {
                    snap: [
                        "none",
                        "x",
                        "y",
                        "both"
                    ]
                }
            ],
            /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ "snap-strictness": [
                {
                    snap: [
                        "mandatory",
                        "proximity"
                    ]
                }
            ],
            /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */ touch: [
                {
                    touch: [
                        "auto",
                        "none",
                        "manipulation"
                    ]
                }
            ],
            /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */ "touch-x": [
                {
                    "touch-pan": [
                        "x",
                        "left",
                        "right"
                    ]
                }
            ],
            /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */ "touch-y": [
                {
                    "touch-pan": [
                        "y",
                        "up",
                        "down"
                    ]
                }
            ],
            /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */ "touch-pz": [
                "touch-pinch-zoom"
            ],
            /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */ select: [
                {
                    select: [
                        "none",
                        "text",
                        "all",
                        "auto"
                    ]
                }
            ],
            /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */ "will-change": [
                {
                    "will-change": [
                        "auto",
                        "scroll",
                        "contents",
                        "transform",
                        $eaad713b70a056bd$var$isArbitraryValue
                    ]
                }
            ],
            // SVG
            /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */ fill: [
                {
                    fill: [
                        colors,
                        "none"
                    ]
                }
            ],
            /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */ "stroke-w": [
                {
                    stroke: [
                        $eaad713b70a056bd$var$isLength,
                        $eaad713b70a056bd$var$isArbitraryLength,
                        $eaad713b70a056bd$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */ stroke: [
                {
                    stroke: [
                        colors,
                        "none"
                    ]
                }
            ],
            // Accessibility
            /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */ sr: [
                "sr-only",
                "not-sr-only"
            ],
            /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */ "forced-color-adjust": [
                {
                    "forced-color-adjust": [
                        "auto",
                        "none"
                    ]
                }
            ]
        },
        conflictingClassGroups: {
            overflow: [
                "overflow-x",
                "overflow-y"
            ],
            overscroll: [
                "overscroll-x",
                "overscroll-y"
            ],
            inset: [
                "inset-x",
                "inset-y",
                "start",
                "end",
                "top",
                "right",
                "bottom",
                "left"
            ],
            "inset-x": [
                "right",
                "left"
            ],
            "inset-y": [
                "top",
                "bottom"
            ],
            flex: [
                "basis",
                "grow",
                "shrink"
            ],
            gap: [
                "gap-x",
                "gap-y"
            ],
            p: [
                "px",
                "py",
                "ps",
                "pe",
                "pt",
                "pr",
                "pb",
                "pl"
            ],
            px: [
                "pr",
                "pl"
            ],
            py: [
                "pt",
                "pb"
            ],
            m: [
                "mx",
                "my",
                "ms",
                "me",
                "mt",
                "mr",
                "mb",
                "ml"
            ],
            mx: [
                "mr",
                "ml"
            ],
            my: [
                "mt",
                "mb"
            ],
            size: [
                "w",
                "h"
            ],
            "font-size": [
                "leading"
            ],
            "fvn-normal": [
                "fvn-ordinal",
                "fvn-slashed-zero",
                "fvn-figure",
                "fvn-spacing",
                "fvn-fraction"
            ],
            "fvn-ordinal": [
                "fvn-normal"
            ],
            "fvn-slashed-zero": [
                "fvn-normal"
            ],
            "fvn-figure": [
                "fvn-normal"
            ],
            "fvn-spacing": [
                "fvn-normal"
            ],
            "fvn-fraction": [
                "fvn-normal"
            ],
            "line-clamp": [
                "display",
                "overflow"
            ],
            rounded: [
                "rounded-s",
                "rounded-e",
                "rounded-t",
                "rounded-r",
                "rounded-b",
                "rounded-l",
                "rounded-ss",
                "rounded-se",
                "rounded-ee",
                "rounded-es",
                "rounded-tl",
                "rounded-tr",
                "rounded-br",
                "rounded-bl"
            ],
            "rounded-s": [
                "rounded-ss",
                "rounded-es"
            ],
            "rounded-e": [
                "rounded-se",
                "rounded-ee"
            ],
            "rounded-t": [
                "rounded-tl",
                "rounded-tr"
            ],
            "rounded-r": [
                "rounded-tr",
                "rounded-br"
            ],
            "rounded-b": [
                "rounded-br",
                "rounded-bl"
            ],
            "rounded-l": [
                "rounded-tl",
                "rounded-bl"
            ],
            "border-spacing": [
                "border-spacing-x",
                "border-spacing-y"
            ],
            "border-w": [
                "border-w-s",
                "border-w-e",
                "border-w-t",
                "border-w-r",
                "border-w-b",
                "border-w-l"
            ],
            "border-w-x": [
                "border-w-r",
                "border-w-l"
            ],
            "border-w-y": [
                "border-w-t",
                "border-w-b"
            ],
            "border-color": [
                "border-color-s",
                "border-color-e",
                "border-color-t",
                "border-color-r",
                "border-color-b",
                "border-color-l"
            ],
            "border-color-x": [
                "border-color-r",
                "border-color-l"
            ],
            "border-color-y": [
                "border-color-t",
                "border-color-b"
            ],
            "scroll-m": [
                "scroll-mx",
                "scroll-my",
                "scroll-ms",
                "scroll-me",
                "scroll-mt",
                "scroll-mr",
                "scroll-mb",
                "scroll-ml"
            ],
            "scroll-mx": [
                "scroll-mr",
                "scroll-ml"
            ],
            "scroll-my": [
                "scroll-mt",
                "scroll-mb"
            ],
            "scroll-p": [
                "scroll-px",
                "scroll-py",
                "scroll-ps",
                "scroll-pe",
                "scroll-pt",
                "scroll-pr",
                "scroll-pb",
                "scroll-pl"
            ],
            "scroll-px": [
                "scroll-pr",
                "scroll-pl"
            ],
            "scroll-py": [
                "scroll-pt",
                "scroll-pb"
            ],
            touch: [
                "touch-x",
                "touch-y",
                "touch-pz"
            ],
            "touch-x": [
                "touch"
            ],
            "touch-y": [
                "touch"
            ],
            "touch-pz": [
                "touch"
            ]
        },
        conflictingClassGroupModifiers: {
            "font-size": [
                "leading"
            ]
        }
    };
};
/**
 * @param baseConfig Config where other config will be merged into. This object will be mutated.
 * @param configExtension Partial config to merge into the `baseConfig`.
 */ const $eaad713b70a056bd$var$mergeConfigs = (baseConfig, { cacheSize: cacheSize, prefix: prefix, separator: separator, experimentalParseClassName: experimentalParseClassName, extend: extend = {}, override: override = {} })=>{
    $eaad713b70a056bd$var$overrideProperty(baseConfig, "cacheSize", cacheSize);
    $eaad713b70a056bd$var$overrideProperty(baseConfig, "prefix", prefix);
    $eaad713b70a056bd$var$overrideProperty(baseConfig, "separator", separator);
    $eaad713b70a056bd$var$overrideProperty(baseConfig, "experimentalParseClassName", experimentalParseClassName);
    for(const configKey in override)$eaad713b70a056bd$var$overrideConfigProperties(baseConfig[configKey], override[configKey]);
    for(const key in extend)$eaad713b70a056bd$var$mergeConfigProperties(baseConfig[key], extend[key]);
    return baseConfig;
};
const $eaad713b70a056bd$var$overrideProperty = (baseObject, overrideKey, overrideValue)=>{
    if (overrideValue !== undefined) baseObject[overrideKey] = overrideValue;
};
const $eaad713b70a056bd$var$overrideConfigProperties = (baseObject, overrideObject)=>{
    if (overrideObject) for(const key in overrideObject)$eaad713b70a056bd$var$overrideProperty(baseObject, key, overrideObject[key]);
};
const $eaad713b70a056bd$var$mergeConfigProperties = (baseObject, mergeObject)=>{
    if (mergeObject) for(const key in mergeObject){
        const mergeValue = mergeObject[key];
        if (mergeValue !== undefined) baseObject[key] = (baseObject[key] || []).concat(mergeValue);
    }
};
const $eaad713b70a056bd$var$extendTailwindMerge = (configExtension, ...createConfig)=>typeof configExtension === "function" ? $eaad713b70a056bd$var$createTailwindMerge($eaad713b70a056bd$var$getDefaultConfig, configExtension, ...createConfig) : $eaad713b70a056bd$var$createTailwindMerge(()=>$eaad713b70a056bd$var$mergeConfigs($eaad713b70a056bd$var$getDefaultConfig(), configExtension), ...createConfig);
const $eaad713b70a056bd$var$twMerge = /*#__PURE__*/ $eaad713b70a056bd$var$createTailwindMerge($eaad713b70a056bd$var$getDefaultConfig);
module.exports.createTailwindMerge = $eaad713b70a056bd$var$createTailwindMerge;
module.exports.extendTailwindMerge = $eaad713b70a056bd$var$extendTailwindMerge;
module.exports.fromTheme = $eaad713b70a056bd$var$fromTheme;
module.exports.getDefaultConfig = $eaad713b70a056bd$var$getDefaultConfig;
module.exports.mergeConfigs = $eaad713b70a056bd$var$mergeConfigs;
module.exports.twJoin = $eaad713b70a056bd$var$twJoin;
module.exports.twMerge = $eaad713b70a056bd$var$twMerge;
module.exports.validators = $eaad713b70a056bd$var$validators;

});


parcelRegister("5XMpG", function(module, exports) {

$parcel$export(module.exports, "Label", function () { return $9039ba852c00586c$export$b04be29aa201d4f5; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $hZz05 = parcelRequire("hZz05");

var $5kn1b = parcelRequire("5kn1b");

var $Yha9m = parcelRequire("Yha9m");
const $9039ba852c00586c$var$labelVariants = (0, $5kn1b.cva)("text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70");
const $9039ba852c00586c$export$b04be29aa201d4f5 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)($hZz05.Root, {
        ref: ref,
        className: (0, $Yha9m.cn)($9039ba852c00586c$var$labelVariants(), className),
        ...props
    }));
$9039ba852c00586c$export$b04be29aa201d4f5.displayName = $hZz05.Root.displayName;

});
parcelRegister("hZz05", function(module, exports) {

$parcel$export(module.exports, "Root", function () { return $ebbbd2d1be11378a$export$be92b6f5f03c0fe9; });

var $jbmdS = parcelRequire("jbmdS");

var $cihg9 = parcelRequire("cihg9");

var $4TLFw = parcelRequire("4TLFw");
"use client";
var $ebbbd2d1be11378a$var$NAME = "Label";
var $ebbbd2d1be11378a$export$b04be29aa201d4f5 = $jbmdS.forwardRef((props, forwardedRef)=>{
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).label, {
        ...props,
        ref: forwardedRef,
        onMouseDown: (event)=>{
            const target = event.target;
            if (target.closest("button, input, select, textarea")) return;
            props.onMouseDown?.(event);
            if (!event.defaultPrevented && event.detail > 1) event.preventDefault();
        }
    });
});
$ebbbd2d1be11378a$export$b04be29aa201d4f5.displayName = $ebbbd2d1be11378a$var$NAME;
var $ebbbd2d1be11378a$export$be92b6f5f03c0fe9 = $ebbbd2d1be11378a$export$b04be29aa201d4f5;

});
parcelRegister("cihg9", function(module, exports) {

$parcel$export(module.exports, "Primitive", function () { return $6047f63b92c35b6a$export$250ffa63cdc0d034; });
$parcel$export(module.exports, "dispatchDiscreteCustomEvent", function () { return $6047f63b92c35b6a$export$6d1a0317bde7de7f; });
// packages/react/primitive/src/Primitive.tsx

var $jbmdS = parcelRequire("jbmdS");

var $jCNM0 = parcelRequire("jCNM0");

var $bXq35 = parcelRequire("bXq35");

var $4TLFw = parcelRequire("4TLFw");
var $6047f63b92c35b6a$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
];
var $6047f63b92c35b6a$export$250ffa63cdc0d034 = $6047f63b92c35b6a$var$NODES.reduce((primitive, node)=>{
    const Node = $jbmdS.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? (0, $bXq35.Slot) : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $4TLFw.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $6047f63b92c35b6a$export$6d1a0317bde7de7f(target, event) {
    if (target) $jCNM0.flushSync(()=>target.dispatchEvent(event));
}
var $6047f63b92c35b6a$export$be92b6f5f03c0fe9 = $6047f63b92c35b6a$export$250ffa63cdc0d034;

});
parcelRegister("bXq35", function(module, exports) {

$parcel$export(module.exports, "Slot", function () { return $7ace3bb484da0338$export$8c6ed5c666ac1360; });
$parcel$export(module.exports, "Slottable", function () { return $7ace3bb484da0338$export$d9f1ccf0bdb05d45; });
// packages/react/slot/src/Slot.tsx

var $jbmdS = parcelRequire("jbmdS");

var $9sunj = parcelRequire("9sunj");

var $4TLFw = parcelRequire("4TLFw");
var $7ace3bb484da0338$export$8c6ed5c666ac1360 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    const childrenArray = $jbmdS.Children.toArray(children);
    const slottable = childrenArray.find($7ace3bb484da0338$var$isSlottable);
    if (slottable) {
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                if ($jbmdS.Children.count(newElement) > 1) return $jbmdS.Children.only(null);
                return $jbmdS.isValidElement(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /* @__PURE__ */ (0, $4TLFw.jsx)($7ace3bb484da0338$var$SlotClone, {
            ...slotProps,
            ref: forwardedRef,
            children: $jbmdS.isValidElement(newElement) ? $jbmdS.cloneElement(newElement, void 0, newChildren) : null
        });
    }
    return /* @__PURE__ */ (0, $4TLFw.jsx)($7ace3bb484da0338$var$SlotClone, {
        ...slotProps,
        ref: forwardedRef,
        children: children
    });
});
$7ace3bb484da0338$export$8c6ed5c666ac1360.displayName = "Slot";
var $7ace3bb484da0338$var$SlotClone = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    if ($jbmdS.isValidElement(children)) {
        const childrenRef = $7ace3bb484da0338$var$getElementRef(children);
        return $jbmdS.cloneElement(children, {
            ...$7ace3bb484da0338$var$mergeProps(slotProps, children.props),
            // @ts-ignore
            ref: forwardedRef ? (0, $9sunj.composeRefs)(forwardedRef, childrenRef) : childrenRef
        });
    }
    return $jbmdS.Children.count(children) > 1 ? $jbmdS.Children.only(null) : null;
});
$7ace3bb484da0338$var$SlotClone.displayName = "SlotClone";
var $7ace3bb484da0338$export$d9f1ccf0bdb05d45 = ({ children: children })=>{
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $4TLFw.Fragment), {
        children: children
    });
};
function $7ace3bb484da0338$var$isSlottable(child) {
    return $jbmdS.isValidElement(child) && child.type === $7ace3bb484da0338$export$d9f1ccf0bdb05d45;
}
function $7ace3bb484da0338$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function $7ace3bb484da0338$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
var $7ace3bb484da0338$export$be92b6f5f03c0fe9 = $7ace3bb484da0338$export$8c6ed5c666ac1360;

});
parcelRegister("9sunj", function(module, exports) {

$parcel$export(module.exports, "composeRefs", function () { return $3b1774344090bc59$export$43e446d32b3d21af; });
$parcel$export(module.exports, "useComposedRefs", function () { return $3b1774344090bc59$export$c7b2cbe3552a0d05; });
// packages/react/compose-refs/src/composeRefs.tsx

var $jbmdS = parcelRequire("jbmdS");
function $3b1774344090bc59$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $3b1774344090bc59$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$3b1774344090bc59$var$setRef(ref, node));
}
function $3b1774344090bc59$export$c7b2cbe3552a0d05(...refs) {
    return $jbmdS.useCallback($3b1774344090bc59$export$43e446d32b3d21af(...refs), refs);
}

});




parcelRegister("5kn1b", function(module, exports) {

$parcel$export(module.exports, "cva", function () { return $49833dc2a521c18e$export$87dc52566e90b739; });

var $5AyPi = parcelRequire("5AyPi");
const $49833dc2a521c18e$var$falsyToString = (value)=>typeof value === "boolean" ? "".concat(value) : value === 0 ? "0" : value;
const $49833dc2a521c18e$export$a274e22fb40f762e = (0, $5AyPi.clsx);
const $49833dc2a521c18e$export$87dc52566e90b739 = (base, config)=>{
    return (props)=>{
        var ref;
        if ((config === null || config === void 0 ? void 0 : config.variants) == null) return $49833dc2a521c18e$export$a274e22fb40f762e(base, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
        const { variants: variants, defaultVariants: defaultVariants } = config;
        const getVariantClassNames = Object.keys(variants).map((variant)=>{
            const variantProp = props === null || props === void 0 ? void 0 : props[variant];
            const defaultVariantProp = defaultVariants === null || defaultVariants === void 0 ? void 0 : defaultVariants[variant];
            if (variantProp === null) return null;
            const variantKey = $49833dc2a521c18e$var$falsyToString(variantProp) || $49833dc2a521c18e$var$falsyToString(defaultVariantProp);
            return variants[variant][variantKey];
        });
        const propsWithoutUndefined = props && Object.entries(props).reduce((acc, param)=>{
            let [key, value] = param;
            if (value === undefined) return acc;
            acc[key] = value;
            return acc;
        }, {});
        const getCompoundVariantClassNames = config === null || config === void 0 ? void 0 : (ref = config.compoundVariants) === null || ref === void 0 ? void 0 : ref.reduce((acc, param1)=>{
            let { class: cvClass, className: cvClassName, ...compoundVariantOptions } = param1;
            return Object.entries(compoundVariantOptions).every((param)=>{
                let [key, value] = param;
                return Array.isArray(value) ? value.includes({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                }[key]) : ({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                })[key] === value;
            }) ? [
                ...acc,
                cvClass,
                cvClassName
            ] : acc;
        }, []);
        return $49833dc2a521c18e$export$a274e22fb40f762e(base, getVariantClassNames, getCompoundVariantClassNames, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
    };
};

});
parcelRegister("5AyPi", function(module, exports) {

$parcel$export(module.exports, "clsx", function () { return $07f6ba7623d46389$export$4f5d2d50c9deca37; });
function $07f6ba7623d46389$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $07f6ba7623d46389$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $07f6ba7623d46389$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $07f6ba7623d46389$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $07f6ba7623d46389$export$2e2bcd8739ae039 = $07f6ba7623d46389$export$4f5d2d50c9deca37;

});




parcelRegister("95Evz", function(module, exports) {

$parcel$export(module.exports, "cn", function () { return $bfc7bbc402b5878e$export$1343a74baacb0543; });

var $dWgPS = parcelRequire("dWgPS");

var $k9bkX = parcelRequire("k9bkX");
function $bfc7bbc402b5878e$export$1343a74baacb0543(...inputs) {
    return (0, $k9bkX.twMerge)((0, $dWgPS.clsx)(inputs));
}

});

parcelRegister("uOjok", function(module, exports) {

$parcel$export(module.exports, "setDateByType", function () { return $35094c83e8653ebc$export$cad541bc043ba344; });
$parcel$export(module.exports, "getDateByType", function () { return $35094c83e8653ebc$export$74195b4be50fc089; });
$parcel$export(module.exports, "display12HourValue", function () { return $35094c83e8653ebc$export$6957f51588365802; });
$parcel$export(module.exports, "getPeriod", function () { return $35094c83e8653ebc$export$d7b798838bc3adf4; });
$parcel$export(module.exports, "getArrowByType", function () { return $35094c83e8653ebc$export$620558ea3d7a5fcb; });
/**
 * regular expression to check for valid hour format (01-23)
 */ function $35094c83e8653ebc$export$8039dc2a357e7bd5(value) {
    return /^(0[0-9]|1[0-9]|2[0-3])$/.test(value);
}
function $35094c83e8653ebc$export$5c1acddeaeed1cb9(value) {
    return /^(0[1-9]|1[0-2])$/.test(value);
}
function $35094c83e8653ebc$export$87e24463242f87b5(value) {
    return /^[0-5][0-9]$/.test(value);
}
function $35094c83e8653ebc$export$92f1e02399d3dabf(value, { max: max, min: min = 0, loop: loop = false }) {
    let numericValue = parseInt(value, 10);
    if (!isNaN(numericValue)) {
        if (!loop) {
            if (numericValue > max) numericValue = max;
            if (numericValue < min) numericValue = min;
        } else {
            if (numericValue > max) numericValue = min;
            if (numericValue < min) numericValue = max;
        }
        return numericValue.toString().padStart(2, "0");
    }
    return "00";
}
function $35094c83e8653ebc$export$9bea5c2cb6c9a4a0(value) {
    if ($35094c83e8653ebc$export$8039dc2a357e7bd5(value)) return value;
    return $35094c83e8653ebc$export$92f1e02399d3dabf(value, {
        max: 23
    });
}
function $35094c83e8653ebc$export$8d53e25a30cfe4d0(value) {
    if ($35094c83e8653ebc$export$5c1acddeaeed1cb9(value)) return value;
    return $35094c83e8653ebc$export$92f1e02399d3dabf(value, {
        min: 1,
        max: 12
    });
}
function $35094c83e8653ebc$export$15d996bf5e368421(value) {
    if ($35094c83e8653ebc$export$87e24463242f87b5(value)) return value;
    return $35094c83e8653ebc$export$92f1e02399d3dabf(value, {
        max: 59
    });
}
function $35094c83e8653ebc$export$483a3e96ac250fcb(value, { min: min, max: max, step: step }) {
    let numericValue = parseInt(value, 10);
    if (!isNaN(numericValue)) {
        numericValue += step;
        return $35094c83e8653ebc$export$92f1e02399d3dabf(String(numericValue), {
            min: min,
            max: max,
            loop: true
        });
    }
    return "00";
}
function $35094c83e8653ebc$export$76199f42e59afdb1(value, step) {
    return $35094c83e8653ebc$export$483a3e96ac250fcb(value, {
        min: 0,
        max: 23,
        step: step
    });
}
function $35094c83e8653ebc$export$4691bb5d386ae79f(value, step) {
    return $35094c83e8653ebc$export$483a3e96ac250fcb(value, {
        min: 1,
        max: 12,
        step: step
    });
}
function $35094c83e8653ebc$export$8c5d6594d30a30bb(value, step) {
    return $35094c83e8653ebc$export$483a3e96ac250fcb(value, {
        min: 0,
        max: 59,
        step: step
    });
}
function $35094c83e8653ebc$export$ad569bf1c79ea89d(date, value) {
    const minutes = $35094c83e8653ebc$export$15d996bf5e368421(value);
    date.setMinutes(parseInt(minutes, 10));
    return date;
}
function $35094c83e8653ebc$export$aec44746644cbf43(date, value) {
    const seconds = $35094c83e8653ebc$export$15d996bf5e368421(value);
    date.setSeconds(parseInt(seconds, 10));
    return date;
}
function $35094c83e8653ebc$export$f86b797a4659b781(date, value) {
    const hours = $35094c83e8653ebc$export$9bea5c2cb6c9a4a0(value);
    date.setHours(parseInt(hours, 10));
    return date;
}
function $35094c83e8653ebc$export$7e0193a769956ad4(date, value, period) {
    console.log("\uD83D\uDE80 ~ set12Hours ~ period:", period);
    const hours = parseInt($35094c83e8653ebc$export$8d53e25a30cfe4d0(value), 10);
    const convertedHours = $35094c83e8653ebc$export$ce2250a8fcf05b62(hours, period);
    date.setHours(convertedHours);
    return date;
}
function $35094c83e8653ebc$export$cad541bc043ba344(date, value, type, period) {
    switch(type){
        case "minutes":
            return $35094c83e8653ebc$export$ad569bf1c79ea89d(date, value);
        case "seconds":
            return $35094c83e8653ebc$export$aec44746644cbf43(date, value);
        case "hours":
            return $35094c83e8653ebc$export$f86b797a4659b781(date, value);
        case "12hours":
            if (!period) return date;
            return $35094c83e8653ebc$export$7e0193a769956ad4(date, value, period);
        default:
            return date;
    }
}
function $35094c83e8653ebc$export$74195b4be50fc089(date, type) {
    switch(type){
        case "minutes":
            return $35094c83e8653ebc$export$15d996bf5e368421(String(date.getMinutes()));
        case "seconds":
            return $35094c83e8653ebc$export$15d996bf5e368421(String(date.getSeconds()));
        case "hours":
            return $35094c83e8653ebc$export$9bea5c2cb6c9a4a0(String(date.getHours()));
        case "12hours":
            const hours = $35094c83e8653ebc$export$6957f51588365802(date.getHours());
            return $35094c83e8653ebc$export$8d53e25a30cfe4d0(String(hours));
        default:
            return "00";
    }
}
function $35094c83e8653ebc$export$d7b798838bc3adf4(date) {
    return date.getHours() >= 12 ? "PM" : "AM";
}
function $35094c83e8653ebc$export$620558ea3d7a5fcb(value, step, type) {
    switch(type){
        case "minutes":
            return $35094c83e8653ebc$export$8c5d6594d30a30bb(value, step);
        case "seconds":
            return $35094c83e8653ebc$export$8c5d6594d30a30bb(value, step);
        case "hours":
            return $35094c83e8653ebc$export$76199f42e59afdb1(value, step);
        case "12hours":
            return $35094c83e8653ebc$export$4691bb5d386ae79f(value, step);
        default:
            return "00";
    }
}
function $35094c83e8653ebc$export$ce2250a8fcf05b62(hour, period) {
    if (period === "PM") {
        if (hour <= 11) return hour + 12;
        else return hour;
    } else if (period === "AM") {
        if (hour === 12) return 0;
        return hour;
    }
    return hour;
}
function $35094c83e8653ebc$export$6957f51588365802(hours) {
    if (hours === 0 || hours === 12) return "12";
    if (hours >= 22) return `${hours - 12}`;
    if (hours % 12 > 9) return `${hours}`;
    return `0${hours % 12}`;
}

});


parcelRegister("enJk6", function(module, exports) {

$parcel$export(module.exports, "TimePeriodSelect", function () { return $6a16197ecbd4a310$export$c86e19284370fbb9; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $uOjok = parcelRequire("uOjok");

var $ewAM3 = parcelRequire("ewAM3");
const $6a16197ecbd4a310$export$c86e19284370fbb9 = /*#__PURE__*/ $jbmdS.forwardRef(({ period: period, setPeriod: setPeriod, date: date, setDate: setDate, onLeftFocus: onLeftFocus, onRightFocus: onRightFocus, disabled: disabled }, ref)=>{
    const handleKeyDown = (e)=>{
        if (e.key === "ArrowRight") onRightFocus === null || onRightFocus === void 0 || onRightFocus();
        if (e.key === "ArrowLeft") onLeftFocus === null || onLeftFocus === void 0 || onLeftFocus();
    };
    const handleValueChange = (value)=>{
        setPeriod(value);
        /**
     * trigger an update whenever the user switches between AM and PM;
     * otherwise user must manually change the hour each time
     */ if (date) {
            const tempDate = new Date(date);
            const hours = (0, $uOjok.display12HourValue)(date.getHours());
            setDate((0, $uOjok.setDateByType)(tempDate, hours.toString(), "12hours", value === "AM" ? "AM" : "PM"));
        }
    };
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "flex h-full items-center",
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
            value: period,
            options: [
                "AM",
                "PM"
            ],
            onChange: (value)=>handleValueChange(value),
            disabled: disabled,
            variant: "secondary"
        })
    });
});
$6a16197ecbd4a310$export$c86e19284370fbb9.displayName = "TimePeriodSelect";

});



parcelRegister("1kvoC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f8003550741a0c5$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $0f8003550741a0c5$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("Check", [
    [
        "path",
        {
            d: "M20 6 9 17l-5-5",
            key: "1gmf2c"
        }
    ]
]);

});
parcelRegister("bYZ6V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b94b3a142fcaa97$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $jbmdS = parcelRequire("jbmdS");

var $ipPS4 = parcelRequire("ipPS4");

var $MVKM8 = parcelRequire("MVKM8");
const $8b94b3a142fcaa97$export$2e2bcd8739ae039 = (iconName, iconNode)=>{
    const Component = (0, $jbmdS.forwardRef)(({ className: className, ...props }, ref)=>(0, $jbmdS.createElement)((0, $MVKM8.default), {
            ref: ref,
            iconNode: iconNode,
            className: (0, $ipPS4.mergeClasses)(`lucide-${(0, $ipPS4.toKebabCase)(iconName)}`, className),
            ...props
        }));
    Component.displayName = `${iconName}`;
    return Component;
};

});
parcelRegister("ipPS4", function(module, exports) {

$parcel$export(module.exports, "toKebabCase", function () { return $d682cc4f8b36466e$export$73bda83cddbc7187; });
$parcel$export(module.exports, "mergeClasses", function () { return $d682cc4f8b36466e$export$3d46f4579dba46e5; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $d682cc4f8b36466e$export$73bda83cddbc7187 = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const $d682cc4f8b36466e$export$3d46f4579dba46e5 = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && array.indexOf(className) === index;
    }).join(" ");

});

parcelRegister("MVKM8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $093148708824e720$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $jbmdS = parcelRequire("jbmdS");

var $gT8SG = parcelRequire("gT8SG");

var $ipPS4 = parcelRequire("ipPS4");
const $093148708824e720$export$2e2bcd8739ae039 = (0, $jbmdS.forwardRef)(({ color: color = "currentColor", size: size = 24, strokeWidth: strokeWidth = 2, absoluteStrokeWidth: absoluteStrokeWidth, className: className = "", children: children, iconNode: iconNode, ...rest }, ref)=>{
    return (0, $jbmdS.createElement)("svg", {
        ref: ref,
        ...(0, $gT8SG.default),
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: (0, $ipPS4.mergeClasses)("lucide", className),
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, $jbmdS.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]);
});

});
parcelRegister("gT8SG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4b8abfa586cc252$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var $c4b8abfa586cc252$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};

});




parcelRegister("kSlHv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f329af17ebe38b57$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $f329af17ebe38b57$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("ChevronsUpDown", [
    [
        "path",
        {
            d: "m7 15 5 5 5-5",
            key: "1hf1tw"
        }
    ],
    [
        "path",
        {
            d: "m7 9 5-5 5 5",
            key: "sgt6xg"
        }
    ]
]);

});

parcelRegister("hzq93", function(module, exports) {

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $bXq35 = parcelRequire("bXq35");
// Simplified style object to replace Tailwind classes
const $013152976b6c8a05$var$baseButtonStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    whiteSpace: "nowrap",
    borderRadius: "0.375rem",
    // Equivalent to rounded-md in Tailwind
    fontSize: "1.2rem",
    // Equivalent to text-sm in Tailwind
    fontWeight: "medium",
    // Equivalent to font-medium in Tailwind
    transition: "colors 0.2s",
    // Simplified version of transition-colors
    outline: "none",
    cursor: "pointer",
    opacity: 1,
    // Default state
    overflow: "hidden"
};
// Basic button component without variant logic
const $013152976b6c8a05$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).forwardRef(({ asChild: asChild = false, className: className, style: style, ...props }, ref)=>{
    const Comp = asChild ? (0, $bXq35.Slot) : "button";
    const finalStyle = {
        ...$013152976b6c8a05$var$baseButtonStyle,
        ...style
    }; // Combine base style with any passed inline style
    return /*#__PURE__*/ (0, $61Ea1.jsx)(Comp, {
        className: className,
        ref: ref,
        style: finalStyle,
        ...props
    });
});
$013152976b6c8a05$export$353f5b6fc5456de1.displayName = "Button";

});

parcelRegister("aouPi", function(module, exports) {

$parcel$export(module.exports, "Command", function () { return $83e771d631d271c8$export$cc7e12c76513e857; });
$parcel$export(module.exports, "CommandInput", function () { return $83e771d631d271c8$export$ebdebb88e46df62a; });
$parcel$export(module.exports, "CommandList", function () { return $83e771d631d271c8$export$9cffcb65e9381872; });
$parcel$export(module.exports, "CommandEmpty", function () { return $83e771d631d271c8$export$f1753c65029fce09; });
$parcel$export(module.exports, "CommandItem", function () { return $83e771d631d271c8$export$b9b346a733d36f61; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $fDHGo = parcelRequire("fDHGo");

var $jSiTu = parcelRequire("jSiTu");

var $7MfWg = parcelRequire("7MfWg");
// Assuming a simple utility for classNames
function $83e771d631d271c8$var$cn(...classes) {
    return classes.filter(Boolean).join(" ");
}
const $83e771d631d271c8$var$Dialog = $fDHGo.Root;
const $83e771d631d271c8$var$DialogContent = $fDHGo.Content;
const $83e771d631d271c8$export$cc7e12c76513e857 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $7MfWg.Command), {
        ref: ref,
        className: $83e771d631d271c8$var$cn("command-base", className),
        ...props
    }));
$83e771d631d271c8$export$cc7e12c76513e857.displayName = "Command";
const $83e771d631d271c8$export$98f0540b5c04f3e8 = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)($83e771d631d271c8$var$Dialog, {
        ...props,
        children: /*#__PURE__*/ (0, $61Ea1.jsx)($83e771d631d271c8$var$DialogContent, {
            className: "dialog-content",
            children: children
        })
    });
};
const $83e771d631d271c8$export$ebdebb88e46df62a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "command-input-wrapper",
        style: {
            display: "flex",
            alignItems: "center",
            width: "100%",
            padding: "0.5rem",
            borderBottom: "1px solid #e5e7eb"
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jSiTu.MagnifyingGlassIcon), {
                className: "magnifying-glass-icon",
                style: {
                    flex: "0 0 auto"
                }
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7MfWg.Command).Input, {
                style: {
                    flex: "1 1 auto",
                    width: "100%",
                    border: "none",
                    boxShadow: "none"
                },
                ref: ref,
                className: $83e771d631d271c8$var$cn("focus:outline-none pl-2 text-sm", className),
                ...props
            })
        ]
    }));
$83e771d631d271c8$export$ebdebb88e46df62a.displayName = "CommandInput";
const $83e771d631d271c8$export$9cffcb65e9381872 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $7MfWg.Command).List, {
        ref: ref,
        className: $83e771d631d271c8$var$cn("command-list", className),
        ...props
    }));
$83e771d631d271c8$export$9cffcb65e9381872.displayName = "CommandList";
const $83e771d631d271c8$export$f1753c65029fce09 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).forwardRef((props, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $7MfWg.Command).Empty, {
        ref: ref,
        className: "command-empty",
        ...props
    }));
$83e771d631d271c8$export$f1753c65029fce09.displayName = "CommandEmpty";
const $83e771d631d271c8$export$c157b9873a7a0fbd = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $7MfWg.Command).Group, {
        ref: ref,
        className: $83e771d631d271c8$var$cn("command-group", className),
        ...props
    }));
$83e771d631d271c8$export$c157b9873a7a0fbd.displayName = "CommandGroup";
const $83e771d631d271c8$export$ace649eed6990b42 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $7MfWg.Command).Separator, {
        ref: ref,
        className: $83e771d631d271c8$var$cn("command-separator", className),
        ...props
    }));
$83e771d631d271c8$export$ace649eed6990b42.displayName = "CommandSeparator";
const $83e771d631d271c8$export$b9b346a733d36f61 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $7MfWg.Command).Item, {
        ref: ref,
        className: $83e771d631d271c8$var$cn("hover:bg-[#f5f5f5] cursor-pointer text-xs", className),
        ...props
    }));
$83e771d631d271c8$export$b9b346a733d36f61.displayName = "CommandItem";
const $83e771d631d271c8$export$8b2995843ab6cf09 = ({ className: className, ...props })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
        className: $83e771d631d271c8$var$cn("command-shortcut", className),
        ...props
    });
};
$83e771d631d271c8$export$8b2995843ab6cf09.displayName = "CommandShortcut";

});
parcelRegister("fDHGo", function(module, exports) {

$parcel$export(module.exports, "Root", function () { return $6c97cacb193c8fd4$export$be92b6f5f03c0fe9; });
$parcel$export(module.exports, "Trigger", function () { return $6c97cacb193c8fd4$export$41fb9f06171c75f4; });
$parcel$export(module.exports, "Portal", function () { return $6c97cacb193c8fd4$export$602eac185826482c; });
$parcel$export(module.exports, "Overlay", function () { return $6c97cacb193c8fd4$export$c6fdb837b070b4ff; });
$parcel$export(module.exports, "Content", function () { return $6c97cacb193c8fd4$export$7c6e2c02157bb7d2; });
$parcel$export(module.exports, "Title", function () { return $6c97cacb193c8fd4$export$f99233281efd08a0; });
$parcel$export(module.exports, "Description", function () { return $6c97cacb193c8fd4$export$393edc798c47379d; });
$parcel$export(module.exports, "Close", function () { return $6c97cacb193c8fd4$export$f39c2d165cd861fe; });

var $jbmdS = parcelRequire("jbmdS");

var $hFcKE = parcelRequire("hFcKE");

var $9sunj = parcelRequire("9sunj");

var $f4RZG = parcelRequire("f4RZG");

var $g7F3X = parcelRequire("g7F3X");

var $1sq0Q = parcelRequire("1sq0Q");

var $jJBMp = parcelRequire("jJBMp");

var $i3HOY = parcelRequire("i3HOY");

var $fKp8B = parcelRequire("fKp8B");

var $joHB8 = parcelRequire("joHB8");

var $cihg9 = parcelRequire("cihg9");

var $fbZ8r = parcelRequire("fbZ8r");

var $gQkjX = parcelRequire("gQkjX");

var $9Y02g = parcelRequire("9Y02g");

var $bXq35 = parcelRequire("bXq35");

var $4TLFw = parcelRequire("4TLFw");
"use client";
var $6c97cacb193c8fd4$var$DIALOG_NAME = "Dialog";
var [$6c97cacb193c8fd4$var$createDialogContext, $6c97cacb193c8fd4$export$cc702773b8ea3e41] = (0, $f4RZG.createContextScope)($6c97cacb193c8fd4$var$DIALOG_NAME);
var [$6c97cacb193c8fd4$var$DialogProvider, $6c97cacb193c8fd4$var$useDialogContext] = $6c97cacb193c8fd4$var$createDialogContext($6c97cacb193c8fd4$var$DIALOG_NAME);
var $6c97cacb193c8fd4$export$3ddf2d174ce01153 = (props)=>{
    const { __scopeDialog: __scopeDialog, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = true } = props;
    const triggerRef = $jbmdS.useRef(null);
    const contentRef = $jbmdS.useRef(null);
    const [open = false, setOpen] = (0, $1sq0Q.useControllableState)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /* @__PURE__ */ (0, $4TLFw.jsx)($6c97cacb193c8fd4$var$DialogProvider, {
        scope: __scopeDialog,
        triggerRef: triggerRef,
        contentRef: contentRef,
        contentId: (0, $g7F3X.useId)(),
        titleId: (0, $g7F3X.useId)(),
        descriptionId: (0, $g7F3X.useId)(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: $jbmdS.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal: modal,
        children: children
    });
};
$6c97cacb193c8fd4$export$3ddf2d174ce01153.displayName = $6c97cacb193c8fd4$var$DIALOG_NAME;
var $6c97cacb193c8fd4$var$TRIGGER_NAME = "DialogTrigger";
var $6c97cacb193c8fd4$export$2e1e1122cf0cba88 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...triggerProps } = props;
    const context = $6c97cacb193c8fd4$var$useDialogContext($6c97cacb193c8fd4$var$TRIGGER_NAME, __scopeDialog);
    const composedTriggerRef = (0, $9sunj.useComposedRefs)(forwardedRef, context.triggerRef);
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).button, {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $6c97cacb193c8fd4$var$getState(context.open),
        ...triggerProps,
        ref: composedTriggerRef,
        onClick: (0, $hFcKE.composeEventHandlers)(props.onClick, context.onOpenToggle)
    });
});
$6c97cacb193c8fd4$export$2e1e1122cf0cba88.displayName = $6c97cacb193c8fd4$var$TRIGGER_NAME;
var $6c97cacb193c8fd4$var$PORTAL_NAME = "DialogPortal";
var [$6c97cacb193c8fd4$var$PortalProvider, $6c97cacb193c8fd4$var$usePortalContext] = $6c97cacb193c8fd4$var$createDialogContext($6c97cacb193c8fd4$var$PORTAL_NAME, {
    forceMount: void 0
});
var $6c97cacb193c8fd4$export$dad7c95542bacce0 = (props)=>{
    const { __scopeDialog: __scopeDialog, forceMount: forceMount, children: children, container: container } = props;
    const context = $6c97cacb193c8fd4$var$useDialogContext($6c97cacb193c8fd4$var$PORTAL_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($6c97cacb193c8fd4$var$PortalProvider, {
        scope: __scopeDialog,
        forceMount: forceMount,
        children: $jbmdS.Children.map(children, (child)=>/* @__PURE__ */ (0, $4TLFw.jsx)((0, $joHB8.Presence), {
                present: forceMount || context.open,
                children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $fKp8B.Portal), {
                    asChild: true,
                    container: container,
                    children: child
                })
            }))
    });
};
$6c97cacb193c8fd4$export$dad7c95542bacce0.displayName = $6c97cacb193c8fd4$var$PORTAL_NAME;
var $6c97cacb193c8fd4$var$OVERLAY_NAME = "DialogOverlay";
var $6c97cacb193c8fd4$export$bd1d06c79be19e17 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const portalContext = $6c97cacb193c8fd4$var$usePortalContext($6c97cacb193c8fd4$var$OVERLAY_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...overlayProps } = props;
    const context = $6c97cacb193c8fd4$var$useDialogContext($6c97cacb193c8fd4$var$OVERLAY_NAME, props.__scopeDialog);
    return context.modal ? /* @__PURE__ */ (0, $4TLFw.jsx)((0, $joHB8.Presence), {
        present: forceMount || context.open,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)($6c97cacb193c8fd4$var$DialogOverlayImpl, {
            ...overlayProps,
            ref: forwardedRef
        })
    }) : null;
});
$6c97cacb193c8fd4$export$bd1d06c79be19e17.displayName = $6c97cacb193c8fd4$var$OVERLAY_NAME;
var $6c97cacb193c8fd4$var$DialogOverlayImpl = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...overlayProps } = props;
    const context = $6c97cacb193c8fd4$var$useDialogContext($6c97cacb193c8fd4$var$OVERLAY_NAME, __scopeDialog);
    return(// Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ (0, $4TLFw.jsx)((0, $gQkjX.default), {
        as: (0, $bXq35.Slot),
        allowPinchZoom: true,
        shards: [
            context.contentRef
        ],
        children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).div, {
            "data-state": $6c97cacb193c8fd4$var$getState(context.open),
            ...overlayProps,
            ref: forwardedRef,
            style: {
                pointerEvents: "auto",
                ...overlayProps.style
            }
        })
    }));
});
var $6c97cacb193c8fd4$var$CONTENT_NAME = "DialogContent";
var $6c97cacb193c8fd4$export$b6d9565de1e068cf = $jbmdS.forwardRef((props, forwardedRef)=>{
    const portalContext = $6c97cacb193c8fd4$var$usePortalContext($6c97cacb193c8fd4$var$CONTENT_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $6c97cacb193c8fd4$var$useDialogContext($6c97cacb193c8fd4$var$CONTENT_NAME, props.__scopeDialog);
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $joHB8.Presence), {
        present: forceMount || context.open,
        children: context.modal ? /* @__PURE__ */ (0, $4TLFw.jsx)($6c97cacb193c8fd4$var$DialogContentModal, {
            ...contentProps,
            ref: forwardedRef
        }) : /* @__PURE__ */ (0, $4TLFw.jsx)($6c97cacb193c8fd4$var$DialogContentNonModal, {
            ...contentProps,
            ref: forwardedRef
        })
    });
});
$6c97cacb193c8fd4$export$b6d9565de1e068cf.displayName = $6c97cacb193c8fd4$var$CONTENT_NAME;
var $6c97cacb193c8fd4$var$DialogContentModal = $jbmdS.forwardRef((props, forwardedRef)=>{
    const context = $6c97cacb193c8fd4$var$useDialogContext($6c97cacb193c8fd4$var$CONTENT_NAME, props.__scopeDialog);
    const contentRef = $jbmdS.useRef(null);
    const composedRefs = (0, $9sunj.useComposedRefs)(forwardedRef, context.contentRef, contentRef);
    $jbmdS.useEffect(()=>{
        const content = contentRef.current;
        if (content) return (0, $9Y02g.hideOthers)(content);
    }, []);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($6c97cacb193c8fd4$var$DialogContentImpl, {
        ...props,
        ref: composedRefs,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: (0, $hFcKE.composeEventHandlers)(props.onCloseAutoFocus, (event)=>{
            event.preventDefault();
            context.triggerRef.current?.focus();
        }),
        onPointerDownOutside: (0, $hFcKE.composeEventHandlers)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            if (isRightClick) event.preventDefault();
        }),
        onFocusOutside: (0, $hFcKE.composeEventHandlers)(props.onFocusOutside, (event)=>event.preventDefault())
    });
});
var $6c97cacb193c8fd4$var$DialogContentNonModal = $jbmdS.forwardRef((props, forwardedRef)=>{
    const context = $6c97cacb193c8fd4$var$useDialogContext($6c97cacb193c8fd4$var$CONTENT_NAME, props.__scopeDialog);
    const hasInteractedOutsideRef = $jbmdS.useRef(false);
    const hasPointerDownOutsideRef = $jbmdS.useRef(false);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($6c97cacb193c8fd4$var$DialogContentImpl, {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            props.onCloseAutoFocus?.(event);
            if (!event.defaultPrevented) {
                if (!hasInteractedOutsideRef.current) context.triggerRef.current?.focus();
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            props.onInteractOutside?.(event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            }
            const target = event.target;
            const targetIsTrigger = context.triggerRef.current?.contains(target);
            if (targetIsTrigger) event.preventDefault();
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    });
});
var $6c97cacb193c8fd4$var$DialogContentImpl = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, ...contentProps } = props;
    const context = $6c97cacb193c8fd4$var$useDialogContext($6c97cacb193c8fd4$var$CONTENT_NAME, __scopeDialog);
    const contentRef = $jbmdS.useRef(null);
    const composedRefs = (0, $9sunj.useComposedRefs)(forwardedRef, contentRef);
    (0, $fbZ8r.useFocusGuards)();
    return /* @__PURE__ */ (0, $4TLFw.jsxs)((0, $4TLFw.Fragment), {
        children: [
            /* @__PURE__ */ (0, $4TLFw.jsx)((0, $i3HOY.FocusScope), {
                asChild: true,
                loop: true,
                trapped: trapFocus,
                onMountAutoFocus: onOpenAutoFocus,
                onUnmountAutoFocus: onCloseAutoFocus,
                children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $jJBMp.DismissableLayer), {
                    role: "dialog",
                    id: context.contentId,
                    "aria-describedby": context.descriptionId,
                    "aria-labelledby": context.titleId,
                    "data-state": $6c97cacb193c8fd4$var$getState(context.open),
                    ...contentProps,
                    ref: composedRefs,
                    onDismiss: ()=>context.onOpenChange(false)
                })
            }),
            /* @__PURE__ */ (0, $4TLFw.jsxs)((0, $4TLFw.Fragment), {
                children: [
                    /* @__PURE__ */ (0, $4TLFw.jsx)($6c97cacb193c8fd4$var$TitleWarning, {
                        titleId: context.titleId
                    }),
                    /* @__PURE__ */ (0, $4TLFw.jsx)($6c97cacb193c8fd4$var$DescriptionWarning, {
                        contentRef: contentRef,
                        descriptionId: context.descriptionId
                    })
                ]
            })
        ]
    });
});
var $6c97cacb193c8fd4$var$TITLE_NAME = "DialogTitle";
var $6c97cacb193c8fd4$export$16f7638e4a34b909 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...titleProps } = props;
    const context = $6c97cacb193c8fd4$var$useDialogContext($6c97cacb193c8fd4$var$TITLE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).h2, {
        id: context.titleId,
        ...titleProps,
        ref: forwardedRef
    });
});
$6c97cacb193c8fd4$export$16f7638e4a34b909.displayName = $6c97cacb193c8fd4$var$TITLE_NAME;
var $6c97cacb193c8fd4$var$DESCRIPTION_NAME = "DialogDescription";
var $6c97cacb193c8fd4$export$94e94c2ec2c954d5 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...descriptionProps } = props;
    const context = $6c97cacb193c8fd4$var$useDialogContext($6c97cacb193c8fd4$var$DESCRIPTION_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).p, {
        id: context.descriptionId,
        ...descriptionProps,
        ref: forwardedRef
    });
});
$6c97cacb193c8fd4$export$94e94c2ec2c954d5.displayName = $6c97cacb193c8fd4$var$DESCRIPTION_NAME;
var $6c97cacb193c8fd4$var$CLOSE_NAME = "DialogClose";
var $6c97cacb193c8fd4$export$fba2fb7cd781b7ac = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...closeProps } = props;
    const context = $6c97cacb193c8fd4$var$useDialogContext($6c97cacb193c8fd4$var$CLOSE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).button, {
        type: "button",
        ...closeProps,
        ref: forwardedRef,
        onClick: (0, $hFcKE.composeEventHandlers)(props.onClick, ()=>context.onOpenChange(false))
    });
});
$6c97cacb193c8fd4$export$fba2fb7cd781b7ac.displayName = $6c97cacb193c8fd4$var$CLOSE_NAME;
function $6c97cacb193c8fd4$var$getState(open) {
    return open ? "open" : "closed";
}
var $6c97cacb193c8fd4$var$TITLE_WARNING_NAME = "DialogTitleWarning";
var [$6c97cacb193c8fd4$export$69b62a49393917d6, $6c97cacb193c8fd4$var$useWarningContext] = (0, $f4RZG.createContext)($6c97cacb193c8fd4$var$TITLE_WARNING_NAME, {
    contentName: $6c97cacb193c8fd4$var$CONTENT_NAME,
    titleName: $6c97cacb193c8fd4$var$TITLE_NAME,
    docsSlug: "dialog"
});
var $6c97cacb193c8fd4$var$TitleWarning = ({ titleId: titleId })=>{
    const titleWarningContext = $6c97cacb193c8fd4$var$useWarningContext($6c97cacb193c8fd4$var$TITLE_WARNING_NAME);
    const MESSAGE = `\`${titleWarningContext.contentName}\` requires a \`${titleWarningContext.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${titleWarningContext.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${titleWarningContext.docsSlug}`;
    $jbmdS.useEffect(()=>{
        if (titleId) {
            const hasTitle = document.getElementById(titleId);
            if (!hasTitle) console.error(MESSAGE);
        }
    }, [
        MESSAGE,
        titleId
    ]);
    return null;
};
var $6c97cacb193c8fd4$var$DESCRIPTION_WARNING_NAME = "DialogDescriptionWarning";
var $6c97cacb193c8fd4$var$DescriptionWarning = ({ contentRef: contentRef, descriptionId: descriptionId })=>{
    const descriptionWarningContext = $6c97cacb193c8fd4$var$useWarningContext($6c97cacb193c8fd4$var$DESCRIPTION_WARNING_NAME);
    const MESSAGE = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${descriptionWarningContext.contentName}}.`;
    $jbmdS.useEffect(()=>{
        const describedById = contentRef.current?.getAttribute("aria-describedby");
        if (descriptionId && describedById) {
            const hasDescription = document.getElementById(descriptionId);
            if (!hasDescription) console.warn(MESSAGE);
        }
    }, [
        MESSAGE,
        contentRef,
        descriptionId
    ]);
    return null;
};
var $6c97cacb193c8fd4$export$be92b6f5f03c0fe9 = $6c97cacb193c8fd4$export$3ddf2d174ce01153;
var $6c97cacb193c8fd4$export$41fb9f06171c75f4 = $6c97cacb193c8fd4$export$2e1e1122cf0cba88;
var $6c97cacb193c8fd4$export$602eac185826482c = $6c97cacb193c8fd4$export$dad7c95542bacce0;
var $6c97cacb193c8fd4$export$c6fdb837b070b4ff = $6c97cacb193c8fd4$export$bd1d06c79be19e17;
var $6c97cacb193c8fd4$export$7c6e2c02157bb7d2 = $6c97cacb193c8fd4$export$b6d9565de1e068cf;
var $6c97cacb193c8fd4$export$f99233281efd08a0 = $6c97cacb193c8fd4$export$16f7638e4a34b909;
var $6c97cacb193c8fd4$export$393edc798c47379d = $6c97cacb193c8fd4$export$94e94c2ec2c954d5;
var $6c97cacb193c8fd4$export$f39c2d165cd861fe = $6c97cacb193c8fd4$export$fba2fb7cd781b7ac;

});
parcelRegister("hFcKE", function(module, exports) {

$parcel$export(module.exports, "composeEventHandlers", function () { return $a467397d564240a3$export$b9ecd428b558ff10; });
// packages/core/primitive/src/primitive.tsx
function $a467397d564240a3$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler?.(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler?.(event);
    };
}

});

parcelRegister("f4RZG", function(module, exports) {

$parcel$export(module.exports, "createContext", function () { return $df734f4637f4b110$export$fd42f52fd3ae1109; });
$parcel$export(module.exports, "createContextScope", function () { return $df734f4637f4b110$export$50c7b4e9d9f19c1; });
// packages/react/context/src/createContext.tsx

var $jbmdS = parcelRequire("jbmdS");

var $4TLFw = parcelRequire("4TLFw");
function $df734f4637f4b110$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $jbmdS.createContext(defaultContext);
    const Provider = (props)=>{
        const { children: children, ...context } = props;
        const value = $jbmdS.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $4TLFw.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    };
    Provider.displayName = rootComponentName + "Provider";
    function useContext2(consumerName) {
        const context = $jbmdS.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    return [
        Provider,
        useContext2
    ];
}
function $df734f4637f4b110$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $jbmdS.createContext(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        const Provider = (props)=>{
            const { scope: scope, children: children, ...context } = props;
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const value = $jbmdS.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $4TLFw.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        };
        Provider.displayName = rootComponentName + "Provider";
        function useContext2(consumerName, scope) {
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const context = $jbmdS.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $jbmdS.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = scope?.[scopeName] || scopeContexts;
            return $jbmdS.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $df734f4637f4b110$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function $df734f4637f4b110$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope, scopeName: scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $jbmdS.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}

});

parcelRegister("g7F3X", function(module, exports) {

$parcel$export(module.exports, "useId", function () { return $10b86b584cf86706$export$f680877a34711e37; });
// packages/react/id/src/id.tsx

var $jbmdS = parcelRequire("jbmdS");

var $9crHl = parcelRequire("9crHl");
var $10b86b584cf86706$var$useReactId = $jbmdS["useId".toString()] || (()=>void 0);
var $10b86b584cf86706$var$count = 0;
function $10b86b584cf86706$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $jbmdS.useState($10b86b584cf86706$var$useReactId());
    (0, $9crHl.useLayoutEffect)(()=>{
        if (!deterministicId) setId((reactId)=>reactId ?? String($10b86b584cf86706$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}

});
parcelRegister("9crHl", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", function () { return $db2bd8f1e3fd074e$export$e5c5a5f917a5871c; });
// packages/react/use-layout-effect/src/useLayoutEffect.tsx

var $jbmdS = parcelRequire("jbmdS");
var $db2bd8f1e3fd074e$export$e5c5a5f917a5871c = Boolean(globalThis?.document) ? $jbmdS.useLayoutEffect : ()=>{};

});


parcelRegister("1sq0Q", function(module, exports) {

$parcel$export(module.exports, "useControllableState", function () { return $f6fee6578d30af8e$export$6f32135080cb4c3; });
// packages/react/use-controllable-state/src/useControllableState.tsx

var $jbmdS = parcelRequire("jbmdS");

var $kjEX1 = parcelRequire("kjEX1");
function $f6fee6578d30af8e$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{} }) {
    const [uncontrolledProp, setUncontrolledProp] = $f6fee6578d30af8e$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $kjEX1.useCallbackRef)(onChange);
    const setValue = $jbmdS.useCallback((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value2 = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value2 !== prop) handleChange(value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value,
        setValue
    ];
}
function $f6fee6578d30af8e$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const uncontrolledState = $jbmdS.useState(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = $jbmdS.useRef(value);
    const handleChange = (0, $kjEX1.useCallbackRef)(onChange);
    $jbmdS.useEffect(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}

});
parcelRegister("kjEX1", function(module, exports) {

$parcel$export(module.exports, "useCallbackRef", function () { return $e29c95af7260d431$export$25bec8c6f54ee79a; });
// packages/react/use-callback-ref/src/useCallbackRef.tsx

var $jbmdS = parcelRequire("jbmdS");
function $e29c95af7260d431$export$25bec8c6f54ee79a(callback) {
    const callbackRef = $jbmdS.useRef(callback);
    $jbmdS.useEffect(()=>{
        callbackRef.current = callback;
    });
    return $jbmdS.useMemo(()=>(...args)=>callbackRef.current?.(...args), []);
}

});


parcelRegister("jJBMp", function(module, exports) {

$parcel$export(module.exports, "DismissableLayer", function () { return $9ceab2b909de20bc$export$177fb62ff3ec1f22; });

var $jbmdS = parcelRequire("jbmdS");

var $hFcKE = parcelRequire("hFcKE");

var $cihg9 = parcelRequire("cihg9");

var $9sunj = parcelRequire("9sunj");

var $kjEX1 = parcelRequire("kjEX1");

var $dXvOF = parcelRequire("dXvOF");

var $4TLFw = parcelRequire("4TLFw");
"use client";
var $9ceab2b909de20bc$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
var $9ceab2b909de20bc$var$CONTEXT_UPDATE = "dismissableLayer.update";
var $9ceab2b909de20bc$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var $9ceab2b909de20bc$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var $9ceab2b909de20bc$var$originalBodyPointerEvents;
var $9ceab2b909de20bc$var$DismissableLayerContext = $jbmdS.createContext({
    layers: /* @__PURE__ */ new Set(),
    layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
    branches: /* @__PURE__ */ new Set()
});
var $9ceab2b909de20bc$export$177fb62ff3ec1f22 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, ...layerProps } = props;
    const context = $jbmdS.useContext($9ceab2b909de20bc$var$DismissableLayerContext);
    const [node, setNode] = $jbmdS.useState(null);
    const ownerDocument = node?.ownerDocument ?? globalThis?.document;
    const [, force] = $jbmdS.useState({});
    const composedRefs = (0, $9sunj.useComposedRefs)(forwardedRef, (node2)=>setNode(node2));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1);
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled);
    const index = node ? layers.indexOf(node) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $9ceab2b909de20bc$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    const focusOutside = $9ceab2b909de20bc$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    (0, $dXvOF.useEscapeKeydown)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown?.(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    $jbmdS.useEffect(()=>{
        if (!node) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $9ceab2b909de20bc$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node);
        }
        context.layers.add(node);
        $9ceab2b909de20bc$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $9ceab2b909de20bc$var$originalBodyPointerEvents;
        };
    }, [
        node,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    $jbmdS.useEffect(()=>{
        return ()=>{
            if (!node) return;
            context.layers.delete(node);
            context.layersWithOutsidePointerEventsDisabled.delete(node);
            $9ceab2b909de20bc$var$dispatchUpdate();
        };
    }, [
        node,
        context
    ]);
    $jbmdS.useEffect(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($9ceab2b909de20bc$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($9ceab2b909de20bc$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).div, {
        ...layerProps,
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
            ...props.style
        },
        onFocusCapture: (0, $hFcKE.composeEventHandlers)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $hFcKE.composeEventHandlers)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $hFcKE.composeEventHandlers)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    });
});
$9ceab2b909de20bc$export$177fb62ff3ec1f22.displayName = $9ceab2b909de20bc$var$DISMISSABLE_LAYER_NAME;
var $9ceab2b909de20bc$var$BRANCH_NAME = "DismissableLayerBranch";
var $9ceab2b909de20bc$export$4d5eb2109db14228 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const context = $jbmdS.useContext($9ceab2b909de20bc$var$DismissableLayerContext);
    const ref = $jbmdS.useRef(null);
    const composedRefs = (0, $9sunj.useComposedRefs)(forwardedRef, ref);
    $jbmdS.useEffect(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).div, {
        ...props,
        ref: composedRefs
    });
});
$9ceab2b909de20bc$export$4d5eb2109db14228.displayName = $9ceab2b909de20bc$var$BRANCH_NAME;
function $9ceab2b909de20bc$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis?.document) {
    const handlePointerDownOutside = (0, $kjEX1.useCallbackRef)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = $jbmdS.useRef(false);
    const handleClickRef = $jbmdS.useRef(()=>{});
    $jbmdS.useEffect(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                let handleAndDispatchPointerDownOutsideEvent2 = function() {
                    $9ceab2b909de20bc$var$handleAndDispatchCustomEvent($9ceab2b909de20bc$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                };
                var handleAndDispatchPointerDownOutsideEvent = handleAndDispatchPointerDownOutsideEvent2;
                const eventDetail = {
                    originalEvent: event
                };
                if (event.pointerType === "touch") {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent2();
            } else ownerDocument.removeEventListener("click", handleClickRef.current);
            isPointerInsideReactTreeRef.current = false;
        };
        const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
function $9ceab2b909de20bc$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis?.document) {
    const handleFocusOutside = (0, $kjEX1.useCallbackRef)(onFocusOutside);
    const isFocusInsideReactTreeRef = $jbmdS.useRef(false);
    $jbmdS.useEffect(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $9ceab2b909de20bc$var$handleAndDispatchCustomEvent($9ceab2b909de20bc$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $9ceab2b909de20bc$var$dispatchUpdate() {
    const event = new CustomEvent($9ceab2b909de20bc$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $9ceab2b909de20bc$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $cihg9.dispatchDiscreteCustomEvent)(target, event);
    else target.dispatchEvent(event);
}
var $9ceab2b909de20bc$export$be92b6f5f03c0fe9 = $9ceab2b909de20bc$export$177fb62ff3ec1f22;
var $9ceab2b909de20bc$export$aecb2ddcb55c95be = $9ceab2b909de20bc$export$4d5eb2109db14228;

});
parcelRegister("dXvOF", function(module, exports) {

$parcel$export(module.exports, "useEscapeKeydown", function () { return $9825d38bf9ce4bad$export$3a72a57244d6e765; });
// packages/react/use-escape-keydown/src/useEscapeKeydown.tsx

var $jbmdS = parcelRequire("jbmdS");

var $kjEX1 = parcelRequire("kjEX1");
function $9825d38bf9ce4bad$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis?.document) {
    const onEscapeKeyDown = (0, $kjEX1.useCallbackRef)(onEscapeKeyDownProp);
    $jbmdS.useEffect(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}

});


parcelRegister("i3HOY", function(module, exports) {

$parcel$export(module.exports, "FocusScope", function () { return $7fdee893af56e859$export$20e40289641fbbb6; });

var $jbmdS = parcelRequire("jbmdS");

var $9sunj = parcelRequire("9sunj");

var $cihg9 = parcelRequire("cihg9");

var $kjEX1 = parcelRequire("kjEX1");

var $4TLFw = parcelRequire("4TLFw");
"use client";
var $7fdee893af56e859$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
var $7fdee893af56e859$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
var $7fdee893af56e859$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $7fdee893af56e859$var$FOCUS_SCOPE_NAME = "FocusScope";
var $7fdee893af56e859$export$20e40289641fbbb6 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { loop: loop = false, trapped: trapped = false, onMountAutoFocus: onMountAutoFocusProp, onUnmountAutoFocus: onUnmountAutoFocusProp, ...scopeProps } = props;
    const [container, setContainer] = $jbmdS.useState(null);
    const onMountAutoFocus = (0, $kjEX1.useCallbackRef)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $kjEX1.useCallbackRef)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = $jbmdS.useRef(null);
    const composedRefs = (0, $9sunj.useComposedRefs)(forwardedRef, (node)=>setContainer(node));
    const focusScope = $jbmdS.useRef({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current;
    $jbmdS.useEffect(()=>{
        if (trapped) {
            let handleFocusIn2 = function(event) {
                if (focusScope.paused || !container) return;
                const target = event.target;
                if (container.contains(target)) lastFocusedElementRef.current = target;
                else $7fdee893af56e859$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleFocusOut2 = function(event) {
                if (focusScope.paused || !container) return;
                const relatedTarget = event.relatedTarget;
                if (relatedTarget === null) return;
                if (!container.contains(relatedTarget)) $7fdee893af56e859$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleMutations2 = function(mutations) {
                const focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                for (const mutation of mutations)if (mutation.removedNodes.length > 0) $7fdee893af56e859$var$focus(container);
            };
            var handleFocusIn = handleFocusIn2, handleFocusOut = handleFocusOut2, handleMutations = handleMutations2;
            document.addEventListener("focusin", handleFocusIn2);
            document.addEventListener("focusout", handleFocusOut2);
            const mutationObserver = new MutationObserver(handleMutations2);
            if (container) mutationObserver.observe(container, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn2);
                document.removeEventListener("focusout", handleFocusOut2);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container,
        focusScope.paused
    ]);
    $jbmdS.useEffect(()=>{
        if (container) {
            $7fdee893af56e859$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($7fdee893af56e859$var$AUTOFOCUS_ON_MOUNT, $7fdee893af56e859$var$EVENT_OPTIONS);
                container.addEventListener($7fdee893af56e859$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $7fdee893af56e859$var$focusFirst($7fdee893af56e859$var$removeLinks($7fdee893af56e859$var$getTabbableCandidates(container)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $7fdee893af56e859$var$focus(container);
                }
            }
            return ()=>{
                container.removeEventListener($7fdee893af56e859$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($7fdee893af56e859$var$AUTOFOCUS_ON_UNMOUNT, $7fdee893af56e859$var$EVENT_OPTIONS);
                    container.addEventListener($7fdee893af56e859$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $7fdee893af56e859$var$focus(previouslyFocusedElement ?? document.body, {
                        select: true
                    });
                    container.removeEventListener($7fdee893af56e859$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $7fdee893af56e859$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]);
    const handleKeyDown = $jbmdS.useCallback((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container2 = event.currentTarget;
            const [first, last] = $7fdee893af56e859$var$getTabbableEdges(container2);
            const hasTabbableElementsInside = first && last;
            if (!hasTabbableElementsInside) {
                if (focusedElement === container2) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $7fdee893af56e859$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $7fdee893af56e859$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).div, {
        tabIndex: -1,
        ...scopeProps,
        ref: composedRefs,
        onKeyDown: handleKeyDown
    });
});
$7fdee893af56e859$export$20e40289641fbbb6.displayName = $7fdee893af56e859$var$FOCUS_SCOPE_NAME;
function $7fdee893af56e859$var$focusFirst(candidates, { select: select = false } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $7fdee893af56e859$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
function $7fdee893af56e859$var$getTabbableEdges(container) {
    const candidates = $7fdee893af56e859$var$getTabbableCandidates(container);
    const first = $7fdee893af56e859$var$findVisible(candidates, container);
    const last = $7fdee893af56e859$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
function $7fdee893af56e859$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode);
    return nodes;
}
function $7fdee893af56e859$var$findVisible(elements, container) {
    for (const element of elements){
        if (!$7fdee893af56e859$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function $7fdee893af56e859$var$isHidden(node, { upTo: upTo }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        if (upTo !== void 0 && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function $7fdee893af56e859$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function $7fdee893af56e859$var$focus(element, { select: select = false } = {}) {
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement;
        element.focus({
            preventScroll: true
        });
        if (element !== previouslyFocusedElement && $7fdee893af56e859$var$isSelectableInput(element) && select) element.select();
    }
}
var $7fdee893af56e859$var$focusScopesStack = $7fdee893af56e859$var$createFocusScopesStack();
function $7fdee893af56e859$var$createFocusScopesStack() {
    let stack = [];
    return {
        add (focusScope) {
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope?.pause();
            stack = $7fdee893af56e859$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            stack = $7fdee893af56e859$var$arrayRemove(stack, focusScope);
            stack[0]?.resume();
        }
    };
}
function $7fdee893af56e859$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $7fdee893af56e859$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
var $7fdee893af56e859$export$be92b6f5f03c0fe9 = $7fdee893af56e859$export$20e40289641fbbb6;

});

parcelRegister("fKp8B", function(module, exports) {

$parcel$export(module.exports, "Portal", function () { return $d02f2246814dffbd$export$602eac185826482c; });
$parcel$export(module.exports, "Root", function () { return $d02f2246814dffbd$export$be92b6f5f03c0fe9; });

var $jbmdS = parcelRequire("jbmdS");

var $jCNM0 = parcelRequire("jCNM0");

var $cihg9 = parcelRequire("cihg9");

var $9crHl = parcelRequire("9crHl");

var $4TLFw = parcelRequire("4TLFw");
"use client";
var $d02f2246814dffbd$var$PORTAL_NAME = "Portal";
var $d02f2246814dffbd$export$602eac185826482c = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { container: containerProp, ...portalProps } = props;
    const [mounted, setMounted] = $jbmdS.useState(false);
    (0, $9crHl.useLayoutEffect)(()=>setMounted(true), []);
    const container = containerProp || mounted && globalThis?.document?.body;
    return container ? (0, (/*@__PURE__*/$parcel$interopDefault($jCNM0))).createPortal(/* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).div, {
        ...portalProps,
        ref: forwardedRef
    }), container) : null;
});
$d02f2246814dffbd$export$602eac185826482c.displayName = $d02f2246814dffbd$var$PORTAL_NAME;
var $d02f2246814dffbd$export$be92b6f5f03c0fe9 = $d02f2246814dffbd$export$602eac185826482c;

});

parcelRegister("joHB8", function(module, exports) {

$parcel$export(module.exports, "Presence", function () { return $5bc908e40ff9eb9e$export$99c2b779aa4e8b8b; });

var $jbmdS = parcelRequire("jbmdS");

var $9sunj = parcelRequire("9sunj");

var $9crHl = parcelRequire("9crHl");
"use client";
function $5bc908e40ff9eb9e$var$useStateMachine(initialState, machine) {
    return $jbmdS.useReducer((state, event)=>{
        const nextState = machine[state][event];
        return nextState ?? state;
    }, initialState);
}
// packages/react/presence/src/Presence.tsx
var $5bc908e40ff9eb9e$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present, children: children } = props;
    const presence = $5bc908e40ff9eb9e$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : $jbmdS.Children.only(children);
    const ref = (0, $9sunj.useComposedRefs)(presence.ref, $5bc908e40ff9eb9e$var$getElementRef(child));
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? $jbmdS.cloneElement(child, {
        ref: ref
    }) : null;
};
$5bc908e40ff9eb9e$export$99c2b779aa4e8b8b.displayName = "Presence";
function $5bc908e40ff9eb9e$var$usePresence(present) {
    const [node, setNode] = $jbmdS.useState();
    const stylesRef = $jbmdS.useRef({});
    const prevPresentRef = $jbmdS.useRef(present);
    const prevAnimationNameRef = $jbmdS.useRef("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $5bc908e40ff9eb9e$var$useStateMachine(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    $jbmdS.useEffect(()=>{
        const currentAnimationName = $5bc908e40ff9eb9e$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $9crHl.useLayoutEffect)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $5bc908e40ff9eb9e$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || styles?.display === "none") send("UNMOUNT");
            else {
                const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $9crHl.useLayoutEffect)(()=>{
        if (node) {
            let timeoutId;
            const ownerWindow = node.ownerDocument.defaultView ?? window;
            const handleAnimationEnd = (event)=>{
                const currentAnimationName = $5bc908e40ff9eb9e$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node && isCurrentAnimation) {
                    send("ANIMATION_END");
                    if (!prevPresentRef.current) {
                        const currentFillMode = node.style.animationFillMode;
                        node.style.animationFillMode = "forwards";
                        timeoutId = ownerWindow.setTimeout(()=>{
                            if (node.style.animationFillMode === "forwards") node.style.animationFillMode = currentFillMode;
                        });
                    }
                }
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node) prevAnimationNameRef.current = $5bc908e40ff9eb9e$var$getAnimationName(stylesRef.current);
            };
            node.addEventListener("animationstart", handleAnimationStart);
            node.addEventListener("animationcancel", handleAnimationEnd);
            node.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                ownerWindow.clearTimeout(timeoutId);
                node.removeEventListener("animationstart", handleAnimationStart);
                node.removeEventListener("animationcancel", handleAnimationEnd);
                node.removeEventListener("animationend", handleAnimationEnd);
            };
        } else send("ANIMATION_END");
    }, [
        node,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: $jbmdS.useCallback((node2)=>{
            if (node2) stylesRef.current = getComputedStyle(node2);
            setNode(node2);
        }, [])
    };
}
function $5bc908e40ff9eb9e$var$getAnimationName(styles) {
    return styles?.animationName || "none";
}
function $5bc908e40ff9eb9e$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}

});

parcelRegister("fbZ8r", function(module, exports) {

$parcel$export(module.exports, "useFocusGuards", function () { return $c14b99d3b80d2afc$export$b7ece24a22aeda8c; });

var $jbmdS = parcelRequire("jbmdS");
"use client";
var $c14b99d3b80d2afc$var$count = 0;
function $c14b99d3b80d2afc$export$ac5b58043b79449b(props) {
    $c14b99d3b80d2afc$export$b7ece24a22aeda8c();
    return props.children;
}
function $c14b99d3b80d2afc$export$b7ece24a22aeda8c() {
    $jbmdS.useEffect(()=>{
        const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
        document.body.insertAdjacentElement("afterbegin", edgeGuards[0] ?? $c14b99d3b80d2afc$var$createFocusGuard());
        document.body.insertAdjacentElement("beforeend", edgeGuards[1] ?? $c14b99d3b80d2afc$var$createFocusGuard());
        $c14b99d3b80d2afc$var$count++;
        return ()=>{
            if ($c14b99d3b80d2afc$var$count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach((node)=>node.remove());
            $c14b99d3b80d2afc$var$count--;
        };
    }, []);
}
function $c14b99d3b80d2afc$var$createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.outline = "none";
    element.style.opacity = "0";
    element.style.position = "fixed";
    element.style.pointerEvents = "none";
    return element;
}
var $c14b99d3b80d2afc$export$be92b6f5f03c0fe9 = $c14b99d3b80d2afc$export$ac5b58043b79449b;

});

parcelRegister("gQkjX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c43143f7c8b27183$export$2e2bcd8739ae039; });

var $53oVd = parcelRequire("53oVd");

var $jbmdS = parcelRequire("jbmdS");

var $5DeBe = parcelRequire("5DeBe");

var $cO4In = parcelRequire("cO4In");
var $c43143f7c8b27183$var$ReactRemoveScroll = $jbmdS.forwardRef(function(props, ref) {
    return $jbmdS.createElement((0, $5DeBe.RemoveScroll), (0, $53oVd.__assign)({}, props, {
        ref: ref,
        sideCar: (0, $cO4In.default)
    }));
});
$c43143f7c8b27183$var$ReactRemoveScroll.classNames = (0, $5DeBe.RemoveScroll).classNames;
var $c43143f7c8b27183$export$2e2bcd8739ae039 = $c43143f7c8b27183$var$ReactRemoveScroll;

});
parcelRegister("5DeBe", function(module, exports) {

$parcel$export(module.exports, "RemoveScroll", function () { return $419beb72bcdd5c2f$export$22940b497e769dee; });

var $53oVd = parcelRequire("53oVd");

var $jbmdS = parcelRequire("jbmdS");

var $2agjQ = parcelRequire("2agjQ");

var $d5w9m = parcelRequire("d5w9m");

var $7JwcA = parcelRequire("7JwcA");
var $419beb72bcdd5c2f$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $419beb72bcdd5c2f$export$22940b497e769dee = $jbmdS.forwardRef(function(props, parentRef) {
    var ref = $jbmdS.useRef(null);
    var _a = $jbmdS.useState({
        onScrollCapture: $419beb72bcdd5c2f$var$nothing,
        onWheelCapture: $419beb72bcdd5c2f$var$nothing,
        onTouchMoveCapture: $419beb72bcdd5c2f$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, gapMode = props.gapMode, rest = (0, $53oVd.__rest)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $d5w9m.useMergeRefs)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $53oVd.__assign)((0, $53oVd.__assign)({}, rest), callbacks);
    return $jbmdS.createElement($jbmdS.Fragment, null, enabled && $jbmdS.createElement(SideCar, {
        sideCar: (0, $7JwcA.effectCar),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? $jbmdS.cloneElement($jbmdS.Children.only(children), (0, $53oVd.__assign)((0, $53oVd.__assign)({}, containerProps), {
        ref: containerRef
    })) : $jbmdS.createElement(Container, (0, $53oVd.__assign)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$419beb72bcdd5c2f$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$419beb72bcdd5c2f$export$22940b497e769dee.classNames = {
    fullWidth: (0, $2agjQ.fullWidthClassName),
    zeroRight: (0, $2agjQ.zeroRightClassName)
};

});
parcelRegister("2agjQ", function(module, exports) {

$parcel$export(module.exports, "zeroRightClassName", function () { return $19392c8f8bb03a58$export$1da7500147d4bc3; });
$parcel$export(module.exports, "fullWidthClassName", function () { return $19392c8f8bb03a58$export$898e37bbd2a0ae4e; });
$parcel$export(module.exports, "noScrollbarsClassName", function () { return $19392c8f8bb03a58$export$bb813dfbbc432abc; });
$parcel$export(module.exports, "removedBarSizeVariable", function () { return $19392c8f8bb03a58$export$63d0edf80fea83b1; });
var $19392c8f8bb03a58$export$1da7500147d4bc3 = "right-scroll-bar-position";
var $19392c8f8bb03a58$export$898e37bbd2a0ae4e = "width-before-scroll-bar";
var $19392c8f8bb03a58$export$bb813dfbbc432abc = "with-scroll-bars-hidden";
var $19392c8f8bb03a58$export$63d0edf80fea83b1 = "--removed-body-scroll-bar-size";

});

parcelRegister("d5w9m", function(module, exports) {

$parcel$export(module.exports, "useMergeRefs", function () { return $9874ae4de43855e8$export$74665b213cb5c4cf; });

var $jbmdS = parcelRequire("jbmdS");

var $7kGR9 = parcelRequire("7kGR9");

var $a848E = parcelRequire("a848E");
var $9874ae4de43855e8$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? $jbmdS.useLayoutEffect : $jbmdS.useEffect;
var $9874ae4de43855e8$var$currentValues = new WeakMap();
function $9874ae4de43855e8$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $a848E.useCallbackRef)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $7kGR9.assignRef)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $9874ae4de43855e8$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $9874ae4de43855e8$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $7kGR9.assignRef)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $7kGR9.assignRef)(ref, current_1);
            });
        }
        $9874ae4de43855e8$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}

});
parcelRegister("7kGR9", function(module, exports) {

$parcel$export(module.exports, "assignRef", function () { return $556ba509447ac23c$export$d734136a7b018efe; });
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $556ba509447ac23c$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}

});

parcelRegister("a848E", function(module, exports) {

$parcel$export(module.exports, "useCallbackRef", function () { return $75fddc8b403674f1$export$25bec8c6f54ee79a; });

var $jbmdS = parcelRequire("jbmdS");
function $75fddc8b403674f1$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $jbmdS.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

});


parcelRegister("7JwcA", function(module, exports) {

$parcel$export(module.exports, "effectCar", function () { return $5a15b7033e82e6a4$export$e27363444bedfeac; });

var $iFDfj = parcelRequire("iFDfj");
var $5a15b7033e82e6a4$export$e27363444bedfeac = (0, $iFDfj.createSidecarMedium)();

});
parcelRegister("iFDfj", function(module, exports) {

$parcel$export(module.exports, "createSidecarMedium", function () { return $d97a7fbd5e38c3c6$export$e13ec7dd7a14088d; });

var $53oVd = parcelRequire("53oVd");
function $d97a7fbd5e38c3c6$var$ItoI(a) {
    return a;
}
function $d97a7fbd5e38c3c6$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $d97a7fbd5e38c3c6$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $d97a7fbd5e38c3c6$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $d97a7fbd5e38c3c6$var$ItoI;
    return $d97a7fbd5e38c3c6$var$innerCreateMedium(defaults, middleware);
}
function $d97a7fbd5e38c3c6$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $d97a7fbd5e38c3c6$var$innerCreateMedium(null);
    medium.options = (0, $53oVd.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}

});



parcelRegister("cO4In", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $952dcfd248d9a6ed$export$2e2bcd8739ae039; });

var $1AqwU = parcelRequire("1AqwU");

var $7LjiU = parcelRequire("7LjiU");

var $7JwcA = parcelRequire("7JwcA");
var $952dcfd248d9a6ed$export$2e2bcd8739ae039 = (0, $1AqwU.exportSidecar)((0, $7JwcA.effectCar), (0, $7LjiU.RemoveScrollSideCar));

});
parcelRegister("1AqwU", function(module, exports) {

$parcel$export(module.exports, "exportSidecar", function () { return $127dbb7c3d779d07$export$6cacc8fb0a9b94ce; });

var $53oVd = parcelRequire("53oVd");

var $jbmdS = parcelRequire("jbmdS");
var $127dbb7c3d779d07$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $53oVd.__rest)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
    var Target = sideCar.read();
    if (!Target) throw new Error("Sidecar medium not found");
    return $jbmdS.createElement(Target, (0, $53oVd.__assign)({}, rest));
};
$127dbb7c3d779d07$var$SideCar.isSideCarExport = true;
function $127dbb7c3d779d07$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $127dbb7c3d779d07$var$SideCar;
}

});

parcelRegister("7LjiU", function(module, exports) {

$parcel$export(module.exports, "RemoveScrollSideCar", function () { return $5a6be58f648eecbb$export$a09dbff87b5da2d; });

var $53oVd = parcelRequire("53oVd");

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("geJTE");
var $h5klF = parcelRequire("h5klF");
parcelRequire("5yDIS");
var $i5wAQ = parcelRequire("i5wAQ");

var $jIMc7 = parcelRequire("jIMc7");

var $9Rxy4 = parcelRequire("9Rxy4");
var $5a6be58f648eecbb$export$6e085704a79f4f56 = function(event) {
    return "changedTouches" in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $5a6be58f648eecbb$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $5a6be58f648eecbb$var$extractRef = function(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $5a6be58f648eecbb$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $5a6be58f648eecbb$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $5a6be58f648eecbb$var$idCounter = 0;
var $5a6be58f648eecbb$var$lockStack = [];
function $5a6be58f648eecbb$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $jbmdS.useRef([]);
    var touchStartRef = $jbmdS.useRef([
        0,
        0
    ]);
    var activeAxis = $jbmdS.useRef();
    var id = $jbmdS.useState($5a6be58f648eecbb$var$idCounter++)[0];
    var Style = $jbmdS.useState((0, $i5wAQ.styleSingleton))[0];
    var lastProps = $jbmdS.useRef(props);
    $jbmdS.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $jbmdS.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $53oVd.__spreadArray)([
                props.lockRef.current
            ], (props.shards || []).map($5a6be58f648eecbb$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $jbmdS.useCallback(function(event, parent) {
        if ("touches" in event && event.touches.length === 2 || event.type === "wheel" && event.ctrlKey) return !lastProps.current.allowPinchZoom;
        var touch = $5a6be58f648eecbb$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ("touches" in event && moveDirection === "h" && target.type === "range") return false;
        var canBeScrolledInMainDirection = (0, $9Rxy4.locationCouldBeScrolled)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === "v" ? "h" : "v";
            canBeScrolledInMainDirection = (0, $9Rxy4.locationCouldBeScrolled)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $9Rxy4.handleScroll)(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $jbmdS.useCallback(function(_event) {
        var event = _event;
        if (!$5a6be58f648eecbb$var$lockStack.length || $5a6be58f648eecbb$var$lockStack[$5a6be58f648eecbb$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = "deltaY" in event ? $5a6be58f648eecbb$export$39efaa2ca254a28d(event) : $5a6be58f648eecbb$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && $5a6be58f648eecbb$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($5a6be58f648eecbb$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $jbmdS.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should,
            shadowParent: $5a6be58f648eecbb$var$getOutermostShadowParent(target)
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $jbmdS.useCallback(function(event) {
        touchStartRef.current = $5a6be58f648eecbb$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $jbmdS.useCallback(function(event) {
        shouldCancel(event.type, $5a6be58f648eecbb$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $jbmdS.useCallback(function(event) {
        shouldCancel(event.type, $5a6be58f648eecbb$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $jbmdS.useEffect(function() {
        $5a6be58f648eecbb$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener("wheel", shouldPrevent, (0, $jIMc7.nonPassive));
        document.addEventListener("touchmove", shouldPrevent, (0, $jIMc7.nonPassive));
        document.addEventListener("touchstart", scrollTouchStart, (0, $jIMc7.nonPassive));
        return function() {
            $5a6be58f648eecbb$var$lockStack = $5a6be58f648eecbb$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener("wheel", shouldPrevent, (0, $jIMc7.nonPassive));
            document.removeEventListener("touchmove", shouldPrevent, (0, $jIMc7.nonPassive));
            document.removeEventListener("touchstart", scrollTouchStart, (0, $jIMc7.nonPassive));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $jbmdS.createElement($jbmdS.Fragment, null, inert ? $jbmdS.createElement(Style, {
        styles: $5a6be58f648eecbb$var$generateStyle(id)
    }) : null, removeScrollBar ? $jbmdS.createElement((0, $h5klF.RemoveScrollBar), {
        gapMode: props.gapMode
    }) : null);
}
function $5a6be58f648eecbb$var$getOutermostShadowParent(node) {
    var shadowParent = null;
    while(node !== null){
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}

});
parcelRegister("geJTE", function(module, exports) {

$parcel$export(module.exports, "RemoveScrollBar", function () { return (parcelRequire("h5klF")).RemoveScrollBar; });

var $h5klF = parcelRequire("h5klF");

var $2agjQ = parcelRequire("2agjQ");

var $9bvpe = parcelRequire("9bvpe");

});
parcelRegister("h5klF", function(module, exports) {

$parcel$export(module.exports, "RemoveScrollBar", function () { return $c702b011fa66b2e1$export$9aa43b459c5ae9b9; });

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("5yDIS");
var $i5wAQ = parcelRequire("i5wAQ");

var $2agjQ = parcelRequire("2agjQ");

var $9bvpe = parcelRequire("9bvpe");
var $c702b011fa66b2e1$var$Style = (0, $i5wAQ.styleSingleton)();
var $c702b011fa66b2e1$export$65254d5f26cb9564 = "data-scroll-locked";
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $c702b011fa66b2e1$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = "margin";
    return "\n  .".concat((0, $2agjQ.noScrollbarsClassName), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat($c702b011fa66b2e1$export$65254d5f26cb9564, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(""), "\n  }\n  \n  .").concat((0, $2agjQ.zeroRightClassName), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $2agjQ.fullWidthClassName), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $2agjQ.zeroRightClassName), " .").concat((0, $2agjQ.zeroRightClassName), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $2agjQ.fullWidthClassName), " .").concat((0, $2agjQ.fullWidthClassName), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat($c702b011fa66b2e1$export$65254d5f26cb9564, "] {\n    ").concat((0, $2agjQ.removedBarSizeVariable), ": ").concat(gap, "px;\n  }\n");
};
var $c702b011fa66b2e1$var$getCurrentUseCounter = function() {
    var counter = parseInt(document.body.getAttribute($c702b011fa66b2e1$export$65254d5f26cb9564) || "0", 10);
    return isFinite(counter) ? counter : 0;
};
var $c702b011fa66b2e1$export$a1939b1f9f9b02dc = function() {
    $jbmdS.useEffect(function() {
        document.body.setAttribute($c702b011fa66b2e1$export$65254d5f26cb9564, ($c702b011fa66b2e1$var$getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = $c702b011fa66b2e1$var$getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute($c702b011fa66b2e1$export$65254d5f26cb9564);
            else document.body.setAttribute($c702b011fa66b2e1$export$65254d5f26cb9564, newCounter.toString());
        };
    }, []);
};
var $c702b011fa66b2e1$export$9aa43b459c5ae9b9 = function(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? "margin" : _b;
    $c702b011fa66b2e1$export$a1939b1f9f9b02dc();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $jbmdS.useMemo(function() {
        return (0, $9bvpe.getGapWidth)(gapMode);
    }, [
        gapMode
    ]);
    return $jbmdS.createElement($c702b011fa66b2e1$var$Style, {
        styles: $c702b011fa66b2e1$var$getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "")
    });
};

});
parcelRegister("5yDIS", function(module, exports) {

$parcel$export(module.exports, "styleSingleton", function () { return (parcelRequire("i5wAQ")).styleSingleton; });

var $i5wAQ = parcelRequire("i5wAQ");

var $3SsmW = parcelRequire("3SsmW");

var $howIy = parcelRequire("howIy");

});
parcelRegister("i5wAQ", function(module, exports) {

$parcel$export(module.exports, "styleSingleton", function () { return $d2b1f9f4d140c833$export$c1248ee86ba532c8; });

var $howIy = parcelRequire("howIy");
var $d2b1f9f4d140c833$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $howIy.styleHookSingleton)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};

});
parcelRegister("howIy", function(module, exports) {

$parcel$export(module.exports, "styleHookSingleton", function () { return $ca9e0e9c52f51952$export$7d7b35c2d250e94c; });

var $jbmdS = parcelRequire("jbmdS");

var $3SsmW = parcelRequire("3SsmW");
var $ca9e0e9c52f51952$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $3SsmW.stylesheetSingleton)();
    return function(styles, isDynamic) {
        $jbmdS.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};

});
parcelRegister("3SsmW", function(module, exports) {

$parcel$export(module.exports, "stylesheetSingleton", function () { return $2d2c6bbc9e56a471$export$7c74eec858d5d226; });

var $3xb20 = parcelRequire("3xb20");
function $2d2c6bbc9e56a471$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement("style");
    tag.type = "text/css";
    var nonce = (0, $3xb20.getNonce)();
    if (nonce) tag.setAttribute("nonce", nonce);
    return tag;
}
function $2d2c6bbc9e56a471$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $2d2c6bbc9e56a471$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(tag);
}
var $2d2c6bbc9e56a471$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $2d2c6bbc9e56a471$var$makeStyleTag()) {
                    $2d2c6bbc9e56a471$var$injectStyles(stylesheet, style);
                    $2d2c6bbc9e56a471$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};

});
parcelRegister("3xb20", function(module, exports) {

$parcel$export(module.exports, "getNonce", function () { return $292d02c1eae3aeae$export$2b85b721e524d74b; });
var $292d02c1eae3aeae$var$currentNonce;
var $292d02c1eae3aeae$export$c5f670b24c0ae95a = function(nonce) {
    $292d02c1eae3aeae$var$currentNonce = nonce;
};
var $292d02c1eae3aeae$export$2b85b721e524d74b = function() {
    if ($292d02c1eae3aeae$var$currentNonce) return $292d02c1eae3aeae$var$currentNonce;
    if (typeof __webpack_nonce__ !== "undefined") return __webpack_nonce__;
    return undefined;
};

});





parcelRegister("9bvpe", function(module, exports) {

$parcel$export(module.exports, "getGapWidth", function () { return $6afd80b3f364300b$export$75f2ca8f029c77f4; });
var $6afd80b3f364300b$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $6afd80b3f364300b$var$parse = function(x) {
    return parseInt(x || "", 10) || 0;
};
var $6afd80b3f364300b$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
    var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
    var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
    return [
        $6afd80b3f364300b$var$parse(left),
        $6afd80b3f364300b$var$parse(top),
        $6afd80b3f364300b$var$parse(right)
    ];
};
var $6afd80b3f364300b$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = "margin";
    if (typeof window === "undefined") return $6afd80b3f364300b$export$efed13b5d0ca3386;
    var offsets = $6afd80b3f364300b$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};

});



parcelRegister("jIMc7", function(module, exports) {

$parcel$export(module.exports, "nonPassive", function () { return $e5b782c9f8c37adf$export$10a6e88623fa9454; });
var $e5b782c9f8c37adf$var$passiveSupported = false;
if (typeof window !== "undefined") try {
    var $e5b782c9f8c37adf$var$options = Object.defineProperty({}, "passive", {
        get: function() {
            $e5b782c9f8c37adf$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener("test", $e5b782c9f8c37adf$var$options, $e5b782c9f8c37adf$var$options);
    // @ts-ignore
    window.removeEventListener("test", $e5b782c9f8c37adf$var$options, $e5b782c9f8c37adf$var$options);
} catch (err) {
    $e5b782c9f8c37adf$var$passiveSupported = false;
}
var $e5b782c9f8c37adf$export$10a6e88623fa9454 = $e5b782c9f8c37adf$var$passiveSupported ? {
    passive: false
} : false;

});

parcelRegister("9Rxy4", function(module, exports) {

$parcel$export(module.exports, "locationCouldBeScrolled", function () { return $72e316560bbe6949$export$9ec64480cae49817; });
$parcel$export(module.exports, "handleScroll", function () { return $72e316560bbe6949$export$dde0441bd4a6ded8; });
var $72e316560bbe6949$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === "TEXTAREA";
};
var $72e316560bbe6949$var$elementCanBeScrolled = function(node, overflow) {
    if (!(node instanceof Element)) return false;
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== "hidden" && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$72e316560bbe6949$var$alwaysContainsScroll(node) && styles[overflow] === "visible"));
};
var $72e316560bbe6949$var$elementCouldBeVScrolled = function(node) {
    return $72e316560bbe6949$var$elementCanBeScrolled(node, "overflowY");
};
var $72e316560bbe6949$var$elementCouldBeHScrolled = function(node) {
    return $72e316560bbe6949$var$elementCanBeScrolled(node, "overflowX");
};
var $72e316560bbe6949$export$9ec64480cae49817 = function(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $72e316560bbe6949$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $72e316560bbe6949$var$getScrollVariables(axis, current), scrollHeight = _a[1], clientHeight = _a[2];
            if (scrollHeight > clientHeight) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var $72e316560bbe6949$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $72e316560bbe6949$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $72e316560bbe6949$var$elementCouldBeScrolled = function(axis, node) {
    return axis === "v" ? $72e316560bbe6949$var$elementCouldBeVScrolled(node) : $72e316560bbe6949$var$elementCouldBeHScrolled(node);
};
var $72e316560bbe6949$var$getScrollVariables = function(axis, node) {
    return axis === "v" ? $72e316560bbe6949$var$getVScrollVariables(node) : $72e316560bbe6949$var$getHScrollVariables(node);
};
var $72e316560bbe6949$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === "h" && direction === "rtl" ? -1 : 1;
};
var $72e316560bbe6949$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $72e316560bbe6949$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = $72e316560bbe6949$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($72e316560bbe6949$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        if (target instanceof ShadowRoot) target = target.host;
        else target = target.parentNode;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};

});




parcelRegister("9Y02g", function(module, exports) {

$parcel$export(module.exports, "hideOthers", function () { return $7419beb8b5cffd17$export$6e33d16126ed003c; });
var $7419beb8b5cffd17$var$getDefaultParent = function(originalTarget) {
    if (typeof document === "undefined") return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $7419beb8b5cffd17$var$counterMap = new WeakMap();
var $7419beb8b5cffd17$var$uncontrolledNodes = new WeakMap();
var $7419beb8b5cffd17$var$markerMap = {};
var $7419beb8b5cffd17$var$lockCount = 0;
var $7419beb8b5cffd17$var$unwrapHost = function(node) {
    return node && (node.host || $7419beb8b5cffd17$var$unwrapHost(node.parentNode));
};
var $7419beb8b5cffd17$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $7419beb8b5cffd17$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $7419beb8b5cffd17$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $7419beb8b5cffd17$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$7419beb8b5cffd17$var$markerMap[markerName]) $7419beb8b5cffd17$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $7419beb8b5cffd17$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else try {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== "false";
                var counterValue = ($7419beb8b5cffd17$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $7419beb8b5cffd17$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $7419beb8b5cffd17$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, "true");
                if (!alreadyHidden) node.setAttribute(controlAttribute, "true");
            } catch (e) {
                console.error("aria-hidden: cannot operate on ", node, e);
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $7419beb8b5cffd17$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $7419beb8b5cffd17$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $7419beb8b5cffd17$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$7419beb8b5cffd17$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $7419beb8b5cffd17$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $7419beb8b5cffd17$var$lockCount--;
        if (!$7419beb8b5cffd17$var$lockCount) {
            // clear
            $7419beb8b5cffd17$var$counterMap = new WeakMap();
            $7419beb8b5cffd17$var$counterMap = new WeakMap();
            $7419beb8b5cffd17$var$uncontrolledNodes = new WeakMap();
            $7419beb8b5cffd17$var$markerMap = {};
        }
    };
};
var $7419beb8b5cffd17$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-aria-hidden";
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $7419beb8b5cffd17$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide ariaLive elements - https://github.com/theKashey/aria-hidden/issues/10
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live]")));
    return $7419beb8b5cffd17$var$applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};
var $7419beb8b5cffd17$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-inert-ed";
    var activeParentNode = parentNode || $7419beb8b5cffd17$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $7419beb8b5cffd17$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, "inert");
};
var $7419beb8b5cffd17$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== "undefined" && HTMLElement.prototype.hasOwnProperty("inert");
};
var $7419beb8b5cffd17$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-suppressed";
    return ($7419beb8b5cffd17$export$cc95fea82d705fca() ? $7419beb8b5cffd17$export$59151cc8db999a24 : $7419beb8b5cffd17$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};

});


parcelRegister("jSiTu", function(module, exports) {

$parcel$export(module.exports, "ArrowDownIcon", function () { return $e781b76dcad7c5d5$export$1c939d3c9b6931b; });
$parcel$export(module.exports, "ArrowUpIcon", function () { return $e781b76dcad7c5d5$export$f1a507b991affc46; });
$parcel$export(module.exports, "CaretSortIcon", function () { return $e781b76dcad7c5d5$export$432020ae7f5a1085; });
$parcel$export(module.exports, "CheckIcon", function () { return $e781b76dcad7c5d5$export$7dd004358974b05d; });
$parcel$export(module.exports, "ChevronDownIcon", function () { return $e781b76dcad7c5d5$export$4857d3f3f5f8319b; });
$parcel$export(module.exports, "ChevronUpIcon", function () { return $e781b76dcad7c5d5$export$7f01a6cbee61a0f2; });
$parcel$export(module.exports, "Cross2Icon", function () { return $e781b76dcad7c5d5$export$b7fa469a3cb3cd4f; });
$parcel$export(module.exports, "EyeNoneIcon", function () { return $e781b76dcad7c5d5$export$3547759c3ff9b44c; });
$parcel$export(module.exports, "InfoCircledIcon", function () { return $e781b76dcad7c5d5$export$7a1b52edf33ca2d9; });
$parcel$export(module.exports, "MagnifyingGlassIcon", function () { return $e781b76dcad7c5d5$export$f7658c347b037c3f; });
$parcel$export(module.exports, "MixIcon", function () { return $e781b76dcad7c5d5$export$7829447535316b17; });
$parcel$export(module.exports, "MixerHorizontalIcon", function () { return $e781b76dcad7c5d5$export$5560e721cf131890; });
$parcel$export(module.exports, "PlusIcon", function () { return $e781b76dcad7c5d5$export$f21ab0717a89c77f; });
$parcel$export(module.exports, "TrashIcon", function () { return $e781b76dcad7c5d5$export$d23329de703dffc4; });

var $jbmdS = parcelRequire("jbmdS");
function $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $e781b76dcad7c5d5$var$_excluded = [
    "color"
];
var $e781b76dcad7c5d5$export$12f5813a529780ed = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M0.877197 7.49984C0.877197 3.84216 3.84234 0.877014 7.50003 0.877014C11.1577 0.877014 14.1229 3.84216 14.1229 7.49984C14.1229 11.1575 11.1577 14.1227 7.50003 14.1227C3.84234 14.1227 0.877197 11.1575 0.877197 7.49984ZM7.50003 1.82701C4.36702 1.82701 1.8272 4.36683 1.8272 7.49984C1.8272 10.6328 4.36702 13.1727 7.50003 13.1727C10.633 13.1727 13.1729 10.6328 13.1729 7.49984C13.1729 4.36683 10.633 1.82701 7.50003 1.82701ZM7.12457 9.00001C7.06994 9.12735 6.33165 11.9592 6.33165 11.9592C6.26018 12.226 5.98601 12.3843 5.71928 12.3128C5.45255 12.2413 5.29425 11.9672 5.36573 11.7004C5.36573 11.7004 6.24661 8.87268 6.24661 8.27007V6.80099L4.28763 6.27608C4.0209 6.20461 3.86261 5.93045 3.93408 5.66371C4.00555 5.39698 4.27972 5.23869 4.54645 5.31016C4.54645 5.31016 6.20042 5.87268 6.84579 5.87268H8.15505C8.80042 5.87268 10.4534 5.31042 10.4534 5.31042C10.7202 5.23895 10.9943 5.39724 11.0658 5.66397C11.1373 5.93071 10.979 6.20487 10.7122 6.27635L8.74661 6.80303V8.27007C8.74661 8.87268 9.62663 11.6971 9.62663 11.6971C9.6981 11.9639 9.5398 12.238 9.27307 12.3095C9.00634 12.381 8.73217 12.2227 8.6607 11.956C8.6607 11.956 7.91994 9.12735 7.86866 9.00001C7.81994 8.87268 7.65006 8.87268 7.65006 8.87268H7.34317C7.34317 8.87268 7.16994 8.87268 7.12457 9.00001ZM7.50043 5.12007C8.12175 5.12007 8.62543 4.61639 8.62543 3.99507C8.62543 3.37375 8.12175 2.87007 7.50043 2.87007C6.87911 2.87007 6.37543 3.37375 6.37543 3.99507C6.37543 4.61639 6.87911 5.12007 7.50043 5.12007Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1 = [
    "color"
];
var $e781b76dcad7c5d5$export$c40c07f3e63e590d = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M0 1.5C0 1.22386 0.223858 1 0.5 1H2.5C2.77614 1 3 1.22386 3 1.5C3 1.77614 2.77614 2 2.5 2H0.5C0.223858 2 0 1.77614 0 1.5ZM4 1.5C4 1.22386 4.22386 1 4.5 1H14.5C14.7761 1 15 1.22386 15 1.5C15 1.77614 14.7761 2 14.5 2H4.5C4.22386 2 4 1.77614 4 1.5ZM4 4.5C4 4.22386 4.22386 4 4.5 4H11.5C11.7761 4 12 4.22386 12 4.5C12 4.77614 11.7761 5 11.5 5H4.5C4.22386 5 4 4.77614 4 4.5ZM0 7.5C0 7.22386 0.223858 7 0.5 7H2.5C2.77614 7 3 7.22386 3 7.5C3 7.77614 2.77614 8 2.5 8H0.5C0.223858 8 0 7.77614 0 7.5ZM4 7.5C4 7.22386 4.22386 7 4.5 7H14.5C14.7761 7 15 7.22386 15 7.5C15 7.77614 14.7761 8 14.5 8H4.5C4.22386 8 4 7.77614 4 7.5ZM4 10.5C4 10.2239 4.22386 10 4.5 10H11.5C11.7761 10 12 10.2239 12 10.5C12 10.7761 11.7761 11 11.5 11H4.5C4.22386 11 4 10.7761 4 10.5ZM0 13.5C0 13.2239 0.223858 13 0.5 13H2.5C2.77614 13 3 13.2239 3 13.5C3 13.7761 2.77614 14 2.5 14H0.5C0.223858 14 0 13.7761 0 13.5ZM4 13.5C4 13.2239 4.22386 13 4.5 13H14.5C14.7761 13 15 13.2239 15 13.5C15 13.7761 14.7761 14 14.5 14H4.5C4.22386 14 4 13.7761 4 13.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2 = [
    "color"
];
var $e781b76dcad7c5d5$export$315d3fae607b3916 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M10.5 1.75003C10.7107 1.75003 10.8988 1.88217 10.9703 2.08042L13.9703 10.4C14.064 10.6598 13.9293 10.9463 13.6696 11.04C13.4098 11.1336 13.1233 10.999 13.0296 10.7392L12.0477 8.01606H8.95227L7.97031 10.7392C7.87664 10.999 7.59012 11.1336 7.33035 11.04C7.07058 10.9463 6.93593 10.6598 7.0296 10.4L10.0296 2.08042C10.1011 1.88217 10.2892 1.75003 10.5 1.75003ZM10.5 3.72402L11.7411 7.16606H9.25877L10.5 3.72402ZM2.49949 2.09997C2.7204 2.09997 2.89949 2.27906 2.89949 2.49997L2.89949 9.53428L4.21664 8.21713C4.37285 8.06092 4.62612 8.06092 4.78233 8.21713C4.93854 8.37334 4.93854 8.6266 4.78233 8.78281L2.78233 10.7828C2.70732 10.8578 2.60557 10.9 2.49949 10.9C2.3934 10.9 2.29166 10.8578 2.21664 10.7828L0.216645 8.78281C0.0604349 8.6266 0.0604349 8.37334 0.216645 8.21713C0.372854 8.06092 0.62612 8.06092 0.78233 8.21713L2.09949 9.53428L2.09949 2.49997C2.09949 2.27906 2.27857 2.09997 2.49949 2.09997ZM0.0999695 13.5001C0.0999695 13.2791 0.279056 13.1001 0.499969 13.1001H14.5C14.7209 13.1001 14.9 13.2791 14.9 13.5001C14.9 13.721 14.7209 13.9001 14.5 13.9001H0.499969C0.279056 13.9001 0.0999695 13.721 0.0999695 13.5001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3 = [
    "color"
];
var $e781b76dcad7c5d5$export$28c63a2a77a6b6ba = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M9 3C9 2.44772 8.55229 2 8 2H7C6.44772 2 6 2.44772 6 3L6 14H1.5C1.22386 14 1 14.2239 1 14.5C1 14.7761 1.22386 15 1.5 15L6 15H9H13.5C13.7761 15 14 14.7761 14 14.5C14 14.2239 13.7761 14 13.5 14H9V3Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4 = [
    "color"
];
var $e781b76dcad7c5d5$export$5284d356b9eb3ea0 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M1.99988 6C1.44759 6 0.999877 6.44772 0.999877 7L0.999877 8C0.999877 8.55228 1.44759 9 1.99988 9L6.99988 9L6.99988 13.5C6.99988 13.7761 7.22374 14 7.49988 14C7.77602 14 7.99988 13.7761 7.99988 13.5L7.99988 9L12.9999 9C13.5522 9 13.9999 8.55228 13.9999 8L13.9999 7C13.9999 6.44772 13.5522 6 12.9999 6L7.99988 6L7.99988 1.5C7.99988 1.22386 7.77602 1 7.49988 1C7.22373 1 6.99988 1.22386 6.99988 1.5L6.99988 6L1.99988 6Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$5 = [
    "color"
];
var $e781b76dcad7c5d5$export$a87e0381c7863d70 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$5);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M6.99988 1C6.44759 1 5.99988 1.44772 5.99988 2V7H1.49988C1.22374 7 0.999878 7.22386 0.999878 7.5C0.999878 7.77614 1.22374 8 1.49988 8H5.99988V13C5.99988 13.5523 6.44759 14 6.99988 14H7.99988C8.55216 14 8.99988 13.5523 8.99988 13V8H13.4999C13.776 8 13.9999 7.77614 13.9999 7.5C13.9999 7.22386 13.776 7 13.4999 7H8.99988V2C8.99988 1.44772 8.55216 1 7.99988 1L6.99988 1Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$6 = [
    "color"
];
var $e781b76dcad7c5d5$export$43a2a6205c884160 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$6);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M0.499995 0.999995C0.223855 0.999995 -5.58458e-07 1.22385 -5.46388e-07 1.49999L-2.18554e-08 13.4999C-9.78492e-09 13.776 0.223855 13.9999 0.499995 13.9999C0.776136 13.9999 0.999991 13.776 0.999991 13.4999L0.999991 8.99993L12 8.99993C12.5523 8.99993 13 8.55222 13 7.99993L13 6.99994C13 6.44766 12.5523 5.99995 12 5.99995L0.999991 5.99995L0.999991 1.49999C0.999991 1.22385 0.776135 0.999995 0.499995 0.999995Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$7 = [
    "color"
];
var $e781b76dcad7c5d5$export$589ba7400e24d687 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$7);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M14.4999 1C14.2237 1 13.9999 1.22386 13.9999 1.5L13.9999 6L2.99988 6C2.44759 6 1.99988 6.44772 1.99988 7L1.99988 8C1.99988 8.55228 2.44759 9 2.99988 9L13.9999 9L13.9999 13.5C13.9999 13.7761 14.2237 14 14.4999 14C14.776 14 14.9999 13.7761 14.9999 13.5L14.9999 9L14.9999 6L14.9999 1.5C14.9999 1.22386 14.776 1 14.4999 1Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$8 = [
    "color"
];
var $e781b76dcad7c5d5$export$359aaf594ac84c59 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$8);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M1.5 0C1.22386 0 1 0.223858 1 0.5C1 0.776142 1.22386 1 1.5 1H6V12C6 12.5523 6.44772 13 7 13H8C8.55228 13 9 12.5523 9 12V1H13.5C13.7761 1 14 0.776142 14 0.5C14 0.223858 13.7761 0 13.5 0H9H6H1.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$9 = [
    "color"
];
var $e781b76dcad7c5d5$export$c5eda4f4203e72ab = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$9);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.5 0.75L9.75 3H5.25L7.5 0.75ZM7.5 14.25L9.75 12H5.25L7.5 14.25ZM3 5.25L0.75 7.5L3 9.75V5.25ZM14.25 7.5L12 5.25V9.75L14.25 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$a = [
    "color"
];
var $e781b76dcad7c5d5$export$c3671dfffcc20189 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$a);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M8.8914 2.1937C9.1158 2.35464 9.16725 2.66701 9.00631 2.89141L2.47388 12H13.5C13.7761 12 14 12.2239 14 12.5C14 12.7762 13.7761 13 13.5 13H1.5C1.31254 13 1.14082 12.8952 1.0552 12.7284C0.969578 12.5616 0.984438 12.361 1.09369 12.2086L8.19369 2.30862C8.35462 2.08422 8.667 2.03277 8.8914 2.1937ZM11.1 6.50001C11.1 6.22387 11.3238 6.00001 11.6 6.00001C11.8761 6.00001 12.1 6.22387 12.1 6.50001C12.1 6.77615 11.8761 7.00001 11.6 7.00001C11.3238 7.00001 11.1 6.77615 11.1 6.50001ZM10.4 4.00001C10.1239 4.00001 9.90003 4.22387 9.90003 4.50001C9.90003 4.77615 10.1239 5.00001 10.4 5.00001C10.6762 5.00001 10.9 4.77615 10.9 4.50001C10.9 4.22387 10.6762 4.00001 10.4 4.00001ZM12.1 8.50001C12.1 8.22387 12.3238 8.00001 12.6 8.00001C12.8761 8.00001 13.1 8.22387 13.1 8.50001C13.1 8.77615 12.8761 9.00001 12.6 9.00001C12.3238 9.00001 12.1 8.77615 12.1 8.50001ZM13.4 10C13.1239 10 12.9 10.2239 12.9 10.5C12.9 10.7761 13.1239 11 13.4 11C13.6762 11 13.9 10.7761 13.9 10.5C13.9 10.2239 13.6762 10 13.4 10Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$b = [
    "color"
];
var $e781b76dcad7c5d5$export$64abfa02d870a554 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$b);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M3.30902 1C2.93025 1 2.58398 1.214 2.41459 1.55279L1.05279 4.27639C1.01807 4.34582 1 4.42238 1 4.5V13C1 13.5523 1.44772 14 2 14H13C13.5523 14 14 13.5523 14 13V4.5C14 4.42238 13.9819 4.34582 13.9472 4.27639L12.5854 1.55281C12.416 1.21403 12.0698 1.00003 11.691 1.00003L7.5 1.00001L3.30902 1ZM3.30902 2L7 2.00001V4H2.30902L3.30902 2ZM8 4V2.00002L11.691 2.00003L12.691 4H8ZM7.5 5H13V13H2V5H7.5ZM5.5 7C5.22386 7 5 7.22386 5 7.5C5 7.77614 5.22386 8 5.5 8H9.5C9.77614 8 10 7.77614 10 7.5C10 7.22386 9.77614 7 9.5 7H5.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$c = [
    "color"
];
var $e781b76dcad7c5d5$export$ba8ee9ef4800b4a5 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$c);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M11.3536 3.64644C11.5488 3.8417 11.5488 4.15828 11.3536 4.35354L4.70711 11L9 11C9.27614 11 9.5 11.2239 9.5 11.5C9.5 11.7761 9.27614 12 9 12L3.5 12C3.36739 12 3.24021 11.9473 3.14645 11.8536C3.05268 11.7598 3 11.6326 3 11.5L3 5.99999C3 5.72385 3.22386 5.49999 3.5 5.49999C3.77614 5.49999 4 5.72385 4 5.99999V10.2929L10.6464 3.64643C10.8417 3.45117 11.1583 3.45117 11.3536 3.64644Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$d = [
    "color"
];
var $e781b76dcad7c5d5$export$1a0b00ff4e10643e = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$d);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M3.64645 3.64644C3.45118 3.8417 3.45118 4.15828 3.64645 4.35354L10.2929 11L6 11C5.72386 11 5.5 11.2239 5.5 11.5C5.5 11.7761 5.72386 12 6 12L11.5 12C11.6326 12 11.7598 11.9473 11.8536 11.8536C11.9473 11.7598 12 11.6326 12 11.5L12 5.99999C12 5.72385 11.7761 5.49999 11.5 5.49999C11.2239 5.49999 11 5.72385 11 5.99999V10.2929L4.35355 3.64643C4.15829 3.45117 3.84171 3.45117 3.64645 3.64644Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$e = [
    "color"
];
var $e781b76dcad7c5d5$export$1c939d3c9b6931b = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$e);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.5 2C7.77614 2 8 2.22386 8 2.5L8 11.2929L11.1464 8.14645C11.3417 7.95118 11.6583 7.95118 11.8536 8.14645C12.0488 8.34171 12.0488 8.65829 11.8536 8.85355L7.85355 12.8536C7.75979 12.9473 7.63261 13 7.5 13C7.36739 13 7.24021 12.9473 7.14645 12.8536L3.14645 8.85355C2.95118 8.65829 2.95118 8.34171 3.14645 8.14645C3.34171 7.95118 3.65829 7.95118 3.85355 8.14645L7 11.2929L7 2.5C7 2.22386 7.22386 2 7.5 2Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$f = [
    "color"
];
var $e781b76dcad7c5d5$export$8afed21ef5c2afa5 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$f);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M6.85355 3.14645C7.04882 3.34171 7.04882 3.65829 6.85355 3.85355L3.70711 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H3.70711L6.85355 11.1464C7.04882 11.3417 7.04882 11.6583 6.85355 11.8536C6.65829 12.0488 6.34171 12.0488 6.14645 11.8536L2.14645 7.85355C1.95118 7.65829 1.95118 7.34171 2.14645 7.14645L6.14645 3.14645C6.34171 2.95118 6.65829 2.95118 6.85355 3.14645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$g = [
    "color"
];
var $e781b76dcad7c5d5$export$9ca09caa9c849d9c = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$g);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M8.14645 3.14645C8.34171 2.95118 8.65829 2.95118 8.85355 3.14645L12.8536 7.14645C13.0488 7.34171 13.0488 7.65829 12.8536 7.85355L8.85355 11.8536C8.65829 12.0488 8.34171 12.0488 8.14645 11.8536C7.95118 11.6583 7.95118 11.3417 8.14645 11.1464L11.2929 8H2.5C2.22386 8 2 7.77614 2 7.5C2 7.22386 2.22386 7 2.5 7H11.2929L8.14645 3.85355C7.95118 3.65829 7.95118 3.34171 8.14645 3.14645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$h = [
    "color"
];
var $e781b76dcad7c5d5$export$9f5fe8cc556ac1f3 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$h);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M11.3536 11.3536C11.5488 11.1583 11.5488 10.8417 11.3536 10.6465L4.70711 4L9 4C9.27614 4 9.5 3.77614 9.5 3.5C9.5 3.22386 9.27614 3 9 3L3.5 3C3.36739 3 3.24021 3.05268 3.14645 3.14645C3.05268 3.24022 3 3.36739 3 3.5L3 9.00001C3 9.27615 3.22386 9.50001 3.5 9.50001C3.77614 9.50001 4 9.27615 4 9.00001V4.70711L10.6464 11.3536C10.8417 11.5488 11.1583 11.5488 11.3536 11.3536Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$i = [
    "color"
];
var $e781b76dcad7c5d5$export$64a9bd58f7494197 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$i);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M3.64645 11.3536C3.45118 11.1583 3.45118 10.8417 3.64645 10.6465L10.2929 4L6 4C5.72386 4 5.5 3.77614 5.5 3.5C5.5 3.22386 5.72386 3 6 3L11.5 3C11.6326 3 11.7598 3.05268 11.8536 3.14645C11.9473 3.24022 12 3.36739 12 3.5L12 9.00001C12 9.27615 11.7761 9.50001 11.5 9.50001C11.2239 9.50001 11 9.27615 11 9.00001V4.70711L4.35355 11.3536C4.15829 11.5488 3.84171 11.5488 3.64645 11.3536Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$j = [
    "color"
];
var $e781b76dcad7c5d5$export$f1a507b991affc46 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$j);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.14645 2.14645C7.34171 1.95118 7.65829 1.95118 7.85355 2.14645L11.8536 6.14645C12.0488 6.34171 12.0488 6.65829 11.8536 6.85355C11.6583 7.04882 11.3417 7.04882 11.1464 6.85355L8 3.70711L8 12.5C8 12.7761 7.77614 13 7.5 13C7.22386 13 7 12.7761 7 12.5L7 3.70711L3.85355 6.85355C3.65829 7.04882 3.34171 7.04882 3.14645 6.85355C2.95118 6.65829 2.95118 6.34171 3.14645 6.14645L7.14645 2.14645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$k = [
    "color"
];
var $e781b76dcad7c5d5$export$843c734d18c2237 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$k);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M2.5 2H12.5C12.7761 2 13 2.22386 13 2.5V12.5C13 12.7761 12.7761 13 12.5 13H2.5C2.22386 13 2 12.7761 2 12.5V2.5C2 2.22386 2.22386 2 2.5 2ZM1 2.5C1 1.67157 1.67157 1 2.5 1H12.5C13.3284 1 14 1.67157 14 2.5V12.5C14 13.3284 13.3284 14 12.5 14H2.5C1.67157 14 1 13.3284 1 12.5V2.5ZM7.5 4C7.77614 4 8 3.77614 8 3.5C8 3.22386 7.77614 3 7.5 3C7.22386 3 7 3.22386 7 3.5C7 3.77614 7.22386 4 7.5 4ZM8 5.5C8 5.77614 7.77614 6 7.5 6C7.22386 6 7 5.77614 7 5.5C7 5.22386 7.22386 5 7.5 5C7.77614 5 8 5.22386 8 5.5ZM7.5 8C7.77614 8 8 7.77614 8 7.5C8 7.22386 7.77614 7 7.5 7C7.22386 7 7 7.22386 7 7.5C7 7.77614 7.22386 8 7.5 8ZM10 7.5C10 7.77614 9.77614 8 9.5 8C9.22386 8 9 7.77614 9 7.5C9 7.22386 9.22386 7 9.5 7C9.77614 7 10 7.22386 10 7.5ZM11.5 8C11.7761 8 12 7.77614 12 7.5C12 7.22386 11.7761 7 11.5 7C11.2239 7 11 7.22386 11 7.5C11 7.77614 11.2239 8 11.5 8Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$l = [
    "color"
];
var $e781b76dcad7c5d5$export$b1f22795a41806ac = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$l);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M0.877014 7.49988C0.877014 3.84219 3.84216 0.877045 7.49985 0.877045C11.1575 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1575 14.1227 7.49985 14.1227C3.84216 14.1227 0.877014 11.1575 0.877014 7.49988ZM7.49985 1.82704C4.36683 1.82704 1.82701 4.36686 1.82701 7.49988C1.82701 8.97196 2.38774 10.3131 3.30727 11.3213C4.19074 9.94119 5.73818 9.02499 7.50023 9.02499C9.26206 9.02499 10.8093 9.94097 11.6929 11.3208C12.6121 10.3127 13.1727 8.97172 13.1727 7.49988C13.1727 4.36686 10.6328 1.82704 7.49985 1.82704ZM10.9818 11.9787C10.2839 10.7795 8.9857 9.97499 7.50023 9.97499C6.01458 9.97499 4.71624 10.7797 4.01845 11.9791C4.97952 12.7272 6.18765 13.1727 7.49985 13.1727C8.81227 13.1727 10.0206 12.727 10.9818 11.9787ZM5.14999 6.50487C5.14999 5.207 6.20212 4.15487 7.49999 4.15487C8.79786 4.15487 9.84999 5.207 9.84999 6.50487C9.84999 7.80274 8.79786 8.85487 7.49999 8.85487C6.20212 8.85487 5.14999 7.80274 5.14999 6.50487ZM7.49999 5.10487C6.72679 5.10487 6.09999 5.73167 6.09999 6.50487C6.09999 7.27807 6.72679 7.90487 7.49999 7.90487C8.27319 7.90487 8.89999 7.27807 8.89999 6.50487C8.89999 5.73167 8.27319 5.10487 7.49999 5.10487Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$m = [
    "color"
];
var $e781b76dcad7c5d5$export$a7965fbad5d67169 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$m);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M5 1C5 0.447715 5.44772 0 6 0H9C9.55228 0 10 0.447715 10 1V2H14C14.5523 2 15 2.44772 15 3V6C15 6.8888 14.6131 7.68734 14 8.23608V11.5C14 12.3284 13.3284 13 12.5 13H2.5C1.67157 13 1 12.3284 1 11.5V8.2359C0.38697 7.68721 0 6.88883 0 6V3C0 2.44772 0.447716 2 1 2H5V1ZM9 1V2H6V1H9ZM1 3H5H5.5H9.5H10H14V6C14 6.654 13.6866 7.23467 13.1997 7.6004C12.8655 7.85144 12.4508 8 12 8H8V7.5C8 7.22386 7.77614 7 7.5 7C7.22386 7 7 7.22386 7 7.5V8H3C2.5493 8 2.1346 7.85133 1.80029 7.60022C1.31335 7.23446 1 6.65396 1 6V3ZM7 9H3C2.64961 9 2.31292 8.93972 2 8.82905V11.5C2 11.7761 2.22386 12 2.5 12H12.5C12.7761 12 13 11.7761 13 11.5V8.82915C12.6871 8.93978 12.3504 9 12 9H8V9.5C8 9.77614 7.77614 10 7.5 10C7.22386 10 7 9.77614 7 9.5V9Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$n = [
    "color"
];
var $e781b76dcad7c5d5$export$e32f68df2d27987 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$n);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M3.5 6H11.5C12.3284 6 13 6.67157 13 7.5C13 8.32843 12.3284 9 11.5 9H3.5C2.67157 9 2 8.32843 2 7.5C2 6.67157 2.67157 6 3.5 6ZM1 7.5C1 6.11929 2.11929 5 3.5 5H11.5C12.8807 5 14 6.11929 14 7.5C14 8.88071 12.8807 10 11.5 10H3.5C2.11929 10 1 8.88071 1 7.5ZM4.5 7C4.22386 7 4 7.22386 4 7.5C4 7.77614 4.22386 8 4.5 8H10.5C10.7761 8 11 7.77614 11 7.5C11 7.22386 10.7761 7 10.5 7H4.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$o = [
    "color"
];
var $e781b76dcad7c5d5$export$472946dc5493045a = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$o);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M11.5 1C11.7761 1 12 1.22386 12 1.5V13.5C12 13.7761 11.7761 14 11.5 14C11.2239 14 11 13.7761 11 13.5V1.5C11 1.22386 11.2239 1 11.5 1ZM9.5 3C9.77614 3 10 3.22386 10 3.5V13.5C10 13.7761 9.77614 14 9.5 14C9.22386 14 9 13.7761 9 13.5V3.5C9 3.22386 9.22386 3 9.5 3ZM13.5 3C13.7761 3 14 3.22386 14 3.5V13.5C14 13.7761 13.7761 14 13.5 14C13.2239 14 13 13.7761 13 13.5V3.5C13 3.22386 13.2239 3 13.5 3ZM5.5 4C5.77614 4 6 4.22386 6 4.5V13.5C6 13.7761 5.77614 14 5.5 14C5.22386 14 5 13.7761 5 13.5V4.5C5 4.22386 5.22386 4 5.5 4ZM1.5 5C1.77614 5 2 5.22386 2 5.5V13.5C2 13.7761 1.77614 14 1.5 14C1.22386 14 1 13.7761 1 13.5V5.5C1 5.22386 1.22386 5 1.5 5ZM7.5 5C7.77614 5 8 5.22386 8 5.5V13.5C8 13.7761 7.77614 14 7.5 14C7.22386 14 7 13.7761 7 13.5V5.5C7 5.22386 7.22386 5 7.5 5ZM3.5 7C3.77614 7 4 7.22386 4 7.5V13.5C4 13.7761 3.77614 14 3.5 14C3.22386 14 3 13.7761 3 13.5V7.5C3 7.22386 3.22386 7 3.5 7Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$p = [
    "color"
];
var $e781b76dcad7c5d5$export$2235404cc2cfe93c = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$p);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M8.60124 1.25086C8.60124 1.75459 8.26278 2.17927 7.80087 2.30989C10.1459 2.4647 12 4.41582 12 6.79999V10.25C12 11.0563 12.0329 11.7074 12.7236 12.0528C12.931 12.1565 13.0399 12.3892 12.9866 12.6149C12.9333 12.8406 12.7319 13 12.5 13H8.16144C8.36904 13.1832 8.49997 13.4513 8.49997 13.75C8.49997 14.3023 8.05226 14.75 7.49997 14.75C6.94769 14.75 6.49997 14.3023 6.49997 13.75C6.49997 13.4513 6.63091 13.1832 6.83851 13H2.49999C2.2681 13 2.06664 12.8406 2.01336 12.6149C1.96009 12.3892 2.06897 12.1565 2.27638 12.0528C2.96708 11.7074 2.99999 11.0563 2.99999 10.25V6.79999C2.99999 4.41537 4.85481 2.46396 7.20042 2.3098C6.73867 2.17908 6.40036 1.75448 6.40036 1.25086C6.40036 0.643104 6.89304 0.150421 7.5008 0.150421C8.10855 0.150421 8.60124 0.643104 8.60124 1.25086ZM7.49999 3.29999C5.56699 3.29999 3.99999 4.86699 3.99999 6.79999V10.25L4.00002 10.3009C4.0005 10.7463 4.00121 11.4084 3.69929 12H11.3007C10.9988 11.4084 10.9995 10.7463 11 10.3009L11 10.25V6.79999C11 4.86699 9.43299 3.29999 7.49999 3.29999Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$q = [
    "color"
];
var $e781b76dcad7c5d5$export$cd91dad3f7d2f1be = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$q);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M3 9C3 6.5 4.5 4.25 7.5 1.5C10.5 4.25 12 6.5 12 9C12 11.4853 9.98528 13.5 7.5 13.5C5.01472 13.5 3 11.4853 3 9ZM10.9524 8.30307C9.67347 7.82121 8.2879 8.46208 6.98956 9.06259C5.9327 9.55142 4.93365 10.0135 4.09695 9.82153C4.03357 9.55804 4 9.28294 4 9C4 7.11203 5.02686 5.27195 7.5 2.87357C9.66837 4.97639 10.725 6.65004 10.9524 8.30307Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$r = [
    "color"
];
var $e781b76dcad7c5d5$export$93cb139c864b0aec = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$r);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M3 2.5C3 2.22386 3.22386 2 3.5 2H11.5C11.7761 2 12 2.22386 12 2.5V13.5C12 13.6818 11.9014 13.8492 11.7424 13.9373C11.5834 14.0254 11.3891 14.0203 11.235 13.924L7.5 11.5896L3.765 13.924C3.61087 14.0203 3.41659 14.0254 3.25762 13.9373C3.09864 13.8492 3 13.6818 3 13.5V2.5ZM4 3V12.5979L6.97 10.7416C7.29427 10.539 7.70573 10.539 8.03 10.7416L11 12.5979V3H4Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$s = [
    "color"
];
var $e781b76dcad7c5d5$export$77df11a9db3bfb4e = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$s);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M3.5 2C3.22386 2 3 2.22386 3 2.5V13.5C3 13.6818 3.09864 13.8492 3.25762 13.9373C3.41659 14.0254 3.61087 14.0203 3.765 13.924L7.5 11.5896L11.235 13.924C11.3891 14.0203 11.5834 14.0254 11.7424 13.9373C11.9014 13.8492 12 13.6818 12 13.5V2.5C12 2.22386 11.7761 2 11.5 2H3.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$t = [
    "color"
];
var $e781b76dcad7c5d5$export$2b8bb78df07fc3c1 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$t);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M0.25 1C0.25 0.585786 0.585786 0.25 1 0.25H14C14.4142 0.25 14.75 0.585786 14.75 1V14C14.75 14.4142 14.4142 14.75 14 14.75H1C0.585786 14.75 0.25 14.4142 0.25 14V1ZM1.75 1.75V13.25H13.25V1.75H1.75Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("rect", {
        x: "7",
        y: "5",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "7",
        y: "3",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "7",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "5",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "3",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "9",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "11",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "7",
        y: "9",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "7",
        y: "11",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }));
});
var $e781b76dcad7c5d5$var$_excluded$u = [
    "color"
];
var $e781b76dcad7c5d5$export$1986587b5169c3d1 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$u);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M1 13.25L14 13.25V14.75L1 14.75V13.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("rect", {
        x: "7",
        y: "5",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "13",
        y: "5",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "7",
        y: "3",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "13",
        y: "3",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "7",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "7",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "13",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "13",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "5",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "5",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "3",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "3",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "9",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "9",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "11",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "11",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "7",
        y: "9",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "13",
        y: "9",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "7",
        y: "11",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "13",
        y: "11",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "1",
        y: "5",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "1",
        y: "3",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "1",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "1",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "1",
        y: "9",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "1",
        y: "11",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }));
});
var $e781b76dcad7c5d5$var$_excluded$v = [
    "color"
];
var $e781b76dcad7c5d5$export$9e3588048b381346 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$v);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M0 7.5C0 7.22386 0.223858 7 0.5 7H3C3.27614 7 3.5 7.22386 3.5 7.5C3.5 7.77614 3.27614 8 3 8H0.5C0.223858 8 0 7.77614 0 7.5ZM5.75 7.5C5.75 7.22386 5.97386 7 6.25 7H8.75C9.02614 7 9.25 7.22386 9.25 7.5C9.25 7.77614 9.02614 8 8.75 8H6.25C5.97386 8 5.75 7.77614 5.75 7.5ZM12 7C11.7239 7 11.5 7.22386 11.5 7.5C11.5 7.77614 11.7239 8 12 8H14.5C14.7761 8 15 7.77614 15 7.5C15 7.22386 14.7761 7 14.5 7H12Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$w = [
    "color"
];
var $e781b76dcad7c5d5$export$db4fc3403d513c1 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$w);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M1.5 6.625C1.01675 6.625 0.625 7.01675 0.625 7.5C0.625 7.98325 1.01675 8.375 1.5 8.375C1.98325 8.375 2.375 7.98325 2.375 7.5C2.375 7.01675 1.98325 6.625 1.5 6.625ZM5.5 6.625C5.01675 6.625 4.625 7.01675 4.625 7.5C4.625 7.98325 5.01675 8.375 5.5 8.375C5.98325 8.375 6.375 7.98325 6.375 7.5C6.375 7.01675 5.98325 6.625 5.5 6.625ZM9.5 6.625C9.01675 6.625 8.625 7.01675 8.625 7.5C8.625 7.98325 9.01675 8.375 9.5 8.375C9.98325 8.375 10.375 7.98325 10.375 7.5C10.375 7.01675 9.98325 6.625 9.5 6.625ZM12.625 7.5C12.625 7.01675 13.0168 6.625 13.5 6.625C13.9832 6.625 14.375 7.01675 14.375 7.5C14.375 7.98325 13.9832 8.375 13.5 8.375C13.0168 8.375 12.625 7.98325 12.625 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$x = [
    "color"
];
var $e781b76dcad7c5d5$export$90857351d8240996 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$x);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M1.75 1L1.75 14L0.249999 14L0.25 1L1.75 1Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("rect", {
        x: "10",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 10 7)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "10",
        y: "13",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 10 13)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "12",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 12 7)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "12",
        y: "13",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 12 13)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "8",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 8 7)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "14",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 14 7)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "8",
        y: "13",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 8 13)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "14",
        y: "13",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 14 13)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "8",
        y: "5",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 8 5)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "14",
        y: "5",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 14 5)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "8",
        y: "3",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 8 3)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "14",
        y: "3",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 14 3)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "8",
        y: "9",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 8 9)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "14",
        y: "9",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 14 9)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "8",
        y: "11",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 8 11)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "14",
        y: "11",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 14 11)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "6",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 6 7)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "6",
        y: "13",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 6 13)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "4",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 4 7)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "4",
        y: "13",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 4 13)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "10",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 10 1)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "12",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 12 1)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "8",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 8 1)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "14",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 14 1)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "6",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 6 1)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "4",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 4 1)",
        fill: color
    }));
});
var $e781b76dcad7c5d5$var$_excluded$y = [
    "color"
];
var $e781b76dcad7c5d5$export$fc99bfbabe8fe100 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$y);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("rect", {
        x: "7",
        y: "5.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "13",
        y: "5.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "7",
        y: "3.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "13",
        y: "3.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "7",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "7",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "7",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "13",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "13",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "13",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "5",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "5",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "5",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "3",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "3",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "3",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "9",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "9",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "9",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "11",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "11",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "11",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "7",
        y: "9.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "13",
        y: "9.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "7",
        y: "11.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "13",
        y: "11.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "1",
        y: "5.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "1",
        y: "3.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "1",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "1",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "1",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "1",
        y: "9.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "1",
        y: "11.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }));
});
var $e781b76dcad7c5d5$var$_excluded$z = [
    "color"
];
var $e781b76dcad7c5d5$export$d19e24a090b81f38 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$z);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M13.25 1L13.25 14L14.75 14L14.75 1L13.25 1Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 5 7)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 5 13)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 3 7)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 3 13)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 7 7)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 1 7)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 7 13)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 1 13)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 7 5)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 1 5)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 7 3)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 1 3)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 7 9)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 1 9)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 7 11)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 1 11)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 9 7)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 9 13)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 11 7)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 11 13)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 5 1)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 3 1)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 7 1)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 1 1)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 9 1)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 11 1)",
        fill: color
    }));
});
var $e781b76dcad7c5d5$var$_excluded$A = [
    "color"
];
var $e781b76dcad7c5d5$export$ca09e5ae294d45cc = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$A);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M1.25 7.5C1.25 7.22386 1.47386 7 1.75 7H13.25C13.5261 7 13.75 7.22386 13.75 7.5C13.75 7.77614 13.5261 8 13.25 8H1.75C1.47386 8 1.25 7.77614 1.25 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$B = [
    "color"
];
var $e781b76dcad7c5d5$export$fbe2d4727aba00b7 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$B);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("rect", {
        x: "7",
        y: "5.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "7",
        y: "3.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "7",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "7",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "7",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "13",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "5",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "3",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "9",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "11",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "7",
        y: "9.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "7",
        y: "11.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "1",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $jbmdS.createElement)("path", {
        d: "M1 1.49994C1 1.2238 1.22386 0.999939 1.5 0.999939H6V1.99994H2V5.99994H1V1.49994ZM13 1.99994H9V0.999939H13.5C13.7761 0.999939 14 1.2238 14 1.49994V5.99994H13V1.99994ZM1 13.4999V8.99994H2V12.9999H6V13.9999H1.5C1.22386 13.9999 1 13.7761 1 13.4999ZM13 12.9999V8.99994H14V13.4999C14 13.7761 13.7761 13.9999 13.5 13.9999H9.5V12.9999H13Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$C = [
    "color"
];
var $e781b76dcad7c5d5$export$99084cce0e645aeb = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$C);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M1.5 3C1.22386 3 1 3.22386 1 3.5C1 3.77614 1.22386 4 1.5 4H13.5C13.7761 4 14 3.77614 14 3.5C14 3.22386 13.7761 3 13.5 3H1.5ZM1 7.5C1 7.22386 1.22386 7 1.5 7H3.5C3.77614 7 4 7.22386 4 7.5C4 7.77614 3.77614 8 3.5 8H1.5C1.22386 8 1 7.77614 1 7.5ZM1 11.5C1 11.2239 1.22386 11 1.5 11C1.77614 11 2 11.2239 2 11.5C2 11.7761 1.77614 12 1.5 12C1.22386 12 1 11.7761 1 11.5ZM3 11.5C3 11.2239 3.22386 11 3.5 11C3.77614 11 4 11.2239 4 11.5C4 11.7761 3.77614 12 3.5 12C3.22386 12 3 11.7761 3 11.5ZM5.5 11C5.22386 11 5 11.2239 5 11.5C5 11.7761 5.22386 12 5.5 12C5.77614 12 6 11.7761 6 11.5C6 11.2239 5.77614 11 5.5 11ZM7 11.5C7 11.2239 7.22386 11 7.5 11C7.77614 11 8 11.2239 8 11.5C8 11.7761 7.77614 12 7.5 12C7.22386 12 7 11.7761 7 11.5ZM9.5 11C9.22386 11 9 11.2239 9 11.5C9 11.7761 9.22386 12 9.5 12C9.77614 12 10 11.7761 10 11.5C10 11.2239 9.77614 11 9.5 11ZM11 11.5C11 11.2239 11.2239 11 11.5 11C11.7761 11 12 11.2239 12 11.5C12 11.7761 11.7761 12 11.5 12C11.2239 12 11 11.7761 11 11.5ZM13.5 11C13.2239 11 13 11.2239 13 11.5C13 11.7761 13.2239 12 13.5 12C13.7761 12 14 11.7761 14 11.5C14 11.2239 13.7761 11 13.5 11ZM6.5 7C6.22386 7 6 7.22386 6 7.5C6 7.77614 6.22386 8 6.5 8H8.5C8.77614 8 9 7.77614 9 7.5C9 7.22386 8.77614 7 8.5 7H6.5ZM11 7.5C11 7.22386 11.2239 7 11.5 7H13.5C13.7761 7 14 7.22386 14 7.5C14 7.77614 13.7761 8 13.5 8H11.5C11.2239 8 11 7.77614 11 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$D = [
    "color"
];
var $e781b76dcad7c5d5$export$c244c53943ad4d08 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$D);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M14 1.75L1 1.75L1 0.249999L14 0.25L14 1.75Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("rect", {
        x: "8",
        y: "10",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 8 10)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "2",
        y: "10",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 2 10)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "8",
        y: "12",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 8 12)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "2",
        y: "12",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 2 12)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "8",
        y: "8",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 8 8)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "8",
        y: "14",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 8 14)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "2",
        y: "8",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 2 8)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "2",
        y: "14",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 2 14)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "10",
        y: "8",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 10 8)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "10",
        y: "14",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 10 14)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "12",
        y: "8",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 12 8)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "12",
        y: "14",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 12 14)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "6",
        y: "8",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 6 8)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "6",
        y: "14",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 6 14)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "4",
        y: "8",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 4 8)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "4",
        y: "14",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 4 14)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "8",
        y: "6",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 8 6)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "2",
        y: "6",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 2 6)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "8",
        y: "4",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 8 4)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "2",
        y: "4",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 2 4)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "14",
        y: "10",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 14 10)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "14",
        y: "12",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 14 12)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "14",
        y: "8",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 14 8)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "14",
        y: "14",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 14 14)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "14",
        y: "6",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 14 6)",
        fill: color
    }), (0, $jbmdS.createElement)("rect", {
        x: "14",
        y: "4",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 14 4)",
        fill: color
    }));
});
var $e781b76dcad7c5d5$var$_excluded$E = [
    "color"
];
var $e781b76dcad7c5d5$export$26dc332286fcc660 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$E);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M1 3H14V4H1V3ZM1 6H14V8H1V6ZM14 10.25H1V12.75H14V10.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$F = [
    "color"
];
var $e781b76dcad7c5d5$export$adedf1569d7107de = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$F);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M12.5 2H2.5C2.22386 2 2 2.22386 2 2.5V12.5C2 12.7761 2.22386 13 2.5 13H12.5C12.7761 13 13 12.7761 13 12.5V2.5C13 2.22386 12.7761 2 12.5 2ZM2.5 1C1.67157 1 1 1.67157 1 2.5V12.5C1 13.3284 1.67157 14 2.5 14H12.5C13.3284 14 14 13.3284 14 12.5V2.5C14 1.67157 13.3284 1 12.5 1H2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$G = [
    "color"
];
var $e781b76dcad7c5d5$export$742ea6014cb11378 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$G);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M1.99998 0.999976C1.44769 0.999976 0.999976 1.44769 0.999976 1.99998V13C0.999976 13.5523 1.44769 14 1.99998 14H13C13.5523 14 14 13.5523 14 13V1.99998C14 1.44769 13.5523 0.999976 13 0.999976H1.99998ZM1.99998 1.99998L13 1.99998V13H1.99998V1.99998ZM4.49996 3.99996C4.22382 3.99996 3.99996 4.22382 3.99996 4.49996V10.5C3.99996 10.7761 4.22382 11 4.49996 11H10.5C10.7761 11 11 10.7761 11 10.5V4.49996C11 4.22382 10.7761 3.99996 10.5 3.99996H4.49996ZM4.99996 9.99996V4.99996H9.99996V9.99996H4.99996Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$H = [
    "color"
];
var $e781b76dcad7c5d5$export$e1c22a2ee2645e36 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$H);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M2 5H13C13.5523 5 14 5.44772 14 6V9C14 9.55228 13.5523 10 13 10H2C1.44772 10 1 9.55228 1 9V6C1 5.44772 1.44772 5 2 5ZM0 6C0 4.89543 0.895431 4 2 4H13C14.1046 4 15 4.89543 15 6V9C15 10.1046 14.1046 11 13 11H2C0.89543 11 0 10.1046 0 9V6ZM4.5 6.75C4.08579 6.75 3.75 7.08579 3.75 7.5C3.75 7.91421 4.08579 8.25 4.5 8.25C4.91421 8.25 5.25 7.91421 5.25 7.5C5.25 7.08579 4.91421 6.75 4.5 6.75ZM6.75 7.5C6.75 7.08579 7.08579 6.75 7.5 6.75C7.91421 6.75 8.25 7.08579 8.25 7.5C8.25 7.91421 7.91421 8.25 7.5 8.25C7.08579 8.25 6.75 7.91421 6.75 7.5ZM10.5 6.75C10.0858 6.75 9.75 7.08579 9.75 7.5C9.75 7.91421 10.0858 8.25 10.5 8.25C10.9142 8.25 11.25 7.91421 11.25 7.5C11.25 7.08579 10.9142 6.75 10.5 6.75Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$I = [
    "color"
];
var $e781b76dcad7c5d5$export$5fda1783bb83f57b = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$I);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M4.5 1C4.77614 1 5 1.22386 5 1.5V2H10V1.5C10 1.22386 10.2239 1 10.5 1C10.7761 1 11 1.22386 11 1.5V2H12.5C13.3284 2 14 2.67157 14 3.5V12.5C14 13.3284 13.3284 14 12.5 14H2.5C1.67157 14 1 13.3284 1 12.5V3.5C1 2.67157 1.67157 2 2.5 2H4V1.5C4 1.22386 4.22386 1 4.5 1ZM10 3V3.5C10 3.77614 10.2239 4 10.5 4C10.7761 4 11 3.77614 11 3.5V3H12.5C12.7761 3 13 3.22386 13 3.5V5H2V3.5C2 3.22386 2.22386 3 2.5 3H4V3.5C4 3.77614 4.22386 4 4.5 4C4.77614 4 5 3.77614 5 3.5V3H10ZM2 6V12.5C2 12.7761 2.22386 13 2.5 13H12.5C12.7761 13 13 12.7761 13 12.5V6H2ZM7 7.5C7 7.22386 7.22386 7 7.5 7C7.77614 7 8 7.22386 8 7.5C8 7.77614 7.77614 8 7.5 8C7.22386 8 7 7.77614 7 7.5ZM9.5 7C9.22386 7 9 7.22386 9 7.5C9 7.77614 9.22386 8 9.5 8C9.77614 8 10 7.77614 10 7.5C10 7.22386 9.77614 7 9.5 7ZM11 7.5C11 7.22386 11.2239 7 11.5 7C11.7761 7 12 7.22386 12 7.5C12 7.77614 11.7761 8 11.5 8C11.2239 8 11 7.77614 11 7.5ZM11.5 9C11.2239 9 11 9.22386 11 9.5C11 9.77614 11.2239 10 11.5 10C11.7761 10 12 9.77614 12 9.5C12 9.22386 11.7761 9 11.5 9ZM9 9.5C9 9.22386 9.22386 9 9.5 9C9.77614 9 10 9.22386 10 9.5C10 9.77614 9.77614 10 9.5 10C9.22386 10 9 9.77614 9 9.5ZM7.5 9C7.22386 9 7 9.22386 7 9.5C7 9.77614 7.22386 10 7.5 10C7.77614 10 8 9.77614 8 9.5C8 9.22386 7.77614 9 7.5 9ZM5 9.5C5 9.22386 5.22386 9 5.5 9C5.77614 9 6 9.22386 6 9.5C6 9.77614 5.77614 10 5.5 10C5.22386 10 5 9.77614 5 9.5ZM3.5 9C3.22386 9 3 9.22386 3 9.5C3 9.77614 3.22386 10 3.5 10C3.77614 10 4 9.77614 4 9.5C4 9.22386 3.77614 9 3.5 9ZM3 11.5C3 11.2239 3.22386 11 3.5 11C3.77614 11 4 11.2239 4 11.5C4 11.7761 3.77614 12 3.5 12C3.22386 12 3 11.7761 3 11.5ZM5.5 11C5.22386 11 5 11.2239 5 11.5C5 11.7761 5.22386 12 5.5 12C5.77614 12 6 11.7761 6 11.5C6 11.2239 5.77614 11 5.5 11ZM7 11.5C7 11.2239 7.22386 11 7.5 11C7.77614 11 8 11.2239 8 11.5C8 11.7761 7.77614 12 7.5 12C7.22386 12 7 11.7761 7 11.5ZM9.5 11C9.22386 11 9 11.2239 9 11.5C9 11.7761 9.22386 12 9.5 12C9.77614 12 10 11.7761 10 11.5C10 11.2239 9.77614 11 9.5 11Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$J = [
    "color"
];
var $e781b76dcad7c5d5$export$1bd12807c2fea239 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$J);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M2 3C1.44772 3 1 3.44772 1 4V11C1 11.5523 1.44772 12 2 12H13C13.5523 12 14 11.5523 14 11V4C14 3.44772 13.5523 3 13 3H2ZM0 4C0 2.89543 0.895431 2 2 2H13C14.1046 2 15 2.89543 15 4V11C15 12.1046 14.1046 13 13 13H2C0.895431 13 0 12.1046 0 11V4ZM2 4.25C2 4.11193 2.11193 4 2.25 4H4.75C4.88807 4 5 4.11193 5 4.25V5.75454C5 5.89261 4.88807 6.00454 4.75 6.00454H2.25C2.11193 6.00454 2 5.89261 2 5.75454V4.25ZM12.101 7.58421C12.101 9.02073 10.9365 10.1853 9.49998 10.1853C8.06346 10.1853 6.89893 9.02073 6.89893 7.58421C6.89893 6.14769 8.06346 4.98315 9.49998 4.98315C10.9365 4.98315 12.101 6.14769 12.101 7.58421ZM13.101 7.58421C13.101 9.57302 11.4888 11.1853 9.49998 11.1853C7.51117 11.1853 5.89893 9.57302 5.89893 7.58421C5.89893 5.5954 7.51117 3.98315 9.49998 3.98315C11.4888 3.98315 13.101 5.5954 13.101 7.58421Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$K = [
    "color"
];
var $e781b76dcad7c5d5$export$16dbc2701f60a606 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$K);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M2 3.5C2 3.22386 2.22386 3 2.5 3H12.5C12.7761 3 13 3.22386 13 3.5V9.5C13 9.77614 12.7761 10 12.5 10H2.5C2.22386 10 2 9.77614 2 9.5V3.5ZM2 10.9146C1.4174 10.7087 1 10.1531 1 9.5V3.5C1 2.67157 1.67157 2 2.5 2H12.5C13.3284 2 14 2.67157 14 3.5V9.5C14 10.1531 13.5826 10.7087 13 10.9146V11.5C13 12.3284 12.3284 13 11.5 13H3.5C2.67157 13 2 12.3284 2 11.5V10.9146ZM12 11V11.5C12 11.7761 11.7761 12 11.5 12H3.5C3.22386 12 3 11.7761 3 11.5V11H12Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$L = [
    "color"
];
var $e781b76dcad7c5d5$export$cf8d533bd52e80e3 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$L);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M2.5 3C2.22386 3 2 3.22386 2 3.5V9.5C2 9.77614 2.22386 10 2.5 10H12.5C12.7761 10 13 9.77614 13 9.5V3.5C13 3.22386 12.7761 3 12.5 3H2.5ZM1 9.5C1 10.1531 1.4174 10.7087 2 10.9146V11.5C2 12.3284 2.67157 13 3.5 13H11.5C12.3284 13 13 12.3284 13 11.5V10.9146C13.5826 10.7087 14 10.1531 14 9.5V3.5C14 2.67157 13.3284 2 12.5 2H2.5C1.67157 2 1 2.67157 1 3.5V9.5ZM12 11.5V11H3V11.5C3 11.7761 3.22386 12 3.5 12H11.5C11.7761 12 12 11.7761 12 11.5ZM5.5 6C5.22386 6 5 6.22386 5 6.5C5 6.77614 5.22386 7 5.5 7H9.5C9.77614 7 10 6.77614 10 6.5C10 6.22386 9.77614 6 9.5 6H5.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$M = [
    "color"
];
var $e781b76dcad7c5d5$export$e590b2572239e122 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$M);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M2 3.5C2 3.22386 2.22386 3 2.5 3H12.5C12.7761 3 13 3.22386 13 3.5V9.5C13 9.77614 12.7761 10 12.5 10H2.5C2.22386 10 2 9.77614 2 9.5V3.5ZM2 10.9146C1.4174 10.7087 1 10.1531 1 9.5V3.5C1 2.67157 1.67157 2 2.5 2H12.5C13.3284 2 14 2.67157 14 3.5V9.5C14 10.1531 13.5826 10.7087 13 10.9146V11.5C13 12.3284 12.3284 13 11.5 13H3.5C2.67157 13 2 12.3284 2 11.5V10.9146ZM12 11V11.5C12 11.7761 11.7761 12 11.5 12H3.5C3.22386 12 3 11.7761 3 11.5V11H12ZM5 6.5C5 6.22386 5.22386 6 5.5 6H7V4.5C7 4.22386 7.22386 4 7.5 4C7.77614 4 8 4.22386 8 4.5V6H9.5C9.77614 6 10 6.22386 10 6.5C10 6.77614 9.77614 7 9.5 7H8V8.5C8 8.77614 7.77614 9 7.5 9C7.22386 9 7 8.77614 7 8.5V7H5.5C5.22386 7 5 6.77614 5 6.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$N = [
    "color"
];
var $e781b76dcad7c5d5$export$73a4c78a4a00962 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$N);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M4.18179 6.18181C4.35753 6.00608 4.64245 6.00608 4.81819 6.18181L7.49999 8.86362L10.1818 6.18181C10.3575 6.00608 10.6424 6.00608 10.8182 6.18181C10.9939 6.35755 10.9939 6.64247 10.8182 6.81821L7.81819 9.81821C7.73379 9.9026 7.61934 9.95001 7.49999 9.95001C7.38064 9.95001 7.26618 9.9026 7.18179 9.81821L4.18179 6.81821C4.00605 6.64247 4.00605 6.35755 4.18179 6.18181Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$O = [
    "color"
];
var $e781b76dcad7c5d5$export$810196a5854768f3 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$O);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M8.81809 4.18179C8.99383 4.35753 8.99383 4.64245 8.81809 4.81819L6.13629 7.49999L8.81809 10.1818C8.99383 10.3575 8.99383 10.6424 8.81809 10.8182C8.64236 10.9939 8.35743 10.9939 8.1817 10.8182L5.1817 7.81819C5.09731 7.73379 5.0499 7.61933 5.0499 7.49999C5.0499 7.38064 5.09731 7.26618 5.1817 7.18179L8.1817 4.18179C8.35743 4.00605 8.64236 4.00605 8.81809 4.18179Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$P = [
    "color"
];
var $e781b76dcad7c5d5$export$5e4a7579d3e78657 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$P);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M6.18194 4.18185C6.35767 4.00611 6.6426 4.00611 6.81833 4.18185L9.81833 7.18185C9.90272 7.26624 9.95013 7.3807 9.95013 7.50005C9.95013 7.6194 9.90272 7.73386 9.81833 7.81825L6.81833 10.8182C6.6426 10.994 6.35767 10.994 6.18194 10.8182C6.0062 10.6425 6.0062 10.3576 6.18194 10.1819L8.86374 7.50005L6.18194 4.81825C6.0062 4.64251 6.0062 4.35759 6.18194 4.18185Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$Q = [
    "color"
];
var $e781b76dcad7c5d5$export$432020ae7f5a1085 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$Q);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M4.93179 5.43179C4.75605 5.60753 4.75605 5.89245 4.93179 6.06819C5.10753 6.24392 5.39245 6.24392 5.56819 6.06819L7.49999 4.13638L9.43179 6.06819C9.60753 6.24392 9.89245 6.24392 10.0682 6.06819C10.2439 5.89245 10.2439 5.60753 10.0682 5.43179L7.81819 3.18179C7.73379 3.0974 7.61933 3.04999 7.49999 3.04999C7.38064 3.04999 7.26618 3.0974 7.18179 3.18179L4.93179 5.43179ZM10.0682 9.56819C10.2439 9.39245 10.2439 9.10753 10.0682 8.93179C9.89245 8.75606 9.60753 8.75606 9.43179 8.93179L7.49999 10.8636L5.56819 8.93179C5.39245 8.75606 5.10753 8.75606 4.93179 8.93179C4.75605 9.10753 4.75605 9.39245 4.93179 9.56819L7.18179 11.8182C7.35753 11.9939 7.64245 11.9939 7.81819 11.8182L10.0682 9.56819Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$R = [
    "color"
];
var $e781b76dcad7c5d5$export$7d1b8b90f61377d1 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$R);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M4.18179 8.81819C4.00605 8.64245 4.00605 8.35753 4.18179 8.18179L7.18179 5.18179C7.26618 5.0974 7.38064 5.04999 7.49999 5.04999C7.61933 5.04999 7.73379 5.0974 7.81819 5.18179L10.8182 8.18179C10.9939 8.35753 10.9939 8.64245 10.8182 8.81819C10.6424 8.99392 10.3575 8.99392 10.1818 8.81819L7.49999 6.13638L4.81819 8.81819C4.64245 8.99392 4.35753 8.99392 4.18179 8.81819Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$S = [
    "color"
];
var $e781b76dcad7c5d5$export$83414514025c111b = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$S);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M12.5 3L2.5 3.00002C1.67157 3.00002 1 3.6716 1 4.50002V9.50003C1 10.3285 1.67157 11 2.5 11H7.50003C7.63264 11 7.75982 11.0527 7.85358 11.1465L10 13.2929V11.5C10 11.2239 10.2239 11 10.5 11H12.5C13.3284 11 14 10.3285 14 9.50003V4.5C14 3.67157 13.3284 3 12.5 3ZM2.49999 2.00002L12.5 2C13.8807 2 15 3.11929 15 4.5V9.50003C15 10.8807 13.8807 12 12.5 12H11V14.5C11 14.7022 10.8782 14.8845 10.6913 14.9619C10.5045 15.0393 10.2894 14.9965 10.1464 14.8536L7.29292 12H2.5C1.11929 12 0 10.8807 0 9.50003V4.50002C0 3.11931 1.11928 2.00003 2.49999 2.00002Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$T = [
    "color"
];
var $e781b76dcad7c5d5$export$7dd004358974b05d = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$T);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M11.4669 3.72684C11.7558 3.91574 11.8369 4.30308 11.648 4.59198L7.39799 11.092C7.29783 11.2452 7.13556 11.3467 6.95402 11.3699C6.77247 11.3931 6.58989 11.3355 6.45446 11.2124L3.70446 8.71241C3.44905 8.48022 3.43023 8.08494 3.66242 7.82953C3.89461 7.57412 4.28989 7.55529 4.5453 7.78749L6.75292 9.79441L10.6018 3.90792C10.7907 3.61902 11.178 3.53795 11.4669 3.72684Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$U = [
    "color"
];
var $e781b76dcad7c5d5$export$54060461b8d0e637 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$U);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.49991 0.877045C3.84222 0.877045 0.877075 3.84219 0.877075 7.49988C0.877075 11.1575 3.84222 14.1227 7.49991 14.1227C11.1576 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 3.84219 11.1576 0.877045 7.49991 0.877045ZM1.82708 7.49988C1.82708 4.36686 4.36689 1.82704 7.49991 1.82704C10.6329 1.82704 13.1727 4.36686 13.1727 7.49988C13.1727 10.6329 10.6329 13.1727 7.49991 13.1727C4.36689 13.1727 1.82708 10.6329 1.82708 7.49988ZM10.1589 5.53774C10.3178 5.31191 10.2636 5.00001 10.0378 4.84109C9.81194 4.68217 9.50004 4.73642 9.34112 4.96225L6.51977 8.97154L5.35681 7.78706C5.16334 7.59002 4.84677 7.58711 4.64973 7.78058C4.45268 7.97404 4.44978 8.29061 4.64325 8.48765L6.22658 10.1003C6.33054 10.2062 6.47617 10.2604 6.62407 10.2483C6.77197 10.2363 6.90686 10.1591 6.99226 10.0377L10.1589 5.53774Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$V = [
    "color"
];
var $e781b76dcad7c5d5$export$c0a1936901b0e55 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$V);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M3 3H12V12H3L3 3ZM2 3C2 2.44771 2.44772 2 3 2H12C12.5523 2 13 2.44772 13 3V12C13 12.5523 12.5523 13 12 13H3C2.44771 13 2 12.5523 2 12V3ZM10.3498 5.51105C10.506 5.28337 10.4481 4.97212 10.2204 4.81587C9.99275 4.65961 9.6815 4.71751 9.52525 4.94519L6.64048 9.14857L5.19733 7.40889C5.02102 7.19635 4.7058 7.16699 4.49327 7.34329C4.28073 7.5196 4.25137 7.83482 4.42767 8.04735L6.2934 10.2964C6.39348 10.4171 6.54437 10.4838 6.70097 10.4767C6.85757 10.4695 7.00177 10.3894 7.09047 10.2601L10.3498 5.51105Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$W = [
    "color"
];
var $e781b76dcad7c5d5$export$4857d3f3f5f8319b = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$W);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M3.13523 6.15803C3.3241 5.95657 3.64052 5.94637 3.84197 6.13523L7.5 9.56464L11.158 6.13523C11.3595 5.94637 11.6759 5.95657 11.8648 6.15803C12.0536 6.35949 12.0434 6.67591 11.842 6.86477L7.84197 10.6148C7.64964 10.7951 7.35036 10.7951 7.15803 10.6148L3.15803 6.86477C2.95657 6.67591 2.94637 6.35949 3.13523 6.15803Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$X = [
    "color"
];
var $e781b76dcad7c5d5$export$20bc5960c3c9eebb = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$X);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M8.84182 3.13514C9.04327 3.32401 9.05348 3.64042 8.86462 3.84188L5.43521 7.49991L8.86462 11.1579C9.05348 11.3594 9.04327 11.6758 8.84182 11.8647C8.64036 12.0535 8.32394 12.0433 8.13508 11.8419L4.38508 7.84188C4.20477 7.64955 4.20477 7.35027 4.38508 7.15794L8.13508 3.15794C8.32394 2.95648 8.64036 2.94628 8.84182 3.13514Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$Y = [
    "color"
];
var $e781b76dcad7c5d5$export$b837bd7eac09a33e = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$Y);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M6.1584 3.13508C6.35985 2.94621 6.67627 2.95642 6.86514 3.15788L10.6151 7.15788C10.7954 7.3502 10.7954 7.64949 10.6151 7.84182L6.86514 11.8418C6.67627 12.0433 6.35985 12.0535 6.1584 11.8646C5.95694 11.6757 5.94673 11.3593 6.1356 11.1579L9.565 7.49985L6.1356 3.84182C5.94673 3.64036 5.95694 3.32394 6.1584 3.13508Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$Z = [
    "color"
];
var $e781b76dcad7c5d5$export$7f01a6cbee61a0f2 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$Z);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M3.13523 8.84197C3.3241 9.04343 3.64052 9.05363 3.84197 8.86477L7.5 5.43536L11.158 8.86477C11.3595 9.05363 11.6759 9.04343 11.8648 8.84197C12.0536 8.64051 12.0434 8.32409 11.842 8.13523L7.84197 4.38523C7.64964 4.20492 7.35036 4.20492 7.15803 4.38523L3.15803 8.13523C2.95657 8.32409 2.94637 8.64051 3.13523 8.84197Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$_ = [
    "color"
];
var $e781b76dcad7c5d5$export$9c1c3f5a4a271817 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$_);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M0.877075 7.49991C0.877075 3.84222 3.84222 0.877075 7.49991 0.877075C11.1576 0.877075 14.1227 3.84222 14.1227 7.49991C14.1227 11.1576 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1576 0.877075 7.49991ZM7.49991 1.82708C4.36689 1.82708 1.82708 4.36689 1.82708 7.49991C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49991C13.1727 4.36689 10.6329 1.82708 7.49991 1.82708Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$$ = [
    "color"
];
var $e781b76dcad7c5d5$export$10324e86d7995e4 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$$);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.49991 0.877075C3.84222 0.877075 0.877075 3.84222 0.877075 7.49991C0.877075 11.1576 3.84222 14.1227 7.49991 14.1227C11.1576 14.1227 14.1227 11.1576 14.1227 7.49991C14.1227 3.84222 11.1576 0.877075 7.49991 0.877075ZM3.85768 3.15057C4.84311 2.32448 6.11342 1.82708 7.49991 1.82708C10.6329 1.82708 13.1727 4.36689 13.1727 7.49991C13.1727 8.88638 12.6753 10.1567 11.8492 11.1421L3.85768 3.15057ZM3.15057 3.85768C2.32448 4.84311 1.82708 6.11342 1.82708 7.49991C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C8.88638 13.1727 10.1567 12.6753 11.1421 11.8492L3.15057 3.85768Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$10 = [
    "color"
];
var $e781b76dcad7c5d5$export$60f3f00eeba09710 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$10);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M5 2V1H10V2H5ZM4.75 0C4.33579 0 4 0.335786 4 0.75V1H3.5C2.67157 1 2 1.67157 2 2.5V12.5C2 13.3284 2.67157 14 3.5 14H11.5C12.3284 14 13 13.3284 13 12.5V2.5C13 1.67157 12.3284 1 11.5 1H11V0.75C11 0.335786 10.6642 0 10.25 0H4.75ZM11 2V2.25C11 2.66421 10.6642 3 10.25 3H4.75C4.33579 3 4 2.66421 4 2.25V2H3.5C3.22386 2 3 2.22386 3 2.5V12.5C3 12.7761 3.22386 13 3.5 13H11.5C11.7761 13 12 12.7761 12 12.5V2.5C12 2.22386 11.7761 2 11.5 2H11Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$11 = [
    "color"
];
var $e781b76dcad7c5d5$export$1a4dc243f6e39802 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$11);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M5 2V1H10V2H5ZM4.75 0C4.33579 0 4 0.335786 4 0.75V1H3.5C2.67157 1 2 1.67157 2 2.5V12.5C2 13.3284 2.67157 14 3.5 14H7V13H3.5C3.22386 13 3 12.7761 3 12.5V2.5C3 2.22386 3.22386 2 3.5 2H4V2.25C4 2.66421 4.33579 3 4.75 3H10.25C10.6642 3 11 2.66421 11 2.25V2H11.5C11.7761 2 12 2.22386 12 2.5V7H13V2.5C13 1.67157 12.3284 1 11.5 1H11V0.75C11 0.335786 10.6642 0 10.25 0H4.75ZM9 8.5C9 8.77614 8.77614 9 8.5 9C8.22386 9 8 8.77614 8 8.5C8 8.22386 8.22386 8 8.5 8C8.77614 8 9 8.22386 9 8.5ZM10.5 9C10.7761 9 11 8.77614 11 8.5C11 8.22386 10.7761 8 10.5 8C10.2239 8 10 8.22386 10 8.5C10 8.77614 10.2239 9 10.5 9ZM13 8.5C13 8.77614 12.7761 9 12.5 9C12.2239 9 12 8.77614 12 8.5C12 8.22386 12.2239 8 12.5 8C12.7761 8 13 8.22386 13 8.5ZM14.5 9C14.7761 9 15 8.77614 15 8.5C15 8.22386 14.7761 8 14.5 8C14.2239 8 14 8.22386 14 8.5C14 8.77614 14.2239 9 14.5 9ZM15 10.5C15 10.7761 14.7761 11 14.5 11C14.2239 11 14 10.7761 14 10.5C14 10.2239 14.2239 10 14.5 10C14.7761 10 15 10.2239 15 10.5ZM14.5 13C14.7761 13 15 12.7761 15 12.5C15 12.2239 14.7761 12 14.5 12C14.2239 12 14 12.2239 14 12.5C14 12.7761 14.2239 13 14.5 13ZM14.5 15C14.7761 15 15 14.7761 15 14.5C15 14.2239 14.7761 14 14.5 14C14.2239 14 14 14.2239 14 14.5C14 14.7761 14.2239 15 14.5 15ZM8.5 11C8.77614 11 9 10.7761 9 10.5C9 10.2239 8.77614 10 8.5 10C8.22386 10 8 10.2239 8 10.5C8 10.7761 8.22386 11 8.5 11ZM9 12.5C9 12.7761 8.77614 13 8.5 13C8.22386 13 8 12.7761 8 12.5C8 12.2239 8.22386 12 8.5 12C8.77614 12 9 12.2239 9 12.5ZM8.5 15C8.77614 15 9 14.7761 9 14.5C9 14.2239 8.77614 14 8.5 14C8.22386 14 8 14.2239 8 14.5C8 14.7761 8.22386 15 8.5 15ZM11 14.5C11 14.7761 10.7761 15 10.5 15C10.2239 15 10 14.7761 10 14.5C10 14.2239 10.2239 14 10.5 14C10.7761 14 11 14.2239 11 14.5ZM12.5 15C12.7761 15 13 14.7761 13 14.5C13 14.2239 12.7761 14 12.5 14C12.2239 14 12 14.2239 12 14.5C12 14.7761 12.2239 15 12.5 15Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$12 = [
    "color"
];
var $e781b76dcad7c5d5$export$8099ab97743c966c = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$12);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.50009 0.877014C3.84241 0.877014 0.877258 3.84216 0.877258 7.49984C0.877258 11.1575 3.8424 14.1227 7.50009 14.1227C11.1578 14.1227 14.1229 11.1575 14.1229 7.49984C14.1229 3.84216 11.1577 0.877014 7.50009 0.877014ZM1.82726 7.49984C1.82726 4.36683 4.36708 1.82701 7.50009 1.82701C10.6331 1.82701 13.1729 4.36683 13.1729 7.49984C13.1729 10.6328 10.6331 13.1727 7.50009 13.1727C4.36708 13.1727 1.82726 10.6328 1.82726 7.49984ZM8 4.50001C8 4.22387 7.77614 4.00001 7.5 4.00001C7.22386 4.00001 7 4.22387 7 4.50001V7.50001C7 7.63262 7.05268 7.7598 7.14645 7.85357L9.14645 9.85357C9.34171 10.0488 9.65829 10.0488 9.85355 9.85357C10.0488 9.65831 10.0488 9.34172 9.85355 9.14646L8 7.29291V4.50001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$13 = [
    "color"
];
var $e781b76dcad7c5d5$export$8036f09137bee589 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$13);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M9.96424 2.68571C10.0668 2.42931 9.94209 2.13833 9.6857 2.03577C9.4293 1.93322 9.13832 2.05792 9.03576 2.31432L5.03576 12.3143C4.9332 12.5707 5.05791 12.8617 5.3143 12.9642C5.5707 13.0668 5.86168 12.9421 5.96424 12.6857L9.96424 2.68571ZM3.85355 5.14646C4.04882 5.34172 4.04882 5.6583 3.85355 5.85356L2.20711 7.50001L3.85355 9.14646C4.04882 9.34172 4.04882 9.6583 3.85355 9.85356C3.65829 10.0488 3.34171 10.0488 3.14645 9.85356L1.14645 7.85356C0.951184 7.6583 0.951184 7.34172 1.14645 7.14646L3.14645 5.14646C3.34171 4.9512 3.65829 4.9512 3.85355 5.14646ZM11.1464 5.14646C11.3417 4.9512 11.6583 4.9512 11.8536 5.14646L13.8536 7.14646C14.0488 7.34172 14.0488 7.6583 13.8536 7.85356L11.8536 9.85356C11.6583 10.0488 11.3417 10.0488 11.1464 9.85356C10.9512 9.6583 10.9512 9.34172 11.1464 9.14646L12.7929 7.50001L11.1464 5.85356C10.9512 5.6583 10.9512 5.34172 11.1464 5.14646Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$14 = [
    "color"
];
var $e781b76dcad7c5d5$export$32cdc32ad6ae0658 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$14);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.71144 0.796902C7.57741 0.734357 7.42257 0.734357 7.28855 0.796902L1.28855 3.5969C1.11251 3.67905 0.999993 3.85573 0.999993 4.04999V10.95C0.999993 11.1443 1.11251 11.3209 1.28855 11.4031L7.28855 14.2031C7.42257 14.2656 7.57741 14.2656 7.71144 14.2031L13.7114 11.4031C13.8875 11.3209 14 11.1443 14 10.95V4.04999C14 3.85573 13.8875 3.67905 13.7114 3.5969L7.71144 0.796902ZM7.49999 3.15674L5.98039 2.51091L7.49999 1.80176L9.01959 2.51091L7.49999 3.15674ZM7.69556 4.16018L10.2382 3.07958L12.2719 4.02865L7.49999 6.05671L2.72808 4.02865L4.76181 3.07958L7.30442 4.16018C7.42939 4.2133 7.57059 4.2133 7.69556 4.16018ZM7.99999 6.93078L13 4.80578V7.92966L11.0821 8.8119C10.7273 8.97509 10.5 9.32988 10.5 9.72039V11.7982L7.99999 12.9649V6.93078ZM11.5 11.3316L13 10.6316V9.03039L11.5 9.72039V11.3316ZM6.99999 6.93078V12.9649L4.50231 11.7993V9.72036C4.50231 9.32985 4.27499 8.97506 3.92022 8.81187L1.99999 7.92856V4.80578L6.99999 6.93078ZM1.99999 10.6316L3.50231 11.3326L3.50231 9.72036L1.99999 9.02929V10.6316Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$15 = [
    "color"
];
var $e781b76dcad7c5d5$export$bda33a04439dd942 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$15);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M0.877075 7.49985C0.877075 3.84216 3.84222 0.877014 7.49991 0.877014C11.1576 0.877014 14.1227 3.84216 14.1227 7.49985C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49985ZM3.78135 3.21565C4.68298 2.43239 5.83429 1.92904 7.09998 1.84089V6.53429L3.78135 3.21565ZM3.21567 3.78134C2.43242 4.68298 1.92909 5.83428 1.84095 7.09997H6.5343L3.21567 3.78134ZM6.5343 7.89997H1.84097C1.92916 9.16562 2.43253 10.3169 3.21579 11.2185L6.5343 7.89997ZM3.78149 11.7842C4.6831 12.5673 5.83435 13.0707 7.09998 13.1588V8.46566L3.78149 11.7842ZM7.89998 8.46566V13.1588C9.16559 13.0706 10.3168 12.5673 11.2184 11.7841L7.89998 8.46566ZM11.7841 11.2184C12.5673 10.3168 13.0707 9.16558 13.1588 7.89997H8.46567L11.7841 11.2184ZM8.46567 7.09997H13.1589C13.0707 5.83432 12.5674 4.68305 11.7842 3.78143L8.46567 7.09997ZM11.2185 3.21573C10.3169 2.43246 9.16565 1.92909 7.89998 1.8409V6.53429L11.2185 3.21573Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$16 = [
    "color"
];
var $e781b76dcad7c5d5$export$bfc20b5a7dea0537 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$16);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M8.00012 1.5C8.00012 1.22386 7.77626 1 7.50012 1C7.22398 1 7.00012 1.22386 7.00012 1.5V13.5C7.00012 13.7761 7.22398 14 7.50012 14C7.77626 14 8.00012 13.7761 8.00012 13.5V1.5ZM3.31812 5.818C3.49386 5.64227 3.49386 5.35734 3.31812 5.18161C3.14239 5.00587 2.85746 5.00587 2.68173 5.18161L0.681729 7.18161C0.505993 7.35734 0.505993 7.64227 0.681729 7.818L2.68173 9.818C2.85746 9.99374 3.14239 9.99374 3.31812 9.818C3.49386 9.64227 3.49386 9.35734 3.31812 9.18161L2.08632 7.9498H5.50017C5.7487 7.9498 5.95017 7.74833 5.95017 7.4998C5.95017 7.25128 5.7487 7.0498 5.50017 7.0498H2.08632L3.31812 5.818ZM12.3181 5.18161C12.1424 5.00587 11.8575 5.00587 11.6817 5.18161C11.506 5.35734 11.506 5.64227 11.6817 5.818L12.9135 7.0498H9.50017C9.25164 7.0498 9.05017 7.25128 9.05017 7.4998C9.05017 7.74833 9.25164 7.9498 9.50017 7.9498H12.9135L11.6817 9.18161C11.506 9.35734 11.506 9.64227 11.6817 9.818C11.8575 9.99374 12.1424 9.99374 12.3181 9.818L14.3181 7.818C14.4939 7.64227 14.4939 7.35734 14.3181 7.18161L12.3181 5.18161Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$17 = [
    "color"
];
var $e781b76dcad7c5d5$export$38f001d9cffdd080 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$17);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M2.14998 14V1H0.849976V14H2.14998ZM6.14998 14V1H4.84998V14H6.14998ZM10.15 1V14H8.84998V1H10.15ZM14.15 14V1H12.85V14H14.15Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$18 = [
    "color"
];
var $e781b76dcad7c5d5$export$13d9ab7fa696f910 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$18);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M9.94969 7.49989C9.94969 8.85288 8.85288 9.94969 7.49989 9.94969C6.14691 9.94969 5.0501 8.85288 5.0501 7.49989C5.0501 6.14691 6.14691 5.0501 7.49989 5.0501C8.85288 5.0501 9.94969 6.14691 9.94969 7.49989ZM10.8632 8C10.6213 9.64055 9.20764 10.8997 7.49989 10.8997C5.79214 10.8997 4.37847 9.64055 4.13662 8H0.5C0.223858 8 0 7.77614 0 7.5C0 7.22386 0.223858 7 0.5 7H4.13659C4.37835 5.35935 5.79206 4.1001 7.49989 4.1001C9.20772 4.1001 10.6214 5.35935 10.8632 7H14.5C14.7761 7 15 7.22386 15 7.5C15 7.77614 14.7761 8 14.5 8H10.8632Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$19 = [
    "color"
];
var $e781b76dcad7c5d5$export$a8e03ddff565be2c = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$19);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M4.67129 3.14634C4.47603 3.34161 4.47603 3.65819 4.67129 3.85345L7.14616 6.32833C7.34142 6.52359 7.65801 6.52359 7.85327 6.32833L10.3281 3.85345C10.5234 3.65819 10.5234 3.34161 10.3281 3.14634L7.85327 0.671471C7.65801 0.476209 7.34142 0.476209 7.14616 0.671471L4.67129 3.14634ZM7.49971 5.26766L5.73195 3.4999L7.49971 1.73213L9.26748 3.4999L7.49971 5.26766ZM8.67129 7.14634C8.47603 7.34161 8.47603 7.65819 8.67129 7.85345L11.1462 10.3283C11.3414 10.5236 11.658 10.5236 11.8533 10.3283L14.3281 7.85345C14.5234 7.65819 14.5234 7.34161 14.3281 7.14634L11.8533 4.67147C11.658 4.47621 11.3414 4.47621 11.1462 4.67147L8.67129 7.14634ZM11.4997 9.26766L9.73195 7.4999L11.4997 5.73213L13.2675 7.4999L11.4997 9.26766ZM4.67129 11.8535C4.47603 11.6582 4.47603 11.3416 4.67129 11.1463L7.14616 8.67147C7.34142 8.47621 7.65801 8.47621 7.85327 8.67147L10.3281 11.1463C10.5234 11.3416 10.5234 11.6582 10.3281 11.8535L7.85327 14.3283C7.65801 14.5236 7.34142 14.5236 7.14616 14.3283L4.67129 11.8535ZM5.73195 11.4999L7.49971 13.2677L9.26748 11.4999L7.49971 9.73213L5.73195 11.4999ZM0.671288 7.14649C0.476026 7.34175 0.476026 7.65834 0.671288 7.8536L3.14616 10.3285C3.34142 10.5237 3.65801 10.5237 3.85327 10.3285L6.32814 7.8536C6.5234 7.65834 6.5234 7.34175 6.32814 7.14649L3.85327 4.67162C3.65801 4.47636 3.34142 4.47636 3.14616 4.67162L0.671288 7.14649ZM3.49972 9.26781L1.73195 7.50005L3.49972 5.73228L5.26748 7.50005L3.49972 9.26781Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1a = [
    "color"
];
var $e781b76dcad7c5d5$export$467c6b1dbd59bc1e = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1a);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M3.87935 1H3.9H11.1H11.1207C11.5231 0.999994 11.8553 0.999989 12.1259 1.0221C12.407 1.04506 12.6653 1.09434 12.908 1.21799C13.2843 1.40973 13.5903 1.7157 13.782 2.09202C13.9057 2.33469 13.9549 2.59304 13.9779 2.87409C14 3.14468 14 3.47686 14 3.87934V3.9V11.1V11.1207C14 11.5231 14 11.8553 13.9779 12.1259C13.9549 12.407 13.9057 12.6653 13.782 12.908C13.5903 13.2843 13.2843 13.5903 12.908 13.782C12.6653 13.9057 12.407 13.9549 12.1259 13.9779C11.8553 14 11.5231 14 11.1207 14H11.1H3.9H3.87934C3.47686 14 3.14468 14 2.87409 13.9779C2.59304 13.9549 2.33469 13.9057 2.09202 13.782C1.7157 13.5903 1.40973 13.2843 1.21799 12.908C1.09434 12.6653 1.04506 12.407 1.0221 12.1259C0.999989 11.8553 0.999994 11.5231 1 11.1207V11.1207V11.1V3.9V3.87935V3.87934C0.999994 3.47686 0.999989 3.14468 1.0221 2.87409C1.04506 2.59304 1.09434 2.33469 1.21799 2.09202C1.40973 1.7157 1.7157 1.40973 2.09202 1.21799C2.33469 1.09434 2.59304 1.04506 2.87409 1.0221C3.14469 0.999989 3.47687 0.999994 3.87935 1ZM2.95552 2.01878C2.73631 2.03669 2.62421 2.06915 2.54601 2.10899C2.35785 2.20487 2.20487 2.35785 2.10899 2.54601C2.06915 2.62421 2.03669 2.73631 2.01878 2.95552C2.00039 3.18056 2 3.47171 2 3.9V7H7V2H3.9C3.47171 2 3.18056 2.00039 2.95552 2.01878ZM7 8H2V11.1C2 11.5283 2.00039 11.8194 2.01878 12.0445C2.03669 12.2637 2.06915 12.3758 2.10899 12.454C2.20487 12.6422 2.35785 12.7951 2.54601 12.891C2.62421 12.9309 2.73631 12.9633 2.95552 12.9812C3.18056 12.9996 3.47171 13 3.9 13H7V8ZM8 8H13V11.1C13 11.5283 12.9996 11.8194 12.9812 12.0445C12.9633 12.2637 12.9309 12.3758 12.891 12.454C12.7951 12.6422 12.6422 12.7951 12.454 12.891C12.3758 12.9309 12.2637 12.9633 12.0445 12.9812C11.8194 12.9996 11.5283 13 11.1 13H8V8ZM13 7H8V2H11.1C11.5283 2 11.8194 2.00039 12.0445 2.01878C12.2637 2.03669 12.3758 2.06915 12.454 2.10899C12.6422 2.20487 12.7951 2.35785 12.891 2.54601C12.9309 2.62421 12.9633 2.73631 12.9812 2.95552C12.9996 3.18056 13 3.47171 13 3.9V7Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1b = [
    "color"
];
var $e781b76dcad7c5d5$export$8b4f0e3d2d9d0b5 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1b);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.85367 1.48956C7.65841 1.29429 7.34182 1.29429 7.14656 1.48956L1.48971 7.14641C1.29445 7.34167 1.29445 7.65825 1.48971 7.85352L7.14656 13.5104C7.34182 13.7056 7.65841 13.7056 7.85367 13.5104L13.5105 7.85352C13.7058 7.65825 13.7058 7.34167 13.5105 7.14641L7.85367 1.48956ZM7.5 2.55033L2.55037 7.49996L7.5 12.4496V2.55033Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1c = [
    "color"
];
var $e781b76dcad7c5d5$export$4edbb1daceb32596 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1c);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.1465 1.48959C7.34176 1.29432 7.65835 1.29432 7.85361 1.48959L13.5105 7.14644C13.7057 7.3417 13.7057 7.65829 13.5105 7.85355L7.85361 13.5104C7.65835 13.7057 7.34176 13.7057 7.1465 13.5104L1.48965 7.85355C1.29439 7.65829 1.29439 7.3417 1.48965 7.14644L7.1465 1.48959ZM7.50005 2.55025L2.55031 7.49999L7.50005 12.4497L12.4498 7.49999L7.50005 2.55025Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1d = [
    "color"
];
var $e781b76dcad7c5d5$export$8a42855f849911b4 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1d);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.85361 1.48959C7.65835 1.29432 7.34176 1.29432 7.1465 1.48959L1.48965 7.14644C1.29439 7.3417 1.29439 7.65829 1.48965 7.85355L3.9645 10.3284L1.64644 12.6464C1.45118 12.8417 1.45118 13.1583 1.64644 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L4.6716 11.0355L7.1465 13.5104C7.34176 13.7057 7.65835 13.7057 7.85361 13.5104L13.5105 7.85355C13.7057 7.65829 13.7057 7.3417 13.5105 7.14644L11.0356 4.67154L13.3535 2.35355C13.5488 2.15829 13.5488 1.84171 13.3535 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L10.3285 3.96443L7.85361 1.48959ZM9.62135 4.67154L7.50005 2.55025L2.55031 7.49999L4.6716 9.62129L9.62135 4.67154ZM5.37871 10.3284L7.50005 12.4497L12.4498 7.49999L10.3285 5.37865L5.37871 10.3284Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1e = [
    "color"
];
var $e781b76dcad7c5d5$export$39c9cf5aa1336b1f = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1e);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M12.8034 7.14644C12.9986 6.95118 13.3152 6.95118 13.5105 7.14644C13.7057 7.3417 13.7057 7.65829 13.5105 7.85355C13.3152 8.04881 12.9986 8.04881 12.8034 7.85355C12.6081 7.65828 12.6081 7.3417 12.8034 7.14644ZM12.0962 8.56065C12.2915 8.75592 12.2915 9.0725 12.0962 9.26776C11.901 9.46302 11.5844 9.46302 11.3891 9.26776C11.1939 9.0725 11.1939 8.75592 11.3891 8.56065C11.5844 8.36539 11.901 8.36539 12.0962 8.56065ZM10.682 9.97487C10.8773 10.1701 10.8773 10.4867 10.682 10.682C10.4868 10.8772 10.1702 10.8772 9.97493 10.682C9.77967 10.4867 9.77967 10.1701 9.97493 9.97487C10.1702 9.7796 10.4868 9.7796 10.682 9.97487ZM9.26782 11.3891C9.46308 11.5843 9.46308 11.9009 9.26782 12.0962C9.07256 12.2915 8.75598 12.2915 8.56071 12.0962C8.36545 11.9009 8.36545 11.5843 8.56072 11.3891C8.75598 11.1938 9.07256 11.1938 9.26782 11.3891ZM7.1465 13.5104C6.95124 13.3151 6.95124 12.9986 7.1465 12.8033C7.17091 12.7789 7.19721 12.7575 7.22494 12.7392C7.41901 12.6111 7.68275 12.6324 7.85361 12.8033C8.04887 12.9986 8.04887 13.3151 7.85361 13.5104C7.65835 13.7057 7.34176 13.7057 7.1465 13.5104Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        d: "M2.90386 8.56065C2.7086 8.75592 2.7086 9.0725 2.90386 9.26776 3.09912 9.46302 3.41571 9.46302 3.61097 9.26776 3.80623 9.0725 3.80623 8.75592 3.61097 8.56065 3.41571 8.36539 3.09912 8.36539 2.90386 8.56065zM4.31807 9.97487C4.12281 10.1701 4.12281 10.4867 4.31807 10.682 4.51334 10.8772 4.82992 10.8772 5.02518 10.682 5.22044 10.4867 5.22044 10.1701 5.02518 9.97487 4.82992 9.7796 4.51334 9.7796 4.31807 9.97487zM5.73229 11.3891C5.53703 11.5843 5.53703 11.9009 5.73229 12.0962 5.92755 12.2914 6.24413 12.2915 6.43939 12.0962 6.63466 11.9009 6.63466 11.5843 6.43939 11.3891 6.24413 11.1938 5.92755 11.1938 5.73229 11.3891zM2.19675 7.85355C2.36761 7.68269 2.38897 7.41895 2.26082 7.22488 2.09046 6.96684 1.71063 6.92546 1.48965 7.14644 1.29439 7.3417 1.29439 7.65829 1.48965 7.85355 1.68491 8.04881 2.00149 8.04881 2.19675 7.85355zM3.61097 5.73223C3.41571 5.53696 3.09912 5.53696 2.90386 5.73223 2.7086 5.92749 2.7086 6.24407 2.90386 6.43933 3.09912 6.6346 3.41571 6.6346 3.61097 6.43933 3.80623 6.24407 3.80623 5.92749 3.61097 5.73223zM5.02518 4.31801C4.82992 4.12275 4.51334 4.12275 4.31807 4.31801 4.12281 4.51328 4.12281 4.82986 4.31807 5.02512 4.51334 5.22038 4.82992 5.22038 5.02518 5.02512 5.22044 4.82986 5.22044 4.51328 5.02518 4.31801zM6.43939 2.9038C6.24413 2.70854 5.92755 2.70854 5.73229 2.9038 5.53703 3.09906 5.53703 3.41564 5.73229 3.61091 5.92755 3.80617 6.24413 3.80617 6.43939 3.61091 6.63466 3.41564 6.63466 3.09906 6.43939 2.9038zM7.85361 1.48959C7.65835 1.29432 7.34176 1.29432 7.1465 1.48959 6.95124 1.68485 6.95124 2.00143 7.1465 2.19669 7.34176 2.39196 7.65835 2.39196 7.85361 2.19669 8.04887 2.00143 8.04887 1.68485 7.85361 1.48959zM9.26782 2.9038C9.07256 2.70854 8.75598 2.70854 8.56071 2.9038 8.36545 3.09906 8.36545 3.41564 8.56071 3.61091 8.75598 3.80617 9.07256 3.80617 9.26782 3.61091 9.46308 3.41564 9.46308 3.09906 9.26782 2.9038zM10.682 4.31801C10.4868 4.12275 10.1702 4.12275 9.97493 4.31801 9.77967 4.51328 9.77967 4.82986 9.97493 5.02512 10.1702 5.22038 10.4868 5.22038 10.682 5.02512 10.8773 4.82986 10.8773 4.51328 10.682 4.31801zM12.0962 5.73223C11.901 5.53696 11.5844 5.53696 11.3891 5.73223 11.1939 5.92749 11.1939 6.24407 11.3891 6.43933 11.5844 6.6346 11.901 6.6346 12.0962 6.43933 12.2915 6.24407 12.2915 5.92749 12.0962 5.73223z",
        fill: color
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1f = [
    "color"
];
var $e781b76dcad7c5d5$export$6d6da6edaddd5876 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1f);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M2 1.5C2 1.77614 1.77614 2 1.5 2C1.22386 2 1 1.77614 1 1.5C1 1.22386 1.22386 1 1.5 1C1.77614 1 2 1.22386 2 1.5ZM5 13H10V2L5 2L5 13ZM4 13C4 13.5523 4.44772 14 5 14H10C10.5523 14 11 13.5523 11 13V2C11 1.44772 10.5523 1 10 1H5C4.44772 1 4 1.44771 4 2V13ZM13.5 2C13.7761 2 14 1.77614 14 1.5C14 1.22386 13.7761 1 13.5 1C13.2239 1 13 1.22386 13 1.5C13 1.77614 13.2239 2 13.5 2ZM2 3.5C2 3.77614 1.77614 4 1.5 4C1.22386 4 1 3.77614 1 3.5C1 3.22386 1.22386 3 1.5 3C1.77614 3 2 3.22386 2 3.5ZM13.5 4C13.7761 4 14 3.77614 14 3.5C14 3.22386 13.7761 3 13.5 3C13.2239 3 13 3.22386 13 3.5C13 3.77614 13.2239 4 13.5 4ZM2 5.5C2 5.77614 1.77614 6 1.5 6C1.22386 6 1 5.77614 1 5.5C1 5.22386 1.22386 5 1.5 5C1.77614 5 2 5.22386 2 5.5ZM13.5 6C13.7761 6 14 5.77614 14 5.5C14 5.22386 13.7761 5 13.5 5C13.2239 5 13 5.22386 13 5.5C13 5.77614 13.2239 6 13.5 6ZM2 7.5C2 7.77614 1.77614 8 1.5 8C1.22386 8 1 7.77614 1 7.5C1 7.22386 1.22386 7 1.5 7C1.77614 7 2 7.22386 2 7.5ZM13.5 8C13.7761 8 14 7.77614 14 7.5C14 7.22386 13.7761 7 13.5 7C13.2239 7 13 7.22386 13 7.5C13 7.77614 13.2239 8 13.5 8ZM2 9.5C2 9.77614 1.77614 10 1.5 10C1.22386 10 1 9.77614 1 9.5C1 9.22386 1.22386 9 1.5 9C1.77614 9 2 9.22386 2 9.5ZM13.5 10C13.7761 10 14 9.77614 14 9.5C14 9.22386 13.7761 9 13.5 9C13.2239 9 13 9.22386 13 9.5C13 9.77614 13.2239 10 13.5 10ZM2 11.5C2 11.7761 1.77614 12 1.5 12C1.22386 12 1 11.7761 1 11.5C1 11.2239 1.22386 11 1.5 11C1.77614 11 2 11.2239 2 11.5ZM13.5 12C13.7761 12 14 11.7761 14 11.5C14 11.2239 13.7761 11 13.5 11C13.2239 11 13 11.2239 13 11.5C13 11.7761 13.2239 12 13.5 12ZM2 13.5C2 13.7761 1.77614 14 1.5 14C1.22386 14 1 13.7761 1 13.5C1 13.2239 1.22386 13 1.5 13C1.77614 13 2 13.2239 2 13.5ZM13.5 14C13.7761 14 14 13.7761 14 13.5C14 13.2239 13.7761 13 13.5 13C13.2239 13 13 13.2239 13 13.5C13 13.7761 13.2239 14 13.5 14Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1g = [
    "color"
];
var $e781b76dcad7c5d5$export$4231f341127e9d59 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1g);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M12.0697 1.76746C12.4807 1.21947 11.4605 0.454311 11.0495 1.0023C10.6385 1.55028 11.6588 2.31544 12.0697 1.76746ZM8.39263 1.07811C7.15585 0.950602 5.7823 1.16348 4.58433 1.70937C3.38552 2.25563 2.32735 3.15309 1.78844 4.41832C1.37574 5.38724 1.01715 6.28113 1.00088 7.44354C0.984724 8.59844 1.30522 9.96898 2.13174 11.928C2.61142 13.0649 4.03963 13.5446 5.13895 13.8079C6.40836 14.1119 7.80857 14.1914 8.6644 14.0742C9.36515 13.9782 10.1448 13.8284 10.7987 13.297C11.8977 12.4039 12.9009 11.3955 13.4994 10.3393C14.104 9.27221 14.3256 8.09207 13.7216 6.95324C13.5628 6.65373 13.316 6.57734 13.0412 6.4923C12.9374 6.46016 12.8295 6.42678 12.7209 6.37966C11.6211 5.90234 10.9646 5.34963 10.9135 5.02876C10.8656 4.72808 10.9221 4.51463 10.9811 4.29181C11.0129 4.17199 11.0453 4.04947 11.0626 3.90922C11.0838 3.73737 11.0814 3.33319 10.6996 3.12761C10.4048 2.96888 10.2164 2.65843 10.0407 2.36904C9.99742 2.29775 9.95492 2.22773 9.9118 2.16158C9.62634 1.72367 9.20769 1.16213 8.39263 1.07811ZM4.99899 2.61935C3.96483 3.09058 3.12554 3.83097 2.70846 4.81018C2.29808 5.77368 2.01406 6.50873 2.00079 7.45753C1.98741 8.41385 2.25043 9.6368 3.0531 11.5393C3.39181 12.3421 4.62167 12.6557 5.37186 12.8354C6.5493 13.1174 7.822 13.1802 8.52868 13.0834C9.21271 12.9897 9.74568 12.8642 10.1681 12.5209C11.229 11.6587 12.121 10.7435 12.6293 9.84635C12.9349 9.30709 13.5141 7.7028 12.6292 7.3873C10.7539 6.71875 10.262 6.06669 9.99011 5.41268C9.80915 4.97744 9.82868 4.52282 9.95741 4.07885L9.95741 4.07884C9.97662 4.0126 9.99538 3.94791 10.0334 3.88882C9.81857 3.73676 9.6515 3.55195 9.51464 3.3715C9.42876 3.25828 9.3469 3.12099 9.26197 2.97856C9.01866 2.57052 8.75018 2.12027 8.29008 2.07283C7.22889 1.96343 6.03398 2.14772 4.99899 2.61935ZM13.2081 3.77471C13.441 3.22671 12.4547 2.63606 12.0822 3.10163C11.5817 3.72732 12.9029 4.49281 13.2081 3.77471ZM14.3672 2.26031C14.9668 2.27493 15.1551 1.11603 14.5718 0.949371C13.8076 0.731026 13.5918 2.24139 14.3672 2.26031ZM14.2857 5.09098C14.8644 5.10004 15.0462 4.38222 14.4832 4.27899C13.7455 4.14375 13.5373 5.07927 14.2857 5.09098ZM6.9075 4.28672C6.46898 4.66754 6.0522 4.15185 5.97983 3.7365C5.86848 3.09744 6.33696 2.56856 6.94823 2.91156C7.43344 3.18382 7.26678 3.97471 6.9075 4.28672ZM4.94455 5.88184C5.40885 5.41754 4.59567 4.57013 4.11425 5.05154C3.83338 5.33242 4.00936 5.65376 4.23744 5.88184C4.43271 6.0771 4.74929 6.0771 4.94455 5.88184ZM6.97716 6.71984C7.31181 7.38914 8.48804 6.79159 7.99413 6.14788C7.86519 5.97983 7.68657 5.9494 7.62145 5.94207C7.21217 5.89601 6.76349 6.2925 6.97716 6.71984ZM6.98798 8.72461C7.14066 9.1188 7.51122 9.3187 7.91915 9.1633C8.27434 9.02799 8.33186 8.39689 8.17175 8.07427C8.02331 7.77514 7.63956 7.67793 7.33747 7.79417C6.98512 7.92976 6.85672 8.38708 6.98576 8.71889L6.98798 8.72461ZM10.3885 8.84081C10.7575 8.6566 11.4617 8.82771 11.4617 9.31199C11.4617 9.71286 10.9587 10.2165 10.5634 10.2826C10.1813 10.3465 9.70515 9.97581 9.76648 9.57718C9.81445 9.26539 10.1217 8.97401 10.3885 8.84081ZM7.56704 10.8432C7.33461 10.7502 7.14353 10.8601 7.11437 10.8769L7.11279 10.8778C6.90782 10.9949 6.71383 11.2439 6.6747 11.4842C6.59018 12.0034 7.13199 12.1239 7.52661 12.0987C8.2074 12.0553 8.06547 11.0426 7.56704 10.8432ZM4.8805 10.8932C5.0674 10.7723 5.15658 10.5363 5.08293 10.3153C4.93046 9.79687 4.3246 9.71252 3.96561 10.1297C3.79336 10.3299 3.80749 10.6274 3.99214 10.8105L3.99495 10.814L3.9979 10.8176C4.22025 11.0942 4.63624 11.1857 4.8805 10.8932ZM3.04695 7.81318C3.33147 8.0977 3.60077 8.15067 3.98443 8.05859C4.60826 7.90887 4.13814 6.24299 3.047 6.87296C2.70939 7.06788 2.86716 7.63339 3.04695 7.81318Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1h = [
    "color"
];
var $e781b76dcad7c5d5$export$51b6cd98f8778f0d = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1h);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M1 9.50006C1 10.3285 1.67157 11.0001 2.5 11.0001H4L4 10.0001H2.5C2.22386 10.0001 2 9.7762 2 9.50006L2 2.50006C2 2.22392 2.22386 2.00006 2.5 2.00006L9.5 2.00006C9.77614 2.00006 10 2.22392 10 2.50006V4.00002H5.5C4.67158 4.00002 4 4.67159 4 5.50002V12.5C4 13.3284 4.67158 14 5.5 14H12.5C13.3284 14 14 13.3284 14 12.5V5.50002C14 4.67159 13.3284 4.00002 12.5 4.00002H11V2.50006C11 1.67163 10.3284 1.00006 9.5 1.00006H2.5C1.67157 1.00006 1 1.67163 1 2.50006V9.50006ZM5 5.50002C5 5.22388 5.22386 5.00002 5.5 5.00002H12.5C12.7761 5.00002 13 5.22388 13 5.50002V12.5C13 12.7762 12.7761 13 12.5 13H5.5C5.22386 13 5 12.7762 5 12.5V5.50002Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1i = [
    "color"
];
var $e781b76dcad7c5d5$export$53250eb5c8bd1390 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1i);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M9.87737 12H9.9H11.5C11.7761 12 12 11.7761 12 11.5C12 11.2239 11.7761 11 11.5 11H9.9C8.77164 11 7.95545 10.9996 7.31352 10.9472C6.67744 10.8952 6.25662 10.7946 5.91103 10.6185C5.25247 10.283 4.71703 9.74753 4.38148 9.08897C4.20539 8.74338 4.10481 8.32256 4.05284 7.68648C4.00039 7.04455 4 6.22836 4 5.1V3.5C4 3.22386 3.77614 3 3.5 3C3.22386 3 3 3.22386 3 3.5V5.1V5.12263C3 6.22359 3 7.08052 3.05616 7.76791C3.11318 8.46584 3.23058 9.0329 3.49047 9.54296C3.9219 10.3897 4.61031 11.0781 5.45704 11.5095C5.9671 11.7694 6.53416 11.8868 7.23209 11.9438C7.91948 12 8.77641 12 9.87737 12Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1j = [
    "color"
];
var $e781b76dcad7c5d5$export$13d7020d49a403c9 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1j);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M5.12263 12H5.1H3.5C3.22386 12 3 11.7761 3 11.5C3 11.2239 3.22386 11 3.5 11H5.1C6.22836 11 7.04455 10.9996 7.68648 10.9472C8.32256 10.8952 8.74338 10.7946 9.08897 10.6185C9.74753 10.283 10.283 9.74753 10.6185 9.08897C10.7946 8.74338 10.8952 8.32256 10.9472 7.68648C10.9996 7.04455 11 6.22836 11 5.1V3.5C11 3.22386 11.2239 3 11.5 3C11.7761 3 12 3.22386 12 3.5V5.1V5.12263C12 6.22359 12 7.08052 11.9438 7.76791C11.8868 8.46584 11.7694 9.0329 11.5095 9.54296C11.0781 10.3897 10.3897 11.0781 9.54296 11.5095C9.0329 11.7694 8.46584 11.8868 7.76791 11.9438C7.08052 12 6.22359 12 5.12263 12Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1k = [
    "color"
];
var $e781b76dcad7c5d5$export$e709160419ee2246 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1k);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M9.87737 3H9.9H11.5C11.7761 3 12 3.22386 12 3.5C12 3.77614 11.7761 4 11.5 4H9.9C8.77164 4 7.95545 4.00039 7.31352 4.05284C6.67744 4.10481 6.25662 4.20539 5.91103 4.38148C5.25247 4.71703 4.71703 5.25247 4.38148 5.91103C4.20539 6.25662 4.10481 6.67744 4.05284 7.31352C4.00039 7.95545 4 8.77164 4 9.9V11.5C4 11.7761 3.77614 12 3.5 12C3.22386 12 3 11.7761 3 11.5V9.9V9.87737C3 8.77641 3 7.91948 3.05616 7.23209C3.11318 6.53416 3.23058 5.9671 3.49047 5.45704C3.9219 4.61031 4.61031 3.9219 5.45704 3.49047C5.9671 3.23058 6.53416 3.11318 7.23209 3.05616C7.91948 3 8.77641 3 9.87737 3Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1l = [
    "color"
];
var $e781b76dcad7c5d5$export$8e3e82083a0db3ff = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1l);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M5.12263 3H5.1H3.5C3.22386 3 3 3.22386 3 3.5C3 3.77614 3.22386 4 3.5 4H5.1C6.22836 4 7.04455 4.00039 7.68648 4.05284C8.32256 4.10481 8.74338 4.20539 9.08897 4.38148C9.74753 4.71703 10.283 5.25247 10.6185 5.91103C10.7946 6.25662 10.8952 6.67744 10.9472 7.31352C10.9996 7.95545 11 8.77164 11 9.9V11.5C11 11.7761 11.2239 12 11.5 12C11.7761 12 12 11.7761 12 11.5V9.9V9.87737C12 8.77641 12 7.91948 11.9438 7.23209C11.8868 6.53416 11.7694 5.9671 11.5095 5.45704C11.0781 4.61031 10.3897 3.9219 9.54296 3.49047C9.0329 3.23058 8.46584 3.11318 7.76791 3.05616C7.08052 3 6.22359 3 5.12263 3Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1m = [
    "color"
];
var $e781b76dcad7c5d5$export$3473a9c28d168741 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1m);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M5.5 2L4.87935 2C4.47687 1.99999 4.14469 1.99999 3.87409 2.0221C3.59304 2.04506 3.33469 2.09434 3.09202 2.21799C2.7157 2.40973 2.40973 2.7157 2.21799 3.09202C2.09434 3.33469 2.04506 3.59304 2.0221 3.87409C1.99999 4.14468 1.99999 4.47686 2 4.87933V4.87935V5.5C2 5.77614 2.22386 6 2.5 6C2.77614 6 3 5.77614 3 5.5V4.9C3 4.47171 3.00039 4.18056 3.01878 3.95552C3.03669 3.73631 3.06915 3.62421 3.10899 3.54601C3.20487 3.35785 3.35785 3.20487 3.54601 3.10899C3.62421 3.06915 3.73631 3.03669 3.95552 3.01878C4.18056 3.00039 4.47171 3 4.9 3H5.5C5.77614 3 6 2.77614 6 2.5C6 2.22386 5.77614 2 5.5 2ZM13 9.5C13 9.22386 12.7761 9 12.5 9C12.2239 9 12 9.22386 12 9.5V10.1C12 10.5283 11.9996 10.8194 11.9812 11.0445C11.9633 11.2637 11.9309 11.3758 11.891 11.454C11.7951 11.6422 11.6422 11.7951 11.454 11.891C11.3758 11.9309 11.2637 11.9633 11.0445 11.9812C10.8194 11.9996 10.5283 12 10.1 12H9.5C9.22386 12 9 12.2239 9 12.5C9 12.7761 9.22386 13 9.5 13H10.1206C10.5231 13 10.8553 13 11.1259 12.9779C11.407 12.9549 11.6653 12.9057 11.908 12.782C12.2843 12.5903 12.5903 12.2843 12.782 11.908C12.9057 11.6653 12.9549 11.407 12.9779 11.1259C13 10.8553 13 10.5232 13 10.1207V10.1207V10.1207V10.1206V9.5ZM2.5 9C2.77614 9 3 9.22386 3 9.5V10.1C3 10.5283 3.00039 10.8194 3.01878 11.0445C3.03669 11.2637 3.06915 11.3758 3.10899 11.454C3.20487 11.6422 3.35785 11.7951 3.54601 11.891C3.62421 11.9309 3.73631 11.9633 3.95552 11.9812C4.18056 11.9996 4.47171 12 4.9 12H5.5C5.77614 12 6 12.2239 6 12.5C6 12.7761 5.77614 13 5.5 13H4.87935C4.47687 13 4.14469 13 3.87409 12.9779C3.59304 12.9549 3.33469 12.9057 3.09202 12.782C2.7157 12.5903 2.40973 12.2843 2.21799 11.908C2.09434 11.6653 2.04506 11.407 2.0221 11.1259C1.99999 10.8553 1.99999 10.5231 2 10.1207V10.1206V10.1V9.5C2 9.22386 2.22386 9 2.5 9ZM10.1 3C10.5283 3 10.8194 3.00039 11.0445 3.01878C11.2637 3.03669 11.3758 3.06915 11.454 3.10899C11.6422 3.20487 11.7951 3.35785 11.891 3.54601C11.9309 3.62421 11.9633 3.73631 11.9812 3.95552C11.9996 4.18056 12 4.47171 12 4.9V5.5C12 5.77614 12.2239 6 12.5 6C12.7761 6 13 5.77614 13 5.5V4.87935V4.87934C13 4.47686 13 4.14468 12.9779 3.87409C12.9549 3.59304 12.9057 3.33469 12.782 3.09202C12.5903 2.7157 12.2843 2.40973 11.908 2.21799C11.6653 2.09434 11.407 2.04506 11.1259 2.0221C10.8553 1.99999 10.5231 1.99999 10.1206 2L10.1 2H9.5C9.22386 2 9 2.22386 9 2.5C9 2.77614 9.22386 3 9.5 3H10.1Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1n = [
    "color"
];
var $e781b76dcad7c5d5$export$d947354b0bb44dfa = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1n);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M13.15 7.49998C13.15 4.66458 10.9402 1.84998 7.50002 1.84998C4.7217 1.84998 3.34851 3.90636 2.76336 4.99997H4.5C4.77614 4.99997 5 5.22383 5 5.49997C5 5.77611 4.77614 5.99997 4.5 5.99997H1.5C1.22386 5.99997 1 5.77611 1 5.49997V2.49997C1 2.22383 1.22386 1.99997 1.5 1.99997C1.77614 1.99997 2 2.22383 2 2.49997V4.31318C2.70453 3.07126 4.33406 0.849976 7.50002 0.849976C11.5628 0.849976 14.15 4.18537 14.15 7.49998C14.15 10.8146 11.5628 14.15 7.50002 14.15C5.55618 14.15 3.93778 13.3808 2.78548 12.2084C2.16852 11.5806 1.68668 10.839 1.35816 10.0407C1.25306 9.78536 1.37488 9.49315 1.63024 9.38806C1.8856 9.28296 2.17781 9.40478 2.2829 9.66014C2.56374 10.3425 2.97495 10.9745 3.4987 11.5074C4.47052 12.4963 5.83496 13.15 7.50002 13.15C10.9402 13.15 13.15 10.3354 13.15 7.49998ZM7 10V5.00001H8V10H7Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1o = [
    "color"
];
var $e781b76dcad7c5d5$export$92a2757a17018399 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1o);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M13.15 7.49998C13.15 4.66458 10.9402 1.84998 7.50002 1.84998C4.72167 1.84998 3.34849 3.9064 2.76335 5H4.5C4.77614 5 5 5.22386 5 5.5C5 5.77614 4.77614 6 4.5 6H1.5C1.22386 6 1 5.77614 1 5.5V2.5C1 2.22386 1.22386 2 1.5 2C1.77614 2 2 2.22386 2 2.5V4.31318C2.70453 3.07126 4.33406 0.849976 7.50002 0.849976C11.5628 0.849976 14.15 4.18537 14.15 7.49998C14.15 10.8146 11.5628 14.15 7.50002 14.15C5.55618 14.15 3.93778 13.3808 2.78548 12.2084C2.16852 11.5806 1.68668 10.839 1.35816 10.0407C1.25306 9.78536 1.37488 9.49315 1.63024 9.38806C1.8856 9.28296 2.17781 9.40478 2.2829 9.66014C2.56374 10.3425 2.97495 10.9745 3.4987 11.5074C4.47052 12.4963 5.83496 13.15 7.50002 13.15C10.9402 13.15 13.15 10.3354 13.15 7.49998ZM7.5 4.00001C7.77614 4.00001 8 4.22387 8 4.50001V7.29291L9.85355 9.14646C10.0488 9.34172 10.0488 9.65831 9.85355 9.85357C9.65829 10.0488 9.34171 10.0488 9.14645 9.85357L7.14645 7.85357C7.05268 7.7598 7 7.63262 7 7.50001V4.50001C7 4.22387 7.22386 4.00001 7.5 4.00001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1p = [
    "color"
];
var $e781b76dcad7c5d5$export$9816aad82d905e6 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1p);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M3.5 8.00684e-07C3.77614 7.88614e-07 4 0.223859 4 0.500001L4 3.00006L11.5 3.00006C11.7761 3.00006 12 3.22392 12 3.50006L12 11.0001L14.5 11C14.7761 11 15 11.2238 15 11.5C15 11.7761 14.7762 12 14.5 12L12 12.0001L12 14.5C12 14.7761 11.7761 15 11.5 15C11.2239 15 11 14.7761 11 14.5L11 12.0001L3.5 12.0001C3.22386 12.0001 3 11.7762 3 11.5001L3 4.00005L0.499989 4C0.223847 4 -6.10541e-06 3.77613 -5.02576e-07 3.49999C5.13006e-06 3.22385 0.223867 3 0.50001 3L3 3.00005L3 0.500001C3 0.223859 3.22386 8.12755e-07 3.5 8.00684e-07ZM4 4.00006L4 11.0001L11 11.0001L11 4.00006L4 4.00006Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1q = [
    "color"
];
var $e781b76dcad7c5d5$export$8c97d895bfadca90 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1q);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M12.8536 2.85355C13.0488 2.65829 13.0488 2.34171 12.8536 2.14645C12.6583 1.95118 12.3417 1.95118 12.1464 2.14645L7.5 6.79289L2.85355 2.14645C2.65829 1.95118 2.34171 1.95118 2.14645 2.14645C1.95118 2.34171 1.95118 2.65829 2.14645 2.85355L6.79289 7.5L2.14645 12.1464C1.95118 12.3417 1.95118 12.6583 2.14645 12.8536C2.34171 13.0488 2.65829 13.0488 2.85355 12.8536L7.5 8.20711L12.1464 12.8536C12.3417 13.0488 12.6583 13.0488 12.8536 12.8536C13.0488 12.6583 13.0488 12.3417 12.8536 12.1464L8.20711 7.5L12.8536 2.85355Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1r = [
    "color"
];
var $e781b76dcad7c5d5$export$b7fa469a3cb3cd4f = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1r);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1s = [
    "color"
];
var $e781b76dcad7c5d5$export$8710c0d3947fcfc3 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1s);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M0.877075 7.49988C0.877075 3.84219 3.84222 0.877045 7.49991 0.877045C11.1576 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49988ZM7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 4.36686 10.6329 1.82704 7.49991 1.82704ZM9.85358 5.14644C10.0488 5.3417 10.0488 5.65829 9.85358 5.85355L8.20713 7.49999L9.85358 9.14644C10.0488 9.3417 10.0488 9.65829 9.85358 9.85355C9.65832 10.0488 9.34173 10.0488 9.14647 9.85355L7.50002 8.2071L5.85358 9.85355C5.65832 10.0488 5.34173 10.0488 5.14647 9.85355C4.95121 9.65829 4.95121 9.3417 5.14647 9.14644L6.79292 7.49999L5.14647 5.85355C4.95121 5.65829 4.95121 5.3417 5.14647 5.14644C5.34173 4.95118 5.65832 4.95118 5.85358 5.14644L7.50002 6.79289L9.14647 5.14644C9.34173 4.95118 9.65832 4.95118 9.85358 5.14644Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1t = [
    "color"
];
var $e781b76dcad7c5d5$export$d5c5855fccded9fe = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1t);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M0.877075 7.50207C0.877075 3.84319 3.84319 0.877075 7.50208 0.877075C11.1609 0.877075 14.1271 3.84319 14.1271 7.50207C14.1271 11.1609 11.1609 14.1271 7.50208 14.1271C3.84319 14.1271 0.877075 11.1609 0.877075 7.50207ZM1.84898 7.00003C2.0886 4.26639 4.26639 2.0886 7.00003 1.84898V4.50003C7.00003 4.77617 7.22388 5.00003 7.50003 5.00003C7.77617 5.00003 8.00003 4.77617 8.00003 4.50003V1.84862C10.7356 2.08643 12.9154 4.26502 13.1552 7.00003H10.5C10.2239 7.00003 10 7.22388 10 7.50003C10 7.77617 10.2239 8.00003 10.5 8.00003H13.1555C12.9176 10.7369 10.7369 12.9176 8.00003 13.1555V10.5C8.00003 10.2239 7.77617 10 7.50003 10C7.22388 10 7.00003 10.2239 7.00003 10.5V13.1552C4.26502 12.9154 2.08643 10.7356 1.84862 8.00003H4.50003C4.77617 8.00003 5.00003 7.77617 5.00003 7.50003C5.00003 7.22388 4.77617 7.00003 4.50003 7.00003H1.84898Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1u = [
    "color"
];
var $e781b76dcad7c5d5$export$d0fffbce0e008b09 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1u);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.5 0C7.77614 0 8 0.223858 8 0.5V1.80687C10.6922 2.0935 12.8167 4.28012 13.0068 7H14.5C14.7761 7 15 7.22386 15 7.5C15 7.77614 14.7761 8 14.5 8H12.9888C12.7094 10.6244 10.6244 12.7094 8 12.9888V14.5C8 14.7761 7.77614 15 7.5 15C7.22386 15 7 14.7761 7 14.5V13.0068C4.28012 12.8167 2.0935 10.6922 1.80687 8H0.5C0.223858 8 0 7.77614 0 7.5C0 7.22386 0.223858 7 0.5 7H1.78886C1.98376 4.21166 4.21166 1.98376 7 1.78886V0.5C7 0.223858 7.22386 0 7.5 0ZM8 12.0322V9.5C8 9.22386 7.77614 9 7.5 9C7.22386 9 7 9.22386 7 9.5V12.054C4.80517 11.8689 3.04222 10.1668 2.76344 8H5.5C5.77614 8 6 7.77614 6 7.5C6 7.22386 5.77614 7 5.5 7H2.7417C2.93252 4.73662 4.73662 2.93252 7 2.7417V5.5C7 5.77614 7.22386 6 7.5 6C7.77614 6 8 5.77614 8 5.5V2.76344C10.1668 3.04222 11.8689 4.80517 12.054 7H9.5C9.22386 7 9 7.22386 9 7.5C9 7.77614 9.22386 8 9.5 8H12.0322C11.7621 10.0991 10.0991 11.7621 8 12.0322Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1v = [
    "color"
];
var $e781b76dcad7c5d5$export$18abdbf97bad2a11 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1v);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M4.60913 0.0634287C4.39082 0.0088505 4.16575 0.12393 4.08218 0.332867L3.1538 2.6538L0.832866 3.58218C0.702884 3.63417 0.604504 3.7437 0.566705 3.87849C0.528906 4.01329 0.555994 4.158 0.639992 4.26999L2.01148 6.09864L1.06343 9.89085C1.00944 10.1068 1.12145 10.3298 1.32691 10.4154L4.20115 11.613L5.62557 13.7496C5.73412 13.9124 5.93545 13.9864 6.12362 13.9327L9.62362 12.9327C9.62988 12.9309 9.63611 12.929 9.64229 12.9269L12.6423 11.9269C12.7923 11.8769 12.905 11.7519 12.9393 11.5976L13.9393 7.09761C13.9776 6.92506 13.9114 6.74605 13.77 6.63999L11.95 5.27499V2.99999C11.95 2.82955 11.8537 2.67373 11.7012 2.5975L8.70124 1.0975C8.67187 1.08282 8.64098 1.07139 8.60913 1.06343L4.60913 0.0634287ZM11.4323 6.01173L12.7748 7.01858L10.2119 9.15429C10.1476 9.20786 10.0995 9.2783 10.0731 9.35769L9.25382 11.8155L7.73849 10.8684C7.52774 10.7367 7.25011 10.8007 7.11839 11.0115C6.98667 11.2222 7.05074 11.4999 7.26149 11.6316L8.40341 12.3453L6.19221 12.9771L4.87441 11.0004C4.82513 10.9265 4.75508 10.8688 4.67307 10.8346L2.03046 9.73352L2.85134 6.44999H4.99999C5.24852 6.44999 5.44999 6.24852 5.44999 5.99999C5.44999 5.75146 5.24852 5.54999 4.99999 5.54999H2.72499L1.7123 4.19974L3.51407 3.47903L6.35769 4.4269C6.53655 4.48652 6.73361 4.42832 6.85138 4.28111L8.62413 2.06518L11.05 3.27811V5.19533L8.83287 6.08218C8.70996 6.13134 8.61494 6.23212 8.57308 6.35769L8.07308 7.85769C7.99449 8.09346 8.12191 8.34831 8.35769 8.4269C8.59346 8.50549 8.84831 8.37807 8.9269 8.14229L9.3609 6.84029L11.4323 6.01173ZM7.71052 1.76648L6.34462 3.47386L4.09505 2.724L4.77192 1.03183L7.71052 1.76648ZM10.2115 11.7885L12.116 11.1537L12.7745 8.19034L10.8864 9.76374L10.2115 11.7885Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1w = [
    "color"
];
var $e781b76dcad7c5d5$export$315ae6298b7de94 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1w);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.28856 0.796908C7.42258 0.734364 7.57742 0.734364 7.71144 0.796908L13.7114 3.59691C13.8875 3.67906 14 3.85574 14 4.05V10.95C14 11.1443 13.8875 11.3209 13.7114 11.4031L7.71144 14.2031C7.57742 14.2656 7.42258 14.2656 7.28856 14.2031L1.28856 11.4031C1.11252 11.3209 1 11.1443 1 10.95V4.05C1 3.85574 1.11252 3.67906 1.28856 3.59691L7.28856 0.796908ZM2 4.80578L7 6.93078V12.9649L2 10.6316V4.80578ZM8 12.9649L13 10.6316V4.80578L8 6.93078V12.9649ZM7.5 6.05672L12.2719 4.02866L7.5 1.80176L2.72809 4.02866L7.5 6.05672Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1x = [
    "color"
];
var $e781b76dcad7c5d5$export$4e8767be554cec68 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1x);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M3.29227 0.048984C3.47033 -0.032338 3.67946 -0.00228214 3.8274 0.125891L12.8587 7.95026C13.0134 8.08432 13.0708 8.29916 13.0035 8.49251C12.9362 8.68586 12.7578 8.81866 12.5533 8.82768L9.21887 8.97474L11.1504 13.2187C11.2648 13.47 11.1538 13.7664 10.9026 13.8808L8.75024 14.8613C8.499 14.9758 8.20255 14.8649 8.08802 14.6137L6.15339 10.3703L3.86279 12.7855C3.72196 12.934 3.50487 12.9817 3.31479 12.9059C3.1247 12.8301 3 12.6461 3 12.4414V0.503792C3 0.308048 3.11422 0.130306 3.29227 0.048984ZM4 1.59852V11.1877L5.93799 9.14425C6.05238 9.02363 6.21924 8.96776 6.38319 8.99516C6.54715 9.02256 6.68677 9.12965 6.75573 9.2809L8.79056 13.7441L10.0332 13.178L8.00195 8.71497C7.93313 8.56376 7.94391 8.38824 8.03072 8.24659C8.11753 8.10494 8.26903 8.01566 8.435 8.00834L11.2549 7.88397L4 1.59852Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1y = [
    "color"
];
var $e781b76dcad7c5d5$export$d665abe9390574dd = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1y);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M4.5 1C4.22386 1 4 1.22386 4 1.5C4 1.77614 4.22386 2 4.5 2C5.42215 2 6.0399 2.23054 6.42075 2.56379C6.79286 2.88939 7 3.36626 7 4V7H5.75C5.47386 7 5.25 7.22386 5.25 7.5C5.25 7.77614 5.47386 8 5.75 8H7V11C7 11.6337 6.79286 12.1106 6.42075 12.4362C6.0399 12.7695 5.42215 13 4.5 13C4.22386 13 4 13.2239 4 13.5C4 13.7761 4.22386 14 4.5 14C5.57785 14 6.4601 13.7305 7.07925 13.1888C7.24168 13.0467 7.38169 12.8896 7.5 12.7198C7.61832 12.8896 7.75832 13.0467 7.92075 13.1888C8.5399 13.7305 9.42215 14 10.5 14C10.7761 14 11 13.7761 11 13.5C11 13.2239 10.7761 13 10.5 13C9.57785 13 8.9601 12.7695 8.57925 12.4362C8.20714 12.1106 8 11.6337 8 11V8H9.25C9.52614 8 9.75 7.77614 9.75 7.5C9.75 7.22386 9.52614 7 9.25 7H8V4C8 3.36626 8.20714 2.88939 8.57925 2.56379C8.9601 2.23054 9.57785 2 10.5 2C10.7761 2 11 1.77614 11 1.5C11 1.22386 10.7761 1 10.5 1C9.42215 1 8.5399 1.26946 7.92075 1.81121C7.75832 1.95333 7.61832 2.11043 7.5 2.28023C7.38168 2.11043 7.24168 1.95333 7.07925 1.81121C6.4601 1.26946 5.57785 1 4.5 1Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1z = [
    "color"
];
var $e781b76dcad7c5d5$export$a2bc8cb49334c5d1 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1z);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M5 7.5C5 7.22386 5.22386 7 5.5 7H9.5C9.77614 7 10 7.22386 10 7.5C10 7.77614 9.77614 8 9.5 8H5.5C5.22386 8 5 7.77614 5 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1A = [
    "color"
];
var $e781b76dcad7c5d5$export$8fd9d8340b1bb79a = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1A);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M2.8 1L2.74967 0.99997C2.52122 0.999752 2.32429 0.999564 2.14983 1.04145C1.60136 1.17312 1.17312 1.60136 1.04145 2.14983C0.999564 2.32429 0.999752 2.52122 0.99997 2.74967L1 2.8V5.2L0.99997 5.25033C0.999752 5.47878 0.999564 5.67572 1.04145 5.85017C1.17312 6.39864 1.60136 6.82688 2.14983 6.95856C2.32429 7.00044 2.52122 7.00025 2.74967 7.00003L2.8 7H5.2L5.25033 7.00003C5.47878 7.00025 5.67572 7.00044 5.85017 6.95856C6.39864 6.82688 6.82688 6.39864 6.95856 5.85017C7.00044 5.67572 7.00025 5.47878 7.00003 5.25033L7 5.2V2.8L7.00003 2.74967C7.00025 2.52122 7.00044 2.32429 6.95856 2.14983C6.82688 1.60136 6.39864 1.17312 5.85017 1.04145C5.67572 0.999564 5.47878 0.999752 5.25033 0.99997L5.2 1H2.8ZM2.38328 2.01382C2.42632 2.00348 2.49222 2 2.8 2H5.2C5.50779 2 5.57369 2.00348 5.61672 2.01382C5.79955 2.05771 5.94229 2.20045 5.98619 2.38328C5.99652 2.42632 6 2.49222 6 2.8V5.2C6 5.50779 5.99652 5.57369 5.98619 5.61672C5.94229 5.79955 5.79955 5.94229 5.61672 5.98619C5.57369 5.99652 5.50779 6 5.2 6H2.8C2.49222 6 2.42632 5.99652 2.38328 5.98619C2.20045 5.94229 2.05771 5.79955 2.01382 5.61672C2.00348 5.57369 2 5.50779 2 5.2V2.8C2 2.49222 2.00348 2.42632 2.01382 2.38328C2.05771 2.20045 2.20045 2.05771 2.38328 2.01382ZM9.8 1L9.74967 0.99997C9.52122 0.999752 9.32429 0.999564 9.14983 1.04145C8.60136 1.17312 8.17312 1.60136 8.04145 2.14983C7.99956 2.32429 7.99975 2.52122 7.99997 2.74967L8 2.8V5.2L7.99997 5.25033C7.99975 5.47878 7.99956 5.67572 8.04145 5.85017C8.17312 6.39864 8.60136 6.82688 9.14983 6.95856C9.32429 7.00044 9.52122 7.00025 9.74967 7.00003L9.8 7H12.2L12.2503 7.00003C12.4788 7.00025 12.6757 7.00044 12.8502 6.95856C13.3986 6.82688 13.8269 6.39864 13.9586 5.85017C14.0004 5.67572 14.0003 5.47878 14 5.25033L14 5.2V2.8L14 2.74967C14.0003 2.52122 14.0004 2.32429 13.9586 2.14983C13.8269 1.60136 13.3986 1.17312 12.8502 1.04145C12.6757 0.999564 12.4788 0.999752 12.2503 0.99997L12.2 1H9.8ZM9.38328 2.01382C9.42632 2.00348 9.49222 2 9.8 2H12.2C12.5078 2 12.5737 2.00348 12.6167 2.01382C12.7995 2.05771 12.9423 2.20045 12.9862 2.38328C12.9965 2.42632 13 2.49222 13 2.8V5.2C13 5.50779 12.9965 5.57369 12.9862 5.61672C12.9423 5.79955 12.7995 5.94229 12.6167 5.98619C12.5737 5.99652 12.5078 6 12.2 6H9.8C9.49222 6 9.42632 5.99652 9.38328 5.98619C9.20045 5.94229 9.05771 5.79955 9.01382 5.61672C9.00348 5.57369 9 5.50779 9 5.2V2.8C9 2.49222 9.00348 2.42632 9.01382 2.38328C9.05771 2.20045 9.20045 2.05771 9.38328 2.01382ZM2.74967 7.99997L2.8 8H5.2L5.25033 7.99997C5.47878 7.99975 5.67572 7.99956 5.85017 8.04145C6.39864 8.17312 6.82688 8.60136 6.95856 9.14983C7.00044 9.32429 7.00025 9.52122 7.00003 9.74967L7 9.8V12.2L7.00003 12.2503C7.00025 12.4788 7.00044 12.6757 6.95856 12.8502C6.82688 13.3986 6.39864 13.8269 5.85017 13.9586C5.67572 14.0004 5.47878 14.0003 5.25033 14L5.2 14H2.8L2.74967 14C2.52122 14.0003 2.32429 14.0004 2.14983 13.9586C1.60136 13.8269 1.17312 13.3986 1.04145 12.8502C0.999564 12.6757 0.999752 12.4788 0.99997 12.2503L1 12.2V9.8L0.99997 9.74967C0.999752 9.52122 0.999564 9.32429 1.04145 9.14983C1.17312 8.60136 1.60136 8.17312 2.14983 8.04145C2.32429 7.99956 2.52122 7.99975 2.74967 7.99997ZM2.8 9C2.49222 9 2.42632 9.00348 2.38328 9.01382C2.20045 9.05771 2.05771 9.20045 2.01382 9.38328C2.00348 9.42632 2 9.49222 2 9.8V12.2C2 12.5078 2.00348 12.5737 2.01382 12.6167C2.05771 12.7995 2.20045 12.9423 2.38328 12.9862C2.42632 12.9965 2.49222 13 2.8 13H5.2C5.50779 13 5.57369 12.9965 5.61672 12.9862C5.79955 12.9423 5.94229 12.7995 5.98619 12.6167C5.99652 12.5737 6 12.5078 6 12.2V9.8C6 9.49222 5.99652 9.42632 5.98619 9.38328C5.94229 9.20045 5.79955 9.05771 5.61672 9.01382C5.57369 9.00348 5.50779 9 5.2 9H2.8ZM9.8 8L9.74967 7.99997C9.52122 7.99975 9.32429 7.99956 9.14983 8.04145C8.60136 8.17312 8.17312 8.60136 8.04145 9.14983C7.99956 9.32429 7.99975 9.52122 7.99997 9.74967L8 9.8V12.2L7.99997 12.2503C7.99975 12.4788 7.99956 12.6757 8.04145 12.8502C8.17312 13.3986 8.60136 13.8269 9.14983 13.9586C9.32429 14.0004 9.52122 14.0003 9.74967 14L9.8 14H12.2L12.2503 14C12.4788 14.0003 12.6757 14.0004 12.8502 13.9586C13.3986 13.8269 13.8269 13.3986 13.9586 12.8502C14.0004 12.6757 14.0003 12.4788 14 12.2503L14 12.2V9.8L14 9.74967C14.0003 9.52122 14.0004 9.32429 13.9586 9.14983C13.8269 8.60136 13.3986 8.17312 12.8502 8.04145C12.6757 7.99956 12.4788 7.99975 12.2503 7.99997L12.2 8H9.8ZM9.38328 9.01382C9.42632 9.00348 9.49222 9 9.8 9H12.2C12.5078 9 12.5737 9.00348 12.6167 9.01382C12.7995 9.05771 12.9423 9.20045 12.9862 9.38328C12.9965 9.42632 13 9.49222 13 9.8V12.2C13 12.5078 12.9965 12.5737 12.9862 12.6167C12.9423 12.7995 12.7995 12.9423 12.6167 12.9862C12.5737 12.9965 12.5078 13 12.2 13H9.8C9.49222 13 9.42632 12.9965 9.38328 12.9862C9.20045 12.9423 9.05771 12.7995 9.01382 12.6167C9.00348 12.5737 9 12.5078 9 12.2V9.8C9 9.49222 9.00348 9.42632 9.01382 9.38328C9.05771 9.20045 9.20045 9.05771 9.38328 9.01382Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1B = [
    "color"
];
var $e781b76dcad7c5d5$export$78a6319cfd8cd037 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1B);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M1 3.25C1 3.11193 1.11193 3 1.25 3H13.75C13.8881 3 14 3.11193 14 3.25V10.75C14 10.8881 13.8881 11 13.75 11H1.25C1.11193 11 1 10.8881 1 10.75V3.25ZM1.25 2C0.559643 2 0 2.55964 0 3.25V10.75C0 11.4404 0.559644 12 1.25 12H5.07341L4.82991 13.2986C4.76645 13.6371 5.02612 13.95 5.37049 13.95H9.62951C9.97389 13.95 10.2336 13.6371 10.1701 13.2986L9.92659 12H13.75C14.4404 12 15 11.4404 15 10.75V3.25C15 2.55964 14.4404 2 13.75 2H1.25ZM9.01091 12H5.98909L5.79222 13.05H9.20778L9.01091 12Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1C = [
    "color"
];
var $e781b76dcad7c5d5$export$63405b713b830f28 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1C);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M3.00014 2.73895C3.00014 2.94698 2.76087 3.06401 2.59666 2.93628L1.00386 1.69744C0.875177 1.59735 0.875177 1.40286 1.00386 1.30277L2.59666 0.063928C2.76087 -0.0637944 3.00014 0.0532293 3.00014 0.261266V1.00012H9.00009V0.261296C9.00009 0.0532591 9.23936 -0.0637646 9.40358 0.0639578L10.9964 1.3028C11.1251 1.40289 11.1251 1.59738 10.9964 1.69747L9.40358 2.93631C9.23936 3.06404 9.00009 2.94701 9.00009 2.73898V2.00012H3.00014V2.73895ZM9.50002 4.99998H2.50002C2.22388 4.99998 2.00002 5.22384 2.00002 5.49998V12.5C2.00002 12.7761 2.22388 13 2.50002 13H9.50002C9.77616 13 10 12.7761 10 12.5V5.49998C10 5.22384 9.77616 4.99998 9.50002 4.99998ZM2.50002 3.99998C1.67159 3.99998 1.00002 4.67156 1.00002 5.49998V12.5C1.00002 13.3284 1.67159 14 2.50002 14H9.50002C10.3284 14 11 13.3284 11 12.5V5.49998C11 4.67156 10.3284 3.99998 9.50002 3.99998H2.50002ZM14.7389 6.00001H14V12H14.7389C14.9469 12 15.064 12.2393 14.9362 12.4035L13.6974 13.9963C13.5973 14.125 13.4028 14.125 13.3027 13.9963L12.0639 12.4035C11.9362 12.2393 12.0532 12 12.2612 12H13V6.00001H12.2612C12.0532 6.00001 11.9361 5.76074 12.0639 5.59653L13.3027 4.00373C13.4028 3.87505 13.5973 3.87505 13.6974 4.00374L14.9362 5.59653C15.0639 5.76074 14.9469 6.00001 14.7389 6.00001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1D = [
    "color"
];
var $e781b76dcad7c5d5$export$e9e14b59da099a2a = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1D);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.49991 0.877075C3.84222 0.877075 0.877075 3.84222 0.877075 7.49991C0.877075 11.1576 3.84222 14.1227 7.49991 14.1227C11.1576 14.1227 14.1227 11.1576 14.1227 7.49991C14.1227 3.84222 11.1576 0.877075 7.49991 0.877075ZM1.82708 7.49991C1.82708 4.36689 4.36689 1.82707 7.49991 1.82707C10.6329 1.82707 13.1727 4.36689 13.1727 7.49991C13.1727 10.6329 10.6329 13.1727 7.49991 13.1727C4.36689 13.1727 1.82708 10.6329 1.82708 7.49991ZM8.37287 7.50006C8.37287 7.98196 7.98221 8.37263 7.5003 8.37263C7.01839 8.37263 6.62773 7.98196 6.62773 7.50006C6.62773 7.01815 7.01839 6.62748 7.5003 6.62748C7.98221 6.62748 8.37287 7.01815 8.37287 7.50006ZM9.32287 7.50006C9.32287 8.50664 8.50688 9.32263 7.5003 9.32263C6.49372 9.32263 5.67773 8.50664 5.67773 7.50006C5.67773 6.49348 6.49372 5.67748 7.5003 5.67748C8.50688 5.67748 9.32287 6.49348 9.32287 7.50006Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1E = [
    "color"
];
var $e781b76dcad7c5d5$export$bf776c57f6d5a7c1 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1E);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.07451 1.82584C5.03267 1.81926 4.99014 1.81825 4.94803 1.82284C4.10683 1.91446 2.82673 2.36828 2.07115 2.77808C2.02106 2.80525 1.97621 2.84112 1.93869 2.88402C1.62502 3.24266 1.34046 3.82836 1.11706 4.38186C0.887447 4.95076 0.697293 5.55032 0.588937 5.98354C0.236232 7.39369 0.042502 9.08728 0.0174948 10.6925C0.0162429 10.7729 0.0351883 10.8523 0.0725931 10.9234C0.373679 11.496 1.02015 12.027 1.66809 12.4152C2.32332 12.8078 3.08732 13.1182 3.70385 13.1778C3.85335 13.1922 4.00098 13.1358 4.10282 13.0255C4.2572 12.8581 4.5193 12.4676 4.71745 12.1643C4.80739 12.0267 4.89157 11.8953 4.95845 11.7901C5.62023 11.9106 6.45043 11.9801 7.50002 11.9801C8.54844 11.9801 9.37796 11.9107 10.0394 11.7905C10.1062 11.8957 10.1903 12.0269 10.2801 12.1643C10.4783 12.4676 10.7404 12.8581 10.8947 13.0255C10.9966 13.1358 11.1442 13.1922 11.2937 13.1778C11.9102 13.1182 12.6742 12.8078 13.3295 12.4152C13.9774 12.027 14.6239 11.496 14.925 10.9234C14.9624 10.8523 14.9813 10.7729 14.9801 10.6925C14.9551 9.08728 14.7613 7.39369 14.4086 5.98354C14.3003 5.55032 14.1101 4.95076 13.8805 4.38186C13.6571 3.82836 13.3725 3.24266 13.0589 2.88402C13.0214 2.84112 12.9765 2.80525 12.9264 2.77808C12.1708 2.36828 10.8907 1.91446 10.0495 1.82284C10.0074 1.81825 9.96489 1.81926 9.92305 1.82584C9.71676 1.85825 9.5391 1.96458 9.40809 2.06355C9.26977 2.16804 9.1413 2.29668 9.0304 2.42682C8.86968 2.61544 8.71437 2.84488 8.61428 3.06225C8.27237 3.03501 7.90138 3.02 7.5 3.02C7.0977 3.02 6.72593 3.03508 6.38337 3.06244C6.28328 2.84501 6.12792 2.61549 5.96716 2.42682C5.85626 2.29668 5.72778 2.16804 5.58947 2.06355C5.45846 1.96458 5.2808 1.85825 5.07451 1.82584ZM11.0181 11.5382C11.0395 11.5713 11.0615 11.6051 11.0838 11.6392C11.2169 11.843 11.3487 12.0385 11.4508 12.1809C11.8475 12.0916 12.352 11.8818 12.8361 11.5917C13.3795 11.2661 13.8098 10.8918 14.0177 10.5739C13.9852 9.06758 13.7993 7.50369 13.4773 6.21648C13.38 5.82759 13.2038 5.27021 12.9903 4.74117C12.7893 4.24326 12.5753 3.82162 12.388 3.5792C11.7376 3.24219 10.7129 2.88582 10.0454 2.78987C10.0308 2.79839 10.0113 2.81102 9.98675 2.82955C9.91863 2.881 9.84018 2.95666 9.76111 3.04945C9.71959 3.09817 9.68166 3.1471 9.64768 3.19449C9.953 3.25031 10.2253 3.3171 10.4662 3.39123C11.1499 3.6016 11.6428 3.89039 11.884 4.212C12.0431 4.42408 12.0001 4.72494 11.788 4.884C11.5759 5.04306 11.2751 5.00008 11.116 4.788C11.0572 4.70961 10.8001 4.4984 10.1838 4.30877C9.58933 4.12585 8.71356 3.98 7.5 3.98C6.28644 3.98 5.41067 4.12585 4.81616 4.30877C4.19988 4.4984 3.94279 4.70961 3.884 4.788C3.72494 5.00008 3.42408 5.04306 3.212 4.884C2.99992 4.72494 2.95694 4.42408 3.116 4.212C3.35721 3.89039 3.85011 3.6016 4.53383 3.39123C4.77418 3.31727 5.04571 3.25062 5.35016 3.19488C5.31611 3.14738 5.27808 3.09831 5.23645 3.04945C5.15738 2.95666 5.07893 2.881 5.01081 2.82955C4.98628 2.81102 4.96674 2.79839 4.95217 2.78987C4.28464 2.88582 3.25999 3.24219 2.60954 3.5792C2.42226 3.82162 2.20825 4.24326 2.00729 4.74117C1.79376 5.27021 1.61752 5.82759 1.52025 6.21648C1.19829 7.50369 1.01236 9.06758 0.97986 10.5739C1.18772 10.8918 1.61807 11.2661 2.16148 11.5917C2.64557 11.8818 3.15003 12.0916 3.5468 12.1809C3.64885 12.0385 3.78065 11.843 3.9138 11.6392C3.93626 11.6048 3.95838 11.5708 3.97996 11.5375C3.19521 11.2591 2.77361 10.8758 2.50064 10.4664C2.35359 10.2458 2.4132 9.94778 2.63377 9.80074C2.85435 9.65369 3.15236 9.71329 3.29941 9.93387C3.56077 10.3259 4.24355 11.0201 7.50002 11.0201C10.7565 11.0201 11.4392 10.326 11.7006 9.93386C11.8477 9.71329 12.1457 9.65369 12.3663 9.80074C12.5869 9.94779 12.6465 10.2458 12.4994 10.4664C12.2262 10.8762 11.8041 11.2598 11.0181 11.5382ZM4.08049 7.01221C4.32412 6.74984 4.65476 6.60162 5.00007 6.59998C5.34538 6.60162 5.67603 6.74984 5.91966 7.01221C6.16329 7.27459 6.30007 7.62974 6.30007 7.99998C6.30007 8.37021 6.16329 8.72536 5.91966 8.98774C5.67603 9.25011 5.34538 9.39833 5.00007 9.39998C4.65476 9.39833 4.32412 9.25011 4.08049 8.98774C3.83685 8.72536 3.70007 8.37021 3.70007 7.99998C3.70007 7.62974 3.83685 7.27459 4.08049 7.01221ZM9.99885 6.59998C9.65354 6.60162 9.3229 6.74984 9.07926 7.01221C8.83563 7.27459 8.69885 7.62974 8.69885 7.99998C8.69885 8.37021 8.83563 8.72536 9.07926 8.98774C9.3229 9.25011 9.65354 9.39833 9.99885 9.39998C10.3442 9.39833 10.6748 9.25011 10.9184 8.98774C11.1621 8.72536 11.2989 8.37021 11.2989 7.99998C11.2989 7.62974 11.1621 7.27459 10.9184 7.01221C10.6748 6.74984 10.3442 6.60162 9.99885 6.59998Z",
        fill: color
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1F = [
    "color"
];
var $e781b76dcad7c5d5$export$67e4f137381994a7 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1F);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M2 7.5C2 7.22386 2.22386 7 2.5 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H2.5C2.22386 8 2 7.77614 2 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1G = [
    "color"
];
var $e781b76dcad7c5d5$export$4941448a902289ea = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1G);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.5 2C7.77614 2 8 2.22386 8 2.5L8 12.5C8 12.7761 7.77614 13 7.5 13C7.22386 13 7 12.7761 7 12.5L7 2.5C7 2.22386 7.22386 2 7.5 2Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1H = [
    "color"
];
var $e781b76dcad7c5d5$export$1638d451d4588271 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1H);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.5 9.125C8.39746 9.125 9.125 8.39746 9.125 7.5C9.125 6.60254 8.39746 5.875 7.5 5.875C6.60254 5.875 5.875 6.60254 5.875 7.5C5.875 8.39746 6.60254 9.125 7.5 9.125ZM7.5 10.125C8.94975 10.125 10.125 8.94975 10.125 7.5C10.125 6.05025 8.94975 4.875 7.5 4.875C6.05025 4.875 4.875 6.05025 4.875 7.5C4.875 8.94975 6.05025 10.125 7.5 10.125Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1I = [
    "color"
];
var $e781b76dcad7c5d5$export$5ce415a59e297ace = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1I);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M9.875 7.5C9.875 8.81168 8.81168 9.875 7.5 9.875C6.18832 9.875 5.125 8.81168 5.125 7.5C5.125 6.18832 6.18832 5.125 7.5 5.125C8.81168 5.125 9.875 6.18832 9.875 7.5Z",
        fill: color
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1J = [
    "color"
];
var $e781b76dcad7c5d5$export$9789fa787c2a8e33 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1J);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M3.625 7.5C3.625 8.12132 3.12132 8.625 2.5 8.625C1.87868 8.625 1.375 8.12132 1.375 7.5C1.375 6.87868 1.87868 6.375 2.5 6.375C3.12132 6.375 3.625 6.87868 3.625 7.5ZM8.625 7.5C8.625 8.12132 8.12132 8.625 7.5 8.625C6.87868 8.625 6.375 8.12132 6.375 7.5C6.375 6.87868 6.87868 6.375 7.5 6.375C8.12132 6.375 8.625 6.87868 8.625 7.5ZM12.5 8.625C13.1213 8.625 13.625 8.12132 13.625 7.5C13.625 6.87868 13.1213 6.375 12.5 6.375C11.8787 6.375 11.375 6.87868 11.375 7.5C11.375 8.12132 11.8787 8.625 12.5 8.625Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1K = [
    "color"
];
var $e781b76dcad7c5d5$export$f50786ff8e0cdf62 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1K);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M8.625 2.5C8.625 3.12132 8.12132 3.625 7.5 3.625C6.87868 3.625 6.375 3.12132 6.375 2.5C6.375 1.87868 6.87868 1.375 7.5 1.375C8.12132 1.375 8.625 1.87868 8.625 2.5ZM8.625 7.5C8.625 8.12132 8.12132 8.625 7.5 8.625C6.87868 8.625 6.375 8.12132 6.375 7.5C6.375 6.87868 6.87868 6.375 7.5 6.375C8.12132 6.375 8.625 6.87868 8.625 7.5ZM7.5 13.625C8.12132 13.625 8.625 13.1213 8.625 12.5C8.625 11.8787 8.12132 11.375 7.5 11.375C6.87868 11.375 6.375 11.8787 6.375 12.5C6.375 13.1213 6.87868 13.625 7.5 13.625Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1L = [
    "color"
];
var $e781b76dcad7c5d5$export$de42cbda950c1561 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1L);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M3.85355 2.14645C3.65829 1.95118 3.34171 1.95118 3.14645 2.14645C2.95118 2.34171 2.95118 2.65829 3.14645 2.85355L7.14645 6.85355C7.34171 7.04882 7.65829 7.04882 7.85355 6.85355L11.8536 2.85355C12.0488 2.65829 12.0488 2.34171 11.8536 2.14645C11.6583 1.95118 11.3417 1.95118 11.1464 2.14645L7.5 5.79289L3.85355 2.14645ZM3.85355 8.14645C3.65829 7.95118 3.34171 7.95118 3.14645 8.14645C2.95118 8.34171 2.95118 8.65829 3.14645 8.85355L7.14645 12.8536C7.34171 13.0488 7.65829 13.0488 7.85355 12.8536L11.8536 8.85355C12.0488 8.65829 12.0488 8.34171 11.8536 8.14645C11.6583 7.95118 11.3417 7.95118 11.1464 8.14645L7.5 11.7929L3.85355 8.14645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1M = [
    "color"
];
var $e781b76dcad7c5d5$export$8f14af9007650906 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1M);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M6.85355 3.85355C7.04882 3.65829 7.04882 3.34171 6.85355 3.14645C6.65829 2.95118 6.34171 2.95118 6.14645 3.14645L2.14645 7.14645C1.95118 7.34171 1.95118 7.65829 2.14645 7.85355L6.14645 11.8536C6.34171 12.0488 6.65829 12.0488 6.85355 11.8536C7.04882 11.6583 7.04882 11.3417 6.85355 11.1464L3.20711 7.5L6.85355 3.85355ZM12.8536 3.85355C13.0488 3.65829 13.0488 3.34171 12.8536 3.14645C12.6583 2.95118 12.3417 2.95118 12.1464 3.14645L8.14645 7.14645C7.95118 7.34171 7.95118 7.65829 8.14645 7.85355L12.1464 11.8536C12.3417 12.0488 12.6583 12.0488 12.8536 11.8536C13.0488 11.6583 13.0488 11.3417 12.8536 11.1464L9.20711 7.5L12.8536 3.85355Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1N = [
    "color"
];
var $e781b76dcad7c5d5$export$90b329a415b2a5d4 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1N);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M2.14645 11.1464C1.95118 11.3417 1.95118 11.6583 2.14645 11.8536C2.34171 12.0488 2.65829 12.0488 2.85355 11.8536L6.85355 7.85355C7.04882 7.65829 7.04882 7.34171 6.85355 7.14645L2.85355 3.14645C2.65829 2.95118 2.34171 2.95118 2.14645 3.14645C1.95118 3.34171 1.95118 3.65829 2.14645 3.85355L5.79289 7.5L2.14645 11.1464ZM8.14645 11.1464C7.95118 11.3417 7.95118 11.6583 8.14645 11.8536C8.34171 12.0488 8.65829 12.0488 8.85355 11.8536L12.8536 7.85355C13.0488 7.65829 13.0488 7.34171 12.8536 7.14645L8.85355 3.14645C8.65829 2.95118 8.34171 2.95118 8.14645 3.14645C7.95118 3.34171 7.95118 3.65829 8.14645 3.85355L11.7929 7.5L8.14645 11.1464Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1O = [
    "color"
];
var $e781b76dcad7c5d5$export$4625b0d11d3861cc = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1O);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M11.1464 6.85355C11.3417 7.04882 11.6583 7.04882 11.8536 6.85355C12.0488 6.65829 12.0488 6.34171 11.8536 6.14645L7.85355 2.14645C7.65829 1.95118 7.34171 1.95118 7.14645 2.14645L3.14645 6.14645C2.95118 6.34171 2.95118 6.65829 3.14645 6.85355C3.34171 7.04882 3.65829 7.04882 3.85355 6.85355L7.5 3.20711L11.1464 6.85355ZM11.1464 12.8536C11.3417 13.0488 11.6583 13.0488 11.8536 12.8536C12.0488 12.6583 12.0488 12.3417 11.8536 12.1464L7.85355 8.14645C7.65829 7.95118 7.34171 7.95118 7.14645 8.14645L3.14645 12.1464C2.95118 12.3417 2.95118 12.6583 3.14645 12.8536C3.34171 13.0488 3.65829 13.0488 3.85355 12.8536L7.5 9.20711L11.1464 12.8536Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1P = [
    "color"
];
var $e781b76dcad7c5d5$export$4e54df4252b4a99c = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1P);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.50005 1.04999C7.74858 1.04999 7.95005 1.25146 7.95005 1.49999V8.41359L10.1819 6.18179C10.3576 6.00605 10.6425 6.00605 10.8182 6.18179C10.994 6.35753 10.994 6.64245 10.8182 6.81819L7.81825 9.81819C7.64251 9.99392 7.35759 9.99392 7.18185 9.81819L4.18185 6.81819C4.00611 6.64245 4.00611 6.35753 4.18185 6.18179C4.35759 6.00605 4.64251 6.00605 4.81825 6.18179L7.05005 8.41359V1.49999C7.05005 1.25146 7.25152 1.04999 7.50005 1.04999ZM2.5 10C2.77614 10 3 10.2239 3 10.5V12C3 12.5539 3.44565 13 3.99635 13H11.0012C11.5529 13 12 12.5528 12 12V10.5C12 10.2239 12.2239 10 12.5 10C12.7761 10 13 10.2239 13 10.5V12C13 13.1041 12.1062 14 11.0012 14H3.99635C2.89019 14 2 13.103 2 12V10.5C2 10.2239 2.22386 10 2.5 10Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1Q = [
    "color"
];
var $e781b76dcad7c5d5$export$209fdd70701c1b6e = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1Q);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("circle", {
        cx: "4.5",
        cy: "2.5",
        r: ".6",
        fill: color
    }), (0, $jbmdS.createElement)("circle", {
        cx: "4.5",
        cy: "4.5",
        r: ".6",
        fill: color
    }), (0, $jbmdS.createElement)("circle", {
        cx: "4.5",
        cy: "6.499",
        r: ".6",
        fill: color
    }), (0, $jbmdS.createElement)("circle", {
        cx: "4.5",
        cy: "8.499",
        r: ".6",
        fill: color
    }), (0, $jbmdS.createElement)("circle", {
        cx: "4.5",
        cy: "10.498",
        r: ".6",
        fill: color
    }), (0, $jbmdS.createElement)("circle", {
        cx: "4.5",
        cy: "12.498",
        r: ".6",
        fill: color
    }), (0, $jbmdS.createElement)("circle", {
        cx: "6.5",
        cy: "2.5",
        r: ".6",
        fill: color
    }), (0, $jbmdS.createElement)("circle", {
        cx: "6.5",
        cy: "4.5",
        r: ".6",
        fill: color
    }), (0, $jbmdS.createElement)("circle", {
        cx: "6.5",
        cy: "6.499",
        r: ".6",
        fill: color
    }), (0, $jbmdS.createElement)("circle", {
        cx: "6.5",
        cy: "8.499",
        r: ".6",
        fill: color
    }), (0, $jbmdS.createElement)("circle", {
        cx: "6.5",
        cy: "10.498",
        r: ".6",
        fill: color
    }), (0, $jbmdS.createElement)("circle", {
        cx: "6.5",
        cy: "12.498",
        r: ".6",
        fill: color
    }), (0, $jbmdS.createElement)("circle", {
        cx: "8.499",
        cy: "2.5",
        r: ".6",
        fill: color
    }), (0, $jbmdS.createElement)("circle", {
        cx: "8.499",
        cy: "4.5",
        r: ".6",
        fill: color
    }), (0, $jbmdS.createElement)("circle", {
        cx: "8.499",
        cy: "6.499",
        r: ".6",
        fill: color
    }), (0, $jbmdS.createElement)("circle", {
        cx: "8.499",
        cy: "8.499",
        r: ".6",
        fill: color
    }), (0, $jbmdS.createElement)("circle", {
        cx: "8.499",
        cy: "10.498",
        r: ".6",
        fill: color
    }), (0, $jbmdS.createElement)("circle", {
        cx: "8.499",
        cy: "12.498",
        r: ".6",
        fill: color
    }), (0, $jbmdS.createElement)("circle", {
        cx: "10.499",
        cy: "2.5",
        r: ".6",
        fill: color
    }), (0, $jbmdS.createElement)("circle", {
        cx: "10.499",
        cy: "4.5",
        r: ".6",
        fill: color
    }), (0, $jbmdS.createElement)("circle", {
        cx: "10.499",
        cy: "6.499",
        r: ".6",
        fill: color
    }), (0, $jbmdS.createElement)("circle", {
        cx: "10.499",
        cy: "8.499",
        r: ".6",
        fill: color
    }), (0, $jbmdS.createElement)("circle", {
        cx: "10.499",
        cy: "10.498",
        r: ".6",
        fill: color
    }), (0, $jbmdS.createElement)("circle", {
        cx: "10.499",
        cy: "12.498",
        r: ".6",
        fill: color
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1R = [
    "color"
];
var $e781b76dcad7c5d5$export$829e9de7006febc4 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1R);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M5.5 4.625C6.12132 4.625 6.625 4.12132 6.625 3.5C6.625 2.87868 6.12132 2.375 5.5 2.375C4.87868 2.375 4.375 2.87868 4.375 3.5C4.375 4.12132 4.87868 4.625 5.5 4.625ZM9.5 4.625C10.1213 4.625 10.625 4.12132 10.625 3.5C10.625 2.87868 10.1213 2.375 9.5 2.375C8.87868 2.375 8.375 2.87868 8.375 3.5C8.375 4.12132 8.87868 4.625 9.5 4.625ZM10.625 7.5C10.625 8.12132 10.1213 8.625 9.5 8.625C8.87868 8.625 8.375 8.12132 8.375 7.5C8.375 6.87868 8.87868 6.375 9.5 6.375C10.1213 6.375 10.625 6.87868 10.625 7.5ZM5.5 8.625C6.12132 8.625 6.625 8.12132 6.625 7.5C6.625 6.87868 6.12132 6.375 5.5 6.375C4.87868 6.375 4.375 6.87868 4.375 7.5C4.375 8.12132 4.87868 8.625 5.5 8.625ZM10.625 11.5C10.625 12.1213 10.1213 12.625 9.5 12.625C8.87868 12.625 8.375 12.1213 8.375 11.5C8.375 10.8787 8.87868 10.375 9.5 10.375C10.1213 10.375 10.625 10.8787 10.625 11.5ZM5.5 12.625C6.12132 12.625 6.625 12.1213 6.625 11.5C6.625 10.8787 6.12132 10.375 5.5 10.375C4.87868 10.375 4.375 10.8787 4.375 11.5C4.375 12.1213 4.87868 12.625 5.5 12.625Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1S = [
    "color"
];
var $e781b76dcad7c5d5$export$e6848a231b25a576 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1S);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M2.49998 4.09998C2.27906 4.09998 2.09998 4.27906 2.09998 4.49998C2.09998 4.72089 2.27906 4.89998 2.49998 4.89998H12.5C12.7209 4.89998 12.9 4.72089 12.9 4.49998C12.9 4.27906 12.7209 4.09998 12.5 4.09998H2.49998ZM2.49998 6.09998C2.27906 6.09998 2.09998 6.27906 2.09998 6.49998C2.09998 6.72089 2.27906 6.89998 2.49998 6.89998H12.5C12.7209 6.89998 12.9 6.72089 12.9 6.49998C12.9 6.27906 12.7209 6.09998 12.5 6.09998H2.49998ZM2.09998 8.49998C2.09998 8.27906 2.27906 8.09998 2.49998 8.09998H12.5C12.7209 8.09998 12.9 8.27906 12.9 8.49998C12.9 8.72089 12.7209 8.89998 12.5 8.89998H2.49998C2.27906 8.89998 2.09998 8.72089 2.09998 8.49998ZM2.49998 10.1C2.27906 10.1 2.09998 10.2791 2.09998 10.5C2.09998 10.7209 2.27906 10.9 2.49998 10.9H12.5C12.7209 10.9 12.9 10.7209 12.9 10.5C12.9 10.2791 12.7209 10.1 12.5 10.1H2.49998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1T = [
    "color"
];
var $e781b76dcad7c5d5$export$b72a86f6a31cd8d8 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1T);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M4.09998 12.5C4.09998 12.7209 4.27906 12.9 4.49998 12.9C4.72089 12.9 4.89998 12.7209 4.89998 12.5L4.89998 2.50002C4.89998 2.27911 4.72089 2.10003 4.49998 2.10003C4.27906 2.10003 4.09998 2.27911 4.09998 2.50002L4.09998 12.5ZM6.09998 12.5C6.09998 12.7209 6.27906 12.9 6.49998 12.9C6.72089 12.9 6.89998 12.7209 6.89998 12.5L6.89998 2.50002C6.89998 2.27911 6.72089 2.10003 6.49998 2.10003C6.27906 2.10003 6.09998 2.27911 6.09998 2.50002L6.09998 12.5ZM8.49998 12.9C8.27906 12.9 8.09998 12.7209 8.09998 12.5L8.09998 2.50002C8.09998 2.27911 8.27906 2.10002 8.49998 2.10002C8.72089 2.10002 8.89998 2.27911 8.89998 2.50002L8.89998 12.5C8.89998 12.7209 8.72089 12.9 8.49998 12.9ZM10.1 12.5C10.1 12.7209 10.2791 12.9 10.5 12.9C10.7209 12.9 10.9 12.7209 10.9 12.5L10.9 2.50002C10.9 2.27911 10.7209 2.10002 10.5 2.10002C10.2791 2.10002 10.1 2.27911 10.1 2.50002L10.1 12.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1U = [
    "color"
];
var $e781b76dcad7c5d5$export$d678e82375a26dcf = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1U);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M10.3285 1.13607C10.1332 0.940809 9.81662 0.940808 9.62136 1.13607C9.42609 1.33133 9.42609 1.64792 9.62136 1.84318L10.2744 2.49619L5.42563 6.13274L4.31805 5.02516C4.12279 4.8299 3.80621 4.8299 3.61095 5.02516C3.41569 5.22042 3.41569 5.537 3.61095 5.73226L5.02516 7.14648L6.08582 8.20714L2.81545 11.4775C2.62019 11.6728 2.62019 11.9894 2.81545 12.1846C3.01072 12.3799 3.3273 12.3799 3.52256 12.1846L6.79293 8.91425L7.85359 9.97491L9.2678 11.3891C9.46306 11.5844 9.77965 11.5844 9.97491 11.3891C10.1702 11.1939 10.1702 10.8773 9.97491 10.682L8.86733 9.57443L12.5039 4.7257L13.1569 5.37871C13.3522 5.57397 13.6687 5.57397 13.864 5.37871C14.0593 5.18345 14.0593 4.86687 13.864 4.6716L12.8033 3.61094L11.3891 2.19673L10.3285 1.13607ZM6.13992 6.84702L10.9887 3.21047L11.7896 4.01142L8.15305 8.86015L6.13992 6.84702Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1V = [
    "color"
];
var $e781b76dcad7c5d5$export$c6212c739d4cf8da = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1V);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M9.62129 1.13607C9.81656 0.940808 10.1331 0.940809 10.3284 1.13607L11.3891 2.19673L12.8033 3.61094L13.8639 4.6716C14.0592 4.86687 14.0592 5.18345 13.8639 5.37871C13.6687 5.57397 13.3521 5.57397 13.1568 5.37871L12.5038 4.7257L8.86727 9.57443L9.97485 10.682C10.1701 10.8773 10.1701 11.1939 9.97485 11.3891C9.77959 11.5844 9.463 11.5844 9.26774 11.3891L7.85353 9.97491L6.79287 8.91425L3.5225 12.1846C3.32724 12.3799 3.01065 12.3799 2.81539 12.1846C2.62013 11.9894 2.62013 11.6728 2.81539 11.4775L6.08576 8.20714L5.0251 7.14648L3.61089 5.73226C3.41563 5.537 3.41562 5.22042 3.61089 5.02516C3.80615 4.8299 4.12273 4.8299 4.31799 5.02516L5.42557 6.13274L10.2743 2.49619L9.62129 1.84318C9.42603 1.64792 9.42603 1.33133 9.62129 1.13607Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        d: "M9.62129 1.13607C9.81656 0.940808 10.1331 0.940809 10.3284 1.13607L11.3891 2.19673L12.8033 3.61094L13.8639 4.6716C14.0592 4.86687 14.0592 5.18345 13.8639 5.37871C13.6687 5.57397 13.3521 5.57397 13.1568 5.37871L12.5038 4.7257L8.86727 9.57443L9.97485 10.682C10.1701 10.8773 10.1701 11.1939 9.97485 11.3891C9.77959 11.5844 9.463 11.5844 9.26774 11.3891L7.85353 9.97491L6.79287 8.91425L3.5225 12.1846C3.32724 12.3799 3.01065 12.3799 2.81539 12.1846C2.62013 11.9894 2.62013 11.6728 2.81539 11.4775L6.08576 8.20714L5.0251 7.14648L3.61089 5.73226C3.41563 5.537 3.41562 5.22042 3.61089 5.02516C3.80615 4.8299 4.12273 4.8299 4.31799 5.02516L5.42557 6.13274L10.2743 2.49619L9.62129 1.84318C9.42603 1.64792 9.42603 1.33133 9.62129 1.13607Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1W = [
    "color"
];
var $e781b76dcad7c5d5$export$e5daec7136b0534 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1W);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.49999 3.09998C7.27907 3.09998 7.09999 3.27906 7.09999 3.49998C7.09999 3.72089 7.27907 3.89998 7.49999 3.89998H14.5C14.7209 3.89998 14.9 3.72089 14.9 3.49998C14.9 3.27906 14.7209 3.09998 14.5 3.09998H7.49999ZM7.49998 5.1C7.27907 5.1 7.09998 5.27908 7.09998 5.5C7.09998 5.72091 7.27907 5.9 7.49998 5.9H14.5C14.7209 5.9 14.9 5.72091 14.9 5.5C14.9 5.27908 14.7209 5.1 14.5 5.1H7.49998ZM7.1 7.5C7.1 7.27908 7.27909 7.1 7.5 7.1H14.5C14.7209 7.1 14.9 7.27908 14.9 7.5C14.9 7.72091 14.7209 7.9 14.5 7.9H7.5C7.27909 7.9 7.1 7.72091 7.1 7.5ZM7.49998 9.1C7.27907 9.1 7.09998 9.27908 7.09998 9.5C7.09998 9.72091 7.27907 9.9 7.49998 9.9H14.5C14.7209 9.9 14.9 9.72091 14.9 9.5C14.9 9.27908 14.7209 9.1 14.5 9.1H7.49998ZM7.09998 11.5C7.09998 11.2791 7.27907 11.1 7.49998 11.1H14.5C14.7209 11.1 14.9 11.2791 14.9 11.5C14.9 11.7209 14.7209 11.9 14.5 11.9H7.49998C7.27907 11.9 7.09998 11.7209 7.09998 11.5ZM2.5 9.25003L5 6.00003H0L2.5 9.25003Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1X = [
    "color"
];
var $e781b76dcad7c5d5$export$296bea1be8b4086a = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1X);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M4.5 1C4.22386 1 4 1.22386 4 1.5C4 1.77614 4.22386 2 4.5 2H12V13H4.5C4.22386 13 4 13.2239 4 13.5C4 13.7761 4.22386 14 4.5 14H12C12.5523 14 13 13.5523 13 13V2C13 1.44772 12.5523 1 12 1H4.5ZM6.60355 4.89645C6.40829 4.70118 6.09171 4.70118 5.89645 4.89645C5.70118 5.09171 5.70118 5.40829 5.89645 5.60355L7.29289 7H0.5C0.223858 7 0 7.22386 0 7.5C0 7.77614 0.223858 8 0.5 8H7.29289L5.89645 9.39645C5.70118 9.59171 5.70118 9.90829 5.89645 10.1036C6.09171 10.2988 6.40829 10.2988 6.60355 10.1036L8.85355 7.85355C9.04882 7.65829 9.04882 7.34171 8.85355 7.14645L6.60355 4.89645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1Y = [
    "color"
];
var $e781b76dcad7c5d5$export$5886b995403a6540 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1Y);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M2 2.5C2 2.22386 2.22386 2 2.5 2H5.5C5.77614 2 6 2.22386 6 2.5C6 2.77614 5.77614 3 5.5 3H3V5.5C3 5.77614 2.77614 6 2.5 6C2.22386 6 2 5.77614 2 5.5V2.5ZM9 2.5C9 2.22386 9.22386 2 9.5 2H12.5C12.7761 2 13 2.22386 13 2.5V5.5C13 5.77614 12.7761 6 12.5 6C12.2239 6 12 5.77614 12 5.5V3H9.5C9.22386 3 9 2.77614 9 2.5ZM2.5 9C2.77614 9 3 9.22386 3 9.5V12H5.5C5.77614 12 6 12.2239 6 12.5C6 12.7761 5.77614 13 5.5 13H2.5C2.22386 13 2 12.7761 2 12.5V9.5C2 9.22386 2.22386 9 2.5 9ZM12.5 9C12.7761 9 13 9.22386 13 9.5V12.5C13 12.7761 12.7761 13 12.5 13H9.5C9.22386 13 9 12.7761 9 12.5C9 12.2239 9.22386 12 9.5 12H12V9.5C12 9.22386 12.2239 9 12.5 9Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1Z = [
    "color"
];
var $e781b76dcad7c5d5$export$c81ccc0bdd70284 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1Z);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M1 2C0.447715 2 0 2.44772 0 3V12C0 12.5523 0.447715 13 1 13H14C14.5523 13 15 12.5523 15 12V3C15 2.44772 14.5523 2 14 2H1ZM1 3L14 3V3.92494C13.9174 3.92486 13.8338 3.94751 13.7589 3.99505L7.5 7.96703L1.24112 3.99505C1.16621 3.94751 1.0826 3.92486 1 3.92494V3ZM1 4.90797V12H14V4.90797L7.74112 8.87995C7.59394 8.97335 7.40606 8.97335 7.25888 8.87995L1 4.90797Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1_ = [
    "color"
];
var $e781b76dcad7c5d5$export$808857d2db6c57a2 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1_);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.94721 0.164594C7.66569 0.0238299 7.33431 0.0238302 7.05279 0.164594L0.552786 3.41459C0.214002 3.58399 0 3.93025 0 4.30902V12C0 12.5523 0.447715 13 1 13H14C14.5523 13 15 12.5523 15 12V4.30902C15 3.93025 14.786 3.58399 14.4472 3.41459L7.94721 0.164594ZM13.5689 4.09349L7.5 1.05902L1.43105 4.09349L7.5 7.29136L13.5689 4.09349ZM1 4.88366V12H14V4.88366L7.70977 8.19813C7.57848 8.26731 7.42152 8.26731 7.29023 8.19813L1 4.88366Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$1$ = [
    "color"
];
var $e781b76dcad7c5d5$export$b6c544816d254f36 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$1$);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M8.36052 0.72921C8.55578 0.533948 8.87236 0.533948 9.06763 0.72921L14.2708 5.93235C14.466 6.12761 14.466 6.4442 14.2708 6.63946L8.95513 11.9551L7.3466 13.5636C6.76081 14.1494 5.81106 14.1494 5.22528 13.5636L1.43635 9.7747C0.850563 9.18891 0.850563 8.23917 1.43635 7.65338L3.04488 6.04485L8.36052 0.72921ZM8.71407 1.78987L4.10554 6.3984L8.60157 10.8944L13.2101 6.28591L8.71407 1.78987ZM7.89447 11.6015L3.39843 7.10551L2.14346 8.36049C1.94819 8.55575 1.94819 8.87233 2.14346 9.06759L5.93238 12.8565C6.12765 13.0518 6.44423 13.0518 6.63949 12.8565L7.89447 11.6015Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$20 = [
    "color"
];
var $e781b76dcad7c5d5$export$b409b230b61d4724 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$20);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M8.4449 0.608765C8.0183 -0.107015 6.9817 -0.107015 6.55509 0.608766L0.161178 11.3368C-0.275824 12.07 0.252503 13 1.10608 13H13.8939C14.7475 13 15.2758 12.07 14.8388 11.3368L8.4449 0.608765ZM7.4141 1.12073C7.45288 1.05566 7.54712 1.05566 7.5859 1.12073L13.9798 11.8488C14.0196 11.9154 13.9715 12 13.8939 12H1.10608C1.02849 12 0.980454 11.9154 1.02018 11.8488L7.4141 1.12073ZM6.8269 4.48611C6.81221 4.10423 7.11783 3.78663 7.5 3.78663C7.88217 3.78663 8.18778 4.10423 8.1731 4.48612L8.01921 8.48701C8.00848 8.766 7.7792 8.98664 7.5 8.98664C7.2208 8.98664 6.99151 8.766 6.98078 8.48701L6.8269 4.48611ZM8.24989 10.476C8.24989 10.8902 7.9141 11.226 7.49989 11.226C7.08567 11.226 6.74989 10.8902 6.74989 10.476C6.74989 10.0618 7.08567 9.72599 7.49989 9.72599C7.9141 9.72599 8.24989 10.0618 8.24989 10.476Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$21 = [
    "color"
];
var $e781b76dcad7c5d5$export$72b807c0098a555f = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$21);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M3 1C2.44771 1 2 1.44772 2 2V13C2 13.5523 2.44772 14 3 14H10.5C10.7761 14 11 13.7761 11 13.5C11 13.2239 10.7761 13 10.5 13H3V2L10.5 2C10.7761 2 11 1.77614 11 1.5C11 1.22386 10.7761 1 10.5 1H3ZM12.6036 4.89645C12.4083 4.70118 12.0917 4.70118 11.8964 4.89645C11.7012 5.09171 11.7012 5.40829 11.8964 5.60355L13.2929 7H6.5C6.22386 7 6 7.22386 6 7.5C6 7.77614 6.22386 8 6.5 8H13.2929L11.8964 9.39645C11.7012 9.59171 11.7012 9.90829 11.8964 10.1036C12.0917 10.2988 12.4083 10.2988 12.6036 10.1036L14.8536 7.85355C15.0488 7.65829 15.0488 7.34171 14.8536 7.14645L12.6036 4.89645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$22 = [
    "color"
];
var $e781b76dcad7c5d5$export$7e82c66e763fb043 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$22);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M5.5 2C5.77614 2 6 2.22386 6 2.5V5.5C6 5.77614 5.77614 6 5.5 6H2.5C2.22386 6 2 5.77614 2 5.5C2 5.22386 2.22386 5 2.5 5H5V2.5C5 2.22386 5.22386 2 5.5 2ZM9.5 2C9.77614 2 10 2.22386 10 2.5V5H12.5C12.7761 5 13 5.22386 13 5.5C13 5.77614 12.7761 6 12.5 6H9.5C9.22386 6 9 5.77614 9 5.5V2.5C9 2.22386 9.22386 2 9.5 2ZM2 9.5C2 9.22386 2.22386 9 2.5 9H5.5C5.77614 9 6 9.22386 6 9.5V12.5C6 12.7761 5.77614 13 5.5 13C5.22386 13 5 12.7761 5 12.5V10H2.5C2.22386 10 2 9.77614 2 9.5ZM9 9.5C9 9.22386 9.22386 9 9.5 9H12.5C12.7761 9 13 9.22386 13 9.5C13 9.77614 12.7761 10 12.5 10H10V12.5C10 12.7761 9.77614 13 9.5 13C9.22386 13 9 12.7761 9 12.5V9.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$23 = [
    "color"
];
var $e781b76dcad7c5d5$export$9bd11592bfa362e7 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$23);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M3 2C2.44772 2 2 2.44772 2 3V12C2 12.5523 2.44772 13 3 13H12C12.5523 13 13 12.5523 13 12V8.5C13 8.22386 12.7761 8 12.5 8C12.2239 8 12 8.22386 12 8.5V12H3V3L6.5 3C6.77614 3 7 2.77614 7 2.5C7 2.22386 6.77614 2 6.5 2H3ZM12.8536 2.14645C12.9015 2.19439 12.9377 2.24964 12.9621 2.30861C12.9861 2.36669 12.9996 2.4303 13 2.497L13 2.5V2.50049V5.5C13 5.77614 12.7761 6 12.5 6C12.2239 6 12 5.77614 12 5.5V3.70711L6.85355 8.85355C6.65829 9.04882 6.34171 9.04882 6.14645 8.85355C5.95118 8.65829 5.95118 8.34171 6.14645 8.14645L11.2929 3H9.5C9.22386 3 9 2.77614 9 2.5C9 2.22386 9.22386 2 9.5 2H12.4999H12.5C12.5678 2 12.6324 2.01349 12.6914 2.03794C12.7504 2.06234 12.8056 2.09851 12.8536 2.14645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$24 = [
    "color"
];
var $e781b76dcad7c5d5$export$f2c2531e46a6c1ea = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$24);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M14.7649 6.07596C14.9991 6.22231 15.0703 6.53079 14.9239 6.76495C14.4849 7.46743 13.9632 8.10645 13.3702 8.66305L14.5712 9.86406C14.7664 10.0593 14.7664 10.3759 14.5712 10.5712C14.3759 10.7664 14.0593 10.7664 13.8641 10.5712L12.6011 9.30817C11.805 9.90283 10.9089 10.3621 9.93375 10.651L10.383 12.3277C10.4544 12.5944 10.2961 12.8685 10.0294 12.94C9.76267 13.0115 9.4885 12.8532 9.41704 12.5865L8.95917 10.8775C8.48743 10.958 8.00036 10.9999 7.50001 10.9999C6.99965 10.9999 6.51257 10.958 6.04082 10.8775L5.58299 12.5864C5.51153 12.8532 5.23737 13.0115 4.97064 12.94C4.7039 12.8686 4.5456 12.5944 4.61706 12.3277L5.06625 10.651C4.09111 10.3621 3.19503 9.90282 2.3989 9.30815L1.1359 10.5712C0.940638 10.7664 0.624058 10.7664 0.428798 10.5712C0.233537 10.3759 0.233537 10.0593 0.428798 9.86405L1.62982 8.66303C1.03682 8.10643 0.515113 7.46742 0.0760677 6.76495C-0.0702867 6.53079 0.000898544 6.22231 0.235065 6.07596C0.469231 5.9296 0.777703 6.00079 0.924058 6.23496C1.40354 7.00213 1.989 7.68057 2.66233 8.2427C2.67315 8.25096 2.6837 8.25972 2.69397 8.26898C4.00897 9.35527 5.65537 9.99991 7.50001 9.99991C10.3078 9.99991 12.6564 8.5063 14.076 6.23495C14.2223 6.00079 14.5308 5.9296 14.7649 6.07596Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$25 = [
    "color"
];
var $e781b76dcad7c5d5$export$3547759c3ff9b44c = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$25);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M13.3536 2.35355C13.5488 2.15829 13.5488 1.84171 13.3536 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L10.6828 3.61012C9.70652 3.21671 8.63759 3 7.5 3C4.30786 3 1.65639 4.70638 0.0760002 7.23501C-0.0253338 7.39715 -0.0253334 7.60288 0.0760014 7.76501C0.902945 9.08812 2.02314 10.1861 3.36061 10.9323L1.64645 12.6464C1.45118 12.8417 1.45118 13.1583 1.64645 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L4.31723 11.3899C5.29348 11.7833 6.36241 12 7.5 12C10.6921 12 13.3436 10.2936 14.924 7.76501C15.0253 7.60288 15.0253 7.39715 14.924 7.23501C14.0971 5.9119 12.9769 4.81391 11.6394 4.06771L13.3536 2.35355ZM9.90428 4.38861C9.15332 4.1361 8.34759 4 7.5 4C4.80285 4 2.52952 5.37816 1.09622 7.50001C1.87284 8.6497 2.89609 9.58106 4.09974 10.1931L9.90428 4.38861ZM5.09572 10.6114L10.9003 4.80685C12.1039 5.41894 13.1272 6.35031 13.9038 7.50001C12.4705 9.62183 10.1971 11 7.5 11C6.65241 11 5.84668 10.8639 5.09572 10.6114Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$26 = [
    "color"
];
var $e781b76dcad7c5d5$export$620653f31aa3377e = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$26);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.5 11C4.80285 11 2.52952 9.62184 1.09622 7.50001C2.52952 5.37816 4.80285 4 7.5 4C10.1971 4 12.4705 5.37816 13.9038 7.50001C12.4705 9.62183 10.1971 11 7.5 11ZM7.5 3C4.30786 3 1.65639 4.70638 0.0760002 7.23501C-0.0253338 7.39715 -0.0253334 7.60288 0.0760014 7.76501C1.65639 10.2936 4.30786 12 7.5 12C10.6921 12 13.3436 10.2936 14.924 7.76501C15.0253 7.60288 15.0253 7.39715 14.924 7.23501C13.3436 4.70638 10.6921 3 7.5 3ZM7.5 9.5C8.60457 9.5 9.5 8.60457 9.5 7.5C9.5 6.39543 8.60457 5.5 7.5 5.5C6.39543 5.5 5.5 6.39543 5.5 7.5C5.5 8.60457 6.39543 9.5 7.5 9.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$27 = [
    "color"
];
var $e781b76dcad7c5d5$export$b8f42e9471d5f647 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$27);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82708 7.49972C1.82708 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82708 10.6327 1.82708 7.49972ZM5.03747 9.21395C4.87949 8.98746 4.56782 8.93193 4.34133 9.08991C4.11484 9.24789 4.05931 9.55956 4.21729 9.78605C4.93926 10.8211 6.14033 11.5 7.50004 11.5C8.85974 11.5 10.0608 10.8211 10.7828 9.78605C10.9408 9.55956 10.8852 9.24789 10.6587 9.08991C10.4323 8.93193 10.1206 8.98746 9.9626 9.21395C9.41963 9.99238 8.51907 10.5 7.50004 10.5C6.481 10.5 5.58044 9.99238 5.03747 9.21395ZM5.37503 6.84998C5.85828 6.84998 6.25003 6.45815 6.25003 5.97498C6.25003 5.4918 5.85828 5.09998 5.37503 5.09998C4.89179 5.09998 4.50003 5.4918 4.50003 5.97498C4.50003 6.45815 4.89179 6.84998 5.37503 6.84998ZM10.5 5.97498C10.5 6.45815 10.1083 6.84998 9.62503 6.84998C9.14179 6.84998 8.75003 6.45815 8.75003 5.97498C8.75003 5.4918 9.14179 5.09998 9.62503 5.09998C10.1083 5.09998 10.5 5.4918 10.5 5.97498Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$28 = [
    "color"
];
var $e781b76dcad7c5d5$export$2b3d0ca2fe16e98c = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$28);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.00005 2.04999H5.52505C4.71043 2.04999 4.05005 2.71037 4.05005 3.52499C4.05005 4.33961 4.71043 4.99999 5.52505 4.99999H7.00005V2.04999ZM7.00005 1.04999H8.00005H9.47505C10.842 1.04999 11.95 2.15808 11.95 3.52499C11.95 4.33163 11.5642 5.04815 10.9669 5.49999C11.5642 5.95184 11.95 6.66836 11.95 7.475C11.95 8.8419 10.842 9.95 9.47505 9.95C8.92236 9.95 8.41198 9.76884 8.00005 9.46266V9.95L8.00005 11.425C8.00005 12.7919 6.89195 13.9 5.52505 13.9C4.15814 13.9 3.05005 12.7919 3.05005 11.425C3.05005 10.6183 3.43593 9.90184 4.03317 9.44999C3.43593 8.99814 3.05005 8.28163 3.05005 7.475C3.05005 6.66836 3.43594 5.95184 4.03319 5.5C3.43594 5.04815 3.05005 4.33163 3.05005 3.52499C3.05005 2.15808 4.15814 1.04999 5.52505 1.04999H7.00005ZM8.00005 2.04999V4.99999H9.47505C10.2897 4.99999 10.95 4.33961 10.95 3.52499C10.95 2.71037 10.2897 2.04999 9.47505 2.04999H8.00005ZM5.52505 8.94998H7.00005L7.00005 7.4788L7.00005 7.475L7.00005 7.4712V6H5.52505C4.71043 6 4.05005 6.66038 4.05005 7.475C4.05005 8.28767 4.70727 8.94684 5.5192 8.94999L5.52505 8.94998ZM4.05005 11.425C4.05005 10.6123 4.70727 9.95315 5.5192 9.94999L5.52505 9.95H7.00005L7.00005 11.425C7.00005 12.2396 6.33967 12.9 5.52505 12.9C4.71043 12.9 4.05005 12.2396 4.05005 11.425ZM8.00005 7.47206C8.00164 6.65879 8.66141 6 9.47505 6C10.2897 6 10.95 6.66038 10.95 7.475C10.95 8.28962 10.2897 8.95 9.47505 8.95C8.66141 8.95 8.00164 8.29121 8.00005 7.47794V7.47206Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$29 = [
    "color"
];
var $e781b76dcad7c5d5$export$8c1a3d13e85d78b7 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$29);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M3.5 2C3.22386 2 3 2.22386 3 2.5V12.5C3 12.7761 3.22386 13 3.5 13H11.5C11.7761 13 12 12.7761 12 12.5V6H8.5C8.22386 6 8 5.77614 8 5.5V2H3.5ZM9 2.70711L11.2929 5H9V2.70711ZM2 2.5C2 1.67157 2.67157 1 3.5 1H8.5C8.63261 1 8.75979 1.05268 8.85355 1.14645L12.8536 5.14645C12.9473 5.24021 13 5.36739 13 5.5V12.5C13 13.3284 12.3284 14 11.5 14H3.5C2.67157 14 2 13.3284 2 12.5V2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2a = [
    "color"
];
var $e781b76dcad7c5d5$export$3c5dbe056aa7c94f = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2a);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M3 2.5C3 2.22386 3.22386 2 3.5 2H9.29289L12 4.70711V12.5C12 12.7761 11.7761 13 11.5 13H3.5C3.22386 13 3 12.7761 3 12.5V2.5ZM3.5 1C2.67157 1 2 1.67157 2 2.5V12.5C2 13.3284 2.67157 14 3.5 14H11.5C12.3284 14 13 13.3284 13 12.5V4.60355C13 4.40464 12.921 4.21388 12.7803 4.07322L9.85355 1.14645C9.75979 1.05268 9.63261 1 9.5 1H3.5ZM5.25 7C4.97386 7 4.75 7.22386 4.75 7.5C4.75 7.77614 4.97386 8 5.25 8H9.75C10.0261 8 10.25 7.77614 10.25 7.5C10.25 7.22386 10.0261 7 9.75 7H5.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2b = [
    "color"
];
var $e781b76dcad7c5d5$export$ca191b730434e9b4 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2b);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M3.5 2C3.22386 2 3 2.22386 3 2.5V12.5C3 12.7761 3.22386 13 3.5 13H11.5C11.7761 13 12 12.7761 12 12.5V4.70711L9.29289 2H3.5ZM2 2.5C2 1.67157 2.67157 1 3.5 1H9.5C9.63261 1 9.75979 1.05268 9.85355 1.14645L12.7803 4.07322C12.921 4.21388 13 4.40464 13 4.60355V12.5C13 13.3284 12.3284 14 11.5 14H3.5C2.67157 14 2 13.3284 2 12.5V2.5ZM4.75 7.5C4.75 7.22386 4.97386 7 5.25 7H7V5.25C7 4.97386 7.22386 4.75 7.5 4.75C7.77614 4.75 8 4.97386 8 5.25V7H9.75C10.0261 7 10.25 7.22386 10.25 7.5C10.25 7.77614 10.0261 8 9.75 8H8V9.75C8 10.0261 7.77614 10.25 7.5 10.25C7.22386 10.25 7 10.0261 7 9.75V8H5.25C4.97386 8 4.75 7.77614 4.75 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2c = [
    "color"
];
var $e781b76dcad7c5d5$export$605674723bcc715c = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2c);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M3 2.5C3 2.22386 3.22386 2 3.5 2H9.08579C9.21839 2 9.34557 2.05268 9.43934 2.14645L11.8536 4.56066C11.9473 4.65443 12 4.78161 12 4.91421V12.5C12 12.7761 11.7761 13 11.5 13H3.5C3.22386 13 3 12.7761 3 12.5V2.5ZM3.5 1C2.67157 1 2 1.67157 2 2.5V12.5C2 13.3284 2.67157 14 3.5 14H11.5C12.3284 14 13 13.3284 13 12.5V4.91421C13 4.51639 12.842 4.13486 12.5607 3.85355L10.1464 1.43934C9.86514 1.15804 9.48361 1 9.08579 1H3.5ZM4.5 4C4.22386 4 4 4.22386 4 4.5C4 4.77614 4.22386 5 4.5 5H7.5C7.77614 5 8 4.77614 8 4.5C8 4.22386 7.77614 4 7.5 4H4.5ZM4.5 7C4.22386 7 4 7.22386 4 7.5C4 7.77614 4.22386 8 4.5 8H10.5C10.7761 8 11 7.77614 11 7.5C11 7.22386 10.7761 7 10.5 7H4.5ZM4.5 10C4.22386 10 4 10.2239 4 10.5C4 10.7761 4.22386 11 4.5 11H10.5C10.7761 11 11 10.7761 11 10.5C11 10.2239 10.7761 10 10.5 10H4.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2d = [
    "color"
];
var $e781b76dcad7c5d5$export$1a2ae984f27cf526 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2d);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M5.10505 12C4.70805 12 4.4236 11.912 4.25171 11.736C4.0839 11.5559 4 11.2715 4 10.8827V4.11733C4 3.72033 4.08595 3.43588 4.25784 3.26398C4.43383 3.08799 4.71623 3 5.10505 3C6.42741 3 8.25591 3 9.02852 3C10.1373 3 11.0539 3.98153 11.0539 5.1846C11.0539 6.08501 10.6037 6.81855 9.70327 7.23602C10.8657 7.44851 11.5176 8.62787 11.5176 9.48128C11.5176 10.5125 10.9902 12 9.27734 12C8.77742 12 6.42626 12 5.10505 12ZM8.37891 8.00341H5.8V10.631H8.37891C8.9 10.631 9.6296 10.1211 9.6296 9.29877C9.6296 8.47643 8.9 8.00341 8.37891 8.00341ZM5.8 4.36903V6.69577H8.17969C8.53906 6.69577 9.27734 6.35939 9.27734 5.50002C9.27734 4.64064 8.48047 4.36903 8.17969 4.36903H5.8Z",
        fill: color
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2e = [
    "color"
];
var $e781b76dcad7c5d5$export$79d8792587f7aca5 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2e);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M2.5 4.5C2.5 3.09886 3.59886 2 5 2H12.499C12.7752 2 13 2.22386 13 2.5C13 2.77614 12.7761 3 12.5 3H8.69244L8.40509 3.85458C8.18869 4.49752 7.89401 5.37197 7.58091 6.29794C7.50259 6.52956 7.42308 6.76453 7.34332 7H8.5C8.77614 7 9 7.22386 9 7.5C9 7.77614 8.77614 8 8.5 8H7.00407C6.56724 9.28543 6.16435 10.4613 5.95799 11.0386C5.63627 11.9386 5.20712 12.4857 4.66741 12.7778C4.16335 13.0507 3.64154 13.0503 3.28378 13.05L3.25 13.05C2.94624 13.05 2.7 12.8037 2.7 12.5C2.7 12.1962 2.94624 11.95 3.25 11.95C3.64182 11.95 3.9035 11.9405 4.14374 11.8105C4.36443 11.691 4.65532 11.4148 4.92217 10.6683C5.10695 10.1514 5.45375 9.14134 5.8422 8H4.5C4.22386 8 4 7.77614 4 7.5C4 7.22386 4.22386 7 4.5 7H6.18187C6.30127 6.64785 6.42132 6.29323 6.53887 5.94559C6.85175 5.02025 7.14627 4.14631 7.36256 3.50368L7.53192 3H5C4.15114 3 3.5 3.65114 3.5 4.5C3.5 4.77614 3.27614 5 3 5C2.72386 5 2.5 4.77614 2.5 4.5Z",
        fill: color
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2f = [
    "color"
];
var $e781b76dcad7c5d5$export$f5ac866b2a77627a = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2f);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M5.67494 3.50017C5.67494 3.25164 5.87641 3.05017 6.12494 3.05017H10.6249C10.8735 3.05017 11.0749 3.25164 11.0749 3.50017C11.0749 3.7487 10.8735 3.95017 10.6249 3.95017H9.00587L7.2309 11.05H8.87493C9.12345 11.05 9.32493 11.2515 9.32493 11.5C9.32493 11.7486 9.12345 11.95 8.87493 11.95H4.37493C4.1264 11.95 3.92493 11.7486 3.92493 11.5C3.92493 11.2515 4.1264 11.05 4.37493 11.05H5.99397L7.76894 3.95017H6.12494C5.87641 3.95017 5.67494 3.7487 5.67494 3.50017Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2g = [
    "color"
];
var $e781b76dcad7c5d5$export$9f94aa21504b3fcd = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2g);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M4.79993 3.50017C4.79993 3.25164 5.0014 3.05017 5.24993 3.05017H9.74993C9.99845 3.05017 10.1999 3.25164 10.1999 3.50017C10.1999 3.7487 9.99845 3.95017 9.74993 3.95017H8.09993V11.05H9.74994C9.99847 11.05 10.1999 11.2515 10.1999 11.5C10.1999 11.7486 9.99847 11.95 9.74994 11.95H5.24994C5.00141 11.95 4.79994 11.7486 4.79994 11.5C4.79994 11.2515 5.00141 11.05 5.24994 11.05H6.89993V3.95017H5.24993C5.0014 3.95017 4.79993 3.7487 4.79993 3.50017Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2h = [
    "color"
];
var $e781b76dcad7c5d5$export$88890ea574fb3a19 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2h);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M2.78233 2.21707C2.70732 2.14206 2.60557 2.09991 2.49949 2.09991C2.3934 2.09991 2.29166 2.14206 2.21664 2.21707L0.216645 4.21707C0.0604351 4.37328 0.0604351 4.62655 0.216645 4.78276C0.372855 4.93897 0.626121 4.93897 0.78233 4.78276L2.09949 3.4656L2.09949 11.5342L0.78233 10.2171C0.62612 10.0609 0.372854 10.0609 0.216645 10.2171C0.0604349 10.3733 0.0604349 10.6265 0.216645 10.7828L2.21664 12.7828C2.29166 12.8578 2.3934 12.8999 2.49949 12.8999C2.60557 12.8999 2.70731 12.8578 2.78233 12.7828L4.78233 10.7828C4.93854 10.6265 4.93854 10.3733 4.78233 10.2171C4.62612 10.0609 4.37285 10.0609 4.21664 10.2171L2.89949 11.5342L2.89949 3.4656L4.21664 4.78276C4.37285 4.93897 4.62612 4.93897 4.78233 4.78276C4.93854 4.62655 4.93854 4.37328 4.78233 4.21707L2.78233 2.21707ZM10.5 2.74997C10.7107 2.74997 10.8988 2.88211 10.9703 3.08036L13.9703 11.3999C14.064 11.6597 13.9293 11.9462 13.6696 12.0399C13.4098 12.1336 13.1233 11.9989 13.0296 11.7392L12.0477 9.016H8.95228L7.97033 11.7392C7.87666 11.9989 7.59013 12.1336 7.33036 12.0399C7.07059 11.9462 6.93595 11.6597 7.02962 11.3999L10.0296 3.08036C10.1011 2.88211 10.2892 2.74997 10.5 2.74997ZM10.5 4.72396L11.7412 8.166H9.25879L10.5 4.72396Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2i = [
    "color"
];
var $e781b76dcad7c5d5$export$805712ff48c03e2e = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2i);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M1.03791 9.98075C0.934777 9.6583 1.11603 9.37719 1.40005 9.24871C1.68408 9.12022 2.09463 9.13412 2.27071 9.45426C2.85393 10.5147 3.64599 10.7282 4.48665 10.7282C5.52721 10.7282 6.29659 10.2615 6.29659 9.45426C6.29659 8.8047 5.9119 8.46416 4.87134 8.14253L4.15872 7.92181C2.64518 7.44883 1.88842 6.69206 1.88842 5.45601C1.88842 3.79743 3.27583 2.6875 5.24342 2.6875C6.91733 2.6875 7.97409 3.33536 8.43833 4.31065C8.57087 4.58909 8.57614 4.91294 8.22794 5.19114C7.87974 5.46934 7.52351 5.34799 7.23327 5.03839C6.47215 4.22653 5.99545 4.04968 5.25604 4.04968C4.1398 4.04968 3.547 4.63618 3.547 5.27943C3.547 5.86592 3.96322 6.23169 4.94702 6.5344L5.67856 6.76143C7.22994 7.23441 7.97409 7.95964 7.97409 9.17047C7.97409 10.7723 6.69389 12.0903 4.46143 12.0903C2.86612 12.0903 1.40005 11.1131 1.03791 9.98075ZM11.8491 8.77985C10.661 8.39543 10.1649 7.86114 10.1649 6.98805C10.1649 5.86736 11.1636 5.04639 12.6128 5.04639C13.8546 5.04639 14.6629 5.63345 14.9778 6.6346C15.0443 6.84599 14.9593 6.98006 14.7475 7.0491C14.5394 7.11697 14.3176 7.09974 14.238 6.89611C13.9356 6.12273 13.352 5.76311 12.5998 5.76311C11.6467 5.76311 11.0135 6.25178 11.0135 6.91638C11.0135 7.45066 11.3464 7.75038 12.2473 8.04358L12.8348 8.23254C14.062 8.62999 14.5516 9.13821 14.5516 10.0178C14.5516 11.1972 13.481 12.0442 11.9927 12.0442C10.6439 12.0442 9.65644 11.2809 9.41979 10.3361C9.36535 10.1188 9.41192 10.0287 9.70039 9.96184C9.98886 9.89499 10.0714 9.89918 10.1715 10.1369C10.4555 10.8114 11.1531 11.3275 12.0318 11.3275C12.9914 11.3275 13.6834 10.7802 13.6834 10.0634C13.6834 9.53567 13.3961 9.28807 12.4366 8.97532L11.8491 8.77985Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2j = [
    "color"
];
var $e781b76dcad7c5d5$export$bbfc12447ec5dbe8 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2j);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M11 1.5C11 1.22386 10.7761 1 10.5 1C10.2239 1 10 1.22386 10 1.5V4H5V1.5C5 1.22386 4.77614 1 4.5 1C4.22386 1 4 1.22386 4 1.5V4H1.5C1.22386 4 1 4.22386 1 4.5C1 4.77614 1.22386 5 1.5 5H4V10H1.5C1.22386 10 1 10.2239 1 10.5C1 10.7761 1.22386 11 1.5 11H4V13.5C4 13.7761 4.22386 14 4.5 14C4.77614 14 5 13.7761 5 13.5V11H10V13.5C10 13.7761 10.2239 14 10.5 14C10.7761 14 11 13.7761 11 13.5V11H13.5C13.7761 11 14 10.7761 14 10.5C14 10.2239 13.7761 10 13.5 10H11V5H13.5C13.7761 5 14 4.77614 14 4.5C14 4.22386 13.7761 4 13.5 4H11V1.5ZM10 10V5H5V10H10Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2k = [
    "color"
];
var $e781b76dcad7c5d5$export$49fa3bb64381879 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2k);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M3.3825 1.29567C3.46241 1.11432 3.64188 0.997284 3.84005 0.997284H11.5C11.7761 0.997284 12 1.22114 12 1.49728V5.5C12 5.77614 11.7761 6 11.5 6H8.63521L11.5288 9.16247C11.6626 9.3087 11.6974 9.52015 11.6175 9.70154C11.5376 9.88293 11.3582 10 11.16 10H8V13.5C8 13.7022 7.87818 13.8845 7.69134 13.9619C7.5045 14.0393 7.28945 13.9966 7.14645 13.8536L3.14645 9.85355C3.05268 9.75979 3 9.63261 3 9.5V5.5C3 5.22386 3.22386 5 3.5 5H6.36531L3.47105 1.83468C3.33732 1.68844 3.30259 1.47701 3.3825 1.29567ZM7.72032 5L4.97474 1.99728H11V5H7.72032ZM7.27978 6H4V9H7.5H10.0247L7.27978 6ZM4.70711 10L7 12.2929V10H4.70711Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2l = [
    "color"
];
var $e781b76dcad7c5d5$export$70208e77f6c45b17 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2l);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.07095 0.650238C6.67391 0.650238 6.32977 0.925096 6.24198 1.31231L6.0039 2.36247C5.6249 2.47269 5.26335 2.62363 4.92436 2.81013L4.01335 2.23585C3.67748 2.02413 3.23978 2.07312 2.95903 2.35386L2.35294 2.95996C2.0722 3.2407 2.0232 3.6784 2.23493 4.01427L2.80942 4.92561C2.62307 5.2645 2.47227 5.62594 2.36216 6.00481L1.31209 6.24287C0.924883 6.33065 0.650024 6.6748 0.650024 7.07183V7.92897C0.650024 8.32601 0.924883 8.67015 1.31209 8.75794L2.36228 8.99603C2.47246 9.375 2.62335 9.73652 2.80979 10.0755L2.2354 10.9867C2.02367 11.3225 2.07267 11.7602 2.35341 12.041L2.95951 12.6471C3.24025 12.9278 3.67795 12.9768 4.01382 12.7651L4.92506 12.1907C5.26384 12.377 5.62516 12.5278 6.0039 12.6379L6.24198 13.6881C6.32977 14.0753 6.67391 14.3502 7.07095 14.3502H7.92809C8.32512 14.3502 8.66927 14.0753 8.75705 13.6881L8.99505 12.6383C9.37411 12.5282 9.73573 12.3773 10.0748 12.1909L10.986 12.7653C11.3218 12.977 11.7595 12.928 12.0403 12.6473L12.6464 12.0412C12.9271 11.7604 12.9761 11.3227 12.7644 10.9869L12.1902 10.076C12.3768 9.73688 12.5278 9.37515 12.638 8.99596L13.6879 8.75794C14.0751 8.67015 14.35 8.32601 14.35 7.92897V7.07183C14.35 6.6748 14.0751 6.33065 13.6879 6.24287L12.6381 6.00488C12.528 5.62578 12.3771 5.26414 12.1906 4.92507L12.7648 4.01407C12.9766 3.6782 12.9276 3.2405 12.6468 2.95975L12.0407 2.35366C11.76 2.07292 11.3223 2.02392 10.9864 2.23565L10.0755 2.80989C9.73622 2.62328 9.37437 2.47229 8.99505 2.36209L8.75705 1.31231C8.66927 0.925096 8.32512 0.650238 7.92809 0.650238H7.07095ZM4.92053 3.81251C5.44724 3.44339 6.05665 3.18424 6.71543 3.06839L7.07095 1.50024H7.92809L8.28355 3.06816C8.94267 3.18387 9.5524 3.44302 10.0794 3.81224L11.4397 2.9547L12.0458 3.56079L11.1882 4.92117C11.5573 5.44798 11.8164 6.0575 11.9321 6.71638L13.5 7.07183V7.92897L11.932 8.28444C11.8162 8.94342 11.557 9.55301 11.1878 10.0798L12.0453 11.4402L11.4392 12.0462L10.0787 11.1886C9.55192 11.5576 8.94241 11.8166 8.28355 11.9323L7.92809 13.5002H7.07095L6.71543 11.932C6.0569 11.8162 5.44772 11.5572 4.92116 11.1883L3.56055 12.046L2.95445 11.4399L3.81213 10.0794C3.4431 9.55266 3.18403 8.94326 3.06825 8.2845L1.50002 7.92897V7.07183L3.06818 6.71632C3.18388 6.05765 3.44283 5.44833 3.81171 4.92165L2.95398 3.561L3.56008 2.95491L4.92053 3.81251ZM9.02496 7.50008C9.02496 8.34226 8.34223 9.02499 7.50005 9.02499C6.65786 9.02499 5.97513 8.34226 5.97513 7.50008C5.97513 6.65789 6.65786 5.97516 7.50005 5.97516C8.34223 5.97516 9.02496 6.65789 9.02496 7.50008ZM9.92496 7.50008C9.92496 8.83932 8.83929 9.92499 7.50005 9.92499C6.1608 9.92499 5.07513 8.83932 5.07513 7.50008C5.07513 6.16084 6.1608 5.07516 7.50005 5.07516C8.83929 5.07516 9.92496 6.16084 9.92496 7.50008Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2m = [
    "color"
];
var $e781b76dcad7c5d5$export$9a0862960670d05c = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2m);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.49933 0.25C3.49635 0.25 0.25 3.49593 0.25 7.50024C0.25 10.703 2.32715 13.4206 5.2081 14.3797C5.57084 14.446 5.70302 14.2222 5.70302 14.0299C5.70302 13.8576 5.69679 13.4019 5.69323 12.797C3.67661 13.235 3.25112 11.825 3.25112 11.825C2.92132 10.9874 2.44599 10.7644 2.44599 10.7644C1.78773 10.3149 2.49584 10.3238 2.49584 10.3238C3.22353 10.375 3.60629 11.0711 3.60629 11.0711C4.25298 12.1788 5.30335 11.8588 5.71638 11.6732C5.78225 11.205 5.96962 10.8854 6.17658 10.7043C4.56675 10.5209 2.87415 9.89918 2.87415 7.12104C2.87415 6.32925 3.15677 5.68257 3.62053 5.17563C3.54576 4.99226 3.29697 4.25521 3.69174 3.25691C3.69174 3.25691 4.30015 3.06196 5.68522 3.99973C6.26337 3.83906 6.8838 3.75895 7.50022 3.75583C8.1162 3.75895 8.73619 3.83906 9.31523 3.99973C10.6994 3.06196 11.3069 3.25691 11.3069 3.25691C11.7026 4.25521 11.4538 4.99226 11.3795 5.17563C11.8441 5.68257 12.1245 6.32925 12.1245 7.12104C12.1245 9.9063 10.4292 10.5192 8.81452 10.6985C9.07444 10.9224 9.30633 11.3648 9.30633 12.0413C9.30633 13.0102 9.29742 13.7922 9.29742 14.0299C9.29742 14.2239 9.42828 14.4496 9.79591 14.3788C12.6746 13.4179 14.75 10.7025 14.75 7.50024C14.75 3.49593 11.5036 0.25 7.49933 0.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2n = [
    "color"
];
var $e781b76dcad7c5d5$export$a70e2e549144f66 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2n);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.49996 1.80002C4.35194 1.80002 1.79996 4.352 1.79996 7.50002C1.79996 10.648 4.35194 13.2 7.49996 13.2C10.648 13.2 13.2 10.648 13.2 7.50002C13.2 4.352 10.648 1.80002 7.49996 1.80002ZM0.899963 7.50002C0.899963 3.85494 3.85488 0.900024 7.49996 0.900024C11.145 0.900024 14.1 3.85494 14.1 7.50002C14.1 11.1451 11.145 14.1 7.49996 14.1C3.85488 14.1 0.899963 11.1451 0.899963 7.50002Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        d: "M13.4999 7.89998H1.49994V7.09998H13.4999V7.89998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.09991 13.5V1.5H7.89991V13.5H7.09991zM10.375 7.49998C10.375 5.32724 9.59364 3.17778 8.06183 1.75656L8.53793 1.24341C10.2396 2.82218 11.075 5.17273 11.075 7.49998 11.075 9.82724 10.2396 12.1778 8.53793 13.7566L8.06183 13.2434C9.59364 11.8222 10.375 9.67273 10.375 7.49998zM3.99969 7.5C3.99969 5.17611 4.80786 2.82678 6.45768 1.24719L6.94177 1.75281C5.4582 3.17323 4.69969 5.32389 4.69969 7.5 4.6997 9.67611 5.45822 11.8268 6.94179 13.2472L6.45769 13.7528C4.80788 12.1732 3.9997 9.8239 3.99969 7.5z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.49996 3.95801C9.66928 3.95801 11.8753 4.35915 13.3706 5.19448 13.5394 5.28875 13.5998 5.50197 13.5055 5.67073 13.4113 5.83948 13.198 5.89987 13.0293 5.8056 11.6794 5.05155 9.60799 4.65801 7.49996 4.65801 5.39192 4.65801 3.32052 5.05155 1.97064 5.8056 1.80188 5.89987 1.58866 5.83948 1.49439 5.67073 1.40013 5.50197 1.46051 5.28875 1.62927 5.19448 3.12466 4.35915 5.33063 3.95801 7.49996 3.95801zM7.49996 10.85C9.66928 10.85 11.8753 10.4488 13.3706 9.6135 13.5394 9.51924 13.5998 9.30601 13.5055 9.13726 13.4113 8.9685 13.198 8.90812 13.0293 9.00238 11.6794 9.75643 9.60799 10.15 7.49996 10.15 5.39192 10.15 3.32052 9.75643 1.97064 9.00239 1.80188 8.90812 1.58866 8.9685 1.49439 9.13726 1.40013 9.30601 1.46051 9.51924 1.62927 9.6135 3.12466 10.4488 5.33063 10.85 7.49996 10.85z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2o = [
    "color"
];
var $e781b76dcad7c5d5$export$fa17e9a974485717 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2o);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M12.5 2H8V7H13V2.5C13 2.22386 12.7761 2 12.5 2ZM13 8H8V13H12.5C12.7761 13 13 12.7761 13 12.5V8ZM7 7V2H2.5C2.22386 2 2 2.22386 2 2.5V7H7ZM2 8V12.5C2 12.7761 2.22386 13 2.5 13H7V8H2ZM2.5 1C1.67157 1 1 1.67157 1 2.5V12.5C1 13.3284 1.67157 14 2.5 14H12.5C13.3284 14 14 13.3284 14 12.5V2.5C14 1.67157 13.3284 1 12.5 1H2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2p = [
    "color"
];
var $e781b76dcad7c5d5$export$97eeb400c5f33310 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2p);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M1.44995 0.949951C1.31734 0.949951 1.19016 1.00263 1.0964 1.0964C1.00263 1.19017 0.949951 1.31735 0.949951 1.44995L0.949966 3.44995C0.949969 3.7261 1.17383 3.94995 1.44997 3.94995C1.72611 3.94995 1.94997 3.72609 1.94997 3.44995L1.94995 1.94995H3.44997C3.72611 1.94995 3.94997 1.72609 3.94997 1.44995C3.94997 1.17381 3.72611 0.949951 3.44997 0.949951H1.44995ZM5.94995 0.949951C5.67381 0.949951 5.44995 1.17381 5.44995 1.44995C5.44995 1.72609 5.67381 1.94995 5.94995 1.94995H8.94995C9.22609 1.94995 9.44995 1.72609 9.44995 1.44995C9.44995 1.17381 9.22609 0.949951 8.94995 0.949951H5.94995ZM5.44995 13.45C5.44995 13.1738 5.67381 12.95 5.94995 12.95H8.94995C9.22609 12.95 9.44995 13.1738 9.44995 13.45C9.44995 13.7261 9.22609 13.95 8.94995 13.95H5.94995C5.67381 13.95 5.44995 13.7261 5.44995 13.45ZM1.94995 5.94995C1.94995 5.67381 1.72609 5.44995 1.44995 5.44995C1.17381 5.44995 0.949951 5.67381 0.949951 5.94995V8.94995C0.949951 9.22609 1.17381 9.44995 1.44995 9.44995C1.72609 9.44995 1.94995 9.22609 1.94995 8.94995V5.94995ZM13.45 5.44995C13.7261 5.44995 13.95 5.67381 13.95 5.94995V8.94995C13.95 9.22609 13.7261 9.44995 13.45 9.44995C13.1738 9.44995 12.95 9.22609 12.95 8.94995V5.94995C12.95 5.67381 13.1738 5.44995 13.45 5.44995ZM11.45 0.949951C11.1738 0.949951 10.95 1.17381 10.95 1.44995C10.95 1.72609 11.1738 1.94995 11.45 1.94995H12.9499V3.44995C12.9499 3.72609 13.1738 3.94995 13.4499 3.94995C13.7261 3.94995 13.9499 3.72609 13.9499 3.44995V1.44995C13.9499 1.17381 13.7252 0.949951 13.449 0.949951H11.45ZM1.44995 10.95C1.72609 10.95 1.94995 11.1738 1.94995 11.45V12.95H3.44997C3.72611 12.95 3.94997 13.1738 3.94997 13.45C3.94997 13.7261 3.72611 13.95 3.44997 13.95H1.44995C1.17381 13.95 0.949951 13.7261 0.949951 13.45V11.45C0.949951 11.1738 1.17381 10.95 1.44995 10.95ZM13.95 11.45C13.95 11.1738 13.7261 10.95 13.45 10.95C13.1738 10.9499 12.95 11.1738 12.95 11.4499L12.9491 12.95H11.45C11.1738 12.95 10.95 13.1738 10.95 13.45C10.95 13.7261 11.1738 13.95 11.45 13.95H13.4499C13.7261 13.95 13.9499 13.7261 13.9499 13.45L13.95 11.45Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2q = [
    "color"
];
var $e781b76dcad7c5d5$export$1106febb4d651860 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2q);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM7.00003 1.84861C4.10114 2.1017 1.82707 4.53515 1.82707 7.49972C1.82707 10.4643 4.10114 12.8977 7.00003 13.1508V1.84861ZM8.00003 13.1508C10.8988 12.8976 13.1727 10.4642 13.1727 7.49972C13.1727 4.53524 10.8988 2.10185 8.00003 1.84864V13.1508Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2r = [
    "color"
];
var $e781b76dcad7c5d5$export$991e44cd0549467c = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2r);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM7.49988 1.82689C4.36688 1.8269 1.82707 4.36672 1.82707 7.49972C1.82707 10.6327 4.36688 13.1725 7.49988 13.1726V1.82689Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2s = [
    "color"
];
var $e781b76dcad7c5d5$export$ea8e5ed9f4a6e89d = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2s);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M1.5 3C1.22386 3 1 3.22386 1 3.5C1 3.77614 1.22386 4 1.5 4H13.5C13.7761 4 14 3.77614 14 3.5C14 3.22386 13.7761 3 13.5 3H1.5ZM1 7.5C1 7.22386 1.22386 7 1.5 7H13.5C13.7761 7 14 7.22386 14 7.5C14 7.77614 13.7761 8 13.5 8H1.5C1.22386 8 1 7.77614 1 7.5ZM1 11.5C1 11.2239 1.22386 11 1.5 11H13.5C13.7761 11 14 11.2239 14 11.5C14 11.7761 13.7761 12 13.5 12H1.5C1.22386 12 1 11.7761 1 11.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2t = [
    "color"
];
var $e781b76dcad7c5d5$export$f9eb84fdaa009a42 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2t);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M6.8113 1.64706C6.62188 2.87918 6.68268 3.88523 6.76848 5.30499C6.78415 5.56426 6.80065 5.83732 6.81661 6.12808C6.83111 6.39208 6.63758 6.62172 6.37495 6.65217C6.11232 6.68262 5.87138 6.50334 5.82509 6.24304L5.74754 5.80698C5.64402 5.16529 5.48355 4.25481 5.17807 3.44741C4.86241 2.61312 4.4486 2.04121 3.93436 1.86044C3.64994 1.76104 3.41901 1.84279 3.25868 2.01052C3.08746 2.18962 2.9976 2.47065 3.0627 2.75399C3.2146 3.34424 3.44627 3.9167 3.69836 4.51802C3.72082 4.57158 3.74346 4.62543 3.76621 4.67954C3.9954 5.22457 4.23619 5.7972 4.41644 6.39081L4.41691 6.39238C4.562 6.87586 4.65646 7.2595 4.73086 7.56165C4.76034 7.68138 4.78667 7.78831 4.81175 7.88359C4.86768 8.09606 4.77836 8.32014 4.59161 8.43588C4.40486 8.55161 4.16445 8.53188 3.99907 8.38725C3.73749 8.15848 3.515 7.92784 3.31817 7.71802C3.27627 7.67335 3.23602 7.63018 3.19705 7.58838C3.04777 7.42826 2.91712 7.28812 2.78334 7.16029C2.45989 6.85122 2.18398 6.68004 1.80585 6.64369L1.80324 6.64343C1.56117 6.61888 1.41402 6.66441 1.31756 6.72627C1.21899 6.78947 1.11988 6.90414 1.03784 7.1123C0.976576 7.28492 1.01515 7.62987 1.1929 7.96911L1.19728 7.97747C1.40086 8.38452 1.74475 8.81587 2.18141 9.29299C2.39739 9.52898 2.62872 9.76849 2.86934 10.0174L2.87966 10.0281C3.11546 10.2721 3.35962 10.5247 3.59713 10.7827C4.4288 11.6863 5.27706 12.7538 5.4627 14H11.5087C11.5636 12.4353 11.8756 11.268 12.2875 10.1346C12.4454 9.70041 12.6121 9.28412 12.7826 8.85829C13.1097 8.04139 13.4509 7.18937 13.7705 6.10824C14.0989 4.99737 14.0097 4.37033 13.8613 4.03984C13.717 3.71858 13.4914 3.61786 13.3816 3.59606C13.1381 3.54774 13.0384 3.60947 12.9698 3.67901C12.867 3.78316 12.7698 3.98273 12.6921 4.30269C12.6166 4.61345 12.5752 4.96517 12.533 5.32501L12.5298 5.35285C12.4924 5.67242 12.4505 6.03016 12.3665 6.30098C12.3383 6.40699 12.2819 6.50407 12.1979 6.57539C12.1382 6.6261 12.0104 6.70818 11.8309 6.69312C11.5424 6.66891 11.3712 6.42143 11.365 6.14783C11.356 5.75454 11.3883 5.35864 11.4074 4.96608C11.4428 4.23646 11.477 3.5337 11.4245 2.8342L11.4242 2.82934C11.3916 2.32997 11.0493 2.00228 10.7007 1.9228C10.5305 1.88401 10.369 1.90601 10.2347 1.9835C10.103 2.05946 9.95535 2.21318 9.8574 2.51394L9.85631 2.51726C9.81525 2.6404 9.77298 2.87753 9.73606 3.2124C9.70044 3.53542 9.67337 3.91279 9.65156 4.29418C9.6329 4.62033 9.61785 4.9584 9.60434 5.26194C9.58728 5.64529 9.57267 5.97357 9.55633 6.1532C9.54983 6.22459 9.52939 6.29493 9.49501 6.35785C9.47356 6.39711 9.36115 6.60947 9.07106 6.61843C8.77917 6.62744 8.63975 6.40057 8.61698 6.35919C8.55634 6.24899 8.55066 6.11807 8.54754 5.99283C8.54474 5.88064 8.54294 5.71798 8.54174 5.54767C8.53935 5.20582 8.53935 4.81919 8.53935 4.70952C8.53935 3.6657 8.53838 2.65372 8.44714 1.64372C8.39183 1.24127 8.06278 1.00455 7.6436 1.00005C7.22399 0.995552 6.87918 1.22704 6.8113 1.64706ZM9.41219 1.3617C9.21469 0.448484 8.39913 0.00810324 7.65433 0.00011154C6.86452 -0.00836308 5.98761 0.465881 5.82365 1.49037L5.82318 1.49334C5.78239 1.7584 5.75229 2.01481 5.7309 2.26652C5.39423 1.67364 4.92622 1.14894 4.2655 0.916859C3.58661 0.679312 2.9492 0.887087 2.53582 1.31952C2.13415 1.73971 1.94438 2.36742 2.09031 2.98746L2.09269 2.99713C2.26478 3.66808 2.52396 4.30316 2.77613 4.90465C2.79814 4.95717 2.8201 5.00941 2.84194 5.06139C3.02139 5.48842 3.19378 5.89866 3.33871 6.31256C2.96404 5.98142 2.51925 5.70796 1.90276 5.6484C1.48865 5.60663 1.10391 5.67536 0.777805 5.88444C0.454239 6.0919 0.240671 6.40405 0.104187 6.75406L0.100868 6.76281C-0.10184 7.31286 0.0663312 7.97157 0.304895 8.42897C0.573704 8.96474 0.996104 9.47904 1.44372 9.96813C1.67046 10.2159 1.91136 10.4652 2.15033 10.7124L2.15682 10.7191C2.39524 10.9658 2.63217 11.2109 2.86134 11.4599C3.80937 12.49 4.50002 13.4632 4.50002 14.5C4.50002 14.7761 4.72388 15 5.00002 15H12C12.2762 15 12.5 14.7761 12.5 14.5C12.5 12.8212 12.8021 11.6462 13.2274 10.4762C13.3653 10.0968 13.5216 9.70579 13.6868 9.29247C14.0238 8.44922 14.398 7.51298 14.7295 6.39175C15.0956 5.15324 15.0559 4.25904 14.7735 3.63017C14.487 2.99208 13.9798 2.6953 13.5763 2.6152C13.1276 2.52614 12.7367 2.60475 12.4268 2.83081C12.4253 2.80773 12.4236 2.78468 12.4219 2.76167C12.3587 1.8105 11.6907 1.12285 10.923 0.947821C10.5346 0.859287 10.1111 0.900393 9.73509 1.11724C9.61852 1.18446 9.51055 1.26623 9.41219 1.3617Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2u = [
    "color"
];
var $e781b76dcad7c5d5$export$635e9dadffe43ee = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2u);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M8.75432 2.0502C8.50579 2.0502 8.30432 2.25167 8.30432 2.5002C8.30432 2.74873 8.50579 2.9502 8.75432 2.9502H9.94997V7.05004H5.04997V2.9502H6.25432C6.50285 2.9502 6.70432 2.74873 6.70432 2.5002C6.70432 2.25167 6.50285 2.0502 6.25432 2.0502H2.75432C2.50579 2.0502 2.30432 2.25167 2.30432 2.5002C2.30432 2.74873 2.50579 2.9502 2.75432 2.9502H3.94997V12.0502H2.75432C2.50579 12.0502 2.30432 12.2517 2.30432 12.5002C2.30432 12.7487 2.50579 12.9502 2.75432 12.9502H6.25432C6.50285 12.9502 6.70432 12.7487 6.70432 12.5002C6.70432 12.2517 6.50285 12.0502 6.25432 12.0502H5.04997V7.95004H9.94997V12.0502H8.75432C8.50579 12.0502 8.30432 12.2517 8.30432 12.5002C8.30432 12.7487 8.50579 12.9502 8.75432 12.9502H12.2543C12.5028 12.9502 12.7043 12.7487 12.7043 12.5002C12.7043 12.2517 12.5028 12.0502 12.2543 12.0502H11.05V2.9502H12.2543C12.5028 2.9502 12.7043 2.74873 12.7043 2.5002C12.7043 2.25167 12.5028 2.0502 12.2543 2.0502H8.75432Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2v = [
    "color"
];
var $e781b76dcad7c5d5$export$16f03ed71cfb60c9 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2v);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M4.89346 2.35248C3.49195 2.35248 2.35248 3.49359 2.35248 4.90532C2.35248 6.38164 3.20954 7.9168 4.37255 9.33522C5.39396 10.581 6.59464 11.6702 7.50002 12.4778C8.4054 11.6702 9.60608 10.581 10.6275 9.33522C11.7905 7.9168 12.6476 6.38164 12.6476 4.90532C12.6476 3.49359 11.5081 2.35248 10.1066 2.35248C9.27059 2.35248 8.81894 2.64323 8.5397 2.95843C8.27877 3.25295 8.14623 3.58566 8.02501 3.88993C8.00391 3.9429 7.98315 3.99501 7.96211 4.04591C7.88482 4.23294 7.7024 4.35494 7.50002 4.35494C7.29765 4.35494 7.11523 4.23295 7.03793 4.04592C7.01689 3.99501 6.99612 3.94289 6.97502 3.8899C6.8538 3.58564 6.72126 3.25294 6.46034 2.95843C6.18109 2.64323 5.72945 2.35248 4.89346 2.35248ZM1.35248 4.90532C1.35248 2.94498 2.936 1.35248 4.89346 1.35248C6.0084 1.35248 6.73504 1.76049 7.20884 2.2953C7.32062 2.42147 7.41686 2.55382 7.50002 2.68545C7.58318 2.55382 7.67941 2.42147 7.79119 2.2953C8.265 1.76049 8.99164 1.35248 10.1066 1.35248C12.064 1.35248 13.6476 2.94498 13.6476 4.90532C13.6476 6.74041 12.6013 8.50508 11.4008 9.96927C10.2636 11.3562 8.92194 12.5508 8.00601 13.3664C7.94645 13.4194 7.88869 13.4709 7.83291 13.5206C7.64324 13.6899 7.3568 13.6899 7.16713 13.5206C7.11135 13.4709 7.05359 13.4194 6.99403 13.3664C6.0781 12.5508 4.73641 11.3562 3.59926 9.96927C2.39872 8.50508 1.35248 6.74041 1.35248 4.90532Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2w = [
    "color"
];
var $e781b76dcad7c5d5$export$b4120a3a3b5e8fcd = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2w);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M1.35248 4.90532C1.35248 2.94498 2.936 1.35248 4.89346 1.35248C6.25769 1.35248 6.86058 1.92336 7.50002 2.93545C8.13946 1.92336 8.74235 1.35248 10.1066 1.35248C12.064 1.35248 13.6476 2.94498 13.6476 4.90532C13.6476 6.74041 12.6013 8.50508 11.4008 9.96927C10.2636 11.3562 8.92194 12.5508 8.00601 13.3664C7.94645 13.4194 7.88869 13.4709 7.83291 13.5206C7.64324 13.6899 7.3568 13.6899 7.16713 13.5206C7.11135 13.4709 7.05359 13.4194 6.99403 13.3664C6.0781 12.5508 4.73641 11.3562 3.59926 9.96927C2.39872 8.50508 1.35248 6.74041 1.35248 4.90532Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2x = [
    "color"
];
var $e781b76dcad7c5d5$export$141e350c1bf9e61a = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2x);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.1813 1.68179C7.35704 1.50605 7.64196 1.50605 7.8177 1.68179L10.3177 4.18179C10.4934 4.35753 10.4934 4.64245 10.3177 4.81819C10.142 4.99392 9.85704 4.99392 9.6813 4.81819L7.9495 3.08638L7.9495 11.9136L9.6813 10.1818C9.85704 10.0061 10.142 10.0061 10.3177 10.1818C10.4934 10.3575 10.4934 10.6424 10.3177 10.8182L7.8177 13.3182C7.73331 13.4026 7.61885 13.45 7.4995 13.45C7.38015 13.45 7.26569 13.4026 7.1813 13.3182L4.6813 10.8182C4.50557 10.6424 4.50557 10.3575 4.6813 10.1818C4.85704 10.0061 5.14196 10.0061 5.3177 10.1818L7.0495 11.9136L7.0495 3.08638L5.3177 4.81819C5.14196 4.99392 4.85704 4.99392 4.6813 4.81819C4.50557 4.64245 4.50557 4.35753 4.6813 4.18179L7.1813 1.68179Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2y = [
    "color"
];
var $e781b76dcad7c5d5$export$9360f6250c6c6a8c = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2y);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M12.3536 13.3536C12.1583 13.5488 11.8417 13.5488 11.6465 13.3536L6.39645 8.10355C6.36478 8.07188 6.33824 8.03702 6.31685 8H5.00002C4.78719 8 4.59769 7.86528 4.52777 7.66426L2.12777 0.764277C2.05268 0.548387 2.13355 0.309061 2.3242 0.182972C2.51486 0.0568819 2.76674 0.0761337 2.93602 0.229734L8.336 5.12972C8.44044 5.22449 8.50001 5.35897 8.50001 5.5V5.81684C8.53702 5.83824 8.57189 5.86478 8.60356 5.89645L13.8536 11.1464C14.0488 11.3417 14.0488 11.6583 13.8536 11.8536L12.3536 13.3536ZM8.25 6.95711L7.45711 7.75L12 12.2929L12.7929 11.5L8.25 6.95711ZM3.71669 2.28845L5.35549 7H6.2929L7.50001 5.79289V5.72146L3.71669 2.28845Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2z = [
    "color"
];
var $e781b76dcad7c5d5$export$92c8767b874048d = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2z);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.07926 0.222253C7.31275 -0.007434 7.6873 -0.007434 7.92079 0.222253L14.6708 6.86227C14.907 7.09465 14.9101 7.47453 14.6778 7.71076C14.4454 7.947 14.0655 7.95012 13.8293 7.71773L13 6.90201V12.5C13 12.7761 12.7762 13 12.5 13H2.50002C2.22388 13 2.00002 12.7761 2.00002 12.5V6.90201L1.17079 7.71773C0.934558 7.95012 0.554672 7.947 0.32229 7.71076C0.0899079 7.47453 0.0930283 7.09465 0.32926 6.86227L7.07926 0.222253ZM7.50002 1.49163L12 5.91831V12H10V8.49999C10 8.22385 9.77617 7.99999 9.50002 7.99999H6.50002C6.22388 7.99999 6.00002 8.22385 6.00002 8.49999V12H3.00002V5.91831L7.50002 1.49163ZM7.00002 12H9.00002V8.99999H7.00002V12Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2A = [
    "color"
];
var $e781b76dcad7c5d5$export$13a4588734565757 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2A);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.5 0.0032959C6.80473 0.0032959 6.24953 0.281106 6.25 0.749995C6.25 0.997258 6.42446 1.12014 6.57687 1.22749C6.69507 1.31074 6.8 1.38465 6.8 1.5C6.8 1.7071 6.06224 1.74264 5.19789 1.78427C3.97553 1.84314 2.5 1.91421 2.5 2.5C2.5 2.77614 2.72386 3 3 3H12C12.2761 3 12.5 2.77614 12.5 2.5C12.5 1.91421 11.0245 1.84314 9.80211 1.78427C8.93776 1.74264 8.2 1.7071 8.2 1.5C8.2 1.38465 8.30493 1.31074 8.42313 1.22749C8.57554 1.12014 8.75 0.997258 8.75 0.749995C8.75047 0.281106 8.19527 0.0032959 7.5 0.0032959ZM2.89451 6.12266C2.25806 6.52471 1.90417 7.31118 2.02473 8.0556L2.83588 12.4772C3.00993 13.3562 3.7629 14 4.66061 14H10.3373C11.2354 14 11.9884 13.3562 12.1625 12.4772L12.9736 8.05607C13.089 7.32358 12.8284 6.53276 12.1331 6.09373C11.7283 5.83013 11.6412 5.33231 12.1331 5.12796C12.8284 4.86435 12.6948 4 12 4H10.3001H6.80005H2.99996C2.30469 4 2.19878 4.89328 2.89451 5.15689C3.38642 5.33231 3.29939 5.83013 2.89451 6.12266ZM8.20006 6.25C8.20006 5.81769 8.08572 5.37615 7.90635 5L4.11093 5C4.20626 5.21312 4.2419 5.43889 4.22904 5.65521C4.19522 6.22412 3.84587 6.66899 3.48016 6.93322L3.45492 6.95146L3.42858 6.9681C3.13407 7.15414 2.95801 7.53989 3.01058 7.88749L3.81797 12.2886C3.90513 12.7154 4.26148 13 4.66061 13H10.3373C10.737 13 11.0932 12.7153 11.1804 12.2886L11.9874 7.8898C12.048 7.48247 11.8954 7.12631 11.5992 6.93927L11.5875 6.93184L11.5875 6.93176C11.1947 6.67602 10.8331 6.22785 10.7986 5.64798C10.7846 5.412 10.8264 5.19397 10.9112 5H9.05517C9.01987 5.14611 9.00006 5.31201 9.00006 5.5C9.00006 5.9745 9.21679 6.37127 9.44367 6.78662C9.69284 7.24278 9.95425 7.72136 9.95425 8.34993C9.95425 9.2698 9.49868 9.84205 8.62189 9.84205C8.13206 9.84205 7.57818 9.46097 7.57818 8.75781C7.57818 8.35279 7.71558 8.01646 7.86121 7.65998C8.0254 7.25806 8.20006 6.83051 8.20006 6.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2B = [
    "color"
];
var $e781b76dcad7c5d5$export$583b57cdbe59a84e = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2B);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M14 11.0001V4.00006L1 4.00006L1 11.0001H14ZM15 4.00006V11.0001C15 11.5523 14.5523 12.0001 14 12.0001H1C0.447715 12.0001 0 11.5523 0 11.0001V4.00006C0 3.44778 0.447715 3.00006 1 3.00006H14C14.5523 3.00006 15 3.44778 15 4.00006ZM2 5.25C2 5.11193 2.11193 5 2.25 5H5.75C5.88807 5 6 5.11193 6 5.25V9.75C6 9.88807 5.88807 10 5.75 10H2.25C2.11193 10 2 9.88807 2 9.75V5.25ZM7.5 7C7.22386 7 7 7.22386 7 7.5C7 7.77614 7.22386 8 7.5 8H10.5C10.7761 8 11 7.77614 11 7.5C11 7.22386 10.7761 7 10.5 7H7.5ZM7 9.5C7 9.22386 7.22386 9 7.5 9H12.5C12.7761 9 13 9.22386 13 9.5C13 9.77614 12.7761 10 12.5 10H7.5C7.22386 10 7 9.77614 7 9.5ZM7.5 5C7.22386 5 7 5.22386 7 5.5C7 5.77614 7.22386 6 7.5 6H11.5C11.7761 6 12 5.77614 12 5.5C12 5.22386 11.7761 5 11.5 5H7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2C = [
    "color"
];
var $e781b76dcad7c5d5$export$4a122bafaa48b23d = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2C);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M2.5 1H12.5C13.3284 1 14 1.67157 14 2.5V12.5C14 13.3284 13.3284 14 12.5 14H2.5C1.67157 14 1 13.3284 1 12.5V2.5C1 1.67157 1.67157 1 2.5 1ZM2.5 2C2.22386 2 2 2.22386 2 2.5V8.3636L3.6818 6.6818C3.76809 6.59551 3.88572 6.54797 4.00774 6.55007C4.12975 6.55216 4.24568 6.60372 4.32895 6.69293L7.87355 10.4901L10.6818 7.6818C10.8575 7.50607 11.1425 7.50607 11.3182 7.6818L13 9.3636V2.5C13 2.22386 12.7761 2 12.5 2H2.5ZM2 12.5V9.6364L3.98887 7.64753L7.5311 11.4421L8.94113 13H2.5C2.22386 13 2 12.7761 2 12.5ZM12.5 13H10.155L8.48336 11.153L11 8.6364L13 10.6364V12.5C13 12.7761 12.7761 13 12.5 13ZM6.64922 5.5C6.64922 5.03013 7.03013 4.64922 7.5 4.64922C7.96987 4.64922 8.35078 5.03013 8.35078 5.5C8.35078 5.96987 7.96987 6.35078 7.5 6.35078C7.03013 6.35078 6.64922 5.96987 6.64922 5.5ZM7.5 3.74922C6.53307 3.74922 5.74922 4.53307 5.74922 5.5C5.74922 6.46693 6.53307 7.25078 7.5 7.25078C8.46693 7.25078 9.25078 6.46693 9.25078 5.5C9.25078 4.53307 8.46693 3.74922 7.5 3.74922Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2D = [
    "color"
];
var $e781b76dcad7c5d5$export$7a1b52edf33ca2d9 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2D);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82707 7.49972C1.82707 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82707 10.6327 1.82707 7.49972ZM8.24992 4.49999C8.24992 4.9142 7.91413 5.24999 7.49992 5.24999C7.08571 5.24999 6.74992 4.9142 6.74992 4.49999C6.74992 4.08577 7.08571 3.74999 7.49992 3.74999C7.91413 3.74999 8.24992 4.08577 8.24992 4.49999ZM6.00003 5.99999H6.50003H7.50003C7.77618 5.99999 8.00003 6.22384 8.00003 6.49999V9.99999H8.50003H9.00003V11H8.50003H7.50003H6.50003H6.00003V9.99999H6.50003H7.00003V6.99999H6.50003H6.00003V5.99999Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2E = [
    "color"
];
var $e781b76dcad7c5d5$export$f8fea9f50a4bfae6 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2E);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M6.5 1C6.22386 1 6 1.22386 6 1.5C6 1.77614 6.22386 2 6.5 2C7.12671 2 7.45718 2.20028 7.65563 2.47812C7.8781 2.78957 8 3.28837 8 4V11C8 11.7116 7.8781 12.2104 7.65563 12.5219C7.45718 12.7997 7.12671 13 6.5 13C6.22386 13 6 13.2239 6 13.5C6 13.7761 6.22386 14 6.5 14C7.37329 14 8.04282 13.7003 8.46937 13.1031C8.47976 13.0886 8.48997 13.0739 8.5 13.0591C8.51003 13.0739 8.52024 13.0886 8.53063 13.1031C8.95718 13.7003 9.62671 14 10.5 14C10.7761 14 11 13.7761 11 13.5C11 13.2239 10.7761 13 10.5 13C9.87329 13 9.54282 12.7997 9.34437 12.5219C9.1219 12.2104 9 11.7116 9 11V4C9 3.28837 9.1219 2.78957 9.34437 2.47812C9.54282 2.20028 9.87329 2 10.5 2C10.7761 2 11 1.77614 11 1.5C11 1.22386 10.7761 1 10.5 1C9.62671 1 8.95718 1.29972 8.53063 1.89688C8.52024 1.91143 8.51003 1.92611 8.5 1.9409C8.48997 1.92611 8.47976 1.91143 8.46937 1.89688C8.04282 1.29972 7.37329 1 6.5 1ZM14 5H11V4H14C14.5523 4 15 4.44772 15 5V10C15 10.5523 14.5523 11 14 11H11V10H14V5ZM6 4V5H1L1 10H6V11H1C0.447715 11 0 10.5523 0 10V5C0 4.44772 0.447715 4 1 4H6Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2F = [
    "color"
];
var $e781b76dcad7c5d5$export$632f10cfe13035ff = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2F);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.9091 12.909C13.2365 12.5817 13.4918 12.1895 13.6588 11.7577C13.8195 11.3443 13.9294 10.8718 13.961 10.1799C13.9926 9.48665 14.0001 9.26529 14.0001 7.50001C14.0001 5.73473 13.9926 5.51328 13.961 4.82008C13.9294 4.12821 13.8195 3.65573 13.6588 3.24228C13.4956 2.80857 13.2398 2.41567 12.9091 2.091C12.5844 1.76028 12.1915 1.50437 11.7578 1.34113C11.3443 1.18056 10.8718 1.0707 10.1799 1.03924C9.48675 1.00748 9.26537 1 7.50006 1C5.73476 1 5.51333 1.00748 4.82014 1.03912C4.12826 1.0707 3.65578 1.18056 3.24233 1.34125C2.80862 1.50447 2.41573 1.76032 2.09105 2.09098C1.76032 2.41563 1.5044 2.80852 1.34113 3.24225C1.18056 3.65573 1.0707 4.12821 1.03924 4.82008C1.00748 5.51328 1 5.73471 1 7.50001C1 9.26532 1.00748 9.48675 1.03924 10.1799C1.07083 10.8718 1.18069 11.3443 1.34138 11.7577C1.5046 12.1915 1.76045 12.5843 2.09111 12.909C2.41578 13.2397 2.80867 13.4955 3.24238 13.6587C3.65586 13.8194 4.12834 13.9293 4.82019 13.9609C5.51348 13.9925 5.73483 14 7.50012 14C9.2654 14 9.48685 13.9925 10.18 13.9609C10.8719 13.9293 11.3444 13.8194 11.7578 13.6587C12.1896 13.4917 12.5818 13.2364 12.9091 12.909ZM1.99949 6.73496C1.99974 6.94524 2.00005 7.19543 2.00005 7.50002C2.00005 7.80461 1.99974 8.0548 1.99949 8.26507C1.99849 9.08596 1.99824 9.29856 2.01963 9.7655C2.04625 10.3509 2.07823 10.7811 2.17588 11.1053C2.26976 11.417 2.37505 11.7342 2.7188 12.1171C3.06255 12.4999 3.39411 12.6733 3.81645 12.8007C4.23879 12.928 4.7696 12.9554 5.23052 12.9764C5.75332 13.0003 5.96052 13.0002 7.05714 12.9999L7.50006 12.9999C7.79304 12.9999 8.03569 13.0001 8.2409 13.0004C9.08195 13.0013 9.29425 13.0015 9.76575 12.9799C10.3512 12.9533 10.7814 12.9213 11.1056 12.8237C11.4173 12.7298 11.7345 12.6245 12.1173 12.2807C12.5001 11.937 12.6735 11.6054 12.8009 11.1831C12.9283 10.7607 12.9557 10.2299 12.9767 9.76902C13.0005 9.24689 13.0004 9.04027 13.0002 7.94749V7.94738L13.0001 7.50039L13.0001 7.05747C13.0004 5.96085 13.0005 5.75365 12.9766 5.23085C12.9556 4.76993 12.9282 4.23912 12.8009 3.81678C12.6735 3.39445 12.5001 3.06288 12.1173 2.71913C11.7345 2.37538 11.4172 2.27009 11.1056 2.17621C10.7813 2.07856 10.3511 2.04658 9.76571 2.01996C9.29421 1.99836 9.08194 1.99859 8.24092 1.99951H8.24092C8.0357 1.99974 7.79305 2.00001 7.50006 2.00001L7.05704 1.99993C5.96051 1.99964 5.75331 1.99958 5.23052 2.02343C4.7696 2.04446 4.23879 2.07183 3.81645 2.19921C3.39411 2.32659 3.06255 2.49999 2.7188 2.88281C2.37505 3.26562 2.26976 3.58286 2.17588 3.89453C2.07823 4.21874 2.04625 4.64894 2.01963 5.23437C1.99824 5.70131 1.99849 5.91401 1.99949 6.73496ZM7.49996 5.25015C6.25741 5.25015 5.25012 6.25744 5.25012 7.49999C5.25012 8.74254 6.25741 9.74983 7.49996 9.74983C8.74251 9.74983 9.7498 8.74254 9.7498 7.49999C9.7498 6.25744 8.74251 5.25015 7.49996 5.25015ZM4.25012 7.49999C4.25012 5.70515 5.70512 4.25015 7.49996 4.25015C9.2948 4.25015 10.7498 5.70515 10.7498 7.49999C10.7498 9.29483 9.2948 10.7498 7.49996 10.7498C5.70512 10.7498 4.25012 9.29483 4.25012 7.49999ZM10.9697 4.7803C11.3839 4.7803 11.7197 4.44452 11.7197 4.0303C11.7197 3.61609 11.3839 3.2803 10.9697 3.2803C10.5555 3.2803 10.2197 3.61609 10.2197 4.0303C10.2197 4.44452 10.5555 4.7803 10.9697 4.7803Z",
        fill: color
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2G = [
    "color"
];
var $e781b76dcad7c5d5$export$97dac707ecee26f6 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2G);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.5 4H1.5C1.22386 4 1 4.22386 1 4.5V10.5C1 10.7761 1.22386 11 1.5 11H13.5C13.7761 11 14 10.7761 14 10.5V4.5C14 4.22386 13.7761 4 13.5 4ZM1.5 3C0.671573 3 0 3.67157 0 4.5V10.5C0 11.3284 0.671573 12 1.5 12H13.5C14.3284 12 15 11.3284 15 10.5V4.5C15 3.67157 14.3284 3 13.5 3H1.5ZM2 5H3V6H2V5ZM5 5H4V6H5V5ZM6 5H7V6H6V5ZM9 5H8V6H9V5ZM10 5H11V6H10V5ZM13 5H12V6H13V5ZM11 7H12V8H11V7ZM13 9H12V10H13V9ZM9 7H10V8H9V7ZM8 7H7V8H8V7ZM5 7H6V8H5V7ZM4 7H3V8H4V7ZM2 9H3V10H2V9ZM11 9H4V10H11V9Z",
        fill: color
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2H = [
    "color"
];
var $e781b76dcad7c5d5$export$73ea89eab1c37fa2 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2H);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M5.49998 0.5C5.49998 0.223858 5.72383 0 5.99998 0H7.49998H8.99998C9.27612 0 9.49998 0.223858 9.49998 0.5C9.49998 0.776142 9.27612 1 8.99998 1H7.99998V2.11922C9.09832 2.20409 10.119 2.56622 10.992 3.13572C11.0116 3.10851 11.0336 3.08252 11.058 3.05806L12.058 2.05806C12.3021 1.81398 12.6978 1.81398 12.9419 2.05806C13.186 2.30214 13.186 2.69786 12.9419 2.94194L11.967 3.91682C13.1595 5.07925 13.9 6.70314 13.9 8.49998C13.9 12.0346 11.0346 14.9 7.49998 14.9C3.96535 14.9 1.09998 12.0346 1.09998 8.49998C1.09998 5.13361 3.69904 2.3743 6.99998 2.11922V1H5.99998C5.72383 1 5.49998 0.776142 5.49998 0.5ZM2.09998 8.49998C2.09998 5.51764 4.51764 3.09998 7.49998 3.09998C10.4823 3.09998 12.9 5.51764 12.9 8.49998C12.9 11.4823 10.4823 13.9 7.49998 13.9C4.51764 13.9 2.09998 11.4823 2.09998 8.49998ZM7.49998 8.49998V4.09998C5.06992 4.09998 3.09998 6.06992 3.09998 8.49998C3.09998 10.93 5.06992 12.9 7.49998 12.9C8.715 12.9 9.815 12.4075 10.6112 11.6112L7.49998 8.49998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2I = [
    "color"
];
var $e781b76dcad7c5d5$export$b94473071ddf9fbf = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2I);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M2 4.25C2 4.11193 2.11193 4 2.25 4H12.75C12.8881 4 13 4.11193 13 4.25V11.5H2V4.25ZM2.25 3C1.55964 3 1 3.55964 1 4.25V12H0V12.5C0 12.7761 0.223858 13 0.5 13H14.5C14.7761 13 15 12.7761 15 12.5V12H14V4.25C14 3.55964 13.4404 3 12.75 3H2.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2J = [
    "color"
];
var $e781b76dcad7c5d5$export$a00948e6c38bedc8 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2J);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.75432 0.819537C7.59742 0.726821 7.4025 0.726821 7.24559 0.819537L1.74559 4.06954C1.59336 4.15949 1.49996 4.32317 1.49996 4.5C1.49996 4.67683 1.59336 4.84051 1.74559 4.93046L7.24559 8.18046C7.4025 8.27318 7.59742 8.27318 7.75432 8.18046L13.2543 4.93046C13.4066 4.84051 13.5 4.67683 13.5 4.5C13.5 4.32317 13.4066 4.15949 13.2543 4.06954L7.75432 0.819537ZM7.49996 7.16923L2.9828 4.5L7.49996 1.83077L12.0171 4.5L7.49996 7.16923ZM1.5695 7.49564C1.70998 7.2579 2.01659 7.17906 2.25432 7.31954L7.49996 10.4192L12.7456 7.31954C12.9833 7.17906 13.2899 7.2579 13.4304 7.49564C13.5709 7.73337 13.4921 8.03998 13.2543 8.18046L7.75432 11.4305C7.59742 11.5232 7.4025 11.5232 7.24559 11.4305L1.74559 8.18046C1.50786 8.03998 1.42901 7.73337 1.5695 7.49564ZM1.56949 10.4956C1.70998 10.2579 2.01658 10.1791 2.25432 10.3195L7.49996 13.4192L12.7456 10.3195C12.9833 10.1791 13.2899 10.2579 13.4304 10.4956C13.5709 10.7334 13.4921 11.04 13.2543 11.1805L7.75432 14.4305C7.59742 14.5232 7.4025 14.5232 7.24559 14.4305L1.74559 11.1805C1.50785 11.04 1.42901 10.7334 1.56949 10.4956Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2K = [
    "color"
];
var $e781b76dcad7c5d5$export$b5c6e0b0c099878a = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2K);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M9 2H6V13H9V2ZM10 2V13H12.5C12.7761 13 13 12.7761 13 12.5V2.5C13 2.22386 12.7761 2 12.5 2H10ZM2.5 2H5V13H2.5C2.22386 13 2 12.7761 2 12.5V2.5C2 2.22386 2.22386 2 2.5 2ZM2.5 1C1.67157 1 1 1.67157 1 2.5V12.5C1 13.3284 1.67157 14 2.5 14H12.5C13.3284 14 14 13.3284 14 12.5V2.5C14 1.67157 13.3284 1 12.5 1H2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2L = [
    "color"
];
var $e781b76dcad7c5d5$export$2d8928fe752eaf76 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2L);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M3.68979 2.75C3.89667 2.74979 4.08232 2.87701 4.15679 3.07003L7.36662 11.39C7.46602 11.6477 7.33774 11.9371 7.0801 12.0365C6.82247 12.1359 6.53304 12.0076 6.43365 11.75L5.3825 9.02537H2.01133L0.966992 11.749C0.868128 12.0068 0.578964 12.1357 0.321126 12.0369C0.0632878 11.938 -0.0655864 11.6488 0.0332774 11.391L3.22344 3.07099C3.29751 2.87782 3.4829 2.75021 3.68979 2.75ZM3.69174 4.64284L5.05458 8.17537H2.33724L3.69174 4.64284ZM10.8989 5.20703C9.25818 5.20703 8.00915 6.68569 8.00915 8.60972C8.00915 10.6337 9.35818 12.0124 10.8989 12.0124C11.7214 12.0124 12.5744 11.6692 13.1543 11.0219V11.53C13.1543 11.7785 13.3557 11.98 13.6043 11.98C13.8528 11.98 14.0543 11.7785 14.0543 11.53V5.72C14.0543 5.47147 13.8528 5.27 13.6043 5.27C13.3557 5.27 13.1543 5.47147 13.1543 5.72V6.22317C12.6054 5.60095 11.7924 5.20703 10.8989 5.20703ZM13.1543 9.79823V7.30195C12.7639 6.58101 11.9414 6.05757 11.0868 6.05757C10.1088 6.05757 9.03503 6.96581 9.03503 8.60955C9.03503 10.1533 10.0088 11.1615 11.0868 11.1615C11.9701 11.1615 12.7719 10.4952 13.1543 9.79823Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2M = [
    "color"
];
var $e781b76dcad7c5d5$export$ba5807ad0c0f9980 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2M);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M3.69899 5.20703C2.05823 5.20703 0.809204 6.68569 0.809204 8.60972C0.809204 10.6337 2.15823 12.0124 3.69899 12.0124C4.52126 12.0124 5.37402 11.6693 5.9539 11.0223V11.53C5.9539 11.7785 6.15537 11.98 6.4039 11.98C6.65243 11.98 6.8539 11.7785 6.8539 11.53V5.72001C6.8539 5.47149 6.65243 5.27001 6.4039 5.27001C6.15537 5.27001 5.9539 5.47149 5.9539 5.72001V6.22269C5.40506 5.60075 4.59218 5.20703 3.69899 5.20703ZM5.9539 9.799V7.30117C5.56339 6.58064 4.74118 6.05757 3.8868 6.05757C2.9089 6.05757 1.83508 6.96581 1.83508 8.60955C1.83508 10.1533 2.80889 11.1615 3.8868 11.1615C4.76984 11.1615 5.57141 10.4957 5.9539 9.799ZM10.799 5.20703C9.15823 5.20703 7.9092 6.68569 7.9092 8.60972C7.9092 10.6337 9.25823 12.0124 10.799 12.0124C11.6215 12.0124 12.4744 11.6692 13.0543 11.0218V11.53C13.0543 11.7785 13.2558 11.98 13.5043 11.98C13.7529 11.98 13.9543 11.7785 13.9543 11.53V5.72C13.9543 5.47147 13.7529 5.27 13.5043 5.27C13.2558 5.27 13.0543 5.47147 13.0543 5.72V6.22318C12.5055 5.60095 11.6924 5.20703 10.799 5.20703ZM13.0543 9.79822V7.30196C12.664 6.58102 11.8415 6.05757 10.9868 6.05757C10.0089 6.05757 8.93508 6.96581 8.93508 8.60955C8.93508 10.1533 9.90889 11.1615 10.9868 11.1615C11.8702 11.1615 12.672 10.4952 13.0543 9.79822Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2N = [
    "color"
];
var $e781b76dcad7c5d5$export$7e8527e8d8b03e5e = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2N);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M11.2895 2.75C11.4964 2.74979 11.6821 2.87701 11.7565 3.07003L14.9664 11.39C15.0657 11.6477 14.9375 11.9371 14.6798 12.0365C14.4222 12.1359 14.1328 12.0076 14.0334 11.75L12.9822 9.02537H9.61106L8.56672 11.749C8.46786 12.0068 8.1787 12.1357 7.92086 12.0369C7.66302 11.938 7.53415 11.6488 7.63301 11.391L10.8232 3.07099C10.8972 2.87782 11.0826 2.75021 11.2895 2.75ZM11.2915 4.64284L12.6543 8.17537H9.93698L11.2915 4.64284ZM2.89895 5.20703C1.25818 5.20703 0.00915527 6.68569 0.00915527 8.60972C0.00915527 10.6337 1.35818 12.0124 2.89895 12.0124C3.72141 12.0124 4.57438 11.6692 5.15427 11.0219V11.53C5.15427 11.7785 5.35574 11.98 5.60427 11.98C5.8528 11.98 6.05427 11.7785 6.05427 11.53V5.72C6.05427 5.47147 5.8528 5.27 5.60427 5.27C5.35574 5.27 5.15427 5.47147 5.15427 5.72V6.22317C4.60543 5.60095 3.79236 5.20703 2.89895 5.20703ZM5.15427 9.79823V7.30195C4.76393 6.58101 3.94144 6.05757 3.08675 6.05757C2.10885 6.05757 1.03503 6.96581 1.03503 8.60955C1.03503 10.1533 2.00885 11.1615 3.08675 11.1615C3.97011 11.1615 4.77195 10.4952 5.15427 9.79823Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2O = [
    "color"
];
var $e781b76dcad7c5d5$export$9395c236dc77b2d2 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2O);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M3.6255 2.75C3.83478 2.75 4.02192 2.88034 4.09448 3.07664L7.16985 11.3962C7.2656 11.6552 7.13324 11.9428 6.87423 12.0386C6.61522 12.1343 6.32763 12.002 6.23188 11.7429L5.22387 9.01603H2.02712L1.01911 11.7429C0.923362 12.002 0.635774 12.1343 0.376762 12.0386C0.117749 11.9428 -0.0146052 11.6552 0.0811401 11.3962L3.15651 3.07664C3.22908 2.88034 3.41621 2.75 3.6255 2.75ZM3.6255 4.69207L4.90966 8.16603H2.34133L3.6255 4.69207ZM11.3719 2.75C11.5811 2.75 11.7683 2.88034 11.8408 3.07664L14.9162 11.3962C15.012 11.6552 14.8796 11.9428 14.6206 12.0386C14.3616 12.1343 14.074 12.002 13.9782 11.7429L12.9702 9.01603H9.77348L8.76547 11.7429C8.66972 12.002 8.38213 12.1343 8.12312 12.0386C7.86411 11.9428 7.73175 11.6552 7.8275 11.3962L10.9029 3.07664C10.9754 2.88034 11.1626 2.75 11.3719 2.75ZM11.3719 4.69207L12.656 8.16603H10.0877L11.3719 4.69207Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2P = [
    "color"
];
var $e781b76dcad7c5d5$export$b5d24f94d82d9f2b = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2P);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M4.55293 0.999969C4.75295 0.999969 4.93372 1.11917 5.0125 1.30301L8.01106 8.29982C8.11984 8.55363 8.00226 8.84757 7.74844 8.95635C7.49463 9.06512 7.20069 8.94754 7.09191 8.69373L6.11613 6.41685H2.98973L2.01395 8.69373C1.90517 8.94754 1.61123 9.06512 1.35742 8.95635C1.1036 8.84757 0.986023 8.55363 1.0948 8.29982L4.09336 1.30301C4.17214 1.11917 4.35291 0.999969 4.55293 0.999969ZM4.55293 2.76929L5.75186 5.56685H3.354L4.55293 2.76929ZM11.0562 9.00214C11.2617 9.00214 11.4463 8.87633 11.5215 8.68502L14.2733 1.68299C14.3743 1.42598 14.2478 1.13575 13.9908 1.03475C13.7338 0.933747 13.4436 1.06021 13.3426 1.31722L11.0562 7.13514L8.76973 1.31722C8.66873 1.06021 8.3785 0.933747 8.1215 1.03475C7.86449 1.13575 7.73802 1.42598 7.83902 1.68299L10.5908 8.68502C10.666 8.87633 10.8506 9.00214 11.0562 9.00214ZM14.9537 12.4999C14.9537 12.606 14.9115 12.7077 14.8365 12.7828L12.8365 14.7828C12.6803 14.939 12.4271 14.939 12.2708 14.7828C12.1146 14.6265 12.1146 14.3733 12.2708 14.2171L13.588 12.8999H1.51937L2.83653 14.2171C2.99274 14.3733 2.99274 14.6265 2.83653 14.7828C2.68032 14.939 2.42705 14.939 2.27084 14.7828L0.270843 12.7828C0.195828 12.7077 0.153687 12.606 0.153687 12.4999C0.153687 12.3938 0.195828 12.2921 0.270843 12.2171L2.27084 10.2171C2.42705 10.0609 2.68032 10.0609 2.83653 10.2171C2.99274 10.3733 2.99274 10.6265 2.83653 10.7828L1.51937 12.0999L13.588 12.0999L12.2708 10.7828C12.1146 10.6265 12.1146 10.3733 12.2708 10.2171C12.4271 10.0609 12.6803 10.0609 12.8365 10.2171L14.8365 12.2171C14.9115 12.2921 14.9537 12.3938 14.9537 12.4999Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2Q = [
    "color"
];
var $e781b76dcad7c5d5$export$afee984ac0331725 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2Q);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M8.69667 0.0403541C8.90859 0.131038 9.03106 0.354857 8.99316 0.582235L8.0902 6.00001H12.5C12.6893 6.00001 12.8625 6.10701 12.9472 6.27641C13.0319 6.4458 13.0136 6.6485 12.8999 6.80001L6.89997 14.8C6.76167 14.9844 6.51521 15.0503 6.30328 14.9597C6.09135 14.869 5.96888 14.6452 6.00678 14.4178L6.90974 9H2.49999C2.31061 9 2.13748 8.893 2.05278 8.72361C1.96809 8.55422 1.98636 8.35151 2.09999 8.2L8.09997 0.200038C8.23828 0.0156255 8.48474 -0.0503301 8.69667 0.0403541ZM3.49999 8.00001H7.49997C7.64695 8.00001 7.78648 8.06467 7.88148 8.17682C7.97648 8.28896 8.01733 8.43723 7.99317 8.5822L7.33027 12.5596L11.5 7.00001H7.49997C7.353 7.00001 7.21347 6.93534 7.11846 6.8232C7.02346 6.71105 6.98261 6.56279 7.00678 6.41781L7.66968 2.44042L3.49999 8.00001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2R = [
    "color"
];
var $e781b76dcad7c5d5$export$9b61d117ad943959 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2R);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M3.78233 2.21713C3.70732 2.14212 3.60557 2.09998 3.49949 2.09998C3.3934 2.09998 3.29166 2.14212 3.21664 2.21713L1.21664 4.21713C1.06044 4.37334 1.06044 4.62661 1.21664 4.78282C1.37285 4.93903 1.62612 4.93903 1.78233 4.78282L3.09949 3.46566L3.09949 11.5343L1.78233 10.2171C1.62612 10.0609 1.37285 10.0609 1.21664 10.2171C1.06043 10.3733 1.06043 10.6266 1.21664 10.7828L3.21664 12.7828C3.29166 12.8578 3.3934 12.9 3.49949 12.9C3.60557 12.9 3.70731 12.8578 3.78233 12.7828L5.78233 10.7828C5.93854 10.6266 5.93854 10.3733 5.78233 10.2171C5.62612 10.0609 5.37285 10.0609 5.21664 10.2171L3.89949 11.5343L3.89949 3.46566L5.21664 4.78282C5.37285 4.93903 5.62612 4.93903 5.78233 4.78282C5.93854 4.62661 5.93854 4.37334 5.78233 4.21713L3.78233 2.21713ZM8.49998 3.99997C8.22383 3.99997 7.99998 4.22382 7.99998 4.49997C7.99998 4.77611 8.22383 4.99997 8.49998 4.99997H14.5C14.7761 4.99997 15 4.77611 15 4.49997C15 4.22382 14.7761 3.99997 14.5 3.99997H8.49998ZM7.99998 7.49997C7.99998 7.22382 8.22383 6.99997 8.49998 6.99997H14.5C14.7761 6.99997 15 7.22382 15 7.49997C15 7.77611 14.7761 7.99997 14.5 7.99997H8.49998C8.22383 7.99997 7.99998 7.77611 7.99998 7.49997ZM8.49998 9.99997C8.22383 9.99997 7.99998 10.2238 7.99998 10.5C7.99998 10.7761 8.22383 11 8.49998 11H14.5C14.7761 11 15 10.7761 15 10.5C15 10.2238 14.7761 9.99997 14.5 9.99997H8.49998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2S = [
    "color"
];
var $e781b76dcad7c5d5$export$c99cd348175308cb = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2S);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M4.62471 4.00001L4.56402 4.00001C4.04134 3.99993 3.70687 3.99988 3.4182 4.055C2.2379 4.28039 1.29846 5.17053 1.05815 6.33035C0.999538 6.61321 0.999604 6.93998 0.999703 7.43689L0.999711 7.50001L0.999703 7.56313C0.999604 8.06004 0.999538 8.38681 1.05815 8.66967C1.29846 9.8295 2.2379 10.7196 3.4182 10.945C3.70688 11.0001 4.04135 11.0001 4.56403 11L4.62471 11H5.49971C5.77585 11 5.99971 10.7762 5.99971 10.5C5.99971 10.2239 5.77585 10 5.49971 10H4.62471C4.02084 10 3.78907 9.99777 3.60577 9.96277C2.80262 9.8094 2.19157 9.21108 2.03735 8.46678C2.00233 8.29778 1.99971 8.08251 1.99971 7.50001C1.99971 6.91752 2.00233 6.70225 2.03735 6.53324C2.19157 5.78895 2.80262 5.19062 3.60577 5.03725C3.78907 5.00225 4.02084 5.00001 4.62471 5.00001H5.49971C5.77585 5.00001 5.99971 4.77615 5.99971 4.50001C5.99971 4.22387 5.77585 4.00001 5.49971 4.00001H4.62471ZM10.3747 5.00001C10.9786 5.00001 11.2104 5.00225 11.3937 5.03725C12.1968 5.19062 12.8079 5.78895 12.9621 6.53324C12.9971 6.70225 12.9997 6.91752 12.9997 7.50001C12.9997 8.08251 12.9971 8.29778 12.9621 8.46678C12.8079 9.21108 12.1968 9.8094 11.3937 9.96277C11.2104 9.99777 10.9786 10 10.3747 10H9.49971C9.22357 10 8.99971 10.2239 8.99971 10.5C8.99971 10.7762 9.22357 11 9.49971 11H10.3747L10.4354 11C10.9581 11.0001 11.2925 11.0001 11.5812 10.945C12.7615 10.7196 13.701 9.8295 13.9413 8.66967C13.9999 8.38681 13.9998 8.06005 13.9997 7.56314L13.9997 7.50001L13.9997 7.43688C13.9998 6.93998 13.9999 6.61321 13.9413 6.33035C13.701 5.17053 12.7615 4.28039 11.5812 4.055C11.2925 3.99988 10.9581 3.99993 10.4354 4.00001L10.3747 4.00001H9.49971C9.22357 4.00001 8.99971 4.22387 8.99971 4.50001C8.99971 4.77615 9.22357 5.00001 9.49971 5.00001H10.3747ZM5.00038 7C4.72424 7 4.50038 7.22386 4.50038 7.5C4.50038 7.77614 4.72424 8 5.00038 8H10.0004C10.2765 8 10.5004 7.77614 10.5004 7.5C10.5004 7.22386 10.2765 7 10.0004 7H5.00038Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2T = [
    "color"
];
var $e781b76dcad7c5d5$export$a0f93c0a3250ca9d = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2T);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M8.51194 3.00541C9.18829 2.54594 10.0435 2.53694 10.6788 2.95419C10.8231 3.04893 10.9771 3.1993 11.389 3.61119C11.8009 4.02307 11.9513 4.17714 12.046 4.32141C12.4633 4.95675 12.4543 5.81192 11.9948 6.48827C11.8899 6.64264 11.7276 6.80811 11.3006 7.23511L10.6819 7.85383C10.4867 8.04909 10.4867 8.36567 10.6819 8.56093C10.8772 8.7562 11.1938 8.7562 11.389 8.56093L12.0077 7.94221L12.0507 7.89929C12.4203 7.52976 12.6568 7.2933 12.822 7.0502C13.4972 6.05623 13.5321 4.76252 12.8819 3.77248C12.7233 3.53102 12.4922 3.30001 12.1408 2.94871L12.0961 2.90408L12.0515 2.85942C11.7002 2.508 11.4692 2.27689 11.2277 2.11832C10.2377 1.46813 8.94398 1.50299 7.95001 2.17822C7.70691 2.34336 7.47044 2.57991 7.1009 2.94955L7.058 2.99247L6.43928 3.61119C6.24401 3.80645 6.24401 4.12303 6.43928 4.31829C6.63454 4.51355 6.95112 4.51355 7.14638 4.31829L7.7651 3.69957C8.1921 3.27257 8.35757 3.11027 8.51194 3.00541ZM4.31796 7.14672C4.51322 6.95146 4.51322 6.63487 4.31796 6.43961C4.12269 6.24435 3.80611 6.24435 3.61085 6.43961L2.99213 7.05833L2.94922 7.10124C2.57957 7.47077 2.34303 7.70724 2.17788 7.95035C1.50265 8.94432 1.4678 10.238 2.11799 11.2281C2.27656 11.4695 2.50766 11.7005 2.8591 12.0518L2.90374 12.0965L2.94837 12.1411C3.29967 12.4925 3.53068 12.7237 3.77214 12.8822C4.76219 13.5324 6.05589 13.4976 7.04986 12.8223C7.29296 12.6572 7.52943 12.4206 7.89896 12.051L7.89897 12.051L7.94188 12.0081L8.5606 11.3894C8.75586 11.1941 8.75586 10.8775 8.5606 10.6823C8.36533 10.487 8.04875 10.487 7.85349 10.6823L7.23477 11.301C6.80777 11.728 6.6423 11.8903 6.48794 11.9951C5.81158 12.4546 4.95642 12.4636 4.32107 12.0464C4.17681 11.9516 4.02274 11.8012 3.61085 11.3894C3.19896 10.9775 3.0486 10.8234 2.95385 10.6791C2.53661 10.0438 2.54561 9.18863 3.00507 8.51227C3.10993 8.35791 3.27224 8.19244 3.69924 7.76544L4.31796 7.14672ZM9.62172 6.08558C9.81698 5.89032 9.81698 5.57373 9.62172 5.37847C9.42646 5.18321 9.10988 5.18321 8.91461 5.37847L5.37908 8.91401C5.18382 9.10927 5.18382 9.42585 5.37908 9.62111C5.57434 9.81637 5.89092 9.81637 6.08619 9.62111L9.62172 6.08558Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2U = [
    "color"
];
var $e781b76dcad7c5d5$export$c2a4804b810abd59 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2U);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M13.3536 2.35355C13.5488 2.15829 13.5488 1.84171 13.3536 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L1.64645 12.6464C1.45118 12.8417 1.45118 13.1583 1.64645 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L13.3536 2.35355ZM2.03735 8.46678C2.17398 9.12619 2.66918 9.67103 3.33886 9.89338L2.57833 10.6539C1.80843 10.2534 1.23784 9.53693 1.05815 8.66967C0.999538 8.38681 0.999604 8.06004 0.999703 7.56313L0.999711 7.50001L0.999703 7.43689C0.999604 6.93998 0.999538 6.61321 1.05815 6.33035C1.29846 5.17053 2.2379 4.28039 3.4182 4.055C3.70687 3.99988 4.04134 3.99993 4.56402 4.00001L4.62471 4.00001H5.49971C5.77585 4.00001 5.99971 4.22387 5.99971 4.50001C5.99971 4.77615 5.77585 5.00001 5.49971 5.00001H4.62471C4.02084 5.00001 3.78907 5.00225 3.60577 5.03725C2.80262 5.19062 2.19157 5.78895 2.03735 6.53324C2.00233 6.70225 1.99971 6.91752 1.99971 7.50001C1.99971 8.08251 2.00233 8.29778 2.03735 8.46678ZM12.9621 6.53324C12.8255 5.87397 12.3304 5.32922 11.661 5.10679L12.4215 4.34631C13.1912 4.74686 13.7616 5.46323 13.9413 6.33035C13.9999 6.61321 13.9998 6.93998 13.9997 7.43688L13.9997 7.50001L13.9997 7.56314C13.9998 8.06005 13.9999 8.38681 13.9413 8.66967C13.701 9.8295 12.7615 10.7196 11.5812 10.945C11.2925 11.0001 10.9581 11.0001 10.4354 11L10.3747 11H9.49971C9.22357 11 8.99971 10.7762 8.99971 10.5C8.99971 10.2239 9.22357 10 9.49971 10H10.3747C10.9786 10 11.2104 9.99777 11.3937 9.96277C12.1968 9.8094 12.8079 9.21108 12.9621 8.46678C12.9971 8.29778 12.9997 8.08251 12.9997 7.50001C12.9997 6.91752 12.9971 6.70225 12.9621 6.53324Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2V = [
    "color"
];
var $e781b76dcad7c5d5$export$c8d5b415f7d58ebc = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2V);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M4.50021 0C4.77635 0 5.0002 0.223853 5.0002 0.49999V2.49995C5.0002 2.77609 4.77635 2.99994 4.50021 2.99994C4.22408 2.99994 4.00022 2.77609 4.00022 2.49995V0.49999C4.00022 0.223853 4.22408 0 4.50021 0ZM0.646451 0.64647C0.84171 0.451212 1.15829 0.451212 1.35354 0.64647L2.85351 2.14644C3.04877 2.3417 3.04877 2.65827 2.85351 2.85353C2.65826 3.04879 2.34168 3.04879 2.14642 2.85353L0.646452 1.35356C0.451193 1.1583 0.451193 0.841728 0.646451 0.64647ZM0.00030517 4.49991C0.00030517 4.22377 0.224158 3.99992 0.500295 3.99992H2.50025C2.77639 3.99992 3.00024 4.22377 3.00024 4.49991C3.00024 4.77605 2.77639 4.9999 2.50025 4.9999H0.500295C0.224158 4.9999 0.00030517 4.77605 0.00030517 4.49991ZM12.0001 10.4998C12.0001 10.2236 12.2239 9.9998 12.5001 9.9998H14.5C14.7761 9.9998 15 10.2236 15 10.4998C15 10.7759 14.7761 10.9998 14.5 10.9998H12.5001C12.2239 10.9998 12.0001 10.7759 12.0001 10.4998ZM10.5001 11.9998C10.7762 11.9998 11.0001 12.2236 11.0001 12.4997V14.4997C11.0001 14.7758 10.7762 14.9997 10.5001 14.9997C10.224 14.9997 10.0001 14.7758 10.0001 14.4997V12.4997C10.0001 12.2236 10.224 11.9998 10.5001 11.9998ZM12.1462 12.1462C12.3415 11.951 12.658 11.951 12.8533 12.1462L14.3533 13.6462C14.5485 13.8415 14.5485 14.158 14.3533 14.3533C14.158 14.5485 13.8414 14.5485 13.6462 14.3533L12.1462 12.8533C11.951 12.6581 11.951 12.3415 12.1462 12.1462ZM7.76478 3.69938C8.19177 3.27238 8.35724 3.11008 8.5116 3.00522C9.18794 2.54577 10.0431 2.53677 10.6784 2.95401C10.8227 3.04875 10.9767 3.19911 11.3886 3.61099C11.8005 4.02287 11.9509 4.17694 12.0456 4.3212C12.4628 4.95653 12.4539 5.81168 11.9944 6.48802C11.8895 6.64238 11.7272 6.80785 11.3002 7.23484L10.6815 7.85354C10.4863 8.0488 10.4863 8.36538 10.6815 8.56064C10.8768 8.75589 11.1934 8.75589 11.3886 8.56064L12.0073 7.94193L12.0502 7.89903C12.4199 7.5295 12.6564 7.29303 12.8216 7.04993C13.4968 6.05598 13.5316 4.7623 12.8815 3.77228C12.7229 3.53083 12.4918 3.29982 12.1404 2.94853L12.0957 2.9039L12.0511 2.85925C11.6998 2.50782 11.4688 2.27672 11.2273 2.11816C10.2373 1.46798 8.94364 1.50284 7.94968 2.17805C7.70659 2.34319 7.47012 2.57973 7.1006 2.94936L7.1006 2.94937L7.05769 2.99228L6.43898 3.61099C6.24372 3.80625 6.24372 4.12282 6.43898 4.31808C6.63424 4.51334 6.95081 4.51334 7.14607 4.31808L7.76478 3.69938ZM2.99191 7.05807L2.94899 7.10097C2.57935 7.4705 2.34282 7.70697 2.17767 7.95006C1.50246 8.94401 1.4676 10.2377 2.11778 11.2277C2.27634 11.4692 2.50744 11.7002 2.85886 12.0515L2.85888 12.0515L2.90352 12.0961L2.94815 12.1407L2.94815 12.1407L2.94817 12.1408C3.29945 12.4922 3.53045 12.7233 3.7719 12.8818C4.76193 13.532 6.0556 13.4972 7.04956 12.8219C7.29265 12.6568 7.52912 12.4203 7.89865 12.0506L7.94155 12.0077L8.56026 11.389C8.75552 11.1937 8.75552 10.8772 8.56026 10.6819C8.365 10.4867 8.04842 10.4867 7.85317 10.6819L7.23446 11.3006C6.80747 11.7276 6.642 11.8899 6.48764 11.9948C5.8113 12.4542 4.95615 12.4632 4.32082 12.046C4.17656 11.9512 4.02249 11.8009 3.61061 11.389C3.19873 10.9771 3.04837 10.8231 2.95363 10.6788C2.53639 10.0435 2.54539 9.18832 3.00484 8.51198C3.10971 8.35761 3.27201 8.19215 3.699 7.76516L4.3177 7.14645C4.51296 6.95119 4.51296 6.63462 4.3177 6.43936C4.12245 6.2441 3.80587 6.2441 3.61061 6.43936L2.99191 7.05807Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2W = [
    "color"
];
var $e781b76dcad7c5d5$export$928cb2cfdd1b2e72 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2W);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M4.56427 3.99988C4.58422 3.99989 4.60445 3.99989 4.62496 3.99989H5.49996C5.7761 3.99989 5.99996 4.22375 5.99996 4.49989C5.99996 4.77603 5.7761 4.99989 5.49996 4.99989H4.62496C4.02108 4.99989 3.78932 5.00213 3.60601 5.03713C2.80287 5.1905 2.19181 5.78883 2.03759 6.53312C2.00257 6.70212 1.99996 6.91739 1.99996 7.49989C1.99996 8.08239 2.00257 8.29766 2.03759 8.46666C2.19181 9.21095 2.80287 9.80928 3.60601 9.96265C3.78932 9.99765 4.02108 9.99989 4.62496 9.99989H5.49996C5.7761 9.99989 5.99996 10.2237 5.99996 10.4999C5.99996 10.776 5.7761 10.9999 5.49996 10.9999H4.62496C4.60445 10.9999 4.58422 10.9999 4.56427 10.9999C4.04159 11 3.70712 11 3.41845 10.9449C2.23814 10.7195 1.29871 9.82937 1.05839 8.66955C0.999782 8.38669 0.999848 8.05992 0.999947 7.56301C0.999951 7.54227 0.999955 7.52123 0.999955 7.49989C0.999955 7.47855 0.999951 7.45751 0.999947 7.43677C0.999848 6.93986 0.999782 6.61309 1.05839 6.33023C1.29871 5.17041 2.23814 4.28027 3.41845 4.05488C3.70712 3.99976 4.04159 3.99981 4.56427 3.99988ZM11.3939 5.03713C11.2106 5.00213 10.9788 4.99989 10.375 4.99989H9.49996C9.22381 4.99989 8.99996 4.77603 8.99996 4.49989C8.99996 4.22375 9.22381 3.99989 9.49996 3.99989H10.375C10.3955 3.99989 10.4157 3.99989 10.4356 3.99988C10.9583 3.99981 11.2928 3.99976 11.5815 4.05488C12.7618 4.28027 13.7012 5.17041 13.9415 6.33023C14.0001 6.61309 14.0001 6.93985 14 7.43676C14 7.4575 14 7.47854 14 7.49989C14 7.52124 14 7.54228 14 7.56302C14.0001 8.05992 14.0001 8.38669 13.9415 8.66955C13.7012 9.82937 12.7618 10.7195 11.5815 10.9449C11.2928 11 10.9583 11 10.4356 10.9999C10.4157 10.9999 10.3955 10.9999 10.375 10.9999H9.49996C9.22381 10.9999 8.99996 10.776 8.99996 10.4999C8.99996 10.2237 9.22381 9.99989 9.49996 9.99989H10.375C10.9788 9.99989 11.2106 9.99765 11.3939 9.96265C12.197 9.80928 12.8081 9.21095 12.9623 8.46666C12.9973 8.29766 13 8.08239 13 7.49989C13 6.91739 12.9973 6.70212 12.9623 6.53312C12.8081 5.78883 12.197 5.1905 11.3939 5.03713Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2X = [
    "color"
];
var $e781b76dcad7c5d5$export$36a31df0698e942 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2X);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M10.6788 2.95419C10.0435 2.53694 9.18829 2.54594 8.51194 3.00541C8.35757 3.11027 8.1921 3.27257 7.7651 3.69957L7.14638 4.31829C6.95112 4.51355 6.63454 4.51355 6.43928 4.31829C6.24401 4.12303 6.24401 3.80645 6.43928 3.61119L7.058 2.99247C7.0725 2.97797 7.08679 2.96366 7.1009 2.94955C7.47044 2.57991 7.70691 2.34336 7.95001 2.17822C8.94398 1.50299 10.2377 1.46813 11.2277 2.11832C11.4692 2.27689 11.7002 2.508 12.0515 2.85942C12.0662 2.8741 12.081 2.88898 12.0961 2.90408C12.1112 2.91917 12.1261 2.93405 12.1408 2.94871C12.4922 3.30001 12.7233 3.53102 12.8819 3.77248C13.5321 4.76252 13.4972 6.05623 12.822 7.0502C12.6568 7.2933 12.4203 7.52976 12.0507 7.89929C12.0366 7.9134 12.0222 7.92771 12.0077 7.94221L11.389 8.56093C11.1938 8.7562 10.8772 8.7562 10.6819 8.56093C10.4867 8.36567 10.4867 8.04909 10.6819 7.85383L11.3006 7.23511C11.7276 6.80811 11.8899 6.64264 11.9948 6.48827C12.4543 5.81192 12.4633 4.95675 12.046 4.32141C11.9513 4.17714 11.8009 4.02307 11.389 3.61119C10.9771 3.1993 10.8231 3.04893 10.6788 2.95419ZM4.31796 6.43961C4.51322 6.63487 4.51322 6.95146 4.31796 7.14672L3.69924 7.76544C3.27224 8.19244 3.10993 8.35791 3.00507 8.51227C2.54561 9.18863 2.53661 10.0438 2.95385 10.6791C3.0486 10.8234 3.19896 10.9775 3.61085 11.3894C4.02274 11.8012 4.17681 11.9516 4.32107 12.0464C4.95642 12.4636 5.81158 12.4546 6.48794 11.9951C6.6423 11.8903 6.80777 11.728 7.23477 11.301L7.85349 10.6823C8.04875 10.487 8.36533 10.487 8.5606 10.6823C8.75586 10.8775 8.75586 11.1941 8.5606 11.3894L7.94188 12.0081C7.92738 12.0226 7.91307 12.0369 7.89897 12.051C7.52943 12.4206 7.29296 12.6572 7.04986 12.8223C6.05589 13.4976 4.76219 13.5324 3.77214 12.8822C3.53068 12.7237 3.29967 12.4925 2.94837 12.1411C2.93371 12.1264 2.91883 12.1116 2.90374 12.0965C2.88865 12.0814 2.87377 12.0665 2.8591 12.0518C2.50766 11.7005 2.27656 11.4695 2.11799 11.2281C1.4678 10.238 1.50265 8.94432 2.17788 7.95035C2.34303 7.70724 2.57957 7.47077 2.94922 7.10124C2.96333 7.08713 2.97763 7.07283 2.99213 7.05833L3.61085 6.43961C3.80611 6.24435 4.12269 6.24435 4.31796 6.43961Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2Y = [
    "color"
];
var $e781b76dcad7c5d5$export$8ec07838913349db = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2Y);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M2 1C1.44772 1 1 1.44772 1 2V13C1 13.5523 1.44772 14 2 14H13C13.5523 14 14 13.5523 14 13V2C14 1.44772 13.5523 1 13 1H2ZM3.05 6H4.95V12H3.05V6ZM5.075 4.005C5.075 4.59871 4.59371 5.08 4 5.08C3.4063 5.08 2.925 4.59871 2.925 4.005C2.925 3.41129 3.4063 2.93 4 2.93C4.59371 2.93 5.075 3.41129 5.075 4.005ZM12 8.35713C12 6.55208 10.8334 5.85033 9.67449 5.85033C9.29502 5.83163 8.91721 5.91119 8.57874 6.08107C8.32172 6.21007 8.05265 6.50523 7.84516 7.01853H7.79179V6.00044H6V12.0047H7.90616V8.8112C7.8786 8.48413 7.98327 8.06142 8.19741 7.80987C8.41156 7.55832 8.71789 7.49825 8.95015 7.46774H9.02258C9.62874 7.46774 10.0786 7.84301 10.0786 8.78868V12.0047H11.9847L12 8.35713Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2Z = [
    "color"
];
var $e781b76dcad7c5d5$export$9b1a2d77017d0edb = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2Z);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M1.5 5.25C1.91421 5.25 2.25 4.91421 2.25 4.5C2.25 4.08579 1.91421 3.75 1.5 3.75C1.08579 3.75 0.75 4.08579 0.75 4.5C0.75 4.91421 1.08579 5.25 1.5 5.25ZM4 4.5C4 4.22386 4.22386 4 4.5 4H13.5C13.7761 4 14 4.22386 14 4.5C14 4.77614 13.7761 5 13.5 5H4.5C4.22386 5 4 4.77614 4 4.5ZM4.5 7C4.22386 7 4 7.22386 4 7.5C4 7.77614 4.22386 8 4.5 8H13.5C13.7761 8 14 7.77614 14 7.5C14 7.22386 13.7761 7 13.5 7H4.5ZM4.5 10C4.22386 10 4 10.2239 4 10.5C4 10.7761 4.22386 11 4.5 11H13.5C13.7761 11 14 10.7761 14 10.5C14 10.2239 13.7761 10 13.5 10H4.5ZM2.25 7.5C2.25 7.91421 1.91421 8.25 1.5 8.25C1.08579 8.25 0.75 7.91421 0.75 7.5C0.75 7.08579 1.08579 6.75 1.5 6.75C1.91421 6.75 2.25 7.08579 2.25 7.5ZM1.5 11.25C1.91421 11.25 2.25 10.9142 2.25 10.5C2.25 10.0858 1.91421 9.75 1.5 9.75C1.08579 9.75 0.75 10.0858 0.75 10.5C0.75 10.9142 1.08579 11.25 1.5 11.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2_ = [
    "color"
];
var $e781b76dcad7c5d5$export$f53936b98653a113 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2_);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M5 4.63601C5 3.76031 5.24219 3.1054 5.64323 2.67357C6.03934 2.24705 6.64582 1.9783 7.5014 1.9783C8.35745 1.9783 8.96306 2.24652 9.35823 2.67208C9.75838 3.10299 10 3.75708 10 4.63325V5.99999H5V4.63601ZM4 5.99999V4.63601C4 3.58148 4.29339 2.65754 4.91049 1.99307C5.53252 1.32329 6.42675 0.978302 7.5014 0.978302C8.57583 0.978302 9.46952 1.32233 10.091 1.99162C10.7076 2.65557 11 3.57896 11 4.63325V5.99999H12C12.5523 5.99999 13 6.44771 13 6.99999V13C13 13.5523 12.5523 14 12 14H3C2.44772 14 2 13.5523 2 13V6.99999C2 6.44771 2.44772 5.99999 3 5.99999H4ZM3 6.99999H12V13H3V6.99999Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$2$ = [
    "color"
];
var $e781b76dcad7c5d5$export$5f7f9efc246369d3 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$2$);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.4986 0C6.3257 0 5.36107 0.38943 4.73753 1.19361C4.23745 1.83856 4 2.68242 4 3.63325H5C5 2.84313 5.19691 2.23312 5.5278 1.80636C5.91615 1.30552 6.55152 1 7.4986 1C8.35683 1 8.96336 1.26502 9.35846 1.68623C9.75793 2.11211 10 2.76044 10 3.63601V6H3C2.44772 6 2 6.44772 2 7V13C2 13.5523 2.44772 14 3 14H12C12.5523 14 13 13.5523 13 13V7C13 6.44771 12.5523 6 12 6H11V3.63601C11 2.58135 10.7065 1.66167 10.0878 1.0021C9.46477 0.337871 8.57061 0 7.4986 0ZM3 7H12V13H3V7Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$30 = [
    "color"
];
var $e781b76dcad7c5d5$export$fea8b3d7473481c5 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$30);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M9 3.63601C9 2.76044 9.24207 2.11211 9.64154 1.68623C10.0366 1.26502 10.6432 1 11.5014 1C12.4485 1 13.0839 1.30552 13.4722 1.80636C13.8031 2.23312 14 2.84313 14 3.63325H15C15 2.68242 14.7626 1.83856 14.2625 1.19361C13.6389 0.38943 12.6743 0 11.5014 0C10.4294 0 9.53523 0.337871 8.91218 1.0021C8.29351 1.66167 8 2.58135 8 3.63601V6H1C0.447715 6 0 6.44772 0 7V13C0 13.5523 0.447715 14 1 14H10C10.5523 14 11 13.5523 11 13V7C11 6.44772 10.5523 6 10 6H9V3.63601ZM1 7H10V13H1V7Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$31 = [
    "color"
];
var $e781b76dcad7c5d5$export$ab1b7565a980cdcc = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$31);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M3.35355 1.85355C3.54882 1.65829 3.54882 1.34171 3.35355 1.14645C3.15829 0.951184 2.84171 0.951184 2.64645 1.14645L0.646447 3.14645C0.451184 3.34171 0.451184 3.65829 0.646447 3.85355L2.64645 5.85355C2.84171 6.04882 3.15829 6.04882 3.35355 5.85355C3.54882 5.65829 3.54882 5.34171 3.35355 5.14645L2.20711 4H9.5C11.433 4 13 5.567 13 7.5C13 7.77614 13.2239 8 13.5 8C13.7761 8 14 7.77614 14 7.5C14 5.01472 11.9853 3 9.5 3H2.20711L3.35355 1.85355ZM2 7.5C2 7.22386 1.77614 7 1.5 7C1.22386 7 1 7.22386 1 7.5C1 9.98528 3.01472 12 5.5 12H12.7929L11.6464 13.1464C11.4512 13.3417 11.4512 13.6583 11.6464 13.8536C11.8417 14.0488 12.1583 14.0488 12.3536 13.8536L14.3536 11.8536C14.5488 11.6583 14.5488 11.3417 14.3536 11.1464L12.3536 9.14645C12.1583 8.95118 11.8417 8.95118 11.6464 9.14645C11.4512 9.34171 11.4512 9.65829 11.6464 9.85355L12.7929 11H5.5C3.567 11 2 9.433 2 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$32 = [
    "color"
];
var $e781b76dcad7c5d5$export$bd662a7321ab10c4 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$32);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M13.9 0.499976C13.9 0.279062 13.7209 0.0999756 13.5 0.0999756C13.2791 0.0999756 13.1 0.279062 13.1 0.499976V1.09998H12.5C12.2791 1.09998 12.1 1.27906 12.1 1.49998C12.1 1.72089 12.2791 1.89998 12.5 1.89998H13.1V2.49998C13.1 2.72089 13.2791 2.89998 13.5 2.89998C13.7209 2.89998 13.9 2.72089 13.9 2.49998V1.89998H14.5C14.7209 1.89998 14.9 1.72089 14.9 1.49998C14.9 1.27906 14.7209 1.09998 14.5 1.09998H13.9V0.499976ZM11.8536 3.14642C12.0488 3.34168 12.0488 3.65826 11.8536 3.85353L10.8536 4.85353C10.6583 5.04879 10.3417 5.04879 10.1465 4.85353C9.9512 4.65827 9.9512 4.34169 10.1465 4.14642L11.1464 3.14643C11.3417 2.95116 11.6583 2.95116 11.8536 3.14642ZM9.85357 5.14642C10.0488 5.34168 10.0488 5.65827 9.85357 5.85353L2.85355 12.8535C2.65829 13.0488 2.34171 13.0488 2.14645 12.8535C1.95118 12.6583 1.95118 12.3417 2.14645 12.1464L9.14646 5.14642C9.34172 4.95116 9.65831 4.95116 9.85357 5.14642ZM13.5 5.09998C13.7209 5.09998 13.9 5.27906 13.9 5.49998V6.09998H14.5C14.7209 6.09998 14.9 6.27906 14.9 6.49998C14.9 6.72089 14.7209 6.89998 14.5 6.89998H13.9V7.49998C13.9 7.72089 13.7209 7.89998 13.5 7.89998C13.2791 7.89998 13.1 7.72089 13.1 7.49998V6.89998H12.5C12.2791 6.89998 12.1 6.72089 12.1 6.49998C12.1 6.27906 12.2791 6.09998 12.5 6.09998H13.1V5.49998C13.1 5.27906 13.2791 5.09998 13.5 5.09998ZM8.90002 0.499976C8.90002 0.279062 8.72093 0.0999756 8.50002 0.0999756C8.2791 0.0999756 8.10002 0.279062 8.10002 0.499976V1.09998H7.50002C7.2791 1.09998 7.10002 1.27906 7.10002 1.49998C7.10002 1.72089 7.2791 1.89998 7.50002 1.89998H8.10002V2.49998C8.10002 2.72089 8.2791 2.89998 8.50002 2.89998C8.72093 2.89998 8.90002 2.72089 8.90002 2.49998V1.89998H9.50002C9.72093 1.89998 9.90002 1.72089 9.90002 1.49998C9.90002 1.27906 9.72093 1.09998 9.50002 1.09998H8.90002V0.499976Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$33 = [
    "color"
];
var $e781b76dcad7c5d5$export$f7658c347b037c3f = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$33);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M10 6.5C10 8.433 8.433 10 6.5 10C4.567 10 3 8.433 3 6.5C3 4.567 4.567 3 6.5 3C8.433 3 10 4.567 10 6.5ZM9.30884 10.0159C8.53901 10.6318 7.56251 11 6.5 11C4.01472 11 2 8.98528 2 6.5C2 4.01472 4.01472 2 6.5 2C8.98528 2 11 4.01472 11 6.5C11 7.56251 10.6318 8.53901 10.0159 9.30884L12.8536 12.1464C13.0488 12.3417 13.0488 12.6583 12.8536 12.8536C12.6583 13.0488 12.3417 13.0488 12.1464 12.8536L9.30884 10.0159Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$34 = [
    "color"
];
var $e781b76dcad7c5d5$export$fca30e52ebed3683 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$34);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M1.49988 2.00012C1.77602 2.00012 1.99988 1.77626 1.99988 1.50012C1.99988 1.22398 1.77602 1.00012 1.49988 1.00012C1.22374 1.00012 0.999878 1.22398 0.999878 1.50012C0.999878 1.77626 1.22374 2.00012 1.49988 2.00012ZM4.49988 2.00012C4.77602 2.00012 4.99988 1.77626 4.99988 1.50012C4.99988 1.22398 4.77602 1.00012 4.49988 1.00012C4.22374 1.00012 3.99988 1.22398 3.99988 1.50012C3.99988 1.77626 4.22374 2.00012 4.49988 2.00012ZM7.99988 1.50012C7.99988 1.77626 7.77602 2.00012 7.49988 2.00012C7.22374 2.00012 6.99988 1.77626 6.99988 1.50012C6.99988 1.22398 7.22374 1.00012 7.49988 1.00012C7.77602 1.00012 7.99988 1.22398 7.99988 1.50012ZM10.4999 2.00012C10.776 2.00012 10.9999 1.77626 10.9999 1.50012C10.9999 1.22398 10.776 1.00012 10.4999 1.00012C10.2237 1.00012 9.99988 1.22398 9.99988 1.50012C9.99988 1.77626 10.2237 2.00012 10.4999 2.00012ZM13.9999 1.50012C13.9999 1.77626 13.776 2.00012 13.4999 2.00012C13.2237 2.00012 12.9999 1.77626 12.9999 1.50012C12.9999 1.22398 13.2237 1.00012 13.4999 1.00012C13.776 1.00012 13.9999 1.22398 13.9999 1.50012ZM1.49988 14.0001C1.77602 14.0001 1.99988 13.7763 1.99988 13.5001C1.99988 13.224 1.77602 13.0001 1.49988 13.0001C1.22374 13.0001 0.999878 13.224 0.999878 13.5001C0.999878 13.7763 1.22374 14.0001 1.49988 14.0001ZM1.99988 10.5001C1.99988 10.7763 1.77602 11.0001 1.49988 11.0001C1.22374 11.0001 0.999878 10.7763 0.999878 10.5001C0.999878 10.224 1.22374 10.0001 1.49988 10.0001C1.77602 10.0001 1.99988 10.224 1.99988 10.5001ZM1.49988 8.00012C1.77602 8.00012 1.99988 7.77626 1.99988 7.50012C1.99988 7.22398 1.77602 7.00012 1.49988 7.00012C1.22374 7.00012 0.999878 7.22398 0.999878 7.50012C0.999878 7.77626 1.22374 8.00012 1.49988 8.00012ZM1.99988 4.50012C1.99988 4.77626 1.77602 5.00012 1.49988 5.00012C1.22374 5.00012 0.999878 4.77626 0.999878 4.50012C0.999878 4.22398 1.22374 4.00012 1.49988 4.00012C1.77602 4.00012 1.99988 4.22398 1.99988 4.50012ZM13.4999 11.0001C13.776 11.0001 13.9999 10.7763 13.9999 10.5001C13.9999 10.224 13.776 10.0001 13.4999 10.0001C13.2237 10.0001 12.9999 10.224 12.9999 10.5001C12.9999 10.7763 13.2237 11.0001 13.4999 11.0001ZM13.9999 7.50012C13.9999 7.77626 13.776 8.00012 13.4999 8.00012C13.2237 8.00012 12.9999 7.77626 12.9999 7.50012C12.9999 7.22398 13.2237 7.00012 13.4999 7.00012C13.776 7.00012 13.9999 7.22398 13.9999 7.50012ZM13.4999 5.00012C13.776 5.00012 13.9999 4.77626 13.9999 4.50012C13.9999 4.22398 13.776 4.00012 13.4999 4.00012C13.2237 4.00012 12.9999 4.22398 12.9999 4.50012C12.9999 4.77626 13.2237 5.00012 13.4999 5.00012ZM4.99988 13.5001C4.99988 13.7763 4.77602 14.0001 4.49988 14.0001C4.22374 14.0001 3.99988 13.7763 3.99988 13.5001C3.99988 13.224 4.22374 13.0001 4.49988 13.0001C4.77602 13.0001 4.99988 13.224 4.99988 13.5001ZM7.49988 14.0001C7.77602 14.0001 7.99988 13.7763 7.99988 13.5001C7.99988 13.224 7.77602 13.0001 7.49988 13.0001C7.22374 13.0001 6.99988 13.224 6.99988 13.5001C6.99988 13.7763 7.22374 14.0001 7.49988 14.0001ZM10.9999 13.5001C10.9999 13.7763 10.776 14.0001 10.4999 14.0001C10.2237 14.0001 9.99988 13.7763 9.99988 13.5001C9.99988 13.224 10.2237 13.0001 10.4999 13.0001C10.776 13.0001 10.9999 13.224 10.9999 13.5001ZM13.4999 14.0001C13.776 14.0001 13.9999 13.7763 13.9999 13.5001C13.9999 13.224 13.776 13.0001 13.4999 13.0001C13.2237 13.0001 12.9999 13.224 12.9999 13.5001C12.9999 13.7763 13.2237 14.0001 13.4999 14.0001ZM3.99988 5.00012C3.99988 4.44784 4.44759 4.00012 4.99988 4.00012H9.99988C10.5522 4.00012 10.9999 4.44784 10.9999 5.00012V10.0001C10.9999 10.5524 10.5522 11.0001 9.99988 11.0001H4.99988C4.44759 11.0001 3.99988 10.5524 3.99988 10.0001V5.00012ZM4.99988 5.00012H9.99988V10.0001H4.99988V5.00012Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$35 = [
    "color"
];
var $e781b76dcad7c5d5$export$afa4b2f99a1f67c0 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$35);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M1 2H14V13H1L1 2ZM0 2C0 1.44772 0.447715 1 1 1H14C14.5523 1 15 1.44772 15 2V13C15 13.5523 14.5523 14 14 14H1C0.447715 14 0 13.5523 0 13V2ZM4.875 7.5C4.875 6.05025 6.05025 4.875 7.5 4.875C8.94975 4.875 10.125 6.05025 10.125 7.5C10.125 8.94975 8.94975 10.125 7.5 10.125C6.05025 10.125 4.875 8.94975 4.875 7.5ZM7.5 3.875C5.49797 3.875 3.875 5.49797 3.875 7.5C3.875 9.50203 5.49797 11.125 7.5 11.125C9.50203 11.125 11.125 9.50203 11.125 7.5C11.125 5.49797 9.50203 3.875 7.5 3.875Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$36 = [
    "color"
];
var $e781b76dcad7c5d5$export$34d98fe14bf296c1 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$36);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M1 1C0.447715 1 0 1.44772 0 2V13C0 13.5523 0.447715 14 1 14H14C14.5523 14 15 13.5523 15 13V2C15 1.44772 14.5523 1 14 1H1ZM7.5 10.625C9.22589 10.625 10.625 9.22589 10.625 7.5C10.625 5.77411 9.22589 4.375 7.5 4.375C5.77411 4.375 4.375 5.77411 4.375 7.5C4.375 9.22589 5.77411 10.625 7.5 10.625Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$37 = [
    "color"
];
var $e781b76dcad7c5d5$export$cb808a3c41736d8e = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$37);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M2.25 7.5C2.25 7.22386 2.47386 7 2.75 7H12.25C12.5261 7 12.75 7.22386 12.75 7.5C12.75 7.77614 12.5261 8 12.25 8H2.75C2.47386 8 2.25 7.77614 2.25 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$38 = [
    "color"
];
var $e781b76dcad7c5d5$export$80cd35ac42af1413 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$38);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82707 7.49972C1.82707 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82707 10.6327 1.82707 7.49972ZM4.50003 7C4.22389 7 4.00003 7.22386 4.00003 7.5C4.00003 7.77614 4.22389 8 4.50003 8H10.5C10.7762 8 11 7.77614 11 7.5C11 7.22386 10.7762 7 10.5 7H4.50003Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$39 = [
    "color"
];
var $e781b76dcad7c5d5$export$7829447535316b17 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$39);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M2.14921 3.99996C2.14921 2.97778 2.97784 2.14915 4.00002 2.14915C5.02219 2.14915 5.85083 2.97778 5.85083 3.99996C5.85083 5.02213 5.02219 5.85077 4.00002 5.85077C2.97784 5.85077 2.14921 5.02213 2.14921 3.99996ZM4.00002 1.24915C2.48079 1.24915 1.24921 2.48073 1.24921 3.99996C1.24921 5.51919 2.48079 6.75077 4.00002 6.75077C5.51925 6.75077 6.75083 5.51919 6.75083 3.99996C6.75083 2.48073 5.51925 1.24915 4.00002 1.24915ZM5.82034 11.0001L2.49998 12.8369V9.16331L5.82034 11.0001ZM2.63883 8.21159C2.17228 7.9535 1.59998 8.29093 1.59998 8.82411V13.1761C1.59998 13.7093 2.17228 14.0467 2.63883 13.7886L6.57235 11.6126C7.05389 11.3462 7.05389 10.654 6.57235 10.3876L2.63883 8.21159ZM8.30001 9.00003C8.30001 8.61343 8.61341 8.30003 9.00001 8.30003H13C13.3866 8.30003 13.7 8.61343 13.7 9.00003V13C13.7 13.3866 13.3866 13.7 13 13.7H9.00001C8.61341 13.7 8.30001 13.3866 8.30001 13V9.00003ZM9.20001 9.20003V12.8H12.8V9.20003H9.20001ZM13.4432 2.19311C13.6189 2.01737 13.6189 1.73245 13.4432 1.55671C13.2675 1.38098 12.9826 1.38098 12.8068 1.55671L11 3.36353L9.19321 1.55674C9.01748 1.381 8.73255 1.381 8.55682 1.55674C8.38108 1.73247 8.38108 2.0174 8.55682 2.19313L10.3636 3.99992L8.55682 5.80671C8.38108 5.98245 8.38108 6.26737 8.55682 6.44311C8.73255 6.61885 9.01748 6.61885 9.19321 6.44311L11 4.63632L12.8068 6.44314C12.9826 6.61887 13.2675 6.61887 13.4432 6.44314C13.6189 6.2674 13.6189 5.98247 13.4432 5.80674L11.6364 3.99992L13.4432 2.19311Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3a = [
    "color"
];
var $e781b76dcad7c5d5$export$5560e721cf131890 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3a);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M5.5 3C4.67157 3 4 3.67157 4 4.5C4 5.32843 4.67157 6 5.5 6C6.32843 6 7 5.32843 7 4.5C7 3.67157 6.32843 3 5.5 3ZM3 5C3.01671 5 3.03323 4.99918 3.04952 4.99758C3.28022 6.1399 4.28967 7 5.5 7C6.71033 7 7.71978 6.1399 7.95048 4.99758C7.96677 4.99918 7.98329 5 8 5H13.5C13.7761 5 14 4.77614 14 4.5C14 4.22386 13.7761 4 13.5 4H8C7.98329 4 7.96677 4.00082 7.95048 4.00242C7.71978 2.86009 6.71033 2 5.5 2C4.28967 2 3.28022 2.86009 3.04952 4.00242C3.03323 4.00082 3.01671 4 3 4H1.5C1.22386 4 1 4.22386 1 4.5C1 4.77614 1.22386 5 1.5 5H3ZM11.9505 10.9976C11.7198 12.1399 10.7103 13 9.5 13C8.28967 13 7.28022 12.1399 7.04952 10.9976C7.03323 10.9992 7.01671 11 7 11H1.5C1.22386 11 1 10.7761 1 10.5C1 10.2239 1.22386 10 1.5 10H7C7.01671 10 7.03323 10.0008 7.04952 10.0024C7.28022 8.8601 8.28967 8 9.5 8C10.7103 8 11.7198 8.8601 11.9505 10.0024C11.9668 10.0008 11.9833 10 12 10H13.5C13.7761 10 14 10.2239 14 10.5C14 10.7761 13.7761 11 13.5 11H12C11.9833 11 11.9668 10.9992 11.9505 10.9976ZM8 10.5C8 9.67157 8.67157 9 9.5 9C10.3284 9 11 9.67157 11 10.5C11 11.3284 10.3284 12 9.5 12C8.67157 12 8 11.3284 8 10.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3b = [
    "color"
];
var $e781b76dcad7c5d5$export$8154ac77932ca099 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3b);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M5 1.5C5 1.22386 4.77614 1 4.5 1C4.22386 1 4 1.22386 4 1.5L4 7C4 7.01671 4.00082 7.03323 4.00242 7.04952C2.86009 7.28022 2 8.28967 2 9.5C2 10.7103 2.86009 11.7198 4.00242 11.9505C4.00082 11.9668 4 11.9833 4 12V13.5C4 13.7761 4.22386 14 4.5 14C4.77614 14 5 13.7761 5 13.5V12C5 11.9833 4.99918 11.9668 4.99758 11.9505C6.1399 11.7198 7 10.7103 7 9.5C7 8.28967 6.1399 7.28022 4.99758 7.04952C4.99918 7.03323 5 7.01671 5 7L5 1.5ZM11 1.5C11 1.22386 10.7761 1 10.5 1C10.2239 1 10 1.22386 10 1.5V3C10 3.01671 10.0008 3.03323 10.0024 3.04952C8.8601 3.28022 8 4.28967 8 5.5C8 6.71033 8.8601 7.71978 10.0024 7.95048C10.0008 7.96677 10 7.98329 10 8V13.5C10 13.7761 10.2239 14 10.5 14C10.7761 14 11 13.7761 11 13.5V8C11 7.98329 10.9992 7.96677 10.9976 7.95048C12.1399 7.71978 13 6.71033 13 5.5C13 4.28967 12.1399 3.28022 10.9976 3.04952C10.9992 3.03323 11 3.01671 11 3V1.5ZM4.5 8C3.67157 8 3 8.67157 3 9.5C3 10.3284 3.67157 11 4.5 11C5.32843 11 6 10.3284 6 9.5C6 8.67157 5.32843 8 4.5 8ZM9 5.5C9 4.67157 9.67157 4 10.5 4C11.3284 4 12 4.67157 12 5.5C12 6.32843 11.3284 7 10.5 7C9.67157 7 9 6.32843 9 5.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3c = [
    "color"
];
var $e781b76dcad7c5d5$export$4484d2284bbfa969 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3c);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M4 2.5C4 2.22386 4.22386 2 4.5 2H10.5C10.7761 2 11 2.22386 11 2.5V12.5C11 12.7761 10.7761 13 10.5 13H4.5C4.22386 13 4 12.7761 4 12.5V2.5ZM4.5 1C3.67157 1 3 1.67157 3 2.5V12.5C3 13.3284 3.67157 14 4.5 14H10.5C11.3284 14 12 13.3284 12 12.5V2.5C12 1.67157 11.3284 1 10.5 1H4.5ZM6 11.65C5.8067 11.65 5.65 11.8067 5.65 12C5.65 12.1933 5.8067 12.35 6 12.35H9C9.1933 12.35 9.35 12.1933 9.35 12C9.35 11.8067 9.1933 11.65 9 11.65H6Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3d = [
    "color"
];
var $e781b76dcad7c5d5$export$a2a3256d1cc3a69a = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3d);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.25925 3.16667L4.37036 5.33333V1L7.25925 3.16667ZM1 8.22222L3.88889 6.05555L1 3.88889V8.22222ZM1 14L3.88889 11.8333L1 9.66666V14ZM7.74072 8.22222L10.6296 6.05555L7.74072 3.88889V8.22222ZM14 3.16667L11.1111 5.33333V1L14 3.16667ZM11.1111 11.1111L14 8.94444L11.1111 6.77777V11.1111ZM3.88889 11.1111L1 8.94444L3.88889 6.77777V11.1111ZM4.37036 6.05555L7.25925 8.22222V3.88889L4.37036 6.05555ZM3.88889 5.33333L1 3.16667L3.88889 1V5.33333ZM7.74072 3.16667L10.6296 5.33333V1L7.74072 3.16667ZM14 8.22222L11.1111 6.05555L14 3.88889V8.22222ZM11.1111 11.8333L14 14V9.66666L11.1111 11.8333Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3e = [
    "color"
];
var $e781b76dcad7c5d5$export$41051b6be05d5fb0 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3e);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M2.89998 0.499976C2.89998 0.279062 2.72089 0.0999756 2.49998 0.0999756C2.27906 0.0999756 2.09998 0.279062 2.09998 0.499976V1.09998H1.49998C1.27906 1.09998 1.09998 1.27906 1.09998 1.49998C1.09998 1.72089 1.27906 1.89998 1.49998 1.89998H2.09998V2.49998C2.09998 2.72089 2.27906 2.89998 2.49998 2.89998C2.72089 2.89998 2.89998 2.72089 2.89998 2.49998V1.89998H3.49998C3.72089 1.89998 3.89998 1.72089 3.89998 1.49998C3.89998 1.27906 3.72089 1.09998 3.49998 1.09998H2.89998V0.499976ZM5.89998 3.49998C5.89998 3.27906 5.72089 3.09998 5.49998 3.09998C5.27906 3.09998 5.09998 3.27906 5.09998 3.49998V4.09998H4.49998C4.27906 4.09998 4.09998 4.27906 4.09998 4.49998C4.09998 4.72089 4.27906 4.89998 4.49998 4.89998H5.09998V5.49998C5.09998 5.72089 5.27906 5.89998 5.49998 5.89998C5.72089 5.89998 5.89998 5.72089 5.89998 5.49998V4.89998H6.49998C6.72089 4.89998 6.89998 4.72089 6.89998 4.49998C6.89998 4.27906 6.72089 4.09998 6.49998 4.09998H5.89998V3.49998ZM1.89998 6.49998C1.89998 6.27906 1.72089 6.09998 1.49998 6.09998C1.27906 6.09998 1.09998 6.27906 1.09998 6.49998V7.09998H0.499976C0.279062 7.09998 0.0999756 7.27906 0.0999756 7.49998C0.0999756 7.72089 0.279062 7.89998 0.499976 7.89998H1.09998V8.49998C1.09998 8.72089 1.27906 8.89997 1.49998 8.89997C1.72089 8.89997 1.89998 8.72089 1.89998 8.49998V7.89998H2.49998C2.72089 7.89998 2.89998 7.72089 2.89998 7.49998C2.89998 7.27906 2.72089 7.09998 2.49998 7.09998H1.89998V6.49998ZM8.54406 0.98184L8.24618 0.941586C8.03275 0.917676 7.90692 1.1655 8.02936 1.34194C8.17013 1.54479 8.29981 1.75592 8.41754 1.97445C8.91878 2.90485 9.20322 3.96932 9.20322 5.10022C9.20322 8.37201 6.82247 11.0878 3.69887 11.6097C3.45736 11.65 3.20988 11.6772 2.96008 11.6906C2.74563 11.702 2.62729 11.9535 2.77721 12.1072C2.84551 12.1773 2.91535 12.2458 2.98667 12.3128L3.05883 12.3795L3.31883 12.6045L3.50684 12.7532L3.62796 12.8433L3.81491 12.9742L3.99079 13.089C4.11175 13.1651 4.23536 13.2375 4.36157 13.3059L4.62496 13.4412L4.88553 13.5607L5.18837 13.6828L5.43169 13.7686C5.56564 13.8128 5.70149 13.8529 5.83857 13.8885C5.94262 13.9155 6.04767 13.9401 6.15405 13.9622C6.27993 13.9883 6.40713 14.0109 6.53544 14.0298L6.85241 14.0685L7.11934 14.0892C7.24637 14.0965 7.37436 14.1002 7.50322 14.1002C11.1483 14.1002 14.1032 11.1453 14.1032 7.50023C14.1032 7.25044 14.0893 7.00389 14.0623 6.76131L14.0255 6.48407C13.991 6.26083 13.9453 6.04129 13.8891 5.82642C13.8213 5.56709 13.7382 5.31398 13.6409 5.06881L13.5279 4.80132L13.4507 4.63542L13.3766 4.48666C13.2178 4.17773 13.0353 3.88295 12.8312 3.60423L12.6782 3.40352L12.4793 3.16432L12.3157 2.98361L12.1961 2.85951L12.0355 2.70246L11.8134 2.50184L11.4925 2.24191L11.2483 2.06498L10.9562 1.87446L10.6346 1.68894L10.3073 1.52378L10.1938 1.47176L9.95488 1.3706L9.67791 1.2669L9.42566 1.1846L9.10075 1.09489L8.83599 1.03486L8.54406 0.98184ZM10.4032 5.30023C10.4032 4.27588 10.2002 3.29829 9.83244 2.40604C11.7623 3.28995 13.1032 5.23862 13.1032 7.50023C13.1032 10.593 10.596 13.1002 7.50322 13.1002C6.63646 13.1002 5.81597 12.9036 5.08355 12.5522C6.5419 12.0941 7.81081 11.2082 8.74322 10.0416C8.87963 10.2284 9.10028 10.3497 9.34928 10.3497C9.76349 10.3497 10.0993 10.0139 10.0993 9.59971C10.0993 9.24256 9.84965 8.94373 9.51535 8.86816C9.57741 8.75165 9.63653 8.63334 9.6926 8.51332C9.88358 8.63163 10.1088 8.69993 10.35 8.69993C11.0403 8.69993 11.6 8.14028 11.6 7.44993C11.6 6.75976 11.0406 6.20024 10.3505 6.19993C10.3853 5.90487 10.4032 5.60464 10.4032 5.30023Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3f = [
    "color"
];
var $e781b76dcad7c5d5$export$3e0409b11e4da6d2 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3f);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.81819 0.93179C7.64245 0.756054 7.35753 0.756054 7.18179 0.93179L5.43179 2.68179C5.25605 2.85753 5.25605 3.14245 5.43179 3.31819C5.60753 3.49392 5.89245 3.49392 6.06819 3.31819L6.99999 2.38638V5.49999C6.99999 5.77613 7.22385 5.99999 7.49999 5.99999C7.77613 5.99999 7.99999 5.77613 7.99999 5.49999V2.38638L8.93179 3.31819C9.10753 3.49392 9.39245 3.49392 9.56819 3.31819C9.74392 3.14245 9.74392 2.85753 9.56819 2.68179L7.81819 0.93179ZM7.99999 9.49999C7.99999 9.22385 7.77613 8.99999 7.49999 8.99999C7.22385 8.99999 6.99999 9.22385 6.99999 9.49999V12.6136L6.06819 11.6818C5.89245 11.5061 5.60753 11.5061 5.43179 11.6818C5.25605 11.8575 5.25605 12.1424 5.43179 12.3182L7.18179 14.0682C7.35753 14.2439 7.64245 14.2439 7.81819 14.0682L9.56819 12.3182C9.74392 12.1424 9.74392 11.8575 9.56819 11.6818C9.39245 11.5061 9.10753 11.5061 8.93179 11.6818L7.99999 12.6136V9.49999ZM8.99999 7.49999C8.99999 7.22385 9.22385 6.99999 9.49999 6.99999H12.6136L11.6818 6.06819C11.5061 5.89245 11.5061 5.60753 11.6818 5.43179C11.8575 5.25605 12.1424 5.25605 12.3182 5.43179L14.0682 7.18179C14.2439 7.35753 14.2439 7.64245 14.0682 7.81819L12.3182 9.56819C12.1424 9.74392 11.8575 9.74392 11.6818 9.56819C11.5061 9.39245 11.5061 9.10753 11.6818 8.93179L12.6136 7.99999H9.49999C9.22385 7.99999 8.99999 7.77613 8.99999 7.49999ZM3.31819 6.06819L2.38638 6.99999H5.49999C5.77613 6.99999 5.99999 7.22385 5.99999 7.49999C5.99999 7.77613 5.77613 7.99999 5.49999 7.99999H2.38638L3.31819 8.93179C3.49392 9.10753 3.49392 9.39245 3.31819 9.56819C3.14245 9.74392 2.85753 9.74392 2.68179 9.56819L0.93179 7.81819C0.756054 7.64245 0.756054 7.35753 0.93179 7.18179L2.68179 5.43179C2.85753 5.25605 3.14245 5.25605 3.31819 5.43179C3.49392 5.60753 3.49392 5.89245 3.31819 6.06819Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3g = [
    "color"
];
var $e781b76dcad7c5d5$export$f8668531034d5b61 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3g);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M3.25781 3.11684C3.67771 3.45796 3.83523 3.43193 4.62369 3.37933L12.0571 2.93299C12.2147 2.93299 12.0836 2.77571 12.0311 2.74957L10.7965 1.85711C10.56 1.67347 10.2448 1.46315 9.64083 1.51576L2.44308 2.04074C2.18059 2.06677 2.12815 2.19801 2.2327 2.30322L3.25781 3.11684ZM3.7041 4.84917V12.6704C3.7041 13.0907 3.91415 13.248 4.38693 13.222L12.5562 12.7493C13.0292 12.7233 13.0819 12.4341 13.0819 12.0927V4.32397C13.0819 3.98306 12.9508 3.79921 12.6612 3.82545L4.12422 4.32397C3.80918 4.35044 3.7041 4.50803 3.7041 4.84917ZM11.7688 5.26872C11.8212 5.50518 11.7688 5.74142 11.5319 5.76799L11.1383 5.84641V11.6205C10.7965 11.8042 10.4814 11.9092 10.2188 11.9092C9.79835 11.9092 9.69305 11.7779 9.37812 11.3844L6.80345 7.34249V11.2532L7.61816 11.437C7.61816 11.437 7.61816 11.9092 6.96086 11.9092L5.14879 12.0143C5.09615 11.9092 5.14879 11.647 5.33259 11.5944L5.80546 11.4634V6.29276L5.1489 6.24015C5.09625 6.00369 5.22739 5.66278 5.5954 5.63631L7.53935 5.50528L10.2188 9.5998V5.97765L9.53564 5.89924C9.4832 5.61018 9.69305 5.40028 9.95576 5.37425L11.7688 5.26872ZM1.83874 1.33212L9.32557 0.780787C10.245 0.701932 10.4815 0.754753 11.0594 1.17452L13.4492 2.85424C13.8436 3.14309 13.975 3.22173 13.975 3.53661V12.7493C13.975 13.3266 13.7647 13.6681 13.0293 13.7203L4.33492 14.2454C3.78291 14.2717 3.52019 14.193 3.23111 13.8253L1.47116 11.5419C1.1558 11.1216 1.02466 10.8071 1.02466 10.4392V2.25041C1.02466 1.77825 1.23504 1.38441 1.83874 1.33212Z",
        fill: color
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3h = [
    "color"
];
var $e781b76dcad7c5d5$export$8af0311c2e327563 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3h);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.5 1.5C4.5 4.25 3 6.5 3 9C3 11.4853 5.01472 13.5 7.5 13.5C9.98528 13.5 12 11.4853 12 9C12 6.5 10.5 4.25 7.5 1.5ZM11 9C11 7.11203 9.97315 5.27195 7.5 2.87357C5.02686 5.27195 4 7.11203 4 9C4 10.933 5.567 12.5 7.5 12.5C9.433 12.5 11 10.933 11 9Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3i = [
    "color"
];
var $e781b76dcad7c5d5$export$31dd750d53ed8eca = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3i);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 13C12.5523 13 13 12.5523 13 12V3C13 2.44771 12.5523 2 12 2H3C2.44771 2 2 2.44771 2 3V6.5C2 6.77614 2.22386 7 2.5 7C2.77614 7 3 6.77614 3 6.5V3H12V12H8.5C8.22386 12 8 12.2239 8 12.5C8 12.7761 8.22386 13 8.5 13H12ZM9 6.5C9 6.5001 9 6.50021 9 6.50031V6.50035V9.5C9 9.77614 8.77614 10 8.5 10C8.22386 10 8 9.77614 8 9.5V7.70711L2.85355 12.8536C2.65829 13.0488 2.34171 13.0488 2.14645 12.8536C1.95118 12.6583 1.95118 12.3417 2.14645 12.1464L7.29289 7H5.5C5.22386 7 5 6.77614 5 6.5C5 6.22386 5.22386 6 5.5 6H8.5C8.56779 6 8.63244 6.01349 8.69139 6.03794C8.74949 6.06198 8.80398 6.09744 8.85143 6.14433C8.94251 6.23434 8.9992 6.35909 8.99999 6.49708L8.99999 6.49738",
        fill: color
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3j = [
    "color"
];
var $e781b76dcad7c5d5$export$cc1d3fa780ad61dc = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3j);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M3.49985 1.10001C3.27894 1.10001 3.09985 1.27909 3.09985 1.50001C3.09985 1.72092 3.27894 1.90001 3.49985 1.90001H11.4999C11.7208 1.90001 11.8999 1.72092 11.8999 1.50001C11.8999 1.27909 11.7208 1.10001 11.4999 1.10001H3.49985ZM4.99995 4.25001C4.99995 3.97387 4.77609 3.75001 4.49995 3.75001C4.22381 3.75001 3.99995 3.97387 3.99995 4.25001V9.55001C3.99995 11.483 5.56695 13.05 7.49995 13.05C9.43295 13.05 11 11.483 11 9.55001V4.25001C11 3.97387 10.7761 3.75001 10.5 3.75001C10.2238 3.75001 9.99995 3.97387 9.99995 4.25001V9.55001C9.99995 10.9307 8.88066 12.05 7.49995 12.05C6.11924 12.05 4.99995 10.9307 4.99995 9.55001V4.25001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3k = [
    "color"
];
var $e781b76dcad7c5d5$export$2ff5a181c2f67fef = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3k);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M2.85714 2H12.1429C12.6162 2 13 2.38376 13 2.85714V12.1429C13 12.6162 12.6162 13 12.1429 13H2.85714C2.38376 13 2 12.6162 2 12.1429V2.85714C2 2.38376 2.38376 2 2.85714 2ZM1 2.85714C1 1.83147 1.83147 1 2.85714 1H12.1429C13.1685 1 14 1.83147 14 2.85714V12.1429C14 13.1685 13.1685 14 12.1429 14H2.85714C1.83147 14 1 13.1685 1 12.1429V2.85714ZM7.49988 5.00012C7.77602 5.00012 7.99988 4.77626 7.99988 4.50012C7.99988 4.22398 7.77602 4.00012 7.49988 4.00012C7.22374 4.00012 6.99988 4.22398 6.99988 4.50012C6.99988 4.77626 7.22374 5.00012 7.49988 5.00012ZM4.49988 11.0001C4.77602 11.0001 4.99988 10.7763 4.99988 10.5001C4.99988 10.224 4.77602 10.0001 4.49988 10.0001C4.22374 10.0001 3.99988 10.224 3.99988 10.5001C3.99988 10.7763 4.22374 11.0001 4.49988 11.0001ZM4.99988 7.50012C4.99988 7.77626 4.77602 8.00012 4.49988 8.00012C4.22374 8.00012 3.99988 7.77626 3.99988 7.50012C3.99988 7.22398 4.22374 7.00012 4.49988 7.00012C4.77602 7.00012 4.99988 7.22398 4.99988 7.50012ZM4.49988 5.00012C4.77602 5.00012 4.99988 4.77626 4.99988 4.50012C4.99988 4.22398 4.77602 4.00012 4.49988 4.00012C4.22374 4.00012 3.99988 4.22398 3.99988 4.50012C3.99988 4.77626 4.22374 5.00012 4.49988 5.00012ZM10.9999 10.5001C10.9999 10.7763 10.776 11.0001 10.4999 11.0001C10.2237 11.0001 9.99988 10.7763 9.99988 10.5001C9.99988 10.224 10.2237 10.0001 10.4999 10.0001C10.776 10.0001 10.9999 10.224 10.9999 10.5001ZM10.4999 8.00012C10.776 8.00012 10.9999 7.77626 10.9999 7.50012C10.9999 7.22398 10.776 7.00012 10.4999 7.00012C10.2237 7.00012 9.99988 7.22398 9.99988 7.50012C9.99988 7.77626 10.2237 8.00012 10.4999 8.00012ZM10.9999 4.50012C10.9999 4.77626 10.776 5.00012 10.4999 5.00012C10.2237 5.00012 9.99988 4.77626 9.99988 4.50012C9.99988 4.22398 10.2237 4.00012 10.4999 4.00012C10.776 4.00012 10.9999 4.22398 10.9999 4.50012ZM7.49988 11.0001C7.77602 11.0001 7.99988 10.7763 7.99988 10.5001C7.99988 10.224 7.77602 10.0001 7.49988 10.0001C7.22374 10.0001 6.99988 10.224 6.99988 10.5001C6.99988 10.7763 7.22374 11.0001 7.49988 11.0001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3l = [
    "color"
];
var $e781b76dcad7c5d5$export$7e727ef41af0217d = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3l);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M1.20308 1.04312C1.00481 0.954998 0.772341 1.0048 0.627577 1.16641C0.482813 1.32802 0.458794 1.56455 0.568117 1.75196L3.92115 7.50002L0.568117 13.2481C0.458794 13.4355 0.482813 13.672 0.627577 13.8336C0.772341 13.9952 1.00481 14.045 1.20308 13.9569L14.7031 7.95693C14.8836 7.87668 15 7.69762 15 7.50002C15 7.30243 14.8836 7.12337 14.7031 7.04312L1.20308 1.04312ZM4.84553 7.10002L2.21234 2.586L13.2689 7.50002L2.21234 12.414L4.84552 7.90002H9C9.22092 7.90002 9.4 7.72094 9.4 7.50002C9.4 7.27911 9.22092 7.10002 9 7.10002H4.84553Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3m = [
    "color"
];
var $e781b76dcad7c5d5$export$9b47433640e5db3a = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3m);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M6.04995 2.74998C6.04995 2.44623 5.80371 2.19998 5.49995 2.19998C5.19619 2.19998 4.94995 2.44623 4.94995 2.74998V12.25C4.94995 12.5537 5.19619 12.8 5.49995 12.8C5.80371 12.8 6.04995 12.5537 6.04995 12.25V2.74998ZM10.05 2.74998C10.05 2.44623 9.80371 2.19998 9.49995 2.19998C9.19619 2.19998 8.94995 2.44623 8.94995 2.74998V12.25C8.94995 12.5537 9.19619 12.8 9.49995 12.8C9.80371 12.8 10.05 12.5537 10.05 12.25V2.74998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3n = [
    "color"
];
var $e781b76dcad7c5d5$export$41c6eabacaa37313 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3n);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M11.8536 1.14645C11.6583 0.951184 11.3417 0.951184 11.1465 1.14645L3.71455 8.57836C3.62459 8.66832 3.55263 8.77461 3.50251 8.89155L2.04044 12.303C1.9599 12.491 2.00189 12.709 2.14646 12.8536C2.29103 12.9981 2.50905 13.0401 2.69697 12.9596L6.10847 11.4975C6.2254 11.4474 6.3317 11.3754 6.42166 11.2855L13.8536 3.85355C14.0488 3.65829 14.0488 3.34171 13.8536 3.14645L11.8536 1.14645ZM4.42166 9.28547L11.5 2.20711L12.7929 3.5L5.71455 10.5784L4.21924 11.2192L3.78081 10.7808L4.42166 9.28547Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3o = [
    "color"
];
var $e781b76dcad7c5d5$export$bedf874c76d8ae34 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3o);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M12.1464 1.14645C12.3417 0.951184 12.6583 0.951184 12.8535 1.14645L14.8535 3.14645C15.0488 3.34171 15.0488 3.65829 14.8535 3.85355L10.9109 7.79618C10.8349 7.87218 10.7471 7.93543 10.651 7.9835L6.72359 9.94721C6.53109 10.0435 6.29861 10.0057 6.14643 9.85355C5.99425 9.70137 5.95652 9.46889 6.05277 9.27639L8.01648 5.34897C8.06455 5.25283 8.1278 5.16507 8.2038 5.08907L12.1464 1.14645ZM12.5 2.20711L8.91091 5.79618L7.87266 7.87267L8.12731 8.12732L10.2038 7.08907L13.7929 3.5L12.5 2.20711ZM9.99998 2L8.99998 3H4.9C4.47171 3 4.18056 3.00039 3.95552 3.01877C3.73631 3.03668 3.62421 3.06915 3.54601 3.10899C3.35785 3.20487 3.20487 3.35785 3.10899 3.54601C3.06915 3.62421 3.03669 3.73631 3.01878 3.95552C3.00039 4.18056 3 4.47171 3 4.9V11.1C3 11.5283 3.00039 11.8194 3.01878 12.0445C3.03669 12.2637 3.06915 12.3758 3.10899 12.454C3.20487 12.6422 3.35785 12.7951 3.54601 12.891C3.62421 12.9309 3.73631 12.9633 3.95552 12.9812C4.18056 12.9996 4.47171 13 4.9 13H11.1C11.5283 13 11.8194 12.9996 12.0445 12.9812C12.2637 12.9633 12.3758 12.9309 12.454 12.891C12.6422 12.7951 12.7951 12.6422 12.891 12.454C12.9309 12.3758 12.9633 12.2637 12.9812 12.0445C12.9996 11.8194 13 11.5283 13 11.1V6.99998L14 5.99998V11.1V11.1207C14 11.5231 14 11.8553 13.9779 12.1259C13.9549 12.407 13.9057 12.6653 13.782 12.908C13.5903 13.2843 13.2843 13.5903 12.908 13.782C12.6653 13.9057 12.407 13.9549 12.1259 13.9779C11.8553 14 11.5231 14 11.1207 14H11.1H4.9H4.87934C4.47686 14 4.14468 14 3.87409 13.9779C3.59304 13.9549 3.33469 13.9057 3.09202 13.782C2.7157 13.5903 2.40973 13.2843 2.21799 12.908C2.09434 12.6653 2.04506 12.407 2.0221 12.1259C1.99999 11.8553 1.99999 11.5231 2 11.1207V11.1206V11.1V4.9V4.87935V4.87932V4.87931C1.99999 4.47685 1.99999 4.14468 2.0221 3.87409C2.04506 3.59304 2.09434 3.33469 2.21799 3.09202C2.40973 2.71569 2.7157 2.40973 3.09202 2.21799C3.33469 2.09434 3.59304 2.04506 3.87409 2.0221C4.14468 1.99999 4.47685 1.99999 4.87932 2H4.87935H4.9H9.99998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3p = [
    "color"
];
var $e781b76dcad7c5d5$export$7dcc8f518762622d = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3p);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.5 0.875C5.49797 0.875 3.875 2.49797 3.875 4.5C3.875 6.15288 4.98124 7.54738 6.49373 7.98351C5.2997 8.12901 4.27557 8.55134 3.50407 9.31167C2.52216 10.2794 2.02502 11.72 2.02502 13.5999C2.02502 13.8623 2.23769 14.0749 2.50002 14.0749C2.76236 14.0749 2.97502 13.8623 2.97502 13.5999C2.97502 11.8799 3.42786 10.7206 4.17091 9.9883C4.91536 9.25463 6.02674 8.87499 7.49995 8.87499C8.97317 8.87499 10.0846 9.25463 10.8291 9.98831C11.5721 10.7206 12.025 11.8799 12.025 13.5999C12.025 13.8623 12.2376 14.0749 12.5 14.0749C12.7623 14.075 12.975 13.8623 12.975 13.6C12.975 11.72 12.4778 10.2794 11.4959 9.31166C10.7244 8.55135 9.70025 8.12903 8.50625 7.98352C10.0187 7.5474 11.125 6.15289 11.125 4.5C11.125 2.49797 9.50203 0.875 7.5 0.875ZM4.825 4.5C4.825 3.02264 6.02264 1.825 7.5 1.825C8.97736 1.825 10.175 3.02264 10.175 4.5C10.175 5.97736 8.97736 7.175 7.5 7.175C6.02264 7.175 4.825 5.97736 4.825 4.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3q = [
    "color"
];
var $e781b76dcad7c5d5$export$b86b18d4ddcc0181 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3q);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M1.85001 7.50043C1.85001 4.37975 4.37963 1.85001 7.50001 1.85001C10.6204 1.85001 13.15 4.37975 13.15 7.50043C13.15 10.6211 10.6204 13.1509 7.50001 13.1509C4.37963 13.1509 1.85001 10.6211 1.85001 7.50043ZM7.50001 0.850006C3.82728 0.850006 0.850006 3.82753 0.850006 7.50043C0.850006 11.1733 3.82728 14.1509 7.50001 14.1509C11.1727 14.1509 14.15 11.1733 14.15 7.50043C14.15 3.82753 11.1727 0.850006 7.50001 0.850006ZM7.00001 8.00001V3.12811C7.16411 3.10954 7.33094 3.10001 7.50001 3.10001C9.93006 3.10001 11.9 5.07014 11.9 7.50043C11.9 7.66935 11.8905 7.83604 11.872 8.00001H7.00001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3r = [
    "color"
];
var $e781b76dcad7c5d5$export$d5d0c446063e1490 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3r);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M3 5.5C3 7.983 4.99169 9 7 9V12.5C7 12.7761 7.22386 13 7.5 13C7.77614 13 8 12.7761 8 12.5V9V3.1H9V12.5C9 12.7761 9.22386 13 9.5 13C9.77614 13 10 12.7761 10 12.5V3.1H11.5C11.8038 3.1 12.05 2.85376 12.05 2.55C12.05 2.24624 11.8038 2 11.5 2H9.5H8H7.5H7C4.99169 2 3 3.017 3 5.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3s = [
    "color"
];
var $e781b76dcad7c5d5$export$f65249e0566edf55 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3s);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M13.5 13.95C13.7485 13.95 13.95 13.7485 13.95 13.5C13.95 13.2514 13.7485 13.05 13.5 13.05L1.49995 13.05C1.25142 13.05 1.04995 13.2514 1.04995 13.5C1.04995 13.7485 1.25142 13.95 1.49995 13.95L13.5 13.95ZM11.0681 7.5683C11.2439 7.39257 11.2439 7.10764 11.0681 6.93191C10.8924 6.75617 10.6075 6.75617 10.4317 6.93191L7.94993 9.41371L7.94993 1.49998C7.94993 1.25146 7.74846 1.04998 7.49993 1.04998C7.2514 1.04998 7.04993 1.25146 7.04993 1.49998L7.04993 9.41371L4.56813 6.93191C4.39239 6.75617 4.10746 6.75617 3.93173 6.93191C3.75599 7.10764 3.75599 7.39257 3.93173 7.5683L7.18173 10.8183C7.35746 10.994 7.64239 10.994 7.81812 10.8183L11.0681 7.5683Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3t = [
    "color"
];
var $e781b76dcad7c5d5$export$d57f0cfd6aca7ffa = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3t);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M2.05005 13.5C2.05005 13.7485 2.25152 13.95 2.50005 13.95C2.74858 13.95 2.95005 13.7485 2.95005 13.5L2.95005 1.49995C2.95005 1.25142 2.74858 1.04995 2.50005 1.04995C2.25152 1.04995 2.05005 1.25142 2.05005 1.49995L2.05005 13.5ZM8.4317 11.0681C8.60743 11.2439 8.89236 11.2439 9.06809 11.0681C9.24383 10.8924 9.24383 10.6075 9.06809 10.4317L6.58629 7.94993L14.5 7.94993C14.7485 7.94993 14.95 7.74846 14.95 7.49993C14.95 7.2514 14.7485 7.04993 14.5 7.04993L6.58629 7.04993L9.06809 4.56813C9.24383 4.39239 9.24383 4.10746 9.06809 3.93173C8.89236 3.75599 8.60743 3.75599 8.4317 3.93173L5.1817 7.18173C5.00596 7.35746 5.00596 7.64239 5.1817 7.81812L8.4317 11.0681Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3u = [
    "color"
];
var $e781b76dcad7c5d5$export$fe9311722b59190b = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3u);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M12.95 1.50005C12.95 1.25152 12.7485 1.05005 12.5 1.05005C12.2514 1.05005 12.05 1.25152 12.05 1.50005L12.05 13.5C12.05 13.7486 12.2514 13.95 12.5 13.95C12.7485 13.95 12.95 13.7486 12.95 13.5L12.95 1.50005ZM6.5683 3.93188C6.39257 3.75614 6.10764 3.75614 5.93191 3.93188C5.75617 4.10761 5.75617 4.39254 5.93191 4.56827L8.41371 7.05007L0.499984 7.05007C0.251456 7.05007 0.0499847 7.25155 0.0499847 7.50007C0.0499846 7.7486 0.251457 7.95007 0.499984 7.95007L8.41371 7.95007L5.93191 10.4319C5.75617 10.6076 5.75617 10.8925 5.93191 11.0683C6.10764 11.244 6.39257 11.244 6.56831 11.0683L9.8183 7.81827C9.99404 7.64254 9.99404 7.35761 9.8183 7.18188L6.5683 3.93188Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3v = [
    "color"
];
var $e781b76dcad7c5d5$export$71e4148884d34eff = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3v);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M1.50005 1.05005C1.25152 1.05005 1.05005 1.25152 1.05005 1.50005C1.05005 1.74858 1.25152 1.95005 1.50005 1.95005L13.5 1.95005C13.7486 1.95005 13.95 1.74858 13.95 1.50005C13.95 1.25152 13.7486 1.05005 13.5 1.05005H1.50005ZM3.93188 7.43169C3.75614 7.60743 3.75614 7.89236 3.93188 8.06809C4.10761 8.24383 4.39254 8.24383 4.56827 8.06809L7.05007 5.58629V13.5C7.05007 13.7485 7.25155 13.95 7.50007 13.95C7.7486 13.95 7.95007 13.7485 7.95007 13.5L7.95007 5.58629L10.4319 8.06809C10.6076 8.24383 10.8925 8.24383 11.0683 8.06809C11.244 7.89235 11.244 7.60743 11.0683 7.43169L7.81827 4.18169C7.64254 4.00596 7.35761 4.00596 7.18188 4.18169L3.93188 7.43169Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3w = [
    "color"
];
var $e781b76dcad7c5d5$export$a6630b90defda83f = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3w);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M3.24182 2.32181C3.3919 2.23132 3.5784 2.22601 3.73338 2.30781L12.7334 7.05781C12.8974 7.14436 13 7.31457 13 7.5C13 7.68543 12.8974 7.85564 12.7334 7.94219L3.73338 12.6922C3.5784 12.774 3.3919 12.7687 3.24182 12.6782C3.09175 12.5877 3 12.4252 3 12.25V2.75C3 2.57476 3.09175 2.4123 3.24182 2.32181ZM4 3.57925V11.4207L11.4288 7.5L4 3.57925Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3x = [
    "color"
];
var $e781b76dcad7c5d5$export$f21ab0717a89c77f = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3x);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M8 2.75C8 2.47386 7.77614 2.25 7.5 2.25C7.22386 2.25 7 2.47386 7 2.75V7H2.75C2.47386 7 2.25 7.22386 2.25 7.5C2.25 7.77614 2.47386 8 2.75 8H7V12.25C7 12.5261 7.22386 12.75 7.5 12.75C7.77614 12.75 8 12.5261 8 12.25V8H12.25C12.5261 8 12.75 7.77614 12.75 7.5C12.75 7.22386 12.5261 7 12.25 7H8V2.75Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3y = [
    "color"
];
var $e781b76dcad7c5d5$export$75a23c9e49a976a = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3y);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82707 7.49972C1.82707 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82707 10.6327 1.82707 7.49972ZM7.50003 4C7.77617 4 8.00003 4.22386 8.00003 4.5V7H10.5C10.7762 7 11 7.22386 11 7.5C11 7.77614 10.7762 8 10.5 8H8.00003V10.5C8.00003 10.7761 7.77617 11 7.50003 11C7.22389 11 7.00003 10.7761 7.00003 10.5V8H4.50003C4.22389 8 4.00003 7.77614 4.00003 7.5C4.00003 7.22386 4.22389 7 4.50003 7H7.00003V4.5C7.00003 4.22386 7.22389 4 7.50003 4Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3z = [
    "color"
];
var $e781b76dcad7c5d5$export$58a334b597cee6d6 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3z);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M5.07505 4.10001C5.07505 2.91103 6.25727 1.92502 7.50005 1.92502C8.74283 1.92502 9.92505 2.91103 9.92505 4.10001C9.92505 5.19861 9.36782 5.71436 8.61854 6.37884L8.58757 6.4063C7.84481 7.06467 6.92505 7.87995 6.92505 9.5C6.92505 9.81757 7.18248 10.075 7.50005 10.075C7.81761 10.075 8.07505 9.81757 8.07505 9.5C8.07505 8.41517 8.62945 7.90623 9.38156 7.23925L9.40238 7.22079C10.1496 6.55829 11.075 5.73775 11.075 4.10001C11.075 2.12757 9.21869 0.775024 7.50005 0.775024C5.7814 0.775024 3.92505 2.12757 3.92505 4.10001C3.92505 4.41758 4.18249 4.67501 4.50005 4.67501C4.81761 4.67501 5.07505 4.41758 5.07505 4.10001ZM7.50005 13.3575C7.9833 13.3575 8.37505 12.9657 8.37505 12.4825C8.37505 11.9992 7.9833 11.6075 7.50005 11.6075C7.0168 11.6075 6.62505 11.9992 6.62505 12.4825C6.62505 12.9657 7.0168 13.3575 7.50005 13.3575Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3A = [
    "color"
];
var $e781b76dcad7c5d5$export$2548f56a2855ec74 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3A);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M0.877075 7.49972C0.877075 3.84204 3.84222 0.876892 7.49991 0.876892C11.1576 0.876892 14.1227 3.84204 14.1227 7.49972C14.1227 11.1574 11.1576 14.1226 7.49991 14.1226C3.84222 14.1226 0.877075 11.1574 0.877075 7.49972ZM7.49991 1.82689C4.36689 1.82689 1.82708 4.36671 1.82708 7.49972C1.82708 10.6327 4.36689 13.1726 7.49991 13.1726C10.6329 13.1726 13.1727 10.6327 13.1727 7.49972C13.1727 4.36671 10.6329 1.82689 7.49991 1.82689ZM8.24993 10.5C8.24993 10.9142 7.91414 11.25 7.49993 11.25C7.08571 11.25 6.74993 10.9142 6.74993 10.5C6.74993 10.0858 7.08571 9.75 7.49993 9.75C7.91414 9.75 8.24993 10.0858 8.24993 10.5ZM6.05003 6.25C6.05003 5.57211 6.63511 4.925 7.50003 4.925C8.36496 4.925 8.95003 5.57211 8.95003 6.25C8.95003 6.74118 8.68002 6.99212 8.21447 7.27494C8.16251 7.30651 8.10258 7.34131 8.03847 7.37854L8.03841 7.37858C7.85521 7.48497 7.63788 7.61119 7.47449 7.73849C7.23214 7.92732 6.95003 8.23198 6.95003 8.7C6.95004 9.00376 7.19628 9.25 7.50004 9.25C7.8024 9.25 8.04778 9.00601 8.05002 8.70417L8.05056 8.7033C8.05924 8.6896 8.08493 8.65735 8.15058 8.6062C8.25207 8.52712 8.36508 8.46163 8.51567 8.37436L8.51571 8.37433C8.59422 8.32883 8.68296 8.27741 8.78559 8.21506C9.32004 7.89038 10.05 7.35382 10.05 6.25C10.05 4.92789 8.93511 3.825 7.50003 3.825C6.06496 3.825 4.95003 4.92789 4.95003 6.25C4.95003 6.55376 5.19628 6.8 5.50003 6.8C5.80379 6.8 6.05003 6.55376 6.05003 6.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3B = [
    "color"
];
var $e781b76dcad7c5d5$export$62bd98fc131b5caa = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3B);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M9.42503 3.44136C10.0561 3.23654 10.7837 3.2402 11.3792 3.54623C12.7532 4.25224 13.3477 6.07191 12.7946 8C12.5465 8.8649 12.1102 9.70472 11.1861 10.5524C10.262 11.4 8.98034 11.9 8.38571 11.9C8.17269 11.9 8 11.7321 8 11.525C8 11.3179 8.17644 11.15 8.38571 11.15C9.06497 11.15 9.67189 10.7804 10.3906 10.236C10.9406 9.8193 11.3701 9.28633 11.608 8.82191C12.0628 7.93367 12.0782 6.68174 11.3433 6.34901C10.9904 6.73455 10.5295 6.95946 9.97725 6.95946C8.7773 6.95946 8.0701 5.99412 8.10051 5.12009C8.12957 4.28474 8.66032 3.68954 9.42503 3.44136ZM3.42503 3.44136C4.05614 3.23654 4.78366 3.2402 5.37923 3.54623C6.7532 4.25224 7.34766 6.07191 6.79462 8C6.54654 8.8649 6.11019 9.70472 5.1861 10.5524C4.26201 11.4 2.98034 11.9 2.38571 11.9C2.17269 11.9 2 11.7321 2 11.525C2 11.3179 2.17644 11.15 2.38571 11.15C3.06497 11.15 3.67189 10.7804 4.39058 10.236C4.94065 9.8193 5.37014 9.28633 5.60797 8.82191C6.06282 7.93367 6.07821 6.68174 5.3433 6.34901C4.99037 6.73455 4.52948 6.95946 3.97725 6.95946C2.7773 6.95946 2.0701 5.99412 2.10051 5.12009C2.12957 4.28474 2.66032 3.68954 3.42503 3.44136Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3C = [
    "color"
];
var $e781b76dcad7c5d5$export$c617f5f26da0904b = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3C);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.49985 0.877045C3.84216 0.877045 0.877014 3.84219 0.877014 7.49988C0.877014 11.1575 3.84216 14.1227 7.49985 14.1227C11.1575 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 3.84219 11.1575 0.877045 7.49985 0.877045ZM1.82701 7.49988C1.82701 4.36686 4.36683 1.82704 7.49985 1.82704C10.6328 1.82704 13.1727 4.36686 13.1727 7.49988C13.1727 10.6329 10.6328 13.1727 7.49985 13.1727C4.36683 13.1727 1.82701 10.6329 1.82701 7.49988ZM7.49999 9.49999C8.60456 9.49999 9.49999 8.60456 9.49999 7.49999C9.49999 6.39542 8.60456 5.49999 7.49999 5.49999C6.39542 5.49999 5.49999 6.39542 5.49999 7.49999C5.49999 8.60456 6.39542 9.49999 7.49999 9.49999Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3D = [
    "color"
];
var $e781b76dcad7c5d5$export$b6cede2da0e4d831 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3D);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M4.2 1H4.17741H4.1774C3.86936 0.999988 3.60368 0.999978 3.38609 1.02067C3.15576 1.04257 2.92825 1.09113 2.71625 1.22104C2.51442 1.34472 2.34473 1.51442 2.22104 1.71625C2.09113 1.92825 2.04257 2.15576 2.02067 2.38609C1.99998 2.60367 1.99999 2.86935 2 3.17738V3.1774V3.2V11.8V11.8226V11.8226C1.99999 12.1307 1.99998 12.3963 2.02067 12.6139C2.04257 12.8442 2.09113 13.0717 2.22104 13.2837C2.34473 13.4856 2.51442 13.6553 2.71625 13.779C2.92825 13.9089 3.15576 13.9574 3.38609 13.9793C3.60368 14 3.86937 14 4.17741 14H4.2H10.8H10.8226C11.1306 14 11.3963 14 11.6139 13.9793C11.8442 13.9574 12.0717 13.9089 12.2837 13.779C12.4856 13.6553 12.6553 13.4856 12.779 13.2837C12.9089 13.0717 12.9574 12.8442 12.9793 12.6139C13 12.3963 13 12.1306 13 11.8226V11.8V3.2V3.17741C13 2.86936 13 2.60368 12.9793 2.38609C12.9574 2.15576 12.9089 1.92825 12.779 1.71625C12.6553 1.51442 12.4856 1.34472 12.2837 1.22104C12.0717 1.09113 11.8442 1.04257 11.6139 1.02067C11.3963 0.999978 11.1306 0.999988 10.8226 1H10.8H4.2ZM3.23875 2.07368C3.26722 2.05623 3.32362 2.03112 3.48075 2.01618C3.64532 2.00053 3.86298 2 4.2 2H10.8C11.137 2 11.3547 2.00053 11.5193 2.01618C11.6764 2.03112 11.7328 2.05623 11.7613 2.07368C11.8285 2.11491 11.8851 2.17147 11.9263 2.23875C11.9438 2.26722 11.9689 2.32362 11.9838 2.48075C11.9995 2.64532 12 2.86298 12 3.2V11.8C12 12.137 11.9995 12.3547 11.9838 12.5193C11.9689 12.6764 11.9438 12.7328 11.9263 12.7613C11.8851 12.8285 11.8285 12.8851 11.7613 12.9263C11.7328 12.9438 11.6764 12.9689 11.5193 12.9838C11.3547 12.9995 11.137 13 10.8 13H4.2C3.86298 13 3.64532 12.9995 3.48075 12.9838C3.32362 12.9689 3.26722 12.9438 3.23875 12.9263C3.17147 12.8851 3.11491 12.8285 3.07368 12.7613C3.05624 12.7328 3.03112 12.6764 3.01618 12.5193C3.00053 12.3547 3 12.137 3 11.8V3.2C3 2.86298 3.00053 2.64532 3.01618 2.48075C3.03112 2.32362 3.05624 2.26722 3.07368 2.23875C3.11491 2.17147 3.17147 2.11491 3.23875 2.07368ZM5 10C4.72386 10 4.5 10.2239 4.5 10.5C4.5 10.7761 4.72386 11 5 11H8C8.27614 11 8.5 10.7761 8.5 10.5C8.5 10.2239 8.27614 10 8 10H5ZM4.5 7.5C4.5 7.22386 4.72386 7 5 7H10C10.2761 7 10.5 7.22386 10.5 7.5C10.5 7.77614 10.2761 8 10 8H5C4.72386 8 4.5 7.77614 4.5 7.5ZM5 4C4.72386 4 4.5 4.22386 4.5 4.5C4.5 4.77614 4.72386 5 5 5H10C10.2761 5 10.5 4.77614 10.5 4.5C10.5 4.22386 10.2761 4 10 4H5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3E = [
    "color"
];
var $e781b76dcad7c5d5$export$ca36f1a1d2d1ca14 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3E);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M1.84998 7.49998C1.84998 4.66458 4.05979 1.84998 7.49998 1.84998C10.2783 1.84998 11.6515 3.9064 12.2367 5H10.5C10.2239 5 10 5.22386 10 5.5C10 5.77614 10.2239 6 10.5 6H13.5C13.7761 6 14 5.77614 14 5.5V2.5C14 2.22386 13.7761 2 13.5 2C13.2239 2 13 2.22386 13 2.5V4.31318C12.2955 3.07126 10.6659 0.849976 7.49998 0.849976C3.43716 0.849976 0.849976 4.18537 0.849976 7.49998C0.849976 10.8146 3.43716 14.15 7.49998 14.15C9.44382 14.15 11.0622 13.3808 12.2145 12.2084C12.8315 11.5806 13.3133 10.839 13.6418 10.0407C13.7469 9.78536 13.6251 9.49315 13.3698 9.38806C13.1144 9.28296 12.8222 9.40478 12.7171 9.66014C12.4363 10.3425 12.0251 10.9745 11.5013 11.5074C10.5295 12.4963 9.16504 13.15 7.49998 13.15C4.05979 13.15 1.84998 10.3354 1.84998 7.49998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3F = [
    "color"
];
var $e781b76dcad7c5d5$export$7637ad60dd86d3b1 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3F);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M4.85355 2.14645C5.04882 2.34171 5.04882 2.65829 4.85355 2.85355L3.70711 4H9C11.4853 4 13.5 6.01472 13.5 8.5C13.5 10.9853 11.4853 13 9 13H5C4.72386 13 4.5 12.7761 4.5 12.5C4.5 12.2239 4.72386 12 5 12H9C10.933 12 12.5 10.433 12.5 8.5C12.5 6.567 10.933 5 9 5H3.70711L4.85355 6.14645C5.04882 6.34171 5.04882 6.65829 4.85355 6.85355C4.65829 7.04882 4.34171 7.04882 4.14645 6.85355L2.14645 4.85355C1.95118 4.65829 1.95118 4.34171 2.14645 4.14645L4.14645 2.14645C4.34171 1.95118 4.65829 1.95118 4.85355 2.14645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3G = [
    "color"
];
var $e781b76dcad7c5d5$export$199745d7f18c0761 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3G);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M3.04995 2.74995C3.04995 2.44619 2.80371 2.19995 2.49995 2.19995C2.19619 2.19995 1.94995 2.44619 1.94995 2.74995V12.25C1.94995 12.5537 2.19619 12.8 2.49995 12.8C2.80371 12.8 3.04995 12.5537 3.04995 12.25V2.74995ZM5.73333 2.30776C5.57835 2.22596 5.39185 2.23127 5.24177 2.32176C5.0917 2.41225 4.99995 2.57471 4.99995 2.74995V12.25C4.99995 12.4252 5.0917 12.5877 5.24177 12.6781C5.39185 12.7686 5.57835 12.7739 5.73333 12.6921L14.7333 7.94214C14.8973 7.85559 15 7.68539 15 7.49995C15 7.31452 14.8973 7.14431 14.7333 7.05776L5.73333 2.30776ZM5.99995 11.4207V3.5792L13.4287 7.49995L5.99995 11.4207Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3H = [
    "color"
];
var $e781b76dcad7c5d5$export$8e0d2500d5bd92ef = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3H);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M6.85357 3.85355L7.65355 3.05353C8.2981 2.40901 9.42858 1.96172 10.552 1.80125C11.1056 1.72217 11.6291 1.71725 12.0564 1.78124C12.4987 1.84748 12.7698 1.97696 12.8965 2.10357C13.0231 2.23018 13.1526 2.50125 13.2188 2.94357C13.2828 3.37086 13.2779 3.89439 13.1988 4.44801C13.0383 5.57139 12.591 6.70188 11.9464 7.34645L7.49999 11.7929L6.35354 10.6465C6.15827 10.4512 5.84169 10.4512 5.64643 10.6465C5.45117 10.8417 5.45117 11.1583 5.64643 11.3536L7.14644 12.8536C7.34171 13.0488 7.65829 13.0488 7.85355 12.8536L8.40073 12.3064L9.57124 14.2572C9.65046 14.3893 9.78608 14.4774 9.9389 14.4963C10.0917 14.5151 10.2447 14.4624 10.3535 14.3536L12.3535 12.3536C12.4648 12.2423 12.5172 12.0851 12.495 11.9293L12.0303 8.67679L12.6536 8.05355C13.509 7.19808 14.0117 5.82855 14.1887 4.58943C14.2784 3.9618 14.2891 3.33847 14.2078 2.79546C14.1287 2.26748 13.9519 1.74482 13.6035 1.39645C13.2552 1.04809 12.7325 0.871332 12.2045 0.792264C11.6615 0.710945 11.0382 0.721644 10.4105 0.8113C9.17143 0.988306 7.80189 1.491 6.94644 2.34642L6.32322 2.96968L3.07071 2.50504C2.91492 2.48278 2.75773 2.53517 2.64645 2.64646L0.646451 4.64645C0.537579 4.75533 0.484938 4.90829 0.50375 5.0611C0.522563 5.21391 0.61073 5.34954 0.742757 5.42876L2.69364 6.59928L2.14646 7.14645C2.0527 7.24022 2.00002 7.3674 2.00002 7.50001C2.00002 7.63261 2.0527 7.75979 2.14646 7.85356L3.64647 9.35356C3.84173 9.54883 4.15831 9.54883 4.35357 9.35356C4.54884 9.1583 4.54884 8.84172 4.35357 8.64646L3.20712 7.50001L3.85357 6.85356L6.85357 3.85355ZM10.0993 13.1936L9.12959 11.5775L11.1464 9.56067L11.4697 11.8232L10.0993 13.1936ZM3.42251 5.87041L5.43935 3.85356L3.17678 3.53034L1.80638 4.90074L3.42251 5.87041ZM2.35356 10.3535C2.54882 10.1583 2.54882 9.8417 2.35356 9.64644C2.1583 9.45118 1.84171 9.45118 1.64645 9.64644L0.646451 10.6464C0.451188 10.8417 0.451188 11.1583 0.646451 11.3535C0.841713 11.5488 1.1583 11.5488 1.35356 11.3535L2.35356 10.3535ZM3.85358 11.8536C4.04884 11.6583 4.04885 11.3417 3.85359 11.1465C3.65833 10.9512 3.34175 10.9512 3.14648 11.1465L1.14645 13.1464C0.95119 13.3417 0.951187 13.6583 1.14645 13.8535C1.34171 14.0488 1.65829 14.0488 1.85355 13.8536L3.85358 11.8536ZM5.35356 13.3535C5.54882 13.1583 5.54882 12.8417 5.35356 12.6464C5.1583 12.4512 4.84171 12.4512 4.64645 12.6464L3.64645 13.6464C3.45119 13.8417 3.45119 14.1583 3.64645 14.3535C3.84171 14.5488 4.1583 14.5488 4.35356 14.3535L5.35356 13.3535ZM9.49997 6.74881C10.1897 6.74881 10.7488 6.1897 10.7488 5.5C10.7488 4.8103 10.1897 4.25118 9.49997 4.25118C8.81026 4.25118 8.25115 4.8103 8.25115 5.5C8.25115 6.1897 8.81026 6.74881 9.49997 6.74881Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3I = [
    "color"
];
var $e781b76dcad7c5d5$export$f0960ce3e1a6f234 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3I);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.59664 2.93628C7.76085 3.06401 8.00012 2.94698 8.00012 2.73895V1.99998C9.98143 2 11.1848 2.3637 11.9105 3.08945C12.6363 3.81522 13 5.0186 13 6.99998C13 7.27613 13.2239 7.49998 13.5 7.49998C13.7761 7.49998 14 7.27613 14 6.99998C14 4.9438 13.6325 3.39719 12.6176 2.38234C11.6028 1.36752 10.0562 0.999999 8.00012 0.999984V0.261266C8.00012 0.0532293 7.76085 -0.0637944 7.59664 0.063928L6.00384 1.30277C5.87516 1.40286 5.87516 1.59735 6.00384 1.69744L7.59664 2.93628ZM9.5 5H2.5C2.22386 5 2 5.22386 2 5.5V12.5C2 12.7761 2.22386 13 2.5 13H9.5C9.77614 13 10 12.7761 10 12.5V5.5C10 5.22386 9.77614 5 9.5 5ZM2.5 4C1.67157 4 1 4.67157 1 5.5V12.5C1 13.3284 1.67157 14 2.5 14H9.5C10.3284 14 11 13.3284 11 12.5V5.5C11 4.67157 10.3284 4 9.5 4H2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3J = [
    "color"
];
var $e781b76dcad7c5d5$export$f0399077805ff597 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3J);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.81832 0.68179C7.64258 0.506054 7.35766 0.506054 7.18192 0.68179L5.18192 2.68179C5.00619 2.85753 5.00619 3.14245 5.18192 3.31819C5.35766 3.49392 5.64258 3.49392 5.81832 3.31819L7.05012 2.08638L7.05012 5.50023C7.05012 5.74876 7.25159 5.95023 7.50012 5.95023C7.74865 5.95023 7.95012 5.74876 7.95012 5.50023L7.95012 2.08638L9.18192 3.31819C9.35766 3.49392 9.64258 3.49392 9.81832 3.31819C9.99406 3.14245 9.99406 2.85753 9.81832 2.68179L7.81832 0.68179ZM7.95012 12.9136V9.50023C7.95012 9.2517 7.74865 9.05023 7.50012 9.05023C7.25159 9.05023 7.05012 9.2517 7.05012 9.50023V12.9136L5.81832 11.6818C5.64258 11.5061 5.35766 11.5061 5.18192 11.6818C5.00619 11.8575 5.00619 12.1424 5.18192 12.3182L7.18192 14.3182C7.26632 14.4026 7.38077 14.45 7.50012 14.45C7.61947 14.45 7.73393 14.4026 7.81832 14.3182L9.81832 12.3182C9.99406 12.1424 9.99406 11.8575 9.81832 11.6818C9.64258 11.5061 9.35766 11.5061 9.18192 11.6818L7.95012 12.9136ZM1.49994 7.00017C1.2238 7.00017 0.999939 7.22403 0.999939 7.50017C0.999939 7.77631 1.2238 8.00017 1.49994 8.00017L13.4999 8.00017C13.7761 8.00017 13.9999 7.77631 13.9999 7.50017C13.9999 7.22403 13.7761 7.00017 13.4999 7.00017L1.49994 7.00017Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3K = [
    "color"
];
var $e781b76dcad7c5d5$export$472271f3e918e2f4 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3K);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M14 12.85L1 12.85L1 14.15L14 14.15L14 12.85ZM14 8.85002L1 8.85002L1 10.15L14 10.15L14 8.85002ZM1 4.85003L14 4.85003L14 6.15003L1 6.15002L1 4.85003ZM14 0.850025L1 0.850025L1 2.15002L14 2.15002L14 0.850025Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3L = [
    "color"
];
var $e781b76dcad7c5d5$export$c3403272e8c8becf = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3L);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M0.5 4C0.223858 4 0 4.22386 0 4.5V10.5C0 10.7761 0.223858 11 0.5 11H14.5C14.7761 11 15 10.7761 15 10.5V4.5C15 4.22386 14.7761 4 14.5 4H0.5ZM1 10V5H2.075V7.5C2.075 7.73472 2.26528 7.925 2.5 7.925C2.73472 7.925 2.925 7.73472 2.925 7.5V5H4.075V6.5C4.075 6.73472 4.26528 6.925 4.5 6.925C4.73472 6.925 4.925 6.73472 4.925 6.5V5H6.075V6.5C6.075 6.73472 6.26528 6.925 6.5 6.925C6.73472 6.925 6.925 6.73472 6.925 6.5V5H8.075V7.5C8.075 7.73472 8.26528 7.925 8.5 7.925C8.73472 7.925 8.925 7.73472 8.925 7.5V5H10.075V6.5C10.075 6.73472 10.2653 6.925 10.5 6.925C10.7347 6.925 10.925 6.73472 10.925 6.5V5H12.075V6.5C12.075 6.73472 12.2653 6.925 12.5 6.925C12.7347 6.925 12.925 6.73472 12.925 6.5V5H14V10H1Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3M = [
    "color"
];
var $e781b76dcad7c5d5$export$e940813548ac56bd = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3M);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M0.5 0C0.223858 0 0 0.223858 0 0.5V14.5C0 14.7761 0.223858 15 0.5 15H4.5C4.77614 15 5 14.7761 5 14.5V5H14.5C14.7761 5 15 4.77614 15 4.5V0.5C15 0.223858 14.7761 0 14.5 0H0.5ZM1 4.07505L1 1H4.07502C4.07502 1 4.07502 1 4.07502 1L4.07505 4.07507L1 4.07505ZM0.999997 4.92505L1 14H4V12.925H2.75002C2.5153 12.925 2.32502 12.7348 2.32502 12.5C2.32502 12.2653 2.5153 12.075 2.75002 12.075H4V10.925H2.25002C2.0153 10.925 1.82502 10.7347 1.82502 10.5C1.82502 10.2653 2.0153 10.075 2.25002 10.075H4V8.92504L2.75002 8.92502C2.5153 8.92502 2.32502 8.73474 2.32502 8.50002C2.32503 8.26529 2.51531 8.07502 2.75003 8.07502L4 8.07504V6.92502L2.74999 6.925C2.51527 6.925 2.325 6.73472 2.325 6.5C2.325 6.26528 2.51529 6.075 2.75001 6.075L4 6.07502V4.92507L0.999997 4.92505ZM4.92505 4H6.075V2.75006C6.075 2.51534 6.26528 2.32506 6.5 2.32506C6.73472 2.32506 6.925 2.51534 6.925 2.75006V4H8.07502V2.75005C8.07502 2.51533 8.2653 2.32505 8.50002 2.32505C8.73474 2.32505 8.92502 2.51533 8.92502 2.75005V4H10.0751V2.25005C10.0751 2.01533 10.2653 1.82505 10.5001 1.82505C10.7348 1.82505 10.9251 2.01533 10.9251 2.25005V4H12.0751V2.75005C12.0751 2.51533 12.2654 2.32505 12.5001 2.32505C12.7348 2.32505 12.9251 2.51533 12.9251 2.75005V4H14V1H4.92502L4.92505 4Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3N = [
    "color"
];
var $e781b76dcad7c5d5$export$ca010e7ed4ef0790 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3N);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M0.949988 4.48455C0.949988 5.34059 1.64395 6.03455 2.49999 6.03455C3.35603 6.03455 4.04999 5.34059 4.04999 4.48455C4.04999 3.6285 3.35603 2.93455 2.49999 2.93455C1.64395 2.93455 0.949988 3.6285 0.949988 4.48455ZM2.49999 6.93455C1.14689 6.93455 0.0499878 5.83764 0.0499878 4.48455C0.0499878 3.13145 1.14689 2.03455 2.49999 2.03455C3.85309 2.03455 4.94999 3.13145 4.94999 4.48455C4.94999 4.80813 4.88726 5.11707 4.77329 5.39985L5.73655 6.04413C5.72943 6.06656 5.72269 6.08914 5.71635 6.11188L5.56288 6.66186L5.21005 6.89773L4.21554 6.23366C3.77357 6.6672 3.168 6.93455 2.49999 6.93455ZM0.949991 10.5C0.949991 9.64394 1.64395 8.94998 2.49999 8.94998C3.35603 8.94998 4.04999 9.64394 4.04999 10.5C4.04999 11.356 3.35603 12.05 2.49999 12.05C1.64395 12.05 0.949991 11.356 0.949991 10.5ZM2.49999 8.04998C1.14689 8.04998 0.0499908 9.14688 0.0499908 10.5C0.0499908 11.8531 1.14689 12.95 2.49999 12.95C3.85309 12.95 4.94999 11.8531 4.94999 10.5C4.94999 10.1803 4.88877 9.87497 4.77743 9.595L15 2.75737L14.0486 2.85737C12.7077 2.9983 11.4091 3.40895 10.231 4.06461L7.15646 5.77564C6.92307 5.90553 6.75134 6.12339 6.67955 6.38066L6.42653 7.28737L4.22437 8.75957C3.78166 8.32091 3.17246 8.04998 2.49999 8.04998ZM7.14435 9.2149L7.15646 9.22176L10.231 10.9328C11.4091 11.5884 12.7077 11.9991 14.0486 12.14L15 12.24L8.81072 8.1003L7.14435 9.2149Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3O = [
    "color"
];
var $e781b76dcad7c5d5$export$ab8815222a429372 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3O);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M2 1.5C2 1.77614 1.77614 2 1.5 2C1.22386 2 1 1.77614 1 1.5C1 1.22386 1.22386 1 1.5 1C1.77614 1 2 1.22386 2 1.5ZM2 5L2 10H13V5H2ZM2 4C1.44772 4 1 4.44772 1 5V10C1 10.5523 1.44772 11 2 11H13C13.5523 11 14 10.5523 14 10V5C14 4.44772 13.5523 4 13 4H2ZM1.5 14C1.77614 14 2 13.7761 2 13.5C2 13.2239 1.77614 13 1.5 13C1.22386 13 1 13.2239 1 13.5C1 13.7761 1.22386 14 1.5 14ZM4 1.5C4 1.77614 3.77614 2 3.5 2C3.22386 2 3 1.77614 3 1.5C3 1.22386 3.22386 1 3.5 1C3.77614 1 4 1.22386 4 1.5ZM3.5 14C3.77614 14 4 13.7761 4 13.5C4 13.2239 3.77614 13 3.5 13C3.22386 13 3 13.2239 3 13.5C3 13.7761 3.22386 14 3.5 14ZM6 1.5C6 1.77614 5.77614 2 5.5 2C5.22386 2 5 1.77614 5 1.5C5 1.22386 5.22386 1 5.5 1C5.77614 1 6 1.22386 6 1.5ZM5.5 14C5.77614 14 6 13.7761 6 13.5C6 13.2239 5.77614 13 5.5 13C5.22386 13 5 13.2239 5 13.5C5 13.7761 5.22386 14 5.5 14ZM8 1.5C8 1.77614 7.77614 2 7.5 2C7.22386 2 7 1.77614 7 1.5C7 1.22386 7.22386 1 7.5 1C7.77614 1 8 1.22386 8 1.5ZM7.5 14C7.77614 14 8 13.7761 8 13.5C8 13.2239 7.77614 13 7.5 13C7.22386 13 7 13.2239 7 13.5C7 13.7761 7.22386 14 7.5 14ZM10 1.5C10 1.77614 9.77614 2 9.5 2C9.22386 2 9 1.77614 9 1.5C9 1.22386 9.22386 1 9.5 1C9.77614 1 10 1.22386 10 1.5ZM9.5 14C9.77614 14 10 13.7761 10 13.5C10 13.2239 9.77614 13 9.5 13C9.22386 13 9 13.2239 9 13.5C9 13.7761 9.22386 14 9.5 14ZM12 1.5C12 1.77614 11.7761 2 11.5 2C11.2239 2 11 1.77614 11 1.5C11 1.22386 11.2239 1 11.5 1C11.7761 1 12 1.22386 12 1.5ZM11.5 14C11.7761 14 12 13.7761 12 13.5C12 13.2239 11.7761 13 11.5 13C11.2239 13 11 13.2239 11 13.5C11 13.7761 11.2239 14 11.5 14ZM14 1.5C14 1.77614 13.7761 2 13.5 2C13.2239 2 13 1.77614 13 1.5C13 1.22386 13.2239 1 13.5 1C13.7761 1 14 1.22386 14 1.5ZM13.5 14C13.7761 14 14 13.7761 14 13.5C14 13.2239 13.7761 13 13.5 13C13.2239 13 13 13.2239 13 13.5C13 13.7761 13.2239 14 13.5 14Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3P = [
    "color"
];
var $e781b76dcad7c5d5$export$9a1f3409566e1d35 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3P);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M6 3.5C6 2.67157 6.67157 2 7.5 2C8.32843 2 9 2.67157 9 3.5C9 4.32843 8.32843 5 7.5 5C6.67157 5 6 4.32843 6 3.5ZM8 5.94999C9.14112 5.71836 10 4.70948 10 3.5C10 2.11929 8.88071 1 7.5 1C6.11929 1 5 2.11929 5 3.5C5 4.70948 5.85888 5.71836 7 5.94999V13.5C7 13.7761 7.22386 14 7.5 14C7.77614 14 8 13.7761 8 13.5V5.94999Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3Q = [
    "color"
];
var $e781b76dcad7c5d5$export$8217100f92ae3d76 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3Q);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M10 3.5C10 4.70948 9.14112 5.71836 8 5.94999V13.5C8 13.7761 7.77614 14 7.5 14C7.22386 14 7 13.7761 7 13.5V5.94999C5.85888 5.71836 5 4.70948 5 3.5C5 2.11929 6.11929 1 7.5 1C8.88071 1 10 2.11929 10 3.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3R = [
    "color"
];
var $e781b76dcad7c5d5$export$30dea8f5f241e3b3 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3R);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        opacity: ".05",
        d: "M6.78296 13.376C8.73904 9.95284 8.73904 5.04719 6.78296 1.62405L7.21708 1.37598C9.261 4.95283 9.261 10.0472 7.21708 13.624L6.78296 13.376Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        opacity: ".1",
        d: "M7.28204 13.4775C9.23929 9.99523 9.23929 5.00475 7.28204 1.52248L7.71791 1.2775C9.76067 4.9119 9.76067 10.0881 7.71791 13.7225L7.28204 13.4775Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        opacity: ".15",
        d: "M7.82098 13.5064C9.72502 9.99523 9.72636 5.01411 7.82492 1.50084L8.26465 1.26285C10.2465 4.92466 10.2451 10.085 8.26052 13.7448L7.82098 13.5064Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        opacity: ".2",
        d: "M8.41284 13.429C10.1952 9.92842 10.1957 5.07537 8.41435 1.57402L8.85999 1.34729C10.7139 4.99113 10.7133 10.0128 8.85841 13.6559L8.41284 13.429Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        opacity: ".25",
        d: "M9.02441 13.2956C10.6567 9.8379 10.6586 5.17715 9.03005 1.71656L9.48245 1.50366C11.1745 5.09919 11.1726 9.91629 9.47657 13.5091L9.02441 13.2956Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        opacity: ".3",
        d: "M9.66809 13.0655C11.1097 9.69572 11.1107 5.3121 9.67088 1.94095L10.1307 1.74457C11.6241 5.24121 11.6231 9.76683 10.1278 13.2622L9.66809 13.0655Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        opacity: ".35",
        d: "M10.331 12.7456C11.5551 9.52073 11.5564 5.49103 10.3347 2.26444L10.8024 2.0874C12.0672 5.42815 12.0659 9.58394 10.7985 12.9231L10.331 12.7456Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        opacity: ".4",
        d: "M11.0155 12.2986C11.9938 9.29744 11.9948 5.71296 11.0184 2.71067L11.4939 2.55603C12.503 5.6589 12.502 9.35178 11.4909 12.4535L11.0155 12.2986Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        opacity: ".45",
        d: "M11.7214 11.668C12.4254 9.01303 12.4262 5.99691 11.7237 3.34116L12.2071 3.21329C12.9318 5.95292 12.931 9.05728 12.2047 11.7961L11.7214 11.668Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        opacity: ".5",
        d: "M12.4432 10.752C12.8524 8.63762 12.8523 6.36089 12.4429 4.2466L12.9338 4.15155C13.3553 6.32861 13.3554 8.66985 12.9341 10.847L12.4432 10.752Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        d: "M0.877075 7.49988C0.877075 3.84219 3.84222 0.877045 7.49991 0.877045C11.1576 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49988ZM7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 4.36686 10.6329 1.82704 7.49991 1.82704Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3S = [
    "color"
];
var $e781b76dcad7c5d5$export$c7400a1254b7566e = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3S);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        opacity: ".05",
        d: "M12.1619 3.85182C8.35817 4.88918 4.88936 8.358 3.85199 12.1617L3.3696 12.0301C4.45356 8.05564 8.05581 4.45339 12.0303 3.36943L12.1619 3.85182Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        opacity: ".1",
        d: "M11.8807 3.42707C8.03441 4.50542 4.50561 8.03422 3.42726 11.8805L2.94582 11.7456C4.07129 7.73121 7.7314 4.0711 11.7458 2.94563L11.8807 3.42707Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        opacity: ".15",
        d: "M11.5201 3.02556C7.69092 4.16199 4.16779 7.68323 3.02805 11.512L2.54883 11.3694C3.73676 7.37869 7.38659 3.73076 11.3778 2.54623L11.5201 3.02556Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        opacity: ".2",
        d: "M11.0468 2.66169C7.31117 3.87664 3.87918 7.3079 2.66298 11.0434L2.18754 10.8886C3.45324 7.00109 7.00445 3.45062 10.8921 2.18621L11.0468 2.66169Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        opacity: ".25",
        d: "M10.5201 2.32365C6.92091 3.61447 3.62391 6.90876 2.32845 10.5073L1.858 10.338C3.20398 6.59909 6.61155 3.19424 10.3513 1.85301L10.5201 2.32365Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        opacity: ".3",
        d: "M9.90222 2.03122C6.50003 3.39465 3.39968 6.49367 2.03399 9.89551L1.56998 9.70924C2.98651 6.18076 6.18728 2.98133 9.71622 1.5671L9.90222 2.03122Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        opacity: ".35",
        d: "M9.20727 1.78873C6.06136 3.20349 3.21103 6.05203 1.79331 9.19738L1.33747 8.99192C2.80536 5.73528 5.74485 2.7976 9.0022 1.33272L9.20727 1.78873Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        opacity: ".4",
        d: "M8.40713 1.62085C5.59323 3.05117 3.05794 5.58509 1.62544 8.39847L1.17987 8.1716C2.66036 5.26397 5.27232 2.6534 8.18057 1.17513L8.40713 1.62085Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        opacity: ".45",
        d: "M7.46207 1.56747C5.08689 2.94695 2.95362 5.07912 1.57249 7.45379L1.14028 7.20241C2.56503 4.75273 4.7607 2.55818 7.21096 1.1351L7.46207 1.56747Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        opacity: ".5",
        d: "M6.30407 1.70487C4.51964 2.91063 2.90983 4.52061 1.7043 6.30513L1.28998 6.02524C2.5313 4.18773 4.18673 2.53214 6.02413 1.29059L6.30407 1.70487Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        d: "M0.877075 7.49988C0.877075 3.84219 3.84222 0.877045 7.49991 0.877045C11.1576 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49988ZM7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 4.36686 10.6329 1.82704 7.49991 1.82704Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3T = [
    "color"
];
var $e781b76dcad7c5d5$export$126350cae9fbd558 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3T);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        opacity: ".05",
        d: "M6.78296 13.376C8.73904 9.95284 8.73904 5.04719 6.78296 1.62405L7.21708 1.37598C9.261 4.95283 9.261 10.0472 7.21708 13.624L6.78296 13.376Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        opacity: ".1",
        d: "M7.28204 13.4775C9.23929 9.99523 9.23929 5.00475 7.28204 1.52248L7.71791 1.2775C9.76067 4.9119 9.76067 10.0881 7.71791 13.7225L7.28204 13.4775Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        opacity: ".15",
        d: "M7.82098 13.5064C9.72502 9.99523 9.72636 5.01411 7.82492 1.50084L8.26465 1.26285C10.2465 4.92466 10.2451 10.085 8.26052 13.7448L7.82098 13.5064Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        opacity: ".2",
        d: "M8.41284 13.429C10.1952 9.92842 10.1957 5.07537 8.41435 1.57402L8.85999 1.34729C10.7139 4.99113 10.7133 10.0128 8.85841 13.6559L8.41284 13.429Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        opacity: ".25",
        d: "M9.02441 13.2956C10.6567 9.8379 10.6586 5.17715 9.03005 1.71656L9.48245 1.50366C11.1745 5.09919 11.1726 9.91629 9.47657 13.5091L9.02441 13.2956Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        opacity: ".3",
        d: "M9.66809 13.0655C11.1097 9.69572 11.1107 5.3121 9.67088 1.94095L10.1307 1.74457C11.6241 5.24121 11.6231 9.76683 10.1278 13.2622L9.66809 13.0655Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        opacity: ".35",
        d: "M10.331 12.7456C11.5551 9.52073 11.5564 5.49103 10.3347 2.26444L10.8024 2.0874C12.0672 5.42815 12.0659 9.58394 10.7985 12.9231L10.331 12.7456Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        opacity: ".4",
        d: "M11.0155 12.2986C11.9938 9.29744 11.9948 5.71296 11.0184 2.71067L11.4939 2.55603C12.503 5.6589 12.502 9.35178 11.4909 12.4535L11.0155 12.2986Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        opacity: ".45",
        d: "M11.7214 11.668C12.4254 9.01303 12.4262 5.99691 11.7237 3.34116L12.2071 3.21329C12.9318 5.95292 12.931 9.05728 12.2047 11.7961L11.7214 11.668Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        opacity: ".5",
        d: "M12.4432 10.752C12.8524 8.63762 12.8523 6.36089 12.4429 4.2466L12.9338 4.15155C13.3553 6.32861 13.3554 8.66985 12.9341 10.847L12.4432 10.752Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.49991 0.877045C3.84222 0.877045 0.877075 3.84219 0.877075 7.49988C0.877075 9.1488 1.47969 10.657 2.4767 11.8162L1.64647 12.6464C1.45121 12.8417 1.45121 13.1583 1.64647 13.3535C1.84173 13.5488 2.15832 13.5488 2.35358 13.3535L3.18383 12.5233C4.34302 13.5202 5.8511 14.1227 7.49991 14.1227C11.1576 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 5.85107 13.5202 4.34298 12.5233 3.1838L13.3536 2.35355C13.5488 2.15829 13.5488 1.8417 13.3536 1.64644C13.1583 1.45118 12.8417 1.45118 12.6465 1.64644L11.8162 2.47667C10.657 1.47966 9.14883 0.877045 7.49991 0.877045ZM11.1423 3.15065C10.1568 2.32449 8.88644 1.82704 7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 8.88641 2.32452 10.1568 3.15069 11.1422L11.1423 3.15065ZM3.85781 11.8493C4.84322 12.6753 6.11348 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 6.11345 12.6754 4.84319 11.8493 3.85778L3.85781 11.8493Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3U = [
    "color"
];
var $e781b76dcad7c5d5$export$a3edb785270158f1 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3U);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        opacity: ".05",
        d: "M12.1398 3.88617C13.8553 4.94159 15 6.83701 15 9.00001C15 12.3137 12.3137 15 9.00002 15C6.84351 15 4.95296 13.8621 3.89569 12.1552L4.32076 11.8919C5.29069 13.4578 7.02376 14.5 9.00002 14.5C12.0376 14.5 14.5 12.0375 14.5 9.00001C14.5 7.01781 13.4516 5.28027 11.8778 4.31203L12.1398 3.88617Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        opacity: ".2",
        d: "M12.851 5.07321C13.8684 6.07106 14.5 7.46199 14.5 9C14.5 12.0375 12.0376 14.5 9.00004 14.5C7.46215 14.5 6.07132 13.8685 5.07349 12.8513L5.43043 12.5011C6.3381 13.4264 7.60186 14 9.00004 14C11.7614 14 14 11.7614 14 9C14 7.60171 13.4264 6.33786 12.5009 5.43017L12.851 5.07321Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        opacity: ".35",
        d: "M13.3022 6.45071C13.7455 7.19737 14 8.06935 14 9.00001C14 11.7614 11.7614 14 9.00002 14C8.04868 14 7.15868 13.7341 6.40118 13.2724L6.66142 12.8454C7.34275 13.2607 8.14306 13.5 9.00002 13.5C11.4853 13.5 13.5 11.4853 13.5 9.00001C13.5 8.16165 13.271 7.37754 12.8722 6.70599L13.3022 6.45071Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        opacity: ".5",
        d: "M13.3745 7.94022C13.4566 8.28031 13.5 8.63525 13.5 9.00001C13.5 11.4853 11.4853 13.5 9.00003 13.5C8.61104 13.5 8.23323 13.4506 7.87268 13.3576L7.99759 12.8734C8.31768 12.956 8.65353 13 9.00003 13C11.2091 13 13 11.2091 13 9.00001C13 8.67509 12.9613 8.35953 12.8884 8.05757L13.3745 7.94022Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        opacity: ".65",
        d: "M12.9155 9.82133C12.5898 11.3813 11.3562 12.6072 9.79205 12.9215L9.69354 12.4313C11.0613 12.1565 12.1413 11.0834 12.4261 9.71915L12.9155 9.82133Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $jbmdS.createElement)("path", {
        d: "M1.2771 7.50253C1.2771 4.06456 4.06413 1.27753 7.5021 1.27753C10.94 1.27753 13.7271 4.06456 13.7271 7.50253C13.7271 10.9405 10.94 13.7275 7.5021 13.7275C4.06413 13.7275 1.2771 10.9405 1.2771 7.50253ZM7.5021 2.22753C4.5888 2.22753 2.2271 4.58923 2.2271 7.50253C2.2271 10.4158 4.5888 12.7775 7.5021 12.7775C10.4154 12.7775 12.7771 10.4158 12.7771 7.50253C12.7771 4.58923 10.4154 2.22753 7.5021 2.22753Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3V = [
    "color"
];
var $e781b76dcad7c5d5$export$fe819ae1b3a84d32 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3V);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M5 7.50003C5 8.32845 4.32843 9.00003 3.5 9.00003C2.67157 9.00003 2 8.32845 2 7.50003C2 6.6716 2.67157 6.00003 3.5 6.00003C4.32843 6.00003 5 6.6716 5 7.50003ZM5.71313 8.66388C5.29445 9.45838 4.46048 10 3.5 10C2.11929 10 1 8.88074 1 7.50003C1 6.11931 2.11929 5.00003 3.5 5.00003C4.46048 5.00003 5.29445 5.54167 5.71313 6.33616L9.10424 4.21671C9.03643 3.98968 9 3.74911 9 3.50003C9 2.11932 10.1193 1.00003 11.5 1.00003C12.8807 1.00003 14 2.11932 14 3.50003C14 4.88074 12.8807 6.00003 11.5 6.00003C10.6915 6.00003 9.97264 5.61624 9.51566 5.0209L5.9853 7.22738C5.99502 7.31692 6 7.40789 6 7.50003C6 7.59216 5.99502 7.68312 5.9853 7.77267L9.51567 9.97915C9.97265 9.38382 10.6915 9.00003 11.5 9.00003C12.8807 9.00003 14 10.1193 14 11.5C14 12.8807 12.8807 14 11.5 14C10.1193 14 9 12.8807 9 11.5C9 11.2509 9.03643 11.0104 9.10425 10.7833L5.71313 8.66388ZM11.5 5.00003C12.3284 5.00003 13 4.32846 13 3.50003C13 2.6716 12.3284 2.00003 11.5 2.00003C10.6716 2.00003 10 2.6716 10 3.50003C10 4.32846 10.6716 5.00003 11.5 5.00003ZM13 11.5C13 12.3285 12.3284 13 11.5 13C10.6716 13 10 12.3285 10 11.5C10 10.6716 10.6716 10 11.5 10C12.3284 10 13 10.6716 13 11.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3W = [
    "color"
];
var $e781b76dcad7c5d5$export$fd8d21248a547675 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3W);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M3.5 5.00006C3.22386 5.00006 3 5.22392 3 5.50006L3 11.5001C3 11.7762 3.22386 12.0001 3.5 12.0001L11.5 12.0001C11.7761 12.0001 12 11.7762 12 11.5001L12 5.50006C12 5.22392 11.7761 5.00006 11.5 5.00006L10.25 5.00006C9.97386 5.00006 9.75 4.7762 9.75 4.50006C9.75 4.22392 9.97386 4.00006 10.25 4.00006L11.5 4.00006C12.3284 4.00006 13 4.67163 13 5.50006L13 11.5001C13 12.3285 12.3284 13.0001 11.5 13.0001L3.5 13.0001C2.67157 13.0001 2 12.3285 2 11.5001L2 5.50006C2 4.67163 2.67157 4.00006 3.5 4.00006L4.75 4.00006C5.02614 4.00006 5.25 4.22392 5.25 4.50006C5.25 4.7762 5.02614 5.00006 4.75 5.00006L3.5 5.00006ZM7 1.6364L5.5682 3.0682C5.39246 3.24393 5.10754 3.24393 4.9318 3.0682C4.75607 2.89246 4.75607 2.60754 4.9318 2.4318L7.1818 0.181802C7.26619 0.09741 7.38065 0.049999 7.5 0.049999C7.61935 0.049999 7.73381 0.09741 7.8182 0.181802L10.0682 2.4318C10.2439 2.60754 10.2439 2.89246 10.0682 3.0682C9.89246 3.24393 9.60754 3.24393 9.4318 3.0682L8 1.6364L8 8.5C8 8.77614 7.77614 9 7.5 9C7.22386 9 7 8.77614 7 8.5L7 1.6364Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3X = [
    "color"
];
var $e781b76dcad7c5d5$export$f584b8d6931467fb = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3X);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M12.3536 1.14645C12.1583 0.951184 11.8417 0.951184 11.6464 1.14645C11.4512 1.34171 11.4512 1.65829 11.6464 1.85355L12.7929 3H12C10.7037 3 9.71111 3.58423 8.87248 4.38931C8.20065 5.03427 7.59349 5.85684 6.99461 6.6682C6.86287 6.84668 6.73154 7.02462 6.6 7.2C5.10874 9.18835 3.49037 11 0.5 11C0.223858 11 0 11.2239 0 11.5C0 11.7761 0.223858 12 0.5 12C4.00963 12 5.89126 9.81165 7.4 7.8C7.54367 7.60845 7.6832 7.41962 7.81996 7.23454L7.82005 7.23443L7.82006 7.23441C8.41674 6.42695 8.96069 5.69085 9.56502 5.11069C10.2889 4.41577 11.0463 4 12 4H12.7929L11.6464 5.14645C11.4512 5.34171 11.4512 5.65829 11.6464 5.85355C11.8417 6.04882 12.1583 6.04882 12.3536 5.85355L14.3536 3.85355C14.5488 3.65829 14.5488 3.34171 14.3536 3.14645L12.3536 1.14645ZM0.5 3C3.35278 3 5.12992 4.44588 6.50548 6.06746L6.3762 6.24266C6.2483 6.4161 6.12293 6.58609 6 6.75C5.96397 6.79804 5.92798 6.84581 5.892 6.89331C4.57348 5.29306 3.02637 4 0.5 4C0.223858 4 0 3.77614 0 3.5C0 3.22386 0.223858 3 0.5 3ZM8.87248 10.6107C8.37284 10.131 7.90897 9.55314 7.45767 8.95468C7.64688 8.71693 7.82704 8.48061 8 8.25L8.08987 8.12987C8.58412 8.79402 9.05288 9.39766 9.56502 9.88931C10.2889 10.5842 11.0463 11 12 11H12.7929L11.6464 9.85355C11.4512 9.65829 11.4512 9.34171 11.6464 9.14645C11.8417 8.95118 12.1583 8.95118 12.3536 9.14645L14.3536 11.1464C14.5488 11.3417 14.5488 11.6583 14.3536 11.8536L12.3536 13.8536C12.1583 14.0488 11.8417 14.0488 11.6464 13.8536C11.4512 13.6583 11.4512 13.3417 11.6464 13.1464L12.7929 12H12C10.7037 12 9.71111 11.4158 8.87248 10.6107Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3Y = [
    "color"
];
var $e781b76dcad7c5d5$export$9b9cddf895f6c38e = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3Y);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M11.5 3.04999C11.7485 3.04999 11.95 3.25146 11.95 3.49999V7.49999C11.95 7.74852 11.7485 7.94999 11.5 7.94999C11.2515 7.94999 11.05 7.74852 11.05 7.49999V4.58639L4.58638 11.05H7.49999C7.74852 11.05 7.94999 11.2515 7.94999 11.5C7.94999 11.7485 7.74852 11.95 7.49999 11.95L3.49999 11.95C3.38064 11.95 3.26618 11.9026 3.18179 11.8182C3.0974 11.7338 3.04999 11.6193 3.04999 11.5L3.04999 7.49999C3.04999 7.25146 3.25146 7.04999 3.49999 7.04999C3.74852 7.04999 3.94999 7.25146 3.94999 7.49999L3.94999 10.4136L10.4136 3.94999L7.49999 3.94999C7.25146 3.94999 7.04999 3.74852 7.04999 3.49999C7.04999 3.25146 7.25146 3.04999 7.49999 3.04999L11.5 3.04999Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3Z = [
    "color"
];
var $e781b76dcad7c5d5$export$5881b38319b9ceb7 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3Z);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.53731 0.826873C7.5125 0.824392 7.4875 0.824392 7.46269 0.826873L3.96269 1.17687C3.85672 1.18747 3.76025 1.24262 3.69736 1.32857L0.699771 5.42528C0.654046 5.48627 0.62647 5.56165 0.625057 5.6434C0.625019 5.6456 0.625 5.64781 0.625 5.65001C0.625 5.65052 0.625001 5.65103 0.625003 5.65153C0.625363 5.74237 0.658021 5.82559 0.712087 5.8903L7.21042 13.7883C7.28165 13.8749 7.38789 13.925 7.5 13.925C7.61211 13.925 7.71835 13.8749 7.78958 13.7883L14.2879 5.89031C14.342 5.8256 14.3746 5.74237 14.375 5.65153C14.375 5.65103 14.375 5.65052 14.375 5.65001C14.375 5.64849 14.375 5.64697 14.375 5.64545C14.3749 5.63963 14.3747 5.63382 14.3744 5.62801C14.37 5.55219 14.3431 5.48242 14.3002 5.42527L11.3026 1.32857C11.2397 1.24262 11.1433 1.18747 11.0373 1.17687L7.53731 0.826873ZM10.925 5.27501V5.25236L10.9223 5.27501H10.925ZM10.9342 5.17498H13.1877L11.2495 2.5261L10.9342 5.17498ZM10.5707 1.88395L8.04432 1.63131L10.1747 5.21034L10.5707 1.88395ZM6.95568 1.63131L4.42931 1.88395L4.82531 5.21034L6.95568 1.63131ZM3.75046 2.5261L1.81226 5.17498H4.0658L3.75046 2.5261ZM1.79416 6.02501L6.75861 12.0587L4.22371 6.0669C4.21787 6.0531 4.21314 6.0391 4.20949 6.02501H1.79416ZM5.15055 6.02501L7.49999 12.1085L9.84943 6.02501H9.78681H5.21319H5.15055ZM10.7905 6.02501C10.7869 6.0391 10.7821 6.0531 10.7763 6.0669L8.24139 12.0587L13.2058 6.02501H10.7905ZM7.5 2.18317L9.34038 5.27501H5.65962L7.5 2.18317Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3_ = [
    "color"
];
var $e781b76dcad7c5d5$export$fab36db504d71648 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3_);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M4.10876 14L9.46582 1H10.8178L5.46074 14H4.10876Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$3$ = [
    "color"
];
var $e781b76dcad7c5d5$export$c1a54868c36d9c70 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$3$);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M10.3004 7.49991C10.3004 8.4943 9.49426 9.30041 8.49988 9.30041C7.50549 9.30041 6.69938 8.4943 6.69938 7.49991C6.69938 6.50553 7.50549 5.69942 8.49988 5.69942C9.49426 5.69942 10.3004 6.50553 10.3004 7.49991ZM11.205 8C10.9699 9.28029 9.84816 10.2504 8.49988 10.2504C7.1516 10.2504 6.0299 9.28029 5.79473 8H0.5C0.223858 8 0 7.77614 0 7.5C0 7.22386 0.223858 7 0.5 7H5.7947C6.0298 5.71962 7.15154 4.74942 8.49988 4.74942C9.84822 4.74942 10.97 5.71962 11.2051 7H14.5C14.7761 7 15 7.22386 15 7.5C15 7.77614 14.7761 8 14.5 8H11.205Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$40 = [
    "color"
];
var $e781b76dcad7c5d5$export$389ac29f15551cc = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$40);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M14.4999 0.999994C14.2237 0.999994 13.9999 1.22385 13.9999 1.49999L13.9999 5.99995L9.99992 5.99995C9.44764 5.99995 8.99993 6.44766 8.99993 6.99994L8.99993 7.99994C8.99993 8.55222 9.44764 8.99993 9.99992 8.99993L13.9999 8.99993L13.9999 13.4999C13.9999 13.776 14.2237 13.9999 14.4999 13.9999C14.776 13.9999 14.9999 13.776 14.9999 13.4999L14.9999 1.49999C14.9999 1.22385 14.776 0.999994 14.4999 0.999994ZM4.99996 5.99995L0.999992 5.99995L0.999992 1.49999C0.999992 1.22385 0.776136 0.999994 0.499996 0.999994C0.223856 0.999994 -9.7852e-09 1.22385 -2.18557e-08 1.49999L4.07279e-07 13.4999C3.95208e-07 13.776 0.223855 13.9999 0.499996 13.9999C0.776136 13.9999 0.999992 13.776 0.999992 13.4999L0.999992 8.99993L4.99996 8.99993C5.55224 8.99993 5.99995 8.55222 5.99995 7.99993L5.99995 6.99994C5.99995 6.44766 5.55224 5.99995 4.99996 5.99995Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$41 = [
    "color"
];
var $e781b76dcad7c5d5$export$d6c80469522241f6 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$41);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M0.999878 0.5C0.999878 0.223858 1.22374 0 1.49988 0H13.4999C13.776 0 13.9999 0.223858 13.9999 0.5C13.9999 0.776142 13.776 1 13.4999 1L9 1V5C9 5.55228 8.55228 6 8 6H7C6.44772 6 6 5.55228 6 5V1H1.49988C1.22374 1 0.999878 0.776142 0.999878 0.5ZM7 9C6.44772 9 6 9.44771 6 10V14H1.49988C1.22374 14 0.999878 14.2239 0.999878 14.5C0.999878 14.7761 1.22374 15 1.49988 15H13.4999C13.776 15 13.9999 14.7761 13.9999 14.5C13.9999 14.2239 13.776 14 13.4999 14H9V10C9 9.44772 8.55228 9 8 9H7Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$42 = [
    "color"
];
var $e781b76dcad7c5d5$export$d569b77eb092ec4 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$42);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M14.4999 0.999992C14.2237 0.999992 13.9999 1.22385 13.9999 1.49999L13.9999 13.4999C13.9999 13.776 14.2237 13.9999 14.4999 13.9999C14.776 13.9999 14.9999 13.776 14.9999 13.4999L14.9999 1.49999C14.9999 1.22385 14.776 0.999992 14.4999 0.999992ZM0.499996 0.999992C0.223856 0.999992 -9.78509e-09 1.22385 -2.18556e-08 1.49999L4.07279e-07 13.4999C3.95208e-07 13.776 0.223855 13.9999 0.499996 13.9999C0.776136 13.9999 0.999992 13.776 0.999992 13.4999L0.999992 1.49999C0.999992 1.22385 0.776136 0.999992 0.499996 0.999992ZM1.99998 6.99994C1.99998 6.44766 2.44769 5.99995 2.99998 5.99995L5.99995 5.99995C6.55223 5.99995 6.99994 6.44766 6.99994 6.99994L6.99994 7.99993C6.99994 8.55221 6.55223 8.99992 5.99995 8.99992L2.99998 8.99992C2.4477 8.99992 1.99998 8.55221 1.99998 7.99993L1.99998 6.99994ZM8.99993 5.99995C8.44765 5.99995 7.99993 6.44766 7.99993 6.99994L7.99993 7.99993C7.99993 8.55221 8.44765 8.99992 8.99993 8.99992L11.9999 8.99992C12.5522 8.99992 12.9999 8.55221 12.9999 7.99993L12.9999 6.99994C12.9999 6.44766 12.5522 5.99995 11.9999 5.99995L8.99993 5.99995Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$43 = [
    "color"
];
var $e781b76dcad7c5d5$export$7b2a11c2d6945102 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$43);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M0.999878 0.5C0.999878 0.223858 1.22374 0 1.49988 0H13.4999C13.776 0 13.9999 0.223858 13.9999 0.5C13.9999 0.776142 13.776 1 13.4999 1H1.49988C1.22374 1 0.999878 0.776142 0.999878 0.5ZM7 2C6.44772 2 6 2.44772 6 3V6C6 6.55228 6.44772 7 7 7H8C8.55228 7 9 6.55228 9 6V3C9 2.44772 8.55228 2 8 2H7ZM7 8C6.44772 8 6 8.44771 6 9V12C6 12.5523 6.44772 13 7 13H8C8.55228 13 9 12.5523 9 12V9C9 8.44772 8.55228 8 8 8H7ZM1.49988 14C1.22374 14 0.999878 14.2239 0.999878 14.5C0.999878 14.7761 1.22374 15 1.49988 15H13.4999C13.776 15 13.9999 14.7761 13.9999 14.5C13.9999 14.2239 13.776 14 13.4999 14H1.49988Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$44 = [
    "color"
];
var $e781b76dcad7c5d5$export$7fee6559072912ad = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$44);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.46968 1.05085C7.64122 1.13475 7.75 1.30904 7.75 1.5V13.5C7.75 13.691 7.64122 13.8653 7.46968 13.9492C7.29813 14.0331 7.09377 14.0119 6.94303 13.8947L3.2213 11H1.5C0.671571 11 0 10.3284 0 9.5V5.5C0 4.67158 0.671573 4 1.5 4H3.2213L6.94303 1.10533C7.09377 0.988085 7.29813 0.966945 7.46968 1.05085ZM6.75 2.52232L3.69983 4.89468C3.61206 4.96294 3.50405 5 3.39286 5H1.5C1.22386 5 1 5.22386 1 5.5V9.5C1 9.77615 1.22386 10 1.5 10H3.39286C3.50405 10 3.61206 10.0371 3.69983 10.1053L6.75 12.4777V2.52232ZM10.2784 3.84804C10.4623 3.72567 10.7106 3.77557 10.833 3.95949C12.2558 6.09798 12.2558 8.90199 10.833 11.0405C10.7106 11.2244 10.4623 11.2743 10.2784 11.1519C10.0944 11.0296 10.0445 10.7813 10.1669 10.5973C11.4111 8.72728 11.4111 6.27269 10.1669 4.40264C10.0445 4.21871 10.0944 3.97041 10.2784 3.84804ZM12.6785 1.43044C12.5356 1.2619 12.2832 1.24104 12.1147 1.38386C11.9462 1.52667 11.9253 1.77908 12.0681 1.94762C14.7773 5.14488 14.7773 9.85513 12.0681 13.0524C11.9253 13.2209 11.9462 13.4733 12.1147 13.6161C12.2832 13.759 12.5356 13.7381 12.6785 13.5696C15.6406 10.0739 15.6406 4.92612 12.6785 1.43044Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$45 = [
    "color"
];
var $e781b76dcad7c5d5$export$a45f43fe1bacf3af = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$45);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M8 1.5C8 1.31062 7.893 1.13749 7.72361 1.05279C7.55421 0.968093 7.35151 0.986371 7.2 1.1L3.33333 4H1.5C0.671573 4 0 4.67158 0 5.5V9.5C0 10.3284 0.671573 11 1.5 11H3.33333L7.2 13.9C7.35151 14.0136 7.55421 14.0319 7.72361 13.9472C7.893 13.8625 8 13.6894 8 13.5V1.5ZM3.8 4.9L7 2.5V12.5L3.8 10.1C3.71345 10.0351 3.60819 10 3.5 10H1.5C1.22386 10 1 9.77614 1 9.5V5.5C1 5.22386 1.22386 5 1.5 5H3.5C3.60819 5 3.71345 4.96491 3.8 4.9ZM10.833 3.95949C10.7106 3.77557 10.4623 3.72567 10.2784 3.84804C10.0944 3.97041 10.0445 4.21871 10.1669 4.40264C11.4111 6.27268 11.4111 8.72728 10.1669 10.5973C10.0445 10.7813 10.0944 11.0296 10.2784 11.1519C10.4623 11.2743 10.7106 11.2244 10.833 11.0405C12.2558 8.90199 12.2558 6.09798 10.833 3.95949Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$46 = [
    "color"
];
var $e781b76dcad7c5d5$export$9ea4d02db3207a8b = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$46);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.72361 1.05279C7.893 1.13749 8 1.31062 8 1.5V13.5C8 13.6894 7.893 13.8625 7.72361 13.9472C7.55421 14.0319 7.35151 14.0136 7.2 13.9L3.33333 11H1.5C0.671573 11 0 10.3284 0 9.5V5.5C0 4.67158 0.671573 4 1.5 4H3.33333L7.2 1.1C7.35151 0.986371 7.55421 0.968093 7.72361 1.05279ZM7 2.5L3.8 4.9C3.71345 4.96491 3.60819 5 3.5 5H1.5C1.22386 5 1 5.22386 1 5.5V9.5C1 9.77614 1.22386 10 1.5 10H3.5C3.60819 10 3.71345 10.0351 3.8 10.1L7 12.5V2.5ZM14.8536 5.14645C15.0488 5.34171 15.0488 5.65829 14.8536 5.85355L13.2071 7.5L14.8536 9.14645C15.0488 9.34171 15.0488 9.65829 14.8536 9.85355C14.6583 10.0488 14.3417 10.0488 14.1464 9.85355L12.5 8.20711L10.8536 9.85355C10.6583 10.0488 10.3417 10.0488 10.1464 9.85355C9.95118 9.65829 9.95118 9.34171 10.1464 9.14645L11.7929 7.5L10.1464 5.85355C9.95118 5.65829 9.95118 5.34171 10.1464 5.14645C10.3417 4.95118 10.6583 4.95118 10.8536 5.14645L12.5 6.79289L14.1464 5.14645C14.3417 4.95118 14.6583 4.95118 14.8536 5.14645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$47 = [
    "color"
];
var $e781b76dcad7c5d5$export$c28fae3b5b7c9a0b = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$47);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M8 1.5C8 1.31062 7.893 1.13749 7.72361 1.05279C7.55421 0.968093 7.35151 0.986371 7.2 1.1L3.33333 4H1.5C0.671573 4 0 4.67158 0 5.5V9.5C0 10.3284 0.671573 11 1.5 11H3.33333L7.2 13.9C7.35151 14.0136 7.55421 14.0319 7.72361 13.9472C7.893 13.8625 8 13.6894 8 13.5V1.5ZM3.8 4.9L7 2.5V12.5L3.8 10.1C3.71345 10.0351 3.60819 10 3.5 10H1.5C1.22386 10 1 9.77614 1 9.5V5.5C1 5.22386 1.22386 5 1.5 5H3.5C3.60819 5 3.71345 4.96491 3.8 4.9ZM10.083 5.05577C9.96066 4.87185 9.71235 4.82195 9.52843 4.94432C9.3445 5.06669 9.2946 5.31499 9.41697 5.49892C10.2207 6.70693 10.2207 8.29303 9.41697 9.50104C9.2946 9.68496 9.3445 9.93326 9.52843 10.0556C9.71235 10.178 9.96066 10.1281 10.083 9.94418C11.0653 8.46773 11.0653 6.53222 10.083 5.05577Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$48 = [
    "color"
];
var $e781b76dcad7c5d5$export$c19d0dc844f6640 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$48);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M1 1H1.5H13.5H14V1.5V13.5V14H13.5H1.5H1V13.5V1.5V1ZM2 2V13H13V2H2Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$49 = [
    "color"
];
var $e781b76dcad7c5d5$export$f95b8a41f9121b54 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$49);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.75432 1.81954C7.59742 1.72682 7.4025 1.72682 7.24559 1.81954L1.74559 5.06954C1.59336 5.15949 1.49996 5.32317 1.49996 5.5C1.49996 5.67683 1.59336 5.84051 1.74559 5.93046L7.24559 9.18046C7.4025 9.27318 7.59742 9.27318 7.75432 9.18046L13.2543 5.93046C13.4066 5.84051 13.5 5.67683 13.5 5.5C13.5 5.32317 13.4066 5.15949 13.2543 5.06954L7.75432 1.81954ZM7.49996 8.16923L2.9828 5.5L7.49996 2.83077L12.0171 5.5L7.49996 8.16923ZM2.25432 8.31954C2.01658 8.17906 1.70998 8.2579 1.56949 8.49564C1.42901 8.73337 1.50785 9.03998 1.74559 9.18046L7.24559 12.4305C7.4025 12.5232 7.59742 12.5232 7.75432 12.4305L13.2543 9.18046C13.4921 9.03998 13.5709 8.73337 13.4304 8.49564C13.2899 8.2579 12.9833 8.17906 12.7456 8.31954L7.49996 11.4192L2.25432 8.31954Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4a = [
    "color"
];
var $e781b76dcad7c5d5$export$2ee28caa7f1e962e = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4a);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M6.97942 1.25171L6.9585 1.30199L5.58662 4.60039C5.54342 4.70426 5.44573 4.77523 5.3336 4.78422L1.7727 5.0697L1.71841 5.07405L1.38687 5.10063L1.08608 5.12475C0.820085 5.14607 0.712228 5.47802 0.914889 5.65162L1.14406 5.84793L1.39666 6.06431L1.43802 6.09974L4.15105 8.42374C4.23648 8.49692 4.2738 8.61176 4.24769 8.72118L3.41882 12.196L3.40618 12.249L3.32901 12.5725L3.25899 12.866C3.19708 13.1256 3.47945 13.3308 3.70718 13.1917L3.9647 13.0344L4.24854 12.861L4.29502 12.8326L7.34365 10.9705C7.43965 10.9119 7.5604 10.9119 7.6564 10.9705L10.705 12.8326L10.7515 12.861L11.0354 13.0344L11.2929 13.1917C11.5206 13.3308 11.803 13.1256 11.7411 12.866L11.671 12.5725L11.5939 12.249L11.5812 12.196L10.7524 8.72118C10.7263 8.61176 10.7636 8.49692 10.849 8.42374L13.562 6.09974L13.6034 6.06431L13.856 5.84793L14.0852 5.65162C14.2878 5.47802 14.18 5.14607 13.914 5.12475L13.6132 5.10063L13.2816 5.07405L13.2274 5.0697L9.66645 4.78422C9.55432 4.77523 9.45663 4.70426 9.41343 4.60039L8.04155 1.30199L8.02064 1.25171L7.89291 0.944609L7.77702 0.665992C7.67454 0.419604 7.32551 0.419604 7.22303 0.665992L7.10715 0.944609L6.97942 1.25171ZM7.50003 2.60397L6.50994 4.98442C6.32273 5.43453 5.89944 5.74207 5.41351 5.78103L2.84361 5.98705L4.8016 7.66428C5.17183 7.98142 5.33351 8.47903 5.2204 8.95321L4.62221 11.461L6.8224 10.1171C7.23842 9.86302 7.76164 9.86302 8.17766 10.1171L10.3778 11.461L9.77965 8.95321C9.66654 8.47903 9.82822 7.98142 10.1984 7.66428L12.1564 5.98705L9.58654 5.78103C9.10061 5.74207 8.67732 5.43453 8.49011 4.98442L7.50003 2.60397Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4b = [
    "color"
];
var $e781b76dcad7c5d5$export$b9957ed2bd2cc18b = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4b);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.22303 0.665992C7.32551 0.419604 7.67454 0.419604 7.77702 0.665992L9.41343 4.60039C9.45663 4.70426 9.55432 4.77523 9.66645 4.78422L13.914 5.12475C14.18 5.14607 14.2878 5.47802 14.0852 5.65162L10.849 8.42374C10.7636 8.49692 10.7263 8.61176 10.7524 8.72118L11.7411 12.866C11.803 13.1256 11.5206 13.3308 11.2929 13.1917L7.6564 10.9705C7.5604 10.9119 7.43965 10.9119 7.34365 10.9705L3.70718 13.1917C3.47945 13.3308 3.19708 13.1256 3.25899 12.866L4.24769 8.72118C4.2738 8.61176 4.23648 8.49692 4.15105 8.42374L0.914889 5.65162C0.712228 5.47802 0.820086 5.14607 1.08608 5.12475L5.3336 4.78422C5.44573 4.77523 5.54342 4.70426 5.58662 4.60039L7.22303 0.665992Z",
        fill: color
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4c = [
    "color"
];
var $e781b76dcad7c5d5$export$fa3807a0e988146 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4c);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M1.84998 7.49998C1.84998 7.21321 1.87134 6.93143 1.91256 6.65615L9.56374 2.23875C9.86311 2.35627 10.15 2.49861 10.4219 2.66322L3.77065 6.50332C3.73669 6.52183 3.70482 6.5449 3.67602 6.57238C3.5911 6.65308 3.54245 6.76286 3.53682 6.87658C3.53359 6.9418 3.54451 7.00831 3.57086 7.07137C3.58927 7.1157 3.6149 7.15742 3.64744 7.19458C3.67306 7.22396 3.702 7.24941 3.73337 7.27069L7.32533 9.83813L3.87232 11.8317C2.63604 10.7953 1.84998 9.23944 1.84998 7.49998ZM8.36843 10.2751C8.37682 10.2706 8.38509 10.2659 8.39322 10.2608L9.84091 9.42499C9.84706 9.42163 9.85314 9.41812 9.85915 9.41446L11.3101 8.57677C11.3655 8.54649 11.4154 8.504 11.4554 8.44995C11.6034 8.25031 11.5616 7.96848 11.362 7.82046L7.82779 5.20017L11.2161 3.24393C12.4013 4.27963 13.15 5.80237 13.15 7.49998C13.15 7.83546 13.1207 8.16411 13.0647 8.48353L5.56875 12.8113C5.26138 12.6995 4.96646 12.5618 4.68662 12.4008L8.36843 10.2751ZM8.18149 9.34383L4.81659 6.93868L5.50918 6.53881L8.80604 8.98324L8.18149 9.34383ZM6.35875 6.04832L6.97822 5.69067L10.2751 8.13506L9.6556 8.49275L6.35875 6.04832ZM8.3318 1.91078L2.24263 5.42636C3.06941 3.33188 5.11164 1.84998 7.49998 1.84998C7.78258 1.84998 8.06033 1.87072 8.3318 1.91078ZM6.84684 13.1126C7.06114 13.1373 7.27908 13.15 7.49998 13.15C9.8246 13.15 11.8213 11.7461 12.6886 9.7399L6.84684 13.1126ZM7.49998 0.849976C3.82728 0.849976 0.849976 3.82728 0.849976 7.49998C0.849976 11.1727 3.82728 14.15 7.49998 14.15C11.1727 14.15 14.15 11.1727 14.15 7.49998C14.15 3.82728 11.1727 0.849976 7.49998 0.849976Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4d = [
    "color"
];
var $e781b76dcad7c5d5$export$dc6949a98411e916 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4d);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M2 3C2 2.44772 2.44772 2 3 2H12C12.5523 2 13 2.44772 13 3V12C13 12.5523 12.5523 13 12 13H3C2.44772 13 2 12.5523 2 12V3ZM12 3H3V12H12V3Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4e = [
    "color"
];
var $e781b76dcad7c5d5$export$93c9322cdb01abe0 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4e);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M5.49998 0.5C5.49998 0.223858 5.72383 0 5.99998 0H7.49998H8.99998C9.27612 0 9.49998 0.223858 9.49998 0.5C9.49998 0.776142 9.27612 1 8.99998 1H7.99998V2.11922C9.09832 2.20409 10.119 2.56622 10.992 3.13572C11.0116 3.10851 11.0336 3.08252 11.058 3.05806L11.858 2.25806C12.1021 2.01398 12.4978 2.01398 12.7419 2.25806C12.986 2.50214 12.986 2.89786 12.7419 3.14194L11.967 3.91682C13.1595 5.07925 13.9 6.70314 13.9 8.49998C13.9 12.0346 11.0346 14.9 7.49998 14.9C3.96535 14.9 1.09998 12.0346 1.09998 8.49998C1.09998 5.13362 3.69904 2.3743 6.99998 2.11922V1H5.99998C5.72383 1 5.49998 0.776142 5.49998 0.5ZM2.09998 8.49998C2.09998 5.51764 4.51764 3.09998 7.49998 3.09998C10.4823 3.09998 12.9 5.51764 12.9 8.49998C12.9 11.4823 10.4823 13.9 7.49998 13.9C4.51764 13.9 2.09998 11.4823 2.09998 8.49998ZM7.99998 4.5C7.99998 4.22386 7.77612 4 7.49998 4C7.22383 4 6.99998 4.22386 6.99998 4.5V9.5C6.99998 9.77614 7.22383 10 7.49998 10C7.77612 10 7.99998 9.77614 7.99998 9.5V4.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4f = [
    "color"
];
var $e781b76dcad7c5d5$export$672f8b757251d92b = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4f);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M14.4999 0.999992C14.2237 0.999992 13.9999 1.22385 13.9999 1.49999L13.9999 5.99995L0.999992 5.99995L0.999992 1.49999C0.999992 1.22385 0.776136 0.999992 0.499996 0.999992C0.223856 0.999992 -9.78509e-09 1.22385 -2.18556e-08 1.49999L4.07279e-07 13.4999C3.95208e-07 13.776 0.223855 13.9999 0.499996 13.9999C0.776136 13.9999 0.999992 13.776 0.999992 13.4999L0.999992 8.99992L13.9999 8.99992L13.9999 13.4999C13.9999 13.776 14.2237 13.9999 14.4999 13.9999C14.776 13.9999 14.9999 13.776 14.9999 13.4999L14.9999 1.49999C14.9999 1.22385 14.776 0.999992 14.4999 0.999992Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4g = [
    "color"
];
var $e781b76dcad7c5d5$export$dd3bd56329b5fe85 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4g);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M0.999878 0.5C0.999878 0.223858 1.22374 0 1.49988 0H13.4999C13.776 0 13.9999 0.223858 13.9999 0.5C13.9999 0.776142 13.776 1 13.4999 1H6H1.49988C1.22374 1 0.999878 0.776142 0.999878 0.5ZM9 14V1L6 1V14H1.49988C1.22374 14 0.999878 14.2239 0.999878 14.5C0.999878 14.7761 1.22374 15 1.49988 15H13.4999C13.776 15 13.9999 14.7761 13.9999 14.5C13.9999 14.2239 13.776 14 13.4999 14H9Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4h = [
    "color"
];
var $e781b76dcad7c5d5$export$25ec4ecc9c5701a5 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4h);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M5.00003 3.25C5.00003 2.97386 4.77617 2.75 4.50003 2.75C4.22389 2.75 4.00003 2.97386 4.00003 3.25V7.10003H2.49998C2.27906 7.10003 2.09998 7.27912 2.09998 7.50003C2.09998 7.72094 2.27906 7.90003 2.49998 7.90003H4.00003V8.55C4.00003 10.483 5.56703 12.05 7.50003 12.05C9.43303 12.05 11 10.483 11 8.55V7.90003H12.5C12.7209 7.90003 12.9 7.72094 12.9 7.50003C12.9 7.27912 12.7209 7.10003 12.5 7.10003H11V3.25C11 2.97386 10.7762 2.75 10.5 2.75C10.2239 2.75 10 2.97386 10 3.25V7.10003H5.00003V3.25ZM5.00003 7.90003V8.55C5.00003 9.93071 6.11932 11.05 7.50003 11.05C8.88074 11.05 10 9.93071 10 8.55V7.90003H5.00003Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4i = [
    "color"
];
var $e781b76dcad7c5d5$export$cd27c497b93dbe8d = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4i);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.5 0C7.77614 0 8 0.223858 8 0.5V2.5C8 2.77614 7.77614 3 7.5 3C7.22386 3 7 2.77614 7 2.5V0.5C7 0.223858 7.22386 0 7.5 0ZM2.1967 2.1967C2.39196 2.00144 2.70854 2.00144 2.90381 2.1967L4.31802 3.61091C4.51328 3.80617 4.51328 4.12276 4.31802 4.31802C4.12276 4.51328 3.80617 4.51328 3.61091 4.31802L2.1967 2.90381C2.00144 2.70854 2.00144 2.39196 2.1967 2.1967ZM0.5 7C0.223858 7 0 7.22386 0 7.5C0 7.77614 0.223858 8 0.5 8H2.5C2.77614 8 3 7.77614 3 7.5C3 7.22386 2.77614 7 2.5 7H0.5ZM2.1967 12.8033C2.00144 12.608 2.00144 12.2915 2.1967 12.0962L3.61091 10.682C3.80617 10.4867 4.12276 10.4867 4.31802 10.682C4.51328 10.8772 4.51328 11.1938 4.31802 11.3891L2.90381 12.8033C2.70854 12.9986 2.39196 12.9986 2.1967 12.8033ZM12.5 7C12.2239 7 12 7.22386 12 7.5C12 7.77614 12.2239 8 12.5 8H14.5C14.7761 8 15 7.77614 15 7.5C15 7.22386 14.7761 7 14.5 7H12.5ZM10.682 4.31802C10.4867 4.12276 10.4867 3.80617 10.682 3.61091L12.0962 2.1967C12.2915 2.00144 12.608 2.00144 12.8033 2.1967C12.9986 2.39196 12.9986 2.70854 12.8033 2.90381L11.3891 4.31802C11.1938 4.51328 10.8772 4.51328 10.682 4.31802ZM8 12.5C8 12.2239 7.77614 12 7.5 12C7.22386 12 7 12.2239 7 12.5V14.5C7 14.7761 7.22386 15 7.5 15C7.77614 15 8 14.7761 8 14.5V12.5ZM10.682 10.682C10.8772 10.4867 11.1938 10.4867 11.3891 10.682L12.8033 12.0962C12.9986 12.2915 12.9986 12.608 12.8033 12.8033C12.608 12.9986 12.2915 12.9986 12.0962 12.8033L10.682 11.3891C10.4867 11.1938 10.4867 10.8772 10.682 10.682ZM5.5 7.5C5.5 6.39543 6.39543 5.5 7.5 5.5C8.60457 5.5 9.5 6.39543 9.5 7.5C9.5 8.60457 8.60457 9.5 7.5 9.5C6.39543 9.5 5.5 8.60457 5.5 7.5ZM7.5 4.5C5.84315 4.5 4.5 5.84315 4.5 7.5C4.5 9.15685 5.84315 10.5 7.5 10.5C9.15685 10.5 10.5 9.15685 10.5 7.5C10.5 5.84315 9.15685 4.5 7.5 4.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4j = [
    "color"
];
var $e781b76dcad7c5d5$export$381bc0c1798a0082 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4j);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M10.5 4C8.567 4 7 5.567 7 7.5C7 9.433 8.567 11 10.5 11C12.433 11 14 9.433 14 7.5C14 5.567 12.433 4 10.5 4ZM7.67133 11C6.65183 10.175 6 8.91363 6 7.5C6 6.08637 6.65183 4.82498 7.67133 4H4.5C2.567 4 1 5.567 1 7.5C1 9.433 2.567 11 4.5 11H7.67133ZM0 7.5C0 5.01472 2.01472 3 4.5 3H10.5C12.9853 3 15 5.01472 15 7.5C15 9.98528 12.9853 12 10.5 12H4.5C2.01472 12 0 9.98528 0 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4k = [
    "color"
];
var $e781b76dcad7c5d5$export$b6fcc44f764b8899 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4k);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M1.90321 7.29677C1.90321 10.341 4.11041 12.4147 6.58893 12.8439C6.87255 12.893 7.06266 13.1627 7.01355 13.4464C6.96444 13.73 6.69471 13.9201 6.41109 13.871C3.49942 13.3668 0.86084 10.9127 0.86084 7.29677C0.860839 5.76009 1.55996 4.55245 2.37639 3.63377C2.96124 2.97568 3.63034 2.44135 4.16846 2.03202L2.53205 2.03202C2.25591 2.03202 2.03205 1.80816 2.03205 1.53202C2.03205 1.25588 2.25591 1.03202 2.53205 1.03202L5.53205 1.03202C5.80819 1.03202 6.03205 1.25588 6.03205 1.53202L6.03205 4.53202C6.03205 4.80816 5.80819 5.03202 5.53205 5.03202C5.25591 5.03202 5.03205 4.80816 5.03205 4.53202L5.03205 2.68645L5.03054 2.68759L5.03045 2.68766L5.03044 2.68767L5.03043 2.68767C4.45896 3.11868 3.76059 3.64538 3.15554 4.3262C2.44102 5.13021 1.90321 6.10154 1.90321 7.29677ZM13.0109 7.70321C13.0109 4.69115 10.8505 2.6296 8.40384 2.17029C8.12093 2.11718 7.93465 1.84479 7.98776 1.56188C8.04087 1.27898 8.31326 1.0927 8.59616 1.14581C11.4704 1.68541 14.0532 4.12605 14.0532 7.70321C14.0532 9.23988 13.3541 10.4475 12.5377 11.3662C11.9528 12.0243 11.2837 12.5586 10.7456 12.968L12.3821 12.968C12.6582 12.968 12.8821 13.1918 12.8821 13.468C12.8821 13.7441 12.6582 13.968 12.3821 13.968L9.38205 13.968C9.10591 13.968 8.88205 13.7441 8.88205 13.468L8.88205 10.468C8.88205 10.1918 9.10591 9.96796 9.38205 9.96796C9.65819 9.96796 9.88205 10.1918 9.88205 10.468L9.88205 12.3135L9.88362 12.3123C10.4551 11.8813 11.1535 11.3546 11.7585 10.6738C12.4731 9.86976 13.0109 8.89844 13.0109 7.70321Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4l = [
    "color"
];
var $e781b76dcad7c5d5$export$560b0277c649ed6b = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4l);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M8 2H12.5C12.7761 2 13 2.22386 13 2.5V5H8V2ZM7 5V2H2.5C2.22386 2 2 2.22386 2 2.5V5H7ZM2 6V9H7V6H2ZM8 6H13V9H8V6ZM8 10H13V12.5C13 12.7761 12.7761 13 12.5 13H8V10ZM2 12.5V10H7V13H2.5C2.22386 13 2 12.7761 2 12.5ZM1 2.5C1 1.67157 1.67157 1 2.5 1H12.5C13.3284 1 14 1.67157 14 2.5V12.5C14 13.3284 13.3284 14 12.5 14H2.5C1.67157 14 1 13.3284 1 12.5V2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4m = [
    "color"
];
var $e781b76dcad7c5d5$export$aea5b1a1d88a7a75 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4m);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M0.900024 7.50002C0.900024 3.85495 3.85495 0.900024 7.50002 0.900024C11.1451 0.900024 14.1 3.85495 14.1 7.50002C14.1 11.1451 11.1451 14.1 7.50002 14.1C3.85495 14.1 0.900024 11.1451 0.900024 7.50002ZM7.50002 1.80002C4.35201 1.80002 1.80002 4.35201 1.80002 7.50002C1.80002 10.648 4.35201 13.2 7.50002 13.2C10.648 13.2 13.2 10.648 13.2 7.50002C13.2 4.35201 10.648 1.80002 7.50002 1.80002ZM3.07504 7.50002C3.07504 5.05617 5.05618 3.07502 7.50004 3.07502C9.94388 3.07502 11.925 5.05617 11.925 7.50002C11.925 9.94386 9.94388 11.925 7.50004 11.925C5.05618 11.925 3.07504 9.94386 3.07504 7.50002ZM7.50004 3.92502C5.52562 3.92502 3.92504 5.52561 3.92504 7.50002C3.92504 9.47442 5.52563 11.075 7.50004 11.075C9.47444 11.075 11.075 9.47442 11.075 7.50002C11.075 5.52561 9.47444 3.92502 7.50004 3.92502ZM7.50004 5.25002C6.2574 5.25002 5.25004 6.25739 5.25004 7.50002C5.25004 8.74266 6.2574 9.75002 7.50004 9.75002C8.74267 9.75002 9.75004 8.74266 9.75004 7.50002C9.75004 6.25738 8.74267 5.25002 7.50004 5.25002ZM6.05004 7.50002C6.05004 6.69921 6.69923 6.05002 7.50004 6.05002C8.30084 6.05002 8.95004 6.69921 8.95004 7.50002C8.95004 8.30083 8.30084 8.95002 7.50004 8.95002C6.69923 8.95002 6.05004 8.30083 6.05004 7.50002Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4n = [
    "color"
];
var $e781b76dcad7c5d5$export$4a7d2a945910cc57 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4n);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M3.94993 2.95002L3.94993 4.49998C3.94993 4.74851 3.74845 4.94998 3.49993 4.94998C3.2514 4.94998 3.04993 4.74851 3.04993 4.49998V2.50004C3.04993 2.45246 3.05731 2.40661 3.07099 2.36357C3.12878 2.18175 3.29897 2.05002 3.49993 2.05002H11.4999C11.6553 2.05002 11.7922 2.12872 11.8731 2.24842C11.9216 2.32024 11.9499 2.40682 11.9499 2.50002L11.9499 2.50004V4.49998C11.9499 4.74851 11.7485 4.94998 11.4999 4.94998C11.2514 4.94998 11.0499 4.74851 11.0499 4.49998V2.95002H8.04993V12.05H9.25428C9.50281 12.05 9.70428 12.2515 9.70428 12.5C9.70428 12.7486 9.50281 12.95 9.25428 12.95H5.75428C5.50575 12.95 5.30428 12.7486 5.30428 12.5C5.30428 12.2515 5.50575 12.05 5.75428 12.05H6.94993V2.95002H3.94993Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4o = [
    "color"
];
var $e781b76dcad7c5d5$export$934aaa521722e7a1 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4o);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M3.89949 5.50002C3.89949 5.27911 3.7204 5.10003 3.49949 5.10003C3.27857 5.10003 3.09949 5.27911 3.09949 5.50002L3.09949 12.5343L1.78233 11.2172C1.62612 11.061 1.37285 11.061 1.21664 11.2172C1.06043 11.3734 1.06043 11.6267 1.21664 11.7829L3.21664 13.7829C3.29166 13.8579 3.3934 13.9 3.49949 13.9C3.60557 13.9 3.70732 13.8579 3.78233 13.7829L5.78233 11.7829C5.93854 11.6267 5.93854 11.3734 5.78233 11.2172C5.62612 11.061 5.37285 11.061 5.21664 11.2172L3.89949 12.5343L3.89949 5.50002ZM8.49998 13C8.22383 13 7.99998 12.7762 7.99998 12.5C7.99998 12.2239 8.22383 12 8.49998 12H14.5C14.7761 12 15 12.2239 15 12.5C15 12.7762 14.7761 13 14.5 13H8.49998ZM8.49998 10C8.22383 10 7.99998 9.77617 7.99998 9.50002C7.99998 9.22388 8.22383 9.00002 8.49998 9.00002H14.5C14.7761 9.00002 15 9.22388 15 9.50002C15 9.77617 14.7761 10 14.5 10H8.49998ZM7.99998 6.50002C7.99998 6.77617 8.22383 7.00002 8.49998 7.00002H14.5C14.7761 7.00002 15 6.77617 15 6.50002C15 6.22388 14.7761 6.00002 14.5 6.00002H8.49998C8.22383 6.00002 7.99998 6.22388 7.99998 6.50002Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4p = [
    "color"
];
var $e781b76dcad7c5d5$export$c0990f168a0bad08 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4p);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M2 4.5C2 4.22386 2.22386 4 2.5 4H12.5C12.7761 4 13 4.22386 13 4.5C13 4.77614 12.7761 5 12.5 5H2.5C2.22386 5 2 4.77614 2 4.5ZM4 7.5C4 7.22386 4.22386 7 4.5 7H10.5C10.7761 7 11 7.22386 11 7.5C11 7.77614 10.7761 8 10.5 8H4.5C4.22386 8 4 7.77614 4 7.5ZM3 10.5C3 10.2239 3.22386 10 3.5 10H11.5C11.7761 10 12 10.2239 12 10.5C12 10.7761 11.7761 11 11.5 11H3.5C3.22386 11 3 10.7761 3 10.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4q = [
    "color"
];
var $e781b76dcad7c5d5$export$8ea3580a4e458099 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4q);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M2.5 4C2.22386 4 2 4.22386 2 4.5C2 4.77614 2.22386 5 2.5 5H12.5C12.7761 5 13 4.77614 13 4.5C13 4.22386 12.7761 4 12.5 4H2.5ZM2 7.5C2 7.22386 2.22386 7 2.5 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H2.5C2.22386 8 2 7.77614 2 7.5ZM2 10.5C2 10.2239 2.22386 10 2.5 10H12.5C12.7761 10 13 10.2239 13 10.5C13 10.7761 12.7761 11 12.5 11H2.5C2.22386 11 2 10.7761 2 10.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4r = [
    "color"
];
var $e781b76dcad7c5d5$export$e9337773b10190a1 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4r);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M2 4.5C2 4.22386 2.22386 4 2.5 4H12.5C12.7761 4 13 4.22386 13 4.5C13 4.77614 12.7761 5 12.5 5H2.5C2.22386 5 2 4.77614 2 4.5ZM2 7.5C2 7.22386 2.22386 7 2.5 7H7.5C7.77614 7 8 7.22386 8 7.5C8 7.77614 7.77614 8 7.5 8H2.5C2.22386 8 2 7.77614 2 7.5ZM2 10.5C2 10.2239 2.22386 10 2.5 10H10.5C10.7761 10 11 10.2239 11 10.5C11 10.7761 10.7761 11 10.5 11H2.5C2.22386 11 2 10.7761 2 10.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4s = [
    "color"
];
var $e781b76dcad7c5d5$export$79a9a721b029c6d9 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4s);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M3.49949 14.9C3.7204 14.9 3.89949 14.7209 3.89949 14.5L3.89949 10.4657L5.21664 11.7829C5.37285 11.9391 5.62612 11.9391 5.78233 11.7829C5.93854 11.6267 5.93854 11.3734 5.78233 11.2172L3.78233 9.21718C3.70732 9.14217 3.60557 9.10002 3.49949 9.10002C3.3934 9.10002 3.29166 9.14217 3.21664 9.21718L1.21664 11.2172C1.06043 11.3734 1.06043 11.6267 1.21664 11.7829C1.37285 11.9391 1.62612 11.9391 1.78233 11.7829L3.09949 10.4657L3.09949 14.5C3.09949 14.7209 3.27857 14.9 3.49949 14.9ZM7.99998 10.5C7.99998 10.7762 8.22383 11 8.49998 11H14.5C14.7761 11 15 10.7762 15 10.5C15 10.2239 14.7761 10 14.5 10H8.49998C8.22383 10 7.99998 10.2239 7.99998 10.5ZM7.99998 7.50002C7.99998 7.77617 8.22383 8.00002 8.49998 8.00002H14.5C14.7761 8.00002 15 7.77617 15 7.50002C15 7.22388 14.7761 7.00002 14.5 7.00002H8.49998C8.22383 7.00002 7.99998 7.22388 7.99998 7.50002ZM8.49998 5.00002C8.22383 5.00002 7.99998 4.77617 7.99998 4.50002C7.99998 4.22388 8.22383 4.00002 8.49998 4.00002H14.5C14.7761 4.00002 15 4.22388 15 4.50002C15 4.77617 14.7761 5.00002 14.5 5.00002H8.49998ZM3.89949 0.500025C3.89949 0.279111 3.7204 0.100025 3.49949 0.100025C3.27857 0.100025 3.09949 0.279111 3.09949 0.500025L3.09949 4.53434L1.78233 3.21718C1.62612 3.06097 1.37285 3.06097 1.21664 3.21718C1.06043 3.37339 1.06043 3.62666 1.21664 3.78287L3.21664 5.78287C3.29166 5.85788 3.3934 5.90002 3.49949 5.90002C3.60557 5.90002 3.70732 5.85788 3.78233 5.78287L5.78233 3.78287C5.93854 3.62666 5.93854 3.37339 5.78233 3.21718C5.62612 3.06097 5.37285 3.06097 5.21664 3.21718L3.89949 4.53434L3.89949 0.500025Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4t = [
    "color"
];
var $e781b76dcad7c5d5$export$2b644951427679e4 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4t);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M2 4.5C2 4.22386 2.22386 4 2.5 4H12.5C12.7761 4 13 4.22386 13 4.5C13 4.77614 12.7761 5 12.5 5H2.5C2.22386 5 2 4.77614 2 4.5ZM7 7.5C7 7.22386 7.22386 7 7.5 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H7.5C7.22386 8 7 7.77614 7 7.5ZM4 10.5C4 10.2239 4.22386 10 4.5 10H12.5C12.7761 10 13 10.2239 13 10.5C13 10.7761 12.7761 11 12.5 11H4.5C4.22386 11 4 10.7761 4 10.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4u = [
    "color"
];
var $e781b76dcad7c5d5$export$65298c635b1d5567 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4u);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M3.89949 9.49998C3.89949 9.72089 3.7204 9.89997 3.49949 9.89997C3.27857 9.89997 3.09949 9.72089 3.09949 9.49998L3.09949 2.46566L1.78233 3.78282C1.62612 3.93903 1.37285 3.93903 1.21664 3.78282C1.06043 3.62661 1.06043 3.37334 1.21664 3.21713L3.21664 1.21713C3.29166 1.14212 3.3934 1.09998 3.49949 1.09998C3.60557 1.09998 3.70732 1.14212 3.78233 1.21713L5.78233 3.21713C5.93854 3.37334 5.93854 3.62661 5.78233 3.78282C5.62612 3.93903 5.37285 3.93903 5.21664 3.78282L3.89949 2.46566L3.89949 9.49998ZM8.49998 1.99998C8.22383 1.99998 7.99998 2.22383 7.99998 2.49998C7.99998 2.77612 8.22383 2.99998 8.49998 2.99998H14.5C14.7761 2.99998 15 2.77612 15 2.49998C15 2.22383 14.7761 1.99998 14.5 1.99998H8.49998ZM8.49998 4.99998C8.22383 4.99998 7.99998 5.22383 7.99998 5.49998C7.99998 5.77612 8.22383 5.99998 8.49998 5.99998H14.5C14.7761 5.99998 15 5.77612 15 5.49998C15 5.22383 14.7761 4.99998 14.5 4.99998H8.49998ZM7.99998 8.49998C7.99998 8.22383 8.22383 7.99998 8.49998 7.99998H14.5C14.7761 7.99998 15 8.22383 15 8.49998C15 8.77612 14.7761 8.99998 14.5 8.99998H8.49998C8.22383 8.99998 7.99998 8.77612 7.99998 8.49998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4v = [
    "color"
];
var $e781b76dcad7c5d5$export$2407db3e81e79ec8 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4v);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M13.3536 2.35355C13.5488 2.15829 13.5488 1.84171 13.3536 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L11.9291 2.36383C11.9159 2.32246 11.897 2.28368 11.8732 2.24845C11.7923 2.12875 11.6554 2.05005 11.5001 2.05005H3.50005C3.29909 2.05005 3.1289 2.18178 3.07111 2.3636C3.05743 2.40665 3.05005 2.45249 3.05005 2.50007V4.50001C3.05005 4.74854 3.25152 4.95001 3.50005 4.95001C3.74858 4.95001 3.95005 4.74854 3.95005 4.50001V2.95005H6.95006V7.34284L1.64645 12.6464C1.45118 12.8417 1.45118 13.1583 1.64645 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L6.95006 8.75705V12.0501H5.7544C5.50587 12.0501 5.3044 12.2515 5.3044 12.5001C5.3044 12.7486 5.50587 12.9501 5.7544 12.9501H9.2544C9.50293 12.9501 9.7044 12.7486 9.7044 12.5001C9.7044 12.2515 9.50293 12.0501 9.2544 12.0501H8.05006V7.65705L13.3536 2.35355ZM8.05006 6.24284L11.0501 3.24283V2.95005H8.05006V6.24284Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4w = [
    "color"
];
var $e781b76dcad7c5d5$export$d02861c1158d3b3d = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4w);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M5 3.5C5 3.22386 5.22386 3 5.5 3H9.5C9.77614 3 10 3.22386 10 3.5V6H12.5C12.6873 6 12.8589 6.10467 12.9446 6.27121C13.0303 6.43774 13.0157 6.63821 12.9069 6.79062L7.90687 13.7906C7.81301 13.922 7.66148 14 7.5 14C7.33853 14 7.18699 13.922 7.09314 13.7906L2.09314 6.79062C1.98427 6.63821 1.96972 6.43774 2.05542 6.27121C2.14112 6.10467 2.31271 6 2.5 6H5V3.5ZM6 4V6.5C6 6.77614 5.77614 7 5.5 7H3.4716L7.5 12.6398L11.5284 7H9.5C9.22386 7 9 6.77614 9 6.5V4H6Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4x = [
    "color"
];
var $e781b76dcad7c5d5$export$90890f1931da847b = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4x);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M1 7.5C1 7.66148 1.07798 7.81301 1.20938 7.90687L8.20938 12.9069C8.36179 13.0157 8.56226 13.0303 8.72879 12.9446C8.89533 12.8589 9 12.6873 9 12.5L9 10L11.5 10C11.7761 10 12 9.77614 12 9.5L12 5.5C12 5.22386 11.7761 5 11.5 5L9 5L9 2.5C9 2.31271 8.89533 2.14112 8.72879 2.05542C8.56226 1.96972 8.36179 1.98427 8.20938 2.09313L1.20938 7.09314C1.07798 7.18699 1 7.33853 1 7.5ZM8 3.4716L8 5.5C8 5.77614 8.22386 6 8.5 6L11 6L11 9L8.5 9C8.22386 9 8 9.22386 8 9.5L8 11.5284L2.36023 7.5L8 3.4716Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4y = [
    "color"
];
var $e781b76dcad7c5d5$export$72a6223ceb8df5ef = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4y);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M14 7.5C14 7.66148 13.922 7.81301 13.7906 7.90687L6.79062 12.9069C6.63821 13.0157 6.43774 13.0303 6.27121 12.9446C6.10467 12.8589 6 12.6873 6 12.5L6 10L3.5 10C3.22386 10 3 9.77614 3 9.5L3 5.5C3 5.22386 3.22386 5 3.5 5L6 5L6 2.5C6 2.31271 6.10467 2.14112 6.27121 2.05542C6.43774 1.96972 6.63821 1.98427 6.79062 2.09313L13.7906 7.09314C13.922 7.18699 14 7.33853 14 7.5ZM7 3.4716L7 5.5C7 5.77614 6.77614 6 6.5 6L4 6L4 9L6.5 9C6.77614 9 7 9.22386 7 9.5L7 11.5284L12.6398 7.5L7 3.4716Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4z = [
    "color"
];
var $e781b76dcad7c5d5$export$edde007a504cdbfe = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4z);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.5 1C7.66148 1 7.81301 1.07798 7.90687 1.20938L12.9069 8.20938C13.0157 8.36179 13.0303 8.56226 12.9446 8.72879C12.8589 8.89533 12.6873 9 12.5 9H10V11.5C10 11.7761 9.77614 12 9.5 12H5.5C5.22386 12 5 11.7761 5 11.5V9H2.5C2.31271 9 2.14112 8.89533 2.05542 8.72879C1.96972 8.56226 1.98427 8.36179 2.09314 8.20938L7.09314 1.20938C7.18699 1.07798 7.33853 1 7.5 1ZM3.4716 8H5.5C5.77614 8 6 8.22386 6 8.5V11H9V8.5C9 8.22386 9.22386 8 9.5 8H11.5284L7.5 2.36023L3.4716 8Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4A = [
    "color"
];
var $e781b76dcad7c5d5$export$579848c7cccecf3f = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4A);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.49998 0.849976C7.22383 0.849976 6.99998 1.07383 6.99998 1.34998V3.52234C6.99998 3.79848 7.22383 4.02234 7.49998 4.02234C7.77612 4.02234 7.99998 3.79848 7.99998 3.52234V1.8718C10.8862 2.12488 13.15 4.54806 13.15 7.49998C13.15 10.6204 10.6204 13.15 7.49998 13.15C4.37957 13.15 1.84998 10.6204 1.84998 7.49998C1.84998 6.10612 2.35407 4.83128 3.19049 3.8459C3.36919 3.63538 3.34339 3.31985 3.13286 3.14115C2.92234 2.96245 2.60681 2.98825 2.42811 3.19877C1.44405 4.35808 0.849976 5.86029 0.849976 7.49998C0.849976 11.1727 3.82728 14.15 7.49998 14.15C11.1727 14.15 14.15 11.1727 14.15 7.49998C14.15 3.82728 11.1727 0.849976 7.49998 0.849976ZM6.74049 8.08072L4.22363 4.57237C4.15231 4.47295 4.16346 4.33652 4.24998 4.25C4.33649 4.16348 4.47293 4.15233 4.57234 4.22365L8.08069 6.74051C8.56227 7.08599 8.61906 7.78091 8.19998 8.2C7.78089 8.61909 7.08597 8.56229 6.74049 8.08072Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4B = [
    "color"
];
var $e781b76dcad7c5d5$export$872ef4fe88315cc3 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4B);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M4.5 2C3.11929 2 2 3.11929 2 4.5C2 5.88072 3.11929 7 4.5 7C5.88072 7 7 5.88072 7 4.5C7 3.11929 5.88072 2 4.5 2ZM3 4.5C3 3.67157 3.67157 3 4.5 3C5.32843 3 6 3.67157 6 4.5C6 5.32843 5.32843 6 4.5 6C3.67157 6 3 5.32843 3 4.5ZM10.5 2C9.11929 2 8 3.11929 8 4.5C8 5.88072 9.11929 7 10.5 7C11.8807 7 13 5.88072 13 4.5C13 3.11929 11.8807 2 10.5 2ZM9 4.5C9 3.67157 9.67157 3 10.5 3C11.3284 3 12 3.67157 12 4.5C12 5.32843 11.3284 6 10.5 6C9.67157 6 9 5.32843 9 4.5ZM2 10.5C2 9.11929 3.11929 8 4.5 8C5.88072 8 7 9.11929 7 10.5C7 11.8807 5.88072 13 4.5 13C3.11929 13 2 11.8807 2 10.5ZM4.5 9C3.67157 9 3 9.67157 3 10.5C3 11.3284 3.67157 12 4.5 12C5.32843 12 6 11.3284 6 10.5C6 9.67157 5.32843 9 4.5 9ZM10.5 8C9.11929 8 8 9.11929 8 10.5C8 11.8807 9.11929 13 10.5 13C11.8807 13 13 11.8807 13 10.5C13 9.11929 11.8807 8 10.5 8ZM9 10.5C9 9.67157 9.67157 9 10.5 9C11.3284 9 12 9.67157 12 10.5C12 11.3284 11.3284 12 10.5 12C9.67157 12 9 11.3284 9 10.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4C = [
    "color"
];
var $e781b76dcad7c5d5$export$df10b15f2353def5 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4C);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M13.0502 2.74989C13.0502 2.44613 12.804 2.19989 12.5002 2.19989C12.1965 2.19989 11.9502 2.44613 11.9502 2.74989V7.2825C11.9046 7.18802 11.8295 7.10851 11.7334 7.05776L2.73338 2.30776C2.5784 2.22596 2.3919 2.23127 2.24182 2.32176C2.09175 2.41225 2 2.57471 2 2.74995V12.25C2 12.4252 2.09175 12.5877 2.24182 12.6781C2.3919 12.7686 2.5784 12.7739 2.73338 12.6921L11.7334 7.94214C11.8295 7.89139 11.9046 7.81188 11.9502 7.7174V12.2499C11.9502 12.5536 12.1965 12.7999 12.5002 12.7999C12.804 12.7999 13.0502 12.5536 13.0502 12.2499V2.74989ZM3 11.4207V3.5792L10.4288 7.49995L3 11.4207Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4D = [
    "color"
];
var $e781b76dcad7c5d5$export$6130ef86fd52e250 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4D);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M1.94976 2.74989C1.94976 2.44613 2.196 2.19989 2.49976 2.19989C2.80351 2.19989 3.04976 2.44613 3.04976 2.74989V7.2825C3.0954 7.18802 3.17046 7.10851 3.26662 7.05776L12.2666 2.30776C12.4216 2.22596 12.6081 2.23127 12.7582 2.32176C12.9083 2.41225 13 2.57471 13 2.74995V12.25C13 12.4252 12.9083 12.5877 12.7582 12.6781C12.6081 12.7686 12.4216 12.7739 12.2666 12.6921L3.26662 7.94214C3.17046 7.89139 3.0954 7.81188 3.04976 7.7174V12.2499C3.04976 12.5536 2.80351 12.7999 2.49976 12.7999C2.196 12.7999 1.94976 12.5536 1.94976 12.2499V2.74989ZM4.57122 7.49995L12 11.4207V3.5792L4.57122 7.49995Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4E = [
    "color"
];
var $e781b76dcad7c5d5$export$ee1fdf1996836514 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4E);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M0.849976 1.74998C0.849976 1.25292 1.25292 0.849976 1.74998 0.849976H3.24998C3.74703 0.849976 4.14998 1.25292 4.14998 1.74998V2.04998H10.85V1.74998C10.85 1.25292 11.2529 0.849976 11.75 0.849976H13.25C13.747 0.849976 14.15 1.25292 14.15 1.74998V3.24998C14.15 3.74703 13.747 4.14998 13.25 4.14998H12.95V10.85H13.25C13.747 10.85 14.15 11.2529 14.15 11.75V13.25C14.15 13.747 13.747 14.15 13.25 14.15H11.75C11.2529 14.15 10.85 13.747 10.85 13.25V12.95H4.14998V13.25C4.14998 13.747 3.74703 14.15 3.24998 14.15H1.74998C1.25292 14.15 0.849976 13.747 0.849976 13.25V11.75C0.849976 11.2529 1.25292 10.85 1.74998 10.85H2.04998V4.14998H1.74998C1.25292 4.14998 0.849976 3.74703 0.849976 3.24998V1.74998ZM2.94998 4.14998V10.85H3.24998C3.74703 10.85 4.14998 11.2529 4.14998 11.75V12.05H10.85V11.75C10.85 11.2529 11.2529 10.85 11.75 10.85H12.05V4.14998H11.75C11.2529 4.14998 10.85 3.74703 10.85 3.24998V2.94998H4.14998V3.24998C4.14998 3.74703 3.74703 4.14998 3.24998 4.14998H2.94998ZM2.34998 1.74998H1.74998V2.34998V2.64998V3.24998H2.34998H2.64998H3.24998V2.64998V2.34998V1.74998H2.64998H2.34998ZM5.09998 5.99998C5.09998 5.50292 5.50292 5.09998 5.99998 5.09998H6.99998C7.49703 5.09998 7.89998 5.50292 7.89998 5.99998V6.99998C7.89998 7.03591 7.89787 7.07134 7.89378 7.10618C7.92861 7.10208 7.96405 7.09998 7.99998 7.09998H8.99998C9.49703 7.09998 9.89998 7.50292 9.89998 7.99998V8.99998C9.89998 9.49703 9.49703 9.89998 8.99998 9.89998H7.99998C7.50292 9.89998 7.09998 9.49703 7.09998 8.99998V7.99998C7.09998 7.96405 7.10208 7.92861 7.10618 7.89378C7.07134 7.89787 7.03591 7.89998 6.99998 7.89998H5.99998C5.50292 7.89998 5.09998 7.49703 5.09998 6.99998V5.99998ZM6.09998 5.99998H5.99998V6.09998V6.89998V6.99998H6.09998H6.89998H6.99998V6.89998V6.09998V5.99998H6.89998H6.09998ZM7.99998 7.99998H8.09998H8.89998H8.99998V8.09998V8.89998V8.99998H8.89998H8.09998H7.99998V8.89998V8.09998V7.99998ZM2.64998 11.75H2.34998H1.74998V12.35V12.65V13.25H2.34998H2.64998H3.24998V12.65V12.35V11.75H2.64998ZM11.75 1.74998H12.35H12.65H13.25V2.34998V2.64998V3.24998H12.65H12.35H11.75V2.64998V2.34998V1.74998ZM12.65 11.75H12.35H11.75V12.35V12.65V13.25H12.35H12.65H13.25V12.65V12.35V11.75H12.65Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4F = [
    "color"
];
var $e781b76dcad7c5d5$export$287e71cda35821ff = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4F);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        opacity: ".25",
        d: "M0 0H3V3H0V0ZM6 3H3V6H0V9H3V12H0V15H3V12H6V15H9V12H12V15H15V12H12V9H15V6H12V3H15V0H12V3H9V0H6V3ZM6 6V3H9V6H6ZM6 9H3V6H6V9ZM9 9V6H12V9H9ZM9 9H6V12H9V9Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4G = [
    "color"
];
var $e781b76dcad7c5d5$export$d23329de703dffc4 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4G);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M5.5 1C5.22386 1 5 1.22386 5 1.5C5 1.77614 5.22386 2 5.5 2H9.5C9.77614 2 10 1.77614 10 1.5C10 1.22386 9.77614 1 9.5 1H5.5ZM3 3.5C3 3.22386 3.22386 3 3.5 3H5H10H11.5C11.7761 3 12 3.22386 12 3.5C12 3.77614 11.7761 4 11.5 4H11V12C11 12.5523 10.5523 13 10 13H5C4.44772 13 4 12.5523 4 12V4L3.5 4C3.22386 4 3 3.77614 3 3.5ZM5 4H10V12H5V4Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4H = [
    "color"
];
var $e781b76dcad7c5d5$export$b445c2dc6993f9f8 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4H);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M4 6H11L7.5 10.5L4 6Z",
        fill: color
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4I = [
    "color"
];
var $e781b76dcad7c5d5$export$62f44957433ecfbf = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4I);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M9 4L9 11L4.5 7.5L9 4Z",
        fill: color
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4J = [
    "color"
];
var $e781b76dcad7c5d5$export$43e4d35e8a44b537 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4J);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M6 11L6 4L10.5 7.5L6 11Z",
        fill: color
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4K = [
    "color"
];
var $e781b76dcad7c5d5$export$9ff28f4659896371 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4K);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M4 9H11L7.5 4.5L4 9Z",
        fill: color
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4L = [
    "color"
];
var $e781b76dcad7c5d5$export$890946d7e35b6ab9 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4L);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.23336 4.69629C7.23336 2.96884 8.63335 1.56857 10.36 1.56857C11.3736 1.56857 12.183 2.04804 12.7254 2.74385C13.3079 2.62467 13.8557 2.40913 14.3513 2.11508C14.1559 2.72598 13.7424 3.2396 13.2033 3.56463C13.2038 3.56568 13.2042 3.56674 13.2047 3.56779C13.7334 3.50361 14.2364 3.36302 14.7048 3.15546L14.7037 3.15715C14.3667 3.66183 13.9431 4.10736 13.4561 4.47034C13.4823 4.64672 13.4956 4.82427 13.4956 5.00079C13.4956 8.6871 10.6873 12.9746 5.52122 12.9746C3.93906 12.9746 2.46544 12.511 1.22505 11.7152C0.992632 11.5661 0.925108 11.2568 1.07423 11.0244C1.0874 11.0038 1.10183 10.9846 1.11734 10.9666C1.20582 10.8202 1.37438 10.7309 1.5554 10.7522C2.47066 10.8601 3.38568 10.7485 4.19219 10.3962C3.39226 10.0434 2.77129 9.35975 2.50204 8.51974C2.45359 8.3686 2.48835 8.20311 2.59351 8.08422C2.59716 8.0801 2.60087 8.07606 2.60464 8.0721C1.96391 7.50819 1.55973 6.68208 1.55973 5.76143V5.72759C1.55973 5.56814 1.64411 5.42059 1.78155 5.33974C1.82671 5.31317 1.87537 5.29511 1.92532 5.28558C1.70549 4.86154 1.58116 4.37984 1.58116 3.86958C1.58116 3.40165 1.58384 2.81192 1.91332 2.28081C1.98718 2.16175 2.10758 2.08915 2.2364 2.07195C2.42588 2.01237 2.64087 2.06969 2.77406 2.23302C3.86536 3.57126 5.44066 4.49583 7.23366 4.73961L7.23336 4.69629ZM5.52122 11.9746C4.73387 11.9746 3.97781 11.8435 3.27248 11.6023C4.13012 11.4538 4.95307 11.1159 5.66218 10.5602C5.81211 10.4427 5.87182 10.2435 5.81126 10.0629C5.7507 9.88234 5.583 9.75943 5.39255 9.75607C4.68968 9.74366 4.06712 9.39716 3.67793 8.86845C3.86828 8.85306 4.05428 8.82039 4.23445 8.77167C4.43603 8.71716 4.57363 8.53114 4.56674 8.32243C4.55985 8.11372 4.41029 7.93718 4.20555 7.89607C3.42694 7.73977 2.79883 7.16764 2.56169 6.42174C2.76255 6.47025 2.97102 6.4991 3.18482 6.5061C3.38563 6.51267 3.56646 6.38533 3.62795 6.19405C3.68943 6.00277 3.61666 5.79391 3.44963 5.68224C2.86523 5.29155 2.48116 4.62464 2.48116 3.86958C2.48116 3.70213 2.48352 3.55268 2.49355 3.41719C3.85115 4.79913 5.70873 5.68931 7.77588 5.79338C7.93225 5.80126 8.08328 5.73543 8.18395 5.61553C8.28463 5.49562 8.32332 5.33548 8.28851 5.18284C8.25255 5.02517 8.23336 4.86284 8.23336 4.69629C8.23336 3.52085 9.18591 2.56857 10.36 2.56857C11.5943 2.56857 12.4956 3.71208 12.4956 5.00079C12.4956 8.25709 10.0202 11.9746 5.52122 11.9746Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4M = [
    "color"
];
var $e781b76dcad7c5d5$export$4ce1642bb7f15c79 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4M);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M5.00001 2.75C5.00001 2.47386 4.77615 2.25 4.50001 2.25C4.22387 2.25 4.00001 2.47386 4.00001 2.75V8.05C4.00001 9.983 5.56702 11.55 7.50001 11.55C9.43301 11.55 11 9.983 11 8.05V2.75C11 2.47386 10.7762 2.25 10.5 2.25C10.2239 2.25 10 2.47386 10 2.75V8.05C10 9.43071 8.88072 10.55 7.50001 10.55C6.1193 10.55 5.00001 9.43071 5.00001 8.05V2.75ZM3.49998 13.1001C3.27906 13.1001 3.09998 13.2791 3.09998 13.5001C3.09998 13.721 3.27906 13.9001 3.49998 13.9001H11.5C11.7209 13.9001 11.9 13.721 11.9 13.5001C11.9 13.2791 11.7209 13.1001 11.5 13.1001H3.49998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4N = [
    "color"
];
var $e781b76dcad7c5d5$export$35f5c3e250802cd1 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4N);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M1.90321 7.29677C1.90321 10.341 4.11041 12.4147 6.58893 12.8439C6.87255 12.893 7.06266 13.1627 7.01355 13.4464C6.96444 13.73 6.69471 13.9201 6.41109 13.871C3.49942 13.3668 0.86084 10.9127 0.86084 7.29677C0.860839 5.76009 1.55996 4.55245 2.37639 3.63377C2.96124 2.97568 3.63034 2.44135 4.16846 2.03202L2.53205 2.03202C2.25591 2.03202 2.03205 1.80816 2.03205 1.53202C2.03205 1.25588 2.25591 1.03202 2.53205 1.03202L5.53205 1.03202C5.80819 1.03202 6.03205 1.25588 6.03205 1.53202L6.03205 4.53202C6.03205 4.80816 5.80819 5.03202 5.53205 5.03202C5.25591 5.03202 5.03205 4.80816 5.03205 4.53202L5.03205 2.68645L5.03054 2.68759L5.03045 2.68766L5.03044 2.68767L5.03043 2.68767C4.45896 3.11868 3.76059 3.64538 3.15554 4.3262C2.44102 5.13021 1.90321 6.10154 1.90321 7.29677ZM13.0109 7.70321C13.0109 4.69115 10.8505 2.6296 8.40384 2.17029C8.12093 2.11718 7.93465 1.84479 7.98776 1.56188C8.04087 1.27898 8.31326 1.0927 8.59616 1.14581C11.4704 1.68541 14.0532 4.12605 14.0532 7.70321C14.0532 9.23988 13.3541 10.4475 12.5377 11.3662C11.9528 12.0243 11.2837 12.5586 10.7456 12.968L12.3821 12.968C12.6582 12.968 12.8821 13.1918 12.8821 13.468C12.8821 13.7441 12.6582 13.968 12.3821 13.968L9.38205 13.968C9.10591 13.968 8.88205 13.7441 8.88205 13.468L8.88205 10.468C8.88205 10.1918 9.10591 9.96796 9.38205 9.96796C9.65819 9.96796 9.88205 10.1918 9.88205 10.468L9.88205 12.3135L9.88362 12.3123C10.4551 11.8813 11.1535 11.3546 11.7585 10.6738C12.4731 9.86976 13.0109 8.89844 13.0109 7.70321Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4O = [
    "color"
];
var $e781b76dcad7c5d5$export$8df90684a752ef81 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4O);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.81825 1.18188C7.64251 1.00615 7.35759 1.00615 7.18185 1.18188L4.18185 4.18188C4.00611 4.35762 4.00611 4.64254 4.18185 4.81828C4.35759 4.99401 4.64251 4.99401 4.81825 4.81828L7.05005 2.58648V9.49996C7.05005 9.74849 7.25152 9.94996 7.50005 9.94996C7.74858 9.94996 7.95005 9.74849 7.95005 9.49996V2.58648L10.1819 4.81828C10.3576 4.99401 10.6425 4.99401 10.8182 4.81828C10.994 4.64254 10.994 4.35762 10.8182 4.18188L7.81825 1.18188ZM2.5 9.99997C2.77614 9.99997 3 10.2238 3 10.5V12C3 12.5538 3.44565 13 3.99635 13H11.0012C11.5529 13 12 12.5528 12 12V10.5C12 10.2238 12.2239 9.99997 12.5 9.99997C12.7761 9.99997 13 10.2238 13 10.5V12C13 13.104 12.1062 14 11.0012 14H3.99635C2.89019 14 2 13.103 2 12V10.5C2 10.2238 2.22386 9.99997 2.5 9.99997Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4P = [
    "color"
];
var $e781b76dcad7c5d5$export$6e6352268496f418 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4P);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M0.877075 7.49988C0.877075 3.84219 3.84222 0.877045 7.49991 0.877045C11.1576 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49988ZM7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 4.36686 10.6329 1.82704 7.49991 1.82704Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4Q = [
    "color"
];
var $e781b76dcad7c5d5$export$aff958e91ee0391a = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4Q);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.49985 0.877045C3.84216 0.877045 0.877014 3.84219 0.877014 7.49988C0.877014 9.1488 1.47963 10.657 2.47665 11.8162L1.64643 12.6464C1.45117 12.8417 1.45117 13.1583 1.64643 13.3535C1.8417 13.5488 2.15828 13.5488 2.35354 13.3535L3.18377 12.5233C4.34296 13.5202 5.85104 14.1227 7.49985 14.1227C11.1575 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 5.85107 13.5202 4.34299 12.5233 3.1838L13.3535 2.35354C13.5488 2.15827 13.5488 1.84169 13.3535 1.64643C13.1583 1.45117 12.8417 1.45117 12.6464 1.64643L11.8162 2.47668C10.657 1.47966 9.14877 0.877045 7.49985 0.877045ZM11.1422 3.15066C10.1567 2.32449 8.88639 1.82704 7.49985 1.82704C4.36683 1.82704 1.82701 4.36686 1.82701 7.49988C1.82701 8.88642 2.32446 10.1568 3.15063 11.1422L11.1422 3.15066ZM3.85776 11.8493C4.84317 12.6753 6.11343 13.1727 7.49985 13.1727C10.6328 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 6.11346 12.6753 4.8432 11.8493 3.85779L3.85776 11.8493Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4R = [
    "color"
];
var $e781b76dcad7c5d5$export$18bf59af111847c = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4R);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7.49998 1L6.92321 2.00307L1.17498 12L0.599976 13H1.7535H13.2464H14.4L13.825 12L8.07674 2.00307L7.49998 1ZM7.49998 3.00613L2.3285 12H12.6714L7.49998 3.00613Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4S = [
    "color"
];
var $e781b76dcad7c5d5$export$4ec8735ec23c8112 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4S);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M4.76447 3.12199C5.63151 3.04859 6.56082 3 7.5 3C8.43918 3 9.36849 3.04859 10.2355 3.12199C11.2796 3.21037 11.9553 3.27008 12.472 3.39203C12.9425 3.50304 13.2048 3.64976 13.4306 3.88086C13.4553 3.90618 13.4902 3.94414 13.5133 3.97092C13.7126 4.20149 13.8435 4.4887 13.918 5.03283C13.9978 5.6156 14 6.37644 14 7.52493C14 8.66026 13.9978 9.41019 13.9181 9.98538C13.8439 10.5206 13.7137 10.8061 13.5125 11.0387C13.4896 11.0651 13.4541 11.1038 13.4296 11.1287C13.2009 11.3625 12.9406 11.5076 12.4818 11.6164C11.9752 11.7365 11.3143 11.7942 10.2878 11.8797C9.41948 11.9521 8.47566 12 7.5 12C6.52434 12 5.58052 11.9521 4.7122 11.8797C3.68572 11.7942 3.02477 11.7365 2.51816 11.6164C2.05936 11.5076 1.7991 11.3625 1.57037 11.1287C1.54593 11.1038 1.51035 11.0651 1.48748 11.0387C1.28628 10.8061 1.15612 10.5206 1.08193 9.98538C1.00221 9.41019 1 8.66026 1 7.52493C1 6.37644 1.00216 5.6156 1.082 5.03283C1.15654 4.4887 1.28744 4.20149 1.48666 3.97092C1.5098 3.94414 1.54468 3.90618 1.56942 3.88086C1.7952 3.64976 2.05752 3.50304 2.52796 3.39203C3.04473 3.27008 3.7204 3.21037 4.76447 3.12199ZM0 7.52493C0 5.28296 0 4.16198 0.729985 3.31713C0.766457 3.27491 0.815139 3.22194 0.854123 3.18204C1.63439 2.38339 2.64963 2.29744 4.68012 2.12555C5.56923 2.05028 6.52724 2 7.5 2C8.47276 2 9.43077 2.05028 10.3199 2.12555C12.3504 2.29744 13.3656 2.38339 14.1459 3.18204C14.1849 3.22194 14.2335 3.27491 14.27 3.31713C15 4.16198 15 5.28296 15 7.52493C15 9.74012 15 10.8477 14.2688 11.6929C14.2326 11.7348 14.1832 11.7885 14.1444 11.8281C13.3629 12.6269 12.3655 12.71 10.3709 12.8763C9.47971 12.9505 8.50782 13 7.5 13C6.49218 13 5.52028 12.9505 4.62915 12.8763C2.63446 12.71 1.63712 12.6269 0.855558 11.8281C0.816844 11.7885 0.767442 11.7348 0.731221 11.6929C0 10.8477 0 9.74012 0 7.52493ZM5.25 5.38264C5.25 5.20225 5.43522 5.08124 5.60041 5.15369L10.428 7.27105C10.6274 7.35853 10.6274 7.64147 10.428 7.72895L5.60041 9.84631C5.43522 9.91876 5.25 9.79775 5.25 9.61736V5.38264Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4T = [
    "color"
];
var $e781b76dcad7c5d5$export$6262053f5289408a = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4T);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M7 2H1.5C1.22386 2 1 2.22386 1 2.5V7H7V2ZM8 2V7H14V2.5C14 2.22386 13.7761 2 13.5 2H8ZM7 8H1V12.5C1 12.7761 1.22386 13 1.5 13H7V8ZM8 13V8H14V12.5C14 12.7761 13.7761 13 13.5 13H8ZM1.5 1C0.671573 1 0 1.67157 0 2.5V12.5C0 13.3284 0.671573 14 1.5 14H13.5C14.3284 14 15 13.3284 15 12.5V2.5C15 1.67157 14.3284 1 13.5 1H1.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4U = [
    "color"
];
var $e781b76dcad7c5d5$export$832ec864fd299632 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4U);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M1.5 2H13.5C13.7761 2 14 2.22386 14 2.5V7H1V2.5C1 2.22386 1.22386 2 1.5 2ZM1 8V12.5C1 12.7761 1.22386 13 1.5 13H13.5C13.7761 13 14 12.7761 14 12.5V8H1ZM0 2.5C0 1.67157 0.671573 1 1.5 1H13.5C14.3284 1 15 1.67157 15 2.5V12.5C15 13.3284 14.3284 14 13.5 14H1.5C0.671573 14 0 13.3284 0 12.5V2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4V = [
    "color"
];
var $e781b76dcad7c5d5$export$c65e16705969a7a8 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4V);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M14 2.58711L1.85163 13H13.5C13.7761 13 14 12.7761 14 12.5V2.58711ZM0.762879 13.8067L0.825396 13.8796L0.854717 13.8545C1.05017 13.9478 1.26899 14 1.5 14H13.5C14.3284 14 15 13.3284 15 12.5V2.5C15 1.93949 14.6926 1.45078 14.2371 1.19331L14.1746 1.12037L14.1453 1.1455C13.9498 1.05222 13.731 1 13.5 1H1.5C0.671573 1 0 1.67157 0 2.5V12.5C0 13.0605 0.307435 13.5492 0.762879 13.8067ZM1 12.4129L13.1484 2H1.5C1.22386 2 1 2.22386 1 2.5V12.4129Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4W = [
    "color"
];
var $e781b76dcad7c5d5$export$96186050b98a4434 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4W);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M8 2H13.5C13.7761 2 14 2.22386 14 2.5V12.5C14 12.7761 13.7761 13 13.5 13H8V2ZM7 2H1.5C1.22386 2 1 2.22386 1 2.5V12.5C1 12.7761 1.22386 13 1.5 13H7V2ZM0 2.5C0 1.67157 0.671573 1 1.5 1H13.5C14.3284 1 15 1.67157 15 2.5V12.5C15 13.3284 14.3284 14 13.5 14H1.5C0.671573 14 0 13.3284 0 12.5V2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4X = [
    "color"
];
var $e781b76dcad7c5d5$export$815859cc984b9edf = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4X);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M4.81812 4.68161C4.99386 4.85734 4.99386 5.14227 4.81812 5.318L3.08632 7.0498H11.9135L10.1817 5.318C10.006 5.14227 10.006 4.85734 10.1817 4.68161C10.3575 4.50587 10.6424 4.50587 10.8181 4.68161L13.3181 7.18161C13.4939 7.35734 13.4939 7.64227 13.3181 7.818L10.8181 10.318C10.6424 10.4937 10.3575 10.4937 10.1817 10.318C10.006 10.1423 10.006 9.85734 10.1817 9.68161L11.9135 7.9498H3.08632L4.81812 9.68161C4.99386 9.85734 4.99386 10.1423 4.81812 10.318C4.64239 10.4937 4.35746 10.4937 4.18173 10.318L1.68173 7.818C1.50599 7.64227 1.50599 7.35734 1.68173 7.18161L4.18173 4.68161C4.35746 4.50587 4.64239 4.50587 4.81812 4.68161Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4Y = [
    "color"
];
var $e781b76dcad7c5d5$export$418cedbcfc990387 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4Y);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M10 6.5C10 8.433 8.433 10 6.5 10C4.567 10 3 8.433 3 6.5C3 4.567 4.567 3 6.5 3C8.433 3 10 4.567 10 6.5ZM9.30884 10.0159C8.53901 10.6318 7.56251 11 6.5 11C4.01472 11 2 8.98528 2 6.5C2 4.01472 4.01472 2 6.5 2C8.98528 2 11 4.01472 11 6.5C11 7.56251 10.6318 8.53901 10.0159 9.30884L12.8536 12.1464C13.0488 12.3417 13.0488 12.6583 12.8536 12.8536C12.6583 13.0488 12.3417 13.0488 12.1464 12.8536L9.30884 10.0159ZM4.25 6.5C4.25 6.22386 4.47386 6 4.75 6H6V4.75C6 4.47386 6.22386 4.25 6.5 4.25C6.77614 4.25 7 4.47386 7 4.75V6H8.25C8.52614 6 8.75 6.22386 8.75 6.5C8.75 6.77614 8.52614 7 8.25 7H7V8.25C7 8.52614 6.77614 8.75 6.5 8.75C6.22386 8.75 6 8.52614 6 8.25V7H4.75C4.47386 7 4.25 6.77614 4.25 6.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $e781b76dcad7c5d5$var$_excluded$4Z = [
    "color"
];
var $e781b76dcad7c5d5$export$fbd55a4c69e8e024 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $e781b76dcad7c5d5$var$_objectWithoutPropertiesLoose(_ref, $e781b76dcad7c5d5$var$_excluded$4Z);
    return (0, $jbmdS.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $jbmdS.createElement)("path", {
        d: "M6.5 10C8.433 10 10 8.433 10 6.5C10 4.567 8.433 3 6.5 3C4.567 3 3 4.567 3 6.5C3 8.433 4.567 10 6.5 10ZM6.5 11C7.56251 11 8.53901 10.6318 9.30884 10.0159L12.1464 12.8536C12.3417 13.0488 12.6583 13.0488 12.8536 12.8536C13.0488 12.6583 13.0488 12.3417 12.8536 12.1464L10.0159 9.30884C10.6318 8.53901 11 7.56251 11 6.5C11 4.01472 8.98528 2 6.5 2C4.01472 2 2 4.01472 2 6.5C2 8.98528 4.01472 11 6.5 11ZM4.75 6C4.47386 6 4.25 6.22386 4.25 6.5C4.25 6.77614 4.47386 7 4.75 7H8.25C8.52614 7 8.75 6.77614 8.75 6.5C8.75 6.22386 8.52614 6 8.25 6H4.75Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});

});

parcelRegister("7MfWg", function(module, exports) {

$parcel$export(module.exports, "Command", function () { return $bc5b00cb4375a366$export$cc7e12c76513e857; });

var $9iKiw = parcelRequire("9iKiw");

var $ixm3B = parcelRequire("ixm3B");

var $jbmdS = parcelRequire("jbmdS");

var $bwjUk = parcelRequire("bwjUk");
var $bc5b00cb4375a366$var$V = '[cmdk-group=""]', $bc5b00cb4375a366$var$X = '[cmdk-group-items=""]', $bc5b00cb4375a366$var$ge = '[cmdk-group-heading=""]', $bc5b00cb4375a366$var$Y = '[cmdk-item=""]', $bc5b00cb4375a366$var$le = `${$bc5b00cb4375a366$var$Y}:not([aria-disabled="true"])`, $bc5b00cb4375a366$var$Q = "cmdk-item-select", $bc5b00cb4375a366$var$M = "data-value", $bc5b00cb4375a366$var$Re = (r, o, n)=>(0, $9iKiw.a)(r, o, n), $bc5b00cb4375a366$var$ue = $jbmdS.createContext(void 0), $bc5b00cb4375a366$var$G = ()=>$jbmdS.useContext($bc5b00cb4375a366$var$ue), $bc5b00cb4375a366$var$de = $jbmdS.createContext(void 0), $bc5b00cb4375a366$var$Z = ()=>$jbmdS.useContext($bc5b00cb4375a366$var$de), $bc5b00cb4375a366$var$fe = $jbmdS.createContext(void 0), $bc5b00cb4375a366$export$6def88b96ee4affb = $jbmdS.forwardRef((r, o)=>{
    let n = $bc5b00cb4375a366$var$k(()=>{
        var e, s;
        return {
            search: "",
            value: (s = (e = r.value) != null ? e : r.defaultValue) != null ? s : "",
            filtered: {
                count: 0,
                items: new Map,
                groups: new Set
            }
        };
    }), u = $bc5b00cb4375a366$var$k(()=>new Set), c = $bc5b00cb4375a366$var$k(()=>new Map), d = $bc5b00cb4375a366$var$k(()=>new Map), f = $bc5b00cb4375a366$var$k(()=>new Set), p = $bc5b00cb4375a366$var$pe(r), { label: v, children: b, value: l, onValueChange: y, filter: S, shouldFilter: C, loop: L, disablePointerSelection: ee = !1, vimBindings: j = !0, ...H } = r, te = $jbmdS.useId(), $ = $jbmdS.useId(), K = $jbmdS.useId(), x = $jbmdS.useRef(null), g = $bc5b00cb4375a366$var$Me();
    $bc5b00cb4375a366$var$T(()=>{
        if (l !== void 0) {
            let e = l.trim();
            n.current.value = e, h.emit();
        }
    }, [
        l
    ]), $bc5b00cb4375a366$var$T(()=>{
        g(6, re);
    }, []);
    let h = $jbmdS.useMemo(()=>({
            subscribe: (e)=>(f.current.add(e), ()=>f.current.delete(e)),
            snapshot: ()=>n.current,
            setState: (e, s, i)=>{
                var a, m, R;
                if (!Object.is(n.current[e], s)) {
                    if (n.current[e] = s, e === "search") z(), q(), g(1, U);
                    else if (e === "value" && (i || g(5, re), ((a = p.current) == null ? void 0 : a.value) !== void 0)) {
                        let E = s != null ? s : "";
                        (R = (m = p.current).onValueChange) == null || R.call(m, E);
                        return;
                    }
                    h.emit();
                }
            },
            emit: ()=>{
                f.current.forEach((e)=>e());
            }
        }), []), B = $jbmdS.useMemo(()=>({
            value: (e, s, i)=>{
                var a;
                s !== ((a = d.current.get(e)) == null ? void 0 : a.value) && (d.current.set(e, {
                    value: s,
                    keywords: i
                }), n.current.filtered.items.set(e, ne(s, i)), g(2, ()=>{
                    q(), h.emit();
                }));
            },
            item: (e, s)=>(u.current.add(e), s && (c.current.has(s) ? c.current.get(s).add(e) : c.current.set(s, new Set([
                    e
                ]))), g(3, ()=>{
                    z(), q(), n.current.value || U(), h.emit();
                }), ()=>{
                    d.current.delete(e), u.current.delete(e), n.current.filtered.items.delete(e);
                    let i = O();
                    g(4, ()=>{
                        z(), (i == null ? void 0 : i.getAttribute("id")) === e && U(), h.emit();
                    });
                }),
            group: (e)=>(c.current.has(e) || c.current.set(e, new Set), ()=>{
                    d.current.delete(e), c.current.delete(e);
                }),
            filter: ()=>p.current.shouldFilter,
            label: v || r["aria-label"],
            disablePointerSelection: ee,
            listId: te,
            inputId: K,
            labelId: $,
            listInnerRef: x
        }), []);
    function ne(e, s) {
        var a, m;
        let i = (m = (a = p.current) == null ? void 0 : a.filter) != null ? m : $bc5b00cb4375a366$var$Re;
        return e ? i(e, n.current.search, s) : 0;
    }
    function q() {
        if (!n.current.search || p.current.shouldFilter === !1) return;
        let e = n.current.filtered.items, s = [];
        n.current.filtered.groups.forEach((a)=>{
            let m = c.current.get(a), R = 0;
            m.forEach((E)=>{
                let P = e.get(E);
                R = Math.max(P, R);
            }), s.push([
                a,
                R
            ]);
        });
        let i = x.current;
        A().sort((a, m)=>{
            var P, _;
            let R = a.getAttribute("id"), E = m.getAttribute("id");
            return ((P = e.get(E)) != null ? P : 0) - ((_ = e.get(R)) != null ? _ : 0);
        }).forEach((a)=>{
            let m = a.closest($bc5b00cb4375a366$var$X);
            m ? m.appendChild(a.parentElement === m ? a : a.closest(`${$bc5b00cb4375a366$var$X} > *`)) : i.appendChild(a.parentElement === i ? a : a.closest(`${$bc5b00cb4375a366$var$X} > *`));
        }), s.sort((a, m)=>m[1] - a[1]).forEach((a)=>{
            let m = x.current.querySelector(`${$bc5b00cb4375a366$var$V}[${$bc5b00cb4375a366$var$M}="${encodeURIComponent(a[0])}"]`);
            m == null || m.parentElement.appendChild(m);
        });
    }
    function U() {
        let e = A().find((i)=>i.getAttribute("aria-disabled") !== "true"), s = e == null ? void 0 : e.getAttribute($bc5b00cb4375a366$var$M);
        h.setState("value", s || void 0);
    }
    function z() {
        var s, i, a, m;
        if (!n.current.search || p.current.shouldFilter === !1) {
            n.current.filtered.count = u.current.size;
            return;
        }
        n.current.filtered.groups = new Set;
        let e = 0;
        for (let R of u.current){
            let E = (i = (s = d.current.get(R)) == null ? void 0 : s.value) != null ? i : "", P = (m = (a = d.current.get(R)) == null ? void 0 : a.keywords) != null ? m : [], _ = ne(E, P);
            n.current.filtered.items.set(R, _), _ > 0 && e++;
        }
        for (let [R, E] of c.current)for (let P of E)if (n.current.filtered.items.get(P) > 0) {
            n.current.filtered.groups.add(R);
            break;
        }
        n.current.filtered.count = e;
    }
    function re() {
        var s, i, a;
        let e = O();
        e && (((s = e.parentElement) == null ? void 0 : s.firstChild) === e && ((a = (i = e.closest($bc5b00cb4375a366$var$V)) == null ? void 0 : i.querySelector($bc5b00cb4375a366$var$ge)) == null || a.scrollIntoView({
            block: "nearest"
        })), e.scrollIntoView({
            block: "nearest"
        }));
    }
    function O() {
        var e;
        return (e = x.current) == null ? void 0 : e.querySelector(`${$bc5b00cb4375a366$var$Y}[aria-selected="true"]`);
    }
    function A() {
        var e;
        return Array.from((e = x.current) == null ? void 0 : e.querySelectorAll($bc5b00cb4375a366$var$le));
    }
    function W(e) {
        let i = A()[e];
        i && h.setState("value", i.getAttribute($bc5b00cb4375a366$var$M));
    }
    function J(e) {
        var R;
        let s = O(), i = A(), a = i.findIndex((E)=>E === s), m = i[a + e];
        (R = p.current) != null && R.loop && (m = a + e < 0 ? i[i.length - 1] : a + e === i.length ? i[0] : i[a + e]), m && h.setState("value", m.getAttribute($bc5b00cb4375a366$var$M));
    }
    function oe(e) {
        let s = O(), i = s == null ? void 0 : s.closest($bc5b00cb4375a366$var$V), a;
        for(; i && !a;)i = e > 0 ? $bc5b00cb4375a366$var$we(i, $bc5b00cb4375a366$var$V) : $bc5b00cb4375a366$var$Ie(i, $bc5b00cb4375a366$var$V), a = i == null ? void 0 : i.querySelector($bc5b00cb4375a366$var$le);
        a ? h.setState("value", a.getAttribute($bc5b00cb4375a366$var$M)) : J(e);
    }
    let ie = ()=>W(A().length - 1), ae = (e)=>{
        e.preventDefault(), e.metaKey ? ie() : e.altKey ? oe(1) : J(1);
    }, se = (e)=>{
        e.preventDefault(), e.metaKey ? W(0) : e.altKey ? oe(-1) : J(-1);
    };
    return $jbmdS.createElement((0, $bwjUk.Primitive).div, {
        ref: o,
        tabIndex: -1,
        ...H,
        "cmdk-root": "",
        onKeyDown: (e)=>{
            var s;
            if ((s = H.onKeyDown) == null || s.call(H, e), !e.defaultPrevented) switch(e.key){
                case "n":
                case "j":
                    j && e.ctrlKey && ae(e);
                    break;
                case "ArrowDown":
                    ae(e);
                    break;
                case "p":
                case "k":
                    j && e.ctrlKey && se(e);
                    break;
                case "ArrowUp":
                    se(e);
                    break;
                case "Home":
                    e.preventDefault(), W(0);
                    break;
                case "End":
                    e.preventDefault(), ie();
                    break;
                case "Enter":
                    if (!e.nativeEvent.isComposing && e.keyCode !== 229) {
                        e.preventDefault();
                        let i = O();
                        if (i) {
                            let a = new Event($bc5b00cb4375a366$var$Q);
                            i.dispatchEvent(a);
                        }
                    }
            }
        }
    }, $jbmdS.createElement("label", {
        "cmdk-label": "",
        htmlFor: B.inputId,
        id: B.labelId,
        style: $bc5b00cb4375a366$var$De
    }, v), $bc5b00cb4375a366$var$F(r, (e)=>$jbmdS.createElement($bc5b00cb4375a366$var$de.Provider, {
            value: h
        }, $jbmdS.createElement($bc5b00cb4375a366$var$ue.Provider, {
            value: B
        }, e))));
}), $bc5b00cb4375a366$export$b9b346a733d36f61 = $jbmdS.forwardRef((r, o)=>{
    var K, x;
    let n = $jbmdS.useId(), u = $jbmdS.useRef(null), c = $jbmdS.useContext($bc5b00cb4375a366$var$fe), d = $bc5b00cb4375a366$var$G(), f = $bc5b00cb4375a366$var$pe(r), p = (x = (K = f.current) == null ? void 0 : K.forceMount) != null ? x : c == null ? void 0 : c.forceMount;
    $bc5b00cb4375a366$var$T(()=>{
        if (!p) return d.item(n, c == null ? void 0 : c.id);
    }, [
        p
    ]);
    let v = $bc5b00cb4375a366$var$ve(n, u, [
        r.value,
        r.children,
        u
    ], r.keywords), b = $bc5b00cb4375a366$var$Z(), l = $bc5b00cb4375a366$export$606184d999862dff((g)=>g.value && g.value === v.current), y = $bc5b00cb4375a366$export$606184d999862dff((g)=>p || d.filter() === !1 ? !0 : g.search ? g.filtered.items.get(n) > 0 : !0);
    $jbmdS.useEffect(()=>{
        let g = u.current;
        if (!(!g || r.disabled)) return g.addEventListener($bc5b00cb4375a366$var$Q, S), ()=>g.removeEventListener($bc5b00cb4375a366$var$Q, S);
    }, [
        y,
        r.onSelect,
        r.disabled
    ]);
    function S() {
        var g, h;
        C(), (h = (g = f.current).onSelect) == null || h.call(g, v.current);
    }
    function C() {
        b.setState("value", v.current, !0);
    }
    if (!y) return null;
    let { disabled: L, value: ee, onSelect: j, forceMount: H, keywords: te, ...$ } = r;
    return $jbmdS.createElement((0, $bwjUk.Primitive).div, {
        ref: $bc5b00cb4375a366$var$N([
            u,
            o
        ]),
        ...$,
        id: n,
        "cmdk-item": "",
        role: "option",
        "aria-disabled": !!L,
        "aria-selected": !!l,
        "data-disabled": !!L,
        "data-selected": !!l,
        onPointerMove: L || d.disablePointerSelection ? void 0 : C,
        onClick: L ? void 0 : S
    }, r.children);
}), $bc5b00cb4375a366$export$c157b9873a7a0fbd = $jbmdS.forwardRef((r, o)=>{
    let { heading: n, children: u, forceMount: c, ...d } = r, f = $jbmdS.useId(), p = $jbmdS.useRef(null), v = $jbmdS.useRef(null), b = $jbmdS.useId(), l = $bc5b00cb4375a366$var$G(), y = $bc5b00cb4375a366$export$606184d999862dff((C)=>c || l.filter() === !1 ? !0 : C.search ? C.filtered.groups.has(f) : !0);
    $bc5b00cb4375a366$var$T(()=>l.group(f), []), $bc5b00cb4375a366$var$ve(f, p, [
        r.value,
        r.heading,
        v
    ]);
    let S = $jbmdS.useMemo(()=>({
            id: f,
            forceMount: c
        }), [
        c
    ]);
    return $jbmdS.createElement((0, $bwjUk.Primitive).div, {
        ref: $bc5b00cb4375a366$var$N([
            p,
            o
        ]),
        ...d,
        "cmdk-group": "",
        role: "presentation",
        hidden: y ? void 0 : !0
    }, n && $jbmdS.createElement("div", {
        ref: v,
        "cmdk-group-heading": "",
        "aria-hidden": !0,
        id: b
    }, n), $bc5b00cb4375a366$var$F(r, (C)=>$jbmdS.createElement("div", {
            "cmdk-group-items": "",
            role: "group",
            "aria-labelledby": n ? b : void 0
        }, $jbmdS.createElement($bc5b00cb4375a366$var$fe.Provider, {
            value: S
        }, C))));
}), $bc5b00cb4375a366$export$ace649eed6990b42 = $jbmdS.forwardRef((r, o)=>{
    let { alwaysRender: n, ...u } = r, c = $jbmdS.useRef(null), d = $bc5b00cb4375a366$export$606184d999862dff((f)=>!f.search);
    return !n && !d ? null : $jbmdS.createElement((0, $bwjUk.Primitive).div, {
        ref: $bc5b00cb4375a366$var$N([
            c,
            o
        ]),
        ...u,
        "cmdk-separator": "",
        role: "separator"
    });
}), $bc5b00cb4375a366$export$ebdebb88e46df62a = $jbmdS.forwardRef((r, o)=>{
    let { onValueChange: n, ...u } = r, c = r.value != null, d = $bc5b00cb4375a366$var$Z(), f = $bc5b00cb4375a366$export$606184d999862dff((l)=>l.search), p = $bc5b00cb4375a366$export$606184d999862dff((l)=>l.value), v = $bc5b00cb4375a366$var$G(), b = $jbmdS.useMemo(()=>{
        var y;
        let l = (y = v.listInnerRef.current) == null ? void 0 : y.querySelector(`${$bc5b00cb4375a366$var$Y}[${$bc5b00cb4375a366$var$M}="${encodeURIComponent(p)}"]`);
        return l == null ? void 0 : l.getAttribute("id");
    }, []);
    return $jbmdS.useEffect(()=>{
        r.value != null && d.setState("search", r.value);
    }, [
        r.value
    ]), $jbmdS.createElement((0, $bwjUk.Primitive).input, {
        ref: o,
        ...u,
        "cmdk-input": "",
        autoComplete: "off",
        autoCorrect: "off",
        spellCheck: !1,
        "aria-autocomplete": "list",
        role: "combobox",
        "aria-expanded": !0,
        "aria-controls": v.listId,
        "aria-labelledby": v.labelId,
        "aria-activedescendant": b,
        id: v.inputId,
        type: "text",
        value: c ? r.value : f,
        onChange: (l)=>{
            c || d.setState("search", l.target.value), n == null || n(l.target.value);
        }
    });
}), $bc5b00cb4375a366$export$9cffcb65e9381872 = $jbmdS.forwardRef((r, o)=>{
    let { children: n, label: u = "Suggestions", ...c } = r, d = $jbmdS.useRef(null), f = $jbmdS.useRef(null), p = $bc5b00cb4375a366$var$G();
    return $jbmdS.useEffect(()=>{
        if (f.current && d.current) {
            let v = f.current, b = d.current, l, y = new ResizeObserver(()=>{
                l = requestAnimationFrame(()=>{
                    let S = v.offsetHeight;
                    b.style.setProperty("--cmdk-list-height", S.toFixed(1) + "px");
                });
            });
            return y.observe(v), ()=>{
                cancelAnimationFrame(l), y.unobserve(v);
            };
        }
    }, []), $jbmdS.createElement((0, $bwjUk.Primitive).div, {
        ref: $bc5b00cb4375a366$var$N([
            d,
            o
        ]),
        ...c,
        "cmdk-list": "",
        role: "listbox",
        "aria-label": u,
        id: p.listId
    }, $bc5b00cb4375a366$var$F(r, (v)=>$jbmdS.createElement("div", {
            ref: $bc5b00cb4375a366$var$N([
                f,
                p.listInnerRef
            ]),
            "cmdk-list-sizer": ""
        }, v)));
}), $bc5b00cb4375a366$export$98f0540b5c04f3e8 = $jbmdS.forwardRef((r, o)=>{
    let { open: n, onOpenChange: u, overlayClassName: c, contentClassName: d, container: f, ...p } = r;
    return $jbmdS.createElement($ixm3B.Root, {
        open: n,
        onOpenChange: u
    }, $jbmdS.createElement($ixm3B.Portal, {
        container: f
    }, $jbmdS.createElement($ixm3B.Overlay, {
        "cmdk-overlay": "",
        className: c
    }), $jbmdS.createElement($ixm3B.Content, {
        "aria-label": r.label,
        "cmdk-dialog": "",
        className: d
    }, $jbmdS.createElement($bc5b00cb4375a366$export$6def88b96ee4affb, {
        ref: o,
        ...p
    }))));
}), $bc5b00cb4375a366$export$f1753c65029fce09 = $jbmdS.forwardRef((r, o)=>$bc5b00cb4375a366$export$606184d999862dff((u)=>u.filtered.count === 0) ? $jbmdS.createElement((0, $bwjUk.Primitive).div, {
        ref: o,
        ...r,
        "cmdk-empty": "",
        role: "presentation"
    }) : null), $bc5b00cb4375a366$export$8980984ffcab084a = $jbmdS.forwardRef((r, o)=>{
    let { progress: n, children: u, label: c = "Loading...", ...d } = r;
    return $jbmdS.createElement((0, $bwjUk.Primitive).div, {
        ref: o,
        ...d,
        "cmdk-loading": "",
        role: "progressbar",
        "aria-valuenow": n,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-label": c
    }, $bc5b00cb4375a366$var$F(r, (f)=>$jbmdS.createElement("div", {
            "aria-hidden": !0
        }, f)));
}), $bc5b00cb4375a366$export$cc7e12c76513e857 = Object.assign($bc5b00cb4375a366$export$6def88b96ee4affb, {
    List: $bc5b00cb4375a366$export$9cffcb65e9381872,
    Item: $bc5b00cb4375a366$export$b9b346a733d36f61,
    Input: $bc5b00cb4375a366$export$ebdebb88e46df62a,
    Group: $bc5b00cb4375a366$export$c157b9873a7a0fbd,
    Separator: $bc5b00cb4375a366$export$ace649eed6990b42,
    Dialog: $bc5b00cb4375a366$export$98f0540b5c04f3e8,
    Empty: $bc5b00cb4375a366$export$f1753c65029fce09,
    Loading: $bc5b00cb4375a366$export$8980984ffcab084a
});
function $bc5b00cb4375a366$var$we(r, o) {
    let n = r.nextElementSibling;
    for(; n;){
        if (n.matches(o)) return n;
        n = n.nextElementSibling;
    }
}
function $bc5b00cb4375a366$var$Ie(r, o) {
    let n = r.previousElementSibling;
    for(; n;){
        if (n.matches(o)) return n;
        n = n.previousElementSibling;
    }
}
function $bc5b00cb4375a366$var$pe(r) {
    let o = $jbmdS.useRef(r);
    return $bc5b00cb4375a366$var$T(()=>{
        o.current = r;
    }), o;
}
var $bc5b00cb4375a366$var$T = typeof window == "undefined" ? $jbmdS.useEffect : $jbmdS.useLayoutEffect;
function $bc5b00cb4375a366$var$k(r) {
    let o = $jbmdS.useRef();
    return o.current === void 0 && (o.current = r()), o;
}
function $bc5b00cb4375a366$var$N(r) {
    return (o)=>{
        r.forEach((n)=>{
            typeof n == "function" ? n(o) : n != null && (n.current = o);
        });
    };
}
function $bc5b00cb4375a366$export$606184d999862dff(r) {
    let o = $bc5b00cb4375a366$var$Z(), n = ()=>r(o.snapshot());
    return $jbmdS.useSyncExternalStore(o.subscribe, n, n);
}
function $bc5b00cb4375a366$var$ve(r, o, n, u = []) {
    let c = $jbmdS.useRef(), d = $bc5b00cb4375a366$var$G();
    return $bc5b00cb4375a366$var$T(()=>{
        var v;
        let f = (()=>{
            var b;
            for (let l of n){
                if (typeof l == "string") return l.trim();
                if (typeof l == "object" && "current" in l) return l.current ? (b = l.current.textContent) == null ? void 0 : b.trim() : c.current;
            }
        })(), p = u.map((b)=>b.trim());
        d.value(r, f, p), (v = o.current) == null || v.setAttribute($bc5b00cb4375a366$var$M, f), c.current = f;
    }), c;
}
var $bc5b00cb4375a366$var$Me = ()=>{
    let [r, o] = $jbmdS.useState(), n = $bc5b00cb4375a366$var$k(()=>new Map);
    return $bc5b00cb4375a366$var$T(()=>{
        n.current.forEach((u)=>u()), n.current = new Map;
    }, [
        r
    ]), (u, c)=>{
        n.current.set(u, c), o({});
    };
};
function $bc5b00cb4375a366$var$Te(r) {
    let o = r.type;
    return typeof o == "function" ? o(r.props) : "render" in o ? o.render(r.props) : r;
}
function $bc5b00cb4375a366$var$F({ asChild: r, children: o }, n) {
    return r && $jbmdS.isValidElement(o) ? $jbmdS.cloneElement($bc5b00cb4375a366$var$Te(o), {
        ref: o.ref
    }, n(o.props.children)) : n(o);
}
var $bc5b00cb4375a366$var$De = {
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: "0",
    margin: "-1px",
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    borderWidth: "0"
};

});
parcelRegister("9iKiw", function(module, exports) {

$parcel$export(module.exports, "a", function () { return $387f95fe12fc57cc$export$407448d2b89b1813; });
var $387f95fe12fc57cc$var$U = 1, $387f95fe12fc57cc$var$Y = .9, $387f95fe12fc57cc$var$H = .8, $387f95fe12fc57cc$var$J = .17, $387f95fe12fc57cc$var$p = .1, $387f95fe12fc57cc$var$u = .999, $387f95fe12fc57cc$var$$ = .9999;
var $387f95fe12fc57cc$var$k = .99, $387f95fe12fc57cc$var$m = /[\\\/_+.#"@\[\(\{&]/, $387f95fe12fc57cc$var$B = /[\\\/_+.#"@\[\(\{&]/g, $387f95fe12fc57cc$var$K = /[\s-]/, $387f95fe12fc57cc$var$X = /[\s-]/g;
function $387f95fe12fc57cc$var$G(_, C, h, P, A, f, O) {
    if (f === C.length) return A === _.length ? $387f95fe12fc57cc$var$U : $387f95fe12fc57cc$var$k;
    var T = `${A},${f}`;
    if (O[T] !== void 0) return O[T];
    for(var L = P.charAt(f), c = h.indexOf(L, A), S = 0, E, N, R, M; c >= 0;)E = $387f95fe12fc57cc$var$G(_, C, h, P, c + 1, f + 1, O), E > S && (c === A ? E *= $387f95fe12fc57cc$var$U : $387f95fe12fc57cc$var$m.test(_.charAt(c - 1)) ? (E *= $387f95fe12fc57cc$var$H, R = _.slice(A, c - 1).match($387f95fe12fc57cc$var$B), R && A > 0 && (E *= Math.pow($387f95fe12fc57cc$var$u, R.length))) : $387f95fe12fc57cc$var$K.test(_.charAt(c - 1)) ? (E *= $387f95fe12fc57cc$var$Y, M = _.slice(A, c - 1).match($387f95fe12fc57cc$var$X), M && A > 0 && (E *= Math.pow($387f95fe12fc57cc$var$u, M.length))) : (E *= $387f95fe12fc57cc$var$J, A > 0 && (E *= Math.pow($387f95fe12fc57cc$var$u, c - A))), _.charAt(c) !== C.charAt(f) && (E *= $387f95fe12fc57cc$var$$)), (E < $387f95fe12fc57cc$var$p && h.charAt(c - 1) === P.charAt(f + 1) || P.charAt(f + 1) === P.charAt(f) && h.charAt(c - 1) !== P.charAt(f)) && (N = $387f95fe12fc57cc$var$G(_, C, h, P, c + 1, f + 2, O), N * $387f95fe12fc57cc$var$p > E && (E = N * $387f95fe12fc57cc$var$p)), E > S && (S = E), c = h.indexOf(L, c + 1);
    return O[T] = S, S;
}
function $387f95fe12fc57cc$var$D(_) {
    return _.toLowerCase().replace($387f95fe12fc57cc$var$X, " ");
}
function $387f95fe12fc57cc$export$407448d2b89b1813(_, C, h) {
    return _ = h && h.length > 0 ? `${_ + " " + h.join(" ")}` : _, $387f95fe12fc57cc$var$G(_, C, $387f95fe12fc57cc$var$D(_), $387f95fe12fc57cc$var$D(C), 0, 0, {});
}

});

parcelRegister("ixm3B", function(module, exports) {

$parcel$export(module.exports, "Root", function () { return $3a2a87d05713be38$export$be92b6f5f03c0fe9; });
$parcel$export(module.exports, "Portal", function () { return $3a2a87d05713be38$export$602eac185826482c; });
$parcel$export(module.exports, "Overlay", function () { return $3a2a87d05713be38$export$c6fdb837b070b4ff; });
$parcel$export(module.exports, "Content", function () { return $3a2a87d05713be38$export$7c6e2c02157bb7d2; });

var $7i29i = parcelRequire("7i29i");

var $jbmdS = parcelRequire("jbmdS");

var $2sqGm = parcelRequire("2sqGm");

var $gqYbm = parcelRequire("gqYbm");

var $x85pc = parcelRequire("x85pc");

var $5HOdO = parcelRequire("5HOdO");

var $codSs = parcelRequire("codSs");

var $3aldz = parcelRequire("3aldz");

var $cHqKY = parcelRequire("cHqKY");

var $j8lTd = parcelRequire("j8lTd");

var $caDPP = parcelRequire("caDPP");

var $bwjUk = parcelRequire("bwjUk");

var $8n0mq = parcelRequire("8n0mq");

var $iXs0o = parcelRequire("iXs0o");

var $9Y02g = parcelRequire("9Y02g");

var $i1DYX = parcelRequire("i1DYX");
/* -------------------------------------------------------------------------------------------------
 * Dialog
 * -----------------------------------------------------------------------------------------------*/ const $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME = "Dialog";
const [$3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$createDialogContext, $3a2a87d05713be38$export$cc702773b8ea3e41] = (0, $x85pc.createContextScope)($3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME);
const [$3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$DialogProvider, $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$useDialogContext] = $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$createDialogContext($3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME);
const $3a2a87d05713be38$export$3ddf2d174ce01153 = (props)=>{
    const { __scopeDialog: __scopeDialog, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = true } = props;
    const triggerRef = (0, $jbmdS.useRef)(null);
    const contentRef = (0, $jbmdS.useRef)(null);
    const [open = false, setOpen] = (0, $codSs.useControllableState)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0, $jbmdS.createElement)($3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$DialogProvider, {
        scope: __scopeDialog,
        triggerRef: triggerRef,
        contentRef: contentRef,
        contentId: (0, $5HOdO.useId)(),
        titleId: (0, $5HOdO.useId)(),
        descriptionId: (0, $5HOdO.useId)(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: (0, $jbmdS.useCallback)(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal: modal
    }, children);
};
/*#__PURE__*/ Object.assign($3a2a87d05713be38$export$3ddf2d174ce01153, {
    displayName: $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogTrigger
 * -----------------------------------------------------------------------------------------------*/ const $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$TRIGGER_NAME = "DialogTrigger";
const $3a2a87d05713be38$export$2e1e1122cf0cba88 = /*#__PURE__*/ (0, $jbmdS.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...triggerProps } = props;
    const context = $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$useDialogContext($3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$TRIGGER_NAME, __scopeDialog);
    const composedTriggerRef = (0, $gqYbm.useComposedRefs)(forwardedRef, context.triggerRef);
    return /*#__PURE__*/ (0, $jbmdS.createElement)((0, $bwjUk.Primitive).button, (0, $7i29i.default)({
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$getState(context.open)
    }, triggerProps, {
        ref: composedTriggerRef,
        onClick: (0, $2sqGm.composeEventHandlers)(props.onClick, context.onOpenToggle)
    }));
});
/*#__PURE__*/ Object.assign($3a2a87d05713be38$export$2e1e1122cf0cba88, {
    displayName: $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogPortal
 * -----------------------------------------------------------------------------------------------*/ const $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME = "DialogPortal";
const [$3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$PortalProvider, $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$usePortalContext] = $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$createDialogContext($3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME, {
    forceMount: undefined
});
const $3a2a87d05713be38$export$dad7c95542bacce0 = (props)=>{
    const { __scopeDialog: __scopeDialog, forceMount: forceMount, children: children, container: container } = props;
    const context = $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$useDialogContext($3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $jbmdS.createElement)($3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$PortalProvider, {
        scope: __scopeDialog,
        forceMount: forceMount
    }, (0, $jbmdS.Children).map(children, (child)=>/*#__PURE__*/ (0, $jbmdS.createElement)((0, $caDPP.Presence), {
            present: forceMount || context.open
        }, /*#__PURE__*/ (0, $jbmdS.createElement)((0, $j8lTd.Portal), {
            asChild: true,
            container: container
        }, child))));
};
/*#__PURE__*/ Object.assign($3a2a87d05713be38$export$dad7c95542bacce0, {
    displayName: $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogOverlay
 * -----------------------------------------------------------------------------------------------*/ const $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME = "DialogOverlay";
const $3a2a87d05713be38$export$bd1d06c79be19e17 = /*#__PURE__*/ (0, $jbmdS.forwardRef)((props, forwardedRef)=>{
    const portalContext = $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$usePortalContext($3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...overlayProps } = props;
    const context = $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$useDialogContext($3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME, props.__scopeDialog);
    return context.modal ? /*#__PURE__*/ (0, $jbmdS.createElement)((0, $caDPP.Presence), {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0, $jbmdS.createElement)($3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$DialogOverlayImpl, (0, $7i29i.default)({}, overlayProps, {
        ref: forwardedRef
    }))) : null;
});
/*#__PURE__*/ Object.assign($3a2a87d05713be38$export$bd1d06c79be19e17, {
    displayName: $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME
});
const $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$DialogOverlayImpl = /*#__PURE__*/ (0, $jbmdS.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...overlayProps } = props;
    const context = $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$useDialogContext($3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME, __scopeDialog);
    return(/*#__PURE__*/ // ie. when `Overlay` and `Content` are siblings
    (0, $jbmdS.createElement)((0, $iXs0o.default), {
        as: (0, $i1DYX.Slot),
        allowPinchZoom: true,
        shards: [
            context.contentRef
        ]
    }, /*#__PURE__*/ (0, $jbmdS.createElement)((0, $bwjUk.Primitive).div, (0, $7i29i.default)({
        "data-state": $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$getState(context.open)
    }, overlayProps, {
        ref: forwardedRef // We re-enable pointer-events prevented by `Dialog.Content` to allow scrolling the overlay.
        ,
        style: {
            pointerEvents: "auto",
            ...overlayProps.style
        }
    }))));
});
/* -------------------------------------------------------------------------------------------------
 * DialogContent
 * -----------------------------------------------------------------------------------------------*/ const $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME = "DialogContent";
const $3a2a87d05713be38$export$b6d9565de1e068cf = /*#__PURE__*/ (0, $jbmdS.forwardRef)((props, forwardedRef)=>{
    const portalContext = $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$usePortalContext($3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$useDialogContext($3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    return /*#__PURE__*/ (0, $jbmdS.createElement)((0, $caDPP.Presence), {
        present: forceMount || context.open
    }, context.modal ? /*#__PURE__*/ (0, $jbmdS.createElement)($3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$DialogContentModal, (0, $7i29i.default)({}, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ (0, $jbmdS.createElement)($3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$DialogContentNonModal, (0, $7i29i.default)({}, contentProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($3a2a87d05713be38$export$b6d9565de1e068cf, {
    displayName: $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$DialogContentModal = /*#__PURE__*/ (0, $jbmdS.forwardRef)((props, forwardedRef)=>{
    const context = $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$useDialogContext($3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const contentRef = (0, $jbmdS.useRef)(null);
    const composedRefs = (0, $gqYbm.useComposedRefs)(forwardedRef, context.contentRef, contentRef); // aria-hide everything except the content (better supported equivalent to setting aria-modal)
    (0, $jbmdS.useEffect)(()=>{
        const content = contentRef.current;
        if (content) return (0, $9Y02g.hideOthers)(content);
    }, []);
    return /*#__PURE__*/ (0, $jbmdS.createElement)($3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$DialogContentImpl, (0, $7i29i.default)({}, props, {
        ref: composedRefs // we make sure focus isn't trapped once `DialogContent` has been closed
        ,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: (0, $2sqGm.composeEventHandlers)(props.onCloseAutoFocus, (event)=>{
            var _context$triggerRef$c;
            event.preventDefault();
            (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
        }),
        onPointerDownOutside: (0, $2sqGm.composeEventHandlers)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick; // If the event is a right-click, we shouldn't close because
            // it is effectively as if we right-clicked the `Overlay`.
            if (isRightClick) event.preventDefault();
        }) // When focus is trapped, a `focusout` event may still happen.
        ,
        onFocusOutside: (0, $2sqGm.composeEventHandlers)(props.onFocusOutside, (event)=>event.preventDefault())
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$DialogContentNonModal = /*#__PURE__*/ (0, $jbmdS.forwardRef)((props, forwardedRef)=>{
    const context = $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$useDialogContext($3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const hasInteractedOutsideRef = (0, $jbmdS.useRef)(false);
    const hasPointerDownOutsideRef = (0, $jbmdS.useRef)(false);
    return /*#__PURE__*/ (0, $jbmdS.createElement)($3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$DialogContentImpl, (0, $7i29i.default)({}, props, {
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            var _props$onCloseAutoFoc;
            (_props$onCloseAutoFoc = props.onCloseAutoFocus) === null || _props$onCloseAutoFoc === void 0 || _props$onCloseAutoFoc.call(props, event);
            if (!event.defaultPrevented) {
                var _context$triggerRef$c2;
                if (!hasInteractedOutsideRef.current) (_context$triggerRef$c2 = context.triggerRef.current) === null || _context$triggerRef$c2 === void 0 || _context$triggerRef$c2.focus(); // Always prevent auto focus because we either focus manually or want user agent focus
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            var _props$onInteractOuts, _context$triggerRef$c3;
            (_props$onInteractOuts = props.onInteractOutside) === null || _props$onInteractOuts === void 0 || _props$onInteractOuts.call(props, event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            } // Prevent dismissing when clicking the trigger.
            // As the trigger is already setup to close, without doing so would
            // cause it to close and immediately open.
            const target = event.target;
            const targetIsTrigger = (_context$triggerRef$c3 = context.triggerRef.current) === null || _context$triggerRef$c3 === void 0 ? void 0 : _context$triggerRef$c3.contains(target);
            if (targetIsTrigger) event.preventDefault(); // On Safari if the trigger is inside a container with tabIndex={0}, when clicked
            // we will get the pointer down outside event on the trigger, but then a subsequent
            // focus outside event on the container, we ignore any focus outside event when we've
            // already had a pointer down outside event.
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$DialogContentImpl = /*#__PURE__*/ (0, $jbmdS.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, ...contentProps } = props;
    const context = $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$useDialogContext($3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, __scopeDialog);
    const contentRef = (0, $jbmdS.useRef)(null);
    const composedRefs = (0, $gqYbm.useComposedRefs)(forwardedRef, contentRef); // Make sure the whole tree has focus guards as our `Dialog` will be
    // the last element in the DOM (beacuse of the `Portal`)
    (0, $8n0mq.useFocusGuards)();
    return /*#__PURE__*/ (0, $jbmdS.createElement)((0, $jbmdS.Fragment), null, /*#__PURE__*/ (0, $jbmdS.createElement)((0, $cHqKY.FocusScope), {
        asChild: true,
        loop: true,
        trapped: trapFocus,
        onMountAutoFocus: onOpenAutoFocus,
        onUnmountAutoFocus: onCloseAutoFocus
    }, /*#__PURE__*/ (0, $jbmdS.createElement)((0, $3aldz.DismissableLayer), (0, $7i29i.default)({
        role: "dialog",
        id: context.contentId,
        "aria-describedby": context.descriptionId,
        "aria-labelledby": context.titleId,
        "data-state": $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$getState(context.open)
    }, contentProps, {
        ref: composedRefs,
        onDismiss: ()=>context.onOpenChange(false)
    }))), false);
});
/* -------------------------------------------------------------------------------------------------
 * DialogTitle
 * -----------------------------------------------------------------------------------------------*/ const $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$TITLE_NAME = "DialogTitle";
const $3a2a87d05713be38$export$16f7638e4a34b909 = /*#__PURE__*/ (0, $jbmdS.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...titleProps } = props;
    const context = $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$useDialogContext($3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$TITLE_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $jbmdS.createElement)((0, $bwjUk.Primitive).h2, (0, $7i29i.default)({
        id: context.titleId
    }, titleProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($3a2a87d05713be38$export$16f7638e4a34b909, {
    displayName: $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$TITLE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogDescription
 * -----------------------------------------------------------------------------------------------*/ const $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_NAME = "DialogDescription";
const $3a2a87d05713be38$export$94e94c2ec2c954d5 = /*#__PURE__*/ (0, $jbmdS.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...descriptionProps } = props;
    const context = $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$useDialogContext($3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $jbmdS.createElement)((0, $bwjUk.Primitive).p, (0, $7i29i.default)({
        id: context.descriptionId
    }, descriptionProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($3a2a87d05713be38$export$94e94c2ec2c954d5, {
    displayName: $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogClose
 * -----------------------------------------------------------------------------------------------*/ const $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$CLOSE_NAME = "DialogClose";
const $3a2a87d05713be38$export$fba2fb7cd781b7ac = /*#__PURE__*/ (0, $jbmdS.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...closeProps } = props;
    const context = $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$useDialogContext($3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$CLOSE_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $jbmdS.createElement)((0, $bwjUk.Primitive).button, (0, $7i29i.default)({
        type: "button"
    }, closeProps, {
        ref: forwardedRef,
        onClick: (0, $2sqGm.composeEventHandlers)(props.onClick, ()=>context.onOpenChange(false))
    }));
});
/*#__PURE__*/ Object.assign($3a2a87d05713be38$export$fba2fb7cd781b7ac, {
    displayName: $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$CLOSE_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$getState(open) {
    return open ? "open" : "closed";
}
const $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME = "DialogTitleWarning";
const [$3a2a87d05713be38$export$69b62a49393917d6, $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$useWarningContext] = (0, $x85pc.createContext)($3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME, {
    contentName: $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME,
    titleName: $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$TITLE_NAME,
    docsSlug: "dialog"
});
const $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$TitleWarning = ({ titleId: titleId })=>{
    const titleWarningContext = $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$useWarningContext($3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME);
    const MESSAGE = `\`${titleWarningContext.contentName}\` requires a \`${titleWarningContext.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${titleWarningContext.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${titleWarningContext.docsSlug}`;
    (0, $jbmdS.useEffect)(()=>{
        if (titleId) {
            const hasTitle = document.getElementById(titleId);
            if (!hasTitle) throw new Error(MESSAGE);
        }
    }, [
        MESSAGE,
        titleId
    ]);
    return null;
};
const $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_WARNING_NAME = "DialogDescriptionWarning";
const $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$DescriptionWarning = ({ contentRef: contentRef, descriptionId: descriptionId })=>{
    const descriptionWarningContext = $3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$useWarningContext($3a2a87d05713be38$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_WARNING_NAME);
    const MESSAGE = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${descriptionWarningContext.contentName}}.`;
    (0, $jbmdS.useEffect)(()=>{
        var _contentRef$current;
        const describedById = (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.getAttribute("aria-describedby"); // if we have an id and the user hasn't set aria-describedby={undefined}
        if (descriptionId && describedById) {
            const hasDescription = document.getElementById(descriptionId);
            if (!hasDescription) console.warn(MESSAGE);
        }
    }, [
        MESSAGE,
        contentRef,
        descriptionId
    ]);
    return null;
};
const $3a2a87d05713be38$export$be92b6f5f03c0fe9 = $3a2a87d05713be38$export$3ddf2d174ce01153;
const $3a2a87d05713be38$export$41fb9f06171c75f4 = $3a2a87d05713be38$export$2e1e1122cf0cba88;
const $3a2a87d05713be38$export$602eac185826482c = $3a2a87d05713be38$export$dad7c95542bacce0;
const $3a2a87d05713be38$export$c6fdb837b070b4ff = $3a2a87d05713be38$export$bd1d06c79be19e17;
const $3a2a87d05713be38$export$7c6e2c02157bb7d2 = $3a2a87d05713be38$export$b6d9565de1e068cf;
const $3a2a87d05713be38$export$f99233281efd08a0 = $3a2a87d05713be38$export$16f7638e4a34b909;
const $3a2a87d05713be38$export$393edc798c47379d = $3a2a87d05713be38$export$94e94c2ec2c954d5;
const $3a2a87d05713be38$export$f39c2d165cd861fe = $3a2a87d05713be38$export$fba2fb7cd781b7ac;

});
parcelRegister("2sqGm", function(module, exports) {

$parcel$export(module.exports, "composeEventHandlers", function () { return $0eaa446fe5546ce8$export$b9ecd428b558ff10; });
function $0eaa446fe5546ce8$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}

});

parcelRegister("gqYbm", function(module, exports) {

$parcel$export(module.exports, "composeRefs", function () { return $2c5895a0bfae0119$export$43e446d32b3d21af; });
$parcel$export(module.exports, "useComposedRefs", function () { return $2c5895a0bfae0119$export$c7b2cbe3552a0d05; });

var $jbmdS = parcelRequire("jbmdS");
/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $2c5895a0bfae0119$var$$6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $2c5895a0bfae0119$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$2c5895a0bfae0119$var$$6ed0406888f73fc4$var$setRef(ref, node));
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $2c5895a0bfae0119$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $jbmdS.useCallback)($2c5895a0bfae0119$export$43e446d32b3d21af(...refs), refs);
}

});

parcelRegister("x85pc", function(module, exports) {

$parcel$export(module.exports, "createContext", function () { return $4fe001843c14b8b2$export$fd42f52fd3ae1109; });
$parcel$export(module.exports, "createContextScope", function () { return $4fe001843c14b8b2$export$50c7b4e9d9f19c1; });

var $jbmdS = parcelRequire("jbmdS");
function $4fe001843c14b8b2$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = /*#__PURE__*/ (0, $jbmdS.createContext)(defaultContext);
    function Provider(props) {
        const { children: children, ...context } = props; // Only re-memoize when prop values change
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const value = (0, $jbmdS.useMemo)(()=>context, Object.values(context));
        return /*#__PURE__*/ (0, $jbmdS.createElement)(Context.Provider, {
            value: value
        }, children);
    }
    function useContext(consumerName) {
        const context = (0, $jbmdS.useContext)(Context);
        if (context) return context;
        if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext
    ];
}
/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/ function $4fe001843c14b8b2$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    /* -----------------------------------------------------------------------------------------------
   * createContext
   * ---------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        const BaseContext = /*#__PURE__*/ (0, $jbmdS.createContext)(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope, children: children, ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const value = (0, $jbmdS.useMemo)(()=>context, Object.values(context));
            return /*#__PURE__*/ (0, $jbmdS.createElement)(Context.Provider, {
                value: value
            }, children);
        }
        function useContext(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = (0, $jbmdS.useContext)(Context);
            if (context) return context;
            if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext
        ];
    }
    /* -----------------------------------------------------------------------------------------------
   * createScope
   * ---------------------------------------------------------------------------------------------*/ const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return /*#__PURE__*/ (0, $jbmdS.createContext)(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return (0, $jbmdS.useMemo)(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        $4fe001843c14b8b2$var$$c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/ function $4fe001843c14b8b2$var$$c512c27ab02ef895$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope1 = ()=>{
        const scopeHooks = scopes.map((createScope)=>({
                useScope: createScope(),
                scopeName: createScope.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope: useScope, scopeName: scopeName })=>{
                // We are calling a hook inside a callback which React warns against to avoid inconsistent
                // renders, however, scoping doesn't have render side effects so we ignore the rule.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes,
                    ...currentScope
                };
            }, {});
            return (0, $jbmdS.useMemo)(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes1
                }), [
                nextScopes1
            ]);
        };
    };
    createScope1.scopeName = baseScope.scopeName;
    return createScope1;
}

});

parcelRegister("5HOdO", function(module, exports) {

$parcel$export(module.exports, "useId", function () { return $94f05f965142621d$export$f680877a34711e37; });

var $jbmdS = parcelRequire("jbmdS");

var $6wQzl = parcelRequire("6wQzl");
const $94f05f965142621d$var$$1746a345f3d73bb7$var$useReactId = $jbmdS["useId".toString()] || (()=>undefined);
let $94f05f965142621d$var$$1746a345f3d73bb7$var$count = 0;
function $94f05f965142621d$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $jbmdS.useState($94f05f965142621d$var$$1746a345f3d73bb7$var$useReactId()); // React versions older than 18 will have client-side ids only.
    (0, $6wQzl.useLayoutEffect)(()=>{
        if (!deterministicId) setId((reactId)=>reactId !== null && reactId !== void 0 ? reactId : String($94f05f965142621d$var$$1746a345f3d73bb7$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}

});
parcelRegister("6wQzl", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", function () { return $ca0f4c6409418bd4$export$e5c5a5f917a5871c; });

var $jbmdS = parcelRequire("jbmdS");
/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ const $ca0f4c6409418bd4$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? (0, $jbmdS.useLayoutEffect) : ()=>{};

});


parcelRegister("codSs", function(module, exports) {

$parcel$export(module.exports, "useControllableState", function () { return $efe021584056a776$export$6f32135080cb4c3; });

var $jbmdS = parcelRequire("jbmdS");

var $hPMQ8 = parcelRequire("hPMQ8");
function $efe021584056a776$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{} }) {
    const [uncontrolledProp, setUncontrolledProp] = $efe021584056a776$var$$71cd76cc60e0454e$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== undefined;
    const value1 = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $hPMQ8.useCallbackRef)(onChange);
    const setValue = (0, $jbmdS.useCallback)((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value !== prop) handleChange(value);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value1,
        setValue
    ];
}
function $efe021584056a776$var$$71cd76cc60e0454e$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const uncontrolledState = (0, $jbmdS.useState)(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = (0, $jbmdS.useRef)(value);
    const handleChange = (0, $hPMQ8.useCallbackRef)(onChange);
    (0, $jbmdS.useEffect)(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}

});
parcelRegister("hPMQ8", function(module, exports) {

$parcel$export(module.exports, "useCallbackRef", function () { return $b6d64206270509af$export$25bec8c6f54ee79a; });

var $jbmdS = parcelRequire("jbmdS");
/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */ function $b6d64206270509af$export$25bec8c6f54ee79a(callback) {
    const callbackRef = (0, $jbmdS.useRef)(callback);
    (0, $jbmdS.useEffect)(()=>{
        callbackRef.current = callback;
    }); // https://github.com/facebook/react/issues/19240
    return (0, $jbmdS.useMemo)(()=>(...args)=>{
            var _callbackRef$current;
            return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
        }, []);
}

});


parcelRegister("3aldz", function(module, exports) {

$parcel$export(module.exports, "DismissableLayer", function () { return $063a34396f86598f$export$177fb62ff3ec1f22; });

var $7i29i = parcelRequire("7i29i");

var $jbmdS = parcelRequire("jbmdS");

var $2sqGm = parcelRequire("2sqGm");

var $bwjUk = parcelRequire("bwjUk");

var $gqYbm = parcelRequire("gqYbm");

var $hPMQ8 = parcelRequire("hPMQ8");

var $bjOtX = parcelRequire("bjOtX");
/* -------------------------------------------------------------------------------------------------
 * DismissableLayer
 * -----------------------------------------------------------------------------------------------*/ const $063a34396f86598f$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
const $063a34396f86598f$var$$5cb92bef7577960e$var$CONTEXT_UPDATE = "dismissableLayer.update";
const $063a34396f86598f$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
const $063a34396f86598f$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
let $063a34396f86598f$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
const $063a34396f86598f$var$$5cb92bef7577960e$var$DismissableLayerContext = /*#__PURE__*/ (0, $jbmdS.createContext)({
    layers: new Set(),
    layersWithOutsidePointerEventsDisabled: new Set(),
    branches: new Set()
});
const $063a34396f86598f$export$177fb62ff3ec1f22 = /*#__PURE__*/ (0, $jbmdS.forwardRef)((props, forwardedRef)=>{
    var _node$ownerDocument;
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, ...layerProps } = props;
    const context = (0, $jbmdS.useContext)($063a34396f86598f$var$$5cb92bef7577960e$var$DismissableLayerContext);
    const [node1, setNode] = (0, $jbmdS.useState)(null);
    const ownerDocument = (_node$ownerDocument = node1 === null || node1 === void 0 ? void 0 : node1.ownerDocument) !== null && _node$ownerDocument !== void 0 ? _node$ownerDocument : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
    const [, force] = (0, $jbmdS.useState)({});
    const composedRefs = (0, $gqYbm.useComposedRefs)(forwardedRef, (node)=>setNode(node));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1); // prettier-ignore
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled); // prettier-ignore
    const index = node1 ? layers.indexOf(node1) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $063a34396f86598f$var$$5cb92bef7577960e$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside === null || onPointerDownOutside === void 0 || onPointerDownOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    const focusOutside = $063a34396f86598f$var$$5cb92bef7577960e$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside === null || onFocusOutside === void 0 || onFocusOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    (0, $bjOtX.useEscapeKeydown)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    (0, $jbmdS.useEffect)(()=>{
        if (!node1) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $063a34396f86598f$var$$5cb92bef7577960e$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node1);
        }
        context.layers.add(node1);
        $063a34396f86598f$var$$5cb92bef7577960e$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $063a34396f86598f$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
        };
    }, [
        node1,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    /**
   * We purposefully prevent combining this effect with the `disableOutsidePointerEvents` effect
   * because a change to `disableOutsidePointerEvents` would remove this layer from the stack
   * and add it to the end again so the layering order wouldn't be _creation order_.
   * We only want them to be removed from context stacks when unmounted.
   */ (0, $jbmdS.useEffect)(()=>{
        return ()=>{
            if (!node1) return;
            context.layers.delete(node1);
            context.layersWithOutsidePointerEventsDisabled.delete(node1);
            $063a34396f86598f$var$$5cb92bef7577960e$var$dispatchUpdate();
        };
    }, [
        node1,
        context
    ]);
    (0, $jbmdS.useEffect)(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($063a34396f86598f$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($063a34396f86598f$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /*#__PURE__*/ (0, $jbmdS.createElement)((0, $bwjUk.Primitive).div, (0, $7i29i.default)({}, layerProps, {
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : undefined,
            ...props.style
        },
        onFocusCapture: (0, $2sqGm.composeEventHandlers)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $2sqGm.composeEventHandlers)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $2sqGm.composeEventHandlers)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    }));
});
/*#__PURE__*/ Object.assign($063a34396f86598f$export$177fb62ff3ec1f22, {
    displayName: $063a34396f86598f$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DismissableLayerBranch
 * -----------------------------------------------------------------------------------------------*/ const $063a34396f86598f$var$$5cb92bef7577960e$var$BRANCH_NAME = "DismissableLayerBranch";
const $063a34396f86598f$export$4d5eb2109db14228 = /*#__PURE__*/ (0, $jbmdS.forwardRef)((props, forwardedRef)=>{
    const context = (0, $jbmdS.useContext)($063a34396f86598f$var$$5cb92bef7577960e$var$DismissableLayerContext);
    const ref = (0, $jbmdS.useRef)(null);
    const composedRefs = (0, $gqYbm.useComposedRefs)(forwardedRef, ref);
    (0, $jbmdS.useEffect)(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /*#__PURE__*/ (0, $jbmdS.createElement)((0, $bwjUk.Primitive).div, (0, $7i29i.default)({}, props, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($063a34396f86598f$export$4d5eb2109db14228, {
    displayName: $063a34396f86598f$var$$5cb92bef7577960e$var$BRANCH_NAME
});
/* -----------------------------------------------------------------------------------------------*/ /**
 * Listens for `pointerdown` outside a react subtree. We use `pointerdown` rather than `pointerup`
 * to mimic layer dismissing behaviour present in OS.
 * Returns props to pass to the node we want to check for outside events.
 */ function $063a34396f86598f$var$$5cb92bef7577960e$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handlePointerDownOutside = (0, $hPMQ8.useCallbackRef)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = (0, $jbmdS.useRef)(false);
    const handleClickRef = (0, $jbmdS.useRef)(()=>{});
    (0, $jbmdS.useEffect)(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                function handleAndDispatchPointerDownOutsideEvent() {
                    $063a34396f86598f$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($063a34396f86598f$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                }
                /**
         * On touch devices, we need to wait for a click event because browsers implement
         * a ~350ms delay between the time the user stops touching the display and when the
         * browser executres events. We need to ensure we don't reactivate pointer-events within
         * this timeframe otherwise the browser may execute events that should have been prevented.
         *
         * Additionally, this also lets us deal automatically with cancellations when a click event
         * isn't raised because the page was considered scrolled/drag-scrolled, long-pressed, etc.
         *
         * This is why we also continuously remove the previous listener, because we cannot be
         * certain that it was raised, and therefore cleaned-up.
         */ if (event.pointerType === "touch") {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent();
            } else // See: https://github.com/radix-ui/primitives/issues/2171
            ownerDocument.removeEventListener("click", handleClickRef.current);
            isPointerInsideReactTreeRef.current = false;
        };
        /**
     * if this hook executes in a component that mounts via a `pointerdown` event, the event
     * would bubble up to the document and trigger a `pointerDownOutside` event. We avoid
     * this by delaying the event listener registration on the document.
     * This is not React specific, but rather how the DOM works, ie:
     * ```
     * button.addEventListener('pointerdown', () => {
     *   console.log('I will log');
     *   document.addEventListener('pointerdown', () => {
     *     console.log('I will also log');
     *   })
     * });
     */ const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
/**
 * Listens for when focus happens outside a react subtree.
 * Returns props to pass to the root (node) of the subtree we want to check.
 */ function $063a34396f86598f$var$$5cb92bef7577960e$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handleFocusOutside = (0, $hPMQ8.useCallbackRef)(onFocusOutside);
    const isFocusInsideReactTreeRef = (0, $jbmdS.useRef)(false);
    (0, $jbmdS.useEffect)(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $063a34396f86598f$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($063a34396f86598f$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $063a34396f86598f$var$$5cb92bef7577960e$var$dispatchUpdate() {
    const event = new CustomEvent($063a34396f86598f$var$$5cb92bef7577960e$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $063a34396f86598f$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $bwjUk.dispatchDiscreteCustomEvent)(target, event);
    else target.dispatchEvent(event);
}
const $063a34396f86598f$export$be92b6f5f03c0fe9 = $063a34396f86598f$export$177fb62ff3ec1f22;
const $063a34396f86598f$export$aecb2ddcb55c95be = $063a34396f86598f$export$4d5eb2109db14228;

});
parcelRegister("bwjUk", function(module, exports) {

$parcel$export(module.exports, "Primitive", function () { return $d7e8449ed6ce1b50$export$250ffa63cdc0d034; });
$parcel$export(module.exports, "dispatchDiscreteCustomEvent", function () { return $d7e8449ed6ce1b50$export$6d1a0317bde7de7f; });

var $7i29i = parcelRequire("7i29i");

var $jbmdS = parcelRequire("jbmdS");

var $jCNM0 = parcelRequire("jCNM0");

var $i1DYX = parcelRequire("i1DYX");
const $d7e8449ed6ce1b50$var$$8927f6f2acc4f386$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const $d7e8449ed6ce1b50$export$250ffa63cdc0d034 = $d7e8449ed6ce1b50$var$$8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ (0, $jbmdS.forwardRef)((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? (0, $i1DYX.Slot) : node;
        (0, $jbmdS.useEffect)(()=>{
            window[Symbol.for("radix-ui")] = true;
        }, []);
        return /*#__PURE__*/ (0, $jbmdS.createElement)(Comp, (0, $7i29i.default)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function $d7e8449ed6ce1b50$export$6d1a0317bde7de7f(target, event) {
    if (target) (0, $jCNM0.flushSync)(()=>target.dispatchEvent(event));
}
/* -----------------------------------------------------------------------------------------------*/ const $d7e8449ed6ce1b50$export$be92b6f5f03c0fe9 = $d7e8449ed6ce1b50$export$250ffa63cdc0d034;

});
parcelRegister("i1DYX", function(module, exports) {

$parcel$export(module.exports, "Slot", function () { return $2f2f9af73b7ba03e$export$8c6ed5c666ac1360; });

var $7i29i = parcelRequire("7i29i");

var $jbmdS = parcelRequire("jbmdS");

var $gqYbm = parcelRequire("gqYbm");
/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const $2f2f9af73b7ba03e$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0, $jbmdS.forwardRef)((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    const childrenArray = (0, $jbmdS.Children).toArray(children);
    const slottable = childrenArray.find($2f2f9af73b7ba03e$var$$5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if ((0, $jbmdS.Children).count(newElement) > 1) return (0, $jbmdS.Children).only(null);
                return /*#__PURE__*/ (0, $jbmdS.isValidElement)(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ (0, $jbmdS.createElement)($2f2f9af73b7ba03e$var$$5e63c961fc1ce211$var$SlotClone, (0, $7i29i.default)({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ (0, $jbmdS.isValidElement)(newElement) ? /*#__PURE__*/ (0, $jbmdS.cloneElement)(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ (0, $jbmdS.createElement)($2f2f9af73b7ba03e$var$$5e63c961fc1ce211$var$SlotClone, (0, $7i29i.default)({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$2f2f9af73b7ba03e$export$8c6ed5c666ac1360.displayName = "Slot";
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const $2f2f9af73b7ba03e$var$$5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ (0, $jbmdS.forwardRef)((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    if (/*#__PURE__*/ (0, $jbmdS.isValidElement)(children)) return /*#__PURE__*/ (0, $jbmdS.cloneElement)(children, {
        ...$2f2f9af73b7ba03e$var$$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: forwardedRef ? (0, $gqYbm.composeRefs)(forwardedRef, children.ref) : children.ref
    });
    return (0, $jbmdS.Children).count(children) > 1 ? (0, $jbmdS.Children).only(null) : null;
});
$2f2f9af73b7ba03e$var$$5e63c961fc1ce211$var$SlotClone.displayName = "SlotClone";
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const $2f2f9af73b7ba03e$export$d9f1ccf0bdb05d45 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $jbmdS.createElement)((0, $jbmdS.Fragment), null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function $2f2f9af73b7ba03e$var$$5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ (0, $jbmdS.isValidElement)(child) && child.type === $2f2f9af73b7ba03e$export$d9f1ccf0bdb05d45;
}
function $2f2f9af73b7ba03e$var$$5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            // if the handler exists on both, we compose them
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
const $2f2f9af73b7ba03e$export$be92b6f5f03c0fe9 = $2f2f9af73b7ba03e$export$8c6ed5c666ac1360;

});


parcelRegister("bjOtX", function(module, exports) {

$parcel$export(module.exports, "useEscapeKeydown", function () { return $dd0700070eec6d7b$export$3a72a57244d6e765; });

var $jbmdS = parcelRequire("jbmdS");

var $hPMQ8 = parcelRequire("hPMQ8");
/**
 * Listens for when the escape key is down
 */ function $dd0700070eec6d7b$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const onEscapeKeyDown = (0, $hPMQ8.useCallbackRef)(onEscapeKeyDownProp);
    (0, $jbmdS.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener("keydown", handleKeyDown);
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown);
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}

});


parcelRegister("cHqKY", function(module, exports) {

$parcel$export(module.exports, "FocusScope", function () { return $51b99c14f254b0a4$export$20e40289641fbbb6; });

var $7i29i = parcelRequire("7i29i");

var $jbmdS = parcelRequire("jbmdS");

var $gqYbm = parcelRequire("gqYbm");

var $bwjUk = parcelRequire("bwjUk");

var $hPMQ8 = parcelRequire("hPMQ8");
const $51b99c14f254b0a4$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
const $51b99c14f254b0a4$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
const $51b99c14f254b0a4$var$$d3863c46a17e8a28$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * FocusScope
 * -----------------------------------------------------------------------------------------------*/ const $51b99c14f254b0a4$var$$d3863c46a17e8a28$var$FOCUS_SCOPE_NAME = "FocusScope";
const $51b99c14f254b0a4$export$20e40289641fbbb6 = /*#__PURE__*/ (0, $jbmdS.forwardRef)((props, forwardedRef)=>{
    const { loop: loop = false, trapped: trapped = false, onMountAutoFocus: onMountAutoFocusProp, onUnmountAutoFocus: onUnmountAutoFocusProp, ...scopeProps } = props;
    const [container1, setContainer] = (0, $jbmdS.useState)(null);
    const onMountAutoFocus = (0, $hPMQ8.useCallbackRef)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $hPMQ8.useCallbackRef)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = (0, $jbmdS.useRef)(null);
    const composedRefs = (0, $gqYbm.useComposedRefs)(forwardedRef, (node)=>setContainer(node));
    const focusScope = (0, $jbmdS.useRef)({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current; // Takes care of trapping focus if focus is moved outside programmatically for example
    (0, $jbmdS.useEffect)(()=>{
        if (trapped) {
            function handleFocusIn(event) {
                if (focusScope.paused || !container1) return;
                const target = event.target;
                if (container1.contains(target)) lastFocusedElementRef.current = target;
                else $51b99c14f254b0a4$var$$d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }
            function handleFocusOut(event) {
                if (focusScope.paused || !container1) return;
                const relatedTarget = event.relatedTarget; // A `focusout` event with a `null` `relatedTarget` will happen in at least two cases:
                //
                // 1. When the user switches app/tabs/windows/the browser itself loses focus.
                // 2. In Google Chrome, when the focused element is removed from the DOM.
                //
                // We let the browser do its thing here because:
                //
                // 1. The browser already keeps a memory of what's focused for when the page gets refocused.
                // 2. In Google Chrome, if we try to focus the deleted focused element (as per below), it
                //    throws the CPU to 100%, so we avoid doing anything for this reason here too.
                if (relatedTarget === null) return; // If the focus has moved to an actual legitimate element (`relatedTarget !== null`)
                // that is outside the container, we move focus to the last valid focused element inside.
                if (!container1.contains(relatedTarget)) $51b99c14f254b0a4$var$$d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            } // When the focused element gets removed from the DOM, browsers move focus
            // back to the document.body. In this case, we move focus to the container
            // to keep focus trapped correctly.
            function handleMutations(mutations) {
                const focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                for (const mutation of mutations)if (mutation.removedNodes.length > 0) $51b99c14f254b0a4$var$$d3863c46a17e8a28$var$focus(container1);
            }
            document.addEventListener("focusin", handleFocusIn);
            document.addEventListener("focusout", handleFocusOut);
            const mutationObserver = new MutationObserver(handleMutations);
            if (container1) mutationObserver.observe(container1, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn);
                document.removeEventListener("focusout", handleFocusOut);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container1,
        focusScope.paused
    ]);
    (0, $jbmdS.useEffect)(()=>{
        if (container1) {
            $51b99c14f254b0a4$var$$d3863c46a17e8a28$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container1.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($51b99c14f254b0a4$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, $51b99c14f254b0a4$var$$d3863c46a17e8a28$var$EVENT_OPTIONS);
                container1.addEventListener($51b99c14f254b0a4$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container1.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $51b99c14f254b0a4$var$$d3863c46a17e8a28$var$focusFirst($51b99c14f254b0a4$var$$d3863c46a17e8a28$var$removeLinks($51b99c14f254b0a4$var$$d3863c46a17e8a28$var$getTabbableCandidates(container1)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $51b99c14f254b0a4$var$$d3863c46a17e8a28$var$focus(container1);
                }
            }
            return ()=>{
                container1.removeEventListener($51b99c14f254b0a4$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus); // We hit a react bug (fixed in v17) with focusing in unmount.
                // We need to delay the focus a little to get around it for now.
                // See: https://github.com/facebook/react/issues/17894
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($51b99c14f254b0a4$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, $51b99c14f254b0a4$var$$d3863c46a17e8a28$var$EVENT_OPTIONS);
                    container1.addEventListener($51b99c14f254b0a4$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container1.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $51b99c14f254b0a4$var$$d3863c46a17e8a28$var$focus(previouslyFocusedElement !== null && previouslyFocusedElement !== void 0 ? previouslyFocusedElement : document.body, {
                        select: true
                    });
                    // we need to remove the listener after we `dispatchEvent`
                    container1.removeEventListener($51b99c14f254b0a4$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $51b99c14f254b0a4$var$$d3863c46a17e8a28$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container1,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]); // Takes care of looping focus (when tabbing whilst at the edges)
    const handleKeyDown = (0, $jbmdS.useCallback)((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container = event.currentTarget;
            const [first, last] = $51b99c14f254b0a4$var$$d3863c46a17e8a28$var$getTabbableEdges(container);
            const hasTabbableElementsInside = first && last; // we can only wrap focus if we have tabbable edges
            if (!hasTabbableElementsInside) {
                if (focusedElement === container) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $51b99c14f254b0a4$var$$d3863c46a17e8a28$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $51b99c14f254b0a4$var$$d3863c46a17e8a28$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /*#__PURE__*/ (0, $jbmdS.createElement)((0, $bwjUk.Primitive).div, (0, $7i29i.default)({
        tabIndex: -1
    }, scopeProps, {
        ref: composedRefs,
        onKeyDown: handleKeyDown
    }));
});
/*#__PURE__*/ Object.assign($51b99c14f254b0a4$export$20e40289641fbbb6, {
    displayName: $51b99c14f254b0a4$var$$d3863c46a17e8a28$var$FOCUS_SCOPE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Attempts focusing the first element in a list of candidates.
 * Stops when focus has actually moved.
 */ function $51b99c14f254b0a4$var$$d3863c46a17e8a28$var$focusFirst(candidates, { select: select = false } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $51b99c14f254b0a4$var$$d3863c46a17e8a28$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
/**
 * Returns the first and last tabbable elements inside a container.
 */ function $51b99c14f254b0a4$var$$d3863c46a17e8a28$var$getTabbableEdges(container) {
    const candidates = $51b99c14f254b0a4$var$$d3863c46a17e8a28$var$getTabbableCandidates(container);
    const first = $51b99c14f254b0a4$var$$d3863c46a17e8a28$var$findVisible(candidates, container);
    const last = $51b99c14f254b0a4$var$$d3863c46a17e8a28$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
/**
 * Returns a list of potential tabbable candidates.
 *
 * NOTE: This is only a close approximation. For example it doesn't take into account cases like when
 * elements are not visible. This cannot be worked out easily by just reading a property, but rather
 * necessitate runtime knowledge (computed styles, etc). We deal with these cases separately.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker
 * Credit: https://github.com/discord/focus-layers/blob/master/src/util/wrapFocus.tsx#L1
 */ function $51b99c14f254b0a4$var$$d3863c46a17e8a28$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP; // `.tabIndex` is not the same as the `tabindex` attribute. It works on the
            // runtime's understanding of tabbability, so this automatically accounts
            // for any kind of element that could be tabbed to.
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode); // we do not take into account the order of nodes with positive `tabIndex` as it
    // hinders accessibility to have tab order different from visual order.
    return nodes;
}
/**
 * Returns the first visible element in a list.
 * NOTE: Only checks visibility up to the `container`.
 */ function $51b99c14f254b0a4$var$$d3863c46a17e8a28$var$findVisible(elements, container) {
    for (const element of elements){
        // we stop checking if it's hidden at the `container` level (excluding)
        if (!$51b99c14f254b0a4$var$$d3863c46a17e8a28$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function $51b99c14f254b0a4$var$$d3863c46a17e8a28$var$isHidden(node, { upTo: upTo }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        // we stop at `upTo` (excluding it)
        if (upTo !== undefined && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function $51b99c14f254b0a4$var$$d3863c46a17e8a28$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function $51b99c14f254b0a4$var$$d3863c46a17e8a28$var$focus(element, { select: select = false } = {}) {
    // only focus if that element is focusable
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement; // NOTE: we prevent scrolling on focus, to minimize jarring transitions for users
        element.focus({
            preventScroll: true
        }); // only select if its not the same element, it supports selection and we need to select
        if (element !== previouslyFocusedElement && $51b99c14f254b0a4$var$$d3863c46a17e8a28$var$isSelectableInput(element) && select) element.select();
    }
}
/* -------------------------------------------------------------------------------------------------
 * FocusScope stack
 * -----------------------------------------------------------------------------------------------*/ const $51b99c14f254b0a4$var$$d3863c46a17e8a28$var$focusScopesStack = $51b99c14f254b0a4$var$$d3863c46a17e8a28$var$createFocusScopesStack();
function $51b99c14f254b0a4$var$$d3863c46a17e8a28$var$createFocusScopesStack() {
    /** A stack of focus scopes, with the active one at the top */ let stack = [];
    return {
        add (focusScope) {
            // pause the currently active focus scope (at the top of the stack)
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope === null || activeFocusScope === void 0 || activeFocusScope.pause();
            // remove in case it already exists (because we'll re-add it at the top of the stack)
            stack = $51b99c14f254b0a4$var$$d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            var _stack$;
            stack = $51b99c14f254b0a4$var$$d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            (_stack$ = stack[0]) === null || _stack$ === void 0 || _stack$.resume();
        }
    };
}
function $51b99c14f254b0a4$var$$d3863c46a17e8a28$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $51b99c14f254b0a4$var$$d3863c46a17e8a28$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
const $51b99c14f254b0a4$export$be92b6f5f03c0fe9 = $51b99c14f254b0a4$export$20e40289641fbbb6;

});

parcelRegister("j8lTd", function(module, exports) {

$parcel$export(module.exports, "Portal", function () { return $879a1234ffae0fae$export$602eac185826482c; });

var $7i29i = parcelRequire("7i29i");

var $jbmdS = parcelRequire("jbmdS");

var $jCNM0 = parcelRequire("jCNM0");

var $bwjUk = parcelRequire("bwjUk");
/* -------------------------------------------------------------------------------------------------
 * Portal
 * -----------------------------------------------------------------------------------------------*/ const $879a1234ffae0fae$var$$f1701beae083dbae$var$PORTAL_NAME = "Portal";
const $879a1234ffae0fae$export$602eac185826482c = /*#__PURE__*/ (0, $jbmdS.forwardRef)((props, forwardedRef)=>{
    var _globalThis$document;
    const { container: container = globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.body, ...portalProps } = props;
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jCNM0))).createPortal(/*#__PURE__*/ (0, $jbmdS.createElement)((0, $bwjUk.Primitive).div, (0, $7i29i.default)({}, portalProps, {
        ref: forwardedRef
    })), container) : null;
});
/*#__PURE__*/ Object.assign($879a1234ffae0fae$export$602eac185826482c, {
    displayName: $879a1234ffae0fae$var$$f1701beae083dbae$var$PORTAL_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $879a1234ffae0fae$export$be92b6f5f03c0fe9 = $879a1234ffae0fae$export$602eac185826482c;

});

parcelRegister("caDPP", function(module, exports) {

$parcel$export(module.exports, "Presence", function () { return $65d8d9f9719c51fb$export$99c2b779aa4e8b8b; });

var $jbmdS = parcelRequire("jbmdS");

var $jCNM0 = parcelRequire("jCNM0");

var $gqYbm = parcelRequire("gqYbm");

var $6wQzl = parcelRequire("6wQzl");
function $65d8d9f9719c51fb$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, machine) {
    return (0, $jbmdS.useReducer)((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}
const $65d8d9f9719c51fb$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present, children: children } = props;
    const presence = $65d8d9f9719c51fb$var$$921a889cee6df7e8$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : (0, $jbmdS.Children).only(children);
    const ref = (0, $gqYbm.useComposedRefs)(presence.ref, child.ref);
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? /*#__PURE__*/ (0, $jbmdS.cloneElement)(child, {
        ref: ref
    }) : null;
};
$65d8d9f9719c51fb$export$99c2b779aa4e8b8b.displayName = "Presence";
/* -------------------------------------------------------------------------------------------------
 * usePresence
 * -----------------------------------------------------------------------------------------------*/ function $65d8d9f9719c51fb$var$$921a889cee6df7e8$var$usePresence(present) {
    const [node1, setNode] = (0, $jbmdS.useState)();
    const stylesRef = (0, $jbmdS.useRef)({});
    const prevPresentRef = (0, $jbmdS.useRef)(present);
    const prevAnimationNameRef = (0, $jbmdS.useRef)("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $65d8d9f9719c51fb$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    (0, $jbmdS.useEffect)(()=>{
        const currentAnimationName = $65d8d9f9719c51fb$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $6wQzl.useLayoutEffect)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $65d8d9f9719c51fb$var$$921a889cee6df7e8$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || (styles === null || styles === void 0 ? void 0 : styles.display) === "none") // so we unmount instantly
            send("UNMOUNT");
            else {
                /**
         * When `present` changes to `false`, we check changes to animation-name to
         * determine whether an animation has started. We chose this approach (reading
         * computed styles) because there is no `animationrun` event and `animationstart`
         * fires after `animation-delay` has expired which would be too late.
         */ const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $6wQzl.useLayoutEffect)(()=>{
        if (node1) {
            /**
       * Triggering an ANIMATION_OUT during an ANIMATION_IN will fire an `animationcancel`
       * event for ANIMATION_IN after we have entered `unmountSuspended` state. So, we
       * make sure we only trigger ANIMATION_END for the currently active animation.
       */ const handleAnimationEnd = (event)=>{
                const currentAnimationName = $65d8d9f9719c51fb$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node1 && isCurrentAnimation) // a frame after the animation ends, creating a flash of visible content.
                // By manually flushing we ensure they sync within a frame, removing the flash.
                (0, $jCNM0.flushSync)(()=>send("ANIMATION_END"));
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node1) prevAnimationNameRef.current = $65d8d9f9719c51fb$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
            };
            node1.addEventListener("animationstart", handleAnimationStart);
            node1.addEventListener("animationcancel", handleAnimationEnd);
            node1.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                node1.removeEventListener("animationstart", handleAnimationStart);
                node1.removeEventListener("animationcancel", handleAnimationEnd);
                node1.removeEventListener("animationend", handleAnimationEnd);
            };
        } else // We avoid doing so during cleanup as the node may change but still exist.
        send("ANIMATION_END");
    }, [
        node1,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: (0, $jbmdS.useCallback)((node)=>{
            if (node) stylesRef.current = getComputedStyle(node);
            setNode(node);
        }, [])
    };
}
/* -----------------------------------------------------------------------------------------------*/ function $65d8d9f9719c51fb$var$$921a889cee6df7e8$var$getAnimationName(styles) {
    return (styles === null || styles === void 0 ? void 0 : styles.animationName) || "none";
}

});

parcelRegister("8n0mq", function(module, exports) {

$parcel$export(module.exports, "useFocusGuards", function () { return $db8e3124efa3a9cd$export$b7ece24a22aeda8c; });

var $jbmdS = parcelRequire("jbmdS");
/** Number of components which have requested interest to have focus guards */ let $db8e3124efa3a9cd$var$$3db38b7d1fb3fe6a$var$count = 0;
function $db8e3124efa3a9cd$export$ac5b58043b79449b(props) {
    $db8e3124efa3a9cd$export$b7ece24a22aeda8c();
    return props.children;
}
/**
 * Injects a pair of focus guards at the edges of the whole DOM tree
 * to ensure `focusin` & `focusout` events can be caught consistently.
 */ function $db8e3124efa3a9cd$export$b7ece24a22aeda8c() {
    (0, $jbmdS.useEffect)(()=>{
        var _edgeGuards$, _edgeGuards$2;
        const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
        document.body.insertAdjacentElement("afterbegin", (_edgeGuards$ = edgeGuards[0]) !== null && _edgeGuards$ !== void 0 ? _edgeGuards$ : $db8e3124efa3a9cd$var$$3db38b7d1fb3fe6a$var$createFocusGuard());
        document.body.insertAdjacentElement("beforeend", (_edgeGuards$2 = edgeGuards[1]) !== null && _edgeGuards$2 !== void 0 ? _edgeGuards$2 : $db8e3124efa3a9cd$var$$3db38b7d1fb3fe6a$var$createFocusGuard());
        $db8e3124efa3a9cd$var$$3db38b7d1fb3fe6a$var$count++;
        return ()=>{
            if ($db8e3124efa3a9cd$var$$3db38b7d1fb3fe6a$var$count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach((node)=>node.remove());
            $db8e3124efa3a9cd$var$$3db38b7d1fb3fe6a$var$count--;
        };
    }, []);
}
function $db8e3124efa3a9cd$var$$3db38b7d1fb3fe6a$var$createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none";
    return element;
}
const $db8e3124efa3a9cd$export$be92b6f5f03c0fe9 = $db8e3124efa3a9cd$export$ac5b58043b79449b;

});

parcelRegister("iXs0o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcd375f98ac08a06$export$2e2bcd8739ae039; });

var $53oVd = parcelRequire("53oVd");

var $jbmdS = parcelRequire("jbmdS");

var $5CA9y = parcelRequire("5CA9y");

var $4J5CS = parcelRequire("4J5CS");
var $dcd375f98ac08a06$var$ReactRemoveScroll = $jbmdS.forwardRef(function(props, ref) {
    return $jbmdS.createElement((0, $5CA9y.RemoveScroll), (0, $53oVd.__assign)({}, props, {
        ref: ref,
        sideCar: (0, $4J5CS.default)
    }));
});
$dcd375f98ac08a06$var$ReactRemoveScroll.classNames = (0, $5CA9y.RemoveScroll).classNames;
var $dcd375f98ac08a06$export$2e2bcd8739ae039 = $dcd375f98ac08a06$var$ReactRemoveScroll;

});
parcelRegister("5CA9y", function(module, exports) {

$parcel$export(module.exports, "RemoveScroll", function () { return $417c8b9e05ebbfa0$export$22940b497e769dee; });

var $53oVd = parcelRequire("53oVd");

var $jbmdS = parcelRequire("jbmdS");

var $2agjQ = parcelRequire("2agjQ");

var $d5w9m = parcelRequire("d5w9m");

var $kzVUd = parcelRequire("kzVUd");
var $417c8b9e05ebbfa0$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $417c8b9e05ebbfa0$export$22940b497e769dee = $jbmdS.forwardRef(function(props, parentRef) {
    var ref = $jbmdS.useRef(null);
    var _a = $jbmdS.useState({
        onScrollCapture: $417c8b9e05ebbfa0$var$nothing,
        onWheelCapture: $417c8b9e05ebbfa0$var$nothing,
        onTouchMoveCapture: $417c8b9e05ebbfa0$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, rest = (0, $53oVd.__rest)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $d5w9m.useMergeRefs)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $53oVd.__assign)((0, $53oVd.__assign)({}, rest), callbacks);
    return $jbmdS.createElement($jbmdS.Fragment, null, enabled && $jbmdS.createElement(SideCar, {
        sideCar: (0, $kzVUd.effectCar),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref
    }), forwardProps ? $jbmdS.cloneElement($jbmdS.Children.only(children), (0, $53oVd.__assign)((0, $53oVd.__assign)({}, containerProps), {
        ref: containerRef
    })) : $jbmdS.createElement(Container, (0, $53oVd.__assign)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$417c8b9e05ebbfa0$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$417c8b9e05ebbfa0$export$22940b497e769dee.classNames = {
    fullWidth: (0, $2agjQ.fullWidthClassName),
    zeroRight: (0, $2agjQ.zeroRightClassName)
};

});
parcelRegister("kzVUd", function(module, exports) {

$parcel$export(module.exports, "effectCar", function () { return $efb3fe62095c1206$export$e27363444bedfeac; });

var $iFDfj = parcelRequire("iFDfj");
var $efb3fe62095c1206$export$e27363444bedfeac = (0, $iFDfj.createSidecarMedium)();

});


parcelRegister("4J5CS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $370fba99e876a744$export$2e2bcd8739ae039; });

var $1AqwU = parcelRequire("1AqwU");

var $6HNLi = parcelRequire("6HNLi");

var $kzVUd = parcelRequire("kzVUd");
var $370fba99e876a744$export$2e2bcd8739ae039 = (0, $1AqwU.exportSidecar)((0, $kzVUd.effectCar), (0, $6HNLi.RemoveScrollSideCar));

});
parcelRegister("6HNLi", function(module, exports) {

$parcel$export(module.exports, "RemoveScrollSideCar", function () { return $4e1d5be9136c4465$export$a09dbff87b5da2d; });

var $53oVd = parcelRequire("53oVd");

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("geJTE");
var $h5klF = parcelRequire("h5klF");
parcelRequire("5yDIS");
var $i5wAQ = parcelRequire("i5wAQ");

var $dbaLa = parcelRequire("dbaLa");

var $7aPzl = parcelRequire("7aPzl");
var $4e1d5be9136c4465$export$6e085704a79f4f56 = function(event) {
    return "changedTouches" in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $4e1d5be9136c4465$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $4e1d5be9136c4465$var$extractRef = function(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $4e1d5be9136c4465$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $4e1d5be9136c4465$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $4e1d5be9136c4465$var$idCounter = 0;
var $4e1d5be9136c4465$var$lockStack = [];
function $4e1d5be9136c4465$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $jbmdS.useRef([]);
    var touchStartRef = $jbmdS.useRef([
        0,
        0
    ]);
    var activeAxis = $jbmdS.useRef();
    var id = $jbmdS.useState($4e1d5be9136c4465$var$idCounter++)[0];
    var Style = $jbmdS.useState(function() {
        return (0, $i5wAQ.styleSingleton)();
    })[0];
    var lastProps = $jbmdS.useRef(props);
    $jbmdS.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $jbmdS.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $53oVd.__spreadArray)([
                props.lockRef.current
            ], (props.shards || []).map($4e1d5be9136c4465$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $jbmdS.useCallback(function(event, parent) {
        if ("touches" in event && event.touches.length === 2) return !lastProps.current.allowPinchZoom;
        var touch = $4e1d5be9136c4465$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ("touches" in event && moveDirection === "h" && target.type === "range") return false;
        var canBeScrolledInMainDirection = (0, $7aPzl.locationCouldBeScrolled)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === "v" ? "h" : "v";
            canBeScrolledInMainDirection = (0, $7aPzl.locationCouldBeScrolled)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $7aPzl.handleScroll)(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $jbmdS.useCallback(function(_event) {
        var event = _event;
        if (!$4e1d5be9136c4465$var$lockStack.length || $4e1d5be9136c4465$var$lockStack[$4e1d5be9136c4465$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = "deltaY" in event ? $4e1d5be9136c4465$export$39efaa2ca254a28d(event) : $4e1d5be9136c4465$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && e.target === event.target && $4e1d5be9136c4465$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($4e1d5be9136c4465$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $jbmdS.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $jbmdS.useCallback(function(event) {
        touchStartRef.current = $4e1d5be9136c4465$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $jbmdS.useCallback(function(event) {
        shouldCancel(event.type, $4e1d5be9136c4465$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $jbmdS.useCallback(function(event) {
        shouldCancel(event.type, $4e1d5be9136c4465$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $jbmdS.useEffect(function() {
        $4e1d5be9136c4465$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener("wheel", shouldPrevent, (0, $dbaLa.nonPassive));
        document.addEventListener("touchmove", shouldPrevent, (0, $dbaLa.nonPassive));
        document.addEventListener("touchstart", scrollTouchStart, (0, $dbaLa.nonPassive));
        return function() {
            $4e1d5be9136c4465$var$lockStack = $4e1d5be9136c4465$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener("wheel", shouldPrevent, (0, $dbaLa.nonPassive));
            document.removeEventListener("touchmove", shouldPrevent, (0, $dbaLa.nonPassive));
            document.removeEventListener("touchstart", scrollTouchStart, (0, $dbaLa.nonPassive));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $jbmdS.createElement($jbmdS.Fragment, null, inert ? $jbmdS.createElement(Style, {
        styles: $4e1d5be9136c4465$var$generateStyle(id)
    }) : null, removeScrollBar ? $jbmdS.createElement((0, $h5klF.RemoveScrollBar), {
        gapMode: "margin"
    }) : null);
}

});
parcelRegister("dbaLa", function(module, exports) {

$parcel$export(module.exports, "nonPassive", function () { return $9984a6153eb646b5$export$10a6e88623fa9454; });
var $9984a6153eb646b5$var$passiveSupported = false;
if (typeof window !== "undefined") try {
    var $9984a6153eb646b5$var$options = Object.defineProperty({}, "passive", {
        get: function() {
            $9984a6153eb646b5$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener("test", $9984a6153eb646b5$var$options, $9984a6153eb646b5$var$options);
    // @ts-ignore
    window.removeEventListener("test", $9984a6153eb646b5$var$options, $9984a6153eb646b5$var$options);
} catch (err) {
    $9984a6153eb646b5$var$passiveSupported = false;
}
var $9984a6153eb646b5$export$10a6e88623fa9454 = $9984a6153eb646b5$var$passiveSupported ? {
    passive: false
} : false;

});

parcelRegister("7aPzl", function(module, exports) {

$parcel$export(module.exports, "locationCouldBeScrolled", function () { return $539178211e430c68$export$9ec64480cae49817; });
$parcel$export(module.exports, "handleScroll", function () { return $539178211e430c68$export$dde0441bd4a6ded8; });
var $539178211e430c68$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === "TEXTAREA";
};
var $539178211e430c68$var$elementCanBeScrolled = function(node, overflow) {
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== "hidden" && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$539178211e430c68$var$alwaysContainsScroll(node) && styles[overflow] === "visible"));
};
var $539178211e430c68$var$elementCouldBeVScrolled = function(node) {
    return $539178211e430c68$var$elementCanBeScrolled(node, "overflowY");
};
var $539178211e430c68$var$elementCouldBeHScrolled = function(node) {
    return $539178211e430c68$var$elementCanBeScrolled(node, "overflowX");
};
var $539178211e430c68$export$9ec64480cae49817 = function(axis, node) {
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $539178211e430c68$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $539178211e430c68$var$getScrollVariables(axis, current), s = _a[1], d = _a[2];
            if (s > d) return true;
        }
        current = current.parentNode;
    }while (current && current !== document.body);
    return false;
};
var $539178211e430c68$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $539178211e430c68$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $539178211e430c68$var$elementCouldBeScrolled = function(axis, node) {
    return axis === "v" ? $539178211e430c68$var$elementCouldBeVScrolled(node) : $539178211e430c68$var$elementCouldBeHScrolled(node);
};
var $539178211e430c68$var$getScrollVariables = function(axis, node) {
    return axis === "v" ? $539178211e430c68$var$getVScrollVariables(node) : $539178211e430c68$var$getHScrollVariables(node);
};
var $539178211e430c68$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === "h" && direction === "rtl" ? -1 : 1;
};
var $539178211e430c68$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $539178211e430c68$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = $539178211e430c68$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($539178211e430c68$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        target = target.parentNode;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    if (isDeltaPositive && (noOverscroll && availableScroll === 0 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && availableScrollTop === 0 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};

});







parcelRegister("6gkJQ", function(module, exports) {

$parcel$export(module.exports, "Popover", function () { return $e004e4d28a50db41$export$5b6b19405a83ff9d; });
$parcel$export(module.exports, "PopoverTrigger", function () { return $e004e4d28a50db41$export$7dacb05d26466c3; });
$parcel$export(module.exports, "PopoverContent", function () { return $e004e4d28a50db41$export$d7e1f420b25549ff; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $bDCDZ = parcelRequire("bDCDZ");
// Assuming a simple utility for classNames similar to the one you might be using
function $e004e4d28a50db41$var$cn(...classes) {
    return classes.filter(Boolean).join(" ");
}
const $e004e4d28a50db41$export$5b6b19405a83ff9d = $bDCDZ.Root;
const $e004e4d28a50db41$export$7dacb05d26466c3 = $bDCDZ.Trigger;
const $e004e4d28a50db41$export$96e5381f42521a79 = $bDCDZ.Anchor;
// Inline styles as an alternative to Tailwind classes
const $e004e4d28a50db41$var$popoverStyles = {
    zIndex: 50,
    width: "auto",
    // equivalent to w-72 in Tailwind
    maxWidth: "358px",
    borderRadius: "0.375rem",
    // equivalent to rounded-md in Tailwind
    border: "1px solid  #e5e7eb",
    // add your borderColor
    backgroundColor: "#ffffff",
    // bg-popover, replace with your color
    // padding: '1rem', // p-4 in Tailwind
    color: "#000000",
    // text-popover-foreground, replace with your color
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    // shadow-md in Tailwind
    outline: "none",
    minWidth: "var(--radix-popover-trigger-width)",
    maxHeight: "var(--radix-popover-content-available-height)"
};
const $e004e4d28a50db41$export$d7e1f420b25549ff = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).forwardRef(({ className: className, align: align = "center", sideOffset: sideOffset = 4, style: style, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)($bDCDZ.Portal, {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)($bDCDZ.Content, {
            ref: ref,
            align: align,
            sideOffset: sideOffset,
            className: $e004e4d28a50db41$var$cn(className),
            style: {
                ...$e004e4d28a50db41$var$popoverStyles,
                ...style
            },
            ...props
        })
    }));
$e004e4d28a50db41$export$d7e1f420b25549ff.displayName = "PopoverContent";

});
parcelRegister("bDCDZ", function(module, exports) {

$parcel$export(module.exports, "Root", function () { return $a521e940a17a4639$export$be92b6f5f03c0fe9; });
$parcel$export(module.exports, "Anchor", function () { return $a521e940a17a4639$export$b688253958b8dfe7; });
$parcel$export(module.exports, "Trigger", function () { return $a521e940a17a4639$export$41fb9f06171c75f4; });
$parcel$export(module.exports, "Portal", function () { return $a521e940a17a4639$export$602eac185826482c; });
$parcel$export(module.exports, "Content", function () { return $a521e940a17a4639$export$7c6e2c02157bb7d2; });

var $jbmdS = parcelRequire("jbmdS");

var $hFcKE = parcelRequire("hFcKE");

var $9sunj = parcelRequire("9sunj");

var $f4RZG = parcelRequire("f4RZG");

var $jJBMp = parcelRequire("jJBMp");

var $fbZ8r = parcelRequire("fbZ8r");

var $i3HOY = parcelRequire("i3HOY");

var $g7F3X = parcelRequire("g7F3X");

var $aU3NZ = parcelRequire("aU3NZ");

var $fKp8B = parcelRequire("fKp8B");

var $joHB8 = parcelRequire("joHB8");

var $cihg9 = parcelRequire("cihg9");

var $bXq35 = parcelRequire("bXq35");

var $1sq0Q = parcelRequire("1sq0Q");

var $9Y02g = parcelRequire("9Y02g");

var $gQkjX = parcelRequire("gQkjX");

var $4TLFw = parcelRequire("4TLFw");
"use client";
var $a521e940a17a4639$var$POPOVER_NAME = "Popover";
var [$a521e940a17a4639$var$createPopoverContext, $a521e940a17a4639$export$c8393c9e73286932] = (0, $f4RZG.createContextScope)($a521e940a17a4639$var$POPOVER_NAME, [
    (0, $aU3NZ.createPopperScope)
]);
var $a521e940a17a4639$var$usePopperScope = (0, $aU3NZ.createPopperScope)();
var [$a521e940a17a4639$var$PopoverProvider, $a521e940a17a4639$var$usePopoverContext] = $a521e940a17a4639$var$createPopoverContext($a521e940a17a4639$var$POPOVER_NAME);
var $a521e940a17a4639$export$5b6b19405a83ff9d = (props)=>{
    const { __scopePopover: __scopePopover, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = false } = props;
    const popperScope = $a521e940a17a4639$var$usePopperScope(__scopePopover);
    const triggerRef = $jbmdS.useRef(null);
    const [hasCustomAnchor, setHasCustomAnchor] = $jbmdS.useState(false);
    const [open = false, setOpen] = (0, $1sq0Q.useControllableState)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /* @__PURE__ */ (0, $4TLFw.jsx)($aU3NZ.Root, {
        ...popperScope,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)($a521e940a17a4639$var$PopoverProvider, {
            scope: __scopePopover,
            contentId: (0, $g7F3X.useId)(),
            triggerRef: triggerRef,
            open: open,
            onOpenChange: setOpen,
            onOpenToggle: $jbmdS.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
                setOpen
            ]),
            hasCustomAnchor: hasCustomAnchor,
            onCustomAnchorAdd: $jbmdS.useCallback(()=>setHasCustomAnchor(true), []),
            onCustomAnchorRemove: $jbmdS.useCallback(()=>setHasCustomAnchor(false), []),
            modal: modal,
            children: children
        })
    });
};
$a521e940a17a4639$export$5b6b19405a83ff9d.displayName = $a521e940a17a4639$var$POPOVER_NAME;
var $a521e940a17a4639$var$ANCHOR_NAME = "PopoverAnchor";
var $a521e940a17a4639$export$96e5381f42521a79 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...anchorProps } = props;
    const context = $a521e940a17a4639$var$usePopoverContext($a521e940a17a4639$var$ANCHOR_NAME, __scopePopover);
    const popperScope = $a521e940a17a4639$var$usePopperScope(__scopePopover);
    const { onCustomAnchorAdd: onCustomAnchorAdd, onCustomAnchorRemove: onCustomAnchorRemove } = context;
    $jbmdS.useEffect(()=>{
        onCustomAnchorAdd();
        return ()=>onCustomAnchorRemove();
    }, [
        onCustomAnchorAdd,
        onCustomAnchorRemove
    ]);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($aU3NZ.Anchor, {
        ...popperScope,
        ...anchorProps,
        ref: forwardedRef
    });
});
$a521e940a17a4639$export$96e5381f42521a79.displayName = $a521e940a17a4639$var$ANCHOR_NAME;
var $a521e940a17a4639$var$TRIGGER_NAME = "PopoverTrigger";
var $a521e940a17a4639$export$7dacb05d26466c3 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...triggerProps } = props;
    const context = $a521e940a17a4639$var$usePopoverContext($a521e940a17a4639$var$TRIGGER_NAME, __scopePopover);
    const popperScope = $a521e940a17a4639$var$usePopperScope(__scopePopover);
    const composedTriggerRef = (0, $9sunj.useComposedRefs)(forwardedRef, context.triggerRef);
    const trigger = /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).button, {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $a521e940a17a4639$var$getState(context.open),
        ...triggerProps,
        ref: composedTriggerRef,
        onClick: (0, $hFcKE.composeEventHandlers)(props.onClick, context.onOpenToggle)
    });
    return context.hasCustomAnchor ? trigger : /* @__PURE__ */ (0, $4TLFw.jsx)($aU3NZ.Anchor, {
        asChild: true,
        ...popperScope,
        children: trigger
    });
});
$a521e940a17a4639$export$7dacb05d26466c3.displayName = $a521e940a17a4639$var$TRIGGER_NAME;
var $a521e940a17a4639$var$PORTAL_NAME = "PopoverPortal";
var [$a521e940a17a4639$var$PortalProvider, $a521e940a17a4639$var$usePortalContext] = $a521e940a17a4639$var$createPopoverContext($a521e940a17a4639$var$PORTAL_NAME, {
    forceMount: void 0
});
var $a521e940a17a4639$export$dd679ffb4362d2d4 = (props)=>{
    const { __scopePopover: __scopePopover, forceMount: forceMount, children: children, container: container } = props;
    const context = $a521e940a17a4639$var$usePopoverContext($a521e940a17a4639$var$PORTAL_NAME, __scopePopover);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($a521e940a17a4639$var$PortalProvider, {
        scope: __scopePopover,
        forceMount: forceMount,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $joHB8.Presence), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $fKp8B.Portal), {
                asChild: true,
                container: container,
                children: children
            })
        })
    });
};
$a521e940a17a4639$export$dd679ffb4362d2d4.displayName = $a521e940a17a4639$var$PORTAL_NAME;
var $a521e940a17a4639$var$CONTENT_NAME = "PopoverContent";
var $a521e940a17a4639$export$d7e1f420b25549ff = $jbmdS.forwardRef((props, forwardedRef)=>{
    const portalContext = $a521e940a17a4639$var$usePortalContext($a521e940a17a4639$var$CONTENT_NAME, props.__scopePopover);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $a521e940a17a4639$var$usePopoverContext($a521e940a17a4639$var$CONTENT_NAME, props.__scopePopover);
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $joHB8.Presence), {
        present: forceMount || context.open,
        children: context.modal ? /* @__PURE__ */ (0, $4TLFw.jsx)($a521e940a17a4639$var$PopoverContentModal, {
            ...contentProps,
            ref: forwardedRef
        }) : /* @__PURE__ */ (0, $4TLFw.jsx)($a521e940a17a4639$var$PopoverContentNonModal, {
            ...contentProps,
            ref: forwardedRef
        })
    });
});
$a521e940a17a4639$export$d7e1f420b25549ff.displayName = $a521e940a17a4639$var$CONTENT_NAME;
var $a521e940a17a4639$var$PopoverContentModal = $jbmdS.forwardRef((props, forwardedRef)=>{
    const context = $a521e940a17a4639$var$usePopoverContext($a521e940a17a4639$var$CONTENT_NAME, props.__scopePopover);
    const contentRef = $jbmdS.useRef(null);
    const composedRefs = (0, $9sunj.useComposedRefs)(forwardedRef, contentRef);
    const isRightClickOutsideRef = $jbmdS.useRef(false);
    $jbmdS.useEffect(()=>{
        const content = contentRef.current;
        if (content) return (0, $9Y02g.hideOthers)(content);
    }, []);
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $gQkjX.default), {
        as: (0, $bXq35.Slot),
        allowPinchZoom: true,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)($a521e940a17a4639$var$PopoverContentImpl, {
            ...props,
            ref: composedRefs,
            trapFocus: context.open,
            disableOutsidePointerEvents: true,
            onCloseAutoFocus: (0, $hFcKE.composeEventHandlers)(props.onCloseAutoFocus, (event)=>{
                event.preventDefault();
                if (!isRightClickOutsideRef.current) context.triggerRef.current?.focus();
            }),
            onPointerDownOutside: (0, $hFcKE.composeEventHandlers)(props.onPointerDownOutside, (event)=>{
                const originalEvent = event.detail.originalEvent;
                const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
                const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
                isRightClickOutsideRef.current = isRightClick;
            }, {
                checkForDefaultPrevented: false
            }),
            onFocusOutside: (0, $hFcKE.composeEventHandlers)(props.onFocusOutside, (event)=>event.preventDefault(), {
                checkForDefaultPrevented: false
            })
        })
    });
});
var $a521e940a17a4639$var$PopoverContentNonModal = $jbmdS.forwardRef((props, forwardedRef)=>{
    const context = $a521e940a17a4639$var$usePopoverContext($a521e940a17a4639$var$CONTENT_NAME, props.__scopePopover);
    const hasInteractedOutsideRef = $jbmdS.useRef(false);
    const hasPointerDownOutsideRef = $jbmdS.useRef(false);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($a521e940a17a4639$var$PopoverContentImpl, {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            props.onCloseAutoFocus?.(event);
            if (!event.defaultPrevented) {
                if (!hasInteractedOutsideRef.current) context.triggerRef.current?.focus();
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            props.onInteractOutside?.(event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            }
            const target = event.target;
            const targetIsTrigger = context.triggerRef.current?.contains(target);
            if (targetIsTrigger) event.preventDefault();
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    });
});
var $a521e940a17a4639$var$PopoverContentImpl = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, disableOutsidePointerEvents: disableOutsidePointerEvents, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, ...contentProps } = props;
    const context = $a521e940a17a4639$var$usePopoverContext($a521e940a17a4639$var$CONTENT_NAME, __scopePopover);
    const popperScope = $a521e940a17a4639$var$usePopperScope(__scopePopover);
    (0, $fbZ8r.useFocusGuards)();
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $i3HOY.FocusScope), {
        asChild: true,
        loop: true,
        trapped: trapFocus,
        onMountAutoFocus: onOpenAutoFocus,
        onUnmountAutoFocus: onCloseAutoFocus,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $jJBMp.DismissableLayer), {
            asChild: true,
            disableOutsidePointerEvents: disableOutsidePointerEvents,
            onInteractOutside: onInteractOutside,
            onEscapeKeyDown: onEscapeKeyDown,
            onPointerDownOutside: onPointerDownOutside,
            onFocusOutside: onFocusOutside,
            onDismiss: ()=>context.onOpenChange(false),
            children: /* @__PURE__ */ (0, $4TLFw.jsx)($aU3NZ.Content, {
                "data-state": $a521e940a17a4639$var$getState(context.open),
                role: "dialog",
                id: context.contentId,
                ...popperScope,
                ...contentProps,
                ref: forwardedRef,
                style: {
                    ...contentProps.style,
                    "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                    "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                    "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                    "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                    "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
            })
        })
    });
});
var $a521e940a17a4639$var$CLOSE_NAME = "PopoverClose";
var $a521e940a17a4639$export$d6ac43ebaa40d53e = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...closeProps } = props;
    const context = $a521e940a17a4639$var$usePopoverContext($a521e940a17a4639$var$CLOSE_NAME, __scopePopover);
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).button, {
        type: "button",
        ...closeProps,
        ref: forwardedRef,
        onClick: (0, $hFcKE.composeEventHandlers)(props.onClick, ()=>context.onOpenChange(false))
    });
});
$a521e940a17a4639$export$d6ac43ebaa40d53e.displayName = $a521e940a17a4639$var$CLOSE_NAME;
var $a521e940a17a4639$var$ARROW_NAME = "PopoverArrow";
var $a521e940a17a4639$export$3152841115e061b2 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...arrowProps } = props;
    const popperScope = $a521e940a17a4639$var$usePopperScope(__scopePopover);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($aU3NZ.Arrow, {
        ...popperScope,
        ...arrowProps,
        ref: forwardedRef
    });
});
$a521e940a17a4639$export$3152841115e061b2.displayName = $a521e940a17a4639$var$ARROW_NAME;
function $a521e940a17a4639$var$getState(open) {
    return open ? "open" : "closed";
}
var $a521e940a17a4639$export$be92b6f5f03c0fe9 = $a521e940a17a4639$export$5b6b19405a83ff9d;
var $a521e940a17a4639$export$b688253958b8dfe7 = $a521e940a17a4639$export$96e5381f42521a79;
var $a521e940a17a4639$export$41fb9f06171c75f4 = $a521e940a17a4639$export$7dacb05d26466c3;
var $a521e940a17a4639$export$602eac185826482c = $a521e940a17a4639$export$dd679ffb4362d2d4;
var $a521e940a17a4639$export$7c6e2c02157bb7d2 = $a521e940a17a4639$export$d7e1f420b25549ff;
var $a521e940a17a4639$export$f39c2d165cd861fe = $a521e940a17a4639$export$d6ac43ebaa40d53e;
var $a521e940a17a4639$export$21b07c8f274aebd5 = $a521e940a17a4639$export$3152841115e061b2;

});
parcelRegister("aU3NZ", function(module, exports) {

$parcel$export(module.exports, "createPopperScope", function () { return $e7278d8b495a5fb8$export$722aac194ae923; });
$parcel$export(module.exports, "Root", function () { return $e7278d8b495a5fb8$export$be92b6f5f03c0fe9; });
$parcel$export(module.exports, "Anchor", function () { return $e7278d8b495a5fb8$export$b688253958b8dfe7; });
$parcel$export(module.exports, "Content", function () { return $e7278d8b495a5fb8$export$7c6e2c02157bb7d2; });
$parcel$export(module.exports, "Arrow", function () { return $e7278d8b495a5fb8$export$21b07c8f274aebd5; });

var $jbmdS = parcelRequire("jbmdS");

var $fcOr4 = parcelRequire("fcOr4");
var $gIRV7 = parcelRequire("gIRV7");

var $7n3c4 = parcelRequire("7n3c4");

var $9sunj = parcelRequire("9sunj");

var $hfERT = parcelRequire("hfERT");

var $cihg9 = parcelRequire("cihg9");

var $kjEX1 = parcelRequire("kjEX1");

var $9crHl = parcelRequire("9crHl");

var $am0tV = parcelRequire("am0tV");

var $4TLFw = parcelRequire("4TLFw");
"use client";
var $e7278d8b495a5fb8$export$36f0086da09c4b9f = [
    "top",
    "right",
    "bottom",
    "left"
];
var $e7278d8b495a5fb8$export$3671ffab7b302fc9 = [
    "start",
    "center",
    "end"
];
var $e7278d8b495a5fb8$var$POPPER_NAME = "Popper";
var [$e7278d8b495a5fb8$var$createPopperContext, $e7278d8b495a5fb8$export$722aac194ae923] = (0, $hfERT.createContextScope)($e7278d8b495a5fb8$var$POPPER_NAME);
var [$e7278d8b495a5fb8$var$PopperProvider, $e7278d8b495a5fb8$var$usePopperContext] = $e7278d8b495a5fb8$var$createPopperContext($e7278d8b495a5fb8$var$POPPER_NAME);
var $e7278d8b495a5fb8$export$badac9ada3a0bdf9 = (props)=>{
    const { __scopePopper: __scopePopper, children: children } = props;
    const [anchor, setAnchor] = $jbmdS.useState(null);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($e7278d8b495a5fb8$var$PopperProvider, {
        scope: __scopePopper,
        anchor: anchor,
        onAnchorChange: setAnchor,
        children: children
    });
};
$e7278d8b495a5fb8$export$badac9ada3a0bdf9.displayName = $e7278d8b495a5fb8$var$POPPER_NAME;
var $e7278d8b495a5fb8$var$ANCHOR_NAME = "PopperAnchor";
var $e7278d8b495a5fb8$export$ecd4e1ccab6ed6d = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper, virtualRef: virtualRef, ...anchorProps } = props;
    const context = $e7278d8b495a5fb8$var$usePopperContext($e7278d8b495a5fb8$var$ANCHOR_NAME, __scopePopper);
    const ref = $jbmdS.useRef(null);
    const composedRefs = (0, $9sunj.useComposedRefs)(forwardedRef, ref);
    $jbmdS.useEffect(()=>{
        context.onAnchorChange(virtualRef?.current || ref.current);
    });
    return virtualRef ? null : /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).div, {
        ...anchorProps,
        ref: composedRefs
    });
});
$e7278d8b495a5fb8$export$ecd4e1ccab6ed6d.displayName = $e7278d8b495a5fb8$var$ANCHOR_NAME;
var $e7278d8b495a5fb8$var$CONTENT_NAME = "PopperContent";
var [$e7278d8b495a5fb8$var$PopperContentProvider, $e7278d8b495a5fb8$var$useContentContext] = $e7278d8b495a5fb8$var$createPopperContext($e7278d8b495a5fb8$var$CONTENT_NAME);
var $e7278d8b495a5fb8$export$bc4ae5855d3c4fc = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper, side: side = "bottom", sideOffset: sideOffset = 0, align: align = "center", alignOffset: alignOffset = 0, arrowPadding: arrowPadding = 0, avoidCollisions: avoidCollisions = true, collisionBoundary: collisionBoundary = [], collisionPadding: collisionPaddingProp = 0, sticky: sticky = "partial", hideWhenDetached: hideWhenDetached = false, updatePositionStrategy: updatePositionStrategy = "optimized", onPlaced: onPlaced, ...contentProps } = props;
    const context = $e7278d8b495a5fb8$var$usePopperContext($e7278d8b495a5fb8$var$CONTENT_NAME, __scopePopper);
    const [content, setContent] = $jbmdS.useState(null);
    const composedRefs = (0, $9sunj.useComposedRefs)(forwardedRef, (node)=>setContent(node));
    const [arrow, setArrow] = $jbmdS.useState(null);
    const arrowSize = (0, $am0tV.useSize)(arrow);
    const arrowWidth = arrowSize?.width ?? 0;
    const arrowHeight = arrowSize?.height ?? 0;
    const desiredPlacement = side + (align !== "center" ? "-" + align : "");
    const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...collisionPaddingProp
    };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter($e7278d8b495a5fb8$var$isNotNull),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    const { refs: refs, floatingStyles: floatingStyles, placement: placement, isPositioned: isPositioned, middlewareData: middlewareData } = (0, $fcOr4.useFloating)({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: "fixed",
        placement: desiredPlacement,
        whileElementsMounted: (...args)=>{
            const cleanup = (0, $gIRV7.autoUpdate)(...args, {
                animationFrame: updatePositionStrategy === "always"
            });
            return cleanup;
        },
        elements: {
            reference: context.anchor
        },
        middleware: [
            (0, $fcOr4.offset)({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions && (0, $fcOr4.shift)({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === "partial" ? (0, $fcOr4.limitShift)() : void 0,
                ...detectOverflowOptions
            }),
            avoidCollisions && (0, $fcOr4.flip)({
                ...detectOverflowOptions
            }),
            (0, $fcOr4.size)({
                ...detectOverflowOptions,
                apply: ({ elements: elements, rects: rects, availableWidth: availableWidth, availableHeight: availableHeight })=>{
                    const { width: anchorWidth, height: anchorHeight } = rects.reference;
                    const contentStyle = elements.floating.style;
                    contentStyle.setProperty("--radix-popper-available-width", `${availableWidth}px`);
                    contentStyle.setProperty("--radix-popper-available-height", `${availableHeight}px`);
                    contentStyle.setProperty("--radix-popper-anchor-width", `${anchorWidth}px`);
                    contentStyle.setProperty("--radix-popper-anchor-height", `${anchorHeight}px`);
                }
            }),
            arrow && (0, $fcOr4.arrow)({
                element: arrow,
                padding: arrowPadding
            }),
            $e7278d8b495a5fb8$var$transformOrigin({
                arrowWidth: arrowWidth,
                arrowHeight: arrowHeight
            }),
            hideWhenDetached && (0, $fcOr4.hide)({
                strategy: "referenceHidden",
                ...detectOverflowOptions
            })
        ]
    });
    const [placedSide, placedAlign] = $e7278d8b495a5fb8$var$getSideAndAlignFromPlacement(placement);
    const handlePlaced = (0, $kjEX1.useCallbackRef)(onPlaced);
    (0, $9crHl.useLayoutEffect)(()=>{
        if (isPositioned) handlePlaced?.();
    }, [
        isPositioned,
        handlePlaced
    ]);
    const arrowX = middlewareData.arrow?.x;
    const arrowY = middlewareData.arrow?.y;
    const cannotCenterArrow = middlewareData.arrow?.centerOffset !== 0;
    const [contentZIndex, setContentZIndex] = $jbmdS.useState();
    (0, $9crHl.useLayoutEffect)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    return /* @__PURE__ */ (0, $4TLFw.jsx)("div", {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
            ...floatingStyles,
            transform: isPositioned ? floatingStyles.transform : "translate(0, -200%)",
            // keep off the page when measuring
            minWidth: "max-content",
            zIndex: contentZIndex,
            ["--radix-popper-transform-origin"]: [
                middlewareData.transformOrigin?.x,
                middlewareData.transformOrigin?.y
            ].join(" "),
            // hide the content if using the hide middleware and should be hidden
            // set visibility to hidden and disable pointer events so the UI behaves
            // as if the PopperContent isn't there at all
            ...middlewareData.hide?.referenceHidden && {
                visibility: "hidden",
                pointerEvents: "none"
            }
        },
        dir: props.dir,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)($e7278d8b495a5fb8$var$PopperContentProvider, {
            scope: __scopePopper,
            placedSide: placedSide,
            onArrowChange: setArrow,
            arrowX: arrowX,
            arrowY: arrowY,
            shouldHideArrow: cannotCenterArrow,
            children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).div, {
                "data-side": placedSide,
                "data-align": placedAlign,
                ...contentProps,
                ref: composedRefs,
                style: {
                    ...contentProps.style,
                    // if the PopperContent hasn't been placed yet (not all measurements done)
                    // we prevent animations so that users's animation don't kick in too early referring wrong sides
                    animation: !isPositioned ? "none" : void 0
                }
            })
        })
    });
});
$e7278d8b495a5fb8$export$bc4ae5855d3c4fc.displayName = $e7278d8b495a5fb8$var$CONTENT_NAME;
var $e7278d8b495a5fb8$var$ARROW_NAME = "PopperArrow";
var $e7278d8b495a5fb8$var$OPPOSITE_SIDE = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
};
var $e7278d8b495a5fb8$export$79d62cd4e10a3fd0 = $jbmdS.forwardRef(function PopperArrow2(props, forwardedRef) {
    const { __scopePopper: __scopePopper, ...arrowProps } = props;
    const contentContext = $e7278d8b495a5fb8$var$useContentContext($e7278d8b495a5fb8$var$ARROW_NAME, __scopePopper);
    const baseSide = $e7278d8b495a5fb8$var$OPPOSITE_SIDE[contentContext.placedSide];
    return(// we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ (0, $4TLFw.jsx)("span", {
        ref: contentContext.onArrowChange,
        style: {
            position: "absolute",
            left: contentContext.arrowX,
            top: contentContext.arrowY,
            [baseSide]: 0,
            transformOrigin: {
                top: "",
                right: "0 0",
                bottom: "center 0",
                left: "100% 0"
            }[contentContext.placedSide],
            transform: {
                top: "translateY(100%)",
                right: "translateY(50%) rotate(90deg) translateX(-50%)",
                bottom: `rotate(180deg)`,
                left: "translateY(50%) rotate(-90deg) translateX(50%)"
            }[contentContext.placedSide],
            visibility: contentContext.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ (0, $4TLFw.jsx)($7n3c4.Root, {
            ...arrowProps,
            ref: forwardedRef,
            style: {
                ...arrowProps.style,
                // ensures the element can be measured correctly (mostly for if SVG)
                display: "block"
            }
        })
    }));
});
$e7278d8b495a5fb8$export$79d62cd4e10a3fd0.displayName = $e7278d8b495a5fb8$var$ARROW_NAME;
function $e7278d8b495a5fb8$var$isNotNull(value) {
    return value !== null;
}
var $e7278d8b495a5fb8$var$transformOrigin = (options)=>({
        name: "transformOrigin",
        options: options,
        fn (data) {
            const { placement: placement, rects: rects, middlewareData: middlewareData } = data;
            const cannotCenterArrow = middlewareData.arrow?.centerOffset !== 0;
            const isArrowHidden = cannotCenterArrow;
            const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            const [placedSide, placedAlign] = $e7278d8b495a5fb8$var$getSideAndAlignFromPlacement(placement);
            const noArrowAlign = {
                start: "0%",
                center: "50%",
                end: "100%"
            }[placedAlign];
            const arrowXCenter = (middlewareData.arrow?.x ?? 0) + arrowWidth / 2;
            const arrowYCenter = (middlewareData.arrow?.y ?? 0) + arrowHeight / 2;
            let x = "";
            let y = "";
            if (placedSide === "bottom") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${-arrowHeight}px`;
            } else if (placedSide === "top") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${rects.floating.height + arrowHeight}px`;
            } else if (placedSide === "right") {
                x = `${-arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            } else if (placedSide === "left") {
                x = `${rects.floating.width + arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            }
            return {
                data: {
                    x: x,
                    y: y
                }
            };
        }
    });
function $e7278d8b495a5fb8$var$getSideAndAlignFromPlacement(placement) {
    const [side, align = "center"] = placement.split("-");
    return [
        side,
        align
    ];
}
var $e7278d8b495a5fb8$export$be92b6f5f03c0fe9 = $e7278d8b495a5fb8$export$badac9ada3a0bdf9;
var $e7278d8b495a5fb8$export$b688253958b8dfe7 = $e7278d8b495a5fb8$export$ecd4e1ccab6ed6d;
var $e7278d8b495a5fb8$export$7c6e2c02157bb7d2 = $e7278d8b495a5fb8$export$bc4ae5855d3c4fc;
var $e7278d8b495a5fb8$export$21b07c8f274aebd5 = $e7278d8b495a5fb8$export$79d62cd4e10a3fd0;

});
parcelRegister("fcOr4", function(module, exports) {

$parcel$export(module.exports, "useFloating", function () { return $b11f19784fdf19ff$export$4e02a5c1d08bac65; });
$parcel$export(module.exports, "offset", function () { return $b11f19784fdf19ff$export$cc800923e997bb8; });
$parcel$export(module.exports, "shift", function () { return $b11f19784fdf19ff$export$fba63a578e423eb; });
$parcel$export(module.exports, "limitShift", function () { return $b11f19784fdf19ff$export$7bf07e38f3dc4b69; });
$parcel$export(module.exports, "flip", function () { return $b11f19784fdf19ff$export$8a83211c878a3f1f; });
$parcel$export(module.exports, "size", function () { return $b11f19784fdf19ff$export$346677f925de839c; });
$parcel$export(module.exports, "hide", function () { return $b11f19784fdf19ff$export$fe8985bb6374093c; });
$parcel$export(module.exports, "arrow", function () { return $b11f19784fdf19ff$export$f2120bbfa5450bd2; });

var $gIRV7 = parcelRequire("gIRV7");

var $jbmdS = parcelRequire("jbmdS");

var $jCNM0 = parcelRequire("jCNM0");
var $b11f19784fdf19ff$var$index = typeof document !== "undefined" ? (0, $jbmdS.useLayoutEffect) : (0, $jbmdS.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $b11f19784fdf19ff$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === "function" && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === "object") {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$b11f19784fdf19ff$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            if (!$b11f19784fdf19ff$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $b11f19784fdf19ff$var$getDPR(element) {
    if (typeof window === "undefined") return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $b11f19784fdf19ff$var$roundByDPR(element, value) {
    const dpr = $b11f19784fdf19ff$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $b11f19784fdf19ff$var$useLatestRef(value) {
    const ref = $jbmdS.useRef(value);
    $b11f19784fdf19ff$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $b11f19784fdf19ff$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $jbmdS.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $jbmdS.useState(middleware);
    if (!$b11f19784fdf19ff$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $jbmdS.useState(null);
    const [_floating, _setFloating] = $jbmdS.useState(null);
    const setReference = $jbmdS.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $jbmdS.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $jbmdS.useRef(null);
    const floatingRef = $jbmdS.useRef(null);
    const dataRef = $jbmdS.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $b11f19784fdf19ff$var$useLatestRef(whileElementsMounted);
    const platformRef = $b11f19784fdf19ff$var$useLatestRef(platform);
    const openRef = $b11f19784fdf19ff$var$useLatestRef(open);
    const update = $jbmdS.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $gIRV7.computePosition)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            };
            if (isMountedRef.current && !$b11f19784fdf19ff$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $jCNM0.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    $b11f19784fdf19ff$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $jbmdS.useRef(false);
    $b11f19784fdf19ff$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $b11f19784fdf19ff$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $jbmdS.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $jbmdS.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $jbmdS.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $b11f19784fdf19ff$var$roundByDPR(elements.floating, data.x);
        const y = $b11f19784fdf19ff$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$b11f19784fdf19ff$var$getDPR(elements.floating) >= 1.5 && {
                willChange: "transform"
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $jbmdS.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $b11f19784fdf19ff$var$arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, "current");
    }
    return {
        name: "arrow",
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === "function" ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $gIRV7.arrow)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $gIRV7.arrow)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $b11f19784fdf19ff$export$cc800923e997bb8 = (options, deps)=>({
        ...(0, $gIRV7.offset)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $b11f19784fdf19ff$export$fba63a578e423eb = (options, deps)=>({
        ...(0, $gIRV7.shift)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $b11f19784fdf19ff$export$7bf07e38f3dc4b69 = (options, deps)=>({
        ...(0, $gIRV7.limitShift)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $b11f19784fdf19ff$export$8a83211c878a3f1f = (options, deps)=>({
        ...(0, $gIRV7.flip)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $b11f19784fdf19ff$export$346677f925de839c = (options, deps)=>({
        ...(0, $gIRV7.size)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $b11f19784fdf19ff$export$91fb6ecbd551914 = (options, deps)=>({
        ...(0, $gIRV7.autoPlacement)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $b11f19784fdf19ff$export$fe8985bb6374093c = (options, deps)=>({
        ...(0, $gIRV7.hide)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $b11f19784fdf19ff$export$18c8ad048e32c7d5 = (options, deps)=>({
        ...(0, $gIRV7.inline)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $b11f19784fdf19ff$export$f2120bbfa5450bd2 = (options, deps)=>({
        ...$b11f19784fdf19ff$var$arrow$1(options),
        options: [
            options,
            deps
        ]
    });

});

parcelRegister("7n3c4", function(module, exports) {

$parcel$export(module.exports, "Root", function () { return $071bc6c0de1a7538$export$be92b6f5f03c0fe9; });
// packages/react/arrow/src/Arrow.tsx

var $jbmdS = parcelRequire("jbmdS");

var $cihg9 = parcelRequire("cihg9");

var $4TLFw = parcelRequire("4TLFw");
var $071bc6c0de1a7538$var$NAME = "Arrow";
var $071bc6c0de1a7538$export$21b07c8f274aebd5 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { children: children, width: width = 10, height: height = 5, ...arrowProps } = props;
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).svg, {
        ...arrowProps,
        ref: forwardedRef,
        width: width,
        height: height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none",
        children: props.asChild ? children : /* @__PURE__ */ (0, $4TLFw.jsx)("polygon", {
            points: "0,0 30,0 15,10"
        })
    });
});
$071bc6c0de1a7538$export$21b07c8f274aebd5.displayName = $071bc6c0de1a7538$var$NAME;
var $071bc6c0de1a7538$export$be92b6f5f03c0fe9 = $071bc6c0de1a7538$export$21b07c8f274aebd5;

});

parcelRegister("hfERT", function(module, exports) {

$parcel$export(module.exports, "createContextScope", function () { return $91a1926fdfc4de88$export$50c7b4e9d9f19c1; });
// packages/react/context/src/createContext.tsx

var $jbmdS = parcelRequire("jbmdS");

var $4TLFw = parcelRequire("4TLFw");
function $91a1926fdfc4de88$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $jbmdS.createContext(defaultContext);
    function Provider(props) {
        const { children: children, ...context } = props;
        const value = $jbmdS.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $4TLFw.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    }
    function useContext2(consumerName) {
        const context = $jbmdS.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext2
    ];
}
function $91a1926fdfc4de88$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $jbmdS.createContext(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope, children: children, ...context } = props;
            const Context = scope?.[scopeName][index] || BaseContext;
            const value = $jbmdS.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $4TLFw.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        }
        function useContext2(consumerName, scope) {
            const Context = scope?.[scopeName][index] || BaseContext;
            const context = $jbmdS.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $jbmdS.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = scope?.[scopeName] || scopeContexts;
            return $jbmdS.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $91a1926fdfc4de88$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function $91a1926fdfc4de88$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope, scopeName: scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $jbmdS.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}

});

parcelRegister("am0tV", function(module, exports) {

$parcel$export(module.exports, "useSize", function () { return $bbd3e39ee8069fc1$export$1ab7ae714698c4b8; });
// packages/react/use-size/src/useSize.tsx

var $jbmdS = parcelRequire("jbmdS");

var $9crHl = parcelRequire("9crHl");
function $bbd3e39ee8069fc1$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = $jbmdS.useState(void 0);
    (0, $9crHl.useLayoutEffect)(()=>{
        if (element) {
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ("borderBoxSize" in entry) {
                    const borderSizeEntry = entry["borderBoxSize"];
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize["inlineSize"];
                    height = borderSize["blockSize"];
                } else {
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return ()=>resizeObserver.unobserve(element);
        } else setSize(void 0);
    }, [
        element
    ]);
    return size;
}

});




parcelRegister("fEtu5", function(module, exports) {

$parcel$export(module.exports, "Checkbox", function () { return (parcelRequire("aEc4x")).Checkbox; });
$parcel$export(module.exports, "SmallDeleteButton", function () { return (parcelRequire("avIhR")).SmallDeleteButton; });
$parcel$export(module.exports, "NumberInputContainer", function () { return (parcelRequire("amISd")).NumberInputContainer; });
$parcel$export(module.exports, "FilterTextBox", function () { return (parcelRequire("e4TNX")).FilterTextBox; });
$parcel$export(module.exports, "Dropdown3", function () { return (parcelRequire("avIhR")).Dropdown3; });
$parcel$export(module.exports, "Dropdown3ListItem", function () { return (parcelRequire("avIhR")).Dropdown3ListItem; });
$parcel$export(module.exports, "HoursInput", function () { return (parcelRequire("y5iig")).HoursInput; });
$parcel$export(module.exports, "ErrorAlert", function () { return (parcelRequire("zyiwQ")).ErrorAlert; });
$parcel$export(module.exports, "SuccessAlert", function () { return (parcelRequire("zyiwQ")).SuccessAlert; });
parcelRequire("avIhR");
var $aEc4x = parcelRequire("aEc4x");
var $avIhR = parcelRequire("avIhR");
var $e4TNX = parcelRequire("e4TNX");
var $amISd = parcelRequire("amISd");

var $y5iig = parcelRequire("y5iig");

var $zyiwQ = parcelRequire("zyiwQ");

});
parcelRegister("avIhR", function(module, exports) {

$parcel$export(module.exports, "SmallDeleteButton", function () { return $01f988e3b6190229$export$a0e80aa7f086000b; });
$parcel$export(module.exports, "Dropdown3", function () { return $01f988e3b6190229$export$4187240375243742; });
$parcel$export(module.exports, "Dropdown3ListItem", function () { return $01f988e3b6190229$export$50c285dd13b92ac4; });
$parcel$export(module.exports, "NumberInputContainer", function () { return (parcelRequire("amISd")).NumberInputContainer; });
$parcel$export(module.exports, "FilterTextBox", function () { return (parcelRequire("e4TNX")).FilterTextBox; });
$parcel$export(module.exports, "Checkbox", function () { return (parcelRequire("aEc4x")).Checkbox; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("8mgS6");
parcelRequire("eBwNQ");

var $jbmdS = parcelRequire("jbmdS");

var $e64Mn = parcelRequire("e64Mn");
parcelRequire("jCNM0");

var $02LyB = parcelRequire("02LyB");
parcelRequire("cIuPI");

var $2MXkj = parcelRequire("2MXkj");

var $amISd = parcelRequire("amISd");

var $e4TNX = parcelRequire("e4TNX");

var $aEc4x = parcelRequire("aEc4x");
var $01f988e3b6190229$export$f4422ae58352e179 = (0, (/*@__PURE__*/$parcel$interopDefault($e64Mn)))({
    /**
  <RadioButton
    valueLink={this.linkState('variable')}
    identifier="value1"
  />
   is a shortcut for
   <RadioButton
    value={this.state.variable === 'value1'}
    onChange={function(checked) {
      if (checked) {
        self.setState({variable: 'value1'});
      }
    }}
  />
  */ propTypes: {
        label: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).node,
        value: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).bool,
        // `onChange` and `onSelected` are identical; `onSelected` is a better name
        // but `onChange` still exists for backward compatibility.
        onChange: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).func,
        onSelected: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).func,
        valueLink: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).object,
        identifier: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).any,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).string,
        name: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).string,
        disabled: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).bool
    },
    getDefaultProps: function() {
        return {
            className: "",
            disabled: false
        };
    },
    getInitialState: function() {
        return {};
    },
    render: function() {
        let value = this.props.valueLink != null ? this.props.valueLink.value === this.props.identifier : this.props.value;
        let disabled = this.props.disabled;
        //TODO-project_architect make this accessible
        return /*#__PURE__*/ (0, $61Ea1.jsxs)("label", {
            className: `coincraft-radio-button ${this.props.className}`,
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("coincraft-radio-button__square", {
                        checked: value
                    }),
                    style: {
                        cursor: disabled ? "default" : "pointer"
                    },
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
                            className: "coincraft-radio-button__input",
                            type: "radio",
                            name: this.props.name,
                            checked: value || "",
                            onChange: this.handleChange,
                            required: true,
                            disabled: disabled
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)("ins", {
                            className: "coincraft-radio-button__helper"
                        })
                    ]
                }),
                this.props.label
            ]
        });
    },
    handleChange: function(event) {
        if (!this.props.disabled) {
            if (this.props.valueLink != null) this.props.valueLink.requestChange(this.props.identifier);
            else {
                if (this.props.onChange != null) this.props.onChange(event.target.checked, event);
                if (this.props.onSelected != null) this.props.onSelected(event.target.checked, event);
            }
        }
    }
});
var $01f988e3b6190229$export$a0e80aa7f086000b = (0, (/*@__PURE__*/$parcel$interopDefault($e64Mn)))({
    propTypes: {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).string
    },
    getDefaultProps: function() {
        return {
            className: ""
        };
    },
    render: function() {
        var { className: className, ...props } = this.props;
        return /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("btn", "btn-default", "btn-sm", "delete-button", "size-[30px] flex items-center justify-center disabled:text-[#ccc]", className),
            ...props,
            children: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                className: "fa fa-times",
                style: {
                    marginRight: 0
                }
            })
        });
    }
});
const $01f988e3b6190229$export$4187240375243742 = ({ isExpanded: propsIsExpanded, onToggle: onToggle, contentStyle: contentStyle, containerStyle: containerStyle, onItemClick: onItemClick, dropLeft: dropLeft, toggleElement: toggleElement, children: children, className: className })=>{
    const [isExpanded, setIsExpanded] = (0, $jbmdS.useState)(propsIsExpanded || false);
    const dropdownRef = (0, $jbmdS.useRef)(null);
    const menuRef = (0, $jbmdS.useRef)(null);
    (0, $jbmdS.useEffect)(()=>{
        if (propsIsExpanded !== undefined) setIsExpanded(propsIsExpanded);
    }, [
        propsIsExpanded
    ]);
    (0, $jbmdS.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsExpanded(false);
                onToggle(false);
            }
        };
        if (isExpanded) document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        isExpanded,
        onToggle
    ]);
    (0, $jbmdS.useEffect)(()=>{
        if (isExpanded && menuRef.current) {
            const rect = dropdownRef.current.getBoundingClientRect();
            menuRef.current.style.top = `${rect.bottom}px`;
            menuRef.current.style.left = dropLeft ? "auto" : `${rect.left}px`;
            menuRef.current.style.right = dropLeft ? `${window.innerWidth - rect.right}px` : "auto";
        }
    }, [
        isExpanded,
        dropLeft
    ]);
    const handleToggle = (event)=>{
        event.stopPropagation();
        const newIsExpanded = !isExpanded;
        setIsExpanded(newIsExpanded);
        onToggle(newIsExpanded);
    };
    const handleItemClick = (identifier, event)=>{
        if (onItemClick) onItemClick(identifier, event);
        setIsExpanded(false);
        onToggle(false);
    };
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        ref: dropdownRef,
        style: {
            display: "inline-block",
            ...containerStyle
        },
        className: className,
        children: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).cloneElement(toggleElement, {
                onClick: handleToggle
            }),
            isExpanded && /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                ref: menuRef,
                style: {
                    position: "fixed",
                    zIndex: 1000,
                    backgroundColor: "white",
                    boxShadow: "0 6px 12px rgba(0,0,0,.175)",
                    border: "1px solid rgba(0,0,0,.15)",
                    ...contentStyle
                },
                children: (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).Children.map(children, (child, index)=>child && /*#__PURE__*/ (0, $61Ea1.jsx)($01f988e3b6190229$var$Dropdown3ListItemWrapper, {
                        onClick: (event)=>handleItemClick(child.props.identifier, event),
                        disabled: child.props.disabled,
                        item: child
                    }, index))
            })
        ]
    });
};
$01f988e3b6190229$export$4187240375243742.propTypes = {
    isExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).bool,
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).func,
    contentStyle: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).object,
    containerStyle: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).object,
    onItemClick: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).func,
    dropLeft: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).bool,
    toggleElement: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).element.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).node,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).string
};
$01f988e3b6190229$export$4187240375243742.defaultProps = {
    onToggle: ()=>{},
    dropLeft: false
};
const $01f988e3b6190229$var$Dropdown3ListItemWrapper = ({ onClick: onClick, item: item, disabled: disabled })=>{
    const handleClick = (event)=>{
        if (!disabled) onClick(event);
    };
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        onClick: handleClick,
        children: item
    });
};
$01f988e3b6190229$var$Dropdown3ListItemWrapper.propTypes = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).func.isRequired,
    item: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).node.isRequired,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).bool
};
const $01f988e3b6190229$export$50c285dd13b92ac4 = ({ children: children, style: style, disabled: disabled, onClick: onClick, ...props })=>{
    const [isHovered, setIsHovered] = (0, $jbmdS.useState)(false);
    const handleMouseOver = ()=>setIsHovered(true);
    const handleMouseOut = ()=>setIsHovered(false);
    const handleClick = ()=>{
        if (!disabled && onClick) onClick();
    };
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        style: {
            backgroundColor: isHovered ? "#eaeaea" : null,
            color: disabled ? "#aaa" : null,
            cursor: "pointer",
            padding: "0.5em 1em",
            ...style
        },
        onClick: handleClick,
        ...props,
        children: children
    });
};
$01f988e3b6190229$export$50c285dd13b92ac4.propTypes = {
    identifier: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).any,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).node,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).object,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).func
};
$01f988e3b6190229$export$50c285dd13b92ac4.defaultProps = {
    disabled: false
};

});
parcelRegister("e4TNX", function(module, exports) {

$parcel$export(module.exports, "FilterTextBox", function () { return $a3fcba16cdb5bd0e$export$c120c50c7e0a5eb0; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("jbmdS");

var $e64Mn = parcelRequire("e64Mn");

var $2MXkj = parcelRequire("2MXkj");

var $02LyB = parcelRequire("02LyB");
var $a3fcba16cdb5bd0e$export$c120c50c7e0a5eb0 = (0, (/*@__PURE__*/$parcel$interopDefault($e64Mn)))({
    propTypes: {
        value: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).string,
        onChange: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).func,
        placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).string,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).string
    },
    render: function() {
        return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            style: {
                ...this.props.style
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("relative flex items-center lg:w-[250px]", this.props.className),
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                    className: "fa fa-search absolute left-[1em] top-[calc(50%-0.5em)] p-0 m-0 h-[0.5em] w-[0.5em]"
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
                    type: "search",
                    className: "bg-transparent py-2 pl-9 pr-4 border border-white text-xs rounded-[6px] w-full text-white focus:outline-none cursor-text hover:bg-white/10",
                    value: this.props.value || "",
                    onChange: this.handleInputChange,
                    placeholder: this.props.placeholder
                }),
                this.props.value !== "" ? /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                    className: "text-xs absolute right-1.5 top-1/2 -translate-y-1/2 border px-2 py-1 rounded-[6px] hover:bg-white/10",
                    onClick: this.handleClearButtonClick,
                    children: "Clear"
                }) : null
            ]
        });
    },
    handleInputChange: function(event) {
        this.props.onChange(event.target.value);
    },
    handleClearButtonClick: function() {
        this.props.onChange("");
    }
});

});

parcelRegister("aEc4x", function(module, exports) {

$parcel$export(module.exports, "Checkbox", function () { return $7c070115efdc0743$export$48513f6b9f8ce62d; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("eBwNQ");
parcelRequire("jbmdS");

var $e64Mn = parcelRequire("e64Mn");

var $2MXkj = parcelRequire("2MXkj");
var $7c070115efdc0743$export$48513f6b9f8ce62d = (0, (/*@__PURE__*/$parcel$interopDefault($e64Mn)))({
    propTypes: {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).string,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).node,
        disabled: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).bool,
        labelPosition: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).oneOf([
            "left",
            "right"
        ]),
        // Either `valueLink` or (`value` and `onChange`).
        valueLink: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).object,
        value: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).bool,
        indeterminate: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).bool,
        /**
    * Usually you should use `onChange` and not `onClick`. Though if you want
    * to do an `event.stopPropagation`, use both: use `onChange` as normal and
    * additionally call `event.stopPropagation()` from `onClick`.  This is
    * because the `onClick` events of parents will be called before the
    * `onChange` event of this component.
    *
    * Ie.
     <Checkbox
      ...
      onChange={function(value, event) {
        // Do stuff with value (and optionally event) as normal
      }}
      onClick={function(event) {
        event.stopPropagation();
      }}
    />
    */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).func,
        onClick: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).func,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).string
    },
    getDefaultProps: function() {
        return {
            className: "",
            disabled: false,
            indeterminate: false,
            labelPosition: "right"
        };
    },
    getInitialState: function() {
        return {};
    },
    statics: {
        nextId: 1,
        getNextId: function() {
            return $7c070115efdc0743$export$48513f6b9f8ce62d.nextId++;
        }
    },
    render: function() {
        let id = this.props.id != null ? this.props.id : "coincraft-checkbox-" + $7c070115efdc0743$export$48513f6b9f8ce62d.getNextId();
        let value = this.props.valueLink != null ? this.props.valueLink.value : this.props.value;
        let checkbox = /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
            className: "coincraft-checkbox__input",
            id: id,
            type: "checkbox",
            checked: value || "",
            disabled: this.props.disabled,
            onChange: this.handleChange,
            onClick: this.props.onClick,
            style: {
                cursor: "pointer"
            },
            tabIndex: "0",
            ref: (input)=>{
                if (input) input.indeterminate = this.props.indeterminate;
            }
        });
        let label = this.props.label != null ? /*#__PURE__*/ (0, $61Ea1.jsx)("label", {
            htmlFor: id,
            className: `${this.props.labelPosition === "right" ? "ml-2.5" : "mr-2.5"}`,
            children: this.props.label
        }) : null;
        return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            className: `coincraft-checkbox ${this.props.className}`,
            style: {
                display: "inline-block",
                ...this.props.style
            },
            children: this.props.labelPosition === "right" ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "inline-flex flex-align-items-center",
                children: [
                    checkbox,
                    label
                ]
            }) : /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "inline-flex flex-align-items-center",
                children: [
                    label,
                    checkbox
                ]
            })
        });
    },
    handleChange: function(event) {
        if (!this.props.disabled) {
            if (this.props.valueLink != null) this.props.valueLink.requestChange(event.target.checked);
            else this.props.onChange(event.target.checked, event);
        }
    }
});

});


parcelRegister("zyiwQ", function(module, exports) {

$parcel$export(module.exports, "ErrorAlert", function () { return $06addfd68e84c837$export$6e469ba74eae4500; });
$parcel$export(module.exports, "SuccessAlert", function () { return $06addfd68e84c837$export$9c720f5a911bdbee; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("jbmdS");

var $e64Mn = parcelRequire("e64Mn");

var $02LyB = parcelRequire("02LyB");

var $2MXkj = parcelRequire("2MXkj");
var $06addfd68e84c837$export$caec2af78bcc877f = (0, (/*@__PURE__*/$parcel$interopDefault($e64Mn)))({
    /**
   * An `Alert` without an `alertType` is just a plain `div`; this is useful if
   * you have some content that might be inside an alert or might not.
   */ propTypes: {
        alertType: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).oneOf([
            "danger",
            "warning",
            "info",
            "success"
        ])
    },
    render: function() {
        let { className: className, children: children, alertType: alertType, ...props } = this.props;
        const actualClassName = alertType != null ? (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("alert", `alert-${alertType}`, className) : className;
        return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            className: actualClassName,
            ...props,
            children: children
        });
    }
});
var $06addfd68e84c837$export$6e469ba74eae4500 = (0, (/*@__PURE__*/$parcel$interopDefault($e64Mn)))({
    render: function() {
        return /*#__PURE__*/ (0, $61Ea1.jsx)($06addfd68e84c837$export$caec2af78bcc877f, {
            alertType: "danger",
            ...this.props
        });
    }
});
var $06addfd68e84c837$export$ee91ffc7d60a66d = (0, (/*@__PURE__*/$parcel$interopDefault($e64Mn)))({
    render: function() {
        return /*#__PURE__*/ (0, $61Ea1.jsx)($06addfd68e84c837$export$caec2af78bcc877f, {
            alertType: "warning",
            ...this.props
        });
    }
});
var $06addfd68e84c837$export$42ec9b3131d145b9 = (0, (/*@__PURE__*/$parcel$interopDefault($e64Mn)))({
    render: function() {
        return /*#__PURE__*/ (0, $61Ea1.jsx)($06addfd68e84c837$export$caec2af78bcc877f, {
            alertType: "info",
            ...this.props
        });
    }
});
var $06addfd68e84c837$export$9c720f5a911bdbee = (0, (/*@__PURE__*/$parcel$interopDefault($e64Mn)))({
    render: function() {
        return /*#__PURE__*/ (0, $61Ea1.jsx)($06addfd68e84c837$export$caec2af78bcc877f, {
            alertType: "success",
            ...this.props
        });
    }
});

});


parcelRegister("3X7oM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f693a2a80011245$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("02LyB");

var $jbmdS = parcelRequire("jbmdS");

var $95Evz = parcelRequire("95Evz");
const $7f693a2a80011245$var$HeaderButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).forwardRef(({ label: label, icon: icon, onClick: onClick, rightIcon: rightIcon, className: className, ...props }, ref)=>{
    const { variant: variant } = props;
    const primary = "border-white disabled:bg-white text-white disabled:text-[#444] hover:bg-white/25 max-w-max";
    const secondary = "hover:bg-[#e0e0e0] text-[#333] hover:border-[#adadad] border-[#ccc] bg-white";
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("button", {
        ...props,
        ref: ref,
        onClick: onClick,
        className: (0, $95Evz.cn)("flex items-center py-1.5 gap-2 px-4 border bg-transparent transition-colors rounded-[6px] relative disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none w-full whitespace-nowrap", variant === "secondary" ? secondary : primary, className && className),
        children: [
            icon,
            /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                className: "hover:text-black font-normal flex items-center flex-auto overflow-hidden text-ellipsis whitespace-nowrap text-[length:inherit]",
                children: label
            }),
            rightIcon
        ]
    });
});
$7f693a2a80011245$var$HeaderButton.displayName = "HeaderButton";
var $7f693a2a80011245$export$2e2bcd8739ae039 = $7f693a2a80011245$var$HeaderButton;

});

parcelRegister("80DmM", function(module, exports) {

$parcel$export(module.exports, "DatePicker", function () { return $e397b7f558eab11a$export$5109c6dd95d8fb00; });

var $61Ea1 = parcelRequire("61Ea1");

var $ffYB6 = parcelRequire("ffYB6");

var $Yha9m = parcelRequire("Yha9m");

var $2YJBX = parcelRequire("2YJBX");

var $8orVP = parcelRequire("8orVP");

var $l4nwI = parcelRequire("l4nwI");

var $jbmdS = parcelRequire("jbmdS");

var $fJ4T4 = parcelRequire("fJ4T4");

var $8oaA5 = parcelRequire("8oaA5");
function $e397b7f558eab11a$export$5109c6dd95d8fb00({ value: value, onChange: onChange, className: className, popoverClassName: popoverClassName }) {
    const [open, setOpen] = (0, $jbmdS.useState)(false);
    const inputRef = (0, $jbmdS.useRef)(null);
    const [month, setMonth] = (0, $jbmdS.useState)(value || new Date());
    const [inputValue, setInputValue] = (0, $jbmdS.useState)(value ? (0, $fJ4T4.FormatDate)(value, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
    }) : "");
    (0, $jbmdS.useEffect)(()=>{
        if (open) {
            // Use a small delay to ensure the input gets focus after the popover opens
            const timeoutId = setTimeout(()=>{
                var _inputRef$current;
                (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
            }, 0);
            return ()=>clearTimeout(timeoutId);
        }
    }, [
        open
    ]);
    const handleSelect = (date)=>{
        var _inputRef$current2;
        onChange(date);
        setInputValue(date ? (0, $fJ4T4.FormatDate)(date, {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        }) : "");
        (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.focus();
    };
    const handleInputChange = (e)=>{
        var _parsedDate$getTime;
        setInputValue(e.target.value);
        const parsedDate = (0, $8oaA5.ParseDate)(e.target.value);
        if (!isNaN(parsedDate === null || parsedDate === void 0 ? void 0 : (_parsedDate$getTime = parsedDate.getTime) === null || _parsedDate$getTime === void 0 ? void 0 : _parsedDate$getTime.call(parsedDate))) {
            onChange(parsedDate);
            setMonth(parsedDate);
        }
    };
    const handleInputClick = (e)=>{
        // If the input is already focused, prevent the click from bubbling
        // up to the PopoverTrigger to avoid toggling the calendar
        if (open && document.activeElement === inputRef.current) e.stopPropagation();
    };
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $l4nwI.Popover), {
        open: open,
        onOpenChange: setOpen,
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $l4nwI.PopoverTrigger), {
                asChild: true,
                children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    className: "relative",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $2YJBX.Input), {
                            ref: inputRef,
                            type: "text",
                            value: inputValue,
                            onChange: handleInputChange,
                            onClick: handleInputClick,
                            placeholder: "Pick a date",
                            className: (0, $Yha9m.cn)("pl-10", !value && "text-muted-foreground", className)
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ffYB6.default), {
                            className: "absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $l4nwI.PopoverContent), {
                className: (0, $Yha9m.cn)("w-auto p-0", popoverClassName),
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8orVP.Calendar), {
                    mode: "single",
                    selected: value,
                    onSelect: handleSelect,
                    month: month,
                    onMonthChange: setMonth
                })
            })
        ]
    });
}
var $e397b7f558eab11a$export$2e2bcd8739ae039 = $e397b7f558eab11a$export$5109c6dd95d8fb00;

});
parcelRegister("ffYB6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1b7431faf1c8ed9$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $b1b7431faf1c8ed9$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("Calendar", [
    [
        "path",
        {
            d: "M8 2v4",
            key: "1cmpym"
        }
    ],
    [
        "path",
        {
            d: "M16 2v4",
            key: "4m81vk"
        }
    ],
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "4",
            rx: "2",
            key: "1hopcy"
        }
    ],
    [
        "path",
        {
            d: "M3 10h18",
            key: "8toen8"
        }
    ]
]);

});

parcelRegister("8orVP", function(module, exports) {

$parcel$export(module.exports, "Calendar", function () { return $e549bdb35c203219$export$e1aef45b828286de; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $6VWxL = parcelRequire("6VWxL");
var $ahXOC = parcelRequire("ahXOC");

var $cdlXd = parcelRequire("cdlXd");

var $3Gs4l = parcelRequire("3Gs4l");

var $fTGwv = parcelRequire("fTGwv");

var $Yha9m = parcelRequire("Yha9m");
function $e549bdb35c203219$export$e1aef45b828286de({ className: className, classNames: classNames, showOutsideDays: showOutsideDays = true, ...props }) {
    let [month, setMonth] = $jbmdS.useState(new Date());
    month = props.month || month;
    setMonth = props.onMonthChange || setMonth;
    // Create arrays for months and years
    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];
    const years = Array.from({
        length: 16
    }, (_, i)=>new Date().getFullYear() - 10 + i);
    // Handlers for month and year selection
    const handleMonthSelect = (value)=>{
        const newMonth = new Date(month.setMonth(months.indexOf(value)));
        setMonth(newMonth);
    };
    const handleYearSelect = (value)=>{
        const newDate = new Date(month.setFullYear(parseInt(value)));
        setMonth(newDate);
    };
    const handlePreviousMonth = ()=>{
        const previousMonth = new Date(month);
        previousMonth.setMonth(previousMonth.getMonth() - 1);
        setMonth(previousMonth);
    };
    const handleNextMonth = ()=>{
        const nextMonth = new Date(month);
        nextMonth.setMonth(nextMonth.getMonth() + 1);
        setMonth(nextMonth);
    };
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $cdlXd.DayPicker), {
        showOutsideDays: showOutsideDays,
        className: (0, $Yha9m.cn)("p-3", className),
        month: month,
        onMonthChange: setMonth,
        classNames: {
            months: "flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0",
            month: "space-y-4",
            caption: "flex justify-center pt-1 relative items-center",
            caption_label: "text-sm font-medium flex space-x-2",
            nav: "space-x-1 flex items-center",
            nav_button: (0, $Yha9m.cn)((0, $fTGwv.buttonVariants)({
                variant: "outline"
            }), "h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100"),
            nav_button_previous: "absolute left-1",
            nav_button_next: "absolute right-1",
            table: "w-full border-collapse space-y-1",
            head_row: "flex justify-between px-4",
            head_cell: "text-muted-foreground rounded-md w-9 font-normal text-[0.8rem]",
            row: "flex w-full justify-between mt-2 px-4",
            cell: "h-9 w-9 text-center text-sm p-0 relative [&:has([aria-selected].day-range-end)]:rounded-r-md [&:has([aria-selected].day-outside)]:bg-accent/50 [&:has([aria-selected])]:bg-accent first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md focus-within:relative focus-within:z-20",
            day: (0, $Yha9m.cn)((0, $fTGwv.buttonVariants)({
                variant: "ghost"
            }), "h-9 w-9 p-0 font-normal aria-selected:opacity-100"),
            day_range_end: "day-range-end",
            day_selected: "bg-primary text-primary-foreground hover:bg-primary hover:text-primary-foreground focus:bg-primary focus:text-primary-foreground",
            day_today: "bg-accent text-accent-foreground",
            day_outside: "day-outside text-muted-foreground opacity-50 aria-selected:bg-accent/50 aria-selected:text-muted-foreground aria-selected:opacity-30",
            day_disabled: "text-muted-foreground opacity-50",
            day_range_middle: "aria-selected:bg-accent aria-selected:text-accent-foreground",
            day_hidden: "invisible",
            ...classNames
        },
        components: {
            Caption: ({ displayMonth: displayMonth })=>/*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    className: "flex justify-center space-x-2 items-center",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fTGwv.Button), {
                            variant: "ghost",
                            className: "h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100",
                            onClick: handlePreviousMonth,
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6VWxL.default), {
                                className: "h-4 w-4"
                            })
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            className: "relative",
                            children: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $3Gs4l.Select), {
                                value: months[displayMonth.getMonth()],
                                onValueChange: handleMonthSelect,
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3Gs4l.SelectTrigger), {
                                        className: "w-[120px] h-8",
                                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3Gs4l.SelectValue), {})
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3Gs4l.SelectContent), {
                                        ref: (ref)=>{
                                            if (ref) ref.style.zIndex = "9999999999";
                                        },
                                        children: months.map((month)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $3Gs4l.SelectItem), {
                                                value: month,
                                                children: month
                                            }, month))
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            className: "relative",
                            children: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $3Gs4l.Select), {
                                value: displayMonth.getFullYear().toString(),
                                onValueChange: handleYearSelect,
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3Gs4l.SelectTrigger), {
                                        className: "w-[90px] h-8",
                                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3Gs4l.SelectValue), {})
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3Gs4l.SelectContent), {
                                        ref: (ref)=>{
                                            if (ref) ref.style.zIndex = "9999999999";
                                        },
                                        children: years.map((year)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $3Gs4l.SelectItem), {
                                                value: year.toString(),
                                                children: year
                                            }, year))
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fTGwv.Button), {
                            variant: "ghost",
                            className: "h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100",
                            onClick: handleNextMonth,
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ahXOC.default), {
                                className: "h-4 w-4"
                            })
                        })
                    ]
                })
        },
        ...props
    });
}
$e549bdb35c203219$export$e1aef45b828286de.displayName = "Calendar";

});
parcelRegister("6VWxL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50c57a8150eb990e$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $50c57a8150eb990e$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("ChevronLeft", [
    [
        "path",
        {
            d: "m15 18-6-6 6-6",
            key: "1wnfg3"
        }
    ]
]);

});

parcelRegister("ahXOC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77d9e407fde9b530$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $77d9e407fde9b530$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("ChevronRight", [
    [
        "path",
        {
            d: "m9 18 6-6-6-6",
            key: "mthhwq"
        }
    ]
]);

});

parcelRegister("cdlXd", function(module, exports) {

$parcel$export(module.exports, "DayPicker", function () { return $8e47ba8d561bde0d$export$97e6db89a86ff7ab; });

var $4TLFw = parcelRequire("4TLFw");

var $jbmdS = parcelRequire("jbmdS");

var $4hBm1 = parcelRequire("4hBm1");

var $aBC3c = parcelRequire("aBC3c");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $8e47ba8d561bde0d$var$__assign = function() {
    $8e47ba8d561bde0d$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8e47ba8d561bde0d$var$__assign.apply(this, arguments);
};
function $8e47ba8d561bde0d$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $8e47ba8d561bde0d$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" && SuppressedError;
/** Returns true when the props are of type {@link DayPickerMultipleProps}. */ function $8e47ba8d561bde0d$export$2d8c2b43ec0e528(props) {
    return props.mode === "multiple";
}
/** Returns true when the props are of type {@link DayPickerRangeProps}. */ function $8e47ba8d561bde0d$export$f7b9f96866ec1964(props) {
    return props.mode === "range";
}
/** Returns true when the props are of type {@link DayPickerSingleProps}. */ function $8e47ba8d561bde0d$export$e659ce9b264ea61(props) {
    return props.mode === "single";
}
/**
 * The name of the default CSS classes.
 */ var $8e47ba8d561bde0d$var$defaultClassNames = {
    root: "rdp",
    multiple_months: "rdp-multiple_months",
    with_weeknumber: "rdp-with_weeknumber",
    vhidden: "rdp-vhidden",
    button_reset: "rdp-button_reset",
    button: "rdp-button",
    caption: "rdp-caption",
    caption_start: "rdp-caption_start",
    caption_end: "rdp-caption_end",
    caption_between: "rdp-caption_between",
    caption_label: "rdp-caption_label",
    caption_dropdowns: "rdp-caption_dropdowns",
    dropdown: "rdp-dropdown",
    dropdown_month: "rdp-dropdown_month",
    dropdown_year: "rdp-dropdown_year",
    dropdown_icon: "rdp-dropdown_icon",
    months: "rdp-months",
    month: "rdp-month",
    table: "rdp-table",
    tbody: "rdp-tbody",
    tfoot: "rdp-tfoot",
    head: "rdp-head",
    head_row: "rdp-head_row",
    head_cell: "rdp-head_cell",
    nav: "rdp-nav",
    nav_button: "rdp-nav_button",
    nav_button_previous: "rdp-nav_button_previous",
    nav_button_next: "rdp-nav_button_next",
    nav_icon: "rdp-nav_icon",
    row: "rdp-row",
    weeknumber: "rdp-weeknumber",
    cell: "rdp-cell",
    day: "rdp-day",
    day_today: "rdp-day_today",
    day_outside: "rdp-day_outside",
    day_selected: "rdp-day_selected",
    day_disabled: "rdp-day_disabled",
    day_hidden: "rdp-day_hidden",
    day_range_start: "rdp-day_range_start",
    day_range_end: "rdp-day_range_end",
    day_range_middle: "rdp-day_range_middle"
};
/**
 * The default formatter for the caption.
 */ function $8e47ba8d561bde0d$var$formatCaption(month, options) {
    return (0, $4hBm1.format)(month, "LLLL y", options);
}
/**
 * The default formatter for the Day button.
 */ function $8e47ba8d561bde0d$var$formatDay(day, options) {
    return (0, $4hBm1.format)(day, "d", options);
}
/**
 * The default formatter for the Month caption.
 */ function $8e47ba8d561bde0d$var$formatMonthCaption(month, options) {
    return (0, $4hBm1.format)(month, "LLLL", options);
}
/**
 * The default formatter for the week number.
 */ function $8e47ba8d561bde0d$var$formatWeekNumber(weekNumber) {
    return "".concat(weekNumber);
}
/**
 * The default formatter for the name of the weekday.
 */ function $8e47ba8d561bde0d$var$formatWeekdayName(weekday, options) {
    return (0, $4hBm1.format)(weekday, "cccccc", options);
}
/**
 * The default formatter for the Year caption.
 */ function $8e47ba8d561bde0d$var$formatYearCaption(year, options) {
    return (0, $4hBm1.format)(year, "yyyy", options);
}
var $8e47ba8d561bde0d$var$formatters = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    formatCaption: $8e47ba8d561bde0d$var$formatCaption,
    formatDay: $8e47ba8d561bde0d$var$formatDay,
    formatMonthCaption: $8e47ba8d561bde0d$var$formatMonthCaption,
    formatWeekNumber: $8e47ba8d561bde0d$var$formatWeekNumber,
    formatWeekdayName: $8e47ba8d561bde0d$var$formatWeekdayName,
    formatYearCaption: $8e47ba8d561bde0d$var$formatYearCaption
});
/**
 * The default ARIA label for the day button.
 */ var $8e47ba8d561bde0d$var$labelDay = function(day, activeModifiers, options) {
    return (0, $4hBm1.format)(day, "do MMMM (EEEE)", options);
};
/**
 * The default ARIA label for the WeekNumber element.
 */ var $8e47ba8d561bde0d$var$labelMonthDropdown = function() {
    return "Month: ";
};
/**
 * The default ARIA label for next month button in navigation
 */ var $8e47ba8d561bde0d$var$labelNext = function() {
    return "Go to next month";
};
/**
 * The default ARIA label for previous month button in navigation
 */ var $8e47ba8d561bde0d$var$labelPrevious = function() {
    return "Go to previous month";
};
/**
 * The default ARIA label for the Weekday element.
 */ var $8e47ba8d561bde0d$var$labelWeekday = function(day, options) {
    return (0, $4hBm1.format)(day, "cccc", options);
};
/**
 * The default ARIA label for the WeekNumber element.
 */ var $8e47ba8d561bde0d$var$labelWeekNumber = function(n) {
    return "Week n. ".concat(n);
};
/**
 * The default ARIA label for the WeekNumber element.
 */ var $8e47ba8d561bde0d$var$labelYearDropdown = function() {
    return "Year: ";
};
var $8e47ba8d561bde0d$var$labels = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    labelDay: $8e47ba8d561bde0d$var$labelDay,
    labelMonthDropdown: $8e47ba8d561bde0d$var$labelMonthDropdown,
    labelNext: $8e47ba8d561bde0d$var$labelNext,
    labelPrevious: $8e47ba8d561bde0d$var$labelPrevious,
    labelWeekNumber: $8e47ba8d561bde0d$var$labelWeekNumber,
    labelWeekday: $8e47ba8d561bde0d$var$labelWeekday,
    labelYearDropdown: $8e47ba8d561bde0d$var$labelYearDropdown
});
/**
 * Returns the default values to use in the DayPickerContext, in case they are
 * not passed down with the DayPicker initial props.
 */ function $8e47ba8d561bde0d$var$getDefaultContextValues() {
    var captionLayout = "buttons";
    var classNames = $8e47ba8d561bde0d$var$defaultClassNames;
    var locale = (0, $aBC3c.enUS);
    var modifiersClassNames = {};
    var modifiers = {};
    var numberOfMonths = 1;
    var styles = {};
    var today = new Date();
    return {
        captionLayout: captionLayout,
        classNames: classNames,
        formatters: $8e47ba8d561bde0d$var$formatters,
        labels: $8e47ba8d561bde0d$var$labels,
        locale: locale,
        modifiersClassNames: modifiersClassNames,
        modifiers: modifiers,
        numberOfMonths: numberOfMonths,
        styles: styles,
        today: today,
        mode: "default"
    };
}
/** Return the `fromDate` and `toDate` prop values values parsing the DayPicker props. */ function $8e47ba8d561bde0d$var$parseFromToProps(props) {
    var fromYear = props.fromYear, toYear = props.toYear, fromMonth = props.fromMonth, toMonth = props.toMonth;
    var fromDate = props.fromDate, toDate = props.toDate;
    if (fromMonth) fromDate = (0, $4hBm1.startOfMonth)(fromMonth);
    else if (fromYear) fromDate = new Date(fromYear, 0, 1);
    if (toMonth) toDate = (0, $4hBm1.endOfMonth)(toMonth);
    else if (toYear) toDate = new Date(toYear, 11, 31);
    return {
        fromDate: fromDate ? (0, $4hBm1.startOfDay)(fromDate) : undefined,
        toDate: toDate ? (0, $4hBm1.startOfDay)(toDate) : undefined
    };
}
/**
 * The DayPicker context shares the props passed to DayPicker within internal
 * and custom components. It is used to set the default values and perform
 * one-time calculations required to render the days.
 *
 * Access to this context from the {@link useDayPicker} hook.
 */ var $8e47ba8d561bde0d$export$5e463664ac32e9a9 = (0, $jbmdS.createContext)(undefined);
/**
 * The provider for the {@link DayPickerContext}, assigning the defaults from the
 * initial DayPicker props.
 */ function $8e47ba8d561bde0d$export$a84f964d022d25c(props) {
    var _a;
    var initialProps = props.initialProps;
    var defaultContextValues = $8e47ba8d561bde0d$var$getDefaultContextValues();
    var _b = $8e47ba8d561bde0d$var$parseFromToProps(initialProps), fromDate = _b.fromDate, toDate = _b.toDate;
    var captionLayout = (_a = initialProps.captionLayout) !== null && _a !== void 0 ? _a : defaultContextValues.captionLayout;
    if (captionLayout !== "buttons" && (!fromDate || !toDate)) // When no from/to dates are set, the caption is always buttons
    captionLayout = "buttons";
    var onSelect;
    if ($8e47ba8d561bde0d$export$e659ce9b264ea61(initialProps) || $8e47ba8d561bde0d$export$2d8c2b43ec0e528(initialProps) || $8e47ba8d561bde0d$export$f7b9f96866ec1964(initialProps)) onSelect = initialProps.onSelect;
    var value = $8e47ba8d561bde0d$var$__assign($8e47ba8d561bde0d$var$__assign($8e47ba8d561bde0d$var$__assign({}, defaultContextValues), initialProps), {
        captionLayout: captionLayout,
        classNames: $8e47ba8d561bde0d$var$__assign($8e47ba8d561bde0d$var$__assign({}, defaultContextValues.classNames), initialProps.classNames),
        components: $8e47ba8d561bde0d$var$__assign({}, initialProps.components),
        formatters: $8e47ba8d561bde0d$var$__assign($8e47ba8d561bde0d$var$__assign({}, defaultContextValues.formatters), initialProps.formatters),
        fromDate: fromDate,
        labels: $8e47ba8d561bde0d$var$__assign($8e47ba8d561bde0d$var$__assign({}, defaultContextValues.labels), initialProps.labels),
        mode: initialProps.mode || defaultContextValues.mode,
        modifiers: $8e47ba8d561bde0d$var$__assign($8e47ba8d561bde0d$var$__assign({}, defaultContextValues.modifiers), initialProps.modifiers),
        modifiersClassNames: $8e47ba8d561bde0d$var$__assign($8e47ba8d561bde0d$var$__assign({}, defaultContextValues.modifiersClassNames), initialProps.modifiersClassNames),
        onSelect: onSelect,
        styles: $8e47ba8d561bde0d$var$__assign($8e47ba8d561bde0d$var$__assign({}, defaultContextValues.styles), initialProps.styles),
        toDate: toDate
    });
    return (0, $4TLFw.jsx)($8e47ba8d561bde0d$export$5e463664ac32e9a9.Provider, {
        value: value,
        children: props.children
    });
}
/**
 * Hook to access the {@link DayPickerContextValue}.
 *
 * Use the DayPicker context to access to the props passed to DayPicker inside
 * internal or custom components.
 */ function $8e47ba8d561bde0d$export$332e9e0d64b1f294() {
    var context = (0, $jbmdS.useContext)($8e47ba8d561bde0d$export$5e463664ac32e9a9);
    if (!context) throw new Error("useDayPicker must be used within a DayPickerProvider.");
    return context;
}
/** Render the caption for the displayed month. This component is used when `captionLayout="buttons"`. */ function $8e47ba8d561bde0d$export$5b9f95302ae85eba(props) {
    var _a = $8e47ba8d561bde0d$export$332e9e0d64b1f294(), locale = _a.locale, classNames = _a.classNames, styles = _a.styles, formatCaption = _a.formatters.formatCaption;
    return (0, $4TLFw.jsx)("div", {
        className: classNames.caption_label,
        style: styles.caption_label,
        "aria-live": "polite",
        role: "presentation",
        id: props.id,
        children: formatCaption(props.displayMonth, {
            locale: locale
        })
    });
}
/**
 * Render the icon in the styled drop-down.
 */ function $8e47ba8d561bde0d$export$eaf28e65c2d9267c(props) {
    return (0, $4TLFw.jsx)("svg", $8e47ba8d561bde0d$var$__assign({
        width: "8px",
        height: "8px",
        viewBox: "0 0 120 120",
        "data-testid": "iconDropdown"
    }, props, {
        children: (0, $4TLFw.jsx)("path", {
            d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z",
            fill: "currentColor",
            fillRule: "nonzero"
        })
    }));
}
/**
 * Render a styled select component – displaying a caption and a custom
 * drop-down icon.
 */ function $8e47ba8d561bde0d$export$931cbfb6bfb85fc(props) {
    var _a, _b;
    var onChange = props.onChange, value = props.value, children = props.children, caption = props.caption, className = props.className, style = props.style;
    var dayPicker = $8e47ba8d561bde0d$export$332e9e0d64b1f294();
    var IconDropdownComponent = (_b = (_a = dayPicker.components) === null || _a === void 0 ? void 0 : _a.IconDropdown) !== null && _b !== void 0 ? _b : $8e47ba8d561bde0d$export$eaf28e65c2d9267c;
    return (0, $4TLFw.jsxs)("div", {
        className: className,
        style: style,
        children: [
            (0, $4TLFw.jsx)("span", {
                className: dayPicker.classNames.vhidden,
                children: props["aria-label"]
            }),
            (0, $4TLFw.jsx)("select", {
                name: props.name,
                "aria-label": props["aria-label"],
                className: dayPicker.classNames.dropdown,
                style: dayPicker.styles.dropdown,
                value: value,
                onChange: onChange,
                children: children
            }),
            (0, $4TLFw.jsxs)("div", {
                className: dayPicker.classNames.caption_label,
                style: dayPicker.styles.caption_label,
                "aria-hidden": "true",
                children: [
                    caption,
                    (0, $4TLFw.jsx)(IconDropdownComponent, {
                        className: dayPicker.classNames.dropdown_icon,
                        style: dayPicker.styles.dropdown_icon
                    })
                ]
            })
        ]
    });
}
/** Render the dropdown to navigate between months. */ function $8e47ba8d561bde0d$var$MonthsDropdown(props) {
    var _a;
    var _b = $8e47ba8d561bde0d$export$332e9e0d64b1f294(), fromDate = _b.fromDate, toDate = _b.toDate, styles = _b.styles, locale = _b.locale, formatMonthCaption = _b.formatters.formatMonthCaption, classNames = _b.classNames, components = _b.components, labelMonthDropdown = _b.labels.labelMonthDropdown;
    // Dropdown should appear only when both from/toDate is set
    if (!fromDate) return (0, $4TLFw.jsx)((0, $4TLFw.Fragment), {});
    if (!toDate) return (0, $4TLFw.jsx)((0, $4TLFw.Fragment), {});
    var dropdownMonths = [];
    if ((0, $4hBm1.isSameYear)(fromDate, toDate)) {
        // only display the months included in the range
        var date = (0, $4hBm1.startOfMonth)(fromDate);
        for(var month = fromDate.getMonth(); month <= toDate.getMonth(); month++)dropdownMonths.push((0, $4hBm1.setMonth)(date, month));
    } else {
        // display all the 12 months
        var date = (0, $4hBm1.startOfMonth)(new Date()); // Any date should be OK, as we just need the year
        for(var month = 0; month <= 11; month++)dropdownMonths.push((0, $4hBm1.setMonth)(date, month));
    }
    var handleChange = function(e) {
        var selectedMonth = Number(e.target.value);
        var newMonth = (0, $4hBm1.setMonth)((0, $4hBm1.startOfMonth)(props.displayMonth), selectedMonth);
        props.onChange(newMonth);
    };
    var DropdownComponent = (_a = components === null || components === void 0 ? void 0 : components.Dropdown) !== null && _a !== void 0 ? _a : $8e47ba8d561bde0d$export$931cbfb6bfb85fc;
    return (0, $4TLFw.jsx)(DropdownComponent, {
        name: "months",
        "aria-label": labelMonthDropdown(),
        className: classNames.dropdown_month,
        style: styles.dropdown_month,
        onChange: handleChange,
        value: props.displayMonth.getMonth(),
        caption: formatMonthCaption(props.displayMonth, {
            locale: locale
        }),
        children: dropdownMonths.map(function(m) {
            return (0, $4TLFw.jsx)("option", {
                value: m.getMonth(),
                children: formatMonthCaption(m, {
                    locale: locale
                })
            }, m.getMonth());
        })
    });
}
/**
 * Render a dropdown to change the year. Take in account the `nav.fromDate` and
 * `toDate` from context.
 */ function $8e47ba8d561bde0d$var$YearsDropdown(props) {
    var _a;
    var displayMonth = props.displayMonth;
    var _b = $8e47ba8d561bde0d$export$332e9e0d64b1f294(), fromDate = _b.fromDate, toDate = _b.toDate, locale = _b.locale, styles = _b.styles, classNames = _b.classNames, components = _b.components, formatYearCaption = _b.formatters.formatYearCaption, labelYearDropdown = _b.labels.labelYearDropdown;
    var years = [];
    // Dropdown should appear only when both from/toDate is set
    if (!fromDate) return (0, $4TLFw.jsx)((0, $4TLFw.Fragment), {});
    if (!toDate) return (0, $4TLFw.jsx)((0, $4TLFw.Fragment), {});
    var fromYear = fromDate.getFullYear();
    var toYear = toDate.getFullYear();
    for(var year = fromYear; year <= toYear; year++)years.push((0, $4hBm1.setYear)((0, $4hBm1.startOfYear)(new Date()), year));
    var handleChange = function(e) {
        var newMonth = (0, $4hBm1.setYear)((0, $4hBm1.startOfMonth)(displayMonth), Number(e.target.value));
        props.onChange(newMonth);
    };
    var DropdownComponent = (_a = components === null || components === void 0 ? void 0 : components.Dropdown) !== null && _a !== void 0 ? _a : $8e47ba8d561bde0d$export$931cbfb6bfb85fc;
    return (0, $4TLFw.jsx)(DropdownComponent, {
        name: "years",
        "aria-label": labelYearDropdown(),
        className: classNames.dropdown_year,
        style: styles.dropdown_year,
        onChange: handleChange,
        value: displayMonth.getFullYear(),
        caption: formatYearCaption(displayMonth, {
            locale: locale
        }),
        children: years.map(function(year) {
            return (0, $4TLFw.jsx)("option", {
                value: year.getFullYear(),
                children: formatYearCaption(year, {
                    locale: locale
                })
            }, year.getFullYear());
        })
    });
}
/**
 * Helper hook for using controlled/uncontrolled values from a component props.
 *
 * When the value is not controlled, pass `undefined` as `controlledValue` and
 * use the returned setter to update it.
 *
 * When the value is controlled, pass the controlled value as second
 * argument, which will be always returned as `value`.
 */ function $8e47ba8d561bde0d$var$useControlledValue(defaultValue, controlledValue) {
    var _a = (0, $jbmdS.useState)(defaultValue), uncontrolledValue = _a[0], setValue = _a[1];
    var value = controlledValue === undefined ? uncontrolledValue : controlledValue;
    return [
        value,
        setValue
    ];
}
/** Return the initial month according to the given options. */ function $8e47ba8d561bde0d$var$getInitialMonth(context) {
    var month = context.month, defaultMonth = context.defaultMonth, today = context.today;
    var initialMonth = month || defaultMonth || today || new Date();
    var toDate = context.toDate, fromDate = context.fromDate, _a = context.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    // Fix the initialMonth if is after the to-date
    if (toDate && (0, $4hBm1.differenceInCalendarMonths)(toDate, initialMonth) < 0) {
        var offset = -1 * (numberOfMonths - 1);
        initialMonth = (0, $4hBm1.addMonths)(toDate, offset);
    }
    // Fix the initialMonth if is before the from-date
    if (fromDate && (0, $4hBm1.differenceInCalendarMonths)(initialMonth, fromDate) < 0) initialMonth = fromDate;
    return (0, $4hBm1.startOfMonth)(initialMonth);
}
/** Controls the navigation state. */ function $8e47ba8d561bde0d$var$useNavigationState() {
    var context = $8e47ba8d561bde0d$export$332e9e0d64b1f294();
    var initialMonth = $8e47ba8d561bde0d$var$getInitialMonth(context);
    var _a = $8e47ba8d561bde0d$var$useControlledValue(initialMonth, context.month), month = _a[0], setMonth = _a[1];
    var goToMonth = function(date) {
        var _a;
        if (context.disableNavigation) return;
        var month = (0, $4hBm1.startOfMonth)(date);
        setMonth(month);
        (_a = context.onMonthChange) === null || _a === void 0 || _a.call(context, month);
    };
    return [
        month,
        goToMonth
    ];
}
/**
 * Return the months to display in the component according to the number of
 * months and the from/to date.
 */ function $8e47ba8d561bde0d$var$getDisplayMonths(month, _a) {
    var reverseMonths = _a.reverseMonths, numberOfMonths = _a.numberOfMonths;
    var start = (0, $4hBm1.startOfMonth)(month);
    var end = (0, $4hBm1.startOfMonth)((0, $4hBm1.addMonths)(start, numberOfMonths));
    var monthsDiff = (0, $4hBm1.differenceInCalendarMonths)(end, start);
    var months = [];
    for(var i = 0; i < monthsDiff; i++){
        var nextMonth = (0, $4hBm1.addMonths)(start, i);
        months.push(nextMonth);
    }
    if (reverseMonths) months = months.reverse();
    return months;
}
/**
 * Returns the next month the user can navigate to according to the given
 * options.
 *
 * Please note that the next month is not always the next calendar month:
 *
 * - if after the `toDate` range, is undefined;
 * - if the navigation is paged, is the number of months displayed ahead.
 *
 */ function $8e47ba8d561bde0d$var$getNextMonth(startingMonth, options) {
    if (options.disableNavigation) return undefined;
    var toDate = options.toDate, pagedNavigation = options.pagedNavigation, _a = options.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    var offset = pagedNavigation ? numberOfMonths : 1;
    var month = (0, $4hBm1.startOfMonth)(startingMonth);
    if (!toDate) return (0, $4hBm1.addMonths)(month, offset);
    var monthsDiff = (0, $4hBm1.differenceInCalendarMonths)(toDate, startingMonth);
    if (monthsDiff < numberOfMonths) return undefined;
    // Jump forward as the number of months when paged navigation
    return (0, $4hBm1.addMonths)(month, offset);
}
/**
 * Returns the next previous the user can navigate to, according to the given
 * options.
 *
 * Please note that the previous month is not always the previous calendar
 * month:
 *
 * - if before the `fromDate` date, is `undefined`;
 * - if the navigation is paged, is the number of months displayed before.
 *
 */ function $8e47ba8d561bde0d$var$getPreviousMonth(startingMonth, options) {
    if (options.disableNavigation) return undefined;
    var fromDate = options.fromDate, pagedNavigation = options.pagedNavigation, _a = options.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    var offset = pagedNavigation ? numberOfMonths : 1;
    var month = (0, $4hBm1.startOfMonth)(startingMonth);
    if (!fromDate) return (0, $4hBm1.addMonths)(month, -offset);
    var monthsDiff = (0, $4hBm1.differenceInCalendarMonths)(month, fromDate);
    if (monthsDiff <= 0) return undefined;
    // Jump back as the number of months when paged navigation
    return (0, $4hBm1.addMonths)(month, -offset);
}
/**
 * The Navigation context shares details and methods to navigate the months in DayPicker.
 * Access this context from the {@link useNavigation} hook.
 */ var $8e47ba8d561bde0d$export$3044ab7fdabeaee6 = (0, $jbmdS.createContext)(undefined);
/** Provides the values for the {@link NavigationContext}. */ function $8e47ba8d561bde0d$export$d91daf425539f32f(props) {
    var dayPicker = $8e47ba8d561bde0d$export$332e9e0d64b1f294();
    var _a = $8e47ba8d561bde0d$var$useNavigationState(), currentMonth = _a[0], goToMonth = _a[1];
    var displayMonths = $8e47ba8d561bde0d$var$getDisplayMonths(currentMonth, dayPicker);
    var nextMonth = $8e47ba8d561bde0d$var$getNextMonth(currentMonth, dayPicker);
    var previousMonth = $8e47ba8d561bde0d$var$getPreviousMonth(currentMonth, dayPicker);
    var isDateDisplayed = function(date) {
        return displayMonths.some(function(displayMonth) {
            return (0, $4hBm1.isSameMonth)(date, displayMonth);
        });
    };
    var goToDate = function(date, refDate) {
        if (isDateDisplayed(date)) return;
        if (refDate && (0, $4hBm1.isBefore)(date, refDate)) goToMonth((0, $4hBm1.addMonths)(date, 1 + dayPicker.numberOfMonths * -1));
        else goToMonth(date);
    };
    var value = {
        currentMonth: currentMonth,
        displayMonths: displayMonths,
        goToMonth: goToMonth,
        goToDate: goToDate,
        previousMonth: previousMonth,
        nextMonth: nextMonth,
        isDateDisplayed: isDateDisplayed
    };
    return (0, $4TLFw.jsx)($8e47ba8d561bde0d$export$3044ab7fdabeaee6.Provider, {
        value: value,
        children: props.children
    });
}
/**
 * Hook to access the {@link NavigationContextValue}. Use this hook to navigate
 * between months or years in DayPicker.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function $8e47ba8d561bde0d$export$d0fd4b7106de2769() {
    var context = (0, $jbmdS.useContext)($8e47ba8d561bde0d$export$3044ab7fdabeaee6);
    if (!context) throw new Error("useNavigation must be used within a NavigationProvider");
    return context;
}
/**
 * Render a caption with the dropdowns to navigate between months and years.
 */ function $8e47ba8d561bde0d$export$6a3605aba74bcb3d(props) {
    var _a;
    var _b = $8e47ba8d561bde0d$export$332e9e0d64b1f294(), classNames = _b.classNames, styles = _b.styles, components = _b.components;
    var goToMonth = $8e47ba8d561bde0d$export$d0fd4b7106de2769().goToMonth;
    var handleMonthChange = function(newMonth) {
        goToMonth((0, $4hBm1.addMonths)(newMonth, props.displayIndex ? -props.displayIndex : 0));
    };
    var CaptionLabelComponent = (_a = components === null || components === void 0 ? void 0 : components.CaptionLabel) !== null && _a !== void 0 ? _a : $8e47ba8d561bde0d$export$5b9f95302ae85eba;
    var captionLabel = (0, $4TLFw.jsx)(CaptionLabelComponent, {
        id: props.id,
        displayMonth: props.displayMonth
    });
    return (0, $4TLFw.jsxs)("div", {
        className: classNames.caption_dropdowns,
        style: styles.caption_dropdowns,
        children: [
            (0, $4TLFw.jsx)("div", {
                className: classNames.vhidden,
                children: captionLabel
            }),
            (0, $4TLFw.jsx)($8e47ba8d561bde0d$var$MonthsDropdown, {
                onChange: handleMonthChange,
                displayMonth: props.displayMonth
            }),
            (0, $4TLFw.jsx)($8e47ba8d561bde0d$var$YearsDropdown, {
                onChange: handleMonthChange,
                displayMonth: props.displayMonth
            })
        ]
    });
}
/**
 * Render the "previous month" button in the navigation.
 */ function $8e47ba8d561bde0d$export$fac286bb0d0d0385(props) {
    return (0, $4TLFw.jsx)("svg", $8e47ba8d561bde0d$var$__assign({
        width: "16px",
        height: "16px",
        viewBox: "0 0 120 120"
    }, props, {
        children: (0, $4TLFw.jsx)("path", {
            d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z",
            fill: "currentColor",
            fillRule: "nonzero"
        })
    }));
}
/**
 * Render the "next month" button in the navigation.
 */ function $8e47ba8d561bde0d$export$142e5a7835580ff5(props) {
    return (0, $4TLFw.jsx)("svg", $8e47ba8d561bde0d$var$__assign({
        width: "16px",
        height: "16px",
        viewBox: "0 0 120 120"
    }, props, {
        children: (0, $4TLFw.jsx)("path", {
            d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z",
            fill: "currentColor"
        })
    }));
}
/** Render a button HTML element applying the reset class name. */ var $8e47ba8d561bde0d$export$353f5b6fc5456de1 = (0, $jbmdS.forwardRef)(function(props, ref) {
    var _a = $8e47ba8d561bde0d$export$332e9e0d64b1f294(), classNames = _a.classNames, styles = _a.styles;
    var classNamesArr = [
        classNames.button_reset,
        classNames.button
    ];
    if (props.className) classNamesArr.push(props.className);
    var className = classNamesArr.join(" ");
    var style = $8e47ba8d561bde0d$var$__assign($8e47ba8d561bde0d$var$__assign({}, styles.button_reset), styles.button);
    if (props.style) Object.assign(style, props.style);
    return (0, $4TLFw.jsx)("button", $8e47ba8d561bde0d$var$__assign({}, props, {
        ref: ref,
        type: "button",
        className: className,
        style: style
    }));
});
/** A component rendering the navigation buttons or the drop-downs. */ function $8e47ba8d561bde0d$var$Navigation(props) {
    var _a, _b;
    var _c = $8e47ba8d561bde0d$export$332e9e0d64b1f294(), dir = _c.dir, locale = _c.locale, classNames = _c.classNames, styles = _c.styles, _d = _c.labels, labelPrevious = _d.labelPrevious, labelNext = _d.labelNext, components = _c.components;
    if (!props.nextMonth && !props.previousMonth) return (0, $4TLFw.jsx)((0, $4TLFw.Fragment), {});
    var previousLabel = labelPrevious(props.previousMonth, {
        locale: locale
    });
    var previousClassName = [
        classNames.nav_button,
        classNames.nav_button_previous
    ].join(" ");
    var nextLabel = labelNext(props.nextMonth, {
        locale: locale
    });
    var nextClassName = [
        classNames.nav_button,
        classNames.nav_button_next
    ].join(" ");
    var IconRightComponent = (_a = components === null || components === void 0 ? void 0 : components.IconRight) !== null && _a !== void 0 ? _a : $8e47ba8d561bde0d$export$142e5a7835580ff5;
    var IconLeftComponent = (_b = components === null || components === void 0 ? void 0 : components.IconLeft) !== null && _b !== void 0 ? _b : $8e47ba8d561bde0d$export$fac286bb0d0d0385;
    return (0, $4TLFw.jsxs)("div", {
        className: classNames.nav,
        style: styles.nav,
        children: [
            !props.hidePrevious && (0, $4TLFw.jsx)($8e47ba8d561bde0d$export$353f5b6fc5456de1, {
                name: "previous-month",
                "aria-label": previousLabel,
                className: previousClassName,
                style: styles.nav_button_previous,
                disabled: !props.previousMonth,
                onClick: props.onPreviousClick,
                children: dir === "rtl" ? (0, $4TLFw.jsx)(IconRightComponent, {
                    className: classNames.nav_icon,
                    style: styles.nav_icon
                }) : (0, $4TLFw.jsx)(IconLeftComponent, {
                    className: classNames.nav_icon,
                    style: styles.nav_icon
                })
            }),
            !props.hideNext && (0, $4TLFw.jsx)($8e47ba8d561bde0d$export$353f5b6fc5456de1, {
                name: "next-month",
                "aria-label": nextLabel,
                className: nextClassName,
                style: styles.nav_button_next,
                disabled: !props.nextMonth,
                onClick: props.onNextClick,
                children: dir === "rtl" ? (0, $4TLFw.jsx)(IconLeftComponent, {
                    className: classNames.nav_icon,
                    style: styles.nav_icon
                }) : (0, $4TLFw.jsx)(IconRightComponent, {
                    className: classNames.nav_icon,
                    style: styles.nav_icon
                })
            })
        ]
    });
}
/**
 * Render a caption with a button-based navigation.
 */ function $8e47ba8d561bde0d$export$f6e46da460a028c1(props) {
    var numberOfMonths = $8e47ba8d561bde0d$export$332e9e0d64b1f294().numberOfMonths;
    var _a = $8e47ba8d561bde0d$export$d0fd4b7106de2769(), previousMonth = _a.previousMonth, nextMonth = _a.nextMonth, goToMonth = _a.goToMonth, displayMonths = _a.displayMonths;
    var displayIndex = displayMonths.findIndex(function(month) {
        return (0, $4hBm1.isSameMonth)(props.displayMonth, month);
    });
    var isFirst = displayIndex === 0;
    var isLast = displayIndex === displayMonths.length - 1;
    var hideNext = numberOfMonths > 1 && (isFirst || !isLast);
    var hidePrevious = numberOfMonths > 1 && (isLast || !isFirst);
    var handlePreviousClick = function() {
        if (!previousMonth) return;
        goToMonth(previousMonth);
    };
    var handleNextClick = function() {
        if (!nextMonth) return;
        goToMonth(nextMonth);
    };
    return (0, $4TLFw.jsx)($8e47ba8d561bde0d$var$Navigation, {
        displayMonth: props.displayMonth,
        hideNext: hideNext,
        hidePrevious: hidePrevious,
        nextMonth: nextMonth,
        previousMonth: previousMonth,
        onPreviousClick: handlePreviousClick,
        onNextClick: handleNextClick
    });
}
/**
 * Render the caption of a month. The caption has a different layout when
 * setting the {@link DayPickerBase.captionLayout} prop.
 */ function $8e47ba8d561bde0d$export$32fbfacc5d962e0c(props) {
    var _a;
    var _b = $8e47ba8d561bde0d$export$332e9e0d64b1f294(), classNames = _b.classNames, disableNavigation = _b.disableNavigation, styles = _b.styles, captionLayout = _b.captionLayout, components = _b.components;
    var CaptionLabelComponent = (_a = components === null || components === void 0 ? void 0 : components.CaptionLabel) !== null && _a !== void 0 ? _a : $8e47ba8d561bde0d$export$5b9f95302ae85eba;
    var caption;
    if (disableNavigation) caption = (0, $4TLFw.jsx)(CaptionLabelComponent, {
        id: props.id,
        displayMonth: props.displayMonth
    });
    else if (captionLayout === "dropdown") caption = (0, $4TLFw.jsx)($8e47ba8d561bde0d$export$6a3605aba74bcb3d, {
        displayMonth: props.displayMonth,
        id: props.id
    });
    else if (captionLayout === "dropdown-buttons") caption = (0, $4TLFw.jsxs)((0, $4TLFw.Fragment), {
        children: [
            (0, $4TLFw.jsx)($8e47ba8d561bde0d$export$6a3605aba74bcb3d, {
                displayMonth: props.displayMonth,
                displayIndex: props.displayIndex,
                id: props.id
            }),
            (0, $4TLFw.jsx)($8e47ba8d561bde0d$export$f6e46da460a028c1, {
                displayMonth: props.displayMonth,
                displayIndex: props.displayIndex,
                id: props.id
            })
        ]
    });
    else caption = (0, $4TLFw.jsxs)((0, $4TLFw.Fragment), {
        children: [
            (0, $4TLFw.jsx)(CaptionLabelComponent, {
                id: props.id,
                displayMonth: props.displayMonth,
                displayIndex: props.displayIndex
            }),
            (0, $4TLFw.jsx)($8e47ba8d561bde0d$export$f6e46da460a028c1, {
                displayMonth: props.displayMonth,
                id: props.id
            })
        ]
    });
    return (0, $4TLFw.jsx)("div", {
        className: classNames.caption,
        style: styles.caption,
        children: caption
    });
}
/** Render the Footer component (empty as default).*/ // eslint-disable-next-line @typescript-eslint/no-unused-vars
function $8e47ba8d561bde0d$export$a06f1c675e846f6f(props) {
    var _a = $8e47ba8d561bde0d$export$332e9e0d64b1f294(), footer = _a.footer, styles = _a.styles, tfoot = _a.classNames.tfoot;
    if (!footer) return (0, $4TLFw.jsx)((0, $4TLFw.Fragment), {});
    return (0, $4TLFw.jsx)("tfoot", {
        className: tfoot,
        style: styles.tfoot,
        children: (0, $4TLFw.jsx)("tr", {
            children: (0, $4TLFw.jsx)("td", {
                colSpan: 8,
                children: footer
            })
        })
    });
}
/**
 * Generate a series of 7 days, starting from the week, to use for formatting
 * the weekday names (Monday, Tuesday, etc.).
 */ function $8e47ba8d561bde0d$var$getWeekdays(locale, /** The index of the first day of the week (0 - Sunday). */ weekStartsOn, /** Use ISOWeek instead of locale/ */ ISOWeek) {
    var start = ISOWeek ? (0, $4hBm1.startOfISOWeek)(new Date()) : (0, $4hBm1.startOfWeek)(new Date(), {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
    var days = [];
    for(var i = 0; i < 7; i++){
        var day = (0, $4hBm1.addDays)(start, i);
        days.push(day);
    }
    return days;
}
/**
 * Render the HeadRow component - i.e. the table head row with the weekday names.
 */ function $8e47ba8d561bde0d$export$b008e842a2213343() {
    var _a = $8e47ba8d561bde0d$export$332e9e0d64b1f294(), classNames = _a.classNames, styles = _a.styles, showWeekNumber = _a.showWeekNumber, locale = _a.locale, weekStartsOn = _a.weekStartsOn, ISOWeek = _a.ISOWeek, formatWeekdayName = _a.formatters.formatWeekdayName, labelWeekday = _a.labels.labelWeekday;
    var weekdays = $8e47ba8d561bde0d$var$getWeekdays(locale, weekStartsOn, ISOWeek);
    return (0, $4TLFw.jsxs)("tr", {
        style: styles.head_row,
        className: classNames.head_row,
        children: [
            showWeekNumber && (0, $4TLFw.jsx)("td", {
                style: styles.head_cell,
                className: classNames.head_cell
            }),
            weekdays.map(function(weekday, i) {
                return (0, $4TLFw.jsx)("th", {
                    scope: "col",
                    className: classNames.head_cell,
                    style: styles.head_cell,
                    "aria-label": labelWeekday(weekday, {
                        locale: locale
                    }),
                    children: formatWeekdayName(weekday, {
                        locale: locale
                    })
                }, i);
            })
        ]
    });
}
/** Render the table head. */ function $8e47ba8d561bde0d$export$e93312b7773dfcac() {
    var _a;
    var _b = $8e47ba8d561bde0d$export$332e9e0d64b1f294(), classNames = _b.classNames, styles = _b.styles, components = _b.components;
    var HeadRowComponent = (_a = components === null || components === void 0 ? void 0 : components.HeadRow) !== null && _a !== void 0 ? _a : $8e47ba8d561bde0d$export$b008e842a2213343;
    return (0, $4TLFw.jsx)("thead", {
        style: styles.head,
        className: classNames.head,
        children: (0, $4TLFw.jsx)(HeadRowComponent, {})
    });
}
/** Render the content of the day cell. */ function $8e47ba8d561bde0d$export$16d0634337daf8ec(props) {
    var _a = $8e47ba8d561bde0d$export$332e9e0d64b1f294(), locale = _a.locale, formatDay = _a.formatters.formatDay;
    return (0, $4TLFw.jsx)((0, $4TLFw.Fragment), {
        children: formatDay(props.date, {
            locale: locale
        })
    });
}
/**
 * The SelectMultiple context shares details about the selected days when in
 * multiple selection mode.
 *
 * Access this context from the {@link useSelectMultiple} hook.
 */ var $8e47ba8d561bde0d$export$26e3e4d6f601d4d6 = (0, $jbmdS.createContext)(undefined);
/** Provides the values for the {@link SelectMultipleContext}. */ function $8e47ba8d561bde0d$export$913827019032c8d4(props) {
    if (!$8e47ba8d561bde0d$export$2d8c2b43ec0e528(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined,
            modifiers: {
                disabled: []
            }
        };
        return (0, $4TLFw.jsx)($8e47ba8d561bde0d$export$26e3e4d6f601d4d6.Provider, {
            value: emptyContextValue,
            children: props.children
        });
    }
    return (0, $4TLFw.jsx)($8e47ba8d561bde0d$export$91128e1c5ca64a0d, {
        initialProps: props.initialProps,
        children: props.children
    });
}
function $8e47ba8d561bde0d$export$91128e1c5ca64a0d(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var selected = initialProps.selected, min = initialProps.min, max = initialProps.max;
    var onDayClick = function(day, activeModifiers, e) {
        var _a, _b;
        (_a = initialProps.onDayClick) === null || _a === void 0 || _a.call(initialProps, day, activeModifiers, e);
        var isMinSelected = Boolean(activeModifiers.selected && min && (selected === null || selected === void 0 ? void 0 : selected.length) === min);
        if (isMinSelected) return;
        var isMaxSelected = Boolean(!activeModifiers.selected && max && (selected === null || selected === void 0 ? void 0 : selected.length) === max);
        if (isMaxSelected) return;
        var selectedDays = selected ? $8e47ba8d561bde0d$var$__spreadArray([], selected, true) : [];
        if (activeModifiers.selected) {
            var index = selectedDays.findIndex(function(selectedDay) {
                return (0, $4hBm1.isSameDay)(day, selectedDay);
            });
            selectedDays.splice(index, 1);
        } else selectedDays.push(day);
        (_b = initialProps.onSelect) === null || _b === void 0 || _b.call(initialProps, selectedDays, day, activeModifiers, e);
    };
    var modifiers = {
        disabled: []
    };
    if (selected) modifiers.disabled.push(function(day) {
        var isMaxSelected = max && selected.length > max - 1;
        var isSelected = selected.some(function(selectedDay) {
            return (0, $4hBm1.isSameDay)(selectedDay, day);
        });
        return Boolean(isMaxSelected && !isSelected);
    });
    var contextValue = {
        selected: selected,
        onDayClick: onDayClick,
        modifiers: modifiers
    };
    return (0, $4TLFw.jsx)($8e47ba8d561bde0d$export$26e3e4d6f601d4d6.Provider, {
        value: contextValue,
        children: children
    });
}
/**
 * Hook to access the {@link SelectMultipleContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function $8e47ba8d561bde0d$export$458361db477d8ed0() {
    var context = (0, $jbmdS.useContext)($8e47ba8d561bde0d$export$26e3e4d6f601d4d6);
    if (!context) throw new Error("useSelectMultiple must be used within a SelectMultipleProvider");
    return context;
}
/**
 * Add a day to an existing range.
 *
 * The returned range takes in account the `undefined` values and if the added
 * day is already present in the range.
 */ function $8e47ba8d561bde0d$export$27ef550b4e6acc0c(day, range) {
    var _a = range || {}, from = _a.from, to = _a.to;
    if (from && to) {
        if ((0, $4hBm1.isSameDay)(to, day) && (0, $4hBm1.isSameDay)(from, day)) return undefined;
        if ((0, $4hBm1.isSameDay)(to, day)) return {
            from: to,
            to: undefined
        };
        if ((0, $4hBm1.isSameDay)(from, day)) return undefined;
        if ((0, $4hBm1.isAfter)(from, day)) return {
            from: day,
            to: to
        };
        return {
            from: from,
            to: day
        };
    }
    if (to) {
        if ((0, $4hBm1.isAfter)(day, to)) return {
            from: to,
            to: day
        };
        return {
            from: day,
            to: to
        };
    }
    if (from) {
        if ((0, $4hBm1.isBefore)(day, from)) return {
            from: day,
            to: from
        };
        return {
            from: from,
            to: day
        };
    }
    return {
        from: day,
        to: undefined
    };
}
/**
 * The SelectRange context shares details about the selected days when in
 * range selection mode.
 *
 * Access this context from the {@link useSelectRange} hook.
 */ var $8e47ba8d561bde0d$export$49c734aed8c840bb = (0, $jbmdS.createContext)(undefined);
/** Provides the values for the {@link SelectRangeProvider}. */ function $8e47ba8d561bde0d$export$deb49a47c7ee5fdf(props) {
    if (!$8e47ba8d561bde0d$export$f7b9f96866ec1964(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined,
            modifiers: {
                range_start: [],
                range_end: [],
                range_middle: [],
                disabled: []
            }
        };
        return (0, $4TLFw.jsx)($8e47ba8d561bde0d$export$49c734aed8c840bb.Provider, {
            value: emptyContextValue,
            children: props.children
        });
    }
    return (0, $4TLFw.jsx)($8e47ba8d561bde0d$export$cca59e032fbbe71f, {
        initialProps: props.initialProps,
        children: props.children
    });
}
function $8e47ba8d561bde0d$export$cca59e032fbbe71f(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var selected = initialProps.selected;
    var _b = selected || {}, selectedFrom = _b.from, selectedTo = _b.to;
    var min = initialProps.min;
    var max = initialProps.max;
    var onDayClick = function(day, activeModifiers, e) {
        var _a, _b;
        (_a = initialProps.onDayClick) === null || _a === void 0 || _a.call(initialProps, day, activeModifiers, e);
        var newRange = $8e47ba8d561bde0d$export$27ef550b4e6acc0c(day, selected);
        (_b = initialProps.onSelect) === null || _b === void 0 || _b.call(initialProps, newRange, day, activeModifiers, e);
    };
    var modifiers = {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
    };
    if (selectedFrom) {
        modifiers.range_start = [
            selectedFrom
        ];
        if (!selectedTo) modifiers.range_end = [
            selectedFrom
        ];
        else {
            modifiers.range_end = [
                selectedTo
            ];
            if (!(0, $4hBm1.isSameDay)(selectedFrom, selectedTo)) modifiers.range_middle = [
                {
                    after: selectedFrom,
                    before: selectedTo
                }
            ];
        }
    } else if (selectedTo) {
        modifiers.range_start = [
            selectedTo
        ];
        modifiers.range_end = [
            selectedTo
        ];
    }
    if (min) {
        if (selectedFrom && !selectedTo) modifiers.disabled.push({
            after: (0, $4hBm1.subDays)(selectedFrom, min - 1),
            before: (0, $4hBm1.addDays)(selectedFrom, min - 1)
        });
        if (selectedFrom && selectedTo) modifiers.disabled.push({
            after: selectedFrom,
            before: (0, $4hBm1.addDays)(selectedFrom, min - 1)
        });
        if (!selectedFrom && selectedTo) modifiers.disabled.push({
            after: (0, $4hBm1.subDays)(selectedTo, min - 1),
            before: (0, $4hBm1.addDays)(selectedTo, min - 1)
        });
    }
    if (max) {
        if (selectedFrom && !selectedTo) {
            modifiers.disabled.push({
                before: (0, $4hBm1.addDays)(selectedFrom, -max + 1)
            });
            modifiers.disabled.push({
                after: (0, $4hBm1.addDays)(selectedFrom, max - 1)
            });
        }
        if (selectedFrom && selectedTo) {
            var selectedCount = (0, $4hBm1.differenceInCalendarDays)(selectedTo, selectedFrom) + 1;
            var offset = max - selectedCount;
            modifiers.disabled.push({
                before: (0, $4hBm1.subDays)(selectedFrom, offset)
            });
            modifiers.disabled.push({
                after: (0, $4hBm1.addDays)(selectedTo, offset)
            });
        }
        if (!selectedFrom && selectedTo) {
            modifiers.disabled.push({
                before: (0, $4hBm1.addDays)(selectedTo, -max + 1)
            });
            modifiers.disabled.push({
                after: (0, $4hBm1.addDays)(selectedTo, max - 1)
            });
        }
    }
    return (0, $4TLFw.jsx)($8e47ba8d561bde0d$export$49c734aed8c840bb.Provider, {
        value: {
            selected: selected,
            onDayClick: onDayClick,
            modifiers: modifiers
        },
        children: children
    });
}
/**
 * Hook to access the {@link SelectRangeContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function $8e47ba8d561bde0d$export$ad0998138eb321e7() {
    var context = (0, $jbmdS.useContext)($8e47ba8d561bde0d$export$49c734aed8c840bb);
    if (!context) throw new Error("useSelectRange must be used within a SelectRangeProvider");
    return context;
}
/** Normalize to array a matcher input. */ function $8e47ba8d561bde0d$var$matcherToArray(matcher) {
    if (Array.isArray(matcher)) return $8e47ba8d561bde0d$var$__spreadArray([], matcher, true);
    else if (matcher !== undefined) return [
        matcher
    ];
    else return [];
}
/** Create CustomModifiers from dayModifiers */ function $8e47ba8d561bde0d$var$getCustomModifiers(dayModifiers) {
    var customModifiers = {};
    Object.entries(dayModifiers).forEach(function(_a) {
        var modifier = _a[0], matcher = _a[1];
        customModifiers[modifier] = $8e47ba8d561bde0d$var$matcherToArray(matcher);
    });
    return customModifiers;
}
/** The name of the modifiers that are used internally by DayPicker. */ var $8e47ba8d561bde0d$export$7652a4f8ecc53eb5;
(function(InternalModifier) {
    InternalModifier["Outside"] = "outside";
    /** Name of the modifier applied to the disabled days, using the `disabled` prop. */ InternalModifier["Disabled"] = "disabled";
    /** Name of the modifier applied to the selected days using the `selected` prop). */ InternalModifier["Selected"] = "selected";
    /** Name of the modifier applied to the hidden days using the `hidden` prop). */ InternalModifier["Hidden"] = "hidden";
    /** Name of the modifier applied to the day specified using the `today` prop). */ InternalModifier["Today"] = "today";
    /** The modifier applied to the day starting a selected range, when in range selection mode.  */ InternalModifier["RangeStart"] = "range_start";
    /** The modifier applied to the day ending a selected range, when in range selection mode.  */ InternalModifier["RangeEnd"] = "range_end";
    /** The modifier applied to the days between the start and the end of a selected range, when in range selection mode.  */ InternalModifier["RangeMiddle"] = "range_middle";
})($8e47ba8d561bde0d$export$7652a4f8ecc53eb5 || ($8e47ba8d561bde0d$export$7652a4f8ecc53eb5 = {}));
var $8e47ba8d561bde0d$var$Selected = $8e47ba8d561bde0d$export$7652a4f8ecc53eb5.Selected, $8e47ba8d561bde0d$var$Disabled = $8e47ba8d561bde0d$export$7652a4f8ecc53eb5.Disabled, $8e47ba8d561bde0d$var$Hidden = $8e47ba8d561bde0d$export$7652a4f8ecc53eb5.Hidden, $8e47ba8d561bde0d$var$Today = $8e47ba8d561bde0d$export$7652a4f8ecc53eb5.Today, $8e47ba8d561bde0d$var$RangeEnd = $8e47ba8d561bde0d$export$7652a4f8ecc53eb5.RangeEnd, $8e47ba8d561bde0d$var$RangeMiddle = $8e47ba8d561bde0d$export$7652a4f8ecc53eb5.RangeMiddle, $8e47ba8d561bde0d$var$RangeStart = $8e47ba8d561bde0d$export$7652a4f8ecc53eb5.RangeStart, $8e47ba8d561bde0d$var$Outside = $8e47ba8d561bde0d$export$7652a4f8ecc53eb5.Outside;
/** Return the {@link InternalModifiers} from the DayPicker and select contexts. */ function $8e47ba8d561bde0d$var$getInternalModifiers(dayPicker, selectMultiple, selectRange) {
    var _a;
    var internalModifiers = (_a = {}, _a[$8e47ba8d561bde0d$var$Selected] = $8e47ba8d561bde0d$var$matcherToArray(dayPicker.selected), _a[$8e47ba8d561bde0d$var$Disabled] = $8e47ba8d561bde0d$var$matcherToArray(dayPicker.disabled), _a[$8e47ba8d561bde0d$var$Hidden] = $8e47ba8d561bde0d$var$matcherToArray(dayPicker.hidden), _a[$8e47ba8d561bde0d$var$Today] = [
        dayPicker.today
    ], _a[$8e47ba8d561bde0d$var$RangeEnd] = [], _a[$8e47ba8d561bde0d$var$RangeMiddle] = [], _a[$8e47ba8d561bde0d$var$RangeStart] = [], _a[$8e47ba8d561bde0d$var$Outside] = [], _a);
    if (dayPicker.fromDate) internalModifiers[$8e47ba8d561bde0d$var$Disabled].push({
        before: dayPicker.fromDate
    });
    if (dayPicker.toDate) internalModifiers[$8e47ba8d561bde0d$var$Disabled].push({
        after: dayPicker.toDate
    });
    if ($8e47ba8d561bde0d$export$2d8c2b43ec0e528(dayPicker)) internalModifiers[$8e47ba8d561bde0d$var$Disabled] = internalModifiers[$8e47ba8d561bde0d$var$Disabled].concat(selectMultiple.modifiers[$8e47ba8d561bde0d$var$Disabled]);
    else if ($8e47ba8d561bde0d$export$f7b9f96866ec1964(dayPicker)) {
        internalModifiers[$8e47ba8d561bde0d$var$Disabled] = internalModifiers[$8e47ba8d561bde0d$var$Disabled].concat(selectRange.modifiers[$8e47ba8d561bde0d$var$Disabled]);
        internalModifiers[$8e47ba8d561bde0d$var$RangeStart] = selectRange.modifiers[$8e47ba8d561bde0d$var$RangeStart];
        internalModifiers[$8e47ba8d561bde0d$var$RangeMiddle] = selectRange.modifiers[$8e47ba8d561bde0d$var$RangeMiddle];
        internalModifiers[$8e47ba8d561bde0d$var$RangeEnd] = selectRange.modifiers[$8e47ba8d561bde0d$var$RangeEnd];
    }
    return internalModifiers;
}
/** The Modifiers context store the modifiers used in DayPicker. To access the value of this context, use {@link useModifiers}. */ var $8e47ba8d561bde0d$var$ModifiersContext = (0, $jbmdS.createContext)(undefined);
/** Provide the value for the {@link ModifiersContext}. */ function $8e47ba8d561bde0d$var$ModifiersProvider(props) {
    var dayPicker = $8e47ba8d561bde0d$export$332e9e0d64b1f294();
    var selectMultiple = $8e47ba8d561bde0d$export$458361db477d8ed0();
    var selectRange = $8e47ba8d561bde0d$export$ad0998138eb321e7();
    var internalModifiers = $8e47ba8d561bde0d$var$getInternalModifiers(dayPicker, selectMultiple, selectRange);
    var customModifiers = $8e47ba8d561bde0d$var$getCustomModifiers(dayPicker.modifiers);
    var modifiers = $8e47ba8d561bde0d$var$__assign($8e47ba8d561bde0d$var$__assign({}, internalModifiers), customModifiers);
    return (0, $4TLFw.jsx)($8e47ba8d561bde0d$var$ModifiersContext.Provider, {
        value: modifiers,
        children: props.children
    });
}
/**
 * Return the modifiers used by DayPicker.
 *
 * This hook is meant to be used inside internal or custom components.
 * Requires to be wrapped into {@link ModifiersProvider}.
 *
 */ function $8e47ba8d561bde0d$var$useModifiers() {
    var context = (0, $jbmdS.useContext)($8e47ba8d561bde0d$var$ModifiersContext);
    if (!context) throw new Error("useModifiers must be used within a ModifiersProvider");
    return context;
}
/** Returns true if `matcher` is of type {@link DateInterval}. */ function $8e47ba8d561bde0d$export$654311eaff47f3cd(matcher) {
    return Boolean(matcher && typeof matcher === "object" && "before" in matcher && "after" in matcher);
}
/** Returns true if `value` is a {@link DateRange} type. */ function $8e47ba8d561bde0d$export$dd455b9c98fea187(value) {
    return Boolean(value && typeof value === "object" && "from" in value);
}
/** Returns true if `value` is of type {@link DateAfter}. */ function $8e47ba8d561bde0d$export$4760905e07020cd4(value) {
    return Boolean(value && typeof value === "object" && "after" in value);
}
/** Returns true if `value` is of type {@link DateBefore}. */ function $8e47ba8d561bde0d$export$a3bef2c4e855ef4e(value) {
    return Boolean(value && typeof value === "object" && "before" in value);
}
/** Returns true if `value` is a {@link DayOfWeek} type. */ function $8e47ba8d561bde0d$export$483c833837970a3(value) {
    return Boolean(value && typeof value === "object" && "dayOfWeek" in value);
}
/** Return `true` whether `date` is inside `range`. */ function $8e47ba8d561bde0d$var$isDateInRange(date, range) {
    var _a;
    var from = range.from, to = range.to;
    if (from && to) {
        var isRangeInverted = (0, $4hBm1.differenceInCalendarDays)(to, from) < 0;
        if (isRangeInverted) _a = [
            to,
            from
        ], from = _a[0], to = _a[1];
        var isInRange = (0, $4hBm1.differenceInCalendarDays)(date, from) >= 0 && (0, $4hBm1.differenceInCalendarDays)(to, date) >= 0;
        return isInRange;
    }
    if (to) return (0, $4hBm1.isSameDay)(to, date);
    if (from) return (0, $4hBm1.isSameDay)(from, date);
    return false;
}
/** Returns true if `value` is a Date type. */ function $8e47ba8d561bde0d$var$isDateType(value) {
    return (0, $4hBm1.isDate)(value);
}
/** Returns true if `value` is an array of valid dates. */ function $8e47ba8d561bde0d$var$isArrayOfDates(value) {
    return Array.isArray(value) && value.every((0, $4hBm1.isDate));
}
/**
 * Returns whether a day matches against at least one of the given Matchers.
 *
 * ```
 * const day = new Date(2022, 5, 19);
 * const matcher1: DateRange = {
 *    from: new Date(2021, 12, 21),
 *    to: new Date(2021, 12, 30)
 * }
 * const matcher2: DateRange = {
 *    from: new Date(2022, 5, 1),
 *    to: new Date(2022, 5, 23)
 * }
 *
 * const isMatch(day, [matcher1, matcher2]); // true, since day is in the matcher1 range.
 * ```
 * */ function $8e47ba8d561bde0d$export$b74c33566721f70f(day, matchers) {
    return matchers.some(function(matcher) {
        if (typeof matcher === "boolean") return matcher;
        if ($8e47ba8d561bde0d$var$isDateType(matcher)) return (0, $4hBm1.isSameDay)(day, matcher);
        if ($8e47ba8d561bde0d$var$isArrayOfDates(matcher)) return matcher.includes(day);
        if ($8e47ba8d561bde0d$export$dd455b9c98fea187(matcher)) return $8e47ba8d561bde0d$var$isDateInRange(day, matcher);
        if ($8e47ba8d561bde0d$export$483c833837970a3(matcher)) return matcher.dayOfWeek.includes(day.getDay());
        if ($8e47ba8d561bde0d$export$654311eaff47f3cd(matcher)) {
            var diffBefore = (0, $4hBm1.differenceInCalendarDays)(matcher.before, day);
            var diffAfter = (0, $4hBm1.differenceInCalendarDays)(matcher.after, day);
            var isDayBefore = diffBefore > 0;
            var isDayAfter = diffAfter < 0;
            var isClosedInterval = (0, $4hBm1.isAfter)(matcher.before, matcher.after);
            if (isClosedInterval) return isDayAfter && isDayBefore;
            else return isDayBefore || isDayAfter;
        }
        if ($8e47ba8d561bde0d$export$4760905e07020cd4(matcher)) return (0, $4hBm1.differenceInCalendarDays)(day, matcher.after) > 0;
        if ($8e47ba8d561bde0d$export$a3bef2c4e855ef4e(matcher)) return (0, $4hBm1.differenceInCalendarDays)(matcher.before, day) > 0;
        if (typeof matcher === "function") return matcher(day);
        return false;
    });
}
/** Return the active modifiers for the given day. */ function $8e47ba8d561bde0d$var$getActiveModifiers(day, /** The modifiers to match for the given date. */ modifiers, /** The month where the day is displayed, to add the "outside" modifiers.  */ displayMonth) {
    var matchedModifiers = Object.keys(modifiers).reduce(function(result, key) {
        var modifier = modifiers[key];
        if ($8e47ba8d561bde0d$export$b74c33566721f70f(day, modifier)) result.push(key);
        return result;
    }, []);
    var activeModifiers = {};
    matchedModifiers.forEach(function(modifier) {
        return activeModifiers[modifier] = true;
    });
    if (displayMonth && !(0, $4hBm1.isSameMonth)(day, displayMonth)) activeModifiers.outside = true;
    return activeModifiers;
}
/**
 * Returns the day that should be the target of the focus when DayPicker is
 * rendered the first time.
 *
 * TODO: this function doesn't consider if the day is outside the month. We
 * implemented this check in `useDayRender` but it should probably go here. See
 * https://github.com/gpbl/react-day-picker/pull/1576
 */ function $8e47ba8d561bde0d$var$getInitialFocusTarget(displayMonths, modifiers) {
    var firstDayInMonth = (0, $4hBm1.startOfMonth)(displayMonths[0]);
    var lastDayInMonth = (0, $4hBm1.endOfMonth)(displayMonths[displayMonths.length - 1]);
    // TODO: cleanup code
    var firstFocusableDay;
    var today;
    var date = firstDayInMonth;
    while(date <= lastDayInMonth){
        var activeModifiers = $8e47ba8d561bde0d$var$getActiveModifiers(date, modifiers);
        var isFocusable = !activeModifiers.disabled && !activeModifiers.hidden;
        if (!isFocusable) {
            date = (0, $4hBm1.addDays)(date, 1);
            continue;
        }
        if (activeModifiers.selected) return date;
        if (activeModifiers.today && !today) today = date;
        if (!firstFocusableDay) firstFocusableDay = date;
        date = (0, $4hBm1.addDays)(date, 1);
    }
    if (today) return today;
    else return firstFocusableDay;
}
var $8e47ba8d561bde0d$var$MAX_RETRY = 365;
/** Return the next date to be focused. */ function $8e47ba8d561bde0d$var$getNextFocus(focusedDay, options) {
    var moveBy = options.moveBy, direction = options.direction, context = options.context, modifiers = options.modifiers, _a = options.retry, retry = _a === void 0 ? {
        count: 0,
        lastFocused: focusedDay
    } : _a;
    var weekStartsOn = context.weekStartsOn, fromDate = context.fromDate, toDate = context.toDate, locale = context.locale;
    var moveFns = {
        day: (0, $4hBm1.addDays),
        week: (0, $4hBm1.addWeeks),
        month: (0, $4hBm1.addMonths),
        year: (0, $4hBm1.addYears),
        startOfWeek: function(date) {
            return context.ISOWeek ? (0, $4hBm1.startOfISOWeek)(date) : (0, $4hBm1.startOfWeek)(date, {
                locale: locale,
                weekStartsOn: weekStartsOn
            });
        },
        endOfWeek: function(date) {
            return context.ISOWeek ? (0, $4hBm1.endOfISOWeek)(date) : (0, $4hBm1.endOfWeek)(date, {
                locale: locale,
                weekStartsOn: weekStartsOn
            });
        }
    };
    var newFocusedDay = moveFns[moveBy](focusedDay, direction === "after" ? 1 : -1);
    if (direction === "before" && fromDate) newFocusedDay = (0, $4hBm1.max)([
        fromDate,
        newFocusedDay
    ]);
    else if (direction === "after" && toDate) newFocusedDay = (0, $4hBm1.min)([
        toDate,
        newFocusedDay
    ]);
    var isFocusable = true;
    if (modifiers) {
        var activeModifiers = $8e47ba8d561bde0d$var$getActiveModifiers(newFocusedDay, modifiers);
        isFocusable = !activeModifiers.disabled && !activeModifiers.hidden;
    }
    if (isFocusable) return newFocusedDay;
    else {
        if (retry.count > $8e47ba8d561bde0d$var$MAX_RETRY) return retry.lastFocused;
        return $8e47ba8d561bde0d$var$getNextFocus(newFocusedDay, {
            moveBy: moveBy,
            direction: direction,
            context: context,
            modifiers: modifiers,
            retry: $8e47ba8d561bde0d$var$__assign($8e47ba8d561bde0d$var$__assign({}, retry), {
                count: retry.count + 1
            })
        });
    }
}
/**
 * The Focus context shares details about the focused day for the keyboard
 *
 * Access this context from the {@link useFocusContext} hook.
 */ var $8e47ba8d561bde0d$export$e1f21ba6aeca320f = (0, $jbmdS.createContext)(undefined);
/** The provider for the {@link FocusContext}. */ function $8e47ba8d561bde0d$export$97cf4ab9b312b61a(props) {
    var navigation = $8e47ba8d561bde0d$export$d0fd4b7106de2769();
    var modifiers = $8e47ba8d561bde0d$var$useModifiers();
    var _a = (0, $jbmdS.useState)(), focusedDay = _a[0], setFocusedDay = _a[1];
    var _b = (0, $jbmdS.useState)(), lastFocused = _b[0], setLastFocused = _b[1];
    var initialFocusTarget = $8e47ba8d561bde0d$var$getInitialFocusTarget(navigation.displayMonths, modifiers);
    // TODO: cleanup and test obscure code below
    var focusTarget = (focusedDay !== null && focusedDay !== void 0 ? focusedDay : lastFocused && navigation.isDateDisplayed(lastFocused)) ? lastFocused : initialFocusTarget;
    var blur = function() {
        setLastFocused(focusedDay);
        setFocusedDay(undefined);
    };
    var focus = function(date) {
        setFocusedDay(date);
    };
    var context = $8e47ba8d561bde0d$export$332e9e0d64b1f294();
    var moveFocus = function(moveBy, direction) {
        if (!focusedDay) return;
        var nextFocused = $8e47ba8d561bde0d$var$getNextFocus(focusedDay, {
            moveBy: moveBy,
            direction: direction,
            context: context,
            modifiers: modifiers
        });
        if ((0, $4hBm1.isSameDay)(focusedDay, nextFocused)) return undefined;
        navigation.goToDate(nextFocused, focusedDay);
        focus(nextFocused);
    };
    var value = {
        focusedDay: focusedDay,
        focusTarget: focusTarget,
        blur: blur,
        focus: focus,
        focusDayAfter: function() {
            return moveFocus("day", "after");
        },
        focusDayBefore: function() {
            return moveFocus("day", "before");
        },
        focusWeekAfter: function() {
            return moveFocus("week", "after");
        },
        focusWeekBefore: function() {
            return moveFocus("week", "before");
        },
        focusMonthBefore: function() {
            return moveFocus("month", "before");
        },
        focusMonthAfter: function() {
            return moveFocus("month", "after");
        },
        focusYearBefore: function() {
            return moveFocus("year", "before");
        },
        focusYearAfter: function() {
            return moveFocus("year", "after");
        },
        focusStartOfWeek: function() {
            return moveFocus("startOfWeek", "before");
        },
        focusEndOfWeek: function() {
            return moveFocus("endOfWeek", "after");
        }
    };
    return (0, $4TLFw.jsx)($8e47ba8d561bde0d$export$e1f21ba6aeca320f.Provider, {
        value: value,
        children: props.children
    });
}
/**
 * Hook to access the {@link FocusContextValue}. Use this hook to handle the
 * focus state of the elements.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function $8e47ba8d561bde0d$export$69130071837c676e() {
    var context = (0, $jbmdS.useContext)($8e47ba8d561bde0d$export$e1f21ba6aeca320f);
    if (!context) throw new Error("useFocusContext must be used within a FocusProvider");
    return context;
}
/**
 * Return the active modifiers for the specified day.
 *
 * This hook is meant to be used inside internal or custom components.
 *
 * @param day
 * @param displayMonth
 */ function $8e47ba8d561bde0d$export$174df9b23ec1eb4b(day, /**
 * The month where the date is displayed. If not the same as `date`, the day
 * is an "outside day".
 */ displayMonth) {
    var modifiers = $8e47ba8d561bde0d$var$useModifiers();
    var activeModifiers = $8e47ba8d561bde0d$var$getActiveModifiers(day, modifiers, displayMonth);
    return activeModifiers;
}
/**
 * The SelectSingle context shares details about the selected days when in
 * single selection mode.
 *
 * Access this context from the {@link useSelectSingle} hook.
 */ var $8e47ba8d561bde0d$export$9632b0427d86eff3 = (0, $jbmdS.createContext)(undefined);
/** Provides the values for the {@link SelectSingleProvider}. */ function $8e47ba8d561bde0d$export$d40a11a5bbe785ba(props) {
    if (!$8e47ba8d561bde0d$export$e659ce9b264ea61(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined
        };
        return (0, $4TLFw.jsx)($8e47ba8d561bde0d$export$9632b0427d86eff3.Provider, {
            value: emptyContextValue,
            children: props.children
        });
    }
    return (0, $4TLFw.jsx)($8e47ba8d561bde0d$export$37bf09040cff7c3b, {
        initialProps: props.initialProps,
        children: props.children
    });
}
function $8e47ba8d561bde0d$export$37bf09040cff7c3b(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var onDayClick = function(day, activeModifiers, e) {
        var _a, _b, _c;
        (_a = initialProps.onDayClick) === null || _a === void 0 || _a.call(initialProps, day, activeModifiers, e);
        if (activeModifiers.selected && !initialProps.required) {
            (_b = initialProps.onSelect) === null || _b === void 0 || _b.call(initialProps, undefined, day, activeModifiers, e);
            return;
        }
        (_c = initialProps.onSelect) === null || _c === void 0 || _c.call(initialProps, day, day, activeModifiers, e);
    };
    var contextValue = {
        selected: initialProps.selected,
        onDayClick: onDayClick
    };
    return (0, $4TLFw.jsx)($8e47ba8d561bde0d$export$9632b0427d86eff3.Provider, {
        value: contextValue,
        children: children
    });
}
/**
 * Hook to access the {@link SelectSingleContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function $8e47ba8d561bde0d$export$2d75d772c98e4b05() {
    var context = (0, $jbmdS.useContext)($8e47ba8d561bde0d$export$9632b0427d86eff3);
    if (!context) throw new Error("useSelectSingle must be used within a SelectSingleProvider");
    return context;
}
/**
 * This hook returns details about the content to render in the day cell.
 *
 *
 * When a day cell is rendered in the table, DayPicker can either:
 *
 * - render nothing: when the day is outside the month or has matched the
 *   "hidden" modifier.
 * - render a button when `onDayClick` or a selection mode is set.
 * - render a non-interactive element: when no selection mode is set, the day
 *   cell shouldn’t respond to any interaction. DayPicker should render a `div`
 *   or a `span`.
 *
 * ### Usage
 *
 * Use this hook to customize the behavior of the {@link Day} component. Create a
 * new `Day` component using this hook and pass it to the `components` prop.
 * The source of {@link Day} can be a good starting point.
 *
 */ function $8e47ba8d561bde0d$var$useDayEventHandlers(date, activeModifiers) {
    var dayPicker = $8e47ba8d561bde0d$export$332e9e0d64b1f294();
    var single = $8e47ba8d561bde0d$export$2d75d772c98e4b05();
    var multiple = $8e47ba8d561bde0d$export$458361db477d8ed0();
    var range = $8e47ba8d561bde0d$export$ad0998138eb321e7();
    var _a = $8e47ba8d561bde0d$export$69130071837c676e(), focusDayAfter = _a.focusDayAfter, focusDayBefore = _a.focusDayBefore, focusWeekAfter = _a.focusWeekAfter, focusWeekBefore = _a.focusWeekBefore, blur = _a.blur, focus = _a.focus, focusMonthBefore = _a.focusMonthBefore, focusMonthAfter = _a.focusMonthAfter, focusYearBefore = _a.focusYearBefore, focusYearAfter = _a.focusYearAfter, focusStartOfWeek = _a.focusStartOfWeek, focusEndOfWeek = _a.focusEndOfWeek;
    var onClick = function(e) {
        var _a, _b, _c, _d;
        if ($8e47ba8d561bde0d$export$e659ce9b264ea61(dayPicker)) (_a = single.onDayClick) === null || _a === void 0 || _a.call(single, date, activeModifiers, e);
        else if ($8e47ba8d561bde0d$export$2d8c2b43ec0e528(dayPicker)) (_b = multiple.onDayClick) === null || _b === void 0 || _b.call(multiple, date, activeModifiers, e);
        else if ($8e47ba8d561bde0d$export$f7b9f96866ec1964(dayPicker)) (_c = range.onDayClick) === null || _c === void 0 || _c.call(range, date, activeModifiers, e);
        else (_d = dayPicker.onDayClick) === null || _d === void 0 || _d.call(dayPicker, date, activeModifiers, e);
    };
    var onFocus = function(e) {
        var _a;
        focus(date);
        (_a = dayPicker.onDayFocus) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onBlur = function(e) {
        var _a;
        blur();
        (_a = dayPicker.onDayBlur) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onMouseEnter = function(e) {
        var _a;
        (_a = dayPicker.onDayMouseEnter) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onMouseLeave = function(e) {
        var _a;
        (_a = dayPicker.onDayMouseLeave) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onPointerEnter = function(e) {
        var _a;
        (_a = dayPicker.onDayPointerEnter) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onPointerLeave = function(e) {
        var _a;
        (_a = dayPicker.onDayPointerLeave) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchCancel = function(e) {
        var _a;
        (_a = dayPicker.onDayTouchCancel) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchEnd = function(e) {
        var _a;
        (_a = dayPicker.onDayTouchEnd) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchMove = function(e) {
        var _a;
        (_a = dayPicker.onDayTouchMove) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchStart = function(e) {
        var _a;
        (_a = dayPicker.onDayTouchStart) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onKeyUp = function(e) {
        var _a;
        (_a = dayPicker.onDayKeyUp) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onKeyDown = function(e) {
        var _a;
        switch(e.key){
            case "ArrowLeft":
                e.preventDefault();
                e.stopPropagation();
                dayPicker.dir === "rtl" ? focusDayAfter() : focusDayBefore();
                break;
            case "ArrowRight":
                e.preventDefault();
                e.stopPropagation();
                dayPicker.dir === "rtl" ? focusDayBefore() : focusDayAfter();
                break;
            case "ArrowDown":
                e.preventDefault();
                e.stopPropagation();
                focusWeekAfter();
                break;
            case "ArrowUp":
                e.preventDefault();
                e.stopPropagation();
                focusWeekBefore();
                break;
            case "PageUp":
                e.preventDefault();
                e.stopPropagation();
                e.shiftKey ? focusYearBefore() : focusMonthBefore();
                break;
            case "PageDown":
                e.preventDefault();
                e.stopPropagation();
                e.shiftKey ? focusYearAfter() : focusMonthAfter();
                break;
            case "Home":
                e.preventDefault();
                e.stopPropagation();
                focusStartOfWeek();
                break;
            case "End":
                e.preventDefault();
                e.stopPropagation();
                focusEndOfWeek();
                break;
        }
        (_a = dayPicker.onDayKeyDown) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var eventHandlers = {
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onPointerEnter: onPointerEnter,
        onPointerLeave: onPointerLeave,
        onTouchCancel: onTouchCancel,
        onTouchEnd: onTouchEnd,
        onTouchMove: onTouchMove,
        onTouchStart: onTouchStart
    };
    return eventHandlers;
}
/**
 * Return the current selected days when DayPicker is in selection mode. Days
 * selected by the custom selection mode are not returned.
 *
 * This hook is meant to be used inside internal or custom components.
 *
 */ function $8e47ba8d561bde0d$var$useSelectedDays() {
    var dayPicker = $8e47ba8d561bde0d$export$332e9e0d64b1f294();
    var single = $8e47ba8d561bde0d$export$2d75d772c98e4b05();
    var multiple = $8e47ba8d561bde0d$export$458361db477d8ed0();
    var range = $8e47ba8d561bde0d$export$ad0998138eb321e7();
    var selectedDays = $8e47ba8d561bde0d$export$e659ce9b264ea61(dayPicker) ? single.selected : $8e47ba8d561bde0d$export$2d8c2b43ec0e528(dayPicker) ? multiple.selected : $8e47ba8d561bde0d$export$f7b9f96866ec1964(dayPicker) ? range.selected : undefined;
    return selectedDays;
}
function $8e47ba8d561bde0d$var$isInternalModifier(modifier) {
    return Object.values($8e47ba8d561bde0d$export$7652a4f8ecc53eb5).includes(modifier);
}
/**
 * Return the class names for the Day element, according to the given active
 * modifiers.
 *
 * Custom class names are set via `modifiersClassNames` or `classNames`,
 * where the first have the precedence.
 */ function $8e47ba8d561bde0d$var$getDayClassNames(dayPicker, activeModifiers) {
    var classNames = [
        dayPicker.classNames.day
    ];
    Object.keys(activeModifiers).forEach(function(modifier) {
        var customClassName = dayPicker.modifiersClassNames[modifier];
        if (customClassName) classNames.push(customClassName);
        else if ($8e47ba8d561bde0d$var$isInternalModifier(modifier)) {
            var internalClassName = dayPicker.classNames["day_".concat(modifier)];
            if (internalClassName) classNames.push(internalClassName);
        }
    });
    return classNames;
}
/** Return the style for the Day element, according to the given active modifiers. */ function $8e47ba8d561bde0d$var$getDayStyle(dayPicker, activeModifiers) {
    var style = $8e47ba8d561bde0d$var$__assign({}, dayPicker.styles.day);
    Object.keys(activeModifiers).forEach(function(modifier) {
        var _a;
        style = $8e47ba8d561bde0d$var$__assign($8e47ba8d561bde0d$var$__assign({}, style), (_a = dayPicker.modifiersStyles) === null || _a === void 0 ? void 0 : _a[modifier]);
    });
    return style;
}
/**
 * Return props and data used to render the {@link Day} component.
 *
 * Use this hook when creating a component to replace the built-in `Day`
 * component.
 */ function $8e47ba8d561bde0d$export$634dab6d85b953fc(/** The date to render. */ day, /** The month where the date is displayed (if not the same as `date`, it means it is an "outside" day). */ displayMonth, /** A ref to the button element that will be target of focus when rendered (if required). */ buttonRef) {
    var _a;
    var _b, _c;
    var dayPicker = $8e47ba8d561bde0d$export$332e9e0d64b1f294();
    var focusContext = $8e47ba8d561bde0d$export$69130071837c676e();
    var activeModifiers = $8e47ba8d561bde0d$export$174df9b23ec1eb4b(day, displayMonth);
    var eventHandlers = $8e47ba8d561bde0d$var$useDayEventHandlers(day, activeModifiers);
    var selectedDays = $8e47ba8d561bde0d$var$useSelectedDays();
    var isButton = Boolean(dayPicker.onDayClick || dayPicker.mode !== "default");
    // Focus the button if the day is focused according to the focus context
    (0, $jbmdS.useEffect)(function() {
        var _a;
        if (activeModifiers.outside) return;
        if (!focusContext.focusedDay) return;
        if (!isButton) return;
        if ((0, $4hBm1.isSameDay)(focusContext.focusedDay, day)) (_a = buttonRef.current) === null || _a === void 0 || _a.focus();
    }, [
        focusContext.focusedDay,
        day,
        buttonRef,
        isButton,
        activeModifiers.outside
    ]);
    var className = $8e47ba8d561bde0d$var$getDayClassNames(dayPicker, activeModifiers).join(" ");
    var style = $8e47ba8d561bde0d$var$getDayStyle(dayPicker, activeModifiers);
    var isHidden = Boolean(activeModifiers.outside && !dayPicker.showOutsideDays || activeModifiers.hidden);
    var DayContentComponent = (_c = (_b = dayPicker.components) === null || _b === void 0 ? void 0 : _b.DayContent) !== null && _c !== void 0 ? _c : $8e47ba8d561bde0d$export$16d0634337daf8ec;
    var children = (0, $4TLFw.jsx)(DayContentComponent, {
        date: day,
        displayMonth: displayMonth,
        activeModifiers: activeModifiers
    });
    var divProps = {
        style: style,
        className: className,
        children: children,
        role: "gridcell"
    };
    var isFocusTarget = focusContext.focusTarget && (0, $4hBm1.isSameDay)(focusContext.focusTarget, day) && !activeModifiers.outside;
    var isFocused = focusContext.focusedDay && (0, $4hBm1.isSameDay)(focusContext.focusedDay, day);
    var buttonProps = $8e47ba8d561bde0d$var$__assign($8e47ba8d561bde0d$var$__assign($8e47ba8d561bde0d$var$__assign({}, divProps), (_a = {
        disabled: activeModifiers.disabled,
        role: "gridcell"
    }, _a["aria-selected"] = activeModifiers.selected, _a.tabIndex = isFocused || isFocusTarget ? 0 : -1, _a)), eventHandlers);
    var dayRender = {
        isButton: isButton,
        isHidden: isHidden,
        activeModifiers: activeModifiers,
        selectedDays: selectedDays,
        buttonProps: buttonProps,
        divProps: divProps
    };
    return dayRender;
}
/**
 * The content of a day cell – as a button or span element according to its
 * modifiers.
 */ function $8e47ba8d561bde0d$export$7a9a31a911eb9a20(props) {
    var buttonRef = (0, $jbmdS.useRef)(null);
    var dayRender = $8e47ba8d561bde0d$export$634dab6d85b953fc(props.date, props.displayMonth, buttonRef);
    if (dayRender.isHidden) return (0, $4TLFw.jsx)("div", {
        role: "gridcell"
    });
    if (!dayRender.isButton) return (0, $4TLFw.jsx)("div", $8e47ba8d561bde0d$var$__assign({}, dayRender.divProps));
    return (0, $4TLFw.jsx)($8e47ba8d561bde0d$export$353f5b6fc5456de1, $8e47ba8d561bde0d$var$__assign({
        name: "day",
        ref: buttonRef
    }, dayRender.buttonProps));
}
/**
 * Render the week number element. If `onWeekNumberClick` is passed to DayPicker, it
 * renders a button, otherwise a span element.
 */ function $8e47ba8d561bde0d$export$f52f5e0fedb732da(props) {
    var weekNumber = props.number, dates = props.dates;
    var _a = $8e47ba8d561bde0d$export$332e9e0d64b1f294(), onWeekNumberClick = _a.onWeekNumberClick, styles = _a.styles, classNames = _a.classNames, locale = _a.locale, labelWeekNumber = _a.labels.labelWeekNumber, formatWeekNumber = _a.formatters.formatWeekNumber;
    var content = formatWeekNumber(Number(weekNumber), {
        locale: locale
    });
    if (!onWeekNumberClick) return (0, $4TLFw.jsx)("span", {
        className: classNames.weeknumber,
        style: styles.weeknumber,
        children: content
    });
    var label = labelWeekNumber(Number(weekNumber), {
        locale: locale
    });
    var handleClick = function(e) {
        onWeekNumberClick(weekNumber, dates, e);
    };
    return (0, $4TLFw.jsx)($8e47ba8d561bde0d$export$353f5b6fc5456de1, {
        name: "week-number",
        "aria-label": label,
        className: classNames.weeknumber,
        style: styles.weeknumber,
        onClick: handleClick,
        children: content
    });
}
/** Render a row in the calendar, with the days and the week number. */ function $8e47ba8d561bde0d$export$b59bdbef9ce70de2(props) {
    var _a, _b;
    var _c = $8e47ba8d561bde0d$export$332e9e0d64b1f294(), styles = _c.styles, classNames = _c.classNames, showWeekNumber = _c.showWeekNumber, components = _c.components;
    var DayComponent = (_a = components === null || components === void 0 ? void 0 : components.Day) !== null && _a !== void 0 ? _a : $8e47ba8d561bde0d$export$7a9a31a911eb9a20;
    var WeeknumberComponent = (_b = components === null || components === void 0 ? void 0 : components.WeekNumber) !== null && _b !== void 0 ? _b : $8e47ba8d561bde0d$export$f52f5e0fedb732da;
    var weekNumberCell;
    if (showWeekNumber) weekNumberCell = (0, $4TLFw.jsx)("td", {
        className: classNames.cell,
        style: styles.cell,
        children: (0, $4TLFw.jsx)(WeeknumberComponent, {
            number: props.weekNumber,
            dates: props.dates
        })
    });
    return (0, $4TLFw.jsxs)("tr", {
        className: classNames.row,
        style: styles.row,
        children: [
            weekNumberCell,
            props.dates.map(function(date) {
                return (0, $4TLFw.jsx)("td", {
                    className: classNames.cell,
                    style: styles.cell,
                    role: "presentation",
                    children: (0, $4TLFw.jsx)(DayComponent, {
                        displayMonth: props.displayMonth,
                        date: date
                    })
                }, (0, $4hBm1.getUnixTime)(date));
            })
        ]
    });
}
/** Return the weeks between two dates.  */ function $8e47ba8d561bde0d$var$daysToMonthWeeks(fromDate, toDate, options) {
    var toWeek = (options === null || options === void 0 ? void 0 : options.ISOWeek) ? (0, $4hBm1.endOfISOWeek)(toDate) : (0, $4hBm1.endOfWeek)(toDate, options);
    var fromWeek = (options === null || options === void 0 ? void 0 : options.ISOWeek) ? (0, $4hBm1.startOfISOWeek)(fromDate) : (0, $4hBm1.startOfWeek)(fromDate, options);
    var nOfDays = (0, $4hBm1.differenceInCalendarDays)(toWeek, fromWeek);
    var days = [];
    for(var i = 0; i <= nOfDays; i++)days.push((0, $4hBm1.addDays)(fromWeek, i));
    var weeksInMonth = days.reduce(function(result, date) {
        var weekNumber = (options === null || options === void 0 ? void 0 : options.ISOWeek) ? (0, $4hBm1.getISOWeek)(date) : (0, $4hBm1.getWeek)(date, options);
        var existingWeek = result.find(function(value) {
            return value.weekNumber === weekNumber;
        });
        if (existingWeek) {
            existingWeek.dates.push(date);
            return result;
        }
        result.push({
            weekNumber: weekNumber,
            dates: [
                date
            ]
        });
        return result;
    }, []);
    return weeksInMonth;
}
/**
 * Return the weeks belonging to the given month, adding the "outside days" to
 * the first and last week.
 */ function $8e47ba8d561bde0d$var$getMonthWeeks(month, options) {
    var weeksInMonth = $8e47ba8d561bde0d$var$daysToMonthWeeks((0, $4hBm1.startOfMonth)(month), (0, $4hBm1.endOfMonth)(month), options);
    if (options === null || options === void 0 ? void 0 : options.useFixedWeeks) {
        // Add extra weeks to the month, up to 6 weeks
        var nrOfMonthWeeks = (0, $4hBm1.getWeeksInMonth)(month, options);
        if (nrOfMonthWeeks < 6) {
            var lastWeek = weeksInMonth[weeksInMonth.length - 1];
            var lastDate = lastWeek.dates[lastWeek.dates.length - 1];
            var toDate = (0, $4hBm1.addWeeks)(lastDate, 6 - nrOfMonthWeeks);
            var extraWeeks = $8e47ba8d561bde0d$var$daysToMonthWeeks((0, $4hBm1.addWeeks)(lastDate, 1), toDate, options);
            weeksInMonth.push.apply(weeksInMonth, extraWeeks);
        }
    }
    return weeksInMonth;
}
/** Render the table with the calendar. */ function $8e47ba8d561bde0d$var$Table(props) {
    var _a, _b, _c;
    var _d = $8e47ba8d561bde0d$export$332e9e0d64b1f294(), locale = _d.locale, classNames = _d.classNames, styles = _d.styles, hideHead = _d.hideHead, fixedWeeks = _d.fixedWeeks, components = _d.components, weekStartsOn = _d.weekStartsOn, firstWeekContainsDate = _d.firstWeekContainsDate, ISOWeek = _d.ISOWeek;
    var weeks = $8e47ba8d561bde0d$var$getMonthWeeks(props.displayMonth, {
        useFixedWeeks: Boolean(fixedWeeks),
        ISOWeek: ISOWeek,
        locale: locale,
        weekStartsOn: weekStartsOn,
        firstWeekContainsDate: firstWeekContainsDate
    });
    var HeadComponent = (_a = components === null || components === void 0 ? void 0 : components.Head) !== null && _a !== void 0 ? _a : $8e47ba8d561bde0d$export$e93312b7773dfcac;
    var RowComponent = (_b = components === null || components === void 0 ? void 0 : components.Row) !== null && _b !== void 0 ? _b : $8e47ba8d561bde0d$export$b59bdbef9ce70de2;
    var FooterComponent = (_c = components === null || components === void 0 ? void 0 : components.Footer) !== null && _c !== void 0 ? _c : $8e47ba8d561bde0d$export$a06f1c675e846f6f;
    return (0, $4TLFw.jsxs)("table", {
        id: props.id,
        className: classNames.table,
        style: styles.table,
        role: "grid",
        "aria-labelledby": props["aria-labelledby"],
        children: [
            !hideHead && (0, $4TLFw.jsx)(HeadComponent, {}),
            (0, $4TLFw.jsx)("tbody", {
                className: classNames.tbody,
                style: styles.tbody,
                children: weeks.map(function(week) {
                    return (0, $4TLFw.jsx)(RowComponent, {
                        displayMonth: props.displayMonth,
                        dates: week.dates,
                        weekNumber: week.weekNumber
                    }, week.weekNumber);
                })
            }),
            (0, $4TLFw.jsx)(FooterComponent, {
                displayMonth: props.displayMonth
            })
        ]
    });
}
/*
The MIT License (MIT)

Copyright (c) 2018-present, React Training LLC

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/ /* eslint-disable prefer-const */ /* eslint-disable @typescript-eslint/ban-ts-comment */ /*
 * Welcome to @reach/auto-id!
 * Let's see if we can make sense of why this hook exists and its
 * implementation.
 *
 * Some background:
 *   1. Accessibility APIs rely heavily on element IDs
 *   2. Requiring developers to put IDs on every element in Reach UI is both
 *      cumbersome and error-prone
 *   3. With a component model, we can generate IDs for them!
 *
 * Solution 1: Generate random IDs.
 *
 * This works great as long as you don't server render your app. When React (in
 * the client) tries to reuse the markup from the server, the IDs won't match
 * and React will then recreate the entire DOM tree.
 *
 * Solution 2: Increment an integer
 *
 * This sounds great. Since we're rendering the exact same tree on the server
 * and client, we can increment a counter and get a deterministic result between
 * client and server. Also, JS integers can go up to nine-quadrillion. I'm
 * pretty sure the tab will be closed before an app never needs
 * 10 quadrillion IDs!
 *
 * Problem solved, right?
 *
 * Ah, but there's a catch! React's concurrent rendering makes this approach
 * non-deterministic. While the client and server will end up with the same
 * elements in the end, depending on suspense boundaries (and possibly some user
 * input during the initial render) the incrementing integers won't always match
 * up.
 *
 * Solution 3: Don't use IDs at all on the server; patch after first render.
 *
 * What we've done here is solution 2 with some tricks. With this approach, the
 * ID returned is an empty string on the first render. This way the server and
 * client have the same markup no matter how wild the concurrent rendering may
 * have gotten.
 *
 * After the render, we patch up the components with an incremented ID. This
 * causes a double render on any components with `useId`. Shouldn't be a problem
 * since the components using this hook should be small, and we're only updating
 * the ID attribute on the DOM, nothing big is happening.
 *
 * It doesn't have to be an incremented number, though--we could do generate
 * random strings instead, but incrementing a number is probably the cheapest
 * thing we can do.
 *
 * Additionally, we only do this patchup on the very first client render ever.
 * Any calls to `useId` that happen dynamically in the client will be
 * populated immediately with a value. So, we only get the double render after
 * server hydration and never again, SO BACK OFF ALRIGHT?
 */ function $8e47ba8d561bde0d$var$canUseDOM() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
/**
 * React currently throws a warning when using useLayoutEffect on the server. To
 * get around it, we can conditionally useEffect on the server (no-op) and
 * useLayoutEffect in the browser. We occasionally need useLayoutEffect to
 * ensure we don't get a render flash for certain operations, but we may also
 * need affected components to render on the server. One example is when setting
 * a component's descendants to retrieve their index values.
 *
 * Important to note that using this hook as an escape hatch will break the
 * eslint dependency warnings unless you rename the import to `useLayoutEffect`.
 * Use sparingly only when the effect won't effect the rendered HTML to avoid
 * any server/client mismatch.
 *
 * If a useLayoutEffect is needed and the result would create a mismatch, it's
 * likely that the component in question shouldn't be rendered on the server at
 * all, so a better approach would be to lazily render those in a parent
 * component after client-side hydration.
 *
 * https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * https://github.com/reduxjs/react-redux/blob/master/src/utils/useIsomorphicLayoutEffect.js
 *
 * @param effect
 * @param deps
 */ var $8e47ba8d561bde0d$var$useIsomorphicLayoutEffect = $8e47ba8d561bde0d$var$canUseDOM() ? (0, $jbmdS.useLayoutEffect) : (0, $jbmdS.useEffect);
var $8e47ba8d561bde0d$var$serverHandoffComplete = false;
var $8e47ba8d561bde0d$var$id = 0;
function $8e47ba8d561bde0d$var$genId() {
    return "react-day-picker-".concat(++$8e47ba8d561bde0d$var$id);
}
function $8e47ba8d561bde0d$var$useId(providedId) {
    // TODO: Remove error flag when updating internal deps to React 18. None of
    // our tricks will play well with concurrent rendering anyway.
    var _a;
    // If this instance isn't part of the initial render, we don't have to do the
    // double render/patch-up dance. We can just generate the ID and return it.
    var initialId = providedId !== null && providedId !== void 0 ? providedId : $8e47ba8d561bde0d$var$serverHandoffComplete ? $8e47ba8d561bde0d$var$genId() : null;
    var _b = (0, $jbmdS.useState)(initialId), id = _b[0], setId = _b[1];
    $8e47ba8d561bde0d$var$useIsomorphicLayoutEffect(function() {
        if (id === null) // Patch the ID after render. We do this in `useLayoutEffect` to avoid any
        // rendering flicker, though it'll make the first render slower (unlikely
        // to matter, but you're welcome to measure your app and let us know if
        // it's a problem).
        setId($8e47ba8d561bde0d$var$genId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $jbmdS.useEffect)(function() {
        if ($8e47ba8d561bde0d$var$serverHandoffComplete === false) // Flag all future uses of `useId` to skip the update dance. This is in
        // `useEffect` because it goes after `useLayoutEffect`, ensuring we don't
        // accidentally bail out of the patch-up dance prematurely.
        $8e47ba8d561bde0d$var$serverHandoffComplete = true;
    }, []);
    return (_a = providedId !== null && providedId !== void 0 ? providedId : id) !== null && _a !== void 0 ? _a : undefined;
}
/** Render a month. */ function $8e47ba8d561bde0d$var$Month(props) {
    var _a;
    var _b;
    var dayPicker = $8e47ba8d561bde0d$export$332e9e0d64b1f294();
    var dir = dayPicker.dir, classNames = dayPicker.classNames, styles = dayPicker.styles, components = dayPicker.components;
    var displayMonths = $8e47ba8d561bde0d$export$d0fd4b7106de2769().displayMonths;
    var captionId = $8e47ba8d561bde0d$var$useId(dayPicker.id ? "".concat(dayPicker.id, "-").concat(props.displayIndex) : undefined);
    var tableId = dayPicker.id ? "".concat(dayPicker.id, "-grid-").concat(props.displayIndex) : undefined;
    var className = [
        classNames.month
    ];
    var style = styles.month;
    var isStart = props.displayIndex === 0;
    var isEnd = props.displayIndex === displayMonths.length - 1;
    var isCenter = !isStart && !isEnd;
    if (dir === "rtl") _a = [
        isStart,
        isEnd
    ], isEnd = _a[0], isStart = _a[1];
    if (isStart) {
        className.push(classNames.caption_start);
        style = $8e47ba8d561bde0d$var$__assign($8e47ba8d561bde0d$var$__assign({}, style), styles.caption_start);
    }
    if (isEnd) {
        className.push(classNames.caption_end);
        style = $8e47ba8d561bde0d$var$__assign($8e47ba8d561bde0d$var$__assign({}, style), styles.caption_end);
    }
    if (isCenter) {
        className.push(classNames.caption_between);
        style = $8e47ba8d561bde0d$var$__assign($8e47ba8d561bde0d$var$__assign({}, style), styles.caption_between);
    }
    var CaptionComponent = (_b = components === null || components === void 0 ? void 0 : components.Caption) !== null && _b !== void 0 ? _b : $8e47ba8d561bde0d$export$32fbfacc5d962e0c;
    return (0, $4TLFw.jsxs)("div", {
        className: className.join(" "),
        style: style,
        children: [
            (0, $4TLFw.jsx)(CaptionComponent, {
                id: captionId,
                displayMonth: props.displayMonth,
                displayIndex: props.displayIndex
            }),
            (0, $4TLFw.jsx)($8e47ba8d561bde0d$var$Table, {
                id: tableId,
                "aria-labelledby": captionId,
                displayMonth: props.displayMonth
            })
        ]
    }, props.displayIndex);
}
/**
 * Render the wrapper for the month grids.
 */ function $8e47ba8d561bde0d$export$a0ec4efdb90fa181(props) {
    var _a = $8e47ba8d561bde0d$export$332e9e0d64b1f294(), classNames = _a.classNames, styles = _a.styles;
    return (0, $4TLFw.jsx)("div", {
        className: classNames.months,
        style: styles.months,
        children: props.children
    });
}
/** Render the container with the months according to the number of months to display. */ function $8e47ba8d561bde0d$var$Root(_a) {
    var _b, _c;
    var initialProps = _a.initialProps;
    var dayPicker = $8e47ba8d561bde0d$export$332e9e0d64b1f294();
    var focusContext = $8e47ba8d561bde0d$export$69130071837c676e();
    var navigation = $8e47ba8d561bde0d$export$d0fd4b7106de2769();
    var _d = (0, $jbmdS.useState)(false), hasInitialFocus = _d[0], setHasInitialFocus = _d[1];
    // Focus the focus target when initialFocus is passed in
    (0, $jbmdS.useEffect)(function() {
        if (!dayPicker.initialFocus) return;
        if (!focusContext.focusTarget) return;
        if (hasInitialFocus) return;
        focusContext.focus(focusContext.focusTarget);
        setHasInitialFocus(true);
    }, [
        dayPicker.initialFocus,
        hasInitialFocus,
        focusContext.focus,
        focusContext.focusTarget,
        focusContext
    ]);
    // Apply classnames according to props
    var classNames = [
        dayPicker.classNames.root,
        dayPicker.className
    ];
    if (dayPicker.numberOfMonths > 1) classNames.push(dayPicker.classNames.multiple_months);
    if (dayPicker.showWeekNumber) classNames.push(dayPicker.classNames.with_weeknumber);
    var style = $8e47ba8d561bde0d$var$__assign($8e47ba8d561bde0d$var$__assign({}, dayPicker.styles.root), dayPicker.style);
    var dataAttributes = Object.keys(initialProps).filter(function(key) {
        return key.startsWith("data-");
    }).reduce(function(attrs, key) {
        var _a;
        return $8e47ba8d561bde0d$var$__assign($8e47ba8d561bde0d$var$__assign({}, attrs), (_a = {}, _a[key] = initialProps[key], _a));
    }, {});
    var MonthsComponent = (_c = (_b = initialProps.components) === null || _b === void 0 ? void 0 : _b.Months) !== null && _c !== void 0 ? _c : $8e47ba8d561bde0d$export$a0ec4efdb90fa181;
    return (0, $4TLFw.jsx)("div", $8e47ba8d561bde0d$var$__assign({
        className: classNames.join(" "),
        style: style,
        dir: dayPicker.dir,
        id: dayPicker.id,
        nonce: initialProps.nonce,
        title: initialProps.title,
        lang: initialProps.lang
    }, dataAttributes, {
        children: (0, $4TLFw.jsx)(MonthsComponent, {
            children: navigation.displayMonths.map(function(month, i) {
                return (0, $4TLFw.jsx)($8e47ba8d561bde0d$var$Month, {
                    displayIndex: i,
                    displayMonth: month
                }, i);
            })
        })
    }));
}
/** Provide the value for all the context providers. */ function $8e47ba8d561bde0d$export$8f349d07558f59c4(props) {
    var children = props.children, initialProps = $8e47ba8d561bde0d$var$__rest(props, [
        "children"
    ]);
    return (0, $4TLFw.jsx)($8e47ba8d561bde0d$export$a84f964d022d25c, {
        initialProps: initialProps,
        children: (0, $4TLFw.jsx)($8e47ba8d561bde0d$export$d91daf425539f32f, {
            children: (0, $4TLFw.jsx)($8e47ba8d561bde0d$export$d40a11a5bbe785ba, {
                initialProps: initialProps,
                children: (0, $4TLFw.jsx)($8e47ba8d561bde0d$export$913827019032c8d4, {
                    initialProps: initialProps,
                    children: (0, $4TLFw.jsx)($8e47ba8d561bde0d$export$deb49a47c7ee5fdf, {
                        initialProps: initialProps,
                        children: (0, $4TLFw.jsx)($8e47ba8d561bde0d$var$ModifiersProvider, {
                            children: (0, $4TLFw.jsx)($8e47ba8d561bde0d$export$97cf4ab9b312b61a, {
                                children: children
                            })
                        })
                    })
                })
            })
        })
    });
}
/**
 * DayPicker render a date picker component to let users pick dates from a
 * calendar. See http://react-day-picker.js.org for updated documentation and
 * examples.
 *
 * ### Customization
 *
 * DayPicker offers different customization props. For example,
 *
 * - show multiple months using `numberOfMonths`
 * - display a dropdown to navigate the months via `captionLayout`
 * - display the week numbers with `showWeekNumbers`
 * - disable or hide days with `disabled` or `hidden`
 *
 * ### Controlling the months
 *
 * Change the initially displayed month using the `defaultMonth` prop. The
 * displayed months are controlled by DayPicker and stored in its internal
 * state. To control the months yourself, use `month` instead of `defaultMonth`
 * and use the `onMonthChange` event to set it.
 *
 * To limit the months the user can navigate to, use
 * `fromDate`/`fromMonth`/`fromYear` or `toDate`/`toMonth`/`toYear`.
 *
 * ### Selection modes
 *
 * DayPicker supports different selection mode that can be toggled using the
 * `mode` prop:
 *
 * - `mode="single"`: only one day can be selected. Use `required` to make the
 *   selection required. Use the `onSelect` event handler to get the selected
 *   days.
 * - `mode="multiple"`: users can select one or more days. Limit the amount of
 *   days that can be selected with the `min` or the `max` props.
 * - `mode="range"`: users can select a range of days. Limit the amount of days
 *   in the range with the `min` or the `max` props.
 * - `mode="default"` (default): the built-in selections are disabled. Implement
 *   your own selection mode with `onDayClick`.
 *
 * The selection modes should cover the most common use cases. In case you
 * need a more refined way of selecting days, use `mode="default"`. Use the
 * `selected` props and add the day event handlers to add/remove days from the
 * selection.
 *
 * ### Modifiers
 *
 * A _modifier_ represents different styles or states for the days displayed in
 * the calendar (like "selected" or "disabled"). Define custom modifiers using
 * the `modifiers` prop.
 *
 * ### Formatters and custom component
 *
 * You can customize how the content is displayed in the date picker by using
 * either the formatters or replacing the internal components.
 *
 * For the most common cases you want to use the `formatters` prop to change how
 * the content is formatted in the calendar. Use the `components` prop to
 * replace the internal components, like the navigation icons.
 *
 * ### Styling
 *
 * DayPicker comes with a default, basic style in `react-day-picker/style` – use
 * it as template for your own style.
 *
 * If you are using CSS modules, pass the imported styles object the
 * `classNames` props.
 *
 * You can also style the elements via inline styles using the `styles` prop.
 *
 * ### Form fields
 *
 * If you need to bind the date picker to a form field, you can use the
 * `useInput` hooks for a basic behavior. See the `useInput` source as an
 * example to bind the date picker with form fields.
 *
 * ### Localization
 *
 * To localize DayPicker, import the locale from `date-fns` package and use the
 * `locale` prop.
 *
 * For example, to use Spanish locale:
 *
 * ```
 * import { es } from 'date-fns/locale';
 * <DayPicker locale={es} />
 * ```
 */ function $8e47ba8d561bde0d$export$97e6db89a86ff7ab(props) {
    return (0, $4TLFw.jsx)($8e47ba8d561bde0d$export$8f349d07558f59c4, $8e47ba8d561bde0d$var$__assign({}, props, {
        children: (0, $4TLFw.jsx)($8e47ba8d561bde0d$var$Root, {
            initialProps: props
        })
    }));
}
/** @private */ function $8e47ba8d561bde0d$var$isValidDate(day) {
    return !isNaN(day.getTime());
}
/** Return props and setters for binding an input field to DayPicker. */ function $8e47ba8d561bde0d$export$1e36b9f257eee5fa(options) {
    if (options === void 0) options = {};
    var _a = options.locale, locale = _a === void 0 ? (0, $aBC3c.enUS) : _a, required = options.required, _b = options.format, format$1 = _b === void 0 ? "PP" : _b, defaultSelected = options.defaultSelected, _c = options.today, today = _c === void 0 ? new Date() : _c;
    var _d = $8e47ba8d561bde0d$var$parseFromToProps(options), fromDate = _d.fromDate, toDate = _d.toDate;
    // Shortcut to the DateFns functions
    var parseValue = function(value) {
        return (0, $4hBm1.parse)(value, format$1, today, {
            locale: locale
        });
    };
    // Initialize states
    var _e = (0, $jbmdS.useState)(defaultSelected !== null && defaultSelected !== void 0 ? defaultSelected : today), month = _e[0], setMonth = _e[1];
    var _f = (0, $jbmdS.useState)(defaultSelected), selectedDay = _f[0], setSelectedDay = _f[1];
    var defaultInputValue = defaultSelected ? (0, $4hBm1.format)(defaultSelected, format$1, {
        locale: locale
    }) : "";
    var _g = (0, $jbmdS.useState)(defaultInputValue), inputValue = _g[0], setInputValue = _g[1];
    var reset = function() {
        setSelectedDay(defaultSelected);
        setMonth(defaultSelected !== null && defaultSelected !== void 0 ? defaultSelected : today);
        setInputValue(defaultInputValue !== null && defaultInputValue !== void 0 ? defaultInputValue : "");
    };
    var setSelected = function(date) {
        setSelectedDay(date);
        setMonth(date !== null && date !== void 0 ? date : today);
        setInputValue(date ? (0, $4hBm1.format)(date, format$1, {
            locale: locale
        }) : "");
    };
    var handleDayClick = function(day, _a) {
        var selected = _a.selected;
        if (!required && selected) {
            setSelectedDay(undefined);
            setInputValue("");
            return;
        }
        setSelectedDay(day);
        setInputValue(day ? (0, $4hBm1.format)(day, format$1, {
            locale: locale
        }) : "");
    };
    var handleMonthChange = function(month) {
        setMonth(month);
    };
    // When changing the input field, save its value in state and check if the
    // string is a valid date. If it is a valid day, set it as selected and update
    // the calendar’s month.
    var handleChange = function(e) {
        setInputValue(e.target.value);
        var day = parseValue(e.target.value);
        var isBefore = fromDate && (0, $4hBm1.differenceInCalendarDays)(fromDate, day) > 0;
        var isAfter = toDate && (0, $4hBm1.differenceInCalendarDays)(day, toDate) > 0;
        if (!$8e47ba8d561bde0d$var$isValidDate(day) || isBefore || isAfter) {
            setSelectedDay(undefined);
            return;
        }
        setSelectedDay(day);
        setMonth(day);
    };
    // Special case for _required_ fields: on blur, if the value of the input is not
    // a valid date, reset the calendar and the input value.
    var handleBlur = function(e) {
        var day = parseValue(e.target.value);
        if (!$8e47ba8d561bde0d$var$isValidDate(day)) reset();
    };
    // When focusing, make sure DayPicker visualizes the month of the date in the
    // input field.
    var handleFocus = function(e) {
        if (!e.target.value) {
            reset();
            return;
        }
        var day = parseValue(e.target.value);
        if ($8e47ba8d561bde0d$var$isValidDate(day)) setMonth(day);
    };
    var dayPickerProps = {
        month: month,
        onDayClick: handleDayClick,
        onMonthChange: handleMonthChange,
        selected: selectedDay,
        locale: locale,
        fromDate: fromDate,
        toDate: toDate,
        today: today
    };
    var inputProps = {
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        value: inputValue,
        placeholder: (0, $4hBm1.format)(new Date(), format$1, {
            locale: locale
        })
    };
    return {
        dayPickerProps: dayPickerProps,
        inputProps: inputProps,
        reset: reset,
        setSelected: setSelected
    };
}
/** Returns true when the props are of type {@link DayPickerDefaultProps}. */ function $8e47ba8d561bde0d$export$92cab9761365b1ec(props) {
    return props.mode === undefined || props.mode === "default";
}

});

parcelRegister("3Gs4l", function(module, exports) {

$parcel$export(module.exports, "Select", function () { return $4fde388597381492$export$ef9b1a59e592288f; });
$parcel$export(module.exports, "SelectGroup", function () { return $4fde388597381492$export$ee25a334c55de1f4; });
$parcel$export(module.exports, "SelectValue", function () { return $4fde388597381492$export$e288731fd71264f0; });
$parcel$export(module.exports, "SelectTrigger", function () { return $4fde388597381492$export$3ac1e88a1c0b9f1; });
$parcel$export(module.exports, "SelectContent", function () { return $4fde388597381492$export$c973a4b3cb86a03d; });
$parcel$export(module.exports, "SelectItem", function () { return $4fde388597381492$export$13ef48a934230896; });
$parcel$export(module.exports, "SelectWithLabel", function () { return $4fde388597381492$export$2d49384d850eb0d6; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $bSr1M = parcelRequire("bSr1M");

var $1kvoC = parcelRequire("1kvoC");
var $lKdR6 = parcelRequire("lKdR6");
var $joA1X = parcelRequire("joA1X");

var $Yha9m = parcelRequire("Yha9m");

var $5XMpG = parcelRequire("5XMpG");
const $4fde388597381492$export$ef9b1a59e592288f = $bSr1M.Root;
const $4fde388597381492$export$ee25a334c55de1f4 = $bSr1M.Group;
const $4fde388597381492$export$e288731fd71264f0 = $bSr1M.Value;
const $4fde388597381492$export$3ac1e88a1c0b9f1 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, children: children, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsxs)($bSr1M.Trigger, {
        ref: ref,
        className: (0, $Yha9m.cn)("flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-ring focus:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1", className),
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, $61Ea1.jsx)($bSr1M.Icon, {
                asChild: true,
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $lKdR6.default), {
                    className: "h-4 w-4 opacity-50"
                })
            })
        ]
    }));
$4fde388597381492$export$3ac1e88a1c0b9f1.displayName = $bSr1M.Trigger.displayName;
const $4fde388597381492$export$d8117927658af6d7 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)($bSr1M.ScrollUpButton, {
        ref: ref,
        className: (0, $Yha9m.cn)("flex cursor-default items-center justify-center py-1", className),
        ...props,
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $joA1X.default), {
            className: "h-4 w-4"
        })
    }));
$4fde388597381492$export$d8117927658af6d7.displayName = $bSr1M.ScrollUpButton.displayName;
const $4fde388597381492$export$ff951e476c12189 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)($bSr1M.ScrollDownButton, {
        ref: ref,
        className: (0, $Yha9m.cn)("flex cursor-default items-center justify-center py-1", className),
        ...props,
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $lKdR6.default), {
            className: "h-4 w-4"
        })
    }));
$4fde388597381492$export$ff951e476c12189.displayName = $bSr1M.ScrollDownButton.displayName;
const $4fde388597381492$export$c973a4b3cb86a03d = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, children: children, position: position = "popper", ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)($bSr1M.Portal, {
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)($bSr1M.Content, {
            ref: ref,
            className: (0, $Yha9m.cn)("relative z-50 max-h-96 min-w-[8rem] overflow-hidden rounded-md border bg-popover text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", position === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1", className),
            position: position,
            ...props,
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsx)($4fde388597381492$export$d8117927658af6d7, {}),
                /*#__PURE__*/ (0, $61Ea1.jsx)($bSr1M.Viewport, {
                    className: (0, $Yha9m.cn)("p-1", position === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"),
                    children: children
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)($4fde388597381492$export$ff951e476c12189, {})
            ]
        })
    }));
$4fde388597381492$export$c973a4b3cb86a03d.displayName = $bSr1M.Content.displayName;
const $4fde388597381492$export$f67338d29bd972f8 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)($bSr1M.Label, {
        ref: ref,
        className: (0, $Yha9m.cn)("py-1.5 pl-8 pr-2 text-sm font-semibold", className),
        ...props
    }));
$4fde388597381492$export$f67338d29bd972f8.displayName = $bSr1M.Label.displayName;
const $4fde388597381492$export$13ef48a934230896 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, children: children, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsxs)($bSr1M.Item, {
        ref: ref,
        className: (0, $Yha9m.cn)("relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50", className),
        ...props,
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)($bSr1M.ItemIndicator, {
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $1kvoC.default), {
                        className: "h-4 w-4"
                    })
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)($bSr1M.ItemText, {
                children: children
            })
        ]
    }));
$4fde388597381492$export$13ef48a934230896.displayName = $bSr1M.Item.displayName;
const $4fde388597381492$export$eba4b1df07cb1d3 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)($bSr1M.Separator, {
        ref: ref,
        className: (0, $Yha9m.cn)("-mx-1 my-1 h-px bg-muted", className),
        ...props
    }));
$4fde388597381492$export$eba4b1df07cb1d3.displayName = $bSr1M.Separator.displayName;
const $4fde388597381492$export$2d49384d850eb0d6 = ({ defaultValue: defaultValue, value: value, onValueChange: onValueChange, options: options = [], placeholder: placeholder = "Select...", className: className, label: label, editable: editable = true })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: (0, $Yha9m.cn)("flex items-center space-x-2", className),
        children: [
            label ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5XMpG.Label), {
                children: label
            }) : null,
            /*#__PURE__*/ (0, $61Ea1.jsxs)($4fde388597381492$export$ef9b1a59e592288f, {
                defaultValue: defaultValue,
                value: value,
                onValueChange: onValueChange,
                disabled: !editable,
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)($4fde388597381492$export$3ac1e88a1c0b9f1, {
                        className: "w-[180px] mx-auto",
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)($4fde388597381492$export$e288731fd71264f0, {
                            placeholder: placeholder
                        })
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)($4fde388597381492$export$c973a4b3cb86a03d, {
                        children: options.map((op)=>/*#__PURE__*/ (0, $61Ea1.jsx)($4fde388597381492$export$13ef48a934230896, {
                                value: op === null || op === void 0 ? void 0 : op.value,
                                children: op === null || op === void 0 ? void 0 : op.label
                            }, op === null || op === void 0 ? void 0 : op.key))
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("bSr1M", function(module, exports) {

$parcel$export(module.exports, "Root", function () { return $c142b84a15be9b78$export$be92b6f5f03c0fe9; });
$parcel$export(module.exports, "Trigger", function () { return $c142b84a15be9b78$export$41fb9f06171c75f4; });
$parcel$export(module.exports, "Value", function () { return $c142b84a15be9b78$export$4c8d1a57a761ef94; });
$parcel$export(module.exports, "Icon", function () { return $c142b84a15be9b78$export$f04a61298a47a40f; });
$parcel$export(module.exports, "Portal", function () { return $c142b84a15be9b78$export$602eac185826482c; });
$parcel$export(module.exports, "Content", function () { return $c142b84a15be9b78$export$7c6e2c02157bb7d2; });
$parcel$export(module.exports, "Viewport", function () { return $c142b84a15be9b78$export$d5c6c08dc2d3ca7; });
$parcel$export(module.exports, "Group", function () { return $c142b84a15be9b78$export$eb2fcfdbd7ba97d4; });
$parcel$export(module.exports, "Label", function () { return $c142b84a15be9b78$export$b04be29aa201d4f5; });
$parcel$export(module.exports, "Item", function () { return $c142b84a15be9b78$export$6d08773d2e66f8f2; });
$parcel$export(module.exports, "ItemText", function () { return $c142b84a15be9b78$export$d6e5bf9c43ea9319; });
$parcel$export(module.exports, "ItemIndicator", function () { return $c142b84a15be9b78$export$c3468e2714d175fa; });
$parcel$export(module.exports, "ScrollUpButton", function () { return $c142b84a15be9b78$export$2f60d3ec9ad468f2; });
$parcel$export(module.exports, "ScrollDownButton", function () { return $c142b84a15be9b78$export$bf1aedc3039c8d63; });
$parcel$export(module.exports, "Separator", function () { return $c142b84a15be9b78$export$1ff3c3f08ae963c0; });

var $jbmdS = parcelRequire("jbmdS");

var $jCNM0 = parcelRequire("jCNM0");

var $kMiXC = parcelRequire("kMiXC");

var $hFcKE = parcelRequire("hFcKE");

var $g2eqD = parcelRequire("g2eqD");

var $9sunj = parcelRequire("9sunj");

var $f4RZG = parcelRequire("f4RZG");

var $9czjk = parcelRequire("9czjk");

var $jJBMp = parcelRequire("jJBMp");

var $fbZ8r = parcelRequire("fbZ8r");

var $i3HOY = parcelRequire("i3HOY");

var $g7F3X = parcelRequire("g7F3X");

var $aU3NZ = parcelRequire("aU3NZ");

var $fKp8B = parcelRequire("fKp8B");

var $cihg9 = parcelRequire("cihg9");

var $bXq35 = parcelRequire("bXq35");

var $kjEX1 = parcelRequire("kjEX1");

var $1sq0Q = parcelRequire("1sq0Q");

var $9crHl = parcelRequire("9crHl");

var $f4s2q = parcelRequire("f4s2q");

var $fLY1n = parcelRequire("fLY1n");

var $9Y02g = parcelRequire("9Y02g");

var $gQkjX = parcelRequire("gQkjX");

var $4TLFw = parcelRequire("4TLFw");
"use client";
var $c142b84a15be9b78$var$OPEN_KEYS = [
    " ",
    "Enter",
    "ArrowUp",
    "ArrowDown"
];
var $c142b84a15be9b78$var$SELECTION_KEYS = [
    " ",
    "Enter"
];
var $c142b84a15be9b78$var$SELECT_NAME = "Select";
var [$c142b84a15be9b78$var$Collection, $c142b84a15be9b78$var$useCollection, $c142b84a15be9b78$var$createCollectionScope] = (0, $g2eqD.createCollection)($c142b84a15be9b78$var$SELECT_NAME);
var [$c142b84a15be9b78$var$createSelectContext, $c142b84a15be9b78$export$286727a75dc039bd] = (0, $f4RZG.createContextScope)($c142b84a15be9b78$var$SELECT_NAME, [
    $c142b84a15be9b78$var$createCollectionScope,
    (0, $aU3NZ.createPopperScope)
]);
var $c142b84a15be9b78$var$usePopperScope = (0, $aU3NZ.createPopperScope)();
var [$c142b84a15be9b78$var$SelectProvider, $c142b84a15be9b78$var$useSelectContext] = $c142b84a15be9b78$var$createSelectContext($c142b84a15be9b78$var$SELECT_NAME);
var [$c142b84a15be9b78$var$SelectNativeOptionsProvider, $c142b84a15be9b78$var$useSelectNativeOptionsContext] = $c142b84a15be9b78$var$createSelectContext($c142b84a15be9b78$var$SELECT_NAME);
var $c142b84a15be9b78$export$ef9b1a59e592288f = (props)=>{
    const { __scopeSelect: __scopeSelect, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, value: valueProp, defaultValue: defaultValue, onValueChange: onValueChange, dir: dir, name: name, autoComplete: autoComplete, disabled: disabled, required: required, form: form } = props;
    const popperScope = $c142b84a15be9b78$var$usePopperScope(__scopeSelect);
    const [trigger, setTrigger] = $jbmdS.useState(null);
    const [valueNode, setValueNode] = $jbmdS.useState(null);
    const [valueNodeHasChildren, setValueNodeHasChildren] = $jbmdS.useState(false);
    const direction = (0, $9czjk.useDirection)(dir);
    const [open = false, setOpen] = (0, $1sq0Q.useControllableState)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    const [value, setValue] = (0, $1sq0Q.useControllableState)({
        prop: valueProp,
        defaultProp: defaultValue,
        onChange: onValueChange
    });
    const triggerPointerDownPosRef = $jbmdS.useRef(null);
    const isFormControl = trigger ? form || !!trigger.closest("form") : true;
    const [nativeOptionsSet, setNativeOptionsSet] = $jbmdS.useState(/* @__PURE__ */ new Set());
    const nativeSelectKey = Array.from(nativeOptionsSet).map((option)=>option.props.value).join(";");
    return /* @__PURE__ */ (0, $4TLFw.jsx)($aU3NZ.Root, {
        ...popperScope,
        children: /* @__PURE__ */ (0, $4TLFw.jsxs)($c142b84a15be9b78$var$SelectProvider, {
            required: required,
            scope: __scopeSelect,
            trigger: trigger,
            onTriggerChange: setTrigger,
            valueNode: valueNode,
            onValueNodeChange: setValueNode,
            valueNodeHasChildren: valueNodeHasChildren,
            onValueNodeHasChildrenChange: setValueNodeHasChildren,
            contentId: (0, $g7F3X.useId)(),
            value: value,
            onValueChange: setValue,
            open: open,
            onOpenChange: setOpen,
            dir: direction,
            triggerPointerDownPosRef: triggerPointerDownPosRef,
            disabled: disabled,
            children: [
                /* @__PURE__ */ (0, $4TLFw.jsx)($c142b84a15be9b78$var$Collection.Provider, {
                    scope: __scopeSelect,
                    children: /* @__PURE__ */ (0, $4TLFw.jsx)($c142b84a15be9b78$var$SelectNativeOptionsProvider, {
                        scope: props.__scopeSelect,
                        onNativeOptionAdd: $jbmdS.useCallback((option)=>{
                            setNativeOptionsSet((prev)=>new Set(prev).add(option));
                        }, []),
                        onNativeOptionRemove: $jbmdS.useCallback((option)=>{
                            setNativeOptionsSet((prev)=>{
                                const optionsSet = new Set(prev);
                                optionsSet.delete(option);
                                return optionsSet;
                            });
                        }, []),
                        children: children
                    })
                }),
                isFormControl ? /* @__PURE__ */ (0, $4TLFw.jsxs)($c142b84a15be9b78$var$BubbleSelect, {
                    "aria-hidden": true,
                    required: required,
                    tabIndex: -1,
                    name: name,
                    autoComplete: autoComplete,
                    value: value,
                    onChange: (event)=>setValue(event.target.value),
                    disabled: disabled,
                    form: form,
                    children: [
                        value === void 0 ? /* @__PURE__ */ (0, $4TLFw.jsx)("option", {
                            value: ""
                        }) : null,
                        Array.from(nativeOptionsSet)
                    ]
                }, nativeSelectKey) : null
            ]
        })
    });
};
$c142b84a15be9b78$export$ef9b1a59e592288f.displayName = $c142b84a15be9b78$var$SELECT_NAME;
var $c142b84a15be9b78$var$TRIGGER_NAME = "SelectTrigger";
var $c142b84a15be9b78$export$3ac1e88a1c0b9f1 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, disabled: disabled = false, ...triggerProps } = props;
    const popperScope = $c142b84a15be9b78$var$usePopperScope(__scopeSelect);
    const context = $c142b84a15be9b78$var$useSelectContext($c142b84a15be9b78$var$TRIGGER_NAME, __scopeSelect);
    const isDisabled = context.disabled || disabled;
    const composedRefs = (0, $9sunj.useComposedRefs)(forwardedRef, context.onTriggerChange);
    const getItems = $c142b84a15be9b78$var$useCollection(__scopeSelect);
    const pointerTypeRef = $jbmdS.useRef("touch");
    const [searchRef, handleTypeaheadSearch, resetTypeahead] = $c142b84a15be9b78$var$useTypeaheadSearch((search)=>{
        const enabledItems = getItems().filter((item)=>!item.disabled);
        const currentItem = enabledItems.find((item)=>item.value === context.value);
        const nextItem = $c142b84a15be9b78$var$findNextItem(enabledItems, search, currentItem);
        if (nextItem !== void 0) context.onValueChange(nextItem.value);
    });
    const handleOpen = (pointerEvent)=>{
        if (!isDisabled) {
            context.onOpenChange(true);
            resetTypeahead();
        }
        if (pointerEvent) context.triggerPointerDownPosRef.current = {
            x: Math.round(pointerEvent.pageX),
            y: Math.round(pointerEvent.pageY)
        };
    };
    return /* @__PURE__ */ (0, $4TLFw.jsx)($aU3NZ.Anchor, {
        asChild: true,
        ...popperScope,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).button, {
            type: "button",
            role: "combobox",
            "aria-controls": context.contentId,
            "aria-expanded": context.open,
            "aria-required": context.required,
            "aria-autocomplete": "none",
            dir: context.dir,
            "data-state": context.open ? "open" : "closed",
            disabled: isDisabled,
            "data-disabled": isDisabled ? "" : void 0,
            "data-placeholder": $c142b84a15be9b78$var$shouldShowPlaceholder(context.value) ? "" : void 0,
            ...triggerProps,
            ref: composedRefs,
            onClick: (0, $hFcKE.composeEventHandlers)(triggerProps.onClick, (event)=>{
                event.currentTarget.focus();
                if (pointerTypeRef.current !== "mouse") handleOpen(event);
            }),
            onPointerDown: (0, $hFcKE.composeEventHandlers)(triggerProps.onPointerDown, (event)=>{
                pointerTypeRef.current = event.pointerType;
                const target = event.target;
                if (target.hasPointerCapture(event.pointerId)) target.releasePointerCapture(event.pointerId);
                if (event.button === 0 && event.ctrlKey === false && event.pointerType === "mouse") {
                    handleOpen(event);
                    event.preventDefault();
                }
            }),
            onKeyDown: (0, $hFcKE.composeEventHandlers)(triggerProps.onKeyDown, (event)=>{
                const isTypingAhead = searchRef.current !== "";
                const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
                if (!isModifierKey && event.key.length === 1) handleTypeaheadSearch(event.key);
                if (isTypingAhead && event.key === " ") return;
                if ($c142b84a15be9b78$var$OPEN_KEYS.includes(event.key)) {
                    handleOpen();
                    event.preventDefault();
                }
            })
        })
    });
});
$c142b84a15be9b78$export$3ac1e88a1c0b9f1.displayName = $c142b84a15be9b78$var$TRIGGER_NAME;
var $c142b84a15be9b78$var$VALUE_NAME = "SelectValue";
var $c142b84a15be9b78$export$e288731fd71264f0 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, className: className, style: style, children: children, placeholder: placeholder = "", ...valueProps } = props;
    const context = $c142b84a15be9b78$var$useSelectContext($c142b84a15be9b78$var$VALUE_NAME, __scopeSelect);
    const { onValueNodeHasChildrenChange: onValueNodeHasChildrenChange } = context;
    const hasChildren = children !== void 0;
    const composedRefs = (0, $9sunj.useComposedRefs)(forwardedRef, context.onValueNodeChange);
    (0, $9crHl.useLayoutEffect)(()=>{
        onValueNodeHasChildrenChange(hasChildren);
    }, [
        onValueNodeHasChildrenChange,
        hasChildren
    ]);
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).span, {
        ...valueProps,
        ref: composedRefs,
        style: {
            pointerEvents: "none"
        },
        children: $c142b84a15be9b78$var$shouldShowPlaceholder(context.value) ? /* @__PURE__ */ (0, $4TLFw.jsx)((0, $4TLFw.Fragment), {
            children: placeholder
        }) : children
    });
});
$c142b84a15be9b78$export$e288731fd71264f0.displayName = $c142b84a15be9b78$var$VALUE_NAME;
var $c142b84a15be9b78$var$ICON_NAME = "SelectIcon";
var $c142b84a15be9b78$export$99b400cabb58c515 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, children: children, ...iconProps } = props;
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).span, {
        "aria-hidden": true,
        ...iconProps,
        ref: forwardedRef,
        children: children || "\u25BC"
    });
});
$c142b84a15be9b78$export$99b400cabb58c515.displayName = $c142b84a15be9b78$var$ICON_NAME;
var $c142b84a15be9b78$var$PORTAL_NAME = "SelectPortal";
var $c142b84a15be9b78$export$b2af6c9944296213 = (props)=>{
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $fKp8B.Portal), {
        asChild: true,
        ...props
    });
};
$c142b84a15be9b78$export$b2af6c9944296213.displayName = $c142b84a15be9b78$var$PORTAL_NAME;
var $c142b84a15be9b78$var$CONTENT_NAME = "SelectContent";
var $c142b84a15be9b78$export$c973a4b3cb86a03d = $jbmdS.forwardRef((props, forwardedRef)=>{
    const context = $c142b84a15be9b78$var$useSelectContext($c142b84a15be9b78$var$CONTENT_NAME, props.__scopeSelect);
    const [fragment, setFragment] = $jbmdS.useState();
    (0, $9crHl.useLayoutEffect)(()=>{
        setFragment(new DocumentFragment());
    }, []);
    if (!context.open) {
        const frag = fragment;
        return frag ? $jCNM0.createPortal(/* @__PURE__ */ (0, $4TLFw.jsx)($c142b84a15be9b78$var$SelectContentProvider, {
            scope: props.__scopeSelect,
            children: /* @__PURE__ */ (0, $4TLFw.jsx)($c142b84a15be9b78$var$Collection.Slot, {
                scope: props.__scopeSelect,
                children: /* @__PURE__ */ (0, $4TLFw.jsx)("div", {
                    children: props.children
                })
            })
        }), frag) : null;
    }
    return /* @__PURE__ */ (0, $4TLFw.jsx)($c142b84a15be9b78$var$SelectContentImpl, {
        ...props,
        ref: forwardedRef
    });
});
$c142b84a15be9b78$export$c973a4b3cb86a03d.displayName = $c142b84a15be9b78$var$CONTENT_NAME;
var $c142b84a15be9b78$var$CONTENT_MARGIN = 10;
var [$c142b84a15be9b78$var$SelectContentProvider, $c142b84a15be9b78$var$useSelectContentContext] = $c142b84a15be9b78$var$createSelectContext($c142b84a15be9b78$var$CONTENT_NAME);
var $c142b84a15be9b78$var$CONTENT_IMPL_NAME = "SelectContentImpl";
var $c142b84a15be9b78$var$SelectContentImpl = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, position: position = "item-aligned", onCloseAutoFocus: onCloseAutoFocus, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, side: //
    // PopperContent props
    side, sideOffset: sideOffset, align: align, alignOffset: alignOffset, arrowPadding: arrowPadding, collisionBoundary: collisionBoundary, collisionPadding: collisionPadding, sticky: sticky, hideWhenDetached: hideWhenDetached, avoidCollisions: avoidCollisions, //
    ...contentProps } = props;
    const context = $c142b84a15be9b78$var$useSelectContext($c142b84a15be9b78$var$CONTENT_NAME, __scopeSelect);
    const [content, setContent] = $jbmdS.useState(null);
    const [viewport, setViewport] = $jbmdS.useState(null);
    const composedRefs = (0, $9sunj.useComposedRefs)(forwardedRef, (node)=>setContent(node));
    const [selectedItem, setSelectedItem] = $jbmdS.useState(null);
    const [selectedItemText, setSelectedItemText] = $jbmdS.useState(null);
    const getItems = $c142b84a15be9b78$var$useCollection(__scopeSelect);
    const [isPositioned, setIsPositioned] = $jbmdS.useState(false);
    const firstValidItemFoundRef = $jbmdS.useRef(false);
    $jbmdS.useEffect(()=>{
        if (content) return (0, $9Y02g.hideOthers)(content);
    }, [
        content
    ]);
    (0, $fbZ8r.useFocusGuards)();
    const focusFirst = $jbmdS.useCallback((candidates)=>{
        const [firstItem, ...restItems] = getItems().map((item)=>item.ref.current);
        const [lastItem] = restItems.slice(-1);
        const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
        for (const candidate of candidates){
            if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
            candidate?.scrollIntoView({
                block: "nearest"
            });
            if (candidate === firstItem && viewport) viewport.scrollTop = 0;
            if (candidate === lastItem && viewport) viewport.scrollTop = viewport.scrollHeight;
            candidate?.focus();
            if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
        }
    }, [
        getItems,
        viewport
    ]);
    const focusSelectedItem = $jbmdS.useCallback(()=>focusFirst([
            selectedItem,
            content
        ]), [
        focusFirst,
        selectedItem,
        content
    ]);
    $jbmdS.useEffect(()=>{
        if (isPositioned) focusSelectedItem();
    }, [
        isPositioned,
        focusSelectedItem
    ]);
    const { onOpenChange: onOpenChange, triggerPointerDownPosRef: triggerPointerDownPosRef } = context;
    $jbmdS.useEffect(()=>{
        if (content) {
            let pointerMoveDelta = {
                x: 0,
                y: 0
            };
            const handlePointerMove = (event)=>{
                pointerMoveDelta = {
                    x: Math.abs(Math.round(event.pageX) - (triggerPointerDownPosRef.current?.x ?? 0)),
                    y: Math.abs(Math.round(event.pageY) - (triggerPointerDownPosRef.current?.y ?? 0))
                };
            };
            const handlePointerUp = (event)=>{
                if (pointerMoveDelta.x <= 10 && pointerMoveDelta.y <= 10) event.preventDefault();
                else if (!content.contains(event.target)) onOpenChange(false);
                document.removeEventListener("pointermove", handlePointerMove);
                triggerPointerDownPosRef.current = null;
            };
            if (triggerPointerDownPosRef.current !== null) {
                document.addEventListener("pointermove", handlePointerMove);
                document.addEventListener("pointerup", handlePointerUp, {
                    capture: true,
                    once: true
                });
            }
            return ()=>{
                document.removeEventListener("pointermove", handlePointerMove);
                document.removeEventListener("pointerup", handlePointerUp, {
                    capture: true
                });
            };
        }
    }, [
        content,
        onOpenChange,
        triggerPointerDownPosRef
    ]);
    $jbmdS.useEffect(()=>{
        const close = ()=>onOpenChange(false);
        window.addEventListener("blur", close);
        window.addEventListener("resize", close);
        return ()=>{
            window.removeEventListener("blur", close);
            window.removeEventListener("resize", close);
        };
    }, [
        onOpenChange
    ]);
    const [searchRef, handleTypeaheadSearch] = $c142b84a15be9b78$var$useTypeaheadSearch((search)=>{
        const enabledItems = getItems().filter((item)=>!item.disabled);
        const currentItem = enabledItems.find((item)=>item.ref.current === document.activeElement);
        const nextItem = $c142b84a15be9b78$var$findNextItem(enabledItems, search, currentItem);
        if (nextItem) setTimeout(()=>nextItem.ref.current.focus());
    });
    const itemRefCallback = $jbmdS.useCallback((node, value, disabled)=>{
        const isFirstValidItem = !firstValidItemFoundRef.current && !disabled;
        const isSelectedItem = context.value !== void 0 && context.value === value;
        if (isSelectedItem || isFirstValidItem) {
            setSelectedItem(node);
            if (isFirstValidItem) firstValidItemFoundRef.current = true;
        }
    }, [
        context.value
    ]);
    const handleItemLeave = $jbmdS.useCallback(()=>content?.focus(), [
        content
    ]);
    const itemTextRefCallback = $jbmdS.useCallback((node, value, disabled)=>{
        const isFirstValidItem = !firstValidItemFoundRef.current && !disabled;
        const isSelectedItem = context.value !== void 0 && context.value === value;
        if (isSelectedItem || isFirstValidItem) setSelectedItemText(node);
    }, [
        context.value
    ]);
    const SelectPosition = position === "popper" ? $c142b84a15be9b78$var$SelectPopperPosition : $c142b84a15be9b78$var$SelectItemAlignedPosition;
    const popperContentProps = SelectPosition === $c142b84a15be9b78$var$SelectPopperPosition ? {
        side: side,
        sideOffset: sideOffset,
        align: align,
        alignOffset: alignOffset,
        arrowPadding: arrowPadding,
        collisionBoundary: collisionBoundary,
        collisionPadding: collisionPadding,
        sticky: sticky,
        hideWhenDetached: hideWhenDetached,
        avoidCollisions: avoidCollisions
    } : {};
    return /* @__PURE__ */ (0, $4TLFw.jsx)($c142b84a15be9b78$var$SelectContentProvider, {
        scope: __scopeSelect,
        content: content,
        viewport: viewport,
        onViewportChange: setViewport,
        itemRefCallback: itemRefCallback,
        selectedItem: selectedItem,
        onItemLeave: handleItemLeave,
        itemTextRefCallback: itemTextRefCallback,
        focusSelectedItem: focusSelectedItem,
        selectedItemText: selectedItemText,
        position: position,
        isPositioned: isPositioned,
        searchRef: searchRef,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $gQkjX.default), {
            as: (0, $bXq35.Slot),
            allowPinchZoom: true,
            children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $i3HOY.FocusScope), {
                asChild: true,
                trapped: context.open,
                onMountAutoFocus: (event)=>{
                    event.preventDefault();
                },
                onUnmountAutoFocus: (0, $hFcKE.composeEventHandlers)(onCloseAutoFocus, (event)=>{
                    context.trigger?.focus({
                        preventScroll: true
                    });
                    event.preventDefault();
                }),
                children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $jJBMp.DismissableLayer), {
                    asChild: true,
                    disableOutsidePointerEvents: true,
                    onEscapeKeyDown: onEscapeKeyDown,
                    onPointerDownOutside: onPointerDownOutside,
                    onFocusOutside: (event)=>event.preventDefault(),
                    onDismiss: ()=>context.onOpenChange(false),
                    children: /* @__PURE__ */ (0, $4TLFw.jsx)(SelectPosition, {
                        role: "listbox",
                        id: context.contentId,
                        "data-state": context.open ? "open" : "closed",
                        dir: context.dir,
                        onContextMenu: (event)=>event.preventDefault(),
                        ...contentProps,
                        ...popperContentProps,
                        onPlaced: ()=>setIsPositioned(true),
                        ref: composedRefs,
                        style: {
                            // flex layout so we can place the scroll buttons properly
                            display: "flex",
                            flexDirection: "column",
                            // reset the outline by default as the content MAY get focused
                            outline: "none",
                            ...contentProps.style
                        },
                        onKeyDown: (0, $hFcKE.composeEventHandlers)(contentProps.onKeyDown, (event)=>{
                            const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
                            if (event.key === "Tab") event.preventDefault();
                            if (!isModifierKey && event.key.length === 1) handleTypeaheadSearch(event.key);
                            if ([
                                "ArrowUp",
                                "ArrowDown",
                                "Home",
                                "End"
                            ].includes(event.key)) {
                                const items = getItems().filter((item)=>!item.disabled);
                                let candidateNodes = items.map((item)=>item.ref.current);
                                if ([
                                    "ArrowUp",
                                    "End"
                                ].includes(event.key)) candidateNodes = candidateNodes.slice().reverse();
                                if ([
                                    "ArrowUp",
                                    "ArrowDown"
                                ].includes(event.key)) {
                                    const currentElement = event.target;
                                    const currentIndex = candidateNodes.indexOf(currentElement);
                                    candidateNodes = candidateNodes.slice(currentIndex + 1);
                                }
                                setTimeout(()=>focusFirst(candidateNodes));
                                event.preventDefault();
                            }
                        })
                    })
                })
            })
        })
    });
});
$c142b84a15be9b78$var$SelectContentImpl.displayName = $c142b84a15be9b78$var$CONTENT_IMPL_NAME;
var $c142b84a15be9b78$var$ITEM_ALIGNED_POSITION_NAME = "SelectItemAlignedPosition";
var $c142b84a15be9b78$var$SelectItemAlignedPosition = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, onPlaced: onPlaced, ...popperProps } = props;
    const context = $c142b84a15be9b78$var$useSelectContext($c142b84a15be9b78$var$CONTENT_NAME, __scopeSelect);
    const contentContext = $c142b84a15be9b78$var$useSelectContentContext($c142b84a15be9b78$var$CONTENT_NAME, __scopeSelect);
    const [contentWrapper, setContentWrapper] = $jbmdS.useState(null);
    const [content, setContent] = $jbmdS.useState(null);
    const composedRefs = (0, $9sunj.useComposedRefs)(forwardedRef, (node)=>setContent(node));
    const getItems = $c142b84a15be9b78$var$useCollection(__scopeSelect);
    const shouldExpandOnScrollRef = $jbmdS.useRef(false);
    const shouldRepositionRef = $jbmdS.useRef(true);
    const { viewport: viewport, selectedItem: selectedItem, selectedItemText: selectedItemText, focusSelectedItem: focusSelectedItem } = contentContext;
    const position = $jbmdS.useCallback(()=>{
        if (context.trigger && context.valueNode && contentWrapper && content && viewport && selectedItem && selectedItemText) {
            const triggerRect = context.trigger.getBoundingClientRect();
            const contentRect = content.getBoundingClientRect();
            const valueNodeRect = context.valueNode.getBoundingClientRect();
            const itemTextRect = selectedItemText.getBoundingClientRect();
            if (context.dir !== "rtl") {
                const itemTextOffset = itemTextRect.left - contentRect.left;
                const left = valueNodeRect.left - itemTextOffset;
                const leftDelta = triggerRect.left - left;
                const minContentWidth = triggerRect.width + leftDelta;
                const contentWidth = Math.max(minContentWidth, contentRect.width);
                const rightEdge = window.innerWidth - $c142b84a15be9b78$var$CONTENT_MARGIN;
                const clampedLeft = (0, $kMiXC.clamp)(left, [
                    $c142b84a15be9b78$var$CONTENT_MARGIN,
                    // Prevents the content from going off the starting edge of the
                    // viewport. It may still go off the ending edge, but this can be
                    // controlled by the user since they may want to manage overflow in a
                    // specific way.
                    // https://github.com/radix-ui/primitives/issues/2049
                    Math.max($c142b84a15be9b78$var$CONTENT_MARGIN, rightEdge - contentWidth)
                ]);
                contentWrapper.style.minWidth = minContentWidth + "px";
                contentWrapper.style.left = clampedLeft + "px";
            } else {
                const itemTextOffset = contentRect.right - itemTextRect.right;
                const right = window.innerWidth - valueNodeRect.right - itemTextOffset;
                const rightDelta = window.innerWidth - triggerRect.right - right;
                const minContentWidth = triggerRect.width + rightDelta;
                const contentWidth = Math.max(minContentWidth, contentRect.width);
                const leftEdge = window.innerWidth - $c142b84a15be9b78$var$CONTENT_MARGIN;
                const clampedRight = (0, $kMiXC.clamp)(right, [
                    $c142b84a15be9b78$var$CONTENT_MARGIN,
                    Math.max($c142b84a15be9b78$var$CONTENT_MARGIN, leftEdge - contentWidth)
                ]);
                contentWrapper.style.minWidth = minContentWidth + "px";
                contentWrapper.style.right = clampedRight + "px";
            }
            const items = getItems();
            const availableHeight = window.innerHeight - $c142b84a15be9b78$var$CONTENT_MARGIN * 2;
            const itemsHeight = viewport.scrollHeight;
            const contentStyles = window.getComputedStyle(content);
            const contentBorderTopWidth = parseInt(contentStyles.borderTopWidth, 10);
            const contentPaddingTop = parseInt(contentStyles.paddingTop, 10);
            const contentBorderBottomWidth = parseInt(contentStyles.borderBottomWidth, 10);
            const contentPaddingBottom = parseInt(contentStyles.paddingBottom, 10);
            const fullContentHeight = contentBorderTopWidth + contentPaddingTop + itemsHeight + contentPaddingBottom + contentBorderBottomWidth;
            const minContentHeight = Math.min(selectedItem.offsetHeight * 5, fullContentHeight);
            const viewportStyles = window.getComputedStyle(viewport);
            const viewportPaddingTop = parseInt(viewportStyles.paddingTop, 10);
            const viewportPaddingBottom = parseInt(viewportStyles.paddingBottom, 10);
            const topEdgeToTriggerMiddle = triggerRect.top + triggerRect.height / 2 - $c142b84a15be9b78$var$CONTENT_MARGIN;
            const triggerMiddleToBottomEdge = availableHeight - topEdgeToTriggerMiddle;
            const selectedItemHalfHeight = selectedItem.offsetHeight / 2;
            const itemOffsetMiddle = selectedItem.offsetTop + selectedItemHalfHeight;
            const contentTopToItemMiddle = contentBorderTopWidth + contentPaddingTop + itemOffsetMiddle;
            const itemMiddleToContentBottom = fullContentHeight - contentTopToItemMiddle;
            const willAlignWithoutTopOverflow = contentTopToItemMiddle <= topEdgeToTriggerMiddle;
            if (willAlignWithoutTopOverflow) {
                const isLastItem = items.length > 0 && selectedItem === items[items.length - 1].ref.current;
                contentWrapper.style.bottom = "0px";
                const viewportOffsetBottom = content.clientHeight - viewport.offsetTop - viewport.offsetHeight;
                const clampedTriggerMiddleToBottomEdge = Math.max(triggerMiddleToBottomEdge, selectedItemHalfHeight + // viewport might have padding bottom, include it to avoid a scrollable viewport
                (isLastItem ? viewportPaddingBottom : 0) + viewportOffsetBottom + contentBorderBottomWidth);
                const height = contentTopToItemMiddle + clampedTriggerMiddleToBottomEdge;
                contentWrapper.style.height = height + "px";
            } else {
                const isFirstItem = items.length > 0 && selectedItem === items[0].ref.current;
                contentWrapper.style.top = "0px";
                const clampedTopEdgeToTriggerMiddle = Math.max(topEdgeToTriggerMiddle, contentBorderTopWidth + viewport.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
                (isFirstItem ? viewportPaddingTop : 0) + selectedItemHalfHeight);
                const height = clampedTopEdgeToTriggerMiddle + itemMiddleToContentBottom;
                contentWrapper.style.height = height + "px";
                viewport.scrollTop = contentTopToItemMiddle - topEdgeToTriggerMiddle + viewport.offsetTop;
            }
            contentWrapper.style.margin = `${$c142b84a15be9b78$var$CONTENT_MARGIN}px 0`;
            contentWrapper.style.minHeight = minContentHeight + "px";
            contentWrapper.style.maxHeight = availableHeight + "px";
            onPlaced?.();
            requestAnimationFrame(()=>shouldExpandOnScrollRef.current = true);
        }
    }, [
        getItems,
        context.trigger,
        context.valueNode,
        contentWrapper,
        content,
        viewport,
        selectedItem,
        selectedItemText,
        context.dir,
        onPlaced
    ]);
    (0, $9crHl.useLayoutEffect)(()=>position(), [
        position
    ]);
    const [contentZIndex, setContentZIndex] = $jbmdS.useState();
    (0, $9crHl.useLayoutEffect)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    const handleScrollButtonChange = $jbmdS.useCallback((node)=>{
        if (node && shouldRepositionRef.current === true) {
            position();
            focusSelectedItem?.();
            shouldRepositionRef.current = false;
        }
    }, [
        position,
        focusSelectedItem
    ]);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($c142b84a15be9b78$var$SelectViewportProvider, {
        scope: __scopeSelect,
        contentWrapper: contentWrapper,
        shouldExpandOnScrollRef: shouldExpandOnScrollRef,
        onScrollButtonChange: handleScrollButtonChange,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)("div", {
            ref: setContentWrapper,
            style: {
                display: "flex",
                flexDirection: "column",
                position: "fixed",
                zIndex: contentZIndex
            },
            children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).div, {
                ...popperProps,
                ref: composedRefs,
                style: {
                    // When we get the height of the content, it includes borders. If we were to set
                    // the height without having `boxSizing: 'border-box'` it would be too big.
                    boxSizing: "border-box",
                    // We need to ensure the content doesn't get taller than the wrapper
                    maxHeight: "100%",
                    ...popperProps.style
                }
            })
        })
    });
});
$c142b84a15be9b78$var$SelectItemAlignedPosition.displayName = $c142b84a15be9b78$var$ITEM_ALIGNED_POSITION_NAME;
var $c142b84a15be9b78$var$POPPER_POSITION_NAME = "SelectPopperPosition";
var $c142b84a15be9b78$var$SelectPopperPosition = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, align: align = "start", collisionPadding: collisionPadding = $c142b84a15be9b78$var$CONTENT_MARGIN, ...popperProps } = props;
    const popperScope = $c142b84a15be9b78$var$usePopperScope(__scopeSelect);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($aU3NZ.Content, {
        ...popperScope,
        ...popperProps,
        ref: forwardedRef,
        align: align,
        collisionPadding: collisionPadding,
        style: {
            // Ensure border-box for floating-ui calculations
            boxSizing: "border-box",
            ...popperProps.style,
            "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-select-content-available-width": "var(--radix-popper-available-width)",
            "--radix-select-content-available-height": "var(--radix-popper-available-height)",
            "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
        }
    });
});
$c142b84a15be9b78$var$SelectPopperPosition.displayName = $c142b84a15be9b78$var$POPPER_POSITION_NAME;
var [$c142b84a15be9b78$var$SelectViewportProvider, $c142b84a15be9b78$var$useSelectViewportContext] = $c142b84a15be9b78$var$createSelectContext($c142b84a15be9b78$var$CONTENT_NAME, {});
var $c142b84a15be9b78$var$VIEWPORT_NAME = "SelectViewport";
var $c142b84a15be9b78$export$9ed6e7b40248d36d = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, nonce: nonce, ...viewportProps } = props;
    const contentContext = $c142b84a15be9b78$var$useSelectContentContext($c142b84a15be9b78$var$VIEWPORT_NAME, __scopeSelect);
    const viewportContext = $c142b84a15be9b78$var$useSelectViewportContext($c142b84a15be9b78$var$VIEWPORT_NAME, __scopeSelect);
    const composedRefs = (0, $9sunj.useComposedRefs)(forwardedRef, contentContext.onViewportChange);
    const prevScrollTopRef = $jbmdS.useRef(0);
    return /* @__PURE__ */ (0, $4TLFw.jsxs)((0, $4TLFw.Fragment), {
        children: [
            /* @__PURE__ */ (0, $4TLFw.jsx)("style", {
                dangerouslySetInnerHTML: {
                    __html: `[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}`
                },
                nonce: nonce
            }),
            /* @__PURE__ */ (0, $4TLFw.jsx)($c142b84a15be9b78$var$Collection.Slot, {
                scope: __scopeSelect,
                children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).div, {
                    "data-radix-select-viewport": "",
                    role: "presentation",
                    ...viewportProps,
                    ref: composedRefs,
                    style: {
                        // we use position: 'relative' here on the `viewport` so that when we call
                        // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
                        // (independent of the scrollUpButton).
                        position: "relative",
                        flex: 1,
                        // Viewport should only be scrollable in the vertical direction.
                        // This won't work in vertical writing modes, so we'll need to
                        // revisit this if/when that is supported
                        // https://developer.chrome.com/blog/vertical-form-controls
                        overflow: "hidden auto",
                        ...viewportProps.style
                    },
                    onScroll: (0, $hFcKE.composeEventHandlers)(viewportProps.onScroll, (event)=>{
                        const viewport = event.currentTarget;
                        const { contentWrapper: contentWrapper, shouldExpandOnScrollRef: shouldExpandOnScrollRef } = viewportContext;
                        if (shouldExpandOnScrollRef?.current && contentWrapper) {
                            const scrolledBy = Math.abs(prevScrollTopRef.current - viewport.scrollTop);
                            if (scrolledBy > 0) {
                                const availableHeight = window.innerHeight - $c142b84a15be9b78$var$CONTENT_MARGIN * 2;
                                const cssMinHeight = parseFloat(contentWrapper.style.minHeight);
                                const cssHeight = parseFloat(contentWrapper.style.height);
                                const prevHeight = Math.max(cssMinHeight, cssHeight);
                                if (prevHeight < availableHeight) {
                                    const nextHeight = prevHeight + scrolledBy;
                                    const clampedNextHeight = Math.min(availableHeight, nextHeight);
                                    const heightDiff = nextHeight - clampedNextHeight;
                                    contentWrapper.style.height = clampedNextHeight + "px";
                                    if (contentWrapper.style.bottom === "0px") {
                                        viewport.scrollTop = heightDiff > 0 ? heightDiff : 0;
                                        contentWrapper.style.justifyContent = "flex-end";
                                    }
                                }
                            }
                        }
                        prevScrollTopRef.current = viewport.scrollTop;
                    })
                })
            })
        ]
    });
});
$c142b84a15be9b78$export$9ed6e7b40248d36d.displayName = $c142b84a15be9b78$var$VIEWPORT_NAME;
var $c142b84a15be9b78$var$GROUP_NAME = "SelectGroup";
var [$c142b84a15be9b78$var$SelectGroupContextProvider, $c142b84a15be9b78$var$useSelectGroupContext] = $c142b84a15be9b78$var$createSelectContext($c142b84a15be9b78$var$GROUP_NAME);
var $c142b84a15be9b78$export$ee25a334c55de1f4 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...groupProps } = props;
    const groupId = (0, $g7F3X.useId)();
    return /* @__PURE__ */ (0, $4TLFw.jsx)($c142b84a15be9b78$var$SelectGroupContextProvider, {
        scope: __scopeSelect,
        id: groupId,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).div, {
            role: "group",
            "aria-labelledby": groupId,
            ...groupProps,
            ref: forwardedRef
        })
    });
});
$c142b84a15be9b78$export$ee25a334c55de1f4.displayName = $c142b84a15be9b78$var$GROUP_NAME;
var $c142b84a15be9b78$var$LABEL_NAME = "SelectLabel";
var $c142b84a15be9b78$export$f67338d29bd972f8 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...labelProps } = props;
    const groupContext = $c142b84a15be9b78$var$useSelectGroupContext($c142b84a15be9b78$var$LABEL_NAME, __scopeSelect);
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).div, {
        id: groupContext.id,
        ...labelProps,
        ref: forwardedRef
    });
});
$c142b84a15be9b78$export$f67338d29bd972f8.displayName = $c142b84a15be9b78$var$LABEL_NAME;
var $c142b84a15be9b78$var$ITEM_NAME = "SelectItem";
var [$c142b84a15be9b78$var$SelectItemContextProvider, $c142b84a15be9b78$var$useSelectItemContext] = $c142b84a15be9b78$var$createSelectContext($c142b84a15be9b78$var$ITEM_NAME);
var $c142b84a15be9b78$export$13ef48a934230896 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, value: value, disabled: disabled = false, textValue: textValueProp, ...itemProps } = props;
    const context = $c142b84a15be9b78$var$useSelectContext($c142b84a15be9b78$var$ITEM_NAME, __scopeSelect);
    const contentContext = $c142b84a15be9b78$var$useSelectContentContext($c142b84a15be9b78$var$ITEM_NAME, __scopeSelect);
    const isSelected = context.value === value;
    const [textValue, setTextValue] = $jbmdS.useState(textValueProp ?? "");
    const [isFocused, setIsFocused] = $jbmdS.useState(false);
    const composedRefs = (0, $9sunj.useComposedRefs)(forwardedRef, (node)=>contentContext.itemRefCallback?.(node, value, disabled));
    const textId = (0, $g7F3X.useId)();
    const pointerTypeRef = $jbmdS.useRef("touch");
    const handleSelect = ()=>{
        if (!disabled) {
            context.onValueChange(value);
            context.onOpenChange(false);
        }
    };
    if (value === "") throw new Error("A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder.");
    return /* @__PURE__ */ (0, $4TLFw.jsx)($c142b84a15be9b78$var$SelectItemContextProvider, {
        scope: __scopeSelect,
        value: value,
        disabled: disabled,
        textId: textId,
        isSelected: isSelected,
        onItemTextChange: $jbmdS.useCallback((node)=>{
            setTextValue((prevTextValue)=>prevTextValue || (node?.textContent ?? "").trim());
        }, []),
        children: /* @__PURE__ */ (0, $4TLFw.jsx)($c142b84a15be9b78$var$Collection.ItemSlot, {
            scope: __scopeSelect,
            value: value,
            disabled: disabled,
            textValue: textValue,
            children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).div, {
                role: "option",
                "aria-labelledby": textId,
                "data-highlighted": isFocused ? "" : void 0,
                "aria-selected": isSelected && isFocused,
                "data-state": isSelected ? "checked" : "unchecked",
                "aria-disabled": disabled || void 0,
                "data-disabled": disabled ? "" : void 0,
                tabIndex: disabled ? void 0 : -1,
                ...itemProps,
                ref: composedRefs,
                onFocus: (0, $hFcKE.composeEventHandlers)(itemProps.onFocus, ()=>setIsFocused(true)),
                onBlur: (0, $hFcKE.composeEventHandlers)(itemProps.onBlur, ()=>setIsFocused(false)),
                onClick: (0, $hFcKE.composeEventHandlers)(itemProps.onClick, ()=>{
                    if (pointerTypeRef.current !== "mouse") handleSelect();
                }),
                onPointerUp: (0, $hFcKE.composeEventHandlers)(itemProps.onPointerUp, ()=>{
                    if (pointerTypeRef.current === "mouse") handleSelect();
                }),
                onPointerDown: (0, $hFcKE.composeEventHandlers)(itemProps.onPointerDown, (event)=>{
                    pointerTypeRef.current = event.pointerType;
                }),
                onPointerMove: (0, $hFcKE.composeEventHandlers)(itemProps.onPointerMove, (event)=>{
                    pointerTypeRef.current = event.pointerType;
                    if (disabled) contentContext.onItemLeave?.();
                    else if (pointerTypeRef.current === "mouse") event.currentTarget.focus({
                        preventScroll: true
                    });
                }),
                onPointerLeave: (0, $hFcKE.composeEventHandlers)(itemProps.onPointerLeave, (event)=>{
                    if (event.currentTarget === document.activeElement) contentContext.onItemLeave?.();
                }),
                onKeyDown: (0, $hFcKE.composeEventHandlers)(itemProps.onKeyDown, (event)=>{
                    const isTypingAhead = contentContext.searchRef?.current !== "";
                    if (isTypingAhead && event.key === " ") return;
                    if ($c142b84a15be9b78$var$SELECTION_KEYS.includes(event.key)) handleSelect();
                    if (event.key === " ") event.preventDefault();
                })
            })
        })
    });
});
$c142b84a15be9b78$export$13ef48a934230896.displayName = $c142b84a15be9b78$var$ITEM_NAME;
var $c142b84a15be9b78$var$ITEM_TEXT_NAME = "SelectItemText";
var $c142b84a15be9b78$export$3572fb0fb821ff49 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, className: className, style: style, ...itemTextProps } = props;
    const context = $c142b84a15be9b78$var$useSelectContext($c142b84a15be9b78$var$ITEM_TEXT_NAME, __scopeSelect);
    const contentContext = $c142b84a15be9b78$var$useSelectContentContext($c142b84a15be9b78$var$ITEM_TEXT_NAME, __scopeSelect);
    const itemContext = $c142b84a15be9b78$var$useSelectItemContext($c142b84a15be9b78$var$ITEM_TEXT_NAME, __scopeSelect);
    const nativeOptionsContext = $c142b84a15be9b78$var$useSelectNativeOptionsContext($c142b84a15be9b78$var$ITEM_TEXT_NAME, __scopeSelect);
    const [itemTextNode, setItemTextNode] = $jbmdS.useState(null);
    const composedRefs = (0, $9sunj.useComposedRefs)(forwardedRef, (node)=>setItemTextNode(node), itemContext.onItemTextChange, (node)=>contentContext.itemTextRefCallback?.(node, itemContext.value, itemContext.disabled));
    const textContent = itemTextNode?.textContent;
    const nativeOption = $jbmdS.useMemo(()=>/* @__PURE__ */ (0, $4TLFw.jsx)("option", {
            value: itemContext.value,
            disabled: itemContext.disabled,
            children: textContent
        }, itemContext.value), [
        itemContext.disabled,
        itemContext.value,
        textContent
    ]);
    const { onNativeOptionAdd: onNativeOptionAdd, onNativeOptionRemove: onNativeOptionRemove } = nativeOptionsContext;
    (0, $9crHl.useLayoutEffect)(()=>{
        onNativeOptionAdd(nativeOption);
        return ()=>onNativeOptionRemove(nativeOption);
    }, [
        onNativeOptionAdd,
        onNativeOptionRemove,
        nativeOption
    ]);
    return /* @__PURE__ */ (0, $4TLFw.jsxs)((0, $4TLFw.Fragment), {
        children: [
            /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).span, {
                id: itemContext.textId,
                ...itemTextProps,
                ref: composedRefs
            }),
            itemContext.isSelected && context.valueNode && !context.valueNodeHasChildren ? $jCNM0.createPortal(itemTextProps.children, context.valueNode) : null
        ]
    });
});
$c142b84a15be9b78$export$3572fb0fb821ff49.displayName = $c142b84a15be9b78$var$ITEM_TEXT_NAME;
var $c142b84a15be9b78$var$ITEM_INDICATOR_NAME = "SelectItemIndicator";
var $c142b84a15be9b78$export$6b9198de19accfe6 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...itemIndicatorProps } = props;
    const itemContext = $c142b84a15be9b78$var$useSelectItemContext($c142b84a15be9b78$var$ITEM_INDICATOR_NAME, __scopeSelect);
    return itemContext.isSelected ? /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).span, {
        "aria-hidden": true,
        ...itemIndicatorProps,
        ref: forwardedRef
    }) : null;
});
$c142b84a15be9b78$export$6b9198de19accfe6.displayName = $c142b84a15be9b78$var$ITEM_INDICATOR_NAME;
var $c142b84a15be9b78$var$SCROLL_UP_BUTTON_NAME = "SelectScrollUpButton";
var $c142b84a15be9b78$export$d8117927658af6d7 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const contentContext = $c142b84a15be9b78$var$useSelectContentContext($c142b84a15be9b78$var$SCROLL_UP_BUTTON_NAME, props.__scopeSelect);
    const viewportContext = $c142b84a15be9b78$var$useSelectViewportContext($c142b84a15be9b78$var$SCROLL_UP_BUTTON_NAME, props.__scopeSelect);
    const [canScrollUp, setCanScrollUp] = $jbmdS.useState(false);
    const composedRefs = (0, $9sunj.useComposedRefs)(forwardedRef, viewportContext.onScrollButtonChange);
    (0, $9crHl.useLayoutEffect)(()=>{
        if (contentContext.viewport && contentContext.isPositioned) {
            let handleScroll2 = function() {
                const canScrollUp2 = viewport.scrollTop > 0;
                setCanScrollUp(canScrollUp2);
            };
            var handleScroll = handleScroll2;
            const viewport = contentContext.viewport;
            handleScroll2();
            viewport.addEventListener("scroll", handleScroll2);
            return ()=>viewport.removeEventListener("scroll", handleScroll2);
        }
    }, [
        contentContext.viewport,
        contentContext.isPositioned
    ]);
    return canScrollUp ? /* @__PURE__ */ (0, $4TLFw.jsx)($c142b84a15be9b78$var$SelectScrollButtonImpl, {
        ...props,
        ref: composedRefs,
        onAutoScroll: ()=>{
            const { viewport: viewport, selectedItem: selectedItem } = contentContext;
            if (viewport && selectedItem) viewport.scrollTop = viewport.scrollTop - selectedItem.offsetHeight;
        }
    }) : null;
});
$c142b84a15be9b78$export$d8117927658af6d7.displayName = $c142b84a15be9b78$var$SCROLL_UP_BUTTON_NAME;
var $c142b84a15be9b78$var$SCROLL_DOWN_BUTTON_NAME = "SelectScrollDownButton";
var $c142b84a15be9b78$export$ff951e476c12189 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const contentContext = $c142b84a15be9b78$var$useSelectContentContext($c142b84a15be9b78$var$SCROLL_DOWN_BUTTON_NAME, props.__scopeSelect);
    const viewportContext = $c142b84a15be9b78$var$useSelectViewportContext($c142b84a15be9b78$var$SCROLL_DOWN_BUTTON_NAME, props.__scopeSelect);
    const [canScrollDown, setCanScrollDown] = $jbmdS.useState(false);
    const composedRefs = (0, $9sunj.useComposedRefs)(forwardedRef, viewportContext.onScrollButtonChange);
    (0, $9crHl.useLayoutEffect)(()=>{
        if (contentContext.viewport && contentContext.isPositioned) {
            let handleScroll2 = function() {
                const maxScroll = viewport.scrollHeight - viewport.clientHeight;
                const canScrollDown2 = Math.ceil(viewport.scrollTop) < maxScroll;
                setCanScrollDown(canScrollDown2);
            };
            var handleScroll = handleScroll2;
            const viewport = contentContext.viewport;
            handleScroll2();
            viewport.addEventListener("scroll", handleScroll2);
            return ()=>viewport.removeEventListener("scroll", handleScroll2);
        }
    }, [
        contentContext.viewport,
        contentContext.isPositioned
    ]);
    return canScrollDown ? /* @__PURE__ */ (0, $4TLFw.jsx)($c142b84a15be9b78$var$SelectScrollButtonImpl, {
        ...props,
        ref: composedRefs,
        onAutoScroll: ()=>{
            const { viewport: viewport, selectedItem: selectedItem } = contentContext;
            if (viewport && selectedItem) viewport.scrollTop = viewport.scrollTop + selectedItem.offsetHeight;
        }
    }) : null;
});
$c142b84a15be9b78$export$ff951e476c12189.displayName = $c142b84a15be9b78$var$SCROLL_DOWN_BUTTON_NAME;
var $c142b84a15be9b78$var$SelectScrollButtonImpl = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, onAutoScroll: onAutoScroll, ...scrollIndicatorProps } = props;
    const contentContext = $c142b84a15be9b78$var$useSelectContentContext("SelectScrollButton", __scopeSelect);
    const autoScrollTimerRef = $jbmdS.useRef(null);
    const getItems = $c142b84a15be9b78$var$useCollection(__scopeSelect);
    const clearAutoScrollTimer = $jbmdS.useCallback(()=>{
        if (autoScrollTimerRef.current !== null) {
            window.clearInterval(autoScrollTimerRef.current);
            autoScrollTimerRef.current = null;
        }
    }, []);
    $jbmdS.useEffect(()=>{
        return ()=>clearAutoScrollTimer();
    }, [
        clearAutoScrollTimer
    ]);
    (0, $9crHl.useLayoutEffect)(()=>{
        const activeItem = getItems().find((item)=>item.ref.current === document.activeElement);
        activeItem?.ref.current?.scrollIntoView({
            block: "nearest"
        });
    }, [
        getItems
    ]);
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).div, {
        "aria-hidden": true,
        ...scrollIndicatorProps,
        ref: forwardedRef,
        style: {
            flexShrink: 0,
            ...scrollIndicatorProps.style
        },
        onPointerDown: (0, $hFcKE.composeEventHandlers)(scrollIndicatorProps.onPointerDown, ()=>{
            if (autoScrollTimerRef.current === null) autoScrollTimerRef.current = window.setInterval(onAutoScroll, 50);
        }),
        onPointerMove: (0, $hFcKE.composeEventHandlers)(scrollIndicatorProps.onPointerMove, ()=>{
            contentContext.onItemLeave?.();
            if (autoScrollTimerRef.current === null) autoScrollTimerRef.current = window.setInterval(onAutoScroll, 50);
        }),
        onPointerLeave: (0, $hFcKE.composeEventHandlers)(scrollIndicatorProps.onPointerLeave, ()=>{
            clearAutoScrollTimer();
        })
    });
});
var $c142b84a15be9b78$var$SEPARATOR_NAME = "SelectSeparator";
var $c142b84a15be9b78$export$eba4b1df07cb1d3 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...separatorProps } = props;
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).div, {
        "aria-hidden": true,
        ...separatorProps,
        ref: forwardedRef
    });
});
$c142b84a15be9b78$export$eba4b1df07cb1d3.displayName = $c142b84a15be9b78$var$SEPARATOR_NAME;
var $c142b84a15be9b78$var$ARROW_NAME = "SelectArrow";
var $c142b84a15be9b78$export$314f4cb8f8099628 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...arrowProps } = props;
    const popperScope = $c142b84a15be9b78$var$usePopperScope(__scopeSelect);
    const context = $c142b84a15be9b78$var$useSelectContext($c142b84a15be9b78$var$ARROW_NAME, __scopeSelect);
    const contentContext = $c142b84a15be9b78$var$useSelectContentContext($c142b84a15be9b78$var$ARROW_NAME, __scopeSelect);
    return context.open && contentContext.position === "popper" ? /* @__PURE__ */ (0, $4TLFw.jsx)($aU3NZ.Arrow, {
        ...popperScope,
        ...arrowProps,
        ref: forwardedRef
    }) : null;
});
$c142b84a15be9b78$export$314f4cb8f8099628.displayName = $c142b84a15be9b78$var$ARROW_NAME;
function $c142b84a15be9b78$var$shouldShowPlaceholder(value) {
    return value === "" || value === void 0;
}
var $c142b84a15be9b78$var$BubbleSelect = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { value: value, ...selectProps } = props;
    const ref = $jbmdS.useRef(null);
    const composedRefs = (0, $9sunj.useComposedRefs)(forwardedRef, ref);
    const prevValue = (0, $f4s2q.usePrevious)(value);
    $jbmdS.useEffect(()=>{
        const select = ref.current;
        const selectProto = window.HTMLSelectElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(selectProto, "value");
        const setValue = descriptor.set;
        if (prevValue !== value && setValue) {
            const event = new Event("change", {
                bubbles: true
            });
            setValue.call(select, value);
            select.dispatchEvent(event);
        }
    }, [
        prevValue,
        value
    ]);
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $fLY1n.VisuallyHidden), {
        asChild: true,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)("select", {
            ...selectProps,
            ref: composedRefs,
            defaultValue: value
        })
    });
});
$c142b84a15be9b78$var$BubbleSelect.displayName = "BubbleSelect";
function $c142b84a15be9b78$var$useTypeaheadSearch(onSearchChange) {
    const handleSearchChange = (0, $kjEX1.useCallbackRef)(onSearchChange);
    const searchRef = $jbmdS.useRef("");
    const timerRef = $jbmdS.useRef(0);
    const handleTypeaheadSearch = $jbmdS.useCallback((key)=>{
        const search = searchRef.current + key;
        handleSearchChange(search);
        (function updateSearch(value) {
            searchRef.current = value;
            window.clearTimeout(timerRef.current);
            if (value !== "") timerRef.current = window.setTimeout(()=>updateSearch(""), 1e3);
        })(search);
    }, [
        handleSearchChange
    ]);
    const resetTypeahead = $jbmdS.useCallback(()=>{
        searchRef.current = "";
        window.clearTimeout(timerRef.current);
    }, []);
    $jbmdS.useEffect(()=>{
        return ()=>window.clearTimeout(timerRef.current);
    }, []);
    return [
        searchRef,
        handleTypeaheadSearch,
        resetTypeahead
    ];
}
function $c142b84a15be9b78$var$findNextItem(items, search, currentItem) {
    const isRepeated = search.length > 1 && Array.from(search).every((char)=>char === search[0]);
    const normalizedSearch = isRepeated ? search[0] : search;
    const currentItemIndex = currentItem ? items.indexOf(currentItem) : -1;
    let wrappedItems = $c142b84a15be9b78$var$wrapArray(items, Math.max(currentItemIndex, 0));
    const excludeCurrentItem = normalizedSearch.length === 1;
    if (excludeCurrentItem) wrappedItems = wrappedItems.filter((v)=>v !== currentItem);
    const nextItem = wrappedItems.find((item)=>item.textValue.toLowerCase().startsWith(normalizedSearch.toLowerCase()));
    return nextItem !== currentItem ? nextItem : void 0;
}
function $c142b84a15be9b78$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
var $c142b84a15be9b78$export$be92b6f5f03c0fe9 = $c142b84a15be9b78$export$ef9b1a59e592288f;
var $c142b84a15be9b78$export$41fb9f06171c75f4 = $c142b84a15be9b78$export$3ac1e88a1c0b9f1;
var $c142b84a15be9b78$export$4c8d1a57a761ef94 = $c142b84a15be9b78$export$e288731fd71264f0;
var $c142b84a15be9b78$export$f04a61298a47a40f = $c142b84a15be9b78$export$99b400cabb58c515;
var $c142b84a15be9b78$export$602eac185826482c = $c142b84a15be9b78$export$b2af6c9944296213;
var $c142b84a15be9b78$export$7c6e2c02157bb7d2 = $c142b84a15be9b78$export$c973a4b3cb86a03d;
var $c142b84a15be9b78$export$d5c6c08dc2d3ca7 = $c142b84a15be9b78$export$9ed6e7b40248d36d;
var $c142b84a15be9b78$export$eb2fcfdbd7ba97d4 = $c142b84a15be9b78$export$ee25a334c55de1f4;
var $c142b84a15be9b78$export$b04be29aa201d4f5 = $c142b84a15be9b78$export$f67338d29bd972f8;
var $c142b84a15be9b78$export$6d08773d2e66f8f2 = $c142b84a15be9b78$export$13ef48a934230896;
var $c142b84a15be9b78$export$d6e5bf9c43ea9319 = $c142b84a15be9b78$export$3572fb0fb821ff49;
var $c142b84a15be9b78$export$c3468e2714d175fa = $c142b84a15be9b78$export$6b9198de19accfe6;
var $c142b84a15be9b78$export$2f60d3ec9ad468f2 = $c142b84a15be9b78$export$d8117927658af6d7;
var $c142b84a15be9b78$export$bf1aedc3039c8d63 = $c142b84a15be9b78$export$ff951e476c12189;
var $c142b84a15be9b78$export$1ff3c3f08ae963c0 = $c142b84a15be9b78$export$eba4b1df07cb1d3;
var $c142b84a15be9b78$export$21b07c8f274aebd5 = $c142b84a15be9b78$export$314f4cb8f8099628;

});
parcelRegister("kMiXC", function(module, exports) {

$parcel$export(module.exports, "clamp", function () { return $bc023292e781c38e$export$7d15b64cf5a3a4c4; });
// packages/core/number/src/number.ts
function $bc023292e781c38e$export$7d15b64cf5a3a4c4(value, [min, max]) {
    return Math.min(max, Math.max(min, value));
}

});

parcelRegister("g2eqD", function(module, exports) {

$parcel$export(module.exports, "createCollection", function () { return $739e66fccc451068$export$c74125a8e3af6bb2; });

var $jbmdS = parcelRequire("jbmdS");

var $4iR5Y = parcelRequire("4iR5Y");

var $9sunj = parcelRequire("9sunj");

var $bXq35 = parcelRequire("bXq35");

var $4TLFw = parcelRequire("4TLFw");
"use client";
function $739e66fccc451068$export$c74125a8e3af6bb2(name) {
    const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $4iR5Y.createContextScope)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: /* @__PURE__ */ new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope: scope, children: children } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useRef(null);
        const itemMap = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useRef(/* @__PURE__ */ new Map()).current;
        return /* @__PURE__ */ (0, $4TLFw.jsx)(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref,
            children: children
        });
    };
    CollectionProvider.displayName = PROVIDER_NAME;
    const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlot = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $9sunj.useComposedRefs)(forwardedRef, context.collectionRef);
        return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $bXq35.Slot), {
            ref: composedRefs,
            children: children
        });
    });
    CollectionSlot.displayName = COLLECTION_SLOT_NAME;
    const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlot = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children, ...itemData } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useRef(null);
        const composedRefs = (0, $9sunj.useComposedRefs)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref);
        });
        return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $bXq35.Slot), {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs,
            children: children
        });
    });
    CollectionItemSlot.displayName = ITEM_SLOT_NAME;
    function useCollection(scope) {
        const context = useCollectionContext(name + "CollectionConsumer", scope);
        const getItems = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}

});
parcelRegister("4iR5Y", function(module, exports) {

$parcel$export(module.exports, "createContextScope", function () { return $78fb55579069e502$export$50c7b4e9d9f19c1; });
// packages/react/context/src/createContext.tsx

var $jbmdS = parcelRequire("jbmdS");

var $4TLFw = parcelRequire("4TLFw");
function $78fb55579069e502$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $jbmdS.createContext(defaultContext);
    function Provider(props) {
        const { children: children, ...context } = props;
        const value = $jbmdS.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $4TLFw.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    }
    function useContext2(consumerName) {
        const context = $jbmdS.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext2
    ];
}
function $78fb55579069e502$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $jbmdS.createContext(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope, children: children, ...context } = props;
            const Context = scope?.[scopeName][index] || BaseContext;
            const value = $jbmdS.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $4TLFw.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        }
        function useContext2(consumerName, scope) {
            const Context = scope?.[scopeName][index] || BaseContext;
            const context = $jbmdS.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $jbmdS.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = scope?.[scopeName] || scopeContexts;
            return $jbmdS.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $78fb55579069e502$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function $78fb55579069e502$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope, scopeName: scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $jbmdS.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}

});


parcelRegister("9czjk", function(module, exports) {

$parcel$export(module.exports, "useDirection", function () { return $089439262d4b2c10$export$b39126d51d94e6f3; });
// packages/react/direction/src/Direction.tsx

var $jbmdS = parcelRequire("jbmdS");

var $4TLFw = parcelRequire("4TLFw");
var $089439262d4b2c10$var$DirectionContext = $jbmdS.createContext(void 0);
var $089439262d4b2c10$export$c760c09fdd558351 = (props)=>{
    const { dir: dir, children: children } = props;
    return /* @__PURE__ */ (0, $4TLFw.jsx)($089439262d4b2c10$var$DirectionContext.Provider, {
        value: dir,
        children: children
    });
};
function $089439262d4b2c10$export$b39126d51d94e6f3(localDir) {
    const globalDir = $jbmdS.useContext($089439262d4b2c10$var$DirectionContext);
    return localDir || globalDir || "ltr";
}
var $089439262d4b2c10$export$2881499e37b75b9a = $089439262d4b2c10$export$c760c09fdd558351;

});

parcelRegister("f4s2q", function(module, exports) {

$parcel$export(module.exports, "usePrevious", function () { return $d7ea72a2b736680a$export$5cae361ad82dce8b; });
// packages/react/use-previous/src/usePrevious.tsx

var $jbmdS = parcelRequire("jbmdS");
function $d7ea72a2b736680a$export$5cae361ad82dce8b(value) {
    const ref = $jbmdS.useRef({
        value: value,
        previous: value
    });
    return $jbmdS.useMemo(()=>{
        if (ref.current.value !== value) {
            ref.current.previous = ref.current.value;
            ref.current.value = value;
        }
        return ref.current.previous;
    }, [
        value
    ]);
}

});

parcelRegister("fLY1n", function(module, exports) {

$parcel$export(module.exports, "VisuallyHidden", function () { return $a67038ffb1c75fd7$export$439d29a4e110a164; });
$parcel$export(module.exports, "Root", function () { return $a67038ffb1c75fd7$export$be92b6f5f03c0fe9; });
// packages/react/visually-hidden/src/VisuallyHidden.tsx

var $jbmdS = parcelRequire("jbmdS");

var $cihg9 = parcelRequire("cihg9");

var $4TLFw = parcelRequire("4TLFw");
var $a67038ffb1c75fd7$var$NAME = "VisuallyHidden";
var $a67038ffb1c75fd7$export$439d29a4e110a164 = $jbmdS.forwardRef((props, forwardedRef)=>{
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).span, {
        ...props,
        ref: forwardedRef,
        style: {
            // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
            position: "absolute",
            border: 0,
            width: 1,
            height: 1,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            wordWrap: "normal",
            ...props.style
        }
    });
});
$a67038ffb1c75fd7$export$439d29a4e110a164.displayName = $a67038ffb1c75fd7$var$NAME;
var $a67038ffb1c75fd7$export$be92b6f5f03c0fe9 = $a67038ffb1c75fd7$export$439d29a4e110a164;

});


parcelRegister("lKdR6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd48a445b9990040$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $fd48a445b9990040$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("ChevronDown", [
    [
        "path",
        {
            d: "m6 9 6 6 6-6",
            key: "qrunsl"
        }
    ]
]);

});

parcelRegister("joA1X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1ec3523b20e8b32$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $e1ec3523b20e8b32$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("ChevronUp", [
    [
        "path",
        {
            d: "m18 15-6-6-6 6",
            key: "153udz"
        }
    ]
]);

});


parcelRegister("fTGwv", function(module, exports) {

$parcel$export(module.exports, "buttonVariants", function () { return $e119d5e70e36c16c$export$dca1ee5a936bb312; });
$parcel$export(module.exports, "Button", function () { return $e119d5e70e36c16c$export$353f5b6fc5456de1; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $bXq35 = parcelRequire("bXq35");

var $5kn1b = parcelRequire("5kn1b");

var $Yha9m = parcelRequire("Yha9m");
const $e119d5e70e36c16c$export$dca1ee5a936bb312 = (0, $5kn1b.cva)("inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50", {
    variants: {
        variant: {
            default: "bg-primary text-primary-foreground shadow hover:bg-primary/90",
            destructive: "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
            outline: "border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground",
            secondary: "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
            ghost: "hover:bg-accent hover:text-accent-foreground",
            link: "text-primary underline-offset-4 hover:underline"
        },
        size: {
            default: "h-9 px-4 py-2",
            sm: "h-8 rounded-md px-3 text-xs",
            lg: "h-10 rounded-md px-8",
            icon: "size-8"
        }
    },
    defaultVariants: {
        variant: "default",
        size: "default"
    }
});
const $e119d5e70e36c16c$export$353f5b6fc5456de1 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, variant: variant, size: size, asChild: asChild = false, ...props }, ref)=>{
    const Comp = asChild ? (0, $bXq35.Slot) : "button";
    return /*#__PURE__*/ (0, $61Ea1.jsx)(Comp, {
        className: (0, $Yha9m.cn)($e119d5e70e36c16c$export$dca1ee5a936bb312({
            variant: variant,
            size: size,
            className: className
        })),
        ref: ref,
        ...props
    });
});
$e119d5e70e36c16c$export$353f5b6fc5456de1.displayName = "Button";

});


parcelRegister("l4nwI", function(module, exports) {

$parcel$export(module.exports, "Popover", function () { return $2111783d6a135127$export$5b6b19405a83ff9d; });
$parcel$export(module.exports, "PopoverTrigger", function () { return $2111783d6a135127$export$7dacb05d26466c3; });
$parcel$export(module.exports, "PopoverContent", function () { return $2111783d6a135127$export$d7e1f420b25549ff; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $bDCDZ = parcelRequire("bDCDZ");

var $Yha9m = parcelRequire("Yha9m");
const $2111783d6a135127$export$5b6b19405a83ff9d = $bDCDZ.Root;
const $2111783d6a135127$export$7dacb05d26466c3 = $bDCDZ.Trigger;
const $2111783d6a135127$export$d7e1f420b25549ff = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, align: align = "center", sideOffset: sideOffset = 4, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)($bDCDZ.Portal, {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)($bDCDZ.Content, {
            ref: ref,
            align: align,
            sideOffset: sideOffset,
            className: (0, $Yha9m.cn)("z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", className),
            ...props
        })
    }));
$2111783d6a135127$export$d7e1f420b25549ff.displayName = $bDCDZ.Content.displayName;

});


parcelRegister("6fNfM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48da597f49025467$export$2e2bcd8739ae039; });

var $1BTI2 = parcelRequire("1BTI2");
const $48da597f49025467$var$getPhaseTitle = (phase)=>{
    return phase !== null && phase !== void 0 && phase.jobNumber && phase !== null && phase !== void 0 && phase.name ? `${phase === null || phase === void 0 ? void 0 : phase.jobNumber}: ${phase === null || phase === void 0 ? void 0 : phase.name}` : (phase === null || phase === void 0 ? void 0 : phase.name) || (phase === null || phase === void 0 ? void 0 : phase.jobNumber);
};
var $48da597f49025467$export$2e2bcd8739ae039 = (a, b)=>{
    var _titleA$toLowerCase, _titleA$toLowerCase$c, _titleA$toLowerCase$c2, _titleB$toLowerCase;
    // Check if either phase is a root phase
    if (a !== null && a !== void 0 && a.isRootPhase && !(b !== null && b !== void 0 && b.isRootPhase)) return 1; // a is root, so it should be last
    else if (!(a !== null && a !== void 0 && a.isRootPhase) && b !== null && b !== void 0 && b.isRootPhase) return -1; // b is root, so a should come first
    // First check if both have positions
    if ((a === null || a === void 0 ? void 0 : a.position) !== undefined && (a === null || a === void 0 ? void 0 : a.position) !== null && (b === null || b === void 0 ? void 0 : b.position) !== undefined && (b === null || b === void 0 ? void 0 : b.position) !== null) return (a === null || a === void 0 ? void 0 : a.position) - (b === null || b === void 0 ? void 0 : b.position);
    // If only one has a position, it should come first
    if ((a === null || a === void 0 ? void 0 : a.position) !== undefined && (a === null || a === void 0 ? void 0 : a.position) !== null) return -1;
    if ((b === null || b === void 0 ? void 0 : b.position) !== undefined && (b === null || b === void 0 ? void 0 : b.position) !== null) return 1;
    if ((0, $1BTI2.default).settings.sortPhasesBy === "startDate") {
        // Check if both items have a startDate
        if (a !== null && a !== void 0 && a.startDate && b !== null && b !== void 0 && b.startDate) {
            var _titleA$localeCompare;
            // If both have a startDate, first sort by startDate
            if ((a === null || a === void 0 ? void 0 : a.startDate) !== (b === null || b === void 0 ? void 0 : b.startDate)) return new Date(a === null || a === void 0 ? void 0 : a.startDate).getTime() - new Date(b === null || b === void 0 ? void 0 : b.startDate).getTime();
            // If startDate is the same, sort by title
            const titleA = $48da597f49025467$var$getPhaseTitle(a);
            const titleB = $48da597f49025467$var$getPhaseTitle(b);
            return titleA === null || titleA === void 0 ? void 0 : (_titleA$localeCompare = titleA.localeCompare) === null || _titleA$localeCompare === void 0 ? void 0 : _titleA$localeCompare.call(titleA, titleB);
        } else if (a !== null && a !== void 0 && a.startDate) // If only a has a startDate, it should come first
        return -1;
        else if (b !== null && b !== void 0 && b.startDate) // If only b has a startDate, it should come first
        return 1;
    }
    // If neither has a startDate, sort by title
    const titleA = $48da597f49025467$var$getPhaseTitle(a);
    const titleB = $48da597f49025467$var$getPhaseTitle(b);
    return titleA === null || titleA === void 0 ? void 0 : (_titleA$toLowerCase = titleA.toLowerCase) === null || _titleA$toLowerCase === void 0 ? void 0 : (_titleA$toLowerCase$c = _titleA$toLowerCase.call(titleA)) === null || _titleA$toLowerCase$c === void 0 ? void 0 : (_titleA$toLowerCase$c2 = _titleA$toLowerCase$c.localeCompare) === null || _titleA$toLowerCase$c2 === void 0 ? void 0 : _titleA$toLowerCase$c2.call(_titleA$toLowerCase$c, titleB === null || titleB === void 0 ? void 0 : (_titleB$toLowerCase = titleB.toLowerCase) === null || _titleB$toLowerCase === void 0 ? void 0 : _titleB$toLowerCase.call(titleB));
};

});

parcelRegister("cXBQb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96f8591cbce7d5fa$export$2e2bcd8739ae039; });
const $96f8591cbce7d5fa$var$statuses = [
    "active",
    "onHold",
    "prospective",
    "archived"
];
const $96f8591cbce7d5fa$var$getProjectTitle = (project)=>{
    return project !== null && project !== void 0 && project.jobNumber && project !== null && project !== void 0 && project.name ? `${project === null || project === void 0 ? void 0 : project.jobNumber}: ${project === null || project === void 0 ? void 0 : project.name}` : (project === null || project === void 0 ? void 0 : project.name) || (project === null || project === void 0 ? void 0 : project.jobNumber);
};
var $96f8591cbce7d5fa$export$2e2bcd8739ae039 = (a, b)=>{
    var _titleA$toLowerCase, _titleA$toLowerCase$c, _titleA$toLowerCase$c2, _titleB$toLowerCase;
    const titleA = $96f8591cbce7d5fa$var$getProjectTitle(a);
    const titleB = $96f8591cbce7d5fa$var$getProjectTitle(b);
    return (titleA === null || titleA === void 0 ? void 0 : (_titleA$toLowerCase = titleA.toLowerCase) === null || _titleA$toLowerCase === void 0 ? void 0 : (_titleA$toLowerCase$c = _titleA$toLowerCase.call(titleA)) === null || _titleA$toLowerCase$c === void 0 ? void 0 : (_titleA$toLowerCase$c2 = _titleA$toLowerCase$c.localeCompare) === null || _titleA$toLowerCase$c2 === void 0 ? void 0 : _titleA$toLowerCase$c2.call(_titleA$toLowerCase$c, titleB === null || titleB === void 0 ? void 0 : (_titleB$toLowerCase = titleB.toLowerCase) === null || _titleB$toLowerCase === void 0 ? void 0 : _titleB$toLowerCase.call(titleB))) || 0;
};

});

parcelRegister("ip90b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6618b604ac15ad6$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $1EEMt = parcelRequire("1EEMt");

var $fEcKX = parcelRequire("fEcKX");

var $ewAM3 = parcelRequire("ewAM3");

var $1BTI2 = parcelRequire("1BTI2");

var $43oHB = parcelRequire("43oHB");
parcelRequire("52dEm");

var $8NSNz = parcelRequire("8NSNz");

var $goLmS = parcelRequire("goLmS");

var $bhvQG = parcelRequire("bhvQG");

var $fM2j4 = parcelRequire("fM2j4");

var $foLWS = parcelRequire("foLWS");

var $4JcCM = parcelRequire("4JcCM");

var $6ywef = parcelRequire("6ywef");

var $khJQv = parcelRequire("khJQv");
const $d6618b604ac15ad6$var$accountingDropdownOptions = [
    {
        label: "None",
        value: "none"
    },
    {
        label: "Xero",
        value: "xero"
    },
    {
        label: "Myob Essentials",
        value: "myob-essentials"
    },
    {
        label: "Myob AccountRight",
        value: "myob-accountright"
    },
    {
        label: "Quickbooks",
        value: "quickbooks"
    }
];
let $d6618b604ac15ad6$var$selectedState = (0, $4JcCM.observable)({
    contacts: new Set()
});
const $d6618b604ac15ad6$var$ContactSelectColumns = (onClick)=>[
        {
            id: "label",
            label: "Label",
            type: "text",
            width: 50,
            value: (row)=>{
                return row.label;
            },
            onClick: (row, stores)=>()=>onClick(row)
        }
    ];
var $d6618b604ac15ad6$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ modalId: modalId, onSave: onSave })=>{
    const [fetchStatus, setFetchStatus] = (0, $jbmdS.useState)("idle");
    const [contacts, setContacts] = (0, $jbmdS.useState)([]);
    const [contactFilter, setContactFilter] = (0, $jbmdS.useState)("");
    const accountingSystem = $d6618b604ac15ad6$var$accountingDropdownOptions.find((o)=>{
        var _SessionStore$organis;
        return o.value === ((_SessionStore$organis = (0, $1BTI2.default).organisation) === null || _SessionStore$organis === void 0 ? void 0 : _SessionStore$organis.accountingSystem);
    }) || $d6618b604ac15ad6$var$accountingDropdownOptions[0];
    const accountingSystemConnected = (0, $1BTI2.default).accountingConnected;
    const accountSystemSettings = (0, $1BTI2.default).organisation.accountingSystemSettings;
    // If coming back from OAuth flow, fetch contacts automatically
    (0, $jbmdS.useEffect)(()=>{
        if (accountingSystemConnected && fetchStatus === "idle") (0, $43oHB.fetchAccountingContacts)().then((data)=>{
            if (data !== null && data !== void 0 && data.contacts) {
                setContacts(data.contacts.map((c)=>new (0, $8NSNz.default)(c, {
                        trackUpdates: true,
                        detached: true
                    })));
                setFetchStatus("fetched");
            }
        }).catch((err)=>{
            console.error(err);
            setFetchStatus("error");
        });
    }, [
        accountingSystemConnected,
        fetchStatus
    ]);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fEcKX.default), {
        modalId: modalId,
        heading: "Import Contact",
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    padding: "1em",
                    display: "flex",
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                        style: {
                            flex: "0 0 auto",
                            paddingRight: "1em"
                        },
                        children: [
                            "Accounting System:",
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                        selectedOption: $d6618b604ac15ad6$var$accountingDropdownOptions.find((o)=>o.value === (0, $1BTI2.default).organisation.accountingSystem) || $d6618b604ac15ad6$var$accountingDropdownOptions[0],
                        onChange: (o)=>(0, $1BTI2.default).organisation.update({
                                accountingSystem: o.value
                            }),
                        options: $d6618b604ac15ad6$var$accountingDropdownOptions,
                        optionLabel: (o)=>o.label,
                        style: {
                            flex: "1 1 auto"
                        }
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6ywef.default), {
                        action: "fetchContacts",
                        onActionSuccess: (r)=>{
                            setContacts(r.contacts.map((c)=>new (0, $8NSNz.default)(c, {
                                    trackUpdates: true,
                                    detached: true
                                })));
                            setFetchStatus("fetched");
                        },
                        onActionError: (e)=>{
                            console.error(e);
                            setFetchStatus("error");
                        },
                        onActionStart: (r)=>{
                            setFetchStatus("fetching");
                        },
                        style: {
                            margin: "0 1em",
                            flex: "1 1 auto"
                        }
                    })
                ]
            }),
            accountingSystemConnected ? /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    padding: "1em"
                },
                children: fetchStatus === "fetched" ? /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            style: {
                                display: "flex",
                                alignItems: "center",
                                margin: "0 0.5em 1em",
                                justifyContent: "flex-end"
                            },
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $foLWS.default), {
                                style: {
                                    width: "20em",
                                    textAlign: "right"
                                },
                                placeholder: "Search Contacts",
                                value: contactFilter,
                                onChange: (v)=>{
                                    setContactFilter(v);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            style: {
                                display: "flex",
                                justifyContent: "center"
                            },
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
                                style: {
                                    maxHeight: "22em",
                                    overflow: "auto",
                                    width: "100%"
                                },
                                columns: $d6618b604ac15ad6$var$ContactSelectColumns((row)=>{
                                    var _ContactCollection$co;
                                    const existingContact = (_ContactCollection$co = (0, $bhvQG.default).contactsByAccountingSystemId) === null || _ContactCollection$co === void 0 ? void 0 : _ContactCollection$co[row.accountingSystemContactId];
                                    if (existingContact) {
                                        existingContact.update({
                                            firstName: row.firstName,
                                            lastName: row.lastName,
                                            organisationName: row.organisationName,
                                            phone: row.phone,
                                            email: row.email
                                        });
                                        (0, $fM2j4.default).saveModel(existingContact);
                                        onSave(existingContact);
                                        (0, $khJQv.default).closeModal(modalId);
                                    } else {
                                        row.attach();
                                        (0, $fM2j4.default).saveModel(row);
                                        onSave(row);
                                        (0, $khJQv.default).closeModal(modalId);
                                    }
                                }),
                                rows: contacts.filter((c)=>!contactFilter.length || c.label.toLowerCase().includes(contactFilter.toLowerCase()))
                            })
                        })
                    ]
                }) : fetchStatus === "error" ? "Error Fetching Contacts" : ""
            }) : null
        ]
    });
});

});
parcelRegister("43oHB", function(module, exports) {

$parcel$export(module.exports, "beginAccountingOauth", function () { return $2f3a9a9e10d6810d$export$18640d2f3e2bfed0; });
$parcel$export(module.exports, "connectAccountingOauth", function () { return $2f3a9a9e10d6810d$export$86df032847767650; });
$parcel$export(module.exports, "syncInvoiceToAccounting", function () { return $2f3a9a9e10d6810d$export$693a60c321a66034; });
$parcel$export(module.exports, "fetchAccountingSettings", function () { return $2f3a9a9e10d6810d$export$48d412ff9c9a35fc; });
$parcel$export(module.exports, "fetchAccountingContacts", function () { return $2f3a9a9e10d6810d$export$99aba374f1498742; });

var $4hBm1 = parcelRequire("4hBm1");

var $fM2j4 = parcelRequire("fM2j4");

var $khJQv = parcelRequire("khJQv");

var $1BTI2 = parcelRequire("1BTI2");

var $iOQGT = parcelRequire("iOQGT");

var $6Q5sp = parcelRequire("6Q5sp");
const $2f3a9a9e10d6810d$export$18640d2f3e2bfed0 = async (accountingSystem = (0, $1BTI2.default).organisation.accountingSystem)=>{
    var _accountingSystem, _r$data;
    await (0, $fM2j4.default).startSave();
    (_accountingSystem = accountingSystem) !== null && _accountingSystem !== void 0 ? _accountingSystem : accountingSystem = (0, $1BTI2.default).organisation.accountingSystem;
    // Helper to safely check if modal parameter equals a specific value
    const hasModalParam = (modalName)=>{
        var _router$latestLocatio;
        const searchParams = new URLSearchParams(typeof ((_router$latestLocatio = (0, $6Q5sp.router).latestLocation) === null || _router$latestLocatio === void 0 ? void 0 : _router$latestLocatio.search) === "string" ? (0, $6Q5sp.router).latestLocation.search : "");
        return searchParams.get("modal") === modalName;
    };
    // Determine the state query parameter based on modal
    let stateQueryParam = "";
    if ((0, $khJQv.default).modals.has("invoice-settings") || hasModalParam("invoice-settings")) stateQueryParam = "?modal=invoice-settings";
    else if ((0, $khJQv.default).modals.has("import-one-contact") || hasModalParam("import-one-contact")) stateQueryParam = "?modal=import-one-contact";
    else if ((0, $khJQv.default).modals.has("import-contacts") || hasModalParam("import-contacts")) stateQueryParam = "?modal=import-contacts";
    let r = await (0, $iOQGT.makeRequest)({
        path: `api/v1.5/accounting/redirect`,
        method: "post",
        data: {
            accountingSystem: accountingSystem,
            timezoneOffset: -1 * new Date().getTimezoneOffset(),
            redirectUri: `${"https://launch.coincraft.co"}/accounting/auth`,
            state: (0, $6Q5sp.router).latestLocation.pathname + stateQueryParam
        }
    });
    window.location.href = r === null || r === void 0 ? void 0 : (_r$data = r.data) === null || _r$data === void 0 ? void 0 : _r$data.url;
};
const $2f3a9a9e10d6810d$export$86df032847767650 = async (accountingSystem = (0, $1BTI2.default).organisation.accountingSystem)=>{
    var _router$latestLocatio2, _r$data2;
    let r = await (0, $iOQGT.makeRequest)({
        path: `api/v1.5/accounting/connect`,
        method: "post",
        data: {
            accountingSystem: accountingSystem,
            redirectUri: `${"https://launch.coincraft.co"}/accounting/auth`,
            ...(_router$latestLocatio2 = (0, $6Q5sp.router).latestLocation) === null || _router$latestLocatio2 === void 0 ? void 0 : _router$latestLocatio2.search
        }
    });
    if (r !== null && r !== void 0 && (_r$data2 = r.data) !== null && _r$data2 !== void 0 && _r$data2.expiresAt) await (0, $1BTI2.default).saveAccountingExpires((0, $4hBm1.parseISO)(r.data.expiresAt));
};
const $2f3a9a9e10d6810d$export$693a60c321a66034 = async (invoice, accountingSystem = (0, $1BTI2.default).organisation.accountingSystem)=>{
    var _r$data3;
    const lineItemDescriptions = {};
    invoice.lineItems.forEach((li)=>{
        lineItemDescriptions[li.id] = li.formattedDescription;
    });
    let r = await (0, $iOQGT.makeRequest)({
        path: `api/v1.5/accounting/sync`,
        method: "post",
        data: {
            accountingSystem: accountingSystem,
            redirectUri: `${"https://launch.coincraft.co"}/accounting/auth`,
            invoiceId: invoice.id,
            lineItemDescriptions: lineItemDescriptions
        }
    });
    invoice.accountingSystemId = (0, $1BTI2.default).organisation.accountingSystem;
    invoice.accountingSystemInvoiceId = (r === null || r === void 0 ? void 0 : (_r$data3 = r.data) === null || _r$data3 === void 0 ? void 0 : _r$data3.accountingSystemInvoiceId) || invoice.accountingSystemInvoiceId;
};
const $2f3a9a9e10d6810d$export$48d412ff9c9a35fc = async (accountingSystem = (0, $1BTI2.default).organisation.accountingSystem)=>{
    let r = await (0, $iOQGT.makeRequest)({
        path: `api/v1.5/accounting/settings`,
        method: "post",
        data: {
            accountingSystem: accountingSystem,
            redirectUri: `${"https://launch.coincraft.co"}/accounting/auth`
        }
    });
    (0, $1BTI2.default).organisation.updateAccountingSystemSettings({
        data: r === null || r === void 0 ? void 0 : r.data
    });
    return r === null || r === void 0 ? void 0 : r.data;
};
const $2f3a9a9e10d6810d$export$99aba374f1498742 = async (accountingSystem = (0, $1BTI2.default).organisation.accountingSystem)=>{
    let r = await (0, $iOQGT.makeRequest)({
        path: `api/v1.5/accounting/contacts`,
        method: "post",
        data: {
            accountingSystem: accountingSystem,
            redirectUri: `${"https://launch.coincraft.co"}/accounting/auth`
        }
    });
    return r === null || r === void 0 ? void 0 : r.data;
};

});
parcelRegister("iOQGT", function(module, exports) {

$parcel$export(module.exports, "makeRequest", function () { return $db35c4d295232b1c$export$699251e5611cc6db; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("jbmdS");

var $f2HBX = parcelRequire("f2HBX");

var $khJQv = parcelRequire("khJQv");

var $2vZjW = parcelRequire("2vZjW");

var $1BTI2 = parcelRequire("1BTI2");

var $iKbxs = parcelRequire("iKbxs");

var $clrGT = parcelRequire("clrGT");


var $8kZ1o = parcelRequire("8kZ1o");

var $6Q5sp = parcelRequire("6Q5sp");

var $3H03w = parcelRequire("3H03w");
async function $db35c4d295232b1c$export$699251e5611cc6db({ path: path, method: method, data: data, baseURL: baseURL = "https://api.coincraft.co", maxRetries: maxRetries = 1 }) {
    //const maxRetries = 3
    const retryDelay = 500; // Delay in milliseconds
    let attempts = 0;
    data = (0, $clrGT.default)(data);
    // Check if this is a login request - if so, we handle errors differently
    const isLoginRequest = path.includes("/api/v1.5/user/login");
    while(attempts < maxRetries)try {
        const headers = {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json"
        };
        if ((0, $8kZ1o.usingNewLogin)()) {
            var _clerk$session, _clerk$session$getTok, _clerk$session2;
            const token = await ((0, $6Q5sp.clerk) === null || (0, $6Q5sp.clerk) === void 0 ? void 0 : (_clerk$session = (0, $6Q5sp.clerk).session) === null || _clerk$session === void 0 ? void 0 : (_clerk$session$getTok = (_clerk$session2 = _clerk$session).getToken) === null || _clerk$session$getTok === void 0 ? void 0 : _clerk$session$getTok.call(_clerk$session2, {
                template: "coincraft"
            }));
            headers.Authorization = `Bearer ${token}`;
        }
        if ((0, $1BTI2.default).userId) headers["x-user-id"] = (0, $1BTI2.default).userId;
        if ((0, $1BTI2.default).organisationId) headers["x-org-id"] = (0, $1BTI2.default).organisationId;
        // Add PostHog session info for server-side event tracking
        try {
            const sessionId = (0, $3H03w.default).get_session_id();
            const distinctId = (0, $3H03w.default).get_distinct_id();
            if (sessionId) headers["x-posthog-session-id"] = sessionId;
            if (distinctId) headers["x-posthog-distinct-id"] = distinctId;
        } catch (error) {
            // PostHog might not be initialized yet, that's ok
            console.debug("PostHog session info not available:", error.message);
        }
        const response = await (0, (/*@__PURE__*/$parcel$interopDefault($f2HBX))).request({
            baseURL: baseURL,
            url: path,
            method: method,
            data: data,
            timeout: 30000,
            withCredentials: true,
            headers: headers
        });
        return response;
    } catch (error) {
        var _error$response;
        // Check if the error is a timeout
        if ((0, (/*@__PURE__*/$parcel$interopDefault($f2HBX))).isCancel(error) || error.code === "ECONNABORTED" || error.message.includes("timeout")) {
            attempts = maxRetries;
            throw error; // Do not retry on timeouts
        }
        // Special case for login requests - don't redirect to login page for login failures
        if (((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 401 && !isLoginRequest) {
            await (0, $1BTI2.default).checkAuthentication();
            attempts = maxRetries;
            if (!(0, $8kZ1o.usingNewLogin)() && (0, $khJQv.default).pageRendered) (0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $2vZjW.default), {
                modalId: "login-modal"
            }));
            else window.location.replace("/login");
        }
        attempts++;
        // check login
        if (attempts >= maxRetries) {
            $iKbxs.captureException(error);
            (0, $3H03w.default).captureException(error);
            // Handle error or throw it after max retries
            if (error.response) console.error(error.response);
            else if (error.request) console.error(error.request);
            else console.error("Error", error.message);
            throw error;
        }
        // Wait for a specified time before retrying
        await new Promise((resolve)=>setTimeout(resolve, retryDelay));
    }
}

});
parcelRegister("f2HBX", function(module, exports) {

module.exports = (parcelRequire("fzwuk"));

});
parcelRegister("fzwuk", function(module, exports) {
"use strict";

var $dbSQl = parcelRequire("dbSQl");

var $iMMCS = parcelRequire("iMMCS");

var $18EoT = parcelRequire("18EoT");

var $aFSY7 = parcelRequire("aFSY7");

var $jnThg = parcelRequire("jnThg");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $b5635365f07aaa33$var$createInstance(defaultConfig) {
    var context = new $18EoT(defaultConfig);
    var instance = $iMMCS($18EoT.prototype.request, context);
    // Copy axios.prototype to instance
    $dbSQl.extend(instance, $18EoT.prototype, context);
    // Copy context to instance
    $dbSQl.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $b5635365f07aaa33$var$axios = $b5635365f07aaa33$var$createInstance($jnThg);
// Expose Axios class to allow class inheritance
$b5635365f07aaa33$var$axios.Axios = $18EoT;
// Factory for creating new instances
$b5635365f07aaa33$var$axios.create = function create(instanceConfig) {
    return $b5635365f07aaa33$var$createInstance($aFSY7($b5635365f07aaa33$var$axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
$b5635365f07aaa33$var$axios.Cancel = (parcelRequire("eLjDt"));

$b5635365f07aaa33$var$axios.CancelToken = (parcelRequire("cjHdX"));

$b5635365f07aaa33$var$axios.isCancel = (parcelRequire("hZBzN"));
// Expose all/spread
$b5635365f07aaa33$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$b5635365f07aaa33$var$axios.spread = (parcelRequire("j1L0R"));
module.exports = $b5635365f07aaa33$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $b5635365f07aaa33$var$axios;

});
parcelRegister("dbSQl", function(module, exports) {
"use strict";

var $iMMCS = parcelRequire("iMMCS");
/*global toString:true*/ // utils is a library of generic helper functions non-specific to axios
var $99a6d82c8747f854$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $99a6d82c8747f854$var$isArray(val) {
    return $99a6d82c8747f854$var$toString.call(val) === "[object Array]";
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $99a6d82c8747f854$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $99a6d82c8747f854$var$isBuffer(val) {
    return val !== null && !$99a6d82c8747f854$var$isUndefined(val) && val.constructor !== null && !$99a6d82c8747f854$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $99a6d82c8747f854$var$isArrayBuffer(val) {
    return $99a6d82c8747f854$var$toString.call(val) === "[object ArrayBuffer]";
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $99a6d82c8747f854$var$isFormData(val) {
    return typeof FormData !== "undefined" && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $99a6d82c8747f854$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $99a6d82c8747f854$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $99a6d82c8747f854$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $99a6d82c8747f854$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $99a6d82c8747f854$var$isDate(val) {
    return $99a6d82c8747f854$var$toString.call(val) === "[object Date]";
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $99a6d82c8747f854$var$isFile(val) {
    return $99a6d82c8747f854$var$toString.call(val) === "[object File]";
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $99a6d82c8747f854$var$isBlob(val) {
    return $99a6d82c8747f854$var$toString.call(val) === "[object Blob]";
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $99a6d82c8747f854$var$isFunction(val) {
    return $99a6d82c8747f854$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $99a6d82c8747f854$var$isStream(val) {
    return $99a6d82c8747f854$var$isObject(val) && $99a6d82c8747f854$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $99a6d82c8747f854$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $99a6d82c8747f854$var$trim(str) {
    return str.replace(/^\s*/, "").replace(/\s*$/, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $99a6d82c8747f854$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $99a6d82c8747f854$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($99a6d82c8747f854$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $99a6d82c8747f854$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if (typeof result[key] === "object" && typeof val === "object") result[key] = $99a6d82c8747f854$var$merge(result[key], val);
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$99a6d82c8747f854$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $99a6d82c8747f854$var$deepMerge() {
    var result = {};
    function assignValue(val, key) {
        if (typeof result[key] === "object" && typeof val === "object") result[key] = $99a6d82c8747f854$var$deepMerge(result[key], val);
        else if (typeof val === "object") result[key] = $99a6d82c8747f854$var$deepMerge({}, val);
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$99a6d82c8747f854$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $99a6d82c8747f854$var$extend(a, b, thisArg) {
    $99a6d82c8747f854$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $iMMCS(val, thisArg);
        else a[key] = val;
    });
    return a;
}
module.exports = {
    isArray: $99a6d82c8747f854$var$isArray,
    isArrayBuffer: $99a6d82c8747f854$var$isArrayBuffer,
    isBuffer: $99a6d82c8747f854$var$isBuffer,
    isFormData: $99a6d82c8747f854$var$isFormData,
    isArrayBufferView: $99a6d82c8747f854$var$isArrayBufferView,
    isString: $99a6d82c8747f854$var$isString,
    isNumber: $99a6d82c8747f854$var$isNumber,
    isObject: $99a6d82c8747f854$var$isObject,
    isUndefined: $99a6d82c8747f854$var$isUndefined,
    isDate: $99a6d82c8747f854$var$isDate,
    isFile: $99a6d82c8747f854$var$isFile,
    isBlob: $99a6d82c8747f854$var$isBlob,
    isFunction: $99a6d82c8747f854$var$isFunction,
    isStream: $99a6d82c8747f854$var$isStream,
    isURLSearchParams: $99a6d82c8747f854$var$isURLSearchParams,
    isStandardBrowserEnv: $99a6d82c8747f854$var$isStandardBrowserEnv,
    forEach: $99a6d82c8747f854$var$forEach,
    merge: $99a6d82c8747f854$var$merge,
    deepMerge: $99a6d82c8747f854$var$deepMerge,
    extend: $99a6d82c8747f854$var$extend,
    trim: $99a6d82c8747f854$var$trim
};

});
parcelRegister("iMMCS", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("18EoT", function(module, exports) {
"use strict";

var $dbSQl = parcelRequire("dbSQl");

var $75Z6p = parcelRequire("75Z6p");

var $iG5aX = parcelRequire("iG5aX");

var $2S5XW = parcelRequire("2S5XW");

var $aFSY7 = parcelRequire("aFSY7");
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $0d45e07dd034e169$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $iG5aX(),
        response: new $iG5aX()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $0d45e07dd034e169$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === "string") {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $aFSY7(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    // Hook up interceptors middleware
    var chain = [
        $2S5XW,
        undefined
    ];
    var promise = Promise.resolve(config);
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        chain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        chain.push(interceptor.fulfilled, interceptor.rejected);
    });
    while(chain.length)promise = promise.then(chain.shift(), chain.shift());
    return promise;
};
$0d45e07dd034e169$var$Axios.prototype.getUri = function getUri(config) {
    config = $aFSY7(this.defaults, config);
    return $75Z6p(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
// Provide aliases for supported request methods
$dbSQl.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $0d45e07dd034e169$var$Axios.prototype[method] = function(url, config) {
        return this.request($dbSQl.merge(config || {}, {
            method: method,
            url: url
        }));
    };
});
$dbSQl.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $0d45e07dd034e169$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($dbSQl.merge(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $0d45e07dd034e169$var$Axios;

});
parcelRegister("75Z6p", function(module, exports) {
"use strict";

var $dbSQl = parcelRequire("dbSQl");
function $52a865b4032cb05d$var$encode(val) {
    return encodeURIComponent(val).replace(/%40/gi, "@").replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($dbSQl.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $dbSQl.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($dbSQl.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $dbSQl.forEach(val, function parseValue(v) {
                if ($dbSQl.isDate(v)) v = v.toISOString();
                else if ($dbSQl.isObject(v)) v = JSON.stringify(v);
                parts.push($52a865b4032cb05d$var$encode(key) + "=" + $52a865b4032cb05d$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRegister("iG5aX", function(module, exports) {
"use strict";

var $dbSQl = parcelRequire("dbSQl");
function $d9902a05d8eda3b7$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $d9902a05d8eda3b7$var$InterceptorManager.prototype.use = function use(fulfilled, rejected) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $d9902a05d8eda3b7$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $d9902a05d8eda3b7$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $dbSQl.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $d9902a05d8eda3b7$var$InterceptorManager;

});

parcelRegister("2S5XW", function(module, exports) {
"use strict";

var $dbSQl = parcelRequire("dbSQl");

var $8PzSh = parcelRequire("8PzSh");

var $hZBzN = parcelRequire("hZBzN");

var $jnThg = parcelRequire("jnThg");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $217540962ca48b11$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $217540962ca48b11$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $8PzSh(config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $dbSQl.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $dbSQl.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $jnThg.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $217540962ca48b11$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $8PzSh(response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$hZBzN(reason)) {
            $217540962ca48b11$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $8PzSh(reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("8PzSh", function(module, exports) {
"use strict";

var $dbSQl = parcelRequire("dbSQl");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    /*eslint no-param-reassign:0*/ $dbSQl.forEach(fns, function transform(fn) {
        data = fn(data, headers);
    });
    return data;
};

});

parcelRegister("hZBzN", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});

parcelRegister("jnThg", function(module, exports) {

var $2Prz7 = parcelRequire("2Prz7");
"use strict";

var $dbSQl = parcelRequire("dbSQl");

var $k0J0C = parcelRequire("k0J0C");
var $e1cb0b3bb0b2d672$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $e1cb0b3bb0b2d672$var$setContentTypeIfUnset(headers, value) {
    if (!$dbSQl.isUndefined(headers) && $dbSQl.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $e1cb0b3bb0b2d672$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("84ipc"));
    else if (typeof $2Prz7 !== "undefined" && Object.prototype.toString.call($2Prz7) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("84ipc"));
    return adapter;
}
var $e1cb0b3bb0b2d672$var$defaults = {
    adapter: $e1cb0b3bb0b2d672$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $k0J0C(headers, "Accept");
            $k0J0C(headers, "Content-Type");
            if ($dbSQl.isFormData(data) || $dbSQl.isArrayBuffer(data) || $dbSQl.isBuffer(data) || $dbSQl.isStream(data) || $dbSQl.isFile(data) || $dbSQl.isBlob(data)) return data;
            if ($dbSQl.isArrayBufferView(data)) return data.buffer;
            if ($dbSQl.isURLSearchParams(data)) {
                $e1cb0b3bb0b2d672$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            if ($dbSQl.isObject(data)) {
                $e1cb0b3bb0b2d672$var$setContentTypeIfUnset(headers, "application/json;charset=utf-8");
                return JSON.stringify(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            /*eslint no-param-reassign:0*/ if (typeof data === "string") try {
                data = JSON.parse(data);
            } catch (e) {}
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$e1cb0b3bb0b2d672$var$defaults.headers = {
    common: {
        "Accept": "application/json, text/plain, */*"
    }
};
$dbSQl.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $e1cb0b3bb0b2d672$var$defaults.headers[method] = {};
});
$dbSQl.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $e1cb0b3bb0b2d672$var$defaults.headers[method] = $dbSQl.merge($e1cb0b3bb0b2d672$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $e1cb0b3bb0b2d672$var$defaults;

});
parcelRegister("k0J0C", function(module, exports) {
"use strict";

var $dbSQl = parcelRequire("dbSQl");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $dbSQl.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("84ipc", function(module, exports) {
"use strict";

var $dbSQl = parcelRequire("dbSQl");

var $kezmP = parcelRequire("kezmP");

var $75Z6p = parcelRequire("75Z6p");

var $8lTr6 = parcelRequire("8lTr6");

var $41F7G = parcelRequire("41F7G");

var $9Zqgf = parcelRequire("9Zqgf");

var $gpDLS = parcelRequire("gpDLS");

module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        if ($dbSQl.isFormData(requestData)) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password || "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $8lTr6(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $75Z6p(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        // Listen for ready state
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $41F7G(request.getAllResponseHeaders()) : null;
            var responseData = !config.responseType || config.responseType === "text" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $kezmP(resolve, reject, response);
            // Clean up request
            request = null;
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($gpDLS("Request aborted", config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($gpDLS("Network Error", config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = "timeout of " + config.timeout + "ms exceeded";
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($gpDLS(timeoutErrorMessage, config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($dbSQl.isStandardBrowserEnv()) {
            var cookies = (parcelRequire("8bMWY"));
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $9Zqgf(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $dbSQl.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$dbSQl.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (config.responseType) try {
            request.responseType = config.responseType;
        } catch (e) {
            // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
            // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
            if (config.responseType !== "json") throw e;
        }
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (requestData === undefined) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("kezmP", function(module, exports) {
"use strict";

var $gpDLS = parcelRequire("gpDLS");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!validateStatus || validateStatus(response.status)) resolve(response);
    else reject($gpDLS("Request failed with status code " + response.status, response.config, null, response.request, response));
};

});
parcelRegister("gpDLS", function(module, exports) {
"use strict";

var $2bEhQ = parcelRequire("2bEhQ");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $2bEhQ(error, config, code, request, response);
};

});
parcelRegister("2bEhQ", function(module, exports) {
"use strict";
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};

});



parcelRegister("8lTr6", function(module, exports) {
"use strict";

var $hLwn1 = parcelRequire("hLwn1");

var $fwd3C = parcelRequire("fwd3C");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$hLwn1(requestedURL)) return $fwd3C(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("hLwn1", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("fwd3C", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRegister("41F7G", function(module, exports) {
"use strict";

var $dbSQl = parcelRequire("dbSQl");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $2ee72796f1ce179a$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $dbSQl.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $dbSQl.trim(line.substr(0, i)).toLowerCase();
        val = $dbSQl.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $2ee72796f1ce179a$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("9Zqgf", function(module, exports) {
"use strict";

var $dbSQl = parcelRequire("dbSQl");
module.exports = $dbSQl.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $dbSQl.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("8bMWY", function(module, exports) {
"use strict";

var $dbSQl = parcelRequire("dbSQl");
module.exports = $dbSQl.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($dbSQl.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($dbSQl.isString(path)) cookie.push("path=" + path);
            if ($dbSQl.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});




parcelRegister("aFSY7", function(module, exports) {
"use strict";

var $dbSQl = parcelRequire("dbSQl");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var valueFromConfig2Keys = [
        "url",
        "method",
        "params",
        "data"
    ];
    var mergeDeepPropertiesKeys = [
        "headers",
        "auth",
        "proxy"
    ];
    var defaultToConfig2Keys = [
        "baseURL",
        "url",
        "transformRequest",
        "transformResponse",
        "paramsSerializer",
        "timeout",
        "withCredentials",
        "adapter",
        "responseType",
        "xsrfCookieName",
        "xsrfHeaderName",
        "onUploadProgress",
        "onDownloadProgress",
        "maxContentLength",
        "validateStatus",
        "maxRedirects",
        "httpAgent",
        "httpsAgent",
        "cancelToken",
        "socketPath"
    ];
    $dbSQl.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (typeof config2[prop] !== "undefined") config[prop] = config2[prop];
    });
    $dbSQl.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
        if ($dbSQl.isObject(config2[prop])) config[prop] = $dbSQl.deepMerge(config1[prop], config2[prop]);
        else if (typeof config2[prop] !== "undefined") config[prop] = config2[prop];
        else if ($dbSQl.isObject(config1[prop])) config[prop] = $dbSQl.deepMerge(config1[prop]);
        else if (typeof config1[prop] !== "undefined") config[prop] = config1[prop];
    });
    $dbSQl.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (typeof config2[prop] !== "undefined") config[prop] = config2[prop];
        else if (typeof config1[prop] !== "undefined") config[prop] = config1[prop];
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys);
    var otherKeys = Object.keys(config2).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    $dbSQl.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
        if (typeof config2[prop] !== "undefined") config[prop] = config2[prop];
        else if (typeof config1[prop] !== "undefined") config[prop] = config1[prop];
    });
    return config;
};

});


parcelRegister("eLjDt", function(module, exports) {
"use strict";
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $abf4afb32c525e7e$var$Cancel(message) {
    this.message = message;
}
$abf4afb32c525e7e$var$Cancel.prototype.toString = function toString() {
    return "Cancel" + (this.message ? ": " + this.message : "");
};
$abf4afb32c525e7e$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $abf4afb32c525e7e$var$Cancel;

});

parcelRegister("cjHdX", function(module, exports) {
"use strict";

var $eLjDt = parcelRequire("eLjDt");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $8f78c9c9e7466180$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $eLjDt(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $8f78c9c9e7466180$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $8f78c9c9e7466180$var$CancelToken.source = function source() {
    var cancel;
    var token = new $8f78c9c9e7466180$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $8f78c9c9e7466180$var$CancelToken;

});

parcelRegister("j1L0R", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});



parcelRegister("2vZjW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d4e0b03ad812fbc$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $fEcKX = parcelRequire("fEcKX");

var $khJQv = parcelRequire("khJQv");
parcelRequire("fEtu5");
var $zyiwQ = parcelRequire("zyiwQ");

var $1BTI2 = parcelRequire("1BTI2");

var $iKbxs = parcelRequire("iKbxs");

var $kqlQp = parcelRequire("kqlQp");
var $6UBLf = parcelRequire("6UBLf");
parcelRequire("02LyB");

var $3H03w = parcelRequire("3H03w");
var $1d4e0b03ad812fbc$export$2e2bcd8739ae039 = ({ modalId: modalId })=>{
    var _SessionStore$user;
    const navigate = (0, $6UBLf.useNavigate)();
    const [loginState, setLoginState] = (0, $jbmdS.useState)("idle");
    const [email, setEmail] = (0, $jbmdS.useState)(((0, $1BTI2.default) === null || (0, $1BTI2.default) === void 0 ? void 0 : (_SessionStore$user = (0, $1BTI2.default).user) === null || _SessionStore$user === void 0 ? void 0 : _SessionStore$user.email) || "");
    const [password, setPassword] = (0, $jbmdS.useState)("");
    const handleSubmit = async (event)=>{
        var _event$preventDefault;
        event === null || event === void 0 || (_event$preventDefault = event.preventDefault) === null || _event$preventDefault === void 0 || _event$preventDefault.call(event);
        try {
            setLoginState("pending");
            await (0, $1BTI2.default).login({
                email: email,
                password: password
            });
            setLoginState("success");
        } catch (error) {
            $iKbxs.captureException(error);
            (0, $3H03w.default).captureException(error);
            setLoginState("error");
        }
    };
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fEcKX.default), {
        modalId: modalId,
        heading: "Login Expired",
        saveLabel: "Sign In",
        onSave: handleSubmit,
        onClose: ()=>{
            (0, $khJQv.default).closeModal(modalId);
            navigate({
                to: "/login"
            });
        },
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            className: "body",
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsxs)("form", {
                    onSubmit: async (e)=>{
                        try {
                            await handleSubmit(e);
                            (0, $khJQv.default).closeModal(modalId);
                        } catch (e) {
                            console.error(e);
                        }
                    },
                    children: [
                        " ",
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            className: "form-group mb-5",
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "input-group input-group-lg",
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
                                    value: email || "",
                                    onChange: (e)=>setEmail(e.target.value),
                                    type: "email",
                                    className: "form-control input-lg login-widget__email-input input-base w-full h-10 py-2 focus:outline-none hover:border-[#618fb0]",
                                    placeholder: "Your Email"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            className: "form-group",
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "input-group input-group-lg",
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
                                    type: "password",
                                    value: password || "",
                                    onChange: (e)=>setPassword(e.target.value),
                                    className: "form-control input-lg login-widget__password-input input-base w-full h-10 py-2 focus:outline-none hover:border-[#618fb0]",
                                    placeholder: "Your Password"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                            type: "submit",
                            style: {
                                display: "none"
                            }
                        })
                    ]
                }),
                loginState === "error" && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $zyiwQ.ErrorAlert), {
                    children: `Sorry, we couldn't log you in with those details. Please try again.`
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    className: "forgot",
                    style: {
                        textAlign: "right"
                    },
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqlQp.Link), {
                        to: `/forgotten-password?email=${email}`,
                        className: "forgot",
                        children: "Forgotten Your Password?"
                    })
                })
            ]
        })
    });
};

});
parcelRegister("kqlQp", function(module, exports) {

$parcel$export(module.exports, "Link", function () { return $ede72e28be53fca0$export$a6c7ac8248d6e38a; });

var $4TLFw = parcelRequire("4TLFw");

var $jbmdS = parcelRequire("jbmdS");

var $jCNM0 = parcelRequire("jCNM0");

var $bypHT = parcelRequire("bypHT");
var $2oA9E = parcelRequire("2oA9E");
var $9q1lR = parcelRequire("9q1lR");

var $2cXZi = parcelRequire("2cXZi");

var $1Fr27 = parcelRequire("1Fr27");

var $l70dZ = parcelRequire("l70dZ");

var $4huLw = parcelRequire("4huLw");
function $ede72e28be53fca0$export$7e924b3091a3bd18(options, forwardedRef) {
    const router = (0, $1Fr27.useRouter)();
    const [isTransitioning, setIsTransitioning] = $jbmdS.useState(false);
    const hasRenderFetched = $jbmdS.useRef(false);
    const innerRef = (0, $l70dZ.useForwardedRef)(forwardedRef);
    const { activeProps: // custom props
    activeProps = ()=>({
            className: "active"
        }), inactiveProps: inactiveProps = ()=>({}), activeOptions: activeOptions, to: to, preload: userPreload, preloadDelay: userPreloadDelay, hashScrollIntoView: hashScrollIntoView, replace: replace, startTransition: startTransition, resetScroll: resetScroll, viewTransition: viewTransition, children: // element props
    children, target: target, disabled: disabled, style: style, className: className, onClick: onClick, onFocus: onFocus, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart, ignoreBlocker: ignoreBlocker, ...rest } = options;
    const { // prevent these from being returned
    params: _params, search: _search, hash: _hash, state: _state, mask: _mask, reloadDocument: _reloadDocument, ...propsSafeToSpread } = rest;
    const type = $jbmdS.useMemo(()=>{
        try {
            new URL(`${to}`);
            return "external";
        } catch  {}
        return "internal";
    }, [
        to
    ]);
    const currentSearch = (0, $2cXZi.useRouterState)({
        select: (s)=>s.location.search,
        structuralSharing: true
    });
    const parentRouteId = (0, $4huLw.useMatch)({
        strict: false,
        select: (s)=>s.pathname
    });
    options = {
        from: parentRouteId,
        ...options
    };
    const next = $jbmdS.useMemo(()=>router.buildLocation(options), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        router,
        options,
        currentSearch
    ]);
    const preload = $jbmdS.useMemo(()=>{
        if (options.reloadDocument) return false;
        return userPreload ?? router.options.defaultPreload;
    }, [
        router.options.defaultPreload,
        userPreload,
        options.reloadDocument
    ]);
    const preloadDelay = userPreloadDelay ?? router.options.defaultPreloadDelay ?? 0;
    const isActive = (0, $2cXZi.useRouterState)({
        select: (s)=>{
            if (activeOptions == null ? void 0 : activeOptions.exact) {
                const testExact = (0, $2oA9E.exactPathTest)(s.location.pathname, next.pathname, router.basepath);
                if (!testExact) return false;
            } else {
                const currentPathSplit = (0, $2oA9E.removeTrailingSlash)(s.location.pathname, router.basepath).split("/");
                const nextPathSplit = (0, $2oA9E.removeTrailingSlash)(next.pathname, router.basepath).split("/");
                const pathIsFuzzyEqual = nextPathSplit.every((d, i)=>d === currentPathSplit[i]);
                if (!pathIsFuzzyEqual) return false;
            }
            if ((activeOptions == null ? void 0 : activeOptions.includeSearch) ?? true) {
                const searchTest = (0, $bypHT.deepEqual)(s.location.search, next.search, {
                    partial: !(activeOptions == null ? void 0 : activeOptions.exact),
                    ignoreUndefined: !(activeOptions == null ? void 0 : activeOptions.explicitUndefined)
                });
                if (!searchTest) return false;
            }
            if (activeOptions == null ? void 0 : activeOptions.includeHash) return s.location.hash === next.hash;
            return true;
        }
    });
    const doPreload = $jbmdS.useCallback(()=>{
        router.preloadRoute(options).catch((err)=>{
            console.warn(err);
            console.warn((0, $9q1lR.preloadWarning));
        });
    }, [
        options,
        router
    ]);
    const preloadViewportIoCallback = $jbmdS.useCallback((entry)=>{
        if (entry == null ? void 0 : entry.isIntersecting) doPreload();
    }, [
        doPreload
    ]);
    (0, $l70dZ.useIntersectionObserver)(innerRef, preloadViewportIoCallback, {
        rootMargin: "100px"
    }, {
        disabled: !!disabled || !(preload === "viewport")
    });
    (0, $l70dZ.useLayoutEffect)(()=>{
        if (hasRenderFetched.current) return;
        if (!disabled && preload === "render") {
            doPreload();
            hasRenderFetched.current = true;
        }
    }, [
        disabled,
        doPreload,
        preload
    ]);
    if (type === "external") return {
        ...propsSafeToSpread,
        ref: innerRef,
        type: type,
        href: to,
        ...children && {
            children: children
        },
        ...target && {
            target: target
        },
        ...disabled && {
            disabled: disabled
        },
        ...style && {
            style: style
        },
        ...className && {
            className: className
        },
        ...onClick && {
            onClick: onClick
        },
        ...onFocus && {
            onFocus: onFocus
        },
        ...onMouseEnter && {
            onMouseEnter: onMouseEnter
        },
        ...onMouseLeave && {
            onMouseLeave: onMouseLeave
        },
        ...onTouchStart && {
            onTouchStart: onTouchStart
        }
    };
    const handleClick = (e)=>{
        if (!disabled && !$ede72e28be53fca0$var$isCtrlEvent(e) && !e.defaultPrevented && (!target || target === "_self") && e.button === 0) {
            e.preventDefault();
            (0, $jCNM0.flushSync)(()=>{
                setIsTransitioning(true);
            });
            const unsub = router.subscribe("onResolved", ()=>{
                unsub();
                setIsTransitioning(false);
            });
            return router.navigate({
                ...options,
                replace: replace,
                resetScroll: resetScroll,
                hashScrollIntoView: hashScrollIntoView,
                startTransition: startTransition,
                viewTransition: viewTransition,
                ignoreBlocker: ignoreBlocker
            });
        }
    };
    const handleFocus = (_)=>{
        if (disabled) return;
        if (preload) doPreload();
    };
    const handleTouchStart = handleFocus;
    const handleEnter = (e)=>{
        if (disabled) return;
        const eventTarget = e.target || {};
        if (preload) {
            if (eventTarget.preloadTimeout) return;
            eventTarget.preloadTimeout = setTimeout(()=>{
                eventTarget.preloadTimeout = null;
                doPreload();
            }, preloadDelay);
        }
    };
    const handleLeave = (e)=>{
        if (disabled) return;
        const eventTarget = e.target || {};
        if (eventTarget.preloadTimeout) {
            clearTimeout(eventTarget.preloadTimeout);
            eventTarget.preloadTimeout = null;
        }
    };
    const composeHandlers = (handlers)=>(e)=>{
            var _a;
            (_a = e.persist) == null || _a.call(e);
            handlers.filter(Boolean).forEach((handler)=>{
                if (e.defaultPrevented) return;
                handler(e);
            });
        };
    const resolvedActiveProps = isActive ? (0, $bypHT.functionalUpdate)(activeProps, {}) ?? {} : {};
    const resolvedInactiveProps = isActive ? {} : (0, $bypHT.functionalUpdate)(inactiveProps, {});
    const resolvedClassName = [
        className,
        resolvedActiveProps.className,
        resolvedInactiveProps.className
    ].filter(Boolean).join(" ");
    const resolvedStyle = {
        ...style,
        ...resolvedActiveProps.style,
        ...resolvedInactiveProps.style
    };
    return {
        ...propsSafeToSpread,
        ...resolvedActiveProps,
        ...resolvedInactiveProps,
        href: disabled ? void 0 : next.maskedLocation ? router.history.createHref(next.maskedLocation.href) : router.history.createHref(next.href),
        ref: innerRef,
        onClick: composeHandlers([
            onClick,
            handleClick
        ]),
        onFocus: composeHandlers([
            onFocus,
            handleFocus
        ]),
        onMouseEnter: composeHandlers([
            onMouseEnter,
            handleEnter
        ]),
        onMouseLeave: composeHandlers([
            onMouseLeave,
            handleLeave
        ]),
        onTouchStart: composeHandlers([
            onTouchStart,
            handleTouchStart
        ]),
        disabled: !!disabled,
        target: target,
        ...Object.keys(resolvedStyle).length && {
            style: resolvedStyle
        },
        ...resolvedClassName && {
            className: resolvedClassName
        },
        ...disabled && {
            role: "link",
            "aria-disabled": true
        },
        ...isActive && {
            "data-status": "active",
            "aria-current": "page"
        },
        ...isTransitioning && {
            "data-transitioning": "transitioning"
        }
    };
}
function $ede72e28be53fca0$export$cdda5b1be25f9499(Comp) {
    return $jbmdS.forwardRef(function CreatedLink(props, ref) {
        return /* @__PURE__ */ (0, $4TLFw.jsx)($ede72e28be53fca0$export$a6c7ac8248d6e38a, {
            ...props,
            _asChild: Comp,
            ref: ref
        });
    });
}
const $ede72e28be53fca0$export$a6c7ac8248d6e38a = $jbmdS.forwardRef((props, ref)=>{
    const { _asChild: _asChild, ...rest } = props;
    const { type: _type, ref: innerRef, ...linkProps } = $ede72e28be53fca0$export$7e924b3091a3bd18(rest, ref);
    const children = typeof rest.children === "function" ? rest.children({
        isActive: linkProps["data-status"] === "active"
    }) : rest.children;
    if (typeof _asChild === "undefined") delete linkProps.disabled;
    return $jbmdS.createElement(_asChild ? _asChild : "a", {
        ...linkProps,
        ref: innerRef
    }, children);
});
function $ede72e28be53fca0$var$isCtrlEvent(e) {
    return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
}
const $ede72e28be53fca0$export$e59c53748bd0ed3d = (options)=>{
    return options;
};

});
parcelRegister("9q1lR", function(module, exports) {

$parcel$export(module.exports, "preloadWarning", function () { return $6db7972a736a00c7$export$fe194d064ae6fae0; });
const $6db7972a736a00c7$export$fe194d064ae6fae0 = "Error preloading route! \u261D\uFE0F";

});



parcelRegister("clrGT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8fcced0341b52346$export$2e2bcd8739ae039; });
function $8fcced0341b52346$export$2e2bcd8739ae039(object) {
    const seenObjects = new WeakMap();
    function internalDecircular(value, path = []) {
        if (!(value !== null && typeof value === "object")) return value;
        const existingPath = seenObjects.get(value);
        if (existingPath) return `[Circular *${existingPath.join(".")}]`;
        seenObjects.set(value, path);
        const newValue = Array.isArray(value) ? [] : {};
        for (const [key2, value2] of Object.entries(value))newValue[key2] = internalDecircular(value2, [
            ...path,
            key2
        ]);
        seenObjects.delete(value);
        return newValue;
    }
    return internalDecircular(object);
}

});



parcelRegister("goLmS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf03a1833e7d9ef0$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $BPPBq = parcelRequire("BPPBq");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $hdshG = parcelRequire("hdshG");

var $6RcUP = parcelRequire("6RcUP");

var $6d1V1 = parcelRequire("6d1V1");

var $1fkTL = parcelRequire("1fkTL");

var $d8zxI = parcelRequire("d8zxI");

var $eat5C = parcelRequire("eat5C");

var $4Jl8d = parcelRequire("4Jl8d");
const $bf03a1833e7d9ef0$var$useSize = (target)=>{
    const [size, setSize] = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useState();
    (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useLayoutEffect(()=>{
        setSize(target.current.getBoundingClientRect());
    }, [
        target
    ]);
    // Where the magic happens
    (0, $d8zxI.default)(target, (entry)=>setSize(entry.contentRect));
    return size;
};
function $bf03a1833e7d9ef0$var$remToPx(rem) {
    const remToPxRatio = 10;
    return rem * remToPxRatio;
}
var $bf03a1833e7d9ef0$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ id: id, tableStore: tableStore, columns: columns, rows: rows, filters: filters, interfaceRows: interfaceRows, getChildComponent: getChildComponent, showHeader: showHeader = true, showTotals: showTotals = false, className: className = "", headerClassName: headerClassName = "", headerStyle: headerStyle = {}, style: style, sortBy: sortBy, groupBy: groupBy, expandedGroups: expandedGroups, newRowDirection: newRowDirection = "desc", queryResults: queryResults, onExpand: onExpand, onCollapse: onCollapse, topRow: topRow, expandAll: expandAll, totalsRowStyles: totalsRowStyles, totalsCellStyles: totalsCellStyles, draggable: draggable = false, onReorder: onReorder, ...props })=>{
    const isPrinting = (0, $6d1V1.useMediaQuery)("print");
    const [store, setStore] = (0, $jbmdS.useState)(tableStore || new (0, $hdshG.default)());
    (0, $jbmdS.useEffect)(()=>{
        if (tableStore && tableStore !== store) {
            setStore(tableStore);
            tableStore.update({
                columns: columns,
                rows: rows,
                getChildComponent: getChildComponent,
                showHeader: showHeader,
                showTotals: showTotals,
                sortBy: sortBy,
                groupBy: groupBy,
                expandedGroups: expandedGroups,
                filters: filters,
                newRowDirection: newRowDirection,
                onExpand: onExpand,
                onCollapse: onCollapse,
                expandAll: expandAll,
                style: style,
                draggable: draggable
            });
        }
    }, [
        tableStore,
        store
    ]);
    const target = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useRef(null);
    const size = $bf03a1833e7d9ef0$var$useSize(target);
    const width = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(store.columns.filter((c)=>!isPrinting || c.print).map((c)=>c.width));
    const widthRatio = (size === null || size === void 0 ? void 0 : size.width) / (width * 12);
    (0, $jbmdS.useEffect)(()=>{
        store.update({
            columns: columns,
            rows: rows,
            getChildComponent: getChildComponent,
            showHeader: showHeader,
            showTotals: showTotals,
            sortBy: sortBy,
            groupBy: groupBy,
            expandedGroups: expandedGroups,
            filters: filters,
            newRowDirection: newRowDirection,
            onExpand: onExpand,
            onCollapse: onCollapse,
            expandAll: expandAll,
            style: style,
            draggable: draggable
        });
    }, [
        rows,
        columns
    ]);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        ref: target,
        className: "coincraft-table w-full mx-auto max-h-max mb-auto" + className,
        ...props,
        css: (0, $BPPBq.css)({
            width: `${$bf03a1833e7d9ef0$var$remToPx(width)}px`,
            "@media print": {
                width: "100%"
            }
        }, ""),
        style: {
            ...style
        },
        children: [
            store.showHeader ? /*#__PURE__*/ (0, $61Ea1.jsx)($bf03a1833e7d9ef0$var$TableHeader, {
                store: store,
                className: headerClassName,
                style: headerStyle,
                isPrinting: isPrinting,
                width: width,
                widthRatio: widthRatio
            }) : null,
            topRow ? topRow : null,
            store.showTotals ? /*#__PURE__*/ (0, $61Ea1.jsx)($bf03a1833e7d9ef0$var$TableTotals, {
                store: store,
                isPrinting: isPrinting,
                width: width,
                widthRatio: widthRatio,
                totalsRowStyles: totalsRowStyles,
                totalsCellStyles: totalsCellStyles
            }) : null,
            /*#__PURE__*/ (0, $61Ea1.jsx)($bf03a1833e7d9ef0$var$TableRows, {
                tableId: id,
                rows: store.rows,
                store: store,
                style: style,
                isPrinting: isPrinting,
                width: width,
                widthRatio: widthRatio,
                draggable: draggable,
                onReorder: onReorder
            })
        ]
    });
});
const $bf03a1833e7d9ef0$var$TableHeader = (0, $1EEMt.observer)(({ store: store, className: className = "", isPrinting: isPrinting, width: width, widthRatio: widthRatio, style: style, ...props })=>{
    const [isScrolled, setIsScrolled] = (0, $jbmdS.useState)(false);
    const headerRef = (0, $jbmdS.useRef)(null);
    const shadowRef = (0, $jbmdS.useRef)(null);
    (0, $jbmdS.useEffect)(()=>{
        const header = headerRef.current;
        const shadow = shadowRef.current;
        if (!header || !shadow) return;
        const observer = new IntersectionObserver(([entry])=>{
            setIsScrolled(!entry.isIntersecting);
        }, {
            threshold: [
                0,
                1
            ],
            rootMargin: "-1px 0px 0px 0px"
        });
        observer.observe(shadow);
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                ref: shadowRef,
                className: "h-px w-full absolute top-0"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                ref: headerRef,
                className: `coincraft-table-row header sticky top-0 z-[1] ${isScrolled ? "shadow-xl" : ""} ${className}`,
                style: style,
                ...props,
                children: store.columns.filter((c)=>!isPrinting || c.print).map((c, i)=>/*#__PURE__*/ (0, $61Ea1.jsx)($bf03a1833e7d9ef0$var$TableHeaderCell, {
                        store: store,
                        column: c,
                        isPrinting: isPrinting,
                        width: width,
                        widthRatio: widthRatio,
                        style: style
                    }, "header" + c.id))
            })
        ]
    });
});
const $bf03a1833e7d9ef0$var$TableHeaderCell = (0, $1EEMt.observer)(({ store: store, column: column, isPrinting: isPrinting, width: width, widthRatio: widthRatio, style: style })=>{
    const target = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useRef(null);
    const isHovering = (0, $1fkTL.default)(target);
    const matchingSort = store.sortBy.find(([col, direction])=>col === column.id);
    const showSort = isHovering || matchingSort;
    const leftSort = showSort && column.textAlign === "right";
    const rightSort = showSort && !leftSort;
    const direction = !matchingSort ? "asc" : isHovering ? matchingSort[1] === "asc" ? "desc" : "asc" : matchingSort[1];
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        ref: target,
        className: "coincraft-table-cell",
        css: (0, $BPPBq.css)({
            width: `${$bf03a1833e7d9ef0$var$remToPx(column.width)}px`,
            fontSize: "inherit",
            backgroundColor: isHovering ? "#ffde66" : "#ffd333",
            textAlign: column.textAlign,
            cursor: "pointer",
            ...column.style(),
            ...style,
            "@media print": {
                width: `${column.width / width * 100}%`,
                fontSize: `${10 * widthRatio}px !important`,
                backgroundColor: "black",
                color: "white"
            }
        }, "", ""),
        onClick: ()=>store.updateSort(column.id, direction),
        children: [
            leftSort ? /*#__PURE__*/ (0, $61Ea1.jsx)($bf03a1833e7d9ef0$var$SortingCaret, {
                direction: direction
            }) : null,
            column.label,
            rightSort ? /*#__PURE__*/ (0, $61Ea1.jsx)($bf03a1833e7d9ef0$var$SortingCaret, {
                direction: direction
            }) : null
        ]
    });
});
const $bf03a1833e7d9ef0$var$SortingCaret = (0, $1EEMt.observer)(({ direction: direction })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
        className: `fa fa-caret-${direction === "desc" ? "up" : "down"}`,
        style: {
            marginLeft: "0.5em",
            fontSize: "1.4em",
            position: "relative",
            top: "0.1em"
        }
    });
});
const $bf03a1833e7d9ef0$var$TableTotals = (0, $1EEMt.observer)(({ store: store, columns: columns, isPrinting: isPrinting, width: width, widthRatio: widthRatio, totalsRowStyles: totalsRowStyles = {}, totalsCellStyles: totalsCellStyles = {} })=>{
    const row = store.totalsRow;
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        style: {
            background: "#ffffff",
            fontSize: "1.01em",
            fontWeight: "bold",
            borderBottom: "1px solid #e0e0e0",
            ...totalsRowStyles
        },
        children: /*#__PURE__*/ (0, $61Ea1.jsx)($bf03a1833e7d9ef0$var$TableRow, {
            store: store,
            row: row,
            isPrinting: isPrinting,
            width: width,
            widthRatio: widthRatio,
            cellStyle: {
                padding: "1.25em 0.5em",
                borderColor: "#eee",
                ...totalsCellStyles
            }
        })
    });
});
const $bf03a1833e7d9ef0$var$DragHandle = ({ dragHandleProps: dragHandleProps })=>/*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        ...dragHandleProps,
        className: "flex items-center justify-center w-8 h-full cursor-grab active:cursor-grabbing group",
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            className: "flex flex-col items-center justify-center w-4 h-4 gap-[2px] opacity-40 group-hover:opacity-80 transition-opacity",
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    className: "w-full h-[2px] bg-gray-600 rounded-full"
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    className: "w-full h-[2px] bg-gray-600 rounded-full"
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    className: "w-full h-[2px] bg-gray-600 rounded-full"
                })
            ]
        })
    });
const $bf03a1833e7d9ef0$var$TableRows = (0, $1EEMt.observer)(({ rows: rows, store: store, isPrinting: isPrinting, width: width, widthRatio: widthRatio, style: style, tableId: tableId, draggable: draggable, onReorder: onReorder })=>{
    if (!draggable) return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        children: rows.map((r, i)=>/*#__PURE__*/ (0, $61Ea1.jsx)($bf03a1833e7d9ef0$var$TableRow, {
                store: store,
                row: r,
                isPrinting: isPrinting,
                width: width,
                widthRatio: widthRatio,
                style: style,
                index: i,
                tableId: tableId
            }, r.id + i))
    });
    const handleDragEnd = (result)=>{
        if (!result.destination || !onReorder) return;
        const sourceIndex = result.source.index;
        const destinationIndex = result.destination.index;
        onReorder(sourceIndex, destinationIndex);
    };
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $4Jl8d.DragDropContext), {
        onDragEnd: handleDragEnd,
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $4Jl8d.Droppable), {
            droppableId: "table-rows",
            children: (provided)=>/*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    ...provided.droppableProps,
                    ref: provided.innerRef,
                    children: [
                        rows.map((r, i)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $4Jl8d.Draggable), {
                                draggableId: r.id,
                                index: i,
                                children: (provided, snapshot)=>/*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        ref: provided.innerRef,
                                        ...provided.draggableProps,
                                        className: snapshot.isDragging ? "shadow-lg" : "",
                                        children: /*#__PURE__*/ (0, $61Ea1.jsx)($bf03a1833e7d9ef0$var$TableRow, {
                                            store: store,
                                            row: r,
                                            isPrinting: isPrinting,
                                            width: width,
                                            widthRatio: widthRatio,
                                            style: {
                                                ...style,
                                                backgroundColor: snapshot.isDragging ? "#f5f5f5" : undefined
                                            },
                                            index: i,
                                            tableId: tableId,
                                            dragHandleProps: provided.dragHandleProps
                                        })
                                    })
                            }, r.id)),
                        provided.placeholder
                    ]
                })
        })
    });
});
const $bf03a1833e7d9ef0$var$TableRow = (0, $1EEMt.observer)(({ store: store, row: row, isPrinting: isPrinting, width: width, widthRatio: widthRatio, style: style, cellStyle: cellStyle, index: index, tableId: tableId, dragHandleProps: dragHandleProps })=>{
    const target = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useRef(null);
    const isHovering = (0, $1fkTL.default)(target);
    const groupLevel = row.group === "totals" ? 1 : row.groupLevel;
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                ref: target,
                className: `coincraft-table-row row-index-${index}`,
                "data-testid": tableId && `${tableId}-${index}`,
                css: (0, $BPPBq.css)({
                    background: style !== null && style !== void 0 && style.backgroundColor ? style === null || style === void 0 ? void 0 : style.backgroundColor : "#000000" + ((8 * (groupLevel + isHovering * 2)).toString(16).length < 2 ? "0" + (8 * (groupLevel + isHovering * 2)).toString(16) : (8 * (groupLevel + isHovering * 2)).toString(16)),
                    fontSize: row.groupLevel ? "0.99em" : "1em",
                    "@media print": {
                        background: `white`
                    }
                }, "", ""),
                children: store.columns.filter((c)=>!isPrinting || c.print).map((c)=>{
                    const cell = row.cells[c.id];
                    return /*#__PURE__*/ (0, $61Ea1.jsx)($bf03a1833e7d9ef0$var$TableCell, {
                        store: store,
                        row: row,
                        column: c,
                        cell: cell,
                        isPrinting: isPrinting,
                        width: width,
                        widthRatio: widthRatio,
                        style: cellStyle,
                        rowIndex: index,
                        tableId: tableId,
                        dragHandleProps: dragHandleProps
                    }, "cell" + c.id + row.id);
                })
            }),
            row.expanded ? /*#__PURE__*/ (0, $61Ea1.jsx)($bf03a1833e7d9ef0$var$RowChildren, {
                row: row,
                store: store,
                style: cellStyle
            }) : null
        ]
    });
});
const $bf03a1833e7d9ef0$var$TableCell = (0, $1EEMt.observer)(({ column: column, row: row, cell: cell, store: store, isPrinting: isPrinting, widthRatio: widthRatio, style: style, className: className = "", dragHandleProps: dragHandleProps, ...props })=>{
    var _cell$data;
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6RcUP.default), {
        queryIds: ((_cell$data = cell.data) === null || _cell$data === void 0 ? void 0 : _cell$data.call(cell, row)) || [],
        loading: /*#__PURE__*/ (0, $61Ea1.jsx)($bf03a1833e7d9ef0$var$LoadingCell, {
            column: column,
            row: row,
            cell: cell,
            store: store,
            isPrinting: isPrinting,
            widthRatio: widthRatio,
            style: style,
            className: className,
            ...props
        }),
        children: /*#__PURE__*/ (0, $61Ea1.jsx)($bf03a1833e7d9ef0$var$TableCellContent, {
            column: column,
            row: row,
            cell: cell,
            store: store,
            isPrinting: isPrinting,
            widthRatio: widthRatio,
            style: style,
            className: className,
            dragHandleProps: dragHandleProps,
            ...props
        })
    });
});
const $bf03a1833e7d9ef0$var$TableCellContent = (0, $1EEMt.observer)(({ column: column, cell: cell, store: store, isPrinting: isPrinting, width: width, widthRatio: widthRatio, style: style, className: className = "", rowIndex: rowIndex, tableId: tableId, dragHandleProps: dragHandleProps, ...props })=>{
    if (column.id === "dragHandle") return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: `coincraft-table-cell ` + (!isPrinting && cell.editable ? `coincraft-table-cell--${cell.type}` : "") + ` ${cell.className}` + (cell.selected ? " selected" : "") + ` row-index-${rowIndex}-${cell.id}`,
        "data-testid": tableId && `${tableId}-${rowIndex}-${column.id}`,
        css: (0, $BPPBq.css)({
            width: `${$bf03a1833e7d9ef0$var$remToPx(column.width)}px`,
            fontSize: "inherit",
            "@media print": {
                width: `${column.width / width * 100}%`,
                fontSize: `${10 * widthRatio}px !important`
            }
        }, "", ""),
        style: {
            position: "relative",
            textAlign: column.textAlign,
            display: "flex",
            alignItems: "center",
            justifyContent: column.justifyContent,
            ...cell.style,
            ...style
        },
        ...props,
        children: /*#__PURE__*/ (0, $61Ea1.jsx)($bf03a1833e7d9ef0$var$DragHandle, {
            dragHandleProps: dragHandleProps
        })
    });
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: `coincraft-table-cell ` + (!isPrinting && cell.editable ? `coincraft-table-cell--${cell.type}` : "") + ` ${cell.className}` + (cell.selected ? " selected" : "") + ` row-index-${rowIndex}-${cell.id}`,
        "data-testid": tableId && `${tableId}-${rowIndex}-${column.id}`,
        css: (0, $BPPBq.css)({
            width: `${$bf03a1833e7d9ef0$var$remToPx(column.width)}px`,
            fontSize: "inherit",
            "@media print": {
                width: `${column.width / width * 100}%`,
                fontSize: `${10 * widthRatio}px !important`
            }
        }, "", ""),
        style: {
            position: "relative",
            textAlign: column.textAlign,
            display: "flex",
            alignItems: "center",
            justifyContent: column.justifyContent,
            ...cell.style,
            ...style
        },
        ...props,
        children: !isPrinting ? cell.component : cell.readOnlyComponent
    });
});
const $bf03a1833e7d9ef0$var$LoadingCell = (0, $1EEMt.observer)(({ store: store, column: column, isPrinting: isPrinting, width: width, widthRatio: widthRatio, cell: cell, style: style, ...props })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: `coincraft-table-cell ` + (!isPrinting && cell.editable ? `coincraft-table-cell--${cell.type}` : "") + ` ${cell.className}` + (cell.selected ? " selected" : ""),
        css: (0, $BPPBq.css)({
            width: `${$bf03a1833e7d9ef0$var$remToPx(column.width)}px`,
            fontSize: "inherit",
            "@media print": {
                width: `${column.width / width * 100}%`,
                fontSize: `${10 * widthRatio}px !important`
            }
        }, "", ""),
        style: {
            textAlign: column.textAlign,
            display: "flex",
            alignItems: "center",
            justifyContent: column.justifyContent,
            ...cell.style,
            ...style
        },
        ...props,
        children: "loading..."
    });
});
const $bf03a1833e7d9ef0$var$RowChildren = (0, $1EEMt.observer)(({ row: row, store: store })=>{
    return row.childRows.length ? /*#__PURE__*/ (0, $61Ea1.jsx)($bf03a1833e7d9ef0$var$TableRows, {
        rows: row.childRows,
        store: store
    }) : row.childComponent;
});

});
parcelRegister("hdshG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8899737d360f6a8$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $4JcCM = parcelRequire("4JcCM");
parcelRequire("jbmdS");

var $eat5C = parcelRequire("eat5C");

var $NJf3Q = parcelRequire("NJf3Q");

var $caaOk = parcelRequire("caaOk");

var $f44xu = parcelRequire("f44xu");
parcelRequire("98Ukb");

var $62nmb = parcelRequire("62nmb");
var $c8899737d360f6a8$var$_dec, $c8899737d360f6a8$var$_dec2, $c8899737d360f6a8$var$_dec3, $c8899737d360f6a8$var$_dec4, $c8899737d360f6a8$var$_dec5, $c8899737d360f6a8$var$_dec6, $c8899737d360f6a8$var$_dec7, $c8899737d360f6a8$var$_dec8, $c8899737d360f6a8$var$_dec9, $c8899737d360f6a8$var$_class, $c8899737d360f6a8$var$_descriptor, $c8899737d360f6a8$var$_descriptor2, $c8899737d360f6a8$var$_descriptor3, $c8899737d360f6a8$var$_descriptor4, $c8899737d360f6a8$var$_descriptor5, $c8899737d360f6a8$var$_descriptor6, $c8899737d360f6a8$var$_descriptor7, $c8899737d360f6a8$var$_descriptor8, $c8899737d360f6a8$var$_descriptor9, $c8899737d360f6a8$var$_descriptor10, $c8899737d360f6a8$var$_descriptor11, $c8899737d360f6a8$var$_descriptor12, $c8899737d360f6a8$var$_descriptor13, $c8899737d360f6a8$var$_descriptor14;
function $c8899737d360f6a8$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $c8899737d360f6a8$var$_defineProperty(e, r, t) {
    return (r = $c8899737d360f6a8$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $c8899737d360f6a8$var$_toPropertyKey(t) {
    var i = $c8899737d360f6a8$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $c8899737d360f6a8$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $c8899737d360f6a8$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $c8899737d360f6a8$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $c8899737d360f6a8$var$TableStore = ($c8899737d360f6a8$var$_dec = (0, $4JcCM.action).bound, $c8899737d360f6a8$var$_dec2 = (0, $4JcCM.action).bound, $c8899737d360f6a8$var$_dec3 = (0, $4JcCM.action).bound, $c8899737d360f6a8$var$_dec4 = (0, $4JcCM.action).bound, $c8899737d360f6a8$var$_dec5 = (0, $4JcCM.action).bound, $c8899737d360f6a8$var$_dec6 = (0, $4JcCM.action).bound, $c8899737d360f6a8$var$_dec7 = (0, $4JcCM.action).bound, $c8899737d360f6a8$var$_dec8 = (0, $4JcCM.action).bound, $c8899737d360f6a8$var$_dec9 = (0, $4JcCM.action).bound, $c8899737d360f6a8$var$_class = class TableStore {
    constructor(){
        $c8899737d360f6a8$var$_initializerDefineProperty(this, "showHeader", $c8899737d360f6a8$var$_descriptor, this);
        $c8899737d360f6a8$var$_initializerDefineProperty(this, "showTotals", $c8899737d360f6a8$var$_descriptor2, this);
        $c8899737d360f6a8$var$_initializerDefineProperty(this, "_rows", $c8899737d360f6a8$var$_descriptor3, this);
        $c8899737d360f6a8$var$_initializerDefineProperty(this, "_rowsByObject", $c8899737d360f6a8$var$_descriptor4, this);
        $c8899737d360f6a8$var$_initializerDefineProperty(this, "_columns", $c8899737d360f6a8$var$_descriptor5, this);
        $c8899737d360f6a8$var$_initializerDefineProperty(this, "_columnsById", $c8899737d360f6a8$var$_descriptor6, this);
        $c8899737d360f6a8$var$_initializerDefineProperty(this, "expandedRows", $c8899737d360f6a8$var$_descriptor7, this);
        $c8899737d360f6a8$var$_initializerDefineProperty(this, "sortBy", $c8899737d360f6a8$var$_descriptor8, this);
        $c8899737d360f6a8$var$_initializerDefineProperty(this, "groups", $c8899737d360f6a8$var$_descriptor9, this);
        $c8899737d360f6a8$var$_initializerDefineProperty(this, "expandedGroups", $c8899737d360f6a8$var$_descriptor10, this);
        $c8899737d360f6a8$var$_initializerDefineProperty(this, "filters", $c8899737d360f6a8$var$_descriptor11, this);
        $c8899737d360f6a8$var$_initializerDefineProperty(this, "reverseSort", $c8899737d360f6a8$var$_descriptor12, this);
        $c8899737d360f6a8$var$_initializerDefineProperty(this, "newRowDirection", $c8899737d360f6a8$var$_descriptor13, this);
        $c8899737d360f6a8$var$_initializerDefineProperty(this, "expandAll", $c8899737d360f6a8$var$_descriptor14, this);
        $c8899737d360f6a8$var$_defineProperty(this, "onExpand", ()=>null);
        $c8899737d360f6a8$var$_defineProperty(this, "onCollapse", ()=>null);
        (0, $4JcCM.makeObservable)(this);
    }
    update({ columns: columns, rows: rows, getChildComponent: getChildComponent, showHeader: showHeader, showTotals: showTotals, sortBy: sortBy, groupBy: groupBy, filters: filters, newRowDirection: newRowDirection, expandedGroups: expandedGroups, onExpand: onExpand, onCollapse: onCollapse, expandAll: expandAll, draggable: draggable } = {}) {
        this.getChildComponent = getChildComponent !== null && getChildComponent !== void 0 ? getChildComponent : this.getChildComponent;
        this.draggable = draggable !== null && draggable !== void 0 ? draggable : this.draggable;
        this.setupColumns(columns !== null && columns !== void 0 ? columns : this.columns);
        this.groups = groupBy !== null && groupBy !== void 0 ? groupBy : this.groups;
        this.setupRows(rows);
        this.showHeader = showHeader !== null && showHeader !== void 0 ? showHeader : this.showHeader;
        this.showTotals = showTotals !== null && showTotals !== void 0 ? showTotals : this.showTotals;
        this.sortBy = sortBy !== null && sortBy !== void 0 ? sortBy : this.sortBy;
        this.filters = filters !== null && filters !== void 0 ? filters : this.filters;
        this.newRowDirection = newRowDirection !== null && newRowDirection !== void 0 ? newRowDirection : this.newRowDirection;
        this.expandedGroups = expandedGroups !== null && expandedGroups !== void 0 ? expandedGroups : this.expandedGroups;
        this.onExpand = onExpand !== null && onExpand !== void 0 ? onExpand : this.onExpand;
        this.onCollapse = onCollapse !== null && onCollapse !== void 0 ? onCollapse : this.onCollapse;
        if (expandAll) {
            this.rows.forEach((r)=>{
                if (this.getChildComponent) this.expandedRows.add(r);
            });
            this.expandAll = true;
        } else if (!expandAll) {
            if (this.expandAll) this.expandedRows.clear();
            this.expandAll = false;
        }
    }
    updateRows(rows) {
        this.setupRows(rows);
    }
    updateColumns(columns) {
        this.setupColumns(columns);
    }
    updateGroups(groups) {
        this.groups = groups;
    }
    updateColumn(column) {
        this._columnsById.set(column.id || column, new (0, $NJf3Q.default)({
            ...column,
            tableStore: this
        }));
        this._rows.forEach((r)=>r.updateColumn(column));
    }
    getOrCreateColumn(columnDef) {
        if (!this._columnsById.get(columnDef.id || columnDef)) this._columnsById.set(columnDef.id || columnDef, new (0, $NJf3Q.default)({
            ...columnDef,
            tableStore: this
        }));
        else this._columnsById.get(columnDef.id || columnDef).update(columnDef);
        return this._columnsById.get(columnDef.id || columnDef);
    }
    setupColumns(columns) {
        this._columns = new Set(columns.map((c)=>this.getOrCreateColumn(c)));
        this._columns.add(this.getOrCreateColumn({
            id: "position",
            tableStore: this,
            label: "",
            width: 3,
            type: "number",
            editable: (r)=>false,
            visible: false,
            value: (r)=>r.position
        }));
        if (this.getChildComponent) this._columns = new Set([
            this.getOrCreateColumn({
                id: "expand",
                tableStore: this,
                label: "",
                width: 3,
                type: "button",
                print: false,
                editable: (model, { row: row } = {})=>{
                    return row.id !== "totals";
                },
                value: (model, { row: row } = {})=>{
                    if (row.id === "totals") return null;
                    return /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                        className: "fa fa-chevron-" + (row.expanded ? "down" : "right"),
                        style: {
                            marginRight: 0
                        }
                    });
                },
                onClick: (rowObj, stores)=>()=>{
                        this.toggleRowExpand(stores.row);
                    }
            }),
            ...this._columns
        ]);
        if (this.draggable) this._columns = new Set([
            this.getOrCreateColumn({
                id: "dragHandle",
                label: "",
                width: 3,
                // Adjust width as needed
                style: ()=>({}),
                print: false
            }),
            ...this._columns
        ]);
    }
    getOrCreateRow(rowObject, { id: id, group: group } = {}) {
        if (!this._rowsByObject.get(id || (rowObject === null || rowObject === void 0 ? void 0 : rowObject.id) || rowObject)) {
            var _this$getChildCompone;
            this._rowsByObject.set(id || (rowObject === null || rowObject === void 0 ? void 0 : rowObject.id) || rowObject, new (0, $caaOk.default)({
                id: id || (rowObject === null || rowObject === void 0 ? void 0 : rowObject.id) || rowObject,
                rowObject: rowObject,
                table: this,
                childComponent: (_this$getChildCompone = this.getChildComponent) === null || _this$getChildCompone === void 0 ? void 0 : _this$getChildCompone.call(this, rowObject),
                group: group,
                childRows: new Set()
            }));
        }
        return this._rowsByObject.get(id || (rowObject === null || rowObject === void 0 ? void 0 : rowObject.id) || rowObject);
    }
    setupRows(rowsData = []) {
        const noGroupRows = rowsData.map((r)=>{
            return this.getOrCreateRow(r);
        });
        this._rows = new Set([
            ...noGroupRows
        ]);
        let groupRows = {};
        noGroupRows.forEach((r)=>{
            let prevGroupRow = null;
            this.groups.forEach((gId, i)=>{
                const groupId = (0, $f44xu.default)(...this.groups.map((gId2, i2)=>{
                    var _r$cells$gId;
                    return i2 <= i ? (_r$cells$gId = r.cells[gId2]) === null || _r$cells$gId === void 0 ? void 0 : _r$cells$gId.equalityComparatorValue : undefined;
                }));
                const groupObject = r.cells[gId].value;
                let groupRow = groupRows[groupId];
                if (!groupRow) {
                    groupRow = groupRows[groupId] = this.getOrCreateRow(groupObject, {
                        id: groupId,
                        group: gId
                    });
                    groupRow = groupRows[groupId];
                    if (prevGroupRow) prevGroupRow._childRows.add(groupRow);
                    this._rows.add(groupRow);
                }
                if (i === this.groups.length - 1) groupRow._childRows.add(r);
                prevGroupRow = groupRow;
            });
        });
    }
    get columnsById() {
        const columnsById = {};
        this._columns.forEach((c)=>{
            columnsById[c.id] = c;
        });
        return columnsById;
    }
    get columns() {
        return [
            ...this._columns
        ].filter((c)=>c.visible);
    }
    get rowsByGroup() {
        const rowsByGroup = {};
        this._rows.forEach((r)=>{
            var _r$group, _rowsByGroup$_r$group;
            (_rowsByGroup$_r$group = rowsByGroup[_r$group = r.group]) !== null && _rowsByGroup$_r$group !== void 0 ? _rowsByGroup$_r$group : rowsByGroup[_r$group] = [];
            rowsByGroup[r.group].push(r);
        });
        return rowsByGroup;
    }
    get rows() {
        var _this$rowsByGroup$thi, _this$groups;
        const newSort = (r)=>r.rowObject.isNew ? 0 : 1; // Adjusted to prioritize null values
        const newDir = this.newRowDirection;
        const createdSort = (r)=>r.rowObject.initiatedAt ? new Date(r.rowObject.initiatedAt) : Infinity;
        const createdDir = this.newRowDirection === "asc" ? "desc" : "asc";
        const columnSort = this.sortBy.map(([prop, direction])=>(r)=>{
                let val = null;
                if (typeof prop === "string" && r.cells[prop]) {
                    var _r$cells$prop$sortCom;
                    val = (_r$cells$prop$sortCom = r.cells[prop].sortComparatorValue) !== null && _r$cells$prop$sortCom !== void 0 ? _r$cells$prop$sortCom : Infinity;
                } else if (typeof prop === "function") {
                    var _prop;
                    val = (_prop = prop(r.rowObject)) !== null && _prop !== void 0 ? _prop : Infinity;
                }
                return val;
            });
        const columnDir = this.sortBy.map(([prop, direction])=>direction);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).orderBy((_this$rowsByGroup$thi = this.rowsByGroup[(_this$groups = this.groups) === null || _this$groups === void 0 ? void 0 : _this$groups[0]]) === null || _this$rowsByGroup$thi === void 0 ? void 0 : _this$rowsByGroup$thi.filter((r)=>r.visible), [
            ...columnSort
        ], [
            ...columnDir
        ]);
    }
    toggleRowExpand(row) {
        if (this.expandedRows.has(row)) {
            this.expandedRows.delete(row);
            this.onCollapse(row.rowObject);
        } else {
            this.expandedRows.add(row);
            this.onExpand(row.rowObject);
        }
    }
    get headerLabels() {
        return this.columns.map((c)=>c.label);
    }
    get totals() {
        return this.columns.map((c)=>c.label);
    }
    get width() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.columns.map((c)=>c.width));
    }
    get printingWidth() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.columns.filter((c)=>c.print).map((c)=>c.width));
    }
    updateSort(column, direction) {
        this.sortBy = [
            [
                column,
                direction
            ]
        ];
    }
    get csvData() {
        const columns = this.columns.filter((c)=>c.visible && c.id !== "expand");
        return [
            columns.map((c)=>c.label),
            ...this.rows.map((r)=>columns.map((c)=>{
                    return r.cells[c.id].formattedCSVValue;
                }))
        ];
    }
    getCsvData({ columns: columns = this.columns.filter((c)=>c.visible && c.id !== "expand"), rows: rows = this.rows, includeHeadings: includeHeadings = true } = {}) {
        const csv = [];
        if (includeHeadings) csv.push(columns.map((c)=>c.label));
        csv.push(...rows.map((r)=>columns.map((c)=>{
                return r.cells[c.id].formattedCSVValue;
            })));
        return csv;
    }
    get totalsRow() {
        var _this$groups2;
        return new (0, $caaOk.default)({
            id: "totals",
            group: "totals",
            childRows: new Set(this.rowsByGroup[(_this$groups2 = this.groups) === null || _this$groups2 === void 0 ? void 0 : _this$groups2[0]]),
            table: this
        });
    }
}, $c8899737d360f6a8$var$_descriptor = $c8899737d360f6a8$var$_applyDecoratedDescriptor($c8899737d360f6a8$var$_class.prototype, "showHeader", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return true;
    }
}), $c8899737d360f6a8$var$_descriptor2 = $c8899737d360f6a8$var$_applyDecoratedDescriptor($c8899737d360f6a8$var$_class.prototype, "showTotals", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $c8899737d360f6a8$var$_descriptor3 = $c8899737d360f6a8$var$_applyDecoratedDescriptor($c8899737d360f6a8$var$_class.prototype, "_rows", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Set();
    }
}), $c8899737d360f6a8$var$_descriptor4 = $c8899737d360f6a8$var$_applyDecoratedDescriptor($c8899737d360f6a8$var$_class.prototype, "_rowsByObject", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Map();
    }
}), $c8899737d360f6a8$var$_descriptor5 = $c8899737d360f6a8$var$_applyDecoratedDescriptor($c8899737d360f6a8$var$_class.prototype, "_columns", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Set();
    }
}), $c8899737d360f6a8$var$_descriptor6 = $c8899737d360f6a8$var$_applyDecoratedDescriptor($c8899737d360f6a8$var$_class.prototype, "_columnsById", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Map();
    }
}), $c8899737d360f6a8$var$_descriptor7 = $c8899737d360f6a8$var$_applyDecoratedDescriptor($c8899737d360f6a8$var$_class.prototype, "expandedRows", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Set();
    }
}), $c8899737d360f6a8$var$_descriptor8 = $c8899737d360f6a8$var$_applyDecoratedDescriptor($c8899737d360f6a8$var$_class.prototype, "sortBy", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $c8899737d360f6a8$var$_descriptor9 = $c8899737d360f6a8$var$_applyDecoratedDescriptor($c8899737d360f6a8$var$_class.prototype, "groups", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $c8899737d360f6a8$var$_descriptor10 = $c8899737d360f6a8$var$_applyDecoratedDescriptor($c8899737d360f6a8$var$_class.prototype, "expandedGroups", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $c8899737d360f6a8$var$_descriptor11 = $c8899737d360f6a8$var$_applyDecoratedDescriptor($c8899737d360f6a8$var$_class.prototype, "filters", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $c8899737d360f6a8$var$_descriptor12 = $c8899737d360f6a8$var$_applyDecoratedDescriptor($c8899737d360f6a8$var$_class.prototype, "reverseSort", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $c8899737d360f6a8$var$_descriptor13 = $c8899737d360f6a8$var$_applyDecoratedDescriptor($c8899737d360f6a8$var$_class.prototype, "newRowDirection", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "desc";
    }
}), $c8899737d360f6a8$var$_descriptor14 = $c8899737d360f6a8$var$_applyDecoratedDescriptor($c8899737d360f6a8$var$_class.prototype, "expandAll", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $c8899737d360f6a8$var$_applyDecoratedDescriptor($c8899737d360f6a8$var$_class.prototype, "update", [
    $c8899737d360f6a8$var$_dec
], Object.getOwnPropertyDescriptor($c8899737d360f6a8$var$_class.prototype, "update"), $c8899737d360f6a8$var$_class.prototype), $c8899737d360f6a8$var$_applyDecoratedDescriptor($c8899737d360f6a8$var$_class.prototype, "updateRows", [
    $c8899737d360f6a8$var$_dec2
], Object.getOwnPropertyDescriptor($c8899737d360f6a8$var$_class.prototype, "updateRows"), $c8899737d360f6a8$var$_class.prototype), $c8899737d360f6a8$var$_applyDecoratedDescriptor($c8899737d360f6a8$var$_class.prototype, "updateColumns", [
    $c8899737d360f6a8$var$_dec3
], Object.getOwnPropertyDescriptor($c8899737d360f6a8$var$_class.prototype, "updateColumns"), $c8899737d360f6a8$var$_class.prototype), $c8899737d360f6a8$var$_applyDecoratedDescriptor($c8899737d360f6a8$var$_class.prototype, "updateGroups", [
    $c8899737d360f6a8$var$_dec4
], Object.getOwnPropertyDescriptor($c8899737d360f6a8$var$_class.prototype, "updateGroups"), $c8899737d360f6a8$var$_class.prototype), $c8899737d360f6a8$var$_applyDecoratedDescriptor($c8899737d360f6a8$var$_class.prototype, "updateColumn", [
    $c8899737d360f6a8$var$_dec5
], Object.getOwnPropertyDescriptor($c8899737d360f6a8$var$_class.prototype, "updateColumn"), $c8899737d360f6a8$var$_class.prototype), $c8899737d360f6a8$var$_applyDecoratedDescriptor($c8899737d360f6a8$var$_class.prototype, "getOrCreateColumn", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($c8899737d360f6a8$var$_class.prototype, "getOrCreateColumn"), $c8899737d360f6a8$var$_class.prototype), $c8899737d360f6a8$var$_applyDecoratedDescriptor($c8899737d360f6a8$var$_class.prototype, "setupColumns", [
    (0, $4JcCM.action)
], Object.getOwnPropertyDescriptor($c8899737d360f6a8$var$_class.prototype, "setupColumns"), $c8899737d360f6a8$var$_class.prototype), $c8899737d360f6a8$var$_applyDecoratedDescriptor($c8899737d360f6a8$var$_class.prototype, "getOrCreateRow", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($c8899737d360f6a8$var$_class.prototype, "getOrCreateRow"), $c8899737d360f6a8$var$_class.prototype), $c8899737d360f6a8$var$_applyDecoratedDescriptor($c8899737d360f6a8$var$_class.prototype, "setupRows", [
    $c8899737d360f6a8$var$_dec6
], Object.getOwnPropertyDescriptor($c8899737d360f6a8$var$_class.prototype, "setupRows"), $c8899737d360f6a8$var$_class.prototype), $c8899737d360f6a8$var$_applyDecoratedDescriptor($c8899737d360f6a8$var$_class.prototype, "columnsById", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c8899737d360f6a8$var$_class.prototype, "columnsById"), $c8899737d360f6a8$var$_class.prototype), $c8899737d360f6a8$var$_applyDecoratedDescriptor($c8899737d360f6a8$var$_class.prototype, "columns", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c8899737d360f6a8$var$_class.prototype, "columns"), $c8899737d360f6a8$var$_class.prototype), $c8899737d360f6a8$var$_applyDecoratedDescriptor($c8899737d360f6a8$var$_class.prototype, "rowsByGroup", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c8899737d360f6a8$var$_class.prototype, "rowsByGroup"), $c8899737d360f6a8$var$_class.prototype), $c8899737d360f6a8$var$_applyDecoratedDescriptor($c8899737d360f6a8$var$_class.prototype, "rows", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c8899737d360f6a8$var$_class.prototype, "rows"), $c8899737d360f6a8$var$_class.prototype), $c8899737d360f6a8$var$_applyDecoratedDescriptor($c8899737d360f6a8$var$_class.prototype, "toggleRowExpand", [
    $c8899737d360f6a8$var$_dec7
], Object.getOwnPropertyDescriptor($c8899737d360f6a8$var$_class.prototype, "toggleRowExpand"), $c8899737d360f6a8$var$_class.prototype), $c8899737d360f6a8$var$_applyDecoratedDescriptor($c8899737d360f6a8$var$_class.prototype, "headerLabels", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c8899737d360f6a8$var$_class.prototype, "headerLabels"), $c8899737d360f6a8$var$_class.prototype), $c8899737d360f6a8$var$_applyDecoratedDescriptor($c8899737d360f6a8$var$_class.prototype, "totals", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c8899737d360f6a8$var$_class.prototype, "totals"), $c8899737d360f6a8$var$_class.prototype), $c8899737d360f6a8$var$_applyDecoratedDescriptor($c8899737d360f6a8$var$_class.prototype, "width", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c8899737d360f6a8$var$_class.prototype, "width"), $c8899737d360f6a8$var$_class.prototype), $c8899737d360f6a8$var$_applyDecoratedDescriptor($c8899737d360f6a8$var$_class.prototype, "printingWidth", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c8899737d360f6a8$var$_class.prototype, "printingWidth"), $c8899737d360f6a8$var$_class.prototype), $c8899737d360f6a8$var$_applyDecoratedDescriptor($c8899737d360f6a8$var$_class.prototype, "updateSort", [
    $c8899737d360f6a8$var$_dec8
], Object.getOwnPropertyDescriptor($c8899737d360f6a8$var$_class.prototype, "updateSort"), $c8899737d360f6a8$var$_class.prototype), $c8899737d360f6a8$var$_applyDecoratedDescriptor($c8899737d360f6a8$var$_class.prototype, "csvData", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c8899737d360f6a8$var$_class.prototype, "csvData"), $c8899737d360f6a8$var$_class.prototype), $c8899737d360f6a8$var$_applyDecoratedDescriptor($c8899737d360f6a8$var$_class.prototype, "getCsvData", [
    $c8899737d360f6a8$var$_dec9
], Object.getOwnPropertyDescriptor($c8899737d360f6a8$var$_class.prototype, "getCsvData"), $c8899737d360f6a8$var$_class.prototype), $c8899737d360f6a8$var$_applyDecoratedDescriptor($c8899737d360f6a8$var$_class.prototype, "totalsRow", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c8899737d360f6a8$var$_class.prototype, "totalsRow"), $c8899737d360f6a8$var$_class.prototype), $c8899737d360f6a8$var$_class);
var $c8899737d360f6a8$export$2e2bcd8739ae039 = $c8899737d360f6a8$var$TableStore;

});
parcelRegister("NJf3Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0957abd22c3ef861$export$2e2bcd8739ae039; });

parcelRequire("jbmdS");
parcelRequire("eat5C");

var $gN0TC = parcelRequire("gN0TC");

var $azaaH = parcelRequire("azaaH");

var $78RoM = parcelRequire("78RoM");

var $g0rG0 = parcelRequire("g0rG0");

var $kl7jd = parcelRequire("kl7jd");

var $2gGkh = parcelRequire("2gGkh");

var $49KZT = parcelRequire("49KZT");

var $fJ4T4 = parcelRequire("fJ4T4");
function $0957abd22c3ef861$var$_defineProperty(e, r, t) {
    return (r = $0957abd22c3ef861$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $0957abd22c3ef861$var$_toPropertyKey(t) {
    var i = $0957abd22c3ef861$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $0957abd22c3ef861$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $0957abd22c3ef861$var$TableColumnStore {
    constructor(data){
        $0957abd22c3ef861$var$_defineProperty(this, "id", (0, (/*@__PURE__*/$parcel$interopDefault($gN0TC)))());
        $0957abd22c3ef861$var$_defineProperty(this, "label", "");
        $0957abd22c3ef861$var$_defineProperty(this, "tableStore", null);
        $0957abd22c3ef861$var$_defineProperty(this, "type", "text");
        $0957abd22c3ef861$var$_defineProperty(this, "value", (row)=>String(row[this.id]));
        $0957abd22c3ef861$var$_defineProperty(this, "editable", (row)=>false);
        $0957abd22c3ef861$var$_defineProperty(this, "style", (row)=>({}));
        $0957abd22c3ef861$var$_defineProperty(this, "unique", false);
        $0957abd22c3ef861$var$_defineProperty(this, "visible", true);
        $0957abd22c3ef861$var$_defineProperty(this, "width", "10%");
        $0957abd22c3ef861$var$_defineProperty(this, "onChange", (row, stores)=>()=>null);
        $0957abd22c3ef861$var$_defineProperty(this, "onClick", (row, stores)=>()=>null);
        $0957abd22c3ef861$var$_defineProperty(this, "onFocus", (row, stores)=>()=>null);
        $0957abd22c3ef861$var$_defineProperty(this, "onBlur", (row, stores)=>()=>null);
        $0957abd22c3ef861$var$_defineProperty(this, "data", ()=>[]);
        $0957abd22c3ef861$var$_defineProperty(this, "component", null);
        $0957abd22c3ef861$var$_defineProperty(this, "className", ()=>"");
        $0957abd22c3ef861$var$_defineProperty(this, "selected", (row)=>false);
        $0957abd22c3ef861$var$_defineProperty(this, "permissions", ()=>true);
        $0957abd22c3ef861$var$_defineProperty(this, "print", true);
        // makeObservable(this)
        this.update(data);
    }
    update({ tableStore: tableStore, id: id, label: label, type: type, value: value, editable: editable, unique: unique, visible: visible, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, width: width, data: data, style: style, aggregate: aggregate, cellStyle: cellStyle, className: className, component: component, format: format, groupFormat: groupFormat, selected: selected, permissions: permissions, print: print }) {
        // makeObservable(this)
        this.tableStore = tableStore;
        this.id = id !== null && id !== void 0 ? id : this.id;
        this.label = label !== null && label !== void 0 ? label : this.label;
        this.type = type !== null && type !== void 0 ? type : this.type;
        this.value = value !== null && value !== void 0 ? value : this.value;
        this.editable = editable !== null && editable !== void 0 ? editable : this.editable;
        this.unique = unique !== null && unique !== void 0 ? unique : this.unique; // TODO - for disabling selectors
        this.visible = visible !== null && visible !== void 0 ? visible : this.visible;
        this.width = width !== null && width !== void 0 ? width : this.width;
        this.onClick = onClick !== null && onClick !== void 0 ? onClick : this.onClick;
        this.onChange = onChange !== null && onChange !== void 0 ? onChange : this.onChange;
        this.onFocus = onFocus !== null && onFocus !== void 0 ? onFocus : this.onFocus;
        this.onBlur = onBlur !== null && onBlur !== void 0 ? onBlur : this.onBlur;
        this.data = data !== null && data !== void 0 ? data : this.data;
        this.style = style !== null && style !== void 0 ? style : this.style;
        this.aggregate = aggregate !== null && aggregate !== void 0 ? aggregate : this.aggregate;
        this.cellStyle = cellStyle !== null && cellStyle !== void 0 ? cellStyle : this.cellStyle;
        this.className = className !== null && className !== void 0 ? className : this.className;
        this.component = component;
        this.format = format;
        this.groupFormat = groupFormat;
        this.selected = selected !== null && selected !== void 0 ? selected : this.selected;
        this.permissions = permissions !== null && permissions !== void 0 ? permissions : this.permissions;
        this.print = print !== null && print !== void 0 ? print : this.print;
    }
    get formatter() {
        return this.format || (0, $azaaH.default)[this.type] || (()=>"");
    }
    get groupFormatter() {
        return this.groupFormat || (0, $kl7jd.default)[this.type] || (()=>"");
    }
    get csvFormatter() {
        if (this.type.includes("progress")) return ({ numerator: numerator, denominator: denominator } = {}, options)=>{
            if (numerator || denominator) return `${this.formatter(numerator || 0, options)} / ${this.formatter(denominator || 0, options)})`;
            else return (options === null || options === void 0 ? void 0 : options.fallbackValue) || "";
        };
        else if (this.type === "date") return (v)=>(0, $fJ4T4.FormatDate)(v, {
                year: "numeric",
                month: "2-digit",
                day: "2-digit"
            });
        else return this.formatter;
    }
    get csvGroupFormatter() {
        if (this.type.includes("progress")) return ({ numerator: numerator, denominator: denominator } = {}, options)=>{
            if (numerator || denominator) return `${this.groupFormatter(numerator || 0, options)} / ${this.groupFormatter(denominator || 0, options)})`;
            else return (options === null || options === void 0 ? void 0 : options.fallbackValue) || "";
        };
        else return this.groupFormatter;
    }
    get equalityComparator() {
        return (0, $78RoM.default)[this.type] || (()=>-Infinity);
    }
    get sortComparator() {
        return (0, $g0rG0.default)[this.type] || (()=>-Infinity);
    }
    get aggregator() {
        var _Aggregator$this$type, _Aggregator$this$type2, _Aggregator$this$type3;
        if (this.aggregate === "none") return ()=>null;
        return ((_Aggregator$this$type = (0, $2gGkh.default)[this.type]) === null || _Aggregator$this$type === void 0 ? void 0 : _Aggregator$this$type[this.aggregate]) || ((_Aggregator$this$type2 = (0, $2gGkh.default)[this.type]) === null || _Aggregator$this$type2 === void 0 ? void 0 : _Aggregator$this$type2.sum) || ((_Aggregator$this$type3 = (0, $2gGkh.default)[this.type]) === null || _Aggregator$this$type3 === void 0 ? void 0 : _Aggregator$this$type3.avg) || (()=>null);
    }
    get sortable() {
        return [
            "text",
            "number"
        ].includes(this.type);
    }
    get filterable() {
        return [
            "text",
            "number"
        ].includes(this.type);
    }
    get groupable() {
        return [
            "project",
            "phase",
            "staff",
            "role",
            "costCentre",
            "status",
            "contact"
        ].includes(this.type);
    }
    get textAlign() {
        switch(this.type){
            case "number":
            case "currency":
            case "percent":
            case "durationMinutes":
            case "date":
                return "right";
            case "checkbox":
                return "center";
            default:
                return "left";
        }
    }
    get justifyContent() {
        switch(this.type){
            case "number":
            case "currency":
            case "percent":
            case "durationMinutes":
            case "date":
                return "flex-end";
            case "checkbox":
                return "center";
            default:
                return "flex-start";
        }
    }
    get cellComponent() {
        return this.component || (0, $49KZT.default)[this.type];
    }
}
var $0957abd22c3ef861$export$2e2bcd8739ae039 = $0957abd22c3ef861$var$TableColumnStore;

});
parcelRegister("g0rG0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba721d66b2cbfa84$export$2e2bcd8739ae039; });

var $7CaHe = parcelRequire("7CaHe");
var $ba721d66b2cbfa84$export$2e2bcd8739ae039 = {
    boolean: (value)=>value,
    text: (value)=>value ? String(value).toLowerCase() : "",
    number: (value)=>value !== null && value !== void 0 ? value : Infinity,
    currency: (value)=>value !== null && value !== void 0 ? value : Infinity,
    percent: (value)=>value !== null && value !== void 0 ? value : Infinity,
    durationMinutes: (value)=>value !== null && value !== void 0 ? value : Infinity,
    date: (value)=>value instanceof Date && !isNaN(value) ? value === null || value === void 0 ? void 0 : value.getTime() : Infinity,
    time: (value)=>value !== null && value !== void 0 ? value : Infinity,
    duration: (value)=>value !== null && value !== void 0 && value.value && value !== null && value !== void 0 && value.unit ? (0, $7CaHe.durationToUnit)(value, "milliseconds") : Infinity,
    progress: (value)=>value !== null && value !== void 0 && value.denominator ? value.numerator / value.denominator : Infinity,
    progressBar: (value)=>value !== null && value !== void 0 && value.denominator ? value.numerator / value.denominator : Infinity,
    project: (value)=>{
        var _ref, _value$title;
        return (_ref = (_value$title = value === null || value === void 0 ? void 0 : value.title) !== null && _value$title !== void 0 ? _value$title : value) !== null && _ref !== void 0 ? _ref : "";
    },
    phase: (value)=>{
        var _ref2, _value$title2;
        return (_ref2 = (_value$title2 = value === null || value === void 0 ? void 0 : value.title) !== null && _value$title2 !== void 0 ? _value$title2 : value) !== null && _ref2 !== void 0 ? _ref2 : "";
    },
    costCentre: (value)=>{
        var _ref3, _value$name;
        return (_ref3 = (_value$name = value === null || value === void 0 ? void 0 : value.name) !== null && _value$name !== void 0 ? _value$name : value) !== null && _ref3 !== void 0 ? _ref3 : "";
    },
    contact: (value)=>{
        var _ref4, _value$label;
        return (_ref4 = (_value$label = value === null || value === void 0 ? void 0 : value.label) !== null && _value$label !== void 0 ? _value$label : value) !== null && _ref4 !== void 0 ? _ref4 : "";
    },
    staff: (value)=>{
        var _ref5, _value$fullName;
        return (_ref5 = (_value$fullName = value === null || value === void 0 ? void 0 : value.fullName) !== null && _value$fullName !== void 0 ? _value$fullName : value) !== null && _ref5 !== void 0 ? _ref5 : "";
    },
    staffMember: (value)=>{
        var _ref6, _value$fullName2;
        return (_ref6 = (_value$fullName2 = value === null || value === void 0 ? void 0 : value.fullName) !== null && _value$fullName2 !== void 0 ? _value$fullName2 : value) !== null && _ref6 !== void 0 ? _ref6 : "";
    },
    role: (value)=>{
        var _ref7, _value$name2;
        return (_ref7 = (_value$name2 = value === null || value === void 0 ? void 0 : value.name) !== null && _value$name2 !== void 0 ? _value$name2 : value) !== null && _ref7 !== void 0 ? _ref7 : "";
    },
    status: (value)=>value !== null && value !== void 0 ? value : ""
};

});

parcelRegister("kl7jd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eceb7033c74c2b8d$export$2e2bcd8739ae039; });


var $dtopU = parcelRequire("dtopU");

var $12o9H = parcelRequire("12o9H");

var $cwjKY = parcelRequire("cwjKY");

var $gjxeM = parcelRequire("gjxeM");

var $eat5C = parcelRequire("eat5C");

var $fJ4T4 = parcelRequire("fJ4T4");

var $azaaH = parcelRequire("azaaH");

var $i0shw = parcelRequire("i0shw");
var $eceb7033c74c2b8d$export$2e2bcd8739ae039 = {
    boolean: (values, { fallbackValue: fallbackValue } = {})=>{
        var _ref, _values$map$join, _values$map;
        return (_ref = (_values$map$join = (_values$map = values.map) === null || _values$map === void 0 ? void 0 : _values$map.call(values, (value)=>String(value)).join(", ")) !== null && _values$map$join !== void 0 ? _values$map$join : values) !== null && _ref !== void 0 ? _ref : fallbackValue;
    },
    text: (values, { fallbackValue: fallbackValue } = {})=>{
        var _ref2, _values$map$join2, _values$map2;
        return (_ref2 = (_values$map$join2 = (_values$map2 = values.map) === null || _values$map2 === void 0 ? void 0 : _values$map2.call(values, (value)=>String(value)).join(", ")) !== null && _values$map$join2 !== void 0 ? _values$map$join2 : values) !== null && _ref2 !== void 0 ? _ref2 : fallbackValue;
    },
    number: (value, { decimals: decimals = 2, fallbackValue: fallbackValue } = {})=>{
        var _FormatNumber;
        return isFinite(value) ? (_FormatNumber = (0, $cwjKY.FormatNumber)((0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(value), {
            decimals: decimals
        })) !== null && _FormatNumber !== void 0 ? _FormatNumber : fallbackValue : fallbackValue;
    },
    durationMinutes: (value, { fallbackValue: fallbackValue } = {})=>{
        var _FormatMinutes;
        return isFinite(value) ? (_FormatMinutes = (0, $azaaH.FormatMinutes)((0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(value), {
            fallbackValue: fallbackValue
        })) !== null && _FormatMinutes !== void 0 ? _FormatMinutes : fallbackValue : fallbackValue;
    },
    currency: (value, { decimals: decimals = 2, fallbackValue: fallbackValue } = {})=>{
        var _FormatCurrency;
        return isFinite(value) ? (_FormatCurrency = (0, $12o9H.FormatCurrency)((0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(value), {
            decimals: decimals
        })) !== null && _FormatCurrency !== void 0 ? _FormatCurrency : fallbackValue : fallbackValue;
    },
    // TODO - useful?
    percent: (value, { decimals: decimals = 2, fallbackValue: fallbackValue } = {})=>{
        var _FormatPercent;
        return isFinite(value) ? (_FormatPercent = (0, $gjxeM.FormatPercent)((0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(value), {
            decimals: decimals
        })) !== null && _FormatPercent !== void 0 ? _FormatPercent : fallbackValue : fallbackValue;
    },
    date: (value, { fallbackValue: fallbackValue } = {})=>value instanceof Date && !isNaN(value) ? (0, $fJ4T4.FormatDate)(value) : fallbackValue,
    time: (value, { fallbackValue: fallbackValue } = {})=>value instanceof Date && !isNaN(value) ? (0, $i0shw.FormatTime)(value) : fallbackValue,
    duration: (value, { decimals: decimals = 2, fallbackValue: fallbackValue } = {})=>value !== null && value !== void 0 && value.value && value !== null && value !== void 0 && value.unit ? `${(0, $cwjKY.FormatNumber)(value.value, {
            decimals: decimals
        })} ${(0, (/*@__PURE__*/$parcel$interopDefault($dtopU)))(value.unit, (0, $cwjKY.FormatNumber)(value.value, {
            decimals: decimals
        }))}` : fallbackValue,
    progress: (value, { decimals: decimals = 0, fallbackValue: fallbackValue } = {})=>{
        var _FormatNumber2;
        return isFinite(value) ? (_FormatNumber2 = (0, $cwjKY.FormatNumber)((0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(value), {
            decimals: decimals
        })) !== null && _FormatNumber2 !== void 0 ? _FormatNumber2 : fallbackValue : fallbackValue;
    },
    progressBar: (value, { decimals: decimals = 0, fallbackValue: fallbackValue } = {})=>{
        var _FormatNumber3;
        return isFinite(value) ? (_FormatNumber3 = (0, $cwjKY.FormatNumber)((0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(value), {
            decimals: decimals
        })) !== null && _FormatNumber3 !== void 0 ? _FormatNumber3 : fallbackValue : fallbackValue;
    },
    project: (values, { fallbackValue: fallbackValue } = {})=>{
        var _values$map$join3;
        return (_values$map$join3 = values.map((value)=>value === null || value === void 0 ? void 0 : value.title).join(", ")) !== null && _values$map$join3 !== void 0 ? _values$map$join3 : fallbackValue;
    },
    phase: (values, { fallbackValue: fallbackValue } = {})=>{
        var _values$map$join4;
        return (_values$map$join4 = values.map((value)=>value === null || value === void 0 ? void 0 : value.title).join(", ")) !== null && _values$map$join4 !== void 0 ? _values$map$join4 : fallbackValue;
    },
    costCentre: (values, { fallbackValue: fallbackValue } = {})=>{
        var _values$map$join5;
        return (_values$map$join5 = values.map((value)=>value === null || value === void 0 ? void 0 : value.name).join(", ")) !== null && _values$map$join5 !== void 0 ? _values$map$join5 : fallbackValue;
    },
    contact: (values, { fallbackValue: fallbackValue } = {})=>{
        var _values$map$join6;
        return (_values$map$join6 = values.map((value)=>value === null || value === void 0 ? void 0 : value.label).join(", ")) !== null && _values$map$join6 !== void 0 ? _values$map$join6 : fallbackValue;
    },
    staff: (values, { fallbackValue: fallbackValue } = {})=>{
        var _values$map$join7;
        return (_values$map$join7 = values.map((value)=>value === null || value === void 0 ? void 0 : value.fullName).join(", ")) !== null && _values$map$join7 !== void 0 ? _values$map$join7 : fallbackValue;
    },
    staffMember: (values, { fallbackValue: fallbackValue } = {})=>{
        var _values$map$join8;
        return (_values$map$join8 = values.map((value)=>value === null || value === void 0 ? void 0 : value.fullName).join(", ")) !== null && _values$map$join8 !== void 0 ? _values$map$join8 : fallbackValue;
    },
    role: (values, { fallbackValue: fallbackValue } = {})=>{
        var _values$map$join9;
        return (_values$map$join9 = values.map((value)=>value === null || value === void 0 ? void 0 : value.name).join(", ")) !== null && _values$map$join9 !== void 0 ? _values$map$join9 : fallbackValue;
    },
    status: (values, { fallbackValue: fallbackValue } = {})=>{
        var _ref3, _values$map$join10, _values$map3;
        return (_ref3 = (_values$map$join10 = (_values$map3 = values.map) === null || _values$map3 === void 0 ? void 0 : _values$map3.call(values, (value)=>String(value)).join(", ")) !== null && _values$map$join10 !== void 0 ? _values$map$join10 : values) !== null && _ref3 !== void 0 ? _ref3 : fallbackValue;
    }
};

});

parcelRegister("2gGkh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a6de87f68f3d79b$export$2e2bcd8739ae039; });

parcelRequire("dtopU");

var $eat5C = parcelRequire("eat5C");
parcelRequire("8mgS6");

var $7CaHe = parcelRequire("7CaHe");

var $3cqhz = parcelRequire("3cqhz");
var $1a6de87f68f3d79b$export$2e2bcd8739ae039 = {
    // boolean: {
    //     sum: (values) => values.every((v) => v),
    //     avg: (values) => Math.round(_.mean(values)),
    //     max: (values) => _.max(values),
    //     min: (values) => _.min(values),
    // },
    // text: { sum: (values) => [...new Set(values.filter((v) => v))] },
    number: {
        sum: (values)=>(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(values.filter((v)=>isFinite(v))),
        avg: (values)=>(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).mean(values.filter((v)=>isFinite(v))),
        max: (values)=>(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).max(values.filter((v)=>isFinite(v))),
        min: (values)=>(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).min(values.filter((v)=>isFinite(v)))
    },
    currency: {
        sum: (values)=>(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(values.filter((v)=>isFinite(v))),
        avg: (values)=>(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).mean(values.filter((v)=>isFinite(v))),
        max: (values)=>(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).max(values.filter((v)=>isFinite(v))),
        min: (values)=>(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).min(values.filter((v)=>isFinite(v)))
    },
    percent: {
        sum: (values)=>(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(values.filter((v)=>isFinite(v))),
        avg: (values)=>(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).mean(values.filter((v)=>isFinite(v))),
        max: (values)=>(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).max(values.filter((v)=>isFinite(v))),
        min: (values)=>(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).min(values.filter((v)=>isFinite(v)))
    },
    durationHours: {
        sum: (values)=>(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(values.filter((v)=>isFinite(v))),
        avg: (values)=>(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).mean(values.filter((v)=>isFinite(v))),
        max: (values)=>(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).max(values.filter((v)=>isFinite(v))),
        min: (values)=>(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).min(values.filter((v)=>isFinite(v)))
    },
    date: {
        avg: (values)=>new Date((0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).mean(values.filter((v)=>v instanceof Date && !isNaN(v)).map((v)=>v.getTime()))),
        max: (values)=>new Date((0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).max(values.filter((v)=>v instanceof Date && !isNaN(v)).map((v)=>v.getTime()))),
        min: (values)=>new Date((0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).min(values.filter((v)=>v instanceof Date && !isNaN(v)).map((v)=>v.getTime()))),
        same: (values)=>{
            const firstValue = values[0];
            return values.every((v)=>v instanceof Date && !isNaN(v) && v.getTime() === firstValue.getTime()) ? firstValue : null;
        }
    },
    time: {
        avg: (values)=>new Date((0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).mean(values.filter((v)=>v instanceof Date && !isNaN(v)).map((v)=>v.getTime()))),
        max: (values)=>new Date((0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).max(values.filter((v)=>v instanceof Date && !isNaN(v)).map((v)=>v.getTime()))),
        min: (values)=>new Date((0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).min(values.filter((v)=>v instanceof Date && !isNaN(v)).map((v)=>v.getTime()))),
        same: (values)=>{
            const firstValue = values[0];
            return values.every((v)=>v instanceof Date && !isNaN(v) && v.getTime() === firstValue.getTime()) ? firstValue : null;
        }
    },
    duration: {
        sum: (values)=>{
            var _values$, _values$2;
            return {
                value: (0, $7CaHe.durationToUnit)((0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(values.map((v)=>(0, $7CaHe.durationToUnit)(v, "milliseconds") || 0)), (_values$ = values[0]) === null || _values$ === void 0 ? void 0 : _values$.unit),
                unit: (_values$2 = values[0]) === null || _values$2 === void 0 ? void 0 : _values$2.unit
            };
        },
        avg: (values)=>{
            var _values$3, _values$4;
            return {
                value: (0, $7CaHe.durationToUnit)((0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).mean(values.map((v)=>(0, $7CaHe.durationToUnit)(v, "milliseconds") || 0)), (_values$3 = values[0]) === null || _values$3 === void 0 ? void 0 : _values$3.unit),
                unit: (_values$4 = values[0]) === null || _values$4 === void 0 ? void 0 : _values$4.unit
            };
        },
        max: (values)=>{
            var _values$5, _values$6;
            return {
                value: (0, $7CaHe.durationToUnit)((0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).max(values.map((v)=>(0, $7CaHe.durationToUnit)(v, "milliseconds") || 0)), (_values$5 = values[0]) === null || _values$5 === void 0 ? void 0 : _values$5.unit),
                unit: (_values$6 = values[0]) === null || _values$6 === void 0 ? void 0 : _values$6.unit
            };
        },
        min: (values)=>{
            var _values$7, _values$8;
            return {
                value: (0, $7CaHe.durationToUnit)((0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).min(values.map((v)=>(0, $7CaHe.durationToUnit)(v, "milliseconds") || 0)), (_values$7 = values[0]) === null || _values$7 === void 0 ? void 0 : _values$7.unit),
                unit: (_values$8 = values[0]) === null || _values$8 === void 0 ? void 0 : _values$8.unit
            };
        }
    },
    progress: {
        sum: (values)=>{
            return {
                numerator: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(values.map((v)=>isFinite(v === null || v === void 0 ? void 0 : v.numerator) ? v.numerator : 0)),
                denominator: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(values.map((v)=>isFinite(v === null || v === void 0 ? void 0 : v.numerator) ? v.denominator : 0))
            };
        },
        avg: (values)=>({
                numerator: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).avg(values.map((v)=>isFinite(v === null || v === void 0 ? void 0 : v.numerator) ? v.numerator : 0)),
                denominator: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).avg(values.map((v)=>isFinite(v === null || v === void 0 ? void 0 : v.numerator) ? v.denominator : 0))
            })
    },
    progressBar: {
        sum: (values)=>{
            return {
                numerator: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(values.map((v)=>isFinite(v === null || v === void 0 ? void 0 : v.numerator) ? v.numerator : 0)),
                denominator: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(values.map((v)=>isFinite(v === null || v === void 0 ? void 0 : v.numerator) ? v.denominator : 0))
            };
        },
        avg: (values)=>({
                numerator: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).avg(values.map((v)=>isFinite(v === null || v === void 0 ? void 0 : v.numerator) ? v.numerator : 0)),
                denominator: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).avg(values.map((v)=>isFinite(v === null || v === void 0 ? void 0 : v.numerator) ? v.denominator : 0))
            })
    },
    // project: { sum: (values) => [...new Set(values.filter((v) => v))] },
    // phase: { sum: (values) => [...new Set(values.filter((v) => v))] },
    // costCentre: { sum: (values) => [...new Set(values.filter((v) => v))] },
    // contact: { sum: (values) => [...new Set(values.filter((v) => v))] },
    // staff: { sum: (values) => [...new Set(values.filter((v) => v))] },
    // staffMember: { sum: (values) => [...new Set(values.filter((v) => v))] },
    // task: { sum: (values) => [...new Set(values.filter((v) => v))] },
    // role: { sum: (values) => [...new Set(values.filter((v) => v))] },
    status: {
        max: (values)=>{
            const statusPriority = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).min(values.map((v)=>(0, $3cqhz.statusPriorities)[v]));
            return (0, $3cqhz.statusByPriority)[statusPriority];
        }
    }
};

});

parcelRegister("49KZT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $306c755b3ed13b6a$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

parcelRequire("dtopU");

var $210wi = parcelRequire("210wi");
parcelRequire("jbmdS");

var $ek5Pm = parcelRequire("ek5Pm");
const $306c755b3ed13b6a$var$PlainTextCellComponent = ({ formattedValue: formattedValue, onClick: onClick, onFocus: onFocus, onBlur: onBlur, style: style })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        style: {
            width: "100%"
        },
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        style: style,
        children: formattedValue || /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
            children: "\xa0"
        })
    });
};
var $306c755b3ed13b6a$export$2e2bcd8739ae039 = {
    boolean: ({ value: value, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, key: key, style: style })=>{
        return editable ? (0, $ek5Pm.default).checkbox({
            value: value,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group,
            key: key,
            style: style,
            disabled: !editable
        }) : /*#__PURE__*/ (0, $61Ea1.jsx)($306c755b3ed13b6a$var$PlainTextCellComponent, {
            formattedValue: formattedValue,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur
        });
    },
    text: ({ value: value, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, key: key, style: style })=>editable ? (0, $ek5Pm.default).text({
            value: value,
            formattedValue: formattedValue,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group,
            key: key,
            style: style
        }) : /*#__PURE__*/ (0, $61Ea1.jsx)($306c755b3ed13b6a$var$PlainTextCellComponent, {
            formattedValue: formattedValue,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur
        }),
    number: ({ value: value, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, key: key, style: style })=>editable ? (0, $ek5Pm.default).number({
            value: value,
            formattedValue: formattedValue,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group,
            key: key,
            style: style
        }) : /*#__PURE__*/ (0, $61Ea1.jsx)($306c755b3ed13b6a$var$PlainTextCellComponent, {
            formattedValue: formattedValue,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            style: {
                color: value < 0 ? "red" : "inherit"
            }
        }),
    currency: ({ value: value, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, key: key, style: style })=>{
        return editable ? (0, $ek5Pm.default).currency({
            value: value,
            formattedValue: formattedValue,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group,
            key: key,
            style: style
        }) : /*#__PURE__*/ (0, $61Ea1.jsx)($306c755b3ed13b6a$var$PlainTextCellComponent, {
            formattedValue: formattedValue,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            style: {
                color: value < 0 ? "red" : "inherit"
            }
        });
    },
    percent: ({ value: value, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, key: key, stores: stores })=>editable ? (0, $ek5Pm.default).percent({
            value: value,
            formattedValue: formattedValue,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group,
            key: key
        }) : /*#__PURE__*/ (0, $61Ea1.jsx)($306c755b3ed13b6a$var$PlainTextCellComponent, {
            formattedValue: formattedValue,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            style: {
                color: value < 0 ? "red" : "inherit"
            }
        }),
    date: ({ value: value, formattedvalue: formattedvalue, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, key: key, stores: stores })=>editable ? (0, $ek5Pm.default).date({
            value: value,
            formattedValue: formattedValue,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group,
            key: key
        }) : /*#__PURE__*/ (0, $61Ea1.jsx)($306c755b3ed13b6a$var$PlainTextCellComponent, {
            formattedValue: formattedValue,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur
        }),
    time: ({ value: value, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, key: key, style: style })=>editable ? (0, $ek5Pm.default).time({
            value: value,
            formattedValue: formattedValue,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group,
            key: key,
            style: style
        }) : /*#__PURE__*/ (0, $61Ea1.jsx)($306c755b3ed13b6a$var$PlainTextCellComponent, {
            formattedValue: formattedValue,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur
        }),
    duration: ({ value: value, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, key: key, stores: stores })=>editable ? (0, $ek5Pm.default).duration({
            value: value,
            formattedValue: formattedValue,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group,
            key: key
        }) : /*#__PURE__*/ (0, $61Ea1.jsx)($306c755b3ed13b6a$var$PlainTextCellComponent, {
            formattedValue: formattedValue,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur
        }),
    progress: ({ value: value, formattedValue: formattedValue, formatter: formatter, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, key: key, stores: stores })=>{
        return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            children: `${isFinite(value === null || value === void 0 ? void 0 : value.numerator) ? formatter(value === null || value === void 0 ? void 0 : value.numerator) : "-"} / ${isFinite(value === null || value === void 0 ? void 0 : value.denominator) ? formatter(value === null || value === void 0 ? void 0 : value.denominator) : "-"}`
        });
    },
    progressBar: ({ value: value, formattedValue: formattedValue, formatter: formatter, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, key: key, stores: stores })=>{
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $210wi.default), {
            width: "100%",
            height: "1.5em",
            numerator: value === null || value === void 0 ? void 0 : value.numerator,
            denominator: value === null || value === void 0 ? void 0 : value.denominator,
            formatNumber: formatter
        });
    },
    project: ({ value: value, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, key: key, stores: stores })=>editable ? (0, $ek5Pm.default).project({
            value: value,
            formattedValue: formattedValue,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group,
            key: key
        }) : /*#__PURE__*/ (0, $61Ea1.jsx)($306c755b3ed13b6a$var$PlainTextCellComponent, {
            formattedValue: formattedValue,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur
        }),
    phase: ({ value: value, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, key: key, stores: stores })=>editable ? (0, $ek5Pm.default).phase({
            value: value,
            formattedValue: formattedValue,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group,
            key: key
        }) : /*#__PURE__*/ (0, $61Ea1.jsx)($306c755b3ed13b6a$var$PlainTextCellComponent, {
            formattedValue: formattedValue,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur
        }),
    costCentre: ({ value: value, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, key: key, stores: stores })=>{
        return editable ? (0, $ek5Pm.default).costCentre({
            value: value,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group,
            key: key
        }) : /*#__PURE__*/ (0, $61Ea1.jsx)($306c755b3ed13b6a$var$PlainTextCellComponent, {
            formattedValue: formattedValue,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur
        });
    },
    contact: ({ value: value, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, key: key, stores: stores })=>editable ? (0, $ek5Pm.default).contact({
            value: value,
            formattedValue: formattedValue,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group,
            key: key
        }) : /*#__PURE__*/ (0, $61Ea1.jsx)($306c755b3ed13b6a$var$PlainTextCellComponent, {
            formattedValue: formattedValue,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur
        }),
    staff: ({ value: value, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, key: key, stores: stores })=>editable ? (0, $ek5Pm.default).staff({
            value: value,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group,
            key: key
        }) : /*#__PURE__*/ (0, $61Ea1.jsx)($306c755b3ed13b6a$var$PlainTextCellComponent, {
            formattedValue: formattedValue,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur
        }),
    staffMember: ({ value: value, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, key: key, stores: stores })=>editable ? (0, $ek5Pm.default).staff({
            value: value,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group,
            key: key
        }) : /*#__PURE__*/ (0, $61Ea1.jsx)($306c755b3ed13b6a$var$PlainTextCellComponent, {
            formattedValue: formattedValue,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur
        }),
    role: ({ value: value, formattedvalue: formattedvalue, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, key: key, stores: stores })=>editable ? (0, $ek5Pm.default).role({
            value: value,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group,
            key: key
        }) : /*#__PURE__*/ (0, $61Ea1.jsx)($306c755b3ed13b6a$var$PlainTextCellComponent, {
            formattedValue: formattedValue,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur
        }),
    button: ({ value: value, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, key: key, stores: stores })=>{
        return value ? (0, $ek5Pm.default).button({
            value: value,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group,
            key: key,
            disabled: !editable
        }) : null;
    },
    checkbox: ({ value: value, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, key: key, stores: stores })=>{
        return (0, $ek5Pm.default).checkbox({
            value: value,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group,
            key: key,
            disabled: !editable
        });
    },
    textarea: ({ value: value, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, key: key, stores: stores })=>{
        return editable ? (0, $ek5Pm.default).textarea({
            value: value,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group,
            key: key
        }) : /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            children: value
        });
    },
    status: ({ value: value, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, key: key, stores: stores })=>{
        return editable ? (0, $ek5Pm.default).status({
            value: value,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group,
            key: key
        }) : /*#__PURE__*/ (0, $61Ea1.jsx)($306c755b3ed13b6a$var$PlainTextCellComponent, {
            formattedValue: formattedValue,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur
        });
    },
    staffOrRole: ({ value: value, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, key: key, stores: stores })=>{
        return (0, $ek5Pm.default).staffOrRole({
            value: value,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group,
            key: key
        });
    },
    task: ({ value: value, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, key: key, stores: stores })=>editable ? (0, $ek5Pm.default).task({
            value: value,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group,
            key: key
        }) : /*#__PURE__*/ (0, $61Ea1.jsx)($306c755b3ed13b6a$var$PlainTextCellComponent, {
            formattedValue: formattedValue,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur
        }),
    durationMinutes: ({ value: value, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, key: key, stores: stores })=>editable ? (0, $ek5Pm.default).durationMinutes({
            value: value,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group,
            key: key
        }) : /*#__PURE__*/ (0, $61Ea1.jsx)($306c755b3ed13b6a$var$PlainTextCellComponent, {
            formattedValue: formattedValue,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur
        })
};
const $306c755b3ed13b6a$export$5ddacafafa766b44 = (number, decimals = 2, multiplyer = 1)=>{
    return Math.round((parseFloat(number) || 0) * multiplyer * Math.pow(10, decimals)) / Math.pow(10, decimals);
};

});
parcelRegister("210wi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $177c1408b6bcf112$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("jbmdS");
parcelRequire("eat5C");

var $e8Hda = parcelRequire("e8Hda");
var $177c1408b6bcf112$export$2e2bcd8739ae039 = ({ numerator: numerator, denominator: denominator, nullText: nullText = "N/A", formatNumber: formatNumber = (n)=>Math.round(n), ...props })=>{
    let value, text;
    numerator = numerator ? Math.round(numerator * 10) / 10 : 0;
    denominator = denominator ? Math.round(denominator * 10) / 10 : 0;
    if (numerator == null) {
        value = NaN;
        text = nullText;
    } else if (denominator == null || denominator === 0) {
        value = NaN;
        text = `${formatNumber(numerator)} / -`;
    } else {
        value = numerator / denominator;
        text = `${formatNumber(numerator)} / ${formatNumber(denominator)} (${(0, $e8Hda.formatPercentage0)(numerator / denominator * 100)})`;
    }
    return /*#__PURE__*/ (0, $61Ea1.jsx)($177c1408b6bcf112$var$ProgressBar, {
        value: value,
        text: text,
        ...props
    });
};
const $177c1408b6bcf112$var$ProgressBar = ({ width: width, height: height, value: value, text: text, className: className, radius: radius = 0, ...props })=>{
    var val = !isNaN(value) ? value : 0;
    var color;
    if (val < 0.8) color = "#FFC734";
    else if (val <= 1.0) color = "#ffb534";
    else color = "#f05a28";
    var innerWidth = (0, $e8Hda.middleOfThree)(0, val, 1) * 100 + "%";
    return /*#__PURE__*/ (0, $61Ea1.jsx)("svg", {
        className: className,
        style: {
            width: width,
            height: height,
            display: "inline-block"
        },
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("g", {
            shapeRendering: "crisp-edges",
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsx)("rect", {
                    x: 0,
                    y: 0,
                    width: "100%",
                    height: "100%",
                    fill: !isNaN(value) ? "#888" : "#aaa",
                    stroke: "none",
                    rx: radius,
                    ry: radius
                }),
                value > 0 ? /*#__PURE__*/ (0, $61Ea1.jsx)("g", {
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)("rect", {
                        x: 0,
                        y: 0,
                        width: innerWidth,
                        height: "100%",
                        fill: color,
                        stroke: "none",
                        rx: radius,
                        ry: radius
                    })
                }) : null,
                text ? /*#__PURE__*/ (0, $61Ea1.jsx)("text", {
                    x: "50%",
                    y: "50%",
                    fill: "white",
                    textAnchor: "middle",
                    dy: "0.4em",
                    style: {
                        fontWeight: 600,
                        textShadow: "1px 1px 2px rgba(0, 0, 0, 0.43)"
                    },
                    children: text
                }) : null
            ]
        })
    });
};

});



parcelRegister("caaOk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8daecdfe4ce3be54$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");
parcelRequire("jbmdS");

var $eat5C = parcelRequire("eat5C");

var $gN0TC = parcelRequire("gN0TC");


var $cnmvx = parcelRequire("cnmvx");

parcelRequire("kl7jd");

var $98Ukb = parcelRequire("98Ukb");

var $62nmb = parcelRequire("62nmb");
var $8daecdfe4ce3be54$var$_class;
function $8daecdfe4ce3be54$var$_defineProperty(e, r, t) {
    return (r = $8daecdfe4ce3be54$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $8daecdfe4ce3be54$var$_toPropertyKey(t) {
    var i = $8daecdfe4ce3be54$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $8daecdfe4ce3be54$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $8daecdfe4ce3be54$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $8daecdfe4ce3be54$var$TableRowStore = ($8daecdfe4ce3be54$var$_class = class TableRowStore {
    constructor({ id: id, table: table, rowObject: rowObject, childComponent: childComponent, group: group, childRows: childRows }){
        $8daecdfe4ce3be54$var$_defineProperty(this, "id", (0, (/*@__PURE__*/$parcel$interopDefault($gN0TC)))());
        $8daecdfe4ce3be54$var$_defineProperty(this, "table", {});
        $8daecdfe4ce3be54$var$_defineProperty(this, "rowObject", {});
        $8daecdfe4ce3be54$var$_defineProperty(this, "rowOptions", {});
        $8daecdfe4ce3be54$var$_defineProperty(this, "group", undefined);
        $8daecdfe4ce3be54$var$_defineProperty(this, "_cellsByColumnId", new Map());
        (0, $4JcCM.makeObservable)(this);
        this.id = id !== null && id !== void 0 ? id : this.id;
        this.table = table !== null && table !== void 0 ? table : this.table;
        this.rowObject = rowObject !== null && rowObject !== void 0 ? rowObject : this.rowObject;
        this.childComponent = childComponent;
        this.group = group;
        this._childRows = childRows || new Set();
    }
    getOrCreateCell(column) {
        if (!this._cellsByColumnId.get(column.id || column)) this._cellsByColumnId.set(column.id || column, new (0, $98Ukb.default)({
            table: this.table,
            column: column,
            row: this
        }));
        return this._cellsByColumnId.get(column.id || column);
    }
    updateColumn(column) {
        this._cellsByColumnId.set(column.id, new (0, $98Ukb.default)({
            table: this.table,
            column: column,
            row: this
        }));
    }
    get cells() {
        const cells = {};
        this.table._columns.forEach((column)=>{
            cells[column.id] = this.getOrCreateCell(column);
        });
        return cells;
    }
    get groupLevel() {
        const groupIndex = this.table.groups.findIndex((g)=>g === this.group);
        return groupIndex >= 0 ? groupIndex : this.table.groups.length;
    }
    get parent() {
        return this.table._rows.filter((r)=>r._childRows.has(this))[0];
    }
    get expanded() {
        return this.table.expandedRows.has(this) || this.table.expandedGroups.includes(this.group);
    }
    get childRows() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).orderBy([
            ...this._childRows
        ].filter((cr)=>cr.visible), [
            (r)=>r.rowObject.isNew,
            ...this.table.sortBy.map(([prop, direction])=>(r)=>{
                    let val;
                    if (typeof prop === "string" && r.cells[prop]) val = r.cells[prop].value;
                    else if (typeof prop === "function") val = prop(r);
                    return val || Infinity;
                }),
            (r)=>r.rowObject.initiatedAt
        ], [
            "desc",
            ...this.table.sortBy.map(([prop, direction])=>direction),
            "asc"
        ]);
    }
    get descendants() {
        const descendants = [];
        if (this.childRows.length) this.childRows.forEach((cr)=>{
            descendants.push(...cr.descendants);
        });
        else descendants.push(this);
        return descendants;
    }
    get ungroupedDescendants() {
        return this.descendants.filter((r)=>!r.group);
    }
    get visible() {
        return this.table.filters.every(({ column: column, operator: operator, value: value, group: group })=>{
            var _this$cells$column, _this$cells$column2, _this$cells$column3, _Filters$type, _Filters$type$operato;
            if (group !== this.group) return true;
            const val = (_this$cells$column = this.cells[column]) === null || _this$cells$column === void 0 ? void 0 : _this$cells$column.value;
            if (((_this$cells$column2 = this.cells[column]) === null || _this$cells$column2 === void 0 ? void 0 : _this$cells$column2.equalityComparatorValue) == null) return false;
            const type = (_this$cells$column3 = this.cells[column]) === null || _this$cells$column3 === void 0 ? void 0 : _this$cells$column3.type;
            const not = operator.includes("!");
            const matchFilter = (_Filters$type = (0, $cnmvx.default)[type]) === null || _Filters$type === void 0 ? void 0 : (_Filters$type$operato = _Filters$type[operator.replace("!", "")]) === null || _Filters$type$operato === void 0 ? void 0 : _Filters$type$operato.call(_Filters$type, val, value);
            return not ? !matchFilter : matchFilter;
        });
    }
}, $8daecdfe4ce3be54$var$_applyDecoratedDescriptor($8daecdfe4ce3be54$var$_class.prototype, "getOrCreateCell", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($8daecdfe4ce3be54$var$_class.prototype, "getOrCreateCell"), $8daecdfe4ce3be54$var$_class.prototype), $8daecdfe4ce3be54$var$_applyDecoratedDescriptor($8daecdfe4ce3be54$var$_class.prototype, "updateColumn", [
    (0, $4JcCM.action)
], Object.getOwnPropertyDescriptor($8daecdfe4ce3be54$var$_class.prototype, "updateColumn"), $8daecdfe4ce3be54$var$_class.prototype), $8daecdfe4ce3be54$var$_applyDecoratedDescriptor($8daecdfe4ce3be54$var$_class.prototype, "cells", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($8daecdfe4ce3be54$var$_class.prototype, "cells"), $8daecdfe4ce3be54$var$_class.prototype), $8daecdfe4ce3be54$var$_applyDecoratedDescriptor($8daecdfe4ce3be54$var$_class.prototype, "groupLevel", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($8daecdfe4ce3be54$var$_class.prototype, "groupLevel"), $8daecdfe4ce3be54$var$_class.prototype), $8daecdfe4ce3be54$var$_applyDecoratedDescriptor($8daecdfe4ce3be54$var$_class.prototype, "parent", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($8daecdfe4ce3be54$var$_class.prototype, "parent"), $8daecdfe4ce3be54$var$_class.prototype), $8daecdfe4ce3be54$var$_applyDecoratedDescriptor($8daecdfe4ce3be54$var$_class.prototype, "expanded", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($8daecdfe4ce3be54$var$_class.prototype, "expanded"), $8daecdfe4ce3be54$var$_class.prototype), $8daecdfe4ce3be54$var$_applyDecoratedDescriptor($8daecdfe4ce3be54$var$_class.prototype, "childRows", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($8daecdfe4ce3be54$var$_class.prototype, "childRows"), $8daecdfe4ce3be54$var$_class.prototype), $8daecdfe4ce3be54$var$_applyDecoratedDescriptor($8daecdfe4ce3be54$var$_class.prototype, "descendants", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($8daecdfe4ce3be54$var$_class.prototype, "descendants"), $8daecdfe4ce3be54$var$_class.prototype), $8daecdfe4ce3be54$var$_applyDecoratedDescriptor($8daecdfe4ce3be54$var$_class.prototype, "ungroupedDescendants", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($8daecdfe4ce3be54$var$_class.prototype, "ungroupedDescendants"), $8daecdfe4ce3be54$var$_class.prototype), $8daecdfe4ce3be54$var$_applyDecoratedDescriptor($8daecdfe4ce3be54$var$_class.prototype, "visible", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($8daecdfe4ce3be54$var$_class.prototype, "visible"), $8daecdfe4ce3be54$var$_class.prototype), $8daecdfe4ce3be54$var$_class);
var $8daecdfe4ce3be54$export$2e2bcd8739ae039 = $8daecdfe4ce3be54$var$TableRowStore;

});
parcelRegister("98Ukb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a808d4c81d7b0d8$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");
parcelRequire("jbmdS");
parcelRequire("eat5C");

var $gN0TC = parcelRequire("gN0TC");

parcelRequire("cnmvx");

var $f4n1H = parcelRequire("f4n1H");
var $6a808d4c81d7b0d8$var$_class;
function $6a808d4c81d7b0d8$var$_defineProperty(e, r, t) {
    return (r = $6a808d4c81d7b0d8$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $6a808d4c81d7b0d8$var$_toPropertyKey(t) {
    var i = $6a808d4c81d7b0d8$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $6a808d4c81d7b0d8$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $6a808d4c81d7b0d8$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $6a808d4c81d7b0d8$var$TableCellStore = ($6a808d4c81d7b0d8$var$_class = class TableCellStore {
    constructor({ table: table, row: row, column: column }){
        $6a808d4c81d7b0d8$var$_defineProperty(this, "id", (0, (/*@__PURE__*/$parcel$interopDefault($gN0TC)))());
        $6a808d4c81d7b0d8$var$_defineProperty(this, "table", {});
        $6a808d4c81d7b0d8$var$_defineProperty(this, "row", {});
        $6a808d4c81d7b0d8$var$_defineProperty(this, "column", {});
        (0, $4JcCM.makeObservable)(this);
        this.table = table !== null && table !== void 0 ? table : this.table;
        this.row = row !== null && row !== void 0 ? row : this.row;
        this.column = column !== null && column !== void 0 ? column : this.column;
    }
    get stores() {
        return {
            cell: this,
            row: this.row,
            column: this.column,
            table: this.table
        };
    }
    get rowObject() {
        return this.row.rowObject;
    }
    get group() {
        return this.row.group;
    }
    get type() {
        return this.column.type;
    }
    get data() {
        return this.column.data;
    }
    get editable() {
        return this.rowObject && this.column.editable(this.rowObject, this.stores);
    }
    get onChange() {
        var _this$column$onChange, _this$column;
        return (_this$column$onChange = (_this$column = this.column).onChange) === null || _this$column$onChange === void 0 ? void 0 : _this$column$onChange.call(_this$column, this.rowObject, this.stores);
    }
    get onClick() {
        var _this$column$onClick, _this$column2;
        return (_this$column$onClick = (_this$column2 = this.column).onClick) === null || _this$column$onClick === void 0 ? void 0 : _this$column$onClick.call(_this$column2, this.rowObject, this.stores);
    }
    get onFocus() {
        var _this$column$onFocus, _this$column3;
        return (_this$column$onFocus = (_this$column3 = this.column).onFocus) === null || _this$column$onFocus === void 0 ? void 0 : _this$column$onFocus.call(_this$column3, this.rowObject, this.stores);
    }
    get onBlur() {
        var _this$column$onBlur, _this$column4;
        return (_this$column$onBlur = (_this$column4 = this.column).onBlur) === null || _this$column$onBlur === void 0 ? void 0 : _this$column$onBlur.call(_this$column4, this.rowObject, this.stores);
    }
    get value() {
        var _this$column5, _this$column6, _this$column7;
        if (!this.hasPermission) return null;
        const getBestValue = (values)=>{
            let sortValue = null;
            let bestValue = null;
            for (let v of values)if (v) {
                sortValue = this.column.sortComparator((v === null || v === void 0 ? void 0 : v[0]) || v, this.stores);
                bestValue = v;
                break;
            }
            if (!sortValue || typeof sortValue === "number" && !isFinite(sortValue)) for (let v of values){
                let sv = this.column.sortComparator((v === null || v === void 0 ? void 0 : v[0]) || v, this.stores);
                if (sv !== null && sv !== undefined && isFinite(sv)) {
                    sortValue = sv;
                    bestValue = v;
                    break;
                }
            }
            return bestValue;
        };
        let val1 = $6a808d4c81d7b0d8$var$tryOrNull(()=>this.column.value(this.rowObject, this.stores));
        let val2 = this.rowObject[this.column.id];
        const val3 = this.row.childRows.length ? (_this$column5 = this.column) === null || _this$column5 === void 0 ? void 0 : _this$column5.aggregator(this.row.descendants.map((d)=>{
            var _d$cells$this$column$;
            return (_d$cells$this$column$ = d.cells[this.column.id]) === null || _d$cells$this$column$ === void 0 ? void 0 : _d$cells$this$column$.value;
        }), this.stores) : null;
        val1 = (0, (/*@__PURE__*/$parcel$interopDefault($f4n1H))).array(val1) ? (_this$column6 = this.column) === null || _this$column6 === void 0 ? void 0 : _this$column6.aggregator(val1) : val1;
        val2 = (0, (/*@__PURE__*/$parcel$interopDefault($f4n1H))).array(val2) ? (_this$column7 = this.column) === null || _this$column7 === void 0 ? void 0 : _this$column7.aggregator(val2) : val2;
        const value = getBestValue([
            val1,
            val2,
            val3
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($f4n1H))).array(value) && value.length === 1 ? value[0] : (0, (/*@__PURE__*/$parcel$interopDefault($f4n1H))).array(value) && value.length === 0 ? null : value;
    }
    get formattedValue() {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($f4n1H))).array(this.value)) return this.column.groupFormatter(this.value, this.stores);
        else return this.column.formatter(this.value, this.stores);
    }
    get formattedCSVValue() {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($f4n1H))).array(this.value)) return this.column.csvGroupFormatter(this.value, this.stores);
        else return this.column.csvFormatter(this.value, this.stores);
    }
    get equalityComparatorValue() {
        let value = (0, (/*@__PURE__*/$parcel$interopDefault($f4n1H))).array(this.value) ? this.value[0] : this.value;
        return this.column.equalityComparator(value, this.stores);
    }
    get sortComparatorValue() {
        let value = (0, (/*@__PURE__*/$parcel$interopDefault($f4n1H))).array(this.value) ? this.value[0] : this.value;
        return this.column.sortComparator(value, this.stores);
    }
    get component() {
        var _this$column$cellComp, _this$column8;
        return (_this$column$cellComp = (_this$column8 = this.column).cellComponent) === null || _this$column$cellComp === void 0 ? void 0 : _this$column$cellComp.call(_this$column8, {
            value: this.value,
            group: this.group,
            formattedValue: this.formattedValue,
            formatter: this.column.formatter,
            editable: this.editable,
            onChange: this.onChange,
            onClick: this.onClick,
            onFocus: this.onFocus,
            onBlur: this.onBlur,
            stores: this.stores,
            selected: this.selected,
            style: {
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center"
            }
        });
    }
    get readOnlyComponent() {
        return this.column.cellComponent({
            value: this.value,
            group: this.group,
            formattedValue: this.formattedValue,
            formatter: this.column.formatter,
            editable: false,
            stores: this.stores,
            style: {
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center"
            }
        });
    }
    get style() {
        return this.column.style(this.rowObject, this.stores);
    }
    get className() {
        return this.column.className(this.rowObject, this.stores);
    }
    get selected() {
        return this.column.selected(this.rowObject, this.stores);
    }
    get hasPermission() {
        return this.column.permissions(this.rowObject, this.stores);
    }
}, $6a808d4c81d7b0d8$var$_applyDecoratedDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "stores", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "stores"), $6a808d4c81d7b0d8$var$_class.prototype), $6a808d4c81d7b0d8$var$_applyDecoratedDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "rowObject", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "rowObject"), $6a808d4c81d7b0d8$var$_class.prototype), $6a808d4c81d7b0d8$var$_applyDecoratedDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "group", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "group"), $6a808d4c81d7b0d8$var$_class.prototype), $6a808d4c81d7b0d8$var$_applyDecoratedDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "type", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "type"), $6a808d4c81d7b0d8$var$_class.prototype), $6a808d4c81d7b0d8$var$_applyDecoratedDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "data", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "data"), $6a808d4c81d7b0d8$var$_class.prototype), $6a808d4c81d7b0d8$var$_applyDecoratedDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "editable", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "editable"), $6a808d4c81d7b0d8$var$_class.prototype), $6a808d4c81d7b0d8$var$_applyDecoratedDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "onChange", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "onChange"), $6a808d4c81d7b0d8$var$_class.prototype), $6a808d4c81d7b0d8$var$_applyDecoratedDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "onClick", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "onClick"), $6a808d4c81d7b0d8$var$_class.prototype), $6a808d4c81d7b0d8$var$_applyDecoratedDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "onFocus", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "onFocus"), $6a808d4c81d7b0d8$var$_class.prototype), $6a808d4c81d7b0d8$var$_applyDecoratedDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "onBlur", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "onBlur"), $6a808d4c81d7b0d8$var$_class.prototype), $6a808d4c81d7b0d8$var$_applyDecoratedDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "value", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "value"), $6a808d4c81d7b0d8$var$_class.prototype), $6a808d4c81d7b0d8$var$_applyDecoratedDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "formattedValue", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "formattedValue"), $6a808d4c81d7b0d8$var$_class.prototype), $6a808d4c81d7b0d8$var$_applyDecoratedDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "formattedCSVValue", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "formattedCSVValue"), $6a808d4c81d7b0d8$var$_class.prototype), $6a808d4c81d7b0d8$var$_applyDecoratedDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "equalityComparatorValue", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "equalityComparatorValue"), $6a808d4c81d7b0d8$var$_class.prototype), $6a808d4c81d7b0d8$var$_applyDecoratedDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "sortComparatorValue", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "sortComparatorValue"), $6a808d4c81d7b0d8$var$_class.prototype), $6a808d4c81d7b0d8$var$_applyDecoratedDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "component", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "component"), $6a808d4c81d7b0d8$var$_class.prototype), $6a808d4c81d7b0d8$var$_applyDecoratedDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "readOnlyComponent", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "readOnlyComponent"), $6a808d4c81d7b0d8$var$_class.prototype), $6a808d4c81d7b0d8$var$_applyDecoratedDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "style", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "style"), $6a808d4c81d7b0d8$var$_class.prototype), $6a808d4c81d7b0d8$var$_applyDecoratedDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "className", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "className"), $6a808d4c81d7b0d8$var$_class.prototype), $6a808d4c81d7b0d8$var$_applyDecoratedDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "selected", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "selected"), $6a808d4c81d7b0d8$var$_class.prototype), $6a808d4c81d7b0d8$var$_applyDecoratedDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "hasPermission", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($6a808d4c81d7b0d8$var$_class.prototype, "hasPermission"), $6a808d4c81d7b0d8$var$_class.prototype), $6a808d4c81d7b0d8$var$_class);
var $6a808d4c81d7b0d8$export$2e2bcd8739ae039 = $6a808d4c81d7b0d8$var$TableCellStore;
const $6a808d4c81d7b0d8$var$tryOrNull = (func)=>{
    try {
        return func === null || func === void 0 ? void 0 : func();
    } catch (e) {
        // console.warn(e)
        return null;
    }
};

});
parcelRegister("f4n1H", function(module, exports) {
"use strict";
/// <reference lib="es2018"/>
/// <reference lib="dom"/>
/// <reference types="node"/>
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $af89174fb098ebf7$var$typedArrayTypeNames = [
    "Int8Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Int16Array",
    "Uint16Array",
    "Int32Array",
    "Uint32Array",
    "Float32Array",
    "Float64Array",
    "BigInt64Array",
    "BigUint64Array"
];
function $af89174fb098ebf7$var$isTypedArrayName(name) {
    return $af89174fb098ebf7$var$typedArrayTypeNames.includes(name);
}
const $af89174fb098ebf7$var$objectTypeNames = [
    "Function",
    "Generator",
    "AsyncGenerator",
    "GeneratorFunction",
    "AsyncGeneratorFunction",
    "AsyncFunction",
    "Observable",
    "Array",
    "Buffer",
    "Blob",
    "Object",
    "RegExp",
    "Date",
    "Error",
    "Map",
    "Set",
    "WeakMap",
    "WeakSet",
    "ArrayBuffer",
    "SharedArrayBuffer",
    "DataView",
    "Promise",
    "URL",
    "FormData",
    "URLSearchParams",
    "HTMLElement",
    ...$af89174fb098ebf7$var$typedArrayTypeNames
];
function $af89174fb098ebf7$var$isObjectTypeName(name) {
    return $af89174fb098ebf7$var$objectTypeNames.includes(name);
}
const $af89174fb098ebf7$var$primitiveTypeNames = [
    "null",
    "undefined",
    "string",
    "number",
    "bigint",
    "boolean",
    "symbol"
];
function $af89174fb098ebf7$var$isPrimitiveTypeName(name) {
    return $af89174fb098ebf7$var$primitiveTypeNames.includes(name);
}
// eslint-disable-next-line @typescript-eslint/ban-types
function $af89174fb098ebf7$var$isOfType(type) {
    return (value)=>typeof value === type;
}
const { toString: $af89174fb098ebf7$var$toString } = Object.prototype;
const $af89174fb098ebf7$var$getObjectType = (value)=>{
    const objectTypeName = $af89174fb098ebf7$var$toString.call(value).slice(8, -1);
    if (/HTML\w+Element/.test(objectTypeName) && $af89174fb098ebf7$var$is.domElement(value)) return "HTMLElement";
    if ($af89174fb098ebf7$var$isObjectTypeName(objectTypeName)) return objectTypeName;
    return undefined;
};
const $af89174fb098ebf7$var$isObjectOfType = (type)=>(value)=>$af89174fb098ebf7$var$getObjectType(value) === type;
function $af89174fb098ebf7$var$is(value) {
    if (value === null) return "null";
    switch(typeof value){
        case "undefined":
            return "undefined";
        case "string":
            return "string";
        case "number":
            return "number";
        case "boolean":
            return "boolean";
        case "function":
            return "Function";
        case "bigint":
            return "bigint";
        case "symbol":
            return "symbol";
        default:
    }
    if ($af89174fb098ebf7$var$is.observable(value)) return "Observable";
    if ($af89174fb098ebf7$var$is.array(value)) return "Array";
    if ($af89174fb098ebf7$var$is.buffer(value)) return "Buffer";
    const tagType = $af89174fb098ebf7$var$getObjectType(value);
    if (tagType) return tagType;
    if (value instanceof String || value instanceof Boolean || value instanceof Number) throw new TypeError("Please don't use object wrappers for primitive types");
    return "Object";
}
$af89174fb098ebf7$var$is.undefined = $af89174fb098ebf7$var$isOfType("undefined");
$af89174fb098ebf7$var$is.string = $af89174fb098ebf7$var$isOfType("string");
const $af89174fb098ebf7$var$isNumberType = $af89174fb098ebf7$var$isOfType("number");
$af89174fb098ebf7$var$is.number = (value)=>$af89174fb098ebf7$var$isNumberType(value) && !$af89174fb098ebf7$var$is.nan(value);
$af89174fb098ebf7$var$is.bigint = $af89174fb098ebf7$var$isOfType("bigint");
// eslint-disable-next-line @typescript-eslint/ban-types
$af89174fb098ebf7$var$is.function_ = $af89174fb098ebf7$var$isOfType("function");
$af89174fb098ebf7$var$is.null_ = (value)=>value === null;
$af89174fb098ebf7$var$is.class_ = (value)=>$af89174fb098ebf7$var$is.function_(value) && value.toString().startsWith("class ");
$af89174fb098ebf7$var$is.boolean = (value)=>value === true || value === false;
$af89174fb098ebf7$var$is.symbol = $af89174fb098ebf7$var$isOfType("symbol");
$af89174fb098ebf7$var$is.numericString = (value)=>$af89174fb098ebf7$var$is.string(value) && !$af89174fb098ebf7$var$is.emptyStringOrWhitespace(value) && !Number.isNaN(Number(value));
$af89174fb098ebf7$var$is.array = (value, assertion)=>{
    if (!Array.isArray(value)) return false;
    if (!$af89174fb098ebf7$var$is.function_(assertion)) return true;
    return value.every(assertion);
};
$af89174fb098ebf7$var$is.buffer = (value)=>{
    var _a, _b, _c, _d;
    return (_d = (_c = (_b = (_a = value) === null || _a === void 0 ? void 0 : _a.constructor) === null || _b === void 0 ? void 0 : _b.isBuffer) === null || _c === void 0 ? void 0 : _c.call(_b, value)) !== null && _d !== void 0 ? _d : false;
};
$af89174fb098ebf7$var$is.blob = (value)=>$af89174fb098ebf7$var$isObjectOfType("Blob")(value);
$af89174fb098ebf7$var$is.nullOrUndefined = (value)=>$af89174fb098ebf7$var$is.null_(value) || $af89174fb098ebf7$var$is.undefined(value);
$af89174fb098ebf7$var$is.object = (value)=>!$af89174fb098ebf7$var$is.null_(value) && (typeof value === "object" || $af89174fb098ebf7$var$is.function_(value));
$af89174fb098ebf7$var$is.iterable = (value)=>{
    var _a;
    return $af89174fb098ebf7$var$is.function_((_a = value) === null || _a === void 0 ? void 0 : _a[Symbol.iterator]);
};
$af89174fb098ebf7$var$is.asyncIterable = (value)=>{
    var _a;
    return $af89174fb098ebf7$var$is.function_((_a = value) === null || _a === void 0 ? void 0 : _a[Symbol.asyncIterator]);
};
$af89174fb098ebf7$var$is.generator = (value)=>{
    var _a, _b;
    return $af89174fb098ebf7$var$is.iterable(value) && $af89174fb098ebf7$var$is.function_((_a = value) === null || _a === void 0 ? void 0 : _a.next) && $af89174fb098ebf7$var$is.function_((_b = value) === null || _b === void 0 ? void 0 : _b.throw);
};
$af89174fb098ebf7$var$is.asyncGenerator = (value)=>$af89174fb098ebf7$var$is.asyncIterable(value) && $af89174fb098ebf7$var$is.function_(value.next) && $af89174fb098ebf7$var$is.function_(value.throw);
$af89174fb098ebf7$var$is.nativePromise = (value)=>$af89174fb098ebf7$var$isObjectOfType("Promise")(value);
const $af89174fb098ebf7$var$hasPromiseAPI = (value)=>{
    var _a, _b;
    return $af89174fb098ebf7$var$is.function_((_a = value) === null || _a === void 0 ? void 0 : _a.then) && $af89174fb098ebf7$var$is.function_((_b = value) === null || _b === void 0 ? void 0 : _b.catch);
};
$af89174fb098ebf7$var$is.promise = (value)=>$af89174fb098ebf7$var$is.nativePromise(value) || $af89174fb098ebf7$var$hasPromiseAPI(value);
$af89174fb098ebf7$var$is.generatorFunction = $af89174fb098ebf7$var$isObjectOfType("GeneratorFunction");
$af89174fb098ebf7$var$is.asyncGeneratorFunction = (value)=>$af89174fb098ebf7$var$getObjectType(value) === "AsyncGeneratorFunction";
$af89174fb098ebf7$var$is.asyncFunction = (value)=>$af89174fb098ebf7$var$getObjectType(value) === "AsyncFunction";
// eslint-disable-next-line no-prototype-builtins, @typescript-eslint/ban-types
$af89174fb098ebf7$var$is.boundFunction = (value)=>$af89174fb098ebf7$var$is.function_(value) && !value.hasOwnProperty("prototype");
$af89174fb098ebf7$var$is.regExp = $af89174fb098ebf7$var$isObjectOfType("RegExp");
$af89174fb098ebf7$var$is.date = $af89174fb098ebf7$var$isObjectOfType("Date");
$af89174fb098ebf7$var$is.error = $af89174fb098ebf7$var$isObjectOfType("Error");
$af89174fb098ebf7$var$is.map = (value)=>$af89174fb098ebf7$var$isObjectOfType("Map")(value);
$af89174fb098ebf7$var$is.set = (value)=>$af89174fb098ebf7$var$isObjectOfType("Set")(value);
$af89174fb098ebf7$var$is.weakMap = (value)=>$af89174fb098ebf7$var$isObjectOfType("WeakMap")(value);
$af89174fb098ebf7$var$is.weakSet = (value)=>$af89174fb098ebf7$var$isObjectOfType("WeakSet")(value);
$af89174fb098ebf7$var$is.int8Array = $af89174fb098ebf7$var$isObjectOfType("Int8Array");
$af89174fb098ebf7$var$is.uint8Array = $af89174fb098ebf7$var$isObjectOfType("Uint8Array");
$af89174fb098ebf7$var$is.uint8ClampedArray = $af89174fb098ebf7$var$isObjectOfType("Uint8ClampedArray");
$af89174fb098ebf7$var$is.int16Array = $af89174fb098ebf7$var$isObjectOfType("Int16Array");
$af89174fb098ebf7$var$is.uint16Array = $af89174fb098ebf7$var$isObjectOfType("Uint16Array");
$af89174fb098ebf7$var$is.int32Array = $af89174fb098ebf7$var$isObjectOfType("Int32Array");
$af89174fb098ebf7$var$is.uint32Array = $af89174fb098ebf7$var$isObjectOfType("Uint32Array");
$af89174fb098ebf7$var$is.float32Array = $af89174fb098ebf7$var$isObjectOfType("Float32Array");
$af89174fb098ebf7$var$is.float64Array = $af89174fb098ebf7$var$isObjectOfType("Float64Array");
$af89174fb098ebf7$var$is.bigInt64Array = $af89174fb098ebf7$var$isObjectOfType("BigInt64Array");
$af89174fb098ebf7$var$is.bigUint64Array = $af89174fb098ebf7$var$isObjectOfType("BigUint64Array");
$af89174fb098ebf7$var$is.arrayBuffer = $af89174fb098ebf7$var$isObjectOfType("ArrayBuffer");
$af89174fb098ebf7$var$is.sharedArrayBuffer = $af89174fb098ebf7$var$isObjectOfType("SharedArrayBuffer");
$af89174fb098ebf7$var$is.dataView = $af89174fb098ebf7$var$isObjectOfType("DataView");
$af89174fb098ebf7$var$is.enumCase = (value, targetEnum)=>Object.values(targetEnum).includes(value);
$af89174fb098ebf7$var$is.directInstanceOf = (instance, class_)=>Object.getPrototypeOf(instance) === class_.prototype;
$af89174fb098ebf7$var$is.urlInstance = (value)=>$af89174fb098ebf7$var$isObjectOfType("URL")(value);
$af89174fb098ebf7$var$is.urlString = (value)=>{
    if (!$af89174fb098ebf7$var$is.string(value)) return false;
    try {
        new URL(value); // eslint-disable-line no-new
        return true;
    } catch (_a) {
        return false;
    }
};
// Example: `is.truthy = (value: unknown): value is (not false | not 0 | not '' | not undefined | not null) => Boolean(value);`
$af89174fb098ebf7$var$is.truthy = (value)=>Boolean(value);
// Example: `is.falsy = (value: unknown): value is (not true | 0 | '' | undefined | null) => Boolean(value);`
$af89174fb098ebf7$var$is.falsy = (value)=>!value;
$af89174fb098ebf7$var$is.nan = (value)=>Number.isNaN(value);
$af89174fb098ebf7$var$is.primitive = (value)=>$af89174fb098ebf7$var$is.null_(value) || $af89174fb098ebf7$var$isPrimitiveTypeName(typeof value);
$af89174fb098ebf7$var$is.integer = (value)=>Number.isInteger(value);
$af89174fb098ebf7$var$is.safeInteger = (value)=>Number.isSafeInteger(value);
$af89174fb098ebf7$var$is.plainObject = (value)=>{
    // From: https://github.com/sindresorhus/is-plain-obj/blob/main/index.js
    if ($af89174fb098ebf7$var$toString.call(value) !== "[object Object]") return false;
    const prototype = Object.getPrototypeOf(value);
    return prototype === null || prototype === Object.getPrototypeOf({});
};
$af89174fb098ebf7$var$is.typedArray = (value)=>$af89174fb098ebf7$var$isTypedArrayName($af89174fb098ebf7$var$getObjectType(value));
const $af89174fb098ebf7$var$isValidLength = (value)=>$af89174fb098ebf7$var$is.safeInteger(value) && value >= 0;
$af89174fb098ebf7$var$is.arrayLike = (value)=>!$af89174fb098ebf7$var$is.nullOrUndefined(value) && !$af89174fb098ebf7$var$is.function_(value) && $af89174fb098ebf7$var$isValidLength(value.length);
$af89174fb098ebf7$var$is.inRange = (value, range)=>{
    if ($af89174fb098ebf7$var$is.number(range)) return value >= Math.min(0, range) && value <= Math.max(range, 0);
    if ($af89174fb098ebf7$var$is.array(range) && range.length === 2) return value >= Math.min(...range) && value <= Math.max(...range);
    throw new TypeError(`Invalid range: ${JSON.stringify(range)}`);
};
const $af89174fb098ebf7$var$NODE_TYPE_ELEMENT = 1;
const $af89174fb098ebf7$var$DOM_PROPERTIES_TO_CHECK = [
    "innerHTML",
    "ownerDocument",
    "style",
    "attributes",
    "nodeValue"
];
$af89174fb098ebf7$var$is.domElement = (value)=>{
    return $af89174fb098ebf7$var$is.object(value) && value.nodeType === $af89174fb098ebf7$var$NODE_TYPE_ELEMENT && $af89174fb098ebf7$var$is.string(value.nodeName) && !$af89174fb098ebf7$var$is.plainObject(value) && $af89174fb098ebf7$var$DOM_PROPERTIES_TO_CHECK.every((property)=>property in value);
};
$af89174fb098ebf7$var$is.observable = (value)=>{
    var _a, _b, _c, _d;
    if (!value) return false;
    // eslint-disable-next-line no-use-extend-native/no-use-extend-native
    if (value === ((_b = (_a = value)[Symbol.observable]) === null || _b === void 0 ? void 0 : _b.call(_a))) return true;
    if (value === ((_d = (_c = value)["@@observable"]) === null || _d === void 0 ? void 0 : _d.call(_c))) return true;
    return false;
};
$af89174fb098ebf7$var$is.nodeStream = (value)=>$af89174fb098ebf7$var$is.object(value) && $af89174fb098ebf7$var$is.function_(value.pipe) && !$af89174fb098ebf7$var$is.observable(value);
$af89174fb098ebf7$var$is.infinite = (value)=>value === Infinity || value === -Infinity;
const $af89174fb098ebf7$var$isAbsoluteMod2 = (remainder)=>(value)=>$af89174fb098ebf7$var$is.integer(value) && Math.abs(value % 2) === remainder;
$af89174fb098ebf7$var$is.evenInteger = $af89174fb098ebf7$var$isAbsoluteMod2(0);
$af89174fb098ebf7$var$is.oddInteger = $af89174fb098ebf7$var$isAbsoluteMod2(1);
$af89174fb098ebf7$var$is.emptyArray = (value)=>$af89174fb098ebf7$var$is.array(value) && value.length === 0;
$af89174fb098ebf7$var$is.nonEmptyArray = (value)=>$af89174fb098ebf7$var$is.array(value) && value.length > 0;
$af89174fb098ebf7$var$is.emptyString = (value)=>$af89174fb098ebf7$var$is.string(value) && value.length === 0;
const $af89174fb098ebf7$var$isWhiteSpaceString = (value)=>$af89174fb098ebf7$var$is.string(value) && !/\S/.test(value);
$af89174fb098ebf7$var$is.emptyStringOrWhitespace = (value)=>$af89174fb098ebf7$var$is.emptyString(value) || $af89174fb098ebf7$var$isWhiteSpaceString(value);
// TODO: Use `not ''` when the `not` operator is available.
$af89174fb098ebf7$var$is.nonEmptyString = (value)=>$af89174fb098ebf7$var$is.string(value) && value.length > 0;
// TODO: Use `not ''` when the `not` operator is available.
$af89174fb098ebf7$var$is.nonEmptyStringAndNotWhitespace = (value)=>$af89174fb098ebf7$var$is.string(value) && !$af89174fb098ebf7$var$is.emptyStringOrWhitespace(value);
$af89174fb098ebf7$var$is.emptyObject = (value)=>$af89174fb098ebf7$var$is.object(value) && !$af89174fb098ebf7$var$is.map(value) && !$af89174fb098ebf7$var$is.set(value) && Object.keys(value).length === 0;
// TODO: Use `not` operator here to remove `Map` and `Set` from type guard:
// - https://github.com/Microsoft/TypeScript/pull/29317
$af89174fb098ebf7$var$is.nonEmptyObject = (value)=>$af89174fb098ebf7$var$is.object(value) && !$af89174fb098ebf7$var$is.map(value) && !$af89174fb098ebf7$var$is.set(value) && Object.keys(value).length > 0;
$af89174fb098ebf7$var$is.emptySet = (value)=>$af89174fb098ebf7$var$is.set(value) && value.size === 0;
$af89174fb098ebf7$var$is.nonEmptySet = (value)=>$af89174fb098ebf7$var$is.set(value) && value.size > 0;
$af89174fb098ebf7$var$is.emptyMap = (value)=>$af89174fb098ebf7$var$is.map(value) && value.size === 0;
$af89174fb098ebf7$var$is.nonEmptyMap = (value)=>$af89174fb098ebf7$var$is.map(value) && value.size > 0;
// `PropertyKey` is any value that can be used as an object key (string, number, or symbol)
$af89174fb098ebf7$var$is.propertyKey = (value)=>$af89174fb098ebf7$var$is.any([
        $af89174fb098ebf7$var$is.string,
        $af89174fb098ebf7$var$is.number,
        $af89174fb098ebf7$var$is.symbol
    ], value);
$af89174fb098ebf7$var$is.formData = (value)=>$af89174fb098ebf7$var$isObjectOfType("FormData")(value);
$af89174fb098ebf7$var$is.urlSearchParams = (value)=>$af89174fb098ebf7$var$isObjectOfType("URLSearchParams")(value);
const $af89174fb098ebf7$var$predicateOnArray = (method, predicate, values)=>{
    if (!$af89174fb098ebf7$var$is.function_(predicate)) throw new TypeError(`Invalid predicate: ${JSON.stringify(predicate)}`);
    if (values.length === 0) throw new TypeError("Invalid number of values");
    return method.call(values, predicate);
};
$af89174fb098ebf7$var$is.any = (predicate, ...values)=>{
    const predicates = $af89174fb098ebf7$var$is.array(predicate) ? predicate : [
        predicate
    ];
    return predicates.some((singlePredicate)=>$af89174fb098ebf7$var$predicateOnArray(Array.prototype.some, singlePredicate, values));
};
$af89174fb098ebf7$var$is.all = (predicate, ...values)=>$af89174fb098ebf7$var$predicateOnArray(Array.prototype.every, predicate, values);
const $af89174fb098ebf7$var$assertType = (condition, description, value, options = {})=>{
    if (!condition) {
        const { multipleValues: multipleValues } = options;
        const valuesMessage = multipleValues ? `received values of types ${[
            ...new Set(value.map((singleValue)=>`\`${$af89174fb098ebf7$var$is(singleValue)}\``))
        ].join(", ")}` : `received value of type \`${$af89174fb098ebf7$var$is(value)}\``;
        throw new TypeError(`Expected value which is \`${description}\`, ${valuesMessage}.`);
    }
};
module.exports.assert = {
    // Unknowns.
    undefined: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.undefined(value), "undefined", value),
    string: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.string(value), "string", value),
    number: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.number(value), "number", value),
    bigint: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.bigint(value), "bigint", value),
    // eslint-disable-next-line @typescript-eslint/ban-types
    function_: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.function_(value), "Function", value),
    null_: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.null_(value), "null", value),
    class_: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.class_(value), "Class" /* class_ */ , value),
    boolean: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.boolean(value), "boolean", value),
    symbol: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.symbol(value), "symbol", value),
    numericString: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.numericString(value), "string with a number" /* numericString */ , value),
    array: (value, assertion)=>{
        const assert = $af89174fb098ebf7$var$assertType;
        assert($af89174fb098ebf7$var$is.array(value), "Array", value);
        if (assertion) value.forEach(assertion);
    },
    buffer: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.buffer(value), "Buffer", value),
    blob: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.blob(value), "Blob", value),
    nullOrUndefined: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.nullOrUndefined(value), "null or undefined" /* nullOrUndefined */ , value),
    object: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.object(value), "Object", value),
    iterable: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.iterable(value), "Iterable" /* iterable */ , value),
    asyncIterable: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.asyncIterable(value), "AsyncIterable" /* asyncIterable */ , value),
    generator: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.generator(value), "Generator", value),
    asyncGenerator: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.asyncGenerator(value), "AsyncGenerator", value),
    nativePromise: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.nativePromise(value), "native Promise" /* nativePromise */ , value),
    promise: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.promise(value), "Promise", value),
    generatorFunction: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.generatorFunction(value), "GeneratorFunction", value),
    asyncGeneratorFunction: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.asyncGeneratorFunction(value), "AsyncGeneratorFunction", value),
    // eslint-disable-next-line @typescript-eslint/ban-types
    asyncFunction: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.asyncFunction(value), "AsyncFunction", value),
    // eslint-disable-next-line @typescript-eslint/ban-types
    boundFunction: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.boundFunction(value), "Function", value),
    regExp: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.regExp(value), "RegExp", value),
    date: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.date(value), "Date", value),
    error: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.error(value), "Error", value),
    map: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.map(value), "Map", value),
    set: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.set(value), "Set", value),
    weakMap: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.weakMap(value), "WeakMap", value),
    weakSet: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.weakSet(value), "WeakSet", value),
    int8Array: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.int8Array(value), "Int8Array", value),
    uint8Array: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.uint8Array(value), "Uint8Array", value),
    uint8ClampedArray: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.uint8ClampedArray(value), "Uint8ClampedArray", value),
    int16Array: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.int16Array(value), "Int16Array", value),
    uint16Array: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.uint16Array(value), "Uint16Array", value),
    int32Array: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.int32Array(value), "Int32Array", value),
    uint32Array: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.uint32Array(value), "Uint32Array", value),
    float32Array: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.float32Array(value), "Float32Array", value),
    float64Array: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.float64Array(value), "Float64Array", value),
    bigInt64Array: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.bigInt64Array(value), "BigInt64Array", value),
    bigUint64Array: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.bigUint64Array(value), "BigUint64Array", value),
    arrayBuffer: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.arrayBuffer(value), "ArrayBuffer", value),
    sharedArrayBuffer: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.sharedArrayBuffer(value), "SharedArrayBuffer", value),
    dataView: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.dataView(value), "DataView", value),
    enumCase: (value, targetEnum)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.enumCase(value, targetEnum), "EnumCase", value),
    urlInstance: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.urlInstance(value), "URL", value),
    urlString: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.urlString(value), "string with a URL" /* urlString */ , value),
    truthy: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.truthy(value), "truthy" /* truthy */ , value),
    falsy: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.falsy(value), "falsy" /* falsy */ , value),
    nan: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.nan(value), "NaN" /* nan */ , value),
    primitive: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.primitive(value), "primitive" /* primitive */ , value),
    integer: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.integer(value), "integer" /* integer */ , value),
    safeInteger: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.safeInteger(value), "integer" /* safeInteger */ , value),
    plainObject: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.plainObject(value), "plain object" /* plainObject */ , value),
    typedArray: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.typedArray(value), "TypedArray" /* typedArray */ , value),
    arrayLike: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.arrayLike(value), "array-like" /* arrayLike */ , value),
    domElement: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.domElement(value), "HTMLElement" /* domElement */ , value),
    observable: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.observable(value), "Observable", value),
    nodeStream: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.nodeStream(value), "Node.js Stream" /* nodeStream */ , value),
    infinite: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.infinite(value), "infinite number" /* infinite */ , value),
    emptyArray: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.emptyArray(value), "empty array" /* emptyArray */ , value),
    nonEmptyArray: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.nonEmptyArray(value), "non-empty array" /* nonEmptyArray */ , value),
    emptyString: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.emptyString(value), "empty string" /* emptyString */ , value),
    emptyStringOrWhitespace: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.emptyStringOrWhitespace(value), "empty string or whitespace" /* emptyStringOrWhitespace */ , value),
    nonEmptyString: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.nonEmptyString(value), "non-empty string" /* nonEmptyString */ , value),
    nonEmptyStringAndNotWhitespace: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.nonEmptyStringAndNotWhitespace(value), "non-empty string and not whitespace" /* nonEmptyStringAndNotWhitespace */ , value),
    emptyObject: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.emptyObject(value), "empty object" /* emptyObject */ , value),
    nonEmptyObject: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.nonEmptyObject(value), "non-empty object" /* nonEmptyObject */ , value),
    emptySet: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.emptySet(value), "empty set" /* emptySet */ , value),
    nonEmptySet: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.nonEmptySet(value), "non-empty set" /* nonEmptySet */ , value),
    emptyMap: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.emptyMap(value), "empty map" /* emptyMap */ , value),
    nonEmptyMap: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.nonEmptyMap(value), "non-empty map" /* nonEmptyMap */ , value),
    propertyKey: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.propertyKey(value), "PropertyKey", value),
    formData: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.formData(value), "FormData", value),
    urlSearchParams: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.urlSearchParams(value), "URLSearchParams", value),
    // Numbers.
    evenInteger: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.evenInteger(value), "even integer" /* evenInteger */ , value),
    oddInteger: (value)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.oddInteger(value), "odd integer" /* oddInteger */ , value),
    // Two arguments.
    directInstanceOf: (instance, class_)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.directInstanceOf(instance, class_), "T" /* directInstanceOf */ , instance),
    inRange: (value, range)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.inRange(value, range), "in range" /* inRange */ , value),
    // Variadic functions.
    any: (predicate, ...values)=>{
        return $af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.any(predicate, ...values), "predicate returns truthy for any value" /* any */ , values, {
            multipleValues: true
        });
    },
    all: (predicate, ...values)=>$af89174fb098ebf7$var$assertType($af89174fb098ebf7$var$is.all(predicate, ...values), "predicate returns truthy for all values" /* all */ , values, {
            multipleValues: true
        })
};
// Some few keywords are reserved, but we'll populate them for Node.js users
// See https://github.com/Microsoft/TypeScript/issues/2536
Object.defineProperties($af89174fb098ebf7$var$is, {
    class: {
        value: $af89174fb098ebf7$var$is.class_
    },
    function: {
        value: $af89174fb098ebf7$var$is.function_
    },
    null: {
        value: $af89174fb098ebf7$var$is.null_
    }
});
Object.defineProperties(module.exports.assert, {
    class: {
        value: module.exports.assert.class_
    },
    function: {
        value: module.exports.assert.function_
    },
    null: {
        value: module.exports.assert.null_
    }
});
module.exports.default = $af89174fb098ebf7$var$is;
// For CommonJS default export support
module.exports = $af89174fb098ebf7$var$is;
module.exports.default = $af89174fb098ebf7$var$is;
module.exports.assert = module.exports.assert;

});




parcelRegister("6RcUP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4fe1b60f0926d99c$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $co9fz = parcelRequire("co9fz");
var $hErV2 = parcelRequire("hErV2");

var $47i9t = parcelRequire("47i9t");

var $eOTWQ = parcelRequire("eOTWQ");

var $kJfnW = parcelRequire("kJfnW");
parcelRequire("eat5C");

var $iKbxs = parcelRequire("iKbxs");

var $iOQGT = parcelRequire("iOQGT");
parcelRequire("eBwNQ");
var $Xm84r = parcelRequire("Xm84r");

var $3H03w = parcelRequire("3H03w");

var $6Q5sp = parcelRequire("6Q5sp");
var $4fe1b60f0926d99c$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ queryIds: queryIds, children: children, loading: loading })=>{
    const { reset: reset } = (0, $hErV2.useQueryErrorResetBoundary)();
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $eOTWQ.ErrorBoundary), {
        onReset: reset,
        fallbackRender: ({ error: error, resetErrorBoundary: resetErrorBoundary })=>{
            $iKbxs.captureException(error);
            (0, $3H03w.default).captureException(error);
            return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                children: [
                    "There was an error!",
                    /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                        className: "btn btn-default",
                        style: {
                            padding: "0.25em 0.5em",
                            marginLeft: "0.5em",
                            fontSize: "0.9em"
                        },
                        onClick: ()=>resetErrorBoundary(),
                        children: "Try again"
                    })
                ]
            });
        },
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jbmdS.Suspense), {
            fallback: loading || /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kJfnW.default), {}),
            children: /*#__PURE__*/ (0, $61Ea1.jsx)($4fe1b60f0926d99c$var$RenderItems, {
                queryIds: queryIds,
                children: children
            }, queryIds)
        })
    });
});
const $4fe1b60f0926d99c$var$RenderItems = (0, $1EEMt.observer)(({ queryIds: queryIds, children: children })=>{
    const queryResults = (0, $co9fz.useQueries)({
        queries: queryIds.map((qId)=>{
            return {
                queryKey: (0, $Xm84r.default)(qId) ? qId : [
                    (qId === null || qId === void 0 ? void 0 : qId.id) || qId
                ],
                queryFn: qId.queryFn ? async ()=>await qId.queryFn() : qId.collection ? async ()=>await (0, $47i9t.default)(qId) : async ()=>await (0, $iOQGT.makeRequest)(qId),
                staleTime: qId.staleTime || 0,
                cacheTime: qId.cacheTime || 0,
                retry: 3
            };
        })
    }, (0, $6Q5sp.queryClient));
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
        children: children
    });
});

});
parcelRegister("co9fz", function(module, exports) {

$parcel$export(module.exports, "useQueries", function () { return $904ee6d055de64f9$export$408667c6c87da1e5; });

var $jbmdS = parcelRequire("jbmdS");

var $7jCK0 = parcelRequire("7jCK0");
var $eaY4X = parcelRequire("eaY4X");

var $lK3dc = parcelRequire("lK3dc");

var $9d62S = parcelRequire("9d62S");

var $1j7JM = parcelRequire("1j7JM");

var $hErV2 = parcelRequire("hErV2");

var $fKh4E = parcelRequire("fKh4E");

var $83bXR = parcelRequire("83bXR");
"use client";
function $904ee6d055de64f9$export$408667c6c87da1e5({ queries: queries, context: context }) {
    const queryClient = (0, $9d62S.useQueryClient)({
        context: context
    });
    const isRestoring = (0, $1j7JM.useIsRestoring)();
    const errorResetBoundary = (0, $hErV2.useQueryErrorResetBoundary)();
    const defaultedQueries = $jbmdS.useMemo(()=>queries.map((options)=>{
            const defaultedOptions = queryClient.defaultQueryOptions(options); // Make sure the results are already in fetching state before subscribing or updating options
            defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
            return defaultedOptions;
        }), [
        queries,
        queryClient,
        isRestoring
    ]);
    defaultedQueries.forEach((query)=>{
        (0, $83bXR.ensureStaleTime)(query);
        (0, $fKh4E.ensurePreventErrorBoundaryRetry)(query, errorResetBoundary);
    });
    (0, $fKh4E.useClearResetErrorBoundary)(errorResetBoundary);
    const [observer] = $jbmdS.useState(()=>new (0, $eaY4X.QueriesObserver)(queryClient, defaultedQueries));
    const optimisticResult = observer.getOptimisticResult(defaultedQueries);
    (0, $lK3dc.useSyncExternalStore)($jbmdS.useCallback((onStoreChange)=>isRestoring ? ()=>undefined : observer.subscribe((0, $7jCK0.notifyManager).batchCalls(onStoreChange)), [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $jbmdS.useEffect(()=>{
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setQueries(defaultedQueries, {
            listeners: false
        });
    }, [
        defaultedQueries,
        observer
    ]);
    const shouldAtLeastOneSuspend = optimisticResult.some((result, index)=>(0, $83bXR.shouldSuspend)(defaultedQueries[index], result, isRestoring));
    const suspensePromises = shouldAtLeastOneSuspend ? optimisticResult.flatMap((result, index)=>{
        const options = defaultedQueries[index];
        const queryObserver = observer.getObservers()[index];
        if (options && queryObserver) {
            if ((0, $83bXR.shouldSuspend)(options, result, isRestoring)) return (0, $83bXR.fetchOptimistic)(options, queryObserver, errorResetBoundary);
            else if ((0, $83bXR.willFetch)(result, isRestoring)) (0, $83bXR.fetchOptimistic)(options, queryObserver, errorResetBoundary);
        }
        return [];
    }) : [];
    if (suspensePromises.length > 0) throw Promise.all(suspensePromises);
    const observerQueries = observer.getQueries();
    const firstSingleResultWhichShouldThrow = optimisticResult.find((result, index)=>{
        var _defaultedQueries$ind, _defaultedQueries$ind2;
        return (0, $fKh4E.getHasError)({
            result: result,
            errorResetBoundary: errorResetBoundary,
            useErrorBoundary: (_defaultedQueries$ind = (_defaultedQueries$ind2 = defaultedQueries[index]) == null ? void 0 : _defaultedQueries$ind2.useErrorBoundary) != null ? _defaultedQueries$ind : false,
            query: observerQueries[index]
        });
    });
    if (firstSingleResultWhichShouldThrow != null && firstSingleResultWhichShouldThrow.error) throw firstSingleResultWhichShouldThrow.error;
    return optimisticResult;
}

});
parcelRegister("eaY4X", function(module, exports) {

$parcel$export(module.exports, "QueriesObserver", function () { return $a5209a44675151d0$export$15352e437905ad4c; });

var $dI9XE = parcelRequire("dI9XE");

var $7jCK0 = parcelRequire("7jCK0");

var $432gx = parcelRequire("432gx");

var $dcJMr = parcelRequire("dcJMr");
class $a5209a44675151d0$export$15352e437905ad4c extends (0, $dcJMr.Subscribable) {
    constructor(client, queries){
        super();
        this.client = client;
        this.queries = [];
        this.result = [];
        this.observers = [];
        this.observersMap = {};
        if (queries) this.setQueries(queries);
    }
    onSubscribe() {
        if (this.listeners.size === 1) this.observers.forEach((observer)=>{
            observer.subscribe((result)=>{
                this.onUpdate(observer, result);
            });
        });
    }
    onUnsubscribe() {
        if (!this.listeners.size) this.destroy();
    }
    destroy() {
        this.listeners = new Set();
        this.observers.forEach((observer)=>{
            observer.destroy();
        });
    }
    setQueries(queries, notifyOptions) {
        this.queries = queries;
        (0, $7jCK0.notifyManager).batch(()=>{
            const prevObservers = this.observers;
            const newObserverMatches = this.findMatchingObservers(this.queries); // set options for the new observers to notify of changes
            newObserverMatches.forEach((match)=>match.observer.setOptions(match.defaultedQueryOptions, notifyOptions));
            const newObservers = newObserverMatches.map((match)=>match.observer);
            const newObserversMap = Object.fromEntries(newObservers.map((observer)=>[
                    observer.options.queryHash,
                    observer
                ]));
            const newResult = newObservers.map((observer)=>observer.getCurrentResult());
            const hasIndexChange = newObservers.some((observer, index)=>observer !== prevObservers[index]);
            if (prevObservers.length === newObservers.length && !hasIndexChange) return;
            this.observers = newObservers;
            this.observersMap = newObserversMap;
            this.result = newResult;
            if (!this.hasListeners()) return;
            (0, $dI9XE.difference)(prevObservers, newObservers).forEach((observer)=>{
                observer.destroy();
            });
            (0, $dI9XE.difference)(newObservers, prevObservers).forEach((observer)=>{
                observer.subscribe((result)=>{
                    this.onUpdate(observer, result);
                });
            });
            this.notify();
        });
    }
    getCurrentResult() {
        return this.result;
    }
    getQueries() {
        return this.observers.map((observer)=>observer.getCurrentQuery());
    }
    getObservers() {
        return this.observers;
    }
    getOptimisticResult(queries) {
        return this.findMatchingObservers(queries).map((match)=>match.observer.getOptimisticResult(match.defaultedQueryOptions));
    }
    findMatchingObservers(queries) {
        const prevObservers = this.observers;
        const prevObserversMap = new Map(prevObservers.map((observer)=>[
                observer.options.queryHash,
                observer
            ]));
        const defaultedQueryOptions = queries.map((options)=>this.client.defaultQueryOptions(options));
        const matchingObservers = defaultedQueryOptions.flatMap((defaultedOptions)=>{
            const match = prevObserversMap.get(defaultedOptions.queryHash);
            if (match != null) return [
                {
                    defaultedQueryOptions: defaultedOptions,
                    observer: match
                }
            ];
            return [];
        });
        const matchedQueryHashes = new Set(matchingObservers.map((match)=>match.defaultedQueryOptions.queryHash));
        const unmatchedQueries = defaultedQueryOptions.filter((defaultedOptions)=>!matchedQueryHashes.has(defaultedOptions.queryHash));
        const matchingObserversSet = new Set(matchingObservers.map((match)=>match.observer));
        const unmatchedObservers = prevObservers.filter((prevObserver)=>!matchingObserversSet.has(prevObserver));
        const getObserver = (options)=>{
            const defaultedOptions = this.client.defaultQueryOptions(options);
            const currentObserver = this.observersMap[defaultedOptions.queryHash];
            return currentObserver != null ? currentObserver : new (0, $432gx.QueryObserver)(this.client, defaultedOptions);
        };
        const newOrReusedObservers = unmatchedQueries.map((options, index)=>{
            if (options.keepPreviousData) {
                // return previous data from one of the observers that no longer match
                const previouslyUsedObserver = unmatchedObservers[index];
                if (previouslyUsedObserver !== undefined) return {
                    defaultedQueryOptions: options,
                    observer: previouslyUsedObserver
                };
            }
            return {
                defaultedQueryOptions: options,
                observer: getObserver(options)
            };
        });
        const sortMatchesByOrderOfQueries = (a, b)=>defaultedQueryOptions.indexOf(a.defaultedQueryOptions) - defaultedQueryOptions.indexOf(b.defaultedQueryOptions);
        return matchingObservers.concat(newOrReusedObservers).sort(sortMatchesByOrderOfQueries);
    }
    onUpdate(observer, result) {
        const index = this.observers.indexOf(observer);
        if (index !== -1) {
            this.result = (0, $dI9XE.replaceAt)(this.result, index, result);
            this.notify();
        }
    }
    notify() {
        (0, $7jCK0.notifyManager).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(this.result);
            });
        });
    }
}

});
parcelRegister("432gx", function(module, exports) {

$parcel$export(module.exports, "QueryObserver", function () { return $2f293327b3788040$export$a06cf8c0066f0d4c; });

var $dI9XE = parcelRequire("dI9XE");

var $7jCK0 = parcelRequire("7jCK0");

var $6IjPu = parcelRequire("6IjPu");

var $dcJMr = parcelRequire("dcJMr");

var $4ntlP = parcelRequire("4ntlP");
class $2f293327b3788040$export$a06cf8c0066f0d4c extends (0, $dcJMr.Subscribable) {
    constructor(client, options){
        super();
        this.client = client;
        this.options = options;
        this.trackedProps = new Set();
        this.selectError = null;
        this.bindMethods();
        this.setOptions(options);
    }
    bindMethods() {
        this.remove = this.remove.bind(this);
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            this.currentQuery.addObserver(this);
            if ($2f293327b3788040$var$shouldFetchOnMount(this.currentQuery, this.options)) this.executeFetch();
            this.updateTimers();
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $2f293327b3788040$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $2f293327b3788040$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = new Set();
        this.clearStaleTimeout();
        this.clearRefetchInterval();
        this.currentQuery.removeObserver(this);
    }
    setOptions(options, notifyOptions) {
        const prevOptions = this.options;
        const prevQuery = this.currentQuery;
        this.options = this.client.defaultQueryOptions(options);
        if (!(0, $dI9XE.shallowEqualObjects)(prevOptions, this.options)) this.client.getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: this.currentQuery,
            observer: this
        });
        if (typeof this.options.enabled !== "undefined" && typeof this.options.enabled !== "boolean") throw new Error("Expected enabled to be a boolean");
         // Keep previous query key if the user does not supply one
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        this.updateQuery();
        const mounted = this.hasListeners(); // Fetch if there are subscribers
        if (mounted && $2f293327b3788040$var$shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) this.executeFetch();
         // Update result
        this.updateResult(notifyOptions); // Update stale interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) this.updateStaleTimeout();
        const nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) this.updateRefetchInterval(nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = this.client.getQueryCache().build(this.client, options);
        const result = this.createResult(query, options);
        if ($2f293327b3788040$var$shouldAssignObserverCurrentProperties(this, result, options)) {
            // this assigns the optimistic result to the current Observer
            // because if the query function changes, useQuery will be performing
            // an effect where it would fetch again.
            // When the fetch finishes, we perform a deep data cloning in order
            // to reuse objects references. This deep data clone is performed against
            // the `observer.currentResult.data` property
            // When QueryKey changes, we refresh the query and get new `optimistic`
            // result, while we leave the `observer.currentResult`, so when new data
            // arrives, it finds the old `observer.currentResult` which is related
            // to the old QueryKey. Which means that currentResult and selectData are
            // out of sync already.
            // To solve this, we move the cursor of the currentResult everytime
            // an observer reads an optimistic value.
            // When keeping the previous data, the result doesn't change until new
            // data arrives.
            this.currentResult = result;
            this.currentResultOptions = this.options;
            this.currentResultState = this.currentQuery.state;
        }
        return result;
    }
    getCurrentResult() {
        return this.currentResult;
    }
    trackResult(result) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    this.trackedProps.add(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    getCurrentQuery() {
        return this.currentQuery;
    }
    remove() {
        this.client.getQueryCache().remove(this.currentQuery);
    }
    refetch({ refetchPage: refetchPage, ...options } = {}) {
        return this.fetch({
            ...options,
            meta: {
                refetchPage: refetchPage
            }
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = this.client.defaultQueryOptions(options);
        const query = this.client.getQueryCache().build(this.client, defaultedOptions);
        query.isFetchingOptimistic = true;
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        var _fetchOptions$cancelR;
        return this.executeFetch({
            ...fetchOptions,
            cancelRefetch: (_fetchOptions$cancelR = fetchOptions.cancelRefetch) != null ? _fetchOptions$cancelR : true
        }).then(()=>{
            this.updateResult();
            return this.currentResult;
        });
    }
    executeFetch(fetchOptions) {
        // Make sure we reference the latest query as the current one might have been removed
        this.updateQuery(); // Fetch
        let promise = this.currentQuery.fetch(this.options, fetchOptions);
        if (!(fetchOptions != null && fetchOptions.throwOnError)) promise = promise.catch((0, $dI9XE.noop));
        return promise;
    }
    updateStaleTimeout() {
        this.clearStaleTimeout();
        if ((0, $dI9XE.isServer) || this.currentResult.isStale || !(0, $dI9XE.isValidTimeout)(this.options.staleTime)) return;
        const time = (0, $dI9XE.timeUntilStale)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
        // To mitigate this issue we always add 1 ms to the timeout.
        const timeout = time + 1;
        this.staleTimeoutId = setTimeout(()=>{
            if (!this.currentResult.isStale) this.updateResult();
        }, timeout);
    }
    computeRefetchInterval() {
        var _this$options$refetch;
        return typeof this.options.refetchInterval === "function" ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
    }
    updateRefetchInterval(nextInterval) {
        this.clearRefetchInterval();
        this.currentRefetchInterval = nextInterval;
        if ((0, $dI9XE.isServer) || this.options.enabled === false || !(0, $dI9XE.isValidTimeout)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) return;
        this.refetchIntervalId = setInterval(()=>{
            if (this.options.refetchIntervalInBackground || (0, $6IjPu.focusManager).isFocused()) this.executeFetch();
        }, this.currentRefetchInterval);
    }
    updateTimers() {
        this.updateStaleTimeout();
        this.updateRefetchInterval(this.computeRefetchInterval());
    }
    clearStaleTimeout() {
        if (this.staleTimeoutId) {
            clearTimeout(this.staleTimeoutId);
            this.staleTimeoutId = undefined;
        }
    }
    clearRefetchInterval() {
        if (this.refetchIntervalId) {
            clearInterval(this.refetchIntervalId);
            this.refetchIntervalId = undefined;
        }
    }
    createResult(query, options) {
        const prevQuery = this.currentQuery;
        const prevOptions = this.options;
        const prevResult = this.currentResult;
        const prevResultState = this.currentResultState;
        const prevResultOptions = this.currentResultOptions;
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
        const prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
        const { state: state } = query;
        let { dataUpdatedAt: dataUpdatedAt, error: error, errorUpdatedAt: errorUpdatedAt, fetchStatus: fetchStatus, status: status } = state;
        let isPreviousData = false;
        let isPlaceholderData = false;
        let data; // Optimistically set result in fetching state if needed
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $2f293327b3788040$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $2f293327b3788040$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                fetchStatus = (0, $4ntlP.canFetch)(query.options.networkMode) ? "fetching" : "paused";
                if (!dataUpdatedAt) status = "loading";
            }
            if (options._optimisticResults === "isRestoring") fetchStatus = "idle";
        } // Keep previous data if needed
        if (options.keepPreviousData && !state.dataUpdatedAt && prevQueryResult != null && prevQueryResult.isSuccess && status !== "error") {
            data = prevQueryResult.data;
            dataUpdatedAt = prevQueryResult.dataUpdatedAt;
            status = prevQueryResult.status;
            isPreviousData = true;
        } else if (options.select && typeof state.data !== "undefined") {
            // Memoize select result
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) data = this.selectResult;
            else try {
                this.selectFn = options.select;
                data = options.select(state.data);
                data = (0, $dI9XE.replaceData)(prevResult == null ? void 0 : prevResult.data, data, options);
                this.selectResult = data;
                this.selectError = null;
            } catch (selectError) {
                this.selectError = selectError;
            }
        } else data = state.data;
         // Show placeholder data if needed
        if (typeof options.placeholderData !== "undefined" && typeof data === "undefined" && status === "loading") {
            let placeholderData; // Memoize placeholder data
            if (prevResult != null && prevResult.isPlaceholderData && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData() : options.placeholderData;
                if (options.select && typeof placeholderData !== "undefined") try {
                    placeholderData = options.select(placeholderData);
                    this.selectError = null;
                } catch (selectError) {
                    this.selectError = selectError;
                }
            }
            if (typeof placeholderData !== "undefined") {
                status = "success";
                data = (0, $dI9XE.replaceData)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (this.selectError) {
            error = this.selectError;
            data = this.selectResult;
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = fetchStatus === "fetching";
        const isLoading = status === "loading";
        const isError = status === "error";
        const result = {
            status: status,
            fetchStatus: fetchStatus,
            isLoading: isLoading,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading && isFetching,
            data: data,
            dataUpdatedAt: dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            failureReason: state.fetchFailureReason,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isLoading,
            isLoadingError: isError && state.dataUpdatedAt === 0,
            isPaused: fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isPreviousData: isPreviousData,
            isRefetchError: isError && state.dataUpdatedAt !== 0,
            isStale: $2f293327b3788040$var$isStale(query, options),
            refetch: this.refetch,
            remove: this.remove
        };
        return result;
    }
    updateResult(notifyOptions) {
        const prevResult = this.currentResult;
        const nextResult = this.createResult(this.currentQuery, this.options);
        this.currentResultState = this.currentQuery.state;
        this.currentResultOptions = this.options; // Only notify and update result if something has changed
        if ((0, $dI9XE.shallowEqualObjects)(nextResult, prevResult)) return;
        this.currentResult = nextResult; // Determine which callbacks to trigger
        const defaultNotifyOptions = {
            cache: true
        };
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !this.trackedProps.size) return true;
            const includedProps = new Set(notifyOnChangePropsValue != null ? notifyOnChangePropsValue : this.trackedProps);
            if (this.options.useErrorBoundary) includedProps.add("error");
            return Object.keys(this.currentResult).some((key)=>{
                const typedKey = key;
                const changed = this.currentResult[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) defaultNotifyOptions.listeners = true;
        this.notify({
            ...defaultNotifyOptions,
            ...notifyOptions
        });
    }
    updateQuery() {
        const query = this.client.getQueryCache().build(this.client, this.options);
        if (query === this.currentQuery) return;
        const prevQuery = this.currentQuery;
        this.currentQuery = query;
        this.currentQueryInitialState = query.state;
        this.previousQueryResult = this.currentResult;
        if (this.hasListeners()) {
            prevQuery == null || prevQuery.removeObserver(this);
            query.addObserver(this);
        }
    }
    onQueryUpdate(action) {
        const notifyOptions = {};
        if (action.type === "success") notifyOptions.onSuccess = !action.manual;
        else if (action.type === "error" && !(0, $4ntlP.isCancelledError)(action.error)) notifyOptions.onError = true;
        this.updateResult(notifyOptions);
        if (this.hasListeners()) this.updateTimers();
    }
    notify(notifyOptions) {
        (0, $7jCK0.notifyManager).batch(()=>{
            // First trigger the configuration callbacks
            if (notifyOptions.onSuccess) {
                var _this$options$onSucce, _this$options, _this$options$onSettl, _this$options2;
                (_this$options$onSucce = (_this$options = this.options).onSuccess) == null || _this$options$onSucce.call(_this$options, this.currentResult.data);
                (_this$options$onSettl = (_this$options2 = this.options).onSettled) == null || _this$options$onSettl.call(_this$options2, this.currentResult.data, null);
            } else if (notifyOptions.onError) {
                var _this$options$onError, _this$options3, _this$options$onSettl2, _this$options4;
                (_this$options$onError = (_this$options3 = this.options).onError) == null || _this$options$onError.call(_this$options3, this.currentResult.error);
                (_this$options$onSettl2 = (_this$options4 = this.options).onSettled) == null || _this$options$onSettl2.call(_this$options4, undefined, this.currentResult.error);
            } // Then trigger the listeners
            if (notifyOptions.listeners) this.listeners.forEach(({ listener: listener })=>{
                listener(this.currentResult);
            });
             // Then the cache listeners
            if (notifyOptions.cache) this.client.getQueryCache().notify({
                query: this.currentQuery,
                type: "observerResultsUpdated"
            });
        });
    }
}
function $2f293327b3788040$var$shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === "error" && options.retryOnMount === false);
}
function $2f293327b3788040$var$shouldFetchOnMount(query, options) {
    return $2f293327b3788040$var$shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && $2f293327b3788040$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $2f293327b3788040$var$shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $2f293327b3788040$var$isStale(query, options);
    }
    return false;
}
function $2f293327b3788040$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== "error") && $2f293327b3788040$var$isStale(query, options);
}
function $2f293327b3788040$var$isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
} // this function would decide if we will update the observer's 'current'
// properties after an optimistic reading via getOptimisticResult
function $2f293327b3788040$var$shouldAssignObserverCurrentProperties(observer, optimisticResult, options) {
    // it is important to keep this condition like this for three reasons:
    // 1. It will get removed in the v5
    // 2. it reads: don't update the properties if we want to keep the previous
    // data.
    // 3. The opposite condition (!options.keepPreviousData) would fallthrough
    // and will result in a bad decision
    if (options.keepPreviousData) return false;
     // this means we want to put some placeholder data when pending and queryKey
    // changed.
    if (options.placeholderData !== undefined) // re-assign properties only if current data is placeholder data
    // which means that data did not arrive yet, so, if there is some cached data
    // we need to "prepare" to receive it
    return optimisticResult.isPlaceholderData;
     // if the newly created result isn't what the observer is holding as current,
    // then we'll need to update the properties as well
    if (!(0, $dI9XE.shallowEqualObjects)(observer.getCurrentResult(), optimisticResult)) return true;
     // basically, just keep previous properties if nothing changed
    return false;
}

});


parcelRegister("lK3dc", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $fd4062a5f0047a24$export$306c0aa65ff9ec16; });

var $bUdUR = parcelRequire("bUdUR");
"use client";
const $fd4062a5f0047a24$export$306c0aa65ff9ec16 = (0, $bUdUR.useSyncExternalStore);

});
parcelRegister("bUdUR", function(module, exports) {
"use strict";

module.exports = (parcelRequire("9TTgH"));

});
parcelRegister("9TTgH", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $73541f45c6681907$export$306c0aa65ff9ec16; }, function (v) { return $73541f45c6681907$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $73541f45c6681907$export$306c0aa65ff9ec16;
"use strict";

var $jbmdS = parcelRequire("jbmdS");
function $73541f45c6681907$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $73541f45c6681907$var$k = "function" === typeof Object.is ? Object.is : $73541f45c6681907$var$h, $73541f45c6681907$var$l = $jbmdS.useState, $73541f45c6681907$var$m = $jbmdS.useEffect, $73541f45c6681907$var$n = $jbmdS.useLayoutEffect, $73541f45c6681907$var$p = $jbmdS.useDebugValue;
function $73541f45c6681907$var$q(a, b) {
    var d = b(), f = $73541f45c6681907$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $73541f45c6681907$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $73541f45c6681907$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $73541f45c6681907$var$m(function() {
        $73541f45c6681907$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $73541f45c6681907$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $73541f45c6681907$var$p(d);
    return d;
}
function $73541f45c6681907$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$73541f45c6681907$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $73541f45c6681907$var$t(a, b) {
    return b();
}
var $73541f45c6681907$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $73541f45c6681907$var$t : $73541f45c6681907$var$q;
$73541f45c6681907$export$306c0aa65ff9ec16 = void 0 !== $jbmdS.useSyncExternalStore ? $jbmdS.useSyncExternalStore : $73541f45c6681907$var$u;

});



parcelRegister("1j7JM", function(module, exports) {

$parcel$export(module.exports, "useIsRestoring", function () { return $0f3d9148d2fd2fe5$export$4da0178d6b5f553; });

var $jbmdS = parcelRequire("jbmdS");
"use client";
const $0f3d9148d2fd2fe5$var$IsRestoringContext = /*#__PURE__*/ $jbmdS.createContext(false);
const $0f3d9148d2fd2fe5$export$4da0178d6b5f553 = ()=>$jbmdS.useContext($0f3d9148d2fd2fe5$var$IsRestoringContext);
const $0f3d9148d2fd2fe5$export$593807d4e94f9621 = $0f3d9148d2fd2fe5$var$IsRestoringContext.Provider;

});

parcelRegister("hErV2", function(module, exports) {

$parcel$export(module.exports, "useQueryErrorResetBoundary", function () { return $cd9bd43902c56518$export$50dfac555130cafd; });

var $jbmdS = parcelRequire("jbmdS");
"use client";
function $cd9bd43902c56518$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
const $cd9bd43902c56518$var$QueryErrorResetBoundaryContext = /*#__PURE__*/ $jbmdS.createContext($cd9bd43902c56518$var$createValue()); // HOOK
const $cd9bd43902c56518$export$50dfac555130cafd = ()=>$jbmdS.useContext($cd9bd43902c56518$var$QueryErrorResetBoundaryContext); // COMPONENT
const $cd9bd43902c56518$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $jbmdS.useState(()=>$cd9bd43902c56518$var$createValue());
    return /*#__PURE__*/ $jbmdS.createElement($cd9bd43902c56518$var$QueryErrorResetBoundaryContext.Provider, {
        value: value
    }, typeof children === "function" ? children(value) : children);
};

});

parcelRegister("fKh4E", function(module, exports) {

$parcel$export(module.exports, "ensurePreventErrorBoundaryRetry", function () { return $b768656c297707f2$export$ae8adb3de3d77633; });
$parcel$export(module.exports, "useClearResetErrorBoundary", function () { return $b768656c297707f2$export$b2b17ca3a1fb0229; });
$parcel$export(module.exports, "getHasError", function () { return $b768656c297707f2$export$1fbcf724762d607; });

var $jbmdS = parcelRequire("jbmdS");

var $97JdE = parcelRequire("97JdE");
"use client";
const $b768656c297707f2$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.useErrorBoundary) // Prevent retrying failed query if the error boundary has not been reset yet
    {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
const $b768656c297707f2$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $jbmdS.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
const $b768656c297707f2$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, useErrorBoundary: useErrorBoundary, query: query })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, $97JdE.shouldThrowError)(useErrorBoundary, [
        result.error,
        query
    ]);
};

});
parcelRegister("97JdE", function(module, exports) {

$parcel$export(module.exports, "shouldThrowError", function () { return $01b6d610ee7ec516$export$2072f68e6c3507cf; });
function $01b6d610ee7ec516$export$2072f68e6c3507cf(_useErrorBoundary, params) {
    // Allow useErrorBoundary function to override throwing behavior on a per-error basis
    if (typeof _useErrorBoundary === "function") return _useErrorBoundary(...params);
    return !!_useErrorBoundary;
}

});


parcelRegister("83bXR", function(module, exports) {

$parcel$export(module.exports, "ensureStaleTime", function () { return $5dc7e2770fe24145$export$2c40a591ad2dafb1; });
$parcel$export(module.exports, "willFetch", function () { return $5dc7e2770fe24145$export$e0a3f29513afe430; });
$parcel$export(module.exports, "shouldSuspend", function () { return $5dc7e2770fe24145$export$88d3586dfed64df9; });
$parcel$export(module.exports, "fetchOptimistic", function () { return $5dc7e2770fe24145$export$defdc11a9c9acfcf; });
const $5dc7e2770fe24145$export$2c40a591ad2dafb1 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    {
        if (typeof defaultedOptions.staleTime !== "number") defaultedOptions.staleTime = 1000;
    }
};
const $5dc7e2770fe24145$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
const $5dc7e2770fe24145$export$88d3586dfed64df9 = (defaultedOptions, result, isRestoring)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && $5dc7e2770fe24145$export$e0a3f29513afe430(result, isRestoring);
const $5dc7e2770fe24145$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).then(({ data: data })=>{
        defaultedOptions.onSuccess == null || defaultedOptions.onSuccess(data);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(data, null);
    }).catch((error)=>{
        errorResetBoundary.clearReset();
        defaultedOptions.onError == null || defaultedOptions.onError(error);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(undefined, error);
    });

});


parcelRegister("47i9t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ff5e56c6e67c774$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "processTRPCData", function () { return $2ff5e56c6e67c774$export$93e54950f4ca4b28; });

var $iOQGT = parcelRequire("iOQGT");

var $7Vift = parcelRequire("7Vift");

var $1BTI2 = parcelRequire("1BTI2");
parcelRequire("eat5C");

var $6un1H = parcelRequire("6un1H");

var $8kZ1o = parcelRequire("8kZ1o");

var $iKbxs = parcelRequire("iKbxs");

var $3H03w = parcelRequire("3H03w");
var $2ff5e56c6e67c774$export$2e2bcd8739ae039 = async ({ collection: collection, ids: ids = [], fields: fields = [], filters: filters = [], groupBy: groupBy = [], chain: chain = [], sortBy: sortBy = [], limit: limit = null, subQueries: subQueries = [], id: id = null, data: data = {} } = {})=>{
    if (!collection) console.trace();
    let response = {};
    if ((0, $1BTI2.default).user) {
        chain = chain.map((c)=>{
            var _c$filters;
            return {
                ...c,
                filters: [
                    ...(_c$filters = c.filters) !== null && _c$filters !== void 0 ? _c$filters : [],
                    ...(0, $8kZ1o.getQueryPermissionFilters)(c.collection, (0, $1BTI2.default).user)
                ]
            };
        });
        subQueries = subQueries.map((sq)=>{
            var _sq$filters;
            return {
                ...sq,
                filters: [
                    ...(_sq$filters = sq.filters) !== null && _sq$filters !== void 0 ? _sq$filters : [],
                    ...(0, $8kZ1o.getQueryPermissionFilters)(sq.collection, (0, $1BTI2.default).user)
                ]
            };
        });
        response = [
            await (0, $iOQGT.makeRequest)({
                path: `api/v1.5/fetch/${collection}`,
                method: "post",
                data: {
                    collection: collection,
                    fields: [
                        ...fields
                    ],
                    //_.intersection(fields, fieldPermissions[level]),
                    filters: [
                        ...filters,
                        ...(0, $8kZ1o.getQueryPermissionFilters)(collection, (0, $1BTI2.default).user)
                    ],
                    groupBy: [
                        ...groupBy
                    ],
                    chain: [
                        ...chain
                    ],
                    sortBy: [
                        ...sortBy
                    ],
                    limit: limit,
                    subQueries: [
                        ...subQueries
                    ],
                    ...data
                }
            })
        ];
        let models = {};
        response.forEach((r)=>{
            Object.entries(r.data).forEach(([rCollection, modelsData])=>{
                var _r$data$labels;
                if (rCollection === "labels") return;
                rCollection = ((_r$data$labels = r.data.labels) === null || _r$data$labels === void 0 ? void 0 : _r$data$labels[rCollection]) || rCollection;
                try {
                    let model;
                    if (!(groupBy.length && collection === rCollection)) {
                        var _rCollection, _models$_rCollection;
                        model = (0, $7Vift.CollectionLookup)[rCollection].addMany(modelsData, {
                            trackUpdates: false
                        });
                        (_models$_rCollection = models[_rCollection = rCollection]) !== null && _models$_rCollection !== void 0 ? _models$_rCollection : models[_rCollection] = new (0, $7Vift.CollectionClassLookup)[rCollection]();
                        models[rCollection].addMany(modelsData, {
                            trackUpdates: false
                        });
                    } else {
                        var _rCollection2, _models$_rCollection2;
                        model = (0, $7Vift.AggregateCollectionLookup)[rCollection].addMany(groupBy, modelsData, {
                            trackUpdates: false
                        });
                        (_models$_rCollection2 = models[_rCollection2 = rCollection]) !== null && _models$_rCollection2 !== void 0 ? _models$_rCollection2 : models[_rCollection2] = new (0, $7Vift.AggregateCollectionClassLookup)[rCollection]();
                        models[rCollection].addMany(modelsData, {
                            trackUpdates: false
                        });
                    }
                } catch (e) {
                    $iKbxs.captureException(e);
                    (0, $3H03w.default).captureException(e);
                    console.error(e);
                    throw e;
                }
            });
        });
        if (id) (0, $6un1H.default).setResponse(id, models);
        return models;
    } else {
        response = await (0, $iOQGT.makeRequest)({
            path: `api/v1.5/fetch/${collection}`,
            method: "post",
            data: {
                collection: collection,
                ids: [
                    ...ids
                ],
                fields: [
                    ...fields
                ],
                filters: [
                    ...filters
                ],
                groupBy: [
                    ...groupBy
                ],
                chain: [
                    ...chain
                ],
                sortBy: [
                    ...sortBy
                ],
                limit: limit,
                subQueries: [
                    ...subQueries
                ]
            }
        });
        let models = {};
        Object.entries(response.data).forEach(([rCollection, modelsData])=>{
            var _response$data$labels, _rCollection3, _models$_rCollection3;
            if (rCollection === "labels") return;
            rCollection = ((_response$data$labels = response.data.labels) === null || _response$data$labels === void 0 ? void 0 : _response$data$labels[rCollection]) || rCollection;
            (_models$_rCollection3 = models[_rCollection3 = rCollection]) !== null && _models$_rCollection3 !== void 0 ? _models$_rCollection3 : models[_rCollection3] = [];
            try {
                let model;
                if (!(groupBy.length && collection === rCollection)) model = (0, $7Vift.CollectionLookup)[rCollection].addMany(modelsData, {
                    trackUpdates: false
                });
                else model = (0, $7Vift.AggregateCollectionLookup)[rCollection].addMany(groupBy, modelsData, {
                    trackUpdates: false
                });
                models[rCollection].push(...model);
            } catch (e) {
                $iKbxs.captureException(e);
                (0, $3H03w.default).captureException(e);
                console.error(e);
                throw e;
            }
        });
        if (id) (0, $6un1H.default).setResponse(id, models);
        return models;
    }
};
const $2ff5e56c6e67c774$export$93e54950f4ca4b28 = (data, id = null)=>{
    if (!data) {
        console.error("processTRPCData received null or undefined data");
        return {};
    }
    const models = {};
    let returnRawData = true;
    Object.entries(data).forEach(([collectionName, modelsData])=>{
        if (!modelsData || collectionName === "labels") return;
        // Determine the correct collection name (handling potential aliases if needed in future)
        const rCollection = collectionName; // Simple mapping for now
        if (!(0, $7Vift.CollectionLookup)[rCollection] && !(0, $7Vift.AggregateCollectionLookup)[rCollection]) return; // Skip if no corresponding store
        try {
            // Check if this collection should be treated as aggregated (based on name or structure if needed)
            // For now, assuming all data from getAppData is non-aggregated
            const isAggregated = false; // Adjust if getAppData returns aggregated formats
            if (!isAggregated) {
                if ((0, $7Vift.CollectionLookup)[rCollection]) {
                    var _models$rCollection;
                    (0, $7Vift.CollectionLookup)[rCollection].addMany(modelsData, {
                        trackUpdates: false
                    });
                    (_models$rCollection = models[rCollection]) !== null && _models$rCollection !== void 0 ? _models$rCollection : models[rCollection] = new (0, $7Vift.CollectionClassLookup)[rCollection]();
                    // Ensure modelsData is an array before calling addMany
                    const dataArray = Array.isArray(modelsData) ? modelsData : modelsData ? [
                        modelsData
                    ] : [];
                    models[rCollection].addMany(dataArray, {
                        trackUpdates: false
                    });
                    returnRawData = false;
                } else console.warn(`CollectionLookup[${rCollection}] not found, but not aggregated.`);
            } else // Handle aggregated data if necessary (requires groupBy info)
            // This part is complex as groupBy info isn't directly in getAppData response
            // Might need to refactor or avoid using this function for aggregated data initially
            console.warn(`Processing aggregated data for ${rCollection} not fully implemented in processTRPCData yet.`);
        } catch (e) {
            $iKbxs.captureException(e);
            (0, $3H03w.default).captureException(e);
            console.error(`Error processing collection ${rCollection} in processTRPCData:`, e);
        // Decide if we should throw or just log and continue
        }
    });
    // Optionally, could set response in FetchStore if needed, but maybe not necessary
    if (id) (0, $6un1H.default).setResponse(id, returnRawData ? data : {
        ...data || {},
        ...models
    });
    return returnRawData ? data : {
        ...data || {},
        ...models
    };
};
function $2ff5e56c6e67c774$var$timeout(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}

});
parcelRegister("7Vift", function(module, exports) {

$parcel$export(module.exports, "collections", function () { return $5c4c03095d6bf370$export$167de583c0ce0e55; });
$parcel$export(module.exports, "aggregateCollections", function () { return $5c4c03095d6bf370$export$3ffbf194efc035e2; });
$parcel$export(module.exports, "CollectionLookup", function () { return $5c4c03095d6bf370$export$2bd3f057a523cb29; });
$parcel$export(module.exports, "AggregateCollectionLookup", function () { return $5c4c03095d6bf370$export$90240c993c78249f; });
$parcel$export(module.exports, "autoSaveCollections", function () { return $5c4c03095d6bf370$export$6fdabe77c101832f; });
$parcel$export(module.exports, "collectionClasses", function () { return $5c4c03095d6bf370$export$514460938402b9ab; });
$parcel$export(module.exports, "aggregateCollectionClasses", function () { return $5c4c03095d6bf370$export$b45a5f62da66feff; });
$parcel$export(module.exports, "CollectionClassLookup", function () { return $5c4c03095d6bf370$export$1c068831c12f7c9a; });
$parcel$export(module.exports, "AggregateCollectionClassLookup", function () { return $5c4c03095d6bf370$export$873db4a93360f506; });

var $bhvQG = parcelRequire("bhvQG");

var $eNcHX = parcelRequire("eNcHX");

var $2Zzii = parcelRequire("2Zzii");

var $9VnJj = parcelRequire("9VnJj");

var $jg8jZ = parcelRequire("jg8jZ");

var $huUQP = parcelRequire("huUQP");

var $fFfyp = parcelRequire("fFfyp");

var $XoImS = parcelRequire("XoImS");

var $gJT7h = parcelRequire("gJT7h");

var $cxnwP = parcelRequire("cxnwP");

var $lu0ti = parcelRequire("lu0ti");

var $3PAB5 = parcelRequire("3PAB5");

var $8XaFv = parcelRequire("8XaFv");

var $i0HPj = parcelRequire("i0HPj");

var $h6zQv = parcelRequire("h6zQv");

var $1UDCR = parcelRequire("1UDCR");

var $d4jhX = parcelRequire("d4jhX");

var $evRPQ = parcelRequire("evRPQ");

var $avf6p = parcelRequire("avf6p");

var $4iwZm = parcelRequire("4iwZm");

var $1k348 = parcelRequire("1k348");

var $64hVI = parcelRequire("64hVI");

var $bxXv3 = parcelRequire("bxXv3");

var $dtlWt = parcelRequire("dtlWt");

var $htkeB = parcelRequire("htkeB");

var $kb7bz = parcelRequire("kb7bz");

var $keGWP = parcelRequire("keGWP");

var $5JL5P = parcelRequire("5JL5P");

var $QiMYe = parcelRequire("QiMYe");

var $cfp1m = parcelRequire("cfp1m");

var $hSUCJ = parcelRequire("hSUCJ");

var $jc1Yz = parcelRequire("jc1Yz");

var $gkMXq = parcelRequire("gkMXq");

var $kRqe9 = parcelRequire("kRqe9");

var $4tYKG = parcelRequire("4tYKG");

var $ermXU = parcelRequire("ermXU");

var $jYjJH = parcelRequire("jYjJH");

var $cTdgh = parcelRequire("cTdgh");

var $8yVxd = parcelRequire("8yVxd");

var $3AXgX = parcelRequire("3AXgX");

var $aJ9vI = parcelRequire("aJ9vI");

var $816ZB = parcelRequire("816ZB");

var $kuXqZ = parcelRequire("kuXqZ");

var $8qPFs = parcelRequire("8qPFs");

var $9eute = parcelRequire("9eute");

var $4oQMK = parcelRequire("4oQMK");

var $3gI5O = parcelRequire("3gI5O");

var $6920Q = parcelRequire("6920Q");

var $5o9Ld = parcelRequire("5o9Ld");

var $liJtZ = parcelRequire("liJtZ");
const $5c4c03095d6bf370$export$167de583c0ce0e55 = [
    (0, $hSUCJ.default),
    (0, $gkMXq.default),
    (0, $bhvQG.default),
    (0, $eNcHX.default),
    (0, $2Zzii.default),
    (0, $9VnJj.default),
    (0, $jg8jZ.default),
    (0, $huUQP.default),
    (0, $fFfyp.default),
    (0, $cxnwP.default),
    (0, $kRqe9.default),
    (0, $lu0ti.default),
    (0, $3PAB5.default),
    (0, $8XaFv.default),
    (0, $i0HPj.default),
    (0, $h6zQv.default),
    (0, $1UDCR.default),
    (0, $XoImS.default),
    (0, $gJT7h.default),
    (0, $cfp1m.default),
    (0, $d4jhX.default),
    (0, $evRPQ.default),
    (0, $jc1Yz.default),
    (0, $avf6p.default),
    (0, $4iwZm.default),
    (0, $1k348.default),
    (0, $64hVI.default),
    (0, $bxXv3.default),
    (0, $dtlWt.default),
    (0, $htkeB.default),
    (0, $kb7bz.default),
    (0, $keGWP.default),
    (0, $5JL5P.default),
    (0, $QiMYe.default),
    (0, $liJtZ.default),
    (0, $8qPFs.default),
    (0, $9eute.default),
    (0, $4oQMK.default),
    (0, $3gI5O.default),
    (0, $6920Q.default),
    (0, $5o9Ld.default)
];
const $5c4c03095d6bf370$export$3ffbf194efc035e2 = [
    (0, $4tYKG.default),
    (0, $ermXU.default),
    (0, $jYjJH.default),
    (0, $cTdgh.default),
    (0, $8yVxd.default),
    (0, $3AXgX.default),
    (0, $aJ9vI.default),
    (0, $816ZB.default),
    (0, $kuXqZ.default)
];
const $5c4c03095d6bf370$export$2bd3f057a523cb29 = Object.fromEntries([
    ...$5c4c03095d6bf370$export$167de583c0ce0e55.map((c)=>[
            c.collection,
            c
        ]),
    [
        "staffMembers",
        (0, $htkeB.default)
    ],
    [
        "staffs",
        (0, $htkeB.default)
    ]
]);
const $5c4c03095d6bf370$export$90240c993c78249f = Object.fromEntries($5c4c03095d6bf370$export$3ffbf194efc035e2.map((c)=>[
        c.collection,
        c
    ]));
const $5c4c03095d6bf370$export$6fdabe77c101832f = [
    (0, $hSUCJ.default),
    (0, $gkMXq.default),
    (0, $bhvQG.default),
    (0, $eNcHX.default),
    (0, $2Zzii.default),
    (0, $9VnJj.default),
    (0, $jg8jZ.default),
    (0, $huUQP.default),
    (0, $fFfyp.default),
    (0, $cxnwP.default),
    (0, $kRqe9.default),
    (0, $lu0ti.default),
    (0, $3PAB5.default),
    (0, $8XaFv.default),
    // OrganisationSubscriptionCollection,
    // ReportCollection,
    (0, $1UDCR.default),
    (0, $XoImS.default),
    (0, $gJT7h.default),
    (0, $cfp1m.default),
    (0, $d4jhX.default),
    (0, $evRPQ.default),
    (0, $jc1Yz.default),
    (0, $avf6p.default),
    // ResourceScheduleReportCollection,
    // RevenueForecastReportCollection,
    (0, $64hVI.default),
    (0, $bxXv3.default),
    (0, $dtlWt.default),
    (0, $64hVI.default),
    (0, $htkeB.default),
    (0, $kb7bz.default),
    (0, $keGWP.default),
    (0, $5JL5P.default),
    (0, $QiMYe.default),
    (0, $8qPFs.default),
    (0, $9eute.default),
    (0, $4oQMK.default),
    (0, $3gI5O.default),
    (0, $6920Q.default),
    (0, $5o9Ld.default),
    (0, $liJtZ.default)
];
const $5c4c03095d6bf370$export$514460938402b9ab = [
    (0, $hSUCJ.BudgetCollectionClass),
    (0, $gkMXq.ChangeLogCollectionClass),
    (0, $bhvQG.ContactCollectionClass),
    (0, $eNcHX.CostCentreCollectionClass),
    (0, $2Zzii.SupplierCollectionClass),
    (0, $9VnJj.DailyAllocationCollectionClass),
    (0, $jg8jZ.AllocationCollectionClass),
    (0, $huUQP.MonthlyAllocationCollectionClass),
    (0, $fFfyp.WeeklyAllocationCollectionClass),
    (0, $cxnwP.InvoiceCollectionClass),
    (0, $kRqe9.InvoiceLineItemCollectionClass),
    (0, $lu0ti.InvoiceDescriptionTemplateCollectionClass),
    (0, $3PAB5.OrganisationCollectionClass),
    (0, $8XaFv.OrganisationHolidayCollectionClass),
    (0, $i0HPj.OrganisationSubscriptionCollectionClass),
    (0, $h6zQv.ReportCollectionClass),
    (0, $1UDCR.OverheadExpenseCollectionClass),
    (0, $XoImS.PhaseCollectionClass),
    (0, $gJT7h.ProjectCollectionClass),
    (0, $cfp1m.ProjectExpenseCollectionClass),
    (0, $d4jhX.ProjectExpenseAllocationCollectionClass),
    (0, $evRPQ.ProjectExpenseItemCollectionClass),
    (0, $jc1Yz.ProjectNoteCollectionClass),
    (0, $avf6p.ProjectRateCollectionClass),
    (0, $4iwZm.ResourceScheduleReportCollectionClass),
    (0, $1k348.RevenueForecastReportCollectionClass),
    (0, $64hVI.RevenueTargetCollectionClass),
    (0, $bxXv3.RoleCollectionClass),
    (0, $dtlWt.RoleRateCollectionClass),
    (0, $htkeB.StaffCollectionClass),
    (0, $kb7bz.StaffRateCollectionClass),
    (0, $keGWP.TaskCollectionClass),
    (0, $5JL5P.PermissionCollectionClass),
    (0, $QiMYe.TimeEntryCollectionClass),
    (0, $8qPFs.MonthlyResourceCellCollectionClass),
    (0, $9eute.ResourceRowCollectionClass),
    (0, $4oQMK.MonthlyRevenueCellCollectionClass),
    (0, $3gI5O.RevenueRowCollectionClass),
    (0, $6920Q.MonthlyExpenseCellCollectionClass),
    (0, $5o9Ld.ExpenseRowCollectionClass),
    (0, $liJtZ.MilestoneCollectionClass)
];
const $5c4c03095d6bf370$export$b45a5f62da66feff = [
    (0, $4tYKG.InvoiceLineItemAggregateCollectionClass),
    (0, $ermXU.ProjectExpenseAggregateCollectionClass),
    (0, $jYjJH.TimeEntryAggregateCollectionClass),
    (0, $cTdgh.DailyAllocationAggregateCollectionClass),
    (0, $8yVxd.AllocationAggregateCollectionClass),
    (0, $huUQP.MonthlyAllocationCollectionClass),
    (0, $aJ9vI.RevenueTargetAggregateCollectionClass),
    (0, $816ZB.PhaseAggregateCollectionClass),
    (0, $kuXqZ.BudgetAggregateCollectionClass)
];
const $5c4c03095d6bf370$export$1c068831c12f7c9a = Object.fromEntries($5c4c03095d6bf370$export$514460938402b9ab.map((c)=>[
        new c().collection,
        c
    ]));
const $5c4c03095d6bf370$export$873db4a93360f506 = Object.fromEntries($5c4c03095d6bf370$export$b45a5f62da66feff.map((c)=>[
        new c().collection,
        c
    ]));

});
parcelRegister("jg8jZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e055f76c5f6cbc8c$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "AllocationCollectionClass", function () { return $e055f76c5f6cbc8c$export$10677ecf6e061ea5; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $fcWDh = parcelRequire("fcWDh");

var $f44xu = parcelRequire("f44xu");

var $4hBm1 = parcelRequire("4hBm1");
var $e055f76c5f6cbc8c$var$_dec, $e055f76c5f6cbc8c$var$_dec2, $e055f76c5f6cbc8c$var$_dec3, $e055f76c5f6cbc8c$var$_class;
function $e055f76c5f6cbc8c$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $e055f76c5f6cbc8c$var$AllocationCollection = ($e055f76c5f6cbc8c$var$_dec = (0, $4JcCM.action).bound, $e055f76c5f6cbc8c$var$_dec2 = (0, $4JcCM.action).bound, $e055f76c5f6cbc8c$var$_dec3 = (0, $4JcCM.action).bound, $e055f76c5f6cbc8c$var$_class = class AllocationCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "allocations",
            modelClass: (0, $fcWDh.default)
        });
        this.addLookup("allocationsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByStaffId", "manyByKey", {
            key: (t)=>t.staffId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByRoleId", "manyByKey", {
            key: (t)=>{
                var _t$staff;
                return t.roleId || ((_t$staff = t.staff) === null || _t$staff === void 0 ? void 0 : _t$staff.roleId);
            },
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByTaskId", "manyByKey", {
            key: (t)=>t.taskId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByCostCentreId", "manyByKey", {
            key: (t)=>t.costCentreId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByStaffIdDate", "manyByKey", {
            key: (t)=>(0, $f44xu.default)(t.staffId, t.date.getTime()),
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByStaffIdWeek", "manyByKey", {
            key: (t)=>{
                return (0, $f44xu.default)(t.staffId, t.week);
            },
            filter: (t)=>!t.deletedAt
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get allocationsById() {
        return this.modelsById;
    }
    get allocations() {
        return this.models;
    }
    get allocationsById() {
        return this.modelsById;
    }
    addAllocation(data, options) {
        this.add(data, options);
    }
    addAllocations(data, options) {
        this.addMany(data, options);
    }
    addAllocationsAcrossDateRange(dateRange, data, options) {
        const workingDays = [];
        let date = dateRange[0];
        while(date <= dateRange[1]){
            if (!(0, $4hBm1.isWeekend)(date)) workingDays.push(date);
            date = (0, $4hBm1.addDays)(date, 1);
        }
        const numMinutes = data.numMinutes / workingDays.length;
        this.addMany(workingDays.map((date)=>({
                ...data,
                date: date,
                numMinutes: numMinutes
            })), options);
    }
}, $e055f76c5f6cbc8c$var$_applyDecoratedDescriptor($e055f76c5f6cbc8c$var$_class.prototype, "addAllocation", [
    $e055f76c5f6cbc8c$var$_dec
], Object.getOwnPropertyDescriptor($e055f76c5f6cbc8c$var$_class.prototype, "addAllocation"), $e055f76c5f6cbc8c$var$_class.prototype), $e055f76c5f6cbc8c$var$_applyDecoratedDescriptor($e055f76c5f6cbc8c$var$_class.prototype, "addAllocations", [
    $e055f76c5f6cbc8c$var$_dec2
], Object.getOwnPropertyDescriptor($e055f76c5f6cbc8c$var$_class.prototype, "addAllocations"), $e055f76c5f6cbc8c$var$_class.prototype), $e055f76c5f6cbc8c$var$_applyDecoratedDescriptor($e055f76c5f6cbc8c$var$_class.prototype, "addAllocationsAcrossDateRange", [
    $e055f76c5f6cbc8c$var$_dec3
], Object.getOwnPropertyDescriptor($e055f76c5f6cbc8c$var$_class.prototype, "addAllocationsAcrossDateRange"), $e055f76c5f6cbc8c$var$_class.prototype), $e055f76c5f6cbc8c$var$_class);
var $e055f76c5f6cbc8c$export$2e2bcd8739ae039 = new $e055f76c5f6cbc8c$var$AllocationCollection();
const $e055f76c5f6cbc8c$export$10677ecf6e061ea5 = $e055f76c5f6cbc8c$var$AllocationCollection;

});
parcelRegister("fcWDh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b125753a3ee28647$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $htkeB = parcelRequire("htkeB");

var $gJT7h = parcelRequire("gJT7h");

var $XoImS = parcelRequire("XoImS");
parcelRequire("keGWP");

var $3PpOX = parcelRequire("3PpOX");

var $jg8jZ = parcelRequire("jg8jZ");
parcelRequire("eNcHX");

var $4hBm1 = parcelRequire("4hBm1");

var $bxXv3 = parcelRequire("bxXv3");
var $b125753a3ee28647$var$_class, $b125753a3ee28647$var$_descriptor, $b125753a3ee28647$var$_descriptor2, $b125753a3ee28647$var$_descriptor3, $b125753a3ee28647$var$_descriptor4, $b125753a3ee28647$var$_descriptor5, $b125753a3ee28647$var$_descriptor6, $b125753a3ee28647$var$_descriptor7, $b125753a3ee28647$var$_descriptor8, $b125753a3ee28647$var$_descriptor9, $b125753a3ee28647$var$_descriptor10;
function $b125753a3ee28647$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $b125753a3ee28647$var$_defineProperty(e, r, t) {
    return (r = $b125753a3ee28647$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $b125753a3ee28647$var$_toPropertyKey(t) {
    var i = $b125753a3ee28647$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $b125753a3ee28647$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $b125753a3ee28647$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $b125753a3ee28647$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $b125753a3ee28647$var$AllocationModel = ($b125753a3ee28647$var$_class = class AllocationModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $b125753a3ee28647$var$_initializerDefineProperty(this, "staffId", $b125753a3ee28647$var$_descriptor, this);
        $b125753a3ee28647$var$_initializerDefineProperty(this, "roleId", $b125753a3ee28647$var$_descriptor2, this);
        $b125753a3ee28647$var$_initializerDefineProperty(this, "projectId", $b125753a3ee28647$var$_descriptor3, this);
        $b125753a3ee28647$var$_initializerDefineProperty(this, "phaseId", $b125753a3ee28647$var$_descriptor4, this);
        $b125753a3ee28647$var$_initializerDefineProperty(this, "date", $b125753a3ee28647$var$_descriptor5, this);
        $b125753a3ee28647$var$_initializerDefineProperty(this, "numMinutes", $b125753a3ee28647$var$_descriptor6, this);
        $b125753a3ee28647$var$_initializerDefineProperty(this, "startMinutes", $b125753a3ee28647$var$_descriptor7, this);
        $b125753a3ee28647$var$_initializerDefineProperty(this, "pay", $b125753a3ee28647$var$_descriptor8, this);
        $b125753a3ee28647$var$_initializerDefineProperty(this, "cost", $b125753a3ee28647$var$_descriptor9, this);
        $b125753a3ee28647$var$_initializerDefineProperty(this, "charge_out", $b125753a3ee28647$var$_descriptor10, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $jg8jZ.default);
        this.init(data, options);
    }
    get staff() {
        return (0, $htkeB.default).staffsById[this.staffId];
    }
    get role() {
        var _this$staff;
        return (0, $bxXv3.default).rolesById[this.roleId] || ((_this$staff = this.staff) === null || _this$staff === void 0 ? void 0 : _this$staff.role);
    }
    get costCentre() {
        return this.project.costCentre;
    }
    get project() {
        return (0, $gJT7h.default).modelsById[this.projectId];
    }
    get phase() {
        return (0, $XoImS.default).modelsById[this.phaseId];
    }
    get hours() {
        return this.numMinutes / 60;
    }
    get payRate() {
        return this.pay / this.hours;
    }
    get costRate() {
        return this.cost / this.hours;
    }
    get chargeOutRate() {
        return this.chargeOut / this.hours;
    }
    get week() {
        return (0, $4hBm1.getWeek)(this.date, {
            weekStartsOn: 1
        });
    }
    get month() {
        return (0, $4hBm1.getMonth)(this.date);
    }
    get likelihood() {
        var _this$phase;
        return ((_this$phase = this.phase) === null || _this$phase === void 0 ? void 0 : _this$phase.likelihood) || 100;
    }
}, $b125753a3ee28647$var$_descriptor = $b125753a3ee28647$var$_applyDecoratedDescriptor($b125753a3ee28647$var$_class.prototype, "staffId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $b125753a3ee28647$var$_descriptor2 = $b125753a3ee28647$var$_applyDecoratedDescriptor($b125753a3ee28647$var$_class.prototype, "roleId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $b125753a3ee28647$var$_descriptor3 = $b125753a3ee28647$var$_applyDecoratedDescriptor($b125753a3ee28647$var$_class.prototype, "projectId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $b125753a3ee28647$var$_descriptor4 = $b125753a3ee28647$var$_applyDecoratedDescriptor($b125753a3ee28647$var$_class.prototype, "phaseId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $b125753a3ee28647$var$_descriptor5 = $b125753a3ee28647$var$_applyDecoratedDescriptor($b125753a3ee28647$var$_class.prototype, "date", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Date();
    }
}), $b125753a3ee28647$var$_descriptor6 = $b125753a3ee28647$var$_applyDecoratedDescriptor($b125753a3ee28647$var$_class.prototype, "numMinutes", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $b125753a3ee28647$var$_descriptor7 = $b125753a3ee28647$var$_applyDecoratedDescriptor($b125753a3ee28647$var$_class.prototype, "startMinutes", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $b125753a3ee28647$var$_descriptor8 = $b125753a3ee28647$var$_applyDecoratedDescriptor($b125753a3ee28647$var$_class.prototype, "pay", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $b125753a3ee28647$var$_descriptor9 = $b125753a3ee28647$var$_applyDecoratedDescriptor($b125753a3ee28647$var$_class.prototype, "cost", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $b125753a3ee28647$var$_descriptor10 = $b125753a3ee28647$var$_applyDecoratedDescriptor($b125753a3ee28647$var$_class.prototype, "charge_out", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $b125753a3ee28647$var$_applyDecoratedDescriptor($b125753a3ee28647$var$_class.prototype, "staff", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($b125753a3ee28647$var$_class.prototype, "staff"), $b125753a3ee28647$var$_class.prototype), $b125753a3ee28647$var$_applyDecoratedDescriptor($b125753a3ee28647$var$_class.prototype, "role", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($b125753a3ee28647$var$_class.prototype, "role"), $b125753a3ee28647$var$_class.prototype), $b125753a3ee28647$var$_applyDecoratedDescriptor($b125753a3ee28647$var$_class.prototype, "costCentre", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($b125753a3ee28647$var$_class.prototype, "costCentre"), $b125753a3ee28647$var$_class.prototype), $b125753a3ee28647$var$_applyDecoratedDescriptor($b125753a3ee28647$var$_class.prototype, "project", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($b125753a3ee28647$var$_class.prototype, "project"), $b125753a3ee28647$var$_class.prototype), $b125753a3ee28647$var$_applyDecoratedDescriptor($b125753a3ee28647$var$_class.prototype, "phase", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($b125753a3ee28647$var$_class.prototype, "phase"), $b125753a3ee28647$var$_class.prototype), $b125753a3ee28647$var$_applyDecoratedDescriptor($b125753a3ee28647$var$_class.prototype, "hours", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($b125753a3ee28647$var$_class.prototype, "hours"), $b125753a3ee28647$var$_class.prototype), $b125753a3ee28647$var$_applyDecoratedDescriptor($b125753a3ee28647$var$_class.prototype, "payRate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($b125753a3ee28647$var$_class.prototype, "payRate"), $b125753a3ee28647$var$_class.prototype), $b125753a3ee28647$var$_applyDecoratedDescriptor($b125753a3ee28647$var$_class.prototype, "costRate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($b125753a3ee28647$var$_class.prototype, "costRate"), $b125753a3ee28647$var$_class.prototype), $b125753a3ee28647$var$_applyDecoratedDescriptor($b125753a3ee28647$var$_class.prototype, "chargeOutRate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($b125753a3ee28647$var$_class.prototype, "chargeOutRate"), $b125753a3ee28647$var$_class.prototype), $b125753a3ee28647$var$_applyDecoratedDescriptor($b125753a3ee28647$var$_class.prototype, "week", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($b125753a3ee28647$var$_class.prototype, "week"), $b125753a3ee28647$var$_class.prototype), $b125753a3ee28647$var$_applyDecoratedDescriptor($b125753a3ee28647$var$_class.prototype, "month", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($b125753a3ee28647$var$_class.prototype, "month"), $b125753a3ee28647$var$_class.prototype), $b125753a3ee28647$var$_applyDecoratedDescriptor($b125753a3ee28647$var$_class.prototype, "likelihood", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($b125753a3ee28647$var$_class.prototype, "likelihood"), $b125753a3ee28647$var$_class.prototype), $b125753a3ee28647$var$_class);
var $b125753a3ee28647$export$2e2bcd8739ae039 = $b125753a3ee28647$var$AllocationModel;

});


parcelRegister("lu0ti", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa3cc3f6fa79b830$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "InvoiceDescriptionTemplateCollectionClass", function () { return $fa3cc3f6fa79b830$export$5663121f96b25801; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $lNvF1 = parcelRequire("lNvF1");
var $fa3cc3f6fa79b830$var$_dec, $fa3cc3f6fa79b830$var$_dec2, $fa3cc3f6fa79b830$var$_class;
function $fa3cc3f6fa79b830$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $fa3cc3f6fa79b830$var$InvoiceDescriptionTemplateCollection = ($fa3cc3f6fa79b830$var$_dec = (0, $4JcCM.action).bound, $fa3cc3f6fa79b830$var$_dec2 = (0, $4JcCM.action).bound, $fa3cc3f6fa79b830$var$_class = class InvoiceDescriptionTemplateCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "invoiceDescriptionTemplates",
            modelClass: (0, $lNvF1.default)
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get descriptionTemplatesById() {
        return this.modelsById;
    }
    get descriptionTemplates() {
        return this.models;
    }
    addDescriptionTemplate(data) {
        this.add(data);
    }
    addDescriptionTemplates(data) {
        this.addMany(data);
    }
}, $fa3cc3f6fa79b830$var$_applyDecoratedDescriptor($fa3cc3f6fa79b830$var$_class.prototype, "addDescriptionTemplate", [
    $fa3cc3f6fa79b830$var$_dec
], Object.getOwnPropertyDescriptor($fa3cc3f6fa79b830$var$_class.prototype, "addDescriptionTemplate"), $fa3cc3f6fa79b830$var$_class.prototype), $fa3cc3f6fa79b830$var$_applyDecoratedDescriptor($fa3cc3f6fa79b830$var$_class.prototype, "addDescriptionTemplates", [
    $fa3cc3f6fa79b830$var$_dec2
], Object.getOwnPropertyDescriptor($fa3cc3f6fa79b830$var$_class.prototype, "addDescriptionTemplates"), $fa3cc3f6fa79b830$var$_class.prototype), $fa3cc3f6fa79b830$var$_class);
var $fa3cc3f6fa79b830$export$2e2bcd8739ae039 = new $fa3cc3f6fa79b830$var$InvoiceDescriptionTemplateCollection();
const $fa3cc3f6fa79b830$export$5663121f96b25801 = $fa3cc3f6fa79b830$var$InvoiceDescriptionTemplateCollection;

});
parcelRegister("lNvF1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fde6bbbf67d48a0d$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $lu0ti = parcelRequire("lu0ti");

var $3PpOX = parcelRequire("3PpOX");
var $fde6bbbf67d48a0d$var$_class, $fde6bbbf67d48a0d$var$_descriptor, $fde6bbbf67d48a0d$var$_descriptor2;
function $fde6bbbf67d48a0d$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $fde6bbbf67d48a0d$var$_defineProperty(e, r, t) {
    return (r = $fde6bbbf67d48a0d$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fde6bbbf67d48a0d$var$_toPropertyKey(t) {
    var i = $fde6bbbf67d48a0d$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $fde6bbbf67d48a0d$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $fde6bbbf67d48a0d$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $fde6bbbf67d48a0d$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $fde6bbbf67d48a0d$var$InvoiceDescriptionTemplateModel = ($fde6bbbf67d48a0d$var$_class = class InvoiceDescriptionTemplateModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $fde6bbbf67d48a0d$var$_initializerDefineProperty(this, "name", $fde6bbbf67d48a0d$var$_descriptor, this);
        $fde6bbbf67d48a0d$var$_initializerDefineProperty(this, "description", $fde6bbbf67d48a0d$var$_descriptor2, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $lu0ti.default);
        this.init(data, options);
    }
}, $fde6bbbf67d48a0d$var$_descriptor = $fde6bbbf67d48a0d$var$_applyDecoratedDescriptor($fde6bbbf67d48a0d$var$_class.prototype, "name", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $fde6bbbf67d48a0d$var$_descriptor2 = $fde6bbbf67d48a0d$var$_applyDecoratedDescriptor($fde6bbbf67d48a0d$var$_class.prototype, "description", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $fde6bbbf67d48a0d$var$_class);
var $fde6bbbf67d48a0d$export$2e2bcd8739ae039 = $fde6bbbf67d48a0d$var$InvoiceDescriptionTemplateModel;

});


parcelRegister("8XaFv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $684c1befe419fe90$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "OrganisationHolidayCollectionClass", function () { return $684c1befe419fe90$export$643eeb189ba93479; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $gzeXf = parcelRequire("gzeXf");
var $684c1befe419fe90$var$_dec, $684c1befe419fe90$var$_dec2, $684c1befe419fe90$var$_class;
function $684c1befe419fe90$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $684c1befe419fe90$var$OrganisationHolidayCollection = ($684c1befe419fe90$var$_dec = (0, $4JcCM.action).bound, $684c1befe419fe90$var$_dec2 = (0, $4JcCM.action).bound, $684c1befe419fe90$var$_class = class OrganisationHolidayCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "organisationHolidays",
            modelClass: (0, $gzeXf.default)
        });
        this.addLookup("activeHolidays", "list", {
            filter: (t)=>!t.deletedAt
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get organisationHolidaysById() {
        return this.modelsById;
    }
    get organisationHolidays() {
        return this.models;
    }
    addOrganisationHoliday(data) {
        this.add(data);
    }
    addOrganisationHolidays(data) {
        this.addMany(data);
    }
}, $684c1befe419fe90$var$_applyDecoratedDescriptor($684c1befe419fe90$var$_class.prototype, "addOrganisationHoliday", [
    $684c1befe419fe90$var$_dec
], Object.getOwnPropertyDescriptor($684c1befe419fe90$var$_class.prototype, "addOrganisationHoliday"), $684c1befe419fe90$var$_class.prototype), $684c1befe419fe90$var$_applyDecoratedDescriptor($684c1befe419fe90$var$_class.prototype, "addOrganisationHolidays", [
    $684c1befe419fe90$var$_dec2
], Object.getOwnPropertyDescriptor($684c1befe419fe90$var$_class.prototype, "addOrganisationHolidays"), $684c1befe419fe90$var$_class.prototype), $684c1befe419fe90$var$_class);
var $684c1befe419fe90$export$2e2bcd8739ae039 = new $684c1befe419fe90$var$OrganisationHolidayCollection();
const $684c1befe419fe90$export$643eeb189ba93479 = $684c1befe419fe90$var$OrganisationHolidayCollection;

});
parcelRegister("gzeXf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0fb83e31e127d49$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $8XaFv = parcelRequire("8XaFv");

var $3PpOX = parcelRequire("3PpOX");
var $c0fb83e31e127d49$var$_class, $c0fb83e31e127d49$var$_descriptor, $c0fb83e31e127d49$var$_descriptor2, $c0fb83e31e127d49$var$_descriptor3;
function $c0fb83e31e127d49$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $c0fb83e31e127d49$var$_defineProperty(e, r, t) {
    return (r = $c0fb83e31e127d49$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $c0fb83e31e127d49$var$_toPropertyKey(t) {
    var i = $c0fb83e31e127d49$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $c0fb83e31e127d49$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $c0fb83e31e127d49$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $c0fb83e31e127d49$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $c0fb83e31e127d49$var$OrganisationHolidayModel = ($c0fb83e31e127d49$var$_class = class OrganisationHolidayModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $c0fb83e31e127d49$var$_initializerDefineProperty(this, "name", $c0fb83e31e127d49$var$_descriptor, this);
        $c0fb83e31e127d49$var$_initializerDefineProperty(this, "startDate", $c0fb83e31e127d49$var$_descriptor2, this);
        $c0fb83e31e127d49$var$_initializerDefineProperty(this, "endDate", $c0fb83e31e127d49$var$_descriptor3, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $8XaFv.default);
        this.init(data, options);
    }
}, $c0fb83e31e127d49$var$_descriptor = $c0fb83e31e127d49$var$_applyDecoratedDescriptor($c0fb83e31e127d49$var$_class.prototype, "name", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c0fb83e31e127d49$var$_descriptor2 = $c0fb83e31e127d49$var$_applyDecoratedDescriptor($c0fb83e31e127d49$var$_class.prototype, "startDate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c0fb83e31e127d49$var$_descriptor3 = $c0fb83e31e127d49$var$_applyDecoratedDescriptor($c0fb83e31e127d49$var$_class.prototype, "endDate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c0fb83e31e127d49$var$_class);
var $c0fb83e31e127d49$export$2e2bcd8739ae039 = $c0fb83e31e127d49$var$OrganisationHolidayModel;

});


parcelRegister("i0HPj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1ca3923069715df$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "OrganisationSubscriptionCollectionClass", function () { return $d1ca3923069715df$export$2e9a9d75bf939bf4; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $8yC54 = parcelRequire("8yC54");
var $d1ca3923069715df$var$_dec, $d1ca3923069715df$var$_dec2, $d1ca3923069715df$var$_class;
function $d1ca3923069715df$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $d1ca3923069715df$var$OrganisationSubscriptionCollection = ($d1ca3923069715df$var$_dec = (0, $4JcCM.action).bound, $d1ca3923069715df$var$_dec2 = (0, $4JcCM.action).bound, $d1ca3923069715df$var$_class = class OrganisationSubscriptionCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "organisationSubscriptions",
            modelClass: (0, $8yC54.default)
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get organisationSubscriptionsById() {
        return this.modelsById;
    }
    get organisationSubscriptions() {
        return this.models;
    }
    addOrganisationSubscription(data) {
        this.add(data);
    }
    addOrganisationSubscriptions(data) {
        this.addMany(data);
    }
}, $d1ca3923069715df$var$_applyDecoratedDescriptor($d1ca3923069715df$var$_class.prototype, "addOrganisationSubscription", [
    $d1ca3923069715df$var$_dec
], Object.getOwnPropertyDescriptor($d1ca3923069715df$var$_class.prototype, "addOrganisationSubscription"), $d1ca3923069715df$var$_class.prototype), $d1ca3923069715df$var$_applyDecoratedDescriptor($d1ca3923069715df$var$_class.prototype, "addOrganisationSubscriptions", [
    $d1ca3923069715df$var$_dec2
], Object.getOwnPropertyDescriptor($d1ca3923069715df$var$_class.prototype, "addOrganisationSubscriptions"), $d1ca3923069715df$var$_class.prototype), $d1ca3923069715df$var$_class);
var $d1ca3923069715df$export$2e2bcd8739ae039 = new $d1ca3923069715df$var$OrganisationSubscriptionCollection();
const $d1ca3923069715df$export$2e9a9d75bf939bf4 = $d1ca3923069715df$var$OrganisationSubscriptionCollection;

});
parcelRegister("8yC54", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63af09c0c9af16b4$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $i0HPj = parcelRequire("i0HPj");

var $3PpOX = parcelRequire("3PpOX");

var $4hBm1 = parcelRequire("4hBm1");

var $eat5C = parcelRequire("eat5C");

var $1BTI2 = parcelRequire("1BTI2");


var $6Q5sp = parcelRequire("6Q5sp");
var $63af09c0c9af16b4$var$_class, $63af09c0c9af16b4$var$_descriptor, $63af09c0c9af16b4$var$_descriptor2, $63af09c0c9af16b4$var$_descriptor3, $63af09c0c9af16b4$var$_descriptor4, $63af09c0c9af16b4$var$_descriptor5, $63af09c0c9af16b4$var$_descriptor6, $63af09c0c9af16b4$var$_descriptor7, $63af09c0c9af16b4$var$_descriptor8, $63af09c0c9af16b4$var$_descriptor9, $63af09c0c9af16b4$var$_descriptor10, $63af09c0c9af16b4$var$_descriptor11, $63af09c0c9af16b4$var$_descriptor12, $63af09c0c9af16b4$var$_descriptor13, $63af09c0c9af16b4$var$_descriptor14, $63af09c0c9af16b4$var$_descriptor15, $63af09c0c9af16b4$var$_descriptor16, $63af09c0c9af16b4$var$_descriptor17, $63af09c0c9af16b4$var$_descriptor18;
function $63af09c0c9af16b4$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $63af09c0c9af16b4$var$_defineProperty(e, r, t) {
    return (r = $63af09c0c9af16b4$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $63af09c0c9af16b4$var$_toPropertyKey(t) {
    var i = $63af09c0c9af16b4$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $63af09c0c9af16b4$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $63af09c0c9af16b4$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $63af09c0c9af16b4$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $63af09c0c9af16b4$var$OrganisationSubscriptionModel = ($63af09c0c9af16b4$var$_class = class OrganisationSubscriptionModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $63af09c0c9af16b4$var$_initializerDefineProperty(this, "subscribedAt", $63af09c0c9af16b4$var$_descriptor, this);
        $63af09c0c9af16b4$var$_initializerDefineProperty(this, "startedTrialOn", $63af09c0c9af16b4$var$_descriptor2, this);
        $63af09c0c9af16b4$var$_initializerDefineProperty(this, "cardBrand", $63af09c0c9af16b4$var$_descriptor3, this);
        $63af09c0c9af16b4$var$_initializerDefineProperty(this, "cardLast4", $63af09c0c9af16b4$var$_descriptor4, this);
        $63af09c0c9af16b4$var$_initializerDefineProperty(this, "cardExpDate", $63af09c0c9af16b4$var$_descriptor5, this);
        $63af09c0c9af16b4$var$_initializerDefineProperty(this, "endsTrialOn", $63af09c0c9af16b4$var$_descriptor6, this);
        $63af09c0c9af16b4$var$_initializerDefineProperty(this, "receiptEmail", $63af09c0c9af16b4$var$_descriptor7, this);
        $63af09c0c9af16b4$var$_initializerDefineProperty(this, "stripeId", $63af09c0c9af16b4$var$_descriptor8, this);
        $63af09c0c9af16b4$var$_initializerDefineProperty(this, "credit", $63af09c0c9af16b4$var$_descriptor9, this);
        $63af09c0c9af16b4$var$_initializerDefineProperty(this, "nextPaymentDate", $63af09c0c9af16b4$var$_descriptor10, this);
        $63af09c0c9af16b4$var$_initializerDefineProperty(this, "monthlyAdminPlanId", $63af09c0c9af16b4$var$_descriptor11, this);
        $63af09c0c9af16b4$var$_initializerDefineProperty(this, "monthlyCouponId", $63af09c0c9af16b4$var$_descriptor12, this);
        $63af09c0c9af16b4$var$_initializerDefineProperty(this, "monthlyStandardPlanId", $63af09c0c9af16b4$var$_descriptor13, this);
        $63af09c0c9af16b4$var$_initializerDefineProperty(this, "subscriptionPeriod", $63af09c0c9af16b4$var$_descriptor14, this);
        $63af09c0c9af16b4$var$_initializerDefineProperty(this, "unpaidInvoices", $63af09c0c9af16b4$var$_descriptor15, this);
        $63af09c0c9af16b4$var$_initializerDefineProperty(this, "yearlyAdminPlanId", $63af09c0c9af16b4$var$_descriptor16, this);
        $63af09c0c9af16b4$var$_initializerDefineProperty(this, "yearlyCouponId", $63af09c0c9af16b4$var$_descriptor17, this);
        $63af09c0c9af16b4$var$_initializerDefineProperty(this, "yearlyStandardPlanId", $63af09c0c9af16b4$var$_descriptor18, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $i0HPj.default);
        this.init(data, options);
    }
    update(data, options) {
        super.update(data, options);
        if (this.isAccountLocked) (0, $6Q5sp.router).navigate({
            to: "/billing"
        });
    }
    get trialEndDate() {
        return (0, $4hBm1.endOfDay)(new Date(this.endsTrialOn));
    }
    get hasSubscription() {
        return this.subscribedAt !== null;
    }
    get hasTrialExpired() {
        if (this.hasSubscription) return false;
        return this.trialEndDate < (0, $4hBm1.endOfDay)(new Date());
    }
    get hasCreditCardExpired() {
        if (!this.cardExpDate) return false;
        return (0, $4hBm1.endOfDay)(this.cardExpDate) < (0, $4hBm1.endOfDay)(new Date());
    }
    get willCreditCardExpireInLessThanAMonth() {
        if (!this.cardExpDate) return false;
        return (0, $4hBm1.differenceInMonths)(this.cardExpDate, new Date()) < 1;
    }
    get invoicesDue() {
        return this.unpaidInvoices.filter((inv)=>(inv.stripe_invoice_id !== "proration" || inv.amount >= 50) && inv.date);
    }
    get hasUnpaidInvoices() {
        return this.invoicesDue.length > 0;
    }
    get earliestUnpaidInvoiceDate() {
        if (!this.invoicesDue.length > 0) return null;
        else return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).min(this.invoicesDue.map((inv)=>new Date(inv.date)));
    }
    get hasOverdueInvoices() {
        return false;
    }
    get isAccountLocked() {
        //TODO - add unpaid invoices
        return this.hasTrialExpired || this.hasOverdueInvoices;
    }
    get defaultMonthlyStandardPlanId() {
        const subscribedDate = this.subscribedAt ? new Date(this.subscribedAt) : null;
        if (subscribedDate && subscribedDate < new Date("2023-03-20")) return [
            "au",
            "nz"
        ].includes((0, $1BTI2.default) === null || (0, $1BTI2.default) === void 0 ? void 0 : (0, $1BTI2.default).organisationCountry) ? "1_Month_Aus_Standard" : "1_Month_US_Standard";
        return [
            "au",
            "nz"
        ].includes((0, $1BTI2.default) === null || (0, $1BTI2.default) === void 0 ? void 0 : (0, $1BTI2.default).organisationCountry) ? "1_Month_Aus_35" : "1_Month_US_25";
    }
    get defaultYearlyStandardPlanId() {
        const subscribedDate = this.subscribedAt ? new Date(this.subscribedAt) : null;
        if (subscribedDate && subscribedDate < new Date("2023-03-20")) return [
            "au",
            "nz"
        ].includes((0, $1BTI2.default) === null || (0, $1BTI2.default) === void 0 ? void 0 : (0, $1BTI2.default).organisationCountry) ? "12_Month_Aus_Standard" : "12_Month_US_Standard";
        return [
            "au",
            "nz"
        ].includes((0, $1BTI2.default) === null || (0, $1BTI2.default) === void 0 ? void 0 : (0, $1BTI2.default).organisationCountry) ? "12_Month_Aus_35" : "12_Month_US_25";
    }
    get defaultMonthlyAdminPlanId() {
        const subscribedDate = this.subscribedAt ? new Date(this.subscribedAt) : null;
        if (subscribedDate && subscribedDate < new Date("2023-03-20")) return [
            "au",
            "nz"
        ].includes((0, $1BTI2.default) === null || (0, $1BTI2.default) === void 0 ? void 0 : (0, $1BTI2.default).organisationCountry) ? "1_Month_Aus_Admin" : "1_Month_US_Admin";
        return [
            "au",
            "nz"
        ].includes((0, $1BTI2.default) === null || (0, $1BTI2.default) === void 0 ? void 0 : (0, $1BTI2.default).organisationCountry) ? "1_Month_Aus_35" : "1_Month_US_25";
    }
    get defaultYearlyAdminPlanId() {
        const subscribedDate = this.subscribedAt ? new Date(this.subscribedAt) : null;
        if (subscribedDate && subscribedDate < new Date("2023-03-20")) return [
            "au",
            "nz"
        ].includes((0, $1BTI2.default) === null || (0, $1BTI2.default) === void 0 ? void 0 : (0, $1BTI2.default).organisationCountry) ? "12_Month_Aus_Admin" : "12_Month_US_Admin";
        return [
            "au",
            "nz"
        ].includes((0, $1BTI2.default) === null || (0, $1BTI2.default) === void 0 ? void 0 : (0, $1BTI2.default).organisationCountry) ? "12_Month_Aus_35" : "12_Month_US_25";
    }
    get monthlyAdminPlanPrice() {
        return $63af09c0c9af16b4$var$planLookup[this.monthlyAdminPlanId || this.defaultMonthlyAdminPlanId].amount;
    }
    get monthlyStandardPlanPrice() {
        return $63af09c0c9af16b4$var$planLookup[this.monthlyStandardPlanId || this.defaultMonthlyStandardPlanId].amount;
    }
    get yearlyAdminPlanPrice() {
        return $63af09c0c9af16b4$var$planLookup[this.yearlyAdminPlanId || this.defaultYearlyAdminPlanId].amount;
    }
    get yearlyStandardPlanPrice() {
        return $63af09c0c9af16b4$var$planLookup[this.yearlyStandardPlanId || this.defaultYearlyStandardPlanId].amount;
    }
    get yearlyDiscount() {
        var _couponLookup;
        return ((_couponLookup = $63af09c0c9af16b4$var$couponLookup[this.yearlyCouponId || "15_percent_forever"]) === null || _couponLookup === void 0 ? void 0 : _couponLookup.percentDiscount) || 0;
    }
    get monthlyDiscount() {
        var _couponLookup$this$mo;
        return ((_couponLookup$this$mo = $63af09c0c9af16b4$var$couponLookup[this.monthlyCouponId]) === null || _couponLookup$this$mo === void 0 ? void 0 : _couponLookup$this$mo.percentDiscount) || 0;
    }
    get taxPercent() {
        var _taxLookup$SessionSto;
        return ((_taxLookup$SessionSto = $63af09c0c9af16b4$var$taxLookup[(0, $1BTI2.default) === null || (0, $1BTI2.default) === void 0 ? void 0 : (0, $1BTI2.default).organisationCountry]) === null || _taxLookup$SessionSto === void 0 ? void 0 : _taxLookup$SessionSto.taxPercent) || 0;
    }
}, $63af09c0c9af16b4$var$_descriptor = $63af09c0c9af16b4$var$_applyDecoratedDescriptor($63af09c0c9af16b4$var$_class.prototype, "subscribedAt", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $63af09c0c9af16b4$var$_descriptor2 = $63af09c0c9af16b4$var$_applyDecoratedDescriptor($63af09c0c9af16b4$var$_class.prototype, "startedTrialOn", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $63af09c0c9af16b4$var$_descriptor3 = $63af09c0c9af16b4$var$_applyDecoratedDescriptor($63af09c0c9af16b4$var$_class.prototype, "cardBrand", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $63af09c0c9af16b4$var$_descriptor4 = $63af09c0c9af16b4$var$_applyDecoratedDescriptor($63af09c0c9af16b4$var$_class.prototype, "cardLast4", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $63af09c0c9af16b4$var$_descriptor5 = $63af09c0c9af16b4$var$_applyDecoratedDescriptor($63af09c0c9af16b4$var$_class.prototype, "cardExpDate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $63af09c0c9af16b4$var$_descriptor6 = $63af09c0c9af16b4$var$_applyDecoratedDescriptor($63af09c0c9af16b4$var$_class.prototype, "endsTrialOn", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $63af09c0c9af16b4$var$_descriptor7 = $63af09c0c9af16b4$var$_applyDecoratedDescriptor($63af09c0c9af16b4$var$_class.prototype, "receiptEmail", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $63af09c0c9af16b4$var$_descriptor8 = $63af09c0c9af16b4$var$_applyDecoratedDescriptor($63af09c0c9af16b4$var$_class.prototype, "stripeId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $63af09c0c9af16b4$var$_descriptor9 = $63af09c0c9af16b4$var$_applyDecoratedDescriptor($63af09c0c9af16b4$var$_class.prototype, "credit", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $63af09c0c9af16b4$var$_descriptor10 = $63af09c0c9af16b4$var$_applyDecoratedDescriptor($63af09c0c9af16b4$var$_class.prototype, "nextPaymentDate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $63af09c0c9af16b4$var$_descriptor11 = $63af09c0c9af16b4$var$_applyDecoratedDescriptor($63af09c0c9af16b4$var$_class.prototype, "monthlyAdminPlanId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $63af09c0c9af16b4$var$_descriptor12 = $63af09c0c9af16b4$var$_applyDecoratedDescriptor($63af09c0c9af16b4$var$_class.prototype, "monthlyCouponId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $63af09c0c9af16b4$var$_descriptor13 = $63af09c0c9af16b4$var$_applyDecoratedDescriptor($63af09c0c9af16b4$var$_class.prototype, "monthlyStandardPlanId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $63af09c0c9af16b4$var$_descriptor14 = $63af09c0c9af16b4$var$_applyDecoratedDescriptor($63af09c0c9af16b4$var$_class.prototype, "subscriptionPeriod", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $63af09c0c9af16b4$var$_descriptor15 = $63af09c0c9af16b4$var$_applyDecoratedDescriptor($63af09c0c9af16b4$var$_class.prototype, "unpaidInvoices", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $63af09c0c9af16b4$var$_descriptor16 = $63af09c0c9af16b4$var$_applyDecoratedDescriptor($63af09c0c9af16b4$var$_class.prototype, "yearlyAdminPlanId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $63af09c0c9af16b4$var$_descriptor17 = $63af09c0c9af16b4$var$_applyDecoratedDescriptor($63af09c0c9af16b4$var$_class.prototype, "yearlyCouponId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $63af09c0c9af16b4$var$_descriptor18 = $63af09c0c9af16b4$var$_applyDecoratedDescriptor($63af09c0c9af16b4$var$_class.prototype, "yearlyStandardPlanId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $63af09c0c9af16b4$var$_class);
var $63af09c0c9af16b4$export$2e2bcd8739ae039 = $63af09c0c9af16b4$var$OrganisationSubscriptionModel;
const $63af09c0c9af16b4$var$planLookup = {
    "1_Month_Aus_Admin": {
        id: "1_Month_Aus_Admin",
        interval: "month",
        intervalCount: 1,
        amount: 4500,
        currency: "aud"
    },
    "1_Month_Aus_Standard": {
        id: "1",
        interval: "month",
        intervalCount: 1,
        amount: 2000,
        currency: "aud"
    },
    "12_Month_Aus_Admin": {
        id: "12_Month_Aus_Admin",
        interval: "year",
        intervalCount: 1,
        amount: 54000,
        currency: "aud"
    },
    "12_Month_Aus_Standard": {
        id: "12_Month_Aus_Standard",
        interval: "year",
        intervalCount: 1,
        amount: 24000,
        currency: "aud"
    },
    "6_Month_Aus_Admin": {
        id: "6_Month_Aus_Admin",
        interval: "month",
        intervalCount: 6,
        amount: 27000,
        currency: "aud"
    },
    "6_Month_Aus_Standard": {
        id: "6_Month_Aus_Standard",
        interval: "month",
        intervalCount: 6,
        amount: 12000,
        currency: "aud"
    },
    "1_Month_Aus_Standard_$15": {
        id: "15AUD_User",
        interval: "month",
        intervalCount: 1,
        amount: 1500,
        currency: "aud"
    },
    "12_Month_Aus_Standard_$15": {
        id: "12_Month_15AUD",
        interval: "year",
        intervalCount: 1,
        amount: 18000,
        currency: "aud"
    },
    "12_Month_Aus_Standard_BS": {
        id: "12_Month_Timesheet_BS",
        interval: "year",
        intervalCount: 1,
        amount: 18000,
        currency: "aud"
    },
    "1_Month_US_Admin": {
        id: "1month_admin_usd",
        interval: "month",
        intervalCount: 1,
        amount: 3500,
        currency: "usd"
    },
    "1_Month_US_Standard": {
        id: "1month_timesheet_usd",
        interval: "month",
        intervalCount: 1,
        amount: 1500,
        currency: "usd"
    },
    "12_Month_US_Admin": {
        id: "12month_admin_usd",
        interval: "year",
        intervalCount: 1,
        amount: 42000,
        currency: "usd"
    },
    "12_Month_US_Standard": {
        id: "12month_timesheet_usd",
        interval: "year",
        intervalCount: 1,
        amount: 18000,
        currency: "usd"
    },
    "1_Month_US_Any_$23": {
        id: "1_monthly_plan",
        interval: "month",
        intervalCount: 1,
        amount: 2300,
        currency: "usd"
    },
    "12_Month_US_Admin_$30": {
        id: "12month_admin_30usd",
        interval: "year",
        intervalCount: 1,
        amount: 36000,
        currency: "usd"
    },
    "1_Month_Aus_29": {
        id: "price_1MnYUZC5Z2UupQFYupQNBHo6",
        interval: "month",
        intervalCount: 1,
        amount: 2900,
        currency: "aud"
    },
    "12_Month_Aus_29": {
        id: "price_1MnYV3C5Z2UupQFYEBt85US1",
        interval: "year",
        intervalCount: 1,
        amount: 34800,
        currency: "aud"
    },
    "1_Month_US_19": {
        id: "price_1MnYW7C5Z2UupQFYHpzWaEih",
        interval: "month",
        intervalCount: 1,
        amount: 1900,
        currency: "usd"
    },
    "12_Month_US_19": {
        id: "price_1MnYWeC5Z2UupQFYmgDbRJqy",
        interval: "year",
        intervalCount: 1,
        amount: 22800,
        currency: "usd"
    },
    "1_Month_Aus_35": {
        id: "price_1Q8B6xC5Z2UupQFYHil12VMM",
        interval: "month",
        intervalCount: 1,
        amount: 3500,
        currency: "aud"
    },
    "12_Month_Aus_35": {
        id: "price_1Q8B7tC5Z2UupQFY5PjrScn4",
        interval: "year",
        intervalCount: 1,
        amount: 42000,
        currency: "aud"
    },
    "1_Month_US_25": {
        id: "price_1Q8B8tC5Z2UupQFYLobMM9KB",
        interval: "month",
        intervalCount: 1,
        amount: 2500,
        currency: "usd"
    },
    "12_Month_US_25": {
        id: "price_1Q8B9RC5Z2UupQFYCVOeNrd7",
        interval: "year",
        intervalCount: 1,
        amount: 30000,
        currency: "usd"
    }
};
const $63af09c0c9af16b4$var$couponLookup = {
    "10_percent_forever": {
        id: "10_percent_forever",
        percentDiscount: 10
    },
    "15_percent_forever": {
        id: "15_percent_forever",
        percentDiscount: 15
    },
    "20_percent_forever": {
        id: "20_percent_forever",
        percentDiscount: 20
    },
    "25_percent_forever": {
        id: "25_percent_forever",
        percentDiscount: 25
    },
    "35_percent_forever": {
        id: "35_percent_forever",
        percentDiscount: 35
    },
    "50_percent_forever": {
        id: "50_percent_forever",
        percentDiscount: 50
    },
    FREE: {
        id: "FREE",
        percentDiscount: 100
    },
    "20_percent_1_year": {
        id: "20_percent_1_year",
        percentDiscount: 20
    },
    "25_percent_1_year": {
        id: "25_percent_1_year",
        percentDiscount: 25
    },
    "50_percent_12months": {
        id: "50_percent_12months",
        percentDiscount: 50
    },
    "35_percent_off_6_months": {
        id: "35_percent_off_6_months",
        percentDiscount: 35
    },
    "5_percent_discount_once": {
        id: "5_percent_discount_once",
        percentDiscount: 5
    },
    "10_percent_discount_once": {
        id: "10_percent_discount_once",
        percentDiscount: 10
    },
    "20_percent_discount_once": {
        id: "20_percent_discount_once",
        percentDiscount: 20
    },
    "25_percent_discount_once": {
        id: "25_percent_discount_once",
        percentDiscount: 25
    },
    "35_percent_discount_once": {
        id: "35_percent_discount_once",
        percentDiscount: 35
    },
    "50_percent_discount_once": {
        id: "50_percent_discount_once",
        percentDiscount: 50
    }
};
const $63af09c0c9af16b4$var$taxLookup = {
    au: {
        name: "GST",
        taxPercent: 10
    }
};

});


parcelRegister("4iwZm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32126ebc73598dd4$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "ResourceScheduleReportCollectionClass", function () { return $32126ebc73598dd4$export$e3f3a79e92bf9bf5; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $3ArO6 = parcelRequire("3ArO6");
var $32126ebc73598dd4$var$_dec, $32126ebc73598dd4$var$_dec2, $32126ebc73598dd4$var$_class;
function $32126ebc73598dd4$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $32126ebc73598dd4$var$ResourceScheduleReportCollection = ($32126ebc73598dd4$var$_dec = (0, $4JcCM.action).bound, $32126ebc73598dd4$var$_dec2 = (0, $4JcCM.action).bound, $32126ebc73598dd4$var$_class = class ResourceScheduleReportCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "resourceScheduleReports",
            modelClass: (0, $3ArO6.default)
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get resourceSchedulesById() {
        return this.modelsById;
    }
    get resourceSchedules() {
        return this.models;
    }
    addResourceSchedule(data) {
        this.add(data);
    }
    addResourceSchedules(data) {
        this.addMany(data);
    }
}, $32126ebc73598dd4$var$_applyDecoratedDescriptor($32126ebc73598dd4$var$_class.prototype, "addResourceSchedule", [
    $32126ebc73598dd4$var$_dec
], Object.getOwnPropertyDescriptor($32126ebc73598dd4$var$_class.prototype, "addResourceSchedule"), $32126ebc73598dd4$var$_class.prototype), $32126ebc73598dd4$var$_applyDecoratedDescriptor($32126ebc73598dd4$var$_class.prototype, "addResourceSchedules", [
    $32126ebc73598dd4$var$_dec2
], Object.getOwnPropertyDescriptor($32126ebc73598dd4$var$_class.prototype, "addResourceSchedules"), $32126ebc73598dd4$var$_class.prototype), $32126ebc73598dd4$var$_class);
var $32126ebc73598dd4$export$2e2bcd8739ae039 = new $32126ebc73598dd4$var$ResourceScheduleReportCollection();
const $32126ebc73598dd4$export$e3f3a79e92bf9bf5 = $32126ebc73598dd4$var$ResourceScheduleReportCollection;

});
parcelRegister("3ArO6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29ca4dd1fae0de0f$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $g6lcW = parcelRequire("g6lcW");

var $4iwZm = parcelRequire("4iwZm");

var $3PpOX = parcelRequire("3PpOX");
parcelRequire("eBwNQ");

var $1BTI2 = parcelRequire("1BTI2");
var $29ca4dd1fae0de0f$var$_dec, $29ca4dd1fae0de0f$var$_dec2, $29ca4dd1fae0de0f$var$_dec3, $29ca4dd1fae0de0f$var$_dec4, $29ca4dd1fae0de0f$var$_class, $29ca4dd1fae0de0f$var$_descriptor, $29ca4dd1fae0de0f$var$_descriptor2, $29ca4dd1fae0de0f$var$_descriptor3, $29ca4dd1fae0de0f$var$_descriptor4;
function $29ca4dd1fae0de0f$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $29ca4dd1fae0de0f$var$_defineProperty(e, r, t) {
    return (r = $29ca4dd1fae0de0f$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $29ca4dd1fae0de0f$var$_toPropertyKey(t) {
    var i = $29ca4dd1fae0de0f$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $29ca4dd1fae0de0f$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $29ca4dd1fae0de0f$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $29ca4dd1fae0de0f$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $29ca4dd1fae0de0f$var$ResourceScheduleReportModel = ($29ca4dd1fae0de0f$var$_dec = (0, $4JcCM.action).bound, $29ca4dd1fae0de0f$var$_dec2 = (0, $4JcCM.action).bound, $29ca4dd1fae0de0f$var$_dec3 = (0, $4JcCM.action).bound, $29ca4dd1fae0de0f$var$_dec4 = (0, $4JcCM.action).bound, $29ca4dd1fae0de0f$var$_class = class ResourceScheduleReportModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $29ca4dd1fae0de0f$var$_initializerDefineProperty(this, "name", $29ca4dd1fae0de0f$var$_descriptor, this);
        $29ca4dd1fae0de0f$var$_initializerDefineProperty(this, "filters", $29ca4dd1fae0de0f$var$_descriptor2, this);
        $29ca4dd1fae0de0f$var$_initializerDefineProperty(this, "queryKey", $29ca4dd1fae0de0f$var$_descriptor3, this);
        $29ca4dd1fae0de0f$var$_initializerDefineProperty(this, "systemReport", $29ca4dd1fae0de0f$var$_descriptor4, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $4iwZm.default);
        data.filters = {
            ...(0, $g6lcW.default).filters,
            ...data.filters
        };
        this.init(data, options);
        this.setQueryKey();
    }
    update(data, options, ignoreQueryKey = false) {
        super.update(data, options);
        if (!ignoreQueryKey) this.setQueryKey();
    }
    updateFilters(data) {
        this.update({
            filters: {
                ...this.filters,
                ...data
            }
        }, {}, true);
    }
    get needsUpdate() {
        return this.queryKey !== this.makeQueryKey();
    }
    setQueryKey() {
        this.queryKey = this.makeQueryKey();
    }
    makeQueryKey() {
        return JSON.stringify({
            filters: this.filters
        });
    }
    makeDefault() {
        (0, $1BTI2.default).organisation.update({
            defaultResourceScheduleReportId: this.id
        });
    }
    removeDefault() {
        (0, $1BTI2.default).organisation.update({
            defaultResourceScheduleReportId: null
        });
    }
}, $29ca4dd1fae0de0f$var$_descriptor = $29ca4dd1fae0de0f$var$_applyDecoratedDescriptor($29ca4dd1fae0de0f$var$_class.prototype, "name", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $29ca4dd1fae0de0f$var$_descriptor2 = $29ca4dd1fae0de0f$var$_applyDecoratedDescriptor($29ca4dd1fae0de0f$var$_class.prototype, "filters", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $29ca4dd1fae0de0f$var$_descriptor3 = $29ca4dd1fae0de0f$var$_applyDecoratedDescriptor($29ca4dd1fae0de0f$var$_class.prototype, "queryKey", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $29ca4dd1fae0de0f$var$_descriptor4 = $29ca4dd1fae0de0f$var$_applyDecoratedDescriptor($29ca4dd1fae0de0f$var$_class.prototype, "systemReport", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $29ca4dd1fae0de0f$var$_applyDecoratedDescriptor($29ca4dd1fae0de0f$var$_class.prototype, "updateFilters", [
    $29ca4dd1fae0de0f$var$_dec
], Object.getOwnPropertyDescriptor($29ca4dd1fae0de0f$var$_class.prototype, "updateFilters"), $29ca4dd1fae0de0f$var$_class.prototype), $29ca4dd1fae0de0f$var$_applyDecoratedDescriptor($29ca4dd1fae0de0f$var$_class.prototype, "needsUpdate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($29ca4dd1fae0de0f$var$_class.prototype, "needsUpdate"), $29ca4dd1fae0de0f$var$_class.prototype), $29ca4dd1fae0de0f$var$_applyDecoratedDescriptor($29ca4dd1fae0de0f$var$_class.prototype, "setQueryKey", [
    $29ca4dd1fae0de0f$var$_dec2
], Object.getOwnPropertyDescriptor($29ca4dd1fae0de0f$var$_class.prototype, "setQueryKey"), $29ca4dd1fae0de0f$var$_class.prototype), $29ca4dd1fae0de0f$var$_applyDecoratedDescriptor($29ca4dd1fae0de0f$var$_class.prototype, "makeDefault", [
    $29ca4dd1fae0de0f$var$_dec3
], Object.getOwnPropertyDescriptor($29ca4dd1fae0de0f$var$_class.prototype, "makeDefault"), $29ca4dd1fae0de0f$var$_class.prototype), $29ca4dd1fae0de0f$var$_applyDecoratedDescriptor($29ca4dd1fae0de0f$var$_class.prototype, "removeDefault", [
    $29ca4dd1fae0de0f$var$_dec4
], Object.getOwnPropertyDescriptor($29ca4dd1fae0de0f$var$_class.prototype, "removeDefault"), $29ca4dd1fae0de0f$var$_class.prototype), $29ca4dd1fae0de0f$var$_class);
var $29ca4dd1fae0de0f$export$2e2bcd8739ae039 = $29ca4dd1fae0de0f$var$ResourceScheduleReportModel;

});


parcelRegister("1k348", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f6a098017478675$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "RevenueForecastReportCollectionClass", function () { return $0f6a098017478675$export$4595977366ccd31e; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $i0u26 = parcelRequire("i0u26");
var $0f6a098017478675$var$_dec, $0f6a098017478675$var$_dec2, $0f6a098017478675$var$_class;
function $0f6a098017478675$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $0f6a098017478675$var$RevenueForecastReportCollection = ($0f6a098017478675$var$_dec = (0, $4JcCM.action).bound, $0f6a098017478675$var$_dec2 = (0, $4JcCM.action).bound, $0f6a098017478675$var$_class = class RevenueForecastReportCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "revenueForecastReports",
            modelClass: (0, $i0u26.default)
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get revenueForecastReportsById() {
        return this.modelsById;
    }
    get revenueForecastReports() {
        return this.models;
    }
    addRevenueForecastReport(data) {
        this.add(data);
    }
    addRevenueForecastReports(data) {
        this.addMany(data);
    }
}, $0f6a098017478675$var$_applyDecoratedDescriptor($0f6a098017478675$var$_class.prototype, "addRevenueForecastReport", [
    $0f6a098017478675$var$_dec
], Object.getOwnPropertyDescriptor($0f6a098017478675$var$_class.prototype, "addRevenueForecastReport"), $0f6a098017478675$var$_class.prototype), $0f6a098017478675$var$_applyDecoratedDescriptor($0f6a098017478675$var$_class.prototype, "addRevenueForecastReports", [
    $0f6a098017478675$var$_dec2
], Object.getOwnPropertyDescriptor($0f6a098017478675$var$_class.prototype, "addRevenueForecastReports"), $0f6a098017478675$var$_class.prototype), $0f6a098017478675$var$_class);
var $0f6a098017478675$export$2e2bcd8739ae039 = new $0f6a098017478675$var$RevenueForecastReportCollection();
const $0f6a098017478675$export$4595977366ccd31e = $0f6a098017478675$var$RevenueForecastReportCollection;

});
parcelRegister("i0u26", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1bf86000c9b75a3$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $1k348 = parcelRequire("1k348");

var $3PpOX = parcelRequire("3PpOX");

var $kp6ni = parcelRequire("kp6ni");
parcelRequire("eBwNQ");

var $1BTI2 = parcelRequire("1BTI2");
var $d1bf86000c9b75a3$var$_dec, $d1bf86000c9b75a3$var$_dec2, $d1bf86000c9b75a3$var$_dec3, $d1bf86000c9b75a3$var$_dec4, $d1bf86000c9b75a3$var$_class, $d1bf86000c9b75a3$var$_descriptor, $d1bf86000c9b75a3$var$_descriptor2, $d1bf86000c9b75a3$var$_descriptor3, $d1bf86000c9b75a3$var$_descriptor4;
function $d1bf86000c9b75a3$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $d1bf86000c9b75a3$var$_defineProperty(e, r, t) {
    return (r = $d1bf86000c9b75a3$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $d1bf86000c9b75a3$var$_toPropertyKey(t) {
    var i = $d1bf86000c9b75a3$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $d1bf86000c9b75a3$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $d1bf86000c9b75a3$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $d1bf86000c9b75a3$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $d1bf86000c9b75a3$var$RevenueForecastReportModel = ($d1bf86000c9b75a3$var$_dec = (0, $4JcCM.action).bound, $d1bf86000c9b75a3$var$_dec2 = (0, $4JcCM.action).bound, $d1bf86000c9b75a3$var$_dec3 = (0, $4JcCM.action).bound, $d1bf86000c9b75a3$var$_dec4 = (0, $4JcCM.action).bound, $d1bf86000c9b75a3$var$_class = class RevenueForecastReportModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $d1bf86000c9b75a3$var$_initializerDefineProperty(this, "name", $d1bf86000c9b75a3$var$_descriptor, this);
        $d1bf86000c9b75a3$var$_initializerDefineProperty(this, "filters", $d1bf86000c9b75a3$var$_descriptor2, this);
        $d1bf86000c9b75a3$var$_initializerDefineProperty(this, "queryKey", $d1bf86000c9b75a3$var$_descriptor3, this);
        $d1bf86000c9b75a3$var$_initializerDefineProperty(this, "systemReport", $d1bf86000c9b75a3$var$_descriptor4, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $1k348.default);
        data.filters = {
            ...(0, $kp6ni.default).filters,
            invoiceData: (0, $1BTI2.default).settings.reportInvoiceDateType.replace("issueDate", "issuedOn"),
            ...data.filters
        };
        this.init(data, options);
        this.setQueryKey();
    }
    update(data, options, ignoreQueryKey = false) {
        super.update(data, options);
        if (!ignoreQueryKey) this.setQueryKey();
    }
    updateFilters(data) {
        this.update({
            filters: {
                ...this.filters,
                ...data
            }
        }, {}, true);
    }
    get needsUpdate() {
        return this.queryKey !== this.makeQueryKey();
    }
    setQueryKey() {
        this.queryKey = this.makeQueryKey();
    }
    makeQueryKey() {
        return JSON.stringify({
            filters: this.filters
        });
    }
    makeDefault() {
        (0, $1BTI2.default).organisation.update({
            defaultRevenueForecastReportId: this.id
        });
    }
    removeDefault() {
        (0, $1BTI2.default).organisation.update({
            defaultRevenueForecastReportId: null
        });
    }
}, $d1bf86000c9b75a3$var$_descriptor = $d1bf86000c9b75a3$var$_applyDecoratedDescriptor($d1bf86000c9b75a3$var$_class.prototype, "name", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d1bf86000c9b75a3$var$_descriptor2 = $d1bf86000c9b75a3$var$_applyDecoratedDescriptor($d1bf86000c9b75a3$var$_class.prototype, "filters", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d1bf86000c9b75a3$var$_descriptor3 = $d1bf86000c9b75a3$var$_applyDecoratedDescriptor($d1bf86000c9b75a3$var$_class.prototype, "queryKey", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d1bf86000c9b75a3$var$_descriptor4 = $d1bf86000c9b75a3$var$_applyDecoratedDescriptor($d1bf86000c9b75a3$var$_class.prototype, "systemReport", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $d1bf86000c9b75a3$var$_applyDecoratedDescriptor($d1bf86000c9b75a3$var$_class.prototype, "updateFilters", [
    $d1bf86000c9b75a3$var$_dec
], Object.getOwnPropertyDescriptor($d1bf86000c9b75a3$var$_class.prototype, "updateFilters"), $d1bf86000c9b75a3$var$_class.prototype), $d1bf86000c9b75a3$var$_applyDecoratedDescriptor($d1bf86000c9b75a3$var$_class.prototype, "needsUpdate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($d1bf86000c9b75a3$var$_class.prototype, "needsUpdate"), $d1bf86000c9b75a3$var$_class.prototype), $d1bf86000c9b75a3$var$_applyDecoratedDescriptor($d1bf86000c9b75a3$var$_class.prototype, "setQueryKey", [
    $d1bf86000c9b75a3$var$_dec2
], Object.getOwnPropertyDescriptor($d1bf86000c9b75a3$var$_class.prototype, "setQueryKey"), $d1bf86000c9b75a3$var$_class.prototype), $d1bf86000c9b75a3$var$_applyDecoratedDescriptor($d1bf86000c9b75a3$var$_class.prototype, "makeDefault", [
    $d1bf86000c9b75a3$var$_dec3
], Object.getOwnPropertyDescriptor($d1bf86000c9b75a3$var$_class.prototype, "makeDefault"), $d1bf86000c9b75a3$var$_class.prototype), $d1bf86000c9b75a3$var$_applyDecoratedDescriptor($d1bf86000c9b75a3$var$_class.prototype, "removeDefault", [
    $d1bf86000c9b75a3$var$_dec4
], Object.getOwnPropertyDescriptor($d1bf86000c9b75a3$var$_class.prototype, "removeDefault"), $d1bf86000c9b75a3$var$_class.prototype), $d1bf86000c9b75a3$var$_class);
var $d1bf86000c9b75a3$export$2e2bcd8739ae039 = $d1bf86000c9b75a3$var$RevenueForecastReportModel;

});


parcelRegister("kb7bz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb0a689e15991730$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "StaffRateCollectionClass", function () { return $eb0a689e15991730$export$b7f94ba660bb961a; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $kQ5eA = parcelRequire("kQ5eA");
var $eb0a689e15991730$var$_dec, $eb0a689e15991730$var$_dec2, $eb0a689e15991730$var$_class;
function $eb0a689e15991730$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $eb0a689e15991730$var$StaffRateCollection = ($eb0a689e15991730$var$_dec = (0, $4JcCM.action).bound, $eb0a689e15991730$var$_dec2 = (0, $4JcCM.action).bound, $eb0a689e15991730$var$_class = class StaffRateCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "staffRates",
            modelClass: (0, $kQ5eA.default)
        });
        this.addLookup("ratesByStaffId", "manyByKey", {
            key: (t)=>t.staffId,
            filter: (t)=>!t.deletedAt
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get staffRatesById() {
        return this.modelsById;
    }
    get staffRates() {
        return this.models;
    }
    addStaffRate(data) {
        this.add(data);
    }
    addStaffRates(data) {
        this.addMany(data);
    }
}, $eb0a689e15991730$var$_applyDecoratedDescriptor($eb0a689e15991730$var$_class.prototype, "addStaffRate", [
    $eb0a689e15991730$var$_dec
], Object.getOwnPropertyDescriptor($eb0a689e15991730$var$_class.prototype, "addStaffRate"), $eb0a689e15991730$var$_class.prototype), $eb0a689e15991730$var$_applyDecoratedDescriptor($eb0a689e15991730$var$_class.prototype, "addStaffRates", [
    $eb0a689e15991730$var$_dec2
], Object.getOwnPropertyDescriptor($eb0a689e15991730$var$_class.prototype, "addStaffRates"), $eb0a689e15991730$var$_class.prototype), $eb0a689e15991730$var$_class);
var $eb0a689e15991730$export$2e2bcd8739ae039 = new $eb0a689e15991730$var$StaffRateCollection();
const $eb0a689e15991730$export$b7f94ba660bb961a = $eb0a689e15991730$var$StaffRateCollection;

});
parcelRegister("kQ5eA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2bcb9696bfe3c21$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $htkeB = parcelRequire("htkeB");

var $kb7bz = parcelRequire("kb7bz");

var $3PpOX = parcelRequire("3PpOX");
var $f2bcb9696bfe3c21$var$_class, $f2bcb9696bfe3c21$var$_descriptor, $f2bcb9696bfe3c21$var$_descriptor2, $f2bcb9696bfe3c21$var$_descriptor3, $f2bcb9696bfe3c21$var$_descriptor4, $f2bcb9696bfe3c21$var$_descriptor5, $f2bcb9696bfe3c21$var$_descriptor6, $f2bcb9696bfe3c21$var$_descriptor7;
function $f2bcb9696bfe3c21$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $f2bcb9696bfe3c21$var$_defineProperty(e, r, t) {
    return (r = $f2bcb9696bfe3c21$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f2bcb9696bfe3c21$var$_toPropertyKey(t) {
    var i = $f2bcb9696bfe3c21$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $f2bcb9696bfe3c21$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $f2bcb9696bfe3c21$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $f2bcb9696bfe3c21$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $f2bcb9696bfe3c21$var$StaffRateModel = ($f2bcb9696bfe3c21$var$_class = class StaffRateModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $f2bcb9696bfe3c21$var$_initializerDefineProperty(this, "staffId", $f2bcb9696bfe3c21$var$_descriptor, this);
        $f2bcb9696bfe3c21$var$_initializerDefineProperty(this, "date", $f2bcb9696bfe3c21$var$_descriptor2, this);
        $f2bcb9696bfe3c21$var$_initializerDefineProperty(this, "payRate", $f2bcb9696bfe3c21$var$_descriptor3, this);
        $f2bcb9696bfe3c21$var$_initializerDefineProperty(this, "chargeOutRate", $f2bcb9696bfe3c21$var$_descriptor4, this);
        $f2bcb9696bfe3c21$var$_initializerDefineProperty(this, "costRate", $f2bcb9696bfe3c21$var$_descriptor5, this);
        $f2bcb9696bfe3c21$var$_initializerDefineProperty(this, "weeklyAvailability", $f2bcb9696bfe3c21$var$_descriptor6, this);
        $f2bcb9696bfe3c21$var$_initializerDefineProperty(this, "overtimeRate", $f2bcb9696bfe3c21$var$_descriptor7, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $kb7bz.default);
        this.init(data, options);
    }
    get staff() {
        return (0, $htkeB.default).modelsById[this.staffId];
    }
}, $f2bcb9696bfe3c21$var$_descriptor = $f2bcb9696bfe3c21$var$_applyDecoratedDescriptor($f2bcb9696bfe3c21$var$_class.prototype, "staffId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $f2bcb9696bfe3c21$var$_descriptor2 = $f2bcb9696bfe3c21$var$_applyDecoratedDescriptor($f2bcb9696bfe3c21$var$_class.prototype, "date", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $f2bcb9696bfe3c21$var$_descriptor3 = $f2bcb9696bfe3c21$var$_applyDecoratedDescriptor($f2bcb9696bfe3c21$var$_class.prototype, "payRate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $f2bcb9696bfe3c21$var$_descriptor4 = $f2bcb9696bfe3c21$var$_applyDecoratedDescriptor($f2bcb9696bfe3c21$var$_class.prototype, "chargeOutRate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $f2bcb9696bfe3c21$var$_descriptor5 = $f2bcb9696bfe3c21$var$_applyDecoratedDescriptor($f2bcb9696bfe3c21$var$_class.prototype, "costRate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $f2bcb9696bfe3c21$var$_descriptor6 = $f2bcb9696bfe3c21$var$_applyDecoratedDescriptor($f2bcb9696bfe3c21$var$_class.prototype, "weeklyAvailability", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $f2bcb9696bfe3c21$var$_descriptor7 = $f2bcb9696bfe3c21$var$_applyDecoratedDescriptor($f2bcb9696bfe3c21$var$_class.prototype, "overtimeRate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $f2bcb9696bfe3c21$var$_applyDecoratedDescriptor($f2bcb9696bfe3c21$var$_class.prototype, "staff", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($f2bcb9696bfe3c21$var$_class.prototype, "staff"), $f2bcb9696bfe3c21$var$_class.prototype), $f2bcb9696bfe3c21$var$_class);
var $f2bcb9696bfe3c21$export$2e2bcd8739ae039 = $f2bcb9696bfe3c21$var$StaffRateModel;

});


parcelRegister("5JL5P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42d5af66993084f1$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "PermissionCollectionClass", function () { return $42d5af66993084f1$export$89385daf08d529a1; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $c26i5 = parcelRequire("c26i5");

var $4WSZl = parcelRequire("4WSZl");

var $htkeB = parcelRequire("htkeB");
var $42d5af66993084f1$var$_dec, $42d5af66993084f1$var$_dec2, $42d5af66993084f1$var$_dec3, $42d5af66993084f1$var$_dec4, $42d5af66993084f1$var$_class;
function $42d5af66993084f1$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $42d5af66993084f1$var$PermissionCollection = ($42d5af66993084f1$var$_dec = (0, $4JcCM.action).bound, $42d5af66993084f1$var$_dec2 = (0, $4JcCM.action).bound, $42d5af66993084f1$var$_dec3 = (0, $4JcCM.action).bound, $42d5af66993084f1$var$_dec4 = (0, $4JcCM.action).bound, $42d5af66993084f1$var$_class = class PermissionCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "permissions",
            modelClass: (0, $c26i5.default)
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get permissionsById() {
        return this.modelsById;
    }
    get permissions() {
        return this.models;
    }
    addPermission(data) {
        this.add(data);
    }
    addPermissions(data) {
        this.addMany(data);
    }
    createPermission(settings) {
        var _settings;
        (_settings = settings) !== null && _settings !== void 0 ? _settings : settings = (0, $4WSZl.permissionPresets).timesheet;
        return this.add({
            name: "New Permission",
            settings: settings
        }, {
            trackUpdates: true
        });
    }
    createPermissionFromStaff(staff) {
        const permission = this.createPermission(staff.permissions);
        staff.update({
            permissionsId: permission.id
        });
        const matchingStaff = (0, $htkeB.default).staffByPermissionKey[permission.key] || [];
        matchingStaff.forEach((s)=>{
            s.update({
                permissionsId: permission.id
            });
        });
        return permission;
    }
}, $42d5af66993084f1$var$_applyDecoratedDescriptor($42d5af66993084f1$var$_class.prototype, "addPermission", [
    $42d5af66993084f1$var$_dec
], Object.getOwnPropertyDescriptor($42d5af66993084f1$var$_class.prototype, "addPermission"), $42d5af66993084f1$var$_class.prototype), $42d5af66993084f1$var$_applyDecoratedDescriptor($42d5af66993084f1$var$_class.prototype, "addPermissions", [
    $42d5af66993084f1$var$_dec2
], Object.getOwnPropertyDescriptor($42d5af66993084f1$var$_class.prototype, "addPermissions"), $42d5af66993084f1$var$_class.prototype), $42d5af66993084f1$var$_applyDecoratedDescriptor($42d5af66993084f1$var$_class.prototype, "createPermission", [
    $42d5af66993084f1$var$_dec3
], Object.getOwnPropertyDescriptor($42d5af66993084f1$var$_class.prototype, "createPermission"), $42d5af66993084f1$var$_class.prototype), $42d5af66993084f1$var$_applyDecoratedDescriptor($42d5af66993084f1$var$_class.prototype, "createPermissionFromStaff", [
    $42d5af66993084f1$var$_dec4
], Object.getOwnPropertyDescriptor($42d5af66993084f1$var$_class.prototype, "createPermissionFromStaff"), $42d5af66993084f1$var$_class.prototype), $42d5af66993084f1$var$_class);
var $42d5af66993084f1$export$2e2bcd8739ae039 = new $42d5af66993084f1$var$PermissionCollection();
const $42d5af66993084f1$export$89385daf08d529a1 = $42d5af66993084f1$var$PermissionCollection;

});
parcelRegister("c26i5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c2a8d1efd8bceb7$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $5JL5P = parcelRequire("5JL5P");

var $3PpOX = parcelRequire("3PpOX");

var $htkeB = parcelRequire("htkeB");

var $bKg2i = parcelRequire("bKg2i");
var $8c2a8d1efd8bceb7$var$_class, $8c2a8d1efd8bceb7$var$_descriptor, $8c2a8d1efd8bceb7$var$_descriptor2;
function $8c2a8d1efd8bceb7$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $8c2a8d1efd8bceb7$var$_defineProperty(e, r, t) {
    return (r = $8c2a8d1efd8bceb7$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $8c2a8d1efd8bceb7$var$_toPropertyKey(t) {
    var i = $8c2a8d1efd8bceb7$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $8c2a8d1efd8bceb7$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $8c2a8d1efd8bceb7$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $8c2a8d1efd8bceb7$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $8c2a8d1efd8bceb7$var$PermissionModel = ($8c2a8d1efd8bceb7$var$_class = class PermissionModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $8c2a8d1efd8bceb7$var$_initializerDefineProperty(this, "name", $8c2a8d1efd8bceb7$var$_descriptor, this);
        $8c2a8d1efd8bceb7$var$_initializerDefineProperty(this, "settings", $8c2a8d1efd8bceb7$var$_descriptor2, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $5JL5P.default);
        this.init(data, options);
    }
    get staff() {
        return (0, $htkeB.default).staffByPermissionsId[this.id] || [];
    }
    get key() {
        return (0, $bKg2i.getPermissionKey)(this.settings);
    }
}, $8c2a8d1efd8bceb7$var$_descriptor = $8c2a8d1efd8bceb7$var$_applyDecoratedDescriptor($8c2a8d1efd8bceb7$var$_class.prototype, "name", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $8c2a8d1efd8bceb7$var$_descriptor2 = $8c2a8d1efd8bceb7$var$_applyDecoratedDescriptor($8c2a8d1efd8bceb7$var$_class.prototype, "settings", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $8c2a8d1efd8bceb7$var$_applyDecoratedDescriptor($8c2a8d1efd8bceb7$var$_class.prototype, "staff", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($8c2a8d1efd8bceb7$var$_class.prototype, "staff"), $8c2a8d1efd8bceb7$var$_class.prototype), $8c2a8d1efd8bceb7$var$_applyDecoratedDescriptor($8c2a8d1efd8bceb7$var$_class.prototype, "key", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($8c2a8d1efd8bceb7$var$_class.prototype, "key"), $8c2a8d1efd8bceb7$var$_class.prototype), $8c2a8d1efd8bceb7$var$_class);
var $8c2a8d1efd8bceb7$export$2e2bcd8739ae039 = $8c2a8d1efd8bceb7$var$PermissionModel;

});
parcelRegister("bKg2i", function(module, exports) {

$parcel$export(module.exports, "getPermissionKey", function () { return $88d06e00faf05995$export$69888f9528531d62; });

var $5Oj0k = parcelRequire("5Oj0k");

var $eat5C = parcelRequire("eat5C");
const $88d06e00faf05995$export$69888f9528531d62 = (permissions)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($5Oj0k)))($88d06e00faf05995$var$normalizePermissions(permissions));
};
const $88d06e00faf05995$var$normalizePermissions = (permissions = {})=>{
    var _permissions, _permissions$canViewO, _permissions2, _permissions2$canView, _permissions3, _permissions3$canView, _permissions4, _permissions4$holiday, _permissions5, _permissions5$invoice, _permissions6, _permissions6$operati, _permissions7, _permissions7$organis, _permissions8, _permissions8$rolePer, _permissions9, _permissions9$staffPe;
    permissions = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).cloneDeep(permissions);
    if (!permissions) return {};
    delete permissions.id;
    delete permissions.uuid;
    const revHidden = permissions.canViewRevenueForecast === "hidden";
    const staffHidden = permissions.staffPermissions === "hidden";
    (_permissions$canViewO = (_permissions = permissions).canViewOperationalExpenses) !== null && _permissions$canViewO !== void 0 ? _permissions$canViewO : _permissions.canViewOperationalExpenses = false;
    (_permissions2$canView = (_permissions2 = permissions).canViewResourceSchedule) !== null && _permissions2$canView !== void 0 ? _permissions2$canView : _permissions2.canViewResourceSchedule = false;
    permissions.canViewRevenueForecast = revHidden || !permissions.canViewRevenueForecast ? false : permissions.canViewRevenueForecast;
    permissions.canViewStaffExpenses = revHidden || !permissions.canViewStaffExpenses ? false : permissions.canViewStaffExpenses;
    (_permissions3$canView = (_permissions3 = permissions).canViewWeeklyPlanner) !== null && _permissions3$canView !== void 0 ? _permissions3$canView : _permissions3.canViewWeeklyPlanner = false;
    permissions.chargeOutRate = staffHidden || !permissions.chargeOutRate ? "hidden" : permissions.chargeOutRate;
    permissions.contacts = [
        "view",
        "edit"
    ].includes(permissions.contacts) ? permissions.contacts : "view";
    permissions.costCentres = [
        "view",
        "edit"
    ].includes(permissions.costCentres) ? permissions.costCentres : "view";
    permissions.costRate = staffHidden || !permissions.costRate ? "hidden" : permissions.costRate;
    permissions.editStaffTime = staffHidden || !permissions.editStaffTime ? false : permissions.editStaffTime;
    (_permissions4$holiday = (_permissions4 = permissions).holidays) !== null && _permissions4$holiday !== void 0 ? _permissions4$holiday : _permissions4.holidays = "hidden";
    (_permissions5$invoice = (_permissions5 = permissions).invoiceSettings) !== null && _permissions5$invoice !== void 0 ? _permissions5$invoice : _permissions5.invoiceSettings = "hidden";
    (_permissions6$operati = (_permissions6 = permissions).operationalExpenses) !== null && _permissions6$operati !== void 0 ? _permissions6$operati : _permissions6.operationalExpenses = "hidden";
    (_permissions7$organis = (_permissions7 = permissions).organisationSettings) !== null && _permissions7$organis !== void 0 ? _permissions7$organis : _permissions7.organisationSettings = "hidden";
    permissions.overtimeRate = staffHidden || !permissions.overtimeRate ? "hidden" : permissions.overtimeRate;
    permissions.payRate = staffHidden || !permissions.payRate ? "hidden" : permissions.payRate;
    (_permissions8$rolePer = (_permissions8 = permissions).rolePermissions) !== null && _permissions8$rolePer !== void 0 ? _permissions8$rolePer : _permissions8.rolePermissions = "hidden";
    (_permissions9$staffPe = (_permissions9 = permissions).staffPermissions) !== null && _permissions9$staffPe !== void 0 ? _permissions9$staffPe : _permissions9.staffPermissions = "hidden";
    permissions.projects = permissions.projects.map((pp)=>{
        delete pp.id;
        delete pp.uuid;
        const p = pp.permissions;
        if (!p) return pp;
        const pHidden = p.projectPermissions === "hidden";
        p.projectDates = pHidden || !p.projectDates ? "view" : p.projectDates;
        p.projectExpenseBudgets = pHidden || !p.projectExpenseBudgets ? "hidden" : p.projectExpenseBudgets;
        p.projectExpenses = pHidden || !p.projectExpenses ? "hidden" : p.projectExpenses;
        p.projectFees = pHidden || !p.projectFees ? "hidden" : p.projectFees;
        p.projectForecastedHours = pHidden || !p.projectForecastedHours ? "view" : p.projectForecastedHours;
        p.projectForecastedRevenue = pHidden || !p.projectForecastedRevenue ? "hidden" : p.projectForecastedRevenue;
        p.projectHoursBudgets = pHidden || !p.projectHoursBudgets ? "view" : p.projectHoursBudgets;
        p.projectInvoices = pHidden || !p.projectInvoices ? "hidden" : p.projectInvoices;
        p.projectNotes = pHidden || !p.projectNotes ? "hidden" : p.projectNotes;
        p.projectPermissions = pHidden || !p.projectPermissions ? "hidden" : p.projectPermissions;
        p.projectPhasesTasks = pHidden || !p.projectPhasesTasks ? "view" : p.projectPhasesTasks;
        p.projectRates = pHidden || !p.projectRates ? "hidden" : p.projectRates;
        p.projectStaffBudgets = pHidden || !p.projectStaffBudgets ? "view" : p.projectStaffBudgets;
        p.projectTimesheets = pHidden || !p.projectTimesheets ? true : p.projectTimesheets;
        return pp;
    });
    return permissions;
};

});
parcelRegister("5Oj0k", function(module, exports) {
"use strict";
module.exports = function(data, opts) {
    if (!opts) opts = {};
    if (typeof opts === "function") opts = {
        cmp: opts
    };
    var cycles = typeof opts.cycles === "boolean" ? opts.cycles : false;
    var cmp = opts.cmp && function(f) {
        return function(node) {
            return function(a, b) {
                var aobj = {
                    key: a,
                    value: node[a]
                };
                var bobj = {
                    key: b,
                    value: node[b]
                };
                return f(aobj, bobj);
            };
        };
    }(opts.cmp);
    var seen = [];
    return function stringify(node) {
        if (node && node.toJSON && typeof node.toJSON === "function") node = node.toJSON();
        if (node === undefined) return;
        if (typeof node == "number") return isFinite(node) ? "" + node : "null";
        if (typeof node !== "object") return JSON.stringify(node);
        var i, out;
        if (Array.isArray(node)) {
            out = "[";
            for(i = 0; i < node.length; i++){
                if (i) out += ",";
                out += stringify(node[i]) || "null";
            }
            return out + "]";
        }
        if (node === null) return "null";
        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify("__cycle__");
            throw new TypeError("Converting circular structure to JSON");
        }
        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = "";
        for(i = 0; i < keys.length; i++){
            var key = keys[i];
            var value = stringify(node[key]);
            if (!value) continue;
            if (out) out += ",";
            out += JSON.stringify(key) + ":" + value;
        }
        seen.splice(seenIndex, 1);
        return "{" + out + "}";
    }(data);
};

});




parcelRegister("ermXU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a83566bcfac8f5c1$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "ProjectExpenseAggregateCollectionClass", function () { return $a83566bcfac8f5c1$export$d72ddc0b5eb1bc01; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $1kjVt = parcelRequire("1kjVt");

var $gTzRd = parcelRequire("gTzRd");
var $a83566bcfac8f5c1$var$_dec, $a83566bcfac8f5c1$var$_dec2, $a83566bcfac8f5c1$var$_class;
function $a83566bcfac8f5c1$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
class $a83566bcfac8f5c1$var$ProjectExpenseAggregate extends (0, $1kjVt.default) {
    constructor(){
        super({
            collectionClass: $a83566bcfac8f5c1$var$ProjectExpenseAggregateCollection
        });
        (0, $4JcCM.makeObservable)(this);
    }
}
let $a83566bcfac8f5c1$var$ProjectExpenseAggregateCollection = ($a83566bcfac8f5c1$var$_dec = (0, $4JcCM.action).bound, $a83566bcfac8f5c1$var$_dec2 = (0, $4JcCM.action).bound, $a83566bcfac8f5c1$var$_class = class ProjectExpenseAggregateCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "projectExpenses",
            modelClass: (0, $gTzRd.default)
        });
        this.addLookup("expensesByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("expensesByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("expensesByStatus", "manyByKey", {
            key: (t)=>t.status,
            filter: (t)=>!t.deletedAt
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get projectExpensesById() {
        return this.modelsById;
    }
    get projectExpenses() {
        return this.models;
    }
    get projectExpensesById() {
        return this.modelsById;
    }
    addProjectExpense(data) {
        this.add(data);
    }
    addProjectExpenses(data) {
        this.addMany(data);
    }
}, $a83566bcfac8f5c1$var$_applyDecoratedDescriptor($a83566bcfac8f5c1$var$_class.prototype, "addProjectExpense", [
    $a83566bcfac8f5c1$var$_dec
], Object.getOwnPropertyDescriptor($a83566bcfac8f5c1$var$_class.prototype, "addProjectExpense"), $a83566bcfac8f5c1$var$_class.prototype), $a83566bcfac8f5c1$var$_applyDecoratedDescriptor($a83566bcfac8f5c1$var$_class.prototype, "addProjectExpenses", [
    $a83566bcfac8f5c1$var$_dec2
], Object.getOwnPropertyDescriptor($a83566bcfac8f5c1$var$_class.prototype, "addProjectExpenses"), $a83566bcfac8f5c1$var$_class.prototype), $a83566bcfac8f5c1$var$_class);
var $a83566bcfac8f5c1$export$2e2bcd8739ae039 = new $a83566bcfac8f5c1$var$ProjectExpenseAggregate();
const $a83566bcfac8f5c1$export$d72ddc0b5eb1bc01 = $a83566bcfac8f5c1$var$ProjectExpenseAggregateCollection;

});
parcelRegister("gTzRd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4cd98e5aacc47cd$export$2e2bcd8739ae039; });


var $4JcCM = parcelRequire("4JcCM");

var $XoImS = parcelRequire("XoImS");

var $gJT7h = parcelRequire("gJT7h");

var $ermXU = parcelRequire("ermXU");

var $d4jhX = parcelRequire("d4jhX");

var $3PpOX = parcelRequire("3PpOX");
var $c4cd98e5aacc47cd$var$_class, $c4cd98e5aacc47cd$var$_descriptor, $c4cd98e5aacc47cd$var$_descriptor2, $c4cd98e5aacc47cd$var$_descriptor3, $c4cd98e5aacc47cd$var$_descriptor4, $c4cd98e5aacc47cd$var$_descriptor5, $c4cd98e5aacc47cd$var$_descriptor6, $c4cd98e5aacc47cd$var$_descriptor7, $c4cd98e5aacc47cd$var$_descriptor8, $c4cd98e5aacc47cd$var$_descriptor9;
function $c4cd98e5aacc47cd$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $c4cd98e5aacc47cd$var$_defineProperty(e, r, t) {
    return (r = $c4cd98e5aacc47cd$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $c4cd98e5aacc47cd$var$_toPropertyKey(t) {
    var i = $c4cd98e5aacc47cd$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $c4cd98e5aacc47cd$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $c4cd98e5aacc47cd$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $c4cd98e5aacc47cd$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $c4cd98e5aacc47cd$var$ProjectExpenseAggregateModel = ($c4cd98e5aacc47cd$var$_class = class ProjectExpenseAggregateModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $c4cd98e5aacc47cd$var$_initializerDefineProperty(this, "projectId", $c4cd98e5aacc47cd$var$_descriptor, this);
        $c4cd98e5aacc47cd$var$_initializerDefineProperty(this, "phaseId", $c4cd98e5aacc47cd$var$_descriptor2, this);
        $c4cd98e5aacc47cd$var$_initializerDefineProperty(this, "name", $c4cd98e5aacc47cd$var$_descriptor3, this);
        $c4cd98e5aacc47cd$var$_initializerDefineProperty(this, "quantity", $c4cd98e5aacc47cd$var$_descriptor4, this);
        $c4cd98e5aacc47cd$var$_initializerDefineProperty(this, "unitCost", $c4cd98e5aacc47cd$var$_descriptor5, this);
        $c4cd98e5aacc47cd$var$_initializerDefineProperty(this, "billable", $c4cd98e5aacc47cd$var$_descriptor6, this);
        $c4cd98e5aacc47cd$var$_initializerDefineProperty(this, "cost", $c4cd98e5aacc47cd$var$_descriptor7, this);
        $c4cd98e5aacc47cd$var$_initializerDefineProperty(this, "startDate", $c4cd98e5aacc47cd$var$_descriptor8, this);
        $c4cd98e5aacc47cd$var$_initializerDefineProperty(this, "endDate", $c4cd98e5aacc47cd$var$_descriptor9, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $ermXU.default);
        this.init(data, options);
    }
    get project() {
        return (0, $gJT7h.default).modelsById[this.projectId];
    }
    get phase() {
        return (0, $XoImS.default).modelsById[this.phaseId];
    }
    get allocations() {
        return (0, $d4jhX.default).expenseAllocationsByExpenseId[this.id];
    }
}, $c4cd98e5aacc47cd$var$_descriptor = $c4cd98e5aacc47cd$var$_applyDecoratedDescriptor($c4cd98e5aacc47cd$var$_class.prototype, "projectId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c4cd98e5aacc47cd$var$_descriptor2 = $c4cd98e5aacc47cd$var$_applyDecoratedDescriptor($c4cd98e5aacc47cd$var$_class.prototype, "phaseId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c4cd98e5aacc47cd$var$_descriptor3 = $c4cd98e5aacc47cd$var$_applyDecoratedDescriptor($c4cd98e5aacc47cd$var$_class.prototype, "name", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c4cd98e5aacc47cd$var$_descriptor4 = $c4cd98e5aacc47cd$var$_applyDecoratedDescriptor($c4cd98e5aacc47cd$var$_class.prototype, "quantity", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c4cd98e5aacc47cd$var$_descriptor5 = $c4cd98e5aacc47cd$var$_applyDecoratedDescriptor($c4cd98e5aacc47cd$var$_class.prototype, "unitCost", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c4cd98e5aacc47cd$var$_descriptor6 = $c4cd98e5aacc47cd$var$_applyDecoratedDescriptor($c4cd98e5aacc47cd$var$_class.prototype, "billable", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c4cd98e5aacc47cd$var$_descriptor7 = $c4cd98e5aacc47cd$var$_applyDecoratedDescriptor($c4cd98e5aacc47cd$var$_class.prototype, "cost", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c4cd98e5aacc47cd$var$_descriptor8 = $c4cd98e5aacc47cd$var$_applyDecoratedDescriptor($c4cd98e5aacc47cd$var$_class.prototype, "startDate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c4cd98e5aacc47cd$var$_descriptor9 = $c4cd98e5aacc47cd$var$_applyDecoratedDescriptor($c4cd98e5aacc47cd$var$_class.prototype, "endDate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c4cd98e5aacc47cd$var$_applyDecoratedDescriptor($c4cd98e5aacc47cd$var$_class.prototype, "project", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c4cd98e5aacc47cd$var$_class.prototype, "project"), $c4cd98e5aacc47cd$var$_class.prototype), $c4cd98e5aacc47cd$var$_applyDecoratedDescriptor($c4cd98e5aacc47cd$var$_class.prototype, "phase", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c4cd98e5aacc47cd$var$_class.prototype, "phase"), $c4cd98e5aacc47cd$var$_class.prototype), $c4cd98e5aacc47cd$var$_applyDecoratedDescriptor($c4cd98e5aacc47cd$var$_class.prototype, "allocations", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c4cd98e5aacc47cd$var$_class.prototype, "allocations"), $c4cd98e5aacc47cd$var$_class.prototype), $c4cd98e5aacc47cd$var$_class);
var $c4cd98e5aacc47cd$export$2e2bcd8739ae039 = $c4cd98e5aacc47cd$var$ProjectExpenseAggregateModel;

});


parcelRegister("cTdgh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9624e89636999519$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "DailyAllocationAggregateCollectionClass", function () { return $9624e89636999519$export$daa479bc7a97193c; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $hZQN9 = parcelRequire("hZQN9");

var $1kjVt = parcelRequire("1kjVt");
parcelRequire("62nmb");

var $f44xu = parcelRequire("f44xu");
var $9624e89636999519$var$_dec, $9624e89636999519$var$_dec2, $9624e89636999519$var$_class;
function $9624e89636999519$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
class $9624e89636999519$var$DailyAllocationAggregate extends (0, $1kjVt.default) {
    constructor(){
        super({
            collectionClass: $9624e89636999519$var$DailyAllocationAggregateCollection
        });
        (0, $4JcCM.makeObservable)(this);
    }
}
let $9624e89636999519$var$DailyAllocationAggregateCollection = ($9624e89636999519$var$_dec = (0, $4JcCM.action).bound, $9624e89636999519$var$_dec2 = (0, $4JcCM.action).bound, $9624e89636999519$var$_class = class DailyAllocationAggregateCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "dailyAllocations",
            modelClass: (0, $hZQN9.default)
        });
        this.addLookup("dailyAllocationsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("dailyAllocationsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("dailyAllocationsByStaffId", "manyByKey", {
            key: (t)=>t.staffId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("dailyAllocationsByRoleId", "manyByKey", {
            key: (t)=>{
                var _t$staff;
                return t.roleId || ((_t$staff = t.staff) === null || _t$staff === void 0 ? void 0 : _t$staff.roleId);
            },
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("dailyAllocationsByMonth", "manyByKey", {
            key: (t)=>t.month,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("dailyAllocationsByModelTuple", "manyByMany", {
            keys: (t)=>{
                var _t$project, _t$phase, _t$role, _t$staff2, _t$project2, _t$phase2, _t$project3, _t$role2, _t$project4, _t$staff3, _t$phase3, _t$role3, _t$phase4, _t$staff4, _t$role4, _t$staff5, _t$project5, _t$phase5, _t$role5, _t$project6, _t$phase6, _t$staff6, _t$project7, _t$role6, _t$staff7, _t$phase7, _t$role7, _t$staff8, _t$project8, _t$phase8, _t$role8, _t$staff9;
                return [
                    (0, $f44xu.default)((_t$project = t.project) === null || _t$project === void 0 ? void 0 : _t$project.id, undefined, undefined, undefined),
                    (0, $f44xu.default)(undefined, (_t$phase = t.phase) === null || _t$phase === void 0 ? void 0 : _t$phase.id, undefined, undefined),
                    (0, $f44xu.default)(undefined, undefined, (_t$role = t.role) === null || _t$role === void 0 ? void 0 : _t$role.id, undefined),
                    (0, $f44xu.default)(undefined, undefined, undefined, (_t$staff2 = t.staff) === null || _t$staff2 === void 0 ? void 0 : _t$staff2.id),
                    (0, $f44xu.default)((_t$project2 = t.project) === null || _t$project2 === void 0 ? void 0 : _t$project2.id, (_t$phase2 = t.phase) === null || _t$phase2 === void 0 ? void 0 : _t$phase2.id, undefined, undefined),
                    (0, $f44xu.default)((_t$project3 = t.project) === null || _t$project3 === void 0 ? void 0 : _t$project3.id, undefined, (_t$role2 = t.role) === null || _t$role2 === void 0 ? void 0 : _t$role2.id, undefined),
                    (0, $f44xu.default)((_t$project4 = t.project) === null || _t$project4 === void 0 ? void 0 : _t$project4.id, undefined, undefined, (_t$staff3 = t.staff) === null || _t$staff3 === void 0 ? void 0 : _t$staff3.id),
                    (0, $f44xu.default)(undefined, (_t$phase3 = t.phase) === null || _t$phase3 === void 0 ? void 0 : _t$phase3.id, (_t$role3 = t.role) === null || _t$role3 === void 0 ? void 0 : _t$role3.id, undefined),
                    (0, $f44xu.default)(undefined, (_t$phase4 = t.phase) === null || _t$phase4 === void 0 ? void 0 : _t$phase4.id, undefined, (_t$staff4 = t.staff) === null || _t$staff4 === void 0 ? void 0 : _t$staff4.id),
                    (0, $f44xu.default)(undefined, undefined, (_t$role4 = t.role) === null || _t$role4 === void 0 ? void 0 : _t$role4.id, (_t$staff5 = t.staff) === null || _t$staff5 === void 0 ? void 0 : _t$staff5.id),
                    (0, $f44xu.default)((_t$project5 = t.project) === null || _t$project5 === void 0 ? void 0 : _t$project5.id, (_t$phase5 = t.phase) === null || _t$phase5 === void 0 ? void 0 : _t$phase5.id, (_t$role5 = t.role) === null || _t$role5 === void 0 ? void 0 : _t$role5.id, undefined),
                    (0, $f44xu.default)((_t$project6 = t.project) === null || _t$project6 === void 0 ? void 0 : _t$project6.id, (_t$phase6 = t.phase) === null || _t$phase6 === void 0 ? void 0 : _t$phase6.id, undefined, (_t$staff6 = t.staff) === null || _t$staff6 === void 0 ? void 0 : _t$staff6.id),
                    (0, $f44xu.default)((_t$project7 = t.project) === null || _t$project7 === void 0 ? void 0 : _t$project7.id, undefined, (_t$role6 = t.role) === null || _t$role6 === void 0 ? void 0 : _t$role6.id, (_t$staff7 = t.staff) === null || _t$staff7 === void 0 ? void 0 : _t$staff7.id),
                    (0, $f44xu.default)(undefined, (_t$phase7 = t.phase) === null || _t$phase7 === void 0 ? void 0 : _t$phase7.id, (_t$role7 = t.role) === null || _t$role7 === void 0 ? void 0 : _t$role7.id, (_t$staff8 = t.staff) === null || _t$staff8 === void 0 ? void 0 : _t$staff8.id),
                    (0, $f44xu.default)((_t$project8 = t.project) === null || _t$project8 === void 0 ? void 0 : _t$project8.id, (_t$phase8 = t.phase) === null || _t$phase8 === void 0 ? void 0 : _t$phase8.id, (_t$role8 = t.role) === null || _t$role8 === void 0 ? void 0 : _t$role8.id, (_t$staff9 = t.staff) === null || _t$staff9 === void 0 ? void 0 : _t$staff9.id)
                ];
            },
            filter: (t)=>!t.deletedAt
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get dailyAllocationsById() {
        return this.modelsById;
    }
    get dailyAllocations() {
        return this.models;
    }
    get dailyAllocationsById() {
        return this.modelsById;
    }
    addDailyAllocation(data) {
        this.add(data);
    }
    addDailyAllocations(data) {
        this.addMany(data);
    }
}, $9624e89636999519$var$_applyDecoratedDescriptor($9624e89636999519$var$_class.prototype, "addDailyAllocation", [
    $9624e89636999519$var$_dec
], Object.getOwnPropertyDescriptor($9624e89636999519$var$_class.prototype, "addDailyAllocation"), $9624e89636999519$var$_class.prototype), $9624e89636999519$var$_applyDecoratedDescriptor($9624e89636999519$var$_class.prototype, "addDailyAllocations", [
    $9624e89636999519$var$_dec2
], Object.getOwnPropertyDescriptor($9624e89636999519$var$_class.prototype, "addDailyAllocations"), $9624e89636999519$var$_class.prototype), $9624e89636999519$var$_class);
var $9624e89636999519$export$2e2bcd8739ae039 = new $9624e89636999519$var$DailyAllocationAggregate();
const $9624e89636999519$export$daa479bc7a97193c = $9624e89636999519$var$DailyAllocationAggregateCollection;

});
parcelRegister("hZQN9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1a11584720f8a6d$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $htkeB = parcelRequire("htkeB");

var $gJT7h = parcelRequire("gJT7h");

var $XoImS = parcelRequire("XoImS");

var $3PpOX = parcelRequire("3PpOX");

var $cTdgh = parcelRequire("cTdgh");

var $4hBm1 = parcelRequire("4hBm1");

var $bxXv3 = parcelRequire("bxXv3");
var $d1a11584720f8a6d$var$_class, $d1a11584720f8a6d$var$_descriptor, $d1a11584720f8a6d$var$_descriptor2, $d1a11584720f8a6d$var$_descriptor3, $d1a11584720f8a6d$var$_descriptor4, $d1a11584720f8a6d$var$_descriptor5, $d1a11584720f8a6d$var$_descriptor6, $d1a11584720f8a6d$var$_descriptor7, $d1a11584720f8a6d$var$_descriptor8, $d1a11584720f8a6d$var$_descriptor9, $d1a11584720f8a6d$var$_descriptor10, $d1a11584720f8a6d$var$_descriptor11;
function $d1a11584720f8a6d$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $d1a11584720f8a6d$var$_defineProperty(e, r, t) {
    return (r = $d1a11584720f8a6d$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $d1a11584720f8a6d$var$_toPropertyKey(t) {
    var i = $d1a11584720f8a6d$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $d1a11584720f8a6d$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $d1a11584720f8a6d$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $d1a11584720f8a6d$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $d1a11584720f8a6d$var$DailyAllocationAggregateModel = ($d1a11584720f8a6d$var$_class = class DailyAllocationAggregateModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $d1a11584720f8a6d$var$_initializerDefineProperty(this, "staffId", $d1a11584720f8a6d$var$_descriptor, this);
        $d1a11584720f8a6d$var$_initializerDefineProperty(this, "projectId", $d1a11584720f8a6d$var$_descriptor2, this);
        $d1a11584720f8a6d$var$_initializerDefineProperty(this, "phaseId", $d1a11584720f8a6d$var$_descriptor3, this);
        $d1a11584720f8a6d$var$_initializerDefineProperty(this, "month", $d1a11584720f8a6d$var$_descriptor4, this);
        $d1a11584720f8a6d$var$_initializerDefineProperty(this, "numMinutes", $d1a11584720f8a6d$var$_descriptor5, this);
        $d1a11584720f8a6d$var$_initializerDefineProperty(this, "pay", $d1a11584720f8a6d$var$_descriptor6, this);
        $d1a11584720f8a6d$var$_initializerDefineProperty(this, "cost", $d1a11584720f8a6d$var$_descriptor7, this);
        $d1a11584720f8a6d$var$_initializerDefineProperty(this, "chargeOut", $d1a11584720f8a6d$var$_descriptor8, this);
        $d1a11584720f8a6d$var$_initializerDefineProperty(this, "isBillable", $d1a11584720f8a6d$var$_descriptor9, this);
        $d1a11584720f8a6d$var$_initializerDefineProperty(this, "isVariation", $d1a11584720f8a6d$var$_descriptor10, this);
        $d1a11584720f8a6d$var$_initializerDefineProperty(this, "beenInvoiced", $d1a11584720f8a6d$var$_descriptor11, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $cTdgh.default);
        this.init(data, options);
    }
    get staff() {
        return (0, $htkeB.default).modelsById[this.staffId];
    }
    get role() {
        var _this$staff;
        return ((_this$staff = this.staff) === null || _this$staff === void 0 ? void 0 : _this$staff.role) || (0, $bxXv3.default).modelsById[this.roleId];
    }
    get project() {
        return (0, $gJT7h.default).modelsById[this.projectId];
    }
    get phase() {
        return (0, $XoImS.default).modelsById[this.phaseId];
    }
    get date() {
        return (0, $4hBm1.parse)(this.month, "yyyy-MM", new Date());
    }
    get startDate() {
        return (0, $4hBm1.startOfMonth)((0, $4hBm1.parse)(this.month, "yyyy-MM", new Date()));
    }
    get endDate() {
        return (0, $4hBm1.endOfMonth)((0, $4hBm1.parse)(this.month, "yyyy-MM", new Date()));
    }
    get hours() {
        return this.numMinutes / 60;
    }
}, $d1a11584720f8a6d$var$_descriptor = $d1a11584720f8a6d$var$_applyDecoratedDescriptor($d1a11584720f8a6d$var$_class.prototype, "staffId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d1a11584720f8a6d$var$_descriptor2 = $d1a11584720f8a6d$var$_applyDecoratedDescriptor($d1a11584720f8a6d$var$_class.prototype, "projectId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d1a11584720f8a6d$var$_descriptor3 = $d1a11584720f8a6d$var$_applyDecoratedDescriptor($d1a11584720f8a6d$var$_class.prototype, "phaseId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d1a11584720f8a6d$var$_descriptor4 = $d1a11584720f8a6d$var$_applyDecoratedDescriptor($d1a11584720f8a6d$var$_class.prototype, "month", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "";
    }
}), $d1a11584720f8a6d$var$_descriptor5 = $d1a11584720f8a6d$var$_applyDecoratedDescriptor($d1a11584720f8a6d$var$_class.prototype, "numMinutes", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $d1a11584720f8a6d$var$_descriptor6 = $d1a11584720f8a6d$var$_applyDecoratedDescriptor($d1a11584720f8a6d$var$_class.prototype, "pay", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $d1a11584720f8a6d$var$_descriptor7 = $d1a11584720f8a6d$var$_applyDecoratedDescriptor($d1a11584720f8a6d$var$_class.prototype, "cost", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $d1a11584720f8a6d$var$_descriptor8 = $d1a11584720f8a6d$var$_applyDecoratedDescriptor($d1a11584720f8a6d$var$_class.prototype, "chargeOut", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $d1a11584720f8a6d$var$_descriptor9 = $d1a11584720f8a6d$var$_applyDecoratedDescriptor($d1a11584720f8a6d$var$_class.prototype, "isBillable", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d1a11584720f8a6d$var$_descriptor10 = $d1a11584720f8a6d$var$_applyDecoratedDescriptor($d1a11584720f8a6d$var$_class.prototype, "isVariation", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d1a11584720f8a6d$var$_descriptor11 = $d1a11584720f8a6d$var$_applyDecoratedDescriptor($d1a11584720f8a6d$var$_class.prototype, "beenInvoiced", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d1a11584720f8a6d$var$_applyDecoratedDescriptor($d1a11584720f8a6d$var$_class.prototype, "staff", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($d1a11584720f8a6d$var$_class.prototype, "staff"), $d1a11584720f8a6d$var$_class.prototype), $d1a11584720f8a6d$var$_applyDecoratedDescriptor($d1a11584720f8a6d$var$_class.prototype, "role", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($d1a11584720f8a6d$var$_class.prototype, "role"), $d1a11584720f8a6d$var$_class.prototype), $d1a11584720f8a6d$var$_applyDecoratedDescriptor($d1a11584720f8a6d$var$_class.prototype, "project", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($d1a11584720f8a6d$var$_class.prototype, "project"), $d1a11584720f8a6d$var$_class.prototype), $d1a11584720f8a6d$var$_applyDecoratedDescriptor($d1a11584720f8a6d$var$_class.prototype, "phase", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($d1a11584720f8a6d$var$_class.prototype, "phase"), $d1a11584720f8a6d$var$_class.prototype), $d1a11584720f8a6d$var$_applyDecoratedDescriptor($d1a11584720f8a6d$var$_class.prototype, "date", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($d1a11584720f8a6d$var$_class.prototype, "date"), $d1a11584720f8a6d$var$_class.prototype), $d1a11584720f8a6d$var$_applyDecoratedDescriptor($d1a11584720f8a6d$var$_class.prototype, "startDate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($d1a11584720f8a6d$var$_class.prototype, "startDate"), $d1a11584720f8a6d$var$_class.prototype), $d1a11584720f8a6d$var$_applyDecoratedDescriptor($d1a11584720f8a6d$var$_class.prototype, "endDate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($d1a11584720f8a6d$var$_class.prototype, "endDate"), $d1a11584720f8a6d$var$_class.prototype), $d1a11584720f8a6d$var$_applyDecoratedDescriptor($d1a11584720f8a6d$var$_class.prototype, "hours", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($d1a11584720f8a6d$var$_class.prototype, "hours"), $d1a11584720f8a6d$var$_class.prototype), $d1a11584720f8a6d$var$_class);
var $d1a11584720f8a6d$export$2e2bcd8739ae039 = $d1a11584720f8a6d$var$DailyAllocationAggregateModel;

});


parcelRegister("8yVxd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63be20ebed832d21$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "AllocationAggregateCollectionClass", function () { return $63be20ebed832d21$export$a8665b634e909b5c; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $k4DS5 = parcelRequire("k4DS5");

var $1kjVt = parcelRequire("1kjVt");
parcelRequire("62nmb");

var $f44xu = parcelRequire("f44xu");
var $63be20ebed832d21$var$_dec, $63be20ebed832d21$var$_dec2, $63be20ebed832d21$var$_class;
function $63be20ebed832d21$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
class $63be20ebed832d21$var$AllocationAggregate extends (0, $1kjVt.default) {
    constructor(){
        super({
            collectionClass: $63be20ebed832d21$var$AllocationAggregateCollection
        });
        (0, $4JcCM.makeObservable)(this);
    }
}
let $63be20ebed832d21$var$AllocationAggregateCollection = ($63be20ebed832d21$var$_dec = (0, $4JcCM.action).bound, $63be20ebed832d21$var$_dec2 = (0, $4JcCM.action).bound, $63be20ebed832d21$var$_class = class AllocationAggregateCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "allocations",
            modelClass: (0, $k4DS5.default)
        });
        this.addLookup("allocationsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByStaffId", "manyByKey", {
            key: (t)=>t.staffId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByRoleId", "manyByKey", {
            key: (t)=>{
                var _t$staff;
                return t.roleId || ((_t$staff = t.staff) === null || _t$staff === void 0 ? void 0 : _t$staff.roleId);
            },
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByMonth", "manyByKey", {
            key: (t)=>t.month,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByModelTuple", "manyByMany", {
            keys: (t)=>{
                var _t$project, _t$phase, _t$role, _t$staff2, _t$project2, _t$phase2, _t$project3, _t$role2, _t$project4, _t$staff3, _t$phase3, _t$role3, _t$phase4, _t$staff4, _t$role4, _t$staff5, _t$project5, _t$phase5, _t$role5, _t$project6, _t$phase6, _t$staff6, _t$project7, _t$role6, _t$staff7, _t$phase7, _t$role7, _t$staff8, _t$project8, _t$phase8, _t$role8, _t$staff9;
                return [
                    (0, $f44xu.default)((_t$project = t.project) === null || _t$project === void 0 ? void 0 : _t$project.id, undefined, undefined, undefined),
                    (0, $f44xu.default)(undefined, (_t$phase = t.phase) === null || _t$phase === void 0 ? void 0 : _t$phase.id, undefined, undefined),
                    (0, $f44xu.default)(undefined, undefined, (_t$role = t.role) === null || _t$role === void 0 ? void 0 : _t$role.id, undefined),
                    (0, $f44xu.default)(undefined, undefined, undefined, (_t$staff2 = t.staff) === null || _t$staff2 === void 0 ? void 0 : _t$staff2.id),
                    (0, $f44xu.default)((_t$project2 = t.project) === null || _t$project2 === void 0 ? void 0 : _t$project2.id, (_t$phase2 = t.phase) === null || _t$phase2 === void 0 ? void 0 : _t$phase2.id, undefined, undefined),
                    (0, $f44xu.default)((_t$project3 = t.project) === null || _t$project3 === void 0 ? void 0 : _t$project3.id, undefined, (_t$role2 = t.role) === null || _t$role2 === void 0 ? void 0 : _t$role2.id, undefined),
                    (0, $f44xu.default)((_t$project4 = t.project) === null || _t$project4 === void 0 ? void 0 : _t$project4.id, undefined, undefined, (_t$staff3 = t.staff) === null || _t$staff3 === void 0 ? void 0 : _t$staff3.id),
                    (0, $f44xu.default)(undefined, (_t$phase3 = t.phase) === null || _t$phase3 === void 0 ? void 0 : _t$phase3.id, (_t$role3 = t.role) === null || _t$role3 === void 0 ? void 0 : _t$role3.id, undefined),
                    (0, $f44xu.default)(undefined, (_t$phase4 = t.phase) === null || _t$phase4 === void 0 ? void 0 : _t$phase4.id, undefined, (_t$staff4 = t.staff) === null || _t$staff4 === void 0 ? void 0 : _t$staff4.id),
                    (0, $f44xu.default)(undefined, undefined, (_t$role4 = t.role) === null || _t$role4 === void 0 ? void 0 : _t$role4.id, (_t$staff5 = t.staff) === null || _t$staff5 === void 0 ? void 0 : _t$staff5.id),
                    (0, $f44xu.default)((_t$project5 = t.project) === null || _t$project5 === void 0 ? void 0 : _t$project5.id, (_t$phase5 = t.phase) === null || _t$phase5 === void 0 ? void 0 : _t$phase5.id, (_t$role5 = t.role) === null || _t$role5 === void 0 ? void 0 : _t$role5.id, undefined),
                    (0, $f44xu.default)((_t$project6 = t.project) === null || _t$project6 === void 0 ? void 0 : _t$project6.id, (_t$phase6 = t.phase) === null || _t$phase6 === void 0 ? void 0 : _t$phase6.id, undefined, (_t$staff6 = t.staff) === null || _t$staff6 === void 0 ? void 0 : _t$staff6.id),
                    (0, $f44xu.default)((_t$project7 = t.project) === null || _t$project7 === void 0 ? void 0 : _t$project7.id, undefined, (_t$role6 = t.role) === null || _t$role6 === void 0 ? void 0 : _t$role6.id, (_t$staff7 = t.staff) === null || _t$staff7 === void 0 ? void 0 : _t$staff7.id),
                    (0, $f44xu.default)(undefined, (_t$phase7 = t.phase) === null || _t$phase7 === void 0 ? void 0 : _t$phase7.id, (_t$role7 = t.role) === null || _t$role7 === void 0 ? void 0 : _t$role7.id, (_t$staff8 = t.staff) === null || _t$staff8 === void 0 ? void 0 : _t$staff8.id),
                    (0, $f44xu.default)((_t$project8 = t.project) === null || _t$project8 === void 0 ? void 0 : _t$project8.id, (_t$phase8 = t.phase) === null || _t$phase8 === void 0 ? void 0 : _t$phase8.id, (_t$role8 = t.role) === null || _t$role8 === void 0 ? void 0 : _t$role8.id, (_t$staff9 = t.staff) === null || _t$staff9 === void 0 ? void 0 : _t$staff9.id)
                ];
            },
            filter: (t)=>!t.deletedAt
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get allocationsById() {
        return this.modelsById;
    }
    get allocations() {
        return this.models;
    }
    get allocationsById() {
        return this.modelsById;
    }
    addAllocation(data) {
        this.add(data);
    }
    addAllocations(data) {
        this.addMany(data);
    }
}, $63be20ebed832d21$var$_applyDecoratedDescriptor($63be20ebed832d21$var$_class.prototype, "addAllocation", [
    $63be20ebed832d21$var$_dec
], Object.getOwnPropertyDescriptor($63be20ebed832d21$var$_class.prototype, "addAllocation"), $63be20ebed832d21$var$_class.prototype), $63be20ebed832d21$var$_applyDecoratedDescriptor($63be20ebed832d21$var$_class.prototype, "addAllocations", [
    $63be20ebed832d21$var$_dec2
], Object.getOwnPropertyDescriptor($63be20ebed832d21$var$_class.prototype, "addAllocations"), $63be20ebed832d21$var$_class.prototype), $63be20ebed832d21$var$_class);
var $63be20ebed832d21$export$2e2bcd8739ae039 = new $63be20ebed832d21$var$AllocationAggregate();
const $63be20ebed832d21$export$a8665b634e909b5c = $63be20ebed832d21$var$AllocationAggregateCollection;

});
parcelRegister("k4DS5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9d31bf9854ee5b9$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $htkeB = parcelRequire("htkeB");

var $gJT7h = parcelRequire("gJT7h");

var $XoImS = parcelRequire("XoImS");

var $3PpOX = parcelRequire("3PpOX");

var $8yVxd = parcelRequire("8yVxd");

var $4hBm1 = parcelRequire("4hBm1");

var $bxXv3 = parcelRequire("bxXv3");
var $e9d31bf9854ee5b9$var$_class, $e9d31bf9854ee5b9$var$_descriptor, $e9d31bf9854ee5b9$var$_descriptor2, $e9d31bf9854ee5b9$var$_descriptor3, $e9d31bf9854ee5b9$var$_descriptor4, $e9d31bf9854ee5b9$var$_descriptor5, $e9d31bf9854ee5b9$var$_descriptor6, $e9d31bf9854ee5b9$var$_descriptor7, $e9d31bf9854ee5b9$var$_descriptor8, $e9d31bf9854ee5b9$var$_descriptor9;
function $e9d31bf9854ee5b9$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $e9d31bf9854ee5b9$var$_defineProperty(e, r, t) {
    return (r = $e9d31bf9854ee5b9$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $e9d31bf9854ee5b9$var$_toPropertyKey(t) {
    var i = $e9d31bf9854ee5b9$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $e9d31bf9854ee5b9$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $e9d31bf9854ee5b9$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $e9d31bf9854ee5b9$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $e9d31bf9854ee5b9$var$AllocationAggregateModel = ($e9d31bf9854ee5b9$var$_class = class AllocationAggregateModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $e9d31bf9854ee5b9$var$_initializerDefineProperty(this, "staffId", $e9d31bf9854ee5b9$var$_descriptor, this);
        $e9d31bf9854ee5b9$var$_initializerDefineProperty(this, "projectId", $e9d31bf9854ee5b9$var$_descriptor2, this);
        $e9d31bf9854ee5b9$var$_initializerDefineProperty(this, "phaseId", $e9d31bf9854ee5b9$var$_descriptor3, this);
        $e9d31bf9854ee5b9$var$_initializerDefineProperty(this, "roleId", $e9d31bf9854ee5b9$var$_descriptor4, this);
        $e9d31bf9854ee5b9$var$_initializerDefineProperty(this, "month", $e9d31bf9854ee5b9$var$_descriptor5, this);
        $e9d31bf9854ee5b9$var$_initializerDefineProperty(this, "numMinutes", $e9d31bf9854ee5b9$var$_descriptor6, this);
        $e9d31bf9854ee5b9$var$_initializerDefineProperty(this, "pay", $e9d31bf9854ee5b9$var$_descriptor7, this);
        $e9d31bf9854ee5b9$var$_initializerDefineProperty(this, "cost", $e9d31bf9854ee5b9$var$_descriptor8, this);
        $e9d31bf9854ee5b9$var$_initializerDefineProperty(this, "chargeOut", $e9d31bf9854ee5b9$var$_descriptor9, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $8yVxd.default);
        this.init(data, options);
    }
    get staff() {
        return (0, $htkeB.default).modelsById[this.staffId];
    }
    get role() {
        var _this$staff;
        return ((_this$staff = this.staff) === null || _this$staff === void 0 ? void 0 : _this$staff.role) || (0, $bxXv3.default).modelsById[this.staffRoleId] || (0, $bxXv3.default).modelsById[this.roleId];
    }
    get project() {
        return (0, $gJT7h.default).modelsById[this.projectId];
    }
    get phase() {
        return (0, $XoImS.default).modelsById[this.phaseId];
    }
    get date() {
        return (0, $4hBm1.parse)(this.month, "yyyy-MM", new Date());
    }
    get startDate() {
        return (0, $4hBm1.startOfMonth)((0, $4hBm1.parse)(this.month, "yyyy-MM", new Date()));
    }
    get endDate() {
        return (0, $4hBm1.endOfMonth)((0, $4hBm1.parse)(this.month, "yyyy-MM", new Date()));
    }
    get hours() {
        return this.numMinutes / 60;
    }
}, $e9d31bf9854ee5b9$var$_descriptor = $e9d31bf9854ee5b9$var$_applyDecoratedDescriptor($e9d31bf9854ee5b9$var$_class.prototype, "staffId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $e9d31bf9854ee5b9$var$_descriptor2 = $e9d31bf9854ee5b9$var$_applyDecoratedDescriptor($e9d31bf9854ee5b9$var$_class.prototype, "projectId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $e9d31bf9854ee5b9$var$_descriptor3 = $e9d31bf9854ee5b9$var$_applyDecoratedDescriptor($e9d31bf9854ee5b9$var$_class.prototype, "phaseId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $e9d31bf9854ee5b9$var$_descriptor4 = $e9d31bf9854ee5b9$var$_applyDecoratedDescriptor($e9d31bf9854ee5b9$var$_class.prototype, "roleId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $e9d31bf9854ee5b9$var$_descriptor5 = $e9d31bf9854ee5b9$var$_applyDecoratedDescriptor($e9d31bf9854ee5b9$var$_class.prototype, "month", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "";
    }
}), $e9d31bf9854ee5b9$var$_descriptor6 = $e9d31bf9854ee5b9$var$_applyDecoratedDescriptor($e9d31bf9854ee5b9$var$_class.prototype, "numMinutes", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $e9d31bf9854ee5b9$var$_descriptor7 = $e9d31bf9854ee5b9$var$_applyDecoratedDescriptor($e9d31bf9854ee5b9$var$_class.prototype, "pay", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $e9d31bf9854ee5b9$var$_descriptor8 = $e9d31bf9854ee5b9$var$_applyDecoratedDescriptor($e9d31bf9854ee5b9$var$_class.prototype, "cost", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $e9d31bf9854ee5b9$var$_descriptor9 = $e9d31bf9854ee5b9$var$_applyDecoratedDescriptor($e9d31bf9854ee5b9$var$_class.prototype, "chargeOut", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $e9d31bf9854ee5b9$var$_applyDecoratedDescriptor($e9d31bf9854ee5b9$var$_class.prototype, "staff", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($e9d31bf9854ee5b9$var$_class.prototype, "staff"), $e9d31bf9854ee5b9$var$_class.prototype), $e9d31bf9854ee5b9$var$_applyDecoratedDescriptor($e9d31bf9854ee5b9$var$_class.prototype, "role", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($e9d31bf9854ee5b9$var$_class.prototype, "role"), $e9d31bf9854ee5b9$var$_class.prototype), $e9d31bf9854ee5b9$var$_applyDecoratedDescriptor($e9d31bf9854ee5b9$var$_class.prototype, "project", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($e9d31bf9854ee5b9$var$_class.prototype, "project"), $e9d31bf9854ee5b9$var$_class.prototype), $e9d31bf9854ee5b9$var$_applyDecoratedDescriptor($e9d31bf9854ee5b9$var$_class.prototype, "phase", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($e9d31bf9854ee5b9$var$_class.prototype, "phase"), $e9d31bf9854ee5b9$var$_class.prototype), $e9d31bf9854ee5b9$var$_applyDecoratedDescriptor($e9d31bf9854ee5b9$var$_class.prototype, "date", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($e9d31bf9854ee5b9$var$_class.prototype, "date"), $e9d31bf9854ee5b9$var$_class.prototype), $e9d31bf9854ee5b9$var$_applyDecoratedDescriptor($e9d31bf9854ee5b9$var$_class.prototype, "startDate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($e9d31bf9854ee5b9$var$_class.prototype, "startDate"), $e9d31bf9854ee5b9$var$_class.prototype), $e9d31bf9854ee5b9$var$_applyDecoratedDescriptor($e9d31bf9854ee5b9$var$_class.prototype, "endDate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($e9d31bf9854ee5b9$var$_class.prototype, "endDate"), $e9d31bf9854ee5b9$var$_class.prototype), $e9d31bf9854ee5b9$var$_applyDecoratedDescriptor($e9d31bf9854ee5b9$var$_class.prototype, "hours", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($e9d31bf9854ee5b9$var$_class.prototype, "hours"), $e9d31bf9854ee5b9$var$_class.prototype), $e9d31bf9854ee5b9$var$_class);
var $e9d31bf9854ee5b9$export$2e2bcd8739ae039 = $e9d31bf9854ee5b9$var$AllocationAggregateModel;

});


parcelRegister("3AXgX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29e2b62d2f4fb1b8$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $6CZMX = parcelRequire("6CZMX");

var $1kjVt = parcelRequire("1kjVt");
parcelRequire("62nmb");

var $f44xu = parcelRequire("f44xu");
var $29e2b62d2f4fb1b8$var$_dec, $29e2b62d2f4fb1b8$var$_dec2, $29e2b62d2f4fb1b8$var$_class;
function $29e2b62d2f4fb1b8$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
class $29e2b62d2f4fb1b8$var$MonthlyAllocationAggregate extends (0, $1kjVt.default) {
    constructor(){
        super({
            collectionClass: $29e2b62d2f4fb1b8$var$MonthlyAllocationAggregateCollection
        });
        (0, $4JcCM.makeObservable)(this);
    }
}
let $29e2b62d2f4fb1b8$var$MonthlyAllocationAggregateCollection = ($29e2b62d2f4fb1b8$var$_dec = (0, $4JcCM.action).bound, $29e2b62d2f4fb1b8$var$_dec2 = (0, $4JcCM.action).bound, $29e2b62d2f4fb1b8$var$_class = class MonthlyAllocationAggregateCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "monthlyAllocations",
            modelClass: (0, $6CZMX.default)
        });
        this.addLookup("allocationsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByStaffId", "manyByKey", {
            key: (t)=>t.staffId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByRoleId", "manyByKey", {
            key: (t)=>{
                var _t$staff;
                return t.roleId || ((_t$staff = t.staff) === null || _t$staff === void 0 ? void 0 : _t$staff.roleId);
            },
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByMonth", "manyByKey", {
            key: (t)=>t.month,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByModelTuple", "manyByMany", {
            keys: (t)=>{
                var _t$project, _t$phase, _t$role, _t$staff2, _t$project2, _t$phase2, _t$project3, _t$role2, _t$project4, _t$staff3, _t$phase3, _t$role3, _t$phase4, _t$staff4, _t$role4, _t$staff5, _t$project5, _t$phase5, _t$role5, _t$project6, _t$phase6, _t$staff6, _t$project7, _t$role6, _t$staff7, _t$phase7, _t$role7, _t$staff8, _t$project8, _t$phase8, _t$role8, _t$staff9;
                return [
                    (0, $f44xu.default)((_t$project = t.project) === null || _t$project === void 0 ? void 0 : _t$project.id, undefined, undefined, undefined),
                    (0, $f44xu.default)(undefined, (_t$phase = t.phase) === null || _t$phase === void 0 ? void 0 : _t$phase.id, undefined, undefined),
                    (0, $f44xu.default)(undefined, undefined, (_t$role = t.role) === null || _t$role === void 0 ? void 0 : _t$role.id, undefined),
                    (0, $f44xu.default)(undefined, undefined, undefined, (_t$staff2 = t.staff) === null || _t$staff2 === void 0 ? void 0 : _t$staff2.id),
                    (0, $f44xu.default)((_t$project2 = t.project) === null || _t$project2 === void 0 ? void 0 : _t$project2.id, (_t$phase2 = t.phase) === null || _t$phase2 === void 0 ? void 0 : _t$phase2.id, undefined, undefined),
                    (0, $f44xu.default)((_t$project3 = t.project) === null || _t$project3 === void 0 ? void 0 : _t$project3.id, undefined, (_t$role2 = t.role) === null || _t$role2 === void 0 ? void 0 : _t$role2.id, undefined),
                    (0, $f44xu.default)((_t$project4 = t.project) === null || _t$project4 === void 0 ? void 0 : _t$project4.id, undefined, undefined, (_t$staff3 = t.staff) === null || _t$staff3 === void 0 ? void 0 : _t$staff3.id),
                    (0, $f44xu.default)(undefined, (_t$phase3 = t.phase) === null || _t$phase3 === void 0 ? void 0 : _t$phase3.id, (_t$role3 = t.role) === null || _t$role3 === void 0 ? void 0 : _t$role3.id, undefined),
                    (0, $f44xu.default)(undefined, (_t$phase4 = t.phase) === null || _t$phase4 === void 0 ? void 0 : _t$phase4.id, undefined, (_t$staff4 = t.staff) === null || _t$staff4 === void 0 ? void 0 : _t$staff4.id),
                    (0, $f44xu.default)(undefined, undefined, (_t$role4 = t.role) === null || _t$role4 === void 0 ? void 0 : _t$role4.id, (_t$staff5 = t.staff) === null || _t$staff5 === void 0 ? void 0 : _t$staff5.id),
                    (0, $f44xu.default)((_t$project5 = t.project) === null || _t$project5 === void 0 ? void 0 : _t$project5.id, (_t$phase5 = t.phase) === null || _t$phase5 === void 0 ? void 0 : _t$phase5.id, (_t$role5 = t.role) === null || _t$role5 === void 0 ? void 0 : _t$role5.id, undefined),
                    (0, $f44xu.default)((_t$project6 = t.project) === null || _t$project6 === void 0 ? void 0 : _t$project6.id, (_t$phase6 = t.phase) === null || _t$phase6 === void 0 ? void 0 : _t$phase6.id, undefined, (_t$staff6 = t.staff) === null || _t$staff6 === void 0 ? void 0 : _t$staff6.id),
                    (0, $f44xu.default)((_t$project7 = t.project) === null || _t$project7 === void 0 ? void 0 : _t$project7.id, undefined, (_t$role6 = t.role) === null || _t$role6 === void 0 ? void 0 : _t$role6.id, (_t$staff7 = t.staff) === null || _t$staff7 === void 0 ? void 0 : _t$staff7.id),
                    (0, $f44xu.default)(undefined, (_t$phase7 = t.phase) === null || _t$phase7 === void 0 ? void 0 : _t$phase7.id, (_t$role7 = t.role) === null || _t$role7 === void 0 ? void 0 : _t$role7.id, (_t$staff8 = t.staff) === null || _t$staff8 === void 0 ? void 0 : _t$staff8.id),
                    (0, $f44xu.default)((_t$project8 = t.project) === null || _t$project8 === void 0 ? void 0 : _t$project8.id, (_t$phase8 = t.phase) === null || _t$phase8 === void 0 ? void 0 : _t$phase8.id, (_t$role8 = t.role) === null || _t$role8 === void 0 ? void 0 : _t$role8.id, (_t$staff9 = t.staff) === null || _t$staff9 === void 0 ? void 0 : _t$staff9.id)
                ];
            },
            filter: (t)=>!t.deletedAt
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get allocationsById() {
        return this.modelsById;
    }
    get allocations() {
        return this.models;
    }
    get allocationsById() {
        return this.modelsById;
    }
    addAllocation(data) {
        this.add(data);
    }
    addAllocations(data) {
        this.addMany(data);
    }
}, $29e2b62d2f4fb1b8$var$_applyDecoratedDescriptor($29e2b62d2f4fb1b8$var$_class.prototype, "addAllocation", [
    $29e2b62d2f4fb1b8$var$_dec
], Object.getOwnPropertyDescriptor($29e2b62d2f4fb1b8$var$_class.prototype, "addAllocation"), $29e2b62d2f4fb1b8$var$_class.prototype), $29e2b62d2f4fb1b8$var$_applyDecoratedDescriptor($29e2b62d2f4fb1b8$var$_class.prototype, "addAllocations", [
    $29e2b62d2f4fb1b8$var$_dec2
], Object.getOwnPropertyDescriptor($29e2b62d2f4fb1b8$var$_class.prototype, "addAllocations"), $29e2b62d2f4fb1b8$var$_class.prototype), $29e2b62d2f4fb1b8$var$_class);
var $29e2b62d2f4fb1b8$export$2e2bcd8739ae039 = new $29e2b62d2f4fb1b8$var$MonthlyAllocationAggregate();
const $29e2b62d2f4fb1b8$export$c9e702474e5b47e2 = $29e2b62d2f4fb1b8$var$MonthlyAllocationAggregateCollection;

});
parcelRegister("6CZMX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d3638999c8e11e5$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $htkeB = parcelRequire("htkeB");

var $gJT7h = parcelRequire("gJT7h");

var $XoImS = parcelRequire("XoImS");

var $3PpOX = parcelRequire("3PpOX");

var $3AXgX = parcelRequire("3AXgX");

var $4hBm1 = parcelRequire("4hBm1");

var $bxXv3 = parcelRequire("bxXv3");
var $4d3638999c8e11e5$var$_class, $4d3638999c8e11e5$var$_descriptor, $4d3638999c8e11e5$var$_descriptor2, $4d3638999c8e11e5$var$_descriptor3, $4d3638999c8e11e5$var$_descriptor4, $4d3638999c8e11e5$var$_descriptor5, $4d3638999c8e11e5$var$_descriptor6, $4d3638999c8e11e5$var$_descriptor7, $4d3638999c8e11e5$var$_descriptor8, $4d3638999c8e11e5$var$_descriptor9;
function $4d3638999c8e11e5$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $4d3638999c8e11e5$var$_defineProperty(e, r, t) {
    return (r = $4d3638999c8e11e5$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4d3638999c8e11e5$var$_toPropertyKey(t) {
    var i = $4d3638999c8e11e5$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $4d3638999c8e11e5$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $4d3638999c8e11e5$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $4d3638999c8e11e5$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $4d3638999c8e11e5$var$MonthlyAllocationAggregateModel = ($4d3638999c8e11e5$var$_class = class MonthlyAllocationAggregateModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $4d3638999c8e11e5$var$_initializerDefineProperty(this, "staffId", $4d3638999c8e11e5$var$_descriptor, this);
        $4d3638999c8e11e5$var$_initializerDefineProperty(this, "projectId", $4d3638999c8e11e5$var$_descriptor2, this);
        $4d3638999c8e11e5$var$_initializerDefineProperty(this, "phaseId", $4d3638999c8e11e5$var$_descriptor3, this);
        $4d3638999c8e11e5$var$_initializerDefineProperty(this, "roleId", $4d3638999c8e11e5$var$_descriptor4, this);
        $4d3638999c8e11e5$var$_initializerDefineProperty(this, "month", $4d3638999c8e11e5$var$_descriptor5, this);
        $4d3638999c8e11e5$var$_initializerDefineProperty(this, "numMinutes", $4d3638999c8e11e5$var$_descriptor6, this);
        $4d3638999c8e11e5$var$_initializerDefineProperty(this, "pay", $4d3638999c8e11e5$var$_descriptor7, this);
        $4d3638999c8e11e5$var$_initializerDefineProperty(this, "cost", $4d3638999c8e11e5$var$_descriptor8, this);
        $4d3638999c8e11e5$var$_initializerDefineProperty(this, "chargeOut", $4d3638999c8e11e5$var$_descriptor9, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $3AXgX.default);
        this.init(data, options);
    }
    get staff() {
        return (0, $htkeB.default).modelsById[this.staffId];
    }
    get role() {
        var _this$staff;
        return ((_this$staff = this.staff) === null || _this$staff === void 0 ? void 0 : _this$staff.role) || (0, $bxXv3.default).modelsById[this.staffRoleId] || (0, $bxXv3.default).modelsById[this.roleId];
    }
    get project() {
        return (0, $gJT7h.default).modelsById[this.projectId];
    }
    get phase() {
        return (0, $XoImS.default).modelsById[this.phaseId];
    }
    get date() {
        return (0, $4hBm1.parse)(this.month, "yyyy-MM", new Date());
    }
    get startDate() {
        return (0, $4hBm1.startOfMonth)((0, $4hBm1.parse)(this.month, "yyyy-MM", new Date()));
    }
    get endDate() {
        return (0, $4hBm1.endOfMonth)((0, $4hBm1.parse)(this.month, "yyyy-MM", new Date()));
    }
    get hours() {
        return this.numMinutes / 60;
    }
}, $4d3638999c8e11e5$var$_descriptor = $4d3638999c8e11e5$var$_applyDecoratedDescriptor($4d3638999c8e11e5$var$_class.prototype, "staffId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $4d3638999c8e11e5$var$_descriptor2 = $4d3638999c8e11e5$var$_applyDecoratedDescriptor($4d3638999c8e11e5$var$_class.prototype, "projectId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $4d3638999c8e11e5$var$_descriptor3 = $4d3638999c8e11e5$var$_applyDecoratedDescriptor($4d3638999c8e11e5$var$_class.prototype, "phaseId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $4d3638999c8e11e5$var$_descriptor4 = $4d3638999c8e11e5$var$_applyDecoratedDescriptor($4d3638999c8e11e5$var$_class.prototype, "roleId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $4d3638999c8e11e5$var$_descriptor5 = $4d3638999c8e11e5$var$_applyDecoratedDescriptor($4d3638999c8e11e5$var$_class.prototype, "month", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "";
    }
}), $4d3638999c8e11e5$var$_descriptor6 = $4d3638999c8e11e5$var$_applyDecoratedDescriptor($4d3638999c8e11e5$var$_class.prototype, "numMinutes", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $4d3638999c8e11e5$var$_descriptor7 = $4d3638999c8e11e5$var$_applyDecoratedDescriptor($4d3638999c8e11e5$var$_class.prototype, "pay", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $4d3638999c8e11e5$var$_descriptor8 = $4d3638999c8e11e5$var$_applyDecoratedDescriptor($4d3638999c8e11e5$var$_class.prototype, "cost", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $4d3638999c8e11e5$var$_descriptor9 = $4d3638999c8e11e5$var$_applyDecoratedDescriptor($4d3638999c8e11e5$var$_class.prototype, "chargeOut", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $4d3638999c8e11e5$var$_applyDecoratedDescriptor($4d3638999c8e11e5$var$_class.prototype, "staff", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($4d3638999c8e11e5$var$_class.prototype, "staff"), $4d3638999c8e11e5$var$_class.prototype), $4d3638999c8e11e5$var$_applyDecoratedDescriptor($4d3638999c8e11e5$var$_class.prototype, "role", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($4d3638999c8e11e5$var$_class.prototype, "role"), $4d3638999c8e11e5$var$_class.prototype), $4d3638999c8e11e5$var$_applyDecoratedDescriptor($4d3638999c8e11e5$var$_class.prototype, "project", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($4d3638999c8e11e5$var$_class.prototype, "project"), $4d3638999c8e11e5$var$_class.prototype), $4d3638999c8e11e5$var$_applyDecoratedDescriptor($4d3638999c8e11e5$var$_class.prototype, "phase", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($4d3638999c8e11e5$var$_class.prototype, "phase"), $4d3638999c8e11e5$var$_class.prototype), $4d3638999c8e11e5$var$_applyDecoratedDescriptor($4d3638999c8e11e5$var$_class.prototype, "date", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($4d3638999c8e11e5$var$_class.prototype, "date"), $4d3638999c8e11e5$var$_class.prototype), $4d3638999c8e11e5$var$_applyDecoratedDescriptor($4d3638999c8e11e5$var$_class.prototype, "startDate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($4d3638999c8e11e5$var$_class.prototype, "startDate"), $4d3638999c8e11e5$var$_class.prototype), $4d3638999c8e11e5$var$_applyDecoratedDescriptor($4d3638999c8e11e5$var$_class.prototype, "endDate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($4d3638999c8e11e5$var$_class.prototype, "endDate"), $4d3638999c8e11e5$var$_class.prototype), $4d3638999c8e11e5$var$_applyDecoratedDescriptor($4d3638999c8e11e5$var$_class.prototype, "hours", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($4d3638999c8e11e5$var$_class.prototype, "hours"), $4d3638999c8e11e5$var$_class.prototype), $4d3638999c8e11e5$var$_class);
var $4d3638999c8e11e5$export$2e2bcd8739ae039 = $4d3638999c8e11e5$var$MonthlyAllocationAggregateModel;

});


parcelRegister("aJ9vI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7cf57bf5315e6317$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "RevenueTargetAggregateCollectionClass", function () { return $7cf57bf5315e6317$export$ba135e6aff5357c; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $1kjVt = parcelRequire("1kjVt");

var $8wpMc = parcelRequire("8wpMc");
var $7cf57bf5315e6317$var$_dec, $7cf57bf5315e6317$var$_dec2, $7cf57bf5315e6317$var$_class;
function $7cf57bf5315e6317$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
class $7cf57bf5315e6317$var$RevenueTargetAggregate extends (0, $1kjVt.default) {
    constructor(){
        super({
            collectionClass: $7cf57bf5315e6317$var$RevenueTargetAggregateCollection
        });
        (0, $4JcCM.makeObservable)(this);
    }
}
let $7cf57bf5315e6317$var$RevenueTargetAggregateCollection = ($7cf57bf5315e6317$var$_dec = (0, $4JcCM.action).bound, $7cf57bf5315e6317$var$_dec2 = (0, $4JcCM.action).bound, $7cf57bf5315e6317$var$_class = class RevenueTargetAggregateCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "revenueTargets",
            modelClass: (0, $8wpMc.default)
        });
        this.addLookup("revenueTargetsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("revenueTargetsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("revenueTargetsByStatus", "manyByKey", {
            key: (t)=>t.status,
            filter: (t)=>!t.deletedAt
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get revenueTargetsById() {
        return this.modelsById;
    }
    get revenueTargets() {
        return this.models;
    }
    get revenueTargetsById() {
        return this.modelsById;
    }
    addRevenueTarget(data) {
        this.add(data);
    }
    addRevenueTargets(data) {
        this.addMany(data);
    }
}, $7cf57bf5315e6317$var$_applyDecoratedDescriptor($7cf57bf5315e6317$var$_class.prototype, "addRevenueTarget", [
    $7cf57bf5315e6317$var$_dec
], Object.getOwnPropertyDescriptor($7cf57bf5315e6317$var$_class.prototype, "addRevenueTarget"), $7cf57bf5315e6317$var$_class.prototype), $7cf57bf5315e6317$var$_applyDecoratedDescriptor($7cf57bf5315e6317$var$_class.prototype, "addRevenueTargets", [
    $7cf57bf5315e6317$var$_dec2
], Object.getOwnPropertyDescriptor($7cf57bf5315e6317$var$_class.prototype, "addRevenueTargets"), $7cf57bf5315e6317$var$_class.prototype), $7cf57bf5315e6317$var$_class);
var $7cf57bf5315e6317$export$2e2bcd8739ae039 = new $7cf57bf5315e6317$var$RevenueTargetAggregate();
const $7cf57bf5315e6317$export$ba135e6aff5357c = $7cf57bf5315e6317$var$RevenueTargetAggregateCollection;

});
parcelRegister("8wpMc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63454e9202437d5f$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");
parcelRequire("bhvQG");
parcelRequire("cxnwP");

var $aJ9vI = parcelRequire("aJ9vI");

var $XoImS = parcelRequire("XoImS");

var $gJT7h = parcelRequire("gJT7h");

var $3PpOX = parcelRequire("3PpOX");
var $63454e9202437d5f$var$_class, $63454e9202437d5f$var$_descriptor, $63454e9202437d5f$var$_descriptor2, $63454e9202437d5f$var$_descriptor3;
function $63454e9202437d5f$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $63454e9202437d5f$var$_defineProperty(e, r, t) {
    return (r = $63454e9202437d5f$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $63454e9202437d5f$var$_toPropertyKey(t) {
    var i = $63454e9202437d5f$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $63454e9202437d5f$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $63454e9202437d5f$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $63454e9202437d5f$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $63454e9202437d5f$var$RevenueTargetAggregateModel = ($63454e9202437d5f$var$_class = class RevenueTargetAggregateModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $63454e9202437d5f$var$_initializerDefineProperty(this, "projectId", $63454e9202437d5f$var$_descriptor, this);
        $63454e9202437d5f$var$_initializerDefineProperty(this, "phaseId", $63454e9202437d5f$var$_descriptor2, this);
        $63454e9202437d5f$var$_initializerDefineProperty(this, "amount", $63454e9202437d5f$var$_descriptor3, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $aJ9vI.default);
        this.init(data, options);
    }
    get project() {
        return (0, $gJT7h.default).projectsById[this.projectId];
    }
    get phase() {
        return (0, $XoImS.default).phasesById[this.phaseId];
    }
}, $63454e9202437d5f$var$_descriptor = $63454e9202437d5f$var$_applyDecoratedDescriptor($63454e9202437d5f$var$_class.prototype, "projectId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $63454e9202437d5f$var$_descriptor2 = $63454e9202437d5f$var$_applyDecoratedDescriptor($63454e9202437d5f$var$_class.prototype, "phaseId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $63454e9202437d5f$var$_descriptor3 = $63454e9202437d5f$var$_applyDecoratedDescriptor($63454e9202437d5f$var$_class.prototype, "amount", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $63454e9202437d5f$var$_applyDecoratedDescriptor($63454e9202437d5f$var$_class.prototype, "project", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($63454e9202437d5f$var$_class.prototype, "project"), $63454e9202437d5f$var$_class.prototype), $63454e9202437d5f$var$_applyDecoratedDescriptor($63454e9202437d5f$var$_class.prototype, "phase", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($63454e9202437d5f$var$_class.prototype, "phase"), $63454e9202437d5f$var$_class.prototype), $63454e9202437d5f$var$_class);
var $63454e9202437d5f$export$2e2bcd8739ae039 = $63454e9202437d5f$var$RevenueTargetAggregateModel;

});


parcelRegister("816ZB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d63d7497c0492e2$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "PhaseAggregateCollectionClass", function () { return $5d63d7497c0492e2$export$203f52a416729f06; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $6FJ05 = parcelRequire("6FJ05");

var $1kjVt = parcelRequire("1kjVt");
var $5d63d7497c0492e2$var$_dec, $5d63d7497c0492e2$var$_dec2, $5d63d7497c0492e2$var$_class;
function $5d63d7497c0492e2$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
class $5d63d7497c0492e2$var$PhaseAggregate extends (0, $1kjVt.default) {
    constructor(){
        super({
            collectionClass: $5d63d7497c0492e2$var$PhaseAggregateCollection
        });
        (0, $4JcCM.makeObservable)(this);
    }
}
let $5d63d7497c0492e2$var$PhaseAggregateCollection = ($5d63d7497c0492e2$var$_dec = (0, $4JcCM.action).bound, $5d63d7497c0492e2$var$_dec2 = (0, $4JcCM.action).bound, $5d63d7497c0492e2$var$_class = class PhaseAggregateCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "phases",
            modelClass: (0, $6FJ05.default)
        });
        this.addLookup("phasesByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("phasesByCostCentreId", "manyByKey", {
            key: (t)=>t.phasesByCostCentreId,
            filter: (t)=>!t.deletedAt
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get phasesById() {
        return this.modelsById;
    }
    get phases() {
        return this.models;
    }
    get phasesById() {
        return this.modelsById;
    }
    addPhase(data) {
        this.add(data);
    }
    addPhases(data) {
        this.addMany(data);
    }
}, $5d63d7497c0492e2$var$_applyDecoratedDescriptor($5d63d7497c0492e2$var$_class.prototype, "addPhase", [
    $5d63d7497c0492e2$var$_dec
], Object.getOwnPropertyDescriptor($5d63d7497c0492e2$var$_class.prototype, "addPhase"), $5d63d7497c0492e2$var$_class.prototype), $5d63d7497c0492e2$var$_applyDecoratedDescriptor($5d63d7497c0492e2$var$_class.prototype, "addPhases", [
    $5d63d7497c0492e2$var$_dec2
], Object.getOwnPropertyDescriptor($5d63d7497c0492e2$var$_class.prototype, "addPhases"), $5d63d7497c0492e2$var$_class.prototype), $5d63d7497c0492e2$var$_class);
var $5d63d7497c0492e2$export$2e2bcd8739ae039 = new $5d63d7497c0492e2$var$PhaseAggregate();
const $5d63d7497c0492e2$export$203f52a416729f06 = $5d63d7497c0492e2$var$PhaseAggregateCollection;

});
parcelRegister("6FJ05", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4db97a8a54dc541f$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $816ZB = parcelRequire("816ZB");

var $7CaHe = parcelRequire("7CaHe");
parcelRequire("eat5C");

var $gJT7h = parcelRequire("gJT7h");

var $3PpOX = parcelRequire("3PpOX");
var $4db97a8a54dc541f$var$_class, $4db97a8a54dc541f$var$_descriptor, $4db97a8a54dc541f$var$_descriptor2, $4db97a8a54dc541f$var$_descriptor3, $4db97a8a54dc541f$var$_descriptor4, $4db97a8a54dc541f$var$_descriptor5, $4db97a8a54dc541f$var$_descriptor6, $4db97a8a54dc541f$var$_descriptor7, $4db97a8a54dc541f$var$_descriptor8, $4db97a8a54dc541f$var$_descriptor9, $4db97a8a54dc541f$var$_descriptor10, $4db97a8a54dc541f$var$_descriptor11, $4db97a8a54dc541f$var$_descriptor12, $4db97a8a54dc541f$var$_descriptor13, $4db97a8a54dc541f$var$_descriptor14;
function $4db97a8a54dc541f$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $4db97a8a54dc541f$var$_defineProperty(e, r, t) {
    return (r = $4db97a8a54dc541f$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4db97a8a54dc541f$var$_toPropertyKey(t) {
    var i = $4db97a8a54dc541f$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $4db97a8a54dc541f$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $4db97a8a54dc541f$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $4db97a8a54dc541f$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $4db97a8a54dc541f$var$PhaseAggregateModel = ($4db97a8a54dc541f$var$_class = class PhaseAggregateModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $4db97a8a54dc541f$var$_initializerDefineProperty(this, "jobNumber", $4db97a8a54dc541f$var$_descriptor, this);
        $4db97a8a54dc541f$var$_initializerDefineProperty(this, "name", $4db97a8a54dc541f$var$_descriptor2, this);
        $4db97a8a54dc541f$var$_initializerDefineProperty(this, "projectId", $4db97a8a54dc541f$var$_descriptor3, this);
        $4db97a8a54dc541f$var$_initializerDefineProperty(this, "startDate", $4db97a8a54dc541f$var$_descriptor4, this);
        $4db97a8a54dc541f$var$_initializerDefineProperty(this, "endDate", $4db97a8a54dc541f$var$_descriptor5, this);
        $4db97a8a54dc541f$var$_initializerDefineProperty(this, "fee", $4db97a8a54dc541f$var$_descriptor6, this);
        $4db97a8a54dc541f$var$_initializerDefineProperty(this, "expenseBudget", $4db97a8a54dc541f$var$_descriptor7, this);
        $4db97a8a54dc541f$var$_initializerDefineProperty(this, "hoursBudget", $4db97a8a54dc541f$var$_descriptor8, this);
        $4db97a8a54dc541f$var$_initializerDefineProperty(this, "status", $4db97a8a54dc541f$var$_descriptor9, this);
        $4db97a8a54dc541f$var$_initializerDefineProperty(this, "percentLikelihood", $4db97a8a54dc541f$var$_descriptor10, this);
        $4db97a8a54dc541f$var$_initializerDefineProperty(this, "feeLinked", $4db97a8a54dc541f$var$_descriptor11, this);
        $4db97a8a54dc541f$var$_initializerDefineProperty(this, "expenseBudgetLinked", $4db97a8a54dc541f$var$_descriptor12, this);
        $4db97a8a54dc541f$var$_initializerDefineProperty(this, "hoursBudgetLinked", $4db97a8a54dc541f$var$_descriptor13, this);
        $4db97a8a54dc541f$var$_initializerDefineProperty(this, "durationUnit", $4db97a8a54dc541f$var$_descriptor14, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $816ZB.default);
        this.init(data, options);
    }
    get title() {
        return this.jobNumber && this.name ? `${this.jobNumber}: ${this.name}` : this.name || this.jobNumber;
    }
    get project() {
        return (0, $gJT7h.default).modelsById[this.projectId];
    }
    get duration() {
        return (0, $7CaHe.unitsBetween)(this.startDate, this.endDate, this.durationUnit);
    }
    get costCentre() {
        var _this$project;
        return (_this$project = this.project) === null || _this$project === void 0 ? void 0 : _this$project.costCentre;
    }
    get contact() {
        var _this$project2;
        return (_this$project2 = this.project) === null || _this$project2 === void 0 ? void 0 : _this$project2.contact;
    }
    get primaryContact() {
        var _this$project3;
        return (_this$project3 = this.project) === null || _this$project3 === void 0 ? void 0 : _this$project3.primaryContact;
    }
    get owner() {
        var _this$project4;
        return (_this$project4 = this.project) === null || _this$project4 === void 0 ? void 0 : _this$project4.owner;
    }
    get hasDates() {
        return this.startDate && this.endDate;
    }
    get isCurrent() {
        return !this.startDate && this.endDate >= new Date() || !this.endDate && this.startDate <= new Date() || this.endDate >= new Date() && this.startDate <= new Date();
    }
    get hasEnded() {
        return this.hasDates && !this.isCurrent;
    }
    get feeAdjustedByLikelihood() {
        if ([
            "prospective",
            "onHold"
        ].includes(this.status) && this.percentLikelihood) return this.fee * (this.percentLikelihood / 100);
        else return this.fee;
    }
}, $4db97a8a54dc541f$var$_descriptor = $4db97a8a54dc541f$var$_applyDecoratedDescriptor($4db97a8a54dc541f$var$_class.prototype, "jobNumber", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $4db97a8a54dc541f$var$_descriptor2 = $4db97a8a54dc541f$var$_applyDecoratedDescriptor($4db97a8a54dc541f$var$_class.prototype, "name", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $4db97a8a54dc541f$var$_descriptor3 = $4db97a8a54dc541f$var$_applyDecoratedDescriptor($4db97a8a54dc541f$var$_class.prototype, "projectId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $4db97a8a54dc541f$var$_descriptor4 = $4db97a8a54dc541f$var$_applyDecoratedDescriptor($4db97a8a54dc541f$var$_class.prototype, "startDate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $4db97a8a54dc541f$var$_descriptor5 = $4db97a8a54dc541f$var$_applyDecoratedDescriptor($4db97a8a54dc541f$var$_class.prototype, "endDate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $4db97a8a54dc541f$var$_descriptor6 = $4db97a8a54dc541f$var$_applyDecoratedDescriptor($4db97a8a54dc541f$var$_class.prototype, "fee", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $4db97a8a54dc541f$var$_descriptor7 = $4db97a8a54dc541f$var$_applyDecoratedDescriptor($4db97a8a54dc541f$var$_class.prototype, "expenseBudget", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $4db97a8a54dc541f$var$_descriptor8 = $4db97a8a54dc541f$var$_applyDecoratedDescriptor($4db97a8a54dc541f$var$_class.prototype, "hoursBudget", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $4db97a8a54dc541f$var$_descriptor9 = $4db97a8a54dc541f$var$_applyDecoratedDescriptor($4db97a8a54dc541f$var$_class.prototype, "status", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $4db97a8a54dc541f$var$_descriptor10 = $4db97a8a54dc541f$var$_applyDecoratedDescriptor($4db97a8a54dc541f$var$_class.prototype, "percentLikelihood", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $4db97a8a54dc541f$var$_descriptor11 = $4db97a8a54dc541f$var$_applyDecoratedDescriptor($4db97a8a54dc541f$var$_class.prototype, "feeLinked", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $4db97a8a54dc541f$var$_descriptor12 = $4db97a8a54dc541f$var$_applyDecoratedDescriptor($4db97a8a54dc541f$var$_class.prototype, "expenseBudgetLinked", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $4db97a8a54dc541f$var$_descriptor13 = $4db97a8a54dc541f$var$_applyDecoratedDescriptor($4db97a8a54dc541f$var$_class.prototype, "hoursBudgetLinked", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $4db97a8a54dc541f$var$_descriptor14 = $4db97a8a54dc541f$var$_applyDecoratedDescriptor($4db97a8a54dc541f$var$_class.prototype, "durationUnit", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $4db97a8a54dc541f$var$_applyDecoratedDescriptor($4db97a8a54dc541f$var$_class.prototype, "title", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($4db97a8a54dc541f$var$_class.prototype, "title"), $4db97a8a54dc541f$var$_class.prototype), $4db97a8a54dc541f$var$_applyDecoratedDescriptor($4db97a8a54dc541f$var$_class.prototype, "project", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($4db97a8a54dc541f$var$_class.prototype, "project"), $4db97a8a54dc541f$var$_class.prototype), $4db97a8a54dc541f$var$_applyDecoratedDescriptor($4db97a8a54dc541f$var$_class.prototype, "duration", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($4db97a8a54dc541f$var$_class.prototype, "duration"), $4db97a8a54dc541f$var$_class.prototype), $4db97a8a54dc541f$var$_applyDecoratedDescriptor($4db97a8a54dc541f$var$_class.prototype, "costCentre", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($4db97a8a54dc541f$var$_class.prototype, "costCentre"), $4db97a8a54dc541f$var$_class.prototype), $4db97a8a54dc541f$var$_applyDecoratedDescriptor($4db97a8a54dc541f$var$_class.prototype, "contact", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($4db97a8a54dc541f$var$_class.prototype, "contact"), $4db97a8a54dc541f$var$_class.prototype), $4db97a8a54dc541f$var$_applyDecoratedDescriptor($4db97a8a54dc541f$var$_class.prototype, "primaryContact", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($4db97a8a54dc541f$var$_class.prototype, "primaryContact"), $4db97a8a54dc541f$var$_class.prototype), $4db97a8a54dc541f$var$_applyDecoratedDescriptor($4db97a8a54dc541f$var$_class.prototype, "owner", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($4db97a8a54dc541f$var$_class.prototype, "owner"), $4db97a8a54dc541f$var$_class.prototype), $4db97a8a54dc541f$var$_applyDecoratedDescriptor($4db97a8a54dc541f$var$_class.prototype, "hasDates", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($4db97a8a54dc541f$var$_class.prototype, "hasDates"), $4db97a8a54dc541f$var$_class.prototype), $4db97a8a54dc541f$var$_applyDecoratedDescriptor($4db97a8a54dc541f$var$_class.prototype, "isCurrent", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($4db97a8a54dc541f$var$_class.prototype, "isCurrent"), $4db97a8a54dc541f$var$_class.prototype), $4db97a8a54dc541f$var$_applyDecoratedDescriptor($4db97a8a54dc541f$var$_class.prototype, "hasEnded", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($4db97a8a54dc541f$var$_class.prototype, "hasEnded"), $4db97a8a54dc541f$var$_class.prototype), $4db97a8a54dc541f$var$_applyDecoratedDescriptor($4db97a8a54dc541f$var$_class.prototype, "feeAdjustedByLikelihood", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($4db97a8a54dc541f$var$_class.prototype, "feeAdjustedByLikelihood"), $4db97a8a54dc541f$var$_class.prototype), $4db97a8a54dc541f$var$_class);
var $4db97a8a54dc541f$export$2e2bcd8739ae039 = $4db97a8a54dc541f$var$PhaseAggregateModel;

});


parcelRegister("kuXqZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eec4b66d0374362c$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "BudgetAggregateCollectionClass", function () { return $eec4b66d0374362c$export$55d313ff01ac4c2e; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $1tZIG = parcelRequire("1tZIG");

var $1kjVt = parcelRequire("1kjVt");
var $eec4b66d0374362c$var$_dec, $eec4b66d0374362c$var$_dec2, $eec4b66d0374362c$var$_class;
function $eec4b66d0374362c$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
class $eec4b66d0374362c$var$BudgetAggregate extends (0, $1kjVt.default) {
    constructor(){
        super({
            collectionClass: $eec4b66d0374362c$var$BudgetAggregateCollection
        });
        (0, $4JcCM.makeObservable)(this);
    }
}
let $eec4b66d0374362c$var$BudgetAggregateCollection = ($eec4b66d0374362c$var$_dec = (0, $4JcCM.action).bound, $eec4b66d0374362c$var$_dec2 = (0, $4JcCM.action).bound, $eec4b66d0374362c$var$_class = class BudgetAggregateCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "budgetedHours",
            modelClass: (0, $1tZIG.default)
        });
        this.addLookup("budgetsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("budgetsByStaffId", "manyByKey", {
            key: (t)=>t.staffId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("budgetsByRoleId", "manyByKey", {
            key: (t)=>t.roleId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("budgetsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get budgetsById() {
        return this.modelsById;
    }
    get budgets() {
        return this.models;
    }
    get budgetsById() {
        return this.modelsById;
    }
    addBudget(data) {
        this.add(data);
    }
    addBudgets(data) {
        this.addMany(data);
    }
}, $eec4b66d0374362c$var$_applyDecoratedDescriptor($eec4b66d0374362c$var$_class.prototype, "addBudget", [
    $eec4b66d0374362c$var$_dec
], Object.getOwnPropertyDescriptor($eec4b66d0374362c$var$_class.prototype, "addBudget"), $eec4b66d0374362c$var$_class.prototype), $eec4b66d0374362c$var$_applyDecoratedDescriptor($eec4b66d0374362c$var$_class.prototype, "addBudgets", [
    $eec4b66d0374362c$var$_dec2
], Object.getOwnPropertyDescriptor($eec4b66d0374362c$var$_class.prototype, "addBudgets"), $eec4b66d0374362c$var$_class.prototype), $eec4b66d0374362c$var$_class);
var $eec4b66d0374362c$export$2e2bcd8739ae039 = new $eec4b66d0374362c$var$BudgetAggregate();
const $eec4b66d0374362c$export$55d313ff01ac4c2e = $eec4b66d0374362c$var$BudgetAggregateCollection;

});
parcelRegister("1tZIG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11486024b1531cb7$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $kuXqZ = parcelRequire("kuXqZ");
parcelRequire("7CaHe");
parcelRequire("eat5C");

var $gJT7h = parcelRequire("gJT7h");

var $3PpOX = parcelRequire("3PpOX");

var $htkeB = parcelRequire("htkeB");

var $XoImS = parcelRequire("XoImS");

var $bxXv3 = parcelRequire("bxXv3");

var $ywyHN = parcelRequire("ywyHN");
var $11486024b1531cb7$var$_dec, $11486024b1531cb7$var$_class, $11486024b1531cb7$var$_descriptor, $11486024b1531cb7$var$_descriptor2, $11486024b1531cb7$var$_descriptor3, $11486024b1531cb7$var$_descriptor4, $11486024b1531cb7$var$_descriptor5;
function $11486024b1531cb7$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $11486024b1531cb7$var$_defineProperty(e, r, t) {
    return (r = $11486024b1531cb7$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $11486024b1531cb7$var$_toPropertyKey(t) {
    var i = $11486024b1531cb7$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $11486024b1531cb7$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $11486024b1531cb7$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $11486024b1531cb7$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $11486024b1531cb7$var$BudgetAggregateModel = ($11486024b1531cb7$var$_dec = (0, $4JcCM.action).bound, $11486024b1531cb7$var$_class = class BudgetAggregateModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $11486024b1531cb7$var$_initializerDefineProperty(this, "staffId", $11486024b1531cb7$var$_descriptor, this);
        $11486024b1531cb7$var$_initializerDefineProperty(this, "roleId", $11486024b1531cb7$var$_descriptor2, this);
        $11486024b1531cb7$var$_initializerDefineProperty(this, "projectId", $11486024b1531cb7$var$_descriptor3, this);
        $11486024b1531cb7$var$_initializerDefineProperty(this, "phaseId", $11486024b1531cb7$var$_descriptor4, this);
        $11486024b1531cb7$var$_initializerDefineProperty(this, "hours", $11486024b1531cb7$var$_descriptor5, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $kuXqZ.default);
        this.init(data, options);
    }
    get resource() {
        return this.staff || this.role;
    }
    get staff() {
        return (0, $htkeB.default).staffsById[this.staffId];
    }
    get phase() {
        return (0, $XoImS.default).phasesById[this.phaseId];
    }
    get project() {
        return (0, $gJT7h.default).projectsById[this.projectId];
    }
    get role() {
        return (0, $bxXv3.default).rolesById[this.roleId];
    }
    get costRate() {
        if (!this.resource) return 0;
        return (0, $ywyHN.default)({
            project: this.project,
            phase: this.phase,
            staff: this.staff,
            role: this.role
        }, "cost", [
            this.startDate,
            this.endDate
        ]);
    }
    get chargeOutRate() {
        if (!this.resource) return 0;
        return (0, $ywyHN.default)({
            project: this.project,
            phase: this.phase,
            staff: this.staff,
            role: this.role
        }, "chargeOut", [
            this.startDate,
            this.endDate
        ]);
    }
    get cost() {
        return this.hours * this.costRate;
    }
    get chargeOut() {
        return this.hours * this.chargeOutRate;
    }
    rateValueToHours(value, rateType) {
        const rateName = rateType === "availability" ? "weeklyAvailability" : rateType + "Rate";
        this.update({
            hours: value / this[rateName]
        });
    }
    get rates() {
        var _this$resource;
        return (_this$resource = this.resource) === null || _this$resource === void 0 ? void 0 : _this$resource.rates.sort((a, b)=>a.date - b.date);
    }
    get startDate() {
        var _this$phase;
        return (_this$phase = this.phase) === null || _this$phase === void 0 ? void 0 : _this$phase.startDate;
    }
    get endDate() {
        var _this$phase2;
        return (_this$phase2 = this.phase) === null || _this$phase2 === void 0 ? void 0 : _this$phase2.endDate;
    }
}, $11486024b1531cb7$var$_descriptor = $11486024b1531cb7$var$_applyDecoratedDescriptor($11486024b1531cb7$var$_class.prototype, "staffId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $11486024b1531cb7$var$_descriptor2 = $11486024b1531cb7$var$_applyDecoratedDescriptor($11486024b1531cb7$var$_class.prototype, "roleId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $11486024b1531cb7$var$_descriptor3 = $11486024b1531cb7$var$_applyDecoratedDescriptor($11486024b1531cb7$var$_class.prototype, "projectId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $11486024b1531cb7$var$_descriptor4 = $11486024b1531cb7$var$_applyDecoratedDescriptor($11486024b1531cb7$var$_class.prototype, "phaseId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $11486024b1531cb7$var$_descriptor5 = $11486024b1531cb7$var$_applyDecoratedDescriptor($11486024b1531cb7$var$_class.prototype, "hours", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $11486024b1531cb7$var$_applyDecoratedDescriptor($11486024b1531cb7$var$_class.prototype, "resource", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($11486024b1531cb7$var$_class.prototype, "resource"), $11486024b1531cb7$var$_class.prototype), $11486024b1531cb7$var$_applyDecoratedDescriptor($11486024b1531cb7$var$_class.prototype, "staff", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($11486024b1531cb7$var$_class.prototype, "staff"), $11486024b1531cb7$var$_class.prototype), $11486024b1531cb7$var$_applyDecoratedDescriptor($11486024b1531cb7$var$_class.prototype, "phase", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($11486024b1531cb7$var$_class.prototype, "phase"), $11486024b1531cb7$var$_class.prototype), $11486024b1531cb7$var$_applyDecoratedDescriptor($11486024b1531cb7$var$_class.prototype, "project", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($11486024b1531cb7$var$_class.prototype, "project"), $11486024b1531cb7$var$_class.prototype), $11486024b1531cb7$var$_applyDecoratedDescriptor($11486024b1531cb7$var$_class.prototype, "role", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($11486024b1531cb7$var$_class.prototype, "role"), $11486024b1531cb7$var$_class.prototype), $11486024b1531cb7$var$_applyDecoratedDescriptor($11486024b1531cb7$var$_class.prototype, "costRate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($11486024b1531cb7$var$_class.prototype, "costRate"), $11486024b1531cb7$var$_class.prototype), $11486024b1531cb7$var$_applyDecoratedDescriptor($11486024b1531cb7$var$_class.prototype, "chargeOutRate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($11486024b1531cb7$var$_class.prototype, "chargeOutRate"), $11486024b1531cb7$var$_class.prototype), $11486024b1531cb7$var$_applyDecoratedDescriptor($11486024b1531cb7$var$_class.prototype, "cost", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($11486024b1531cb7$var$_class.prototype, "cost"), $11486024b1531cb7$var$_class.prototype), $11486024b1531cb7$var$_applyDecoratedDescriptor($11486024b1531cb7$var$_class.prototype, "chargeOut", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($11486024b1531cb7$var$_class.prototype, "chargeOut"), $11486024b1531cb7$var$_class.prototype), $11486024b1531cb7$var$_applyDecoratedDescriptor($11486024b1531cb7$var$_class.prototype, "rateValueToHours", [
    $11486024b1531cb7$var$_dec
], Object.getOwnPropertyDescriptor($11486024b1531cb7$var$_class.prototype, "rateValueToHours"), $11486024b1531cb7$var$_class.prototype), $11486024b1531cb7$var$_applyDecoratedDescriptor($11486024b1531cb7$var$_class.prototype, "rates", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($11486024b1531cb7$var$_class.prototype, "rates"), $11486024b1531cb7$var$_class.prototype), $11486024b1531cb7$var$_applyDecoratedDescriptor($11486024b1531cb7$var$_class.prototype, "startDate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($11486024b1531cb7$var$_class.prototype, "startDate"), $11486024b1531cb7$var$_class.prototype), $11486024b1531cb7$var$_applyDecoratedDescriptor($11486024b1531cb7$var$_class.prototype, "endDate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($11486024b1531cb7$var$_class.prototype, "endDate"), $11486024b1531cb7$var$_class.prototype), $11486024b1531cb7$var$_class);
var $11486024b1531cb7$export$2e2bcd8739ae039 = $11486024b1531cb7$var$BudgetAggregateModel;

});


parcelRegister("8qPFs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6238d4949d5f0118$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "MonthlyResourceCellCollectionClass", function () { return $6238d4949d5f0118$export$2f6614d0d0b22e74; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $igMq4 = parcelRequire("igMq4");
var $6238d4949d5f0118$var$_dec, $6238d4949d5f0118$var$_dec2, $6238d4949d5f0118$var$_class;
function $6238d4949d5f0118$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $6238d4949d5f0118$var$MonthlyResourceCellCollection = ($6238d4949d5f0118$var$_dec = (0, $4JcCM.action).bound, $6238d4949d5f0118$var$_dec2 = (0, $4JcCM.action).bound, $6238d4949d5f0118$var$_class = class MonthlyResourceCellCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "monthlyResourceCells",
            modelClass: (0, $igMq4.default)
        });
        this.addLookup("cellsByStatus", "manyByKey", {
            key: (t)=>t.status,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("cellsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("cellsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("cellsByStaffId", "manyByKey", {
            key: (t)=>t.staffId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("cellsByRoleId", "manyByKey", {
            key: (t)=>t.staffRoleId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("cellsByMonth", "manyByKey", {
            key: (t)=>t.month,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("cellsByType", "manyByKey", {
            key: (t)=>t.type,
            filter: (t)=>!t.deletedAt
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get cellsById() {
        return this.modelsById;
    }
    get cells() {
        return this.models;
    }
    addCell(data, options) {
        return this.add(data, options);
    }
    addCells(data, options) {
        return this.addMany(data, options);
    }
}, $6238d4949d5f0118$var$_applyDecoratedDescriptor($6238d4949d5f0118$var$_class.prototype, "addCell", [
    $6238d4949d5f0118$var$_dec
], Object.getOwnPropertyDescriptor($6238d4949d5f0118$var$_class.prototype, "addCell"), $6238d4949d5f0118$var$_class.prototype), $6238d4949d5f0118$var$_applyDecoratedDescriptor($6238d4949d5f0118$var$_class.prototype, "addCells", [
    $6238d4949d5f0118$var$_dec2
], Object.getOwnPropertyDescriptor($6238d4949d5f0118$var$_class.prototype, "addCells"), $6238d4949d5f0118$var$_class.prototype), $6238d4949d5f0118$var$_class);
var $6238d4949d5f0118$export$2e2bcd8739ae039 = new $6238d4949d5f0118$var$MonthlyResourceCellCollection();
const $6238d4949d5f0118$export$2f6614d0d0b22e74 = $6238d4949d5f0118$var$MonthlyResourceCellCollection;

});
parcelRegister("igMq4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4cf47be8b45ebbd$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $XoImS = parcelRequire("XoImS");

var $gJT7h = parcelRequire("gJT7h");

var $8qPFs = parcelRequire("8qPFs");

var $3PpOX = parcelRequire("3PpOX");

var $4hBm1 = parcelRequire("4hBm1");

var $bxXv3 = parcelRequire("bxXv3");

var $htkeB = parcelRequire("htkeB");

var $62nmb = parcelRequire("62nmb");

var $9eute = parcelRequire("9eute");
var $d4cf47be8b45ebbd$var$_class, $d4cf47be8b45ebbd$var$_descriptor, $d4cf47be8b45ebbd$var$_descriptor2, $d4cf47be8b45ebbd$var$_descriptor3, $d4cf47be8b45ebbd$var$_descriptor4, $d4cf47be8b45ebbd$var$_descriptor5, $d4cf47be8b45ebbd$var$_descriptor6, $d4cf47be8b45ebbd$var$_descriptor7, $d4cf47be8b45ebbd$var$_descriptor8, $d4cf47be8b45ebbd$var$_descriptor9, $d4cf47be8b45ebbd$var$_descriptor10, $d4cf47be8b45ebbd$var$_descriptor11, $d4cf47be8b45ebbd$var$_descriptor12, $d4cf47be8b45ebbd$var$_descriptor13;
function $d4cf47be8b45ebbd$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $d4cf47be8b45ebbd$var$_defineProperty(e, r, t) {
    return (r = $d4cf47be8b45ebbd$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $d4cf47be8b45ebbd$var$_toPropertyKey(t) {
    var i = $d4cf47be8b45ebbd$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $d4cf47be8b45ebbd$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $d4cf47be8b45ebbd$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $d4cf47be8b45ebbd$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $d4cf47be8b45ebbd$var$MonthlyResourceCellModel = ($d4cf47be8b45ebbd$var$_class = class MonthlyResourceCellModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $d4cf47be8b45ebbd$var$_initializerDefineProperty(this, "month", $d4cf47be8b45ebbd$var$_descriptor, this);
        $d4cf47be8b45ebbd$var$_initializerDefineProperty(this, "hours", $d4cf47be8b45ebbd$var$_descriptor2, this);
        $d4cf47be8b45ebbd$var$_initializerDefineProperty(this, "cost", $d4cf47be8b45ebbd$var$_descriptor3, this);
        $d4cf47be8b45ebbd$var$_initializerDefineProperty(this, "chargeOut", $d4cf47be8b45ebbd$var$_descriptor4, this);
        $d4cf47be8b45ebbd$var$_initializerDefineProperty(this, "status", $d4cf47be8b45ebbd$var$_descriptor5, this);
        $d4cf47be8b45ebbd$var$_initializerDefineProperty(this, "projectId", $d4cf47be8b45ebbd$var$_descriptor6, this);
        $d4cf47be8b45ebbd$var$_initializerDefineProperty(this, "phaseId", $d4cf47be8b45ebbd$var$_descriptor7, this);
        $d4cf47be8b45ebbd$var$_initializerDefineProperty(this, "phaseTitle", $d4cf47be8b45ebbd$var$_descriptor8, this);
        $d4cf47be8b45ebbd$var$_initializerDefineProperty(this, "staffRoleId", $d4cf47be8b45ebbd$var$_descriptor9, this);
        $d4cf47be8b45ebbd$var$_initializerDefineProperty(this, "staffId", $d4cf47be8b45ebbd$var$_descriptor10, this);
        $d4cf47be8b45ebbd$var$_initializerDefineProperty(this, "ownerId", $d4cf47be8b45ebbd$var$_descriptor11, this);
        $d4cf47be8b45ebbd$var$_initializerDefineProperty(this, "costCentreId", $d4cf47be8b45ebbd$var$_descriptor12, this);
        $d4cf47be8b45ebbd$var$_initializerDefineProperty(this, "type", $d4cf47be8b45ebbd$var$_descriptor13, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $8qPFs.default);
        this.init(data, options);
        const rowId = `('${this.status}', '${this.projectId}', '${this.phaseId}', '${this.staffRoleId || null}', '${this.staffId}')`;
        const row = (0, $9eute.default).rowsById[rowId];
        if (!row) (0, $9eute.default).addRow({
            id: rowId,
            status: this.status,
            projectId: this.projectId,
            phaseId: this.phaseId,
            phaseTitle: this.phaseTitle,
            staffRoleId: this.staffRoleId,
            staffId: this.staffId,
            groups: [
                "status",
                "project",
                "phase",
                "role",
                "staff"
            ]
        }, {
            trackUpdates: false
        });
    }
    get phase() {
        return (0, $XoImS.default).phasesById[this.phaseId];
    }
    get project() {
        return (0, $gJT7h.default).projectsById[this.projectId];
    }
    get role() {
        return (0, $bxXv3.default).rolesById[this.staffRoleId];
    }
    get staff() {
        return (0, $htkeB.default).staffById[this.staffId];
    }
    serialize() {
        return {
            id: this.id,
            month: this.month,
            hours: this.hours,
            projectId: this.projectId,
            phaseId: this.phaseId,
            staffRoleId: this.staffRoleId,
            staffId: this.staffId
        };
    }
    serializeUpdates() {
        return this.serialize();
    }
    get date() {
        return (0, $4hBm1.startOfMonth)((0, $4hBm1.parse)(this.month, "yyyy-MM", new Date()));
    }
    get startDate() {
        return this.date;
    }
    get endDate() {
        return (0, $4hBm1.endOfMonth)(this.date);
    }
    getRateInDateRange(rateType, dateRange) {
        if (this.staff) return this.staff.getRateInDateRange(rateType, dateRange);
        else if (this.role) return this.role.getRateInDateRange(rateType, dateRange);
        else return null;
    }
    get costRate() {
        return this.getRateInDateRange("cost", [
            this.startDate,
            this.endDate
        ]);
    }
    get chargeOutRate() {
        return this.getRateInDateRange("chargeOut", [
            this.startDate,
            this.endDate
        ]);
    }
}, $d4cf47be8b45ebbd$var$_descriptor = $d4cf47be8b45ebbd$var$_applyDecoratedDescriptor($d4cf47be8b45ebbd$var$_class.prototype, "month", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d4cf47be8b45ebbd$var$_descriptor2 = $d4cf47be8b45ebbd$var$_applyDecoratedDescriptor($d4cf47be8b45ebbd$var$_class.prototype, "hours", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $d4cf47be8b45ebbd$var$_descriptor3 = $d4cf47be8b45ebbd$var$_applyDecoratedDescriptor($d4cf47be8b45ebbd$var$_class.prototype, "cost", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $d4cf47be8b45ebbd$var$_descriptor4 = $d4cf47be8b45ebbd$var$_applyDecoratedDescriptor($d4cf47be8b45ebbd$var$_class.prototype, "chargeOut", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $d4cf47be8b45ebbd$var$_descriptor5 = $d4cf47be8b45ebbd$var$_applyDecoratedDescriptor($d4cf47be8b45ebbd$var$_class.prototype, "status", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d4cf47be8b45ebbd$var$_descriptor6 = $d4cf47be8b45ebbd$var$_applyDecoratedDescriptor($d4cf47be8b45ebbd$var$_class.prototype, "projectId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d4cf47be8b45ebbd$var$_descriptor7 = $d4cf47be8b45ebbd$var$_applyDecoratedDescriptor($d4cf47be8b45ebbd$var$_class.prototype, "phaseId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d4cf47be8b45ebbd$var$_descriptor8 = $d4cf47be8b45ebbd$var$_applyDecoratedDescriptor($d4cf47be8b45ebbd$var$_class.prototype, "phaseTitle", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d4cf47be8b45ebbd$var$_descriptor9 = $d4cf47be8b45ebbd$var$_applyDecoratedDescriptor($d4cf47be8b45ebbd$var$_class.prototype, "staffRoleId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d4cf47be8b45ebbd$var$_descriptor10 = $d4cf47be8b45ebbd$var$_applyDecoratedDescriptor($d4cf47be8b45ebbd$var$_class.prototype, "staffId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d4cf47be8b45ebbd$var$_descriptor11 = $d4cf47be8b45ebbd$var$_applyDecoratedDescriptor($d4cf47be8b45ebbd$var$_class.prototype, "ownerId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d4cf47be8b45ebbd$var$_descriptor12 = $d4cf47be8b45ebbd$var$_applyDecoratedDescriptor($d4cf47be8b45ebbd$var$_class.prototype, "costCentreId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d4cf47be8b45ebbd$var$_descriptor13 = $d4cf47be8b45ebbd$var$_applyDecoratedDescriptor($d4cf47be8b45ebbd$var$_class.prototype, "type", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d4cf47be8b45ebbd$var$_applyDecoratedDescriptor($d4cf47be8b45ebbd$var$_class.prototype, "phase", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($d4cf47be8b45ebbd$var$_class.prototype, "phase"), $d4cf47be8b45ebbd$var$_class.prototype), $d4cf47be8b45ebbd$var$_applyDecoratedDescriptor($d4cf47be8b45ebbd$var$_class.prototype, "project", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($d4cf47be8b45ebbd$var$_class.prototype, "project"), $d4cf47be8b45ebbd$var$_class.prototype), $d4cf47be8b45ebbd$var$_applyDecoratedDescriptor($d4cf47be8b45ebbd$var$_class.prototype, "role", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($d4cf47be8b45ebbd$var$_class.prototype, "role"), $d4cf47be8b45ebbd$var$_class.prototype), $d4cf47be8b45ebbd$var$_applyDecoratedDescriptor($d4cf47be8b45ebbd$var$_class.prototype, "staff", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($d4cf47be8b45ebbd$var$_class.prototype, "staff"), $d4cf47be8b45ebbd$var$_class.prototype), $d4cf47be8b45ebbd$var$_applyDecoratedDescriptor($d4cf47be8b45ebbd$var$_class.prototype, "date", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($d4cf47be8b45ebbd$var$_class.prototype, "date"), $d4cf47be8b45ebbd$var$_class.prototype), $d4cf47be8b45ebbd$var$_applyDecoratedDescriptor($d4cf47be8b45ebbd$var$_class.prototype, "startDate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($d4cf47be8b45ebbd$var$_class.prototype, "startDate"), $d4cf47be8b45ebbd$var$_class.prototype), $d4cf47be8b45ebbd$var$_applyDecoratedDescriptor($d4cf47be8b45ebbd$var$_class.prototype, "endDate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($d4cf47be8b45ebbd$var$_class.prototype, "endDate"), $d4cf47be8b45ebbd$var$_class.prototype), $d4cf47be8b45ebbd$var$_applyDecoratedDescriptor($d4cf47be8b45ebbd$var$_class.prototype, "getRateInDateRange", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($d4cf47be8b45ebbd$var$_class.prototype, "getRateInDateRange"), $d4cf47be8b45ebbd$var$_class.prototype), $d4cf47be8b45ebbd$var$_applyDecoratedDescriptor($d4cf47be8b45ebbd$var$_class.prototype, "costRate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($d4cf47be8b45ebbd$var$_class.prototype, "costRate"), $d4cf47be8b45ebbd$var$_class.prototype), $d4cf47be8b45ebbd$var$_applyDecoratedDescriptor($d4cf47be8b45ebbd$var$_class.prototype, "chargeOutRate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($d4cf47be8b45ebbd$var$_class.prototype, "chargeOutRate"), $d4cf47be8b45ebbd$var$_class.prototype), $d4cf47be8b45ebbd$var$_class);
var $d4cf47be8b45ebbd$export$2e2bcd8739ae039 = $d4cf47be8b45ebbd$var$MonthlyResourceCellModel;

});
parcelRegister("9eute", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b8d0eadc2e8f6cd$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "ResourceRowCollectionClass", function () { return $6b8d0eadc2e8f6cd$export$6798d7f54903900c; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $3KSJP = parcelRequire("3KSJP");
var $6b8d0eadc2e8f6cd$var$_dec, $6b8d0eadc2e8f6cd$var$_dec2, $6b8d0eadc2e8f6cd$var$_class;
function $6b8d0eadc2e8f6cd$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $6b8d0eadc2e8f6cd$var$ResourceRowCollection = ($6b8d0eadc2e8f6cd$var$_dec = (0, $4JcCM.action).bound, $6b8d0eadc2e8f6cd$var$_dec2 = (0, $4JcCM.action).bound, $6b8d0eadc2e8f6cd$var$_class = class ResourceRowCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "resourceRows",
            modelClass: (0, $3KSJP.default)
        });
        this.addLookup("rowsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!(t !== null && t !== void 0 && t.deletedAt)
        });
        this.addLookup("rowsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!(t !== null && t !== void 0 && t.deletedAt)
        });
        this.addLookup("rowsByStaffId", "manyByKey", {
            key: (t)=>t.staffId,
            filter: (t)=>!(t !== null && t !== void 0 && t.deletedAt)
        });
        this.addLookup("rowsByRoleId", "manyByKey", {
            key: (t)=>t.staffRoleId || null,
            filter: (t)=>!(t !== null && t !== void 0 && t.deletedAt)
        });
        this.addLookup("rowsByStatus", "manyByKey", {
            key: (t)=>t.status,
            filter: (t)=>!(t !== null && t !== void 0 && t.deletedAt)
        });
        this.addLookup("leafRows", "list", {
            filter: (m)=>{
                return m.isLeaf;
            }
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get rowsById() {
        return this.modelsById;
    }
    get rows() {
        return this.models;
    }
    addRow(data) {
        return this.add(data);
    }
    addRows(data) {
        return this.addMany(data);
    }
}, $6b8d0eadc2e8f6cd$var$_applyDecoratedDescriptor($6b8d0eadc2e8f6cd$var$_class.prototype, "addRow", [
    $6b8d0eadc2e8f6cd$var$_dec
], Object.getOwnPropertyDescriptor($6b8d0eadc2e8f6cd$var$_class.prototype, "addRow"), $6b8d0eadc2e8f6cd$var$_class.prototype), $6b8d0eadc2e8f6cd$var$_applyDecoratedDescriptor($6b8d0eadc2e8f6cd$var$_class.prototype, "addRows", [
    $6b8d0eadc2e8f6cd$var$_dec2
], Object.getOwnPropertyDescriptor($6b8d0eadc2e8f6cd$var$_class.prototype, "addRows"), $6b8d0eadc2e8f6cd$var$_class.prototype), $6b8d0eadc2e8f6cd$var$_class);
var $6b8d0eadc2e8f6cd$export$2e2bcd8739ae039 = new $6b8d0eadc2e8f6cd$var$ResourceRowCollection();
const $6b8d0eadc2e8f6cd$export$6798d7f54903900c = $6b8d0eadc2e8f6cd$var$ResourceRowCollection;

});
parcelRegister("3KSJP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2bc020d69e68aaa7$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $XoImS = parcelRequire("XoImS");

var $gJT7h = parcelRequire("gJT7h");

var $9eute = parcelRequire("9eute");

var $3PpOX = parcelRequire("3PpOX");

var $eat5C = parcelRequire("eat5C");

var $62nmb = parcelRequire("62nmb");

var $4hBm1 = parcelRequire("4hBm1");

var $bxXv3 = parcelRequire("bxXv3");

var $htkeB = parcelRequire("htkeB");

var $Ds2V9 = parcelRequire("Ds2V9");

var $ywyHN = parcelRequire("ywyHN");

var $8XaFv = parcelRequire("8XaFv");
var $2bc020d69e68aaa7$var$_dec, $2bc020d69e68aaa7$var$_dec2, $2bc020d69e68aaa7$var$_dec3, $2bc020d69e68aaa7$var$_dec4, $2bc020d69e68aaa7$var$_dec5, $2bc020d69e68aaa7$var$_class, $2bc020d69e68aaa7$var$_descriptor, $2bc020d69e68aaa7$var$_descriptor2, $2bc020d69e68aaa7$var$_descriptor3, $2bc020d69e68aaa7$var$_descriptor4, $2bc020d69e68aaa7$var$_descriptor5, $2bc020d69e68aaa7$var$_descriptor6, $2bc020d69e68aaa7$var$_descriptor7, $2bc020d69e68aaa7$var$_descriptor8, $2bc020d69e68aaa7$var$_descriptor9, $2bc020d69e68aaa7$var$_descriptor10, $2bc020d69e68aaa7$var$_descriptor11, $2bc020d69e68aaa7$var$_descriptor12, $2bc020d69e68aaa7$var$_descriptor13, $2bc020d69e68aaa7$var$_descriptor14, $2bc020d69e68aaa7$var$_descriptor15, $2bc020d69e68aaa7$var$_descriptor16, $2bc020d69e68aaa7$var$_descriptor17, $2bc020d69e68aaa7$var$_descriptor18, $2bc020d69e68aaa7$var$_descriptor19, $2bc020d69e68aaa7$var$_descriptor20, $2bc020d69e68aaa7$var$_descriptor21, $2bc020d69e68aaa7$var$_descriptor22, $2bc020d69e68aaa7$var$_descriptor23;
function $2bc020d69e68aaa7$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $2bc020d69e68aaa7$var$_defineProperty(e, r, t) {
    return (r = $2bc020d69e68aaa7$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $2bc020d69e68aaa7$var$_toPropertyKey(t) {
    var i = $2bc020d69e68aaa7$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $2bc020d69e68aaa7$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $2bc020d69e68aaa7$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $2bc020d69e68aaa7$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
const $2bc020d69e68aaa7$var$propByGroup = {
    status: "status",
    project: "projectId",
    phase: "phaseId",
    staff: "staffId",
    role: "staffRoleId"
};
const $2bc020d69e68aaa7$var$titlePropByGroup = {
    project: "title",
    phase: "title",
    staff: "fullName",
    role: "name"
};
let $2bc020d69e68aaa7$var$ResourceRowModel = ($2bc020d69e68aaa7$var$_dec = (0, $4JcCM.action).bound, $2bc020d69e68aaa7$var$_dec2 = (0, $4JcCM.action).bound, $2bc020d69e68aaa7$var$_dec3 = (0, $4JcCM.action).bound, $2bc020d69e68aaa7$var$_dec4 = (0, $4JcCM.action).bound, $2bc020d69e68aaa7$var$_dec5 = (0, $4JcCM.action).bound, $2bc020d69e68aaa7$var$_class = class ResourceRowModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $2bc020d69e68aaa7$var$_initializerDefineProperty(this, "label", $2bc020d69e68aaa7$var$_descriptor, this);
        $2bc020d69e68aaa7$var$_initializerDefineProperty(this, "budget", $2bc020d69e68aaa7$var$_descriptor2, this);
        $2bc020d69e68aaa7$var$_initializerDefineProperty(this, "actualHours", $2bc020d69e68aaa7$var$_descriptor3, this);
        $2bc020d69e68aaa7$var$_initializerDefineProperty(this, "projectedHours", $2bc020d69e68aaa7$var$_descriptor4, this);
        $2bc020d69e68aaa7$var$_initializerDefineProperty(this, "prospectiveHours", $2bc020d69e68aaa7$var$_descriptor5, this);
        $2bc020d69e68aaa7$var$_initializerDefineProperty(this, "actualCost", $2bc020d69e68aaa7$var$_descriptor6, this);
        $2bc020d69e68aaa7$var$_initializerDefineProperty(this, "projectedCost", $2bc020d69e68aaa7$var$_descriptor7, this);
        $2bc020d69e68aaa7$var$_initializerDefineProperty(this, "prospectiveCost", $2bc020d69e68aaa7$var$_descriptor8, this);
        $2bc020d69e68aaa7$var$_initializerDefineProperty(this, "editedHours", $2bc020d69e68aaa7$var$_descriptor9, this);
        $2bc020d69e68aaa7$var$_initializerDefineProperty(this, "editedCost", $2bc020d69e68aaa7$var$_descriptor10, this);
        $2bc020d69e68aaa7$var$_initializerDefineProperty(this, "status", $2bc020d69e68aaa7$var$_descriptor11, this);
        $2bc020d69e68aaa7$var$_initializerDefineProperty(this, "projectId", $2bc020d69e68aaa7$var$_descriptor12, this);
        $2bc020d69e68aaa7$var$_initializerDefineProperty(this, "phaseId", $2bc020d69e68aaa7$var$_descriptor13, this);
        $2bc020d69e68aaa7$var$_initializerDefineProperty(this, "phaseTitle", $2bc020d69e68aaa7$var$_descriptor14, this);
        $2bc020d69e68aaa7$var$_initializerDefineProperty(this, "staffRoleId", $2bc020d69e68aaa7$var$_descriptor15, this);
        $2bc020d69e68aaa7$var$_initializerDefineProperty(this, "staffId", $2bc020d69e68aaa7$var$_descriptor16, this);
        $2bc020d69e68aaa7$var$_initializerDefineProperty(this, "hoursStartDate", $2bc020d69e68aaa7$var$_descriptor17, this);
        $2bc020d69e68aaa7$var$_initializerDefineProperty(this, "hoursEndDate", $2bc020d69e68aaa7$var$_descriptor18, this);
        $2bc020d69e68aaa7$var$_initializerDefineProperty(this, "groups", $2bc020d69e68aaa7$var$_descriptor19, this);
        $2bc020d69e68aaa7$var$_initializerDefineProperty(this, "store", $2bc020d69e68aaa7$var$_descriptor20, this);
        $2bc020d69e68aaa7$var$_initializerDefineProperty(this, "parent", $2bc020d69e68aaa7$var$_descriptor21, this);
        $2bc020d69e68aaa7$var$_initializerDefineProperty(this, "children", $2bc020d69e68aaa7$var$_descriptor22, this);
        $2bc020d69e68aaa7$var$_initializerDefineProperty(this, "isRootPhase", $2bc020d69e68aaa7$var$_descriptor23, this);
        $2bc020d69e68aaa7$var$_defineProperty(this, "getHoursInMonth", (month, hoursData = this.hoursData)=>{
            if (this.children.length) return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.children.map((r)=>r.getHoursInMonth(month)));
            if (hoursData === "actual") {
                var _this$actualHours$mon;
                return (_this$actualHours$mon = this.actualHours[month]) !== null && _this$actualHours$mon !== void 0 ? _this$actualHours$mon : 0;
            }
            if (hoursData === "projected") {
                var _this$staff, _ref, _this$editedHours$mon;
                if ((_this$staff = this.staff) !== null && _this$staff !== void 0 && _this$staff.isArchived) return 0;
                return (_ref = (_this$editedHours$mon = this.editedHours[month]) !== null && _this$editedHours$mon !== void 0 ? _this$editedHours$mon : this.projectedHours[month]) !== null && _ref !== void 0 ? _ref : 0;
            }
            if (hoursData === "actualsProjected") {
                if (month < (0, $4hBm1.format)(new Date(), "yyyy-MM")) {
                    var _this$actualHours$mon2;
                    return (_this$actualHours$mon2 = this.actualHours[month]) !== null && _this$actualHours$mon2 !== void 0 ? _this$actualHours$mon2 : 0;
                } else if (month > (0, $4hBm1.format)(new Date(), "yyyy-MM")) {
                    var _ref2, _this$editedHours$mon2;
                    return (_ref2 = (_this$editedHours$mon2 = this.editedHours[month]) !== null && _this$editedHours$mon2 !== void 0 ? _this$editedHours$mon2 : this.projectedHours[month]) !== null && _ref2 !== void 0 ? _ref2 : 0;
                } else {
                    var _this$actualHours$mon3, _ref3, _this$editedHours$mon3;
                    return Math.max((_this$actualHours$mon3 = this.actualHours[month]) !== null && _this$actualHours$mon3 !== void 0 ? _this$actualHours$mon3 : 0, (_ref3 = (_this$editedHours$mon3 = this.editedHours[month]) !== null && _this$editedHours$mon3 !== void 0 ? _this$editedHours$mon3 : this.projectedHours[month]) !== null && _ref3 !== void 0 ? _ref3 : 0);
                }
            }
            if (hoursData === "remainingProjected") {
                var _ref4, _this$editedHours$mon4, _this$actualHours$mon4;
                return ((_ref4 = (_this$editedHours$mon4 = this.editedHours[month]) !== null && _this$editedHours$mon4 !== void 0 ? _this$editedHours$mon4 : this.projectedHours[month]) !== null && _ref4 !== void 0 ? _ref4 : 0) - ((_this$actualHours$mon4 = this.actualHours[month]) !== null && _this$actualHours$mon4 !== void 0 ? _this$actualHours$mon4 : 0);
            }
            if (hoursData === "remainingProjectedCapped") {
                var _ref5, _this$editedHours$mon5, _this$actualHours$mon5;
                return Math.max(((_ref5 = (_this$editedHours$mon5 = this.editedHours[month]) !== null && _this$editedHours$mon5 !== void 0 ? _this$editedHours$mon5 : this.projectedHours[month]) !== null && _ref5 !== void 0 ? _ref5 : 0) - ((_this$actualHours$mon5 = this.actualHours[month]) !== null && _this$actualHours$mon5 !== void 0 ? _this$actualHours$mon5 : 0), 0);
            }
        });
        $2bc020d69e68aaa7$var$_defineProperty(this, "getProspectiveHoursInMonth", (0, $Ds2V9.computedFn)((month)=>{
            if (this.children.length) return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.children.map((r)=>r.getProspectiveHoursInMonth(month)));
            if (this.hoursData === "actual") return 0;
            if (this.hoursData === "projected") {
                var _this$staff2, _this$prospectiveHour;
                if ((_this$staff2 = this.staff) !== null && _this$staff2 !== void 0 && _this$staff2.isArchived) return 0;
                return (_this$prospectiveHour = this.prospectiveHours[month]) !== null && _this$prospectiveHour !== void 0 ? _this$prospectiveHour : 0;
            }
            if (this.hoursData === "actualsProjected") {
                if (month < (0, $4hBm1.format)(new Date(), "yyyy-MM")) return 0;
                else if (month >= (0, $4hBm1.format)(new Date(), "yyyy-MM")) {
                    var _this$prospectiveHour2;
                    return (_this$prospectiveHour2 = this.prospectiveHours[month]) !== null && _this$prospectiveHour2 !== void 0 ? _this$prospectiveHour2 : 0;
                }
            }
        }));
        $2bc020d69e68aaa7$var$_defineProperty(this, "getCostInMonth", (0, $Ds2V9.computedFn)((month)=>{
            if (this.children.length) return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.children.map((r)=>r.getCostInMonth(month)));
            if (this.hoursData === "actual") {
                var _this$actualCost$mont;
                return (_this$actualCost$mont = this.actualCost[month]) !== null && _this$actualCost$mont !== void 0 ? _this$actualCost$mont : 0;
            }
            if (this.hoursData === "projected") {
                var _ref6, _this$editedCost$mont;
                return (_ref6 = (_this$editedCost$mont = this.editedCost[month]) !== null && _this$editedCost$mont !== void 0 ? _this$editedCost$mont : this.projectedCost[month]) !== null && _ref6 !== void 0 ? _ref6 : 0;
            }
            if (this.hoursData === "actualsProjected") {
                if (month < (0, $4hBm1.format)(new Date(), "yyyy-MM")) {
                    var _this$actualCost$mont2;
                    return (_this$actualCost$mont2 = this.actualCost[month]) !== null && _this$actualCost$mont2 !== void 0 ? _this$actualCost$mont2 : 0;
                } else if (month > (0, $4hBm1.format)(new Date(), "yyyy-MM")) {
                    var _ref7, _this$editedCost$mont2;
                    return (_ref7 = (_this$editedCost$mont2 = this.editedCost[month]) !== null && _this$editedCost$mont2 !== void 0 ? _this$editedCost$mont2 : this.projectedCost[month]) !== null && _ref7 !== void 0 ? _ref7 : 0;
                } else {
                    var _this$actualCost$mont3, _ref8, _this$editedCost$mont3;
                    return Math.max((_this$actualCost$mont3 = this.actualCost[month]) !== null && _this$actualCost$mont3 !== void 0 ? _this$actualCost$mont3 : 0, (_ref8 = (_this$editedCost$mont3 = this.editedCost[month]) !== null && _this$editedCost$mont3 !== void 0 ? _this$editedCost$mont3 : this.projectedCost[month]) !== null && _ref8 !== void 0 ? _ref8 : 0);
                }
            }
        }));
        $2bc020d69e68aaa7$var$_defineProperty(this, "getHoursToDateInMonth", (0, $Ds2V9.computedFn)((month)=>{
            const prevHoursMonths = this.hoursMonths.filter((m)=>m <= month);
            const hoursToDate = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(prevHoursMonths.map((m)=>this.getHoursInMonth(m)));
            return hoursToDate;
        }));
        $2bc020d69e68aaa7$var$_defineProperty(this, "getCostToDateInMonth", (0, $Ds2V9.computedFn)((month)=>{
            const prevHoursMonths = this.hoursMonths.filter((m)=>m <= month);
            const costToDate = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(prevHoursMonths.map((m)=>this.getCostInMonth(m)));
            return costToDate;
        }));
        $2bc020d69e68aaa7$var$_defineProperty(this, "getTotalHours", (0, $Ds2V9.computedFn)(()=>{
            return this.getHoursToDateInMonth((0, $4hBm1.format)((0, $4hBm1.addYears)(new Date(), 100), "yyyy-MM"));
        }));
        $2bc020d69e68aaa7$var$_defineProperty(this, "getTotalCost", (0, $Ds2V9.computedFn)(()=>{
            return this.getCostToDateInMonth((0, $4hBm1.format)((0, $4hBm1.addYears)(new Date(), 100), "yyyy-MM"));
        }));
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $9eute.default);
        this.init(data, options);
    }
    setStore(store) {
        this.children.forEach((r)=>r.setStore(store));
        if (this.store === store) return;
        this.store = store;
    }
    setParent(parent) {
        this.parent = parent;
    }
    setChildren(children = []) {
        this.children = children;
    }
    get leaves() {
        if (this.children.length) return this.children.flatMap((c)=>c.leaves);
        return [
            this
        ];
    }
    get hoursData() {
        var _this$store, _this$store$report, _this$store$report$fi, _this$store2, _this$store2$report, _this$store2$report$f, _this$store3, _this$store3$report, _this$store3$report$f;
        return ((_this$store = this.store) === null || _this$store === void 0 ? void 0 : (_this$store$report = _this$store.report) === null || _this$store$report === void 0 ? void 0 : (_this$store$report$fi = _this$store$report.filters) === null || _this$store$report$fi === void 0 ? void 0 : _this$store$report$fi.hoursData) || ((_this$store2 = this.store) === null || _this$store2 === void 0 ? void 0 : (_this$store2$report = _this$store2.report) === null || _this$store2$report === void 0 ? void 0 : (_this$store2$report$f = _this$store2$report.filters) === null || _this$store2$report$f === void 0 ? void 0 : _this$store2$report$f.revenueData) || ((_this$store3 = this.store) === null || _this$store3 === void 0 ? void 0 : (_this$store3$report = _this$store3.report) === null || _this$store3$report === void 0 ? void 0 : (_this$store3$report$f = _this$store3$report.filters) === null || _this$store3$report$f === void 0 ? void 0 : _this$store3$report$f.expenseData) || "actualsProjected";
    }
    get title() {
        const lastGroup = this.groups[this.groups.length - 1];
        if (!this.label || this.label === "") {
            var _this$lastGroup;
            const titleProp = $2bc020d69e68aaa7$var$titlePropByGroup[lastGroup];
            return titleProp ? (_this$lastGroup = this[lastGroup]) === null || _this$lastGroup === void 0 ? void 0 : _this$lastGroup[titleProp] : this[lastGroup];
        } else return this.label;
    }
    get hoursBudget() {
        if (!("staffId" in this.matchers || "staffRoleId" in this.matchers)) {
            var _this$phase, _this$project;
            return this.budget || ((_this$phase = this.phase) === null || _this$phase === void 0 ? void 0 : _this$phase.hoursBudget) || ((_this$project = this.project) === null || _this$project === void 0 ? void 0 : _this$project.hoursBudget);
        } else return this.budget || (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.children.map((c)=>c.hoursBudget));
    }
    get costBudget() {
        if (!("staffId" in this.matchers || "staffRoleId" in this.matchers)) {
            var _this$phase2, _this$project2;
            return this.hoursBudget * this.costRate || ((_this$phase2 = this.phase) === null || _this$phase2 === void 0 ? void 0 : _this$phase2.expenseBudget) || ((_this$project2 = this.project) === null || _this$project2 === void 0 ? void 0 : _this$project2.expenseBudget);
        } else return this.hoursBudget * this.costRate || (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.children.map((c)=>c.costBudget));
    }
    get chargeOutBudget() {
        if (!("staffId" in this.matchers || "staffRoleId" in this.matchers)) {
            var _this$phase3, _this$project3;
            return this.hoursBudget * this.chargeOutRate || ((_this$phase3 = this.phase) === null || _this$phase3 === void 0 ? void 0 : _this$phase3.fee) || ((_this$project3 = this.project) === null || _this$project3 === void 0 ? void 0 : _this$project3.fee);
        } else return this.hoursBudget * this.chargeOutRate || (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.children.map((c)=>c.chargeOutBudget));
    }
    get level() {
        return this.groups.length - 1;
    }
    get childPhases() {
        return this.phase ? [
            this.phase
        ] : [
            ...new Set(this.children.flatMap((c)=>c.childPhases))
        ].filter((p)=>p);
    }
    get childPhaseIds() {
        return this.phaseId ? [
            this.phaseId
        ] : [
            ...new Set(this.children.flatMap((c)=>c.childPhaseIds))
        ].filter((p)=>p);
    }
    get childProjects() {
        return this.project ? [
            this.project
        ] : [
            ...new Set(this.children.flatMap((c)=>c.childProjects))
        ].filter((p)=>p);
    }
    get childProjectIds() {
        return this.projectId ? [
            this.projectId
        ] : [
            ...new Set(this.children.flatMap((c)=>c.childProjectIds))
        ].filter((p)=>p);
    }
    get childProjectRows() {
        return this.project ? [
            this
        ] : [
            ...new Set(this.children.flatMap((c)=>c.childProjectRows))
        ];
    }
    get childStaff() {
        return this.staff ? [
            this.staff
        ] : [
            ...new Set(this.children.flatMap((c)=>c.childStaff))
        ].filter((s)=>s);
    }
    get childRoles() {
        return this.role ? [
            this.role
        ] : [
            ...new Set(this.children.flatMap((c)=>c.childRoles))
        ];
    }
    get phase() {
        return (0, $XoImS.default).phasesById[this.matchers.phaseId];
    }
    get project() {
        return (0, $gJT7h.default).projectsById[this.matchers.projectId];
    }
    get role() {
        return (0, $bxXv3.default).rolesById[this.matchers.staffRoleId];
    }
    get staff() {
        return (0, $htkeB.default).staffById[this.matchers.staffId];
    }
    get allStaff() {
        var _this$role;
        return ((this.groups.includes("staff") ? [
            this.staff
        ] : this.groups.includes("role") ? ((_this$role = this.role) === null || _this$role === void 0 ? void 0 : _this$role.staff) || (0, $htkeB.default).staffByRoleId[this.staffRoleId] : (0, $htkeB.default).staff) || []).filter((s)=>s && !(s !== null && s !== void 0 && s.deletedAt));
    }
    get matchers() {
        let matchers = {};
        if (this.groups.includes("staff")) matchers.staffId = this.staffId;
        if (this.groups.includes("role")) matchers.staffRoleId = this.staffRoleId;
        if (this.groups.includes("phase")) matchers.phaseId = this.phaseId;
        if (this.groups.includes("project")) matchers.projectId = this.projectId;
        if (this.groups.includes("status")) matchers.status = this.status;
        return matchers;
    }
    getAvailabilityInMonth(month, store) {
        const monthDate = (0, $4hBm1.startOfMonth)((0, $4hBm1.parse)(month, "yyyy-MM", new Date()));
        const start = (0, $4hBm1.startOfMonth)(monthDate);
        const end = (0, $4hBm1.endOfMonth)(monthDate);
        const dayAfterEnd = (0, $4hBm1.startOfMonth)((0, $4hBm1.addDays)(end, 1));
        const holidayDays = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum((0, $8XaFv.default).organisationHolidays.filter((h)=>h.startDate <= end && h.endDate >= start).map((h)=>{
            const startDate = Math.max(h.startDate, start);
            const endDate = (0, $4hBm1.addDays)((0, $4hBm1.startOfDay)(Math.min(h.endDate, end)), 1);
            return (0, $4hBm1.differenceInBusinessDays)(endDate, startDate);
        }));
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.allStaff.filter((s)=>!store || store.staff.includes(s)).map((s)=>s.getAvailabilityInDateRange([
                start,
                end
            ]) / 60 / 5)) * ((0, $4hBm1.differenceInBusinessDays)(dayAfterEnd, start) - holidayDays);
    }
    getTotalAvailability(store) {
        const endMonth = (0, $4hBm1.startOfMonth)(this.hoursEndDate || new Date());
        let startMonth = (0, $4hBm1.startOfMonth)(this.hoursStartDate || new Date());
        const months = [];
        while(startMonth <= endMonth){
            months.push((0, $4hBm1.format)(startMonth, "yyyy-MM"));
            startMonth = (0, $4hBm1.startOfMonth)((0, $4hBm1.addMonths)(startMonth, 1));
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(months.map((m)=>this.getAvailabilityInMonth(m, store))) || 0;
    }
    get hoursMonths() {
        if (this.children.length) return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).uniq(this.children.flatMap((r)=>r.hoursMonths));
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).uniq([
            ...Object.keys(this.actualHours),
            ...Object.keys(this.projectedHours),
            ...Object.keys(this.editedHours)
        ]);
    }
    getProgressInMonth(month) {
        return this.getHoursToDateInMonth(month) / this.hoursBudget;
    }
    getCostProgressInMonth(month) {
        return this.getCostToDateInMonth(month) / this.costBudget;
    }
    get resource() {
        return this.staff || this.role;
    }
    get costRate() {
        if (this.children.length) return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).mean(this.children.map((r)=>r.costRate));
        return (0, $ywyHN.default)({
            project: this.project,
            phase: this.phase,
            staff: this.staff,
            role: this.role
        }, "cost", [
            this.startDate,
            this.endDate
        ]);
    }
    get chargeOutRate() {
        if (this.children.length) return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).mean(this.children.map((r)=>r.chargeOutRate));
        return (0, $ywyHN.default)({
            project: this.project,
            phase: this.phase,
            staff: this.staff,
            role: this.role
        }, "chargeOut", [
            this.startDate,
            this.endDate
        ]);
    }
    getCostRateInMonth(month) {
        const costInMonth = this.getCostInMonth(month);
        const hoursInMonth = this.getHoursInMonth(month);
        if (hoursInMonth) return costInMonth / hoursInMonth;
        if (this.children.length) return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).mean(this.children.map((r)=>r.getCostRateInMonth(month)));
        const monthDate = (0, $4hBm1.startOfMonth)((0, $4hBm1.parse)(month, "yyyy-MM", new Date()));
        const monthEndDate = (0, $4hBm1.endOfMonth)(monthDate);
        return (0, $ywyHN.default)({
            project: this.project,
            phase: this.phase,
            staff: this.staff,
            role: this.role
        }, "cost", [
            monthDate,
            monthEndDate
        ]);
    }
    getChargeOutRateInMonth(month) {
        const chargeOutInMonth = this.getChargeOutInMonth(month);
        const hoursInMonth = this.getHoursInMonth(month);
        if (hoursInMonth) return chargeOutInMonth / hoursInMonth;
        if (this.children.length) return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).mean(this.children.map((r)=>r.getChargeOutRateInMonth(month)));
        const monthDate = (0, $4hBm1.startOfMonth)((0, $4hBm1.parse)(month, "yyyy-MM", new Date()));
        const monthEndDate = (0, $4hBm1.endOfMonth)(monthDate);
        return (0, $ywyHN.default)({
            project: this.project,
            phase: this.phase,
            staff: this.staff,
            role: this.role
        }, "chargeOut", [
            monthDate,
            monthEndDate
        ]);
    }
    setHoursProgressInMonth(month, progress) {
        progress || (progress = 0);
        const monthDate = (0, $4hBm1.parse)(month, "yyyy-MM", new Date());
        const prevMonth = (0, $4hBm1.format)((0, $4hBm1.subMonths)(monthDate, 1), "yyyy-MM");
        const prevProgress = this.getProgressInMonth(prevMonth) || 0;
        const diffProgress = Math.max(progress, prevProgress) - prevProgress;
        const diffHours = diffProgress * this.hoursBudget;
        return this.setHoursInMonth(month, diffHours);
    }
    setCostProgressInMonth(month, progress) {
        progress || (progress = 0);
        const monthDate = (0, $4hBm1.parse)(month, "yyyy-MM", new Date());
        const prevMonth = (0, $4hBm1.format)((0, $4hBm1.subMonths)(monthDate, 1), "yyyy-MM");
        const prevProgress = this.getCostProgressInMonth(prevMonth) || 0;
        const diffProgress = Math.max(progress, prevProgress) - prevProgress;
        const diffCost = diffProgress * this.costBudget;
        return this.setCostInMonth(month, diffCost);
    }
    setHoursInMonth(month, v, options) {
        const costRate = this.getCostRateInMonth(month);
        if (!this.children.length) {
            this.editedHours[month] = v;
            this.update({
                editedHours: {
                    ...this.editedHours
                }
            }, options);
            this.editedCost[month] = v * costRate;
        }
        const children = this.children;
        const childrenWithHoursInMonth = children.filter((r)=>r.getHoursInMonth(month) > 0);
        const existingHoursInMonth = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(childrenWithHoursInMonth.map((r)=>r.getHoursInMonth(month)));
        if (existingHoursInMonth) {
            const ratio = v / existingHoursInMonth;
            childrenWithHoursInMonth.forEach((r)=>r.setHoursInMonth(month, r.getHoursInMonth(month) * ratio, options));
        } else children.forEach((r)=>r.setHoursInMonth(month, v / children.length, options));
    }
    setCostInMonth(month, v, options) {
        const costRate = this.getCostRateInMonth(month);
        const hours = costRate ? v / costRate : 0;
        this.setHoursInMonth(month, hours, options);
    }
    serialize() {
        var _this$store4, _this$store4$report;
        return {
            id: this.id,
            editedHours: this.editedHours,
            reportFilters: {
                ...((_this$store4 = this.store) === null || _this$store4 === void 0 ? void 0 : (_this$store4$report = _this$store4.report) === null || _this$store4$report === void 0 ? void 0 : _this$store4$report.filters) || {},
                ...this.matchers
            }
        };
    }
    serializeUpdates() {
        return this.serialize();
    }
}, $2bc020d69e68aaa7$var$_descriptor = $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "label", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $2bc020d69e68aaa7$var$_descriptor2 = $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "budget", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $2bc020d69e68aaa7$var$_descriptor3 = $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "actualHours", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $2bc020d69e68aaa7$var$_descriptor4 = $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "projectedHours", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $2bc020d69e68aaa7$var$_descriptor5 = $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "prospectiveHours", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $2bc020d69e68aaa7$var$_descriptor6 = $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "actualCost", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $2bc020d69e68aaa7$var$_descriptor7 = $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "projectedCost", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $2bc020d69e68aaa7$var$_descriptor8 = $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "prospectiveCost", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $2bc020d69e68aaa7$var$_descriptor9 = $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "editedHours", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $2bc020d69e68aaa7$var$_descriptor10 = $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "editedCost", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $2bc020d69e68aaa7$var$_descriptor11 = $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "status", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $2bc020d69e68aaa7$var$_descriptor12 = $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "projectId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $2bc020d69e68aaa7$var$_descriptor13 = $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "phaseId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $2bc020d69e68aaa7$var$_descriptor14 = $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "phaseTitle", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $2bc020d69e68aaa7$var$_descriptor15 = $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "staffRoleId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $2bc020d69e68aaa7$var$_descriptor16 = $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "staffId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $2bc020d69e68aaa7$var$_descriptor17 = $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "hoursStartDate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $2bc020d69e68aaa7$var$_descriptor18 = $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "hoursEndDate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $2bc020d69e68aaa7$var$_descriptor19 = $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "groups", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [
            "status"
        ];
    }
}), $2bc020d69e68aaa7$var$_descriptor20 = $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "store", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $2bc020d69e68aaa7$var$_descriptor21 = $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "parent", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $2bc020d69e68aaa7$var$_descriptor22 = $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "children", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $2bc020d69e68aaa7$var$_descriptor23 = $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "isRootPhase", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "setStore", [
    $2bc020d69e68aaa7$var$_dec
], Object.getOwnPropertyDescriptor($2bc020d69e68aaa7$var$_class.prototype, "setStore"), $2bc020d69e68aaa7$var$_class.prototype), $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "setParent", [
    $2bc020d69e68aaa7$var$_dec2
], Object.getOwnPropertyDescriptor($2bc020d69e68aaa7$var$_class.prototype, "setParent"), $2bc020d69e68aaa7$var$_class.prototype), $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "setChildren", [
    $2bc020d69e68aaa7$var$_dec3
], Object.getOwnPropertyDescriptor($2bc020d69e68aaa7$var$_class.prototype, "setChildren"), $2bc020d69e68aaa7$var$_class.prototype), $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "leaves", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($2bc020d69e68aaa7$var$_class.prototype, "leaves"), $2bc020d69e68aaa7$var$_class.prototype), $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "hoursData", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($2bc020d69e68aaa7$var$_class.prototype, "hoursData"), $2bc020d69e68aaa7$var$_class.prototype), $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "title", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($2bc020d69e68aaa7$var$_class.prototype, "title"), $2bc020d69e68aaa7$var$_class.prototype), $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "hoursBudget", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($2bc020d69e68aaa7$var$_class.prototype, "hoursBudget"), $2bc020d69e68aaa7$var$_class.prototype), $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "costBudget", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($2bc020d69e68aaa7$var$_class.prototype, "costBudget"), $2bc020d69e68aaa7$var$_class.prototype), $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "chargeOutBudget", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($2bc020d69e68aaa7$var$_class.prototype, "chargeOutBudget"), $2bc020d69e68aaa7$var$_class.prototype), $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "level", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($2bc020d69e68aaa7$var$_class.prototype, "level"), $2bc020d69e68aaa7$var$_class.prototype), $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "childPhases", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($2bc020d69e68aaa7$var$_class.prototype, "childPhases"), $2bc020d69e68aaa7$var$_class.prototype), $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "childPhaseIds", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($2bc020d69e68aaa7$var$_class.prototype, "childPhaseIds"), $2bc020d69e68aaa7$var$_class.prototype), $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "childProjects", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($2bc020d69e68aaa7$var$_class.prototype, "childProjects"), $2bc020d69e68aaa7$var$_class.prototype), $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "childProjectIds", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($2bc020d69e68aaa7$var$_class.prototype, "childProjectIds"), $2bc020d69e68aaa7$var$_class.prototype), $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "childProjectRows", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($2bc020d69e68aaa7$var$_class.prototype, "childProjectRows"), $2bc020d69e68aaa7$var$_class.prototype), $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "childStaff", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($2bc020d69e68aaa7$var$_class.prototype, "childStaff"), $2bc020d69e68aaa7$var$_class.prototype), $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "childRoles", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($2bc020d69e68aaa7$var$_class.prototype, "childRoles"), $2bc020d69e68aaa7$var$_class.prototype), $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "phase", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($2bc020d69e68aaa7$var$_class.prototype, "phase"), $2bc020d69e68aaa7$var$_class.prototype), $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "project", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($2bc020d69e68aaa7$var$_class.prototype, "project"), $2bc020d69e68aaa7$var$_class.prototype), $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "role", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($2bc020d69e68aaa7$var$_class.prototype, "role"), $2bc020d69e68aaa7$var$_class.prototype), $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "staff", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($2bc020d69e68aaa7$var$_class.prototype, "staff"), $2bc020d69e68aaa7$var$_class.prototype), $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "allStaff", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($2bc020d69e68aaa7$var$_class.prototype, "allStaff"), $2bc020d69e68aaa7$var$_class.prototype), $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "matchers", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($2bc020d69e68aaa7$var$_class.prototype, "matchers"), $2bc020d69e68aaa7$var$_class.prototype), $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "getAvailabilityInMonth", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($2bc020d69e68aaa7$var$_class.prototype, "getAvailabilityInMonth"), $2bc020d69e68aaa7$var$_class.prototype), $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "getTotalAvailability", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($2bc020d69e68aaa7$var$_class.prototype, "getTotalAvailability"), $2bc020d69e68aaa7$var$_class.prototype), $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "hoursMonths", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($2bc020d69e68aaa7$var$_class.prototype, "hoursMonths"), $2bc020d69e68aaa7$var$_class.prototype), $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "getProgressInMonth", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($2bc020d69e68aaa7$var$_class.prototype, "getProgressInMonth"), $2bc020d69e68aaa7$var$_class.prototype), $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "getCostProgressInMonth", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($2bc020d69e68aaa7$var$_class.prototype, "getCostProgressInMonth"), $2bc020d69e68aaa7$var$_class.prototype), $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "resource", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($2bc020d69e68aaa7$var$_class.prototype, "resource"), $2bc020d69e68aaa7$var$_class.prototype), $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "costRate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($2bc020d69e68aaa7$var$_class.prototype, "costRate"), $2bc020d69e68aaa7$var$_class.prototype), $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "chargeOutRate", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($2bc020d69e68aaa7$var$_class.prototype, "chargeOutRate"), $2bc020d69e68aaa7$var$_class.prototype), $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "setHoursProgressInMonth", [
    $2bc020d69e68aaa7$var$_dec4
], Object.getOwnPropertyDescriptor($2bc020d69e68aaa7$var$_class.prototype, "setHoursProgressInMonth"), $2bc020d69e68aaa7$var$_class.prototype), $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "setCostProgressInMonth", [
    $2bc020d69e68aaa7$var$_dec5
], Object.getOwnPropertyDescriptor($2bc020d69e68aaa7$var$_class.prototype, "setCostProgressInMonth"), $2bc020d69e68aaa7$var$_class.prototype), $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "setHoursInMonth", [
    (0, $4JcCM.action)
], Object.getOwnPropertyDescriptor($2bc020d69e68aaa7$var$_class.prototype, "setHoursInMonth"), $2bc020d69e68aaa7$var$_class.prototype), $2bc020d69e68aaa7$var$_applyDecoratedDescriptor($2bc020d69e68aaa7$var$_class.prototype, "setCostInMonth", [
    (0, $4JcCM.action)
], Object.getOwnPropertyDescriptor($2bc020d69e68aaa7$var$_class.prototype, "setCostInMonth"), $2bc020d69e68aaa7$var$_class.prototype), $2bc020d69e68aaa7$var$_class);
var $2bc020d69e68aaa7$export$2e2bcd8739ae039 = $2bc020d69e68aaa7$var$ResourceRowModel;

});
parcelRegister("Ds2V9", function(module, exports) {

$parcel$export(module.exports, "computedFn", function () { return $076966017c87bdf8$export$79a1d35ba0cac8da; });

var $4JcCM = parcelRequire("4JcCM");
var $076966017c87bdf8$export$5702a91a6f42969f = function() {};
var $076966017c87bdf8$export$76c0f2b8ecfc3d8a = function(_) {
    return _;
};
function $076966017c87bdf8$export$2b62a06a9fee979c(message) {
    throw new Error("[mobx-utils] " + message);
}
function $076966017c87bdf8$export$f5708dca728d7177(cond, message) {
    if (message === void 0) message = "Illegal state";
    if (!cond) $076966017c87bdf8$export$2b62a06a9fee979c(message);
}
function $076966017c87bdf8$export$edfd600d9920791e(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
var $076966017c87bdf8$var$deepFields = function(x) {
    return x && x !== Object.prototype && Object.getOwnPropertyNames(x).concat($076966017c87bdf8$var$deepFields(Object.getPrototypeOf(x)) || []);
};
var $076966017c87bdf8$var$distinctDeepFields = function(x) {
    var deepFieldsIndistinct = $076966017c87bdf8$var$deepFields(x);
    var deepFieldsDistinct = deepFieldsIndistinct.filter(function(item, index) {
        return deepFieldsIndistinct.indexOf(item) === index;
    });
    return deepFieldsDistinct;
};
var $076966017c87bdf8$export$a984b761acd10b55 = function(x) {
    return $076966017c87bdf8$var$distinctDeepFields(x).filter(function(name) {
        return name !== "constructor" && !~name.indexOf("__");
    });
};
var $076966017c87bdf8$export$aebb42912407fb2d = "pending";
var $076966017c87bdf8$export$db6da4f66a5dc93d = "fulfilled";
var $076966017c87bdf8$export$83d3e3ad3e63df9c = "rejected";
function $076966017c87bdf8$var$caseImpl(handlers) {
    switch(this.state){
        case $076966017c87bdf8$export$aebb42912407fb2d:
            return handlers.pending && handlers.pending(this.value);
        case $076966017c87bdf8$export$83d3e3ad3e63df9c:
            return handlers.rejected && handlers.rejected(this.value);
        case $076966017c87bdf8$export$db6da4f66a5dc93d:
            return handlers.fulfilled ? handlers.fulfilled(this.value) : this.value;
    }
}
/**
 * `fromPromise` takes a Promise, extends it with 2 observable properties that track
 * the status of the promise and returns it. The returned object has the following observable properties:
 *  - `value`: either the initial value, the value the Promise resolved to, or the value the Promise was rejected with. use `.state` if you need to be able to tell the difference.
 *  - `state`: one of `"pending"`, `"fulfilled"` or `"rejected"`
 *
 * And the following methods:
 * - `case({fulfilled, rejected, pending})`: maps over the result using the provided handlers, or returns `undefined` if a handler isn't available for the current promise state.
 *
 * The returned object implements `PromiseLike<TValue>`, so you can chain additional `Promise` handlers using `then`. You may also use it with `await` in `async` functions.
 *
 * Note that the status strings are available as constants:
 * `mobxUtils.PENDING`, `mobxUtils.REJECTED`, `mobxUtil.FULFILLED`
 *
 * fromPromise takes an optional second argument, a previously created `fromPromise` based observable.
 * This is useful to replace one promise based observable with another, without going back to an intermediate
 * "pending" promise state while fetching data. For example:
 *
 * @example
 * \@observer
 * class SearchResults extends React.Component {
 *   \@observable.ref searchResults
 *
 *   componentDidUpdate(nextProps) {
 *     if (nextProps.query !== this.props.query)
 *       this.searchResults = fromPromise(
 *         window.fetch("/search?q=" + nextProps.query),
 *         // by passing, we won't render a pending state if we had a successful search query before
 *         // rather, we will keep showing the previous search results, until the new promise resolves (or rejects)
 *         this.searchResults
 *       )
 *   }
 *
 *   render() {
 *     return this.searchResults.case({
 *        pending: (staleValue) => {
 *          return staleValue || "searching" // <- value might set to previous results while the promise is still pending
 *        },
 *        fulfilled: (value) => {
 *          return value // the fresh results
 *        },
 *        rejected: (error) => {
 *          return "Oops: " + error
 *        }
 *     })
 *   }
 * }
 *
 * Observable promises can be created immediately in a certain state using
 * `fromPromise.reject(reason)` or `fromPromise.resolve(value?)`.
 * The main advantage of `fromPromise.resolve(value)` over `fromPromise(Promise.resolve(value))` is that the first _synchronously_ starts in the desired state.
 *
 * It is possible to directly create a promise using a resolve, reject function:
 * `fromPromise((resolve, reject) => setTimeout(() => resolve(true), 1000))`
 *
 * @example
 * const fetchResult = fromPromise(fetch("http://someurl"))
 *
 * // combine with when..
 * when(
 *   () => fetchResult.state !== "pending",
 *   () => {
 *     console.log("Got ", fetchResult.value)
 *   }
 * )
 *
 * // or a mobx-react component..
 * const myComponent = observer(({ fetchResult }) => {
 *   switch(fetchResult.state) {
 *      case "pending": return <div>Loading...</div>
 *      case "rejected": return <div>Ooops... {fetchResult.value}</div>
 *      case "fulfilled": return <div>Gotcha: {fetchResult.value}</div>
 *   }
 * })
 *
 * // or using the case method instead of switch:
 *
 * const myComponent = observer(({ fetchResult }) =>
 *   fetchResult.case({
 *     pending:   () => <div>Loading...</div>,
 *     rejected:  error => <div>Ooops.. {error}</div>,
 *     fulfilled: value => <div>Gotcha: {value}</div>,
 *   }))
 *
 * // chain additional handler(s) to the resolve/reject:
 *
 * fetchResult.then(
 *   (result) =>  doSomeTransformation(result),
 *   (rejectReason) => console.error('fetchResult was rejected, reason: ' + rejectReason)
 * ).then(
 *   (transformedResult) => console.log('transformed fetchResult: ' + transformedResult)
 * )
 *
 * @param origPromise The promise which will be observed
 * @param oldPromise The previously observed promise
 * @returns origPromise with added properties and methods described above.
 */ function $076966017c87bdf8$export$60f45028237c39d1(origPromise, oldPromise) {
    $076966017c87bdf8$export$f5708dca728d7177(arguments.length <= 2, "fromPromise expects up to two arguments");
    $076966017c87bdf8$export$f5708dca728d7177(typeof origPromise === "function" || typeof origPromise === "object" && origPromise && typeof origPromise.then === "function", "Please pass a promise or function to fromPromise");
    if (origPromise.isPromiseBasedObservable === true) return origPromise;
    if (typeof origPromise === "function") // If it is a (reject, resolve function, wrap it)
    origPromise = new Promise(origPromise);
    var promise = origPromise;
    origPromise.then((0, $4JcCM.action)("observableFromPromise-resolve", function(value) {
        promise.value = value;
        promise.state = $076966017c87bdf8$export$db6da4f66a5dc93d;
    }), (0, $4JcCM.action)("observableFromPromise-reject", function(reason) {
        promise.value = reason;
        promise.state = $076966017c87bdf8$export$83d3e3ad3e63df9c;
    }));
    promise.isPromiseBasedObservable = true;
    promise.case = $076966017c87bdf8$var$caseImpl;
    var oldData = oldPromise && (oldPromise.state === $076966017c87bdf8$export$db6da4f66a5dc93d || oldPromise.state === $076966017c87bdf8$export$aebb42912407fb2d) ? oldPromise.value : undefined;
    (0, $4JcCM.extendObservable)(promise, {
        value: oldData,
        state: $076966017c87bdf8$export$aebb42912407fb2d
    }, {}, {
        deep: false
    });
    return promise;
}
(function(fromPromise) {
    fromPromise.reject = (0, $4JcCM.action)("fromPromise.reject", function(reason) {
        var p = fromPromise(Promise.reject(reason));
        p.state = $076966017c87bdf8$export$83d3e3ad3e63df9c;
        p.value = reason;
        return p;
    });
    function resolveBase(value) {
        if (value === void 0) value = undefined;
        var p = fromPromise(Promise.resolve(value));
        p.state = $076966017c87bdf8$export$db6da4f66a5dc93d;
        p.value = value;
        return p;
    }
    fromPromise.resolve = (0, $4JcCM.action)("fromPromise.resolve", resolveBase);
})($076966017c87bdf8$export$60f45028237c39d1 || ($076966017c87bdf8$export$60f45028237c39d1 = {}));
/**
 * Returns true if the provided value is a promise-based observable.
 * @param value any
 * @returns {boolean}
 */ function $076966017c87bdf8$export$ec6a0a7c8171750d(value) {
    return value && value.isPromiseBasedObservable === true;
}
var $076966017c87bdf8$var$__spreadArrays = function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
/**
 * Moves an item from one position to another, checking that the indexes given are within bounds.
 *
 * @example
 * const source = observable([1, 2, 3])
 * moveItem(source, 0, 1)
 * console.log(source.map(x => x)) // [2, 1, 3]
 *
 * @export
 * @param {ObservableArray<T>} target
 * @param {number} fromIndex
 * @param {number} toIndex
 * @returns {ObservableArray<T>}
 */ function $076966017c87bdf8$export$ec937e64de6c1257(target, fromIndex, toIndex) {
    $076966017c87bdf8$var$checkIndex(target, fromIndex);
    $076966017c87bdf8$var$checkIndex(target, toIndex);
    if (fromIndex === toIndex) return;
    var oldItems = target.slice();
    var newItems;
    if (fromIndex < toIndex) newItems = $076966017c87bdf8$var$__spreadArrays(oldItems.slice(0, fromIndex), oldItems.slice(fromIndex + 1, toIndex + 1), [
        oldItems[fromIndex]
    ], oldItems.slice(toIndex + 1));
    else // toIndex < fromIndex
    newItems = $076966017c87bdf8$var$__spreadArrays(oldItems.slice(0, toIndex), [
        oldItems[fromIndex]
    ], oldItems.slice(toIndex, fromIndex), oldItems.slice(fromIndex + 1));
    target.replace(newItems);
    return target;
}
/**
 * Checks whether the specified index is within bounds. Throws if not.
 *
 * @private
 * @param {ObservableArray<any>} target
 * @param {number }index
 */ function $076966017c87bdf8$var$checkIndex(target, index) {
    if (index < 0) throw new Error("[mobx.array] Index out of bounds: " + index + " is negative");
    var length = target.length;
    if (index >= length) throw new Error("[mobx.array] Index out of bounds: " + index + " is not smaller than " + length);
}
/**
 * `lazyObservable` creates an observable around a `fetch` method that will not be invoked
 * until the observable is needed the first time.
 * The fetch method receives a `sink` callback which can be used to replace the
 * current value of the lazyObservable. It is allowed to call `sink` multiple times
 * to keep the lazyObservable up to date with some external resource.
 *
 * Note that it is the `current()` call itself which is being tracked by MobX,
 * so make sure that you don't dereference to early.
 *
 * @example
 * const userProfile = lazyObservable(
 *   sink => fetch("/myprofile").then(profile => sink(profile))
 * )
 *
 * // use the userProfile in a React component:
 * const Profile = observer(({ userProfile }) =>
 *   userProfile.current() === undefined
 *   ? <div>Loading user profile...</div>
 *   : <div>{userProfile.current().displayName}</div>
 * )
 *
 * // triggers refresh the userProfile
 * userProfile.refresh()
 *
 * @param {(sink: (newValue: T) => void) => void} fetch method that will be called the first time the value of this observable is accessed. The provided sink can be used to produce a new value, synchronously or asynchronously
 * @param {T} [initialValue=undefined] optional initialValue that will be returned from `current` as long as the `sink` has not been called at least once
 * @returns {{
 *     current(): T,
 *     refresh(): T,
 *     reset(): T
 *     pending: boolean
 * }}
 */ function $076966017c87bdf8$export$fa198792e96a6577(fetch, initialValue) {
    if (initialValue === void 0) initialValue = undefined;
    var started = false;
    var value = (0, $4JcCM.observable).box(initialValue, {
        deep: false
    });
    var pending = (0, $4JcCM.observable).box(false);
    var currentFnc = function() {
        if (!started) {
            started = true;
            (0, $4JcCM._allowStateChanges)(true, function() {
                pending.set(true);
            });
            fetch(function(newValue) {
                (0, $4JcCM._allowStateChanges)(true, function() {
                    value.set(newValue);
                    pending.set(false);
                });
            });
        }
        return value.get();
    };
    var resetFnc = (0, $4JcCM.action)("lazyObservable-reset", function() {
        started = false;
        value.set(initialValue);
        return value.get();
    });
    return {
        current: currentFnc,
        refresh: function() {
            if (started) {
                started = false;
                return currentFnc();
            } else return value.get();
        },
        reset: function() {
            return resetFnc();
        },
        get pending () {
            return pending.get();
        }
    };
}
/**
 * `fromResource` creates an observable whose current state can be inspected using `.current()`,
 * and which can be kept in sync with some external datasource that can be subscribed to.
 *
 * The created observable will only subscribe to the datasource if it is in use somewhere,
 * (un)subscribing when needed. To enable `fromResource` to do that two callbacks need to be provided,
 * one to subscribe, and one to unsubscribe. The subscribe callback itself will receive a `sink` callback, which can be used
 * to update the current state of the observable, allowing observes to react.
 *
 * Whatever is passed to `sink` will be returned by `current()`. The values passed to the sink will not be converted to
 * observables automatically, but feel free to do so.
 * It is the `current()` call itself which is being tracked,
 * so make sure that you don't dereference to early.
 *
 * For inspiration, an example integration with the apollo-client on [github](https://github.com/apollostack/apollo-client/issues/503#issuecomment-241101379),
 * or the [implementation](https://github.com/mobxjs/mobx-utils/blob/1d17cf7f7f5200937f68cc0b5e7ec7f3f71dccba/src/now.ts#L43-L57) of `mobxUtils.now`
 *
 * The following example code creates an observable that connects to a `dbUserRecord`,
 * which comes from an imaginary database and notifies when it has changed.
 *
 * @example
 * function createObservableUser(dbUserRecord) {
 *   let currentSubscription;
 *   return fromResource(
 *     (sink) => {
 *       // sink the current state
 *       sink(dbUserRecord.fields)
 *       // subscribe to the record, invoke the sink callback whenever new data arrives
 *       currentSubscription = dbUserRecord.onUpdated(() => {
 *         sink(dbUserRecord.fields)
 *       })
 *     },
 *     () => {
 *       // the user observable is not in use at the moment, unsubscribe (for now)
 *       dbUserRecord.unsubscribe(currentSubscription)
 *     }
 *   )
 * }
 *
 * // usage:
 * const myUserObservable = createObservableUser(myDatabaseConnector.query("name = 'Michel'"))
 *
 * // use the observable in autorun
 * autorun(() => {
 *   // printed everytime the database updates its records
 *   console.log(myUserObservable.current().displayName)
 * })
 *
 * // ... or a component
 * const userComponent = observer(({ user }) =>
 *   <div>{user.current().displayName}</div>
 * )
 *
 * @export
 * @template T
 * @param {(sink: (newValue: T) => void) => void} subscriber
 * @param {IDisposer} [unsubscriber=NOOP]
 * @param {T} [initialValue=undefined] the data that will be returned by `get()` until the `sink` has emitted its first data
 * @returns {{
 *     current(): T;
 *     dispose(): void;
 *     isAlive(): boolean;
 * }}
 */ function $076966017c87bdf8$export$c5c49fce5ba0daad(subscriber, unsubscriber, initialValue) {
    if (unsubscriber === void 0) unsubscriber = $076966017c87bdf8$export$5702a91a6f42969f;
    if (initialValue === void 0) initialValue = undefined;
    var isActive = false;
    var isDisposed = false;
    var value = initialValue;
    var suspender = function() {
        if (isActive) {
            isActive = false;
            unsubscriber();
        }
    };
    var atom = (0, $4JcCM.createAtom)("ResourceBasedObservable", function() {
        $076966017c87bdf8$export$f5708dca728d7177(!isActive && !isDisposed);
        isActive = true;
        subscriber(function(newValue) {
            (0, $4JcCM._allowStateChanges)(true, function() {
                value = newValue;
                atom.reportChanged();
            });
        });
    }, suspender);
    return {
        current: function() {
            $076966017c87bdf8$export$f5708dca728d7177(!isDisposed, "subscribingObservable has already been disposed");
            var isBeingTracked = atom.reportObserved();
            if (!isBeingTracked && !isActive) console.warn("Called `get` of a subscribingObservable outside a reaction. Current value will be returned but no new subscription has started");
            return value;
        },
        dispose: function() {
            isDisposed = true;
            suspender();
        },
        isAlive: function() {
            return isActive;
        }
    };
}
var $076966017c87bdf8$var$__decorate = function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
function $076966017c87bdf8$var$observableSymbol() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}
/**
 * Converts an expression to an observable stream (a.k.a. TC 39 Observable / RxJS observable).
 * The provided expression is tracked by mobx as long as there are subscribers, automatically
 * emitting when new values become available. The expressions respect (trans)actions.
 *
 * @example
 *
 * const user = observable({
 *   firstName: "C.S",
 *   lastName: "Lewis"
 * })
 *
 * Rx.Observable
 *   .from(mobxUtils.toStream(() => user.firstname + user.lastName))
 *   .scan(nameChanges => nameChanges + 1, 0)
 *   .subscribe(nameChanges => console.log("Changed name ", nameChanges, "times"))
 *
 * @export
 * @template T
 * @param {() => T} expression
 * @param {boolean} fireImmediately (by default false)
 * @returns {IObservableStream<T>}
 */ function $076966017c87bdf8$export$d4050479c73a24b(expression, fireImmediately) {
    var _a;
    if (fireImmediately === void 0) fireImmediately = false;
    var computedValue = (0, $4JcCM.computed)(expression);
    return _a = {
        subscribe: function(observer) {
            if ("function" === typeof observer) return {
                unsubscribe: (0, $4JcCM.observe)(computedValue, function(_a) {
                    var newValue = _a.newValue;
                    return observer(newValue);
                }, fireImmediately)
            };
            if (observer && "object" === typeof observer && observer.next) return {
                unsubscribe: (0, $4JcCM.observe)(computedValue, function(_a) {
                    var newValue = _a.newValue;
                    return observer.next(newValue);
                }, fireImmediately)
            };
            return {
                unsubscribe: function() {}
            };
        }
    }, _a[$076966017c87bdf8$var$observableSymbol()] = function() {
        return this;
    }, _a;
}
var $076966017c87bdf8$var$StreamListener = /** @class */ function() {
    function StreamListener(observable, initialValue) {
        var _this = this;
        Object.defineProperty(this, "current", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "subscription", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        (0, $4JcCM.makeObservable)(this);
        (0, $4JcCM.runInAction)(function() {
            _this.current = initialValue;
            _this.subscription = observable.subscribe(_this);
        });
    }
    Object.defineProperty(StreamListener.prototype, "dispose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (this.subscription) this.subscription.unsubscribe();
        }
    });
    Object.defineProperty(StreamListener.prototype, "next", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value) {
            this.current = value;
        }
    });
    Object.defineProperty(StreamListener.prototype, "complete", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            this.dispose();
        }
    });
    Object.defineProperty(StreamListener.prototype, "error", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value) {
            this.current = value;
            this.dispose();
        }
    });
    $076966017c87bdf8$var$__decorate([
        (0, $4JcCM.observable).ref
    ], StreamListener.prototype, "current", void 0);
    $076966017c87bdf8$var$__decorate([
        (0, $4JcCM.action).bound
    ], StreamListener.prototype, "next", null);
    $076966017c87bdf8$var$__decorate([
        (0, $4JcCM.action).bound
    ], StreamListener.prototype, "complete", null);
    $076966017c87bdf8$var$__decorate([
        (0, $4JcCM.action).bound
    ], StreamListener.prototype, "error", null);
    return StreamListener;
}();
function $076966017c87bdf8$export$2c6bc52bcd2a369b(observable, initialValue) {
    if (initialValue === void 0) initialValue = undefined;
    return new $076966017c87bdf8$var$StreamListener(observable, initialValue);
}
var $076966017c87bdf8$var$__assign = function() {
    $076966017c87bdf8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $076966017c87bdf8$var$__assign.apply(this, arguments);
};
var $076966017c87bdf8$var$__decorate$1 = function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $076966017c87bdf8$var$RESERVED_NAMES = [
    "model",
    "reset",
    "submit",
    "isDirty",
    "isPropertyDirty",
    "resetProperty"
];
var $076966017c87bdf8$export$a0505c1b7de1f868 = /** @class */ function() {
    function ViewModel(model) {
        var _this = this;
        Object.defineProperty(this, "model", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: model
        });
        Object.defineProperty(this, "localValues", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $4JcCM.observable).map({})
        });
        Object.defineProperty(this, "localComputedValues", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $4JcCM.observable).map({})
        });
        Object.defineProperty(this, "isPropertyDirty", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function(key) {
                return _this.localValues.has(key);
            }
        });
        (0, $4JcCM.makeObservable)(this);
        $076966017c87bdf8$export$f5708dca728d7177((0, $4JcCM.isObservableObject)(model), "createViewModel expects an observable object");
        var ownMethodsAndProperties = $076966017c87bdf8$export$a984b761acd10b55(this);
        // use this helper as Object.getOwnPropertyNames doesn't return getters
        $076966017c87bdf8$export$a984b761acd10b55(model).forEach(function(key) {
            var _a;
            if (ownMethodsAndProperties.includes(key)) return;
            if (key === (0, $4JcCM.$mobx) || key === "__mobxDidRunLazyInitializers") return;
            $076966017c87bdf8$export$f5708dca728d7177($076966017c87bdf8$var$RESERVED_NAMES.indexOf(key) === -1, "The propertyname " + key + " is reserved and cannot be used with viewModels");
            if ((0, $4JcCM.isComputedProp)(model, key)) {
                var computedBox = (0, $4JcCM._getAdministration)(model, key); // Fixme: there is no clear api to get the derivation
                var get = computedBox.derivation.bind(_this);
                var set = (_a = computedBox.setter_) === null || _a === void 0 ? void 0 : _a.bind(_this);
                _this.localComputedValues.set(key, (0, $4JcCM.computed)(get, {
                    set: set
                }));
            }
            var descriptor = Object.getOwnPropertyDescriptor(model, key);
            var additionalDescriptor = descriptor ? {
                enumerable: descriptor.enumerable
            } : {};
            Object.defineProperty(_this, key, $076966017c87bdf8$var$__assign($076966017c87bdf8$var$__assign({}, additionalDescriptor), {
                configurable: true,
                get: function() {
                    if ((0, $4JcCM.isComputedProp)(model, key)) return _this.localComputedValues.get(key).get();
                    if (_this.isPropertyDirty(key)) return _this.localValues.get(key);
                    else return _this.model[key];
                },
                set: (0, $4JcCM.action)(function(value) {
                    if ((0, $4JcCM.isComputedProp)(model, key)) _this.localComputedValues.get(key).set(value);
                    else if (value !== _this.model[key]) _this.localValues.set(key, value);
                    else _this.localValues.delete(key);
                })
            }));
        });
    }
    Object.defineProperty(ViewModel.prototype, "isDirty", {
        get: function() {
            return this.localValues.size > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewModel.prototype, "changedValues", {
        get: function() {
            return new Map(this.localValues);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewModel.prototype, "submit", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            var _this = this;
            (0, $4JcCM.keys)(this.localValues).forEach(function(key) {
                var source = _this.localValues.get(key);
                var destination = _this.model[key];
                if ((0, $4JcCM.isObservableArray)(destination)) destination.replace(source);
                else if ((0, $4JcCM.isObservableMap)(destination)) {
                    destination.clear();
                    destination.merge(source);
                } else if (!(0, $4JcCM.isComputed)(source)) _this.model[key] = source;
            });
            this.localValues.clear();
        }
    });
    Object.defineProperty(ViewModel.prototype, "reset", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            this.localValues.clear();
        }
    });
    Object.defineProperty(ViewModel.prototype, "resetProperty", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(key) {
            this.localValues.delete(key);
        }
    });
    $076966017c87bdf8$var$__decorate$1([
        (0, $4JcCM.computed)
    ], ViewModel.prototype, "isDirty", null);
    $076966017c87bdf8$var$__decorate$1([
        (0, $4JcCM.computed)
    ], ViewModel.prototype, "changedValues", null);
    $076966017c87bdf8$var$__decorate$1([
        (0, $4JcCM.action).bound
    ], ViewModel.prototype, "submit", null);
    $076966017c87bdf8$var$__decorate$1([
        (0, $4JcCM.action).bound
    ], ViewModel.prototype, "reset", null);
    $076966017c87bdf8$var$__decorate$1([
        (0, $4JcCM.action).bound
    ], ViewModel.prototype, "resetProperty", null);
    return ViewModel;
}();
/**
 * `createViewModel` takes an object with observable properties (model)
 * and wraps a viewmodel around it. The viewmodel proxies all enumerable properties of the original model with the following behavior:
 *  - as long as no new value has been assigned to the viewmodel property, the original property will be returned.
 *  - any future change in the model will be visible in the viewmodel as well unless the viewmodel property was dirty at the time of the attempted change.
 *  - once a new value has been assigned to a property of the viewmodel, that value will be returned during a read of that property in the future. However, the original model remain untouched until `submit()` is called.
 *
 * The viewmodel exposes the following additional methods, besides all the enumerable properties of the model:
 * - `submit()`: copies all the values of the viewmodel to the model and resets the state
 * - `reset()`: resets the state of the viewmodel, abandoning all local modifications
 * - `resetProperty(propName)`: resets the specified property of the viewmodel
 * - `isDirty`: observable property indicating if the viewModel contains any modifications
 * - `isPropertyDirty(propName)`: returns true if the specified property is dirty
 * - `changedValues`: returns a key / value map with the properties that have been changed in the model so far
 * - `model`: The original model object for which this viewModel was created
 *
 * You may use observable arrays, maps and objects with `createViewModel` but keep in mind to assign fresh instances of those to the viewmodel's properties, otherwise you would end up modifying the properties of the original model.
 * Note that if you read a non-dirty property, viewmodel only proxies the read to the model. You therefore need to assign a fresh instance not only the first time you make the assignment but also after calling `reset()` or `submit()`.
 *
 * @example
 * class Todo {
 *   \@observable title = "Test"
 * }
 *
 * const model = new Todo()
 * const viewModel = createViewModel(model);
 *
 * autorun(() => console.log(viewModel.model.title, ",", viewModel.title))
 * // prints "Test, Test"
 * model.title = "Get coffee"
 * // prints "Get coffee, Get coffee", viewModel just proxies to model
 * viewModel.title = "Get tea"
 * // prints "Get coffee, Get tea", viewModel's title is now dirty, and the local value will be printed
 * viewModel.submit()
 * // prints "Get tea, Get tea", changes submitted from the viewModel to the model, viewModel is proxying again
 * viewModel.title = "Get cookie"
 * // prints "Get tea, Get cookie" // viewModel has diverged again
 * viewModel.reset()
 * // prints "Get tea, Get tea", changes of the viewModel have been abandoned
 *
 * @param {T} model
 * @returns {(T & IViewModel<T>)}
 * ```
 */ function $076966017c87bdf8$export$313a9917afd1f6c1(model) {
    return new $076966017c87bdf8$export$a0505c1b7de1f868(model);
}
/**
 * MobX normally suspends any computed value that is not in use by any reaction,
 * and lazily re-evaluates the expression if needed outside a reaction while not in use.
 * `keepAlive` marks a computed value as always in use, meaning that it will always fresh, but never disposed automatically.
 *
 * @example
 * const obj = observable({
 *   number: 3,
 *   doubler: function() { return this.number * 2 }
 * })
 * const stop = keepAlive(obj, "doubler")
 *
 * @param {Object} target an object that has a computed property, created by `@computed` or `extendObservable`
 * @param {string} property the name of the property to keep alive
 * @returns {IDisposer} stops this keep alive so that the computed value goes back to normal behavior
 */ /**
 * @example
 * const number = observable(3)
 * const doubler = computed(() => number.get() * 2)
 * const stop = keepAlive(doubler)
 * // doubler will now stay in sync reactively even when there are no further observers
 * stop()
 * // normal behavior, doubler results will be recomputed if not observed but needed, but lazily
 *
 * @param {IComputedValue<any>} computedValue created using the `computed` function
 * @returns {IDisposer} stops this keep alive so that the computed value goes back to normal behavior
 */ function $076966017c87bdf8$export$a1c7a439f47575e5(_1, _2) {
    var computed = (0, $4JcCM.getAtom)(_1, _2);
    if (!computed) throw new Error("No computed provided, please provide an object created with `computed(() => expr)` or an object + property name");
    return (0, $4JcCM.observe)(computed, function() {});
}
/**
 * `queueProcessor` takes an observable array, observes it and calls `processor`
 * once for each item added to the observable array, optionally debouncing the action
 *
 * @example
 * const pendingNotifications = observable([])
 * const stop = queueProcessor(pendingNotifications, msg => {
 *   // show Desktop notification
 *   new Notification(msg);
 * })
 *
 * // usage:
 * pendingNotifications.push("test!")
 *
 * @param {T[]} observableArray observable array instance to track
 * @param {(item: T) => void} processor action to call per item
 * @param {number} [debounce=0] optional debounce time in ms. With debounce 0 the processor will run synchronously
 * @returns {IDisposer} stops the processor
 */ function $076966017c87bdf8$export$2b2a82cc67fc06db(observableArray, processor, debounce) {
    if (debounce === void 0) debounce = 0;
    if (!(0, $4JcCM.isObservableArray)(observableArray)) throw new Error("Expected observable array as first argument");
    if (!(0, $4JcCM.isAction)(processor)) processor = (0, $4JcCM.action)("queueProcessor", processor);
    var runner = function() {
        // construct a final set
        var items = observableArray.slice(0);
        // clear the queue for next iteration
        (0, $4JcCM.runInAction)(function() {
            return observableArray.splice(0);
        });
        // fire processor
        items.forEach(processor);
    };
    if (debounce > 0) return (0, $4JcCM.autorun)(runner, {
        delay: debounce
    });
    else return (0, $4JcCM.autorun)(runner);
}
/**
 * `chunkProcessor` takes an observable array, observes it and calls `processor`
 * once for a chunk of items added to the observable array, optionally deboucing the action.
 * The maximum chunk size can be limited by number.
 * This allows both, splitting larger into smaller chunks or (when debounced) combining smaller
 * chunks and/or single items into reasonable chunks of work.
 *
 * @example
 * const trackedActions = observable([])
 * const stop = chunkProcessor(trackedActions, chunkOfMax10Items => {
 *   sendTrackedActionsToServer(chunkOfMax10Items);
 * }, 100, 10)
 *
 * // usage:
 * trackedActions.push("scrolled")
 * trackedActions.push("hoveredButton")
 * // when both pushes happen within 100ms, there will be only one call to server
 *
 * @param {T[]} observableArray observable array instance to track
 * @param {(item: T[]) => void} processor action to call per item
 * @param {number} [debounce=0] optional debounce time in ms. With debounce 0 the processor will run synchronously
 * @param {number} [maxChunkSize=0] optionally do not call on full array but smaller chunks. With 0 it will process the full array.
 * @returns {IDisposer} stops the processor
 */ function $076966017c87bdf8$export$8430f878cdcb7e2f(observableArray, processor, debounce, maxChunkSize) {
    if (debounce === void 0) debounce = 0;
    if (maxChunkSize === void 0) maxChunkSize = 0;
    if (!(0, $4JcCM.isObservableArray)(observableArray)) throw new Error("Expected observable array as first argument");
    if (!(0, $4JcCM.isAction)(processor)) processor = (0, $4JcCM.action)("chunkProcessor", processor);
    var runner = function() {
        var _loop_1 = function() {
            var chunkSize = maxChunkSize === 0 ? observableArray.length : Math.min(observableArray.length, maxChunkSize);
            // construct a final set
            var items = observableArray.slice(0, chunkSize);
            // clear the slice for next iteration
            (0, $4JcCM.runInAction)(function() {
                return observableArray.splice(0, chunkSize);
            });
            // fire processor
            processor(items);
        };
        while(observableArray.length > 0)_loop_1();
    };
    if (debounce > 0) return (0, $4JcCM.autorun)(runner, {
        delay: debounce
    });
    else return (0, $4JcCM.autorun)(runner);
}
var $076966017c87bdf8$var$tickers = {};
/**
 * Disposes of all the internal Observables created by invocations of `now()`.
 *
 * The use case for this is to ensure that unit tests can run independent of each other.
 * You should not call this in regular application code.
 *
 * @example
 * afterEach(() => {
 *     utils.resetNowInternalState()
 * })
 */ function $076966017c87bdf8$export$63951e38944358c9() {
    for(var _i = 0, _a = Object.getOwnPropertyNames($076966017c87bdf8$var$tickers); _i < _a.length; _i++){
        var key = _a[_i];
        $076966017c87bdf8$var$tickers[key].dispose();
        delete $076966017c87bdf8$var$tickers[key];
    }
}
/**
 * Returns the current date time as epoch number.
 * The date time is read from an observable which is updated automatically after the given interval.
 * So basically it treats time as an observable.
 *
 * The function takes an interval as parameter, which indicates how often `now()` will return a new value.
 * If no interval is given, it will update each second. If "frame" is specified, it will update each time a
 * `requestAnimationFrame` is available.
 *
 * Multiple clocks with the same interval will automatically be synchronized.
 *
 * Countdown example: https://jsfiddle.net/mweststrate/na0qdmkw/
 *
 * @example
 *
 * const start = Date.now()
 *
 * autorun(() => {
 *   console.log("Seconds elapsed: ", (mobxUtils.now() - start) / 1000)
 * })
 *
 *
 * @export
 * @param {(number | "frame")} [interval=1000] interval in milliseconds about how often the interval should update
 * @returns
 */ function $076966017c87bdf8$export$461939dd4422153(interval) {
    if (interval === void 0) interval = 1000;
    if (!(0, $4JcCM._isComputingDerivation)()) // See #40
    return Date.now();
    if (!$076966017c87bdf8$var$tickers[interval]) {
        if (typeof interval === "number") $076966017c87bdf8$var$tickers[interval] = $076966017c87bdf8$var$createIntervalTicker(interval);
        else $076966017c87bdf8$var$tickers[interval] = $076966017c87bdf8$var$createAnimationFrameTicker();
    }
    return $076966017c87bdf8$var$tickers[interval].current();
}
function $076966017c87bdf8$var$createIntervalTicker(interval) {
    var subscriptionHandle;
    return $076966017c87bdf8$export$c5c49fce5ba0daad(function(sink) {
        sink(Date.now());
        subscriptionHandle = setInterval(function() {
            return sink(Date.now());
        }, interval);
    }, function() {
        clearInterval(subscriptionHandle);
    }, Date.now());
}
function $076966017c87bdf8$var$createAnimationFrameTicker() {
    var frameBasedTicker = $076966017c87bdf8$export$c5c49fce5ba0daad(function(sink) {
        sink(Date.now());
        function scheduleTick() {
            window.requestAnimationFrame(function() {
                sink(Date.now());
                if (frameBasedTicker.isAlive()) scheduleTick();
            });
        }
        scheduleTick();
    }, function() {}, Date.now());
    return frameBasedTicker;
}
/**
 *`expr` can be used to create temporary computed values inside computed values.
 * Nesting computed values is useful to create cheap computations in order to prevent expensive computations from needing to run.
 * In the following example the expression prevents that a component is rerender _each time_ the selection changes;
 * instead it will only rerenders when the current todo is (de)selected.
 *
 * `expr(func)` is an alias for `computed(func).get()`.
 * Please note that the function given to `expr` is evaluated _twice_ in the scenario that the overall expression value changes.
 * It is evaluated the first time when any observables it depends on change.
 * It is evaluated a second time when a change in its value triggers the outer computed or reaction to evaluate, which recreates and reevaluates the expression.
 *
 * In the following example, the expression prevents the `TodoView` component from being re-rendered if the selection changes elsewhere.
 * Instead, the component will only re-render when the relevant todo is (de)selected, which happens much less frequently.
 *
 * @example
 * const TodoView = observer(({ todo, editorState }) => {
 *     const isSelected = mobxUtils.expr(() => editorState.selection === todo)
 *     return <div className={isSelected ? "todo todo-selected" : "todo"}>{todo.title}</div>
 * })
 */ function $076966017c87bdf8$export$dce8637ca0d755f(expr) {
    if (!(0, $4JcCM._isComputingDerivation)()) console.warn("'expr' should only be used inside other reactive functions.");
    // optimization: would be more efficient if the expr itself wouldn't be evaluated first on the next change, but just a 'changed' signal would be fired
    return (0, $4JcCM.computed)(expr).get();
}
var $076966017c87bdf8$var$__assign$1 = function() {
    $076966017c87bdf8$var$__assign$1 = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $076966017c87bdf8$var$__assign$1.apply(this, arguments);
};
/**
 * Creates a function that maps an object to a view.
 * The mapping is memoized.
 *
 * See the [transformer](#createtransformer-in-detail) section for more details.
 *
 * @param transformer A function which transforms instances of A into instances of B
 * @param arg2 An optional cleanup function which is called when the transformation is no longer
 * observed from a reactive context, or config options
 * @returns The memoized transformer function
 */ function $076966017c87bdf8$export$9591aa59b8e3deeb(transformer, arg2) {
    $076966017c87bdf8$export$f5708dca728d7177(typeof transformer === "function" && transformer.length < 2, "createTransformer expects a function that accepts one argument");
    // Memoizes: object -> reactive view that applies transformer to the object
    var views = new Map();
    var onCleanup = undefined;
    var keepAlive = false;
    var debugNameGenerator = undefined;
    if (typeof arg2 === "object") {
        onCleanup = arg2.onCleanup;
        keepAlive = arg2.keepAlive !== undefined ? arg2.keepAlive : false;
        debugNameGenerator = arg2.debugNameGenerator;
    } else if (typeof arg2 === "function") onCleanup = arg2;
    function createView(sourceObject) {
        var latestValue;
        var computedValueOptions = {};
        if (typeof arg2 === "object") {
            onCleanup = arg2.onCleanup;
            debugNameGenerator = arg2.debugNameGenerator;
            computedValueOptions = arg2;
        } else if (typeof arg2 === "function") onCleanup = arg2;
        else {
            onCleanup = undefined;
            debugNameGenerator = undefined;
        }
        var sourceType = typeof sourceObject;
        var prettifiedName = debugNameGenerator ? debugNameGenerator(sourceObject) : "Transformer-" + transformer.name + "-" + (sourceType === "string" || sourceType === "number" ? sourceObject : "object");
        var expr = (0, $4JcCM.computed)(function() {
            return latestValue = transformer(sourceObject);
        }, $076966017c87bdf8$var$__assign$1($076966017c87bdf8$var$__assign$1({}, computedValueOptions), {
            name: prettifiedName
        }));
        if (!keepAlive) var disposer_1 = (0, $4JcCM.onBecomeUnobserved)(expr, function() {
            views.delete(sourceObject);
            disposer_1();
            if (onCleanup) onCleanup(latestValue, sourceObject);
        });
        return expr;
    }
    var memoWarned = false;
    return function(object) {
        $076966017c87bdf8$var$checkTransformableObject(object);
        var reactiveView = views.get(object);
        if (reactiveView) return reactiveView.get();
        if (!keepAlive && !(0, $4JcCM._isComputingDerivation)()) {
            if (!memoWarned) {
                console.warn("invoking a transformer from outside a reactive context won't memorized and is cleaned up immediately, unless keepAlive is set");
                memoWarned = true;
            }
            var value = transformer(object);
            if (onCleanup) onCleanup(value, object);
            return value;
        }
        // Not in cache; create a reactive view
        reactiveView = createView(object);
        views.set(object, reactiveView);
        return reactiveView.get();
    };
}
function $076966017c87bdf8$var$checkTransformableObject(object) {
    var objectType = typeof object;
    if (object === null || objectType !== "object" && objectType !== "function" && objectType !== "string" && objectType !== "number") throw new Error("[mobx-utils] transform expected an object, function, string or number, got: " + String(object));
}
function $076966017c87bdf8$var$buildPath(entry) {
    if (!entry) return "ROOT";
    var res = [];
    while(entry.parent){
        res.push(entry.path);
        entry = entry.parent;
    }
    return res.reverse().join("/");
}
function $076966017c87bdf8$var$isRecursivelyObservable(thing) {
    return (0, $4JcCM.isObservableObject)(thing) || (0, $4JcCM.isObservableArray)(thing) || (0, $4JcCM.isObservableMap)(thing);
}
/**
 * Given an object, deeply observes the given object.
 * It is like `observe` from mobx, but applied recursively, including all future children.
 *
 * Note that the given object cannot ever contain cycles and should be a tree.
 *
 * As benefit: path and root will be provided in the callback, so the signature of the listener is
 * (change, path, root) => void
 *
 * The returned disposer can be invoked to clean up the listener
 *
 * deepObserve cannot be used on computed values.
 *
 * @example
 * const disposer = deepObserve(target, (change, path) => {
 *    console.dir(change)
 * })
 */ function $076966017c87bdf8$export$d026ecd6f7c99c26(target, listener) {
    var entrySet = new WeakMap();
    function genericListener(change) {
        var entry = entrySet.get(change.object);
        processChange(change, entry);
        listener(change, $076966017c87bdf8$var$buildPath(entry), target);
    }
    function processChange(change, parent) {
        switch(change.type){
            // Object changes
            case "add":
                observeRecursively(change.newValue, parent, change.name);
                break;
            case "update":
                unobserveRecursively(change.oldValue);
                observeRecursively(change.newValue, parent, change.name || "" + change.index);
                break;
            case "remove":
            case "delete":
                unobserveRecursively(change.oldValue);
                break;
            // Array changes
            case "splice":
                change.removed.map(unobserveRecursively);
                change.added.forEach(function(value, idx) {
                    return observeRecursively(value, parent, "" + (change.index + idx));
                });
                // update paths
                for(var i = change.index + change.addedCount; i < change.object.length; i++)if ($076966017c87bdf8$var$isRecursivelyObservable(change.object[i])) {
                    var entry = entrySet.get(change.object[i]);
                    if (entry) entry.path = "" + i;
                }
                break;
        }
    }
    function observeRecursively(thing, parent, path) {
        if ($076966017c87bdf8$var$isRecursivelyObservable(thing)) {
            var entry = entrySet.get(thing);
            if (entry) {
                if (entry.parent !== parent || entry.path !== path) // MWE: this constraint is artificial, and this tool could be made to work with cycles,
                // but it increases administration complexity, has tricky edge cases and the meaning of 'path'
                // would become less clear. So doesn't seem to be needed for now
                throw new Error("The same observable object cannot appear twice in the same tree," + (" trying to assign it to '" + $076966017c87bdf8$var$buildPath(parent) + "/" + path + "',") + (" but it already exists at '" + $076966017c87bdf8$var$buildPath(entry.parent) + "/" + entry.path + "'"));
            } else {
                var entry_1 = {
                    parent: parent,
                    path: path,
                    dispose: (0, $4JcCM.observe)(thing, genericListener)
                };
                entrySet.set(thing, entry_1);
                (0, $4JcCM.entries)(thing).forEach(function(_a) {
                    var key = _a[0], value = _a[1];
                    return observeRecursively(value, entry_1, key);
                });
            }
        }
    }
    function unobserveRecursively(thing) {
        if ($076966017c87bdf8$var$isRecursivelyObservable(thing)) {
            var entry = entrySet.get(thing);
            if (!entry) return;
            entrySet.delete(thing);
            entry.dispose();
            (0, $4JcCM.values)(thing).forEach(unobserveRecursively);
        }
    }
    observeRecursively(target, undefined, "");
    return function() {
        unobserveRecursively(target);
    };
}
var $076966017c87bdf8$var$__extends = function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Reactively sorts a base observable array into multiple observable arrays based on the value of a
 * `groupBy: (item: T) => G` function.
 *
 * This observes the individual computed groupBy values and only updates the source and dest arrays
 * when there is an actual change, so this is far more efficient than, for example
 * `base.filter(i => groupBy(i) === 'we')`. Call #dispose() to stop tracking.
 *
 * No guarantees are made about the order of items in the grouped arrays.
 *
 * The resulting map of arrays is read-only. clear(), set(), delete() are not supported and
 * modifying the group arrays will lead to undefined behavior.
 *
 * NB: ObservableGroupMap relies on `Symbol`s. If you are targeting a platform which doesn't
 * support these natively, you will need to provide a polyfill.
 *
 * @param {array} base The array to sort into groups.
 * @param {function} groupBy The function used for grouping.
 * @param options Object with properties:
 *  `name`: Debug name of this ObservableGroupMap.
 *  `keyToName`: Function to create the debug names of the observable group arrays.
 *
 * @example
 * const slices = observable([
 *     { day: "mo", hours: 12 },
 *     { day: "tu", hours: 2 },
 * ])
 * const slicesByDay = new ObservableGroupMap(slices, (slice) => slice.day)
 * autorun(() => console.log(
 *     slicesByDay.get("mo")?.length ?? 0,
 *     slicesByDay.get("we"))) // outputs 1, undefined
 * slices[0].day = "we" // outputs 0, [{ day: "we", hours: 12 }]
 */ var $076966017c87bdf8$export$f8edb9738c5f010e = /** @class */ function(_super) {
    $076966017c87bdf8$var$__extends(ObservableGroupMap, _super);
    function ObservableGroupMap(base, groupBy, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.name, name = _c === void 0 ? "ogm" + (Math.random() * 1000 | 0) : _c, _d = _b.keyToName, keyToName = _d === void 0 ? function(x) {
            return "" + x;
        } : _d;
        var _this = _super.call(this) || this;
        /**
         * Base observable array which is being sorted into groups.
         */ Object.defineProperty(_this, "_base", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /**
         * The ObservableGroupMap needs to track some state per-item. This is the name/symbol of the
         * property used to attach the state.
         */ Object.defineProperty(_this, "_ogmInfoKey", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /**
         * The function used to group the items.
         */ Object.defineProperty(_this, "_groupBy", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /**
         * This function is used to generate the mobx debug names of the observable group arrays.
         */ Object.defineProperty(_this, "_keyToName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "_disposeBaseObserver", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        _this._keyToName = keyToName;
        _this._groupBy = groupBy;
        _this._ogmInfoKey = Symbol("ogmInfo" + name);
        _this._base = base;
        for(var i = 0; i < base.length; i++)_this._addItem(base[i]);
        _this._disposeBaseObserver = (0, $4JcCM.observe)(_this._base, function(change) {
            if ("splice" === change.type) (0, $4JcCM.transaction)(function() {
                for(var _i = 0, _a = change.removed; _i < _a.length; _i++){
                    var removed = _a[_i];
                    _this._removeItem(removed);
                }
                for(var _b = 0, _c = change.added; _b < _c.length; _b++){
                    var added = _c[_b];
                    _this._addItem(added);
                }
            });
            else if ("update" === change.type) (0, $4JcCM.transaction)(function() {
                _this._removeItem(change.oldValue);
                _this._addItem(change.newValue);
            });
            else throw new Error("illegal state");
        });
        return _this;
    }
    Object.defineProperty(ObservableGroupMap.prototype, "clear", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            throw new Error("not supported");
        }
    });
    Object.defineProperty(ObservableGroupMap.prototype, "delete", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(_key) {
            throw new Error("not supported");
        }
    });
    Object.defineProperty(ObservableGroupMap.prototype, "set", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(_key, _value) {
            throw new Error("not supported");
        }
    });
    /**
     * Disposes all observers created during construction and removes state added to base array
     * items.
     */ Object.defineProperty(ObservableGroupMap.prototype, "dispose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            this._disposeBaseObserver();
            for(var i = 0; i < this._base.length; i++){
                var item = this._base[i];
                var grouperItemInfo = item[this._ogmInfoKey];
                grouperItemInfo.reaction();
                delete item[this._ogmInfoKey];
            }
        }
    });
    Object.defineProperty(ObservableGroupMap.prototype, "_getGroupArr", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(key) {
            var result = _super.prototype.get.call(this, key);
            if (undefined === result) {
                result = (0, $4JcCM.observable)([], {
                    name: "GroupArray[" + this._keyToName(key) + "]",
                    deep: false
                });
                _super.prototype.set.call(this, key, result);
            }
            return result;
        }
    });
    Object.defineProperty(ObservableGroupMap.prototype, "_removeFromGroupArr", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(key, itemIndex) {
            var arr = _super.prototype.get.call(this, key);
            if (1 === arr.length) _super.prototype.delete.call(this, key);
            else if (itemIndex === arr.length - 1) // last position in array
            arr.length--;
            else {
                arr[itemIndex] = arr[arr.length - 1];
                arr[itemIndex][this._ogmInfoKey].groupArrIndex = itemIndex;
                arr.length--;
            }
        }
    });
    Object.defineProperty(ObservableGroupMap.prototype, "_addItem", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(item) {
            var _this = this;
            var groupByValue = this._groupBy(item);
            var groupArr = this._getGroupArr(groupByValue);
            var value = {
                groupByValue: groupByValue,
                groupArrIndex: groupArr.length,
                reaction: (0, $4JcCM.reaction)(function() {
                    return _this._groupBy(item);
                }, function(newGroupByValue, _r) {
                    var grouperItemInfo = item[_this._ogmInfoKey];
                    _this._removeFromGroupArr(grouperItemInfo.groupByValue, grouperItemInfo.groupArrIndex);
                    var newGroupArr = _this._getGroupArr(newGroupByValue);
                    var newGroupArrIndex = newGroupArr.length;
                    newGroupArr.push(item);
                    grouperItemInfo.groupByValue = newGroupByValue;
                    grouperItemInfo.groupArrIndex = newGroupArrIndex;
                })
            };
            Object.defineProperty(item, this._ogmInfoKey, {
                configurable: true,
                enumerable: false,
                value: value
            });
            groupArr.push(item);
        }
    });
    Object.defineProperty(ObservableGroupMap.prototype, "_removeItem", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(item) {
            var grouperItemInfo = item[this._ogmInfoKey];
            this._removeFromGroupArr(grouperItemInfo.groupByValue, grouperItemInfo.groupArrIndex);
            grouperItemInfo.reaction();
            delete item[this._ogmInfoKey];
        }
    });
    return ObservableGroupMap;
}((0, $4JcCM.ObservableMap));
/**
 * @private
 */ var $076966017c87bdf8$var$DeepMapEntry = /** @class */ function() {
    function DeepMapEntry(base, args) {
        Object.defineProperty(this, "base", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: base
        });
        Object.defineProperty(this, "args", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: args
        });
        Object.defineProperty(this, "root", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "closest", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "closestIdx", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "isDisposed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        var current = this.closest = this.root = base;
        var i = 0;
        for(; i < this.args.length - 1; i++){
            current = current.get(args[i]);
            if (current) this.closest = current;
            else break;
        }
        this.closestIdx = i;
    }
    Object.defineProperty(DeepMapEntry.prototype, "exists", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            this.assertNotDisposed();
            var l = this.args.length;
            return this.closestIdx >= l - 1 && this.closest.has(this.args[l - 1]);
        }
    });
    Object.defineProperty(DeepMapEntry.prototype, "get", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            this.assertNotDisposed();
            if (!this.exists()) throw new Error("Entry doesn't exist");
            return this.closest.get(this.args[this.args.length - 1]);
        }
    });
    Object.defineProperty(DeepMapEntry.prototype, "set", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value) {
            this.assertNotDisposed();
            var l = this.args.length;
            var current = this.closest;
            // create remaining maps
            for(var i = this.closestIdx; i < l - 1; i++){
                var m = new Map();
                current.set(this.args[i], m);
                current = m;
            }
            this.closestIdx = l - 1;
            this.closest = current;
            current.set(this.args[l - 1], value);
        }
    });
    Object.defineProperty(DeepMapEntry.prototype, "delete", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            this.assertNotDisposed();
            if (!this.exists()) throw new Error("Entry doesn't exist");
            var l = this.args.length;
            this.closest.delete(this.args[l - 1]);
            // clean up remaining maps if needed (reconstruct stack first)
            var c = this.root;
            var maps = [
                c
            ];
            for(var i = 0; i < l - 1; i++){
                c = c.get(this.args[i]);
                maps.push(c);
            }
            for(var i = maps.length - 1; i > 0; i--)if (maps[i].size === 0) maps[i - 1].delete(this.args[i - 1]);
            this.isDisposed = true;
        }
    });
    Object.defineProperty(DeepMapEntry.prototype, "assertNotDisposed", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            // TODO: once this becomes annoying, we should introduce a reset method to re-run the constructor logic
            if (this.isDisposed) throw new Error("Concurrent modification exception");
        }
    });
    return DeepMapEntry;
}();
/**
 * @private
 */ var $076966017c87bdf8$var$DeepMap = /** @class */ function() {
    function DeepMap() {
        Object.defineProperty(this, "store", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "argsLength", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: -1
        });
        Object.defineProperty(this, "last", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    Object.defineProperty(DeepMap.prototype, "entry", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(args) {
            if (this.argsLength === -1) this.argsLength = args.length;
            else if (this.argsLength !== args.length) throw new Error("DeepMap should be used with functions with a consistent length, expected: " + this.argsLength + ", got: " + args.length);
            if (this.last) this.last.isDisposed = true;
            return this.last = new $076966017c87bdf8$var$DeepMapEntry(this.store, args);
        }
    });
    return DeepMap;
}();
var $076966017c87bdf8$var$__assign$2 = function() {
    $076966017c87bdf8$var$__assign$2 = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $076966017c87bdf8$var$__assign$2.apply(this, arguments);
};
var $076966017c87bdf8$var$__spreadArrays$1 = function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
/**
 * computedFn takes a function with an arbitrary amount of arguments,
 * and memoizes the output of the function based on the arguments passed in.
 *
 * computedFn(fn) returns a function with the very same signature. There is no limit on the amount of arguments
 * that is accepted. However, the amount of arguments must be constant and default arguments are not supported.
 *
 * By default the output of a function call will only be memoized as long as the
 * output is being observed.
 *
 * The function passes into `computedFn` should be pure, not be an action and only be relying on
 * observables.
 *
 * Setting `keepAlive` to `true` will cause the output to be forcefully cached forever.
 * Note that this might introduce memory leaks!
 *
 * @example
 * const store = observable({
    a: 1,
    b: 2,
    c: 3,
    m: computedFn(function(x) {
      return this.a * this.b * x
    })
  })

  const d = autorun(() => {
    // store.m(3) will be cached as long as this autorun is running
    console.log(store.m(3) * store.c)
  })
 *
 * @param fn
 * @param keepAliveOrOptions
 */ function $076966017c87bdf8$export$79a1d35ba0cac8da(fn, keepAliveOrOptions) {
    if (keepAliveOrOptions === void 0) keepAliveOrOptions = false;
    if ((0, $4JcCM.isAction)(fn)) throw new Error("computedFn shouldn't be used on actions");
    var memoWarned = false;
    var i = 0;
    var opts = typeof keepAliveOrOptions === "boolean" ? {
        keepAlive: keepAliveOrOptions
    } : keepAliveOrOptions;
    var d = new $076966017c87bdf8$var$DeepMap();
    return function() {
        var _this = this;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var entry = d.entry(args);
        // cache hit, return
        if (entry.exists()) return entry.get().get();
        // if function is invoked, and its a cache miss without reactive, there is no point in caching...
        if (!opts.keepAlive && !(0, $4JcCM._isComputingDerivation)()) {
            if (!memoWarned && (0, $4JcCM._getGlobalState)().computedRequiresReaction) {
                console.warn("Invoking a computedFn from outside a reactive context won't be memoized unless keepAlive is set.");
                memoWarned = true;
            }
            return fn.apply(this, args);
        }
        // create new entry
        var latestValue;
        var c = (0, $4JcCM.computed)(function() {
            return latestValue = fn.apply(_this, args);
        }, $076966017c87bdf8$var$__assign$2($076966017c87bdf8$var$__assign$2({}, opts), {
            name: "computedFn(" + (opts.name || fn.name) + "#" + ++i + ")"
        }));
        entry.set(c);
        // clean up if no longer observed
        if (!opts.keepAlive) (0, $4JcCM.onBecomeUnobserved)(c, function() {
            d.entry(args).delete();
            if (opts.onCleanup) opts.onCleanup.apply(opts, $076966017c87bdf8$var$__spreadArrays$1([
                latestValue
            ], args));
            latestValue = undefined;
        });
        // return current val
        return c.get();
    };
}

});





parcelRegister("4oQMK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33425959d9bc282e$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "MonthlyRevenueCellCollectionClass", function () { return $33425959d9bc282e$export$b2adacc0b3733cd1; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $cYthn = parcelRequire("cYthn");
var $33425959d9bc282e$var$_dec, $33425959d9bc282e$var$_dec2, $33425959d9bc282e$var$_class;
function $33425959d9bc282e$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $33425959d9bc282e$var$MonthlyRevenueCellCollection = ($33425959d9bc282e$var$_dec = (0, $4JcCM.action).bound, $33425959d9bc282e$var$_dec2 = (0, $4JcCM.action).bound, $33425959d9bc282e$var$_class = class MonthlyRevenueCellCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "monthlyRevenueCells",
            modelClass: (0, $cYthn.default)
        });
        this.addLookup("cellsByStatus", "manyByKey", {
            key: (t)=>t.status,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("cellsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("cellsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("cellsByMonth", "manyByKey", {
            key: (t)=>t.month,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("cellsByType", "manyByKey", {
            key: (t)=>t.type,
            filter: (t)=>!t.deletedAt
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get cellsById() {
        return this.modelsById;
    }
    get cells() {
        return this.models;
    }
    addCell(data, options) {
        return this.add(data, options);
    }
    addCells(data, options) {
        return this.addMany(data, options);
    }
}, $33425959d9bc282e$var$_applyDecoratedDescriptor($33425959d9bc282e$var$_class.prototype, "addCell", [
    $33425959d9bc282e$var$_dec
], Object.getOwnPropertyDescriptor($33425959d9bc282e$var$_class.prototype, "addCell"), $33425959d9bc282e$var$_class.prototype), $33425959d9bc282e$var$_applyDecoratedDescriptor($33425959d9bc282e$var$_class.prototype, "addCells", [
    $33425959d9bc282e$var$_dec2
], Object.getOwnPropertyDescriptor($33425959d9bc282e$var$_class.prototype, "addCells"), $33425959d9bc282e$var$_class.prototype), $33425959d9bc282e$var$_class);
var $33425959d9bc282e$export$2e2bcd8739ae039 = new $33425959d9bc282e$var$MonthlyRevenueCellCollection();
const $33425959d9bc282e$export$b2adacc0b3733cd1 = $33425959d9bc282e$var$MonthlyRevenueCellCollection;

});
parcelRegister("cYthn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9721ccdd1e00f7fb$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $XoImS = parcelRequire("XoImS");

var $gJT7h = parcelRequire("gJT7h");

var $4oQMK = parcelRequire("4oQMK");

var $3PpOX = parcelRequire("3PpOX");

var $4hBm1 = parcelRequire("4hBm1");

var $3gI5O = parcelRequire("3gI5O");
var $9721ccdd1e00f7fb$var$_class, $9721ccdd1e00f7fb$var$_descriptor, $9721ccdd1e00f7fb$var$_descriptor2, $9721ccdd1e00f7fb$var$_descriptor3, $9721ccdd1e00f7fb$var$_descriptor4, $9721ccdd1e00f7fb$var$_descriptor5, $9721ccdd1e00f7fb$var$_descriptor6, $9721ccdd1e00f7fb$var$_descriptor7, $9721ccdd1e00f7fb$var$_descriptor8, $9721ccdd1e00f7fb$var$_descriptor9, $9721ccdd1e00f7fb$var$_descriptor10;
function $9721ccdd1e00f7fb$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $9721ccdd1e00f7fb$var$_defineProperty(e, r, t) {
    return (r = $9721ccdd1e00f7fb$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $9721ccdd1e00f7fb$var$_toPropertyKey(t) {
    var i = $9721ccdd1e00f7fb$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $9721ccdd1e00f7fb$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $9721ccdd1e00f7fb$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $9721ccdd1e00f7fb$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $9721ccdd1e00f7fb$var$MonthlyRevenueCellModel = ($9721ccdd1e00f7fb$var$_class = class MonthlyRevenueCellModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $9721ccdd1e00f7fb$var$_initializerDefineProperty(this, "month", $9721ccdd1e00f7fb$var$_descriptor, this);
        $9721ccdd1e00f7fb$var$_initializerDefineProperty(this, "revenue", $9721ccdd1e00f7fb$var$_descriptor2, this);
        $9721ccdd1e00f7fb$var$_initializerDefineProperty(this, "revenueToDate", $9721ccdd1e00f7fb$var$_descriptor3, this);
        $9721ccdd1e00f7fb$var$_initializerDefineProperty(this, "status", $9721ccdd1e00f7fb$var$_descriptor4, this);
        $9721ccdd1e00f7fb$var$_initializerDefineProperty(this, "projectId", $9721ccdd1e00f7fb$var$_descriptor5, this);
        $9721ccdd1e00f7fb$var$_initializerDefineProperty(this, "phaseId", $9721ccdd1e00f7fb$var$_descriptor6, this);
        $9721ccdd1e00f7fb$var$_initializerDefineProperty(this, "phaseTitle", $9721ccdd1e00f7fb$var$_descriptor7, this);
        $9721ccdd1e00f7fb$var$_initializerDefineProperty(this, "ownerId", $9721ccdd1e00f7fb$var$_descriptor8, this);
        $9721ccdd1e00f7fb$var$_initializerDefineProperty(this, "costCentreId", $9721ccdd1e00f7fb$var$_descriptor9, this);
        $9721ccdd1e00f7fb$var$_initializerDefineProperty(this, "type", $9721ccdd1e00f7fb$var$_descriptor10, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $4oQMK.default);
        this.init(data, options);
        const rowId = `('${this.status}', '${this.projectId}', '${this.phaseId}')`;
        const row = (0, $3gI5O.default).rowsById[rowId];
        if (!row) (0, $3gI5O.default).addRow({
            id: rowId,
            status: this.status,
            projectId: this.projectId,
            phaseId: this.phaseId,
            phaseTitle: this.phaseTitle,
            groups: [
                "status",
                "project",
                "phase"
            ]
        }, {
            trackUpdates: false
        });
    }
    get phase() {
        return (0, $XoImS.default).phasesById[this.phaseId];
    }
    get project() {
        return (0, $gJT7h.default).projectsById[this.projectId];
    }
    serialize() {
        return {
            id: this.id,
            month: this.month,
            revenue: this.revenue,
            projectId: this.projectId,
            phaseId: this.phaseId
        };
    }
    serializeUpdates() {
        return this.serialize();
    }
    get date() {
        return (0, $4hBm1.startOfMonth)((0, $4hBm1.parse)(this.month, "yyyy-MM", new Date()));
    }
}, $9721ccdd1e00f7fb$var$_descriptor = $9721ccdd1e00f7fb$var$_applyDecoratedDescriptor($9721ccdd1e00f7fb$var$_class.prototype, "month", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $9721ccdd1e00f7fb$var$_descriptor2 = $9721ccdd1e00f7fb$var$_applyDecoratedDescriptor($9721ccdd1e00f7fb$var$_class.prototype, "revenue", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $9721ccdd1e00f7fb$var$_descriptor3 = $9721ccdd1e00f7fb$var$_applyDecoratedDescriptor($9721ccdd1e00f7fb$var$_class.prototype, "revenueToDate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $9721ccdd1e00f7fb$var$_descriptor4 = $9721ccdd1e00f7fb$var$_applyDecoratedDescriptor($9721ccdd1e00f7fb$var$_class.prototype, "status", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $9721ccdd1e00f7fb$var$_descriptor5 = $9721ccdd1e00f7fb$var$_applyDecoratedDescriptor($9721ccdd1e00f7fb$var$_class.prototype, "projectId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $9721ccdd1e00f7fb$var$_descriptor6 = $9721ccdd1e00f7fb$var$_applyDecoratedDescriptor($9721ccdd1e00f7fb$var$_class.prototype, "phaseId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $9721ccdd1e00f7fb$var$_descriptor7 = $9721ccdd1e00f7fb$var$_applyDecoratedDescriptor($9721ccdd1e00f7fb$var$_class.prototype, "phaseTitle", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $9721ccdd1e00f7fb$var$_descriptor8 = $9721ccdd1e00f7fb$var$_applyDecoratedDescriptor($9721ccdd1e00f7fb$var$_class.prototype, "ownerId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $9721ccdd1e00f7fb$var$_descriptor9 = $9721ccdd1e00f7fb$var$_applyDecoratedDescriptor($9721ccdd1e00f7fb$var$_class.prototype, "costCentreId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $9721ccdd1e00f7fb$var$_descriptor10 = $9721ccdd1e00f7fb$var$_applyDecoratedDescriptor($9721ccdd1e00f7fb$var$_class.prototype, "type", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $9721ccdd1e00f7fb$var$_applyDecoratedDescriptor($9721ccdd1e00f7fb$var$_class.prototype, "phase", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($9721ccdd1e00f7fb$var$_class.prototype, "phase"), $9721ccdd1e00f7fb$var$_class.prototype), $9721ccdd1e00f7fb$var$_applyDecoratedDescriptor($9721ccdd1e00f7fb$var$_class.prototype, "project", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($9721ccdd1e00f7fb$var$_class.prototype, "project"), $9721ccdd1e00f7fb$var$_class.prototype), $9721ccdd1e00f7fb$var$_applyDecoratedDescriptor($9721ccdd1e00f7fb$var$_class.prototype, "date", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($9721ccdd1e00f7fb$var$_class.prototype, "date"), $9721ccdd1e00f7fb$var$_class.prototype), $9721ccdd1e00f7fb$var$_class);
var $9721ccdd1e00f7fb$export$2e2bcd8739ae039 = $9721ccdd1e00f7fb$var$MonthlyRevenueCellModel;

});
parcelRegister("3gI5O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2615119f7db49b60$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "RevenueRowCollectionClass", function () { return $2615119f7db49b60$export$eeeec0570e0f8690; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $lOQvu = parcelRequire("lOQvu");
var $2615119f7db49b60$var$_dec, $2615119f7db49b60$var$_dec2, $2615119f7db49b60$var$_class;
function $2615119f7db49b60$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $2615119f7db49b60$var$RevenueRowCollection = ($2615119f7db49b60$var$_dec = (0, $4JcCM.action).bound, $2615119f7db49b60$var$_dec2 = (0, $4JcCM.action).bound, $2615119f7db49b60$var$_class = class RevenueRowCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "revenueRows",
            modelClass: (0, $lOQvu.default)
        });
        this.addLookup("rowsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("rowsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("rowsByStatus", "manyByKey", {
            key: (t)=>t.status,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("leafRows", "list", {
            filter: (m)=>{
                return m.isLeaf;
            }
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get rowsById() {
        return this.modelsById;
    }
    get rows() {
        return this.models;
    }
    addRow(data) {
        return this.add(data);
    }
    addRows(data) {
        return this.addMany(data);
    }
}, $2615119f7db49b60$var$_applyDecoratedDescriptor($2615119f7db49b60$var$_class.prototype, "addRow", [
    $2615119f7db49b60$var$_dec
], Object.getOwnPropertyDescriptor($2615119f7db49b60$var$_class.prototype, "addRow"), $2615119f7db49b60$var$_class.prototype), $2615119f7db49b60$var$_applyDecoratedDescriptor($2615119f7db49b60$var$_class.prototype, "addRows", [
    $2615119f7db49b60$var$_dec2
], Object.getOwnPropertyDescriptor($2615119f7db49b60$var$_class.prototype, "addRows"), $2615119f7db49b60$var$_class.prototype), $2615119f7db49b60$var$_class);
var $2615119f7db49b60$export$2e2bcd8739ae039 = new $2615119f7db49b60$var$RevenueRowCollection();
const $2615119f7db49b60$export$eeeec0570e0f8690 = $2615119f7db49b60$var$RevenueRowCollection;

});
parcelRegister("lOQvu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe26ff4880d8831d$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $XoImS = parcelRequire("XoImS");

var $gJT7h = parcelRequire("gJT7h");

var $3gI5O = parcelRequire("3gI5O");

var $3PpOX = parcelRequire("3PpOX");

var $eat5C = parcelRequire("eat5C");

var $62nmb = parcelRequire("62nmb");

var $4hBm1 = parcelRequire("4hBm1");
parcelRequire("bxXv3");
parcelRequire("htkeB");

var $Ds2V9 = parcelRequire("Ds2V9");
var $fe26ff4880d8831d$var$_dec, $fe26ff4880d8831d$var$_dec2, $fe26ff4880d8831d$var$_dec3, $fe26ff4880d8831d$var$_dec4, $fe26ff4880d8831d$var$_dec5, $fe26ff4880d8831d$var$_class, $fe26ff4880d8831d$var$_descriptor, $fe26ff4880d8831d$var$_descriptor2, $fe26ff4880d8831d$var$_descriptor3, $fe26ff4880d8831d$var$_descriptor4, $fe26ff4880d8831d$var$_descriptor5, $fe26ff4880d8831d$var$_descriptor6, $fe26ff4880d8831d$var$_descriptor7, $fe26ff4880d8831d$var$_descriptor8, $fe26ff4880d8831d$var$_descriptor9, $fe26ff4880d8831d$var$_descriptor10, $fe26ff4880d8831d$var$_descriptor11, $fe26ff4880d8831d$var$_descriptor12, $fe26ff4880d8831d$var$_descriptor13, $fe26ff4880d8831d$var$_descriptor14, $fe26ff4880d8831d$var$_descriptor15, $fe26ff4880d8831d$var$_descriptor16, $fe26ff4880d8831d$var$_descriptor17, $fe26ff4880d8831d$var$_descriptor18, $fe26ff4880d8831d$var$_descriptor19, $fe26ff4880d8831d$var$_descriptor20, $fe26ff4880d8831d$var$_descriptor21, $fe26ff4880d8831d$var$_descriptor22;
function $fe26ff4880d8831d$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $fe26ff4880d8831d$var$_defineProperty(e, r, t) {
    return (r = $fe26ff4880d8831d$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fe26ff4880d8831d$var$_toPropertyKey(t) {
    var i = $fe26ff4880d8831d$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $fe26ff4880d8831d$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $fe26ff4880d8831d$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $fe26ff4880d8831d$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
const $fe26ff4880d8831d$var$propByGroup = {
    status: "status",
    project: "projectId",
    phase: "phaseId"
};
let $fe26ff4880d8831d$var$RevenueRowModel = ($fe26ff4880d8831d$var$_dec = (0, $4JcCM.action).bound, $fe26ff4880d8831d$var$_dec2 = (0, $4JcCM.action).bound, $fe26ff4880d8831d$var$_dec3 = (0, $4JcCM.action).bound, $fe26ff4880d8831d$var$_dec4 = (0, $4JcCM.action).bound, $fe26ff4880d8831d$var$_dec5 = (0, $4JcCM.action).bound, $fe26ff4880d8831d$var$_class = class RevenueRowModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $fe26ff4880d8831d$var$_initializerDefineProperty(this, "label", $fe26ff4880d8831d$var$_descriptor, this);
        $fe26ff4880d8831d$var$_initializerDefineProperty(this, "fee", $fe26ff4880d8831d$var$_descriptor2, this);
        $fe26ff4880d8831d$var$_initializerDefineProperty(this, "actualRevenue", $fe26ff4880d8831d$var$_descriptor3, this);
        $fe26ff4880d8831d$var$_initializerDefineProperty(this, "actualVariationRevenue", $fe26ff4880d8831d$var$_descriptor4, this);
        $fe26ff4880d8831d$var$_initializerDefineProperty(this, "actualReimbursementRevenue", $fe26ff4880d8831d$var$_descriptor5, this);
        $fe26ff4880d8831d$var$_initializerDefineProperty(this, "projectedRevenue", $fe26ff4880d8831d$var$_descriptor6, this);
        $fe26ff4880d8831d$var$_initializerDefineProperty(this, "editedRevenue", $fe26ff4880d8831d$var$_descriptor7, this);
        $fe26ff4880d8831d$var$_initializerDefineProperty(this, "editedExpense", $fe26ff4880d8831d$var$_descriptor8, this);
        $fe26ff4880d8831d$var$_initializerDefineProperty(this, "expenses", $fe26ff4880d8831d$var$_descriptor9, this);
        $fe26ff4880d8831d$var$_initializerDefineProperty(this, "status", $fe26ff4880d8831d$var$_descriptor10, this);
        $fe26ff4880d8831d$var$_initializerDefineProperty(this, "projectId", $fe26ff4880d8831d$var$_descriptor11, this);
        $fe26ff4880d8831d$var$_initializerDefineProperty(this, "phaseId", $fe26ff4880d8831d$var$_descriptor12, this);
        $fe26ff4880d8831d$var$_initializerDefineProperty(this, "phaseTitle", $fe26ff4880d8831d$var$_descriptor13, this);
        $fe26ff4880d8831d$var$_initializerDefineProperty(this, "revenueStartDate", $fe26ff4880d8831d$var$_descriptor14, this);
        $fe26ff4880d8831d$var$_initializerDefineProperty(this, "revenueEndDate", $fe26ff4880d8831d$var$_descriptor15, this);
        $fe26ff4880d8831d$var$_initializerDefineProperty(this, "startDate", $fe26ff4880d8831d$var$_descriptor16, this);
        $fe26ff4880d8831d$var$_initializerDefineProperty(this, "endDate", $fe26ff4880d8831d$var$_descriptor17, this);
        $fe26ff4880d8831d$var$_initializerDefineProperty(this, "groups", $fe26ff4880d8831d$var$_descriptor18, this);
        $fe26ff4880d8831d$var$_initializerDefineProperty(this, "store", $fe26ff4880d8831d$var$_descriptor19, this);
        $fe26ff4880d8831d$var$_initializerDefineProperty(this, "parent", $fe26ff4880d8831d$var$_descriptor20, this);
        $fe26ff4880d8831d$var$_initializerDefineProperty(this, "children", $fe26ff4880d8831d$var$_descriptor21, this);
        $fe26ff4880d8831d$var$_initializerDefineProperty(this, "isRootPhase", $fe26ff4880d8831d$var$_descriptor22, this);
        $fe26ff4880d8831d$var$_defineProperty(this, "getRevenueInMonth", (0, $Ds2V9.computedFn)((month)=>{
            if (this.children.length) return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.children.flatMap((r)=>r.getRevenueInMonth(month)));
            if (this.revenueData === "actual") {
                var _this$actualRevenue$m;
                return (_this$actualRevenue$m = this.actualRevenue[month]) !== null && _this$actualRevenue$m !== void 0 ? _this$actualRevenue$m : 0;
            }
            if (this.revenueData === "projected") {
                var _ref, _this$editedRevenue$m;
                return (_ref = (_this$editedRevenue$m = this.editedRevenue[month]) !== null && _this$editedRevenue$m !== void 0 ? _this$editedRevenue$m : this.projectedRevenue[month]) !== null && _ref !== void 0 ? _ref : 0;
            }
            if (this.revenueData === "actualsProjected") {
                if (month < (0, $4hBm1.format)(new Date(), "yyyy-MM")) {
                    var _this$actualRevenue$m2;
                    return (_this$actualRevenue$m2 = this.actualRevenue[month]) !== null && _this$actualRevenue$m2 !== void 0 ? _this$actualRevenue$m2 : 0;
                } else if (month > (0, $4hBm1.format)(new Date(), "yyyy-MM")) {
                    var _ref2, _this$editedRevenue$m2;
                    return (_ref2 = (_this$editedRevenue$m2 = this.editedRevenue[month]) !== null && _this$editedRevenue$m2 !== void 0 ? _this$editedRevenue$m2 : this.projectedRevenue[month]) !== null && _ref2 !== void 0 ? _ref2 : 0;
                } else {
                    var _this$actualRevenue$m3, _ref3, _this$editedRevenue$m3;
                    return Math.max((_this$actualRevenue$m3 = this.actualRevenue[month]) !== null && _this$actualRevenue$m3 !== void 0 ? _this$actualRevenue$m3 : 0, (_ref3 = (_this$editedRevenue$m3 = this.editedRevenue[month]) !== null && _this$editedRevenue$m3 !== void 0 ? _this$editedRevenue$m3 : this.projectedRevenue[month]) !== null && _ref3 !== void 0 ? _ref3 : 0);
                }
            }
        }));
        $fe26ff4880d8831d$var$_defineProperty(this, "getVariationRevenueInMonth", (0, $Ds2V9.computedFn)((month)=>{
            var _this$actualVariation;
            if (this.children.length) return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.children.flatMap((r)=>r.getVariationRevenueInMonth(month)));
            if (this.revenueData === "projected") return 0;
            return (_this$actualVariation = this.actualVariationRevenue[month]) !== null && _this$actualVariation !== void 0 ? _this$actualVariation : 0;
        }));
        $fe26ff4880d8831d$var$_defineProperty(this, "getExpenseInMonth", (0, $Ds2V9.computedFn)((month)=>{
            if (this.children.length) return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.children.flatMap((r)=>r.getExpenseInMonth(month)));
            if (this.revenueData === "actual") return this.expenses[month] || 0;
            if (this.revenueData === "projected") return this.editedExpense[month] || this.expenses[month] || 0;
            if (this.revenueData === "actualsProjected") {
                if (month < (0, $4hBm1.format)(new Date(), "yyyy-MM")) return this.expenses[month] || 0;
                else if (month > (0, $4hBm1.format)(new Date(), "yyyy-MM")) return this.editedExpense[month] || this.expenses[month] || 0;
                else return Math.max(this.expenses[month] || 0, this.editedExpense[month] || this.expenses[month] || 0);
            }
        }));
        $fe26ff4880d8831d$var$_defineProperty(this, "getRevenueToDateInMonth", (0, $Ds2V9.computedFn)((month)=>{
            const prevRevenueMonths = this.revenueMonths.filter((m)=>m <= month);
            const revenueToDate = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(prevRevenueMonths.map((m)=>this.getRevenueInMonth(m)));
            return revenueToDate;
        }));
        $fe26ff4880d8831d$var$_defineProperty(this, "getVariationRevenueToDateInMonth", (0, $Ds2V9.computedFn)((month)=>{
            const prevRevenueMonths = this.revenueMonths.filter((m)=>m <= month);
            const revenueToDate = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(prevRevenueMonths.map((m)=>this.getVariationRevenueInMonth(m)));
            return revenueToDate;
        }));
        $fe26ff4880d8831d$var$_defineProperty(this, "getExpenseToDateInMonth", (0, $Ds2V9.computedFn)((month)=>{
            const prevExpenseMonths = this.expenseMonths.filter((m)=>m <= month);
            const expensesToDate = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(prevExpenseMonths.map((m)=>this.getExpenseInMonth(m)));
            return expensesToDate;
        }));
        $fe26ff4880d8831d$var$_defineProperty(this, "getTotalRevenue", (0, $Ds2V9.computedFn)(()=>{
            return this.getRevenueToDateInMonth((0, $4hBm1.format)((0, $4hBm1.addYears)(new Date(), 100), "yyyy-MM"));
        }));
        $fe26ff4880d8831d$var$_defineProperty(this, "getTotalExpense", (0, $Ds2V9.computedFn)(()=>{
            return this.getExpenseToDateInMonth((0, $4hBm1.format)((0, $4hBm1.addYears)(new Date(), 100), "yyyy-MM"));
        }));
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $3gI5O.default);
        this.init(data, options);
    }
    setStore(store) {
        this.children.forEach((r)=>r.setStore(store));
        if (this.store === store) return;
        this.store = store;
    }
    setParent(parent) {
        this.parent = parent;
    }
    setChildren(children = []) {
        this.children = children;
    }
    get totalFee() {
        var _this$phase, _this$project;
        if (this.children.length) return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.children.map((r)=>r.totalFee));
        return this.fee || ((_this$phase = this.phase) === null || _this$phase === void 0 ? void 0 : _this$phase.fee) || ((_this$project = this.project) === null || _this$project === void 0 ? void 0 : _this$project.fee) || 0;
    }
    get revenueData() {
        var _this$store, _this$store$report, _this$store$report$fi, _this$store2, _this$store2$report, _this$store2$report$f, _this$store3, _this$store3$report, _this$store3$report$f;
        return ((_this$store = this.store) === null || _this$store === void 0 ? void 0 : (_this$store$report = _this$store.report) === null || _this$store$report === void 0 ? void 0 : (_this$store$report$fi = _this$store$report.filters) === null || _this$store$report$fi === void 0 ? void 0 : _this$store$report$fi.revenueData) || ((_this$store2 = this.store) === null || _this$store2 === void 0 ? void 0 : (_this$store2$report = _this$store2.report) === null || _this$store2$report === void 0 ? void 0 : (_this$store2$report$f = _this$store2$report.filters) === null || _this$store2$report$f === void 0 ? void 0 : _this$store2$report$f.expenseData) || ((_this$store3 = this.store) === null || _this$store3 === void 0 ? void 0 : (_this$store3$report = _this$store3.report) === null || _this$store3$report === void 0 ? void 0 : (_this$store3$report$f = _this$store3$report.filters) === null || _this$store3$report$f === void 0 ? void 0 : _this$store3$report$f.hoursData) || "actualsProjected";
    }
    get phase() {
        return (0, $XoImS.default).phasesById[this.phaseId];
    }
    get project() {
        return (0, $gJT7h.default).projectsById[this.projectId];
    }
    get childPhases() {
        return this.phase ? [
            this.phase
        ] : [
            ...new Set(this.children.flatMap((c)=>c.childPhases))
        ].filter((p)=>p);
    }
    get childPhaseIds() {
        return this.phaseId ? [
            this.phaseId
        ] : [
            ...new Set(this.children.flatMap((c)=>c.childPhaseIds))
        ].filter((p)=>p);
    }
    get childProjects() {
        return this.project ? [
            this.project
        ] : [
            ...new Set(this.children.flatMap((c)=>c.childProjects))
        ].filter((p)=>p);
    }
    get level() {
        return this.groups.length - 1;
    }
    get matchers() {
        let matchers = {};
        if (this.groups.includes("staff")) matchers.staffId = this.staffId;
        if (this.groups.includes("role")) matchers.roleId = this.roleId;
        if (this.groups.includes("phase")) matchers.phaseId = this.phaseId;
        if (this.groups.includes("project")) matchers.projectId = this.projectId;
        if (this.groups.includes("status")) matchers.status = this.status;
        return matchers;
    }
    get revenueMonths() {
        if (this.children.length) return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).uniq(this.children.flatMap((r)=>r.revenueMonths));
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).uniq([
            ...Object.keys(this.actualRevenue),
            ...Object.keys(this.projectedRevenue),
            ...Object.keys(this.editedRevenue)
        ]);
    }
    get expenseMonths() {
        if (this.children.length) return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).uniq(this.children.flatMap((r)=>r.expenseMonths));
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).uniq([
            ...Object.keys(this.expenses),
            ...Object.keys(this.editedExpense)
        ]);
    }
    getProgressInMonth(month) {
        if (!this.totalFee) return null;
        return this.getRevenueToDateInMonth(month) / this.totalFee;
    }
    getExpenseProgressInMonth(month) {
        return this.getExpenseToDateInMonth(month) / this.expenseBudget;
    }
    setProgressInMonth(month, progress) {
        progress || (progress = 0);
        const monthDate = (0, $4hBm1.parse)(month, "yyyy-MM", new Date());
        const prevMonth = (0, $4hBm1.format)((0, $4hBm1.subMonths)(monthDate, 1), "yyyy-MM");
        const prevProgress = this.getProgressInMonth(prevMonth) || 0;
        const diffProgress = Math.max(progress, prevProgress) - prevProgress;
        const diffRevenue = diffProgress * this.totalFee;
        return this.setRevenueInMonth(month, diffRevenue);
    }
    setExpenseProgressInMonth(month, progress) {
        progress || (progress = 0);
        const monthDate = (0, $4hBm1.parse)(month, "yyyy-MM", new Date());
        const prevMonth = (0, $4hBm1.format)((0, $4hBm1.subMonths)(monthDate, 1), "yyyy-MM");
        const prevProgress = this.getExpenseProgressInMonth(prevMonth) || 0;
        const diffProgress = Math.max(progress, prevProgress) - prevProgress;
        const diffExpense = diffProgress * this.expenseBudget;
        return this.setExpenseInMonth(month, diffExpense);
    }
    setRevenueInMonth(month, v) {
        if (!this.children.length) {
            this.editedRevenue[month] = v;
            this.update({
                editedRevenue: {
                    ...this.editedRevenue
                }
            });
        }
        const children = this.children;
        const childrenWithRevenueInMonth = children.filter((r)=>r.getRevenueInMonth(month) > 0);
        const existingRevenueInMonth = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(childrenWithRevenueInMonth.map((r)=>r.getRevenueInMonth(month)));
        if (existingRevenueInMonth) {
            const ratio = v / existingRevenueInMonth;
            childrenWithRevenueInMonth.forEach((r)=>r.setRevenueInMonth(month, r.getRevenueInMonth(month) * ratio));
        } else children.forEach((r)=>r.setRevenueInMonth(month, v / children.length));
    }
    serialize() {
        var _this$store4, _this$store4$report;
        return {
            id: this.id,
            editedRevenue: this.editedRevenue,
            reportFilters: {
                ...((_this$store4 = this.store) === null || _this$store4 === void 0 ? void 0 : (_this$store4$report = _this$store4.report) === null || _this$store4$report === void 0 ? void 0 : _this$store4$report.filters) || {},
                ...this.matchers
            }
        };
    }
    serializeUpdates() {
        return this.serialize();
    }
}, $fe26ff4880d8831d$var$_descriptor = $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "label", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $fe26ff4880d8831d$var$_descriptor2 = $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "fee", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $fe26ff4880d8831d$var$_descriptor3 = $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "actualRevenue", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $fe26ff4880d8831d$var$_descriptor4 = $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "actualVariationRevenue", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $fe26ff4880d8831d$var$_descriptor5 = $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "actualReimbursementRevenue", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $fe26ff4880d8831d$var$_descriptor6 = $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "projectedRevenue", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $fe26ff4880d8831d$var$_descriptor7 = $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "editedRevenue", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $fe26ff4880d8831d$var$_descriptor8 = $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "editedExpense", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $fe26ff4880d8831d$var$_descriptor9 = $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "expenses", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $fe26ff4880d8831d$var$_descriptor10 = $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "status", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $fe26ff4880d8831d$var$_descriptor11 = $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "projectId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $fe26ff4880d8831d$var$_descriptor12 = $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "phaseId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $fe26ff4880d8831d$var$_descriptor13 = $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "phaseTitle", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $fe26ff4880d8831d$var$_descriptor14 = $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "revenueStartDate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $fe26ff4880d8831d$var$_descriptor15 = $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "revenueEndDate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $fe26ff4880d8831d$var$_descriptor16 = $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "startDate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $fe26ff4880d8831d$var$_descriptor17 = $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "endDate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $fe26ff4880d8831d$var$_descriptor18 = $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "groups", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [
            "status"
        ];
    }
}), $fe26ff4880d8831d$var$_descriptor19 = $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "store", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $fe26ff4880d8831d$var$_descriptor20 = $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "parent", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $fe26ff4880d8831d$var$_descriptor21 = $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "children", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $fe26ff4880d8831d$var$_descriptor22 = $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "isRootPhase", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "setStore", [
    (0, $4JcCM.action)
], Object.getOwnPropertyDescriptor($fe26ff4880d8831d$var$_class.prototype, "setStore"), $fe26ff4880d8831d$var$_class.prototype), $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "setParent", [
    $fe26ff4880d8831d$var$_dec
], Object.getOwnPropertyDescriptor($fe26ff4880d8831d$var$_class.prototype, "setParent"), $fe26ff4880d8831d$var$_class.prototype), $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "setChildren", [
    $fe26ff4880d8831d$var$_dec2
], Object.getOwnPropertyDescriptor($fe26ff4880d8831d$var$_class.prototype, "setChildren"), $fe26ff4880d8831d$var$_class.prototype), $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "totalFee", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($fe26ff4880d8831d$var$_class.prototype, "totalFee"), $fe26ff4880d8831d$var$_class.prototype), $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "revenueData", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($fe26ff4880d8831d$var$_class.prototype, "revenueData"), $fe26ff4880d8831d$var$_class.prototype), $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "phase", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($fe26ff4880d8831d$var$_class.prototype, "phase"), $fe26ff4880d8831d$var$_class.prototype), $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "project", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($fe26ff4880d8831d$var$_class.prototype, "project"), $fe26ff4880d8831d$var$_class.prototype), $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "childPhases", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($fe26ff4880d8831d$var$_class.prototype, "childPhases"), $fe26ff4880d8831d$var$_class.prototype), $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "childPhaseIds", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($fe26ff4880d8831d$var$_class.prototype, "childPhaseIds"), $fe26ff4880d8831d$var$_class.prototype), $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "childProjects", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($fe26ff4880d8831d$var$_class.prototype, "childProjects"), $fe26ff4880d8831d$var$_class.prototype), $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "level", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($fe26ff4880d8831d$var$_class.prototype, "level"), $fe26ff4880d8831d$var$_class.prototype), $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "matchers", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($fe26ff4880d8831d$var$_class.prototype, "matchers"), $fe26ff4880d8831d$var$_class.prototype), $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "revenueMonths", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($fe26ff4880d8831d$var$_class.prototype, "revenueMonths"), $fe26ff4880d8831d$var$_class.prototype), $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "expenseMonths", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($fe26ff4880d8831d$var$_class.prototype, "expenseMonths"), $fe26ff4880d8831d$var$_class.prototype), $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "getProgressInMonth", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($fe26ff4880d8831d$var$_class.prototype, "getProgressInMonth"), $fe26ff4880d8831d$var$_class.prototype), $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "getExpenseProgressInMonth", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($fe26ff4880d8831d$var$_class.prototype, "getExpenseProgressInMonth"), $fe26ff4880d8831d$var$_class.prototype), $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "setProgressInMonth", [
    $fe26ff4880d8831d$var$_dec3
], Object.getOwnPropertyDescriptor($fe26ff4880d8831d$var$_class.prototype, "setProgressInMonth"), $fe26ff4880d8831d$var$_class.prototype), $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "setExpenseProgressInMonth", [
    $fe26ff4880d8831d$var$_dec4
], Object.getOwnPropertyDescriptor($fe26ff4880d8831d$var$_class.prototype, "setExpenseProgressInMonth"), $fe26ff4880d8831d$var$_class.prototype), $fe26ff4880d8831d$var$_applyDecoratedDescriptor($fe26ff4880d8831d$var$_class.prototype, "setRevenueInMonth", [
    $fe26ff4880d8831d$var$_dec5
], Object.getOwnPropertyDescriptor($fe26ff4880d8831d$var$_class.prototype, "setRevenueInMonth"), $fe26ff4880d8831d$var$_class.prototype), $fe26ff4880d8831d$var$_class);
var $fe26ff4880d8831d$export$2e2bcd8739ae039 = $fe26ff4880d8831d$var$RevenueRowModel;

});




parcelRegister("6920Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $479524fb7e5efcf8$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "MonthlyExpenseCellCollectionClass", function () { return $479524fb7e5efcf8$export$b3413dfcf8f176a9; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $l377H = parcelRequire("l377H");
var $479524fb7e5efcf8$var$_dec, $479524fb7e5efcf8$var$_dec2, $479524fb7e5efcf8$var$_class;
function $479524fb7e5efcf8$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $479524fb7e5efcf8$var$MonthlyExpenseCellCollection = ($479524fb7e5efcf8$var$_dec = (0, $4JcCM.action).bound, $479524fb7e5efcf8$var$_dec2 = (0, $4JcCM.action).bound, $479524fb7e5efcf8$var$_class = class MonthlyExpenseCellCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "monthlyExpenseCells",
            modelClass: (0, $l377H.default)
        });
        this.addLookup("cellsByStatus", "manyByKey", {
            key: (t)=>t.status,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("cellsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("cellsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("cellsByExpenseName", "manyByKey", {
            key: (t)=>t.expenseName,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("cellsByMonth", "manyByKey", {
            key: (t)=>t.month,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("cellsByType", "manyByKey", {
            key: (t)=>t.type,
            filter: (t)=>!t.deletedAt
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get cellsById() {
        return this.modelsById;
    }
    get cells() {
        return this.models;
    }
    addCell(data, options) {
        return this.add(data, options);
    }
    addCells(data, options) {
        return this.addMany(data, options);
    }
}, $479524fb7e5efcf8$var$_applyDecoratedDescriptor($479524fb7e5efcf8$var$_class.prototype, "addCell", [
    $479524fb7e5efcf8$var$_dec
], Object.getOwnPropertyDescriptor($479524fb7e5efcf8$var$_class.prototype, "addCell"), $479524fb7e5efcf8$var$_class.prototype), $479524fb7e5efcf8$var$_applyDecoratedDescriptor($479524fb7e5efcf8$var$_class.prototype, "addCells", [
    $479524fb7e5efcf8$var$_dec2
], Object.getOwnPropertyDescriptor($479524fb7e5efcf8$var$_class.prototype, "addCells"), $479524fb7e5efcf8$var$_class.prototype), $479524fb7e5efcf8$var$_class);
var $479524fb7e5efcf8$export$2e2bcd8739ae039 = new $479524fb7e5efcf8$var$MonthlyExpenseCellCollection();
const $479524fb7e5efcf8$export$b3413dfcf8f176a9 = $479524fb7e5efcf8$var$MonthlyExpenseCellCollection;

});
parcelRegister("l377H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f52f6750bdd993c3$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $XoImS = parcelRequire("XoImS");

var $gJT7h = parcelRequire("gJT7h");

var $6920Q = parcelRequire("6920Q");

var $3PpOX = parcelRequire("3PpOX");

var $4hBm1 = parcelRequire("4hBm1");

var $cfp1m = parcelRequire("cfp1m");
parcelRequire("fZxja");
var $f52f6750bdd993c3$var$_class, $f52f6750bdd993c3$var$_descriptor, $f52f6750bdd993c3$var$_descriptor2, $f52f6750bdd993c3$var$_descriptor3, $f52f6750bdd993c3$var$_descriptor4, $f52f6750bdd993c3$var$_descriptor5, $f52f6750bdd993c3$var$_descriptor6, $f52f6750bdd993c3$var$_descriptor7, $f52f6750bdd993c3$var$_descriptor8, $f52f6750bdd993c3$var$_descriptor9, $f52f6750bdd993c3$var$_descriptor10;
function $f52f6750bdd993c3$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $f52f6750bdd993c3$var$_defineProperty(e, r, t) {
    return (r = $f52f6750bdd993c3$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f52f6750bdd993c3$var$_toPropertyKey(t) {
    var i = $f52f6750bdd993c3$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $f52f6750bdd993c3$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $f52f6750bdd993c3$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $f52f6750bdd993c3$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $f52f6750bdd993c3$var$MonthlyExpenseCellModel = ($f52f6750bdd993c3$var$_class = class MonthlyExpenseCellModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $f52f6750bdd993c3$var$_initializerDefineProperty(this, "month", $f52f6750bdd993c3$var$_descriptor, this);
        $f52f6750bdd993c3$var$_initializerDefineProperty(this, "expense", $f52f6750bdd993c3$var$_descriptor2, this);
        $f52f6750bdd993c3$var$_initializerDefineProperty(this, "expenseToDate", $f52f6750bdd993c3$var$_descriptor3, this);
        $f52f6750bdd993c3$var$_initializerDefineProperty(this, "status", $f52f6750bdd993c3$var$_descriptor4, this);
        $f52f6750bdd993c3$var$_initializerDefineProperty(this, "projectId", $f52f6750bdd993c3$var$_descriptor5, this);
        $f52f6750bdd993c3$var$_initializerDefineProperty(this, "phaseId", $f52f6750bdd993c3$var$_descriptor6, this);
        $f52f6750bdd993c3$var$_initializerDefineProperty(this, "expenseName", $f52f6750bdd993c3$var$_descriptor7, this);
        $f52f6750bdd993c3$var$_initializerDefineProperty(this, "ownerId", $f52f6750bdd993c3$var$_descriptor8, this);
        $f52f6750bdd993c3$var$_initializerDefineProperty(this, "costCentreId", $f52f6750bdd993c3$var$_descriptor9, this);
        $f52f6750bdd993c3$var$_initializerDefineProperty(this, "type", $f52f6750bdd993c3$var$_descriptor10, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $6920Q.default);
        this.init(data, options);
    }
    get phase() {
        return (0, $XoImS.default).phasesById[this.phaseId];
    }
    get project() {
        return (0, $gJT7h.default).projectsById[this.projectId];
    }
    get projectExpense() {
        return (0, $cfp1m.default).expensesByName[this.expenseName] || (0, $cfp1m.default).add({
            projectId: this.projectId,
            phaseId: this.phaseId,
            name: this.expenseName
        });
    }
    serialize() {
        return {
            id: this.id,
            month: this.month,
            expense: this.expense,
            expenseName: this.expenseName,
            projectId: this.projectId,
            phaseId: this.phaseId
        };
    }
    serializeUpdates() {
        return this.serialize();
    }
    get date() {
        return (0, $4hBm1.startOfMonth)((0, $4hBm1.parse)(this.month, "yyyy-MM", new Date()));
    }
}, $f52f6750bdd993c3$var$_descriptor = $f52f6750bdd993c3$var$_applyDecoratedDescriptor($f52f6750bdd993c3$var$_class.prototype, "month", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $f52f6750bdd993c3$var$_descriptor2 = $f52f6750bdd993c3$var$_applyDecoratedDescriptor($f52f6750bdd993c3$var$_class.prototype, "expense", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $f52f6750bdd993c3$var$_descriptor3 = $f52f6750bdd993c3$var$_applyDecoratedDescriptor($f52f6750bdd993c3$var$_class.prototype, "expenseToDate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $f52f6750bdd993c3$var$_descriptor4 = $f52f6750bdd993c3$var$_applyDecoratedDescriptor($f52f6750bdd993c3$var$_class.prototype, "status", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $f52f6750bdd993c3$var$_descriptor5 = $f52f6750bdd993c3$var$_applyDecoratedDescriptor($f52f6750bdd993c3$var$_class.prototype, "projectId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $f52f6750bdd993c3$var$_descriptor6 = $f52f6750bdd993c3$var$_applyDecoratedDescriptor($f52f6750bdd993c3$var$_class.prototype, "phaseId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $f52f6750bdd993c3$var$_descriptor7 = $f52f6750bdd993c3$var$_applyDecoratedDescriptor($f52f6750bdd993c3$var$_class.prototype, "expenseName", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $f52f6750bdd993c3$var$_descriptor8 = $f52f6750bdd993c3$var$_applyDecoratedDescriptor($f52f6750bdd993c3$var$_class.prototype, "ownerId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $f52f6750bdd993c3$var$_descriptor9 = $f52f6750bdd993c3$var$_applyDecoratedDescriptor($f52f6750bdd993c3$var$_class.prototype, "costCentreId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $f52f6750bdd993c3$var$_descriptor10 = $f52f6750bdd993c3$var$_applyDecoratedDescriptor($f52f6750bdd993c3$var$_class.prototype, "type", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $f52f6750bdd993c3$var$_applyDecoratedDescriptor($f52f6750bdd993c3$var$_class.prototype, "phase", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($f52f6750bdd993c3$var$_class.prototype, "phase"), $f52f6750bdd993c3$var$_class.prototype), $f52f6750bdd993c3$var$_applyDecoratedDescriptor($f52f6750bdd993c3$var$_class.prototype, "project", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($f52f6750bdd993c3$var$_class.prototype, "project"), $f52f6750bdd993c3$var$_class.prototype), $f52f6750bdd993c3$var$_applyDecoratedDescriptor($f52f6750bdd993c3$var$_class.prototype, "projectExpense", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($f52f6750bdd993c3$var$_class.prototype, "projectExpense"), $f52f6750bdd993c3$var$_class.prototype), $f52f6750bdd993c3$var$_applyDecoratedDescriptor($f52f6750bdd993c3$var$_class.prototype, "date", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($f52f6750bdd993c3$var$_class.prototype, "date"), $f52f6750bdd993c3$var$_class.prototype), $f52f6750bdd993c3$var$_class);
var $f52f6750bdd993c3$export$2e2bcd8739ae039 = $f52f6750bdd993c3$var$MonthlyExpenseCellModel;

});


parcelRegister("5o9Ld", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ec6c3e287a7d094$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "ExpenseRowCollectionClass", function () { return $3ec6c3e287a7d094$export$61860cc5fc65ddb4; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $bvRAk = parcelRequire("bvRAk");
var $3ec6c3e287a7d094$var$_dec, $3ec6c3e287a7d094$var$_dec2, $3ec6c3e287a7d094$var$_class;
function $3ec6c3e287a7d094$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $3ec6c3e287a7d094$var$ExpenseRowCollection = ($3ec6c3e287a7d094$var$_dec = (0, $4JcCM.action).bound, $3ec6c3e287a7d094$var$_dec2 = (0, $4JcCM.action).bound, $3ec6c3e287a7d094$var$_class = class ExpenseRowCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "expenseRows",
            modelClass: (0, $bvRAk.default)
        });
        this.addLookup("rowsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("rowsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("rowsByExpenseId", "manyByKey", {
            key: (t)=>t.expenseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("rowsByStatus", "manyByKey", {
            key: (t)=>t.status,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("leafRows", "list", {
            filter: (m)=>{
                return m.isLeaf;
            }
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get rowsById() {
        return this.modelsById;
    }
    get rows() {
        return this.models;
    }
    addRow(data) {
        this.add(data);
    }
    addRows(data) {
        this.addMany(data);
    }
}, $3ec6c3e287a7d094$var$_applyDecoratedDescriptor($3ec6c3e287a7d094$var$_class.prototype, "addRow", [
    $3ec6c3e287a7d094$var$_dec
], Object.getOwnPropertyDescriptor($3ec6c3e287a7d094$var$_class.prototype, "addRow"), $3ec6c3e287a7d094$var$_class.prototype), $3ec6c3e287a7d094$var$_applyDecoratedDescriptor($3ec6c3e287a7d094$var$_class.prototype, "addRows", [
    $3ec6c3e287a7d094$var$_dec2
], Object.getOwnPropertyDescriptor($3ec6c3e287a7d094$var$_class.prototype, "addRows"), $3ec6c3e287a7d094$var$_class.prototype), $3ec6c3e287a7d094$var$_class);
var $3ec6c3e287a7d094$export$2e2bcd8739ae039 = new $3ec6c3e287a7d094$var$ExpenseRowCollection();
const $3ec6c3e287a7d094$export$61860cc5fc65ddb4 = $3ec6c3e287a7d094$var$ExpenseRowCollection;

});
parcelRegister("bvRAk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $861c27c9a335cf9a$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $XoImS = parcelRequire("XoImS");

var $gJT7h = parcelRequire("gJT7h");

var $5o9Ld = parcelRequire("5o9Ld");

var $3PpOX = parcelRequire("3PpOX");

var $6920Q = parcelRequire("6920Q");

var $eat5C = parcelRequire("eat5C");

var $62nmb = parcelRequire("62nmb");

var $4hBm1 = parcelRequire("4hBm1");
parcelRequire("bxXv3");
parcelRequire("htkeB");

var $Ds2V9 = parcelRequire("Ds2V9");

var $cfp1m = parcelRequire("cfp1m");
var $861c27c9a335cf9a$var$_dec, $861c27c9a335cf9a$var$_class, $861c27c9a335cf9a$var$_descriptor, $861c27c9a335cf9a$var$_descriptor2, $861c27c9a335cf9a$var$_descriptor3, $861c27c9a335cf9a$var$_descriptor4, $861c27c9a335cf9a$var$_descriptor5, $861c27c9a335cf9a$var$_descriptor6, $861c27c9a335cf9a$var$_descriptor7, $861c27c9a335cf9a$var$_descriptor8, $861c27c9a335cf9a$var$_descriptor9, $861c27c9a335cf9a$var$_descriptor10, $861c27c9a335cf9a$var$_descriptor11, $861c27c9a335cf9a$var$_descriptor12, $861c27c9a335cf9a$var$_descriptor13, $861c27c9a335cf9a$var$_descriptor14, $861c27c9a335cf9a$var$_descriptor15;
function $861c27c9a335cf9a$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $861c27c9a335cf9a$var$_defineProperty(e, r, t) {
    return (r = $861c27c9a335cf9a$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $861c27c9a335cf9a$var$_toPropertyKey(t) {
    var i = $861c27c9a335cf9a$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $861c27c9a335cf9a$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $861c27c9a335cf9a$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $861c27c9a335cf9a$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
const $861c27c9a335cf9a$var$cellsByGroup = {
    status: ()=>(0, $6920Q.default).cellsByStatus,
    project: ()=>(0, $6920Q.default).cellsByProjectId,
    phase: ()=>(0, $6920Q.default).cellsByPhaseId,
    expense: ()=>(0, $6920Q.default).cellsByExpenseName
};
const $861c27c9a335cf9a$var$propByGroup = {
    status: "status",
    project: "projectId",
    phase: "phaseId",
    expense: "expenseName"
};
const $861c27c9a335cf9a$var$titlePropByGroup = {
    project: "title",
    phase: "title",
    staff: "fullName",
    role: "name",
    expense: "expenseName"
};
let $861c27c9a335cf9a$var$ExpenseRowModel = ($861c27c9a335cf9a$var$_dec = (0, $4JcCM.action).bound, $861c27c9a335cf9a$var$_class = class ExpenseRowModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $861c27c9a335cf9a$var$_initializerDefineProperty(this, "label", $861c27c9a335cf9a$var$_descriptor, this);
        $861c27c9a335cf9a$var$_initializerDefineProperty(this, "fee", $861c27c9a335cf9a$var$_descriptor2, this);
        $861c27c9a335cf9a$var$_initializerDefineProperty(this, "hoursBudget", $861c27c9a335cf9a$var$_descriptor3, this);
        $861c27c9a335cf9a$var$_initializerDefineProperty(this, "expenseBudget", $861c27c9a335cf9a$var$_descriptor4, this);
        $861c27c9a335cf9a$var$_initializerDefineProperty(this, "expenses", $861c27c9a335cf9a$var$_descriptor5, this);
        $861c27c9a335cf9a$var$_initializerDefineProperty(this, "editedExpenses", $861c27c9a335cf9a$var$_descriptor6, this);
        $861c27c9a335cf9a$var$_initializerDefineProperty(this, "status", $861c27c9a335cf9a$var$_descriptor7, this);
        $861c27c9a335cf9a$var$_initializerDefineProperty(this, "projectId", $861c27c9a335cf9a$var$_descriptor8, this);
        $861c27c9a335cf9a$var$_initializerDefineProperty(this, "phaseId", $861c27c9a335cf9a$var$_descriptor9, this);
        $861c27c9a335cf9a$var$_initializerDefineProperty(this, "expenseName", $861c27c9a335cf9a$var$_descriptor10, this);
        $861c27c9a335cf9a$var$_initializerDefineProperty(this, "expenseStartDate", $861c27c9a335cf9a$var$_descriptor11, this);
        $861c27c9a335cf9a$var$_initializerDefineProperty(this, "expenseEndDate", $861c27c9a335cf9a$var$_descriptor12, this);
        $861c27c9a335cf9a$var$_initializerDefineProperty(this, "startDate", $861c27c9a335cf9a$var$_descriptor13, this);
        $861c27c9a335cf9a$var$_initializerDefineProperty(this, "endDate", $861c27c9a335cf9a$var$_descriptor14, this);
        $861c27c9a335cf9a$var$_initializerDefineProperty(this, "groups", $861c27c9a335cf9a$var$_descriptor15, this);
        $861c27c9a335cf9a$var$_defineProperty(this, "getExpenseInMonth", (0, $Ds2V9.computedFn)((month, expenseData = "actualsProjected")=>{
            var _ref, _this$editedExpenses$;
            if (!this.isLeaf && this.leafRows.length) return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.leafRows.flatMap((r)=>r.getExpenseInMonth(month, expenseData)));
            return (_ref = (_this$editedExpenses$ = this.editedExpenses[month]) !== null && _this$editedExpenses$ !== void 0 ? _this$editedExpenses$ : this.expenses[month]) !== null && _ref !== void 0 ? _ref : 0;
        }));
        $861c27c9a335cf9a$var$_defineProperty(this, "getExpenseToDateInMonth", (0, $Ds2V9.computedFn)((month, expenseData = "actualsProjected")=>{
            const prevExpenseMonths = this.expenseMonths.filter((m)=>m <= month);
            const expenseToDate = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(prevExpenseMonths.map((m)=>this.getExpenseInMonth(m, expenseData)));
            return expenseToDate;
        }));
        $861c27c9a335cf9a$var$_defineProperty(this, "getTotalExpense", (0, $Ds2V9.computedFn)((expenseData = "actualsProjected")=>{
            return this.getExpenseToDateInMonth((0, $4hBm1.format)(addYears(new Date(), 100), "yyyy-MM"), expenseData);
        }));
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $5o9Ld.default);
        this.init(data, options);
    }
    get title() {
        const lastGroup = this.groups[this.groups.length - 1];
        if (!this.label || this.label === "") {
            var _this$lastGroup;
            const titleProp = $861c27c9a335cf9a$var$titlePropByGroup[lastGroup];
            return titleProp ? (_this$lastGroup = this[lastGroup]) === null || _this$lastGroup === void 0 ? void 0 : _this$lastGroup[titleProp] : this[lastGroup];
        } else return this.label;
    }
    get isLeaf() {
        return this.groups.includes("phase") && this.groups.includes("project") && this.groups.includes("status") && this.groups.includes("expense");
    }
    get leafRows() {
        return this.isLeaf ? [] : (0, $5o9Ld.default).leafRows.filter((r)=>{
            const matcher = this.matchers;
            return (!("phaseId" in matcher) || r.phaseId === this.phaseId) && (!("projectId" in matcher) || r.projectId === this.projectId) && (!("status" in matcher) || r.status === this.status) && (!("expense" in matcher) || r.expenseName === this.expenseName);
        });
    }
    get level() {
        return this.groups.length - 1;
    }
    get childPhases() {
        return this.phase ? [
            this.phase
        ] : [
            ...new Set(this.leafRows.flatMap((c)=>c.childPhases))
        ].filter((p)=>p);
    }
    get childPhaseIds() {
        return this.phaseId ? [
            this.phaseId
        ] : [
            ...new Set(this.leafRows.flatMap((c)=>c.childPhaseIds))
        ].filter((p)=>p);
    }
    get childProjects() {
        return this.project ? [
            this.project
        ] : [
            ...new Set(this.leafRows.flatMap((c)=>c.childProjects))
        ].filter((p)=>p);
    }
    get childProjectIds() {
        return this.projectId ? [
            this.projectId
        ] : [
            ...new Set(this.leafRows.flatMap((c)=>c.childProjectIds))
        ].filter((p)=>p);
    }
    get childProjectExpenses() {
        return this.projectExpense ? [
            this.projectExpense
        ] : [
            ...new Set(this.leafRows.flatMap((c)=>c.childProjectExpenses))
        ].filter((p)=>p);
    }
    get phase() {
        return (0, $XoImS.default).phasesById[this.phaseId];
    }
    get project() {
        return (0, $gJT7h.default).projectsById[this.projectId];
    }
    get projectExpense() {
        return (0, $cfp1m.default).expensesByName[this.expenseName];
    }
    get matchers() {
        let matchers = {};
        if (this.groups.includes("phase")) matchers.phaseId = this.phaseId;
        if (this.groups.includes("project")) matchers.projectId = this.projectId;
        if (this.groups.includes("status")) matchers.status = this.status;
        if (this.groups.includes("expense")) matchers.expenseName = this.expenseName;
        return matchers;
    }
    get expenseMonths() {
        if (!this.isLeaf && this.leafRows.length) return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).uniq(this.leafRows.flatMap((r)=>r.revenueMonths));
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).uniq([
            ...Object.keys(this.expenses),
            ...Object.keys(this.editedExpenses)
        ]);
    }
    getProgressInMonth(month, expenseData = "actualsProjected") {
        return this.getExpenseToDateInMonth(month, expenseData) / this.budget;
    }
    setExpenseInMonth(month, v, expenseData = "actualsProjected") {
        if (this.isLeaf) {
            this.editedExpenses[month] = v;
            this.update({
                editedExpenses: {
                    ...this.editedExpenses
                }
            });
        }
        const leafRows = this.leafRows;
        const leafRowsWithExpensesInMonth = leafRows.filter((r)=>r.getExpenseInMonth(month, expenseData) > 0);
        const existingExpenseInMonth = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(leafRowsWithExpensesInMonth.map((r)=>r.getExpenseInMonth(month, expenseData)));
        if (existingExpenseInMonth) {
            const ratio = v / existingExpenseInMonth;
            leafRowsWithExpensesInMonth.forEach((r)=>r.setExpenseInMonth(month, r.getExpenseInMonth(month, expenseData) * ratio));
        } else leafRows.forEach((r)=>r.getExpenseInMonth(month, v / leafRows.length));
    }
    serialize() {
        return {
            id: this.id,
            editedExpenses: this.editedExpenses,
            projectId: this.projectId,
            phaseId: this.phaseId,
            expenseName: this.expenseName
        };
    }
    serializeUpdates() {
        return this.serialize();
    }
}, $861c27c9a335cf9a$var$_descriptor = $861c27c9a335cf9a$var$_applyDecoratedDescriptor($861c27c9a335cf9a$var$_class.prototype, "label", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $861c27c9a335cf9a$var$_descriptor2 = $861c27c9a335cf9a$var$_applyDecoratedDescriptor($861c27c9a335cf9a$var$_class.prototype, "fee", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $861c27c9a335cf9a$var$_descriptor3 = $861c27c9a335cf9a$var$_applyDecoratedDescriptor($861c27c9a335cf9a$var$_class.prototype, "hoursBudget", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $861c27c9a335cf9a$var$_descriptor4 = $861c27c9a335cf9a$var$_applyDecoratedDescriptor($861c27c9a335cf9a$var$_class.prototype, "expenseBudget", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $861c27c9a335cf9a$var$_descriptor5 = $861c27c9a335cf9a$var$_applyDecoratedDescriptor($861c27c9a335cf9a$var$_class.prototype, "expenses", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $861c27c9a335cf9a$var$_descriptor6 = $861c27c9a335cf9a$var$_applyDecoratedDescriptor($861c27c9a335cf9a$var$_class.prototype, "editedExpenses", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $861c27c9a335cf9a$var$_descriptor7 = $861c27c9a335cf9a$var$_applyDecoratedDescriptor($861c27c9a335cf9a$var$_class.prototype, "status", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $861c27c9a335cf9a$var$_descriptor8 = $861c27c9a335cf9a$var$_applyDecoratedDescriptor($861c27c9a335cf9a$var$_class.prototype, "projectId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $861c27c9a335cf9a$var$_descriptor9 = $861c27c9a335cf9a$var$_applyDecoratedDescriptor($861c27c9a335cf9a$var$_class.prototype, "phaseId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $861c27c9a335cf9a$var$_descriptor10 = $861c27c9a335cf9a$var$_applyDecoratedDescriptor($861c27c9a335cf9a$var$_class.prototype, "expenseName", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $861c27c9a335cf9a$var$_descriptor11 = $861c27c9a335cf9a$var$_applyDecoratedDescriptor($861c27c9a335cf9a$var$_class.prototype, "expenseStartDate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $861c27c9a335cf9a$var$_descriptor12 = $861c27c9a335cf9a$var$_applyDecoratedDescriptor($861c27c9a335cf9a$var$_class.prototype, "expenseEndDate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $861c27c9a335cf9a$var$_descriptor13 = $861c27c9a335cf9a$var$_applyDecoratedDescriptor($861c27c9a335cf9a$var$_class.prototype, "startDate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $861c27c9a335cf9a$var$_descriptor14 = $861c27c9a335cf9a$var$_applyDecoratedDescriptor($861c27c9a335cf9a$var$_class.prototype, "endDate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $861c27c9a335cf9a$var$_descriptor15 = $861c27c9a335cf9a$var$_applyDecoratedDescriptor($861c27c9a335cf9a$var$_class.prototype, "groups", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [
            "status"
        ];
    }
}), $861c27c9a335cf9a$var$_applyDecoratedDescriptor($861c27c9a335cf9a$var$_class.prototype, "title", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($861c27c9a335cf9a$var$_class.prototype, "title"), $861c27c9a335cf9a$var$_class.prototype), $861c27c9a335cf9a$var$_applyDecoratedDescriptor($861c27c9a335cf9a$var$_class.prototype, "isLeaf", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($861c27c9a335cf9a$var$_class.prototype, "isLeaf"), $861c27c9a335cf9a$var$_class.prototype), $861c27c9a335cf9a$var$_applyDecoratedDescriptor($861c27c9a335cf9a$var$_class.prototype, "leafRows", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($861c27c9a335cf9a$var$_class.prototype, "leafRows"), $861c27c9a335cf9a$var$_class.prototype), $861c27c9a335cf9a$var$_applyDecoratedDescriptor($861c27c9a335cf9a$var$_class.prototype, "level", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($861c27c9a335cf9a$var$_class.prototype, "level"), $861c27c9a335cf9a$var$_class.prototype), $861c27c9a335cf9a$var$_applyDecoratedDescriptor($861c27c9a335cf9a$var$_class.prototype, "childPhases", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($861c27c9a335cf9a$var$_class.prototype, "childPhases"), $861c27c9a335cf9a$var$_class.prototype), $861c27c9a335cf9a$var$_applyDecoratedDescriptor($861c27c9a335cf9a$var$_class.prototype, "childPhaseIds", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($861c27c9a335cf9a$var$_class.prototype, "childPhaseIds"), $861c27c9a335cf9a$var$_class.prototype), $861c27c9a335cf9a$var$_applyDecoratedDescriptor($861c27c9a335cf9a$var$_class.prototype, "childProjects", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($861c27c9a335cf9a$var$_class.prototype, "childProjects"), $861c27c9a335cf9a$var$_class.prototype), $861c27c9a335cf9a$var$_applyDecoratedDescriptor($861c27c9a335cf9a$var$_class.prototype, "childProjectIds", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($861c27c9a335cf9a$var$_class.prototype, "childProjectIds"), $861c27c9a335cf9a$var$_class.prototype), $861c27c9a335cf9a$var$_applyDecoratedDescriptor($861c27c9a335cf9a$var$_class.prototype, "childProjectExpenses", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($861c27c9a335cf9a$var$_class.prototype, "childProjectExpenses"), $861c27c9a335cf9a$var$_class.prototype), $861c27c9a335cf9a$var$_applyDecoratedDescriptor($861c27c9a335cf9a$var$_class.prototype, "phase", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($861c27c9a335cf9a$var$_class.prototype, "phase"), $861c27c9a335cf9a$var$_class.prototype), $861c27c9a335cf9a$var$_applyDecoratedDescriptor($861c27c9a335cf9a$var$_class.prototype, "project", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($861c27c9a335cf9a$var$_class.prototype, "project"), $861c27c9a335cf9a$var$_class.prototype), $861c27c9a335cf9a$var$_applyDecoratedDescriptor($861c27c9a335cf9a$var$_class.prototype, "projectExpense", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($861c27c9a335cf9a$var$_class.prototype, "projectExpense"), $861c27c9a335cf9a$var$_class.prototype), $861c27c9a335cf9a$var$_applyDecoratedDescriptor($861c27c9a335cf9a$var$_class.prototype, "matchers", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($861c27c9a335cf9a$var$_class.prototype, "matchers"), $861c27c9a335cf9a$var$_class.prototype), $861c27c9a335cf9a$var$_applyDecoratedDescriptor($861c27c9a335cf9a$var$_class.prototype, "expenseMonths", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($861c27c9a335cf9a$var$_class.prototype, "expenseMonths"), $861c27c9a335cf9a$var$_class.prototype), $861c27c9a335cf9a$var$_applyDecoratedDescriptor($861c27c9a335cf9a$var$_class.prototype, "getProgressInMonth", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($861c27c9a335cf9a$var$_class.prototype, "getProgressInMonth"), $861c27c9a335cf9a$var$_class.prototype), $861c27c9a335cf9a$var$_applyDecoratedDescriptor($861c27c9a335cf9a$var$_class.prototype, "setExpenseInMonth", [
    $861c27c9a335cf9a$var$_dec
], Object.getOwnPropertyDescriptor($861c27c9a335cf9a$var$_class.prototype, "setExpenseInMonth"), $861c27c9a335cf9a$var$_class.prototype), $861c27c9a335cf9a$var$_class);
var $861c27c9a335cf9a$export$2e2bcd8739ae039 = $861c27c9a335cf9a$var$ExpenseRowModel;

});


parcelRegister("liJtZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f81e8f59abd39e76$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "MilestoneCollectionClass", function () { return $f81e8f59abd39e76$export$1ac57c26e108a0fe; });

var $4JcCM = parcelRequire("4JcCM");

var $htmCK = parcelRequire("htmCK");

var $hU40t = parcelRequire("hU40t");
var $f81e8f59abd39e76$var$_dec, $f81e8f59abd39e76$var$_dec2, $f81e8f59abd39e76$var$_class;
function $f81e8f59abd39e76$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $f81e8f59abd39e76$var$MilestoneCollection = ($f81e8f59abd39e76$var$_dec = (0, $4JcCM.action).bound, $f81e8f59abd39e76$var$_dec2 = (0, $4JcCM.action).bound, $f81e8f59abd39e76$var$_class = class MilestoneCollection extends (0, $htmCK.default) {
    constructor(){
        super({
            collection: "milestones",
            modelClass: (0, $hU40t.default)
        });
        this.addLookup("milestonesByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("milestonesByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        (0, $4JcCM.makeObservable)(this);
    }
    get milestonesById() {
        return this.modelsById;
    }
    get milestones() {
        return this.models;
    }
    addMilestone(data, options) {
        return this.add(data, options);
    }
    addMilestones(data, options) {
        return this.addMany(data, options);
    }
}, $f81e8f59abd39e76$var$_applyDecoratedDescriptor($f81e8f59abd39e76$var$_class.prototype, "addMilestone", [
    $f81e8f59abd39e76$var$_dec
], Object.getOwnPropertyDescriptor($f81e8f59abd39e76$var$_class.prototype, "addMilestone"), $f81e8f59abd39e76$var$_class.prototype), $f81e8f59abd39e76$var$_applyDecoratedDescriptor($f81e8f59abd39e76$var$_class.prototype, "addMilestones", [
    $f81e8f59abd39e76$var$_dec2
], Object.getOwnPropertyDescriptor($f81e8f59abd39e76$var$_class.prototype, "addMilestones"), $f81e8f59abd39e76$var$_class.prototype), $f81e8f59abd39e76$var$_class);
var $f81e8f59abd39e76$export$2e2bcd8739ae039 = new $f81e8f59abd39e76$var$MilestoneCollection();
const $f81e8f59abd39e76$export$1ac57c26e108a0fe = $f81e8f59abd39e76$var$MilestoneCollection;

});
parcelRegister("hU40t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d08ac649a460e0c0$export$2e2bcd8739ae039; });
parcelRequire("gN0TC");

var $4JcCM = parcelRequire("4JcCM");

var $XoImS = parcelRequire("XoImS");

var $gJT7h = parcelRequire("gJT7h");

var $liJtZ = parcelRequire("liJtZ");

var $3PpOX = parcelRequire("3PpOX");

var $4hBm1 = parcelRequire("4hBm1");
var $d08ac649a460e0c0$var$_class, $d08ac649a460e0c0$var$_descriptor, $d08ac649a460e0c0$var$_descriptor2, $d08ac649a460e0c0$var$_descriptor3, $d08ac649a460e0c0$var$_descriptor4;
function $d08ac649a460e0c0$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $d08ac649a460e0c0$var$_defineProperty(e, r, t) {
    return (r = $d08ac649a460e0c0$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $d08ac649a460e0c0$var$_toPropertyKey(t) {
    var i = $d08ac649a460e0c0$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $d08ac649a460e0c0$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $d08ac649a460e0c0$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $d08ac649a460e0c0$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $d08ac649a460e0c0$var$MilestoneModel = ($d08ac649a460e0c0$var$_class = class MilestoneModel extends (0, $3PpOX.default) {
    constructor(data, options){
        super();
        $d08ac649a460e0c0$var$_initializerDefineProperty(this, "projectId", $d08ac649a460e0c0$var$_descriptor, this);
        $d08ac649a460e0c0$var$_initializerDefineProperty(this, "phaseId", $d08ac649a460e0c0$var$_descriptor2, this);
        $d08ac649a460e0c0$var$_initializerDefineProperty(this, "date", $d08ac649a460e0c0$var$_descriptor3, this);
        $d08ac649a460e0c0$var$_initializerDefineProperty(this, "label", $d08ac649a460e0c0$var$_descriptor4, this);
        (0, $4JcCM.makeObservable)(this);
        this.collection = (0, $liJtZ.default);
        this.init(data, options);
    }
    get project() {
        return (0, $gJT7h.default).modelsById[this.projectId];
    }
    get phase() {
        return (0, $XoImS.default).modelsById[this.phaseId];
    }
    get month() {
        return this.date ? (0, $4hBm1.format)(this.date, "yyyy-MM") : null;
    }
    get week() {
        return this.date ? (0, $4hBm1.format)(this.date, "RRRR-II") : null;
    }
}, $d08ac649a460e0c0$var$_descriptor = $d08ac649a460e0c0$var$_applyDecoratedDescriptor($d08ac649a460e0c0$var$_class.prototype, "projectId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d08ac649a460e0c0$var$_descriptor2 = $d08ac649a460e0c0$var$_applyDecoratedDescriptor($d08ac649a460e0c0$var$_class.prototype, "phaseId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d08ac649a460e0c0$var$_descriptor3 = $d08ac649a460e0c0$var$_applyDecoratedDescriptor($d08ac649a460e0c0$var$_class.prototype, "date", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Date();
    }
}), $d08ac649a460e0c0$var$_descriptor4 = $d08ac649a460e0c0$var$_applyDecoratedDescriptor($d08ac649a460e0c0$var$_class.prototype, "label", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "";
    }
}), $d08ac649a460e0c0$var$_applyDecoratedDescriptor($d08ac649a460e0c0$var$_class.prototype, "project", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($d08ac649a460e0c0$var$_class.prototype, "project"), $d08ac649a460e0c0$var$_class.prototype), $d08ac649a460e0c0$var$_applyDecoratedDescriptor($d08ac649a460e0c0$var$_class.prototype, "phase", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($d08ac649a460e0c0$var$_class.prototype, "phase"), $d08ac649a460e0c0$var$_class.prototype), $d08ac649a460e0c0$var$_applyDecoratedDescriptor($d08ac649a460e0c0$var$_class.prototype, "month", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($d08ac649a460e0c0$var$_class.prototype, "month"), $d08ac649a460e0c0$var$_class.prototype), $d08ac649a460e0c0$var$_applyDecoratedDescriptor($d08ac649a460e0c0$var$_class.prototype, "week", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($d08ac649a460e0c0$var$_class.prototype, "week"), $d08ac649a460e0c0$var$_class.prototype), $d08ac649a460e0c0$var$_class);
var $d08ac649a460e0c0$export$2e2bcd8739ae039 = $d08ac649a460e0c0$var$MilestoneModel;

});



parcelRegister("6un1H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b9768011e91ef30$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $Ds2V9 = parcelRequire("Ds2V9");
var $4b9768011e91ef30$var$_class, $4b9768011e91ef30$var$_descriptor;
function $4b9768011e91ef30$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $4b9768011e91ef30$var$_defineProperty(e, r, t) {
    return (r = $4b9768011e91ef30$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4b9768011e91ef30$var$_toPropertyKey(t) {
    var i = $4b9768011e91ef30$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $4b9768011e91ef30$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $4b9768011e91ef30$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $4b9768011e91ef30$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $4b9768011e91ef30$var$FetchStoreClass = ($4b9768011e91ef30$var$_class = class FetchStoreClass {
    constructor(){
        $4b9768011e91ef30$var$_initializerDefineProperty(this, "lookup", $4b9768011e91ef30$var$_descriptor, this);
        $4b9768011e91ef30$var$_defineProperty(this, "getResponse", (0, $Ds2V9.computedFn)((id)=>{
            return this.lookup[id];
        }));
        (0, $4JcCM.makeObservable)(this);
    }
    setResponse(id, response) {
        this.lookup[id] = response;
    }
    deleteResponse(id) {
        delete this.lookup[id];
    }
}, $4b9768011e91ef30$var$_descriptor = $4b9768011e91ef30$var$_applyDecoratedDescriptor($4b9768011e91ef30$var$_class.prototype, "lookup", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $4b9768011e91ef30$var$_applyDecoratedDescriptor($4b9768011e91ef30$var$_class.prototype, "setResponse", [
    (0, $4JcCM.action)
], Object.getOwnPropertyDescriptor($4b9768011e91ef30$var$_class.prototype, "setResponse"), $4b9768011e91ef30$var$_class.prototype), $4b9768011e91ef30$var$_applyDecoratedDescriptor($4b9768011e91ef30$var$_class.prototype, "deleteResponse", [
    (0, $4JcCM.action)
], Object.getOwnPropertyDescriptor($4b9768011e91ef30$var$_class.prototype, "deleteResponse"), $4b9768011e91ef30$var$_class.prototype), $4b9768011e91ef30$var$_class);
var $4b9768011e91ef30$export$2e2bcd8739ae039 = new $4b9768011e91ef30$var$FetchStoreClass();

});


parcelRegister("eOTWQ", function(module, exports) {

(function(global, factory) {
    factory(module.exports, (parcelRequire("jbmdS")));
})(module.exports, function(exports1, React) {
    "use strict";
    function _interopNamespace(e) {
        if (e && e.__esModule) return e;
        var n = Object.create(null);
        if (e) Object.keys(e).forEach(function(k) {
            if (k !== "default") {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function() {
                        return e[k];
                    }
                });
            }
        });
        n["default"] = e;
        return Object.freeze(n);
    }
    var React__namespace = /*#__PURE__*/ _interopNamespace(React);
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf(subClass, superClass);
    }
    var changedArray = function changedArray(a, b) {
        if (a === void 0) a = [];
        if (b === void 0) b = [];
        return a.length !== b.length || a.some(function(item, index) {
            return !Object.is(item, b[index]);
        });
    };
    var initialState = {
        error: null
    };
    var ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
        _inheritsLoose(ErrorBoundary, _React$Component);
        function ErrorBoundary() {
            var _this;
            for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(_args)) || this;
            _this.state = initialState;
            _this.resetErrorBoundary = function() {
                var _this$props;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                _this.props.onReset == null || (_this$props = _this.props).onReset.apply(_this$props, args);
                _this.reset();
            };
            return _this;
        }
        ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
            return {
                error: error
            };
        };
        var _proto = ErrorBoundary.prototype;
        _proto.reset = function reset() {
            this.setState(initialState);
        };
        _proto.componentDidCatch = function componentDidCatch(error, info) {
            var _this$props$onError, _this$props2;
            (_this$props$onError = (_this$props2 = this.props).onError) == null || _this$props$onError.call(_this$props2, error, info);
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            var error = this.state.error;
            var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
            // happens to *also* be in the resetKeys array, we'd end up resetting
            // the error boundary immediately. This would likely trigger a second
            // error to be thrown.
            // So we make sure that we don't check the resetKeys on the first call
            // of cDU after the error is set
            if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
                var _this$props$onResetKe, _this$props3;
                (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null || _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
                this.reset();
            }
        };
        _proto.render = function render() {
            var error = this.state.error;
            var _this$props4 = this.props, fallbackRender = _this$props4.fallbackRender, FallbackComponent = _this$props4.FallbackComponent, fallback = _this$props4.fallback;
            if (error !== null) {
                var _props = {
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                };
                if (/*#__PURE__*/ React__namespace.isValidElement(fallback)) return fallback;
                else if (typeof fallbackRender === "function") return fallbackRender(_props);
                else if (FallbackComponent) return /*#__PURE__*/ React__namespace.createElement(FallbackComponent, _props);
                else throw new Error("react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop");
            }
            return this.props.children;
        };
        return ErrorBoundary;
    }(React__namespace.Component);
    function withErrorBoundary(Component, errorBoundaryProps) {
        var Wrapped = function Wrapped(props) {
            return /*#__PURE__*/ React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/ React__namespace.createElement(Component, props));
        }; // Format for display in DevTools
        var name = Component.displayName || Component.name || "Unknown";
        Wrapped.displayName = "withErrorBoundary(" + name + ")";
        return Wrapped;
    }
    function useErrorHandler(givenError) {
        var _React$useState = React__namespace.useState(null), error = _React$useState[0], setError = _React$useState[1];
        if (givenError != null) throw givenError;
        if (error != null) throw error;
        return setError;
    }
    /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */ exports1.ErrorBoundary = ErrorBoundary;
    exports1.useErrorHandler = useErrorHandler;
    exports1.withErrorBoundary = withErrorBoundary;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});

});

parcelRegister("kJfnW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f173f1ca61e7c282$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("jbmdS");
var $f173f1ca61e7c282$export$2e2bcd8739ae039 = ()=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
            className: "fa fa-spinner fa-spin",
            style: {
                margin: 0
            }
        })
    });
};

});


parcelRegister("6d1V1", function(module, exports) {

$parcel$export(module.exports, "useMediaQuery", function () { return $485572003ab4b49c$export$32d5543ab307c01; });

var $jbmdS = parcelRequire("jbmdS");
function $485572003ab4b49c$var$queriesDidChange(prevQueries, nextQueries) {
    if (nextQueries === prevQueries) return false;
    const nextQueriesArr = Object.values(nextQueries);
    const prevQueriesArr = Object.values(prevQueries);
    if (nextQueriesArr.length !== prevQueriesArr.length) return true;
    if (nextQueriesArr.some((q, i)=>q !== prevQueriesArr[i])) return true;
    const prevKeys = Object.keys(prevQueries);
    return Object.keys(nextQueries).some((n, i)=>n !== prevKeys[i]);
}
function $485572003ab4b49c$var$_ref(curr, key) {
    curr.matches[key] = false;
    curr.mediaQueries[key] = {};
    return curr;
}
function $485572003ab4b49c$var$init(queries) {
    const queryKeys = Object.keys(queries);
    /* istanbul ignore next */ if (typeof window === "undefined") return queryKeys.reduce($485572003ab4b49c$var$_ref, {
        mediaQueries: {},
        matches: {}
    });
    return queryKeys.reduce((state, name)=>{
        const mql = window.matchMedia(queries[name]);
        state.mediaQueries[name] = mql;
        state.matches[name] = mql.matches;
        return state;
    }, {
        mediaQueries: {},
        matches: {}
    });
}
function $485572003ab4b49c$var$reducer(state, action) {
    function _ref2(prev, key) {
        prev[key] = state.mediaQueries[key].matches;
        return prev;
    }
    switch(action.type){
        case "updateMatches":
            return {
                matches: Object.keys(state.mediaQueries).reduce(_ref2, {}),
                mediaQueries: state.mediaQueries
            };
        case "setQueries":
            return $485572003ab4b49c$var$init(action.queries);
    }
}
function $485572003ab4b49c$export$1050778cf3fc02c3(queryMap) {
    const prevQueries = $jbmdS.useRef(queryMap);
    const [state, dispatch] = $jbmdS.useReducer($485572003ab4b49c$var$reducer, queryMap, $485572003ab4b49c$var$init);
    $jbmdS.useEffect(()=>{
        if ($485572003ab4b49c$var$queriesDidChange(queryMap, prevQueries.current)) {
            dispatch({
                type: "setQueries",
                queries: queryMap
            });
            prevQueries.current = queryMap;
        }
    }, [
        queryMap
    ]);
    function _ref3() {
        return dispatch({
            type: "updateMatches"
        });
    }
    function _ref4(mq) {
        const callback = _ref3;
        if (typeof mq.addListener !== "undefined") mq.addListener(callback);
        else mq.addEventListener("change", callback);
        return callback;
    }
    $jbmdS.useEffect(()=>{
        const queries = Object.values(state.mediaQueries);
        const callbacks = queries.map(_ref4);
        function _ref5(mq, i) {
            if (typeof mq.addListener !== "undefined") mq.removeListener(callbacks[i]);
            else mq.removeEventListener("change", callbacks[i]);
        }
        return ()=>{
            queries.forEach(_ref5);
        };
    }, [
        state.mediaQueries
    ]);
    const { matches: matches } = state;
    const matchValues = $jbmdS.useMemo(()=>Object.values(matches), [
        matches
    ]);
    return {
        matches: matches,
        matchesAny: matchValues.some(Boolean),
        matchesAll: matchValues.length > 0 && matchValues.every(Boolean)
    };
}
function $485572003ab4b49c$export$32d5543ab307c01(query) {
    return $485572003ab4b49c$export$1050778cf3fc02c3($485572003ab4b49c$var$getObj(query)).matchesAll;
}
const $485572003ab4b49c$var$cache = {};
function $485572003ab4b49c$var$getObj(query) {
    if ($485572003ab4b49c$var$cache[query] === void 0) $485572003ab4b49c$var$cache[query] = {
        default: query
    };
    return $485572003ab4b49c$var$cache[query];
}

});

parcelRegister("1fkTL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e87672b865d20c1$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");

var $bJYb4 = parcelRequire("bJYb4");
function $0e87672b865d20c1$var$useHover(target, options = {}) {
    const { enterDelay: enterDelay, leaveDelay: leaveDelay } = options;
    const timeout = $jbmdS.useRef();
    const [hovering, setHovering] = $jbmdS.useState(false);
    const toggle = (which)=>{
        if (!$0e87672b865d20c1$var$canHover()) return;
        const delay = which ? enterDelay : leaveDelay;
        window.clearTimeout(timeout.current);
        function _ref() {
            return setHovering(which);
        }
        if (delay) timeout.current = window.setTimeout(_ref, delay);
        else setHovering(which);
    };
    (0, $bJYb4.default)(target, "mouseenter", ()=>toggle(true));
    (0, $bJYb4.default)(target, "mouseleave", ()=>toggle(false)); // Cleans up timeout on unmount
    function _ref2() {
        window.clearTimeout(timeout.current);
    }
    $jbmdS.useEffect(()=>_ref2, []);
    return hovering;
}
const $0e87672b865d20c1$var$canHover = ()=>typeof window !== "undefined" ? !window.matchMedia("(hover: none)").matches : false;
var $0e87672b865d20c1$export$2e2bcd8739ae039 = $0e87672b865d20c1$var$useHover;

});
parcelRegister("bJYb4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88c293b52d0c3111$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");
function $88c293b52d0c3111$var$useEvent(target, type, listener, cleanup) {
    const storedListener = $jbmdS.useRef(listener);
    const storedCleanup = $jbmdS.useRef(cleanup);
    $jbmdS.useEffect(()=>{
        storedListener.current = listener;
        storedCleanup.current = cleanup;
    });
    $jbmdS.useEffect(()=>{
        const targetEl = target && "current" in target ? target.current : target;
        if (!targetEl) return;
        let didUnsubscribe = 0;
        function listener(...args) {
            if (didUnsubscribe) return;
            storedListener.current.apply(this, args);
        }
        targetEl.addEventListener(type, listener);
        const cleanup = storedCleanup.current;
        return ()=>{
            didUnsubscribe = 1;
            targetEl.removeEventListener(type, listener);
            cleanup && cleanup();
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        target,
        type
    ]);
}
var $88c293b52d0c3111$export$2e2bcd8739ae039 = $88c293b52d0c3111$var$useEvent;

});


parcelRegister("d8zxI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $990797cb2c260fa1$export$2e2bcd8739ae039; });
/* eslint-disable no-return-assign */ /* eslint-disable no-underscore-dangle */ parcelRequire("aYGQD");
var $d9xTg = parcelRequire("d9xTg");

var $crgnS = parcelRequire("crgnS");

var $3R0HB = parcelRequire("3R0HB");
const $990797cb2c260fa1$var$ResizeObserver = typeof window !== "undefined" && "ResizeObserver" in window ? window.ResizeObserver : (0, $d9xTg.ResizeObserver);
/**
 * A React hook that fires a callback whenever ResizeObserver detects a change to its size
 *
 * @param target A React ref created by `useRef()` or an HTML element
 * @param callback Invoked with a single `ResizeObserverEntry` any time
 *   the `target` resizes
 */ function $990797cb2c260fa1$var$_ref() {}
function $990797cb2c260fa1$var$useResizeObserver(target, callback) {
    const resizeObserver = $990797cb2c260fa1$var$getResizeObserver();
    const storedCallback = (0, $3R0HB.default)(callback);
    (0, $crgnS.default)(()=>{
        let didUnsubscribe = false;
        const targetEl = target && "current" in target ? target.current : target;
        if (!targetEl) return $990797cb2c260fa1$var$_ref;
        function cb(entry, observer) {
            if (didUnsubscribe) return;
            storedCallback.current(entry, observer);
        }
        resizeObserver.subscribe(targetEl, cb);
        return ()=>{
            didUnsubscribe = true;
            resizeObserver.unsubscribe(targetEl, cb);
        };
    }, [
        target,
        resizeObserver,
        storedCallback
    ]);
    return resizeObserver.observer;
}
function $990797cb2c260fa1$var$createResizeObserver() {
    let ticking = false;
    let allEntries = [];
    const callbacks = new Map();
    const observer = new $990797cb2c260fa1$var$ResizeObserver((entries, obs)=>{
        allEntries = allEntries.concat(entries);
        function _ref2() {
            const triggered = new Set();
            for(let i = 0; i < allEntries.length; i++){
                if (triggered.has(allEntries[i].target)) continue;
                triggered.add(allEntries[i].target);
                const cbs = callbacks.get(allEntries[i].target);
                cbs === null || cbs === void 0 || cbs.forEach((cb)=>cb(allEntries[i], obs));
            }
            allEntries = [];
            ticking = false;
        }
        if (!ticking) window.requestAnimationFrame(_ref2);
        ticking = true;
    });
    return {
        observer: observer,
        subscribe (target, callback) {
            var _callbacks$get;
            observer.observe(target);
            const cbs = (_callbacks$get = callbacks.get(target)) !== null && _callbacks$get !== void 0 ? _callbacks$get : [];
            cbs.push(callback);
            callbacks.set(target, cbs);
        },
        unsubscribe (target, callback) {
            var _callbacks$get2;
            const cbs = (_callbacks$get2 = callbacks.get(target)) !== null && _callbacks$get2 !== void 0 ? _callbacks$get2 : [];
            if (cbs.length === 1) {
                observer.unobserve(target);
                callbacks.delete(target);
                return;
            }
            const cbIndex = cbs.indexOf(callback);
            if (cbIndex !== -1) cbs.splice(cbIndex, 1);
            callbacks.set(target, cbs);
        }
    };
}
let $990797cb2c260fa1$var$_resizeObserver;
const $990797cb2c260fa1$var$getResizeObserver = ()=>!$990797cb2c260fa1$var$_resizeObserver ? $990797cb2c260fa1$var$_resizeObserver = $990797cb2c260fa1$var$createResizeObserver() : $990797cb2c260fa1$var$_resizeObserver;
var $990797cb2c260fa1$export$2e2bcd8739ae039 = $990797cb2c260fa1$var$useResizeObserver;

});
parcelRegister("aYGQD", function(module, exports) {

$parcel$export(module.exports, "ResizeObserver", function () { return (parcelRequire("d9xTg")).ResizeObserver; });

var $d9xTg = parcelRequire("d9xTg");

var $gcTCz = parcelRequire("gcTCz");

var $atxmV = parcelRequire("atxmV");

});
parcelRegister("d9xTg", function(module, exports) {

$parcel$export(module.exports, "ResizeObserver", function () { return $9936678b4ca17211$export$9caf76241ca21a11; });

var $1bDlx = parcelRequire("1bDlx");

var $hVKOW = parcelRequire("hVKOW");
var $9936678b4ca17211$export$9caf76241ca21a11 = function() {
    function ResizeObserver(callback) {
        if (arguments.length === 0) throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
        if (typeof callback !== "function") throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
        (0, $1bDlx.ResizeObserverController).connect(this, callback);
    }
    ResizeObserver.prototype.observe = function(target, options) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, $hVKOW.isElement)(target)) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, $1bDlx.ResizeObserverController).observe(this, target, options);
    };
    ResizeObserver.prototype.unobserve = function(target) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, $hVKOW.isElement)(target)) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, $1bDlx.ResizeObserverController).unobserve(this, target);
    };
    ResizeObserver.prototype.disconnect = function() {
        (0, $1bDlx.ResizeObserverController).disconnect(this);
    };
    ResizeObserver.toString = function() {
        return "function ResizeObserver () { [polyfill code] }";
    };
    return ResizeObserver;
}();

});
parcelRegister("1bDlx", function(module, exports) {

$parcel$export(module.exports, "ResizeObserverController", function () { return $0dd556e971eabb65$export$ed99c5bafbaf8300; });

var $4u1FW = parcelRequire("4u1FW");

var $6xdiG = parcelRequire("6xdiG");

var $fdSNw = parcelRequire("fdSNw");

var $4cnD7 = parcelRequire("4cnD7");
var $0dd556e971eabb65$var$observerMap = new WeakMap();
var $0dd556e971eabb65$var$getObservationIndex = function(observationTargets, target) {
    for(var i = 0; i < observationTargets.length; i += 1){
        if (observationTargets[i].target === target) return i;
    }
    return -1;
};
var $0dd556e971eabb65$export$ed99c5bafbaf8300 = function() {
    function ResizeObserverController() {}
    ResizeObserverController.connect = function(resizeObserver, callback) {
        var detail = new (0, $fdSNw.ResizeObserverDetail)(resizeObserver, callback);
        $0dd556e971eabb65$var$observerMap.set(resizeObserver, detail);
    };
    ResizeObserverController.observe = function(resizeObserver, target, options) {
        var detail = $0dd556e971eabb65$var$observerMap.get(resizeObserver);
        var firstObservation = detail.observationTargets.length === 0;
        if ($0dd556e971eabb65$var$getObservationIndex(detail.observationTargets, target) < 0) {
            firstObservation && (0, $4cnD7.resizeObservers).push(detail);
            detail.observationTargets.push(new (0, $6xdiG.ResizeObservation)(target, options && options.box));
            (0, $4u1FW.updateCount)(1);
            (0, $4u1FW.scheduler).schedule();
        }
    };
    ResizeObserverController.unobserve = function(resizeObserver, target) {
        var detail = $0dd556e971eabb65$var$observerMap.get(resizeObserver);
        var index = $0dd556e971eabb65$var$getObservationIndex(detail.observationTargets, target);
        var lastObservation = detail.observationTargets.length === 1;
        if (index >= 0) {
            lastObservation && (0, $4cnD7.resizeObservers).splice((0, $4cnD7.resizeObservers).indexOf(detail), 1);
            detail.observationTargets.splice(index, 1);
            (0, $4u1FW.updateCount)(-1);
        }
    };
    ResizeObserverController.disconnect = function(resizeObserver) {
        var _this = this;
        var detail = $0dd556e971eabb65$var$observerMap.get(resizeObserver);
        detail.observationTargets.slice().forEach(function(ot) {
            return _this.unobserve(resizeObserver, ot.target);
        });
        detail.activeTargets.splice(0, detail.activeTargets.length);
    };
    return ResizeObserverController;
}();

});
parcelRegister("4u1FW", function(module, exports) {

$parcel$export(module.exports, "scheduler", function () { return $343b4375501ea513$export$d30788f2c20241cd; });
$parcel$export(module.exports, "updateCount", function () { return $343b4375501ea513$export$1f18a74d42722835; });

var $kmt9x = parcelRequire("kmt9x");

var $2BXQo = parcelRequire("2BXQo");

var $kL10O = parcelRequire("kL10O");
var $343b4375501ea513$var$watching = 0;
var $343b4375501ea513$var$isWatching = function() {
    return !!$343b4375501ea513$var$watching;
};
var $343b4375501ea513$var$CATCH_PERIOD = 250;
var $343b4375501ea513$var$observerConfig = {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true
};
var $343b4375501ea513$var$events = [
    "resize",
    "load",
    "transitionend",
    "animationend",
    "animationstart",
    "animationiteration",
    "keyup",
    "keydown",
    "mouseup",
    "mousedown",
    "mouseover",
    "mouseout",
    "blur",
    "focus"
];
var $343b4375501ea513$var$time = function(timeout) {
    if (timeout === void 0) timeout = 0;
    return Date.now() + timeout;
};
var $343b4375501ea513$var$scheduled = false;
var $343b4375501ea513$var$Scheduler = function() {
    function Scheduler() {
        var _this = this;
        this.stopped = true;
        this.listener = function() {
            return _this.schedule();
        };
    }
    Scheduler.prototype.run = function(timeout) {
        var _this = this;
        if (timeout === void 0) timeout = $343b4375501ea513$var$CATCH_PERIOD;
        if ($343b4375501ea513$var$scheduled) return;
        $343b4375501ea513$var$scheduled = true;
        var until = $343b4375501ea513$var$time(timeout);
        (0, $kL10O.queueResizeObserver)(function() {
            var elementsHaveResized = false;
            try {
                elementsHaveResized = (0, $kmt9x.process)();
            } finally{
                $343b4375501ea513$var$scheduled = false;
                timeout = until - $343b4375501ea513$var$time();
                if (!$343b4375501ea513$var$isWatching()) return;
                if (elementsHaveResized) _this.run(1000);
                else if (timeout > 0) _this.run(timeout);
                else _this.start();
            }
        });
    };
    Scheduler.prototype.schedule = function() {
        this.stop();
        this.run();
    };
    Scheduler.prototype.observe = function() {
        var _this = this;
        var cb = function() {
            return _this.observer && _this.observer.observe(document.body, $343b4375501ea513$var$observerConfig);
        };
        document.body ? cb() : (0, $2BXQo.global).addEventListener("DOMContentLoaded", cb);
    };
    Scheduler.prototype.start = function() {
        var _this = this;
        if (this.stopped) {
            this.stopped = false;
            this.observer = new MutationObserver(this.listener);
            this.observe();
            $343b4375501ea513$var$events.forEach(function(name) {
                return (0, $2BXQo.global).addEventListener(name, _this.listener, true);
            });
        }
    };
    Scheduler.prototype.stop = function() {
        var _this = this;
        if (!this.stopped) {
            this.observer && this.observer.disconnect();
            $343b4375501ea513$var$events.forEach(function(name) {
                return (0, $2BXQo.global).removeEventListener(name, _this.listener, true);
            });
            this.stopped = true;
        }
    };
    return Scheduler;
}();
var $343b4375501ea513$export$d30788f2c20241cd = new $343b4375501ea513$var$Scheduler();
var $343b4375501ea513$export$1f18a74d42722835 = function(n) {
    !$343b4375501ea513$var$watching && n > 0 && $343b4375501ea513$export$d30788f2c20241cd.start();
    $343b4375501ea513$var$watching += n;
    !$343b4375501ea513$var$watching && $343b4375501ea513$export$d30788f2c20241cd.stop();
};

});
parcelRegister("kmt9x", function(module, exports) {

$parcel$export(module.exports, "process", function () { return $ed2c79dd86d8f43b$export$e54fe5b0f43758f7; });

var $2l75D = parcelRequire("2l75D");

var $66suI = parcelRequire("66suI");

var $dctLw = parcelRequire("dctLw");

var $cE9wa = parcelRequire("cE9wa");

var $bGNUY = parcelRequire("bGNUY");
var $ed2c79dd86d8f43b$export$e54fe5b0f43758f7 = function() {
    var depth = 0;
    (0, $bGNUY.gatherActiveObservationsAtDepth)(depth);
    while((0, $2l75D.hasActiveObservations)()){
        depth = (0, $cE9wa.broadcastActiveObservations)();
        (0, $bGNUY.gatherActiveObservationsAtDepth)(depth);
    }
    if ((0, $66suI.hasSkippedObservations)()) (0, $dctLw.deliverResizeLoopError)();
    return depth > 0;
};

});
parcelRegister("2l75D", function(module, exports) {

$parcel$export(module.exports, "hasActiveObservations", function () { return $1b430ad5302d68eb$export$63c81bd924f89474; });

var $4cnD7 = parcelRequire("4cnD7");
var $1b430ad5302d68eb$export$63c81bd924f89474 = function() {
    return (0, $4cnD7.resizeObservers).some(function(ro) {
        return ro.activeTargets.length > 0;
    });
};

});
parcelRegister("4cnD7", function(module, exports) {

$parcel$export(module.exports, "resizeObservers", function () { return $30ea9ccf6b8dfe7c$export$402e76927ebf6a24; });
var $30ea9ccf6b8dfe7c$export$402e76927ebf6a24 = [];

});


parcelRegister("66suI", function(module, exports) {

$parcel$export(module.exports, "hasSkippedObservations", function () { return $47196801b2be3ef3$export$8ca35300535e324d; });

var $4cnD7 = parcelRequire("4cnD7");
var $47196801b2be3ef3$export$8ca35300535e324d = function() {
    return (0, $4cnD7.resizeObservers).some(function(ro) {
        return ro.skippedTargets.length > 0;
    });
};

});

parcelRegister("dctLw", function(module, exports) {

$parcel$export(module.exports, "deliverResizeLoopError", function () { return $99c37c263a022bbb$export$888cb69481582149; });
var $99c37c263a022bbb$var$msg = "ResizeObserver loop completed with undelivered notifications.";
var $99c37c263a022bbb$export$888cb69481582149 = function() {
    var event;
    if (typeof ErrorEvent === "function") event = new ErrorEvent("error", {
        message: $99c37c263a022bbb$var$msg
    });
    else {
        event = document.createEvent("Event");
        event.initEvent("error", false, false);
        event.message = $99c37c263a022bbb$var$msg;
    }
    window.dispatchEvent(event);
};

});

parcelRegister("cE9wa", function(module, exports) {

$parcel$export(module.exports, "broadcastActiveObservations", function () { return $93509a8328add0e7$export$9cac928141e5443b; });

var $4cnD7 = parcelRequire("4cnD7");

var $gcTCz = parcelRequire("gcTCz");

var $aB4rg = parcelRequire("aB4rg");

var $bpIfz = parcelRequire("bpIfz");
var $93509a8328add0e7$export$9cac928141e5443b = function() {
    var shallowestDepth = Infinity;
    var callbacks = [];
    (0, $4cnD7.resizeObservers).forEach(function processObserver(ro) {
        if (ro.activeTargets.length === 0) return;
        var entries = [];
        ro.activeTargets.forEach(function processTarget(ot) {
            var entry = new (0, $gcTCz.ResizeObserverEntry)(ot.target);
            var targetDepth = (0, $aB4rg.calculateDepthForNode)(ot.target);
            entries.push(entry);
            ot.lastReportedSize = (0, $bpIfz.calculateBoxSize)(ot.target, ot.observedBox);
            if (targetDepth < shallowestDepth) shallowestDepth = targetDepth;
        });
        callbacks.push(function resizeObserverCallback() {
            ro.callback.call(ro.observer, entries, ro.observer);
        });
        ro.activeTargets.splice(0, ro.activeTargets.length);
    });
    for(var _i = 0, callbacks_1 = callbacks; _i < callbacks_1.length; _i++){
        var callback = callbacks_1[_i];
        callback();
    }
    return shallowestDepth;
};

});
parcelRegister("gcTCz", function(module, exports) {

$parcel$export(module.exports, "ResizeObserverEntry", function () { return $bcc8e98a72aee1b8$export$226159b441fc89f8; });

var $bpIfz = parcelRequire("bpIfz");

var $fwp7f = parcelRequire("fwp7f");
var $bcc8e98a72aee1b8$export$226159b441fc89f8 = function() {
    function ResizeObserverEntry(target) {
        var boxes = (0, $bpIfz.calculateBoxSizes)(target);
        this.target = target;
        this.contentRect = boxes.contentRect;
        this.borderBoxSize = (0, $fwp7f.freeze)([
            boxes.borderBoxSize
        ]);
        this.contentBoxSize = (0, $fwp7f.freeze)([
            boxes.contentBoxSize
        ]);
        this.devicePixelContentBoxSize = (0, $fwp7f.freeze)([
            boxes.devicePixelContentBoxSize
        ]);
    }
    return ResizeObserverEntry;
}();

});
parcelRegister("bpIfz", function(module, exports) {

$parcel$export(module.exports, "calculateBoxSizes", function () { return $84f45aa916ed640a$export$504d039a9c501c94; });
$parcel$export(module.exports, "calculateBoxSize", function () { return $84f45aa916ed640a$export$1a78030b04106bdb; });

var $d4GGx = parcelRequire("d4GGx");

var $atxmV = parcelRequire("atxmV");

var $bSqyI = parcelRequire("bSqyI");

var $hVKOW = parcelRequire("hVKOW");

var $fwp7f = parcelRequire("fwp7f");

var $2BXQo = parcelRequire("2BXQo");
var $84f45aa916ed640a$var$cache = new WeakMap();
var $84f45aa916ed640a$var$scrollRegexp = /auto|scroll/;
var $84f45aa916ed640a$var$verticalRegexp = /^tb|vertical/;
var $84f45aa916ed640a$var$IE = /msie|trident/i.test((0, $2BXQo.global).navigator && (0, $2BXQo.global).navigator.userAgent);
var $84f45aa916ed640a$var$parseDimension = function(pixel) {
    return parseFloat(pixel || "0");
};
var $84f45aa916ed640a$var$size = function(inlineSize, blockSize, switchSizes) {
    if (inlineSize === void 0) inlineSize = 0;
    if (blockSize === void 0) blockSize = 0;
    if (switchSizes === void 0) switchSizes = false;
    return new (0, $atxmV.ResizeObserverSize)((switchSizes ? blockSize : inlineSize) || 0, (switchSizes ? inlineSize : blockSize) || 0);
};
var $84f45aa916ed640a$var$zeroBoxes = (0, $fwp7f.freeze)({
    devicePixelContentBoxSize: $84f45aa916ed640a$var$size(),
    borderBoxSize: $84f45aa916ed640a$var$size(),
    contentBoxSize: $84f45aa916ed640a$var$size(),
    contentRect: new (0, $bSqyI.DOMRectReadOnly)(0, 0, 0, 0)
});
var $84f45aa916ed640a$export$504d039a9c501c94 = function(target, forceRecalculation) {
    if (forceRecalculation === void 0) forceRecalculation = false;
    if ($84f45aa916ed640a$var$cache.has(target) && !forceRecalculation) return $84f45aa916ed640a$var$cache.get(target);
    if ((0, $hVKOW.isHidden)(target)) {
        $84f45aa916ed640a$var$cache.set(target, $84f45aa916ed640a$var$zeroBoxes);
        return $84f45aa916ed640a$var$zeroBoxes;
    }
    var cs = getComputedStyle(target);
    var svg = (0, $hVKOW.isSVG)(target) && target.ownerSVGElement && target.getBBox();
    var removePadding = !$84f45aa916ed640a$var$IE && cs.boxSizing === "border-box";
    var switchSizes = $84f45aa916ed640a$var$verticalRegexp.test(cs.writingMode || "");
    var canScrollVertically = !svg && $84f45aa916ed640a$var$scrollRegexp.test(cs.overflowY || "");
    var canScrollHorizontally = !svg && $84f45aa916ed640a$var$scrollRegexp.test(cs.overflowX || "");
    var paddingTop = svg ? 0 : $84f45aa916ed640a$var$parseDimension(cs.paddingTop);
    var paddingRight = svg ? 0 : $84f45aa916ed640a$var$parseDimension(cs.paddingRight);
    var paddingBottom = svg ? 0 : $84f45aa916ed640a$var$parseDimension(cs.paddingBottom);
    var paddingLeft = svg ? 0 : $84f45aa916ed640a$var$parseDimension(cs.paddingLeft);
    var borderTop = svg ? 0 : $84f45aa916ed640a$var$parseDimension(cs.borderTopWidth);
    var borderRight = svg ? 0 : $84f45aa916ed640a$var$parseDimension(cs.borderRightWidth);
    var borderBottom = svg ? 0 : $84f45aa916ed640a$var$parseDimension(cs.borderBottomWidth);
    var borderLeft = svg ? 0 : $84f45aa916ed640a$var$parseDimension(cs.borderLeftWidth);
    var horizontalPadding = paddingLeft + paddingRight;
    var verticalPadding = paddingTop + paddingBottom;
    var horizontalBorderArea = borderLeft + borderRight;
    var verticalBorderArea = borderTop + borderBottom;
    var horizontalScrollbarThickness = !canScrollHorizontally ? 0 : target.offsetHeight - verticalBorderArea - target.clientHeight;
    var verticalScrollbarThickness = !canScrollVertically ? 0 : target.offsetWidth - horizontalBorderArea - target.clientWidth;
    var widthReduction = removePadding ? horizontalPadding + horizontalBorderArea : 0;
    var heightReduction = removePadding ? verticalPadding + verticalBorderArea : 0;
    var contentWidth = svg ? svg.width : $84f45aa916ed640a$var$parseDimension(cs.width) - widthReduction - verticalScrollbarThickness;
    var contentHeight = svg ? svg.height : $84f45aa916ed640a$var$parseDimension(cs.height) - heightReduction - horizontalScrollbarThickness;
    var borderBoxWidth = contentWidth + horizontalPadding + verticalScrollbarThickness + horizontalBorderArea;
    var borderBoxHeight = contentHeight + verticalPadding + horizontalScrollbarThickness + verticalBorderArea;
    var boxes = (0, $fwp7f.freeze)({
        devicePixelContentBoxSize: $84f45aa916ed640a$var$size(Math.round(contentWidth * devicePixelRatio), Math.round(contentHeight * devicePixelRatio), switchSizes),
        borderBoxSize: $84f45aa916ed640a$var$size(borderBoxWidth, borderBoxHeight, switchSizes),
        contentBoxSize: $84f45aa916ed640a$var$size(contentWidth, contentHeight, switchSizes),
        contentRect: new (0, $bSqyI.DOMRectReadOnly)(paddingLeft, paddingTop, contentWidth, contentHeight)
    });
    $84f45aa916ed640a$var$cache.set(target, boxes);
    return boxes;
};
var $84f45aa916ed640a$export$1a78030b04106bdb = function(target, observedBox, forceRecalculation) {
    var _a = $84f45aa916ed640a$export$504d039a9c501c94(target, forceRecalculation), borderBoxSize = _a.borderBoxSize, contentBoxSize = _a.contentBoxSize, devicePixelContentBoxSize = _a.devicePixelContentBoxSize;
    switch(observedBox){
        case (0, $d4GGx.ResizeObserverBoxOptions).DEVICE_PIXEL_CONTENT_BOX:
            return devicePixelContentBoxSize;
        case (0, $d4GGx.ResizeObserverBoxOptions).BORDER_BOX:
            return borderBoxSize;
        default:
            return contentBoxSize;
    }
};

});
parcelRegister("d4GGx", function(module, exports) {

$parcel$export(module.exports, "ResizeObserverBoxOptions", function () { return $0274d9d892520d2d$export$416d111b83cd1483; });
var $0274d9d892520d2d$export$416d111b83cd1483;
(function(ResizeObserverBoxOptions) {
    ResizeObserverBoxOptions["BORDER_BOX"] = "border-box";
    ResizeObserverBoxOptions["CONTENT_BOX"] = "content-box";
    ResizeObserverBoxOptions["DEVICE_PIXEL_CONTENT_BOX"] = "device-pixel-content-box";
})($0274d9d892520d2d$export$416d111b83cd1483 || ($0274d9d892520d2d$export$416d111b83cd1483 = {}));

});

parcelRegister("atxmV", function(module, exports) {

$parcel$export(module.exports, "ResizeObserverSize", function () { return $7a067f25cc1e2436$export$c9ad8cdf6bbd331c; });

var $fwp7f = parcelRequire("fwp7f");
var $7a067f25cc1e2436$export$c9ad8cdf6bbd331c = function() {
    function ResizeObserverSize(inlineSize, blockSize) {
        this.inlineSize = inlineSize;
        this.blockSize = blockSize;
        (0, $fwp7f.freeze)(this);
    }
    return ResizeObserverSize;
}();

});
parcelRegister("fwp7f", function(module, exports) {

$parcel$export(module.exports, "freeze", function () { return $02ea899b70bee488$export$792f3d81ea979f55; });
var $02ea899b70bee488$export$792f3d81ea979f55 = function(obj) {
    return Object.freeze(obj);
};

});


parcelRegister("bSqyI", function(module, exports) {

$parcel$export(module.exports, "DOMRectReadOnly", function () { return $8a5956e9ed0e8617$export$51d7a67026f4e0b7; });

var $fwp7f = parcelRequire("fwp7f");
var $8a5956e9ed0e8617$export$51d7a67026f4e0b7 = function() {
    function DOMRectReadOnly(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.top = this.y;
        this.left = this.x;
        this.bottom = this.top + this.height;
        this.right = this.left + this.width;
        return (0, $fwp7f.freeze)(this);
    }
    DOMRectReadOnly.prototype.toJSON = function() {
        var _a = this, x = _a.x, y = _a.y, top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left, width = _a.width, height = _a.height;
        return {
            x: x,
            y: y,
            top: top,
            right: right,
            bottom: bottom,
            left: left,
            width: width,
            height: height
        };
    };
    DOMRectReadOnly.fromRect = function(rectangle) {
        return new DOMRectReadOnly(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
    };
    return DOMRectReadOnly;
}();

});

parcelRegister("hVKOW", function(module, exports) {

$parcel$export(module.exports, "isSVG", function () { return $d0dc1422ec66e282$export$165b39ed277223c2; });
$parcel$export(module.exports, "isHidden", function () { return $d0dc1422ec66e282$export$ee695c13482bb5dd; });
$parcel$export(module.exports, "isElement", function () { return $d0dc1422ec66e282$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isReplacedElement", function () { return $d0dc1422ec66e282$export$a6eb60f7e7c182ba; });
var $d0dc1422ec66e282$export$165b39ed277223c2 = function(target) {
    return target instanceof SVGElement && "getBBox" in target;
};
var $d0dc1422ec66e282$export$ee695c13482bb5dd = function(target) {
    if ($d0dc1422ec66e282$export$165b39ed277223c2(target)) {
        var _a = target.getBBox(), width = _a.width, height = _a.height;
        return !width && !height;
    }
    var _b = target, offsetWidth = _b.offsetWidth, offsetHeight = _b.offsetHeight;
    return !(offsetWidth || offsetHeight || target.getClientRects().length);
};
var $d0dc1422ec66e282$export$45a5e7f76e0caa8d = function(obj) {
    var _a;
    if (obj instanceof Element) return true;
    var scope = (_a = obj === null || obj === void 0 ? void 0 : obj.ownerDocument) === null || _a === void 0 ? void 0 : _a.defaultView;
    return !!(scope && obj instanceof scope.Element);
};
var $d0dc1422ec66e282$export$a6eb60f7e7c182ba = function(target) {
    switch(target.tagName){
        case "INPUT":
            if (target.type !== "image") break;
        case "VIDEO":
        case "AUDIO":
        case "EMBED":
        case "OBJECT":
        case "CANVAS":
        case "IFRAME":
        case "IMG":
            return true;
    }
    return false;
};

});

parcelRegister("2BXQo", function(module, exports) {

$parcel$export(module.exports, "global", function () { return $1e6d7546430c75c0$export$90b4d2ff6acb88af; });
var $1e6d7546430c75c0$export$90b4d2ff6acb88af = typeof window !== "undefined" ? window : {};

});



parcelRegister("aB4rg", function(module, exports) {

$parcel$export(module.exports, "calculateDepthForNode", function () { return $7b70cd897c42e551$export$f8c8e3b5da1f41d2; });

var $hVKOW = parcelRequire("hVKOW");
var $7b70cd897c42e551$export$f8c8e3b5da1f41d2 = function(node) {
    if ((0, $hVKOW.isHidden)(node)) return Infinity;
    var depth = 0;
    var parent = node.parentNode;
    while(parent){
        depth += 1;
        parent = parent.parentNode;
    }
    return depth;
};

});


parcelRegister("bGNUY", function(module, exports) {

$parcel$export(module.exports, "gatherActiveObservationsAtDepth", function () { return $882a569f75b2525e$export$9c17b8913a2a3572; });

var $4cnD7 = parcelRequire("4cnD7");

var $aB4rg = parcelRequire("aB4rg");
var $882a569f75b2525e$export$9c17b8913a2a3572 = function(depth) {
    (0, $4cnD7.resizeObservers).forEach(function processObserver(ro) {
        ro.activeTargets.splice(0, ro.activeTargets.length);
        ro.skippedTargets.splice(0, ro.skippedTargets.length);
        ro.observationTargets.forEach(function processTarget(ot) {
            if (ot.isActive()) {
                if ((0, $aB4rg.calculateDepthForNode)(ot.target) > depth) ro.activeTargets.push(ot);
                else ro.skippedTargets.push(ot);
            }
        });
    });
};

});


parcelRegister("kL10O", function(module, exports) {

$parcel$export(module.exports, "queueResizeObserver", function () { return $f1c8fb665fa4ad64$export$5755c7b572e34c6; });

var $ahG4N = parcelRequire("ahG4N");
var $f1c8fb665fa4ad64$export$5755c7b572e34c6 = function(cb) {
    (0, $ahG4N.queueMicroTask)(function ResizeObserver() {
        requestAnimationFrame(cb);
    });
};

});
parcelRegister("ahG4N", function(module, exports) {

$parcel$export(module.exports, "queueMicroTask", function () { return $77cc2160ce7a4b3a$export$4c995d4933c4abb; });
var $77cc2160ce7a4b3a$var$trigger;
var $77cc2160ce7a4b3a$var$callbacks = [];
var $77cc2160ce7a4b3a$var$notify = function() {
    return $77cc2160ce7a4b3a$var$callbacks.splice(0).forEach(function(cb) {
        return cb();
    });
};
var $77cc2160ce7a4b3a$export$4c995d4933c4abb = function(callback) {
    if (!$77cc2160ce7a4b3a$var$trigger) {
        var toggle_1 = 0;
        var el_1 = document.createTextNode("");
        var config = {
            characterData: true
        };
        new MutationObserver(function() {
            return $77cc2160ce7a4b3a$var$notify();
        }).observe(el_1, config);
        $77cc2160ce7a4b3a$var$trigger = function() {
            el_1.textContent = "".concat(toggle_1 ? toggle_1-- : toggle_1++);
        };
    }
    $77cc2160ce7a4b3a$var$callbacks.push(callback);
    $77cc2160ce7a4b3a$var$trigger();
};

});



parcelRegister("6xdiG", function(module, exports) {

$parcel$export(module.exports, "ResizeObservation", function () { return $4c20245461d5bb2e$export$fea412043713122; });

var $d4GGx = parcelRequire("d4GGx");

var $bpIfz = parcelRequire("bpIfz");

var $hVKOW = parcelRequire("hVKOW");
var $4c20245461d5bb2e$var$skipNotifyOnElement = function(target) {
    return !(0, $hVKOW.isSVG)(target) && !(0, $hVKOW.isReplacedElement)(target) && getComputedStyle(target).display === "inline";
};
var $4c20245461d5bb2e$export$fea412043713122 = function() {
    function ResizeObservation(target, observedBox) {
        this.target = target;
        this.observedBox = observedBox || (0, $d4GGx.ResizeObserverBoxOptions).CONTENT_BOX;
        this.lastReportedSize = {
            inlineSize: 0,
            blockSize: 0
        };
    }
    ResizeObservation.prototype.isActive = function() {
        var size = (0, $bpIfz.calculateBoxSize)(this.target, this.observedBox, true);
        if ($4c20245461d5bb2e$var$skipNotifyOnElement(this.target)) this.lastReportedSize = size;
        if (this.lastReportedSize.inlineSize !== size.inlineSize || this.lastReportedSize.blockSize !== size.blockSize) return true;
        return false;
    };
    return ResizeObservation;
}();

});

parcelRegister("fdSNw", function(module, exports) {

$parcel$export(module.exports, "ResizeObserverDetail", function () { return $b1529397c6885455$export$d86966e6e4bc97e1; });
var $b1529397c6885455$export$d86966e6e4bc97e1 = function() {
    function ResizeObserverDetail(resizeObserver, callback) {
        this.activeTargets = [];
        this.skippedTargets = [];
        this.observationTargets = [];
        this.observer = resizeObserver;
        this.callback = callback;
    }
    return ResizeObserverDetail;
}();

});




parcelRegister("crgnS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $90e4b731d36b7b3e$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");
const $90e4b731d36b7b3e$var$usePassiveLayoutEffect = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS)))[typeof document !== "undefined" && document.createElement !== void 0 ? "useLayoutEffect" : "useEffect"];
var $90e4b731d36b7b3e$export$2e2bcd8739ae039 = $90e4b731d36b7b3e$var$usePassiveLayoutEffect;

});

parcelRegister("3R0HB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ce6ddcc1b0a8b99$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");
const $2ce6ddcc1b0a8b99$var$useLatest = (current)=>{
    const storedValue = $jbmdS.useRef(current);
    $jbmdS.useEffect(()=>{
        storedValue.current = current;
    });
    return storedValue;
};
var $2ce6ddcc1b0a8b99$export$2e2bcd8739ae039 = $2ce6ddcc1b0a8b99$var$useLatest;

});


parcelRegister("4Jl8d", function(module, exports) {

$parcel$export(module.exports, "DragDropContext", function () { return $371bc1a9f05b39cc$export$237bd83162c14364; });
$parcel$export(module.exports, "Draggable", function () { return $371bc1a9f05b39cc$export$f2a139e5d18b9882; });
$parcel$export(module.exports, "Droppable", function () { return $371bc1a9f05b39cc$export$423ec2075359570a; });

var $jbmdS = parcelRequire("jbmdS");

var $jCNM0 = parcelRequire("jCNM0");

var $gJd8P = parcelRequire("gJd8P");

var $5Vhc6 = parcelRequire("5Vhc6");

var $g21f0 = parcelRequire("g21f0");

var $8rsfJ = parcelRequire("8rsfJ");

var $34S1T = parcelRequire("34S1T");

var $RIdqi = parcelRequire("RIdqi");

var $7i29i = parcelRequire("7i29i");
const $371bc1a9f05b39cc$var$isProduction$1 = true;
const $371bc1a9f05b39cc$var$spacesAndTabs = /[ \t]{2,}/g;
const $371bc1a9f05b39cc$var$lineStartWithSpaces = /^[ \t]*/gm;
const $371bc1a9f05b39cc$var$clean$2 = (value)=>value.replace($371bc1a9f05b39cc$var$spacesAndTabs, " ").replace($371bc1a9f05b39cc$var$lineStartWithSpaces, "").trim();
const $371bc1a9f05b39cc$var$getDevMessage = (message)=>$371bc1a9f05b39cc$var$clean$2(`
  %c@hello-pangea/dnd

  %c${$371bc1a9f05b39cc$var$clean$2(message)}

  %c\u{1F477}\u{200D} This is a development only message. It will be removed in production builds.
`);
const $371bc1a9f05b39cc$var$getFormattedMessage = (message)=>[
        $371bc1a9f05b39cc$var$getDevMessage(message),
        "color: #00C584; font-size: 1.2em; font-weight: bold;",
        "line-height: 1.5",
        "color: #723874;"
    ];
const $371bc1a9f05b39cc$var$isDisabledFlag = "__@hello-pangea/dnd-disable-dev-warnings";
function $371bc1a9f05b39cc$var$log(type, message) {
    if ($371bc1a9f05b39cc$var$isProduction$1) return;
    if (typeof window !== "undefined" && window[$371bc1a9f05b39cc$var$isDisabledFlag]) return;
    console[type](...$371bc1a9f05b39cc$var$getFormattedMessage(message));
}
const $371bc1a9f05b39cc$var$warning = $371bc1a9f05b39cc$var$log.bind(null, "warn");
const $371bc1a9f05b39cc$var$error = $371bc1a9f05b39cc$var$log.bind(null, "error");
function $371bc1a9f05b39cc$var$noop$2() {}
function $371bc1a9f05b39cc$var$getOptions(shared, fromBinding) {
    return {
        ...shared,
        ...fromBinding
    };
}
function $371bc1a9f05b39cc$var$bindEvents(el, bindings, sharedOptions) {
    const unbindings = bindings.map((binding)=>{
        const options = $371bc1a9f05b39cc$var$getOptions(sharedOptions, binding.options);
        el.addEventListener(binding.eventName, binding.fn, options);
        return function unbind() {
            el.removeEventListener(binding.eventName, binding.fn, options);
        };
    });
    return function unbindAll() {
        unbindings.forEach((unbind)=>{
            unbind();
        });
    };
}
const $371bc1a9f05b39cc$var$isProduction = true;
const $371bc1a9f05b39cc$var$prefix$1 = "Invariant failed";
class $371bc1a9f05b39cc$var$RbdInvariant extends Error {
}
$371bc1a9f05b39cc$var$RbdInvariant.prototype.toString = function toString() {
    return this.message;
};
function $371bc1a9f05b39cc$var$invariant(condition, message) {
    if ($371bc1a9f05b39cc$var$isProduction) throw new $371bc1a9f05b39cc$var$RbdInvariant($371bc1a9f05b39cc$var$prefix$1);
    else throw new $371bc1a9f05b39cc$var$RbdInvariant(`${$371bc1a9f05b39cc$var$prefix$1}: ${message || ""}`);
}
class $371bc1a9f05b39cc$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).Component {
    constructor(...args){
        super(...args);
        this.callbacks = null;
        this.unbind = $371bc1a9f05b39cc$var$noop$2;
        this.onWindowError = (event)=>{
            const callbacks = this.getCallbacks();
            if (callbacks.isDragging()) callbacks.tryAbort();
            const err = event.error;
            if (err instanceof $371bc1a9f05b39cc$var$RbdInvariant) event.preventDefault();
        };
        this.getCallbacks = ()=>{
            if (!this.callbacks) throw new Error("Unable to find AppCallbacks in <ErrorBoundary/>");
            return this.callbacks;
        };
        this.setCallbacks = (callbacks)=>{
            this.callbacks = callbacks;
        };
    }
    componentDidMount() {
        this.unbind = $371bc1a9f05b39cc$var$bindEvents(window, [
            {
                eventName: "error",
                fn: this.onWindowError
            }
        ]);
    }
    componentDidCatch(err) {
        if (err instanceof $371bc1a9f05b39cc$var$RbdInvariant) {
            this.setState({});
            return;
        }
        throw err;
    }
    componentWillUnmount() {
        this.unbind();
    }
    render() {
        return this.props.children(this.setCallbacks);
    }
}
const $371bc1a9f05b39cc$var$dragHandleUsageInstructions = `
  Press space bar to start a drag.
  When dragging you can use the arrow keys to move the item around and escape to cancel.
  Some screen readers may require you to be in focus mode or to use your pass through key
`;
const $371bc1a9f05b39cc$var$position = (index)=>index + 1;
const $371bc1a9f05b39cc$var$onDragStart = (start)=>`
  You have lifted an item in position ${$371bc1a9f05b39cc$var$position(start.source.index)}
`;
const $371bc1a9f05b39cc$var$withLocation = (source, destination)=>{
    const isInHomeList = source.droppableId === destination.droppableId;
    const startPosition = $371bc1a9f05b39cc$var$position(source.index);
    const endPosition = $371bc1a9f05b39cc$var$position(destination.index);
    if (isInHomeList) return `
      You have moved the item from position ${startPosition}
      to position ${endPosition}
    `;
    return `
    You have moved the item from position ${startPosition}
    in list ${source.droppableId}
    to list ${destination.droppableId}
    in position ${endPosition}
  `;
};
const $371bc1a9f05b39cc$var$withCombine = (id, source, combine)=>{
    const inHomeList = source.droppableId === combine.droppableId;
    if (inHomeList) return `
      The item ${id}
      has been combined with ${combine.draggableId}`;
    return `
      The item ${id}
      in list ${source.droppableId}
      has been combined with ${combine.draggableId}
      in list ${combine.droppableId}
    `;
};
const $371bc1a9f05b39cc$var$onDragUpdate = (update)=>{
    const location = update.destination;
    if (location) return $371bc1a9f05b39cc$var$withLocation(update.source, location);
    const combine = update.combine;
    if (combine) return $371bc1a9f05b39cc$var$withCombine(update.draggableId, update.source, combine);
    return "You are over an area that cannot be dropped on";
};
const $371bc1a9f05b39cc$var$returnedToStart = (source)=>`
  The item has returned to its starting position
  of ${$371bc1a9f05b39cc$var$position(source.index)}
`;
const $371bc1a9f05b39cc$var$onDragEnd = (result)=>{
    if (result.reason === "CANCEL") return `
      Movement cancelled.
      ${$371bc1a9f05b39cc$var$returnedToStart(result.source)}
    `;
    const location = result.destination;
    const combine = result.combine;
    if (location) return `
      You have dropped the item.
      ${$371bc1a9f05b39cc$var$withLocation(result.source, location)}
    `;
    if (combine) return `
      You have dropped the item.
      ${$371bc1a9f05b39cc$var$withCombine(result.draggableId, result.source, combine)}
    `;
    return `
    The item has been dropped while not over a drop area.
    ${$371bc1a9f05b39cc$var$returnedToStart(result.source)}
  `;
};
const $371bc1a9f05b39cc$var$preset = {
    dragHandleUsageInstructions: $371bc1a9f05b39cc$var$dragHandleUsageInstructions,
    onDragStart: $371bc1a9f05b39cc$var$onDragStart,
    onDragUpdate: $371bc1a9f05b39cc$var$onDragUpdate,
    onDragEnd: $371bc1a9f05b39cc$var$onDragEnd
};
const $371bc1a9f05b39cc$var$origin = {
    x: 0,
    y: 0
};
const $371bc1a9f05b39cc$var$add = (point1, point2)=>({
        x: point1.x + point2.x,
        y: point1.y + point2.y
    });
const $371bc1a9f05b39cc$var$subtract = (point1, point2)=>({
        x: point1.x - point2.x,
        y: point1.y - point2.y
    });
const $371bc1a9f05b39cc$var$isEqual$1 = (point1, point2)=>point1.x === point2.x && point1.y === point2.y;
const $371bc1a9f05b39cc$var$negate = (point)=>({
        x: point.x !== 0 ? -point.x : 0,
        y: point.y !== 0 ? -point.y : 0
    });
const $371bc1a9f05b39cc$var$patch = (line, value, otherValue = 0)=>{
    if (line === "x") return {
        x: value,
        y: otherValue
    };
    return {
        x: otherValue,
        y: value
    };
};
const $371bc1a9f05b39cc$var$distance = (point1, point2)=>Math.sqrt((point2.x - point1.x) ** 2 + (point2.y - point1.y) ** 2);
const $371bc1a9f05b39cc$var$closest$1 = (target, points)=>Math.min(...points.map((point)=>$371bc1a9f05b39cc$var$distance(target, point)));
const $371bc1a9f05b39cc$var$apply = (fn)=>(point)=>({
            x: fn(point.x),
            y: fn(point.y)
        });
var $371bc1a9f05b39cc$var$executeClip = (frame, subject)=>{
    const result = (0, $8rsfJ.getRect)({
        top: Math.max(subject.top, frame.top),
        right: Math.min(subject.right, frame.right),
        bottom: Math.min(subject.bottom, frame.bottom),
        left: Math.max(subject.left, frame.left)
    });
    if (result.width <= 0 || result.height <= 0) return null;
    return result;
};
const $371bc1a9f05b39cc$var$offsetByPosition = (spacing, point)=>({
        top: spacing.top + point.y,
        left: spacing.left + point.x,
        bottom: spacing.bottom + point.y,
        right: spacing.right + point.x
    });
const $371bc1a9f05b39cc$var$getCorners = (spacing)=>[
        {
            x: spacing.left,
            y: spacing.top
        },
        {
            x: spacing.right,
            y: spacing.top
        },
        {
            x: spacing.left,
            y: spacing.bottom
        },
        {
            x: spacing.right,
            y: spacing.bottom
        }
    ];
const $371bc1a9f05b39cc$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
const $371bc1a9f05b39cc$var$scroll$1 = (target, frame)=>{
    if (!frame) return target;
    return $371bc1a9f05b39cc$var$offsetByPosition(target, frame.scroll.diff.displacement);
};
const $371bc1a9f05b39cc$var$increase = (target, axis, withPlaceholder)=>{
    if (withPlaceholder && withPlaceholder.increasedBy) return {
        ...target,
        [axis.end]: target[axis.end] + withPlaceholder.increasedBy[axis.line]
    };
    return target;
};
const $371bc1a9f05b39cc$var$clip = (target, frame)=>{
    if (frame && frame.shouldClipSubject) return $371bc1a9f05b39cc$var$executeClip(frame.pageMarginBox, target);
    return (0, $8rsfJ.getRect)(target);
};
var $371bc1a9f05b39cc$var$getSubject = ({ page: page, withPlaceholder: withPlaceholder, axis: axis, frame: frame })=>{
    const scrolled = $371bc1a9f05b39cc$var$scroll$1(page.marginBox, frame);
    const increased = $371bc1a9f05b39cc$var$increase(scrolled, axis, withPlaceholder);
    const clipped = $371bc1a9f05b39cc$var$clip(increased, frame);
    return {
        page: page,
        withPlaceholder: withPlaceholder,
        active: clipped
    };
};
var $371bc1a9f05b39cc$var$scrollDroppable = (droppable, newScroll)=>{
    !droppable.frame && $371bc1a9f05b39cc$var$invariant();
    const scrollable = droppable.frame;
    const scrollDiff = $371bc1a9f05b39cc$var$subtract(newScroll, scrollable.scroll.initial);
    const scrollDisplacement = $371bc1a9f05b39cc$var$negate(scrollDiff);
    const frame = {
        ...scrollable,
        scroll: {
            initial: scrollable.scroll.initial,
            current: newScroll,
            diff: {
                value: scrollDiff,
                displacement: scrollDisplacement
            },
            max: scrollable.scroll.max
        }
    };
    const subject = $371bc1a9f05b39cc$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: droppable.subject.withPlaceholder,
        axis: droppable.axis,
        frame: frame
    });
    const result = {
        ...droppable,
        frame: frame,
        subject: subject
    };
    return result;
};
const $371bc1a9f05b39cc$var$toDroppableMap = (0, $34S1T.default)((droppables)=>droppables.reduce((previous, current)=>{
        previous[current.descriptor.id] = current;
        return previous;
    }, {}));
const $371bc1a9f05b39cc$var$toDraggableMap = (0, $34S1T.default)((draggables)=>draggables.reduce((previous, current)=>{
        previous[current.descriptor.id] = current;
        return previous;
    }, {}));
const $371bc1a9f05b39cc$var$toDroppableList = (0, $34S1T.default)((droppables)=>Object.values(droppables));
const $371bc1a9f05b39cc$var$toDraggableList = (0, $34S1T.default)((draggables)=>Object.values(draggables));
var $371bc1a9f05b39cc$var$getDraggablesInsideDroppable = (0, $34S1T.default)((droppableId, draggables)=>{
    const result = $371bc1a9f05b39cc$var$toDraggableList(draggables).filter((draggable)=>droppableId === draggable.descriptor.droppableId).sort((a, b)=>a.descriptor.index - b.descriptor.index);
    return result;
});
function $371bc1a9f05b39cc$var$tryGetDestination(impact) {
    if (impact.at && impact.at.type === "REORDER") return impact.at.destination;
    return null;
}
function $371bc1a9f05b39cc$var$tryGetCombine(impact) {
    if (impact.at && impact.at.type === "COMBINE") return impact.at.combine;
    return null;
}
var $371bc1a9f05b39cc$var$removeDraggableFromList = (0, $34S1T.default)((remove, list)=>list.filter((item)=>item.descriptor.id !== remove.descriptor.id));
var $371bc1a9f05b39cc$var$moveToNextCombine = ({ isMovingForward: isMovingForward, draggable: draggable, destination: destination, insideDestination: insideDestination, previousImpact: previousImpact })=>{
    if (!destination.isCombineEnabled) return null;
    const location = $371bc1a9f05b39cc$var$tryGetDestination(previousImpact);
    if (!location) return null;
    function getImpact(target) {
        const at = {
            type: "COMBINE",
            combine: {
                draggableId: target,
                droppableId: destination.descriptor.id
            }
        };
        return {
            ...previousImpact,
            at: at
        };
    }
    const all = previousImpact.displaced.all;
    const closestId = all.length ? all[0] : null;
    if (isMovingForward) return closestId ? getImpact(closestId) : null;
    const withoutDraggable = $371bc1a9f05b39cc$var$removeDraggableFromList(draggable, insideDestination);
    if (!closestId) {
        if (!withoutDraggable.length) return null;
        const last = withoutDraggable[withoutDraggable.length - 1];
        return getImpact(last.descriptor.id);
    }
    const indexOfClosest = withoutDraggable.findIndex((d)=>d.descriptor.id === closestId);
    !(indexOfClosest !== -1) && $371bc1a9f05b39cc$var$invariant();
    const proposedIndex = indexOfClosest - 1;
    if (proposedIndex < 0) return null;
    const before = withoutDraggable[proposedIndex];
    return getImpact(before.descriptor.id);
};
var $371bc1a9f05b39cc$var$isHomeOf = (draggable, destination)=>draggable.descriptor.droppableId === destination.descriptor.id;
const $371bc1a9f05b39cc$var$noDisplacedBy = {
    point: $371bc1a9f05b39cc$var$origin,
    value: 0
};
const $371bc1a9f05b39cc$var$emptyGroups = {
    invisible: {},
    visible: {},
    all: []
};
const $371bc1a9f05b39cc$var$noImpact = {
    displaced: $371bc1a9f05b39cc$var$emptyGroups,
    displacedBy: $371bc1a9f05b39cc$var$noDisplacedBy,
    at: null
};
var $371bc1a9f05b39cc$var$isWithin = (lowerBound, upperBound)=>(value)=>lowerBound <= value && value <= upperBound;
var $371bc1a9f05b39cc$var$isPartiallyVisibleThroughFrame = (frame)=>{
    const isWithinVertical = $371bc1a9f05b39cc$var$isWithin(frame.top, frame.bottom);
    const isWithinHorizontal = $371bc1a9f05b39cc$var$isWithin(frame.left, frame.right);
    return (subject)=>{
        const isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        if (isContained) return true;
        const isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
        const isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
        const isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;
        if (isPartiallyContained) return true;
        const isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
        const isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
        const isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;
        if (isTargetBiggerThanFrame) return true;
        const isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
        return isTargetBiggerOnOneAxis;
    };
};
var $371bc1a9f05b39cc$var$isTotallyVisibleThroughFrame = (frame)=>{
    const isWithinVertical = $371bc1a9f05b39cc$var$isWithin(frame.top, frame.bottom);
    const isWithinHorizontal = $371bc1a9f05b39cc$var$isWithin(frame.left, frame.right);
    return (subject)=>{
        const isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        return isContained;
    };
};
const $371bc1a9f05b39cc$var$vertical = {
    direction: "vertical",
    line: "y",
    crossAxisLine: "x",
    start: "top",
    end: "bottom",
    size: "height",
    crossAxisStart: "left",
    crossAxisEnd: "right",
    crossAxisSize: "width"
};
const $371bc1a9f05b39cc$var$horizontal = {
    direction: "horizontal",
    line: "x",
    crossAxisLine: "y",
    start: "left",
    end: "right",
    size: "width",
    crossAxisStart: "top",
    crossAxisEnd: "bottom",
    crossAxisSize: "height"
};
var $371bc1a9f05b39cc$var$isTotallyVisibleThroughFrameOnAxis = (axis)=>(frame)=>{
        const isWithinVertical = $371bc1a9f05b39cc$var$isWithin(frame.top, frame.bottom);
        const isWithinHorizontal = $371bc1a9f05b39cc$var$isWithin(frame.left, frame.right);
        return (subject)=>{
            if (axis === $371bc1a9f05b39cc$var$vertical) return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
            return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        };
    };
const $371bc1a9f05b39cc$var$getDroppableDisplaced = (target, destination)=>{
    const displacement = destination.frame ? destination.frame.scroll.diff.displacement : $371bc1a9f05b39cc$var$origin;
    return $371bc1a9f05b39cc$var$offsetByPosition(target, displacement);
};
const $371bc1a9f05b39cc$var$isVisibleInDroppable = (target, destination, isVisibleThroughFrameFn)=>{
    if (!destination.subject.active) return false;
    return isVisibleThroughFrameFn(destination.subject.active)(target);
};
const $371bc1a9f05b39cc$var$isVisibleInViewport = (target, viewport, isVisibleThroughFrameFn)=>isVisibleThroughFrameFn(viewport)(target);
const $371bc1a9f05b39cc$var$isVisible$1 = ({ target: toBeDisplaced, destination: destination, viewport: viewport, withDroppableDisplacement: withDroppableDisplacement, isVisibleThroughFrameFn: isVisibleThroughFrameFn })=>{
    const displacedTarget = withDroppableDisplacement ? $371bc1a9f05b39cc$var$getDroppableDisplaced(toBeDisplaced, destination) : toBeDisplaced;
    return $371bc1a9f05b39cc$var$isVisibleInDroppable(displacedTarget, destination, isVisibleThroughFrameFn) && $371bc1a9f05b39cc$var$isVisibleInViewport(displacedTarget, viewport, isVisibleThroughFrameFn);
};
const $371bc1a9f05b39cc$var$isPartiallyVisible = (args)=>$371bc1a9f05b39cc$var$isVisible$1({
        ...args,
        isVisibleThroughFrameFn: $371bc1a9f05b39cc$var$isPartiallyVisibleThroughFrame
    });
const $371bc1a9f05b39cc$var$isTotallyVisible = (args)=>$371bc1a9f05b39cc$var$isVisible$1({
        ...args,
        isVisibleThroughFrameFn: $371bc1a9f05b39cc$var$isTotallyVisibleThroughFrame
    });
const $371bc1a9f05b39cc$var$isTotallyVisibleOnAxis = (args)=>$371bc1a9f05b39cc$var$isVisible$1({
        ...args,
        isVisibleThroughFrameFn: $371bc1a9f05b39cc$var$isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
    });
const $371bc1a9f05b39cc$var$getShouldAnimate = (id, last, forceShouldAnimate)=>{
    if (typeof forceShouldAnimate === "boolean") return forceShouldAnimate;
    if (!last) return true;
    const { invisible: invisible, visible: visible } = last;
    if (invisible[id]) return false;
    const previous = visible[id];
    return previous ? previous.shouldAnimate : true;
};
function $371bc1a9f05b39cc$var$getTarget(draggable, displacedBy) {
    const marginBox = draggable.page.marginBox;
    const expandBy = {
        top: displacedBy.point.y,
        right: 0,
        bottom: 0,
        left: displacedBy.point.x
    };
    return (0, $8rsfJ.getRect)((0, $8rsfJ.expand)(marginBox, expandBy));
}
function $371bc1a9f05b39cc$var$getDisplacementGroups({ afterDragging: afterDragging, destination: destination, displacedBy: displacedBy, viewport: viewport, forceShouldAnimate: forceShouldAnimate, last: last }) {
    return afterDragging.reduce(function process(groups, draggable) {
        const target = $371bc1a9f05b39cc$var$getTarget(draggable, displacedBy);
        const id = draggable.descriptor.id;
        groups.all.push(id);
        const isVisible = $371bc1a9f05b39cc$var$isPartiallyVisible({
            target: target,
            destination: destination,
            viewport: viewport,
            withDroppableDisplacement: true
        });
        if (!isVisible) {
            groups.invisible[draggable.descriptor.id] = true;
            return groups;
        }
        const shouldAnimate = $371bc1a9f05b39cc$var$getShouldAnimate(id, last, forceShouldAnimate);
        const displacement = {
            draggableId: id,
            shouldAnimate: shouldAnimate
        };
        groups.visible[id] = displacement;
        return groups;
    }, {
        all: [],
        visible: {},
        invisible: {}
    });
}
function $371bc1a9f05b39cc$var$getIndexOfLastItem(draggables, options) {
    if (!draggables.length) return 0;
    const indexOfLastItem = draggables[draggables.length - 1].descriptor.index;
    return options.inHomeList ? indexOfLastItem : indexOfLastItem + 1;
}
function $371bc1a9f05b39cc$var$goAtEnd({ insideDestination: insideDestination, inHomeList: inHomeList, displacedBy: displacedBy, destination: destination }) {
    const newIndex = $371bc1a9f05b39cc$var$getIndexOfLastItem(insideDestination, {
        inHomeList: inHomeList
    });
    return {
        displaced: $371bc1a9f05b39cc$var$emptyGroups,
        displacedBy: displacedBy,
        at: {
            type: "REORDER",
            destination: {
                droppableId: destination.descriptor.id,
                index: newIndex
            }
        }
    };
}
function $371bc1a9f05b39cc$var$calculateReorderImpact({ draggable: draggable, insideDestination: insideDestination, destination: destination, viewport: viewport, displacedBy: displacedBy, last: last, index: index, forceShouldAnimate: forceShouldAnimate }) {
    const inHomeList = $371bc1a9f05b39cc$var$isHomeOf(draggable, destination);
    if (index == null) return $371bc1a9f05b39cc$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    const match = insideDestination.find((item)=>item.descriptor.index === index);
    if (!match) return $371bc1a9f05b39cc$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    const withoutDragging = $371bc1a9f05b39cc$var$removeDraggableFromList(draggable, insideDestination);
    const sliceFrom = insideDestination.indexOf(match);
    const impacted = withoutDragging.slice(sliceFrom);
    const displaced = $371bc1a9f05b39cc$var$getDisplacementGroups({
        afterDragging: impacted,
        destination: destination,
        displacedBy: displacedBy,
        last: last,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate
    });
    return {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: "REORDER",
            destination: {
                droppableId: destination.descriptor.id,
                index: index
            }
        }
    };
}
function $371bc1a9f05b39cc$var$didStartAfterCritical(draggableId, afterCritical) {
    return Boolean(afterCritical.effected[draggableId]);
}
var $371bc1a9f05b39cc$var$fromCombine = ({ isMovingForward: isMovingForward, destination: destination, draggables: draggables, combine: combine, afterCritical: afterCritical })=>{
    if (!destination.isCombineEnabled) return null;
    const combineId = combine.draggableId;
    const combineWith = draggables[combineId];
    const combineWithIndex = combineWith.descriptor.index;
    const didCombineWithStartAfterCritical = $371bc1a9f05b39cc$var$didStartAfterCritical(combineId, afterCritical);
    if (didCombineWithStartAfterCritical) {
        if (isMovingForward) return combineWithIndex;
        return combineWithIndex - 1;
    }
    if (isMovingForward) return combineWithIndex + 1;
    return combineWithIndex;
};
var $371bc1a9f05b39cc$var$fromReorder = ({ isMovingForward: isMovingForward, isInHomeList: isInHomeList, insideDestination: insideDestination, location: location })=>{
    if (!insideDestination.length) return null;
    const currentIndex = location.index;
    const proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
    const firstIndex = insideDestination[0].descriptor.index;
    const lastIndex = insideDestination[insideDestination.length - 1].descriptor.index;
    const upperBound = isInHomeList ? lastIndex : lastIndex + 1;
    if (proposedIndex < firstIndex) return null;
    if (proposedIndex > upperBound) return null;
    return proposedIndex;
};
var $371bc1a9f05b39cc$var$moveToNextIndex = ({ isMovingForward: isMovingForward, isInHomeList: isInHomeList, draggable: draggable, draggables: draggables, destination: destination, insideDestination: insideDestination, previousImpact: previousImpact, viewport: viewport, afterCritical: afterCritical })=>{
    const wasAt = previousImpact.at;
    !wasAt && $371bc1a9f05b39cc$var$invariant();
    if (wasAt.type === "REORDER") {
        const newIndex = $371bc1a9f05b39cc$var$fromReorder({
            isMovingForward: isMovingForward,
            isInHomeList: isInHomeList,
            location: wasAt.destination,
            insideDestination: insideDestination
        });
        if (newIndex == null) return null;
        return $371bc1a9f05b39cc$var$calculateReorderImpact({
            draggable: draggable,
            insideDestination: insideDestination,
            destination: destination,
            viewport: viewport,
            last: previousImpact.displaced,
            displacedBy: previousImpact.displacedBy,
            index: newIndex
        });
    }
    const newIndex = $371bc1a9f05b39cc$var$fromCombine({
        isMovingForward: isMovingForward,
        destination: destination,
        displaced: previousImpact.displaced,
        draggables: draggables,
        combine: wasAt.combine,
        afterCritical: afterCritical
    });
    if (newIndex == null) return null;
    return $371bc1a9f05b39cc$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: previousImpact.displaced,
        displacedBy: previousImpact.displacedBy,
        index: newIndex
    });
};
var $371bc1a9f05b39cc$var$getCombinedItemDisplacement = ({ displaced: displaced, afterCritical: afterCritical, combineWith: combineWith, displacedBy: displacedBy })=>{
    const isDisplaced = Boolean(displaced.visible[combineWith] || displaced.invisible[combineWith]);
    if ($371bc1a9f05b39cc$var$didStartAfterCritical(combineWith, afterCritical)) return isDisplaced ? $371bc1a9f05b39cc$var$origin : $371bc1a9f05b39cc$var$negate(displacedBy.point);
    return isDisplaced ? displacedBy.point : $371bc1a9f05b39cc$var$origin;
};
var $371bc1a9f05b39cc$var$whenCombining = ({ afterCritical: afterCritical, impact: impact, draggables: draggables })=>{
    const combine = $371bc1a9f05b39cc$var$tryGetCombine(impact);
    !combine && $371bc1a9f05b39cc$var$invariant();
    const combineWith = combine.draggableId;
    const center = draggables[combineWith].page.borderBox.center;
    const displaceBy = $371bc1a9f05b39cc$var$getCombinedItemDisplacement({
        displaced: impact.displaced,
        afterCritical: afterCritical,
        combineWith: combineWith,
        displacedBy: impact.displacedBy
    });
    return $371bc1a9f05b39cc$var$add(center, displaceBy);
};
const $371bc1a9f05b39cc$var$distanceFromStartToBorderBoxCenter = (axis, box)=>box.margin[axis.start] + box.borderBox[axis.size] / 2;
const $371bc1a9f05b39cc$var$distanceFromEndToBorderBoxCenter = (axis, box)=>box.margin[axis.end] + box.borderBox[axis.size] / 2;
const $371bc1a9f05b39cc$var$getCrossAxisBorderBoxCenter = (axis, target, isMoving)=>target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
const $371bc1a9f05b39cc$var$goAfter = ({ axis: axis, moveRelativeTo: moveRelativeTo, isMoving: isMoving })=>$371bc1a9f05b39cc$var$patch(axis.line, moveRelativeTo.marginBox[axis.end] + $371bc1a9f05b39cc$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $371bc1a9f05b39cc$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
const $371bc1a9f05b39cc$var$goBefore = ({ axis: axis, moveRelativeTo: moveRelativeTo, isMoving: isMoving })=>$371bc1a9f05b39cc$var$patch(axis.line, moveRelativeTo.marginBox[axis.start] - $371bc1a9f05b39cc$var$distanceFromEndToBorderBoxCenter(axis, isMoving), $371bc1a9f05b39cc$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
const $371bc1a9f05b39cc$var$goIntoStart = ({ axis: axis, moveInto: moveInto, isMoving: isMoving })=>$371bc1a9f05b39cc$var$patch(axis.line, moveInto.contentBox[axis.start] + $371bc1a9f05b39cc$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $371bc1a9f05b39cc$var$getCrossAxisBorderBoxCenter(axis, moveInto.contentBox, isMoving));
var $371bc1a9f05b39cc$var$whenReordering = ({ impact: impact, draggable: draggable, draggables: draggables, droppable: droppable, afterCritical: afterCritical })=>{
    const insideDestination = $371bc1a9f05b39cc$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    const draggablePage = draggable.page;
    const axis = droppable.axis;
    if (!insideDestination.length) return $371bc1a9f05b39cc$var$goIntoStart({
        axis: axis,
        moveInto: droppable.page,
        isMoving: draggablePage
    });
    const { displaced: displaced, displacedBy: displacedBy } = impact;
    const closestAfter = displaced.all[0];
    if (closestAfter) {
        const closest = draggables[closestAfter];
        if ($371bc1a9f05b39cc$var$didStartAfterCritical(closestAfter, afterCritical)) return $371bc1a9f05b39cc$var$goBefore({
            axis: axis,
            moveRelativeTo: closest.page,
            isMoving: draggablePage
        });
        const withDisplacement = (0, $8rsfJ.offset)(closest.page, displacedBy.point);
        return $371bc1a9f05b39cc$var$goBefore({
            axis: axis,
            moveRelativeTo: withDisplacement,
            isMoving: draggablePage
        });
    }
    const last = insideDestination[insideDestination.length - 1];
    if (last.descriptor.id === draggable.descriptor.id) return draggablePage.borderBox.center;
    if ($371bc1a9f05b39cc$var$didStartAfterCritical(last.descriptor.id, afterCritical)) {
        const page = (0, $8rsfJ.offset)(last.page, $371bc1a9f05b39cc$var$negate(afterCritical.displacedBy.point));
        return $371bc1a9f05b39cc$var$goAfter({
            axis: axis,
            moveRelativeTo: page,
            isMoving: draggablePage
        });
    }
    return $371bc1a9f05b39cc$var$goAfter({
        axis: axis,
        moveRelativeTo: last.page,
        isMoving: draggablePage
    });
};
var $371bc1a9f05b39cc$var$withDroppableDisplacement = (droppable, point)=>{
    const frame = droppable.frame;
    if (!frame) return point;
    return $371bc1a9f05b39cc$var$add(point, frame.scroll.diff.displacement);
};
const $371bc1a9f05b39cc$var$getResultWithoutDroppableDisplacement = ({ impact: impact, draggable: draggable, droppable: droppable, draggables: draggables, afterCritical: afterCritical })=>{
    const original = draggable.page.borderBox.center;
    const at = impact.at;
    if (!droppable) return original;
    if (!at) return original;
    if (at.type === "REORDER") return $371bc1a9f05b39cc$var$whenReordering({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $371bc1a9f05b39cc$var$whenCombining({
        impact: impact,
        draggables: draggables,
        afterCritical: afterCritical
    });
};
var $371bc1a9f05b39cc$var$getPageBorderBoxCenterFromImpact = (args)=>{
    const withoutDisplacement = $371bc1a9f05b39cc$var$getResultWithoutDroppableDisplacement(args);
    const droppable = args.droppable;
    const withDisplacement = droppable ? $371bc1a9f05b39cc$var$withDroppableDisplacement(droppable, withoutDisplacement) : withoutDisplacement;
    return withDisplacement;
};
var $371bc1a9f05b39cc$var$scrollViewport = (viewport, newScroll)=>{
    const diff = $371bc1a9f05b39cc$var$subtract(newScroll, viewport.scroll.initial);
    const displacement = $371bc1a9f05b39cc$var$negate(diff);
    const frame = (0, $8rsfJ.getRect)({
        top: newScroll.y,
        bottom: newScroll.y + viewport.frame.height,
        left: newScroll.x,
        right: newScroll.x + viewport.frame.width
    });
    const updated = {
        frame: frame,
        scroll: {
            initial: viewport.scroll.initial,
            max: viewport.scroll.max,
            current: newScroll,
            diff: {
                value: diff,
                displacement: displacement
            }
        }
    };
    return updated;
};
function $371bc1a9f05b39cc$var$getDraggables$1(ids, draggables) {
    return ids.map((id)=>draggables[id]);
}
function $371bc1a9f05b39cc$var$tryGetVisible(id, groups) {
    for(let i = 0; i < groups.length; i++){
        const displacement = groups[i].visible[id];
        if (displacement) return displacement;
    }
    return null;
}
var $371bc1a9f05b39cc$var$speculativelyIncrease = ({ impact: impact, viewport: viewport, destination: destination, draggables: draggables, maxScrollChange: maxScrollChange })=>{
    const scrolledViewport = $371bc1a9f05b39cc$var$scrollViewport(viewport, $371bc1a9f05b39cc$var$add(viewport.scroll.current, maxScrollChange));
    const scrolledDroppable = destination.frame ? $371bc1a9f05b39cc$var$scrollDroppable(destination, $371bc1a9f05b39cc$var$add(destination.frame.scroll.current, maxScrollChange)) : destination;
    const last = impact.displaced;
    const withViewportScroll = $371bc1a9f05b39cc$var$getDisplacementGroups({
        afterDragging: $371bc1a9f05b39cc$var$getDraggables$1(last.all, draggables),
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: scrolledViewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    const withDroppableScroll = $371bc1a9f05b39cc$var$getDisplacementGroups({
        afterDragging: $371bc1a9f05b39cc$var$getDraggables$1(last.all, draggables),
        destination: scrolledDroppable,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    const invisible = {};
    const visible = {};
    const groups = [
        last,
        withViewportScroll,
        withDroppableScroll
    ];
    last.all.forEach((id)=>{
        const displacement = $371bc1a9f05b39cc$var$tryGetVisible(id, groups);
        if (displacement) {
            visible[id] = displacement;
            return;
        }
        invisible[id] = true;
    });
    const newImpact = {
        ...impact,
        displaced: {
            all: last.all,
            invisible: invisible,
            visible: visible
        }
    };
    return newImpact;
};
var $371bc1a9f05b39cc$var$withViewportDisplacement = (viewport, point)=>$371bc1a9f05b39cc$var$add(viewport.scroll.diff.displacement, point);
var $371bc1a9f05b39cc$var$getClientFromPageBorderBoxCenter = ({ pageBorderBoxCenter: pageBorderBoxCenter, draggable: draggable, viewport: viewport })=>{
    const withoutPageScrollChange = $371bc1a9f05b39cc$var$withViewportDisplacement(viewport, pageBorderBoxCenter);
    const offset = $371bc1a9f05b39cc$var$subtract(withoutPageScrollChange, draggable.page.borderBox.center);
    return $371bc1a9f05b39cc$var$add(draggable.client.borderBox.center, offset);
};
var $371bc1a9f05b39cc$var$isTotallyVisibleInNewLocation = ({ draggable: draggable, destination: destination, newPageBorderBoxCenter: newPageBorderBoxCenter, viewport: viewport, withDroppableDisplacement: withDroppableDisplacement, onlyOnMainAxis: onlyOnMainAxis = false })=>{
    const changeNeeded = $371bc1a9f05b39cc$var$subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
    const shifted = $371bc1a9f05b39cc$var$offsetByPosition(draggable.page.borderBox, changeNeeded);
    const args = {
        target: shifted,
        destination: destination,
        withDroppableDisplacement: withDroppableDisplacement,
        viewport: viewport
    };
    return onlyOnMainAxis ? $371bc1a9f05b39cc$var$isTotallyVisibleOnAxis(args) : $371bc1a9f05b39cc$var$isTotallyVisible(args);
};
var $371bc1a9f05b39cc$var$moveToNextPlace = ({ isMovingForward: isMovingForward, draggable: draggable, destination: destination, draggables: draggables, previousImpact: previousImpact, viewport: viewport, previousPageBorderBoxCenter: previousPageBorderBoxCenter, previousClientSelection: previousClientSelection, afterCritical: afterCritical })=>{
    if (!destination.isEnabled) return null;
    const insideDestination = $371bc1a9f05b39cc$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    const isInHomeList = $371bc1a9f05b39cc$var$isHomeOf(draggable, destination);
    const impact = $371bc1a9f05b39cc$var$moveToNextCombine({
        isMovingForward: isMovingForward,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact
    }) || $371bc1a9f05b39cc$var$moveToNextIndex({
        isMovingForward: isMovingForward,
        isInHomeList: isInHomeList,
        draggable: draggable,
        draggables: draggables,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    const pageBorderBoxCenter = $371bc1a9f05b39cc$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    const isVisibleInNewLocation = $371bc1a9f05b39cc$var$isTotallyVisibleInNewLocation({
        draggable: draggable,
        destination: destination,
        newPageBorderBoxCenter: pageBorderBoxCenter,
        viewport: viewport.frame,
        withDroppableDisplacement: false,
        onlyOnMainAxis: true
    });
    if (isVisibleInNewLocation) {
        const clientSelection = $371bc1a9f05b39cc$var$getClientFromPageBorderBoxCenter({
            pageBorderBoxCenter: pageBorderBoxCenter,
            draggable: draggable,
            viewport: viewport
        });
        return {
            clientSelection: clientSelection,
            impact: impact,
            scrollJumpRequest: null
        };
    }
    const distance = $371bc1a9f05b39cc$var$subtract(pageBorderBoxCenter, previousPageBorderBoxCenter);
    const cautious = $371bc1a9f05b39cc$var$speculativelyIncrease({
        impact: impact,
        viewport: viewport,
        destination: destination,
        draggables: draggables,
        maxScrollChange: distance
    });
    return {
        clientSelection: previousClientSelection,
        impact: cautious,
        scrollJumpRequest: distance
    };
};
const $371bc1a9f05b39cc$var$getKnownActive = (droppable)=>{
    const rect = droppable.subject.active;
    !rect && $371bc1a9f05b39cc$var$invariant();
    return rect;
};
var $371bc1a9f05b39cc$var$getBestCrossAxisDroppable = ({ isMovingForward: isMovingForward, pageBorderBoxCenter: pageBorderBoxCenter, source: source, droppables: droppables, viewport: viewport })=>{
    const active = source.subject.active;
    if (!active) return null;
    const axis = source.axis;
    const isBetweenSourceClipped = $371bc1a9f05b39cc$var$isWithin(active[axis.start], active[axis.end]);
    const candidates = $371bc1a9f05b39cc$var$toDroppableList(droppables).filter((droppable)=>droppable !== source).filter((droppable)=>droppable.isEnabled).filter((droppable)=>Boolean(droppable.subject.active)).filter((droppable)=>$371bc1a9f05b39cc$var$isPartiallyVisibleThroughFrame(viewport.frame)($371bc1a9f05b39cc$var$getKnownActive(droppable))).filter((droppable)=>{
        const activeOfTarget = $371bc1a9f05b39cc$var$getKnownActive(droppable);
        if (isMovingForward) return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
        return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
    }).filter((droppable)=>{
        const activeOfTarget = $371bc1a9f05b39cc$var$getKnownActive(droppable);
        const isBetweenDestinationClipped = $371bc1a9f05b39cc$var$isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
        return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
    }).sort((a, b)=>{
        const first = $371bc1a9f05b39cc$var$getKnownActive(a)[axis.crossAxisStart];
        const second = $371bc1a9f05b39cc$var$getKnownActive(b)[axis.crossAxisStart];
        if (isMovingForward) return first - second;
        return second - first;
    }).filter((droppable, index, array)=>$371bc1a9f05b39cc$var$getKnownActive(droppable)[axis.crossAxisStart] === $371bc1a9f05b39cc$var$getKnownActive(array[0])[axis.crossAxisStart]);
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0];
    const contains = candidates.filter((droppable)=>{
        const isWithinDroppable = $371bc1a9f05b39cc$var$isWithin($371bc1a9f05b39cc$var$getKnownActive(droppable)[axis.start], $371bc1a9f05b39cc$var$getKnownActive(droppable)[axis.end]);
        return isWithinDroppable(pageBorderBoxCenter[axis.line]);
    });
    if (contains.length === 1) return contains[0];
    if (contains.length > 1) return contains.sort((a, b)=>$371bc1a9f05b39cc$var$getKnownActive(a)[axis.start] - $371bc1a9f05b39cc$var$getKnownActive(b)[axis.start])[0];
    return candidates.sort((a, b)=>{
        const first = $371bc1a9f05b39cc$var$closest$1(pageBorderBoxCenter, $371bc1a9f05b39cc$var$getCorners($371bc1a9f05b39cc$var$getKnownActive(a)));
        const second = $371bc1a9f05b39cc$var$closest$1(pageBorderBoxCenter, $371bc1a9f05b39cc$var$getCorners($371bc1a9f05b39cc$var$getKnownActive(b)));
        if (first !== second) return first - second;
        return $371bc1a9f05b39cc$var$getKnownActive(a)[axis.start] - $371bc1a9f05b39cc$var$getKnownActive(b)[axis.start];
    })[0];
};
const $371bc1a9f05b39cc$var$getCurrentPageBorderBoxCenter = (draggable, afterCritical)=>{
    const original = draggable.page.borderBox.center;
    return $371bc1a9f05b39cc$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $371bc1a9f05b39cc$var$subtract(original, afterCritical.displacedBy.point) : original;
};
const $371bc1a9f05b39cc$var$getCurrentPageBorderBox = (draggable, afterCritical)=>{
    const original = draggable.page.borderBox;
    return $371bc1a9f05b39cc$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $371bc1a9f05b39cc$var$offsetByPosition(original, $371bc1a9f05b39cc$var$negate(afterCritical.displacedBy.point)) : original;
};
var $371bc1a9f05b39cc$var$getClosestDraggable = ({ pageBorderBoxCenter: pageBorderBoxCenter, viewport: viewport, destination: destination, insideDestination: insideDestination, afterCritical: afterCritical })=>{
    const sorted = insideDestination.filter((draggable)=>$371bc1a9f05b39cc$var$isTotallyVisible({
            target: $371bc1a9f05b39cc$var$getCurrentPageBorderBox(draggable, afterCritical),
            destination: destination,
            viewport: viewport.frame,
            withDroppableDisplacement: true
        })).sort((a, b)=>{
        const distanceToA = $371bc1a9f05b39cc$var$distance(pageBorderBoxCenter, $371bc1a9f05b39cc$var$withDroppableDisplacement(destination, $371bc1a9f05b39cc$var$getCurrentPageBorderBoxCenter(a, afterCritical)));
        const distanceToB = $371bc1a9f05b39cc$var$distance(pageBorderBoxCenter, $371bc1a9f05b39cc$var$withDroppableDisplacement(destination, $371bc1a9f05b39cc$var$getCurrentPageBorderBoxCenter(b, afterCritical)));
        if (distanceToA < distanceToB) return -1;
        if (distanceToB < distanceToA) return 1;
        return a.descriptor.index - b.descriptor.index;
    });
    return sorted[0] || null;
};
var $371bc1a9f05b39cc$var$getDisplacedBy = (0, $34S1T.default)(function getDisplacedBy(axis, displaceBy) {
    const displacement = displaceBy[axis.line];
    return {
        value: displacement,
        point: $371bc1a9f05b39cc$var$patch(axis.line, displacement)
    };
});
const $371bc1a9f05b39cc$var$getRequiredGrowthForPlaceholder = (droppable, placeholderSize, draggables)=>{
    const axis = droppable.axis;
    if (droppable.descriptor.mode === "virtual") return $371bc1a9f05b39cc$var$patch(axis.line, placeholderSize[axis.line]);
    const availableSpace = droppable.subject.page.contentBox[axis.size];
    const insideDroppable = $371bc1a9f05b39cc$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    const spaceUsed = insideDroppable.reduce((sum, dimension)=>sum + dimension.client.marginBox[axis.size], 0);
    const requiredSpace = spaceUsed + placeholderSize[axis.line];
    const needsToGrowBy = requiredSpace - availableSpace;
    if (needsToGrowBy <= 0) return null;
    return $371bc1a9f05b39cc$var$patch(axis.line, needsToGrowBy);
};
const $371bc1a9f05b39cc$var$withMaxScroll = (frame, max)=>({
        ...frame,
        scroll: {
            ...frame.scroll,
            max: max
        }
    });
const $371bc1a9f05b39cc$var$addPlaceholder = (droppable, draggable, draggables)=>{
    const frame = droppable.frame;
    !!$371bc1a9f05b39cc$var$isHomeOf(draggable, droppable) && $371bc1a9f05b39cc$var$invariant();
    !!droppable.subject.withPlaceholder && $371bc1a9f05b39cc$var$invariant();
    const placeholderSize = $371bc1a9f05b39cc$var$getDisplacedBy(droppable.axis, draggable.displaceBy).point;
    const requiredGrowth = $371bc1a9f05b39cc$var$getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables);
    const added = {
        placeholderSize: placeholderSize,
        increasedBy: requiredGrowth,
        oldFrameMaxScroll: droppable.frame ? droppable.frame.scroll.max : null
    };
    if (!frame) {
        const subject = $371bc1a9f05b39cc$var$getSubject({
            page: droppable.subject.page,
            withPlaceholder: added,
            axis: droppable.axis,
            frame: droppable.frame
        });
        return {
            ...droppable,
            subject: subject
        };
    }
    const maxScroll = requiredGrowth ? $371bc1a9f05b39cc$var$add(frame.scroll.max, requiredGrowth) : frame.scroll.max;
    const newFrame = $371bc1a9f05b39cc$var$withMaxScroll(frame, maxScroll);
    const subject = $371bc1a9f05b39cc$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: added,
        axis: droppable.axis,
        frame: newFrame
    });
    return {
        ...droppable,
        subject: subject,
        frame: newFrame
    };
};
const $371bc1a9f05b39cc$var$removePlaceholder = (droppable)=>{
    const added = droppable.subject.withPlaceholder;
    !added && $371bc1a9f05b39cc$var$invariant();
    const frame = droppable.frame;
    if (!frame) {
        const subject = $371bc1a9f05b39cc$var$getSubject({
            page: droppable.subject.page,
            axis: droppable.axis,
            frame: null,
            withPlaceholder: null
        });
        return {
            ...droppable,
            subject: subject
        };
    }
    const oldMaxScroll = added.oldFrameMaxScroll;
    !oldMaxScroll && $371bc1a9f05b39cc$var$invariant();
    const newFrame = $371bc1a9f05b39cc$var$withMaxScroll(frame, oldMaxScroll);
    const subject = $371bc1a9f05b39cc$var$getSubject({
        page: droppable.subject.page,
        axis: droppable.axis,
        frame: newFrame,
        withPlaceholder: null
    });
    return {
        ...droppable,
        subject: subject,
        frame: newFrame
    };
};
var $371bc1a9f05b39cc$var$moveToNewDroppable = ({ previousPageBorderBoxCenter: previousPageBorderBoxCenter, moveRelativeTo: moveRelativeTo, insideDestination: insideDestination, draggable: draggable, draggables: draggables, destination: destination, viewport: viewport, afterCritical: afterCritical })=>{
    if (!moveRelativeTo) {
        if (insideDestination.length) return null;
        const proposed = {
            displaced: $371bc1a9f05b39cc$var$emptyGroups,
            displacedBy: $371bc1a9f05b39cc$var$noDisplacedBy,
            at: {
                type: "REORDER",
                destination: {
                    droppableId: destination.descriptor.id,
                    index: 0
                }
            }
        };
        const proposedPageBorderBoxCenter = $371bc1a9f05b39cc$var$getPageBorderBoxCenterFromImpact({
            impact: proposed,
            draggable: draggable,
            droppable: destination,
            draggables: draggables,
            afterCritical: afterCritical
        });
        const withPlaceholder = $371bc1a9f05b39cc$var$isHomeOf(draggable, destination) ? destination : $371bc1a9f05b39cc$var$addPlaceholder(destination, draggable, draggables);
        const isVisibleInNewLocation = $371bc1a9f05b39cc$var$isTotallyVisibleInNewLocation({
            draggable: draggable,
            destination: withPlaceholder,
            newPageBorderBoxCenter: proposedPageBorderBoxCenter,
            viewport: viewport.frame,
            withDroppableDisplacement: false,
            onlyOnMainAxis: true
        });
        return isVisibleInNewLocation ? proposed : null;
    }
    const isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] <= moveRelativeTo.page.borderBox.center[destination.axis.line]);
    const proposedIndex = (()=>{
        const relativeTo = moveRelativeTo.descriptor.index;
        if (moveRelativeTo.descriptor.id === draggable.descriptor.id) return relativeTo;
        if (isGoingBeforeTarget) return relativeTo;
        return relativeTo + 1;
    })();
    const displacedBy = $371bc1a9f05b39cc$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    return $371bc1a9f05b39cc$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        displacedBy: displacedBy,
        last: $371bc1a9f05b39cc$var$emptyGroups,
        index: proposedIndex
    });
};
var $371bc1a9f05b39cc$var$moveCrossAxis = ({ isMovingForward: isMovingForward, previousPageBorderBoxCenter: previousPageBorderBoxCenter, draggable: draggable, isOver: isOver, draggables: draggables, droppables: droppables, viewport: viewport, afterCritical: afterCritical })=>{
    const destination = $371bc1a9f05b39cc$var$getBestCrossAxisDroppable({
        isMovingForward: isMovingForward,
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        source: isOver,
        droppables: droppables,
        viewport: viewport
    });
    if (!destination) return null;
    const insideDestination = $371bc1a9f05b39cc$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    const moveRelativeTo = $371bc1a9f05b39cc$var$getClosestDraggable({
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        viewport: viewport,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    });
    const impact = $371bc1a9f05b39cc$var$moveToNewDroppable({
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        destination: destination,
        draggable: draggable,
        draggables: draggables,
        moveRelativeTo: moveRelativeTo,
        insideDestination: insideDestination,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    const pageBorderBoxCenter = $371bc1a9f05b39cc$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    const clientSelection = $371bc1a9f05b39cc$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
    return {
        clientSelection: clientSelection,
        impact: impact,
        scrollJumpRequest: null
    };
};
var $371bc1a9f05b39cc$var$whatIsDraggedOver = (impact)=>{
    const at = impact.at;
    if (!at) return null;
    if (at.type === "REORDER") return at.destination.droppableId;
    return at.combine.droppableId;
};
const $371bc1a9f05b39cc$var$getDroppableOver$1 = (impact, droppables)=>{
    const id = $371bc1a9f05b39cc$var$whatIsDraggedOver(impact);
    return id ? droppables[id] : null;
};
var $371bc1a9f05b39cc$var$moveInDirection = ({ state: state, type: type })=>{
    const isActuallyOver = $371bc1a9f05b39cc$var$getDroppableOver$1(state.impact, state.dimensions.droppables);
    const isMainAxisMovementAllowed = Boolean(isActuallyOver);
    const home = state.dimensions.droppables[state.critical.droppable.id];
    const isOver = isActuallyOver || home;
    const direction = isOver.axis.direction;
    const isMovingOnMainAxis = direction === "vertical" && (type === "MOVE_UP" || type === "MOVE_DOWN") || direction === "horizontal" && (type === "MOVE_LEFT" || type === "MOVE_RIGHT");
    if (isMovingOnMainAxis && !isMainAxisMovementAllowed) return null;
    const isMovingForward = type === "MOVE_DOWN" || type === "MOVE_RIGHT";
    const draggable = state.dimensions.draggables[state.critical.draggable.id];
    const previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
    const { draggables: draggables, droppables: droppables } = state.dimensions;
    return isMovingOnMainAxis ? $371bc1a9f05b39cc$var$moveToNextPlace({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        destination: isOver,
        draggables: draggables,
        viewport: state.viewport,
        previousClientSelection: state.current.client.selection,
        previousImpact: state.impact,
        afterCritical: state.afterCritical
    }) : $371bc1a9f05b39cc$var$moveCrossAxis({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        isOver: isOver,
        draggables: draggables,
        droppables: droppables,
        viewport: state.viewport,
        afterCritical: state.afterCritical
    });
};
function $371bc1a9f05b39cc$var$isMovementAllowed(state) {
    return state.phase === "DRAGGING" || state.phase === "COLLECTING";
}
function $371bc1a9f05b39cc$var$isPositionInFrame(frame) {
    const isWithinVertical = $371bc1a9f05b39cc$var$isWithin(frame.top, frame.bottom);
    const isWithinHorizontal = $371bc1a9f05b39cc$var$isWithin(frame.left, frame.right);
    return function run(point) {
        return isWithinVertical(point.y) && isWithinHorizontal(point.x);
    };
}
function $371bc1a9f05b39cc$var$getHasOverlap(first, second) {
    return first.left < second.right && first.right > second.left && first.top < second.bottom && first.bottom > second.top;
}
function $371bc1a9f05b39cc$var$getFurthestAway({ pageBorderBox: pageBorderBox, draggable: draggable, candidates: candidates }) {
    const startCenter = draggable.page.borderBox.center;
    const sorted = candidates.map((candidate)=>{
        const axis = candidate.axis;
        const target = $371bc1a9f05b39cc$var$patch(candidate.axis.line, pageBorderBox.center[axis.line], candidate.page.borderBox.center[axis.crossAxisLine]);
        return {
            id: candidate.descriptor.id,
            distance: $371bc1a9f05b39cc$var$distance(startCenter, target)
        };
    }).sort((a, b)=>b.distance - a.distance);
    return sorted[0] ? sorted[0].id : null;
}
function $371bc1a9f05b39cc$var$getDroppableOver({ pageBorderBox: pageBorderBox, draggable: draggable, droppables: droppables }) {
    const candidates = $371bc1a9f05b39cc$var$toDroppableList(droppables).filter((item)=>{
        if (!item.isEnabled) return false;
        const active = item.subject.active;
        if (!active) return false;
        if (!$371bc1a9f05b39cc$var$getHasOverlap(pageBorderBox, active)) return false;
        if ($371bc1a9f05b39cc$var$isPositionInFrame(active)(pageBorderBox.center)) return true;
        const axis = item.axis;
        const childCenter = active.center[axis.crossAxisLine];
        const crossAxisStart = pageBorderBox[axis.crossAxisStart];
        const crossAxisEnd = pageBorderBox[axis.crossAxisEnd];
        const isContained = $371bc1a9f05b39cc$var$isWithin(active[axis.crossAxisStart], active[axis.crossAxisEnd]);
        const isStartContained = isContained(crossAxisStart);
        const isEndContained = isContained(crossAxisEnd);
        if (!isStartContained && !isEndContained) return true;
        if (isStartContained) return crossAxisStart < childCenter;
        return crossAxisEnd > childCenter;
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0].descriptor.id;
    return $371bc1a9f05b39cc$var$getFurthestAway({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        candidates: candidates
    });
}
const $371bc1a9f05b39cc$var$offsetRectByPosition = (rect, point)=>(0, $8rsfJ.getRect)($371bc1a9f05b39cc$var$offsetByPosition(rect, point));
var $371bc1a9f05b39cc$var$withDroppableScroll = (droppable, area)=>{
    const frame = droppable.frame;
    if (!frame) return area;
    return $371bc1a9f05b39cc$var$offsetRectByPosition(area, frame.scroll.diff.value);
};
function $371bc1a9f05b39cc$var$getIsDisplaced({ displaced: displaced, id: id }) {
    return Boolean(displaced.visible[id] || displaced.invisible[id]);
}
function $371bc1a9f05b39cc$var$atIndex({ draggable: draggable, closest: closest, inHomeList: inHomeList }) {
    if (!closest) return null;
    if (!inHomeList) return closest.descriptor.index;
    if (closest.descriptor.index > draggable.descriptor.index) return closest.descriptor.index - 1;
    return closest.descriptor.index;
}
var $371bc1a9f05b39cc$var$getReorderImpact = ({ pageBorderBoxWithDroppableScroll: targetRect, draggable: draggable, destination: destination, insideDestination: insideDestination, last: last, viewport: viewport, afterCritical: afterCritical })=>{
    const axis = destination.axis;
    const displacedBy = $371bc1a9f05b39cc$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    const displacement = displacedBy.value;
    const targetStart = targetRect[axis.start];
    const targetEnd = targetRect[axis.end];
    const withoutDragging = $371bc1a9f05b39cc$var$removeDraggableFromList(draggable, insideDestination);
    const closest = withoutDragging.find((child)=>{
        const id = child.descriptor.id;
        const childCenter = child.page.borderBox.center[axis.line];
        const didStartAfterCritical$1 = $371bc1a9f05b39cc$var$didStartAfterCritical(id, afterCritical);
        const isDisplaced = $371bc1a9f05b39cc$var$getIsDisplaced({
            displaced: last,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd <= childCenter;
            return targetStart < childCenter - displacement;
        }
        if (isDisplaced) return targetEnd <= childCenter + displacement;
        return targetStart < childCenter;
    }) || null;
    const newIndex = $371bc1a9f05b39cc$var$atIndex({
        draggable: draggable,
        closest: closest,
        inHomeList: $371bc1a9f05b39cc$var$isHomeOf(draggable, destination)
    });
    return $371bc1a9f05b39cc$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: last,
        displacedBy: displacedBy,
        index: newIndex
    });
};
const $371bc1a9f05b39cc$var$combineThresholdDivisor = 4;
var $371bc1a9f05b39cc$var$getCombineImpact = ({ draggable: draggable, pageBorderBoxWithDroppableScroll: targetRect, previousImpact: previousImpact, destination: destination, insideDestination: insideDestination, afterCritical: afterCritical })=>{
    if (!destination.isCombineEnabled) return null;
    const axis = destination.axis;
    const displacedBy = $371bc1a9f05b39cc$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    const displacement = displacedBy.value;
    const targetStart = targetRect[axis.start];
    const targetEnd = targetRect[axis.end];
    const withoutDragging = $371bc1a9f05b39cc$var$removeDraggableFromList(draggable, insideDestination);
    const combineWith = withoutDragging.find((child)=>{
        const id = child.descriptor.id;
        const childRect = child.page.borderBox;
        const childSize = childRect[axis.size];
        const threshold = childSize / $371bc1a9f05b39cc$var$combineThresholdDivisor;
        const didStartAfterCritical$1 = $371bc1a9f05b39cc$var$didStartAfterCritical(id, afterCritical);
        const isDisplaced = $371bc1a9f05b39cc$var$getIsDisplaced({
            displaced: previousImpact.displaced,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd > childRect[axis.start] + threshold && targetEnd < childRect[axis.end] - threshold;
            return targetStart > childRect[axis.start] - displacement + threshold && targetStart < childRect[axis.end] - displacement - threshold;
        }
        if (isDisplaced) return targetEnd > childRect[axis.start] + displacement + threshold && targetEnd < childRect[axis.end] + displacement - threshold;
        return targetStart > childRect[axis.start] + threshold && targetStart < childRect[axis.end] - threshold;
    });
    if (!combineWith) return null;
    const impact = {
        displacedBy: displacedBy,
        displaced: previousImpact.displaced,
        at: {
            type: "COMBINE",
            combine: {
                draggableId: combineWith.descriptor.id,
                droppableId: destination.descriptor.id
            }
        }
    };
    return impact;
};
var $371bc1a9f05b39cc$var$getDragImpact = ({ pageOffset: pageOffset, draggable: draggable, draggables: draggables, droppables: droppables, previousImpact: previousImpact, viewport: viewport, afterCritical: afterCritical })=>{
    const pageBorderBox = $371bc1a9f05b39cc$var$offsetRectByPosition(draggable.page.borderBox, pageOffset);
    const destinationId = $371bc1a9f05b39cc$var$getDroppableOver({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        droppables: droppables
    });
    if (!destinationId) return $371bc1a9f05b39cc$var$noImpact;
    const destination = droppables[destinationId];
    const insideDestination = $371bc1a9f05b39cc$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    const pageBorderBoxWithDroppableScroll = $371bc1a9f05b39cc$var$withDroppableScroll(destination, pageBorderBox);
    return $371bc1a9f05b39cc$var$getCombineImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        previousImpact: previousImpact,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    }) || $371bc1a9f05b39cc$var$getReorderImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        last: previousImpact.displaced,
        viewport: viewport,
        afterCritical: afterCritical
    });
};
var $371bc1a9f05b39cc$var$patchDroppableMap = (droppables, updated)=>({
        ...droppables,
        [updated.descriptor.id]: updated
    });
const $371bc1a9f05b39cc$var$clearUnusedPlaceholder = ({ previousImpact: previousImpact, impact: impact, droppables: droppables })=>{
    const last = $371bc1a9f05b39cc$var$whatIsDraggedOver(previousImpact);
    const now = $371bc1a9f05b39cc$var$whatIsDraggedOver(impact);
    if (!last) return droppables;
    if (last === now) return droppables;
    const lastDroppable = droppables[last];
    if (!lastDroppable.subject.withPlaceholder) return droppables;
    const updated = $371bc1a9f05b39cc$var$removePlaceholder(lastDroppable);
    return $371bc1a9f05b39cc$var$patchDroppableMap(droppables, updated);
};
var $371bc1a9f05b39cc$var$recomputePlaceholders = ({ draggable: draggable, draggables: draggables, droppables: droppables, previousImpact: previousImpact, impact: impact })=>{
    const cleaned = $371bc1a9f05b39cc$var$clearUnusedPlaceholder({
        previousImpact: previousImpact,
        impact: impact,
        droppables: droppables
    });
    const isOver = $371bc1a9f05b39cc$var$whatIsDraggedOver(impact);
    if (!isOver) return cleaned;
    const droppable = droppables[isOver];
    if ($371bc1a9f05b39cc$var$isHomeOf(draggable, droppable)) return cleaned;
    if (droppable.subject.withPlaceholder) return cleaned;
    const patched = $371bc1a9f05b39cc$var$addPlaceholder(droppable, draggable, draggables);
    return $371bc1a9f05b39cc$var$patchDroppableMap(cleaned, patched);
};
var $371bc1a9f05b39cc$var$update = ({ state: state, clientSelection: forcedClientSelection, dimensions: forcedDimensions, viewport: forcedViewport, impact: forcedImpact, scrollJumpRequest: scrollJumpRequest })=>{
    const viewport = forcedViewport || state.viewport;
    const dimensions = forcedDimensions || state.dimensions;
    const clientSelection = forcedClientSelection || state.current.client.selection;
    const offset = $371bc1a9f05b39cc$var$subtract(clientSelection, state.initial.client.selection);
    const client = {
        offset: offset,
        selection: clientSelection,
        borderBoxCenter: $371bc1a9f05b39cc$var$add(state.initial.client.borderBoxCenter, offset)
    };
    const page = {
        selection: $371bc1a9f05b39cc$var$add(client.selection, viewport.scroll.current),
        borderBoxCenter: $371bc1a9f05b39cc$var$add(client.borderBoxCenter, viewport.scroll.current),
        offset: $371bc1a9f05b39cc$var$add(client.offset, viewport.scroll.diff.value)
    };
    const current = {
        client: client,
        page: page
    };
    if (state.phase === "COLLECTING") return {
        ...state,
        dimensions: dimensions,
        viewport: viewport,
        current: current
    };
    const draggable = dimensions.draggables[state.critical.draggable.id];
    const newImpact = forcedImpact || $371bc1a9f05b39cc$var$getDragImpact({
        pageOffset: page.offset,
        draggable: draggable,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: state.impact,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    const withUpdatedPlaceholders = $371bc1a9f05b39cc$var$recomputePlaceholders({
        draggable: draggable,
        impact: newImpact,
        previousImpact: state.impact,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables
    });
    const result = {
        ...state,
        current: current,
        dimensions: {
            draggables: dimensions.draggables,
            droppables: withUpdatedPlaceholders
        },
        impact: newImpact,
        viewport: viewport,
        scrollJumpRequest: scrollJumpRequest || null,
        forceShouldAnimate: scrollJumpRequest ? false : null
    };
    return result;
};
function $371bc1a9f05b39cc$var$getDraggables(ids, draggables) {
    return ids.map((id)=>draggables[id]);
}
var $371bc1a9f05b39cc$var$recompute = ({ impact: impact, viewport: viewport, draggables: draggables, destination: destination, forceShouldAnimate: forceShouldAnimate })=>{
    const last = impact.displaced;
    const afterDragging = $371bc1a9f05b39cc$var$getDraggables(last.all, draggables);
    const displaced = $371bc1a9f05b39cc$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate,
        last: last
    });
    return {
        ...impact,
        displaced: displaced
    };
};
var $371bc1a9f05b39cc$var$getClientBorderBoxCenter = ({ impact: impact, draggable: draggable, droppable: droppable, draggables: draggables, viewport: viewport, afterCritical: afterCritical })=>{
    const pageBorderBoxCenter = $371bc1a9f05b39cc$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $371bc1a9f05b39cc$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
};
var $371bc1a9f05b39cc$var$refreshSnap = ({ state: state, dimensions: forcedDimensions, viewport: forcedViewport })=>{
    !(state.movementMode === "SNAP") && $371bc1a9f05b39cc$var$invariant();
    const needsVisibilityCheck = state.impact;
    const viewport = forcedViewport || state.viewport;
    const dimensions = forcedDimensions || state.dimensions;
    const { draggables: draggables, droppables: droppables } = dimensions;
    const draggable = draggables[state.critical.draggable.id];
    const isOver = $371bc1a9f05b39cc$var$whatIsDraggedOver(needsVisibilityCheck);
    !isOver && $371bc1a9f05b39cc$var$invariant();
    const destination = droppables[isOver];
    const impact = $371bc1a9f05b39cc$var$recompute({
        impact: needsVisibilityCheck,
        viewport: viewport,
        destination: destination,
        draggables: draggables
    });
    const clientSelection = $371bc1a9f05b39cc$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    return $371bc1a9f05b39cc$var$update({
        impact: impact,
        clientSelection: clientSelection,
        state: state,
        dimensions: dimensions,
        viewport: viewport
    });
};
var $371bc1a9f05b39cc$var$getHomeLocation = (descriptor)=>({
        index: descriptor.index,
        droppableId: descriptor.droppableId
    });
var $371bc1a9f05b39cc$var$getLiftEffect = ({ draggable: draggable, home: home, draggables: draggables, viewport: viewport })=>{
    const displacedBy = $371bc1a9f05b39cc$var$getDisplacedBy(home.axis, draggable.displaceBy);
    const insideHome = $371bc1a9f05b39cc$var$getDraggablesInsideDroppable(home.descriptor.id, draggables);
    const rawIndex = insideHome.indexOf(draggable);
    !(rawIndex !== -1) && $371bc1a9f05b39cc$var$invariant();
    const afterDragging = insideHome.slice(rawIndex + 1);
    const effected = afterDragging.reduce((previous, item)=>{
        previous[item.descriptor.id] = true;
        return previous;
    }, {});
    const afterCritical = {
        inVirtualList: home.descriptor.mode === "virtual",
        displacedBy: displacedBy,
        effected: effected
    };
    const displaced = $371bc1a9f05b39cc$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: home,
        displacedBy: displacedBy,
        last: null,
        viewport: viewport.frame,
        forceShouldAnimate: false
    });
    const impact = {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: "REORDER",
            destination: $371bc1a9f05b39cc$var$getHomeLocation(draggable.descriptor)
        }
    };
    return {
        impact: impact,
        afterCritical: afterCritical
    };
};
var $371bc1a9f05b39cc$var$patchDimensionMap = (dimensions, updated)=>({
        draggables: dimensions.draggables,
        droppables: $371bc1a9f05b39cc$var$patchDroppableMap(dimensions.droppables, updated)
    });
const $371bc1a9f05b39cc$var$start = (key)=>{};
const $371bc1a9f05b39cc$var$finish = (key)=>{};
var $371bc1a9f05b39cc$var$offsetDraggable = ({ draggable: draggable, offset: offset$1, initialWindowScroll: initialWindowScroll })=>{
    const client = (0, $8rsfJ.offset)(draggable.client, offset$1);
    const page = (0, $8rsfJ.withScroll)(client, initialWindowScroll);
    const moved = {
        ...draggable,
        placeholder: {
            ...draggable.placeholder,
            client: client
        },
        client: client,
        page: page
    };
    return moved;
};
var $371bc1a9f05b39cc$var$getFrame = (droppable)=>{
    const frame = droppable.frame;
    !frame && $371bc1a9f05b39cc$var$invariant();
    return frame;
};
var $371bc1a9f05b39cc$var$adjustAdditionsForScrollChanges = ({ additions: additions, updatedDroppables: updatedDroppables, viewport: viewport })=>{
    const windowScrollChange = viewport.scroll.diff.value;
    return additions.map((draggable)=>{
        const droppableId = draggable.descriptor.droppableId;
        const modified = updatedDroppables[droppableId];
        const frame = $371bc1a9f05b39cc$var$getFrame(modified);
        const droppableScrollChange = frame.scroll.diff.value;
        const totalChange = $371bc1a9f05b39cc$var$add(windowScrollChange, droppableScrollChange);
        const moved = $371bc1a9f05b39cc$var$offsetDraggable({
            draggable: draggable,
            offset: totalChange,
            initialWindowScroll: viewport.scroll.initial
        });
        return moved;
    });
};
const $371bc1a9f05b39cc$var$timingsKey = "Processing dynamic changes";
var $371bc1a9f05b39cc$var$publishWhileDraggingInVirtual = ({ state: state, published: published })=>{
    $371bc1a9f05b39cc$var$start();
    const withScrollChange = published.modified.map((update)=>{
        const existing = state.dimensions.droppables[update.droppableId];
        const scrolled = $371bc1a9f05b39cc$var$scrollDroppable(existing, update.scroll);
        return scrolled;
    });
    const droppables = {
        ...state.dimensions.droppables,
        ...$371bc1a9f05b39cc$var$toDroppableMap(withScrollChange)
    };
    const updatedAdditions = $371bc1a9f05b39cc$var$toDraggableMap($371bc1a9f05b39cc$var$adjustAdditionsForScrollChanges({
        additions: published.additions,
        updatedDroppables: droppables,
        viewport: state.viewport
    }));
    const draggables = {
        ...state.dimensions.draggables,
        ...updatedAdditions
    };
    published.removals.forEach((id)=>{
        delete draggables[id];
    });
    const dimensions = {
        droppables: droppables,
        draggables: draggables
    };
    const wasOverId = $371bc1a9f05b39cc$var$whatIsDraggedOver(state.impact);
    const wasOver = wasOverId ? dimensions.droppables[wasOverId] : null;
    const draggable = dimensions.draggables[state.critical.draggable.id];
    const home = dimensions.droppables[state.critical.droppable.id];
    const { impact: onLiftImpact, afterCritical: afterCritical } = $371bc1a9f05b39cc$var$getLiftEffect({
        draggable: draggable,
        home: home,
        draggables: draggables,
        viewport: state.viewport
    });
    const previousImpact = wasOver && wasOver.isCombineEnabled ? state.impact : onLiftImpact;
    const impact = $371bc1a9f05b39cc$var$getDragImpact({
        pageOffset: state.current.page.offset,
        draggable: dimensions.draggables[state.critical.draggable.id],
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: previousImpact,
        viewport: state.viewport,
        afterCritical: afterCritical
    });
    $371bc1a9f05b39cc$var$finish($371bc1a9f05b39cc$var$timingsKey);
    const draggingState = {
        ...state,
        phase: "DRAGGING",
        impact: impact,
        onLiftImpact: onLiftImpact,
        dimensions: dimensions,
        afterCritical: afterCritical,
        forceShouldAnimate: false
    };
    if (state.phase === "COLLECTING") return draggingState;
    const dropPending = {
        ...draggingState,
        phase: "DROP_PENDING",
        reason: state.reason,
        isWaiting: false
    };
    return dropPending;
};
const $371bc1a9f05b39cc$var$isSnapping = (state)=>state.movementMode === "SNAP";
const $371bc1a9f05b39cc$var$postDroppableChange = (state, updated, isEnabledChanging)=>{
    const dimensions = $371bc1a9f05b39cc$var$patchDimensionMap(state.dimensions, updated);
    if (!$371bc1a9f05b39cc$var$isSnapping(state) || isEnabledChanging) return $371bc1a9f05b39cc$var$update({
        state: state,
        dimensions: dimensions
    });
    return $371bc1a9f05b39cc$var$refreshSnap({
        state: state,
        dimensions: dimensions
    });
};
function $371bc1a9f05b39cc$var$removeScrollJumpRequest(state) {
    if (state.isDragging && state.movementMode === "SNAP") return {
        ...state,
        scrollJumpRequest: null
    };
    return state;
}
const $371bc1a9f05b39cc$var$idle$2 = {
    phase: "IDLE",
    completed: null,
    shouldFlush: false
};
var $371bc1a9f05b39cc$var$reducer = (state = $371bc1a9f05b39cc$var$idle$2, action)=>{
    if (action.type === "FLUSH") return {
        ...$371bc1a9f05b39cc$var$idle$2,
        shouldFlush: true
    };
    if (action.type === "INITIAL_PUBLISH") {
        !(state.phase === "IDLE") && $371bc1a9f05b39cc$var$invariant();
        const { critical: critical, clientSelection: clientSelection, viewport: viewport, dimensions: dimensions, movementMode: movementMode } = action.payload;
        const draggable = dimensions.draggables[critical.draggable.id];
        const home = dimensions.droppables[critical.droppable.id];
        const client = {
            selection: clientSelection,
            borderBoxCenter: draggable.client.borderBox.center,
            offset: $371bc1a9f05b39cc$var$origin
        };
        const initial = {
            client: client,
            page: {
                selection: $371bc1a9f05b39cc$var$add(client.selection, viewport.scroll.initial),
                borderBoxCenter: $371bc1a9f05b39cc$var$add(client.selection, viewport.scroll.initial),
                offset: $371bc1a9f05b39cc$var$add(client.selection, viewport.scroll.diff.value)
            }
        };
        const isWindowScrollAllowed = $371bc1a9f05b39cc$var$toDroppableList(dimensions.droppables).every((item)=>!item.isFixedOnPage);
        const { impact: impact, afterCritical: afterCritical } = $371bc1a9f05b39cc$var$getLiftEffect({
            draggable: draggable,
            home: home,
            draggables: dimensions.draggables,
            viewport: viewport
        });
        const result = {
            phase: "DRAGGING",
            isDragging: true,
            critical: critical,
            movementMode: movementMode,
            dimensions: dimensions,
            initial: initial,
            current: initial,
            isWindowScrollAllowed: isWindowScrollAllowed,
            impact: impact,
            afterCritical: afterCritical,
            onLiftImpact: impact,
            viewport: viewport,
            scrollJumpRequest: null,
            forceShouldAnimate: null
        };
        return result;
    }
    if (action.type === "COLLECTION_STARTING") {
        if (state.phase === "COLLECTING" || state.phase === "DROP_PENDING") return state;
        !(state.phase === "DRAGGING") && $371bc1a9f05b39cc$var$invariant();
        const result = {
            ...state,
            phase: "COLLECTING"
        };
        return result;
    }
    if (action.type === "PUBLISH_WHILE_DRAGGING") {
        !(state.phase === "COLLECTING" || state.phase === "DROP_PENDING") && $371bc1a9f05b39cc$var$invariant();
        return $371bc1a9f05b39cc$var$publishWhileDraggingInVirtual({
            state: state,
            published: action.payload
        });
    }
    if (action.type === "MOVE") {
        if (state.phase === "DROP_PENDING") return state;
        !$371bc1a9f05b39cc$var$isMovementAllowed(state) && $371bc1a9f05b39cc$var$invariant();
        const { client: clientSelection } = action.payload;
        if ($371bc1a9f05b39cc$var$isEqual$1(clientSelection, state.current.client.selection)) return state;
        return $371bc1a9f05b39cc$var$update({
            state: state,
            clientSelection: clientSelection,
            impact: $371bc1a9f05b39cc$var$isSnapping(state) ? state.impact : null
        });
    }
    if (action.type === "UPDATE_DROPPABLE_SCROLL") {
        if (state.phase === "DROP_PENDING") return $371bc1a9f05b39cc$var$removeScrollJumpRequest(state);
        if (state.phase === "COLLECTING") return $371bc1a9f05b39cc$var$removeScrollJumpRequest(state);
        !$371bc1a9f05b39cc$var$isMovementAllowed(state) && $371bc1a9f05b39cc$var$invariant();
        const { id: id, newScroll: newScroll } = action.payload;
        const target = state.dimensions.droppables[id];
        if (!target) return state;
        const scrolled = $371bc1a9f05b39cc$var$scrollDroppable(target, newScroll);
        return $371bc1a9f05b39cc$var$postDroppableChange(state, scrolled, false);
    }
    if (action.type === "UPDATE_DROPPABLE_IS_ENABLED") {
        if (state.phase === "DROP_PENDING") return state;
        !$371bc1a9f05b39cc$var$isMovementAllowed(state) && $371bc1a9f05b39cc$var$invariant();
        const { id: id, isEnabled: isEnabled } = action.payload;
        const target = state.dimensions.droppables[id];
        !target && $371bc1a9f05b39cc$var$invariant();
        !(target.isEnabled !== isEnabled) && $371bc1a9f05b39cc$var$invariant();
        const updated = {
            ...target,
            isEnabled: isEnabled
        };
        return $371bc1a9f05b39cc$var$postDroppableChange(state, updated, true);
    }
    if (action.type === "UPDATE_DROPPABLE_IS_COMBINE_ENABLED") {
        if (state.phase === "DROP_PENDING") return state;
        !$371bc1a9f05b39cc$var$isMovementAllowed(state) && $371bc1a9f05b39cc$var$invariant();
        const { id: id, isCombineEnabled: isCombineEnabled } = action.payload;
        const target = state.dimensions.droppables[id];
        !target && $371bc1a9f05b39cc$var$invariant();
        !(target.isCombineEnabled !== isCombineEnabled) && $371bc1a9f05b39cc$var$invariant();
        const updated = {
            ...target,
            isCombineEnabled: isCombineEnabled
        };
        return $371bc1a9f05b39cc$var$postDroppableChange(state, updated, true);
    }
    if (action.type === "MOVE_BY_WINDOW_SCROLL") {
        if (state.phase === "DROP_PENDING" || state.phase === "DROP_ANIMATING") return state;
        !$371bc1a9f05b39cc$var$isMovementAllowed(state) && $371bc1a9f05b39cc$var$invariant();
        !state.isWindowScrollAllowed && $371bc1a9f05b39cc$var$invariant();
        const newScroll = action.payload.newScroll;
        if ($371bc1a9f05b39cc$var$isEqual$1(state.viewport.scroll.current, newScroll)) return $371bc1a9f05b39cc$var$removeScrollJumpRequest(state);
        const viewport = $371bc1a9f05b39cc$var$scrollViewport(state.viewport, newScroll);
        if ($371bc1a9f05b39cc$var$isSnapping(state)) return $371bc1a9f05b39cc$var$refreshSnap({
            state: state,
            viewport: viewport
        });
        return $371bc1a9f05b39cc$var$update({
            state: state,
            viewport: viewport
        });
    }
    if (action.type === "UPDATE_VIEWPORT_MAX_SCROLL") {
        if (!$371bc1a9f05b39cc$var$isMovementAllowed(state)) return state;
        const maxScroll = action.payload.maxScroll;
        if ($371bc1a9f05b39cc$var$isEqual$1(maxScroll, state.viewport.scroll.max)) return state;
        const withMaxScroll = {
            ...state.viewport,
            scroll: {
                ...state.viewport.scroll,
                max: maxScroll
            }
        };
        return {
            ...state,
            viewport: withMaxScroll
        };
    }
    if (action.type === "MOVE_UP" || action.type === "MOVE_DOWN" || action.type === "MOVE_LEFT" || action.type === "MOVE_RIGHT") {
        if (state.phase === "COLLECTING" || state.phase === "DROP_PENDING") return state;
        !(state.phase === "DRAGGING") && $371bc1a9f05b39cc$var$invariant();
        const result = $371bc1a9f05b39cc$var$moveInDirection({
            state: state,
            type: action.type
        });
        if (!result) return state;
        return $371bc1a9f05b39cc$var$update({
            state: state,
            impact: result.impact,
            clientSelection: result.clientSelection,
            scrollJumpRequest: result.scrollJumpRequest
        });
    }
    if (action.type === "DROP_PENDING") {
        const reason = action.payload.reason;
        !(state.phase === "COLLECTING") && $371bc1a9f05b39cc$var$invariant();
        const newState = {
            ...state,
            phase: "DROP_PENDING",
            isWaiting: true,
            reason: reason
        };
        return newState;
    }
    if (action.type === "DROP_ANIMATE") {
        const { completed: completed, dropDuration: dropDuration, newHomeClientOffset: newHomeClientOffset } = action.payload;
        !(state.phase === "DRAGGING" || state.phase === "DROP_PENDING") && $371bc1a9f05b39cc$var$invariant();
        const result = {
            phase: "DROP_ANIMATING",
            completed: completed,
            dropDuration: dropDuration,
            newHomeClientOffset: newHomeClientOffset,
            dimensions: state.dimensions
        };
        return result;
    }
    if (action.type === "DROP_COMPLETE") {
        const { completed: completed } = action.payload;
        return {
            phase: "IDLE",
            completed: completed,
            shouldFlush: false
        };
    }
    return state;
};
function $371bc1a9f05b39cc$var$guard(action, predicate) {
    return action instanceof Object && "type" in action && action.type === predicate;
}
const $371bc1a9f05b39cc$var$beforeInitialCapture = (args)=>({
        type: "BEFORE_INITIAL_CAPTURE",
        payload: args
    });
const $371bc1a9f05b39cc$var$lift$1 = (args)=>({
        type: "LIFT",
        payload: args
    });
const $371bc1a9f05b39cc$var$initialPublish = (args)=>({
        type: "INITIAL_PUBLISH",
        payload: args
    });
const $371bc1a9f05b39cc$var$publishWhileDragging = (args)=>({
        type: "PUBLISH_WHILE_DRAGGING",
        payload: args
    });
const $371bc1a9f05b39cc$var$collectionStarting = ()=>({
        type: "COLLECTION_STARTING",
        payload: null
    });
const $371bc1a9f05b39cc$var$updateDroppableScroll = (args)=>({
        type: "UPDATE_DROPPABLE_SCROLL",
        payload: args
    });
const $371bc1a9f05b39cc$var$updateDroppableIsEnabled = (args)=>({
        type: "UPDATE_DROPPABLE_IS_ENABLED",
        payload: args
    });
const $371bc1a9f05b39cc$var$updateDroppableIsCombineEnabled = (args)=>({
        type: "UPDATE_DROPPABLE_IS_COMBINE_ENABLED",
        payload: args
    });
const $371bc1a9f05b39cc$var$move = (args)=>({
        type: "MOVE",
        payload: args
    });
const $371bc1a9f05b39cc$var$moveByWindowScroll = (args)=>({
        type: "MOVE_BY_WINDOW_SCROLL",
        payload: args
    });
const $371bc1a9f05b39cc$var$updateViewportMaxScroll = (args)=>({
        type: "UPDATE_VIEWPORT_MAX_SCROLL",
        payload: args
    });
const $371bc1a9f05b39cc$var$moveUp = ()=>({
        type: "MOVE_UP",
        payload: null
    });
const $371bc1a9f05b39cc$var$moveDown = ()=>({
        type: "MOVE_DOWN",
        payload: null
    });
const $371bc1a9f05b39cc$var$moveRight = ()=>({
        type: "MOVE_RIGHT",
        payload: null
    });
const $371bc1a9f05b39cc$var$moveLeft = ()=>({
        type: "MOVE_LEFT",
        payload: null
    });
const $371bc1a9f05b39cc$var$flush = ()=>({
        type: "FLUSH",
        payload: null
    });
const $371bc1a9f05b39cc$var$animateDrop = (args)=>({
        type: "DROP_ANIMATE",
        payload: args
    });
const $371bc1a9f05b39cc$var$completeDrop = (args)=>({
        type: "DROP_COMPLETE",
        payload: args
    });
const $371bc1a9f05b39cc$var$drop = (args)=>({
        type: "DROP",
        payload: args
    });
const $371bc1a9f05b39cc$var$dropPending = (args)=>({
        type: "DROP_PENDING",
        payload: args
    });
const $371bc1a9f05b39cc$var$dropAnimationFinished = ()=>({
        type: "DROP_ANIMATION_FINISHED",
        payload: null
    });
function $371bc1a9f05b39cc$var$checkIndexes(insideDestination) {
    if (insideDestination.length <= 1) return;
    const indexes = insideDestination.map((d)=>d.descriptor.index);
    const errors = {};
    for(let i = 1; i < indexes.length; i++){
        const current = indexes[i];
        const previous = indexes[i - 1];
        if (current !== previous + 1) errors[current] = true;
    }
    if (!Object.keys(errors).length) return;
    const formatted = indexes.map((index)=>{
        const hasError = Boolean(errors[index]);
        return hasError ? `[\u{1F525}${index}]` : `${index}`;
    }).join(", ");
}
function $371bc1a9f05b39cc$var$validateDimensions(critical, dimensions) {}
var $371bc1a9f05b39cc$var$lift = (marshal)=>({ getState: getState, dispatch: dispatch })=>(next)=>(action)=>{
                if (!$371bc1a9f05b39cc$var$guard(action, "LIFT")) {
                    next(action);
                    return;
                }
                const { id: id, clientSelection: clientSelection, movementMode: movementMode } = action.payload;
                const initial = getState();
                if (initial.phase === "DROP_ANIMATING") dispatch($371bc1a9f05b39cc$var$completeDrop({
                    completed: initial.completed
                }));
                !(getState().phase === "IDLE") && $371bc1a9f05b39cc$var$invariant();
                dispatch($371bc1a9f05b39cc$var$flush());
                dispatch($371bc1a9f05b39cc$var$beforeInitialCapture({
                    draggableId: id,
                    movementMode: movementMode
                }));
                const scrollOptions = {
                    shouldPublishImmediately: movementMode === "SNAP"
                };
                const request = {
                    draggableId: id,
                    scrollOptions: scrollOptions
                };
                const { critical: critical, dimensions: dimensions, viewport: viewport } = marshal.startPublishing(request);
                $371bc1a9f05b39cc$var$validateDimensions(critical, dimensions);
                dispatch($371bc1a9f05b39cc$var$initialPublish({
                    critical: critical,
                    dimensions: dimensions,
                    clientSelection: clientSelection,
                    movementMode: movementMode,
                    viewport: viewport
                }));
            };
var $371bc1a9f05b39cc$var$style = (marshal)=>()=>(next)=>(action)=>{
                if ($371bc1a9f05b39cc$var$guard(action, "INITIAL_PUBLISH")) marshal.dragging();
                if ($371bc1a9f05b39cc$var$guard(action, "DROP_ANIMATE")) marshal.dropping(action.payload.completed.result.reason);
                if ($371bc1a9f05b39cc$var$guard(action, "FLUSH") || $371bc1a9f05b39cc$var$guard(action, "DROP_COMPLETE")) marshal.resting();
                next(action);
            };
const $371bc1a9f05b39cc$var$curves = {
    outOfTheWay: "cubic-bezier(0.2, 0, 0, 1)",
    drop: "cubic-bezier(.2,1,.1,1)"
};
const $371bc1a9f05b39cc$var$combine = {
    opacity: {
        drop: 0,
        combining: 0.7
    },
    scale: {
        drop: 0.75
    }
};
const $371bc1a9f05b39cc$var$timings = {
    outOfTheWay: 0.2,
    minDropTime: 0.33,
    maxDropTime: 0.55
};
const $371bc1a9f05b39cc$var$outOfTheWayTiming = `${$371bc1a9f05b39cc$var$timings.outOfTheWay}s ${$371bc1a9f05b39cc$var$curves.outOfTheWay}`;
const $371bc1a9f05b39cc$var$transitions = {
    fluid: `opacity ${$371bc1a9f05b39cc$var$outOfTheWayTiming}`,
    snap: `transform ${$371bc1a9f05b39cc$var$outOfTheWayTiming}, opacity ${$371bc1a9f05b39cc$var$outOfTheWayTiming}`,
    drop: (duration)=>{
        const timing = `${duration}s ${$371bc1a9f05b39cc$var$curves.drop}`;
        return `transform ${timing}, opacity ${timing}`;
    },
    outOfTheWay: `transform ${$371bc1a9f05b39cc$var$outOfTheWayTiming}`,
    placeholder: `height ${$371bc1a9f05b39cc$var$outOfTheWayTiming}, width ${$371bc1a9f05b39cc$var$outOfTheWayTiming}, margin ${$371bc1a9f05b39cc$var$outOfTheWayTiming}`
};
const $371bc1a9f05b39cc$var$moveTo = (offset)=>$371bc1a9f05b39cc$var$isEqual$1(offset, $371bc1a9f05b39cc$var$origin) ? undefined : `translate(${offset.x}px, ${offset.y}px)`;
const $371bc1a9f05b39cc$var$transforms = {
    moveTo: $371bc1a9f05b39cc$var$moveTo,
    drop: (offset, isCombining)=>{
        const translate = $371bc1a9f05b39cc$var$moveTo(offset);
        if (!translate) return undefined;
        if (!isCombining) return translate;
        return `${translate} scale(${$371bc1a9f05b39cc$var$combine.scale.drop})`;
    }
};
const { minDropTime: $371bc1a9f05b39cc$var$minDropTime, maxDropTime: $371bc1a9f05b39cc$var$maxDropTime } = $371bc1a9f05b39cc$var$timings;
const $371bc1a9f05b39cc$var$dropTimeRange = $371bc1a9f05b39cc$var$maxDropTime - $371bc1a9f05b39cc$var$minDropTime;
const $371bc1a9f05b39cc$var$maxDropTimeAtDistance = 1500;
const $371bc1a9f05b39cc$var$cancelDropModifier = 0.6;
var $371bc1a9f05b39cc$var$getDropDuration = ({ current: current, destination: destination, reason: reason })=>{
    const distance$1 = $371bc1a9f05b39cc$var$distance(current, destination);
    if (distance$1 <= 0) return $371bc1a9f05b39cc$var$minDropTime;
    if (distance$1 >= $371bc1a9f05b39cc$var$maxDropTimeAtDistance) return $371bc1a9f05b39cc$var$maxDropTime;
    const percentage = distance$1 / $371bc1a9f05b39cc$var$maxDropTimeAtDistance;
    const duration = $371bc1a9f05b39cc$var$minDropTime + $371bc1a9f05b39cc$var$dropTimeRange * percentage;
    const withDuration = reason === "CANCEL" ? duration * $371bc1a9f05b39cc$var$cancelDropModifier : duration;
    return Number(withDuration.toFixed(2));
};
var $371bc1a9f05b39cc$var$getNewHomeClientOffset = ({ impact: impact, draggable: draggable, dimensions: dimensions, viewport: viewport, afterCritical: afterCritical })=>{
    const { draggables: draggables, droppables: droppables } = dimensions;
    const droppableId = $371bc1a9f05b39cc$var$whatIsDraggedOver(impact);
    const destination = droppableId ? droppables[droppableId] : null;
    const home = droppables[draggable.descriptor.droppableId];
    const newClientCenter = $371bc1a9f05b39cc$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        afterCritical: afterCritical,
        droppable: destination || home,
        viewport: viewport
    });
    const offset = $371bc1a9f05b39cc$var$subtract(newClientCenter, draggable.client.borderBox.center);
    return offset;
};
var $371bc1a9f05b39cc$var$getDropImpact = ({ draggables: draggables, reason: reason, lastImpact: lastImpact, home: home, viewport: viewport, onLiftImpact: onLiftImpact })=>{
    if (!lastImpact.at || reason !== "DROP") {
        const recomputedHomeImpact = $371bc1a9f05b39cc$var$recompute({
            draggables: draggables,
            impact: onLiftImpact,
            destination: home,
            viewport: viewport,
            forceShouldAnimate: true
        });
        return {
            impact: recomputedHomeImpact,
            didDropInsideDroppable: false
        };
    }
    if (lastImpact.at.type === "REORDER") return {
        impact: lastImpact,
        didDropInsideDroppable: true
    };
    const withoutMovement = {
        ...lastImpact,
        displaced: $371bc1a9f05b39cc$var$emptyGroups
    };
    return {
        impact: withoutMovement,
        didDropInsideDroppable: true
    };
};
const $371bc1a9f05b39cc$var$dropMiddleware = ({ getState: getState, dispatch: dispatch })=>(next)=>(action)=>{
            if (!$371bc1a9f05b39cc$var$guard(action, "DROP")) {
                next(action);
                return;
            }
            const state = getState();
            const reason = action.payload.reason;
            if (state.phase === "COLLECTING") {
                dispatch($371bc1a9f05b39cc$var$dropPending({
                    reason: reason
                }));
                return;
            }
            if (state.phase === "IDLE") return;
            const isWaitingForDrop = state.phase === "DROP_PENDING" && state.isWaiting;
            !!isWaitingForDrop && $371bc1a9f05b39cc$var$invariant();
            !(state.phase === "DRAGGING" || state.phase === "DROP_PENDING") && $371bc1a9f05b39cc$var$invariant();
            const critical = state.critical;
            const dimensions = state.dimensions;
            const draggable = dimensions.draggables[state.critical.draggable.id];
            const { impact: impact, didDropInsideDroppable: didDropInsideDroppable } = $371bc1a9f05b39cc$var$getDropImpact({
                reason: reason,
                lastImpact: state.impact,
                afterCritical: state.afterCritical,
                onLiftImpact: state.onLiftImpact,
                home: state.dimensions.droppables[state.critical.droppable.id],
                viewport: state.viewport,
                draggables: state.dimensions.draggables
            });
            const destination = didDropInsideDroppable ? $371bc1a9f05b39cc$var$tryGetDestination(impact) : null;
            const combine = didDropInsideDroppable ? $371bc1a9f05b39cc$var$tryGetCombine(impact) : null;
            const source = {
                index: critical.draggable.index,
                droppableId: critical.droppable.id
            };
            const result = {
                draggableId: draggable.descriptor.id,
                type: draggable.descriptor.type,
                source: source,
                reason: reason,
                mode: state.movementMode,
                destination: destination,
                combine: combine
            };
            const newHomeClientOffset = $371bc1a9f05b39cc$var$getNewHomeClientOffset({
                impact: impact,
                draggable: draggable,
                dimensions: dimensions,
                viewport: state.viewport,
                afterCritical: state.afterCritical
            });
            const completed = {
                critical: state.critical,
                afterCritical: state.afterCritical,
                result: result,
                impact: impact
            };
            const isAnimationRequired = !$371bc1a9f05b39cc$var$isEqual$1(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);
            if (!isAnimationRequired) {
                dispatch($371bc1a9f05b39cc$var$completeDrop({
                    completed: completed
                }));
                return;
            }
            const dropDuration = $371bc1a9f05b39cc$var$getDropDuration({
                current: state.current.client.offset,
                destination: newHomeClientOffset,
                reason: reason
            });
            const args = {
                newHomeClientOffset: newHomeClientOffset,
                dropDuration: dropDuration,
                completed: completed
            };
            dispatch($371bc1a9f05b39cc$var$animateDrop(args));
        };
var $371bc1a9f05b39cc$var$getWindowScroll = ()=>({
        x: window.pageXOffset,
        y: window.pageYOffset
    });
function $371bc1a9f05b39cc$var$getWindowScrollBinding(update) {
    return {
        eventName: "scroll",
        options: {
            passive: true,
            capture: false
        },
        fn: (event)=>{
            if (event.target !== window && event.target !== window.document) return;
            update();
        }
    };
}
function $371bc1a9f05b39cc$var$getScrollListener({ onWindowScroll: onWindowScroll }) {
    function updateScroll() {
        onWindowScroll($371bc1a9f05b39cc$var$getWindowScroll());
    }
    const scheduled = (0, $RIdqi.default)(updateScroll);
    const binding = $371bc1a9f05b39cc$var$getWindowScrollBinding(scheduled);
    let unbind = $371bc1a9f05b39cc$var$noop$2;
    function isActive() {
        return unbind !== $371bc1a9f05b39cc$var$noop$2;
    }
    function start() {
        !!isActive() && $371bc1a9f05b39cc$var$invariant();
        unbind = $371bc1a9f05b39cc$var$bindEvents(window, [
            binding
        ]);
    }
    function stop() {
        !isActive() && $371bc1a9f05b39cc$var$invariant();
        scheduled.cancel();
        unbind();
        unbind = $371bc1a9f05b39cc$var$noop$2;
    }
    return {
        start: start,
        stop: stop,
        isActive: isActive
    };
}
const $371bc1a9f05b39cc$var$shouldStop$1 = (action)=>$371bc1a9f05b39cc$var$guard(action, "DROP_COMPLETE") || $371bc1a9f05b39cc$var$guard(action, "DROP_ANIMATE") || $371bc1a9f05b39cc$var$guard(action, "FLUSH");
const $371bc1a9f05b39cc$var$scrollListener = (store)=>{
    const listener = $371bc1a9f05b39cc$var$getScrollListener({
        onWindowScroll: (newScroll)=>{
            store.dispatch($371bc1a9f05b39cc$var$moveByWindowScroll({
                newScroll: newScroll
            }));
        }
    });
    return (next)=>(action)=>{
            if (!listener.isActive() && $371bc1a9f05b39cc$var$guard(action, "INITIAL_PUBLISH")) listener.start();
            if (listener.isActive() && $371bc1a9f05b39cc$var$shouldStop$1(action)) listener.stop();
            next(action);
        };
};
var $371bc1a9f05b39cc$var$getExpiringAnnounce = (announce)=>{
    let wasCalled = false;
    let isExpired = false;
    const timeoutId = setTimeout(()=>{
        isExpired = true;
    });
    const result = (message)=>{
        if (wasCalled) return;
        if (isExpired) return;
        wasCalled = true;
        announce(message);
        clearTimeout(timeoutId);
    };
    result.wasCalled = ()=>wasCalled;
    return result;
};
var $371bc1a9f05b39cc$var$getAsyncMarshal = ()=>{
    const entries = [];
    const execute = (timerId)=>{
        const index = entries.findIndex((item)=>item.timerId === timerId);
        !(index !== -1) && $371bc1a9f05b39cc$var$invariant();
        const [entry] = entries.splice(index, 1);
        entry.callback();
    };
    const add = (fn)=>{
        const timerId = setTimeout(()=>execute(timerId));
        const entry = {
            timerId: timerId,
            callback: fn
        };
        entries.push(entry);
    };
    const flush = ()=>{
        if (!entries.length) return;
        const shallow = [
            ...entries
        ];
        entries.length = 0;
        shallow.forEach((entry)=>{
            clearTimeout(entry.timerId);
            entry.callback();
        });
    };
    return {
        add: add,
        flush: flush
    };
};
const $371bc1a9f05b39cc$var$areLocationsEqual = (first, second)=>{
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.droppableId === second.droppableId && first.index === second.index;
};
const $371bc1a9f05b39cc$var$isCombineEqual = (first, second)=>{
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.draggableId === second.draggableId && first.droppableId === second.droppableId;
};
const $371bc1a9f05b39cc$var$isCriticalEqual = (first, second)=>{
    if (first === second) return true;
    const isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
    const isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
    return isDraggableEqual && isDroppableEqual;
};
const $371bc1a9f05b39cc$var$withTimings = (key, fn)=>{
    $371bc1a9f05b39cc$var$start();
    fn();
    $371bc1a9f05b39cc$var$finish();
};
const $371bc1a9f05b39cc$var$getDragStart = (critical, mode)=>({
        draggableId: critical.draggable.id,
        type: critical.droppable.type,
        source: {
            droppableId: critical.droppable.id,
            index: critical.draggable.index
        },
        mode: mode
    });
function $371bc1a9f05b39cc$var$execute(responder, data, announce, getDefaultMessage) {
    if (!responder) {
        announce(getDefaultMessage(data));
        return;
    }
    const willExpire = $371bc1a9f05b39cc$var$getExpiringAnnounce(announce);
    const provided = {
        announce: willExpire
    };
    responder(data, provided);
    if (!willExpire.wasCalled()) announce(getDefaultMessage(data));
}
var $371bc1a9f05b39cc$var$getPublisher = (getResponders, announce)=>{
    const asyncMarshal = $371bc1a9f05b39cc$var$getAsyncMarshal();
    let dragging = null;
    const beforeCapture = (draggableId, mode)=>{
        !!dragging && $371bc1a9f05b39cc$var$invariant();
        $371bc1a9f05b39cc$var$withTimings("onBeforeCapture", ()=>{
            const fn = getResponders().onBeforeCapture;
            if (fn) {
                const before = {
                    draggableId: draggableId,
                    mode: mode
                };
                fn(before);
            }
        });
    };
    const beforeStart = (critical, mode)=>{
        !!dragging && $371bc1a9f05b39cc$var$invariant();
        $371bc1a9f05b39cc$var$withTimings("onBeforeDragStart", ()=>{
            const fn = getResponders().onBeforeDragStart;
            if (fn) fn($371bc1a9f05b39cc$var$getDragStart(critical, mode));
        });
    };
    const start = (critical, mode)=>{
        !!dragging && $371bc1a9f05b39cc$var$invariant();
        const data = $371bc1a9f05b39cc$var$getDragStart(critical, mode);
        dragging = {
            mode: mode,
            lastCritical: critical,
            lastLocation: data.source,
            lastCombine: null
        };
        asyncMarshal.add(()=>{
            $371bc1a9f05b39cc$var$withTimings("onDragStart", ()=>$371bc1a9f05b39cc$var$execute(getResponders().onDragStart, data, announce, $371bc1a9f05b39cc$var$preset.onDragStart));
        });
    };
    const update = (critical, impact)=>{
        const location = $371bc1a9f05b39cc$var$tryGetDestination(impact);
        const combine = $371bc1a9f05b39cc$var$tryGetCombine(impact);
        !dragging && $371bc1a9f05b39cc$var$invariant();
        const hasCriticalChanged = !$371bc1a9f05b39cc$var$isCriticalEqual(critical, dragging.lastCritical);
        if (hasCriticalChanged) dragging.lastCritical = critical;
        const hasLocationChanged = !$371bc1a9f05b39cc$var$areLocationsEqual(dragging.lastLocation, location);
        if (hasLocationChanged) dragging.lastLocation = location;
        const hasGroupingChanged = !$371bc1a9f05b39cc$var$isCombineEqual(dragging.lastCombine, combine);
        if (hasGroupingChanged) dragging.lastCombine = combine;
        if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) return;
        const data = {
            ...$371bc1a9f05b39cc$var$getDragStart(critical, dragging.mode),
            combine: combine,
            destination: location
        };
        asyncMarshal.add(()=>{
            $371bc1a9f05b39cc$var$withTimings("onDragUpdate", ()=>$371bc1a9f05b39cc$var$execute(getResponders().onDragUpdate, data, announce, $371bc1a9f05b39cc$var$preset.onDragUpdate));
        });
    };
    const flush = ()=>{
        !dragging && $371bc1a9f05b39cc$var$invariant();
        asyncMarshal.flush();
    };
    const drop = (result)=>{
        !dragging && $371bc1a9f05b39cc$var$invariant();
        dragging = null;
        $371bc1a9f05b39cc$var$withTimings("onDragEnd", ()=>$371bc1a9f05b39cc$var$execute(getResponders().onDragEnd, result, announce, $371bc1a9f05b39cc$var$preset.onDragEnd));
    };
    const abort = ()=>{
        if (!dragging) return;
        const result = {
            ...$371bc1a9f05b39cc$var$getDragStart(dragging.lastCritical, dragging.mode),
            combine: null,
            destination: null,
            reason: "CANCEL"
        };
        drop(result);
    };
    return {
        beforeCapture: beforeCapture,
        beforeStart: beforeStart,
        start: start,
        update: update,
        flush: flush,
        drop: drop,
        abort: abort
    };
};
var $371bc1a9f05b39cc$var$responders = (getResponders, announce)=>{
    const publisher = $371bc1a9f05b39cc$var$getPublisher(getResponders, announce);
    return (store)=>(next)=>(action)=>{
                if ($371bc1a9f05b39cc$var$guard(action, "BEFORE_INITIAL_CAPTURE")) {
                    publisher.beforeCapture(action.payload.draggableId, action.payload.movementMode);
                    return;
                }
                if ($371bc1a9f05b39cc$var$guard(action, "INITIAL_PUBLISH")) {
                    const critical = action.payload.critical;
                    publisher.beforeStart(critical, action.payload.movementMode);
                    next(action);
                    publisher.start(critical, action.payload.movementMode);
                    return;
                }
                if ($371bc1a9f05b39cc$var$guard(action, "DROP_COMPLETE")) {
                    const result = action.payload.completed.result;
                    publisher.flush();
                    next(action);
                    publisher.drop(result);
                    return;
                }
                next(action);
                if ($371bc1a9f05b39cc$var$guard(action, "FLUSH")) {
                    publisher.abort();
                    return;
                }
                const state = store.getState();
                if (state.phase === "DRAGGING") publisher.update(state.critical, state.impact);
            };
};
const $371bc1a9f05b39cc$var$dropAnimationFinishMiddleware = (store)=>(next)=>(action)=>{
            if (!$371bc1a9f05b39cc$var$guard(action, "DROP_ANIMATION_FINISHED")) {
                next(action);
                return;
            }
            const state = store.getState();
            !(state.phase === "DROP_ANIMATING") && $371bc1a9f05b39cc$var$invariant();
            store.dispatch($371bc1a9f05b39cc$var$completeDrop({
                completed: state.completed
            }));
        };
const $371bc1a9f05b39cc$var$dropAnimationFlushOnScrollMiddleware = (store)=>{
    let unbind = null;
    let frameId = null;
    function clear() {
        if (frameId) {
            cancelAnimationFrame(frameId);
            frameId = null;
        }
        if (unbind) {
            unbind();
            unbind = null;
        }
    }
    return (next)=>(action)=>{
            if ($371bc1a9f05b39cc$var$guard(action, "FLUSH") || $371bc1a9f05b39cc$var$guard(action, "DROP_COMPLETE") || $371bc1a9f05b39cc$var$guard(action, "DROP_ANIMATION_FINISHED")) clear();
            next(action);
            if (!$371bc1a9f05b39cc$var$guard(action, "DROP_ANIMATE")) return;
            const binding = {
                eventName: "scroll",
                options: {
                    capture: true,
                    passive: false,
                    once: true
                },
                fn: function flushDropAnimation() {
                    const state = store.getState();
                    if (state.phase === "DROP_ANIMATING") store.dispatch($371bc1a9f05b39cc$var$dropAnimationFinished());
                }
            };
            frameId = requestAnimationFrame(()=>{
                frameId = null;
                unbind = $371bc1a9f05b39cc$var$bindEvents(window, [
                    binding
                ]);
            });
        };
};
var $371bc1a9f05b39cc$var$dimensionMarshalStopper = (marshal)=>()=>(next)=>(action)=>{
                if ($371bc1a9f05b39cc$var$guard(action, "DROP_COMPLETE") || $371bc1a9f05b39cc$var$guard(action, "FLUSH") || $371bc1a9f05b39cc$var$guard(action, "DROP_ANIMATE")) marshal.stopPublishing();
                next(action);
            };
var $371bc1a9f05b39cc$var$focus = (marshal)=>{
    let isWatching = false;
    return ()=>(next)=>(action)=>{
                if ($371bc1a9f05b39cc$var$guard(action, "INITIAL_PUBLISH")) {
                    isWatching = true;
                    marshal.tryRecordFocus(action.payload.critical.draggable.id);
                    next(action);
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                next(action);
                if (!isWatching) return;
                if ($371bc1a9f05b39cc$var$guard(action, "FLUSH")) {
                    isWatching = false;
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                if ($371bc1a9f05b39cc$var$guard(action, "DROP_COMPLETE")) {
                    isWatching = false;
                    const result = action.payload.completed.result;
                    if (result.combine) marshal.tryShiftRecord(result.draggableId, result.combine.draggableId);
                    marshal.tryRestoreFocusRecorded();
                }
            };
};
const $371bc1a9f05b39cc$var$shouldStop = (action)=>$371bc1a9f05b39cc$var$guard(action, "DROP_COMPLETE") || $371bc1a9f05b39cc$var$guard(action, "DROP_ANIMATE") || $371bc1a9f05b39cc$var$guard(action, "FLUSH");
var $371bc1a9f05b39cc$var$autoScroll = (autoScroller)=>(store)=>(next)=>(action)=>{
                if ($371bc1a9f05b39cc$var$shouldStop(action)) {
                    autoScroller.stop();
                    next(action);
                    return;
                }
                if ($371bc1a9f05b39cc$var$guard(action, "INITIAL_PUBLISH")) {
                    next(action);
                    const state = store.getState();
                    !(state.phase === "DRAGGING") && $371bc1a9f05b39cc$var$invariant();
                    autoScroller.start(state);
                    return;
                }
                next(action);
                autoScroller.scroll(store.getState());
            };
const $371bc1a9f05b39cc$var$pendingDrop = (store)=>(next)=>(action)=>{
            next(action);
            if (!$371bc1a9f05b39cc$var$guard(action, "PUBLISH_WHILE_DRAGGING")) return;
            const postActionState = store.getState();
            if (postActionState.phase !== "DROP_PENDING") return;
            if (postActionState.isWaiting) return;
            store.dispatch($371bc1a9f05b39cc$var$drop({
                reason: postActionState.reason
            }));
        };
const $371bc1a9f05b39cc$var$composeEnhancers = (0, $gJd8P.compose);
var $371bc1a9f05b39cc$var$createStore = ({ dimensionMarshal: dimensionMarshal, focusMarshal: focusMarshal, styleMarshal: styleMarshal, getResponders: getResponders, announce: announce, autoScroller: autoScroller })=>(0, $gJd8P.createStore)($371bc1a9f05b39cc$var$reducer, $371bc1a9f05b39cc$var$composeEnhancers((0, $gJd8P.applyMiddleware)($371bc1a9f05b39cc$var$style(styleMarshal), $371bc1a9f05b39cc$var$dimensionMarshalStopper(dimensionMarshal), $371bc1a9f05b39cc$var$lift(dimensionMarshal), $371bc1a9f05b39cc$var$dropMiddleware, $371bc1a9f05b39cc$var$dropAnimationFinishMiddleware, $371bc1a9f05b39cc$var$dropAnimationFlushOnScrollMiddleware, $371bc1a9f05b39cc$var$pendingDrop, $371bc1a9f05b39cc$var$autoScroll(autoScroller), $371bc1a9f05b39cc$var$scrollListener, $371bc1a9f05b39cc$var$focus(focusMarshal), $371bc1a9f05b39cc$var$responders(getResponders, announce))));
const $371bc1a9f05b39cc$var$clean$1 = ()=>({
        additions: {},
        removals: {},
        modified: {}
    });
function $371bc1a9f05b39cc$var$createPublisher({ registry: registry, callbacks: callbacks }) {
    let staging = $371bc1a9f05b39cc$var$clean$1();
    let frameId = null;
    const collect = ()=>{
        if (frameId) return;
        callbacks.collectionStarting();
        frameId = requestAnimationFrame(()=>{
            frameId = null;
            $371bc1a9f05b39cc$var$start();
            const { additions: additions, removals: removals, modified: modified } = staging;
            const added = Object.keys(additions).map((id)=>registry.draggable.getById(id).getDimension($371bc1a9f05b39cc$var$origin)).sort((a, b)=>a.descriptor.index - b.descriptor.index);
            const updated = Object.keys(modified).map((id)=>{
                const entry = registry.droppable.getById(id);
                const scroll = entry.callbacks.getScrollWhileDragging();
                return {
                    droppableId: id,
                    scroll: scroll
                };
            });
            const result = {
                additions: added,
                removals: Object.keys(removals),
                modified: updated
            };
            staging = $371bc1a9f05b39cc$var$clean$1();
            $371bc1a9f05b39cc$var$finish();
            callbacks.publish(result);
        });
    };
    const add = (entry)=>{
        const id = entry.descriptor.id;
        staging.additions[id] = entry;
        staging.modified[entry.descriptor.droppableId] = true;
        if (staging.removals[id]) delete staging.removals[id];
        collect();
    };
    const remove = (entry)=>{
        const descriptor = entry.descriptor;
        staging.removals[descriptor.id] = true;
        staging.modified[descriptor.droppableId] = true;
        if (staging.additions[descriptor.id]) delete staging.additions[descriptor.id];
        collect();
    };
    const stop = ()=>{
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
        staging = $371bc1a9f05b39cc$var$clean$1();
    };
    return {
        add: add,
        remove: remove,
        stop: stop
    };
}
var $371bc1a9f05b39cc$var$getMaxScroll = ({ scrollHeight: scrollHeight, scrollWidth: scrollWidth, height: height, width: width })=>{
    const maxScroll = $371bc1a9f05b39cc$var$subtract({
        x: scrollWidth,
        y: scrollHeight
    }, {
        x: width,
        y: height
    });
    const adjustedMaxScroll = {
        x: Math.max(0, maxScroll.x),
        y: Math.max(0, maxScroll.y)
    };
    return adjustedMaxScroll;
};
var $371bc1a9f05b39cc$var$getDocumentElement = ()=>{
    const doc = document.documentElement;
    !doc && $371bc1a9f05b39cc$var$invariant();
    return doc;
};
var $371bc1a9f05b39cc$var$getMaxWindowScroll = ()=>{
    const doc = $371bc1a9f05b39cc$var$getDocumentElement();
    const maxScroll = $371bc1a9f05b39cc$var$getMaxScroll({
        scrollHeight: doc.scrollHeight,
        scrollWidth: doc.scrollWidth,
        width: doc.clientWidth,
        height: doc.clientHeight
    });
    return maxScroll;
};
var $371bc1a9f05b39cc$var$getViewport = ()=>{
    const scroll = $371bc1a9f05b39cc$var$getWindowScroll();
    const maxScroll = $371bc1a9f05b39cc$var$getMaxWindowScroll();
    const top = scroll.y;
    const left = scroll.x;
    const doc = $371bc1a9f05b39cc$var$getDocumentElement();
    const width = doc.clientWidth;
    const height = doc.clientHeight;
    const right = left + width;
    const bottom = top + height;
    const frame = (0, $8rsfJ.getRect)({
        top: top,
        left: left,
        right: right,
        bottom: bottom
    });
    const viewport = {
        frame: frame,
        scroll: {
            initial: scroll,
            current: scroll,
            max: maxScroll,
            diff: {
                value: $371bc1a9f05b39cc$var$origin,
                displacement: $371bc1a9f05b39cc$var$origin
            }
        }
    };
    return viewport;
};
var $371bc1a9f05b39cc$var$getInitialPublish = ({ critical: critical, scrollOptions: scrollOptions, registry: registry })=>{
    $371bc1a9f05b39cc$var$start();
    const viewport = $371bc1a9f05b39cc$var$getViewport();
    const windowScroll = viewport.scroll.current;
    const home = critical.droppable;
    const droppables = registry.droppable.getAllByType(home.type).map((entry)=>entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions));
    const draggables = registry.draggable.getAllByType(critical.draggable.type).map((entry)=>entry.getDimension(windowScroll));
    const dimensions = {
        draggables: $371bc1a9f05b39cc$var$toDraggableMap(draggables),
        droppables: $371bc1a9f05b39cc$var$toDroppableMap(droppables)
    };
    $371bc1a9f05b39cc$var$finish();
    const result = {
        dimensions: dimensions,
        critical: critical,
        viewport: viewport
    };
    return result;
};
function $371bc1a9f05b39cc$var$shouldPublishUpdate(registry, dragging, entry) {
    if (entry.descriptor.id === dragging.id) return false;
    if (entry.descriptor.type !== dragging.type) return false;
    const home = registry.droppable.getById(entry.descriptor.droppableId);
    if (home.descriptor.mode !== "virtual") return false;
    return true;
}
var $371bc1a9f05b39cc$var$createDimensionMarshal = (registry, callbacks)=>{
    let collection = null;
    const publisher = $371bc1a9f05b39cc$var$createPublisher({
        callbacks: {
            publish: callbacks.publishWhileDragging,
            collectionStarting: callbacks.collectionStarting
        },
        registry: registry
    });
    const updateDroppableIsEnabled = (id, isEnabled)=>{
        !registry.droppable.exists(id) && $371bc1a9f05b39cc$var$invariant();
        if (!collection) return;
        callbacks.updateDroppableIsEnabled({
            id: id,
            isEnabled: isEnabled
        });
    };
    const updateDroppableIsCombineEnabled = (id, isCombineEnabled)=>{
        if (!collection) return;
        !registry.droppable.exists(id) && $371bc1a9f05b39cc$var$invariant();
        callbacks.updateDroppableIsCombineEnabled({
            id: id,
            isCombineEnabled: isCombineEnabled
        });
    };
    const updateDroppableScroll = (id, newScroll)=>{
        if (!collection) return;
        !registry.droppable.exists(id) && $371bc1a9f05b39cc$var$invariant();
        callbacks.updateDroppableScroll({
            id: id,
            newScroll: newScroll
        });
    };
    const scrollDroppable = (id, change)=>{
        if (!collection) return;
        registry.droppable.getById(id).callbacks.scroll(change);
    };
    const stopPublishing = ()=>{
        if (!collection) return;
        publisher.stop();
        const home = collection.critical.droppable;
        registry.droppable.getAllByType(home.type).forEach((entry)=>entry.callbacks.dragStopped());
        collection.unsubscribe();
        collection = null;
    };
    const subscriber = (event)=>{
        !collection && $371bc1a9f05b39cc$var$invariant();
        const dragging = collection.critical.draggable;
        if (event.type === "ADDITION") {
            if ($371bc1a9f05b39cc$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.add(event.value);
        }
        if (event.type === "REMOVAL") {
            if ($371bc1a9f05b39cc$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.remove(event.value);
        }
    };
    const startPublishing = (request)=>{
        !!collection && $371bc1a9f05b39cc$var$invariant();
        const entry = registry.draggable.getById(request.draggableId);
        const home = registry.droppable.getById(entry.descriptor.droppableId);
        const critical = {
            draggable: entry.descriptor,
            droppable: home.descriptor
        };
        const unsubscribe = registry.subscribe(subscriber);
        collection = {
            critical: critical,
            unsubscribe: unsubscribe
        };
        return $371bc1a9f05b39cc$var$getInitialPublish({
            critical: critical,
            registry: registry,
            scrollOptions: request.scrollOptions
        });
    };
    const marshal = {
        updateDroppableIsEnabled: updateDroppableIsEnabled,
        updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
        scrollDroppable: scrollDroppable,
        updateDroppableScroll: updateDroppableScroll,
        startPublishing: startPublishing,
        stopPublishing: stopPublishing
    };
    return marshal;
};
var $371bc1a9f05b39cc$var$canStartDrag = (state, id)=>{
    if (state.phase === "IDLE") return true;
    if (state.phase !== "DROP_ANIMATING") return false;
    if (state.completed.result.draggableId === id) return false;
    return state.completed.result.reason === "DROP";
};
var $371bc1a9f05b39cc$var$scrollWindow = (change)=>{
    window.scrollBy(change.x, change.y);
};
const $371bc1a9f05b39cc$var$getScrollableDroppables = (0, $34S1T.default)((droppables)=>$371bc1a9f05b39cc$var$toDroppableList(droppables).filter((droppable)=>{
        if (!droppable.isEnabled) return false;
        if (!droppable.frame) return false;
        return true;
    }));
const $371bc1a9f05b39cc$var$getScrollableDroppableOver = (target, droppables)=>{
    const maybe = $371bc1a9f05b39cc$var$getScrollableDroppables(droppables).find((droppable)=>{
        !droppable.frame && $371bc1a9f05b39cc$var$invariant();
        return $371bc1a9f05b39cc$var$isPositionInFrame(droppable.frame.pageMarginBox)(target);
    }) || null;
    return maybe;
};
var $371bc1a9f05b39cc$var$getBestScrollableDroppable = ({ center: center, destination: destination, droppables: droppables })=>{
    if (destination) {
        const dimension = droppables[destination];
        if (!dimension.frame) return null;
        return dimension;
    }
    const dimension = $371bc1a9f05b39cc$var$getScrollableDroppableOver(center, droppables);
    return dimension;
};
const $371bc1a9f05b39cc$var$defaultAutoScrollerOptions = {
    startFromPercentage: 0.25,
    maxScrollAtPercentage: 0.05,
    maxPixelScroll: 28,
    ease: (percentage)=>percentage ** 2,
    durationDampening: {
        stopDampeningAt: 1200,
        accelerateAt: 360
    },
    disabled: false
};
var $371bc1a9f05b39cc$var$getDistanceThresholds = (container, axis, getAutoScrollerOptions = ()=>$371bc1a9f05b39cc$var$defaultAutoScrollerOptions)=>{
    const autoScrollerOptions = getAutoScrollerOptions();
    const startScrollingFrom = container[axis.size] * autoScrollerOptions.startFromPercentage;
    const maxScrollValueAt = container[axis.size] * autoScrollerOptions.maxScrollAtPercentage;
    const thresholds = {
        startScrollingFrom: startScrollingFrom,
        maxScrollValueAt: maxScrollValueAt
    };
    return thresholds;
};
var $371bc1a9f05b39cc$var$getPercentage = ({ startOfRange: startOfRange, endOfRange: endOfRange, current: current })=>{
    const range = endOfRange - startOfRange;
    if (range === 0) return 0;
    const currentInRange = current - startOfRange;
    const percentage = currentInRange / range;
    return percentage;
};
var $371bc1a9f05b39cc$var$minScroll = 1;
var $371bc1a9f05b39cc$var$getValueFromDistance = (distanceToEdge, thresholds, getAutoScrollerOptions = ()=>$371bc1a9f05b39cc$var$defaultAutoScrollerOptions)=>{
    const autoScrollerOptions = getAutoScrollerOptions();
    if (distanceToEdge > thresholds.startScrollingFrom) return 0;
    if (distanceToEdge <= thresholds.maxScrollValueAt) return autoScrollerOptions.maxPixelScroll;
    if (distanceToEdge === thresholds.startScrollingFrom) return $371bc1a9f05b39cc$var$minScroll;
    const percentageFromMaxScrollValueAt = $371bc1a9f05b39cc$var$getPercentage({
        startOfRange: thresholds.maxScrollValueAt,
        endOfRange: thresholds.startScrollingFrom,
        current: distanceToEdge
    });
    const percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
    const scroll = autoScrollerOptions.maxPixelScroll * autoScrollerOptions.ease(percentageFromStartScrollingFrom);
    return Math.ceil(scroll);
};
var $371bc1a9f05b39cc$var$dampenValueByTime = (proposedScroll, dragStartTime, getAutoScrollerOptions)=>{
    const autoScrollerOptions = getAutoScrollerOptions();
    const accelerateAt = autoScrollerOptions.durationDampening.accelerateAt;
    const stopAt = autoScrollerOptions.durationDampening.stopDampeningAt;
    const startOfRange = dragStartTime;
    const endOfRange = stopAt;
    const now = Date.now();
    const runTime = now - startOfRange;
    if (runTime >= stopAt) return proposedScroll;
    if (runTime < accelerateAt) return $371bc1a9f05b39cc$var$minScroll;
    const betweenAccelerateAtAndStopAtPercentage = $371bc1a9f05b39cc$var$getPercentage({
        startOfRange: accelerateAt,
        endOfRange: endOfRange,
        current: runTime
    });
    const scroll = proposedScroll * autoScrollerOptions.ease(betweenAccelerateAtAndStopAtPercentage);
    return Math.ceil(scroll);
};
var $371bc1a9f05b39cc$var$getValue = ({ distanceToEdge: distanceToEdge, thresholds: thresholds, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening, getAutoScrollerOptions: getAutoScrollerOptions })=>{
    const scroll = $371bc1a9f05b39cc$var$getValueFromDistance(distanceToEdge, thresholds, getAutoScrollerOptions);
    if (scroll === 0) return 0;
    if (!shouldUseTimeDampening) return scroll;
    return Math.max($371bc1a9f05b39cc$var$dampenValueByTime(scroll, dragStartTime, getAutoScrollerOptions), $371bc1a9f05b39cc$var$minScroll);
};
var $371bc1a9f05b39cc$var$getScrollOnAxis = ({ container: container, distanceToEdges: distanceToEdges, dragStartTime: dragStartTime, axis: axis, shouldUseTimeDampening: shouldUseTimeDampening, getAutoScrollerOptions: getAutoScrollerOptions })=>{
    const thresholds = $371bc1a9f05b39cc$var$getDistanceThresholds(container, axis, getAutoScrollerOptions);
    const isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];
    if (isCloserToEnd) return $371bc1a9f05b39cc$var$getValue({
        distanceToEdge: distanceToEdges[axis.end],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
    return -1 * $371bc1a9f05b39cc$var$getValue({
        distanceToEdge: distanceToEdges[axis.start],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
};
var $371bc1a9f05b39cc$var$adjustForSizeLimits = ({ container: container, subject: subject, proposedScroll: proposedScroll })=>{
    const isTooBigVertically = subject.height > container.height;
    const isTooBigHorizontally = subject.width > container.width;
    if (!isTooBigHorizontally && !isTooBigVertically) return proposedScroll;
    if (isTooBigHorizontally && isTooBigVertically) return null;
    return {
        x: isTooBigHorizontally ? 0 : proposedScroll.x,
        y: isTooBigVertically ? 0 : proposedScroll.y
    };
};
const $371bc1a9f05b39cc$var$clean = $371bc1a9f05b39cc$var$apply((value)=>value === 0 ? 0 : value);
var $371bc1a9f05b39cc$var$getScroll$1 = ({ dragStartTime: dragStartTime, container: container, subject: subject, center: center, shouldUseTimeDampening: shouldUseTimeDampening, getAutoScrollerOptions: getAutoScrollerOptions })=>{
    const distanceToEdges = {
        top: center.y - container.top,
        right: container.right - center.x,
        bottom: container.bottom - center.y,
        left: center.x - container.left
    };
    const y = $371bc1a9f05b39cc$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $371bc1a9f05b39cc$var$vertical,
        shouldUseTimeDampening: shouldUseTimeDampening,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
    const x = $371bc1a9f05b39cc$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $371bc1a9f05b39cc$var$horizontal,
        shouldUseTimeDampening: shouldUseTimeDampening,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
    const required = $371bc1a9f05b39cc$var$clean({
        x: x,
        y: y
    });
    if ($371bc1a9f05b39cc$var$isEqual$1(required, $371bc1a9f05b39cc$var$origin)) return null;
    const limited = $371bc1a9f05b39cc$var$adjustForSizeLimits({
        container: container,
        subject: subject,
        proposedScroll: required
    });
    if (!limited) return null;
    return $371bc1a9f05b39cc$var$isEqual$1(limited, $371bc1a9f05b39cc$var$origin) ? null : limited;
};
const $371bc1a9f05b39cc$var$smallestSigned = $371bc1a9f05b39cc$var$apply((value)=>{
    if (value === 0) return 0;
    return value > 0 ? 1 : -1;
});
const $371bc1a9f05b39cc$var$getOverlap = (()=>{
    const getRemainder = (target, max)=>{
        if (target < 0) return target;
        if (target > max) return target - max;
        return 0;
    };
    return ({ current: current, max: max, change: change })=>{
        const targetScroll = $371bc1a9f05b39cc$var$add(current, change);
        const overlap = {
            x: getRemainder(targetScroll.x, max.x),
            y: getRemainder(targetScroll.y, max.y)
        };
        if ($371bc1a9f05b39cc$var$isEqual$1(overlap, $371bc1a9f05b39cc$var$origin)) return null;
        return overlap;
    };
})();
const $371bc1a9f05b39cc$var$canPartiallyScroll = ({ max: rawMax, current: current, change: change })=>{
    const max = {
        x: Math.max(current.x, rawMax.x),
        y: Math.max(current.y, rawMax.y)
    };
    const smallestChange = $371bc1a9f05b39cc$var$smallestSigned(change);
    const overlap = $371bc1a9f05b39cc$var$getOverlap({
        max: max,
        current: current,
        change: smallestChange
    });
    if (!overlap) return true;
    if (smallestChange.x !== 0 && overlap.x === 0) return true;
    if (smallestChange.y !== 0 && overlap.y === 0) return true;
    return false;
};
const $371bc1a9f05b39cc$var$canScrollWindow = (viewport, change)=>$371bc1a9f05b39cc$var$canPartiallyScroll({
        current: viewport.scroll.current,
        max: viewport.scroll.max,
        change: change
    });
const $371bc1a9f05b39cc$var$getWindowOverlap = (viewport, change)=>{
    if (!$371bc1a9f05b39cc$var$canScrollWindow(viewport, change)) return null;
    const max = viewport.scroll.max;
    const current = viewport.scroll.current;
    return $371bc1a9f05b39cc$var$getOverlap({
        current: current,
        max: max,
        change: change
    });
};
const $371bc1a9f05b39cc$var$canScrollDroppable = (droppable, change)=>{
    const frame = droppable.frame;
    if (!frame) return false;
    return $371bc1a9f05b39cc$var$canPartiallyScroll({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
const $371bc1a9f05b39cc$var$getDroppableOverlap = (droppable, change)=>{
    const frame = droppable.frame;
    if (!frame) return null;
    if (!$371bc1a9f05b39cc$var$canScrollDroppable(droppable, change)) return null;
    return $371bc1a9f05b39cc$var$getOverlap({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $371bc1a9f05b39cc$var$getWindowScrollChange = ({ viewport: viewport, subject: subject, center: center, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening, getAutoScrollerOptions: getAutoScrollerOptions })=>{
    const scroll = $371bc1a9f05b39cc$var$getScroll$1({
        dragStartTime: dragStartTime,
        container: viewport.frame,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
    return scroll && $371bc1a9f05b39cc$var$canScrollWindow(viewport, scroll) ? scroll : null;
};
var $371bc1a9f05b39cc$var$getDroppableScrollChange = ({ droppable: droppable, subject: subject, center: center, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening, getAutoScrollerOptions: getAutoScrollerOptions })=>{
    const frame = droppable.frame;
    if (!frame) return null;
    const scroll = $371bc1a9f05b39cc$var$getScroll$1({
        dragStartTime: dragStartTime,
        container: frame.pageMarginBox,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
    return scroll && $371bc1a9f05b39cc$var$canScrollDroppable(droppable, scroll) ? scroll : null;
};
var $371bc1a9f05b39cc$var$scroll = ({ state: state, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening, scrollWindow: scrollWindow, scrollDroppable: scrollDroppable, getAutoScrollerOptions: getAutoScrollerOptions })=>{
    const center = state.current.page.borderBoxCenter;
    const draggable = state.dimensions.draggables[state.critical.draggable.id];
    const subject = draggable.page.marginBox;
    if (state.isWindowScrollAllowed) {
        const viewport = state.viewport;
        const change = $371bc1a9f05b39cc$var$getWindowScrollChange({
            dragStartTime: dragStartTime,
            viewport: viewport,
            subject: subject,
            center: center,
            shouldUseTimeDampening: shouldUseTimeDampening,
            getAutoScrollerOptions: getAutoScrollerOptions
        });
        if (change) {
            scrollWindow(change);
            return;
        }
    }
    const droppable = $371bc1a9f05b39cc$var$getBestScrollableDroppable({
        center: center,
        destination: $371bc1a9f05b39cc$var$whatIsDraggedOver(state.impact),
        droppables: state.dimensions.droppables
    });
    if (!droppable) return;
    const change = $371bc1a9f05b39cc$var$getDroppableScrollChange({
        dragStartTime: dragStartTime,
        droppable: droppable,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
    if (change) scrollDroppable(droppable.descriptor.id, change);
};
var $371bc1a9f05b39cc$var$createFluidScroller = ({ scrollWindow: scrollWindow, scrollDroppable: scrollDroppable, getAutoScrollerOptions: getAutoScrollerOptions = ()=>$371bc1a9f05b39cc$var$defaultAutoScrollerOptions })=>{
    const scheduleWindowScroll = (0, $RIdqi.default)(scrollWindow);
    const scheduleDroppableScroll = (0, $RIdqi.default)(scrollDroppable);
    let dragging = null;
    const tryScroll = (state)=>{
        !dragging && $371bc1a9f05b39cc$var$invariant();
        const { shouldUseTimeDampening: shouldUseTimeDampening, dragStartTime: dragStartTime } = dragging;
        $371bc1a9f05b39cc$var$scroll({
            state: state,
            scrollWindow: scheduleWindowScroll,
            scrollDroppable: scheduleDroppableScroll,
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: shouldUseTimeDampening,
            getAutoScrollerOptions: getAutoScrollerOptions
        });
    };
    const start$1 = (state)=>{
        $371bc1a9f05b39cc$var$start();
        !!dragging && $371bc1a9f05b39cc$var$invariant();
        const dragStartTime = Date.now();
        let wasScrollNeeded = false;
        const fakeScrollCallback = ()=>{
            wasScrollNeeded = true;
        };
        $371bc1a9f05b39cc$var$scroll({
            state: state,
            dragStartTime: 0,
            shouldUseTimeDampening: false,
            scrollWindow: fakeScrollCallback,
            scrollDroppable: fakeScrollCallback,
            getAutoScrollerOptions: getAutoScrollerOptions
        });
        dragging = {
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: wasScrollNeeded
        };
        $371bc1a9f05b39cc$var$finish();
        if (wasScrollNeeded) tryScroll(state);
    };
    const stop = ()=>{
        if (!dragging) return;
        scheduleWindowScroll.cancel();
        scheduleDroppableScroll.cancel();
        dragging = null;
    };
    return {
        start: start$1,
        stop: stop,
        scroll: tryScroll
    };
};
var $371bc1a9f05b39cc$var$createJumpScroller = ({ move: move, scrollDroppable: scrollDroppable, scrollWindow: scrollWindow })=>{
    const moveByOffset = (state, offset)=>{
        const client = $371bc1a9f05b39cc$var$add(state.current.client.selection, offset);
        move({
            client: client
        });
    };
    const scrollDroppableAsMuchAsItCan = (droppable, change)=>{
        if (!$371bc1a9f05b39cc$var$canScrollDroppable(droppable, change)) return change;
        const overlap = $371bc1a9f05b39cc$var$getDroppableOverlap(droppable, change);
        if (!overlap) {
            scrollDroppable(droppable.descriptor.id, change);
            return null;
        }
        const whatTheDroppableCanScroll = $371bc1a9f05b39cc$var$subtract(change, overlap);
        scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
        const remainder = $371bc1a9f05b39cc$var$subtract(change, whatTheDroppableCanScroll);
        return remainder;
    };
    const scrollWindowAsMuchAsItCan = (isWindowScrollAllowed, viewport, change)=>{
        if (!isWindowScrollAllowed) return change;
        if (!$371bc1a9f05b39cc$var$canScrollWindow(viewport, change)) return change;
        const overlap = $371bc1a9f05b39cc$var$getWindowOverlap(viewport, change);
        if (!overlap) {
            scrollWindow(change);
            return null;
        }
        const whatTheWindowCanScroll = $371bc1a9f05b39cc$var$subtract(change, overlap);
        scrollWindow(whatTheWindowCanScroll);
        const remainder = $371bc1a9f05b39cc$var$subtract(change, whatTheWindowCanScroll);
        return remainder;
    };
    const jumpScroller = (state)=>{
        const request = state.scrollJumpRequest;
        if (!request) return;
        const destination = $371bc1a9f05b39cc$var$whatIsDraggedOver(state.impact);
        !destination && $371bc1a9f05b39cc$var$invariant();
        const droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);
        if (!droppableRemainder) return;
        const viewport = state.viewport;
        const windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);
        if (!windowRemainder) return;
        moveByOffset(state, windowRemainder);
    };
    return jumpScroller;
};
var $371bc1a9f05b39cc$var$createAutoScroller = ({ scrollDroppable: scrollDroppable, scrollWindow: scrollWindow, move: move, getAutoScrollerOptions: getAutoScrollerOptions })=>{
    const fluidScroller = $371bc1a9f05b39cc$var$createFluidScroller({
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
    const jumpScroll = $371bc1a9f05b39cc$var$createJumpScroller({
        move: move,
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    const scroll = (state)=>{
        const autoScrollerOptions = getAutoScrollerOptions();
        if (autoScrollerOptions.disabled || state.phase !== "DRAGGING") return;
        if (state.movementMode === "FLUID") {
            fluidScroller.scroll(state);
            return;
        }
        if (!state.scrollJumpRequest) return;
        jumpScroll(state);
    };
    const scroller = {
        scroll: scroll,
        start: fluidScroller.start,
        stop: fluidScroller.stop
    };
    return scroller;
};
const $371bc1a9f05b39cc$var$prefix = "data-rfd";
const $371bc1a9f05b39cc$var$dragHandle = (()=>{
    const base = `${$371bc1a9f05b39cc$var$prefix}-drag-handle`;
    return {
        base: base,
        draggableId: `${base}-draggable-id`,
        contextId: `${base}-context-id`
    };
})();
const $371bc1a9f05b39cc$var$draggable = (()=>{
    const base = `${$371bc1a9f05b39cc$var$prefix}-draggable`;
    return {
        base: base,
        contextId: `${base}-context-id`,
        id: `${base}-id`
    };
})();
const $371bc1a9f05b39cc$var$droppable = (()=>{
    const base = `${$371bc1a9f05b39cc$var$prefix}-droppable`;
    return {
        base: base,
        contextId: `${base}-context-id`,
        id: `${base}-id`
    };
})();
const $371bc1a9f05b39cc$var$scrollContainer = {
    contextId: `${$371bc1a9f05b39cc$var$prefix}-scroll-container-context-id`
};
const $371bc1a9f05b39cc$var$makeGetSelector = (context)=>(attribute)=>`[${attribute}="${context}"]`;
const $371bc1a9f05b39cc$var$getStyles = (rules, property)=>rules.map((rule)=>{
        const value = rule.styles[property];
        if (!value) return "";
        return `${rule.selector} { ${value} }`;
    }).join(" ");
const $371bc1a9f05b39cc$var$noPointerEvents = "pointer-events: none;";
var $371bc1a9f05b39cc$var$getStyles$1 = (contextId)=>{
    const getSelector = $371bc1a9f05b39cc$var$makeGetSelector(contextId);
    const dragHandle$1 = (()=>{
        const grabCursor = `
      cursor: -webkit-grab;
      cursor: grab;
    `;
        return {
            selector: getSelector($371bc1a9f05b39cc$var$dragHandle.contextId),
            styles: {
                always: `
          -webkit-touch-callout: none;
          -webkit-tap-highlight-color: rgba(0,0,0,0);
          touch-action: manipulation;
        `,
                resting: grabCursor,
                dragging: $371bc1a9f05b39cc$var$noPointerEvents,
                dropAnimating: grabCursor
            }
        };
    })();
    const draggable$1 = (()=>{
        const transition = `
      transition: ${$371bc1a9f05b39cc$var$transitions.outOfTheWay};
    `;
        return {
            selector: getSelector($371bc1a9f05b39cc$var$draggable.contextId),
            styles: {
                dragging: transition,
                dropAnimating: transition,
                userCancel: transition
            }
        };
    })();
    const droppable$1 = {
        selector: getSelector($371bc1a9f05b39cc$var$droppable.contextId),
        styles: {
            always: `overflow-anchor: none;`
        }
    };
    const body = {
        selector: "body",
        styles: {
            dragging: `
        cursor: grabbing;
        cursor: -webkit-grabbing;
        user-select: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        overflow-anchor: none;
      `
        }
    };
    const rules = [
        draggable$1,
        dragHandle$1,
        droppable$1,
        body
    ];
    return {
        always: $371bc1a9f05b39cc$var$getStyles(rules, "always"),
        resting: $371bc1a9f05b39cc$var$getStyles(rules, "resting"),
        dragging: $371bc1a9f05b39cc$var$getStyles(rules, "dragging"),
        dropAnimating: $371bc1a9f05b39cc$var$getStyles(rules, "dropAnimating"),
        userCancel: $371bc1a9f05b39cc$var$getStyles(rules, "userCancel")
    };
};
const $371bc1a9f05b39cc$var$useIsomorphicLayoutEffect = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $jbmdS.useLayoutEffect) : (0, $jbmdS.useEffect);
const $371bc1a9f05b39cc$var$getHead = ()=>{
    const head = document.querySelector("head");
    !head && $371bc1a9f05b39cc$var$invariant();
    return head;
};
const $371bc1a9f05b39cc$var$createStyleEl = (nonce)=>{
    const el = document.createElement("style");
    if (nonce) el.setAttribute("nonce", nonce);
    el.type = "text/css";
    return el;
};
function $371bc1a9f05b39cc$var$useStyleMarshal(contextId, nonce) {
    const styles = (0, $g21f0.useMemo)(()=>$371bc1a9f05b39cc$var$getStyles$1(contextId), [
        contextId
    ]);
    const alwaysRef = (0, $jbmdS.useRef)(null);
    const dynamicRef = (0, $jbmdS.useRef)(null);
    const setDynamicStyle = (0, $g21f0.useCallback)((0, $34S1T.default)((proposed)=>{
        const el = dynamicRef.current;
        !el && $371bc1a9f05b39cc$var$invariant();
        el.textContent = proposed;
    }), []);
    const setAlwaysStyle = (0, $g21f0.useCallback)((proposed)=>{
        const el = alwaysRef.current;
        !el && $371bc1a9f05b39cc$var$invariant();
        el.textContent = proposed;
    }, []);
    $371bc1a9f05b39cc$var$useIsomorphicLayoutEffect(()=>{
        !(!alwaysRef.current && !dynamicRef.current) && $371bc1a9f05b39cc$var$invariant();
        const always = $371bc1a9f05b39cc$var$createStyleEl(nonce);
        const dynamic = $371bc1a9f05b39cc$var$createStyleEl(nonce);
        alwaysRef.current = always;
        dynamicRef.current = dynamic;
        always.setAttribute(`${$371bc1a9f05b39cc$var$prefix}-always`, contextId);
        dynamic.setAttribute(`${$371bc1a9f05b39cc$var$prefix}-dynamic`, contextId);
        $371bc1a9f05b39cc$var$getHead().appendChild(always);
        $371bc1a9f05b39cc$var$getHead().appendChild(dynamic);
        setAlwaysStyle(styles.always);
        setDynamicStyle(styles.resting);
        return ()=>{
            const remove = (ref)=>{
                const current = ref.current;
                !current && $371bc1a9f05b39cc$var$invariant();
                $371bc1a9f05b39cc$var$getHead().removeChild(current);
                ref.current = null;
            };
            remove(alwaysRef);
            remove(dynamicRef);
        };
    }, [
        nonce,
        setAlwaysStyle,
        setDynamicStyle,
        styles.always,
        styles.resting,
        contextId
    ]);
    const dragging = (0, $g21f0.useCallback)(()=>setDynamicStyle(styles.dragging), [
        setDynamicStyle,
        styles.dragging
    ]);
    const dropping = (0, $g21f0.useCallback)((reason)=>{
        if (reason === "DROP") {
            setDynamicStyle(styles.dropAnimating);
            return;
        }
        setDynamicStyle(styles.userCancel);
    }, [
        setDynamicStyle,
        styles.dropAnimating,
        styles.userCancel
    ]);
    const resting = (0, $g21f0.useCallback)(()=>{
        if (!dynamicRef.current) return;
        setDynamicStyle(styles.resting);
    }, [
        setDynamicStyle,
        styles.resting
    ]);
    const marshal = (0, $g21f0.useMemo)(()=>({
            dragging: dragging,
            dropping: dropping,
            resting: resting
        }), [
        dragging,
        dropping,
        resting
    ]);
    return marshal;
}
function $371bc1a9f05b39cc$var$querySelectorAll(parentNode, selector) {
    return Array.from(parentNode.querySelectorAll(selector));
}
var $371bc1a9f05b39cc$var$getWindowFromEl = (el)=>{
    if (el && el.ownerDocument && el.ownerDocument.defaultView) return el.ownerDocument.defaultView;
    return window;
};
function $371bc1a9f05b39cc$var$isHtmlElement(el) {
    return el instanceof $371bc1a9f05b39cc$var$getWindowFromEl(el).HTMLElement;
}
function $371bc1a9f05b39cc$var$findDragHandle(contextId, draggableId) {
    const selector = `[${$371bc1a9f05b39cc$var$dragHandle.contextId}="${contextId}"]`;
    const possible = $371bc1a9f05b39cc$var$querySelectorAll(document, selector);
    if (!possible.length) return null;
    const handle = possible.find((el)=>{
        return el.getAttribute($371bc1a9f05b39cc$var$dragHandle.draggableId) === draggableId;
    });
    if (!handle) return null;
    if (!$371bc1a9f05b39cc$var$isHtmlElement(handle)) return null;
    return handle;
}
function $371bc1a9f05b39cc$var$useFocusMarshal(contextId) {
    const entriesRef = (0, $jbmdS.useRef)({});
    const recordRef = (0, $jbmdS.useRef)(null);
    const restoreFocusFrameRef = (0, $jbmdS.useRef)(null);
    const isMountedRef = (0, $jbmdS.useRef)(false);
    const register = (0, $g21f0.useCallback)(function register(id, focus) {
        const entry = {
            id: id,
            focus: focus
        };
        entriesRef.current[id] = entry;
        return function unregister() {
            const entries = entriesRef.current;
            const current = entries[id];
            if (current !== entry) delete entries[id];
        };
    }, []);
    const tryGiveFocus = (0, $g21f0.useCallback)(function tryGiveFocus(tryGiveFocusTo) {
        const handle = $371bc1a9f05b39cc$var$findDragHandle(contextId, tryGiveFocusTo);
        if (handle && handle !== document.activeElement) handle.focus();
    }, [
        contextId
    ]);
    const tryShiftRecord = (0, $g21f0.useCallback)(function tryShiftRecord(previous, redirectTo) {
        if (recordRef.current === previous) recordRef.current = redirectTo;
    }, []);
    const tryRestoreFocusRecorded = (0, $g21f0.useCallback)(function tryRestoreFocusRecorded() {
        if (restoreFocusFrameRef.current) return;
        if (!isMountedRef.current) return;
        restoreFocusFrameRef.current = requestAnimationFrame(()=>{
            restoreFocusFrameRef.current = null;
            const record = recordRef.current;
            if (record) tryGiveFocus(record);
        });
    }, [
        tryGiveFocus
    ]);
    const tryRecordFocus = (0, $g21f0.useCallback)(function tryRecordFocus(id) {
        recordRef.current = null;
        const focused = document.activeElement;
        if (!focused) return;
        if (focused.getAttribute($371bc1a9f05b39cc$var$dragHandle.draggableId) !== id) return;
        recordRef.current = id;
    }, []);
    $371bc1a9f05b39cc$var$useIsomorphicLayoutEffect(()=>{
        isMountedRef.current = true;
        return function clearFrameOnUnmount() {
            isMountedRef.current = false;
            const frameId = restoreFocusFrameRef.current;
            if (frameId) cancelAnimationFrame(frameId);
        };
    }, []);
    const marshal = (0, $g21f0.useMemo)(()=>({
            register: register,
            tryRecordFocus: tryRecordFocus,
            tryRestoreFocusRecorded: tryRestoreFocusRecorded,
            tryShiftRecord: tryShiftRecord
        }), [
        register,
        tryRecordFocus,
        tryRestoreFocusRecorded,
        tryShiftRecord
    ]);
    return marshal;
}
function $371bc1a9f05b39cc$var$createRegistry() {
    const entries = {
        draggables: {},
        droppables: {}
    };
    const subscribers = [];
    function subscribe(cb) {
        subscribers.push(cb);
        return function unsubscribe() {
            const index = subscribers.indexOf(cb);
            if (index === -1) return;
            subscribers.splice(index, 1);
        };
    }
    function notify(event) {
        if (subscribers.length) subscribers.forEach((cb)=>cb(event));
    }
    function findDraggableById(id) {
        return entries.draggables[id] || null;
    }
    function getDraggableById(id) {
        const entry = findDraggableById(id);
        !entry && $371bc1a9f05b39cc$var$invariant();
        return entry;
    }
    const draggableAPI = {
        register: (entry)=>{
            entries.draggables[entry.descriptor.id] = entry;
            notify({
                type: "ADDITION",
                value: entry
            });
        },
        update: (entry, last)=>{
            const current = entries.draggables[last.descriptor.id];
            if (!current) return;
            if (current.uniqueId !== entry.uniqueId) return;
            delete entries.draggables[last.descriptor.id];
            entries.draggables[entry.descriptor.id] = entry;
        },
        unregister: (entry)=>{
            const draggableId = entry.descriptor.id;
            const current = findDraggableById(draggableId);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.draggables[draggableId];
            if (entries.droppables[entry.descriptor.droppableId]) notify({
                type: "REMOVAL",
                value: entry
            });
        },
        getById: getDraggableById,
        findById: findDraggableById,
        exists: (id)=>Boolean(findDraggableById(id)),
        getAllByType: (type)=>Object.values(entries.draggables).filter((entry)=>entry.descriptor.type === type)
    };
    function findDroppableById(id) {
        return entries.droppables[id] || null;
    }
    function getDroppableById(id) {
        const entry = findDroppableById(id);
        !entry && $371bc1a9f05b39cc$var$invariant();
        return entry;
    }
    const droppableAPI = {
        register: (entry)=>{
            entries.droppables[entry.descriptor.id] = entry;
        },
        unregister: (entry)=>{
            const current = findDroppableById(entry.descriptor.id);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.droppables[entry.descriptor.id];
        },
        getById: getDroppableById,
        findById: findDroppableById,
        exists: (id)=>Boolean(findDroppableById(id)),
        getAllByType: (type)=>Object.values(entries.droppables).filter((entry)=>entry.descriptor.type === type)
    };
    function clean() {
        entries.draggables = {};
        entries.droppables = {};
        subscribers.length = 0;
    }
    return {
        draggable: draggableAPI,
        droppable: droppableAPI,
        subscribe: subscribe,
        clean: clean
    };
}
function $371bc1a9f05b39cc$var$useRegistry() {
    const registry = (0, $g21f0.useMemo)($371bc1a9f05b39cc$var$createRegistry, []);
    (0, $jbmdS.useEffect)(()=>{
        return function unmount() {
            registry.clean();
        };
    }, [
        registry
    ]);
    return registry;
}
var $371bc1a9f05b39cc$var$StoreContext = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createContext(null);
var $371bc1a9f05b39cc$var$getBodyElement = ()=>{
    const body = document.body;
    !body && $371bc1a9f05b39cc$var$invariant();
    return body;
};
const $371bc1a9f05b39cc$var$visuallyHidden = {
    position: "absolute",
    width: "1px",
    height: "1px",
    margin: "-1px",
    border: "0",
    padding: "0",
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    "clip-path": "inset(100%)"
};
const $371bc1a9f05b39cc$var$getId = (contextId)=>`rfd-announcement-${contextId}`;
function $371bc1a9f05b39cc$var$useAnnouncer(contextId) {
    const id = (0, $g21f0.useMemo)(()=>$371bc1a9f05b39cc$var$getId(contextId), [
        contextId
    ]);
    const ref = (0, $jbmdS.useRef)(null);
    (0, $jbmdS.useEffect)(function setup() {
        const el = document.createElement("div");
        ref.current = el;
        el.id = id;
        el.setAttribute("aria-live", "assertive");
        el.setAttribute("aria-atomic", "true");
        (0, $7i29i.default)(el.style, $371bc1a9f05b39cc$var$visuallyHidden);
        $371bc1a9f05b39cc$var$getBodyElement().appendChild(el);
        return function cleanup() {
            setTimeout(function remove() {
                const body = $371bc1a9f05b39cc$var$getBodyElement();
                if (body.contains(el)) body.removeChild(el);
                if (el === ref.current) ref.current = null;
            });
        };
    }, [
        id
    ]);
    const announce = (0, $g21f0.useCallback)((message)=>{
        const el = ref.current;
        if (el) {
            el.textContent = message;
            return;
        }
    }, []);
    return announce;
}
const $371bc1a9f05b39cc$var$defaults = {
    separator: "::"
};
function $371bc1a9f05b39cc$var$useUniqueId(prefix, options = $371bc1a9f05b39cc$var$defaults) {
    const id = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useId();
    return (0, $g21f0.useMemo)(()=>`${prefix}${options.separator}${id}`, [
        options.separator,
        prefix,
        id
    ]);
}
function $371bc1a9f05b39cc$var$getElementId({ contextId: contextId, uniqueId: uniqueId }) {
    return `rfd-hidden-text-${contextId}-${uniqueId}`;
}
function $371bc1a9f05b39cc$var$useHiddenTextElement({ contextId: contextId, text: text }) {
    const uniqueId = $371bc1a9f05b39cc$var$useUniqueId("hidden-text", {
        separator: "-"
    });
    const id = (0, $g21f0.useMemo)(()=>$371bc1a9f05b39cc$var$getElementId({
            contextId: contextId,
            uniqueId: uniqueId
        }), [
        uniqueId,
        contextId
    ]);
    (0, $jbmdS.useEffect)(function mount() {
        const el = document.createElement("div");
        el.id = id;
        el.textContent = text;
        el.style.display = "none";
        $371bc1a9f05b39cc$var$getBodyElement().appendChild(el);
        return function unmount() {
            const body = $371bc1a9f05b39cc$var$getBodyElement();
            if (body.contains(el)) body.removeChild(el);
        };
    }, [
        id,
        text
    ]);
    return id;
}
var $371bc1a9f05b39cc$var$AppContext = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createContext(null);
var $371bc1a9f05b39cc$var$peerDependencies = {
    react: "^18.0.0",
    "react-dom": "^18.0.0"
};
const $371bc1a9f05b39cc$var$semver = /(\d+)\.(\d+)\.(\d+)/;
const $371bc1a9f05b39cc$var$getVersion = (value)=>{
    const result = $371bc1a9f05b39cc$var$semver.exec(value);
    !(result != null) && $371bc1a9f05b39cc$var$invariant();
    const major = Number(result[1]);
    const minor = Number(result[2]);
    const patch = Number(result[3]);
    return {
        major: major,
        minor: minor,
        patch: patch,
        raw: value
    };
};
const $371bc1a9f05b39cc$var$isSatisfied = (expected, actual)=>{
    if (actual.major > expected.major) return true;
    if (actual.major < expected.major) return false;
    if (actual.minor > expected.minor) return true;
    if (actual.minor < expected.minor) return false;
    return actual.patch >= expected.patch;
};
var $371bc1a9f05b39cc$var$checkReactVersion = (peerDepValue, actualValue)=>{
    const peerDep = $371bc1a9f05b39cc$var$getVersion(peerDepValue);
    const actual = $371bc1a9f05b39cc$var$getVersion(actualValue);
    if ($371bc1a9f05b39cc$var$isSatisfied(peerDep, actual)) return;
};
const $371bc1a9f05b39cc$var$suffix = `
  We expect a html5 doctype: <!doctype html>
  This is to ensure consistent browser layout and measurement

  More information: https://github.com/hello-pangea/dnd/blob/main/docs/guides/doctype.md
`;
var $371bc1a9f05b39cc$var$checkDoctype = (doc)=>{
    const doctype = doc.doctype;
    if (!doctype) return;
    doctype.name.toLowerCase();
    doctype.publicId;
};
function $371bc1a9f05b39cc$var$useDev(useHook) {}
function $371bc1a9f05b39cc$var$useDevSetupWarning(fn, inputs) {
    $371bc1a9f05b39cc$var$useDev(()=>{
        (0, $jbmdS.useEffect)(()=>{
            try {
                fn();
            } catch (e) {
                $371bc1a9f05b39cc$var$error(`
          A setup problem was encountered.

          > ${e.message}
        `);
            }
        }, inputs);
    });
}
function $371bc1a9f05b39cc$var$useStartupValidation() {
    $371bc1a9f05b39cc$var$useDevSetupWarning(()=>{
        $371bc1a9f05b39cc$var$checkReactVersion($371bc1a9f05b39cc$var$peerDependencies.react, (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).version);
        $371bc1a9f05b39cc$var$checkDoctype(document);
    }, []);
}
function $371bc1a9f05b39cc$var$usePrevious(current) {
    const ref = (0, $jbmdS.useRef)(current);
    (0, $jbmdS.useEffect)(()=>{
        ref.current = current;
    });
    return ref;
}
function $371bc1a9f05b39cc$var$create() {
    let lock = null;
    function isClaimed() {
        return Boolean(lock);
    }
    function isActive(value) {
        return value === lock;
    }
    function claim(abandon) {
        !!lock && $371bc1a9f05b39cc$var$invariant();
        const newLock = {
            abandon: abandon
        };
        lock = newLock;
        return newLock;
    }
    function release() {
        !lock && $371bc1a9f05b39cc$var$invariant();
        lock = null;
    }
    function tryAbandon() {
        if (lock) {
            lock.abandon();
            release();
        }
    }
    return {
        isClaimed: isClaimed,
        isActive: isActive,
        claim: claim,
        release: release,
        tryAbandon: tryAbandon
    };
}
function $371bc1a9f05b39cc$var$isDragging(state) {
    if (state.phase === "IDLE" || state.phase === "DROP_ANIMATING") return false;
    return state.isDragging;
}
const $371bc1a9f05b39cc$var$tab = 9;
const $371bc1a9f05b39cc$var$enter = 13;
const $371bc1a9f05b39cc$var$escape = 27;
const $371bc1a9f05b39cc$var$space = 32;
const $371bc1a9f05b39cc$var$pageUp = 33;
const $371bc1a9f05b39cc$var$pageDown = 34;
const $371bc1a9f05b39cc$var$end = 35;
const $371bc1a9f05b39cc$var$home = 36;
const $371bc1a9f05b39cc$var$arrowLeft = 37;
const $371bc1a9f05b39cc$var$arrowUp = 38;
const $371bc1a9f05b39cc$var$arrowRight = 39;
const $371bc1a9f05b39cc$var$arrowDown = 40;
const $371bc1a9f05b39cc$var$preventedKeys = {
    [$371bc1a9f05b39cc$var$enter]: true,
    [$371bc1a9f05b39cc$var$tab]: true
};
var $371bc1a9f05b39cc$var$preventStandardKeyEvents = (event)=>{
    if ($371bc1a9f05b39cc$var$preventedKeys[event.keyCode]) event.preventDefault();
};
const $371bc1a9f05b39cc$var$supportedEventName = (()=>{
    const base = "visibilitychange";
    if (typeof document === "undefined") return base;
    const candidates = [
        base,
        `ms${base}`,
        `webkit${base}`,
        `moz${base}`,
        `o${base}`
    ];
    const supported = candidates.find((eventName)=>`on${eventName}` in document);
    return supported || base;
})();
const $371bc1a9f05b39cc$var$primaryButton = 0;
const $371bc1a9f05b39cc$var$sloppyClickThreshold = 5;
function $371bc1a9f05b39cc$var$isSloppyClickThresholdExceeded(original, current) {
    return Math.abs(current.x - original.x) >= $371bc1a9f05b39cc$var$sloppyClickThreshold || Math.abs(current.y - original.y) >= $371bc1a9f05b39cc$var$sloppyClickThreshold;
}
const $371bc1a9f05b39cc$var$idle$1 = {
    type: "IDLE"
};
function $371bc1a9f05b39cc$var$getCaptureBindings({ cancel: cancel, completed: completed, getPhase: getPhase, setPhase: setPhase }) {
    return [
        {
            eventName: "mousemove",
            fn: (event)=>{
                const { button: button, clientX: clientX, clientY: clientY } = event;
                if (button !== $371bc1a9f05b39cc$var$primaryButton) return;
                const point = {
                    x: clientX,
                    y: clientY
                };
                const phase = getPhase();
                if (phase.type === "DRAGGING") {
                    event.preventDefault();
                    phase.actions.move(point);
                    return;
                }
                !(phase.type === "PENDING") && $371bc1a9f05b39cc$var$invariant();
                const pending = phase.point;
                if (!$371bc1a9f05b39cc$var$isSloppyClickThresholdExceeded(pending, point)) return;
                event.preventDefault();
                const actions = phase.actions.fluidLift(point);
                setPhase({
                    type: "DRAGGING",
                    actions: actions
                });
            }
        },
        {
            eventName: "mouseup",
            fn: (event)=>{
                const phase = getPhase();
                if (phase.type !== "DRAGGING") {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: "mousedown",
            fn: (event)=>{
                if (getPhase().type === "DRAGGING") event.preventDefault();
                cancel();
            }
        },
        {
            eventName: "keydown",
            fn: (event)=>{
                const phase = getPhase();
                if (phase.type === "PENDING") {
                    cancel();
                    return;
                }
                if (event.keyCode === $371bc1a9f05b39cc$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                $371bc1a9f05b39cc$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: "resize",
            fn: cancel
        },
        {
            eventName: "scroll",
            options: {
                passive: true,
                capture: false
            },
            fn: ()=>{
                if (getPhase().type === "PENDING") cancel();
            }
        },
        {
            eventName: "webkitmouseforcedown",
            fn: (event)=>{
                const phase = getPhase();
                !(phase.type !== "IDLE") && $371bc1a9f05b39cc$var$invariant();
                if (phase.actions.shouldRespectForcePress()) {
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $371bc1a9f05b39cc$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $371bc1a9f05b39cc$export$2f59cd992b42195a(api) {
    const phaseRef = (0, $jbmdS.useRef)($371bc1a9f05b39cc$var$idle$1);
    const unbindEventsRef = (0, $jbmdS.useRef)($371bc1a9f05b39cc$var$noop$2);
    const startCaptureBinding = (0, $g21f0.useMemo)(()=>({
            eventName: "mousedown",
            fn: function onMouseDown(event) {
                if (event.defaultPrevented) return;
                if (event.button !== $371bc1a9f05b39cc$var$primaryButton) return;
                if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
                const draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                const actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                event.preventDefault();
                const point = {
                    x: event.clientX,
                    y: event.clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        }), [
        api
    ]);
    const preventForcePressBinding = (0, $g21f0.useMemo)(()=>({
            eventName: "webkitmouseforcewillbegin",
            fn: (event)=>{
                if (event.defaultPrevented) return;
                const id = api.findClosestDraggableId(event);
                if (!id) return;
                const options = api.findOptionsForDraggable(id);
                if (!options) return;
                if (options.shouldRespectForcePress) return;
                if (!api.canGetLock(id)) return;
                event.preventDefault();
            }
        }), [
        api
    ]);
    const listenForCapture = (0, $g21f0.useCallback)(function listenForCapture() {
        const options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $371bc1a9f05b39cc$var$bindEvents(window, [
            preventForcePressBinding,
            startCaptureBinding
        ], options);
    }, [
        preventForcePressBinding,
        startCaptureBinding
    ]);
    const stop = (0, $g21f0.useCallback)(()=>{
        const current = phaseRef.current;
        if (current.type === "IDLE") return;
        phaseRef.current = $371bc1a9f05b39cc$var$idle$1;
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture
    ]);
    const cancel = (0, $g21f0.useCallback)(()=>{
        const phase = phaseRef.current;
        stop();
        if (phase.type === "DRAGGING") phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === "PENDING") phase.actions.abort();
    }, [
        stop
    ]);
    const bindCapturingEvents = (0, $g21f0.useCallback)(function bindCapturingEvents() {
        const options = {
            capture: true,
            passive: false
        };
        const bindings = $371bc1a9f05b39cc$var$getCaptureBindings({
            cancel: cancel,
            completed: stop,
            getPhase: ()=>phaseRef.current,
            setPhase: (phase)=>{
                phaseRef.current = phase;
            }
        });
        unbindEventsRef.current = $371bc1a9f05b39cc$var$bindEvents(window, bindings, options);
    }, [
        cancel,
        stop
    ]);
    const startPendingDrag = (0, $g21f0.useCallback)(function startPendingDrag(actions, point) {
        !(phaseRef.current.type === "IDLE") && $371bc1a9f05b39cc$var$invariant();
        phaseRef.current = {
            type: "PENDING",
            point: point,
            actions: actions
        };
        bindCapturingEvents();
    }, [
        bindCapturingEvents
    ]);
    $371bc1a9f05b39cc$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
function $371bc1a9f05b39cc$var$noop$1() {}
const $371bc1a9f05b39cc$var$scrollJumpKeys = {
    [$371bc1a9f05b39cc$var$pageDown]: true,
    [$371bc1a9f05b39cc$var$pageUp]: true,
    [$371bc1a9f05b39cc$var$home]: true,
    [$371bc1a9f05b39cc$var$end]: true
};
function $371bc1a9f05b39cc$var$getDraggingBindings(actions, stop) {
    function cancel() {
        stop();
        actions.cancel();
    }
    function drop() {
        stop();
        actions.drop();
    }
    return [
        {
            eventName: "keydown",
            fn: (event)=>{
                if (event.keyCode === $371bc1a9f05b39cc$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                if (event.keyCode === $371bc1a9f05b39cc$var$space) {
                    event.preventDefault();
                    drop();
                    return;
                }
                if (event.keyCode === $371bc1a9f05b39cc$var$arrowDown) {
                    event.preventDefault();
                    actions.moveDown();
                    return;
                }
                if (event.keyCode === $371bc1a9f05b39cc$var$arrowUp) {
                    event.preventDefault();
                    actions.moveUp();
                    return;
                }
                if (event.keyCode === $371bc1a9f05b39cc$var$arrowRight) {
                    event.preventDefault();
                    actions.moveRight();
                    return;
                }
                if (event.keyCode === $371bc1a9f05b39cc$var$arrowLeft) {
                    event.preventDefault();
                    actions.moveLeft();
                    return;
                }
                if ($371bc1a9f05b39cc$var$scrollJumpKeys[event.keyCode]) {
                    event.preventDefault();
                    return;
                }
                $371bc1a9f05b39cc$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: "mousedown",
            fn: cancel
        },
        {
            eventName: "mouseup",
            fn: cancel
        },
        {
            eventName: "click",
            fn: cancel
        },
        {
            eventName: "touchstart",
            fn: cancel
        },
        {
            eventName: "resize",
            fn: cancel
        },
        {
            eventName: "wheel",
            fn: cancel,
            options: {
                passive: true
            }
        },
        {
            eventName: $371bc1a9f05b39cc$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $371bc1a9f05b39cc$export$42b74264faad0714(api) {
    const unbindEventsRef = (0, $jbmdS.useRef)($371bc1a9f05b39cc$var$noop$1);
    const startCaptureBinding = (0, $g21f0.useMemo)(()=>({
            eventName: "keydown",
            fn: function onKeyDown(event) {
                if (event.defaultPrevented) return;
                if (event.keyCode !== $371bc1a9f05b39cc$var$space) return;
                const draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                const preDrag = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!preDrag) return;
                event.preventDefault();
                let isCapturing = true;
                const actions = preDrag.snapLift();
                unbindEventsRef.current();
                function stop() {
                    !isCapturing && $371bc1a9f05b39cc$var$invariant();
                    isCapturing = false;
                    unbindEventsRef.current();
                    listenForCapture();
                }
                unbindEventsRef.current = $371bc1a9f05b39cc$var$bindEvents(window, $371bc1a9f05b39cc$var$getDraggingBindings(actions, stop), {
                    capture: true,
                    passive: false
                });
            }
        }), [
        api
    ]);
    const listenForCapture = (0, $g21f0.useCallback)(function tryStartCapture() {
        const options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $371bc1a9f05b39cc$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    $371bc1a9f05b39cc$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
const $371bc1a9f05b39cc$var$idle = {
    type: "IDLE"
};
const $371bc1a9f05b39cc$var$timeForLongPress = 120;
const $371bc1a9f05b39cc$var$forcePressThreshold = 0.15;
function $371bc1a9f05b39cc$var$getWindowBindings({ cancel: cancel, getPhase: getPhase }) {
    return [
        {
            eventName: "orientationchange",
            fn: cancel
        },
        {
            eventName: "resize",
            fn: cancel
        },
        {
            eventName: "contextmenu",
            fn: (event)=>{
                event.preventDefault();
            }
        },
        {
            eventName: "keydown",
            fn: (event)=>{
                if (getPhase().type !== "DRAGGING") {
                    cancel();
                    return;
                }
                if (event.keyCode === $371bc1a9f05b39cc$var$escape) event.preventDefault();
                cancel();
            }
        },
        {
            eventName: $371bc1a9f05b39cc$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $371bc1a9f05b39cc$var$getHandleBindings({ cancel: cancel, completed: completed, getPhase: getPhase }) {
    return [
        {
            eventName: "touchmove",
            options: {
                capture: false
            },
            fn: (event)=>{
                const phase = getPhase();
                if (phase.type !== "DRAGGING") {
                    cancel();
                    return;
                }
                phase.hasMoved = true;
                const { clientX: clientX, clientY: clientY } = event.touches[0];
                const point = {
                    x: clientX,
                    y: clientY
                };
                event.preventDefault();
                phase.actions.move(point);
            }
        },
        {
            eventName: "touchend",
            fn: (event)=>{
                const phase = getPhase();
                if (phase.type !== "DRAGGING") {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: "touchcancel",
            fn: (event)=>{
                if (getPhase().type !== "DRAGGING") {
                    cancel();
                    return;
                }
                event.preventDefault();
                cancel();
            }
        },
        {
            eventName: "touchforcechange",
            fn: (event)=>{
                const phase = getPhase();
                !(phase.type !== "IDLE") && $371bc1a9f05b39cc$var$invariant();
                const touch = event.touches[0];
                if (!touch) return;
                const isForcePress = touch.force >= $371bc1a9f05b39cc$var$forcePressThreshold;
                if (!isForcePress) return;
                const shouldRespect = phase.actions.shouldRespectForcePress();
                if (phase.type === "PENDING") {
                    if (shouldRespect) cancel();
                    return;
                }
                if (shouldRespect) {
                    if (phase.hasMoved) {
                        event.preventDefault();
                        return;
                    }
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $371bc1a9f05b39cc$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $371bc1a9f05b39cc$export$ac235fd3a7bcf7b4(api) {
    const phaseRef = (0, $jbmdS.useRef)($371bc1a9f05b39cc$var$idle);
    const unbindEventsRef = (0, $jbmdS.useRef)($371bc1a9f05b39cc$var$noop$2);
    const getPhase = (0, $g21f0.useCallback)(function getPhase() {
        return phaseRef.current;
    }, []);
    const setPhase = (0, $g21f0.useCallback)(function setPhase(phase) {
        phaseRef.current = phase;
    }, []);
    const startCaptureBinding = (0, $g21f0.useMemo)(()=>({
            eventName: "touchstart",
            fn: function onTouchStart(event) {
                if (event.defaultPrevented) return;
                const draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                const actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                const touch = event.touches[0];
                const { clientX: clientX, clientY: clientY } = touch;
                const point = {
                    x: clientX,
                    y: clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        }), [
        api
    ]);
    const listenForCapture = (0, $g21f0.useCallback)(function listenForCapture() {
        const options = {
            capture: true,
            passive: false
        };
        unbindEventsRef.current = $371bc1a9f05b39cc$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    const stop = (0, $g21f0.useCallback)(()=>{
        const current = phaseRef.current;
        if (current.type === "IDLE") return;
        if (current.type === "PENDING") clearTimeout(current.longPressTimerId);
        setPhase($371bc1a9f05b39cc$var$idle);
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture,
        setPhase
    ]);
    const cancel = (0, $g21f0.useCallback)(()=>{
        const phase = phaseRef.current;
        stop();
        if (phase.type === "DRAGGING") phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === "PENDING") phase.actions.abort();
    }, [
        stop
    ]);
    const bindCapturingEvents = (0, $g21f0.useCallback)(function bindCapturingEvents() {
        const options = {
            capture: true,
            passive: false
        };
        const args = {
            cancel: cancel,
            completed: stop,
            getPhase: getPhase
        };
        const unbindTarget = $371bc1a9f05b39cc$var$bindEvents(window, $371bc1a9f05b39cc$var$getHandleBindings(args), options);
        const unbindWindow = $371bc1a9f05b39cc$var$bindEvents(window, $371bc1a9f05b39cc$var$getWindowBindings(args), options);
        unbindEventsRef.current = function unbindAll() {
            unbindTarget();
            unbindWindow();
        };
    }, [
        cancel,
        getPhase,
        stop
    ]);
    const startDragging = (0, $g21f0.useCallback)(function startDragging() {
        const phase = getPhase();
        !(phase.type === "PENDING") && $371bc1a9f05b39cc$var$invariant();
        const actions = phase.actions.fluidLift(phase.point);
        setPhase({
            type: "DRAGGING",
            actions: actions,
            hasMoved: false
        });
    }, [
        getPhase,
        setPhase
    ]);
    const startPendingDrag = (0, $g21f0.useCallback)(function startPendingDrag(actions, point) {
        !(getPhase().type === "IDLE") && $371bc1a9f05b39cc$var$invariant();
        const longPressTimerId = setTimeout(startDragging, $371bc1a9f05b39cc$var$timeForLongPress);
        setPhase({
            type: "PENDING",
            point: point,
            actions: actions,
            longPressTimerId: longPressTimerId
        });
        bindCapturingEvents();
    }, [
        bindCapturingEvents,
        getPhase,
        setPhase,
        startDragging
    ]);
    $371bc1a9f05b39cc$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
            const phase = getPhase();
            if (phase.type === "PENDING") {
                clearTimeout(phase.longPressTimerId);
                setPhase($371bc1a9f05b39cc$var$idle);
            }
        };
    }, [
        getPhase,
        listenForCapture,
        setPhase
    ]);
    $371bc1a9f05b39cc$var$useIsomorphicLayoutEffect(function webkitHack() {
        const unbind = $371bc1a9f05b39cc$var$bindEvents(window, [
            {
                eventName: "touchmove",
                fn: ()=>{},
                options: {
                    capture: false,
                    passive: false
                }
            }
        ]);
        return unbind;
    }, []);
}
function $371bc1a9f05b39cc$var$useValidateSensorHooks(sensorHooks) {
    $371bc1a9f05b39cc$var$useDev(()=>{
        const previousRef = $371bc1a9f05b39cc$var$usePrevious(sensorHooks);
        $371bc1a9f05b39cc$var$useDevSetupWarning(()=>{
            !(previousRef.current.length === sensorHooks.length) && $371bc1a9f05b39cc$var$invariant(false);
        });
    });
}
const $371bc1a9f05b39cc$var$interactiveTagNames = [
    "input",
    "button",
    "textarea",
    "select",
    "option",
    "optgroup",
    "video",
    "audio"
];
function $371bc1a9f05b39cc$var$isAnInteractiveElement(parent, current) {
    if (current == null) return false;
    const hasAnInteractiveTag = $371bc1a9f05b39cc$var$interactiveTagNames.includes(current.tagName.toLowerCase());
    if (hasAnInteractiveTag) return true;
    const attribute = current.getAttribute("contenteditable");
    if (attribute === "true" || attribute === "") return true;
    if (current === parent) return false;
    return $371bc1a9f05b39cc$var$isAnInteractiveElement(parent, current.parentElement);
}
function $371bc1a9f05b39cc$var$isEventInInteractiveElement(draggable, event) {
    const target = event.target;
    if (!$371bc1a9f05b39cc$var$isHtmlElement(target)) return false;
    return $371bc1a9f05b39cc$var$isAnInteractiveElement(draggable, target);
}
var $371bc1a9f05b39cc$var$getBorderBoxCenterPosition = (el)=>(0, $8rsfJ.getRect)(el.getBoundingClientRect()).center;
function $371bc1a9f05b39cc$var$isElement(el) {
    return el instanceof $371bc1a9f05b39cc$var$getWindowFromEl(el).Element;
}
const $371bc1a9f05b39cc$var$supportedMatchesName = (()=>{
    const base = "matches";
    if (typeof document === "undefined") return base;
    const candidates = [
        base,
        "msMatchesSelector",
        "webkitMatchesSelector"
    ];
    const value = candidates.find((name)=>name in Element.prototype);
    return value || base;
})();
function $371bc1a9f05b39cc$var$closestPonyfill(el, selector) {
    if (el == null) return null;
    if (el[$371bc1a9f05b39cc$var$supportedMatchesName](selector)) return el;
    return $371bc1a9f05b39cc$var$closestPonyfill(el.parentElement, selector);
}
function $371bc1a9f05b39cc$var$closest(el, selector) {
    if (el.closest) return el.closest(selector);
    return $371bc1a9f05b39cc$var$closestPonyfill(el, selector);
}
function $371bc1a9f05b39cc$var$getSelector(contextId) {
    return `[${$371bc1a9f05b39cc$var$dragHandle.contextId}="${contextId}"]`;
}
function $371bc1a9f05b39cc$var$findClosestDragHandleFromEvent(contextId, event) {
    const target = event.target;
    if (!$371bc1a9f05b39cc$var$isElement(target)) return null;
    const selector = $371bc1a9f05b39cc$var$getSelector(contextId);
    const handle = $371bc1a9f05b39cc$var$closest(target, selector);
    if (!handle) return null;
    if (!$371bc1a9f05b39cc$var$isHtmlElement(handle)) return null;
    return handle;
}
function $371bc1a9f05b39cc$var$tryGetClosestDraggableIdFromEvent(contextId, event) {
    const handle = $371bc1a9f05b39cc$var$findClosestDragHandleFromEvent(contextId, event);
    if (!handle) return null;
    return handle.getAttribute($371bc1a9f05b39cc$var$dragHandle.draggableId);
}
function $371bc1a9f05b39cc$var$findDraggable(contextId, draggableId) {
    const selector = `[${$371bc1a9f05b39cc$var$draggable.contextId}="${contextId}"]`;
    const possible = $371bc1a9f05b39cc$var$querySelectorAll(document, selector);
    const draggable$1 = possible.find((el)=>{
        return el.getAttribute($371bc1a9f05b39cc$var$draggable.id) === draggableId;
    });
    if (!draggable$1) return null;
    if (!$371bc1a9f05b39cc$var$isHtmlElement(draggable$1)) return null;
    return draggable$1;
}
function $371bc1a9f05b39cc$var$preventDefault(event) {
    event.preventDefault();
}
function $371bc1a9f05b39cc$var$isActive({ expected: expected, phase: phase, isLockActive: isLockActive, shouldWarn: shouldWarn }) {
    if (!isLockActive()) {
        shouldWarn;
        return false;
    }
    if (expected !== phase) {
        shouldWarn;
        return false;
    }
    return true;
}
function $371bc1a9f05b39cc$var$canStart({ lockAPI: lockAPI, store: store, registry: registry, draggableId: draggableId }) {
    if (lockAPI.isClaimed()) return false;
    const entry = registry.draggable.findById(draggableId);
    if (!entry) return false;
    if (!entry.options.isEnabled) return false;
    if (!$371bc1a9f05b39cc$var$canStartDrag(store.getState(), draggableId)) return false;
    return true;
}
function $371bc1a9f05b39cc$var$tryStart({ lockAPI: lockAPI, contextId: contextId, store: store, registry: registry, draggableId: draggableId, forceSensorStop: forceSensorStop, sourceEvent: sourceEvent }) {
    const shouldStart = $371bc1a9f05b39cc$var$canStart({
        lockAPI: lockAPI,
        store: store,
        registry: registry,
        draggableId: draggableId
    });
    if (!shouldStart) return null;
    const entry = registry.draggable.getById(draggableId);
    const el = $371bc1a9f05b39cc$var$findDraggable(contextId, entry.descriptor.id);
    if (!el) return null;
    if (sourceEvent && !entry.options.canDragInteractiveElements && $371bc1a9f05b39cc$var$isEventInInteractiveElement(el, sourceEvent)) return null;
    const lock = lockAPI.claim(forceSensorStop || $371bc1a9f05b39cc$var$noop$2);
    let phase = "PRE_DRAG";
    function getShouldRespectForcePress() {
        return entry.options.shouldRespectForcePress;
    }
    function isLockActive() {
        return lockAPI.isActive(lock);
    }
    function tryDispatch(expected, getAction) {
        if ($371bc1a9f05b39cc$var$isActive({
            expected: expected,
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        })) store.dispatch(getAction());
    }
    const tryDispatchWhenDragging = tryDispatch.bind(null, "DRAGGING");
    function lift(args) {
        function completed() {
            lockAPI.release();
            phase = "COMPLETED";
        }
        if (phase !== "PRE_DRAG") {
            completed();
            $371bc1a9f05b39cc$var$invariant();
        }
        store.dispatch($371bc1a9f05b39cc$var$lift$1(args.liftActionArgs));
        phase = "DRAGGING";
        function finish(reason, options = {
            shouldBlockNextClick: false
        }) {
            args.cleanup();
            if (options.shouldBlockNextClick) {
                const unbind = $371bc1a9f05b39cc$var$bindEvents(window, [
                    {
                        eventName: "click",
                        fn: $371bc1a9f05b39cc$var$preventDefault,
                        options: {
                            once: true,
                            passive: false,
                            capture: true
                        }
                    }
                ]);
                setTimeout(unbind);
            }
            completed();
            store.dispatch($371bc1a9f05b39cc$var$drop({
                reason: reason
            }));
        }
        return {
            isActive: ()=>$371bc1a9f05b39cc$var$isActive({
                    expected: "DRAGGING",
                    phase: phase,
                    isLockActive: isLockActive,
                    shouldWarn: false
                }),
            shouldRespectForcePress: getShouldRespectForcePress,
            drop: (options)=>finish("DROP", options),
            cancel: (options)=>finish("CANCEL", options),
            ...args.actions
        };
    }
    function fluidLift(clientSelection) {
        const move$1 = (0, $RIdqi.default)((client)=>{
            tryDispatchWhenDragging(()=>$371bc1a9f05b39cc$var$move({
                    client: client
                }));
        });
        const api = lift({
            liftActionArgs: {
                id: draggableId,
                clientSelection: clientSelection,
                movementMode: "FLUID"
            },
            cleanup: ()=>move$1.cancel(),
            actions: {
                move: move$1
            }
        });
        return {
            ...api,
            move: move$1
        };
    }
    function snapLift() {
        const actions = {
            moveUp: ()=>tryDispatchWhenDragging($371bc1a9f05b39cc$var$moveUp),
            moveRight: ()=>tryDispatchWhenDragging($371bc1a9f05b39cc$var$moveRight),
            moveDown: ()=>tryDispatchWhenDragging($371bc1a9f05b39cc$var$moveDown),
            moveLeft: ()=>tryDispatchWhenDragging($371bc1a9f05b39cc$var$moveLeft)
        };
        return lift({
            liftActionArgs: {
                id: draggableId,
                clientSelection: $371bc1a9f05b39cc$var$getBorderBoxCenterPosition(el),
                movementMode: "SNAP"
            },
            cleanup: $371bc1a9f05b39cc$var$noop$2,
            actions: actions
        });
    }
    function abortPreDrag() {
        const shouldRelease = $371bc1a9f05b39cc$var$isActive({
            expected: "PRE_DRAG",
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        });
        if (shouldRelease) lockAPI.release();
    }
    const preDrag = {
        isActive: ()=>$371bc1a9f05b39cc$var$isActive({
                expected: "PRE_DRAG",
                phase: phase,
                isLockActive: isLockActive,
                shouldWarn: false
            }),
        shouldRespectForcePress: getShouldRespectForcePress,
        fluidLift: fluidLift,
        snapLift: snapLift,
        abort: abortPreDrag
    };
    return preDrag;
}
const $371bc1a9f05b39cc$var$defaultSensors = [
    $371bc1a9f05b39cc$export$2f59cd992b42195a,
    $371bc1a9f05b39cc$export$42b74264faad0714,
    $371bc1a9f05b39cc$export$ac235fd3a7bcf7b4
];
function $371bc1a9f05b39cc$var$useSensorMarshal({ contextId: contextId, store: store, registry: registry, customSensors: customSensors, enableDefaultSensors: enableDefaultSensors }) {
    const useSensors = [
        ...enableDefaultSensors ? $371bc1a9f05b39cc$var$defaultSensors : [],
        ...customSensors || []
    ];
    const lockAPI = (0, $jbmdS.useState)(()=>$371bc1a9f05b39cc$var$create())[0];
    const tryAbandonLock = (0, $g21f0.useCallback)(function tryAbandonLock(previous, current) {
        if ($371bc1a9f05b39cc$var$isDragging(previous) && !$371bc1a9f05b39cc$var$isDragging(current)) lockAPI.tryAbandon();
    }, [
        lockAPI
    ]);
    $371bc1a9f05b39cc$var$useIsomorphicLayoutEffect(function listenToStore() {
        let previous = store.getState();
        const unsubscribe = store.subscribe(()=>{
            const current = store.getState();
            tryAbandonLock(previous, current);
            previous = current;
        });
        return unsubscribe;
    }, [
        lockAPI,
        store,
        tryAbandonLock
    ]);
    $371bc1a9f05b39cc$var$useIsomorphicLayoutEffect(()=>{
        return lockAPI.tryAbandon;
    }, [
        lockAPI.tryAbandon
    ]);
    const canGetLock = (0, $g21f0.useCallback)((draggableId)=>{
        return $371bc1a9f05b39cc$var$canStart({
            lockAPI: lockAPI,
            registry: registry,
            store: store,
            draggableId: draggableId
        });
    }, [
        lockAPI,
        registry,
        store
    ]);
    const tryGetLock = (0, $g21f0.useCallback)((draggableId, forceStop, options)=>$371bc1a9f05b39cc$var$tryStart({
            lockAPI: lockAPI,
            registry: registry,
            contextId: contextId,
            store: store,
            draggableId: draggableId,
            forceSensorStop: forceStop || null,
            sourceEvent: options && options.sourceEvent ? options.sourceEvent : null
        }), [
        contextId,
        lockAPI,
        registry,
        store
    ]);
    const findClosestDraggableId = (0, $g21f0.useCallback)((event)=>$371bc1a9f05b39cc$var$tryGetClosestDraggableIdFromEvent(contextId, event), [
        contextId
    ]);
    const findOptionsForDraggable = (0, $g21f0.useCallback)((id)=>{
        const entry = registry.draggable.findById(id);
        return entry ? entry.options : null;
    }, [
        registry.draggable
    ]);
    const tryReleaseLock = (0, $g21f0.useCallback)(function tryReleaseLock() {
        if (!lockAPI.isClaimed()) return;
        lockAPI.tryAbandon();
        if (store.getState().phase !== "IDLE") store.dispatch($371bc1a9f05b39cc$var$flush());
    }, [
        lockAPI,
        store
    ]);
    const isLockClaimed = (0, $g21f0.useCallback)(()=>lockAPI.isClaimed(), [
        lockAPI
    ]);
    const api = (0, $g21f0.useMemo)(()=>({
            canGetLock: canGetLock,
            tryGetLock: tryGetLock,
            findClosestDraggableId: findClosestDraggableId,
            findOptionsForDraggable: findOptionsForDraggable,
            tryReleaseLock: tryReleaseLock,
            isLockClaimed: isLockClaimed
        }), [
        canGetLock,
        tryGetLock,
        findClosestDraggableId,
        findOptionsForDraggable,
        tryReleaseLock,
        isLockClaimed
    ]);
    $371bc1a9f05b39cc$var$useValidateSensorHooks(useSensors);
    for(let i = 0; i < useSensors.length; i++)useSensors[i](api);
}
const $371bc1a9f05b39cc$var$createResponders = (props)=>({
        onBeforeCapture: (t)=>{
            const onBeforeCapureCallback = ()=>{
                if (props.onBeforeCapture) props.onBeforeCapture(t);
            };
            (0, $jCNM0.flushSync)(onBeforeCapureCallback);
        },
        onBeforeDragStart: props.onBeforeDragStart,
        onDragStart: props.onDragStart,
        onDragEnd: props.onDragEnd,
        onDragUpdate: props.onDragUpdate
    });
const $371bc1a9f05b39cc$var$createAutoScrollerOptions = (props)=>({
        ...$371bc1a9f05b39cc$var$defaultAutoScrollerOptions,
        ...props.autoScrollerOptions,
        durationDampening: {
            ...$371bc1a9f05b39cc$var$defaultAutoScrollerOptions.durationDampening,
            ...props.autoScrollerOptions
        }
    });
function $371bc1a9f05b39cc$var$getStore(lazyRef) {
    !lazyRef.current && $371bc1a9f05b39cc$var$invariant();
    return lazyRef.current;
}
function $371bc1a9f05b39cc$var$App(props) {
    const { contextId: contextId, setCallbacks: setCallbacks, sensors: sensors, nonce: nonce, dragHandleUsageInstructions: dragHandleUsageInstructions } = props;
    const lazyStoreRef = (0, $jbmdS.useRef)(null);
    $371bc1a9f05b39cc$var$useStartupValidation();
    const lastPropsRef = $371bc1a9f05b39cc$var$usePrevious(props);
    const getResponders = (0, $g21f0.useCallback)(()=>{
        return $371bc1a9f05b39cc$var$createResponders(lastPropsRef.current);
    }, [
        lastPropsRef
    ]);
    const getAutoScrollerOptions = (0, $g21f0.useCallback)(()=>{
        return $371bc1a9f05b39cc$var$createAutoScrollerOptions(lastPropsRef.current);
    }, [
        lastPropsRef
    ]);
    const announce = $371bc1a9f05b39cc$var$useAnnouncer(contextId);
    const dragHandleUsageInstructionsId = $371bc1a9f05b39cc$var$useHiddenTextElement({
        contextId: contextId,
        text: dragHandleUsageInstructions
    });
    const styleMarshal = $371bc1a9f05b39cc$var$useStyleMarshal(contextId, nonce);
    const lazyDispatch = (0, $g21f0.useCallback)((action)=>{
        $371bc1a9f05b39cc$var$getStore(lazyStoreRef).dispatch(action);
    }, []);
    const marshalCallbacks = (0, $g21f0.useMemo)(()=>(0, $gJd8P.bindActionCreators)({
            publishWhileDragging: $371bc1a9f05b39cc$var$publishWhileDragging,
            updateDroppableScroll: $371bc1a9f05b39cc$var$updateDroppableScroll,
            updateDroppableIsEnabled: $371bc1a9f05b39cc$var$updateDroppableIsEnabled,
            updateDroppableIsCombineEnabled: $371bc1a9f05b39cc$var$updateDroppableIsCombineEnabled,
            collectionStarting: $371bc1a9f05b39cc$var$collectionStarting
        }, lazyDispatch), [
        lazyDispatch
    ]);
    const registry = $371bc1a9f05b39cc$var$useRegistry();
    const dimensionMarshal = (0, $g21f0.useMemo)(()=>{
        return $371bc1a9f05b39cc$var$createDimensionMarshal(registry, marshalCallbacks);
    }, [
        registry,
        marshalCallbacks
    ]);
    const autoScroller = (0, $g21f0.useMemo)(()=>$371bc1a9f05b39cc$var$createAutoScroller({
            scrollWindow: $371bc1a9f05b39cc$var$scrollWindow,
            scrollDroppable: dimensionMarshal.scrollDroppable,
            getAutoScrollerOptions: getAutoScrollerOptions,
            ...(0, $gJd8P.bindActionCreators)({
                move: $371bc1a9f05b39cc$var$move
            }, lazyDispatch)
        }), [
        dimensionMarshal.scrollDroppable,
        lazyDispatch,
        getAutoScrollerOptions
    ]);
    const focusMarshal = $371bc1a9f05b39cc$var$useFocusMarshal(contextId);
    const store = (0, $g21f0.useMemo)(()=>$371bc1a9f05b39cc$var$createStore({
            announce: announce,
            autoScroller: autoScroller,
            dimensionMarshal: dimensionMarshal,
            focusMarshal: focusMarshal,
            getResponders: getResponders,
            styleMarshal: styleMarshal
        }), [
        announce,
        autoScroller,
        dimensionMarshal,
        focusMarshal,
        getResponders,
        styleMarshal
    ]);
    lazyStoreRef.current = store;
    const tryResetStore = (0, $g21f0.useCallback)(()=>{
        const current = $371bc1a9f05b39cc$var$getStore(lazyStoreRef);
        const state = current.getState();
        if (state.phase !== "IDLE") current.dispatch($371bc1a9f05b39cc$var$flush());
    }, []);
    const isDragging = (0, $g21f0.useCallback)(()=>{
        const state = $371bc1a9f05b39cc$var$getStore(lazyStoreRef).getState();
        if (state.phase === "DROP_ANIMATING") return true;
        if (state.phase === "IDLE") return false;
        return state.isDragging;
    }, []);
    const appCallbacks = (0, $g21f0.useMemo)(()=>({
            isDragging: isDragging,
            tryAbort: tryResetStore
        }), [
        isDragging,
        tryResetStore
    ]);
    setCallbacks(appCallbacks);
    const getCanLift = (0, $g21f0.useCallback)((id)=>$371bc1a9f05b39cc$var$canStartDrag($371bc1a9f05b39cc$var$getStore(lazyStoreRef).getState(), id), []);
    const getIsMovementAllowed = (0, $g21f0.useCallback)(()=>$371bc1a9f05b39cc$var$isMovementAllowed($371bc1a9f05b39cc$var$getStore(lazyStoreRef).getState()), []);
    const appContext = (0, $g21f0.useMemo)(()=>({
            marshal: dimensionMarshal,
            focus: focusMarshal,
            contextId: contextId,
            canLift: getCanLift,
            isMovementAllowed: getIsMovementAllowed,
            dragHandleUsageInstructionsId: dragHandleUsageInstructionsId,
            registry: registry
        }), [
        contextId,
        dimensionMarshal,
        dragHandleUsageInstructionsId,
        focusMarshal,
        getCanLift,
        getIsMovementAllowed,
        registry
    ]);
    $371bc1a9f05b39cc$var$useSensorMarshal({
        contextId: contextId,
        store: store,
        registry: registry,
        customSensors: sensors || null,
        enableDefaultSensors: props.enableDefaultSensors !== false
    });
    (0, $jbmdS.useEffect)(()=>{
        return tryResetStore;
    }, [
        tryResetStore
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($371bc1a9f05b39cc$var$AppContext.Provider, {
        value: appContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $5Vhc6.Provider), {
        context: $371bc1a9f05b39cc$var$StoreContext,
        store: store
    }, props.children));
}
function $371bc1a9f05b39cc$var$useUniqueContextId() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useId();
}
function $371bc1a9f05b39cc$export$237bd83162c14364(props) {
    const contextId = $371bc1a9f05b39cc$var$useUniqueContextId();
    const dragHandleUsageInstructions = props.dragHandleUsageInstructions || $371bc1a9f05b39cc$var$preset.dragHandleUsageInstructions;
    return (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($371bc1a9f05b39cc$var$ErrorBoundary, null, (setCallbacks)=>(0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($371bc1a9f05b39cc$var$App, {
            nonce: props.nonce,
            contextId: contextId,
            setCallbacks: setCallbacks,
            dragHandleUsageInstructions: dragHandleUsageInstructions,
            enableDefaultSensors: props.enableDefaultSensors,
            sensors: props.sensors,
            onBeforeCapture: props.onBeforeCapture,
            onBeforeDragStart: props.onBeforeDragStart,
            onDragStart: props.onDragStart,
            onDragUpdate: props.onDragUpdate,
            onDragEnd: props.onDragEnd,
            autoScrollerOptions: props.autoScrollerOptions
        }, props.children));
}
const $371bc1a9f05b39cc$var$zIndexOptions = {
    dragging: 5000,
    dropAnimating: 4500
};
const $371bc1a9f05b39cc$var$getDraggingTransition = (shouldAnimateDragMovement, dropping)=>{
    if (dropping) return $371bc1a9f05b39cc$var$transitions.drop(dropping.duration);
    if (shouldAnimateDragMovement) return $371bc1a9f05b39cc$var$transitions.snap;
    return $371bc1a9f05b39cc$var$transitions.fluid;
};
const $371bc1a9f05b39cc$var$getDraggingOpacity = (isCombining, isDropAnimating)=>{
    if (!isCombining) return undefined;
    return isDropAnimating ? $371bc1a9f05b39cc$var$combine.opacity.drop : $371bc1a9f05b39cc$var$combine.opacity.combining;
};
const $371bc1a9f05b39cc$var$getShouldDraggingAnimate = (dragging)=>{
    if (dragging.forceShouldAnimate != null) return dragging.forceShouldAnimate;
    return dragging.mode === "SNAP";
};
function $371bc1a9f05b39cc$var$getDraggingStyle(dragging) {
    const dimension = dragging.dimension;
    const box = dimension.client;
    const { offset: offset, combineWith: combineWith, dropping: dropping } = dragging;
    const isCombining = Boolean(combineWith);
    const shouldAnimate = $371bc1a9f05b39cc$var$getShouldDraggingAnimate(dragging);
    const isDropAnimating = Boolean(dropping);
    const transform = isDropAnimating ? $371bc1a9f05b39cc$var$transforms.drop(offset, isCombining) : $371bc1a9f05b39cc$var$transforms.moveTo(offset);
    const style = {
        position: "fixed",
        top: box.marginBox.top,
        left: box.marginBox.left,
        boxSizing: "border-box",
        width: box.borderBox.width,
        height: box.borderBox.height,
        transition: $371bc1a9f05b39cc$var$getDraggingTransition(shouldAnimate, dropping),
        transform: transform,
        opacity: $371bc1a9f05b39cc$var$getDraggingOpacity(isCombining, isDropAnimating),
        zIndex: isDropAnimating ? $371bc1a9f05b39cc$var$zIndexOptions.dropAnimating : $371bc1a9f05b39cc$var$zIndexOptions.dragging,
        pointerEvents: "none"
    };
    return style;
}
function $371bc1a9f05b39cc$var$getSecondaryStyle(secondary) {
    return {
        transform: $371bc1a9f05b39cc$var$transforms.moveTo(secondary.offset),
        transition: secondary.shouldAnimateDisplacement ? undefined : "none"
    };
}
function $371bc1a9f05b39cc$var$getStyle$1(mapped) {
    return mapped.type === "DRAGGING" ? $371bc1a9f05b39cc$var$getDraggingStyle(mapped) : $371bc1a9f05b39cc$var$getSecondaryStyle(mapped);
}
function $371bc1a9f05b39cc$var$getDimension$1(descriptor, el, windowScroll = $371bc1a9f05b39cc$var$origin) {
    const computedStyles = window.getComputedStyle(el);
    const borderBox = el.getBoundingClientRect();
    const client = (0, $8rsfJ.calculateBox)(borderBox, computedStyles);
    const page = (0, $8rsfJ.withScroll)(client, windowScroll);
    const placeholder = {
        client: client,
        tagName: el.tagName.toLowerCase(),
        display: computedStyles.display
    };
    const displaceBy = {
        x: client.marginBox.width,
        y: client.marginBox.height
    };
    const dimension = {
        descriptor: descriptor,
        placeholder: placeholder,
        displaceBy: displaceBy,
        client: client,
        page: page
    };
    return dimension;
}
function $371bc1a9f05b39cc$var$useDraggablePublisher(args) {
    const uniqueId = $371bc1a9f05b39cc$var$useUniqueId("draggable");
    const { descriptor: descriptor, registry: registry, getDraggableRef: getDraggableRef, canDragInteractiveElements: canDragInteractiveElements, shouldRespectForcePress: shouldRespectForcePress, isEnabled: isEnabled } = args;
    const options = (0, $g21f0.useMemo)(()=>({
            canDragInteractiveElements: canDragInteractiveElements,
            shouldRespectForcePress: shouldRespectForcePress,
            isEnabled: isEnabled
        }), [
        canDragInteractiveElements,
        isEnabled,
        shouldRespectForcePress
    ]);
    const getDimension = (0, $g21f0.useCallback)((windowScroll)=>{
        const el = getDraggableRef();
        !el && $371bc1a9f05b39cc$var$invariant();
        return $371bc1a9f05b39cc$var$getDimension$1(descriptor, el, windowScroll);
    }, [
        descriptor,
        getDraggableRef
    ]);
    const entry = (0, $g21f0.useMemo)(()=>({
            uniqueId: uniqueId,
            descriptor: descriptor,
            options: options,
            getDimension: getDimension
        }), [
        descriptor,
        getDimension,
        options,
        uniqueId
    ]);
    const publishedRef = (0, $jbmdS.useRef)(entry);
    const isFirstPublishRef = (0, $jbmdS.useRef)(true);
    $371bc1a9f05b39cc$var$useIsomorphicLayoutEffect(()=>{
        registry.draggable.register(publishedRef.current);
        return ()=>registry.draggable.unregister(publishedRef.current);
    }, [
        registry.draggable
    ]);
    $371bc1a9f05b39cc$var$useIsomorphicLayoutEffect(()=>{
        if (isFirstPublishRef.current) {
            isFirstPublishRef.current = false;
            return;
        }
        const last = publishedRef.current;
        publishedRef.current = entry;
        registry.draggable.update(entry, last);
    }, [
        entry,
        registry.draggable
    ]);
}
var $371bc1a9f05b39cc$var$DroppableContext = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createContext(null);
function $371bc1a9f05b39cc$var$checkIsValidInnerRef(el) {
    !(el && $371bc1a9f05b39cc$var$isHtmlElement(el)) && $371bc1a9f05b39cc$var$invariant();
}
function $371bc1a9f05b39cc$var$useValidation$1(props, contextId, getRef) {
    $371bc1a9f05b39cc$var$useDevSetupWarning(()=>{
        function prefix(id) {
            return `Draggable[id: ${id}]: `;
        }
        const id = props.draggableId;
        !id && $371bc1a9f05b39cc$var$invariant(false);
        !(typeof id === "string") && $371bc1a9f05b39cc$var$invariant(false);
        !Number.isInteger(props.index) && $371bc1a9f05b39cc$var$invariant(false);
        if (props.mapped.type === "DRAGGING") return;
        $371bc1a9f05b39cc$var$checkIsValidInnerRef(getRef());
        if (props.isEnabled) !$371bc1a9f05b39cc$var$findDragHandle(contextId, id) && $371bc1a9f05b39cc$var$invariant(false);
    });
}
function $371bc1a9f05b39cc$var$useClonePropValidation(isClone) {
    $371bc1a9f05b39cc$var$useDev(()=>{
        const initialRef = (0, $jbmdS.useRef)(isClone);
        $371bc1a9f05b39cc$var$useDevSetupWarning(()=>{
            !(isClone === initialRef.current) && $371bc1a9f05b39cc$var$invariant(false);
        }, [
            isClone
        ]);
    });
}
function $371bc1a9f05b39cc$var$useRequiredContext(Context) {
    const result = (0, $jbmdS.useContext)(Context);
    !result && $371bc1a9f05b39cc$var$invariant();
    return result;
}
function $371bc1a9f05b39cc$var$preventHtml5Dnd(event) {
    event.preventDefault();
}
const $371bc1a9f05b39cc$var$Draggable = (props)=>{
    const ref = (0, $jbmdS.useRef)(null);
    const setRef = (0, $g21f0.useCallback)((el = null)=>{
        ref.current = el;
    }, []);
    const getRef = (0, $g21f0.useCallback)(()=>ref.current, []);
    const { contextId: contextId, dragHandleUsageInstructionsId: dragHandleUsageInstructionsId, registry: registry } = $371bc1a9f05b39cc$var$useRequiredContext($371bc1a9f05b39cc$var$AppContext);
    const { type: type, droppableId: droppableId } = $371bc1a9f05b39cc$var$useRequiredContext($371bc1a9f05b39cc$var$DroppableContext);
    const descriptor = (0, $g21f0.useMemo)(()=>({
            id: props.draggableId,
            index: props.index,
            type: type,
            droppableId: droppableId
        }), [
        props.draggableId,
        props.index,
        type,
        droppableId
    ]);
    const { children: children, draggableId: draggableId, isEnabled: isEnabled, shouldRespectForcePress: shouldRespectForcePress, canDragInteractiveElements: canDragInteractiveElements, isClone: isClone, mapped: mapped, dropAnimationFinished: dropAnimationFinishedAction } = props;
    $371bc1a9f05b39cc$var$useValidation$1(props, contextId, getRef);
    $371bc1a9f05b39cc$var$useClonePropValidation(isClone);
    if (!isClone) {
        const forPublisher = (0, $g21f0.useMemo)(()=>({
                descriptor: descriptor,
                registry: registry,
                getDraggableRef: getRef,
                canDragInteractiveElements: canDragInteractiveElements,
                shouldRespectForcePress: shouldRespectForcePress,
                isEnabled: isEnabled
            }), [
            descriptor,
            registry,
            getRef,
            canDragInteractiveElements,
            shouldRespectForcePress,
            isEnabled
        ]);
        $371bc1a9f05b39cc$var$useDraggablePublisher(forPublisher);
    }
    const dragHandleProps = (0, $g21f0.useMemo)(()=>isEnabled ? {
            tabIndex: 0,
            role: "button",
            "aria-describedby": dragHandleUsageInstructionsId,
            "data-rfd-drag-handle-draggable-id": draggableId,
            "data-rfd-drag-handle-context-id": contextId,
            draggable: false,
            onDragStart: $371bc1a9f05b39cc$var$preventHtml5Dnd
        } : null, [
        contextId,
        dragHandleUsageInstructionsId,
        draggableId,
        isEnabled
    ]);
    const onMoveEnd = (0, $g21f0.useCallback)((event)=>{
        if (mapped.type !== "DRAGGING") return;
        if (!mapped.dropping) return;
        if (event.propertyName !== "transform") return;
        (0, $jCNM0.flushSync)(dropAnimationFinishedAction);
    }, [
        dropAnimationFinishedAction,
        mapped
    ]);
    const provided = (0, $g21f0.useMemo)(()=>{
        const style = $371bc1a9f05b39cc$var$getStyle$1(mapped);
        const onTransitionEnd = mapped.type === "DRAGGING" && mapped.dropping ? onMoveEnd : undefined;
        const result = {
            innerRef: setRef,
            draggableProps: {
                "data-rfd-draggable-context-id": contextId,
                "data-rfd-draggable-id": draggableId,
                style: style,
                onTransitionEnd: onTransitionEnd
            },
            dragHandleProps: dragHandleProps
        };
        return result;
    }, [
        contextId,
        dragHandleProps,
        draggableId,
        mapped,
        onMoveEnd,
        setRef
    ]);
    const rubric = (0, $g21f0.useMemo)(()=>({
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        }), [
        descriptor.droppableId,
        descriptor.id,
        descriptor.index,
        descriptor.type
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).Fragment, null, children(provided, mapped.snapshot, rubric));
};
var $371bc1a9f05b39cc$var$isStrictEqual = (a, b)=>a === b;
var $371bc1a9f05b39cc$var$whatIsDraggedOverFromResult = (result)=>{
    const { combine: combine, destination: destination } = result;
    if (destination) return destination.droppableId;
    if (combine) return combine.droppableId;
    return null;
};
const $371bc1a9f05b39cc$var$getCombineWithFromResult = (result)=>{
    return result.combine ? result.combine.draggableId : null;
};
const $371bc1a9f05b39cc$var$getCombineWithFromImpact = (impact)=>{
    return impact.at && impact.at.type === "COMBINE" ? impact.at.combine.draggableId : null;
};
function $371bc1a9f05b39cc$var$getDraggableSelector() {
    const memoizedOffset = (0, $34S1T.default)((x, y)=>({
            x: x,
            y: y
        }));
    const getMemoizedSnapshot = (0, $34S1T.default)((mode, isClone, draggingOver = null, combineWith = null, dropping = null)=>({
            isDragging: true,
            isClone: isClone,
            isDropAnimating: Boolean(dropping),
            dropAnimation: dropping,
            mode: mode,
            draggingOver: draggingOver,
            combineWith: combineWith,
            combineTargetFor: null
        }));
    const getMemoizedProps = (0, $34S1T.default)((offset, mode, dimension, isClone, draggingOver = null, combineWith = null, forceShouldAnimate = null)=>({
            mapped: {
                type: "DRAGGING",
                dropping: null,
                draggingOver: draggingOver,
                combineWith: combineWith,
                mode: mode,
                offset: offset,
                dimension: dimension,
                forceShouldAnimate: forceShouldAnimate,
                snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, null)
            }
        }));
    const selector = (state, ownProps)=>{
        if ($371bc1a9f05b39cc$var$isDragging(state)) {
            if (state.critical.draggable.id !== ownProps.draggableId) return null;
            const offset = state.current.client.offset;
            const dimension = state.dimensions.draggables[ownProps.draggableId];
            const draggingOver = $371bc1a9f05b39cc$var$whatIsDraggedOver(state.impact);
            const combineWith = $371bc1a9f05b39cc$var$getCombineWithFromImpact(state.impact);
            const forceShouldAnimate = state.forceShouldAnimate;
            return getMemoizedProps(memoizedOffset(offset.x, offset.y), state.movementMode, dimension, ownProps.isClone, draggingOver, combineWith, forceShouldAnimate);
        }
        if (state.phase === "DROP_ANIMATING") {
            const completed = state.completed;
            if (completed.result.draggableId !== ownProps.draggableId) return null;
            const isClone = ownProps.isClone;
            const dimension = state.dimensions.draggables[ownProps.draggableId];
            const result = completed.result;
            const mode = result.mode;
            const draggingOver = $371bc1a9f05b39cc$var$whatIsDraggedOverFromResult(result);
            const combineWith = $371bc1a9f05b39cc$var$getCombineWithFromResult(result);
            const duration = state.dropDuration;
            const dropping = {
                duration: duration,
                curve: $371bc1a9f05b39cc$var$curves.drop,
                moveTo: state.newHomeClientOffset,
                opacity: combineWith ? $371bc1a9f05b39cc$var$combine.opacity.drop : null,
                scale: combineWith ? $371bc1a9f05b39cc$var$combine.scale.drop : null
            };
            return {
                mapped: {
                    type: "DRAGGING",
                    offset: state.newHomeClientOffset,
                    dimension: dimension,
                    dropping: dropping,
                    draggingOver: draggingOver,
                    combineWith: combineWith,
                    mode: mode,
                    forceShouldAnimate: null,
                    snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, dropping)
                }
            };
        }
        return null;
    };
    return selector;
}
function $371bc1a9f05b39cc$var$getSecondarySnapshot(combineTargetFor = null) {
    return {
        isDragging: false,
        isDropAnimating: false,
        isClone: false,
        dropAnimation: null,
        mode: null,
        draggingOver: null,
        combineTargetFor: combineTargetFor,
        combineWith: null
    };
}
const $371bc1a9f05b39cc$var$atRest = {
    mapped: {
        type: "SECONDARY",
        offset: $371bc1a9f05b39cc$var$origin,
        combineTargetFor: null,
        shouldAnimateDisplacement: true,
        snapshot: $371bc1a9f05b39cc$var$getSecondarySnapshot(null)
    }
};
function $371bc1a9f05b39cc$var$getSecondarySelector() {
    const memoizedOffset = (0, $34S1T.default)((x, y)=>({
            x: x,
            y: y
        }));
    const getMemoizedSnapshot = (0, $34S1T.default)($371bc1a9f05b39cc$var$getSecondarySnapshot);
    const getMemoizedProps = (0, $34S1T.default)((offset, combineTargetFor = null, shouldAnimateDisplacement)=>({
            mapped: {
                type: "SECONDARY",
                offset: offset,
                combineTargetFor: combineTargetFor,
                shouldAnimateDisplacement: shouldAnimateDisplacement,
                snapshot: getMemoizedSnapshot(combineTargetFor)
            }
        }));
    const getFallback = (combineTargetFor)=>{
        return combineTargetFor ? getMemoizedProps($371bc1a9f05b39cc$var$origin, combineTargetFor, true) : null;
    };
    const getProps = (ownId, draggingId, impact, afterCritical)=>{
        const visualDisplacement = impact.displaced.visible[ownId];
        const isAfterCriticalInVirtualList = Boolean(afterCritical.inVirtualList && afterCritical.effected[ownId]);
        const combine = $371bc1a9f05b39cc$var$tryGetCombine(impact);
        const combineTargetFor = combine && combine.draggableId === ownId ? draggingId : null;
        if (!visualDisplacement) {
            if (!isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
            if (impact.displaced.invisible[ownId]) return null;
            const change = $371bc1a9f05b39cc$var$negate(afterCritical.displacedBy.point);
            const offset = memoizedOffset(change.x, change.y);
            return getMemoizedProps(offset, combineTargetFor, true);
        }
        if (isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
        const displaceBy = impact.displacedBy.point;
        const offset = memoizedOffset(displaceBy.x, displaceBy.y);
        return getMemoizedProps(offset, combineTargetFor, visualDisplacement.shouldAnimate);
    };
    const selector = (state, ownProps)=>{
        if ($371bc1a9f05b39cc$var$isDragging(state)) {
            if (state.critical.draggable.id === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, state.critical.draggable.id, state.impact, state.afterCritical);
        }
        if (state.phase === "DROP_ANIMATING") {
            const completed = state.completed;
            if (completed.result.draggableId === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, completed.result.draggableId, completed.impact, completed.afterCritical);
        }
        return null;
    };
    return selector;
}
const $371bc1a9f05b39cc$var$makeMapStateToProps$1 = ()=>{
    const draggingSelector = $371bc1a9f05b39cc$var$getDraggableSelector();
    const secondarySelector = $371bc1a9f05b39cc$var$getSecondarySelector();
    const selector = (state, ownProps)=>draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || $371bc1a9f05b39cc$var$atRest;
    return selector;
};
const $371bc1a9f05b39cc$var$mapDispatchToProps$1 = {
    dropAnimationFinished: $371bc1a9f05b39cc$var$dropAnimationFinished
};
const $371bc1a9f05b39cc$var$ConnectedDraggable = (0, $5Vhc6.connect)($371bc1a9f05b39cc$var$makeMapStateToProps$1, $371bc1a9f05b39cc$var$mapDispatchToProps$1, null, {
    context: $371bc1a9f05b39cc$var$StoreContext,
    areStatePropsEqual: $371bc1a9f05b39cc$var$isStrictEqual
})($371bc1a9f05b39cc$var$Draggable);
function $371bc1a9f05b39cc$var$PrivateDraggable(props) {
    const droppableContext = $371bc1a9f05b39cc$var$useRequiredContext($371bc1a9f05b39cc$var$DroppableContext);
    const isUsingCloneFor = droppableContext.isUsingCloneFor;
    if (isUsingCloneFor === props.draggableId && !props.isClone) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($371bc1a9f05b39cc$var$ConnectedDraggable, props);
}
function $371bc1a9f05b39cc$export$f2a139e5d18b9882(props) {
    const isEnabled = typeof props.isDragDisabled === "boolean" ? !props.isDragDisabled : true;
    const canDragInteractiveElements = Boolean(props.disableInteractiveElementBlocking);
    const shouldRespectForcePress = Boolean(props.shouldRespectForcePress);
    return (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($371bc1a9f05b39cc$var$PrivateDraggable, (0, $7i29i.default)({}, props, {
        isClone: false,
        isEnabled: isEnabled,
        canDragInteractiveElements: canDragInteractiveElements,
        shouldRespectForcePress: shouldRespectForcePress
    }));
}
const $371bc1a9f05b39cc$var$isEqual = (base)=>(value)=>base === value;
const $371bc1a9f05b39cc$var$isScroll = $371bc1a9f05b39cc$var$isEqual("scroll");
const $371bc1a9f05b39cc$var$isAuto = $371bc1a9f05b39cc$var$isEqual("auto");
const $371bc1a9f05b39cc$var$isVisible = $371bc1a9f05b39cc$var$isEqual("visible");
const $371bc1a9f05b39cc$var$isEither = (overflow, fn)=>fn(overflow.overflowX) || fn(overflow.overflowY);
const $371bc1a9f05b39cc$var$isBoth = (overflow, fn)=>fn(overflow.overflowX) && fn(overflow.overflowY);
const $371bc1a9f05b39cc$var$isElementScrollable = (el)=>{
    const style = window.getComputedStyle(el);
    const overflow = {
        overflowX: style.overflowX,
        overflowY: style.overflowY
    };
    return $371bc1a9f05b39cc$var$isEither(overflow, $371bc1a9f05b39cc$var$isScroll) || $371bc1a9f05b39cc$var$isEither(overflow, $371bc1a9f05b39cc$var$isAuto);
};
const $371bc1a9f05b39cc$var$isBodyScrollable = ()=>{
    return false;
};
const $371bc1a9f05b39cc$var$getClosestScrollable = (el)=>{
    if (el == null) return null;
    if (el === document.body) return $371bc1a9f05b39cc$var$isBodyScrollable() ? el : null;
    if (el === document.documentElement) return null;
    if (!$371bc1a9f05b39cc$var$isElementScrollable(el)) return $371bc1a9f05b39cc$var$getClosestScrollable(el.parentElement);
    return el;
};
var $371bc1a9f05b39cc$var$checkForNestedScrollContainers = (scrollable)=>{
    if (!scrollable) return;
    const anotherScrollParent = $371bc1a9f05b39cc$var$getClosestScrollable(scrollable.parentElement);
    if (!anotherScrollParent) return;
};
var $371bc1a9f05b39cc$var$getScroll = (el)=>({
        x: el.scrollLeft,
        y: el.scrollTop
    });
const $371bc1a9f05b39cc$var$getIsFixed = (el)=>{
    if (!el) return false;
    const style = window.getComputedStyle(el);
    if (style.position === "fixed") return true;
    return $371bc1a9f05b39cc$var$getIsFixed(el.parentElement);
};
var $371bc1a9f05b39cc$var$getEnv = (start)=>{
    const closestScrollable = $371bc1a9f05b39cc$var$getClosestScrollable(start);
    const isFixedOnPage = $371bc1a9f05b39cc$var$getIsFixed(start);
    return {
        closestScrollable: closestScrollable,
        isFixedOnPage: isFixedOnPage
    };
};
var $371bc1a9f05b39cc$var$getDroppableDimension = ({ descriptor: descriptor, isEnabled: isEnabled, isCombineEnabled: isCombineEnabled, isFixedOnPage: isFixedOnPage, direction: direction, client: client, page: page, closest: closest })=>{
    const frame = (()=>{
        if (!closest) return null;
        const { scrollSize: scrollSize, client: frameClient } = closest;
        const maxScroll = $371bc1a9f05b39cc$var$getMaxScroll({
            scrollHeight: scrollSize.scrollHeight,
            scrollWidth: scrollSize.scrollWidth,
            height: frameClient.paddingBox.height,
            width: frameClient.paddingBox.width
        });
        return {
            pageMarginBox: closest.page.marginBox,
            frameClient: frameClient,
            scrollSize: scrollSize,
            shouldClipSubject: closest.shouldClipSubject,
            scroll: {
                initial: closest.scroll,
                current: closest.scroll,
                max: maxScroll,
                diff: {
                    value: $371bc1a9f05b39cc$var$origin,
                    displacement: $371bc1a9f05b39cc$var$origin
                }
            }
        };
    })();
    const axis = direction === "vertical" ? $371bc1a9f05b39cc$var$vertical : $371bc1a9f05b39cc$var$horizontal;
    const subject = $371bc1a9f05b39cc$var$getSubject({
        page: page,
        withPlaceholder: null,
        axis: axis,
        frame: frame
    });
    const dimension = {
        descriptor: descriptor,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: isFixedOnPage,
        axis: axis,
        isEnabled: isEnabled,
        client: client,
        page: page,
        frame: frame,
        subject: subject
    };
    return dimension;
};
const $371bc1a9f05b39cc$var$getClient = (targetRef, closestScrollable)=>{
    const base = (0, $8rsfJ.getBox)(targetRef);
    if (!closestScrollable) return base;
    if (targetRef !== closestScrollable) return base;
    const top = base.paddingBox.top - closestScrollable.scrollTop;
    const left = base.paddingBox.left - closestScrollable.scrollLeft;
    const bottom = top + closestScrollable.scrollHeight;
    const right = left + closestScrollable.scrollWidth;
    const paddingBox = {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
    const borderBox = (0, $8rsfJ.expand)(paddingBox, base.border);
    const client = (0, $8rsfJ.createBox)({
        borderBox: borderBox,
        margin: base.margin,
        border: base.border,
        padding: base.padding
    });
    return client;
};
var $371bc1a9f05b39cc$var$getDimension = ({ ref: ref, descriptor: descriptor, env: env, windowScroll: windowScroll, direction: direction, isDropDisabled: isDropDisabled, isCombineEnabled: isCombineEnabled, shouldClipSubject: shouldClipSubject })=>{
    const closestScrollable = env.closestScrollable;
    const client = $371bc1a9f05b39cc$var$getClient(ref, closestScrollable);
    const page = (0, $8rsfJ.withScroll)(client, windowScroll);
    const closest = (()=>{
        if (!closestScrollable) return null;
        const frameClient = (0, $8rsfJ.getBox)(closestScrollable);
        const scrollSize = {
            scrollHeight: closestScrollable.scrollHeight,
            scrollWidth: closestScrollable.scrollWidth
        };
        return {
            client: frameClient,
            page: (0, $8rsfJ.withScroll)(frameClient, windowScroll),
            scroll: $371bc1a9f05b39cc$var$getScroll(closestScrollable),
            scrollSize: scrollSize,
            shouldClipSubject: shouldClipSubject
        };
    })();
    const dimension = $371bc1a9f05b39cc$var$getDroppableDimension({
        descriptor: descriptor,
        isEnabled: !isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: env.isFixedOnPage,
        direction: direction,
        client: client,
        page: page,
        closest: closest
    });
    return dimension;
};
const $371bc1a9f05b39cc$var$immediate = {
    passive: false
};
const $371bc1a9f05b39cc$var$delayed = {
    passive: true
};
var $371bc1a9f05b39cc$var$getListenerOptions = (options)=>options.shouldPublishImmediately ? $371bc1a9f05b39cc$var$immediate : $371bc1a9f05b39cc$var$delayed;
const $371bc1a9f05b39cc$var$getClosestScrollableFromDrag = (dragging)=>dragging && dragging.env.closestScrollable || null;
function $371bc1a9f05b39cc$var$useDroppablePublisher(args) {
    const whileDraggingRef = (0, $jbmdS.useRef)(null);
    const appContext = $371bc1a9f05b39cc$var$useRequiredContext($371bc1a9f05b39cc$var$AppContext);
    const uniqueId = $371bc1a9f05b39cc$var$useUniqueId("droppable");
    const { registry: registry, marshal: marshal } = appContext;
    const previousRef = $371bc1a9f05b39cc$var$usePrevious(args);
    const descriptor = (0, $g21f0.useMemo)(()=>({
            id: args.droppableId,
            type: args.type,
            mode: args.mode
        }), [
        args.droppableId,
        args.mode,
        args.type
    ]);
    const publishedDescriptorRef = (0, $jbmdS.useRef)(descriptor);
    const memoizedUpdateScroll = (0, $g21f0.useMemo)(()=>(0, $34S1T.default)((x, y)=>{
            !whileDraggingRef.current && $371bc1a9f05b39cc$var$invariant();
            const scroll = {
                x: x,
                y: y
            };
            marshal.updateDroppableScroll(descriptor.id, scroll);
        }), [
        descriptor.id,
        marshal
    ]);
    const getClosestScroll = (0, $g21f0.useCallback)(()=>{
        const dragging = whileDraggingRef.current;
        if (!dragging || !dragging.env.closestScrollable) return $371bc1a9f05b39cc$var$origin;
        return $371bc1a9f05b39cc$var$getScroll(dragging.env.closestScrollable);
    }, []);
    const updateScroll = (0, $g21f0.useCallback)(()=>{
        const scroll = getClosestScroll();
        memoizedUpdateScroll(scroll.x, scroll.y);
    }, [
        getClosestScroll,
        memoizedUpdateScroll
    ]);
    const scheduleScrollUpdate = (0, $g21f0.useMemo)(()=>(0, $RIdqi.default)(updateScroll), [
        updateScroll
    ]);
    const onClosestScroll = (0, $g21f0.useCallback)(()=>{
        const dragging = whileDraggingRef.current;
        const closest = $371bc1a9f05b39cc$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $371bc1a9f05b39cc$var$invariant();
        const options = dragging.scrollOptions;
        if (options.shouldPublishImmediately) {
            updateScroll();
            return;
        }
        scheduleScrollUpdate();
    }, [
        scheduleScrollUpdate,
        updateScroll
    ]);
    const getDimensionAndWatchScroll = (0, $g21f0.useCallback)((windowScroll, options)=>{
        !!whileDraggingRef.current && $371bc1a9f05b39cc$var$invariant();
        const previous = previousRef.current;
        const ref = previous.getDroppableRef();
        !ref && $371bc1a9f05b39cc$var$invariant();
        const env = $371bc1a9f05b39cc$var$getEnv(ref);
        const dragging = {
            ref: ref,
            descriptor: descriptor,
            env: env,
            scrollOptions: options
        };
        whileDraggingRef.current = dragging;
        const dimension = $371bc1a9f05b39cc$var$getDimension({
            ref: ref,
            descriptor: descriptor,
            env: env,
            windowScroll: windowScroll,
            direction: previous.direction,
            isDropDisabled: previous.isDropDisabled,
            isCombineEnabled: previous.isCombineEnabled,
            shouldClipSubject: !previous.ignoreContainerClipping
        });
        const scrollable = env.closestScrollable;
        if (scrollable) {
            scrollable.setAttribute($371bc1a9f05b39cc$var$scrollContainer.contextId, appContext.contextId);
            scrollable.addEventListener("scroll", onClosestScroll, $371bc1a9f05b39cc$var$getListenerOptions(dragging.scrollOptions));
        }
        return dimension;
    }, [
        appContext.contextId,
        descriptor,
        onClosestScroll,
        previousRef
    ]);
    const getScrollWhileDragging = (0, $g21f0.useCallback)(()=>{
        const dragging = whileDraggingRef.current;
        const closest = $371bc1a9f05b39cc$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $371bc1a9f05b39cc$var$invariant();
        return $371bc1a9f05b39cc$var$getScroll(closest);
    }, []);
    const dragStopped = (0, $g21f0.useCallback)(()=>{
        const dragging = whileDraggingRef.current;
        !dragging && $371bc1a9f05b39cc$var$invariant();
        const closest = $371bc1a9f05b39cc$var$getClosestScrollableFromDrag(dragging);
        whileDraggingRef.current = null;
        if (!closest) return;
        scheduleScrollUpdate.cancel();
        closest.removeAttribute($371bc1a9f05b39cc$var$scrollContainer.contextId);
        closest.removeEventListener("scroll", onClosestScroll, $371bc1a9f05b39cc$var$getListenerOptions(dragging.scrollOptions));
    }, [
        onClosestScroll,
        scheduleScrollUpdate
    ]);
    const scroll = (0, $g21f0.useCallback)((change)=>{
        const dragging = whileDraggingRef.current;
        !dragging && $371bc1a9f05b39cc$var$invariant();
        const closest = $371bc1a9f05b39cc$var$getClosestScrollableFromDrag(dragging);
        !closest && $371bc1a9f05b39cc$var$invariant();
        closest.scrollTop += change.y;
        closest.scrollLeft += change.x;
    }, []);
    const callbacks = (0, $g21f0.useMemo)(()=>{
        return {
            getDimensionAndWatchScroll: getDimensionAndWatchScroll,
            getScrollWhileDragging: getScrollWhileDragging,
            dragStopped: dragStopped,
            scroll: scroll
        };
    }, [
        dragStopped,
        getDimensionAndWatchScroll,
        getScrollWhileDragging,
        scroll
    ]);
    const entry = (0, $g21f0.useMemo)(()=>({
            uniqueId: uniqueId,
            descriptor: descriptor,
            callbacks: callbacks
        }), [
        callbacks,
        descriptor,
        uniqueId
    ]);
    $371bc1a9f05b39cc$var$useIsomorphicLayoutEffect(()=>{
        publishedDescriptorRef.current = entry.descriptor;
        registry.droppable.register(entry);
        return ()=>{
            if (whileDraggingRef.current) dragStopped();
            registry.droppable.unregister(entry);
        };
    }, [
        callbacks,
        descriptor,
        dragStopped,
        entry,
        marshal,
        registry.droppable
    ]);
    $371bc1a9f05b39cc$var$useIsomorphicLayoutEffect(()=>{
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
    }, [
        args.isDropDisabled,
        marshal
    ]);
    $371bc1a9f05b39cc$var$useIsomorphicLayoutEffect(()=>{
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
    }, [
        args.isCombineEnabled,
        marshal
    ]);
}
function $371bc1a9f05b39cc$var$noop() {}
const $371bc1a9f05b39cc$var$empty = {
    width: 0,
    height: 0,
    margin: $371bc1a9f05b39cc$var$noSpacing
};
const $371bc1a9f05b39cc$var$getSize = ({ isAnimatingOpenOnMount: isAnimatingOpenOnMount, placeholder: placeholder, animate: animate })=>{
    if (isAnimatingOpenOnMount) return $371bc1a9f05b39cc$var$empty;
    if (animate === "close") return $371bc1a9f05b39cc$var$empty;
    return {
        height: placeholder.client.borderBox.height,
        width: placeholder.client.borderBox.width,
        margin: placeholder.client.margin
    };
};
const $371bc1a9f05b39cc$var$getStyle = ({ isAnimatingOpenOnMount: isAnimatingOpenOnMount, placeholder: placeholder, animate: animate })=>{
    const size = $371bc1a9f05b39cc$var$getSize({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        placeholder: placeholder,
        animate: animate
    });
    return {
        display: placeholder.display,
        boxSizing: "border-box",
        width: size.width,
        height: size.height,
        marginTop: size.margin.top,
        marginRight: size.margin.right,
        marginBottom: size.margin.bottom,
        marginLeft: size.margin.left,
        flexShrink: "0",
        flexGrow: "0",
        pointerEvents: "none",
        transition: animate !== "none" ? $371bc1a9f05b39cc$var$transitions.placeholder : null
    };
};
const $371bc1a9f05b39cc$var$Placeholder = (props)=>{
    const animateOpenTimerRef = (0, $jbmdS.useRef)(null);
    const tryClearAnimateOpenTimer = (0, $g21f0.useCallback)(()=>{
        if (!animateOpenTimerRef.current) return;
        clearTimeout(animateOpenTimerRef.current);
        animateOpenTimerRef.current = null;
    }, []);
    const { animate: animate, onTransitionEnd: onTransitionEnd, onClose: onClose, contextId: contextId } = props;
    const [isAnimatingOpenOnMount, setIsAnimatingOpenOnMount] = (0, $jbmdS.useState)(props.animate === "open");
    (0, $jbmdS.useEffect)(()=>{
        if (!isAnimatingOpenOnMount) return $371bc1a9f05b39cc$var$noop;
        if (animate !== "open") {
            tryClearAnimateOpenTimer();
            setIsAnimatingOpenOnMount(false);
            return $371bc1a9f05b39cc$var$noop;
        }
        if (animateOpenTimerRef.current) return $371bc1a9f05b39cc$var$noop;
        animateOpenTimerRef.current = setTimeout(()=>{
            animateOpenTimerRef.current = null;
            setIsAnimatingOpenOnMount(false);
        });
        return tryClearAnimateOpenTimer;
    }, [
        animate,
        isAnimatingOpenOnMount,
        tryClearAnimateOpenTimer
    ]);
    const onSizeChangeEnd = (0, $g21f0.useCallback)((event)=>{
        if (event.propertyName !== "height") return;
        onTransitionEnd();
        if (animate === "close") onClose();
    }, [
        animate,
        onClose,
        onTransitionEnd
    ]);
    const style = $371bc1a9f05b39cc$var$getStyle({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        animate: props.animate,
        placeholder: props.placeholder
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement(props.placeholder.tagName, {
        style: style,
        "data-rfd-placeholder-context-id": contextId,
        onTransitionEnd: onSizeChangeEnd,
        ref: props.innerRef
    });
};
var $371bc1a9f05b39cc$var$Placeholder$1 = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).memo($371bc1a9f05b39cc$var$Placeholder);
function $371bc1a9f05b39cc$var$isBoolean(value) {
    return typeof value === "boolean";
}
function $371bc1a9f05b39cc$var$runChecks(args, checks) {
    checks.forEach((check)=>check(args));
}
const $371bc1a9f05b39cc$var$shared = [
    function required({ props: props }) {
        !props.droppableId && $371bc1a9f05b39cc$var$invariant();
        !(typeof props.droppableId === "string") && $371bc1a9f05b39cc$var$invariant();
    },
    function boolean({ props: props }) {
        !$371bc1a9f05b39cc$var$isBoolean(props.isDropDisabled) && $371bc1a9f05b39cc$var$invariant();
        !$371bc1a9f05b39cc$var$isBoolean(props.isCombineEnabled) && $371bc1a9f05b39cc$var$invariant();
        !$371bc1a9f05b39cc$var$isBoolean(props.ignoreContainerClipping) && $371bc1a9f05b39cc$var$invariant();
    },
    function ref({ getDroppableRef: getDroppableRef }) {
        $371bc1a9f05b39cc$var$checkIsValidInnerRef(getDroppableRef());
    }
];
const $371bc1a9f05b39cc$var$standard = [
    function placeholder({ props: props, getPlaceholderRef: getPlaceholderRef }) {
        if (!props.placeholder) return;
        const ref = getPlaceholderRef();
        if (ref) return;
    }
];
const $371bc1a9f05b39cc$var$virtual = [
    function hasClone({ props: props }) {
        !props.renderClone && $371bc1a9f05b39cc$var$invariant();
    },
    function hasNoPlaceholder({ getPlaceholderRef: getPlaceholderRef }) {
        !!getPlaceholderRef() && $371bc1a9f05b39cc$var$invariant();
    }
];
function $371bc1a9f05b39cc$var$useValidation(args) {
    $371bc1a9f05b39cc$var$useDevSetupWarning(()=>{
        $371bc1a9f05b39cc$var$runChecks(args, $371bc1a9f05b39cc$var$shared);
        if (args.props.mode === "standard") $371bc1a9f05b39cc$var$runChecks(args, $371bc1a9f05b39cc$var$standard);
        if (args.props.mode === "virtual") $371bc1a9f05b39cc$var$runChecks(args, $371bc1a9f05b39cc$var$virtual);
    });
}
class $371bc1a9f05b39cc$var$AnimateInOut extends (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).PureComponent {
    constructor(...args){
        super(...args);
        this.state = {
            isVisible: Boolean(this.props.on),
            data: this.props.on,
            animate: this.props.shouldAnimate && this.props.on ? "open" : "none"
        };
        this.onClose = ()=>{
            if (this.state.animate !== "close") return;
            this.setState({
                isVisible: false
            });
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (!props.shouldAnimate) return {
            isVisible: Boolean(props.on),
            data: props.on,
            animate: "none"
        };
        if (props.on) return {
            isVisible: true,
            data: props.on,
            animate: "open"
        };
        if (state.isVisible) return {
            isVisible: true,
            data: state.data,
            animate: "close"
        };
        return {
            isVisible: false,
            animate: "close",
            data: null
        };
    }
    render() {
        if (!this.state.isVisible) return null;
        const provided = {
            onClose: this.onClose,
            data: this.state.data,
            animate: this.state.animate
        };
        return this.props.children(provided);
    }
}
const $371bc1a9f05b39cc$var$Droppable = (props)=>{
    const appContext = (0, $jbmdS.useContext)($371bc1a9f05b39cc$var$AppContext);
    !appContext && $371bc1a9f05b39cc$var$invariant();
    const { contextId: contextId, isMovementAllowed: isMovementAllowed } = appContext;
    const droppableRef = (0, $jbmdS.useRef)(null);
    const placeholderRef = (0, $jbmdS.useRef)(null);
    const { children: children, droppableId: droppableId, type: type, mode: mode, direction: direction, ignoreContainerClipping: ignoreContainerClipping, isDropDisabled: isDropDisabled, isCombineEnabled: isCombineEnabled, snapshot: snapshot, useClone: useClone, updateViewportMaxScroll: updateViewportMaxScroll, getContainerForClone: getContainerForClone } = props;
    const getDroppableRef = (0, $g21f0.useCallback)(()=>droppableRef.current, []);
    const setDroppableRef = (0, $g21f0.useCallback)((value = null)=>{
        droppableRef.current = value;
    }, []);
    const getPlaceholderRef = (0, $g21f0.useCallback)(()=>placeholderRef.current, []);
    const setPlaceholderRef = (0, $g21f0.useCallback)((value = null)=>{
        placeholderRef.current = value;
    }, []);
    $371bc1a9f05b39cc$var$useValidation({
        props: props,
        getDroppableRef: getDroppableRef,
        getPlaceholderRef: getPlaceholderRef
    });
    const onPlaceholderTransitionEnd = (0, $g21f0.useCallback)(()=>{
        if (isMovementAllowed()) updateViewportMaxScroll({
            maxScroll: $371bc1a9f05b39cc$var$getMaxWindowScroll()
        });
    }, [
        isMovementAllowed,
        updateViewportMaxScroll
    ]);
    $371bc1a9f05b39cc$var$useDroppablePublisher({
        droppableId: droppableId,
        type: type,
        mode: mode,
        direction: direction,
        isDropDisabled: isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        ignoreContainerClipping: ignoreContainerClipping,
        getDroppableRef: getDroppableRef
    });
    const placeholder = (0, $g21f0.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($371bc1a9f05b39cc$var$AnimateInOut, {
            on: props.placeholder,
            shouldAnimate: props.shouldAnimatePlaceholder
        }, ({ onClose: onClose, data: data, animate: animate })=>(0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($371bc1a9f05b39cc$var$Placeholder$1, {
                placeholder: data,
                onClose: onClose,
                innerRef: setPlaceholderRef,
                animate: animate,
                contextId: contextId,
                onTransitionEnd: onPlaceholderTransitionEnd
            })), [
        contextId,
        onPlaceholderTransitionEnd,
        props.placeholder,
        props.shouldAnimatePlaceholder,
        setPlaceholderRef
    ]);
    const provided = (0, $g21f0.useMemo)(()=>({
            innerRef: setDroppableRef,
            placeholder: placeholder,
            droppableProps: {
                "data-rfd-droppable-id": droppableId,
                "data-rfd-droppable-context-id": contextId
            }
        }), [
        contextId,
        droppableId,
        placeholder,
        setDroppableRef
    ]);
    const isUsingCloneFor = useClone ? useClone.dragging.draggableId : null;
    const droppableContext = (0, $g21f0.useMemo)(()=>({
            droppableId: droppableId,
            type: type,
            isUsingCloneFor: isUsingCloneFor
        }), [
        droppableId,
        isUsingCloneFor,
        type
    ]);
    function getClone() {
        if (!useClone) return null;
        const { dragging: dragging, render: render } = useClone;
        const node = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($371bc1a9f05b39cc$var$PrivateDraggable, {
            draggableId: dragging.draggableId,
            index: dragging.source.index,
            isClone: true,
            isEnabled: true,
            shouldRespectForcePress: false,
            canDragInteractiveElements: true
        }, (draggableProvided, draggableSnapshot)=>render(draggableProvided, draggableSnapshot, dragging));
        return (0, (/*@__PURE__*/$parcel$interopDefault($jCNM0))).createPortal(node, getContainerForClone());
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($371bc1a9f05b39cc$var$DroppableContext.Provider, {
        value: droppableContext
    }, children(provided, snapshot), getClone());
};
function $371bc1a9f05b39cc$var$getBody() {
    !document.body && $371bc1a9f05b39cc$var$invariant();
    return document.body;
}
const $371bc1a9f05b39cc$var$defaultProps = {
    mode: "standard",
    type: "DEFAULT",
    direction: "vertical",
    isDropDisabled: false,
    isCombineEnabled: false,
    ignoreContainerClipping: false,
    renderClone: null,
    getContainerForClone: $371bc1a9f05b39cc$var$getBody
};
const $371bc1a9f05b39cc$var$attachDefaultPropsToOwnProps = (ownProps)=>{
    let mergedProps = {
        ...ownProps
    };
    let defaultPropKey;
    for(defaultPropKey in $371bc1a9f05b39cc$var$defaultProps)if (ownProps[defaultPropKey] === undefined) mergedProps = {
        ...mergedProps,
        [defaultPropKey]: $371bc1a9f05b39cc$var$defaultProps[defaultPropKey]
    };
    return mergedProps;
};
const $371bc1a9f05b39cc$var$isMatchingType = (type, critical)=>type === critical.droppable.type;
const $371bc1a9f05b39cc$var$getDraggable = (critical, dimensions)=>dimensions.draggables[critical.draggable.id];
const $371bc1a9f05b39cc$var$makeMapStateToProps = ()=>{
    const idleWithAnimation = {
        placeholder: null,
        shouldAnimatePlaceholder: true,
        snapshot: {
            isDraggingOver: false,
            draggingOverWith: null,
            draggingFromThisWith: null,
            isUsingPlaceholder: false
        },
        useClone: null
    };
    const idleWithoutAnimation = {
        ...idleWithAnimation,
        shouldAnimatePlaceholder: false
    };
    const getDraggableRubric = (0, $34S1T.default)((descriptor)=>({
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        }));
    const getMapProps = (0, $34S1T.default)((id, isEnabled, isDraggingOverForConsumer, isDraggingOverForImpact, dragging, renderClone)=>{
        const draggableId = dragging.descriptor.id;
        const isHome = dragging.descriptor.droppableId === id;
        if (isHome) {
            const useClone = renderClone ? {
                render: renderClone,
                dragging: getDraggableRubric(dragging.descriptor)
            } : null;
            const snapshot = {
                isDraggingOver: isDraggingOverForConsumer,
                draggingOverWith: isDraggingOverForConsumer ? draggableId : null,
                draggingFromThisWith: draggableId,
                isUsingPlaceholder: true
            };
            return {
                placeholder: dragging.placeholder,
                shouldAnimatePlaceholder: false,
                snapshot: snapshot,
                useClone: useClone
            };
        }
        if (!isEnabled) return idleWithoutAnimation;
        if (!isDraggingOverForImpact) return idleWithAnimation;
        const snapshot = {
            isDraggingOver: isDraggingOverForConsumer,
            draggingOverWith: draggableId,
            draggingFromThisWith: null,
            isUsingPlaceholder: true
        };
        return {
            placeholder: dragging.placeholder,
            shouldAnimatePlaceholder: true,
            snapshot: snapshot,
            useClone: null
        };
    });
    const selector = (state, ownProps)=>{
        const ownPropsWithDefaultProps = $371bc1a9f05b39cc$var$attachDefaultPropsToOwnProps(ownProps);
        const id = ownPropsWithDefaultProps.droppableId;
        const type = ownPropsWithDefaultProps.type;
        const isEnabled = !ownPropsWithDefaultProps.isDropDisabled;
        const renderClone = ownPropsWithDefaultProps.renderClone;
        if ($371bc1a9f05b39cc$var$isDragging(state)) {
            const critical = state.critical;
            if (!$371bc1a9f05b39cc$var$isMatchingType(type, critical)) return idleWithoutAnimation;
            const dragging = $371bc1a9f05b39cc$var$getDraggable(critical, state.dimensions);
            const isDraggingOver = $371bc1a9f05b39cc$var$whatIsDraggedOver(state.impact) === id;
            return getMapProps(id, isEnabled, isDraggingOver, isDraggingOver, dragging, renderClone);
        }
        if (state.phase === "DROP_ANIMATING") {
            const completed = state.completed;
            if (!$371bc1a9f05b39cc$var$isMatchingType(type, completed.critical)) return idleWithoutAnimation;
            const dragging = $371bc1a9f05b39cc$var$getDraggable(completed.critical, state.dimensions);
            return getMapProps(id, isEnabled, $371bc1a9f05b39cc$var$whatIsDraggedOverFromResult(completed.result) === id, $371bc1a9f05b39cc$var$whatIsDraggedOver(completed.impact) === id, dragging, renderClone);
        }
        if (state.phase === "IDLE" && state.completed && !state.shouldFlush) {
            const completed = state.completed;
            if (!$371bc1a9f05b39cc$var$isMatchingType(type, completed.critical)) return idleWithoutAnimation;
            const wasOver = $371bc1a9f05b39cc$var$whatIsDraggedOver(completed.impact) === id;
            const wasCombining = Boolean(completed.impact.at && completed.impact.at.type === "COMBINE");
            const isHome = completed.critical.droppable.id === id;
            if (wasOver) return wasCombining ? idleWithAnimation : idleWithoutAnimation;
            if (isHome) return idleWithAnimation;
            return idleWithoutAnimation;
        }
        return idleWithoutAnimation;
    };
    return selector;
};
const $371bc1a9f05b39cc$var$mapDispatchToProps = {
    updateViewportMaxScroll: $371bc1a9f05b39cc$var$updateViewportMaxScroll
};
const $371bc1a9f05b39cc$var$ConnectedDroppable = (0, $5Vhc6.connect)($371bc1a9f05b39cc$var$makeMapStateToProps, $371bc1a9f05b39cc$var$mapDispatchToProps, (stateProps, dispatchProps, ownProps)=>{
    return {
        ...$371bc1a9f05b39cc$var$attachDefaultPropsToOwnProps(ownProps),
        ...stateProps,
        ...dispatchProps
    };
}, {
    context: $371bc1a9f05b39cc$var$StoreContext,
    areStatePropsEqual: $371bc1a9f05b39cc$var$isStrictEqual
})($371bc1a9f05b39cc$var$Droppable);
var $371bc1a9f05b39cc$export$423ec2075359570a = $371bc1a9f05b39cc$var$ConnectedDroppable;

});
parcelRegister("gJd8P", function(module, exports) {

$parcel$export(module.exports, "createStore", function () { return $c2db0aeb56498364$export$f51a9068ac82ea43; });
$parcel$export(module.exports, "bindActionCreators", function () { return $c2db0aeb56498364$export$aea084d96e84da92; });
$parcel$export(module.exports, "compose", function () { return $c2db0aeb56498364$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "applyMiddleware", function () { return $c2db0aeb56498364$export$9ff26e0402cc7b7; });
// src/utils/formatProdErrorMessage.ts
function $c2db0aeb56498364$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $c2db0aeb56498364$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $c2db0aeb56498364$var$symbol_observable_default = $c2db0aeb56498364$var$$$observable;
// src/utils/actionTypes.ts
var $c2db0aeb56498364$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $c2db0aeb56498364$var$ActionTypes = {
    INIT: `@@redux/INIT${$c2db0aeb56498364$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$c2db0aeb56498364$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$c2db0aeb56498364$var$randomString()}`
};
var $c2db0aeb56498364$export$4219e499db7ca678 = $c2db0aeb56498364$var$ActionTypes;
// src/utils/isPlainObject.ts
function $c2db0aeb56498364$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $c2db0aeb56498364$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($c2db0aeb56498364$var$isDate(val)) return "date";
    if ($c2db0aeb56498364$var$isError(val)) return "error";
    const constructorName = $c2db0aeb56498364$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $c2db0aeb56498364$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $c2db0aeb56498364$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $c2db0aeb56498364$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $c2db0aeb56498364$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $c2db0aeb56498364$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($c2db0aeb56498364$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($c2db0aeb56498364$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($c2db0aeb56498364$var$formatProdErrorMessage(1));
        return enhancer($c2db0aeb56498364$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($c2db0aeb56498364$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($c2db0aeb56498364$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($c2db0aeb56498364$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($c2db0aeb56498364$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$c2db0aeb56498364$export$53b83ca8eaab0383(action)) throw new Error($c2db0aeb56498364$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($c2db0aeb56498364$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($c2db0aeb56498364$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($c2db0aeb56498364$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($c2db0aeb56498364$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $c2db0aeb56498364$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($c2db0aeb56498364$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$c2db0aeb56498364$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $c2db0aeb56498364$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$c2db0aeb56498364$var$symbol_observable_default]: observable
    };
    return store;
}
function $c2db0aeb56498364$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $c2db0aeb56498364$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $c2db0aeb56498364$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $c2db0aeb56498364$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $c2db0aeb56498364$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$c2db0aeb56498364$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$c2db0aeb56498364$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $c2db0aeb56498364$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $c2db0aeb56498364$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $c2db0aeb56498364$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($c2db0aeb56498364$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $c2db0aeb56498364$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($c2db0aeb56498364$var$formatProdErrorMessage(13));
    });
}
function $c2db0aeb56498364$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $c2db0aeb56498364$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($c2db0aeb56498364$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $c2db0aeb56498364$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $c2db0aeb56498364$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $c2db0aeb56498364$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($c2db0aeb56498364$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $c2db0aeb56498364$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $c2db0aeb56498364$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $c2db0aeb56498364$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($c2db0aeb56498364$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $c2db0aeb56498364$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $c2db0aeb56498364$export$b956e38827fca970(action) {
    return $c2db0aeb56498364$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}

});

parcelRegister("5Vhc6", function(module, exports) {

$parcel$export(module.exports, "connect", function () { return $44ff9d03a30a5360$export$64605811ab45167f; });
$parcel$export(module.exports, "Provider", function () { return $44ff9d03a30a5360$export$2881499e37b75b9a; });

var $jbmdS = parcelRequire("jbmdS");

var $1hzEy = parcelRequire("1hzEy");
var $44ff9d03a30a5360$var$__defProp = Object.defineProperty;
var $44ff9d03a30a5360$var$__defProps = Object.defineProperties;
var $44ff9d03a30a5360$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $44ff9d03a30a5360$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $44ff9d03a30a5360$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $44ff9d03a30a5360$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $44ff9d03a30a5360$var$__defNormalProp = (obj, key, value)=>key in obj ? $44ff9d03a30a5360$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $44ff9d03a30a5360$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($44ff9d03a30a5360$var$__hasOwnProp.call(b, prop)) $44ff9d03a30a5360$var$__defNormalProp(a, prop, b[prop]);
    if ($44ff9d03a30a5360$var$__getOwnPropSymbols) {
        for (var prop of $44ff9d03a30a5360$var$__getOwnPropSymbols(b))if ($44ff9d03a30a5360$var$__propIsEnum.call(b, prop)) $44ff9d03a30a5360$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $44ff9d03a30a5360$var$__spreadProps = (a, b)=>$44ff9d03a30a5360$var$__defProps(a, $44ff9d03a30a5360$var$__getOwnPropDescs(b));
var $44ff9d03a30a5360$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($44ff9d03a30a5360$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $44ff9d03a30a5360$var$__getOwnPropSymbols) {
        for (var prop of $44ff9d03a30a5360$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $44ff9d03a30a5360$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $44ff9d03a30a5360$var$React = // prettier-ignore
// @ts-ignore
"default" in $jbmdS ? $jbmdS["default"] : $jbmdS;
// src/components/Context.ts
var $44ff9d03a30a5360$var$ContextKey = Symbol.for(`react-redux-context`);
var $44ff9d03a30a5360$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $44ff9d03a30a5360$var$getContext() {
    var _a;
    if (!$44ff9d03a30a5360$var$React.createContext) return {};
    const contextMap = (_a = $44ff9d03a30a5360$var$gT[$44ff9d03a30a5360$var$ContextKey]) != null ? _a : $44ff9d03a30a5360$var$gT[$44ff9d03a30a5360$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($44ff9d03a30a5360$var$React.createContext);
    if (!realContext) {
        realContext = $44ff9d03a30a5360$var$React.createContext(null);
        contextMap.set($44ff9d03a30a5360$var$React.createContext, realContext);
    }
    return realContext;
}
var $44ff9d03a30a5360$export$cc80c08dc91f1c00 = /* @__PURE__ */ $44ff9d03a30a5360$var$getContext();
// src/utils/useSyncExternalStore.ts
var $44ff9d03a30a5360$var$notInitialized = ()=>{
    throw new Error("uSES not initialized!");
};
// src/hooks/useReduxContext.ts
function $44ff9d03a30a5360$var$createReduxContextHook(context = $44ff9d03a30a5360$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $44ff9d03a30a5360$var$React.useContext(context);
        return contextValue;
    };
}
var $44ff9d03a30a5360$var$useReduxContext = /* @__PURE__ */ $44ff9d03a30a5360$var$createReduxContextHook();
// src/hooks/useSelector.ts
var $44ff9d03a30a5360$var$useSyncExternalStoreWithSelector = $44ff9d03a30a5360$var$notInitialized;
var $44ff9d03a30a5360$var$initializeUseSelector = (fn)=>{
    $44ff9d03a30a5360$var$useSyncExternalStoreWithSelector = fn;
};
var $44ff9d03a30a5360$var$refEquality = (a, b)=>a === b;
function $44ff9d03a30a5360$export$2b53f90d2bd1cbfb(context = $44ff9d03a30a5360$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $44ff9d03a30a5360$export$cc80c08dc91f1c00 ? $44ff9d03a30a5360$var$useReduxContext : $44ff9d03a30a5360$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $44ff9d03a30a5360$var$refEquality, devModeChecks: devModeChecks = {} } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: stabilityCheck, identityFunctionCheck: identityFunctionCheck } = useReduxContext2();
        const firstRun = $44ff9d03a30a5360$var$React.useRef(true);
        const wrappedSelector = $44ff9d03a30a5360$var$React.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            stabilityCheck,
            devModeChecks.stabilityCheck
        ]);
        const selectedState = $44ff9d03a30a5360$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $44ff9d03a30a5360$var$React.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $44ff9d03a30a5360$export$2105062e25df4afe = /* @__PURE__ */ $44ff9d03a30a5360$export$2b53f90d2bd1cbfb();
// src/utils/react-is.ts
var $44ff9d03a30a5360$var$REACT_ELEMENT_TYPE = Symbol.for("react.element");
var $44ff9d03a30a5360$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
var $44ff9d03a30a5360$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
var $44ff9d03a30a5360$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
var $44ff9d03a30a5360$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
var $44ff9d03a30a5360$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider");
var $44ff9d03a30a5360$var$REACT_CONTEXT_TYPE = Symbol.for("react.context");
var $44ff9d03a30a5360$var$REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
var $44ff9d03a30a5360$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
var $44ff9d03a30a5360$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
var $44ff9d03a30a5360$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
var $44ff9d03a30a5360$var$REACT_MEMO_TYPE = Symbol.for("react.memo");
var $44ff9d03a30a5360$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
var $44ff9d03a30a5360$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
var $44ff9d03a30a5360$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
var $44ff9d03a30a5360$var$ForwardRef = $44ff9d03a30a5360$var$REACT_FORWARD_REF_TYPE;
var $44ff9d03a30a5360$var$Memo = $44ff9d03a30a5360$var$REACT_MEMO_TYPE;
function $44ff9d03a30a5360$var$isValidElementType(type) {
    if (typeof type === "string" || typeof type === "function") return true;
    if (type === $44ff9d03a30a5360$var$REACT_FRAGMENT_TYPE || type === $44ff9d03a30a5360$var$REACT_PROFILER_TYPE || type === $44ff9d03a30a5360$var$REACT_STRICT_MODE_TYPE || type === $44ff9d03a30a5360$var$REACT_SUSPENSE_TYPE || type === $44ff9d03a30a5360$var$REACT_SUSPENSE_LIST_TYPE || type === $44ff9d03a30a5360$var$REACT_OFFSCREEN_TYPE) return true;
    if (typeof type === "object" && type !== null) {
        if (type.$$typeof === $44ff9d03a30a5360$var$REACT_LAZY_TYPE || type.$$typeof === $44ff9d03a30a5360$var$REACT_MEMO_TYPE || type.$$typeof === $44ff9d03a30a5360$var$REACT_PROVIDER_TYPE || type.$$typeof === $44ff9d03a30a5360$var$REACT_CONTEXT_TYPE || type.$$typeof === $44ff9d03a30a5360$var$REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        type.$$typeof === $44ff9d03a30a5360$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) return true;
    }
    return false;
}
function $44ff9d03a30a5360$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const $$typeof = object.$$typeof;
        switch($$typeof){
            case $44ff9d03a30a5360$var$REACT_ELEMENT_TYPE:
                {
                    const type = object.type;
                    switch(type){
                        case $44ff9d03a30a5360$var$REACT_FRAGMENT_TYPE:
                        case $44ff9d03a30a5360$var$REACT_PROFILER_TYPE:
                        case $44ff9d03a30a5360$var$REACT_STRICT_MODE_TYPE:
                        case $44ff9d03a30a5360$var$REACT_SUSPENSE_TYPE:
                        case $44ff9d03a30a5360$var$REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            {
                                const $$typeofType = type && type.$$typeof;
                                switch($$typeofType){
                                    case $44ff9d03a30a5360$var$REACT_SERVER_CONTEXT_TYPE:
                                    case $44ff9d03a30a5360$var$REACT_CONTEXT_TYPE:
                                    case $44ff9d03a30a5360$var$REACT_FORWARD_REF_TYPE:
                                    case $44ff9d03a30a5360$var$REACT_LAZY_TYPE:
                                    case $44ff9d03a30a5360$var$REACT_MEMO_TYPE:
                                    case $44ff9d03a30a5360$var$REACT_PROVIDER_TYPE:
                                        return $$typeofType;
                                    default:
                                        return $$typeof;
                                }
                            }
                    }
                }
            case $44ff9d03a30a5360$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
    return void 0;
}
function $44ff9d03a30a5360$var$isContextConsumer(object) {
    return $44ff9d03a30a5360$var$typeOf(object) === $44ff9d03a30a5360$var$REACT_CONTEXT_TYPE;
}
function $44ff9d03a30a5360$var$isMemo(object) {
    return $44ff9d03a30a5360$var$typeOf(object) === $44ff9d03a30a5360$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $44ff9d03a30a5360$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $44ff9d03a30a5360$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $44ff9d03a30a5360$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $44ff9d03a30a5360$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $44ff9d03a30a5360$var$verify(mapStateToProps, "mapStateToProps");
    $44ff9d03a30a5360$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $44ff9d03a30a5360$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $44ff9d03a30a5360$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $44ff9d03a30a5360$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $44ff9d03a30a5360$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $44ff9d03a30a5360$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $44ff9d03a30a5360$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $44ff9d03a30a5360$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $44ff9d03a30a5360$var$verifyPlainObject(value, displayName, methodName) {
    if (!$44ff9d03a30a5360$var$isPlainObject(value)) $44ff9d03a30a5360$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $44ff9d03a30a5360$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $44ff9d03a30a5360$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $44ff9d03a30a5360$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $44ff9d03a30a5360$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $44ff9d03a30a5360$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $44ff9d03a30a5360$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $44ff9d03a30a5360$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $44ff9d03a30a5360$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $44ff9d03a30a5360$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $44ff9d03a30a5360$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $44ff9d03a30a5360$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $44ff9d03a30a5360$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $44ff9d03a30a5360$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $44ff9d03a30a5360$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $44ff9d03a30a5360$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $44ff9d03a30a5360$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $44ff9d03a30a5360$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $44ff9d03a30a5360$var$__spreadValues($44ff9d03a30a5360$var$__spreadValues($44ff9d03a30a5360$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $44ff9d03a30a5360$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $44ff9d03a30a5360$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$44ff9d03a30a5360$var$defaultMergeProps : typeof mergeProps === "function" ? $44ff9d03a30a5360$var$wrapMergePropsFunc(mergeProps) : $44ff9d03a30a5360$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $44ff9d03a30a5360$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $44ff9d03a30a5360$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $44ff9d03a30a5360$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $44ff9d03a30a5360$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $44ff9d03a30a5360$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $44ff9d03a30a5360$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $44ff9d03a30a5360$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $44ff9d03a30a5360$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $44ff9d03a30a5360$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $44ff9d03a30a5360$var$isReactNative = typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $44ff9d03a30a5360$var$useIsomorphicLayoutEffect = $44ff9d03a30a5360$var$canUseDOM || $44ff9d03a30a5360$var$isReactNative ? $44ff9d03a30a5360$var$React.useLayoutEffect : $44ff9d03a30a5360$var$React.useEffect;
// src/utils/shallowEqual.ts
function $44ff9d03a30a5360$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $44ff9d03a30a5360$export$d36bdfa510afb180(objA, objB) {
    if ($44ff9d03a30a5360$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$44ff9d03a30a5360$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $44ff9d03a30a5360$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $44ff9d03a30a5360$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $44ff9d03a30a5360$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $44ff9d03a30a5360$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $44ff9d03a30a5360$var$TYPE_STATICS = {
    [$44ff9d03a30a5360$var$ForwardRef]: $44ff9d03a30a5360$var$FORWARD_REF_STATICS,
    [$44ff9d03a30a5360$var$Memo]: $44ff9d03a30a5360$var$MEMO_STATICS
};
function $44ff9d03a30a5360$var$getStatics(component) {
    if ($44ff9d03a30a5360$var$isMemo(component)) return $44ff9d03a30a5360$var$MEMO_STATICS;
    return $44ff9d03a30a5360$var$TYPE_STATICS[component["$$typeof"]] || $44ff9d03a30a5360$var$REACT_STATICS;
}
var $44ff9d03a30a5360$var$defineProperty = Object.defineProperty;
var $44ff9d03a30a5360$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $44ff9d03a30a5360$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $44ff9d03a30a5360$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $44ff9d03a30a5360$var$getPrototypeOf = Object.getPrototypeOf;
var $44ff9d03a30a5360$var$objectPrototype = Object.prototype;
function $44ff9d03a30a5360$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($44ff9d03a30a5360$var$objectPrototype) {
            const inheritedComponent = $44ff9d03a30a5360$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $44ff9d03a30a5360$var$objectPrototype) $44ff9d03a30a5360$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $44ff9d03a30a5360$var$getOwnPropertyNames(sourceComponent);
        if ($44ff9d03a30a5360$var$getOwnPropertySymbols) keys = keys.concat($44ff9d03a30a5360$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $44ff9d03a30a5360$var$getStatics(targetComponent);
        const sourceStatics = $44ff9d03a30a5360$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$44ff9d03a30a5360$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $44ff9d03a30a5360$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $44ff9d03a30a5360$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/connect.tsx
var $44ff9d03a30a5360$var$useSyncExternalStore = $44ff9d03a30a5360$var$notInitialized;
var $44ff9d03a30a5360$var$initializeConnect = (fn)=>{
    $44ff9d03a30a5360$var$useSyncExternalStore = fn;
};
var $44ff9d03a30a5360$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $44ff9d03a30a5360$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $44ff9d03a30a5360$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $44ff9d03a30a5360$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $44ff9d03a30a5360$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $44ff9d03a30a5360$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $44ff9d03a30a5360$var$strictEqual(a, b) {
    return a === b;
}
var $44ff9d03a30a5360$var$hasWarnedAboutDeprecatedPureOption = false;
function $44ff9d03a30a5360$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $44ff9d03a30a5360$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $44ff9d03a30a5360$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $44ff9d03a30a5360$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $44ff9d03a30a5360$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $44ff9d03a30a5360$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $44ff9d03a30a5360$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $44ff9d03a30a5360$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $44ff9d03a30a5360$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $44ff9d03a30a5360$var$React.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $44ff9d03a30a5360$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $44ff9d03a30a5360$var$React.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $44ff9d03a30a5360$var$React.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $44ff9d03a30a5360$var$React.useMemo(()=>{
                return $44ff9d03a30a5360$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $44ff9d03a30a5360$var$React.useMemo(()=>{
                if (!shouldHandleStateChanges) return $44ff9d03a30a5360$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $44ff9d03a30a5360$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $44ff9d03a30a5360$var$React.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $44ff9d03a30a5360$var$__spreadProps($44ff9d03a30a5360$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $44ff9d03a30a5360$var$React.useRef(void 0);
            const lastWrapperProps = $44ff9d03a30a5360$var$React.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $44ff9d03a30a5360$var$React.useRef(void 0);
            const renderIsScheduled = $44ff9d03a30a5360$var$React.useRef(false);
            const isMounted = $44ff9d03a30a5360$var$React.useRef(false);
            const latestSubscriptionCallbackError = $44ff9d03a30a5360$var$React.useRef(void 0);
            $44ff9d03a30a5360$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $44ff9d03a30a5360$var$React.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $44ff9d03a30a5360$var$React.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $44ff9d03a30a5360$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $44ff9d03a30a5360$var$useIsomorphicLayoutEffectWithArgs($44ff9d03a30a5360$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $44ff9d03a30a5360$var$useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $44ff9d03a30a5360$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $44ff9d03a30a5360$var$React.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $44ff9d03a30a5360$var$React.createElement(WrappedComponent, $44ff9d03a30a5360$var$__spreadProps($44ff9d03a30a5360$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $44ff9d03a30a5360$var$React.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $44ff9d03a30a5360$var$React.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $44ff9d03a30a5360$var$React.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $44ff9d03a30a5360$var$React.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $44ff9d03a30a5360$var$React.createElement(Connect, $44ff9d03a30a5360$var$__spreadProps($44ff9d03a30a5360$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $44ff9d03a30a5360$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $44ff9d03a30a5360$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $44ff9d03a30a5360$export$64605811ab45167f = $44ff9d03a30a5360$var$connect;
// src/components/Provider.tsx
function $44ff9d03a30a5360$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = "once", identityFunctionCheck: identityFunctionCheck = "once" }) {
    const contextValue = $44ff9d03a30a5360$var$React.useMemo(()=>{
        const subscription = $44ff9d03a30a5360$var$createSubscription(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0,
            stabilityCheck: stabilityCheck,
            identityFunctionCheck: identityFunctionCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        identityFunctionCheck
    ]);
    const previousState = $44ff9d03a30a5360$var$React.useMemo(()=>store.getState(), [
        store
    ]);
    $44ff9d03a30a5360$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $44ff9d03a30a5360$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $44ff9d03a30a5360$var$React.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $44ff9d03a30a5360$export$2881499e37b75b9a = $44ff9d03a30a5360$var$Provider;
// src/hooks/useStore.ts
function $44ff9d03a30a5360$export$671dba69185d0304(context = $44ff9d03a30a5360$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $44ff9d03a30a5360$export$cc80c08dc91f1c00 ? $44ff9d03a30a5360$var$useReduxContext : // @ts-ignore
    $44ff9d03a30a5360$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $44ff9d03a30a5360$export$6ccbb43953eebf8 = /* @__PURE__ */ $44ff9d03a30a5360$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $44ff9d03a30a5360$export$bc9b55530897c558(context = $44ff9d03a30a5360$export$cc80c08dc91f1c00) {
    const useStore2 = context === $44ff9d03a30a5360$export$cc80c08dc91f1c00 ? $44ff9d03a30a5360$export$6ccbb43953eebf8 : $44ff9d03a30a5360$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $44ff9d03a30a5360$export$8ad76b76a4c905f8 = /* @__PURE__ */ $44ff9d03a30a5360$export$bc9b55530897c558();
// src/exports.ts
var $44ff9d03a30a5360$export$712ea50be43a7858 = $44ff9d03a30a5360$var$defaultNoopBatch;
// src/index.ts
$44ff9d03a30a5360$var$initializeUseSelector((0, $1hzEy.useSyncExternalStoreWithSelector));
$44ff9d03a30a5360$var$initializeConnect($jbmdS.useSyncExternalStore);

});
parcelRegister("1hzEy", function(module, exports) {
"use strict";

module.exports = (parcelRequire("l9Zzq"));

});
parcelRegister("l9Zzq", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $f67a32cffe48d480$export$bf730a2d8bf68b42; }, function (v) { return $f67a32cffe48d480$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f67a32cffe48d480$export$bf730a2d8bf68b42;
"use strict";

var $jbmdS = parcelRequire("jbmdS");
function $f67a32cffe48d480$var$n(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $f67a32cffe48d480$var$p = "function" === typeof Object.is ? Object.is : $f67a32cffe48d480$var$n, $f67a32cffe48d480$var$q = $jbmdS.useSyncExternalStore, $f67a32cffe48d480$var$r = $jbmdS.useRef, $f67a32cffe48d480$var$t = $jbmdS.useEffect, $f67a32cffe48d480$var$u = $jbmdS.useMemo, $f67a32cffe48d480$var$v = $jbmdS.useDebugValue;
$f67a32cffe48d480$export$bf730a2d8bf68b42 = function(a, b, e, l, h) {
    var c = $f67a32cffe48d480$var$r(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $f67a32cffe48d480$var$u(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== h && f.hasValue) {
                    var b = f.value;
                    if (h(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($f67a32cffe48d480$var$p(d, a)) return b;
            var e = l(a);
            if (void 0 !== h && h(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        h
    ]);
    var d = $f67a32cffe48d480$var$q(a, c[0], c[1]);
    $f67a32cffe48d480$var$t(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $f67a32cffe48d480$var$v(d);
    return d;
};

});



parcelRegister("g21f0", function(module, exports) {

$parcel$export(module.exports, "useMemo", function () { return $babdcbaf67f5da02$export$1538c33de8887b59; });
$parcel$export(module.exports, "useCallback", function () { return $babdcbaf67f5da02$export$35808ee640e87ca7; });

var $jbmdS = parcelRequire("jbmdS");
function $babdcbaf67f5da02$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $babdcbaf67f5da02$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $jbmdS.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $jbmdS.useRef)(true);
    var committed = (0, $jbmdS.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $babdcbaf67f5da02$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $jbmdS.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $babdcbaf67f5da02$export$33752cf3ee811995(callback, inputs) {
    return $babdcbaf67f5da02$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $babdcbaf67f5da02$export$1538c33de8887b59 = $babdcbaf67f5da02$export$b6feb8998cd9b342;
var $babdcbaf67f5da02$export$35808ee640e87ca7 = $babdcbaf67f5da02$export$33752cf3ee811995;

});

parcelRegister("8rsfJ", function(module, exports) {

$parcel$export(module.exports, "getRect", function () { return $6256c2c6daca64cd$export$4b834cebd9e5cebe; });
$parcel$export(module.exports, "expand", function () { return $6256c2c6daca64cd$export$9f77e0932fb78f72; });
$parcel$export(module.exports, "createBox", function () { return $6256c2c6daca64cd$export$6459fc9e86be362e; });
$parcel$export(module.exports, "offset", function () { return $6256c2c6daca64cd$export$cc800923e997bb8; });
$parcel$export(module.exports, "withScroll", function () { return $6256c2c6daca64cd$export$1d0caec378d7d0ae; });
$parcel$export(module.exports, "calculateBox", function () { return $6256c2c6daca64cd$export$b8dfc5d4e552b8e1; });
$parcel$export(module.exports, "getBox", function () { return $6256c2c6daca64cd$export$34928e660d2a8702; });

var $9GFyS = parcelRequire("9GFyS");
var $6256c2c6daca64cd$export$4b834cebd9e5cebe = function getRect(_ref) {
    var top = _ref.top, right = _ref.right, bottom = _ref.bottom, left = _ref.left;
    var width = right - left;
    var height = bottom - top;
    var rect = {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        width: width,
        height: height,
        x: left,
        y: top,
        center: {
            x: (right + left) / 2,
            y: (bottom + top) / 2
        }
    };
    return rect;
};
var $6256c2c6daca64cd$export$9f77e0932fb78f72 = function expand(target, expandBy) {
    return {
        top: target.top - expandBy.top,
        left: target.left - expandBy.left,
        bottom: target.bottom + expandBy.bottom,
        right: target.right + expandBy.right
    };
};
var $6256c2c6daca64cd$export$8b1f3092f5e28575 = function shrink(target, shrinkBy) {
    return {
        top: target.top + shrinkBy.top,
        left: target.left + shrinkBy.left,
        bottom: target.bottom - shrinkBy.bottom,
        right: target.right - shrinkBy.right
    };
};
var $6256c2c6daca64cd$var$shift = function shift(target, shiftBy) {
    return {
        top: target.top + shiftBy.y,
        left: target.left + shiftBy.x,
        bottom: target.bottom + shiftBy.y,
        right: target.right + shiftBy.x
    };
};
var $6256c2c6daca64cd$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $6256c2c6daca64cd$export$6459fc9e86be362e = function createBox(_ref2) {
    var borderBox = _ref2.borderBox, _ref2$margin = _ref2.margin, margin = _ref2$margin === void 0 ? $6256c2c6daca64cd$var$noSpacing : _ref2$margin, _ref2$border = _ref2.border, border = _ref2$border === void 0 ? $6256c2c6daca64cd$var$noSpacing : _ref2$border, _ref2$padding = _ref2.padding, padding = _ref2$padding === void 0 ? $6256c2c6daca64cd$var$noSpacing : _ref2$padding;
    var marginBox = $6256c2c6daca64cd$export$4b834cebd9e5cebe($6256c2c6daca64cd$export$9f77e0932fb78f72(borderBox, margin));
    var paddingBox = $6256c2c6daca64cd$export$4b834cebd9e5cebe($6256c2c6daca64cd$export$8b1f3092f5e28575(borderBox, border));
    var contentBox = $6256c2c6daca64cd$export$4b834cebd9e5cebe($6256c2c6daca64cd$export$8b1f3092f5e28575(paddingBox, padding));
    return {
        marginBox: marginBox,
        borderBox: $6256c2c6daca64cd$export$4b834cebd9e5cebe(borderBox),
        paddingBox: paddingBox,
        contentBox: contentBox,
        margin: margin,
        border: border,
        padding: padding
    };
};
var $6256c2c6daca64cd$var$parse = function parse(raw) {
    var value = raw.slice(0, -2);
    var suffix = raw.slice(-2);
    if (suffix !== "px") return 0;
    var result = Number(value);
    !!isNaN(result) && (0, $9GFyS.default)(false);
    return result;
};
var $6256c2c6daca64cd$var$getWindowScroll = function getWindowScroll() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
var $6256c2c6daca64cd$export$cc800923e997bb8 = function offset(original, change) {
    var borderBox = original.borderBox, border = original.border, margin = original.margin, padding = original.padding;
    var shifted = $6256c2c6daca64cd$var$shift(borderBox, change);
    return $6256c2c6daca64cd$export$6459fc9e86be362e({
        borderBox: shifted,
        border: border,
        margin: margin,
        padding: padding
    });
};
var $6256c2c6daca64cd$export$1d0caec378d7d0ae = function withScroll(original, scroll) {
    if (scroll === void 0) scroll = $6256c2c6daca64cd$var$getWindowScroll();
    return $6256c2c6daca64cd$export$cc800923e997bb8(original, scroll);
};
var $6256c2c6daca64cd$export$b8dfc5d4e552b8e1 = function calculateBox(borderBox, styles) {
    var margin = {
        top: $6256c2c6daca64cd$var$parse(styles.marginTop),
        right: $6256c2c6daca64cd$var$parse(styles.marginRight),
        bottom: $6256c2c6daca64cd$var$parse(styles.marginBottom),
        left: $6256c2c6daca64cd$var$parse(styles.marginLeft)
    };
    var padding = {
        top: $6256c2c6daca64cd$var$parse(styles.paddingTop),
        right: $6256c2c6daca64cd$var$parse(styles.paddingRight),
        bottom: $6256c2c6daca64cd$var$parse(styles.paddingBottom),
        left: $6256c2c6daca64cd$var$parse(styles.paddingLeft)
    };
    var border = {
        top: $6256c2c6daca64cd$var$parse(styles.borderTopWidth),
        right: $6256c2c6daca64cd$var$parse(styles.borderRightWidth),
        bottom: $6256c2c6daca64cd$var$parse(styles.borderBottomWidth),
        left: $6256c2c6daca64cd$var$parse(styles.borderLeftWidth)
    };
    return $6256c2c6daca64cd$export$6459fc9e86be362e({
        borderBox: borderBox,
        margin: margin,
        padding: padding,
        border: border
    });
};
var $6256c2c6daca64cd$export$34928e660d2a8702 = function getBox(el) {
    var borderBox = el.getBoundingClientRect();
    var styles = window.getComputedStyle(el);
    return $6256c2c6daca64cd$export$b8dfc5d4e552b8e1(borderBox, styles);
};

});

parcelRegister("RIdqi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a173fa1490d0ba1$export$2e2bcd8739ae039; });
var $0a173fa1490d0ba1$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $0a173fa1490d0ba1$export$2e2bcd8739ae039 = $0a173fa1490d0ba1$var$rafSchd;

});



parcelRegister("6ywef", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c5eeb045c6000c1$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");


var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $9mNEQ = parcelRequire("9mNEQ");

var $ldrel = parcelRequire("ldrel");

var $43oHB = parcelRequire("43oHB");

var $1BTI2 = parcelRequire("1BTI2");

var $khJQv = parcelRequire("khJQv");

var $aZcHl = parcelRequire("aZcHl");

var $iKbxs = parcelRequire("iKbxs");

var $3H03w = parcelRequire("3H03w");
const $4c5eeb045c6000c1$var$accountingActions = {
    connect: {
        getLabel: (accountingSystem)=>`Connect To ${accountingSystem}`,
        icon: "fa-plug",
        action: ()=>(0, $43oHB.beginAccountingOauth),
        pendingLabel: "Connecting..."
    },
    syncInvoice: {
        getLabel: (accountingSystem)=>`Sync To ${accountingSystem}`,
        icon: "fa-exchange",
        action: ({ invoice: invoice })=>(0, $43oHB.syncInvoiceToAccounting)(invoice),
        pendingLabel: "Syncing Invoice..."
    },
    fetchSettings: {
        getLabel: (accountingSystem)=>`Get ${accountingSystem} Settings`,
        icon: "fa-cog",
        action: ()=>(0, $43oHB.fetchAccountingSettings)(),
        pendingLabel: "Fetching Options..."
    },
    fetchContacts: {
        getLabel: (accountingSystem)=>`Get ${accountingSystem} Contacts`,
        icon: "fa-users",
        action: ()=>(0, $43oHB.fetchAccountingContacts)(),
        pendingLabel: "Fetching Contacts..."
    }
};
const $4c5eeb045c6000c1$var$accountingSystemOptions = {
    xero: {
        id: "xero",
        label: "Xero",
        requiredData: [
            "salesAccount",
            "taxOffTaxType",
            "taxOnTaxType"
        ],
        color: "#11b5ea",
        getInvoiceUrl: (id)=>`https://go.xero.com/app/invoicing/edit/${id}`
    },
    quickbooks: {
        id: "quickbooks",
        label: "Quickbooks",
        requiredData: [
            "taxOffTaxType",
            "taxOnTaxType"
        ],
        color: "#2ba01d",
        getInvoiceUrl: (id)=>`https://app.qbo.intuit.com/app/invoice?txnId=${id}`
    },
    "myob-essentials": {
        id: "myob-essentials",
        label: "MYOB Essentials",
        requiredData: [
            "salesAccount",
            "taxOffTaxType",
            "taxOnTaxType"
        ],
        color: "#6100a5",
        getInvoiceUrl: (id)=>`https://essentials.myob.com.au/LA/app.htm#businesses/390816/invoices/${id}`
    },
    "myob-accountright": {
        id: "myob-accountright",
        label: "MYOB AccountRight",
        requiredData: [
            "salesAccount",
            "taxOffTaxType",
            "taxOnTaxType"
        ],
        color: "#6100a5",
        getInvoiceUrl: (id)=>`https://accountright.myob.com.au/LA/app.htm#businesses/390816/invoices/${id}`
    },
    none: {
        id: "none",
        requiredData: [],
        getInvoiceUrl: ()=>""
    }
};
var $4c5eeb045c6000c1$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ action: action = "connect", actionProps: actionProps = {}, style: style = {}, onActionSuccess: onActionSuccess = ()=>null, onActionError: onActionError = ()=>null, onActionStart: onActionStart = ()=>null })=>{
    const accountingSystemId = (0, $1BTI2.default).organisation.accountingSystem || "none";
    const accountingSystem = $4c5eeb045c6000c1$var$accountingSystemOptions[accountingSystemId];
    const accountingSystemConnected = (0, $1BTI2.default).accountingConnected;
    const accountingSystemSettings = (0, $1BTI2.default).organisation.accountingSystemSettings;
    const accountingAction = $4c5eeb045c6000c1$var$accountingActions[action];
    const hasRequiredData = accountingSystem.requiredData.every((key)=>{
        var _accountingSystemSett;
        return accountingSystemSettings === null || accountingSystemSettings === void 0 ? void 0 : (_accountingSystemSett = accountingSystemSettings.settings) === null || _accountingSystemSett === void 0 ? void 0 : _accountingSystemSett[key];
    });
    const needsSettings = (accountingSystemId === "none" || !hasRequiredData) && action !== "connect";
    const [actionState, setActionState] = (0, $jbmdS.useState)("idle");
    if (needsSettings) return /*#__PURE__*/ (0, $61Ea1.jsxs)("button", {
        className: "btn btn-primary btn-connect",
        onClick: ()=>{
            (0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $ldrel.default), {
                modalId: "invoice-settings"
            }));
        },
        style: {
            backgroundColor: accountingSystem.color || "#428bca",
            borderColor: "white",
            ...style
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                className: "fa fa-plug mr-2.5"
            }),
            "Connect To ",
            accountingSystem.label || "Accounting System"
        ]
    });
    if (action === "connect" && accountingSystemId === "none") return null;
    if (!accountingSystemConnected) return /*#__PURE__*/ (0, $61Ea1.jsxs)("button", {
        className: "btn btn-primary btn-connect",
        onClick: async ()=>{
            try {
                await onActionStart();
                await (0, $43oHB.beginAccountingOauth)();
            } catch (e) {
                console.error(e);
            }
        },
        style: {
            backgroundColor: accountingSystem.color || "#428bca",
            borderColor: "white",
            ...style
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                className: "fa fa-plug mr-2.5"
            }),
            "Connect To ",
            accountingSystem.label || "Accounting System"
        ]
    });
    if (action === "connect") return /*#__PURE__*/ (0, $61Ea1.jsxs)("button", {
        className: "btn btn-primary btn-connect",
        style: {
            backgroundColor: accountingSystem.color || "#428bca",
            borderColor: "red",
            ...style
        },
        disabled: true,
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                className: "fa fa-check mr-2.5"
            }),
            "Connected To ",
            accountingSystem.label || "Accounting System"
        ]
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("button", {
        className: "btn btn-primary btn-connect",
        style: {
            backgroundColor: accountingSystem.color || "#428bca",
            borderColor: "white",
            ...style
        },
        onClick: async ()=>{
            if (actionState !== "idle") return null;
            setActionState("syncing");
            try {
                await onActionStart();
                accountingAction.action(actionProps).then((data)=>{
                    setActionState("success");
                    onActionSuccess(data);
                    (0, $9mNEQ.default)(1000).then(()=>setActionState("idle"));
                }).catch((e)=>{
                    var _e$response, _e$response2, _e$response2$data, _e$response3, _e$response3$data;
                    $iKbxs.captureException(e);
                    (0, $3H03w.default).captureException(e);
                    console.warn(e === null || e === void 0 ? void 0 : (_e$response = e.response) === null || _e$response === void 0 ? void 0 : _e$response.data);
                    setActionState("error");
                    onActionError(e);
                    (0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $aZcHl.default), {
                        modalId: "accounting-error",
                        heading: (e === null || e === void 0 ? void 0 : (_e$response2 = e.response) === null || _e$response2 === void 0 ? void 0 : (_e$response2$data = _e$response2.data) === null || _e$response2$data === void 0 ? void 0 : _e$response2$data.name) || "Accounting System Error",
                        message: (e === null || e === void 0 ? void 0 : (_e$response3 = e.response) === null || _e$response3 === void 0 ? void 0 : (_e$response3$data = _e$response3.data) === null || _e$response3$data === void 0 ? void 0 : _e$response3$data.message) || e.message
                    }));
                    (0, $9mNEQ.default)(1000).then(()=>setActionState("idle"));
                });
            } catch (e) {
                setActionState("idle");
            }
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                className: `fa ${actionState === "success" ? "fa-check" : actionState === "error" ? "fa-times" : actionState === "syncing" ? "fa-spinner fa-spin" : accountingAction.icon}`
            }),
            actionState === "success" ? "Success!" : actionState === "error" ? "Error!" : actionState === "syncing" ? accountingAction.pendingLabel : accountingAction.getLabel(accountingSystem.label)
        ]
    });
});

});
parcelRegister("9mNEQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d1cb025e6ef1b92$export$2e2bcd8739ae039; });
function $6d1cb025e6ef1b92$export$2e2bcd8739ae039(e) {
    return void 0 === e && (e = 0), new Promise(function(t) {
        return setTimeout(t, e);
    });
}

});

parcelRegister("ldrel", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f71fef3e77138d06$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $1EEMt = parcelRequire("1EEMt");

var $fEcKX = parcelRequire("fEcKX");

var $ewAM3 = parcelRequire("ewAM3");

var $1BTI2 = parcelRequire("1BTI2");
parcelRequire("fEtu5");
var $amISd = parcelRequire("amISd");

var $cxnwP = parcelRequire("cxnwP");

var $kScV6 = parcelRequire("kScV6");

var $hIH1V = parcelRequire("hIH1V");

var $43oHB = parcelRequire("43oHB");

var $52dEm = parcelRequire("52dEm");

var $6ywef = parcelRequire("6ywef");

var $fM2j4 = parcelRequire("fM2j4");

var $iKbxs = parcelRequire("iKbxs");

var $3H03w = parcelRequire("3H03w");
const $f71fef3e77138d06$var$accountingSettingsDisplay = {
    none: {
        salesAccount: false,
        taxOffTaxType: false,
        taxOnTaxType: false,
        usePhaseCodesAsItemCodes: false,
        useProjectNameAsReference: false,
        taxAmount: true,
        fileLogin: false
    },
    xero: {
        salesAccount: true,
        taxOffTaxType: true,
        taxOnTaxType: true,
        usePhaseCodesAsItemCodes: true,
        useProjectNameAsReference: true,
        taxAmount: false,
        fileLogin: false
    },
    "myob-essentials": {
        salesAccount: true,
        taxOffTaxType: true,
        taxOnTaxType: true,
        usePhaseCodesAsItemCodes: false,
        useProjectNameAsReference: false,
        taxAmount: false,
        fileLogin: false
    },
    "myob-accountright": {
        salesAccount: true,
        taxOffTaxType: true,
        taxOnTaxType: true,
        usePhaseCodesAsItemCodes: false,
        useProjectNameAsReference: false,
        taxAmount: false,
        fileLogin: true
    },
    quickbooks: {
        salesAccount: false,
        taxOffTaxType: true,
        taxOnTaxType: true,
        usePhaseCodesAsItemCodes: false,
        useProjectNameAsReference: false,
        taxAmount: false,
        fileLogin: false
    }
};
const $f71fef3e77138d06$var$accountingDropdownOptions = [
    {
        label: "None",
        value: "none"
    },
    {
        label: "Xero",
        value: "xero"
    },
    {
        label: "Myob Essentials",
        value: "myob-essentials"
    },
    {
        label: "Myob AccountRight",
        value: "myob-accountright"
    },
    {
        label: "Quickbooks",
        value: "quickbooks"
    }
];
var $f71fef3e77138d06$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ modalId: modalId })=>{
    var _SessionStore$organis3, _SessionStore$organis4, _SessionStore$organis5, _SessionStore$organis6, _SessionStore$organis7, _SessionStore$organis8, _SessionStore$organis9, _SessionStore$organis10, _SessionStore$organis12, _SessionStore$organis13;
    const [fetchDataStatus, setFetchDataStatus] = (0, $jbmdS.useState)("idle");
    const fetchData = ()=>{
        var _SessionStore$organis;
        if (((_SessionStore$organis = (0, $1BTI2.default).organisation) === null || _SessionStore$organis === void 0 ? void 0 : _SessionStore$organis.accountingSystem) === "none") return;
        setFetchDataStatus("loading");
        (0, $43oHB.fetchAccountingSettings)().then((r)=>{
            setFetchDataStatus("success");
        }).catch((e)=>{
            $iKbxs.captureException(e);
            (0, $3H03w.default).captureException(e);
            setFetchDataStatus("error");
        });
    };
    (0, $jbmdS.useEffect)(fetchData, []);
    const accountingSystem = $f71fef3e77138d06$var$accountingDropdownOptions.find((o)=>{
        var _SessionStore$organis2;
        return (o === null || o === void 0 ? void 0 : o.value) === ((_SessionStore$organis2 = (0, $1BTI2.default).organisation) === null || _SessionStore$organis2 === void 0 ? void 0 : _SessionStore$organis2.accountingSystem);
    }) || $f71fef3e77138d06$var$accountingDropdownOptions[0];
    const accountingSystemConnected = (0, $1BTI2.default).accountingConnected;
    const accountSystemSettings = (0, $1BTI2.default).organisation.accountingSystemSettings;
    const latestInv = (0, $cxnwP.default).invoices[(0, $cxnwP.default).invoices.length - 1];
    const invCodeFormula = new (0, $kScV6.default)({
        ref: "inv" + ((latestInv === null || latestInv === void 0 ? void 0 : latestInv.id) || "0"),
        prop: "invoiceNumber",
        formula: ((_SessionStore$organis3 = (0, $1BTI2.default).organisation.settings) === null || _SessionStore$organis3 === void 0 ? void 0 : (_SessionStore$organis4 = _SessionStore$organis3.invoice) === null || _SessionStore$organis4 === void 0 ? void 0 : _SessionStore$organis4.invoiceCode) || `format(invNum, "0000")`
    });
    console.log("\uD83D\uDE80 ~ observer ~ invCodeFormula:", invCodeFormula);
    const accountingDisplay = $f71fef3e77138d06$var$accountingSettingsDisplay[(0, $1BTI2.default).organisation.accountingSystem];
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fEcKX.default), {
        modalId: modalId,
        heading: "Invoice Settings",
        saveLabel: "Save Settings",
        onSave: ()=>{
            (0, $fM2j4.default).startSave();
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "p-3 border-b border-[#ccc]",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                className: "text-[#444] text-sm font-bold w-[30%]",
                                children: [
                                    "Invoice Code: ",
                                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hIH1V.InvoiceFormulaInfo), {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                className: "w-[70%] flex items-center gap-1",
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
                                        value: ((_SessionStore$organis5 = (0, $1BTI2.default).organisation.settings) === null || _SessionStore$organis5 === void 0 ? void 0 : (_SessionStore$organis6 = _SessionStore$organis5.invoice) === null || _SessionStore$organis6 === void 0 ? void 0 : _SessionStore$organis6.invoiceCode) || `format(invNum, "0000")`,
                                        style: {
                                            width: "18em",
                                            textAlign: "left",
                                            margin: "1em 0",
                                            border: "solid 1px #ccc",
                                            padding: "0.1em 0.5em"
                                        },
                                        onChange: (e)=>(0, $1BTI2.default).organisation.updateInvoiceSettings({
                                                invoiceCode: e.target.value
                                            })
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                        className: "text-444 text-sm",
                                        children: invCodeFormula !== null && invCodeFormula !== void 0 && invCodeFormula.validAst ? " eg." + (invCodeFormula === null || invCodeFormula === void 0 ? void 0 : invCodeFormula.value) : "invalid code"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "text-[#444] text-sm font-bold w-[30%]",
                                children: "Invoices due:"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                className: "w-[70%] flex items-center gap-1",
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $amISd.NumberInputContainer), {
                                        value: (_SessionStore$organis7 = (0, $1BTI2.default).organisation.settings) === null || _SessionStore$organis7 === void 0 ? void 0 : (_SessionStore$organis8 = _SessionStore$organis7.invoice) === null || _SessionStore$organis8 === void 0 ? void 0 : _SessionStore$organis8.numDaysBetweenIssueDateAndDueDate,
                                        formatFunc: (n)=>n.toString(),
                                        style: {
                                            width: "3em",
                                            textAlign: "center",
                                            margin: "1em 0"
                                        },
                                        onChange: (e)=>(0, $1BTI2.default).organisation.handleNumDaysBetweenIssueDateAndDueDateChange({
                                                invoiceCode: e.target.value
                                            })
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                        className: "text-444 text-sm",
                                        children: " days after issue"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("h3", {
                style: {
                    margin: "1em 0.5em 0.5em"
                },
                children: "Accounting System Settings"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "p-4 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                        style: {
                            flex: "0 0 auto"
                        },
                        className: "pr-1",
                        children: [
                            "Accounting System:",
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "max-w-max",
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                            selectedOption: $f71fef3e77138d06$var$accountingDropdownOptions.find((o)=>(o === null || o === void 0 ? void 0 : o.value) === (0, $1BTI2.default).organisation.accountingSystem) || $f71fef3e77138d06$var$accountingDropdownOptions[0],
                            onChange: (o)=>{
                                (0, $1BTI2.default).organisation.update({
                                    accountingSystem: o
                                });
                            },
                            options: $f71fef3e77138d06$var$accountingDropdownOptions,
                            optionLabel: (o)=>o.label,
                            style: {
                                flex: "1 1 auto"
                            },
                            variant: "secondary"
                        })
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6ywef.default), {
                        action: "connect",
                        style: {
                            margin: "0 1em",
                            flex: "1 1 auto"
                        }
                    })
                ]
            }),
            accountingDisplay !== null && accountingDisplay !== void 0 && accountingDisplay.fileLogin ? /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    className: "flex flex-align-items-center",
                    style: {
                        padding: "0.5em 3em",
                        justifyContent: "flex-end"
                    },
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            style: {
                                fontWeight: "bold"
                            },
                            children: "Company File Login:"
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                className: "flex flex-align-items-center",
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
                                        value: ((_SessionStore$organis9 = (0, $1BTI2.default).organisation.accountingSystemSettings) === null || _SessionStore$organis9 === void 0 ? void 0 : (_SessionStore$organis10 = _SessionStore$organis9.settings) === null || _SessionStore$organis10 === void 0 ? void 0 : _SessionStore$organis10.localUsername) || "",
                                        style: {
                                            textAlign: "left",
                                            marginLeft: "1em"
                                        },
                                        onChange: (e)=>{
                                            var _SessionStore$organis11;
                                            return (0, $1BTI2.default).organisation.updateAccountingSystemSettings({
                                                settings: {
                                                    ...(_SessionStore$organis11 = (0, $1BTI2.default).organisation.accountingSystemSettings) === null || _SessionStore$organis11 === void 0 ? void 0 : _SessionStore$organis11.settings,
                                                    localUsername: e.target.value
                                                }
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
                                        type: "password",
                                        value: ((_SessionStore$organis12 = (0, $1BTI2.default).organisation.accountingSystemSettings) === null || _SessionStore$organis12 === void 0 ? void 0 : (_SessionStore$organis13 = _SessionStore$organis12.settings) === null || _SessionStore$organis13 === void 0 ? void 0 : _SessionStore$organis13.localPassword) || "",
                                        style: {
                                            textAlign: "left",
                                            marginLeft: "1em"
                                        },
                                        onChange: (e)=>{
                                            var _SessionStore$organis14;
                                            return (0, $1BTI2.default).organisation.updateAccountingSystemSettings({
                                                settings: {
                                                    ...(_SessionStore$organis14 = (0, $1BTI2.default).organisation.accountingSystemSettings) === null || _SessionStore$organis14 === void 0 ? void 0 : _SessionStore$organis14.settings,
                                                    localPassword: e.target.value
                                                }
                                            });
                                        }
                                    })
                                ]
                            })
                        })
                    ]
                })
            }) : null,
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    padding: "1em"
                },
                children: accountSystemSettings !== null && accountSystemSettings !== void 0 && accountSystemSettings.data ? /*#__PURE__*/ (0, $61Ea1.jsx)($f71fef3e77138d06$var$AccountingSystemSettings, {}) : fetchDataStatus === "error" ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    style: {
                        color: "red"
                    },
                    children: [
                        "Error loading settings",
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("button", {
                            style: {
                                marginLeft: "1em",
                                color: "black"
                            },
                            onClick: ()=>fetchData(),
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                    className: "fa fa-refresh"
                                }),
                                "Retry"
                            ]
                        })
                    ]
                }) : "Please connect to your accounting system to complete setup."
            })
        ]
    });
});
const $f71fef3e77138d06$var$AccountingSystemSettings = (0, $1EEMt.observer)(()=>{
    var _SessionStore$organis15, _SessionStore$organis16, _SessionStore$organis18, _SessionStore$organis19, _SessionStore$organis20, _SessionStore$organis21, _SessionStore$organis23, _SessionStore$organis24, _SessionStore$organis25, _SessionStore$organis26, _SessionStore$organis28, _SessionStore$organis29, _SessionStore$organis30, _SessionStore$organis31, _SessionStore$organis33, _SessionStore$organis34;
    const accountingDisplay = $f71fef3e77138d06$var$accountingSettingsDisplay[(0, $1BTI2.default).organisation.accountingSystem];
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            accountingDisplay.salesAccount && /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "flex flex-align-items-center",
                style: {
                    margin: "1em 0"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "w-[30%]",
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)("strong", {
                            children: "Sales Account"
                        })
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "xero-settings-widget__sales-account-cell w-[70%] max-w-max",
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                            selectedOption: (_SessionStore$organis15 = (0, $1BTI2.default).organisation.accountingSystemSettings) === null || _SessionStore$organis15 === void 0 ? void 0 : (_SessionStore$organis16 = _SessionStore$organis15.settings) === null || _SessionStore$organis16 === void 0 ? void 0 : _SessionStore$organis16.salesAccount,
                            onChange: (o)=>{
                                var _SessionStore$organis17;
                                return (0, $1BTI2.default).organisation.updateAccountingSystemSettings({
                                    settings: {
                                        ...(_SessionStore$organis17 = (0, $1BTI2.default).organisation.accountingSystemSettings) === null || _SessionStore$organis17 === void 0 ? void 0 : _SessionStore$organis17.settings,
                                        salesAccount: o
                                    }
                                });
                            },
                            options: (_SessionStore$organis18 = (0, $1BTI2.default).organisation.accountingSystemSettings) === null || _SessionStore$organis18 === void 0 ? void 0 : (_SessionStore$organis19 = _SessionStore$organis18.data) === null || _SessionStore$organis19 === void 0 ? void 0 : _SessionStore$organis19.accounts,
                            optionLabel: (o)=>o === null || o === void 0 ? void 0 : o.name,
                            optionValue: (o)=>o === null || o === void 0 ? void 0 : o.id,
                            style: {
                                flex: "1 1 auto"
                            },
                            variant: "secondary"
                        })
                    })
                ]
            }),
            accountingDisplay.taxOnTaxType && /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "flex flex-align-items-center",
                style: {
                    margin: "1em 0"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "w-[30%]",
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)("strong", {
                            children: "Taxable Income"
                        })
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "xero-settings-widget__sales-account-cell w-[70%] max-w-max",
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                            selectedOption: (_SessionStore$organis20 = (0, $1BTI2.default).organisation.accountingSystemSettings) === null || _SessionStore$organis20 === void 0 ? void 0 : (_SessionStore$organis21 = _SessionStore$organis20.settings) === null || _SessionStore$organis21 === void 0 ? void 0 : _SessionStore$organis21.taxOnTaxType,
                            onChange: (o)=>{
                                var _SessionStore$organis22;
                                return (0, $1BTI2.default).organisation.updateAccountingSystemSettings({
                                    settings: {
                                        ...(_SessionStore$organis22 = (0, $1BTI2.default).organisation.accountingSystemSettings) === null || _SessionStore$organis22 === void 0 ? void 0 : _SessionStore$organis22.settings,
                                        taxOnTaxType: o
                                    }
                                });
                            },
                            options: (_SessionStore$organis23 = (0, $1BTI2.default).organisation.accountingSystemSettings) === null || _SessionStore$organis23 === void 0 ? void 0 : (_SessionStore$organis24 = _SessionStore$organis23.data) === null || _SessionStore$organis24 === void 0 ? void 0 : _SessionStore$organis24.taxTypes,
                            optionLabel: (o)=>o === null || o === void 0 ? void 0 : o.name,
                            optionValue: (o)=>o === null || o === void 0 ? void 0 : o.id,
                            style: {
                                flex: "1 1 auto"
                            },
                            variant: "secondary"
                        })
                    })
                ]
            }),
            accountingDisplay.taxOffTaxType && /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "flex flex-align-items-center",
                style: {
                    margin: "1em 0"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "w-[30%]",
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)("strong", {
                            children: "Tax Free Income"
                        })
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "xero-settings-widget__sales-account-cell w-[70%] max-w-max",
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                            selectedOption: (_SessionStore$organis25 = (0, $1BTI2.default).organisation.accountingSystemSettings) === null || _SessionStore$organis25 === void 0 ? void 0 : (_SessionStore$organis26 = _SessionStore$organis25.settings) === null || _SessionStore$organis26 === void 0 ? void 0 : _SessionStore$organis26.taxOffTaxType,
                            onChange: (o)=>{
                                var _SessionStore$organis27;
                                return (0, $1BTI2.default).organisation.updateAccountingSystemSettings({
                                    settings: {
                                        ...(_SessionStore$organis27 = (0, $1BTI2.default).organisation.accountingSystemSettings) === null || _SessionStore$organis27 === void 0 ? void 0 : _SessionStore$organis27.settings,
                                        taxOffTaxType: o
                                    }
                                });
                            },
                            options: (_SessionStore$organis28 = (0, $1BTI2.default).organisation.accountingSystemSettings) === null || _SessionStore$organis28 === void 0 ? void 0 : (_SessionStore$organis29 = _SessionStore$organis28.data) === null || _SessionStore$organis29 === void 0 ? void 0 : _SessionStore$organis29.taxTypes,
                            optionLabel: (o)=>o === null || o === void 0 ? void 0 : o.name,
                            optionValue: (o)=>o === null || o === void 0 ? void 0 : o.id,
                            style: {
                                flex: "1 1 auto"
                            },
                            variant: "secondary"
                        })
                    })
                ]
            }),
            accountingDisplay.usePhaseCodesAsItemCodes && /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                    value: ((_SessionStore$organis30 = (0, $1BTI2.default).organisation.accountingSystemSettings) === null || _SessionStore$organis30 === void 0 ? void 0 : (_SessionStore$organis31 = _SessionStore$organis30.settings) === null || _SessionStore$organis31 === void 0 ? void 0 : _SessionStore$organis31.usePhaseCodesAsItemCodes) || false,
                    onChange: (v)=>{
                        var _SessionStore$organis32;
                        return (0, $1BTI2.default).organisation.updateAccountingSystemSettings({
                            settings: {
                                ...(_SessionStore$organis32 = (0, $1BTI2.default).organisation.accountingSystemSettings) === null || _SessionStore$organis32 === void 0 ? void 0 : _SessionStore$organis32.settings,
                                usePhaseCodesAsItemCodes: v
                            }
                        });
                    },
                    style: {
                        margin: "1em 0"
                    },
                    label: "Use Phase Codes as Xero Item Codes",
                    variant: "secondary"
                })
            }),
            accountingDisplay.useProjectNameAsReference && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                value: ((_SessionStore$organis33 = (0, $1BTI2.default).organisation.accountingSystemSettings) === null || _SessionStore$organis33 === void 0 ? void 0 : (_SessionStore$organis34 = _SessionStore$organis33.settings) === null || _SessionStore$organis34 === void 0 ? void 0 : _SessionStore$organis34.useProjectNameAsReference) || false,
                onChange: (v)=>{
                    var _SessionStore$organis35;
                    return (0, $1BTI2.default).organisation.updateAccountingSystemSettings({
                        settings: {
                            ...(_SessionStore$organis35 = (0, $1BTI2.default).organisation.accountingSystemSettings) === null || _SessionStore$organis35 === void 0 ? void 0 : _SessionStore$organis35.settings,
                            useProjectNameAsReference: v
                        }
                    });
                },
                style: {
                    margin: "1em 0"
                },
                label: "Use Project Name as Xero Invoice Reference",
                variant: "secondary"
            }),
            accountingDisplay.taxAmount && "Tax Amount"
        ]
    });
});

});
parcelRegister("kScV6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f322df751d47a557$export$2e2bcd8739ae039; });

var $hCQbc = parcelRequire("hCQbc");

var $32EfH = parcelRequire("32EfH");

var $lzKQ8 = parcelRequire("lzKQ8");

var $chXZl = parcelRequire("chXZl");

var $cxnwP = parcelRequire("cxnwP");

var $1BTI2 = parcelRequire("1BTI2");

var $gJT7h = parcelRequire("gJT7h");

var $4hBm1 = parcelRequire("4hBm1");

var $bhvQG = parcelRequire("bhvQG");
const $f322df751d47a557$var$getObjs = ()=>{
    var _ProjectCollection$pr;
    return {
        ...Object.fromEntries((0, $cxnwP.default).invoices.map((i)=>[
                "inv" + i.id,
                {
                    ...i.serialize(),
                    type: "invoice"
                }
            ])),
        ...Object.fromEntries((0, $gJT7h.default).projects.map((i)=>[
                "pr" + i.id,
                {
                    ...i.serialize(),
                    type: "project"
                }
            ])),
        ...Object.fromEntries((0, $bhvQG.default).contacts.map((i)=>[
                "con" + i.id,
                {
                    ...i.serialize(),
                    type: "contact"
                }
            ])),
        inv0: {
            type: "invoice",
            projectId: ((_ProjectCollection$pr = (0, $gJT7h.default).projects[0]) === null || _ProjectCollection$pr === void 0 ? void 0 : _ProjectCollection$pr.id) || -1
        }
    };
};
const $f322df751d47a557$var$getHashObj = (ref, contextRef)=>{
    var _contextObj$siblingsB;
    const contextObj = $f322df751d47a557$var$getContextObj(contextRef);
    const refObj = (contextObj === null || contextObj === void 0 ? void 0 : (_contextObj$siblingsB = contextObj.siblingsByRef) === null || _contextObj$siblingsB === void 0 ? void 0 : _contextObj$siblingsB[ref]) || $f322df751d47a557$var$getObjs()[ref];
    return refObj;
};
const $f322df751d47a557$var$getAtObj = (ref, contextRef)=>{
    var _contextObj$siblingsB2;
    const contextObj = $f322df751d47a557$var$getContextObj(contextRef);
    const refObj = (contextObj === null || contextObj === void 0 ? void 0 : (_contextObj$siblingsB2 = contextObj.siblingsByRef) === null || _contextObj$siblingsB2 === void 0 ? void 0 : _contextObj$siblingsB2[ref]) || $f322df751d47a557$var$getObjs()[ref];
    return refObj;
};
const $f322df751d47a557$var$getContextObj = ([ref, prop])=>{
    return $f322df751d47a557$var$getObjs()[ref];
};
var $f322df751d47a557$export$2e2bcd8739ae039 = (0, $hCQbc.initParser)({
    getHashObj: $f322df751d47a557$var$getHashObj,
    getAtObj: $f322df751d47a557$var$getAtObj,
    getContextObj: $f322df751d47a557$var$getContextObj,
    constants: {
        invNum: ()=>{
            var _SessionStore$organis;
            return {
                type: "number",
                value: ((0, $1BTI2.default).organisation.invNum || 0) + 1 + (((_SessionStore$organis = (0, $1BTI2.default).organisation.settings.invoiceNumber) === null || _SessionStore$organis === void 0 ? void 0 : _SessionStore$organis.numAdjustor) || 0)
            };
        },
        projNum: ()=>{
            var _SessionStore$organis2;
            return {
                type: "number",
                value: (0, $gJT7h.default).projects.length + 1 + (((_SessionStore$organis2 = (0, $1BTI2.default).organisation.settings.projectNumber) === null || _SessionStore$organis2 === void 0 ? void 0 : _SessionStore$organis2.numAdjustor) || 0)
            };
        },
        invNumYear: ()=>{
            var _SessionStore$organis3, _SessionStore$organis4;
            return {
                type: "number",
                value: ((0, $1BTI2.default).organisation.invNumYear || 0) + 1 + (((_SessionStore$organis3 = (0, $1BTI2.default).organisation.settings.invoiceNumber) === null || _SessionStore$organis3 === void 0 ? void 0 : (_SessionStore$organis4 = _SessionStore$organis3.numYearAdjustors) === null || _SessionStore$organis4 === void 0 ? void 0 : _SessionStore$organis4[new Date().getFullYear()]) || 0)
            };
        },
        projNumYear: ()=>{
            var _SessionStore$organis5, _SessionStore$organis6;
            return {
                type: "number",
                value: (0, $gJT7h.default).projects.filter((i)=>(0, $4hBm1.isSameYear)(i.createdAt, new Date())).length + 1 + (((_SessionStore$organis5 = (0, $1BTI2.default).organisation.settings.projectNumber) === null || _SessionStore$organis5 === void 0 ? void 0 : (_SessionStore$organis6 = _SessionStore$organis5.numYearAdjustors) === null || _SessionStore$organis6 === void 0 ? void 0 : _SessionStore$organis6[new Date().getFullYear()]) || 0)
            };
        }
    },
    functions: {
    },
    objectProps: {
        invoice: {
            propertyLookup: (0, $32EfH.invoiceProperties),
            methodLookup: {}
        },
        project: {
            propertyLookup: (0, $lzKQ8.projectProperties),
            methodLookup: {}
        },
        contact: {
            propertyLookup: (0, $chXZl.contactProperties),
            methodLookup: {}
        }
    }
});

});
parcelRegister("hCQbc", function(module, exports) {

$parcel$export(module.exports, "initParser", function () { return $cd4e760b928291c5$export$84bb9899435eeb61; });

var $2Fel1 = parcelRequire("2Fel1");

var $9Nhon = parcelRequire("9Nhon");

var $eat5C = parcelRequire("eat5C");

var $LvEEw = parcelRequire("LvEEw");

var $fYQXH = parcelRequire("fYQXH");

var $5vW7M = parcelRequire("5vW7M");

var $c3qWO = parcelRequire("c3qWO");
const $cd4e760b928291c5$export$84bb9899435eeb61 = ({ getHashObj: getHashObj, getAtObj: getAtObj, getContextObj: getContextObj, objectProps: objectProps, constants: constants, functions: functions })=>{
    (0, $LvEEw.setGetHashObj)(getHashObj);
    (0, $LvEEw.setGetAtObj)(getAtObj);
    (0, $LvEEw.setGetContextObj)(getContextObj);
    (0, $2Fel1.addProperties)((0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).mapValues(objectProps, (o)=>o.propertyLookup));
    (0, $9Nhon.addMethods)((0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).mapValues(objectProps, (o)=>o.methodLookup));
    (0, $5vW7M.addConstants)(constants);
    (0, $c3qWO.addFunctions)(functions);
    return 0, $fYQXH.default;
};

});
parcelRegister("2Fel1", function(module, exports) {

$parcel$export(module.exports, "Properties", function () { return $1f0a885d4bf1291b$export$8714badcfa4caafb; });
$parcel$export(module.exports, "addProperties", function () { return $1f0a885d4bf1291b$export$25069d271a4443b2; });

var $3OjKl = parcelRequire("3OjKl");
let $1f0a885d4bf1291b$export$8714badcfa4caafb = {
    text: (0, $3OjKl.textProperties)
};
const $1f0a885d4bf1291b$export$25069d271a4443b2 = (newProps)=>{
    $1f0a885d4bf1291b$export$8714badcfa4caafb = {
        ...$1f0a885d4bf1291b$export$8714badcfa4caafb,
        ...newProps
    };
};

});
parcelRegister("3OjKl", function(module, exports) {

$parcel$export(module.exports, "textProperties", function () { return $2c655bdecc96f1d5$export$b9f5db49c77be77f; });
$parcel$export(module.exports, "textMethods", function () { return $2c655bdecc96f1d5$export$8e502bccaff93437; });
const $2c655bdecc96f1d5$export$b9f5db49c77be77f = (prop, textValue, context)=>{
    var _textPropertiesLookup;
    return (_textPropertiesLookup = $2c655bdecc96f1d5$var$textPropertiesLookup[prop]) === null || _textPropertiesLookup === void 0 ? void 0 : _textPropertiesLookup.call($2c655bdecc96f1d5$var$textPropertiesLookup, textValue, context);
};
const $2c655bdecc96f1d5$var$textPropertiesLookup = {
    length: (textValue, context)=>({
            type: "number",
            value: textValue.value.length
        })
};
const $2c655bdecc96f1d5$export$8e502bccaff93437 = {};

});


parcelRegister("9Nhon", function(module, exports) {

$parcel$export(module.exports, "Methods", function () { return $72162e67a4d55cf8$export$abe5cd09e951a89a; });
$parcel$export(module.exports, "addMethods", function () { return $72162e67a4d55cf8$export$626ce79af72fc3d3; });

var $3OjKl = parcelRequire("3OjKl");
let $72162e67a4d55cf8$export$abe5cd09e951a89a = {
    text: (0, $3OjKl.textMethods)
};
const $72162e67a4d55cf8$export$626ce79af72fc3d3 = (newMeths)=>{
    $72162e67a4d55cf8$export$abe5cd09e951a89a = {
        ...$72162e67a4d55cf8$export$abe5cd09e951a89a,
        ...newMeths
    };
};

});

parcelRegister("LvEEw", function(module, exports) {

$parcel$export(module.exports, "setGetHashObj", function () { return $08ecf1dcd80aec61$export$8e01281f14bbe8a3; });
$parcel$export(module.exports, "setGetAtObj", function () { return $08ecf1dcd80aec61$export$fb0166b6a3ca2434; });
$parcel$export(module.exports, "setGetContextObj", function () { return $08ecf1dcd80aec61$export$1b324680ae6b31b5; });
$parcel$export(module.exports, "getHashReferenceObject", function () { return $08ecf1dcd80aec61$export$ff6cc93a5b9478c3; });
$parcel$export(module.exports, "getAtReferenceObject", function () { return $08ecf1dcd80aec61$export$1ff62241d409976d; });
$parcel$export(module.exports, "getContextReferenceObject", function () { return $08ecf1dcd80aec61$export$270a34244357bdcb; });
let $08ecf1dcd80aec61$export$1c378393ceebe07d = (ref, contextRef)=>null;
const $08ecf1dcd80aec61$export$8e01281f14bbe8a3 = (newLookupFunc)=>$08ecf1dcd80aec61$export$1c378393ceebe07d = newLookupFunc !== null && newLookupFunc !== void 0 ? newLookupFunc : $08ecf1dcd80aec61$export$1c378393ceebe07d;
let $08ecf1dcd80aec61$export$1a026f087e274241 = (ref, contextRef)=>null;
const $08ecf1dcd80aec61$export$fb0166b6a3ca2434 = (newLookupFunc)=>$08ecf1dcd80aec61$export$1a026f087e274241 = newLookupFunc !== null && newLookupFunc !== void 0 ? newLookupFunc : $08ecf1dcd80aec61$export$1a026f087e274241;
let $08ecf1dcd80aec61$export$db89a4411af472ae = (contextRef)=>null;
const $08ecf1dcd80aec61$export$1b324680ae6b31b5 = (newLookupFunc)=>$08ecf1dcd80aec61$export$db89a4411af472ae = newLookupFunc !== null && newLookupFunc !== void 0 ? newLookupFunc : $08ecf1dcd80aec61$export$db89a4411af472ae;
const $08ecf1dcd80aec61$export$ff6cc93a5b9478c3 = (ref, contextRef)=>{
    return $08ecf1dcd80aec61$export$1c378393ceebe07d(ref, contextRef);
};
const $08ecf1dcd80aec61$export$1ff62241d409976d = (ref, contextRef)=>{
    return $08ecf1dcd80aec61$export$1a026f087e274241(ref, contextRef);
};
const $08ecf1dcd80aec61$export$270a34244357bdcb = (contextRef)=>{
    return $08ecf1dcd80aec61$export$db89a4411af472ae(contextRef);
};

});

parcelRegister("fYQXH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba258abfd7e0b1a8$export$2e2bcd8739ae039; });

var $F76En = parcelRequire("F76En");

var $f44xu = parcelRequire("f44xu");

var $gdz3N = parcelRequire("gdz3N");

var $gN0TC = parcelRequire("gN0TC");

var $2N6oS = parcelRequire("2N6oS");
function $ba258abfd7e0b1a8$var$_defineProperty(e, r, t) {
    return (r = $ba258abfd7e0b1a8$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ba258abfd7e0b1a8$var$_toPropertyKey(t) {
    var i = $ba258abfd7e0b1a8$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $ba258abfd7e0b1a8$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
// import { unitDefinitions } from "../../TimelineHelpers";
// // import CanvasStore from "../../CanvasStore";
// import { roundDateToNearestUnit } from "@ryki/datemath";
// import { getReferenceObject } from "./core/ReferenceLookup";
class $ba258abfd7e0b1a8$var$Formula {
    constructor({ ref: /*context,*/ ref, prop: prop, expectedType: expectedType, formula: formula }){
        var _ref;
        $ba258abfd7e0b1a8$var$_defineProperty(this, "ref", (0, (/*@__PURE__*/$parcel$interopDefault($gN0TC)))());
        // context = null;
        $ba258abfd7e0b1a8$var$_defineProperty(this, "prop", null);
        $ba258abfd7e0b1a8$var$_defineProperty(this, "expectedType", null);
        $ba258abfd7e0b1a8$var$_defineProperty(this, "_formula", "");
        $ba258abfd7e0b1a8$var$_defineProperty(this, "cachedAst", {});
        $ba258abfd7e0b1a8$var$_defineProperty(this, "cachedValidAst", {});
        $ba258abfd7e0b1a8$var$_defineProperty(this, "updateListeners", new Set());
        $ba258abfd7e0b1a8$var$_defineProperty(this, "needsUpdate", true);
        // this.context = context;
        this.ref = ref;
        this.prop = prop;
        this._formula = (_ref = formula !== null && formula !== void 0 ? formula : (0, $gdz3N.formulaDefaults)[expectedType]) !== null && _ref !== void 0 ? _ref : "";
        (0, $2N6oS.storeFormula)(this);
        this.update = this.update.bind(this);
        this.prepareUpdate = this.prepareUpdate.bind(this);
    }
    get formula() {
        return this._formula;
    }
    set formula(newFormula) {
        this._formula = newFormula;
        this.prepareUpdate();
        (0, $2N6oS.updateFormulas)();
    }
    update() {
        for (const listenter of this.updateListeners)listenter();
    }
    prepareUpdate() {
        (0, $2N6oS.prepareFormulaForUpdate)(this);
        this.needsUpdate = true;
        for (const dep of (0, $2N6oS.getDependants)(this))dep.prepareUpdate();
    }
    get context() {
        return (0, $f44xu.default)(this.ref, this.prop);
    }
    get ast() {
        var _this$cachedAst, _this$cachedAst2;
        if (!this.needsUpdate) return this.cachedAst;
        const oldDeps = this.cachedValidAst.dependencies || new Map();
        this.cachedAst = (0, $F76En.parseFormula)(this.formula, this.context);
        if ((_this$cachedAst = this.cachedAst) !== null && _this$cachedAst !== void 0 && _this$cachedAst.type && ((_this$cachedAst2 = this.cachedAst) === null || _this$cachedAst2 === void 0 ? void 0 : _this$cachedAst2.type) !== "error") this.cachedValidAst = {
            ...this.cachedAst
        };
        const newDeps = this.cachedValidAst.dependencies || new Map();
        if (!(oldDeps.size === newDeps.size && [
            ...newDeps.keys()
        ].every((dep)=>oldDeps.has(dep)))) (0, $2N6oS.updateDependencies)(this, oldDeps, newDeps);
        this.needsUpdate = false;
        return this.cachedAst;
    }
    get validAst() {
        var _this$ast, _this$ast2;
        return ((_this$ast = this.ast) === null || _this$ast === void 0 ? void 0 : _this$ast.type) && ((_this$ast2 = this.ast) === null || _this$ast2 === void 0 ? void 0 : _this$ast2.type) !== "error";
    }
    get type() {
        return this.validAst && this.ast.type || this.cachedValidAst.type;
    }
    get value() {
        return this.validAst && this.ast.value || this.cachedValidAst.value;
    }
    get dependencies() {
        return this.validAst && this.ast.dependencies || this.cachedValidAst.dependencies || new Map();
    }
    adjustToValue(newVal) {
        const newFormula = (0, $gdz3N.adjustFormulaToValue)(this.ast, newVal, this.context);
        this.formula = newFormula;
        return newFormula;
    }
}
var $ba258abfd7e0b1a8$export$2e2bcd8739ae039 = $ba258abfd7e0b1a8$var$Formula;

});
parcelRegister("F76En", function(module, exports) {

$parcel$export(module.exports, "parseFormula", function () { return $07b9579b1be7820f$export$eeb32a119aed5e3; });

var $9OakW = parcelRequire("9OakW");

var $6TQqK = parcelRequire("6TQqK");
parcelRequire("hcUu8");
const $07b9579b1be7820f$export$eeb32a119aed5e3 = (string, context)=>{
    if (!string) return;
    const parser = new (0, (/*@__PURE__*/$parcel$interopDefault($9OakW))).Parser((0, (/*@__PURE__*/$parcel$interopDefault($9OakW))).Grammar.fromCompiled((0, $6TQqK.default)(context)));
    try {
        parser.feed(string);
        return parser.results[0];
    } catch (err) {
        //error breaks things for some reason
        console.log("Error at character " + (err === null || err === void 0 ? void 0 : err.offset), err); // "Error at character 9"
        return {
            type: "error"
        };
    }
};

});
parcelRegister("9OakW", function(module, exports) {
(function(root, factory) {
    if (0, module.exports) module.exports = factory();
    else root.nearley = factory();
})(module.exports, function() {
    function Rule(name, symbols, postprocess) {
        this.id = ++Rule.highestId;
        this.name = name;
        this.symbols = symbols; // a list of literal | regex class | nonterminal
        this.postprocess = postprocess;
        return this;
    }
    Rule.highestId = 0;
    Rule.prototype.toString = function(withCursorAt) {
        var symbolSequence = typeof withCursorAt === "undefined" ? this.symbols.map(getSymbolShortDisplay).join(" ") : this.symbols.slice(0, withCursorAt).map(getSymbolShortDisplay).join(" ") + " \u25CF " + this.symbols.slice(withCursorAt).map(getSymbolShortDisplay).join(" ");
        return this.name + " \u2192 " + symbolSequence;
    };
    // a State is a rule at a position from a given starting point in the input stream (reference)
    function State(rule, dot, reference, wantedBy) {
        this.rule = rule;
        this.dot = dot;
        this.reference = reference;
        this.data = [];
        this.wantedBy = wantedBy;
        this.isComplete = this.dot === rule.symbols.length;
    }
    State.prototype.toString = function() {
        return "{" + this.rule.toString(this.dot) + "}, from: " + (this.reference || 0);
    };
    State.prototype.nextState = function(child) {
        var state = new State(this.rule, this.dot + 1, this.reference, this.wantedBy);
        state.left = this;
        state.right = child;
        if (state.isComplete) {
            state.data = state.build();
            // Having right set here will prevent the right state and its children
            // form being garbage collected
            state.right = undefined;
        }
        return state;
    };
    State.prototype.build = function() {
        var children = [];
        var node = this;
        do {
            children.push(node.right.data);
            node = node.left;
        }while (node.left);
        children.reverse();
        return children;
    };
    State.prototype.finish = function() {
        if (this.rule.postprocess) this.data = this.rule.postprocess(this.data, this.reference, Parser.fail);
    };
    function Column(grammar, index) {
        this.grammar = grammar;
        this.index = index;
        this.states = [];
        this.wants = {}; // states indexed by the non-terminal they expect
        this.scannable = []; // list of states that expect a token
        this.completed = {}; // states that are nullable
    }
    Column.prototype.process = function(nextColumn) {
        var states = this.states;
        var wants = this.wants;
        var completed = this.completed;
        for(var w = 0; w < states.length; w++){
            var state = states[w];
            if (state.isComplete) {
                state.finish();
                if (state.data !== Parser.fail) {
                    // complete
                    var wantedBy = state.wantedBy;
                    for(var i = wantedBy.length; i--;){
                        var left = wantedBy[i];
                        this.complete(left, state);
                    }
                    // special-case nullables
                    if (state.reference === this.index) {
                        // make sure future predictors of this rule get completed.
                        var exp = state.rule.name;
                        (this.completed[exp] = this.completed[exp] || []).push(state);
                    }
                }
            } else {
                // queue scannable states
                var exp = state.rule.symbols[state.dot];
                if (typeof exp !== "string") {
                    this.scannable.push(state);
                    continue;
                }
                // predict
                if (wants[exp]) {
                    wants[exp].push(state);
                    if (completed.hasOwnProperty(exp)) {
                        var nulls = completed[exp];
                        for(var i = 0; i < nulls.length; i++){
                            var right = nulls[i];
                            this.complete(state, right);
                        }
                    }
                } else {
                    wants[exp] = [
                        state
                    ];
                    this.predict(exp);
                }
            }
        }
    };
    Column.prototype.predict = function(exp) {
        var rules = this.grammar.byName[exp] || [];
        for(var i = 0; i < rules.length; i++){
            var r = rules[i];
            var wantedBy = this.wants[exp];
            var s = new State(r, 0, this.index, wantedBy);
            this.states.push(s);
        }
    };
    Column.prototype.complete = function(left, right) {
        var copy = left.nextState(right);
        this.states.push(copy);
    };
    function Grammar(rules, start) {
        this.rules = rules;
        this.start = start || this.rules[0].name;
        var byName = this.byName = {};
        this.rules.forEach(function(rule) {
            if (!byName.hasOwnProperty(rule.name)) byName[rule.name] = [];
            byName[rule.name].push(rule);
        });
    }
    // So we can allow passing (rules, start) directly to Parser for backwards compatibility
    Grammar.fromCompiled = function(rules, start) {
        var lexer = rules.Lexer;
        if (rules.ParserStart) {
            start = rules.ParserStart;
            rules = rules.ParserRules;
        }
        var rules = rules.map(function(r) {
            return new Rule(r.name, r.symbols, r.postprocess);
        });
        var g = new Grammar(rules, start);
        g.lexer = lexer; // nb. storing lexer on Grammar is iffy, but unavoidable
        return g;
    };
    function StreamLexer() {
        this.reset("");
    }
    StreamLexer.prototype.reset = function(data, state) {
        this.buffer = data;
        this.index = 0;
        this.line = state ? state.line : 1;
        this.lastLineBreak = state ? -state.col : 0;
    };
    StreamLexer.prototype.next = function() {
        if (this.index < this.buffer.length) {
            var ch = this.buffer[this.index++];
            if (ch === "\n") {
                this.line += 1;
                this.lastLineBreak = this.index;
            }
            return {
                value: ch
            };
        }
    };
    StreamLexer.prototype.save = function() {
        return {
            line: this.line,
            col: this.index - this.lastLineBreak
        };
    };
    StreamLexer.prototype.formatError = function(token, message) {
        // nb. this gets called after consuming the offending token,
        // so the culprit is index-1
        var buffer = this.buffer;
        if (typeof buffer === "string") {
            var lines = buffer.split("\n").slice(Math.max(0, this.line - 5), this.line);
            var nextLineBreak = buffer.indexOf("\n", this.index);
            if (nextLineBreak === -1) nextLineBreak = buffer.length;
            var col = this.index - this.lastLineBreak;
            var lastLineDigits = String(this.line).length;
            message += " at line " + this.line + " col " + col + ":\n\n";
            message += lines.map(function(line, i) {
                return pad(this.line - lines.length + i + 1, lastLineDigits) + " " + line;
            }, this).join("\n");
            message += "\n" + pad("", lastLineDigits + col) + "^\n";
            return message;
        } else return message + " at index " + (this.index - 1);
        function pad(n, length) {
            var s = String(n);
            return Array(length - s.length + 1).join(" ") + s;
        }
    };
    function Parser(rules, start, options) {
        if (rules instanceof Grammar) {
            var grammar = rules;
            var options = start;
        } else var grammar = Grammar.fromCompiled(rules, start);
        this.grammar = grammar;
        // Read options
        this.options = {
            keepHistory: false,
            lexer: grammar.lexer || new StreamLexer
        };
        for(var key in options || {})this.options[key] = options[key];
        // Setup lexer
        this.lexer = this.options.lexer;
        this.lexerState = undefined;
        // Setup a table
        var column = new Column(grammar, 0);
        var table = this.table = [
            column
        ];
        // I could be expecting anything.
        column.wants[grammar.start] = [];
        column.predict(grammar.start);
        // TODO what if start rule is nullable?
        column.process();
        this.current = 0; // token index
    }
    // create a reserved token for indicating a parse fail
    Parser.fail = {};
    Parser.prototype.feed = function(chunk) {
        var lexer = this.lexer;
        lexer.reset(chunk, this.lexerState);
        var token;
        while(true){
            try {
                token = lexer.next();
                if (!token) break;
            } catch (e) {
                // Create the next column so that the error reporter
                // can display the correctly predicted states.
                var nextColumn = new Column(this.grammar, this.current + 1);
                this.table.push(nextColumn);
                var err = new Error(this.reportLexerError(e));
                err.offset = this.current;
                err.token = e.token;
                throw err;
            }
            // We add new states to table[current+1]
            var column = this.table[this.current];
            // GC unused states
            if (!this.options.keepHistory) delete this.table[this.current - 1];
            var n = this.current + 1;
            var nextColumn = new Column(this.grammar, n);
            this.table.push(nextColumn);
            // Advance all tokens that expect the symbol
            var literal = token.text !== undefined ? token.text : token.value;
            var value = lexer.constructor === StreamLexer ? token.value : token;
            var scannable = column.scannable;
            for(var w = scannable.length; w--;){
                var state = scannable[w];
                var expect = state.rule.symbols[state.dot];
                // Try to consume the token
                // either regex or literal
                if (expect.test ? expect.test(value) : expect.type ? expect.type === token.type : expect.literal === literal) {
                    // Add it
                    var next = state.nextState({
                        data: value,
                        token: token,
                        isToken: true,
                        reference: n - 1
                    });
                    nextColumn.states.push(next);
                }
            }
            // Next, for each of the rules, we either
            // (a) complete it, and try to see if the reference row expected that
            //     rule
            // (b) predict the next nonterminal it expects by adding that
            //     nonterminal's start state
            // To prevent duplication, we also keep track of rules we have already
            // added
            nextColumn.process();
            // If needed, throw an error:
            if (nextColumn.states.length === 0) {
                // No states at all! This is not good.
                var err = new Error(this.reportError(token));
                err.offset = this.current;
                err.token = token;
                throw err;
            }
            // maybe save lexer state
            if (this.options.keepHistory) column.lexerState = lexer.save();
            this.current++;
        }
        if (column) this.lexerState = lexer.save();
        // Incrementally keep track of results
        this.results = this.finish();
        // Allow chaining, for whatever it's worth
        return this;
    };
    Parser.prototype.reportLexerError = function(lexerError) {
        var tokenDisplay, lexerMessage;
        // Planning to add a token property to moo's thrown error
        // even on erroring tokens to be used in error display below
        var token = lexerError.token;
        if (token) {
            tokenDisplay = "input " + JSON.stringify(token.text[0]) + " (lexer error)";
            lexerMessage = this.lexer.formatError(token, "Syntax error");
        } else {
            tokenDisplay = "input (lexer error)";
            lexerMessage = lexerError.message;
        }
        return this.reportErrorCommon(lexerMessage, tokenDisplay);
    };
    Parser.prototype.reportError = function(token) {
        var tokenDisplay = (token.type ? token.type + " token: " : "") + JSON.stringify(token.value !== undefined ? token.value : token);
        var lexerMessage = this.lexer.formatError(token, "Syntax error");
        return this.reportErrorCommon(lexerMessage, tokenDisplay);
    };
    Parser.prototype.reportErrorCommon = function(lexerMessage, tokenDisplay) {
        var lines = [];
        lines.push(lexerMessage);
        var lastColumnIndex = this.table.length - 2;
        var lastColumn = this.table[lastColumnIndex];
        var expectantStates = lastColumn.states.filter(function(state) {
            var nextSymbol = state.rule.symbols[state.dot];
            return nextSymbol && typeof nextSymbol !== "string";
        });
        if (expectantStates.length === 0) {
            lines.push("Unexpected " + tokenDisplay + ". I did not expect any more input. Here is the state of my parse table:\n");
            this.displayStateStack(lastColumn.states, lines);
        } else {
            lines.push("Unexpected " + tokenDisplay + ". Instead, I was expecting to see one of the following:\n");
            // Display a "state stack" for each expectant state
            // - which shows you how this state came to be, step by step.
            // If there is more than one derivation, we only display the first one.
            var stateStacks = expectantStates.map(function(state) {
                return this.buildFirstStateStack(state, []) || [
                    state
                ];
            }, this);
            // Display each state that is expecting a terminal symbol next.
            stateStacks.forEach(function(stateStack) {
                var state = stateStack[0];
                var nextSymbol = state.rule.symbols[state.dot];
                var symbolDisplay = this.getSymbolDisplay(nextSymbol);
                lines.push("A " + symbolDisplay + " based on:");
                this.displayStateStack(stateStack, lines);
            }, this);
        }
        lines.push("");
        return lines.join("\n");
    };
    Parser.prototype.displayStateStack = function(stateStack, lines) {
        var lastDisplay;
        var sameDisplayCount = 0;
        for(var j = 0; j < stateStack.length; j++){
            var state = stateStack[j];
            var display = state.rule.toString(state.dot);
            if (display === lastDisplay) sameDisplayCount++;
            else {
                if (sameDisplayCount > 0) lines.push("    ^ " + sameDisplayCount + " more lines identical to this");
                sameDisplayCount = 0;
                lines.push("    " + display);
            }
            lastDisplay = display;
        }
    };
    Parser.prototype.getSymbolDisplay = function(symbol) {
        return getSymbolLongDisplay(symbol);
    };
    /*
    Builds a the first state stack. You can think of a state stack as the call stack
    of the recursive-descent parser which the Nearley parse algorithm simulates.
    A state stack is represented as an array of state objects. Within a
    state stack, the first item of the array will be the starting
    state, with each successive item in the array going further back into history.

    This function needs to be given a starting state and an empty array representing
    the visited states, and it returns an single state stack.

    */ Parser.prototype.buildFirstStateStack = function(state, visited) {
        if (visited.indexOf(state) !== -1) // Found cycle, return null
        // to eliminate this path from the results, because
        // we don't know how to display it meaningfully
        return null;
        if (state.wantedBy.length === 0) return [
            state
        ];
        var prevState = state.wantedBy[0];
        var childVisited = [
            state
        ].concat(visited);
        var childResult = this.buildFirstStateStack(prevState, childVisited);
        if (childResult === null) return null;
        return [
            state
        ].concat(childResult);
    };
    Parser.prototype.save = function() {
        var column = this.table[this.current];
        column.lexerState = this.lexerState;
        return column;
    };
    Parser.prototype.restore = function(column) {
        var index = column.index;
        this.current = index;
        this.table[index] = column;
        this.table.splice(index + 1);
        this.lexerState = column.lexerState;
        // Incrementally keep track of results
        this.results = this.finish();
    };
    // nb. deprecated: use save/restore instead!
    Parser.prototype.rewind = function(index) {
        if (!this.options.keepHistory) throw new Error("set option `keepHistory` to enable rewinding");
        // nb. recall column (table) indicies fall between token indicies.
        //        col 0   --   token 0   --   col 1
        this.restore(this.table[index]);
    };
    Parser.prototype.finish = function() {
        // Return the possible parsings
        var considerations = [];
        var start = this.grammar.start;
        var column = this.table[this.table.length - 1];
        column.states.forEach(function(t) {
            if (t.rule.name === start && t.dot === t.rule.symbols.length && t.reference === 0 && t.data !== Parser.fail) considerations.push(t);
        });
        return considerations.map(function(c) {
            return c.data;
        });
    };
    function getSymbolLongDisplay(symbol) {
        var type = typeof symbol;
        if (type === "string") return symbol;
        else if (type === "object") {
            if (symbol.literal) return JSON.stringify(symbol.literal);
            else if (symbol instanceof RegExp) return "character matching " + symbol;
            else if (symbol.type) return symbol.type + " token";
            else if (symbol.test) return "token matching " + String(symbol.test);
            else throw new Error("Unknown symbol type: " + symbol);
        }
    }
    function getSymbolShortDisplay(symbol) {
        var type = typeof symbol;
        if (type === "string") return symbol;
        else if (type === "object") {
            if (symbol.literal) return JSON.stringify(symbol.literal);
            else if (symbol instanceof RegExp) return symbol.toString();
            else if (symbol.type) return "%" + symbol.type;
            else if (symbol.test) return "<" + String(symbol.test) + ">";
            else throw new Error("Unknown symbol type: " + symbol);
        }
    }
    return {
        Parser: Parser,
        Grammar: Grammar,
        Rule: Rule
    };
});

});

parcelRegister("6TQqK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $50608cbbbd745b2c$export$2e2bcd8739ae039; });
// Generated automatically by nearley, version 2.19.3
// http://github.com/Hardmath123/nearley

function $50608cbbbd745b2c$export$2e2bcd8739ae039(context) {
    function id(x) {
        return x[0];
    }
    const FormulaNode = (parcelRequire("hcUu8")).FormulaNode;
    const makeString = (d)=>{
        return d.map((e)=>{
            var _ref, _e$matchString;
            return (_ref = (_e$matchString = e === null || e === void 0 ? void 0 : e.matchString) !== null && _e$matchString !== void 0 ? _e$matchString : e) !== null && _ref !== void 0 ? _ref : "";
        }).join("");
    };
    const modifyString = (objects, opVal)=>{
        const str = makeString(objects);
        opVal.matchString = str;
        return opVal;
    };
    const op = (name, objects, inputs)=>{
        return FormulaNode(name, inputs, makeString(objects), context);
    };
    var grammar = {
        Lexer: undefined,
        ParserRules: [
            {
                "name": "value",
                "symbols": [
                    "expression"
                ],
                "postprocess": (d)=>d[0]
            },
            {
                "name": "function",
                "symbols": [
                    "P",
                    {
                        "literal": "."
                    },
                    "string",
                    {
                        "literal": "("
                    },
                    "array",
                    {
                        "literal": ")"
                    }
                ],
                "postprocess": (d)=>op("method", d, {
                        object: d[0],
                        method: d[2],
                        args: d[4]
                    })
            },
            {
                "name": "function",
                "symbols": [
                    "P",
                    {
                        "literal": "."
                    },
                    "string"
                ],
                "postprocess": (d)=>op("property", d, {
                        object: d[0],
                        prop: d[2]
                    })
            },
            {
                "name": "function",
                "symbols": [
                    "context",
                    "string"
                ],
                "postprocess": (d)=>op("property", d, {
                        object: d[0],
                        prop: d[1]
                    })
            },
            {
                "name": "function",
                "symbols": [
                    "string",
                    {
                        "literal": "("
                    },
                    "array",
                    {
                        "literal": ")"
                    }
                ],
                "postprocess": (d)=>op("function", d, {
                        funcName: d[0],
                        args: d[2]
                    })
            },
            {
                "name": "function",
                "symbols": [
                    "basicObject"
                ],
                "postprocess": (d)=>d[0]
            },
            {
                "name": "array",
                "symbols": [
                    "condition",
                    "_",
                    {
                        "literal": ","
                    },
                    "_",
                    "array"
                ],
                "postprocess": (d)=>op("array", d, {
                        array: [
                            d[0],
                            ...d[4].type === "array" ? d[4].value : [
                                d[4]
                            ]
                        ]
                    })
            },
            {
                "name": "array",
                "symbols": [
                    "condition"
                ],
                "postprocess": (d)=>d[0]
            },
            {
                "name": "basicObject$subexpression$1",
                "symbols": [
                    "range"
                ]
            },
            {
                "name": "basicObject$subexpression$1",
                "symbols": [
                    "context"
                ]
            },
            {
                "name": "basicObject$subexpression$1",
                "symbols": [
                    "dateTime"
                ]
            },
            {
                "name": "basicObject$subexpression$1",
                "symbols": [
                    "time"
                ]
            },
            {
                "name": "basicObject$subexpression$1",
                "symbols": [
                    "hashRef"
                ]
            },
            {
                "name": "basicObject$subexpression$1",
                "symbols": [
                    "atRef"
                ]
            },
            {
                "name": "basicObject$subexpression$1",
                "symbols": [
                    "text"
                ]
            },
            {
                "name": "basicObject$subexpression$1",
                "symbols": [
                    "percent"
                ]
            },
            {
                "name": "basicObject$subexpression$1",
                "symbols": [
                    "duration"
                ]
            },
            {
                "name": "basicObject$subexpression$1",
                "symbols": [
                    "float"
                ]
            },
            {
                "name": "basicObject",
                "symbols": [
                    "basicObject$subexpression$1"
                ],
                "postprocess": (d)=>d[0][0]
            },
            {
                "name": "expression",
                "symbols": [
                    "_",
                    "array",
                    "_"
                ],
                "postprocess": (d)=>d[1].length === 1 ? d[1][0] : d[1]
            },
            {
                "name": "condition$subexpression$1",
                "symbols": [
                    /[iI]/,
                    /[fF]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "condition$subexpression$2",
                "symbols": [
                    /[tT]/,
                    /[hH]/,
                    /[eE]/,
                    /[nN]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "condition$subexpression$3",
                "symbols": [
                    /[eE]/,
                    /[lL]/,
                    /[sS]/,
                    /[eE]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "condition",
                "symbols": [
                    "condition$subexpression$1",
                    "__",
                    "condition",
                    "__",
                    "condition$subexpression$2",
                    "__",
                    "condition",
                    "__",
                    "condition$subexpression$3",
                    "__",
                    "condition"
                ],
                "postprocess": (d)=>op("ifElse", d, {
                        if: d[2],
                        then: d[6],
                        else: d[10]
                    })
            },
            {
                "name": "condition",
                "symbols": [
                    "condition",
                    "_",
                    {
                        "literal": "?"
                    },
                    "_",
                    "condition",
                    "_",
                    {
                        "literal": ":"
                    },
                    "_",
                    "condition"
                ],
                "postprocess": (d)=>op("ifElse", d, {
                        if: d[0],
                        then: d[4],
                        else: d[8]
                    })
            },
            {
                "name": "condition$subexpression$4",
                "symbols": [
                    /[iI]/,
                    /[fF]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "condition$subexpression$5",
                "symbols": [
                    /[eE]/,
                    /[lL]/,
                    /[sS]/,
                    /[eE]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "condition",
                "symbols": [
                    "condition",
                    "_",
                    "condition$subexpression$4",
                    "_",
                    "condition",
                    "_",
                    "condition$subexpression$5",
                    "_",
                    "condition"
                ],
                "postprocess": (d)=>op("ifElse", d, {
                        if: d[4],
                        then: d[0],
                        else: d[8]
                    })
            },
            {
                "name": "condition",
                "symbols": [
                    "comparison"
                ],
                "postprocess": (d)=>d[0]
            },
            {
                "name": "comparison",
                "symbols": [
                    "comparison",
                    "_",
                    {
                        "literal": "="
                    },
                    "_",
                    "logic"
                ],
                "postprocess": (d)=>op("equal", d, {
                        left: d[0],
                        right: d[4]
                    })
            },
            {
                "name": "comparison$string$1",
                "symbols": [
                    {
                        "literal": ">"
                    },
                    {
                        "literal": "="
                    }
                ],
                "postprocess": function joiner(d) {
                    return d.join("");
                }
            },
            {
                "name": "comparison",
                "symbols": [
                    "comparison",
                    "_",
                    "comparison$string$1",
                    "_",
                    "logic"
                ],
                "postprocess": (d)=>op("greaterThanEqual", d, {
                        left: d[0],
                        right: d[4]
                    })
            },
            {
                "name": "comparison$string$2",
                "symbols": [
                    {
                        "literal": "<"
                    },
                    {
                        "literal": "="
                    }
                ],
                "postprocess": function joiner(d) {
                    return d.join("");
                }
            },
            {
                "name": "comparison",
                "symbols": [
                    "comparison",
                    "_",
                    "comparison$string$2",
                    "_",
                    "logic"
                ],
                "postprocess": (d)=>op("lessThanEqual", d, {
                        left: d[0],
                        right: d[4]
                    })
            },
            {
                "name": "comparison",
                "symbols": [
                    "comparison",
                    "_",
                    {
                        "literal": ">"
                    },
                    "_",
                    "logic"
                ],
                "postprocess": (d)=>op("greaterThan", d, {
                        left: d[0],
                        right: d[4]
                    })
            },
            {
                "name": "comparison",
                "symbols": [
                    "comparison",
                    "_",
                    {
                        "literal": "<"
                    },
                    "_",
                    "logic"
                ],
                "postprocess": (d)=>op("lessThan", d, {
                        left: d[0],
                        right: d[4]
                    })
            },
            {
                "name": "comparison",
                "symbols": [
                    "logic"
                ],
                "postprocess": (d)=>d[0]
            },
            {
                "name": "logic$subexpression$1",
                "symbols": [
                    /[aA]/,
                    /[nN]/,
                    /[dD]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "logic",
                "symbols": [
                    "logic",
                    "__",
                    "logic$subexpression$1",
                    "__",
                    "AS"
                ],
                "postprocess": (d)=>op("and", d, {
                        left: d[0],
                        right: d[4]
                    })
            },
            {
                "name": "logic",
                "symbols": [
                    "logic",
                    "_",
                    {
                        "literal": "&"
                    },
                    "_",
                    "AS"
                ],
                "postprocess": (d)=>op("and", d, {
                        left: d[0],
                        right: d[4]
                    })
            },
            {
                "name": "logic$subexpression$2",
                "symbols": [
                    /[oO]/,
                    /[rR]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "logic",
                "symbols": [
                    "logic",
                    "__",
                    "logic$subexpression$2",
                    "__",
                    "AS"
                ],
                "postprocess": (d)=>op("or", d, {
                        left: d[0],
                        right: d[4]
                    })
            },
            {
                "name": "logic",
                "symbols": [
                    "logic",
                    "_",
                    {
                        "literal": "|"
                    },
                    "_",
                    "AS"
                ],
                "postprocess": (d)=>op("or", d, {
                        left: d[0],
                        right: d[4]
                    })
            },
            {
                "name": "logic",
                "symbols": [
                    "AS"
                ],
                "postprocess": (d)=>d[0]
            },
            {
                "name": "P",
                "symbols": [
                    {
                        "literal": "("
                    },
                    "_",
                    "value",
                    "_",
                    {
                        "literal": ")"
                    }
                ],
                "postprocess": (d)=>modifyString(d, d[2])
            },
            {
                "name": "P",
                "symbols": [
                    "function"
                ],
                "postprocess": (d)=>d[0]
            },
            {
                "name": "not$subexpression$1",
                "symbols": [
                    /[nN]/,
                    /[oO]/,
                    /[tT]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "not",
                "symbols": [
                    "not$subexpression$1",
                    "__",
                    "not"
                ],
                "postprocess": (d)=>op("not", d, {
                        val: {
                            ...d[2]
                        }
                    })
            },
            {
                "name": "not",
                "symbols": [
                    {
                        "literal": "!"
                    },
                    "_",
                    "not"
                ],
                "postprocess": (d)=>op("not", d, {
                        val: {
                            ...d[2]
                        }
                    })
            },
            {
                "name": "not",
                "symbols": [
                    "P"
                ],
                "postprocess": (d)=>d[0]
            },
            {
                "name": "E",
                "symbols": [
                    "not",
                    "_",
                    {
                        "literal": "^"
                    },
                    "_",
                    "E"
                ],
                "postprocess": (d)=>op("power", d, {
                        base: d[0],
                        power: d[4]
                    })
            },
            {
                "name": "E",
                "symbols": [
                    "not"
                ],
                "postprocess": (d)=>d[0]
            },
            {
                "name": "MD",
                "symbols": [
                    "MD",
                    "_",
                    {
                        "literal": "*"
                    },
                    "_",
                    "E"
                ],
                "postprocess": (d)=>op("multiply", d, {
                        left: d[0],
                        right: d[4]
                    })
            },
            {
                "name": "MD",
                "symbols": [
                    "MD",
                    "_",
                    {
                        "literal": "/"
                    },
                    "_",
                    "E"
                ],
                "postprocess": (d)=>op("divide", d, {
                        left: d[0],
                        right: d[4]
                    })
            },
            {
                "name": "MD",
                "symbols": [
                    "E"
                ],
                "postprocess": (d)=>d[0]
            },
            {
                "name": "AS",
                "symbols": [
                    "AS",
                    "_",
                    {
                        "literal": "+"
                    },
                    "_",
                    "MD"
                ],
                "postprocess": (d)=>op("add", d, {
                        left: d[0],
                        right: d[4]
                    })
            },
            {
                "name": "AS",
                "symbols": [
                    "AS",
                    "_",
                    {
                        "literal": "-"
                    },
                    "_",
                    "MD"
                ],
                "postprocess": (d)=>op("subtract", d, {
                        left: d[0],
                        right: d[4]
                    })
            },
            {
                "name": "AS",
                "symbols": [
                    "MD"
                ],
                "postprocess": (d)=>d[0]
            },
            {
                "name": "context",
                "symbols": [
                    {
                        "literal": "$"
                    }
                ],
                "postprocess": (d)=>op("context", d, {
                        context: context
                    })
            },
            {
                "name": "hashRef",
                "symbols": [
                    {
                        "literal": "#"
                    },
                    "ref"
                ],
                "postprocess": (d)=>op("hashRef", d, {
                        context: context,
                        ref: d[1]
                    })
            },
            {
                "name": "atRef",
                "symbols": [
                    {
                        "literal": "@"
                    },
                    "ref"
                ],
                "postprocess": (d)=>op("atRef", d, {
                        context: context,
                        ref: d[1]
                    })
            },
            {
                "name": "range$string$1",
                "symbols": [
                    {
                        "literal": "-"
                    },
                    {
                        "literal": ">"
                    }
                ],
                "postprocess": function joiner(d) {
                    return d.join("");
                }
            },
            {
                "name": "range",
                "symbols": [
                    "P",
                    "_",
                    "range$string$1",
                    "_",
                    "P"
                ],
                "postprocess": (d)=>op("range", d, {
                        start: d[0],
                        end: d[4]
                    })
            },
            {
                "name": "duration",
                "symbols": [
                    "P",
                    "__",
                    "durationUnit"
                ],
                "postprocess": (d)=>op("duration", d, {
                        amount: d[0],
                        unit: d[2]
                    })
            },
            {
                "name": "duration",
                "symbols": [
                    "P",
                    "__",
                    "durationUnitSingular"
                ],
                "postprocess": (d)=>op("duration", d, {
                        amount: d[0],
                        unit: `${d[2]}s`
                    })
            },
            {
                "name": "durationUnit$subexpression$1$subexpression$1",
                "symbols": [
                    /[mM]/,
                    /[iI]/,
                    /[lL]/,
                    /[lL]/,
                    /[iI]/,
                    /[sS]/,
                    /[eE]/,
                    /[cC]/,
                    /[oO]/,
                    /[nN]/,
                    /[dD]/,
                    /[sS]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "durationUnit$subexpression$1",
                "symbols": [
                    "durationUnit$subexpression$1$subexpression$1"
                ]
            },
            {
                "name": "durationUnit$subexpression$1$subexpression$2",
                "symbols": [
                    /[sS]/,
                    /[eE]/,
                    /[cC]/,
                    /[oO]/,
                    /[nN]/,
                    /[dD]/,
                    /[sS]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "durationUnit$subexpression$1",
                "symbols": [
                    "durationUnit$subexpression$1$subexpression$2"
                ]
            },
            {
                "name": "durationUnit$subexpression$1$subexpression$3",
                "symbols": [
                    /[mM]/,
                    /[iI]/,
                    /[nN]/,
                    /[uU]/,
                    /[tT]/,
                    /[eE]/,
                    /[sS]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "durationUnit$subexpression$1",
                "symbols": [
                    "durationUnit$subexpression$1$subexpression$3"
                ]
            },
            {
                "name": "durationUnit$subexpression$1$subexpression$4",
                "symbols": [
                    /[hH]/,
                    /[oO]/,
                    /[uU]/,
                    /[rR]/,
                    /[sS]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "durationUnit$subexpression$1",
                "symbols": [
                    "durationUnit$subexpression$1$subexpression$4"
                ]
            },
            {
                "name": "durationUnit$subexpression$1$subexpression$5",
                "symbols": [
                    /[dD]/,
                    /[aA]/,
                    /[yY]/,
                    /[sS]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "durationUnit$subexpression$1",
                "symbols": [
                    "durationUnit$subexpression$1$subexpression$5"
                ]
            },
            {
                "name": "durationUnit$subexpression$1$subexpression$6",
                "symbols": [
                    /[wW]/,
                    /[eE]/,
                    /[eE]/,
                    /[kK]/,
                    /[sS]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "durationUnit$subexpression$1",
                "symbols": [
                    "durationUnit$subexpression$1$subexpression$6"
                ]
            },
            {
                "name": "durationUnit$subexpression$1$subexpression$7",
                "symbols": [
                    /[mM]/,
                    /[oO]/,
                    /[nN]/,
                    /[tT]/,
                    /[hH]/,
                    /[sS]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "durationUnit$subexpression$1",
                "symbols": [
                    "durationUnit$subexpression$1$subexpression$7"
                ]
            },
            {
                "name": "durationUnit$subexpression$1$subexpression$8",
                "symbols": [
                    /[yY]/,
                    /[eE]/,
                    /[aA]/,
                    /[rR]/,
                    /[sS]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "durationUnit$subexpression$1",
                "symbols": [
                    "durationUnit$subexpression$1$subexpression$8"
                ]
            },
            {
                "name": "durationUnit",
                "symbols": [
                    "durationUnit$subexpression$1"
                ],
                "postprocess": (d)=>d[0][0]
            },
            {
                "name": "durationUnitSingular$subexpression$1$subexpression$1",
                "symbols": [
                    /[mM]/,
                    /[iI]/,
                    /[lL]/,
                    /[lL]/,
                    /[iI]/,
                    /[sS]/,
                    /[eE]/,
                    /[cC]/,
                    /[oO]/,
                    /[nN]/,
                    /[dD]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "durationUnitSingular$subexpression$1",
                "symbols": [
                    "durationUnitSingular$subexpression$1$subexpression$1"
                ]
            },
            {
                "name": "durationUnitSingular$subexpression$1$subexpression$2",
                "symbols": [
                    /[sS]/,
                    /[eE]/,
                    /[cC]/,
                    /[oO]/,
                    /[nN]/,
                    /[dD]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "durationUnitSingular$subexpression$1",
                "symbols": [
                    "durationUnitSingular$subexpression$1$subexpression$2"
                ]
            },
            {
                "name": "durationUnitSingular$subexpression$1$subexpression$3",
                "symbols": [
                    /[mM]/,
                    /[iI]/,
                    /[nN]/,
                    /[uU]/,
                    /[tT]/,
                    /[eE]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "durationUnitSingular$subexpression$1",
                "symbols": [
                    "durationUnitSingular$subexpression$1$subexpression$3"
                ]
            },
            {
                "name": "durationUnitSingular$subexpression$1$subexpression$4",
                "symbols": [
                    /[hH]/,
                    /[oO]/,
                    /[uU]/,
                    /[rR]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "durationUnitSingular$subexpression$1",
                "symbols": [
                    "durationUnitSingular$subexpression$1$subexpression$4"
                ]
            },
            {
                "name": "durationUnitSingular$subexpression$1$subexpression$5",
                "symbols": [
                    /[dD]/,
                    /[aA]/,
                    /[yY]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "durationUnitSingular$subexpression$1",
                "symbols": [
                    "durationUnitSingular$subexpression$1$subexpression$5"
                ]
            },
            {
                "name": "durationUnitSingular$subexpression$1$subexpression$6",
                "symbols": [
                    /[wW]/,
                    /[eE]/,
                    /[eE]/,
                    /[kK]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "durationUnitSingular$subexpression$1",
                "symbols": [
                    "durationUnitSingular$subexpression$1$subexpression$6"
                ]
            },
            {
                "name": "durationUnitSingular$subexpression$1$subexpression$7",
                "symbols": [
                    /[mM]/,
                    /[oO]/,
                    /[nN]/,
                    /[tT]/,
                    /[hH]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "durationUnitSingular$subexpression$1",
                "symbols": [
                    "durationUnitSingular$subexpression$1$subexpression$7"
                ]
            },
            {
                "name": "durationUnitSingular$subexpression$1$subexpression$8",
                "symbols": [
                    /[yY]/,
                    /[eE]/,
                    /[aA]/,
                    /[rR]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "durationUnitSingular$subexpression$1",
                "symbols": [
                    "durationUnitSingular$subexpression$1$subexpression$8"
                ]
            },
            {
                "name": "durationUnitSingular",
                "symbols": [
                    "durationUnitSingular$subexpression$1"
                ],
                "postprocess": (d)=>d[0][0]
            },
            {
                "name": "dateTime",
                "symbols": [
                    "date",
                    "__",
                    "time"
                ],
                "postprocess": (d)=>op("dateTime", d, {
                        date: d[0],
                        time: d[2]
                    })
            },
            {
                "name": "dateTime",
                "symbols": [
                    "time",
                    "__",
                    "date"
                ],
                "postprocess": (d)=>op("dateTime", d, {
                        date: d[2],
                        time: d[0]
                    })
            },
            {
                "name": "dateTime",
                "symbols": [
                    "date"
                ],
                "postprocess": (d)=>op("dateTime", d, {
                        date: d[0]
                    })
            },
            {
                "name": "date",
                "symbols": [
                    "int",
                    {
                        "literal": "."
                    },
                    "int",
                    {
                        "literal": "."
                    },
                    "int"
                ],
                "postprocess": (d)=>op("date", d, {
                        day: d[0],
                        month: d[2],
                        year: d[4]
                    })
            },
            {
                "name": "time$ebnf$1$subexpression$1$subexpression$1",
                "symbols": [
                    /[aA]/,
                    /[mM]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "time$ebnf$1$subexpression$1",
                "symbols": [
                    "time$ebnf$1$subexpression$1$subexpression$1"
                ]
            },
            {
                "name": "time$ebnf$1$subexpression$1$subexpression$2",
                "symbols": [
                    /[pP]/,
                    /[mM]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "time$ebnf$1$subexpression$1",
                "symbols": [
                    "time$ebnf$1$subexpression$1$subexpression$2"
                ]
            },
            {
                "name": "time$ebnf$1",
                "symbols": [
                    "time$ebnf$1$subexpression$1"
                ],
                "postprocess": id
            },
            {
                "name": "time$ebnf$1",
                "symbols": [],
                "postprocess": function(d) {
                    return null;
                }
            },
            {
                "name": "time",
                "symbols": [
                    "int",
                    {
                        "literal": ":"
                    },
                    "int",
                    {
                        "literal": ":"
                    },
                    "int",
                    "_",
                    "time$ebnf$1"
                ],
                "postprocess": (d)=>{
                    var _d$;
                    return op("time", d, {
                        hours: d[0],
                        minutes: d[2],
                        seconds: d[4],
                        ampm: (_d$ = d[6]) === null || _d$ === void 0 ? void 0 : _d$[0]
                    });
                }
            },
            {
                "name": "time$ebnf$2$subexpression$1$subexpression$1",
                "symbols": [
                    /[aA]/,
                    /[mM]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "time$ebnf$2$subexpression$1",
                "symbols": [
                    "time$ebnf$2$subexpression$1$subexpression$1"
                ]
            },
            {
                "name": "time$ebnf$2$subexpression$1$subexpression$2",
                "symbols": [
                    /[pP]/,
                    /[mM]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "time$ebnf$2$subexpression$1",
                "symbols": [
                    "time$ebnf$2$subexpression$1$subexpression$2"
                ]
            },
            {
                "name": "time$ebnf$2",
                "symbols": [
                    "time$ebnf$2$subexpression$1"
                ],
                "postprocess": id
            },
            {
                "name": "time$ebnf$2",
                "symbols": [],
                "postprocess": function(d) {
                    return null;
                }
            },
            {
                "name": "time",
                "symbols": [
                    "int",
                    {
                        "literal": ":"
                    },
                    "int",
                    "_",
                    "time$ebnf$2"
                ],
                "postprocess": (d)=>{
                    var _d$2;
                    return op("time", d, {
                        hours: d[0],
                        minutes: d[2],
                        seconds: 0,
                        ampm: (_d$2 = d[4]) === null || _d$2 === void 0 ? void 0 : _d$2[0]
                    });
                }
            },
            {
                "name": "time$subexpression$1$subexpression$1",
                "symbols": [
                    /[aA]/,
                    /[mM]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "time$subexpression$1",
                "symbols": [
                    "time$subexpression$1$subexpression$1"
                ]
            },
            {
                "name": "time$subexpression$1$subexpression$2",
                "symbols": [
                    /[pP]/,
                    /[mM]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "time$subexpression$1",
                "symbols": [
                    "time$subexpression$1$subexpression$2"
                ]
            },
            {
                "name": "time",
                "symbols": [
                    "int",
                    "_",
                    "time$subexpression$1"
                ],
                "postprocess": (d)=>{
                    var _d$3;
                    return op("time", d, {
                        hours: d[0],
                        minutes: 0,
                        seconds: 0,
                        ampm: (_d$3 = d[2]) === null || _d$3 === void 0 ? void 0 : _d$3[0]
                    });
                }
            },
            {
                "name": "percent",
                "symbols": [
                    "int",
                    "_",
                    {
                        "literal": "%"
                    }
                ],
                "postprocess": (d)=>op("percent", d, {
                        val: d[0]
                    })
            },
            {
                "name": "float$ebnf$1",
                "symbols": []
            },
            {
                "name": "float$ebnf$1",
                "symbols": [
                    "float$ebnf$1",
                    /[-]/
                ],
                "postprocess": function arrpush(d) {
                    return d[0].concat([
                        d[1]
                    ]);
                }
            },
            {
                "name": "float",
                "symbols": [
                    "float$ebnf$1",
                    "int",
                    {
                        "literal": "."
                    },
                    "int"
                ],
                "postprocess": (d)=>op("number", [
                        d.join("")
                    ], {
                        val: d.join("")
                    })
            },
            {
                "name": "float$ebnf$2",
                "symbols": []
            },
            {
                "name": "float$ebnf$2",
                "symbols": [
                    "float$ebnf$2",
                    /[-]/
                ],
                "postprocess": function arrpush(d) {
                    return d[0].concat([
                        d[1]
                    ]);
                }
            },
            {
                "name": "float",
                "symbols": [
                    "float$ebnf$2",
                    "int"
                ],
                "postprocess": (d)=>op("number", [
                        d.join("")
                    ], {
                        val: d.join("")
                    })
            },
            {
                "name": "int$ebnf$1",
                "symbols": [
                    /[0-9]/
                ]
            },
            {
                "name": "int$ebnf$1",
                "symbols": [
                    "int$ebnf$1",
                    /[0-9]/
                ],
                "postprocess": function arrpush(d) {
                    return d[0].concat([
                        d[1]
                    ]);
                }
            },
            {
                "name": "int",
                "symbols": [
                    "int$ebnf$1"
                ],
                "postprocess": (d)=>d[0].join("")
            },
            {
                "name": "text",
                "symbols": [
                    {
                        "literal": '"'
                    },
                    "quotedString",
                    {
                        "literal": '"'
                    }
                ],
                "postprocess": (d)=>op("quoteText", d, {
                        string: d[1]
                    })
            },
            {
                "name": "text",
                "symbols": [
                    "string"
                ],
                "postprocess": (d)=>op("text", d, {
                        string: d[0]
                    })
            },
            {
                "name": "ref",
                "symbols": [
                    {
                        "literal": '"'
                    },
                    "quotedString",
                    {
                        "literal": '"'
                    }
                ],
                "postprocess": (d)=>op("quoteText", d, {
                        string: d[1]
                    })
            },
            {
                "name": "ref",
                "symbols": [
                    "refString"
                ],
                "postprocess": (d)=>op("text", d, {
                        string: d[0]
                    })
            },
            {
                "name": "string$subexpression$1$subexpression$1$ebnf$1",
                "symbols": [
                    /[0-9]/
                ]
            },
            {
                "name": "string$subexpression$1$subexpression$1$ebnf$1",
                "symbols": [
                    "string$subexpression$1$subexpression$1$ebnf$1",
                    /[0-9]/
                ],
                "postprocess": function arrpush(d) {
                    return d[0].concat([
                        d[1]
                    ]);
                }
            },
            {
                "name": "string$subexpression$1$subexpression$1",
                "symbols": [
                    "string$subexpression$1$subexpression$1$ebnf$1",
                    /[a-zA-Z_]/
                ]
            },
            {
                "name": "string$subexpression$1",
                "symbols": [
                    "string$subexpression$1$subexpression$1"
                ]
            },
            {
                "name": "string$subexpression$1",
                "symbols": [
                    /[a-zA-Z_]/
                ]
            },
            {
                "name": "string$ebnf$1",
                "symbols": []
            },
            {
                "name": "string$ebnf$1",
                "symbols": [
                    "string$ebnf$1",
                    /[a-zA-Z_0-9]/
                ],
                "postprocess": function arrpush(d) {
                    return d[0].concat([
                        d[1]
                    ]);
                }
            },
            {
                "name": "string",
                "symbols": [
                    "string$subexpression$1",
                    "string$ebnf$1"
                ],
                "postprocess": (d)=>d.toString().replace(/,/g, "")
            },
            {
                "name": "quotedString$ebnf$1",
                "symbols": [
                    /[a-zA-Z0-9\s.,\/?:;\[\]+=\-_~!@#$%^&*()]/
                ]
            },
            {
                "name": "quotedString$ebnf$1",
                "symbols": [
                    "quotedString$ebnf$1",
                    /[a-zA-Z0-9\s.,\/?:;\[\]+=\-_~!@#$%^&*()]/
                ],
                "postprocess": function arrpush(d) {
                    return d[0].concat([
                        d[1]
                    ]);
                }
            },
            {
                "name": "quotedString",
                "symbols": [
                    "quotedString$ebnf$1"
                ],
                "postprocess": (d)=>d[0].join("")
            },
            {
                "name": "refString$ebnf$1",
                "symbols": [
                    /[a-zA-Z_0-9:]/
                ]
            },
            {
                "name": "refString$ebnf$1",
                "symbols": [
                    "refString$ebnf$1",
                    /[a-zA-Z_0-9:]/
                ],
                "postprocess": function arrpush(d) {
                    return d[0].concat([
                        d[1]
                    ]);
                }
            },
            {
                "name": "refString",
                "symbols": [
                    "refString$ebnf$1"
                ],
                "postprocess": (d)=>d[0].join("")
            },
            {
                "name": "_$ebnf$1",
                "symbols": []
            },
            {
                "name": "_$ebnf$1",
                "symbols": [
                    "_$ebnf$1",
                    /[\s]/
                ],
                "postprocess": function arrpush(d) {
                    return d[0].concat([
                        d[1]
                    ]);
                }
            },
            {
                "name": "_",
                "symbols": [
                    "_$ebnf$1"
                ],
                "postprocess": function(d) {
                    return d[0].join("");
                }
            },
            {
                "name": "__$ebnf$1",
                "symbols": [
                    /[\s]/
                ]
            },
            {
                "name": "__$ebnf$1",
                "symbols": [
                    "__$ebnf$1",
                    /[\s]/
                ],
                "postprocess": function arrpush(d) {
                    return d[0].concat([
                        d[1]
                    ]);
                }
            },
            {
                "name": "__",
                "symbols": [
                    "__$ebnf$1"
                ],
                "postprocess": function(d) {
                    return d[0].join("");
                }
            }
        ],
        ParserStart: "value"
    };
    if (typeof module.exports !== "undefined") return grammar;
    else return grammar;
}

});
parcelRegister("hcUu8", function(module, exports) {

$parcel$export(module.exports, "FormulaNode", function () { return $c86f5f66c5c53d2c$export$6c22c9de3c5987ee; });

var $8IBRa = parcelRequire("8IBRa");

var $f4n1H = parcelRequire("f4n1H");
const $c86f5f66c5c53d2c$export$6c22c9de3c5987ee = (type, inputs, matchString, contextRef)=>{
    var _value$dependencies, _value$dependencies2;
    let value, dependencies;
    try {
        value = (0, $8IBRa.Operations)[type](inputs, contextRef);
    } catch (err) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($f4n1H))).error(err)) console.error(err);
        value = err;
    }
    if (!((_value$dependencies = value.dependencies) !== null && _value$dependencies !== void 0 && _value$dependencies.size)) {
        let depArray = [];
        Object.values(inputs).forEach((i)=>{
            (i === null || i === void 0 ? void 0 : i.dependencies) && depArray.push(...i.dependencies);
        });
        dependencies = new Map(depArray);
    }
    const node = {
        op: type,
        params: inputs,
        matchString: matchString,
        ...value,
        dependencies: (_value$dependencies2 = value.dependencies) !== null && _value$dependencies2 !== void 0 && _value$dependencies2.size ? value.dependencies : dependencies
    };
    Object.values(inputs).forEach((i)=>(0, (/*@__PURE__*/$parcel$interopDefault($f4n1H))).plainObject(i) && (i.parent = node));
    return node;
};

});
parcelRegister("8IBRa", function(module, exports) {

$parcel$export(module.exports, "Operations", function () { return $658fcc4a47b96efb$export$3d72bd1ae0aee044; });

var $5j0Eu = parcelRequire("5j0Eu");

var $8wxap = parcelRequire("8wxap");

var $afJLg = parcelRequire("afJLg");

var $3P00J = parcelRequire("3P00J");

var $9LwTZ = parcelRequire("9LwTZ");

var $a9jR0 = parcelRequire("a9jR0");

var $la77q = parcelRequire("la77q");

var $eCEen = parcelRequire("eCEen");

var $5MuRT = parcelRequire("5MuRT");

var $8dH53 = parcelRequire("8dH53");

var $b32Vb = parcelRequire("b32Vb");

var $cDrTG = parcelRequire("cDrTG");

var $iPzOH = parcelRequire("iPzOH");

var $cgs1V = parcelRequire("cgs1V");

var $1vY7H = parcelRequire("1vY7H");

var $5XBic = parcelRequire("5XBic");

var $lvYd0 = parcelRequire("lvYd0");

var $iJqrE = parcelRequire("iJqrE");

var $k9Wiq = parcelRequire("k9Wiq");

var $kqlKD = parcelRequire("kqlKD");

var $8dNEn = parcelRequire("8dNEn");

var $dY3wj = parcelRequire("dY3wj");

var $83KHZ = parcelRequire("83KHZ");

var $4LOPH = parcelRequire("4LOPH");

var $995mg = parcelRequire("995mg");

var $kUPVi = parcelRequire("kUPVi");

var $6GZGo = parcelRequire("6GZGo");

var $1CFC5 = parcelRequire("1CFC5");

var $lLAF8 = parcelRequire("lLAF8");

var $gi6jc = parcelRequire("gi6jc");
let $658fcc4a47b96efb$export$3d72bd1ae0aee044 = {
    array: (0, $5j0Eu.default),
    context: (0, $8wxap.default),
    date: (0, $afJLg.default),
    dateTime: (0, $3P00J.default),
    duration: (0, $9LwTZ.default),
    number: (0, $a9jR0.default),
    method: (0, $la77q.default),
    property: (0, $eCEen.default),
    percent: (0, $5MuRT.default),
    quoteText: (0, $8dH53.default),
    range: (0, $b32Vb.default),
    text: (0, $cgs1V.default),
    time: (0, $1vY7H.default),
    add: (0, $5XBic.default),
    and: (0, $lvYd0.default),
    divide: (0, $iJqrE.default),
    equal: (0, $k9Wiq.default),
    function: (0, $kqlKD.default),
    greaterThan: (0, $8dNEn.default),
    greaterThanEqual: (0, $dY3wj.default),
    ifElse: (0, $83KHZ.default),
    lessThan: (0, $4LOPH.default),
    lessThanEqual: (0, $995mg.default),
    multiply: (0, $kUPVi.default),
    not: (0, $6GZGo.default),
    or: (0, $1CFC5.default),
    power: (0, $lLAF8.default),
    subtract: (0, $gi6jc.default),
    atRef: (0, $cDrTG.default),
    hashRef: (0, $iPzOH.default)
};

});
parcelRegister("5j0Eu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3dcf3b923be1b6ae$export$2e2bcd8739ae039; });
var $3dcf3b923be1b6ae$export$2e2bcd8739ae039 = ({ array: array }, context)=>{
    return {
        type: "array",
        value: array
    };
};

});

parcelRegister("8wxap", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $634b0a2964e52c5f$export$2e2bcd8739ae039; });

var $LvEEw = parcelRequire("LvEEw");
var $634b0a2964e52c5f$export$2e2bcd8739ae039 = (inputs, context)=>{
    if (!context) throw {
        value: "No context provided",
        type: "error",
        dependencies: []
    };
    const contextObj = (0, $LvEEw.getContextReferenceObject)(context);
    return {
        type: contextObj.type,
        value: contextObj,
        primitive: true
    };
};

});

parcelRegister("3P00J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c8624af09406f37$export$2e2bcd8739ae039; });

var $7CaHe = parcelRequire("7CaHe");
var $2c8624af09406f37$export$2e2bcd8739ae039 = ({ date: date, time: time }, context)=>{
    return {
        type: "dateTime",
        value: time !== null && time !== void 0 && time.value ? (0, $7CaHe.addDurationToDate)(date.value, time.value).getTime() : date.value,
        primitive: true
    };
};

});

parcelRegister("9LwTZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71c2067ca4fddee5$export$2e2bcd8739ae039; });
var $71c2067ca4fddee5$export$2e2bcd8739ae039 = ({ amount: amount, unit: unit }, context)=>{
    return {
        type: "duration",
        value: Object.fromEntries([
            [
                unit,
                amount.value
            ]
        ]),
        primitive: true
    };
};

});

parcelRegister("a9jR0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $763a25397e3ad500$export$2e2bcd8739ae039; });
var $763a25397e3ad500$export$2e2bcd8739ae039 = ({ val: val })=>{
    return {
        type: "number",
        value: parseFloat(val),
        primitive: true
    };
};

});

parcelRegister("la77q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6800dc42543e47c$export$2e2bcd8739ae039; });

var $9Nhon = parcelRequire("9Nhon");
var $f6800dc42543e47c$export$2e2bcd8739ae039 = ({ object: object, method: method, args: args }, context)=>{
    if (object.type !== "array") {
        var _Methods$object$type, _Methods$object$type2, _Methods$object$type3;
        if (!((_Methods$object$type = (0, $9Nhon.Methods)[object.type]) !== null && _Methods$object$type !== void 0 && _Methods$object$type[method])) throw {
            value: `${object.type} does not have method ${method}`,
            type: "error"
        };
        return (_Methods$object$type2 = (0, $9Nhon.Methods)[object.type]) === null || _Methods$object$type2 === void 0 ? void 0 : (_Methods$object$type3 = _Methods$object$type2[method]) === null || _Methods$object$type3 === void 0 ? void 0 : _Methods$object$type3.call(_Methods$object$type2, object, args, context);
    } else {
        var _Methods$object$value;
        if (!((_Methods$object$value = (0, $9Nhon.Methods)[object.value[0].type]) !== null && _Methods$object$value !== void 0 && _Methods$object$value[method])) throw {
            value: `${object.type} does not have method ${method}`,
            type: "error"
        };
        const methArray = object.value.map((ob)=>{
            var _Methods$ob$type, _Methods$ob$type$meth;
            return (_Methods$ob$type = (0, $9Nhon.Methods)[ob.type]) === null || _Methods$ob$type === void 0 ? void 0 : (_Methods$ob$type$meth = _Methods$ob$type[method]) === null || _Methods$ob$type$meth === void 0 ? void 0 : _Methods$ob$type$meth.call(_Methods$ob$type, ob, args, context);
        });
        return {
            type: "array",
            value: methArray
        };
    }
};

});

parcelRegister("eCEen", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa53d2547e92c762$export$2e2bcd8739ae039; });

var $2Fel1 = parcelRequire("2Fel1");
var $aa53d2547e92c762$export$2e2bcd8739ae039 = ({ object: object, prop: prop }, context)=>{
    if (object.type !== "array") {
        var _Properties$object$ty;
        let val = (_Properties$object$ty = (0, $2Fel1.Properties)[object.type]) === null || _Properties$object$ty === void 0 ? void 0 : _Properties$object$ty.call((0, $2Fel1.Properties), prop, object, context);
        if (!val) throw {
            value: `${object.type} does not have property ${prop}`,
            type: "error"
        };
        return val;
    } else {
        let propArray = [];
        object.value.forEach((ob)=>{
            var _Properties$ob$type;
            let propVal = (_Properties$ob$type = (0, $2Fel1.Properties)[ob.type]) === null || _Properties$ob$type === void 0 ? void 0 : _Properties$ob$type.call((0, $2Fel1.Properties), prop, ob, context);
            if (propVal && propVal.type === "array") propArray.push(...propVal.value);
            else if (propVal) propArray.push(propVal);
        });
        if (propArray.length && !propArray[0]) throw {
            value: `${object.value[0].type} does not have property ${prop}`,
            type: "error"
        };
        let dependencies = new Map();
        propArray.forEach((p)=>[
                ...p.dependencies || []
            ].forEach(([dId, dData])=>{
                const existingDepData = dependencies.get(dId);
                dependencies.set(dId, {
                    ...existingDepData || {},
                    ...dData,
                    inherited: existingDepData && !existingDepData.inherited ? existingDepData.inherited : dData.inherited
                });
            }));
        return {
            type: "array",
            value: propArray,
            dependencies: dependencies
        };
    }
};

});

parcelRegister("5MuRT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43596141e2165cac$export$2e2bcd8739ae039; });
var $43596141e2165cac$export$2e2bcd8739ae039 = ({ val: val }, context)=>{
    return {
        type: "number",
        value: parseFloat(val) / 100,
        primitive: true
    };
};

});

parcelRegister("8dH53", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fc0f48c0306020e$export$2e2bcd8739ae039; });
var $5fc0f48c0306020e$export$2e2bcd8739ae039 = ({ string: string }, context)=>{
    return {
        type: "text",
        value: string
    };
};

});

parcelRegister("b32Vb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80b23da1b2949a21$export$2e2bcd8739ae039; });
var $80b23da1b2949a21$export$2e2bcd8739ae039 = ({ start: start, end: end }, context)=>{
    return {
        type: start.type,
        value: {
            start: start,
            end: end
        }
    };
};

});

parcelRegister("cDrTG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $932ec45c39b872f5$export$2e2bcd8739ae039; });

var $LvEEw = parcelRequire("LvEEw");
var $932ec45c39b872f5$export$2e2bcd8739ae039 = ({ ref: ref }, context)=>{
    const refObj = (0, $LvEEw.getAtReferenceObject)(ref.value, context);
    if (!refObj) throw {
        value: "No object found with this reference.",
        type: "error",
        dependencies: new Map([
            ...ref.dependencies
        ])
    };
    return {
        type: refObj.type,
        value: refObj,
        primitive: true
    };
};

});

parcelRegister("iPzOH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db58c5d9240814cd$export$2e2bcd8739ae039; });

var $LvEEw = parcelRequire("LvEEw");
var $db58c5d9240814cd$export$2e2bcd8739ae039 = ({ ref: ref }, context)=>{
    const refObj = (0, $LvEEw.getHashReferenceObject)(ref.value, context);
    if (!refObj) throw {
        value: "No object found with this reference.",
        type: "error",
        dependencies: new Map([
            ...ref.dependencies
        ])
    };
    return {
        type: refObj.type,
        value: refObj,
        primitive: true
    };
};

});

parcelRegister("cgs1V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8edcb8d569930ee1$export$2e2bcd8739ae039; });

var $5vW7M = parcelRequire("5vW7M");
var $8edcb8d569930ee1$export$2e2bcd8739ae039 = ({ string: string })=>{
    var _Constants$string;
    return ((_Constants$string = (0, $5vW7M.Constants)[string]) === null || _Constants$string === void 0 ? void 0 : _Constants$string.call((0, $5vW7M.Constants))) || {
        type: "text",
        value: string,
        primitive: true
    };
};

});
parcelRegister("5vW7M", function(module, exports) {

$parcel$export(module.exports, "Constants", function () { return $403cef4cb19d0382$export$a002182e51710d39; });
$parcel$export(module.exports, "addConstants", function () { return $403cef4cb19d0382$export$f08b431b616b78c4; });
let $403cef4cb19d0382$export$a002182e51710d39 = {
    true: ()=>({
            type: "logic",
            value: true
        }),
    false: ()=>({
            type: "logic",
            value: false
        }),
    pi: ()=>({
            type: "number",
            value: Math.PI
        }),
    e: ()=>({
            type: "number",
            value: Math.E
        }),
    millisecond: ()=>({
            type: "duration",
            value: {
                milliseconds: 1
            }
        }),
    second: ()=>({
            type: "duration",
            value: {
                seconds: 1
            }
        }),
    minute: ()=>({
            type: "duration",
            value: {
                minutes: 1
            }
        }),
    hour: ()=>({
            type: "duration",
            value: {
                hours: 1
            }
        }),
    day: ()=>({
            type: "duration",
            value: {
                days: 1
            }
        }),
    week: ()=>({
            type: "duration",
            value: {
                weeks: 1
            }
        }),
    month: ()=>({
            type: "duration",
            value: {
                months: 1
            }
        }),
    year: ()=>({
            type: "duration",
            value: {
                years: 1
            }
        }),
    now: ()=>({
            type: "dateTime",
            value: Date.now(),
            primitive: true
        }),
    currentDate: ()=>({
            type: "dateTime",
            value: Date.now(),
            primitive: true
        })
};
const $403cef4cb19d0382$export$f08b431b616b78c4 = (newConsts)=>{
    $403cef4cb19d0382$export$a002182e51710d39 = {
        ...$403cef4cb19d0382$export$a002182e51710d39,
        ...newConsts
    };
};

});


parcelRegister("1vY7H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11a752e55813e2fe$export$2e2bcd8739ae039; });
var $11a752e55813e2fe$export$2e2bcd8739ae039 = ({ hours: hours, minutes: minutes, seconds: seconds, ampm: ampm }, context)=>{
    if (ampm === "pm" && hours < 12) hours += 12;
    return {
        type: "date",
        value: {
            hours: hours,
            minutes: minutes,
            seconds: seconds
        },
        primitive: true
    };
};

});

parcelRegister("5XBic", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $456f63f59dc503d9$export$2e2bcd8739ae039; });

var $7CaHe = parcelRequire("7CaHe");
var $456f63f59dc503d9$export$2e2bcd8739ae039 = ({ left: left, right: right }, context)=>{
    const adderId = left.type + right.type;
    if (!$456f63f59dc503d9$var$adderValues[adderId]) throw {
        value: `Cannot add a ${left.type} to a ${right.type}.`,
        type: "error",
        dependencies: []
    };
    return {
        type: $456f63f59dc503d9$var$adderTypes[adderId],
        value: $456f63f59dc503d9$var$adderValues[adderId](left, right)
    };
};
const $456f63f59dc503d9$var$adderTypes = {
    numbernumber: "number",
    texttext: "text",
    textnumber: "text",
    numbertext: "text",
    dateTimeduration: "dateTime",
    durationduration: "duration",
    raterate: "rate"
};
const $456f63f59dc503d9$var$adderValues = {
    numbernumber: (left, right)=>left.value + right.value,
    texttext: (left, right)=>left.value + right.value,
    textnumber: (left, right)=>left.value + right.value,
    numbertext: (left, right)=>left.value + right.value,
    dateTimeduration: (left, right)=>(0, $7CaHe.addDurationToDate)(left.value, right.value).getTime(),
    durationduration: (left, right)=>(0, $7CaHe.simplifyDuration)((0, $7CaHe.addDurations)(left.value, right.value)),
    raterate: (left, right)=>(0, $7CaHe.simplifyRate)((0, $7CaHe.addRates)(left.value, right.value))
};

});

parcelRegister("lvYd0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa9b327064017001$export$2e2bcd8739ae039; });
var $fa9b327064017001$export$2e2bcd8739ae039 = ({ left: left, right: right }, context)=>{
    const selectedVal = left.value ? right : left;
    return {
        type: selectedVal.type,
        value: selectedVal.value
    };
};

});

parcelRegister("iJqrE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da30f16085758b52$export$2e2bcd8739ae039; });

var $7CaHe = parcelRequire("7CaHe");

var $gdz3N = parcelRequire("gdz3N");
var $da30f16085758b52$export$2e2bcd8739ae039 = ({ left: left, right: right }, context)=>{
    const dividerId = left.type + right.type;
    if (!$da30f16085758b52$var$dividerValues[dividerId]) throw {
        value: `Cannot divide a ${left.type} to a ${right.type}.`,
        type: "error"
    };
    if ((0, $gdz3N.isZeroValue)[right.type](right.value)) throw {
        value: `Cannot divide by zero.`,
        type: "error"
    };
    return {
        type: $da30f16085758b52$var$dividerTypes[dividerId],
        value: $da30f16085758b52$var$dividerValues[dividerId](left, right)
    };
};
const $da30f16085758b52$var$dividerTypes = {
    numbernumber: "number",
    numberduration: "rate",
    durationnumber: "duration",
    durationduration: "number",
    numberrate: "duration",
    ratenumber: "rate",
    raterate: "number",
    powerDurationduration: "duration"
};
const $da30f16085758b52$var$dividerValues = {
    numbernumber: (left, right)=>left.value / right.value,
    numberduration: (left, right)=>{
        return (0, $7CaHe.simplifyRate)({
            amount: left.value,
            per: right.value
        });
    },
    durationnumber: (left, right)=>(0, $7CaHe.simplifyDuration)((0, $7CaHe.divideDurationBy)(left.value, right.value)),
    durationduration: (left, right)=>{
        return (0, $7CaHe.divideDurations)(left.value, right.value);
    },
    numberrate: (left, right)=>{
        return (0, $7CaHe.divideNumberByRate)(left.value, right.value);
    },
    ratenumber: (left, right)=>{
        return (0, $7CaHe.divideRateBy)(left.value, right.value);
    },
    raterate: (left, right)=>{
        return (0, $7CaHe.divideRates)(left.value, right.value);
    },
    powerDurationduration: (left, right)=>{
        return (0, $7CaHe.simplifyDuration)((0, $7CaHe.dividePowerDurationByDuration)(left.value, right.value));
    }
};

});
parcelRegister("gdz3N", function(module, exports) {

$parcel$export(module.exports, "adjustFormulaToValue", function () { return $bce90e7954761cf2$export$506457a8beabc4ae; });
$parcel$export(module.exports, "isZeroValue", function () { return $bce90e7954761cf2$export$634c47c3257423c1; });
$parcel$export(module.exports, "formulaDefaults", function () { return $bce90e7954761cf2$export$7aaf19950eefdf1c; });

var $F76En = parcelRequire("F76En");

var $4hBm1 = parcelRequire("4hBm1");
parcelRequire("7CaHe");
const $bce90e7954761cf2$export$506457a8beabc4ae = (ast, newValue, ref)=>{
    if (!(ast.type === newValue.type)) return;
    if (!$bce90e7954761cf2$export$412b44c694f80a56.includes(ast.type)) return;
    if (ast.primitive && ast.type === newValue.type) return $bce90e7954761cf2$export$a902250547926f80[newValue.type](newValue.value);
    else {
        var _isZeroValue$diffAst$;
        let nodes = [];
        let newFormula = null;
        const diffAst = (0, $F76En.parseFormula)(`(${$bce90e7954761cf2$export$a902250547926f80[newValue.type](newValue.value)}) - (${ast.matchString})`, ref);
        if ((_isZeroValue$diffAst$ = $bce90e7954761cf2$export$634c47c3257423c1[diffAst.type]) !== null && _isZeroValue$diffAst$ !== void 0 && _isZeroValue$diffAst$.call($bce90e7954761cf2$export$634c47c3257423c1, diffAst.value)) return ast.matchString;
        nodes.push(ast);
        while(nodes.length && !newFormula){
            // may be an issue with primitive string inputs
            const node = nodes.shift();
            if (node.primitive && node.type === diffAst.type) {
                var _node$parent;
                const invert = (node === null || node === void 0 ? void 0 : (_node$parent = node.parent) === null || _node$parent === void 0 ? void 0 : _node$parent.op) === "subtract";
                // node does not know if it's being subtracted resulting in bad calculations
                const adjustedVal = (0, $F76En.parseFormula)(`((${$bce90e7954761cf2$export$a902250547926f80[diffAst.type](diffAst.value)}) ${!invert ? "+" : "-"} (${node.matchString}))${invert ? "* -1" : ""}`, ref);
                newFormula = ast.matchString.replace(node.matchString, $bce90e7954761cf2$export$a902250547926f80[adjustedVal.type](adjustedVal.value)).replace("+ -", "- ").replace("- -", "+ ");
            }
            if (!newFormula && $bce90e7954761cf2$export$38839043d87f15bb(node.type, node.op)) nodes.push(...Object.values(node.params));
        }
        if (!newFormula && $bce90e7954761cf2$export$d0a5c90efda19e8c(ast.type, ast.op)) {
            let nodes = [];
            const scalerVal = (0, $F76En.parseFormula)(`(${$bce90e7954761cf2$export$a902250547926f80[newValue.type](newValue.value)}) / (${$bce90e7954761cf2$export$a902250547926f80[ast.type](ast.value)})`, ref);
            nodes.push(ast);
            while(nodes.length && !newFormula){
                // may be an issue with primitive string inputs
                const node = nodes.shift();
                if (node.primitive && $bce90e7954761cf2$export$f51d97000f83ee12.includes(node.type)) {
                    const scaledVal = (0, $F76En.parseFormula)(`(${node.matchString}) * (${$bce90e7954761cf2$export$a902250547926f80[scalerVal.type](scalerVal.value)})`, ref);
                    newFormula = ast.matchString.replace(node.matchString, $bce90e7954761cf2$export$a902250547926f80[scaledVal.type](scaledVal.value));
                }
                if (!newFormula && $bce90e7954761cf2$export$d0a5c90efda19e8c(node.type, node.op)) nodes.push(...Object.values(node.params));
            }
        }
        return newFormula || `${ast.matchString} + ${$bce90e7954761cf2$export$a902250547926f80[diffAst.type](diffAst.value)}`.replace("+ -", "- ");
    }
};
const $bce90e7954761cf2$export$a902250547926f80 = {
    text: (val)=>String(val),
    number: (val)=>String(val),
    dateTime: (val)=>{
        const date = new Date(val);
        if (date.getHours() || date.getMinutes() || date.getSeconds()) return (0, $4hBm1.format)(date, "dd.MM.yyyy HH:mm:ss");
        else return (0, $4hBm1.format)(date, "dd.MM.yyyy");
    },
    duration: (val)=>{
        const units = Object.keys(val)[0];
        return `${val[units]} ${units}`;
    },
    rate: (val)=>{
        return `${val.amount} / ${Object.keys(val.per)[0].slice(0, -1)}`;
    },
    task: (val)=>val.label,
    resource: (val)=>val.label,
    undefined: (val)=>"-",
    null: (val)=>"-"
};
const $bce90e7954761cf2$export$634c47c3257423c1 = {
    string: (val)=>null,
    number: (val)=>val === 0,
    dateTime: (val)=>val === 0,
    duration: (val)=>{
        const units = Object.keys(val)[0];
        return val[units] === 0;
    },
    rate: (val)=>val.amount === 0,
    task: (val)=>null,
    resource: (val)=>null
};
const $bce90e7954761cf2$export$38839043d87f15bb = (type, op)=>$bce90e7954761cf2$export$412b44c694f80a56.includes(type) && $bce90e7954761cf2$export$b4b14971105a4fb0.includes(op);
const $bce90e7954761cf2$export$412b44c694f80a56 = [
    "number",
    "dateTime",
    "duration",
    "rate"
];
const $bce90e7954761cf2$export$b4b14971105a4fb0 = [
    "add",
    "subtract"
];
const $bce90e7954761cf2$export$d0a5c90efda19e8c = (type, op)=>$bce90e7954761cf2$export$f51d97000f83ee12.includes(type) && $bce90e7954761cf2$export$33624ca114bff389.includes(op);
const $bce90e7954761cf2$export$f51d97000f83ee12 = [
    "number",
    "duration",
    "rate"
];
const $bce90e7954761cf2$export$33624ca114bff389 = [
    "divide",
    "multiply"
];
const $bce90e7954761cf2$export$c09fd095eb6d34d1 = (ref)=>{
    return /^[a-zA-Z_0-9]+$/.test(ref) ? ref : `"${ref}"`;
};
const $bce90e7954761cf2$export$7aaf19950eefdf1c = {
    string: (val)=>"",
    number: (val)=>"0",
    dateTime: (val)=>"",
    duration: (val)=>"0 days",
    rate: (val)=>"0 / hour",
    task: (val)=>"",
    resource: (val)=>""
};

});


parcelRegister("k9Wiq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ead1de4d32265530$export$2e2bcd8739ae039; });
var $ead1de4d32265530$export$2e2bcd8739ae039 = ({ left: left, right: right }, context)=>{
    return {
        type: "logic",
        value: left.value === right.value
    };
};

});

parcelRegister("kqlKD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ede71bae0ff20745$export$2e2bcd8739ae039; });

var $c3qWO = parcelRequire("c3qWO");
var $ede71bae0ff20745$export$2e2bcd8739ae039 = ({ funcName: funcName, args: args }, context)=>{
    var _args$;
    args = args.type === "array" ? args.value : [
        args
    ];
    const type = (_args$ = args[0]) === null || _args$ === void 0 ? void 0 : _args$.type;
    if (!(0, $c3qWO.Functions)[funcName]) throw {
        value: `Function ${funcName} does not exist`,
        type: "error"
    };
    if ((0, $c3qWO.Functions)[funcName] && !(0, $c3qWO.Functions)[funcName][type]) throw {
        value: `Cannot apply ${funcName} function to ${type} types.`,
        type: "error"
    };
    return (0, $c3qWO.Functions)[funcName][type](args, context);
};

});
parcelRegister("c3qWO", function(module, exports) {

$parcel$export(module.exports, "Functions", function () { return $8c6aab126421b73b$export$da780471809663e; });
$parcel$export(module.exports, "addFunctions", function () { return $8c6aab126421b73b$export$b09452532e358f46; });

var $eat5C = parcelRequire("eat5C");

var $7CaHe = parcelRequire("7CaHe");

var $2Jmdb = parcelRequire("2Jmdb");

var $4hBm1 = parcelRequire("4hBm1");
let $8c6aab126421b73b$export$da780471809663e = {
    abs: {
        number: (args, context)=>({
                type: args[0].type,
                value: Math.abs(args[0].value)
            })
    },
    round: {
        number: (args, context)=>({
                type: args[0].type,
                value: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).round(...args.map((a)=>a.value))
            })
    },
    max: {
        number: (args, context)=>({
                type: args[0].type,
                value: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).max(args.map((a)=>a.value).filter((v)=>v))
            }),
        dateTime: (args, context)=>({
                type: args[0].type,
                value: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).max(args.map((a)=>a.value).filter((v)=>v))
            }),
        duration: (args, context)=>({
                type: args[0].type,
                value: (0, $7CaHe.simplifyDuration)({
                    milliseconds: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).max(args.map((a)=>(0, $7CaHe.durationToUnit)(a.value, "milliseconds")).filter((v)=>v))
                })
            })
    },
    min: {
        number: (args, context)=>({
                type: args[0].type,
                value: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).min(args.map((a)=>a.value).filter((v)=>v))
            }),
        dateTime: (args, context)=>({
                type: args[0].type,
                value: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).min(args.map((a)=>a.value).filter((v)=>v))
            }),
        duration: (args, context)=>({
                type: args[0].type,
                value: (0, $7CaHe.simplifyDuration)({
                    milliseconds: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).min(args.map((a)=>(0, $7CaHe.durationToUnit)(a.value, "milliseconds")).filter((v)=>v))
                })
            })
    },
    sum: {
        number: (args, context)=>({
                type: args[0].type,
                value: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(args.map((a)=>a.value).filter((v)=>v))
            }),
        duration: (args, context)=>{
            return {
                type: args[0].type,
                value: (0, $7CaHe.simplifyDuration)({
                    milliseconds: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(args.map((a)=>(0, $7CaHe.durationToUnit)(a.value, "milliseconds")).filter((v)=>v))
                })
            };
        }
    },
    avg: {
        number: (args, context)=>({
                type: args[0].type,
                value: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).mean(args.map((a)=>a.value).filter((v)=>v))
            }),
        duration: (args, context)=>({
                type: args[0].type,
                value: (0, $7CaHe.simplifyDuration)({
                    milliseconds: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).mean(args.map((a)=>(0, $7CaHe.durationToUnit)(a.value, "milliseconds")).filter((v)=>v))
                })
            }),
        rate: (args, context)=>({
                type: args[0].type,
                value: (0, $7CaHe.simplifyRate)({
                    amount: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).mean(args.map((a)=>(0, $7CaHe.ratePerUnit)(a.value, "milliseconds").amount)),
                    per: {
                        milliseconds: 1
                    }
                })
            })
    },
    format: {
        number: (args, context)=>({
                type: "text",
                value: (0, (/*@__PURE__*/$parcel$interopDefault($2Jmdb)))(args[0].value).format(args[1].value)
            }),
        dateTime: (args, context)=>({
                type: "text",
                value: (0, $4hBm1.format)(args[0].value, args[1].value)
            })
    }
};
const $8c6aab126421b73b$export$b09452532e358f46 = (newConsts)=>{
    $8c6aab126421b73b$export$da780471809663e = {
        ...$8c6aab126421b73b$export$da780471809663e,
        ...newConsts
    };
};

});
parcelRegister("2Jmdb", function(module, exports) {
/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */ (function(global, factory) {
    if (typeof define === "function" && define.amd) define(factory);
    else if (0, module.exports) module.exports = factory();
    else global.numeral = factory();
})(module.exports, function() {
    /************************************
        Variables
    ************************************/ var numeral, _, VERSION = "2.0.6", formats = {}, locales = {}, defaults = {
        currentLocale: "en",
        zeroFormat: null,
        nullFormat: null,
        defaultFormat: "0,0",
        scalePercentBy100: true
    }, options = {
        currentLocale: defaults.currentLocale,
        zeroFormat: defaults.zeroFormat,
        nullFormat: defaults.nullFormat,
        defaultFormat: defaults.defaultFormat,
        scalePercentBy100: defaults.scalePercentBy100
    };
    /************************************
        Constructors
    ************************************/ // Numeral prototype object
    function Numeral(input, number) {
        this._input = input;
        this._value = number;
    }
    numeral = function(input) {
        var value, kind, unformatFunction, regexp;
        if (numeral.isNumeral(input)) value = input.value();
        else if (input === 0 || typeof input === "undefined") value = 0;
        else if (input === null || _.isNaN(input)) value = null;
        else if (typeof input === "string") {
            if (options.zeroFormat && input === options.zeroFormat) value = 0;
            else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, "").length) value = null;
            else {
                for(kind in formats){
                    regexp = typeof formats[kind].regexps.unformat === "function" ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;
                    if (regexp && input.match(regexp)) {
                        unformatFunction = formats[kind].unformat;
                        break;
                    }
                }
                unformatFunction = unformatFunction || numeral._.stringToNumber;
                value = unformatFunction(input);
            }
        } else value = Number(input) || null;
        return new Numeral(input, value);
    };
    // version number
    numeral.version = VERSION;
    // compare numeral object
    numeral.isNumeral = function(obj) {
        return obj instanceof Numeral;
    };
    // helper functions
    numeral._ = _ = {
        // formats numbers separators, decimals places, signs, abbreviations
        numberToFormat: function(value, format, roundingFunction) {
            var locale = locales[numeral.options.currentLocale], negP = false, optDec = false, leadingCount = 0, abbr = "", trillion = 1000000000000, billion = 1000000000, million = 1000000, thousand = 1000, decimal = "", neg = false, abbrForce, abs, min, max, power, int, precision, signed, thousands, output;
            // make sure we never format a null value
            value = value || 0;
            abs = Math.abs(value);
            // see if we should use parentheses for negative number or if we should prefix with a sign
            // if both are present we default to parentheses
            if (numeral._.includes(format, "(")) {
                negP = true;
                format = format.replace(/[\(|\)]/g, "");
            } else if (numeral._.includes(format, "+") || numeral._.includes(format, "-")) {
                signed = numeral._.includes(format, "+") ? format.indexOf("+") : value < 0 ? format.indexOf("-") : -1;
                format = format.replace(/[\+|\-]/g, "");
            }
            // see if abbreviation is wanted
            if (numeral._.includes(format, "a")) {
                abbrForce = format.match(/a(k|m|b|t)?/);
                abbrForce = abbrForce ? abbrForce[1] : false;
                // check for space before abbreviation
                if (numeral._.includes(format, " a")) abbr = " ";
                format = format.replace(new RegExp(abbr + "a[kmbt]?"), "");
                if (abs >= trillion && !abbrForce || abbrForce === "t") {
                    // trillion
                    abbr += locale.abbreviations.trillion;
                    value = value / trillion;
                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === "b") {
                    // billion
                    abbr += locale.abbreviations.billion;
                    value = value / billion;
                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === "m") {
                    // million
                    abbr += locale.abbreviations.million;
                    value = value / million;
                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === "k") {
                    // thousand
                    abbr += locale.abbreviations.thousand;
                    value = value / thousand;
                }
            }
            // check for optional decimals
            if (numeral._.includes(format, "[.]")) {
                optDec = true;
                format = format.replace("[.]", ".");
            }
            // break number and format
            int = value.toString().split(".")[0];
            precision = format.split(".")[1];
            thousands = format.indexOf(",");
            leadingCount = (format.split(".")[0].split(",")[0].match(/0/g) || []).length;
            if (precision) {
                if (numeral._.includes(precision, "[")) {
                    precision = precision.replace("]", "");
                    precision = precision.split("[");
                    decimal = numeral._.toFixed(value, precision[0].length + precision[1].length, roundingFunction, precision[1].length);
                } else decimal = numeral._.toFixed(value, precision.length, roundingFunction);
                int = decimal.split(".")[0];
                if (numeral._.includes(decimal, ".")) decimal = locale.delimiters.decimal + decimal.split(".")[1];
                else decimal = "";
                if (optDec && Number(decimal.slice(1)) === 0) decimal = "";
            } else int = numeral._.toFixed(value, 0, roundingFunction);
            // check abbreviation again after rounding
            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
                int = String(Number(int) / 1000);
                switch(abbr){
                    case locale.abbreviations.thousand:
                        abbr = locale.abbreviations.million;
                        break;
                    case locale.abbreviations.million:
                        abbr = locale.abbreviations.billion;
                        break;
                    case locale.abbreviations.billion:
                        abbr = locale.abbreviations.trillion;
                        break;
                }
            }
            // format number
            if (numeral._.includes(int, "-")) {
                int = int.slice(1);
                neg = true;
            }
            if (int.length < leadingCount) for(var i = leadingCount - int.length; i > 0; i--)int = "0" + int;
            if (thousands > -1) int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + locale.delimiters.thousands);
            if (format.indexOf(".") === 0) int = "";
            output = int + decimal + (abbr ? abbr : "");
            if (negP) output = (negP && neg ? "(" : "") + output + (negP && neg ? ")" : "");
            else {
                if (signed >= 0) output = signed === 0 ? (neg ? "-" : "+") + output : output + (neg ? "-" : "+");
                else if (neg) output = "-" + output;
            }
            return output;
        },
        // unformats numbers separators, decimals places, signs, abbreviations
        stringToNumber: function(string) {
            var locale = locales[options.currentLocale], stringOriginal = string, abbreviations = {
                thousand: 3,
                million: 6,
                billion: 9,
                trillion: 12
            }, abbreviation, value, i, regexp;
            if (options.zeroFormat && string === options.zeroFormat) value = 0;
            else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, "").length) value = null;
            else {
                value = 1;
                if (locale.delimiters.decimal !== ".") string = string.replace(/\./g, "").replace(locale.delimiters.decimal, ".");
                for(abbreviation in abbreviations){
                    regexp = new RegExp("[^a-zA-Z]" + locale.abbreviations[abbreviation] + "(?:\\)|(\\" + locale.currency.symbol + ")?(?:\\))?)?$");
                    if (stringOriginal.match(regexp)) {
                        value *= Math.pow(10, abbreviations[abbreviation]);
                        break;
                    }
                }
                // check for negative number
                value *= (string.split("-").length + Math.min(string.split("(").length - 1, string.split(")").length - 1)) % 2 ? 1 : -1;
                // remove non numbers
                string = string.replace(/[^0-9\.]+/g, "");
                value *= Number(string);
            }
            return value;
        },
        isNaN: function(value) {
            return typeof value === "number" && isNaN(value);
        },
        includes: function(string, search) {
            return string.indexOf(search) !== -1;
        },
        insert: function(string, subString, start) {
            return string.slice(0, start) + subString + string.slice(start);
        },
        reduce: function(array, callback /*, initialValue*/ ) {
            if (this === null) throw new TypeError("Array.prototype.reduce called on null or undefined");
            if (typeof callback !== "function") throw new TypeError(callback + " is not a function");
            var t = Object(array), len = t.length >>> 0, k = 0, value;
            if (arguments.length === 3) value = arguments[2];
            else {
                while(k < len && !(k in t))k++;
                if (k >= len) throw new TypeError("Reduce of empty array with no initial value");
                value = t[k++];
            }
            for(; k < len; k++)if (k in t) value = callback(value, t[k], k, t);
            return value;
        },
        /**
         * Computes the multiplier necessary to make x >= 1,
         * effectively eliminating miscalculations caused by
         * finite precision.
         */ multiplier: function(x) {
            var parts = x.toString().split(".");
            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
        },
        /**
         * Given a variable number of arguments, returns the maximum
         * multiplier that must be used to normalize an operation involving
         * all of them.
         */ correctionFactor: function() {
            var args = Array.prototype.slice.call(arguments);
            return args.reduce(function(accum, next) {
                var mn = _.multiplier(next);
                return accum > mn ? accum : mn;
            }, 1);
        },
        /**
         * Implementation of toFixed() that treats floats more like decimals
         *
         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
         * problems for accounting- and finance-related software.
         */ toFixed: function(value, maxDecimals, roundingFunction, optionals) {
            var splitValue = value.toString().split("."), minDecimals = maxDecimals - (optionals || 0), boundedPrecision, optionalsRegExp, power, output;
            // Use the smallest precision value possible to avoid errors from floating point representation
            if (splitValue.length === 2) boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
            else boundedPrecision = minDecimals;
            power = Math.pow(10, boundedPrecision);
            // Multiply up by precision, round accurately, then divide and use native toFixed():
            output = (roundingFunction(value + "e+" + boundedPrecision) / power).toFixed(boundedPrecision);
            if (optionals > maxDecimals - boundedPrecision) {
                optionalsRegExp = new RegExp("\\.?0{1," + (optionals - (maxDecimals - boundedPrecision)) + "}$");
                output = output.replace(optionalsRegExp, "");
            }
            return output;
        }
    };
    // avaliable options
    numeral.options = options;
    // avaliable formats
    numeral.formats = formats;
    // avaliable formats
    numeral.locales = locales;
    // This function sets the current locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    numeral.locale = function(key) {
        if (key) options.currentLocale = key.toLowerCase();
        return options.currentLocale;
    };
    // This function provides access to the loaded locale data.  If
    // no arguments are passed in, it will simply return the current
    // global locale object.
    numeral.localeData = function(key) {
        if (!key) return locales[options.currentLocale];
        key = key.toLowerCase();
        if (!locales[key]) throw new Error("Unknown locale : " + key);
        return locales[key];
    };
    numeral.reset = function() {
        for(var property in defaults)options[property] = defaults[property];
    };
    numeral.zeroFormat = function(format) {
        options.zeroFormat = typeof format === "string" ? format : null;
    };
    numeral.nullFormat = function(format) {
        options.nullFormat = typeof format === "string" ? format : null;
    };
    numeral.defaultFormat = function(format) {
        options.defaultFormat = typeof format === "string" ? format : "0.0";
    };
    numeral.register = function(type, name, format) {
        name = name.toLowerCase();
        if (this[type + "s"][name]) throw new TypeError(name + " " + type + " already registered.");
        this[type + "s"][name] = format;
        return format;
    };
    numeral.validate = function(val, culture) {
        var _decimalSep, _thousandSep, _currSymbol, _valArray, _abbrObj, _thousandRegEx, localeData, temp;
        //coerce val to string
        if (typeof val !== "string") {
            val += "";
            if (console.warn) console.warn("Numeral.js: Value is not string. It has been co-erced to: ", val);
        }
        //trim whitespaces from either sides
        val = val.trim();
        //if val is just digits return true
        if (!!val.match(/^\d+$/)) return true;
        //if val is empty return false
        if (val === "") return false;
        //get the decimal and thousands separator from numeral.localeData
        try {
            //check if the culture is understood by numeral. if not, default it to current locale
            localeData = numeral.localeData(culture);
        } catch (e) {
            localeData = numeral.localeData(numeral.locale());
        }
        //setup the delimiters and currency symbol based on culture/locale
        _currSymbol = localeData.currency.symbol;
        _abbrObj = localeData.abbreviations;
        _decimalSep = localeData.delimiters.decimal;
        if (localeData.delimiters.thousands === ".") _thousandSep = "\\.";
        else _thousandSep = localeData.delimiters.thousands;
        // validating currency symbol
        temp = val.match(/^[^\d]+/);
        if (temp !== null) {
            val = val.substr(1);
            if (temp[0] !== _currSymbol) return false;
        }
        //validating abbreviation symbol
        temp = val.match(/[^\d]+$/);
        if (temp !== null) {
            val = val.slice(0, -1);
            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) return false;
        }
        _thousandRegEx = new RegExp(_thousandSep + "{2}");
        if (!val.match(/[^\d.,]/g)) {
            _valArray = val.split(_decimalSep);
            if (_valArray.length > 2) return false;
            else {
                if (_valArray.length < 2) return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx);
                else {
                    if (_valArray[0].length === 1) return !!_valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
                    else return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
                }
            }
        }
        return false;
    };
    /************************************
        Numeral Prototype
    ************************************/ numeral.fn = Numeral.prototype = {
        clone: function() {
            return numeral(this);
        },
        format: function(inputString, roundingFunction) {
            var value = this._value, format = inputString || options.defaultFormat, kind, output, formatFunction;
            // make sure we have a roundingFunction
            roundingFunction = roundingFunction || Math.round;
            // format based on value
            if (value === 0 && options.zeroFormat !== null) output = options.zeroFormat;
            else if (value === null && options.nullFormat !== null) output = options.nullFormat;
            else {
                for(kind in formats)if (format.match(formats[kind].regexps.format)) {
                    formatFunction = formats[kind].format;
                    break;
                }
                formatFunction = formatFunction || numeral._.numberToFormat;
                output = formatFunction(value, format, roundingFunction);
            }
            return output;
        },
        value: function() {
            return this._value;
        },
        input: function() {
            return this._input;
        },
        set: function(value) {
            this._value = Number(value);
            return this;
        },
        add: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);
            function cback(accum, curr, currI, O) {
                return accum + Math.round(corrFactor * curr);
            }
            this._value = _.reduce([
                this._value,
                value
            ], cback, 0) / corrFactor;
            return this;
        },
        subtract: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);
            function cback(accum, curr, currI, O) {
                return accum - Math.round(corrFactor * curr);
            }
            this._value = _.reduce([
                value
            ], cback, Math.round(this._value * corrFactor)) / corrFactor;
            return this;
        },
        multiply: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
            }
            this._value = _.reduce([
                this._value,
                value
            ], cback, 1);
            return this;
        },
        divide: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
            }
            this._value = _.reduce([
                this._value,
                value
            ], cback);
            return this;
        },
        difference: function(value) {
            return Math.abs(numeral(this._value).subtract(value).value());
        }
    };
    /************************************
        Default Locale && Format
    ************************************/ numeral.register("locale", "en", {
        delimiters: {
            thousands: ",",
            decimal: "."
        },
        abbreviations: {
            thousand: "k",
            million: "m",
            billion: "b",
            trillion: "t"
        },
        ordinal: function(number) {
            var b = number % 10;
            return ~~(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
        },
        currency: {
            symbol: "$"
        }
    });
    (function() {
        numeral.register("format", "bps", {
            regexps: {
                format: /(BPS)/,
                unformat: /(BPS)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, " BPS") ? " " : "", output;
                value = value * 10000;
                // check for space before BPS
                format = format.replace(/\s?BPS/, "");
                output = numeral._.numberToFormat(value, format, roundingFunction);
                if (numeral._.includes(output, ")")) {
                    output = output.split("");
                    output.splice(-1, 0, space + "BPS");
                    output = output.join("");
                } else output = output + space + "BPS";
                return output;
            },
            unformat: function(string) {
                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
            }
        });
    })();
    (function() {
        var decimal = {
            base: 1000,
            suffixes: [
                "B",
                "KB",
                "MB",
                "GB",
                "TB",
                "PB",
                "EB",
                "ZB",
                "YB"
            ]
        }, binary = {
            base: 1024,
            suffixes: [
                "B",
                "KiB",
                "MiB",
                "GiB",
                "TiB",
                "PiB",
                "EiB",
                "ZiB",
                "YiB"
            ]
        };
        var allSuffixes = decimal.suffixes.concat(binary.suffixes.filter(function(item) {
            return decimal.suffixes.indexOf(item) < 0;
        }));
        var unformatRegex = allSuffixes.join("|");
        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
        unformatRegex = "(" + unformatRegex.replace("B", "B(?!PS)") + ")";
        numeral.register("format", "bytes", {
            regexps: {
                format: /([0\s]i?b)/,
                unformat: new RegExp(unformatRegex)
            },
            format: function(value, format, roundingFunction) {
                var output, bytes = numeral._.includes(format, "ib") ? binary : decimal, suffix = numeral._.includes(format, " b") || numeral._.includes(format, " ib") ? " " : "", power, min, max;
                // check for space before
                format = format.replace(/\s?i?b/, "");
                for(power = 0; power <= bytes.suffixes.length; power++){
                    min = Math.pow(bytes.base, power);
                    max = Math.pow(bytes.base, power + 1);
                    if (value === null || value === 0 || value >= min && value < max) {
                        suffix += bytes.suffixes[power];
                        if (min > 0) value = value / min;
                        break;
                    }
                }
                output = numeral._.numberToFormat(value, format, roundingFunction);
                return output + suffix;
            },
            unformat: function(string) {
                var value = numeral._.stringToNumber(string), power, bytesMultiplier;
                if (value) {
                    for(power = decimal.suffixes.length - 1; power >= 0; power--){
                        if (numeral._.includes(string, decimal.suffixes[power])) {
                            bytesMultiplier = Math.pow(decimal.base, power);
                            break;
                        }
                        if (numeral._.includes(string, binary.suffixes[power])) {
                            bytesMultiplier = Math.pow(binary.base, power);
                            break;
                        }
                    }
                    value *= bytesMultiplier || 1;
                }
                return value;
            }
        });
    })();
    (function() {
        numeral.register("format", "currency", {
            regexps: {
                format: /(\$)/
            },
            format: function(value, format, roundingFunction) {
                var locale = numeral.locales[numeral.options.currentLocale], symbols = {
                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
                }, output, symbol, i;
                // strip format of spaces and $
                format = format.replace(/\s?\$\s?/, "");
                // format the number
                output = numeral._.numberToFormat(value, format, roundingFunction);
                // update the before and after based on value
                if (value >= 0) {
                    symbols.before = symbols.before.replace(/[\-\(]/, "");
                    symbols.after = symbols.after.replace(/[\-\)]/, "");
                } else if (value < 0 && !numeral._.includes(symbols.before, "-") && !numeral._.includes(symbols.before, "(")) symbols.before = "-" + symbols.before;
                // loop through each before symbol
                for(i = 0; i < symbols.before.length; i++){
                    symbol = symbols.before[i];
                    switch(symbol){
                        case "$":
                            output = numeral._.insert(output, locale.currency.symbol, i);
                            break;
                        case " ":
                            output = numeral._.insert(output, " ", i + locale.currency.symbol.length - 1);
                            break;
                    }
                }
                // loop through each after symbol
                for(i = symbols.after.length - 1; i >= 0; i--){
                    symbol = symbols.after[i];
                    switch(symbol){
                        case "$":
                            output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
                            break;
                        case " ":
                            output = i === symbols.after.length - 1 ? output + " " : numeral._.insert(output, " ", -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
                            break;
                    }
                }
                return output;
            }
        });
    })();
    (function() {
        numeral.register("format", "exponential", {
            regexps: {
                format: /(e\+|e-)/,
                unformat: /(e\+|e-)/
            },
            format: function(value, format, roundingFunction) {
                var output, exponential = typeof value === "number" && !numeral._.isNaN(value) ? value.toExponential() : "0e+0", parts = exponential.split("e");
                format = format.replace(/e[\+|\-]{1}0/, "");
                output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);
                return output + "e" + parts[1];
            },
            unformat: function(string) {
                var parts = numeral._.includes(string, "e+") ? string.split("e+") : string.split("e-"), value = Number(parts[0]), power = Number(parts[1]);
                power = numeral._.includes(string, "e-") ? power *= -1 : power;
                function cback(accum, curr, currI, O) {
                    var corrFactor = numeral._.correctionFactor(accum, curr), num = accum * corrFactor * (curr * corrFactor) / (corrFactor * corrFactor);
                    return num;
                }
                return numeral._.reduce([
                    value,
                    Math.pow(10, power)
                ], cback, 1);
            }
        });
    })();
    (function() {
        numeral.register("format", "ordinal", {
            regexps: {
                format: /(o)/
            },
            format: function(value, format, roundingFunction) {
                var locale = numeral.locales[numeral.options.currentLocale], output, ordinal = numeral._.includes(format, " o") ? " " : "";
                // check for space before
                format = format.replace(/\s?o/, "");
                ordinal += locale.ordinal(value);
                output = numeral._.numberToFormat(value, format, roundingFunction);
                return output + ordinal;
            }
        });
    })();
    (function() {
        numeral.register("format", "percentage", {
            regexps: {
                format: /(%)/,
                unformat: /(%)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, " %") ? " " : "", output;
                if (numeral.options.scalePercentBy100) value = value * 100;
                // check for space before %
                format = format.replace(/\s?\%/, "");
                output = numeral._.numberToFormat(value, format, roundingFunction);
                if (numeral._.includes(output, ")")) {
                    output = output.split("");
                    output.splice(-1, 0, space + "%");
                    output = output.join("");
                } else output = output + space + "%";
                return output;
            },
            unformat: function(string) {
                var number = numeral._.stringToNumber(string);
                if (numeral.options.scalePercentBy100) return number * 0.01;
                return number;
            }
        });
    })();
    (function() {
        numeral.register("format", "time", {
            regexps: {
                format: /(:)/,
                unformat: /(:)/
            },
            format: function(value, format, roundingFunction) {
                var hours = Math.floor(value / 60 / 60), minutes = Math.floor((value - hours * 3600) / 60), seconds = Math.round(value - hours * 3600 - minutes * 60);
                return hours + ":" + (minutes < 10 ? "0" + minutes : minutes) + ":" + (seconds < 10 ? "0" + seconds : seconds);
            },
            unformat: function(string) {
                var timeArray = string.split(":"), seconds = 0;
                // turn hours and minutes into seconds and add them all up
                if (timeArray.length === 3) {
                    // hours
                    seconds = seconds + Number(timeArray[0]) * 3600;
                    // minutes
                    seconds = seconds + Number(timeArray[1]) * 60;
                    // seconds
                    seconds = seconds + Number(timeArray[2]);
                } else if (timeArray.length === 2) {
                    // minutes
                    seconds = seconds + Number(timeArray[0]) * 60;
                    // seconds
                    seconds = seconds + Number(timeArray[1]);
                }
                return Number(seconds);
            }
        });
    })();
    return numeral;
});

});



parcelRegister("8dNEn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fc60d2407358c6d$export$2e2bcd8739ae039; });
var $5fc60d2407358c6d$export$2e2bcd8739ae039 = ({ left: left, right: right }, context)=>{
    return {
        type: "logic",
        value: left.value > right.value
    };
};

});

parcelRegister("dY3wj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2b39c03abbed02f$export$2e2bcd8739ae039; });
var $a2b39c03abbed02f$export$2e2bcd8739ae039 = ({ left: left, right: right }, context)=>{
    return {
        type: "logic",
        value: left.value >= right.value
    };
};

});

parcelRegister("83KHZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5de2d5e0ab5b0bb4$export$2e2bcd8739ae039; });
var $5de2d5e0ab5b0bb4$export$2e2bcd8739ae039 = (inputs, context)=>{
    const val = inputs.if ? inputs.then : inputs.else;
    return {
        type: val.type,
        value: val.value
    };
};

});

parcelRegister("4LOPH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3792fb8b6c6ff585$export$2e2bcd8739ae039; });
var $3792fb8b6c6ff585$export$2e2bcd8739ae039 = ({ left: left, right: right }, context)=>{
    return {
        type: "logic",
        value: left.value < right.value
    };
};

});

parcelRegister("995mg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a891c537e0b2aeb$export$2e2bcd8739ae039; });
var $6a891c537e0b2aeb$export$2e2bcd8739ae039 = ({ left: left, right: right }, context)=>{
    return {
        type: "logic",
        value: left.value <= right.value
    };
};

});

parcelRegister("kUPVi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3a1507c62106174$export$2e2bcd8739ae039; });

var $7CaHe = parcelRequire("7CaHe");
var $f3a1507c62106174$export$2e2bcd8739ae039 = ({ left: left, right: right }, context)=>{
    const multiplierId = left.type + right.type;
    if (!$f3a1507c62106174$var$multiplierValues[multiplierId]) throw {
        value: `Cannot multiply a ${left.type} with a ${right.type}.`,
        type: "error"
    };
    return {
        type: $f3a1507c62106174$var$multiplierTypes[multiplierId],
        value: $f3a1507c62106174$var$multiplierValues[multiplierId](left, right)
    };
};
const $f3a1507c62106174$var$multiplierTypes = {
    numbernumber: "number",
    textnumber: "text",
    numbertext: "text",
    numberduration: "duration",
    durationnumber: "duration",
    numberrate: "rate",
    ratenumber: "rate",
    durationrate: "number",
    rateduration: "number",
    durationduration: "powerDuration"
};
const $f3a1507c62106174$var$multiplierValues = {
    numbernumber: (left, right)=>left.value * right.value,
    textnumber: (left, right)=>left.value.repeat(right.value),
    numbertext: (left, right)=>right.value.repeat(left.value),
    numberduration: (left, right)=>{
        return (0, $7CaHe.simplifyDuration)((0, $7CaHe.multiplyDurationBy)(right.value, left.value));
    },
    durationnumber: (left, right)=>{
        return (0, $7CaHe.simplifyDuration)((0, $7CaHe.multiplyDurationBy)(left.value, right.value));
    },
    numberrate: (left, right)=>{
        return (0, $7CaHe.simplifyRate)((0, $7CaHe.multiplyRateBy)(right.value, left.value));
    },
    ratenumber: (left, right)=>{
        return (0, $7CaHe.simplifyRate)((0, $7CaHe.multiplyRateBy)(left.value, right.value));
    },
    durationrate: (left, right)=>{
        return (0, $7CaHe.multiplyRateByDuration)(right.value, left.value);
    },
    rateduration: (left, right)=>{
        return (0, $7CaHe.multiplyRateByDuration)(left.value, right.value);
    },
    durationduration: (left, right)=>{
        return (0, $7CaHe.multiplyDurations)(left.value, right.value);
    }
};

});

parcelRegister("6GZGo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4df6833e11cbd1f3$export$2e2bcd8739ae039; });
var $4df6833e11cbd1f3$export$2e2bcd8739ae039 = ({ val: val }, context)=>{
    return {
        type: "logic",
        value: !val.value
    };
};

});

parcelRegister("1CFC5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12e99e9072b34f1d$export$2e2bcd8739ae039; });
var $12e99e9072b34f1d$export$2e2bcd8739ae039 = ({ left: left, right: right }, context)=>{
    const selectedVal = left.value ? left : right;
    return {
        type: selectedVal.type,
        value: selectedVal.value
    };
};

});

parcelRegister("lLAF8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd8a6d29fac77037$export$2e2bcd8739ae039; });
var $fd8a6d29fac77037$export$2e2bcd8739ae039 = ({ base: base, power: power }, context)=>{
    const raiserId = base.type + power.type;
    if (!$fd8a6d29fac77037$var$raiserValues[raiserId]) throw {
        value: `Cannot raise a ${base.type} to the power of a ${power.type}.`,
        type: "error"
    };
    return {
        type: $fd8a6d29fac77037$var$raiserTypes[raiserId],
        value: $fd8a6d29fac77037$var$raiserValues[raiserId] && $fd8a6d29fac77037$var$raiserValues[raiserId](base, power)
    };
};
const $fd8a6d29fac77037$var$raiserTypes = {
    numbernumber: "number"
};
const $fd8a6d29fac77037$var$raiserValues = {
    numbernumber: (base, power)=>Math.pow(base.value, power.value)
};
const $fd8a6d29fac77037$var$raiserValidators = {
    numbernumber: []
};

});

parcelRegister("gi6jc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bdc33889cf052b92$export$2e2bcd8739ae039; });

var $7CaHe = parcelRequire("7CaHe");
var $bdc33889cf052b92$export$2e2bcd8739ae039 = ({ left: left, right: right }, context)=>{
    const subberId = left.type + right.type;
    if (!$bdc33889cf052b92$var$subberValues[subberId]) throw {
        value: `Cannot subtract a ${right.type} from a ${left.type}.`,
        type: "error"
    };
    return {
        type: $bdc33889cf052b92$var$subberTypes[subberId],
        value: $bdc33889cf052b92$var$subberValues[subberId] && $bdc33889cf052b92$var$subberValues[subberId](left, right)
    };
};
const $bdc33889cf052b92$var$subberTypes = {
    numbernumber: "number",
    texttext: "text",
    dateTimeduration: "dateTime",
    dateTimedateTime: "duration",
    durationduration: "duration",
    raterate: "rate"
};
const $bdc33889cf052b92$var$subberValues = {
    numbernumber: (left, right)=>left.value - right.value,
    texttext: (left, right)=>left.value.replace(right.value, ""),
    dateTimeduration: (left, right)=>(0, $7CaHe.subDurationFromDate)(left.value, right.value).getTime(),
    dateTimedateTime: (left, right)=>(0, $7CaHe.simplifyDuration)((0, $7CaHe.durationBetween)(right.value, left.value)),
    durationduration: (left, right)=>(0, $7CaHe.simplifyDuration)((0, $7CaHe.subDurations)(left.value, right.value)),
    raterate: (left, right)=>(0, $7CaHe.simplifyRate)((0, $7CaHe.subRates)(left.value, right.value))
};

});





parcelRegister("2N6oS", function(module, exports) {

$parcel$export(module.exports, "storeFormula", function () { return $20851f509947eb5d$export$60ed586f871e60ae; });
$parcel$export(module.exports, "updateDependencies", function () { return $20851f509947eb5d$export$9a371ee2fc90de9a; });
$parcel$export(module.exports, "getDependants", function () { return $20851f509947eb5d$export$ba70c5c8163184ee; });
$parcel$export(module.exports, "prepareFormulaForUpdate", function () { return $20851f509947eb5d$export$6d4423933971cfe0; });
$parcel$export(module.exports, "updateFormulas", function () { return $20851f509947eb5d$export$ac548ee671daaf6a; });

var $f44xu = parcelRequire("f44xu");
let $20851f509947eb5d$export$fca82059df0f33af = new Map();
let $20851f509947eb5d$export$2c2eda57346d1d49 = new Map();
let $20851f509947eb5d$export$3ee3d3a9e0006c80 = new Set();
const $20851f509947eb5d$export$60ed586f871e60ae = (formula)=>{
    $20851f509947eb5d$export$fca82059df0f33af.set(formula.context, formula);
};
const $20851f509947eb5d$export$3f9479a0e213ca3e = (dependencyRef, formula)=>{
    var _DependencyStore$get;
    $20851f509947eb5d$export$2c2eda57346d1d49.set(dependencyRef, (_DependencyStore$get = $20851f509947eb5d$export$2c2eda57346d1d49.get(dependencyRef)) !== null && _DependencyStore$get !== void 0 ? _DependencyStore$get : new Set());
    $20851f509947eb5d$export$2c2eda57346d1d49.get(dependencyRef).add(formula);
};
const $20851f509947eb5d$export$d68ff131ad0917e4 = (dependencyRef, formula)=>{
    const dependants = $20851f509947eb5d$export$2c2eda57346d1d49.get(dependencyRef);
    dependants && dependants.delete(formula);
    if (!dependants.size) $20851f509947eb5d$export$2c2eda57346d1d49.delete(dependencyRef);
};
const $20851f509947eb5d$export$9a371ee2fc90de9a = (formula, oldDeps, newDeps)=>{
    for (const depRef of oldDeps.keys())$20851f509947eb5d$export$d68ff131ad0917e4(depRef, formula);
    for (const depRef of newDeps.keys())$20851f509947eb5d$export$3f9479a0e213ca3e(depRef, formula);
};
const $20851f509947eb5d$export$862155d9d6290450 = (formula)=>{
    $20851f509947eb5d$export$fca82059df0f33af.delete(formula.context);
    for (const depRef of formula.dependencies.keys())$20851f509947eb5d$export$2c2eda57346d1d49.get(depRef).delete(formula);
};
const $20851f509947eb5d$export$ba70c5c8163184ee = (formula)=>{
    // console.log(
    //     "🚀 ~ file: FormulaStore.js ~ line 41 ~ getDependants ~ DependencyStore.get(formula.context)",
    // 	DependencyStore
    // );    
    return $20851f509947eb5d$export$2c2eda57346d1d49.get(formula.context) || new Set();
};
const $20851f509947eb5d$export$b97978456bcd4d5a = (oldRef, newRef)=>{
    for (const formulaRef of $20851f509947eb5d$export$fca82059df0f33af.keys())if (formulaRef[0] === oldRef) {
        const newFormulaRef = (0, $f44xu.default)(newRef, formulaRef[1]);
        const formula = $20851f509947eb5d$export$fca82059df0f33af.get(formulaRef);
        $20851f509947eb5d$export$fca82059df0f33af.delete(formulaRef);
        $20851f509947eb5d$export$fca82059df0f33af.set(newFormulaRef, formula);
    }
    for (const depRef of $20851f509947eb5d$export$2c2eda57346d1d49.keys())if (depRef[0] === oldRef) {
        const dependants = $20851f509947eb5d$export$2c2eda57346d1d49.get(depRef);
        for (const dep of dependants)$20851f509947eb5d$export$35aac200cfa5adf1(dep);
    }
};
const $20851f509947eb5d$export$35aac200cfa5adf1 = (formula, oldRef, newRef)=>{
    const oldString = formula.formula;
    const newString = oldString.replace(`#{oldRef}`, `#{newRef}`);
    if (oldString !== newString) formula.setFormula(newString);
};
const $20851f509947eb5d$export$6d4423933971cfe0 = (formula)=>{
    $20851f509947eb5d$export$3ee3d3a9e0006c80.add(formula);
};
const $20851f509947eb5d$export$ac548ee671daaf6a = ()=>{
    console.log("\uD83D\uDE80 ~ file: FormulaStore.js ~ line 76 ~ updateFormulas ~ ForumlasToUpdate", $20851f509947eb5d$export$3ee3d3a9e0006c80);
    for (const formula of $20851f509947eb5d$export$3ee3d3a9e0006c80)formula.update();
    $20851f509947eb5d$export$3ee3d3a9e0006c80 = new Set();
};

});



parcelRegister("32EfH", function(module, exports) {

$parcel$export(module.exports, "invoiceProperties", function () { return $2370c83b4be07188$export$d8cbae27a3b99756; });

var $f44xu = parcelRequire("f44xu");

var $bhvQG = parcelRequire("bhvQG");

var $gJT7h = parcelRequire("gJT7h");
const $2370c83b4be07188$export$d8cbae27a3b99756 = (prop, invoiceValue, context)=>{
    var _invoicePropDepLookup, _invoicePropertiesLoo;
    const dependencies = ((_invoicePropDepLookup = $2370c83b4be07188$var$invoicePropDepLookup[prop]) === null || _invoicePropDepLookup === void 0 ? void 0 : _invoicePropDepLookup.call($2370c83b4be07188$var$invoicePropDepLookup, invoiceValue, context)) || new Map();
    if (dependencies.get(context)) throw {
        value: "Circular reference.",
        type: "error",
        dependencies: dependencies
    };
    const val = (_invoicePropertiesLoo = $2370c83b4be07188$var$invoicePropertiesLookup[prop]) === null || _invoicePropertiesLoo === void 0 ? void 0 : _invoicePropertiesLoo.call($2370c83b4be07188$var$invoicePropertiesLookup, invoiceValue, context);
    return val && {
        ...val,
        dependencies: dependencies
    };
};
const $2370c83b4be07188$var$invoicePropertiesLookup = {
    project: (invoiceValue, context)=>{
        return {
            type: "project",
            value: (0, $gJT7h.default).projectsById[invoiceValue.value.projectId] || (0, $gJT7h.default).projects[0]
        };
    },
    contact: (invoiceValue, context)=>{
        return {
            type: "contact",
            value: (0, $bhvQG.default).contactsById[invoiceValue.value.contactId] || (0, $bhvQG.default).contacts[0]
        };
    }
};
const $2370c83b4be07188$var$invoicePropDepLookup = {
    project: (invoiceValue, context)=>new Map([
            ...invoiceValue.dependencies || [],
            [
                (0, $f44xu.default)(invoiceValue.value.ref, "project"),
                {}
            ]
        ]),
    contact: (invoiceValue, context)=>new Map([
            ...invoiceValue.dependencies || [],
            [
                (0, $f44xu.default)(invoiceValue.value.ref, "contact"),
                {}
            ]
        ])
};
const $2370c83b4be07188$export$bc99da532307cb19 = {};

});

parcelRegister("lzKQ8", function(module, exports) {

$parcel$export(module.exports, "projectProperties", function () { return $fb51334dac4331d5$export$6d40c8dda1d4fe52; });

var $4hBm1 = parcelRequire("4hBm1");

var $1BTI2 = parcelRequire("1BTI2");

var $cxnwP = parcelRequire("cxnwP");
const $fb51334dac4331d5$export$6d40c8dda1d4fe52 = (prop, projectValue, context)=>{
    var _projectPropDepLookup, _projectPropertiesLoo;
    const dependencies = ((_projectPropDepLookup = $fb51334dac4331d5$var$projectPropDepLookup[prop]) === null || _projectPropDepLookup === void 0 ? void 0 : _projectPropDepLookup.call($fb51334dac4331d5$var$projectPropDepLookup, projectValue, context)) || new Map();
    if (dependencies.get(context)) throw {
        value: "Circular reference.",
        type: "error",
        dependencies: dependencies
    };
    const val = (_projectPropertiesLoo = $fb51334dac4331d5$var$projectPropertiesLookup[prop]) === null || _projectPropertiesLoo === void 0 ? void 0 : _projectPropertiesLoo.call($fb51334dac4331d5$var$projectPropertiesLookup, projectValue, context);
    return val && {
        ...val,
        dependencies: dependencies
    };
};
const $fb51334dac4331d5$var$projectPropertiesLookup = {
    code: (projectValue, context)=>{
        return {
            type: "text",
            value: projectValue.value.jobNumber
        };
    },
    name: (projectValue, context)=>{
        return {
            type: "text",
            value: projectValue.value.name
        };
    },
    invNum: (projectValue, context)=>{
        var _SessionStore$organis, _SessionStore$organis2;
        return {
            type: "number",
            value: (0, $cxnwP.default).invoices.filter((i)=>i.projectId === projectValue.value.id).length + 1 + (((_SessionStore$organis = (0, $1BTI2.default).organisation.settings.invoiceNumber) === null || _SessionStore$organis === void 0 ? void 0 : (_SessionStore$organis2 = _SessionStore$organis.numProjAdjustors) === null || _SessionStore$organis2 === void 0 ? void 0 : _SessionStore$organis2[projectValue.value.id]) || 0)
        };
    },
    invNumYear: (projectValue, context)=>{
        var _SessionStore$organis3, _SessionStore$organis4, _SessionStore$organis5;
        return {
            type: "number",
            value: (0, $cxnwP.default).invoicesfilter((i)=>i.projectId === projectValue.value.id && (0, $4hBm1.isSameYear)(i.createdAt, new Date())).length + 1 + (((_SessionStore$organis3 = (0, $1BTI2.default).organisation.settings.invoiceNumber) === null || _SessionStore$organis3 === void 0 ? void 0 : (_SessionStore$organis4 = _SessionStore$organis3.numProjAdjustors) === null || _SessionStore$organis4 === void 0 ? void 0 : (_SessionStore$organis5 = _SessionStore$organis4[projectValue.value.id]) === null || _SessionStore$organis5 === void 0 ? void 0 : _SessionStore$organis5[new Date().getFullYear()]) || 0)
        };
    }
};
const $fb51334dac4331d5$var$projectPropDepLookup = {
    code: (projectValue, context)=>new Map([
            ...projectValue.dependencies || []
        ]),
    name: (projectValue, context)=>new Map([
            ...projectValue.dependencies || []
        ]),
    numInvoices: (projectValue, context)=>new Map([
            ...projectValue.dependencies || []
        ]),
    numInvoicesThisYear: (projectValue, context)=>new Map([
            ...projectValue.dependencies || []
        ])
};
const $fb51334dac4331d5$export$67497ab732922a97 = {};

});

parcelRegister("chXZl", function(module, exports) {

$parcel$export(module.exports, "contactProperties", function () { return $8f259b09944ad05b$export$7840d0801779381f; });
const $8f259b09944ad05b$export$7840d0801779381f = (prop, contactValue, context)=>{
    var _contactPropDepLookup, _contactPropertiesLoo;
    const dependencies = ((_contactPropDepLookup = $8f259b09944ad05b$var$contactPropDepLookup[prop]) === null || _contactPropDepLookup === void 0 ? void 0 : _contactPropDepLookup.call($8f259b09944ad05b$var$contactPropDepLookup, contactValue, context)) || new Map();
    if (dependencies.get(context)) throw {
        value: "Circular reference.",
        type: "error",
        dependencies: dependencies
    };
    const val = (_contactPropertiesLoo = $8f259b09944ad05b$var$contactPropertiesLookup[prop]) === null || _contactPropertiesLoo === void 0 ? void 0 : _contactPropertiesLoo.call($8f259b09944ad05b$var$contactPropertiesLookup, contactValue, context);
    return val && {
        ...val,
        dependencies: dependencies
    };
};
const $8f259b09944ad05b$var$contactPropertiesLookup = {
    firstName: (contactValue, context)=>{
        return {
            type: "text",
            value: contactValue.value.firstName
        };
    },
    lastName: (contactValue, context)=>{
        return {
            type: "text",
            value: contactValue.value.lastName
        };
    },
    organisation: (contactValue, context)=>{
        return {
            type: "text",
            value: contactValue.value.organisationName
        };
    }
};
const $8f259b09944ad05b$var$contactPropDepLookup = {
    firstName: (contactValue, context)=>new Map([
            ...contactValue.dependencies || []
        ]),
    lastName: (contactValue, context)=>new Map([
            ...contactValue.dependencies || []
        ]),
    organisation: (contactValue, context)=>new Map([
            ...contactValue.dependencies || []
        ])
};
const $8f259b09944ad05b$export$acaba7e6766bdad = {};

});


parcelRegister("hIH1V", function(module, exports) {

$parcel$export(module.exports, "InvoiceFormulaInfo", function () { return $ce67ec96fc734d24$export$f9d165a97a1a63a; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("hrKXR");
const $ce67ec96fc734d24$export$f9d165a97a1a63a = (props)=>{
    const { style: style, ...extraProps } = props;
    const [showDropdown, setShowDropdown] = (0, $jbmdS.useState)(false);
    const [hoveredKey, setHoveredKey] = (0, $jbmdS.useState)(null);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        style: {
            position: "relative",
            display: "inline-block",
            ...style
        },
        ...extraProps,
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                onClick: (e)=>setShowDropdown(!showDropdown),
                className: "fa fa-question-circle"
            }),
            showDropdown && /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    position: "absolute",
                    right: 0,
                    top: "2em",
                    textAlign: "right",
                    zIndex: 100,
                    fontSize: "0.9em",
                    border: "1px solid #ddd",
                    borderRadius: "0.5em",
                    background: "white",
                    boxShadow: "9px 7px 17px -4px rgb(0,0,0,0.2)"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        style: {
                            padding: "0.5em 1em",
                            borderBottom: "1px solid #ddd"
                        },
                        children: "Description Codes"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        style: {
                            overflowY: "scroll",
                            height: "15em"
                        },
                        children: $ce67ec96fc734d24$var$formulaExamples.map((e, i)=>{
                            const hovering = hoveredKey === i;
                            return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                style: {
                                    padding: "0.5em 1em",
                                    borderBottom: "1px solid #eee",
                                    fontWeight: "normal",
                                    background: hovering ? "#f9f9f9" : "white",
                                    cursor: "pointer",
                                    position: "relative"
                                },
                                onPointerOver: (e)=>setHoveredKey(i),
                                onPointerOut: (e)=>hoveredKey === i && setHoveredKey(null),
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                    children: e.label
                                })
                            });
                        })
                    })
                ]
            }),
            $ce67ec96fc734d24$var$formulaExamples[hoveredKey] && /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    position: "absolute",
                    left: "2.5em",
                    top: "4.5em",
                    fontSize: "0.9em",
                    width: "25em",
                    padding: "1em",
                    border: "1px solid #ddd",
                    borderRadius: "0.5em",
                    background: "white",
                    boxShadow: "9px 7px 17px -4px rgb(0,0,0,0.2)",
                    zIndex: 100,
                    fontWeight: "normal"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        children: $ce67ec96fc734d24$var$formulaExamples[hoveredKey].description
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            fontSize: "0.9em",
                            fontStyle: "italic",
                            fontWeight: "normal",
                            marginTop: "1em",
                            whiteSpace: "pre-line"
                        },
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)("b", {
                                    children: "For Example:"
                                })
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                style: {
                                    marginTop: "-0.25em"
                                },
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                    children: $ce67ec96fc734d24$var$formulaExamples[hoveredKey].example.code
                                })
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                style: {
                                    marginTop: "0.5em"
                                },
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)("b", {
                                    children: "Results In:"
                                })
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                style: {
                                    marginTop: "-0.25em"
                                },
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                    children: $ce67ec96fc734d24$var$formulaExamples[hoveredKey].example.result
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $ce67ec96fc734d24$var$formulaExamples = [
    {
        label: `"Text"`,
        description: "Use quotation marks around any text values.",
        example: {
            code: `"Invoice" + "Code"`,
            result: `InvoiceCode`
        }
    },
    {
        label: `invNum`,
        description: "The next invoice number.",
        example: {
            code: `"INV_" + invNum`,
            result: `INV_15`
        }
    },
    {
        label: `format Number`,
        description: "Format numbers to have a certain character length.",
        example: {
            code: `"INV_" + format(invNum, "0000")`,
            result: `INV_0015`
        }
    },
    {
        label: `invNumYear`,
        description: "The next invoice number this year.",
        example: {
            code: `"INV_" + invNumYear`,
            result: `INV_5`
        }
    },
    {
        label: `format Date`,
        description: "Format numbers to have a certain character length.",
        example: {
            code: `"INV_" + format(now, "yy") + format(invNumYear, "000")`,
            result: `INV_21003`
        }
    },
    {
        label: `$project.invNum`,
        description: "The next invoice number for this project.",
        example: {
            code: `"INV_" + $project.invNum`,
            result: `INV_3`
        }
    },
    {
        label: `$project.code`,
        description: "The project number/code for this project.",
        example: {
            code: `"$project.code" + "_" + format($project.invNum, "00)`,
            result: `2003_05`
        }
    }
];

});
parcelRegister("hrKXR", function(module, exports) {
"use strict";

var $5dqYf = parcelRequire("5dqYf");
var $cb396371edbbf744$var$clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
};
var $cb396371edbbf744$var$defaultMessage = "Copy to clipboard: #{key}, Enter";
function $cb396371edbbf744$var$format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
    return message.replace(/#{\s*key\s*}/g, copyKey);
}
function $cb396371edbbf744$var$copy(text, options) {
    var debug, message, reselectPrevious, range, selection, mark, success = false;
    if (!options) options = {};
    debug = options.debug || false;
    try {
        reselectPrevious = $5dqYf();
        range = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text;
        // avoid screen readers from reading out loud the text
        mark.ariaHidden = "true";
        // reset user styles for span element
        mark.style.all = "unset";
        // prevents scrolling to the end of the page
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = "pre";
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e) {
            e.stopPropagation();
            if (options.format) {
                e.preventDefault();
                if (typeof e.clipboardData === "undefined") {
                    debug && console.warn("unable to use e.clipboardData");
                    debug && console.warn("trying IE specific stuff");
                    window.clipboardData.clearData();
                    var format = $cb396371edbbf744$var$clipboardToIE11Formatting[options.format] || $cb396371edbbf744$var$clipboardToIE11Formatting["default"];
                    window.clipboardData.setData(format, text);
                } else {
                    e.clipboardData.clearData();
                    e.clipboardData.setData(options.format, text);
                }
            }
            if (options.onCopy) {
                e.preventDefault();
                options.onCopy(e.clipboardData);
            }
        });
        document.body.appendChild(mark);
        range.selectNodeContents(mark);
        selection.addRange(range);
        var successful = document.execCommand("copy");
        if (!successful) throw new Error("copy command was unsuccessful");
        success = true;
    } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
            window.clipboardData.setData(options.format || "text", text);
            options.onCopy && options.onCopy(window.clipboardData);
            success = true;
        } catch (err) {
            debug && console.error("unable to copy using clipboardData: ", err);
            debug && console.error("falling back to prompt");
            message = $cb396371edbbf744$var$format("message" in options ? options.message : $cb396371edbbf744$var$defaultMessage);
            window.prompt(message, text);
        }
    } finally{
        if (selection) {
            if (typeof selection.removeRange == "function") selection.removeRange(range);
            else selection.removeAllRanges();
        }
        if (mark) document.body.removeChild(mark);
        reselectPrevious();
    }
    return success;
}
module.exports = $cb396371edbbf744$var$copy;

});
parcelRegister("5dqYf", function(module, exports) {
module.exports = function() {
    var selection = document.getSelection();
    if (!selection.rangeCount) return function() {};
    var active = document.activeElement;
    var ranges = [];
    for(var i = 0; i < selection.rangeCount; i++)ranges.push(selection.getRangeAt(i));
    switch(active.tagName.toUpperCase()){
        case "INPUT":
        case "TEXTAREA":
            active.blur();
            break;
        default:
            active = null;
            break;
    }
    selection.removeAllRanges();
    return function() {
        selection.type === "Caret" && selection.removeAllRanges();
        if (!selection.rangeCount) ranges.forEach(function(range) {
            selection.addRange(range);
        });
        active && active.focus();
    };
};

});




parcelRegister("aZcHl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ff9737cc8c60007$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("jbmdS");

var $fEcKX = parcelRequire("fEcKX");
var $7ff9737cc8c60007$export$2e2bcd8739ae039 = ({ modalId: modalId, heading: heading, message: message })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fEcKX.default), {
        modalId: modalId,
        heading: heading,
        children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            className: "error",
            style: {
                color: "red",
                fontSize: "1.05em",
                padding: "1em 1em",
                margin: "1em 2em",
                backgroundColor: "#ff00001c",
                borderRadius: "1em"
            },
            children: message
        })
    });
};

});



parcelRegister("i7jlS", function(module, exports) {

var $9OLwn = parcelRequire("9OLwn");
module.exports = $9OLwn("jScBC").then(()=>parcelRequire("1AVf4"));

});
parcelRegister("9OLwn", function(module, exports) {
"use strict";

function $725da546330457a8$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("lNBqR")).resolve(id));
}
module.exports = $725da546330457a8$var$load;

});




parcelRegister("4B1JG", function(module, exports) {

var $4hBm1 = parcelRequire("4hBm1");

var $eat5C = parcelRequire("eat5C");

var $jg8jZ = parcelRequire("jg8jZ");

var $d4jhX = parcelRequire("d4jhX");

var $64hVI = parcelRequire("64hVI");

var $hVjuY = parcelRequire("hVjuY");
const $358bf6cfd6a7684e$var$getPhaseRevenueAmounts = {
    total: (phase)=>phase.fee,
    remaining: (phase)=>phase.fee - (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(phase.invoiceLineItems.filter((li)=>li.billingType === "agreedFee").map((ili)=>ili.amount)) - (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(phase.changeLog.map((cli)=>cli.revenue))
};
const $358bf6cfd6a7684e$var$getBudgetResourceAmounts = {
    total: (budget)=>budget.hours,
    remaining: (budget)=>budget.hours - (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(budget.phase.getAggregateTimeEntries([
            "projectId",
            "phaseId",
            "staffId",
            "isBillable",
            "isVariation",
            "beenInvoiced",
            "month"
        ]).filter((te)=>!te.isVariation && (!budget.staffId || te.staff === budget.staff) && (!budget.roleId || te.role === budget.role)).map((te)=>te.numMinutes / 60))
};
const $358bf6cfd6a7684e$var$getExpenseAmounts = {
    total: (expense)=>expense.cost,
    remaining: (expense)=>expense.cost - (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(expense.invoiceLineItems.map((ili)=>ili.amount))
};
const $358bf6cfd6a7684e$var$getPhaseDate = {
    startDate: (phase)=>phase.startDate,
    endDate: (phase)=>phase.endDate,
    now: (phase)=>(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).max([
            new Date(),
            phase.startDate
        ])
};
const $358bf6cfd6a7684e$var$getFutureRevenueTargets = (phase, fromDate = new Date())=>{
    const monthStart = (0, $4hBm1.startOfMonth)(fromDate);
    return phase.revenueTargets.filter((rt)=>rt.date >= monthStart);
};
const $358bf6cfd6a7684e$var$getFutureAllocations = (phase, budget, fromDate = new Date())=>{
    var _allocations$;
    const monthStart = (0, $4hBm1.startOfMonth)(fromDate);
    let allocations = phase.allocations.filter((al)=>al.date >= monthStart && (!budget.staffId || al.staff === budget.staff) && (!budget.roleId || al.role === budget.role));
    if (((_allocations$ = allocations[0]) === null || _allocations$ === void 0 ? void 0 : _allocations$.startDate) < monthStart) allocations[0] = $358bf6cfd6a7684e$var$splitAllocationAtDate(allocations[0], monthStart);
    return allocations;
};
const $358bf6cfd6a7684e$var$getFutureExpenseAllocations = (expense, fromDate = new Date())=>{
    const monthStart = (0, $4hBm1.startOfMonth)(fromDate);
    return expense.allocations.filter((al)=>(rt)=>rt.date >= monthStart);
};
const $358bf6cfd6a7684e$var$splitAllocationAtDate = (allocation, date)=>{
    const alStart1 = allocation.start;
    const alEnd1 = (0, $4hBm1.subDays)(date, 1);
    const alStart2 = date;
    const alEnd2 = allocation.end;
    const hoursPerDuration = allocation.hours / (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).max([
        allocation.endDate - allocation.startDate,
        1
    ]);
    const alHours1 = (0, $hVjuY.logRound)(hoursPerDuration * (alEnd1 - alStart1));
    const alHours2 = allocation.hours - alHours1;
    allocation.update({
        endDate: alEnd1,
        hours: alHours1
    });
    const al2 = allocation.clone({
        startDate: alStart2,
        endDate: alEnd2,
        hours: alHours2
    }, {
        trackUpdates: true
    });
    return al2;
};
const $358bf6cfd6a7684e$export$3469d2657332a94d = (phases, remainingOrTotal, updateFrom, updateTo)=>{
    phases.forEach((ph)=>{
        let amount = $358bf6cfd6a7684e$var$getPhaseRevenueAmounts[remainingOrTotal](ph);
        const fromDate = $358bf6cfd6a7684e$var$getPhaseDate[updateFrom](ph);
        const toDate = $358bf6cfd6a7684e$var$getPhaseDate[updateTo](ph);
        const amountPerDuration = amount / (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).max([
            toDate - fromDate,
            1
        ]);
        let revenueTargets = $358bf6cfd6a7684e$var$getFutureRevenueTargets(ph, updateFrom === "startDate" ? new Date(0) : new Date());
        let date = fromDate;
        while(date < toDate){
            const prevDate = date;
            date = (0, $4hBm1.endOfMonth)((0, $4hBm1.addDays)(date, 1));
            let rtAmount = (0, $hVjuY.logRound)(amountPerDuration * (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).max([
                date - prevDate,
                1
            ]));
            if (date > toDate) {
                date = toDate;
                rtAmount = amount;
            }
            const rt = revenueTargets.shift() || (0, $64hVI.default).add({
                projectId: ph.project.id,
                phaseId: ph.id
            }, {
                trackUpdates: true
            });
            rt.update({
                date: date,
                amount: rtAmount,
                deletedAt: null
            });
            amount -= rtAmount;
        }
        revenueTargets.forEach((rt)=>rt.update({
                deletedAt: new Date(),
                amount: 0
            }));
    });
};
const $358bf6cfd6a7684e$export$af7c2a49649bf57d = (expenses, remainingOrTotal, updateFrom, updateTo)=>{
    expenses.forEach((e)=>{
        let amount = $358bf6cfd6a7684e$var$getExpenseAmounts[remainingOrTotal](e);
        const fromDate = $358bf6cfd6a7684e$var$getPhaseDate[updateFrom](e);
        const toDate = $358bf6cfd6a7684e$var$getPhaseDate[updateTo](e);
        const amountPerDuration = amount / (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).max([
            toDate - fromDate,
            1
        ]);
        let expenseAllocations = $358bf6cfd6a7684e$var$getFutureExpenseAllocations(e, updateFrom === "startDate" ? new Date(0) : new Date());
        let date;
        while(!date || date < toDate){
            var _date;
            (_date = date) !== null && _date !== void 0 ? _date : date = fromDate;
            const prevDate = date;
            date = (0, $4hBm1.endOfMonth)((0, $4hBm1.addDays)(date, 1));
            let eaAmount = (0, $hVjuY.logRound)(amountPerDuration * (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).max([
                date - prevDate,
                1
            ]));
            if (date > toDate) {
                date = toDate;
                eaAmount = amount;
            }
            const ea = expenseAllocations.shift() || (0, $d4jhX.default).add({
                projectId: e.projectId,
                phaseId: e.phaseId,
                expenseId: e.id
            }, {
                trackUpdates: true
            });
            ea.update({
                date: date,
                amount: eaAmount,
                deletedAt: null
            });
            amount -= eaAmount;
        }
        expenseAllocations.forEach((rt)=>rt.update({
                deletedAt: new Date(),
                amount: 0
            }));
    });
};
const $358bf6cfd6a7684e$export$32cc7b6066090f34 = (budgets, remainingOrTotal, updateFrom, updateTo)=>{
    budgets.forEach((e)=>{
        budgets.forEach((phb)=>{
            let amount = $358bf6cfd6a7684e$var$getBudgetResourceAmounts[remainingOrTotal](phb);
            const fromDate = $358bf6cfd6a7684e$var$getPhaseDate[updateFrom](phb.phase);
            const toDate = $358bf6cfd6a7684e$var$getPhaseDate[updateTo](phb.phase);
            const amountPerDuration = amount / (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).max([
                toDate - fromDate,
                1
            ]);
            let allocations = $358bf6cfd6a7684e$var$getFutureAllocations(phb.phase, phb, updateFrom === "startDate" ? new Date(0) : new Date());
            let date;
            while(!date || date < toDate){
                var _date2;
                (_date2 = date) !== null && _date2 !== void 0 ? _date2 : date = fromDate;
                const prevDate = date;
                date = (0, $4hBm1.endOfMonth)((0, $4hBm1.addDays)(date, 1));
                let alAmount = (0, $hVjuY.logRound)(amountPerDuration * (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).max([
                    date - prevDate,
                    1
                ]));
                if (date > toDate) {
                    date = toDate;
                    alAmount = amount;
                }
                const al = allocations.shift() || (0, $jg8jZ.default).add({
                    projectId: phb.project.id,
                    phaseId: phb.phase.id,
                    staffId: phb.staffId,
                    roleId: phb.roleId
                }, {
                    trackUpdates: true
                });
                al.update({
                    date: date,
                    numMinutes: alAmount * 60,
                    deletedAt: null
                });
                amount -= alAmount;
            }
            allocations.forEach((al)=>al.update({
                    deletedAt: new Date(),
                    hours: 0
                }));
        });
    });
};

});
parcelRegister("hVjuY", function(module, exports) {

$parcel$export(module.exports, "niceScale", function () { return $035e0be968c92784$export$3d277fa4028b79fa; });
$parcel$export(module.exports, "logRound", function () { return $035e0be968c92784$export$43d207fa0e038737; });
const $035e0be968c92784$export$3d277fa4028b79fa = (range, intervals)=>{
    const length = range[1] - range[0];
    let intervalLength = $035e0be968c92784$export$15ddf536a55ce7ba(length / intervals);
    const intervalValues = [];
    let i = 0;
    let latestIntervalValue = 0;
    while(latestIntervalValue < range[1]){
        let intervalValue = range[0] + intervalLength * i;
        intervalValues.push(intervalValue);
        i++;
        latestIntervalValue = intervalValue;
    }
    return intervalValues;
};
const $035e0be968c92784$var$roundingScale = (num)=>{
    const scaleLog = Math.floor(Math.log10(num));
    const scale = Math.pow(10, scaleLog);
    return scale;
};
const $035e0be968c92784$export$43d207fa0e038737 = (num)=>{
    const scale = $035e0be968c92784$var$roundingScale(num);
    return Math.round(num / scale) * scale;
};
const $035e0be968c92784$export$15ddf536a55ce7ba = (num)=>{
    const scale = $035e0be968c92784$var$roundingScale(num);
    return Math.floor(num / scale) * scale;
};
const $035e0be968c92784$export$e9c91d6eb1d3335a = (num)=>{
    const scale = $035e0be968c92784$var$roundingScale(num);
    return Math.ceil(num / scale) * scale;
};

});



parcelRegister("26CpJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1889f082cca337d1$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $iOQGT = parcelRequire("iOQGT");

var $iKbxs = parcelRequire("iKbxs");

var $3H03w = parcelRequire("3H03w");
var $1889f082cca337d1$var$_class, $1889f082cca337d1$var$_descriptor, $1889f082cca337d1$var$_descriptor2, $1889f082cca337d1$var$_descriptor3;
function $1889f082cca337d1$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $1889f082cca337d1$var$_defineProperty(e, r, t) {
    return (r = $1889f082cca337d1$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $1889f082cca337d1$var$_toPropertyKey(t) {
    var i = $1889f082cca337d1$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $1889f082cca337d1$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $1889f082cca337d1$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $1889f082cca337d1$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $1889f082cca337d1$var$DateRangeDataStore = ($1889f082cca337d1$var$_class = class DateRangeDataStore {
    // idle, saving, error
    // {id: {
    //     collection
    //     dateRange
    //     field
    //     value
    //     filters
    // }}
    constructor(props){
        $1889f082cca337d1$var$_initializerDefineProperty(this, "dateRangeData", $1889f082cca337d1$var$_descriptor, this);
        $1889f082cca337d1$var$_initializerDefineProperty(this, "savingDateRangeData", $1889f082cca337d1$var$_descriptor2, this);
        $1889f082cca337d1$var$_initializerDefineProperty(this, "saveState", $1889f082cca337d1$var$_descriptor3, this);
        (0, $4JcCM.makeObservable)(this);
    }
    get needsSaving() {
        return Object.values(this.dateRangeData).length > 0;
    }
    clearData() {
        this.dateRangeData = {};
    }
    addData(id, data) {
        this.dateRangeData[id] = data;
    }
    async startSave() {
        if (this.needsSaving && this.saveState !== "saving" && this.saveState !== "error") try {
            this.saveState = "saving";
            this.savingDateRangeData = this.dateRangeData;
            this.dateRangeData = {};
            await (0, $iOQGT.makeRequest)({
                path: `api/v1.5/save-date-range`,
                method: "post",
                data: Object.values(this.savingDateRangeData)
            });
            this.saveState = "success";
            if (this.needsSaving) this.startSave();
            else setTimeout(()=>{
                if (this.saveState === "success") this.saveState = "idle";
            }, 1000);
        } catch (e) {
            $iKbxs.captureException(e);
            (0, $3H03w.default).captureException(e);
            console.error(e.message);
            this.saveState = "error";
            this.dateRangeData = {
                ...this.dateRangeData,
                ...this.savingDateRangeData
            };
            throw e;
        }
        return;
    }
}, $1889f082cca337d1$var$_descriptor = $1889f082cca337d1$var$_applyDecoratedDescriptor($1889f082cca337d1$var$_class.prototype, "dateRangeData", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $1889f082cca337d1$var$_descriptor2 = $1889f082cca337d1$var$_applyDecoratedDescriptor($1889f082cca337d1$var$_class.prototype, "savingDateRangeData", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $1889f082cca337d1$var$_descriptor3 = $1889f082cca337d1$var$_applyDecoratedDescriptor($1889f082cca337d1$var$_class.prototype, "saveState", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "idle";
    }
}), $1889f082cca337d1$var$_applyDecoratedDescriptor($1889f082cca337d1$var$_class.prototype, "needsSaving", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($1889f082cca337d1$var$_class.prototype, "needsSaving"), $1889f082cca337d1$var$_class.prototype), $1889f082cca337d1$var$_applyDecoratedDescriptor($1889f082cca337d1$var$_class.prototype, "clearData", [
    (0, $4JcCM.action)
], Object.getOwnPropertyDescriptor($1889f082cca337d1$var$_class.prototype, "clearData"), $1889f082cca337d1$var$_class.prototype), $1889f082cca337d1$var$_applyDecoratedDescriptor($1889f082cca337d1$var$_class.prototype, "addData", [
    (0, $4JcCM.action)
], Object.getOwnPropertyDescriptor($1889f082cca337d1$var$_class.prototype, "addData"), $1889f082cca337d1$var$_class.prototype), $1889f082cca337d1$var$_applyDecoratedDescriptor($1889f082cca337d1$var$_class.prototype, "startSave", [
    (0, $4JcCM.action)
], Object.getOwnPropertyDescriptor($1889f082cca337d1$var$_class.prototype, "startSave"), $1889f082cca337d1$var$_class.prototype), $1889f082cca337d1$var$_class);
var $1889f082cca337d1$export$2e2bcd8739ae039 = new $1889f082cca337d1$var$DateRangeDataStore();

});

parcelRegister("cv7Es", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $919e50bf6ea0aded$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");
parcelRequire("iOQGT");

var $iKbxs = parcelRequire("iKbxs");

var $3H03w = parcelRequire("3H03w");

var $3h7sC = parcelRequire("3h7sC");
var $919e50bf6ea0aded$var$_dec, $919e50bf6ea0aded$var$_dec2, $919e50bf6ea0aded$var$_dec3, $919e50bf6ea0aded$var$_class, $919e50bf6ea0aded$var$_descriptor, $919e50bf6ea0aded$var$_descriptor2, $919e50bf6ea0aded$var$_descriptor3;
function $919e50bf6ea0aded$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $919e50bf6ea0aded$var$_defineProperty(e, r, t) {
    return (r = $919e50bf6ea0aded$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $919e50bf6ea0aded$var$_toPropertyKey(t) {
    var i = $919e50bf6ea0aded$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $919e50bf6ea0aded$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $919e50bf6ea0aded$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $919e50bf6ea0aded$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $919e50bf6ea0aded$var$BatchDataStore = ($919e50bf6ea0aded$var$_dec = (0, $4JcCM.action).bound, $919e50bf6ea0aded$var$_dec2 = (0, $4JcCM.action).bound, $919e50bf6ea0aded$var$_dec3 = (0, $4JcCM.action).bound, $919e50bf6ea0aded$var$_class = class BatchDataStore {
    // idle, saving, error
    // {id: {
    //     collection
    //     filters
    //     data
    // }}
    constructor(props){
        $919e50bf6ea0aded$var$_initializerDefineProperty(this, "batchData", $919e50bf6ea0aded$var$_descriptor, this);
        $919e50bf6ea0aded$var$_initializerDefineProperty(this, "savingBatchData", $919e50bf6ea0aded$var$_descriptor2, this);
        $919e50bf6ea0aded$var$_initializerDefineProperty(this, "saveState", $919e50bf6ea0aded$var$_descriptor3, this);
        (0, $4JcCM.makeObservable)(this);
    }
    get needsSaving() {
        return this.batchData.length > 0;
    }
    clearData() {
        this.batchData = [];
    }
    addData(data) {
        this.batchData.push(data);
    }
    async startSave(afterSave) {
        if (this.needsSaving && this.saveState !== "saving" && this.saveState !== "error") try {
            this.saveState = "saving";
            this.savingBatchData = this.batchData;
            this.batchData = [];
            for (const batchItem of this.savingBatchData)await (0, $3h7sC.trpc).legacy.batchSaveData.mutate(batchItem);
            this.saveState = "success";
            if (this.needsSaving) this.startSave();
            else {
                afterSave && afterSave();
                setTimeout(()=>{
                    if (this.saveState === "success") this.saveState = "idle";
                }, 1000);
            }
        } catch (e) {
            $iKbxs.captureException(e);
            (0, $3H03w.default).captureException(e);
            console.error(e.message);
            this.saveState = "error";
            this.batchData = [
                ...this.savingBatchData,
                ...this.batchData
            ];
            throw e;
        }
        return;
    }
}, $919e50bf6ea0aded$var$_descriptor = $919e50bf6ea0aded$var$_applyDecoratedDescriptor($919e50bf6ea0aded$var$_class.prototype, "batchData", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $919e50bf6ea0aded$var$_descriptor2 = $919e50bf6ea0aded$var$_applyDecoratedDescriptor($919e50bf6ea0aded$var$_class.prototype, "savingBatchData", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $919e50bf6ea0aded$var$_descriptor3 = $919e50bf6ea0aded$var$_applyDecoratedDescriptor($919e50bf6ea0aded$var$_class.prototype, "saveState", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "idle";
    }
}), $919e50bf6ea0aded$var$_applyDecoratedDescriptor($919e50bf6ea0aded$var$_class.prototype, "needsSaving", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($919e50bf6ea0aded$var$_class.prototype, "needsSaving"), $919e50bf6ea0aded$var$_class.prototype), $919e50bf6ea0aded$var$_applyDecoratedDescriptor($919e50bf6ea0aded$var$_class.prototype, "clearData", [
    $919e50bf6ea0aded$var$_dec
], Object.getOwnPropertyDescriptor($919e50bf6ea0aded$var$_class.prototype, "clearData"), $919e50bf6ea0aded$var$_class.prototype), $919e50bf6ea0aded$var$_applyDecoratedDescriptor($919e50bf6ea0aded$var$_class.prototype, "addData", [
    $919e50bf6ea0aded$var$_dec2
], Object.getOwnPropertyDescriptor($919e50bf6ea0aded$var$_class.prototype, "addData"), $919e50bf6ea0aded$var$_class.prototype), $919e50bf6ea0aded$var$_applyDecoratedDescriptor($919e50bf6ea0aded$var$_class.prototype, "startSave", [
    $919e50bf6ea0aded$var$_dec3
], Object.getOwnPropertyDescriptor($919e50bf6ea0aded$var$_class.prototype, "startSave"), $919e50bf6ea0aded$var$_class.prototype), $919e50bf6ea0aded$var$_class);
var $919e50bf6ea0aded$export$2e2bcd8739ae039 = new $919e50bf6ea0aded$var$BatchDataStore();

});
parcelRegister("3h7sC", function(module, exports) {

$parcel$export(module.exports, "trpc", function () { return $6d8cb2f6446fea12$export$26420885829a1061; });

var $1BTI2 = parcelRequire("1BTI2");

var $2clhi = parcelRequire("2clhi");
var $lorg3 = parcelRequire("lorg3");

var $3H03w = parcelRequire("3H03w");
const $6d8cb2f6446fea12$export$26420885829a1061 = (0, $2clhi.createTRPCProxyClient)({
    links: [
        (0, $lorg3.h)({
            url: `${"https://server2.coincraft.co"}/trpc`,
            async headers () {
                const headers = {};
                // if (usingNewLogin()) {
                //     const token = await clerk?.session?.getToken?.({
                //         template: 'coincraft',
                //     })
                //     headers.Authorization = token ? `Bearer ${token}` : ''
                // } else {
                // Add legacy auth headers
                if ((0, $1BTI2.default).userId) headers["x-user-id"] = (0, $1BTI2.default).userId;
                if ((0, $1BTI2.default).organisationId) headers["x-org-id"] = (0, $1BTI2.default).organisationId;
                // }
                // Add PostHog session info for server-side event tracking
                try {
                    const sessionId = (0, $3H03w.default).get_session_id();
                    const distinctId = (0, $3H03w.default).get_distinct_id();
                    if (sessionId) headers["x-posthog-session-id"] = sessionId;
                    if (distinctId) headers["x-posthog-distinct-id"] = distinctId;
                } catch (error) {
                    // PostHog might not be initialized yet, that's ok
                    console.debug("PostHog session info not available:", error.message);
                }
                return headers;
            },
            fetch (url, options) {
                return fetch(url, {
                    ...options,
                    credentials: "include"
                });
            }
        })
    ]
});

});
parcelRegister("2clhi", function(module, exports) {

$parcel$export(module.exports, "createTRPCProxyClient", function () { return $40a4297abc514c93$export$29b633cf6ed54809; });
$parcel$export(module.exports, "httpBatchLink", function () { return (parcelRequire("lorg3")).h; });

var $3Hgap = parcelRequire("3Hgap");

var $jLPJc = parcelRequire("jLPJc");

var $jdQPa = parcelRequire("jdQPa");

var $ih57M = parcelRequire("ih57M");

var $gqfK1 = parcelRequire("gqfK1");

var $lorg3 = parcelRequire("lorg3");

var $1i6Yt = parcelRequire("1i6Yt");

var $dHIwi = parcelRequire("dHIwi");

var $3RI63 = parcelRequire("3RI63");
parcelRequire("9G4X6");
class $40a4297abc514c93$export$a10d649cc8f633d5 {
    $request({ type: type, input: input, path: path, context: context = {} }) {
        const chain$ = (0, $jLPJc.c)({
            links: this.links,
            op: {
                id: ++this.requestId,
                type: type,
                path: path,
                input: input,
                context: context
            }
        });
        return chain$.pipe((0, $3Hgap.share)());
    }
    requestAsPromise(opts) {
        const req$ = this.$request(opts);
        const { promise: promise, abort: abort } = (0, $3Hgap.observableToPromise)(req$);
        const abortablePromise = new Promise((resolve, reject)=>{
            opts.signal?.addEventListener("abort", abort);
            promise.then((envelope)=>{
                resolve(envelope.result.data);
            }).catch((err)=>{
                reject((0, $jdQPa.T).from(err));
            });
        });
        return abortablePromise;
    }
    query(path, input, opts) {
        return this.requestAsPromise({
            type: "query",
            path: path,
            input: input,
            context: opts?.context,
            signal: opts?.signal
        });
    }
    mutation(path, input, opts) {
        return this.requestAsPromise({
            type: "mutation",
            path: path,
            input: input,
            context: opts?.context,
            signal: opts?.signal
        });
    }
    subscription(path, input, opts) {
        const observable$ = this.$request({
            type: "subscription",
            path: path,
            input: input,
            context: opts?.context
        });
        return observable$.subscribe({
            next (envelope) {
                if (envelope.result.type === "started") opts.onStarted?.();
                else if (envelope.result.type === "stopped") opts.onStopped?.();
                else opts.onData?.(envelope.result.data);
            },
            error (err) {
                opts.onError?.(err);
            },
            complete () {
                opts.onComplete?.();
            }
        });
    }
    constructor(opts){
        this.requestId = 0;
        const combinedTransformer = (()=>{
            const transformer = opts.transformer;
            if (!transformer) return {
                input: {
                    serialize: (data)=>data,
                    deserialize: (data)=>data
                },
                output: {
                    serialize: (data)=>data,
                    deserialize: (data)=>data
                }
            };
            if ("input" in transformer) return opts.transformer;
            return {
                input: transformer,
                output: transformer
            };
        })();
        this.runtime = {
            transformer: {
                serialize: (data)=>combinedTransformer.input.serialize(data),
                deserialize: (data)=>combinedTransformer.output.deserialize(data)
            },
            combinedTransformer: combinedTransformer
        };
        // Initialize the links
        this.links = opts.links.map((link)=>link(this.runtime));
    }
}
function $40a4297abc514c93$export$3f94c4551b43e9f9(opts) {
    return new $40a4297abc514c93$export$a10d649cc8f633d5(opts);
}
/**
 * @deprecated use `createTRPCProxyClient` instead
 */ function $40a4297abc514c93$export$b2acd49cd3814618(opts) {
    const client = new $40a4297abc514c93$export$a10d649cc8f633d5(opts);
    return client;
}
const $40a4297abc514c93$var$clientCallTypeMap = {
    query: "query",
    mutate: "mutation",
    subscribe: "subscription"
};
/** @internal */ const $40a4297abc514c93$export$fb09c8ac507dc94d = (clientCallType)=>{
    return $40a4297abc514c93$var$clientCallTypeMap[clientCallType];
};
/**
 * @deprecated use `createTRPCProxyClient` instead
 * @internal
 */ function $40a4297abc514c93$export$a66136bdbd4ef050(client) {
    return (0, $ih57M.createFlatProxy)((key)=>{
        if (client.hasOwnProperty(key)) return client[key];
        if (key === "__untypedClient") return client;
        return (0, $ih57M.createRecursiveProxy)(({ path: path, args: args })=>{
            const pathCopy = [
                key,
                ...path
            ];
            const procedureType = $40a4297abc514c93$export$fb09c8ac507dc94d(pathCopy.pop());
            const fullPath = pathCopy.join(".");
            return client[procedureType](fullPath, ...args);
        });
    });
}
function $40a4297abc514c93$export$29b633cf6ed54809(opts) {
    const client = new $40a4297abc514c93$export$a10d649cc8f633d5(opts);
    const proxy = $40a4297abc514c93$export$a66136bdbd4ef050(client);
    return proxy;
}
/**
 * Get an untyped client from a proxy client
 * @internal
 */ function $40a4297abc514c93$export$53bfa8a200ae4db4(client) {
    return client.__untypedClient;
}
function $40a4297abc514c93$var$getTextDecoder(customTextDecoder) {
    if (customTextDecoder) return customTextDecoder;
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    if (typeof window !== "undefined" && window.TextDecoder) return new window.TextDecoder();
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    if (typeof globalThis !== "undefined" && globalThis.TextDecoder) return new globalThis.TextDecoder();
    throw new Error("No TextDecoder implementation found");
}
// Stream parsing adapted from https://www.loginradius.com/blog/engineering/guest-post/http-streaming-with-nodejs-and-fetch-api/
/**
 * @internal
 * @description Take a stream of bytes and call `onLine` with
 * a JSON object for each line in the stream. Expected stream
 * format is:
 * ```json
 * {"1": {...}
 * ,"0": {...}
 * }
 * ```
 */ async function $40a4297abc514c93$var$parseJSONStream(opts) {
    const parse = opts.parse ?? JSON.parse;
    const onLine = (line)=>{
        if (opts.signal?.aborted) return;
        if (!line || line === "}") return;
        /**
     * At this point, `line` can be one of two things:
     * - The first line of the stream `{"2":{...}`
     * - A line in the middle of the stream `,"2":{...}`
     */ const indexOfColon = line.indexOf(":");
        const indexAsStr = line.substring(2, indexOfColon - 1);
        const text = line.substring(indexOfColon + 1);
        opts.onSingle(Number(indexAsStr), parse(text));
    };
    await $40a4297abc514c93$var$readLines(opts.readableStream, onLine, opts.textDecoder);
}
/**
 * Handle transforming a stream of bytes into lines of text.
 * To avoid using AsyncIterators / AsyncGenerators,
 * we use a callback for each line.
 *
 * @param readableStream can be a NodeJS stream or a WebAPI stream
 * @param onLine will be called for every line ('\n' delimited) in the stream
 */ async function $40a4297abc514c93$var$readLines(readableStream, onLine, textDecoder) {
    let partOfLine = "";
    const onChunk = (chunk)=>{
        const chunkText = textDecoder.decode(chunk);
        const chunkLines = chunkText.split("\n");
        if (chunkLines.length === 1) partOfLine += chunkLines[0];
        else if (chunkLines.length > 1) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- length checked on line above
            onLine(partOfLine + chunkLines[0]);
            for(let i = 1; i < chunkLines.length - 1; i++)// eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- length checked on line above
            onLine(chunkLines[i]);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- length doesn't change, so is necessarily > 1
            partOfLine = chunkLines[chunkLines.length - 1];
        }
    };
    // we handle 2 different types of streams, this if where we figure out which one we have
    if ("getReader" in readableStream) await $40a4297abc514c93$var$readStandardChunks(readableStream, onChunk);
    else await $40a4297abc514c93$var$readNodeChunks(readableStream, onChunk);
    onLine(partOfLine);
}
/**
 * Handle NodeJS stream
 */ function $40a4297abc514c93$var$readNodeChunks(stream, onChunk) {
    return new Promise((resolve)=>{
        stream.on("data", onChunk);
        stream.on("end", resolve);
    });
}
/**
 * Handle WebAPI stream
 */ async function $40a4297abc514c93$var$readStandardChunks(stream, onChunk) {
    const reader = stream.getReader();
    let readResult = await reader.read();
    while(!readResult.done){
        onChunk(readResult.value);
        readResult = await reader.read();
    }
}
const $40a4297abc514c93$var$streamingJsonHttpRequester = (opts, onSingle)=>{
    const ac = opts.AbortController ? new opts.AbortController() : null;
    const responsePromise = (0, $gqfK1.f)({
        ...opts,
        contentTypeHeader: "application/json",
        batchModeHeader: "stream",
        getUrl: $gqfK1.g,
        getBody: (0, $gqfK1.a)
    }, ac);
    const cancel = ()=>ac?.abort();
    const promise = responsePromise.then(async (res)=>{
        if (!res.body) throw new Error("Received response without body");
        const meta = {
            response: res
        };
        return $40a4297abc514c93$var$parseJSONStream({
            readableStream: res.body,
            onSingle: onSingle,
            parse: (string)=>({
                    json: JSON.parse(string),
                    meta: meta
                }),
            signal: ac?.signal,
            textDecoder: opts.textDecoder
        });
    });
    return {
        cancel: cancel,
        promise: promise
    };
};
const $40a4297abc514c93$var$streamRequester = (requesterOpts)=>{
    const textDecoder = $40a4297abc514c93$var$getTextDecoder(requesterOpts.opts.textDecoder);
    return (batchOps, unitResolver)=>{
        const path = batchOps.map((op)=>op.path).join(",");
        const inputs = batchOps.map((op)=>op.input);
        const { cancel: cancel, promise: promise } = $40a4297abc514c93$var$streamingJsonHttpRequester({
            ...requesterOpts,
            textDecoder: textDecoder,
            path: path,
            inputs: inputs,
            headers () {
                if (!requesterOpts.opts.headers) return {};
                if (typeof requesterOpts.opts.headers === "function") return requesterOpts.opts.headers({
                    opList: batchOps
                });
                return requesterOpts.opts.headers;
            }
        }, (index, res)=>{
            unitResolver(index, res);
        });
        return {
            /**
       * return an empty array because the batchLoader expects an array of results
       * but we've already called the `unitResolver` for each of them, there's
       * nothing left to do here.
       */ promise: promise.then(()=>[]),
            cancel: cancel
        };
    };
};
const $40a4297abc514c93$export$24eee9f0ddf4df55 = (0, $lorg3.c)($40a4297abc514c93$var$streamRequester);
const $40a4297abc514c93$var$getBody = (opts)=>{
    if (!("input" in opts)) return undefined;
    if (!(opts.input instanceof FormData)) throw new Error("Input is not FormData");
    return opts.input;
};
const $40a4297abc514c93$var$formDataRequester = (opts)=>{
    if (opts.type !== "mutation") // TODO(?) handle formdata queries
    throw new Error("We only handle mutations with formdata");
    return (0, $gqfK1.h)({
        ...opts,
        getUrl () {
            return `${opts.url}/${opts.path}`;
        },
        getBody: $40a4297abc514c93$var$getBody
    });
};
const $40a4297abc514c93$export$4e7fd0d93e18bb17 = (0, $1i6Yt.httpLinkFactory)({
    requester: $40a4297abc514c93$var$formDataRequester
});

});
parcelRegister("3Hgap", function(module, exports) {

module.exports = (parcelRequire("8mDh4"));

});
parcelRegister("8mDh4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fCBAx = parcelRequire("fCBAx");
function $616ed7dda565ddc5$var$share(_opts) {
    return (originalObserver)=>{
        let refCount = 0;
        let subscription = null;
        const observers = [];
        function startIfNeeded() {
            if (subscription) return;
            subscription = originalObserver.subscribe({
                next (value) {
                    for (const observer of observers)observer.next?.(value);
                },
                error (error) {
                    for (const observer of observers)observer.error?.(error);
                },
                complete () {
                    for (const observer of observers)observer.complete?.();
                }
            });
        }
        function resetIfNeeded() {
            // "resetOnRefCountZero"
            if (refCount === 0 && subscription) {
                const _sub = subscription;
                subscription = null;
                _sub.unsubscribe();
            }
        }
        return {
            subscribe (observer) {
                refCount++;
                observers.push(observer);
                startIfNeeded();
                return {
                    unsubscribe () {
                        refCount--;
                        resetIfNeeded();
                        const index = observers.findIndex((v)=>v === observer);
                        if (index > -1) observers.splice(index, 1);
                    }
                };
            }
        };
    };
}
function $616ed7dda565ddc5$var$map(project) {
    return (originalObserver)=>{
        return {
            subscribe (observer) {
                let index = 0;
                const subscription = originalObserver.subscribe({
                    next (value) {
                        observer.next?.(project(value, index++));
                    },
                    error (error) {
                        observer.error?.(error);
                    },
                    complete () {
                        observer.complete?.();
                    }
                });
                return subscription;
            }
        };
    };
}
function $616ed7dda565ddc5$var$tap(observer) {
    return (originalObserver)=>{
        return {
            subscribe (observer2) {
                return originalObserver.subscribe({
                    next (v) {
                        observer.next?.(v);
                        observer2.next?.(v);
                    },
                    error (v) {
                        observer.error?.(v);
                        observer2.error?.(v);
                    },
                    complete () {
                        observer.complete?.();
                        observer2.complete?.();
                    }
                });
            }
        };
    };
}
class $616ed7dda565ddc5$var$ObservableAbortError extends Error {
    constructor(message){
        super(message);
        this.name = "ObservableAbortError";
        Object.setPrototypeOf(this, $616ed7dda565ddc5$var$ObservableAbortError.prototype);
    }
}
/** @internal */ function $616ed7dda565ddc5$var$observableToPromise(observable) {
    let abort;
    const promise = new Promise((resolve, reject)=>{
        let isDone = false;
        function onDone() {
            if (isDone) return;
            isDone = true;
            reject(new $616ed7dda565ddc5$var$ObservableAbortError("This operation was aborted."));
            obs$.unsubscribe();
        }
        const obs$ = observable.subscribe({
            next (data) {
                isDone = true;
                resolve(data);
                onDone();
            },
            error (data) {
                isDone = true;
                reject(data);
                onDone();
            },
            complete () {
                isDone = true;
                onDone();
            }
        });
        abort = onDone;
    });
    return {
        promise: promise,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        abort: abort
    };
}
module.exports.isObservable = $fCBAx.isObservable;
module.exports.observable = $fCBAx.observable;
module.exports.map = $616ed7dda565ddc5$var$map;
module.exports.observableToPromise = $616ed7dda565ddc5$var$observableToPromise;
module.exports.share = $616ed7dda565ddc5$var$share;
module.exports.tap = $616ed7dda565ddc5$var$tap;

});
parcelRegister("fCBAx", function(module, exports) {

$parcel$export(module.exports, "isObservable", function () { return $b5f78fe5d5805a5c$export$5cd057a6046189f9; }, function (v) { return $b5f78fe5d5805a5c$export$5cd057a6046189f9 = v; });
$parcel$export(module.exports, "observable", function () { return $b5f78fe5d5805a5c$export$5ab46cbf6120b33a; }, function (v) { return $b5f78fe5d5805a5c$export$5ab46cbf6120b33a = v; });
var $b5f78fe5d5805a5c$export$5cd057a6046189f9;
var $b5f78fe5d5805a5c$export$5ab46cbf6120b33a;
"use strict";
function $b5f78fe5d5805a5c$var$identity(x) {
    return x;
}
/** @internal */ function $b5f78fe5d5805a5c$var$pipeFromArray(fns) {
    if (fns.length === 0) return $b5f78fe5d5805a5c$var$identity;
    if (fns.length === 1) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return fns[0];
    return function piped(input) {
        return fns.reduce((prev, fn)=>fn(prev), input);
    };
}
function $b5f78fe5d5805a5c$var$isObservable(x) {
    return typeof x === "object" && x !== null && "subscribe" in x;
}
function $b5f78fe5d5805a5c$var$observable(subscribe) {
    const self = {
        subscribe (observer) {
            let teardownRef = null;
            let isDone = false;
            let unsubscribed = false;
            let teardownImmediately = false;
            function unsubscribe() {
                if (teardownRef === null) {
                    teardownImmediately = true;
                    return;
                }
                if (unsubscribed) return;
                unsubscribed = true;
                if (typeof teardownRef === "function") teardownRef();
                else if (teardownRef) teardownRef.unsubscribe();
            }
            teardownRef = subscribe({
                next (value) {
                    if (isDone) return;
                    observer.next?.(value);
                },
                error (err) {
                    if (isDone) return;
                    isDone = true;
                    observer.error?.(err);
                    unsubscribe();
                },
                complete () {
                    if (isDone) return;
                    isDone = true;
                    observer.complete?.();
                    unsubscribe();
                }
            });
            if (teardownImmediately) unsubscribe();
            return {
                unsubscribe: unsubscribe
            };
        },
        pipe (...operations) {
            return $b5f78fe5d5805a5c$var$pipeFromArray(operations)(self);
        }
    };
    return self;
}
$b5f78fe5d5805a5c$export$5cd057a6046189f9 = $b5f78fe5d5805a5c$var$isObservable;
$b5f78fe5d5805a5c$export$5ab46cbf6120b33a = $b5f78fe5d5805a5c$var$observable;

});



parcelRegister("jLPJc", function(module, exports) {

$parcel$export(module.exports, "c", function () { return $e5bfdf19ef1b86d8$export$db3b6bfb95261072; });

var $3Hgap = parcelRequire("3Hgap");
/** @internal */ function $e5bfdf19ef1b86d8$export$db3b6bfb95261072(opts) {
    return (0, $3Hgap.observable)((observer)=>{
        function execute(index = 0, op = opts.op) {
            const next = opts.links[index];
            if (!next) throw new Error("No more links to execute - did you forget to add an ending link?");
            const subscription = next({
                op: op,
                next (nextOp) {
                    const nextObserver = execute(index + 1, nextOp);
                    return nextObserver;
                }
            });
            return subscription;
        }
        const obs$ = execute();
        return obs$.subscribe(observer);
    });
}
function $e5bfdf19ef1b86d8$var$asArray(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}
function $e5bfdf19ef1b86d8$export$2408f22a0fab9ae5(opts) {
    return (runtime)=>{
        const yes = $e5bfdf19ef1b86d8$var$asArray(opts.true).map((link)=>link(runtime));
        const no = $e5bfdf19ef1b86d8$var$asArray(opts.false).map((link)=>link(runtime));
        return (props)=>{
            return (0, $3Hgap.observable)((observer)=>{
                const links = opts.condition(props.op) ? yes : no;
                return $e5bfdf19ef1b86d8$export$db3b6bfb95261072({
                    op: props.op,
                    links: links
                }).subscribe(observer);
            });
        };
    };
}

});

parcelRegister("jdQPa", function(module, exports) {

$parcel$export(module.exports, "T", function () { return $29c378ff2f0505fb$export$971d5caa766a69d7; });

var $ih57M = parcelRequire("ih57M");

var $9G4X6 = parcelRequire("9G4X6");
function $29c378ff2f0505fb$var$isTRPCClientError(cause) {
    return cause instanceof $29c378ff2f0505fb$export$971d5caa766a69d7 || /**
     * @deprecated
     * Delete in next major
     */ cause instanceof Error && cause.name === "TRPCClientError";
}
function $29c378ff2f0505fb$var$isTRPCErrorResponse(obj) {
    return (0, $9G4X6.i)(obj) && (0, $9G4X6.i)(obj.error) && typeof obj.error.code === "number" && typeof obj.error.message === "string";
}
class $29c378ff2f0505fb$export$971d5caa766a69d7 extends Error {
    static from(_cause, opts = {}) {
        const cause = _cause;
        if ($29c378ff2f0505fb$var$isTRPCClientError(cause)) {
            if (opts.meta) // Decorate with meta error data
            cause.meta = {
                ...cause.meta,
                ...opts.meta
            };
            return cause;
        }
        if ($29c378ff2f0505fb$var$isTRPCErrorResponse(cause)) return new $29c378ff2f0505fb$export$971d5caa766a69d7(cause.error.message, {
            ...opts,
            result: cause
        });
        if (!(cause instanceof Error)) return new $29c378ff2f0505fb$export$971d5caa766a69d7("Unknown error", {
            ...opts,
            cause: cause
        });
        return new $29c378ff2f0505fb$export$971d5caa766a69d7(cause.message, {
            ...opts,
            cause: (0, $ih57M.getCauseFromUnknown)(cause)
        });
    }
    constructor(message, opts){
        const cause = opts?.cause;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore https://github.com/tc39/proposal-error-cause
        super(message, {
            cause: cause
        });
        this.meta = opts?.meta;
        this.cause = cause;
        this.shape = opts?.result?.error;
        this.data = opts?.result?.error.data;
        this.name = "TRPCClientError";
        Object.setPrototypeOf(this, $29c378ff2f0505fb$export$971d5caa766a69d7.prototype);
    }
}

});
parcelRegister("ih57M", function(module, exports) {

module.exports = (parcelRequire("6y3jP"));

});
parcelRegister("6y3jP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lJ52l = parcelRequire("lJ52l");

var $J4qUw = parcelRequire("J4qUw");

var $7aa6J = parcelRequire("7aa6J");
parcelRequire("7quQo");
module.exports.createFlatProxy = $lJ52l.createFlatProxy;
module.exports.createRecursiveProxy = $lJ52l.createRecursiveProxy;
module.exports.getErrorShape = $J4qUw.getErrorShape;
module.exports.transformTRPCResponse = $J4qUw.transformTRPCResponse;
module.exports.getCauseFromUnknown = $7aa6J.getCauseFromUnknown;

});
parcelRegister("lJ52l", function(module, exports) {

$parcel$export(module.exports, "createFlatProxy", function () { return $fd11b5237ced328c$export$341f807458b1fa7f; }, function (v) { return $fd11b5237ced328c$export$341f807458b1fa7f = v; });
$parcel$export(module.exports, "createRecursiveProxy", function () { return $fd11b5237ced328c$export$7b7795bbf1e1dd0c; }, function (v) { return $fd11b5237ced328c$export$7b7795bbf1e1dd0c = v; });
$parcel$export(module.exports, "getHTTPStatusCodeFromError", function () { return $fd11b5237ced328c$export$b7c4c86fc34f289; }, function (v) { return $fd11b5237ced328c$export$b7c4c86fc34f289 = v; });
var $fd11b5237ced328c$export$1c81d19d5f55b92b;
var $fd11b5237ced328c$export$341f807458b1fa7f;
var $fd11b5237ced328c$export$7b7795bbf1e1dd0c;
var $fd11b5237ced328c$export$10ee37adc9bafa65;
var $fd11b5237ced328c$export$b7c4c86fc34f289;
"use strict";

var $7quQo = parcelRequire("7quQo");
const $fd11b5237ced328c$var$TRPC_ERROR_CODES_BY_NUMBER = $7quQo.invert($7quQo.TRPC_ERROR_CODES_BY_KEY);
const $fd11b5237ced328c$var$JSONRPC2_TO_HTTP_CODE = {
    PARSE_ERROR: 400,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    NOT_FOUND: 404,
    FORBIDDEN: 403,
    METHOD_NOT_SUPPORTED: 405,
    TIMEOUT: 408,
    CONFLICT: 409,
    PRECONDITION_FAILED: 412,
    PAYLOAD_TOO_LARGE: 413,
    UNPROCESSABLE_CONTENT: 422,
    TOO_MANY_REQUESTS: 429,
    CLIENT_CLOSED_REQUEST: 499,
    INTERNAL_SERVER_ERROR: 500,
    NOT_IMPLEMENTED: 501
};
function $fd11b5237ced328c$var$getStatusCodeFromKey(code) {
    return $fd11b5237ced328c$var$JSONRPC2_TO_HTTP_CODE[code] ?? 500;
}
function $fd11b5237ced328c$var$getHTTPStatusCode(json) {
    const arr = Array.isArray(json) ? json : [
        json
    ];
    const httpStatuses = new Set(arr.map((res)=>{
        if ("error" in res) {
            const data = res.error.data;
            if (typeof data.httpStatus === "number") return data.httpStatus;
            const code = $fd11b5237ced328c$var$TRPC_ERROR_CODES_BY_NUMBER[res.error.code];
            return $fd11b5237ced328c$var$getStatusCodeFromKey(code);
        }
        return 200;
    }));
    if (httpStatuses.size !== 1) return 207;
    const httpStatus = httpStatuses.values().next().value;
    return httpStatus;
}
function $fd11b5237ced328c$var$getHTTPStatusCodeFromError(error) {
    return $fd11b5237ced328c$var$getStatusCodeFromKey(error.code);
}
const $fd11b5237ced328c$var$noop = ()=>{
// noop
};
function $fd11b5237ced328c$var$createInnerProxy(callback, path) {
    const proxy = new Proxy($fd11b5237ced328c$var$noop, {
        get (_obj, key) {
            if (typeof key !== "string" || key === "then") // special case for if the proxy is accidentally treated
            // like a PromiseLike (like in `Promise.resolve(proxy)`)
            return undefined;
            return $fd11b5237ced328c$var$createInnerProxy(callback, [
                ...path,
                key
            ]);
        },
        apply (_1, _2, args) {
            const isApply = path[path.length - 1] === "apply";
            return callback({
                args: isApply ? args.length >= 2 ? args[1] : [] : args,
                path: isApply ? path.slice(0, -1) : path
            });
        }
    });
    return proxy;
}
/**
 * Creates a proxy that calls the callback with the path and arguments
 *
 * @internal
 */ const $fd11b5237ced328c$var$createRecursiveProxy = (callback)=>$fd11b5237ced328c$var$createInnerProxy(callback, []);
/**
 * Used in place of `new Proxy` where each handler will map 1 level deep to another value.
 *
 * @internal
 */ const $fd11b5237ced328c$var$createFlatProxy = (callback)=>{
    return new Proxy($fd11b5237ced328c$var$noop, {
        get (_obj, name) {
            if (typeof name !== "string" || name === "then") // special case for if the proxy is accidentally treated
            // like a PromiseLike (like in `Promise.resolve(proxy)`)
            return undefined;
            return callback(name);
        }
    });
};
$fd11b5237ced328c$export$1c81d19d5f55b92b = $fd11b5237ced328c$var$TRPC_ERROR_CODES_BY_NUMBER;
$fd11b5237ced328c$export$341f807458b1fa7f = $fd11b5237ced328c$var$createFlatProxy;
$fd11b5237ced328c$export$7b7795bbf1e1dd0c = $fd11b5237ced328c$var$createRecursiveProxy;
$fd11b5237ced328c$export$10ee37adc9bafa65 = $fd11b5237ced328c$var$getHTTPStatusCode;
$fd11b5237ced328c$export$b7c4c86fc34f289 = $fd11b5237ced328c$var$getHTTPStatusCodeFromError;

});
parcelRegister("7quQo", function(module, exports) {

$parcel$export(module.exports, "TRPC_ERROR_CODES_BY_KEY", function () { return $5682e3177044b55c$export$bfde8546f9e43f6a; }, function (v) { return $5682e3177044b55c$export$bfde8546f9e43f6a = v; });
$parcel$export(module.exports, "invert", function () { return $5682e3177044b55c$export$6897c284b6f9f4dc; }, function (v) { return $5682e3177044b55c$export$6897c284b6f9f4dc = v; });
var $5682e3177044b55c$export$bfde8546f9e43f6a;
var $5682e3177044b55c$export$1c81d19d5f55b92b;
var $5682e3177044b55c$export$6897c284b6f9f4dc;
"use strict";
/**
 * @internal
 */ function $5682e3177044b55c$var$invert(obj) {
    const newObj = Object.create(null);
    for(const key in obj){
        const v = obj[key];
        newObj[v] = key;
    }
    return newObj;
}
// reference: https://www.jsonrpc.org/specification
/**
 * JSON-RPC 2.0 Error codes
 *
 * `-32000` to `-32099` are reserved for implementation-defined server-errors.
 * For tRPC we're copying the last digits of HTTP 4XX errors.
 */ const $5682e3177044b55c$var$TRPC_ERROR_CODES_BY_KEY = {
    /**
   * Invalid JSON was received by the server.
   * An error occurred on the server while parsing the JSON text.
   */ PARSE_ERROR: -32700,
    /**
   * The JSON sent is not a valid Request object.
   */ BAD_REQUEST: -32600,
    // Internal JSON-RPC error
    INTERNAL_SERVER_ERROR: -32603,
    NOT_IMPLEMENTED: -32603,
    // Implementation specific errors
    UNAUTHORIZED: -32001,
    FORBIDDEN: -32003,
    NOT_FOUND: -32004,
    METHOD_NOT_SUPPORTED: -32005,
    TIMEOUT: -32008,
    CONFLICT: -32009,
    PRECONDITION_FAILED: -32012,
    PAYLOAD_TOO_LARGE: -32013,
    UNPROCESSABLE_CONTENT: -32022,
    TOO_MANY_REQUESTS: -32029,
    CLIENT_CLOSED_REQUEST: -32099
};
const $5682e3177044b55c$var$TRPC_ERROR_CODES_BY_NUMBER = $5682e3177044b55c$var$invert($5682e3177044b55c$var$TRPC_ERROR_CODES_BY_KEY);
$5682e3177044b55c$export$bfde8546f9e43f6a = $5682e3177044b55c$var$TRPC_ERROR_CODES_BY_KEY;
$5682e3177044b55c$export$1c81d19d5f55b92b = $5682e3177044b55c$var$TRPC_ERROR_CODES_BY_NUMBER;
$5682e3177044b55c$export$6897c284b6f9f4dc = $5682e3177044b55c$var$invert;

});


parcelRegister("J4qUw", function(module, exports) {

$parcel$export(module.exports, "getErrorShape", function () { return $0877a464ef1f68f9$export$84f1b56083509104; }, function (v) { return $0877a464ef1f68f9$export$84f1b56083509104 = v; });
$parcel$export(module.exports, "transformTRPCResponse", function () { return $0877a464ef1f68f9$export$ba650e8f1d255662; }, function (v) { return $0877a464ef1f68f9$export$ba650e8f1d255662 = v; });
var $0877a464ef1f68f9$export$84f1b56083509104;
var $0877a464ef1f68f9$export$ba650e8f1d255662;
"use strict";

var $lJ52l = parcelRequire("lJ52l");

var $7quQo = parcelRequire("7quQo");
/**
 * @internal
 */ function $0877a464ef1f68f9$var$getErrorShape(opts) {
    const { path: path, error: error, config: config } = opts;
    const { code: code } = opts.error;
    const shape = {
        message: error.message,
        code: $7quQo.TRPC_ERROR_CODES_BY_KEY[code],
        data: {
            code: code,
            httpStatus: $lJ52l.getHTTPStatusCodeFromError(error)
        }
    };
    if (config.isDev && typeof opts.error.stack === "string") shape.data.stack = opts.error.stack;
    if (typeof path === "string") shape.data.path = path;
    return config.errorFormatter({
        ...opts,
        shape: shape
    });
}
function $0877a464ef1f68f9$var$transformTRPCResponseItem(config, item) {
    if ("error" in item) return {
        ...item,
        error: config.transformer.output.serialize(item.error)
    };
    if ("data" in item.result) return {
        ...item,
        result: {
            ...item.result,
            data: config.transformer.output.serialize(item.result.data)
        }
    };
    return item;
}
/**
 * Takes a unserialized `TRPCResponse` and serializes it with the router's transformers
 **/ function $0877a464ef1f68f9$var$transformTRPCResponse(config, itemOrItems) {
    return Array.isArray(itemOrItems) ? itemOrItems.map((item)=>$0877a464ef1f68f9$var$transformTRPCResponseItem(config, item)) : $0877a464ef1f68f9$var$transformTRPCResponseItem(config, itemOrItems);
}
$0877a464ef1f68f9$export$84f1b56083509104 = $0877a464ef1f68f9$var$getErrorShape;
$0877a464ef1f68f9$export$ba650e8f1d255662 = $0877a464ef1f68f9$var$transformTRPCResponse;

});

parcelRegister("7aa6J", function(module, exports) {

$parcel$export(module.exports, "getCauseFromUnknown", function () { return $53714eb904a25f16$export$22aa9a5f89dcf72; }, function (v) { return $53714eb904a25f16$export$22aa9a5f89dcf72 = v; });
var $53714eb904a25f16$export$22aa9a5f89dcf72;
"use strict";
/**
 * @internal
 */ function $53714eb904a25f16$var$isObject(value) {
    // check that value is object
    return !!value && !Array.isArray(value) && typeof value === "object";
}
class $53714eb904a25f16$var$UnknownCauseError extends Error {
}
function $53714eb904a25f16$var$getCauseFromUnknown(cause) {
    if (cause instanceof Error) return cause;
    const type = typeof cause;
    if (type === "undefined" || type === "function" || cause === null) return undefined;
    // Primitive types just get wrapped in an error
    if (type !== "object") return new Error(String(cause));
    // If it's an object, we'll create a synthetic error
    if ($53714eb904a25f16$var$isObject(cause)) {
        const err = new $53714eb904a25f16$var$UnknownCauseError();
        for(const key in cause)err[key] = cause[key];
        return err;
    }
    return undefined;
}
$53714eb904a25f16$export$22aa9a5f89dcf72 = $53714eb904a25f16$var$getCauseFromUnknown;

});



parcelRegister("9G4X6", function(module, exports) {

$parcel$export(module.exports, "i", function () { return $db0c30ee6826111a$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "t", function () { return $db0c30ee6826111a$export$625550452a3fa3ec; });
function $db0c30ee6826111a$export$23f2a1d2818174ef(value) {
    // check that value is object
    return !!value && !Array.isArray(value) && typeof value === "object";
}
// FIXME:
// - the generics here are probably unnecessary
// - the RPC-spec could probably be simplified to combine HTTP + WS
/** @internal */ function $db0c30ee6826111a$var$transformResultInner(response, runtime) {
    if ("error" in response) {
        const error = runtime.transformer.deserialize(response.error);
        return {
            ok: false,
            error: {
                ...response,
                error: error
            }
        };
    }
    const result = {
        ...response.result,
        ...(!response.result.type || response.result.type === "data") && {
            type: "data",
            data: runtime.transformer.deserialize(response.result.data)
        }
    };
    return {
        ok: true,
        result: result
    };
}
class $db0c30ee6826111a$var$TransformResultError extends Error {
    constructor(){
        super("Unable to transform response from server");
    }
}
/**
 * Transforms and validates that the result is a valid TRPCResponse
 * @internal
 */ function $db0c30ee6826111a$export$625550452a3fa3ec(response, runtime) {
    let result;
    try {
        // Use the data transformers on the JSON-response
        result = $db0c30ee6826111a$var$transformResultInner(response, runtime);
    } catch (err) {
        throw new $db0c30ee6826111a$var$TransformResultError();
    }
    // check that output of the transformers is a valid TRPCResponse
    if (!result.ok && (!$db0c30ee6826111a$export$23f2a1d2818174ef(result.error.error) || typeof result.error.error.code !== "number")) throw new $db0c30ee6826111a$var$TransformResultError();
    if (result.ok && !$db0c30ee6826111a$export$23f2a1d2818174ef(result.result)) throw new $db0c30ee6826111a$var$TransformResultError();
    return result;
}

});


parcelRegister("gqfK1", function(module, exports) {

$parcel$export(module.exports, "r", function () { return $2f260c924956915a$export$43caf9889c228507; });
$parcel$export(module.exports, "g", function () { return $2f260c924956915a$export$39b482c5e57630a8; });
$parcel$export(module.exports, "a", function () { return $2f260c924956915a$export$407448d2b89b1813; });
$parcel$export(module.exports, "j", function () { return $2f260c924956915a$export$35e795649ee09318; });
$parcel$export(module.exports, "h", function () { return $2f260c924956915a$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "f", function () { return $2f260c924956915a$export$2d1720544b23b823; });

var $jdQPa = parcelRequire("jdQPa");
const $2f260c924956915a$var$isFunction = (fn)=>typeof fn === "function";
function $2f260c924956915a$export$8b22cf2602fb60ce(customFetchImpl) {
    if (customFetchImpl) return customFetchImpl;
    if (typeof window !== "undefined" && $2f260c924956915a$var$isFunction(window.fetch)) return window.fetch;
    if (typeof globalThis !== "undefined" && $2f260c924956915a$var$isFunction(globalThis.fetch)) return globalThis.fetch;
    throw new Error("No fetch implementation found");
}
function $2f260c924956915a$var$getAbortController(customAbortControllerImpl) {
    if (customAbortControllerImpl) return customAbortControllerImpl;
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    if (typeof window !== "undefined" && window.AbortController) return window.AbortController;
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    if (typeof globalThis !== "undefined" && globalThis.AbortController) return globalThis.AbortController;
    return null;
}
function $2f260c924956915a$export$43caf9889c228507(opts) {
    return {
        url: opts.url.toString().replace(/\/$/, ""),
        fetch: opts.fetch,
        AbortController: $2f260c924956915a$var$getAbortController(opts.AbortController)
    };
}
// https://github.com/trpc/trpc/pull/669
function $2f260c924956915a$var$arrayToDict(array) {
    const dict = {};
    for(let index = 0; index < array.length; index++){
        const element = array[index];
        dict[index] = element;
    }
    return dict;
}
const $2f260c924956915a$var$METHOD = {
    query: "GET",
    mutation: "POST"
};
function $2f260c924956915a$var$getInput(opts) {
    return "input" in opts ? opts.runtime.transformer.serialize(opts.input) : $2f260c924956915a$var$arrayToDict(opts.inputs.map((_input)=>opts.runtime.transformer.serialize(_input)));
}
const $2f260c924956915a$export$39b482c5e57630a8 = (opts)=>{
    let url = opts.url + "/" + opts.path;
    const queryParts = [];
    if ("inputs" in opts) queryParts.push("batch=1");
    if (opts.type === "query") {
        const input = $2f260c924956915a$var$getInput(opts);
        if (input !== undefined) queryParts.push(`input=${encodeURIComponent(JSON.stringify(input))}`);
    }
    if (queryParts.length) url += "?" + queryParts.join("&");
    return url;
};
const $2f260c924956915a$export$407448d2b89b1813 = (opts)=>{
    if (opts.type === "query") return undefined;
    const input = $2f260c924956915a$var$getInput(opts);
    return input !== undefined ? JSON.stringify(input) : undefined;
};
const $2f260c924956915a$export$35e795649ee09318 = (opts)=>{
    return $2f260c924956915a$export$dda1d9f60106f0e9({
        ...opts,
        contentTypeHeader: "application/json",
        getUrl: $2f260c924956915a$export$39b482c5e57630a8,
        getBody: $2f260c924956915a$export$407448d2b89b1813
    });
};
async function $2f260c924956915a$export$2d1720544b23b823(opts, ac) {
    const url = opts.getUrl(opts);
    const body = opts.getBody(opts);
    const { type: type } = opts;
    const resolvedHeaders = await opts.headers();
    /* istanbul ignore if -- @preserve */ if (type === "subscription") throw new Error("Subscriptions should use wsLink");
    const headers = {
        ...opts.contentTypeHeader ? {
            "content-type": opts.contentTypeHeader
        } : {},
        ...opts.batchModeHeader ? {
            "trpc-batch-mode": opts.batchModeHeader
        } : {},
        ...resolvedHeaders
    };
    return $2f260c924956915a$export$8b22cf2602fb60ce(opts.fetch)(url, {
        method: $2f260c924956915a$var$METHOD[type],
        signal: ac?.signal,
        body: body,
        headers: headers
    });
}
function $2f260c924956915a$export$dda1d9f60106f0e9(opts) {
    const ac = opts.AbortController ? new opts.AbortController() : null;
    const meta = {};
    let done = false;
    const promise = new Promise((resolve, reject)=>{
        $2f260c924956915a$export$2d1720544b23b823(opts, ac).then((_res)=>{
            meta.response = _res;
            done = true;
            return _res.json();
        }).then((json)=>{
            meta.responseJSON = json;
            resolve({
                json: json,
                meta: meta
            });
        }).catch((err)=>{
            done = true;
            reject((0, $jdQPa.T).from(err, {
                meta: meta
            }));
        });
    });
    const cancel = ()=>{
        if (!done) ac?.abort();
    };
    return {
        promise: promise,
        cancel: cancel
    };
}

});

parcelRegister("lorg3", function(module, exports) {

$parcel$export(module.exports, "c", function () { return $8ab887dd78f00b5c$export$db3b6bfb95261072; });
$parcel$export(module.exports, "h", function () { return $8ab887dd78f00b5c$export$dda1d9f60106f0e9; });

var $3Hgap = parcelRequire("3Hgap");

var $9G4X6 = parcelRequire("9G4X6");

var $jdQPa = parcelRequire("jdQPa");

var $gqfK1 = parcelRequire("gqfK1");
/* eslint-disable @typescript-eslint/no-non-null-assertion */ /**
 * A function that should never be called unless we messed something up.
 */ const $8ab887dd78f00b5c$var$throwFatalError = ()=>{
    throw new Error("Something went wrong. Please submit an issue at https://github.com/trpc/trpc/issues/new");
};
/**
 * Dataloader that's very inspired by https://github.com/graphql/dataloader
 * Less configuration, no caching, and allows you to cancel requests
 * When cancelling a single fetch the whole batch will be cancelled only when _all_ items are cancelled
 */ function $8ab887dd78f00b5c$var$dataLoader(batchLoader) {
    let pendingItems = null;
    let dispatchTimer = null;
    const destroyTimerAndPendingItems = ()=>{
        clearTimeout(dispatchTimer);
        dispatchTimer = null;
        pendingItems = null;
    };
    /**
   * Iterate through the items and split them into groups based on the `batchLoader`'s validate function
   */ function groupItems(items) {
        const groupedItems = [
            []
        ];
        let index = 0;
        while(true){
            const item = items[index];
            if (!item) break;
            const lastGroup = groupedItems[groupedItems.length - 1];
            if (item.aborted) {
                // Item was aborted before it was dispatched
                item.reject?.(new Error("Aborted"));
                index++;
                continue;
            }
            const isValid = batchLoader.validate(lastGroup.concat(item).map((it)=>it.key));
            if (isValid) {
                lastGroup.push(item);
                index++;
                continue;
            }
            if (lastGroup.length === 0) {
                item.reject?.(new Error("Input is too big for a single dispatch"));
                index++;
                continue;
            }
            // Create new group, next iteration will try to add the item to that
            groupedItems.push([]);
        }
        return groupedItems;
    }
    function dispatch() {
        const groupedItems = groupItems(pendingItems);
        destroyTimerAndPendingItems();
        // Create batches for each group of items
        for (const items of groupedItems){
            if (!items.length) continue;
            const batch = {
                items: items,
                cancel: $8ab887dd78f00b5c$var$throwFatalError
            };
            for (const item of items)item.batch = batch;
            const unitResolver = (index, value)=>{
                const item = batch.items[index];
                item.resolve?.(value);
                item.batch = null;
                item.reject = null;
                item.resolve = null;
            };
            const { promise: promise, cancel: cancel } = batchLoader.fetch(batch.items.map((_item)=>_item.key), unitResolver);
            batch.cancel = cancel;
            promise.then((result)=>{
                for(let i = 0; i < result.length; i++){
                    const value = result[i];
                    unitResolver(i, value);
                }
                for (const item of batch.items){
                    item.reject?.(new Error("Missing result"));
                    item.batch = null;
                }
            }).catch((cause)=>{
                for (const item of batch.items){
                    item.reject?.(cause);
                    item.batch = null;
                }
            });
        }
    }
    function load(key) {
        const item = {
            aborted: false,
            key: key,
            batch: null,
            resolve: $8ab887dd78f00b5c$var$throwFatalError,
            reject: $8ab887dd78f00b5c$var$throwFatalError
        };
        const promise = new Promise((resolve, reject)=>{
            item.reject = reject;
            item.resolve = resolve;
            if (!pendingItems) pendingItems = [];
            pendingItems.push(item);
        });
        if (!dispatchTimer) dispatchTimer = setTimeout(dispatch);
        const cancel = ()=>{
            item.aborted = true;
            if (item.batch?.items.every((item)=>item.aborted)) {
                // All items in the batch have been cancelled
                item.batch.cancel();
                item.batch = null;
            }
        };
        return {
            promise: promise,
            cancel: cancel
        };
    }
    return {
        load: load
    };
}
/**
 * @internal
 */ function $8ab887dd78f00b5c$export$db3b6bfb95261072(requester) {
    return function httpBatchLink(opts) {
        const resolvedOpts = (0, $gqfK1.r)(opts);
        const maxURLLength = opts.maxURLLength ?? Infinity;
        // initialized config
        return (runtime)=>{
            const batchLoader = (type)=>{
                const validate = (batchOps)=>{
                    if (maxURLLength === Infinity) // escape hatch for quick calcs
                    return true;
                    const path = batchOps.map((op)=>op.path).join(",");
                    const inputs = batchOps.map((op)=>op.input);
                    const url = (0, $gqfK1.g)({
                        ...resolvedOpts,
                        runtime: runtime,
                        type: type,
                        path: path,
                        inputs: inputs
                    });
                    return url.length <= maxURLLength;
                };
                const fetch = requester({
                    ...resolvedOpts,
                    runtime: runtime,
                    type: type,
                    opts: opts
                });
                return {
                    validate: validate,
                    fetch: fetch
                };
            };
            const query = $8ab887dd78f00b5c$var$dataLoader(batchLoader("query"));
            const mutation = $8ab887dd78f00b5c$var$dataLoader(batchLoader("mutation"));
            const subscription = $8ab887dd78f00b5c$var$dataLoader(batchLoader("subscription"));
            const loaders = {
                query: query,
                subscription: subscription,
                mutation: mutation
            };
            return ({ op: op })=>{
                return (0, $3Hgap.observable)((observer)=>{
                    const loader = loaders[op.type];
                    const { promise: promise, cancel: cancel } = loader.load(op);
                    let _res = undefined;
                    promise.then((res)=>{
                        _res = res;
                        const transformed = (0, $9G4X6.t)(res.json, runtime);
                        if (!transformed.ok) {
                            observer.error((0, $jdQPa.T).from(transformed.error, {
                                meta: res.meta
                            }));
                            return;
                        }
                        observer.next({
                            context: res.meta,
                            result: transformed.result
                        });
                        observer.complete();
                    }).catch((err)=>{
                        observer.error((0, $jdQPa.T).from(err, {
                            meta: _res?.meta
                        }));
                    });
                    return ()=>{
                        cancel();
                    };
                });
            };
        };
    };
}
const $8ab887dd78f00b5c$var$batchRequester = (requesterOpts)=>{
    return (batchOps)=>{
        const path = batchOps.map((op)=>op.path).join(",");
        const inputs = batchOps.map((op)=>op.input);
        const { promise: promise, cancel: cancel } = (0, $gqfK1.j)({
            ...requesterOpts,
            path: path,
            inputs: inputs,
            headers () {
                if (!requesterOpts.opts.headers) return {};
                if (typeof requesterOpts.opts.headers === "function") return requesterOpts.opts.headers({
                    opList: batchOps
                });
                return requesterOpts.opts.headers;
            }
        });
        return {
            promise: promise.then((res)=>{
                const resJSON = Array.isArray(res.json) ? res.json : batchOps.map(()=>res.json);
                const result = resJSON.map((item)=>({
                        meta: res.meta,
                        json: item
                    }));
                return result;
            }),
            cancel: cancel
        };
    };
};
const $8ab887dd78f00b5c$export$dda1d9f60106f0e9 = $8ab887dd78f00b5c$export$db3b6bfb95261072($8ab887dd78f00b5c$var$batchRequester);

});

parcelRegister("1i6Yt", function(module, exports) {

$parcel$export(module.exports, "httpLinkFactory", function () { return $496d6c0d6e9ea03c$export$404a788fcf5149fa; });

var $3Hgap = parcelRequire("3Hgap");

var $9G4X6 = parcelRequire("9G4X6");

var $jdQPa = parcelRequire("jdQPa");

var $gqfK1 = parcelRequire("gqfK1");
parcelRequire("ih57M");
function $496d6c0d6e9ea03c$export$404a788fcf5149fa(factoryOpts) {
    return (opts)=>{
        const resolvedOpts = (0, $gqfK1.r)(opts);
        return (runtime)=>({ op: op })=>(0, $3Hgap.observable)((observer)=>{
                    const { path: path, input: input, type: type } = op;
                    const { promise: promise, cancel: cancel } = factoryOpts.requester({
                        ...resolvedOpts,
                        runtime: runtime,
                        type: type,
                        path: path,
                        input: input,
                        headers () {
                            if (!opts.headers) return {};
                            if (typeof opts.headers === "function") return opts.headers({
                                op: op
                            });
                            return opts.headers;
                        }
                    });
                    let meta = undefined;
                    promise.then((res)=>{
                        meta = res.meta;
                        const transformed = (0, $9G4X6.t)(res.json, runtime);
                        if (!transformed.ok) {
                            observer.error((0, $jdQPa.T).from(transformed.error, {
                                meta: meta
                            }));
                            return;
                        }
                        observer.next({
                            context: res.meta,
                            result: transformed.result
                        });
                        observer.complete();
                    }).catch((cause)=>{
                        observer.error((0, $jdQPa.T).from(cause, {
                            meta: meta
                        }));
                    });
                    return ()=>{
                        cancel();
                    };
                });
    };
}
/**
 * @see https://trpc.io/docs/client/links/httpLink
 */ const $496d6c0d6e9ea03c$export$9b6146f3c3e2c24a = $496d6c0d6e9ea03c$export$404a788fcf5149fa({
    requester: (0, $gqfK1.j)
});

});

parcelRegister("dHIwi", function(module, exports) {

var $3Hgap = parcelRequire("3Hgap");
/// <reference lib="dom.iterable" />
function $76d375b156eb18b4$var$isFormData(value) {
    if (typeof FormData === "undefined") // FormData is not supported
    return false;
    return value instanceof FormData;
}
const $76d375b156eb18b4$var$palettes = {
    css: {
        query: [
            "72e3ff",
            "3fb0d8"
        ],
        mutation: [
            "c5a3fc",
            "904dfc"
        ],
        subscription: [
            "ff49e1",
            "d83fbe"
        ]
    },
    ansi: {
        regular: {
            // Cyan background, black and white text respectively
            query: [
                "\x1b[30;46m",
                "\x1b[97;46m"
            ],
            // Magenta background, black and white text respectively
            mutation: [
                "\x1b[30;45m",
                "\x1b[97;45m"
            ],
            // Green background, black and white text respectively
            subscription: [
                "\x1b[30;42m",
                "\x1b[97;42m"
            ]
        },
        bold: {
            query: [
                "\x1b[1;30;46m",
                "\x1b[1;97;46m"
            ],
            mutation: [
                "\x1b[1;30;45m",
                "\x1b[1;97;45m"
            ],
            subscription: [
                "\x1b[1;30;42m",
                "\x1b[1;97;42m"
            ]
        }
    }
};
function $76d375b156eb18b4$var$constructPartsAndArgs(opts) {
    const { direction: direction, type: type, path: path, id: id, input: input } = opts;
    const parts = [];
    const args = [];
    if (opts.colorMode === "ansi") {
        const [lightRegular, darkRegular] = $76d375b156eb18b4$var$palettes.ansi.regular[type];
        const [lightBold, darkBold] = $76d375b156eb18b4$var$palettes.ansi.bold[type];
        const reset = "\x1b[0m";
        parts.push(direction === "up" ? lightRegular : darkRegular, direction === "up" ? ">>" : "<<", type, direction === "up" ? lightBold : darkBold, `#${id}`, path, reset);
        if (direction === "up") args.push({
            input: opts.input
        });
        else args.push({
            input: opts.input,
            // strip context from result cause it's too noisy in terminal wihtout collapse mode
            result: "result" in opts.result ? opts.result.result : opts.result,
            elapsedMs: opts.elapsedMs
        });
        return {
            parts: parts,
            args: args
        };
    }
    const [light, dark] = $76d375b156eb18b4$var$palettes.css[type];
    const css = `
    background-color: #${direction === "up" ? light : dark}; 
    color: ${direction === "up" ? "black" : "white"};
    padding: 2px;
  `;
    parts.push("%c", direction === "up" ? ">>" : "<<", type, `#${id}`, `%c${path}%c`, "%O");
    args.push(css, `${css}; font-weight: bold;`, `${css}; font-weight: normal;`);
    if (direction === "up") args.push({
        input: input,
        context: opts.context
    });
    else args.push({
        input: input,
        result: opts.result,
        elapsedMs: opts.elapsedMs,
        context: opts.context
    });
    return {
        parts: parts,
        args: args
    };
}
// maybe this should be moved to it's own package
const $76d375b156eb18b4$var$defaultLogger = ({ c: c = console, colorMode: colorMode = "css" })=>(props)=>{
        const rawInput = props.input;
        const input = $76d375b156eb18b4$var$isFormData(rawInput) ? Object.fromEntries(rawInput) : rawInput;
        const { parts: parts, args: args } = $76d375b156eb18b4$var$constructPartsAndArgs({
            ...props,
            colorMode: colorMode,
            input: input
        });
        const fn = props.direction === "down" && props.result && (props.result instanceof Error || "error" in props.result.result) ? "error" : "log";
        c[fn].apply(null, [
            parts.join(" ")
        ].concat(args));
    };
/**
 * @see https://trpc.io/docs/client/links/loggerLink
 */ function $76d375b156eb18b4$export$6c4954c1f47de3ce(opts = {}) {
    const { enabled: enabled = ()=>true } = opts;
    const colorMode = opts.colorMode ?? (typeof window === "undefined" ? "ansi" : "css");
    const { logger: logger = $76d375b156eb18b4$var$defaultLogger({
        c: opts.console,
        colorMode: colorMode
    }) } = opts;
    return ()=>{
        return ({ op: op, next: next })=>{
            return (0, $3Hgap.observable)((observer)=>{
                // ->
                enabled({
                    ...op,
                    direction: "up"
                }) && logger({
                    ...op,
                    direction: "up"
                });
                const requestStartTime = Date.now();
                function logResult(result) {
                    const elapsedMs = Date.now() - requestStartTime;
                    enabled({
                        ...op,
                        direction: "down",
                        result: result
                    }) && logger({
                        ...op,
                        direction: "down",
                        elapsedMs: elapsedMs,
                        result: result
                    });
                }
                return next(op).pipe((0, $3Hgap.tap)({
                    next (result) {
                        logResult(result);
                    },
                    error (result) {
                        logResult(result);
                    }
                })).subscribe(observer);
            });
        };
    };
}

});

parcelRegister("3RI63", function(module, exports) {

var $3Hgap = parcelRequire("3Hgap");

var $9G4X6 = parcelRequire("9G4X6");

var $jdQPa = parcelRequire("jdQPa");
parcelRequire("ih57M");
/* istanbul ignore next -- @preserve */ const $1227d8a1e403b319$var$retryDelay = (attemptIndex)=>attemptIndex === 0 ? 0 : Math.min(1000 * 2 ** attemptIndex, 30000);
function $1227d8a1e403b319$export$345df463fed6e4eb(opts) {
    const { url: url, WebSocket: WebSocketImpl = WebSocket, retryDelayMs: retryDelayFn = $1227d8a1e403b319$var$retryDelay, onOpen: onOpen, onClose: onClose } = opts;
    /* istanbul ignore next -- @preserve */ if (!WebSocketImpl) throw new Error("No WebSocket implementation found - you probably don't want to use this on the server, but if you do you need to pass a `WebSocket`-ponyfill");
    /**
   * outgoing messages buffer whilst not open
   */ let outgoing = [];
    const pendingRequests = Object.create(null);
    let connectAttempt = 0;
    let dispatchTimer = null;
    let connectTimer = null;
    let activeConnection = createWS();
    let state = "connecting";
    /**
   * tries to send the list of messages
   */ function dispatch() {
        if (state !== "open" || dispatchTimer) return;
        dispatchTimer = setTimeout(()=>{
            dispatchTimer = null;
            if (outgoing.length === 1) // single send
            activeConnection.send(JSON.stringify(outgoing.pop()));
            else // batch send
            activeConnection.send(JSON.stringify(outgoing));
            // clear
            outgoing = [];
        });
    }
    function tryReconnect() {
        if (connectTimer !== null || state === "closed") return;
        const timeout = retryDelayFn(connectAttempt++);
        reconnectInMs(timeout);
    }
    function reconnect() {
        state = "connecting";
        const oldConnection = activeConnection;
        activeConnection = createWS();
        closeIfNoPending(oldConnection);
    }
    function reconnectInMs(ms) {
        if (connectTimer) return;
        state = "connecting";
        connectTimer = setTimeout(reconnect, ms);
    }
    function closeIfNoPending(conn) {
        // disconnect as soon as there are are no pending result
        const hasPendingRequests = Object.values(pendingRequests).some((p)=>p.ws === conn);
        if (!hasPendingRequests) conn.close();
    }
    function closeActiveSubscriptions() {
        Object.values(pendingRequests).forEach((req)=>{
            if (req.type === "subscription") req.callbacks.complete();
        });
    }
    function resumeSubscriptionOnReconnect(req) {
        if (outgoing.some((r)=>r.id === req.op.id)) return;
        request(req.op, req.callbacks);
    }
    function createWS() {
        const urlString = typeof url === "function" ? url() : url;
        const conn = new WebSocketImpl(urlString);
        clearTimeout(connectTimer);
        connectTimer = null;
        conn.addEventListener("open", ()=>{
            /* istanbul ignore next -- @preserve */ if (conn !== activeConnection) return;
            connectAttempt = 0;
            state = "open";
            onOpen?.();
            dispatch();
        });
        conn.addEventListener("error", ()=>{
            if (conn === activeConnection) tryReconnect();
        });
        const handleIncomingRequest = (req)=>{
            if (req.method === "reconnect" && conn === activeConnection) {
                if (state === "open") onClose?.();
                reconnect();
                // notify subscribers
                for (const pendingReq of Object.values(pendingRequests))if (pendingReq.type === "subscription") resumeSubscriptionOnReconnect(pendingReq);
            }
        };
        const handleIncomingResponse = (data)=>{
            const req = data.id !== null && pendingRequests[data.id];
            if (!req) // do something?
            return;
            req.callbacks.next?.(data);
            if (req.ws !== activeConnection && conn === activeConnection) {
                const oldWs = req.ws;
                // gracefully replace old connection with this
                req.ws = activeConnection;
                closeIfNoPending(oldWs);
            }
            if ("result" in data && data.result.type === "stopped" && conn === activeConnection) req.callbacks.complete();
        };
        conn.addEventListener("message", ({ data: data })=>{
            const msg = JSON.parse(data);
            if ("method" in msg) handleIncomingRequest(msg);
            else handleIncomingResponse(msg);
            if (conn !== activeConnection || state === "closed") // when receiving a message, we close old connection that has no pending requests
            closeIfNoPending(conn);
        });
        conn.addEventListener("close", ({ code: code })=>{
            if (state === "open") onClose?.({
                code: code
            });
            if (activeConnection === conn) // connection might have been replaced already
            tryReconnect();
            for (const [key, req] of Object.entries(pendingRequests)){
                if (req.ws !== conn) continue;
                if (state === "closed") {
                    // If the connection was closed, we just call `complete()` on the request
                    delete pendingRequests[key];
                    req.callbacks.complete?.();
                    continue;
                }
                // The connection was closed either unexpectedly or because of a reconnect
                if (req.type === "subscription") // Subscriptions will resume after we've reconnected
                resumeSubscriptionOnReconnect(req);
                else {
                    // Queries and mutations will error if interrupted
                    delete pendingRequests[key];
                    req.callbacks.error?.((0, $jdQPa.T).from(new $1227d8a1e403b319$var$TRPCWebSocketClosedError("WebSocket closed prematurely")));
                }
            }
        });
        return conn;
    }
    function request(op, callbacks) {
        const { type: type, input: input, path: path, id: id } = op;
        const envelope = {
            id: id,
            method: type,
            params: {
                input: input,
                path: path
            }
        };
        pendingRequests[id] = {
            ws: activeConnection,
            type: type,
            callbacks: callbacks,
            op: op
        };
        // enqueue message
        outgoing.push(envelope);
        dispatch();
        return ()=>{
            const callbacks = pendingRequests[id]?.callbacks;
            delete pendingRequests[id];
            outgoing = outgoing.filter((msg)=>msg.id !== id);
            callbacks?.complete?.();
            if (activeConnection.readyState === WebSocketImpl.OPEN && op.type === "subscription") {
                outgoing.push({
                    id: id,
                    method: "subscription.stop"
                });
                dispatch();
            }
        };
    }
    return {
        close: ()=>{
            state = "closed";
            onClose?.();
            closeActiveSubscriptions();
            closeIfNoPending(activeConnection);
            clearTimeout(connectTimer);
            connectTimer = null;
        },
        request: request,
        getConnection () {
            return activeConnection;
        }
    };
}
class $1227d8a1e403b319$var$TRPCWebSocketClosedError extends Error {
    constructor(message){
        super(message);
        this.name = "TRPCWebSocketClosedError";
        Object.setPrototypeOf(this, $1227d8a1e403b319$var$TRPCWebSocketClosedError.prototype);
    }
}
/**
 * @see https://trpc.io/docs/client/links/wsLink
 */ function $1227d8a1e403b319$export$31d1274c8c32ef82(opts) {
    return (runtime)=>{
        const { client: client } = opts;
        return ({ op: op })=>{
            return (0, $3Hgap.observable)((observer)=>{
                const { type: type, path: path, id: id, context: context } = op;
                const input = runtime.transformer.serialize(op.input);
                const unsub = client.request({
                    type: type,
                    path: path,
                    input: input,
                    id: id,
                    context: context
                }, {
                    error (err) {
                        observer.error(err);
                        unsub();
                    },
                    complete () {
                        observer.complete();
                    },
                    next (message) {
                        const transformed = (0, $9G4X6.t)(message, runtime);
                        if (!transformed.ok) {
                            observer.error((0, $jdQPa.T).from(transformed.error));
                            return;
                        }
                        observer.next({
                            result: transformed.result
                        });
                        if (op.type !== "subscription") {
                            // if it isn't a subscription we don't care about next response
                            unsub();
                            observer.complete();
                        }
                    }
                });
                return ()=>{
                    unsub();
                };
            });
        };
    };
}

});




parcelRegister("ixbie", function(module, exports) {

var $hBKZ2 = parcelRequire("hBKZ2");

var $7p9v6 = parcelRequire("7p9v6");

var $799qX = parcelRequire("799qX");
/** Error message constants. */ var $d7e4119e052016f1$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d7e4119e052016f1$var$nativeMax = Math.max, $d7e4119e052016f1$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $d7e4119e052016f1$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($d7e4119e052016f1$var$FUNC_ERROR_TEXT);
    wait = $799qX(wait) || 0;
    if ($hBKZ2(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $d7e4119e052016f1$var$nativeMax($799qX(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $d7e4119e052016f1$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $7p9v6();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($7p9v6());
    }
    function debounced() {
        var time = $7p9v6(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
module.exports = $d7e4119e052016f1$var$debounce;

});
parcelRegister("hBKZ2", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $cd1a564e4956caeb$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = $cd1a564e4956caeb$var$isObject;

});

parcelRegister("7p9v6", function(module, exports) {

var $bHcVp = parcelRequire("bHcVp");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $56423cd45c5efc4f$var$now = function() {
    return $bHcVp.Date.now();
};
module.exports = $56423cd45c5efc4f$var$now;

});

parcelRegister("799qX", function(module, exports) {

var $eklpi = parcelRequire("eklpi");

var $hBKZ2 = parcelRequire("hBKZ2");

var $5Ob3C = parcelRequire("5Ob3C");
/** Used as references for various `Number` constants. */ var $5340b109496a423c$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $5340b109496a423c$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $5340b109496a423c$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $5340b109496a423c$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $5340b109496a423c$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $5340b109496a423c$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($5Ob3C(value)) return $5340b109496a423c$var$NAN;
    if ($hBKZ2(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $hBKZ2(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = $eklpi(value);
    var isBinary = $5340b109496a423c$var$reIsBinary.test(value);
    return isBinary || $5340b109496a423c$var$reIsOctal.test(value) ? $5340b109496a423c$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $5340b109496a423c$var$reIsBadHex.test(value) ? $5340b109496a423c$var$NAN : +value;
}
module.exports = $5340b109496a423c$var$toNumber;

});
parcelRegister("eklpi", function(module, exports) {

var $dTjEh = parcelRequire("dTjEh");
/** Used to match leading whitespace. */ var $a6e389f313a46ab3$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $a6e389f313a46ab3$var$baseTrim(string) {
    return string ? string.slice(0, $dTjEh(string) + 1).replace($a6e389f313a46ab3$var$reTrimStart, "") : string;
}
module.exports = $a6e389f313a46ab3$var$baseTrim;

});
parcelRegister("dTjEh", function(module, exports) {
/** Used to match a single whitespace character. */ var $a1cfa73b1d3abf81$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $a1cfa73b1d3abf81$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $a1cfa73b1d3abf81$var$reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = $a1cfa73b1d3abf81$var$trimmedEndIndex;

});






parcelRegister("jd5kC", function(module, exports) {

$parcel$export(module.exports, "FontAwesomeIcon", function () { return $dfc35df5bc8e1b48$export$2b9260d4a45c8710; });

var $82t48 = parcelRequire("82t48");

var $2MXkj = parcelRequire("2MXkj");

var $jbmdS = parcelRequire("jbmdS");
function $dfc35df5bc8e1b48$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $dfc35df5bc8e1b48$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $dfc35df5bc8e1b48$var$ownKeys(Object(source), !0).forEach(function(key) {
            $dfc35df5bc8e1b48$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $dfc35df5bc8e1b48$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $dfc35df5bc8e1b48$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $dfc35df5bc8e1b48$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $dfc35df5bc8e1b48$var$_typeof(obj);
}
function $dfc35df5bc8e1b48$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $dfc35df5bc8e1b48$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $dfc35df5bc8e1b48$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $dfc35df5bc8e1b48$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $dfc35df5bc8e1b48$var$_toConsumableArray(arr) {
    return $dfc35df5bc8e1b48$var$_arrayWithoutHoles(arr) || $dfc35df5bc8e1b48$var$_iterableToArray(arr) || $dfc35df5bc8e1b48$var$_unsupportedIterableToArray(arr) || $dfc35df5bc8e1b48$var$_nonIterableSpread();
}
function $dfc35df5bc8e1b48$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $dfc35df5bc8e1b48$var$_arrayLikeToArray(arr);
}
function $dfc35df5bc8e1b48$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $dfc35df5bc8e1b48$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $dfc35df5bc8e1b48$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $dfc35df5bc8e1b48$var$_arrayLikeToArray(o, minLen);
}
function $dfc35df5bc8e1b48$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $dfc35df5bc8e1b48$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// Get CSS class list from a props object
function $dfc35df5bc8e1b48$var$classList(props) {
    var _classes;
    var beat = props.beat, fade = props.fade, beatFade = props.beatFade, bounce = props.bounce, shake = props.shake, flash = props.flash, spin = props.spin, spinPulse = props.spinPulse, spinReverse = props.spinReverse, pulse = props.pulse, fixedWidth = props.fixedWidth, inverse = props.inverse, border = props.border, listItem = props.listItem, flip = props.flip, size = props.size, rotation = props.rotation, pull = props.pull; // map of CSS class names to properties
    var classes = (_classes = {
        "fa-beat": beat,
        "fa-fade": fade,
        "fa-beat-fade": beatFade,
        "fa-bounce": bounce,
        "fa-shake": shake,
        "fa-flash": flash,
        "fa-spin": spin,
        "fa-spin-reverse": spinReverse,
        "fa-spin-pulse": spinPulse,
        "fa-pulse": pulse,
        "fa-fw": fixedWidth,
        "fa-inverse": inverse,
        "fa-border": border,
        "fa-li": listItem,
        "fa-flip": flip === true,
        "fa-flip-horizontal": flip === "horizontal" || flip === "both",
        "fa-flip-vertical": flip === "vertical" || flip === "both"
    }, $dfc35df5bc8e1b48$var$_defineProperty(_classes, "fa-".concat(size), typeof size !== "undefined" && size !== null), $dfc35df5bc8e1b48$var$_defineProperty(_classes, "fa-rotate-".concat(rotation), typeof rotation !== "undefined" && rotation !== null && rotation !== 0), $dfc35df5bc8e1b48$var$_defineProperty(_classes, "fa-pull-".concat(pull), typeof pull !== "undefined" && pull !== null), $dfc35df5bc8e1b48$var$_defineProperty(_classes, "fa-swap-opacity", props.swapOpacity), _classes); // map over all the keys in the classes object
    // return an array of the keys where the value for the key is not null
    return Object.keys(classes).map(function(key) {
        return classes[key] ? key : null;
    }).filter(function(key) {
        return key;
    });
}
// Camelize taken from humps
// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.
// Performant way to determine if object coerces to a number
function $dfc35df5bc8e1b48$var$_isNumerical(obj) {
    obj = obj - 0; // eslint-disable-next-line no-self-compare
    return obj === obj;
}
function $dfc35df5bc8e1b48$var$camelize(string) {
    if ($dfc35df5bc8e1b48$var$_isNumerical(string)) return string;
     // eslint-disable-next-line no-useless-escape
    string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
        return chr ? chr.toUpperCase() : "";
    }); // Ensure 1st char is always lowercase
    return string.substr(0, 1).toLowerCase() + string.substr(1);
}
var $dfc35df5bc8e1b48$var$_excluded$1 = [
    "style"
];
function $dfc35df5bc8e1b48$var$capitalize(val) {
    return val.charAt(0).toUpperCase() + val.slice(1);
}
function $dfc35df5bc8e1b48$var$styleToObject(style) {
    return style.split(";").map(function(s) {
        return s.trim();
    }).filter(function(s) {
        return s;
    }).reduce(function(acc, pair) {
        var i = pair.indexOf(":");
        var prop = $dfc35df5bc8e1b48$var$camelize(pair.slice(0, i));
        var value = pair.slice(i + 1).trim();
        prop.startsWith("webkit") ? acc[$dfc35df5bc8e1b48$var$capitalize(prop)] = value : acc[prop] = value;
        return acc;
    }, {});
}
function $dfc35df5bc8e1b48$var$convert(createElement, element) {
    var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (typeof element === "string") return element;
    var children = (element.children || []).map(function(child) {
        return $dfc35df5bc8e1b48$var$convert(createElement, child);
    });
    /* eslint-disable dot-notation */ var mixins = Object.keys(element.attributes || {}).reduce(function(acc, key) {
        var val = element.attributes[key];
        switch(key){
            case "class":
                acc.attrs["className"] = val;
                delete element.attributes["class"];
                break;
            case "style":
                acc.attrs["style"] = $dfc35df5bc8e1b48$var$styleToObject(val);
                break;
            default:
                if (key.indexOf("aria-") === 0 || key.indexOf("data-") === 0) acc.attrs[key.toLowerCase()] = val;
                else acc.attrs[$dfc35df5bc8e1b48$var$camelize(key)] = val;
        }
        return acc;
    }, {
        attrs: {}
    });
    var _extraProps$style = extraProps.style, existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style, remaining = $dfc35df5bc8e1b48$var$_objectWithoutProperties(extraProps, $dfc35df5bc8e1b48$var$_excluded$1);
    mixins.attrs["style"] = $dfc35df5bc8e1b48$var$_objectSpread2($dfc35df5bc8e1b48$var$_objectSpread2({}, mixins.attrs["style"]), existingStyle);
    /* eslint-enable */ return createElement.apply(void 0, [
        element.tag,
        $dfc35df5bc8e1b48$var$_objectSpread2($dfc35df5bc8e1b48$var$_objectSpread2({}, mixins.attrs), remaining)
    ].concat($dfc35df5bc8e1b48$var$_toConsumableArray(children)));
}
var $dfc35df5bc8e1b48$var$PRODUCTION = false;
try {
    $dfc35df5bc8e1b48$var$PRODUCTION = true;
} catch (e) {}
function $dfc35df5bc8e1b48$var$log() {
    if (!$dfc35df5bc8e1b48$var$PRODUCTION && console && typeof console.error === "function") {
        var _console;
        (_console = console).error.apply(_console, arguments);
    }
}
function $dfc35df5bc8e1b48$var$normalizeIconArgs(icon) {
    // this has everything that it needs to be rendered which means it was probably imported
    // directly from an icon svg package
    if (icon && $dfc35df5bc8e1b48$var$_typeof(icon) === "object" && icon.prefix && icon.iconName && icon.icon) return icon;
    if ((0, $82t48.parse).icon) return (0, $82t48.parse).icon(icon);
     // if the icon is null, there's nothing to do
    if (icon === null) return null;
     // if the icon is an object and has a prefix and an icon name, return it
    if (icon && $dfc35df5bc8e1b48$var$_typeof(icon) === "object" && icon.prefix && icon.iconName) return icon;
     // if it's an array with length of two
    if (Array.isArray(icon) && icon.length === 2) // use the first item as prefix, second as icon name
    return {
        prefix: icon[0],
        iconName: icon[1]
    };
     // if it's a string, use it as the icon name
    if (typeof icon === "string") return {
        prefix: "fas",
        iconName: icon
    };
}
// creates an object with a key of key
// and a value of value
// if certain conditions are met
function $dfc35df5bc8e1b48$var$objectWithKey(key, value) {
    // if the value is a non-empty array
    // or it's not an array but it is truthy
    // then create the object with the key and the value
    // if not, return an empty array
    return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? $dfc35df5bc8e1b48$var$_defineProperty({}, key, value) : {};
}
var $dfc35df5bc8e1b48$var$_excluded = [
    "forwardedRef"
];
function $dfc35df5bc8e1b48$export$2b9260d4a45c8710(_ref) {
    var forwardedRef = _ref.forwardedRef, props = $dfc35df5bc8e1b48$var$_objectWithoutProperties(_ref, $dfc35df5bc8e1b48$var$_excluded);
    var iconArgs = props.icon, maskArgs = props.mask, symbol = props.symbol, className = props.className, title = props.title, titleId = props.titleId, maskId = props.maskId;
    var iconLookup = $dfc35df5bc8e1b48$var$normalizeIconArgs(iconArgs);
    var classes = $dfc35df5bc8e1b48$var$objectWithKey("classes", [].concat($dfc35df5bc8e1b48$var$_toConsumableArray($dfc35df5bc8e1b48$var$classList(props)), $dfc35df5bc8e1b48$var$_toConsumableArray(className.split(" "))));
    var transform = $dfc35df5bc8e1b48$var$objectWithKey("transform", typeof props.transform === "string" ? (0, $82t48.parse).transform(props.transform) : props.transform);
    var mask = $dfc35df5bc8e1b48$var$objectWithKey("mask", $dfc35df5bc8e1b48$var$normalizeIconArgs(maskArgs));
    var renderedIcon = (0, $82t48.icon)(iconLookup, $dfc35df5bc8e1b48$var$_objectSpread2($dfc35df5bc8e1b48$var$_objectSpread2($dfc35df5bc8e1b48$var$_objectSpread2($dfc35df5bc8e1b48$var$_objectSpread2({}, classes), transform), mask), {}, {
        symbol: symbol,
        title: title,
        titleId: titleId,
        maskId: maskId
    }));
    if (!renderedIcon) {
        $dfc35df5bc8e1b48$var$log("Could not find icon", iconLookup);
        return null;
    }
    var abstract = renderedIcon.abstract;
    var extraProps = {
        ref: forwardedRef
    };
    Object.keys(props).forEach(function(key) {
        // eslint-disable-next-line no-prototype-builtins
        if (!$dfc35df5bc8e1b48$export$2b9260d4a45c8710.defaultProps.hasOwnProperty(key)) extraProps[key] = props[key];
    });
    return $dfc35df5bc8e1b48$var$convertCurry(abstract[0], extraProps);
}
$dfc35df5bc8e1b48$export$2b9260d4a45c8710.displayName = "FontAwesomeIcon";
$dfc35df5bc8e1b48$export$2b9260d4a45c8710.propTypes = {
    beat: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).bool,
    border: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).bool,
    beatFade: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).bool,
    bounce: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).string,
    fade: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).bool,
    flash: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).bool,
    mask: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).string
    ]),
    maskId: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).string,
    fixedWidth: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).bool,
    inverse: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).bool,
    flip: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).oneOf([
        true,
        false,
        "horizontal",
        "vertical",
        "both"
    ]),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).string
    ]),
    listItem: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).bool,
    pull: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).oneOf([
        "right",
        "left"
    ]),
    pulse: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).bool,
    rotation: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).oneOf([
        0,
        90,
        180,
        270
    ]),
    shake: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).bool,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).oneOf([
        "2xs",
        "xs",
        "sm",
        "lg",
        "xl",
        "2xl",
        "1x",
        "2x",
        "3x",
        "4x",
        "5x",
        "6x",
        "7x",
        "8x",
        "9x",
        "10x"
    ]),
    spin: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).bool,
    spinPulse: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).bool,
    spinReverse: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).bool,
    symbol: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).string
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).string,
    titleId: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).string,
    transform: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).object
    ]),
    swapOpacity: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).bool
};
$dfc35df5bc8e1b48$export$2b9260d4a45c8710.defaultProps = {
    border: false,
    className: "",
    mask: null,
    maskId: null,
    fixedWidth: false,
    inverse: false,
    flip: false,
    icon: null,
    listItem: false,
    pull: null,
    pulse: false,
    rotation: null,
    size: null,
    spin: false,
    spinPulse: false,
    spinReverse: false,
    beat: false,
    fade: false,
    beatFade: false,
    bounce: false,
    shake: false,
    symbol: false,
    title: "",
    titleId: null,
    transform: null,
    swapOpacity: false
};
var $dfc35df5bc8e1b48$var$convertCurry = $dfc35df5bc8e1b48$var$convert.bind(null, (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement);

});
parcelRegister("82t48", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $089d1397ac35d9f8$export$98e6a39c04603d36; });
$parcel$export(module.exports, "icon", function () { return $089d1397ac35d9f8$export$1ca1ec8b29a4ce27; });
const $089d1397ac35d9f8$var$noop = ()=>{};
let $089d1397ac35d9f8$var$_WINDOW = {};
let $089d1397ac35d9f8$var$_DOCUMENT = {};
let $089d1397ac35d9f8$var$_MUTATION_OBSERVER = null;
let $089d1397ac35d9f8$var$_PERFORMANCE = {
    mark: $089d1397ac35d9f8$var$noop,
    measure: $089d1397ac35d9f8$var$noop
};
try {
    if (typeof window !== "undefined") $089d1397ac35d9f8$var$_WINDOW = window;
    if (typeof document !== "undefined") $089d1397ac35d9f8$var$_DOCUMENT = document;
    if (typeof MutationObserver !== "undefined") $089d1397ac35d9f8$var$_MUTATION_OBSERVER = MutationObserver;
    if (typeof performance !== "undefined") $089d1397ac35d9f8$var$_PERFORMANCE = performance;
} catch (e) {}
const { userAgent: $089d1397ac35d9f8$var$userAgent = "" } = $089d1397ac35d9f8$var$_WINDOW.navigator || {};
const $089d1397ac35d9f8$var$WINDOW = $089d1397ac35d9f8$var$_WINDOW;
const $089d1397ac35d9f8$var$DOCUMENT = $089d1397ac35d9f8$var$_DOCUMENT;
const $089d1397ac35d9f8$var$MUTATION_OBSERVER = $089d1397ac35d9f8$var$_MUTATION_OBSERVER;
const $089d1397ac35d9f8$var$PERFORMANCE = $089d1397ac35d9f8$var$_PERFORMANCE;
const $089d1397ac35d9f8$var$IS_BROWSER = !!$089d1397ac35d9f8$var$WINDOW.document;
const $089d1397ac35d9f8$var$IS_DOM = !!$089d1397ac35d9f8$var$DOCUMENT.documentElement && !!$089d1397ac35d9f8$var$DOCUMENT.head && typeof $089d1397ac35d9f8$var$DOCUMENT.addEventListener === "function" && typeof $089d1397ac35d9f8$var$DOCUMENT.createElement === "function";
const $089d1397ac35d9f8$var$IS_IE = ~$089d1397ac35d9f8$var$userAgent.indexOf("MSIE") || ~$089d1397ac35d9f8$var$userAgent.indexOf("Trident/");
var $089d1397ac35d9f8$var$a = "classic", $089d1397ac35d9f8$var$t = "duotone", $089d1397ac35d9f8$var$r = "sharp", $089d1397ac35d9f8$var$o = "sharp-duotone", $089d1397ac35d9f8$var$c = [
    $089d1397ac35d9f8$var$a,
    $089d1397ac35d9f8$var$t,
    $089d1397ac35d9f8$var$r,
    $089d1397ac35d9f8$var$o
];
var $089d1397ac35d9f8$var$et$1 = {
    classic: {
        900: "fas",
        400: "far",
        normal: "far",
        300: "fal",
        100: "fat"
    },
    sharp: {
        900: "fass",
        400: "fasr",
        300: "fasl",
        100: "fast"
    },
    "sharp-duotone": {
        900: "fasds"
    }
};
var $089d1397ac35d9f8$var$bt = {
    kit: {
        fak: "kit",
        "fa-kit": "kit"
    },
    "kit-duotone": {
        fakd: "kit-duotone",
        "fa-kit-duotone": "kit-duotone"
    }
}, $089d1397ac35d9f8$var$Ct = [
    "kit"
];
var $089d1397ac35d9f8$var$Dt = /fa(s|r|l|t|d|b|k|kd|ss|sr|sl|st|sds)?[\-\ ]/, $089d1397ac35d9f8$var$Kt = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit)?.*/i;
var $089d1397ac35d9f8$var$ao = {
    "Font Awesome 5 Free": {
        900: "fas",
        400: "far"
    },
    "Font Awesome 5 Pro": {
        900: "fas",
        400: "far",
        normal: "far",
        300: "fal"
    },
    "Font Awesome 5 Brands": {
        400: "fab",
        normal: "fab"
    },
    "Font Awesome 5 Duotone": {
        900: "fad"
    }
};
var $089d1397ac35d9f8$var$eo = {
    "Font Awesome 6 Free": {
        900: "fas",
        400: "far"
    },
    "Font Awesome 6 Pro": {
        900: "fas",
        400: "far",
        normal: "far",
        300: "fal",
        100: "fat"
    },
    "Font Awesome 6 Brands": {
        400: "fab",
        normal: "fab"
    },
    "Font Awesome 6 Duotone": {
        900: "fad"
    },
    "Font Awesome 6 Sharp": {
        900: "fass",
        400: "fasr",
        normal: "fasr",
        300: "fasl",
        100: "fast"
    },
    "Font Awesome 6 Sharp Duotone": {
        900: "fasds"
    }
}, $089d1397ac35d9f8$var$lo = {
    classic: {
        "fa-brands": "fab",
        "fa-duotone": "fad",
        "fa-light": "fal",
        "fa-regular": "far",
        "fa-solid": "fas",
        "fa-thin": "fat"
    },
    sharp: {
        "fa-solid": "fass",
        "fa-regular": "fasr",
        "fa-light": "fasl",
        "fa-thin": "fast"
    },
    "sharp-duotone": {
        "fa-solid": "fasds"
    }
}, $089d1397ac35d9f8$var$y = {
    classic: [
        "fas",
        "far",
        "fal",
        "fat"
    ],
    sharp: [
        "fass",
        "fasr",
        "fasl",
        "fast"
    ],
    "sharp-duotone": [
        "fasds"
    ]
}, $089d1397ac35d9f8$var$no = {
    classic: {
        fab: "fa-brands",
        fad: "fa-duotone",
        fal: "fa-light",
        far: "fa-regular",
        fas: "fa-solid",
        fat: "fa-thin"
    },
    sharp: {
        fass: "fa-solid",
        fasr: "fa-regular",
        fasl: "fa-light",
        fast: "fa-thin"
    },
    "sharp-duotone": {
        fasds: "fa-solid"
    }
}, $089d1397ac35d9f8$var$fo = {
    classic: {
        solid: "fas",
        regular: "far",
        light: "fal",
        thin: "fat",
        duotone: "fad",
        brands: "fab"
    },
    sharp: {
        solid: "fass",
        regular: "fasr",
        light: "fasl",
        thin: "fast"
    },
    "sharp-duotone": {
        solid: "fasds"
    }
}, $089d1397ac35d9f8$var$ho = {
    classic: {
        fa: "solid",
        fas: "solid",
        "fa-solid": "solid",
        far: "regular",
        "fa-regular": "regular",
        fal: "light",
        "fa-light": "light",
        fat: "thin",
        "fa-thin": "thin",
        fad: "duotone",
        "fa-duotone": "duotone",
        fab: "brands",
        "fa-brands": "brands"
    },
    sharp: {
        fa: "solid",
        fass: "solid",
        "fa-solid": "solid",
        fasr: "regular",
        "fa-regular": "regular",
        fasl: "light",
        "fa-light": "light",
        fast: "thin",
        "fa-thin": "thin"
    },
    "sharp-duotone": {
        fa: "solid",
        fasds: "solid",
        "fa-solid": "solid"
    }
}, $089d1397ac35d9f8$var$x$1 = [
    "solid",
    "regular",
    "light",
    "thin",
    "duotone",
    "brands"
], $089d1397ac35d9f8$var$u$1 = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
], $089d1397ac35d9f8$var$m$1 = $089d1397ac35d9f8$var$u$1.concat([
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20
]), $089d1397ac35d9f8$var$t$1 = {
    GROUP: "duotone-group",
    SWAP_OPACITY: "swap-opacity",
    PRIMARY: "primary",
    SECONDARY: "secondary"
}, $089d1397ac35d9f8$var$yo = [
    ...Object.keys($089d1397ac35d9f8$var$y),
    ...$089d1397ac35d9f8$var$x$1,
    "2xs",
    "xs",
    "sm",
    "lg",
    "xl",
    "2xl",
    "beat",
    "border",
    "fade",
    "beat-fade",
    "bounce",
    "flip-both",
    "flip-horizontal",
    "flip-vertical",
    "flip",
    "fw",
    "inverse",
    "layers-counter",
    "layers-text",
    "layers",
    "li",
    "pull-left",
    "pull-right",
    "pulse",
    "rotate-180",
    "rotate-270",
    "rotate-90",
    "rotate-by",
    "shake",
    "spin-pulse",
    "spin-reverse",
    "spin",
    "stack-1x",
    "stack-2x",
    "stack",
    "ul",
    $089d1397ac35d9f8$var$t$1.GROUP,
    $089d1397ac35d9f8$var$t$1.SWAP_OPACITY,
    $089d1397ac35d9f8$var$t$1.PRIMARY,
    $089d1397ac35d9f8$var$t$1.SECONDARY
].concat($089d1397ac35d9f8$var$u$1.map((o)=>"".concat(o, "x"))).concat($089d1397ac35d9f8$var$m$1.map((o)=>"w-".concat(o)));
var $089d1397ac35d9f8$var$mo = {
    "Font Awesome Kit": {
        400: "fak",
        normal: "fak"
    },
    "Font Awesome Kit Duotone": {
        400: "fakd",
        normal: "fakd"
    }
}, $089d1397ac35d9f8$var$Io = {
    kit: {
        "fa-kit": "fak"
    },
    "kit-duotone": {
        "fa-kit-duotone": "fakd"
    }
}, $089d1397ac35d9f8$var$Fo = {
    kit: {
        fak: "fa-kit"
    },
    "kit-duotone": {
        fakd: "fa-kit-duotone"
    }
}, $089d1397ac35d9f8$var$So = {
    kit: {
        kit: "fak"
    },
    "kit-duotone": {
        "kit-duotone": "fakd"
    }
};
const $089d1397ac35d9f8$var$NAMESPACE_IDENTIFIER = "___FONT_AWESOME___";
const $089d1397ac35d9f8$var$UNITS_IN_GRID = 16;
const $089d1397ac35d9f8$var$DEFAULT_CSS_PREFIX = "fa";
const $089d1397ac35d9f8$var$DEFAULT_REPLACEMENT_CLASS = "svg-inline--fa";
const $089d1397ac35d9f8$var$DATA_FA_I2SVG = "data-fa-i2svg";
const $089d1397ac35d9f8$var$DATA_FA_PSEUDO_ELEMENT = "data-fa-pseudo-element";
const $089d1397ac35d9f8$var$DATA_FA_PSEUDO_ELEMENT_PENDING = "data-fa-pseudo-element-pending";
const $089d1397ac35d9f8$var$DATA_PREFIX = "data-prefix";
const $089d1397ac35d9f8$var$DATA_ICON = "data-icon";
const $089d1397ac35d9f8$var$HTML_CLASS_I2SVG_BASE_CLASS = "fontawesome-i2svg";
const $089d1397ac35d9f8$var$MUTATION_APPROACH_ASYNC = "async";
const $089d1397ac35d9f8$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = [
    "HTML",
    "HEAD",
    "STYLE",
    "SCRIPT"
];
const $089d1397ac35d9f8$var$PRODUCTION = (()=>{
    try {
        return true;
    } catch (e$$1) {
        return false;
    }
})();
const $089d1397ac35d9f8$var$FAMILIES = [
    $089d1397ac35d9f8$var$a,
    $089d1397ac35d9f8$var$r,
    $089d1397ac35d9f8$var$o
];
function $089d1397ac35d9f8$var$familyProxy(obj) {
    // Defaults to the classic family if family is not available
    return new Proxy(obj, {
        get (target, prop) {
            return prop in target ? target[prop] : target[$089d1397ac35d9f8$var$a];
        }
    });
}
const $089d1397ac35d9f8$var$_PREFIX_TO_STYLE = {
    ...$089d1397ac35d9f8$var$ho
};
$089d1397ac35d9f8$var$_PREFIX_TO_STYLE[$089d1397ac35d9f8$var$a] = {
    ...$089d1397ac35d9f8$var$ho[$089d1397ac35d9f8$var$a],
    ...$089d1397ac35d9f8$var$bt["kit"],
    ...$089d1397ac35d9f8$var$bt["kit-duotone"]
};
const $089d1397ac35d9f8$var$PREFIX_TO_STYLE = $089d1397ac35d9f8$var$familyProxy($089d1397ac35d9f8$var$_PREFIX_TO_STYLE);
const $089d1397ac35d9f8$var$_STYLE_TO_PREFIX = {
    ...$089d1397ac35d9f8$var$fo
};
$089d1397ac35d9f8$var$_STYLE_TO_PREFIX[$089d1397ac35d9f8$var$a] = {
    ...$089d1397ac35d9f8$var$_STYLE_TO_PREFIX[$089d1397ac35d9f8$var$a],
    ...$089d1397ac35d9f8$var$So["kit"],
    ...$089d1397ac35d9f8$var$So["kit-duotone"]
};
const $089d1397ac35d9f8$var$STYLE_TO_PREFIX = $089d1397ac35d9f8$var$familyProxy($089d1397ac35d9f8$var$_STYLE_TO_PREFIX);
const $089d1397ac35d9f8$var$_PREFIX_TO_LONG_STYLE = {
    ...$089d1397ac35d9f8$var$no
};
$089d1397ac35d9f8$var$_PREFIX_TO_LONG_STYLE[$089d1397ac35d9f8$var$a] = {
    ...$089d1397ac35d9f8$var$_PREFIX_TO_LONG_STYLE[$089d1397ac35d9f8$var$a],
    ...$089d1397ac35d9f8$var$Fo["kit"]
};
const $089d1397ac35d9f8$var$PREFIX_TO_LONG_STYLE = $089d1397ac35d9f8$var$familyProxy($089d1397ac35d9f8$var$_PREFIX_TO_LONG_STYLE);
const $089d1397ac35d9f8$var$_LONG_STYLE_TO_PREFIX = {
    ...$089d1397ac35d9f8$var$lo
};
$089d1397ac35d9f8$var$_LONG_STYLE_TO_PREFIX[$089d1397ac35d9f8$var$a] = {
    ...$089d1397ac35d9f8$var$_LONG_STYLE_TO_PREFIX[$089d1397ac35d9f8$var$a],
    ...$089d1397ac35d9f8$var$Io["kit"]
};
const $089d1397ac35d9f8$var$LONG_STYLE_TO_PREFIX = $089d1397ac35d9f8$var$familyProxy($089d1397ac35d9f8$var$_LONG_STYLE_TO_PREFIX);
const $089d1397ac35d9f8$var$ICON_SELECTION_SYNTAX_PATTERN = $089d1397ac35d9f8$var$Dt; // eslint-disable-line no-useless-escape
const $089d1397ac35d9f8$var$LAYERS_TEXT_CLASSNAME = "fa-layers-text";
const $089d1397ac35d9f8$var$FONT_FAMILY_PATTERN = $089d1397ac35d9f8$var$Kt;
const $089d1397ac35d9f8$var$_FONT_WEIGHT_TO_PREFIX = {
    ...$089d1397ac35d9f8$var$et$1
};
const $089d1397ac35d9f8$var$FONT_WEIGHT_TO_PREFIX = $089d1397ac35d9f8$var$familyProxy($089d1397ac35d9f8$var$_FONT_WEIGHT_TO_PREFIX);
const $089d1397ac35d9f8$var$ATTRIBUTES_WATCHED_FOR_MUTATION = [
    "class",
    "data-prefix",
    "data-icon",
    "data-fa-transform",
    "data-fa-mask"
];
const $089d1397ac35d9f8$var$DUOTONE_CLASSES = $089d1397ac35d9f8$var$t$1;
const $089d1397ac35d9f8$var$prefixes = new Set();
Object.keys($089d1397ac35d9f8$var$STYLE_TO_PREFIX[$089d1397ac35d9f8$var$a]).map($089d1397ac35d9f8$var$prefixes.add.bind($089d1397ac35d9f8$var$prefixes));
Object.keys($089d1397ac35d9f8$var$STYLE_TO_PREFIX[$089d1397ac35d9f8$var$r]).map($089d1397ac35d9f8$var$prefixes.add.bind($089d1397ac35d9f8$var$prefixes));
Object.keys($089d1397ac35d9f8$var$STYLE_TO_PREFIX[$089d1397ac35d9f8$var$o]).map($089d1397ac35d9f8$var$prefixes.add.bind($089d1397ac35d9f8$var$prefixes));
const $089d1397ac35d9f8$var$RESERVED_CLASSES = [
    ...$089d1397ac35d9f8$var$Ct,
    ...$089d1397ac35d9f8$var$yo
];
const $089d1397ac35d9f8$var$initial = $089d1397ac35d9f8$var$WINDOW.FontAwesomeConfig || {};
function $089d1397ac35d9f8$var$getAttrConfig(attr) {
    var element = $089d1397ac35d9f8$var$DOCUMENT.querySelector("script[" + attr + "]");
    if (element) return element.getAttribute(attr);
}
function $089d1397ac35d9f8$var$coerce(val) {
    // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
    // We'll assume that this is an indication that it should be toggled to true
    if (val === "") return true;
    if (val === "false") return false;
    if (val === "true") return true;
    return val;
}
if ($089d1397ac35d9f8$var$DOCUMENT && typeof $089d1397ac35d9f8$var$DOCUMENT.querySelector === "function") {
    const attrs = [
        [
            "data-family-prefix",
            "familyPrefix"
        ],
        [
            "data-css-prefix",
            "cssPrefix"
        ],
        [
            "data-family-default",
            "familyDefault"
        ],
        [
            "data-style-default",
            "styleDefault"
        ],
        [
            "data-replacement-class",
            "replacementClass"
        ],
        [
            "data-auto-replace-svg",
            "autoReplaceSvg"
        ],
        [
            "data-auto-add-css",
            "autoAddCss"
        ],
        [
            "data-auto-a11y",
            "autoA11y"
        ],
        [
            "data-search-pseudo-elements",
            "searchPseudoElements"
        ],
        [
            "data-observe-mutations",
            "observeMutations"
        ],
        [
            "data-mutate-approach",
            "mutateApproach"
        ],
        [
            "data-keep-original-source",
            "keepOriginalSource"
        ],
        [
            "data-measure-performance",
            "measurePerformance"
        ],
        [
            "data-show-missing-icons",
            "showMissingIcons"
        ]
    ];
    attrs.forEach((_ref)=>{
        let [attr, key] = _ref;
        const val = $089d1397ac35d9f8$var$coerce($089d1397ac35d9f8$var$getAttrConfig(attr));
        if (val !== undefined && val !== null) $089d1397ac35d9f8$var$initial[key] = val;
    });
}
const $089d1397ac35d9f8$var$_default = {
    styleDefault: "solid",
    familyDefault: "classic",
    cssPrefix: $089d1397ac35d9f8$var$DEFAULT_CSS_PREFIX,
    replacementClass: $089d1397ac35d9f8$var$DEFAULT_REPLACEMENT_CLASS,
    autoReplaceSvg: true,
    autoAddCss: true,
    autoA11y: true,
    searchPseudoElements: false,
    observeMutations: true,
    mutateApproach: "async",
    keepOriginalSource: true,
    measurePerformance: false,
    showMissingIcons: true
}; // familyPrefix is deprecated but we must still support it if present
if ($089d1397ac35d9f8$var$initial.familyPrefix) $089d1397ac35d9f8$var$initial.cssPrefix = $089d1397ac35d9f8$var$initial.familyPrefix;
const $089d1397ac35d9f8$var$_config = {
    ...$089d1397ac35d9f8$var$_default,
    ...$089d1397ac35d9f8$var$initial
};
if (!$089d1397ac35d9f8$var$_config.autoReplaceSvg) $089d1397ac35d9f8$var$_config.observeMutations = false;
const $089d1397ac35d9f8$var$config = {};
Object.keys($089d1397ac35d9f8$var$_default).forEach((key)=>{
    Object.defineProperty($089d1397ac35d9f8$var$config, key, {
        enumerable: true,
        set: function(val) {
            $089d1397ac35d9f8$var$_config[key] = val;
            $089d1397ac35d9f8$var$_onChangeCb.forEach((cb)=>cb($089d1397ac35d9f8$var$config));
        },
        get: function() {
            return $089d1397ac35d9f8$var$_config[key];
        }
    });
}); // familyPrefix is deprecated as of 6.2.0 and should be removed in 7.0.0
Object.defineProperty($089d1397ac35d9f8$var$config, "familyPrefix", {
    enumerable: true,
    set: function(val) {
        $089d1397ac35d9f8$var$_config.cssPrefix = val;
        $089d1397ac35d9f8$var$_onChangeCb.forEach((cb)=>cb($089d1397ac35d9f8$var$config));
    },
    get: function() {
        return $089d1397ac35d9f8$var$_config.cssPrefix;
    }
});
$089d1397ac35d9f8$var$WINDOW.FontAwesomeConfig = $089d1397ac35d9f8$var$config;
const $089d1397ac35d9f8$var$_onChangeCb = [];
function $089d1397ac35d9f8$var$onChange(cb) {
    $089d1397ac35d9f8$var$_onChangeCb.push(cb);
    return ()=>{
        $089d1397ac35d9f8$var$_onChangeCb.splice($089d1397ac35d9f8$var$_onChangeCb.indexOf(cb), 1);
    };
}
const $089d1397ac35d9f8$var$d$2 = $089d1397ac35d9f8$var$UNITS_IN_GRID;
const $089d1397ac35d9f8$var$meaninglessTransform = {
    size: 16,
    x: 0,
    y: 0,
    rotate: 0,
    flipX: false,
    flipY: false
};
function $089d1397ac35d9f8$var$insertCss(css) {
    if (!css || !$089d1397ac35d9f8$var$IS_DOM) return;
    const style = $089d1397ac35d9f8$var$DOCUMENT.createElement("style");
    style.setAttribute("type", "text/css");
    style.innerHTML = css;
    const headChildren = $089d1397ac35d9f8$var$DOCUMENT.head.childNodes;
    let beforeChild = null;
    for(let i = headChildren.length - 1; i > -1; i--){
        const child = headChildren[i];
        const tagName = (child.tagName || "").toUpperCase();
        if ([
            "STYLE",
            "LINK"
        ].indexOf(tagName) > -1) beforeChild = child;
    }
    $089d1397ac35d9f8$var$DOCUMENT.head.insertBefore(style, beforeChild);
    return css;
}
const $089d1397ac35d9f8$var$idPool = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function $089d1397ac35d9f8$var$nextUniqueId() {
    let size = 12;
    let id = "";
    while(size-- > 0)id += $089d1397ac35d9f8$var$idPool[Math.random() * 62 | 0];
    return id;
}
function $089d1397ac35d9f8$var$toArray(obj) {
    const array = [];
    for(let i = (obj || []).length >>> 0; i--;)array[i] = obj[i];
    return array;
}
function $089d1397ac35d9f8$var$classArray(node) {
    if (node.classList) return $089d1397ac35d9f8$var$toArray(node.classList);
    else return (node.getAttribute("class") || "").split(" ").filter((i)=>i);
}
function $089d1397ac35d9f8$var$htmlEscape(str) {
    return "".concat(str).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function $089d1397ac35d9f8$var$joinAttributes(attributes) {
    return Object.keys(attributes || {}).reduce((acc, attributeName)=>{
        return acc + "".concat(attributeName, '="').concat($089d1397ac35d9f8$var$htmlEscape(attributes[attributeName]), '" ');
    }, "").trim();
}
function $089d1397ac35d9f8$var$joinStyles(styles) {
    return Object.keys(styles || {}).reduce((acc, styleName)=>{
        return acc + "".concat(styleName, ": ").concat(styles[styleName].trim(), ";");
    }, "");
}
function $089d1397ac35d9f8$var$transformIsMeaningful(transform) {
    return transform.size !== $089d1397ac35d9f8$var$meaninglessTransform.size || transform.x !== $089d1397ac35d9f8$var$meaninglessTransform.x || transform.y !== $089d1397ac35d9f8$var$meaninglessTransform.y || transform.rotate !== $089d1397ac35d9f8$var$meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function $089d1397ac35d9f8$var$transformForSvg(_ref) {
    let { transform: transform, containerWidth: containerWidth, iconWidth: iconWidth } = _ref;
    const outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
    };
    const innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
    const innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
    const innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
    const inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
    };
    const path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
    };
    return {
        outer: outer,
        inner: inner,
        path: path
    };
}
function $089d1397ac35d9f8$var$transformForCss(_ref2) {
    let { transform: transform, width: width = $089d1397ac35d9f8$var$UNITS_IN_GRID, height: height = $089d1397ac35d9f8$var$UNITS_IN_GRID, startCentered: startCentered = false } = _ref2;
    let val = "";
    if (startCentered && $089d1397ac35d9f8$var$IS_IE) val += "translate(".concat(transform.x / $089d1397ac35d9f8$var$d$2 - width / 2, "em, ").concat(transform.y / $089d1397ac35d9f8$var$d$2 - height / 2, "em) ");
    else if (startCentered) val += "translate(calc(-50% + ".concat(transform.x / $089d1397ac35d9f8$var$d$2, "em), calc(-50% + ").concat(transform.y / $089d1397ac35d9f8$var$d$2, "em)) ");
    else val += "translate(".concat(transform.x / $089d1397ac35d9f8$var$d$2, "em, ").concat(transform.y / $089d1397ac35d9f8$var$d$2, "em) ");
    val += "scale(".concat(transform.size / $089d1397ac35d9f8$var$d$2 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / $089d1397ac35d9f8$var$d$2 * (transform.flipY ? -1 : 1), ") ");
    val += "rotate(".concat(transform.rotate, "deg) ");
    return val;
}
var $089d1397ac35d9f8$var$baseStyles = ':root, :host {\n  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free";\n  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Free";\n  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Pro";\n  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Pro";\n  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";\n  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";\n  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-duotone-solid: normal 900 1em/1 "Font Awesome 6 Sharp Duotone";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  transform: scale(var(--fa-counter-scale, 0.25));\n  transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(-1 * var(--fa-li-width, 2em));\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  animation-name: fa-beat;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  animation-name: fa-bounce;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  animation-name: fa-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  animation-name: fa-beat-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  animation-name: fa-flip;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  animation-name: fa-shake;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  animation-name: fa-spin;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 2s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  animation-name: fa-spin;\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    animation-delay: -1ms;\n    animation-duration: 1ms;\n    animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    transform: scale(1);\n  }\n  45% {\n    transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-shake {\n  0% {\n    transform: rotate(-15deg);\n  }\n  4% {\n    transform: rotate(15deg);\n  }\n  8%, 24% {\n    transform: rotate(-18deg);\n  }\n  12%, 28% {\n    transform: rotate(18deg);\n  }\n  16% {\n    transform: rotate(-22deg);\n  }\n  20% {\n    transform: rotate(22deg);\n  }\n  32% {\n    transform: rotate(-12deg);\n  }\n  36% {\n    transform: rotate(12deg);\n  }\n  40%, 100% {\n    transform: rotate(0deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  transform: rotate(var(--fa-rotate-angle, 0));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse,\n.fa-duotone.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}';
function $089d1397ac35d9f8$var$css() {
    const dcp = $089d1397ac35d9f8$var$DEFAULT_CSS_PREFIX;
    const drc = $089d1397ac35d9f8$var$DEFAULT_REPLACEMENT_CLASS;
    const fp = $089d1397ac35d9f8$var$config.cssPrefix;
    const rc = $089d1397ac35d9f8$var$config.replacementClass;
    let s = $089d1397ac35d9f8$var$baseStyles;
    if (fp !== dcp || rc !== drc) {
        const dPatt = new RegExp("\\.".concat(dcp, "\\-"), "g");
        const customPropPatt = new RegExp("\\--".concat(dcp, "\\-"), "g");
        const rPatt = new RegExp("\\.".concat(drc), "g");
        s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
    }
    return s;
}
let $089d1397ac35d9f8$var$_cssInserted = false;
function $089d1397ac35d9f8$var$ensureCss() {
    if ($089d1397ac35d9f8$var$config.autoAddCss && !$089d1397ac35d9f8$var$_cssInserted) {
        $089d1397ac35d9f8$var$insertCss($089d1397ac35d9f8$var$css());
        $089d1397ac35d9f8$var$_cssInserted = true;
    }
}
var $089d1397ac35d9f8$var$InjectCSS = {
    mixout () {
        return {
            dom: {
                css: $089d1397ac35d9f8$var$css,
                insertCss: $089d1397ac35d9f8$var$ensureCss
            }
        };
    },
    hooks () {
        return {
            beforeDOMElementCreation () {
                $089d1397ac35d9f8$var$ensureCss();
            },
            beforeI2svg () {
                $089d1397ac35d9f8$var$ensureCss();
            }
        };
    }
};
const $089d1397ac35d9f8$var$w$1 = $089d1397ac35d9f8$var$WINDOW || {};
if (!$089d1397ac35d9f8$var$w$1[$089d1397ac35d9f8$var$NAMESPACE_IDENTIFIER]) $089d1397ac35d9f8$var$w$1[$089d1397ac35d9f8$var$NAMESPACE_IDENTIFIER] = {};
if (!$089d1397ac35d9f8$var$w$1[$089d1397ac35d9f8$var$NAMESPACE_IDENTIFIER].styles) $089d1397ac35d9f8$var$w$1[$089d1397ac35d9f8$var$NAMESPACE_IDENTIFIER].styles = {};
if (!$089d1397ac35d9f8$var$w$1[$089d1397ac35d9f8$var$NAMESPACE_IDENTIFIER].hooks) $089d1397ac35d9f8$var$w$1[$089d1397ac35d9f8$var$NAMESPACE_IDENTIFIER].hooks = {};
if (!$089d1397ac35d9f8$var$w$1[$089d1397ac35d9f8$var$NAMESPACE_IDENTIFIER].shims) $089d1397ac35d9f8$var$w$1[$089d1397ac35d9f8$var$NAMESPACE_IDENTIFIER].shims = [];
var $089d1397ac35d9f8$var$namespace = $089d1397ac35d9f8$var$w$1[$089d1397ac35d9f8$var$NAMESPACE_IDENTIFIER];
const $089d1397ac35d9f8$var$functions = [];
const $089d1397ac35d9f8$var$listener = function() {
    $089d1397ac35d9f8$var$DOCUMENT.removeEventListener("DOMContentLoaded", $089d1397ac35d9f8$var$listener);
    $089d1397ac35d9f8$var$loaded = 1;
    $089d1397ac35d9f8$var$functions.map((fn)=>fn());
};
let $089d1397ac35d9f8$var$loaded = false;
if ($089d1397ac35d9f8$var$IS_DOM) {
    $089d1397ac35d9f8$var$loaded = ($089d1397ac35d9f8$var$DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test($089d1397ac35d9f8$var$DOCUMENT.readyState);
    if (!$089d1397ac35d9f8$var$loaded) $089d1397ac35d9f8$var$DOCUMENT.addEventListener("DOMContentLoaded", $089d1397ac35d9f8$var$listener);
}
function $089d1397ac35d9f8$var$domready(fn) {
    if (!$089d1397ac35d9f8$var$IS_DOM) return;
    $089d1397ac35d9f8$var$loaded ? setTimeout(fn, 0) : $089d1397ac35d9f8$var$functions.push(fn);
}
function $089d1397ac35d9f8$var$toHtml(abstractNodes) {
    const { tag: tag, attributes: attributes = {}, children: children = [] } = abstractNodes;
    if (typeof abstractNodes === "string") return $089d1397ac35d9f8$var$htmlEscape(abstractNodes);
    else return "<".concat(tag, " ").concat($089d1397ac35d9f8$var$joinAttributes(attributes), ">").concat(children.map($089d1397ac35d9f8$var$toHtml).join(""), "</").concat(tag, ">");
}
function $089d1397ac35d9f8$var$iconFromMapping(mapping, prefix, iconName) {
    if (mapping && mapping[prefix] && mapping[prefix][iconName]) return {
        prefix: prefix,
        iconName: iconName,
        icon: mapping[prefix][iconName]
    };
}
/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */ var $089d1397ac35d9f8$var$bindInternal4 = function bindInternal4(func, thisContext) {
    return function(a, b, c, d) {
        return func.call(thisContext, a, b, c, d);
    };
};
/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */ var $089d1397ac35d9f8$var$reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
    var keys = Object.keys(subject), length = keys.length, iterator = thisContext !== undefined ? $089d1397ac35d9f8$var$bindInternal4(fn, thisContext) : fn, i, key, result;
    if (initialValue === undefined) {
        i = 1;
        result = subject[keys[0]];
    } else {
        i = 0;
        result = initialValue;
    }
    for(; i < length; i++){
        key = keys[i];
        result = iterator(result, subject[key], key, subject);
    }
    return result;
};
/**
 * ucs2decode() and codePointAt() are both works of Mathias Bynens and licensed under MIT
 *
 * Copyright Mathias Bynens <https://mathiasbynens.be/>

 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:

 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ function $089d1397ac35d9f8$var$ucs2decode(string) {
    const output = [];
    let counter = 0;
    const length = string.length;
    while(counter < length){
        const value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            const extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) // eslint-disable-line eqeqeq
            output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
function $089d1397ac35d9f8$var$toHex(unicode) {
    const decoded = $089d1397ac35d9f8$var$ucs2decode(unicode);
    return decoded.length === 1 ? decoded[0].toString(16) : null;
}
function $089d1397ac35d9f8$var$codePointAt(string, index) {
    const size = string.length;
    let first = string.charCodeAt(index);
    let second;
    if (first >= 0xD800 && first <= 0xDBFF && size > index + 1) {
        second = string.charCodeAt(index + 1);
        if (second >= 0xDC00 && second <= 0xDFFF) return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
    }
    return first;
}
function $089d1397ac35d9f8$var$normalizeIcons(icons) {
    return Object.keys(icons).reduce((acc, iconName)=>{
        const icon = icons[iconName];
        const expanded = !!icon.icon;
        if (expanded) acc[icon.iconName] = icon.icon;
        else acc[iconName] = icon;
        return acc;
    }, {});
}
function $089d1397ac35d9f8$var$defineIcons(prefix, icons) {
    let params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const { skipHooks: skipHooks = false } = params;
    const normalized = $089d1397ac35d9f8$var$normalizeIcons(icons);
    if (typeof $089d1397ac35d9f8$var$namespace.hooks.addPack === "function" && !skipHooks) $089d1397ac35d9f8$var$namespace.hooks.addPack(prefix, $089d1397ac35d9f8$var$normalizeIcons(icons));
    else $089d1397ac35d9f8$var$namespace.styles[prefix] = {
        ...$089d1397ac35d9f8$var$namespace.styles[prefix] || {},
        ...normalized
    };
    /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll ease the upgrade process for our users by automatically defining
   * this as well.
   */ if (prefix === "fas") $089d1397ac35d9f8$var$defineIcons("fa", icons);
}
const { styles: $089d1397ac35d9f8$var$styles, shims: $089d1397ac35d9f8$var$shims } = $089d1397ac35d9f8$var$namespace;
const $089d1397ac35d9f8$var$LONG_STYLE = {
    [$089d1397ac35d9f8$var$a]: Object.values($089d1397ac35d9f8$var$PREFIX_TO_LONG_STYLE[$089d1397ac35d9f8$var$a]),
    [$089d1397ac35d9f8$var$r]: Object.values($089d1397ac35d9f8$var$PREFIX_TO_LONG_STYLE[$089d1397ac35d9f8$var$r]),
    [$089d1397ac35d9f8$var$o]: Object.values($089d1397ac35d9f8$var$PREFIX_TO_LONG_STYLE[$089d1397ac35d9f8$var$o])
};
let $089d1397ac35d9f8$var$_defaultUsablePrefix = null;
let $089d1397ac35d9f8$var$_byUnicode = {};
let $089d1397ac35d9f8$var$_byLigature = {};
let $089d1397ac35d9f8$var$_byOldName = {};
let $089d1397ac35d9f8$var$_byOldUnicode = {};
let $089d1397ac35d9f8$var$_byAlias = {};
const $089d1397ac35d9f8$var$PREFIXES = {
    [$089d1397ac35d9f8$var$a]: Object.keys($089d1397ac35d9f8$var$PREFIX_TO_STYLE[$089d1397ac35d9f8$var$a]),
    [$089d1397ac35d9f8$var$r]: Object.keys($089d1397ac35d9f8$var$PREFIX_TO_STYLE[$089d1397ac35d9f8$var$r]),
    [$089d1397ac35d9f8$var$o]: Object.keys($089d1397ac35d9f8$var$PREFIX_TO_STYLE[$089d1397ac35d9f8$var$o])
};
function $089d1397ac35d9f8$var$isReserved(name) {
    return ~$089d1397ac35d9f8$var$RESERVED_CLASSES.indexOf(name);
}
function $089d1397ac35d9f8$var$getIconName(cssPrefix, cls) {
    const parts = cls.split("-");
    const prefix = parts[0];
    const iconName = parts.slice(1).join("-");
    if (prefix === cssPrefix && iconName !== "" && !$089d1397ac35d9f8$var$isReserved(iconName)) return iconName;
    else return null;
}
const $089d1397ac35d9f8$var$build = ()=>{
    const lookup = (reducer)=>{
        return $089d1397ac35d9f8$var$reduce($089d1397ac35d9f8$var$styles, (o$$1, style, prefix)=>{
            o$$1[prefix] = $089d1397ac35d9f8$var$reduce(style, reducer, {});
            return o$$1;
        }, {});
    };
    $089d1397ac35d9f8$var$_byUnicode = lookup((acc, icon, iconName)=>{
        if (icon[3]) acc[icon[3]] = iconName;
        if (icon[2]) {
            const aliases = icon[2].filter((a$$1)=>{
                return typeof a$$1 === "number";
            });
            aliases.forEach((alias)=>{
                acc[alias.toString(16)] = iconName;
            });
        }
        return acc;
    });
    $089d1397ac35d9f8$var$_byLigature = lookup((acc, icon, iconName)=>{
        acc[iconName] = iconName;
        if (icon[2]) {
            const aliases = icon[2].filter((a$$1)=>{
                return typeof a$$1 === "string";
            });
            aliases.forEach((alias)=>{
                acc[alias] = iconName;
            });
        }
        return acc;
    });
    $089d1397ac35d9f8$var$_byAlias = lookup((acc, icon, iconName)=>{
        const aliases = icon[2];
        acc[iconName] = iconName;
        aliases.forEach((alias)=>{
            acc[alias] = iconName;
        });
        return acc;
    }); // If we have a Kit, we can't determine if regular is available since we
    // could be auto-fetching it. We'll have to assume that it is available.
    const hasRegular = "far" in $089d1397ac35d9f8$var$styles || $089d1397ac35d9f8$var$config.autoFetchSvg;
    const shimLookups = $089d1397ac35d9f8$var$reduce($089d1397ac35d9f8$var$shims, (acc, shim)=>{
        const maybeNameMaybeUnicode = shim[0];
        let prefix = shim[1];
        const iconName = shim[2];
        if (prefix === "far" && !hasRegular) prefix = "fas";
        if (typeof maybeNameMaybeUnicode === "string") acc.names[maybeNameMaybeUnicode] = {
            prefix: prefix,
            iconName: iconName
        };
        if (typeof maybeNameMaybeUnicode === "number") acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
            prefix: prefix,
            iconName: iconName
        };
        return acc;
    }, {
        names: {},
        unicodes: {}
    });
    $089d1397ac35d9f8$var$_byOldName = shimLookups.names;
    $089d1397ac35d9f8$var$_byOldUnicode = shimLookups.unicodes;
    $089d1397ac35d9f8$var$_defaultUsablePrefix = $089d1397ac35d9f8$var$getCanonicalPrefix($089d1397ac35d9f8$var$config.styleDefault, {
        family: $089d1397ac35d9f8$var$config.familyDefault
    });
};
$089d1397ac35d9f8$var$onChange((c$$1)=>{
    $089d1397ac35d9f8$var$_defaultUsablePrefix = $089d1397ac35d9f8$var$getCanonicalPrefix(c$$1.styleDefault, {
        family: $089d1397ac35d9f8$var$config.familyDefault
    });
});
$089d1397ac35d9f8$var$build();
function $089d1397ac35d9f8$var$byUnicode(prefix, unicode) {
    return ($089d1397ac35d9f8$var$_byUnicode[prefix] || {})[unicode];
}
function $089d1397ac35d9f8$var$byLigature(prefix, ligature) {
    return ($089d1397ac35d9f8$var$_byLigature[prefix] || {})[ligature];
}
function $089d1397ac35d9f8$var$byAlias(prefix, alias) {
    return ($089d1397ac35d9f8$var$_byAlias[prefix] || {})[alias];
}
function $089d1397ac35d9f8$var$byOldName(name) {
    return $089d1397ac35d9f8$var$_byOldName[name] || {
        prefix: null,
        iconName: null
    };
}
function $089d1397ac35d9f8$var$byOldUnicode(unicode) {
    const oldUnicode = $089d1397ac35d9f8$var$_byOldUnicode[unicode];
    const newUnicode = $089d1397ac35d9f8$var$byUnicode("fas", unicode);
    return oldUnicode || (newUnicode ? {
        prefix: "fas",
        iconName: newUnicode
    } : null) || {
        prefix: null,
        iconName: null
    };
}
function $089d1397ac35d9f8$var$getDefaultUsablePrefix() {
    return $089d1397ac35d9f8$var$_defaultUsablePrefix;
}
const $089d1397ac35d9f8$var$emptyCanonicalIcon = ()=>{
    return {
        prefix: null,
        iconName: null,
        rest: []
    };
};
function $089d1397ac35d9f8$var$getCanonicalPrefix(styleOrPrefix) {
    let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { family: family = $089d1397ac35d9f8$var$a } = params;
    const style = $089d1397ac35d9f8$var$PREFIX_TO_STYLE[family][styleOrPrefix];
    const prefix = $089d1397ac35d9f8$var$STYLE_TO_PREFIX[family][styleOrPrefix] || $089d1397ac35d9f8$var$STYLE_TO_PREFIX[family][style];
    const defined = styleOrPrefix in $089d1397ac35d9f8$var$namespace.styles ? styleOrPrefix : null;
    const result = prefix || defined || null;
    return result;
}
const $089d1397ac35d9f8$var$PREFIXES_FOR_FAMILY = {
    [$089d1397ac35d9f8$var$a]: Object.keys($089d1397ac35d9f8$var$PREFIX_TO_LONG_STYLE[$089d1397ac35d9f8$var$a]),
    [$089d1397ac35d9f8$var$r]: Object.keys($089d1397ac35d9f8$var$PREFIX_TO_LONG_STYLE[$089d1397ac35d9f8$var$r]),
    [$089d1397ac35d9f8$var$o]: Object.keys($089d1397ac35d9f8$var$PREFIX_TO_LONG_STYLE[$089d1397ac35d9f8$var$o])
};
function $089d1397ac35d9f8$var$getCanonicalIcon(values) {
    let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { skipLookups: skipLookups = false } = params;
    const famProps = {
        [$089d1397ac35d9f8$var$a]: "".concat($089d1397ac35d9f8$var$config.cssPrefix, "-").concat($089d1397ac35d9f8$var$a),
        [$089d1397ac35d9f8$var$r]: "".concat($089d1397ac35d9f8$var$config.cssPrefix, "-").concat($089d1397ac35d9f8$var$r),
        [$089d1397ac35d9f8$var$o]: "".concat($089d1397ac35d9f8$var$config.cssPrefix, "-").concat($089d1397ac35d9f8$var$o)
    };
    let givenPrefix = null;
    let family = $089d1397ac35d9f8$var$a;
    const nonDuotoneFamilyIds = $089d1397ac35d9f8$var$c.filter((familyId)=>familyId !== $089d1397ac35d9f8$var$t);
    nonDuotoneFamilyIds.forEach((familyId)=>{
        if (values.includes(famProps[familyId]) || values.some((v$$1)=>$089d1397ac35d9f8$var$PREFIXES_FOR_FAMILY[familyId].includes(v$$1))) family = familyId;
    });
    const canonical = values.reduce((acc, cls)=>{
        const iconName = $089d1397ac35d9f8$var$getIconName($089d1397ac35d9f8$var$config.cssPrefix, cls);
        if ($089d1397ac35d9f8$var$styles[cls]) {
            cls = $089d1397ac35d9f8$var$LONG_STYLE[family].includes(cls) ? $089d1397ac35d9f8$var$LONG_STYLE_TO_PREFIX[family][cls] : cls;
            givenPrefix = cls;
            acc.prefix = cls;
        } else if ($089d1397ac35d9f8$var$PREFIXES[family].indexOf(cls) > -1) {
            givenPrefix = cls;
            acc.prefix = $089d1397ac35d9f8$var$getCanonicalPrefix(cls, {
                family: family
            });
        } else if (iconName) acc.iconName = iconName;
        else if (cls !== $089d1397ac35d9f8$var$config.replacementClass && !nonDuotoneFamilyIds.some((familyName)=>cls === famProps[familyName])) acc.rest.push(cls);
        if (!skipLookups && acc.prefix && acc.iconName) {
            const shim = givenPrefix === "fa" ? $089d1397ac35d9f8$var$byOldName(acc.iconName) : {};
            const aliasIconName = $089d1397ac35d9f8$var$byAlias(acc.prefix, acc.iconName);
            if (shim.prefix) givenPrefix = null;
            acc.iconName = shim.iconName || aliasIconName || acc.iconName;
            acc.prefix = shim.prefix || acc.prefix;
            if (acc.prefix === "far" && !$089d1397ac35d9f8$var$styles["far"] && $089d1397ac35d9f8$var$styles["fas"] && !$089d1397ac35d9f8$var$config.autoFetchSvg) // Allow a fallback from the regular style to solid if regular is not available
            // but only if we aren't auto-fetching SVGs
            acc.prefix = "fas";
        }
        return acc;
    }, $089d1397ac35d9f8$var$emptyCanonicalIcon());
    if (values.includes("fa-brands") || values.includes("fab")) canonical.prefix = "fab";
    if (values.includes("fa-duotone") || values.includes("fad")) canonical.prefix = "fad";
    if (!canonical.prefix && family === $089d1397ac35d9f8$var$r && ($089d1397ac35d9f8$var$styles["fass"] || $089d1397ac35d9f8$var$config.autoFetchSvg)) {
        canonical.prefix = "fass";
        canonical.iconName = $089d1397ac35d9f8$var$byAlias(canonical.prefix, canonical.iconName) || canonical.iconName;
    }
    if (!canonical.prefix && family === $089d1397ac35d9f8$var$o && ($089d1397ac35d9f8$var$styles["fasds"] || $089d1397ac35d9f8$var$config.autoFetchSvg)) {
        canonical.prefix = "fasds";
        canonical.iconName = $089d1397ac35d9f8$var$byAlias(canonical.prefix, canonical.iconName) || canonical.iconName;
    }
    if (canonical.prefix === "fa" || givenPrefix === "fa") // The fa prefix is not canonical. So if it has made it through until this point
    // we will shift it to the correct prefix.
    canonical.prefix = $089d1397ac35d9f8$var$getDefaultUsablePrefix() || "fas";
    return canonical;
}
class $089d1397ac35d9f8$var$Library {
    constructor(){
        this.definitions = {};
    }
    add() {
        for(var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++)definitions[_key] = arguments[_key];
        const additions = definitions.reduce(this._pullDefinitions, {});
        Object.keys(additions).forEach((key)=>{
            this.definitions[key] = {
                ...this.definitions[key] || {},
                ...additions[key]
            };
            $089d1397ac35d9f8$var$defineIcons(key, additions[key]); // TODO can we stop doing this? We can't get the icons by 'fa-solid' any longer so this probably needs to change
            const longPrefix = $089d1397ac35d9f8$var$PREFIX_TO_LONG_STYLE[$089d1397ac35d9f8$var$a][key];
            if (longPrefix) $089d1397ac35d9f8$var$defineIcons(longPrefix, additions[key]);
            $089d1397ac35d9f8$var$build();
        });
    }
    reset() {
        this.definitions = {};
    }
    _pullDefinitions(additions, definition) {
        const normalized = definition.prefix && definition.iconName && definition.icon ? {
            0: definition
        } : definition;
        Object.keys(normalized).map((key)=>{
            const { prefix: prefix, iconName: iconName, icon: icon } = normalized[key];
            const aliases = icon[2];
            if (!additions[prefix]) additions[prefix] = {};
            if (aliases.length > 0) aliases.forEach((alias)=>{
                if (typeof alias === "string") additions[prefix][alias] = icon;
            });
            additions[prefix][iconName] = icon;
        });
        return additions;
    }
}
let $089d1397ac35d9f8$var$_plugins = [];
let $089d1397ac35d9f8$var$_hooks = {};
const $089d1397ac35d9f8$var$providers = {};
const $089d1397ac35d9f8$var$defaultProviderKeys = Object.keys($089d1397ac35d9f8$var$providers);
function $089d1397ac35d9f8$var$registerPlugins(nextPlugins, _ref) {
    let { mixoutsTo: obj } = _ref;
    $089d1397ac35d9f8$var$_plugins = nextPlugins;
    $089d1397ac35d9f8$var$_hooks = {};
    Object.keys($089d1397ac35d9f8$var$providers).forEach((k)=>{
        if ($089d1397ac35d9f8$var$defaultProviderKeys.indexOf(k) === -1) delete $089d1397ac35d9f8$var$providers[k];
    });
    $089d1397ac35d9f8$var$_plugins.forEach((plugin)=>{
        const mixout = plugin.mixout ? plugin.mixout() : {};
        Object.keys(mixout).forEach((tk)=>{
            if (typeof mixout[tk] === "function") obj[tk] = mixout[tk];
            if (typeof mixout[tk] === "object") Object.keys(mixout[tk]).forEach((sk)=>{
                if (!obj[tk]) obj[tk] = {};
                obj[tk][sk] = mixout[tk][sk];
            });
        });
        if (plugin.hooks) {
            const hooks = plugin.hooks();
            Object.keys(hooks).forEach((hook)=>{
                if (!$089d1397ac35d9f8$var$_hooks[hook]) $089d1397ac35d9f8$var$_hooks[hook] = [];
                $089d1397ac35d9f8$var$_hooks[hook].push(hooks[hook]);
            });
        }
        if (plugin.provides) plugin.provides($089d1397ac35d9f8$var$providers);
    });
    return obj;
}
function $089d1397ac35d9f8$var$chainHooks(hook, accumulator) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    const hookFns = $089d1397ac35d9f8$var$_hooks[hook] || [];
    hookFns.forEach((hookFn)=>{
        accumulator = hookFn.apply(null, [
            accumulator,
            ...args
        ]); // eslint-disable-line no-useless-call
    });
    return accumulator;
}
function $089d1397ac35d9f8$var$callHooks(hook) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    const hookFns = $089d1397ac35d9f8$var$_hooks[hook] || [];
    hookFns.forEach((hookFn)=>{
        hookFn.apply(null, args);
    });
    return undefined;
}
function $089d1397ac35d9f8$var$callProvided() {
    const hook = arguments[0];
    const args = Array.prototype.slice.call(arguments, 1);
    return $089d1397ac35d9f8$var$providers[hook] ? $089d1397ac35d9f8$var$providers[hook].apply(null, args) : undefined;
}
function $089d1397ac35d9f8$var$findIconDefinition(iconLookup) {
    if (iconLookup.prefix === "fa") iconLookup.prefix = "fas";
    let { iconName: iconName } = iconLookup;
    const prefix = iconLookup.prefix || $089d1397ac35d9f8$var$getDefaultUsablePrefix();
    if (!iconName) return;
    iconName = $089d1397ac35d9f8$var$byAlias(prefix, iconName) || iconName;
    return $089d1397ac35d9f8$var$iconFromMapping($089d1397ac35d9f8$var$library.definitions, prefix, iconName) || $089d1397ac35d9f8$var$iconFromMapping($089d1397ac35d9f8$var$namespace.styles, prefix, iconName);
}
const $089d1397ac35d9f8$var$library = new $089d1397ac35d9f8$var$Library();
const $089d1397ac35d9f8$var$noAuto = ()=>{
    $089d1397ac35d9f8$var$config.autoReplaceSvg = false;
    $089d1397ac35d9f8$var$config.observeMutations = false;
    $089d1397ac35d9f8$var$callHooks("noAuto");
};
const $089d1397ac35d9f8$var$dom = {
    i2svg: function() {
        let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if ($089d1397ac35d9f8$var$IS_DOM) {
            $089d1397ac35d9f8$var$callHooks("beforeI2svg", params);
            $089d1397ac35d9f8$var$callProvided("pseudoElements2svg", params);
            return $089d1397ac35d9f8$var$callProvided("i2svg", params);
        } else return Promise.reject(new Error("Operation requires a DOM of some kind."));
    },
    watch: function() {
        let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const { autoReplaceSvgRoot: autoReplaceSvgRoot } = params;
        if ($089d1397ac35d9f8$var$config.autoReplaceSvg === false) $089d1397ac35d9f8$var$config.autoReplaceSvg = true;
        $089d1397ac35d9f8$var$config.observeMutations = true;
        $089d1397ac35d9f8$var$domready(()=>{
            $089d1397ac35d9f8$var$autoReplace({
                autoReplaceSvgRoot: autoReplaceSvgRoot
            });
            $089d1397ac35d9f8$var$callHooks("watch", params);
        });
    }
};
const $089d1397ac35d9f8$var$parse = {
    icon: (icon)=>{
        if (icon === null) return null;
        if (typeof icon === "object" && icon.prefix && icon.iconName) return {
            prefix: icon.prefix,
            iconName: $089d1397ac35d9f8$var$byAlias(icon.prefix, icon.iconName) || icon.iconName
        };
        if (Array.isArray(icon) && icon.length === 2) {
            const iconName = icon[1].indexOf("fa-") === 0 ? icon[1].slice(3) : icon[1];
            const prefix = $089d1397ac35d9f8$var$getCanonicalPrefix(icon[0]);
            return {
                prefix: prefix,
                iconName: $089d1397ac35d9f8$var$byAlias(prefix, iconName) || iconName
            };
        }
        if (typeof icon === "string" && (icon.indexOf("".concat($089d1397ac35d9f8$var$config.cssPrefix, "-")) > -1 || icon.match($089d1397ac35d9f8$var$ICON_SELECTION_SYNTAX_PATTERN))) {
            const canonicalIcon = $089d1397ac35d9f8$var$getCanonicalIcon(icon.split(" "), {
                skipLookups: true
            });
            return {
                prefix: canonicalIcon.prefix || $089d1397ac35d9f8$var$getDefaultUsablePrefix(),
                iconName: $089d1397ac35d9f8$var$byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
            };
        }
        if (typeof icon === "string") {
            const prefix = $089d1397ac35d9f8$var$getDefaultUsablePrefix();
            return {
                prefix: prefix,
                iconName: $089d1397ac35d9f8$var$byAlias(prefix, icon) || icon
            };
        }
    }
};
const $089d1397ac35d9f8$export$644d8ea042df96a6 = {
    noAuto: $089d1397ac35d9f8$var$noAuto,
    config: $089d1397ac35d9f8$var$config,
    dom: $089d1397ac35d9f8$var$dom,
    parse: $089d1397ac35d9f8$var$parse,
    library: $089d1397ac35d9f8$var$library,
    findIconDefinition: $089d1397ac35d9f8$var$findIconDefinition,
    toHtml: $089d1397ac35d9f8$var$toHtml
};
const $089d1397ac35d9f8$var$autoReplace = function() {
    let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const { autoReplaceSvgRoot: autoReplaceSvgRoot = $089d1397ac35d9f8$var$DOCUMENT } = params;
    if ((Object.keys($089d1397ac35d9f8$var$namespace.styles).length > 0 || $089d1397ac35d9f8$var$config.autoFetchSvg) && $089d1397ac35d9f8$var$IS_DOM && $089d1397ac35d9f8$var$config.autoReplaceSvg) $089d1397ac35d9f8$export$644d8ea042df96a6.dom.i2svg({
        node: autoReplaceSvgRoot
    });
};
function $089d1397ac35d9f8$var$domVariants(val, abstractCreator) {
    Object.defineProperty(val, "abstract", {
        get: abstractCreator
    });
    Object.defineProperty(val, "html", {
        get: function() {
            return val.abstract.map((a)=>$089d1397ac35d9f8$var$toHtml(a));
        }
    });
    Object.defineProperty(val, "node", {
        get: function() {
            if (!$089d1397ac35d9f8$var$IS_DOM) return;
            const container = $089d1397ac35d9f8$var$DOCUMENT.createElement("div");
            container.innerHTML = val.html;
            return container.children;
        }
    });
    return val;
}
function $089d1397ac35d9f8$var$asIcon(_ref) {
    let { children: children, main: main, mask: mask, attributes: attributes, styles: styles, transform: transform } = _ref;
    if ($089d1397ac35d9f8$var$transformIsMeaningful(transform) && main.found && !mask.found) {
        const { width: width, height: height } = main;
        const offset = {
            x: width / height / 2,
            y: 0.5
        };
        attributes["style"] = $089d1397ac35d9f8$var$joinStyles({
            ...styles,
            "transform-origin": "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
        });
    }
    return [
        {
            tag: "svg",
            attributes: attributes,
            children: children
        }
    ];
}
function $089d1397ac35d9f8$var$asSymbol(_ref) {
    let { prefix: prefix, iconName: iconName, children: children, attributes: attributes, symbol: symbol } = _ref;
    const id = symbol === true ? "".concat(prefix, "-").concat($089d1397ac35d9f8$var$config.cssPrefix, "-").concat(iconName) : symbol;
    return [
        {
            tag: "svg",
            attributes: {
                style: "display: none;"
            },
            children: [
                {
                    tag: "symbol",
                    attributes: {
                        ...attributes,
                        id: id
                    },
                    children: children
                }
            ]
        }
    ];
}
function $089d1397ac35d9f8$var$makeInlineSvgAbstract(params) {
    const { icons: { main: main, mask: mask }, prefix: prefix, iconName: iconName, transform: transform, symbol: symbol, title: title, maskId: maskId, titleId: titleId, extra: extra, watchable: watchable = false } = params;
    const { width: width, height: height } = mask.found ? mask : main;
    const isUploadedIcon = prefix === "fak";
    const attrClass = [
        $089d1397ac35d9f8$var$config.replacementClass,
        iconName ? "".concat($089d1397ac35d9f8$var$config.cssPrefix, "-").concat(iconName) : ""
    ].filter((c)=>extra.classes.indexOf(c) === -1).filter((c)=>c !== "" || !!c).concat(extra.classes).join(" ");
    let content = {
        children: [],
        attributes: {
            ...extra.attributes,
            "data-prefix": prefix,
            "data-icon": iconName,
            "class": attrClass,
            "role": extra.attributes.role || "img",
            "xmlns": "http://www.w3.org/2000/svg",
            "viewBox": "0 0 ".concat(width, " ").concat(height)
        }
    };
    const uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf("fa-fw") ? {
        width: "".concat(width / height * 1, "em")
    } : {};
    if (watchable) content.attributes[$089d1397ac35d9f8$var$DATA_FA_I2SVG] = "";
    if (title) {
        content.children.push({
            tag: "title",
            attributes: {
                id: content.attributes["aria-labelledby"] || "title-".concat(titleId || $089d1397ac35d9f8$var$nextUniqueId())
            },
            children: [
                title
            ]
        });
        delete content.attributes.title;
    }
    const args = {
        ...content,
        prefix: prefix,
        iconName: iconName,
        main: main,
        mask: mask,
        maskId: maskId,
        transform: transform,
        symbol: symbol,
        styles: {
            ...uploadedIconWidthStyle,
            ...extra.styles
        }
    };
    const { children: children, attributes: attributes } = mask.found && main.found ? $089d1397ac35d9f8$var$callProvided("generateAbstractMask", args) || {
        children: [],
        attributes: {}
    } : $089d1397ac35d9f8$var$callProvided("generateAbstractIcon", args) || {
        children: [],
        attributes: {}
    };
    args.children = children;
    args.attributes = attributes;
    if (symbol) return $089d1397ac35d9f8$var$asSymbol(args);
    else return $089d1397ac35d9f8$var$asIcon(args);
}
function $089d1397ac35d9f8$var$makeLayersTextAbstract(params) {
    const { content: content, width: width, height: height, transform: transform, title: title, extra: extra, watchable: watchable = false } = params;
    const attributes = {
        ...extra.attributes,
        ...title ? {
            "title": title
        } : {},
        "class": extra.classes.join(" ")
    };
    if (watchable) attributes[$089d1397ac35d9f8$var$DATA_FA_I2SVG] = "";
    const styles = {
        ...extra.styles
    };
    if ($089d1397ac35d9f8$var$transformIsMeaningful(transform)) {
        styles["transform"] = $089d1397ac35d9f8$var$transformForCss({
            transform: transform,
            startCentered: true,
            width: width,
            height: height
        });
        styles["-webkit-transform"] = styles["transform"];
    }
    const styleString = $089d1397ac35d9f8$var$joinStyles(styles);
    if (styleString.length > 0) attributes["style"] = styleString;
    const val = [];
    val.push({
        tag: "span",
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: "span",
        attributes: {
            class: "sr-only"
        },
        children: [
            title
        ]
    });
    return val;
}
function $089d1397ac35d9f8$var$makeLayersCounterAbstract(params) {
    const { content: content, title: title, extra: extra } = params;
    const attributes = {
        ...extra.attributes,
        ...title ? {
            "title": title
        } : {},
        "class": extra.classes.join(" ")
    };
    const styleString = $089d1397ac35d9f8$var$joinStyles(extra.styles);
    if (styleString.length > 0) attributes["style"] = styleString;
    const val = [];
    val.push({
        tag: "span",
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: "span",
        attributes: {
            class: "sr-only"
        },
        children: [
            title
        ]
    });
    return val;
}
const { styles: $089d1397ac35d9f8$var$styles$1 } = $089d1397ac35d9f8$var$namespace;
function $089d1397ac35d9f8$var$asFoundIcon(icon) {
    const width = icon[0];
    const height = icon[1];
    const [vectorData] = icon.slice(4);
    let element = null;
    if (Array.isArray(vectorData)) element = {
        tag: "g",
        attributes: {
            class: "".concat($089d1397ac35d9f8$var$config.cssPrefix, "-").concat($089d1397ac35d9f8$var$DUOTONE_CLASSES.GROUP)
        },
        children: [
            {
                tag: "path",
                attributes: {
                    class: "".concat($089d1397ac35d9f8$var$config.cssPrefix, "-").concat($089d1397ac35d9f8$var$DUOTONE_CLASSES.SECONDARY),
                    fill: "currentColor",
                    d: vectorData[0]
                }
            },
            {
                tag: "path",
                attributes: {
                    class: "".concat($089d1397ac35d9f8$var$config.cssPrefix, "-").concat($089d1397ac35d9f8$var$DUOTONE_CLASSES.PRIMARY),
                    fill: "currentColor",
                    d: vectorData[1]
                }
            }
        ]
    };
    else element = {
        tag: "path",
        attributes: {
            fill: "currentColor",
            d: vectorData
        }
    };
    return {
        found: true,
        width: width,
        height: height,
        icon: element
    };
}
const $089d1397ac35d9f8$var$missingIconResolutionMixin = {
    found: false,
    width: 512,
    height: 512
};
function $089d1397ac35d9f8$var$maybeNotifyMissing(iconName, prefix) {
    if (!$089d1397ac35d9f8$var$PRODUCTION && !$089d1397ac35d9f8$var$config.showMissingIcons && iconName) console.error('Icon with name "'.concat(iconName, '" and prefix "').concat(prefix, '" is missing.'));
}
function $089d1397ac35d9f8$var$findIcon(iconName, prefix) {
    let givenPrefix = prefix;
    if (prefix === "fa" && $089d1397ac35d9f8$var$config.styleDefault !== null) prefix = $089d1397ac35d9f8$var$getDefaultUsablePrefix();
    return new Promise((resolve, reject)=>{
        if (givenPrefix === "fa") {
            const shim = $089d1397ac35d9f8$var$byOldName(iconName) || {};
            iconName = shim.iconName || iconName;
            prefix = shim.prefix || prefix;
        }
        if (iconName && prefix && $089d1397ac35d9f8$var$styles$1[prefix] && $089d1397ac35d9f8$var$styles$1[prefix][iconName]) {
            const icon = $089d1397ac35d9f8$var$styles$1[prefix][iconName];
            return resolve($089d1397ac35d9f8$var$asFoundIcon(icon));
        }
        $089d1397ac35d9f8$var$maybeNotifyMissing(iconName, prefix);
        resolve({
            ...$089d1397ac35d9f8$var$missingIconResolutionMixin,
            icon: $089d1397ac35d9f8$var$config.showMissingIcons && iconName ? $089d1397ac35d9f8$var$callProvided("missingIconAbstract") || {} : {}
        });
    });
}
const $089d1397ac35d9f8$var$noop$1 = ()=>{};
const $089d1397ac35d9f8$var$p$2 = $089d1397ac35d9f8$var$config.measurePerformance && $089d1397ac35d9f8$var$PERFORMANCE && $089d1397ac35d9f8$var$PERFORMANCE.mark && $089d1397ac35d9f8$var$PERFORMANCE.measure ? $089d1397ac35d9f8$var$PERFORMANCE : {
    mark: $089d1397ac35d9f8$var$noop$1,
    measure: $089d1397ac35d9f8$var$noop$1
};
const $089d1397ac35d9f8$var$preamble = 'FA "6.6.0"';
const $089d1397ac35d9f8$var$begin = (name)=>{
    $089d1397ac35d9f8$var$p$2.mark("".concat($089d1397ac35d9f8$var$preamble, " ").concat(name, " begins"));
    return ()=>$089d1397ac35d9f8$var$end(name);
};
const $089d1397ac35d9f8$var$end = (name)=>{
    $089d1397ac35d9f8$var$p$2.mark("".concat($089d1397ac35d9f8$var$preamble, " ").concat(name, " ends"));
    $089d1397ac35d9f8$var$p$2.measure("".concat($089d1397ac35d9f8$var$preamble, " ").concat(name), "".concat($089d1397ac35d9f8$var$preamble, " ").concat(name, " begins"), "".concat($089d1397ac35d9f8$var$preamble, " ").concat(name, " ends"));
};
var $089d1397ac35d9f8$var$perf = {
    begin: $089d1397ac35d9f8$var$begin,
    end: $089d1397ac35d9f8$var$end
};
const $089d1397ac35d9f8$var$noop$2 = ()=>{};
function $089d1397ac35d9f8$var$isWatched(node) {
    const i2svg = node.getAttribute ? node.getAttribute($089d1397ac35d9f8$var$DATA_FA_I2SVG) : null;
    return typeof i2svg === "string";
}
function $089d1397ac35d9f8$var$hasPrefixAndIcon(node) {
    const prefix = node.getAttribute ? node.getAttribute($089d1397ac35d9f8$var$DATA_PREFIX) : null;
    const icon = node.getAttribute ? node.getAttribute($089d1397ac35d9f8$var$DATA_ICON) : null;
    return prefix && icon;
}
function $089d1397ac35d9f8$var$hasBeenReplaced(node) {
    return node && node.classList && node.classList.contains && node.classList.contains($089d1397ac35d9f8$var$config.replacementClass);
}
function $089d1397ac35d9f8$var$getMutator() {
    if ($089d1397ac35d9f8$var$config.autoReplaceSvg === true) return $089d1397ac35d9f8$var$mutators.replace;
    const mutator = $089d1397ac35d9f8$var$mutators[$089d1397ac35d9f8$var$config.autoReplaceSvg];
    return mutator || $089d1397ac35d9f8$var$mutators.replace;
}
function $089d1397ac35d9f8$var$createElementNS(tag) {
    return $089d1397ac35d9f8$var$DOCUMENT.createElementNS("http://www.w3.org/2000/svg", tag);
}
function $089d1397ac35d9f8$var$createElement(tag) {
    return $089d1397ac35d9f8$var$DOCUMENT.createElement(tag);
}
function $089d1397ac35d9f8$var$convertSVG(abstractObj) {
    let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { ceFn: ceFn = abstractObj.tag === "svg" ? $089d1397ac35d9f8$var$createElementNS : $089d1397ac35d9f8$var$createElement } = params;
    if (typeof abstractObj === "string") return $089d1397ac35d9f8$var$DOCUMENT.createTextNode(abstractObj);
    const tag = ceFn(abstractObj.tag);
    Object.keys(abstractObj.attributes || []).forEach(function(key) {
        tag.setAttribute(key, abstractObj.attributes[key]);
    });
    const children = abstractObj.children || [];
    children.forEach(function(child) {
        tag.appendChild($089d1397ac35d9f8$var$convertSVG(child, {
            ceFn: ceFn
        }));
    });
    return tag;
}
function $089d1397ac35d9f8$var$nodeAsComment(node) {
    let comment = " ".concat(node.outerHTML, " ");
    /* BEGIN.ATTRIBUTION */ comment = "".concat(comment, "Font Awesome fontawesome.com ");
    /* END.ATTRIBUTION */ return comment;
}
const $089d1397ac35d9f8$var$mutators = {
    replace: function(mutation) {
        const node = mutation[0];
        if (node.parentNode) {
            mutation[1].forEach((abstract)=>{
                node.parentNode.insertBefore($089d1397ac35d9f8$var$convertSVG(abstract), node);
            });
            if (node.getAttribute($089d1397ac35d9f8$var$DATA_FA_I2SVG) === null && $089d1397ac35d9f8$var$config.keepOriginalSource) {
                let comment = $089d1397ac35d9f8$var$DOCUMENT.createComment($089d1397ac35d9f8$var$nodeAsComment(node));
                node.parentNode.replaceChild(comment, node);
            } else node.remove();
        }
    },
    nest: function(mutation) {
        const node = mutation[0];
        const abstract = mutation[1]; // If we already have a replaced node we do not want to continue nesting within it.
        // Short-circuit to the standard replacement
        if (~$089d1397ac35d9f8$var$classArray(node).indexOf($089d1397ac35d9f8$var$config.replacementClass)) return $089d1397ac35d9f8$var$mutators.replace(mutation);
        const forSvg = new RegExp("".concat($089d1397ac35d9f8$var$config.cssPrefix, "-.*"));
        delete abstract[0].attributes.id;
        if (abstract[0].attributes.class) {
            const splitClasses = abstract[0].attributes.class.split(" ").reduce((acc, cls)=>{
                if (cls === $089d1397ac35d9f8$var$config.replacementClass || cls.match(forSvg)) acc.toSvg.push(cls);
                else acc.toNode.push(cls);
                return acc;
            }, {
                toNode: [],
                toSvg: []
            });
            abstract[0].attributes.class = splitClasses.toSvg.join(" ");
            if (splitClasses.toNode.length === 0) node.removeAttribute("class");
            else node.setAttribute("class", splitClasses.toNode.join(" "));
        }
        const newInnerHTML = abstract.map((a)=>$089d1397ac35d9f8$var$toHtml(a)).join("\n");
        node.setAttribute($089d1397ac35d9f8$var$DATA_FA_I2SVG, "");
        node.innerHTML = newInnerHTML;
    }
};
function $089d1397ac35d9f8$var$performOperationSync(op) {
    op();
}
function $089d1397ac35d9f8$var$perform(mutations, callback) {
    const callbackFunction = typeof callback === "function" ? callback : $089d1397ac35d9f8$var$noop$2;
    if (mutations.length === 0) callbackFunction();
    else {
        let frame = $089d1397ac35d9f8$var$performOperationSync;
        if ($089d1397ac35d9f8$var$config.mutateApproach === $089d1397ac35d9f8$var$MUTATION_APPROACH_ASYNC) frame = $089d1397ac35d9f8$var$WINDOW.requestAnimationFrame || $089d1397ac35d9f8$var$performOperationSync;
        frame(()=>{
            const mutator = $089d1397ac35d9f8$var$getMutator();
            const mark = $089d1397ac35d9f8$var$perf.begin("mutate");
            mutations.map(mutator);
            mark();
            callbackFunction();
        });
    }
}
let $089d1397ac35d9f8$var$disabled = false;
function $089d1397ac35d9f8$var$disableObservation() {
    $089d1397ac35d9f8$var$disabled = true;
}
function $089d1397ac35d9f8$var$enableObservation() {
    $089d1397ac35d9f8$var$disabled = false;
}
let $089d1397ac35d9f8$var$mo$1 = null;
function $089d1397ac35d9f8$var$observe(options) {
    if (!$089d1397ac35d9f8$var$MUTATION_OBSERVER) return;
    if (!$089d1397ac35d9f8$var$config.observeMutations) return;
    const { treeCallback: treeCallback = $089d1397ac35d9f8$var$noop$2, nodeCallback: nodeCallback = $089d1397ac35d9f8$var$noop$2, pseudoElementsCallback: pseudoElementsCallback = $089d1397ac35d9f8$var$noop$2, observeMutationsRoot: observeMutationsRoot = $089d1397ac35d9f8$var$DOCUMENT } = options;
    $089d1397ac35d9f8$var$mo$1 = new $089d1397ac35d9f8$var$MUTATION_OBSERVER((objects)=>{
        if ($089d1397ac35d9f8$var$disabled) return;
        const defaultPrefix = $089d1397ac35d9f8$var$getDefaultUsablePrefix();
        $089d1397ac35d9f8$var$toArray(objects).forEach((mutationRecord)=>{
            if (mutationRecord.type === "childList" && mutationRecord.addedNodes.length > 0 && !$089d1397ac35d9f8$var$isWatched(mutationRecord.addedNodes[0])) {
                if ($089d1397ac35d9f8$var$config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target);
                treeCallback(mutationRecord.target);
            }
            if (mutationRecord.type === "attributes" && mutationRecord.target.parentNode && $089d1397ac35d9f8$var$config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target.parentNode);
            if (mutationRecord.type === "attributes" && $089d1397ac35d9f8$var$isWatched(mutationRecord.target) && ~$089d1397ac35d9f8$var$ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
                if (mutationRecord.attributeName === "class" && $089d1397ac35d9f8$var$hasPrefixAndIcon(mutationRecord.target)) {
                    const { prefix: prefix, iconName: iconName } = $089d1397ac35d9f8$var$getCanonicalIcon($089d1397ac35d9f8$var$classArray(mutationRecord.target));
                    mutationRecord.target.setAttribute($089d1397ac35d9f8$var$DATA_PREFIX, prefix || defaultPrefix);
                    if (iconName) mutationRecord.target.setAttribute($089d1397ac35d9f8$var$DATA_ICON, iconName);
                } else if ($089d1397ac35d9f8$var$hasBeenReplaced(mutationRecord.target)) nodeCallback(mutationRecord.target);
            }
        });
    });
    if (!$089d1397ac35d9f8$var$IS_DOM) return;
    $089d1397ac35d9f8$var$mo$1.observe(observeMutationsRoot, {
        childList: true,
        attributes: true,
        characterData: true,
        subtree: true
    });
}
function $089d1397ac35d9f8$var$disconnect() {
    if (!$089d1397ac35d9f8$var$mo$1) return;
    $089d1397ac35d9f8$var$mo$1.disconnect();
}
function $089d1397ac35d9f8$var$styleParser(node) {
    const style = node.getAttribute("style");
    let val = [];
    if (style) val = style.split(";").reduce((acc, style)=>{
        const styles = style.split(":");
        const prop = styles[0];
        const value = styles.slice(1);
        if (prop && value.length > 0) acc[prop] = value.join(":").trim();
        return acc;
    }, {});
    return val;
}
function $089d1397ac35d9f8$var$classParser(node) {
    const existingPrefix = node.getAttribute("data-prefix");
    const existingIconName = node.getAttribute("data-icon");
    const innerText = node.innerText !== undefined ? node.innerText.trim() : "";
    let val = $089d1397ac35d9f8$var$getCanonicalIcon($089d1397ac35d9f8$var$classArray(node));
    if (!val.prefix) val.prefix = $089d1397ac35d9f8$var$getDefaultUsablePrefix();
    if (existingPrefix && existingIconName) {
        val.prefix = existingPrefix;
        val.iconName = existingIconName;
    }
    if (val.iconName && val.prefix) return val;
    if (val.prefix && innerText.length > 0) val.iconName = $089d1397ac35d9f8$var$byLigature(val.prefix, node.innerText) || $089d1397ac35d9f8$var$byUnicode(val.prefix, $089d1397ac35d9f8$var$toHex(node.innerText));
    if (!val.iconName && $089d1397ac35d9f8$var$config.autoFetchSvg && node.firstChild && node.firstChild.nodeType === Node.TEXT_NODE) val.iconName = node.firstChild.data;
    return val;
}
function $089d1397ac35d9f8$var$attributesParser(node) {
    const extraAttributes = $089d1397ac35d9f8$var$toArray(node.attributes).reduce((acc, attr)=>{
        if (acc.name !== "class" && acc.name !== "style") acc[attr.name] = attr.value;
        return acc;
    }, {});
    const title = node.getAttribute("title");
    const titleId = node.getAttribute("data-fa-title-id");
    if ($089d1397ac35d9f8$var$config.autoA11y) {
        if (title) extraAttributes["aria-labelledby"] = "".concat($089d1397ac35d9f8$var$config.replacementClass, "-title-").concat(titleId || $089d1397ac35d9f8$var$nextUniqueId());
        else {
            extraAttributes["aria-hidden"] = "true";
            extraAttributes["focusable"] = "false";
        }
    }
    return extraAttributes;
}
function $089d1397ac35d9f8$var$blankMeta() {
    return {
        iconName: null,
        title: null,
        titleId: null,
        prefix: null,
        transform: $089d1397ac35d9f8$var$meaninglessTransform,
        symbol: false,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        extra: {
            classes: [],
            styles: {},
            attributes: {}
        }
    };
}
function $089d1397ac35d9f8$var$parseMeta(node) {
    let parser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        styleParser: true
    };
    const { iconName: iconName, prefix: prefix, rest: extraClasses } = $089d1397ac35d9f8$var$classParser(node);
    const extraAttributes = $089d1397ac35d9f8$var$attributesParser(node);
    const pluginMeta = $089d1397ac35d9f8$var$chainHooks("parseNodeAttributes", {}, node);
    let extraStyles = parser.styleParser ? $089d1397ac35d9f8$var$styleParser(node) : [];
    return {
        iconName: iconName,
        title: node.getAttribute("title"),
        titleId: node.getAttribute("data-fa-title-id"),
        prefix: prefix,
        transform: $089d1397ac35d9f8$var$meaninglessTransform,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        symbol: false,
        extra: {
            classes: extraClasses,
            styles: extraStyles,
            attributes: extraAttributes
        },
        ...pluginMeta
    };
}
const { styles: $089d1397ac35d9f8$var$styles$2 } = $089d1397ac35d9f8$var$namespace;
function $089d1397ac35d9f8$var$generateMutation(node) {
    const nodeMeta = $089d1397ac35d9f8$var$config.autoReplaceSvg === "nest" ? $089d1397ac35d9f8$var$parseMeta(node, {
        styleParser: false
    }) : $089d1397ac35d9f8$var$parseMeta(node);
    if (~nodeMeta.extra.classes.indexOf($089d1397ac35d9f8$var$LAYERS_TEXT_CLASSNAME)) return $089d1397ac35d9f8$var$callProvided("generateLayersText", node, nodeMeta);
    else return $089d1397ac35d9f8$var$callProvided("generateSvgReplacementMutation", node, nodeMeta);
}
let $089d1397ac35d9f8$var$knownPrefixes = new Set();
$089d1397ac35d9f8$var$FAMILIES.map((family)=>{
    $089d1397ac35d9f8$var$knownPrefixes.add("fa-".concat(family));
});
Object.keys($089d1397ac35d9f8$var$PREFIX_TO_STYLE[$089d1397ac35d9f8$var$a]).map($089d1397ac35d9f8$var$knownPrefixes.add.bind($089d1397ac35d9f8$var$knownPrefixes));
Object.keys($089d1397ac35d9f8$var$PREFIX_TO_STYLE[$089d1397ac35d9f8$var$r]).map($089d1397ac35d9f8$var$knownPrefixes.add.bind($089d1397ac35d9f8$var$knownPrefixes));
Object.keys($089d1397ac35d9f8$var$PREFIX_TO_STYLE[$089d1397ac35d9f8$var$o]).map($089d1397ac35d9f8$var$knownPrefixes.add.bind($089d1397ac35d9f8$var$knownPrefixes));
$089d1397ac35d9f8$var$knownPrefixes = [
    ...$089d1397ac35d9f8$var$knownPrefixes
];
function $089d1397ac35d9f8$var$onTree(root) {
    let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!$089d1397ac35d9f8$var$IS_DOM) return Promise.resolve();
    const htmlClassList = $089d1397ac35d9f8$var$DOCUMENT.documentElement.classList;
    const hclAdd = (suffix)=>htmlClassList.add("".concat($089d1397ac35d9f8$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    const hclRemove = (suffix)=>htmlClassList.remove("".concat($089d1397ac35d9f8$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    const prefixes = $089d1397ac35d9f8$var$config.autoFetchSvg ? $089d1397ac35d9f8$var$knownPrefixes : $089d1397ac35d9f8$var$FAMILIES.map((f$$1)=>"fa-".concat(f$$1)).concat(Object.keys($089d1397ac35d9f8$var$styles$2));
    if (!prefixes.includes("fa")) prefixes.push("fa");
    const prefixesDomQuery = [
        ".".concat($089d1397ac35d9f8$var$LAYERS_TEXT_CLASSNAME, ":not([").concat($089d1397ac35d9f8$var$DATA_FA_I2SVG, "])")
    ].concat(prefixes.map((p$$1)=>".".concat(p$$1, ":not([").concat($089d1397ac35d9f8$var$DATA_FA_I2SVG, "])"))).join(", ");
    if (prefixesDomQuery.length === 0) return Promise.resolve();
    let candidates = [];
    try {
        candidates = $089d1397ac35d9f8$var$toArray(root.querySelectorAll(prefixesDomQuery));
    } catch (e$$1) {}
    if (candidates.length > 0) {
        hclAdd("pending");
        hclRemove("complete");
    } else return Promise.resolve();
    const mark = $089d1397ac35d9f8$var$perf.begin("onTree");
    const mutations = candidates.reduce((acc, node)=>{
        try {
            const mutation = $089d1397ac35d9f8$var$generateMutation(node);
            if (mutation) acc.push(mutation);
        } catch (e$$1) {
            if (!$089d1397ac35d9f8$var$PRODUCTION) {
                if (e$$1.name === "MissingIcon") console.error(e$$1);
            }
        }
        return acc;
    }, []);
    return new Promise((resolve, reject)=>{
        Promise.all(mutations).then((resolvedMutations)=>{
            $089d1397ac35d9f8$var$perform(resolvedMutations, ()=>{
                hclAdd("active");
                hclAdd("complete");
                hclRemove("pending");
                if (typeof callback === "function") callback();
                mark();
                resolve();
            });
        }).catch((e$$1)=>{
            mark();
            reject(e$$1);
        });
    });
}
function $089d1397ac35d9f8$var$onNode(node) {
    let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    $089d1397ac35d9f8$var$generateMutation(node).then((mutation)=>{
        if (mutation) $089d1397ac35d9f8$var$perform([
            mutation
        ], callback);
    });
}
function $089d1397ac35d9f8$var$resolveIcons(next) {
    return function(maybeIconDefinition) {
        let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : $089d1397ac35d9f8$var$findIconDefinition(maybeIconDefinition || {});
        let { mask: mask } = params;
        if (mask) mask = (mask || {}).icon ? mask : $089d1397ac35d9f8$var$findIconDefinition(mask || {});
        return next(iconDefinition, {
            ...params,
            mask: mask
        });
    };
}
const $089d1397ac35d9f8$var$render = function(iconDefinition) {
    let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { transform: transform = $089d1397ac35d9f8$var$meaninglessTransform, symbol: symbol = false, mask: mask = null, maskId: maskId = null, title: title = null, titleId: titleId = null, classes: classes = [], attributes: attributes = {}, styles: styles = {} } = params;
    if (!iconDefinition) return;
    const { prefix: prefix, iconName: iconName, icon: icon } = iconDefinition;
    return $089d1397ac35d9f8$var$domVariants({
        type: "icon",
        ...iconDefinition
    }, ()=>{
        $089d1397ac35d9f8$var$callHooks("beforeDOMElementCreation", {
            iconDefinition: iconDefinition,
            params: params
        });
        if ($089d1397ac35d9f8$var$config.autoA11y) {
            if (title) attributes["aria-labelledby"] = "".concat($089d1397ac35d9f8$var$config.replacementClass, "-title-").concat(titleId || $089d1397ac35d9f8$var$nextUniqueId());
            else {
                attributes["aria-hidden"] = "true";
                attributes["focusable"] = "false";
            }
        }
        return $089d1397ac35d9f8$var$makeInlineSvgAbstract({
            icons: {
                main: $089d1397ac35d9f8$var$asFoundIcon(icon),
                mask: mask ? $089d1397ac35d9f8$var$asFoundIcon(mask.icon) : {
                    found: false,
                    width: null,
                    height: null,
                    icon: {}
                }
            },
            prefix: prefix,
            iconName: iconName,
            transform: {
                ...$089d1397ac35d9f8$var$meaninglessTransform,
                ...transform
            },
            symbol: symbol,
            title: title,
            maskId: maskId,
            titleId: titleId,
            extra: {
                attributes: attributes,
                styles: styles,
                classes: classes
            }
        });
    });
};
var $089d1397ac35d9f8$var$ReplaceElements = {
    mixout () {
        return {
            icon: $089d1397ac35d9f8$var$resolveIcons($089d1397ac35d9f8$var$render)
        };
    },
    hooks () {
        return {
            mutationObserverCallbacks (accumulator) {
                accumulator.treeCallback = $089d1397ac35d9f8$var$onTree;
                accumulator.nodeCallback = $089d1397ac35d9f8$var$onNode;
                return accumulator;
            }
        };
    },
    provides (providers$$1) {
        providers$$1.i2svg = function(params) {
            const { node: node = $089d1397ac35d9f8$var$DOCUMENT, callback: callback = ()=>{} } = params;
            return $089d1397ac35d9f8$var$onTree(node, callback);
        };
        providers$$1.generateSvgReplacementMutation = function(node, nodeMeta) {
            const { iconName: iconName, title: title, titleId: titleId, prefix: prefix, transform: transform, symbol: symbol, mask: mask, maskId: maskId, extra: extra } = nodeMeta;
            return new Promise((resolve, reject)=>{
                Promise.all([
                    $089d1397ac35d9f8$var$findIcon(iconName, prefix),
                    mask.iconName ? $089d1397ac35d9f8$var$findIcon(mask.iconName, mask.prefix) : Promise.resolve({
                        found: false,
                        width: 512,
                        height: 512,
                        icon: {}
                    })
                ]).then((_ref)=>{
                    let [main, mask] = _ref;
                    resolve([
                        node,
                        $089d1397ac35d9f8$var$makeInlineSvgAbstract({
                            icons: {
                                main: main,
                                mask: mask
                            },
                            prefix: prefix,
                            iconName: iconName,
                            transform: transform,
                            symbol: symbol,
                            maskId: maskId,
                            title: title,
                            titleId: titleId,
                            extra: extra,
                            watchable: true
                        })
                    ]);
                }).catch(reject);
            });
        };
        providers$$1.generateAbstractIcon = function(_ref2) {
            let { children: children, attributes: attributes, main: main, transform: transform, styles: styles } = _ref2;
            const styleString = $089d1397ac35d9f8$var$joinStyles(styles);
            if (styleString.length > 0) attributes["style"] = styleString;
            let nextChild;
            if ($089d1397ac35d9f8$var$transformIsMeaningful(transform)) nextChild = $089d1397ac35d9f8$var$callProvided("generateAbstractTransformGrouping", {
                main: main,
                transform: transform,
                containerWidth: main.width,
                iconWidth: main.width
            });
            children.push(nextChild || main.icon);
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $089d1397ac35d9f8$var$Layers = {
    mixout () {
        return {
            layer (assembler) {
                let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                const { classes: classes = [] } = params;
                return $089d1397ac35d9f8$var$domVariants({
                    type: "layer"
                }, ()=>{
                    $089d1397ac35d9f8$var$callHooks("beforeDOMElementCreation", {
                        assembler: assembler,
                        params: params
                    });
                    let children = [];
                    assembler((args)=>{
                        Array.isArray(args) ? args.map((a)=>{
                            children = children.concat(a.abstract);
                        }) : children = children.concat(args.abstract);
                    });
                    return [
                        {
                            tag: "span",
                            attributes: {
                                class: [
                                    "".concat($089d1397ac35d9f8$var$config.cssPrefix, "-layers"),
                                    ...classes
                                ].join(" ")
                            },
                            children: children
                        }
                    ];
                });
            }
        };
    }
};
var $089d1397ac35d9f8$var$LayersCounter = {
    mixout () {
        return {
            counter (content) {
                let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                const { title: title = null, classes: classes = [], attributes: attributes = {}, styles: styles = {} } = params;
                return $089d1397ac35d9f8$var$domVariants({
                    type: "counter",
                    content: content
                }, ()=>{
                    $089d1397ac35d9f8$var$callHooks("beforeDOMElementCreation", {
                        content: content,
                        params: params
                    });
                    return $089d1397ac35d9f8$var$makeLayersCounterAbstract({
                        content: content.toString(),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($089d1397ac35d9f8$var$config.cssPrefix, "-layers-counter"),
                                ...classes
                            ]
                        }
                    });
                });
            }
        };
    }
};
var $089d1397ac35d9f8$var$LayersText = {
    mixout () {
        return {
            text (content) {
                let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                const { transform: transform = $089d1397ac35d9f8$var$meaninglessTransform, title: title = null, classes: classes = [], attributes: attributes = {}, styles: styles = {} } = params;
                return $089d1397ac35d9f8$var$domVariants({
                    type: "text",
                    content: content
                }, ()=>{
                    $089d1397ac35d9f8$var$callHooks("beforeDOMElementCreation", {
                        content: content,
                        params: params
                    });
                    return $089d1397ac35d9f8$var$makeLayersTextAbstract({
                        content: content,
                        transform: {
                            ...$089d1397ac35d9f8$var$meaninglessTransform,
                            ...transform
                        },
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($089d1397ac35d9f8$var$config.cssPrefix, "-layers-text"),
                                ...classes
                            ]
                        }
                    });
                });
            }
        };
    },
    provides (providers$$1) {
        providers$$1.generateLayersText = function(node, nodeMeta) {
            const { title: title, transform: transform, extra: extra } = nodeMeta;
            let width = null;
            let height = null;
            if ($089d1397ac35d9f8$var$IS_IE) {
                const computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
                const boundingClientRect = node.getBoundingClientRect();
                width = boundingClientRect.width / computedFontSize;
                height = boundingClientRect.height / computedFontSize;
            }
            if ($089d1397ac35d9f8$var$config.autoA11y && !title) extra.attributes["aria-hidden"] = "true";
            return Promise.resolve([
                node,
                $089d1397ac35d9f8$var$makeLayersTextAbstract({
                    content: node.innerHTML,
                    width: width,
                    height: height,
                    transform: transform,
                    title: title,
                    extra: extra,
                    watchable: true
                })
            ]);
        };
    }
};
const $089d1397ac35d9f8$var$CLEAN_CONTENT_PATTERN = new RegExp('"', "ug");
const $089d1397ac35d9f8$var$SECONDARY_UNICODE_RANGE = [
    1105920,
    1112319
];
const $089d1397ac35d9f8$var$_FONT_FAMILY_WEIGHT_TO_PREFIX = {
    FontAwesome: {
        normal: "fas",
        400: "fas"
    },
    ...$089d1397ac35d9f8$var$eo,
    ...$089d1397ac35d9f8$var$ao,
    ...$089d1397ac35d9f8$var$mo
};
const $089d1397ac35d9f8$var$FONT_FAMILY_WEIGHT_TO_PREFIX = Object.keys($089d1397ac35d9f8$var$_FONT_FAMILY_WEIGHT_TO_PREFIX).reduce((acc, key)=>{
    acc[key.toLowerCase()] = $089d1397ac35d9f8$var$_FONT_FAMILY_WEIGHT_TO_PREFIX[key];
    return acc;
}, {});
const $089d1397ac35d9f8$var$FONT_FAMILY_WEIGHT_FALLBACK = Object.keys($089d1397ac35d9f8$var$FONT_FAMILY_WEIGHT_TO_PREFIX).reduce((acc, fontFamily)=>{
    const weights = $089d1397ac35d9f8$var$FONT_FAMILY_WEIGHT_TO_PREFIX[fontFamily];
    acc[fontFamily] = weights[900] || [
        ...Object.entries(weights)
    ][0][1];
    return acc;
}, {});
function $089d1397ac35d9f8$var$hexValueFromContent(content) {
    const cleaned = content.replace($089d1397ac35d9f8$var$CLEAN_CONTENT_PATTERN, "");
    const codePoint = $089d1397ac35d9f8$var$codePointAt(cleaned, 0);
    const isPrependTen = codePoint >= $089d1397ac35d9f8$var$SECONDARY_UNICODE_RANGE[0] && codePoint <= $089d1397ac35d9f8$var$SECONDARY_UNICODE_RANGE[1];
    const isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
    return {
        value: isDoubled ? $089d1397ac35d9f8$var$toHex(cleaned[0]) : $089d1397ac35d9f8$var$toHex(cleaned),
        isSecondary: isPrependTen || isDoubled
    };
}
function $089d1397ac35d9f8$var$getPrefix(fontFamily, fontWeight) {
    const fontFamilySanitized = fontFamily.replace(/^['"]|['"]$/g, "").toLowerCase();
    const fontWeightInteger = parseInt(fontWeight);
    const fontWeightSanitized = isNaN(fontWeightInteger) ? "normal" : fontWeightInteger;
    return ($089d1397ac35d9f8$var$FONT_FAMILY_WEIGHT_TO_PREFIX[fontFamilySanitized] || {})[fontWeightSanitized] || $089d1397ac35d9f8$var$FONT_FAMILY_WEIGHT_FALLBACK[fontFamilySanitized];
}
function $089d1397ac35d9f8$var$replaceForPosition(node, position) {
    const pendingAttribute = "".concat($089d1397ac35d9f8$var$DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(":", "-"));
    return new Promise((resolve, reject)=>{
        if (node.getAttribute(pendingAttribute) !== null) // This node is already being processed
        return resolve();
        const children = $089d1397ac35d9f8$var$toArray(node.children);
        const alreadyProcessedPseudoElement = children.filter((c)=>c.getAttribute($089d1397ac35d9f8$var$DATA_FA_PSEUDO_ELEMENT) === position)[0];
        const styles = $089d1397ac35d9f8$var$WINDOW.getComputedStyle(node, position);
        const fontFamily = styles.getPropertyValue("font-family");
        const fontFamilyMatch = fontFamily.match($089d1397ac35d9f8$var$FONT_FAMILY_PATTERN);
        const fontWeight = styles.getPropertyValue("font-weight");
        const content = styles.getPropertyValue("content");
        if (alreadyProcessedPseudoElement && !fontFamilyMatch) {
            // If we've already processed it but the current computed style does not result in a font-family,
            // that probably means that a class name that was previously present to make the icon has been
            // removed. So we now should delete the icon.
            node.removeChild(alreadyProcessedPseudoElement);
            return resolve();
        } else if (fontFamilyMatch && content !== "none" && content !== "") {
            const content = styles.getPropertyValue("content");
            let prefix = $089d1397ac35d9f8$var$getPrefix(fontFamily, fontWeight);
            const { value: hexValue, isSecondary: isSecondary } = $089d1397ac35d9f8$var$hexValueFromContent(content);
            const isV4 = fontFamilyMatch[0].startsWith("FontAwesome");
            let iconName = $089d1397ac35d9f8$var$byUnicode(prefix, hexValue);
            let iconIdentifier = iconName;
            if (isV4) {
                const iconName4 = $089d1397ac35d9f8$var$byOldUnicode(hexValue);
                if (iconName4.iconName && iconName4.prefix) {
                    iconName = iconName4.iconName;
                    prefix = iconName4.prefix;
                }
            } // Only convert the pseudo element in this ::before/::after position into an icon if we haven't
            // already done so with the same prefix and iconName
            if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute($089d1397ac35d9f8$var$DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute($089d1397ac35d9f8$var$DATA_ICON) !== iconIdentifier)) {
                node.setAttribute(pendingAttribute, iconIdentifier);
                if (alreadyProcessedPseudoElement) // Delete the old one, since we're replacing it with a new one
                node.removeChild(alreadyProcessedPseudoElement);
                const meta = $089d1397ac35d9f8$var$blankMeta();
                const { extra: extra } = meta;
                extra.attributes[$089d1397ac35d9f8$var$DATA_FA_PSEUDO_ELEMENT] = position;
                $089d1397ac35d9f8$var$findIcon(iconName, prefix).then((main)=>{
                    const abstract = $089d1397ac35d9f8$var$makeInlineSvgAbstract({
                        ...meta,
                        icons: {
                            main: main,
                            mask: $089d1397ac35d9f8$var$emptyCanonicalIcon()
                        },
                        prefix: prefix,
                        iconName: iconIdentifier,
                        extra: extra,
                        watchable: true
                    });
                    const element = $089d1397ac35d9f8$var$DOCUMENT.createElementNS("http://www.w3.org/2000/svg", "svg");
                    if (position === "::before") node.insertBefore(element, node.firstChild);
                    else node.appendChild(element);
                    element.outerHTML = abstract.map((a)=>$089d1397ac35d9f8$var$toHtml(a)).join("\n");
                    node.removeAttribute(pendingAttribute);
                    resolve();
                }).catch(reject);
            } else resolve();
        } else resolve();
    });
}
function $089d1397ac35d9f8$var$replace(node) {
    return Promise.all([
        $089d1397ac35d9f8$var$replaceForPosition(node, "::before"),
        $089d1397ac35d9f8$var$replaceForPosition(node, "::after")
    ]);
}
function $089d1397ac35d9f8$var$processable(node) {
    return node.parentNode !== document.head && !~$089d1397ac35d9f8$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute($089d1397ac35d9f8$var$DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== "svg");
}
function $089d1397ac35d9f8$var$searchPseudoElements(root) {
    if (!$089d1397ac35d9f8$var$IS_DOM) return;
    return new Promise((resolve, reject)=>{
        const operations = $089d1397ac35d9f8$var$toArray(root.querySelectorAll("*")).filter($089d1397ac35d9f8$var$processable).map($089d1397ac35d9f8$var$replace);
        const end = $089d1397ac35d9f8$var$perf.begin("searchPseudoElements");
        $089d1397ac35d9f8$var$disableObservation();
        Promise.all(operations).then(()=>{
            end();
            $089d1397ac35d9f8$var$enableObservation();
            resolve();
        }).catch(()=>{
            end();
            $089d1397ac35d9f8$var$enableObservation();
            reject();
        });
    });
}
var $089d1397ac35d9f8$var$PseudoElements = {
    hooks () {
        return {
            mutationObserverCallbacks (accumulator) {
                accumulator.pseudoElementsCallback = $089d1397ac35d9f8$var$searchPseudoElements;
                return accumulator;
            }
        };
    },
    provides (providers) {
        providers.pseudoElements2svg = function(params) {
            const { node: node = $089d1397ac35d9f8$var$DOCUMENT } = params;
            if ($089d1397ac35d9f8$var$config.searchPseudoElements) $089d1397ac35d9f8$var$searchPseudoElements(node);
        };
    }
};
let $089d1397ac35d9f8$var$_unwatched = false;
var $089d1397ac35d9f8$var$MutationObserver$1 = {
    mixout () {
        return {
            dom: {
                unwatch () {
                    $089d1397ac35d9f8$var$disableObservation();
                    $089d1397ac35d9f8$var$_unwatched = true;
                }
            }
        };
    },
    hooks () {
        return {
            bootstrap () {
                $089d1397ac35d9f8$var$observe($089d1397ac35d9f8$var$chainHooks("mutationObserverCallbacks", {}));
            },
            noAuto () {
                $089d1397ac35d9f8$var$disconnect();
            },
            watch (params) {
                const { observeMutationsRoot: observeMutationsRoot } = params;
                if ($089d1397ac35d9f8$var$_unwatched) $089d1397ac35d9f8$var$enableObservation();
                else $089d1397ac35d9f8$var$observe($089d1397ac35d9f8$var$chainHooks("mutationObserverCallbacks", {
                    observeMutationsRoot: observeMutationsRoot
                }));
            }
        };
    }
};
const $089d1397ac35d9f8$var$parseTransformString = (transformString)=>{
    let transform = {
        size: 16,
        x: 0,
        y: 0,
        flipX: false,
        flipY: false,
        rotate: 0
    };
    return transformString.toLowerCase().split(" ").reduce((acc, n)=>{
        const parts = n.toLowerCase().split("-");
        const first = parts[0];
        let rest = parts.slice(1).join("-");
        if (first && rest === "h") {
            acc.flipX = true;
            return acc;
        }
        if (first && rest === "v") {
            acc.flipY = true;
            return acc;
        }
        rest = parseFloat(rest);
        if (isNaN(rest)) return acc;
        switch(first){
            case "grow":
                acc.size = acc.size + rest;
                break;
            case "shrink":
                acc.size = acc.size - rest;
                break;
            case "left":
                acc.x = acc.x - rest;
                break;
            case "right":
                acc.x = acc.x + rest;
                break;
            case "up":
                acc.y = acc.y - rest;
                break;
            case "down":
                acc.y = acc.y + rest;
                break;
            case "rotate":
                acc.rotate = acc.rotate + rest;
                break;
        }
        return acc;
    }, transform);
};
var $089d1397ac35d9f8$var$PowerTransforms = {
    mixout () {
        return {
            parse: {
                transform: (transformString)=>{
                    return $089d1397ac35d9f8$var$parseTransformString(transformString);
                }
            }
        };
    },
    hooks () {
        return {
            parseNodeAttributes (accumulator, node) {
                const transformString = node.getAttribute("data-fa-transform");
                if (transformString) accumulator.transform = $089d1397ac35d9f8$var$parseTransformString(transformString);
                return accumulator;
            }
        };
    },
    provides (providers) {
        providers.generateAbstractTransformGrouping = function(_ref) {
            let { main: main, transform: transform, containerWidth: containerWidth, iconWidth: iconWidth } = _ref;
            const outer = {
                transform: "translate(".concat(containerWidth / 2, " 256)")
            };
            const innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
            const innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
            const innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
            const inner = {
                transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
            };
            const path = {
                transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
            };
            const operations = {
                outer: outer,
                inner: inner,
                path: path
            };
            return {
                tag: "g",
                attributes: {
                    ...operations.outer
                },
                children: [
                    {
                        tag: "g",
                        attributes: {
                            ...operations.inner
                        },
                        children: [
                            {
                                tag: main.icon.tag,
                                children: main.icon.children,
                                attributes: {
                                    ...main.icon.attributes,
                                    ...operations.path
                                }
                            }
                        ]
                    }
                ]
            };
        };
    }
};
const $089d1397ac35d9f8$var$ALL_SPACE = {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
};
function $089d1397ac35d9f8$var$fillBlack(abstract) {
    let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (abstract.attributes && (abstract.attributes.fill || force)) abstract.attributes.fill = "black";
    return abstract;
}
function $089d1397ac35d9f8$var$deGroup(abstract) {
    if (abstract.tag === "g") return abstract.children;
    else return [
        abstract
    ];
}
var $089d1397ac35d9f8$var$Masks = {
    hooks () {
        return {
            parseNodeAttributes (accumulator, node) {
                const maskData = node.getAttribute("data-fa-mask");
                const mask = !maskData ? $089d1397ac35d9f8$var$emptyCanonicalIcon() : $089d1397ac35d9f8$var$getCanonicalIcon(maskData.split(" ").map((i)=>i.trim()));
                if (!mask.prefix) mask.prefix = $089d1397ac35d9f8$var$getDefaultUsablePrefix();
                accumulator.mask = mask;
                accumulator.maskId = node.getAttribute("data-fa-mask-id");
                return accumulator;
            }
        };
    },
    provides (providers) {
        providers.generateAbstractMask = function(_ref) {
            let { children: children, attributes: attributes, main: main, mask: mask, maskId: explicitMaskId, transform: transform } = _ref;
            const { width: mainWidth, icon: mainPath } = main;
            const { width: maskWidth, icon: maskPath } = mask;
            const trans = $089d1397ac35d9f8$var$transformForSvg({
                transform: transform,
                containerWidth: maskWidth,
                iconWidth: mainWidth
            });
            const maskRect = {
                tag: "rect",
                attributes: {
                    ...$089d1397ac35d9f8$var$ALL_SPACE,
                    fill: "white"
                }
            };
            const maskInnerGroupChildrenMixin = mainPath.children ? {
                children: mainPath.children.map($089d1397ac35d9f8$var$fillBlack)
            } : {};
            const maskInnerGroup = {
                tag: "g",
                attributes: {
                    ...trans.inner
                },
                children: [
                    $089d1397ac35d9f8$var$fillBlack({
                        tag: mainPath.tag,
                        attributes: {
                            ...mainPath.attributes,
                            ...trans.path
                        },
                        ...maskInnerGroupChildrenMixin
                    })
                ]
            };
            const maskOuterGroup = {
                tag: "g",
                attributes: {
                    ...trans.outer
                },
                children: [
                    maskInnerGroup
                ]
            };
            const maskId = "mask-".concat(explicitMaskId || $089d1397ac35d9f8$var$nextUniqueId());
            const clipId = "clip-".concat(explicitMaskId || $089d1397ac35d9f8$var$nextUniqueId());
            const maskTag = {
                tag: "mask",
                attributes: {
                    ...$089d1397ac35d9f8$var$ALL_SPACE,
                    id: maskId,
                    maskUnits: "userSpaceOnUse",
                    maskContentUnits: "userSpaceOnUse"
                },
                children: [
                    maskRect,
                    maskOuterGroup
                ]
            };
            const defs = {
                tag: "defs",
                children: [
                    {
                        tag: "clipPath",
                        attributes: {
                            id: clipId
                        },
                        children: $089d1397ac35d9f8$var$deGroup(maskPath)
                    },
                    maskTag
                ]
            };
            children.push(defs, {
                tag: "rect",
                attributes: {
                    fill: "currentColor",
                    "clip-path": "url(#".concat(clipId, ")"),
                    mask: "url(#".concat(maskId, ")"),
                    ...$089d1397ac35d9f8$var$ALL_SPACE
                }
            });
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $089d1397ac35d9f8$var$MissingIconIndicator = {
    provides (providers) {
        let reduceMotion = false;
        if ($089d1397ac35d9f8$var$WINDOW.matchMedia) reduceMotion = $089d1397ac35d9f8$var$WINDOW.matchMedia("(prefers-reduced-motion: reduce)").matches;
        providers.missingIconAbstract = function() {
            const gChildren = [];
            const FILL = {
                fill: "currentColor"
            };
            const ANIMATION_BASE = {
                attributeType: "XML",
                repeatCount: "indefinite",
                dur: "2s"
            }; // Ring
            gChildren.push({
                tag: "path",
                attributes: {
                    ...FILL,
                    d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
                }
            });
            const OPACITY_ANIMATE = {
                ...ANIMATION_BASE,
                attributeName: "opacity"
            };
            const dot = {
                tag: "circle",
                attributes: {
                    ...FILL,
                    cx: "256",
                    cy: "364",
                    r: "28"
                },
                children: []
            };
            if (!reduceMotion) dot.children.push({
                tag: "animate",
                attributes: {
                    ...ANIMATION_BASE,
                    attributeName: "r",
                    values: "28;14;28;28;14;28;"
                }
            }, {
                tag: "animate",
                attributes: {
                    ...OPACITY_ANIMATE,
                    values: "1;0;1;1;0;1;"
                }
            });
            gChildren.push(dot);
            gChildren.push({
                tag: "path",
                attributes: {
                    ...FILL,
                    opacity: "1",
                    d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
                },
                children: reduceMotion ? [] : [
                    {
                        tag: "animate",
                        attributes: {
                            ...OPACITY_ANIMATE,
                            values: "1;0;0;0;0;1;"
                        }
                    }
                ]
            });
            if (!reduceMotion) // Exclamation
            gChildren.push({
                tag: "path",
                attributes: {
                    ...FILL,
                    opacity: "0",
                    d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
                },
                children: [
                    {
                        tag: "animate",
                        attributes: {
                            ...OPACITY_ANIMATE,
                            values: "0;0;1;1;0;0;"
                        }
                    }
                ]
            });
            return {
                tag: "g",
                attributes: {
                    "class": "missing"
                },
                children: gChildren
            };
        };
    }
};
var $089d1397ac35d9f8$var$SvgSymbols = {
    hooks () {
        return {
            parseNodeAttributes (accumulator, node) {
                const symbolData = node.getAttribute("data-fa-symbol");
                const symbol = symbolData === null ? false : symbolData === "" ? true : symbolData;
                accumulator["symbol"] = symbol;
                return accumulator;
            }
        };
    }
};
var $089d1397ac35d9f8$var$plugins = [
    $089d1397ac35d9f8$var$InjectCSS,
    $089d1397ac35d9f8$var$ReplaceElements,
    $089d1397ac35d9f8$var$Layers,
    $089d1397ac35d9f8$var$LayersCounter,
    $089d1397ac35d9f8$var$LayersText,
    $089d1397ac35d9f8$var$PseudoElements,
    $089d1397ac35d9f8$var$MutationObserver$1,
    $089d1397ac35d9f8$var$PowerTransforms,
    $089d1397ac35d9f8$var$Masks,
    $089d1397ac35d9f8$var$MissingIconIndicator,
    $089d1397ac35d9f8$var$SvgSymbols
];
$089d1397ac35d9f8$var$registerPlugins($089d1397ac35d9f8$var$plugins, {
    mixoutsTo: $089d1397ac35d9f8$export$644d8ea042df96a6
});
const $089d1397ac35d9f8$export$4f8e844b2782642c = $089d1397ac35d9f8$export$644d8ea042df96a6.noAuto;
const $089d1397ac35d9f8$export$e506a1d27d1eaa20 = $089d1397ac35d9f8$export$644d8ea042df96a6.config;
const $089d1397ac35d9f8$export$b839f963c7dc0e34 = $089d1397ac35d9f8$export$644d8ea042df96a6.library;
const $089d1397ac35d9f8$export$df3a06d6289f983e = $089d1397ac35d9f8$export$644d8ea042df96a6.dom;
const $089d1397ac35d9f8$export$98e6a39c04603d36 = $089d1397ac35d9f8$export$644d8ea042df96a6.parse;
const $089d1397ac35d9f8$export$221fed4a47f597a5 = $089d1397ac35d9f8$export$644d8ea042df96a6.findIconDefinition;
const $089d1397ac35d9f8$export$a10125c086a4df16 = $089d1397ac35d9f8$export$644d8ea042df96a6.toHtml;
const $089d1397ac35d9f8$export$1ca1ec8b29a4ce27 = $089d1397ac35d9f8$export$644d8ea042df96a6.icon;
const $089d1397ac35d9f8$export$50a222d9023da98b = $089d1397ac35d9f8$export$644d8ea042df96a6.layer;
const $089d1397ac35d9f8$export$6f093cfa640b7166 = $089d1397ac35d9f8$export$644d8ea042df96a6.text;
const $089d1397ac35d9f8$export$e575061ef2a070eb = $089d1397ac35d9f8$export$644d8ea042df96a6.counter;

});


parcelRegister("gqtmM", function(module, exports) {

$parcel$export(module.exports, "faPlayCircle", function () { return $40b7be8cb53b06e9$export$cf04333781061c5e; });
$parcel$export(module.exports, "faPauseCircle", function () { return $40b7be8cb53b06e9$export$d8cf08a0362da8db; });
const $40b7be8cb53b06e9$export$82e9f45cca5ba907 = "far";
const $40b7be8cb53b06e9$export$864bb8d6c21fb792 = {
    prefix: "far",
    iconName: "trash-can",
    icon: [
        448,
        512,
        [
            61460,
            "trash-alt"
        ],
        "f2ed",
        "M170.5 51.6L151.5 80l145 0-19-28.4c-1.5-2.2-4-3.6-6.7-3.6l-93.7 0c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80 368 80l48 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 304c0 44.2-35.8 80-80 80l-224 0c-44.2 0-80-35.8-80-80l0-304-8 0c-13.3 0-24-10.7-24-24S10.7 80 24 80l8 0 48 0 13.8 0 36.7-55.1C140.9 9.4 158.4 0 177.1 0l93.7 0c18.7 0 36.2 9.4 46.6 24.9zM80 128l0 304c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-304L80 128zm80 64l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
const $40b7be8cb53b06e9$export$88df7ff7eb32f9dc = $40b7be8cb53b06e9$export$864bb8d6c21fb792;
const $40b7be8cb53b06e9$export$6563a67224e7f879 = {
    prefix: "far",
    iconName: "message",
    icon: [
        512,
        512,
        [
            "comment-alt"
        ],
        "f27a",
        "M160 368c26.5 0 48 21.5 48 48l0 16 72.5-54.4c8.3-6.2 18.4-9.6 28.8-9.6L448 368c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16L64 48c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l96 0zm48 124l-.2 .2-5.1 3.8-17.1 12.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-21.3 0-6.4 0-.3 0-4 0-48-48 0-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L208 492z"
    ]
};
const $40b7be8cb53b06e9$export$6e96904d9af0ec4a = $40b7be8cb53b06e9$export$6563a67224e7f879;
const $40b7be8cb53b06e9$export$ef565d07efe2b5e9 = {
    prefix: "far",
    iconName: "file-lines",
    icon: [
        384,
        512,
        [
            128441,
            128462,
            61686,
            "file-alt",
            "file-text"
        ],
        "f15c",
        "M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm56 256c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"
    ]
};
const $40b7be8cb53b06e9$export$243b47dca32bf0b8 = $40b7be8cb53b06e9$export$ef565d07efe2b5e9;
const $40b7be8cb53b06e9$export$f466100bf9bf37a5 = $40b7be8cb53b06e9$export$ef565d07efe2b5e9;
const $40b7be8cb53b06e9$export$31c6cf6f5d38dc0 = {
    prefix: "far",
    iconName: "calendar-days",
    icon: [
        448,
        512,
        [
            "calendar-alt"
        ],
        "f073",
        "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l80 0 0 56-80 0 0-56zm0 104l80 0 0 64-80 0 0-64zm128 0l96 0 0 64-96 0 0-64zm144 0l80 0 0 64-80 0 0-64zm80-48l-80 0 0-56 80 0 0 56zm0 160l0 40c0 8.8-7.2 16-16 16l-64 0 0-56 80 0zm-128 0l0 56-96 0 0-56 96 0zm-144 0l0 56-64 0c-8.8 0-16-7.2-16-16l0-40 80 0zM272 248l-96 0 0-56 96 0 0 56z"
    ]
};
const $40b7be8cb53b06e9$export$cbc139f33cff356 = $40b7be8cb53b06e9$export$31c6cf6f5d38dc0;
const $40b7be8cb53b06e9$export$f7bc8714c970afa4 = {
    prefix: "far",
    iconName: "hand-point-right",
    icon: [
        512,
        512,
        [],
        "f0a4",
        "M448 128l-177.6 0c1 5.2 1.6 10.5 1.6 16l0 16 32 0 144 0c8.8 0 16-7.2 16-16s-7.2-16-16-16zM224 144c0-17.7-14.3-32-32-32c0 0 0 0 0 0l-24 0c-66.3 0-120 53.7-120 120l0 48c0 52.5 33.7 97.1 80.7 113.4c-.5-3.1-.7-6.2-.7-9.4c0-20 9.2-37.9 23.6-49.7c-4.9-9-7.6-19.4-7.6-30.3c0-15.1 5.3-29 14-40c-8.8-11-14-24.9-14-40l0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40c0 8.8 7.2 16 16 16s16-7.2 16-16l0-40 0-40zM192 64s0 0 0 0c18 0 34.6 6 48 16l208 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-82 0c1.3 5.1 2 10.5 2 16c0 25.3-14.7 47.2-36 57.6c2.6 7 4 14.5 4 22.4c0 20-9.2 37.9-23.6 49.7c4.9 9 7.6 19.4 7.6 30.3c0 35.3-28.7 64-64 64l-64 0-24 0C75.2 448 0 372.8 0 280l0-48C0 139.2 75.2 64 168 64l24 0zm64 336c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0zm16-176c0 5.5-.7 10.9-2 16l2 0 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0 16zm-24 64l-40 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-24 0z"
    ]
};
const $40b7be8cb53b06e9$export$e3c56ed54f074063 = {
    prefix: "far",
    iconName: "face-smile-beam",
    icon: [
        512,
        512,
        [
            128522,
            "smile-beam"
        ],
        "f5b8",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zm40-89.3s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0zm160 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0z"
    ]
};
const $40b7be8cb53b06e9$export$54ada6dc9690e0ca = $40b7be8cb53b06e9$export$e3c56ed54f074063;
const $40b7be8cb53b06e9$export$1d1fbac384a76a12 = {
    prefix: "far",
    iconName: "face-grin-stars",
    icon: [
        512,
        512,
        [
            129321,
            "grin-stars"
        ],
        "f587",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM183.2 132.6c-1.3-2.8-4.1-4.6-7.2-4.6s-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L176 240.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L242.4 186c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7zm160 0c-1.3-2.8-4.1-4.6-7.2-4.6s-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L336 240.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L402.4 186c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7zm6.3 175.8c-28.9 6.8-60.5 10.5-93.6 10.5s-64.7-3.7-93.6-10.5c-18.7-4.4-35.9 12-25.5 28.1c24.6 38.1 68.7 63.5 119.1 63.5s94.5-25.4 119.1-63.5c10.4-16.1-6.8-32.5-25.5-28.1z"
    ]
};
const $40b7be8cb53b06e9$export$64347a5c8c402ef4 = $40b7be8cb53b06e9$export$1d1fbac384a76a12;
const $40b7be8cb53b06e9$export$853fd1561789e3bb = {
    prefix: "far",
    iconName: "address-book",
    icon: [
        512,
        512,
        [
            62138,
            "contact-book"
        ],
        "f2b9",
        "M384 48c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16L96 464c-8.8 0-16-7.2-16-16L80 64c0-8.8 7.2-16 16-16l288 0zM96 0C60.7 0 32 28.7 32 64l0 384c0 35.3 28.7 64 64 64l288 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L96 0zM240 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0zM512 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zM496 192c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16zm16 144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64z"
    ]
};
const $40b7be8cb53b06e9$export$594b5a5d4d2e156b = $40b7be8cb53b06e9$export$853fd1561789e3bb;
const $40b7be8cb53b06e9$export$932912e74adb8939 = {
    prefix: "far",
    iconName: "comments",
    icon: [
        640,
        512,
        [
            128490,
            61670
        ],
        "f086",
        "M88.2 309.1c9.8-18.3 6.8-40.8-7.5-55.8C59.4 230.9 48 204 48 176c0-63.5 63.8-128 160-128s160 64.5 160 128s-63.8 128-160 128c-13.1 0-25.8-1.3-37.8-3.6c-10.4-2-21.2-.6-30.7 4.2c-4.1 2.1-8.3 4.1-12.6 6c-16 7.2-32.9 13.5-49.9 18c2.8-4.6 5.4-9.1 7.9-13.6c1.1-1.9 2.2-3.9 3.2-5.9zM208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 41.8 17.2 80.1 45.9 110.3c-.9 1.7-1.9 3.5-2.8 5.1c-10.3 18.4-22.3 36.5-36.6 52.1c-6.6 7-8.3 17.2-4.6 25.9C5.8 378.3 14.4 384 24 384c43 0 86.5-13.3 122.7-29.7c4.8-2.2 9.6-4.5 14.2-6.8c15.1 3 30.9 4.5 47.1 4.5zM432 480c16.2 0 31.9-1.6 47.1-4.5c4.6 2.3 9.4 4.6 14.2 6.8C529.5 498.7 573 512 616 512c9.6 0 18.2-5.7 22-14.5c3.8-8.8 2-19-4.6-25.9c-14.2-15.6-26.2-33.7-36.6-52.1c-.9-1.7-1.9-3.4-2.8-5.1C622.8 384.1 640 345.8 640 304c0-94.4-87.9-171.5-198.2-175.8c4.1 15.2 6.2 31.2 6.2 47.8l0 .6c87.2 6.7 144 67.5 144 127.4c0 28-11.4 54.9-32.7 77.2c-14.3 15-17.3 37.6-7.5 55.8c1.1 2 2.2 4 3.2 5.9c2.5 4.5 5.2 9 7.9 13.6c-17-4.5-33.9-10.7-49.9-18c-4.3-1.9-8.5-3.9-12.6-6c-9.5-4.8-20.3-6.2-30.7-4.2c-12.1 2.4-24.8 3.6-37.8 3.6c-61.7 0-110-26.5-136.8-62.3c-16 5.4-32.8 9.4-50 11.8C279 439.8 350 480 432 480z"
    ]
};
const $40b7be8cb53b06e9$export$6f95f90dd1f6d86b = {
    prefix: "far",
    iconName: "paste",
    icon: [
        512,
        512,
        [
            "file-clipboard"
        ],
        "f0ea",
        "M104.6 48L64 48C28.7 48 0 76.7 0 112L0 384c0 35.3 28.7 64 64 64l96 0 0-48-96 0c-8.8 0-16-7.2-16-16l0-272c0-8.8 7.2-16 16-16l16 0c0 17.7 14.3 32 32 32l72.4 0C202 108.4 227.6 96 256 96l62 0c-7.1-27.6-32.2-48-62-48l-40.6 0C211.6 20.9 188.2 0 160 0s-51.6 20.9-55.4 48zM144 56a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM448 464l-192 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l140.1 0L464 243.9 464 448c0 8.8-7.2 16-16 16zM256 512l192 0c35.3 0 64-28.7 64-64l0-204.1c0-12.7-5.1-24.9-14.1-33.9l-67.9-67.9c-9-9-21.2-14.1-33.9-14.1L256 128c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64z"
    ]
};
const $40b7be8cb53b06e9$export$ca3229c47de163fa = $40b7be8cb53b06e9$export$6f95f90dd1f6d86b;
const $40b7be8cb53b06e9$export$8eee2c17ff89e724 = {
    prefix: "far",
    iconName: "face-grin-tongue-squint",
    icon: [
        512,
        512,
        [
            128541,
            "grin-tongue-squint"
        ],
        "f58a",
        "M464 256c0-114.9-93.1-208-208-208S48 141.1 48 256c0 81.7 47.1 152.4 115.7 186.4c-2.4-8.4-3.7-17.3-3.7-26.4l0-23.3c-24-17.5-43.1-41.4-54.8-69.2c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7c-11.8 28-31.1 52-55.4 69.6l0 22.9c0 9.2-1.3 18-3.7 26.4C416.9 408.4 464 337.7 464 256zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm116-98.9c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm262.5-10.5c7.9-4.2 17.5 1.5 17.5 10.5c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9zM320 416l0-37.4c0-14.7-11.9-26.6-26.6-26.6l-2 0c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9l-2 0c-14.7 0-26.6 11.9-26.6 26.6l0 37.4c0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
const $40b7be8cb53b06e9$export$4edf34c3def09a31 = $40b7be8cb53b06e9$export$8eee2c17ff89e724;
const $40b7be8cb53b06e9$export$ba5dc4287853ecbd = {
    prefix: "far",
    iconName: "face-flushed",
    icon: [
        512,
        512,
        [
            128563,
            "flushed"
        ],
        "f579",
        "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM160.4 248a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM192 336c-13.3 0-24 10.7-24 24s10.7 24 24 24l128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-128 0zM160 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm144-80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"
    ]
};
const $40b7be8cb53b06e9$export$dfd2bd012685aeac = $40b7be8cb53b06e9$export$ba5dc4287853ecbd;
const $40b7be8cb53b06e9$export$5b1d41cdd118ea6d = {
    prefix: "far",
    iconName: "square-caret-right",
    icon: [
        448,
        512,
        [
            "caret-square-right"
        ],
        "f152",
        "M400 96c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM320 256c0 6.7-2.8 13-7.7 17.6l-112 104c-7 6.5-17.2 8.2-25.9 4.4s-14.4-12.5-14.4-22l0-208c0-9.5 5.7-18.2 14.4-22s18.9-2.1 25.9 4.4l112 104c4.9 4.5 7.7 10.9 7.7 17.6z"
    ]
};
const $40b7be8cb53b06e9$export$ae86c9de7e0f62fa = $40b7be8cb53b06e9$export$5b1d41cdd118ea6d;
const $40b7be8cb53b06e9$export$814c9edba7b84aa4 = {
    prefix: "far",
    iconName: "square-minus",
    icon: [
        448,
        512,
        [
            61767,
            "minus-square"
        ],
        "f146",
        "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM152 232l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
const $40b7be8cb53b06e9$export$ffe9387966b3e681 = $40b7be8cb53b06e9$export$814c9edba7b84aa4;
const $40b7be8cb53b06e9$export$b4d344633433e50e = {
    prefix: "far",
    iconName: "compass",
    icon: [
        512,
        512,
        [
            129517
        ],
        "f14e",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm306.7 69.1L162.4 380.6c-19.4 7.5-38.5-11.6-31-31l55.5-144.3c3.3-8.5 9.9-15.1 18.4-18.4l144.3-55.5c19.4-7.5 38.5 11.6 31 31L325.1 306.7c-3.2 8.5-9.9 15.1-18.4 18.4zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
const $40b7be8cb53b06e9$export$a1ab39cd66c4e50e = {
    prefix: "far",
    iconName: "square-caret-down",
    icon: [
        448,
        512,
        [
            "caret-square-down"
        ],
        "f150",
        "M384 432c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0zm64-16c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320zM224 352c-6.7 0-13-2.8-17.6-7.7l-104-112c-6.5-7-8.2-17.2-4.4-25.9s12.5-14.4 22-14.4l208 0c9.5 0 18.2 5.7 22 14.4s2.1 18.9-4.4 25.9l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7z"
    ]
};
const $40b7be8cb53b06e9$export$61aea18df1c84401 = $40b7be8cb53b06e9$export$a1ab39cd66c4e50e;
const $40b7be8cb53b06e9$export$eca99665af566fe1 = {
    prefix: "far",
    iconName: "face-kiss-beam",
    icon: [
        512,
        512,
        [
            128537,
            "kiss-beam"
        ],
        "f597",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm304.7 41.7c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 427.1 257.4 432 240 432c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zm-87.1-68.9s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0zm160 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0z"
    ]
};
const $40b7be8cb53b06e9$export$d6ff8a73c0812e63 = $40b7be8cb53b06e9$export$eca99665af566fe1;
const $40b7be8cb53b06e9$export$1e80f89fe84a215b = {
    prefix: "far",
    iconName: "lightbulb",
    icon: [
        384,
        512,
        [
            128161
        ],
        "f0eb",
        "M297.2 248.9C311.6 228.3 320 203.2 320 176c0-70.7-57.3-128-128-128S64 105.3 64 176c0 27.2 8.4 52.3 22.8 72.9c3.7 5.3 8.1 11.3 12.8 17.7c0 0 0 0 0 0c12.9 17.7 28.3 38.9 39.8 59.8c10.4 19 15.7 38.8 18.3 57.5L109 384c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8c0 0 0 0 0 0s0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4c0 0 0 0 0 0s0 0 0 0c-12.3 16.8-24.6 33.7-34.5 51.8c-5.9 10.8-9.6 22.5-11.8 34.5l-48.6 0c2.6-18.7 7.9-38.6 18.3-57.5c11.5-20.9 26.9-42.1 39.8-59.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0c4.7-6.4 9-12.4 12.7-17.7zM192 128c-26.5 0-48 21.5-48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16zm0 384c-44.2 0-80-35.8-80-80l0-16 160 0 0 16c0 44.2-35.8 80-80 80z"
    ]
};
const $40b7be8cb53b06e9$export$6591b1ea509be9da = {
    prefix: "far",
    iconName: "flag",
    icon: [
        448,
        512,
        [
            127988,
            61725
        ],
        "f024",
        "M48 24C48 10.7 37.3 0 24 0S0 10.7 0 24L0 64 0 350.5 0 400l0 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-100 80.3-20.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30l0-279.7c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L48 52l0-28zm0 77.5l96.6-24.2c27-6.7 55.5-3.6 80.4 8.8c54.9 27.4 118.7 29.7 175 6.8l0 241.8-24.4 9.1c-33.7 12.6-71.2 10.7-103.4-5.4c-48.2-24.1-103.3-30.1-155.6-17.1L48 338.5l0-237z"
    ]
};
const $40b7be8cb53b06e9$export$5bb6a0c94ad2f4bb = {
    prefix: "far",
    iconName: "square-check",
    icon: [
        448,
        512,
        [
            9745,
            9989,
            61510,
            "check-square"
        ],
        "f14a",
        "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
const $40b7be8cb53b06e9$export$f0c8040f596df7fe = $40b7be8cb53b06e9$export$5bb6a0c94ad2f4bb;
const $40b7be8cb53b06e9$export$aa13d9234890e8d3 = {
    prefix: "far",
    iconName: "circle-dot",
    icon: [
        512,
        512,
        [
            128280,
            "dot-circle"
        ],
        "f192",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
    ]
};
const $40b7be8cb53b06e9$export$92bc269cb244d66a = $40b7be8cb53b06e9$export$aa13d9234890e8d3;
const $40b7be8cb53b06e9$export$635e4d8cc8428961 = {
    prefix: "far",
    iconName: "face-dizzy",
    icon: [
        512,
        512,
        [
            "dizzy"
        ],
        "f567",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM103 135c9.4-9.4 24.6-9.4 33.9 0l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9zm192 0c9.4-9.4 24.6-9.4 33.9 0l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
const $40b7be8cb53b06e9$export$89a2b10dabc487e8 = $40b7be8cb53b06e9$export$635e4d8cc8428961;
const $40b7be8cb53b06e9$export$65a345b33858a655 = {
    prefix: "far",
    iconName: "futbol",
    icon: [
        512,
        512,
        [
            9917,
            "futbol-ball",
            "soccer-ball"
        ],
        "f1e3",
        "M435.4 361.4l-89.7-6c-5.2-.3-10.3 1.1-14.5 4.2s-7.2 7.4-8.4 12.5l-22 87.2c-14.4 3.2-29.4 4.8-44.8 4.8s-30.3-1.7-44.8-4.8l-22-87.2c-1.3-5-4.3-9.4-8.4-12.5s-9.3-4.5-14.5-4.2l-89.7 6C61.7 335.9 51.9 307 49 276.2L125 228.3c4.4-2.8 7.6-7 9.2-11.9s1.4-10.2-.5-15L100.4 118c19.9-22.4 44.6-40.5 72.4-52.7l69.1 57.6c4 3.3 9 5.1 14.1 5.1s10.2-1.8 14.1-5.1l69.1-57.6c27.8 12.2 52.5 30.3 72.4 52.7l-33.4 83.4c-1.9 4.8-2.1 10.1-.5 15s4.9 9.1 9.2 11.9L463 276.2c-3 30.8-12.7 59.7-27.6 85.2zM256 48l.9 0-1.8 0 .9 0zM56.7 196.2c.9-3 1.9-6.1 2.9-9.1l-2.9 9.1zM132 423l3.8 2.7c-1.3-.9-2.5-1.8-3.8-2.7zm248.1-.1c-1.3 1-2.6 2-4 2.9l4-2.9zm75.2-226.7l-3-9.2c1.1 3 2.1 6.1 3 9.2zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm14.1-325.7c-8.4-6.1-19.8-6.1-28.2 0L194 221c-8.4 6.1-11.9 16.9-8.7 26.8l18.3 56.3c3.2 9.9 12.4 16.6 22.8 16.6l59.2 0c10.4 0 19.6-6.7 22.8-16.6l18.3-56.3c3.2-9.9-.3-20.7-8.7-26.8l-47.9-34.8z"
    ]
};
const $40b7be8cb53b06e9$export$51a344ca0a215620 = $40b7be8cb53b06e9$export$65a345b33858a655;
const $40b7be8cb53b06e9$export$f4a29712c724ba2d = $40b7be8cb53b06e9$export$65a345b33858a655;
const $40b7be8cb53b06e9$export$ba236543926e3569 = {
    prefix: "far",
    iconName: "pen-to-square",
    icon: [
        512,
        512,
        [
            "edit"
        ],
        "f044",
        "M441 58.9L453.1 71c9.4 9.4 9.4 24.6 0 33.9L424 134.1 377.9 88 407 58.9c9.4-9.4 24.6-9.4 33.9 0zM209.8 256.2L344 121.9 390.1 168 255.8 302.2c-2.9 2.9-6.5 5-10.4 6.1l-58.5 16.7 16.7-58.5c1.1-3.9 3.2-7.5 6.1-10.4zM373.1 25L175.8 222.2c-8.7 8.7-15 19.4-18.3 31.1l-28.6 100c-2.4 8.4-.1 17.4 6.1 23.6s15.2 8.5 23.6 6.1l100-28.6c11.8-3.4 22.5-9.7 31.1-18.3L487 138.9c28.1-28.1 28.1-73.7 0-101.8L474.9 25C446.8-3.1 401.2-3.1 373.1 25zM88 64C39.4 64 0 103.4 0 152L0 424c0 48.6 39.4 88 88 88l272 0c48.6 0 88-39.4 88-88l0-112c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 22.1-17.9 40-40 40L88 464c-22.1 0-40-17.9-40-40l0-272c0-22.1 17.9-40 40-40l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 64z"
    ]
};
const $40b7be8cb53b06e9$export$7be713e57d023733 = $40b7be8cb53b06e9$export$ba236543926e3569;
const $40b7be8cb53b06e9$export$703272eebf5e3eea = {
    prefix: "far",
    iconName: "hourglass-half",
    icon: [
        384,
        512,
        [
            "hourglass-2"
        ],
        "f252",
        "M0 24C0 10.7 10.7 0 24 0L360 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 19c0 40.3-16 79-44.5 107.5L225.9 256l81.5 81.5C336 366 352 404.7 352 445l0 19 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 0-19c0-40.3 16-79 44.5-107.5L158.1 256 76.5 174.5C48 146 32 107.3 32 67l0-19-8 0C10.7 48 0 37.3 0 24zM110.5 371.5c-3.9 3.9-7.5 8.1-10.7 12.5l184.4 0c-3.2-4.4-6.8-8.6-10.7-12.5L192 289.9l-81.5 81.5zM284.2 128C297 110.4 304 89 304 67l0-19L80 48l0 19c0 22.1 7 43.4 19.8 61l184.4 0z"
    ]
};
const $40b7be8cb53b06e9$export$f1052bbf6bf361c0 = $40b7be8cb53b06e9$export$703272eebf5e3eea;
const $40b7be8cb53b06e9$export$ed3f2918429d029a = {
    prefix: "far",
    iconName: "eye-slash",
    icon: [
        640,
        512,
        [],
        "f070",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zM394.9 284.2l-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3c0-5.5-.7-10.9-2-16c.7 0 1.3 0 2 0c44.2 0 80 35.8 80 80c0 9.9-1.8 19.4-5.1 28.2zm9.4 130.3C378.8 425.4 350.7 432 320 432c-65.2 0-118.8-29.6-159.9-67.7C121.6 328.5 95 286 81.4 256c8.3-18.4 21.5-41.5 39.4-64.8L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5l-41.9-33zM192 256c0 70.7 57.3 128 128 128c13.3 0 26.1-2 38.2-5.8L302 334c-23.5-5.4-43.1-21.2-53.7-42.3l-56.1-44.2c-.2 2.8-.3 5.6-.3 8.5z"
    ]
};
const $40b7be8cb53b06e9$export$f69db0b876f7d753 = {
    prefix: "far",
    iconName: "hand",
    icon: [
        512,
        512,
        [
            129306,
            9995,
            "hand-paper"
        ],
        "f256",
        "M256 0c-25.3 0-47.2 14.7-57.6 36c-7-2.6-14.5-4-22.4-4c-35.3 0-64 28.7-64 64l0 165.5-2.7-2.7c-25-25-65.5-25-90.5 0s-25 65.5 0 90.5L106.5 437c48 48 113.1 75 181 75l8.5 0 8 0c1.5 0 3-.1 4.5-.4c91.7-6.2 165-79.4 171.1-171.1c.3-1.5 .4-3 .4-4.5l0-176c0-35.3-28.7-64-64-64c-5.5 0-10.9 .7-16 2l0-2c0-35.3-28.7-64-64-64c-7.9 0-15.4 1.4-22.4 4C303.2 14.7 281.3 0 256 0zM240 96.1l0-.1 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 31.9 0 .1 0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136c0 0 0 0 0-.1c0-8.8 7.2-16 16-16s16 7.2 16 16l0 55.9c0 0 0 .1 0 .1l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-71.9c0 0 0-.1 0-.1c0-8.8 7.2-16 16-16s16 7.2 16 16l0 172.9c-.1 .6-.1 1.3-.2 1.9c-3.4 69.7-59.3 125.6-129 129c-.6 0-1.3 .1-1.9 .2l-4.9 0-8.5 0c-55.2 0-108.1-21.9-147.1-60.9L52.7 315.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L119 336.4c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2L160 96c0-8.8 7.2-16 16-16c8.8 0 16 7.1 16 15.9L192 232c0 13.3 10.7 24 24 24s24-10.7 24-24l0-135.9z"
    ]
};
const $40b7be8cb53b06e9$export$6e6216c8b50471bb = $40b7be8cb53b06e9$export$f69db0b876f7d753;
const $40b7be8cb53b06e9$export$2262d6b626de1120 = {
    prefix: "far",
    iconName: "hand-spock",
    icon: [
        576,
        512,
        [
            128406
        ],
        "f259",
        "M170.2 80.8C161 47 180.8 12 214.6 2.4c34-9.6 69.4 10.2 79 44.2l30.3 107.1L337.1 84c6.6-34.7 40.1-57.5 74.8-50.9c31.4 6 53 33.9 52 64.9c10-2.6 20.8-2.8 31.5-.1c34.3 8.6 55.1 43.3 46.6 77.6L486.7 397.2C469.8 464.7 409.2 512 339.6 512l-33.7 0c-56.9 0-112.2-19-157.2-53.9l-92-71.6c-27.9-21.7-32.9-61.9-11.2-89.8s61.9-32.9 89.8-11.2l17 13.2L100.5 167.5c-13-32.9 3.2-70.1 36-83c11.1-4.4 22.7-5.4 33.7-3.7zm77.1-21.2c-2.4-8.5-11.2-13.4-19.7-11s-13.4 11.2-11 19.7l54.8 182.4c3.5 12.3-3.3 25.2-15.4 29.3s-25.3-2-30-13.9L174.9 138.1c-3.2-8.2-12.5-12.3-20.8-9s-12.3 12.5-9 20.8l73.3 185.6c12 30.3-23.7 57-49.4 37l-63.1-49.1c-7-5.4-17-4.2-22.5 2.8s-4.2 17 2.8 22.5l92 71.6c36.5 28.4 81.4 43.8 127.7 43.8l33.7 0c47.5 0 89-32.4 100.5-78.5l55.4-221.6c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6l-26 104C435.6 271.8 425 280 413 280c-16.5 0-28.9-15-25.8-31.2L415.7 99c1.7-8.7-4-17.1-12.7-18.7s-17.1 4-18.7 12.7L352.5 260c-2.2 11.6-12.4 20-24.2 20c-11 0-20.7-7.3-23.7-17.9L247.4 59.6z"
    ]
};
const $40b7be8cb53b06e9$export$5a54c83033a0a56a = {
    prefix: "far",
    iconName: "face-kiss",
    icon: [
        512,
        512,
        [
            128535,
            "kiss"
        ],
        "f596",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm304.7 25.7c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 411.1 257.4 416 240 416c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.8-.5-.1-.1-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $40b7be8cb53b06e9$export$c762a77aabf64fd0 = $40b7be8cb53b06e9$export$5a54c83033a0a56a;
const $40b7be8cb53b06e9$export$95a7394c24f57943 = {
    prefix: "far",
    iconName: "face-grin-tongue",
    icon: [
        512,
        512,
        [
            128539,
            "grin-tongue"
        ],
        "f589",
        "M464 256c0-114.9-93.1-208-208-208S48 141.1 48 256c0 81.7 47.1 152.4 115.7 186.4c-2.4-8.4-3.7-17.3-3.7-26.4l0-52.4c-8.9-8-16.7-17.1-23.1-27.1c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5c18.7-4.4 35.9 12 25.5 28.1c-6.4 9.9-14.2 19-23 27l0 52.5c0 9.2-1.3 18-3.7 26.4C416.9 408.4 464 337.7 464 256zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 416l0-37.4c0-14.7-11.9-26.6-26.6-26.6l-2 0c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9l-2 0c-14.7 0-26.6 11.9-26.6 26.6l0 37.4c0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
const $40b7be8cb53b06e9$export$ef222816a43a4b3a = $40b7be8cb53b06e9$export$95a7394c24f57943;
const $40b7be8cb53b06e9$export$a831eedd2f59c62f = {
    prefix: "far",
    iconName: "chess-bishop",
    icon: [
        320,
        512,
        [
            9821
        ],
        "f43a",
        "M104 0C90.7 0 80 10.7 80 24c0 11.2 7.6 20.6 18 23.2c-7.8 8-16.1 17-24.4 27C38.2 116.7 0 178.8 0 250.9c0 44.8 24.6 72.2 48 87.8L48 352l48 0 0-27c0-9-5-17.2-13-21.3c-18-9.3-35-24.7-35-52.7c0-55.5 29.8-106.8 62.4-145.9c16-19.2 32.1-34.8 44.2-45.5c1.9-1.7 3.7-3.2 5.3-4.6c1.7 1.4 3.4 3 5.3 4.6c12.1 10.7 28.2 26.3 44.2 45.5c5.3 6.3 10.5 13 15.5 20L159 191c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57.8-57.8c12.8 25.9 21.2 54.3 21.2 83.8c0 28-17 43.4-35 52.7c-8 4.1-13 12.3-13 21.3l0 27 48 0 0-13.3c23.4-15.6 48-42.9 48-87.8c0-72.1-38.2-134.2-73.6-176.7c-8.3-9.9-16.6-19-24.4-27c10.3-2.7 18-12.1 18-23.2c0-13.3-10.7-24-24-24L160 0 104 0zM52.7 464l16.6-32 181.6 0 16.6 32L52.7 464zm207.9-80l-201 0c-12 0-22.9 6.7-28.4 17.3L4.6 452.5c-3 5.8-4.6 12.2-4.6 18.7C0 493.8 18.2 512 40.8 512l238.5 0c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2c-5.5-10.6-16.5-17.3-28.4-17.3z"
    ]
};
const $40b7be8cb53b06e9$export$1dd161850c5bc64e = {
    prefix: "far",
    iconName: "face-grin-wink",
    icon: [
        512,
        512,
        [
            "grin-wink"
        ],
        "f58c",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm165.8 21.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z"
    ]
};
const $40b7be8cb53b06e9$export$2397fcd34eb12177 = $40b7be8cb53b06e9$export$1dd161850c5bc64e;
const $40b7be8cb53b06e9$export$bdbabf493c478cde = {
    prefix: "far",
    iconName: "face-grin-wide",
    icon: [
        512,
        512,
        [
            128515,
            "grin-alt"
        ],
        "f581",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM224 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64zm96 64c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64z"
    ]
};
const $40b7be8cb53b06e9$export$b4abebfe416d36ba = $40b7be8cb53b06e9$export$bdbabf493c478cde;
const $40b7be8cb53b06e9$export$c8a28356e07b9ccb = {
    prefix: "far",
    iconName: "face-frown-open",
    icon: [
        512,
        512,
        [
            128550,
            "frown-open"
        ],
        "f57a",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM182.4 382.5c-12.4 5.2-26.5-4.1-21.1-16.4c16-36.6 52.4-62.1 94.8-62.1s78.8 25.6 94.8 62.1c5.4 12.3-8.7 21.6-21.1 16.4c-22.4-9.5-47.4-14.8-73.7-14.8s-51.3 5.3-73.7 14.8zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $40b7be8cb53b06e9$export$c4775e66bed5d96 = $40b7be8cb53b06e9$export$c8a28356e07b9ccb;
const $40b7be8cb53b06e9$export$cdc9f5e7e94e76da = {
    prefix: "far",
    iconName: "hand-point-up",
    icon: [
        384,
        512,
        [
            9757
        ],
        "f0a6",
        "M64 64l0 177.6c5.2-1 10.5-1.6 16-1.6l16 0 0-32L96 64c0-8.8-7.2-16-16-16s-16 7.2-16 16zM80 288c-17.7 0-32 14.3-32 32c0 0 0 0 0 0l0 24c0 66.3 53.7 120 120 120l48 0c52.5 0 97.1-33.7 113.4-80.7c-3.1 .5-6.2 .7-9.4 .7c-20 0-37.9-9.2-49.7-23.6c-9 4.9-19.4 7.6-30.3 7.6c-15.1 0-29-5.3-40-14c-11 8.8-24.9 14-40 14l-40 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-40 0-40 0zM0 320s0 0 0 0c0-18 6-34.6 16-48L16 64C16 28.7 44.7 0 80 0s64 28.7 64 64l0 82c5.1-1.3 10.5-2 16-2c25.3 0 47.2 14.7 57.6 36c7-2.6 14.5-4 22.4-4c20 0 37.9 9.2 49.7 23.6c9-4.9 19.4-7.6 30.3-7.6c35.3 0 64 28.7 64 64l0 64 0 24c0 92.8-75.2 168-168 168l-48 0C75.2 512 0 436.8 0 344l0-24zm336-64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zM160 240c5.5 0 10.9 .7 16 2l0-2 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32 16 0zm64 24l0 40c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 24z"
    ]
};
const $40b7be8cb53b06e9$export$4ed9da5c3cca0ef1 = {
    prefix: "far",
    iconName: "bookmark",
    icon: [
        384,
        512,
        [
            128278,
            61591
        ],
        "f02e",
        "M0 48C0 21.5 21.5 0 48 0l0 48 0 393.4 130.1-92.9c8.3-6 19.6-6 27.9 0L336 441.4 336 48 48 48 48 0 336 0c26.5 0 48 21.5 48 48l0 440c0 9-5 17.2-13 21.3s-17.6 3.4-24.9-1.8L192 397.5 37.9 507.5c-7.3 5.2-16.9 5.9-24.9 1.8S0 497 0 488L0 48z"
    ]
};
const $40b7be8cb53b06e9$export$f6dcbf0a940428f4 = {
    prefix: "far",
    iconName: "hand-point-down",
    icon: [
        384,
        512,
        [],
        "f0a7",
        "M64 448l0-177.6c5.2 1 10.5 1.6 16 1.6l16 0 0 32 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16zM80 224c-17.7 0-32-14.3-32-32c0 0 0 0 0 0l0-24c0-66.3 53.7-120 120-120l48 0c52.5 0 97.1 33.7 113.4 80.7c-3.1-.5-6.2-.7-9.4-.7c-20 0-37.9 9.2-49.7 23.6c-9-4.9-19.4-7.6-30.3-7.6c-15.1 0-29 5.3-40 14c-11-8.8-24.9-14-40-14l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-40 0-40 0zM0 192s0 0 0 0c0 18 6 34.6 16 48l0 208c0 35.3 28.7 64 64 64s64-28.7 64-64l0-82c5.1 1.3 10.5 2 16 2c25.3 0 47.2-14.7 57.6-36c7 2.6 14.5 4 22.4 4c20 0 37.9-9.2 49.7-23.6c9 4.9 19.4 7.6 30.3 7.6c35.3 0 64-28.7 64-64l0-64 0-24C384 75.2 308.8 0 216 0L168 0C75.2 0 0 75.2 0 168l0 24zm336 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64zM160 272c5.5 0 10.9-.7 16-2l0 2 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32 16 0zm64-24l0-40c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-24z"
    ]
};
const $40b7be8cb53b06e9$export$72b780186370e953 = {
    prefix: "far",
    iconName: "folder",
    icon: [
        512,
        512,
        [
            128193,
            128447,
            61716,
            "folder-blank"
        ],
        "f07b",
        "M0 96C0 60.7 28.7 32 64 32l132.1 0c19.1 0 37.4 7.6 50.9 21.1L289.9 96 448 96c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16l-161.4 0c-10.6 0-20.8-4.2-28.3-11.7L213.1 87c-4.5-4.5-10.6-7-17-7L64 80z"
    ]
};
const $40b7be8cb53b06e9$export$9ef114244d26da0 = $40b7be8cb53b06e9$export$72b780186370e953;
const $40b7be8cb53b06e9$export$f5699fa0844e0188 = {
    prefix: "far",
    iconName: "user",
    icon: [
        448,
        512,
        [
            128100,
            62144
        ],
        "f007",
        "M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464l349.5 0c-8.9-63.3-63.3-112-129-112l-91.4 0c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3z"
    ]
};
const $40b7be8cb53b06e9$export$2c5163541229363 = {
    prefix: "far",
    iconName: "square-caret-left",
    icon: [
        448,
        512,
        [
            "caret-square-left"
        ],
        "f191",
        "M48 416c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320zm16 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zm64-224c0-6.7 2.8-13 7.7-17.6l112-104c7-6.5 17.2-8.2 25.9-4.4s14.4 12.5 14.4 22l0 208c0 9.5-5.7 18.2-14.4 22s-18.9 2.1-25.9-4.4l-112-104c-4.9-4.5-7.7-10.9-7.7-17.6z"
    ]
};
const $40b7be8cb53b06e9$export$d0c8ba444f1f9581 = $40b7be8cb53b06e9$export$2c5163541229363;
const $40b7be8cb53b06e9$export$a3b0eb2cd7942125 = {
    prefix: "far",
    iconName: "star",
    icon: [
        576,
        512,
        [
            11088,
            61446
        ],
        "f005",
        "M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0zm0 79L235.4 187.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2L384.2 324.1c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1L358.6 200.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z"
    ]
};
const $40b7be8cb53b06e9$export$861b1f13085cf122 = {
    prefix: "far",
    iconName: "chess-knight",
    icon: [
        448,
        512,
        [
            9822
        ],
        "f441",
        "M226.6 48L117.3 48l17.1 12.8c6 4.5 9.6 11.6 9.6 19.2s-3.6 14.7-9.6 19.2l-6.5 4.9c-10 7.5-16 19.3-16 31.9l-.3 91c0 10.2 4.9 19.9 13.2 25.8l1.9 1.3c9.9 7.1 23.3 7 33.2-.1l49.9-36.3c10.7-7.8 25.7-5.4 33.5 5.3s5.4 25.7-5.3 33.5l-49.9 36.3-53.8 39.1c-7.3 5.3-13 12.2-16.9 20.1l-50.7 0c5.3-22.1 17.8-41.9 35.9-56.3c-1.3-.8-2.6-1.7-3.8-2.6L97 291.8c-21-15-33.4-39.2-33.3-65l.3-91c.1-19.8 6.7-38.7 18.6-53.9l-.4-.3C70.7 73 64 59.6 64 45.3C64 20.3 84.3 0 109.3 0L226.6 0C331.2 0 416 84.8 416 189.4c0 11.1-1 22.2-2.9 33.2L390.1 352l-48.8 0 24.5-137.8c1.5-8.2 2.2-16.5 2.2-24.8C368 111.3 304.7 48 226.6 48zM85.2 432L68.7 464l310.7 0-16.6-32L85.2 432zm315.7-30.7l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8L56.8 512C34.2 512 16 493.8 16 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C52.5 390.7 63.5 384 75.5 384l297 0c12 0 22.9 6.7 28.4 17.3zM172 128a20 20 0 1 1 0 40 20 20 0 1 1 0-40z"
    ]
};
const $40b7be8cb53b06e9$export$67ca89c1ca38d559 = {
    prefix: "far",
    iconName: "face-laugh-squint",
    icon: [
        512,
        512,
        [
            "laugh-squint"
        ],
        "f59b",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9l212.5 0c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zm2.8-183.3l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 141.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
    ]
};
const $40b7be8cb53b06e9$export$b206e700cf7084e1 = $40b7be8cb53b06e9$export$67ca89c1ca38d559;
const $40b7be8cb53b06e9$export$2f203616c892d415 = {
    prefix: "far",
    iconName: "face-laugh",
    icon: [
        512,
        512,
        [
            "laugh"
        ],
        "f599",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9l212.5 0c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $40b7be8cb53b06e9$export$6c74e314e801a4fe = $40b7be8cb53b06e9$export$2f203616c892d415;
const $40b7be8cb53b06e9$export$ff7e93418af88b78 = {
    prefix: "far",
    iconName: "folder-open",
    icon: [
        576,
        512,
        [
            128194,
            128449,
            61717
        ],
        "f07c",
        "M384 480l48 0c11.4 0 21.9-6 27.6-15.9l112-192c5.8-9.9 5.8-22.1 .1-32.1S555.5 224 544 224l-400 0c-11.4 0-21.9 6-27.6 15.9L48 357.1 48 96c0-8.8 7.2-16 16-16l117.5 0c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c21 21 49.5 32.8 79.2 32.8L416 144c8.8 0 16 7.2 16 16l0 32 48 0 0-32c0-35.3-28.7-64-64-64L298.5 96c-17 0-33.3-6.7-45.3-18.7L226.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l23.7 0L384 480z"
    ]
};
const $40b7be8cb53b06e9$export$97d84347d71ba297 = {
    prefix: "far",
    iconName: "clipboard",
    icon: [
        384,
        512,
        [
            128203
        ],
        "f328",
        "M280 64l40 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64l40 0 9.6 0C121 27.5 153.3 0 192 0s71 27.5 78.4 64l9.6 0zM64 112c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16l-16 0 0 24c0 13.3-10.7 24-24 24l-88 0-88 0c-13.3 0-24-10.7-24-24l0-24-16 0zm128-8a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
const $40b7be8cb53b06e9$export$7b8ce73615739d30 = {
    prefix: "far",
    iconName: "chess-queen",
    icon: [
        512,
        512,
        [
            9819
        ],
        "f445",
        "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-95.2-8c-18.1 0-31.3 12.8-35.6 26.9c-8 26.2-32.4 45.2-61.2 45.2c-10 0-19.4-2.3-27.7-6.3c-7.6-3.7-16.7-3.3-24 1.2C.7 162.1-3.1 177.1 3.7 188.9L97.6 352l55.4 0-83-144.1c40.5-2.2 75.3-25.9 93.1-59.8c22 26.8 55.4 43.9 92.8 43.9s70.8-17.1 92.8-43.9c17.8 34 52.6 57.7 93.1 59.8L359 352l55.4 0 93.9-163.1c6.8-11.7 3-26.7-8.6-33.8c-7.3-4.5-16.4-4.9-24-1.2c-8.4 4-17.7 6.3-27.7 6.3c-28.8 0-53.2-19-61.2-45.2C382.5 100.8 369.3 88 351.2 88c-14.5 0-26.3 8.5-32.4 19.3c-12.4 22-35.9 36.7-62.8 36.7s-50.4-14.8-62.8-36.7C187.1 96.5 175.4 88 160.8 88zM133.2 432l245.6 0 16.6 32-278.7 0 16.6-32zm283.7-30.7c-5.5-10.6-16.5-17.3-28.4-17.3l-265 0c-12 0-22.9 6.7-28.4 17.3L68.6 452.5c-3 5.8-4.6 12.2-4.6 18.7c0 22.5 18.2 40.8 40.8 40.8l302.5 0c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2z"
    ]
};
const $40b7be8cb53b06e9$export$be38a892fe9b4098 = {
    prefix: "far",
    iconName: "hand-back-fist",
    icon: [
        448,
        512,
        [
            "hand-rock"
        ],
        "f255",
        "M144 64c0-8.8 7.2-16 16-16s16 7.2 16 16c0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2c8.8 0 16 7.2 16 16c0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2c8.8 0 16 7.2 16 16c0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2c8.8 0 16 7.2 16 16l0 104c0 31.3-20 58-48 67.9c-9.6 3.4-16 12.5-16 22.6L304 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-117.8c38-20.1 64-60.1 64-106.2l0-104c0-35.3-28.7-64-64-64c-2.8 0-5.6 .2-8.3 .5C332.8 77.1 311.9 64 288 64c-2.8 0-5.6 .2-8.3 .5C268.8 45.1 247.9 32 224 32c-2.8 0-5.6 .2-8.3 .5C204.8 13.1 183.9 0 160 0C124.7 0 96 28.7 96 64l0 64.3c-11.7 7.4-22.5 16.4-32 26.9l17.8 16.1L64 155.2l-9.4 10.5C40 181.8 32 202.8 32 224.6l0 12.8c0 49.6 24.2 96.1 64.8 124.5l13.8-19.7L96.8 361.9l8.9 6.2c6.9 4.8 14.4 8.6 22.3 11.3L128 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-128.1c0-12.6-9.8-23.1-22.4-23.9c-7.3-.5-14.3-2.9-20.3-7.1l-13.1 18.7 13.1-18.7-8.9-6.2C96.6 303.1 80 271.3 80 237.4l0-12.8c0-9.9 3.7-19.4 10.3-26.8l9.4-10.5c3.8-4.2 7.9-8.1 12.3-11.6l0 32.3c0 8.8 7.2 16 16 16s16-7.2 16-16l0-65.7 0-14.3 0-64z"
    ]
};
const $40b7be8cb53b06e9$export$97a81eba394c8c44 = $40b7be8cb53b06e9$export$be38a892fe9b4098;
const $40b7be8cb53b06e9$export$66068918abb14406 = {
    prefix: "far",
    iconName: "square-caret-up",
    icon: [
        448,
        512,
        [
            "caret-square-up"
        ],
        "f151",
        "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm224 64c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9s-12.5 14.4-22 14.4l-208 0c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112c4.5-4.9 10.9-7.7 17.6-7.7z"
    ]
};
const $40b7be8cb53b06e9$export$307ae80b26533ce5 = $40b7be8cb53b06e9$export$66068918abb14406;
const $40b7be8cb53b06e9$export$b532f5d25de97633 = {
    prefix: "far",
    iconName: "chart-bar",
    icon: [
        512,
        512,
        [
            "bar-chart"
        ],
        "f080",
        "M24 32c13.3 0 24 10.7 24 24l0 352c0 13.3 10.7 24 24 24l416 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L72 480c-39.8 0-72-32.2-72-72L0 56C0 42.7 10.7 32 24 32zM128 136c0-13.3 10.7-24 24-24l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24zm24 72l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96l272 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-272 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
const $40b7be8cb53b06e9$export$2d5f754a5e5738b = $40b7be8cb53b06e9$export$b532f5d25de97633;
const $40b7be8cb53b06e9$export$eccfff9bfd585652 = {
    prefix: "far",
    iconName: "window-restore",
    icon: [
        512,
        512,
        [],
        "f2d2",
        "M432 48L208 48c-17.7 0-32 14.3-32 32l0 16-48 0 0-16c0-44.2 35.8-80 80-80L432 0c44.2 0 80 35.8 80 80l0 224c0 44.2-35.8 80-80 80l-16 0 0-48 16 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32zM48 448c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-192L48 256l0 192zM64 128l256 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192c0-35.3 28.7-64 64-64z"
    ]
};
const $40b7be8cb53b06e9$export$eaf727acca5a35e4 = {
    prefix: "far",
    iconName: "square-plus",
    icon: [
        448,
        512,
        [
            61846,
            "plus-square"
        ],
        "f0fe",
        "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM200 344l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
    ]
};
const $40b7be8cb53b06e9$export$b6359eebfe900c35 = $40b7be8cb53b06e9$export$eaf727acca5a35e4;
const $40b7be8cb53b06e9$export$7e9f0928967e03b = {
    prefix: "far",
    iconName: "image",
    icon: [
        512,
        512,
        [],
        "f03e",
        "M448 80c8.8 0 16 7.2 16 16l0 319.8-5-6.5-136-176c-4.5-5.9-11.6-9.3-19-9.3s-14.4 3.4-19 9.3L202 340.7l-30.5-42.7C167 291.7 159.8 288 152 288s-15 3.7-19.5 10.1l-80 112L48 416.3l0-.3L48 96c0-8.8 7.2-16 16-16l384 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm80 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
const $40b7be8cb53b06e9$export$5e30548b7f8eeb95 = {
    prefix: "far",
    iconName: "folder-closed",
    icon: [
        512,
        512,
        [],
        "e185",
        "M251.7 127.6s0 0 0 0c10.5 10.5 24.7 16.4 39.6 16.4L448 144c8.8 0 16 7.2 16 16l0 32L48 192l0-96c0-8.8 7.2-16 16-16l133.5 0c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zM48 240l416 0 0 176c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-176zM285.7 93.7L242.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.3 96c-2.1 0-4.2-.8-5.7-2.3z"
    ]
};
const $40b7be8cb53b06e9$export$4fbda8f64648f3b5 = {
    prefix: "far",
    iconName: "lemon",
    icon: [
        448,
        512,
        [
            127819
        ],
        "f094",
        "M368 80c-3.2 0-6.2 .4-8.9 1.3C340 86.8 313 91.9 284.8 84.6C227.4 69.7 160.2 92 110.1 142.1S37.7 259.4 52.6 316.8c7.3 28.2 2.2 55.2-3.3 74.3c-.8 2.8-1.3 5.8-1.3 8.9c0 17.7 14.3 32 32 32c3.2 0 6.2-.4 8.9-1.3c19.1-5.5 46.1-10.7 74.3-3.3c57.4 14.9 124.6-7.4 174.7-57.5s72.4-117.3 57.5-174.7c-7.3-28.2-2.2-55.2 3.3-74.3c.8-2.8 1.3-5.8 1.3-8.9c0-17.7-14.3-32-32-32zm0-48c44.2 0 80 35.8 80 80c0 7.7-1.1 15.2-3.1 22.3c-4.6 15.8-7.1 32.9-3 48.9c20.1 77.6-10.9 161.5-70 220.7s-143.1 90.2-220.7 70c-16-4.1-33-1.6-48.9 3c-7.1 2-14.6 3.1-22.3 3.1c-44.2 0-80-35.8-80-80c0-7.7 1.1-15.2 3.1-22.3c4.6-15.8 7.1-32.9 3-48.9C-14 251.3 17 167.3 76.2 108.2S219.3 18 296.8 38.1c16 4.1 33 1.6 48.9-3c7.1-2 14.6-3.1 22.3-3.1zM246.7 167c-52 15.2-96.5 59.7-111.7 111.7c-3.7 12.7-17.1 20-29.8 16.3s-20-17.1-16.3-29.8c19.8-67.7 76.6-124.5 144.3-144.3c12.7-3.7 26.1 3.6 29.8 16.3s-3.6 26.1-16.3 29.8z"
    ]
};
const $40b7be8cb53b06e9$export$b4c63e9bfc7906f1 = {
    prefix: "far",
    iconName: "handshake",
    icon: [
        640,
        512,
        [],
        "f2b5",
        "M272.2 64.6l-51.1 51.1c-15.3 4.2-29.5 11.9-41.5 22.5L153 161.9C142.8 171 129.5 176 115.8 176L96 176l0 128c20.4 .6 39.8 8.9 54.3 23.4l35.6 35.6 7 7c0 0 0 0 0 0L219.9 397c6.2 6.2 16.4 6.2 22.6 0c1.7-1.7 3-3.7 3.7-5.8c2.8-7.7 9.3-13.5 17.3-15.3s16.4 .6 22.2 6.5L296.5 393c11.6 11.6 30.4 11.6 41.9 0c5.4-5.4 8.3-12.3 8.6-19.4c.4-8.8 5.6-16.6 13.6-20.4s17.3-3 24.4 2.1c9.4 6.7 22.5 5.8 30.9-2.6c9.4-9.4 9.4-24.6 0-33.9L340.1 243l-35.8 33c-27.3 25.2-69.2 25.6-97 .9c-31.7-28.2-32.4-77.4-1.6-106.5l70.1-66.2C303.2 78.4 339.4 64 377.1 64c36.1 0 71 13.3 97.9 37.2L505.1 128l38.9 0 40 0 40 0c8.8 0 16 7.2 16 16l0 208c0 17.7-14.3 32-32 32l-32 0c-11.8 0-22.2-6.4-27.7-16l-84.9 0c-3.4 6.7-7.9 13.1-13.5 18.7c-17.1 17.1-40.8 23.8-63 20.1c-3.6 7.3-8.5 14.1-14.6 20.2c-27.3 27.3-70 30-100.4 8.1c-25.1 20.8-62.5 19.5-86-4.1L159 404l-7-7-35.6-35.6c-5.5-5.5-12.7-8.7-20.4-9.3C96 369.7 81.6 384 64 384l-32 0c-17.7 0-32-14.3-32-32L0 144c0-8.8 7.2-16 16-16l40 0 40 0 19.8 0c2 0 3.9-.7 5.3-2l26.5-23.6C175.5 77.7 211.4 64 248.7 64L259 64c4.4 0 8.9 .2 13.2 .6zM544 320l0-144-48 0c-5.9 0-11.6-2.2-15.9-6.1l-36.9-32.8c-18.2-16.2-41.7-25.1-66.1-25.1c-25.4 0-49.8 9.7-68.3 27.1l-70.1 66.2c-10.3 9.8-10.1 26.3 .5 35.7c9.3 8.3 23.4 8.1 32.5-.3l71.9-66.4c9.7-9 24.9-8.4 33.9 1.4s8.4 24.9-1.4 33.9l-.8 .8 74.4 74.4c10 10 16.5 22.3 19.4 35.1l74.8 0zM64 336a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm528 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
const $40b7be8cb53b06e9$export$31ee86ac717db552 = {
    prefix: "far",
    iconName: "gem",
    icon: [
        512,
        512,
        [
            128142
        ],
        "f3a5",
        "M168.5 72L256 165l87.5-93-175 0zM383.9 99.1L311.5 176l129 0L383.9 99.1zm50 124.9L256 224 78.1 224 256 420.3 433.9 224zM71.5 176l129 0L128.1 99.1 71.5 176zm434.3 40.1l-232 256c-4.5 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152c4.5-6.1 11.7-9.8 19.3-9.8l240 0c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4z"
    ]
};
const $40b7be8cb53b06e9$export$86c4e45dc3302d15 = {
    prefix: "far",
    iconName: "circle-play",
    icon: [
        512,
        512,
        [
            61469,
            "play-circle"
        ],
        "f144",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c7.6-4.2 16.8-4.1 24.3 .5l144 88c7.1 4.4 11.5 12.1 11.5 20.5s-4.4 16.1-11.5 20.5l-144 88c-7.4 4.5-16.7 4.7-24.3 .5s-12.3-12.2-12.3-20.9l0-176c0-8.7 4.7-16.7 12.3-20.9z"
    ]
};
const $40b7be8cb53b06e9$export$cf04333781061c5e = $40b7be8cb53b06e9$export$86c4e45dc3302d15;
const $40b7be8cb53b06e9$export$c2e9877668862374 = {
    prefix: "far",
    iconName: "circle-check",
    icon: [
        512,
        512,
        [
            61533,
            "check-circle"
        ],
        "f058",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"
    ]
};
const $40b7be8cb53b06e9$export$be9e388158c74f29 = $40b7be8cb53b06e9$export$c2e9877668862374;
const $40b7be8cb53b06e9$export$229de76dfef2687f = {
    prefix: "far",
    iconName: "circle-stop",
    icon: [
        512,
        512,
        [
            62094,
            "stop-circle"
        ],
        "f28d",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm192-96l128 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32z"
    ]
};
const $40b7be8cb53b06e9$export$47af2aad60ab3e7c = $40b7be8cb53b06e9$export$229de76dfef2687f;
const $40b7be8cb53b06e9$export$a75288855ea05282 = {
    prefix: "far",
    iconName: "id-badge",
    icon: [
        384,
        512,
        [],
        "f2c1",
        "M256 48l0 16c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-16L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16l-64 0zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM160 320l64 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16L96 416c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"
    ]
};
const $40b7be8cb53b06e9$export$3f2d51c0547bf984 = {
    prefix: "far",
    iconName: "face-laugh-beam",
    icon: [
        512,
        512,
        [
            128513,
            "laugh-beam"
        ],
        "f59a",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9l212.5 0c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zm86.9-85.1s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0zm160 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0z"
    ]
};
const $40b7be8cb53b06e9$export$a88d1f4073ea9369 = $40b7be8cb53b06e9$export$3f2d51c0547bf984;
const $40b7be8cb53b06e9$export$5f519e9ac15ab8c3 = {
    prefix: "far",
    iconName: "registered",
    icon: [
        512,
        512,
        [
            174
        ],
        "f25d",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 152l0 112 0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 60.9 0 37.2 81.9c5.5 12.1 19.7 17.4 31.8 11.9s17.4-19.7 11.9-31.8L315.7 275c21.8-14.3 36.3-39 36.3-67c0-44.2-35.8-80-80-80l-88 0c-13.3 0-24 10.7-24 24zm48 88l0-64 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0z"
    ]
};
const $40b7be8cb53b06e9$export$6ea408c7266ed557 = {
    prefix: "far",
    iconName: "address-card",
    icon: [
        576,
        512,
        [
            62140,
            "contact-card",
            "vcard"
        ],
        "f2bb",
        "M512 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l448 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM208 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0zM376 144c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0z"
    ]
};
const $40b7be8cb53b06e9$export$4ac51eb0b298b190 = $40b7be8cb53b06e9$export$6ea408c7266ed557;
const $40b7be8cb53b06e9$export$91228257deb1bf18 = $40b7be8cb53b06e9$export$6ea408c7266ed557;
const $40b7be8cb53b06e9$export$5352cbdc070ce8d = {
    prefix: "far",
    iconName: "face-tired",
    icon: [
        512,
        512,
        [
            128555,
            "tired"
        ],
        "f5c8",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.5 64.3C196.1 302.1 223.8 288 256 288s59.9 14.1 79.5 32.3C354.5 338.1 368 362 368 384c0 5.4-2.7 10.4-7.2 13.4s-10.2 3.4-15.2 1.3l-17.2-7.5c-22.8-10-47.5-15.1-72.4-15.1s-49.6 5.2-72.4 15.1l-17.2 7.5c-4.9 2.2-10.7 1.7-15.2-1.3s-7.2-8-7.2-13.4c0-22 13.5-45.9 32.5-63.7zm-43-173.6l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
    ]
};
const $40b7be8cb53b06e9$export$3d016d62cda18371 = $40b7be8cb53b06e9$export$5352cbdc070ce8d;
const $40b7be8cb53b06e9$export$aa4baaed1c60f58d = {
    prefix: "far",
    iconName: "font-awesome",
    icon: [
        512,
        512,
        [
            62501,
            62694,
            "font-awesome-flag",
            "font-awesome-logo-full"
        ],
        "f2b4",
        "M91.7 96C106.3 86.8 116 70.5 116 52C116 23.3 92.7 0 64 0S12 23.3 12 52c0 16.7 7.8 31.5 20 41l0 3 0 48 0 256 0 48 0 64 48 0 0-64 389.6 0c14.6 0 26.4-11.8 26.4-26.4c0-3.7-.8-7.3-2.3-10.7L432 272l61.7-138.9c1.5-3.4 2.3-7 2.3-10.7c0-14.6-11.8-26.4-26.4-26.4L91.7 96zM80 400l0-256 356.4 0L388.1 252.5c-5.5 12.4-5.5 26.6 0 39L436.4 400 80 400z"
    ]
};
const $40b7be8cb53b06e9$export$102c25fde54d4843 = $40b7be8cb53b06e9$export$aa4baaed1c60f58d;
const $40b7be8cb53b06e9$export$6e20d421a2e0f320 = $40b7be8cb53b06e9$export$aa4baaed1c60f58d;
const $40b7be8cb53b06e9$export$6143da800b0e6626 = {
    prefix: "far",
    iconName: "face-smile-wink",
    icon: [
        512,
        512,
        [
            128521,
            "smile-wink"
        ],
        "f4da",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm165.8 21.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z"
    ]
};
const $40b7be8cb53b06e9$export$f5dbb37f6801ee3f = $40b7be8cb53b06e9$export$6143da800b0e6626;
const $40b7be8cb53b06e9$export$f0858dff6e769cf6 = {
    prefix: "far",
    iconName: "file-word",
    icon: [
        384,
        512,
        [],
        "f1c2",
        "M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm55 241.1c-3.8-12.7-17.2-19.9-29.9-16.1s-19.9 17.2-16.1 29.9l48 160c3 10.2 12.4 17.1 23 17.1s19.9-7 23-17.1l25-83.4 25 83.4c3 10.2 12.4 17.1 23 17.1s19.9-7 23-17.1l48-160c3.8-12.7-3.4-26.1-16.1-29.9s-26.1 3.4-29.9 16.1l-25 83.4-25-83.4c-3-10.2-12.4-17.1-23-17.1s-19.9 7-23 17.1l-25 83.4-25-83.4z"
    ]
};
const $40b7be8cb53b06e9$export$c341daeecdea449a = {
    prefix: "far",
    iconName: "file-powerpoint",
    icon: [
        384,
        512,
        [],
        "f1c4",
        "M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm72 208c-13.3 0-24 10.7-24 24l0 104 0 56c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32 44 0c42 0 76-34 76-76s-34-76-76-76l-68 0zm68 104l-44 0 0-56 44 0c15.5 0 28 12.5 28 28s-12.5 28-28 28z"
    ]
};
const $40b7be8cb53b06e9$export$c6c3bd5f7d9b8bf2 = {
    prefix: "far",
    iconName: "envelope-open",
    icon: [
        512,
        512,
        [
            62135
        ],
        "f2b6",
        "M255.4 48.2c.2-.1 .4-.2 .6-.2s.4 .1 .6 .2L460.6 194c2.1 1.5 3.4 3.9 3.4 6.5l0 13.6L291.5 355.7c-20.7 17-50.4 17-71.1 0L48 214.1l0-13.6c0-2.6 1.2-5 3.4-6.5L255.4 48.2zM48 276.2L190 392.8c38.4 31.5 93.7 31.5 132 0L464 276.2 464 456c0 4.4-3.6 8-8 8L56 464c-4.4 0-8-3.6-8-8l0-179.8zM256 0c-10.2 0-20.2 3.2-28.5 9.1L23.5 154.9C8.7 165.4 0 182.4 0 200.5L0 456c0 30.9 25.1 56 56 56l400 0c30.9 0 56-25.1 56-56l0-255.5c0-18.1-8.7-35.1-23.4-45.6L284.5 9.1C276.2 3.2 266.2 0 256 0z"
    ]
};
const $40b7be8cb53b06e9$export$7a4a0e4caa1e4e6f = {
    prefix: "far",
    iconName: "file-zipper",
    icon: [
        384,
        512,
        [
            "file-archive"
        ],
        "f1c6",
        "M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l48 0c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l48 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm48 112c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm-6.3 71.8L82.1 335.9c-1.4 5.4-2.1 10.9-2.1 16.4c0 35.2 28.8 63.7 64 63.7s64-28.5 64-63.7c0-5.5-.7-11.1-2.1-16.4l-23.5-88.2c-3.7-14-16.4-23.8-30.9-23.8l-14.8 0c-14.5 0-27.2 9.7-30.9 23.8zM128 336l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
const $40b7be8cb53b06e9$export$bf2047a9946b5c3f = $40b7be8cb53b06e9$export$7a4a0e4caa1e4e6f;
const $40b7be8cb53b06e9$export$90b4406457aae8cc = {
    prefix: "far",
    iconName: "square",
    icon: [
        448,
        512,
        [
            9632,
            9723,
            9724,
            61590
        ],
        "f0c8",
        "M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z"
    ]
};
const $40b7be8cb53b06e9$export$bab8f3647c394f48 = {
    prefix: "far",
    iconName: "snowflake",
    icon: [
        448,
        512,
        [
            10052,
            10054
        ],
        "f2dc",
        "M224 0c13.3 0 24 10.7 24 24l0 46.1 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-57 57 0 76.5 66.2-38.2 20.9-77.8c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4L373 142.2l37.1-21.4c11.5-6.6 26.2-2.7 32.8 8.8s2.7 26.2-8.8 32.8L397 183.8l31.5 8.4c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-77.8-20.9L272 256l66.2 38.2 77.8-20.9c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4L397 328.2l37.1 21.4c11.5 6.6 15.4 21.3 8.8 32.8s-21.3 15.4-32.8 8.8L373 369.8l8.4 31.5c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-20.9-77.8L248 297.6l0 76.5 57 57c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23 0 46.1c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-46.1-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l57-57 0-76.5-66.2 38.2-20.9 77.8c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4L75 369.8 37.9 391.2c-11.5 6.6-26.2 2.7-32.8-8.8s-2.7-26.2 8.8-32.8L51 328.2l-31.5-8.4c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l77.8 20.9L176 256l-66.2-38.2L31.9 238.6c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4L51 183.8 13.9 162.4c-11.5-6.6-15.4-21.3-8.8-32.8s21.3-15.4 32.8-8.8L75 142.2l-8.4-31.5c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l20.9 77.8L200 214.4l0-76.5L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23L200 24c0-13.3 10.7-24 24-24z"
    ]
};
const $40b7be8cb53b06e9$export$d91b374112d4f8c1 = {
    prefix: "far",
    iconName: "newspaper",
    icon: [
        512,
        512,
        [
            128240
        ],
        "f1ea",
        "M168 80c-13.3 0-24 10.7-24 24l0 304c0 8.4-1.4 16.5-4.1 24L440 432c13.3 0 24-10.7 24-24l0-304c0-13.3-10.7-24-24-24L168 80zM72 480c-39.8 0-72-32.2-72-72L0 112C0 98.7 10.7 88 24 88s24 10.7 24 24l0 296c0 13.3 10.7 24 24 24s24-10.7 24-24l0-304c0-39.8 32.2-72 72-72l272 0c39.8 0 72 32.2 72 72l0 304c0 39.8-32.2 72-72 72L72 480zM176 136c0-13.3 10.7-24 24-24l96 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24l0-80zm200-24l32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80l32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM200 272l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
const $40b7be8cb53b06e9$export$611ae61f02de0aa = {
    prefix: "far",
    iconName: "face-kiss-wink-heart",
    icon: [
        512,
        512,
        [
            128536,
            "kiss-wink-heart"
        ],
        "f598",
        "M338.9 446.8c-25.4 11-53.4 17.2-82.9 17.2C141.1 464 48 370.9 48 256S141.1 48 256 48s208 93.1 208 208c0 22.4-3.5 43.9-10.1 64.1c3.1 4.5 5.7 9.4 7.8 14.6c12.7-1.6 25.1 .4 36.2 5c9.1-26.2 14-54.4 14-83.7C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c35.4 0 69.1-7.2 99.7-20.2c-4.8-5.5-8.5-12.2-10.4-19.7l-6.5-25.3zM296 316c0-6.9-3.1-13.2-7.3-18.3c-4.3-5.2-10.1-9.7-16.7-13.4C258.7 276.9 241.4 272 224 272c-3.6 0-6.8 2.5-7.7 6s.6 7.2 3.8 9c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2 .1c.2 .1 .5 .3 .9 .5c.8 .5 2 1.2 3.4 2.1c2.8 1.9 6.5 4.5 10.2 7.6c3.7 3.1 7.2 6.6 9.6 10.1c2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1c-3.7 3.1-7.4 5.7-10.2 7.6c-1.4 .9-2.6 1.6-3.4 2.1c-.4 .2-.7 .4-.9 .5l-.2 .1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c-2.5 1.4-4.1 4.1-4.1 7s1.6 5.6 4.1 7c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2 .1c.2 .1 .5 .3 .9 .5c.8 .5 2 1.2 3.4 2.1c2.8 1.9 6.5 4.5 10.2 7.6c3.7 3.1 7.2 6.6 9.6 10.1c2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1c-3.7 3.1-7.4 5.7-10.2 7.6c-1.4 .9-2.6 1.6-3.4 2.1c-.4 .2-.7 .4-.9 .5l-.2 .1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-3.2 1.8-4.7 5.5-3.8 9s4.1 6 7.7 6c17.4 0 34.7-4.9 47.9-12.3c6.6-3.7 12.5-8.2 16.7-13.4c4.3-5.1 7.3-11.4 7.3-18.3s-3.1-13.2-7.3-18.3c-4.3-5.2-10.1-9.7-16.7-13.4c-2.7-1.5-5.7-3-8.7-4.3c3.1-1.3 6-2.7 8.7-4.3c6.6-3.7 12.5-8.2 16.7-13.4c4.3-5.1 7.3-11.4 7.3-18.3zM176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm159.3-20c10.6 0 19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C375.7 186.8 355 180 335.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zM434 352.3c-6-23.2-28.8-37-51.1-30.8s-35.4 30.1-29.5 53.4l22.9 89.3c2.2 8.7 11.2 13.9 19.8 11.4l84.9-23.8c22.2-6.2 35.4-30.1 29.5-53.4s-28.8-37-51.1-30.8l-20.2 5.6-5.4-21z"
    ]
};
const $40b7be8cb53b06e9$export$ebba617701dfb917 = $40b7be8cb53b06e9$export$611ae61f02de0aa;
const $40b7be8cb53b06e9$export$3e4892d8bf919edd = {
    prefix: "far",
    iconName: "star-half-stroke",
    icon: [
        576,
        512,
        [
            "star-half-alt"
        ],
        "f5c0",
        "M309.5 13.5C305.5 5.2 297.1 0 287.9 0s-17.6 5.2-21.6 13.5L197.7 154.8 44.5 177.5c-9 1.3-16.5 7.6-19.3 16.3s-.5 18.1 5.9 24.5L142.2 328.4 116 483.9c-1.5 9 2.2 18.1 9.7 23.5s17.3 6 25.3 1.7l137-73.2 137 73.2c8.1 4.3 17.9 3.7 25.3-1.7s11.2-14.5 9.7-23.5L433.6 328.4 544.8 218.2c6.5-6.4 8.7-15.9 5.9-24.5s-10.3-14.9-19.3-16.3L378.1 154.8 309.5 13.5zM288 384.7l0-305.6 52.5 108.1c3.5 7.1 10.2 12.1 18.1 13.3l118.3 17.5L391 303c-5.5 5.5-8.1 13.3-6.8 21l20.2 119.6L299.2 387.5c-3.5-1.9-7.4-2.8-11.2-2.8z"
    ]
};
const $40b7be8cb53b06e9$export$c13575f42532efb3 = $40b7be8cb53b06e9$export$3e4892d8bf919edd;
const $40b7be8cb53b06e9$export$77cb1a465c4fe84 = {
    prefix: "far",
    iconName: "file-excel",
    icon: [
        384,
        512,
        [],
        "f1c3",
        "M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm90.9 233.3c-8.1-10.5-23.2-12.3-33.7-4.2s-12.3 23.2-4.2 33.7L161.6 320l-44.5 57.3c-8.1 10.5-6.3 25.5 4.2 33.7s25.5 6.3 33.7-4.2L192 359.1l37.1 47.6c8.1 10.5 23.2 12.3 33.7 4.2s12.3-23.2 4.2-33.7L222.4 320l44.5-57.3c8.1-10.5 6.3-25.5-4.2-33.7s-25.5-6.3-33.7 4.2L192 280.9l-37.1-47.6z"
    ]
};
const $40b7be8cb53b06e9$export$3de52eeb00462407 = {
    prefix: "far",
    iconName: "face-grin-beam",
    icon: [
        512,
        512,
        [
            128516,
            "grin-beam"
        ],
        "f582",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM217.6 228.8s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0zm160 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0z"
    ]
};
const $40b7be8cb53b06e9$export$734da5249381ec7e = $40b7be8cb53b06e9$export$3de52eeb00462407;
const $40b7be8cb53b06e9$export$887f6345573abcac = {
    prefix: "far",
    iconName: "object-ungroup",
    icon: [
        640,
        512,
        [],
        "f248",
        "M48.2 66.8c-.1-.8-.2-1.7-.2-2.5l0-.2c0-8.8 7.2-16 16-16c.9 0 1.9 .1 2.8 .2C74.3 49.5 80 56.1 80 64c0 8.8-7.2 16-16 16c-7.9 0-14.5-5.7-15.8-13.2zM0 64c0 26.9 16.5 49.9 40 59.3l0 105.3C16.5 238.1 0 261.1 0 288c0 35.3 28.7 64 64 64c26.9 0 49.9-16.5 59.3-40l201.3 0c9.5 23.5 32.5 40 59.3 40c35.3 0 64-28.7 64-64c0-26.9-16.5-49.9-40-59.3l0-105.3c23.5-9.5 40-32.5 40-59.3c0-35.3-28.7-64-64-64c-26.9 0-49.9 16.5-59.3 40L123.3 40C113.9 16.5 90.9 0 64 0C28.7 0 0 28.7 0 64zm368 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM324.7 88c6.5 16 19.3 28.9 35.3 35.3l0 105.3c-16 6.5-28.9 19.3-35.3 35.3l-201.3 0c-6.5-16-19.3-28.9-35.3-35.3l0-105.3c16-6.5 28.9-19.3 35.3-35.3l201.3 0zM384 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM80 288c0 7.9-5.7 14.5-13.2 15.8c-.8 .1-1.7 .2-2.5 .2l-.2 0c-8.8 0-16-7.2-16-16c0-.9 .1-1.9 .2-2.8C49.5 277.7 56.1 272 64 272c8.8 0 16 7.2 16 16zm391.3-40l45.4 0c6.5 16 19.3 28.9 35.3 35.3l0 105.3c-16 6.5-28.9 19.3-35.3 35.3l-201.3 0c-6.5-16-19.3-28.9-35.3-35.3l0-36.7-48 0 0 36.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64c26.9 0 49.9-16.5 59.3-40l201.3 0c9.5 23.5 32.5 40 59.3 40c35.3 0 64-28.7 64-64c0-26.9-16.5-49.9-40-59.3l0-105.3c23.5-9.5 40-32.5 40-59.3c0-35.3-28.7-64-64-64c-26.9 0-49.9 16.5-59.3 40L448 200l0 16.4c9.8 8.8 17.8 19.5 23.3 31.6zm88.9-26.7a16 16 0 1 1 31.5 5.5 16 16 0 1 1 -31.5-5.5zM271.8 450.7a16 16 0 1 1 -31.5-5.5 16 16 0 1 1 31.5 5.5zm307-18.5a16 16 0 1 1 -5.5 31.5 16 16 0 1 1 5.5-31.5z"
    ]
};
const $40b7be8cb53b06e9$export$1fec48c8bdd69c1d = {
    prefix: "far",
    iconName: "circle-right",
    icon: [
        512,
        512,
        [
            61838,
            "arrow-alt-circle-right"
        ],
        "f35a",
        "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM294.6 151.2c-4.2-4.6-10.1-7.2-16.4-7.2C266 144 256 154 256 166.3l0 41.7-96 0c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l96 0 0 41.7c0 12.3 10 22.3 22.3 22.3c6.2 0 12.1-2.6 16.4-7.2l84-91c3.5-3.8 5.4-8.7 5.4-13.9s-1.9-10.1-5.4-13.9l-84-91z"
    ]
};
const $40b7be8cb53b06e9$export$88962ffdad8b856d = $40b7be8cb53b06e9$export$1fec48c8bdd69c1d;
const $40b7be8cb53b06e9$export$a6d72a9a068392b5 = {
    prefix: "far",
    iconName: "face-rolling-eyes",
    icon: [
        512,
        512,
        [
            128580,
            "meh-rolling-eyes"
        ],
        "f5a5",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM168 376c0 13.3 10.7 24 24 24l128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-128 0c-13.3 0-24 10.7-24 24zm-8-104c-26.5 0-48-21.5-48-48c0-14.3 6.3-27.2 16.2-36c-.2 1.3-.2 2.6-.2 4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1.4-.1-2.7-.2-4c10 8.8 16.2 21.7 16.2 36c0 26.5-21.5 48-48 48zm0 32a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm192-32c-26.5 0-48-21.5-48-48c0-14.3 6.3-27.2 16.2-36c-.2 1.3-.2 2.6-.2 4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1.4-.1-2.7-.2-4c10 8.8 16.2 21.7 16.2 36c0 26.5-21.5 48-48 48zm0 32a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"
    ]
};
const $40b7be8cb53b06e9$export$fdc62a1bea767cc2 = $40b7be8cb53b06e9$export$a6d72a9a068392b5;
const $40b7be8cb53b06e9$export$40cdac24aa94a57a = {
    prefix: "far",
    iconName: "object-group",
    icon: [
        576,
        512,
        [],
        "f247",
        "M48 115.8C38.2 107 32 94.2 32 80c0-26.5 21.5-48 48-48c14.2 0 27 6.2 35.8 16l344.4 0c8.8-9.8 21.6-16 35.8-16c26.5 0 48 21.5 48 48c0 14.2-6.2 27-16 35.8l0 280.4c9.8 8.8 16 21.6 16 35.8c0 26.5-21.5 48-48 48c-14.2 0-27-6.2-35.8-16l-344.4 0c-8.8 9.8-21.6 16-35.8 16c-26.5 0-48-21.5-48-48c0-14.2 6.2-27 16-35.8l0-280.4zM125.3 96c-4.8 13.6-15.6 24.4-29.3 29.3l0 261.5c13.6 4.8 24.4 15.6 29.3 29.3l325.5 0c4.8-13.6 15.6-24.4 29.3-29.3l0-261.5c-13.6-4.8-24.4-15.6-29.3-29.3L125.3 96zm2.7 64c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-96zM256 320l32 0c35.3 0 64-28.7 64-64l0-32 64 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-32z"
    ]
};
const $40b7be8cb53b06e9$export$e4b51a47a2f8b9db = {
    prefix: "far",
    iconName: "heart",
    icon: [
        512,
        512,
        [
            128153,
            128154,
            128155,
            128156,
            128420,
            129293,
            129294,
            129505,
            9829,
            10084,
            61578
        ],
        "f004",
        "M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8l0-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5l0 3.3c0 41.9-17.4 81.9-48.1 110.4L288.7 465.9l-2.5 2.3c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM239.1 145c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1s0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5l0 3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7 431.2 268c20.9-19.4 32.8-46.7 32.8-75.2l0-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7z"
    ]
};
const $40b7be8cb53b06e9$export$c938968e28178994 = {
    prefix: "far",
    iconName: "face-surprise",
    icon: [
        512,
        512,
        [
            128558,
            "surprise"
        ],
        "f5c2",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
const $40b7be8cb53b06e9$export$46647c72213f53ba = $40b7be8cb53b06e9$export$c938968e28178994;
const $40b7be8cb53b06e9$export$fbeef2513e05ad08 = {
    prefix: "far",
    iconName: "circle-pause",
    icon: [
        512,
        512,
        [
            62092,
            "pause-circle"
        ],
        "f28b",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm224-72l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144c0-13.3 10.7-24 24-24s24 10.7 24 24zm112 0l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
const $40b7be8cb53b06e9$export$d8cf08a0362da8db = $40b7be8cb53b06e9$export$fbeef2513e05ad08;
const $40b7be8cb53b06e9$export$4280b2387fbdad12 = {
    prefix: "far",
    iconName: "circle",
    icon: [
        512,
        512,
        [
            128308,
            128309,
            128992,
            128993,
            128994,
            128995,
            128996,
            9679,
            9898,
            9899,
            11044,
            61708,
            61915
        ],
        "f111",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
    ]
};
const $40b7be8cb53b06e9$export$72ea8a5e4e86cd69 = {
    prefix: "far",
    iconName: "circle-up",
    icon: [
        512,
        512,
        [
            61467,
            "arrow-alt-circle-up"
        ],
        "f35b",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM151.2 217.4c-4.6 4.2-7.2 10.1-7.2 16.4c0 12.3 10 22.3 22.3 22.3l41.7 0 0 96c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-96 41.7 0c12.3 0 22.3-10 22.3-22.3c0-6.2-2.6-12.1-7.2-16.4l-91-84c-3.8-3.5-8.7-5.4-13.9-5.4s-10.1 1.9-13.9 5.4l-91 84z"
    ]
};
const $40b7be8cb53b06e9$export$3747a8ef0995eadf = $40b7be8cb53b06e9$export$72ea8a5e4e86cd69;
const $40b7be8cb53b06e9$export$b8d24c57c9e64933 = {
    prefix: "far",
    iconName: "file-audio",
    icon: [
        384,
        512,
        [],
        "f1c7",
        "M64 464l256 0c8.8 0 16-7.2 16-16l0-288-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM192 272l0 128c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L129.4 376 112 376c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16l17.4 0 35.3-35.3c4.6-4.6 11.5-5.9 17.4-3.5s9.9 8.3 9.9 14.8zm85.8-4c11.6 20 18.2 43.3 18.2 68s-6.6 48-18.2 68c-6.6 11.5-21.3 15.4-32.8 8.8s-15.4-21.3-8.8-32.8c7.5-12.9 11.8-27.9 11.8-44s-4.3-31.1-11.8-44c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8z"
    ]
};
const $40b7be8cb53b06e9$export$6440b286d3cbac9b = {
    prefix: "far",
    iconName: "file-image",
    icon: [
        384,
        512,
        [
            128443
        ],
        "f1c5",
        "M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm96 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm69.2 46.9c-3-4.3-7.9-6.9-13.2-6.9s-10.2 2.6-13.2 6.9l-41.3 59.7-11.9-19.1c-2.9-4.7-8.1-7.5-13.6-7.5s-10.6 2.8-13.6 7.5l-40 64c-3.1 4.9-3.2 11.1-.4 16.2s8.2 8.2 14 8.2l48 0 32 0 40 0 72 0c6 0 11.4-3.3 14.2-8.6s2.4-11.6-1-16.5l-72-104z"
    ]
};
const $40b7be8cb53b06e9$export$d7cf0978afd90002 = {
    prefix: "far",
    iconName: "circle-question",
    icon: [
        512,
        512,
        [
            62108,
            "question-circle"
        ],
        "f059",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
const $40b7be8cb53b06e9$export$5ba67d7f2265c1a5 = $40b7be8cb53b06e9$export$d7cf0978afd90002;
const $40b7be8cb53b06e9$export$38c072b870a9e4ab = {
    prefix: "far",
    iconName: "face-meh-blank",
    icon: [
        512,
        512,
        [
            128566,
            "meh-blank"
        ],
        "f5a4",
        "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $40b7be8cb53b06e9$export$e945435725f71e88 = $40b7be8cb53b06e9$export$38c072b870a9e4ab;
const $40b7be8cb53b06e9$export$b8c3e79e8c99c95b = {
    prefix: "far",
    iconName: "eye",
    icon: [
        576,
        512,
        [
            128065
        ],
        "f06e",
        "M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"
    ]
};
const $40b7be8cb53b06e9$export$e8ea88c55e55be7c = {
    prefix: "far",
    iconName: "face-sad-cry",
    icon: [
        512,
        512,
        [
            128557,
            "sad-cry"
        ],
        "f5b3",
        "M400 406.1L400 288c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 152.6c-28.7 15-61.4 23.4-96 23.4s-67.3-8.5-96-23.4L160 288c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 118.1C72.6 368.2 48 315 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 59-24.6 112.2-64 150.1zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.6 220c10.6 0 19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C199.7 186.8 179 180 159.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zm166.6 9.7c5.5-5.8 14.8-9.7 25.4-9.7s19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C391.7 186.8 371 180 351.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9zM208 320l0 32c0 26.5 21.5 48 48 48s48-21.5 48-48l0-32c0-26.5-21.5-48-48-48s-48 21.5-48 48z"
    ]
};
const $40b7be8cb53b06e9$export$8e924e6bd422cef9 = $40b7be8cb53b06e9$export$e8ea88c55e55be7c;
const $40b7be8cb53b06e9$export$143d0ca7d2200f20 = {
    prefix: "far",
    iconName: "file-code",
    icon: [
        384,
        512,
        [],
        "f1c9",
        "M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm97 289c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L79 303c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-31-31 31-31zM257 255c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9l-48-48z"
    ]
};
const $40b7be8cb53b06e9$export$703cd98be31ec905 = {
    prefix: "far",
    iconName: "window-maximize",
    icon: [
        512,
        512,
        [
            128470
        ],
        "f2d0",
        "M.3 89.5C.1 91.6 0 93.8 0 96L0 224 0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-192 0-128c0-35.3-28.7-64-64-64L64 32c-2.2 0-4.4 .1-6.5 .3c-9.2 .9-17.8 3.8-25.5 8.2C21.8 46.5 13.4 55.1 7.7 65.5c-3.9 7.3-6.5 15.4-7.4 24zM48 224l416 0 0 192c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-192z"
    ]
};
const $40b7be8cb53b06e9$export$e5f78e87efbb0248 = {
    prefix: "far",
    iconName: "face-frown",
    icon: [
        512,
        512,
        [
            9785,
            "frown"
        ],
        "f119",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM174.6 384.1c-4.5 12.5-18.2 18.9-30.7 14.4s-18.9-18.2-14.4-30.7C146.9 319.4 198.9 288 256 288s109.1 31.4 126.6 79.9c4.5 12.5-2 26.2-14.4 30.7s-26.2-2-30.7-14.4C328.2 358.5 297.2 336 256 336s-72.2 22.5-81.4 48.1zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $40b7be8cb53b06e9$export$43b7108508aecc5f = $40b7be8cb53b06e9$export$e5f78e87efbb0248;
const $40b7be8cb53b06e9$export$f62f2879ccaea13f = {
    prefix: "far",
    iconName: "floppy-disk",
    icon: [
        448,
        512,
        [
            128190,
            128426,
            "save"
        ],
        "f0c7",
        "M48 96l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-245.5c0-4.2-1.7-8.3-4.7-11.3l33.9-33.9c12 12 18.7 28.3 18.7 45.3L448 416c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l245.5 0c17 0 33.3 6.7 45.3 18.7l74.5 74.5-33.9 33.9L320.8 84.7c-.3-.3-.5-.5-.8-.8L320 184c0 13.3-10.7 24-24 24l-192 0c-13.3 0-24-10.7-24-24L80 80 64 80c-8.8 0-16 7.2-16 16zm80-16l0 80 144 0 0-80L128 80zm32 240a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"
    ]
};
const $40b7be8cb53b06e9$export$1aaa83ff70706e1e = $40b7be8cb53b06e9$export$f62f2879ccaea13f;
const $40b7be8cb53b06e9$export$63ffcb3d4e94cb92 = {
    prefix: "far",
    iconName: "comment-dots",
    icon: [
        512,
        512,
        [
            128172,
            62075,
            "commenting"
        ],
        "f4ad",
        "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM144 272a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm144-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm80 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
const $40b7be8cb53b06e9$export$49ee382a2425e89c = $40b7be8cb53b06e9$export$63ffcb3d4e94cb92;
const $40b7be8cb53b06e9$export$5d53da7627754bc6 = {
    prefix: "far",
    iconName: "face-grin-squint",
    icon: [
        512,
        512,
        [
            128518,
            "grin-squint"
        ],
        "f585",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zm-216-161.7l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
    ]
};
const $40b7be8cb53b06e9$export$243ae757907b1580 = $40b7be8cb53b06e9$export$5d53da7627754bc6;
const $40b7be8cb53b06e9$export$d97ff927c450c87f = {
    prefix: "far",
    iconName: "hand-pointer",
    icon: [
        448,
        512,
        [],
        "f25a",
        "M160 64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 136c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4c8.8 0 16 7.2 16 16c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4c7.8 0 14.3 5.6 15.7 13c1.6 8.2 7.3 15.1 15.1 18s16.7 1.6 23.3-3.6c2.7-2.1 6.1-3.4 9.9-3.4c8.8 0 16 7.2 16 16l0 16 0 104c0 39.8-32.2 72-72 72l-56 0-59.8 0-.9 0c-37.4 0-72.4-18.7-93.2-49.9L50.7 312.9c-4.9-7.4-2.9-17.3 4.4-22.2s17.3-2.9 22.2 4.4L116 353.2c5.9 8.8 16.8 12.7 26.9 9.7s17-12.4 17-23l0-19.9 0-256zM176 0c-35.3 0-64 28.7-64 64l0 197.7C91.2 238 55.5 232.8 28.5 250.7C-.9 270.4-8.9 310.1 10.8 339.5L78.3 440.8c29.7 44.5 79.6 71.2 133.1 71.2l.9 0 59.8 0 56 0c66.3 0 120-53.7 120-120l0-104 0-16c0-35.3-28.7-64-64-64c-4.5 0-8.8 .5-13 1.3c-11.7-15.4-30.2-25.3-51-25.3c-6.9 0-13.5 1.1-19.7 3.1C288.7 170.7 269.6 160 248 160c-2.7 0-5.4 .2-8 .5L240 64c0-35.3-28.7-64-64-64zm48 304c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96zm48-16c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8-7.2-16-16-16zm80 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96z"
    ]
};
const $40b7be8cb53b06e9$export$c578e919f2c5c135 = {
    prefix: "far",
    iconName: "hand-scissors",
    icon: [
        512,
        512,
        [],
        "f257",
        "M.2 276.3c-1.2-35.3 26.4-65 61.7-66.2l3.3-.1L57 208.1C22.5 200.5 .7 166.3 8.3 131.8S50.2 75.5 84.7 83.2l173 38.3c2.3-2.9 4.7-5.7 7.1-8.5l18.4-20.3C299.9 74.5 323.5 64 348.3 64l10.2 0c54.1 0 104.1 28.7 131.3 75.4l1.5 2.6c13.6 23.2 20.7 49.7 20.7 76.6L512 344c0 66.3-53.7 120-120 120l-8 0-96 0c-35.3 0-64-28.7-64-64c0-2.8 .2-5.6 .5-8.3c-19.4-11-32.5-31.8-32.5-55.7c0-.8 0-1.6 0-2.4L66.4 338c-35.3 1.2-65-26.4-66.2-61.7zm63.4-18.2c-8.8 .3-15.7 7.7-15.4 16.5s7.7 15.7 16.5 15.4l161.5-5.6c9.8-.3 18.7 5.3 22.7 14.2s2.2 19.3-4.5 26.4c-2.8 2.9-4.4 6.7-4.4 11c0 8.8 7.2 16 16 16c9.1 0 17.4 5.1 21.5 13.3s3.2 17.9-2.3 25.1c-2 2.7-3.2 6-3.2 9.6c0 8.8 7.2 16 16 16l96 0 8 0c39.8 0 72-32.2 72-72l0-125.4c0-18.4-4.9-36.5-14.2-52.4l-1.5-2.6c-18.6-32-52.8-51.6-89.8-51.6l-10.2 0c-11.3 0-22 4.8-29.6 13.1l-17.5-15.9 17.5 15.9-18.4 20.3c-.6 .6-1.1 1.3-1.7 1.9l57 13.2c8.6 2 14 10.6 12 19.2s-10.6 14-19.2 12l-85.6-19.7L74.3 130c-8.6-1.9-17.2 3.5-19.1 12.2s3.5 17.2 12.2 19.1l187.5 41.6c10.2 2.3 17.8 10.9 18.7 21.4l.1 1c.6 6.6-1.5 13.1-5.8 18.1s-10.6 7.9-17.2 8.2L63.6 258.1z"
    ]
};
const $40b7be8cb53b06e9$export$8ac6d81a3d5b40a1 = {
    prefix: "far",
    iconName: "face-grin-tears",
    icon: [
        640,
        512,
        [
            128514,
            "grin-tears"
        ],
        "f588",
        "M516.1 325.5c1 3 2.1 6 3.3 8.9c3.3 8.1 8.4 18.5 16.5 26.6c3.9 3.9 8.2 7.4 12.7 10.3C506.4 454.8 419.9 512 320 512s-186.4-57.2-228.6-140.6c4.5-2.9 8.7-6.3 12.7-10.3c8.1-8.1 13.2-18.6 16.5-26.6c1.2-2.9 2.3-5.9 3.3-8.9C152.5 406.2 229.5 464 320 464s167.5-57.8 196.1-138.5zM320 48c-101.4 0-185.8 72.5-204.3 168.5c-6.7-3.1-14.3-4.3-22.3-3.1c-6.8 .9-16.2 2.4-26.6 4.4C85.3 94.5 191.6 0 320 0S554.7 94.5 573.2 217.7c-10.3-2-19.8-3.5-26.6-4.4c-8-1.2-15.7 .1-22.3 3.1C505.8 120.5 421.4 48 320 48zM78.5 341.1C60 356.7 32 355.5 14.3 337.7c-18.7-18.7-19.1-48.8-.7-67.2c8.6-8.6 30.1-15.1 50.5-19.6c13-2.8 25.5-4.8 33.9-6c5.4-.8 9.9 3.7 9 9c-3.1 21.5-11.4 70.2-25.5 84.4c-.9 1-1.9 1.8-2.9 2.7zm483 0c-.8-.6-1.5-1.3-2.3-2c-.2-.2-.5-.4-.7-.7c-14.1-14.1-22.5-62.9-25.5-84.4c-.8-5.4 3.7-9.9 9-9c1 .1 2.2 .3 3.3 .5c8.2 1.2 19.2 3 30.6 5.5c20.4 4.4 41.9 10.9 50.5 19.6c18.4 18.4 18 48.5-.7 67.2c-17.7 17.7-45.7 19-64.2 3.4zM439 336.5C414.4 374.6 370.3 400 319.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5c18.7-4.4 35.9 12 25.5 28.1zM281.6 228.8c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0zm160 0s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0z"
    ]
};
const $40b7be8cb53b06e9$export$b2f7512221512b5b = $40b7be8cb53b06e9$export$8ac6d81a3d5b40a1;
const $40b7be8cb53b06e9$export$3c70ffe5660af060 = {
    prefix: "far",
    iconName: "calendar-xmark",
    icon: [
        448,
        512,
        [
            "calendar-times"
        ],
        "f273",
        "M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM400 192L48 192l0 256c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-256zm-95 89l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
const $40b7be8cb53b06e9$export$99b20d7352fbcf08 = $40b7be8cb53b06e9$export$3c70ffe5660af060;
const $40b7be8cb53b06e9$export$b44eb38345c6a964 = {
    prefix: "far",
    iconName: "file-video",
    icon: [
        384,
        512,
        [],
        "f1c8",
        "M320 464c8.8 0 16-7.2 16-16l0-288-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0zM0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM80 288c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32l0 16 44.9-29.9c2-1.3 4.4-2.1 6.8-2.1c6.8 0 12.3 5.5 12.3 12.3l0 103.4c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.8-2.1L240 368l0 16c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-96z"
    ]
};
const $40b7be8cb53b06e9$export$38611f1c776aba73 = {
    prefix: "far",
    iconName: "file-pdf",
    icon: [
        512,
        512,
        [],
        "f1c1",
        "M64 464l48 0 0 48-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z"
    ]
};
const $40b7be8cb53b06e9$export$805cd88398a70581 = {
    prefix: "far",
    iconName: "comment",
    icon: [
        512,
        512,
        [
            128489,
            61669
        ],
        "f075",
        "M123.6 391.3c12.9-9.4 29.6-11.8 44.6-6.4c26.5 9.6 56.2 15.1 87.8 15.1c124.7 0 208-80.5 208-160s-83.3-160-208-160S48 160.5 48 240c0 32 12.4 62.8 35.7 89.2c8.6 9.7 12.8 22.5 11.8 35.5c-1.4 18.1-5.7 34.7-11.3 49.4c17-7.9 31.1-16.7 39.4-22.7zM21.2 431.9c1.8-2.7 3.5-5.4 5.1-8.1c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208s-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6c-15.1 6.6-32.3 12.6-50.1 16.1c-.8 .2-1.6 .3-2.4 .5c-4.4 .8-8.7 1.5-13.2 1.9c-.2 0-.5 .1-.7 .1c-5.1 .5-10.2 .8-15.3 .8c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4c4.1-4.2 7.8-8.7 11.3-13.5c1.7-2.3 3.3-4.6 4.8-6.9l.3-.5z"
    ]
};
const $40b7be8cb53b06e9$export$6f095630677adc = {
    prefix: "far",
    iconName: "envelope",
    icon: [
        512,
        512,
        [
            128386,
            9993,
            61443
        ],
        "f0e0",
        "M64 112c-8.8 0-16 7.2-16 16l0 22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1l0-22.1c0-8.8-7.2-16-16-16L64 112zM48 212.2L48 384c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-171.8L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128z"
    ]
};
const $40b7be8cb53b06e9$export$b9098a890f61e022 = {
    prefix: "far",
    iconName: "hourglass",
    icon: [
        384,
        512,
        [
            9203,
            62032,
            "hourglass-empty"
        ],
        "f254",
        "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l8 0 0 19c0 40.3 16 79 44.5 107.5L158.1 256 76.5 337.5C48 366 32 404.7 32 445l0 19-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l336 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-19c0-40.3-16-79-44.5-107.5L225.9 256l81.5-81.5C336 146 352 107.3 352 67l0-19 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 0zM192 289.9l81.5 81.5C293 391 304 417.4 304 445l0 19L80 464l0-19c0-27.6 11-54 30.5-73.5L192 289.9zm0-67.9l-81.5-81.5C91 121 80 94.6 80 67l0-19 224 0 0 19c0 27.6-11 54-30.5 73.5L192 222.1z"
    ]
};
const $40b7be8cb53b06e9$export$a2f8176a0161e891 = $40b7be8cb53b06e9$export$b9098a890f61e022;
const $40b7be8cb53b06e9$export$5655108e1162ba45 = {
    prefix: "far",
    iconName: "calendar-check",
    icon: [
        448,
        512,
        [],
        "f274",
        "M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM400 192L48 192l0 256c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-256zM329 297L217 409c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 95-95c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
const $40b7be8cb53b06e9$export$4cb736b866cbb7ec = {
    prefix: "far",
    iconName: "hard-drive",
    icon: [
        512,
        512,
        [
            128436,
            "hdd"
        ],
        "f0a0",
        "M64 80c-8.8 0-16 7.2-16 16l0 162c5.1-1.3 10.5-2 16-2l384 0c5.5 0 10.9 .7 16 2l0-162c0-8.8-7.2-16-16-16L64 80zM48 320l0 96c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16L64 304c-8.8 0-16 7.2-16 16zM0 320L0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 224 0 96c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64l0-96zm280 48a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
const $40b7be8cb53b06e9$export$62551e9c5ba7093f = $40b7be8cb53b06e9$export$4cb736b866cbb7ec;
const $40b7be8cb53b06e9$export$8ff56f5ebb8416a0 = {
    prefix: "far",
    iconName: "face-grin-squint-tears",
    icon: [
        512,
        512,
        [
            129315,
            "grin-squint-tears"
        ],
        "f586",
        "M426.8 14.2C446-5 477.5-4.6 497.1 14.9s20 51 .7 70.3c-14.8 14.8-65.7 23.6-88.3 26.7c-5.6 .9-10.3-3.9-9.5-9.5C403.3 79.9 412 29 426.8 14.2zM75 75C158.2-8.3 284.5-22.2 382.2 33.2c-1.5 4.8-2.9 9.6-4.1 14.3c-3.1 12.2-5.5 24.6-7.3 35c-80.8-53.6-190.7-44.8-261.9 26.4C37.7 180.1 28.9 290 82.5 370.8c-10.5 1.8-22.9 4.2-35 7.3c-4.7 1.2-9.5 2.5-14.3 4.1C-22.2 284.5-8.2 158.2 75 75zm389.6 58.9c4.7-1.2 9.5-2.5 14.3-4.1C534.2 227.5 520.2 353.8 437 437c-83.2 83.2-209.5 97.2-307.2 41.8c1.5-4.8 2.8-9.6 4-14.3c3.1-12.2 5.5-24.6 7.3-35c80.8 53.6 190.7 44.8 261.9-26.4c71.2-71.2 80-181.1 26.4-261.9c10.5-1.8 22.9-4.2 35-7.3zm-105.4 93c10.1-16.3 33.9-16.9 37.9 1.9c9.5 44.4-3.7 93.5-39.3 129.1s-84.8 48.8-129.1 39.3c-18.7-4-18.2-27.8-1.9-37.9c25.2-15.7 50.2-35.4 73.6-58.8s43.1-48.4 58.8-73.6zM92 265.3l97.4-29.7c11.6-3.5 22.5 7.3 19 19l-29.7 97.4c-2.6 8.6-13.4 11.3-19.8 4.9c-2-2-3.2-4.6-3.4-7.3l-5.1-56.1-56.1-5.1c-2.8-.3-5.4-1.5-7.3-3.4c-6.3-6.3-3.6-17.2 4.9-19.8zm193-178.2c2 2 3.2 4.6 3.4 7.3l5.1 56.1 56.1 5.1c2.8 .3 5.4 1.5 7.3 3.4c6.3 6.3 3.6 17.2-4.9 19.8l-97.4 29.7c-11.6 3.5-22.5-7.3-19-19L265.3 92c2.6-8.6 13.4-11.3 19.8-4.9zM14.9 497.1c-19.6-19.6-20-51-.7-70.3C29 412 79.8 403.2 102.4 400.1c5.6-.9 10.3 3.9 9.5 9.5c-3.2 22.5-11.9 73.5-26.7 88.3C66 517 34.5 516.6 14.9 497.1z"
    ]
};
const $40b7be8cb53b06e9$export$542206d6a85f3b42 = $40b7be8cb53b06e9$export$8ff56f5ebb8416a0;
const $40b7be8cb53b06e9$export$1f7600fa9fdb3978 = {
    prefix: "far",
    iconName: "rectangle-list",
    icon: [
        576,
        512,
        [
            "list-alt"
        ],
        "f022",
        "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm96 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm104 0c0-13.3 10.7-24 24-24l224 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-224 0c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24l224 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-224 0c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24l224 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-224 0c-13.3 0-24-10.7-24-24zm-72-64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM96 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
const $40b7be8cb53b06e9$export$c6327a203ffc65a3 = $40b7be8cb53b06e9$export$1f7600fa9fdb3978;
const $40b7be8cb53b06e9$export$16768a660ae3ca9d = {
    prefix: "far",
    iconName: "calendar-plus",
    icon: [
        448,
        512,
        [],
        "f271",
        "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256zm176 40c-13.3 0-24 10.7-24 24l0 48-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-48c0-13.3-10.7-24-24-24z"
    ]
};
const $40b7be8cb53b06e9$export$5ae86b9da9cca3bd = {
    prefix: "far",
    iconName: "circle-left",
    icon: [
        512,
        512,
        [
            61840,
            "arrow-alt-circle-left"
        ],
        "f359",
        "M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM256 128l-32 0L96 256 224 384l32 0 0-80 128 0 0-96-128 0 0-80z"
    ]
};
const $40b7be8cb53b06e9$export$5460a5b11a24996f = $40b7be8cb53b06e9$export$5ae86b9da9cca3bd;
const $40b7be8cb53b06e9$export$a312c7d58dd44a75 = {
    prefix: "far",
    iconName: "money-bill-1",
    icon: [
        576,
        512,
        [
            "money-bill-alt"
        ],
        "f3d1",
        "M112 112c0 35.3-28.7 64-64 64l0 160c35.3 0 64 28.7 64 64l352 0c0-35.3 28.7-64 64-64l0-160c-35.3 0-64-28.7-64-64l-352 0zM0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zM176 256a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm80-48c0 8.8 7.2 16 16 16l0 64-8 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l24 0 24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-8 0 0-80c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16z"
    ]
};
const $40b7be8cb53b06e9$export$a35d573395884c3d = $40b7be8cb53b06e9$export$a312c7d58dd44a75;
const $40b7be8cb53b06e9$export$95b9968e7fceb821 = {
    prefix: "far",
    iconName: "clock",
    icon: [
        512,
        512,
        [
            128339,
            "clock-four"
        ],
        "f017",
        "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120l0 136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2 280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
    ]
};
const $40b7be8cb53b06e9$export$9a575facf1cab48f = $40b7be8cb53b06e9$export$95b9968e7fceb821;
const $40b7be8cb53b06e9$export$fb61df5d98785fa8 = {
    prefix: "far",
    iconName: "keyboard",
    icon: [
        576,
        512,
        [
            9000
        ],
        "f11c",
        "M64 112c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16L64 112zM0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zM176 320l224 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm-72-72c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm16-96l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm16-96l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm16-96l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm16-96l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm16-96l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16z"
    ]
};
const $40b7be8cb53b06e9$export$8e047801a8603af7 = {
    prefix: "far",
    iconName: "closed-captioning",
    icon: [
        576,
        512,
        [],
        "f20a",
        "M512 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l448 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM200 208c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48s21.5-48 48-48zm144 48c0-26.5 21.5-48 48-48c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48z"
    ]
};
const $40b7be8cb53b06e9$export$74f06b41ed2ca28a = {
    prefix: "far",
    iconName: "images",
    icon: [
        576,
        512,
        [],
        "f302",
        "M160 80l352 0c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16l-21.2 0L388.1 178.9c-4.4-6.8-12-10.9-20.1-10.9s-15.7 4.1-20.1 10.9l-52.2 79.8-12.4-16.9c-4.5-6.2-11.7-9.8-19.4-9.8s-14.8 3.6-19.4 9.8L175.6 336 160 336c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16zM96 96l0 224c0 35.3 28.7 64 64 64l352 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L160 32c-35.3 0-64 28.7-64 64zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 344c0 75.1 60.9 136 136 136l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-320 0c-48.6 0-88-39.4-88-88l0-224zm208 24a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
const $40b7be8cb53b06e9$export$92292137ef3cf4c8 = {
    prefix: "far",
    iconName: "face-grin",
    icon: [
        512,
        512,
        [
            128512,
            "grin"
        ],
        "f580",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $40b7be8cb53b06e9$export$37e1f10b6de76621 = $40b7be8cb53b06e9$export$92292137ef3cf4c8;
const $40b7be8cb53b06e9$export$dc130582748497c6 = {
    prefix: "far",
    iconName: "face-meh",
    icon: [
        512,
        512,
        [
            128528,
            "meh"
        ],
        "f11a",
        "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM184 328c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"
    ]
};
const $40b7be8cb53b06e9$export$6d2db489aaeeecd2 = $40b7be8cb53b06e9$export$dc130582748497c6;
const $40b7be8cb53b06e9$export$782ac893fc22249b = {
    prefix: "far",
    iconName: "id-card",
    icon: [
        576,
        512,
        [
            62147,
            "drivers-license"
        ],
        "f2c2",
        "M528 160l0 256c0 8.8-7.2 16-16 16l-192 0c0-44.2-35.8-80-80-80l-64 0c-44.2 0-80 35.8-80 80l-32 0c-8.8 0-16-7.2-16-16l0-256 480 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM272 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm104-48c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0z"
    ]
};
const $40b7be8cb53b06e9$export$8359c70e609eff64 = $40b7be8cb53b06e9$export$782ac893fc22249b;
const $40b7be8cb53b06e9$export$2fa35dcbc038dbe9 = {
    prefix: "far",
    iconName: "sun",
    icon: [
        512,
        512,
        [
            9728
        ],
        "f185",
        "M375.7 19.7c-1.5-8-6.9-14.7-14.4-17.8s-16.1-2.2-22.8 2.4L256 61.1 173.5 4.2c-6.7-4.6-15.3-5.5-22.8-2.4s-12.9 9.8-14.4 17.8l-18.1 98.5L19.7 136.3c-8 1.5-14.7 6.9-17.8 14.4s-2.2 16.1 2.4 22.8L61.1 256 4.2 338.5c-4.6 6.7-5.5 15.3-2.4 22.8s9.8 13 17.8 14.4l98.5 18.1 18.1 98.5c1.5 8 6.9 14.7 14.4 17.8s16.1 2.2 22.8-2.4L256 450.9l82.5 56.9c6.7 4.6 15.3 5.5 22.8 2.4s12.9-9.8 14.4-17.8l18.1-98.5 98.5-18.1c8-1.5 14.7-6.9 17.8-14.4s2.2-16.1-2.4-22.8L450.9 256l56.9-82.5c4.6-6.7 5.5-15.3 2.4-22.8s-9.8-12.9-17.8-14.4l-98.5-18.1L375.7 19.7zM269.6 110l65.6-45.2 14.4 78.3c1.8 9.8 9.5 17.5 19.3 19.3l78.3 14.4L402 242.4c-5.7 8.2-5.7 19 0 27.2l45.2 65.6-78.3 14.4c-9.8 1.8-17.5 9.5-19.3 19.3l-14.4 78.3L269.6 402c-8.2-5.7-19-5.7-27.2 0l-65.6 45.2-14.4-78.3c-1.8-9.8-9.5-17.5-19.3-19.3L64.8 335.2 110 269.6c5.7-8.2 5.7-19 0-27.2L64.8 176.8l78.3-14.4c9.8-1.8 17.5-9.5 19.3-19.3l14.4-78.3L242.4 110c8.2 5.7 19 5.7 27.2 0zM256 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM192 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"
    ]
};
const $40b7be8cb53b06e9$export$600a1b26b33c3d47 = {
    prefix: "far",
    iconName: "face-laugh-wink",
    icon: [
        512,
        512,
        [
            "laugh-wink"
        ],
        "f59c",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9l212.5 0c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm165.8 21.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z"
    ]
};
const $40b7be8cb53b06e9$export$77ac40095f39933e = $40b7be8cb53b06e9$export$600a1b26b33c3d47;
const $40b7be8cb53b06e9$export$531badb89cf01312 = {
    prefix: "far",
    iconName: "circle-down",
    icon: [
        512,
        512,
        [
            61466,
            "arrow-alt-circle-down"
        ],
        "f358",
        "M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM128 256l0 32L256 416 384 288l0-32-80 0 0-128-96 0 0 128-80 0z"
    ]
};
const $40b7be8cb53b06e9$export$ff3afbc8c0bc5d59 = $40b7be8cb53b06e9$export$531badb89cf01312;
const $40b7be8cb53b06e9$export$aba24ca305bbe8c1 = {
    prefix: "far",
    iconName: "thumbs-down",
    icon: [
        512,
        512,
        [
            128078,
            61576
        ],
        "f165",
        "M323.8 477.2c-38.2 10.9-78.1-11.2-89-49.4l-5.7-20c-3.7-13-10.4-25-19.5-35l-51.3-56.4c-8.9-9.8-8.2-25 1.6-33.9s25-8.2 33.9 1.6l51.3 56.4c14.1 15.5 24.4 34 30.1 54.1l5.7 20c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7l-5.7-20c-5.7-19.9-14.7-38.7-26.6-55.5c-5.2-7.3-5.8-16.9-1.7-24.9s12.3-13 21.3-13L448 288c8.8 0 16-7.2 16-16c0-6.8-4.3-12.7-10.4-15c-7.4-2.8-13-9-14.9-16.7s.1-15.8 5.3-21.7c2.5-2.8 4-6.5 4-10.6c0-7.8-5.6-14.3-13-15.7c-8.2-1.6-15.1-7.3-18-15.2s-1.6-16.7 3.6-23.3c2.1-2.7 3.4-6.1 3.4-9.9c0-6.7-4.2-12.6-10.2-14.9c-11.5-4.5-17.7-16.9-14.4-28.8c.4-1.3 .6-2.8 .6-4.3c0-8.8-7.2-16-16-16l-97.5 0c-12.6 0-25 3.7-35.5 10.7l-61.7 41.1c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l61.7-41.1c18.4-12.3 40-18.8 62.1-18.8L384 32c34.7 0 62.9 27.6 64 62c14.6 11.7 24 29.7 24 50c0 4.5-.5 8.8-1.3 13c15.4 11.7 25.3 30.2 25.3 51c0 6.5-1 12.8-2.8 18.7C504.8 238.3 512 254.3 512 272c0 35.3-28.6 64-64 64l-92.3 0c4.7 10.4 8.7 21.2 11.8 32.2l5.7 20c10.9 38.2-11.2 78.1-49.4 89zM32 384c-17.7 0-32-14.3-32-32L0 128c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 224c0 17.7-14.3 32-32 32l-64 0z"
    ]
};
const $40b7be8cb53b06e9$export$3db75d5ac9e98468 = {
    prefix: "far",
    iconName: "chess-pawn",
    icon: [
        320,
        512,
        [
            9823
        ],
        "f443",
        "M232 152A72 72 0 1 0 88 152a72 72 0 1 0 144 0zm24 120l-12.6 0 10.7 80-48.4 0L195 272l-35 0-35 0-10.7 80-48.4 0 10.7-80L64 272c-13.3 0-24-10.7-24-24s10.7-24 24-24c-15.1-20.1-24-45-24-72C40 85.7 93.7 32 160 32s120 53.7 120 120c0 27-8.9 51.9-24 72c13.3 0 24 10.7 24 24s-10.7 24-24 24zM52.7 464l214.7 0-16.6-32L69.2 432 52.7 464zm207.9-80c12 0 22.9 6.7 28.4 17.3l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8L40.8 512C18.2 512 0 493.8 0 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C36.5 390.7 47.5 384 59.5 384l201 0z"
    ]
};
const $40b7be8cb53b06e9$export$3e7437bf6535bef0 = {
    prefix: "far",
    iconName: "credit-card",
    icon: [
        576,
        512,
        [
            128179,
            62083,
            "credit-card-alt"
        ],
        "f09d",
        "M512 80c8.8 0 16 7.2 16 16l0 32L48 128l0-32c0-8.8 7.2-16 16-16l448 0zm16 144l0 192c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-192 480 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm56 304c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0z"
    ]
};
const $40b7be8cb53b06e9$export$5fffe8e3c36964a2 = $40b7be8cb53b06e9$export$3e7437bf6535bef0;
const $40b7be8cb53b06e9$export$9b6162797ab1b255 = {
    prefix: "far",
    iconName: "bell",
    icon: [
        448,
        512,
        [
            128276,
            61602
        ],
        "f0f3",
        "M224 0c-17.7 0-32 14.3-32 32l0 19.2C119 66 64 130.6 64 208l0 25.4c0 45.4-15.5 89.5-43.8 124.9L5.3 377c-5.8 7.2-6.9 17.1-2.9 25.4S14.8 416 24 416l400 0c9.2 0 17.6-5.3 21.6-13.6s2.9-18.2-2.9-25.4l-14.9-18.6C399.5 322.9 384 278.8 384 233.4l0-25.4c0-77.4-55-142-128-156.8L256 32c0-17.7-14.3-32-32-32zm0 96c61.9 0 112 50.1 112 112l0 25.4c0 47.9 13.9 94.6 39.7 134.6L72.3 368C98.1 328 112 281.3 112 233.4l0-25.4c0-61.9 50.1-112 112-112zm64 352l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z"
    ]
};
const $40b7be8cb53b06e9$export$cad54bead856a678 = {
    prefix: "far",
    iconName: "file",
    icon: [
        384,
        512,
        [
            128196,
            128459,
            61462
        ],
        "f15b",
        "M320 464c8.8 0 16-7.2 16-16l0-288-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0zM0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64z"
    ]
};
const $40b7be8cb53b06e9$export$7a76c9d35b42d691 = {
    prefix: "far",
    iconName: "hospital",
    icon: [
        640,
        512,
        [
            127973,
            62589,
            "hospital-alt",
            "hospital-wide"
        ],
        "f0f8",
        "M232 0c-39.8 0-72 32.2-72 72l0 8L72 80C32.2 80 0 112.2 0 152L0 440c0 39.8 32.2 72 72 72l.2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0s0 0 0 0l272 0 8 0s0 0 0 0l104 0c39.8 0 72-32.2 72-72l0-288c0-39.8-32.2-72-72-72l-88 0 0-8c0-39.8-32.2-72-72-72L232 0zM480 128l88 0c13.3 0 24 10.7 24 24l0 40-56 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l56 0 0 48-56 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l56 0 0 104c0 13.3-10.7 24-24 24l-88 0 0-128 0-208zM72 128l88 0 0 336c0 0 0 0-.1 0l-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0c-13.2 0-24-10.7-24-24l0-104 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0 0-48 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0 0-40c0-13.3 10.7-24 24-24zM208 72c0-13.3 10.7-24 24-24l176 0c13.3 0 24 10.7 24 24l0 264 0 128-64 0 0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 64-64 0 0-392zm88 24l0 24-24 0c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l24 0 0 24c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-24 24 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-24 0 0-24c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16z"
    ]
};
const $40b7be8cb53b06e9$export$cea7736417b94a3b = $40b7be8cb53b06e9$export$7a76c9d35b42d691;
const $40b7be8cb53b06e9$export$69c8cc0360f017e8 = $40b7be8cb53b06e9$export$7a76c9d35b42d691;
const $40b7be8cb53b06e9$export$5d65c40a109eb09c = {
    prefix: "far",
    iconName: "chess-rook",
    icon: [
        448,
        512,
        [
            9820
        ],
        "f447",
        "M80 80l0 112c0 2.5 1.2 4.9 3.2 6.4l51.2 38.4c6.8 5.1 10.4 13.4 9.5 21.9L133.5 352l-48.3 0 9.4-85L54.4 236.8C40.3 226.2 32 209.6 32 192L32 72c0-22.1 17.9-40 40-40l304 0c22.1 0 40 17.9 40 40l0 120c0 17.6-8.3 34.2-22.4 44.8L353.4 267l9.4 85-48.3 0-10.4-93.3c-.9-8.4 2.7-16.8 9.5-21.9l51.2-38.4c2-1.5 3.2-3.9 3.2-6.4l0-112-64 0 0 24c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-24-64 0 0 24c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-24L80 80zm4.7 384l278.7 0-16.6-32-245.6 0L84.7 464zm271.9-80c12 0 22.9 6.7 28.4 17.3l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8L72.8 512C50.2 512 32 493.8 32 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C68.5 390.7 79.5 384 91.5 384l265 0zM208 288c-8.8 0-16-7.2-16-16l0-48c0-17.7 14.3-32 32-32s32 14.3 32 32l0 48c0 8.8-7.2 16-16 16l-32 0z"
    ]
};
const $40b7be8cb53b06e9$export$228008b5e11032fa = {
    prefix: "far",
    iconName: "star-half",
    icon: [
        576,
        512,
        [
            61731
        ],
        "f089",
        "M293.3 .6c10.9 2.5 18.6 12.2 18.6 23.4l0 384.7c0 8.9-4.9 17-12.7 21.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.3c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5c4.9-10.1 16.1-15.4 27-12.9zM263.9 128.4l-28.6 58.8c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l92.5-49.4 0-265.9z"
    ]
};
const $40b7be8cb53b06e9$export$d5713874f8fefe1b = {
    prefix: "far",
    iconName: "chess-king",
    icon: [
        448,
        512,
        [
            9818
        ],
        "f43f",
        "M248 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 32-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 0 40L59.6 144C26.7 144 0 170.7 0 203.6c0 8.2 1.7 16.3 4.9 23.8L59.1 352l52.3 0L49 208.2c-.6-1.5-1-3-1-4.6c0-6.4 5.2-11.6 11.6-11.6L224 192l164.4 0c6.4 0 11.6 5.2 11.6 11.6c0 1.6-.3 3.2-1 4.6L336.5 352l52.3 0 54.2-124.6c3.3-7.5 4.9-15.6 4.9-23.8c0-32.9-26.7-59.6-59.6-59.6L248 144l0-40 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0 0-32zM101.2 432l245.6 0 16.6 32L84.7 464l16.6-32zm283.7-30.7c-5.5-10.6-16.5-17.3-28.4-17.3l-265 0c-12 0-22.9 6.7-28.4 17.3L36.6 452.5c-3 5.8-4.6 12.2-4.6 18.7C32 493.8 50.2 512 72.8 512l302.5 0c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2z"
    ]
};
const $40b7be8cb53b06e9$export$9a5c11a5e3d7f1e7 = {
    prefix: "far",
    iconName: "circle-user",
    icon: [
        512,
        512,
        [
            62142,
            "user-circle"
        ],
        "f2bd",
        "M406.5 399.6C387.4 352.9 341.5 320 288 320l-64 0c-53.5 0-99.4 32.9-118.5 79.6C69.9 362.2 48 311.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 55.7-21.9 106.2-57.5 143.6zm-40.1 32.7C334.4 452.4 296.6 464 256 464s-78.4-11.6-110.5-31.7c7.3-36.7 39.7-64.3 78.5-64.3l64 0c38.8 0 71.2 27.6 78.5 64.3zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-272a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm-88-40a88 88 0 1 0 176 0 88 88 0 1 0 -176 0z"
    ]
};
const $40b7be8cb53b06e9$export$be7d974e9e0dba1a = $40b7be8cb53b06e9$export$9a5c11a5e3d7f1e7;
const $40b7be8cb53b06e9$export$e9bd786d30cb716c = {
    prefix: "far",
    iconName: "copy",
    icon: [
        448,
        512,
        [],
        "f0c5",
        "M384 336l-192 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l140.1 0L400 115.9 400 320c0 8.8-7.2 16-16 16zM192 384l192 0c35.3 0 64-28.7 64-64l0-204.1c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1L192 0c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-32-48 0 0 32c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l32 0 0-48-32 0z"
    ]
};
const $40b7be8cb53b06e9$export$928280bdd54fa173 = {
    prefix: "far",
    iconName: "share-from-square",
    icon: [
        576,
        512,
        [
            61509,
            "share-square"
        ],
        "f14d",
        "M400 255.4l0-15.4 0-32c0-8.8-7.2-16-16-16l-32 0-16 0-46.5 0c-50.9 0-93.9 33.5-108.3 79.6c-3.3-9.4-5.2-19.8-5.2-31.6c0-61.9 50.1-112 112-112l48 0 16 0 32 0c8.8 0 16-7.2 16-16l0-32 0-15.4L506 160 400 255.4zM336 240l16 0 0 48c0 17.7 14.3 32 32 32l3.7 0c7.9 0 15.5-2.9 21.4-8.2l139-125.1c7.6-6.8 11.9-16.5 11.9-26.7s-4.3-19.9-11.9-26.7L409.9 8.9C403.5 3.2 395.3 0 386.7 0C367.5 0 352 15.5 352 34.7L352 80l-16 0-32 0-16 0c-88.4 0-160 71.6-160 160c0 60.4 34.6 99.1 63.9 120.9c5.9 4.4 11.5 8.1 16.7 11.2c4.4 2.7 8.5 4.9 11.9 6.6c3.4 1.7 6.2 3 8.2 3.9c2.2 1 4.6 1.4 7.1 1.4l2.5 0c9.8 0 17.8-8 17.8-17.8c0-7.8-5.3-14.7-11.6-19.5c0 0 0 0 0 0c-.4-.3-.7-.5-1.1-.8c-1.7-1.1-3.4-2.5-5-4.1c-.8-.8-1.7-1.6-2.5-2.6s-1.6-1.9-2.4-2.9c-1.8-2.5-3.5-5.3-5-8.5c-2.6-6-4.3-13.3-4.3-22.4c0-36.1 29.3-65.5 65.5-65.5l14.5 0 32 0zM72 32C32.2 32 0 64.2 0 104L0 440c0 39.8 32.2 72 72 72l336 0c39.8 0 72-32.2 72-72l0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64c0 13.3-10.7 24-24 24L72 464c-13.3 0-24-10.7-24-24l0-336c0-13.3 10.7-24 24-24l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 32z"
    ]
};
const $40b7be8cb53b06e9$export$ae9e1434571f373c = $40b7be8cb53b06e9$export$928280bdd54fa173;
const $40b7be8cb53b06e9$export$da61665fff8aebfe = {
    prefix: "far",
    iconName: "copyright",
    icon: [
        512,
        512,
        [
            169
        ],
        "f1f9",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM199.4 312.6c-31.2-31.2-31.2-81.9 0-113.1s81.9-31.2 113.1 0c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9c-50-50-131-50-181 0s-50 131 0 181s131 50 181 0c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0c-31.2 31.2-81.9 31.2-113.1 0z"
    ]
};
const $40b7be8cb53b06e9$export$fc82fb79180cd17c = {
    prefix: "far",
    iconName: "map",
    icon: [
        576,
        512,
        [
            128506,
            62072
        ],
        "f279",
        "M565.6 36.2C572.1 40.7 576 48.1 576 56l0 336c0 10-6.2 18.9-15.5 22.4l-168 64c-5.2 2-10.9 2.1-16.1 .3L192.5 417.5l-160 61c-7.4 2.8-15.7 1.8-22.2-2.7S0 463.9 0 456L0 120c0-10 6.1-18.9 15.5-22.4l168-64c5.2-2 10.9-2.1 16.1-.3L383.5 94.5l160-61c7.4-2.8 15.7-1.8 22.2 2.7zM48 136.5l0 284.6 120-45.7 0-284.6L48 136.5zM360 422.7l0-285.4-144-48 0 285.4 144 48zm48-1.5l120-45.7 0-284.6L408 136.5l0 284.6z"
    ]
};
const $40b7be8cb53b06e9$export$6b31a1e5968b2378 = {
    prefix: "far",
    iconName: "bell-slash",
    icon: [
        640,
        512,
        [
            128277,
            61943
        ],
        "f1f6",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L542.6 400c2.7-7.8 1.3-16.5-3.9-23l-14.9-18.6C495.5 322.9 480 278.8 480 233.4l0-33.4c0-75.8-55.5-138.6-128-150.1L352 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 17.9c-43.9 7-81.5 32.7-104.4 68.7L38.8 5.1zM221.7 148.4C239.6 117.1 273.3 96 312 96l8 0 8 0c57.4 0 104 46.6 104 104l0 33.4c0 32.7 6.4 64.8 18.7 94.5L221.7 148.4zM406.2 416l-60.9-48-176.9 0c21.2-32.8 34.4-70.3 38.4-109.1L160 222.1l0 11.4c0 45.4-15.5 89.5-43.8 124.9L101.3 377c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6l286.2 0zM384 448l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z"
    ]
};
const $40b7be8cb53b06e9$export$54608d0a883fea4d = {
    prefix: "far",
    iconName: "hand-lizard",
    icon: [
        512,
        512,
        [],
        "f258",
        "M72 112c-13.3 0-24 10.7-24 24s10.7 24 24 24l168 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-104 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l152 0c4.5 0 8.9 1.3 12.7 3.6l64 40c7 4.4 11.3 12.1 11.3 20.4l0 24c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-10.7L281.1 384 136 384c-39.8 0-72-32.2-72-72s32.2-72 72-72l104 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L72 208c-39.8 0-72-32.2-72-72S32.2 64 72 64l209.6 0c46.7 0 90.9 21.5 119.7 58.3l78.4 100.1c20.9 26.7 32.3 59.7 32.3 93.7L512 424c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-107.9c0-23.2-7.8-45.8-22.1-64.1L363.5 151.9c-19.7-25.2-49.9-39.9-81.9-39.9L72 112z"
    ]
};
const $40b7be8cb53b06e9$export$b5023c446f10324 = {
    prefix: "far",
    iconName: "face-smile",
    icon: [
        512,
        512,
        [
            128578,
            "smile"
        ],
        "f118",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $40b7be8cb53b06e9$export$c632b2334f0913bc = $40b7be8cb53b06e9$export$b5023c446f10324;
const $40b7be8cb53b06e9$export$e49e3cfceea441cc = {
    prefix: "far",
    iconName: "hand-peace",
    icon: [
        512,
        512,
        [
            9996
        ],
        "f25b",
        "M250.8 1.4c-35.2-3.7-66.6 21.8-70.3 57L174 119 156.7 69.6C145 36.3 108.4 18.8 75.1 30.5S24.2 78.8 35.9 112.1L88.7 262.2C73.5 276.7 64 297.3 64 320c0 0 0 0 0 0l0 24c0 92.8 75.2 168 168 168l48 0c92.8 0 168-75.2 168-168l0-72 0-16 0-32c0-35.3-28.7-64-64-64c-7.9 0-15.4 1.4-22.4 4c-10.4-21.3-32.3-36-57.6-36c-.7 0-1.5 0-2.2 0l5.9-56.3c3.7-35.2-21.8-66.6-57-70.3zm-.2 155.4C243.9 166.9 240 179 240 192l0 48c0 .7 0 1.4 0 2c-5.1-1.3-10.5-2-16-2l-7.4 0-5.4-15.3 17-161.3c.9-8.8 8.8-15.2 17.6-14.2s15.2 8.8 14.2 17.6l-9.5 90.1zM111.4 85.6L165.7 240 144 240c-4 0-8 .3-11.9 .9L81.2 96.2c-2.9-8.3 1.5-17.5 9.8-20.4s17.5 1.5 20.4 9.8zM288 192c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48zm38.4 108c10.4 21.3 32.3 36 57.6 36c5.5 0 10.9-.7 16-2l0 10c0 66.3-53.7 120-120 120l-48 0c-66.3 0-120-53.7-120-120l0-24s0 0 0 0c0-17.7 14.3-32 32-32l80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0c35.3 0 64-28.7 64-64c0-.7 0-1.4 0-2c5.1 1.3 10.5 2 16 2c7.9 0 15.4-1.4 22.4-4zM400 272c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 0 16z"
    ]
};
const $40b7be8cb53b06e9$export$fbb22081b65e4f33 = {
    prefix: "far",
    iconName: "face-grin-hearts",
    icon: [
        512,
        512,
        [
            128525,
            "grin-hearts"
        ],
        "f584",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM215.3 137.1c17.8 4.8 28.4 23.1 23.6 40.8l-17.4 65c-2.3 8.5-11.1 13.6-19.6 11.3l-65.1-17.4c-17.8-4.8-28.4-23.1-23.6-40.8s23.1-28.4 40.8-23.6l16.1 4.3 4.3-16.1c4.8-17.8 23.1-28.4 40.8-23.6zm122.3 23.6l4.3 16.1 16.1-4.3c17.8-4.8 36.1 5.8 40.8 23.6s-5.8 36.1-23.6 40.8l-65.1 17.4c-8.5 2.3-17.3-2.8-19.6-11.3l-17.4-65c-4.8-17.8 5.8-36.1 23.6-40.8s36.1 5.8 40.9 23.6z"
    ]
};
const $40b7be8cb53b06e9$export$c56cf0e0c3bc5ed2 = $40b7be8cb53b06e9$export$fbb22081b65e4f33;
const $40b7be8cb53b06e9$export$f26673f8b10c3d46 = {
    prefix: "far",
    iconName: "building",
    icon: [
        384,
        512,
        [
            127970,
            61687
        ],
        "f1ad",
        "M64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l80 0 0-64c0-26.5 21.5-48 48-48s48 21.5 48 48l0 64 80 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm88 40c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48zM232 88l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16zM88 232c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48zm144-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16z"
    ]
};
const $40b7be8cb53b06e9$export$2ff38f330c834084 = {
    prefix: "far",
    iconName: "face-grin-beam-sweat",
    icon: [
        512,
        512,
        [
            128517,
            "grin-beam-sweat"
        ],
        "f583",
        "M476.8 126.3C497.1 120.8 512 102.7 512 81c0-20-28.6-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0c-9.5 12.6-27.1 37.2-36 57.5c-.3 .7-.6 1.4-.9 2.1C417.8 69.7 416 76 416 81c0 26 21.5 47 48 47c4.4 0 8.7-.6 12.8-1.7zM395.4 41.2C355.3 15.2 307.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-35.8-7.3-69.9-20.6-100.8c-8.6 3.1-17.8 4.8-27.4 4.8c-8.9 0-17.6-1.5-25.7-4.2C454.7 185.5 464 219.7 464 256c0 114.9-93.1 208-208 208S48 370.9 48 256S141.1 48 256 48c48.7 0 93.4 16.7 128.9 44.7c-.6-3.8-.9-7.7-.9-11.7c0-11.4 3.8-22.4 7.1-30.5c1.3-3.1 2.7-6.2 4.3-9.3zM375 336.5c10.4-16.1-6.8-32.5-25.5-28.1c-28.9 6.8-60.5 10.5-93.6 10.5s-64.7-3.7-93.6-10.5c-18.7-4.4-35.9 12-25.5 28.1c24.6 38.1 68.7 63.5 119.1 63.5s94.5-25.4 119.1-63.5zM217.6 228.8s0 0 0 0s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 188.4 120 206.1 120 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0zm160 0s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 188.4 280 206.1 280 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0c0 0 0 0 0 0z"
    ]
};
const $40b7be8cb53b06e9$export$14d0ccc54c5b6826 = $40b7be8cb53b06e9$export$2ff38f330c834084;
const $40b7be8cb53b06e9$export$c4c2f69a53bab720 = {
    prefix: "far",
    iconName: "moon",
    icon: [
        384,
        512,
        [
            127769,
            9214
        ],
        "f186",
        "M144.7 98.7c-21 34.1-33.1 74.3-33.1 117.3c0 98 62.8 181.4 150.4 211.7c-12.4 2.8-25.3 4.3-38.6 4.3C126.6 432 48 353.3 48 256c0-68.9 39.4-128.4 96.8-157.3zm62.1-66C91.1 41.2 0 137.9 0 256C0 379.7 100 480 223.5 480c47.8 0 92-15 128.4-40.6c1.9-1.3 3.7-2.7 5.5-4c4.8-3.6 9.4-7.4 13.9-11.4c2.7-2.4 5.3-4.8 7.9-7.3c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-3.7 .6-7.4 1.2-11.1 1.6c-5 .5-10.1 .9-15.3 1c-1.2 0-2.5 0-3.7 0l-.3 0c-96.8-.2-175.2-78.9-175.2-176c0-54.8 24.9-103.7 64.1-136c1-.9 2.1-1.7 3.2-2.6c4-3.2 8.2-6.2 12.5-9c3.1-2 6.3-4 9.6-5.8c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-3.6-.3-7.1-.5-10.7-.6c-2.7-.1-5.5-.1-8.2-.1c-3.3 0-6.5 .1-9.8 .2c-2.3 .1-4.6 .2-6.9 .4z"
    ]
};
const $40b7be8cb53b06e9$export$34f5c36a3e80efa2 = {
    prefix: "far",
    iconName: "calendar",
    icon: [
        448,
        512,
        [
            128197,
            128198
        ],
        "f133",
        "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256z"
    ]
};
const $40b7be8cb53b06e9$export$4272e56f2429da88 = {
    prefix: "far",
    iconName: "face-grin-tongue-wink",
    icon: [
        512,
        512,
        [
            128540,
            "grin-tongue-wink"
        ],
        "f58b",
        "M348.3 442.4c2.4-8.4 3.7-17.3 3.7-26.4l0-52.5c8.8-8 16.6-17.1 23-27c10.4-16.1-6.8-32.5-25.5-28.1c-28.9 6.8-60.5 10.5-93.6 10.5s-64.7-3.7-93.6-10.5c-18.7-4.4-35.9 12-25.5 28.1c6.5 10 14.3 19.1 23.1 27.1l0 52.4c0 9.2 1.3 18 3.7 26.4C95.1 408.4 48 337.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 81.7-47.1 152.4-115.7 186.4zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.6 220c10.6 0 19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C199.7 186.8 179 180 159.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zm176.7 12a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-.4-72a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM320 416c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-37.4c0-14.7 11.9-26.6 26.6-26.6l2 0c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9l2 0c14.7 0 26.6 11.9 26.6 26.6l0 37.4z"
    ]
};
const $40b7be8cb53b06e9$export$58099903d50aefb3 = $40b7be8cb53b06e9$export$4272e56f2429da88;
const $40b7be8cb53b06e9$export$76c1aa4bf9a39458 = {
    prefix: "far",
    iconName: "clone",
    icon: [
        512,
        512,
        [],
        "f24d",
        "M64 464l224 0c8.8 0 16-7.2 16-16l0-64 48 0 0 64c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 224c0-35.3 28.7-64 64-64l64 0 0 48-64 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16zM224 304l224 0c8.8 0 16-7.2 16-16l0-224c0-8.8-7.2-16-16-16L224 48c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16zm-64-16l0-224c0-35.3 28.7-64 64-64L448 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64z"
    ]
};
const $40b7be8cb53b06e9$export$67a047c738fb34da = {
    prefix: "far",
    iconName: "face-angry",
    icon: [
        512,
        512,
        [
            128544,
            "angry"
        ],
        "f556",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm72.4-118.5c9.7-9 10.2-24.2 1.2-33.9C315.3 344.3 290.6 328 256 328s-59.3 16.3-73.5 31.6c-9 9.7-8.5 24.9 1.2 33.9s24.9 8.5 33.9-1.2c7.4-7.9 20-16.4 38.5-16.4s31.1 8.5 38.5 16.4c9 9.7 24.2 10.2 33.9 1.2zM176.4 272c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z"
    ]
};
const $40b7be8cb53b06e9$export$3c96c08e234498c5 = $40b7be8cb53b06e9$export$67a047c738fb34da;
const $40b7be8cb53b06e9$export$3896694b3e81fba7 = {
    prefix: "far",
    iconName: "rectangle-xmark",
    icon: [
        512,
        512,
        [
            62164,
            "rectangle-times",
            "times-rectangle",
            "window-close"
        ],
        "f410",
        "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm175 79c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
const $40b7be8cb53b06e9$export$eaaf26416a51dc1 = $40b7be8cb53b06e9$export$3896694b3e81fba7;
const $40b7be8cb53b06e9$export$10147c0014152a3f = $40b7be8cb53b06e9$export$3896694b3e81fba7;
const $40b7be8cb53b06e9$export$18b7775f78a3e16 = $40b7be8cb53b06e9$export$3896694b3e81fba7;
const $40b7be8cb53b06e9$export$b5378818301da1be = {
    prefix: "far",
    iconName: "paper-plane",
    icon: [
        512,
        512,
        [
            61913
        ],
        "f1d8",
        "M16.1 260.2c-22.6 12.9-20.5 47.3 3.6 57.3L160 376l0 103.3c0 18.1 14.6 32.7 32.7 32.7c9.7 0 18.9-4.3 25.1-11.8l62-74.3 123.9 51.6c18.9 7.9 40.8-4.5 43.9-24.7l64-416c1.9-12.1-3.4-24.3-13.5-31.2s-23.3-7.5-34-1.4l-448 256zm52.1 25.5L409.7 90.6 190.1 336l1.2 1L68.2 285.7zM403.3 425.4L236.7 355.9 450.8 116.6 403.3 425.4z"
    ]
};
const $40b7be8cb53b06e9$export$53dd2cacf674142a = {
    prefix: "far",
    iconName: "life-ring",
    icon: [
        512,
        512,
        [],
        "f1cd",
        "M385.1 419.1C349.7 447.2 304.8 464 256 464s-93.7-16.8-129.1-44.9l80.4-80.4c14.3 8.4 31 13.3 48.8 13.3s34.5-4.8 48.8-13.3l80.4 80.4zm68.1 .2C489.9 374.9 512 318.1 512 256s-22.1-118.9-58.8-163.3L465 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L419.3 58.8C374.9 22.1 318.1 0 256 0S137.1 22.1 92.7 58.8L81 47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L58.8 92.7C22.1 137.1 0 193.9 0 256s22.1 118.9 58.8 163.3L47 431c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l11.8-11.8C137.1 489.9 193.9 512 256 512s118.9-22.1 163.3-58.8L431 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-11.8-11.8zm-34.1-34.1l-80.4-80.4c8.4-14.3 13.3-31 13.3-48.8s-4.8-34.5-13.3-48.8l80.4-80.4C447.2 162.3 464 207.2 464 256s-16.8 93.7-44.9 129.1zM385.1 92.9l-80.4 80.4c-14.3-8.4-31-13.3-48.8-13.3s-34.5 4.8-48.8 13.3L126.9 92.9C162.3 64.8 207.2 48 256 48s93.7 16.8 129.1 44.9zM173.3 304.8L92.9 385.1C64.8 349.7 48 304.8 48 256s16.8-93.7 44.9-129.1l80.4 80.4c-8.4 14.3-13.3 31-13.3 48.8s4.8 34.5 13.3 48.8zM208 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"
    ]
};
const $40b7be8cb53b06e9$export$bd5bd2ef56b793b1 = {
    prefix: "far",
    iconName: "face-grimace",
    icon: [
        512,
        512,
        [
            128556,
            "grimace"
        ],
        "f57f",
        "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM168 320c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0-48-8 0zm40 48l32 0 0-48-32 0 0 48zm96 0l0-48-32 0 0 48 32 0zm32 0l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0 48zM168 288l176 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-176 0c-30.9 0-56-25.1-56-56s25.1-56 56-56zm-23.6-80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $40b7be8cb53b06e9$export$3d08cd36ac1ef231 = $40b7be8cb53b06e9$export$bd5bd2ef56b793b1;
const $40b7be8cb53b06e9$export$23e8b4955c2d951b = {
    prefix: "far",
    iconName: "calendar-minus",
    icon: [
        448,
        512,
        [],
        "f272",
        "M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM400 192L48 192l0 256c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-256zM296 352l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24z"
    ]
};
const $40b7be8cb53b06e9$export$30262489773a79a3 = {
    prefix: "far",
    iconName: "circle-xmark",
    icon: [
        512,
        512,
        [
            61532,
            "times-circle",
            "xmark-circle"
        ],
        "f057",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"
    ]
};
const $40b7be8cb53b06e9$export$ab0ec50720a747eb = $40b7be8cb53b06e9$export$30262489773a79a3;
const $40b7be8cb53b06e9$export$90ac4096df8efdee = $40b7be8cb53b06e9$export$30262489773a79a3;
const $40b7be8cb53b06e9$export$47e4e0d519d33497 = {
    prefix: "far",
    iconName: "thumbs-up",
    icon: [
        512,
        512,
        [
            128077,
            61575
        ],
        "f164",
        "M323.8 34.8c-38.2-10.9-78.1 11.2-89 49.4l-5.7 20c-3.7 13-10.4 25-19.5 35l-51.3 56.4c-8.9 9.8-8.2 25 1.6 33.9s25 8.2 33.9-1.6l51.3-56.4c14.1-15.5 24.4-34 30.1-54.1l5.7-20c3.6-12.7 16.9-20.1 29.7-16.5s20.1 16.9 16.5 29.7l-5.7 20c-5.7 19.9-14.7 38.7-26.6 55.5c-5.2 7.3-5.8 16.9-1.7 24.9s12.3 13 21.3 13L448 224c8.8 0 16 7.2 16 16c0 6.8-4.3 12.7-10.4 15c-7.4 2.8-13 9-14.9 16.7s.1 15.8 5.3 21.7c2.5 2.8 4 6.5 4 10.6c0 7.8-5.6 14.3-13 15.7c-8.2 1.6-15.1 7.3-18 15.2s-1.6 16.7 3.6 23.3c2.1 2.7 3.4 6.1 3.4 9.9c0 6.7-4.2 12.6-10.2 14.9c-11.5 4.5-17.7 16.9-14.4 28.8c.4 1.3 .6 2.8 .6 4.3c0 8.8-7.2 16-16 16l-97.5 0c-12.6 0-25-3.7-35.5-10.7l-61.7-41.1c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l61.7 41.1c18.4 12.3 40 18.8 62.1 18.8l97.5 0c34.7 0 62.9-27.6 64-62c14.6-11.7 24-29.7 24-50c0-4.5-.5-8.8-1.3-13c15.4-11.7 25.3-30.2 25.3-51c0-6.5-1-12.8-2.8-18.7C504.8 273.7 512 257.7 512 240c0-35.3-28.6-64-64-64l-92.3 0c4.7-10.4 8.7-21.2 11.8-32.2l5.7-20c10.9-38.2-11.2-78.1-49.4-89zM32 192c-17.7 0-32 14.3-32 32L0 448c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32l-64 0z"
    ]
};
const $40b7be8cb53b06e9$export$26a3f9d2784b90d8 = {
    prefix: "far",
    iconName: "window-minimize",
    icon: [
        512,
        512,
        [
            128469
        ],
        "f2d1",
        "M24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 432z"
    ]
};
const $40b7be8cb53b06e9$export$7ec6541fee081990 = {
    prefix: "far",
    iconName: "square-full",
    icon: [
        512,
        512,
        [
            128997,
            128998,
            128999,
            129000,
            129001,
            129002,
            129003,
            11035,
            11036
        ],
        "f45c",
        "M464 48l0 416L48 464 48 48l416 0zM48 0L0 0 0 48 0 464l0 48 48 0 416 0 48 0 0-48 0-416 0-48L464 0 48 0z"
    ]
};
const $40b7be8cb53b06e9$export$4a4e034527c933f5 = {
    prefix: "far",
    iconName: "note-sticky",
    icon: [
        448,
        512,
        [
            62026,
            "sticky-note"
        ],
        "f249",
        "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l224 0 0-80c0-17.7 14.3-32 32-32l80 0 0-224c0-8.8-7.2-16-16-16L64 80zM288 480L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 224 0 5.5c0 17-6.7 33.3-18.7 45.3l-90.5 90.5c-12 12-28.3 18.7-45.3 18.7l-5.5 0z"
    ]
};
const $40b7be8cb53b06e9$export$80889adc5d98bf4a = $40b7be8cb53b06e9$export$4a4e034527c933f5;
const $40b7be8cb53b06e9$export$8a5a0dbb2a17e253 = {
    prefix: "far",
    iconName: "face-sad-tear",
    icon: [
        512,
        512,
        [
            128546,
            "sad-tear"
        ],
        "f5b4",
        "M175.9 448c-35-.1-65.5-22.6-76-54.6C67.6 356.8 48 308.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208s-93.1 208-208 208c-28.4 0-55.5-5.7-80.1-16zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM128 369c0 26 21.5 47 48 47s48-21 48-47c0-20-28.4-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0C156.6 308.6 128 349 128 369zm128-65c-13.3 0-24 10.7-24 24s10.7 24 24 24c30.7 0 58.7 11.5 80 30.6c9.9 8.8 25 8 33.9-1.9s8-25-1.9-33.9C338.3 320.2 299 304 256 304zm47.6-96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
const $40b7be8cb53b06e9$export$4b5241926f692f91 = $40b7be8cb53b06e9$export$8a5a0dbb2a17e253;
const $40b7be8cb53b06e9$export$b276ec3dc9760d39 = {
    prefix: "far",
    iconName: "hand-point-left",
    icon: [
        512,
        512,
        [],
        "f0a5",
        "M64 128l177.6 0c-1 5.2-1.6 10.5-1.6 16l0 16-32 0L64 160c-8.8 0-16-7.2-16-16s7.2-16 16-16zm224 16c0-17.7 14.3-32 32-32c0 0 0 0 0 0l24 0c66.3 0 120 53.7 120 120l0 48c0 52.5-33.7 97.1-80.7 113.4c.5-3.1 .7-6.2 .7-9.4c0-20-9.2-37.9-23.6-49.7c4.9-9 7.6-19.4 7.6-30.3c0-15.1-5.3-29-14-40c8.8-11 14-24.9 14-40l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-40 0-40zm32-80s0 0 0 0c-18 0-34.6 6-48 16L64 80C28.7 80 0 108.7 0 144s28.7 64 64 64l82 0c-1.3 5.1-2 10.5-2 16c0 25.3 14.7 47.2 36 57.6c-2.6 7-4 14.5-4 22.4c0 20 9.2 37.9 23.6 49.7c-4.9 9-7.6 19.4-7.6 30.3c0 35.3 28.7 64 64 64l64 0 24 0c92.8 0 168-75.2 168-168l0-48c0-92.8-75.2-168-168-168l-24 0zM256 400c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0zM240 224c0 5.5 .7 10.9 2 16l-2 0-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0 16zm24 64l40 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l24 0z"
    ]
};
var $40b7be8cb53b06e9$export$f9059ea71e16fa16 = {
    faTrashCan: $40b7be8cb53b06e9$export$864bb8d6c21fb792,
    faTrashAlt: $40b7be8cb53b06e9$export$88df7ff7eb32f9dc,
    faMessage: $40b7be8cb53b06e9$export$6563a67224e7f879,
    faCommentAlt: $40b7be8cb53b06e9$export$6e96904d9af0ec4a,
    faFileLines: $40b7be8cb53b06e9$export$ef565d07efe2b5e9,
    faFileAlt: $40b7be8cb53b06e9$export$243b47dca32bf0b8,
    faFileText: $40b7be8cb53b06e9$export$f466100bf9bf37a5,
    faCalendarDays: $40b7be8cb53b06e9$export$31c6cf6f5d38dc0,
    faCalendarAlt: $40b7be8cb53b06e9$export$cbc139f33cff356,
    faHandPointRight: $40b7be8cb53b06e9$export$f7bc8714c970afa4,
    faFaceSmileBeam: $40b7be8cb53b06e9$export$e3c56ed54f074063,
    faSmileBeam: $40b7be8cb53b06e9$export$54ada6dc9690e0ca,
    faFaceGrinStars: $40b7be8cb53b06e9$export$1d1fbac384a76a12,
    faGrinStars: $40b7be8cb53b06e9$export$64347a5c8c402ef4,
    faAddressBook: $40b7be8cb53b06e9$export$853fd1561789e3bb,
    faContactBook: $40b7be8cb53b06e9$export$594b5a5d4d2e156b,
    faComments: $40b7be8cb53b06e9$export$932912e74adb8939,
    faPaste: $40b7be8cb53b06e9$export$6f95f90dd1f6d86b,
    faFileClipboard: $40b7be8cb53b06e9$export$ca3229c47de163fa,
    faFaceGrinTongueSquint: $40b7be8cb53b06e9$export$8eee2c17ff89e724,
    faGrinTongueSquint: $40b7be8cb53b06e9$export$4edf34c3def09a31,
    faFaceFlushed: $40b7be8cb53b06e9$export$ba5dc4287853ecbd,
    faFlushed: $40b7be8cb53b06e9$export$dfd2bd012685aeac,
    faSquareCaretRight: $40b7be8cb53b06e9$export$5b1d41cdd118ea6d,
    faCaretSquareRight: $40b7be8cb53b06e9$export$ae86c9de7e0f62fa,
    faSquareMinus: $40b7be8cb53b06e9$export$814c9edba7b84aa4,
    faMinusSquare: $40b7be8cb53b06e9$export$ffe9387966b3e681,
    faCompass: $40b7be8cb53b06e9$export$b4d344633433e50e,
    faSquareCaretDown: $40b7be8cb53b06e9$export$a1ab39cd66c4e50e,
    faCaretSquareDown: $40b7be8cb53b06e9$export$61aea18df1c84401,
    faFaceKissBeam: $40b7be8cb53b06e9$export$eca99665af566fe1,
    faKissBeam: $40b7be8cb53b06e9$export$d6ff8a73c0812e63,
    faLightbulb: $40b7be8cb53b06e9$export$1e80f89fe84a215b,
    faFlag: $40b7be8cb53b06e9$export$6591b1ea509be9da,
    faSquareCheck: $40b7be8cb53b06e9$export$5bb6a0c94ad2f4bb,
    faCheckSquare: $40b7be8cb53b06e9$export$f0c8040f596df7fe,
    faCircleDot: $40b7be8cb53b06e9$export$aa13d9234890e8d3,
    faDotCircle: $40b7be8cb53b06e9$export$92bc269cb244d66a,
    faFaceDizzy: $40b7be8cb53b06e9$export$635e4d8cc8428961,
    faDizzy: $40b7be8cb53b06e9$export$89a2b10dabc487e8,
    faFutbol: $40b7be8cb53b06e9$export$65a345b33858a655,
    faFutbolBall: $40b7be8cb53b06e9$export$51a344ca0a215620,
    faSoccerBall: $40b7be8cb53b06e9$export$f4a29712c724ba2d,
    faPenToSquare: $40b7be8cb53b06e9$export$ba236543926e3569,
    faEdit: $40b7be8cb53b06e9$export$7be713e57d023733,
    faHourglassHalf: $40b7be8cb53b06e9$export$703272eebf5e3eea,
    faHourglass2: $40b7be8cb53b06e9$export$f1052bbf6bf361c0,
    faEyeSlash: $40b7be8cb53b06e9$export$ed3f2918429d029a,
    faHand: $40b7be8cb53b06e9$export$f69db0b876f7d753,
    faHandPaper: $40b7be8cb53b06e9$export$6e6216c8b50471bb,
    faHandSpock: $40b7be8cb53b06e9$export$2262d6b626de1120,
    faFaceKiss: $40b7be8cb53b06e9$export$5a54c83033a0a56a,
    faKiss: $40b7be8cb53b06e9$export$c762a77aabf64fd0,
    faFaceGrinTongue: $40b7be8cb53b06e9$export$95a7394c24f57943,
    faGrinTongue: $40b7be8cb53b06e9$export$ef222816a43a4b3a,
    faChessBishop: $40b7be8cb53b06e9$export$a831eedd2f59c62f,
    faFaceGrinWink: $40b7be8cb53b06e9$export$1dd161850c5bc64e,
    faGrinWink: $40b7be8cb53b06e9$export$2397fcd34eb12177,
    faFaceGrinWide: $40b7be8cb53b06e9$export$bdbabf493c478cde,
    faGrinAlt: $40b7be8cb53b06e9$export$b4abebfe416d36ba,
    faFaceFrownOpen: $40b7be8cb53b06e9$export$c8a28356e07b9ccb,
    faFrownOpen: $40b7be8cb53b06e9$export$c4775e66bed5d96,
    faHandPointUp: $40b7be8cb53b06e9$export$cdc9f5e7e94e76da,
    faBookmark: $40b7be8cb53b06e9$export$4ed9da5c3cca0ef1,
    faHandPointDown: $40b7be8cb53b06e9$export$f6dcbf0a940428f4,
    faFolder: $40b7be8cb53b06e9$export$72b780186370e953,
    faFolderBlank: $40b7be8cb53b06e9$export$9ef114244d26da0,
    faUser: $40b7be8cb53b06e9$export$f5699fa0844e0188,
    faSquareCaretLeft: $40b7be8cb53b06e9$export$2c5163541229363,
    faCaretSquareLeft: $40b7be8cb53b06e9$export$d0c8ba444f1f9581,
    faStar: $40b7be8cb53b06e9$export$a3b0eb2cd7942125,
    faChessKnight: $40b7be8cb53b06e9$export$861b1f13085cf122,
    faFaceLaughSquint: $40b7be8cb53b06e9$export$67ca89c1ca38d559,
    faLaughSquint: $40b7be8cb53b06e9$export$b206e700cf7084e1,
    faFaceLaugh: $40b7be8cb53b06e9$export$2f203616c892d415,
    faLaugh: $40b7be8cb53b06e9$export$6c74e314e801a4fe,
    faFolderOpen: $40b7be8cb53b06e9$export$ff7e93418af88b78,
    faClipboard: $40b7be8cb53b06e9$export$97d84347d71ba297,
    faChessQueen: $40b7be8cb53b06e9$export$7b8ce73615739d30,
    faHandBackFist: $40b7be8cb53b06e9$export$be38a892fe9b4098,
    faHandRock: $40b7be8cb53b06e9$export$97a81eba394c8c44,
    faSquareCaretUp: $40b7be8cb53b06e9$export$66068918abb14406,
    faCaretSquareUp: $40b7be8cb53b06e9$export$307ae80b26533ce5,
    faChartBar: $40b7be8cb53b06e9$export$b532f5d25de97633,
    faBarChart: $40b7be8cb53b06e9$export$2d5f754a5e5738b,
    faWindowRestore: $40b7be8cb53b06e9$export$eccfff9bfd585652,
    faSquarePlus: $40b7be8cb53b06e9$export$eaf727acca5a35e4,
    faPlusSquare: $40b7be8cb53b06e9$export$b6359eebfe900c35,
    faImage: $40b7be8cb53b06e9$export$7e9f0928967e03b,
    faFolderClosed: $40b7be8cb53b06e9$export$5e30548b7f8eeb95,
    faLemon: $40b7be8cb53b06e9$export$4fbda8f64648f3b5,
    faHandshake: $40b7be8cb53b06e9$export$b4c63e9bfc7906f1,
    faGem: $40b7be8cb53b06e9$export$31ee86ac717db552,
    faCirclePlay: $40b7be8cb53b06e9$export$86c4e45dc3302d15,
    faPlayCircle: $40b7be8cb53b06e9$export$cf04333781061c5e,
    faCircleCheck: $40b7be8cb53b06e9$export$c2e9877668862374,
    faCheckCircle: $40b7be8cb53b06e9$export$be9e388158c74f29,
    faCircleStop: $40b7be8cb53b06e9$export$229de76dfef2687f,
    faStopCircle: $40b7be8cb53b06e9$export$47af2aad60ab3e7c,
    faIdBadge: $40b7be8cb53b06e9$export$a75288855ea05282,
    faFaceLaughBeam: $40b7be8cb53b06e9$export$3f2d51c0547bf984,
    faLaughBeam: $40b7be8cb53b06e9$export$a88d1f4073ea9369,
    faRegistered: $40b7be8cb53b06e9$export$5f519e9ac15ab8c3,
    faAddressCard: $40b7be8cb53b06e9$export$6ea408c7266ed557,
    faContactCard: $40b7be8cb53b06e9$export$4ac51eb0b298b190,
    faVcard: $40b7be8cb53b06e9$export$91228257deb1bf18,
    faFaceTired: $40b7be8cb53b06e9$export$5352cbdc070ce8d,
    faTired: $40b7be8cb53b06e9$export$3d016d62cda18371,
    faFontAwesome: $40b7be8cb53b06e9$export$aa4baaed1c60f58d,
    faFontAwesomeFlag: $40b7be8cb53b06e9$export$102c25fde54d4843,
    faFontAwesomeLogoFull: $40b7be8cb53b06e9$export$6e20d421a2e0f320,
    faFaceSmileWink: $40b7be8cb53b06e9$export$6143da800b0e6626,
    faSmileWink: $40b7be8cb53b06e9$export$f5dbb37f6801ee3f,
    faFileWord: $40b7be8cb53b06e9$export$f0858dff6e769cf6,
    faFilePowerpoint: $40b7be8cb53b06e9$export$c341daeecdea449a,
    faEnvelopeOpen: $40b7be8cb53b06e9$export$c6c3bd5f7d9b8bf2,
    faFileZipper: $40b7be8cb53b06e9$export$7a4a0e4caa1e4e6f,
    faFileArchive: $40b7be8cb53b06e9$export$bf2047a9946b5c3f,
    faSquare: $40b7be8cb53b06e9$export$90b4406457aae8cc,
    faSnowflake: $40b7be8cb53b06e9$export$bab8f3647c394f48,
    faNewspaper: $40b7be8cb53b06e9$export$d91b374112d4f8c1,
    faFaceKissWinkHeart: $40b7be8cb53b06e9$export$611ae61f02de0aa,
    faKissWinkHeart: $40b7be8cb53b06e9$export$ebba617701dfb917,
    faStarHalfStroke: $40b7be8cb53b06e9$export$3e4892d8bf919edd,
    faStarHalfAlt: $40b7be8cb53b06e9$export$c13575f42532efb3,
    faFileExcel: $40b7be8cb53b06e9$export$77cb1a465c4fe84,
    faFaceGrinBeam: $40b7be8cb53b06e9$export$3de52eeb00462407,
    faGrinBeam: $40b7be8cb53b06e9$export$734da5249381ec7e,
    faObjectUngroup: $40b7be8cb53b06e9$export$887f6345573abcac,
    faCircleRight: $40b7be8cb53b06e9$export$1fec48c8bdd69c1d,
    faArrowAltCircleRight: $40b7be8cb53b06e9$export$88962ffdad8b856d,
    faFaceRollingEyes: $40b7be8cb53b06e9$export$a6d72a9a068392b5,
    faMehRollingEyes: $40b7be8cb53b06e9$export$fdc62a1bea767cc2,
    faObjectGroup: $40b7be8cb53b06e9$export$40cdac24aa94a57a,
    faHeart: $40b7be8cb53b06e9$export$e4b51a47a2f8b9db,
    faFaceSurprise: $40b7be8cb53b06e9$export$c938968e28178994,
    faSurprise: $40b7be8cb53b06e9$export$46647c72213f53ba,
    faCirclePause: $40b7be8cb53b06e9$export$fbeef2513e05ad08,
    faPauseCircle: $40b7be8cb53b06e9$export$d8cf08a0362da8db,
    faCircle: $40b7be8cb53b06e9$export$4280b2387fbdad12,
    faCircleUp: $40b7be8cb53b06e9$export$72ea8a5e4e86cd69,
    faArrowAltCircleUp: $40b7be8cb53b06e9$export$3747a8ef0995eadf,
    faFileAudio: $40b7be8cb53b06e9$export$b8d24c57c9e64933,
    faFileImage: $40b7be8cb53b06e9$export$6440b286d3cbac9b,
    faCircleQuestion: $40b7be8cb53b06e9$export$d7cf0978afd90002,
    faQuestionCircle: $40b7be8cb53b06e9$export$5ba67d7f2265c1a5,
    faFaceMehBlank: $40b7be8cb53b06e9$export$38c072b870a9e4ab,
    faMehBlank: $40b7be8cb53b06e9$export$e945435725f71e88,
    faEye: $40b7be8cb53b06e9$export$b8c3e79e8c99c95b,
    faFaceSadCry: $40b7be8cb53b06e9$export$e8ea88c55e55be7c,
    faSadCry: $40b7be8cb53b06e9$export$8e924e6bd422cef9,
    faFileCode: $40b7be8cb53b06e9$export$143d0ca7d2200f20,
    faWindowMaximize: $40b7be8cb53b06e9$export$703cd98be31ec905,
    faFaceFrown: $40b7be8cb53b06e9$export$e5f78e87efbb0248,
    faFrown: $40b7be8cb53b06e9$export$43b7108508aecc5f,
    faFloppyDisk: $40b7be8cb53b06e9$export$f62f2879ccaea13f,
    faSave: $40b7be8cb53b06e9$export$1aaa83ff70706e1e,
    faCommentDots: $40b7be8cb53b06e9$export$63ffcb3d4e94cb92,
    faCommenting: $40b7be8cb53b06e9$export$49ee382a2425e89c,
    faFaceGrinSquint: $40b7be8cb53b06e9$export$5d53da7627754bc6,
    faGrinSquint: $40b7be8cb53b06e9$export$243ae757907b1580,
    faHandPointer: $40b7be8cb53b06e9$export$d97ff927c450c87f,
    faHandScissors: $40b7be8cb53b06e9$export$c578e919f2c5c135,
    faFaceGrinTears: $40b7be8cb53b06e9$export$8ac6d81a3d5b40a1,
    faGrinTears: $40b7be8cb53b06e9$export$b2f7512221512b5b,
    faCalendarXmark: $40b7be8cb53b06e9$export$3c70ffe5660af060,
    faCalendarTimes: $40b7be8cb53b06e9$export$99b20d7352fbcf08,
    faFileVideo: $40b7be8cb53b06e9$export$b44eb38345c6a964,
    faFilePdf: $40b7be8cb53b06e9$export$38611f1c776aba73,
    faComment: $40b7be8cb53b06e9$export$805cd88398a70581,
    faEnvelope: $40b7be8cb53b06e9$export$6f095630677adc,
    faHourglass: $40b7be8cb53b06e9$export$b9098a890f61e022,
    faHourglassEmpty: $40b7be8cb53b06e9$export$a2f8176a0161e891,
    faCalendarCheck: $40b7be8cb53b06e9$export$5655108e1162ba45,
    faHardDrive: $40b7be8cb53b06e9$export$4cb736b866cbb7ec,
    faHdd: $40b7be8cb53b06e9$export$62551e9c5ba7093f,
    faFaceGrinSquintTears: $40b7be8cb53b06e9$export$8ff56f5ebb8416a0,
    faGrinSquintTears: $40b7be8cb53b06e9$export$542206d6a85f3b42,
    faRectangleList: $40b7be8cb53b06e9$export$1f7600fa9fdb3978,
    faListAlt: $40b7be8cb53b06e9$export$c6327a203ffc65a3,
    faCalendarPlus: $40b7be8cb53b06e9$export$16768a660ae3ca9d,
    faCircleLeft: $40b7be8cb53b06e9$export$5ae86b9da9cca3bd,
    faArrowAltCircleLeft: $40b7be8cb53b06e9$export$5460a5b11a24996f,
    faMoneyBill1: $40b7be8cb53b06e9$export$a312c7d58dd44a75,
    faMoneyBillAlt: $40b7be8cb53b06e9$export$a35d573395884c3d,
    faClock: $40b7be8cb53b06e9$export$95b9968e7fceb821,
    faClockFour: $40b7be8cb53b06e9$export$9a575facf1cab48f,
    faKeyboard: $40b7be8cb53b06e9$export$fb61df5d98785fa8,
    faClosedCaptioning: $40b7be8cb53b06e9$export$8e047801a8603af7,
    faImages: $40b7be8cb53b06e9$export$74f06b41ed2ca28a,
    faFaceGrin: $40b7be8cb53b06e9$export$92292137ef3cf4c8,
    faGrin: $40b7be8cb53b06e9$export$37e1f10b6de76621,
    faFaceMeh: $40b7be8cb53b06e9$export$dc130582748497c6,
    faMeh: $40b7be8cb53b06e9$export$6d2db489aaeeecd2,
    faIdCard: $40b7be8cb53b06e9$export$782ac893fc22249b,
    faDriversLicense: $40b7be8cb53b06e9$export$8359c70e609eff64,
    faSun: $40b7be8cb53b06e9$export$2fa35dcbc038dbe9,
    faFaceLaughWink: $40b7be8cb53b06e9$export$600a1b26b33c3d47,
    faLaughWink: $40b7be8cb53b06e9$export$77ac40095f39933e,
    faCircleDown: $40b7be8cb53b06e9$export$531badb89cf01312,
    faArrowAltCircleDown: $40b7be8cb53b06e9$export$ff3afbc8c0bc5d59,
    faThumbsDown: $40b7be8cb53b06e9$export$aba24ca305bbe8c1,
    faChessPawn: $40b7be8cb53b06e9$export$3db75d5ac9e98468,
    faCreditCard: $40b7be8cb53b06e9$export$3e7437bf6535bef0,
    faCreditCardAlt: $40b7be8cb53b06e9$export$5fffe8e3c36964a2,
    faBell: $40b7be8cb53b06e9$export$9b6162797ab1b255,
    faFile: $40b7be8cb53b06e9$export$cad54bead856a678,
    faHospital: $40b7be8cb53b06e9$export$7a76c9d35b42d691,
    faHospitalAlt: $40b7be8cb53b06e9$export$cea7736417b94a3b,
    faHospitalWide: $40b7be8cb53b06e9$export$69c8cc0360f017e8,
    faChessRook: $40b7be8cb53b06e9$export$5d65c40a109eb09c,
    faStarHalf: $40b7be8cb53b06e9$export$228008b5e11032fa,
    faChessKing: $40b7be8cb53b06e9$export$d5713874f8fefe1b,
    faCircleUser: $40b7be8cb53b06e9$export$9a5c11a5e3d7f1e7,
    faUserCircle: $40b7be8cb53b06e9$export$be7d974e9e0dba1a,
    faCopy: $40b7be8cb53b06e9$export$e9bd786d30cb716c,
    faShareFromSquare: $40b7be8cb53b06e9$export$928280bdd54fa173,
    faShareSquare: $40b7be8cb53b06e9$export$ae9e1434571f373c,
    faCopyright: $40b7be8cb53b06e9$export$da61665fff8aebfe,
    faMap: $40b7be8cb53b06e9$export$fc82fb79180cd17c,
    faBellSlash: $40b7be8cb53b06e9$export$6b31a1e5968b2378,
    faHandLizard: $40b7be8cb53b06e9$export$54608d0a883fea4d,
    faFaceSmile: $40b7be8cb53b06e9$export$b5023c446f10324,
    faSmile: $40b7be8cb53b06e9$export$c632b2334f0913bc,
    faHandPeace: $40b7be8cb53b06e9$export$e49e3cfceea441cc,
    faFaceGrinHearts: $40b7be8cb53b06e9$export$fbb22081b65e4f33,
    faGrinHearts: $40b7be8cb53b06e9$export$c56cf0e0c3bc5ed2,
    faBuilding: $40b7be8cb53b06e9$export$f26673f8b10c3d46,
    faFaceGrinBeamSweat: $40b7be8cb53b06e9$export$2ff38f330c834084,
    faGrinBeamSweat: $40b7be8cb53b06e9$export$14d0ccc54c5b6826,
    faMoon: $40b7be8cb53b06e9$export$c4c2f69a53bab720,
    faCalendar: $40b7be8cb53b06e9$export$34f5c36a3e80efa2,
    faFaceGrinTongueWink: $40b7be8cb53b06e9$export$4272e56f2429da88,
    faGrinTongueWink: $40b7be8cb53b06e9$export$58099903d50aefb3,
    faClone: $40b7be8cb53b06e9$export$76c1aa4bf9a39458,
    faFaceAngry: $40b7be8cb53b06e9$export$67a047c738fb34da,
    faAngry: $40b7be8cb53b06e9$export$3c96c08e234498c5,
    faRectangleXmark: $40b7be8cb53b06e9$export$3896694b3e81fba7,
    faRectangleTimes: $40b7be8cb53b06e9$export$eaaf26416a51dc1,
    faTimesRectangle: $40b7be8cb53b06e9$export$10147c0014152a3f,
    faWindowClose: $40b7be8cb53b06e9$export$18b7775f78a3e16,
    faPaperPlane: $40b7be8cb53b06e9$export$b5378818301da1be,
    faLifeRing: $40b7be8cb53b06e9$export$53dd2cacf674142a,
    faFaceGrimace: $40b7be8cb53b06e9$export$bd5bd2ef56b793b1,
    faGrimace: $40b7be8cb53b06e9$export$3d08cd36ac1ef231,
    faCalendarMinus: $40b7be8cb53b06e9$export$23e8b4955c2d951b,
    faCircleXmark: $40b7be8cb53b06e9$export$30262489773a79a3,
    faTimesCircle: $40b7be8cb53b06e9$export$ab0ec50720a747eb,
    faXmarkCircle: $40b7be8cb53b06e9$export$90ac4096df8efdee,
    faThumbsUp: $40b7be8cb53b06e9$export$47e4e0d519d33497,
    faWindowMinimize: $40b7be8cb53b06e9$export$26a3f9d2784b90d8,
    faSquareFull: $40b7be8cb53b06e9$export$7ec6541fee081990,
    faNoteSticky: $40b7be8cb53b06e9$export$4a4e034527c933f5,
    faStickyNote: $40b7be8cb53b06e9$export$80889adc5d98bf4a,
    faFaceSadTear: $40b7be8cb53b06e9$export$8a5a0dbb2a17e253,
    faSadTear: $40b7be8cb53b06e9$export$4b5241926f692f91,
    faHandPointLeft: $40b7be8cb53b06e9$export$b276ec3dc9760d39
};

});

parcelRegister("7NI2K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5adf461180d7307b$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");
/**
 *  useOutsideClick hook
 * Checks if a click happened outside a Ref. Handy for dropdowns, modals and popups etc.
 * @param ref Ref whose outside click needs to be listened to
 * @param handler Callback to fire on outside click
 * @param when A boolean which which activates the hook only when it is true. Useful for conditionally enable the outside click
 */ function $5adf461180d7307b$var$useOutsideClick(ref, handler, when = true) {
    const savedHandler = (0, $jbmdS.useRef)(handler);
    const memoizedCallback = (0, $jbmdS.useCallback)((e)=>{
        if (ref && ref.current && !ref.current.contains(e.target)) savedHandler.current(e);
    }, []);
    (0, $jbmdS.useEffect)(()=>{
        savedHandler.current = handler;
    });
    (0, $jbmdS.useEffect)(()=>{
        if (when) {
            document.addEventListener("click", memoizedCallback);
            document.addEventListener("ontouchstart", memoizedCallback);
            return ()=>{
                document.removeEventListener("click", memoizedCallback);
                document.removeEventListener("ontouchstart", memoizedCallback);
            };
        }
    }, [
        ref,
        handler,
        when
    ]);
}
var $5adf461180d7307b$export$2e2bcd8739ae039 = $5adf461180d7307b$var$useOutsideClick;

});

parcelRegister("ax8Km", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ab3c562396cd635$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("eat5C");
parcelRequire("jYjJH");
parcelRequire("f44xu");

var $cwjKY = parcelRequire("cwjKY");

var $gjxeM = parcelRequire("gjxeM");

var $6RcUP = parcelRequire("6RcUP");

var $4hBm1 = parcelRequire("4hBm1");
parcelRequire("jE5CX");

var $6un1H = parcelRequire("6un1H");
parcelRequire("gJT7h");

var $7jE3m = parcelRequire("7jE3m");

var $ewAM3 = parcelRequire("ewAM3");

var $47i9t = parcelRequire("47i9t");

var $3h7sC = parcelRequire("3h7sC");
const $7ab3c562396cd635$var$budgetDataRequirements = ({ projects: projects, phase: phase, staff: staff, role: role, startDate: startDate, endDate: endDate, extraHours: extraHours })=>{
    return [
        {
            id: "budgetTimeEntries" + endDate,
            queryFn: async ()=>{
                const budgetData = await (0, $3h7sC.trpc).legacy.getProjectBudgets.query({
                    projectIds: projects.filter(Boolean).map((p)=>p.id),
                    startDate: (0, $4hBm1.format)(startDate, "yyyy-MM-dd"),
                    endDate: (0, $4hBm1.format)(endDate, "yyyy-MM-dd"),
                    staffId: staff === null || staff === void 0 ? void 0 : staff.id
                });
                return (0, $47i9t.processTRPCData)(budgetData, "budgetTimeEntries" + endDate);
            },
            staleTime: 0,
            cacheTime: 0
        }
    ];
};
const $7ab3c562396cd635$var$budgetLookup = {
    phaseBudgetForTeam: ({ projects: projects, project: project, phase: phase, staff: staff, role: role, startDate: startDate, endDate: endDate, extraHours: extraHours })=>{
        var _FetchStore$getRespon, _FetchStore$getRespon2, _FetchStore$getRespon3, _FetchStore$getRespon4, _FetchStore$getRespon5, _FetchStore$getRespon6, _FetchStore$getRespon7, _FetchStore$getRespon8;
        return {
            numerator: ((_FetchStore$getRespon = (0, $6un1H.default).getResponse("budgetTimeEntries" + endDate)) === null || _FetchStore$getRespon === void 0 ? void 0 : (_FetchStore$getRespon2 = _FetchStore$getRespon.budgets) === null || _FetchStore$getRespon2 === void 0 ? void 0 : (_FetchStore$getRespon3 = _FetchStore$getRespon2[project === null || project === void 0 ? void 0 : project.id]) === null || _FetchStore$getRespon3 === void 0 ? void 0 : (_FetchStore$getRespon4 = _FetchStore$getRespon3[phase === null || phase === void 0 ? void 0 : phase.id]) === null || _FetchStore$getRespon4 === void 0 ? void 0 : _FetchStore$getRespon4.teamBudgetUse) + extraHours,
            denominator: ((_FetchStore$getRespon5 = (0, $6un1H.default).getResponse("budgetTimeEntries" + endDate)) === null || _FetchStore$getRespon5 === void 0 ? void 0 : (_FetchStore$getRespon6 = _FetchStore$getRespon5.budgets) === null || _FetchStore$getRespon6 === void 0 ? void 0 : (_FetchStore$getRespon7 = _FetchStore$getRespon6[project === null || project === void 0 ? void 0 : project.id]) === null || _FetchStore$getRespon7 === void 0 ? void 0 : (_FetchStore$getRespon8 = _FetchStore$getRespon7[phase === null || phase === void 0 ? void 0 : phase.id]) === null || _FetchStore$getRespon8 === void 0 ? void 0 : _FetchStore$getRespon8.phaseBudget) || 0
        };
    },
    phaseBudgetForRole: ({ projects: projects, project: project, phase: phase, staff: staff, role: role, startDate: startDate, endDate: endDate, extraHours: extraHours })=>{
        var _FetchStore$getRespon9, _FetchStore$getRespon10, _FetchStore$getRespon11, _FetchStore$getRespon12, _FetchStore$getRespon13, _FetchStore$getRespon14, _FetchStore$getRespon15, _FetchStore$getRespon16;
        return {
            numerator: ((_FetchStore$getRespon9 = (0, $6un1H.default).getResponse("budgetTimeEntries" + endDate)) === null || _FetchStore$getRespon9 === void 0 ? void 0 : (_FetchStore$getRespon10 = _FetchStore$getRespon9.budgets) === null || _FetchStore$getRespon10 === void 0 ? void 0 : (_FetchStore$getRespon11 = _FetchStore$getRespon10[project === null || project === void 0 ? void 0 : project.id]) === null || _FetchStore$getRespon11 === void 0 ? void 0 : (_FetchStore$getRespon12 = _FetchStore$getRespon11[phase === null || phase === void 0 ? void 0 : phase.id]) === null || _FetchStore$getRespon12 === void 0 ? void 0 : _FetchStore$getRespon12.roleBudgetUse) + extraHours,
            denominator: ((_FetchStore$getRespon13 = (0, $6un1H.default).getResponse("budgetTimeEntries" + endDate)) === null || _FetchStore$getRespon13 === void 0 ? void 0 : (_FetchStore$getRespon14 = _FetchStore$getRespon13.budgets) === null || _FetchStore$getRespon14 === void 0 ? void 0 : (_FetchStore$getRespon15 = _FetchStore$getRespon14[project === null || project === void 0 ? void 0 : project.id]) === null || _FetchStore$getRespon15 === void 0 ? void 0 : (_FetchStore$getRespon16 = _FetchStore$getRespon15[phase === null || phase === void 0 ? void 0 : phase.id]) === null || _FetchStore$getRespon16 === void 0 ? void 0 : _FetchStore$getRespon16.rolePhaseBudget) || 0
        };
    },
    phaseBudgetForStaff: ({ projects: projects, project: project, phase: phase, staff: staff, role: role, startDate: startDate, endDate: endDate, extraHours: extraHours })=>{
        var _FetchStore$getRespon17, _FetchStore$getRespon18, _FetchStore$getRespon19, _FetchStore$getRespon20, _FetchStore$getRespon21, _FetchStore$getRespon22, _FetchStore$getRespon23, _FetchStore$getRespon24;
        return {
            numerator: ((_FetchStore$getRespon17 = (0, $6un1H.default).getResponse("budgetTimeEntries" + endDate)) === null || _FetchStore$getRespon17 === void 0 ? void 0 : (_FetchStore$getRespon18 = _FetchStore$getRespon17.budgets) === null || _FetchStore$getRespon18 === void 0 ? void 0 : (_FetchStore$getRespon19 = _FetchStore$getRespon18[project === null || project === void 0 ? void 0 : project.id]) === null || _FetchStore$getRespon19 === void 0 ? void 0 : (_FetchStore$getRespon20 = _FetchStore$getRespon19[phase === null || phase === void 0 ? void 0 : phase.id]) === null || _FetchStore$getRespon20 === void 0 ? void 0 : _FetchStore$getRespon20.staffBudgetUse) + extraHours,
            denominator: ((_FetchStore$getRespon21 = (0, $6un1H.default).getResponse("budgetTimeEntries" + endDate)) === null || _FetchStore$getRespon21 === void 0 ? void 0 : (_FetchStore$getRespon22 = _FetchStore$getRespon21.budgets) === null || _FetchStore$getRespon22 === void 0 ? void 0 : (_FetchStore$getRespon23 = _FetchStore$getRespon22[project === null || project === void 0 ? void 0 : project.id]) === null || _FetchStore$getRespon23 === void 0 ? void 0 : (_FetchStore$getRespon24 = _FetchStore$getRespon23[phase === null || phase === void 0 ? void 0 : phase.id]) === null || _FetchStore$getRespon24 === void 0 ? void 0 : _FetchStore$getRespon24.staffPhaseBudget) || 0
        };
    },
    monthlyPhaseBudgetForStaff: ({ projects: projects, project: project, phase: phase, staff: staff, role: role, startDate: startDate, endDate: endDate, extraHours: extraHours })=>{
        var _FetchStore$getRespon25, _FetchStore$getRespon26, _FetchStore$getRespon27, _FetchStore$getRespon28, _FetchStore$getRespon29, _FetchStore$getRespon30, _FetchStore$getRespon31, _FetchStore$getRespon32;
        return {
            numerator: ((_FetchStore$getRespon25 = (0, $6un1H.default).getResponse("budgetTimeEntries" + endDate)) === null || _FetchStore$getRespon25 === void 0 ? void 0 : (_FetchStore$getRespon26 = _FetchStore$getRespon25.budgets) === null || _FetchStore$getRespon26 === void 0 ? void 0 : (_FetchStore$getRespon27 = _FetchStore$getRespon26[project === null || project === void 0 ? void 0 : project.id]) === null || _FetchStore$getRespon27 === void 0 ? void 0 : (_FetchStore$getRespon28 = _FetchStore$getRespon27[phase === null || phase === void 0 ? void 0 : phase.id]) === null || _FetchStore$getRespon28 === void 0 ? void 0 : _FetchStore$getRespon28.monthlyBudgetUse) + extraHours,
            denominator: ((_FetchStore$getRespon29 = (0, $6un1H.default).getResponse("budgetTimeEntries" + endDate)) === null || _FetchStore$getRespon29 === void 0 ? void 0 : (_FetchStore$getRespon30 = _FetchStore$getRespon29.budgets) === null || _FetchStore$getRespon30 === void 0 ? void 0 : (_FetchStore$getRespon31 = _FetchStore$getRespon30[project === null || project === void 0 ? void 0 : project.id]) === null || _FetchStore$getRespon31 === void 0 ? void 0 : (_FetchStore$getRespon32 = _FetchStore$getRespon31[phase === null || phase === void 0 ? void 0 : phase.id]) === null || _FetchStore$getRespon32 === void 0 ? void 0 : _FetchStore$getRespon32.monthlyAllocation) || 0
        };
    },
    weeklyPhaseBudgetForStaff: ({ projects: projects, project: project, phase: phase, staff: staff, role: role, startDate: startDate, endDate: endDate, extraHours: extraHours })=>{
        var _FetchStore$getRespon33, _FetchStore$getRespon34, _FetchStore$getRespon35, _FetchStore$getRespon36, _FetchStore$getRespon37, _FetchStore$getRespon38, _FetchStore$getRespon39, _FetchStore$getRespon40;
        startDate = (0, $4hBm1.startOfISOWeek)(startDate);
        return {
            numerator: ((_FetchStore$getRespon33 = (0, $6un1H.default).getResponse("budgetTimeEntries" + endDate)) === null || _FetchStore$getRespon33 === void 0 ? void 0 : (_FetchStore$getRespon34 = _FetchStore$getRespon33.budgets) === null || _FetchStore$getRespon34 === void 0 ? void 0 : (_FetchStore$getRespon35 = _FetchStore$getRespon34[project === null || project === void 0 ? void 0 : project.id]) === null || _FetchStore$getRespon35 === void 0 ? void 0 : (_FetchStore$getRespon36 = _FetchStore$getRespon35[phase === null || phase === void 0 ? void 0 : phase.id]) === null || _FetchStore$getRespon36 === void 0 ? void 0 : _FetchStore$getRespon36.weeklyBudgetUse) + extraHours,
            denominator: ((_FetchStore$getRespon37 = (0, $6un1H.default).getResponse("budgetTimeEntries" + endDate)) === null || _FetchStore$getRespon37 === void 0 ? void 0 : (_FetchStore$getRespon38 = _FetchStore$getRespon37.budgets) === null || _FetchStore$getRespon38 === void 0 ? void 0 : (_FetchStore$getRespon39 = _FetchStore$getRespon38[project === null || project === void 0 ? void 0 : project.id]) === null || _FetchStore$getRespon39 === void 0 ? void 0 : (_FetchStore$getRespon40 = _FetchStore$getRespon39[phase === null || phase === void 0 ? void 0 : phase.id]) === null || _FetchStore$getRespon40 === void 0 ? void 0 : _FetchStore$getRespon40.weeklyAllocation) || 0
        };
    }
};
const $7ab3c562396cd635$export$b296db6c5b42b457 = {
    phaseBudgetForTeam: "Phase Budget for Team",
    phaseBudgetForRole: "Phase Budget for Role",
    phaseBudgetForStaff: "Phase Budget for Staff Member",
    monthlyPhaseBudgetForStaff: "Monthly Phase Budget for Staff Member",
    weeklyPhaseBudgetForStaff: "Weekly Phase Budget for Staff Member"
};
var $7ab3c562396cd635$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ project: project, projects: projects, phase: phase, staff: staff, role: role, startDate: startDate, endDate: endDate, budget: budget, setBudget: setBudget, extraHours: extraHours = 0, textStyles: textStyles = {}, barStyles: barStyles = {}, dropdownStyles: dropdownStyles = {}, containerStyles: containerStyles = {}, dropdownAbove: dropdownAbove = false, dropdownClassName: dropdownClassName, variant: variant, ...props })=>{
    var _FetchStore$getRespon41, _FetchStore$getRespon42, _FetchStore$getRespon43;
    projects = projects || [
        project
    ];
    const budgetData = (_FetchStore$getRespon41 = (0, $6un1H.default).getResponse("budgetTimeEntries" + endDate)) === null || _FetchStore$getRespon41 === void 0 ? void 0 : (_FetchStore$getRespon42 = _FetchStore$getRespon41.budgets) === null || _FetchStore$getRespon42 === void 0 ? void 0 : (_FetchStore$getRespon43 = _FetchStore$getRespon42[project === null || project === void 0 ? void 0 : project.id]) === null || _FetchStore$getRespon43 === void 0 ? void 0 : _FetchStore$getRespon43[phase === null || phase === void 0 ? void 0 : phase.id];
    let budgetOptions = [
        "phaseBudgetForTeam",
        "phaseBudgetForRole",
        "phaseBudgetForStaff",
        "monthlyPhaseBudgetForStaff",
        "weeklyPhaseBudgetForStaff"
    ].filter((o)=>o);
    const [selectedBudget, setSelectedBudget] = (0, $jbmdS.useState)(budget);
    const budgetOptionsWithData = budgetOptions.filter((b)=>{
        var _budgetLookup$b, _budgetLookup$b$call;
        return ((_budgetLookup$b = $7ab3c562396cd635$var$budgetLookup[b]) === null || _budgetLookup$b === void 0 ? void 0 : (_budgetLookup$b$call = _budgetLookup$b.call($7ab3c562396cd635$var$budgetLookup, {
            projects: projects,
            project: project,
            phase: phase,
            staff: staff,
            role: role,
            startDate: startDate,
            endDate: endDate,
            extraHours: extraHours
        })) === null || _budgetLookup$b$call === void 0 ? void 0 : _budgetLookup$b$call.denominator) > 0;
    });
    const defaultBudget = selectedBudget || (budgetOptionsWithData === null || budgetOptionsWithData === void 0 ? void 0 : budgetOptionsWithData[(budgetOptionsWithData === null || budgetOptionsWithData === void 0 ? void 0 : budgetOptionsWithData.length) - 1]) || "phaseBudgetForTeam";
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        style: containerStyles,
        ...props,
        children: [
            dropdownAbove && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                style: {
                    zIndex: 100,
                    width: "100%",
                    fontSize: "1rem",
                    ...dropdownStyles
                },
                selectedOption: defaultBudget,
                onChange: (v)=>{
                    setSelectedBudget(v);
                    setBudget && setBudget(v);
                },
                className: `budget-selector ${dropdownClassName || ""}`,
                options: budgetOptions,
                optionLabel: (bOpt)=>{
                    return $7ab3c562396cd635$export$b296db6c5b42b457[bOpt];
                },
                variant: "secondary"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6RcUP.default), {
                queryIds: $7ab3c562396cd635$var$budgetDataRequirements({
                    projects: projects || [
                        project
                    ],
                    phase: phase,
                    staff: staff,
                    role: role,
                    startDate: startDate,
                    endDate: endDate,
                    extraHours: extraHours
                }),
                children: /*#__PURE__*/ (0, $61Ea1.jsx)($7ab3c562396cd635$var$BudgetProgressBar, {
                    projects: projects,
                    project: project,
                    phase: phase,
                    staff: staff,
                    role: role,
                    startDate: startDate,
                    endDate: endDate,
                    extraHours: extraHours,
                    selectedBudget: defaultBudget,
                    barStyles: barStyles,
                    textStyles: textStyles,
                    variant: variant
                })
            }),
            !dropdownAbove && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                style: {
                    zIndex: 1000,
                    width: "100%",
                    ...dropdownStyles
                },
                selectedOption: defaultBudget,
                onChange: (v)=>{
                    setSelectedBudget(v);
                    setBudget && setBudget(v);
                },
                className: "budget-selector",
                options: budgetOptions,
                optionLabel: (bOpt)=>{
                    return $7ab3c562396cd635$export$b296db6c5b42b457[bOpt];
                },
                variant: "secondary"
            })
        ]
    });
});
const $7ab3c562396cd635$var$BudgetProgressBar = (0, $1EEMt.observer)(({ projects: projects, project: project, phase: phase, staff: staff, role: role, startDate: startDate, endDate: endDate, extraHours: extraHours = 0, selectedBudget: selectedBudget, barStyles: barStyles, textStyles: textStyles, variant: variant })=>{
    const budgetUse = $7ab3c562396cd635$var$budgetLookup[selectedBudget]({
        projects: projects,
        project: project,
        phase: phase,
        staff: staff,
        role: role,
        startDate: startDate,
        endDate: endDate,
        extraHours: extraHours
    });
    const budgetProgress = budgetUse.numerator / budgetUse.denominator;
    let progressGradient = {
        "0%": "#108ee9"
    };
    progressGradient[`${Math.round(0.5 / budgetProgress * 100)}%`] = "#87d068";
    if (budgetProgress > 0.8) progressGradient[`${Math.round(0.8 / budgetProgress * 100)}%`] = "#ffc200";
    if (budgetProgress > 1) progressGradient[`${Math.round(1 / budgetProgress * 100)}%`] = "#ff5800";
    function makeCSSGradient(colorStops) {
        // Start the gradient string with the direction
        let gradient = "linear-gradient(to right";
        // Add each color stop to the gradient string
        for(const position in colorStops)gradient += `, ${colorStops[position]} ${position}`;
        // Close the gradient string
        gradient += ")";
        return gradient;
    }
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "text-[#666] text-[13px] px-0 pb-2",
                style: {
                    ...textStyles
                },
                children: `${(0, $cwjKY.FormatNumber)(budgetUse.numerator)} / ${(0, $cwjKY.FormatNumber)(budgetUse.denominator)}${isFinite(budgetProgress) ? ` (${(0, $gjxeM.FormatPercent)(budgetProgress)})` : ""}`
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7jE3m.Progress), {
                value: budgetProgress * 100,
                // showInfo={false}
                fill: makeCSSGradient(progressGradient)
            }),
            variant === "secondary" ? /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "mb-1"
            }) : null
        ]
    });
});

});
parcelRegister("7jE3m", function(module, exports) {

$parcel$export(module.exports, "Progress", function () { return $a3c343c1685aa24d$export$b25a304ec7d746bb; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $cmyz6 = parcelRequire("cmyz6");
const $a3c343c1685aa24d$export$b25a304ec7d746bb = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).forwardRef((props, ref)=>{
    let { value: value, fill: fill, ...otherProps } = props;
    value = isFinite(value) ? value : null;
    // Inline styles to replace Tailwind classes
    const rootStyle = {
        position: "relative",
        height: "5px",
        width: "100%",
        overflow: "hidden",
        borderRadius: "9999px",
        background: "rgba(0, 0, 0, 0.2)" // Replace with your primary color
    };
    const indicatorStyle = {
        height: "100%",
        width: `${Math.min(value, 100)}%`,
        // Width is now based on the value prop
        background: fill || "black",
        transition: "width 0.3s ease" // Transitioning the width
    };
    return /*#__PURE__*/ (0, $61Ea1.jsx)($cmyz6.Root, {
        ref: ref,
        style: rootStyle,
        ...otherProps,
        children: /*#__PURE__*/ (0, $61Ea1.jsx)($cmyz6.Indicator, {
            style: indicatorStyle
        })
    });
});
$a3c343c1685aa24d$export$b25a304ec7d746bb.displayName = "Progress";

});
parcelRegister("cmyz6", function(module, exports) {

$parcel$export(module.exports, "Root", function () { return $38dc18d26ca15216$export$be92b6f5f03c0fe9; });
$parcel$export(module.exports, "Indicator", function () { return $38dc18d26ca15216$export$adb584737d712b70; });

var $jbmdS = parcelRequire("jbmdS");

var $5wj0G = parcelRequire("5wj0G");

var $cihg9 = parcelRequire("cihg9");

var $4TLFw = parcelRequire("4TLFw");
"use client";
var $38dc18d26ca15216$var$PROGRESS_NAME = "Progress";
var $38dc18d26ca15216$var$DEFAULT_MAX = 100;
var [$38dc18d26ca15216$var$createProgressContext, $38dc18d26ca15216$export$388eb2d8f6d3261f] = (0, $5wj0G.createContextScope)($38dc18d26ca15216$var$PROGRESS_NAME);
var [$38dc18d26ca15216$var$ProgressProvider, $38dc18d26ca15216$var$useProgressContext] = $38dc18d26ca15216$var$createProgressContext($38dc18d26ca15216$var$PROGRESS_NAME);
var $38dc18d26ca15216$export$b25a304ec7d746bb = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeProgress: __scopeProgress, value: valueProp = null, max: maxProp, getValueLabel: getValueLabel = $38dc18d26ca15216$var$defaultGetValueLabel, ...progressProps } = props;
    if ((maxProp || maxProp === 0) && !$38dc18d26ca15216$var$isValidMaxNumber(maxProp)) console.error($38dc18d26ca15216$var$getInvalidMaxError(`${maxProp}`, "Progress"));
    const max = $38dc18d26ca15216$var$isValidMaxNumber(maxProp) ? maxProp : $38dc18d26ca15216$var$DEFAULT_MAX;
    if (valueProp !== null && !$38dc18d26ca15216$var$isValidValueNumber(valueProp, max)) console.error($38dc18d26ca15216$var$getInvalidValueError(`${valueProp}`, "Progress"));
    const value = $38dc18d26ca15216$var$isValidValueNumber(valueProp, max) ? valueProp : null;
    const valueLabel = $38dc18d26ca15216$var$isNumber(value) ? getValueLabel(value, max) : void 0;
    return /* @__PURE__ */ (0, $4TLFw.jsx)($38dc18d26ca15216$var$ProgressProvider, {
        scope: __scopeProgress,
        value: value,
        max: max,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).div, {
            "aria-valuemax": max,
            "aria-valuemin": 0,
            "aria-valuenow": $38dc18d26ca15216$var$isNumber(value) ? value : void 0,
            "aria-valuetext": valueLabel,
            role: "progressbar",
            "data-state": $38dc18d26ca15216$var$getProgressState(value, max),
            "data-value": value ?? void 0,
            "data-max": max,
            ...progressProps,
            ref: forwardedRef
        })
    });
});
$38dc18d26ca15216$export$b25a304ec7d746bb.displayName = $38dc18d26ca15216$var$PROGRESS_NAME;
var $38dc18d26ca15216$var$INDICATOR_NAME = "ProgressIndicator";
var $38dc18d26ca15216$export$2b776f7e7ee60dbd = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeProgress: __scopeProgress, ...indicatorProps } = props;
    const context = $38dc18d26ca15216$var$useProgressContext($38dc18d26ca15216$var$INDICATOR_NAME, __scopeProgress);
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).div, {
        "data-state": $38dc18d26ca15216$var$getProgressState(context.value, context.max),
        "data-value": context.value ?? void 0,
        "data-max": context.max,
        ...indicatorProps,
        ref: forwardedRef
    });
});
$38dc18d26ca15216$export$2b776f7e7ee60dbd.displayName = $38dc18d26ca15216$var$INDICATOR_NAME;
function $38dc18d26ca15216$var$defaultGetValueLabel(value, max) {
    return `${Math.round(value / max * 100)}%`;
}
function $38dc18d26ca15216$var$getProgressState(value, maxValue) {
    return value == null ? "indeterminate" : value === maxValue ? "complete" : "loading";
}
function $38dc18d26ca15216$var$isNumber(value) {
    return typeof value === "number";
}
function $38dc18d26ca15216$var$isValidMaxNumber(max) {
    return $38dc18d26ca15216$var$isNumber(max) && !isNaN(max) && max > 0;
}
function $38dc18d26ca15216$var$isValidValueNumber(value, max) {
    return $38dc18d26ca15216$var$isNumber(value) && !isNaN(value) && value <= max && value >= 0;
}
function $38dc18d26ca15216$var$getInvalidMaxError(propValue, componentName) {
    return `Invalid prop \`max\` of value \`${propValue}\` supplied to \`${componentName}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${$38dc18d26ca15216$var$DEFAULT_MAX}\`.`;
}
function $38dc18d26ca15216$var$getInvalidValueError(propValue, componentName) {
    return `Invalid prop \`value\` of value \`${propValue}\` supplied to \`${componentName}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${$38dc18d26ca15216$var$DEFAULT_MAX} if no \`max\` prop is set)
  - \`null\` or \`undefined\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
var $38dc18d26ca15216$export$be92b6f5f03c0fe9 = $38dc18d26ca15216$export$b25a304ec7d746bb;
var $38dc18d26ca15216$export$adb584737d712b70 = $38dc18d26ca15216$export$2b776f7e7ee60dbd;

});
parcelRegister("5wj0G", function(module, exports) {

$parcel$export(module.exports, "createContextScope", function () { return $96f91b367bb38f15$export$50c7b4e9d9f19c1; });
// packages/react/context/src/createContext.tsx

var $jbmdS = parcelRequire("jbmdS");

var $4TLFw = parcelRequire("4TLFw");
function $96f91b367bb38f15$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $jbmdS.createContext(defaultContext);
    function Provider(props) {
        const { children: children, ...context } = props;
        const value = $jbmdS.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $4TLFw.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    }
    function useContext2(consumerName) {
        const context = $jbmdS.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext2
    ];
}
function $96f91b367bb38f15$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $jbmdS.createContext(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope, children: children, ...context } = props;
            const Context = scope?.[scopeName][index] || BaseContext;
            const value = $jbmdS.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $4TLFw.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        }
        function useContext2(consumerName, scope) {
            const Context = scope?.[scopeName][index] || BaseContext;
            const context = $jbmdS.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $jbmdS.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = scope?.[scopeName] || scopeContexts;
            return $jbmdS.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $96f91b367bb38f15$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function $96f91b367bb38f15$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope, scopeName: scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $jbmdS.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}

});




parcelRegister("b9nYY", function(module, exports) {

$parcel$export(module.exports, "CalendarSidebar", function () { return $81e32363f35786cc$export$87a2feec72e0b03d; });
$parcel$export(module.exports, "PhaseAndTaskSelectors", function () { return $81e32363f35786cc$export$420edc37383f3495; });

var $61Ea1 = parcelRequire("61Ea1");

var $b1oJz = parcelRequire("b1oJz");
var $e4oIi = parcelRequire("e4oIi");
var $6N1HV = parcelRequire("6N1HV");
var $hRCNE = parcelRequire("hRCNE");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $6RcUP = parcelRequire("6RcUP");

var $XoImS = parcelRequire("XoImS");

var $gJT7h = parcelRequire("gJT7h");

var $keGWP = parcelRequire("keGWP");

var $1BTI2 = parcelRequire("1BTI2");

var $e8Hda = parcelRequire("e8Hda");
parcelRequire("fEtu5");
var $y5iig = parcelRequire("y5iig");

var $eUxk9 = parcelRequire("eUxk9");

var $ax8Km = parcelRequire("ax8Km");

var $4hBm1 = parcelRequire("4hBm1");

var $bxXv3 = parcelRequire("bxXv3");

var $htkeB = parcelRequire("htkeB");

var $8kZ1o = parcelRequire("8kZ1o");

var $6Q5sp = parcelRequire("6Q5sp");

var $QiMYe = parcelRequire("QiMYe");

var $eat5C = parcelRequire("eat5C");

var $6fNfM = parcelRequire("6fNfM");

var $ewAM3 = parcelRequire("ewAM3");

var $3h7sC = parcelRequire("3h7sC");

var $47i9t = parcelRequire("47i9t");
const { TextArea: $81e32363f35786cc$var$TextArea } = (0, $6N1HV.default);
const $81e32363f35786cc$export$24161251db42a3eb = [
    "phase",
    "role",
    "staff",
    "monthlyPhase",
    "monthlyRole",
    "monthlyStaff"
];
const $81e32363f35786cc$export$b296db6c5b42b457 = {
    phase: "Phase Budget for Team",
    role: "Phase Budget for Role",
    staff: "Phase Budget for Staff Member",
    monthlyPhase: "Monthly Budget for Team",
    monthlyRole: "Monthly Budget for Role",
    monthlyStaff: "Monthly Budget for Staff Member"
};
const $81e32363f35786cc$export$87a2feec72e0b03d = (0, $1EEMt.observer)(()=>{
    var _calendarState$select, _calendarState$select2, _calendarState$select3, _calendarState$select4;
    const settings = (0, $1BTI2.default).organisation.settings;
    const disabled = (0, $eUxk9.default).selectedItem && !((_calendarState$select = (0, $eUxk9.default).selectedItem) !== null && _calendarState$select !== void 0 && (_calendarState$select2 = _calendarState$select.modelType) !== null && _calendarState$select2 !== void 0 && _calendarState$select2.toLowerCase().includes((0, $eUxk9.default).mode));
    if (!(0, $eUxk9.default).selectedValues.projectId) return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {});
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "p-4 flex flex-col h-full",
        children: [
            !disabled && (0, $eUxk9.default).selectedItem && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $b1oJz.default), {
                message: "Editing selected item.",
                type: "info",
                showIcon: true
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "py-6",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6RcUP.default), {
                    queryIds: [
                        (0, $eUxk9.default).selectedValues.projectId ? {
                            id: `phases-${(0, $eUxk9.default).selectedValues.projectId}`,
                            queryFn: async ()=>{
                                const requestData = await (0, $3h7sC.trpc).legacy.getProjectPhases.query({
                                    projectId: (0, $eUxk9.default).selectedValues.projectId
                                });
                                return (0, $47i9t.processTRPCData)(requestData, `phases-${(0, $eUxk9.default).selectedValues.projectId}`);
                            }
                        } : null
                    ].filter((v)=>v),
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ax8Km.default), {
                        dropdownClassName: "!text-xs",
                        project: (0, $gJT7h.default).projectsById[(0, $eUxk9.default).selectedValues.projectId],
                        phase: (0, $XoImS.default).phasesById[(0, $eUxk9.default).selectedValues.phaseId],
                        role: (0, $bxXv3.default).rolesById[(0, $eUxk9.default).selectedValues.roleId],
                        staff: (0, $htkeB.default).staffsById[(0, $eUxk9.default).selectedValues.staffId],
                        startDate: (0, $4hBm1.startOfWeek)(((_calendarState$select3 = (0, $eUxk9.default).selectedItem) === null || _calendarState$select3 === void 0 ? void 0 : _calendarState$select3.date) || new Date(), {
                            weekStartsOn: 1
                        }),
                        endDate: (0, $4hBm1.endOfWeek)(((_calendarState$select4 = (0, $eUxk9.default).selectedItem) === null || _calendarState$select4 === void 0 ? void 0 : _calendarState$select4.date) || new Date(), {
                            weekStartsOn: 1
                        }),
                        dropdownAbove: true,
                        extraHours: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(((0, $QiMYe.default).timeEntries || []).filter((te)=>{
                            var _calendarState$select5;
                            return te.staffId === (0, $eUxk9.default).selectedValues.staffId && te.phaseId === (0, $eUxk9.default).selectedValues.phaseId && te.date.getTime() === (((_calendarState$select5 = (0, $eUxk9.default).selectedItem) === null || _calendarState$select5 === void 0 ? void 0 : _calendarState$select5.date) || new Date()).getTime() && !te.deletedAt;
                        }).map((te)=>te.hours))
                    }, String((0, $eUxk9.default).selectedValues.projectId) + String((0, $eUxk9.default).selectedValues.phaseId))
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "flex flex-col gap-1",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.ProjectSelector), {
                        selectedProject: (0, $gJT7h.default).projectsById[(0, $eUxk9.default).selectedValues.projectId],
                        projectOptions: (0, $gJT7h.default).projects.filter((p)=>(0, $8kZ1o.canEnterTimeAgainstProject)((0, $1BTI2.default).user, p)),
                        onChange: (project)=>{
                            const projectId = project === null || project === void 0 ? void 0 : project.id;
                            (0, $6Q5sp.queryClient).invalidateQueries([
                                `phases-${projectId}`
                            ]);
                            (0, $eUxk9.default).updateSelectedValues({
                                projectId: projectId
                            });
                        },
                        variant: "secondary",
                        style: {
                            width: "100%"
                        }
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6RcUP.default), {
                        queryIds: [
                            (0, $eUxk9.default).selectedValues.projectId ? {
                                id: `phases-${(0, $eUxk9.default).selectedValues.projectId}`,
                                queryFn: async ()=>{
                                    const requestData = await (0, $3h7sC.trpc).legacy.getProjectPhases.query({
                                        projectId: (0, $eUxk9.default).selectedValues.projectId
                                    });
                                    return (0, $47i9t.processTRPCData)(requestData, `phases-${(0, $eUxk9.default).selectedValues.projectId}`);
                                }
                            } : null,
                            (0, $eUxk9.default).selectedValues.projectId ? {
                                id: `tasks-${(0, $eUxk9.default).selectedValues.projectId}`,
                                queryFn: async ()=>{
                                    const requestData = await (0, $3h7sC.trpc).legacy.getTasks.query({
                                        projectId: (0, $eUxk9.default).selectedValues.projectId
                                    });
                                    return (0, $47i9t.processTRPCData)(requestData, `tasks-${(0, $eUxk9.default).selectedValues.projectId}`);
                                }
                            } : null
                        ].filter((v)=>v),
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)($81e32363f35786cc$export$420edc37383f3495, {
                            setting: settings,
                            disabled: disabled
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "flex justify-around text-center my-8 mx-0 text-sm text-[#666]",
                children: [
                    (0, $8kZ1o.canUseTimeEntryFlag)("billable") ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hRCNE.default), {
                                checked: (0, $eUxk9.default).selectedValues.isBillable,
                                onChange: (isBillable)=>{
                                    (0, $eUxk9.default).updateSelectedValues({
                                        isBillable: isBillable
                                    });
                                },
                                disabled: disabled
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                children: "Billable"
                            })
                        ]
                    }) : null,
                    (0, $8kZ1o.canUseTimeEntryFlag)("variation") && /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hRCNE.default), {
                                checked: (0, $eUxk9.default).selectedValues.isVariation,
                                onChange: (isVariation)=>{
                                    (0, $eUxk9.default).updateSelectedValues({
                                        isVariation: isVariation
                                    });
                                },
                                disabled: disabled
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                children: "Variation"
                            })
                        ]
                    }),
                    (0, $8kZ1o.canUseTimeEntryFlag)("overtime") ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hRCNE.default), {
                                checked: (0, $eUxk9.default).selectedValues.isOvertime,
                                onChange: (isOvertime)=>{
                                    (0, $eUxk9.default).updateSelectedValues({
                                        isOvertime: isOvertime
                                    });
                                },
                                disabled: disabled
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                children: "Overtime"
                            })
                        ]
                    }) : null,
                    (0, $8kZ1o.canUseTimeEntryFlag)("remote") ? settings.timeEntryFlags.includes("remote") && /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hRCNE.default), {
                                checked: (0, $eUxk9.default).selectedValues.remote,
                                onChange: (remote)=>{
                                    (0, $eUxk9.default).updateSelectedValues({
                                        remote: remote
                                    });
                                },
                                disabled: disabled
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                children: "Remote"
                            })
                        ]
                    }) : null,
                    (0, $8kZ1o.canUseTimeEntryFlag)("flexi") ? settings.timeEntryFlags.includes("flexi") && /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hRCNE.default), {
                                checked: (0, $eUxk9.default).selectedValues.flexi,
                                onChange: (flexi)=>{
                                    (0, $eUxk9.default).updateSelectedValues({
                                        flexi: flexi
                                    });
                                },
                                disabled: disabled
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                children: "Flexi"
                            })
                        ]
                    }) : null
                ]
            }),
            (0, $eUxk9.default).selectedItem ? /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                type: "text",
                                style: {
                                    flex: "1 1 auto",
                                    width: "70%",
                                    margin: "0.25em",
                                    padding: "0.25em",
                                    textAlign: "right"
                                },
                                children: "Hours:"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $y5iig.HoursInput), {
                                style: {
                                    flex: "1 1 auto",
                                    width: "30%",
                                    margin: "0.25em",
                                    textAlign: "right"
                                },
                                className: "form-control input-lg login-widget__email-input input-base w-full focus:outline-none hover:border-[#618fb0]",
                                value: (0, $eUxk9.default).selectedItem.numMinutes,
                                onChange: (numMins)=>(0, $eUxk9.default).editSelectedItem({
                                        numMinutes: numMins
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            display: "flex"
                        },
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)($81e32363f35786cc$export$a1af6f79df847fac, {
                                style: {
                                    flex: "1 1 auto",
                                    width: "50%",
                                    margin: "0.25em",
                                    textAlign: "right"
                                },
                                className: "form-control input-lg login-widget__email-input input-base w-full focus:outline-none hover:border-[#618fb0]",
                                numMins: (0, $eUxk9.default).selectedItem.startMinutes,
                                onChange: (mins)=>(0, $eUxk9.default).editSelectedItem({
                                        startMinutes: mins
                                    })
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)($81e32363f35786cc$export$a1af6f79df847fac, {
                                style: {
                                    flex: "1 1 auto",
                                    width: "50%",
                                    margin: "0.25em",
                                    textAlign: "right"
                                },
                                className: "form-control input-lg login-widget__email-input input-base w-fullfocus:outline-none hover:border-[#618fb0]",
                                numMins: (0, $eUxk9.default).selectedItem.endMinutes,
                                onChange: (mins)=>(0, $eUxk9.default).editSelectedItem({
                                        numMinutes: mins - (0, $eUxk9.default).selectedItem.startMinutes
                                    })
                            })
                        ]
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $61Ea1.jsx)($81e32363f35786cc$var$TextArea, {
                value: (0, $eUxk9.default).selectedValues.notes,
                onChange: (e)=>{
                    (0, $eUxk9.default).updateSelectedValues({
                        notes: e.target.value
                    });
                },
                className: "text-sm",
                placeholder: "Enter some notes...",
                autoSize: {
                    minRows: 5
                },
                allowClear: true,
                disabled: disabled
            }),
            !disabled && (0, $eUxk9.default).selectedItem && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $e4oIi.default), {
                danger: true,
                type: "primary",
                style: {
                    marginTop: "2rem",
                    width: "100%"
                },
                disabled: (0, $eUxk9.default).deletingSelectedItem,
                onClick: (0, $eUxk9.default).deleteSelectedItem,
                children: (0, $eUxk9.default).deletingSelectedItem ? `Deleting in ${(0, $eUxk9.default).deleteCountdown}...` : "Delete"
            }),
            (0, $eUxk9.default).deletingSelectedItem && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $e4oIi.default), {
                danger: true,
                style: {
                    marginTop: "1rem",
                    width: "100%"
                },
                onClick: (0, $eUxk9.default).undoDeleteSelectedItem,
                children: "Undo"
            })
        ]
    }, (0, $eUxk9.default).selectedValues);
});
const $81e32363f35786cc$export$420edc37383f3495 = ({ store: store = (0, $eUxk9.default), disabled: disabled = false })=>{
    var _ref, _project$phases;
    const projectId = store.selectedValues.projectId;
    const project = (0, $gJT7h.default).projectsById[projectId];
    const phaseId = store.selectedValues.phaseId;
    const phase = (0, $XoImS.default)[phaseId] || ((_ref = (0, $XoImS.default).phasesByProjectId[projectId] || []) === null || _ref === void 0 ? void 0 : _ref.sort((0, $6fNfM.default)).filter((p)=>(0, $8kZ1o.canEnterTimeAgainstPhase)((0, $1BTI2.default).user, p))[0]);
    const tasks = (0, $keGWP.default).tasksByPhaseId[phaseId] || [];
    (0, $jbmdS.useEffect)(()=>{
        if (phase && !store.selectedValues.phaseId) store.updateSelectedValues({
            phaseId: phase === null || phase === void 0 ? void 0 : phase.id
        });
        if (phase && !store.selectedValues.taskId) {
            var _phase$defaultTask, _phase$tasks, _phase$tasks$;
            store.updateSelectedValues({
                taskId: (phase === null || phase === void 0 ? void 0 : (_phase$defaultTask = phase.defaultTask) === null || _phase$defaultTask === void 0 ? void 0 : _phase$defaultTask.id) || (phase === null || phase === void 0 ? void 0 : (_phase$tasks = phase.tasks) === null || _phase$tasks === void 0 ? void 0 : (_phase$tasks$ = _phase$tasks[0]) === null || _phase$tasks$ === void 0 ? void 0 : _phase$tasks$.id)
            });
        }
    }, [
        projectId,
        phase
    ]);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.PhaseSelector), {
                selectedPhase: (0, $XoImS.default).phasesById[store.selectedValues.phaseId],
                onChange: (phase)=>{
                    const phaseId = phase === null || phase === void 0 ? void 0 : phase.id;
                    store.updateSelectedValues({
                        phaseId: phaseId
                    });
                },
                phaseOptions: (project === null || project === void 0 ? void 0 : (_project$phases = project.phases) === null || _project$phases === void 0 ? void 0 : _project$phases.filter((ph)=>(0, $8kZ1o.canEnterTimeAgainstPhase)((0, $1BTI2.default).user, ph))) || [],
                disabled: disabled,
                variant: "secondary",
                style: {
                    width: "100%"
                }
            }, `phase-selector-${store.selectedValues.phaseId || "null"}`),
            (0, $8kZ1o.canLogTimeAgainstTasks)() ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.TaskSelector), {
                selectedTask: (0, $keGWP.default).tasksById[store.selectedValues.taskId],
                onChange: (task)=>{
                    const taskId = task === null || task === void 0 ? void 0 : task.id;
                    store.updateSelectedValues({
                        taskId: taskId
                    });
                },
                taskOptions: tasks,
                disabled: disabled,
                variant: "secondary",
                style: {
                    width: "100%"
                }
            }, `task-selector-${store.selectedValues.taskId || "null"}`) : null
        ]
    });
};
const $81e32363f35786cc$export$a1af6f79df847fac = (0, $1EEMt.observer)(({ numMins: numMins, style: style, onChange: onChange, disabled: disabled, ...props })=>{
    const [val, setVal] = (0, $jbmdS.useState)((0, $e8Hda.numMinutesToTimeString)(numMins));
    (0, $jbmdS.useEffect)(()=>{
        setVal((0, $e8Hda.numMinutesToTimeString)(numMins));
    }, [
        numMins
    ]);
    return /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
        type: "text",
        style: style,
        value: val || "",
        onChange: (e)=>setVal(e.target.value),
        onBlur: (e)=>onChange((0, $e8Hda.numberTimeStringToMinutes)(e.target.value)),
        disabled: disabled,
        ...props
    });
});

});
parcelRegister("b1oJz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8062f9633489824b$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $CZyex = parcelRequire("CZyex");

var $8K2NM = parcelRequire("8K2NM");

var $1QBcl = parcelRequire("1QBcl");

var $7oynS = parcelRequire("7oynS");

var $kPBAG = parcelRequire("kPBAG");

var $7zb1D = parcelRequire("7zb1D");

var $8u58w = parcelRequire("8u58w");

var $6kn9Y = parcelRequire("6kn9Y");

var $jcunH = parcelRequire("jcunH");

var $lRx2a = parcelRequire("lRx2a");

var $baxAi = parcelRequire("baxAi");

var $02LyB = parcelRequire("02LyB");

var $jGjXd = parcelRequire("jGjXd");

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("8uDri");
var $ewikT = parcelRequire("ewikT");

var $cSHvN = parcelRequire("cSHvN");

var $l34u6 = parcelRequire("l34u6");

var $8sSo4 = parcelRequire("8sSo4");
var $8062f9633489824b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $8062f9633489824b$var$iconMapFilled = {
    success: (0, $1QBcl.default),
    info: (0, $lRx2a.default),
    error: (0, $kPBAG.default),
    warning: (0, $6kn9Y.default)
};
var $8062f9633489824b$var$iconMapOutlined = {
    success: (0, $7oynS.default),
    info: (0, $baxAi.default),
    error: (0, $7zb1D.default),
    warning: (0, $jcunH.default)
};
var $8062f9633489824b$var$IconNode = function IconNode(props) {
    var description = props.description, icon = props.icon, prefixCls = props.prefixCls, type = props.type;
    var iconType = (description ? $8062f9633489824b$var$iconMapOutlined : $8062f9633489824b$var$iconMapFilled)[type] || null;
    if (icon) return (0, $l34u6.replaceElement)(icon, /*#__PURE__*/ $jbmdS.createElement("span", {
        className: "".concat(prefixCls, "-icon")
    }, icon), function() {
        return {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("".concat(prefixCls, "-icon"), (0, $8K2NM.default)({}, icon.props.className, icon.props.className))
        };
    });
    return /*#__PURE__*/ $jbmdS.createElement(iconType, {
        className: "".concat(prefixCls, "-icon")
    });
};
var $8062f9633489824b$var$CloseIcon = function CloseIcon(props) {
    var isClosable = props.isClosable, closeText = props.closeText, prefixCls = props.prefixCls, closeIcon = props.closeIcon, handleClose = props.handleClose;
    return isClosable ? /*#__PURE__*/ $jbmdS.createElement("button", {
        type: "button",
        onClick: handleClose,
        className: "".concat(prefixCls, "-close-icon"),
        tabIndex: 0
    }, closeText ? /*#__PURE__*/ $jbmdS.createElement("span", {
        className: "".concat(prefixCls, "-close-text")
    }, closeText) : closeIcon) : null;
};
var $8062f9633489824b$var$Alert = function Alert(_a) {
    var description = _a.description, customizePrefixCls = _a.prefixCls, message = _a.message, banner = _a.banner, _a$className = _a.className, className = _a$className === void 0 ? "" : _a$className, style = _a.style, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onClick = _a.onClick, afterClose = _a.afterClose, showIcon = _a.showIcon, closable = _a.closable, closeText = _a.closeText, _a$closeIcon = _a.closeIcon, closeIcon = _a$closeIcon === void 0 ? /*#__PURE__*/ $jbmdS.createElement((0, $8u58w.default), null) : _a$closeIcon, action = _a.action, props = $8062f9633489824b$var$__rest(_a, [
        "description",
        "prefixCls",
        "message",
        "banner",
        "className",
        "style",
        "onMouseEnter",
        "onMouseLeave",
        "onClick",
        "afterClose",
        "showIcon",
        "closable",
        "closeText",
        "closeIcon",
        "action"
    ]);
    var _React$useState = $jbmdS.useState(false), _React$useState2 = (0, $CZyex.default)(_React$useState, 2), closed = _React$useState2[0], setClosed = _React$useState2[1];
    var ref = $jbmdS.useRef();
    var _React$useContext = $jbmdS.useContext((0, $ewikT.ConfigContext)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var prefixCls = getPrefixCls("alert", customizePrefixCls);
    var handleClose = function handleClose(e) {
        var _a;
        setClosed(true);
        (_a = props.onClose) === null || _a === void 0 || _a.call(props, e);
    };
    var getType = function getType() {
        var type = props.type;
        if (type !== undefined) return type;
        // banner 模式默认为警告
        return banner ? "warning" : "info";
    };
    // closeable when closeText is assigned
    var isClosable = closeText ? true : closable;
    var type = getType();
    // banner 模式默认有 Icon
    var isShowIcon = banner && showIcon === undefined ? true : showIcon;
    var alertCls = (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(prefixCls, "".concat(prefixCls, "-").concat(type), (0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)({}, "".concat(prefixCls, "-with-description"), !!description), "".concat(prefixCls, "-no-icon"), !isShowIcon), "".concat(prefixCls, "-banner"), !!banner), "".concat(prefixCls, "-rtl"), direction === "rtl"), className);
    var dataOrAriaProps = (0, $cSHvN.default)(props);
    return /*#__PURE__*/ $jbmdS.createElement((0, $jGjXd.default), {
        visible: !closed,
        motionName: "".concat(prefixCls, "-motion"),
        motionAppear: false,
        motionEnter: false,
        onLeaveStart: function onLeaveStart(node) {
            return {
                maxHeight: node.offsetHeight
            };
        },
        onLeaveEnd: afterClose
    }, function(_ref) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        return /*#__PURE__*/ $jbmdS.createElement("div", (0, $7i29i.default)({
            ref: ref,
            "data-show": !closed,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(alertCls, motionClassName),
            style: (0, $7i29i.default)((0, $7i29i.default)({}, style), motionStyle),
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onClick: onClick,
            role: "alert"
        }, dataOrAriaProps), isShowIcon ? /*#__PURE__*/ $jbmdS.createElement($8062f9633489824b$var$IconNode, {
            description: description,
            icon: props.icon,
            prefixCls: prefixCls,
            type: type
        }) : null, /*#__PURE__*/ $jbmdS.createElement("div", {
            className: "".concat(prefixCls, "-content")
        }, message ? /*#__PURE__*/ $jbmdS.createElement("div", {
            className: "".concat(prefixCls, "-message")
        }, message) : null, description ? /*#__PURE__*/ $jbmdS.createElement("div", {
            className: "".concat(prefixCls, "-description")
        }, description) : null), action ? /*#__PURE__*/ $jbmdS.createElement("div", {
            className: "".concat(prefixCls, "-action")
        }, action) : null, /*#__PURE__*/ $jbmdS.createElement($8062f9633489824b$var$CloseIcon, {
            isClosable: !!isClosable,
            closeText: closeText,
            prefixCls: prefixCls,
            closeIcon: closeIcon,
            handleClose: handleClose
        }));
    });
};
$8062f9633489824b$var$Alert.ErrorBoundary = (0, $8sSo4.default);
var $8062f9633489824b$export$2e2bcd8739ae039 = $8062f9633489824b$var$Alert;

});
parcelRegister("cSHvN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $960c47b56d254819$export$2e2bcd8739ae039; });
function $960c47b56d254819$export$2e2bcd8739ae039(props) {
    return Object.keys(props).reduce(function(prev, key) {
        if ((key.startsWith("data-") || key.startsWith("aria-") || key === "role") && !key.startsWith("data-__")) prev[key] = props[key];
        return prev;
    }, {});
}

});

parcelRegister("8sSo4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $629b206e5cf32bf0$export$2e2bcd8739ae039; });

var $3GVdq = parcelRequire("3GVdq");

var $jj5jQ = parcelRequire("jj5jQ");

var $ibb6t = parcelRequire("ibb6t");

var $lJpH8 = parcelRequire("lJpH8");

var $dO7bG = parcelRequire("dO7bG");

var $1N4zm = parcelRequire("1N4zm");

var $jbmdS = parcelRequire("jbmdS");

var $b1oJz = parcelRequire("b1oJz");
function $629b206e5cf32bf0$var$_callSuper(t, o, e) {
    return o = (0, $dO7bG.default)(o), (0, $ibb6t.default)(t, (0, $lJpH8.default)() ? Reflect.construct(o, e || [], (0, $dO7bG.default)(t).constructor) : o.apply(t, e));
}
var $629b206e5cf32bf0$var$ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
    (0, $1N4zm.default)(ErrorBoundary, _React$Component);
    function ErrorBoundary() {
        var _this;
        (0, $3GVdq.default)(this, ErrorBoundary);
        _this = $629b206e5cf32bf0$var$_callSuper(this, ErrorBoundary, arguments);
        _this.state = {
            error: undefined,
            info: {
                componentStack: ""
            }
        };
        return _this;
    }
    (0, $jj5jQ.default)(ErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, info) {
                this.setState({
                    error: error,
                    info: info
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, message = _this$props.message, description = _this$props.description, children = _this$props.children;
                var _this$state = this.state, error = _this$state.error, info = _this$state.info;
                var componentStack = info && info.componentStack ? info.componentStack : null;
                var errorMessage = typeof message === "undefined" ? (error || "").toString() : message;
                var errorDescription = typeof description === "undefined" ? componentStack : description;
                if (error) return /*#__PURE__*/ $jbmdS.createElement((0, $b1oJz.default), {
                    type: "error",
                    message: errorMessage,
                    description: /*#__PURE__*/ $jbmdS.createElement("pre", null, errorDescription)
                });
                return children;
            }
        }
    ]);
    return ErrorBoundary;
}($jbmdS.Component);
var $629b206e5cf32bf0$export$2e2bcd8739ae039 = $629b206e5cf32bf0$var$ErrorBoundary;

});


parcelRegister("eUxk9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $adb02518d66b3d9b$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $4hBm1 = parcelRequire("4hBm1");

var $gN0TC = parcelRequire("gN0TC");

var $f44xu = parcelRequire("f44xu");

var $1BTI2 = parcelRequire("1BTI2");

var $htkeB = parcelRequire("htkeB");

var $gJT7h = parcelRequire("gJT7h");

var $XoImS = parcelRequire("XoImS");

var $keGWP = parcelRequire("keGWP");

var $9VnJj = parcelRequire("9VnJj");

var $QiMYe = parcelRequire("QiMYe");

var $8kZ1o = parcelRequire("8kZ1o");

var $eat5C = parcelRequire("eat5C");

var $6fNfM = parcelRequire("6fNfM");

var $6Q5sp = parcelRequire("6Q5sp");
var $adb02518d66b3d9b$var$_dec, $adb02518d66b3d9b$var$_dec2, $adb02518d66b3d9b$var$_dec3, $adb02518d66b3d9b$var$_dec4, $adb02518d66b3d9b$var$_dec5, $adb02518d66b3d9b$var$_dec6, $adb02518d66b3d9b$var$_dec7, $adb02518d66b3d9b$var$_dec8, $adb02518d66b3d9b$var$_dec9, $adb02518d66b3d9b$var$_dec10, $adb02518d66b3d9b$var$_dec11, $adb02518d66b3d9b$var$_dec12, $adb02518d66b3d9b$var$_dec13, $adb02518d66b3d9b$var$_dec14, $adb02518d66b3d9b$var$_dec15, $adb02518d66b3d9b$var$_dec16, $adb02518d66b3d9b$var$_dec17, $adb02518d66b3d9b$var$_dec18, $adb02518d66b3d9b$var$_class, $adb02518d66b3d9b$var$_descriptor, $adb02518d66b3d9b$var$_descriptor2, $adb02518d66b3d9b$var$_descriptor3, $adb02518d66b3d9b$var$_descriptor4, $adb02518d66b3d9b$var$_descriptor5, $adb02518d66b3d9b$var$_descriptor6, $adb02518d66b3d9b$var$_descriptor7, $adb02518d66b3d9b$var$_descriptor8, $adb02518d66b3d9b$var$_descriptor9, $adb02518d66b3d9b$var$_descriptor10, $adb02518d66b3d9b$var$_descriptor11, $adb02518d66b3d9b$var$_descriptor12, $adb02518d66b3d9b$var$_descriptor13, $adb02518d66b3d9b$var$_descriptor14, $adb02518d66b3d9b$var$_descriptor15, $adb02518d66b3d9b$var$_descriptor16, $adb02518d66b3d9b$var$_descriptor17, $adb02518d66b3d9b$var$_descriptor18;
function $adb02518d66b3d9b$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $adb02518d66b3d9b$var$_defineProperty(e, r, t) {
    return (r = $adb02518d66b3d9b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $adb02518d66b3d9b$var$_toPropertyKey(t) {
    var i = $adb02518d66b3d9b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $adb02518d66b3d9b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $adb02518d66b3d9b$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $adb02518d66b3d9b$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $adb02518d66b3d9b$var$calendarState = ($adb02518d66b3d9b$var$_dec = (0, $4JcCM.action).bound, $adb02518d66b3d9b$var$_dec2 = (0, $4JcCM.action).bound, $adb02518d66b3d9b$var$_dec3 = (0, $4JcCM.action).bound, $adb02518d66b3d9b$var$_dec4 = (0, $4JcCM.action).bound, $adb02518d66b3d9b$var$_dec5 = (0, $4JcCM.action).bound, $adb02518d66b3d9b$var$_dec6 = (0, $4JcCM.action).bound, $adb02518d66b3d9b$var$_dec7 = (0, $4JcCM.action).bound, $adb02518d66b3d9b$var$_dec8 = (0, $4JcCM.action).bound, $adb02518d66b3d9b$var$_dec9 = (0, $4JcCM.action).bound, $adb02518d66b3d9b$var$_dec10 = (0, $4JcCM.action).bound, $adb02518d66b3d9b$var$_dec11 = (0, $4JcCM.action).bound, $adb02518d66b3d9b$var$_dec12 = (0, $4JcCM.action).bound, $adb02518d66b3d9b$var$_dec13 = (0, $4JcCM.action).bound, $adb02518d66b3d9b$var$_dec14 = (0, $4JcCM.action).bound, $adb02518d66b3d9b$var$_dec15 = (0, $4JcCM.action).bound, $adb02518d66b3d9b$var$_dec16 = (0, $4JcCM.action).bound, $adb02518d66b3d9b$var$_dec17 = (0, $4JcCM.action).bound, $adb02518d66b3d9b$var$_dec18 = (0, $4JcCM.action).bound, $adb02518d66b3d9b$var$_class = class calendarState {
    constructor(){
        $adb02518d66b3d9b$var$_initializerDefineProperty(this, "mode", $adb02518d66b3d9b$var$_descriptor, this);
        // or "allocation"
        $adb02518d66b3d9b$var$_initializerDefineProperty(this, "weekStart", $adb02518d66b3d9b$var$_descriptor2, this);
        $adb02518d66b3d9b$var$_initializerDefineProperty(this, "calendarMouseX", $adb02518d66b3d9b$var$_descriptor3, this);
        $adb02518d66b3d9b$var$_initializerDefineProperty(this, "calendarMouseY", $adb02518d66b3d9b$var$_descriptor4, this);
        $adb02518d66b3d9b$var$_initializerDefineProperty(this, "calendarWidth", $adb02518d66b3d9b$var$_descriptor5, this);
        $adb02518d66b3d9b$var$_initializerDefineProperty(this, "calendarHeight", $adb02518d66b3d9b$var$_descriptor6, this);
        $adb02518d66b3d9b$var$_initializerDefineProperty(this, "calendarMinuteEms", $adb02518d66b3d9b$var$_descriptor7, this);
        $adb02518d66b3d9b$var$_initializerDefineProperty(this, "selectedValues", $adb02518d66b3d9b$var$_descriptor8, this);
        $adb02518d66b3d9b$var$_initializerDefineProperty(this, "budgetType", $adb02518d66b3d9b$var$_descriptor9, this);
        $adb02518d66b3d9b$var$_initializerDefineProperty(this, "newItem", $adb02518d66b3d9b$var$_descriptor10, this);
        $adb02518d66b3d9b$var$_initializerDefineProperty(this, "selectedItem", $adb02518d66b3d9b$var$_descriptor11, this);
        $adb02518d66b3d9b$var$_initializerDefineProperty(this, "newItemModal", $adb02518d66b3d9b$var$_descriptor12, this);
        $adb02518d66b3d9b$var$_initializerDefineProperty(this, "editItemModal", $adb02518d66b3d9b$var$_descriptor13, this);
        $adb02518d66b3d9b$var$_initializerDefineProperty(this, "isDeletingItem", $adb02518d66b3d9b$var$_descriptor14, this);
        $adb02518d66b3d9b$var$_initializerDefineProperty(this, "deletingItem", $adb02518d66b3d9b$var$_descriptor15, this);
        $adb02518d66b3d9b$var$_initializerDefineProperty(this, "deleteCountdown", $adb02518d66b3d9b$var$_descriptor16, this);
        $adb02518d66b3d9b$var$_initializerDefineProperty(this, "dragging", $adb02518d66b3d9b$var$_descriptor17, this);
        $adb02518d66b3d9b$var$_initializerDefineProperty(this, "draggingChangeMinutes", $adb02518d66b3d9b$var$_descriptor18, this);
        $adb02518d66b3d9b$var$_defineProperty(this, "deleteTimeout", null);
        (0, $4JcCM.makeObservable)(this);
    }
    init(mode, { date: date, staffId: staffId } = {}) {
        this.mode = mode;
        this.setDefaults();
        if (date) this.setWeekStart(date);
        if (staffId) this.selectedValues.staffId = staffId || (0, $1BTI2.default).userId;
    }
    setDefaults(selectedValues) {
        var _ProjectCollection$pr, _project$phases, _router$latestLocatio, _router$latestLocatio2, _task$isBillable, _task$isVariation;
        const project = (_ProjectCollection$pr = (0, $gJT7h.default).projects) === null || _ProjectCollection$pr === void 0 ? void 0 : _ProjectCollection$pr.sort((a, b)=>{
            var _a$title, _a$title$localeCompar;
            return (_a$title = a.title) === null || _a$title === void 0 ? void 0 : (_a$title$localeCompar = _a$title.localeCompare) === null || _a$title$localeCompar === void 0 ? void 0 : _a$title$localeCompar.call(_a$title, b.title);
        }).filter((p)=>(0, $8kZ1o.canEnterTimeAgainstProject)((0, $1BTI2.default).user, p))[0];
        const phase = project === null || project === void 0 ? void 0 : (_project$phases = project.phases) === null || _project$phases === void 0 ? void 0 : _project$phases.sort((0, $6fNfM.default)).filter((p)=>(0, $8kZ1o.canEnterTimeAgainstPhase)((0, $1BTI2.default).user, p))[0];
        const task = (phase === null || phase === void 0 ? void 0 : phase.defaultTask) || (phase === null || phase === void 0 ? void 0 : phase.tasks[0]);
        this.selectedValues = {
            costCentreId: project === null || project === void 0 ? void 0 : project.costCentreId,
            projectId: project === null || project === void 0 ? void 0 : project.id,
            phaseId: phase === null || phase === void 0 ? void 0 : phase.id,
            taskId: task === null || task === void 0 ? void 0 : task.id,
            staffId: (0, $8kZ1o.canEditStaffTime)((0, $1BTI2.default).user) ? ((_router$latestLocatio = (0, $6Q5sp.router).latestLocation) === null || _router$latestLocatio === void 0 ? void 0 : (_router$latestLocatio2 = _router$latestLocatio.search) === null || _router$latestLocatio2 === void 0 ? void 0 : _router$latestLocatio2.staffId) || (0, $1BTI2.default).userId : (0, $1BTI2.default).userId,
            isBillable: (_task$isBillable = task === null || task === void 0 ? void 0 : task.isBillable) !== null && _task$isBillable !== void 0 ? _task$isBillable : true,
            isVariation: (_task$isVariation = task === null || task === void 0 ? void 0 : task.isVariation) !== null && _task$isVariation !== void 0 ? _task$isVariation : false,
            isOvertime: false,
            isLocked: false,
            remote: false,
            flexi: false,
            numMinutes: 0,
            ...selectedValues
        };
    }
    get weekEnd() {
        return (0, $4hBm1.endOfWeek)(this.weekStart, {
            weekStartsOn: 1
        });
    }
    get weekDays() {
        return [
            ...Array(7).keys()
        ].map((d)=>(0, $4hBm1.addDays)(this.weekStart, d));
    }
    get calendarMouseDay() {
        return this.weekDays[Math.floor(this.calendarMouseX / (this.calendarWidth / 7))];
    }
    get calendarMouseFloatMinutes() {
        return Math.round(this.calendarMouseY / this.calendarHeight * 1440) || 0;
    }
    get calendarMouseHour() {
        return Math.floor(this.calendarMouseFloatMinutes / 60) || 0;
    }
    get calendarMouseMinute() {
        return this.calendarMouseFloatMinutes - this.calendarMouseHour * 60 || 0;
    }
    adjustDragMinutes(adjustment) {
        this.draggingChangeMinutes = adjustment;
    }
    setDragging(isDragging) {
        this.dragging = isDragging;
    }
    setWeekStart(newWeekStart) {
        this.weekStart = (0, $4hBm1.startOfWeek)(newWeekStart, {
            weekStartsOn: 1
        });
        this.setDefaults(this.selectedValues);
        (0, $6Q5sp.router).navigate({
            search: (prev)=>({
                    ...prev,
                    date: (0, $4hBm1.format)(this.weekStart, "yyyy-MM-dd")
                })
        });
    }
    isDayIndexWeekend(dayIndex) {
        return (0, $4hBm1.isWeekend)(this.weekDays[dayIndex]);
    }
    setCalendarMouseData(x, y, width, height) {
        this.calendarMouseX = x;
        this.calendarMouseY = y;
        this.calendarHeight = height;
        this.calendarWidth = width;
    }
    createNewItem(dragging = false) {
        if ((0, $8kZ1o.canLogTimeAgainstNoPhase)() || this.selectedValues.phaseId) {
            this.newItem = {
                ...this.selectedValues,
                id: (0, (/*@__PURE__*/$parcel$interopDefault($gN0TC)))(),
                date: this.calendarMouseDay,
                startMinutes: Math.round(this.calendarMouseFloatMinutes),
                numMinutes: 15,
                get staff () {
                    return (0, $htkeB.default).staffsById[this.staffId];
                },
                get project () {
                    return (0, $gJT7h.default).projectsById[this.projectId];
                },
                get projectPhase () {
                    return (0, $XoImS.default).phasesById[this.phaseId];
                },
                get task () {
                    return (0, $keGWP.default).tasksById[this.taskId];
                }
            };
            if (dragging) this.editSelectedItem(this.newItem, true);
        }
    }
    updateNewItem(newData) {
        for (const [key, val] of Object.entries(newData))this.newItem[key] = val;
    }
    commitNewItem(newData, dragging = false) {
        this.updateNewItem(newData);
        let item;
        if (dragging) this.editSelectedItem(this.newItem, true);
        if (this.mode === "allocation") item = (0, $9VnJj.default).add(this.newItem, {
            trackUpdates: true
        });
        else item = (0, $QiMYe.default).add(this.newItem, {
            trackUpdates: true
        });
        this.newItem = null;
        return item;
    }
    editSelectedItem(data, dragging = false) {
        var _this$selectedItem, _this$selectedItem$up;
        // Check if we need to snap to nearby time entries
        if (dragging && (data.startMinutes !== undefined || data.numMinutes !== undefined)) {
            const currentItem = this.selectedItem || data;
            const staffId = currentItem.staffId;
            const date = currentItem.date;
            // Get all time entries for this staff member on this date
            const timeEntriesForStaffOnDate = (0, $QiMYe.default).timeEntriesByStaffIdDate[(0, $f44xu.default)(staffId, date.getTime())] || [];
            // Filter out the current entry
            const otherTimeEntries = timeEntriesForStaffOnDate.filter((entry)=>entry.id !== currentItem.id);
            if (otherTimeEntries.length > 0) {
                const newStartMinutes = data.startMinutes !== undefined ? data.startMinutes : currentItem.startMinutes;
                const newNumMinutes = data.numMinutes !== undefined ? data.numMinutes : currentItem.numMinutes;
                const newEndMinutes = newStartMinutes + newNumMinutes;
                // Check for nearby entries to snap to
                let snappedStartMinutes = Math.round(newStartMinutes / 15) * 15;
                let snappedEndMinutes = Math.round(newEndMinutes / 15) * 15;
                for (const entry of otherTimeEntries){
                    const entryStart = entry.startMinutes;
                    const entryEnd = entry.startMinutes + entry.numMinutes;
                    // Check if start time is within 15 minutes of another entry's end time
                    if (Math.abs(newStartMinutes - entryEnd) <= 15) // Snap to the minute after the other entry
                    snappedStartMinutes = entryEnd;
                    // Check if end time is within 15 minutes of another entry's start time
                    if (Math.abs(newEndMinutes - entryStart) <= 15) // Snap to the minute before the other entry
                    snappedEndMinutes = entryStart;
                }
                // Update the data with snapped values
                if (data.startMinutes !== undefined) data.startMinutes = snappedStartMinutes;
                if (data.numMinutes !== undefined) {
                    // Recalculate numMinutes based on snapped end time
                    data.numMinutes = snappedEndMinutes - snappedStartMinutes;
                    // Ensure minimum duration of 15 minutes
                    if (data.numMinutes < 15) data.numMinutes = 15;
                }
            } else {
                if (data.startMinutes !== undefined) data.startMinutes = Math.round(data.startMinutes / 15) * 15;
                if (data.numMinutes !== undefined) data.numMinutes = Math.round(data.numMinutes / 15) * 15;
            }
        }
        (_this$selectedItem = this.selectedItem) === null || _this$selectedItem === void 0 || (_this$selectedItem$up = _this$selectedItem.update) === null || _this$selectedItem$up === void 0 || _this$selectedItem$up.call(_this$selectedItem, data);
    }
    selectItem(item) {
        var _item$project, _item$project2, _item$phase, _item$task;
        this.deleteCountdown = 0;
        this.selectedItem = item;
        console.log(item === null || item === void 0 ? void 0 : item.date);
        this.selectedValues = {
            costCentreId: item === null || item === void 0 ? void 0 : (_item$project = item.project) === null || _item$project === void 0 ? void 0 : _item$project.costCentreId,
            projectId: item === null || item === void 0 ? void 0 : (_item$project2 = item.project) === null || _item$project2 === void 0 ? void 0 : _item$project2.id,
            phaseId: item === null || item === void 0 ? void 0 : (_item$phase = item.phase) === null || _item$phase === void 0 ? void 0 : _item$phase.id,
            taskId: item === null || item === void 0 ? void 0 : (_item$task = item.task) === null || _item$task === void 0 ? void 0 : _item$task.id,
            staffId: item === null || item === void 0 ? void 0 : item.staffId,
            isBillable: item === null || item === void 0 ? void 0 : item.isBillable,
            isVariation: item === null || item === void 0 ? void 0 : item.isVariation,
            isOvertime: item === null || item === void 0 ? void 0 : item.isOvertime,
            isLocked: item === null || item === void 0 ? void 0 : item.isLocked,
            remote: item === null || item === void 0 ? void 0 : item.remote,
            flexi: item === null || item === void 0 ? void 0 : item.flexi,
            numMinutes: item === null || item === void 0 ? void 0 : item.numMinutes,
            notes: item === null || item === void 0 ? void 0 : item.notes,
            date: item === null || item === void 0 ? void 0 : item.date
        };
        this.selectedValues.date = new Date(this.selectedValues.date);
        this.selectedValues.updatedAt = new Date(this.selectedValues.updatedAt);
    //TODO
    // budgetStore.getBudget(
    //     this.weekStart,
    //     this.selectedItem ? this.selectedItem.date : this.weekStart,
    //     this.mode,
    //     this.selectedValues.staffId,
    //     this.selectedValues.projectId,
    //     this.selectedValues.phaseId
    // )
    }
    deselectItem() {
        if (this.selectedItem) {
            var _this$selectedItem$ta, _this$selectedItem2, _this$selectedItem2$t, _this$selectedItem$ta2, _this$selectedItem3, _this$selectedItem3$t;
            this.deleteCountdown = 0;
            this.selectedValues = {
                ...this.selectedValues,
                isBillable: (_this$selectedItem$ta = (_this$selectedItem2 = this.selectedItem) === null || _this$selectedItem2 === void 0 ? void 0 : (_this$selectedItem2$t = _this$selectedItem2.task) === null || _this$selectedItem2$t === void 0 ? void 0 : _this$selectedItem2$t.isBillable) !== null && _this$selectedItem$ta !== void 0 ? _this$selectedItem$ta : true,
                isVariation: (_this$selectedItem$ta2 = (_this$selectedItem3 = this.selectedItem) === null || _this$selectedItem3 === void 0 ? void 0 : (_this$selectedItem3$t = _this$selectedItem3.task) === null || _this$selectedItem3$t === void 0 ? void 0 : _this$selectedItem3$t.isVariation) !== null && _this$selectedItem$ta2 !== void 0 ? _this$selectedItem$ta2 : false,
                isOvertime: false,
                isLocked: false,
                remote: false,
                flexi: false,
                notes: ""
            };
            this.selectedItem = null;
        }
    }
    updateSelectedValues(data, save = true) {
        var _this$selectedItem4, _this$selectedItem4$p, _this$selectedItem5, _this$selectedItem5$p, _this$selectedItem6, _this$selectedItem6$p, _this$selectedItem7, _this$selectedItem7$t, _this$selectedItem8, _this$selectedItem9, _this$selectedItem10, _this$selectedItem11, _this$selectedItem12, _this$selectedItem13, _this$selectedItem14, _this$selectedItem15, _this$selectedItem16, _this$selectedItem17;
        this.selectedValues = {
            ...this.selectedValues,
            ...this.selectedItem ? {
                costCentreId: (_this$selectedItem4 = this.selectedItem) === null || _this$selectedItem4 === void 0 ? void 0 : (_this$selectedItem4$p = _this$selectedItem4.project) === null || _this$selectedItem4$p === void 0 ? void 0 : _this$selectedItem4$p.costCentreId,
                projectId: (_this$selectedItem5 = this.selectedItem) === null || _this$selectedItem5 === void 0 ? void 0 : (_this$selectedItem5$p = _this$selectedItem5.project) === null || _this$selectedItem5$p === void 0 ? void 0 : _this$selectedItem5$p.id,
                phaseId: (_this$selectedItem6 = this.selectedItem) === null || _this$selectedItem6 === void 0 ? void 0 : (_this$selectedItem6$p = _this$selectedItem6.phase) === null || _this$selectedItem6$p === void 0 ? void 0 : _this$selectedItem6$p.id,
                taskId: (_this$selectedItem7 = this.selectedItem) === null || _this$selectedItem7 === void 0 ? void 0 : (_this$selectedItem7$t = _this$selectedItem7.task) === null || _this$selectedItem7$t === void 0 ? void 0 : _this$selectedItem7$t.id,
                staffId: (_this$selectedItem8 = this.selectedItem) === null || _this$selectedItem8 === void 0 ? void 0 : _this$selectedItem8.staffId,
                isBillable: (_this$selectedItem9 = this.selectedItem) === null || _this$selectedItem9 === void 0 ? void 0 : _this$selectedItem9.isBillable,
                isVariation: (_this$selectedItem10 = this.selectedItem) === null || _this$selectedItem10 === void 0 ? void 0 : _this$selectedItem10.isVariation,
                isOvertime: (_this$selectedItem11 = this.selectedItem) === null || _this$selectedItem11 === void 0 ? void 0 : _this$selectedItem11.isOvertime,
                isLocked: (_this$selectedItem12 = this.selectedItem) === null || _this$selectedItem12 === void 0 ? void 0 : _this$selectedItem12.isLocked,
                remote: (_this$selectedItem13 = this.selectedItem) === null || _this$selectedItem13 === void 0 ? void 0 : _this$selectedItem13.remote,
                flexi: (_this$selectedItem14 = this.selectedItem) === null || _this$selectedItem14 === void 0 ? void 0 : _this$selectedItem14.flexi,
                numMinutes: (_this$selectedItem15 = this.selectedItem) === null || _this$selectedItem15 === void 0 ? void 0 : _this$selectedItem15.numMinutes,
                notes: (_this$selectedItem16 = this.selectedItem) === null || _this$selectedItem16 === void 0 ? void 0 : _this$selectedItem16.notes,
                date: (_this$selectedItem17 = this.selectedItem) === null || _this$selectedItem17 === void 0 ? void 0 : _this$selectedItem17.date
            } : {},
            ...data
        };
        if ("projectId" in data) {
            var _project$phases2, _task$isBillable2, _task$isVariation2;
            const project = (0, $gJT7h.default).projectsById[data.projectId];
            const phase = project === null || project === void 0 ? void 0 : (_project$phases2 = project.phases) === null || _project$phases2 === void 0 ? void 0 : _project$phases2.sort((0, $6fNfM.default)).filter((p)=>(0, $8kZ1o.canEnterTimeAgainstPhase)((0, $1BTI2.default).user, p))[0];
            const task = (phase === null || phase === void 0 ? void 0 : phase.defaultTask) || (phase === null || phase === void 0 ? void 0 : phase.tasks[0]);
            this.selectedValues = {
                ...this.selectedValues,
                costCentreId: project === null || project === void 0 ? void 0 : project.costCentreId,
                projectId: project === null || project === void 0 ? void 0 : project.id,
                phaseId: phase === null || phase === void 0 ? void 0 : phase.id,
                taskId: task === null || task === void 0 ? void 0 : task.id,
                isBillable: (_task$isBillable2 = task === null || task === void 0 ? void 0 : task.isBillable) !== null && _task$isBillable2 !== void 0 ? _task$isBillable2 : true,
                isVariation: (_task$isVariation2 = task === null || task === void 0 ? void 0 : task.isVariation) !== null && _task$isVariation2 !== void 0 ? _task$isVariation2 : false
            };
        }
        if ("phaseId" in data) {
            var _task$isBillable3, _task$isVariation3;
            const phase = (0, $XoImS.default).phasesById[data.phaseId];
            const task = (phase === null || phase === void 0 ? void 0 : phase.defaultTask) || (phase === null || phase === void 0 ? void 0 : phase.tasks[0]);
            this.selectedValues = {
                ...this.selectedValues,
                taskId: task === null || task === void 0 ? void 0 : task.id,
                isBillable: (_task$isBillable3 = task === null || task === void 0 ? void 0 : task.isBillable) !== null && _task$isBillable3 !== void 0 ? _task$isBillable3 : true,
                isVariation: (_task$isVariation3 = task === null || task === void 0 ? void 0 : task.isVariation) !== null && _task$isVariation3 !== void 0 ? _task$isVariation3 : false
            };
        }
        if (this.selectedItem && save) this.editSelectedItem(this.selectedValues);
    }
    updateSelectedStaffId(id) {
        this.setDefaults({
            staffId: id
        });
    }
    deleteSelectedItem() {
        this.isDeletingItem = true;
        this.deleteStartTimestamp = Date.now();
        this.deletingItem = this.selectedItem;
        this.deleteCountdown = 5;
        this.deleteTimeout = setInterval(()=>this.deleteItemInterval(this.deletingItem), 1000);
    }
    deleteItemInterval(item) {
        if (this.deleteCountdown > 0) this.deleteCountdown--;
        else {
            if (this.deletingSelectedItem) this.deselectItem();
            item.update({
                deletedAt: new Date()
            });
            this.isDeletingItem = false;
            this.deleteCountdown = 5;
            this.deletingItem = null;
            clearInterval(this.deleteTimeout);
        }
    }
    undoDeleteSelectedItem() {
        this.isDeletingItem = false;
        this.deleteCountdown = 5;
        this.deletingItem = null;
        clearInterval(this.deleteTimeout);
    }
    get deletingSelectedItem() {
        return this.selectedItem && this.deletingItem === this.selectedItem;
    }
    changeBudgetType(newType) {
        this.budgetType = newType;
    }
    get dayTotals() {
        const dayTotals = {
            0: {
                hours: 0,
                minutes: 0
            },
            1: {
                hours: 0,
                minutes: 0
            },
            2: {
                hours: 0,
                minutes: 0
            },
            3: {
                hours: 0,
                minutes: 0
            },
            4: {
                hours: 0,
                minutes: 0
            },
            5: {
                hours: 0,
                minutes: 0
            },
            6: {
                hours: 0,
                minutes: 0
            }
        };
        const maxEndTimes = {
            0: 540,
            1: 540,
            2: 540,
            3: 540,
            4: 540,
            5: 540,
            6: 540
        };
        const items = this.mode === "allocation" ? (0, $9VnJj.default).dailyAllocations : (0, $QiMYe.default).timeEntries;
        let models = items.filter((te)=>te.staffId === this.selectedValues.staffId && (0, $4hBm1.isSameWeek)(te.date, this.weekStart, {
                weekStartsOn: 1
            }) && !te.deletedAt) || [];
        models.forEach((t)=>{
            const diffDays = (0, $4hBm1.differenceInDays)(t.date, this.weekStart);
            if (diffDays >= 0 && diffDays < 7) {
                dayTotals[diffDays].hours += Math.floor(t.numMinutes / 60);
                dayTotals[diffDays].minutes += Math.round(t.numMinutes % 60);
                dayTotals[diffDays].hours += Math.floor(dayTotals[diffDays].minutes / 60);
                dayTotals[diffDays].minutes = Math.round(dayTotals[diffDays].minutes % 60);
            }
            if (t.startMinutes && t.numMinutes) maxEndTimes[diffDays] = Math.max(maxEndTimes[diffDays], t.startMinutes + t.numMinutes);
        });
        models.forEach((t)=>{
            const diffDays = (0, $4hBm1.differenceInDays)(t.date, this.weekStart);
            if (!t.startMinutes && t.numMinutes) {
                t.startMinutes = maxEndTimes[diffDays];
                maxEndTimes[diffDays] += t.numMinutes;
            }
        });
        return dayTotals;
    }
    getTotalOnDate(date) {
        const items = this.mode === "allocation" ? (0, $9VnJj.default).dailyAllocations : (0, $QiMYe.default).timeEntries;
        let models = items.filter((te)=>te.staffId === this.selectedValues.staffId && te.date.getTime() === date.getTime() && !te.deletedAt) || [];
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(models.map((te)=>te.numMinutes));
    }
}, $adb02518d66b3d9b$var$_descriptor = $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "mode", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "time";
    }
}), $adb02518d66b3d9b$var$_descriptor2 = $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "weekStart", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return (0, $4hBm1.startOfWeek)(new Date(), {
            weekStartsOn: 1
        });
    }
}), $adb02518d66b3d9b$var$_descriptor3 = $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "calendarMouseX", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $adb02518d66b3d9b$var$_descriptor4 = $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "calendarMouseY", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $adb02518d66b3d9b$var$_descriptor5 = $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "calendarWidth", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 100;
    }
}), $adb02518d66b3d9b$var$_descriptor6 = $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "calendarHeight", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 100;
    }
}), $adb02518d66b3d9b$var$_descriptor7 = $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "calendarMinuteEms", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0.1;
    }
}), $adb02518d66b3d9b$var$_descriptor8 = $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "selectedValues", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {
            costCentreId: null,
            projectId: null,
            phaseId: null,
            taskId: null,
            staffId: null,
            isBillable: true,
            isVariation: false,
            isOvertime: false,
            isLocked: false,
            remote: false,
            flexi: false
        };
    }
}), $adb02518d66b3d9b$var$_descriptor9 = $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "budgetType", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "phase";
    }
}), $adb02518d66b3d9b$var$_descriptor10 = $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "newItem", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $adb02518d66b3d9b$var$_descriptor11 = $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "selectedItem", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $adb02518d66b3d9b$var$_descriptor12 = $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "newItemModal", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $adb02518d66b3d9b$var$_descriptor13 = $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "editItemModal", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $adb02518d66b3d9b$var$_descriptor14 = $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "isDeletingItem", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $adb02518d66b3d9b$var$_descriptor15 = $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "deletingItem", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $adb02518d66b3d9b$var$_descriptor16 = $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "deleteCountdown", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 5;
    }
}), $adb02518d66b3d9b$var$_descriptor17 = $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "dragging", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $adb02518d66b3d9b$var$_descriptor18 = $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "draggingChangeMinutes", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "init", [
    $adb02518d66b3d9b$var$_dec
], Object.getOwnPropertyDescriptor($adb02518d66b3d9b$var$_class.prototype, "init"), $adb02518d66b3d9b$var$_class.prototype), $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "setDefaults", [
    (0, $4JcCM.action)
], Object.getOwnPropertyDescriptor($adb02518d66b3d9b$var$_class.prototype, "setDefaults"), $adb02518d66b3d9b$var$_class.prototype), $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "weekEnd", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($adb02518d66b3d9b$var$_class.prototype, "weekEnd"), $adb02518d66b3d9b$var$_class.prototype), $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "weekDays", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($adb02518d66b3d9b$var$_class.prototype, "weekDays"), $adb02518d66b3d9b$var$_class.prototype), $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "calendarMouseDay", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($adb02518d66b3d9b$var$_class.prototype, "calendarMouseDay"), $adb02518d66b3d9b$var$_class.prototype), $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "calendarMouseFloatMinutes", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($adb02518d66b3d9b$var$_class.prototype, "calendarMouseFloatMinutes"), $adb02518d66b3d9b$var$_class.prototype), $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "calendarMouseHour", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($adb02518d66b3d9b$var$_class.prototype, "calendarMouseHour"), $adb02518d66b3d9b$var$_class.prototype), $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "calendarMouseMinute", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($adb02518d66b3d9b$var$_class.prototype, "calendarMouseMinute"), $adb02518d66b3d9b$var$_class.prototype), $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "adjustDragMinutes", [
    $adb02518d66b3d9b$var$_dec2
], Object.getOwnPropertyDescriptor($adb02518d66b3d9b$var$_class.prototype, "adjustDragMinutes"), $adb02518d66b3d9b$var$_class.prototype), $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "setDragging", [
    $adb02518d66b3d9b$var$_dec3
], Object.getOwnPropertyDescriptor($adb02518d66b3d9b$var$_class.prototype, "setDragging"), $adb02518d66b3d9b$var$_class.prototype), $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "setWeekStart", [
    $adb02518d66b3d9b$var$_dec4
], Object.getOwnPropertyDescriptor($adb02518d66b3d9b$var$_class.prototype, "setWeekStart"), $adb02518d66b3d9b$var$_class.prototype), $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "isDayIndexWeekend", [
    $adb02518d66b3d9b$var$_dec5
], Object.getOwnPropertyDescriptor($adb02518d66b3d9b$var$_class.prototype, "isDayIndexWeekend"), $adb02518d66b3d9b$var$_class.prototype), $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "setCalendarMouseData", [
    $adb02518d66b3d9b$var$_dec6
], Object.getOwnPropertyDescriptor($adb02518d66b3d9b$var$_class.prototype, "setCalendarMouseData"), $adb02518d66b3d9b$var$_class.prototype), $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "createNewItem", [
    $adb02518d66b3d9b$var$_dec7
], Object.getOwnPropertyDescriptor($adb02518d66b3d9b$var$_class.prototype, "createNewItem"), $adb02518d66b3d9b$var$_class.prototype), $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "updateNewItem", [
    $adb02518d66b3d9b$var$_dec8
], Object.getOwnPropertyDescriptor($adb02518d66b3d9b$var$_class.prototype, "updateNewItem"), $adb02518d66b3d9b$var$_class.prototype), $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "commitNewItem", [
    $adb02518d66b3d9b$var$_dec9
], Object.getOwnPropertyDescriptor($adb02518d66b3d9b$var$_class.prototype, "commitNewItem"), $adb02518d66b3d9b$var$_class.prototype), $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "editSelectedItem", [
    $adb02518d66b3d9b$var$_dec10
], Object.getOwnPropertyDescriptor($adb02518d66b3d9b$var$_class.prototype, "editSelectedItem"), $adb02518d66b3d9b$var$_class.prototype), $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "selectItem", [
    $adb02518d66b3d9b$var$_dec11
], Object.getOwnPropertyDescriptor($adb02518d66b3d9b$var$_class.prototype, "selectItem"), $adb02518d66b3d9b$var$_class.prototype), $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "deselectItem", [
    $adb02518d66b3d9b$var$_dec12
], Object.getOwnPropertyDescriptor($adb02518d66b3d9b$var$_class.prototype, "deselectItem"), $adb02518d66b3d9b$var$_class.prototype), $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "updateSelectedValues", [
    $adb02518d66b3d9b$var$_dec13
], Object.getOwnPropertyDescriptor($adb02518d66b3d9b$var$_class.prototype, "updateSelectedValues"), $adb02518d66b3d9b$var$_class.prototype), $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "updateSelectedStaffId", [
    $adb02518d66b3d9b$var$_dec14
], Object.getOwnPropertyDescriptor($adb02518d66b3d9b$var$_class.prototype, "updateSelectedStaffId"), $adb02518d66b3d9b$var$_class.prototype), $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "deleteSelectedItem", [
    $adb02518d66b3d9b$var$_dec15
], Object.getOwnPropertyDescriptor($adb02518d66b3d9b$var$_class.prototype, "deleteSelectedItem"), $adb02518d66b3d9b$var$_class.prototype), $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "deleteItemInterval", [
    $adb02518d66b3d9b$var$_dec16
], Object.getOwnPropertyDescriptor($adb02518d66b3d9b$var$_class.prototype, "deleteItemInterval"), $adb02518d66b3d9b$var$_class.prototype), $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "undoDeleteSelectedItem", [
    $adb02518d66b3d9b$var$_dec17
], Object.getOwnPropertyDescriptor($adb02518d66b3d9b$var$_class.prototype, "undoDeleteSelectedItem"), $adb02518d66b3d9b$var$_class.prototype), $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "deletingSelectedItem", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($adb02518d66b3d9b$var$_class.prototype, "deletingSelectedItem"), $adb02518d66b3d9b$var$_class.prototype), $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "changeBudgetType", [
    $adb02518d66b3d9b$var$_dec18
], Object.getOwnPropertyDescriptor($adb02518d66b3d9b$var$_class.prototype, "changeBudgetType"), $adb02518d66b3d9b$var$_class.prototype), $adb02518d66b3d9b$var$_applyDecoratedDescriptor($adb02518d66b3d9b$var$_class.prototype, "dayTotals", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($adb02518d66b3d9b$var$_class.prototype, "dayTotals"), $adb02518d66b3d9b$var$_class.prototype), $adb02518d66b3d9b$var$_class);
var $adb02518d66b3d9b$export$2e2bcd8739ae039 = new $adb02518d66b3d9b$var$calendarState();

});




parcelRegister("A8k4f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06c9d19db080a3b1$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $1EEMt = parcelRequire("1EEMt");

var $fEcKX = parcelRequire("fEcKX");

var $6RcUP = parcelRequire("6RcUP");

var $lu0ti = parcelRequire("lu0ti");

var $fM2j4 = parcelRequire("fM2j4");

var $hHlvy = parcelRequire("hHlvy");

var $ewAM3 = parcelRequire("ewAM3");

var $3X7oM = parcelRequire("3X7oM");

var $3h7sC = parcelRequire("3h7sC");

var $47i9t = parcelRequire("47i9t");
var $06c9d19db080a3b1$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ modalId: modalId, defaultSelectedTemplate: defaultSelectedTemplate, defaultState: defaultState })=>{
    const templates = (0, $lu0ti.default).descriptionTemplates.filter((dt)=>!dt.deletedAt);
    const [selectedTemplate, setSelectedTemplate] = (0, $jbmdS.useState)(defaultSelectedTemplate);
    const [state, setState] = (0, $jbmdS.useState)(defaultState || "display");
    const [name, setName] = (0, $jbmdS.useState)(selectedTemplate === null || selectedTemplate === void 0 ? void 0 : selectedTemplate.name);
    const [description, setDescription] = (0, $jbmdS.useState)(selectedTemplate === null || selectedTemplate === void 0 ? void 0 : selectedTemplate.description);
    console.log(state);
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fEcKX.default), {
        modalId: modalId,
        heading: "Invoice Templates",
        onSave: ()=>{
            if (state === "edit") {
                selectedTemplate.update({
                    name: name,
                    description: description
                });
                (0, $fM2j4.default).saveModel(selectedTemplate);
            }
        },
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6RcUP.default), {
            queryIds: [
                {
                    queryFn: async ()=>{
                        const templates = await (0, $3h7sC.trpc).legacy.getInvoiceDescriptionTemplates.query();
                        return (0, $47i9t.processTRPCData)(templates);
                    }
                }
            ],
            children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "description-template-modal",
                children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    className: "p-6",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            className: "flex w-full gap-2",
                            children: [
                                state === "display" && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                                    // style={{marginLeft: '0.5em'}}
                                    className: "flex-auto",
                                    value: selectedTemplate,
                                    onChange: (template)=>{
                                        setSelectedTemplate(template);
                                        setName(template.name);
                                        setDescription(template.description);
                                    },
                                    options: templates.map((t)=>({
                                            label: `${t.name}`,
                                            value: t
                                        })),
                                    placeholder: "Select Template...",
                                    variant: "secondary"
                                }),
                                state === "edit" && /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
                                    style: {
                                        padding: "0.5em 1em",
                                        fontSize: "1em",
                                        borderRadius: "0.5em",
                                        border: "1px solid #ccc"
                                    },
                                    className: "flex-auto",
                                    value: name || "",
                                    onChange: (event)=>setName(event.target.value)
                                }),
                                (selectedTemplate === null || selectedTemplate === void 0 ? void 0 : selectedTemplate.id) && state === "edit" && /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                                    className: "flex-[0_0_0%] btn btn-danger",
                                    style: {
                                        margin: "0 0 0 0.5em"
                                    },
                                    onClick: (e)=>{
                                        selectedTemplate.update({
                                            deletedAt: new Date()
                                        });
                                        setSelectedTemplate(null);
                                        setState("display");
                                    },
                                    children: "Delete"
                                }),
                                selectedTemplate && state === "display" && /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                                    className: "flex-[0_0_0%] btn btn-primary",
                                    style: {
                                        margin: "0 0 0 0.5em"
                                    },
                                    onClick: (e)=>{
                                        setState("edit");
                                        setName(selectedTemplate.name);
                                        setDescription(selectedTemplate.description);
                                    },
                                    children: "Edit"
                                }),
                                state === "edit" && /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                                    className: "flex-[0_0_0%] btn btn-success",
                                    style: {
                                        margin: "0 0 0 0.5em"
                                    },
                                    onClick: (e)=>{
                                        selectedTemplate.update({
                                            name: name,
                                            description: description
                                        });
                                        (0, $fM2j4.default).saveModel(selectedTemplate);
                                        setState("display");
                                    },
                                    children: "Save"
                                }),
                                state === "display" && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3X7oM.default), {
                                    label: "+ New",
                                    onClick: (e)=>{
                                        const newTemplate = (0, $lu0ti.default).add({
                                            name: "New Template",
                                            description: "Template description..."
                                        }, {
                                            trackUpdates: true
                                        });
                                        setSelectedTemplate(newTemplate);
                                        setName(newTemplate.name);
                                        setDescription(newTemplate.description);
                                        setState("edit");
                                        (0, $fM2j4.default).saveModel(newTemplate);
                                    },
                                    variant: "secondary",
                                    className: "flex-[0_0_0%]"
                                }),
                                state === "edit" && /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                                    className: "flex-[0_0_0%] btn btn-default",
                                    style: {
                                        margin: "0 0 0 0.5em"
                                    },
                                    onClick: (e)=>setState("display"),
                                    children: "Cancel"
                                })
                            ]
                        }),
                        selectedTemplate && state === "display" && /*#__PURE__*/ (0, $61Ea1.jsx)("p", {
                            style: {
                                width: "100%",
                                marginTop: "1em",
                                padding: "1em"
                            },
                            children: `"  ${selectedTemplate.description}  "`
                        }),
                        selectedTemplate && state === "edit" && /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            style: {
                                position: "relative"
                            },
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("textarea", {
                                    rows: 8,
                                    style: {
                                        width: "100%",
                                        marginTop: "1em",
                                        padding: "1em",
                                        borderRadius: "0.5em"
                                    },
                                    value: description,
                                    disabled: state === "display",
                                    onChange: (event)=>setDescription(event.target.value)
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hHlvy.InvoiceCodeInfo), {
                                    style: {
                                        position: "absolute",
                                        top: "1.4em",
                                        right: 0
                                    }
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
});

});
parcelRegister("hHlvy", function(module, exports) {

$parcel$export(module.exports, "InvoiceCodeInfo", function () { return $ce2722d3928cffd7$export$d66be3f51de1fc2a; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $hrKXR = parcelRequire("hrKXR");
const $ce2722d3928cffd7$export$d66be3f51de1fc2a = (props)=>{
    const { style: style, ...extraProps } = props;
    const [showDropdown, setShowDropdown] = (0, $jbmdS.useState)(false);
    const [hoveredKey, setHoveredKey] = (0, $jbmdS.useState)(null);
    const [copiedKey, setCopiedKey] = (0, $jbmdS.useState)(null);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        style: {
            position: "relative",
            display: "inline-block",
            ...style
        },
        ...extraProps,
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                onClick: (e)=>setShowDropdown(!showDropdown),
                className: "fa fa-question-circle mr-2.5"
            }),
            showDropdown && /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    position: "absolute",
                    right: 0,
                    top: "2em",
                    textAlign: "right",
                    zIndex: 100,
                    fontSize: "0.9em",
                    border: "1px solid #ddd",
                    borderRadius: "0.5em",
                    background: "white",
                    boxShadow: "9px 7px 17px -4px rgb(0,0,0,0.2)"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        style: {
                            padding: "0.5em 1em",
                            borderBottom: "1px solid #ddd"
                        },
                        children: "Description Codes"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        style: {
                            overflowY: "scroll",
                            height: "15em"
                        },
                        children: Object.keys($ce2722d3928cffd7$var$invoiceCodes).map((k)=>{
                            const hovering = hoveredKey === k;
                            const copied = copiedKey === k;
                            return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                style: {
                                    padding: "0.5em 1em",
                                    borderBottom: "1px solid #eee",
                                    fontWeight: "normal",
                                    background: hovering ? "#f9f9f9" : "white",
                                    cursor: "pointer",
                                    position: "relative"
                                },
                                onPointerOver: (e)=>setHoveredKey(k),
                                onPointerOut: (e)=>hoveredKey === k && setHoveredKey(null),
                                onClick: (e)=>{
                                    setCopiedKey(k);
                                    (0, (/*@__PURE__*/$parcel$interopDefault($hrKXR)))(`[${k}]`);
                                    setTimeout(()=>{
                                        setHoveredKey(null);
                                        setCopiedKey(null);
                                        setShowDropdown(false);
                                    }, 500);
                                },
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                    children: copied ? "Copied!" : `[${k}]`
                                })
                            });
                        })
                    })
                ]
            }),
            $ce2722d3928cffd7$var$invoiceCodes[hoveredKey] && /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    position: "absolute",
                    left: "2.5em",
                    top: "4.5em",
                    fontSize: "0.9em",
                    width: "15em",
                    padding: "1em",
                    border: "1px solid #ddd",
                    borderRadius: "0.5em",
                    background: "white",
                    boxShadow: "9px 7px 17px -4px rgb(0,0,0,0.2)",
                    zIndex: 100
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        children: $ce2722d3928cffd7$var$invoiceCodes[hoveredKey]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        style: {
                            fontSize: "0.9em",
                            fontStyle: "italic",
                            fontWeight: "normal",
                            marginTop: "1em"
                        },
                        children: "<--- Click to Copy"
                    })
                ]
            })
        ]
    });
};
const $ce2722d3928cffd7$var$invoiceCodes = {
    project: "Project name",
    projectcode: "Project Job Number",
    phase: "Phase Name",
    phasecode: "Phase Code",
    phasefee: "Total Agreed Fee for Phase",
    phaseprogress: "Percentage Progress billed Phase Fee for This Invoice",
    quantity: "The Quantity value of this Line Item",
    remainingprogress: "Remaining Percentage Progress billed Phase Fee after This Invoice",
    previousprogress: "Previous Percentage Progress billed Phase Fee prior to This Invoice",
    currentbilled: "Current Amount charged against Phase Fee in This Invoice",
    previousbilled: "Previous Amount charged against Phase Fee prior to This Invoice",
    todatebilled: "Amount To Date charged against Phase before and including This Invoice",
    remainingbilled: "Amount Remaining to be billed after This Invoice",
    hours: "Number of Hours being billed for in Timesheet Line Item",
    staff: "Names of Staff who worked on hours in Timesheet Line Item",
    expensename: "Name of Expense",
    expensetotal: "Total Fee for this Expense",
    expenseprevious: "Previous Amount billed for Expense prior to This Invoice",
    expensecurrent: "Current Amount billed for Expense in This Invoice",
    expensetodate: "Amount Billed To Date, for Expense prior and Including This Invoice",
    expenseremaining: "Remaining Amount to be billed for Expense after This Invoice",
    expenseprogress: "Percentage Progress of Total Expense Fee, including This Invoice",
    expensepreviousprogress: "Previous Percentage Progress of Total Expense Fee, prior to This Invoice",
    expenseremainingprogress: "Remaining Percentage Progress Total Expense Fee to be billed after This Invoice"
};

});


parcelRegister("afeg2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77565d6086f51697$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $1EEMt = parcelRequire("1EEMt");

var $fEcKX = parcelRequire("fEcKX");

var $ewAM3 = parcelRequire("ewAM3");
parcelRequire("ek5Pm");

var $7GQic = parcelRequire("7GQic");

var $6RcUP = parcelRequire("6RcUP");

var $cxnwP = parcelRequire("cxnwP");

var $gJT7h = parcelRequire("gJT7h");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $eat5C = parcelRequire("eat5C");
parcelRequire("jE5CX");
parcelRequire("eBwNQ");
var $6Cfc8 = parcelRequire("6Cfc8");
parcelRequire("6un1H");

var $47i9t = parcelRequire("47i9t");

var $6UBLf = parcelRequire("6UBLf");

var $3h7sC = parcelRequire("3h7sC");
var $77565d6086f51697$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ modalId: modalId })=>{
    const navigate = (0, $6UBLf.useNavigate)();
    const [project, setProject] = (0, $jbmdS.useState)(null);
    const [startDate, setStartDate] = (0, $jbmdS.useState)(null);
    const [endDate, setEndDate] = (0, $jbmdS.useState)(new Date());
    const [creating, setCreating] = (0, $jbmdS.useState)(false);
    const earliestInvoice = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).min((0, $cxnwP.default).invoices.map((inv)=>inv.updatedAt));
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fEcKX.default), {
        modalId: modalId,
        heading: "New Invoice",
        canSave: ()=>project && startDate && endDate,
        saveLabel: creating ? "Creating..." : "Create Invoice",
        onSave: async ()=>{
            setCreating(true);
            try {
                const invoiceData = await (0, $3h7sC.trpc).legacy.getNewInvoiceData.query({
                    projectId: project.id,
                    startDate: startDate,
                    endDate: endDate
                });
                (0, $47i9t.processTRPCData)(invoiceData);
            } catch (error) {
                console.error("Failed to fetch and process new invoice data:", error);
                setCreating(false);
                return;
            }
            try {
                const invoice = await (0, $cxnwP.default).createInvoice(project, startDate, endDate);
                navigate({
                    to: "/invoices/$id",
                    params: {
                        id: invoice.id
                    }
                });
            } catch (error) {
                console.error("Failed to create invoice:", error);
                alert("Failed to create invoice. Please try again.");
            } finally{
                setCreating(false);
            }
        },
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            className: "px-3.5 pt-3.5 pb-20",
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    className: "text-444 font-bold mb-1 text-sm",
                    children: "Select project:"
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    className: "max-w-max",
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.ProjectSelector), {
                        value: project,
                        onChange: setProject,
                        projectOptions: (0, $gJT7h.default).projects.filter((p)=>(0, $8kZ1o.canCreateInvoiceForProject)((0, $1BTI2.default).user, p)),
                        variant: "secondary"
                    })
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    style: {
                        marginTop: "1em"
                    },
                    children: project ? /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $6RcUP.default), {
                        queryIds: [
                            {
                                id: project.id + "newInvDates",
                                queryFn: async ()=>{
                                    var _SessionStore$organis;
                                    let newStartDate = null;
                                    const res = await (0, $3h7sC.trpc).legacy.getNewInvoiceDates.query({
                                        projectId: project.id
                                    });
                                    const invMaxDate = res !== null && res !== void 0 && res.maxDate ? new Date(res.maxDate) : null;
                                    const timeMinDate = res !== null && res !== void 0 && res.minDate ? new Date(res.minDate) : null;
                                    if (((0, $1BTI2.default) === null || (0, $1BTI2.default) === void 0 ? void 0 : (_SessionStore$organis = (0, $1BTI2.default).organisation) === null || _SessionStore$organis === void 0 ? void 0 : _SessionStore$organis.id) === "97a4070d-0bc0-4a1a-b907-b4e3f612a70c") newStartDate = invMaxDate || timeMinDate ? new Date((0, $6Cfc8.default)([
                                        invMaxDate,
                                        timeMinDate
                                    ])) : new Date();
                                    else newStartDate = invMaxDate || timeMinDate ? new Date(invMaxDate || timeMinDate) : new Date();
                                    setStartDate(newStartDate);
                                    if (newStartDate > endDate) setEndDate(newStartDate);
                                    return (0, $47i9t.processTRPCData)(res, project.id + "newInvDates");
                                },
                                staleTime: 0,
                                cacheTime: 0
                            }
                        ],
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "mb-3 font-bold text-sm",
                                children: "Invoicing for work completed:"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                className: "flex fixed",
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                        className: "py-1.5 px-3.5",
                                        children: [
                                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                className: "text-sm",
                                                children: "From:"
                                            }),
                                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7GQic.default), {
                                                value: startDate,
                                                onChange: (v)=>{
                                                    setStartDate(v);
                                                    if (v > endDate) setEndDate(v);
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                        className: "py-1.5 px-3.5",
                                        children: [
                                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                className: "text-sm",
                                                children: "To:"
                                            }),
                                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7GQic.default), {
                                                value: endDate,
                                                onChange: (v)=>{
                                                    setEndDate(v);
                                                    if (v < startDate) setStartDate(v);
                                                }
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, project.id) : null
                })
            ]
        })
    });
});

});

parcelRegister("hzmaq", function(module, exports) {
"use strict";
var $cca6e67d3988e44a$var$__create = Object.create;
var $cca6e67d3988e44a$var$__defProp = Object.defineProperty;
var $cca6e67d3988e44a$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $cca6e67d3988e44a$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $cca6e67d3988e44a$var$__getProtoOf = Object.getPrototypeOf;
var $cca6e67d3988e44a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $cca6e67d3988e44a$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $cca6e67d3988e44a$var$__export = (target, all)=>{
    for(var name in all)$cca6e67d3988e44a$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $cca6e67d3988e44a$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $cca6e67d3988e44a$var$__getOwnPropNames(from))if (!$cca6e67d3988e44a$var$__hasOwnProp.call(to, key) && key !== except) $cca6e67d3988e44a$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $cca6e67d3988e44a$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $cca6e67d3988e44a$var$__toESM = (mod, isNodeMode, target)=>(target = mod != null ? $cca6e67d3988e44a$var$__create($cca6e67d3988e44a$var$__getProtoOf(mod)) : {}, $cca6e67d3988e44a$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $cca6e67d3988e44a$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
var $cca6e67d3988e44a$var$__toCommonJS = (mod)=>$cca6e67d3988e44a$var$__copyProps($cca6e67d3988e44a$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
var $cca6e67d3988e44a$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $cca6e67d3988e44a$var$__typeError("Cannot " + msg);
var $cca6e67d3988e44a$var$__privateGet = (obj, member, getter)=>($cca6e67d3988e44a$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $cca6e67d3988e44a$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $cca6e67d3988e44a$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $cca6e67d3988e44a$var$__privateSet = (obj, member, value, setter)=>($cca6e67d3988e44a$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var $cca6e67d3988e44a$var$__privateMethod = (obj, member, method)=>($cca6e67d3988e44a$var$__accessCheck(obj, member, "access private method"), method);
// src/index.ts
var $cca6e67d3988e44a$var$src_exports = {};
$cca6e67d3988e44a$var$__export($cca6e67d3988e44a$var$src_exports, {
    AuthenticateWithRedirectCallback: ()=>$cca6e67d3988e44a$var$AuthenticateWithRedirectCallback,
    ClerkLoaded: ()=>$cca6e67d3988e44a$var$ClerkLoaded,
    ClerkLoading: ()=>$cca6e67d3988e44a$var$ClerkLoading,
    ClerkProvider: ()=>$cca6e67d3988e44a$var$ClerkProvider,
    CreateOrganization: ()=>$cca6e67d3988e44a$var$CreateOrganization,
    GoogleOneTap: ()=>$cca6e67d3988e44a$var$GoogleOneTap,
    OrganizationList: ()=>$cca6e67d3988e44a$var$OrganizationList,
    OrganizationProfile: ()=>$cca6e67d3988e44a$var$OrganizationProfile,
    OrganizationSwitcher: ()=>$cca6e67d3988e44a$var$OrganizationSwitcher,
    Protect: ()=>$cca6e67d3988e44a$var$Protect,
    RedirectToCreateOrganization: ()=>$cca6e67d3988e44a$var$RedirectToCreateOrganization,
    RedirectToOrganizationProfile: ()=>$cca6e67d3988e44a$var$RedirectToOrganizationProfile,
    RedirectToSignIn: ()=>$cca6e67d3988e44a$var$RedirectToSignIn,
    RedirectToSignUp: ()=>$cca6e67d3988e44a$var$RedirectToSignUp,
    RedirectToUserProfile: ()=>$cca6e67d3988e44a$var$RedirectToUserProfile,
    SignIn: ()=>$cca6e67d3988e44a$var$SignIn,
    SignInButton: ()=>$cca6e67d3988e44a$var$SignInButton,
    SignInWithMetamaskButton: ()=>$cca6e67d3988e44a$var$SignInWithMetamaskButton,
    SignOutButton: ()=>$cca6e67d3988e44a$var$SignOutButton,
    SignUp: ()=>$cca6e67d3988e44a$var$SignUp,
    SignUpButton: ()=>$cca6e67d3988e44a$var$SignUpButton,
    SignedIn: ()=>$cca6e67d3988e44a$var$SignedIn,
    SignedOut: ()=>$cca6e67d3988e44a$var$SignedOut,
    UserButton: ()=>$cca6e67d3988e44a$var$UserButton,
    UserProfile: ()=>$cca6e67d3988e44a$var$UserProfile,
    Waitlist: ()=>$cca6e67d3988e44a$var$Waitlist,
    useAuth: ()=>$cca6e67d3988e44a$var$useAuth,
    useClerk: ()=>$ifeyV.useClerk,
    useEmailLink: ()=>$cca6e67d3988e44a$var$useEmailLink,
    useOrganization: ()=>$ifeyV.useOrganization,
    useOrganizationList: ()=>$ifeyV.useOrganizationList,
    useReverification: ()=>$ifeyV.useReverification,
    useSession: ()=>$ifeyV.useSession,
    useSessionList: ()=>$ifeyV.useSessionList,
    useSignIn: ()=>$cca6e67d3988e44a$var$useSignIn,
    useSignUp: ()=>$cca6e67d3988e44a$var$useSignUp,
    useUser: ()=>$ifeyV.useUser
});
module.exports = $cca6e67d3988e44a$var$__toCommonJS($cca6e67d3988e44a$var$src_exports);
// src/polyfills.ts
if (typeof window !== "undefined" && !window.global) window.global = typeof $parcel$global === "undefined" ? window : $parcel$global;

var $jCQ57 = parcelRequire("jCQ57");

var $aVZ0k = parcelRequire("aVZ0k");
var $cca6e67d3988e44a$var$errorThrower = (0, $aVZ0k.buildErrorThrower)({
    packageName: "@clerk/clerk-react"
});
function $cca6e67d3988e44a$var$setErrorThrowerOptions(options) {
    $cca6e67d3988e44a$var$errorThrower.setMessages(options).setPackageName(options);
}

var $7zhRN = parcelRequire("7zhRN");

var $cca6e67d3988e44a$var$import_react13 = $cca6e67d3988e44a$var$__toESM((parcelRequire("jbmdS")));
// src/errors/messages.ts
var $cca6e67d3988e44a$var$multipleClerkProvidersError = "You've added multiple <ClerkProvider> components in your React component tree. Wrap your components in a single <ClerkProvider>.";
var $cca6e67d3988e44a$var$multipleChildrenInButtonComponent = (name)=>`You've passed multiple children components to <${name}/>. You can only pass a single child component or text.`;
var $cca6e67d3988e44a$var$invalidStateError = "Invalid state. Feel free to submit a bug or reach out to support here: https://clerk.com/support";
var $cca6e67d3988e44a$var$unsupportedNonBrowserDomainOrProxyUrlFunction = "Unsupported usage of isSatellite, domain or proxyUrl. The usage of isSatellite, domain or proxyUrl as function is not supported in non-browser environments.";
var $cca6e67d3988e44a$var$userProfilePageRenderedError = "<UserProfile.Page /> component needs to be a direct child of `<UserProfile />` or `<UserButton />`.";
var $cca6e67d3988e44a$var$userProfileLinkRenderedError = "<UserProfile.Link /> component needs to be a direct child of `<UserProfile />` or `<UserButton />`.";
var $cca6e67d3988e44a$var$organizationProfilePageRenderedError = "<OrganizationProfile.Page /> component needs to be a direct child of `<OrganizationProfile />` or `<OrganizationSwitcher />`.";
var $cca6e67d3988e44a$var$organizationProfileLinkRenderedError = "<OrganizationProfile.Link /> component needs to be a direct child of `<OrganizationProfile />` or `<OrganizationSwitcher />`.";
var $cca6e67d3988e44a$var$customPagesIgnoredComponent = (componentName)=>`<${componentName} /> can only accept <${componentName}.Page /> and <${componentName}.Link /> as its children. Any other provided component will be ignored.`;
var $cca6e67d3988e44a$var$customPageWrongProps = (componentName)=>`Missing props. <${componentName}.Page /> component requires the following props: url, label, labelIcon, alongside with children to be rendered inside the page.`;
var $cca6e67d3988e44a$var$customLinkWrongProps = (componentName)=>`Missing props. <${componentName}.Link /> component requires the following props: url, label and labelIcon.`;
var $cca6e67d3988e44a$var$userButtonIgnoredComponent = `<UserButton /> can only accept <UserButton.UserProfilePage />, <UserButton.UserProfileLink /> and <UserButton.MenuItems /> as its children. Any other provided component will be ignored.`;
var $cca6e67d3988e44a$var$customMenuItemsIgnoredComponent = "<UserButton.MenuItems /> component can only accept <UserButton.Action /> and <UserButton.Link /> as its children. Any other provided component will be ignored.";
var $cca6e67d3988e44a$var$userButtonMenuItemsRenderedError = "<UserButton.MenuItems /> component needs to be a direct child of `<UserButton />`.";
var $cca6e67d3988e44a$var$userButtonMenuActionRenderedError = "<UserButton.Action /> component needs to be a direct child of `<UserButton.MenuItems />`.";
var $cca6e67d3988e44a$var$userButtonMenuLinkRenderedError = "<UserButton.Link /> component needs to be a direct child of `<UserButton.MenuItems />`.";
var $cca6e67d3988e44a$var$userButtonMenuItemLinkWrongProps = "Missing props. <UserButton.Link /> component requires the following props: href, label and labelIcon.";
var $cca6e67d3988e44a$var$userButtonMenuItemsActionWrongsProps = "Missing props. <UserButton.Action /> component requires the following props: label.";

// src/utils/childrenUtils.tsx
var $cca6e67d3988e44a$var$import_react = $cca6e67d3988e44a$var$__toESM((parcelRequire("jbmdS")));
var $cca6e67d3988e44a$var$assertSingleChild = (children)=>(name)=>{
        try {
            return $cca6e67d3988e44a$var$import_react.default.Children.only(children);
        } catch  {
            return $cca6e67d3988e44a$var$errorThrower.throw($cca6e67d3988e44a$var$multipleChildrenInButtonComponent(name));
        }
    };
var $cca6e67d3988e44a$var$normalizeWithDefaultValue = (children, defaultText)=>{
    if (!children) children = defaultText;
    if (typeof children === "string") children = /* @__PURE__ */ $cca6e67d3988e44a$var$import_react.default.createElement("button", null, children);
    return children;
};
var $cca6e67d3988e44a$var$safeExecute = (cb)=>(...args)=>{
        if (cb && typeof cb === "function") return cb(...args);
    };
// src/utils/isConstructor.ts
function $cca6e67d3988e44a$var$isConstructor(f) {
    return typeof f === "function";
}

// src/utils/useMaxAllowedInstancesGuard.tsx
var $cca6e67d3988e44a$var$import_react2 = $cca6e67d3988e44a$var$__toESM((parcelRequire("jbmdS")));
var $cca6e67d3988e44a$var$counts = /* @__PURE__ */ new Map();
function $cca6e67d3988e44a$var$useMaxAllowedInstancesGuard(name, error, maxCount = 1) {
    $cca6e67d3988e44a$var$import_react2.default.useEffect(()=>{
        const count = $cca6e67d3988e44a$var$counts.get(name) || 0;
        if (count == maxCount) return $cca6e67d3988e44a$var$errorThrower.throw(error);
        $cca6e67d3988e44a$var$counts.set(name, count + 1);
        return ()=>{
            $cca6e67d3988e44a$var$counts.set(name, ($cca6e67d3988e44a$var$counts.get(name) || 1) - 1);
        };
    }, []);
}
function $cca6e67d3988e44a$var$withMaxAllowedInstancesGuard(WrappedComponent, name, error) {
    const displayName = WrappedComponent.displayName || WrappedComponent.name || name || "Component";
    const Hoc = (props)=>{
        $cca6e67d3988e44a$var$useMaxAllowedInstancesGuard(name, error);
        return /* @__PURE__ */ $cca6e67d3988e44a$var$import_react2.default.createElement(WrappedComponent, {
            ...props
        });
    };
    Hoc.displayName = `withMaxAllowedInstancesGuard(${displayName})`;
    return Hoc;
}

// src/utils/useCustomElementPortal.tsx
var $cca6e67d3988e44a$var$import_react3 = $cca6e67d3988e44a$var$__toESM((parcelRequire("jbmdS")));

var $jCNM0 = parcelRequire("jCNM0");
var $cca6e67d3988e44a$var$useCustomElementPortal = (elements)=>{
    const initialState = Array(elements.length).fill(null);
    const [nodes, setNodes] = (0, $cca6e67d3988e44a$var$import_react3.useState)(initialState);
    return elements.map((el, index)=>({
            id: el.id,
            mount: (node)=>setNodes((prevState)=>prevState.map((n, i)=>i === index ? node : n)),
            unmount: ()=>setNodes((prevState)=>prevState.map((n, i)=>i === index ? null : n)),
            portal: ()=>/* @__PURE__ */ $cca6e67d3988e44a$var$import_react3.default.createElement($cca6e67d3988e44a$var$import_react3.default.Fragment, null, nodes[index] ? (0, $jCNM0.createPortal)(el.component, nodes[index]) : null)
        }));
};

var $7zhRN = parcelRequire("7zhRN");

var $cca6e67d3988e44a$var$import_react5 = $cca6e67d3988e44a$var$__toESM((parcelRequire("jbmdS")));

// src/utils/componentValidation.ts
var $cca6e67d3988e44a$var$import_react4 = $cca6e67d3988e44a$var$__toESM((parcelRequire("jbmdS")));
var $cca6e67d3988e44a$var$isThatComponent = (v, component)=>{
    return !!v && $cca6e67d3988e44a$var$import_react4.default.isValidElement(v) && (v == null ? void 0 : v.type) === component;
};
// src/utils/useCustomPages.tsx
var $cca6e67d3988e44a$var$useUserProfileCustomPages = (children, options)=>{
    const reorderItemsLabels = [
        "account",
        "security"
    ];
    return $cca6e67d3988e44a$var$useCustomPages({
        children: children,
        reorderItemsLabels: reorderItemsLabels,
        LinkComponent: $cca6e67d3988e44a$var$UserProfileLink,
        PageComponent: $cca6e67d3988e44a$var$UserProfilePage,
        MenuItemsComponent: $cca6e67d3988e44a$var$MenuItems,
        componentName: "UserProfile"
    }, options);
};
var $cca6e67d3988e44a$var$useOrganizationProfileCustomPages = (children, options)=>{
    const reorderItemsLabels = [
        "general",
        "members"
    ];
    return $cca6e67d3988e44a$var$useCustomPages({
        children: children,
        reorderItemsLabels: reorderItemsLabels,
        LinkComponent: $cca6e67d3988e44a$var$OrganizationProfileLink,
        PageComponent: $cca6e67d3988e44a$var$OrganizationProfilePage,
        componentName: "OrganizationProfile"
    }, options);
};
var $cca6e67d3988e44a$var$useSanitizedChildren = (children)=>{
    const sanitizedChildren = [];
    const excludedComponents = [
        $cca6e67d3988e44a$var$OrganizationProfileLink,
        $cca6e67d3988e44a$var$OrganizationProfilePage,
        $cca6e67d3988e44a$var$MenuItems,
        $cca6e67d3988e44a$var$UserProfilePage,
        $cca6e67d3988e44a$var$UserProfileLink
    ];
    $cca6e67d3988e44a$var$import_react5.default.Children.forEach(children, (child)=>{
        if (!excludedComponents.some((component)=>$cca6e67d3988e44a$var$isThatComponent(child, component))) sanitizedChildren.push(child);
    });
    return sanitizedChildren;
};
var $cca6e67d3988e44a$var$useCustomPages = (params, options)=>{
    const { children: children, LinkComponent: LinkComponent, PageComponent: PageComponent, MenuItemsComponent: MenuItemsComponent, reorderItemsLabels: reorderItemsLabels, componentName: componentName } = params;
    const { allowForAnyChildren: allowForAnyChildren = false } = options || {};
    const validChildren = [];
    $cca6e67d3988e44a$var$import_react5.default.Children.forEach(children, (child)=>{
        if (!$cca6e67d3988e44a$var$isThatComponent(child, PageComponent) && !$cca6e67d3988e44a$var$isThatComponent(child, LinkComponent) && !$cca6e67d3988e44a$var$isThatComponent(child, MenuItemsComponent)) {
            if (child && !allowForAnyChildren) (0, $7zhRN.logErrorInDevMode)($cca6e67d3988e44a$var$customPagesIgnoredComponent(componentName));
            return;
        }
        const { props: props } = child;
        const { children: children2, label: label, url: url, labelIcon: labelIcon } = props;
        if ($cca6e67d3988e44a$var$isThatComponent(child, PageComponent)) {
            if ($cca6e67d3988e44a$var$isReorderItem(props, reorderItemsLabels)) validChildren.push({
                label: label
            });
            else if ($cca6e67d3988e44a$var$isCustomPage(props)) validChildren.push({
                label: label,
                labelIcon: labelIcon,
                children: children2,
                url: url
            });
            else {
                (0, $7zhRN.logErrorInDevMode)($cca6e67d3988e44a$var$customPageWrongProps(componentName));
                return;
            }
        }
        if ($cca6e67d3988e44a$var$isThatComponent(child, LinkComponent)) {
            if ($cca6e67d3988e44a$var$isExternalLink(props)) validChildren.push({
                label: label,
                labelIcon: labelIcon,
                url: url
            });
            else {
                (0, $7zhRN.logErrorInDevMode)($cca6e67d3988e44a$var$customLinkWrongProps(componentName));
                return;
            }
        }
    });
    const customPageContents = [];
    const customPageLabelIcons = [];
    const customLinkLabelIcons = [];
    validChildren.forEach((cp, index)=>{
        if ($cca6e67d3988e44a$var$isCustomPage(cp)) {
            customPageContents.push({
                component: cp.children,
                id: index
            });
            customPageLabelIcons.push({
                component: cp.labelIcon,
                id: index
            });
            return;
        }
        if ($cca6e67d3988e44a$var$isExternalLink(cp)) customLinkLabelIcons.push({
            component: cp.labelIcon,
            id: index
        });
    });
    const customPageContentsPortals = $cca6e67d3988e44a$var$useCustomElementPortal(customPageContents);
    const customPageLabelIconsPortals = $cca6e67d3988e44a$var$useCustomElementPortal(customPageLabelIcons);
    const customLinkLabelIconsPortals = $cca6e67d3988e44a$var$useCustomElementPortal(customLinkLabelIcons);
    const customPages = [];
    const customPagesPortals = [];
    validChildren.forEach((cp, index)=>{
        if ($cca6e67d3988e44a$var$isReorderItem(cp, reorderItemsLabels)) {
            customPages.push({
                label: cp.label
            });
            return;
        }
        if ($cca6e67d3988e44a$var$isCustomPage(cp)) {
            const { portal: contentPortal, mount: mount, unmount: unmount } = customPageContentsPortals.find((p)=>p.id === index);
            const { portal: labelPortal, mount: mountIcon, unmount: unmountIcon } = customPageLabelIconsPortals.find((p)=>p.id === index);
            customPages.push({
                label: cp.label,
                url: cp.url,
                mount: mount,
                unmount: unmount,
                mountIcon: mountIcon,
                unmountIcon: unmountIcon
            });
            customPagesPortals.push(contentPortal);
            customPagesPortals.push(labelPortal);
            return;
        }
        if ($cca6e67d3988e44a$var$isExternalLink(cp)) {
            const { portal: labelPortal, mount: mountIcon, unmount: unmountIcon } = customLinkLabelIconsPortals.find((p)=>p.id === index);
            customPages.push({
                label: cp.label,
                url: cp.url,
                mountIcon: mountIcon,
                unmountIcon: unmountIcon
            });
            customPagesPortals.push(labelPortal);
            return;
        }
    });
    return {
        customPages: customPages,
        customPagesPortals: customPagesPortals
    };
};
var $cca6e67d3988e44a$var$isReorderItem = (childProps, validItems)=>{
    const { children: children, label: label, url: url, labelIcon: labelIcon } = childProps;
    return !children && !url && !labelIcon && validItems.some((v)=>v === label);
};
var $cca6e67d3988e44a$var$isCustomPage = (childProps)=>{
    const { children: children, label: label, url: url, labelIcon: labelIcon } = childProps;
    return !!children && !!url && !!labelIcon && !!label;
};
var $cca6e67d3988e44a$var$isExternalLink = (childProps)=>{
    const { children: children, label: label, url: url, labelIcon: labelIcon } = childProps;
    return !children && !!url && !!labelIcon && !!label;
};

var $7zhRN = parcelRequire("7zhRN");

var $cca6e67d3988e44a$var$import_react6 = $cca6e67d3988e44a$var$__toESM((parcelRequire("jbmdS")));
var $cca6e67d3988e44a$var$useUserButtonCustomMenuItems = (children)=>{
    const reorderItemsLabels = [
        "manageAccount",
        "signOut"
    ];
    return $cca6e67d3988e44a$var$useCustomMenuItems({
        children: children,
        reorderItemsLabels: reorderItemsLabels,
        MenuItemsComponent: $cca6e67d3988e44a$var$MenuItems,
        MenuActionComponent: $cca6e67d3988e44a$var$MenuAction,
        MenuLinkComponent: $cca6e67d3988e44a$var$MenuLink,
        UserProfileLinkComponent: $cca6e67d3988e44a$var$UserProfileLink,
        UserProfilePageComponent: $cca6e67d3988e44a$var$UserProfilePage
    });
};
var $cca6e67d3988e44a$var$useCustomMenuItems = ({ children: children, MenuItemsComponent: MenuItemsComponent, MenuActionComponent: MenuActionComponent, MenuLinkComponent: MenuLinkComponent, UserProfileLinkComponent: UserProfileLinkComponent, UserProfilePageComponent: UserProfilePageComponent, reorderItemsLabels: reorderItemsLabels })=>{
    const validChildren = [];
    const customMenuItems = [];
    const customMenuItemsPortals = [];
    $cca6e67d3988e44a$var$import_react6.default.Children.forEach(children, (child)=>{
        if (!$cca6e67d3988e44a$var$isThatComponent(child, MenuItemsComponent) && !$cca6e67d3988e44a$var$isThatComponent(child, UserProfileLinkComponent) && !$cca6e67d3988e44a$var$isThatComponent(child, UserProfilePageComponent)) {
            if (child) (0, $7zhRN.logErrorInDevMode)($cca6e67d3988e44a$var$userButtonIgnoredComponent);
            return;
        }
        if ($cca6e67d3988e44a$var$isThatComponent(child, UserProfileLinkComponent) || $cca6e67d3988e44a$var$isThatComponent(child, UserProfilePageComponent)) return;
        const { props: props } = child;
        $cca6e67d3988e44a$var$import_react6.default.Children.forEach(props.children, (child2)=>{
            if (!$cca6e67d3988e44a$var$isThatComponent(child2, MenuActionComponent) && !$cca6e67d3988e44a$var$isThatComponent(child2, MenuLinkComponent)) {
                if (child2) (0, $7zhRN.logErrorInDevMode)($cca6e67d3988e44a$var$customMenuItemsIgnoredComponent);
                return;
            }
            const { props: props2 } = child2;
            const { label: label, labelIcon: labelIcon, href: href, onClick: onClick, open: open } = props2;
            if ($cca6e67d3988e44a$var$isThatComponent(child2, MenuActionComponent)) {
                if ($cca6e67d3988e44a$var$isReorderItem2(props2, reorderItemsLabels)) validChildren.push({
                    label: label
                });
                else if ($cca6e67d3988e44a$var$isCustomMenuItem(props2)) {
                    const baseItem = {
                        label: label,
                        labelIcon: labelIcon
                    };
                    if (onClick !== void 0) validChildren.push({
                        ...baseItem,
                        onClick: onClick
                    });
                    else if (open !== void 0) validChildren.push({
                        ...baseItem,
                        open: open.startsWith("/") ? open : `/${open}`
                    });
                    else {
                        (0, $7zhRN.logErrorInDevMode)("Custom menu item must have either onClick or open property");
                        return;
                    }
                } else {
                    (0, $7zhRN.logErrorInDevMode)($cca6e67d3988e44a$var$userButtonMenuItemsActionWrongsProps);
                    return;
                }
            }
            if ($cca6e67d3988e44a$var$isThatComponent(child2, MenuLinkComponent)) {
                if ($cca6e67d3988e44a$var$isExternalLink2(props2)) validChildren.push({
                    label: label,
                    labelIcon: labelIcon,
                    href: href
                });
                else {
                    (0, $7zhRN.logErrorInDevMode)($cca6e67d3988e44a$var$userButtonMenuItemLinkWrongProps);
                    return;
                }
            }
        });
    });
    const customMenuItemLabelIcons = [];
    const customLinkLabelIcons = [];
    validChildren.forEach((mi, index)=>{
        if ($cca6e67d3988e44a$var$isCustomMenuItem(mi)) customMenuItemLabelIcons.push({
            component: mi.labelIcon,
            id: index
        });
        if ($cca6e67d3988e44a$var$isExternalLink2(mi)) customLinkLabelIcons.push({
            component: mi.labelIcon,
            id: index
        });
    });
    const customMenuItemLabelIconsPortals = $cca6e67d3988e44a$var$useCustomElementPortal(customMenuItemLabelIcons);
    const customLinkLabelIconsPortals = $cca6e67d3988e44a$var$useCustomElementPortal(customLinkLabelIcons);
    validChildren.forEach((mi, index)=>{
        if ($cca6e67d3988e44a$var$isReorderItem2(mi, reorderItemsLabels)) customMenuItems.push({
            label: mi.label
        });
        if ($cca6e67d3988e44a$var$isCustomMenuItem(mi)) {
            const { portal: iconPortal, mount: mountIcon, unmount: unmountIcon } = customMenuItemLabelIconsPortals.find((p)=>p.id === index);
            const menuItem = {
                label: mi.label,
                mountIcon: mountIcon,
                unmountIcon: unmountIcon
            };
            if ("onClick" in mi) menuItem.onClick = mi.onClick;
            else if ("open" in mi) menuItem.open = mi.open;
            customMenuItems.push(menuItem);
            customMenuItemsPortals.push(iconPortal);
        }
        if ($cca6e67d3988e44a$var$isExternalLink2(mi)) {
            const { portal: iconPortal, mount: mountIcon, unmount: unmountIcon } = customLinkLabelIconsPortals.find((p)=>p.id === index);
            customMenuItems.push({
                label: mi.label,
                href: mi.href,
                mountIcon: mountIcon,
                unmountIcon: unmountIcon
            });
            customMenuItemsPortals.push(iconPortal);
        }
    });
    return {
        customMenuItems: customMenuItems,
        customMenuItemsPortals: customMenuItemsPortals
    };
};
var $cca6e67d3988e44a$var$isReorderItem2 = (childProps, validItems)=>{
    const { children: children, label: label, onClick: onClick, labelIcon: labelIcon } = childProps;
    return !children && !onClick && !labelIcon && validItems.some((v)=>v === label);
};
var $cca6e67d3988e44a$var$isCustomMenuItem = (childProps)=>{
    const { label: label, labelIcon: labelIcon, onClick: onClick, open: open } = childProps;
    return !!labelIcon && !!label && (typeof onClick === "function" || typeof open === "string");
};
var $cca6e67d3988e44a$var$isExternalLink2 = (childProps)=>{
    const { label: label, href: href, labelIcon: labelIcon } = childProps;
    return !!href && !!labelIcon && !!label;
};

function $cca6e67d3988e44a$var$waitForElementChildren(options) {
    const { root: root = document == null ? void 0 : document.body, selector: selector, timeout: timeout = 0 } = options;
    return new Promise((resolve, reject)=>{
        if (!root) {
            reject(new Error("No root element provided"));
            return;
        }
        let elementToWatch = root;
        if (selector) elementToWatch = root == null ? void 0 : root.querySelector(selector);
        const isElementAlreadyPresent = (elementToWatch == null ? void 0 : elementToWatch.childElementCount) && elementToWatch.childElementCount > 0;
        if (isElementAlreadyPresent) {
            resolve();
            return;
        }
        const observer = new MutationObserver((mutationsList)=>{
            for (const mutation of mutationsList)if (mutation.type === "childList") {
                if (!elementToWatch && selector) elementToWatch = root == null ? void 0 : root.querySelector(selector);
                if ((elementToWatch == null ? void 0 : elementToWatch.childElementCount) && elementToWatch.childElementCount > 0) {
                    observer.disconnect();
                    resolve();
                    return;
                }
            }
        });
        observer.observe(root, {
            childList: true,
            subtree: true
        });
        if (timeout > 0) setTimeout(()=>{
            observer.disconnect();
            reject(new Error(`Timeout waiting for element children`));
        }, timeout);
    });
}
function $cca6e67d3988e44a$var$useWaitForComponentMount(component) {
    const watcherRef = (0, (parcelRequire("jbmdS")).useRef)();
    const [status, setStatus] = (0, (parcelRequire("jbmdS")).useState)("rendering");
    (0, (parcelRequire("jbmdS")).useEffect)(()=>{
        if (!component) throw new Error("Clerk: no component name provided, unable to detect mount.");
        if (typeof window !== "undefined" && !watcherRef.current) watcherRef.current = $cca6e67d3988e44a$var$waitForElementChildren({
            selector: `[data-clerk-component="${component}"]`
        }).then(()=>{
            setStatus("rendered");
        }).catch(()=>{
            setStatus("error");
        });
    }, [
        component
    ]);
    return status;
}

var $8JOeW = parcelRequire("8JOeW");

var $ifeyV = parcelRequire("ifeyV");

var $cca6e67d3988e44a$var$import_react9 = $cca6e67d3988e44a$var$__toESM((parcelRequire("jbmdS")));
var $cca6e67d3988e44a$var$isMountProps = (props)=>{
    return "mount" in props;
};
var $cca6e67d3988e44a$var$isOpenProps = (props)=>{
    return "open" in props;
};
var $cca6e67d3988e44a$var$stripMenuItemIconHandlers = (menuItems)=>{
    return menuItems == null ? void 0 : menuItems.map(({ mountIcon: mountIcon, unmountIcon: unmountIcon, ...rest })=>rest);
};
var $cca6e67d3988e44a$var$ClerkHostRenderer = class extends $cca6e67d3988e44a$var$import_react9.default.PureComponent {
    constructor(){
        super(...arguments);
        this.rootRef = $cca6e67d3988e44a$var$import_react9.default.createRef();
    }
    componentDidUpdate(_prevProps) {
        var _a, _b, _c, _d;
        if (!$cca6e67d3988e44a$var$isMountProps(_prevProps) || !$cca6e67d3988e44a$var$isMountProps(this.props)) return;
        const prevProps = (0, $8JOeW.without)(_prevProps.props, "customPages", "customMenuItems", "children");
        const newProps = (0, $8JOeW.without)(this.props.props, "customPages", "customMenuItems", "children");
        const customPagesChanged = ((_a = prevProps.customPages) == null ? void 0 : _a.length) !== ((_b = newProps.customPages) == null ? void 0 : _b.length);
        const customMenuItemsChanged = ((_c = prevProps.customMenuItems) == null ? void 0 : _c.length) !== ((_d = newProps.customMenuItems) == null ? void 0 : _d.length);
        const prevMenuItemsWithoutHandlers = $cca6e67d3988e44a$var$stripMenuItemIconHandlers(_prevProps.props.customMenuItems);
        const newMenuItemsWithoutHandlers = $cca6e67d3988e44a$var$stripMenuItemIconHandlers(this.props.props.customMenuItems);
        if (!(0, $ifeyV.isDeeplyEqual)(prevProps, newProps) || !(0, $ifeyV.isDeeplyEqual)(prevMenuItemsWithoutHandlers, newMenuItemsWithoutHandlers) || customPagesChanged || customMenuItemsChanged) {
            if (this.rootRef.current) this.props.updateProps({
                node: this.rootRef.current,
                props: this.props.props
            });
        }
    }
    componentDidMount() {
        if (this.rootRef.current) {
            if ($cca6e67d3988e44a$var$isMountProps(this.props)) this.props.mount(this.rootRef.current, this.props.props);
            if ($cca6e67d3988e44a$var$isOpenProps(this.props)) this.props.open(this.props.props);
        }
    }
    componentWillUnmount() {
        if (this.rootRef.current) {
            if ($cca6e67d3988e44a$var$isMountProps(this.props)) this.props.unmount(this.rootRef.current);
            if ($cca6e67d3988e44a$var$isOpenProps(this.props)) this.props.close();
        }
    }
    render() {
        const { hideRootHtmlElement: hideRootHtmlElement = false } = this.props;
        const rootAttributes = {
            ref: this.rootRef,
            ...this.props.rootProps,
            ...this.props.component && {
                "data-clerk-component": this.props.component
            }
        };
        return /* @__PURE__ */ $cca6e67d3988e44a$var$import_react9.default.createElement($cca6e67d3988e44a$var$import_react9.default.Fragment, null, !hideRootHtmlElement && /* @__PURE__ */ $cca6e67d3988e44a$var$import_react9.default.createElement("div", {
            ...rootAttributes
        }), this.props.children);
    }
};

// src/components/withClerk.tsx
var $cca6e67d3988e44a$var$import_react12 = $cca6e67d3988e44a$var$__toESM((parcelRequire("jbmdS")));

var $ifeyV = parcelRequire("ifeyV");
var $cca6e67d3988e44a$var$IsomorphicClerkContext = $ifeyV.ClerkInstanceContext;
var $cca6e67d3988e44a$var$useIsomorphicClerkContext = $ifeyV.useClerkInstanceContext;

var $ifeyV = parcelRequire("ifeyV");
var $cca6e67d3988e44a$var$useAssertWrappedByClerkProvider = (source)=>{
    (0, $ifeyV.useAssertWrappedByClerkProvider)(()=>{
        $cca6e67d3988e44a$var$errorThrower.throwMissingClerkProviderError({
            source: source
        });
    });
};
// src/components/withClerk.tsx
var $cca6e67d3988e44a$var$withClerk = (Component, displayNameOrOptions)=>{
    const passedDisplayedName = typeof displayNameOrOptions === "string" ? displayNameOrOptions : displayNameOrOptions == null ? void 0 : displayNameOrOptions.component;
    const displayName = passedDisplayedName || Component.displayName || Component.name || "Component";
    Component.displayName = displayName;
    const options = typeof displayNameOrOptions === "string" ? void 0 : displayNameOrOptions;
    const HOC = (props)=>{
        $cca6e67d3988e44a$var$useAssertWrappedByClerkProvider(displayName || "withClerk");
        const clerk = $cca6e67d3988e44a$var$useIsomorphicClerkContext();
        if (!clerk.loaded && !(options == null ? void 0 : options.renderWhileLoading)) return null;
        return /* @__PURE__ */ $cca6e67d3988e44a$var$import_react12.default.createElement(Component, {
            ...props,
            component: displayName,
            clerk: clerk
        });
    };
    HOC.displayName = `withClerk(${displayName})`;
    return HOC;
};
// src/components/uiComponents.tsx
var $cca6e67d3988e44a$var$CustomPortalsRenderer = (props)=>{
    var _a, _b;
    return /* @__PURE__ */ $cca6e67d3988e44a$var$import_react13.default.createElement($cca6e67d3988e44a$var$import_react13.default.Fragment, null, (_a = props == null ? void 0 : props.customPagesPortals) == null ? void 0 : _a.map((portal, index)=>(0, $cca6e67d3988e44a$var$import_react13.createElement)(portal, {
            key: index
        })), (_b = props == null ? void 0 : props.customMenuItemsPortals) == null ? void 0 : _b.map((portal, index)=>(0, $cca6e67d3988e44a$var$import_react13.createElement)(portal, {
            key: index
        })));
};
var $cca6e67d3988e44a$var$SignIn = $cca6e67d3988e44a$var$withClerk(({ clerk: clerk, component: component, fallback: fallback, ...props })=>{
    const mountingStatus = $cca6e67d3988e44a$var$useWaitForComponentMount(component);
    const shouldShowFallback = mountingStatus === "rendering" || !clerk.loaded;
    const rendererRootProps = {
        ...shouldShowFallback && fallback && {
            style: {
                display: "none"
            }
        }
    };
    return /* @__PURE__ */ $cca6e67d3988e44a$var$import_react13.default.createElement($cca6e67d3988e44a$var$import_react13.default.Fragment, null, shouldShowFallback && fallback, clerk.loaded && /* @__PURE__ */ $cca6e67d3988e44a$var$import_react13.default.createElement($cca6e67d3988e44a$var$ClerkHostRenderer, {
        component: component,
        mount: clerk.mountSignIn,
        unmount: clerk.unmountSignIn,
        updateProps: clerk.__unstable__updateProps,
        props: props,
        rootProps: rendererRootProps
    }));
}, {
    component: "SignIn",
    renderWhileLoading: true
});
var $cca6e67d3988e44a$var$SignUp = $cca6e67d3988e44a$var$withClerk(({ clerk: clerk, component: component, fallback: fallback, ...props })=>{
    const mountingStatus = $cca6e67d3988e44a$var$useWaitForComponentMount(component);
    const shouldShowFallback = mountingStatus === "rendering" || !clerk.loaded;
    const rendererRootProps = {
        ...shouldShowFallback && fallback && {
            style: {
                display: "none"
            }
        }
    };
    return /* @__PURE__ */ $cca6e67d3988e44a$var$import_react13.default.createElement($cca6e67d3988e44a$var$import_react13.default.Fragment, null, shouldShowFallback && fallback, clerk.loaded && /* @__PURE__ */ $cca6e67d3988e44a$var$import_react13.default.createElement($cca6e67d3988e44a$var$ClerkHostRenderer, {
        component: component,
        mount: clerk.mountSignUp,
        unmount: clerk.unmountSignUp,
        updateProps: clerk.__unstable__updateProps,
        props: props,
        rootProps: rendererRootProps
    }));
}, {
    component: "SignUp",
    renderWhileLoading: true
});
function $cca6e67d3988e44a$var$UserProfilePage({ children: children }) {
    (0, $7zhRN.logErrorInDevMode)($cca6e67d3988e44a$var$userProfilePageRenderedError);
    return /* @__PURE__ */ $cca6e67d3988e44a$var$import_react13.default.createElement($cca6e67d3988e44a$var$import_react13.default.Fragment, null, children);
}
function $cca6e67d3988e44a$var$UserProfileLink({ children: children }) {
    (0, $7zhRN.logErrorInDevMode)($cca6e67d3988e44a$var$userProfileLinkRenderedError);
    return /* @__PURE__ */ $cca6e67d3988e44a$var$import_react13.default.createElement($cca6e67d3988e44a$var$import_react13.default.Fragment, null, children);
}
var $cca6e67d3988e44a$var$_UserProfile = $cca6e67d3988e44a$var$withClerk(({ clerk: clerk, component: component, fallback: fallback, ...props })=>{
    const mountingStatus = $cca6e67d3988e44a$var$useWaitForComponentMount(component);
    const shouldShowFallback = mountingStatus === "rendering" || !clerk.loaded;
    const rendererRootProps = {
        ...shouldShowFallback && fallback && {
            style: {
                display: "none"
            }
        }
    };
    const { customPages: customPages, customPagesPortals: customPagesPortals } = $cca6e67d3988e44a$var$useUserProfileCustomPages(props.children);
    return /* @__PURE__ */ $cca6e67d3988e44a$var$import_react13.default.createElement($cca6e67d3988e44a$var$import_react13.default.Fragment, null, shouldShowFallback && fallback, /* @__PURE__ */ $cca6e67d3988e44a$var$import_react13.default.createElement($cca6e67d3988e44a$var$ClerkHostRenderer, {
        component: component,
        mount: clerk.mountUserProfile,
        unmount: clerk.unmountUserProfile,
        updateProps: clerk.__unstable__updateProps,
        props: {
            ...props,
            customPages: customPages
        },
        rootProps: rendererRootProps
    }, /* @__PURE__ */ $cca6e67d3988e44a$var$import_react13.default.createElement($cca6e67d3988e44a$var$CustomPortalsRenderer, {
        customPagesPortals: customPagesPortals
    })));
}, {
    component: "UserProfile",
    renderWhileLoading: true
});
var $cca6e67d3988e44a$var$UserProfile = Object.assign($cca6e67d3988e44a$var$_UserProfile, {
    Page: $cca6e67d3988e44a$var$UserProfilePage,
    Link: $cca6e67d3988e44a$var$UserProfileLink
});
var $cca6e67d3988e44a$var$UserButtonContext = (0, $cca6e67d3988e44a$var$import_react13.createContext)({
    mount: ()=>{},
    unmount: ()=>{},
    updateProps: ()=>{}
});
var $cca6e67d3988e44a$var$_UserButton = $cca6e67d3988e44a$var$withClerk(({ clerk: clerk, component: component, fallback: fallback, ...props })=>{
    const mountingStatus = $cca6e67d3988e44a$var$useWaitForComponentMount(component);
    const shouldShowFallback = mountingStatus === "rendering" || !clerk.loaded;
    const rendererRootProps = {
        ...shouldShowFallback && fallback && {
            style: {
                display: "none"
            }
        }
    };
    const { customPages: customPages, customPagesPortals: customPagesPortals } = $cca6e67d3988e44a$var$useUserProfileCustomPages(props.children, {
        allowForAnyChildren: !!props.__experimental_asProvider
    });
    const userProfileProps = Object.assign(props.userProfileProps || {}, {
        customPages: customPages
    });
    const { customMenuItems: customMenuItems, customMenuItemsPortals: customMenuItemsPortals } = $cca6e67d3988e44a$var$useUserButtonCustomMenuItems(props.children);
    const sanitizedChildren = $cca6e67d3988e44a$var$useSanitizedChildren(props.children);
    const passableProps = {
        mount: clerk.mountUserButton,
        unmount: clerk.unmountUserButton,
        updateProps: clerk.__unstable__updateProps,
        props: {
            ...props,
            userProfileProps: userProfileProps,
            customMenuItems: customMenuItems
        }
    };
    const portalProps = {
        customPagesPortals: customPagesPortals,
        customMenuItemsPortals: customMenuItemsPortals
    };
    return /* @__PURE__ */ $cca6e67d3988e44a$var$import_react13.default.createElement($cca6e67d3988e44a$var$UserButtonContext.Provider, {
        value: passableProps
    }, shouldShowFallback && fallback, clerk.loaded && /* @__PURE__ */ $cca6e67d3988e44a$var$import_react13.default.createElement($cca6e67d3988e44a$var$ClerkHostRenderer, {
        component: component,
        ...passableProps,
        hideRootHtmlElement: !!props.__experimental_asProvider,
        rootProps: rendererRootProps
    }, props.__experimental_asProvider ? sanitizedChildren : null, /* @__PURE__ */ $cca6e67d3988e44a$var$import_react13.default.createElement($cca6e67d3988e44a$var$CustomPortalsRenderer, {
        ...portalProps
    })));
}, {
    component: "UserButton",
    renderWhileLoading: true
});
function $cca6e67d3988e44a$var$MenuItems({ children: children }) {
    (0, $7zhRN.logErrorInDevMode)($cca6e67d3988e44a$var$userButtonMenuItemsRenderedError);
    return /* @__PURE__ */ $cca6e67d3988e44a$var$import_react13.default.createElement($cca6e67d3988e44a$var$import_react13.default.Fragment, null, children);
}
function $cca6e67d3988e44a$var$MenuAction({ children: children }) {
    (0, $7zhRN.logErrorInDevMode)($cca6e67d3988e44a$var$userButtonMenuActionRenderedError);
    return /* @__PURE__ */ $cca6e67d3988e44a$var$import_react13.default.createElement($cca6e67d3988e44a$var$import_react13.default.Fragment, null, children);
}
function $cca6e67d3988e44a$var$MenuLink({ children: children }) {
    (0, $7zhRN.logErrorInDevMode)($cca6e67d3988e44a$var$userButtonMenuLinkRenderedError);
    return /* @__PURE__ */ $cca6e67d3988e44a$var$import_react13.default.createElement($cca6e67d3988e44a$var$import_react13.default.Fragment, null, children);
}
function $cca6e67d3988e44a$var$UserButtonOutlet(outletProps) {
    const providerProps = (0, $cca6e67d3988e44a$var$import_react13.useContext)($cca6e67d3988e44a$var$UserButtonContext);
    const portalProps = {
        ...providerProps,
        props: {
            ...providerProps.props,
            ...outletProps
        }
    };
    return /* @__PURE__ */ $cca6e67d3988e44a$var$import_react13.default.createElement($cca6e67d3988e44a$var$ClerkHostRenderer, {
        ...portalProps
    });
}
var $cca6e67d3988e44a$var$UserButton = Object.assign($cca6e67d3988e44a$var$_UserButton, {
    UserProfilePage: $cca6e67d3988e44a$var$UserProfilePage,
    UserProfileLink: $cca6e67d3988e44a$var$UserProfileLink,
    MenuItems: $cca6e67d3988e44a$var$MenuItems,
    Action: $cca6e67d3988e44a$var$MenuAction,
    Link: $cca6e67d3988e44a$var$MenuLink,
    __experimental_Outlet: $cca6e67d3988e44a$var$UserButtonOutlet
});
function $cca6e67d3988e44a$var$OrganizationProfilePage({ children: children }) {
    (0, $7zhRN.logErrorInDevMode)($cca6e67d3988e44a$var$organizationProfilePageRenderedError);
    return /* @__PURE__ */ $cca6e67d3988e44a$var$import_react13.default.createElement($cca6e67d3988e44a$var$import_react13.default.Fragment, null, children);
}
function $cca6e67d3988e44a$var$OrganizationProfileLink({ children: children }) {
    (0, $7zhRN.logErrorInDevMode)($cca6e67d3988e44a$var$organizationProfileLinkRenderedError);
    return /* @__PURE__ */ $cca6e67d3988e44a$var$import_react13.default.createElement($cca6e67d3988e44a$var$import_react13.default.Fragment, null, children);
}
var $cca6e67d3988e44a$var$_OrganizationProfile = $cca6e67d3988e44a$var$withClerk(({ clerk: clerk, component: component, fallback: fallback, ...props })=>{
    const mountingStatus = $cca6e67d3988e44a$var$useWaitForComponentMount(component);
    const shouldShowFallback = mountingStatus === "rendering" || !clerk.loaded;
    const rendererRootProps = {
        ...shouldShowFallback && fallback && {
            style: {
                display: "none"
            }
        }
    };
    const { customPages: customPages, customPagesPortals: customPagesPortals } = $cca6e67d3988e44a$var$useOrganizationProfileCustomPages(props.children);
    return /* @__PURE__ */ $cca6e67d3988e44a$var$import_react13.default.createElement($cca6e67d3988e44a$var$import_react13.default.Fragment, null, shouldShowFallback && fallback, clerk.loaded && /* @__PURE__ */ $cca6e67d3988e44a$var$import_react13.default.createElement($cca6e67d3988e44a$var$ClerkHostRenderer, {
        component: component,
        mount: clerk.mountOrganizationProfile,
        unmount: clerk.unmountOrganizationProfile,
        updateProps: clerk.__unstable__updateProps,
        props: {
            ...props,
            customPages: customPages
        },
        rootProps: rendererRootProps
    }, /* @__PURE__ */ $cca6e67d3988e44a$var$import_react13.default.createElement($cca6e67d3988e44a$var$CustomPortalsRenderer, {
        customPagesPortals: customPagesPortals
    })));
}, {
    component: "OrganizationProfile",
    renderWhileLoading: true
});
var $cca6e67d3988e44a$var$OrganizationProfile = Object.assign($cca6e67d3988e44a$var$_OrganizationProfile, {
    Page: $cca6e67d3988e44a$var$OrganizationProfilePage,
    Link: $cca6e67d3988e44a$var$OrganizationProfileLink
});
var $cca6e67d3988e44a$var$CreateOrganization = $cca6e67d3988e44a$var$withClerk(({ clerk: clerk, component: component, fallback: fallback, ...props })=>{
    const mountingStatus = $cca6e67d3988e44a$var$useWaitForComponentMount(component);
    const shouldShowFallback = mountingStatus === "rendering" || !clerk.loaded;
    const rendererRootProps = {
        ...shouldShowFallback && fallback && {
            style: {
                display: "none"
            }
        }
    };
    return /* @__PURE__ */ $cca6e67d3988e44a$var$import_react13.default.createElement($cca6e67d3988e44a$var$import_react13.default.Fragment, null, shouldShowFallback && fallback, clerk.loaded && /* @__PURE__ */ $cca6e67d3988e44a$var$import_react13.default.createElement($cca6e67d3988e44a$var$ClerkHostRenderer, {
        component: component,
        mount: clerk.mountCreateOrganization,
        unmount: clerk.unmountCreateOrganization,
        updateProps: clerk.__unstable__updateProps,
        props: props,
        rootProps: rendererRootProps
    }));
}, {
    component: "CreateOrganization",
    renderWhileLoading: true
});
var $cca6e67d3988e44a$var$OrganizationSwitcherContext = (0, $cca6e67d3988e44a$var$import_react13.createContext)({
    mount: ()=>{},
    unmount: ()=>{},
    updateProps: ()=>{}
});
var $cca6e67d3988e44a$var$_OrganizationSwitcher = $cca6e67d3988e44a$var$withClerk(({ clerk: clerk, component: component, fallback: fallback, ...props })=>{
    const mountingStatus = $cca6e67d3988e44a$var$useWaitForComponentMount(component);
    const shouldShowFallback = mountingStatus === "rendering" || !clerk.loaded;
    const rendererRootProps = {
        ...shouldShowFallback && fallback && {
            style: {
                display: "none"
            }
        }
    };
    const { customPages: customPages, customPagesPortals: customPagesPortals } = $cca6e67d3988e44a$var$useOrganizationProfileCustomPages(props.children, {
        allowForAnyChildren: !!props.__experimental_asProvider
    });
    const organizationProfileProps = Object.assign(props.organizationProfileProps || {}, {
        customPages: customPages
    });
    const sanitizedChildren = $cca6e67d3988e44a$var$useSanitizedChildren(props.children);
    const passableProps = {
        mount: clerk.mountOrganizationSwitcher,
        unmount: clerk.unmountOrganizationSwitcher,
        updateProps: clerk.__unstable__updateProps,
        props: {
            ...props,
            organizationProfileProps: organizationProfileProps
        },
        rootProps: rendererRootProps,
        component: component
    };
    clerk.__experimental_prefetchOrganizationSwitcher();
    return /* @__PURE__ */ $cca6e67d3988e44a$var$import_react13.default.createElement($cca6e67d3988e44a$var$OrganizationSwitcherContext.Provider, {
        value: passableProps
    }, /* @__PURE__ */ $cca6e67d3988e44a$var$import_react13.default.createElement($cca6e67d3988e44a$var$import_react13.default.Fragment, null, shouldShowFallback && fallback, clerk.loaded && /* @__PURE__ */ $cca6e67d3988e44a$var$import_react13.default.createElement($cca6e67d3988e44a$var$ClerkHostRenderer, {
        ...passableProps,
        hideRootHtmlElement: !!props.__experimental_asProvider
    }, props.__experimental_asProvider ? sanitizedChildren : null, /* @__PURE__ */ $cca6e67d3988e44a$var$import_react13.default.createElement($cca6e67d3988e44a$var$CustomPortalsRenderer, {
        customPagesPortals: customPagesPortals
    }))));
}, {
    component: "OrganizationSwitcher",
    renderWhileLoading: true
});
function $cca6e67d3988e44a$var$OrganizationSwitcherOutlet(outletProps) {
    const providerProps = (0, $cca6e67d3988e44a$var$import_react13.useContext)($cca6e67d3988e44a$var$OrganizationSwitcherContext);
    const portalProps = {
        ...providerProps,
        props: {
            ...providerProps.props,
            ...outletProps
        }
    };
    return /* @__PURE__ */ $cca6e67d3988e44a$var$import_react13.default.createElement($cca6e67d3988e44a$var$ClerkHostRenderer, {
        ...portalProps
    });
}
var $cca6e67d3988e44a$var$OrganizationSwitcher = Object.assign($cca6e67d3988e44a$var$_OrganizationSwitcher, {
    OrganizationProfilePage: $cca6e67d3988e44a$var$OrganizationProfilePage,
    OrganizationProfileLink: $cca6e67d3988e44a$var$OrganizationProfileLink,
    __experimental_Outlet: $cca6e67d3988e44a$var$OrganizationSwitcherOutlet
});
var $cca6e67d3988e44a$var$OrganizationList = $cca6e67d3988e44a$var$withClerk(({ clerk: clerk, component: component, fallback: fallback, ...props })=>{
    const mountingStatus = $cca6e67d3988e44a$var$useWaitForComponentMount(component);
    const shouldShowFallback = mountingStatus === "rendering" || !clerk.loaded;
    const rendererRootProps = {
        ...shouldShowFallback && fallback && {
            style: {
                display: "none"
            }
        }
    };
    return /* @__PURE__ */ $cca6e67d3988e44a$var$import_react13.default.createElement($cca6e67d3988e44a$var$import_react13.default.Fragment, null, shouldShowFallback && fallback, clerk.loaded && /* @__PURE__ */ $cca6e67d3988e44a$var$import_react13.default.createElement($cca6e67d3988e44a$var$ClerkHostRenderer, {
        component: component,
        mount: clerk.mountOrganizationList,
        unmount: clerk.unmountOrganizationList,
        updateProps: clerk.__unstable__updateProps,
        props: props,
        rootProps: rendererRootProps
    }));
}, {
    component: "OrganizationList",
    renderWhileLoading: true
});
var $cca6e67d3988e44a$var$GoogleOneTap = $cca6e67d3988e44a$var$withClerk(({ clerk: clerk, component: component, fallback: fallback, ...props })=>{
    const mountingStatus = $cca6e67d3988e44a$var$useWaitForComponentMount(component);
    const shouldShowFallback = mountingStatus === "rendering" || !clerk.loaded;
    const rendererRootProps = {
        ...shouldShowFallback && fallback && {
            style: {
                display: "none"
            }
        }
    };
    return /* @__PURE__ */ $cca6e67d3988e44a$var$import_react13.default.createElement($cca6e67d3988e44a$var$import_react13.default.Fragment, null, shouldShowFallback && fallback, clerk.loaded && /* @__PURE__ */ $cca6e67d3988e44a$var$import_react13.default.createElement($cca6e67d3988e44a$var$ClerkHostRenderer, {
        component: component,
        open: clerk.openGoogleOneTap,
        close: clerk.closeGoogleOneTap,
        updateProps: clerk.__unstable__updateProps,
        props: props,
        rootProps: rendererRootProps
    }));
}, {
    component: "GoogleOneTap",
    renderWhileLoading: true
});
var $cca6e67d3988e44a$var$Waitlist = $cca6e67d3988e44a$var$withClerk(({ clerk: clerk, component: component, fallback: fallback, ...props })=>{
    const mountingStatus = $cca6e67d3988e44a$var$useWaitForComponentMount(component);
    const shouldShowFallback = mountingStatus === "rendering" || !clerk.loaded;
    const rendererRootProps = {
        ...shouldShowFallback && fallback && {
            style: {
                display: "none"
            }
        }
    };
    return /* @__PURE__ */ $cca6e67d3988e44a$var$import_react13.default.createElement($cca6e67d3988e44a$var$import_react13.default.Fragment, null, shouldShowFallback && fallback, clerk.loaded && /* @__PURE__ */ $cca6e67d3988e44a$var$import_react13.default.createElement($cca6e67d3988e44a$var$ClerkHostRenderer, {
        component: component,
        mount: clerk.mountWaitlist,
        unmount: clerk.unmountWaitlist,
        updateProps: clerk.__unstable__updateProps,
        props: props,
        rootProps: rendererRootProps
    }));
}, {
    component: "Waitlist",
    renderWhileLoading: true
});

var $2dt0q = parcelRequire("2dt0q");

var $cca6e67d3988e44a$var$import_react21 = $cca6e67d3988e44a$var$__toESM((parcelRequire("jbmdS")));

var $ifeyV = parcelRequire("ifeyV");
var [$cca6e67d3988e44a$var$AuthContext, $cca6e67d3988e44a$var$useAuthContext] = (0, $ifeyV.createContextAndHook)("AuthContext");

var $ifeyV = parcelRequire("ifeyV");

var $kFYV7 = parcelRequire("kFYV7");

// src/hooks/utils.ts
var $cca6e67d3988e44a$var$clerkLoaded = (isomorphicClerk)=>{
    return new Promise((resolve)=>{
        if (isomorphicClerk.loaded) resolve();
        isomorphicClerk.addOnLoaded(resolve);
    });
};
var $cca6e67d3988e44a$var$createGetToken = (isomorphicClerk)=>{
    return async (options)=>{
        await $cca6e67d3988e44a$var$clerkLoaded(isomorphicClerk);
        if (!isomorphicClerk.session) return null;
        return isomorphicClerk.session.getToken(options);
    };
};
var $cca6e67d3988e44a$var$createSignOut = (isomorphicClerk)=>{
    return async (...args)=>{
        await $cca6e67d3988e44a$var$clerkLoaded(isomorphicClerk);
        return isomorphicClerk.signOut(...args);
    };
};
// src/hooks/useAuth.ts
var $cca6e67d3988e44a$var$useAuth = (initialAuthState = {})=>{
    $cca6e67d3988e44a$var$useAssertWrappedByClerkProvider("useAuth");
    const authContextFromHook = $cca6e67d3988e44a$var$useAuthContext();
    let authContext = authContextFromHook;
    if (authContext.sessionId === void 0 && authContext.userId === void 0) authContext = initialAuthState != null ? initialAuthState : {};
    const { sessionId: sessionId, userId: userId, actor: actor, orgId: orgId, orgRole: orgRole, orgSlug: orgSlug, orgPermissions: orgPermissions, factorVerificationAge: factorVerificationAge } = authContext;
    const isomorphicClerk = $cca6e67d3988e44a$var$useIsomorphicClerkContext();
    const getToken = (0, (parcelRequire("jbmdS")).useCallback)($cca6e67d3988e44a$var$createGetToken(isomorphicClerk), [
        isomorphicClerk
    ]);
    const signOut = (0, (parcelRequire("jbmdS")).useCallback)($cca6e67d3988e44a$var$createSignOut(isomorphicClerk), [
        isomorphicClerk
    ]);
    return $cca6e67d3988e44a$var$useDerivedAuth({
        sessionId: sessionId,
        userId: userId,
        actor: actor,
        orgId: orgId,
        orgSlug: orgSlug,
        orgRole: orgRole,
        getToken: getToken,
        signOut: signOut,
        orgPermissions: orgPermissions,
        factorVerificationAge: factorVerificationAge
    });
};
function $cca6e67d3988e44a$var$useDerivedAuth(authObject) {
    const { sessionId: sessionId, userId: userId, actor: actor, orgId: orgId, orgSlug: orgSlug, orgRole: orgRole, has: has, signOut: signOut, getToken: getToken, orgPermissions: orgPermissions, factorVerificationAge: factorVerificationAge } = authObject != null ? authObject : {};
    const derivedHas = (0, (parcelRequire("jbmdS")).useCallback)((params)=>{
        if (has) return has(params);
        return (0, $kFYV7.createCheckAuthorization)({
            userId: userId,
            orgId: orgId,
            orgRole: orgRole,
            orgPermissions: orgPermissions,
            factorVerificationAge: factorVerificationAge
        })(params);
    }, [
        userId,
        factorVerificationAge,
        orgId,
        orgRole,
        orgPermissions
    ]);
    if (sessionId === void 0 && userId === void 0) return {
        isLoaded: false,
        isSignedIn: void 0,
        sessionId: sessionId,
        userId: userId,
        actor: void 0,
        orgId: void 0,
        orgRole: void 0,
        orgSlug: void 0,
        has: void 0,
        signOut: signOut,
        getToken: getToken
    };
    if (sessionId === null && userId === null) return {
        isLoaded: true,
        isSignedIn: false,
        sessionId: sessionId,
        userId: userId,
        actor: null,
        orgId: null,
        orgRole: null,
        orgSlug: null,
        has: ()=>false,
        signOut: signOut,
        getToken: getToken
    };
    if (!!sessionId && !!userId && !!orgId && !!orgRole) return {
        isLoaded: true,
        isSignedIn: true,
        sessionId: sessionId,
        userId: userId,
        actor: actor || null,
        orgId: orgId,
        orgRole: orgRole,
        orgSlug: orgSlug || null,
        has: derivedHas,
        signOut: signOut,
        getToken: getToken
    };
    if (!!sessionId && !!userId && !orgId) return {
        isLoaded: true,
        isSignedIn: true,
        sessionId: sessionId,
        userId: userId,
        actor: actor || null,
        orgId: null,
        orgRole: null,
        orgSlug: null,
        has: derivedHas,
        signOut: signOut,
        getToken: getToken
    };
    return $cca6e67d3988e44a$var$errorThrower.throw($cca6e67d3988e44a$var$invalidStateError);
}

// src/hooks/useEmailLink.ts
var $cca6e67d3988e44a$var$import_react17 = $cca6e67d3988e44a$var$__toESM((parcelRequire("jbmdS")));
function $cca6e67d3988e44a$var$useEmailLink(resource) {
    const { startEmailLinkFlow: startEmailLinkFlow, cancelEmailLinkFlow: cancelEmailLinkFlow } = $cca6e67d3988e44a$var$import_react17.default.useMemo(()=>resource.createEmailLinkFlow(), [
        resource
    ]);
    $cca6e67d3988e44a$var$import_react17.default.useEffect(()=>{
        return cancelEmailLinkFlow;
    }, []);
    return {
        startEmailLinkFlow: startEmailLinkFlow,
        cancelEmailLinkFlow: cancelEmailLinkFlow
    };
}

var $ifeyV = parcelRequire("ifeyV");

var $4cJom = parcelRequire("4cJom");
var $cca6e67d3988e44a$var$useSignIn = ()=>{
    var _a;
    $cca6e67d3988e44a$var$useAssertWrappedByClerkProvider("useSignIn");
    const isomorphicClerk = $cca6e67d3988e44a$var$useIsomorphicClerkContext();
    const client = (0, $ifeyV.useClientContext)();
    (_a = isomorphicClerk.telemetry) == null || _a.record((0, $4cJom.eventMethodCalled)("useSignIn"));
    if (!client) return {
        isLoaded: false,
        signIn: void 0,
        setActive: void 0
    };
    return {
        isLoaded: true,
        signIn: client.signIn,
        setActive: isomorphicClerk.setActive
    };
};

var $ifeyV = parcelRequire("ifeyV");

var $4cJom = parcelRequire("4cJom");
var $cca6e67d3988e44a$var$useSignUp = ()=>{
    var _a;
    $cca6e67d3988e44a$var$useAssertWrappedByClerkProvider("useSignUp");
    const isomorphicClerk = $cca6e67d3988e44a$var$useIsomorphicClerkContext();
    const client = (0, $ifeyV.useClientContext)();
    (_a = isomorphicClerk.telemetry) == null || _a.record((0, $4cJom.eventMethodCalled)("useSignUp"));
    if (!client) return {
        isLoaded: false,
        signUp: void 0,
        setActive: void 0
    };
    return {
        isLoaded: true,
        signUp: client.signUp,
        setActive: isomorphicClerk.setActive
    };
};

var $ifeyV = parcelRequire("ifeyV");
// src/components/controlComponents.tsx
var $cca6e67d3988e44a$var$SignedIn = ({ children: children })=>{
    $cca6e67d3988e44a$var$useAssertWrappedByClerkProvider("SignedIn");
    const { userId: userId } = $cca6e67d3988e44a$var$useAuthContext();
    if (userId) return children;
    return null;
};
var $cca6e67d3988e44a$var$SignedOut = ({ children: children })=>{
    $cca6e67d3988e44a$var$useAssertWrappedByClerkProvider("SignedOut");
    const { userId: userId } = $cca6e67d3988e44a$var$useAuthContext();
    if (userId === null) return children;
    return null;
};
var $cca6e67d3988e44a$var$ClerkLoaded = ({ children: children })=>{
    $cca6e67d3988e44a$var$useAssertWrappedByClerkProvider("ClerkLoaded");
    const isomorphicClerk = $cca6e67d3988e44a$var$useIsomorphicClerkContext();
    if (!isomorphicClerk.loaded) return null;
    return children;
};
var $cca6e67d3988e44a$var$ClerkLoading = ({ children: children })=>{
    $cca6e67d3988e44a$var$useAssertWrappedByClerkProvider("ClerkLoading");
    const isomorphicClerk = $cca6e67d3988e44a$var$useIsomorphicClerkContext();
    if (isomorphicClerk.loaded) return null;
    return children;
};
var $cca6e67d3988e44a$var$Protect = ({ children: children, fallback: fallback, ...restAuthorizedParams })=>{
    $cca6e67d3988e44a$var$useAssertWrappedByClerkProvider("Protect");
    const { isLoaded: isLoaded, has: has, userId: userId } = $cca6e67d3988e44a$var$useAuth();
    if (!isLoaded) return null;
    const unauthorized = fallback != null ? fallback : null;
    const authorized = children;
    if (!userId) return unauthorized;
    if (typeof restAuthorizedParams.condition === "function") {
        if (restAuthorizedParams.condition(has)) return authorized;
        return unauthorized;
    }
    if (restAuthorizedParams.role || restAuthorizedParams.permission) {
        if (has(restAuthorizedParams)) return authorized;
        return unauthorized;
    }
    return authorized;
};
var $cca6e67d3988e44a$var$RedirectToSignIn = $cca6e67d3988e44a$var$withClerk(({ clerk: clerk, ...props })=>{
    const { client: client, session: session } = clerk;
    const hasActiveSessions = client.activeSessions && client.activeSessions.length > 0;
    $cca6e67d3988e44a$var$import_react21.default.useEffect(()=>{
        if (session === null && hasActiveSessions) clerk.redirectToAfterSignOut();
        else clerk.redirectToSignIn(props);
    }, []);
    return null;
}, "RedirectToSignIn");
var $cca6e67d3988e44a$var$RedirectToSignUp = $cca6e67d3988e44a$var$withClerk(({ clerk: clerk, ...props })=>{
    $cca6e67d3988e44a$var$import_react21.default.useEffect(()=>{
        clerk.redirectToSignUp(props);
    }, []);
    return null;
}, "RedirectToSignUp");
var $cca6e67d3988e44a$var$RedirectToUserProfile = $cca6e67d3988e44a$var$withClerk(({ clerk: clerk })=>{
    $cca6e67d3988e44a$var$import_react21.default.useEffect(()=>{
        (0, $2dt0q.deprecated)("RedirectToUserProfile", "Use the `redirectToUserProfile()` method instead.");
        clerk.redirectToUserProfile();
    }, []);
    return null;
}, "RedirectToUserProfile");
var $cca6e67d3988e44a$var$RedirectToOrganizationProfile = $cca6e67d3988e44a$var$withClerk(({ clerk: clerk })=>{
    $cca6e67d3988e44a$var$import_react21.default.useEffect(()=>{
        (0, $2dt0q.deprecated)("RedirectToOrganizationProfile", "Use the `redirectToOrganizationProfile()` method instead.");
        clerk.redirectToOrganizationProfile();
    }, []);
    return null;
}, "RedirectToOrganizationProfile");
var $cca6e67d3988e44a$var$RedirectToCreateOrganization = $cca6e67d3988e44a$var$withClerk(({ clerk: clerk })=>{
    $cca6e67d3988e44a$var$import_react21.default.useEffect(()=>{
        (0, $2dt0q.deprecated)("RedirectToCreateOrganization", "Use the `redirectToCreateOrganization()` method instead.");
        clerk.redirectToCreateOrganization();
    }, []);
    return null;
}, "RedirectToCreateOrganization");
var $cca6e67d3988e44a$var$AuthenticateWithRedirectCallback = $cca6e67d3988e44a$var$withClerk(({ clerk: clerk, ...handleRedirectCallbackParams })=>{
    $cca6e67d3988e44a$var$import_react21.default.useEffect(()=>{
        clerk.handleRedirectCallback(handleRedirectCallbackParams);
    }, []);
    return null;
}, "AuthenticateWithRedirectCallback");

// src/components/SignInButton.tsx
var $cca6e67d3988e44a$var$import_react22 = $cca6e67d3988e44a$var$__toESM((parcelRequire("jbmdS")));
var $cca6e67d3988e44a$var$SignInButton = $cca6e67d3988e44a$var$withClerk(({ clerk: clerk, children: children, ...props })=>{
    const { signUpFallbackRedirectUrl: signUpFallbackRedirectUrl, forceRedirectUrl: forceRedirectUrl, fallbackRedirectUrl: fallbackRedirectUrl, signUpForceRedirectUrl: signUpForceRedirectUrl, mode: mode, initialValues: initialValues, withSignUp: withSignUp, ...rest } = props;
    children = $cca6e67d3988e44a$var$normalizeWithDefaultValue(children, "Sign in");
    const child = $cca6e67d3988e44a$var$assertSingleChild(children)("SignInButton");
    const clickHandler = ()=>{
        const opts = {
            forceRedirectUrl: forceRedirectUrl,
            fallbackRedirectUrl: fallbackRedirectUrl,
            signUpFallbackRedirectUrl: signUpFallbackRedirectUrl,
            signUpForceRedirectUrl: signUpForceRedirectUrl,
            initialValues: initialValues,
            withSignUp: withSignUp
        };
        if (mode === "modal") return clerk.openSignIn({
            ...opts,
            appearance: props.appearance
        });
        return clerk.redirectToSignIn({
            ...opts,
            signInFallbackRedirectUrl: fallbackRedirectUrl,
            signInForceRedirectUrl: forceRedirectUrl
        });
    };
    const wrappedChildClickHandler = async (e)=>{
        if (child && typeof child === "object" && "props" in child) await $cca6e67d3988e44a$var$safeExecute(child.props.onClick)(e);
        return clickHandler();
    };
    const childProps = {
        ...rest,
        onClick: wrappedChildClickHandler
    };
    return $cca6e67d3988e44a$var$import_react22.default.cloneElement(child, childProps);
}, {
    component: "SignInButton",
    renderWhileLoading: true
});

// src/components/SignUpButton.tsx
var $cca6e67d3988e44a$var$import_react23 = $cca6e67d3988e44a$var$__toESM((parcelRequire("jbmdS")));
var $cca6e67d3988e44a$var$SignUpButton = $cca6e67d3988e44a$var$withClerk(({ clerk: clerk, children: children, ...props })=>{
    const { fallbackRedirectUrl: fallbackRedirectUrl, forceRedirectUrl: forceRedirectUrl, signInFallbackRedirectUrl: signInFallbackRedirectUrl, signInForceRedirectUrl: signInForceRedirectUrl, mode: mode, unsafeMetadata: unsafeMetadata, initialValues: initialValues, ...rest } = props;
    children = $cca6e67d3988e44a$var$normalizeWithDefaultValue(children, "Sign up");
    const child = $cca6e67d3988e44a$var$assertSingleChild(children)("SignUpButton");
    const clickHandler = ()=>{
        const opts = {
            fallbackRedirectUrl: fallbackRedirectUrl,
            forceRedirectUrl: forceRedirectUrl,
            signInFallbackRedirectUrl: signInFallbackRedirectUrl,
            signInForceRedirectUrl: signInForceRedirectUrl,
            unsafeMetadata: unsafeMetadata,
            initialValues: initialValues
        };
        if (mode === "modal") return clerk.openSignUp({
            ...opts,
            appearance: props.appearance
        });
        return clerk.redirectToSignUp({
            ...opts,
            signUpFallbackRedirectUrl: fallbackRedirectUrl,
            signUpForceRedirectUrl: forceRedirectUrl
        });
    };
    const wrappedChildClickHandler = async (e)=>{
        if (child && typeof child === "object" && "props" in child) await $cca6e67d3988e44a$var$safeExecute(child.props.onClick)(e);
        return clickHandler();
    };
    const childProps = {
        ...rest,
        onClick: wrappedChildClickHandler
    };
    return $cca6e67d3988e44a$var$import_react23.default.cloneElement(child, childProps);
}, {
    component: "SignUpButton",
    renderWhileLoading: true
});

// src/components/SignOutButton.tsx
var $cca6e67d3988e44a$var$import_react24 = $cca6e67d3988e44a$var$__toESM((parcelRequire("jbmdS")));
var $cca6e67d3988e44a$var$SignOutButton = $cca6e67d3988e44a$var$withClerk(({ clerk: clerk, children: children, ...props })=>{
    const { redirectUrl: redirectUrl = "/", signOutOptions: signOutOptions, ...rest } = props;
    children = $cca6e67d3988e44a$var$normalizeWithDefaultValue(children, "Sign out");
    const child = $cca6e67d3988e44a$var$assertSingleChild(children)("SignOutButton");
    const clickHandler = ()=>clerk.signOut({
            redirectUrl: redirectUrl,
            ...signOutOptions
        });
    const wrappedChildClickHandler = async (e)=>{
        await $cca6e67d3988e44a$var$safeExecute(child.props.onClick)(e);
        return clickHandler();
    };
    const childProps = {
        ...rest,
        onClick: wrappedChildClickHandler
    };
    return $cca6e67d3988e44a$var$import_react24.default.cloneElement(child, childProps);
}, {
    component: "SignOutButton",
    renderWhileLoading: true
});

// src/components/SignInWithMetamaskButton.tsx
var $cca6e67d3988e44a$var$import_react25 = $cca6e67d3988e44a$var$__toESM((parcelRequire("jbmdS")));
var $cca6e67d3988e44a$var$SignInWithMetamaskButton = $cca6e67d3988e44a$var$withClerk(({ clerk: clerk, children: children, ...props })=>{
    const { redirectUrl: redirectUrl, ...rest } = props;
    children = $cca6e67d3988e44a$var$normalizeWithDefaultValue(children, "Sign in with Metamask");
    const child = $cca6e67d3988e44a$var$assertSingleChild(children)("SignInWithMetamaskButton");
    const clickHandler = async ()=>{
        async function authenticate() {
            await clerk.authenticateWithMetamask({
                redirectUrl: redirectUrl || void 0
            });
        }
        authenticate();
    };
    const wrappedChildClickHandler = async (e)=>{
        await $cca6e67d3988e44a$var$safeExecute(child.props.onClick)(e);
        return clickHandler();
    };
    const childProps = {
        ...rest,
        onClick: wrappedChildClickHandler
    };
    return $cca6e67d3988e44a$var$import_react25.default.cloneElement(child, childProps);
}, {
    component: "SignInWithMetamask",
    renderWhileLoading: true
});

var $3jKgV = parcelRequire("3jKgV");

var $cca6e67d3988e44a$var$import_react28 = $cca6e67d3988e44a$var$__toESM((parcelRequire("jbmdS")));

var $3U9YZ = parcelRequire("3U9YZ");

var $ifeyV = parcelRequire("ifeyV");

var $cca6e67d3988e44a$var$import_react27 = $cca6e67d3988e44a$var$__toESM((parcelRequire("jbmdS")));

var $4PzIs = parcelRequire("4PzIs");

var $jCQ57 = parcelRequire("jCQ57");

var $7zhRN = parcelRequire("7zhRN");
if (typeof globalThis.__BUILD_DISABLE_RHC__ === "undefined") globalThis.__BUILD_DISABLE_RHC__ = false;
var $cca6e67d3988e44a$var$SDK_METADATA = {
    name: "@clerk/clerk-react",
    version: "5.23.0",
    environment: "production"
};
var $cca6e67d3988e44a$var$_loaded, $cca6e67d3988e44a$var$_domain, $cca6e67d3988e44a$var$_proxyUrl, $cca6e67d3988e44a$var$_publishableKey, $cca6e67d3988e44a$var$_instance, $cca6e67d3988e44a$var$_IsomorphicClerk_instances, $cca6e67d3988e44a$var$waitForClerkJS_fn;
var $cca6e67d3988e44a$var$_IsomorphicClerk = class _IsomorphicClerk {
    constructor(options){
        $cca6e67d3988e44a$var$__privateAdd(this, $cca6e67d3988e44a$var$_IsomorphicClerk_instances);
        this.clerkjs = null;
        this.preopenOneTap = null;
        this.preopenUserVerification = null;
        this.preopenSignIn = null;
        this.preopenSignUp = null;
        this.preopenUserProfile = null;
        this.preopenOrganizationProfile = null;
        this.preopenCreateOrganization = null;
        this.preOpenWaitlist = null;
        this.premountSignInNodes = /* @__PURE__ */ new Map();
        this.premountSignUpNodes = /* @__PURE__ */ new Map();
        this.premountUserProfileNodes = /* @__PURE__ */ new Map();
        this.premountUserButtonNodes = /* @__PURE__ */ new Map();
        this.premountOrganizationProfileNodes = /* @__PURE__ */ new Map();
        this.premountCreateOrganizationNodes = /* @__PURE__ */ new Map();
        this.premountOrganizationSwitcherNodes = /* @__PURE__ */ new Map();
        this.premountOrganizationListNodes = /* @__PURE__ */ new Map();
        this.premountMethodCalls = /* @__PURE__ */ new Map();
        this.premountWaitlistNodes = /* @__PURE__ */ new Map();
        // A separate Map of `addListener` method calls to handle multiple listeners.
        this.premountAddListenerCalls = /* @__PURE__ */ new Map();
        this.loadedListeners = [];
        $cca6e67d3988e44a$var$__privateAdd(this, $cca6e67d3988e44a$var$_loaded, false);
        $cca6e67d3988e44a$var$__privateAdd(this, $cca6e67d3988e44a$var$_domain);
        $cca6e67d3988e44a$var$__privateAdd(this, $cca6e67d3988e44a$var$_proxyUrl);
        $cca6e67d3988e44a$var$__privateAdd(this, $cca6e67d3988e44a$var$_publishableKey);
        this.buildSignInUrl = (opts)=>{
            const callback = ()=>{
                var _a;
                return ((_a = this.clerkjs) == null ? void 0 : _a.buildSignInUrl(opts)) || "";
            };
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) return callback();
            else this.premountMethodCalls.set("buildSignInUrl", callback);
        };
        this.buildSignUpUrl = (opts)=>{
            const callback = ()=>{
                var _a;
                return ((_a = this.clerkjs) == null ? void 0 : _a.buildSignUpUrl(opts)) || "";
            };
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) return callback();
            else this.premountMethodCalls.set("buildSignUpUrl", callback);
        };
        this.buildAfterSignInUrl = ()=>{
            const callback = ()=>{
                var _a;
                return ((_a = this.clerkjs) == null ? void 0 : _a.buildAfterSignInUrl()) || "";
            };
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) return callback();
            else this.premountMethodCalls.set("buildAfterSignInUrl", callback);
        };
        this.buildAfterSignUpUrl = ()=>{
            const callback = ()=>{
                var _a;
                return ((_a = this.clerkjs) == null ? void 0 : _a.buildAfterSignUpUrl()) || "";
            };
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) return callback();
            else this.premountMethodCalls.set("buildAfterSignUpUrl", callback);
        };
        this.buildAfterSignOutUrl = ()=>{
            const callback = ()=>{
                var _a;
                return ((_a = this.clerkjs) == null ? void 0 : _a.buildAfterSignOutUrl()) || "";
            };
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) return callback();
            else this.premountMethodCalls.set("buildAfterSignOutUrl", callback);
        };
        this.buildAfterMultiSessionSingleSignOutUrl = ()=>{
            const callback = ()=>{
                var _a;
                return ((_a = this.clerkjs) == null ? void 0 : _a.buildAfterMultiSessionSingleSignOutUrl()) || "";
            };
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) return callback();
            else this.premountMethodCalls.set("buildAfterMultiSessionSingleSignOutUrl", callback);
        };
        this.buildUserProfileUrl = ()=>{
            const callback = ()=>{
                var _a;
                return ((_a = this.clerkjs) == null ? void 0 : _a.buildUserProfileUrl()) || "";
            };
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) return callback();
            else this.premountMethodCalls.set("buildUserProfileUrl", callback);
        };
        this.buildCreateOrganizationUrl = ()=>{
            const callback = ()=>{
                var _a;
                return ((_a = this.clerkjs) == null ? void 0 : _a.buildCreateOrganizationUrl()) || "";
            };
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) return callback();
            else this.premountMethodCalls.set("buildCreateOrganizationUrl", callback);
        };
        this.buildOrganizationProfileUrl = ()=>{
            const callback = ()=>{
                var _a;
                return ((_a = this.clerkjs) == null ? void 0 : _a.buildOrganizationProfileUrl()) || "";
            };
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) return callback();
            else this.premountMethodCalls.set("buildOrganizationProfileUrl", callback);
        };
        this.buildWaitlistUrl = ()=>{
            const callback = ()=>{
                var _a;
                return ((_a = this.clerkjs) == null ? void 0 : _a.buildWaitlistUrl()) || "";
            };
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) return callback();
            else this.premountMethodCalls.set("buildWaitlistUrl", callback);
        };
        this.buildUrlWithAuth = (to)=>{
            const callback = ()=>{
                var _a;
                return ((_a = this.clerkjs) == null ? void 0 : _a.buildUrlWithAuth(to)) || "";
            };
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) return callback();
            else this.premountMethodCalls.set("buildUrlWithAuth", callback);
        };
        this.handleUnauthenticated = ()=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.handleUnauthenticated();
            };
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) callback();
            else this.premountMethodCalls.set("handleUnauthenticated", callback);
        };
        this.addOnLoaded = (cb)=>{
            this.loadedListeners.push(cb);
            if (this.loaded) this.emitLoaded();
        };
        this.emitLoaded = ()=>{
            this.loadedListeners.forEach((cb)=>cb());
            this.loadedListeners = [];
        };
        this.hydrateClerkJS = (clerkjs)=>{
            if (!clerkjs) throw new Error("Failed to hydrate latest Clerk JS");
            this.clerkjs = clerkjs;
            this.premountMethodCalls.forEach((cb)=>cb());
            this.premountAddListenerCalls.forEach((listenerHandlers, listener)=>{
                listenerHandlers.nativeUnsubscribe = clerkjs.addListener(listener);
            });
            if (this.preopenSignIn !== null) clerkjs.openSignIn(this.preopenSignIn);
            if (this.preopenSignUp !== null) clerkjs.openSignUp(this.preopenSignUp);
            if (this.preopenUserProfile !== null) clerkjs.openUserProfile(this.preopenUserProfile);
            if (this.preopenUserVerification !== null) clerkjs.__internal_openReverification(this.preopenUserVerification);
            if (this.preopenOneTap !== null) clerkjs.openGoogleOneTap(this.preopenOneTap);
            if (this.preopenOrganizationProfile !== null) clerkjs.openOrganizationProfile(this.preopenOrganizationProfile);
            if (this.preopenCreateOrganization !== null) clerkjs.openCreateOrganization(this.preopenCreateOrganization);
            if (this.preOpenWaitlist !== null) clerkjs.openWaitlist(this.preOpenWaitlist);
            this.premountSignInNodes.forEach((props, node)=>{
                clerkjs.mountSignIn(node, props);
            });
            this.premountSignUpNodes.forEach((props, node)=>{
                clerkjs.mountSignUp(node, props);
            });
            this.premountUserProfileNodes.forEach((props, node)=>{
                clerkjs.mountUserProfile(node, props);
            });
            this.premountUserButtonNodes.forEach((props, node)=>{
                clerkjs.mountUserButton(node, props);
            });
            this.premountOrganizationListNodes.forEach((props, node)=>{
                clerkjs.mountOrganizationList(node, props);
            });
            this.premountWaitlistNodes.forEach((props, node)=>{
                clerkjs.mountWaitlist(node, props);
            });
            $cca6e67d3988e44a$var$__privateSet(this, $cca6e67d3988e44a$var$_loaded, true);
            this.emitLoaded();
            return this.clerkjs;
        };
        this.__unstable__updateProps = async (props)=>{
            const clerkjs = await $cca6e67d3988e44a$var$__privateMethod(this, $cca6e67d3988e44a$var$_IsomorphicClerk_instances, $cca6e67d3988e44a$var$waitForClerkJS_fn).call(this);
            if (clerkjs && "__unstable__updateProps" in clerkjs) return clerkjs.__unstable__updateProps(props);
        };
        /**
     * `setActive` can be used to set the active session and/or organization.
     */ this.setActive = ({ session: session, organization: organization, beforeEmit: beforeEmit, redirectUrl: redirectUrl })=>{
            if (this.clerkjs) return this.clerkjs.setActive({
                session: session,
                organization: organization,
                beforeEmit: beforeEmit,
                redirectUrl: redirectUrl
            });
            else return Promise.reject();
        };
        this.openSignIn = (props)=>{
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) this.clerkjs.openSignIn(props);
            else this.preopenSignIn = props;
        };
        this.closeSignIn = ()=>{
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) this.clerkjs.closeSignIn();
            else this.preopenSignIn = null;
        };
        this.__internal_openReverification = (props)=>{
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) this.clerkjs.__internal_openReverification(props);
            else this.preopenUserVerification = props;
        };
        this.__internal_closeReverification = ()=>{
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) this.clerkjs.__internal_closeReverification();
            else this.preopenUserVerification = null;
        };
        this.openGoogleOneTap = (props)=>{
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) this.clerkjs.openGoogleOneTap(props);
            else this.preopenOneTap = props;
        };
        this.closeGoogleOneTap = ()=>{
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) this.clerkjs.closeGoogleOneTap();
            else this.preopenOneTap = null;
        };
        this.openUserProfile = (props)=>{
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) this.clerkjs.openUserProfile(props);
            else this.preopenUserProfile = props;
        };
        this.closeUserProfile = ()=>{
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) this.clerkjs.closeUserProfile();
            else this.preopenUserProfile = null;
        };
        this.openOrganizationProfile = (props)=>{
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) this.clerkjs.openOrganizationProfile(props);
            else this.preopenOrganizationProfile = props;
        };
        this.closeOrganizationProfile = ()=>{
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) this.clerkjs.closeOrganizationProfile();
            else this.preopenOrganizationProfile = null;
        };
        this.openCreateOrganization = (props)=>{
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) this.clerkjs.openCreateOrganization(props);
            else this.preopenCreateOrganization = props;
        };
        this.closeCreateOrganization = ()=>{
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) this.clerkjs.closeCreateOrganization();
            else this.preopenCreateOrganization = null;
        };
        this.openWaitlist = (props)=>{
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) this.clerkjs.openWaitlist(props);
            else this.preOpenWaitlist = props;
        };
        this.closeWaitlist = ()=>{
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) this.clerkjs.closeWaitlist();
            else this.preOpenWaitlist = null;
        };
        this.openSignUp = (props)=>{
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) this.clerkjs.openSignUp(props);
            else this.preopenSignUp = props;
        };
        this.closeSignUp = ()=>{
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) this.clerkjs.closeSignUp();
            else this.preopenSignUp = null;
        };
        this.mountSignIn = (node, props)=>{
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) this.clerkjs.mountSignIn(node, props);
            else this.premountSignInNodes.set(node, props);
        };
        this.unmountSignIn = (node)=>{
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) this.clerkjs.unmountSignIn(node);
            else this.premountSignInNodes.delete(node);
        };
        this.mountSignUp = (node, props)=>{
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) this.clerkjs.mountSignUp(node, props);
            else this.premountSignUpNodes.set(node, props);
        };
        this.unmountSignUp = (node)=>{
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) this.clerkjs.unmountSignUp(node);
            else this.premountSignUpNodes.delete(node);
        };
        this.mountUserProfile = (node, props)=>{
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) this.clerkjs.mountUserProfile(node, props);
            else this.premountUserProfileNodes.set(node, props);
        };
        this.unmountUserProfile = (node)=>{
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) this.clerkjs.unmountUserProfile(node);
            else this.premountUserProfileNodes.delete(node);
        };
        this.mountOrganizationProfile = (node, props)=>{
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) this.clerkjs.mountOrganizationProfile(node, props);
            else this.premountOrganizationProfileNodes.set(node, props);
        };
        this.unmountOrganizationProfile = (node)=>{
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) this.clerkjs.unmountOrganizationProfile(node);
            else this.premountOrganizationProfileNodes.delete(node);
        };
        this.mountCreateOrganization = (node, props)=>{
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) this.clerkjs.mountCreateOrganization(node, props);
            else this.premountCreateOrganizationNodes.set(node, props);
        };
        this.unmountCreateOrganization = (node)=>{
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) this.clerkjs.unmountCreateOrganization(node);
            else this.premountCreateOrganizationNodes.delete(node);
        };
        this.mountOrganizationSwitcher = (node, props)=>{
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) this.clerkjs.mountOrganizationSwitcher(node, props);
            else this.premountOrganizationSwitcherNodes.set(node, props);
        };
        this.unmountOrganizationSwitcher = (node)=>{
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) this.clerkjs.unmountOrganizationSwitcher(node);
            else this.premountOrganizationSwitcherNodes.delete(node);
        };
        this.__experimental_prefetchOrganizationSwitcher = ()=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.__experimental_prefetchOrganizationSwitcher();
            };
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) callback();
            else this.premountMethodCalls.set("__experimental_prefetchOrganizationSwitcher", callback);
        };
        this.mountOrganizationList = (node, props)=>{
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) this.clerkjs.mountOrganizationList(node, props);
            else this.premountOrganizationListNodes.set(node, props);
        };
        this.unmountOrganizationList = (node)=>{
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) this.clerkjs.unmountOrganizationList(node);
            else this.premountOrganizationListNodes.delete(node);
        };
        this.mountUserButton = (node, userButtonProps)=>{
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) this.clerkjs.mountUserButton(node, userButtonProps);
            else this.premountUserButtonNodes.set(node, userButtonProps);
        };
        this.unmountUserButton = (node)=>{
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) this.clerkjs.unmountUserButton(node);
            else this.premountUserButtonNodes.delete(node);
        };
        this.mountWaitlist = (node, props)=>{
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) this.clerkjs.mountWaitlist(node, props);
            else this.premountWaitlistNodes.set(node, props);
        };
        this.unmountWaitlist = (node)=>{
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) this.clerkjs.unmountWaitlist(node);
            else this.premountWaitlistNodes.delete(node);
        };
        this.addListener = (listener)=>{
            if (this.clerkjs) return this.clerkjs.addListener(listener);
            else {
                const unsubscribe = ()=>{
                    var _a;
                    const listenerHandlers = this.premountAddListenerCalls.get(listener);
                    if (listenerHandlers) {
                        (_a = listenerHandlers.nativeUnsubscribe) == null || _a.call(listenerHandlers);
                        this.premountAddListenerCalls.delete(listener);
                    }
                };
                this.premountAddListenerCalls.set(listener, {
                    unsubscribe: unsubscribe,
                    nativeUnsubscribe: void 0
                });
                return unsubscribe;
            }
        };
        this.navigate = (to)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.navigate(to);
            };
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) callback();
            else this.premountMethodCalls.set("navigate", callback);
        };
        this.redirectWithAuth = async (...args)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.redirectWithAuth(...args);
            };
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) return callback();
            else {
                this.premountMethodCalls.set("redirectWithAuth", callback);
                return;
            }
        };
        this.redirectToSignIn = async (opts)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.redirectToSignIn(opts);
            };
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) return callback();
            else {
                this.premountMethodCalls.set("redirectToSignIn", callback);
                return;
            }
        };
        this.redirectToSignUp = async (opts)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.redirectToSignUp(opts);
            };
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) return callback();
            else {
                this.premountMethodCalls.set("redirectToSignUp", callback);
                return;
            }
        };
        this.redirectToUserProfile = async ()=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.redirectToUserProfile();
            };
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) return callback();
            else {
                this.premountMethodCalls.set("redirectToUserProfile", callback);
                return;
            }
        };
        this.redirectToAfterSignUp = ()=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.redirectToAfterSignUp();
            };
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) return callback();
            else this.premountMethodCalls.set("redirectToAfterSignUp", callback);
        };
        this.redirectToAfterSignIn = ()=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.redirectToAfterSignIn();
            };
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) callback();
            else this.premountMethodCalls.set("redirectToAfterSignIn", callback);
        };
        this.redirectToAfterSignOut = ()=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.redirectToAfterSignOut();
            };
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) callback();
            else this.premountMethodCalls.set("redirectToAfterSignOut", callback);
        };
        this.redirectToOrganizationProfile = async ()=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.redirectToOrganizationProfile();
            };
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) return callback();
            else {
                this.premountMethodCalls.set("redirectToOrganizationProfile", callback);
                return;
            }
        };
        this.redirectToCreateOrganization = async ()=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.redirectToCreateOrganization();
            };
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) return callback();
            else {
                this.premountMethodCalls.set("redirectToCreateOrganization", callback);
                return;
            }
        };
        this.redirectToWaitlist = async ()=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.redirectToWaitlist();
            };
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) return callback();
            else {
                this.premountMethodCalls.set("redirectToWaitlist", callback);
                return;
            }
        };
        this.handleRedirectCallback = (params)=>{
            var _a;
            const callback = ()=>{
                var _a2;
                return (_a2 = this.clerkjs) == null ? void 0 : _a2.handleRedirectCallback(params);
            };
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) (_a = callback()) == null || _a.catch(()=>{});
            else this.premountMethodCalls.set("handleRedirectCallback", callback);
        };
        this.handleGoogleOneTapCallback = (signInOrUp, params)=>{
            var _a;
            const callback = ()=>{
                var _a2;
                return (_a2 = this.clerkjs) == null ? void 0 : _a2.handleGoogleOneTapCallback(signInOrUp, params);
            };
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) (_a = callback()) == null || _a.catch(()=>{});
            else this.premountMethodCalls.set("handleGoogleOneTapCallback", callback);
        };
        this.handleEmailLinkVerification = async (params)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.handleEmailLinkVerification(params);
            };
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) return callback();
            else this.premountMethodCalls.set("handleEmailLinkVerification", callback);
        };
        this.authenticateWithMetamask = async (params)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.authenticateWithMetamask(params);
            };
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) return callback();
            else this.premountMethodCalls.set("authenticateWithMetamask", callback);
        };
        this.authenticateWithCoinbaseWallet = async (params)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.authenticateWithCoinbaseWallet(params);
            };
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) return callback();
            else this.premountMethodCalls.set("authenticateWithCoinbaseWallet", callback);
        };
        this.authenticateWithOKXWallet = async (params)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.authenticateWithOKXWallet(params);
            };
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) return callback();
            else this.premountMethodCalls.set("authenticateWithOKXWallet", callback);
        };
        this.authenticateWithWeb3 = async (params)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.authenticateWithWeb3(params);
            };
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) return callback();
            else this.premountMethodCalls.set("authenticateWithWeb3", callback);
        };
        this.authenticateWithGoogleOneTap = async (params)=>{
            const clerkjs = await $cca6e67d3988e44a$var$__privateMethod(this, $cca6e67d3988e44a$var$_IsomorphicClerk_instances, $cca6e67d3988e44a$var$waitForClerkJS_fn).call(this);
            return clerkjs.authenticateWithGoogleOneTap(params);
        };
        this.createOrganization = async (params)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.createOrganization(params);
            };
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) return callback();
            else this.premountMethodCalls.set("createOrganization", callback);
        };
        this.getOrganization = async (organizationId)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.getOrganization(organizationId);
            };
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) return callback();
            else this.premountMethodCalls.set("getOrganization", callback);
        };
        this.joinWaitlist = async (params)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.joinWaitlist(params);
            };
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) return callback();
            else this.premountMethodCalls.set("joinWaitlist", callback);
        };
        this.signOut = async (signOutCallbackOrOptions, options)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.signOut(signOutCallbackOrOptions, options);
            };
            if (this.clerkjs && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) return callback();
            else this.premountMethodCalls.set("signOut", callback);
        };
        const { Clerk: Clerk = null, publishableKey: publishableKey } = options || {};
        $cca6e67d3988e44a$var$__privateSet(this, $cca6e67d3988e44a$var$_publishableKey, publishableKey);
        $cca6e67d3988e44a$var$__privateSet(this, $cca6e67d3988e44a$var$_proxyUrl, options == null ? void 0 : options.proxyUrl);
        $cca6e67d3988e44a$var$__privateSet(this, $cca6e67d3988e44a$var$_domain, options == null ? void 0 : options.domain);
        this.options = options;
        this.Clerk = Clerk;
        this.mode = (0, $4PzIs.inBrowser)() ? "browser" : "server";
        if (!this.options.sdkMetadata) this.options.sdkMetadata = $cca6e67d3988e44a$var$SDK_METADATA;
        if ($cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_publishableKey)) this.loadClerkJS();
    }
    get publishableKey() {
        return $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_publishableKey);
    }
    get loaded() {
        return $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded);
    }
    static getOrCreateInstance(options) {
        if (!(0, $4PzIs.inBrowser)() || !$cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_instance) || options.Clerk && $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_instance).Clerk !== options.Clerk || // Allow hot swapping PKs on the client
        $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_instance).publishableKey !== options.publishableKey) $cca6e67d3988e44a$var$__privateSet(this, $cca6e67d3988e44a$var$_instance, new _IsomorphicClerk(options));
        return $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_instance);
    }
    static clearInstance() {
        $cca6e67d3988e44a$var$__privateSet(this, $cca6e67d3988e44a$var$_instance, null);
    }
    get domain() {
        if (typeof window !== "undefined" && window.location) return (0, $7zhRN.handleValueOrFn)($cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_domain), new URL(window.location.href), "");
        if (typeof $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_domain) === "function") return $cca6e67d3988e44a$var$errorThrower.throw($cca6e67d3988e44a$var$unsupportedNonBrowserDomainOrProxyUrlFunction);
        return $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_domain) || "";
    }
    get proxyUrl() {
        if (typeof window !== "undefined" && window.location) return (0, $7zhRN.handleValueOrFn)($cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_proxyUrl), new URL(window.location.href), "");
        if (typeof $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_proxyUrl) === "function") return $cca6e67d3988e44a$var$errorThrower.throw($cca6e67d3988e44a$var$unsupportedNonBrowserDomainOrProxyUrlFunction);
        return $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_proxyUrl) || "";
    }
    __internal_getOption(key) {
        var _a;
        return (_a = this.clerkjs) == null ? void 0 : _a.__internal_getOption(key);
    }
    get sdkMetadata() {
        var _a;
        return ((_a = this.clerkjs) == null ? void 0 : _a.sdkMetadata) || this.options.sdkMetadata || void 0;
    }
    get instanceType() {
        var _a;
        return (_a = this.clerkjs) == null ? void 0 : _a.instanceType;
    }
    get frontendApi() {
        var _a;
        return ((_a = this.clerkjs) == null ? void 0 : _a.frontendApi) || "";
    }
    get isStandardBrowser() {
        var _a;
        return ((_a = this.clerkjs) == null ? void 0 : _a.isStandardBrowser) || this.options.standardBrowser || false;
    }
    get isSatellite() {
        if (typeof window !== "undefined" && window.location) return (0, $7zhRN.handleValueOrFn)(this.options.isSatellite, new URL(window.location.href), false);
        if (typeof this.options.isSatellite === "function") return $cca6e67d3988e44a$var$errorThrower.throw($cca6e67d3988e44a$var$unsupportedNonBrowserDomainOrProxyUrlFunction);
        return false;
    }
    async loadClerkJS() {
        var _a;
        if (this.mode !== "browser" || $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_loaded)) return;
        if (typeof window !== "undefined") {
            window.__clerk_publishable_key = $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_publishableKey);
            window.__clerk_proxy_url = this.proxyUrl;
            window.__clerk_domain = this.domain;
        }
        try {
            if (this.Clerk) {
                let c;
                if ($cca6e67d3988e44a$var$isConstructor(this.Clerk)) {
                    c = new this.Clerk($cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_publishableKey), {
                        proxyUrl: this.proxyUrl,
                        domain: this.domain
                    });
                    await c.load(this.options);
                } else {
                    c = this.Clerk;
                    if (!c.loaded) await c.load(this.options);
                }
                $parcel$global.Clerk = c;
            } else if (!__BUILD_DISABLE_RHC__) {
                if (!$parcel$global.Clerk) await (0, $jCQ57.loadClerkJsScript)({
                    ...this.options,
                    publishableKey: $cca6e67d3988e44a$var$__privateGet(this, $cca6e67d3988e44a$var$_publishableKey),
                    proxyUrl: this.proxyUrl,
                    domain: this.domain,
                    nonce: this.options.nonce
                });
                if (!$parcel$global.Clerk) throw new Error("Failed to download latest ClerkJS. Contact support@clerk.com.");
                await $parcel$global.Clerk.load(this.options);
            }
            if ((_a = $parcel$global.Clerk) == null ? void 0 : _a.loaded) return this.hydrateClerkJS($parcel$global.Clerk);
            return;
        } catch (err) {
            const error = err;
            console.error(error.stack || error.message || error);
            return;
        }
    }
    get version() {
        var _a;
        return (_a = this.clerkjs) == null ? void 0 : _a.version;
    }
    get client() {
        if (this.clerkjs) return this.clerkjs.client;
        else return void 0;
    }
    get session() {
        if (this.clerkjs) return this.clerkjs.session;
        else return void 0;
    }
    get user() {
        if (this.clerkjs) return this.clerkjs.user;
        else return void 0;
    }
    get organization() {
        if (this.clerkjs) return this.clerkjs.organization;
        else return void 0;
    }
    get telemetry() {
        if (this.clerkjs) return this.clerkjs.telemetry;
        else return void 0;
    }
    get __unstable__environment() {
        if (this.clerkjs) return this.clerkjs.__unstable__environment;
        else return void 0;
    }
    __unstable__setEnvironment(...args) {
        if (this.clerkjs && "__unstable__setEnvironment" in this.clerkjs) this.clerkjs.__unstable__setEnvironment(args);
        else return void 0;
    }
};
$cca6e67d3988e44a$var$_loaded = new WeakMap();
$cca6e67d3988e44a$var$_domain = new WeakMap();
$cca6e67d3988e44a$var$_proxyUrl = new WeakMap();
$cca6e67d3988e44a$var$_publishableKey = new WeakMap();
$cca6e67d3988e44a$var$_instance = new WeakMap();
$cca6e67d3988e44a$var$_IsomorphicClerk_instances = new WeakSet();
$cca6e67d3988e44a$var$waitForClerkJS_fn = function() {
    return new Promise((resolve)=>{
        this.addOnLoaded(()=>resolve(this.clerkjs));
    });
};
$cca6e67d3988e44a$var$__privateAdd($cca6e67d3988e44a$var$_IsomorphicClerk, $cca6e67d3988e44a$var$_instance);
var $cca6e67d3988e44a$var$IsomorphicClerk = $cca6e67d3988e44a$var$_IsomorphicClerk;
// src/contexts/ClerkContextProvider.tsx
function $cca6e67d3988e44a$var$ClerkContextProvider(props) {
    const { isomorphicClerkOptions: isomorphicClerkOptions, initialState: initialState, children: children } = props;
    const { isomorphicClerk: clerk, loaded: clerkLoaded2 } = $cca6e67d3988e44a$var$useLoadedIsomorphicClerk(isomorphicClerkOptions);
    const [state, setState] = $cca6e67d3988e44a$var$import_react27.default.useState({
        client: clerk.client,
        session: clerk.session,
        user: clerk.user,
        organization: clerk.organization
    });
    $cca6e67d3988e44a$var$import_react27.default.useEffect(()=>{
        return clerk.addListener((e)=>setState({
                ...e
            }));
    }, []);
    const derivedState = (0, $3U9YZ.deriveState)(clerkLoaded2, state, initialState);
    const clerkCtx = $cca6e67d3988e44a$var$import_react27.default.useMemo(()=>({
            value: clerk
        }), [
        clerkLoaded2
    ]);
    const clientCtx = $cca6e67d3988e44a$var$import_react27.default.useMemo(()=>({
            value: state.client
        }), [
        state.client
    ]);
    const { sessionId: sessionId, session: session, userId: userId, user: user, orgId: orgId, actor: actor, organization: organization, orgRole: orgRole, orgSlug: orgSlug, orgPermissions: orgPermissions, factorVerificationAge: factorVerificationAge } = derivedState;
    const authCtx = $cca6e67d3988e44a$var$import_react27.default.useMemo(()=>{
        const value = {
            sessionId: sessionId,
            userId: userId,
            actor: actor,
            orgId: orgId,
            orgRole: orgRole,
            orgSlug: orgSlug,
            orgPermissions: orgPermissions,
            factorVerificationAge: factorVerificationAge
        };
        return {
            value: value
        };
    }, [
        sessionId,
        userId,
        actor,
        orgId,
        orgRole,
        orgSlug,
        factorVerificationAge
    ]);
    const sessionCtx = $cca6e67d3988e44a$var$import_react27.default.useMemo(()=>({
            value: session
        }), [
        sessionId,
        session
    ]);
    const userCtx = $cca6e67d3988e44a$var$import_react27.default.useMemo(()=>({
            value: user
        }), [
        userId,
        user
    ]);
    const organizationCtx = $cca6e67d3988e44a$var$import_react27.default.useMemo(()=>{
        const value = {
            organization: organization
        };
        return {
            value: value
        };
    }, [
        orgId,
        organization
    ]);
    return(// @ts-expect-error value passed is of type IsomorphicClerk where the context expects LoadedClerk
    /* @__PURE__ */ $cca6e67d3988e44a$var$import_react27.default.createElement($cca6e67d3988e44a$var$IsomorphicClerkContext.Provider, {
        value: clerkCtx
    }, /* @__PURE__ */ $cca6e67d3988e44a$var$import_react27.default.createElement($ifeyV.ClientContext.Provider, {
        value: clientCtx
    }, /* @__PURE__ */ $cca6e67d3988e44a$var$import_react27.default.createElement($ifeyV.SessionContext.Provider, {
        value: sessionCtx
    }, /* @__PURE__ */ $cca6e67d3988e44a$var$import_react27.default.createElement($ifeyV.OrganizationProvider, {
        ...organizationCtx.value
    }, /* @__PURE__ */ $cca6e67d3988e44a$var$import_react27.default.createElement($cca6e67d3988e44a$var$AuthContext.Provider, {
        value: authCtx
    }, /* @__PURE__ */ $cca6e67d3988e44a$var$import_react27.default.createElement($ifeyV.UserContext.Provider, {
        value: userCtx
    }, children)))))));
}
var $cca6e67d3988e44a$var$useLoadedIsomorphicClerk = (options)=>{
    const [loaded, setLoaded] = $cca6e67d3988e44a$var$import_react27.default.useState(false);
    const isomorphicClerk = $cca6e67d3988e44a$var$import_react27.default.useMemo(()=>$cca6e67d3988e44a$var$IsomorphicClerk.getOrCreateInstance(options), []);
    $cca6e67d3988e44a$var$import_react27.default.useEffect(()=>{
        isomorphicClerk.__unstable__updateProps({
            appearance: options.appearance
        });
    }, [
        options.appearance
    ]);
    $cca6e67d3988e44a$var$import_react27.default.useEffect(()=>{
        isomorphicClerk.__unstable__updateProps({
            options: options
        });
    }, [
        options.localization
    ]);
    $cca6e67d3988e44a$var$import_react27.default.useEffect(()=>{
        isomorphicClerk.addOnLoaded(()=>setLoaded(true));
    }, []);
    $cca6e67d3988e44a$var$import_react27.default.useEffect(()=>{
        return ()=>{
            $cca6e67d3988e44a$var$IsomorphicClerk.clearInstance();
            setLoaded(false);
        };
    }, []);
    return {
        isomorphicClerk: isomorphicClerk,
        loaded: loaded
    };
};
// src/contexts/ClerkProvider.tsx
function $cca6e67d3988e44a$var$ClerkProviderBase(props) {
    const { initialState: initialState, children: children, __internal_bypassMissingPublishableKey: __internal_bypassMissingPublishableKey, ...restIsomorphicClerkOptions } = props;
    const { publishableKey: publishableKey = "", Clerk: userInitialisedClerk } = restIsomorphicClerkOptions;
    if (!userInitialisedClerk && !__internal_bypassMissingPublishableKey) {
        if (!publishableKey) $cca6e67d3988e44a$var$errorThrower.throwMissingPublishableKeyError();
        else if (publishableKey && !(0, $3jKgV.isPublishableKey)(publishableKey)) $cca6e67d3988e44a$var$errorThrower.throwInvalidPublishableKeyError({
            key: publishableKey
        });
    }
    return /* @__PURE__ */ $cca6e67d3988e44a$var$import_react28.default.createElement($cca6e67d3988e44a$var$ClerkContextProvider, {
        initialState: initialState,
        isomorphicClerkOptions: restIsomorphicClerkOptions
    }, children);
}
var $cca6e67d3988e44a$var$ClerkProvider = $cca6e67d3988e44a$var$withMaxAllowedInstancesGuard($cca6e67d3988e44a$var$ClerkProviderBase, "ClerkProvider", $cca6e67d3988e44a$var$multipleClerkProvidersError);
$cca6e67d3988e44a$var$ClerkProvider.displayName = "ClerkProvider";
// src/index.ts
$cca6e67d3988e44a$var$setErrorThrowerOptions({
    packageName: "@clerk/clerk-react"
});
(0, $jCQ57.setClerkJsLoadingErrorPackageName)("@clerk/clerk-react");

});
parcelRegister("jCQ57", function(module, exports) {
"use strict";
var $e499f7412cb7aa3f$var$__defProp = Object.defineProperty;
var $e499f7412cb7aa3f$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $e499f7412cb7aa3f$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $e499f7412cb7aa3f$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $e499f7412cb7aa3f$var$__export = (target, all)=>{
    for(var name in all)$e499f7412cb7aa3f$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $e499f7412cb7aa3f$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $e499f7412cb7aa3f$var$__getOwnPropNames(from))if (!$e499f7412cb7aa3f$var$__hasOwnProp.call(to, key) && key !== except) $e499f7412cb7aa3f$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $e499f7412cb7aa3f$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $e499f7412cb7aa3f$var$__toCommonJS = (mod)=>$e499f7412cb7aa3f$var$__copyProps($e499f7412cb7aa3f$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
// src/loadClerkJsScript.ts
var $e499f7412cb7aa3f$var$loadClerkJsScript_exports = {};
$e499f7412cb7aa3f$var$__export($e499f7412cb7aa3f$var$loadClerkJsScript_exports, {
    buildClerkJsScriptAttributes: ()=>$e499f7412cb7aa3f$var$buildClerkJsScriptAttributes,
    clerkJsScriptUrl: ()=>$e499f7412cb7aa3f$var$clerkJsScriptUrl,
    loadClerkJsScript: ()=>$e499f7412cb7aa3f$var$loadClerkJsScript,
    setClerkJsLoadingErrorPackageName: ()=>$e499f7412cb7aa3f$var$setClerkJsLoadingErrorPackageName
});
module.exports = $e499f7412cb7aa3f$var$__toCommonJS($e499f7412cb7aa3f$var$loadClerkJsScript_exports);
// src/error.ts
var $e499f7412cb7aa3f$var$DefaultMessages = Object.freeze({
    InvalidProxyUrlErrorMessage: `The proxyUrl passed to Clerk is invalid. The expected value for proxyUrl is an absolute URL or a relative path with a leading '/'. (key={{url}})`,
    InvalidPublishableKeyErrorMessage: `The publishableKey passed to Clerk is invalid. You can get your Publishable key at https://dashboard.clerk.com/last-active?path=api-keys. (key={{key}})`,
    MissingPublishableKeyErrorMessage: `Missing publishableKey. You can get your key at https://dashboard.clerk.com/last-active?path=api-keys.`,
    MissingSecretKeyErrorMessage: `Missing secretKey. You can get your key at https://dashboard.clerk.com/last-active?path=api-keys.`,
    MissingClerkProvider: `{{source}} can only be used within the <ClerkProvider /> component. Learn more: https://clerk.com/docs/components/clerk-provider`
});
function $e499f7412cb7aa3f$var$buildErrorThrower({ packageName: packageName, customMessages: customMessages }) {
    let pkg = packageName;
    const messages = {
        ...$e499f7412cb7aa3f$var$DefaultMessages,
        ...customMessages
    };
    function buildMessage(rawMessage, replacements) {
        if (!replacements) return `${pkg}: ${rawMessage}`;
        let msg = rawMessage;
        const matches = rawMessage.matchAll(/{{([a-zA-Z0-9-_]+)}}/g);
        for (const match of matches){
            const replacement = (replacements[match[1]] || "").toString();
            msg = msg.replace(`{{${match[1]}}}`, replacement);
        }
        return `${pkg}: ${msg}`;
    }
    return {
        setPackageName ({ packageName: packageName2 }) {
            if (typeof packageName2 === "string") pkg = packageName2;
            return this;
        },
        setMessages ({ customMessages: customMessages2 }) {
            Object.assign(messages, customMessages2 || {});
            return this;
        },
        throwInvalidPublishableKeyError (params) {
            throw new Error(buildMessage(messages.InvalidPublishableKeyErrorMessage, params));
        },
        throwInvalidProxyUrl (params) {
            throw new Error(buildMessage(messages.InvalidProxyUrlErrorMessage, params));
        },
        throwMissingPublishableKeyError () {
            throw new Error(buildMessage(messages.MissingPublishableKeyErrorMessage));
        },
        throwMissingSecretKeyError () {
            throw new Error(buildMessage(messages.MissingSecretKeyErrorMessage));
        },
        throwMissingClerkProviderError (params) {
            throw new Error(buildMessage(messages.MissingClerkProvider, params));
        },
        throw (message) {
            throw new Error(buildMessage(message));
        }
    };
}
// src/constants.ts
var $e499f7412cb7aa3f$var$DEV_OR_STAGING_SUFFIXES = [
    ".lcl.dev",
    ".stg.dev",
    ".lclstage.dev",
    ".stgstage.dev",
    ".dev.lclclerk.com",
    ".stg.lclclerk.com",
    ".accounts.lclclerk.com",
    "accountsstage.dev",
    "accounts.dev"
];
// src/isomorphicAtob.ts
var $e499f7412cb7aa3f$var$isomorphicAtob = (data)=>{
    if (typeof atob !== "undefined" && typeof atob === "function") return atob(data);
    else if (typeof $parcel$global !== "undefined" && $parcel$global.Buffer) return new $parcel$global.Buffer(data, "base64").toString();
    return data;
};
// src/keys.ts
var $e499f7412cb7aa3f$var$PUBLISHABLE_KEY_LIVE_PREFIX = "pk_live_";
var $e499f7412cb7aa3f$var$PUBLISHABLE_KEY_TEST_PREFIX = "pk_test_";
function $e499f7412cb7aa3f$var$parsePublishableKey(key, options = {}) {
    key = key || "";
    if (!key || !$e499f7412cb7aa3f$var$isPublishableKey(key)) {
        if (options.fatal && !key) throw new Error("Publishable key is missing. Ensure that your publishable key is correctly configured. Double-check your environment configuration for your keys, or access them here: https://dashboard.clerk.com/last-active?path=api-keys");
        if (options.fatal && !$e499f7412cb7aa3f$var$isPublishableKey(key)) throw new Error("Publishable key not valid.");
        return null;
    }
    const instanceType = key.startsWith($e499f7412cb7aa3f$var$PUBLISHABLE_KEY_LIVE_PREFIX) ? "production" : "development";
    let frontendApi = $e499f7412cb7aa3f$var$isomorphicAtob(key.split("_")[2]);
    frontendApi = frontendApi.slice(0, -1);
    if (options.proxyUrl) frontendApi = options.proxyUrl;
    else if (instanceType !== "development" && options.domain) frontendApi = `clerk.${options.domain}`;
    return {
        instanceType: instanceType,
        frontendApi: frontendApi
    };
}
function $e499f7412cb7aa3f$var$isPublishableKey(key = "") {
    try {
        const hasValidPrefix = key.startsWith($e499f7412cb7aa3f$var$PUBLISHABLE_KEY_LIVE_PREFIX) || key.startsWith($e499f7412cb7aa3f$var$PUBLISHABLE_KEY_TEST_PREFIX);
        const hasValidFrontendApiPostfix = $e499f7412cb7aa3f$var$isomorphicAtob(key.split("_")[2] || "").endsWith("$");
        return hasValidPrefix && hasValidFrontendApiPostfix;
    } catch  {
        return false;
    }
}
function $e499f7412cb7aa3f$var$createDevOrStagingUrlCache() {
    const devOrStagingUrlCache = /* @__PURE__ */ new Map();
    return {
        isDevOrStagingUrl: (url)=>{
            if (!url) return false;
            const hostname = typeof url === "string" ? url : url.hostname;
            let res = devOrStagingUrlCache.get(hostname);
            if (res === void 0) {
                res = $e499f7412cb7aa3f$var$DEV_OR_STAGING_SUFFIXES.some((s)=>hostname.endsWith(s));
                devOrStagingUrlCache.set(hostname, res);
            }
            return res;
        }
    };
}
// src/utils/runWithExponentialBackOff.ts
var $e499f7412cb7aa3f$var$defaultOptions = {
    firstDelay: 125,
    maxDelay: 0,
    timeMultiple: 2,
    shouldRetry: ()=>true
};
var $e499f7412cb7aa3f$var$sleep = async (ms)=>new Promise((s)=>setTimeout(s, ms));
var $e499f7412cb7aa3f$var$createExponentialDelayAsyncFn = (opts)=>{
    let timesCalled = 0;
    const calculateDelayInMs = ()=>{
        const constant = opts.firstDelay;
        const base = opts.timeMultiple;
        const delay = constant * Math.pow(base, timesCalled);
        return Math.min(opts.maxDelay || delay, delay);
    };
    return async ()=>{
        await $e499f7412cb7aa3f$var$sleep(calculateDelayInMs());
        timesCalled++;
    };
};
var $e499f7412cb7aa3f$var$runWithExponentialBackOff = async (callback, options = {})=>{
    let iterationsCount = 0;
    const { shouldRetry: shouldRetry, firstDelay: firstDelay, maxDelay: maxDelay, timeMultiple: timeMultiple } = {
        ...$e499f7412cb7aa3f$var$defaultOptions,
        ...options
    };
    const delay = $e499f7412cb7aa3f$var$createExponentialDelayAsyncFn({
        firstDelay: firstDelay,
        maxDelay: maxDelay,
        timeMultiple: timeMultiple
    });
    while(true)try {
        return await callback();
    } catch (e) {
        iterationsCount++;
        if (!shouldRetry(e, iterationsCount)) throw e;
        await delay();
    }
};
// src/loadScript.ts
var $e499f7412cb7aa3f$var$NO_DOCUMENT_ERROR = "loadScript cannot be called when document does not exist";
var $e499f7412cb7aa3f$var$NO_SRC_ERROR = "loadScript cannot be called without a src";
async function $e499f7412cb7aa3f$var$loadScript(src = "", opts) {
    const { async: async, defer: defer, beforeLoad: beforeLoad, crossOrigin: crossOrigin, nonce: nonce } = opts || {};
    const load = ()=>{
        return new Promise((resolve, reject)=>{
            if (!src) reject(new Error($e499f7412cb7aa3f$var$NO_SRC_ERROR));
            if (!document || !document.body) reject($e499f7412cb7aa3f$var$NO_DOCUMENT_ERROR);
            const script = document.createElement("script");
            if (crossOrigin) script.setAttribute("crossorigin", crossOrigin);
            script.async = async || false;
            script.defer = defer || false;
            script.addEventListener("load", ()=>{
                script.remove();
                resolve(script);
            });
            script.addEventListener("error", ()=>{
                script.remove();
                reject();
            });
            script.src = src;
            script.nonce = nonce;
            beforeLoad?.(script);
            document.body.appendChild(script);
        });
    };
    return $e499f7412cb7aa3f$var$runWithExponentialBackOff(load, {
        shouldRetry: (_, iterations)=>iterations < 5
    });
}
// src/proxy.ts
function $e499f7412cb7aa3f$var$isValidProxyUrl(key) {
    if (!key) return true;
    return $e499f7412cb7aa3f$var$isHttpOrHttps(key) || $e499f7412cb7aa3f$var$isProxyUrlRelative(key);
}
function $e499f7412cb7aa3f$var$isHttpOrHttps(key) {
    return /^http(s)?:\/\//.test(key || "");
}
function $e499f7412cb7aa3f$var$isProxyUrlRelative(key) {
    return key.startsWith("/");
}
function $e499f7412cb7aa3f$var$proxyUrlToAbsoluteURL(url) {
    if (!url) return "";
    return $e499f7412cb7aa3f$var$isProxyUrlRelative(url) ? new URL(url, window.location.origin).toString() : url;
}
// src/url.ts
function $e499f7412cb7aa3f$var$addClerkPrefix(str) {
    if (!str) return "";
    let regex;
    if (str.match(/^(clerk\.)+\w*$/)) regex = /(clerk\.)*(?=clerk\.)/;
    else if (str.match(/\.clerk.accounts/)) return str;
    else regex = /^(clerk\.)*/gi;
    const stripped = str.replace(regex, "");
    return `clerk.${stripped}`;
}
// src/versionSelector.ts
var $e499f7412cb7aa3f$var$versionSelector = (clerkJSVersion, packageVersion = "5.53.0")=>{
    if (clerkJSVersion) return clerkJSVersion;
    const prereleaseTag = $e499f7412cb7aa3f$var$getPrereleaseTag(packageVersion);
    if (prereleaseTag) {
        if (prereleaseTag === "snapshot") return "5.53.0";
        return prereleaseTag;
    }
    return $e499f7412cb7aa3f$var$getMajorVersion(packageVersion);
};
var $e499f7412cb7aa3f$var$getPrereleaseTag = (packageVersion)=>packageVersion.trim().replace(/^v/, "").match(/-(.+?)(\.|$)/)?.[1];
var $e499f7412cb7aa3f$var$getMajorVersion = (packageVersion)=>packageVersion.trim().replace(/^v/, "").split(".")[0];
// src/loadClerkJsScript.ts
var $e499f7412cb7aa3f$var$FAILED_TO_LOAD_ERROR = "Clerk: Failed to load Clerk";
var { isDevOrStagingUrl: $e499f7412cb7aa3f$var$isDevOrStagingUrl } = $e499f7412cb7aa3f$var$createDevOrStagingUrlCache();
var $e499f7412cb7aa3f$var$errorThrower = $e499f7412cb7aa3f$var$buildErrorThrower({
    packageName: "@clerk/shared"
});
function $e499f7412cb7aa3f$var$setClerkJsLoadingErrorPackageName(packageName) {
    $e499f7412cb7aa3f$var$errorThrower.setPackageName({
        packageName: packageName
    });
}
var $e499f7412cb7aa3f$var$loadClerkJsScript = async (opts)=>{
    const existingScript = document.querySelector("script[data-clerk-js-script]");
    if (existingScript) return new Promise((resolve, reject)=>{
        existingScript.addEventListener("load", ()=>{
            resolve(existingScript);
        });
        existingScript.addEventListener("error", ()=>{
            reject($e499f7412cb7aa3f$var$FAILED_TO_LOAD_ERROR);
        });
    });
    if (!opts?.publishableKey) {
        $e499f7412cb7aa3f$var$errorThrower.throwMissingPublishableKeyError();
        return;
    }
    return $e499f7412cb7aa3f$var$loadScript($e499f7412cb7aa3f$var$clerkJsScriptUrl(opts), {
        async: true,
        crossOrigin: "anonymous",
        nonce: opts.nonce,
        beforeLoad: $e499f7412cb7aa3f$var$applyClerkJsScriptAttributes(opts)
    }).catch(()=>{
        throw new Error($e499f7412cb7aa3f$var$FAILED_TO_LOAD_ERROR);
    });
};
var $e499f7412cb7aa3f$var$clerkJsScriptUrl = (opts)=>{
    const { clerkJSUrl: clerkJSUrl, clerkJSVariant: clerkJSVariant, clerkJSVersion: clerkJSVersion, proxyUrl: proxyUrl, domain: domain, publishableKey: publishableKey } = opts;
    if (clerkJSUrl) return clerkJSUrl;
    let scriptHost = "";
    if (!!proxyUrl && $e499f7412cb7aa3f$var$isValidProxyUrl(proxyUrl)) scriptHost = $e499f7412cb7aa3f$var$proxyUrlToAbsoluteURL(proxyUrl).replace(/http(s)?:\/\//, "");
    else if (domain && !$e499f7412cb7aa3f$var$isDevOrStagingUrl($e499f7412cb7aa3f$var$parsePublishableKey(publishableKey)?.frontendApi || "")) scriptHost = $e499f7412cb7aa3f$var$addClerkPrefix(domain);
    else scriptHost = $e499f7412cb7aa3f$var$parsePublishableKey(publishableKey)?.frontendApi || "";
    const variant = clerkJSVariant ? `${clerkJSVariant.replace(/\.+$/, "")}.` : "";
    const version = $e499f7412cb7aa3f$var$versionSelector(clerkJSVersion);
    return `https://${scriptHost}/npm/@clerk/clerk-js@${version}/dist/clerk.${variant}browser.js`;
};
var $e499f7412cb7aa3f$var$buildClerkJsScriptAttributes = (options)=>{
    const obj = {};
    if (options.publishableKey) obj["data-clerk-publishable-key"] = options.publishableKey;
    if (options.proxyUrl) obj["data-clerk-proxy-url"] = options.proxyUrl;
    if (options.domain) obj["data-clerk-domain"] = options.domain;
    if (options.nonce) obj.nonce = options.nonce;
    return obj;
};
var $e499f7412cb7aa3f$var$applyClerkJsScriptAttributes = (options)=>(script)=>{
        const attributes = $e499f7412cb7aa3f$var$buildClerkJsScriptAttributes(options);
        for(const attribute in attributes)script.setAttribute(attribute, attributes[attribute]);
    };

});

parcelRegister("aVZ0k", function(module, exports) {
"use strict";
var $7f5e8c7145d8fd5c$var$__defProp = Object.defineProperty;
var $7f5e8c7145d8fd5c$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $7f5e8c7145d8fd5c$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $7f5e8c7145d8fd5c$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $7f5e8c7145d8fd5c$var$__export = (target, all)=>{
    for(var name in all)$7f5e8c7145d8fd5c$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $7f5e8c7145d8fd5c$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $7f5e8c7145d8fd5c$var$__getOwnPropNames(from))if (!$7f5e8c7145d8fd5c$var$__hasOwnProp.call(to, key) && key !== except) $7f5e8c7145d8fd5c$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $7f5e8c7145d8fd5c$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $7f5e8c7145d8fd5c$var$__toCommonJS = (mod)=>$7f5e8c7145d8fd5c$var$__copyProps($7f5e8c7145d8fd5c$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
// src/error.ts
var $7f5e8c7145d8fd5c$var$error_exports = {};
$7f5e8c7145d8fd5c$var$__export($7f5e8c7145d8fd5c$var$error_exports, {
    ClerkAPIResponseError: ()=>$7f5e8c7145d8fd5c$var$ClerkAPIResponseError,
    ClerkRuntimeError: ()=>$7f5e8c7145d8fd5c$var$ClerkRuntimeError,
    ClerkWebAuthnError: ()=>$7f5e8c7145d8fd5c$var$ClerkWebAuthnError,
    EmailLinkError: ()=>$7f5e8c7145d8fd5c$var$EmailLinkError,
    EmailLinkErrorCode: ()=>$7f5e8c7145d8fd5c$var$EmailLinkErrorCode,
    EmailLinkErrorCodeStatus: ()=>$7f5e8c7145d8fd5c$var$EmailLinkErrorCodeStatus,
    buildErrorThrower: ()=>$7f5e8c7145d8fd5c$var$buildErrorThrower,
    errorToJSON: ()=>$7f5e8c7145d8fd5c$var$errorToJSON,
    is4xxError: ()=>$7f5e8c7145d8fd5c$var$is4xxError,
    isCaptchaError: ()=>$7f5e8c7145d8fd5c$var$isCaptchaError,
    isClerkAPIResponseError: ()=>$7f5e8c7145d8fd5c$var$isClerkAPIResponseError,
    isClerkRuntimeError: ()=>$7f5e8c7145d8fd5c$var$isClerkRuntimeError,
    isEmailLinkError: ()=>$7f5e8c7145d8fd5c$var$isEmailLinkError,
    isKnownError: ()=>$7f5e8c7145d8fd5c$var$isKnownError,
    isMetamaskError: ()=>$7f5e8c7145d8fd5c$var$isMetamaskError,
    isNetworkError: ()=>$7f5e8c7145d8fd5c$var$isNetworkError,
    isPasswordPwnedError: ()=>$7f5e8c7145d8fd5c$var$isPasswordPwnedError,
    isUnauthorizedError: ()=>$7f5e8c7145d8fd5c$var$isUnauthorizedError,
    isUserLockedError: ()=>$7f5e8c7145d8fd5c$var$isUserLockedError,
    parseError: ()=>$7f5e8c7145d8fd5c$var$parseError,
    parseErrors: ()=>$7f5e8c7145d8fd5c$var$parseErrors
});
module.exports = $7f5e8c7145d8fd5c$var$__toCommonJS($7f5e8c7145d8fd5c$var$error_exports);
function $7f5e8c7145d8fd5c$var$isUnauthorizedError(e) {
    const status = e?.status;
    const code = e?.errors?.[0]?.code;
    return code === "authentication_invalid" && status === 401;
}
function $7f5e8c7145d8fd5c$var$isCaptchaError(e) {
    return [
        "captcha_invalid",
        "captcha_not_enabled",
        "captcha_missing_token"
    ].includes(e.errors[0].code);
}
function $7f5e8c7145d8fd5c$var$is4xxError(e) {
    const status = e?.status;
    return !!status && status >= 400 && status < 500;
}
function $7f5e8c7145d8fd5c$var$isNetworkError(e) {
    const message = (`${e.message}${e.name}` || "").toLowerCase().replace(/\s+/g, "");
    return message.includes("networkerror");
}
function $7f5e8c7145d8fd5c$var$isKnownError(error) {
    return $7f5e8c7145d8fd5c$var$isClerkAPIResponseError(error) || $7f5e8c7145d8fd5c$var$isMetamaskError(error) || $7f5e8c7145d8fd5c$var$isClerkRuntimeError(error);
}
function $7f5e8c7145d8fd5c$var$isClerkAPIResponseError(err) {
    return "clerkError" in err;
}
function $7f5e8c7145d8fd5c$var$isClerkRuntimeError(err) {
    return "clerkRuntimeError" in err;
}
function $7f5e8c7145d8fd5c$var$isMetamaskError(err) {
    return "code" in err && [
        4001,
        32602,
        32603
    ].includes(err.code) && "message" in err;
}
function $7f5e8c7145d8fd5c$var$isUserLockedError(err) {
    return $7f5e8c7145d8fd5c$var$isClerkAPIResponseError(err) && err.errors?.[0]?.code === "user_locked";
}
function $7f5e8c7145d8fd5c$var$isPasswordPwnedError(err) {
    return $7f5e8c7145d8fd5c$var$isClerkAPIResponseError(err) && err.errors?.[0]?.code === "form_password_pwned";
}
function $7f5e8c7145d8fd5c$var$parseErrors(data = []) {
    return data.length > 0 ? data.map($7f5e8c7145d8fd5c$var$parseError) : [];
}
function $7f5e8c7145d8fd5c$var$parseError(error) {
    return {
        code: error.code,
        message: error.message,
        longMessage: error.long_message,
        meta: {
            paramName: error?.meta?.param_name,
            sessionId: error?.meta?.session_id,
            emailAddresses: error?.meta?.email_addresses,
            identifiers: error?.meta?.identifiers,
            zxcvbn: error?.meta?.zxcvbn
        }
    };
}
function $7f5e8c7145d8fd5c$var$errorToJSON(error) {
    return {
        code: error?.code || "",
        message: error?.message || "",
        long_message: error?.longMessage,
        meta: {
            param_name: error?.meta?.paramName,
            session_id: error?.meta?.sessionId,
            email_addresses: error?.meta?.emailAddresses,
            identifiers: error?.meta?.identifiers,
            zxcvbn: error?.meta?.zxcvbn
        }
    };
}
var $7f5e8c7145d8fd5c$var$ClerkAPIResponseError = class _ClerkAPIResponseError extends Error {
    constructor(message, { data: data, status: status, clerkTraceId: clerkTraceId }){
        super(message);
        this.toString = ()=>{
            let message = `[${this.name}]
Message:${this.message}
Status:${this.status}
Serialized errors: ${this.errors.map((e)=>JSON.stringify(e))}`;
            if (this.clerkTraceId) message += `
Clerk Trace ID: ${this.clerkTraceId}`;
            return message;
        };
        Object.setPrototypeOf(this, _ClerkAPIResponseError.prototype);
        this.status = status;
        this.message = message;
        this.clerkTraceId = clerkTraceId;
        this.clerkError = true;
        this.errors = $7f5e8c7145d8fd5c$var$parseErrors(data);
    }
};
var $7f5e8c7145d8fd5c$var$ClerkRuntimeError = class _ClerkRuntimeError extends Error {
    constructor(message, { code: code }){
        const prefix = "\uD83D\uDD12 Clerk:";
        const regex = new RegExp(prefix.replace(" ", "\\s*"), "i");
        const sanitized = message.replace(regex, "");
        const _message = `${prefix} ${sanitized.trim()}

(code="${code}")
`;
        super(_message);
        /**
     * Returns a string representation of the error.
     *
     * @returns {string} A formatted string with the error name and message.
     * @memberof ClerkRuntimeError
     */ this.toString = ()=>{
            return `[${this.name}]
Message:${this.message}`;
        };
        Object.setPrototypeOf(this, _ClerkRuntimeError.prototype);
        this.code = code;
        this.message = _message;
        this.clerkRuntimeError = true;
        this.name = "ClerkRuntimeError";
    }
};
var $7f5e8c7145d8fd5c$var$EmailLinkError = class _EmailLinkError extends Error {
    constructor(code){
        super(code);
        this.code = code;
        this.name = "EmailLinkError";
        Object.setPrototypeOf(this, _EmailLinkError.prototype);
    }
};
function $7f5e8c7145d8fd5c$var$isEmailLinkError(err) {
    return err.name === "EmailLinkError";
}
var $7f5e8c7145d8fd5c$var$EmailLinkErrorCode = {
    Expired: "expired",
    Failed: "failed",
    ClientMismatch: "client_mismatch"
};
var $7f5e8c7145d8fd5c$var$EmailLinkErrorCodeStatus = {
    Expired: "expired",
    Failed: "failed",
    ClientMismatch: "client_mismatch"
};
var $7f5e8c7145d8fd5c$var$DefaultMessages = Object.freeze({
    InvalidProxyUrlErrorMessage: `The proxyUrl passed to Clerk is invalid. The expected value for proxyUrl is an absolute URL or a relative path with a leading '/'. (key={{url}})`,
    InvalidPublishableKeyErrorMessage: `The publishableKey passed to Clerk is invalid. You can get your Publishable key at https://dashboard.clerk.com/last-active?path=api-keys. (key={{key}})`,
    MissingPublishableKeyErrorMessage: `Missing publishableKey. You can get your key at https://dashboard.clerk.com/last-active?path=api-keys.`,
    MissingSecretKeyErrorMessage: `Missing secretKey. You can get your key at https://dashboard.clerk.com/last-active?path=api-keys.`,
    MissingClerkProvider: `{{source}} can only be used within the <ClerkProvider /> component. Learn more: https://clerk.com/docs/components/clerk-provider`
});
function $7f5e8c7145d8fd5c$var$buildErrorThrower({ packageName: packageName, customMessages: customMessages }) {
    let pkg = packageName;
    const messages = {
        ...$7f5e8c7145d8fd5c$var$DefaultMessages,
        ...customMessages
    };
    function buildMessage(rawMessage, replacements) {
        if (!replacements) return `${pkg}: ${rawMessage}`;
        let msg = rawMessage;
        const matches = rawMessage.matchAll(/{{([a-zA-Z0-9-_]+)}}/g);
        for (const match of matches){
            const replacement = (replacements[match[1]] || "").toString();
            msg = msg.replace(`{{${match[1]}}}`, replacement);
        }
        return `${pkg}: ${msg}`;
    }
    return {
        setPackageName ({ packageName: packageName2 }) {
            if (typeof packageName2 === "string") pkg = packageName2;
            return this;
        },
        setMessages ({ customMessages: customMessages2 }) {
            Object.assign(messages, customMessages2 || {});
            return this;
        },
        throwInvalidPublishableKeyError (params) {
            throw new Error(buildMessage(messages.InvalidPublishableKeyErrorMessage, params));
        },
        throwInvalidProxyUrl (params) {
            throw new Error(buildMessage(messages.InvalidProxyUrlErrorMessage, params));
        },
        throwMissingPublishableKeyError () {
            throw new Error(buildMessage(messages.MissingPublishableKeyErrorMessage));
        },
        throwMissingSecretKeyError () {
            throw new Error(buildMessage(messages.MissingSecretKeyErrorMessage));
        },
        throwMissingClerkProviderError (params) {
            throw new Error(buildMessage(messages.MissingClerkProvider, params));
        },
        throw (message) {
            throw new Error(buildMessage(message));
        }
    };
}
var $7f5e8c7145d8fd5c$var$ClerkWebAuthnError = class extends $7f5e8c7145d8fd5c$var$ClerkRuntimeError {
    constructor(message, { code: code }){
        super(message, {
            code: code
        });
        this.code = code;
    }
};

});

parcelRegister("7zhRN", function(module, exports) {
"use strict";
var $5829a93d27be3971$var$__defProp = Object.defineProperty;
var $5829a93d27be3971$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $5829a93d27be3971$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $5829a93d27be3971$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $5829a93d27be3971$var$__export = (target, all)=>{
    for(var name in all)$5829a93d27be3971$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $5829a93d27be3971$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $5829a93d27be3971$var$__getOwnPropNames(from))if (!$5829a93d27be3971$var$__hasOwnProp.call(to, key) && key !== except) $5829a93d27be3971$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $5829a93d27be3971$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $5829a93d27be3971$var$__toCommonJS = (mod)=>$5829a93d27be3971$var$__copyProps($5829a93d27be3971$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
// src/utils/index.ts
var $5829a93d27be3971$var$utils_exports = {};
$5829a93d27be3971$var$__export($5829a93d27be3971$var$utils_exports, {
    createDeferredPromise: ()=>$5829a93d27be3971$var$createDeferredPromise,
    fastDeepMergeAndKeep: ()=>$5829a93d27be3971$var$fastDeepMergeAndKeep,
    fastDeepMergeAndReplace: ()=>$5829a93d27be3971$var$fastDeepMergeAndReplace,
    handleValueOrFn: ()=>$5829a93d27be3971$var$handleValueOrFn,
    isDevelopmentEnvironment: ()=>$5829a93d27be3971$var$isDevelopmentEnvironment,
    isProductionEnvironment: ()=>$5829a93d27be3971$var$isProductionEnvironment,
    isStaging: ()=>$5829a93d27be3971$var$isStaging,
    isTestEnvironment: ()=>$5829a93d27be3971$var$isTestEnvironment,
    logErrorInDevMode: ()=>$5829a93d27be3971$var$logErrorInDevMode,
    noop: ()=>$5829a93d27be3971$var$noop,
    runWithExponentialBackOff: ()=>$5829a93d27be3971$var$runWithExponentialBackOff
});
module.exports = $5829a93d27be3971$var$__toCommonJS($5829a93d27be3971$var$utils_exports);
// src/utils/noop.ts
var $5829a93d27be3971$var$noop = (..._args)=>{};
// src/utils/createDeferredPromise.ts
var $5829a93d27be3971$var$createDeferredPromise = ()=>{
    let resolve = $5829a93d27be3971$var$noop;
    let reject = $5829a93d27be3971$var$noop;
    const promise = new Promise((res, rej)=>{
        resolve = res;
        reject = rej;
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
};
// src/utils/instance.ts
function $5829a93d27be3971$var$isStaging(frontendApi) {
    return frontendApi.endsWith(".lclstage.dev") || frontendApi.endsWith(".stgstage.dev") || frontendApi.endsWith(".clerkstage.dev") || frontendApi.endsWith(".accountsstage.dev");
}
// src/utils/runtimeEnvironment.ts
var $5829a93d27be3971$var$isDevelopmentEnvironment = ()=>{
    try {
        return false;
    } catch  {}
    return false;
};
var $5829a93d27be3971$var$isTestEnvironment = ()=>{
    try {
        return false;
    } catch  {}
    return false;
};
var $5829a93d27be3971$var$isProductionEnvironment = ()=>{
    try {
        return true;
    } catch  {}
    return false;
};
// src/utils/logErrorInDevMode.ts
var $5829a93d27be3971$var$logErrorInDevMode = (message)=>{
    if ($5829a93d27be3971$var$isDevelopmentEnvironment()) console.error(`Clerk: ${message}`);
};
// src/utils/runWithExponentialBackOff.ts
var $5829a93d27be3971$var$defaultOptions = {
    firstDelay: 125,
    maxDelay: 0,
    timeMultiple: 2,
    shouldRetry: ()=>true
};
var $5829a93d27be3971$var$sleep = async (ms)=>new Promise((s)=>setTimeout(s, ms));
var $5829a93d27be3971$var$createExponentialDelayAsyncFn = (opts)=>{
    let timesCalled = 0;
    const calculateDelayInMs = ()=>{
        const constant = opts.firstDelay;
        const base = opts.timeMultiple;
        const delay = constant * Math.pow(base, timesCalled);
        return Math.min(opts.maxDelay || delay, delay);
    };
    return async ()=>{
        await $5829a93d27be3971$var$sleep(calculateDelayInMs());
        timesCalled++;
    };
};
var $5829a93d27be3971$var$runWithExponentialBackOff = async (callback, options = {})=>{
    let iterationsCount = 0;
    const { shouldRetry: shouldRetry, firstDelay: firstDelay, maxDelay: maxDelay, timeMultiple: timeMultiple } = {
        ...$5829a93d27be3971$var$defaultOptions,
        ...options
    };
    const delay = $5829a93d27be3971$var$createExponentialDelayAsyncFn({
        firstDelay: firstDelay,
        maxDelay: maxDelay,
        timeMultiple: timeMultiple
    });
    while(true)try {
        return await callback();
    } catch (e) {
        iterationsCount++;
        if (!shouldRetry(e, iterationsCount)) throw e;
        await delay();
    }
};
// src/utils/handleValueOrFn.ts
function $5829a93d27be3971$var$handleValueOrFn(value, url, defaultValue) {
    if (typeof value === "function") return value(url);
    if (typeof value !== "undefined") return value;
    if (typeof defaultValue !== "undefined") return defaultValue;
    return void 0;
}
// src/utils/fastDeepMerge.ts
var $5829a93d27be3971$var$fastDeepMergeAndReplace = (source, target)=>{
    if (!source || !target) return;
    for(const key in source){
        if (Object.prototype.hasOwnProperty.call(source, key) && source[key] !== null && typeof source[key] === `object`) {
            if (target[key] === void 0) target[key] = new (Object.getPrototypeOf(source[key])).constructor();
            $5829a93d27be3971$var$fastDeepMergeAndReplace(source[key], target[key]);
        } else if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
};
var $5829a93d27be3971$var$fastDeepMergeAndKeep = (source, target)=>{
    if (!source || !target) return;
    for(const key in source){
        if (Object.prototype.hasOwnProperty.call(source, key) && source[key] !== null && typeof source[key] === `object`) {
            if (target[key] === void 0) target[key] = new (Object.getPrototypeOf(source[key])).constructor();
            $5829a93d27be3971$var$fastDeepMergeAndKeep(source[key], target[key]);
        } else if (Object.prototype.hasOwnProperty.call(source, key) && target[key] === void 0) target[key] = source[key];
    }
};

});

parcelRegister("8JOeW", function(module, exports) {
"use strict";
var $65c97f53d1972813$var$__defProp = Object.defineProperty;
var $65c97f53d1972813$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $65c97f53d1972813$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $65c97f53d1972813$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $65c97f53d1972813$var$__export = (target, all)=>{
    for(var name in all)$65c97f53d1972813$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $65c97f53d1972813$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $65c97f53d1972813$var$__getOwnPropNames(from))if (!$65c97f53d1972813$var$__hasOwnProp.call(to, key) && key !== except) $65c97f53d1972813$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $65c97f53d1972813$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $65c97f53d1972813$var$__toCommonJS = (mod)=>$65c97f53d1972813$var$__copyProps($65c97f53d1972813$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
// src/object.ts
var $65c97f53d1972813$var$object_exports = {};
$65c97f53d1972813$var$__export($65c97f53d1972813$var$object_exports, {
    applyFunctionToObj: ()=>$65c97f53d1972813$var$applyFunctionToObj,
    filterProps: ()=>$65c97f53d1972813$var$filterProps,
    removeUndefined: ()=>$65c97f53d1972813$var$removeUndefined,
    without: ()=>$65c97f53d1972813$var$without
});
module.exports = $65c97f53d1972813$var$__toCommonJS($65c97f53d1972813$var$object_exports);
var $65c97f53d1972813$var$without = (obj, ...props)=>{
    const copy = {
        ...obj
    };
    for (const prop of props)delete copy[prop];
    return copy;
};
var $65c97f53d1972813$var$removeUndefined = (obj)=>{
    return Object.entries(obj).reduce((acc, [key, value])=>{
        if (value !== void 0 && value !== null) acc[key] = value;
        return acc;
    }, {});
};
var $65c97f53d1972813$var$applyFunctionToObj = (obj, fn)=>{
    const result = {};
    for(const key in obj)result[key] = fn(obj[key], key);
    return result;
};
var $65c97f53d1972813$var$filterProps = (obj, filter)=>{
    const result = {};
    for(const key in obj)if (obj[key] && filter(obj[key])) result[key] = obj[key];
    return result;
};

});

parcelRegister("ifeyV", function(module, exports) {
"use strict";
var $d484ec80d972e133$var$__create = Object.create;
var $d484ec80d972e133$var$__defProp = Object.defineProperty;
var $d484ec80d972e133$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $d484ec80d972e133$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $d484ec80d972e133$var$__getProtoOf = Object.getPrototypeOf;
var $d484ec80d972e133$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d484ec80d972e133$var$__export = (target, all)=>{
    for(var name in all)$d484ec80d972e133$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $d484ec80d972e133$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $d484ec80d972e133$var$__getOwnPropNames(from))if (!$d484ec80d972e133$var$__hasOwnProp.call(to, key) && key !== except) $d484ec80d972e133$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $d484ec80d972e133$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $d484ec80d972e133$var$__reExport = (target, mod, secondTarget)=>($d484ec80d972e133$var$__copyProps(target, mod, "default"), secondTarget && $d484ec80d972e133$var$__copyProps(secondTarget, mod, "default"));
var $d484ec80d972e133$var$__toESM = (mod, isNodeMode, target)=>(target = mod != null ? $d484ec80d972e133$var$__create($d484ec80d972e133$var$__getProtoOf(mod)) : {}, $d484ec80d972e133$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $d484ec80d972e133$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
var $d484ec80d972e133$var$__toCommonJS = (mod)=>$d484ec80d972e133$var$__copyProps($d484ec80d972e133$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
// src/react/index.ts
var $d484ec80d972e133$var$react_exports = {};
$d484ec80d972e133$var$__export($d484ec80d972e133$var$react_exports, {
    ClerkInstanceContext: ()=>$d484ec80d972e133$var$ClerkInstanceContext,
    ClientContext: ()=>$d484ec80d972e133$var$ClientContext,
    OptionsContext: ()=>$d484ec80d972e133$var$OptionsContext,
    OrganizationProvider: ()=>$d484ec80d972e133$var$OrganizationProvider,
    SessionContext: ()=>$d484ec80d972e133$var$SessionContext,
    UserContext: ()=>$d484ec80d972e133$var$UserContext,
    assertContextExists: ()=>$d484ec80d972e133$var$assertContextExists,
    createContextAndHook: ()=>$d484ec80d972e133$var$createContextAndHook,
    isDeeplyEqual: ()=>$d484ec80d972e133$var$isDeeplyEqual,
    useAssertWrappedByClerkProvider: ()=>$d484ec80d972e133$var$useAssertWrappedByClerkProvider,
    useClerk: ()=>$d484ec80d972e133$var$useClerk,
    useClerkInstanceContext: ()=>$d484ec80d972e133$var$useClerkInstanceContext,
    useClientContext: ()=>$d484ec80d972e133$var$useClientContext,
    useDeepEqualMemo: ()=>$d484ec80d972e133$var$useDeepEqualMemo,
    useOptionsContext: ()=>$d484ec80d972e133$var$useOptionsContext,
    useOrganization: ()=>$d484ec80d972e133$var$useOrganization,
    useOrganizationContext: ()=>$d484ec80d972e133$var$useOrganizationContext,
    useOrganizationList: ()=>$d484ec80d972e133$var$useOrganizationList,
    useReverification: ()=>$d484ec80d972e133$var$useReverification,
    useSafeLayoutEffect: ()=>$d484ec80d972e133$var$useSafeLayoutEffect,
    useSession: ()=>$d484ec80d972e133$var$useSession,
    useSessionContext: ()=>$d484ec80d972e133$var$useSessionContext,
    useSessionList: ()=>$d484ec80d972e133$var$useSessionList,
    useUser: ()=>$d484ec80d972e133$var$useUser,
    useUserContext: ()=>$d484ec80d972e133$var$useUserContext
});
module.exports = $d484ec80d972e133$var$__toCommonJS($d484ec80d972e133$var$react_exports);

// src/react/hooks/createContextAndHook.ts
var $d484ec80d972e133$var$import_react = $d484ec80d972e133$var$__toESM((parcelRequire("jbmdS")));
function $d484ec80d972e133$var$assertContextExists(contextVal, msgOrCtx) {
    if (!contextVal) throw typeof msgOrCtx === "string" ? new Error(msgOrCtx) : new Error(`${msgOrCtx.displayName} not found`);
}
var $d484ec80d972e133$var$createContextAndHook = (displayName, options)=>{
    const { assertCtxFn: assertCtxFn = $d484ec80d972e133$var$assertContextExists } = options || {};
    const Ctx = $d484ec80d972e133$var$import_react.default.createContext(void 0);
    Ctx.displayName = displayName;
    const useCtx = ()=>{
        const ctx = $d484ec80d972e133$var$import_react.default.useContext(Ctx);
        assertCtxFn(ctx, `${displayName} not found`);
        return ctx.value;
    };
    const useCtxWithoutGuarantee = ()=>{
        const ctx = $d484ec80d972e133$var$import_react.default.useContext(Ctx);
        return ctx ? ctx.value : {};
    };
    return [
        Ctx,
        useCtx,
        useCtxWithoutGuarantee
    ];
};
// src/organization.ts
function $d484ec80d972e133$var$getCurrentOrganizationMembership(organizationMemberships, organizationId) {
    return organizationMemberships.find((organizationMembership)=>organizationMembership.organization.id === organizationId);
}
// src/telemetry/events/method-called.ts
var $d484ec80d972e133$var$EVENT_METHOD_CALLED = "METHOD_CALLED";
function $d484ec80d972e133$var$eventMethodCalled(method, payload) {
    return {
        event: $d484ec80d972e133$var$EVENT_METHOD_CALLED,
        payload: {
            method: method,
            ...payload
        }
    };
}

// src/react/contexts.tsx
var $d484ec80d972e133$var$import_react2 = $d484ec80d972e133$var$__toESM((parcelRequire("jbmdS")));
// src/react/clerk-swr.ts
var $d484ec80d972e133$var$clerk_swr_exports = {};
$d484ec80d972e133$var$__export($d484ec80d972e133$var$clerk_swr_exports, {
    useSWR: ()=>$d484ec80d972e133$var$import_swr.default,
    useSWRInfinite: ()=>$d484ec80d972e133$var$import_infinite.default
});

$d484ec80d972e133$var$__reExport($d484ec80d972e133$var$clerk_swr_exports, (parcelRequire("3750E")));

var $d484ec80d972e133$var$import_swr = $d484ec80d972e133$var$__toESM((parcelRequire("3750E")));

var $d484ec80d972e133$var$import_infinite = $d484ec80d972e133$var$__toESM((parcelRequire("fo2TC")));
// src/react/contexts.tsx
var [$d484ec80d972e133$var$ClerkInstanceContext, $d484ec80d972e133$var$useClerkInstanceContext] = $d484ec80d972e133$var$createContextAndHook("ClerkInstanceContext");
var [$d484ec80d972e133$var$UserContext, $d484ec80d972e133$var$useUserContext] = $d484ec80d972e133$var$createContextAndHook("UserContext");
var [$d484ec80d972e133$var$ClientContext, $d484ec80d972e133$var$useClientContext] = $d484ec80d972e133$var$createContextAndHook("ClientContext");
var [$d484ec80d972e133$var$SessionContext, $d484ec80d972e133$var$useSessionContext] = $d484ec80d972e133$var$createContextAndHook("SessionContext");
var $d484ec80d972e133$var$OptionsContext = $d484ec80d972e133$var$import_react2.default.createContext({});
function $d484ec80d972e133$var$useOptionsContext() {
    const context = $d484ec80d972e133$var$import_react2.default.useContext($d484ec80d972e133$var$OptionsContext);
    if (context === void 0) throw new Error("useOptions must be used within an OptionsContext");
    return context;
}
var [$d484ec80d972e133$var$OrganizationContextInternal, $d484ec80d972e133$var$useOrganizationContext] = $d484ec80d972e133$var$createContextAndHook("OrganizationContext");
var $d484ec80d972e133$var$OrganizationProvider = ({ children: children, organization: organization, swrConfig: swrConfig })=>{
    return /* @__PURE__ */ $d484ec80d972e133$var$import_react2.default.createElement($d484ec80d972e133$var$clerk_swr_exports.SWRConfig, {
        value: swrConfig
    }, /* @__PURE__ */ $d484ec80d972e133$var$import_react2.default.createElement($d484ec80d972e133$var$OrganizationContextInternal.Provider, {
        value: {
            value: {
                organization: organization
            }
        }
    }, children));
};
function $d484ec80d972e133$var$useAssertWrappedByClerkProvider(displayNameOrFn) {
    const ctx = $d484ec80d972e133$var$import_react2.default.useContext($d484ec80d972e133$var$ClerkInstanceContext);
    if (!ctx) {
        if (typeof displayNameOrFn === "function") {
            displayNameOrFn();
            return;
        }
        throw new Error(`${displayNameOrFn} can only be used within the <ClerkProvider /> component.

Possible fixes:
1. Ensure that the <ClerkProvider /> is correctly wrapping your application where this component is used.
2. Check for multiple versions of the \`@clerk/shared\` package in your project. Use a tool like \`npm ls @clerk/shared\` to identify multiple versions, and update your dependencies to only rely on one.

Learn more: https://clerk.com/docs/components/clerk-provider`.trim());
    }
}

function $d484ec80d972e133$var$getDifferentKeys(obj1, obj2) {
    const keysSet = new Set(Object.keys(obj2));
    const differentKeysObject = {};
    for (const key1 of Object.keys(obj1))if (!keysSet.has(key1)) differentKeysObject[key1] = obj1[key1];
    return differentKeysObject;
}
var $d484ec80d972e133$var$useWithSafeValues = (params, defaultValues)=>{
    const shouldUseDefaults = typeof params === "boolean" && params;
    const initialPageRef = (0, (parcelRequire("jbmdS")).useRef)(shouldUseDefaults ? defaultValues.initialPage : params?.initialPage ?? defaultValues.initialPage);
    const pageSizeRef = (0, (parcelRequire("jbmdS")).useRef)(shouldUseDefaults ? defaultValues.pageSize : params?.pageSize ?? defaultValues.pageSize);
    const newObj = {};
    for (const key of Object.keys(defaultValues))newObj[key] = shouldUseDefaults ? defaultValues[key] : params?.[key] ?? defaultValues[key];
    return {
        ...newObj,
        initialPage: initialPageRef.current,
        pageSize: pageSizeRef.current
    };
};
var $d484ec80d972e133$var$cachingSWROptions = {
    dedupingInterval: 60000,
    focusThrottleInterval: 120000
};
var $d484ec80d972e133$var$usePagesOrInfinite = (params, fetcher, config, cacheKeys)=>{
    const [paginatedPage, setPaginatedPage] = (0, (parcelRequire("jbmdS")).useState)(params.initialPage ?? 1);
    const initialPageRef = (0, (parcelRequire("jbmdS")).useRef)(params.initialPage ?? 1);
    const pageSizeRef = (0, (parcelRequire("jbmdS")).useRef)(params.pageSize ?? 10);
    const enabled = config.enabled ?? true;
    const triggerInfinite = config.infinite ?? false;
    const keepPreviousData = config.keepPreviousData ?? false;
    const pagesCacheKey = {
        ...cacheKeys,
        ...params,
        initialPage: paginatedPage,
        pageSize: pageSizeRef.current
    };
    const { data: swrData, isValidating: swrIsValidating, isLoading: swrIsLoading, error: swrError, mutate: swrMutate } = (0, $d484ec80d972e133$var$import_swr.default)(!triggerInfinite && !!fetcher && enabled ? pagesCacheKey : null, (cacheKeyParams)=>{
        const requestParams = $d484ec80d972e133$var$getDifferentKeys(cacheKeyParams, cacheKeys);
        return fetcher?.(requestParams);
    }, {
        keepPreviousData: keepPreviousData,
        ...$d484ec80d972e133$var$cachingSWROptions
    });
    const { data: swrInfiniteData, isLoading: swrInfiniteIsLoading, isValidating: swrInfiniteIsValidating, error: swrInfiniteError, size: size, setSize: setSize, mutate: swrInfiniteMutate } = (0, $d484ec80d972e133$var$import_infinite.default)((pageIndex)=>{
        if (!triggerInfinite || !enabled) return null;
        return {
            ...params,
            ...cacheKeys,
            initialPage: initialPageRef.current + pageIndex,
            pageSize: pageSizeRef.current
        };
    }, (cacheKeyParams)=>{
        const requestParams = $d484ec80d972e133$var$getDifferentKeys(cacheKeyParams, cacheKeys);
        return fetcher?.(requestParams);
    }, $d484ec80d972e133$var$cachingSWROptions);
    const page = (0, (parcelRequire("jbmdS")).useMemo)(()=>{
        if (triggerInfinite) return size;
        return paginatedPage;
    }, [
        triggerInfinite,
        size,
        paginatedPage
    ]);
    const fetchPage = (0, (parcelRequire("jbmdS")).useCallback)((numberOrgFn)=>{
        if (triggerInfinite) {
            setSize(numberOrgFn);
            return;
        }
        return setPaginatedPage(numberOrgFn);
    }, [
        setSize
    ]);
    const data = (0, (parcelRequire("jbmdS")).useMemo)(()=>{
        if (triggerInfinite) return swrInfiniteData?.map((a)=>a?.data).flat() ?? [];
        return swrData?.data ?? [];
    }, [
        triggerInfinite,
        swrData,
        swrInfiniteData
    ]);
    const count = (0, (parcelRequire("jbmdS")).useMemo)(()=>{
        if (triggerInfinite) return swrInfiniteData?.[swrInfiniteData?.length - 1]?.total_count || 0;
        return swrData?.total_count ?? 0;
    }, [
        triggerInfinite,
        swrData,
        swrInfiniteData
    ]);
    const isLoading = triggerInfinite ? swrInfiniteIsLoading : swrIsLoading;
    const isFetching = triggerInfinite ? swrInfiniteIsValidating : swrIsValidating;
    const error = (triggerInfinite ? swrInfiniteError : swrError) ?? null;
    const isError = !!error;
    const fetchNext = (0, (parcelRequire("jbmdS")).useCallback)(()=>{
        fetchPage((n)=>Math.max(0, n + 1));
    }, [
        fetchPage
    ]);
    const fetchPrevious = (0, (parcelRequire("jbmdS")).useCallback)(()=>{
        fetchPage((n)=>Math.max(0, n - 1));
    }, [
        fetchPage
    ]);
    const offsetCount = (initialPageRef.current - 1) * pageSizeRef.current;
    const pageCount = Math.ceil((count - offsetCount) / pageSizeRef.current);
    const hasNextPage = count - offsetCount * pageSizeRef.current > page * pageSizeRef.current;
    const hasPreviousPage = (page - 1) * pageSizeRef.current > offsetCount * pageSizeRef.current;
    const setData = triggerInfinite ? (value)=>swrInfiniteMutate(value, {
            revalidate: false
        }) : (value)=>swrMutate(value, {
            revalidate: false
        });
    const revalidate = triggerInfinite ? ()=>swrInfiniteMutate() : ()=>swrMutate();
    return {
        data: data,
        count: count,
        error: error,
        isLoading: isLoading,
        isFetching: isFetching,
        isError: isError,
        page: page,
        pageCount: pageCount,
        fetchPage: fetchPage,
        fetchNext: fetchNext,
        fetchPrevious: fetchPrevious,
        hasNextPage: hasNextPage,
        hasPreviousPage: hasPreviousPage,
        revalidate: // Let the hook return type define this type
        revalidate,
        setData: // Let the hook return type define this type
        setData
    };
};
// src/react/hooks/useOrganization.tsx
var $d484ec80d972e133$var$undefinedPaginatedResource = {
    data: void 0,
    count: void 0,
    error: void 0,
    isLoading: false,
    isFetching: false,
    isError: false,
    page: void 0,
    pageCount: void 0,
    fetchPage: void 0,
    fetchNext: void 0,
    fetchPrevious: void 0,
    hasNextPage: false,
    hasPreviousPage: false,
    revalidate: void 0,
    setData: void 0
};
var $d484ec80d972e133$var$useOrganization = (params)=>{
    const { domains: domainListParams, membershipRequests: membershipRequestsListParams, memberships: membersListParams, invitations: invitationsListParams } = params || {};
    $d484ec80d972e133$var$useAssertWrappedByClerkProvider("useOrganization");
    const { organization: organization } = $d484ec80d972e133$var$useOrganizationContext();
    const session = $d484ec80d972e133$var$useSessionContext();
    const domainSafeValues = $d484ec80d972e133$var$useWithSafeValues(domainListParams, {
        initialPage: 1,
        pageSize: 10,
        keepPreviousData: false,
        infinite: false,
        enrollmentMode: void 0
    });
    const membershipRequestSafeValues = $d484ec80d972e133$var$useWithSafeValues(membershipRequestsListParams, {
        initialPage: 1,
        pageSize: 10,
        status: "pending",
        keepPreviousData: false,
        infinite: false
    });
    const membersSafeValues = $d484ec80d972e133$var$useWithSafeValues(membersListParams, {
        initialPage: 1,
        pageSize: 10,
        role: void 0,
        keepPreviousData: false,
        infinite: false,
        query: void 0
    });
    const invitationsSafeValues = $d484ec80d972e133$var$useWithSafeValues(invitationsListParams, {
        initialPage: 1,
        pageSize: 10,
        status: [
            "pending"
        ],
        keepPreviousData: false,
        infinite: false
    });
    const clerk = $d484ec80d972e133$var$useClerkInstanceContext();
    clerk.telemetry?.record($d484ec80d972e133$var$eventMethodCalled("useOrganization"));
    const domainParams = typeof domainListParams === "undefined" ? void 0 : {
        initialPage: domainSafeValues.initialPage,
        pageSize: domainSafeValues.pageSize,
        enrollmentMode: domainSafeValues.enrollmentMode
    };
    const membershipRequestParams = typeof membershipRequestsListParams === "undefined" ? void 0 : {
        initialPage: membershipRequestSafeValues.initialPage,
        pageSize: membershipRequestSafeValues.pageSize,
        status: membershipRequestSafeValues.status
    };
    const membersParams = typeof membersListParams === "undefined" ? void 0 : {
        initialPage: membersSafeValues.initialPage,
        pageSize: membersSafeValues.pageSize,
        role: membersSafeValues.role,
        query: membersSafeValues.query
    };
    const invitationsParams = typeof invitationsListParams === "undefined" ? void 0 : {
        initialPage: invitationsSafeValues.initialPage,
        pageSize: invitationsSafeValues.pageSize,
        status: invitationsSafeValues.status
    };
    const domains = $d484ec80d972e133$var$usePagesOrInfinite({
        ...domainParams
    }, organization?.getDomains, {
        keepPreviousData: domainSafeValues.keepPreviousData,
        infinite: domainSafeValues.infinite,
        enabled: !!domainParams
    }, {
        type: "domains",
        organizationId: organization?.id
    });
    const membershipRequests = $d484ec80d972e133$var$usePagesOrInfinite({
        ...membershipRequestParams
    }, organization?.getMembershipRequests, {
        keepPreviousData: membershipRequestSafeValues.keepPreviousData,
        infinite: membershipRequestSafeValues.infinite,
        enabled: !!membershipRequestParams
    }, {
        type: "membershipRequests",
        organizationId: organization?.id
    });
    const memberships = $d484ec80d972e133$var$usePagesOrInfinite(membersParams || {}, organization?.getMemberships, {
        keepPreviousData: membersSafeValues.keepPreviousData,
        infinite: membersSafeValues.infinite,
        enabled: !!membersParams
    }, {
        type: "members",
        organizationId: organization?.id
    });
    const invitations = $d484ec80d972e133$var$usePagesOrInfinite({
        ...invitationsParams
    }, organization?.getInvitations, {
        keepPreviousData: invitationsSafeValues.keepPreviousData,
        infinite: invitationsSafeValues.infinite,
        enabled: !!invitationsParams
    }, {
        type: "invitations",
        organizationId: organization?.id
    });
    if (organization === void 0) return {
        isLoaded: false,
        organization: void 0,
        membership: void 0,
        domains: $d484ec80d972e133$var$undefinedPaginatedResource,
        membershipRequests: $d484ec80d972e133$var$undefinedPaginatedResource,
        memberships: $d484ec80d972e133$var$undefinedPaginatedResource,
        invitations: $d484ec80d972e133$var$undefinedPaginatedResource
    };
    if (organization === null) return {
        isLoaded: true,
        organization: null,
        membership: null,
        domains: null,
        membershipRequests: null,
        memberships: null,
        invitations: null
    };
    if (!clerk.loaded && organization) return {
        isLoaded: true,
        organization: organization,
        membership: void 0,
        domains: $d484ec80d972e133$var$undefinedPaginatedResource,
        membershipRequests: $d484ec80d972e133$var$undefinedPaginatedResource,
        memberships: $d484ec80d972e133$var$undefinedPaginatedResource,
        invitations: $d484ec80d972e133$var$undefinedPaginatedResource
    };
    return {
        isLoaded: clerk.loaded,
        organization: organization,
        membership: $d484ec80d972e133$var$getCurrentOrganizationMembership(session.user.organizationMemberships, organization.id),
        domains: // your membership in the current org
        domains,
        membershipRequests: membershipRequests,
        memberships: memberships,
        invitations: invitations
    };
};
// src/react/hooks/useOrganizationList.tsx
var $d484ec80d972e133$var$undefinedPaginatedResource2 = {
    data: void 0,
    count: void 0,
    error: void 0,
    isLoading: false,
    isFetching: false,
    isError: false,
    page: void 0,
    pageCount: void 0,
    fetchPage: void 0,
    fetchNext: void 0,
    fetchPrevious: void 0,
    hasNextPage: false,
    hasPreviousPage: false,
    revalidate: void 0,
    setData: void 0
};
var $d484ec80d972e133$var$useOrganizationList = (params)=>{
    const { userMemberships: userMemberships, userInvitations: userInvitations, userSuggestions: userSuggestions } = params || {};
    $d484ec80d972e133$var$useAssertWrappedByClerkProvider("useOrganizationList");
    const userMembershipsSafeValues = $d484ec80d972e133$var$useWithSafeValues(userMemberships, {
        initialPage: 1,
        pageSize: 10,
        keepPreviousData: false,
        infinite: false
    });
    const userInvitationsSafeValues = $d484ec80d972e133$var$useWithSafeValues(userInvitations, {
        initialPage: 1,
        pageSize: 10,
        status: "pending",
        keepPreviousData: false,
        infinite: false
    });
    const userSuggestionsSafeValues = $d484ec80d972e133$var$useWithSafeValues(userSuggestions, {
        initialPage: 1,
        pageSize: 10,
        status: "pending",
        keepPreviousData: false,
        infinite: false
    });
    const clerk = $d484ec80d972e133$var$useClerkInstanceContext();
    const user = $d484ec80d972e133$var$useUserContext();
    clerk.telemetry?.record($d484ec80d972e133$var$eventMethodCalled("useOrganizationList"));
    const userMembershipsParams = typeof userMemberships === "undefined" ? void 0 : {
        initialPage: userMembershipsSafeValues.initialPage,
        pageSize: userMembershipsSafeValues.pageSize
    };
    const userInvitationsParams = typeof userInvitations === "undefined" ? void 0 : {
        initialPage: userInvitationsSafeValues.initialPage,
        pageSize: userInvitationsSafeValues.pageSize,
        status: userInvitationsSafeValues.status
    };
    const userSuggestionsParams = typeof userSuggestions === "undefined" ? void 0 : {
        initialPage: userSuggestionsSafeValues.initialPage,
        pageSize: userSuggestionsSafeValues.pageSize,
        status: userSuggestionsSafeValues.status
    };
    const isClerkLoaded = !!(clerk.loaded && user);
    const memberships = $d484ec80d972e133$var$usePagesOrInfinite(userMembershipsParams || {}, user?.getOrganizationMemberships, {
        keepPreviousData: userMembershipsSafeValues.keepPreviousData,
        infinite: userMembershipsSafeValues.infinite,
        enabled: !!userMembershipsParams
    }, {
        type: "userMemberships",
        userId: user?.id
    });
    const invitations = $d484ec80d972e133$var$usePagesOrInfinite({
        ...userInvitationsParams
    }, user?.getOrganizationInvitations, {
        keepPreviousData: userInvitationsSafeValues.keepPreviousData,
        infinite: userInvitationsSafeValues.infinite,
        enabled: !!userInvitationsParams
    }, {
        type: "userInvitations",
        userId: user?.id
    });
    const suggestions = $d484ec80d972e133$var$usePagesOrInfinite({
        ...userSuggestionsParams
    }, user?.getOrganizationSuggestions, {
        keepPreviousData: userSuggestionsSafeValues.keepPreviousData,
        infinite: userSuggestionsSafeValues.infinite,
        enabled: !!userSuggestionsParams
    }, {
        type: "userSuggestions",
        userId: user?.id
    });
    if (!isClerkLoaded) return {
        isLoaded: false,
        createOrganization: void 0,
        setActive: void 0,
        userMemberships: $d484ec80d972e133$var$undefinedPaginatedResource2,
        userInvitations: $d484ec80d972e133$var$undefinedPaginatedResource2,
        userSuggestions: $d484ec80d972e133$var$undefinedPaginatedResource2
    };
    return {
        isLoaded: isClerkLoaded,
        setActive: clerk.setActive,
        createOrganization: clerk.createOrganization,
        userMemberships: memberships,
        userInvitations: invitations,
        userSuggestions: suggestions
    };
};

// src/react/hooks/useSafeLayoutEffect.tsx
var $d484ec80d972e133$var$import_react4 = $d484ec80d972e133$var$__toESM((parcelRequire("jbmdS")));
var $d484ec80d972e133$var$useSafeLayoutEffect = typeof window !== "undefined" ? $d484ec80d972e133$var$import_react4.default.useLayoutEffect : $d484ec80d972e133$var$import_react4.default.useEffect;
// src/react/hooks/useSession.ts
var $d484ec80d972e133$var$useSession = ()=>{
    $d484ec80d972e133$var$useAssertWrappedByClerkProvider("useSession");
    const session = $d484ec80d972e133$var$useSessionContext();
    if (session === void 0) return {
        isLoaded: false,
        isSignedIn: void 0,
        session: void 0
    };
    if (session === null) return {
        isLoaded: true,
        isSignedIn: false,
        session: null
    };
    return {
        isLoaded: true,
        isSignedIn: true,
        session: session
    };
};
// src/react/hooks/useSessionList.ts
var $d484ec80d972e133$var$useSessionList = ()=>{
    $d484ec80d972e133$var$useAssertWrappedByClerkProvider("useSessionList");
    const isomorphicClerk = $d484ec80d972e133$var$useClerkInstanceContext();
    const client = $d484ec80d972e133$var$useClientContext();
    if (!client) return {
        isLoaded: false,
        sessions: void 0,
        setActive: void 0
    };
    return {
        isLoaded: true,
        sessions: client.sessions,
        setActive: isomorphicClerk.setActive
    };
};
// src/react/hooks/useUser.ts
function $d484ec80d972e133$var$useUser() {
    $d484ec80d972e133$var$useAssertWrappedByClerkProvider("useUser");
    const user = $d484ec80d972e133$var$useUserContext();
    if (user === void 0) return {
        isLoaded: false,
        isSignedIn: void 0,
        user: void 0
    };
    if (user === null) return {
        isLoaded: true,
        isSignedIn: false,
        user: null
    };
    return {
        isLoaded: true,
        isSignedIn: true,
        user: user
    };
}
// src/react/hooks/useClerk.ts
var $d484ec80d972e133$var$useClerk = ()=>{
    $d484ec80d972e133$var$useAssertWrappedByClerkProvider("useClerk");
    return $d484ec80d972e133$var$useClerkInstanceContext();
};

var $3DYI4 = parcelRequire("3DYI4");

var $d484ec80d972e133$var$import_react5 = $d484ec80d972e133$var$__toESM((parcelRequire("jbmdS")));
var $d484ec80d972e133$var$useDeepEqualMemoize = (value)=>{
    const ref = $d484ec80d972e133$var$import_react5.default.useRef(value);
    if (!(0, $3DYI4.dequal)(value, ref.current)) ref.current = value;
    return $d484ec80d972e133$var$import_react5.default.useMemo(()=>ref.current, [
        ref.current
    ]);
};
var $d484ec80d972e133$var$useDeepEqualMemo = (factory, dependencyArray)=>{
    return $d484ec80d972e133$var$import_react5.default.useMemo(factory, $d484ec80d972e133$var$useDeepEqualMemoize(dependencyArray));
};
var $d484ec80d972e133$var$isDeeplyEqual = $3DYI4.dequal;

// src/authorization.ts
var $d484ec80d972e133$var$TYPES_TO_OBJECTS = {
    strict_mfa: {
        afterMinutes: 10,
        level: "multi_factor"
    },
    strict: {
        afterMinutes: 10,
        level: "second_factor"
    },
    moderate: {
        afterMinutes: 60,
        level: "second_factor"
    },
    lax: {
        afterMinutes: 1440,
        level: "second_factor"
    }
};
var $d484ec80d972e133$var$ALLOWED_LEVELS = /* @__PURE__ */ new Set([
    "first_factor",
    "second_factor",
    "multi_factor"
]);
var $d484ec80d972e133$var$ALLOWED_TYPES = /* @__PURE__ */ new Set([
    "strict_mfa",
    "strict",
    "moderate",
    "lax"
]);
var $d484ec80d972e133$var$isValidMaxAge = (maxAge)=>typeof maxAge === "number" && maxAge > 0;
var $d484ec80d972e133$var$isValidLevel = (level)=>$d484ec80d972e133$var$ALLOWED_LEVELS.has(level);
var $d484ec80d972e133$var$isValidVerificationType = (type)=>$d484ec80d972e133$var$ALLOWED_TYPES.has(type);
var $d484ec80d972e133$var$validateReverificationConfig = (config)=>{
    if (!config) return false;
    const convertConfigToObject = (config2)=>{
        if (typeof config2 === "string") return $d484ec80d972e133$var$TYPES_TO_OBJECTS[config2];
        return config2;
    };
    const isValidStringValue = typeof config === "string" && $d484ec80d972e133$var$isValidVerificationType(config);
    const isValidObjectValue = typeof config === "object" && $d484ec80d972e133$var$isValidLevel(config.level) && $d484ec80d972e133$var$isValidMaxAge(config.afterMinutes);
    if (isValidStringValue || isValidObjectValue) return convertConfigToObject.bind(null, config);
    return false;
};
// src/authorization-errors.ts
var $d484ec80d972e133$var$REVERIFICATION_REASON = "reverification-error";
var $d484ec80d972e133$var$reverificationError = (missingConfig)=>({
        clerk_error: {
            type: "forbidden",
            reason: $d484ec80d972e133$var$REVERIFICATION_REASON,
            metadata: {
                reverification: missingConfig
            }
        }
    });
var $d484ec80d972e133$var$isReverificationHint = (result)=>{
    return result && typeof result === "object" && "clerk_error" in result && result.clerk_error?.type === "forbidden" && result.clerk_error?.reason === $d484ec80d972e133$var$REVERIFICATION_REASON;
};
// src/error.ts
function $d484ec80d972e133$var$isClerkAPIResponseError(err) {
    return "clerkError" in err;
}
function $d484ec80d972e133$var$isClerkRuntimeError(err) {
    return "clerkRuntimeError" in err;
}
var $d484ec80d972e133$var$ClerkRuntimeError = class _ClerkRuntimeError extends Error {
    constructor(message, { code: code }){
        const prefix = "\uD83D\uDD12 Clerk:";
        const regex = new RegExp(prefix.replace(" ", "\\s*"), "i");
        const sanitized = message.replace(regex, "");
        const _message = `${prefix} ${sanitized.trim()}

(code="${code}")
`;
        super(_message);
        /**
     * Returns a string representation of the error.
     *
     * @returns {string} A formatted string with the error name and message.
     * @memberof ClerkRuntimeError
     */ this.toString = ()=>{
            return `[${this.name}]
Message:${this.message}`;
        };
        Object.setPrototypeOf(this, _ClerkRuntimeError.prototype);
        this.code = code;
        this.message = _message;
        this.clerkRuntimeError = true;
        this.name = "ClerkRuntimeError";
    }
};
var $d484ec80d972e133$var$DefaultMessages = Object.freeze({
    InvalidProxyUrlErrorMessage: `The proxyUrl passed to Clerk is invalid. The expected value for proxyUrl is an absolute URL or a relative path with a leading '/'. (key={{url}})`,
    InvalidPublishableKeyErrorMessage: `The publishableKey passed to Clerk is invalid. You can get your Publishable key at https://dashboard.clerk.com/last-active?path=api-keys. (key={{key}})`,
    MissingPublishableKeyErrorMessage: `Missing publishableKey. You can get your key at https://dashboard.clerk.com/last-active?path=api-keys.`,
    MissingSecretKeyErrorMessage: `Missing secretKey. You can get your key at https://dashboard.clerk.com/last-active?path=api-keys.`,
    MissingClerkProvider: `{{source}} can only be used within the <ClerkProvider /> component. Learn more: https://clerk.com/docs/components/clerk-provider`
});
// src/utils/noop.ts
var $d484ec80d972e133$var$noop = (..._args)=>{};
// src/utils/createDeferredPromise.ts
var $d484ec80d972e133$var$createDeferredPromise = ()=>{
    let resolve = $d484ec80d972e133$var$noop;
    let reject = $d484ec80d972e133$var$noop;
    const promise = new Promise((res, rej)=>{
        resolve = res;
        reject = rej;
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
};
// src/react/hooks/useReverification.ts
var $d484ec80d972e133$var$CLERK_API_REVERIFICATION_ERROR_CODE = "session_reverification_required";
async function $d484ec80d972e133$var$resolveResult(result) {
    try {
        const r = await result;
        if (r instanceof Response) return r.json();
        return r;
    } catch (e) {
        if ($d484ec80d972e133$var$isClerkAPIResponseError(e) && e.errors.find(({ code: code })=>code === $d484ec80d972e133$var$CLERK_API_REVERIFICATION_ERROR_CODE)) return $d484ec80d972e133$var$reverificationError();
        throw e;
    }
}
function $d484ec80d972e133$var$createReverificationHandler(params) {
    function assertReverification(fetcher) {
        return async (...args)=>{
            let result = await $d484ec80d972e133$var$resolveResult(fetcher(...args));
            if ($d484ec80d972e133$var$isReverificationHint(result)) {
                const resolvers = $d484ec80d972e133$var$createDeferredPromise();
                const isValidMetadata = $d484ec80d972e133$var$validateReverificationConfig(result.clerk_error.metadata?.reverification);
                params.openUIComponent?.({
                    level: isValidMetadata ? isValidMetadata().level : void 0,
                    afterVerification () {
                        resolvers.resolve(true);
                    },
                    afterVerificationCancelled () {
                        resolvers.reject(new $d484ec80d972e133$var$ClerkRuntimeError("User cancelled attempted verification", {
                            code: "reverification_cancelled"
                        }));
                    }
                });
                try {
                    await resolvers.promise;
                } catch (e) {
                    if (params.onCancel) params.onCancel();
                    if ($d484ec80d972e133$var$isClerkRuntimeError(e) && e.code === "reverification_cancelled" && params.throwOnCancel) throw e;
                    return null;
                }
                result = await $d484ec80d972e133$var$resolveResult(fetcher(...args));
            }
            return result;
        };
    }
    return assertReverification;
}
function $d484ec80d972e133$var$useReverification(fetcher, options) {
    const { __internal_openReverification: __internal_openReverification } = $d484ec80d972e133$var$useClerk();
    const fetcherRef = (0, (parcelRequire("jbmdS")).useRef)(fetcher);
    const optionsRef = (0, (parcelRequire("jbmdS")).useRef)(options);
    const handleReverification = (0, (parcelRequire("jbmdS")).useMemo)(()=>{
        const handler = $d484ec80d972e133$var$createReverificationHandler({
            openUIComponent: __internal_openReverification,
            ...optionsRef.current
        })(fetcherRef.current);
        return [
            handler
        ];
    }, [
        __internal_openReverification,
        fetcherRef.current,
        optionsRef.current
    ]);
    $d484ec80d972e133$var$useSafeLayoutEffect(()=>{
        fetcherRef.current = fetcher;
        optionsRef.current = options;
    });
    return handleReverification;
}

});
parcelRegister("3750E", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "unstable_serialize", function () { return $2445e9548358d192$export$dbab534a48e651ef; });
$parcel$export(module.exports, "SWRConfig", function () { return $2445e9548358d192$export$4c7bbecdacc3ca2c; });
$parcel$export(module.exports, "default", function () { return $2445e9548358d192$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "mutate", function () { return (parcelRequire("6gsyk")).mutate; });
$parcel$export(module.exports, "preload", function () { return (parcelRequire("6gsyk")).preload; });
$parcel$export(module.exports, "useSWRConfig", function () { return (parcelRequire("6gsyk")).useSWRConfig; });
parcelRequire("arJgR");

var $jbmdS = parcelRequire("jbmdS");

var $bUdUR = parcelRequire("bUdUR");

var $6gsyk = parcelRequire("6gsyk");
const $2445e9548358d192$export$dbab534a48e651ef = (key)=>(0, $6gsyk.serialize)(key)[0];
/// <reference types="react/experimental" />
const $2445e9548358d192$var$use = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).use || ((promise)=>{
    if (promise.status === "pending") throw promise;
    else if (promise.status === "fulfilled") return promise.value;
    else if (promise.status === "rejected") throw promise.reason;
    else {
        promise.status = "pending";
        promise.then((v)=>{
            promise.status = "fulfilled";
            promise.value = v;
        }, (e)=>{
            promise.status = "rejected";
            promise.reason = e;
        });
        throw promise;
    }
});
const $2445e9548358d192$var$WITH_DEDUPE = {
    dedupe: true
};
const $2445e9548358d192$var$useSWRHandler = (_key, fetcher, config)=>{
    const { cache: cache, compare: compare, suspense: suspense, fallbackData: fallbackData, revalidateOnMount: revalidateOnMount, revalidateIfStale: revalidateIfStale, refreshInterval: refreshInterval, refreshWhenHidden: refreshWhenHidden, refreshWhenOffline: refreshWhenOffline, keepPreviousData: keepPreviousData } = config;
    const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = (0, $6gsyk.SWRGlobalState).get(cache);
    // `key` is the identifier of the SWR internal state,
    // `fnArg` is the argument/arguments parsed from the key, which will be passed
    // to the fetcher.
    // All of them are derived from `_key`.
    const [key, fnArg] = (0, $6gsyk.serialize)(_key);
    // If it's the initial render of this hook.
    const initialMountedRef = (0, $jbmdS.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    const unmountedRef = (0, $jbmdS.useRef)(false);
    // Refs to keep the key and config.
    const keyRef = (0, $jbmdS.useRef)(key);
    const fetcherRef = (0, $jbmdS.useRef)(fetcher);
    const configRef = (0, $jbmdS.useRef)(config);
    const getConfig = ()=>configRef.current;
    const isActive = ()=>getConfig().isVisible() && getConfig().isOnline();
    const [getCache, setCache, subscribeCache, getInitialCache] = (0, $6gsyk.createCacheHelper)(cache, key);
    const stateDependencies = (0, $jbmdS.useRef)({}).current;
    const fallback = (0, $6gsyk.isUndefined)(fallbackData) ? config.fallback[key] : fallbackData;
    const isEqual = (prev, current)=>{
        for(const _ in stateDependencies){
            const t = _;
            if (t === "data") {
                if (!compare(prev[t], current[t])) {
                    if (!(0, $6gsyk.isUndefined)(prev[t])) return false;
                    if (!compare(returnedData, current[t])) return false;
                }
            } else {
                if (current[t] !== prev[t]) return false;
            }
        }
        return true;
    };
    const getSnapshot = (0, $jbmdS.useMemo)(()=>{
        const shouldStartRequest = (()=>{
            if (!key) return false;
            if (!fetcher) return false;
            // If `revalidateOnMount` is set, we take the value directly.
            if (!(0, $6gsyk.isUndefined)(revalidateOnMount)) return revalidateOnMount;
            // If it's paused, we skip revalidation.
            if (getConfig().isPaused()) return false;
            if (suspense) return false;
            if (!(0, $6gsyk.isUndefined)(revalidateIfStale)) return revalidateIfStale;
            return true;
        })();
        // Get the cache and merge it with expected states.
        const getSelectedCache = (state)=>{
            // We only select the needed fields from the state.
            const snapshot = (0, $6gsyk.mergeObjects)(state);
            delete snapshot._k;
            if (!shouldStartRequest) return snapshot;
            return {
                isValidating: true,
                isLoading: true,
                ...snapshot
            };
        };
        const cachedData = getCache();
        const initialData = getInitialCache();
        const clientSnapshot = getSelectedCache(cachedData);
        const serverSnapshot = cachedData === initialData ? clientSnapshot : getSelectedCache(initialData);
        // To make sure that we are returning the same object reference to avoid
        // unnecessary re-renders, we keep the previous snapshot and use deep
        // comparison to check if we need to return a new one.
        let memorizedSnapshot = clientSnapshot;
        return [
            ()=>{
                const newSnapshot = getSelectedCache(getCache());
                const compareResult = isEqual(newSnapshot, memorizedSnapshot);
                if (compareResult) {
                    // Mentally, we should always return the `memorizedSnapshot` here
                    // as there's no change between the new and old snapshots.
                    // However, since the `isEqual` function only compares selected fields,
                    // the values of the unselected fields might be changed. That's
                    // simply because we didn't track them.
                    // To support the case in https://github.com/vercel/swr/pull/2576,
                    // we need to update these fields in the `memorizedSnapshot` too
                    // with direct mutations to ensure the snapshot is always up-to-date
                    // even for the unselected fields, but only trigger re-renders when
                    // the selected fields are changed.
                    memorizedSnapshot.data = newSnapshot.data;
                    memorizedSnapshot.isLoading = newSnapshot.isLoading;
                    memorizedSnapshot.isValidating = newSnapshot.isValidating;
                    memorizedSnapshot.error = newSnapshot.error;
                    return memorizedSnapshot;
                } else {
                    memorizedSnapshot = newSnapshot;
                    return newSnapshot;
                }
            },
            ()=>serverSnapshot
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cache,
        key
    ]);
    // Get the current state that SWR should return.
    const cached = (0, $bUdUR.useSyncExternalStore)((0, $jbmdS.useCallback)((callback)=>subscribeCache(key, (current, prev)=>{
            if (!isEqual(prev, current)) callback();
        }), [
        cache,
        key
    ]), getSnapshot[0], getSnapshot[1]);
    const isInitialMount = !initialMountedRef.current;
    const hasRevalidator = EVENT_REVALIDATORS[key] && EVENT_REVALIDATORS[key].length > 0;
    const cachedData = cached.data;
    const data = (0, $6gsyk.isUndefined)(cachedData) ? fallback : cachedData;
    const error = cached.error;
    // Use a ref to store previously returned data. Use the initial data as its initial value.
    const laggyDataRef = (0, $jbmdS.useRef)(data);
    const returnedData = keepPreviousData ? (0, $6gsyk.isUndefined)(cachedData) ? laggyDataRef.current : cachedData : data;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    const shouldDoInitialRevalidation = (()=>{
        // if a key already has revalidators and also has error, we should not trigger revalidation
        if (hasRevalidator && !(0, $6gsyk.isUndefined)(error)) return false;
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !(0, $6gsyk.isUndefined)(revalidateOnMount)) return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused()) return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately mount it again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense) return (0, $6gsyk.isUndefined)(data) ? false : revalidateIfStale;
        // If there is no stale data, we need to revalidate when mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return (0, $6gsyk.isUndefined)(data) || revalidateIfStale;
    })();
    // Resolve the default validating state:
    // If it's able to validate, and it should revalidate when mount, this will be true.
    const defaultValidatingState = !!(key && fetcher && isInitialMount && shouldDoInitialRevalidation);
    const isValidating = (0, $6gsyk.isUndefined)(cached.isValidating) ? defaultValidatingState : cached.isValidating;
    const isLoading = (0, $6gsyk.isUndefined)(cached.isLoading) ? defaultValidatingState : cached.isLoading;
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    const revalidate = (0, $jbmdS.useCallback)(async (revalidateOpts)=>{
        const currentFetcher = fetcherRef.current;
        if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused()) return false;
        let newData;
        let startAt;
        let loading = true;
        const opts = revalidateOpts || {};
        // If there is no ongoing concurrent request, or `dedupe` is not set, a
        // new request should be initiated.
        const shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
        /*
         For React 17
         Do unmount check for calls:
         If key has changed during the revalidation, or the component has been
         unmounted, old dispatch and old event callbacks should not take any
         effect

        For React 18
        only check if key has changed
        https://github.com/reactwg/react-18/discussions/82
      */ const callbackSafeguard = ()=>{
            if (0, $6gsyk.IS_REACT_LEGACY) return !unmountedRef.current && key === keyRef.current && initialMountedRef.current;
            return key === keyRef.current;
        };
        // The final state object when the request finishes.
        const finalState = {
            isValidating: false,
            isLoading: false
        };
        const finishRequestAndUpdateState = ()=>{
            setCache(finalState);
        };
        const cleanupState = ()=>{
            // Check if it's still the same request before deleting it.
            const requestInfo = FETCH[key];
            if (requestInfo && requestInfo[1] === startAt) delete FETCH[key];
        };
        // Start fetching. Change the `isValidating` state, update the cache.
        const initialState = {
            isValidating: true
        };
        // It is in the `isLoading` state, if and only if there is no cached data.
        // This bypasses fallback data and laggy data.
        if ((0, $6gsyk.isUndefined)(getCache().data)) initialState.isLoading = true;
        try {
            if (shouldStartNewRequest) {
                setCache(initialState);
                // If no cache is being rendered currently (it shows a blank page),
                // we trigger the loading slow event.
                if (config.loadingTimeout && (0, $6gsyk.isUndefined)(getCache().data)) setTimeout(()=>{
                    if (loading && callbackSafeguard()) getConfig().onLoadingSlow(key, config);
                }, config.loadingTimeout);
                // Start the request and save the timestamp.
                // Key must be truthy if entering here.
                FETCH[key] = [
                    currentFetcher(fnArg),
                    (0, $6gsyk.getTimestamp)()
                ];
            }
            [newData, startAt] = FETCH[key];
            newData = await newData;
            if (shouldStartNewRequest) // If the request isn't interrupted, clean it up after the
            // deduplication interval.
            setTimeout(cleanupState, config.dedupingInterval);
            // If there're other ongoing request(s), started after the current one,
            // we need to ignore the current one to avoid possible race conditions:
            //   req1------------------>res1        (current one)
            //        req2---------------->res2
            // the request that fired later will always be kept.
            // The timestamp maybe be `undefined` or a number
            if (!FETCH[key] || FETCH[key][1] !== startAt) {
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Clear error.
            finalState.error = (0, $6gsyk.UNDEFINED);
            // If there're other mutations(s), that overlapped with the current revalidation:
            // case 1:
            //   req------------------>res
            //       mutate------>end
            // case 2:
            //         req------------>res
            //   mutate------>end
            // case 3:
            //   req------------------>res
            //       mutate-------...---------->
            // we have to ignore the revalidation result (res) because it's no longer fresh.
            // meanwhile, a new revalidation should be triggered when the mutation ends.
            const mutationInfo = MUTATION[key];
            if (!(0, $6gsyk.isUndefined)(mutationInfo) && // case 1
            (startAt <= mutationInfo[0] || // case 2
            startAt <= mutationInfo[1] || // case 3
            mutationInfo[1] === 0)) {
                finishRequestAndUpdateState();
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Deep compare with the latest state to avoid extra re-renders.
            // For local state, compare and assign.
            const cacheData = getCache().data;
            // Since the compare fn could be custom fn
            // cacheData might be different from newData even when compare fn returns True
            finalState.data = compare(cacheData, newData) ? cacheData : newData;
            // Trigger the successful callback if it's the original request.
            if (shouldStartNewRequest) {
                if (callbackSafeguard()) getConfig().onSuccess(newData, key, config);
            }
        } catch (err) {
            cleanupState();
            const currentConfig = getConfig();
            const { shouldRetryOnError: shouldRetryOnError } = currentConfig;
            // Not paused, we continue handling the error. Otherwise, discard it.
            if (!currentConfig.isPaused()) {
                // Get a new error, don't use deep comparison for errors.
                finalState.error = err;
                // Error event and retry logic. Only for the actual request, not
                // deduped ones.
                if (shouldStartNewRequest && callbackSafeguard()) {
                    currentConfig.onError(err, key, currentConfig);
                    if (shouldRetryOnError === true || (0, $6gsyk.isFunction)(shouldRetryOnError) && shouldRetryOnError(err)) {
                        if (!getConfig().revalidateOnFocus || !getConfig().revalidateOnReconnect || isActive()) // If it's inactive, stop. It will auto-revalidate when
                        // refocusing or reconnecting.
                        // When retrying, deduplication is always enabled.
                        currentConfig.onErrorRetry(err, key, currentConfig, (_opts)=>{
                            const revalidators = EVENT_REVALIDATORS[key];
                            if (revalidators && revalidators[0]) revalidators[0]((0, $6gsyk.revalidateEvents).ERROR_REVALIDATE_EVENT, _opts);
                        }, {
                            retryCount: (opts.retryCount || 0) + 1,
                            dedupe: true
                        });
                    }
                }
            }
        }
        // Mark loading as stopped.
        loading = false;
        // Update the current hook's state.
        finishRequestAndUpdateState();
        return true;
    }, // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key,
        cache
    ]);
    // Similar to the global mutate but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    const boundMutate = (0, $jbmdS.useCallback)((...args)=>{
        return (0, $6gsyk.internalMutate)(cache, keyRef.current, ...args);
    }, []);
    // The logic for updating refs.
    (0, $6gsyk.useIsomorphicLayoutEffect)(()=>{
        fetcherRef.current = fetcher;
        configRef.current = config;
        // Handle laggy data updates. If there's cached data of the current key,
        // it'll be the correct reference.
        if (!(0, $6gsyk.isUndefined)(cachedData)) laggyDataRef.current = cachedData;
    });
    // After mounted or key changed.
    (0, $6gsyk.useIsomorphicLayoutEffect)(()=>{
        if (!key) return;
        const softRevalidate = revalidate.bind((0, $6gsyk.UNDEFINED), $2445e9548358d192$var$WITH_DEDUPE);
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        let nextFocusRevalidatedAt = 0;
        const onRevalidate = (type, opts = {})=>{
            if (type == (0, $6gsyk.revalidateEvents).FOCUS_EVENT) {
                const now = Date.now();
                if (getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            } else if (type == (0, $6gsyk.revalidateEvents).RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) softRevalidate();
            } else if (type == (0, $6gsyk.revalidateEvents).MUTATE_EVENT) return revalidate();
            else if (type == (0, $6gsyk.revalidateEvents).ERROR_REVALIDATE_EVENT) return revalidate(opts);
            return;
        };
        const unsubEvents = (0, $6gsyk.subscribeCallback)(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // Keep the original key in the cache.
        setCache({
            _k: fnArg
        });
        // Trigger a revalidation
        if (shouldDoInitialRevalidation) {
            if ((0, $6gsyk.isUndefined)(data) || (0, $6gsyk.IS_SERVER)) // Revalidate immediately.
            softRevalidate();
            else // Delay the revalidate if we have data to return so we won't block
            // rendering.
            (0, $6gsyk.rAF)(softRevalidate);
        }
        return ()=>{
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubEvents();
        };
    }, [
        key
    ]);
    // Polling
    (0, $6gsyk.useIsomorphicLayoutEffect)(()=>{
        let timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            const interval = (0, $6gsyk.isFunction)(refreshInterval) ? refreshInterval(getCache().data) : refreshInterval;
            // We only start the next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) timer = setTimeout(execute, interval);
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online, and not errored.
            if (!getCache().error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline())) revalidate($2445e9548358d192$var$WITH_DEDUPE).then(next);
            else // Schedule the next interval to check again.
            next();
        }
        next();
        return ()=>{
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [
        refreshInterval,
        refreshWhenHidden,
        refreshWhenOffline,
        key
    ]);
    // Display debug info in React DevTools.
    (0, $jbmdS.useDebugValue)(returnedData);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is an `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense && (0, $6gsyk.isUndefined)(data) && key) {
        // SWR should throw when trying to use Suspense on the server with React 18,
        // without providing any initial data. See:
        // https://github.com/vercel/swr/issues/1832
        if (!(0, $6gsyk.IS_REACT_LEGACY) && (0, $6gsyk.IS_SERVER)) throw new Error("Fallback data is required when using suspense in SSR.");
        // Always update fetcher and config refs even with the Suspense mode.
        fetcherRef.current = fetcher;
        configRef.current = config;
        unmountedRef.current = false;
        const req = PRELOAD[key];
        if (!(0, $6gsyk.isUndefined)(req)) {
            const promise = boundMutate(req);
            $2445e9548358d192$var$use(promise);
        }
        if ((0, $6gsyk.isUndefined)(error)) {
            const promise = revalidate($2445e9548358d192$var$WITH_DEDUPE);
            if (!(0, $6gsyk.isUndefined)(returnedData)) {
                promise.status = "fulfilled";
                promise.value = true;
            }
            $2445e9548358d192$var$use(promise);
        } else throw error;
    }
    return {
        mutate: boundMutate,
        get data () {
            stateDependencies.data = true;
            return returnedData;
        },
        get error () {
            stateDependencies.error = true;
            return error;
        },
        get isValidating () {
            stateDependencies.isValidating = true;
            return isValidating;
        },
        get isLoading () {
            stateDependencies.isLoading = true;
            return isLoading;
        }
    };
};
const $2445e9548358d192$export$4c7bbecdacc3ca2c = (0, $6gsyk.OBJECT).defineProperty((0, $6gsyk.SWRConfig), "defaultValue", {
    value: (0, $6gsyk.defaultConfig)
});
/**
 * A hook to fetch data.
 *
 * @link https://swr.vercel.app
 * @example
 * ```jsx
 * import useSWR from 'swr'
 * function Profile() {
 *   const { data, error, isLoading } = useSWR('/api/user', fetcher)
 *   if (error) return <div>failed to load</div>
 *   if (isLoading) return <div>loading...</div>
 *   return <div>hello {data.name}!</div>
 * }
 * ```
 */ const $2445e9548358d192$export$2e2bcd8739ae039 = (0, $6gsyk.withArgs)($2445e9548358d192$var$useSWRHandler);

});
parcelRegister("arJgR", function(module, exports) {

});

parcelRegister("6gsyk", function(module, exports) {

$parcel$export(module.exports, "UNDEFINED", function () { return $48fa62b04268f547$export$6db089fe7b26f5b6; });
$parcel$export(module.exports, "OBJECT", function () { return $48fa62b04268f547$export$8b8a958a7f6f130c; });
$parcel$export(module.exports, "isUndefined", function () { return $48fa62b04268f547$export$fce6876652108ab; });
$parcel$export(module.exports, "isFunction", function () { return $48fa62b04268f547$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "mergeObjects", function () { return $48fa62b04268f547$export$2321aea138b44780; });
$parcel$export(module.exports, "SWRGlobalState", function () { return $48fa62b04268f547$export$b94ca9901c60634; });
$parcel$export(module.exports, "createCacheHelper", function () { return $48fa62b04268f547$export$1251d51d9c571b45; });
$parcel$export(module.exports, "IS_REACT_LEGACY", function () { return $48fa62b04268f547$export$ddb64fe6466374f7; });
$parcel$export(module.exports, "IS_SERVER", function () { return $48fa62b04268f547$export$d2f4d8e74279c212; });
$parcel$export(module.exports, "rAF", function () { return $48fa62b04268f547$export$eba6076d3d7d0c06; });
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $48fa62b04268f547$export$700979bc83e7db82; });
$parcel$export(module.exports, "serialize", function () { return $48fa62b04268f547$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "getTimestamp", function () { return $48fa62b04268f547$export$3c95c4c8b671ef0; });
$parcel$export(module.exports, "revalidateEvents", function () { return $48fa62b04268f547$export$10213d6aa5ce32e6; });
$parcel$export(module.exports, "internalMutate", function () { return $48fa62b04268f547$export$c9d44e5bea4509be; });
$parcel$export(module.exports, "cache", function () { return $48fa62b04268f547$export$69a3209f1a06c04d; });
$parcel$export(module.exports, "mutate", function () { return $48fa62b04268f547$export$57e795267c26e600; });
$parcel$export(module.exports, "defaultConfig", function () { return $48fa62b04268f547$export$f84bd70098573c5c; });
$parcel$export(module.exports, "SWRConfig", function () { return $48fa62b04268f547$export$4c7bbecdacc3ca2c; });
$parcel$export(module.exports, "INFINITE_PREFIX", function () { return $48fa62b04268f547$export$8667f065faedc62c; });
$parcel$export(module.exports, "useSWRConfig", function () { return $48fa62b04268f547$export$f1dc0e282d4c1c0; });
$parcel$export(module.exports, "preload", function () { return $48fa62b04268f547$export$513ccb98c53b8039; });
$parcel$export(module.exports, "withArgs", function () { return $48fa62b04268f547$export$84d44e54e14b0133; });
$parcel$export(module.exports, "subscribeCallback", function () { return $48fa62b04268f547$export$e005210ed621746; });
$parcel$export(module.exports, "withMiddleware", function () { return $48fa62b04268f547$export$525ea7fc6ba00096; });

var $jbmdS = parcelRequire("jbmdS");
// Shared state between server components and client components
const $48fa62b04268f547$export$8793edee2d425525 = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $48fa62b04268f547$export$6db089fe7b26f5b6 = /*#__NOINLINE__*/ $48fa62b04268f547$export$8793edee2d425525();
const $48fa62b04268f547$export$8b8a958a7f6f130c = Object;
const $48fa62b04268f547$export$fce6876652108ab = (v)=>v === $48fa62b04268f547$export$6db089fe7b26f5b6;
const $48fa62b04268f547$export$f6e2535fb5126e54 = (v)=>typeof v == "function";
const $48fa62b04268f547$export$2321aea138b44780 = (a, b)=>({
        ...a,
        ...b
    });
const $48fa62b04268f547$export$ae936b9d47e5870e = (x)=>$48fa62b04268f547$export$f6e2535fb5126e54(x.then);
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $48fa62b04268f547$var$table = new WeakMap();
// counter of the key
let $48fa62b04268f547$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $48fa62b04268f547$export$e9a4e06c7dfb0bd4 = (arg)=>{
    const type = typeof arg;
    const constructor = arg && arg.constructor;
    const isDate = constructor == Date;
    let result;
    let index;
    if ($48fa62b04268f547$export$8b8a958a7f6f130c(arg) === arg && !isDate && constructor != RegExp) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $48fa62b04268f547$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$48fa62b04268f547$var$counter + "~";
        $48fa62b04268f547$var$table.set(arg, result);
        if (constructor == Array) {
            // Array.
            result = "@";
            for(index = 0; index < arg.length; index++)result += $48fa62b04268f547$export$e9a4e06c7dfb0bd4(arg[index]) + ",";
            $48fa62b04268f547$var$table.set(arg, result);
        }
        if (constructor == $48fa62b04268f547$export$8b8a958a7f6f130c) {
            // Object, sort keys.
            result = "#";
            const keys = $48fa62b04268f547$export$8b8a958a7f6f130c.keys(arg).sort();
            while(!$48fa62b04268f547$export$fce6876652108ab(index = keys.pop()))if (!$48fa62b04268f547$export$fce6876652108ab(arg[index])) result += index + ":" + $48fa62b04268f547$export$e9a4e06c7dfb0bd4(arg[index]) + ",";
            $48fa62b04268f547$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == "symbol" ? arg.toString() : type == "string" ? JSON.stringify(arg) : "" + arg;
    return result;
};
// Global state used to deduplicate requests and store listeners
const $48fa62b04268f547$export$b94ca9901c60634 = new WeakMap();
const $48fa62b04268f547$var$EMPTY_CACHE = {};
const $48fa62b04268f547$var$INITIAL_CACHE = {};
const $48fa62b04268f547$var$STR_UNDEFINED = "undefined";
// NOTE: Use the function to guarantee it's re-evaluated between jsdom and node runtime for tests.
const $48fa62b04268f547$export$6e85fd745dc51282 = typeof window != $48fa62b04268f547$var$STR_UNDEFINED;
const $48fa62b04268f547$export$842dfe7a9f24298 = typeof document != $48fa62b04268f547$var$STR_UNDEFINED;
const $48fa62b04268f547$export$a9116928c9d15917 = ()=>$48fa62b04268f547$export$6e85fd745dc51282 && typeof window["requestAnimationFrame"] != $48fa62b04268f547$var$STR_UNDEFINED;
const $48fa62b04268f547$export$1251d51d9c571b45 = (cache, key)=>{
    const state = $48fa62b04268f547$export$b94ca9901c60634.get(cache);
    return [
        // Getter
        ()=>!$48fa62b04268f547$export$fce6876652108ab(key) && cache.get(key) || $48fa62b04268f547$var$EMPTY_CACHE,
        // Setter
        (info)=>{
            if (!$48fa62b04268f547$export$fce6876652108ab(key)) {
                const prev = cache.get(key);
                // Before writing to the store, we keep the value in the initial cache
                // if it's not there yet.
                if (!(key in $48fa62b04268f547$var$INITIAL_CACHE)) $48fa62b04268f547$var$INITIAL_CACHE[key] = prev;
                state[5](key, $48fa62b04268f547$export$2321aea138b44780(prev, info), prev || $48fa62b04268f547$var$EMPTY_CACHE);
            }
        },
        // Subscriber
        state[6],
        // Get server cache snapshot
        ()=>{
            if (!$48fa62b04268f547$export$fce6876652108ab(key)) {
                // If the cache was updated on the client, we return the stored initial value.
                if (key in $48fa62b04268f547$var$INITIAL_CACHE) return $48fa62b04268f547$var$INITIAL_CACHE[key];
            }
            // If we haven't done any client-side updates, we return the current value.
            return !$48fa62b04268f547$export$fce6876652108ab(key) && cache.get(key) || $48fa62b04268f547$var$EMPTY_CACHE;
        }
    ];
} // export { UNDEFINED, OBJECT, isUndefined, isFunction, mergeObjects, isPromiseLike }
;
/**
 * Due to the bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a workaround, we always assume it's online on the first load, and change
 * the status upon `online` or `offline` events.
 */ let $48fa62b04268f547$var$online = true;
const $48fa62b04268f547$var$isOnline = ()=>$48fa62b04268f547$var$online;
// For node and React Native, `add/removeEventListener` doesn't exist on window.
const [$48fa62b04268f547$var$onWindowEvent, $48fa62b04268f547$var$offWindowEvent] = $48fa62b04268f547$export$6e85fd745dc51282 && window.addEventListener ? [
    window.addEventListener.bind(window),
    window.removeEventListener.bind(window)
] : [
    $48fa62b04268f547$export$8793edee2d425525,
    $48fa62b04268f547$export$8793edee2d425525
];
const $48fa62b04268f547$var$isVisible = ()=>{
    const visibilityState = $48fa62b04268f547$export$842dfe7a9f24298 && document.visibilityState;
    return $48fa62b04268f547$export$fce6876652108ab(visibilityState) || visibilityState !== "hidden";
};
const $48fa62b04268f547$var$initFocus = (callback)=>{
    // focus revalidate
    if ($48fa62b04268f547$export$842dfe7a9f24298) document.addEventListener("visibilitychange", callback);
    $48fa62b04268f547$var$onWindowEvent("focus", callback);
    return ()=>{
        if ($48fa62b04268f547$export$842dfe7a9f24298) document.removeEventListener("visibilitychange", callback);
        $48fa62b04268f547$var$offWindowEvent("focus", callback);
    };
};
const $48fa62b04268f547$var$initReconnect = (callback)=>{
    // revalidate on reconnected
    const onOnline = ()=>{
        $48fa62b04268f547$var$online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    const onOffline = ()=>{
        $48fa62b04268f547$var$online = false;
    };
    $48fa62b04268f547$var$onWindowEvent("online", onOnline);
    $48fa62b04268f547$var$onWindowEvent("offline", onOffline);
    return ()=>{
        $48fa62b04268f547$var$offWindowEvent("online", onOnline);
        $48fa62b04268f547$var$offWindowEvent("offline", onOffline);
    };
};
const $48fa62b04268f547$export$f5ab8217e0edff04 = {
    isOnline: $48fa62b04268f547$var$isOnline,
    isVisible: $48fa62b04268f547$var$isVisible
};
const $48fa62b04268f547$export$b1857f3440a65373 = {
    initFocus: $48fa62b04268f547$var$initFocus,
    initReconnect: $48fa62b04268f547$var$initReconnect
};
const $48fa62b04268f547$export$ddb64fe6466374f7 = !(0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useId;
const $48fa62b04268f547$export$d2f4d8e74279c212 = !$48fa62b04268f547$export$6e85fd745dc51282 || "Deno" in window;
// Polyfill requestAnimationFrame
const $48fa62b04268f547$export$eba6076d3d7d0c06 = (f)=>$48fa62b04268f547$export$a9116928c9d15917() ? window["requestAnimationFrame"](f) : setTimeout(f, 1);
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
const $48fa62b04268f547$export$700979bc83e7db82 = $48fa62b04268f547$export$d2f4d8e74279c212 ? (0, $jbmdS.useEffect) : (0, $jbmdS.useLayoutEffect);
// This assignment is to extend the Navigator type to use effectiveType.
const $48fa62b04268f547$var$navigatorConnection = typeof navigator !== "undefined" && navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
const $48fa62b04268f547$export$3723beb60427dc52 = !$48fa62b04268f547$export$d2f4d8e74279c212 && $48fa62b04268f547$var$navigatorConnection && ([
    "slow-2g",
    "2g"
].includes($48fa62b04268f547$var$navigatorConnection.effectiveType) || $48fa62b04268f547$var$navigatorConnection.saveData);
const $48fa62b04268f547$export$dfdc1655ccc5b9cb = (key)=>{
    if ($48fa62b04268f547$export$f6e2535fb5126e54(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = "";
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == "string" ? key : (Array.isArray(key) ? key.length : key) ? $48fa62b04268f547$export$e9a4e06c7dfb0bd4(key) : "";
    return [
        key,
        args
    ];
};
// Global timestamp.
let $48fa62b04268f547$var$__timestamp = 0;
const $48fa62b04268f547$export$3c95c4c8b671ef0 = ()=>++$48fa62b04268f547$var$__timestamp;
const $48fa62b04268f547$var$FOCUS_EVENT = 0;
const $48fa62b04268f547$var$RECONNECT_EVENT = 1;
const $48fa62b04268f547$var$MUTATE_EVENT = 2;
const $48fa62b04268f547$var$ERROR_REVALIDATE_EVENT = 3;
var $48fa62b04268f547$export$10213d6aa5ce32e6 = {
    __proto__: null,
    ERROR_REVALIDATE_EVENT: $48fa62b04268f547$var$ERROR_REVALIDATE_EVENT,
    FOCUS_EVENT: $48fa62b04268f547$var$FOCUS_EVENT,
    MUTATE_EVENT: $48fa62b04268f547$var$MUTATE_EVENT,
    RECONNECT_EVENT: $48fa62b04268f547$var$RECONNECT_EVENT
};
async function $48fa62b04268f547$export$c9d44e5bea4509be(...args) {
    const [cache, _key, _data, _opts] = args;
    // When passing as a boolean, it's explicitly used to disable/enable
    // revalidation.
    const options = $48fa62b04268f547$export$2321aea138b44780({
        populateCache: true,
        throwOnError: true
    }, typeof _opts === "boolean" ? {
        revalidate: _opts
    } : _opts || {});
    let populateCache = options.populateCache;
    const rollbackOnErrorOption = options.rollbackOnError;
    let optimisticData = options.optimisticData;
    const rollbackOnError = (error)=>{
        return typeof rollbackOnErrorOption === "function" ? rollbackOnErrorOption(error) : rollbackOnErrorOption !== false;
    };
    const throwOnError = options.throwOnError;
    // If the second argument is a key filter, return the mutation results for all
    // filtered keys.
    if ($48fa62b04268f547$export$f6e2535fb5126e54(_key)) {
        const keyFilter = _key;
        const matchedKeys = [];
        const it = cache.keys();
        for (const key of it)if (!/^\$(inf|sub)\$/.test(key) && keyFilter(cache.get(key)._k)) matchedKeys.push(key);
        return Promise.all(matchedKeys.map(mutateByKey));
    }
    return mutateByKey(_key);
    async function mutateByKey(_k) {
        // Serialize key
        const [key] = $48fa62b04268f547$export$dfdc1655ccc5b9cb(_k);
        if (!key) return;
        const [get, set] = $48fa62b04268f547$export$1251d51d9c571b45(cache, key);
        const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = $48fa62b04268f547$export$b94ca9901c60634.get(cache);
        const startRevalidate = ()=>{
            const revalidators = EVENT_REVALIDATORS[key];
            const revalidate = $48fa62b04268f547$export$f6e2535fb5126e54(options.revalidate) ? options.revalidate(get().data, _k) : options.revalidate !== false;
            if (revalidate) {
                // Invalidate the key by deleting the concurrent request markers so new
                // requests will not be deduped.
                delete FETCH[key];
                delete PRELOAD[key];
                if (revalidators && revalidators[0]) return revalidators[0]($48fa62b04268f547$var$MUTATE_EVENT).then(()=>get().data);
            }
            return get().data;
        };
        // If there is no new data provided, revalidate the key with current state.
        if (args.length < 3) // Revalidate and broadcast state.
        return startRevalidate();
        let data = _data;
        let error;
        // Update global timestamps.
        const beforeMutationTs = $48fa62b04268f547$export$3c95c4c8b671ef0();
        MUTATION[key] = [
            beforeMutationTs,
            0
        ];
        const hasOptimisticData = !$48fa62b04268f547$export$fce6876652108ab(optimisticData);
        const state = get();
        // `displayedData` is the current value on screen. It could be the optimistic value
        // that is going to be overridden by a `committedData`, or get reverted back.
        // `committedData` is the validated value that comes from a fetch or mutation.
        const displayedData = state.data;
        const currentData = state._c;
        const committedData = $48fa62b04268f547$export$fce6876652108ab(currentData) ? displayedData : currentData;
        // Do optimistic data update.
        if (hasOptimisticData) {
            optimisticData = $48fa62b04268f547$export$f6e2535fb5126e54(optimisticData) ? optimisticData(committedData, displayedData) : optimisticData;
            // When we set optimistic data, backup the current committedData data in `_c`.
            set({
                data: optimisticData,
                _c: committedData
            });
        }
        if ($48fa62b04268f547$export$f6e2535fb5126e54(data)) // `data` is a function, call it passing current cache value.
        try {
            data = data(committedData);
        } catch (err) {
            // If it throws an error synchronously, we shouldn't update the cache.
            error = err;
        }
        // `data` is a promise/thenable, resolve the final data first.
        if (data && $48fa62b04268f547$export$ae936b9d47e5870e(data)) {
            // This means that the mutation is async, we need to check timestamps to
            // avoid race conditions.
            data = await data.catch((err)=>{
                error = err;
            });
            // Check if other mutations have occurred since we've started this mutation.
            // If there's a race we don't update cache or broadcast the change,
            // just return the data.
            if (beforeMutationTs !== MUTATION[key][0]) {
                if (error) throw error;
                return data;
            } else if (error && hasOptimisticData && rollbackOnError(error)) {
                // Rollback. Always populate the cache in this case but without
                // transforming the data.
                populateCache = true;
                // Reset data to be the latest committed data, and clear the `_c` value.
                set({
                    data: committedData,
                    _c: $48fa62b04268f547$export$6db089fe7b26f5b6
                });
            }
        }
        // If we should write back the cache after request.
        if (populateCache) {
            if (!error) {
                // Transform the result into data.
                if ($48fa62b04268f547$export$f6e2535fb5126e54(populateCache)) {
                    const populateCachedData = populateCache(data, committedData);
                    set({
                        data: populateCachedData,
                        error: $48fa62b04268f547$export$6db089fe7b26f5b6,
                        _c: $48fa62b04268f547$export$6db089fe7b26f5b6
                    });
                } else // Only update cached data and reset the error if there's no error. Data can be `undefined` here.
                set({
                    data: data,
                    error: $48fa62b04268f547$export$6db089fe7b26f5b6,
                    _c: $48fa62b04268f547$export$6db089fe7b26f5b6
                });
            }
        }
        // Reset the timestamp to mark the mutation has ended.
        MUTATION[key][1] = $48fa62b04268f547$export$3c95c4c8b671ef0();
        // Update existing SWR Hooks' internal states:
        Promise.resolve(startRevalidate()).then(()=>{
            // The mutation and revalidation are ended, we can clear it since the data is
            // not an optimistic value anymore.
            set({
                _c: $48fa62b04268f547$export$6db089fe7b26f5b6
            });
        });
        // Throw error or return data
        if (error) {
            if (throwOnError) throw error;
            return;
        }
        return data;
    }
}
const $48fa62b04268f547$var$revalidateAllKeys = (revalidators, type)=>{
    for(const key in revalidators)if (revalidators[key][0]) revalidators[key][0](type);
};
const $48fa62b04268f547$export$4008f5b66f9e0b3c = (provider, options)=>{
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that is bound to
    // the cache.
    // The provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!$48fa62b04268f547$export$b94ca9901c60634.has(provider)) {
        const opts = $48fa62b04268f547$export$2321aea138b44780($48fa62b04268f547$export$b1857f3440a65373, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        const EVENT_REVALIDATORS = {};
        const mutate = $48fa62b04268f547$export$c9d44e5bea4509be.bind($48fa62b04268f547$export$6db089fe7b26f5b6, provider);
        let unmount = $48fa62b04268f547$export$8793edee2d425525;
        const subscriptions = {};
        const subscribe = (key, callback)=>{
            const subs = subscriptions[key] || [];
            subscriptions[key] = subs;
            subs.push(callback);
            return ()=>subs.splice(subs.indexOf(callback), 1);
        };
        const setter = (key, value, prev)=>{
            provider.set(key, value);
            const subs = subscriptions[key];
            if (subs) for (const fn of subs)fn(value, prev);
        };
        const initProvider = ()=>{
            if (!$48fa62b04268f547$export$b94ca9901c60634.has(provider)) {
                // Update the state if it's new, or if the provider has been extended.
                $48fa62b04268f547$export$b94ca9901c60634.set(provider, [
                    EVENT_REVALIDATORS,
                    {},
                    {},
                    {},
                    mutate,
                    setter,
                    subscribe
                ]);
                if (!$48fa62b04268f547$export$d2f4d8e74279c212) {
                    // When listening to the native events for auto revalidations,
                    // we intentionally put a delay (setTimeout) here to make sure they are
                    // fired after immediate JavaScript executions, which can be
                    // React's state updates.
                    // This avoids some unnecessary revalidations such as
                    // https://github.com/vercel/swr/issues/1680.
                    const releaseFocus = opts.initFocus(setTimeout.bind($48fa62b04268f547$export$6db089fe7b26f5b6, $48fa62b04268f547$var$revalidateAllKeys.bind($48fa62b04268f547$export$6db089fe7b26f5b6, EVENT_REVALIDATORS, $48fa62b04268f547$var$FOCUS_EVENT)));
                    const releaseReconnect = opts.initReconnect(setTimeout.bind($48fa62b04268f547$export$6db089fe7b26f5b6, $48fa62b04268f547$var$revalidateAllKeys.bind($48fa62b04268f547$export$6db089fe7b26f5b6, EVENT_REVALIDATORS, $48fa62b04268f547$var$RECONNECT_EVENT)));
                    unmount = ()=>{
                        releaseFocus && releaseFocus();
                        releaseReconnect && releaseReconnect();
                        // When un-mounting, we need to remove the cache provider from the state
                        // storage too because it's a side-effect. Otherwise, when re-mounting we
                        // will not re-register those event listeners.
                        $48fa62b04268f547$export$b94ca9901c60634.delete(provider);
                    };
                }
            }
        };
        initProvider();
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [
            provider,
            mutate,
            initProvider,
            unmount
        ];
    }
    return [
        provider,
        $48fa62b04268f547$export$b94ca9901c60634.get(provider)[4]
    ];
};
// error retry
const $48fa62b04268f547$var$onErrorRetry = (_, __, config, revalidate, opts)=>{
    const maxRetryCount = config.errorRetryCount;
    const currentRetryCount = opts.retryCount;
    // Exponential backoff
    const timeout = ~~((Math.random() + 0.5) * (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!$48fa62b04268f547$export$fce6876652108ab(maxRetryCount) && currentRetryCount > maxRetryCount) return;
    setTimeout(revalidate, timeout, opts);
};
const $48fa62b04268f547$export$398604a469f7de9a = (currentData, newData)=>$48fa62b04268f547$export$e9a4e06c7dfb0bd4(currentData) == $48fa62b04268f547$export$e9a4e06c7dfb0bd4(newData);
// Default cache provider
const [$48fa62b04268f547$export$69a3209f1a06c04d, $48fa62b04268f547$export$57e795267c26e600] = $48fa62b04268f547$export$4008f5b66f9e0b3c(new Map());
// Default config
const $48fa62b04268f547$export$f84bd70098573c5c = $48fa62b04268f547$export$2321aea138b44780({
    // events
    onLoadingSlow: $48fa62b04268f547$export$8793edee2d425525,
    onSuccess: $48fa62b04268f547$export$8793edee2d425525,
    onError: $48fa62b04268f547$export$8793edee2d425525,
    onErrorRetry: $48fa62b04268f547$var$onErrorRetry,
    onDiscarded: $48fa62b04268f547$export$8793edee2d425525,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: $48fa62b04268f547$export$3723beb60427dc52 ? 10000 : 5000,
    focusThrottleInterval: 5000,
    dedupingInterval: 2000,
    loadingTimeout: $48fa62b04268f547$export$3723beb60427dc52 ? 5000 : 3000,
    compare: // providers
    $48fa62b04268f547$export$398604a469f7de9a,
    isPaused: ()=>false,
    cache: $48fa62b04268f547$export$69a3209f1a06c04d,
    mutate: $48fa62b04268f547$export$57e795267c26e600,
    fallback: {}
}, $48fa62b04268f547$export$f5ab8217e0edff04);
const $48fa62b04268f547$export$5d86b86a654a7039 = (a, b)=>{
    // Need to create a new object to avoid mutating the original here.
    const v = $48fa62b04268f547$export$2321aea138b44780(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        const { use: u1, fallback: f1 } = a;
        const { use: u2, fallback: f2 } = b;
        if (u1 && u2) v.use = u1.concat(u2);
        if (f1 && f2) v.fallback = $48fa62b04268f547$export$2321aea138b44780(f1, f2);
    }
    return v;
};
const $48fa62b04268f547$var$SWRConfigContext = (0, $jbmdS.createContext)({});
const $48fa62b04268f547$export$4c7bbecdacc3ca2c = (props)=>{
    const { value: value } = props;
    const parentConfig = (0, $jbmdS.useContext)($48fa62b04268f547$var$SWRConfigContext);
    const isFunctionalConfig = $48fa62b04268f547$export$f6e2535fb5126e54(value);
    const config = (0, $jbmdS.useMemo)(()=>isFunctionalConfig ? value(parentConfig) : value, [
        isFunctionalConfig,
        parentConfig,
        value
    ]);
    // Extend parent context values and middleware.
    const extendedConfig = (0, $jbmdS.useMemo)(()=>isFunctionalConfig ? config : $48fa62b04268f547$export$5d86b86a654a7039(parentConfig, config), [
        isFunctionalConfig,
        parentConfig,
        config
    ]);
    // Should not use the inherited provider.
    const provider = config && config.provider;
    // initialize the cache only on first access.
    const cacheContextRef = (0, $jbmdS.useRef)($48fa62b04268f547$export$6db089fe7b26f5b6);
    if (provider && !cacheContextRef.current) cacheContextRef.current = $48fa62b04268f547$export$4008f5b66f9e0b3c(provider(extendedConfig.cache || $48fa62b04268f547$export$69a3209f1a06c04d), config);
    const cacheContext = cacheContextRef.current;
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    $48fa62b04268f547$export$700979bc83e7db82(()=>{
        if (cacheContext) {
            cacheContext[2] && cacheContext[2]();
            return cacheContext[3];
        }
    }, []);
    return (0, $jbmdS.createElement)($48fa62b04268f547$var$SWRConfigContext.Provider, $48fa62b04268f547$export$2321aea138b44780(props, {
        value: extendedConfig
    }));
};
const $48fa62b04268f547$export$8667f065faedc62c = "$inf$";
// @ts-expect-error
const $48fa62b04268f547$var$enableDevtools = $48fa62b04268f547$export$6e85fd745dc51282 && window.__SWR_DEVTOOLS_USE__;
const $48fa62b04268f547$var$use = $48fa62b04268f547$var$enableDevtools ? window.__SWR_DEVTOOLS_USE__ : [];
const $48fa62b04268f547$var$setupDevTools = ()=>{
    if ($48fa62b04268f547$var$enableDevtools) // @ts-expect-error
    window.__SWR_DEVTOOLS_REACT__ = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS)));
};
const $48fa62b04268f547$export$a3295358bff77e = (args)=>{
    return $48fa62b04268f547$export$f6e2535fb5126e54(args[1]) ? [
        args[0],
        args[1],
        args[2] || {}
    ] : [
        args[0],
        null,
        (args[1] === null ? args[2] : args[1]) || {}
    ];
};
const $48fa62b04268f547$export$f1dc0e282d4c1c0 = ()=>{
    return $48fa62b04268f547$export$2321aea138b44780($48fa62b04268f547$export$f84bd70098573c5c, (0, $jbmdS.useContext)($48fa62b04268f547$var$SWRConfigContext));
};
const $48fa62b04268f547$export$513ccb98c53b8039 = (key_, fetcher)=>{
    const [key, fnArg] = $48fa62b04268f547$export$dfdc1655ccc5b9cb(key_);
    const [, , , PRELOAD] = $48fa62b04268f547$export$b94ca9901c60634.get($48fa62b04268f547$export$69a3209f1a06c04d);
    // Prevent preload to be called multiple times before used.
    if (PRELOAD[key]) return PRELOAD[key];
    const req = fetcher(fnArg);
    PRELOAD[key] = req;
    return req;
};
const $48fa62b04268f547$var$middleware = (useSWRNext)=>(key_, fetcher_, config)=>{
        // fetcher might be a sync function, so this should not be an async function
        const fetcher = fetcher_ && ((...args)=>{
            const [key] = $48fa62b04268f547$export$dfdc1655ccc5b9cb(key_);
            const [, , , PRELOAD] = $48fa62b04268f547$export$b94ca9901c60634.get($48fa62b04268f547$export$69a3209f1a06c04d);
            if (key.startsWith($48fa62b04268f547$export$8667f065faedc62c)) // we want the infinite fetcher to be called.
            // handling of the PRELOAD cache happens there.
            return fetcher_(...args);
            const req = PRELOAD[key];
            if ($48fa62b04268f547$export$fce6876652108ab(req)) return fetcher_(...args);
            delete PRELOAD[key];
            return req;
        });
        return useSWRNext(key_, fetcher, config);
    };
const $48fa62b04268f547$var$BUILT_IN_MIDDLEWARE = $48fa62b04268f547$var$use.concat($48fa62b04268f547$var$middleware);
// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
const $48fa62b04268f547$export$84d44e54e14b0133 = (hook)=>{
    return function useSWRArgs(...args) {
        // Get the default and inherited configuration.
        const fallbackConfig = $48fa62b04268f547$export$f1dc0e282d4c1c0();
        // Normalize arguments.
        const [key, fn, _config] = $48fa62b04268f547$export$a3295358bff77e(args);
        // Merge configurations.
        const config = $48fa62b04268f547$export$5d86b86a654a7039(fallbackConfig, _config);
        // Apply middleware
        let next = hook;
        const { use: use } = config;
        const middleware = (use || []).concat($48fa62b04268f547$var$BUILT_IN_MIDDLEWARE);
        for(let i = middleware.length; i--;)next = middleware[i](next);
        return next(key, fn || config.fetcher || null, config);
    };
};
// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
const $48fa62b04268f547$export$e005210ed621746 = (key, callbacks, callback)=>{
    const keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return ()=>{
        const index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};
// Create a custom hook with a middleware
const $48fa62b04268f547$export$525ea7fc6ba00096 = (useSWR, middleware)=>{
    return (...args)=>{
        const [key, fn, config] = $48fa62b04268f547$export$a3295358bff77e(args);
        const uses = (config.use || []).concat(middleware);
        return useSWR(key, fn, {
            ...config,
            use: uses
        });
    };
};
$48fa62b04268f547$var$setupDevTools();

});


parcelRegister("fo2TC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "unstable_serialize", function () { return $b33b5801d2cb05e4$export$dbab534a48e651ef; });
$parcel$export(module.exports, "infinite", function () { return $b33b5801d2cb05e4$export$f27219e7b43e81d; });
$parcel$export(module.exports, "default", function () { return $b33b5801d2cb05e4$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("arJgR");

var $bUdUR = parcelRequire("bUdUR");

var $6gsyk = parcelRequire("6gsyk");
/// <reference types="react/experimental" />
const $b33b5801d2cb05e4$var$use = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).use || ((promise)=>{
    if (promise.status === "pending") throw promise;
    else if (promise.status === "fulfilled") return promise.value;
    else if (promise.status === "rejected") throw promise.reason;
    else {
        promise.status = "pending";
        promise.then((v)=>{
            promise.status = "fulfilled";
            promise.value = v;
        }, (e)=>{
            promise.status = "rejected";
            promise.reason = e;
        });
        throw promise;
    }
});
const $b33b5801d2cb05e4$var$WITH_DEDUPE = {
    dedupe: true
};
const $b33b5801d2cb05e4$var$useSWRHandler = (_key, fetcher, config)=>{
    const { cache: cache, compare: compare, suspense: suspense, fallbackData: fallbackData, revalidateOnMount: revalidateOnMount, revalidateIfStale: revalidateIfStale, refreshInterval: refreshInterval, refreshWhenHidden: refreshWhenHidden, refreshWhenOffline: refreshWhenOffline, keepPreviousData: keepPreviousData } = config;
    const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = (0, $6gsyk.SWRGlobalState).get(cache);
    // `key` is the identifier of the SWR internal state,
    // `fnArg` is the argument/arguments parsed from the key, which will be passed
    // to the fetcher.
    // All of them are derived from `_key`.
    const [key, fnArg] = (0, $6gsyk.serialize)(_key);
    // If it's the initial render of this hook.
    const initialMountedRef = (0, $jbmdS.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    const unmountedRef = (0, $jbmdS.useRef)(false);
    // Refs to keep the key and config.
    const keyRef = (0, $jbmdS.useRef)(key);
    const fetcherRef = (0, $jbmdS.useRef)(fetcher);
    const configRef = (0, $jbmdS.useRef)(config);
    const getConfig = ()=>configRef.current;
    const isActive = ()=>getConfig().isVisible() && getConfig().isOnline();
    const [getCache, setCache, subscribeCache, getInitialCache] = (0, $6gsyk.createCacheHelper)(cache, key);
    const stateDependencies = (0, $jbmdS.useRef)({}).current;
    const fallback = (0, $6gsyk.isUndefined)(fallbackData) ? config.fallback[key] : fallbackData;
    const isEqual = (prev, current)=>{
        for(const _ in stateDependencies){
            const t = _;
            if (t === "data") {
                if (!compare(prev[t], current[t])) {
                    if (!(0, $6gsyk.isUndefined)(prev[t])) return false;
                    if (!compare(returnedData, current[t])) return false;
                }
            } else {
                if (current[t] !== prev[t]) return false;
            }
        }
        return true;
    };
    const getSnapshot = (0, $jbmdS.useMemo)(()=>{
        const shouldStartRequest = (()=>{
            if (!key) return false;
            if (!fetcher) return false;
            // If `revalidateOnMount` is set, we take the value directly.
            if (!(0, $6gsyk.isUndefined)(revalidateOnMount)) return revalidateOnMount;
            // If it's paused, we skip revalidation.
            if (getConfig().isPaused()) return false;
            if (suspense) return false;
            if (!(0, $6gsyk.isUndefined)(revalidateIfStale)) return revalidateIfStale;
            return true;
        })();
        // Get the cache and merge it with expected states.
        const getSelectedCache = (state)=>{
            // We only select the needed fields from the state.
            const snapshot = (0, $6gsyk.mergeObjects)(state);
            delete snapshot._k;
            if (!shouldStartRequest) return snapshot;
            return {
                isValidating: true,
                isLoading: true,
                ...snapshot
            };
        };
        const cachedData = getCache();
        const initialData = getInitialCache();
        const clientSnapshot = getSelectedCache(cachedData);
        const serverSnapshot = cachedData === initialData ? clientSnapshot : getSelectedCache(initialData);
        // To make sure that we are returning the same object reference to avoid
        // unnecessary re-renders, we keep the previous snapshot and use deep
        // comparison to check if we need to return a new one.
        let memorizedSnapshot = clientSnapshot;
        return [
            ()=>{
                const newSnapshot = getSelectedCache(getCache());
                const compareResult = isEqual(newSnapshot, memorizedSnapshot);
                if (compareResult) {
                    // Mentally, we should always return the `memorizedSnapshot` here
                    // as there's no change between the new and old snapshots.
                    // However, since the `isEqual` function only compares selected fields,
                    // the values of the unselected fields might be changed. That's
                    // simply because we didn't track them.
                    // To support the case in https://github.com/vercel/swr/pull/2576,
                    // we need to update these fields in the `memorizedSnapshot` too
                    // with direct mutations to ensure the snapshot is always up-to-date
                    // even for the unselected fields, but only trigger re-renders when
                    // the selected fields are changed.
                    memorizedSnapshot.data = newSnapshot.data;
                    memorizedSnapshot.isLoading = newSnapshot.isLoading;
                    memorizedSnapshot.isValidating = newSnapshot.isValidating;
                    memorizedSnapshot.error = newSnapshot.error;
                    return memorizedSnapshot;
                } else {
                    memorizedSnapshot = newSnapshot;
                    return newSnapshot;
                }
            },
            ()=>serverSnapshot
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cache,
        key
    ]);
    // Get the current state that SWR should return.
    const cached = (0, $bUdUR.useSyncExternalStore)((0, $jbmdS.useCallback)((callback)=>subscribeCache(key, (current, prev)=>{
            if (!isEqual(prev, current)) callback();
        }), [
        cache,
        key
    ]), getSnapshot[0], getSnapshot[1]);
    const isInitialMount = !initialMountedRef.current;
    const hasRevalidator = EVENT_REVALIDATORS[key] && EVENT_REVALIDATORS[key].length > 0;
    const cachedData = cached.data;
    const data = (0, $6gsyk.isUndefined)(cachedData) ? fallback : cachedData;
    const error = cached.error;
    // Use a ref to store previously returned data. Use the initial data as its initial value.
    const laggyDataRef = (0, $jbmdS.useRef)(data);
    const returnedData = keepPreviousData ? (0, $6gsyk.isUndefined)(cachedData) ? laggyDataRef.current : cachedData : data;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    const shouldDoInitialRevalidation = (()=>{
        // if a key already has revalidators and also has error, we should not trigger revalidation
        if (hasRevalidator && !(0, $6gsyk.isUndefined)(error)) return false;
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !(0, $6gsyk.isUndefined)(revalidateOnMount)) return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused()) return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately mount it again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense) return (0, $6gsyk.isUndefined)(data) ? false : revalidateIfStale;
        // If there is no stale data, we need to revalidate when mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return (0, $6gsyk.isUndefined)(data) || revalidateIfStale;
    })();
    // Resolve the default validating state:
    // If it's able to validate, and it should revalidate when mount, this will be true.
    const defaultValidatingState = !!(key && fetcher && isInitialMount && shouldDoInitialRevalidation);
    const isValidating = (0, $6gsyk.isUndefined)(cached.isValidating) ? defaultValidatingState : cached.isValidating;
    const isLoading = (0, $6gsyk.isUndefined)(cached.isLoading) ? defaultValidatingState : cached.isLoading;
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    const revalidate = (0, $jbmdS.useCallback)(async (revalidateOpts)=>{
        const currentFetcher = fetcherRef.current;
        if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused()) return false;
        let newData;
        let startAt;
        let loading = true;
        const opts = revalidateOpts || {};
        // If there is no ongoing concurrent request, or `dedupe` is not set, a
        // new request should be initiated.
        const shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
        /*
         For React 17
         Do unmount check for calls:
         If key has changed during the revalidation, or the component has been
         unmounted, old dispatch and old event callbacks should not take any
         effect

        For React 18
        only check if key has changed
        https://github.com/reactwg/react-18/discussions/82
      */ const callbackSafeguard = ()=>{
            if (0, $6gsyk.IS_REACT_LEGACY) return !unmountedRef.current && key === keyRef.current && initialMountedRef.current;
            return key === keyRef.current;
        };
        // The final state object when the request finishes.
        const finalState = {
            isValidating: false,
            isLoading: false
        };
        const finishRequestAndUpdateState = ()=>{
            setCache(finalState);
        };
        const cleanupState = ()=>{
            // Check if it's still the same request before deleting it.
            const requestInfo = FETCH[key];
            if (requestInfo && requestInfo[1] === startAt) delete FETCH[key];
        };
        // Start fetching. Change the `isValidating` state, update the cache.
        const initialState = {
            isValidating: true
        };
        // It is in the `isLoading` state, if and only if there is no cached data.
        // This bypasses fallback data and laggy data.
        if ((0, $6gsyk.isUndefined)(getCache().data)) initialState.isLoading = true;
        try {
            if (shouldStartNewRequest) {
                setCache(initialState);
                // If no cache is being rendered currently (it shows a blank page),
                // we trigger the loading slow event.
                if (config.loadingTimeout && (0, $6gsyk.isUndefined)(getCache().data)) setTimeout(()=>{
                    if (loading && callbackSafeguard()) getConfig().onLoadingSlow(key, config);
                }, config.loadingTimeout);
                // Start the request and save the timestamp.
                // Key must be truthy if entering here.
                FETCH[key] = [
                    currentFetcher(fnArg),
                    (0, $6gsyk.getTimestamp)()
                ];
            }
            [newData, startAt] = FETCH[key];
            newData = await newData;
            if (shouldStartNewRequest) // If the request isn't interrupted, clean it up after the
            // deduplication interval.
            setTimeout(cleanupState, config.dedupingInterval);
            // If there're other ongoing request(s), started after the current one,
            // we need to ignore the current one to avoid possible race conditions:
            //   req1------------------>res1        (current one)
            //        req2---------------->res2
            // the request that fired later will always be kept.
            // The timestamp maybe be `undefined` or a number
            if (!FETCH[key] || FETCH[key][1] !== startAt) {
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Clear error.
            finalState.error = (0, $6gsyk.UNDEFINED);
            // If there're other mutations(s), that overlapped with the current revalidation:
            // case 1:
            //   req------------------>res
            //       mutate------>end
            // case 2:
            //         req------------>res
            //   mutate------>end
            // case 3:
            //   req------------------>res
            //       mutate-------...---------->
            // we have to ignore the revalidation result (res) because it's no longer fresh.
            // meanwhile, a new revalidation should be triggered when the mutation ends.
            const mutationInfo = MUTATION[key];
            if (!(0, $6gsyk.isUndefined)(mutationInfo) && // case 1
            (startAt <= mutationInfo[0] || // case 2
            startAt <= mutationInfo[1] || // case 3
            mutationInfo[1] === 0)) {
                finishRequestAndUpdateState();
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Deep compare with the latest state to avoid extra re-renders.
            // For local state, compare and assign.
            const cacheData = getCache().data;
            // Since the compare fn could be custom fn
            // cacheData might be different from newData even when compare fn returns True
            finalState.data = compare(cacheData, newData) ? cacheData : newData;
            // Trigger the successful callback if it's the original request.
            if (shouldStartNewRequest) {
                if (callbackSafeguard()) getConfig().onSuccess(newData, key, config);
            }
        } catch (err) {
            cleanupState();
            const currentConfig = getConfig();
            const { shouldRetryOnError: shouldRetryOnError } = currentConfig;
            // Not paused, we continue handling the error. Otherwise, discard it.
            if (!currentConfig.isPaused()) {
                // Get a new error, don't use deep comparison for errors.
                finalState.error = err;
                // Error event and retry logic. Only for the actual request, not
                // deduped ones.
                if (shouldStartNewRequest && callbackSafeguard()) {
                    currentConfig.onError(err, key, currentConfig);
                    if (shouldRetryOnError === true || (0, $6gsyk.isFunction)(shouldRetryOnError) && shouldRetryOnError(err)) {
                        if (!getConfig().revalidateOnFocus || !getConfig().revalidateOnReconnect || isActive()) // If it's inactive, stop. It will auto-revalidate when
                        // refocusing or reconnecting.
                        // When retrying, deduplication is always enabled.
                        currentConfig.onErrorRetry(err, key, currentConfig, (_opts)=>{
                            const revalidators = EVENT_REVALIDATORS[key];
                            if (revalidators && revalidators[0]) revalidators[0]((0, $6gsyk.revalidateEvents).ERROR_REVALIDATE_EVENT, _opts);
                        }, {
                            retryCount: (opts.retryCount || 0) + 1,
                            dedupe: true
                        });
                    }
                }
            }
        }
        // Mark loading as stopped.
        loading = false;
        // Update the current hook's state.
        finishRequestAndUpdateState();
        return true;
    }, // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key,
        cache
    ]);
    // Similar to the global mutate but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    const boundMutate = (0, $jbmdS.useCallback)((...args)=>{
        return (0, $6gsyk.internalMutate)(cache, keyRef.current, ...args);
    }, []);
    // The logic for updating refs.
    (0, $6gsyk.useIsomorphicLayoutEffect)(()=>{
        fetcherRef.current = fetcher;
        configRef.current = config;
        // Handle laggy data updates. If there's cached data of the current key,
        // it'll be the correct reference.
        if (!(0, $6gsyk.isUndefined)(cachedData)) laggyDataRef.current = cachedData;
    });
    // After mounted or key changed.
    (0, $6gsyk.useIsomorphicLayoutEffect)(()=>{
        if (!key) return;
        const softRevalidate = revalidate.bind((0, $6gsyk.UNDEFINED), $b33b5801d2cb05e4$var$WITH_DEDUPE);
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        let nextFocusRevalidatedAt = 0;
        const onRevalidate = (type, opts = {})=>{
            if (type == (0, $6gsyk.revalidateEvents).FOCUS_EVENT) {
                const now = Date.now();
                if (getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            } else if (type == (0, $6gsyk.revalidateEvents).RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) softRevalidate();
            } else if (type == (0, $6gsyk.revalidateEvents).MUTATE_EVENT) return revalidate();
            else if (type == (0, $6gsyk.revalidateEvents).ERROR_REVALIDATE_EVENT) return revalidate(opts);
            return;
        };
        const unsubEvents = (0, $6gsyk.subscribeCallback)(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // Keep the original key in the cache.
        setCache({
            _k: fnArg
        });
        // Trigger a revalidation
        if (shouldDoInitialRevalidation) {
            if ((0, $6gsyk.isUndefined)(data) || (0, $6gsyk.IS_SERVER)) // Revalidate immediately.
            softRevalidate();
            else // Delay the revalidate if we have data to return so we won't block
            // rendering.
            (0, $6gsyk.rAF)(softRevalidate);
        }
        return ()=>{
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubEvents();
        };
    }, [
        key
    ]);
    // Polling
    (0, $6gsyk.useIsomorphicLayoutEffect)(()=>{
        let timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            const interval = (0, $6gsyk.isFunction)(refreshInterval) ? refreshInterval(getCache().data) : refreshInterval;
            // We only start the next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) timer = setTimeout(execute, interval);
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online, and not errored.
            if (!getCache().error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline())) revalidate($b33b5801d2cb05e4$var$WITH_DEDUPE).then(next);
            else // Schedule the next interval to check again.
            next();
        }
        next();
        return ()=>{
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [
        refreshInterval,
        refreshWhenHidden,
        refreshWhenOffline,
        key
    ]);
    // Display debug info in React DevTools.
    (0, $jbmdS.useDebugValue)(returnedData);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is an `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense && (0, $6gsyk.isUndefined)(data) && key) {
        // SWR should throw when trying to use Suspense on the server with React 18,
        // without providing any initial data. See:
        // https://github.com/vercel/swr/issues/1832
        if (!(0, $6gsyk.IS_REACT_LEGACY) && (0, $6gsyk.IS_SERVER)) throw new Error("Fallback data is required when using suspense in SSR.");
        // Always update fetcher and config refs even with the Suspense mode.
        fetcherRef.current = fetcher;
        configRef.current = config;
        unmountedRef.current = false;
        const req = PRELOAD[key];
        if (!(0, $6gsyk.isUndefined)(req)) {
            const promise = boundMutate(req);
            $b33b5801d2cb05e4$var$use(promise);
        }
        if ((0, $6gsyk.isUndefined)(error)) {
            const promise = revalidate($b33b5801d2cb05e4$var$WITH_DEDUPE);
            if (!(0, $6gsyk.isUndefined)(returnedData)) {
                promise.status = "fulfilled";
                promise.value = true;
            }
            $b33b5801d2cb05e4$var$use(promise);
        } else throw error;
    }
    return {
        mutate: boundMutate,
        get data () {
            stateDependencies.data = true;
            return returnedData;
        },
        get error () {
            stateDependencies.error = true;
            return error;
        },
        get isValidating () {
            stateDependencies.isValidating = true;
            return isValidating;
        },
        get isLoading () {
            stateDependencies.isLoading = true;
            return isLoading;
        }
    };
};
(0, $6gsyk.OBJECT).defineProperty((0, $6gsyk.SWRConfig), "defaultValue", {
    value: (0, $6gsyk.defaultConfig)
});
/**
 * A hook to fetch data.
 *
 * @link https://swr.vercel.app
 * @example
 * ```jsx
 * import useSWR from 'swr'
 * function Profile() {
 *   const { data, error, isLoading } = useSWR('/api/user', fetcher)
 *   if (error) return <div>failed to load</div>
 *   if (isLoading) return <div>loading...</div>
 *   return <div>hello {data.name}!</div>
 * }
 * ```
 */ const $b33b5801d2cb05e4$var$useSWR = (0, $6gsyk.withArgs)($b33b5801d2cb05e4$var$useSWRHandler);
const $b33b5801d2cb05e4$var$getFirstPageKey = (getKey)=>{
    return (0, $6gsyk.serialize)(getKey ? getKey(0, null) : null)[0];
};
const $b33b5801d2cb05e4$export$dbab534a48e651ef = (getKey)=>{
    return (0, $6gsyk.INFINITE_PREFIX) + $b33b5801d2cb05e4$var$getFirstPageKey(getKey);
};
// We have to several type castings here because `useSWRInfinite` is a special
// hook where `key` and return type are not like the normal `useSWR` types.
// const INFINITE_PREFIX = '$inf$'
const $b33b5801d2cb05e4$var$EMPTY_PROMISE = Promise.resolve();
// export const unstable_serialize = (getKey: SWRInfiniteKeyLoader) => {
//   return INFINITE_PREFIX + getFirstPageKey(getKey)
// }
const $b33b5801d2cb05e4$export$f27219e7b43e81d = (useSWRNext)=>(getKey, fn, config)=>{
        const didMountRef = (0, $jbmdS.useRef)(false);
        const { cache: cache$1, initialSize: initialSize = 1, revalidateAll: revalidateAll = false, persistSize: persistSize = false, revalidateFirstPage: revalidateFirstPage = true, revalidateOnMount: revalidateOnMount = false, parallel: parallel = false } = config;
        const [, , , PRELOAD] = (0, $6gsyk.SWRGlobalState).get((0, $6gsyk.cache));
        // The serialized key of the first page. This key will be used to store
        // metadata of this SWR infinite hook.
        let infiniteKey;
        try {
            infiniteKey = $b33b5801d2cb05e4$var$getFirstPageKey(getKey);
            if (infiniteKey) infiniteKey = (0, $6gsyk.INFINITE_PREFIX) + infiniteKey;
        } catch (err) {
        // Not ready yet.
        }
        const [get, set, subscribeCache] = (0, $6gsyk.createCacheHelper)(cache$1, infiniteKey);
        const getSnapshot = (0, $jbmdS.useCallback)(()=>{
            const size = (0, $6gsyk.isUndefined)(get()._l) ? initialSize : get()._l;
            return size;
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            cache$1,
            infiniteKey,
            initialSize
        ]);
        (0, $bUdUR.useSyncExternalStore)((0, $jbmdS.useCallback)((callback)=>{
            if (infiniteKey) return subscribeCache(infiniteKey, ()=>{
                callback();
            });
            return ()=>{};
        }, [
            cache$1,
            infiniteKey
        ]), getSnapshot, getSnapshot);
        const resolvePageSize = (0, $jbmdS.useCallback)(()=>{
            const cachedPageSize = get()._l;
            return (0, $6gsyk.isUndefined)(cachedPageSize) ? initialSize : cachedPageSize;
        // `cache` isn't allowed to change during the lifecycle
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            infiniteKey,
            initialSize
        ]);
        // keep the last page size to restore it with the persistSize option
        const lastPageSizeRef = (0, $jbmdS.useRef)(resolvePageSize());
        // When the page key changes, we reset the page size if it's not persisted
        (0, $6gsyk.useIsomorphicLayoutEffect)(()=>{
            if (!didMountRef.current) {
                didMountRef.current = true;
                return;
            }
            if (infiniteKey) // If the key has been changed, we keep the current page size if persistSize is enabled
            // Otherwise, we reset the page size to cached pageSize
            set({
                _l: persistSize ? lastPageSizeRef.current : resolvePageSize()
            });
        // `initialSize` isn't allowed to change during the lifecycle
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            infiniteKey,
            cache$1
        ]);
        // Needs to check didMountRef during mounting, not in the fetcher
        const shouldRevalidateOnMount = revalidateOnMount && !didMountRef.current;
        // Actual SWR hook to load all pages in one fetcher.
        const swr = useSWRNext(infiniteKey, async (key)=>{
            // get the revalidate context
            const forceRevalidateAll = get()._i;
            const shouldRevalidatePage = get()._r;
            set({
                _r: (0, $6gsyk.UNDEFINED)
            });
            // return an array of page data
            const data = [];
            const pageSize = resolvePageSize();
            const [getCache] = (0, $6gsyk.createCacheHelper)(cache$1, key);
            const cacheData = getCache().data;
            const revalidators = [];
            let previousPageData = null;
            for(let i = 0; i < pageSize; ++i){
                const [pageKey, pageArg] = (0, $6gsyk.serialize)(getKey(i, parallel ? null : previousPageData));
                if (!pageKey) break;
                const [getSWRCache, setSWRCache] = (0, $6gsyk.createCacheHelper)(cache$1, pageKey);
                // Get the cached page data.
                let pageData = getSWRCache().data;
                // should fetch (or revalidate) if:
                // - `revalidateAll` is enabled
                // - `mutate()` called
                // - the cache is missing
                // - it's the first page and it's not the initial render
                // - `revalidateOnMount` is enabled and it's on mount
                // - cache for that page has changed
                const shouldFetchPage = revalidateAll || forceRevalidateAll || (0, $6gsyk.isUndefined)(pageData) || revalidateFirstPage && !i && !(0, $6gsyk.isUndefined)(cacheData) || shouldRevalidateOnMount || cacheData && !(0, $6gsyk.isUndefined)(cacheData[i]) && !config.compare(cacheData[i], pageData);
                if (fn && (typeof shouldRevalidatePage === "function" ? shouldRevalidatePage(pageData, pageArg) : shouldFetchPage)) {
                    const revalidate = async ()=>{
                        const hasPreloadedRequest = pageKey in PRELOAD;
                        if (!hasPreloadedRequest) pageData = await fn(pageArg);
                        else {
                            const req = PRELOAD[pageKey];
                            // delete the preload cache key before resolving it
                            // in case there's an error
                            delete PRELOAD[pageKey];
                            // get the page data from the preload cache
                            pageData = await req;
                        }
                        setSWRCache({
                            data: pageData,
                            _k: pageArg
                        });
                        data[i] = pageData;
                    };
                    if (parallel) revalidators.push(revalidate);
                    else await revalidate();
                } else data[i] = pageData;
                if (!parallel) previousPageData = pageData;
            }
            // flush all revalidateions in parallel
            if (parallel) await Promise.all(revalidators.map((r)=>r()));
            // once we executed the data fetching based on the context, clear the context
            set({
                _i: (0, $6gsyk.UNDEFINED)
            });
            // return the data
            return data;
        }, config);
        const mutate = (0, $jbmdS.useCallback)(function(data, opts) {
            // When passing as a boolean, it's explicitly used to disable/enable
            // revalidation.
            const options = typeof opts === "boolean" ? {
                revalidate: opts
            } : opts || {};
            // Default to true.
            const shouldRevalidate = options.revalidate !== false;
            // It is possible that the key is still falsy.
            if (!infiniteKey) return $b33b5801d2cb05e4$var$EMPTY_PROMISE;
            if (shouldRevalidate) {
                if (!(0, $6gsyk.isUndefined)(data)) // We only revalidate the pages that are changed
                set({
                    _i: false,
                    _r: options.revalidate
                });
                else // Calling `mutate()`, we revalidate all pages
                set({
                    _i: true,
                    _r: options.revalidate
                });
            }
            return arguments.length ? swr.mutate(data, {
                ...options,
                revalidate: shouldRevalidate
            }) : swr.mutate();
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            infiniteKey,
            cache$1
        ]);
        // Extend the SWR API
        const setSize = (0, $jbmdS.useCallback)((arg)=>{
            // It is possible that the key is still falsy.
            if (!infiniteKey) return $b33b5801d2cb05e4$var$EMPTY_PROMISE;
            const [, changeSize] = (0, $6gsyk.createCacheHelper)(cache$1, infiniteKey);
            let size;
            if ((0, $6gsyk.isFunction)(arg)) size = arg(resolvePageSize());
            else if (typeof arg == "number") size = arg;
            if (typeof size != "number") return $b33b5801d2cb05e4$var$EMPTY_PROMISE;
            changeSize({
                _l: size
            });
            lastPageSizeRef.current = size;
            // Calculate the page data after the size change.
            const data = [];
            const [getInfiniteCache] = (0, $6gsyk.createCacheHelper)(cache$1, infiniteKey);
            let previousPageData = null;
            for(let i = 0; i < size; ++i){
                const [pageKey] = (0, $6gsyk.serialize)(getKey(i, previousPageData));
                const [getCache] = (0, $6gsyk.createCacheHelper)(cache$1, pageKey);
                // Get the cached page data.
                const pageData = pageKey ? getCache().data : (0, $6gsyk.UNDEFINED);
                // Call `mutate` with infinte cache data if we can't get it from the page cache.
                if ((0, $6gsyk.isUndefined)(pageData)) return mutate(getInfiniteCache().data);
                data.push(pageData);
                previousPageData = pageData;
            }
            return mutate(data);
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            infiniteKey,
            cache$1,
            mutate,
            resolvePageSize
        ]);
        // Use getter functions to avoid unnecessary re-renders caused by triggering
        // all the getters of the returned swr object.
        return {
            size: resolvePageSize(),
            setSize: setSize,
            mutate: mutate,
            get data () {
                return swr.data;
            },
            get error () {
                return swr.error;
            },
            get isValidating () {
                return swr.isValidating;
            },
            get isLoading () {
                return swr.isLoading;
            }
        };
    };
const $b33b5801d2cb05e4$export$2e2bcd8739ae039 = (0, $6gsyk.withMiddleware)($b33b5801d2cb05e4$var$useSWR, $b33b5801d2cb05e4$export$f27219e7b43e81d);

});

parcelRegister("3DYI4", function(module, exports) {

$parcel$export(module.exports, "dequal", function () { return $c43d7b21e80340e8$export$de8294bb3be0322f; });
var $c43d7b21e80340e8$var$has = Object.prototype.hasOwnProperty;
function $c43d7b21e80340e8$var$find(iter, tar, key) {
    for (key of iter.keys()){
        if ($c43d7b21e80340e8$export$de8294bb3be0322f(key, tar)) return key;
    }
}
function $c43d7b21e80340e8$export$de8294bb3be0322f(foo, bar) {
    var ctor, len, tmp;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $c43d7b21e80340e8$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (ctor === Set) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len;
                if (tmp && typeof tmp === "object") {
                    tmp = $c43d7b21e80340e8$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!bar.has(tmp)) return false;
            }
            return true;
        }
        if (ctor === Map) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len[0];
                if (tmp && typeof tmp === "object") {
                    tmp = $c43d7b21e80340e8$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!$c43d7b21e80340e8$export$de8294bb3be0322f(len[1], bar.get(tmp))) return false;
            }
            return true;
        }
        if (ctor === ArrayBuffer) {
            foo = new Uint8Array(foo);
            bar = new Uint8Array(bar);
        } else if (ctor === DataView) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo.getInt8(len) === bar.getInt8(len));
            }
            return len === -1;
        }
        if (ArrayBuffer.isView(foo)) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo[len] === bar[len]);
            }
            return len === -1;
        }
        if (!ctor || typeof foo === "object") {
            len = 0;
            for(ctor in foo){
                if ($c43d7b21e80340e8$var$has.call(foo, ctor) && ++len && !$c43d7b21e80340e8$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$c43d7b21e80340e8$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}

});


parcelRegister("2dt0q", function(module, exports) {
"use strict";
var $19d34ba43ba6e6f9$var$__defProp = Object.defineProperty;
var $19d34ba43ba6e6f9$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $19d34ba43ba6e6f9$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $19d34ba43ba6e6f9$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $19d34ba43ba6e6f9$var$__export = (target, all)=>{
    for(var name in all)$19d34ba43ba6e6f9$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $19d34ba43ba6e6f9$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $19d34ba43ba6e6f9$var$__getOwnPropNames(from))if (!$19d34ba43ba6e6f9$var$__hasOwnProp.call(to, key) && key !== except) $19d34ba43ba6e6f9$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $19d34ba43ba6e6f9$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $19d34ba43ba6e6f9$var$__toCommonJS = (mod)=>$19d34ba43ba6e6f9$var$__copyProps($19d34ba43ba6e6f9$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
// src/deprecated.ts
var $19d34ba43ba6e6f9$var$deprecated_exports = {};
$19d34ba43ba6e6f9$var$__export($19d34ba43ba6e6f9$var$deprecated_exports, {
    deprecated: ()=>$19d34ba43ba6e6f9$var$deprecated,
    deprecatedObjectProperty: ()=>$19d34ba43ba6e6f9$var$deprecatedObjectProperty,
    deprecatedProperty: ()=>$19d34ba43ba6e6f9$var$deprecatedProperty
});
module.exports = $19d34ba43ba6e6f9$var$__toCommonJS($19d34ba43ba6e6f9$var$deprecated_exports);
// src/utils/runtimeEnvironment.ts
var $19d34ba43ba6e6f9$var$isTestEnvironment = ()=>{
    try {
        return false;
    } catch  {}
    return false;
};
var $19d34ba43ba6e6f9$var$isProductionEnvironment = ()=>{
    try {
        return true;
    } catch  {}
    return false;
};
// src/deprecated.ts
var $19d34ba43ba6e6f9$var$displayedWarnings = /* @__PURE__ */ new Set();
var $19d34ba43ba6e6f9$var$deprecated = (fnName, warning, key)=>{
    const hideWarning = $19d34ba43ba6e6f9$var$isTestEnvironment() || $19d34ba43ba6e6f9$var$isProductionEnvironment();
    const messageId = key ?? fnName;
    if ($19d34ba43ba6e6f9$var$displayedWarnings.has(messageId) || hideWarning) return;
    $19d34ba43ba6e6f9$var$displayedWarnings.add(messageId);
    console.warn(`Clerk - DEPRECATION WARNING: "${fnName}" is deprecated and will be removed in the next major release.
${warning}`);
};
var $19d34ba43ba6e6f9$var$deprecatedProperty = (cls, propName, warning, isStatic = false)=>{
    const target = isStatic ? cls : cls.prototype;
    let value = target[propName];
    Object.defineProperty(target, propName, {
        get () {
            $19d34ba43ba6e6f9$var$deprecated(propName, warning, `${cls.name}:${propName}`);
            return value;
        },
        set (v) {
            value = v;
        }
    });
};
var $19d34ba43ba6e6f9$var$deprecatedObjectProperty = (obj, propName, warning, key)=>{
    let value = obj[propName];
    Object.defineProperty(obj, propName, {
        get () {
            $19d34ba43ba6e6f9$var$deprecated(propName, warning, key);
            return value;
        },
        set (v) {
            value = v;
        }
    });
};

});

parcelRegister("kFYV7", function(module, exports) {
"use strict";
var $f0d6e47a53c67e2a$var$__defProp = Object.defineProperty;
var $f0d6e47a53c67e2a$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $f0d6e47a53c67e2a$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $f0d6e47a53c67e2a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $f0d6e47a53c67e2a$var$__export = (target, all)=>{
    for(var name in all)$f0d6e47a53c67e2a$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $f0d6e47a53c67e2a$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $f0d6e47a53c67e2a$var$__getOwnPropNames(from))if (!$f0d6e47a53c67e2a$var$__hasOwnProp.call(to, key) && key !== except) $f0d6e47a53c67e2a$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $f0d6e47a53c67e2a$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $f0d6e47a53c67e2a$var$__toCommonJS = (mod)=>$f0d6e47a53c67e2a$var$__copyProps($f0d6e47a53c67e2a$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
// src/authorization.ts
var $f0d6e47a53c67e2a$var$authorization_exports = {};
$f0d6e47a53c67e2a$var$__export($f0d6e47a53c67e2a$var$authorization_exports, {
    createCheckAuthorization: ()=>$f0d6e47a53c67e2a$var$createCheckAuthorization,
    validateReverificationConfig: ()=>$f0d6e47a53c67e2a$var$validateReverificationConfig
});
module.exports = $f0d6e47a53c67e2a$var$__toCommonJS($f0d6e47a53c67e2a$var$authorization_exports);
var $f0d6e47a53c67e2a$var$TYPES_TO_OBJECTS = {
    strict_mfa: {
        afterMinutes: 10,
        level: "multi_factor"
    },
    strict: {
        afterMinutes: 10,
        level: "second_factor"
    },
    moderate: {
        afterMinutes: 60,
        level: "second_factor"
    },
    lax: {
        afterMinutes: 1440,
        level: "second_factor"
    }
};
var $f0d6e47a53c67e2a$var$ALLOWED_LEVELS = /* @__PURE__ */ new Set([
    "first_factor",
    "second_factor",
    "multi_factor"
]);
var $f0d6e47a53c67e2a$var$ALLOWED_TYPES = /* @__PURE__ */ new Set([
    "strict_mfa",
    "strict",
    "moderate",
    "lax"
]);
var $f0d6e47a53c67e2a$var$isValidMaxAge = (maxAge)=>typeof maxAge === "number" && maxAge > 0;
var $f0d6e47a53c67e2a$var$isValidLevel = (level)=>$f0d6e47a53c67e2a$var$ALLOWED_LEVELS.has(level);
var $f0d6e47a53c67e2a$var$isValidVerificationType = (type)=>$f0d6e47a53c67e2a$var$ALLOWED_TYPES.has(type);
var $f0d6e47a53c67e2a$var$checkOrgAuthorization = (params, options)=>{
    const { orgId: orgId, orgRole: orgRole, orgPermissions: orgPermissions } = options;
    if (!params.role && !params.permission) return null;
    if (!orgId || !orgRole || !orgPermissions) return null;
    if (params.permission) return orgPermissions.includes(params.permission);
    if (params.role) return orgRole === params.role;
    return null;
};
var $f0d6e47a53c67e2a$var$validateReverificationConfig = (config)=>{
    if (!config) return false;
    const convertConfigToObject = (config2)=>{
        if (typeof config2 === "string") return $f0d6e47a53c67e2a$var$TYPES_TO_OBJECTS[config2];
        return config2;
    };
    const isValidStringValue = typeof config === "string" && $f0d6e47a53c67e2a$var$isValidVerificationType(config);
    const isValidObjectValue = typeof config === "object" && $f0d6e47a53c67e2a$var$isValidLevel(config.level) && $f0d6e47a53c67e2a$var$isValidMaxAge(config.afterMinutes);
    if (isValidStringValue || isValidObjectValue) return convertConfigToObject.bind(null, config);
    return false;
};
var $f0d6e47a53c67e2a$var$checkStepUpAuthorization = (params, { factorVerificationAge: factorVerificationAge })=>{
    if (!params.reverification || !factorVerificationAge) return null;
    const isValidReverification = $f0d6e47a53c67e2a$var$validateReverificationConfig(params.reverification);
    if (!isValidReverification) return null;
    const { level: level, afterMinutes: afterMinutes } = isValidReverification();
    const [factor1Age, factor2Age] = factorVerificationAge;
    const isValidFactor1 = factor1Age !== -1 ? afterMinutes > factor1Age : null;
    const isValidFactor2 = factor2Age !== -1 ? afterMinutes > factor2Age : null;
    switch(level){
        case "first_factor":
            return isValidFactor1;
        case "second_factor":
            return factor2Age !== -1 ? isValidFactor2 : isValidFactor1;
        case "multi_factor":
            return factor2Age === -1 ? isValidFactor1 : isValidFactor1 && isValidFactor2;
    }
};
var $f0d6e47a53c67e2a$var$createCheckAuthorization = (options)=>{
    return (params)=>{
        if (!options.userId) return false;
        const orgAuthorization = $f0d6e47a53c67e2a$var$checkOrgAuthorization(params, options);
        const stepUpAuthorization = $f0d6e47a53c67e2a$var$checkStepUpAuthorization(params, options);
        if ([
            orgAuthorization,
            stepUpAuthorization
        ].some((a)=>a === null)) return [
            orgAuthorization,
            stepUpAuthorization
        ].some((a)=>a === true);
        return [
            orgAuthorization,
            stepUpAuthorization
        ].every((a)=>a === true);
    };
};

});

parcelRegister("4cJom", function(module, exports) {

var $2Prz7 = parcelRequire("2Prz7");
"use strict";
var $30fb7e52f6de4123$var$__defProp = Object.defineProperty;
var $30fb7e52f6de4123$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $30fb7e52f6de4123$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $30fb7e52f6de4123$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $30fb7e52f6de4123$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $30fb7e52f6de4123$var$__export = (target, all)=>{
    for(var name in all)$30fb7e52f6de4123$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $30fb7e52f6de4123$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $30fb7e52f6de4123$var$__getOwnPropNames(from))if (!$30fb7e52f6de4123$var$__hasOwnProp.call(to, key) && key !== except) $30fb7e52f6de4123$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $30fb7e52f6de4123$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $30fb7e52f6de4123$var$__toCommonJS = (mod)=>$30fb7e52f6de4123$var$__copyProps($30fb7e52f6de4123$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
var $30fb7e52f6de4123$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $30fb7e52f6de4123$var$__typeError("Cannot " + msg);
var $30fb7e52f6de4123$var$__privateGet = (obj, member, getter)=>($30fb7e52f6de4123$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $30fb7e52f6de4123$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $30fb7e52f6de4123$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $30fb7e52f6de4123$var$__privateSet = (obj, member, value, setter)=>($30fb7e52f6de4123$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var $30fb7e52f6de4123$var$__privateMethod = (obj, member, method)=>($30fb7e52f6de4123$var$__accessCheck(obj, member, "access private method"), method);
// src/telemetry.ts
var $30fb7e52f6de4123$var$telemetry_exports = {};
$30fb7e52f6de4123$var$__export($30fb7e52f6de4123$var$telemetry_exports, {
    TelemetryCollector: ()=>$30fb7e52f6de4123$var$TelemetryCollector,
    eventComponentMounted: ()=>$30fb7e52f6de4123$var$eventComponentMounted,
    eventMethodCalled: ()=>$30fb7e52f6de4123$var$eventMethodCalled,
    eventPrebuiltComponentMounted: ()=>$30fb7e52f6de4123$var$eventPrebuiltComponentMounted
});
module.exports = $30fb7e52f6de4123$var$__toCommonJS($30fb7e52f6de4123$var$telemetry_exports);
// src/isomorphicAtob.ts
var $30fb7e52f6de4123$var$isomorphicAtob = (data)=>{
    if (typeof atob !== "undefined" && typeof atob === "function") return atob(data);
    else if (typeof $parcel$global !== "undefined" && $parcel$global.Buffer) return new $parcel$global.Buffer(data, "base64").toString();
    return data;
};
// src/keys.ts
var $30fb7e52f6de4123$var$PUBLISHABLE_KEY_LIVE_PREFIX = "pk_live_";
var $30fb7e52f6de4123$var$PUBLISHABLE_KEY_TEST_PREFIX = "pk_test_";
function $30fb7e52f6de4123$var$parsePublishableKey(key, options = {}) {
    key = key || "";
    if (!key || !$30fb7e52f6de4123$var$isPublishableKey(key)) {
        if (options.fatal && !key) throw new Error("Publishable key is missing. Ensure that your publishable key is correctly configured. Double-check your environment configuration for your keys, or access them here: https://dashboard.clerk.com/last-active?path=api-keys");
        if (options.fatal && !$30fb7e52f6de4123$var$isPublishableKey(key)) throw new Error("Publishable key not valid.");
        return null;
    }
    const instanceType = key.startsWith($30fb7e52f6de4123$var$PUBLISHABLE_KEY_LIVE_PREFIX) ? "production" : "development";
    let frontendApi = $30fb7e52f6de4123$var$isomorphicAtob(key.split("_")[2]);
    frontendApi = frontendApi.slice(0, -1);
    if (options.proxyUrl) frontendApi = options.proxyUrl;
    else if (instanceType !== "development" && options.domain) frontendApi = `clerk.${options.domain}`;
    return {
        instanceType: instanceType,
        frontendApi: frontendApi
    };
}
function $30fb7e52f6de4123$var$isPublishableKey(key = "") {
    try {
        const hasValidPrefix = key.startsWith($30fb7e52f6de4123$var$PUBLISHABLE_KEY_LIVE_PREFIX) || key.startsWith($30fb7e52f6de4123$var$PUBLISHABLE_KEY_TEST_PREFIX);
        const hasValidFrontendApiPostfix = $30fb7e52f6de4123$var$isomorphicAtob(key.split("_")[2] || "").endsWith("$");
        return hasValidPrefix && hasValidFrontendApiPostfix;
    } catch  {
        return false;
    }
}
// src/underscore.ts
function $30fb7e52f6de4123$var$snakeToCamel(str) {
    return str ? str.replace(/([-_][a-z])/g, (match)=>match.toUpperCase().replace(/-|_/, "")) : "";
}
function $30fb7e52f6de4123$var$camelToSnake(str) {
    return str ? str.replace(/[A-Z]/g, (letter)=>`_${letter.toLowerCase()}`) : "";
}
var $30fb7e52f6de4123$var$createDeepObjectTransformer = (transform)=>{
    const deepTransform = (obj)=>{
        if (!obj) return obj;
        if (Array.isArray(obj)) return obj.map((el)=>{
            if (typeof el === "object" || Array.isArray(el)) return deepTransform(el);
            return el;
        });
        const copy = {
            ...obj
        };
        const keys = Object.keys(copy);
        for (const oldName of keys){
            const newName = transform(oldName.toString());
            if (newName !== oldName) {
                copy[newName] = copy[oldName];
                delete copy[oldName];
            }
            if (typeof copy[newName] === "object") copy[newName] = deepTransform(copy[newName]);
        }
        return copy;
    };
    return deepTransform;
};
var $30fb7e52f6de4123$var$deepCamelToSnake = $30fb7e52f6de4123$var$createDeepObjectTransformer($30fb7e52f6de4123$var$camelToSnake);
var $30fb7e52f6de4123$var$deepSnakeToCamel = $30fb7e52f6de4123$var$createDeepObjectTransformer($30fb7e52f6de4123$var$snakeToCamel);
function $30fb7e52f6de4123$var$isTruthy(value) {
    if (typeof value === `boolean`) return value;
    if (value === void 0 || value === null) return false;
    if (typeof value === `string`) {
        if (value.toLowerCase() === `true`) return true;
        if (value.toLowerCase() === `false`) return false;
    }
    const number = parseInt(value, 10);
    if (isNaN(number)) return false;
    if (number > 0) return true;
    return false;
}
// src/telemetry/throttler.ts
var $30fb7e52f6de4123$var$DEFAULT_CACHE_TTL_MS = 864e5;
var $30fb7e52f6de4123$var$_storageKey, $30fb7e52f6de4123$var$_cacheTtl, $30fb7e52f6de4123$var$_TelemetryEventThrottler_instances, $30fb7e52f6de4123$var$generateKey_fn, $30fb7e52f6de4123$var$cache_get, $30fb7e52f6de4123$var$isValidBrowser_get;
var $30fb7e52f6de4123$var$TelemetryEventThrottler = class {
    constructor(){
        $30fb7e52f6de4123$var$__privateAdd(this, $30fb7e52f6de4123$var$_TelemetryEventThrottler_instances);
        $30fb7e52f6de4123$var$__privateAdd(this, $30fb7e52f6de4123$var$_storageKey, "clerk_telemetry_throttler");
        $30fb7e52f6de4123$var$__privateAdd(this, $30fb7e52f6de4123$var$_cacheTtl, $30fb7e52f6de4123$var$DEFAULT_CACHE_TTL_MS);
    }
    isEventThrottled(payload) {
        if (!$30fb7e52f6de4123$var$__privateGet(this, $30fb7e52f6de4123$var$_TelemetryEventThrottler_instances, $30fb7e52f6de4123$var$isValidBrowser_get)) return false;
        const now = Date.now();
        const key = $30fb7e52f6de4123$var$__privateMethod(this, $30fb7e52f6de4123$var$_TelemetryEventThrottler_instances, $30fb7e52f6de4123$var$generateKey_fn).call(this, payload);
        const entry = $30fb7e52f6de4123$var$__privateGet(this, $30fb7e52f6de4123$var$_TelemetryEventThrottler_instances, $30fb7e52f6de4123$var$cache_get)?.[key];
        if (!entry) {
            const updatedCache = {
                ...$30fb7e52f6de4123$var$__privateGet(this, $30fb7e52f6de4123$var$_TelemetryEventThrottler_instances, $30fb7e52f6de4123$var$cache_get),
                [key]: now
            };
            localStorage.setItem($30fb7e52f6de4123$var$__privateGet(this, $30fb7e52f6de4123$var$_storageKey), JSON.stringify(updatedCache));
        }
        const shouldInvalidate = entry && now - entry > $30fb7e52f6de4123$var$__privateGet(this, $30fb7e52f6de4123$var$_cacheTtl);
        if (shouldInvalidate) {
            const updatedCache = $30fb7e52f6de4123$var$__privateGet(this, $30fb7e52f6de4123$var$_TelemetryEventThrottler_instances, $30fb7e52f6de4123$var$cache_get);
            delete updatedCache[key];
            localStorage.setItem($30fb7e52f6de4123$var$__privateGet(this, $30fb7e52f6de4123$var$_storageKey), JSON.stringify(updatedCache));
        }
        return !!entry;
    }
};
$30fb7e52f6de4123$var$_storageKey = new WeakMap();
$30fb7e52f6de4123$var$_cacheTtl = new WeakMap();
$30fb7e52f6de4123$var$_TelemetryEventThrottler_instances = new WeakSet();
/**
 * Generates a consistent unique key for telemetry events by sorting payload properties.
 * This ensures that payloads with identical content in different orders produce the same key.
 */ $30fb7e52f6de4123$var$generateKey_fn = function(event) {
    const { sk: _sk, pk: _pk, payload: payload, ...rest } = event;
    const sanitizedEvent = {
        ...payload,
        ...rest
    };
    return JSON.stringify(Object.keys({
        ...payload,
        ...rest
    }).sort().map((key)=>sanitizedEvent[key]));
};
$30fb7e52f6de4123$var$cache_get = function() {
    const cacheString = localStorage.getItem($30fb7e52f6de4123$var$__privateGet(this, $30fb7e52f6de4123$var$_storageKey));
    if (!cacheString) return {};
    return JSON.parse(cacheString);
};
$30fb7e52f6de4123$var$isValidBrowser_get = function() {
    if (typeof window === "undefined") return false;
    const storage = window.localStorage;
    if (!storage) return false;
    try {
        const testKey = "test";
        storage.setItem(testKey, testKey);
        storage.removeItem(testKey);
        return true;
    } catch (err) {
        const isQuotaExceededError = err instanceof DOMException && // Check error names for different browsers
        (err.name === "QuotaExceededError" || err.name === "NS_ERROR_DOM_QUOTA_REACHED");
        if (isQuotaExceededError && storage.length > 0) storage.removeItem($30fb7e52f6de4123$var$__privateGet(this, $30fb7e52f6de4123$var$_storageKey));
        return false;
    }
};
// src/telemetry/collector.ts
var $30fb7e52f6de4123$var$DEFAULT_CONFIG = {
    samplingRate: 1,
    maxBufferSize: 5,
    // Production endpoint: https://clerk-telemetry.com
    // Staging endpoint: https://staging.clerk-telemetry.com
    // Local: http://localhost:8787
    endpoint: "https://clerk-telemetry.com"
};
var $30fb7e52f6de4123$var$_config, $30fb7e52f6de4123$var$_eventThrottler, $30fb7e52f6de4123$var$_metadata, $30fb7e52f6de4123$var$_buffer, $30fb7e52f6de4123$var$_pendingFlush, $30fb7e52f6de4123$var$_TelemetryCollector_instances, $30fb7e52f6de4123$var$shouldRecord_fn, $30fb7e52f6de4123$var$shouldBeSampled_fn, $30fb7e52f6de4123$var$scheduleFlush_fn, $30fb7e52f6de4123$var$flush_fn, $30fb7e52f6de4123$var$logEvent_fn, $30fb7e52f6de4123$var$getSDKMetadata_fn, $30fb7e52f6de4123$var$preparePayload_fn;
var $30fb7e52f6de4123$var$TelemetryCollector = class {
    constructor(options){
        $30fb7e52f6de4123$var$__privateAdd(this, $30fb7e52f6de4123$var$_TelemetryCollector_instances);
        $30fb7e52f6de4123$var$__privateAdd(this, $30fb7e52f6de4123$var$_config);
        $30fb7e52f6de4123$var$__privateAdd(this, $30fb7e52f6de4123$var$_eventThrottler);
        $30fb7e52f6de4123$var$__privateAdd(this, $30fb7e52f6de4123$var$_metadata, {});
        $30fb7e52f6de4123$var$__privateAdd(this, $30fb7e52f6de4123$var$_buffer, []);
        $30fb7e52f6de4123$var$__privateAdd(this, $30fb7e52f6de4123$var$_pendingFlush);
        $30fb7e52f6de4123$var$__privateSet(this, $30fb7e52f6de4123$var$_config, {
            maxBufferSize: options.maxBufferSize ?? $30fb7e52f6de4123$var$DEFAULT_CONFIG.maxBufferSize,
            samplingRate: options.samplingRate ?? $30fb7e52f6de4123$var$DEFAULT_CONFIG.samplingRate,
            disabled: options.disabled ?? false,
            debug: options.debug ?? false,
            endpoint: $30fb7e52f6de4123$var$DEFAULT_CONFIG.endpoint
        });
        if (!options.clerkVersion && typeof window === "undefined") $30fb7e52f6de4123$var$__privateGet(this, $30fb7e52f6de4123$var$_metadata).clerkVersion = "";
        else $30fb7e52f6de4123$var$__privateGet(this, $30fb7e52f6de4123$var$_metadata).clerkVersion = options.clerkVersion ?? "";
        $30fb7e52f6de4123$var$__privateGet(this, $30fb7e52f6de4123$var$_metadata).sdk = options.sdk;
        $30fb7e52f6de4123$var$__privateGet(this, $30fb7e52f6de4123$var$_metadata).sdkVersion = options.sdkVersion;
        $30fb7e52f6de4123$var$__privateGet(this, $30fb7e52f6de4123$var$_metadata).publishableKey = options.publishableKey ?? "";
        const parsedKey = $30fb7e52f6de4123$var$parsePublishableKey(options.publishableKey);
        if (parsedKey) $30fb7e52f6de4123$var$__privateGet(this, $30fb7e52f6de4123$var$_metadata).instanceType = parsedKey.instanceType;
        if (options.secretKey) $30fb7e52f6de4123$var$__privateGet(this, $30fb7e52f6de4123$var$_metadata).secretKey = options.secretKey.substring(0, 16);
        $30fb7e52f6de4123$var$__privateSet(this, $30fb7e52f6de4123$var$_eventThrottler, new $30fb7e52f6de4123$var$TelemetryEventThrottler());
    }
    get isEnabled() {
        if ($30fb7e52f6de4123$var$__privateGet(this, $30fb7e52f6de4123$var$_metadata).instanceType !== "development") return false;
        if ($30fb7e52f6de4123$var$__privateGet(this, $30fb7e52f6de4123$var$_config).disabled || typeof $2Prz7 !== "undefined" && $30fb7e52f6de4123$var$isTruthy(undefined)) return false;
        if (typeof window !== "undefined" && !!window?.navigator?.webdriver) return false;
        return true;
    }
    get isDebug() {
        return $30fb7e52f6de4123$var$__privateGet(this, $30fb7e52f6de4123$var$_config).debug || typeof $2Prz7 !== "undefined" && $30fb7e52f6de4123$var$isTruthy(undefined);
    }
    record(event) {
        const preparedPayload = $30fb7e52f6de4123$var$__privateMethod(this, $30fb7e52f6de4123$var$_TelemetryCollector_instances, $30fb7e52f6de4123$var$preparePayload_fn).call(this, event.event, event.payload);
        $30fb7e52f6de4123$var$__privateMethod(this, $30fb7e52f6de4123$var$_TelemetryCollector_instances, $30fb7e52f6de4123$var$logEvent_fn).call(this, preparedPayload.event, preparedPayload);
        if (!$30fb7e52f6de4123$var$__privateMethod(this, $30fb7e52f6de4123$var$_TelemetryCollector_instances, $30fb7e52f6de4123$var$shouldRecord_fn).call(this, preparedPayload, event.eventSamplingRate)) return;
        $30fb7e52f6de4123$var$__privateGet(this, $30fb7e52f6de4123$var$_buffer).push(preparedPayload);
        $30fb7e52f6de4123$var$__privateMethod(this, $30fb7e52f6de4123$var$_TelemetryCollector_instances, $30fb7e52f6de4123$var$scheduleFlush_fn).call(this);
    }
};
$30fb7e52f6de4123$var$_config = new WeakMap();
$30fb7e52f6de4123$var$_eventThrottler = new WeakMap();
$30fb7e52f6de4123$var$_metadata = new WeakMap();
$30fb7e52f6de4123$var$_buffer = new WeakMap();
$30fb7e52f6de4123$var$_pendingFlush = new WeakMap();
$30fb7e52f6de4123$var$_TelemetryCollector_instances = new WeakSet();
$30fb7e52f6de4123$var$shouldRecord_fn = function(preparedPayload, eventSamplingRate) {
    return this.isEnabled && !this.isDebug && $30fb7e52f6de4123$var$__privateMethod(this, $30fb7e52f6de4123$var$_TelemetryCollector_instances, $30fb7e52f6de4123$var$shouldBeSampled_fn).call(this, preparedPayload, eventSamplingRate);
};
$30fb7e52f6de4123$var$shouldBeSampled_fn = function(preparedPayload, eventSamplingRate) {
    const randomSeed = Math.random();
    if ($30fb7e52f6de4123$var$__privateGet(this, $30fb7e52f6de4123$var$_eventThrottler).isEventThrottled(preparedPayload)) return false;
    return randomSeed <= $30fb7e52f6de4123$var$__privateGet(this, $30fb7e52f6de4123$var$_config).samplingRate && (typeof eventSamplingRate === "undefined" || randomSeed <= eventSamplingRate);
};
$30fb7e52f6de4123$var$scheduleFlush_fn = function() {
    if (typeof window === "undefined") {
        $30fb7e52f6de4123$var$__privateMethod(this, $30fb7e52f6de4123$var$_TelemetryCollector_instances, $30fb7e52f6de4123$var$flush_fn).call(this);
        return;
    }
    const isBufferFull = $30fb7e52f6de4123$var$__privateGet(this, $30fb7e52f6de4123$var$_buffer).length >= $30fb7e52f6de4123$var$__privateGet(this, $30fb7e52f6de4123$var$_config).maxBufferSize;
    if (isBufferFull) {
        if ($30fb7e52f6de4123$var$__privateGet(this, $30fb7e52f6de4123$var$_pendingFlush)) {
            const cancel = typeof cancelIdleCallback !== "undefined" ? cancelIdleCallback : clearTimeout;
            cancel($30fb7e52f6de4123$var$__privateGet(this, $30fb7e52f6de4123$var$_pendingFlush));
        }
        $30fb7e52f6de4123$var$__privateMethod(this, $30fb7e52f6de4123$var$_TelemetryCollector_instances, $30fb7e52f6de4123$var$flush_fn).call(this);
        return;
    }
    if ($30fb7e52f6de4123$var$__privateGet(this, $30fb7e52f6de4123$var$_pendingFlush)) return;
    if ("requestIdleCallback" in window) $30fb7e52f6de4123$var$__privateSet(this, $30fb7e52f6de4123$var$_pendingFlush, requestIdleCallback(()=>{
        $30fb7e52f6de4123$var$__privateMethod(this, $30fb7e52f6de4123$var$_TelemetryCollector_instances, $30fb7e52f6de4123$var$flush_fn).call(this);
    }));
    else $30fb7e52f6de4123$var$__privateSet(this, $30fb7e52f6de4123$var$_pendingFlush, setTimeout(()=>{
        $30fb7e52f6de4123$var$__privateMethod(this, $30fb7e52f6de4123$var$_TelemetryCollector_instances, $30fb7e52f6de4123$var$flush_fn).call(this);
    }, 0));
};
$30fb7e52f6de4123$var$flush_fn = function() {
    fetch(new URL("/v1/event", $30fb7e52f6de4123$var$__privateGet(this, $30fb7e52f6de4123$var$_config).endpoint), {
        method: "POST",
        // TODO: We send an array here with that idea that we can eventually send multiple events.
        body: JSON.stringify({
            events: $30fb7e52f6de4123$var$__privateGet(this, $30fb7e52f6de4123$var$_buffer)
        }),
        headers: {
            "Content-Type": "application/json"
        }
    }).catch(()=>void 0).then(()=>{
        $30fb7e52f6de4123$var$__privateSet(this, $30fb7e52f6de4123$var$_buffer, []);
    }).catch(()=>void 0);
};
/**
 * If running in debug mode, log the event and its payload to the console.
 */ $30fb7e52f6de4123$var$logEvent_fn = function(event, payload) {
    if (!this.isDebug) return;
    if (typeof console.groupCollapsed !== "undefined") {
        console.groupCollapsed("[clerk/telemetry]", event);
        console.log(payload);
        console.groupEnd();
    } else console.log("[clerk/telemetry]", event, payload);
};
/**
 * If in browser, attempt to lazily grab the SDK metadata from the Clerk singleton, otherwise fallback to the initially passed in values.
 *
 * This is necessary because the sdkMetadata can be set by the host SDK after the TelemetryCollector is instantiated.
 */ $30fb7e52f6de4123$var$getSDKMetadata_fn = function() {
    let sdkMetadata = {
        name: $30fb7e52f6de4123$var$__privateGet(this, $30fb7e52f6de4123$var$_metadata).sdk,
        version: $30fb7e52f6de4123$var$__privateGet(this, $30fb7e52f6de4123$var$_metadata).sdkVersion
    };
    if (typeof window !== "undefined" && window.Clerk) sdkMetadata = {
        ...sdkMetadata,
        ...window.Clerk.constructor.sdkMetadata
    };
    return sdkMetadata;
};
/**
 * Append relevant metadata from the Clerk singleton to the event payload.
 */ $30fb7e52f6de4123$var$preparePayload_fn = function(event, payload) {
    const sdkMetadata = $30fb7e52f6de4123$var$__privateMethod(this, $30fb7e52f6de4123$var$_TelemetryCollector_instances, $30fb7e52f6de4123$var$getSDKMetadata_fn).call(this);
    return {
        event: event,
        cv: $30fb7e52f6de4123$var$__privateGet(this, $30fb7e52f6de4123$var$_metadata).clerkVersion ?? "",
        it: $30fb7e52f6de4123$var$__privateGet(this, $30fb7e52f6de4123$var$_metadata).instanceType ?? "",
        sdk: sdkMetadata.name,
        sdkv: sdkMetadata.version,
        ...$30fb7e52f6de4123$var$__privateGet(this, $30fb7e52f6de4123$var$_metadata).publishableKey ? {
            pk: $30fb7e52f6de4123$var$__privateGet(this, $30fb7e52f6de4123$var$_metadata).publishableKey
        } : {},
        ...$30fb7e52f6de4123$var$__privateGet(this, $30fb7e52f6de4123$var$_metadata).secretKey ? {
            sk: $30fb7e52f6de4123$var$__privateGet(this, $30fb7e52f6de4123$var$_metadata).secretKey
        } : {},
        payload: payload
    };
};
// src/telemetry/events/component-mounted.ts
var $30fb7e52f6de4123$var$EVENT_COMPONENT_MOUNTED = "COMPONENT_MOUNTED";
var $30fb7e52f6de4123$var$EVENT_SAMPLING_RATE = 0.1;
function $30fb7e52f6de4123$var$eventPrebuiltComponentMounted(component, props, additionalPayload) {
    return {
        event: $30fb7e52f6de4123$var$EVENT_COMPONENT_MOUNTED,
        eventSamplingRate: $30fb7e52f6de4123$var$EVENT_SAMPLING_RATE,
        payload: {
            component: component,
            appearanceProp: Boolean(props?.appearance),
            baseTheme: Boolean(props?.appearance?.baseTheme),
            elements: Boolean(props?.appearance?.elements),
            variables: Boolean(props?.appearance?.variables),
            ...additionalPayload
        }
    };
}
function $30fb7e52f6de4123$var$eventComponentMounted(component, props = {}) {
    return {
        event: $30fb7e52f6de4123$var$EVENT_COMPONENT_MOUNTED,
        eventSamplingRate: $30fb7e52f6de4123$var$EVENT_SAMPLING_RATE,
        payload: {
            component: component,
            ...props
        }
    };
}
// src/telemetry/events/method-called.ts
var $30fb7e52f6de4123$var$EVENT_METHOD_CALLED = "METHOD_CALLED";
function $30fb7e52f6de4123$var$eventMethodCalled(method, payload) {
    return {
        event: $30fb7e52f6de4123$var$EVENT_METHOD_CALLED,
        payload: {
            method: method,
            ...payload
        }
    };
}

});

parcelRegister("3jKgV", function(module, exports) {
"use strict";
var $26a70a1bd2ff1ecb$var$__defProp = Object.defineProperty;
var $26a70a1bd2ff1ecb$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $26a70a1bd2ff1ecb$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $26a70a1bd2ff1ecb$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $26a70a1bd2ff1ecb$var$__export = (target, all)=>{
    for(var name in all)$26a70a1bd2ff1ecb$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $26a70a1bd2ff1ecb$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $26a70a1bd2ff1ecb$var$__getOwnPropNames(from))if (!$26a70a1bd2ff1ecb$var$__hasOwnProp.call(to, key) && key !== except) $26a70a1bd2ff1ecb$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $26a70a1bd2ff1ecb$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $26a70a1bd2ff1ecb$var$__toCommonJS = (mod)=>$26a70a1bd2ff1ecb$var$__copyProps($26a70a1bd2ff1ecb$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
// src/keys.ts
var $26a70a1bd2ff1ecb$var$keys_exports = {};
$26a70a1bd2ff1ecb$var$__export($26a70a1bd2ff1ecb$var$keys_exports, {
    buildPublishableKey: ()=>$26a70a1bd2ff1ecb$var$buildPublishableKey,
    createDevOrStagingUrlCache: ()=>$26a70a1bd2ff1ecb$var$createDevOrStagingUrlCache,
    getCookieSuffix: ()=>$26a70a1bd2ff1ecb$var$getCookieSuffix,
    getSuffixedCookieName: ()=>$26a70a1bd2ff1ecb$var$getSuffixedCookieName,
    isDevelopmentFromPublishableKey: ()=>$26a70a1bd2ff1ecb$var$isDevelopmentFromPublishableKey,
    isDevelopmentFromSecretKey: ()=>$26a70a1bd2ff1ecb$var$isDevelopmentFromSecretKey,
    isProductionFromPublishableKey: ()=>$26a70a1bd2ff1ecb$var$isProductionFromPublishableKey,
    isProductionFromSecretKey: ()=>$26a70a1bd2ff1ecb$var$isProductionFromSecretKey,
    isPublishableKey: ()=>$26a70a1bd2ff1ecb$var$isPublishableKey,
    parsePublishableKey: ()=>$26a70a1bd2ff1ecb$var$parsePublishableKey
});
module.exports = $26a70a1bd2ff1ecb$var$__toCommonJS($26a70a1bd2ff1ecb$var$keys_exports);
// src/constants.ts
var $26a70a1bd2ff1ecb$var$LEGACY_DEV_INSTANCE_SUFFIXES = [
    ".lcl.dev",
    ".lclstage.dev",
    ".lclclerk.com"
];
var $26a70a1bd2ff1ecb$var$DEV_OR_STAGING_SUFFIXES = [
    ".lcl.dev",
    ".stg.dev",
    ".lclstage.dev",
    ".stgstage.dev",
    ".dev.lclclerk.com",
    ".stg.lclclerk.com",
    ".accounts.lclclerk.com",
    "accountsstage.dev",
    "accounts.dev"
];
// src/isomorphicAtob.ts
var $26a70a1bd2ff1ecb$var$isomorphicAtob = (data)=>{
    if (typeof atob !== "undefined" && typeof atob === "function") return atob(data);
    else if (typeof $parcel$global !== "undefined" && $parcel$global.Buffer) return new $parcel$global.Buffer(data, "base64").toString();
    return data;
};
// src/isomorphicBtoa.ts
var $26a70a1bd2ff1ecb$var$isomorphicBtoa = (data)=>{
    if (typeof btoa !== "undefined" && typeof btoa === "function") return btoa(data);
    else if (typeof $parcel$global !== "undefined" && $parcel$global.Buffer) return new $parcel$global.Buffer(data).toString("base64");
    return data;
};
// src/keys.ts
var $26a70a1bd2ff1ecb$var$PUBLISHABLE_KEY_LIVE_PREFIX = "pk_live_";
var $26a70a1bd2ff1ecb$var$PUBLISHABLE_KEY_TEST_PREFIX = "pk_test_";
var $26a70a1bd2ff1ecb$var$PUBLISHABLE_FRONTEND_API_DEV_REGEX = /^(([a-z]+)-){2}([0-9]{1,2})\.clerk\.accounts([a-z.]*)(dev|com)$/i;
function $26a70a1bd2ff1ecb$var$buildPublishableKey(frontendApi) {
    const isDevKey = $26a70a1bd2ff1ecb$var$PUBLISHABLE_FRONTEND_API_DEV_REGEX.test(frontendApi) || frontendApi.startsWith("clerk.") && $26a70a1bd2ff1ecb$var$LEGACY_DEV_INSTANCE_SUFFIXES.some((s)=>frontendApi.endsWith(s));
    const keyPrefix = isDevKey ? $26a70a1bd2ff1ecb$var$PUBLISHABLE_KEY_TEST_PREFIX : $26a70a1bd2ff1ecb$var$PUBLISHABLE_KEY_LIVE_PREFIX;
    return `${keyPrefix}${$26a70a1bd2ff1ecb$var$isomorphicBtoa(`${frontendApi}$`)}`;
}
function $26a70a1bd2ff1ecb$var$parsePublishableKey(key, options = {}) {
    key = key || "";
    if (!key || !$26a70a1bd2ff1ecb$var$isPublishableKey(key)) {
        if (options.fatal && !key) throw new Error("Publishable key is missing. Ensure that your publishable key is correctly configured. Double-check your environment configuration for your keys, or access them here: https://dashboard.clerk.com/last-active?path=api-keys");
        if (options.fatal && !$26a70a1bd2ff1ecb$var$isPublishableKey(key)) throw new Error("Publishable key not valid.");
        return null;
    }
    const instanceType = key.startsWith($26a70a1bd2ff1ecb$var$PUBLISHABLE_KEY_LIVE_PREFIX) ? "production" : "development";
    let frontendApi = $26a70a1bd2ff1ecb$var$isomorphicAtob(key.split("_")[2]);
    frontendApi = frontendApi.slice(0, -1);
    if (options.proxyUrl) frontendApi = options.proxyUrl;
    else if (instanceType !== "development" && options.domain) frontendApi = `clerk.${options.domain}`;
    return {
        instanceType: instanceType,
        frontendApi: frontendApi
    };
}
function $26a70a1bd2ff1ecb$var$isPublishableKey(key = "") {
    try {
        const hasValidPrefix = key.startsWith($26a70a1bd2ff1ecb$var$PUBLISHABLE_KEY_LIVE_PREFIX) || key.startsWith($26a70a1bd2ff1ecb$var$PUBLISHABLE_KEY_TEST_PREFIX);
        const hasValidFrontendApiPostfix = $26a70a1bd2ff1ecb$var$isomorphicAtob(key.split("_")[2] || "").endsWith("$");
        return hasValidPrefix && hasValidFrontendApiPostfix;
    } catch  {
        return false;
    }
}
function $26a70a1bd2ff1ecb$var$createDevOrStagingUrlCache() {
    const devOrStagingUrlCache = /* @__PURE__ */ new Map();
    return {
        isDevOrStagingUrl: (url)=>{
            if (!url) return false;
            const hostname = typeof url === "string" ? url : url.hostname;
            let res = devOrStagingUrlCache.get(hostname);
            if (res === void 0) {
                res = $26a70a1bd2ff1ecb$var$DEV_OR_STAGING_SUFFIXES.some((s)=>hostname.endsWith(s));
                devOrStagingUrlCache.set(hostname, res);
            }
            return res;
        }
    };
}
function $26a70a1bd2ff1ecb$var$isDevelopmentFromPublishableKey(apiKey) {
    return apiKey.startsWith("test_") || apiKey.startsWith("pk_test_");
}
function $26a70a1bd2ff1ecb$var$isProductionFromPublishableKey(apiKey) {
    return apiKey.startsWith("live_") || apiKey.startsWith("pk_live_");
}
function $26a70a1bd2ff1ecb$var$isDevelopmentFromSecretKey(apiKey) {
    return apiKey.startsWith("test_") || apiKey.startsWith("sk_test_");
}
function $26a70a1bd2ff1ecb$var$isProductionFromSecretKey(apiKey) {
    return apiKey.startsWith("live_") || apiKey.startsWith("sk_live_");
}
async function $26a70a1bd2ff1ecb$var$getCookieSuffix(publishableKey, subtle = globalThis.crypto.subtle) {
    const data = new TextEncoder().encode(publishableKey);
    const digest = await subtle.digest("sha-1", data);
    const stringDigest = String.fromCharCode(...new Uint8Array(digest));
    return $26a70a1bd2ff1ecb$var$isomorphicBtoa(stringDigest).replace(/\+/gi, "-").replace(/\//gi, "_").substring(0, 8);
}
var $26a70a1bd2ff1ecb$var$getSuffixedCookieName = (cookieName, cookieSuffix)=>{
    return `${cookieName}_${cookieSuffix}`;
};

});

parcelRegister("3U9YZ", function(module, exports) {
"use strict";
var $2d7e5870d3d96b63$var$__defProp = Object.defineProperty;
var $2d7e5870d3d96b63$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $2d7e5870d3d96b63$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $2d7e5870d3d96b63$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $2d7e5870d3d96b63$var$__export = (target, all)=>{
    for(var name in all)$2d7e5870d3d96b63$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $2d7e5870d3d96b63$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $2d7e5870d3d96b63$var$__getOwnPropNames(from))if (!$2d7e5870d3d96b63$var$__hasOwnProp.call(to, key) && key !== except) $2d7e5870d3d96b63$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $2d7e5870d3d96b63$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $2d7e5870d3d96b63$var$__toCommonJS = (mod)=>$2d7e5870d3d96b63$var$__copyProps($2d7e5870d3d96b63$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
// src/deriveState.ts
var $2d7e5870d3d96b63$var$deriveState_exports = {};
$2d7e5870d3d96b63$var$__export($2d7e5870d3d96b63$var$deriveState_exports, {
    deriveState: ()=>$2d7e5870d3d96b63$var$deriveState
});
module.exports = $2d7e5870d3d96b63$var$__toCommonJS($2d7e5870d3d96b63$var$deriveState_exports);
var $2d7e5870d3d96b63$var$deriveState = (clerkLoaded, state, initialState)=>{
    if (!clerkLoaded && initialState) return $2d7e5870d3d96b63$var$deriveFromSsrInitialState(initialState);
    return $2d7e5870d3d96b63$var$deriveFromClientSideState(state);
};
var $2d7e5870d3d96b63$var$deriveFromSsrInitialState = (initialState)=>{
    const userId = initialState.userId;
    const user = initialState.user;
    const sessionId = initialState.sessionId;
    const session = initialState.session;
    const organization = initialState.organization;
    const orgId = initialState.orgId;
    const orgRole = initialState.orgRole;
    const orgPermissions = initialState.orgPermissions;
    const orgSlug = initialState.orgSlug;
    const actor = initialState.actor;
    const factorVerificationAge = initialState.factorVerificationAge;
    return {
        userId: userId,
        user: user,
        sessionId: sessionId,
        session: session,
        organization: organization,
        orgId: orgId,
        orgRole: orgRole,
        orgPermissions: orgPermissions,
        orgSlug: orgSlug,
        actor: actor,
        factorVerificationAge: factorVerificationAge
    };
};
var $2d7e5870d3d96b63$var$deriveFromClientSideState = (state)=>{
    const userId = state.user ? state.user.id : state.user;
    const user = state.user;
    const sessionId = state.session ? state.session.id : state.session;
    const session = state.session;
    const factorVerificationAge = state.session ? state.session.factorVerificationAge : null;
    const actor = session?.actor;
    const organization = state.organization;
    const orgId = state.organization ? state.organization.id : state.organization;
    const orgSlug = organization?.slug;
    const membership = organization ? user?.organizationMemberships?.find((om)=>om.organization.id === orgId) : organization;
    const orgPermissions = membership ? membership.permissions : membership;
    const orgRole = membership ? membership.role : membership;
    return {
        userId: userId,
        user: user,
        sessionId: sessionId,
        session: session,
        organization: organization,
        orgId: orgId,
        orgRole: orgRole,
        orgSlug: orgSlug,
        orgPermissions: orgPermissions,
        actor: actor,
        factorVerificationAge: factorVerificationAge
    };
};

});

parcelRegister("4PzIs", function(module, exports) {
"use strict";
var $3847a14ed334c11d$var$__defProp = Object.defineProperty;
var $3847a14ed334c11d$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $3847a14ed334c11d$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $3847a14ed334c11d$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $3847a14ed334c11d$var$__export = (target, all)=>{
    for(var name in all)$3847a14ed334c11d$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $3847a14ed334c11d$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $3847a14ed334c11d$var$__getOwnPropNames(from))if (!$3847a14ed334c11d$var$__hasOwnProp.call(to, key) && key !== except) $3847a14ed334c11d$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $3847a14ed334c11d$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $3847a14ed334c11d$var$__toCommonJS = (mod)=>$3847a14ed334c11d$var$__copyProps($3847a14ed334c11d$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
// src/browser.ts
var $3847a14ed334c11d$var$browser_exports = {};
$3847a14ed334c11d$var$__export($3847a14ed334c11d$var$browser_exports, {
    inBrowser: ()=>$3847a14ed334c11d$var$inBrowser,
    isBrowserOnline: ()=>$3847a14ed334c11d$var$isBrowserOnline,
    isValidBrowser: ()=>$3847a14ed334c11d$var$isValidBrowser,
    isValidBrowserOnline: ()=>$3847a14ed334c11d$var$isValidBrowserOnline,
    userAgentIsRobot: ()=>$3847a14ed334c11d$var$userAgentIsRobot
});
module.exports = $3847a14ed334c11d$var$__toCommonJS($3847a14ed334c11d$var$browser_exports);
function $3847a14ed334c11d$var$inBrowser() {
    return typeof window !== "undefined";
}
var $3847a14ed334c11d$var$botAgents = [
    "bot",
    "spider",
    "crawl",
    "APIs-Google",
    "AdsBot",
    "Googlebot",
    "mediapartners",
    "Google Favicon",
    "FeedFetcher",
    "Google-Read-Aloud",
    "DuplexWeb-Google",
    "googleweblight",
    "bing",
    "yandex",
    "baidu",
    "duckduck",
    "yahoo",
    "ecosia",
    "ia_archiver",
    "facebook",
    "instagram",
    "pinterest",
    "reddit",
    "slack",
    "twitter",
    "whatsapp",
    "youtube",
    "semrush"
];
var $3847a14ed334c11d$var$botAgentRegex = new RegExp($3847a14ed334c11d$var$botAgents.join("|"), "i");
function $3847a14ed334c11d$var$userAgentIsRobot(userAgent) {
    return !userAgent ? false : $3847a14ed334c11d$var$botAgentRegex.test(userAgent);
}
function $3847a14ed334c11d$var$isValidBrowser() {
    const navigator = $3847a14ed334c11d$var$inBrowser() ? window?.navigator : null;
    if (!navigator) return false;
    return !$3847a14ed334c11d$var$userAgentIsRobot(navigator?.userAgent) && !navigator?.webdriver;
}
function $3847a14ed334c11d$var$isBrowserOnline() {
    const navigator = $3847a14ed334c11d$var$inBrowser() ? window?.navigator : null;
    if (!navigator) return false;
    const isNavigatorOnline = navigator?.onLine;
    const isExperimentalConnectionOnline = navigator?.connection?.rtt !== 0 && navigator?.connection?.downlink !== 0;
    return isExperimentalConnectionOnline && isNavigatorOnline;
}
function $3847a14ed334c11d$var$isValidBrowserOnline() {
    return $3847a14ed334c11d$var$isBrowserOnline() && $3847a14ed334c11d$var$isValidBrowser();
}

});



parcelRegister("6okYk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a75409016da9a4d$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $fM2j4 = parcelRequire("fM2j4");

var $bIzWH = parcelRequire("bIzWH");

var $j2cRM = parcelRequire("j2cRM");

var $02LyB = parcelRequire("02LyB");
const $4a75409016da9a4d$var$messages = {
    needsSaving: "You have some unsaved changes.",
    saving: "Saving changes...",
    error: "Oh no! We couldn't save your changes.",
    success: "All saved :)",
    idle: "Nothing to save."
};
const $4a75409016da9a4d$var$colors = {
    needsSaving: "#009a81",
    saving: "#009a81",
    error: "#dc2d11",
    success: "#009a81",
    idle: "#009a81"
};
const $4a75409016da9a4d$var$icons = {
    needsSaving: "",
    saving: "fa-spinner fa-pulse",
    error: "fa-times",
    success: "fa-check",
    idle: ""
};
const $4a75409016da9a4d$var$buttonText = {
    needsSaving: "Save",
    error: "Try Again"
};
const $4a75409016da9a4d$var$buttonFunc = {
    needsSaving: (0, $fM2j4.default).startSave,
    error: (0, $fM2j4.default).retrySave
};
var $4a75409016da9a4d$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(()=>{
    const Animation = (0, $fM2j4.default).saveState === "error" ? (0, (/*@__PURE__*/$parcel$interopDefault($bIzWH))) : (0, (/*@__PURE__*/$parcel$interopDefault($j2cRM)));
    return /*#__PURE__*/ (0, $61Ea1.jsx)(Animation, {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("fixed top-14 w-full z-[1000] text-center pointer-events-none", (0, $fM2j4.default).saveState !== "idle" ? "block" : "hidden"),
            children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "save-bar dont-print bg-[#009a81] text-white w-[35%] mx-auto inline-block p-[0.5em] font-medium text-sm rounded-[0.5em]",
                style: {
                    backgroundColor: $4a75409016da9a4d$var$colors[(0, $fM2j4.default).saveState]
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("strong", {
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                className: "fa fa-fw " + $4a75409016da9a4d$var$icons[(0, $fM2j4.default).saveState]
                            }),
                            $4a75409016da9a4d$var$messages[(0, $fM2j4.default).saveState]
                        ]
                    }),
                    [
                        "needsSaving",
                        "error"
                    ].includes((0, $fM2j4.default).saveState) ? /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                        className: "save-bar__save-button px-[0.5em] rounded-[6px] bg-white border border-[#ccc] mx-[1em] text-444 cursor-pointer hover:bg-[#f0f0f0] pointer-events-auto",
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                            onClick: $4a75409016da9a4d$var$buttonFunc[(0, $fM2j4.default).saveState],
                            children: $4a75409016da9a4d$var$buttonText[(0, $fM2j4.default).saveState]
                        })
                    }) : null
                ]
            })
        })
    });
});

});
parcelRegister("bIzWH", function(module, exports) {
"use strict";
function $887fafd60b7228cc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $887fafd60b7228cc$var$_objectWithoutProperties(e, r) {
    var t = {};
    for(var o in e)r.indexOf(o) >= 0 || Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
    return t;
}
function $887fafd60b7228cc$var$make() {
    return $887fafd60b7228cc$var$name || ($887fafd60b7228cc$var$name = (0, $1OzFr.animation)($887fafd60b7228cc$var$rule));
}
function $887fafd60b7228cc$var$HeadShake() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : $1OzFr.defaults, r = e.children, t = (e.out, e.timeout), o = e.duration, n = void 0 === o ? $1OzFr.defaults.duration : o, a = e.delay, p = void 0 === a ? $1OzFr.defaults.delay : a, u = e.count, l = void 0 === u ? $1OzFr.defaults.count : u, s = e.forever, i = $887fafd60b7228cc$var$_objectWithoutProperties(e, [
        "children",
        "out",
        "timeout",
        "duration",
        "delay",
        "count",
        "forever"
    ]), d = {
        make: $887fafd60b7228cc$var$make,
        duration: void 0 === t ? n : t,
        delay: p,
        forever: s,
        count: l,
        style: {
            animationFillMode: "both"
        }
    };
    return (0, $887fafd60b7228cc$var$_wrap2.default)(i, d, !1, r, !0);
}
Object.defineProperty(module.exports, "__esModule", {
    value: !0
});

var $2MXkj = parcelRequire("2MXkj");

var $jcCHW = parcelRequire("jcCHW");
var $887fafd60b7228cc$var$_wrap2 = $887fafd60b7228cc$var$_interopRequireDefault($jcCHW);

var $1OzFr = parcelRequire("1OzFr");
var $887fafd60b7228cc$var$propTypes = {
    duration: $2MXkj.number,
    timeout: $2MXkj.number,
    delay: $2MXkj.number,
    count: $2MXkj.number,
    forever: $2MXkj.bool
}, $887fafd60b7228cc$var$rule = "\n  0% {\n    transform: translateX(0);\n  }\n\n  6.5% {\n    transform: translateX(-6px) rotateY(-9deg);\n  }\n\n  18.5% {\n    transform: translateX(5px) rotateY(7deg);\n  }\n\n  31.5% {\n    transform: translateX(-3px) rotateY(-5deg);\n  }\n\n  43.5% {\n    transform: translateX(2px) rotateY(3deg);\n  }\n\n  50% {\n    transform: translateX(0);\n}\n", $887fafd60b7228cc$var$name = !1;
$887fafd60b7228cc$var$HeadShake.propTypes = $887fafd60b7228cc$var$propTypes, module.exports.default = $887fafd60b7228cc$var$HeadShake, module.exports = module.exports.default;

});
parcelRegister("jcCHW", function(module, exports) {
"use strict";
function $dfad29dfef989961$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $dfad29dfef989961$var$wrap(e, t, a, r) {
    return "in" in e && (e.when = e.in), $dfad29dfef989961$var$_react2.default.Children.count(r) < 2 ? $dfad29dfef989961$var$_react2.default.createElement($dfad29dfef989961$var$_RevealBase2.default, $dfad29dfef989961$var$_extends({}, e, {
        inEffect: t,
        outEffect: a,
        children: r
    })) : (r = $dfad29dfef989961$var$_react2.default.Children.map(r, function(r) {
        return $dfad29dfef989961$var$_react2.default.createElement($dfad29dfef989961$var$_RevealBase2.default, $dfad29dfef989961$var$_extends({}, e, {
            inEffect: t,
            outEffect: a,
            children: r
        }));
    }), "Fragment" in $dfad29dfef989961$var$_react2.default ? $dfad29dfef989961$var$_react2.default.createElement($dfad29dfef989961$var$_react2.default.Fragment, null, r) : $dfad29dfef989961$var$_react2.default.createElement("span", null, r));
}
Object.defineProperty(module.exports, "__esModule", {
    value: !0
});
var $dfad29dfef989961$var$_extends = Object.assign || function(e) {
    for(var t = 1; t < arguments.length; t++){
        var a = arguments[t];
        for(var r in a)Object.prototype.hasOwnProperty.call(a, r) && (e[r] = a[r]);
    }
    return e;
};
module.exports.default = $dfad29dfef989961$var$wrap;

var $jbmdS = parcelRequire("jbmdS");
var $dfad29dfef989961$var$_react2 = $dfad29dfef989961$var$_interopRequireDefault($jbmdS);

var $fPV0r = parcelRequire("fPV0r");
var $dfad29dfef989961$var$_RevealBase2 = $dfad29dfef989961$var$_interopRequireDefault($fPV0r);
module.exports = module.exports.default;

});
parcelRegister("fPV0r", function(module, exports) {
"use strict";
function $b877d6a4e12df14a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $b877d6a4e12df14a$var$_defineProperty(e, t, i) {
    return t in e ? Object.defineProperty(e, t, {
        value: i,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = i, e;
}
function $b877d6a4e12df14a$var$_classCallCheck(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function $b877d6a4e12df14a$var$_possibleConstructorReturn(e, t) {
    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !t || "object" != typeof t && "function" != typeof t ? e : t;
}
function $b877d6a4e12df14a$var$_inherits(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
        constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
        }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
Object.defineProperty(module.exports, "__esModule", {
    value: !0
});
var $b877d6a4e12df14a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
    return typeof e;
} : function(e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
}, $b877d6a4e12df14a$var$_slicedToArray = function() {
    function e(e, t) {
        var i = [], s = !0, o = !1, n = void 0;
        try {
            for(var r, a = e[Symbol.iterator](); !(s = (r = a.next()).done) && (i.push(r.value), !t || i.length !== t); s = !0);
        } catch (e) {
            o = !0, n = e;
        } finally{
            try {
                !s && a.return && a.return();
            } finally{
                if (o) throw n;
            }
        }
        return i;
    }
    return function(t, i) {
        if (Array.isArray(t)) return t;
        if (Symbol.iterator in Object(t)) return e(t, i);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}(), $b877d6a4e12df14a$var$_extends = Object.assign || function(e) {
    for(var t = 1; t < arguments.length; t++){
        var i = arguments[t];
        for(var s in i)Object.prototype.hasOwnProperty.call(i, s) && (e[s] = i[s]);
    }
    return e;
}, $b877d6a4e12df14a$var$_createClass = function() {
    function e(e, t) {
        for(var i = 0; i < t.length; i++){
            var s = t[i];
            s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(e, s.key, s);
        }
    }
    return function(t, i, s) {
        return i && e(t.prototype, i), s && e(t, s), t;
    };
}();

var $jbmdS = parcelRequire("jbmdS");
var $b877d6a4e12df14a$var$_react2 = $b877d6a4e12df14a$var$_interopRequireDefault($jbmdS);

var $2MXkj = parcelRequire("2MXkj");

var $1OzFr = parcelRequire("1OzFr");
var $b877d6a4e12df14a$var$inOut = (0, $2MXkj.shape)({
    make: $2MXkj.func,
    duration: $2MXkj.number.isRequired,
    delay: $2MXkj.number.isRequired,
    forever: $2MXkj.bool,
    count: $2MXkj.number.isRequired,
    style: $2MXkj.object.isRequired,
    reverse: $2MXkj.bool
}), $b877d6a4e12df14a$var$propTypes = {
    collapse: $2MXkj.bool,
    collapseEl: $2MXkj.element,
    cascade: $2MXkj.bool,
    wait: $2MXkj.number,
    force: $2MXkj.bool,
    disabled: $2MXkj.bool,
    appear: $2MXkj.bool,
    enter: $2MXkj.bool,
    exit: $2MXkj.bool,
    fraction: $2MXkj.number,
    refProp: $2MXkj.string,
    innerRef: $2MXkj.func,
    onReveal: $2MXkj.func,
    unmountOnExit: $2MXkj.bool,
    mountOnEnter: $2MXkj.bool,
    inEffect: $b877d6a4e12df14a$var$inOut.isRequired,
    outEffect: (0, $2MXkj.oneOfType)([
        $b877d6a4e12df14a$var$inOut,
        (0, $2MXkj.oneOf)([
            !1
        ])
    ]).isRequired,
    ssrReveal: $2MXkj.bool,
    collapseOnly: $2MXkj.bool,
    ssrFadeout: $2MXkj.bool
}, $b877d6a4e12df14a$var$defaultProps = {
    fraction: .2,
    refProp: "ref"
}, $b877d6a4e12df14a$var$contextTypes = {
    transitionGroup: $2MXkj.object
}, $b877d6a4e12df14a$var$RevealBase = function(e) {
    function t(e, i) {
        $b877d6a4e12df14a$var$_classCallCheck(this, t);
        var s = $b877d6a4e12df14a$var$_possibleConstructorReturn(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, i));
        return s.isOn = void 0 === e.when || !!e.when, s.state = {
            collapse: e.collapse ? t.getInitialCollapseStyle(e) : void 0,
            style: {
                opacity: s.isOn && !e.ssrReveal || !e.outEffect ? void 0 : 0
            }
        }, s.savedChild = !1, s.isShown = !1, $1OzFr.observerMode ? s.handleObserve = s.handleObserve.bind(s) : (s.revealHandler = s.makeHandler(s.reveal), s.resizeHandler = s.makeHandler(s.resize)), s.saveRef = s.saveRef.bind(s), s;
    }
    return $b877d6a4e12df14a$var$_inherits(t, e), $b877d6a4e12df14a$var$_createClass(t, [
        {
            key: "saveRef",
            value: function(e) {
                this.childRef && this.childRef(e), this.props.innerRef && this.props.innerRef(e), this.el !== e && (this.el = e && "offsetHeight" in e ? e : void 0, this.observe(this.props, !0));
            }
        },
        {
            key: "invisible",
            value: function() {
                this && this.el && (this.savedChild = !1, this.isShown || (this.setState({
                    hasExited: !0,
                    collapse: this.props.collapse ? $b877d6a4e12df14a$var$_extends({}, this.state.collapse, {
                        visibility: "hidden"
                    }) : null,
                    style: {
                        opacity: 0
                    }
                }), !$1OzFr.observerMode && this.props.collapse && window.document.dispatchEvent($1OzFr.collapseend)));
            }
        },
        {
            key: "animationEnd",
            value: function(e, t, i) {
                var s = this, o = i.forever, n = i.count, r = i.delay, a = i.duration;
                if (!o) {
                    var l = function() {
                        s && s.el && (s.animationEndTimeout = void 0, e.call(s));
                    };
                    this.animationEndTimeout = window.setTimeout(l, r + (a + (t ? a : 0) * n));
                }
            }
        },
        {
            key: "getDimensionValue",
            value: function() {
                return this.el.offsetHeight + parseInt(window.getComputedStyle(this.el, null).getPropertyValue("margin-top"), 10) + parseInt(window.getComputedStyle(this.el, null).getPropertyValue("margin-bottom"), 10);
            }
        },
        {
            key: "collapse",
            value: function(e, t, i) {
                var s = i.duration + (t.cascade ? i.duration : 0), o = this.isOn ? this.getDimensionValue() : 0, n = void 0, r = void 0;
                if (t.collapseOnly) n = i.duration / 3, r = i.delay;
                else {
                    var a = s >> 2, l = a >> 1;
                    n = a, r = i.delay + (this.isOn ? 0 : s - a - l), e.style.animationDuration = s - a + (this.isOn ? l : -l) + "ms", e.style.animationDelay = i.delay + (this.isOn ? a - l : 0) + "ms";
                }
                return e.collapse = {
                    height: o,
                    transition: "height " + n + "ms ease " + r + "ms",
                    overflow: t.collapseOnly ? "hidden" : void 0
                }, e;
            }
        },
        {
            key: "animate",
            value: function(e) {
                if (this && this.el && (this.unlisten(), this.isShown !== this.isOn)) {
                    this.isShown = this.isOn;
                    var t = !this.isOn && e.outEffect, i = e[t ? "outEffect" : "inEffect"], s = "style" in i && i.style.animationName || void 0, o = void 0;
                    e.collapseOnly ? o = {
                        hasAppeared: !0,
                        hasExited: !1,
                        style: {
                            opacity: 1
                        }
                    } : ((e.outEffect || this.isOn) && i.make && (s = i.make), o = {
                        hasAppeared: !0,
                        hasExited: !1,
                        collapse: void 0,
                        style: $b877d6a4e12df14a$var$_extends({}, i.style, {
                            animationDuration: i.duration + "ms",
                            animationDelay: i.delay + "ms",
                            animationIterationCount: i.forever ? "infinite" : i.count,
                            opacity: 1,
                            animationName: s
                        }),
                        className: i.className
                    }), this.setState(e.collapse ? this.collapse(o, e, i) : o), t ? (this.savedChild = $b877d6a4e12df14a$var$_react2.default.cloneElement(this.getChild()), this.animationEnd(this.invisible, e.cascade, i)) : this.savedChild = !1, this.onReveal(e);
                }
            }
        },
        {
            key: "onReveal",
            value: function(e) {
                e.onReveal && this.isOn && (this.onRevealTimeout && (this.onRevealTimeout = window.clearTimeout(this.onRevealTimeout)), e.wait ? this.onRevealTimeout = window.setTimeout(e.onReveal, e.wait) : e.onReveal());
            }
        },
        {
            key: "componentWillUnmount",
            value: function() {
                this.unlisten(), $1OzFr.ssr && (0, $1OzFr.disableSsr)();
            }
        },
        {
            key: "handleObserve",
            value: function(e, t) {
                $b877d6a4e12df14a$var$_slicedToArray(e, 1)[0].intersectionRatio > 0 && (t.disconnect(), this.observer = null, this.reveal(this.props, !0));
            }
        },
        {
            key: "observe",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                if (this.el && $1OzFr.observerMode) {
                    if (this.observer) {
                        if (!t) return;
                        this.observer.disconnect();
                    } else if (t) return;
                    this.observer = new IntersectionObserver(this.handleObserve, {
                        threshold: e.fraction
                    }), this.observer.observe(this.el);
                }
            }
        },
        {
            key: "reveal",
            value: function(e) {
                var t = this, i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                $1OzFr.globalHide || (0, $1OzFr.hideAll)(), this && this.el && (e || (e = this.props), $1OzFr.ssr && (0, $1OzFr.disableSsr)(), this.isOn && this.isShown && void 0 !== e.spy ? (this.isShown = !1, this.setState({
                    style: {}
                }), window.setTimeout(function() {
                    return t.reveal(e);
                }, 200)) : i || this.inViewport(e) || e.force ? this.animate(e) : $1OzFr.observerMode ? this.observe(e) : this.listen());
            }
        },
        {
            key: "componentDidMount",
            value: function() {
                var e = this;
                if (this.el && !this.props.disabled) {
                    this.props.collapseOnly || ("make" in this.props.inEffect && this.props.inEffect.make(!1, this.props), void 0 !== this.props.when && this.props.outEffect && "make" in this.props.outEffect && this.props.outEffect.make(!0, this.props));
                    var i = this.context.transitionGroup, s = i && !i.isMounting ? !("enter" in this.props && !1 === this.props.enter) : this.props.appear;
                    return this.isOn && ((void 0 !== this.props.when || void 0 !== this.props.spy) && !s || $1OzFr.ssr && !$1OzFr.fadeOutEnabled && !this.props.ssrFadeout && this.props.outEffect && !this.props.ssrReveal && t.getTop(this.el) < window.pageYOffset + window.innerHeight) ? (this.isShown = !0, this.setState({
                        hasAppeared: !0,
                        collapse: this.props.collapse ? {
                            height: this.getDimensionValue()
                        } : this.state.collapse,
                        style: {
                            opacity: 1
                        }
                    }), void this.onReveal(this.props)) : $1OzFr.ssr && ($1OzFr.fadeOutEnabled || this.props.ssrFadeout) && this.props.outEffect && t.getTop(this.el) < window.pageYOffset + window.innerHeight ? (this.setState({
                        style: {
                            opacity: 0,
                            transition: "opacity 1000ms 1000ms"
                        }
                    }), void window.setTimeout(function() {
                        return e.reveal(e.props, !0);
                    }, 2e3)) : void (this.isOn && (this.props.force ? this.animate(this.props) : this.reveal(this.props)));
                }
            }
        },
        {
            key: "cascade",
            value: function(e) {
                var t = this, i = void 0;
                i = "string" == typeof e ? e.split("").map(function(e, t) {
                    return $b877d6a4e12df14a$var$_react2.default.createElement("span", {
                        key: t,
                        style: {
                            display: "inline-block",
                            whiteSpace: "pre"
                        }
                    }, e);
                }) : $b877d6a4e12df14a$var$_react2.default.Children.toArray(e);
                var s = this.props[this.isOn || !this.props.outEffect ? "inEffect" : "outEffect"], o = s.duration, n = s.reverse, r = i.length, a = 2 * o;
                this.props.collapse && (a = parseInt(this.state.style.animationDuration, 10), o = a / 2);
                var l = n ? r : 0;
                return i = i.map(function(e) {
                    return "object" === (void 0 === e ? "undefined" : $b877d6a4e12df14a$var$_typeof(e)) && e ? $b877d6a4e12df14a$var$_react2.default.cloneElement(e, {
                        style: $b877d6a4e12df14a$var$_extends({}, e.props.style, t.state.style, {
                            animationDuration: Math.round((0, $1OzFr.cascade)(n ? l-- : l++, 0, r, o, a)) + "ms"
                        })
                    }) : e;
                });
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function(e) {
                if (void 0 !== e.when && (this.isOn = !!e.when), e.fraction !== this.props.fraction && this.observe(e, !0), !this.isOn && e.onExited && "exit" in e && !1 === e.exit) return void e.onExited();
                e.disabled || (e.collapse && !this.props.collapse && (this.setState({
                    style: {},
                    collapse: t.getInitialCollapseStyle(e)
                }), this.isShown = !1), e.when === this.props.when && e.spy === this.props.spy || this.reveal(e), this.onRevealTimeout && !this.isOn && (this.onRevealTimeout = window.clearTimeout(this.onRevealTimeout)));
            }
        },
        {
            key: "getChild",
            value: function() {
                if (this.savedChild && !this.props.disabled) return this.savedChild;
                if ("object" === $b877d6a4e12df14a$var$_typeof(this.props.children)) {
                    var e = $b877d6a4e12df14a$var$_react2.default.Children.only(this.props.children);
                    return "type" in e && "string" == typeof e.type || "ref" !== this.props.refProp ? e : $b877d6a4e12df14a$var$_react2.default.createElement("div", null, e);
                }
                return $b877d6a4e12df14a$var$_react2.default.createElement("div", null, this.props.children);
            }
        },
        {
            key: "render",
            value: function() {
                var e = void 0;
                e = this.state.hasAppeared ? !this.props.unmountOnExit || !this.state.hasExited || this.isOn : !this.props.mountOnEnter || this.isOn;
                var t = this.getChild();
                "function" == typeof t.ref && (this.childRef = t.ref);
                var i = !1, s = t.props, o = s.style, n = s.className, r = s.children, a = this.props.disabled ? n : (this.props.outEffect ? $1OzFr.namespace : "") + (this.state.className ? " " + this.state.className : "") + (n ? " " + n : "") || void 0, l = void 0;
                "function" == typeof this.state.style.animationName && (this.state.style.animationName = this.state.style.animationName(!this.isOn, this.props)), this.props.cascade && !this.props.disabled && r && this.state.style.animationName ? (i = this.cascade(r), l = $b877d6a4e12df14a$var$_extends({}, o, {
                    opacity: 1
                })) : l = this.props.disabled ? o : $b877d6a4e12df14a$var$_extends({}, o, this.state.style);
                var p = $b877d6a4e12df14a$var$_extends({}, this.props.props, $b877d6a4e12df14a$var$_defineProperty({
                    className: a,
                    style: l
                }, this.props.refProp, this.saveRef)), h = $b877d6a4e12df14a$var$_react2.default.cloneElement(t, p, e ? i || r : void 0);
                return void 0 !== this.props.collapse ? this.props.collapseEl ? $b877d6a4e12df14a$var$_react2.default.cloneElement(this.props.collapseEl, {
                    style: $b877d6a4e12df14a$var$_extends({}, this.props.collapseEl.style, this.props.disabled ? void 0 : this.state.collapse),
                    children: h
                }) : $b877d6a4e12df14a$var$_react2.default.createElement("div", {
                    style: this.props.disabled ? void 0 : this.state.collapse,
                    children: h
                }) : h;
            }
        },
        {
            key: "makeHandler",
            value: function(e) {
                var t = this, i = function() {
                    e.call(t, t.props), t.ticking = !1;
                };
                return function() {
                    t.ticking || ((0, $1OzFr.raf)(i), t.ticking = !0);
                };
            }
        },
        {
            key: "inViewport",
            value: function(e) {
                if (!this.el || window.document.hidden) return !1;
                var i = this.el.offsetHeight, s = window.pageYOffset - t.getTop(this.el), o = Math.min(i, window.innerHeight) * ($1OzFr.globalHide ? e.fraction : 0);
                return s > o - window.innerHeight && s < i - o;
            }
        },
        {
            key: "resize",
            value: function(e) {
                this && this.el && this.isOn && this.inViewport(e) && (this.unlisten(), this.isShown = this.isOn, this.setState({
                    hasExited: !this.isOn,
                    hasAppeared: !0,
                    collapse: void 0,
                    style: {
                        opacity: this.isOn || !e.outEffect ? 1 : 0
                    }
                }), this.onReveal(e));
            }
        },
        {
            key: "listen",
            value: function() {
                $1OzFr.observerMode || this.isListener || (this.isListener = !0, window.addEventListener("scroll", this.revealHandler, {
                    passive: !0
                }), window.addEventListener("orientationchange", this.revealHandler, {
                    passive: !0
                }), window.document.addEventListener("visibilitychange", this.revealHandler, {
                    passive: !0
                }), window.document.addEventListener("collapseend", this.revealHandler, {
                    passive: !0
                }), window.addEventListener("resize", this.resizeHandler, {
                    passive: !0
                }));
            }
        },
        {
            key: "unlisten",
            value: function() {
                !$1OzFr.observerMode && this.isListener && (window.removeEventListener("scroll", this.revealHandler, {
                    passive: !0
                }), window.removeEventListener("orientationchange", this.revealHandler, {
                    passive: !0
                }), window.document.removeEventListener("visibilitychange", this.revealHandler, {
                    passive: !0
                }), window.document.removeEventListener("collapseend", this.revealHandler, {
                    passive: !0
                }), window.removeEventListener("resize", this.resizeHandler, {
                    passive: !0
                }), this.isListener = !1), this.onRevealTimeout && (this.onRevealTimeout = window.clearTimeout(this.onRevealTimeout)), this.animationEndTimeout && (this.animationEndTimeout = window.clearTimeout(this.animationEndTimeout));
            }
        }
    ], [
        {
            key: "getInitialCollapseStyle",
            value: function(e) {
                return {
                    height: 0,
                    visibility: e.when ? void 0 : "hidden"
                };
            }
        },
        {
            key: "getTop",
            value: function(e) {
                for(; void 0 === e.offsetTop;)e = e.parentNode;
                for(var t = e.offsetTop; e.offsetParent; t += e.offsetTop)e = e.offsetParent;
                return t;
            }
        }
    ]), t;
}($b877d6a4e12df14a$var$_react2.default.Component);
$b877d6a4e12df14a$var$RevealBase.propTypes = $b877d6a4e12df14a$var$propTypes, $b877d6a4e12df14a$var$RevealBase.defaultProps = $b877d6a4e12df14a$var$defaultProps, $b877d6a4e12df14a$var$RevealBase.contextTypes = $b877d6a4e12df14a$var$contextTypes, $b877d6a4e12df14a$var$RevealBase.displayName = "RevealBase", module.exports.default = $b877d6a4e12df14a$var$RevealBase, module.exports = module.exports.default;

});
parcelRegister("1OzFr", function(module, exports) {
"use strict";
function $152620c440e24c84$var$insertRule(e) {
    try {
        return $152620c440e24c84$var$sheet.insertRule(e, $152620c440e24c84$var$sheet.cssRules.length);
    } catch (e) {
        console.warn("react-reveal - animation failed");
    }
}
function $152620c440e24c84$var$cascade(e, n, t, o, r) {
    var s = Math.log(o), i = Math.log(r), a = (i - s) / (t - n);
    return Math.exp(s + a * (e - n));
}
function $152620c440e24c84$var$animation(e) {
    if (!$152620c440e24c84$var$sheet) return "";
    var n = "@keyframes " + ($152620c440e24c84$var$name + $152620c440e24c84$var$counter) + "{" + e + "}", t = $152620c440e24c84$var$effectMap[e];
    return t ? "" + $152620c440e24c84$var$name + t : ($152620c440e24c84$var$sheet.insertRule(n, $152620c440e24c84$var$sheet.cssRules.length), $152620c440e24c84$var$effectMap[e] = $152620c440e24c84$var$counter, "" + $152620c440e24c84$var$name + $152620c440e24c84$var$counter++);
}
function $152620c440e24c84$var$hideAll() {
    $152620c440e24c84$var$globalHide || (module.exports.globalHide = $152620c440e24c84$var$globalHide = !0, window.removeEventListener("scroll", $152620c440e24c84$var$hideAll, !0), $152620c440e24c84$var$insertRule("." + $152620c440e24c84$var$namespace + " { opacity: 0; }"), window.removeEventListener("orientationchange", $152620c440e24c84$var$hideAll, !0), window.document.removeEventListener("visibilitychange", $152620c440e24c84$var$hideAll));
}
function $152620c440e24c84$var$config(e) {
    var n = e.ssrFadeout;
    module.exports.fadeOutEnabled = $152620c440e24c84$var$fadeOutEnabled = n;
}
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.insertRule = $152620c440e24c84$var$insertRule, module.exports.cascade = $152620c440e24c84$var$cascade, module.exports.animation = $152620c440e24c84$var$animation, module.exports.hideAll = $152620c440e24c84$var$hideAll, module.exports.default = $152620c440e24c84$var$config;
var $152620c440e24c84$var$namespace = module.exports.namespace = "react-reveal", $152620c440e24c84$var$defaults = module.exports.defaults = {
    duration: 1e3,
    delay: 0,
    count: 1
}, $152620c440e24c84$var$ssr = module.exports.ssr = !0, $152620c440e24c84$var$observerMode = module.exports.observerMode = !1, $152620c440e24c84$var$raf = module.exports.raf = function(e) {
    return window.setTimeout(e, 66);
}, $152620c440e24c84$var$disableSsr = module.exports.disableSsr = function() {
    return module.exports.ssr = $152620c440e24c84$var$ssr = !1;
}, $152620c440e24c84$var$fadeOutEnabled = module.exports.fadeOutEnabled = !1, $152620c440e24c84$var$ssrFadeout = module.exports.ssrFadeout = function() {
    var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
    return module.exports.fadeOutEnabled = $152620c440e24c84$var$fadeOutEnabled = e;
}, $152620c440e24c84$var$globalHide = module.exports.globalHide = !1, $152620c440e24c84$var$ie10 = module.exports.ie10 = !1, $152620c440e24c84$var$collapseend = module.exports.collapseend = void 0, $152620c440e24c84$var$counter = 1, $152620c440e24c84$var$effectMap = {}, $152620c440e24c84$var$sheet = !1, $152620c440e24c84$var$name = $152620c440e24c84$var$namespace + "-" + Math.floor(1e15 * Math.random()) + "-";
if ("undefined" != typeof window && "nodejs" !== window.name && window.document && "undefined" != typeof navigator) {
    module.exports.observerMode = $152620c440e24c84$var$observerMode = "IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype && /\{\s*\[native code\]\s*\}/.test("" + IntersectionObserver), module.exports.raf = $152620c440e24c84$var$raf = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || $152620c440e24c84$var$raf, module.exports.ssr = $152620c440e24c84$var$ssr = window.document.querySelectorAll("div[data-reactroot]").length > 0, -1 !== navigator.appVersion.indexOf("MSIE 10") && (module.exports.ie10 = $152620c440e24c84$var$ie10 = !0), $152620c440e24c84$var$ssr && "performance" in window && "timing" in window.performance && "domContentLoadedEventEnd" in window.performance.timing && window.performance.timing.domLoading && Date.now() - window.performance.timing.domLoading < 300 && (module.exports.ssr = $152620c440e24c84$var$ssr = !1), $152620c440e24c84$var$ssr && window.setTimeout($152620c440e24c84$var$disableSsr, 1500), $152620c440e24c84$var$observerMode || (module.exports.collapseend = $152620c440e24c84$var$collapseend = document.createEvent("Event"), $152620c440e24c84$var$collapseend.initEvent("collapseend", !0, !0));
    var $152620c440e24c84$var$element = document.createElement("style");
    document.head.appendChild($152620c440e24c84$var$element), $152620c440e24c84$var$element.sheet && $152620c440e24c84$var$element.sheet.cssRules && $152620c440e24c84$var$element.sheet.insertRule && ($152620c440e24c84$var$sheet = $152620c440e24c84$var$element.sheet, window.addEventListener("scroll", $152620c440e24c84$var$hideAll, !0), window.addEventListener("orientationchange", $152620c440e24c84$var$hideAll, !0), window.document.addEventListener("visibilitychange", $152620c440e24c84$var$hideAll));
}

});




parcelRegister("j2cRM", function(module, exports) {
"use strict";
function $ddb82f3d38acbb32$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $ddb82f3d38acbb32$var$_objectWithoutProperties(e, r) {
    var o = {};
    for(var t in e)r.indexOf(t) >= 0 || Object.prototype.hasOwnProperty.call(e, t) && (o[t] = e[t]);
    return o;
}
function $ddb82f3d38acbb32$var$make() {
    return $ddb82f3d38acbb32$var$name || ($ddb82f3d38acbb32$var$name = (0, $1OzFr.animation)($ddb82f3d38acbb32$var$rule));
}
function $ddb82f3d38acbb32$var$Pulse() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : $1OzFr.defaults, r = e.children, o = (e.out, e.timeout), t = e.duration, n = void 0 === t ? $1OzFr.defaults.duration : t, a = e.delay, u = void 0 === a ? $1OzFr.defaults.delay : a, l = e.count, p = void 0 === l ? $1OzFr.defaults.count : l, s = e.forever, i = $ddb82f3d38acbb32$var$_objectWithoutProperties(e, [
        "children",
        "out",
        "timeout",
        "duration",
        "delay",
        "count",
        "forever"
    ]), d = {
        make: $ddb82f3d38acbb32$var$make,
        duration: void 0 === o ? n : o,
        delay: u,
        forever: s,
        count: p,
        style: {
            animationFillMode: "both"
        }
    };
    return (0, $ddb82f3d38acbb32$var$_wrap2.default)(i, d, !1, r, !0);
}
Object.defineProperty(module.exports, "__esModule", {
    value: !0
});

var $2MXkj = parcelRequire("2MXkj");

var $jcCHW = parcelRequire("jcCHW");
var $ddb82f3d38acbb32$var$_wrap2 = $ddb82f3d38acbb32$var$_interopRequireDefault($jcCHW);

var $1OzFr = parcelRequire("1OzFr");
var $ddb82f3d38acbb32$var$propTypes = {
    duration: $2MXkj.number,
    timeout: $2MXkj.number,
    delay: $2MXkj.number,
    count: $2MXkj.number,
    forever: $2MXkj.bool
}, $ddb82f3d38acbb32$var$rule = "\n	from {\n    transform: scale3d(1, 1, 1);\n  }\n\n  50% {\n    transform: scale3d(1.05, 1.05, 1.05);\n  }\n\n  to {\n    transform: scale3d(1, 1, 1);\n}\n", $ddb82f3d38acbb32$var$name = !1;
$ddb82f3d38acbb32$var$Pulse.propTypes = $ddb82f3d38acbb32$var$propTypes, module.exports.default = $ddb82f3d38acbb32$var$Pulse, module.exports = module.exports.default;

});


parcelRegister("am6LL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78a135bc85607a07$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "UpdateBanner", function () { return $78a135bc85607a07$export$bf187d7d6e084fc8; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $1BTI2 = parcelRequire("1BTI2");

var $4hBm1 = parcelRequire("4hBm1");
parcelRequire("3H03w");
parcelRequire("fJ4T4");

var $8kZ1o = parcelRequire("8kZ1o");

var $6UBLf = parcelRequire("6UBLf");
var $78a135bc85607a07$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(()=>{
    const navigate = (0, $6UBLf.useNavigate)();
    const subscription = (0, $1BTI2.default).subscription;
    if (!subscription) return null;
    if (subscription.hasTrialExpired) return /*#__PURE__*/ (0, $61Ea1.jsx)($78a135bc85607a07$var$Banner, {
        children: "Your trial has expired. If you wish to continue using Coincraft please subscribe below."
    });
    if (!subscription.hasSubscription && subscription.trialEndDate > new Date()) return /*#__PURE__*/ (0, $61Ea1.jsxs)($78a135bc85607a07$var$Banner, {
        children: [
            "Your Trial Ends ",
            $78a135bc85607a07$var$dateToString(subscription.trialEndDate),
            /*#__PURE__*/ (0, $61Ea1.jsx)($78a135bc85607a07$var$BannerButton, {
                onClick: ()=>navigate({
                        to: "/billing"
                    }),
                children: "Click Here to Subscribe!"
            })
        ]
    });
    if (subscription.hasCreditCardExpired && (0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "billing")) return /*#__PURE__*/ (0, $61Ea1.jsxs)($78a135bc85607a07$var$Banner, {
        children: [
            "Your card has expired",
            " ",
            /*#__PURE__*/ (0, $61Ea1.jsx)($78a135bc85607a07$var$BannerButton, {
                onClick: ()=>navigate({
                        to: "/billing"
                    }),
                children: "Click Here to Update!"
            })
        ]
    });
    if (subscription.hasOverdueInvoices && (0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "billing")) return /*#__PURE__*/ (0, $61Ea1.jsx)($78a135bc85607a07$var$Banner, {
        children: "You currently have overdue invoices. If you wish to continue using Coincraft please pay below."
    });
    if (subscription.hasUnpaidInvoices && (0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "billing")) return /*#__PURE__*/ (0, $61Ea1.jsxs)($78a135bc85607a07$var$Banner, {
        children: [
            "You currently have unpaid invoices due",
            " ",
            $78a135bc85607a07$var$dateToString(subscription.earliestUnpaidInvoiceDate),
            /*#__PURE__*/ (0, $61Ea1.jsx)($78a135bc85607a07$var$BannerButton, {
                onClick: ()=>navigate({
                        to: "/billing"
                    }),
                children: "Pay Here!"
            })
        ]
    });
    // if (
    //     subscription.willCreditCardExpireInLessThanAMonth &&
    //     canViewRoute(SessionStore.user, 'billing')
    // ) {
    //     return (
    //         <Banner>
    //             Your card will expire {dateToString(subscription.cardExpDate)}
    //             <BannerButton onClick={() => navigate({ to: '/billing' })}>
    //                 Click Here to Update!
    //             </BannerButton>
    //         </Banner>
    //     )
    // }
    return null;
});
const $78a135bc85607a07$export$bf187d7d6e084fc8 = (0, $1EEMt.observer)(()=>{
    return (0, $1BTI2.default).updateAvailable ? /*#__PURE__*/ (0, $61Ea1.jsx)($78a135bc85607a07$var$Banner, {
        style: {
            background: "#0000ff",
            color: "#fff"
        },
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            style: {
                padding: "0.5em 0 0"
            },
            children: [
                "An Update for Coincraft is available.",
                " ",
                /*#__PURE__*/ (0, $61Ea1.jsx)($78a135bc85607a07$var$BannerButton, {
                    style: {
                        background: "#fff",
                        color: "#0000ff"
                    },
                    onClick: ()=>{
                        let url = window.location.href;
                        url += `${url.indexOf("?") > -1 ? "&" : "?"}ts=${Date.now()}`;
                        window.location.href = url;
                    },
                    children: "Get Latest Improvements!"
                })
            ]
        })
    }) : null;
});
const $78a135bc85607a07$var$Banner = (0, $1EEMt.observer)(({ children: children, style: style })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "dont-print dont-print text-center bg-[#f15a29] text-[#444] font-semibold text-[0.9em] shadow-[inset_0px_2px_8px_1px_rgba(0,0,0,0.2)]",
        style: {
            padding: "0.5em",
            ...style
        },
        children: children
    });
});
const $78a135bc85607a07$var$BannerButton = (0, $1EEMt.observer)(({ children: children, onClick: onClick, style: style })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "inline-block mx-[1em] text-[0.95em] pt-[0.2em] pb-[0.1em] px-[1em] text-white bg-[#444] rounded",
        style: {
            margin: "0 1em",
            ...style
        },
        onClick: onClick,
        children: children
    });
});
function $78a135bc85607a07$var$dateToString(m) {
    const n = (0, $4hBm1.differenceInDays)(m, new Date());
    if (n === 0) return "Today";
    else if (n === 1) return "Tomorrow";
    else return `in ${n} Days`;
}

});


parcelRegister("dYful", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2bce49e933a4ac5$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("gN0TC");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");
parcelRequire("fEcKX");

var $khJQv = parcelRequire("khJQv");

var $ldrel = parcelRequire("ldrel");

var $ip90b = parcelRequire("ip90b");

var $8Os6U = parcelRequire("8Os6U");
var $a2bce49e933a4ac5$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ modal: modal })=>{
    return [
        ...(0, $khJQv.default).modals.values(),
        ...modal === "invoice-settings" ? [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ldrel.default), {
                modalId: "invoice-settings"
            })
        ] : [],
        ...modal === "import-one-contact" ? [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ip90b.default), {
                modalId: "import-one-contact",
                onSave: ()=>{}
            })
        ] : [],
        ...modal === "import-contacts" ? [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8Os6U.default), {
                modalId: "import-contacts"
            })
        ] : []
    ];
});

});
parcelRegister("8Os6U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66a8cc6733ed8ee6$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $1EEMt = parcelRequire("1EEMt");

var $fEcKX = parcelRequire("fEcKX");

var $ewAM3 = parcelRequire("ewAM3");

var $1BTI2 = parcelRequire("1BTI2");

var $43oHB = parcelRequire("43oHB");

var $52dEm = parcelRequire("52dEm");

var $8NSNz = parcelRequire("8NSNz");

var $goLmS = parcelRequire("goLmS");

var $bhvQG = parcelRequire("bhvQG");

var $fM2j4 = parcelRequire("fM2j4");

var $foLWS = parcelRequire("foLWS");
parcelRequire("hdshG");

var $4JcCM = parcelRequire("4JcCM");

var $6ywef = parcelRequire("6ywef");
const $66a8cc6733ed8ee6$var$accountingDropdownOptions = [
    {
        label: "None",
        value: "none"
    },
    {
        label: "Xero",
        value: "xero"
    },
    {
        label: "Myob Essentials",
        value: "myob-essentials"
    },
    {
        label: "Myob AccountRight",
        value: "myob-accountright"
    },
    {
        label: "Quickbooks",
        value: "quickbooks"
    }
];
let $66a8cc6733ed8ee6$var$selectedState = (0, $4JcCM.observable)({
    contacts: new Set()
});
const $66a8cc6733ed8ee6$var$ContactSelectColumns = [
    {
        id: "selected",
        label: "",
        type: "checkbox",
        width: 5,
        value: (row)=>{
            return row.selected;
        },
        component: ({ value: value, stores: stores })=>{
            const { row: row } = stores;
            return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                value: $66a8cc6733ed8ee6$var$selectedState.contacts.has(row.rowObject),
                onChange: (v)=>{
                    if (v) $66a8cc6733ed8ee6$var$selectedState.contacts.add(row.rowObject);
                    else $66a8cc6733ed8ee6$var$selectedState.contacts.delete(row.rowObject);
                }
            });
        }
    },
    {
        id: "label",
        label: "Label",
        type: "text",
        width: 50,
        value: (row)=>{
            return row.label;
        }
    }
];
var $66a8cc6733ed8ee6$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ modalId: modalId })=>{
    const [fetchStatus, setFetchStatus] = (0, $jbmdS.useState)("idle");
    const [contacts, setContacts] = (0, $jbmdS.useState)([]);
    const [contactFilter, setContactFilter] = (0, $jbmdS.useState)("");
    const accountingSystem = $66a8cc6733ed8ee6$var$accountingDropdownOptions.find((o)=>{
        var _SessionStore$organis;
        return o.value === ((_SessionStore$organis = (0, $1BTI2.default).organisation) === null || _SessionStore$organis === void 0 ? void 0 : _SessionStore$organis.accountingSystem);
    }) || $66a8cc6733ed8ee6$var$accountingDropdownOptions[0];
    const accountingSystemConnected = (0, $1BTI2.default).accountingConnected;
    const accountSystemSettings = (0, $1BTI2.default).organisation.accountingSystemSettings;
    // If coming back from OAuth flow, fetch contacts automatically
    (0, $jbmdS.useEffect)(()=>{
        if (accountingSystemConnected && fetchStatus === "idle") (0, $43oHB.fetchAccountingContacts)().then((data)=>{
            if (data !== null && data !== void 0 && data.contacts) {
                setContacts(data.contacts.map((c)=>new (0, $8NSNz.default)(c, {
                        trackUpdates: true,
                        detached: true
                    })));
                setFetchStatus("fetched");
            }
        }).catch((err)=>{
            console.error(err);
            setFetchStatus("error");
        });
    }, [
        accountingSystemConnected,
        fetchStatus
    ]);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fEcKX.default), {
        modalId: modalId,
        heading: "Import Contacts",
        saveLabel: "Import Contacts",
        onSave: ()=>{
            $66a8cc6733ed8ee6$var$selectedState.contacts.forEach((c)=>{
                var _ContactCollection$co;
                if ((_ContactCollection$co = (0, $bhvQG.default).contactsByAccountingSystemId) !== null && _ContactCollection$co !== void 0 && _ContactCollection$co[c.accountingSystemContactId]) {
                    var _ContactCollection$co2;
                    c = (_ContactCollection$co2 = (0, $bhvQG.default).contactsByAccountingSystemId) === null || _ContactCollection$co2 === void 0 ? void 0 : _ContactCollection$co2[c.accountingSystemContactId];
                    c.update({
                        firstName: c.firstName,
                        lastName: c.lastName,
                        organisationName: c.organisationName,
                        phone: c.phone,
                        email: c.email
                    });
                }
                c.attach();
                (0, $fM2j4.default).startSave();
            });
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    padding: "1em",
                    display: "flex",
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                        style: {
                            flex: "0 0 auto",
                            paddingRight: "1em"
                        },
                        children: [
                            "Accounting System:",
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                        selectedOption: $66a8cc6733ed8ee6$var$accountingDropdownOptions.find((o)=>o.value === (0, $1BTI2.default).organisation.accountingSystem) || $66a8cc6733ed8ee6$var$accountingDropdownOptions[0],
                        onChange: (o)=>(0, $1BTI2.default).organisation.update({
                                accountingSystem: o.value
                            }),
                        options: $66a8cc6733ed8ee6$var$accountingDropdownOptions,
                        optionLabel: (o)=>o.label,
                        style: {
                            flex: "1 1 auto"
                        }
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6ywef.default), {
                        action: "fetchContacts",
                        onActionSuccess: (r)=>{
                            setContacts(r.contacts.map((c)=>new (0, $8NSNz.default)(c, {
                                    trackUpdates: true,
                                    detached: true
                                })));
                            setFetchStatus("fetched");
                        },
                        onActionError: (e)=>{
                            console.error(e);
                            setFetchStatus("error");
                        },
                        onActionStart: (r)=>{
                            setFetchStatus("fetching");
                        },
                        style: {
                            margin: "0 1em",
                            flex: "1 1 auto"
                        }
                    })
                ]
            }),
            accountingSystemConnected ? /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    padding: "1em"
                },
                children: fetchStatus === "fetched" ? /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            style: {
                                display: "flex",
                                alignItems: "center",
                                margin: "0 0.5em 1em",
                                justifyContent: "space-between"
                            },
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                                    variant: "secondary",
                                    label: "Select All",
                                    value: contacts.filter((c)=>!contactFilter.length || c.label.toLowerCase().includes(contactFilter.toLowerCase())).every((c)=>$66a8cc6733ed8ee6$var$selectedState.contacts.has(c)),
                                    onChange: (v)=>{
                                        if (v) $66a8cc6733ed8ee6$var$selectedState.contacts = new Set(contacts.filter((c)=>!contactFilter.length || c.label.toLowerCase().includes(contactFilter.toLowerCase())));
                                        else $66a8cc6733ed8ee6$var$selectedState.contacts = new Set();
                                    }
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $foLWS.default), {
                                    style: {
                                        width: "20em",
                                        textAlign: "right"
                                    },
                                    placeholder: "Search Contacts",
                                    value: contactFilter,
                                    onChange: (v)=>{
                                        setContactFilter(v);
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            style: {
                                display: "flex",
                                justifyContent: "center"
                            },
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
                                style: {
                                    width: "100%",
                                    maxHeight: "22em",
                                    overflow: "auto"
                                },
                                columns: $66a8cc6733ed8ee6$var$ContactSelectColumns,
                                rows: contacts.filter((c)=>!contactFilter.length || c.label.toLowerCase().includes(contactFilter.toLowerCase()))
                            })
                        })
                    ]
                }) : fetchStatus === "error" ? "Error Fetching Contacts" : ""
            }) : null
        ]
    });
});

});


parcelRegister("8aL9y", function(module, exports) {
module.exports = JSON.parse('{"name":"cc_web_client","version":"1.9.54","private":true,"dependencies":{"@babel/preset-typescript":"^7.22.5","@clerk/clerk-js":"^5.26.2","@clerk/clerk-react":"^5.23.0","@dnd-kit/core":"^6.3.1","@dnd-kit/modifiers":"^9.0.0","@dnd-kit/sortable":"^10.0.0","@doodle3d/clipper-js":"^1.0.11","@emotion/react":"^11.11.4","@emotion/styled":"^11.9.3","@formkit/auto-animate":"^0.8.2","@fortawesome/fontawesome-svg-core":"^6.1.1","@fortawesome/free-regular-svg-icons":"^6.1.1","@fortawesome/free-solid-svg-icons":"^6.6.0","@fortawesome/react-fontawesome":"^0.1.18","@hello-pangea/dnd":"^17.0.0","@hookform/resolvers":"^3.9.0","@internationalized/date":"^3.3.0","@internationalized/number":"^3.1.1","@mui/material":"^5.9.2","@radix-ui/react-avatar":"^1.1.0","@radix-ui/react-checkbox":"^1.1.1","@radix-ui/react-dialog":"^1.1.1","@radix-ui/react-dropdown-menu":"^2.1.1","@radix-ui/react-icons":"^1.3.0","@radix-ui/react-label":"^2.1.0","@radix-ui/react-popover":"^1.1.1","@radix-ui/react-progress":"^1.0.3","@radix-ui/react-radio-group":"^1.1.3","@radix-ui/react-scroll-area":"^1.1.0","@radix-ui/react-select":"^2.1.1","@radix-ui/react-separator":"^1.1.0","@radix-ui/react-slider":"^1.1.2","@radix-ui/react-slot":"^1.1.0","@radix-ui/react-switch":"^1.1.0","@radix-ui/react-tabs":"^1.1.0","@radix-ui/react-toggle":"^1.1.0","@radix-ui/react-toggle-group":"^1.1.0","@radix-ui/react-tooltip":"^1.1.2","@react-hook/hover":"^4.0.0","@react-hook/media-query":"^1.1.1","@react-hook/mouse-position":"^4.1.3","@react-hook/resize-observer":"^1.2.6","@rooks/use-outside-click":"^4.11.2","@ryki/datemath":"^1.3.4","@sentry/react":"^7.73.0","@sindresorhus/is":"4.6.0","@skoging/react-app-rewire-source-map-loader":"^1.0.9","@tanstack/react-query":"^4.18.0","@tanstack/react-query-devtools":"^4.29.6","@tanstack/react-router":"^1.106.0","@tanstack/react-table":"^8.19.3","@tanstack/router-cli":"^1.33.12","@trpc/client":"^10.45.2","@trpc/react":"^9.27.4","@trpc/server":"^10.45.2","@xstate/store":"^2.6.2","add":"^2.0.6","antd":"^4.7.3","axios":"^0.19.0","axios-request-handler":"^1.0.4","bind-decorator":"^1.0.11","change-case":"^4.1.2","class-variance-authority":"^0.7.0","classnames":"^2.2.5","clsx":"^2.1.1","cmdk":"^1.0.0","copy-to-clipboard":"^3.3.1","core-js":"^3.36.1","create-react-class":"^15.6.3","cuid":"^2.1.8","d3":"^3.5.17","date-fns":"^3.6.0","decircular":"^1.0.0","downloadjs":"^1.4.7","element-resize-detector":"^1.2.3","fast-json-stable-stringify":"^2.1.0","fix-date":"^1.1.6","flux":"^2.1.1","free-email-domains-list":"^1.0.14","fuse.js":"^7.0.0","get-user-locale":"^1.5.1","globalize":"^0.1.1","hamjest":"^2.13.0","history":"^1.17.0","husl":"^6.0.1","immutable":"^3.8.1","immutable-tuple":"^0.4.10","install":"^0.13.0","iso-lang-codes":"^2.1.1","jquery":"^3.4.1","js-cookie":"^3.0.1","js-file-download":"^0.4.8","jwt-decode":"^4.0.0","locale-currency":"^0.0.2","localforage":"^1.10.0","lodash.merge":"^4.3.5","logrocket":"^1.2.2","lucide-react":"^0.407.0","mathjs":"^6.2.1","mobx":"^6.0.1","mobx-react":"^7.0.0","mobx-react-lite":"^3.0.1","mobx-utils":"^6.0.5","mockdate":"^1.0.4","moment":"^2.14.1","mousetrap":"^1.6.1","nearley":"^2.20.1","npm":"^3.9.0","numeral":"^2.0.6","papaparse":"^4.3.6","pluralize":"^8.0.0","posthog-js":"^1.239.0","prop-types":"^15.7.2","pusher-js":"^8.3.0","react":"^18.2.0","react-addons-linked-state-mixin":"^15.0.2","react-addons-pure-render-mixin":"^15.4.2","react-addons-transition-group":"^15.3.2","react-aria":"^3.19.0","react-calendar":"^3.1.0","react-data-grid":"^6.1.0","react-day-picker":"^8.10.1","react-dom":"^18.2.0","react-draggable-list":"^4.1.0","react-error-boundary":"^3.1.4","react-hook-form":"^7.52.1","react-input-autosize":"^1.1.0","react-promise-suspense":"^0.3.3","react-reveal":"^1.2.2","react-router":"^3.0.2","react-scripts":"3.1.1","react-select":"^5.4.0","react-sortable-hoc":"^2.0.0","react-spring":"^9.7.4","react-tap-event-plugin":"^1.0.0","react-textarea-autosize":"^4.0.1","react-tooltip":"^5.19.0","react-use-gesture":"^7.0.16","react-virtuoso":"^4.12.2","react-widgets":"^3.4.5","recharts":"^2.15.1","reselect":"^2.5.3","rsvp":"^3.2.1","sass":"^1.48.0","slsx":"^0.0.3","superjson":"^1.9.1","tailwind-merge":"^2.4.0","tailwindcss-animate":"^1.0.7","title-case":"^3.0.3","trackjs":"^3.9.2","typescript":"^5.5.4","underscore":"^1.8.3","validator":"^13.12.0","velocity-animate":"^1.2.3","vinyl-source-stream":"^1.1.0","wait":"^0.4.2","wouter":"^2.8.0-alpha.2","xspans":"^1.0.1","xstate":"^5.6.2","yarn":"^1.22.19","zod":"^3.23.8"},"devDependencies":{"@babel/core":"^7.12.0","@babel/plugin-proposal-class-properties":"^7.18.6","@babel/plugin-proposal-decorators":"^7.4.4","@babel/plugin-proposal-logical-assignment-operators":"^7.2.0","@babel/plugin-proposal-nullish-coalescing-operator":"^7.4.4","@babel/plugin-proposal-optional-chaining":"^7.2.0","@babel/plugin-proposal-record-and-tuple":"^7.18.6","@babel/preset-env":"^7.22.9","@babel/preset-react":"^7.22.5","@bloomberg/record-tuple-polyfill":"^0.0.4","@emotion/babel-plugin":"^11.11.0","@parcel/packager-raw-url":"2.12.0","@parcel/transformer-sass":"2.12.0","@parcel/transformer-webmanifest":"2.12.0","@tanstack/router-devtools":"^1.31.26","@types/date-fns":"^2.6.3","@types/react":"^18.3.3","@types/react-dom":"^18.3.0","autoprefixer":"^10.4.18","babel-loader":"8.0.6","customize-cra":"^0.2.13","enzyme":"^2.7.1","json":"^9.0.4","parcel":"^2.12.0","postcss":"^8.4.35","qunitjs":"^2.0.0-rc1","react-addons-test-utils":"^15.4.2","react-app-rewired":"^2.1.3","tailwind-scrollbar":"^3.1.0","tailwindcss":"^3.4.1"},"source":"./public/index.html","scripts":{"start":"parcel --port 3000","build":"parcel build --dist-dir build"},"parcel":{"targets":{"main":{"optimize":true}},"extends":"@parcel/config-default","transformers":{"*.txt":["...","@parcel/transformer-raw"]},"contentHash":{"txt":false}},"eslintConfig":{"extends":"react-app"},"browserslist":{"production":[">0.2%","not dead","not op_mini all"],"development":["last 1 chrome version","last 1 firefox version","last 1 safari version"]},"engines":{"node":">=18.17.0"}}');

});

parcelRegister("lvC6D", function(module, exports) {

$parcel$export(module.exports, "Layout", function () { return $d542d1796fbc8788$export$c84671f46d6a1ca; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $bddFI = parcelRequire("bddFI");

var $be27v = parcelRequire("be27v");

var $cOJf8 = parcelRequire("cOJf8");

var $SRJCe = parcelRequire("SRJCe");

var $6Q5sp = parcelRequire("6Q5sp");
const $d542d1796fbc8788$export$c84671f46d6a1ca = ({ children: children })=>{
    const [parent, enableAnimations] = (0, $cOJf8.useAutoAnimate)();
    const { clearSidebar: clearSidebar } = (0, $SRJCe.useSidebarStack)();
    (0, $jbmdS.useEffect)(()=>{
        // Subscribe to route changes
        const unsub = (0, $6Q5sp.router).subscribe("onBeforeNavigate", (e)=>{
            if (e.pathChanged) clearSidebar();
        });
        // Cleanup
        return ()=>{
            unsub === null || unsub === void 0 || unsub();
        };
    }, [
        clearSidebar
    ]);
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            className: "flex overflow-hidden bg-background h-screen print:overflow-visible",
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    className: "flex-none print:hidden",
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bddFI.NavigationSidebar), {})
                }),
                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    className: "flex-auto flex flex-col overflow-hidden border-l border-border print:overflow-visible",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            className: "flex-none w-full",
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $be27v.TopBar), {})
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            ref: parent,
                            className: "flex-auto w-full overflow-hidden flex",
                            children: [
                                children,
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $SRJCe.Sidebar), {})
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("bddFI", function(module, exports) {

$parcel$export(module.exports, "NavigationSidebar", function () { return $c202e6ef079a8189$export$a23db51eeeaf4bdb; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $fTGwv = parcelRequire("fTGwv");

var $gY0X4 = parcelRequire("gY0X4");

var $8tafh = parcelRequire("8tafh");

var $hzfgL = parcelRequire("hzfgL");

var $artg7 = parcelRequire("artg7");
var $3yHyu = parcelRequire("3yHyu");
var $aBjoI = parcelRequire("aBjoI");
var $jqbKH = parcelRequire("jqbKH");
var $4etQs = parcelRequire("4etQs");
var $aLwbW = parcelRequire("aLwbW");
var $hwsY5 = parcelRequire("hwsY5");
var $kKuTV = parcelRequire("kKuTV");
var $ks8uR = parcelRequire("ks8uR");
var $fOr1R = parcelRequire("fOr1R");
var $7TXf7 = parcelRequire("7TXf7");

var $Yha9m = parcelRequire("Yha9m");

var $cOJf8 = parcelRequire("cOJf8");

var $a3BWW = parcelRequire("a3BWW");

var $gzhWA = parcelRequire("gzhWA");

var $fY40Q = parcelRequire("fY40Q");

var $lvLif = parcelRequire("lvLif");

var $7YQNq = parcelRequire("7YQNq");

var $lGnOi = parcelRequire("lGnOi");

var $mEEFh = parcelRequire("mEEFh");

var $2DmvN = parcelRequire("2DmvN");

var $9Xt0I = parcelRequire("9Xt0I");

var $26sX2 = parcelRequire("26sX2");

var $6UBLf = parcelRequire("6UBLf");
// import { useClerk } from '@clerk/clerk-react'
const $c202e6ef079a8189$var$subMenuLookup = {
    organisation: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fY40Q.OrgSubNav), {}),
    projects: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $gzhWA.ProjectsSubNav), {}),
    clients: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $lvLif.ClientsSubNav), {}),
    suppliers: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7YQNq.SuppliersSubNav), {}),
    invoices: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $lGnOi.InvoicesSubNav), {}),
    expenses: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $mEEFh.ExpensesSubNav), {}),
    time: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $2DmvN.TimeSubNav), {}),
    resources: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $9Xt0I.ResourcesSubNav), {})
};
const $c202e6ef079a8189$export$a23db51eeeaf4bdb = ()=>{
    const subMenu = (0, $26sX2.useSubMenu)();
    const showSubMenu = (0, $26sX2.useShowSubMenu)();
    const [hovering, setHovering] = (0, $jbmdS.useState)(false);
    const [parent, enableAnimations] = (0, $cOJf8.useAutoAnimate)();
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        ref: parent,
        className: "flex h-screen",
        onMouseEnter: ()=>setHovering(true),
        onMouseLeave: ()=>{
            setHovering(false);
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)($c202e6ef079a8189$export$fea72764910c994c, {
                setSubMenu: (0, $26sX2.setSubMenu),
                subMenu: subMenu
            }),
            (showSubMenu || hovering) && subMenu ? $c202e6ef079a8189$var$subMenuLookup[subMenu] : null
        ]
    });
};
const $c202e6ef079a8189$export$fea72764910c994c = ({ subMenu: subMenu, setSubMenu: setSubMenu })=>{
    const navigate = (0, $6UBLf.useNavigate)();
    // const { signOut } = useClerk()
    const isExpanded = false;
    return /*#__PURE__*/ (0, $61Ea1.jsx)("nav", {
        className: (0, $Yha9m.cn)("relative flex flex-col h-full bg-background transition-all duration-300", isExpanded ? "w-60" : "w-16"),
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            className: "flex grow flex-col gap-y-4 overflow-hidden p-4",
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    className: (0, $Yha9m.cn)("flex items-center", isExpanded ? "justify-start space-x-2" : "justify-center"),
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            className: "w-7 h-7 bg-yellow-400 rounded-full flex-shrink-0"
                        }),
                        isExpanded && /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                            className: "text-lg font-semibold",
                            children: "coincraft"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $hzfgL.ScrollArea), {
                    className: "flex-1 -mx-4 px-4",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            className: "space-y-1 py-4 border-t border-border",
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $a3BWW.NavButton), {
                                    active: subMenu === "organisation",
                                    isExpanded: isExpanded,
                                    icon: (0, $3yHyu.default),
                                    label: "Organisation",
                                    onClick: ()=>{
                                        setSubMenu("organisation");
                                        navigate({
                                            to: "/revenue-forecast"
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $a3BWW.NavButton), {
                                    active: subMenu === "projects",
                                    isExpanded: isExpanded,
                                    icon: (0, $hwsY5.default),
                                    label: "Projects",
                                    onClick: ()=>{
                                        setSubMenu("projects");
                                        navigate({
                                            to: "/projects"
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $a3BWW.NavButton), {
                                    active: subMenu === "resources",
                                    isExpanded: isExpanded,
                                    icon: (0, $7TXf7.default),
                                    label: "Resources",
                                    onClick: ()=>{
                                        setSubMenu("resources");
                                        navigate({
                                            to: "/staff"
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $a3BWW.NavButton), {
                                    active: subMenu === "clients",
                                    isExpanded: isExpanded,
                                    icon: (0, $artg7.default),
                                    label: "Clients",
                                    onClick: ()=>{
                                        setSubMenu("clients");
                                        navigate({
                                            to: "/contacts"
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $a3BWW.NavButton), {
                                    active: subMenu === "suppliers",
                                    isExpanded: isExpanded,
                                    icon: (0, $fOr1R.default),
                                    label: "Suppliers",
                                    onClick: ()=>{
                                        setSubMenu("suppliers");
                                        navigate({
                                            to: "/suppliers"
                                        });
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            className: "space-y-1 border-t border-b border-border py-4",
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $a3BWW.NavButton), {
                                    active: subMenu === "invoices",
                                    isExpanded: isExpanded,
                                    icon: (0, $4etQs.default),
                                    label: "Invoicing",
                                    onClick: ()=>{
                                        setSubMenu("invoices");
                                        navigate({
                                            to: "/invoices"
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $a3BWW.NavButton), {
                                    active: subMenu === "time",
                                    isExpanded: isExpanded,
                                    icon: (0, $aBjoI.default),
                                    label: "Time",
                                    onClick: ()=>{
                                        setSubMenu("time");
                                        navigate({
                                            to: "/timesheets?tab=weekly"
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $a3BWW.NavButton), {
                                    active: subMenu === "expenses",
                                    isExpanded: isExpanded,
                                    icon: (0, $kKuTV.default),
                                    label: "Expenses",
                                    onClick: ()=>{
                                        setSubMenu("expenses");
                                        navigate({
                                            to: "/track-expenses"
                                        });
                                    }
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    className: "space-y-1 border-b border-t border-border py-4",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $a3BWW.NavButton), {
                            isExpanded: isExpanded,
                            icon: (0, $jqbKH.default),
                            label: "Help",
                            onClick: ()=>window.open("https://help.coincraft.co", "_blank").focus()
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $a3BWW.NavButton), {
                            isExpanded: isExpanded,
                            icon: (0, $ks8uR.default),
                            label: "Settings",
                            onClick: ()=>{
                                setSubMenu(null);
                                navigate({
                                    to: "/settings"
                                });
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $8tafh.DropdownMenu), {
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8tafh.DropdownMenuTrigger), {
                            asChild: true,
                            children: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fTGwv.Button), {
                                variant: "ghost",
                                className: (0, $Yha9m.cn)("w-full justify-between text-foreground hover:bg-accent hover:text-accent-foreground mb-2", !isExpanded && "justify-center p-2"),
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                        className: "flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $gY0X4.Avatar), {
                                                className: "h-8 w-8",
                                                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $gY0X4.AvatarFallback), {
                                                    className: "bg-primary text-primary-foreground",
                                                    children: "LC"
                                                })
                                            }),
                                            isExpanded && /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                                children: "Le Corbusier"
                                            })
                                        ]
                                    }),
                                    isExpanded && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $aLwbW.default), {
                                        className: "h-4 w-4"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $8tafh.DropdownMenuContent), {
                            align: "end",
                            className: "w-[200px]",
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8tafh.DropdownMenuItem), {
                                    children: "Profile"
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8tafh.DropdownMenuItem), {
                                    onClick: ()=>{
                                        setSubMenu(null);
                                        navigate({
                                            to: "/billing"
                                        });
                                    },
                                    children: "Billing"
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8tafh.DropdownMenuItem), {
                                    children: "Logout"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("gY0X4", function(module, exports) {

$parcel$export(module.exports, "Avatar", function () { return $8d9ada951e86edaf$export$e2255cf6045e8d47; });
$parcel$export(module.exports, "AvatarFallback", function () { return $8d9ada951e86edaf$export$69fffb6a9571fbfe; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $tPuBV = parcelRequire("tPuBV");

var $Yha9m = parcelRequire("Yha9m");
const $8d9ada951e86edaf$export$e2255cf6045e8d47 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)($tPuBV.Root, {
        ref: ref,
        className: (0, $Yha9m.cn)("relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full", className),
        ...props
    }));
$8d9ada951e86edaf$export$e2255cf6045e8d47.displayName = $tPuBV.Root.displayName;
const $8d9ada951e86edaf$export$2cd8ae1985206fe8 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)($tPuBV.Image, {
        ref: ref,
        className: (0, $Yha9m.cn)("aspect-square h-full w-full", className),
        ...props
    }));
$8d9ada951e86edaf$export$2cd8ae1985206fe8.displayName = $tPuBV.Image.displayName;
const $8d9ada951e86edaf$export$69fffb6a9571fbfe = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)($tPuBV.Fallback, {
        ref: ref,
        className: (0, $Yha9m.cn)("flex h-full w-full items-center justify-center rounded-full bg-muted", className),
        ...props
    }));
$8d9ada951e86edaf$export$69fffb6a9571fbfe.displayName = $tPuBV.Fallback.displayName;

});
parcelRegister("tPuBV", function(module, exports) {

$parcel$export(module.exports, "Root", function () { return $dc77c54152e4d9f2$export$be92b6f5f03c0fe9; });
$parcel$export(module.exports, "Image", function () { return $dc77c54152e4d9f2$export$3e431a229df88919; });
$parcel$export(module.exports, "Fallback", function () { return $dc77c54152e4d9f2$export$fb8d7f40caaeea67; });

var $jbmdS = parcelRequire("jbmdS");

var $f4RZG = parcelRequire("f4RZG");

var $kjEX1 = parcelRequire("kjEX1");

var $9crHl = parcelRequire("9crHl");

var $cihg9 = parcelRequire("cihg9");

var $4TLFw = parcelRequire("4TLFw");
"use client";
var $dc77c54152e4d9f2$var$AVATAR_NAME = "Avatar";
var [$dc77c54152e4d9f2$var$createAvatarContext, $dc77c54152e4d9f2$export$90370d16b488820f] = (0, $f4RZG.createContextScope)($dc77c54152e4d9f2$var$AVATAR_NAME);
var [$dc77c54152e4d9f2$var$AvatarProvider, $dc77c54152e4d9f2$var$useAvatarContext] = $dc77c54152e4d9f2$var$createAvatarContext($dc77c54152e4d9f2$var$AVATAR_NAME);
var $dc77c54152e4d9f2$export$e2255cf6045e8d47 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeAvatar: __scopeAvatar, ...avatarProps } = props;
    const [imageLoadingStatus, setImageLoadingStatus] = $jbmdS.useState("idle");
    return /* @__PURE__ */ (0, $4TLFw.jsx)($dc77c54152e4d9f2$var$AvatarProvider, {
        scope: __scopeAvatar,
        imageLoadingStatus: imageLoadingStatus,
        onImageLoadingStatusChange: setImageLoadingStatus,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).span, {
            ...avatarProps,
            ref: forwardedRef
        })
    });
});
$dc77c54152e4d9f2$export$e2255cf6045e8d47.displayName = $dc77c54152e4d9f2$var$AVATAR_NAME;
var $dc77c54152e4d9f2$var$IMAGE_NAME = "AvatarImage";
var $dc77c54152e4d9f2$export$2cd8ae1985206fe8 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeAvatar: __scopeAvatar, src: src, onLoadingStatusChange: onLoadingStatusChange = ()=>{}, ...imageProps } = props;
    const context = $dc77c54152e4d9f2$var$useAvatarContext($dc77c54152e4d9f2$var$IMAGE_NAME, __scopeAvatar);
    const imageLoadingStatus = $dc77c54152e4d9f2$var$useImageLoadingStatus(src, imageProps.referrerPolicy);
    const handleLoadingStatusChange = (0, $kjEX1.useCallbackRef)((status)=>{
        onLoadingStatusChange(status);
        context.onImageLoadingStatusChange(status);
    });
    (0, $9crHl.useLayoutEffect)(()=>{
        if (imageLoadingStatus !== "idle") handleLoadingStatusChange(imageLoadingStatus);
    }, [
        imageLoadingStatus,
        handleLoadingStatusChange
    ]);
    return imageLoadingStatus === "loaded" ? /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).img, {
        ...imageProps,
        ref: forwardedRef,
        src: src
    }) : null;
});
$dc77c54152e4d9f2$export$2cd8ae1985206fe8.displayName = $dc77c54152e4d9f2$var$IMAGE_NAME;
var $dc77c54152e4d9f2$var$FALLBACK_NAME = "AvatarFallback";
var $dc77c54152e4d9f2$export$69fffb6a9571fbfe = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeAvatar: __scopeAvatar, delayMs: delayMs, ...fallbackProps } = props;
    const context = $dc77c54152e4d9f2$var$useAvatarContext($dc77c54152e4d9f2$var$FALLBACK_NAME, __scopeAvatar);
    const [canRender, setCanRender] = $jbmdS.useState(delayMs === void 0);
    $jbmdS.useEffect(()=>{
        if (delayMs !== void 0) {
            const timerId = window.setTimeout(()=>setCanRender(true), delayMs);
            return ()=>window.clearTimeout(timerId);
        }
    }, [
        delayMs
    ]);
    return canRender && context.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).span, {
        ...fallbackProps,
        ref: forwardedRef
    }) : null;
});
$dc77c54152e4d9f2$export$69fffb6a9571fbfe.displayName = $dc77c54152e4d9f2$var$FALLBACK_NAME;
function $dc77c54152e4d9f2$var$useImageLoadingStatus(src, referrerPolicy) {
    const [loadingStatus, setLoadingStatus] = $jbmdS.useState("idle");
    (0, $9crHl.useLayoutEffect)(()=>{
        if (!src) {
            setLoadingStatus("error");
            return;
        }
        let isMounted = true;
        const image = new window.Image();
        const updateStatus = (status)=>()=>{
                if (!isMounted) return;
                setLoadingStatus(status);
            };
        setLoadingStatus("loading");
        image.onload = updateStatus("loaded");
        image.onerror = updateStatus("error");
        image.src = src;
        if (referrerPolicy) image.referrerPolicy = referrerPolicy;
        return ()=>{
            isMounted = false;
        };
    }, [
        src,
        referrerPolicy
    ]);
    return loadingStatus;
}
var $dc77c54152e4d9f2$export$be92b6f5f03c0fe9 = $dc77c54152e4d9f2$export$e2255cf6045e8d47;
var $dc77c54152e4d9f2$export$3e431a229df88919 = $dc77c54152e4d9f2$export$2cd8ae1985206fe8;
var $dc77c54152e4d9f2$export$fb8d7f40caaeea67 = $dc77c54152e4d9f2$export$69fffb6a9571fbfe;

});


parcelRegister("8tafh", function(module, exports) {

$parcel$export(module.exports, "DropdownMenu", function () { return $c4759138bdac2ea5$export$e44a253a59704894; });
$parcel$export(module.exports, "DropdownMenuTrigger", function () { return $c4759138bdac2ea5$export$d2469213b3befba9; });
$parcel$export(module.exports, "DropdownMenuSub", function () { return $c4759138bdac2ea5$export$2f307d81a64f5442; });
$parcel$export(module.exports, "DropdownMenuSubTrigger", function () { return $c4759138bdac2ea5$export$21dcb7ec56f874cf; });
$parcel$export(module.exports, "DropdownMenuSubContent", function () { return $c4759138bdac2ea5$export$f34ec8bc2482cc5f; });
$parcel$export(module.exports, "DropdownMenuContent", function () { return $c4759138bdac2ea5$export$6e76d93a37c01248; });
$parcel$export(module.exports, "DropdownMenuItem", function () { return $c4759138bdac2ea5$export$ed97964d1871885d; });
$parcel$export(module.exports, "DropdownMenuSeparator", function () { return $c4759138bdac2ea5$export$da160178fd3bc7e9; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $gTYWj = parcelRequire("gTYWj");

var $1kvoC = parcelRequire("1kvoC");
var $ahXOC = parcelRequire("ahXOC");
var $9mkVX = parcelRequire("9mkVX");

var $Yha9m = parcelRequire("Yha9m");
const $c4759138bdac2ea5$export$e44a253a59704894 = $gTYWj.Root;
const $c4759138bdac2ea5$export$d2469213b3befba9 = $gTYWj.Trigger;
const $c4759138bdac2ea5$export$246bebaba3a2f70e = $gTYWj.Group;
const $c4759138bdac2ea5$export$cd369b4d4d54efc9 = $gTYWj.Portal;
const $c4759138bdac2ea5$export$2f307d81a64f5442 = $gTYWj.Sub;
const $c4759138bdac2ea5$export$3323ad73d55f587e = $gTYWj.RadioGroup;
const $c4759138bdac2ea5$export$21dcb7ec56f874cf = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, inset: inset, children: children, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsxs)($gTYWj.SubTrigger, {
        ref: ref,
        className: (0, $Yha9m.cn)("flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent data-[state=open]:bg-accent", inset && "pl-8", className),
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ahXOC.default), {
                className: "ml-auto h-4 w-4"
            })
        ]
    }));
$c4759138bdac2ea5$export$21dcb7ec56f874cf.displayName = $gTYWj.SubTrigger.displayName;
const $c4759138bdac2ea5$export$f34ec8bc2482cc5f = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)($gTYWj.SubContent, {
        ref: ref,
        className: (0, $Yha9m.cn)("z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", className),
        ...props
    }));
$c4759138bdac2ea5$export$f34ec8bc2482cc5f.displayName = $gTYWj.SubContent.displayName;
const $c4759138bdac2ea5$export$6e76d93a37c01248 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, sideOffset: sideOffset = 4, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)($gTYWj.Portal, {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)($gTYWj.Content, {
            ref: ref,
            sideOffset: sideOffset,
            className: (0, $Yha9m.cn)("z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", className),
            ...props
        })
    }));
$c4759138bdac2ea5$export$6e76d93a37c01248.displayName = $gTYWj.Content.displayName;
const $c4759138bdac2ea5$export$ed97964d1871885d = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, inset: inset, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)($gTYWj.Item, {
        ref: ref,
        className: (0, $Yha9m.cn)("relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50", inset && "pl-8", className),
        ...props
    }));
$c4759138bdac2ea5$export$ed97964d1871885d.displayName = $gTYWj.Item.displayName;
const $c4759138bdac2ea5$export$53a69729da201fa9 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, children: children, checked: checked, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsxs)($gTYWj.CheckboxItem, {
        ref: ref,
        className: (0, $Yha9m.cn)("relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50", className),
        checked: checked,
        ...props,
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)($gTYWj.ItemIndicator, {
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $1kvoC.default), {
                        className: "h-4 w-4"
                    })
                })
            }),
            children
        ]
    }));
$c4759138bdac2ea5$export$53a69729da201fa9.displayName = $gTYWj.CheckboxItem.displayName;
const $c4759138bdac2ea5$export$e4f69b41b1637536 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, children: children, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsxs)($gTYWj.RadioItem, {
        ref: ref,
        className: (0, $Yha9m.cn)("relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50", className),
        ...props,
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)($gTYWj.ItemIndicator, {
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $9mkVX.default), {
                        className: "h-2 w-2 fill-current"
                    })
                })
            }),
            children
        ]
    }));
$c4759138bdac2ea5$export$e4f69b41b1637536.displayName = $gTYWj.RadioItem.displayName;
const $c4759138bdac2ea5$export$76e48c5b57f24495 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, inset: inset, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)($gTYWj.Label, {
        ref: ref,
        className: (0, $Yha9m.cn)("px-2 py-1.5 text-sm font-semibold", inset && "pl-8", className),
        ...props
    }));
$c4759138bdac2ea5$export$76e48c5b57f24495.displayName = $gTYWj.Label.displayName;
const $c4759138bdac2ea5$export$da160178fd3bc7e9 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)($gTYWj.Separator, {
        ref: ref,
        className: (0, $Yha9m.cn)("-mx-1 my-1 h-px bg-muted", className),
        ...props
    }));
$c4759138bdac2ea5$export$da160178fd3bc7e9.displayName = $gTYWj.Separator.displayName;
const $c4759138bdac2ea5$export$b1e098e2962e8df5 = ({ className: className, ...props })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
        className: (0, $Yha9m.cn)("ml-auto text-xs tracking-widest opacity-60", className),
        ...props
    });
};
$c4759138bdac2ea5$export$b1e098e2962e8df5.displayName = "DropdownMenuShortcut";

});
parcelRegister("gTYWj", function(module, exports) {

$parcel$export(module.exports, "Root", function () { return $50eaa85b8f477cda$export$be92b6f5f03c0fe9; });
$parcel$export(module.exports, "Trigger", function () { return $50eaa85b8f477cda$export$41fb9f06171c75f4; });
$parcel$export(module.exports, "Portal", function () { return $50eaa85b8f477cda$export$602eac185826482c; });
$parcel$export(module.exports, "Content", function () { return $50eaa85b8f477cda$export$7c6e2c02157bb7d2; });
$parcel$export(module.exports, "Group", function () { return $50eaa85b8f477cda$export$eb2fcfdbd7ba97d4; });
$parcel$export(module.exports, "Label", function () { return $50eaa85b8f477cda$export$b04be29aa201d4f5; });
$parcel$export(module.exports, "Item", function () { return $50eaa85b8f477cda$export$6d08773d2e66f8f2; });
$parcel$export(module.exports, "CheckboxItem", function () { return $50eaa85b8f477cda$export$16ce288f89fa631c; });
$parcel$export(module.exports, "RadioGroup", function () { return $50eaa85b8f477cda$export$a98f0dcb43a68a25; });
$parcel$export(module.exports, "RadioItem", function () { return $50eaa85b8f477cda$export$371ab307eab489c0; });
$parcel$export(module.exports, "ItemIndicator", function () { return $50eaa85b8f477cda$export$c3468e2714d175fa; });
$parcel$export(module.exports, "Separator", function () { return $50eaa85b8f477cda$export$1ff3c3f08ae963c0; });
$parcel$export(module.exports, "Sub", function () { return $50eaa85b8f477cda$export$d7a01e11500dfb6f; });
$parcel$export(module.exports, "SubTrigger", function () { return $50eaa85b8f477cda$export$2ea8a7a591ac5eac; });
$parcel$export(module.exports, "SubContent", function () { return $50eaa85b8f477cda$export$6d4de93b380beddf; });

var $jbmdS = parcelRequire("jbmdS");

var $hFcKE = parcelRequire("hFcKE");

var $9sunj = parcelRequire("9sunj");

var $f4RZG = parcelRequire("f4RZG");

var $1sq0Q = parcelRequire("1sq0Q");

var $cihg9 = parcelRequire("cihg9");

var $6XGqz = parcelRequire("6XGqz");

var $g7F3X = parcelRequire("g7F3X");

var $4TLFw = parcelRequire("4TLFw");
"use client";
var $50eaa85b8f477cda$var$DROPDOWN_MENU_NAME = "DropdownMenu";
var [$50eaa85b8f477cda$var$createDropdownMenuContext, $50eaa85b8f477cda$export$c0623cd925aeb687] = (0, $f4RZG.createContextScope)($50eaa85b8f477cda$var$DROPDOWN_MENU_NAME, [
    (0, $6XGqz.createMenuScope)
]);
var $50eaa85b8f477cda$var$useMenuScope = (0, $6XGqz.createMenuScope)();
var [$50eaa85b8f477cda$var$DropdownMenuProvider, $50eaa85b8f477cda$var$useDropdownMenuContext] = $50eaa85b8f477cda$var$createDropdownMenuContext($50eaa85b8f477cda$var$DROPDOWN_MENU_NAME);
var $50eaa85b8f477cda$export$e44a253a59704894 = (props)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, children: children, dir: dir, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = true } = props;
    const menuScope = $50eaa85b8f477cda$var$useMenuScope(__scopeDropdownMenu);
    const triggerRef = $jbmdS.useRef(null);
    const [open = false, setOpen] = (0, $1sq0Q.useControllableState)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /* @__PURE__ */ (0, $4TLFw.jsx)($50eaa85b8f477cda$var$DropdownMenuProvider, {
        scope: __scopeDropdownMenu,
        triggerId: (0, $g7F3X.useId)(),
        triggerRef: triggerRef,
        contentId: (0, $g7F3X.useId)(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: $jbmdS.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal: modal,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)($6XGqz.Root, {
            ...menuScope,
            open: open,
            onOpenChange: setOpen,
            dir: dir,
            modal: modal,
            children: children
        })
    });
};
$50eaa85b8f477cda$export$e44a253a59704894.displayName = $50eaa85b8f477cda$var$DROPDOWN_MENU_NAME;
var $50eaa85b8f477cda$var$TRIGGER_NAME = "DropdownMenuTrigger";
var $50eaa85b8f477cda$export$d2469213b3befba9 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, disabled: disabled = false, ...triggerProps } = props;
    const context = $50eaa85b8f477cda$var$useDropdownMenuContext($50eaa85b8f477cda$var$TRIGGER_NAME, __scopeDropdownMenu);
    const menuScope = $50eaa85b8f477cda$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($6XGqz.Anchor, {
        asChild: true,
        ...menuScope,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).button, {
            type: "button",
            id: context.triggerId,
            "aria-haspopup": "menu",
            "aria-expanded": context.open,
            "aria-controls": context.open ? context.contentId : void 0,
            "data-state": context.open ? "open" : "closed",
            "data-disabled": disabled ? "" : void 0,
            disabled: disabled,
            ...triggerProps,
            ref: (0, $9sunj.composeRefs)(forwardedRef, context.triggerRef),
            onPointerDown: (0, $hFcKE.composeEventHandlers)(props.onPointerDown, (event)=>{
                if (!disabled && event.button === 0 && event.ctrlKey === false) {
                    context.onOpenToggle();
                    if (!context.open) event.preventDefault();
                }
            }),
            onKeyDown: (0, $hFcKE.composeEventHandlers)(props.onKeyDown, (event)=>{
                if (disabled) return;
                if ([
                    "Enter",
                    " "
                ].includes(event.key)) context.onOpenToggle();
                if (event.key === "ArrowDown") context.onOpenChange(true);
                if ([
                    "Enter",
                    " ",
                    "ArrowDown"
                ].includes(event.key)) event.preventDefault();
            })
        })
    });
});
$50eaa85b8f477cda$export$d2469213b3befba9.displayName = $50eaa85b8f477cda$var$TRIGGER_NAME;
var $50eaa85b8f477cda$var$PORTAL_NAME = "DropdownMenuPortal";
var $50eaa85b8f477cda$export$cd369b4d4d54efc9 = (props)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...portalProps } = props;
    const menuScope = $50eaa85b8f477cda$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($6XGqz.Portal, {
        ...menuScope,
        ...portalProps
    });
};
$50eaa85b8f477cda$export$cd369b4d4d54efc9.displayName = $50eaa85b8f477cda$var$PORTAL_NAME;
var $50eaa85b8f477cda$var$CONTENT_NAME = "DropdownMenuContent";
var $50eaa85b8f477cda$export$6e76d93a37c01248 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...contentProps } = props;
    const context = $50eaa85b8f477cda$var$useDropdownMenuContext($50eaa85b8f477cda$var$CONTENT_NAME, __scopeDropdownMenu);
    const menuScope = $50eaa85b8f477cda$var$useMenuScope(__scopeDropdownMenu);
    const hasInteractedOutsideRef = $jbmdS.useRef(false);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($6XGqz.Content, {
        id: context.contentId,
        "aria-labelledby": context.triggerId,
        ...menuScope,
        ...contentProps,
        ref: forwardedRef,
        onCloseAutoFocus: (0, $hFcKE.composeEventHandlers)(props.onCloseAutoFocus, (event)=>{
            if (!hasInteractedOutsideRef.current) context.triggerRef.current?.focus();
            hasInteractedOutsideRef.current = false;
            event.preventDefault();
        }),
        onInteractOutside: (0, $hFcKE.composeEventHandlers)(props.onInteractOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            if (!context.modal || isRightClick) hasInteractedOutsideRef.current = true;
        }),
        style: {
            ...props.style,
            "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
            "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
            "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
    });
});
$50eaa85b8f477cda$export$6e76d93a37c01248.displayName = $50eaa85b8f477cda$var$CONTENT_NAME;
var $50eaa85b8f477cda$var$GROUP_NAME = "DropdownMenuGroup";
var $50eaa85b8f477cda$export$246bebaba3a2f70e = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...groupProps } = props;
    const menuScope = $50eaa85b8f477cda$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($6XGqz.Group, {
        ...menuScope,
        ...groupProps,
        ref: forwardedRef
    });
});
$50eaa85b8f477cda$export$246bebaba3a2f70e.displayName = $50eaa85b8f477cda$var$GROUP_NAME;
var $50eaa85b8f477cda$var$LABEL_NAME = "DropdownMenuLabel";
var $50eaa85b8f477cda$export$76e48c5b57f24495 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...labelProps } = props;
    const menuScope = $50eaa85b8f477cda$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($6XGqz.Label, {
        ...menuScope,
        ...labelProps,
        ref: forwardedRef
    });
});
$50eaa85b8f477cda$export$76e48c5b57f24495.displayName = $50eaa85b8f477cda$var$LABEL_NAME;
var $50eaa85b8f477cda$var$ITEM_NAME = "DropdownMenuItem";
var $50eaa85b8f477cda$export$ed97964d1871885d = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...itemProps } = props;
    const menuScope = $50eaa85b8f477cda$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($6XGqz.Item, {
        ...menuScope,
        ...itemProps,
        ref: forwardedRef
    });
});
$50eaa85b8f477cda$export$ed97964d1871885d.displayName = $50eaa85b8f477cda$var$ITEM_NAME;
var $50eaa85b8f477cda$var$CHECKBOX_ITEM_NAME = "DropdownMenuCheckboxItem";
var $50eaa85b8f477cda$export$53a69729da201fa9 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...checkboxItemProps } = props;
    const menuScope = $50eaa85b8f477cda$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($6XGqz.CheckboxItem, {
        ...menuScope,
        ...checkboxItemProps,
        ref: forwardedRef
    });
});
$50eaa85b8f477cda$export$53a69729da201fa9.displayName = $50eaa85b8f477cda$var$CHECKBOX_ITEM_NAME;
var $50eaa85b8f477cda$var$RADIO_GROUP_NAME = "DropdownMenuRadioGroup";
var $50eaa85b8f477cda$export$3323ad73d55f587e = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...radioGroupProps } = props;
    const menuScope = $50eaa85b8f477cda$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($6XGqz.RadioGroup, {
        ...menuScope,
        ...radioGroupProps,
        ref: forwardedRef
    });
});
$50eaa85b8f477cda$export$3323ad73d55f587e.displayName = $50eaa85b8f477cda$var$RADIO_GROUP_NAME;
var $50eaa85b8f477cda$var$RADIO_ITEM_NAME = "DropdownMenuRadioItem";
var $50eaa85b8f477cda$export$e4f69b41b1637536 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...radioItemProps } = props;
    const menuScope = $50eaa85b8f477cda$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($6XGqz.RadioItem, {
        ...menuScope,
        ...radioItemProps,
        ref: forwardedRef
    });
});
$50eaa85b8f477cda$export$e4f69b41b1637536.displayName = $50eaa85b8f477cda$var$RADIO_ITEM_NAME;
var $50eaa85b8f477cda$var$INDICATOR_NAME = "DropdownMenuItemIndicator";
var $50eaa85b8f477cda$export$42355ae145153fb6 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...itemIndicatorProps } = props;
    const menuScope = $50eaa85b8f477cda$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($6XGqz.ItemIndicator, {
        ...menuScope,
        ...itemIndicatorProps,
        ref: forwardedRef
    });
});
$50eaa85b8f477cda$export$42355ae145153fb6.displayName = $50eaa85b8f477cda$var$INDICATOR_NAME;
var $50eaa85b8f477cda$var$SEPARATOR_NAME = "DropdownMenuSeparator";
var $50eaa85b8f477cda$export$da160178fd3bc7e9 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...separatorProps } = props;
    const menuScope = $50eaa85b8f477cda$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($6XGqz.Separator, {
        ...menuScope,
        ...separatorProps,
        ref: forwardedRef
    });
});
$50eaa85b8f477cda$export$da160178fd3bc7e9.displayName = $50eaa85b8f477cda$var$SEPARATOR_NAME;
var $50eaa85b8f477cda$var$ARROW_NAME = "DropdownMenuArrow";
var $50eaa85b8f477cda$export$34b8980744021ec5 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...arrowProps } = props;
    const menuScope = $50eaa85b8f477cda$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($6XGqz.Arrow, {
        ...menuScope,
        ...arrowProps,
        ref: forwardedRef
    });
});
$50eaa85b8f477cda$export$34b8980744021ec5.displayName = $50eaa85b8f477cda$var$ARROW_NAME;
var $50eaa85b8f477cda$export$2f307d81a64f5442 = (props)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, children: children, open: openProp, onOpenChange: onOpenChange, defaultOpen: defaultOpen } = props;
    const menuScope = $50eaa85b8f477cda$var$useMenuScope(__scopeDropdownMenu);
    const [open = false, setOpen] = (0, $1sq0Q.useControllableState)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /* @__PURE__ */ (0, $4TLFw.jsx)($6XGqz.Sub, {
        ...menuScope,
        open: open,
        onOpenChange: setOpen,
        children: children
    });
};
var $50eaa85b8f477cda$var$SUB_TRIGGER_NAME = "DropdownMenuSubTrigger";
var $50eaa85b8f477cda$export$21dcb7ec56f874cf = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...subTriggerProps } = props;
    const menuScope = $50eaa85b8f477cda$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($6XGqz.SubTrigger, {
        ...menuScope,
        ...subTriggerProps,
        ref: forwardedRef
    });
});
$50eaa85b8f477cda$export$21dcb7ec56f874cf.displayName = $50eaa85b8f477cda$var$SUB_TRIGGER_NAME;
var $50eaa85b8f477cda$var$SUB_CONTENT_NAME = "DropdownMenuSubContent";
var $50eaa85b8f477cda$export$f34ec8bc2482cc5f = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...subContentProps } = props;
    const menuScope = $50eaa85b8f477cda$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($6XGqz.SubContent, {
        ...menuScope,
        ...subContentProps,
        ref: forwardedRef,
        style: {
            ...props.style,
            "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
            "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
            "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
    });
});
$50eaa85b8f477cda$export$f34ec8bc2482cc5f.displayName = $50eaa85b8f477cda$var$SUB_CONTENT_NAME;
var $50eaa85b8f477cda$export$be92b6f5f03c0fe9 = $50eaa85b8f477cda$export$e44a253a59704894;
var $50eaa85b8f477cda$export$41fb9f06171c75f4 = $50eaa85b8f477cda$export$d2469213b3befba9;
var $50eaa85b8f477cda$export$602eac185826482c = $50eaa85b8f477cda$export$cd369b4d4d54efc9;
var $50eaa85b8f477cda$export$7c6e2c02157bb7d2 = $50eaa85b8f477cda$export$6e76d93a37c01248;
var $50eaa85b8f477cda$export$eb2fcfdbd7ba97d4 = $50eaa85b8f477cda$export$246bebaba3a2f70e;
var $50eaa85b8f477cda$export$b04be29aa201d4f5 = $50eaa85b8f477cda$export$76e48c5b57f24495;
var $50eaa85b8f477cda$export$6d08773d2e66f8f2 = $50eaa85b8f477cda$export$ed97964d1871885d;
var $50eaa85b8f477cda$export$16ce288f89fa631c = $50eaa85b8f477cda$export$53a69729da201fa9;
var $50eaa85b8f477cda$export$a98f0dcb43a68a25 = $50eaa85b8f477cda$export$3323ad73d55f587e;
var $50eaa85b8f477cda$export$371ab307eab489c0 = $50eaa85b8f477cda$export$e4f69b41b1637536;
var $50eaa85b8f477cda$export$c3468e2714d175fa = $50eaa85b8f477cda$export$42355ae145153fb6;
var $50eaa85b8f477cda$export$1ff3c3f08ae963c0 = $50eaa85b8f477cda$export$da160178fd3bc7e9;
var $50eaa85b8f477cda$export$21b07c8f274aebd5 = $50eaa85b8f477cda$export$34b8980744021ec5;
var $50eaa85b8f477cda$export$d7a01e11500dfb6f = $50eaa85b8f477cda$export$2f307d81a64f5442;
var $50eaa85b8f477cda$export$2ea8a7a591ac5eac = $50eaa85b8f477cda$export$21dcb7ec56f874cf;
var $50eaa85b8f477cda$export$6d4de93b380beddf = $50eaa85b8f477cda$export$f34ec8bc2482cc5f;

});
parcelRegister("6XGqz", function(module, exports) {

$parcel$export(module.exports, "createMenuScope", function () { return $18f76aa3354546f2$export$4027731b685e72eb; });
$parcel$export(module.exports, "Root", function () { return $18f76aa3354546f2$export$be92b6f5f03c0fe9; });
$parcel$export(module.exports, "Anchor", function () { return $18f76aa3354546f2$export$b688253958b8dfe7; });
$parcel$export(module.exports, "Portal", function () { return $18f76aa3354546f2$export$602eac185826482c; });
$parcel$export(module.exports, "Content", function () { return $18f76aa3354546f2$export$7c6e2c02157bb7d2; });
$parcel$export(module.exports, "Group", function () { return $18f76aa3354546f2$export$eb2fcfdbd7ba97d4; });
$parcel$export(module.exports, "Label", function () { return $18f76aa3354546f2$export$b04be29aa201d4f5; });
$parcel$export(module.exports, "Item", function () { return $18f76aa3354546f2$export$6d08773d2e66f8f2; });
$parcel$export(module.exports, "CheckboxItem", function () { return $18f76aa3354546f2$export$16ce288f89fa631c; });
$parcel$export(module.exports, "RadioGroup", function () { return $18f76aa3354546f2$export$a98f0dcb43a68a25; });
$parcel$export(module.exports, "RadioItem", function () { return $18f76aa3354546f2$export$371ab307eab489c0; });
$parcel$export(module.exports, "ItemIndicator", function () { return $18f76aa3354546f2$export$c3468e2714d175fa; });
$parcel$export(module.exports, "Separator", function () { return $18f76aa3354546f2$export$1ff3c3f08ae963c0; });
$parcel$export(module.exports, "Arrow", function () { return $18f76aa3354546f2$export$21b07c8f274aebd5; });
$parcel$export(module.exports, "Sub", function () { return $18f76aa3354546f2$export$d7a01e11500dfb6f; });
$parcel$export(module.exports, "SubTrigger", function () { return $18f76aa3354546f2$export$2ea8a7a591ac5eac; });
$parcel$export(module.exports, "SubContent", function () { return $18f76aa3354546f2$export$6d4de93b380beddf; });

var $jbmdS = parcelRequire("jbmdS");

var $hFcKE = parcelRequire("hFcKE");

var $g2eqD = parcelRequire("g2eqD");

var $9sunj = parcelRequire("9sunj");

var $f4RZG = parcelRequire("f4RZG");

var $9czjk = parcelRequire("9czjk");

var $jJBMp = parcelRequire("jJBMp");

var $fbZ8r = parcelRequire("fbZ8r");

var $i3HOY = parcelRequire("i3HOY");

var $g7F3X = parcelRequire("g7F3X");

var $aU3NZ = parcelRequire("aU3NZ");

var $fKp8B = parcelRequire("fKp8B");

var $joHB8 = parcelRequire("joHB8");

var $cihg9 = parcelRequire("cihg9");

var $cmy02 = parcelRequire("cmy02");

var $bXq35 = parcelRequire("bXq35");

var $kjEX1 = parcelRequire("kjEX1");

var $9Y02g = parcelRequire("9Y02g");

var $gQkjX = parcelRequire("gQkjX");

var $4TLFw = parcelRequire("4TLFw");
"use client";
var $18f76aa3354546f2$var$SELECTION_KEYS = [
    "Enter",
    " "
];
var $18f76aa3354546f2$var$FIRST_KEYS = [
    "ArrowDown",
    "PageUp",
    "Home"
];
var $18f76aa3354546f2$var$LAST_KEYS = [
    "ArrowUp",
    "PageDown",
    "End"
];
var $18f76aa3354546f2$var$FIRST_LAST_KEYS = [
    ...$18f76aa3354546f2$var$FIRST_KEYS,
    ...$18f76aa3354546f2$var$LAST_KEYS
];
var $18f76aa3354546f2$var$SUB_OPEN_KEYS = {
    ltr: [
        ...$18f76aa3354546f2$var$SELECTION_KEYS,
        "ArrowRight"
    ],
    rtl: [
        ...$18f76aa3354546f2$var$SELECTION_KEYS,
        "ArrowLeft"
    ]
};
var $18f76aa3354546f2$var$SUB_CLOSE_KEYS = {
    ltr: [
        "ArrowLeft"
    ],
    rtl: [
        "ArrowRight"
    ]
};
var $18f76aa3354546f2$var$MENU_NAME = "Menu";
var [$18f76aa3354546f2$var$Collection, $18f76aa3354546f2$var$useCollection, $18f76aa3354546f2$var$createCollectionScope] = (0, $g2eqD.createCollection)($18f76aa3354546f2$var$MENU_NAME);
var [$18f76aa3354546f2$var$createMenuContext, $18f76aa3354546f2$export$4027731b685e72eb] = (0, $f4RZG.createContextScope)($18f76aa3354546f2$var$MENU_NAME, [
    $18f76aa3354546f2$var$createCollectionScope,
    (0, $aU3NZ.createPopperScope),
    (0, $cmy02.createRovingFocusGroupScope)
]);
var $18f76aa3354546f2$var$usePopperScope = (0, $aU3NZ.createPopperScope)();
var $18f76aa3354546f2$var$useRovingFocusGroupScope = (0, $cmy02.createRovingFocusGroupScope)();
var [$18f76aa3354546f2$var$MenuProvider, $18f76aa3354546f2$var$useMenuContext] = $18f76aa3354546f2$var$createMenuContext($18f76aa3354546f2$var$MENU_NAME);
var [$18f76aa3354546f2$var$MenuRootProvider, $18f76aa3354546f2$var$useMenuRootContext] = $18f76aa3354546f2$var$createMenuContext($18f76aa3354546f2$var$MENU_NAME);
var $18f76aa3354546f2$export$d9b273488cd8ce6f = (props)=>{
    const { __scopeMenu: __scopeMenu, open: open = false, children: children, dir: dir, onOpenChange: onOpenChange, modal: modal = true } = props;
    const popperScope = $18f76aa3354546f2$var$usePopperScope(__scopeMenu);
    const [content, setContent] = $jbmdS.useState(null);
    const isUsingKeyboardRef = $jbmdS.useRef(false);
    const handleOpenChange = (0, $kjEX1.useCallbackRef)(onOpenChange);
    const direction = (0, $9czjk.useDirection)(dir);
    $jbmdS.useEffect(()=>{
        const handleKeyDown = ()=>{
            isUsingKeyboardRef.current = true;
            document.addEventListener("pointerdown", handlePointer, {
                capture: true,
                once: true
            });
            document.addEventListener("pointermove", handlePointer, {
                capture: true,
                once: true
            });
        };
        const handlePointer = ()=>isUsingKeyboardRef.current = false;
        document.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
            document.removeEventListener("pointerdown", handlePointer, {
                capture: true
            });
            document.removeEventListener("pointermove", handlePointer, {
                capture: true
            });
        };
    }, []);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($aU3NZ.Root, {
        ...popperScope,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)($18f76aa3354546f2$var$MenuProvider, {
            scope: __scopeMenu,
            open: open,
            onOpenChange: handleOpenChange,
            content: content,
            onContentChange: setContent,
            children: /* @__PURE__ */ (0, $4TLFw.jsx)($18f76aa3354546f2$var$MenuRootProvider, {
                scope: __scopeMenu,
                onClose: $jbmdS.useCallback(()=>handleOpenChange(false), [
                    handleOpenChange
                ]),
                isUsingKeyboardRef: isUsingKeyboardRef,
                dir: direction,
                modal: modal,
                children: children
            })
        })
    });
};
$18f76aa3354546f2$export$d9b273488cd8ce6f.displayName = $18f76aa3354546f2$var$MENU_NAME;
var $18f76aa3354546f2$var$ANCHOR_NAME = "MenuAnchor";
var $18f76aa3354546f2$export$9fa5ebd18bee4d43 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...anchorProps } = props;
    const popperScope = $18f76aa3354546f2$var$usePopperScope(__scopeMenu);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($aU3NZ.Anchor, {
        ...popperScope,
        ...anchorProps,
        ref: forwardedRef
    });
});
$18f76aa3354546f2$export$9fa5ebd18bee4d43.displayName = $18f76aa3354546f2$var$ANCHOR_NAME;
var $18f76aa3354546f2$var$PORTAL_NAME = "MenuPortal";
var [$18f76aa3354546f2$var$PortalProvider, $18f76aa3354546f2$var$usePortalContext] = $18f76aa3354546f2$var$createMenuContext($18f76aa3354546f2$var$PORTAL_NAME, {
    forceMount: void 0
});
var $18f76aa3354546f2$export$793392f970497feb = (props)=>{
    const { __scopeMenu: __scopeMenu, forceMount: forceMount, children: children, container: container } = props;
    const context = $18f76aa3354546f2$var$useMenuContext($18f76aa3354546f2$var$PORTAL_NAME, __scopeMenu);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($18f76aa3354546f2$var$PortalProvider, {
        scope: __scopeMenu,
        forceMount: forceMount,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $joHB8.Presence), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $fKp8B.Portal), {
                asChild: true,
                container: container,
                children: children
            })
        })
    });
};
$18f76aa3354546f2$export$793392f970497feb.displayName = $18f76aa3354546f2$var$PORTAL_NAME;
var $18f76aa3354546f2$var$CONTENT_NAME = "MenuContent";
var [$18f76aa3354546f2$var$MenuContentProvider, $18f76aa3354546f2$var$useMenuContentContext] = $18f76aa3354546f2$var$createMenuContext($18f76aa3354546f2$var$CONTENT_NAME);
var $18f76aa3354546f2$export$479f0f2f71193efe = $jbmdS.forwardRef((props, forwardedRef)=>{
    const portalContext = $18f76aa3354546f2$var$usePortalContext($18f76aa3354546f2$var$CONTENT_NAME, props.__scopeMenu);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $18f76aa3354546f2$var$useMenuContext($18f76aa3354546f2$var$CONTENT_NAME, props.__scopeMenu);
    const rootContext = $18f76aa3354546f2$var$useMenuRootContext($18f76aa3354546f2$var$CONTENT_NAME, props.__scopeMenu);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($18f76aa3354546f2$var$Collection.Provider, {
        scope: props.__scopeMenu,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $joHB8.Presence), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, $4TLFw.jsx)($18f76aa3354546f2$var$Collection.Slot, {
                scope: props.__scopeMenu,
                children: rootContext.modal ? /* @__PURE__ */ (0, $4TLFw.jsx)($18f76aa3354546f2$var$MenuRootContentModal, {
                    ...contentProps,
                    ref: forwardedRef
                }) : /* @__PURE__ */ (0, $4TLFw.jsx)($18f76aa3354546f2$var$MenuRootContentNonModal, {
                    ...contentProps,
                    ref: forwardedRef
                })
            })
        })
    });
});
var $18f76aa3354546f2$var$MenuRootContentModal = $jbmdS.forwardRef((props, forwardedRef)=>{
    const context = $18f76aa3354546f2$var$useMenuContext($18f76aa3354546f2$var$CONTENT_NAME, props.__scopeMenu);
    const ref = $jbmdS.useRef(null);
    const composedRefs = (0, $9sunj.useComposedRefs)(forwardedRef, ref);
    $jbmdS.useEffect(()=>{
        const content = ref.current;
        if (content) return (0, $9Y02g.hideOthers)(content);
    }, []);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($18f76aa3354546f2$var$MenuContentImpl, {
        ...props,
        ref: composedRefs,
        trapFocus: context.open,
        disableOutsidePointerEvents: context.open,
        disableOutsideScroll: true,
        onFocusOutside: (0, $hFcKE.composeEventHandlers)(props.onFocusOutside, (event)=>event.preventDefault(), {
            checkForDefaultPrevented: false
        }),
        onDismiss: ()=>context.onOpenChange(false)
    });
});
var $18f76aa3354546f2$var$MenuRootContentNonModal = $jbmdS.forwardRef((props, forwardedRef)=>{
    const context = $18f76aa3354546f2$var$useMenuContext($18f76aa3354546f2$var$CONTENT_NAME, props.__scopeMenu);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($18f76aa3354546f2$var$MenuContentImpl, {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        disableOutsideScroll: false,
        onDismiss: ()=>context.onOpenChange(false)
    });
});
var $18f76aa3354546f2$var$MenuContentImpl = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, loop: loop = false, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, disableOutsidePointerEvents: disableOutsidePointerEvents, onEntryFocus: onEntryFocus, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, disableOutsideScroll: disableOutsideScroll, ...contentProps } = props;
    const context = $18f76aa3354546f2$var$useMenuContext($18f76aa3354546f2$var$CONTENT_NAME, __scopeMenu);
    const rootContext = $18f76aa3354546f2$var$useMenuRootContext($18f76aa3354546f2$var$CONTENT_NAME, __scopeMenu);
    const popperScope = $18f76aa3354546f2$var$usePopperScope(__scopeMenu);
    const rovingFocusGroupScope = $18f76aa3354546f2$var$useRovingFocusGroupScope(__scopeMenu);
    const getItems = $18f76aa3354546f2$var$useCollection(__scopeMenu);
    const [currentItemId, setCurrentItemId] = $jbmdS.useState(null);
    const contentRef = $jbmdS.useRef(null);
    const composedRefs = (0, $9sunj.useComposedRefs)(forwardedRef, contentRef, context.onContentChange);
    const timerRef = $jbmdS.useRef(0);
    const searchRef = $jbmdS.useRef("");
    const pointerGraceTimerRef = $jbmdS.useRef(0);
    const pointerGraceIntentRef = $jbmdS.useRef(null);
    const pointerDirRef = $jbmdS.useRef("right");
    const lastPointerXRef = $jbmdS.useRef(0);
    const ScrollLockWrapper = disableOutsideScroll ? (0, $gQkjX.default) : $jbmdS.Fragment;
    const scrollLockWrapperProps = disableOutsideScroll ? {
        as: (0, $bXq35.Slot),
        allowPinchZoom: true
    } : void 0;
    const handleTypeaheadSearch = (key)=>{
        const search = searchRef.current + key;
        const items = getItems().filter((item)=>!item.disabled);
        const currentItem = document.activeElement;
        const currentMatch = items.find((item)=>item.ref.current === currentItem)?.textValue;
        const values = items.map((item)=>item.textValue);
        const nextMatch = $18f76aa3354546f2$var$getNextMatch(values, search, currentMatch);
        const newItem = items.find((item)=>item.textValue === nextMatch)?.ref.current;
        (function updateSearch(value) {
            searchRef.current = value;
            window.clearTimeout(timerRef.current);
            if (value !== "") timerRef.current = window.setTimeout(()=>updateSearch(""), 1e3);
        })(search);
        if (newItem) setTimeout(()=>newItem.focus());
    };
    $jbmdS.useEffect(()=>{
        return ()=>window.clearTimeout(timerRef.current);
    }, []);
    (0, $fbZ8r.useFocusGuards)();
    const isPointerMovingToSubmenu = $jbmdS.useCallback((event)=>{
        const isMovingTowards = pointerDirRef.current === pointerGraceIntentRef.current?.side;
        return isMovingTowards && $18f76aa3354546f2$var$isPointerInGraceArea(event, pointerGraceIntentRef.current?.area);
    }, []);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($18f76aa3354546f2$var$MenuContentProvider, {
        scope: __scopeMenu,
        searchRef: searchRef,
        onItemEnter: $jbmdS.useCallback((event)=>{
            if (isPointerMovingToSubmenu(event)) event.preventDefault();
        }, [
            isPointerMovingToSubmenu
        ]),
        onItemLeave: $jbmdS.useCallback((event)=>{
            if (isPointerMovingToSubmenu(event)) return;
            contentRef.current?.focus();
            setCurrentItemId(null);
        }, [
            isPointerMovingToSubmenu
        ]),
        onTriggerLeave: $jbmdS.useCallback((event)=>{
            if (isPointerMovingToSubmenu(event)) event.preventDefault();
        }, [
            isPointerMovingToSubmenu
        ]),
        pointerGraceTimerRef: pointerGraceTimerRef,
        onPointerGraceIntentChange: $jbmdS.useCallback((intent)=>{
            pointerGraceIntentRef.current = intent;
        }, []),
        children: /* @__PURE__ */ (0, $4TLFw.jsx)(ScrollLockWrapper, {
            ...scrollLockWrapperProps,
            children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $i3HOY.FocusScope), {
                asChild: true,
                trapped: trapFocus,
                onMountAutoFocus: (0, $hFcKE.composeEventHandlers)(onOpenAutoFocus, (event)=>{
                    event.preventDefault();
                    contentRef.current?.focus({
                        preventScroll: true
                    });
                }),
                onUnmountAutoFocus: onCloseAutoFocus,
                children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $jJBMp.DismissableLayer), {
                    asChild: true,
                    disableOutsidePointerEvents: disableOutsidePointerEvents,
                    onEscapeKeyDown: onEscapeKeyDown,
                    onPointerDownOutside: onPointerDownOutside,
                    onFocusOutside: onFocusOutside,
                    onInteractOutside: onInteractOutside,
                    onDismiss: onDismiss,
                    children: /* @__PURE__ */ (0, $4TLFw.jsx)($cmy02.Root, {
                        asChild: true,
                        ...rovingFocusGroupScope,
                        dir: rootContext.dir,
                        orientation: "vertical",
                        loop: loop,
                        currentTabStopId: currentItemId,
                        onCurrentTabStopIdChange: setCurrentItemId,
                        onEntryFocus: (0, $hFcKE.composeEventHandlers)(onEntryFocus, (event)=>{
                            if (!rootContext.isUsingKeyboardRef.current) event.preventDefault();
                        }),
                        preventScrollOnEntryFocus: true,
                        children: /* @__PURE__ */ (0, $4TLFw.jsx)($aU3NZ.Content, {
                            role: "menu",
                            "aria-orientation": "vertical",
                            "data-state": $18f76aa3354546f2$var$getOpenState(context.open),
                            "data-radix-menu-content": "",
                            dir: rootContext.dir,
                            ...popperScope,
                            ...contentProps,
                            ref: composedRefs,
                            style: {
                                outline: "none",
                                ...contentProps.style
                            },
                            onKeyDown: (0, $hFcKE.composeEventHandlers)(contentProps.onKeyDown, (event)=>{
                                const target = event.target;
                                const isKeyDownInside = target.closest("[data-radix-menu-content]") === event.currentTarget;
                                const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
                                const isCharacterKey = event.key.length === 1;
                                if (isKeyDownInside) {
                                    if (event.key === "Tab") event.preventDefault();
                                    if (!isModifierKey && isCharacterKey) handleTypeaheadSearch(event.key);
                                }
                                const content = contentRef.current;
                                if (event.target !== content) return;
                                if (!$18f76aa3354546f2$var$FIRST_LAST_KEYS.includes(event.key)) return;
                                event.preventDefault();
                                const items = getItems().filter((item)=>!item.disabled);
                                const candidateNodes = items.map((item)=>item.ref.current);
                                if ($18f76aa3354546f2$var$LAST_KEYS.includes(event.key)) candidateNodes.reverse();
                                $18f76aa3354546f2$var$focusFirst(candidateNodes);
                            }),
                            onBlur: (0, $hFcKE.composeEventHandlers)(props.onBlur, (event)=>{
                                if (!event.currentTarget.contains(event.target)) {
                                    window.clearTimeout(timerRef.current);
                                    searchRef.current = "";
                                }
                            }),
                            onPointerMove: (0, $hFcKE.composeEventHandlers)(props.onPointerMove, $18f76aa3354546f2$var$whenMouse((event)=>{
                                const target = event.target;
                                const pointerXHasChanged = lastPointerXRef.current !== event.clientX;
                                if (event.currentTarget.contains(target) && pointerXHasChanged) {
                                    const newDir = event.clientX > lastPointerXRef.current ? "right" : "left";
                                    pointerDirRef.current = newDir;
                                    lastPointerXRef.current = event.clientX;
                                }
                            }))
                        })
                    })
                })
            })
        })
    });
});
$18f76aa3354546f2$export$479f0f2f71193efe.displayName = $18f76aa3354546f2$var$CONTENT_NAME;
var $18f76aa3354546f2$var$GROUP_NAME = "MenuGroup";
var $18f76aa3354546f2$export$22a631d1f72787bb = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...groupProps } = props;
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).div, {
        role: "group",
        ...groupProps,
        ref: forwardedRef
    });
});
$18f76aa3354546f2$export$22a631d1f72787bb.displayName = $18f76aa3354546f2$var$GROUP_NAME;
var $18f76aa3354546f2$var$LABEL_NAME = "MenuLabel";
var $18f76aa3354546f2$export$dd37bec0e8a99143 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...labelProps } = props;
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).div, {
        ...labelProps,
        ref: forwardedRef
    });
});
$18f76aa3354546f2$export$dd37bec0e8a99143.displayName = $18f76aa3354546f2$var$LABEL_NAME;
var $18f76aa3354546f2$var$ITEM_NAME = "MenuItem";
var $18f76aa3354546f2$var$ITEM_SELECT = "menu.itemSelect";
var $18f76aa3354546f2$export$2ce376c2cc3355c8 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { disabled: disabled = false, onSelect: onSelect, ...itemProps } = props;
    const ref = $jbmdS.useRef(null);
    const rootContext = $18f76aa3354546f2$var$useMenuRootContext($18f76aa3354546f2$var$ITEM_NAME, props.__scopeMenu);
    const contentContext = $18f76aa3354546f2$var$useMenuContentContext($18f76aa3354546f2$var$ITEM_NAME, props.__scopeMenu);
    const composedRefs = (0, $9sunj.useComposedRefs)(forwardedRef, ref);
    const isPointerDownRef = $jbmdS.useRef(false);
    const handleSelect = ()=>{
        const menuItem = ref.current;
        if (!disabled && menuItem) {
            const itemSelectEvent = new CustomEvent($18f76aa3354546f2$var$ITEM_SELECT, {
                bubbles: true,
                cancelable: true
            });
            menuItem.addEventListener($18f76aa3354546f2$var$ITEM_SELECT, (event)=>onSelect?.(event), {
                once: true
            });
            (0, $cihg9.dispatchDiscreteCustomEvent)(menuItem, itemSelectEvent);
            if (itemSelectEvent.defaultPrevented) isPointerDownRef.current = false;
            else rootContext.onClose();
        }
    };
    return /* @__PURE__ */ (0, $4TLFw.jsx)($18f76aa3354546f2$var$MenuItemImpl, {
        ...itemProps,
        ref: composedRefs,
        disabled: disabled,
        onClick: (0, $hFcKE.composeEventHandlers)(props.onClick, handleSelect),
        onPointerDown: (event)=>{
            props.onPointerDown?.(event);
            isPointerDownRef.current = true;
        },
        onPointerUp: (0, $hFcKE.composeEventHandlers)(props.onPointerUp, (event)=>{
            if (!isPointerDownRef.current) event.currentTarget?.click();
        }),
        onKeyDown: (0, $hFcKE.composeEventHandlers)(props.onKeyDown, (event)=>{
            const isTypingAhead = contentContext.searchRef.current !== "";
            if (disabled || isTypingAhead && event.key === " ") return;
            if ($18f76aa3354546f2$var$SELECTION_KEYS.includes(event.key)) {
                event.currentTarget.click();
                event.preventDefault();
            }
        })
    });
});
$18f76aa3354546f2$export$2ce376c2cc3355c8.displayName = $18f76aa3354546f2$var$ITEM_NAME;
var $18f76aa3354546f2$var$MenuItemImpl = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, disabled: disabled = false, textValue: textValue, ...itemProps } = props;
    const contentContext = $18f76aa3354546f2$var$useMenuContentContext($18f76aa3354546f2$var$ITEM_NAME, __scopeMenu);
    const rovingFocusGroupScope = $18f76aa3354546f2$var$useRovingFocusGroupScope(__scopeMenu);
    const ref = $jbmdS.useRef(null);
    const composedRefs = (0, $9sunj.useComposedRefs)(forwardedRef, ref);
    const [isFocused, setIsFocused] = $jbmdS.useState(false);
    const [textContent, setTextContent] = $jbmdS.useState("");
    $jbmdS.useEffect(()=>{
        const menuItem = ref.current;
        if (menuItem) setTextContent((menuItem.textContent ?? "").trim());
    }, [
        itemProps.children
    ]);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($18f76aa3354546f2$var$Collection.ItemSlot, {
        scope: __scopeMenu,
        disabled: disabled,
        textValue: textValue ?? textContent,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)($cmy02.Item, {
            asChild: true,
            ...rovingFocusGroupScope,
            focusable: !disabled,
            children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).div, {
                role: "menuitem",
                "data-highlighted": isFocused ? "" : void 0,
                "aria-disabled": disabled || void 0,
                "data-disabled": disabled ? "" : void 0,
                ...itemProps,
                ref: composedRefs,
                onPointerMove: (0, $hFcKE.composeEventHandlers)(props.onPointerMove, $18f76aa3354546f2$var$whenMouse((event)=>{
                    if (disabled) contentContext.onItemLeave(event);
                    else {
                        contentContext.onItemEnter(event);
                        if (!event.defaultPrevented) {
                            const item = event.currentTarget;
                            item.focus({
                                preventScroll: true
                            });
                        }
                    }
                })),
                onPointerLeave: (0, $hFcKE.composeEventHandlers)(props.onPointerLeave, $18f76aa3354546f2$var$whenMouse((event)=>contentContext.onItemLeave(event))),
                onFocus: (0, $hFcKE.composeEventHandlers)(props.onFocus, ()=>setIsFocused(true)),
                onBlur: (0, $hFcKE.composeEventHandlers)(props.onBlur, ()=>setIsFocused(false))
            })
        })
    });
});
var $18f76aa3354546f2$var$CHECKBOX_ITEM_NAME = "MenuCheckboxItem";
var $18f76aa3354546f2$export$f6f243521332502d = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { checked: checked = false, onCheckedChange: onCheckedChange, ...checkboxItemProps } = props;
    return /* @__PURE__ */ (0, $4TLFw.jsx)($18f76aa3354546f2$var$ItemIndicatorProvider, {
        scope: props.__scopeMenu,
        checked: checked,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)($18f76aa3354546f2$export$2ce376c2cc3355c8, {
            role: "menuitemcheckbox",
            "aria-checked": $18f76aa3354546f2$var$isIndeterminate(checked) ? "mixed" : checked,
            ...checkboxItemProps,
            ref: forwardedRef,
            "data-state": $18f76aa3354546f2$var$getCheckedState(checked),
            onSelect: (0, $hFcKE.composeEventHandlers)(checkboxItemProps.onSelect, ()=>onCheckedChange?.($18f76aa3354546f2$var$isIndeterminate(checked) ? true : !checked), {
                checkForDefaultPrevented: false
            })
        })
    });
});
$18f76aa3354546f2$export$f6f243521332502d.displayName = $18f76aa3354546f2$var$CHECKBOX_ITEM_NAME;
var $18f76aa3354546f2$var$RADIO_GROUP_NAME = "MenuRadioGroup";
var [$18f76aa3354546f2$var$RadioGroupProvider, $18f76aa3354546f2$var$useRadioGroupContext] = $18f76aa3354546f2$var$createMenuContext($18f76aa3354546f2$var$RADIO_GROUP_NAME, {
    value: void 0,
    onValueChange: ()=>{}
});
var $18f76aa3354546f2$export$ea2200c9eee416b3 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { value: value, onValueChange: onValueChange, ...groupProps } = props;
    const handleValueChange = (0, $kjEX1.useCallbackRef)(onValueChange);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($18f76aa3354546f2$var$RadioGroupProvider, {
        scope: props.__scopeMenu,
        value: value,
        onValueChange: handleValueChange,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)($18f76aa3354546f2$export$22a631d1f72787bb, {
            ...groupProps,
            ref: forwardedRef
        })
    });
});
$18f76aa3354546f2$export$ea2200c9eee416b3.displayName = $18f76aa3354546f2$var$RADIO_GROUP_NAME;
var $18f76aa3354546f2$var$RADIO_ITEM_NAME = "MenuRadioItem";
var $18f76aa3354546f2$export$69bd225e9817f6d0 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { value: value, ...radioItemProps } = props;
    const context = $18f76aa3354546f2$var$useRadioGroupContext($18f76aa3354546f2$var$RADIO_ITEM_NAME, props.__scopeMenu);
    const checked = value === context.value;
    return /* @__PURE__ */ (0, $4TLFw.jsx)($18f76aa3354546f2$var$ItemIndicatorProvider, {
        scope: props.__scopeMenu,
        checked: checked,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)($18f76aa3354546f2$export$2ce376c2cc3355c8, {
            role: "menuitemradio",
            "aria-checked": checked,
            ...radioItemProps,
            ref: forwardedRef,
            "data-state": $18f76aa3354546f2$var$getCheckedState(checked),
            onSelect: (0, $hFcKE.composeEventHandlers)(radioItemProps.onSelect, ()=>context.onValueChange?.(value), {
                checkForDefaultPrevented: false
            })
        })
    });
});
$18f76aa3354546f2$export$69bd225e9817f6d0.displayName = $18f76aa3354546f2$var$RADIO_ITEM_NAME;
var $18f76aa3354546f2$var$ITEM_INDICATOR_NAME = "MenuItemIndicator";
var [$18f76aa3354546f2$var$ItemIndicatorProvider, $18f76aa3354546f2$var$useItemIndicatorContext] = $18f76aa3354546f2$var$createMenuContext($18f76aa3354546f2$var$ITEM_INDICATOR_NAME, {
    checked: false
});
var $18f76aa3354546f2$export$a2593e23056970a3 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, forceMount: forceMount, ...itemIndicatorProps } = props;
    const indicatorContext = $18f76aa3354546f2$var$useItemIndicatorContext($18f76aa3354546f2$var$ITEM_INDICATOR_NAME, __scopeMenu);
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $joHB8.Presence), {
        present: forceMount || $18f76aa3354546f2$var$isIndeterminate(indicatorContext.checked) || indicatorContext.checked === true,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).span, {
            ...itemIndicatorProps,
            ref: forwardedRef,
            "data-state": $18f76aa3354546f2$var$getCheckedState(indicatorContext.checked)
        })
    });
});
$18f76aa3354546f2$export$a2593e23056970a3.displayName = $18f76aa3354546f2$var$ITEM_INDICATOR_NAME;
var $18f76aa3354546f2$var$SEPARATOR_NAME = "MenuSeparator";
var $18f76aa3354546f2$export$1cec7dcdd713e220 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...separatorProps } = props;
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).div, {
        role: "separator",
        "aria-orientation": "horizontal",
        ...separatorProps,
        ref: forwardedRef
    });
});
$18f76aa3354546f2$export$1cec7dcdd713e220.displayName = $18f76aa3354546f2$var$SEPARATOR_NAME;
var $18f76aa3354546f2$var$ARROW_NAME = "MenuArrow";
var $18f76aa3354546f2$export$bcdda4773debf5fa = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...arrowProps } = props;
    const popperScope = $18f76aa3354546f2$var$usePopperScope(__scopeMenu);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($aU3NZ.Arrow, {
        ...popperScope,
        ...arrowProps,
        ref: forwardedRef
    });
});
$18f76aa3354546f2$export$bcdda4773debf5fa.displayName = $18f76aa3354546f2$var$ARROW_NAME;
var $18f76aa3354546f2$var$SUB_NAME = "MenuSub";
var [$18f76aa3354546f2$var$MenuSubProvider, $18f76aa3354546f2$var$useMenuSubContext] = $18f76aa3354546f2$var$createMenuContext($18f76aa3354546f2$var$SUB_NAME);
var $18f76aa3354546f2$export$71bdb9d1e2909932 = (props)=>{
    const { __scopeMenu: __scopeMenu, children: children, open: open = false, onOpenChange: onOpenChange } = props;
    const parentMenuContext = $18f76aa3354546f2$var$useMenuContext($18f76aa3354546f2$var$SUB_NAME, __scopeMenu);
    const popperScope = $18f76aa3354546f2$var$usePopperScope(__scopeMenu);
    const [trigger, setTrigger] = $jbmdS.useState(null);
    const [content, setContent] = $jbmdS.useState(null);
    const handleOpenChange = (0, $kjEX1.useCallbackRef)(onOpenChange);
    $jbmdS.useEffect(()=>{
        if (parentMenuContext.open === false) handleOpenChange(false);
        return ()=>handleOpenChange(false);
    }, [
        parentMenuContext.open,
        handleOpenChange
    ]);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($aU3NZ.Root, {
        ...popperScope,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)($18f76aa3354546f2$var$MenuProvider, {
            scope: __scopeMenu,
            open: open,
            onOpenChange: handleOpenChange,
            content: content,
            onContentChange: setContent,
            children: /* @__PURE__ */ (0, $4TLFw.jsx)($18f76aa3354546f2$var$MenuSubProvider, {
                scope: __scopeMenu,
                contentId: (0, $g7F3X.useId)(),
                triggerId: (0, $g7F3X.useId)(),
                trigger: trigger,
                onTriggerChange: setTrigger,
                children: children
            })
        })
    });
};
$18f76aa3354546f2$export$71bdb9d1e2909932.displayName = $18f76aa3354546f2$var$SUB_NAME;
var $18f76aa3354546f2$var$SUB_TRIGGER_NAME = "MenuSubTrigger";
var $18f76aa3354546f2$export$5fbbb3ba7297405f = $jbmdS.forwardRef((props, forwardedRef)=>{
    const context = $18f76aa3354546f2$var$useMenuContext($18f76aa3354546f2$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const rootContext = $18f76aa3354546f2$var$useMenuRootContext($18f76aa3354546f2$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const subContext = $18f76aa3354546f2$var$useMenuSubContext($18f76aa3354546f2$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const contentContext = $18f76aa3354546f2$var$useMenuContentContext($18f76aa3354546f2$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const openTimerRef = $jbmdS.useRef(null);
    const { pointerGraceTimerRef: pointerGraceTimerRef, onPointerGraceIntentChange: onPointerGraceIntentChange } = contentContext;
    const scope = {
        __scopeMenu: props.__scopeMenu
    };
    const clearOpenTimer = $jbmdS.useCallback(()=>{
        if (openTimerRef.current) window.clearTimeout(openTimerRef.current);
        openTimerRef.current = null;
    }, []);
    $jbmdS.useEffect(()=>clearOpenTimer, [
        clearOpenTimer
    ]);
    $jbmdS.useEffect(()=>{
        const pointerGraceTimer = pointerGraceTimerRef.current;
        return ()=>{
            window.clearTimeout(pointerGraceTimer);
            onPointerGraceIntentChange(null);
        };
    }, [
        pointerGraceTimerRef,
        onPointerGraceIntentChange
    ]);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($18f76aa3354546f2$export$9fa5ebd18bee4d43, {
        asChild: true,
        ...scope,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)($18f76aa3354546f2$var$MenuItemImpl, {
            id: subContext.triggerId,
            "aria-haspopup": "menu",
            "aria-expanded": context.open,
            "aria-controls": subContext.contentId,
            "data-state": $18f76aa3354546f2$var$getOpenState(context.open),
            ...props,
            ref: (0, $9sunj.composeRefs)(forwardedRef, subContext.onTriggerChange),
            onClick: (event)=>{
                props.onClick?.(event);
                if (props.disabled || event.defaultPrevented) return;
                event.currentTarget.focus();
                if (!context.open) context.onOpenChange(true);
            },
            onPointerMove: (0, $hFcKE.composeEventHandlers)(props.onPointerMove, $18f76aa3354546f2$var$whenMouse((event)=>{
                contentContext.onItemEnter(event);
                if (event.defaultPrevented) return;
                if (!props.disabled && !context.open && !openTimerRef.current) {
                    contentContext.onPointerGraceIntentChange(null);
                    openTimerRef.current = window.setTimeout(()=>{
                        context.onOpenChange(true);
                        clearOpenTimer();
                    }, 100);
                }
            })),
            onPointerLeave: (0, $hFcKE.composeEventHandlers)(props.onPointerLeave, $18f76aa3354546f2$var$whenMouse((event)=>{
                clearOpenTimer();
                const contentRect = context.content?.getBoundingClientRect();
                if (contentRect) {
                    const side = context.content?.dataset.side;
                    const rightSide = side === "right";
                    const bleed = rightSide ? -5 : 5;
                    const contentNearEdge = contentRect[rightSide ? "left" : "right"];
                    const contentFarEdge = contentRect[rightSide ? "right" : "left"];
                    contentContext.onPointerGraceIntentChange({
                        area: [
                            // Apply a bleed on clientX to ensure that our exit point is
                            // consistently within polygon bounds
                            {
                                x: event.clientX + bleed,
                                y: event.clientY
                            },
                            {
                                x: contentNearEdge,
                                y: contentRect.top
                            },
                            {
                                x: contentFarEdge,
                                y: contentRect.top
                            },
                            {
                                x: contentFarEdge,
                                y: contentRect.bottom
                            },
                            {
                                x: contentNearEdge,
                                y: contentRect.bottom
                            }
                        ],
                        side: side
                    });
                    window.clearTimeout(pointerGraceTimerRef.current);
                    pointerGraceTimerRef.current = window.setTimeout(()=>contentContext.onPointerGraceIntentChange(null), 300);
                } else {
                    contentContext.onTriggerLeave(event);
                    if (event.defaultPrevented) return;
                    contentContext.onPointerGraceIntentChange(null);
                }
            })),
            onKeyDown: (0, $hFcKE.composeEventHandlers)(props.onKeyDown, (event)=>{
                const isTypingAhead = contentContext.searchRef.current !== "";
                if (props.disabled || isTypingAhead && event.key === " ") return;
                if ($18f76aa3354546f2$var$SUB_OPEN_KEYS[rootContext.dir].includes(event.key)) {
                    context.onOpenChange(true);
                    context.content?.focus();
                    event.preventDefault();
                }
            })
        })
    });
});
$18f76aa3354546f2$export$5fbbb3ba7297405f.displayName = $18f76aa3354546f2$var$SUB_TRIGGER_NAME;
var $18f76aa3354546f2$var$SUB_CONTENT_NAME = "MenuSubContent";
var $18f76aa3354546f2$export$e7142ab31822bde6 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const portalContext = $18f76aa3354546f2$var$usePortalContext($18f76aa3354546f2$var$CONTENT_NAME, props.__scopeMenu);
    const { forceMount: forceMount = portalContext.forceMount, ...subContentProps } = props;
    const context = $18f76aa3354546f2$var$useMenuContext($18f76aa3354546f2$var$CONTENT_NAME, props.__scopeMenu);
    const rootContext = $18f76aa3354546f2$var$useMenuRootContext($18f76aa3354546f2$var$CONTENT_NAME, props.__scopeMenu);
    const subContext = $18f76aa3354546f2$var$useMenuSubContext($18f76aa3354546f2$var$SUB_CONTENT_NAME, props.__scopeMenu);
    const ref = $jbmdS.useRef(null);
    const composedRefs = (0, $9sunj.useComposedRefs)(forwardedRef, ref);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($18f76aa3354546f2$var$Collection.Provider, {
        scope: props.__scopeMenu,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $joHB8.Presence), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, $4TLFw.jsx)($18f76aa3354546f2$var$Collection.Slot, {
                scope: props.__scopeMenu,
                children: /* @__PURE__ */ (0, $4TLFw.jsx)($18f76aa3354546f2$var$MenuContentImpl, {
                    id: subContext.contentId,
                    "aria-labelledby": subContext.triggerId,
                    ...subContentProps,
                    ref: composedRefs,
                    align: "start",
                    side: rootContext.dir === "rtl" ? "left" : "right",
                    disableOutsidePointerEvents: false,
                    disableOutsideScroll: false,
                    trapFocus: false,
                    onOpenAutoFocus: (event)=>{
                        if (rootContext.isUsingKeyboardRef.current) ref.current?.focus();
                        event.preventDefault();
                    },
                    onCloseAutoFocus: (event)=>event.preventDefault(),
                    onFocusOutside: (0, $hFcKE.composeEventHandlers)(props.onFocusOutside, (event)=>{
                        if (event.target !== subContext.trigger) context.onOpenChange(false);
                    }),
                    onEscapeKeyDown: (0, $hFcKE.composeEventHandlers)(props.onEscapeKeyDown, (event)=>{
                        rootContext.onClose();
                        event.preventDefault();
                    }),
                    onKeyDown: (0, $hFcKE.composeEventHandlers)(props.onKeyDown, (event)=>{
                        const isKeyDownInside = event.currentTarget.contains(event.target);
                        const isCloseKey = $18f76aa3354546f2$var$SUB_CLOSE_KEYS[rootContext.dir].includes(event.key);
                        if (isKeyDownInside && isCloseKey) {
                            context.onOpenChange(false);
                            subContext.trigger?.focus();
                            event.preventDefault();
                        }
                    })
                })
            })
        })
    });
});
$18f76aa3354546f2$export$e7142ab31822bde6.displayName = $18f76aa3354546f2$var$SUB_CONTENT_NAME;
function $18f76aa3354546f2$var$getOpenState(open) {
    return open ? "open" : "closed";
}
function $18f76aa3354546f2$var$isIndeterminate(checked) {
    return checked === "indeterminate";
}
function $18f76aa3354546f2$var$getCheckedState(checked) {
    return $18f76aa3354546f2$var$isIndeterminate(checked) ? "indeterminate" : checked ? "checked" : "unchecked";
}
function $18f76aa3354546f2$var$focusFirst(candidates) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus();
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
function $18f76aa3354546f2$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
function $18f76aa3354546f2$var$getNextMatch(values, search, currentMatch) {
    const isRepeated = search.length > 1 && Array.from(search).every((char)=>char === search[0]);
    const normalizedSearch = isRepeated ? search[0] : search;
    const currentMatchIndex = currentMatch ? values.indexOf(currentMatch) : -1;
    let wrappedValues = $18f76aa3354546f2$var$wrapArray(values, Math.max(currentMatchIndex, 0));
    const excludeCurrentMatch = normalizedSearch.length === 1;
    if (excludeCurrentMatch) wrappedValues = wrappedValues.filter((v)=>v !== currentMatch);
    const nextMatch = wrappedValues.find((value)=>value.toLowerCase().startsWith(normalizedSearch.toLowerCase()));
    return nextMatch !== currentMatch ? nextMatch : void 0;
}
function $18f76aa3354546f2$var$isPointInPolygon(point, polygon) {
    const { x: x, y: y } = point;
    let inside = false;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const xi = polygon[i].x;
        const yi = polygon[i].y;
        const xj = polygon[j].x;
        const yj = polygon[j].y;
        const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
}
function $18f76aa3354546f2$var$isPointerInGraceArea(event, area) {
    if (!area) return false;
    const cursorPos = {
        x: event.clientX,
        y: event.clientY
    };
    return $18f76aa3354546f2$var$isPointInPolygon(cursorPos, area);
}
function $18f76aa3354546f2$var$whenMouse(handler) {
    return (event)=>event.pointerType === "mouse" ? handler(event) : void 0;
}
var $18f76aa3354546f2$export$be92b6f5f03c0fe9 = $18f76aa3354546f2$export$d9b273488cd8ce6f;
var $18f76aa3354546f2$export$b688253958b8dfe7 = $18f76aa3354546f2$export$9fa5ebd18bee4d43;
var $18f76aa3354546f2$export$602eac185826482c = $18f76aa3354546f2$export$793392f970497feb;
var $18f76aa3354546f2$export$7c6e2c02157bb7d2 = $18f76aa3354546f2$export$479f0f2f71193efe;
var $18f76aa3354546f2$export$eb2fcfdbd7ba97d4 = $18f76aa3354546f2$export$22a631d1f72787bb;
var $18f76aa3354546f2$export$b04be29aa201d4f5 = $18f76aa3354546f2$export$dd37bec0e8a99143;
var $18f76aa3354546f2$export$6d08773d2e66f8f2 = $18f76aa3354546f2$export$2ce376c2cc3355c8;
var $18f76aa3354546f2$export$16ce288f89fa631c = $18f76aa3354546f2$export$f6f243521332502d;
var $18f76aa3354546f2$export$a98f0dcb43a68a25 = $18f76aa3354546f2$export$ea2200c9eee416b3;
var $18f76aa3354546f2$export$371ab307eab489c0 = $18f76aa3354546f2$export$69bd225e9817f6d0;
var $18f76aa3354546f2$export$c3468e2714d175fa = $18f76aa3354546f2$export$a2593e23056970a3;
var $18f76aa3354546f2$export$1ff3c3f08ae963c0 = $18f76aa3354546f2$export$1cec7dcdd713e220;
var $18f76aa3354546f2$export$21b07c8f274aebd5 = $18f76aa3354546f2$export$bcdda4773debf5fa;
var $18f76aa3354546f2$export$d7a01e11500dfb6f = $18f76aa3354546f2$export$71bdb9d1e2909932;
var $18f76aa3354546f2$export$2ea8a7a591ac5eac = $18f76aa3354546f2$export$5fbbb3ba7297405f;
var $18f76aa3354546f2$export$6d4de93b380beddf = $18f76aa3354546f2$export$e7142ab31822bde6;

});
parcelRegister("cmy02", function(module, exports) {

$parcel$export(module.exports, "createRovingFocusGroupScope", function () { return $7b7172d2de5acb43$export$c7109489551a4f4; });
$parcel$export(module.exports, "Root", function () { return $7b7172d2de5acb43$export$be92b6f5f03c0fe9; });
$parcel$export(module.exports, "Item", function () { return $7b7172d2de5acb43$export$6d08773d2e66f8f2; });

var $jbmdS = parcelRequire("jbmdS");

var $hFcKE = parcelRequire("hFcKE");

var $g2eqD = parcelRequire("g2eqD");

var $9sunj = parcelRequire("9sunj");

var $3HdFb = parcelRequire("3HdFb");

var $g7F3X = parcelRequire("g7F3X");

var $cihg9 = parcelRequire("cihg9");

var $kjEX1 = parcelRequire("kjEX1");

var $1sq0Q = parcelRequire("1sq0Q");

var $9czjk = parcelRequire("9czjk");

var $4TLFw = parcelRequire("4TLFw");
"use client";
var $7b7172d2de5acb43$var$ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
var $7b7172d2de5acb43$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $7b7172d2de5acb43$var$GROUP_NAME = "RovingFocusGroup";
var [$7b7172d2de5acb43$var$Collection, $7b7172d2de5acb43$var$useCollection, $7b7172d2de5acb43$var$createCollectionScope] = (0, $g2eqD.createCollection)($7b7172d2de5acb43$var$GROUP_NAME);
var [$7b7172d2de5acb43$var$createRovingFocusGroupContext, $7b7172d2de5acb43$export$c7109489551a4f4] = (0, $3HdFb.createContextScope)($7b7172d2de5acb43$var$GROUP_NAME, [
    $7b7172d2de5acb43$var$createCollectionScope
]);
var [$7b7172d2de5acb43$var$RovingFocusProvider, $7b7172d2de5acb43$var$useRovingFocusContext] = $7b7172d2de5acb43$var$createRovingFocusGroupContext($7b7172d2de5acb43$var$GROUP_NAME);
var $7b7172d2de5acb43$export$8699f7c8af148338 = $jbmdS.forwardRef((props, forwardedRef)=>{
    return /* @__PURE__ */ (0, $4TLFw.jsx)($7b7172d2de5acb43$var$Collection.Provider, {
        scope: props.__scopeRovingFocusGroup,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)($7b7172d2de5acb43$var$Collection.Slot, {
            scope: props.__scopeRovingFocusGroup,
            children: /* @__PURE__ */ (0, $4TLFw.jsx)($7b7172d2de5acb43$var$RovingFocusGroupImpl, {
                ...props,
                ref: forwardedRef
            })
        })
    });
});
$7b7172d2de5acb43$export$8699f7c8af148338.displayName = $7b7172d2de5acb43$var$GROUP_NAME;
var $7b7172d2de5acb43$var$RovingFocusGroupImpl = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, orientation: orientation, loop: loop = false, dir: dir, currentTabStopId: currentTabStopIdProp, defaultCurrentTabStopId: defaultCurrentTabStopId, onCurrentTabStopIdChange: onCurrentTabStopIdChange, onEntryFocus: onEntryFocus, preventScrollOnEntryFocus: preventScrollOnEntryFocus = false, ...groupProps } = props;
    const ref = $jbmdS.useRef(null);
    const composedRefs = (0, $9sunj.useComposedRefs)(forwardedRef, ref);
    const direction = (0, $9czjk.useDirection)(dir);
    const [currentTabStopId = null, setCurrentTabStopId] = (0, $1sq0Q.useControllableState)({
        prop: currentTabStopIdProp,
        defaultProp: defaultCurrentTabStopId,
        onChange: onCurrentTabStopIdChange
    });
    const [isTabbingBackOut, setIsTabbingBackOut] = $jbmdS.useState(false);
    const handleEntryFocus = (0, $kjEX1.useCallbackRef)(onEntryFocus);
    const getItems = $7b7172d2de5acb43$var$useCollection(__scopeRovingFocusGroup);
    const isClickFocusRef = $jbmdS.useRef(false);
    const [focusableItemsCount, setFocusableItemsCount] = $jbmdS.useState(0);
    $jbmdS.useEffect(()=>{
        const node = ref.current;
        if (node) {
            node.addEventListener($7b7172d2de5acb43$var$ENTRY_FOCUS, handleEntryFocus);
            return ()=>node.removeEventListener($7b7172d2de5acb43$var$ENTRY_FOCUS, handleEntryFocus);
        }
    }, [
        handleEntryFocus
    ]);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($7b7172d2de5acb43$var$RovingFocusProvider, {
        scope: __scopeRovingFocusGroup,
        orientation: orientation,
        dir: direction,
        loop: loop,
        currentTabStopId: currentTabStopId,
        onItemFocus: $jbmdS.useCallback((tabStopId)=>setCurrentTabStopId(tabStopId), [
            setCurrentTabStopId
        ]),
        onItemShiftTab: $jbmdS.useCallback(()=>setIsTabbingBackOut(true), []),
        onFocusableItemAdd: $jbmdS.useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount + 1), []),
        onFocusableItemRemove: $jbmdS.useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount - 1), []),
        children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).div, {
            tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
            "data-orientation": orientation,
            ...groupProps,
            ref: composedRefs,
            style: {
                outline: "none",
                ...props.style
            },
            onMouseDown: (0, $hFcKE.composeEventHandlers)(props.onMouseDown, ()=>{
                isClickFocusRef.current = true;
            }),
            onFocus: (0, $hFcKE.composeEventHandlers)(props.onFocus, (event)=>{
                const isKeyboardFocus = !isClickFocusRef.current;
                if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
                    const entryFocusEvent = new CustomEvent($7b7172d2de5acb43$var$ENTRY_FOCUS, $7b7172d2de5acb43$var$EVENT_OPTIONS);
                    event.currentTarget.dispatchEvent(entryFocusEvent);
                    if (!entryFocusEvent.defaultPrevented) {
                        const items = getItems().filter((item)=>item.focusable);
                        const activeItem = items.find((item)=>item.active);
                        const currentItem = items.find((item)=>item.id === currentTabStopId);
                        const candidateItems = [
                            activeItem,
                            currentItem,
                            ...items
                        ].filter(Boolean);
                        const candidateNodes = candidateItems.map((item)=>item.ref.current);
                        $7b7172d2de5acb43$var$focusFirst(candidateNodes, preventScrollOnEntryFocus);
                    }
                }
                isClickFocusRef.current = false;
            }),
            onBlur: (0, $hFcKE.composeEventHandlers)(props.onBlur, ()=>setIsTabbingBackOut(false))
        })
    });
});
var $7b7172d2de5acb43$var$ITEM_NAME = "RovingFocusGroupItem";
var $7b7172d2de5acb43$export$ab9df7c53fe8454 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, focusable: focusable = true, active: active = false, tabStopId: tabStopId, ...itemProps } = props;
    const autoId = (0, $g7F3X.useId)();
    const id = tabStopId || autoId;
    const context = $7b7172d2de5acb43$var$useRovingFocusContext($7b7172d2de5acb43$var$ITEM_NAME, __scopeRovingFocusGroup);
    const isCurrentTabStop = context.currentTabStopId === id;
    const getItems = $7b7172d2de5acb43$var$useCollection(__scopeRovingFocusGroup);
    const { onFocusableItemAdd: onFocusableItemAdd, onFocusableItemRemove: onFocusableItemRemove } = context;
    $jbmdS.useEffect(()=>{
        if (focusable) {
            onFocusableItemAdd();
            return ()=>onFocusableItemRemove();
        }
    }, [
        focusable,
        onFocusableItemAdd,
        onFocusableItemRemove
    ]);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($7b7172d2de5acb43$var$Collection.ItemSlot, {
        scope: __scopeRovingFocusGroup,
        id: id,
        focusable: focusable,
        active: active,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).span, {
            tabIndex: isCurrentTabStop ? 0 : -1,
            "data-orientation": context.orientation,
            ...itemProps,
            ref: forwardedRef,
            onMouseDown: (0, $hFcKE.composeEventHandlers)(props.onMouseDown, (event)=>{
                if (!focusable) event.preventDefault();
                else context.onItemFocus(id);
            }),
            onFocus: (0, $hFcKE.composeEventHandlers)(props.onFocus, ()=>context.onItemFocus(id)),
            onKeyDown: (0, $hFcKE.composeEventHandlers)(props.onKeyDown, (event)=>{
                if (event.key === "Tab" && event.shiftKey) {
                    context.onItemShiftTab();
                    return;
                }
                if (event.target !== event.currentTarget) return;
                const focusIntent = $7b7172d2de5acb43$var$getFocusIntent(event, context.orientation, context.dir);
                if (focusIntent !== void 0) {
                    if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
                    event.preventDefault();
                    const items = getItems().filter((item)=>item.focusable);
                    let candidateNodes = items.map((item)=>item.ref.current);
                    if (focusIntent === "last") candidateNodes.reverse();
                    else if (focusIntent === "prev" || focusIntent === "next") {
                        if (focusIntent === "prev") candidateNodes.reverse();
                        const currentIndex = candidateNodes.indexOf(event.currentTarget);
                        candidateNodes = context.loop ? $7b7172d2de5acb43$var$wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                    }
                    setTimeout(()=>$7b7172d2de5acb43$var$focusFirst(candidateNodes));
                }
            })
        })
    });
});
$7b7172d2de5acb43$export$ab9df7c53fe8454.displayName = $7b7172d2de5acb43$var$ITEM_NAME;
var $7b7172d2de5acb43$var$MAP_KEY_TO_FOCUS_INTENT = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
};
function $7b7172d2de5acb43$var$getDirectionAwareKey(key, dir) {
    if (dir !== "rtl") return key;
    return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function $7b7172d2de5acb43$var$getFocusIntent(event, orientation, dir) {
    const key = $7b7172d2de5acb43$var$getDirectionAwareKey(event.key, dir);
    if (orientation === "vertical" && [
        "ArrowLeft",
        "ArrowRight"
    ].includes(key)) return void 0;
    if (orientation === "horizontal" && [
        "ArrowUp",
        "ArrowDown"
    ].includes(key)) return void 0;
    return $7b7172d2de5acb43$var$MAP_KEY_TO_FOCUS_INTENT[key];
}
function $7b7172d2de5acb43$var$focusFirst(candidates, preventScroll = false) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus({
            preventScroll: preventScroll
        });
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
function $7b7172d2de5acb43$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
var $7b7172d2de5acb43$export$be92b6f5f03c0fe9 = $7b7172d2de5acb43$export$8699f7c8af148338;
var $7b7172d2de5acb43$export$6d08773d2e66f8f2 = $7b7172d2de5acb43$export$ab9df7c53fe8454;

});
parcelRegister("3HdFb", function(module, exports) {

$parcel$export(module.exports, "createContextScope", function () { return $461b929e0b16c844$export$50c7b4e9d9f19c1; });
// packages/react/context/src/createContext.tsx

var $jbmdS = parcelRequire("jbmdS");

var $4TLFw = parcelRequire("4TLFw");
function $461b929e0b16c844$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $jbmdS.createContext(defaultContext);
    function Provider(props) {
        const { children: children, ...context } = props;
        const value = $jbmdS.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $4TLFw.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    }
    function useContext2(consumerName) {
        const context = $jbmdS.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext2
    ];
}
function $461b929e0b16c844$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $jbmdS.createContext(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope, children: children, ...context } = props;
            const Context = scope?.[scopeName][index] || BaseContext;
            const value = $jbmdS.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $4TLFw.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        }
        function useContext2(consumerName, scope) {
            const Context = scope?.[scopeName][index] || BaseContext;
            const context = $jbmdS.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $jbmdS.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = scope?.[scopeName] || scopeContexts;
            return $jbmdS.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $461b929e0b16c844$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function $461b929e0b16c844$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope, scopeName: scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $jbmdS.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}

});




parcelRegister("9mkVX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d066820088dbb5b$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $6d066820088dbb5b$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("Circle", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ]
]);

});


parcelRegister("hzfgL", function(module, exports) {

$parcel$export(module.exports, "ScrollArea", function () { return $9a8638427aa9bdf8$export$ccf8d8d7bbf3c2cc; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $bGxp2 = parcelRequire("bGxp2");

var $Yha9m = parcelRequire("Yha9m");
const $9a8638427aa9bdf8$export$ccf8d8d7bbf3c2cc = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, children: children, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsxs)($bGxp2.Root, {
        ref: ref,
        className: (0, $Yha9m.cn)("relative overflow-hidden", className),
        ...props,
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)($bGxp2.Viewport, {
                className: "h-full w-full rounded-[inherit] [&>div]:!block",
                children: children
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)($9a8638427aa9bdf8$export$342551df3dea21fb, {}),
            /*#__PURE__*/ (0, $61Ea1.jsx)($bGxp2.Corner, {})
        ]
    }));
$9a8638427aa9bdf8$export$ccf8d8d7bbf3c2cc.displayName = $bGxp2.Root.displayName;
const $9a8638427aa9bdf8$export$342551df3dea21fb = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, orientation: orientation = "vertical", ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)($bGxp2.ScrollAreaScrollbar, {
        ref: ref,
        orientation: orientation,
        className: (0, $Yha9m.cn)("flex touch-none select-none transition-colors", orientation === "vertical" && "h-full w-2.5 border-l border-l-transparent p-[1px]", orientation === "horizontal" && "h-2.5 flex-col border-t border-t-transparent p-[1px]", className),
        ...props,
        children: /*#__PURE__*/ (0, $61Ea1.jsx)($bGxp2.ScrollAreaThumb, {
            className: "relative flex-1 rounded-full bg-border"
        })
    }));
$9a8638427aa9bdf8$export$342551df3dea21fb.displayName = $bGxp2.ScrollAreaScrollbar.displayName;

});
parcelRegister("bGxp2", function(module, exports) {

$parcel$export(module.exports, "ScrollAreaScrollbar", function () { return $623267bc8899b58d$export$2fabd85d0eba3c57; });
$parcel$export(module.exports, "ScrollAreaThumb", function () { return $623267bc8899b58d$export$9fba1154677d7cd2; });
$parcel$export(module.exports, "Root", function () { return $623267bc8899b58d$export$be92b6f5f03c0fe9; });
$parcel$export(module.exports, "Viewport", function () { return $623267bc8899b58d$export$d5c6c08dc2d3ca7; });
$parcel$export(module.exports, "Corner", function () { return $623267bc8899b58d$export$ac61190d9fc311a9; });

var $jbmdS = parcelRequire("jbmdS");

var $cihg9 = parcelRequire("cihg9");

var $joHB8 = parcelRequire("joHB8");

var $f4RZG = parcelRequire("f4RZG");

var $9sunj = parcelRequire("9sunj");

var $kjEX1 = parcelRequire("kjEX1");

var $9czjk = parcelRequire("9czjk");

var $9crHl = parcelRequire("9crHl");

var $kMiXC = parcelRequire("kMiXC");

var $hFcKE = parcelRequire("hFcKE");

var $4TLFw = parcelRequire("4TLFw");
"use client";
function $623267bc8899b58d$var$useStateMachine(initialState, machine) {
    return $jbmdS.useReducer((state, event)=>{
        const nextState = machine[state][event];
        return nextState ?? state;
    }, initialState);
}
var $623267bc8899b58d$var$SCROLL_AREA_NAME = "ScrollArea";
var [$623267bc8899b58d$var$createScrollAreaContext, $623267bc8899b58d$export$488468afe3a6f2b1] = (0, $f4RZG.createContextScope)($623267bc8899b58d$var$SCROLL_AREA_NAME);
var [$623267bc8899b58d$var$ScrollAreaProvider, $623267bc8899b58d$var$useScrollAreaContext] = $623267bc8899b58d$var$createScrollAreaContext($623267bc8899b58d$var$SCROLL_AREA_NAME);
var $623267bc8899b58d$export$ccf8d8d7bbf3c2cc = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeScrollArea: __scopeScrollArea, type: type = "hover", dir: dir, scrollHideDelay: scrollHideDelay = 600, ...scrollAreaProps } = props;
    const [scrollArea, setScrollArea] = $jbmdS.useState(null);
    const [viewport, setViewport] = $jbmdS.useState(null);
    const [content, setContent] = $jbmdS.useState(null);
    const [scrollbarX, setScrollbarX] = $jbmdS.useState(null);
    const [scrollbarY, setScrollbarY] = $jbmdS.useState(null);
    const [cornerWidth, setCornerWidth] = $jbmdS.useState(0);
    const [cornerHeight, setCornerHeight] = $jbmdS.useState(0);
    const [scrollbarXEnabled, setScrollbarXEnabled] = $jbmdS.useState(false);
    const [scrollbarYEnabled, setScrollbarYEnabled] = $jbmdS.useState(false);
    const composedRefs = (0, $9sunj.useComposedRefs)(forwardedRef, (node)=>setScrollArea(node));
    const direction = (0, $9czjk.useDirection)(dir);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($623267bc8899b58d$var$ScrollAreaProvider, {
        scope: __scopeScrollArea,
        type: type,
        dir: direction,
        scrollHideDelay: scrollHideDelay,
        scrollArea: scrollArea,
        viewport: viewport,
        onViewportChange: setViewport,
        content: content,
        onContentChange: setContent,
        scrollbarX: scrollbarX,
        onScrollbarXChange: setScrollbarX,
        scrollbarXEnabled: scrollbarXEnabled,
        onScrollbarXEnabledChange: setScrollbarXEnabled,
        scrollbarY: scrollbarY,
        onScrollbarYChange: setScrollbarY,
        scrollbarYEnabled: scrollbarYEnabled,
        onScrollbarYEnabledChange: setScrollbarYEnabled,
        onCornerWidthChange: setCornerWidth,
        onCornerHeightChange: setCornerHeight,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).div, {
            dir: direction,
            ...scrollAreaProps,
            ref: composedRefs,
            style: {
                position: "relative",
                // Pass corner sizes as CSS vars to reduce re-renders of context consumers
                ["--radix-scroll-area-corner-width"]: cornerWidth + "px",
                ["--radix-scroll-area-corner-height"]: cornerHeight + "px",
                ...props.style
            }
        })
    });
});
$623267bc8899b58d$export$ccf8d8d7bbf3c2cc.displayName = $623267bc8899b58d$var$SCROLL_AREA_NAME;
var $623267bc8899b58d$var$VIEWPORT_NAME = "ScrollAreaViewport";
var $623267bc8899b58d$export$a21cbf9f11fca853 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeScrollArea: __scopeScrollArea, children: children, asChild: asChild, nonce: nonce, ...viewportProps } = props;
    const context = $623267bc8899b58d$var$useScrollAreaContext($623267bc8899b58d$var$VIEWPORT_NAME, __scopeScrollArea);
    const ref = $jbmdS.useRef(null);
    const composedRefs = (0, $9sunj.useComposedRefs)(forwardedRef, ref, context.onViewportChange);
    return /* @__PURE__ */ (0, $4TLFw.jsxs)((0, $4TLFw.Fragment), {
        children: [
            /* @__PURE__ */ (0, $4TLFw.jsx)("style", {
                dangerouslySetInnerHTML: {
                    __html: `
[data-radix-scroll-area-viewport] {
  scrollbar-width: none;
  -ms-overflow-style: none;
  -webkit-overflow-scrolling: touch;
}
[data-radix-scroll-area-viewport]::-webkit-scrollbar {
  display: none;
}
:where([data-radix-scroll-area-viewport]) {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
:where([data-radix-scroll-area-content]) {
  flex-grow: 1;
}
`
                },
                nonce: nonce
            }),
            /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).div, {
                "data-radix-scroll-area-viewport": "",
                ...viewportProps,
                asChild: asChild,
                ref: composedRefs,
                style: {
                    /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */ overflowX: context.scrollbarXEnabled ? "scroll" : "hidden",
                    overflowY: context.scrollbarYEnabled ? "scroll" : "hidden",
                    ...props.style
                },
                children: $623267bc8899b58d$var$getSubtree({
                    asChild: asChild,
                    children: children
                }, (children2)=>/* @__PURE__ */ (0, $4TLFw.jsx)("div", {
                        "data-radix-scroll-area-content": "",
                        ref: context.onContentChange,
                        style: {
                            minWidth: context.scrollbarXEnabled ? "fit-content" : void 0
                        },
                        children: children2
                    }))
            })
        ]
    });
});
$623267bc8899b58d$export$a21cbf9f11fca853.displayName = $623267bc8899b58d$var$VIEWPORT_NAME;
var $623267bc8899b58d$var$SCROLLBAR_NAME = "ScrollAreaScrollbar";
var $623267bc8899b58d$export$2fabd85d0eba3c57 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { forceMount: forceMount, ...scrollbarProps } = props;
    const context = $623267bc8899b58d$var$useScrollAreaContext($623267bc8899b58d$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const { onScrollbarXEnabledChange: onScrollbarXEnabledChange, onScrollbarYEnabledChange: onScrollbarYEnabledChange } = context;
    const isHorizontal = props.orientation === "horizontal";
    $jbmdS.useEffect(()=>{
        isHorizontal ? onScrollbarXEnabledChange(true) : onScrollbarYEnabledChange(true);
        return ()=>{
            isHorizontal ? onScrollbarXEnabledChange(false) : onScrollbarYEnabledChange(false);
        };
    }, [
        isHorizontal,
        onScrollbarXEnabledChange,
        onScrollbarYEnabledChange
    ]);
    return context.type === "hover" ? /* @__PURE__ */ (0, $4TLFw.jsx)($623267bc8899b58d$var$ScrollAreaScrollbarHover, {
        ...scrollbarProps,
        ref: forwardedRef,
        forceMount: forceMount
    }) : context.type === "scroll" ? /* @__PURE__ */ (0, $4TLFw.jsx)($623267bc8899b58d$var$ScrollAreaScrollbarScroll, {
        ...scrollbarProps,
        ref: forwardedRef,
        forceMount: forceMount
    }) : context.type === "auto" ? /* @__PURE__ */ (0, $4TLFw.jsx)($623267bc8899b58d$var$ScrollAreaScrollbarAuto, {
        ...scrollbarProps,
        ref: forwardedRef,
        forceMount: forceMount
    }) : context.type === "always" ? /* @__PURE__ */ (0, $4TLFw.jsx)($623267bc8899b58d$var$ScrollAreaScrollbarVisible, {
        ...scrollbarProps,
        ref: forwardedRef
    }) : null;
});
$623267bc8899b58d$export$2fabd85d0eba3c57.displayName = $623267bc8899b58d$var$SCROLLBAR_NAME;
var $623267bc8899b58d$var$ScrollAreaScrollbarHover = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { forceMount: forceMount, ...scrollbarProps } = props;
    const context = $623267bc8899b58d$var$useScrollAreaContext($623267bc8899b58d$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const [visible, setVisible] = $jbmdS.useState(false);
    $jbmdS.useEffect(()=>{
        const scrollArea = context.scrollArea;
        let hideTimer = 0;
        if (scrollArea) {
            const handlePointerEnter = ()=>{
                window.clearTimeout(hideTimer);
                setVisible(true);
            };
            const handlePointerLeave = ()=>{
                hideTimer = window.setTimeout(()=>setVisible(false), context.scrollHideDelay);
            };
            scrollArea.addEventListener("pointerenter", handlePointerEnter);
            scrollArea.addEventListener("pointerleave", handlePointerLeave);
            return ()=>{
                window.clearTimeout(hideTimer);
                scrollArea.removeEventListener("pointerenter", handlePointerEnter);
                scrollArea.removeEventListener("pointerleave", handlePointerLeave);
            };
        }
    }, [
        context.scrollArea,
        context.scrollHideDelay
    ]);
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $joHB8.Presence), {
        present: forceMount || visible,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)($623267bc8899b58d$var$ScrollAreaScrollbarAuto, {
            "data-state": visible ? "visible" : "hidden",
            ...scrollbarProps,
            ref: forwardedRef
        })
    });
});
var $623267bc8899b58d$var$ScrollAreaScrollbarScroll = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { forceMount: forceMount, ...scrollbarProps } = props;
    const context = $623267bc8899b58d$var$useScrollAreaContext($623267bc8899b58d$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const isHorizontal = props.orientation === "horizontal";
    const debounceScrollEnd = $623267bc8899b58d$var$useDebounceCallback(()=>send("SCROLL_END"), 100);
    const [state, send] = $623267bc8899b58d$var$useStateMachine("hidden", {
        hidden: {
            SCROLL: "scrolling"
        },
        scrolling: {
            SCROLL_END: "idle",
            POINTER_ENTER: "interacting"
        },
        interacting: {
            SCROLL: "interacting",
            POINTER_LEAVE: "idle"
        },
        idle: {
            HIDE: "hidden",
            SCROLL: "scrolling",
            POINTER_ENTER: "interacting"
        }
    });
    $jbmdS.useEffect(()=>{
        if (state === "idle") {
            const hideTimer = window.setTimeout(()=>send("HIDE"), context.scrollHideDelay);
            return ()=>window.clearTimeout(hideTimer);
        }
    }, [
        state,
        context.scrollHideDelay,
        send
    ]);
    $jbmdS.useEffect(()=>{
        const viewport = context.viewport;
        const scrollDirection = isHorizontal ? "scrollLeft" : "scrollTop";
        if (viewport) {
            let prevScrollPos = viewport[scrollDirection];
            const handleScroll = ()=>{
                const scrollPos = viewport[scrollDirection];
                const hasScrollInDirectionChanged = prevScrollPos !== scrollPos;
                if (hasScrollInDirectionChanged) {
                    send("SCROLL");
                    debounceScrollEnd();
                }
                prevScrollPos = scrollPos;
            };
            viewport.addEventListener("scroll", handleScroll);
            return ()=>viewport.removeEventListener("scroll", handleScroll);
        }
    }, [
        context.viewport,
        isHorizontal,
        send,
        debounceScrollEnd
    ]);
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $joHB8.Presence), {
        present: forceMount || state !== "hidden",
        children: /* @__PURE__ */ (0, $4TLFw.jsx)($623267bc8899b58d$var$ScrollAreaScrollbarVisible, {
            "data-state": state === "hidden" ? "hidden" : "visible",
            ...scrollbarProps,
            ref: forwardedRef,
            onPointerEnter: (0, $hFcKE.composeEventHandlers)(props.onPointerEnter, ()=>send("POINTER_ENTER")),
            onPointerLeave: (0, $hFcKE.composeEventHandlers)(props.onPointerLeave, ()=>send("POINTER_LEAVE"))
        })
    });
});
var $623267bc8899b58d$var$ScrollAreaScrollbarAuto = $jbmdS.forwardRef((props, forwardedRef)=>{
    const context = $623267bc8899b58d$var$useScrollAreaContext($623267bc8899b58d$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const { forceMount: forceMount, ...scrollbarProps } = props;
    const [visible, setVisible] = $jbmdS.useState(false);
    const isHorizontal = props.orientation === "horizontal";
    const handleResize = $623267bc8899b58d$var$useDebounceCallback(()=>{
        if (context.viewport) {
            const isOverflowX = context.viewport.offsetWidth < context.viewport.scrollWidth;
            const isOverflowY = context.viewport.offsetHeight < context.viewport.scrollHeight;
            setVisible(isHorizontal ? isOverflowX : isOverflowY);
        }
    }, 10);
    $623267bc8899b58d$var$useResizeObserver(context.viewport, handleResize);
    $623267bc8899b58d$var$useResizeObserver(context.content, handleResize);
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $joHB8.Presence), {
        present: forceMount || visible,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)($623267bc8899b58d$var$ScrollAreaScrollbarVisible, {
            "data-state": visible ? "visible" : "hidden",
            ...scrollbarProps,
            ref: forwardedRef
        })
    });
});
var $623267bc8899b58d$var$ScrollAreaScrollbarVisible = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { orientation: orientation = "vertical", ...scrollbarProps } = props;
    const context = $623267bc8899b58d$var$useScrollAreaContext($623267bc8899b58d$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const thumbRef = $jbmdS.useRef(null);
    const pointerOffsetRef = $jbmdS.useRef(0);
    const [sizes, setSizes] = $jbmdS.useState({
        content: 0,
        viewport: 0,
        scrollbar: {
            size: 0,
            paddingStart: 0,
            paddingEnd: 0
        }
    });
    const thumbRatio = $623267bc8899b58d$var$getThumbRatio(sizes.viewport, sizes.content);
    const commonProps = {
        ...scrollbarProps,
        sizes: sizes,
        onSizesChange: setSizes,
        hasThumb: Boolean(thumbRatio > 0 && thumbRatio < 1),
        onThumbChange: (thumb)=>thumbRef.current = thumb,
        onThumbPointerUp: ()=>pointerOffsetRef.current = 0,
        onThumbPointerDown: (pointerPos)=>pointerOffsetRef.current = pointerPos
    };
    function getScrollPosition(pointerPos, dir) {
        return $623267bc8899b58d$var$getScrollPositionFromPointer(pointerPos, pointerOffsetRef.current, sizes, dir);
    }
    if (orientation === "horizontal") return /* @__PURE__ */ (0, $4TLFw.jsx)($623267bc8899b58d$var$ScrollAreaScrollbarX, {
        ...commonProps,
        ref: forwardedRef,
        onThumbPositionChange: ()=>{
            if (context.viewport && thumbRef.current) {
                const scrollPos = context.viewport.scrollLeft;
                const offset = $623267bc8899b58d$var$getThumbOffsetFromScroll(scrollPos, sizes, context.dir);
                thumbRef.current.style.transform = `translate3d(${offset}px, 0, 0)`;
            }
        },
        onWheelScroll: (scrollPos)=>{
            if (context.viewport) context.viewport.scrollLeft = scrollPos;
        },
        onDragScroll: (pointerPos)=>{
            if (context.viewport) context.viewport.scrollLeft = getScrollPosition(pointerPos, context.dir);
        }
    });
    if (orientation === "vertical") return /* @__PURE__ */ (0, $4TLFw.jsx)($623267bc8899b58d$var$ScrollAreaScrollbarY, {
        ...commonProps,
        ref: forwardedRef,
        onThumbPositionChange: ()=>{
            if (context.viewport && thumbRef.current) {
                const scrollPos = context.viewport.scrollTop;
                const offset = $623267bc8899b58d$var$getThumbOffsetFromScroll(scrollPos, sizes);
                thumbRef.current.style.transform = `translate3d(0, ${offset}px, 0)`;
            }
        },
        onWheelScroll: (scrollPos)=>{
            if (context.viewport) context.viewport.scrollTop = scrollPos;
        },
        onDragScroll: (pointerPos)=>{
            if (context.viewport) context.viewport.scrollTop = getScrollPosition(pointerPos);
        }
    });
    return null;
});
var $623267bc8899b58d$var$ScrollAreaScrollbarX = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { sizes: sizes, onSizesChange: onSizesChange, ...scrollbarProps } = props;
    const context = $623267bc8899b58d$var$useScrollAreaContext($623267bc8899b58d$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const [computedStyle, setComputedStyle] = $jbmdS.useState();
    const ref = $jbmdS.useRef(null);
    const composeRefs = (0, $9sunj.useComposedRefs)(forwardedRef, ref, context.onScrollbarXChange);
    $jbmdS.useEffect(()=>{
        if (ref.current) setComputedStyle(getComputedStyle(ref.current));
    }, [
        ref
    ]);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($623267bc8899b58d$var$ScrollAreaScrollbarImpl, {
        "data-orientation": "horizontal",
        ...scrollbarProps,
        ref: composeRefs,
        sizes: sizes,
        style: {
            bottom: 0,
            left: context.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
            right: context.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
            ["--radix-scroll-area-thumb-width"]: $623267bc8899b58d$var$getThumbSize(sizes) + "px",
            ...props.style
        },
        onThumbPointerDown: (pointerPos)=>props.onThumbPointerDown(pointerPos.x),
        onDragScroll: (pointerPos)=>props.onDragScroll(pointerPos.x),
        onWheelScroll: (event, maxScrollPos)=>{
            if (context.viewport) {
                const scrollPos = context.viewport.scrollLeft + event.deltaX;
                props.onWheelScroll(scrollPos);
                if ($623267bc8899b58d$var$isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos)) event.preventDefault();
            }
        },
        onResize: ()=>{
            if (ref.current && context.viewport && computedStyle) onSizesChange({
                content: context.viewport.scrollWidth,
                viewport: context.viewport.offsetWidth,
                scrollbar: {
                    size: ref.current.clientWidth,
                    paddingStart: $623267bc8899b58d$var$toInt(computedStyle.paddingLeft),
                    paddingEnd: $623267bc8899b58d$var$toInt(computedStyle.paddingRight)
                }
            });
        }
    });
});
var $623267bc8899b58d$var$ScrollAreaScrollbarY = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { sizes: sizes, onSizesChange: onSizesChange, ...scrollbarProps } = props;
    const context = $623267bc8899b58d$var$useScrollAreaContext($623267bc8899b58d$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const [computedStyle, setComputedStyle] = $jbmdS.useState();
    const ref = $jbmdS.useRef(null);
    const composeRefs = (0, $9sunj.useComposedRefs)(forwardedRef, ref, context.onScrollbarYChange);
    $jbmdS.useEffect(()=>{
        if (ref.current) setComputedStyle(getComputedStyle(ref.current));
    }, [
        ref
    ]);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($623267bc8899b58d$var$ScrollAreaScrollbarImpl, {
        "data-orientation": "vertical",
        ...scrollbarProps,
        ref: composeRefs,
        sizes: sizes,
        style: {
            top: 0,
            right: context.dir === "ltr" ? 0 : void 0,
            left: context.dir === "rtl" ? 0 : void 0,
            bottom: "var(--radix-scroll-area-corner-height)",
            ["--radix-scroll-area-thumb-height"]: $623267bc8899b58d$var$getThumbSize(sizes) + "px",
            ...props.style
        },
        onThumbPointerDown: (pointerPos)=>props.onThumbPointerDown(pointerPos.y),
        onDragScroll: (pointerPos)=>props.onDragScroll(pointerPos.y),
        onWheelScroll: (event, maxScrollPos)=>{
            if (context.viewport) {
                const scrollPos = context.viewport.scrollTop + event.deltaY;
                props.onWheelScroll(scrollPos);
                if ($623267bc8899b58d$var$isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos)) event.preventDefault();
            }
        },
        onResize: ()=>{
            if (ref.current && context.viewport && computedStyle) onSizesChange({
                content: context.viewport.scrollHeight,
                viewport: context.viewport.offsetHeight,
                scrollbar: {
                    size: ref.current.clientHeight,
                    paddingStart: $623267bc8899b58d$var$toInt(computedStyle.paddingTop),
                    paddingEnd: $623267bc8899b58d$var$toInt(computedStyle.paddingBottom)
                }
            });
        }
    });
});
var [$623267bc8899b58d$var$ScrollbarProvider, $623267bc8899b58d$var$useScrollbarContext] = $623267bc8899b58d$var$createScrollAreaContext($623267bc8899b58d$var$SCROLLBAR_NAME);
var $623267bc8899b58d$var$ScrollAreaScrollbarImpl = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeScrollArea: __scopeScrollArea, sizes: sizes, hasThumb: hasThumb, onThumbChange: onThumbChange, onThumbPointerUp: onThumbPointerUp, onThumbPointerDown: onThumbPointerDown, onThumbPositionChange: onThumbPositionChange, onDragScroll: onDragScroll, onWheelScroll: onWheelScroll, onResize: onResize, ...scrollbarProps } = props;
    const context = $623267bc8899b58d$var$useScrollAreaContext($623267bc8899b58d$var$SCROLLBAR_NAME, __scopeScrollArea);
    const [scrollbar, setScrollbar] = $jbmdS.useState(null);
    const composeRefs = (0, $9sunj.useComposedRefs)(forwardedRef, (node)=>setScrollbar(node));
    const rectRef = $jbmdS.useRef(null);
    const prevWebkitUserSelectRef = $jbmdS.useRef("");
    const viewport = context.viewport;
    const maxScrollPos = sizes.content - sizes.viewport;
    const handleWheelScroll = (0, $kjEX1.useCallbackRef)(onWheelScroll);
    const handleThumbPositionChange = (0, $kjEX1.useCallbackRef)(onThumbPositionChange);
    const handleResize = $623267bc8899b58d$var$useDebounceCallback(onResize, 10);
    function handleDragScroll(event) {
        if (rectRef.current) {
            const x = event.clientX - rectRef.current.left;
            const y = event.clientY - rectRef.current.top;
            onDragScroll({
                x: x,
                y: y
            });
        }
    }
    $jbmdS.useEffect(()=>{
        const handleWheel = (event)=>{
            const element = event.target;
            const isScrollbarWheel = scrollbar?.contains(element);
            if (isScrollbarWheel) handleWheelScroll(event, maxScrollPos);
        };
        document.addEventListener("wheel", handleWheel, {
            passive: false
        });
        return ()=>document.removeEventListener("wheel", handleWheel, {
                passive: false
            });
    }, [
        viewport,
        scrollbar,
        maxScrollPos,
        handleWheelScroll
    ]);
    $jbmdS.useEffect(handleThumbPositionChange, [
        sizes,
        handleThumbPositionChange
    ]);
    $623267bc8899b58d$var$useResizeObserver(scrollbar, handleResize);
    $623267bc8899b58d$var$useResizeObserver(context.content, handleResize);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($623267bc8899b58d$var$ScrollbarProvider, {
        scope: __scopeScrollArea,
        scrollbar: scrollbar,
        hasThumb: hasThumb,
        onThumbChange: (0, $kjEX1.useCallbackRef)(onThumbChange),
        onThumbPointerUp: (0, $kjEX1.useCallbackRef)(onThumbPointerUp),
        onThumbPositionChange: handleThumbPositionChange,
        onThumbPointerDown: (0, $kjEX1.useCallbackRef)(onThumbPointerDown),
        children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).div, {
            ...scrollbarProps,
            ref: composeRefs,
            style: {
                position: "absolute",
                ...scrollbarProps.style
            },
            onPointerDown: (0, $hFcKE.composeEventHandlers)(props.onPointerDown, (event)=>{
                const mainPointer = 0;
                if (event.button === mainPointer) {
                    const element = event.target;
                    element.setPointerCapture(event.pointerId);
                    rectRef.current = scrollbar.getBoundingClientRect();
                    prevWebkitUserSelectRef.current = document.body.style.webkitUserSelect;
                    document.body.style.webkitUserSelect = "none";
                    if (context.viewport) context.viewport.style.scrollBehavior = "auto";
                    handleDragScroll(event);
                }
            }),
            onPointerMove: (0, $hFcKE.composeEventHandlers)(props.onPointerMove, handleDragScroll),
            onPointerUp: (0, $hFcKE.composeEventHandlers)(props.onPointerUp, (event)=>{
                const element = event.target;
                if (element.hasPointerCapture(event.pointerId)) element.releasePointerCapture(event.pointerId);
                document.body.style.webkitUserSelect = prevWebkitUserSelectRef.current;
                if (context.viewport) context.viewport.style.scrollBehavior = "";
                rectRef.current = null;
            })
        })
    });
});
var $623267bc8899b58d$var$THUMB_NAME = "ScrollAreaThumb";
var $623267bc8899b58d$export$9fba1154677d7cd2 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { forceMount: forceMount, ...thumbProps } = props;
    const scrollbarContext = $623267bc8899b58d$var$useScrollbarContext($623267bc8899b58d$var$THUMB_NAME, props.__scopeScrollArea);
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $joHB8.Presence), {
        present: forceMount || scrollbarContext.hasThumb,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)($623267bc8899b58d$var$ScrollAreaThumbImpl, {
            ref: forwardedRef,
            ...thumbProps
        })
    });
});
var $623267bc8899b58d$var$ScrollAreaThumbImpl = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeScrollArea: __scopeScrollArea, style: style, ...thumbProps } = props;
    const scrollAreaContext = $623267bc8899b58d$var$useScrollAreaContext($623267bc8899b58d$var$THUMB_NAME, __scopeScrollArea);
    const scrollbarContext = $623267bc8899b58d$var$useScrollbarContext($623267bc8899b58d$var$THUMB_NAME, __scopeScrollArea);
    const { onThumbPositionChange: onThumbPositionChange } = scrollbarContext;
    const composedRef = (0, $9sunj.useComposedRefs)(forwardedRef, (node)=>scrollbarContext.onThumbChange(node));
    const removeUnlinkedScrollListenerRef = $jbmdS.useRef();
    const debounceScrollEnd = $623267bc8899b58d$var$useDebounceCallback(()=>{
        if (removeUnlinkedScrollListenerRef.current) {
            removeUnlinkedScrollListenerRef.current();
            removeUnlinkedScrollListenerRef.current = void 0;
        }
    }, 100);
    $jbmdS.useEffect(()=>{
        const viewport = scrollAreaContext.viewport;
        if (viewport) {
            const handleScroll = ()=>{
                debounceScrollEnd();
                if (!removeUnlinkedScrollListenerRef.current) {
                    const listener = $623267bc8899b58d$var$addUnlinkedScrollListener(viewport, onThumbPositionChange);
                    removeUnlinkedScrollListenerRef.current = listener;
                    onThumbPositionChange();
                }
            };
            onThumbPositionChange();
            viewport.addEventListener("scroll", handleScroll);
            return ()=>viewport.removeEventListener("scroll", handleScroll);
        }
    }, [
        scrollAreaContext.viewport,
        debounceScrollEnd,
        onThumbPositionChange
    ]);
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).div, {
        "data-state": scrollbarContext.hasThumb ? "visible" : "hidden",
        ...thumbProps,
        ref: composedRef,
        style: {
            width: "var(--radix-scroll-area-thumb-width)",
            height: "var(--radix-scroll-area-thumb-height)",
            ...style
        },
        onPointerDownCapture: (0, $hFcKE.composeEventHandlers)(props.onPointerDownCapture, (event)=>{
            const thumb = event.target;
            const thumbRect = thumb.getBoundingClientRect();
            const x = event.clientX - thumbRect.left;
            const y = event.clientY - thumbRect.top;
            scrollbarContext.onThumbPointerDown({
                x: x,
                y: y
            });
        }),
        onPointerUp: (0, $hFcKE.composeEventHandlers)(props.onPointerUp, scrollbarContext.onThumbPointerUp)
    });
});
$623267bc8899b58d$export$9fba1154677d7cd2.displayName = $623267bc8899b58d$var$THUMB_NAME;
var $623267bc8899b58d$var$CORNER_NAME = "ScrollAreaCorner";
var $623267bc8899b58d$export$56969d565df7cc4b = $jbmdS.forwardRef((props, forwardedRef)=>{
    const context = $623267bc8899b58d$var$useScrollAreaContext($623267bc8899b58d$var$CORNER_NAME, props.__scopeScrollArea);
    const hasBothScrollbarsVisible = Boolean(context.scrollbarX && context.scrollbarY);
    const hasCorner = context.type !== "scroll" && hasBothScrollbarsVisible;
    return hasCorner ? /* @__PURE__ */ (0, $4TLFw.jsx)($623267bc8899b58d$var$ScrollAreaCornerImpl, {
        ...props,
        ref: forwardedRef
    }) : null;
});
$623267bc8899b58d$export$56969d565df7cc4b.displayName = $623267bc8899b58d$var$CORNER_NAME;
var $623267bc8899b58d$var$ScrollAreaCornerImpl = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeScrollArea: __scopeScrollArea, ...cornerProps } = props;
    const context = $623267bc8899b58d$var$useScrollAreaContext($623267bc8899b58d$var$CORNER_NAME, __scopeScrollArea);
    const [width, setWidth] = $jbmdS.useState(0);
    const [height, setHeight] = $jbmdS.useState(0);
    const hasSize = Boolean(width && height);
    $623267bc8899b58d$var$useResizeObserver(context.scrollbarX, ()=>{
        const height2 = context.scrollbarX?.offsetHeight || 0;
        context.onCornerHeightChange(height2);
        setHeight(height2);
    });
    $623267bc8899b58d$var$useResizeObserver(context.scrollbarY, ()=>{
        const width2 = context.scrollbarY?.offsetWidth || 0;
        context.onCornerWidthChange(width2);
        setWidth(width2);
    });
    return hasSize ? /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).div, {
        ...cornerProps,
        ref: forwardedRef,
        style: {
            width: width,
            height: height,
            position: "absolute",
            right: context.dir === "ltr" ? 0 : void 0,
            left: context.dir === "rtl" ? 0 : void 0,
            bottom: 0,
            ...props.style
        }
    }) : null;
});
function $623267bc8899b58d$var$toInt(value) {
    return value ? parseInt(value, 10) : 0;
}
function $623267bc8899b58d$var$getThumbRatio(viewportSize, contentSize) {
    const ratio = viewportSize / contentSize;
    return isNaN(ratio) ? 0 : ratio;
}
function $623267bc8899b58d$var$getThumbSize(sizes) {
    const ratio = $623267bc8899b58d$var$getThumbRatio(sizes.viewport, sizes.content);
    const scrollbarPadding = sizes.scrollbar.paddingStart + sizes.scrollbar.paddingEnd;
    const thumbSize = (sizes.scrollbar.size - scrollbarPadding) * ratio;
    return Math.max(thumbSize, 18);
}
function $623267bc8899b58d$var$getScrollPositionFromPointer(pointerPos, pointerOffset, sizes, dir = "ltr") {
    const thumbSizePx = $623267bc8899b58d$var$getThumbSize(sizes);
    const thumbCenter = thumbSizePx / 2;
    const offset = pointerOffset || thumbCenter;
    const thumbOffsetFromEnd = thumbSizePx - offset;
    const minPointerPos = sizes.scrollbar.paddingStart + offset;
    const maxPointerPos = sizes.scrollbar.size - sizes.scrollbar.paddingEnd - thumbOffsetFromEnd;
    const maxScrollPos = sizes.content - sizes.viewport;
    const scrollRange = dir === "ltr" ? [
        0,
        maxScrollPos
    ] : [
        maxScrollPos * -1,
        0
    ];
    const interpolate = $623267bc8899b58d$var$linearScale([
        minPointerPos,
        maxPointerPos
    ], scrollRange);
    return interpolate(pointerPos);
}
function $623267bc8899b58d$var$getThumbOffsetFromScroll(scrollPos, sizes, dir = "ltr") {
    const thumbSizePx = $623267bc8899b58d$var$getThumbSize(sizes);
    const scrollbarPadding = sizes.scrollbar.paddingStart + sizes.scrollbar.paddingEnd;
    const scrollbar = sizes.scrollbar.size - scrollbarPadding;
    const maxScrollPos = sizes.content - sizes.viewport;
    const maxThumbPos = scrollbar - thumbSizePx;
    const scrollClampRange = dir === "ltr" ? [
        0,
        maxScrollPos
    ] : [
        maxScrollPos * -1,
        0
    ];
    const scrollWithoutMomentum = (0, $kMiXC.clamp)(scrollPos, scrollClampRange);
    const interpolate = $623267bc8899b58d$var$linearScale([
        0,
        maxScrollPos
    ], [
        0,
        maxThumbPos
    ]);
    return interpolate(scrollWithoutMomentum);
}
function $623267bc8899b58d$var$linearScale(input, output) {
    return (value)=>{
        if (input[0] === input[1] || output[0] === output[1]) return output[0];
        const ratio = (output[1] - output[0]) / (input[1] - input[0]);
        return output[0] + ratio * (value - input[0]);
    };
}
function $623267bc8899b58d$var$isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos) {
    return scrollPos > 0 && scrollPos < maxScrollPos;
}
var $623267bc8899b58d$var$addUnlinkedScrollListener = (node, handler = ()=>{})=>{
    let prevPosition = {
        left: node.scrollLeft,
        top: node.scrollTop
    };
    let rAF = 0;
    (function loop() {
        const position = {
            left: node.scrollLeft,
            top: node.scrollTop
        };
        const isHorizontalScroll = prevPosition.left !== position.left;
        const isVerticalScroll = prevPosition.top !== position.top;
        if (isHorizontalScroll || isVerticalScroll) handler();
        prevPosition = position;
        rAF = window.requestAnimationFrame(loop);
    })();
    return ()=>window.cancelAnimationFrame(rAF);
};
function $623267bc8899b58d$var$useDebounceCallback(callback, delay) {
    const handleCallback = (0, $kjEX1.useCallbackRef)(callback);
    const debounceTimerRef = $jbmdS.useRef(0);
    $jbmdS.useEffect(()=>()=>window.clearTimeout(debounceTimerRef.current), []);
    return $jbmdS.useCallback(()=>{
        window.clearTimeout(debounceTimerRef.current);
        debounceTimerRef.current = window.setTimeout(handleCallback, delay);
    }, [
        handleCallback,
        delay
    ]);
}
function $623267bc8899b58d$var$useResizeObserver(element, onResize) {
    const handleResize = (0, $kjEX1.useCallbackRef)(onResize);
    (0, $9crHl.useLayoutEffect)(()=>{
        let rAF = 0;
        if (element) {
            const resizeObserver = new ResizeObserver(()=>{
                cancelAnimationFrame(rAF);
                rAF = window.requestAnimationFrame(handleResize);
            });
            resizeObserver.observe(element);
            return ()=>{
                window.cancelAnimationFrame(rAF);
                resizeObserver.unobserve(element);
            };
        }
    }, [
        element,
        handleResize
    ]);
}
function $623267bc8899b58d$var$getSubtree(options, content) {
    const { asChild: asChild, children: children } = options;
    if (!asChild) return typeof content === "function" ? content(children) : content;
    const firstChild = $jbmdS.Children.only(children);
    return $jbmdS.cloneElement(firstChild, {
        children: typeof content === "function" ? content(firstChild.props.children) : content
    });
}
var $623267bc8899b58d$export$be92b6f5f03c0fe9 = $623267bc8899b58d$export$ccf8d8d7bbf3c2cc;
var $623267bc8899b58d$export$d5c6c08dc2d3ca7 = $623267bc8899b58d$export$a21cbf9f11fca853;
var $623267bc8899b58d$export$9a4e88b92edfce6b = $623267bc8899b58d$export$2fabd85d0eba3c57;
var $623267bc8899b58d$export$6521433ed15a34db = $623267bc8899b58d$export$9fba1154677d7cd2;
var $623267bc8899b58d$export$ac61190d9fc311a9 = $623267bc8899b58d$export$56969d565df7cc4b;

});


parcelRegister("artg7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79a31f3e1659b3cf$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $79a31f3e1659b3cf$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("BookUser", [
    [
        "path",
        {
            d: "M15 13a3 3 0 1 0-6 0",
            key: "10j68g"
        }
    ],
    [
        "path",
        {
            d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
            key: "k3hazp"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "8",
            r: "2",
            key: "1822b1"
        }
    ]
]);

});

parcelRegister("3yHyu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2976553c8f6b1458$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $2976553c8f6b1458$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("Building", [
    [
        "rect",
        {
            width: "16",
            height: "20",
            x: "4",
            y: "2",
            rx: "2",
            ry: "2",
            key: "76otgf"
        }
    ],
    [
        "path",
        {
            d: "M9 22v-4h6v4",
            key: "r93iot"
        }
    ],
    [
        "path",
        {
            d: "M8 6h.01",
            key: "1dz90k"
        }
    ],
    [
        "path",
        {
            d: "M16 6h.01",
            key: "1x0f13"
        }
    ],
    [
        "path",
        {
            d: "M12 6h.01",
            key: "1vi96p"
        }
    ],
    [
        "path",
        {
            d: "M12 10h.01",
            key: "1nrarc"
        }
    ],
    [
        "path",
        {
            d: "M12 14h.01",
            key: "1etili"
        }
    ],
    [
        "path",
        {
            d: "M16 10h.01",
            key: "1m94wz"
        }
    ],
    [
        "path",
        {
            d: "M16 14h.01",
            key: "1gbofw"
        }
    ],
    [
        "path",
        {
            d: "M8 10h.01",
            key: "19clt8"
        }
    ],
    [
        "path",
        {
            d: "M8 14h.01",
            key: "6423bh"
        }
    ]
]);

});

parcelRegister("aBjoI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b7c6812755f1388$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $7b7c6812755f1388$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("Clock", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "polyline",
        {
            points: "12 6 12 12 16 14",
            key: "68esgv"
        }
    ]
]);

});

parcelRegister("jqbKH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2398fc4601ca4f5$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $e2398fc4601ca4f5$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("CircleHelp", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3",
            key: "1u773s"
        }
    ],
    [
        "path",
        {
            d: "M12 17h.01",
            key: "p32p05"
        }
    ]
]);

});

parcelRegister("4etQs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $314f9ed5fff227fd$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $314f9ed5fff227fd$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("Landmark", [
    [
        "line",
        {
            x1: "3",
            x2: "21",
            y1: "22",
            y2: "22",
            key: "j8o0r"
        }
    ],
    [
        "line",
        {
            x1: "6",
            x2: "6",
            y1: "18",
            y2: "11",
            key: "10tf0k"
        }
    ],
    [
        "line",
        {
            x1: "10",
            x2: "10",
            y1: "18",
            y2: "11",
            key: "54lgf6"
        }
    ],
    [
        "line",
        {
            x1: "14",
            x2: "14",
            y1: "18",
            y2: "11",
            key: "380y"
        }
    ],
    [
        "line",
        {
            x1: "18",
            x2: "18",
            y1: "18",
            y2: "11",
            key: "1kevvc"
        }
    ],
    [
        "polygon",
        {
            points: "12 2 20 7 4 7",
            key: "jkujk7"
        }
    ]
]);

});

parcelRegister("aLwbW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d6743bf77495dc5$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $7d6743bf77495dc5$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("EllipsisVertical", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "1",
            key: "41hilf"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "5",
            r: "1",
            key: "gxeob9"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "19",
            r: "1",
            key: "lyex9k"
        }
    ]
]);

});

parcelRegister("hwsY5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc1be5510c3b3067$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $cc1be5510c3b3067$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("PencilRuler", [
    [
        "path",
        {
            d: "M13 7 8.7 2.7a2.41 2.41 0 0 0-3.4 0L2.7 5.3a2.41 2.41 0 0 0 0 3.4L7 13",
            key: "orapub"
        }
    ],
    [
        "path",
        {
            d: "m8 6 2-2",
            key: "115y1s"
        }
    ],
    [
        "path",
        {
            d: "m18 16 2-2",
            key: "ee94s4"
        }
    ],
    [
        "path",
        {
            d: "m17 11 4.3 4.3c.94.94.94 2.46 0 3.4l-2.6 2.6c-.94.94-2.46.94-3.4 0L11 17",
            key: "cfq27r"
        }
    ],
    [
        "path",
        {
            d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
            key: "1a8usu"
        }
    ],
    [
        "path",
        {
            d: "m15 5 4 4",
            key: "1mk7zo"
        }
    ]
]);

});

parcelRegister("kKuTV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1b012d912893b9b$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $f1b012d912893b9b$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("ReceiptText", [
    [
        "path",
        {
            d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z",
            key: "q3az6g"
        }
    ],
    [
        "path",
        {
            d: "M14 8H8",
            key: "1l3xfs"
        }
    ],
    [
        "path",
        {
            d: "M16 12H8",
            key: "1fr5h0"
        }
    ],
    [
        "path",
        {
            d: "M13 16H8",
            key: "wsln4y"
        }
    ]
]);

});

parcelRegister("ks8uR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee3d0374e4c4c3e6$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $ee3d0374e4c4c3e6$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("Settings", [
    [
        "path",
        {
            d: "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z",
            key: "1qme2f"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "3",
            key: "1v7zrd"
        }
    ]
]);

});

parcelRegister("fOr1R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8307dedb000251e$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $b8307dedb000251e$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("Truck", [
    [
        "path",
        {
            d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2",
            key: "wrbu53"
        }
    ],
    [
        "path",
        {
            d: "M15 18H9",
            key: "1lyqi6"
        }
    ],
    [
        "path",
        {
            d: "M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14",
            key: "lysw3i"
        }
    ],
    [
        "circle",
        {
            cx: "17",
            cy: "18",
            r: "2",
            key: "332jqn"
        }
    ],
    [
        "circle",
        {
            cx: "7",
            cy: "18",
            r: "2",
            key: "19iecd"
        }
    ]
]);

});

parcelRegister("7TXf7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c0b9fdd355ba37e$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $5c0b9fdd355ba37e$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("Users", [
    [
        "path",
        {
            d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
            key: "1yyitq"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "7",
            r: "4",
            key: "nufk8"
        }
    ],
    [
        "path",
        {
            d: "M22 21v-2a4 4 0 0 0-3-3.87",
            key: "kshegd"
        }
    ],
    [
        "path",
        {
            d: "M16 3.13a4 4 0 0 1 0 7.75",
            key: "1da9ce"
        }
    ]
]);

});

parcelRegister("cOJf8", function(module, exports) {

$parcel$export(module.exports, "useAutoAnimate", function () { return $62b26c8ed7b054e4$export$2a4acc45afacf2f2; });

var $jbmdS = parcelRequire("jbmdS");

var $3rQac = parcelRequire("3rQac");
/**
 * AutoAnimate hook for adding dead-simple transitions and animations to react.
 * @param options - Auto animate options or a plugin
 * @returns
 */ function $62b26c8ed7b054e4$export$2a4acc45afacf2f2(options) {
    const [controller, setController] = (0, $jbmdS.useState)();
    const memoizedOptions = (0, $jbmdS.useMemo)(()=>options, []);
    const element = (0, $jbmdS.useCallback)((node)=>{
        if (node instanceof HTMLElement) setController((0, $3rQac.default)(node, memoizedOptions));
        else setController(undefined);
    }, [
        memoizedOptions
    ]);
    const setEnabled = (0, $jbmdS.useCallback)((enabled)=>{
        if (controller) enabled ? controller.enable() : controller.disable();
    }, [
        controller
    ]);
    return [
        element,
        setEnabled
    ];
}

});
parcelRegister("3rQac", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $adc651f90287d56b$export$2e2bcd8739ae039; });
/**
 * A set of all the parents currently being observe. This is the only non weak
 * registry.
 */ const $adc651f90287d56b$var$parents = new Set();
/**
 * Element coordinates that is constantly kept up to date.
 */ const $adc651f90287d56b$var$coords = new WeakMap();
/**
 * Siblings of elements that have been removed from the dom.
 */ const $adc651f90287d56b$var$siblings = new WeakMap();
/**
 * Animations that are currently running.
 */ const $adc651f90287d56b$var$animations = new WeakMap();
/**
 * A map of existing intersection observers used to track element movements.
 */ const $adc651f90287d56b$var$intersections = new WeakMap();
/**
 * Intervals for automatically checking the position of elements occasionally.
 */ const $adc651f90287d56b$var$intervals = new WeakMap();
/**
 * The configuration options for each group of elements.
 */ const $adc651f90287d56b$var$options = new WeakMap();
/**
 * Debounce counters by id, used to debounce calls to update positions.
 */ const $adc651f90287d56b$var$debounces = new WeakMap();
/**
 * All parents that are currently enabled are tracked here.
 */ const $adc651f90287d56b$var$enabled = new WeakSet();
/**
 * The document used to calculate transitions.
 */ let $adc651f90287d56b$var$root;
/**
 * The root’s XY scroll positions.
 */ let $adc651f90287d56b$var$scrollX = 0;
let $adc651f90287d56b$var$scrollY = 0;
/**
 * Used to sign an element as the target.
 */ const $adc651f90287d56b$var$TGT = "__aa_tgt";
/**
 * Used to sign an element as being part of a removal.
 */ const $adc651f90287d56b$var$DEL = "__aa_del";
/**
 * Used to sign an element as being "new". When an element is removed from the
 * dom, but may cycle back in we can sign it with new to ensure the next time
 * it is recognized we consider it new.
 */ const $adc651f90287d56b$var$NEW = "__aa_new";
/**
 * Callback for handling all mutations.
 * @param mutations - A mutation list
 */ const $adc651f90287d56b$var$handleMutations = (mutations)=>{
    const elements = $adc651f90287d56b$var$getElements(mutations);
    // If elements is "false" that means this mutation that should be ignored.
    if (elements) elements.forEach((el)=>$adc651f90287d56b$var$animate(el));
};
/**
 *
 * @param entries - Elements that have been resized.
 */ const $adc651f90287d56b$var$handleResizes = (entries)=>{
    entries.forEach((entry)=>{
        if (entry.target === $adc651f90287d56b$var$root) $adc651f90287d56b$var$updateAllPos();
        if ($adc651f90287d56b$var$coords.has(entry.target)) $adc651f90287d56b$var$updatePos(entry.target);
    });
};
/**
 * Observe this elements position.
 * @param el - The element to observe the position of.
 */ function $adc651f90287d56b$var$observePosition(el) {
    const oldObserver = $adc651f90287d56b$var$intersections.get(el);
    oldObserver === null || oldObserver === void 0 || oldObserver.disconnect();
    let rect = $adc651f90287d56b$var$coords.get(el);
    let invocations = 0;
    const buffer = 5;
    if (!rect) {
        rect = $adc651f90287d56b$var$getCoords(el);
        $adc651f90287d56b$var$coords.set(el, rect);
    }
    const { offsetWidth: offsetWidth, offsetHeight: offsetHeight } = $adc651f90287d56b$var$root;
    const rootMargins = [
        rect.top - buffer,
        offsetWidth - (rect.left + buffer + rect.width),
        offsetHeight - (rect.top + buffer + rect.height),
        rect.left - buffer
    ];
    const rootMargin = rootMargins.map((px)=>`${-1 * Math.floor(px)}px`).join(" ");
    const observer = new IntersectionObserver(()=>{
        ++invocations > 1 && $adc651f90287d56b$var$updatePos(el);
    }, {
        root: $adc651f90287d56b$var$root,
        threshold: 1,
        rootMargin: rootMargin
    });
    observer.observe(el);
    $adc651f90287d56b$var$intersections.set(el, observer);
}
/**
 * Update the exact position of a given element.
 * @param el - An element to update the position of.
 */ function $adc651f90287d56b$var$updatePos(el) {
    clearTimeout($adc651f90287d56b$var$debounces.get(el));
    const optionsOrPlugin = $adc651f90287d56b$var$getOptions(el);
    const delay = $adc651f90287d56b$var$isPlugin(optionsOrPlugin) ? 500 : optionsOrPlugin.duration;
    $adc651f90287d56b$var$debounces.set(el, setTimeout(async ()=>{
        const currentAnimation = $adc651f90287d56b$var$animations.get(el);
        try {
            await (currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.finished);
            $adc651f90287d56b$var$coords.set(el, $adc651f90287d56b$var$getCoords(el));
            $adc651f90287d56b$var$observePosition(el);
        } catch  {
        // ignore errors as the `.finished` promise is rejected when animations were cancelled
        }
    }, delay));
}
/**
 * Updates all positions that are currently being tracked.
 */ function $adc651f90287d56b$var$updateAllPos() {
    clearTimeout($adc651f90287d56b$var$debounces.get($adc651f90287d56b$var$root));
    $adc651f90287d56b$var$debounces.set($adc651f90287d56b$var$root, setTimeout(()=>{
        $adc651f90287d56b$var$parents.forEach((parent)=>$adc651f90287d56b$var$forEach(parent, (el)=>$adc651f90287d56b$var$lowPriority(()=>$adc651f90287d56b$var$updatePos(el))));
    }, 100));
}
/**
 * Its possible for a quick scroll or other fast events to get past the
 * intersection observer, so occasionally we need want "cold-poll" for the
 * latests and greatest position. We try to do this in the most non-disruptive
 * fashion possible. First we only do this ever couple seconds, staggard by a
 * random offset.
 * @param el - Element
 */ function $adc651f90287d56b$var$poll(el) {
    setTimeout(()=>{
        $adc651f90287d56b$var$intervals.set(el, setInterval(()=>$adc651f90287d56b$var$lowPriority($adc651f90287d56b$var$updatePos.bind(null, el)), 2000));
    }, Math.round(2000 * Math.random()));
}
/**
 * Perform some operation that is non critical at some point.
 * @param callback
 */ function $adc651f90287d56b$var$lowPriority(callback) {
    if (typeof requestIdleCallback === "function") requestIdleCallback(()=>callback());
    else requestAnimationFrame(()=>callback());
}
/**
 * The mutation observer responsible for watching each root element.
 */ let $adc651f90287d56b$var$mutations;
/**
 * A resize observer, responsible for recalculating elements on resize.
 */ let $adc651f90287d56b$var$resize;
/**
 * Ensure the browser is supported.
 */ const $adc651f90287d56b$var$supportedBrowser = typeof window !== "undefined" && "ResizeObserver" in window;
/**
 * If this is in a browser, initialize our Web APIs
 */ if ($adc651f90287d56b$var$supportedBrowser) {
    $adc651f90287d56b$var$root = document.documentElement;
    $adc651f90287d56b$var$mutations = new MutationObserver($adc651f90287d56b$var$handleMutations);
    $adc651f90287d56b$var$resize = new ResizeObserver($adc651f90287d56b$var$handleResizes);
    window.addEventListener("scroll", ()=>{
        $adc651f90287d56b$var$scrollY = window.scrollY;
        $adc651f90287d56b$var$scrollX = window.scrollX;
    });
    $adc651f90287d56b$var$resize.observe($adc651f90287d56b$var$root);
}
/**
 * Retrieves all the elements that may have been affected by the last mutation
 * including ones that have been removed and are no longer in the DOM.
 * @param mutations - A mutation list.
 * @returns
 */ function $adc651f90287d56b$var$getElements(mutations) {
    const observedNodes = mutations.reduce((nodes, mutation)=>{
        return [
            ...nodes,
            ...Array.from(mutation.addedNodes),
            ...Array.from(mutation.removedNodes)
        ];
    }, []);
    // Short circuit if _only_ comment nodes are observed
    const onlyCommentNodesObserved = observedNodes.every((node)=>node.nodeName === "#comment");
    if (onlyCommentNodesObserved) return false;
    return mutations.reduce((elements, mutation)=>{
        // Short circuit if we find a purposefully deleted node.
        if (elements === false) return false;
        if (mutation.target instanceof Element) {
            $adc651f90287d56b$var$target(mutation.target);
            if (!elements.has(mutation.target)) {
                elements.add(mutation.target);
                for(let i = 0; i < mutation.target.children.length; i++){
                    const child = mutation.target.children.item(i);
                    if (!child) continue;
                    if ($adc651f90287d56b$var$DEL in child) return false;
                    $adc651f90287d56b$var$target(mutation.target, child);
                    elements.add(child);
                }
            }
            if (mutation.removedNodes.length) for(let i = 0; i < mutation.removedNodes.length; i++){
                const child = mutation.removedNodes[i];
                if ($adc651f90287d56b$var$DEL in child) return false;
                if (child instanceof Element) {
                    elements.add(child);
                    $adc651f90287d56b$var$target(mutation.target, child);
                    $adc651f90287d56b$var$siblings.set(child, [
                        mutation.previousSibling,
                        mutation.nextSibling
                    ]);
                }
            }
        }
        return elements;
    }, new Set());
}
/**
 * Assign the target to an element.
 * @param el - The root element
 * @param child
 */ function $adc651f90287d56b$var$target(el, child) {
    if (!child && !($adc651f90287d56b$var$TGT in el)) Object.defineProperty(el, $adc651f90287d56b$var$TGT, {
        value: el
    });
    else if (child && !($adc651f90287d56b$var$TGT in child)) Object.defineProperty(child, $adc651f90287d56b$var$TGT, {
        value: el
    });
}
/**
 * Determines what kind of change took place on the given element and then
 * performs the proper animation based on that.
 * @param el - The specific element to animate.
 */ function $adc651f90287d56b$var$animate(el) {
    var _a;
    const isMounted = el.isConnected;
    const preExisting = $adc651f90287d56b$var$coords.has(el);
    if (isMounted && $adc651f90287d56b$var$siblings.has(el)) $adc651f90287d56b$var$siblings.delete(el);
    if ($adc651f90287d56b$var$animations.has(el)) (_a = $adc651f90287d56b$var$animations.get(el)) === null || _a === void 0 || _a.cancel();
    if ($adc651f90287d56b$var$NEW in el) $adc651f90287d56b$var$add(el);
    else if (preExisting && isMounted) $adc651f90287d56b$var$remain(el);
    else if (preExisting && !isMounted) $adc651f90287d56b$var$remove(el);
    else $adc651f90287d56b$var$add(el);
}
/**
 * Removes all non-digits from a string and casts to a number.
 * @param str - A string containing a pixel value.
 * @returns
 */ function $adc651f90287d56b$var$raw(str) {
    return Number(str.replace(/[^0-9.\-]/g, ""));
}
/**
 * Get the scroll offset of elements
 * @param el - Element
 * @returns
 */ function $adc651f90287d56b$var$getScrollOffset(el) {
    let p = el.parentElement;
    while(p){
        if (p.scrollLeft || p.scrollTop) return {
            x: p.scrollLeft,
            y: p.scrollTop
        };
        p = p.parentElement;
    }
    return {
        x: 0,
        y: 0
    };
}
/**
 * Get the coordinates of elements adjusted for scroll position.
 * @param el - Element
 * @returns
 */ function $adc651f90287d56b$var$getCoords(el) {
    const rect = el.getBoundingClientRect();
    const { x: x, y: y } = $adc651f90287d56b$var$getScrollOffset(el);
    return {
        top: rect.top + y,
        left: rect.left + x,
        width: rect.width,
        height: rect.height
    };
}
/**
 * Returns the width/height that the element should be transitioned between.
 * This takes into account box-sizing.
 * @param el - Element being animated
 * @param oldCoords - Old set of Coordinates coordinates
 * @param newCoords - New set of Coordinates coordinates
 * @returns
 */ function $adc651f90287d56b$export$18b6425e11c8bb66(el, oldCoords, newCoords) {
    let widthFrom = oldCoords.width;
    let heightFrom = oldCoords.height;
    let widthTo = newCoords.width;
    let heightTo = newCoords.height;
    const styles = getComputedStyle(el);
    const sizing = styles.getPropertyValue("box-sizing");
    if (sizing === "content-box") {
        const paddingY = $adc651f90287d56b$var$raw(styles.paddingTop) + $adc651f90287d56b$var$raw(styles.paddingBottom) + $adc651f90287d56b$var$raw(styles.borderTopWidth) + $adc651f90287d56b$var$raw(styles.borderBottomWidth);
        const paddingX = $adc651f90287d56b$var$raw(styles.paddingLeft) + $adc651f90287d56b$var$raw(styles.paddingRight) + $adc651f90287d56b$var$raw(styles.borderRightWidth) + $adc651f90287d56b$var$raw(styles.borderLeftWidth);
        widthFrom -= paddingX;
        widthTo -= paddingX;
        heightFrom -= paddingY;
        heightTo -= paddingY;
    }
    return [
        widthFrom,
        widthTo,
        heightFrom,
        heightTo
    ].map(Math.round);
}
/**
 * Retrieves animation options for the current element.
 * @param el - Element to retrieve options for.
 * @returns
 */ function $adc651f90287d56b$var$getOptions(el) {
    return $adc651f90287d56b$var$TGT in el && $adc651f90287d56b$var$options.has(el[$adc651f90287d56b$var$TGT]) ? $adc651f90287d56b$var$options.get(el[$adc651f90287d56b$var$TGT]) : {
        duration: 250,
        easing: "ease-in-out"
    };
}
/**
 * Returns the target of a given animation (generally the parent).
 * @param el - An element to check for a target
 * @returns
 */ function $adc651f90287d56b$var$getTarget(el) {
    if ($adc651f90287d56b$var$TGT in el) return el[$adc651f90287d56b$var$TGT];
    return undefined;
}
/**
 * Checks if animations are enabled or disabled for a given element.
 * @param el - Any element
 * @returns
 */ function $adc651f90287d56b$var$isEnabled(el) {
    const target = $adc651f90287d56b$var$getTarget(el);
    return target ? $adc651f90287d56b$var$enabled.has(target) : false;
}
/**
 * Iterate over the children of a given parent.
 * @param parent - A parent element
 * @param callback - A callback
 */ function $adc651f90287d56b$var$forEach(parent, ...callbacks) {
    callbacks.forEach((callback)=>callback(parent, $adc651f90287d56b$var$options.has(parent)));
    for(let i = 0; i < parent.children.length; i++){
        const child = parent.children.item(i);
        if (child) callbacks.forEach((callback)=>callback(child, $adc651f90287d56b$var$options.has(child)));
    }
}
/**
 * Always return tuple to provide consistent interface
 */ function $adc651f90287d56b$var$getPluginTuple(pluginReturn) {
    if (Array.isArray(pluginReturn)) return pluginReturn;
    return [
        pluginReturn
    ];
}
/**
 * Determine if config is plugin
 */ function $adc651f90287d56b$var$isPlugin(config) {
    return typeof config === "function";
}
/**
 * The element in question is remaining in the DOM.
 * @param el - Element to flip
 * @returns
 */ function $adc651f90287d56b$var$remain(el) {
    const oldCoords = $adc651f90287d56b$var$coords.get(el);
    const newCoords = $adc651f90287d56b$var$getCoords(el);
    if (!$adc651f90287d56b$var$isEnabled(el)) return $adc651f90287d56b$var$coords.set(el, newCoords);
    let animation;
    if (!oldCoords) return;
    const pluginOrOptions = $adc651f90287d56b$var$getOptions(el);
    if (typeof pluginOrOptions !== "function") {
        const deltaX = oldCoords.left - newCoords.left;
        const deltaY = oldCoords.top - newCoords.top;
        const [widthFrom, widthTo, heightFrom, heightTo] = $adc651f90287d56b$export$18b6425e11c8bb66(el, oldCoords, newCoords);
        const start = {
            transform: `translate(${deltaX}px, ${deltaY}px)`
        };
        const end = {
            transform: `translate(0, 0)`
        };
        if (widthFrom !== widthTo) {
            start.width = `${widthFrom}px`;
            end.width = `${widthTo}px`;
        }
        if (heightFrom !== heightTo) {
            start.height = `${heightFrom}px`;
            end.height = `${heightTo}px`;
        }
        animation = el.animate([
            start,
            end
        ], {
            duration: pluginOrOptions.duration,
            easing: pluginOrOptions.easing
        });
    } else {
        const [keyframes] = $adc651f90287d56b$var$getPluginTuple(pluginOrOptions(el, "remain", oldCoords, newCoords));
        animation = new Animation(keyframes);
        animation.play();
    }
    $adc651f90287d56b$var$animations.set(el, animation);
    $adc651f90287d56b$var$coords.set(el, newCoords);
    animation.addEventListener("finish", $adc651f90287d56b$var$updatePos.bind(null, el));
}
/**
 * Adds the element with a transition.
 * @param el - Animates the element being added.
 */ function $adc651f90287d56b$var$add(el) {
    if ($adc651f90287d56b$var$NEW in el) delete el[$adc651f90287d56b$var$NEW];
    const newCoords = $adc651f90287d56b$var$getCoords(el);
    $adc651f90287d56b$var$coords.set(el, newCoords);
    const pluginOrOptions = $adc651f90287d56b$var$getOptions(el);
    if (!$adc651f90287d56b$var$isEnabled(el)) return;
    let animation;
    if (typeof pluginOrOptions !== "function") animation = el.animate([
        {
            transform: "scale(.98)",
            opacity: 0
        },
        {
            transform: "scale(0.98)",
            opacity: 0,
            offset: 0.5
        },
        {
            transform: "scale(1)",
            opacity: 1
        }
    ], {
        duration: pluginOrOptions.duration * 1.5,
        easing: "ease-in"
    });
    else {
        const [keyframes] = $adc651f90287d56b$var$getPluginTuple(pluginOrOptions(el, "add", newCoords));
        animation = new Animation(keyframes);
        animation.play();
    }
    $adc651f90287d56b$var$animations.set(el, animation);
    animation.addEventListener("finish", $adc651f90287d56b$var$updatePos.bind(null, el));
}
/**
 * Clean up after removing an element from the dom.
 * @param el - Element being removed
 * @param styles - Optional styles that should be removed from the element.
 */ function $adc651f90287d56b$var$cleanUp(el, styles) {
    var _a;
    el.remove();
    $adc651f90287d56b$var$coords.delete(el);
    $adc651f90287d56b$var$siblings.delete(el);
    $adc651f90287d56b$var$animations.delete(el);
    (_a = $adc651f90287d56b$var$intersections.get(el)) === null || _a === void 0 || _a.disconnect();
    setTimeout(()=>{
        if ($adc651f90287d56b$var$DEL in el) delete el[$adc651f90287d56b$var$DEL];
        Object.defineProperty(el, $adc651f90287d56b$var$NEW, {
            value: true,
            configurable: true
        });
        if (styles && el instanceof HTMLElement) for(const style in styles)el.style[style] = "";
    }, 0);
}
/**
 * Animates the removal of an element.
 * @param el - Element to remove
 */ function $adc651f90287d56b$var$remove(el) {
    var _a;
    if (!$adc651f90287d56b$var$siblings.has(el) || !$adc651f90287d56b$var$coords.has(el)) return;
    const [prev, next] = $adc651f90287d56b$var$siblings.get(el);
    Object.defineProperty(el, $adc651f90287d56b$var$DEL, {
        value: true,
        configurable: true
    });
    const finalX = window.scrollX;
    const finalY = window.scrollY;
    if (next && next.parentNode && next.parentNode instanceof Element) next.parentNode.insertBefore(el, next);
    else if (prev && prev.parentNode) prev.parentNode.appendChild(el);
    else (_a = $adc651f90287d56b$var$getTarget(el)) === null || _a === void 0 || _a.appendChild(el);
    if (!$adc651f90287d56b$var$isEnabled(el)) return $adc651f90287d56b$var$cleanUp(el);
    const [top, left, width, height] = $adc651f90287d56b$var$deletePosition(el);
    const optionsOrPlugin = $adc651f90287d56b$var$getOptions(el);
    const oldCoords = $adc651f90287d56b$var$coords.get(el);
    if (finalX !== $adc651f90287d56b$var$scrollX || finalY !== $adc651f90287d56b$var$scrollY) $adc651f90287d56b$var$adjustScroll(el, finalX, finalY, optionsOrPlugin);
    let animation;
    let styleReset = {
        position: "absolute",
        top: `${top}px`,
        left: `${left}px`,
        width: `${width}px`,
        height: `${height}px`,
        margin: "0",
        pointerEvents: "none",
        transformOrigin: "center",
        zIndex: "100"
    };
    if (!$adc651f90287d56b$var$isPlugin(optionsOrPlugin)) {
        Object.assign(el.style, styleReset);
        animation = el.animate([
            {
                transform: "scale(1)",
                opacity: 1
            },
            {
                transform: "scale(.98)",
                opacity: 0
            }
        ], {
            duration: optionsOrPlugin.duration,
            easing: "ease-out"
        });
    } else {
        const [keyframes, options] = $adc651f90287d56b$var$getPluginTuple(optionsOrPlugin(el, "remove", oldCoords));
        if ((options === null || options === void 0 ? void 0 : options.styleReset) !== false) {
            styleReset = (options === null || options === void 0 ? void 0 : options.styleReset) || styleReset;
            Object.assign(el.style, styleReset);
        }
        animation = new Animation(keyframes);
        animation.play();
    }
    $adc651f90287d56b$var$animations.set(el, animation);
    animation.addEventListener("finish", $adc651f90287d56b$var$cleanUp.bind(null, el, styleReset));
}
/**
 * If the element being removed is at the very bottom of the page, and the
 * the page was scrolled into a space being "made available" by the element
 * that was removed, the page scroll will have jumped up some amount. We need
 * to offset the jump by the amount that the page was "automatically" scrolled
 * up. We can do this by comparing the scroll position before and after the
 * element was removed, and then offsetting by that amount.
 *
 * @param el - The element being deleted
 * @param finalX - The final X scroll position
 * @param finalY - The final Y scroll position
 * @param optionsOrPlugin - The options or plugin
 * @returns
 */ function $adc651f90287d56b$var$adjustScroll(el, finalX, finalY, optionsOrPlugin) {
    const scrollDeltaX = $adc651f90287d56b$var$scrollX - finalX;
    const scrollDeltaY = $adc651f90287d56b$var$scrollY - finalY;
    const scrollBefore = document.documentElement.style.scrollBehavior;
    const scrollBehavior = getComputedStyle($adc651f90287d56b$var$root).scrollBehavior;
    if (scrollBehavior === "smooth") document.documentElement.style.scrollBehavior = "auto";
    window.scrollTo(window.scrollX + scrollDeltaX, window.scrollY + scrollDeltaY);
    if (!el.parentElement) return;
    const parent = el.parentElement;
    let lastHeight = parent.clientHeight;
    let lastWidth = parent.clientWidth;
    const startScroll = performance.now();
    // Here we use a manual scroll animation to keep the element using the same
    // easing and timing as the parent’s scroll animation.
    function smoothScroll() {
        requestAnimationFrame(()=>{
            if (!$adc651f90287d56b$var$isPlugin(optionsOrPlugin)) {
                const deltaY = lastHeight - parent.clientHeight;
                const deltaX = lastWidth - parent.clientWidth;
                if (startScroll + optionsOrPlugin.duration > performance.now()) {
                    window.scrollTo({
                        left: window.scrollX - deltaX,
                        top: window.scrollY - deltaY
                    });
                    lastHeight = parent.clientHeight;
                    lastWidth = parent.clientWidth;
                    smoothScroll();
                } else document.documentElement.style.scrollBehavior = scrollBefore;
            }
        });
    }
    smoothScroll();
}
/**
 * Determines the position of the element being removed.
 * @param el - The element being deleted
 * @returns
 */ function $adc651f90287d56b$var$deletePosition(el) {
    const oldCoords = $adc651f90287d56b$var$coords.get(el);
    const [width, , height] = $adc651f90287d56b$export$18b6425e11c8bb66(el, oldCoords, $adc651f90287d56b$var$getCoords(el));
    let offsetParent = el.parentElement;
    while(offsetParent && (getComputedStyle(offsetParent).position === "static" || offsetParent instanceof HTMLBodyElement))offsetParent = offsetParent.parentElement;
    if (!offsetParent) offsetParent = document.body;
    const parentStyles = getComputedStyle(offsetParent);
    const parentCoords = $adc651f90287d56b$var$coords.get(offsetParent) || $adc651f90287d56b$var$getCoords(offsetParent);
    const top = Math.round(oldCoords.top - parentCoords.top) - $adc651f90287d56b$var$raw(parentStyles.borderTopWidth);
    const left = Math.round(oldCoords.left - parentCoords.left) - $adc651f90287d56b$var$raw(parentStyles.borderLeftWidth);
    return [
        top,
        left,
        width,
        height
    ];
}
/**
 * A function that automatically adds animation effects to itself and its
 * immediate children. Specifically it adds effects for adding, moving, and
 * removing DOM elements.
 * @param el - A parent element to add animations to.
 * @param options - An optional object of options.
 */ function $adc651f90287d56b$export$2e2bcd8739ae039(el, config = {}) {
    if ($adc651f90287d56b$var$mutations && $adc651f90287d56b$var$resize) {
        const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
        const isDisabledDueToReduceMotion = mediaQuery.matches && !$adc651f90287d56b$var$isPlugin(config) && !config.disrespectUserMotionPreference;
        if (!isDisabledDueToReduceMotion) {
            $adc651f90287d56b$var$enabled.add(el);
            if (getComputedStyle(el).position === "static") Object.assign(el.style, {
                position: "relative"
            });
            $adc651f90287d56b$var$forEach(el, $adc651f90287d56b$var$updatePos, $adc651f90287d56b$var$poll, (element)=>$adc651f90287d56b$var$resize === null || $adc651f90287d56b$var$resize === void 0 ? void 0 : $adc651f90287d56b$var$resize.observe(element));
            if ($adc651f90287d56b$var$isPlugin(config)) $adc651f90287d56b$var$options.set(el, config);
            else $adc651f90287d56b$var$options.set(el, {
                duration: 250,
                easing: "ease-in-out",
                ...config
            });
            $adc651f90287d56b$var$mutations.observe(el, {
                childList: true
            });
            $adc651f90287d56b$var$parents.add(el);
        }
    }
    return Object.freeze({
        parent: el,
        enable: ()=>{
            $adc651f90287d56b$var$enabled.add(el);
        },
        disable: ()=>{
            $adc651f90287d56b$var$enabled.delete(el);
        },
        isEnabled: ()=>$adc651f90287d56b$var$enabled.has(el)
    });
}
/**
 * The vue directive.
 */ const $adc651f90287d56b$export$6ff9d5cc9ef9d729 = {
    mounted: (el, binding)=>{
        $adc651f90287d56b$export$2e2bcd8739ae039(el, binding.value || {});
    },
    // ignore ssr see #96:
    getSSRProps: ()=>({})
};

});


parcelRegister("a3BWW", function(module, exports) {

$parcel$export(module.exports, "NavButton", function () { return $b52ad7f692f8d078$export$3b0a9d598f613fa; });
$parcel$export(module.exports, "SideNavButton", function () { return $b52ad7f692f8d078$export$4188957cd63b68ba; });

var $61Ea1 = parcelRequire("61Ea1");

var $fTGwv = parcelRequire("fTGwv");

var $7sV27 = parcelRequire("7sV27");

var $Yha9m = parcelRequire("Yha9m");
const $b52ad7f692f8d078$export$3b0a9d598f613fa = ({ icon: Icon, label: label, onClick: onClick, isExpanded: isExpanded, className: className, active: active, ...props })=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $7sV27.TooltipProvider), {
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $7sV27.Tooltip), {
            delayDuration: 0,
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7sV27.TooltipTrigger), {
                    asChild: true,
                    children: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fTGwv.Button), {
                        size: "sm",
                        variant: "ghost",
                        className: (0, $Yha9m.cn)("w-full justify-start text-foreground hover:bg-accent hover:text-accent-foreground", !isExpanded && "justify-center p-2", active && "bg-accent text-accent-foreground", className),
                        onClick: onClick,
                        ...props,
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)(Icon, {
                                className: (0, $Yha9m.cn)("h-4 w-4", isExpanded && "mr-2")
                            }),
                            isExpanded && /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                children: label
                            })
                        ]
                    })
                }),
                !isExpanded && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7sV27.TooltipContent), {
                    side: "right",
                    align: "center",
                    className: "flex items-center",
                    children: label
                })
            ]
        })
    });
const $b52ad7f692f8d078$export$4188957cd63b68ba = ({ icon: Icon, label: label, onClick: onClick, active: active, ...props })=>/*#__PURE__*/ (0, $61Ea1.jsx)($b52ad7f692f8d078$export$3b0a9d598f613fa, {
        icon: Icon,
        label: label,
        onClick: onClick,
        isExpanded: true,
        className: "mb-4",
        active: active,
        ...props
    });

});
parcelRegister("7sV27", function(module, exports) {

$parcel$export(module.exports, "TooltipProvider", function () { return $8cb3eae7b6e08bbb$export$f78649fb9ca566b8; });
$parcel$export(module.exports, "Tooltip", function () { return $8cb3eae7b6e08bbb$export$28c660c63b792dea; });
$parcel$export(module.exports, "TooltipTrigger", function () { return $8cb3eae7b6e08bbb$export$8c610744efcf8a1d; });
$parcel$export(module.exports, "TooltipContent", function () { return $8cb3eae7b6e08bbb$export$e9003e2be37ec060; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $eo2jg = parcelRequire("eo2jg");

var $Yha9m = parcelRequire("Yha9m");
const $8cb3eae7b6e08bbb$export$f78649fb9ca566b8 = $eo2jg.Provider;
const $8cb3eae7b6e08bbb$export$28c660c63b792dea = $eo2jg.Root;
const $8cb3eae7b6e08bbb$export$8c610744efcf8a1d = $eo2jg.Trigger;
const $8cb3eae7b6e08bbb$export$e9003e2be37ec060 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, sideOffset: sideOffset = 4, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)($eo2jg.Content, {
        ref: ref,
        sideOffset: sideOffset,
        className: (0, $Yha9m.cn)("z-50 overflow-hidden rounded-md border bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", className),
        ...props
    }));
$8cb3eae7b6e08bbb$export$e9003e2be37ec060.displayName = $eo2jg.Content.displayName;

});
parcelRegister("eo2jg", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return $728dc4158edd5428$export$2881499e37b75b9a; });
$parcel$export(module.exports, "Root", function () { return $728dc4158edd5428$export$be92b6f5f03c0fe9; });
$parcel$export(module.exports, "Trigger", function () { return $728dc4158edd5428$export$41fb9f06171c75f4; });
$parcel$export(module.exports, "Content", function () { return $728dc4158edd5428$export$7c6e2c02157bb7d2; });

var $jbmdS = parcelRequire("jbmdS");

var $hFcKE = parcelRequire("hFcKE");

var $9sunj = parcelRequire("9sunj");

var $f4RZG = parcelRequire("f4RZG");

var $jJBMp = parcelRequire("jJBMp");

var $g7F3X = parcelRequire("g7F3X");

var $aU3NZ = parcelRequire("aU3NZ");

var $fKp8B = parcelRequire("fKp8B");

var $joHB8 = parcelRequire("joHB8");

var $cihg9 = parcelRequire("cihg9");

var $bXq35 = parcelRequire("bXq35");

var $1sq0Q = parcelRequire("1sq0Q");

var $fLY1n = parcelRequire("fLY1n");

var $4TLFw = parcelRequire("4TLFw");
"use client";
var [$728dc4158edd5428$var$createTooltipContext, $728dc4158edd5428$export$1c540a2224f0d865] = (0, $f4RZG.createContextScope)("Tooltip", [
    (0, $aU3NZ.createPopperScope)
]);
var $728dc4158edd5428$var$usePopperScope = (0, $aU3NZ.createPopperScope)();
var $728dc4158edd5428$var$PROVIDER_NAME = "TooltipProvider";
var $728dc4158edd5428$var$DEFAULT_DELAY_DURATION = 700;
var $728dc4158edd5428$var$TOOLTIP_OPEN = "tooltip.open";
var [$728dc4158edd5428$var$TooltipProviderContextProvider, $728dc4158edd5428$var$useTooltipProviderContext] = $728dc4158edd5428$var$createTooltipContext($728dc4158edd5428$var$PROVIDER_NAME);
var $728dc4158edd5428$export$f78649fb9ca566b8 = (props)=>{
    const { __scopeTooltip: __scopeTooltip, delayDuration: delayDuration = $728dc4158edd5428$var$DEFAULT_DELAY_DURATION, skipDelayDuration: skipDelayDuration = 300, disableHoverableContent: disableHoverableContent = false, children: children } = props;
    const [isOpenDelayed, setIsOpenDelayed] = $jbmdS.useState(true);
    const isPointerInTransitRef = $jbmdS.useRef(false);
    const skipDelayTimerRef = $jbmdS.useRef(0);
    $jbmdS.useEffect(()=>{
        const skipDelayTimer = skipDelayTimerRef.current;
        return ()=>window.clearTimeout(skipDelayTimer);
    }, []);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($728dc4158edd5428$var$TooltipProviderContextProvider, {
        scope: __scopeTooltip,
        isOpenDelayed: isOpenDelayed,
        delayDuration: delayDuration,
        onOpen: $jbmdS.useCallback(()=>{
            window.clearTimeout(skipDelayTimerRef.current);
            setIsOpenDelayed(false);
        }, []),
        onClose: $jbmdS.useCallback(()=>{
            window.clearTimeout(skipDelayTimerRef.current);
            skipDelayTimerRef.current = window.setTimeout(()=>setIsOpenDelayed(true), skipDelayDuration);
        }, [
            skipDelayDuration
        ]),
        isPointerInTransitRef: isPointerInTransitRef,
        onPointerInTransitChange: $jbmdS.useCallback((inTransit)=>{
            isPointerInTransitRef.current = inTransit;
        }, []),
        disableHoverableContent: disableHoverableContent,
        children: children
    });
};
$728dc4158edd5428$export$f78649fb9ca566b8.displayName = $728dc4158edd5428$var$PROVIDER_NAME;
var $728dc4158edd5428$var$TOOLTIP_NAME = "Tooltip";
var [$728dc4158edd5428$var$TooltipContextProvider, $728dc4158edd5428$var$useTooltipContext] = $728dc4158edd5428$var$createTooltipContext($728dc4158edd5428$var$TOOLTIP_NAME);
var $728dc4158edd5428$export$28c660c63b792dea = (props)=>{
    const { __scopeTooltip: __scopeTooltip, children: children, open: openProp, defaultOpen: defaultOpen = false, onOpenChange: onOpenChange, disableHoverableContent: disableHoverableContentProp, delayDuration: delayDurationProp } = props;
    const providerContext = $728dc4158edd5428$var$useTooltipProviderContext($728dc4158edd5428$var$TOOLTIP_NAME, props.__scopeTooltip);
    const popperScope = $728dc4158edd5428$var$usePopperScope(__scopeTooltip);
    const [trigger, setTrigger] = $jbmdS.useState(null);
    const contentId = (0, $g7F3X.useId)();
    const openTimerRef = $jbmdS.useRef(0);
    const disableHoverableContent = disableHoverableContentProp ?? providerContext.disableHoverableContent;
    const delayDuration = delayDurationProp ?? providerContext.delayDuration;
    const wasOpenDelayedRef = $jbmdS.useRef(false);
    const [open = false, setOpen] = (0, $1sq0Q.useControllableState)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: (open2)=>{
            if (open2) {
                providerContext.onOpen();
                document.dispatchEvent(new CustomEvent($728dc4158edd5428$var$TOOLTIP_OPEN));
            } else providerContext.onClose();
            onOpenChange?.(open2);
        }
    });
    const stateAttribute = $jbmdS.useMemo(()=>{
        return open ? wasOpenDelayedRef.current ? "delayed-open" : "instant-open" : "closed";
    }, [
        open
    ]);
    const handleOpen = $jbmdS.useCallback(()=>{
        window.clearTimeout(openTimerRef.current);
        wasOpenDelayedRef.current = false;
        setOpen(true);
    }, [
        setOpen
    ]);
    const handleClose = $jbmdS.useCallback(()=>{
        window.clearTimeout(openTimerRef.current);
        setOpen(false);
    }, [
        setOpen
    ]);
    const handleDelayedOpen = $jbmdS.useCallback(()=>{
        window.clearTimeout(openTimerRef.current);
        openTimerRef.current = window.setTimeout(()=>{
            wasOpenDelayedRef.current = true;
            setOpen(true);
        }, delayDuration);
    }, [
        delayDuration,
        setOpen
    ]);
    $jbmdS.useEffect(()=>{
        return ()=>window.clearTimeout(openTimerRef.current);
    }, []);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($aU3NZ.Root, {
        ...popperScope,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)($728dc4158edd5428$var$TooltipContextProvider, {
            scope: __scopeTooltip,
            contentId: contentId,
            open: open,
            stateAttribute: stateAttribute,
            trigger: trigger,
            onTriggerChange: setTrigger,
            onTriggerEnter: $jbmdS.useCallback(()=>{
                if (providerContext.isOpenDelayed) handleDelayedOpen();
                else handleOpen();
            }, [
                providerContext.isOpenDelayed,
                handleDelayedOpen,
                handleOpen
            ]),
            onTriggerLeave: $jbmdS.useCallback(()=>{
                if (disableHoverableContent) handleClose();
                else window.clearTimeout(openTimerRef.current);
            }, [
                handleClose,
                disableHoverableContent
            ]),
            onOpen: handleOpen,
            onClose: handleClose,
            disableHoverableContent: disableHoverableContent,
            children: children
        })
    });
};
$728dc4158edd5428$export$28c660c63b792dea.displayName = $728dc4158edd5428$var$TOOLTIP_NAME;
var $728dc4158edd5428$var$TRIGGER_NAME = "TooltipTrigger";
var $728dc4158edd5428$export$8c610744efcf8a1d = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip, ...triggerProps } = props;
    const context = $728dc4158edd5428$var$useTooltipContext($728dc4158edd5428$var$TRIGGER_NAME, __scopeTooltip);
    const providerContext = $728dc4158edd5428$var$useTooltipProviderContext($728dc4158edd5428$var$TRIGGER_NAME, __scopeTooltip);
    const popperScope = $728dc4158edd5428$var$usePopperScope(__scopeTooltip);
    const ref = $jbmdS.useRef(null);
    const composedRefs = (0, $9sunj.useComposedRefs)(forwardedRef, ref, context.onTriggerChange);
    const isPointerDownRef = $jbmdS.useRef(false);
    const hasPointerMoveOpenedRef = $jbmdS.useRef(false);
    const handlePointerUp = $jbmdS.useCallback(()=>isPointerDownRef.current = false, []);
    $jbmdS.useEffect(()=>{
        return ()=>document.removeEventListener("pointerup", handlePointerUp);
    }, [
        handlePointerUp
    ]);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($aU3NZ.Anchor, {
        asChild: true,
        ...popperScope,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).button, {
            "aria-describedby": context.open ? context.contentId : void 0,
            "data-state": context.stateAttribute,
            ...triggerProps,
            ref: composedRefs,
            onPointerMove: (0, $hFcKE.composeEventHandlers)(props.onPointerMove, (event)=>{
                if (event.pointerType === "touch") return;
                if (!hasPointerMoveOpenedRef.current && !providerContext.isPointerInTransitRef.current) {
                    context.onTriggerEnter();
                    hasPointerMoveOpenedRef.current = true;
                }
            }),
            onPointerLeave: (0, $hFcKE.composeEventHandlers)(props.onPointerLeave, ()=>{
                context.onTriggerLeave();
                hasPointerMoveOpenedRef.current = false;
            }),
            onPointerDown: (0, $hFcKE.composeEventHandlers)(props.onPointerDown, ()=>{
                isPointerDownRef.current = true;
                document.addEventListener("pointerup", handlePointerUp, {
                    once: true
                });
            }),
            onFocus: (0, $hFcKE.composeEventHandlers)(props.onFocus, ()=>{
                if (!isPointerDownRef.current) context.onOpen();
            }),
            onBlur: (0, $hFcKE.composeEventHandlers)(props.onBlur, context.onClose),
            onClick: (0, $hFcKE.composeEventHandlers)(props.onClick, context.onClose)
        })
    });
});
$728dc4158edd5428$export$8c610744efcf8a1d.displayName = $728dc4158edd5428$var$TRIGGER_NAME;
var $728dc4158edd5428$var$PORTAL_NAME = "TooltipPortal";
var [$728dc4158edd5428$var$PortalProvider, $728dc4158edd5428$var$usePortalContext] = $728dc4158edd5428$var$createTooltipContext($728dc4158edd5428$var$PORTAL_NAME, {
    forceMount: void 0
});
var $728dc4158edd5428$export$7b36b8f925ab7497 = (props)=>{
    const { __scopeTooltip: __scopeTooltip, forceMount: forceMount, children: children, container: container } = props;
    const context = $728dc4158edd5428$var$useTooltipContext($728dc4158edd5428$var$PORTAL_NAME, __scopeTooltip);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($728dc4158edd5428$var$PortalProvider, {
        scope: __scopeTooltip,
        forceMount: forceMount,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $joHB8.Presence), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $fKp8B.Portal), {
                asChild: true,
                container: container,
                children: children
            })
        })
    });
};
$728dc4158edd5428$export$7b36b8f925ab7497.displayName = $728dc4158edd5428$var$PORTAL_NAME;
var $728dc4158edd5428$var$CONTENT_NAME = "TooltipContent";
var $728dc4158edd5428$export$e9003e2be37ec060 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const portalContext = $728dc4158edd5428$var$usePortalContext($728dc4158edd5428$var$CONTENT_NAME, props.__scopeTooltip);
    const { forceMount: forceMount = portalContext.forceMount, side: side = "top", ...contentProps } = props;
    const context = $728dc4158edd5428$var$useTooltipContext($728dc4158edd5428$var$CONTENT_NAME, props.__scopeTooltip);
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $joHB8.Presence), {
        present: forceMount || context.open,
        children: context.disableHoverableContent ? /* @__PURE__ */ (0, $4TLFw.jsx)($728dc4158edd5428$var$TooltipContentImpl, {
            side: side,
            ...contentProps,
            ref: forwardedRef
        }) : /* @__PURE__ */ (0, $4TLFw.jsx)($728dc4158edd5428$var$TooltipContentHoverable, {
            side: side,
            ...contentProps,
            ref: forwardedRef
        })
    });
});
var $728dc4158edd5428$var$TooltipContentHoverable = $jbmdS.forwardRef((props, forwardedRef)=>{
    const context = $728dc4158edd5428$var$useTooltipContext($728dc4158edd5428$var$CONTENT_NAME, props.__scopeTooltip);
    const providerContext = $728dc4158edd5428$var$useTooltipProviderContext($728dc4158edd5428$var$CONTENT_NAME, props.__scopeTooltip);
    const ref = $jbmdS.useRef(null);
    const composedRefs = (0, $9sunj.useComposedRefs)(forwardedRef, ref);
    const [pointerGraceArea, setPointerGraceArea] = $jbmdS.useState(null);
    const { trigger: trigger, onClose: onClose } = context;
    const content = ref.current;
    const { onPointerInTransitChange: onPointerInTransitChange } = providerContext;
    const handleRemoveGraceArea = $jbmdS.useCallback(()=>{
        setPointerGraceArea(null);
        onPointerInTransitChange(false);
    }, [
        onPointerInTransitChange
    ]);
    const handleCreateGraceArea = $jbmdS.useCallback((event, hoverTarget)=>{
        const currentTarget = event.currentTarget;
        const exitPoint = {
            x: event.clientX,
            y: event.clientY
        };
        const exitSide = $728dc4158edd5428$var$getExitSideFromRect(exitPoint, currentTarget.getBoundingClientRect());
        const paddedExitPoints = $728dc4158edd5428$var$getPaddedExitPoints(exitPoint, exitSide);
        const hoverTargetPoints = $728dc4158edd5428$var$getPointsFromRect(hoverTarget.getBoundingClientRect());
        const graceArea = $728dc4158edd5428$var$getHull([
            ...paddedExitPoints,
            ...hoverTargetPoints
        ]);
        setPointerGraceArea(graceArea);
        onPointerInTransitChange(true);
    }, [
        onPointerInTransitChange
    ]);
    $jbmdS.useEffect(()=>{
        return ()=>handleRemoveGraceArea();
    }, [
        handleRemoveGraceArea
    ]);
    $jbmdS.useEffect(()=>{
        if (trigger && content) {
            const handleTriggerLeave = (event)=>handleCreateGraceArea(event, content);
            const handleContentLeave = (event)=>handleCreateGraceArea(event, trigger);
            trigger.addEventListener("pointerleave", handleTriggerLeave);
            content.addEventListener("pointerleave", handleContentLeave);
            return ()=>{
                trigger.removeEventListener("pointerleave", handleTriggerLeave);
                content.removeEventListener("pointerleave", handleContentLeave);
            };
        }
    }, [
        trigger,
        content,
        handleCreateGraceArea,
        handleRemoveGraceArea
    ]);
    $jbmdS.useEffect(()=>{
        if (pointerGraceArea) {
            const handleTrackPointerGrace = (event)=>{
                const target = event.target;
                const pointerPosition = {
                    x: event.clientX,
                    y: event.clientY
                };
                const hasEnteredTarget = trigger?.contains(target) || content?.contains(target);
                const isPointerOutsideGraceArea = !$728dc4158edd5428$var$isPointInPolygon(pointerPosition, pointerGraceArea);
                if (hasEnteredTarget) handleRemoveGraceArea();
                else if (isPointerOutsideGraceArea) {
                    handleRemoveGraceArea();
                    onClose();
                }
            };
            document.addEventListener("pointermove", handleTrackPointerGrace);
            return ()=>document.removeEventListener("pointermove", handleTrackPointerGrace);
        }
    }, [
        trigger,
        content,
        pointerGraceArea,
        onClose,
        handleRemoveGraceArea
    ]);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($728dc4158edd5428$var$TooltipContentImpl, {
        ...props,
        ref: composedRefs
    });
});
var [$728dc4158edd5428$var$VisuallyHiddenContentContextProvider, $728dc4158edd5428$var$useVisuallyHiddenContentContext] = $728dc4158edd5428$var$createTooltipContext($728dc4158edd5428$var$TOOLTIP_NAME, {
    isInside: false
});
var $728dc4158edd5428$var$TooltipContentImpl = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip, children: children, "aria-label": ariaLabel, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, ...contentProps } = props;
    const context = $728dc4158edd5428$var$useTooltipContext($728dc4158edd5428$var$CONTENT_NAME, __scopeTooltip);
    const popperScope = $728dc4158edd5428$var$usePopperScope(__scopeTooltip);
    const { onClose: onClose } = context;
    $jbmdS.useEffect(()=>{
        document.addEventListener($728dc4158edd5428$var$TOOLTIP_OPEN, onClose);
        return ()=>document.removeEventListener($728dc4158edd5428$var$TOOLTIP_OPEN, onClose);
    }, [
        onClose
    ]);
    $jbmdS.useEffect(()=>{
        if (context.trigger) {
            const handleScroll = (event)=>{
                const target = event.target;
                if (target?.contains(context.trigger)) onClose();
            };
            window.addEventListener("scroll", handleScroll, {
                capture: true
            });
            return ()=>window.removeEventListener("scroll", handleScroll, {
                    capture: true
                });
        }
    }, [
        context.trigger,
        onClose
    ]);
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $jJBMp.DismissableLayer), {
        asChild: true,
        disableOutsidePointerEvents: false,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside,
        onFocusOutside: (event)=>event.preventDefault(),
        onDismiss: onClose,
        children: /* @__PURE__ */ (0, $4TLFw.jsxs)($aU3NZ.Content, {
            "data-state": context.stateAttribute,
            ...popperScope,
            ...contentProps,
            ref: forwardedRef,
            style: {
                ...contentProps.style,
                "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
                "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
                "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
                "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
                "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
                /* @__PURE__ */ (0, $4TLFw.jsx)((0, $bXq35.Slottable), {
                    children: children
                }),
                /* @__PURE__ */ (0, $4TLFw.jsx)($728dc4158edd5428$var$VisuallyHiddenContentContextProvider, {
                    scope: __scopeTooltip,
                    isInside: true,
                    children: /* @__PURE__ */ (0, $4TLFw.jsx)($fLY1n.Root, {
                        id: context.contentId,
                        role: "tooltip",
                        children: ariaLabel || children
                    })
                })
            ]
        })
    });
});
$728dc4158edd5428$export$e9003e2be37ec060.displayName = $728dc4158edd5428$var$CONTENT_NAME;
var $728dc4158edd5428$var$ARROW_NAME = "TooltipArrow";
var $728dc4158edd5428$export$c27ee0ad710f7559 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip, ...arrowProps } = props;
    const popperScope = $728dc4158edd5428$var$usePopperScope(__scopeTooltip);
    const visuallyHiddenContentContext = $728dc4158edd5428$var$useVisuallyHiddenContentContext($728dc4158edd5428$var$ARROW_NAME, __scopeTooltip);
    return visuallyHiddenContentContext.isInside ? null : /* @__PURE__ */ (0, $4TLFw.jsx)($aU3NZ.Arrow, {
        ...popperScope,
        ...arrowProps,
        ref: forwardedRef
    });
});
$728dc4158edd5428$export$c27ee0ad710f7559.displayName = $728dc4158edd5428$var$ARROW_NAME;
function $728dc4158edd5428$var$getExitSideFromRect(point, rect) {
    const top = Math.abs(rect.top - point.y);
    const bottom = Math.abs(rect.bottom - point.y);
    const right = Math.abs(rect.right - point.x);
    const left = Math.abs(rect.left - point.x);
    switch(Math.min(top, bottom, right, left)){
        case left:
            return "left";
        case right:
            return "right";
        case top:
            return "top";
        case bottom:
            return "bottom";
        default:
            throw new Error("unreachable");
    }
}
function $728dc4158edd5428$var$getPaddedExitPoints(exitPoint, exitSide, padding = 5) {
    const paddedExitPoints = [];
    switch(exitSide){
        case "top":
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y + padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y + padding
            });
            break;
        case "bottom":
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y - padding
            });
            break;
        case "left":
            paddedExitPoints.push({
                x: exitPoint.x + padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y + padding
            });
            break;
        case "right":
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x - padding,
                y: exitPoint.y + padding
            });
            break;
    }
    return paddedExitPoints;
}
function $728dc4158edd5428$var$getPointsFromRect(rect) {
    const { top: top, right: right, bottom: bottom, left: left } = rect;
    return [
        {
            x: left,
            y: top
        },
        {
            x: right,
            y: top
        },
        {
            x: right,
            y: bottom
        },
        {
            x: left,
            y: bottom
        }
    ];
}
function $728dc4158edd5428$var$isPointInPolygon(point, polygon) {
    const { x: x, y: y } = point;
    let inside = false;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const xi = polygon[i].x;
        const yi = polygon[i].y;
        const xj = polygon[j].x;
        const yj = polygon[j].y;
        const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
}
function $728dc4158edd5428$var$getHull(points) {
    const newPoints = points.slice();
    newPoints.sort((a, b)=>{
        if (a.x < b.x) return -1;
        else if (a.x > b.x) return 1;
        else if (a.y < b.y) return -1;
        else if (a.y > b.y) return 1;
        else return 0;
    });
    return $728dc4158edd5428$var$getHullPresorted(newPoints);
}
function $728dc4158edd5428$var$getHullPresorted(points) {
    if (points.length <= 1) return points.slice();
    const upperHull = [];
    for(let i = 0; i < points.length; i++){
        const p = points[i];
        while(upperHull.length >= 2){
            const q = upperHull[upperHull.length - 1];
            const r = upperHull[upperHull.length - 2];
            if ((q.x - r.x) * (p.y - r.y) >= (q.y - r.y) * (p.x - r.x)) upperHull.pop();
            else break;
        }
        upperHull.push(p);
    }
    upperHull.pop();
    const lowerHull = [];
    for(let i = points.length - 1; i >= 0; i--){
        const p = points[i];
        while(lowerHull.length >= 2){
            const q = lowerHull[lowerHull.length - 1];
            const r = lowerHull[lowerHull.length - 2];
            if ((q.x - r.x) * (p.y - r.y) >= (q.y - r.y) * (p.x - r.x)) lowerHull.pop();
            else break;
        }
        lowerHull.push(p);
    }
    lowerHull.pop();
    if (upperHull.length === 1 && lowerHull.length === 1 && upperHull[0].x === lowerHull[0].x && upperHull[0].y === lowerHull[0].y) return upperHull;
    else return upperHull.concat(lowerHull);
}
var $728dc4158edd5428$export$2881499e37b75b9a = $728dc4158edd5428$export$f78649fb9ca566b8;
var $728dc4158edd5428$export$be92b6f5f03c0fe9 = $728dc4158edd5428$export$28c660c63b792dea;
var $728dc4158edd5428$export$41fb9f06171c75f4 = $728dc4158edd5428$export$8c610744efcf8a1d;
var $728dc4158edd5428$export$602eac185826482c = $728dc4158edd5428$export$7b36b8f925ab7497;
var $728dc4158edd5428$export$7c6e2c02157bb7d2 = $728dc4158edd5428$export$e9003e2be37ec060;
var $728dc4158edd5428$export$21b07c8f274aebd5 = $728dc4158edd5428$export$c27ee0ad710f7559;

});



parcelRegister("gzhWA", function(module, exports) {

$parcel$export(module.exports, "ProjectsSubNav", function () { return $31a65b21c3705621$export$ff1bf754ee4673e3; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $bsFNa = parcelRequire("bsFNa");
var $bSUjN = parcelRequire("bSUjN");
var $iKmrz = parcelRequire("iKmrz");
var $eSo00 = parcelRequire("eSo00");
var $k8G68 = parcelRequire("k8G68");
var $hwsY5 = parcelRequire("hwsY5");
var $ks8uR = parcelRequire("ks8uR");

var $38AIP = parcelRequire("38AIP");

var $eGwj2 = parcelRequire("eGwj2");

var $hKvJ8 = parcelRequire("hKvJ8");

var $a3BWW = parcelRequire("a3BWW");
const $31a65b21c3705621$var$getProjectTitle = (project)=>project.jobNumber ? `${project.jobNumber}: ${project.name}` : project.name;
const $31a65b21c3705621$export$ff1bf754ee4673e3 = ()=>{
    const [expandedList, setExpandedList] = (0, $jbmdS.useState)("reports");
    // Create a single selector for all the data we need
    const projectReports = (0, $38AIP.useProjectReports)();
    const projectsByStatus = (0, $38AIP.useProjectsByStatus)();
    const lists = [
        {
            id: "reports",
            title: "Project Reports",
            icon: (0, $eSo00.default),
            rootRoute: "/projects",
            items: projectReports.map((r)=>({
                    label: r.name,
                    value: r.id,
                    route: `/projects?report=${r.id}`
                })).sort((a, b)=>a.label.localeCompare(b.label))
        },
        {
            id: "active",
            title: "Active Projects",
            icon: (0, $hwsY5.default),
            items: projectsByStatus.active.map((pr)=>({
                    label: $31a65b21c3705621$var$getProjectTitle(pr),
                    value: pr.id,
                    route: `/projects/${pr.id}`
                })).sort((a, b)=>a.label.localeCompare(b.label))
        },
        {
            id: "prospective",
            title: "Prospective Projects",
            icon: (0, $bSUjN.default),
            items: projectsByStatus.prospective.map((pr)=>({
                    label: $31a65b21c3705621$var$getProjectTitle(pr),
                    value: pr.id,
                    route: `/projects/${pr.id}`
                })).sort((a, b)=>a.label.localeCompare(b.label))
        },
        {
            id: "onhold",
            title: "On Hold Projects",
            icon: (0, $k8G68.default),
            items: projectsByStatus.onHold.map((pr)=>({
                    label: $31a65b21c3705621$var$getProjectTitle(pr),
                    value: pr.id,
                    route: `/projects/${pr.id}`
                })).sort((a, b)=>a.label.localeCompare(b.label))
        },
        {
            id: "archived",
            title: "Archived Projects",
            icon: (0, $bsFNa.default),
            items: projectsByStatus.archived.map((pr)=>({
                    label: $31a65b21c3705621$var$getProjectTitle(pr),
                    value: pr.id,
                    route: `/projects/${pr.id}`
                })).sort((a, b)=>a.label.localeCompare(b.label))
        }
    ];
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $eGwj2.SubNavigationSidebar), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $eGwj2.SubNavigationHeading), {
                children: "Projects"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $eGwj2.SubNavigationBody), {
                children: lists.map((list)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $hKvJ8.ExpandableList), {
                        title: list.title,
                        rootRoute: list.rootRoute,
                        items: list.items,
                        icon: list.icon,
                        isExpanded: expandedList === list.id,
                        onToggle: ()=>setExpandedList(expandedList === list.id ? null : list.id)
                    }, list.id))
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $eGwj2.SubNavigationFooter), {
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $a3BWW.SideNavButton), {
                        icon: (0, $iKmrz.default),
                        label: "Project Templates",
                        onClick: ()=>null
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $a3BWW.SideNavButton), {
                        icon: (0, $ks8uR.default),
                        label: "Project Settings",
                        onClick: ()=>null
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("bsFNa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8582ba416425d037$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $8582ba416425d037$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("Archive", [
    [
        "rect",
        {
            width: "20",
            height: "5",
            x: "2",
            y: "3",
            rx: "1",
            key: "1wp1u1"
        }
    ],
    [
        "path",
        {
            d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8",
            key: "1s80jp"
        }
    ],
    [
        "path",
        {
            d: "M10 12h4",
            key: "a56b0p"
        }
    ]
]);

});

parcelRegister("bSUjN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a706c803f946a39$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $8a706c803f946a39$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("Handshake", [
    [
        "path",
        {
            d: "m11 17 2 2a1 1 0 1 0 3-3",
            key: "efffak"
        }
    ],
    [
        "path",
        {
            d: "m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4",
            key: "9pr0kb"
        }
    ],
    [
        "path",
        {
            d: "m21 3 1 11h-2",
            key: "1tisrp"
        }
    ],
    [
        "path",
        {
            d: "M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3",
            key: "1uvwmv"
        }
    ],
    [
        "path",
        {
            d: "M3 4h8",
            key: "1ep09j"
        }
    ]
]);

});

parcelRegister("iKmrz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da5deeb6783d445d$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $da5deeb6783d445d$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("LayoutDashboard", [
    [
        "rect",
        {
            width: "7",
            height: "9",
            x: "3",
            y: "3",
            rx: "1",
            key: "10lvy0"
        }
    ],
    [
        "rect",
        {
            width: "7",
            height: "5",
            x: "14",
            y: "3",
            rx: "1",
            key: "16une8"
        }
    ],
    [
        "rect",
        {
            width: "7",
            height: "9",
            x: "14",
            y: "12",
            rx: "1",
            key: "1hutg5"
        }
    ],
    [
        "rect",
        {
            width: "7",
            height: "5",
            x: "3",
            y: "16",
            rx: "1",
            key: "ldoo1y"
        }
    ]
]);

});

parcelRegister("eSo00", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad48b99250945136$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $ad48b99250945136$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("LineChart", [
    [
        "path",
        {
            d: "M3 3v18h18",
            key: "1s2lah"
        }
    ],
    [
        "path",
        {
            d: "m19 9-5 5-4-4-3 3",
            key: "2osh9i"
        }
    ]
]);

});

parcelRegister("k8G68", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea9535ccef18040a$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $ea9535ccef18040a$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("OctagonPause", [
    [
        "path",
        {
            d: "M10 15V9",
            key: "1lckn7"
        }
    ],
    [
        "path",
        {
            d: "M14 15V9",
            key: "1muqhk"
        }
    ],
    [
        "path",
        {
            d: "M2.586 16.872A2 2 0 0 1 2 15.458V8.542a2 2 0 0 1 .586-1.414l4.542-4.542A2 2 0 0 1 8.542 2h6.916a2 2 0 0 1 1.414.586l4.542 4.542A2 2 0 0 1 22 8.542v6.916a2 2 0 0 1-.586 1.414l-4.542 4.542a2 2 0 0 1-1.414.586H8.542a2 2 0 0 1-1.414-.586z",
            key: "1e17ew"
        }
    ]
]);

});

parcelRegister("38AIP", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_CACHE_KEY", function () { return $c5bf0282aef53c75$export$4a547832443fb32b; });
$parcel$export(module.exports, "setCache", function () { return $c5bf0282aef53c75$export$e211dab362b85880; });
$parcel$export(module.exports, "addCacheItem", function () { return $c5bf0282aef53c75$export$3652c9ca4580443; });
$parcel$export(module.exports, "updateCacheItem", function () { return $c5bf0282aef53c75$export$9d714cefde68e1f3; });
$parcel$export(module.exports, "deleteCacheItem", function () { return $c5bf0282aef53c75$export$2149f8ed4f52e562; });
$parcel$export(module.exports, "useCache", function () { return $c5bf0282aef53c75$export$c6e89b6bb9436bc0; });
$parcel$export(module.exports, "getCache", function () { return $c5bf0282aef53c75$export$e2575ed62a2f107b; });
$parcel$export(module.exports, "getCacheItemById", function () { return $c5bf0282aef53c75$export$2704136e386e299b; });
$parcel$export(module.exports, "useCacheSlice", function () { return $c5bf0282aef53c75$export$d82f03d27babb51e; });
$parcel$export(module.exports, "useFilteredCacheItems", function () { return $c5bf0282aef53c75$export$c77d59bde317dcd9; });
$parcel$export(module.exports, "getFilteredCacheItems", function () { return $c5bf0282aef53c75$export$5affd83cb60ffaad; });
$parcel$export(module.exports, "useProjectReports", function () { return $c5bf0282aef53c75$export$908d09eaf7a19a42; });
$parcel$export(module.exports, "useProjectsByStatus", function () { return $c5bf0282aef53c75$export$bd4ec1e5b092147b; });

var $hxM7m = parcelRequire("hxM7m");

var $lJ1OS = parcelRequire("lJ1OS");

var $6Q5sp = parcelRequire("6Q5sp");

var $jbmdS = parcelRequire("jbmdS");
const $c5bf0282aef53c75$export$4a547832443fb32b = [
    "globalCache"
];
const $c5bf0282aef53c75$export$79903bb189f607c7 = (0, $hxM7m.createStore)({
    context: {
        cache: {}
    },
    on: {
        setCache: {
            cache: (_, event)=>{
                (0, $6Q5sp.queryClient).setQueryData($c5bf0282aef53c75$export$4a547832443fb32b, event.cache);
                return event.cache;
            }
        },
        updateCache: {
            cache: (context, event)=>{
                const newCache = {
                    ...context.cache,
                    [event.key]: event.data
                };
                (0, $6Q5sp.queryClient).setQueryData($c5bf0282aef53c75$export$4a547832443fb32b, newCache);
                return newCache;
            }
        },
        addItem: {
            cache: (context, event)=>{
                const newCache = {
                    ...context.cache,
                    [event.key]: [
                        ...context.cache[event.key],
                        event.data
                    ]
                };
                (0, $6Q5sp.queryClient).setQueryData($c5bf0282aef53c75$export$4a547832443fb32b, newCache);
                return newCache;
            }
        },
        updateItem: {
            cache: (context, event)=>{
                var _context$cache$event$;
                const newCache = {
                    ...context.cache,
                    [event.key]: (_context$cache$event$ = context.cache[event.key]) === null || _context$cache$event$ === void 0 ? void 0 : _context$cache$event$.map((item)=>item.id === event.id ? {
                            ...item,
                            ...event.data
                        } : item)
                };
                (0, $6Q5sp.queryClient).setQueryData($c5bf0282aef53c75$export$4a547832443fb32b, newCache);
                return newCache;
            }
        },
        deleteItem: {
            cache: (context, event)=>{
                var _context$cache$event$2;
                const newCache = {
                    ...context.cache,
                    [event.key]: (_context$cache$event$2 = context.cache[event.key]) === null || _context$cache$event$2 === void 0 ? void 0 : _context$cache$event$2.filter((item)=>item.id !== event.id)
                };
                (0, $6Q5sp.queryClient).setQueryData($c5bf0282aef53c75$export$4a547832443fb32b, newCache);
                return newCache;
            }
        },
        clear: {
            cache: ()=>{
                (0, $6Q5sp.queryClient).setQueryData($c5bf0282aef53c75$export$4a547832443fb32b, {});
                return {};
            }
        }
    }
});
const $c5bf0282aef53c75$export$e211dab362b85880 = (cache)=>$c5bf0282aef53c75$export$79903bb189f607c7.send({
        type: "setCache",
        cache: cache
    });
const $c5bf0282aef53c75$export$8f130c338353ac35 = (key, data)=>$c5bf0282aef53c75$export$79903bb189f607c7.send({
        type: "updateCache",
        key: key,
        data: data
    });
const $c5bf0282aef53c75$export$3652c9ca4580443 = (key, data)=>$c5bf0282aef53c75$export$79903bb189f607c7.send({
        type: "addItem",
        key: key,
        data: data
    });
const $c5bf0282aef53c75$export$9d714cefde68e1f3 = (key, id, data)=>$c5bf0282aef53c75$export$79903bb189f607c7.send({
        type: "updateItem",
        key: key,
        id: id,
        data: data
    });
const $c5bf0282aef53c75$export$2149f8ed4f52e562 = (key, id)=>$c5bf0282aef53c75$export$79903bb189f607c7.send({
        type: "deleteItem",
        key: key,
        id: id
    });
const $c5bf0282aef53c75$export$d2adf65b87e47523 = ()=>$c5bf0282aef53c75$export$79903bb189f607c7.send({
        type: "clear"
    });
const $c5bf0282aef53c75$export$c6e89b6bb9436bc0 = ()=>(0, $lJ1OS.useSelector)($c5bf0282aef53c75$export$79903bb189f607c7, (state)=>state.context.cache);
const $c5bf0282aef53c75$export$e2575ed62a2f107b = ()=>$c5bf0282aef53c75$export$79903bb189f607c7.getSnapshot().context.cache;
const $c5bf0282aef53c75$export$2704136e386e299b = (key, id)=>{
    const items = $c5bf0282aef53c75$export$79903bb189f607c7.getSnapshot().context.cache[key];
    return items === null || items === void 0 ? void 0 : items.find((item)=>item.id === id);
};
const $c5bf0282aef53c75$export$815b9d01088339d6 = (key, id)=>{
    const items = (0, $lJ1OS.useSelector)($c5bf0282aef53c75$export$79903bb189f607c7, (state)=>state.context.cache[key]);
    return (0, $jbmdS.useMemo)(()=>items === null || items === void 0 ? void 0 : items.find((item)=>item.id === id), [
        items,
        id
    ]);
};
const $c5bf0282aef53c75$export$d82f03d27babb51e = (key)=>(0, $lJ1OS.useSelector)($c5bf0282aef53c75$export$79903bb189f607c7, (state)=>state.context.cache[key]);
const $c5bf0282aef53c75$export$3023803c4c307088 = (key)=>$c5bf0282aef53c75$export$79903bb189f607c7.getSnapshot().context.cache[key];
const $c5bf0282aef53c75$export$c77d59bde317dcd9 = (key, filter, sort)=>{
    const items = (0, $lJ1OS.useSelector)($c5bf0282aef53c75$export$79903bb189f607c7, (state)=>state.context.cache[key]);
    return (0, $jbmdS.useMemo)(()=>{
        let result = [
            ...items || []
        ];
        if (filter) result = result.filter(filter);
        if (sort) result.sort(sort);
        return result;
    }, [
        items,
        filter,
        sort
    ]);
};
const $c5bf0282aef53c75$export$5affd83cb60ffaad = (key, filter, sort)=>{
    let items = $c5bf0282aef53c75$export$79903bb189f607c7.getSnapshot().context.cache[key];
    if (filter) items = items.filter(filter);
    if (sort) items.sort(sort);
    return items;
};
const $c5bf0282aef53c75$export$908d09eaf7a19a42 = ()=>{
    return $c5bf0282aef53c75$export$c77d59bde317dcd9("organisationReports", (report)=>report.type === "project");
};
const $c5bf0282aef53c75$export$bd4ec1e5b092147b = ()=>{
    const activeProjects = $c5bf0282aef53c75$export$5affd83cb60ffaad("projects", (project)=>project.status === "active");
    const prospectiveProjects = $c5bf0282aef53c75$export$5affd83cb60ffaad("projects", (project)=>project.status === "prospective");
    const onHoldProjects = $c5bf0282aef53c75$export$5affd83cb60ffaad("projects", (project)=>project.status === "onHold");
    const archivedProjects = $c5bf0282aef53c75$export$5affd83cb60ffaad("projects", (project)=>project.status === "archived");
    return (0, $jbmdS.useMemo)(()=>({
            active: activeProjects,
            prospective: prospectiveProjects,
            onHold: onHoldProjects,
            archived: archivedProjects
        }), [
        activeProjects,
        prospectiveProjects,
        onHoldProjects,
        archivedProjects
    ]);
};

});
parcelRegister("hxM7m", function(module, exports) {

$parcel$export(module.exports, "createStore", function () { return $cc5ad7ec823f4619$export$f51a9068ac82ea43; });
// From https://github.com/reduxjs/react-redux/blob/720f0ba79236cdc3e1115f4ef9a7760a21784b48/src/utils/shallowEqual.ts
function $cc5ad7ec823f4619$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $cc5ad7ec823f4619$export$d36bdfa510afb180(objA, objB) {
    if ($cc5ad7ec823f4619$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$cc5ad7ec823f4619$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
const $cc5ad7ec823f4619$var$symbolObservable = (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
function $cc5ad7ec823f4619$var$toObserver(nextHandler, errorHandler, completionHandler) {
    const isObserver = typeof nextHandler === "object";
    const self = isObserver ? nextHandler : undefined;
    return {
        next: (isObserver ? nextHandler.next : nextHandler)?.bind(self),
        error: (isObserver ? nextHandler.error : errorHandler)?.bind(self),
        complete: (isObserver ? nextHandler.complete : completionHandler)?.bind(self)
    };
}
function $cc5ad7ec823f4619$var$setter(context, recipe) {
    return recipe(context);
}
const $cc5ad7ec823f4619$var$inspectionObservers = new WeakMap();
function $cc5ad7ec823f4619$var$createStoreCore(initialContext, transitions, updater) {
    let observers;
    let listeners;
    const initialSnapshot = {
        context: initialContext,
        status: "active",
        output: undefined,
        error: undefined
    };
    let currentSnapshot = initialSnapshot;
    const emit = (ev)=>{
        if (!listeners) return;
        const type = ev.type;
        const typeListeners = listeners.get(type);
        if (typeListeners) typeListeners.forEach((listener)=>listener(ev));
    };
    const transition = $cc5ad7ec823f4619$var$createStoreTransition(transitions, updater);
    function receive(event) {
        let emitted;
        [currentSnapshot, emitted] = transition(currentSnapshot, event);
        $cc5ad7ec823f4619$var$inspectionObservers.get(store)?.forEach((observer)=>{
            observer.next?.({
                type: "@xstate.snapshot",
                event: event,
                snapshot: currentSnapshot,
                actorRef: store,
                rootId: store.sessionId
            });
        });
        observers?.forEach((o)=>o.next?.(currentSnapshot));
        emitted.forEach(emit);
    }
    const store = {
        on (emittedEventType, handler) {
            if (!listeners) listeners = new Map();
            let eventListeners = listeners.get(emittedEventType);
            if (!eventListeners) {
                eventListeners = new Set();
                listeners.set(emittedEventType, eventListeners);
            }
            const wrappedHandler = handler.bind(undefined);
            eventListeners.add(wrappedHandler);
            return {
                unsubscribe () {
                    eventListeners.delete(wrappedHandler);
                }
            };
        },
        sessionId: $cc5ad7ec823f4619$var$uniqueId(),
        send (event) {
            $cc5ad7ec823f4619$var$inspectionObservers.get(store)?.forEach((observer)=>{
                observer.next?.({
                    type: "@xstate.event",
                    event: event,
                    sourceRef: undefined,
                    actorRef: store,
                    rootId: store.sessionId
                });
            });
            receive(event);
        },
        getSnapshot () {
            return currentSnapshot;
        },
        getInitialSnapshot () {
            return initialSnapshot;
        },
        subscribe (observerOrFn) {
            const observer = $cc5ad7ec823f4619$var$toObserver(observerOrFn);
            observers ??= new Set();
            observers.add(observer);
            return {
                unsubscribe () {
                    return observers?.delete(observer);
                }
            };
        },
        [$cc5ad7ec823f4619$var$symbolObservable] () {
            return this;
        },
        inspect: (observerOrFn)=>{
            const observer = $cc5ad7ec823f4619$var$toObserver(observerOrFn);
            $cc5ad7ec823f4619$var$inspectionObservers.set(store, $cc5ad7ec823f4619$var$inspectionObservers.get(store) ?? new Set());
            $cc5ad7ec823f4619$var$inspectionObservers.get(store).add(observer);
            observer.next?.({
                type: "@xstate.actor",
                actorRef: store,
                rootId: store.sessionId
            });
            observer.next?.({
                type: "@xstate.snapshot",
                snapshot: initialSnapshot,
                event: {
                    type: "@xstate.init"
                },
                actorRef: store,
                rootId: store.sessionId
            });
            return {
                unsubscribe () {
                    return $cc5ad7ec823f4619$var$inspectionObservers.get(store)?.delete(observer);
                }
            };
        }
    };
    return store;
}
/**
 * Creates a **store** that has its own internal state and can be sent events
 * that update its internal state based on transitions.
 *
 * @example
 *
 * ```ts
 * const store = createStore({
 *   types: {
 *     // ...
 *   },
 *   context: { count: 0 },
 *   on: {
 *     inc: (context, event: { by: number }) => {
 *       return {
 *         count: context.count + event.by
 *       };
 *     }
 *   }
 * });
 *
 * store.subscribe((snapshot) => {
 *   console.log(snapshot);
 * });
 *
 * store.send({ type: 'inc', by: 5 });
 * // Logs { context: { count: 5 }, status: 'active', ... }
 * ```
 */ /**
 * Creates a **store** that has its own internal state and can be sent events
 * that update its internal state based on transitions.
 *
 * @example
 *
 * ```ts
 * const store = createStore(
 *   // Initial context
 *   { count: 0 },
 *   // Transitions
 *   {
 *     inc: (context, event: { by: number }) => {
 *       return {
 *         count: context.count + event.by
 *       };
 *     }
 *   }
 * );
 *
 * store.subscribe((snapshot) => {
 *   console.log(snapshot);
 * });
 *
 * store.send({ type: 'inc', by: 5 });
 * // Logs { context: { count: 5 }, status: 'active', ... }
 * ```
 */ function $cc5ad7ec823f4619$export$f51a9068ac82ea43(initialContextOrObject, transitions) {
    if (transitions === undefined) return $cc5ad7ec823f4619$var$createStoreCore(initialContextOrObject.context, initialContextOrObject.on);
    return $cc5ad7ec823f4619$var$createStoreCore(initialContextOrObject, transitions);
}
/**
 * Creates a `Store` with a provided producer (such as Immer's `producer(…)` A
 * store has its own internal state and can receive events.
 *
 * @example
 *
 * ```ts
 * import { produce } from 'immer';
 *
 * const store = createStoreWithProducer(produce, {
 *   // Initial context
 *   { count: 0 },
 *   // Transitions
 *   {
 *     on: {
 *       inc: (context, event: { by: number }) => {
 *         context.count += event.by;
 *       }
 *     }
 *   }
 * });
 *
 * store.subscribe((snapshot) => {
 *   console.log(snapshot);
 * });
 *
 * store.send({ type: 'inc', by: 5 });
 * // Logs { context: { count: 5 }, status: 'active', ... }
 * ```
 */ function $cc5ad7ec823f4619$export$dc82e8d824ad2ca(producer, initialContextOrConfig, transitions) {
    if (typeof initialContextOrConfig === "object" && "context" in initialContextOrConfig && "on" in initialContextOrConfig) return $cc5ad7ec823f4619$var$createStoreCore(initialContextOrConfig.context, initialContextOrConfig.on, producer);
    return $cc5ad7ec823f4619$var$createStoreCore(initialContextOrConfig, transitions, producer);
}
/**
 * Creates a store function, which is a function that accepts the current
 * snapshot and an event and returns a new snapshot.
 *
 * @param transitions
 * @param updater
 * @returns
 */ function $cc5ad7ec823f4619$var$createStoreTransition(transitions, updater) {
    return (snapshot, event)=>{
        let currentContext = snapshot.context;
        const assigner = transitions?.[event.type];
        const emitted = [];
        const enqueue = {
            emit: (ev)=>{
                emitted.push(ev);
            }
        };
        if (!assigner) return [
            snapshot,
            emitted
        ];
        if (typeof assigner === "function") currentContext = updater ? updater(currentContext, (draftContext)=>assigner?.(draftContext, event, enqueue)) : $cc5ad7ec823f4619$var$setter(currentContext, (draftContext)=>Object.assign({}, currentContext, assigner?.(draftContext, event, // TODO: help me
            enqueue)));
        else {
            const partialUpdate = {};
            for (const key of Object.keys(assigner)){
                const propAssignment = assigner[key];
                partialUpdate[key] = typeof propAssignment === "function" ? propAssignment(currentContext, event, enqueue) : propAssignment;
            }
            currentContext = Object.assign({}, currentContext, partialUpdate);
        }
        return [
            {
                ...snapshot,
                context: currentContext
            },
            emitted
        ];
    };
}
// create a unique 6-char id
function $cc5ad7ec823f4619$var$uniqueId() {
    return Math.random().toString(36).slice(6);
}
/**
 * An actor logic creator which creates store [actor
 * logic](https://stately.ai/docs/actors#actor-logic) for use with XState.
 *
 * @param initialContext The initial context for the store, either a function
 *   that returns context based on input, or the context itself
 * @param transitions The transitions object defining how the context updates
 *   due to events
 * @returns An actor logic creator function that creates store actor logic
 */ /**
 * An actor logic creator which creates store [actor
 * logic](https://stately.ai/docs/actors#actor-logic) for use with XState.
 *
 * @param config An object containing the store configuration
 * @param config.context The initial context for the store, either a function
 *   that returns context based on input, or the context itself
 * @param config.on An object defining the transitions for different event types
 * @param config.types Optional object to define custom event types
 * @returns An actor logic creator function that creates store actor logic
 */ function $cc5ad7ec823f4619$export$528351d29d037c9c(initialContextOrObj, transitions) {
    let initialContext;
    let transitionsObj;
    if (typeof initialContextOrObj === "object" && "context" in initialContextOrObj) {
        initialContext = initialContextOrObj.context;
        transitionsObj = initialContextOrObj.on;
    } else {
        initialContext = initialContextOrObj;
        transitionsObj = transitions;
    }
    const transition = $cc5ad7ec823f4619$var$createStoreTransition(transitionsObj);
    return {
        transition: (snapshot, event, actorScope)=>{
            const [nextSnapshot, emittedEvents] = transition(snapshot, event);
            emittedEvents.forEach(actorScope.emit);
            return nextSnapshot;
        },
        getInitialSnapshot: (_, input)=>{
            return {
                status: "active",
                context: typeof initialContext === "function" ? initialContext(input) : initialContext,
                output: undefined,
                error: undefined
            };
        },
        getPersistedSnapshot: (s)=>s,
        restoreSnapshot: (s)=>s
    };
}

});

parcelRegister("lJ1OS", function(module, exports) {

$parcel$export(module.exports, "useSelector", function () { return $fd0f36461139472c$export$2105062e25df4afe; });

var $jbmdS = parcelRequire("jbmdS");
function $fd0f36461139472c$var$defaultCompare(a, b) {
    return a === b;
}
function $fd0f36461139472c$var$useSelectorWithCompare(selector, compare) {
    const previous = (0, $jbmdS.useRef)();
    return (state)=>{
        const next = selector(state);
        return compare(previous.current, next) ? previous.current : previous.current = next;
    };
}
/**
 * A React hook that subscribes to the `store` and selects a value from the
 * store's snapshot, with an optional compare function.
 *
 * @example
 *
 * ```ts
 * function Component() {
 *   const count = useSelector(store, (s) => s.count);
 *
 *   return <div>{count}</div>;
 * }
 * ```
 *
 * @param store The store, created from `createStore(…)`
 * @param selector A function which takes in the `snapshot` and returns a
 *   selected value
 * @param compare An optional function which compares the selected value to the
 *   previous value
 * @returns The selected value
 */ function $fd0f36461139472c$export$2105062e25df4afe(store, selector, compare = $fd0f36461139472c$var$defaultCompare) {
    const selectorWithCompare = $fd0f36461139472c$var$useSelectorWithCompare(selector, compare);
    return (0, $jbmdS.useSyncExternalStore)((0, $jbmdS.useCallback)((handleStoreChange)=>store.subscribe(handleStoreChange).unsubscribe, [
        store
    ]), ()=>selectorWithCompare(store.getSnapshot()), ()=>selectorWithCompare(store.getInitialSnapshot()));
}

});


parcelRegister("eGwj2", function(module, exports) {

$parcel$export(module.exports, "SubNavigationSidebar", function () { return $964022385b1fddf9$export$650f0f40ae278c4d; });
$parcel$export(module.exports, "SubNavigationHeading", function () { return $964022385b1fddf9$export$19e7ef9973407dc; });
$parcel$export(module.exports, "SubNavigationBody", function () { return $964022385b1fddf9$export$dfca5949045864f3; });
$parcel$export(module.exports, "SubNavigationFooter", function () { return $964022385b1fddf9$export$1efce35380c76547; });

var $61Ea1 = parcelRequire("61Ea1");
const $964022385b1fddf9$export$650f0f40ae278c4d = ({ children: children })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)("nav", {
        className: "flex flex-col w-64 h-full border-l border-border bg-background  transition-all duration-300",
        children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            className: "flex flex-col h-full p-4 overflow-y-auto overflow-x-hidden relative",
            children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "flex flex-col h-full",
                children: children
            })
        })
    });
};
const $964022385b1fddf9$export$19e7ef9973407dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "flex justify-between items-center pt-1 pb-4 flex-none",
        children: /*#__PURE__*/ (0, $61Ea1.jsx)("h4", {
            className: "m-0",
            children: children
        })
    });
};
const $964022385b1fddf9$export$dfca5949045864f3 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "flex-auto border-t border-border py-4",
        children: children
    });
};
const $964022385b1fddf9$export$1efce35380c76547 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "flex-none border-t border-border pt-4",
        children: children
    });
};

});

parcelRegister("hKvJ8", function(module, exports) {

$parcel$export(module.exports, "ExpandableList", function () { return $743f0c6129b62c5d$export$de84cf4aad0f4eba; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $fTGwv = parcelRequire("fTGwv");

var $2YJBX = parcelRequire("2YJBX");

var $7p0rt = parcelRequire("7p0rt");

var $lKdR6 = parcelRequire("lKdR6");
var $ahXOC = parcelRequire("ahXOC");
var $hAJIP = parcelRequire("hAJIP");

var $cOJf8 = parcelRequire("cOJf8");

var $kqlQp = parcelRequire("kqlQp");
var $6UBLf = parcelRequire("6UBLf");

var $a3BWW = parcelRequire("a3BWW");

var $5wgpP = parcelRequire("5wgpP");
const $743f0c6129b62c5d$export$de84cf4aad0f4eba = ({ title: title, items: items = [], isExpanded: isExpanded, onToggle: onToggle, icon: Icon, rootRoute: rootRoute })=>{
    const navigate = (0, $6UBLf.useNavigate)();
    const [searchQuery, setSearchQuery] = (0, $jbmdS.useState)("");
    const [parent, enableAnimations] = (0, $cOJf8.useAutoAnimate)();
    const filteredItems = items.filter((item)=>item.label.toLowerCase().includes(searchQuery.toLowerCase()));
    if (items.length === 0 && rootRoute) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $a3BWW.SideNavButton), {
        icon: Icon,
        label: title,
        onClick: (e)=>{
            navigate({
                to: rootRoute
            });
        }
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        ref: parent,
        style: {
            height: isExpanded ? `${Math.min(25, filteredItems.length) * 1.5 + 6}rem` : "auto"
        },
        className: `${isExpanded ? "flex-grow" : "flex-shrink-0"} flex flex-col`,
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fTGwv.Button), {
                variant: "ghost",
                size: "sm",
                className: "w-full justify-between mb-4 flex-none",
                onClick: onToggle,
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                        className: "font-semibold flex",
                        children: [
                            Icon ? /*#__PURE__*/ (0, $61Ea1.jsx)(Icon, {
                                className: "h-4 w-4 mr-2"
                            }) : null,
                            title
                        ]
                    }),
                    isExpanded ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $lKdR6.default), {
                        size: 16
                    }) : /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ahXOC.default), {
                        size: 16
                    })
                ]
            }),
            isExpanded && /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "flex flex-col min-h-0 flex-1 mb-4",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "relative -mt-2 mb-2",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $2YJBX.Input), {
                                type: "text",
                                placeholder: "Search...",
                                value: searchQuery,
                                onChange: (e)=>setSearchQuery(e.target.value),
                                className: "pl-7 py-1 h-8 text-sm"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hAJIP.default), {
                                className: "absolute left-2 top-1/2 -translate-y-1/2 h-3 w-3 text-gray-400"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "flex-1",
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5wgpP.Virtuoso), {
                            style: {
                                height: "100%"
                            },
                            totalCount: filteredItems.length,
                            data: filteredItems,
                            className: "scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent hover:scrollbar-thumb-gray-400",
                            itemContent: (index, item)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $7p0rt.MarqueeButton), {
                                    variant: "ghost",
                                    size: "xs",
                                    className: "w-full justify-start mb-1",
                                    onClick: item.onClick,
                                    children: item.route ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqlQp.Link), {
                                        to: item.route,
                                        className: "w-full justify-start",
                                        children: item.label
                                    }) : item.label
                                }, item.id)
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("7p0rt", function(module, exports) {

$parcel$export(module.exports, "MarqueeButton", function () { return $b34b4b63e45d1ddd$export$893f0d16498e6eae; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $fTGwv = parcelRequire("fTGwv");

var $Yha9m = parcelRequire("Yha9m");
parcelRequire("i0LwX");
var $3m8Ly = parcelRequire("3m8Ly");
var $hKLW7 = parcelRequire("hKLW7");
const $b34b4b63e45d1ddd$export$893f0d16498e6eae = ({ children: children, className: className, speed: speed = 50, ...props })=>{
    const [isOverflowing, setIsOverflowing] = (0, $jbmdS.useState)(false);
    const [contentWidth, setContentWidth] = (0, $jbmdS.useState)(0);
    const [containerWidth, setContainerWidth] = (0, $jbmdS.useState)(0);
    const containerRef = (0, $jbmdS.useRef)(null);
    const contentRef = (0, $jbmdS.useRef)(null);
    const [{ x: x }, api] = (0, $hKLW7.useSpring)(()=>({
            x: 0,
            config: {
                duration: 1000
            }
        }));
    (0, $jbmdS.useEffect)(()=>{
        const checkOverflow = ()=>{
            if (contentRef.current && containerRef.current) {
                const contentWidth = contentRef.current.offsetWidth;
                const containerWidth = containerRef.current.offsetWidth;
                setContentWidth(contentWidth);
                setContainerWidth(containerWidth);
                setIsOverflowing(contentWidth > containerWidth);
            }
        };
        checkOverflow();
        window.addEventListener("resize", checkOverflow);
        return ()=>window.removeEventListener("resize", checkOverflow);
    }, [
        children
    ]);
    const handleMouseEnter = ()=>{
        if (isOverflowing) {
            const duration = contentWidth / speed * 1000; // Convert speed to duration
            api.start({
                from: {
                    x: 0
                },
                to: {
                    x: -contentWidth
                },
                loop: true,
                config: {
                    duration: duration
                },
                reset: true
            });
        }
    };
    const handleMouseLeave = ()=>{
        api.stop();
        api.start({
            x: 0,
            config: {
                duration: 150
            }
        });
    };
    const renderContent = ()=>{
        if (isOverflowing) return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                    children: children
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                    style: {
                        marginLeft: "20px"
                    },
                    children: children
                })
            ]
        });
        return /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
            children: children
        });
    };
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fTGwv.Button), {
        className: (0, $Yha9m.cn)(className, "overflow-hidden px-2 text-xs"),
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        ...props,
        children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            ref: containerRef,
            className: "w-full overflow-hidden text-left",
            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3m8Ly.animated).div, {
                ref: contentRef,
                style: {
                    x: x,
                    whiteSpace: "nowrap",
                    display: "inline-block"
                },
                children: renderContent()
            })
        })
    });
};

});
parcelRegister("i0LwX", function(module, exports) {
$parcel$export(module.exports, "animated", function () { return (parcelRequire("3m8Ly")).animated; });
$parcel$export(module.exports, "useSpring", function () { return (parcelRequire("hKLW7")).useSpring; });
// src/index.ts
parcelRequire("3m8Ly");

});
parcelRegister("3m8Ly", function(module, exports) {
$parcel$export(module.exports, "Globals", function () { return (parcelRequire("bYU0b")).Globals; });
$parcel$export(module.exports, "useSpring", function () { return (parcelRequire("hKLW7")).useSpring; });

$parcel$export(module.exports, "animated", function () { return $271a39e9dd81853e$export$407448d2b89b1813; });
// src/index.ts
parcelRequire("hKLW7");
var $bYU0b = parcelRequire("bYU0b");

var $jCNM0 = parcelRequire("jCNM0");

var $bYU0b = parcelRequire("bYU0b");

var $b7bYo = parcelRequire("b7bYo");
// src/applyAnimatedValues.ts
var $271a39e9dd81853e$var$isCustomPropRE = /^--/;
function $271a39e9dd81853e$var$dangerousStyleValue(name, value) {
    if (value == null || typeof value === "boolean" || value === "") return "";
    if (typeof value === "number" && value !== 0 && !$271a39e9dd81853e$var$isCustomPropRE.test(name) && !($271a39e9dd81853e$var$isUnitlessNumber.hasOwnProperty(name) && $271a39e9dd81853e$var$isUnitlessNumber[name])) return value + "px";
    return ("" + value).trim();
}
var $271a39e9dd81853e$var$attributeCache = {};
function $271a39e9dd81853e$var$applyAnimatedValues(instance, props) {
    if (!instance.nodeType || !instance.setAttribute) return false;
    const isFilterElement = instance.nodeName === "filter" || instance.parentNode && instance.parentNode.nodeName === "filter";
    const { className: className, style: style, children: children, scrollTop: scrollTop, scrollLeft: scrollLeft, viewBox: viewBox, ...attributes } = props;
    const values = Object.values(attributes);
    const names = Object.keys(attributes).map((name)=>isFilterElement || instance.hasAttribute(name) ? name : $271a39e9dd81853e$var$attributeCache[name] || ($271a39e9dd81853e$var$attributeCache[name] = name.replace(/([A-Z])/g, // Attributes are written in dash case
        (n)=>"-" + n.toLowerCase())));
    if (children !== void 0) instance.textContent = children;
    for(const name in style)if (style.hasOwnProperty(name)) {
        const value = $271a39e9dd81853e$var$dangerousStyleValue(name, style[name]);
        if ($271a39e9dd81853e$var$isCustomPropRE.test(name)) instance.style.setProperty(name, value);
        else instance.style[name] = value;
    }
    names.forEach((name, i)=>{
        instance.setAttribute(name, values[i]);
    });
    if (className !== void 0) instance.className = className;
    if (scrollTop !== void 0) instance.scrollTop = scrollTop;
    if (scrollLeft !== void 0) instance.scrollLeft = scrollLeft;
    if (viewBox !== void 0) instance.setAttribute("viewBox", viewBox);
}
var $271a39e9dd81853e$var$isUnitlessNumber = {
    animationIterationCount: true,
    borderImageOutset: true,
    borderImageSlice: true,
    borderImageWidth: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    columns: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridRowEnd: true,
    gridRowSpan: true,
    gridRowStart: true,
    gridColumn: true,
    gridColumnEnd: true,
    gridColumnSpan: true,
    gridColumnStart: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    // SVG-related properties
    fillOpacity: true,
    floodOpacity: true,
    stopOpacity: true,
    strokeDasharray: true,
    strokeDashoffset: true,
    strokeMiterlimit: true,
    strokeOpacity: true,
    strokeWidth: true
};
var $271a39e9dd81853e$var$prefixKey = (prefix, key)=>prefix + key.charAt(0).toUpperCase() + key.substring(1);
var $271a39e9dd81853e$var$prefixes = [
    "Webkit",
    "Ms",
    "Moz",
    "O"
];
$271a39e9dd81853e$var$isUnitlessNumber = Object.keys($271a39e9dd81853e$var$isUnitlessNumber).reduce((acc, prop)=>{
    $271a39e9dd81853e$var$prefixes.forEach((prefix)=>acc[$271a39e9dd81853e$var$prefixKey(prefix, prop)] = acc[prop]);
    return acc;
}, $271a39e9dd81853e$var$isUnitlessNumber);
var $271a39e9dd81853e$var$domTransforms = /^(matrix|translate|scale|rotate|skew)/;
var $271a39e9dd81853e$var$pxTransforms = /^(translate)/;
var $271a39e9dd81853e$var$degTransforms = /^(rotate|skew)/;
var $271a39e9dd81853e$var$addUnit = (value, unit)=>(0, $bYU0b.is).num(value) && value !== 0 ? value + unit : value;
var $271a39e9dd81853e$var$isValueIdentity = (value, id)=>(0, $bYU0b.is).arr(value) ? value.every((v)=>$271a39e9dd81853e$var$isValueIdentity(v, id)) : (0, $bYU0b.is).num(value) ? value === id : parseFloat(value) === id;
var $271a39e9dd81853e$var$AnimatedStyle = class extends (0, $b7bYo.AnimatedObject) {
    constructor({ x: x, y: y, z: z, ...style }){
        const inputs = [];
        const transforms = [];
        if (x || y || z) {
            inputs.push([
                x || 0,
                y || 0,
                z || 0
            ]);
            transforms.push((xyz)=>[
                    `translate3d(${xyz.map((v)=>$271a39e9dd81853e$var$addUnit(v, "px")).join(",")})`,
                    // prettier-ignore
                    $271a39e9dd81853e$var$isValueIdentity(xyz, 0)
                ]);
        }
        (0, $bYU0b.eachProp)(style, (value, key)=>{
            if (key === "transform") {
                inputs.push([
                    value || ""
                ]);
                transforms.push((transform)=>[
                        transform,
                        transform === ""
                    ]);
            } else if ($271a39e9dd81853e$var$domTransforms.test(key)) {
                delete style[key];
                if ((0, $bYU0b.is).und(value)) return;
                const unit = $271a39e9dd81853e$var$pxTransforms.test(key) ? "px" : $271a39e9dd81853e$var$degTransforms.test(key) ? "deg" : "";
                inputs.push((0, $bYU0b.toArray)(value));
                transforms.push(key === "rotate3d" ? ([x2, y2, z2, deg])=>[
                        `rotate3d(${x2},${y2},${z2},${$271a39e9dd81853e$var$addUnit(deg, unit)})`,
                        $271a39e9dd81853e$var$isValueIdentity(deg, 0)
                    ] : (input)=>[
                        `${key}(${input.map((v)=>$271a39e9dd81853e$var$addUnit(v, unit)).join(",")})`,
                        $271a39e9dd81853e$var$isValueIdentity(input, key.startsWith("scale") ? 1 : 0)
                    ]);
            }
        });
        if (inputs.length) style.transform = new $271a39e9dd81853e$var$FluidTransform(inputs, transforms);
        super(style);
    }
};
var $271a39e9dd81853e$var$FluidTransform = class extends (0, $bYU0b.FluidValue) {
    constructor(inputs, transforms){
        super();
        this.inputs = inputs;
        this.transforms = transforms;
        this._value = null;
    }
    get() {
        return this._value || (this._value = this._get());
    }
    _get() {
        let transform = "";
        let identity = true;
        (0, $bYU0b.each)(this.inputs, (input, i)=>{
            const arg1 = (0, $bYU0b.getFluidValue)(input[0]);
            const [t, id] = this.transforms[i]((0, $bYU0b.is).arr(arg1) ? arg1 : input.map((0, $bYU0b.getFluidValue)));
            transform += " " + t;
            identity = identity && id;
        });
        return identity ? "none" : transform;
    }
    // Start observing our inputs once we have an observer.
    observerAdded(count) {
        if (count == 1) (0, $bYU0b.each)(this.inputs, (input)=>(0, $bYU0b.each)(input, (value)=>(0, $bYU0b.hasFluidValue)(value) && (0, $bYU0b.addFluidObserver)(value, this)));
    }
    // Stop observing our inputs once we have no observers.
    observerRemoved(count) {
        if (count == 0) (0, $bYU0b.each)(this.inputs, (input)=>(0, $bYU0b.each)(input, (value)=>(0, $bYU0b.hasFluidValue)(value) && (0, $bYU0b.removeFluidObserver)(value, this)));
    }
    eventObserved(event) {
        if (event.type == "change") this._value = null;
        (0, $bYU0b.callFluidObservers)(this, event);
    }
};
// src/primitives.ts
var $271a39e9dd81853e$var$primitives = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    // SVG
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
(0, $bYU0b.Globals).assign({
    batchedUpdates: (0, $jCNM0.unstable_batchedUpdates),
    createStringInterpolator: $bYU0b.createStringInterpolator,
    colors: $bYU0b.colors
});
var $271a39e9dd81853e$var$host = (0, $b7bYo.createHost)($271a39e9dd81853e$var$primitives, {
    applyAnimatedValues: $271a39e9dd81853e$var$applyAnimatedValues,
    createAnimatedStyle: (style)=>new $271a39e9dd81853e$var$AnimatedStyle(style),
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getComponentProps: ({ scrollTop: scrollTop, scrollLeft: scrollLeft, ...props })=>props
});
var $271a39e9dd81853e$export$407448d2b89b1813 = $271a39e9dd81853e$var$host.animated;

});
parcelRegister("hKLW7", function(module, exports) {

$parcel$export(module.exports, "useSpring", function () { return $cecbeabaf9cdcd78$export$c4af9125706c4d30; });
$parcel$export(module.exports, "Globals", function () { return (parcelRequire("bYU0b")).Globals; });
// src/hooks/useChain.ts

var $bYU0b = parcelRequire("bYU0b");
var $cSAm3 = parcelRequire("cSAm3");

var $jbmdS = parcelRequire("jbmdS");

var $b7bYo = parcelRequire("b7bYo");
parcelRequire("SI2zV");
function $cecbeabaf9cdcd78$var$callProp(value, ...args) {
    return (0, $bYU0b.is).fun(value) ? value(...args) : value;
}
var $cecbeabaf9cdcd78$var$matchProp = (value, key)=>value === true || !!(key && value && ((0, $bYU0b.is).fun(value) ? value(key) : (0, $bYU0b.toArray)(value).includes(key)));
var $cecbeabaf9cdcd78$var$resolveProp = (prop, key)=>(0, $bYU0b.is).obj(prop) ? key && prop[key] : prop;
var $cecbeabaf9cdcd78$var$getDefaultProp = (props, key)=>props.default === true ? props[key] : props.default ? props.default[key] : void 0;
var $cecbeabaf9cdcd78$var$noopTransform = (value)=>value;
var $cecbeabaf9cdcd78$var$getDefaultProps = (props, transform = $cecbeabaf9cdcd78$var$noopTransform)=>{
    let keys = $cecbeabaf9cdcd78$var$DEFAULT_PROPS;
    if (props.default && props.default !== true) {
        props = props.default;
        keys = Object.keys(props);
    }
    const defaults2 = {};
    for (const key of keys){
        const value = transform(props[key], key);
        if (!(0, $bYU0b.is).und(value)) defaults2[key] = value;
    }
    return defaults2;
};
var $cecbeabaf9cdcd78$var$DEFAULT_PROPS = [
    "config",
    "onProps",
    "onStart",
    "onChange",
    "onPause",
    "onResume",
    "onRest"
];
var $cecbeabaf9cdcd78$var$RESERVED_PROPS = {
    config: 1,
    from: 1,
    to: 1,
    ref: 1,
    loop: 1,
    reset: 1,
    pause: 1,
    cancel: 1,
    reverse: 1,
    immediate: 1,
    default: 1,
    delay: 1,
    onProps: 1,
    onStart: 1,
    onChange: 1,
    onPause: 1,
    onResume: 1,
    onRest: 1,
    onResolve: 1,
    // Transition props
    items: 1,
    trail: 1,
    sort: 1,
    expires: 1,
    initial: 1,
    enter: 1,
    update: 1,
    leave: 1,
    children: 1,
    onDestroyed: 1,
    // Internal props
    keys: 1,
    callId: 1,
    parentId: 1
};
function $cecbeabaf9cdcd78$var$getForwardProps(props) {
    const forward = {};
    let count = 0;
    (0, $bYU0b.eachProp)(props, (value, prop)=>{
        if (!$cecbeabaf9cdcd78$var$RESERVED_PROPS[prop]) {
            forward[prop] = value;
            count++;
        }
    });
    if (count) return forward;
}
function $cecbeabaf9cdcd78$export$b971039a739bf227(props) {
    const to2 = $cecbeabaf9cdcd78$var$getForwardProps(props);
    if (to2) {
        const out = {
            to: to2
        };
        (0, $bYU0b.eachProp)(props, (val, key)=>key in to2 || (out[key] = val));
        return out;
    }
    return {
        ...props
    };
}
function $cecbeabaf9cdcd78$var$computeGoal(value) {
    value = (0, $bYU0b.getFluidValue)(value);
    return (0, $bYU0b.is).arr(value) ? value.map($cecbeabaf9cdcd78$var$computeGoal) : (0, $bYU0b.isAnimatedString)(value) ? (0, $bYU0b.Globals).createStringInterpolator({
        range: [
            0,
            1
        ],
        output: [
            value,
            value
        ]
    })(1) : value;
}
function $cecbeabaf9cdcd78$var$hasProps(props) {
    for(const _ in props)return true;
    return false;
}
function $cecbeabaf9cdcd78$var$isAsyncTo(to2) {
    return (0, $bYU0b.is).fun(to2) || (0, $bYU0b.is).arr(to2) && (0, $bYU0b.is).obj(to2[0]);
}
function $cecbeabaf9cdcd78$var$detachRefs(ctrl, ref) {
    ctrl.ref?.delete(ctrl);
    ref?.delete(ctrl);
}
function $cecbeabaf9cdcd78$var$replaceRef(ctrl, ref) {
    if (ref && ctrl.ref !== ref) {
        ctrl.ref?.delete(ctrl);
        ref.add(ctrl);
        ctrl.ref = ref;
    }
}
// src/hooks/useChain.ts
function $cecbeabaf9cdcd78$export$a4a17273dffcc09c(refs, timeSteps, timeFrame = 1e3) {
    (0, $bYU0b.useIsomorphicLayoutEffect)(()=>{
        if (timeSteps) {
            let prevDelay = 0;
            (0, $bYU0b.each)(refs, (ref, i)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    let delay = timeFrame * timeSteps[i];
                    if (isNaN(delay)) delay = prevDelay;
                    else prevDelay = delay;
                    (0, $bYU0b.each)(controllers, (ctrl)=>{
                        (0, $bYU0b.each)(ctrl.queue, (props)=>{
                            const memoizedDelayProp = props.delay;
                            props.delay = (key)=>delay + $cecbeabaf9cdcd78$var$callProp(memoizedDelayProp || 0, key);
                        });
                    });
                    ref.start();
                }
            });
        } else {
            let p = Promise.resolve();
            (0, $bYU0b.each)(refs, (ref)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    const queues = controllers.map((ctrl)=>{
                        const q = ctrl.queue;
                        ctrl.queue = [];
                        return q;
                    });
                    p = p.then(()=>{
                        (0, $bYU0b.each)(controllers, (ctrl, i)=>(0, $bYU0b.each)(queues[i] || [], (update2)=>ctrl.queue.push(update2)));
                        return Promise.all(ref.start());
                    });
                }
            });
        }
    });
}
// src/constants.ts
var $cecbeabaf9cdcd78$export$e506a1d27d1eaa20 = {
    default: {
        tension: 170,
        friction: 26
    },
    gentle: {
        tension: 120,
        friction: 14
    },
    wobbly: {
        tension: 180,
        friction: 12
    },
    stiff: {
        tension: 210,
        friction: 20
    },
    slow: {
        tension: 280,
        friction: 60
    },
    molasses: {
        tension: 280,
        friction: 120
    }
};
// src/AnimationConfig.ts
var $cecbeabaf9cdcd78$var$defaults = {
    ...$cecbeabaf9cdcd78$export$e506a1d27d1eaa20.default,
    mass: 1,
    damping: 1,
    easing: (0, $bYU0b.easings).linear,
    clamp: false
};
var $cecbeabaf9cdcd78$var$AnimationConfig = class {
    constructor(){
        /**
     * The initial velocity of one or more values.
     *
     * @default 0
     */ this.velocity = 0;
        Object.assign(this, $cecbeabaf9cdcd78$var$defaults);
    }
};
function $cecbeabaf9cdcd78$var$mergeConfig(config2, newConfig, defaultConfig) {
    if (defaultConfig) {
        defaultConfig = {
            ...defaultConfig
        };
        $cecbeabaf9cdcd78$var$sanitizeConfig(defaultConfig, newConfig);
        newConfig = {
            ...defaultConfig,
            ...newConfig
        };
    }
    $cecbeabaf9cdcd78$var$sanitizeConfig(config2, newConfig);
    Object.assign(config2, newConfig);
    for(const key in $cecbeabaf9cdcd78$var$defaults)if (config2[key] == null) config2[key] = $cecbeabaf9cdcd78$var$defaults[key];
    let { frequency: frequency, damping: damping } = config2;
    const { mass: mass } = config2;
    if (!(0, $bYU0b.is).und(frequency)) {
        if (frequency < 0.01) frequency = 0.01;
        if (damping < 0) damping = 0;
        config2.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
        config2.friction = 4 * Math.PI * damping * mass / frequency;
    }
    return config2;
}
function $cecbeabaf9cdcd78$var$sanitizeConfig(config2, props) {
    if (!(0, $bYU0b.is).und(props.decay)) config2.duration = void 0;
    else {
        const isTensionConfig = !(0, $bYU0b.is).und(props.tension) || !(0, $bYU0b.is).und(props.friction);
        if (isTensionConfig || !(0, $bYU0b.is).und(props.frequency) || !(0, $bYU0b.is).und(props.damping) || !(0, $bYU0b.is).und(props.mass)) {
            config2.duration = void 0;
            config2.decay = void 0;
        }
        if (isTensionConfig) config2.frequency = void 0;
    }
}
// src/Animation.ts
var $cecbeabaf9cdcd78$var$emptyArray = [];
var $cecbeabaf9cdcd78$var$Animation = class {
    constructor(){
        this.changed = false;
        this.values = $cecbeabaf9cdcd78$var$emptyArray;
        this.toValues = null;
        this.fromValues = $cecbeabaf9cdcd78$var$emptyArray;
        this.config = new $cecbeabaf9cdcd78$var$AnimationConfig();
        this.immediate = false;
    }
};
function $cecbeabaf9cdcd78$var$scheduleProps(callId, { key: key, props: props, defaultProps: defaultProps, state: state, actions: actions }) {
    return new Promise((resolve, reject)=>{
        let delay;
        let timeout;
        let cancel = $cecbeabaf9cdcd78$var$matchProp(props.cancel ?? defaultProps?.cancel, key);
        if (cancel) onStart();
        else {
            if (!(0, $bYU0b.is).und(props.pause)) state.paused = $cecbeabaf9cdcd78$var$matchProp(props.pause, key);
            let pause = defaultProps?.pause;
            if (pause !== true) pause = state.paused || $cecbeabaf9cdcd78$var$matchProp(pause, key);
            delay = $cecbeabaf9cdcd78$var$callProp(props.delay || 0, key);
            if (pause) {
                state.resumeQueue.add(onResume);
                actions.pause();
            } else {
                actions.resume();
                onResume();
            }
        }
        function onPause() {
            state.resumeQueue.add(onResume);
            state.timeouts.delete(timeout);
            timeout.cancel();
            delay = timeout.time - (0, $cSAm3.raf).now();
        }
        function onResume() {
            if (delay > 0 && !(0, $bYU0b.Globals).skipAnimation) {
                state.delayed = true;
                timeout = (0, $cSAm3.raf).setTimeout(onStart, delay);
                state.pauseQueue.add(onPause);
                state.timeouts.add(timeout);
            } else onStart();
        }
        function onStart() {
            if (state.delayed) state.delayed = false;
            state.pauseQueue.delete(onPause);
            state.timeouts.delete(timeout);
            if (callId <= (state.cancelId || 0)) cancel = true;
            try {
                actions.start({
                    ...props,
                    callId: callId,
                    cancel: cancel
                }, resolve);
            } catch (err) {
                reject(err);
            }
        }
    });
}
// src/AnimationResult.ts
var $cecbeabaf9cdcd78$var$getCombinedResult = (target, results)=>results.length == 1 ? results[0] : results.some((result)=>result.cancelled) ? $cecbeabaf9cdcd78$var$getCancelledResult(target.get()) : results.every((result)=>result.noop) ? $cecbeabaf9cdcd78$var$getNoopResult(target.get()) : $cecbeabaf9cdcd78$var$getFinishedResult(target.get(), results.every((result)=>result.finished));
var $cecbeabaf9cdcd78$var$getNoopResult = (value)=>({
        value: value,
        noop: true,
        finished: true,
        cancelled: false
    });
var $cecbeabaf9cdcd78$var$getFinishedResult = (value, finished, cancelled = false)=>({
        value: value,
        finished: finished,
        cancelled: cancelled
    });
var $cecbeabaf9cdcd78$var$getCancelledResult = (value)=>({
        value: value,
        cancelled: true,
        finished: false
    });
// src/runAsync.ts
function $cecbeabaf9cdcd78$var$runAsync(to2, props, state, target) {
    const { callId: callId, parentId: parentId, onRest: onRest } = props;
    const { asyncTo: prevTo, promise: prevPromise } = state;
    if (!parentId && to2 === prevTo && !props.reset) return prevPromise;
    return state.promise = (async ()=>{
        state.asyncId = callId;
        state.asyncTo = to2;
        const defaultProps = $cecbeabaf9cdcd78$var$getDefaultProps(props, (value, key)=>// The `onRest` prop is only called when the `runAsync` promise is resolved.
            key === "onRest" ? void 0 : value);
        let preventBail;
        let bail;
        const bailPromise = new Promise((resolve, reject)=>(preventBail = resolve, bail = reject));
        const bailIfEnded = (bailSignal)=>{
            const bailResult = // The `cancel` prop or `stop` method was used.
            callId <= (state.cancelId || 0) && $cecbeabaf9cdcd78$var$getCancelledResult(target) || // The async `to` prop was replaced.
            callId !== state.asyncId && $cecbeabaf9cdcd78$var$getFinishedResult(target, false);
            if (bailResult) {
                bailSignal.result = bailResult;
                bail(bailSignal);
                throw bailSignal;
            }
        };
        const animate = (arg1, arg2)=>{
            const bailSignal = new $cecbeabaf9cdcd78$export$d362d093fa99dc7();
            const skipAnimationSignal = new $cecbeabaf9cdcd78$var$SkipAnimationSignal();
            return (async ()=>{
                if ((0, $bYU0b.Globals).skipAnimation) {
                    $cecbeabaf9cdcd78$var$stopAsync(state);
                    skipAnimationSignal.result = $cecbeabaf9cdcd78$var$getFinishedResult(target, false);
                    bail(skipAnimationSignal);
                    throw skipAnimationSignal;
                }
                bailIfEnded(bailSignal);
                const props2 = (0, $bYU0b.is).obj(arg1) ? {
                    ...arg1
                } : {
                    ...arg2,
                    to: arg1
                };
                props2.parentId = callId;
                (0, $bYU0b.eachProp)(defaultProps, (value, key)=>{
                    if ((0, $bYU0b.is).und(props2[key])) props2[key] = value;
                });
                const result2 = await target.start(props2);
                bailIfEnded(bailSignal);
                if (state.paused) await new Promise((resume)=>{
                    state.resumeQueue.add(resume);
                });
                return result2;
            })();
        };
        let result;
        if ((0, $bYU0b.Globals).skipAnimation) {
            $cecbeabaf9cdcd78$var$stopAsync(state);
            return $cecbeabaf9cdcd78$var$getFinishedResult(target, false);
        }
        try {
            let animating;
            if ((0, $bYU0b.is).arr(to2)) animating = (async (queue)=>{
                for (const props2 of queue)await animate(props2);
            })(to2);
            else animating = Promise.resolve(to2(animate, target.stop.bind(target)));
            await Promise.all([
                animating.then(preventBail),
                bailPromise
            ]);
            result = $cecbeabaf9cdcd78$var$getFinishedResult(target.get(), true, false);
        } catch (err) {
            if (err instanceof $cecbeabaf9cdcd78$export$d362d093fa99dc7) result = err.result;
            else if (err instanceof $cecbeabaf9cdcd78$var$SkipAnimationSignal) result = err.result;
            else throw err;
        } finally{
            if (callId == state.asyncId) {
                state.asyncId = parentId;
                state.asyncTo = parentId ? prevTo : void 0;
                state.promise = parentId ? prevPromise : void 0;
            }
        }
        if ((0, $bYU0b.is).fun(onRest)) (0, $cSAm3.raf).batchedUpdates(()=>{
            onRest(result, target, target.item);
        });
        return result;
    })();
}
function $cecbeabaf9cdcd78$var$stopAsync(state, cancelId) {
    (0, $bYU0b.flush)(state.timeouts, (t)=>t.cancel());
    state.pauseQueue.clear();
    state.resumeQueue.clear();
    state.asyncId = state.asyncTo = state.promise = void 0;
    if (cancelId) state.cancelId = cancelId;
}
var $cecbeabaf9cdcd78$export$d362d093fa99dc7 = class extends Error {
    constructor(){
        super("An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise.");
    }
};
var $cecbeabaf9cdcd78$var$SkipAnimationSignal = class extends Error {
    constructor(){
        super("SkipAnimationSignal");
    }
};
var $cecbeabaf9cdcd78$var$isFrameValue = (value)=>value instanceof $cecbeabaf9cdcd78$export$8229896f80e2495e;
var $cecbeabaf9cdcd78$var$nextId = 1;
var $cecbeabaf9cdcd78$export$8229896f80e2495e = class extends (0, $bYU0b.FluidValue) {
    constructor(){
        super(...arguments);
        this.id = $cecbeabaf9cdcd78$var$nextId++;
        this._priority = 0;
    }
    get priority() {
        return this._priority;
    }
    set priority(priority) {
        if (this._priority != priority) {
            this._priority = priority;
            this._onPriorityChange(priority);
        }
    }
    /** Get the current value */ get() {
        const node = (0, $b7bYo.getAnimated)(this);
        return node && node.getValue();
    }
    /** Create a spring that maps our value to another value */ to(...args) {
        return (0, $bYU0b.Globals).to(this, args);
    }
    /** @deprecated Use the `to` method instead. */ interpolate(...args) {
        (0, $bYU0b.deprecateInterpolate)();
        return (0, $bYU0b.Globals).to(this, args);
    }
    toJSON() {
        return this.get();
    }
    observerAdded(count) {
        if (count == 1) this._attach();
    }
    observerRemoved(count) {
        if (count == 0) this._detach();
    }
    /** Called when the first child is added. */ _attach() {}
    /** Called when the last child is removed. */ _detach() {}
    /** Tell our children about our new value */ _onChange(value, idle = false) {
        (0, $bYU0b.callFluidObservers)(this, {
            type: "change",
            parent: this,
            value: value,
            idle: idle
        });
    }
    /** Tell our children about our new priority */ _onPriorityChange(priority) {
        if (!this.idle) (0, $bYU0b.frameLoop).sort(this);
        (0, $bYU0b.callFluidObservers)(this, {
            type: "priority",
            parent: this,
            priority: priority
        });
    }
};
// src/SpringPhase.ts
var $cecbeabaf9cdcd78$var$$P = Symbol.for("SpringPhase");
var $cecbeabaf9cdcd78$var$HAS_ANIMATED = 1;
var $cecbeabaf9cdcd78$var$IS_ANIMATING = 2;
var $cecbeabaf9cdcd78$var$IS_PAUSED = 4;
var $cecbeabaf9cdcd78$var$hasAnimated = (target)=>(target[$cecbeabaf9cdcd78$var$$P] & $cecbeabaf9cdcd78$var$HAS_ANIMATED) > 0;
var $cecbeabaf9cdcd78$var$isAnimating = (target)=>(target[$cecbeabaf9cdcd78$var$$P] & $cecbeabaf9cdcd78$var$IS_ANIMATING) > 0;
var $cecbeabaf9cdcd78$var$isPaused = (target)=>(target[$cecbeabaf9cdcd78$var$$P] & $cecbeabaf9cdcd78$var$IS_PAUSED) > 0;
var $cecbeabaf9cdcd78$var$setActiveBit = (target, active)=>active ? target[$cecbeabaf9cdcd78$var$$P] |= $cecbeabaf9cdcd78$var$IS_ANIMATING | $cecbeabaf9cdcd78$var$HAS_ANIMATED : target[$cecbeabaf9cdcd78$var$$P] &= ~$cecbeabaf9cdcd78$var$IS_ANIMATING;
var $cecbeabaf9cdcd78$var$setPausedBit = (target, paused)=>paused ? target[$cecbeabaf9cdcd78$var$$P] |= $cecbeabaf9cdcd78$var$IS_PAUSED : target[$cecbeabaf9cdcd78$var$$P] &= ~$cecbeabaf9cdcd78$var$IS_PAUSED;
// src/SpringValue.ts
var $cecbeabaf9cdcd78$export$5854d13427d5a954 = class extends $cecbeabaf9cdcd78$export$8229896f80e2495e {
    constructor(arg1, arg2){
        super();
        /** The animation state */ this.animation = new $cecbeabaf9cdcd78$var$Animation();
        /** Some props have customizable default values */ this.defaultProps = {};
        /** The state for `runAsync` calls */ this._state = {
            paused: false,
            delayed: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The promise resolvers of pending `start` calls */ this._pendingCalls = /* @__PURE__ */ new Set();
        /** The counter for tracking `scheduleProps` calls */ this._lastCallId = 0;
        /** The last `scheduleProps` call that changed the `to` prop */ this._lastToId = 0;
        this._memoizedDuration = 0;
        if (!(0, $bYU0b.is).und(arg1) || !(0, $bYU0b.is).und(arg2)) {
            const props = (0, $bYU0b.is).obj(arg1) ? {
                ...arg1
            } : {
                ...arg2,
                from: arg1
            };
            if ((0, $bYU0b.is).und(props.default)) props.default = true;
            this.start(props);
        }
    }
    /** Equals true when not advancing on each frame. */ get idle() {
        return !($cecbeabaf9cdcd78$var$isAnimating(this) || this._state.asyncTo) || $cecbeabaf9cdcd78$var$isPaused(this);
    }
    get goal() {
        return (0, $bYU0b.getFluidValue)(this.animation.to);
    }
    get velocity() {
        const node = (0, $b7bYo.getAnimated)(this);
        return node instanceof (0, $b7bYo.AnimatedValue) ? node.lastVelocity || 0 : node.getPayload().map((node2)=>node2.lastVelocity || 0);
    }
    /**
   * When true, this value has been animated at least once.
   */ get hasAnimated() {
        return $cecbeabaf9cdcd78$var$hasAnimated(this);
    }
    /**
   * When true, this value has an unfinished animation,
   * which is either active or paused.
   */ get isAnimating() {
        return $cecbeabaf9cdcd78$var$isAnimating(this);
    }
    /**
   * When true, all current and future animations are paused.
   */ get isPaused() {
        return $cecbeabaf9cdcd78$var$isPaused(this);
    }
    /**
   *
   *
   */ get isDelayed() {
        return this._state.delayed;
    }
    /** Advance the current animation by a number of milliseconds */ advance(dt) {
        let idle = true;
        let changed = false;
        const anim = this.animation;
        let { toValues: toValues } = anim;
        const { config: config2 } = anim;
        const payload = (0, $b7bYo.getPayload)(anim.to);
        if (!payload && (0, $bYU0b.hasFluidValue)(anim.to)) toValues = (0, $bYU0b.toArray)((0, $bYU0b.getFluidValue)(anim.to));
        anim.values.forEach((node2, i)=>{
            if (node2.done) return;
            const to2 = // Animated strings always go from 0 to 1.
            node2.constructor == (0, $b7bYo.AnimatedString) ? 1 : payload ? payload[i].lastPosition : toValues[i];
            let finished = anim.immediate;
            let position = to2;
            if (!finished) {
                position = node2.lastPosition;
                if (config2.tension <= 0) {
                    node2.done = true;
                    return;
                }
                let elapsed = node2.elapsedTime += dt;
                const from = anim.fromValues[i];
                const v0 = node2.v0 != null ? node2.v0 : node2.v0 = (0, $bYU0b.is).arr(config2.velocity) ? config2.velocity[i] : config2.velocity;
                let velocity;
                const precision = config2.precision || (from == to2 ? 5e-3 : Math.min(1, Math.abs(to2 - from) * 1e-3));
                if (!(0, $bYU0b.is).und(config2.duration)) {
                    let p = 1;
                    if (config2.duration > 0) {
                        if (this._memoizedDuration !== config2.duration) {
                            this._memoizedDuration = config2.duration;
                            if (node2.durationProgress > 0) {
                                node2.elapsedTime = config2.duration * node2.durationProgress;
                                elapsed = node2.elapsedTime += dt;
                            }
                        }
                        p = (config2.progress || 0) + elapsed / this._memoizedDuration;
                        p = p > 1 ? 1 : p < 0 ? 0 : p;
                        node2.durationProgress = p;
                    }
                    position = from + config2.easing(p) * (to2 - from);
                    velocity = (position - node2.lastPosition) / dt;
                    finished = p == 1;
                } else if (config2.decay) {
                    const decay = config2.decay === true ? 0.998 : config2.decay;
                    const e = Math.exp(-(1 - decay) * elapsed);
                    position = from + v0 / (1 - decay) * (1 - e);
                    finished = Math.abs(node2.lastPosition - position) <= precision;
                    velocity = v0 * e;
                } else {
                    velocity = node2.lastVelocity == null ? v0 : node2.lastVelocity;
                    const restVelocity = config2.restVelocity || precision / 10;
                    const bounceFactor = config2.clamp ? 0 : config2.bounce;
                    const canBounce = !(0, $bYU0b.is).und(bounceFactor);
                    const isGrowing = from == to2 ? node2.v0 > 0 : from < to2;
                    let isMoving;
                    let isBouncing = false;
                    const step = 1;
                    const numSteps = Math.ceil(dt / step);
                    for(let n = 0; n < numSteps; ++n){
                        isMoving = Math.abs(velocity) > restVelocity;
                        if (!isMoving) {
                            finished = Math.abs(to2 - position) <= precision;
                            if (finished) break;
                        }
                        if (canBounce) {
                            isBouncing = position == to2 || position > to2 == isGrowing;
                            if (isBouncing) {
                                velocity = -velocity * bounceFactor;
                                position = to2;
                            }
                        }
                        const springForce = -config2.tension * 1e-6 * (position - to2);
                        const dampingForce = -config2.friction * 1e-3 * velocity;
                        const acceleration = (springForce + dampingForce) / config2.mass;
                        velocity = velocity + acceleration * step;
                        position = position + velocity * step;
                    }
                }
                node2.lastVelocity = velocity;
                if (Number.isNaN(position)) {
                    console.warn(`Got NaN while animating:`, this);
                    finished = true;
                }
            }
            if (payload && !payload[i].done) finished = false;
            if (finished) node2.done = true;
            else idle = false;
            if (node2.setValue(position, config2.round)) changed = true;
        });
        const node = (0, $b7bYo.getAnimated)(this);
        const currVal = node.getValue();
        if (idle) {
            const finalVal = (0, $bYU0b.getFluidValue)(anim.to);
            if ((currVal !== finalVal || changed) && !config2.decay) {
                node.setValue(finalVal);
                this._onChange(finalVal);
            } else if (changed && config2.decay) this._onChange(currVal);
            this._stop();
        } else if (changed) this._onChange(currVal);
    }
    /** Set the current value, while stopping the current animation */ set(value) {
        (0, $cSAm3.raf).batchedUpdates(()=>{
            this._stop();
            this._focus(value);
            this._set(value);
        });
        return this;
    }
    /**
   * Freeze the active animation in time, as well as any updates merged
   * before `resume` is called.
   */ pause() {
        this._update({
            pause: true
        });
    }
    /** Resume the animation if paused. */ resume() {
        this._update({
            pause: false
        });
    }
    /** Skip to the end of the current animation. */ finish() {
        if ($cecbeabaf9cdcd78$var$isAnimating(this)) {
            const { to: to2, config: config2 } = this.animation;
            (0, $cSAm3.raf).batchedUpdates(()=>{
                this._onStart();
                if (!config2.decay) this._set(to2, false);
                this._stop();
            });
        }
        return this;
    }
    /** Push props into the pending queue. */ update(props) {
        const queue = this.queue || (this.queue = []);
        queue.push(props);
        return this;
    }
    start(to2, arg2) {
        let queue;
        if (!(0, $bYU0b.is).und(to2)) queue = [
            (0, $bYU0b.is).obj(to2) ? to2 : {
                ...arg2,
                to: to2
            }
        ];
        else {
            queue = this.queue || [];
            this.queue = [];
        }
        return Promise.all(queue.map((props)=>{
            const up = this._update(props);
            return up;
        })).then((results)=>$cecbeabaf9cdcd78$var$getCombinedResult(this, results));
    }
    /**
   * Stop the current animation, and cancel any delayed updates.
   *
   * Pass `true` to call `onRest` with `cancelled: true`.
   */ stop(cancel) {
        const { to: to2 } = this.animation;
        this._focus(this.get());
        $cecbeabaf9cdcd78$var$stopAsync(this._state, cancel && this._lastCallId);
        (0, $cSAm3.raf).batchedUpdates(()=>this._stop(to2, cancel));
        return this;
    }
    /** Restart the animation. */ reset() {
        this._update({
            reset: true
        });
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") this._start();
        else if (event.type == "priority") this.priority = event.priority + 1;
    }
    /**
   * Parse the `to` and `from` range from the given `props` object.
   *
   * This also ensures the initial value is available to animated components
   * during the render phase.
   */ _prepareNode(props) {
        const key = this.key || "";
        let { to: to2, from: from } = props;
        to2 = (0, $bYU0b.is).obj(to2) ? to2[key] : to2;
        if (to2 == null || $cecbeabaf9cdcd78$var$isAsyncTo(to2)) to2 = void 0;
        from = (0, $bYU0b.is).obj(from) ? from[key] : from;
        if (from == null) from = void 0;
        const range = {
            to: to2,
            from: from
        };
        if (!$cecbeabaf9cdcd78$var$hasAnimated(this)) {
            if (props.reverse) [to2, from] = [
                from,
                to2
            ];
            from = (0, $bYU0b.getFluidValue)(from);
            if (!(0, $bYU0b.is).und(from)) this._set(from);
            else if (!(0, $b7bYo.getAnimated)(this)) this._set(to2);
        }
        return range;
    }
    /** Every update is processed by this method before merging. */ _update({ ...props }, isLoop) {
        const { key: key, defaultProps: defaultProps } = this;
        if (props.default) Object.assign(defaultProps, $cecbeabaf9cdcd78$var$getDefaultProps(props, (value, prop)=>/^on/.test(prop) ? $cecbeabaf9cdcd78$var$resolveProp(value, key) : value));
        $cecbeabaf9cdcd78$var$mergeActiveFn(this, props, "onProps");
        $cecbeabaf9cdcd78$var$sendEvent(this, "onProps", props, this);
        const range = this._prepareNode(props);
        if (Object.isFrozen(this)) throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
        const state = this._state;
        return $cecbeabaf9cdcd78$var$scheduleProps(++this._lastCallId, {
            key: key,
            props: props,
            defaultProps: defaultProps,
            state: state,
            actions: {
                pause: ()=>{
                    if (!$cecbeabaf9cdcd78$var$isPaused(this)) {
                        $cecbeabaf9cdcd78$var$setPausedBit(this, true);
                        (0, $bYU0b.flushCalls)(state.pauseQueue);
                        $cecbeabaf9cdcd78$var$sendEvent(this, "onPause", $cecbeabaf9cdcd78$var$getFinishedResult(this, $cecbeabaf9cdcd78$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                resume: ()=>{
                    if ($cecbeabaf9cdcd78$var$isPaused(this)) {
                        $cecbeabaf9cdcd78$var$setPausedBit(this, false);
                        if ($cecbeabaf9cdcd78$var$isAnimating(this)) this._resume();
                        (0, $bYU0b.flushCalls)(state.resumeQueue);
                        $cecbeabaf9cdcd78$var$sendEvent(this, "onResume", $cecbeabaf9cdcd78$var$getFinishedResult(this, $cecbeabaf9cdcd78$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                start: this._merge.bind(this, range)
            }
        }).then((result)=>{
            if (props.loop && result.finished && !(isLoop && result.noop)) {
                const nextProps = $cecbeabaf9cdcd78$var$createLoopUpdate(props);
                if (nextProps) return this._update(nextProps, true);
            }
            return result;
        });
    }
    /** Merge props into the current animation */ _merge(range, props, resolve) {
        if (props.cancel) {
            this.stop(true);
            return resolve($cecbeabaf9cdcd78$var$getCancelledResult(this));
        }
        const hasToProp = !(0, $bYU0b.is).und(range.to);
        const hasFromProp = !(0, $bYU0b.is).und(range.from);
        if (hasToProp || hasFromProp) {
            if (props.callId > this._lastToId) this._lastToId = props.callId;
            else return resolve($cecbeabaf9cdcd78$var$getCancelledResult(this));
        }
        const { key: key, defaultProps: defaultProps, animation: anim } = this;
        const { to: prevTo, from: prevFrom } = anim;
        let { to: to2 = prevTo, from: from = prevFrom } = range;
        if (hasFromProp && !hasToProp && (!props.default || (0, $bYU0b.is).und(to2))) to2 = from;
        if (props.reverse) [to2, from] = [
            from,
            to2
        ];
        const hasFromChanged = !(0, $bYU0b.isEqual)(from, prevFrom);
        if (hasFromChanged) anim.from = from;
        from = (0, $bYU0b.getFluidValue)(from);
        const hasToChanged = !(0, $bYU0b.isEqual)(to2, prevTo);
        if (hasToChanged) this._focus(to2);
        const hasAsyncTo = $cecbeabaf9cdcd78$var$isAsyncTo(props.to);
        const { config: config2 } = anim;
        const { decay: decay, velocity: velocity } = config2;
        if (hasToProp || hasFromProp) config2.velocity = 0;
        if (props.config && !hasAsyncTo) $cecbeabaf9cdcd78$var$mergeConfig(config2, $cecbeabaf9cdcd78$var$callProp(props.config, key), // Avoid calling the same "config" prop twice.
        props.config !== defaultProps.config ? $cecbeabaf9cdcd78$var$callProp(defaultProps.config, key) : void 0);
        let node = (0, $b7bYo.getAnimated)(this);
        if (!node || (0, $bYU0b.is).und(to2)) return resolve($cecbeabaf9cdcd78$var$getFinishedResult(this, true));
        const reset = // When `reset` is undefined, the `from` prop implies `reset: true`,
        // except for declarative updates. When `reset` is defined, there
        // must exist a value to animate from.
        (0, $bYU0b.is).und(props.reset) ? hasFromProp && !props.default : !(0, $bYU0b.is).und(from) && $cecbeabaf9cdcd78$var$matchProp(props.reset, key);
        const value = reset ? from : this.get();
        const goal = $cecbeabaf9cdcd78$var$computeGoal(to2);
        const isAnimatable = (0, $bYU0b.is).num(goal) || (0, $bYU0b.is).arr(goal) || (0, $bYU0b.isAnimatedString)(goal);
        const immediate = !hasAsyncTo && (!isAnimatable || $cecbeabaf9cdcd78$var$matchProp(defaultProps.immediate || props.immediate, key));
        if (hasToChanged) {
            const nodeType = (0, $b7bYo.getAnimatedType)(to2);
            if (nodeType !== node.constructor) {
                if (immediate) node = this._set(goal);
                else throw Error(`Cannot animate between ${node.constructor.name} and ${nodeType.name}, as the "to" prop suggests`);
            }
        }
        const goalType = node.constructor;
        let started = (0, $bYU0b.hasFluidValue)(to2);
        let finished = false;
        if (!started) {
            const hasValueChanged = reset || !$cecbeabaf9cdcd78$var$hasAnimated(this) && hasFromChanged;
            if (hasToChanged || hasValueChanged) {
                finished = (0, $bYU0b.isEqual)($cecbeabaf9cdcd78$var$computeGoal(value), goal);
                started = !finished;
            }
            if (!(0, $bYU0b.isEqual)(anim.immediate, immediate) && !immediate || !(0, $bYU0b.isEqual)(config2.decay, decay) || !(0, $bYU0b.isEqual)(config2.velocity, velocity)) started = true;
        }
        if (finished && $cecbeabaf9cdcd78$var$isAnimating(this)) {
            if (anim.changed && !reset) started = true;
            else if (!started) this._stop(prevTo);
        }
        if (!hasAsyncTo) {
            if (started || (0, $bYU0b.hasFluidValue)(prevTo)) {
                anim.values = node.getPayload();
                anim.toValues = (0, $bYU0b.hasFluidValue)(to2) ? null : goalType == (0, $b7bYo.AnimatedString) ? [
                    1
                ] : (0, $bYU0b.toArray)(goal);
            }
            if (anim.immediate != immediate) {
                anim.immediate = immediate;
                if (!immediate && !reset) this._set(prevTo);
            }
            if (started) {
                const { onRest: onRest } = anim;
                (0, $bYU0b.each)($cecbeabaf9cdcd78$var$ACTIVE_EVENTS, (type)=>$cecbeabaf9cdcd78$var$mergeActiveFn(this, props, type));
                const result = $cecbeabaf9cdcd78$var$getFinishedResult(this, $cecbeabaf9cdcd78$var$checkFinished(this, prevTo));
                (0, $bYU0b.flushCalls)(this._pendingCalls, result);
                this._pendingCalls.add(resolve);
                if (anim.changed) (0, $cSAm3.raf).batchedUpdates(()=>{
                    anim.changed = !reset;
                    onRest?.(result, this);
                    if (reset) $cecbeabaf9cdcd78$var$callProp(defaultProps.onRest, result);
                    else anim.onStart?.(result, this);
                });
            }
        }
        if (reset) this._set(value);
        if (hasAsyncTo) resolve($cecbeabaf9cdcd78$var$runAsync(props.to, props, this._state, this));
        else if (started) this._start();
        else if ($cecbeabaf9cdcd78$var$isAnimating(this) && !hasToChanged) this._pendingCalls.add(resolve);
        else resolve($cecbeabaf9cdcd78$var$getNoopResult(value));
    }
    /** Update the `animation.to` value, which might be a `FluidValue` */ _focus(value) {
        const anim = this.animation;
        if (value !== anim.to) {
            if ((0, $bYU0b.getFluidObservers)(this)) this._detach();
            anim.to = value;
            if ((0, $bYU0b.getFluidObservers)(this)) this._attach();
        }
    }
    _attach() {
        let priority = 0;
        const { to: to2 } = this.animation;
        if ((0, $bYU0b.hasFluidValue)(to2)) {
            (0, $bYU0b.addFluidObserver)(to2, this);
            if ($cecbeabaf9cdcd78$var$isFrameValue(to2)) priority = to2.priority + 1;
        }
        this.priority = priority;
    }
    _detach() {
        const { to: to2 } = this.animation;
        if ((0, $bYU0b.hasFluidValue)(to2)) (0, $bYU0b.removeFluidObserver)(to2, this);
    }
    /**
   * Update the current value from outside the frameloop,
   * and return the `Animated` node.
   */ _set(arg, idle = true) {
        const value = (0, $bYU0b.getFluidValue)(arg);
        if (!(0, $bYU0b.is).und(value)) {
            const oldNode = (0, $b7bYo.getAnimated)(this);
            if (!oldNode || !(0, $bYU0b.isEqual)(value, oldNode.getValue())) {
                const nodeType = (0, $b7bYo.getAnimatedType)(value);
                if (!oldNode || oldNode.constructor != nodeType) (0, $b7bYo.setAnimated)(this, nodeType.create(value));
                else oldNode.setValue(value);
                if (oldNode) (0, $cSAm3.raf).batchedUpdates(()=>{
                    this._onChange(value, idle);
                });
            }
        }
        return (0, $b7bYo.getAnimated)(this);
    }
    _onStart() {
        const anim = this.animation;
        if (!anim.changed) {
            anim.changed = true;
            $cecbeabaf9cdcd78$var$sendEvent(this, "onStart", $cecbeabaf9cdcd78$var$getFinishedResult(this, $cecbeabaf9cdcd78$var$checkFinished(this, anim.to)), this);
        }
    }
    _onChange(value, idle) {
        if (!idle) {
            this._onStart();
            $cecbeabaf9cdcd78$var$callProp(this.animation.onChange, value, this);
        }
        $cecbeabaf9cdcd78$var$callProp(this.defaultProps.onChange, value, this);
        super._onChange(value, idle);
    }
    // This method resets the animation state (even if already animating) to
    // ensure the latest from/to range is used, and it also ensures this spring
    // is added to the frameloop.
    _start() {
        const anim = this.animation;
        (0, $b7bYo.getAnimated)(this).reset((0, $bYU0b.getFluidValue)(anim.to));
        if (!anim.immediate) anim.fromValues = anim.values.map((node)=>node.lastPosition);
        if (!$cecbeabaf9cdcd78$var$isAnimating(this)) {
            $cecbeabaf9cdcd78$var$setActiveBit(this, true);
            if (!$cecbeabaf9cdcd78$var$isPaused(this)) this._resume();
        }
    }
    _resume() {
        if ((0, $bYU0b.Globals).skipAnimation) this.finish();
        else (0, $bYU0b.frameLoop).start(this);
    }
    /**
   * Exit the frameloop and notify `onRest` listeners.
   *
   * Always wrap `_stop` calls with `batchedUpdates`.
   */ _stop(goal, cancel) {
        if ($cecbeabaf9cdcd78$var$isAnimating(this)) {
            $cecbeabaf9cdcd78$var$setActiveBit(this, false);
            const anim = this.animation;
            (0, $bYU0b.each)(anim.values, (node)=>{
                node.done = true;
            });
            if (anim.toValues) anim.onChange = anim.onPause = anim.onResume = void 0;
            (0, $bYU0b.callFluidObservers)(this, {
                type: "idle",
                parent: this
            });
            const result = cancel ? $cecbeabaf9cdcd78$var$getCancelledResult(this.get()) : $cecbeabaf9cdcd78$var$getFinishedResult(this.get(), $cecbeabaf9cdcd78$var$checkFinished(this, goal ?? anim.to));
            (0, $bYU0b.flushCalls)(this._pendingCalls, result);
            if (anim.changed) {
                anim.changed = false;
                $cecbeabaf9cdcd78$var$sendEvent(this, "onRest", result, this);
            }
        }
    }
};
function $cecbeabaf9cdcd78$var$checkFinished(target, to2) {
    const goal = $cecbeabaf9cdcd78$var$computeGoal(to2);
    const value = $cecbeabaf9cdcd78$var$computeGoal(target.get());
    return (0, $bYU0b.isEqual)(value, goal);
}
function $cecbeabaf9cdcd78$var$createLoopUpdate(props, loop = props.loop, to2 = props.to) {
    const loopRet = $cecbeabaf9cdcd78$var$callProp(loop);
    if (loopRet) {
        const overrides = loopRet !== true && $cecbeabaf9cdcd78$export$b971039a739bf227(loopRet);
        const reverse = (overrides || props).reverse;
        const reset = !overrides || overrides.reset;
        return $cecbeabaf9cdcd78$var$createUpdate({
            ...props,
            loop: loop,
            // Avoid updating default props when looping.
            default: false,
            // Never loop the `pause` prop.
            pause: void 0,
            // For the "reverse" prop to loop as expected, the "to" prop
            // must be undefined. The "reverse" prop is ignored when the
            // "to" prop is an array or function.
            to: !reverse || $cecbeabaf9cdcd78$var$isAsyncTo(to2) ? to2 : void 0,
            // Ignore the "from" prop except on reset.
            from: reset ? props.from : void 0,
            reset: reset,
            // The "loop" prop can return a "useSpring" props object to
            // override any of the original props.
            ...overrides
        });
    }
}
function $cecbeabaf9cdcd78$var$createUpdate(props) {
    const { to: to2, from: from } = props = $cecbeabaf9cdcd78$export$b971039a739bf227(props);
    const keys = /* @__PURE__ */ new Set();
    if ((0, $bYU0b.is).obj(to2)) $cecbeabaf9cdcd78$var$findDefined(to2, keys);
    if ((0, $bYU0b.is).obj(from)) $cecbeabaf9cdcd78$var$findDefined(from, keys);
    props.keys = keys.size ? Array.from(keys) : null;
    return props;
}
function $cecbeabaf9cdcd78$var$declareUpdate(props) {
    const update2 = $cecbeabaf9cdcd78$var$createUpdate(props);
    if ((0, $bYU0b.is).und(update2.default)) update2.default = $cecbeabaf9cdcd78$var$getDefaultProps(update2);
    return update2;
}
function $cecbeabaf9cdcd78$var$findDefined(values, keys) {
    (0, $bYU0b.eachProp)(values, (value, key)=>value != null && keys.add(key));
}
var $cecbeabaf9cdcd78$var$ACTIVE_EVENTS = [
    "onStart",
    "onRest",
    "onChange",
    "onPause",
    "onResume"
];
function $cecbeabaf9cdcd78$var$mergeActiveFn(target, props, type) {
    target.animation[type] = props[type] !== $cecbeabaf9cdcd78$var$getDefaultProp(props, type) ? $cecbeabaf9cdcd78$var$resolveProp(props[type], target.key) : void 0;
}
function $cecbeabaf9cdcd78$var$sendEvent(target, type, ...args) {
    target.animation[type]?.(...args);
    target.defaultProps[type]?.(...args);
}
var $cecbeabaf9cdcd78$var$BATCHED_EVENTS = [
    "onStart",
    "onChange",
    "onRest"
];
var $cecbeabaf9cdcd78$var$nextId2 = 1;
var $cecbeabaf9cdcd78$export$bd0bf19f25da8474 = class {
    constructor(props, flush3){
        this.id = $cecbeabaf9cdcd78$var$nextId2++;
        /** The animated values */ this.springs = {};
        /** The queue of props passed to the `update` method. */ this.queue = [];
        /** The counter for tracking `scheduleProps` calls */ this._lastAsyncId = 0;
        /** The values currently being animated */ this._active = /* @__PURE__ */ new Set();
        /** The values that changed recently */ this._changed = /* @__PURE__ */ new Set();
        /** Equals false when `onStart` listeners can be called */ this._started = false;
        /** State used by the `runAsync` function */ this._state = {
            paused: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The event queues that are flushed once per frame maximum */ this._events = {
            onStart: /* @__PURE__ */ new Map(),
            onChange: /* @__PURE__ */ new Map(),
            onRest: /* @__PURE__ */ new Map()
        };
        this._onFrame = this._onFrame.bind(this);
        if (flush3) this._flush = flush3;
        if (props) this.start({
            default: true,
            ...props
        });
    }
    /**
   * Equals `true` when no spring values are in the frameloop, and
   * no async animation is currently active.
   */ get idle() {
        return !this._state.asyncTo && Object.values(this.springs).every((spring)=>{
            return spring.idle && !spring.isDelayed && !spring.isPaused;
        });
    }
    get item() {
        return this._item;
    }
    set item(item) {
        this._item = item;
    }
    /** Get the current values of our springs */ get() {
        const values = {};
        this.each((spring, key)=>values[key] = spring.get());
        return values;
    }
    /** Set the current values without animating. */ set(values) {
        for(const key in values){
            const value = values[key];
            if (!(0, $bYU0b.is).und(value)) this.springs[key].set(value);
        }
    }
    /** Push an update onto the queue of each value. */ update(props) {
        if (props) this.queue.push($cecbeabaf9cdcd78$var$createUpdate(props));
        return this;
    }
    /**
   * Start the queued animations for every spring, and resolve the returned
   * promise once all queued animations have finished or been cancelled.
   *
   * When you pass a queue (instead of nothing), that queue is used instead of
   * the queued animations added with the `update` method, which are left alone.
   */ start(props) {
        let { queue: queue } = this;
        if (props) queue = (0, $bYU0b.toArray)(props).map($cecbeabaf9cdcd78$var$createUpdate);
        else this.queue = [];
        if (this._flush) return this._flush(this, queue);
        $cecbeabaf9cdcd78$var$prepareKeys(this, queue);
        return $cecbeabaf9cdcd78$var$flushUpdateQueue(this, queue);
    }
    /** @internal */ stop(arg, keys) {
        if (arg !== !!arg) keys = arg;
        if (keys) {
            const springs = this.springs;
            (0, $bYU0b.each)((0, $bYU0b.toArray)(keys), (key)=>springs[key].stop(!!arg));
        } else {
            $cecbeabaf9cdcd78$var$stopAsync(this._state, this._lastAsyncId);
            this.each((spring)=>spring.stop(!!arg));
        }
        return this;
    }
    /** Freeze the active animation in time */ pause(keys) {
        if ((0, $bYU0b.is).und(keys)) this.start({
            pause: true
        });
        else {
            const springs = this.springs;
            (0, $bYU0b.each)((0, $bYU0b.toArray)(keys), (key)=>springs[key].pause());
        }
        return this;
    }
    /** Resume the animation if paused. */ resume(keys) {
        if ((0, $bYU0b.is).und(keys)) this.start({
            pause: false
        });
        else {
            const springs = this.springs;
            (0, $bYU0b.each)((0, $bYU0b.toArray)(keys), (key)=>springs[key].resume());
        }
        return this;
    }
    /** Call a function once per spring value */ each(iterator) {
        (0, $bYU0b.eachProp)(this.springs, iterator);
    }
    /** @internal Called at the end of every animation frame */ _onFrame() {
        const { onStart: onStart, onChange: onChange, onRest: onRest } = this._events;
        const active = this._active.size > 0;
        const changed = this._changed.size > 0;
        if (active && !this._started || changed && !this._started) {
            this._started = true;
            (0, $bYU0b.flush)(onStart, ([onStart2, result])=>{
                result.value = this.get();
                onStart2(result, this, this._item);
            });
        }
        const idle = !active && this._started;
        const values = changed || idle && onRest.size ? this.get() : null;
        if (changed && onChange.size) (0, $bYU0b.flush)(onChange, ([onChange2, result])=>{
            result.value = values;
            onChange2(result, this, this._item);
        });
        if (idle) {
            this._started = false;
            (0, $bYU0b.flush)(onRest, ([onRest2, result])=>{
                result.value = values;
                onRest2(result, this, this._item);
            });
        }
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            this._changed.add(event.parent);
            if (!event.idle) this._active.add(event.parent);
        } else if (event.type == "idle") this._active.delete(event.parent);
        else return;
        (0, $cSAm3.raf).onFrame(this._onFrame);
    }
};
function $cecbeabaf9cdcd78$var$flushUpdateQueue(ctrl, queue) {
    return Promise.all(queue.map((props)=>$cecbeabaf9cdcd78$var$flushUpdate(ctrl, props))).then((results)=>$cecbeabaf9cdcd78$var$getCombinedResult(ctrl, results));
}
async function $cecbeabaf9cdcd78$var$flushUpdate(ctrl, props, isLoop) {
    const { keys: keys, to: to2, from: from, loop: loop, onRest: onRest, onResolve: onResolve } = props;
    const defaults2 = (0, $bYU0b.is).obj(props.default) && props.default;
    if (loop) props.loop = false;
    if (to2 === false) props.to = null;
    if (from === false) props.from = null;
    const asyncTo = (0, $bYU0b.is).arr(to2) || (0, $bYU0b.is).fun(to2) ? to2 : void 0;
    if (asyncTo) {
        props.to = void 0;
        props.onRest = void 0;
        if (defaults2) defaults2.onRest = void 0;
    } else (0, $bYU0b.each)($cecbeabaf9cdcd78$var$BATCHED_EVENTS, (key)=>{
        const handler = props[key];
        if ((0, $bYU0b.is).fun(handler)) {
            const queue = ctrl["_events"][key];
            props[key] = ({ finished: finished, cancelled: cancelled })=>{
                const result2 = queue.get(handler);
                if (result2) {
                    if (!finished) result2.finished = false;
                    if (cancelled) result2.cancelled = true;
                } else queue.set(handler, {
                    value: null,
                    finished: finished || false,
                    cancelled: cancelled || false
                });
            };
            if (defaults2) defaults2[key] = props[key];
        }
    });
    const state = ctrl["_state"];
    if (props.pause === !state.paused) {
        state.paused = props.pause;
        (0, $bYU0b.flushCalls)(props.pause ? state.pauseQueue : state.resumeQueue);
    } else if (state.paused) props.pause = true;
    const promises = (keys || Object.keys(ctrl.springs)).map((key)=>ctrl.springs[key].start(props));
    const cancel = props.cancel === true || $cecbeabaf9cdcd78$var$getDefaultProp(props, "cancel") === true;
    if (asyncTo || cancel && state.asyncId) promises.push($cecbeabaf9cdcd78$var$scheduleProps(++ctrl["_lastAsyncId"], {
        props: props,
        state: state,
        actions: {
            pause: (0, $bYU0b.noop),
            resume: (0, $bYU0b.noop),
            start (props2, resolve) {
                if (cancel) {
                    $cecbeabaf9cdcd78$var$stopAsync(state, ctrl["_lastAsyncId"]);
                    resolve($cecbeabaf9cdcd78$var$getCancelledResult(ctrl));
                } else {
                    props2.onRest = onRest;
                    resolve($cecbeabaf9cdcd78$var$runAsync(asyncTo, props2, state, ctrl));
                }
            }
        }
    }));
    if (state.paused) await new Promise((resume)=>{
        state.resumeQueue.add(resume);
    });
    const result = $cecbeabaf9cdcd78$var$getCombinedResult(ctrl, await Promise.all(promises));
    if (loop && result.finished && !(isLoop && result.noop)) {
        const nextProps = $cecbeabaf9cdcd78$var$createLoopUpdate(props, loop, to2);
        if (nextProps) {
            $cecbeabaf9cdcd78$var$prepareKeys(ctrl, [
                nextProps
            ]);
            return $cecbeabaf9cdcd78$var$flushUpdate(ctrl, nextProps, true);
        }
    }
    if (onResolve) (0, $cSAm3.raf).batchedUpdates(()=>onResolve(result, ctrl, ctrl.item));
    return result;
}
function $cecbeabaf9cdcd78$var$getSprings(ctrl, props) {
    const springs = {
        ...ctrl.springs
    };
    if (props) (0, $bYU0b.each)((0, $bYU0b.toArray)(props), (props2)=>{
        if ((0, $bYU0b.is).und(props2.keys)) props2 = $cecbeabaf9cdcd78$var$createUpdate(props2);
        if (!(0, $bYU0b.is).obj(props2.to)) props2 = {
            ...props2,
            to: void 0
        };
        $cecbeabaf9cdcd78$var$prepareSprings(springs, props2, (key)=>{
            return $cecbeabaf9cdcd78$var$createSpring(key);
        });
    });
    $cecbeabaf9cdcd78$var$setSprings(ctrl, springs);
    return springs;
}
function $cecbeabaf9cdcd78$var$setSprings(ctrl, springs) {
    (0, $bYU0b.eachProp)(springs, (spring, key)=>{
        if (!ctrl.springs[key]) {
            ctrl.springs[key] = spring;
            (0, $bYU0b.addFluidObserver)(spring, ctrl);
        }
    });
}
function $cecbeabaf9cdcd78$var$createSpring(key, observer) {
    const spring = new $cecbeabaf9cdcd78$export$5854d13427d5a954();
    spring.key = key;
    if (observer) (0, $bYU0b.addFluidObserver)(spring, observer);
    return spring;
}
function $cecbeabaf9cdcd78$var$prepareSprings(springs, props, create) {
    if (props.keys) (0, $bYU0b.each)(props.keys, (key)=>{
        const spring = springs[key] || (springs[key] = create(key));
        spring["_prepareNode"](props);
    });
}
function $cecbeabaf9cdcd78$var$prepareKeys(ctrl, queue) {
    (0, $bYU0b.each)(queue, (props)=>{
        $cecbeabaf9cdcd78$var$prepareSprings(ctrl.springs, props, (key)=>{
            return $cecbeabaf9cdcd78$var$createSpring(key, ctrl);
        });
    });
}
var $cecbeabaf9cdcd78$export$f12a216ec50d2cf1 = ({ children: children, ...props })=>{
    const inherited = (0, $jbmdS.useContext)($cecbeabaf9cdcd78$var$ctx);
    const pause = props.pause || !!inherited.pause, immediate = props.immediate || !!inherited.immediate;
    props = (0, $bYU0b.useMemoOne)(()=>({
            pause: pause,
            immediate: immediate
        }), [
        pause,
        immediate
    ]);
    const { Provider: Provider } = $cecbeabaf9cdcd78$var$ctx;
    return /* @__PURE__ */ $jbmdS.createElement(Provider, {
        value: props
    }, children);
};
var $cecbeabaf9cdcd78$var$ctx = $cecbeabaf9cdcd78$var$makeContext($cecbeabaf9cdcd78$export$f12a216ec50d2cf1, {});
$cecbeabaf9cdcd78$export$f12a216ec50d2cf1.Provider = $cecbeabaf9cdcd78$var$ctx.Provider;
$cecbeabaf9cdcd78$export$f12a216ec50d2cf1.Consumer = $cecbeabaf9cdcd78$var$ctx.Consumer;
function $cecbeabaf9cdcd78$var$makeContext(target, init) {
    Object.assign(target, $jbmdS.createContext(init));
    target.Provider._context = target;
    target.Consumer._context = target;
    return target;
}
var $cecbeabaf9cdcd78$export$2471ae76e2946684 = ()=>{
    const current = [];
    const SpringRef2 = function(props) {
        (0, $bYU0b.deprecateDirectCall)();
        const results = [];
        (0, $bYU0b.each)(current, (ctrl, i)=>{
            if ((0, $bYU0b.is).und(props)) results.push(ctrl.start());
            else {
                const update2 = _getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.current = current;
    SpringRef2.add = function(ctrl) {
        if (!current.includes(ctrl)) current.push(ctrl);
    };
    SpringRef2.delete = function(ctrl) {
        const i = current.indexOf(ctrl);
        if (~i) current.splice(i, 1);
    };
    SpringRef2.pause = function() {
        (0, $bYU0b.each)(current, (ctrl)=>ctrl.pause(...arguments));
        return this;
    };
    SpringRef2.resume = function() {
        (0, $bYU0b.each)(current, (ctrl)=>ctrl.resume(...arguments));
        return this;
    };
    SpringRef2.set = function(values) {
        (0, $bYU0b.each)(current, (ctrl, i)=>{
            const update2 = (0, $bYU0b.is).fun(values) ? values(i, ctrl) : values;
            if (update2) ctrl.set(update2);
        });
    };
    SpringRef2.start = function(props) {
        const results = [];
        (0, $bYU0b.each)(current, (ctrl, i)=>{
            if ((0, $bYU0b.is).und(props)) results.push(ctrl.start());
            else {
                const update2 = this._getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.stop = function() {
        (0, $bYU0b.each)(current, (ctrl)=>ctrl.stop(...arguments));
        return this;
    };
    SpringRef2.update = function(props) {
        (0, $bYU0b.each)(current, (ctrl, i)=>ctrl.update(this._getProps(props, ctrl, i)));
        return this;
    };
    const _getProps = function(arg, ctrl, index) {
        return (0, $bYU0b.is).fun(arg) ? arg(index, ctrl) : arg;
    };
    SpringRef2._getProps = _getProps;
    return SpringRef2;
};
// src/hooks/useSprings.ts
function $cecbeabaf9cdcd78$export$15786d483ab9f469(length, props, deps) {
    const propsFn = (0, $bYU0b.is).fun(props) && props;
    if (propsFn && !deps) deps = [];
    const ref = (0, $jbmdS.useMemo)(()=>propsFn || arguments.length == 3 ? $cecbeabaf9cdcd78$export$2471ae76e2946684() : void 0, []);
    const layoutId = (0, $jbmdS.useRef)(0);
    const forceUpdate = (0, $bYU0b.useForceUpdate)();
    const state = (0, $jbmdS.useMemo)(()=>({
            ctrls: [],
            queue: [],
            flush (ctrl, updates2) {
                const springs2 = $cecbeabaf9cdcd78$var$getSprings(ctrl, updates2);
                const canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs2).some((key)=>!ctrl.springs[key]);
                return canFlushSync ? $cecbeabaf9cdcd78$var$flushUpdateQueue(ctrl, updates2) : new Promise((resolve)=>{
                    $cecbeabaf9cdcd78$var$setSprings(ctrl, springs2);
                    state.queue.push(()=>{
                        resolve($cecbeabaf9cdcd78$var$flushUpdateQueue(ctrl, updates2));
                    });
                    forceUpdate();
                });
            }
        }), []);
    const ctrls = (0, $jbmdS.useRef)([
        ...state.ctrls
    ]);
    const updates = [];
    const prevLength = (0, $bYU0b.usePrev)(length) || 0;
    (0, $jbmdS.useMemo)(()=>{
        (0, $bYU0b.each)(ctrls.current.slice(length, prevLength), (ctrl)=>{
            $cecbeabaf9cdcd78$var$detachRefs(ctrl, ref);
            ctrl.stop(true);
        });
        ctrls.current.length = length;
        declareUpdates(prevLength, length);
    }, [
        length
    ]);
    (0, $jbmdS.useMemo)(()=>{
        declareUpdates(0, Math.min(prevLength, length));
    }, deps);
    function declareUpdates(startIndex, endIndex) {
        for(let i = startIndex; i < endIndex; i++){
            const ctrl = ctrls.current[i] || (ctrls.current[i] = new $cecbeabaf9cdcd78$export$bd0bf19f25da8474(null, state.flush));
            const update2 = propsFn ? propsFn(i, ctrl) : props[i];
            if (update2) updates[i] = $cecbeabaf9cdcd78$var$declareUpdate(update2);
        }
    }
    const springs = ctrls.current.map((ctrl, i)=>$cecbeabaf9cdcd78$var$getSprings(ctrl, updates[i]));
    const context = (0, $jbmdS.useContext)($cecbeabaf9cdcd78$export$f12a216ec50d2cf1);
    const prevContext = (0, $bYU0b.usePrev)(context);
    const hasContext = context !== prevContext && $cecbeabaf9cdcd78$var$hasProps(context);
    (0, $bYU0b.useIsomorphicLayoutEffect)(()=>{
        layoutId.current++;
        state.ctrls = ctrls.current;
        const { queue: queue } = state;
        if (queue.length) {
            state.queue = [];
            (0, $bYU0b.each)(queue, (cb)=>cb());
        }
        (0, $bYU0b.each)(ctrls.current, (ctrl, i)=>{
            ref?.add(ctrl);
            if (hasContext) ctrl.start({
                default: context
            });
            const update2 = updates[i];
            if (update2) {
                $cecbeabaf9cdcd78$var$replaceRef(ctrl, update2.ref);
                if (ctrl.ref) ctrl.queue.push(update2);
                else ctrl.start(update2);
            }
        });
    });
    (0, $bYU0b.useOnce)(()=>()=>{
            (0, $bYU0b.each)(state.ctrls, (ctrl)=>ctrl.stop(true));
        });
    const values = springs.map((x)=>({
            ...x
        }));
    return ref ? [
        values,
        ref
    ] : values;
}
// src/hooks/useSpring.ts
function $cecbeabaf9cdcd78$export$c4af9125706c4d30(props, deps) {
    const isFn = (0, $bYU0b.is).fun(props);
    const [[values], ref] = $cecbeabaf9cdcd78$export$15786d483ab9f469(1, isFn ? props : [
        props
    ], isFn ? deps || [] : deps);
    return isFn || arguments.length == 2 ? [
        values,
        ref
    ] : values;
}
var $cecbeabaf9cdcd78$var$initSpringRef = ()=>$cecbeabaf9cdcd78$export$2471ae76e2946684();
var $cecbeabaf9cdcd78$export$564bff9c23cad2ca = ()=>(0, $jbmdS.useState)($cecbeabaf9cdcd78$var$initSpringRef)[0];
var $cecbeabaf9cdcd78$export$ab73804b080feffc = (initial, props)=>{
    const springValue = (0, $bYU0b.useConstant)(()=>new $cecbeabaf9cdcd78$export$5854d13427d5a954(initial, props));
    (0, $bYU0b.useOnce)(()=>()=>{
            springValue.stop();
        });
    return springValue;
};
function $cecbeabaf9cdcd78$export$250279104b4672ed(length, propsArg, deps) {
    const propsFn = (0, $bYU0b.is).fun(propsArg) && propsArg;
    if (propsFn && !deps) deps = [];
    let reverse = true;
    let passedRef = void 0;
    const result = $cecbeabaf9cdcd78$export$15786d483ab9f469(length, (i, ctrl)=>{
        const props = propsFn ? propsFn(i, ctrl) : propsArg;
        passedRef = props.ref;
        reverse = reverse && props.reverse;
        return props;
    }, // Ensure the props function is called when no deps exist.
    // This works around the 3 argument rule.
    deps || [
        {}
    ]);
    (0, $bYU0b.useIsomorphicLayoutEffect)(()=>{
        (0, $bYU0b.each)(result[1].current, (ctrl, i)=>{
            const parent = result[1].current[i + (reverse ? 1 : -1)];
            $cecbeabaf9cdcd78$var$replaceRef(ctrl, passedRef);
            if (ctrl.ref) {
                if (parent) ctrl.update({
                    to: parent.springs
                });
                return;
            }
            if (parent) ctrl.start({
                to: parent.springs
            });
            else ctrl.start();
        });
    }, deps);
    if (propsFn || arguments.length == 3) {
        const ref = passedRef ?? result[1];
        ref["_getProps"] = (propsArg2, ctrl, i)=>{
            const props = (0, $bYU0b.is).fun(propsArg2) ? propsArg2(i, ctrl) : propsArg2;
            if (props) {
                const parent = ref.current[i + (props.reverse ? 1 : -1)];
                if (parent) props.to = parent.springs;
                return props;
            }
        };
        return result;
    }
    return result[0];
}
function $cecbeabaf9cdcd78$export$7b286972b8d8ccbf(data, props, deps) {
    const propsFn = (0, $bYU0b.is).fun(props) && props;
    const { reset: reset, sort: sort, trail: trail = 0, expires: expires = true, exitBeforeEnter: exitBeforeEnter = false, onDestroyed: onDestroyed, ref: propsRef, config: propsConfig } = propsFn ? propsFn() : props;
    const ref = (0, $jbmdS.useMemo)(()=>propsFn || arguments.length == 3 ? $cecbeabaf9cdcd78$export$2471ae76e2946684() : void 0, []);
    const items = (0, $bYU0b.toArray)(data);
    const transitions = [];
    const usedTransitions = (0, $jbmdS.useRef)(null);
    const prevTransitions = reset ? null : usedTransitions.current;
    (0, $bYU0b.useIsomorphicLayoutEffect)(()=>{
        usedTransitions.current = transitions;
    });
    (0, $bYU0b.useOnce)(()=>{
        (0, $bYU0b.each)(transitions, (t)=>{
            ref?.add(t.ctrl);
            t.ctrl.ref = ref;
        });
        return ()=>{
            (0, $bYU0b.each)(usedTransitions.current, (t)=>{
                if (t.expired) clearTimeout(t.expirationId);
                $cecbeabaf9cdcd78$var$detachRefs(t.ctrl, ref);
                t.ctrl.stop(true);
            });
        };
    });
    const keys = $cecbeabaf9cdcd78$var$getKeys(items, propsFn ? propsFn() : props, prevTransitions);
    const expired = reset && usedTransitions.current || [];
    (0, $bYU0b.useIsomorphicLayoutEffect)(()=>(0, $bYU0b.each)(expired, ({ ctrl: ctrl, item: item, key: key })=>{
            $cecbeabaf9cdcd78$var$detachRefs(ctrl, ref);
            $cecbeabaf9cdcd78$var$callProp(onDestroyed, item, key);
        }));
    const reused = [];
    if (prevTransitions) (0, $bYU0b.each)(prevTransitions, (t, i)=>{
        if (t.expired) {
            clearTimeout(t.expirationId);
            expired.push(t);
        } else {
            i = reused[i] = keys.indexOf(t.key);
            if (~i) transitions[i] = t;
        }
    });
    (0, $bYU0b.each)(items, (item, i)=>{
        if (!transitions[i]) {
            transitions[i] = {
                key: keys[i],
                item: item,
                phase: "mount" /* MOUNT */ ,
                ctrl: new $cecbeabaf9cdcd78$export$bd0bf19f25da8474()
            };
            transitions[i].ctrl.item = item;
        }
    });
    if (reused.length) {
        let i = -1;
        const { leave: leave } = propsFn ? propsFn() : props;
        (0, $bYU0b.each)(reused, (keyIndex, prevIndex)=>{
            const t = prevTransitions[prevIndex];
            if (~keyIndex) {
                i = transitions.indexOf(t);
                transitions[i] = {
                    ...t,
                    item: items[keyIndex]
                };
            } else if (leave) transitions.splice(++i, 0, t);
        });
    }
    if ((0, $bYU0b.is).fun(sort)) transitions.sort((a, b)=>sort(a.item, b.item));
    let delay = -trail;
    const forceUpdate = (0, $bYU0b.useForceUpdate)();
    const defaultProps = $cecbeabaf9cdcd78$var$getDefaultProps(props);
    const changes = /* @__PURE__ */ new Map();
    const exitingTransitions = (0, $jbmdS.useRef)(/* @__PURE__ */ new Map());
    const forceChange = (0, $jbmdS.useRef)(false);
    (0, $bYU0b.each)(transitions, (t, i)=>{
        const key = t.key;
        const prevPhase = t.phase;
        const p = propsFn ? propsFn() : props;
        let to2;
        let phase;
        const propsDelay = $cecbeabaf9cdcd78$var$callProp(p.delay || 0, key);
        if (prevPhase == "mount" /* MOUNT */ ) {
            to2 = p.enter;
            phase = "enter" /* ENTER */ ;
        } else {
            const isLeave = keys.indexOf(key) < 0;
            if (prevPhase != "leave" /* LEAVE */ ) {
                if (isLeave) {
                    to2 = p.leave;
                    phase = "leave" /* LEAVE */ ;
                } else if (to2 = p.update) phase = "update" /* UPDATE */ ;
                else return;
            } else if (!isLeave) {
                to2 = p.enter;
                phase = "enter" /* ENTER */ ;
            } else return;
        }
        to2 = $cecbeabaf9cdcd78$var$callProp(to2, t.item, i);
        to2 = (0, $bYU0b.is).obj(to2) ? $cecbeabaf9cdcd78$export$b971039a739bf227(to2) : {
            to: to2
        };
        if (!to2.config) {
            const config2 = propsConfig || defaultProps.config;
            to2.config = $cecbeabaf9cdcd78$var$callProp(config2, t.item, i, phase);
        }
        delay += trail;
        const payload = {
            ...defaultProps,
            // we need to add our props.delay value you here.
            delay: propsDelay + delay,
            ref: propsRef,
            immediate: p.immediate,
            // This prevents implied resets.
            reset: false,
            // Merge any phase-specific props.
            ...to2
        };
        if (phase == "enter" /* ENTER */  && (0, $bYU0b.is).und(payload.from)) {
            const p2 = propsFn ? propsFn() : props;
            const from = (0, $bYU0b.is).und(p2.initial) || prevTransitions ? p2.from : p2.initial;
            payload.from = $cecbeabaf9cdcd78$var$callProp(from, t.item, i);
        }
        const { onResolve: onResolve } = payload;
        payload.onResolve = (result)=>{
            $cecbeabaf9cdcd78$var$callProp(onResolve, result);
            const transitions2 = usedTransitions.current;
            const t2 = transitions2.find((t3)=>t3.key === key);
            if (!t2) return;
            if (result.cancelled && t2.phase != "update" /* UPDATE */ ) return;
            if (t2.ctrl.idle) {
                const idle = transitions2.every((t3)=>t3.ctrl.idle);
                if (t2.phase == "leave" /* LEAVE */ ) {
                    const expiry = $cecbeabaf9cdcd78$var$callProp(expires, t2.item);
                    if (expiry !== false) {
                        const expiryMs = expiry === true ? 0 : expiry;
                        t2.expired = true;
                        if (!idle && expiryMs > 0) {
                            if (expiryMs <= 2147483647) t2.expirationId = setTimeout(forceUpdate, expiryMs);
                            return;
                        }
                    }
                }
                if (idle && transitions2.some((t3)=>t3.expired)) {
                    exitingTransitions.current.delete(t2);
                    if (exitBeforeEnter) forceChange.current = true;
                    forceUpdate();
                }
            }
        };
        const springs = $cecbeabaf9cdcd78$var$getSprings(t.ctrl, payload);
        if (phase === "leave" /* LEAVE */  && exitBeforeEnter) exitingTransitions.current.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
        else changes.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
    });
    const context = (0, $jbmdS.useContext)($cecbeabaf9cdcd78$export$f12a216ec50d2cf1);
    const prevContext = (0, $bYU0b.usePrev)(context);
    const hasContext = context !== prevContext && $cecbeabaf9cdcd78$var$hasProps(context);
    (0, $bYU0b.useIsomorphicLayoutEffect)(()=>{
        if (hasContext) (0, $bYU0b.each)(transitions, (t)=>{
            t.ctrl.start({
                default: context
            });
        });
    }, [
        context
    ]);
    (0, $bYU0b.each)(changes, (_, t)=>{
        if (exitingTransitions.current.size) {
            const ind = transitions.findIndex((state)=>state.key === t.key);
            transitions.splice(ind, 1);
        }
    });
    (0, $bYU0b.useIsomorphicLayoutEffect)(()=>{
        (0, $bYU0b.each)(exitingTransitions.current.size ? exitingTransitions.current : changes, ({ phase: phase, payload: payload }, t)=>{
            const { ctrl: ctrl } = t;
            t.phase = phase;
            ref?.add(ctrl);
            if (hasContext && phase == "enter" /* ENTER */ ) ctrl.start({
                default: context
            });
            if (payload) {
                $cecbeabaf9cdcd78$var$replaceRef(ctrl, payload.ref);
                if ((ctrl.ref || ref) && !forceChange.current) ctrl.update(payload);
                else {
                    ctrl.start(payload);
                    if (forceChange.current) forceChange.current = false;
                }
            }
        });
    }, reset ? void 0 : deps);
    const renderTransitions = (render)=>/* @__PURE__ */ $jbmdS.createElement($jbmdS.Fragment, null, transitions.map((t, i)=>{
            const { springs: springs } = changes.get(t) || t.ctrl;
            const elem = render({
                ...springs
            }, t.item, t, i);
            return elem && elem.type ? /* @__PURE__ */ $jbmdS.createElement(elem.type, {
                ...elem.props,
                key: (0, $bYU0b.is).str(t.key) || (0, $bYU0b.is).num(t.key) ? t.key : t.ctrl.id,
                ref: elem.ref
            }) : elem;
        }));
    return ref ? [
        renderTransitions,
        ref
    ] : renderTransitions;
}
var $cecbeabaf9cdcd78$var$nextKey = 1;
function $cecbeabaf9cdcd78$var$getKeys(items, { key: key, keys: keys = key }, prevTransitions) {
    if (keys === null) {
        const reused = /* @__PURE__ */ new Set();
        return items.map((item)=>{
            const t = prevTransitions && prevTransitions.find((t2)=>t2.item === item && t2.phase !== "leave" /* LEAVE */  && !reused.has(t2));
            if (t) {
                reused.add(t);
                return t.key;
            }
            return $cecbeabaf9cdcd78$var$nextKey++;
        });
    }
    return (0, $bYU0b.is).und(keys) ? items : (0, $bYU0b.is).fun(keys) ? items.map(keys) : (0, $bYU0b.toArray)(keys);
}
var $cecbeabaf9cdcd78$export$d928051c8cd740b = ({ container: container, ...springOptions } = {})=>{
    const [scrollValues, api] = $cecbeabaf9cdcd78$export$c4af9125706c4d30(()=>({
            scrollX: 0,
            scrollY: 0,
            scrollXProgress: 0,
            scrollYProgress: 0,
            ...springOptions
        }), []);
    (0, $bYU0b.useIsomorphicLayoutEffect)(()=>{
        const cleanupScroll = (0, $bYU0b.onScroll)(({ x: x, y: y })=>{
            api.start({
                scrollX: x.current,
                scrollXProgress: x.progress,
                scrollY: y.current,
                scrollYProgress: y.progress
            });
        }, {
            container: container?.current || void 0
        });
        return ()=>{
            (0, $bYU0b.each)(Object.values(scrollValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return scrollValues;
};
var $cecbeabaf9cdcd78$export$e8b771555dc4a003 = ({ container: container, ...springOptions })=>{
    const [sizeValues, api] = $cecbeabaf9cdcd78$export$c4af9125706c4d30(()=>({
            width: 0,
            height: 0,
            ...springOptions
        }), []);
    (0, $bYU0b.useIsomorphicLayoutEffect)(()=>{
        const cleanupScroll = (0, $bYU0b.onResize)(({ width: width, height: height })=>{
            api.start({
                width: width,
                height: height,
                immediate: sizeValues.width.get() === 0 || sizeValues.height.get() === 0
            });
        }, {
            container: container?.current || void 0
        });
        return ()=>{
            (0, $bYU0b.each)(Object.values(sizeValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return sizeValues;
};
var $cecbeabaf9cdcd78$var$defaultThresholdOptions = {
    any: 0,
    all: 1
};
function $cecbeabaf9cdcd78$export$2f62ee6831462844(props, args) {
    const [isInView, setIsInView] = (0, $jbmdS.useState)(false);
    const ref = (0, $jbmdS.useRef)();
    const propsFn = (0, $bYU0b.is).fun(props) && props;
    const springsProps = propsFn ? propsFn() : {};
    const { to: to2 = {}, from: from = {}, ...restSpringProps } = springsProps;
    const intersectionArguments = propsFn ? args : props;
    const [springs, api] = $cecbeabaf9cdcd78$export$c4af9125706c4d30(()=>({
            from: from,
            ...restSpringProps
        }), []);
    (0, $bYU0b.useIsomorphicLayoutEffect)(()=>{
        const element = ref.current;
        const { root: root, once: once, amount: amount = "any", ...restArgs } = intersectionArguments ?? {};
        if (!element || once && isInView || typeof IntersectionObserver === "undefined") return;
        const activeIntersections = /* @__PURE__ */ new WeakMap();
        const onEnter = ()=>{
            if (to2) api.start(to2);
            setIsInView(true);
            const cleanup = ()=>{
                if (from) api.start(from);
                setIsInView(false);
            };
            return once ? void 0 : cleanup;
        };
        const handleIntersection = (entries)=>{
            entries.forEach((entry)=>{
                const onLeave = activeIntersections.get(entry.target);
                if (entry.isIntersecting === Boolean(onLeave)) return;
                if (entry.isIntersecting) {
                    const newOnLeave = onEnter();
                    if ((0, $bYU0b.is).fun(newOnLeave)) activeIntersections.set(entry.target, newOnLeave);
                    else observer.unobserve(entry.target);
                } else if (onLeave) {
                    onLeave();
                    activeIntersections.delete(entry.target);
                }
            });
        };
        const observer = new IntersectionObserver(handleIntersection, {
            root: root && root.current || void 0,
            threshold: typeof amount === "number" || Array.isArray(amount) ? amount : $cecbeabaf9cdcd78$var$defaultThresholdOptions[amount],
            ...restArgs
        });
        observer.observe(element);
        return ()=>observer.unobserve(element);
    }, [
        intersectionArguments
    ]);
    if (propsFn) return [
        ref,
        springs
    ];
    return [
        ref,
        isInView
    ];
}
// src/components/Spring.tsx
function $cecbeabaf9cdcd78$export$a500e5b516cedfc({ children: children, ...props }) {
    return children($cecbeabaf9cdcd78$export$c4af9125706c4d30(props));
}
function $cecbeabaf9cdcd78$export$3b8b9d47fbf8fd2b({ items: items, children: children, ...props }) {
    const trails = $cecbeabaf9cdcd78$export$250279104b4672ed(items.length, props);
    return items.map((item, index)=>{
        const result = children(item, index);
        return (0, $bYU0b.is).fun(result) ? result(trails[index]) : result;
    });
}
// src/components/Transition.tsx
function $cecbeabaf9cdcd78$export$be58926105124dd4({ items: items, children: children, ...props }) {
    return $cecbeabaf9cdcd78$export$7b286972b8d8ccbf(items, props)(children);
}
var $cecbeabaf9cdcd78$export$b0cc4f9860136880 = class extends $cecbeabaf9cdcd78$export$8229896f80e2495e {
    constructor(source, args){
        super();
        this.source = source;
        /** Equals false when in the frameloop */ this.idle = true;
        /** The inputs which are currently animating */ this._active = /* @__PURE__ */ new Set();
        this.calc = (0, $bYU0b.createInterpolator)(...args);
        const value = this._get();
        const nodeType = (0, $b7bYo.getAnimatedType)(value);
        (0, $b7bYo.setAnimated)(this, nodeType.create(value));
    }
    advance(_dt) {
        const value = this._get();
        const oldValue = this.get();
        if (!(0, $bYU0b.isEqual)(value, oldValue)) {
            (0, $b7bYo.getAnimated)(this).setValue(value);
            this._onChange(value, this.idle);
        }
        if (!this.idle && $cecbeabaf9cdcd78$var$checkIdle(this._active)) $cecbeabaf9cdcd78$var$becomeIdle(this);
    }
    _get() {
        const inputs = (0, $bYU0b.is).arr(this.source) ? this.source.map((0, $bYU0b.getFluidValue)) : (0, $bYU0b.toArray)((0, $bYU0b.getFluidValue)(this.source));
        return this.calc(...inputs);
    }
    _start() {
        if (this.idle && !$cecbeabaf9cdcd78$var$checkIdle(this._active)) {
            this.idle = false;
            (0, $bYU0b.each)((0, $b7bYo.getPayload)(this), (node)=>{
                node.done = false;
            });
            if ((0, $bYU0b.Globals).skipAnimation) {
                (0, $cSAm3.raf).batchedUpdates(()=>this.advance());
                $cecbeabaf9cdcd78$var$becomeIdle(this);
            } else (0, $bYU0b.frameLoop).start(this);
        }
    }
    // Observe our sources only when we're observed.
    _attach() {
        let priority = 1;
        (0, $bYU0b.each)((0, $bYU0b.toArray)(this.source), (source)=>{
            if ((0, $bYU0b.hasFluidValue)(source)) (0, $bYU0b.addFluidObserver)(source, this);
            if ($cecbeabaf9cdcd78$var$isFrameValue(source)) {
                if (!source.idle) this._active.add(source);
                priority = Math.max(priority, source.priority + 1);
            }
        });
        this.priority = priority;
        this._start();
    }
    // Stop observing our sources once we have no observers.
    _detach() {
        (0, $bYU0b.each)((0, $bYU0b.toArray)(this.source), (source)=>{
            if ((0, $bYU0b.hasFluidValue)(source)) (0, $bYU0b.removeFluidObserver)(source, this);
        });
        this._active.clear();
        $cecbeabaf9cdcd78$var$becomeIdle(this);
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            if (event.idle) this.advance();
            else {
                this._active.add(event.parent);
                this._start();
            }
        } else if (event.type == "idle") this._active.delete(event.parent);
        else if (event.type == "priority") this.priority = (0, $bYU0b.toArray)(this.source).reduce((highest, parent)=>Math.max(highest, ($cecbeabaf9cdcd78$var$isFrameValue(parent) ? parent.priority : 0) + 1), 0);
    }
};
function $cecbeabaf9cdcd78$var$isIdle(source) {
    return source.idle !== false;
}
function $cecbeabaf9cdcd78$var$checkIdle(active) {
    return !active.size || Array.from(active).every($cecbeabaf9cdcd78$var$isIdle);
}
function $cecbeabaf9cdcd78$var$becomeIdle(self) {
    if (!self.idle) {
        self.idle = true;
        (0, $bYU0b.each)((0, $b7bYo.getPayload)(self), (node)=>{
            node.done = true;
        });
        (0, $bYU0b.callFluidObservers)(self, {
            type: "idle",
            parent: self
        });
    }
}
// src/interpolate.ts
var $cecbeabaf9cdcd78$export$2c618a4308a30424 = (source, ...args)=>new $cecbeabaf9cdcd78$export$b0cc4f9860136880(source, args);
var $cecbeabaf9cdcd78$export$89e29e4ab65e70a9 = (source, ...args)=>((0, $bYU0b.deprecateInterpolate)(), new $cecbeabaf9cdcd78$export$b0cc4f9860136880(source, args));
(0, $bYU0b.Globals).assign({
    createStringInterpolator: $bYU0b.createStringInterpolator,
    to: (source, args)=>new $cecbeabaf9cdcd78$export$b0cc4f9860136880(source, args)
});
var $cecbeabaf9cdcd78$export$722fbec263ad908a = (0, $bYU0b.frameLoop).advance;

});
parcelRegister("bYU0b", function(module, exports) {

$parcel$export(module.exports, "Globals", function () { return $8b90bd1c690cacf0$export$cceeabf822b64fc0; });
$parcel$export(module.exports, "noop", function () { return $8b90bd1c690cacf0$export$8793edee2d425525; });
$parcel$export(module.exports, "defineHidden", function () { return $8b90bd1c690cacf0$export$5c74248ea0e35446; });
$parcel$export(module.exports, "is", function () { return $8b90bd1c690cacf0$export$226b3eccf92c9ed9; });
$parcel$export(module.exports, "isEqual", function () { return $8b90bd1c690cacf0$export$248d38f6296296c5; });
$parcel$export(module.exports, "each", function () { return $8b90bd1c690cacf0$export$79b2f7037acddd43; });
$parcel$export(module.exports, "eachProp", function () { return $8b90bd1c690cacf0$export$f4c6fe153f5a944e; });
$parcel$export(module.exports, "toArray", function () { return $8b90bd1c690cacf0$export$45b10814cc054894; });
$parcel$export(module.exports, "flush", function () { return $8b90bd1c690cacf0$export$4909b86c8034bf73; });
$parcel$export(module.exports, "flushCalls", function () { return $8b90bd1c690cacf0$export$7ba486852759e806; });
$parcel$export(module.exports, "frameLoop", function () { return $8b90bd1c690cacf0$export$a57f5080a3bcc90a; });
$parcel$export(module.exports, "colors", function () { return $8b90bd1c690cacf0$export$8f45430ccf837300; });
$parcel$export(module.exports, "createInterpolator", function () { return $8b90bd1c690cacf0$export$b12af43b97697ef5; });
$parcel$export(module.exports, "easings", function () { return $8b90bd1c690cacf0$export$15a0bf1b4bbacad8; });
$parcel$export(module.exports, "hasFluidValue", function () { return $8b90bd1c690cacf0$export$57ea7e3a7f6280c7; });
$parcel$export(module.exports, "getFluidValue", function () { return $8b90bd1c690cacf0$export$e37b7520edd66839; });
$parcel$export(module.exports, "getFluidObservers", function () { return $8b90bd1c690cacf0$export$133f54e9f7cf1796; });
$parcel$export(module.exports, "callFluidObservers", function () { return $8b90bd1c690cacf0$export$31752c40a5fab62a; });
$parcel$export(module.exports, "FluidValue", function () { return $8b90bd1c690cacf0$export$aff8e1ac1a016a2; });
$parcel$export(module.exports, "addFluidObserver", function () { return $8b90bd1c690cacf0$export$72d604e3f8d000a5; });
$parcel$export(module.exports, "removeFluidObserver", function () { return $8b90bd1c690cacf0$export$7a0eb830d336339b; });
$parcel$export(module.exports, "createStringInterpolator", function () { return $8b90bd1c690cacf0$export$4759a013d387347a; });
$parcel$export(module.exports, "deprecateInterpolate", function () { return $8b90bd1c690cacf0$export$2abfcde8ae218ba8; });
$parcel$export(module.exports, "deprecateDirectCall", function () { return $8b90bd1c690cacf0$export$d99d974913ad3b12; });
$parcel$export(module.exports, "isAnimatedString", function () { return $8b90bd1c690cacf0$export$75bed621f62abfa9; });
$parcel$export(module.exports, "onResize", function () { return $8b90bd1c690cacf0$export$45b39e67d4ce4921; });
$parcel$export(module.exports, "onScroll", function () { return $8b90bd1c690cacf0$export$d4d89fd61e5416ee; });
$parcel$export(module.exports, "useConstant", function () { return $8b90bd1c690cacf0$export$fe4300aa8eebea86; });
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $8b90bd1c690cacf0$export$700979bc83e7db82; });
$parcel$export(module.exports, "useForceUpdate", function () { return $8b90bd1c690cacf0$export$91db9bc4f8ac944a; });
$parcel$export(module.exports, "useMemoOne", function () { return $8b90bd1c690cacf0$export$b6feb8998cd9b342; });
$parcel$export(module.exports, "useOnce", function () { return $8b90bd1c690cacf0$export$392544347a18b6ea; });
$parcel$export(module.exports, "usePrev", function () { return $8b90bd1c690cacf0$export$ef7ad0c4e19d7fbf; });
$parcel$export(module.exports, "raf", function () { return (parcelRequire("cSAm3")).raf; });

var $cSAm3 = parcelRequire("cSAm3");

var $jbmdS = parcelRequire("jbmdS");
var $8b90bd1c690cacf0$var$__defProp = Object.defineProperty;
var $8b90bd1c690cacf0$var$__export = (target, all)=>{
    for(var name in all)$8b90bd1c690cacf0$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
// src/globals.ts
var $8b90bd1c690cacf0$export$cceeabf822b64fc0 = {};
$8b90bd1c690cacf0$var$__export($8b90bd1c690cacf0$export$cceeabf822b64fc0, {
    assign: ()=>$8b90bd1c690cacf0$var$assign,
    colors: ()=>$8b90bd1c690cacf0$var$colors,
    createStringInterpolator: ()=>$8b90bd1c690cacf0$var$createStringInterpolator,
    skipAnimation: ()=>$8b90bd1c690cacf0$var$skipAnimation,
    to: ()=>$8b90bd1c690cacf0$var$to,
    willAdvance: ()=>$8b90bd1c690cacf0$var$willAdvance
});
// src/helpers.ts
function $8b90bd1c690cacf0$export$8793edee2d425525() {}
var $8b90bd1c690cacf0$export$5c74248ea0e35446 = (obj, key, value)=>Object.defineProperty(obj, key, {
        value: value,
        writable: true,
        configurable: true
    });
var $8b90bd1c690cacf0$export$226b3eccf92c9ed9 = {
    arr: Array.isArray,
    obj: (a)=>!!a && a.constructor.name === "Object",
    fun: (a)=>typeof a === "function",
    str: (a)=>typeof a === "string",
    num: (a)=>typeof a === "number",
    und: (a)=>a === void 0
};
function $8b90bd1c690cacf0$export$248d38f6296296c5(a, b) {
    if ($8b90bd1c690cacf0$export$226b3eccf92c9ed9.arr(a)) {
        if (!$8b90bd1c690cacf0$export$226b3eccf92c9ed9.arr(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    return a === b;
}
var $8b90bd1c690cacf0$export$79b2f7037acddd43 = (obj, fn)=>obj.forEach(fn);
function $8b90bd1c690cacf0$export$f4c6fe153f5a944e(obj, fn, ctx) {
    if ($8b90bd1c690cacf0$export$226b3eccf92c9ed9.arr(obj)) {
        for(let i = 0; i < obj.length; i++)fn.call(ctx, obj[i], `${i}`);
        return;
    }
    for(const key in obj)if (obj.hasOwnProperty(key)) fn.call(ctx, obj[key], key);
}
var $8b90bd1c690cacf0$export$45b10814cc054894 = (a)=>$8b90bd1c690cacf0$export$226b3eccf92c9ed9.und(a) ? [] : $8b90bd1c690cacf0$export$226b3eccf92c9ed9.arr(a) ? a : [
        a
    ];
function $8b90bd1c690cacf0$export$4909b86c8034bf73(queue, iterator) {
    if (queue.size) {
        const items = Array.from(queue);
        queue.clear();
        $8b90bd1c690cacf0$export$79b2f7037acddd43(items, iterator);
    }
}
var $8b90bd1c690cacf0$export$7ba486852759e806 = (queue, ...args)=>$8b90bd1c690cacf0$export$4909b86c8034bf73(queue, (fn)=>fn(...args));
var $8b90bd1c690cacf0$export$48d7c418edadb60c = ()=>typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
// src/globals.ts
var $8b90bd1c690cacf0$var$createStringInterpolator;
var $8b90bd1c690cacf0$var$to;
var $8b90bd1c690cacf0$var$colors = null;
var $8b90bd1c690cacf0$var$skipAnimation = false;
var $8b90bd1c690cacf0$var$willAdvance = $8b90bd1c690cacf0$export$8793edee2d425525;
var $8b90bd1c690cacf0$var$assign = (globals)=>{
    if (globals.to) $8b90bd1c690cacf0$var$to = globals.to;
    if (globals.now) (0, $cSAm3.raf).now = globals.now;
    if (globals.colors !== void 0) $8b90bd1c690cacf0$var$colors = globals.colors;
    if (globals.skipAnimation != null) $8b90bd1c690cacf0$var$skipAnimation = globals.skipAnimation;
    if (globals.createStringInterpolator) $8b90bd1c690cacf0$var$createStringInterpolator = globals.createStringInterpolator;
    if (globals.requestAnimationFrame) (0, $cSAm3.raf).use(globals.requestAnimationFrame);
    if (globals.batchedUpdates) (0, $cSAm3.raf).batchedUpdates = globals.batchedUpdates;
    if (globals.willAdvance) $8b90bd1c690cacf0$var$willAdvance = globals.willAdvance;
    if (globals.frameLoop) (0, $cSAm3.raf).frameLoop = globals.frameLoop;
};
var $8b90bd1c690cacf0$var$startQueue = /* @__PURE__ */ new Set();
var $8b90bd1c690cacf0$var$currentFrame = [];
var $8b90bd1c690cacf0$var$prevFrame = [];
var $8b90bd1c690cacf0$var$priority = 0;
var $8b90bd1c690cacf0$export$a57f5080a3bcc90a = {
    get idle () {
        return !$8b90bd1c690cacf0$var$startQueue.size && !$8b90bd1c690cacf0$var$currentFrame.length;
    },
    /** Advance the given animation on every frame until idle. */ start (animation) {
        if ($8b90bd1c690cacf0$var$priority > animation.priority) {
            $8b90bd1c690cacf0$var$startQueue.add(animation);
            (0, $cSAm3.raf).onStart($8b90bd1c690cacf0$var$flushStartQueue);
        } else {
            $8b90bd1c690cacf0$var$startSafely(animation);
            (0, $cSAm3.raf)($8b90bd1c690cacf0$var$advance);
        }
    },
    advance: /** Advance all animations by the given time. */ $8b90bd1c690cacf0$var$advance,
    /** Call this when an animation's priority changes. */ sort (animation) {
        if ($8b90bd1c690cacf0$var$priority) (0, $cSAm3.raf).onFrame(()=>$8b90bd1c690cacf0$export$a57f5080a3bcc90a.sort(animation));
        else {
            const prevIndex = $8b90bd1c690cacf0$var$currentFrame.indexOf(animation);
            if (~prevIndex) {
                $8b90bd1c690cacf0$var$currentFrame.splice(prevIndex, 1);
                $8b90bd1c690cacf0$var$startUnsafely(animation);
            }
        }
    },
    /**
   * Clear all animations. For testing purposes.
   *
   * ☠️ Never call this from within the frameloop.
   */ clear () {
        $8b90bd1c690cacf0$var$currentFrame = [];
        $8b90bd1c690cacf0$var$startQueue.clear();
    }
};
function $8b90bd1c690cacf0$var$flushStartQueue() {
    $8b90bd1c690cacf0$var$startQueue.forEach($8b90bd1c690cacf0$var$startSafely);
    $8b90bd1c690cacf0$var$startQueue.clear();
    (0, $cSAm3.raf)($8b90bd1c690cacf0$var$advance);
}
function $8b90bd1c690cacf0$var$startSafely(animation) {
    if (!$8b90bd1c690cacf0$var$currentFrame.includes(animation)) $8b90bd1c690cacf0$var$startUnsafely(animation);
}
function $8b90bd1c690cacf0$var$startUnsafely(animation) {
    $8b90bd1c690cacf0$var$currentFrame.splice($8b90bd1c690cacf0$var$findIndex($8b90bd1c690cacf0$var$currentFrame, (other)=>other.priority > animation.priority), 0, animation);
}
function $8b90bd1c690cacf0$var$advance(dt) {
    const nextFrame = $8b90bd1c690cacf0$var$prevFrame;
    for(let i = 0; i < $8b90bd1c690cacf0$var$currentFrame.length; i++){
        const animation = $8b90bd1c690cacf0$var$currentFrame[i];
        $8b90bd1c690cacf0$var$priority = animation.priority;
        if (!animation.idle) {
            $8b90bd1c690cacf0$var$willAdvance(animation);
            animation.advance(dt);
            if (!animation.idle) nextFrame.push(animation);
        }
    }
    $8b90bd1c690cacf0$var$priority = 0;
    $8b90bd1c690cacf0$var$prevFrame = $8b90bd1c690cacf0$var$currentFrame;
    $8b90bd1c690cacf0$var$prevFrame.length = 0;
    $8b90bd1c690cacf0$var$currentFrame = nextFrame;
    return $8b90bd1c690cacf0$var$currentFrame.length > 0;
}
function $8b90bd1c690cacf0$var$findIndex(arr, test) {
    const index = arr.findIndex(test);
    return index < 0 ? arr.length : index;
}
// src/clamp.ts
var $8b90bd1c690cacf0$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);
// src/colors.ts
var $8b90bd1c690cacf0$export$8f45430ccf837300 = {
    transparent: 0,
    aliceblue: 4042850303,
    antiquewhite: 4209760255,
    aqua: 16777215,
    aquamarine: 2147472639,
    azure: 4043309055,
    beige: 4126530815,
    bisque: 4293182719,
    black: 255,
    blanchedalmond: 4293643775,
    blue: 65535,
    blueviolet: 2318131967,
    brown: 2771004159,
    burlywood: 3736635391,
    burntsienna: 3934150143,
    cadetblue: 1604231423,
    chartreuse: 2147418367,
    chocolate: 3530104575,
    coral: 4286533887,
    cornflowerblue: 1687547391,
    cornsilk: 4294499583,
    crimson: 3692313855,
    cyan: 16777215,
    darkblue: 35839,
    darkcyan: 9145343,
    darkgoldenrod: 3095792639,
    darkgray: 2846468607,
    darkgreen: 6553855,
    darkgrey: 2846468607,
    darkkhaki: 3182914559,
    darkmagenta: 2332068863,
    darkolivegreen: 1433087999,
    darkorange: 4287365375,
    darkorchid: 2570243327,
    darkred: 2332033279,
    darksalmon: 3918953215,
    darkseagreen: 2411499519,
    darkslateblue: 1211993087,
    darkslategray: 793726975,
    darkslategrey: 793726975,
    darkturquoise: 13554175,
    darkviolet: 2483082239,
    deeppink: 4279538687,
    deepskyblue: 12582911,
    dimgray: 1768516095,
    dimgrey: 1768516095,
    dodgerblue: 512819199,
    firebrick: 2988581631,
    floralwhite: 4294635775,
    forestgreen: 579543807,
    fuchsia: 4278255615,
    gainsboro: 3705462015,
    ghostwhite: 4177068031,
    gold: 4292280575,
    goldenrod: 3668254975,
    gray: 2155905279,
    green: 8388863,
    greenyellow: 2919182335,
    grey: 2155905279,
    honeydew: 4043305215,
    hotpink: 4285117695,
    indianred: 3445382399,
    indigo: 1258324735,
    ivory: 4294963455,
    khaki: 4041641215,
    lavender: 3873897215,
    lavenderblush: 4293981695,
    lawngreen: 2096890111,
    lemonchiffon: 4294626815,
    lightblue: 2916673279,
    lightcoral: 4034953471,
    lightcyan: 3774873599,
    lightgoldenrodyellow: 4210742015,
    lightgray: 3553874943,
    lightgreen: 2431553791,
    lightgrey: 3553874943,
    lightpink: 4290167295,
    lightsalmon: 4288707327,
    lightseagreen: 548580095,
    lightskyblue: 2278488831,
    lightslategray: 2005441023,
    lightslategrey: 2005441023,
    lightsteelblue: 2965692159,
    lightyellow: 4294959359,
    lime: 16711935,
    limegreen: 852308735,
    linen: 4210091775,
    magenta: 4278255615,
    maroon: 2147483903,
    mediumaquamarine: 1724754687,
    mediumblue: 52735,
    mediumorchid: 3126187007,
    mediumpurple: 2473647103,
    mediumseagreen: 1018393087,
    mediumslateblue: 2070474495,
    mediumspringgreen: 16423679,
    mediumturquoise: 1221709055,
    mediumvioletred: 3340076543,
    midnightblue: 421097727,
    mintcream: 4127193855,
    mistyrose: 4293190143,
    moccasin: 4293178879,
    navajowhite: 4292783615,
    navy: 33023,
    oldlace: 4260751103,
    olive: 2155872511,
    olivedrab: 1804477439,
    orange: 4289003775,
    orangered: 4282712319,
    orchid: 3664828159,
    palegoldenrod: 4008225535,
    palegreen: 2566625535,
    paleturquoise: 2951671551,
    palevioletred: 3681588223,
    papayawhip: 4293907967,
    peachpuff: 4292524543,
    peru: 3448061951,
    pink: 4290825215,
    plum: 3718307327,
    powderblue: 2967529215,
    purple: 2147516671,
    rebeccapurple: 1714657791,
    red: 4278190335,
    rosybrown: 3163525119,
    royalblue: 1097458175,
    saddlebrown: 2336560127,
    salmon: 4202722047,
    sandybrown: 4104413439,
    seagreen: 780883967,
    seashell: 4294307583,
    sienna: 2689740287,
    silver: 3233857791,
    skyblue: 2278484991,
    slateblue: 1784335871,
    slategray: 1887473919,
    slategrey: 1887473919,
    snow: 4294638335,
    springgreen: 16744447,
    steelblue: 1182971135,
    tan: 3535047935,
    teal: 8421631,
    thistle: 3636451583,
    tomato: 4284696575,
    turquoise: 1088475391,
    violet: 4001558271,
    wheat: 4125012991,
    white: 4294967295,
    whitesmoke: 4126537215,
    yellow: 4294902015,
    yellowgreen: 2597139199
};
// src/colorMatchers.ts
var $8b90bd1c690cacf0$var$NUMBER = "[-+]?\\d*\\.?\\d+";
var $8b90bd1c690cacf0$var$PERCENTAGE = $8b90bd1c690cacf0$var$NUMBER + "%";
function $8b90bd1c690cacf0$var$call(...parts) {
    return "\\(\\s*(" + parts.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var $8b90bd1c690cacf0$export$8972dc0e6ad9238f = new RegExp("rgb" + $8b90bd1c690cacf0$var$call($8b90bd1c690cacf0$var$NUMBER, $8b90bd1c690cacf0$var$NUMBER, $8b90bd1c690cacf0$var$NUMBER));
var $8b90bd1c690cacf0$export$4e46ac54fc82cf3b = new RegExp("rgba" + $8b90bd1c690cacf0$var$call($8b90bd1c690cacf0$var$NUMBER, $8b90bd1c690cacf0$var$NUMBER, $8b90bd1c690cacf0$var$NUMBER, $8b90bd1c690cacf0$var$NUMBER));
var $8b90bd1c690cacf0$export$8f4a7c0bb78e6ea8 = new RegExp("hsl" + $8b90bd1c690cacf0$var$call($8b90bd1c690cacf0$var$NUMBER, $8b90bd1c690cacf0$var$PERCENTAGE, $8b90bd1c690cacf0$var$PERCENTAGE));
var $8b90bd1c690cacf0$export$810b04175080204c = new RegExp("hsla" + $8b90bd1c690cacf0$var$call($8b90bd1c690cacf0$var$NUMBER, $8b90bd1c690cacf0$var$PERCENTAGE, $8b90bd1c690cacf0$var$PERCENTAGE, $8b90bd1c690cacf0$var$NUMBER));
var $8b90bd1c690cacf0$export$a99b93d698493da5 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $8b90bd1c690cacf0$export$4573e032242724d8 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $8b90bd1c690cacf0$export$86e51e8f361b966e = /^#([0-9a-fA-F]{6})$/;
var $8b90bd1c690cacf0$export$a09ec12fb14c61c4 = /^#([0-9a-fA-F]{8})$/;
// src/normalizeColor.ts
function $8b90bd1c690cacf0$var$normalizeColor(color) {
    let match;
    if (typeof color === "number") return color >>> 0 === color && color >= 0 && color <= 4294967295 ? color : null;
    if (match = $8b90bd1c690cacf0$export$86e51e8f361b966e.exec(color)) return parseInt(match[1] + "ff", 16) >>> 0;
    if ($8b90bd1c690cacf0$var$colors && $8b90bd1c690cacf0$var$colors[color] !== void 0) return $8b90bd1c690cacf0$var$colors[color];
    if (match = $8b90bd1c690cacf0$export$8972dc0e6ad9238f.exec(color)) return ($8b90bd1c690cacf0$var$parse255(match[1]) << 24 | // r
    $8b90bd1c690cacf0$var$parse255(match[2]) << 16 | // g
    $8b90bd1c690cacf0$var$parse255(match[3]) << 8 | // b
    255) >>> // a
    0;
    if (match = $8b90bd1c690cacf0$export$4e46ac54fc82cf3b.exec(color)) return ($8b90bd1c690cacf0$var$parse255(match[1]) << 24 | // r
    $8b90bd1c690cacf0$var$parse255(match[2]) << 16 | // g
    $8b90bd1c690cacf0$var$parse255(match[3]) << 8 | // b
    $8b90bd1c690cacf0$var$parse1(match[4])) >>> // a
    0;
    if (match = $8b90bd1c690cacf0$export$a99b93d698493da5.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    "ff", // a
    16) >>> 0;
    if (match = $8b90bd1c690cacf0$export$a09ec12fb14c61c4.exec(color)) return parseInt(match[1], 16) >>> 0;
    if (match = $8b90bd1c690cacf0$export$4573e032242724d8.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    match[4] + match[4], // a
    16) >>> 0;
    if (match = $8b90bd1c690cacf0$export$8f4a7c0bb78e6ea8.exec(color)) return ($8b90bd1c690cacf0$var$hslToRgb($8b90bd1c690cacf0$var$parse360(match[1]), // h
    $8b90bd1c690cacf0$var$parsePercentage(match[2]), // s
    $8b90bd1c690cacf0$var$parsePercentage(match[3])) | 255) >>> // a
    0;
    if (match = $8b90bd1c690cacf0$export$810b04175080204c.exec(color)) return ($8b90bd1c690cacf0$var$hslToRgb($8b90bd1c690cacf0$var$parse360(match[1]), // h
    $8b90bd1c690cacf0$var$parsePercentage(match[2]), // s
    $8b90bd1c690cacf0$var$parsePercentage(match[3])) | $8b90bd1c690cacf0$var$parse1(match[4])) >>> // a
    0;
    return null;
}
function $8b90bd1c690cacf0$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $8b90bd1c690cacf0$var$hslToRgb(h, s, l) {
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    const r = $8b90bd1c690cacf0$var$hue2rgb(p, q, h + 1 / 3);
    const g = $8b90bd1c690cacf0$var$hue2rgb(p, q, h);
    const b = $8b90bd1c690cacf0$var$hue2rgb(p, q, h - 1 / 3);
    return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}
function $8b90bd1c690cacf0$var$parse255(str) {
    const int = parseInt(str, 10);
    if (int < 0) return 0;
    if (int > 255) return 255;
    return int;
}
function $8b90bd1c690cacf0$var$parse360(str) {
    const int = parseFloat(str);
    return (int % 360 + 360) % 360 / 360;
}
function $8b90bd1c690cacf0$var$parse1(str) {
    const num = parseFloat(str);
    if (num < 0) return 0;
    if (num > 1) return 255;
    return Math.round(num * 255);
}
function $8b90bd1c690cacf0$var$parsePercentage(str) {
    const int = parseFloat(str);
    if (int < 0) return 0;
    if (int > 100) return 1;
    return int / 100;
}
// src/colorToRgba.ts
function $8b90bd1c690cacf0$export$61db176b839af1f(input) {
    let int32Color = $8b90bd1c690cacf0$var$normalizeColor(input);
    if (int32Color === null) return input;
    int32Color = int32Color || 0;
    const r = (int32Color & 4278190080) >>> 24;
    const g = (int32Color & 16711680) >>> 16;
    const b = (int32Color & 65280) >>> 8;
    const a = (int32Color & 255) / 255;
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
// src/createInterpolator.ts
var $8b90bd1c690cacf0$export$b12af43b97697ef5 = (range, output, extrapolate)=>{
    if ($8b90bd1c690cacf0$export$226b3eccf92c9ed9.fun(range)) return range;
    if ($8b90bd1c690cacf0$export$226b3eccf92c9ed9.arr(range)) return $8b90bd1c690cacf0$export$b12af43b97697ef5({
        range: range,
        output: output,
        extrapolate: extrapolate
    });
    if ($8b90bd1c690cacf0$export$226b3eccf92c9ed9.str(range.output[0])) return $8b90bd1c690cacf0$var$createStringInterpolator(range);
    const config = range;
    const outputRange = config.output;
    const inputRange = config.range || [
        0,
        1
    ];
    const extrapolateLeft = config.extrapolateLeft || config.extrapolate || "extend";
    const extrapolateRight = config.extrapolateRight || config.extrapolate || "extend";
    const easing = config.easing || ((t)=>t);
    return (input)=>{
        const range2 = $8b90bd1c690cacf0$var$findRange(input, inputRange);
        return $8b90bd1c690cacf0$var$interpolate(input, inputRange[range2], inputRange[range2 + 1], outputRange[range2], outputRange[range2 + 1], easing, extrapolateLeft, extrapolateRight, config.map);
    };
};
function $8b90bd1c690cacf0$var$interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
    let result = map ? map(input) : input;
    if (result < inputMin) {
        if (extrapolateLeft === "identity") return result;
        else if (extrapolateLeft === "clamp") result = inputMin;
    }
    if (result > inputMax) {
        if (extrapolateRight === "identity") return result;
        else if (extrapolateRight === "clamp") result = inputMax;
    }
    if (outputMin === outputMax) return outputMin;
    if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax;
    if (inputMin === -Infinity) result = -result;
    else if (inputMax === Infinity) result = result - inputMin;
    else result = (result - inputMin) / (inputMax - inputMin);
    result = easing(result);
    if (outputMin === -Infinity) result = -result;
    else if (outputMax === Infinity) result = result + outputMin;
    else result = result * (outputMax - outputMin) + outputMin;
    return result;
}
function $8b90bd1c690cacf0$var$findRange(input, inputRange) {
    for(var i = 1; i < inputRange.length - 1; ++i)if (inputRange[i] >= input) break;
    return i - 1;
}
// src/easings.ts
var $8b90bd1c690cacf0$var$steps = (steps2, direction = "end")=>(progress2)=>{
        progress2 = direction === "end" ? Math.min(progress2, 0.999) : Math.max(progress2, 1e-3);
        const expanded = progress2 * steps2;
        const rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
        return $8b90bd1c690cacf0$export$7d15b64cf5a3a4c4(0, 1, rounded / steps2);
    };
var $8b90bd1c690cacf0$var$c1 = 1.70158;
var $8b90bd1c690cacf0$var$c2 = $8b90bd1c690cacf0$var$c1 * 1.525;
var $8b90bd1c690cacf0$var$c3 = $8b90bd1c690cacf0$var$c1 + 1;
var $8b90bd1c690cacf0$var$c4 = 2 * Math.PI / 3;
var $8b90bd1c690cacf0$var$c5 = 2 * Math.PI / 4.5;
var $8b90bd1c690cacf0$var$bounceOut = (x)=>{
    const n1 = 7.5625;
    const d1 = 2.75;
    if (x < 1 / d1) return n1 * x * x;
    else if (x < 2 / d1) return n1 * (x -= 1.5 / d1) * x + 0.75;
    else if (x < 2.5 / d1) return n1 * (x -= 2.25 / d1) * x + 0.9375;
    else return n1 * (x -= 2.625 / d1) * x + 0.984375;
};
var $8b90bd1c690cacf0$export$15a0bf1b4bbacad8 = {
    linear: (x)=>x,
    easeInQuad: (x)=>x * x,
    easeOutQuad: (x)=>1 - (1 - x) * (1 - x),
    easeInOutQuad: (x)=>x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2,
    easeInCubic: (x)=>x * x * x,
    easeOutCubic: (x)=>1 - Math.pow(1 - x, 3),
    easeInOutCubic: (x)=>x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2,
    easeInQuart: (x)=>x * x * x * x,
    easeOutQuart: (x)=>1 - Math.pow(1 - x, 4),
    easeInOutQuart: (x)=>x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2,
    easeInQuint: (x)=>x * x * x * x * x,
    easeOutQuint: (x)=>1 - Math.pow(1 - x, 5),
    easeInOutQuint: (x)=>x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2,
    easeInSine: (x)=>1 - Math.cos(x * Math.PI / 2),
    easeOutSine: (x)=>Math.sin(x * Math.PI / 2),
    easeInOutSine: (x)=>-(Math.cos(Math.PI * x) - 1) / 2,
    easeInExpo: (x)=>x === 0 ? 0 : Math.pow(2, 10 * x - 10),
    easeOutExpo: (x)=>x === 1 ? 1 : 1 - Math.pow(2, -10 * x),
    easeInOutExpo: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2,
    easeInCirc: (x)=>1 - Math.sqrt(1 - Math.pow(x, 2)),
    easeOutCirc: (x)=>Math.sqrt(1 - Math.pow(x - 1, 2)),
    easeInOutCirc: (x)=>x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2,
    easeInBack: (x)=>$8b90bd1c690cacf0$var$c3 * x * x * x - $8b90bd1c690cacf0$var$c1 * x * x,
    easeOutBack: (x)=>1 + $8b90bd1c690cacf0$var$c3 * Math.pow(x - 1, 3) + $8b90bd1c690cacf0$var$c1 * Math.pow(x - 1, 2),
    easeInOutBack: (x)=>x < 0.5 ? Math.pow(2 * x, 2) * (($8b90bd1c690cacf0$var$c2 + 1) * 2 * x - $8b90bd1c690cacf0$var$c2) / 2 : (Math.pow(2 * x - 2, 2) * (($8b90bd1c690cacf0$var$c2 + 1) * (x * 2 - 2) + $8b90bd1c690cacf0$var$c2) + 2) / 2,
    easeInElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : -Math.pow(2, 10 * x - 10) * Math.sin((x * 10 - 10.75) * $8b90bd1c690cacf0$var$c4),
    easeOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * $8b90bd1c690cacf0$var$c4) + 1,
    easeInOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * $8b90bd1c690cacf0$var$c5)) / 2 : Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * $8b90bd1c690cacf0$var$c5) / 2 + 1,
    easeInBounce: (x)=>1 - $8b90bd1c690cacf0$var$bounceOut(1 - x),
    easeOutBounce: $8b90bd1c690cacf0$var$bounceOut,
    easeInOutBounce: (x)=>x < 0.5 ? (1 - $8b90bd1c690cacf0$var$bounceOut(1 - 2 * x)) / 2 : (1 + $8b90bd1c690cacf0$var$bounceOut(2 * x - 1)) / 2,
    steps: $8b90bd1c690cacf0$var$steps
};
// src/fluids.ts
var $8b90bd1c690cacf0$var$$get = Symbol.for("FluidValue.get");
var $8b90bd1c690cacf0$var$$observers = Symbol.for("FluidValue.observers");
var $8b90bd1c690cacf0$export$57ea7e3a7f6280c7 = (arg)=>Boolean(arg && arg[$8b90bd1c690cacf0$var$$get]);
var $8b90bd1c690cacf0$export$e37b7520edd66839 = (arg)=>arg && arg[$8b90bd1c690cacf0$var$$get] ? arg[$8b90bd1c690cacf0$var$$get]() : arg;
var $8b90bd1c690cacf0$export$133f54e9f7cf1796 = (target)=>target[$8b90bd1c690cacf0$var$$observers] || null;
function $8b90bd1c690cacf0$export$8cbca1207adce0c0(observer2, event) {
    if (observer2.eventObserved) observer2.eventObserved(event);
    else observer2(event);
}
function $8b90bd1c690cacf0$export$31752c40a5fab62a(target, event) {
    const observers = target[$8b90bd1c690cacf0$var$$observers];
    if (observers) observers.forEach((observer2)=>{
        $8b90bd1c690cacf0$export$8cbca1207adce0c0(observer2, event);
    });
}
var $8b90bd1c690cacf0$export$aff8e1ac1a016a2 = class {
    constructor(get){
        if (!get && !(get = this.get)) throw Error("Unknown getter");
        $8b90bd1c690cacf0$export$a3b4618659637aa3(this, get);
    }
};
$8b90bd1c690cacf0$var$$get, $8b90bd1c690cacf0$var$$observers;
var $8b90bd1c690cacf0$export$a3b4618659637aa3 = (target, get)=>$8b90bd1c690cacf0$var$setHidden(target, $8b90bd1c690cacf0$var$$get, get);
function $8b90bd1c690cacf0$export$72d604e3f8d000a5(target, observer2) {
    if (target[$8b90bd1c690cacf0$var$$get]) {
        let observers = target[$8b90bd1c690cacf0$var$$observers];
        if (!observers) $8b90bd1c690cacf0$var$setHidden(target, $8b90bd1c690cacf0$var$$observers, observers = /* @__PURE__ */ new Set());
        if (!observers.has(observer2)) {
            observers.add(observer2);
            if (target.observerAdded) target.observerAdded(observers.size, observer2);
        }
    }
    return observer2;
}
function $8b90bd1c690cacf0$export$7a0eb830d336339b(target, observer2) {
    const observers = target[$8b90bd1c690cacf0$var$$observers];
    if (observers && observers.has(observer2)) {
        const count = observers.size - 1;
        if (count) observers.delete(observer2);
        else target[$8b90bd1c690cacf0$var$$observers] = null;
        if (target.observerRemoved) target.observerRemoved(count, observer2);
    }
}
var $8b90bd1c690cacf0$var$setHidden = (target, key, value)=>Object.defineProperty(target, key, {
        value: value,
        writable: true,
        configurable: true
    });
// src/regexs.ts
var $8b90bd1c690cacf0$var$numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
var $8b90bd1c690cacf0$var$colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
var $8b90bd1c690cacf0$var$unitRegex = new RegExp(`(${$8b90bd1c690cacf0$var$numberRegex.source})(%|[a-z]+)`, "i");
var $8b90bd1c690cacf0$var$rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
var $8b90bd1c690cacf0$var$cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
// src/variableToRgba.ts
var $8b90bd1c690cacf0$var$variableToRgba = (input)=>{
    const [token, fallback] = $8b90bd1c690cacf0$var$parseCSSVariable(input);
    if (!token || $8b90bd1c690cacf0$export$48d7c418edadb60c()) return input;
    const value = window.getComputedStyle(document.documentElement).getPropertyValue(token);
    if (value) return value.trim();
    else if (fallback && fallback.startsWith("--")) {
        const value2 = window.getComputedStyle(document.documentElement).getPropertyValue(fallback);
        if (value2) return value2;
        else return input;
    } else if (fallback && $8b90bd1c690cacf0$var$cssVariableRegex.test(fallback)) return $8b90bd1c690cacf0$var$variableToRgba(fallback);
    else if (fallback) return fallback;
    return input;
};
var $8b90bd1c690cacf0$var$parseCSSVariable = (current)=>{
    const match = $8b90bd1c690cacf0$var$cssVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
};
// src/stringInterpolation.ts
var $8b90bd1c690cacf0$var$namedColorRegex;
var $8b90bd1c690cacf0$var$rgbaRound = (_, p1, p2, p3, p4)=>`rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`;
var $8b90bd1c690cacf0$export$4759a013d387347a = (config)=>{
    if (!$8b90bd1c690cacf0$var$namedColorRegex) $8b90bd1c690cacf0$var$namedColorRegex = $8b90bd1c690cacf0$var$colors ? // match color names, ignore partial matches
    new RegExp(`(${Object.keys($8b90bd1c690cacf0$var$colors).join("|")})(?!\\w)`, "g") : // never match
    /^\b$/;
    const output = config.output.map((value)=>{
        return $8b90bd1c690cacf0$export$e37b7520edd66839(value).replace($8b90bd1c690cacf0$var$cssVariableRegex, $8b90bd1c690cacf0$var$variableToRgba).replace($8b90bd1c690cacf0$var$colorRegex, $8b90bd1c690cacf0$export$61db176b839af1f).replace($8b90bd1c690cacf0$var$namedColorRegex, $8b90bd1c690cacf0$export$61db176b839af1f);
    });
    const keyframes = output.map((value)=>value.match($8b90bd1c690cacf0$var$numberRegex).map(Number));
    const outputRanges = keyframes[0].map((_, i)=>keyframes.map((values)=>{
            if (!(i in values)) throw Error('The arity of each "output" value must be equal');
            return values[i];
        }));
    const interpolators = outputRanges.map((output2)=>$8b90bd1c690cacf0$export$b12af43b97697ef5({
            ...config,
            output: output2
        }));
    return (input)=>{
        const missingUnit = !$8b90bd1c690cacf0$var$unitRegex.test(output[0]) && output.find((value)=>$8b90bd1c690cacf0$var$unitRegex.test(value))?.replace($8b90bd1c690cacf0$var$numberRegex, "");
        let i = 0;
        return output[0].replace($8b90bd1c690cacf0$var$numberRegex, ()=>`${interpolators[i++](input)}${missingUnit || ""}`).replace($8b90bd1c690cacf0$var$rgbaRegex, $8b90bd1c690cacf0$var$rgbaRound);
    };
};
// src/deprecations.ts
var $8b90bd1c690cacf0$export$82e9f45cca5ba907 = "react-spring: ";
var $8b90bd1c690cacf0$export$d2de3aaeafa91619 = (fn)=>{
    const func = fn;
    let called = false;
    if (typeof func != "function") throw new TypeError(`${$8b90bd1c690cacf0$export$82e9f45cca5ba907}once requires a function parameter`);
    return (...args)=>{
        if (!called) {
            func(...args);
            called = true;
        }
    };
};
var $8b90bd1c690cacf0$var$warnInterpolate = $8b90bd1c690cacf0$export$d2de3aaeafa91619(console.warn);
function $8b90bd1c690cacf0$export$2abfcde8ae218ba8() {
    $8b90bd1c690cacf0$var$warnInterpolate(`${$8b90bd1c690cacf0$export$82e9f45cca5ba907}The "interpolate" function is deprecated in v9 (use "to" instead)`);
}
var $8b90bd1c690cacf0$var$warnDirectCall = $8b90bd1c690cacf0$export$d2de3aaeafa91619(console.warn);
function $8b90bd1c690cacf0$export$d99d974913ad3b12() {
    $8b90bd1c690cacf0$var$warnDirectCall(`${$8b90bd1c690cacf0$export$82e9f45cca5ba907}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`);
}
// src/isAnimatedString.ts
function $8b90bd1c690cacf0$export$75bed621f62abfa9(value) {
    return $8b90bd1c690cacf0$export$226b3eccf92c9ed9.str(value) && (value[0] == "#" || /\d/.test(value) || // Do not identify a CSS variable as an AnimatedString if its SSR
    !$8b90bd1c690cacf0$export$48d7c418edadb60c() && $8b90bd1c690cacf0$var$cssVariableRegex.test(value) || value in ($8b90bd1c690cacf0$var$colors || {}));
}
// src/dom-events/resize/resizeElement.ts
var $8b90bd1c690cacf0$var$observer;
var $8b90bd1c690cacf0$var$resizeHandlers = /* @__PURE__ */ new WeakMap();
var $8b90bd1c690cacf0$var$handleObservation = (entries)=>entries.forEach(({ target: target, contentRect: contentRect })=>{
        return $8b90bd1c690cacf0$var$resizeHandlers.get(target)?.forEach((handler)=>handler(contentRect));
    });
function $8b90bd1c690cacf0$var$resizeElement(handler, target) {
    if (!$8b90bd1c690cacf0$var$observer) {
        if (typeof ResizeObserver !== "undefined") $8b90bd1c690cacf0$var$observer = new ResizeObserver($8b90bd1c690cacf0$var$handleObservation);
    }
    let elementHandlers = $8b90bd1c690cacf0$var$resizeHandlers.get(target);
    if (!elementHandlers) {
        elementHandlers = /* @__PURE__ */ new Set();
        $8b90bd1c690cacf0$var$resizeHandlers.set(target, elementHandlers);
    }
    elementHandlers.add(handler);
    if ($8b90bd1c690cacf0$var$observer) $8b90bd1c690cacf0$var$observer.observe(target);
    return ()=>{
        const elementHandlers2 = $8b90bd1c690cacf0$var$resizeHandlers.get(target);
        if (!elementHandlers2) return;
        elementHandlers2.delete(handler);
        if (!elementHandlers2.size && $8b90bd1c690cacf0$var$observer) $8b90bd1c690cacf0$var$observer.unobserve(target);
    };
}
// src/dom-events/resize/resizeWindow.ts
var $8b90bd1c690cacf0$var$listeners = /* @__PURE__ */ new Set();
var $8b90bd1c690cacf0$var$cleanupWindowResizeHandler;
var $8b90bd1c690cacf0$var$createResizeHandler = ()=>{
    const handleResize = ()=>{
        $8b90bd1c690cacf0$var$listeners.forEach((callback)=>callback({
                width: window.innerWidth,
                height: window.innerHeight
            }));
    };
    window.addEventListener("resize", handleResize);
    return ()=>{
        window.removeEventListener("resize", handleResize);
    };
};
var $8b90bd1c690cacf0$var$resizeWindow = (callback)=>{
    $8b90bd1c690cacf0$var$listeners.add(callback);
    if (!$8b90bd1c690cacf0$var$cleanupWindowResizeHandler) $8b90bd1c690cacf0$var$cleanupWindowResizeHandler = $8b90bd1c690cacf0$var$createResizeHandler();
    return ()=>{
        $8b90bd1c690cacf0$var$listeners.delete(callback);
        if (!$8b90bd1c690cacf0$var$listeners.size && $8b90bd1c690cacf0$var$cleanupWindowResizeHandler) {
            $8b90bd1c690cacf0$var$cleanupWindowResizeHandler();
            $8b90bd1c690cacf0$var$cleanupWindowResizeHandler = void 0;
        }
    };
};
// src/dom-events/resize/index.ts
var $8b90bd1c690cacf0$export$45b39e67d4ce4921 = (callback, { container: container = document.documentElement } = {})=>{
    if (container === document.documentElement) return $8b90bd1c690cacf0$var$resizeWindow(callback);
    else return $8b90bd1c690cacf0$var$resizeElement(callback, container);
};
// src/progress.ts
var $8b90bd1c690cacf0$var$progress = (min, max, value)=>max - min === 0 ? 1 : (value - min) / (max - min);
// src/dom-events/scroll/ScrollHandler.ts
var $8b90bd1c690cacf0$var$SCROLL_KEYS = {
    x: {
        length: "Width",
        position: "Left"
    },
    y: {
        length: "Height",
        position: "Top"
    }
};
var $8b90bd1c690cacf0$var$ScrollHandler = class {
    constructor(callback, container){
        this.createAxis = ()=>({
                current: 0,
                progress: 0,
                scrollLength: 0
            });
        this.updateAxis = (axisName)=>{
            const axis = this.info[axisName];
            const { length: length, position: position } = $8b90bd1c690cacf0$var$SCROLL_KEYS[axisName];
            axis.current = this.container[`scroll${position}`];
            axis.scrollLength = this.container[`scroll${length}`] - this.container[`client${length}`];
            axis.progress = $8b90bd1c690cacf0$var$progress(0, axis.scrollLength, axis.current);
        };
        this.update = ()=>{
            this.updateAxis("x");
            this.updateAxis("y");
        };
        this.sendEvent = ()=>{
            this.callback(this.info);
        };
        this.advance = ()=>{
            this.update();
            this.sendEvent();
        };
        this.callback = callback;
        this.container = container;
        this.info = {
            time: 0,
            x: this.createAxis(),
            y: this.createAxis()
        };
    }
};
// src/dom-events/scroll/index.ts
var $8b90bd1c690cacf0$var$scrollListeners = /* @__PURE__ */ new WeakMap();
var $8b90bd1c690cacf0$var$resizeListeners = /* @__PURE__ */ new WeakMap();
var $8b90bd1c690cacf0$var$onScrollHandlers = /* @__PURE__ */ new WeakMap();
var $8b90bd1c690cacf0$var$getTarget = (container)=>container === document.documentElement ? window : container;
var $8b90bd1c690cacf0$export$d4d89fd61e5416ee = (callback, { container: container = document.documentElement } = {})=>{
    let containerHandlers = $8b90bd1c690cacf0$var$onScrollHandlers.get(container);
    if (!containerHandlers) {
        containerHandlers = /* @__PURE__ */ new Set();
        $8b90bd1c690cacf0$var$onScrollHandlers.set(container, containerHandlers);
    }
    const containerHandler = new $8b90bd1c690cacf0$var$ScrollHandler(callback, container);
    containerHandlers.add(containerHandler);
    if (!$8b90bd1c690cacf0$var$scrollListeners.has(container)) {
        const listener = ()=>{
            containerHandlers?.forEach((handler)=>handler.advance());
            return true;
        };
        $8b90bd1c690cacf0$var$scrollListeners.set(container, listener);
        const target = $8b90bd1c690cacf0$var$getTarget(container);
        window.addEventListener("resize", listener, {
            passive: true
        });
        if (container !== document.documentElement) $8b90bd1c690cacf0$var$resizeListeners.set(container, $8b90bd1c690cacf0$export$45b39e67d4ce4921(listener, {
            container: container
        }));
        target.addEventListener("scroll", listener, {
            passive: true
        });
    }
    const animateScroll = $8b90bd1c690cacf0$var$scrollListeners.get(container);
    (0, $cSAm3.raf)(animateScroll);
    return ()=>{
        (0, $cSAm3.raf).cancel(animateScroll);
        const containerHandlers2 = $8b90bd1c690cacf0$var$onScrollHandlers.get(container);
        if (!containerHandlers2) return;
        containerHandlers2.delete(containerHandler);
        if (containerHandlers2.size) return;
        const listener = $8b90bd1c690cacf0$var$scrollListeners.get(container);
        $8b90bd1c690cacf0$var$scrollListeners.delete(container);
        if (listener) {
            $8b90bd1c690cacf0$var$getTarget(container).removeEventListener("scroll", listener);
            window.removeEventListener("resize", listener);
            $8b90bd1c690cacf0$var$resizeListeners.get(container)?.();
        }
    };
};
function $8b90bd1c690cacf0$export$fe4300aa8eebea86(init) {
    const ref = (0, $jbmdS.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}
var $8b90bd1c690cacf0$export$700979bc83e7db82 = $8b90bd1c690cacf0$export$48d7c418edadb60c() ? (0, $jbmdS.useEffect) : (0, $jbmdS.useLayoutEffect);
// src/hooks/useIsMounted.ts
var $8b90bd1c690cacf0$var$useIsMounted = ()=>{
    const isMounted = (0, $jbmdS.useRef)(false);
    $8b90bd1c690cacf0$export$700979bc83e7db82(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
};
// src/hooks/useForceUpdate.ts
function $8b90bd1c690cacf0$export$91db9bc4f8ac944a() {
    const update = (0, $jbmdS.useState)()[1];
    const isMounted = $8b90bd1c690cacf0$var$useIsMounted();
    return ()=>{
        if (isMounted.current) update(Math.random());
    };
}
function $8b90bd1c690cacf0$export$b6feb8998cd9b342(getResult, inputs) {
    const [initial] = (0, $jbmdS.useState)(()=>({
            inputs: inputs,
            result: getResult()
        }));
    const committed = (0, $jbmdS.useRef)();
    const prevCache = committed.current;
    let cache = prevCache;
    if (cache) {
        const useCache = Boolean(inputs && cache.inputs && $8b90bd1c690cacf0$var$areInputsEqual(inputs, cache.inputs));
        if (!useCache) cache = {
            inputs: inputs,
            result: getResult()
        };
    } else cache = initial;
    (0, $jbmdS.useEffect)(()=>{
        committed.current = cache;
        if (prevCache == initial) initial.inputs = initial.result = void 0;
    }, [
        cache
    ]);
    return cache.result;
}
function $8b90bd1c690cacf0$var$areInputsEqual(next, prev) {
    if (next.length !== prev.length) return false;
    for(let i = 0; i < next.length; i++){
        if (next[i] !== prev[i]) return false;
    }
    return true;
}
var $8b90bd1c690cacf0$export$392544347a18b6ea = (effect)=>(0, $jbmdS.useEffect)(effect, $8b90bd1c690cacf0$var$emptyDeps);
var $8b90bd1c690cacf0$var$emptyDeps = [];
function $8b90bd1c690cacf0$export$ef7ad0c4e19d7fbf(value) {
    const prevRef = (0, $jbmdS.useRef)();
    (0, $jbmdS.useEffect)(()=>{
        prevRef.current = value;
    });
    return prevRef.current;
}
var $8b90bd1c690cacf0$export$6a42007cf1e7b6f8 = ()=>{
    const [reducedMotion, setReducedMotion] = (0, $jbmdS.useState)(null);
    $8b90bd1c690cacf0$export$700979bc83e7db82(()=>{
        const mql = window.matchMedia("(prefers-reduced-motion)");
        const handleMediaChange = (e)=>{
            setReducedMotion(e.matches);
            $8b90bd1c690cacf0$var$assign({
                skipAnimation: e.matches
            });
        };
        handleMediaChange(mql);
        if (mql.addEventListener) mql.addEventListener("change", handleMediaChange);
        else mql.addListener(handleMediaChange);
        return ()=>{
            if (mql.removeEventListener) mql.removeEventListener("change", handleMediaChange);
            else mql.removeListener(handleMediaChange);
        };
    }, []);
    return reducedMotion;
};

});
parcelRegister("cSAm3", function(module, exports) {

$parcel$export(module.exports, "raf", function () { return $9606ba7610730223$export$27f233d61a9e2fa4; });
// src/index.ts
var $9606ba7610730223$var$updateQueue = $9606ba7610730223$var$makeQueue();
var $9606ba7610730223$export$27f233d61a9e2fa4 = (fn)=>$9606ba7610730223$var$schedule(fn, $9606ba7610730223$var$updateQueue);
var $9606ba7610730223$var$writeQueue = $9606ba7610730223$var$makeQueue();
$9606ba7610730223$export$27f233d61a9e2fa4.write = (fn)=>$9606ba7610730223$var$schedule(fn, $9606ba7610730223$var$writeQueue);
var $9606ba7610730223$var$onStartQueue = $9606ba7610730223$var$makeQueue();
$9606ba7610730223$export$27f233d61a9e2fa4.onStart = (fn)=>$9606ba7610730223$var$schedule(fn, $9606ba7610730223$var$onStartQueue);
var $9606ba7610730223$var$onFrameQueue = $9606ba7610730223$var$makeQueue();
$9606ba7610730223$export$27f233d61a9e2fa4.onFrame = (fn)=>$9606ba7610730223$var$schedule(fn, $9606ba7610730223$var$onFrameQueue);
var $9606ba7610730223$var$onFinishQueue = $9606ba7610730223$var$makeQueue();
$9606ba7610730223$export$27f233d61a9e2fa4.onFinish = (fn)=>$9606ba7610730223$var$schedule(fn, $9606ba7610730223$var$onFinishQueue);
var $9606ba7610730223$var$timeouts = [];
$9606ba7610730223$export$27f233d61a9e2fa4.setTimeout = (handler, ms)=>{
    const time = $9606ba7610730223$export$27f233d61a9e2fa4.now() + ms;
    const cancel = ()=>{
        const i = $9606ba7610730223$var$timeouts.findIndex((t)=>t.cancel == cancel);
        if (~i) $9606ba7610730223$var$timeouts.splice(i, 1);
        $9606ba7610730223$var$pendingCount -= ~i ? 1 : 0;
    };
    const timeout = {
        time: time,
        handler: handler,
        cancel: cancel
    };
    $9606ba7610730223$var$timeouts.splice($9606ba7610730223$var$findTimeout(time), 0, timeout);
    $9606ba7610730223$var$pendingCount += 1;
    $9606ba7610730223$var$start();
    return timeout;
};
var $9606ba7610730223$var$findTimeout = (time)=>~(~$9606ba7610730223$var$timeouts.findIndex((t)=>t.time > time) || ~$9606ba7610730223$var$timeouts.length);
$9606ba7610730223$export$27f233d61a9e2fa4.cancel = (fn)=>{
    $9606ba7610730223$var$onStartQueue.delete(fn);
    $9606ba7610730223$var$onFrameQueue.delete(fn);
    $9606ba7610730223$var$onFinishQueue.delete(fn);
    $9606ba7610730223$var$updateQueue.delete(fn);
    $9606ba7610730223$var$writeQueue.delete(fn);
};
$9606ba7610730223$export$27f233d61a9e2fa4.sync = (fn)=>{
    $9606ba7610730223$var$sync = true;
    $9606ba7610730223$export$27f233d61a9e2fa4.batchedUpdates(fn);
    $9606ba7610730223$var$sync = false;
};
$9606ba7610730223$export$27f233d61a9e2fa4.throttle = (fn)=>{
    let lastArgs;
    function queuedFn() {
        try {
            fn(...lastArgs);
        } finally{
            lastArgs = null;
        }
    }
    function throttled(...args) {
        lastArgs = args;
        $9606ba7610730223$export$27f233d61a9e2fa4.onStart(queuedFn);
    }
    throttled.handler = fn;
    throttled.cancel = ()=>{
        $9606ba7610730223$var$onStartQueue.delete(queuedFn);
        lastArgs = null;
    };
    return throttled;
};
var $9606ba7610730223$var$nativeRaf = typeof window != "undefined" ? window.requestAnimationFrame : // eslint-disable-next-line @typescript-eslint/no-empty-function
()=>{};
$9606ba7610730223$export$27f233d61a9e2fa4.use = (impl)=>$9606ba7610730223$var$nativeRaf = impl;
$9606ba7610730223$export$27f233d61a9e2fa4.now = typeof performance != "undefined" ? ()=>performance.now() : Date.now;
$9606ba7610730223$export$27f233d61a9e2fa4.batchedUpdates = (fn)=>fn();
$9606ba7610730223$export$27f233d61a9e2fa4.catch = console.error;
$9606ba7610730223$export$27f233d61a9e2fa4.frameLoop = "always";
$9606ba7610730223$export$27f233d61a9e2fa4.advance = ()=>{
    if ($9606ba7610730223$export$27f233d61a9e2fa4.frameLoop !== "demand") console.warn("Cannot call the manual advancement of rafz whilst frameLoop is not set as demand");
    else $9606ba7610730223$var$update();
};
var $9606ba7610730223$var$ts = -1;
var $9606ba7610730223$var$pendingCount = 0;
var $9606ba7610730223$var$sync = false;
function $9606ba7610730223$var$schedule(fn, queue) {
    if ($9606ba7610730223$var$sync) {
        queue.delete(fn);
        fn(0);
    } else {
        queue.add(fn);
        $9606ba7610730223$var$start();
    }
}
function $9606ba7610730223$var$start() {
    if ($9606ba7610730223$var$ts < 0) {
        $9606ba7610730223$var$ts = 0;
        if ($9606ba7610730223$export$27f233d61a9e2fa4.frameLoop !== "demand") $9606ba7610730223$var$nativeRaf($9606ba7610730223$var$loop);
    }
}
function $9606ba7610730223$var$stop() {
    $9606ba7610730223$var$ts = -1;
}
function $9606ba7610730223$var$loop() {
    if (~$9606ba7610730223$var$ts) {
        $9606ba7610730223$var$nativeRaf($9606ba7610730223$var$loop);
        $9606ba7610730223$export$27f233d61a9e2fa4.batchedUpdates($9606ba7610730223$var$update);
    }
}
function $9606ba7610730223$var$update() {
    const prevTs = $9606ba7610730223$var$ts;
    $9606ba7610730223$var$ts = $9606ba7610730223$export$27f233d61a9e2fa4.now();
    const count = $9606ba7610730223$var$findTimeout($9606ba7610730223$var$ts);
    if (count) {
        $9606ba7610730223$var$eachSafely($9606ba7610730223$var$timeouts.splice(0, count), (t)=>t.handler());
        $9606ba7610730223$var$pendingCount -= count;
    }
    if (!$9606ba7610730223$var$pendingCount) {
        $9606ba7610730223$var$stop();
        return;
    }
    $9606ba7610730223$var$onStartQueue.flush();
    $9606ba7610730223$var$updateQueue.flush(prevTs ? Math.min(64, $9606ba7610730223$var$ts - prevTs) : 16.667);
    $9606ba7610730223$var$onFrameQueue.flush();
    $9606ba7610730223$var$writeQueue.flush();
    $9606ba7610730223$var$onFinishQueue.flush();
}
function $9606ba7610730223$var$makeQueue() {
    let next = /* @__PURE__ */ new Set();
    let current = next;
    return {
        add (fn) {
            $9606ba7610730223$var$pendingCount += current == next && !next.has(fn) ? 1 : 0;
            next.add(fn);
        },
        delete (fn) {
            $9606ba7610730223$var$pendingCount -= current == next && next.has(fn) ? 1 : 0;
            return next.delete(fn);
        },
        flush (arg) {
            if (current.size) {
                next = /* @__PURE__ */ new Set();
                $9606ba7610730223$var$pendingCount -= current.size;
                $9606ba7610730223$var$eachSafely(current, (fn)=>fn(arg) && next.add(fn));
                $9606ba7610730223$var$pendingCount += next.size;
                current = next;
            }
        }
    };
}
function $9606ba7610730223$var$eachSafely(values, each) {
    values.forEach((value)=>{
        try {
            each(value);
        } catch (e) {
            $9606ba7610730223$export$27f233d61a9e2fa4.catch(e);
        }
    });
}
var $9606ba7610730223$export$ef91a23fc803e177 = {
    /** The number of pending tasks */ count () {
        return $9606ba7610730223$var$pendingCount;
    },
    /** Whether there's a raf update loop running */ isRunning () {
        return $9606ba7610730223$var$ts >= 0;
    },
    /** Clear internal state. Never call from update loop! */ clear () {
        $9606ba7610730223$var$ts = -1;
        $9606ba7610730223$var$timeouts = [];
        $9606ba7610730223$var$onStartQueue = $9606ba7610730223$var$makeQueue();
        $9606ba7610730223$var$updateQueue = $9606ba7610730223$var$makeQueue();
        $9606ba7610730223$var$onFrameQueue = $9606ba7610730223$var$makeQueue();
        $9606ba7610730223$var$writeQueue = $9606ba7610730223$var$makeQueue();
        $9606ba7610730223$var$onFinishQueue = $9606ba7610730223$var$makeQueue();
        $9606ba7610730223$var$pendingCount = 0;
    }
};

});


parcelRegister("b7bYo", function(module, exports) {

$parcel$export(module.exports, "getAnimated", function () { return $8179a2c3e3693c1e$export$6b63995194a3a9e4; });
$parcel$export(module.exports, "setAnimated", function () { return $8179a2c3e3693c1e$export$b553cb5b22b81b04; });
$parcel$export(module.exports, "getPayload", function () { return $8179a2c3e3693c1e$export$ccab2b64c5d440; });
$parcel$export(module.exports, "AnimatedValue", function () { return $8179a2c3e3693c1e$export$cb1e8f3c05d37ad5; });
$parcel$export(module.exports, "AnimatedString", function () { return $8179a2c3e3693c1e$export$f6c6c4cbd7fa5b93; });
$parcel$export(module.exports, "AnimatedObject", function () { return $8179a2c3e3693c1e$export$f1b0b9e366a6e2d4; });
$parcel$export(module.exports, "getAnimatedType", function () { return $8179a2c3e3693c1e$export$e6b77ddbe47b132e; });
$parcel$export(module.exports, "createHost", function () { return $8179a2c3e3693c1e$export$4ee5c78f6dcbcef; });
// src/Animated.ts

var $bYU0b = parcelRequire("bYU0b");
var $cSAm3 = parcelRequire("cSAm3");

var $jbmdS = parcelRequire("jbmdS");
var $8179a2c3e3693c1e$var$$node = Symbol.for("Animated:node");
var $8179a2c3e3693c1e$export$3df5e165e801a70f = (value)=>!!value && value[$8179a2c3e3693c1e$var$$node] === value;
var $8179a2c3e3693c1e$export$6b63995194a3a9e4 = (owner)=>owner && owner[$8179a2c3e3693c1e$var$$node];
var $8179a2c3e3693c1e$export$b553cb5b22b81b04 = (owner, node)=>(0, $bYU0b.defineHidden)(owner, $8179a2c3e3693c1e$var$$node, node);
var $8179a2c3e3693c1e$export$ccab2b64c5d440 = (owner)=>owner && owner[$8179a2c3e3693c1e$var$$node] && owner[$8179a2c3e3693c1e$var$$node].getPayload();
var $8179a2c3e3693c1e$export$31627395a3b18e54 = class {
    constructor(){
        $8179a2c3e3693c1e$export$b553cb5b22b81b04(this, this);
    }
    /** Get every `AnimatedValue` used by this node. */ getPayload() {
        return this.payload || [];
    }
};
var $8179a2c3e3693c1e$export$cb1e8f3c05d37ad5 = class extends $8179a2c3e3693c1e$export$31627395a3b18e54 {
    constructor(_value){
        super();
        this._value = _value;
        this.done = true;
        this.durationProgress = 0;
        if ((0, $bYU0b.is).num(this._value)) this.lastPosition = this._value;
    }
    /** @internal */ static create(value) {
        return new $8179a2c3e3693c1e$export$cb1e8f3c05d37ad5(value);
    }
    getPayload() {
        return [
            this
        ];
    }
    getValue() {
        return this._value;
    }
    setValue(value, step) {
        if ((0, $bYU0b.is).num(value)) {
            this.lastPosition = value;
            if (step) {
                value = Math.round(value / step) * step;
                if (this.done) this.lastPosition = value;
            }
        }
        if (this._value === value) return false;
        this._value = value;
        return true;
    }
    reset() {
        const { done: done } = this;
        this.done = false;
        if ((0, $bYU0b.is).num(this._value)) {
            this.elapsedTime = 0;
            this.durationProgress = 0;
            this.lastPosition = this._value;
            if (done) this.lastVelocity = null;
            this.v0 = null;
        }
    }
};
var $8179a2c3e3693c1e$export$f6c6c4cbd7fa5b93 = class extends $8179a2c3e3693c1e$export$cb1e8f3c05d37ad5 {
    constructor(value){
        super(0);
        this._string = null;
        this._toString = (0, $bYU0b.createInterpolator)({
            output: [
                value,
                value
            ]
        });
    }
    /** @internal */ static create(value) {
        return new $8179a2c3e3693c1e$export$f6c6c4cbd7fa5b93(value);
    }
    getValue() {
        const value = this._string;
        return value == null ? this._string = this._toString(this._value) : value;
    }
    setValue(value) {
        if ((0, $bYU0b.is).str(value)) {
            if (value == this._string) return false;
            this._string = value;
            this._value = 1;
        } else if (super.setValue(value)) this._string = null;
        else return false;
        return true;
    }
    reset(goal) {
        if (goal) this._toString = (0, $bYU0b.createInterpolator)({
            output: [
                this.getValue(),
                goal
            ]
        });
        this._value = 0;
        super.reset();
    }
};
// src/context.ts
var $8179a2c3e3693c1e$var$TreeContext = {
    dependencies: null
};
// src/AnimatedObject.ts
var $8179a2c3e3693c1e$export$f1b0b9e366a6e2d4 = class extends $8179a2c3e3693c1e$export$31627395a3b18e54 {
    constructor(source){
        super();
        this.source = source;
        this.setValue(source);
    }
    getValue(animated) {
        const values = {};
        (0, $bYU0b.eachProp)(this.source, (source, key)=>{
            if ($8179a2c3e3693c1e$export$3df5e165e801a70f(source)) values[key] = source.getValue(animated);
            else if ((0, $bYU0b.hasFluidValue)(source)) values[key] = (0, $bYU0b.getFluidValue)(source);
            else if (!animated) values[key] = source;
        });
        return values;
    }
    /** Replace the raw object data */ setValue(source) {
        this.source = source;
        this.payload = this._makePayload(source);
    }
    reset() {
        if (this.payload) (0, $bYU0b.each)(this.payload, (node)=>node.reset());
    }
    /** Create a payload set. */ _makePayload(source) {
        if (source) {
            const payload = /* @__PURE__ */ new Set();
            (0, $bYU0b.eachProp)(source, this._addToPayload, payload);
            return Array.from(payload);
        }
    }
    /** Add to a payload set. */ _addToPayload(source) {
        if ($8179a2c3e3693c1e$var$TreeContext.dependencies && (0, $bYU0b.hasFluidValue)(source)) $8179a2c3e3693c1e$var$TreeContext.dependencies.add(source);
        const payload = $8179a2c3e3693c1e$export$ccab2b64c5d440(source);
        if (payload) (0, $bYU0b.each)(payload, (node)=>this.add(node));
    }
};
// src/AnimatedArray.ts
var $8179a2c3e3693c1e$export$ede394683406942d = class extends $8179a2c3e3693c1e$export$f1b0b9e366a6e2d4 {
    constructor(source){
        super(source);
    }
    /** @internal */ static create(source) {
        return new $8179a2c3e3693c1e$export$ede394683406942d(source);
    }
    getValue() {
        return this.source.map((node)=>node.getValue());
    }
    setValue(source) {
        const payload = this.getPayload();
        if (source.length == payload.length) return payload.map((node, i)=>node.setValue(source[i])).some(Boolean);
        super.setValue(source.map($8179a2c3e3693c1e$var$makeAnimated));
        return true;
    }
};
function $8179a2c3e3693c1e$var$makeAnimated(value) {
    const nodeType = (0, $bYU0b.isAnimatedString)(value) ? $8179a2c3e3693c1e$export$f6c6c4cbd7fa5b93 : $8179a2c3e3693c1e$export$cb1e8f3c05d37ad5;
    return nodeType.create(value);
}
function $8179a2c3e3693c1e$export$e6b77ddbe47b132e(value) {
    const parentNode = $8179a2c3e3693c1e$export$6b63995194a3a9e4(value);
    return parentNode ? parentNode.constructor : (0, $bYU0b.is).arr(value) ? $8179a2c3e3693c1e$export$ede394683406942d : (0, $bYU0b.isAnimatedString)(value) ? $8179a2c3e3693c1e$export$f6c6c4cbd7fa5b93 : $8179a2c3e3693c1e$export$cb1e8f3c05d37ad5;
}
var $8179a2c3e3693c1e$var$withAnimated = (Component, host)=>{
    const hasInstance = // Function components must use "forwardRef" to avoid being
    // re-rendered on every animation frame.
    !(0, $bYU0b.is).fun(Component) || Component.prototype && Component.prototype.isReactComponent;
    return (0, $jbmdS.forwardRef)((givenProps, givenRef)=>{
        const instanceRef = (0, $jbmdS.useRef)(null);
        const ref = hasInstance && // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $jbmdS.useCallback)((value)=>{
            instanceRef.current = $8179a2c3e3693c1e$var$updateRef(givenRef, value);
        }, [
            givenRef
        ]);
        const [props, deps] = $8179a2c3e3693c1e$var$getAnimatedState(givenProps, host);
        const forceUpdate = (0, $bYU0b.useForceUpdate)();
        const callback = ()=>{
            const instance = instanceRef.current;
            if (hasInstance && !instance) return;
            const didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false;
            if (didUpdate === false) forceUpdate();
        };
        const observer = new $8179a2c3e3693c1e$var$PropsObserver(callback, deps);
        const observerRef = (0, $jbmdS.useRef)();
        (0, $bYU0b.useIsomorphicLayoutEffect)(()=>{
            observerRef.current = observer;
            (0, $bYU0b.each)(deps, (dep)=>(0, $bYU0b.addFluidObserver)(dep, observer));
            return ()=>{
                if (observerRef.current) {
                    (0, $bYU0b.each)(observerRef.current.deps, (dep)=>(0, $bYU0b.removeFluidObserver)(dep, observerRef.current));
                    (0, $cSAm3.raf).cancel(observerRef.current.update);
                }
            };
        });
        (0, $jbmdS.useEffect)(callback, []);
        (0, $bYU0b.useOnce)(()=>()=>{
                const observer2 = observerRef.current;
                (0, $bYU0b.each)(observer2.deps, (dep)=>(0, $bYU0b.removeFluidObserver)(dep, observer2));
            });
        const usedProps = host.getComponentProps(props.getValue());
        return /* @__PURE__ */ $jbmdS.createElement(Component, {
            ...usedProps,
            ref: ref
        });
    });
};
var $8179a2c3e3693c1e$var$PropsObserver = class {
    constructor(update, deps){
        this.update = update;
        this.deps = deps;
    }
    eventObserved(event) {
        if (event.type == "change") (0, $cSAm3.raf).write(this.update);
    }
};
function $8179a2c3e3693c1e$var$getAnimatedState(props, host) {
    const dependencies = /* @__PURE__ */ new Set();
    $8179a2c3e3693c1e$var$TreeContext.dependencies = dependencies;
    if (props.style) props = {
        ...props,
        style: host.createAnimatedStyle(props.style)
    };
    props = new $8179a2c3e3693c1e$export$f1b0b9e366a6e2d4(props);
    $8179a2c3e3693c1e$var$TreeContext.dependencies = null;
    return [
        props,
        dependencies
    ];
}
function $8179a2c3e3693c1e$var$updateRef(ref, value) {
    if (ref) {
        if ((0, $bYU0b.is).fun(ref)) ref(value);
        else ref.current = value;
    }
    return value;
}
// src/createHost.ts
var $8179a2c3e3693c1e$var$cacheKey = Symbol.for("AnimatedComponent");
var $8179a2c3e3693c1e$export$4ee5c78f6dcbcef = (components, { applyAnimatedValues: applyAnimatedValues = ()=>false, createAnimatedStyle: createAnimatedStyle = (style)=>new $8179a2c3e3693c1e$export$f1b0b9e366a6e2d4(style), getComponentProps: getComponentProps = (props)=>props } = {})=>{
    const hostConfig = {
        applyAnimatedValues: applyAnimatedValues,
        createAnimatedStyle: createAnimatedStyle,
        getComponentProps: getComponentProps
    };
    const animated = (Component)=>{
        const displayName = $8179a2c3e3693c1e$var$getDisplayName(Component) || "Anonymous";
        if ((0, $bYU0b.is).str(Component)) Component = animated[Component] || (animated[Component] = $8179a2c3e3693c1e$var$withAnimated(Component, hostConfig));
        else Component = Component[$8179a2c3e3693c1e$var$cacheKey] || (Component[$8179a2c3e3693c1e$var$cacheKey] = $8179a2c3e3693c1e$var$withAnimated(Component, hostConfig));
        Component.displayName = `Animated(${displayName})`;
        return Component;
    };
    (0, $bYU0b.eachProp)(components, (Component, key)=>{
        if ((0, $bYU0b.is).arr(components)) key = $8179a2c3e3693c1e$var$getDisplayName(Component);
        animated[key] = animated(Component);
    });
    return {
        animated: animated
    };
};
var $8179a2c3e3693c1e$var$getDisplayName = (arg)=>(0, $bYU0b.is).str(arg) ? arg : arg && (0, $bYU0b.is).str(arg.displayName) ? arg.displayName : (0, $bYU0b.is).fun(arg) && arg.name || null;

});

parcelRegister("SI2zV", function(module, exports) {
// src/utils.ts
var $0a4734cdd2822038$export$b24b633b1364b94b = class {
};

});





parcelRegister("hAJIP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cce943e5d09911e9$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $cce943e5d09911e9$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("Search", [
    [
        "circle",
        {
            cx: "11",
            cy: "11",
            r: "8",
            key: "4ej97u"
        }
    ],
    [
        "path",
        {
            d: "m21 21-4.3-4.3",
            key: "1qie3q"
        }
    ]
]);

});

parcelRegister("5wgpP", function(module, exports) {

$parcel$export(module.exports, "Virtuoso", function () { return $5fa732a17329782a$export$ea50ab61e1198ee3; });

var $4TLFw = parcelRequire("4TLFw");

var $jbmdS = parcelRequire("jbmdS");

var $jCNM0 = parcelRequire("jCNM0");
const $5fa732a17329782a$var$PUBLISH = 0;
const $5fa732a17329782a$var$SUBSCRIBE = 1;
const $5fa732a17329782a$var$RESET = 2;
const $5fa732a17329782a$var$VALUE = 4;
function $5fa732a17329782a$var$compose(a, b) {
    return (arg)=>a(b(arg));
}
function $5fa732a17329782a$var$thrush(arg, proc) {
    return proc(arg);
}
function $5fa732a17329782a$var$curry2to1(proc, arg1) {
    return (arg2)=>proc(arg1, arg2);
}
function $5fa732a17329782a$var$curry1to0(proc, arg) {
    return ()=>proc(arg);
}
function $5fa732a17329782a$var$tap(arg, proc) {
    proc(arg);
    return arg;
}
function $5fa732a17329782a$var$tup(...args) {
    return args;
}
function $5fa732a17329782a$var$call(proc) {
    proc();
}
function $5fa732a17329782a$var$always(value) {
    return ()=>value;
}
function $5fa732a17329782a$var$joinProc(...procs) {
    return ()=>{
        procs.map($5fa732a17329782a$var$call);
    };
}
function $5fa732a17329782a$var$isDefined(arg) {
    return arg !== void 0;
}
function $5fa732a17329782a$var$noop() {}
function $5fa732a17329782a$var$subscribe(emitter, subscription) {
    return emitter($5fa732a17329782a$var$SUBSCRIBE, subscription);
}
function $5fa732a17329782a$var$publish(publisher, value) {
    publisher($5fa732a17329782a$var$PUBLISH, value);
}
function $5fa732a17329782a$var$reset(emitter) {
    emitter($5fa732a17329782a$var$RESET);
}
function $5fa732a17329782a$var$getValue(depot) {
    return depot($5fa732a17329782a$var$VALUE);
}
function $5fa732a17329782a$var$connect(emitter, publisher) {
    return $5fa732a17329782a$var$subscribe(emitter, $5fa732a17329782a$var$curry2to1(publisher, $5fa732a17329782a$var$PUBLISH));
}
function $5fa732a17329782a$var$handleNext(emitter, subscription) {
    const unsub = emitter($5fa732a17329782a$var$SUBSCRIBE, (value)=>{
        unsub();
        subscription(value);
    });
    return unsub;
}
function $5fa732a17329782a$var$stream() {
    const subscriptions = [];
    return (action, arg)=>{
        switch(action){
            case $5fa732a17329782a$var$RESET:
                subscriptions.splice(0, subscriptions.length);
                return;
            case $5fa732a17329782a$var$SUBSCRIBE:
                subscriptions.push(arg);
                return ()=>{
                    const indexOf = subscriptions.indexOf(arg);
                    if (indexOf > -1) subscriptions.splice(indexOf, 1);
                };
            case $5fa732a17329782a$var$PUBLISH:
                subscriptions.slice().forEach((subscription)=>{
                    subscription(arg);
                });
                return;
            default:
                throw new Error(`unrecognized action ${action}`);
        }
    };
}
function $5fa732a17329782a$var$statefulStream(initial) {
    let value = initial;
    const innerSubject = $5fa732a17329782a$var$stream();
    return (action, arg)=>{
        switch(action){
            case $5fa732a17329782a$var$SUBSCRIBE:
                const subscription = arg;
                subscription(value);
                break;
            case $5fa732a17329782a$var$PUBLISH:
                value = arg;
                break;
            case $5fa732a17329782a$var$VALUE:
                return value;
        }
        return innerSubject(action, arg);
    };
}
function $5fa732a17329782a$var$eventHandler(emitter) {
    let unsub;
    let currentSubscription;
    const cleanup = ()=>unsub && unsub();
    return function(action, subscription) {
        switch(action){
            case $5fa732a17329782a$var$SUBSCRIBE:
                if (subscription) {
                    if (currentSubscription === subscription) return;
                    cleanup();
                    currentSubscription = subscription;
                    unsub = $5fa732a17329782a$var$subscribe(emitter, subscription);
                    return unsub;
                } else {
                    cleanup();
                    return $5fa732a17329782a$var$noop;
                }
            case $5fa732a17329782a$var$RESET:
                cleanup();
                currentSubscription = null;
                return;
            default:
                throw new Error(`unrecognized action ${action}`);
        }
    };
}
function $5fa732a17329782a$var$streamFromEmitter(emitter) {
    return $5fa732a17329782a$var$tap($5fa732a17329782a$var$stream(), (stream2)=>$5fa732a17329782a$var$connect(emitter, stream2));
}
function $5fa732a17329782a$var$statefulStreamFromEmitter(emitter, initial) {
    return $5fa732a17329782a$var$tap($5fa732a17329782a$var$statefulStream(initial), (stream2)=>$5fa732a17329782a$var$connect(emitter, stream2));
}
function $5fa732a17329782a$var$combineOperators(...operators) {
    return (subscriber)=>{
        return operators.reduceRight($5fa732a17329782a$var$thrush, subscriber);
    };
}
function $5fa732a17329782a$var$pipe(source, ...operators) {
    const project = $5fa732a17329782a$var$combineOperators(...operators);
    return (action, subscription)=>{
        switch(action){
            case $5fa732a17329782a$var$SUBSCRIBE:
                return $5fa732a17329782a$var$subscribe(source, project(subscription));
            case $5fa732a17329782a$var$RESET:
                $5fa732a17329782a$var$reset(source);
                return;
        }
    };
}
function $5fa732a17329782a$var$defaultComparator(previous, next) {
    return previous === next;
}
function $5fa732a17329782a$var$distinctUntilChanged(comparator = $5fa732a17329782a$var$defaultComparator) {
    let current;
    return (done)=>(next)=>{
            if (!comparator(current, next)) {
                current = next;
                done(next);
            }
        };
}
function $5fa732a17329782a$var$filter(predicate) {
    return (done)=>(value)=>{
            predicate(value) && done(value);
        };
}
function $5fa732a17329782a$var$map(project) {
    return (done)=>$5fa732a17329782a$var$compose(done, project);
}
function $5fa732a17329782a$var$mapTo(value) {
    return (done)=>()=>done(value);
}
function $5fa732a17329782a$var$scan(scanner, initial) {
    return (done)=>(value)=>done(initial = scanner(initial, value));
}
function $5fa732a17329782a$var$skip(times) {
    return (done)=>(value)=>{
            times > 0 ? times-- : done(value);
        };
}
function $5fa732a17329782a$var$throttleTime(interval) {
    let currentValue = null;
    let timeout;
    return (done)=>(value)=>{
            currentValue = value;
            if (timeout) return;
            timeout = setTimeout(()=>{
                timeout = void 0;
                done(currentValue);
            }, interval);
        };
}
function $5fa732a17329782a$var$debounceTime(interval) {
    let currentValue;
    let timeout;
    return (done)=>(value)=>{
            currentValue = value;
            if (timeout) clearTimeout(timeout);
            timeout = setTimeout(()=>{
                done(currentValue);
            }, interval);
        };
}
function $5fa732a17329782a$var$withLatestFrom(...sources) {
    const values = new Array(sources.length);
    let called = 0;
    let pendingCall = null;
    const allCalled = Math.pow(2, sources.length) - 1;
    sources.forEach((source, index)=>{
        const bit = Math.pow(2, index);
        $5fa732a17329782a$var$subscribe(source, (value)=>{
            const prevCalled = called;
            called = called | bit;
            values[index] = value;
            if (prevCalled !== allCalled && called === allCalled && pendingCall) {
                pendingCall();
                pendingCall = null;
            }
        });
    });
    return (done)=>(value)=>{
            const call2 = ()=>done([
                    value
                ].concat(values));
            if (called === allCalled) call2();
            else pendingCall = call2;
        };
}
function $5fa732a17329782a$var$merge(...sources) {
    return function(action, subscription) {
        switch(action){
            case $5fa732a17329782a$var$SUBSCRIBE:
                return $5fa732a17329782a$var$joinProc(...sources.map((source)=>$5fa732a17329782a$var$subscribe(source, subscription)));
            case $5fa732a17329782a$var$RESET:
                return;
            default:
                throw new Error(`unrecognized action ${action}`);
        }
    };
}
function $5fa732a17329782a$var$duc(source, comparator = $5fa732a17329782a$var$defaultComparator) {
    return $5fa732a17329782a$var$pipe(source, $5fa732a17329782a$var$distinctUntilChanged(comparator));
}
function $5fa732a17329782a$var$combineLatest(...emitters) {
    const innerSubject = $5fa732a17329782a$var$stream();
    const values = new Array(emitters.length);
    let called = 0;
    const allCalled = Math.pow(2, emitters.length) - 1;
    emitters.forEach((source, index)=>{
        const bit = Math.pow(2, index);
        $5fa732a17329782a$var$subscribe(source, (value)=>{
            values[index] = value;
            called = called | bit;
            if (called === allCalled) $5fa732a17329782a$var$publish(innerSubject, values);
        });
    });
    return function(action, subscription) {
        switch(action){
            case $5fa732a17329782a$var$SUBSCRIBE:
                if (called === allCalled) subscription(values);
                return $5fa732a17329782a$var$subscribe(innerSubject, subscription);
            case $5fa732a17329782a$var$RESET:
                return $5fa732a17329782a$var$reset(innerSubject);
            default:
                throw new Error(`unrecognized action ${action}`);
        }
    };
}
function $5fa732a17329782a$var$system(constructor, dependencies = [], { singleton: singleton } = {
    singleton: true
}) {
    return {
        id: $5fa732a17329782a$var$id(),
        constructor: constructor,
        dependencies: dependencies,
        singleton: singleton
    };
}
const $5fa732a17329782a$var$id = ()=>Symbol();
function $5fa732a17329782a$var$init(systemSpec) {
    const singletons = /* @__PURE__ */ new Map();
    const _init = ({ id: id2, constructor: constructor, dependencies: dependencies, singleton: singleton })=>{
        if (singleton && singletons.has(id2)) return singletons.get(id2);
        const system2 = constructor(dependencies.map((e)=>_init(e)));
        if (singleton) singletons.set(id2, system2);
        return system2;
    };
    return _init(systemSpec);
}
function $5fa732a17329782a$var$omit(keys, obj) {
    const result = {};
    const index = {};
    let idx = 0;
    const len = keys.length;
    while(idx < len){
        index[keys[idx]] = 1;
        idx += 1;
    }
    for(const prop in obj)if (!index.hasOwnProperty(prop)) result[prop] = obj[prop];
    return result;
}
const $5fa732a17329782a$var$useIsomorphicLayoutEffect$1 = typeof document !== "undefined" ? (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useLayoutEffect : (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useEffect;
function $5fa732a17329782a$var$systemToComponent(systemSpec, map2, Root) {
    const requiredPropNames = Object.keys(map2.required || {});
    const optionalPropNames = Object.keys(map2.optional || {});
    const methodNames = Object.keys(map2.methods || {});
    const eventNames = Object.keys(map2.events || {});
    const Context = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createContext({});
    function applyPropsToSystem(system2, props) {
        if (system2["propsReady"]) $5fa732a17329782a$var$publish(system2["propsReady"], false);
        for (const requiredPropName of requiredPropNames){
            const stream2 = system2[map2.required[requiredPropName]];
            $5fa732a17329782a$var$publish(stream2, props[requiredPropName]);
        }
        for (const optionalPropName of optionalPropNames)if (optionalPropName in props) {
            const stream2 = system2[map2.optional[optionalPropName]];
            $5fa732a17329782a$var$publish(stream2, props[optionalPropName]);
        }
        if (system2["propsReady"]) $5fa732a17329782a$var$publish(system2["propsReady"], true);
    }
    function buildMethods(system2) {
        return methodNames.reduce((acc, methodName)=>{
            acc[methodName] = (value)=>{
                const stream2 = system2[map2.methods[methodName]];
                $5fa732a17329782a$var$publish(stream2, value);
            };
            return acc;
        }, {});
    }
    function buildEventHandlers(system2) {
        return eventNames.reduce((handlers, eventName)=>{
            handlers[eventName] = $5fa732a17329782a$var$eventHandler(system2[map2.events[eventName]]);
            return handlers;
        }, {});
    }
    const Component = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).forwardRef((propsWithChildren, ref)=>{
        const { children: children, ...props } = propsWithChildren;
        const [system2] = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useState(()=>{
            return $5fa732a17329782a$var$tap($5fa732a17329782a$var$init(systemSpec), (system22)=>applyPropsToSystem(system22, props));
        });
        const [handlers] = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useState($5fa732a17329782a$var$curry1to0(buildEventHandlers, system2));
        $5fa732a17329782a$var$useIsomorphicLayoutEffect$1(()=>{
            for (const eventName of eventNames)if (eventName in props) $5fa732a17329782a$var$subscribe(handlers[eventName], props[eventName]);
            return ()=>{
                Object.values(handlers).map($5fa732a17329782a$var$reset);
            };
        }, [
            props,
            handlers,
            system2
        ]);
        $5fa732a17329782a$var$useIsomorphicLayoutEffect$1(()=>{
            applyPropsToSystem(system2, props);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useImperativeHandle(ref, $5fa732a17329782a$var$always(buildMethods(system2)));
        const RootComponent = Root;
        return /* @__PURE__ */ (0, $4TLFw.jsx)(Context.Provider, {
            value: system2,
            children: Root ? /* @__PURE__ */ (0, $4TLFw.jsx)(RootComponent, {
                ...$5fa732a17329782a$var$omit([
                    ...requiredPropNames,
                    ...optionalPropNames,
                    ...eventNames
                ], props),
                children: children
            }) : children
        });
    });
    const usePublisher2 = (key)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useCallback($5fa732a17329782a$var$curry2to1($5fa732a17329782a$var$publish, (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useContext(Context)[key]), [
            key
        ]);
    };
    const useEmitterValue18 = (key)=>{
        const system2 = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useContext(Context);
        const source = system2[key];
        const cb = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useCallback((c)=>{
            return $5fa732a17329782a$var$subscribe(source, c);
        }, [
            source
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useSyncExternalStore(cb, ()=>$5fa732a17329782a$var$getValue(source), ()=>$5fa732a17329782a$var$getValue(source));
    };
    const useEmitterValueLegacy = (key)=>{
        const system2 = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useContext(Context);
        const source = system2[key];
        const [value, setValue] = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useState($5fa732a17329782a$var$curry1to0($5fa732a17329782a$var$getValue, source));
        $5fa732a17329782a$var$useIsomorphicLayoutEffect$1(()=>$5fa732a17329782a$var$subscribe(source, (next)=>{
                if (next !== value) setValue($5fa732a17329782a$var$always(next));
            }), [
            source,
            value
        ]);
        return value;
    };
    const useEmitterValue2 = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).version.startsWith("18") ? useEmitterValue18 : useEmitterValueLegacy;
    const useEmitter2 = (key, callback)=>{
        const context = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useContext(Context);
        const source = context[key];
        $5fa732a17329782a$var$useIsomorphicLayoutEffect$1(()=>$5fa732a17329782a$var$subscribe(source, callback), [
            callback,
            source
        ]);
    };
    return {
        Component: Component,
        usePublisher: usePublisher2,
        useEmitterValue: useEmitterValue2,
        useEmitter: useEmitter2
    };
}
const $5fa732a17329782a$var$useIsomorphicLayoutEffect = typeof document !== "undefined" ? (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useLayoutEffect : (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useEffect;
var $5fa732a17329782a$export$243e62d78d3b544d = /* @__PURE__ */ ((LogLevel2)=>{
    LogLevel2[LogLevel2["DEBUG"] = 0] = "DEBUG";
    LogLevel2[LogLevel2["INFO"] = 1] = "INFO";
    LogLevel2[LogLevel2["WARN"] = 2] = "WARN";
    LogLevel2[LogLevel2["ERROR"] = 3] = "ERROR";
    return LogLevel2;
})($5fa732a17329782a$export$243e62d78d3b544d || {});
const $5fa732a17329782a$var$CONSOLE_METHOD_MAP = {
    [0]: "debug",
    [1]: "log",
    [2]: "warn",
    [3]: "error"
};
const $5fa732a17329782a$var$getGlobalThis = ()=>typeof globalThis === "undefined" ? window : globalThis;
const $5fa732a17329782a$var$loggerSystem = $5fa732a17329782a$var$system(()=>{
    const logLevel = $5fa732a17329782a$var$statefulStream(3);
    const log = $5fa732a17329782a$var$statefulStream((label, message, level = 1)=>{
        var _a;
        const currentLevel = (_a = $5fa732a17329782a$var$getGlobalThis()["VIRTUOSO_LOG_LEVEL"]) != null ? _a : $5fa732a17329782a$var$getValue(logLevel);
        if (level >= currentLevel) console[$5fa732a17329782a$var$CONSOLE_METHOD_MAP[level]]("%creact-virtuoso: %c%s %o", "color: #0253b3; font-weight: bold", "color: initial", label, message);
    });
    return {
        log: log,
        logLevel: logLevel
    };
}, [], {
    singleton: true
});
function $5fa732a17329782a$var$useSizeWithElRef(callback, enabled, skipAnimationFrame) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useRef(null);
    let callbackRef = (_el)=>{};
    if (typeof ResizeObserver !== "undefined") {
        const observer = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useMemo(()=>{
            return new ResizeObserver((entries)=>{
                const code = ()=>{
                    const element = entries[0].target;
                    if (element.offsetParent !== null) callback(element);
                };
                skipAnimationFrame ? code() : requestAnimationFrame(code);
            });
        }, [
            callback
        ]);
        callbackRef = (elRef)=>{
            if (elRef && enabled) {
                observer.observe(elRef);
                ref.current = elRef;
            } else {
                if (ref.current) observer.unobserve(ref.current);
                ref.current = null;
            }
        };
    }
    return {
        ref: ref,
        callbackRef: callbackRef
    };
}
function $5fa732a17329782a$var$useSize(callback, enabled, skipAnimationFrame) {
    return $5fa732a17329782a$var$useSizeWithElRef(callback, enabled, skipAnimationFrame).callbackRef;
}
function $5fa732a17329782a$var$useChangedListContentsSizes(callback, itemSize, enabled, scrollContainerStateCallback, log, gap, customScrollParent, horizontalDirection, skipAnimationFrame) {
    const memoedCallback = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useCallback((el)=>{
        const ranges = $5fa732a17329782a$var$getChangedChildSizes(el.children, itemSize, horizontalDirection ? "offsetWidth" : "offsetHeight", log);
        let scrollableElement = el.parentElement;
        while(!scrollableElement.dataset["virtuosoScroller"])scrollableElement = scrollableElement.parentElement;
        const windowScrolling = scrollableElement.lastElementChild.dataset["viewportType"] === "window";
        const scrollTop = customScrollParent ? horizontalDirection ? customScrollParent.scrollLeft : customScrollParent.scrollTop : windowScrolling ? horizontalDirection ? window.pageXOffset || document.documentElement.scrollLeft : window.pageYOffset || document.documentElement.scrollTop : horizontalDirection ? scrollableElement.scrollLeft : scrollableElement.scrollTop;
        const scrollHeight = customScrollParent ? horizontalDirection ? customScrollParent.scrollWidth : customScrollParent.scrollHeight : windowScrolling ? horizontalDirection ? document.documentElement.scrollWidth : document.documentElement.scrollHeight : horizontalDirection ? scrollableElement.scrollWidth : scrollableElement.scrollHeight;
        const viewportHeight = customScrollParent ? horizontalDirection ? customScrollParent.offsetWidth : customScrollParent.offsetHeight : windowScrolling ? horizontalDirection ? window.innerWidth : window.innerHeight : horizontalDirection ? scrollableElement.offsetWidth : scrollableElement.offsetHeight;
        scrollContainerStateCallback({
            scrollTop: Math.max(scrollTop, 0),
            scrollHeight: scrollHeight,
            viewportHeight: viewportHeight
        });
        gap == null || gap(horizontalDirection ? $5fa732a17329782a$var$resolveGapValue$1("column-gap", getComputedStyle(el).columnGap, log) : $5fa732a17329782a$var$resolveGapValue$1("row-gap", getComputedStyle(el).rowGap, log));
        if (ranges !== null) callback(ranges);
    }, [
        callback,
        itemSize,
        log,
        gap,
        customScrollParent,
        scrollContainerStateCallback
    ]);
    return $5fa732a17329782a$var$useSizeWithElRef(memoedCallback, enabled, skipAnimationFrame);
}
function $5fa732a17329782a$var$getChangedChildSizes(children, itemSize, field, log) {
    const length = children.length;
    if (length === 0) return null;
    const results = [];
    for(let i = 0; i < length; i++){
        const child = children.item(i);
        if (!child || child.dataset.index === void 0) continue;
        const index = parseInt(child.dataset.index);
        const knownSize = parseFloat(child.dataset.knownSize);
        const size = itemSize(child, field);
        if (size === 0) log("Zero-sized element, this should not happen", {
            child: child
        }, $5fa732a17329782a$export$243e62d78d3b544d.ERROR);
        if (size === knownSize) continue;
        const lastResult = results[results.length - 1];
        if (results.length === 0 || lastResult.size !== size || lastResult.endIndex !== index - 1) results.push({
            startIndex: index,
            endIndex: index,
            size: size
        });
        else results[results.length - 1].endIndex++;
    }
    return results;
}
function $5fa732a17329782a$var$resolveGapValue$1(property, value, log) {
    if (value !== "normal" && !(value == null ? void 0 : value.endsWith("px"))) log(`${property} was not resolved to pixel value correctly`, value, $5fa732a17329782a$export$243e62d78d3b544d.WARN);
    if (value === "normal") return 0;
    return parseInt(value != null ? value : "0", 10);
}
function $5fa732a17329782a$var$correctItemSize(el, dimension) {
    return Math.round(el.getBoundingClientRect()[dimension]);
}
function $5fa732a17329782a$var$approximatelyEqual(num1, num2) {
    return Math.abs(num1 - num2) < 1.01;
}
function $5fa732a17329782a$var$useScrollTop(scrollContainerStateCallback, smoothScrollTargetReached, scrollerElement, scrollerRefCallback = $5fa732a17329782a$var$noop, customScrollParent, horizontalDirection) {
    const scrollerRef = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useRef(null);
    const scrollTopTarget = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useRef(null);
    const timeoutRef = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useRef(null);
    const handler = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useCallback((ev)=>{
        const el = ev.target;
        const windowScroll = el === window || el === document;
        const scrollTop = horizontalDirection ? windowScroll ? window.pageXOffset || document.documentElement.scrollLeft : el.scrollLeft : windowScroll ? window.pageYOffset || document.documentElement.scrollTop : el.scrollTop;
        const scrollHeight = horizontalDirection ? windowScroll ? document.documentElement.scrollWidth : el.scrollWidth : windowScroll ? document.documentElement.scrollHeight : el.scrollHeight;
        const viewportHeight = horizontalDirection ? windowScroll ? window.innerWidth : el.offsetWidth : windowScroll ? window.innerHeight : el.offsetHeight;
        const call2 = ()=>{
            scrollContainerStateCallback({
                scrollTop: Math.max(scrollTop, 0),
                scrollHeight: scrollHeight,
                viewportHeight: viewportHeight
            });
        };
        if (ev.suppressFlushSync) call2();
        else (0, (/*@__PURE__*/$parcel$interopDefault($jCNM0))).flushSync(call2);
        if (scrollTopTarget.current !== null) {
            if (scrollTop === scrollTopTarget.current || scrollTop <= 0 || scrollTop === scrollHeight - viewportHeight) {
                scrollTopTarget.current = null;
                smoothScrollTargetReached(true);
                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                    timeoutRef.current = null;
                }
            }
        }
    }, [
        scrollContainerStateCallback,
        smoothScrollTargetReached
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useEffect(()=>{
        const localRef = customScrollParent ? customScrollParent : scrollerRef.current;
        scrollerRefCallback(customScrollParent ? customScrollParent : scrollerRef.current);
        handler({
            target: localRef,
            suppressFlushSync: true
        });
        localRef.addEventListener("scroll", handler, {
            passive: true
        });
        return ()=>{
            scrollerRefCallback(null);
            localRef.removeEventListener("scroll", handler);
        };
    }, [
        scrollerRef,
        handler,
        scrollerElement,
        scrollerRefCallback,
        customScrollParent
    ]);
    function scrollToCallback(location) {
        const scrollerElement2 = scrollerRef.current;
        if (!scrollerElement2 || (horizontalDirection ? "offsetWidth" in scrollerElement2 && scrollerElement2.offsetWidth === 0 : "offsetHeight" in scrollerElement2 && scrollerElement2.offsetHeight === 0)) return;
        const isSmooth = location.behavior === "smooth";
        let offsetHeight;
        let scrollHeight;
        let scrollTop;
        if (scrollerElement2 === window) {
            scrollHeight = Math.max($5fa732a17329782a$var$correctItemSize(document.documentElement, horizontalDirection ? "width" : "height"), horizontalDirection ? document.documentElement.scrollWidth : document.documentElement.scrollHeight);
            offsetHeight = horizontalDirection ? window.innerWidth : window.innerHeight;
            scrollTop = horizontalDirection ? document.documentElement.scrollLeft : document.documentElement.scrollTop;
        } else {
            scrollHeight = scrollerElement2[horizontalDirection ? "scrollWidth" : "scrollHeight"];
            offsetHeight = $5fa732a17329782a$var$correctItemSize(scrollerElement2, horizontalDirection ? "width" : "height");
            scrollTop = scrollerElement2[horizontalDirection ? "scrollLeft" : "scrollTop"];
        }
        const maxScrollTop = scrollHeight - offsetHeight;
        location.top = Math.ceil(Math.max(Math.min(maxScrollTop, location.top), 0));
        if ($5fa732a17329782a$var$approximatelyEqual(offsetHeight, scrollHeight) || location.top === scrollTop) {
            scrollContainerStateCallback({
                scrollTop: scrollTop,
                scrollHeight: scrollHeight,
                viewportHeight: offsetHeight
            });
            if (isSmooth) smoothScrollTargetReached(true);
            return;
        }
        if (isSmooth) {
            scrollTopTarget.current = location.top;
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(()=>{
                timeoutRef.current = null;
                scrollTopTarget.current = null;
                smoothScrollTargetReached(true);
            }, 1e3);
        } else scrollTopTarget.current = null;
        if (horizontalDirection) location = {
            left: location.top,
            behavior: location.behavior
        };
        scrollerElement2.scrollTo(location);
    }
    function scrollByCallback(location) {
        if (horizontalDirection) location = {
            left: location.top,
            behavior: location.behavior
        };
        scrollerRef.current.scrollBy(location);
    }
    return {
        scrollerRef: scrollerRef,
        scrollByCallback: scrollByCallback,
        scrollToCallback: scrollToCallback
    };
}
const $5fa732a17329782a$var$domIOSystem = $5fa732a17329782a$var$system(()=>{
    const scrollContainerState = $5fa732a17329782a$var$stream();
    const scrollTop = $5fa732a17329782a$var$stream();
    const deviation = $5fa732a17329782a$var$statefulStream(0);
    const smoothScrollTargetReached = $5fa732a17329782a$var$stream();
    const statefulScrollTop = $5fa732a17329782a$var$statefulStream(0);
    const viewportHeight = $5fa732a17329782a$var$stream();
    const scrollHeight = $5fa732a17329782a$var$stream();
    const headerHeight = $5fa732a17329782a$var$statefulStream(0);
    const fixedHeaderHeight = $5fa732a17329782a$var$statefulStream(0);
    const fixedFooterHeight = $5fa732a17329782a$var$statefulStream(0);
    const footerHeight = $5fa732a17329782a$var$statefulStream(0);
    const scrollTo = $5fa732a17329782a$var$stream();
    const scrollBy = $5fa732a17329782a$var$stream();
    const scrollingInProgress = $5fa732a17329782a$var$statefulStream(false);
    const horizontalDirection = $5fa732a17329782a$var$statefulStream(false);
    const skipAnimationFrameInResizeObserver = $5fa732a17329782a$var$statefulStream(false);
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe(scrollContainerState, $5fa732a17329782a$var$map(({ scrollTop: scrollTop2 })=>scrollTop2)), scrollTop);
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe(scrollContainerState, $5fa732a17329782a$var$map(({ scrollHeight: scrollHeight2 })=>scrollHeight2)), scrollHeight);
    $5fa732a17329782a$var$connect(scrollTop, statefulScrollTop);
    return {
        scrollContainerState: // input
        scrollContainerState,
        scrollTop: scrollTop,
        viewportHeight: viewportHeight,
        headerHeight: headerHeight,
        fixedHeaderHeight: fixedHeaderHeight,
        fixedFooterHeight: fixedFooterHeight,
        footerHeight: footerHeight,
        scrollHeight: scrollHeight,
        smoothScrollTargetReached: smoothScrollTargetReached,
        horizontalDirection: horizontalDirection,
        skipAnimationFrameInResizeObserver: skipAnimationFrameInResizeObserver,
        scrollTo: // signals
        scrollTo,
        scrollBy: scrollBy,
        statefulScrollTop: // state
        statefulScrollTop,
        deviation: deviation,
        scrollingInProgress: scrollingInProgress
    };
}, [], {
    singleton: true
});
const $5fa732a17329782a$var$NIL_NODE = {
    lvl: 0
};
function $5fa732a17329782a$var$newAANode(k, v, lvl, l = $5fa732a17329782a$var$NIL_NODE, r = $5fa732a17329782a$var$NIL_NODE) {
    return {
        k: k,
        v: v,
        lvl: lvl,
        l: l,
        r: r
    };
}
function $5fa732a17329782a$var$empty(node) {
    return node === $5fa732a17329782a$var$NIL_NODE;
}
function $5fa732a17329782a$var$newTree() {
    return $5fa732a17329782a$var$NIL_NODE;
}
function $5fa732a17329782a$var$remove(node, key) {
    if ($5fa732a17329782a$var$empty(node)) return $5fa732a17329782a$var$NIL_NODE;
    const { k: k, l: l, r: r } = node;
    if (key === k) {
        if ($5fa732a17329782a$var$empty(l)) return r;
        else if ($5fa732a17329782a$var$empty(r)) return l;
        else {
            const [lastKey, lastValue] = $5fa732a17329782a$var$last(l);
            return $5fa732a17329782a$var$adjust($5fa732a17329782a$var$clone(node, {
                k: lastKey,
                v: lastValue,
                l: $5fa732a17329782a$var$deleteLast(l)
            }));
        }
    } else if (key < k) return $5fa732a17329782a$var$adjust($5fa732a17329782a$var$clone(node, {
        l: $5fa732a17329782a$var$remove(l, key)
    }));
    else return $5fa732a17329782a$var$adjust($5fa732a17329782a$var$clone(node, {
        r: $5fa732a17329782a$var$remove(r, key)
    }));
}
function $5fa732a17329782a$var$find(node, key) {
    if ($5fa732a17329782a$var$empty(node)) return;
    if (key === node.k) return node.v;
    else if (key < node.k) return $5fa732a17329782a$var$find(node.l, key);
    else return $5fa732a17329782a$var$find(node.r, key);
}
function $5fa732a17329782a$var$findMaxKeyValue(node, value, field = "k") {
    if ($5fa732a17329782a$var$empty(node)) return [
        -Infinity,
        void 0
    ];
    if (Number(node[field]) === value) return [
        node.k,
        node.v
    ];
    if (Number(node[field]) < value) {
        const r = $5fa732a17329782a$var$findMaxKeyValue(node.r, value, field);
        if (r[0] === -Infinity) return [
            node.k,
            node.v
        ];
        else return r;
    }
    return $5fa732a17329782a$var$findMaxKeyValue(node.l, value, field);
}
function $5fa732a17329782a$var$insert(node, k, v) {
    if ($5fa732a17329782a$var$empty(node)) return $5fa732a17329782a$var$newAANode(k, v, 1);
    if (k === node.k) return $5fa732a17329782a$var$clone(node, {
        k: k,
        v: v
    });
    else if (k < node.k) return $5fa732a17329782a$var$rebalance($5fa732a17329782a$var$clone(node, {
        l: $5fa732a17329782a$var$insert(node.l, k, v)
    }));
    else return $5fa732a17329782a$var$rebalance($5fa732a17329782a$var$clone(node, {
        r: $5fa732a17329782a$var$insert(node.r, k, v)
    }));
}
function $5fa732a17329782a$var$walkWithin(node, start, end) {
    if ($5fa732a17329782a$var$empty(node)) return [];
    const { k: k, v: v, l: l, r: r } = node;
    let result = [];
    if (k > start) result = result.concat($5fa732a17329782a$var$walkWithin(l, start, end));
    if (k >= start && k <= end) result.push({
        k: k,
        v: v
    });
    if (k <= end) result = result.concat($5fa732a17329782a$var$walkWithin(r, start, end));
    return result;
}
function $5fa732a17329782a$var$walk(node) {
    if ($5fa732a17329782a$var$empty(node)) return [];
    return [
        ...$5fa732a17329782a$var$walk(node.l),
        {
            k: node.k,
            v: node.v
        },
        ...$5fa732a17329782a$var$walk(node.r)
    ];
}
function $5fa732a17329782a$var$last(node) {
    return $5fa732a17329782a$var$empty(node.r) ? [
        node.k,
        node.v
    ] : $5fa732a17329782a$var$last(node.r);
}
function $5fa732a17329782a$var$deleteLast(node) {
    return $5fa732a17329782a$var$empty(node.r) ? node.l : $5fa732a17329782a$var$adjust($5fa732a17329782a$var$clone(node, {
        r: $5fa732a17329782a$var$deleteLast(node.r)
    }));
}
function $5fa732a17329782a$var$clone(node, args) {
    return $5fa732a17329782a$var$newAANode(args.k !== void 0 ? args.k : node.k, args.v !== void 0 ? args.v : node.v, args.lvl !== void 0 ? args.lvl : node.lvl, args.l !== void 0 ? args.l : node.l, args.r !== void 0 ? args.r : node.r);
}
function $5fa732a17329782a$var$isSingle(node) {
    return $5fa732a17329782a$var$empty(node) || node.lvl > node.r.lvl;
}
function $5fa732a17329782a$var$rebalance(node) {
    return $5fa732a17329782a$var$split($5fa732a17329782a$var$skew(node));
}
function $5fa732a17329782a$var$adjust(node) {
    const { l: l, r: r, lvl: lvl } = node;
    if (r.lvl >= lvl - 1 && l.lvl >= lvl - 1) return node;
    else if (lvl > r.lvl + 1) {
        if ($5fa732a17329782a$var$isSingle(l)) return $5fa732a17329782a$var$skew($5fa732a17329782a$var$clone(node, {
            lvl: lvl - 1
        }));
        else {
            if (!$5fa732a17329782a$var$empty(l) && !$5fa732a17329782a$var$empty(l.r)) return $5fa732a17329782a$var$clone(l.r, {
                l: $5fa732a17329782a$var$clone(l, {
                    r: l.r.l
                }),
                r: $5fa732a17329782a$var$clone(node, {
                    l: l.r.r,
                    lvl: lvl - 1
                }),
                lvl: lvl
            });
            else throw new Error("Unexpected empty nodes");
        }
    } else {
        if ($5fa732a17329782a$var$isSingle(node)) return $5fa732a17329782a$var$split($5fa732a17329782a$var$clone(node, {
            lvl: lvl - 1
        }));
        else {
            if (!$5fa732a17329782a$var$empty(r) && !$5fa732a17329782a$var$empty(r.l)) {
                const rl = r.l;
                const rlvl = $5fa732a17329782a$var$isSingle(rl) ? r.lvl - 1 : r.lvl;
                return $5fa732a17329782a$var$clone(rl, {
                    l: $5fa732a17329782a$var$clone(node, {
                        r: rl.l,
                        lvl: lvl - 1
                    }),
                    r: $5fa732a17329782a$var$split($5fa732a17329782a$var$clone(r, {
                        l: rl.r,
                        lvl: rlvl
                    })),
                    lvl: rl.lvl + 1
                });
            } else throw new Error("Unexpected empty nodes");
        }
    }
}
function $5fa732a17329782a$var$rangesWithin(node, startIndex, endIndex) {
    if ($5fa732a17329782a$var$empty(node)) return [];
    const adjustedStart = $5fa732a17329782a$var$findMaxKeyValue(node, startIndex)[0];
    return $5fa732a17329782a$var$toRanges($5fa732a17329782a$var$walkWithin(node, adjustedStart, endIndex));
}
function $5fa732a17329782a$var$arrayToRanges(items, parser) {
    const length = items.length;
    if (length === 0) return [];
    let { index: start, value: value } = parser(items[0]);
    const result = [];
    for(let i = 1; i < length; i++){
        const { index: nextIndex, value: nextValue } = parser(items[i]);
        result.push({
            start: start,
            end: nextIndex - 1,
            value: value
        });
        start = nextIndex;
        value = nextValue;
    }
    result.push({
        start: start,
        end: Infinity,
        value: value
    });
    return result;
}
function $5fa732a17329782a$var$toRanges(nodes) {
    return $5fa732a17329782a$var$arrayToRanges(nodes, ({ k: index, v: value })=>({
            index: index,
            value: value
        }));
}
function $5fa732a17329782a$var$split(node) {
    const { r: r, lvl: lvl } = node;
    return !$5fa732a17329782a$var$empty(r) && !$5fa732a17329782a$var$empty(r.r) && r.lvl === lvl && r.r.lvl === lvl ? $5fa732a17329782a$var$clone(r, {
        l: $5fa732a17329782a$var$clone(node, {
            r: r.l
        }),
        lvl: lvl + 1
    }) : node;
}
function $5fa732a17329782a$var$skew(node) {
    const { l: l } = node;
    return !$5fa732a17329782a$var$empty(l) && l.lvl === node.lvl ? $5fa732a17329782a$var$clone(l, {
        r: $5fa732a17329782a$var$clone(node, {
            l: l.r
        })
    }) : node;
}
function $5fa732a17329782a$var$findIndexOfClosestSmallerOrEqual(items, value, comparator, start = 0) {
    let end = items.length - 1;
    while(start <= end){
        const index = Math.floor((start + end) / 2);
        const item = items[index];
        const match = comparator(item, value);
        if (match === 0) return index;
        if (match === -1) {
            if (end - start < 2) return index - 1;
            end = index - 1;
        } else {
            if (end === start) return index;
            start = index + 1;
        }
    }
    throw new Error(`Failed binary finding record in array - ${items.join(",")}, searched for ${value}`);
}
function $5fa732a17329782a$var$findClosestSmallerOrEqual(items, value, comparator) {
    return items[$5fa732a17329782a$var$findIndexOfClosestSmallerOrEqual(items, value, comparator)];
}
function $5fa732a17329782a$var$findRange(items, startValue, endValue, comparator) {
    const startIndex = $5fa732a17329782a$var$findIndexOfClosestSmallerOrEqual(items, startValue, comparator);
    const endIndex = $5fa732a17329782a$var$findIndexOfClosestSmallerOrEqual(items, endValue, comparator, startIndex);
    return items.slice(startIndex, endIndex + 1);
}
const $5fa732a17329782a$var$recalcSystem = $5fa732a17329782a$var$system(()=>{
    const recalcInProgress = $5fa732a17329782a$var$statefulStream(false);
    return {
        recalcInProgress: recalcInProgress
    };
}, [], {
    singleton: true
});
function $5fa732a17329782a$var$rangeIncludes(refRange) {
    const { size: size, startIndex: startIndex, endIndex: endIndex } = refRange;
    return (range)=>{
        return range.start === startIndex && (range.end === endIndex || range.end === Infinity) && range.value === size;
    };
}
function $5fa732a17329782a$var$affectedGroupCount(offset, groupIndices) {
    let recognizedOffsetItems = 0;
    let groupIndex = 0;
    while(recognizedOffsetItems < offset){
        recognizedOffsetItems += groupIndices[groupIndex + 1] - groupIndices[groupIndex] - 1;
        groupIndex++;
    }
    const offsetIsExact = recognizedOffsetItems === offset;
    return groupIndex - (offsetIsExact ? 0 : 1);
}
function $5fa732a17329782a$var$insertRanges(sizeTree, ranges) {
    let syncStart = $5fa732a17329782a$var$empty(sizeTree) ? 0 : Infinity;
    for (const range of ranges){
        const { size: size, startIndex: startIndex, endIndex: endIndex } = range;
        syncStart = Math.min(syncStart, startIndex);
        if ($5fa732a17329782a$var$empty(sizeTree)) {
            sizeTree = $5fa732a17329782a$var$insert(sizeTree, 0, size);
            continue;
        }
        const overlappingRanges = $5fa732a17329782a$var$rangesWithin(sizeTree, startIndex - 1, endIndex + 1);
        if (overlappingRanges.some($5fa732a17329782a$var$rangeIncludes(range))) continue;
        let firstPassDone = false;
        let shouldInsert = false;
        for (const { start: rangeStart, end: rangeEnd, value: rangeValue } of overlappingRanges){
            if (!firstPassDone) {
                shouldInsert = rangeValue !== size;
                firstPassDone = true;
            } else if (endIndex >= rangeStart || size === rangeValue) sizeTree = $5fa732a17329782a$var$remove(sizeTree, rangeStart);
            if (rangeEnd > endIndex && endIndex >= rangeStart) {
                if (rangeValue !== size) sizeTree = $5fa732a17329782a$var$insert(sizeTree, endIndex + 1, rangeValue);
            }
        }
        if (shouldInsert) sizeTree = $5fa732a17329782a$var$insert(sizeTree, startIndex, size);
    }
    return [
        sizeTree,
        syncStart
    ];
}
function $5fa732a17329782a$var$initialSizeState() {
    return {
        offsetTree: [],
        sizeTree: $5fa732a17329782a$var$newTree(),
        groupOffsetTree: $5fa732a17329782a$var$newTree(),
        lastIndex: 0,
        lastOffset: 0,
        lastSize: 0,
        groupIndices: []
    };
}
function $5fa732a17329782a$var$indexComparator({ index: itemIndex }, index) {
    return index === itemIndex ? 0 : index < itemIndex ? -1 : 1;
}
function $5fa732a17329782a$var$offsetComparator({ offset: itemOffset }, offset) {
    return offset === itemOffset ? 0 : offset < itemOffset ? -1 : 1;
}
function $5fa732a17329782a$var$offsetPointParser(point) {
    return {
        index: point.index,
        value: point
    };
}
function $5fa732a17329782a$var$rangesWithinOffsets(tree, startOffset, endOffset, minStartIndex = 0) {
    if (minStartIndex > 0) startOffset = Math.max(startOffset, $5fa732a17329782a$var$findClosestSmallerOrEqual(tree, minStartIndex, $5fa732a17329782a$var$indexComparator).offset);
    return $5fa732a17329782a$var$arrayToRanges($5fa732a17329782a$var$findRange(tree, startOffset, endOffset, $5fa732a17329782a$var$offsetComparator), $5fa732a17329782a$var$offsetPointParser);
}
function $5fa732a17329782a$var$createOffsetTree(prevOffsetTree, syncStart, sizeTree, gap) {
    let offsetTree = prevOffsetTree;
    let prevIndex = 0;
    let prevSize = 0;
    let prevOffset = 0;
    let startIndex = 0;
    if (syncStart !== 0) {
        startIndex = $5fa732a17329782a$var$findIndexOfClosestSmallerOrEqual(offsetTree, syncStart - 1, $5fa732a17329782a$var$indexComparator);
        const offsetInfo = offsetTree[startIndex];
        prevOffset = offsetInfo.offset;
        const kv = $5fa732a17329782a$var$findMaxKeyValue(sizeTree, syncStart - 1);
        prevIndex = kv[0];
        prevSize = kv[1];
        if (offsetTree.length && offsetTree[startIndex].size === $5fa732a17329782a$var$findMaxKeyValue(sizeTree, syncStart)[1]) startIndex -= 1;
        offsetTree = offsetTree.slice(0, startIndex + 1);
    } else offsetTree = [];
    for (const { start: startIndex2, value: value } of $5fa732a17329782a$var$rangesWithin(sizeTree, syncStart, Infinity)){
        const indexOffset = startIndex2 - prevIndex;
        const aOffset = indexOffset * prevSize + prevOffset + indexOffset * gap;
        offsetTree.push({
            offset: aOffset,
            size: value,
            index: startIndex2
        });
        prevIndex = startIndex2;
        prevOffset = aOffset;
        prevSize = value;
    }
    return {
        offsetTree: offsetTree,
        lastIndex: prevIndex,
        lastOffset: prevOffset,
        lastSize: prevSize
    };
}
function $5fa732a17329782a$var$sizeStateReducer(state, [ranges, groupIndices, log, gap]) {
    if (ranges.length > 0) log("received item sizes", ranges, $5fa732a17329782a$export$243e62d78d3b544d.DEBUG);
    const sizeTree = state.sizeTree;
    let newSizeTree = sizeTree;
    let syncStart = 0;
    if (groupIndices.length > 0 && $5fa732a17329782a$var$empty(sizeTree) && ranges.length === 2) {
        const groupSize = ranges[0].size;
        const itemSize = ranges[1].size;
        newSizeTree = groupIndices.reduce((tree, groupIndex)=>{
            return $5fa732a17329782a$var$insert($5fa732a17329782a$var$insert(tree, groupIndex, groupSize), groupIndex + 1, itemSize);
        }, newSizeTree);
    } else [newSizeTree, syncStart] = $5fa732a17329782a$var$insertRanges(newSizeTree, ranges);
    if (newSizeTree === sizeTree) return state;
    const { offsetTree: newOffsetTree, lastIndex: lastIndex, lastSize: lastSize, lastOffset: lastOffset } = $5fa732a17329782a$var$createOffsetTree(state.offsetTree, syncStart, newSizeTree, gap);
    return {
        sizeTree: newSizeTree,
        offsetTree: newOffsetTree,
        lastIndex: lastIndex,
        lastOffset: lastOffset,
        lastSize: lastSize,
        groupOffsetTree: groupIndices.reduce((tree, index)=>{
            return $5fa732a17329782a$var$insert(tree, index, $5fa732a17329782a$var$offsetOf(index, newOffsetTree, gap));
        }, $5fa732a17329782a$var$newTree()),
        groupIndices: groupIndices
    };
}
function $5fa732a17329782a$var$offsetOf(index, tree, gap) {
    if (tree.length === 0) return 0;
    const { offset: offset, index: startIndex, size: size } = $5fa732a17329782a$var$findClosestSmallerOrEqual(tree, index, $5fa732a17329782a$var$indexComparator);
    const itemCount = index - startIndex;
    const top = size * itemCount + (itemCount - 1) * gap + offset;
    return top > 0 ? top + gap : top;
}
function $5fa732a17329782a$var$isGroupLocation(location) {
    return typeof location.groupIndex !== "undefined";
}
function $5fa732a17329782a$var$originalIndexFromLocation(location, sizes, lastIndex) {
    if ($5fa732a17329782a$var$isGroupLocation(location)) return sizes.groupIndices[location.groupIndex] + 1;
    else {
        const numericIndex = location.index === "LAST" ? lastIndex : location.index;
        let result = $5fa732a17329782a$var$originalIndexFromItemIndex(numericIndex, sizes);
        result = Math.max(0, result, Math.min(lastIndex, result));
        return result;
    }
}
function $5fa732a17329782a$var$originalIndexFromItemIndex(itemIndex, sizes) {
    if (!$5fa732a17329782a$var$hasGroups(sizes)) return itemIndex;
    let groupOffset = 0;
    while(sizes.groupIndices[groupOffset] <= itemIndex + groupOffset)groupOffset++;
    return itemIndex + groupOffset;
}
function $5fa732a17329782a$var$hasGroups(sizes) {
    return !$5fa732a17329782a$var$empty(sizes.groupOffsetTree);
}
function $5fa732a17329782a$var$sizeTreeToRanges(sizeTree) {
    return $5fa732a17329782a$var$walk(sizeTree).map(({ k: startIndex, v: size }, index, sizeArray)=>{
        const nextSize = sizeArray[index + 1];
        const endIndex = nextSize ? nextSize.k - 1 : Infinity;
        return {
            startIndex: startIndex,
            endIndex: endIndex,
            size: size
        };
    });
}
const $5fa732a17329782a$var$SIZE_MAP = {
    offsetHeight: "height",
    offsetWidth: "width"
};
const $5fa732a17329782a$var$sizeSystem = $5fa732a17329782a$var$system(([{ log: log }, { recalcInProgress: recalcInProgress }])=>{
    const sizeRanges = $5fa732a17329782a$var$stream();
    const totalCount = $5fa732a17329782a$var$stream();
    const statefulTotalCount = $5fa732a17329782a$var$statefulStreamFromEmitter(totalCount, 0);
    const unshiftWith = $5fa732a17329782a$var$stream();
    const shiftWith = $5fa732a17329782a$var$stream();
    const firstItemIndex = $5fa732a17329782a$var$statefulStream(0);
    const groupIndices = $5fa732a17329782a$var$statefulStream([]);
    const fixedItemSize = $5fa732a17329782a$var$statefulStream(void 0);
    const defaultItemSize = $5fa732a17329782a$var$statefulStream(void 0);
    const itemSize = $5fa732a17329782a$var$statefulStream((el, field)=>$5fa732a17329782a$var$correctItemSize(el, $5fa732a17329782a$var$SIZE_MAP[field]));
    const data = $5fa732a17329782a$var$statefulStream(void 0);
    const gap = $5fa732a17329782a$var$statefulStream(0);
    const initial = $5fa732a17329782a$var$initialSizeState();
    const sizes = $5fa732a17329782a$var$statefulStreamFromEmitter($5fa732a17329782a$var$pipe(sizeRanges, $5fa732a17329782a$var$withLatestFrom(groupIndices, log, gap), $5fa732a17329782a$var$scan($5fa732a17329782a$var$sizeStateReducer, initial), $5fa732a17329782a$var$distinctUntilChanged()), initial);
    const prevGroupIndices = $5fa732a17329782a$var$statefulStreamFromEmitter($5fa732a17329782a$var$pipe(groupIndices, $5fa732a17329782a$var$distinctUntilChanged(), $5fa732a17329782a$var$scan((prev, curr)=>({
            prev: prev.current,
            current: curr
        }), {
        prev: [],
        current: []
    }), $5fa732a17329782a$var$map(({ prev: prev })=>prev)), []);
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe(groupIndices, $5fa732a17329782a$var$filter((indexes)=>indexes.length > 0), $5fa732a17329782a$var$withLatestFrom(sizes, gap), $5fa732a17329782a$var$map(([groupIndices2, sizes2, gap2])=>{
        const groupOffsetTree = groupIndices2.reduce((tree, index, idx)=>{
            return $5fa732a17329782a$var$insert(tree, index, $5fa732a17329782a$var$offsetOf(index, sizes2.offsetTree, gap2) || idx);
        }, $5fa732a17329782a$var$newTree());
        return {
            ...sizes2,
            groupIndices: groupIndices2,
            groupOffsetTree: groupOffsetTree
        };
    })), sizes);
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe(totalCount, $5fa732a17329782a$var$withLatestFrom(sizes), $5fa732a17329782a$var$filter(([totalCount2, { lastIndex: lastIndex }])=>{
        return totalCount2 < lastIndex;
    }), $5fa732a17329782a$var$map(([totalCount2, { lastIndex: lastIndex, lastSize: lastSize }])=>{
        return [
            {
                startIndex: totalCount2,
                endIndex: lastIndex,
                size: lastSize
            }
        ];
    })), sizeRanges);
    $5fa732a17329782a$var$connect(fixedItemSize, defaultItemSize);
    const trackItemSizes = $5fa732a17329782a$var$statefulStreamFromEmitter($5fa732a17329782a$var$pipe(fixedItemSize, $5fa732a17329782a$var$map((size)=>size === void 0)), true);
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe(defaultItemSize, $5fa732a17329782a$var$filter((value)=>{
        return value !== void 0 && $5fa732a17329782a$var$empty($5fa732a17329782a$var$getValue(sizes).sizeTree);
    }), $5fa732a17329782a$var$map((size)=>[
            {
                startIndex: 0,
                endIndex: 0,
                size: size
            }
        ])), sizeRanges);
    const listRefresh = $5fa732a17329782a$var$streamFromEmitter($5fa732a17329782a$var$pipe(sizeRanges, $5fa732a17329782a$var$withLatestFrom(sizes), $5fa732a17329782a$var$scan(({ sizes: oldSizes }, [_, newSizes])=>{
        return {
            changed: newSizes !== oldSizes,
            sizes: newSizes
        };
    }, {
        changed: false,
        sizes: initial
    }), $5fa732a17329782a$var$map((value)=>value.changed)));
    $5fa732a17329782a$var$subscribe($5fa732a17329782a$var$pipe(firstItemIndex, $5fa732a17329782a$var$scan((prev, next)=>{
        return {
            diff: prev.prev - next,
            prev: next
        };
    }, {
        diff: 0,
        prev: 0
    }), $5fa732a17329782a$var$map((val)=>val.diff)), (offset)=>{
        const { groupIndices: groupIndices2 } = $5fa732a17329782a$var$getValue(sizes);
        if (offset > 0) {
            $5fa732a17329782a$var$publish(recalcInProgress, true);
            $5fa732a17329782a$var$publish(unshiftWith, offset + $5fa732a17329782a$var$affectedGroupCount(offset, groupIndices2));
        } else if (offset < 0) {
            const prevGroupIndicesValue = $5fa732a17329782a$var$getValue(prevGroupIndices);
            if (prevGroupIndicesValue.length > 0) offset -= $5fa732a17329782a$var$affectedGroupCount(-offset, prevGroupIndicesValue);
            $5fa732a17329782a$var$publish(shiftWith, offset);
        }
    });
    $5fa732a17329782a$var$subscribe($5fa732a17329782a$var$pipe(firstItemIndex, $5fa732a17329782a$var$withLatestFrom(log)), ([index, log2])=>{
        if (index < 0) log2("`firstItemIndex` prop should not be set to less than zero. If you don't know the total count, just use a very high value", {
            firstItemIndex: firstItemIndex
        }, $5fa732a17329782a$export$243e62d78d3b544d.ERROR);
    });
    const beforeUnshiftWith = $5fa732a17329782a$var$streamFromEmitter(unshiftWith);
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe(unshiftWith, $5fa732a17329782a$var$withLatestFrom(sizes), $5fa732a17329782a$var$map(([unshiftWith2, sizes2])=>{
        const groupedMode = sizes2.groupIndices.length > 0;
        const initialRanges = [];
        const defaultSize = sizes2.lastSize;
        if (groupedMode) {
            const firstGroupSize = $5fa732a17329782a$var$find(sizes2.sizeTree, 0);
            let prependedGroupItemsCount = 0;
            let groupIndex = 0;
            while(prependedGroupItemsCount < unshiftWith2){
                const theGroupIndex = sizes2.groupIndices[groupIndex];
                const groupItemCount = sizes2.groupIndices.length === groupIndex + 1 ? Infinity : sizes2.groupIndices[groupIndex + 1] - theGroupIndex - 1;
                initialRanges.push({
                    startIndex: theGroupIndex,
                    endIndex: theGroupIndex,
                    size: firstGroupSize
                });
                initialRanges.push({
                    startIndex: theGroupIndex + 1,
                    endIndex: theGroupIndex + 1 + groupItemCount - 1,
                    size: defaultSize
                });
                groupIndex++;
                prependedGroupItemsCount += groupItemCount + 1;
            }
            const sizeTreeKV = $5fa732a17329782a$var$walk(sizes2.sizeTree);
            const firstGroupIsExpanded = prependedGroupItemsCount !== unshiftWith2;
            if (firstGroupIsExpanded) sizeTreeKV.shift();
            return sizeTreeKV.reduce((acc, { k: index, v: size })=>{
                let ranges = acc.ranges;
                if (acc.prevSize !== 0) ranges = [
                    ...acc.ranges,
                    {
                        startIndex: acc.prevIndex,
                        endIndex: index + unshiftWith2 - 1,
                        size: acc.prevSize
                    }
                ];
                return {
                    ranges: ranges,
                    prevIndex: index + unshiftWith2,
                    prevSize: size
                };
            }, {
                ranges: initialRanges,
                prevIndex: unshiftWith2,
                prevSize: 0
            }).ranges;
        }
        return $5fa732a17329782a$var$walk(sizes2.sizeTree).reduce((acc, { k: index, v: size })=>{
            return {
                ranges: [
                    ...acc.ranges,
                    {
                        startIndex: acc.prevIndex,
                        endIndex: index + unshiftWith2 - 1,
                        size: acc.prevSize
                    }
                ],
                prevIndex: index + unshiftWith2,
                prevSize: size
            };
        }, {
            ranges: [],
            prevIndex: 0,
            prevSize: defaultSize
        }).ranges;
    })), sizeRanges);
    const shiftWithOffset = $5fa732a17329782a$var$streamFromEmitter($5fa732a17329782a$var$pipe(shiftWith, $5fa732a17329782a$var$withLatestFrom(sizes, gap), $5fa732a17329782a$var$map(([shiftWith2, { offsetTree: offsetTree }, gap2])=>{
        const newFirstItemIndex = -shiftWith2;
        return $5fa732a17329782a$var$offsetOf(newFirstItemIndex, offsetTree, gap2);
    })));
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe(shiftWith, $5fa732a17329782a$var$withLatestFrom(sizes, gap), $5fa732a17329782a$var$map(([shiftWith2, sizes2, gap2])=>{
        const groupedMode = sizes2.groupIndices.length > 0;
        if (groupedMode) {
            if ($5fa732a17329782a$var$empty(sizes2.sizeTree)) return sizes2;
            let newSizeTree = $5fa732a17329782a$var$newTree();
            const prevGroupIndicesValue = $5fa732a17329782a$var$getValue(prevGroupIndices);
            let removedItemsCount = 0;
            let groupIndex = 0;
            let groupOffset = 0;
            while(removedItemsCount < -shiftWith2){
                groupOffset = prevGroupIndicesValue[groupIndex];
                const groupItemCount = prevGroupIndicesValue[groupIndex + 1] - groupOffset - 1;
                groupIndex++;
                removedItemsCount += groupItemCount + 1;
            }
            newSizeTree = $5fa732a17329782a$var$walk(sizes2.sizeTree).reduce((acc, { k: k, v: v })=>{
                return $5fa732a17329782a$var$insert(acc, Math.max(0, k + shiftWith2), v);
            }, newSizeTree);
            const aGroupIsShrunk = removedItemsCount !== -shiftWith2;
            if (aGroupIsShrunk) {
                const firstGroupSize = $5fa732a17329782a$var$find(sizes2.sizeTree, groupOffset);
                newSizeTree = $5fa732a17329782a$var$insert(newSizeTree, 0, firstGroupSize);
                const nextItemSize = $5fa732a17329782a$var$findMaxKeyValue(sizes2.sizeTree, -shiftWith2 + 1)[1];
                newSizeTree = $5fa732a17329782a$var$insert(newSizeTree, 1, nextItemSize);
            }
            return {
                ...sizes2,
                sizeTree: newSizeTree,
                ...$5fa732a17329782a$var$createOffsetTree(sizes2.offsetTree, 0, newSizeTree, gap2)
            };
        } else {
            const newSizeTree = $5fa732a17329782a$var$walk(sizes2.sizeTree).reduce((acc, { k: k, v: v })=>{
                return $5fa732a17329782a$var$insert(acc, Math.max(0, k + shiftWith2), v);
            }, $5fa732a17329782a$var$newTree());
            return {
                ...sizes2,
                sizeTree: newSizeTree,
                ...$5fa732a17329782a$var$createOffsetTree(sizes2.offsetTree, 0, newSizeTree, gap2)
            };
        }
    })), sizes);
    return {
        data: // input
        data,
        totalCount: totalCount,
        sizeRanges: sizeRanges,
        groupIndices: groupIndices,
        defaultItemSize: defaultItemSize,
        fixedItemSize: fixedItemSize,
        unshiftWith: unshiftWith,
        shiftWith: shiftWith,
        shiftWithOffset: shiftWithOffset,
        beforeUnshiftWith: beforeUnshiftWith,
        firstItemIndex: firstItemIndex,
        gap: gap,
        sizes: // output
        sizes,
        listRefresh: listRefresh,
        statefulTotalCount: statefulTotalCount,
        trackItemSizes: trackItemSizes,
        itemSize: itemSize
    };
}, $5fa732a17329782a$var$tup($5fa732a17329782a$var$loggerSystem, $5fa732a17329782a$var$recalcSystem), {
    singleton: true
});
const $5fa732a17329782a$var$SUPPORTS_SCROLL_TO_OPTIONS = typeof document !== "undefined" && "scrollBehavior" in document.documentElement.style;
function $5fa732a17329782a$var$normalizeIndexLocation(location) {
    const result = typeof location === "number" ? {
        index: location
    } : location;
    if (!result.align) result.align = "start";
    if (!result.behavior || !$5fa732a17329782a$var$SUPPORTS_SCROLL_TO_OPTIONS) result.behavior = "auto";
    if (!result.offset) result.offset = 0;
    return result;
}
const $5fa732a17329782a$var$scrollToIndexSystem = $5fa732a17329782a$var$system(([{ sizes: sizes, totalCount: totalCount, listRefresh: listRefresh, gap: gap }, { scrollingInProgress: scrollingInProgress, viewportHeight: viewportHeight, scrollTo: scrollTo, smoothScrollTargetReached: smoothScrollTargetReached, headerHeight: headerHeight, footerHeight: footerHeight, fixedHeaderHeight: fixedHeaderHeight, fixedFooterHeight: fixedFooterHeight }, { log: log }])=>{
    const scrollToIndex = $5fa732a17329782a$var$stream();
    const scrollTargetReached = $5fa732a17329782a$var$stream();
    const topListHeight = $5fa732a17329782a$var$statefulStream(0);
    let unsubscribeNextListRefresh = null;
    let cleartTimeoutRef = null;
    let unsubscribeListRefresh = null;
    function cleanup() {
        if (unsubscribeNextListRefresh) {
            unsubscribeNextListRefresh();
            unsubscribeNextListRefresh = null;
        }
        if (unsubscribeListRefresh) {
            unsubscribeListRefresh();
            unsubscribeListRefresh = null;
        }
        if (cleartTimeoutRef) {
            clearTimeout(cleartTimeoutRef);
            cleartTimeoutRef = null;
        }
        $5fa732a17329782a$var$publish(scrollingInProgress, false);
    }
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe(scrollToIndex, $5fa732a17329782a$var$withLatestFrom(sizes, viewportHeight, totalCount, topListHeight, headerHeight, footerHeight, log), $5fa732a17329782a$var$withLatestFrom(gap, fixedHeaderHeight, fixedFooterHeight), $5fa732a17329782a$var$map(([[location, sizes2, viewportHeight2, totalCount2, topListHeight2, headerHeight2, footerHeight2, log2], gap2, fixedHeaderHeight2, fixedFooterHeight2])=>{
        const normalLocation = $5fa732a17329782a$var$normalizeIndexLocation(location);
        const { align: align, behavior: behavior, offset: offset } = normalLocation;
        const lastIndex = totalCount2 - 1;
        const index = $5fa732a17329782a$var$originalIndexFromLocation(normalLocation, sizes2, lastIndex);
        let top = $5fa732a17329782a$var$offsetOf(index, sizes2.offsetTree, gap2) + headerHeight2;
        if (align === "end") {
            top += fixedHeaderHeight2 + $5fa732a17329782a$var$findMaxKeyValue(sizes2.sizeTree, index)[1] - viewportHeight2 + fixedFooterHeight2;
            if (index === lastIndex) top += footerHeight2;
        } else if (align === "center") top += (fixedHeaderHeight2 + $5fa732a17329782a$var$findMaxKeyValue(sizes2.sizeTree, index)[1] - viewportHeight2 + fixedFooterHeight2) / 2;
        else top -= topListHeight2;
        if (offset) top += offset;
        const retry = (listChanged)=>{
            cleanup();
            if (listChanged) {
                log2("retrying to scroll to", {
                    location: location
                }, $5fa732a17329782a$export$243e62d78d3b544d.DEBUG);
                $5fa732a17329782a$var$publish(scrollToIndex, location);
            } else {
                $5fa732a17329782a$var$publish(scrollTargetReached, true);
                log2("list did not change, scroll successful", {}, $5fa732a17329782a$export$243e62d78d3b544d.DEBUG);
            }
        };
        cleanup();
        if (behavior === "smooth") {
            let listChanged = false;
            unsubscribeListRefresh = $5fa732a17329782a$var$subscribe(listRefresh, (changed)=>{
                listChanged = listChanged || changed;
            });
            unsubscribeNextListRefresh = $5fa732a17329782a$var$handleNext(smoothScrollTargetReached, ()=>{
                retry(listChanged);
            });
        } else unsubscribeNextListRefresh = $5fa732a17329782a$var$handleNext($5fa732a17329782a$var$pipe(listRefresh, $5fa732a17329782a$var$watchChangesFor(150)), retry);
        cleartTimeoutRef = setTimeout(()=>{
            cleanup();
        }, 1200);
        $5fa732a17329782a$var$publish(scrollingInProgress, true);
        log2("scrolling from index to", {
            index: index,
            top: top,
            behavior: behavior
        }, $5fa732a17329782a$export$243e62d78d3b544d.DEBUG);
        return {
            top: top,
            behavior: behavior
        };
    })), scrollTo);
    return {
        scrollToIndex: scrollToIndex,
        scrollTargetReached: scrollTargetReached,
        topListHeight: topListHeight
    };
}, $5fa732a17329782a$var$tup($5fa732a17329782a$var$sizeSystem, $5fa732a17329782a$var$domIOSystem, $5fa732a17329782a$var$loggerSystem), {
    singleton: true
});
function $5fa732a17329782a$var$watchChangesFor(limit) {
    return (done)=>{
        const timeoutRef = setTimeout(()=>{
            done(false);
        }, limit);
        return (value)=>{
            if (value) {
                done(true);
                clearTimeout(timeoutRef);
            }
        };
    };
}
const $5fa732a17329782a$var$UP = "up";
const $5fa732a17329782a$var$DOWN = "down";
const $5fa732a17329782a$var$NONE$1 = "none";
const $5fa732a17329782a$var$INITIAL_BOTTOM_STATE = {
    atBottom: false,
    notAtBottomBecause: "NOT_SHOWING_LAST_ITEM",
    state: {
        offsetBottom: 0,
        scrollTop: 0,
        viewportHeight: 0,
        scrollHeight: 0
    }
};
const $5fa732a17329782a$var$DEFAULT_AT_TOP_THRESHOLD = 0;
const $5fa732a17329782a$var$stateFlagsSystem = $5fa732a17329782a$var$system(([{ scrollContainerState: scrollContainerState, scrollTop: scrollTop, viewportHeight: viewportHeight, headerHeight: headerHeight, footerHeight: footerHeight, scrollBy: scrollBy }])=>{
    const isAtBottom = $5fa732a17329782a$var$statefulStream(false);
    const isAtTop = $5fa732a17329782a$var$statefulStream(true);
    const atBottomStateChange = $5fa732a17329782a$var$stream();
    const atTopStateChange = $5fa732a17329782a$var$stream();
    const atBottomThreshold = $5fa732a17329782a$var$statefulStream(4);
    const atTopThreshold = $5fa732a17329782a$var$statefulStream($5fa732a17329782a$var$DEFAULT_AT_TOP_THRESHOLD);
    const isScrolling = $5fa732a17329782a$var$statefulStreamFromEmitter($5fa732a17329782a$var$pipe($5fa732a17329782a$var$merge($5fa732a17329782a$var$pipe($5fa732a17329782a$var$duc(scrollTop), $5fa732a17329782a$var$skip(1), $5fa732a17329782a$var$mapTo(true)), $5fa732a17329782a$var$pipe($5fa732a17329782a$var$duc(scrollTop), $5fa732a17329782a$var$skip(1), $5fa732a17329782a$var$mapTo(false), $5fa732a17329782a$var$debounceTime(100))), $5fa732a17329782a$var$distinctUntilChanged()), false);
    const isScrollingBy = $5fa732a17329782a$var$statefulStreamFromEmitter($5fa732a17329782a$var$pipe($5fa732a17329782a$var$merge($5fa732a17329782a$var$pipe(scrollBy, $5fa732a17329782a$var$mapTo(true)), $5fa732a17329782a$var$pipe(scrollBy, $5fa732a17329782a$var$mapTo(false), $5fa732a17329782a$var$debounceTime(200))), $5fa732a17329782a$var$distinctUntilChanged()), false);
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe($5fa732a17329782a$var$combineLatest($5fa732a17329782a$var$duc(scrollTop), $5fa732a17329782a$var$duc(atTopThreshold)), $5fa732a17329782a$var$map(([top, atTopThreshold2])=>top <= atTopThreshold2), $5fa732a17329782a$var$distinctUntilChanged()), isAtTop);
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe(isAtTop, $5fa732a17329782a$var$throttleTime(50)), atTopStateChange);
    const atBottomState = $5fa732a17329782a$var$streamFromEmitter($5fa732a17329782a$var$pipe($5fa732a17329782a$var$combineLatest(scrollContainerState, $5fa732a17329782a$var$duc(viewportHeight), $5fa732a17329782a$var$duc(headerHeight), $5fa732a17329782a$var$duc(footerHeight), $5fa732a17329782a$var$duc(atBottomThreshold)), $5fa732a17329782a$var$scan((current, [{ scrollTop: scrollTop2, scrollHeight: scrollHeight }, viewportHeight2, _headerHeight, _footerHeight, atBottomThreshold2])=>{
        const isAtBottom2 = scrollTop2 + viewportHeight2 - scrollHeight > -atBottomThreshold2;
        const state = {
            viewportHeight: viewportHeight2,
            scrollTop: scrollTop2,
            scrollHeight: scrollHeight
        };
        if (isAtBottom2) {
            let atBottomBecause;
            let scrollTopDelta;
            if (scrollTop2 > current.state.scrollTop) {
                atBottomBecause = "SCROLLED_DOWN";
                scrollTopDelta = current.state.scrollTop - scrollTop2;
            } else {
                atBottomBecause = "SIZE_DECREASED";
                scrollTopDelta = current.state.scrollTop - scrollTop2 || current.scrollTopDelta;
            }
            return {
                atBottom: true,
                state: state,
                atBottomBecause: atBottomBecause,
                scrollTopDelta: scrollTopDelta
            };
        }
        let notAtBottomBecause;
        if (state.scrollHeight > current.state.scrollHeight) notAtBottomBecause = "SIZE_INCREASED";
        else if (viewportHeight2 < current.state.viewportHeight) notAtBottomBecause = "VIEWPORT_HEIGHT_DECREASING";
        else if (scrollTop2 < current.state.scrollTop) notAtBottomBecause = "SCROLLING_UPWARDS";
        else notAtBottomBecause = "NOT_FULLY_SCROLLED_TO_LAST_ITEM_BOTTOM";
        return {
            atBottom: false,
            notAtBottomBecause: notAtBottomBecause,
            state: state
        };
    }, $5fa732a17329782a$var$INITIAL_BOTTOM_STATE), $5fa732a17329782a$var$distinctUntilChanged((prev, next)=>{
        return prev && prev.atBottom === next.atBottom;
    })));
    const lastJumpDueToItemResize = $5fa732a17329782a$var$statefulStreamFromEmitter($5fa732a17329782a$var$pipe(scrollContainerState, $5fa732a17329782a$var$scan((current, { scrollTop: scrollTop2, scrollHeight: scrollHeight, viewportHeight: viewportHeight2 })=>{
        if (!$5fa732a17329782a$var$approximatelyEqual(current.scrollHeight, scrollHeight)) {
            const atBottom = scrollHeight - (scrollTop2 + viewportHeight2) < 1;
            if (current.scrollTop !== scrollTop2 && atBottom) return {
                scrollHeight: scrollHeight,
                scrollTop: scrollTop2,
                jump: current.scrollTop - scrollTop2,
                changed: true
            };
            else return {
                scrollHeight: scrollHeight,
                scrollTop: scrollTop2,
                jump: 0,
                changed: true
            };
        } else return {
            scrollTop: scrollTop2,
            scrollHeight: scrollHeight,
            jump: 0,
            changed: false
        };
    }, {
        scrollHeight: 0,
        jump: 0,
        scrollTop: 0,
        changed: false
    }), $5fa732a17329782a$var$filter((value)=>value.changed), $5fa732a17329782a$var$map((value)=>value.jump)), 0);
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe(atBottomState, $5fa732a17329782a$var$map((state)=>state.atBottom)), isAtBottom);
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe(isAtBottom, $5fa732a17329782a$var$throttleTime(50)), atBottomStateChange);
    const scrollDirection = $5fa732a17329782a$var$statefulStream($5fa732a17329782a$var$DOWN);
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe(scrollContainerState, $5fa732a17329782a$var$map(({ scrollTop: scrollTop2 })=>scrollTop2), $5fa732a17329782a$var$distinctUntilChanged(), $5fa732a17329782a$var$scan((acc, scrollTop2)=>{
        if ($5fa732a17329782a$var$getValue(isScrollingBy)) return {
            direction: acc.direction,
            prevScrollTop: scrollTop2
        };
        return {
            direction: scrollTop2 < acc.prevScrollTop ? $5fa732a17329782a$var$UP : $5fa732a17329782a$var$DOWN,
            prevScrollTop: scrollTop2
        };
    }, {
        direction: $5fa732a17329782a$var$DOWN,
        prevScrollTop: 0
    }), $5fa732a17329782a$var$map((value)=>value.direction)), scrollDirection);
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe(scrollContainerState, $5fa732a17329782a$var$throttleTime(50), $5fa732a17329782a$var$mapTo($5fa732a17329782a$var$NONE$1)), scrollDirection);
    const scrollVelocity = $5fa732a17329782a$var$statefulStream(0);
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe(isScrolling, $5fa732a17329782a$var$filter((value)=>!value), // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    $5fa732a17329782a$var$mapTo(0)), scrollVelocity);
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe(scrollTop, $5fa732a17329782a$var$throttleTime(100), $5fa732a17329782a$var$withLatestFrom(isScrolling), $5fa732a17329782a$var$filter(([_, isScrolling2])=>!!isScrolling2), $5fa732a17329782a$var$scan(([_, prev], [next])=>[
            prev,
            next
        ], [
        0,
        0
    ]), $5fa732a17329782a$var$map(([prev, next])=>next - prev)), scrollVelocity);
    return {
        isScrolling: isScrolling,
        isAtTop: isAtTop,
        isAtBottom: isAtBottom,
        atBottomState: atBottomState,
        atTopStateChange: atTopStateChange,
        atBottomStateChange: atBottomStateChange,
        scrollDirection: scrollDirection,
        atBottomThreshold: atBottomThreshold,
        atTopThreshold: atTopThreshold,
        scrollVelocity: scrollVelocity,
        lastJumpDueToItemResize: lastJumpDueToItemResize
    };
}, $5fa732a17329782a$var$tup($5fa732a17329782a$var$domIOSystem));
const $5fa732a17329782a$var$propsReadySystem = $5fa732a17329782a$var$system(([{ log: log }])=>{
    const propsReady = $5fa732a17329782a$var$statefulStream(false);
    const didMount = $5fa732a17329782a$var$streamFromEmitter($5fa732a17329782a$var$pipe(propsReady, $5fa732a17329782a$var$filter((ready)=>ready), $5fa732a17329782a$var$distinctUntilChanged()));
    $5fa732a17329782a$var$subscribe(propsReady, (value)=>{
        value && $5fa732a17329782a$var$getValue(log)("props updated", {}, $5fa732a17329782a$export$243e62d78d3b544d.DEBUG);
    });
    return {
        propsReady: propsReady,
        didMount: didMount
    };
}, $5fa732a17329782a$var$tup($5fa732a17329782a$var$loggerSystem), {
    singleton: true
});
function $5fa732a17329782a$var$skipFrames(frameCount, callback) {
    if (frameCount == 0) callback();
    else requestAnimationFrame(()=>$5fa732a17329782a$var$skipFrames(frameCount - 1, callback));
}
function $5fa732a17329782a$var$getInitialTopMostItemIndexNumber(location, totalCount) {
    const lastIndex = totalCount - 1;
    const index = typeof location === "number" ? location : location.index === "LAST" ? lastIndex : location.index;
    return index;
}
const $5fa732a17329782a$var$initialTopMostItemIndexSystem = $5fa732a17329782a$var$system(([{ sizes: sizes, listRefresh: listRefresh, defaultItemSize: defaultItemSize }, { scrollTop: scrollTop }, { scrollToIndex: scrollToIndex, scrollTargetReached: scrollTargetReached }, { didMount: didMount }])=>{
    const scrolledToInitialItem = $5fa732a17329782a$var$statefulStream(true);
    const initialTopMostItemIndex = $5fa732a17329782a$var$statefulStream(0);
    const initialItemFinalLocationReached = $5fa732a17329782a$var$statefulStream(true);
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe(didMount, $5fa732a17329782a$var$withLatestFrom(initialTopMostItemIndex), $5fa732a17329782a$var$filter(([_, location])=>!!location), $5fa732a17329782a$var$mapTo(false)), scrolledToInitialItem);
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe(didMount, $5fa732a17329782a$var$withLatestFrom(initialTopMostItemIndex), $5fa732a17329782a$var$filter(([_, location])=>!!location), $5fa732a17329782a$var$mapTo(false)), initialItemFinalLocationReached);
    $5fa732a17329782a$var$subscribe($5fa732a17329782a$var$pipe($5fa732a17329782a$var$combineLatest(listRefresh, didMount), $5fa732a17329782a$var$withLatestFrom(scrolledToInitialItem, sizes, defaultItemSize, initialItemFinalLocationReached), $5fa732a17329782a$var$filter(([[, didMount2], scrolledToInitialItem2, { sizeTree: sizeTree }, defaultItemSize2, scrollScheduled])=>{
        return didMount2 && (!$5fa732a17329782a$var$empty(sizeTree) || $5fa732a17329782a$var$isDefined(defaultItemSize2)) && !scrolledToInitialItem2 && !scrollScheduled;
    }), $5fa732a17329782a$var$withLatestFrom(initialTopMostItemIndex)), ([, initialTopMostItemIndex2])=>{
        $5fa732a17329782a$var$handleNext(scrollTargetReached, ()=>{
            $5fa732a17329782a$var$publish(initialItemFinalLocationReached, true);
        });
        $5fa732a17329782a$var$skipFrames(4, ()=>{
            $5fa732a17329782a$var$handleNext(scrollTop, ()=>{
                $5fa732a17329782a$var$publish(scrolledToInitialItem, true);
            });
            $5fa732a17329782a$var$publish(scrollToIndex, initialTopMostItemIndex2);
        });
    });
    return {
        scrolledToInitialItem: scrolledToInitialItem,
        initialTopMostItemIndex: initialTopMostItemIndex,
        initialItemFinalLocationReached: initialItemFinalLocationReached
    };
}, $5fa732a17329782a$var$tup($5fa732a17329782a$var$sizeSystem, $5fa732a17329782a$var$domIOSystem, $5fa732a17329782a$var$scrollToIndexSystem, $5fa732a17329782a$var$propsReadySystem), {
    singleton: true
});
function $5fa732a17329782a$var$normalizeFollowOutput(follow) {
    if (!follow) return false;
    return follow === "smooth" ? "smooth" : "auto";
}
const $5fa732a17329782a$var$behaviorFromFollowOutput = (follow, isAtBottom)=>{
    if (typeof follow === "function") return $5fa732a17329782a$var$normalizeFollowOutput(follow(isAtBottom));
    return isAtBottom && $5fa732a17329782a$var$normalizeFollowOutput(follow);
};
const $5fa732a17329782a$var$followOutputSystem = $5fa732a17329782a$var$system(([{ totalCount: totalCount, listRefresh: listRefresh }, { isAtBottom: isAtBottom, atBottomState: atBottomState }, { scrollToIndex: scrollToIndex }, { scrolledToInitialItem: scrolledToInitialItem }, { propsReady: propsReady, didMount: didMount }, { log: log }, { scrollingInProgress: scrollingInProgress }])=>{
    const followOutput = $5fa732a17329782a$var$statefulStream(false);
    const autoscrollToBottom = $5fa732a17329782a$var$stream();
    let pendingScrollHandle = null;
    function scrollToBottom(followOutputBehavior) {
        $5fa732a17329782a$var$publish(scrollToIndex, {
            index: "LAST",
            align: "end",
            behavior: followOutputBehavior
        });
    }
    $5fa732a17329782a$var$subscribe($5fa732a17329782a$var$pipe($5fa732a17329782a$var$combineLatest($5fa732a17329782a$var$pipe($5fa732a17329782a$var$duc(totalCount), $5fa732a17329782a$var$skip(1)), didMount), $5fa732a17329782a$var$withLatestFrom($5fa732a17329782a$var$duc(followOutput), isAtBottom, scrolledToInitialItem, scrollingInProgress), $5fa732a17329782a$var$map(([[totalCount2, didMount2], followOutput2, isAtBottom2, scrolledToInitialItem2, scrollingInProgress2])=>{
        let shouldFollow = didMount2 && scrolledToInitialItem2;
        let followOutputBehavior = "auto";
        if (shouldFollow) {
            followOutputBehavior = $5fa732a17329782a$var$behaviorFromFollowOutput(followOutput2, isAtBottom2 || scrollingInProgress2);
            shouldFollow = shouldFollow && !!followOutputBehavior;
        }
        return {
            totalCount: totalCount2,
            shouldFollow: shouldFollow,
            followOutputBehavior: followOutputBehavior
        };
    }), $5fa732a17329782a$var$filter(({ shouldFollow: shouldFollow })=>shouldFollow)), ({ totalCount: totalCount2, followOutputBehavior: followOutputBehavior })=>{
        if (pendingScrollHandle) {
            pendingScrollHandle();
            pendingScrollHandle = null;
        }
        pendingScrollHandle = $5fa732a17329782a$var$handleNext(listRefresh, ()=>{
            $5fa732a17329782a$var$getValue(log)("following output to ", {
                totalCount: totalCount2
            }, $5fa732a17329782a$export$243e62d78d3b544d.DEBUG);
            scrollToBottom(followOutputBehavior);
            pendingScrollHandle = null;
        });
    });
    function trapNextSizeIncrease(followOutput2) {
        const cancel = $5fa732a17329782a$var$handleNext(atBottomState, (state)=>{
            if (followOutput2 && !state.atBottom && state.notAtBottomBecause === "SIZE_INCREASED" && !pendingScrollHandle) {
                $5fa732a17329782a$var$getValue(log)("scrolling to bottom due to increased size", {}, $5fa732a17329782a$export$243e62d78d3b544d.DEBUG);
                scrollToBottom("auto");
            }
        });
        setTimeout(cancel, 100);
    }
    $5fa732a17329782a$var$subscribe($5fa732a17329782a$var$pipe($5fa732a17329782a$var$combineLatest($5fa732a17329782a$var$duc(followOutput), totalCount, propsReady), $5fa732a17329782a$var$filter(([follow, , ready])=>follow && ready), $5fa732a17329782a$var$scan(({ value: value }, [, next])=>{
        return {
            refreshed: value === next,
            value: next
        };
    }, {
        refreshed: false,
        value: 0
    }), $5fa732a17329782a$var$filter(({ refreshed: refreshed })=>refreshed), $5fa732a17329782a$var$withLatestFrom(followOutput, totalCount)), ([, followOutput2])=>{
        if ($5fa732a17329782a$var$getValue(scrolledToInitialItem)) trapNextSizeIncrease(followOutput2 !== false);
    });
    $5fa732a17329782a$var$subscribe(autoscrollToBottom, ()=>{
        trapNextSizeIncrease($5fa732a17329782a$var$getValue(followOutput) !== false);
    });
    $5fa732a17329782a$var$subscribe($5fa732a17329782a$var$combineLatest($5fa732a17329782a$var$duc(followOutput), atBottomState), ([followOutput2, state])=>{
        if (followOutput2 && !state.atBottom && state.notAtBottomBecause === "VIEWPORT_HEIGHT_DECREASING") scrollToBottom("auto");
    });
    return {
        followOutput: followOutput,
        autoscrollToBottom: autoscrollToBottom
    };
}, $5fa732a17329782a$var$tup($5fa732a17329782a$var$sizeSystem, $5fa732a17329782a$var$stateFlagsSystem, $5fa732a17329782a$var$scrollToIndexSystem, $5fa732a17329782a$var$initialTopMostItemIndexSystem, $5fa732a17329782a$var$propsReadySystem, $5fa732a17329782a$var$loggerSystem, $5fa732a17329782a$var$domIOSystem));
function $5fa732a17329782a$var$groupCountsToIndicesAndCount(counts) {
    return counts.reduce((acc, groupCount)=>{
        acc.groupIndices.push(acc.totalCount);
        acc.totalCount += groupCount + 1;
        return acc;
    }, {
        totalCount: 0,
        groupIndices: []
    });
}
const $5fa732a17329782a$var$groupedListSystem = $5fa732a17329782a$var$system(([{ totalCount: totalCount, groupIndices: groupIndices, sizes: sizes }, { scrollTop: scrollTop, headerHeight: headerHeight }])=>{
    const groupCounts = $5fa732a17329782a$var$stream();
    const topItemsIndexes = $5fa732a17329782a$var$stream();
    const groupIndicesAndCount = $5fa732a17329782a$var$streamFromEmitter($5fa732a17329782a$var$pipe(groupCounts, $5fa732a17329782a$var$map($5fa732a17329782a$var$groupCountsToIndicesAndCount)));
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe(groupIndicesAndCount, $5fa732a17329782a$var$map((value)=>value.totalCount)), totalCount);
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe(groupIndicesAndCount, $5fa732a17329782a$var$map((value)=>value.groupIndices)), groupIndices);
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe($5fa732a17329782a$var$combineLatest(scrollTop, sizes, headerHeight), $5fa732a17329782a$var$filter(([_, sizes2])=>$5fa732a17329782a$var$hasGroups(sizes2)), $5fa732a17329782a$var$map(([scrollTop2, state, headerHeight2])=>$5fa732a17329782a$var$findMaxKeyValue(state.groupOffsetTree, Math.max(scrollTop2 - headerHeight2, 0), "v")[0]), $5fa732a17329782a$var$distinctUntilChanged(), $5fa732a17329782a$var$map((index)=>[
            index
        ])), topItemsIndexes);
    return {
        groupCounts: groupCounts,
        topItemsIndexes: topItemsIndexes
    };
}, $5fa732a17329782a$var$tup($5fa732a17329782a$var$sizeSystem, $5fa732a17329782a$var$domIOSystem));
function $5fa732a17329782a$var$tupleComparator(prev, current) {
    return !!(prev && prev[0] === current[0] && prev[1] === current[1]);
}
function $5fa732a17329782a$var$rangeComparator(prev, next) {
    return !!(prev && prev.startIndex === next.startIndex && prev.endIndex === next.endIndex);
}
const $5fa732a17329782a$var$TOP = "top";
const $5fa732a17329782a$var$BOTTOM = "bottom";
const $5fa732a17329782a$var$NONE = "none";
function $5fa732a17329782a$var$getOverscan(overscan, end, direction) {
    if (typeof overscan === "number") return direction === $5fa732a17329782a$var$UP && end === $5fa732a17329782a$var$TOP || direction === $5fa732a17329782a$var$DOWN && end === $5fa732a17329782a$var$BOTTOM ? overscan : 0;
    else {
        if (direction === $5fa732a17329782a$var$UP) return end === $5fa732a17329782a$var$TOP ? overscan.main : overscan.reverse;
        else return end === $5fa732a17329782a$var$BOTTOM ? overscan.main : overscan.reverse;
    }
}
function $5fa732a17329782a$var$getViewportIncrease(value, end) {
    return typeof value === "number" ? value : value[end] || 0;
}
const $5fa732a17329782a$var$sizeRangeSystem = $5fa732a17329782a$var$system(([{ scrollTop: scrollTop, viewportHeight: viewportHeight, deviation: deviation, headerHeight: headerHeight, fixedHeaderHeight: fixedHeaderHeight }])=>{
    const listBoundary = $5fa732a17329782a$var$stream();
    const topListHeight = $5fa732a17329782a$var$statefulStream(0);
    const increaseViewportBy = $5fa732a17329782a$var$statefulStream(0);
    const overscan = $5fa732a17329782a$var$statefulStream(0);
    const visibleRange = $5fa732a17329782a$var$statefulStreamFromEmitter($5fa732a17329782a$var$pipe($5fa732a17329782a$var$combineLatest($5fa732a17329782a$var$duc(scrollTop), $5fa732a17329782a$var$duc(viewportHeight), $5fa732a17329782a$var$duc(headerHeight), $5fa732a17329782a$var$duc(listBoundary, $5fa732a17329782a$var$tupleComparator), $5fa732a17329782a$var$duc(overscan), $5fa732a17329782a$var$duc(topListHeight), $5fa732a17329782a$var$duc(fixedHeaderHeight), $5fa732a17329782a$var$duc(deviation), $5fa732a17329782a$var$duc(increaseViewportBy)), $5fa732a17329782a$var$map(([scrollTop2, viewportHeight2, headerHeight2, [listTop, listBottom], overscan2, topListHeight2, fixedHeaderHeight2, deviation2, increaseViewportBy2])=>{
        const top = scrollTop2 - deviation2;
        const stickyHeaderHeight = topListHeight2 + fixedHeaderHeight2;
        const headerVisible = Math.max(headerHeight2 - top, 0);
        let direction = $5fa732a17329782a$var$NONE;
        const topViewportAddition = $5fa732a17329782a$var$getViewportIncrease(increaseViewportBy2, $5fa732a17329782a$var$TOP);
        const bottomViewportAddition = $5fa732a17329782a$var$getViewportIncrease(increaseViewportBy2, $5fa732a17329782a$var$BOTTOM);
        listTop -= deviation2;
        listTop += headerHeight2 + fixedHeaderHeight2;
        listBottom += headerHeight2 + fixedHeaderHeight2;
        listBottom -= deviation2;
        if (listTop > scrollTop2 + stickyHeaderHeight - topViewportAddition) direction = $5fa732a17329782a$var$UP;
        if (listBottom < scrollTop2 - headerVisible + viewportHeight2 + bottomViewportAddition) direction = $5fa732a17329782a$var$DOWN;
        if (direction !== $5fa732a17329782a$var$NONE) return [
            Math.max(top - headerHeight2 - $5fa732a17329782a$var$getOverscan(overscan2, $5fa732a17329782a$var$TOP, direction) - topViewportAddition, 0),
            top - headerVisible - fixedHeaderHeight2 + viewportHeight2 + $5fa732a17329782a$var$getOverscan(overscan2, $5fa732a17329782a$var$BOTTOM, direction) + bottomViewportAddition
        ];
        return null;
    }), $5fa732a17329782a$var$filter((value)=>value != null), $5fa732a17329782a$var$distinctUntilChanged($5fa732a17329782a$var$tupleComparator)), [
        0,
        0
    ]);
    return {
        listBoundary: // input
        listBoundary,
        overscan: overscan,
        topListHeight: topListHeight,
        increaseViewportBy: increaseViewportBy,
        visibleRange: // output
        visibleRange
    };
}, $5fa732a17329782a$var$tup($5fa732a17329782a$var$domIOSystem), {
    singleton: true
});
function $5fa732a17329782a$var$probeItemSet(index, sizes, data) {
    if ($5fa732a17329782a$var$hasGroups(sizes)) {
        const itemIndex = $5fa732a17329782a$var$originalIndexFromItemIndex(index, sizes);
        const groupIndex = $5fa732a17329782a$var$findMaxKeyValue(sizes.groupOffsetTree, itemIndex)[0];
        return [
            {
                index: groupIndex,
                size: 0,
                offset: 0
            },
            {
                index: itemIndex,
                size: 0,
                offset: 0,
                data: data && data[0]
            }
        ];
    }
    return [
        {
            index: index,
            size: 0,
            offset: 0,
            data: data && data[0]
        }
    ];
}
const $5fa732a17329782a$var$EMPTY_LIST_STATE = {
    items: [],
    topItems: [],
    offsetTop: 0,
    offsetBottom: 0,
    top: 0,
    bottom: 0,
    topListHeight: 0,
    totalCount: 0,
    firstItemIndex: 0
};
function $5fa732a17329782a$var$transposeItems(items, sizes, firstItemIndex) {
    if (items.length === 0) return [];
    if (!$5fa732a17329782a$var$hasGroups(sizes)) return items.map((item)=>({
            ...item,
            index: item.index + firstItemIndex,
            originalIndex: item.index
        }));
    const startIndex = items[0].index;
    const endIndex = items[items.length - 1].index;
    const transposedItems = [];
    const groupRanges = $5fa732a17329782a$var$rangesWithin(sizes.groupOffsetTree, startIndex, endIndex);
    let currentRange = void 0;
    let currentGroupIndex = 0;
    for (const item of items){
        if (!currentRange || currentRange.end < item.index) {
            currentRange = groupRanges.shift();
            currentGroupIndex = sizes.groupIndices.indexOf(currentRange.start);
        }
        let transposedItem;
        if (item.index === currentRange.start) transposedItem = {
            type: "group",
            index: currentGroupIndex
        };
        else transposedItem = {
            index: item.index - (currentGroupIndex + 1) + firstItemIndex,
            groupIndex: currentGroupIndex
        };
        transposedItems.push({
            ...transposedItem,
            size: item.size,
            offset: item.offset,
            originalIndex: item.index,
            data: item.data
        });
    }
    return transposedItems;
}
function $5fa732a17329782a$var$buildListState(items, topItems, totalCount, gap, sizes, firstItemIndex) {
    const { lastSize: lastSize, lastOffset: lastOffset, lastIndex: lastIndex } = sizes;
    let offsetTop = 0;
    let bottom = 0;
    if (items.length > 0) {
        offsetTop = items[0].offset;
        const lastItem = items[items.length - 1];
        bottom = lastItem.offset + lastItem.size;
    }
    const itemCount = totalCount - lastIndex;
    const total = lastOffset + itemCount * lastSize + (itemCount - 1) * gap;
    const top = offsetTop;
    const offsetBottom = total - bottom;
    return {
        items: $5fa732a17329782a$var$transposeItems(items, sizes, firstItemIndex),
        topItems: $5fa732a17329782a$var$transposeItems(topItems, sizes, firstItemIndex),
        topListHeight: topItems.reduce((height, item)=>item.size + height, 0),
        offsetTop: offsetTop,
        offsetBottom: offsetBottom,
        top: top,
        bottom: bottom,
        totalCount: totalCount,
        firstItemIndex: firstItemIndex
    };
}
function $5fa732a17329782a$var$buildListStateFromItemCount(itemCount, initialTopMostItemIndex, sizes, firstItemIndex, gap, data) {
    let includedGroupsCount = 0;
    if (sizes.groupIndices.length > 0) for (const index of sizes.groupIndices){
        if (index - includedGroupsCount >= itemCount) break;
        includedGroupsCount++;
    }
    const adjustedCount = itemCount + includedGroupsCount;
    const initialTopMostItemIndexNumber = $5fa732a17329782a$var$getInitialTopMostItemIndexNumber(initialTopMostItemIndex, adjustedCount);
    const items = Array.from({
        length: adjustedCount
    }).map((_, index)=>({
            index: index + initialTopMostItemIndexNumber,
            size: 0,
            offset: 0,
            data: data[index + initialTopMostItemIndexNumber]
        }));
    return $5fa732a17329782a$var$buildListState(items, [], adjustedCount, gap, sizes, firstItemIndex);
}
const $5fa732a17329782a$var$listStateSystem = $5fa732a17329782a$var$system(([{ sizes: sizes, totalCount: totalCount, data: data, firstItemIndex: firstItemIndex, gap: gap }, groupedListSystem2, { visibleRange: visibleRange, listBoundary: listBoundary, topListHeight: rangeTopListHeight }, { scrolledToInitialItem: scrolledToInitialItem, initialTopMostItemIndex: initialTopMostItemIndex }, { topListHeight: topListHeight }, stateFlags, { didMount: didMount }, { recalcInProgress: recalcInProgress }])=>{
    const topItemsIndexes = $5fa732a17329782a$var$statefulStream([]);
    const initialItemCount = $5fa732a17329782a$var$statefulStream(0);
    const itemsRendered = $5fa732a17329782a$var$stream();
    $5fa732a17329782a$var$connect(groupedListSystem2.topItemsIndexes, topItemsIndexes);
    const listState = $5fa732a17329782a$var$statefulStreamFromEmitter($5fa732a17329782a$var$pipe($5fa732a17329782a$var$combineLatest(didMount, recalcInProgress, $5fa732a17329782a$var$duc(visibleRange, $5fa732a17329782a$var$tupleComparator), $5fa732a17329782a$var$duc(totalCount), $5fa732a17329782a$var$duc(sizes), $5fa732a17329782a$var$duc(initialTopMostItemIndex), scrolledToInitialItem, $5fa732a17329782a$var$duc(topItemsIndexes), $5fa732a17329782a$var$duc(firstItemIndex), $5fa732a17329782a$var$duc(gap), data), $5fa732a17329782a$var$filter(([mount, recalcInProgress2, , totalCount2, , , , , , , data2])=>{
        const dataChangeInProgress = data2 && data2.length !== totalCount2;
        return mount && !recalcInProgress2 && !dataChangeInProgress;
    }), $5fa732a17329782a$var$map(([, , [startOffset, endOffset], totalCount2, sizes2, initialTopMostItemIndex2, scrolledToInitialItem2, topItemsIndexes2, firstItemIndex2, gap2, data2])=>{
        const sizesValue = sizes2;
        const { sizeTree: sizeTree, offsetTree: offsetTree } = sizesValue;
        const initialItemCountValue = $5fa732a17329782a$var$getValue(initialItemCount);
        if (totalCount2 === 0) return {
            ...$5fa732a17329782a$var$EMPTY_LIST_STATE,
            totalCount: totalCount2
        };
        if (startOffset === 0 && endOffset === 0) {
            if (initialItemCountValue === 0) return {
                ...$5fa732a17329782a$var$EMPTY_LIST_STATE,
                totalCount: totalCount2
            };
            else return $5fa732a17329782a$var$buildListStateFromItemCount(initialItemCountValue, initialTopMostItemIndex2, sizes2, firstItemIndex2, gap2, data2 || []);
        }
        if ($5fa732a17329782a$var$empty(sizeTree)) {
            if (initialItemCountValue > 0) return null;
            const state = $5fa732a17329782a$var$buildListState($5fa732a17329782a$var$probeItemSet($5fa732a17329782a$var$getInitialTopMostItemIndexNumber(initialTopMostItemIndex2, totalCount2), sizesValue, data2), [], totalCount2, gap2, sizesValue, firstItemIndex2);
            return state;
        }
        const topItems = [];
        if (topItemsIndexes2.length > 0) {
            const startIndex = topItemsIndexes2[0];
            const endIndex = topItemsIndexes2[topItemsIndexes2.length - 1];
            let offset = 0;
            for (const range of $5fa732a17329782a$var$rangesWithin(sizeTree, startIndex, endIndex)){
                const size = range.value;
                const rangeStartIndex = Math.max(range.start, startIndex);
                const rangeEndIndex = Math.min(range.end, endIndex);
                for(let i = rangeStartIndex; i <= rangeEndIndex; i++){
                    topItems.push({
                        index: i,
                        size: size,
                        offset: offset,
                        data: data2 && data2[i]
                    });
                    offset += size;
                }
            }
        }
        if (!scrolledToInitialItem2) return $5fa732a17329782a$var$buildListState([], topItems, totalCount2, gap2, sizesValue, firstItemIndex2);
        const minStartIndex = topItemsIndexes2.length > 0 ? topItemsIndexes2[topItemsIndexes2.length - 1] + 1 : 0;
        const offsetPointRanges = $5fa732a17329782a$var$rangesWithinOffsets(offsetTree, startOffset, endOffset, minStartIndex);
        if (offsetPointRanges.length === 0) return null;
        const maxIndex = totalCount2 - 1;
        const items = $5fa732a17329782a$var$tap([], (result)=>{
            for (const range of offsetPointRanges){
                const point = range.value;
                let offset = point.offset;
                let rangeStartIndex = range.start;
                const size = point.size;
                if (point.offset < startOffset) {
                    rangeStartIndex += Math.floor((startOffset - point.offset + gap2) / (size + gap2));
                    const itemCount = rangeStartIndex - range.start;
                    offset += itemCount * size + itemCount * gap2;
                }
                if (rangeStartIndex < minStartIndex) {
                    offset += (minStartIndex - rangeStartIndex) * size;
                    rangeStartIndex = minStartIndex;
                }
                const endIndex = Math.min(range.end, maxIndex);
                for(let i = rangeStartIndex; i <= endIndex; i++){
                    if (offset >= endOffset) break;
                    result.push({
                        index: i,
                        size: size,
                        offset: offset,
                        data: data2 && data2[i]
                    });
                    offset += size + gap2;
                }
            }
        });
        return $5fa732a17329782a$var$buildListState(items, topItems, totalCount2, gap2, sizesValue, firstItemIndex2);
    }), //@ts-expect-error filter needs to be fixed
    $5fa732a17329782a$var$filter((value)=>value !== null), $5fa732a17329782a$var$distinctUntilChanged()), $5fa732a17329782a$var$EMPTY_LIST_STATE);
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe(data, $5fa732a17329782a$var$filter($5fa732a17329782a$var$isDefined), $5fa732a17329782a$var$map((data2)=>data2 == null ? void 0 : data2.length)), totalCount);
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe(listState, $5fa732a17329782a$var$map((value)=>value.topListHeight)), topListHeight);
    $5fa732a17329782a$var$connect(topListHeight, rangeTopListHeight);
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe(listState, $5fa732a17329782a$var$map((state)=>[
            state.top,
            state.bottom
        ])), listBoundary);
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe(listState, $5fa732a17329782a$var$map((state)=>state.items)), itemsRendered);
    const endReached = $5fa732a17329782a$var$streamFromEmitter($5fa732a17329782a$var$pipe(listState, $5fa732a17329782a$var$filter(({ items: items })=>items.length > 0), $5fa732a17329782a$var$withLatestFrom(totalCount, data), $5fa732a17329782a$var$filter(([{ items: items }, totalCount2])=>items[items.length - 1].originalIndex === totalCount2 - 1), $5fa732a17329782a$var$map(([, totalCount2, data2])=>[
            totalCount2 - 1,
            data2
        ]), $5fa732a17329782a$var$distinctUntilChanged($5fa732a17329782a$var$tupleComparator), $5fa732a17329782a$var$map(([count])=>count)));
    const startReached = $5fa732a17329782a$var$streamFromEmitter($5fa732a17329782a$var$pipe(listState, $5fa732a17329782a$var$throttleTime(200), $5fa732a17329782a$var$filter(({ items: items, topItems: topItems })=>{
        return items.length > 0 && items[0].originalIndex === topItems.length;
    }), $5fa732a17329782a$var$map(({ items: items })=>items[0].index), $5fa732a17329782a$var$distinctUntilChanged()));
    const rangeChanged = $5fa732a17329782a$var$streamFromEmitter($5fa732a17329782a$var$pipe(listState, $5fa732a17329782a$var$filter(({ items: items })=>items.length > 0), $5fa732a17329782a$var$map(({ items: items })=>{
        let startIndex = 0;
        let endIndex = items.length - 1;
        while(items[startIndex].type === "group" && startIndex < endIndex)startIndex++;
        while(items[endIndex].type === "group" && endIndex > startIndex)endIndex--;
        return {
            startIndex: items[startIndex].index,
            endIndex: items[endIndex].index
        };
    }), $5fa732a17329782a$var$distinctUntilChanged($5fa732a17329782a$var$rangeComparator)));
    return {
        listState: listState,
        topItemsIndexes: topItemsIndexes,
        endReached: endReached,
        startReached: startReached,
        rangeChanged: rangeChanged,
        itemsRendered: itemsRendered,
        initialItemCount: initialItemCount,
        ...stateFlags
    };
}, $5fa732a17329782a$var$tup($5fa732a17329782a$var$sizeSystem, $5fa732a17329782a$var$groupedListSystem, $5fa732a17329782a$var$sizeRangeSystem, $5fa732a17329782a$var$initialTopMostItemIndexSystem, $5fa732a17329782a$var$scrollToIndexSystem, $5fa732a17329782a$var$stateFlagsSystem, $5fa732a17329782a$var$propsReadySystem, $5fa732a17329782a$var$recalcSystem), {
    singleton: true
});
const $5fa732a17329782a$var$initialItemCountSystem = $5fa732a17329782a$var$system(([{ sizes: sizes, firstItemIndex: firstItemIndex, data: data, gap: gap }, { initialTopMostItemIndex: initialTopMostItemIndex }, { initialItemCount: initialItemCount, listState: listState }, { didMount: didMount }])=>{
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe(didMount, $5fa732a17329782a$var$withLatestFrom(initialItemCount), $5fa732a17329782a$var$filter(([, count])=>count !== 0), $5fa732a17329782a$var$withLatestFrom(initialTopMostItemIndex, sizes, firstItemIndex, gap, data), $5fa732a17329782a$var$map(([[, count], initialTopMostItemIndexValue, sizes2, firstItemIndex2, gap2, data2 = []])=>{
        return $5fa732a17329782a$var$buildListStateFromItemCount(count, initialTopMostItemIndexValue, sizes2, firstItemIndex2, gap2, data2);
    })), listState);
    return {};
}, $5fa732a17329782a$var$tup($5fa732a17329782a$var$sizeSystem, $5fa732a17329782a$var$initialTopMostItemIndexSystem, $5fa732a17329782a$var$listStateSystem, $5fa732a17329782a$var$propsReadySystem), {
    singleton: true
});
const $5fa732a17329782a$var$scrollSeekSystem = $5fa732a17329782a$var$system(([{ scrollVelocity: scrollVelocity }])=>{
    const isSeeking = $5fa732a17329782a$var$statefulStream(false);
    const rangeChanged = $5fa732a17329782a$var$stream();
    const scrollSeekConfiguration = $5fa732a17329782a$var$statefulStream(false);
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe(scrollVelocity, $5fa732a17329782a$var$withLatestFrom(scrollSeekConfiguration, isSeeking, rangeChanged), $5fa732a17329782a$var$filter(([_, config])=>!!config), $5fa732a17329782a$var$map(([speed, config, isSeeking2, range])=>{
        const { exit: exit, enter: enter } = config;
        if (isSeeking2) {
            if (exit(speed, range)) return false;
        } else {
            if (enter(speed, range)) return true;
        }
        return isSeeking2;
    }), $5fa732a17329782a$var$distinctUntilChanged()), isSeeking);
    $5fa732a17329782a$var$subscribe($5fa732a17329782a$var$pipe($5fa732a17329782a$var$combineLatest(isSeeking, scrollVelocity, rangeChanged), $5fa732a17329782a$var$withLatestFrom(scrollSeekConfiguration)), ([[isSeeking2, velocity, range], config])=>isSeeking2 && config && config.change && config.change(velocity, range));
    return {
        isSeeking: isSeeking,
        scrollSeekConfiguration: scrollSeekConfiguration,
        scrollVelocity: scrollVelocity,
        scrollSeekRangeChanged: rangeChanged
    };
}, $5fa732a17329782a$var$tup($5fa732a17329782a$var$stateFlagsSystem), {
    singleton: true
});
const $5fa732a17329782a$var$topItemCountSystem = $5fa732a17329782a$var$system(([{ topItemsIndexes: topItemsIndexes }])=>{
    const topItemCount = $5fa732a17329782a$var$statefulStream(0);
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe(topItemCount, $5fa732a17329782a$var$filter((length)=>length >= 0), $5fa732a17329782a$var$map((length)=>Array.from({
            length: length
        }).map((_, index)=>index))), topItemsIndexes);
    return {
        topItemCount: topItemCount
    };
}, $5fa732a17329782a$var$tup($5fa732a17329782a$var$listStateSystem));
const $5fa732a17329782a$var$totalListHeightSystem = $5fa732a17329782a$var$system(([{ footerHeight: footerHeight, headerHeight: headerHeight, fixedHeaderHeight: fixedHeaderHeight, fixedFooterHeight: fixedFooterHeight }, { listState: listState }])=>{
    const totalListHeightChanged = $5fa732a17329782a$var$stream();
    const totalListHeight = $5fa732a17329782a$var$statefulStreamFromEmitter($5fa732a17329782a$var$pipe($5fa732a17329782a$var$combineLatest(footerHeight, fixedFooterHeight, headerHeight, fixedHeaderHeight, listState), $5fa732a17329782a$var$map(([footerHeight2, fixedFooterHeight2, headerHeight2, fixedHeaderHeight2, listState2])=>{
        return footerHeight2 + fixedFooterHeight2 + headerHeight2 + fixedHeaderHeight2 + listState2.offsetBottom + listState2.bottom;
    })), 0);
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$duc(totalListHeight), totalListHeightChanged);
    return {
        totalListHeight: totalListHeight,
        totalListHeightChanged: totalListHeightChanged
    };
}, $5fa732a17329782a$var$tup($5fa732a17329782a$var$domIOSystem, $5fa732a17329782a$var$listStateSystem), {
    singleton: true
});
function $5fa732a17329782a$var$simpleMemoize(func) {
    let called = false;
    let result;
    return ()=>{
        if (!called) {
            called = true;
            result = func();
        }
        return result;
    };
}
const $5fa732a17329782a$var$isMobileSafari = $5fa732a17329782a$var$simpleMemoize(()=>{
    return /iP(ad|od|hone)/i.test(navigator.userAgent) && /WebKit/i.test(navigator.userAgent);
});
const $5fa732a17329782a$var$upwardScrollFixSystem = $5fa732a17329782a$var$system(([{ scrollBy: scrollBy, scrollTop: scrollTop, deviation: deviation, scrollingInProgress: scrollingInProgress }, { isScrolling: isScrolling, isAtBottom: isAtBottom, scrollDirection: scrollDirection, lastJumpDueToItemResize: lastJumpDueToItemResize }, { listState: listState }, { beforeUnshiftWith: beforeUnshiftWith, shiftWithOffset: shiftWithOffset, sizes: sizes, gap: gap }, { log: log }, { recalcInProgress: recalcInProgress }])=>{
    const deviationOffset = $5fa732a17329782a$var$streamFromEmitter($5fa732a17329782a$var$pipe(listState, $5fa732a17329782a$var$withLatestFrom(lastJumpDueToItemResize), $5fa732a17329782a$var$scan(([, prevItems, prevTotalCount, prevTotalHeight], [{ items: items, totalCount: totalCount, bottom: bottom, offsetBottom: offsetBottom }, lastJumpDueToItemResize2])=>{
        const totalHeight = bottom + offsetBottom;
        let newDev = 0;
        if (prevTotalCount === totalCount) {
            if (prevItems.length > 0 && items.length > 0) {
                const atStart = items[0].originalIndex === 0 && prevItems[0].originalIndex === 0;
                if (!atStart) {
                    newDev = totalHeight - prevTotalHeight;
                    if (newDev !== 0) newDev += lastJumpDueToItemResize2;
                }
            }
        }
        return [
            newDev,
            items,
            totalCount,
            totalHeight
        ];
    }, [
        0,
        [],
        0,
        0
    ]), $5fa732a17329782a$var$filter(([amount])=>amount !== 0), $5fa732a17329782a$var$withLatestFrom(scrollTop, scrollDirection, scrollingInProgress, isAtBottom, log, recalcInProgress), $5fa732a17329782a$var$filter(([, scrollTop2, scrollDirection2, scrollingInProgress2, , , recalcInProgress2])=>{
        return !recalcInProgress2 && !scrollingInProgress2 && scrollTop2 !== 0 && scrollDirection2 === $5fa732a17329782a$var$UP;
    }), $5fa732a17329782a$var$map(([[amount], , , , , log2])=>{
        log2("Upward scrolling compensation", {
            amount: amount
        }, $5fa732a17329782a$export$243e62d78d3b544d.DEBUG);
        return amount;
    })));
    function scrollByWith(offset) {
        if (offset > 0) {
            $5fa732a17329782a$var$publish(scrollBy, {
                top: -offset,
                behavior: "auto"
            });
            $5fa732a17329782a$var$publish(deviation, 0);
        } else {
            $5fa732a17329782a$var$publish(deviation, 0);
            $5fa732a17329782a$var$publish(scrollBy, {
                top: -offset,
                behavior: "auto"
            });
        }
    }
    $5fa732a17329782a$var$subscribe($5fa732a17329782a$var$pipe(deviationOffset, $5fa732a17329782a$var$withLatestFrom(deviation, isScrolling)), ([offset, deviationAmount, isScrolling2])=>{
        if (isScrolling2 && $5fa732a17329782a$var$isMobileSafari()) $5fa732a17329782a$var$publish(deviation, deviationAmount - offset);
        else scrollByWith(-offset);
    });
    $5fa732a17329782a$var$subscribe($5fa732a17329782a$var$pipe($5fa732a17329782a$var$combineLatest($5fa732a17329782a$var$statefulStreamFromEmitter(isScrolling, false), deviation, recalcInProgress), $5fa732a17329782a$var$filter(([is, deviation2, recalc])=>!is && !recalc && deviation2 !== 0), $5fa732a17329782a$var$map(([_, deviation2])=>deviation2), $5fa732a17329782a$var$throttleTime(1)), scrollByWith);
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe(shiftWithOffset, $5fa732a17329782a$var$map((offset)=>{
        return {
            top: -offset
        };
    })), scrollBy);
    $5fa732a17329782a$var$subscribe($5fa732a17329782a$var$pipe(beforeUnshiftWith, $5fa732a17329782a$var$withLatestFrom(sizes, gap), $5fa732a17329782a$var$map(([offset, { lastSize: defaultItemSize, groupIndices: groupIndices, sizeTree: sizeTree }, gap2])=>{
        function getItemOffset(itemCount) {
            return itemCount * (defaultItemSize + gap2);
        }
        if (groupIndices.length === 0) return getItemOffset(offset);
        else {
            let amount = 0;
            const defaultGroupSize = $5fa732a17329782a$var$find(sizeTree, 0);
            let recognizedOffsetItems = 0;
            let groupIndex = 0;
            while(recognizedOffsetItems < offset){
                recognizedOffsetItems++;
                amount += defaultGroupSize;
                let groupItemCount = groupIndices.length === groupIndex + 1 ? Infinity : groupIndices[groupIndex + 1] - groupIndices[groupIndex] - 1;
                if (recognizedOffsetItems + groupItemCount > offset) {
                    amount -= defaultGroupSize;
                    groupItemCount = offset - recognizedOffsetItems + 1;
                }
                recognizedOffsetItems += groupItemCount;
                amount += getItemOffset(groupItemCount);
                groupIndex++;
            }
            return amount;
        }
    })), (offset)=>{
        $5fa732a17329782a$var$publish(deviation, offset);
        requestAnimationFrame(()=>{
            $5fa732a17329782a$var$publish(scrollBy, {
                top: offset
            });
            requestAnimationFrame(()=>{
                $5fa732a17329782a$var$publish(deviation, 0);
                $5fa732a17329782a$var$publish(recalcInProgress, false);
            });
        });
    });
    return {
        deviation: deviation
    };
}, $5fa732a17329782a$var$tup($5fa732a17329782a$var$domIOSystem, $5fa732a17329782a$var$stateFlagsSystem, $5fa732a17329782a$var$listStateSystem, $5fa732a17329782a$var$sizeSystem, $5fa732a17329782a$var$loggerSystem, $5fa732a17329782a$var$recalcSystem));
const $5fa732a17329782a$var$initialScrollTopSystem = $5fa732a17329782a$var$system(([{ didMount: didMount }, { scrollTo: scrollTo }, { listState: listState }])=>{
    const initialScrollTop = $5fa732a17329782a$var$statefulStream(0);
    $5fa732a17329782a$var$subscribe($5fa732a17329782a$var$pipe(didMount, $5fa732a17329782a$var$withLatestFrom(initialScrollTop), $5fa732a17329782a$var$filter(([, offset])=>offset !== 0), $5fa732a17329782a$var$map(([, offset])=>({
            top: offset
        }))), (location)=>{
        $5fa732a17329782a$var$handleNext($5fa732a17329782a$var$pipe(listState, $5fa732a17329782a$var$skip(1), $5fa732a17329782a$var$filter((state)=>state.items.length > 1)), ()=>{
            requestAnimationFrame(()=>{
                $5fa732a17329782a$var$publish(scrollTo, location);
            });
        });
    });
    return {
        initialScrollTop: initialScrollTop
    };
}, $5fa732a17329782a$var$tup($5fa732a17329782a$var$propsReadySystem, $5fa732a17329782a$var$domIOSystem, $5fa732a17329782a$var$listStateSystem), {
    singleton: true
});
const $5fa732a17329782a$var$alignToBottomSystem = $5fa732a17329782a$var$system(([{ viewportHeight: viewportHeight }, { totalListHeight: totalListHeight }])=>{
    const alignToBottom = $5fa732a17329782a$var$statefulStream(false);
    const paddingTopAddition = $5fa732a17329782a$var$statefulStreamFromEmitter($5fa732a17329782a$var$pipe($5fa732a17329782a$var$combineLatest(alignToBottom, viewportHeight, totalListHeight), $5fa732a17329782a$var$filter(([enabled])=>enabled), $5fa732a17329782a$var$map(([, viewportHeight2, totalListHeight2])=>{
        return Math.max(0, viewportHeight2 - totalListHeight2);
    }), $5fa732a17329782a$var$throttleTime(0), $5fa732a17329782a$var$distinctUntilChanged()), 0);
    return {
        alignToBottom: alignToBottom,
        paddingTopAddition: paddingTopAddition
    };
}, $5fa732a17329782a$var$tup($5fa732a17329782a$var$domIOSystem, $5fa732a17329782a$var$totalListHeightSystem), {
    singleton: true
});
const $5fa732a17329782a$var$windowScrollerSystem = $5fa732a17329782a$var$system(([{ scrollTo: scrollTo, scrollContainerState: scrollContainerState }])=>{
    const windowScrollContainerState = $5fa732a17329782a$var$stream();
    const windowViewportRect = $5fa732a17329782a$var$stream();
    const windowScrollTo = $5fa732a17329782a$var$stream();
    const useWindowScroll = $5fa732a17329782a$var$statefulStream(false);
    const customScrollParent = $5fa732a17329782a$var$statefulStream(void 0);
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe($5fa732a17329782a$var$combineLatest(windowScrollContainerState, windowViewportRect), $5fa732a17329782a$var$map(([{ viewportHeight: viewportHeight, scrollTop: windowScrollTop, scrollHeight: scrollHeight }, { offsetTop: offsetTop }])=>{
        return {
            scrollTop: Math.max(0, windowScrollTop - offsetTop),
            scrollHeight: scrollHeight,
            viewportHeight: viewportHeight
        };
    })), scrollContainerState);
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe(scrollTo, $5fa732a17329782a$var$withLatestFrom(windowViewportRect), $5fa732a17329782a$var$map(([scrollTo2, { offsetTop: offsetTop }])=>{
        return {
            ...scrollTo2,
            top: scrollTo2.top + offsetTop
        };
    })), windowScrollTo);
    return {
        useWindowScroll: // config
        useWindowScroll,
        customScrollParent: customScrollParent,
        windowScrollContainerState: // input
        windowScrollContainerState,
        windowViewportRect: windowViewportRect,
        windowScrollTo: // signals
        windowScrollTo
    };
}, $5fa732a17329782a$var$tup($5fa732a17329782a$var$domIOSystem));
const $5fa732a17329782a$var$defaultCalculateViewLocation = ({ itemTop: itemTop2, itemBottom: itemBottom, viewportTop: viewportTop, viewportBottom: viewportBottom, locationParams: { behavior: behavior, align: align, ...rest } })=>{
    if (itemTop2 < viewportTop) return {
        ...rest,
        behavior: behavior,
        align: align != null ? align : "start"
    };
    if (itemBottom > viewportBottom) return {
        ...rest,
        behavior: behavior,
        align: align != null ? align : "end"
    };
    return null;
};
const $5fa732a17329782a$var$scrollIntoViewSystem = $5fa732a17329782a$var$system(([{ sizes: sizes, totalCount: totalCount, gap: gap }, { scrollTop: scrollTop, viewportHeight: viewportHeight, headerHeight: headerHeight, fixedHeaderHeight: fixedHeaderHeight, fixedFooterHeight: fixedFooterHeight, scrollingInProgress: scrollingInProgress }, { scrollToIndex: scrollToIndex }])=>{
    const scrollIntoView = $5fa732a17329782a$var$stream();
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe(scrollIntoView, $5fa732a17329782a$var$withLatestFrom(sizes, viewportHeight, totalCount, headerHeight, fixedHeaderHeight, fixedFooterHeight, scrollTop), $5fa732a17329782a$var$withLatestFrom(gap), $5fa732a17329782a$var$map(([[viewLocation, sizes2, viewportHeight2, totalCount2, headerHeight2, fixedHeaderHeight2, fixedFooterHeight2, scrollTop2], gap2])=>{
        const { done: done, behavior: behavior, align: align, calculateViewLocation: calculateViewLocation = $5fa732a17329782a$var$defaultCalculateViewLocation, ...rest } = viewLocation;
        const actualIndex = $5fa732a17329782a$var$originalIndexFromLocation(viewLocation, sizes2, totalCount2 - 1);
        const itemTop2 = $5fa732a17329782a$var$offsetOf(actualIndex, sizes2.offsetTree, gap2) + headerHeight2 + fixedHeaderHeight2;
        const itemBottom = itemTop2 + $5fa732a17329782a$var$findMaxKeyValue(sizes2.sizeTree, actualIndex)[1];
        const viewportTop = scrollTop2 + fixedHeaderHeight2;
        const viewportBottom = scrollTop2 + viewportHeight2 - fixedFooterHeight2;
        const location = calculateViewLocation({
            itemTop: itemTop2,
            itemBottom: itemBottom,
            viewportTop: viewportTop,
            viewportBottom: viewportBottom,
            locationParams: {
                behavior: behavior,
                align: align,
                ...rest
            }
        });
        if (location) done && $5fa732a17329782a$var$handleNext($5fa732a17329782a$var$pipe(scrollingInProgress, $5fa732a17329782a$var$filter((value)=>value === false), // skips the initial publish of false, and the cleanup call.
        // but if scrollingInProgress is true, we skip the initial publish.
        $5fa732a17329782a$var$skip($5fa732a17329782a$var$getValue(scrollingInProgress) ? 1 : 2)), done);
        else done && done();
        return location;
    }), $5fa732a17329782a$var$filter((value)=>value !== null)), scrollToIndex);
    return {
        scrollIntoView: scrollIntoView
    };
}, $5fa732a17329782a$var$tup($5fa732a17329782a$var$sizeSystem, $5fa732a17329782a$var$domIOSystem, $5fa732a17329782a$var$scrollToIndexSystem, $5fa732a17329782a$var$listStateSystem, $5fa732a17329782a$var$loggerSystem), {
    singleton: true
});
const $5fa732a17329782a$var$stateLoadSystem = $5fa732a17329782a$var$system(([{ sizes: sizes, sizeRanges: sizeRanges }, { scrollTop: scrollTop, headerHeight: headerHeight }, { initialTopMostItemIndex: initialTopMostItemIndex }, { didMount: didMount }, { useWindowScroll: useWindowScroll, windowScrollContainerState: windowScrollContainerState, windowViewportRect: windowViewportRect }])=>{
    const getState = $5fa732a17329782a$var$stream();
    const restoreStateFrom = $5fa732a17329782a$var$statefulStream(void 0);
    const statefulWindowScrollContainerState = $5fa732a17329782a$var$statefulStream(null);
    const statefulWindowViewportRect = $5fa732a17329782a$var$statefulStream(null);
    $5fa732a17329782a$var$connect(windowScrollContainerState, statefulWindowScrollContainerState);
    $5fa732a17329782a$var$connect(windowViewportRect, statefulWindowViewportRect);
    $5fa732a17329782a$var$subscribe($5fa732a17329782a$var$pipe(getState, $5fa732a17329782a$var$withLatestFrom(sizes, scrollTop, useWindowScroll, statefulWindowScrollContainerState, statefulWindowViewportRect, headerHeight)), ([callback, sizes2, scrollTop2, useWindowScroll2, windowScrollContainerState2, windowViewportRect2, headerHeight2])=>{
        const ranges = $5fa732a17329782a$var$sizeTreeToRanges(sizes2.sizeTree);
        if (useWindowScroll2 && windowScrollContainerState2 !== null && windowViewportRect2 !== null) scrollTop2 = windowScrollContainerState2.scrollTop - windowViewportRect2.offsetTop;
        scrollTop2 -= headerHeight2;
        callback({
            ranges: ranges,
            scrollTop: scrollTop2
        });
    });
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe(restoreStateFrom, $5fa732a17329782a$var$filter($5fa732a17329782a$var$isDefined), $5fa732a17329782a$var$map($5fa732a17329782a$var$locationFromSnapshot)), initialTopMostItemIndex);
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe(didMount, $5fa732a17329782a$var$withLatestFrom(restoreStateFrom), $5fa732a17329782a$var$filter(([, state])=>state !== void 0), $5fa732a17329782a$var$distinctUntilChanged(), $5fa732a17329782a$var$map(([, snapshot])=>{
        return snapshot.ranges;
    })), sizeRanges);
    return {
        getState: getState,
        restoreStateFrom: restoreStateFrom
    };
}, $5fa732a17329782a$var$tup($5fa732a17329782a$var$sizeSystem, $5fa732a17329782a$var$domIOSystem, $5fa732a17329782a$var$initialTopMostItemIndexSystem, $5fa732a17329782a$var$propsReadySystem, $5fa732a17329782a$var$windowScrollerSystem));
function $5fa732a17329782a$var$locationFromSnapshot(snapshot) {
    return {
        offset: snapshot.scrollTop,
        index: 0,
        align: "start"
    };
}
const $5fa732a17329782a$var$featureGroup1System = $5fa732a17329782a$var$system(([sizeRange, initialItemCount, propsReady, scrollSeek, totalListHeight, initialScrollTopSystem2, alignToBottom, windowScroller, scrollIntoView, logger])=>{
    return {
        ...sizeRange,
        ...initialItemCount,
        ...propsReady,
        ...scrollSeek,
        ...totalListHeight,
        ...initialScrollTopSystem2,
        ...alignToBottom,
        ...windowScroller,
        ...scrollIntoView,
        ...logger
    };
}, $5fa732a17329782a$var$tup($5fa732a17329782a$var$sizeRangeSystem, $5fa732a17329782a$var$initialItemCountSystem, $5fa732a17329782a$var$propsReadySystem, $5fa732a17329782a$var$scrollSeekSystem, $5fa732a17329782a$var$totalListHeightSystem, $5fa732a17329782a$var$initialScrollTopSystem, $5fa732a17329782a$var$alignToBottomSystem, $5fa732a17329782a$var$windowScrollerSystem, $5fa732a17329782a$var$scrollIntoViewSystem, $5fa732a17329782a$var$loggerSystem));
const $5fa732a17329782a$var$listSystem = $5fa732a17329782a$var$system(([{ totalCount: totalCount, sizeRanges: sizeRanges, fixedItemSize: fixedItemSize, defaultItemSize: defaultItemSize, trackItemSizes: trackItemSizes, itemSize: itemSize, data: data, firstItemIndex: firstItemIndex, groupIndices: groupIndices, statefulTotalCount: statefulTotalCount, gap: gap, sizes: sizes }, { initialTopMostItemIndex: initialTopMostItemIndex, scrolledToInitialItem: scrolledToInitialItem, initialItemFinalLocationReached: initialItemFinalLocationReached }, domIO, stateLoad, followOutput, { listState: listState, topItemsIndexes: topItemsIndexes, ...flags }, { scrollToIndex: scrollToIndex }, _, { topItemCount: topItemCount }, { groupCounts: groupCounts }, featureGroup1])=>{
    $5fa732a17329782a$var$connect(flags.rangeChanged, featureGroup1.scrollSeekRangeChanged);
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe(featureGroup1.windowViewportRect, $5fa732a17329782a$var$map((value)=>value.visibleHeight)), domIO.viewportHeight);
    return {
        totalCount: // input
        totalCount,
        data: data,
        firstItemIndex: firstItemIndex,
        sizeRanges: sizeRanges,
        initialTopMostItemIndex: initialTopMostItemIndex,
        scrolledToInitialItem: scrolledToInitialItem,
        initialItemFinalLocationReached: initialItemFinalLocationReached,
        topItemsIndexes: topItemsIndexes,
        topItemCount: topItemCount,
        groupCounts: groupCounts,
        fixedItemHeight: fixedItemSize,
        defaultItemHeight: defaultItemSize,
        gap: gap,
        ...followOutput,
        statefulTotalCount: // output
        statefulTotalCount,
        listState: listState,
        scrollToIndex: scrollToIndex,
        trackItemSizes: trackItemSizes,
        itemSize: itemSize,
        groupIndices: groupIndices,
        // exported from stateFlagsSystem
        ...flags,
        // the bag of IO from featureGroup1System
        ...featureGroup1,
        ...domIO,
        sizes: sizes,
        ...stateLoad
    };
}, $5fa732a17329782a$var$tup($5fa732a17329782a$var$sizeSystem, $5fa732a17329782a$var$initialTopMostItemIndexSystem, $5fa732a17329782a$var$domIOSystem, $5fa732a17329782a$var$stateLoadSystem, $5fa732a17329782a$var$followOutputSystem, $5fa732a17329782a$var$listStateSystem, $5fa732a17329782a$var$scrollToIndexSystem, $5fa732a17329782a$var$upwardScrollFixSystem, $5fa732a17329782a$var$topItemCountSystem, $5fa732a17329782a$var$groupedListSystem, $5fa732a17329782a$var$featureGroup1System));
const $5fa732a17329782a$var$WEBKIT_STICKY = "-webkit-sticky";
const $5fa732a17329782a$var$STICKY = "sticky";
const $5fa732a17329782a$var$positionStickyCssValue = $5fa732a17329782a$var$simpleMemoize(()=>{
    if (typeof document === "undefined") return $5fa732a17329782a$var$STICKY;
    const node = document.createElement("div");
    node.style.position = $5fa732a17329782a$var$WEBKIT_STICKY;
    return node.style.position === $5fa732a17329782a$var$WEBKIT_STICKY ? $5fa732a17329782a$var$WEBKIT_STICKY : $5fa732a17329782a$var$STICKY;
});
function $5fa732a17329782a$var$useWindowViewportRectRef(callback, customScrollParent, skipAnimationFrame) {
    const viewportInfo = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useRef(null);
    const calculateInfo = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useCallback((element)=>{
        if (element === null || !element.offsetParent) return;
        const rect = element.getBoundingClientRect();
        const visibleWidth = rect.width;
        let visibleHeight, offsetTop;
        if (customScrollParent) {
            const customScrollParentRect = customScrollParent.getBoundingClientRect();
            const deltaTop = rect.top - customScrollParentRect.top;
            visibleHeight = customScrollParentRect.height - Math.max(0, deltaTop);
            offsetTop = deltaTop + customScrollParent.scrollTop;
        } else {
            visibleHeight = window.innerHeight - Math.max(0, rect.top);
            offsetTop = rect.top + window.pageYOffset;
        }
        viewportInfo.current = {
            offsetTop: offsetTop,
            visibleHeight: visibleHeight,
            visibleWidth: visibleWidth
        };
        callback(viewportInfo.current);
    }, [
        callback,
        customScrollParent
    ]);
    const { callbackRef: callbackRef, ref: ref } = $5fa732a17329782a$var$useSizeWithElRef(calculateInfo, true, skipAnimationFrame);
    const scrollAndResizeEventHandler = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useCallback(()=>{
        calculateInfo(ref.current);
    }, [
        calculateInfo,
        ref
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useEffect(()=>{
        if (customScrollParent) {
            customScrollParent.addEventListener("scroll", scrollAndResizeEventHandler);
            const observer = new ResizeObserver(()=>{
                requestAnimationFrame(scrollAndResizeEventHandler);
            });
            observer.observe(customScrollParent);
            return ()=>{
                customScrollParent.removeEventListener("scroll", scrollAndResizeEventHandler);
                observer.unobserve(customScrollParent);
            };
        } else {
            window.addEventListener("scroll", scrollAndResizeEventHandler);
            window.addEventListener("resize", scrollAndResizeEventHandler);
            return ()=>{
                window.removeEventListener("scroll", scrollAndResizeEventHandler);
                window.removeEventListener("resize", scrollAndResizeEventHandler);
            };
        }
    }, [
        scrollAndResizeEventHandler,
        customScrollParent
    ]);
    return callbackRef;
}
const $5fa732a17329782a$export$99e9d54e386aea7b = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createContext(void 0);
const $5fa732a17329782a$export$81e3217b4b7a890f = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createContext(void 0);
function $5fa732a17329782a$var$identity(value) {
    return value;
}
const $5fa732a17329782a$var$listComponentPropsSystem = /* @__PURE__ */ $5fa732a17329782a$var$system(()=>{
    const itemContent = $5fa732a17329782a$var$statefulStream((index)=>`Item ${index}`);
    const context = $5fa732a17329782a$var$statefulStream(null);
    const groupContent = $5fa732a17329782a$var$statefulStream((index)=>`Group ${index}`);
    const components = $5fa732a17329782a$var$statefulStream({});
    const computeItemKey = $5fa732a17329782a$var$statefulStream($5fa732a17329782a$var$identity);
    const HeaderFooterTag = $5fa732a17329782a$var$statefulStream("div");
    const scrollerRef = $5fa732a17329782a$var$statefulStream($5fa732a17329782a$var$noop);
    const distinctProp = (propName, defaultValue = null)=>{
        return $5fa732a17329782a$var$statefulStreamFromEmitter($5fa732a17329782a$var$pipe(components, $5fa732a17329782a$var$map((components2)=>components2[propName]), $5fa732a17329782a$var$distinctUntilChanged()), defaultValue);
    };
    return {
        context: context,
        itemContent: itemContent,
        groupContent: groupContent,
        components: components,
        computeItemKey: computeItemKey,
        HeaderFooterTag: HeaderFooterTag,
        scrollerRef: scrollerRef,
        FooterComponent: distinctProp("Footer"),
        HeaderComponent: distinctProp("Header"),
        TopItemListComponent: distinctProp("TopItemList"),
        ListComponent: distinctProp("List", "div"),
        ItemComponent: distinctProp("Item", "div"),
        GroupComponent: distinctProp("Group", "div"),
        ScrollerComponent: distinctProp("Scroller", "div"),
        EmptyPlaceholder: distinctProp("EmptyPlaceholder"),
        ScrollSeekPlaceholder: distinctProp("ScrollSeekPlaceholder")
    };
});
const $5fa732a17329782a$var$combinedSystem$2 = /* @__PURE__ */ $5fa732a17329782a$var$system(([listSystem2, propsSystem])=>{
    return {
        ...listSystem2,
        ...propsSystem
    };
}, $5fa732a17329782a$var$tup($5fa732a17329782a$var$listSystem, $5fa732a17329782a$var$listComponentPropsSystem));
const $5fa732a17329782a$var$DefaultScrollSeekPlaceholder$1 = ({ height: height })=>/* @__PURE__ */ (0, $4TLFw.jsx)("div", {
        style: {
            height: height
        }
    });
const $5fa732a17329782a$var$GROUP_STYLE = {
    position: $5fa732a17329782a$var$positionStickyCssValue(),
    zIndex: 1,
    overflowAnchor: "none"
};
const $5fa732a17329782a$var$ITEM_STYLE$1 = {
    overflowAnchor: "none"
};
const $5fa732a17329782a$var$HORIZONTAL_ITEM_STYLE = {
    ...$5fa732a17329782a$var$ITEM_STYLE$1,
    display: "inline-block",
    height: "100%"
};
const $5fa732a17329782a$var$Items$1 = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).memo(function VirtuosoItems({ showTopList: showTopList = false }) {
    const listState = $5fa732a17329782a$var$useEmitterValue$2("listState");
    const sizeRanges = $5fa732a17329782a$var$usePublisher$2("sizeRanges");
    const useWindowScroll = $5fa732a17329782a$var$useEmitterValue$2("useWindowScroll");
    const customScrollParent = $5fa732a17329782a$var$useEmitterValue$2("customScrollParent");
    const windowScrollContainerStateCallback = $5fa732a17329782a$var$usePublisher$2("windowScrollContainerState");
    const _scrollContainerStateCallback = $5fa732a17329782a$var$usePublisher$2("scrollContainerState");
    const scrollContainerStateCallback = customScrollParent || useWindowScroll ? windowScrollContainerStateCallback : _scrollContainerStateCallback;
    const itemContent = $5fa732a17329782a$var$useEmitterValue$2("itemContent");
    const context = $5fa732a17329782a$var$useEmitterValue$2("context");
    const groupContent = $5fa732a17329782a$var$useEmitterValue$2("groupContent");
    const trackItemSizes = $5fa732a17329782a$var$useEmitterValue$2("trackItemSizes");
    const itemSize = $5fa732a17329782a$var$useEmitterValue$2("itemSize");
    const log = $5fa732a17329782a$var$useEmitterValue$2("log");
    const listGap = $5fa732a17329782a$var$usePublisher$2("gap");
    const horizontalDirection = $5fa732a17329782a$var$useEmitterValue$2("horizontalDirection");
    const { callbackRef: callbackRef } = $5fa732a17329782a$var$useChangedListContentsSizes(sizeRanges, itemSize, trackItemSizes, showTopList ? $5fa732a17329782a$var$noop : scrollContainerStateCallback, log, listGap, customScrollParent, horizontalDirection, $5fa732a17329782a$var$useEmitterValue$2("skipAnimationFrameInResizeObserver"));
    const [deviation, setDeviation] = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useState(0);
    $5fa732a17329782a$var$useEmitter$2("deviation", (value)=>{
        if (deviation !== value) setDeviation(value);
    });
    const EmptyPlaceholder = $5fa732a17329782a$var$useEmitterValue$2("EmptyPlaceholder");
    const ScrollSeekPlaceholder = $5fa732a17329782a$var$useEmitterValue$2("ScrollSeekPlaceholder") || $5fa732a17329782a$var$DefaultScrollSeekPlaceholder$1;
    const ListComponent = $5fa732a17329782a$var$useEmitterValue$2("ListComponent");
    const ItemComponent = $5fa732a17329782a$var$useEmitterValue$2("ItemComponent");
    const GroupComponent = $5fa732a17329782a$var$useEmitterValue$2("GroupComponent");
    const computeItemKey = $5fa732a17329782a$var$useEmitterValue$2("computeItemKey");
    const isSeeking = $5fa732a17329782a$var$useEmitterValue$2("isSeeking");
    const hasGroups2 = $5fa732a17329782a$var$useEmitterValue$2("groupIndices").length > 0;
    const alignToBottom = $5fa732a17329782a$var$useEmitterValue$2("alignToBottom");
    const initialItemFinalLocationReached = $5fa732a17329782a$var$useEmitterValue$2("initialItemFinalLocationReached");
    const containerStyle = showTopList ? {} : {
        boxSizing: "border-box",
        ...horizontalDirection ? {
            whiteSpace: "nowrap",
            display: "inline-block",
            height: "100%",
            paddingLeft: listState.offsetTop,
            paddingRight: listState.offsetBottom,
            marginLeft: deviation !== 0 ? deviation : alignToBottom ? "auto" : 0
        } : {
            marginTop: deviation !== 0 ? deviation : alignToBottom ? "auto" : 0,
            paddingTop: listState.offsetTop,
            paddingBottom: listState.offsetBottom
        },
        ...initialItemFinalLocationReached ? {} : {
            visibility: "hidden"
        }
    };
    if (!showTopList && listState.totalCount === 0 && EmptyPlaceholder) return /* @__PURE__ */ (0, $4TLFw.jsx)(EmptyPlaceholder, {
        ...$5fa732a17329782a$var$contextPropIfNotDomElement(EmptyPlaceholder, context)
    });
    return /* @__PURE__ */ (0, $4TLFw.jsx)(ListComponent, {
        ...$5fa732a17329782a$var$contextPropIfNotDomElement(ListComponent, context),
        ref: callbackRef,
        style: containerStyle,
        "data-testid": showTopList ? "virtuoso-top-item-list" : "virtuoso-item-list",
        children: (showTopList ? listState.topItems : listState.items).map((item)=>{
            const index = item.originalIndex;
            const key = computeItemKey(index + listState.firstItemIndex, item.data, context);
            if (isSeeking) return /* @__PURE__ */ (0, $jbmdS.createElement)(ScrollSeekPlaceholder, {
                ...$5fa732a17329782a$var$contextPropIfNotDomElement(ScrollSeekPlaceholder, context),
                key: key,
                index: item.index,
                height: item.size,
                type: item.type || "item",
                ...item.type === "group" ? {} : {
                    groupIndex: item.groupIndex
                }
            });
            if (item.type === "group") return /* @__PURE__ */ (0, $jbmdS.createElement)(GroupComponent, {
                ...$5fa732a17329782a$var$contextPropIfNotDomElement(GroupComponent, context),
                key: key,
                "data-index": index,
                "data-known-size": item.size,
                "data-item-index": item.index,
                style: $5fa732a17329782a$var$GROUP_STYLE
            }, groupContent(item.index, context));
            else return /* @__PURE__ */ (0, $jbmdS.createElement)(ItemComponent, {
                ...$5fa732a17329782a$var$contextPropIfNotDomElement(ItemComponent, context),
                ...$5fa732a17329782a$var$itemPropIfNotDomElement(ItemComponent, item.data),
                key: key,
                "data-index": index,
                "data-known-size": item.size,
                "data-item-index": item.index,
                "data-item-group-index": item.groupIndex,
                style: horizontalDirection ? $5fa732a17329782a$var$HORIZONTAL_ITEM_STYLE : $5fa732a17329782a$var$ITEM_STYLE$1
            }, hasGroups2 ? itemContent(item.index, item.groupIndex, item.data, context) : itemContent(item.index, item.data, context));
        })
    });
});
const $5fa732a17329782a$var$scrollerStyle = {
    height: "100%",
    outline: "none",
    overflowY: "auto",
    position: "relative",
    WebkitOverflowScrolling: "touch"
};
const $5fa732a17329782a$var$horizontalScrollerStyle = {
    outline: "none",
    overflowX: "auto",
    position: "relative"
};
const $5fa732a17329782a$var$viewportStyle = (alignToBottom)=>({
        width: "100%",
        height: "100%",
        position: "absolute",
        top: 0,
        ...alignToBottom ? {
            display: "flex",
            flexDirection: "column"
        } : {}
    });
const $5fa732a17329782a$var$topItemListStyle = {
    width: "100%",
    position: $5fa732a17329782a$var$positionStickyCssValue(),
    top: 0,
    zIndex: 1
};
function $5fa732a17329782a$var$contextPropIfNotDomElement(element, context) {
    if (typeof element === "string") return void 0;
    return {
        context: context
    };
}
function $5fa732a17329782a$var$itemPropIfNotDomElement(element, item) {
    return {
        item: typeof element === "string" ? void 0 : item
    };
}
const $5fa732a17329782a$var$Header$1 = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).memo(function VirtuosoHeader() {
    const Header2 = $5fa732a17329782a$var$useEmitterValue$2("HeaderComponent");
    const headerHeight = $5fa732a17329782a$var$usePublisher$2("headerHeight");
    const HeaderFooterTag = $5fa732a17329782a$var$useEmitterValue$2("HeaderFooterTag");
    const ref = $5fa732a17329782a$var$useSize((0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useMemo(()=>(el)=>headerHeight($5fa732a17329782a$var$correctItemSize(el, "height")), [
        headerHeight
    ]), true, $5fa732a17329782a$var$useEmitterValue$2("skipAnimationFrameInResizeObserver"));
    const context = $5fa732a17329782a$var$useEmitterValue$2("context");
    return Header2 ? /* @__PURE__ */ (0, $4TLFw.jsx)(HeaderFooterTag, {
        ref: ref,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)(Header2, {
            ...$5fa732a17329782a$var$contextPropIfNotDomElement(Header2, context)
        })
    }) : null;
});
const $5fa732a17329782a$var$Footer$1 = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).memo(function VirtuosoFooter() {
    const Footer2 = $5fa732a17329782a$var$useEmitterValue$2("FooterComponent");
    const footerHeight = $5fa732a17329782a$var$usePublisher$2("footerHeight");
    const HeaderFooterTag = $5fa732a17329782a$var$useEmitterValue$2("HeaderFooterTag");
    const ref = $5fa732a17329782a$var$useSize((0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useMemo(()=>(el)=>footerHeight($5fa732a17329782a$var$correctItemSize(el, "height")), [
        footerHeight
    ]), true, $5fa732a17329782a$var$useEmitterValue$2("skipAnimationFrameInResizeObserver"));
    const context = $5fa732a17329782a$var$useEmitterValue$2("context");
    return Footer2 ? /* @__PURE__ */ (0, $4TLFw.jsx)(HeaderFooterTag, {
        ref: ref,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)(Footer2, {
            ...$5fa732a17329782a$var$contextPropIfNotDomElement(Footer2, context)
        })
    }) : null;
});
function $5fa732a17329782a$var$buildScroller({ usePublisher: usePublisher2, useEmitter: useEmitter2, useEmitterValue: useEmitterValue2 }) {
    const Scroller2 = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).memo(function VirtuosoScroller({ style: style, children: children, ...props }) {
        const scrollContainerStateCallback = usePublisher2("scrollContainerState");
        const ScrollerComponent = useEmitterValue2("ScrollerComponent");
        const smoothScrollTargetReached = usePublisher2("smoothScrollTargetReached");
        const scrollerRefCallback = useEmitterValue2("scrollerRef");
        const context = useEmitterValue2("context");
        const horizontalDirection = useEmitterValue2("horizontalDirection") || false;
        const { scrollerRef: scrollerRef, scrollByCallback: scrollByCallback, scrollToCallback: scrollToCallback } = $5fa732a17329782a$var$useScrollTop(scrollContainerStateCallback, smoothScrollTargetReached, ScrollerComponent, scrollerRefCallback, void 0, horizontalDirection);
        useEmitter2("scrollTo", scrollToCallback);
        useEmitter2("scrollBy", scrollByCallback);
        const defaultStyle = horizontalDirection ? $5fa732a17329782a$var$horizontalScrollerStyle : $5fa732a17329782a$var$scrollerStyle;
        return /* @__PURE__ */ (0, $4TLFw.jsx)(ScrollerComponent, {
            ref: scrollerRef,
            style: {
                ...defaultStyle,
                ...style
            },
            "data-testid": "virtuoso-scroller",
            "data-virtuoso-scroller": true,
            tabIndex: 0,
            ...props,
            ...$5fa732a17329782a$var$contextPropIfNotDomElement(ScrollerComponent, context),
            children: children
        });
    });
    return Scroller2;
}
function $5fa732a17329782a$var$buildWindowScroller({ usePublisher: usePublisher2, useEmitter: useEmitter2, useEmitterValue: useEmitterValue2 }) {
    const Scroller2 = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).memo(function VirtuosoWindowScroller({ style: style, children: children, ...props }) {
        const scrollContainerStateCallback = usePublisher2("windowScrollContainerState");
        const ScrollerComponent = useEmitterValue2("ScrollerComponent");
        const smoothScrollTargetReached = usePublisher2("smoothScrollTargetReached");
        const totalListHeight = useEmitterValue2("totalListHeight");
        const deviation = useEmitterValue2("deviation");
        const customScrollParent = useEmitterValue2("customScrollParent");
        const context = useEmitterValue2("context");
        const { scrollerRef: scrollerRef, scrollByCallback: scrollByCallback, scrollToCallback: scrollToCallback } = $5fa732a17329782a$var$useScrollTop(scrollContainerStateCallback, smoothScrollTargetReached, ScrollerComponent, $5fa732a17329782a$var$noop, customScrollParent);
        $5fa732a17329782a$var$useIsomorphicLayoutEffect(()=>{
            scrollerRef.current = customScrollParent ? customScrollParent : window;
            return ()=>{
                scrollerRef.current = null;
            };
        }, [
            scrollerRef,
            customScrollParent
        ]);
        useEmitter2("windowScrollTo", scrollToCallback);
        useEmitter2("scrollBy", scrollByCallback);
        return /* @__PURE__ */ (0, $4TLFw.jsx)(ScrollerComponent, {
            style: {
                position: "relative",
                ...style,
                ...totalListHeight !== 0 ? {
                    height: totalListHeight + deviation
                } : {}
            },
            "data-virtuoso-scroller": true,
            ...props,
            ...$5fa732a17329782a$var$contextPropIfNotDomElement(ScrollerComponent, context),
            children: children
        });
    });
    return Scroller2;
}
const $5fa732a17329782a$var$Viewport$2 = ({ children: children })=>{
    const ctx = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useContext($5fa732a17329782a$export$99e9d54e386aea7b);
    const viewportHeight = $5fa732a17329782a$var$usePublisher$2("viewportHeight");
    const fixedItemHeight = $5fa732a17329782a$var$usePublisher$2("fixedItemHeight");
    const alignToBottom = $5fa732a17329782a$var$useEmitterValue$2("alignToBottom");
    const horizontalDirection = $5fa732a17329782a$var$useEmitterValue$2("horizontalDirection");
    const viewportSizeCallbackMemo = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useMemo(()=>$5fa732a17329782a$var$compose(viewportHeight, (el)=>$5fa732a17329782a$var$correctItemSize(el, horizontalDirection ? "width" : "height")), [
        viewportHeight,
        horizontalDirection
    ]);
    const viewportRef = $5fa732a17329782a$var$useSize(viewportSizeCallbackMemo, true, $5fa732a17329782a$var$useEmitterValue$2("skipAnimationFrameInResizeObserver"));
    (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useEffect(()=>{
        if (ctx) {
            viewportHeight(ctx.viewportHeight);
            fixedItemHeight(ctx.itemHeight);
        }
    }, [
        ctx,
        viewportHeight,
        fixedItemHeight
    ]);
    return /* @__PURE__ */ (0, $4TLFw.jsx)("div", {
        style: $5fa732a17329782a$var$viewportStyle(alignToBottom),
        ref: viewportRef,
        "data-viewport-type": "element",
        children: children
    });
};
const $5fa732a17329782a$var$WindowViewport$2 = ({ children: children })=>{
    const ctx = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useContext($5fa732a17329782a$export$99e9d54e386aea7b);
    const windowViewportRect = $5fa732a17329782a$var$usePublisher$2("windowViewportRect");
    const fixedItemHeight = $5fa732a17329782a$var$usePublisher$2("fixedItemHeight");
    const customScrollParent = $5fa732a17329782a$var$useEmitterValue$2("customScrollParent");
    const viewportRef = $5fa732a17329782a$var$useWindowViewportRectRef(windowViewportRect, customScrollParent, $5fa732a17329782a$var$useEmitterValue$2("skipAnimationFrameInResizeObserver"));
    const alignToBottom = $5fa732a17329782a$var$useEmitterValue$2("alignToBottom");
    (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useEffect(()=>{
        if (ctx) {
            fixedItemHeight(ctx.itemHeight);
            windowViewportRect({
                offsetTop: 0,
                visibleHeight: ctx.viewportHeight,
                visibleWidth: 100
            });
        }
    }, [
        ctx,
        windowViewportRect,
        fixedItemHeight
    ]);
    return /* @__PURE__ */ (0, $4TLFw.jsx)("div", {
        ref: viewportRef,
        style: $5fa732a17329782a$var$viewportStyle(alignToBottom),
        "data-viewport-type": "window",
        children: children
    });
};
const $5fa732a17329782a$var$TopItemListContainer = ({ children: children })=>{
    const TopItemList = $5fa732a17329782a$var$useEmitterValue$2("TopItemListComponent") || "div";
    const headerHeight = $5fa732a17329782a$var$useEmitterValue$2("headerHeight");
    const style = {
        ...$5fa732a17329782a$var$topItemListStyle,
        marginTop: `${headerHeight}px`
    };
    const context = $5fa732a17329782a$var$useEmitterValue$2("context");
    return /* @__PURE__ */ (0, $4TLFw.jsx)(TopItemList, {
        style: style,
        ...$5fa732a17329782a$var$contextPropIfNotDomElement(TopItemList, context),
        children: children
    });
};
const $5fa732a17329782a$var$ListRoot = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).memo(function VirtuosoRoot(props) {
    const useWindowScroll = $5fa732a17329782a$var$useEmitterValue$2("useWindowScroll");
    const showTopList = $5fa732a17329782a$var$useEmitterValue$2("topItemsIndexes").length > 0;
    const customScrollParent = $5fa732a17329782a$var$useEmitterValue$2("customScrollParent");
    const TheScroller = customScrollParent || useWindowScroll ? $5fa732a17329782a$var$WindowScroller$2 : $5fa732a17329782a$var$Scroller$2;
    const TheViewport = customScrollParent || useWindowScroll ? $5fa732a17329782a$var$WindowViewport$2 : $5fa732a17329782a$var$Viewport$2;
    return /* @__PURE__ */ (0, $4TLFw.jsxs)(TheScroller, {
        ...props,
        children: [
            showTopList && /* @__PURE__ */ (0, $4TLFw.jsx)($5fa732a17329782a$var$TopItemListContainer, {
                children: /* @__PURE__ */ (0, $4TLFw.jsx)($5fa732a17329782a$var$Items$1, {
                    showTopList: true
                })
            }),
            /* @__PURE__ */ (0, $4TLFw.jsxs)(TheViewport, {
                children: [
                    /* @__PURE__ */ (0, $4TLFw.jsx)($5fa732a17329782a$var$Header$1, {}),
                    /* @__PURE__ */ (0, $4TLFw.jsx)($5fa732a17329782a$var$Items$1, {}),
                    /* @__PURE__ */ (0, $4TLFw.jsx)($5fa732a17329782a$var$Footer$1, {})
                ]
            })
        ]
    });
});
const { Component: $5fa732a17329782a$var$List, usePublisher: $5fa732a17329782a$var$usePublisher$2, useEmitterValue: $5fa732a17329782a$var$useEmitterValue$2, useEmitter: $5fa732a17329782a$var$useEmitter$2 } = /* @__PURE__ */ $5fa732a17329782a$var$systemToComponent($5fa732a17329782a$var$combinedSystem$2, {
    required: {},
    optional: {
        restoreStateFrom: "restoreStateFrom",
        context: "context",
        followOutput: "followOutput",
        itemContent: "itemContent",
        groupContent: "groupContent",
        overscan: "overscan",
        increaseViewportBy: "increaseViewportBy",
        totalCount: "totalCount",
        groupCounts: "groupCounts",
        topItemCount: "topItemCount",
        firstItemIndex: "firstItemIndex",
        initialTopMostItemIndex: "initialTopMostItemIndex",
        components: "components",
        atBottomThreshold: "atBottomThreshold",
        atTopThreshold: "atTopThreshold",
        computeItemKey: "computeItemKey",
        defaultItemHeight: "defaultItemHeight",
        fixedItemHeight: "fixedItemHeight",
        itemSize: "itemSize",
        scrollSeekConfiguration: "scrollSeekConfiguration",
        headerFooterTag: "HeaderFooterTag",
        data: "data",
        initialItemCount: "initialItemCount",
        initialScrollTop: "initialScrollTop",
        alignToBottom: "alignToBottom",
        useWindowScroll: "useWindowScroll",
        customScrollParent: "customScrollParent",
        scrollerRef: "scrollerRef",
        logLevel: "logLevel",
        horizontalDirection: "horizontalDirection",
        skipAnimationFrameInResizeObserver: "skipAnimationFrameInResizeObserver"
    },
    methods: {
        scrollToIndex: "scrollToIndex",
        scrollIntoView: "scrollIntoView",
        scrollTo: "scrollTo",
        scrollBy: "scrollBy",
        autoscrollToBottom: "autoscrollToBottom",
        getState: "getState"
    },
    events: {
        isScrolling: "isScrolling",
        endReached: "endReached",
        startReached: "startReached",
        rangeChanged: "rangeChanged",
        atBottomStateChange: "atBottomStateChange",
        atTopStateChange: "atTopStateChange",
        totalListHeightChanged: "totalListHeightChanged",
        itemsRendered: "itemsRendered",
        groupIndices: "groupIndices"
    }
}, $5fa732a17329782a$var$ListRoot);
const $5fa732a17329782a$var$Scroller$2 = /* @__PURE__ */ $5fa732a17329782a$var$buildScroller({
    usePublisher: $5fa732a17329782a$var$usePublisher$2,
    useEmitterValue: $5fa732a17329782a$var$useEmitterValue$2,
    useEmitter: $5fa732a17329782a$var$useEmitter$2
});
const $5fa732a17329782a$var$WindowScroller$2 = /* @__PURE__ */ $5fa732a17329782a$var$buildWindowScroller({
    usePublisher: $5fa732a17329782a$var$usePublisher$2,
    useEmitterValue: $5fa732a17329782a$var$useEmitterValue$2,
    useEmitter: $5fa732a17329782a$var$useEmitter$2
});
const $5fa732a17329782a$export$ea50ab61e1198ee3 = $5fa732a17329782a$var$List;
const $5fa732a17329782a$export$41737384f976dee3 = $5fa732a17329782a$var$List;
const $5fa732a17329782a$var$INITIAL_GRID_STATE = {
    items: [],
    offsetBottom: 0,
    offsetTop: 0,
    top: 0,
    bottom: 0,
    itemHeight: 0,
    itemWidth: 0
};
const $5fa732a17329782a$var$PROBE_GRID_STATE = {
    items: [
        {
            index: 0
        }
    ],
    offsetBottom: 0,
    offsetTop: 0,
    top: 0,
    bottom: 0,
    itemHeight: 0,
    itemWidth: 0
};
const { round: $5fa732a17329782a$var$round, ceil: $5fa732a17329782a$var$ceil, floor: $5fa732a17329782a$var$floor, min: $5fa732a17329782a$var$min, max: $5fa732a17329782a$var$max } = Math;
function $5fa732a17329782a$var$buildProbeGridState(items) {
    return {
        ...$5fa732a17329782a$var$PROBE_GRID_STATE,
        items: items
    };
}
function $5fa732a17329782a$var$buildItems(startIndex, endIndex, data) {
    return Array.from({
        length: endIndex - startIndex + 1
    }).map((_, i)=>{
        const dataItem = data === null ? null : data[i + startIndex];
        return {
            index: i + startIndex,
            data: dataItem
        };
    });
}
function $5fa732a17329782a$var$gapComparator(prev, next) {
    return prev && prev.column === next.column && prev.row === next.row;
}
function $5fa732a17329782a$var$dimensionComparator(prev, next) {
    return prev && prev.width === next.width && prev.height === next.height;
}
const $5fa732a17329782a$var$gridSystem = /* @__PURE__ */ $5fa732a17329782a$var$system(([{ overscan: overscan, visibleRange: visibleRange, listBoundary: listBoundary, increaseViewportBy: increaseViewportBy }, { scrollTop: scrollTop, viewportHeight: viewportHeight, scrollBy: scrollBy, scrollTo: scrollTo, smoothScrollTargetReached: smoothScrollTargetReached, scrollContainerState: scrollContainerState, footerHeight: footerHeight, headerHeight: headerHeight }, stateFlags, scrollSeek, { propsReady: propsReady, didMount: didMount }, { windowViewportRect: windowViewportRect, useWindowScroll: useWindowScroll, customScrollParent: customScrollParent, windowScrollContainerState: windowScrollContainerState, windowScrollTo: windowScrollTo }, log])=>{
    const totalCount = $5fa732a17329782a$var$statefulStream(0);
    const initialItemCount = $5fa732a17329782a$var$statefulStream(0);
    const gridState = $5fa732a17329782a$var$statefulStream($5fa732a17329782a$var$INITIAL_GRID_STATE);
    const viewportDimensions = $5fa732a17329782a$var$statefulStream({
        height: 0,
        width: 0
    });
    const itemDimensions = $5fa732a17329782a$var$statefulStream({
        height: 0,
        width: 0
    });
    const scrollToIndex = $5fa732a17329782a$var$stream();
    const scrollHeight = $5fa732a17329782a$var$stream();
    const deviation = $5fa732a17329782a$var$statefulStream(0);
    const data = $5fa732a17329782a$var$statefulStream(null);
    const gap = $5fa732a17329782a$var$statefulStream({
        row: 0,
        column: 0
    });
    const stateChanged = $5fa732a17329782a$var$stream();
    const restoreStateFrom = $5fa732a17329782a$var$stream();
    const stateRestoreInProgress = $5fa732a17329782a$var$statefulStream(false);
    const initialTopMostItemIndex = $5fa732a17329782a$var$statefulStream(0);
    const scrolledToInitialItem = $5fa732a17329782a$var$statefulStream(true);
    const scrollScheduled = $5fa732a17329782a$var$statefulStream(false);
    const horizontalDirection = $5fa732a17329782a$var$statefulStream(false);
    $5fa732a17329782a$var$subscribe($5fa732a17329782a$var$pipe(didMount, $5fa732a17329782a$var$withLatestFrom(initialTopMostItemIndex), $5fa732a17329782a$var$filter(([_, location])=>!!location)), ()=>{
        $5fa732a17329782a$var$publish(scrolledToInitialItem, false);
    });
    $5fa732a17329782a$var$subscribe($5fa732a17329782a$var$pipe($5fa732a17329782a$var$combineLatest(didMount, scrolledToInitialItem, itemDimensions, viewportDimensions, initialTopMostItemIndex, scrollScheduled), $5fa732a17329782a$var$filter(([didMount2, scrolledToInitialItem2, itemDimensions2, viewportDimensions2, , scrollScheduled2])=>{
        return didMount2 && !scrolledToInitialItem2 && itemDimensions2.height !== 0 && viewportDimensions2.height !== 0 && !scrollScheduled2;
    })), ([, , , , initialTopMostItemIndex2])=>{
        $5fa732a17329782a$var$publish(scrollScheduled, true);
        $5fa732a17329782a$var$skipFrames(1, ()=>{
            $5fa732a17329782a$var$publish(scrollToIndex, initialTopMostItemIndex2);
        });
        $5fa732a17329782a$var$handleNext($5fa732a17329782a$var$pipe(scrollTop), ()=>{
            $5fa732a17329782a$var$publish(listBoundary, [
                0,
                0
            ]);
            $5fa732a17329782a$var$publish(scrolledToInitialItem, true);
        });
    });
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe(restoreStateFrom, $5fa732a17329782a$var$filter((value)=>value !== void 0 && value !== null && value.scrollTop > 0), $5fa732a17329782a$var$mapTo(0)), initialItemCount);
    $5fa732a17329782a$var$subscribe($5fa732a17329782a$var$pipe(didMount, $5fa732a17329782a$var$withLatestFrom(restoreStateFrom), $5fa732a17329782a$var$filter(([, snapshot])=>snapshot !== void 0 && snapshot !== null)), ([, snapshot])=>{
        if (!snapshot) return;
        $5fa732a17329782a$var$publish(viewportDimensions, snapshot.viewport), $5fa732a17329782a$var$publish(itemDimensions, snapshot == null ? void 0 : snapshot.item);
        $5fa732a17329782a$var$publish(gap, snapshot.gap);
        if (snapshot.scrollTop > 0) {
            $5fa732a17329782a$var$publish(stateRestoreInProgress, true);
            $5fa732a17329782a$var$handleNext($5fa732a17329782a$var$pipe(scrollTop, $5fa732a17329782a$var$skip(1)), (_value)=>{
                $5fa732a17329782a$var$publish(stateRestoreInProgress, false);
            });
            $5fa732a17329782a$var$publish(scrollTo, {
                top: snapshot.scrollTop
            });
        }
    });
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe(viewportDimensions, $5fa732a17329782a$var$map(({ height: height })=>height)), viewportHeight);
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe($5fa732a17329782a$var$combineLatest($5fa732a17329782a$var$duc(viewportDimensions, $5fa732a17329782a$var$dimensionComparator), $5fa732a17329782a$var$duc(itemDimensions, $5fa732a17329782a$var$dimensionComparator), $5fa732a17329782a$var$duc(gap, (prev, next)=>prev && prev.column === next.column && prev.row === next.row), $5fa732a17329782a$var$duc(scrollTop)), $5fa732a17329782a$var$map(([viewport, item, gap2, scrollTop2])=>({
            viewport: viewport,
            item: item,
            gap: gap2,
            scrollTop: scrollTop2
        }))), stateChanged);
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe($5fa732a17329782a$var$combineLatest($5fa732a17329782a$var$duc(totalCount), visibleRange, $5fa732a17329782a$var$duc(gap, $5fa732a17329782a$var$gapComparator), $5fa732a17329782a$var$duc(itemDimensions, $5fa732a17329782a$var$dimensionComparator), $5fa732a17329782a$var$duc(viewportDimensions, $5fa732a17329782a$var$dimensionComparator), $5fa732a17329782a$var$duc(data), $5fa732a17329782a$var$duc(initialItemCount), $5fa732a17329782a$var$duc(stateRestoreInProgress), $5fa732a17329782a$var$duc(scrolledToInitialItem), $5fa732a17329782a$var$duc(initialTopMostItemIndex)), $5fa732a17329782a$var$filter(([, , , , , , , stateRestoreInProgress2])=>{
        return !stateRestoreInProgress2;
    }), $5fa732a17329782a$var$map(([totalCount2, [startOffset, endOffset], gap2, item, viewport, data2, initialItemCount2, , scrolledToInitialItem2, initialTopMostItemIndex2])=>{
        const { row: rowGap, column: columnGap } = gap2;
        const { height: itemHeight, width: itemWidth } = item;
        const { width: viewportWidth } = viewport;
        if (initialItemCount2 === 0 && (totalCount2 === 0 || viewportWidth === 0)) return $5fa732a17329782a$var$INITIAL_GRID_STATE;
        if (itemWidth === 0) {
            const startIndex2 = $5fa732a17329782a$var$getInitialTopMostItemIndexNumber(initialTopMostItemIndex2, totalCount2);
            const endIndex2 = startIndex2 + Math.max(initialItemCount2 - 1, 0);
            return $5fa732a17329782a$var$buildProbeGridState($5fa732a17329782a$var$buildItems(startIndex2, endIndex2, data2));
        }
        const perRow = $5fa732a17329782a$var$itemsPerRow(viewportWidth, itemWidth, columnGap);
        let startIndex;
        let endIndex;
        if (!scrolledToInitialItem2) {
            startIndex = 0;
            endIndex = -1;
        } else if (startOffset === 0 && endOffset === 0 && initialItemCount2 > 0) {
            startIndex = 0;
            endIndex = initialItemCount2 - 1;
        } else {
            startIndex = perRow * $5fa732a17329782a$var$floor((startOffset + rowGap) / (itemHeight + rowGap));
            endIndex = perRow * $5fa732a17329782a$var$ceil((endOffset + rowGap) / (itemHeight + rowGap)) - 1;
            endIndex = $5fa732a17329782a$var$min(totalCount2 - 1, $5fa732a17329782a$var$max(endIndex, perRow - 1));
            startIndex = $5fa732a17329782a$var$min(endIndex, $5fa732a17329782a$var$max(0, startIndex));
        }
        const items = $5fa732a17329782a$var$buildItems(startIndex, endIndex, data2);
        const { top: top, bottom: bottom } = $5fa732a17329782a$var$gridLayout(viewport, gap2, item, items);
        const rowCount = $5fa732a17329782a$var$ceil(totalCount2 / perRow);
        const totalHeight = rowCount * itemHeight + (rowCount - 1) * rowGap;
        const offsetBottom = totalHeight - bottom;
        return {
            items: items,
            offsetTop: top,
            offsetBottom: offsetBottom,
            top: top,
            bottom: bottom,
            itemHeight: itemHeight,
            itemWidth: itemWidth
        };
    })), gridState);
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe(data, $5fa732a17329782a$var$filter((data2)=>data2 !== null), $5fa732a17329782a$var$map((data2)=>data2.length)), totalCount);
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe($5fa732a17329782a$var$combineLatest(viewportDimensions, itemDimensions, gridState, gap), $5fa732a17329782a$var$filter(([viewportDimensions2, itemDimensions2, { items: items }])=>{
        return items.length > 0 && itemDimensions2.height !== 0 && viewportDimensions2.height !== 0;
    }), $5fa732a17329782a$var$map(([viewportDimensions2, itemDimensions2, { items: items }, gap2])=>{
        const { top: top, bottom: bottom } = $5fa732a17329782a$var$gridLayout(viewportDimensions2, gap2, itemDimensions2, items);
        return [
            top,
            bottom
        ];
    }), $5fa732a17329782a$var$distinctUntilChanged($5fa732a17329782a$var$tupleComparator)), listBoundary);
    const hasScrolled = $5fa732a17329782a$var$statefulStream(false);
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe(scrollTop, $5fa732a17329782a$var$withLatestFrom(hasScrolled), $5fa732a17329782a$var$map(([scrollTop2, hasScrolled2])=>{
        return hasScrolled2 || scrollTop2 !== 0;
    })), hasScrolled);
    const endReached = $5fa732a17329782a$var$streamFromEmitter($5fa732a17329782a$var$pipe($5fa732a17329782a$var$duc(gridState), $5fa732a17329782a$var$filter(({ items: items })=>items.length > 0), $5fa732a17329782a$var$withLatestFrom(totalCount, hasScrolled), $5fa732a17329782a$var$filter(([{ items: items }, totalCount2, hasScrolled2])=>hasScrolled2 && items[items.length - 1].index === totalCount2 - 1), $5fa732a17329782a$var$map(([, totalCount2])=>totalCount2 - 1), $5fa732a17329782a$var$distinctUntilChanged()));
    const startReached = $5fa732a17329782a$var$streamFromEmitter($5fa732a17329782a$var$pipe($5fa732a17329782a$var$duc(gridState), $5fa732a17329782a$var$filter(({ items: items })=>{
        return items.length > 0 && items[0].index === 0;
    }), // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    $5fa732a17329782a$var$mapTo(0), $5fa732a17329782a$var$distinctUntilChanged()));
    const rangeChanged = $5fa732a17329782a$var$streamFromEmitter($5fa732a17329782a$var$pipe($5fa732a17329782a$var$duc(gridState), $5fa732a17329782a$var$withLatestFrom(stateRestoreInProgress), $5fa732a17329782a$var$filter(([{ items: items }, stateRestoreInProgress2])=>items.length > 0 && !stateRestoreInProgress2), $5fa732a17329782a$var$map(([{ items: items }])=>{
        return {
            startIndex: items[0].index,
            endIndex: items[items.length - 1].index
        };
    }), $5fa732a17329782a$var$distinctUntilChanged($5fa732a17329782a$var$rangeComparator), $5fa732a17329782a$var$throttleTime(0)));
    $5fa732a17329782a$var$connect(rangeChanged, scrollSeek.scrollSeekRangeChanged);
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe(scrollToIndex, $5fa732a17329782a$var$withLatestFrom(viewportDimensions, itemDimensions, totalCount, gap), $5fa732a17329782a$var$map(([location, viewportDimensions2, itemDimensions2, totalCount2, gap2])=>{
        const normalLocation = $5fa732a17329782a$var$normalizeIndexLocation(location);
        const { align: align, behavior: behavior, offset: offset } = normalLocation;
        let index = normalLocation.index;
        if (index === "LAST") index = totalCount2 - 1;
        index = $5fa732a17329782a$var$max(0, index, $5fa732a17329782a$var$min(totalCount2 - 1, index));
        let top = $5fa732a17329782a$var$itemTop(viewportDimensions2, gap2, itemDimensions2, index);
        if (align === "end") top = $5fa732a17329782a$var$round(top - viewportDimensions2.height + itemDimensions2.height);
        else if (align === "center") top = $5fa732a17329782a$var$round(top - viewportDimensions2.height / 2 + itemDimensions2.height / 2);
        if (offset) top += offset;
        return {
            top: top,
            behavior: behavior
        };
    })), scrollTo);
    const totalListHeight = $5fa732a17329782a$var$statefulStreamFromEmitter($5fa732a17329782a$var$pipe(gridState, $5fa732a17329782a$var$map((gridState2)=>{
        return gridState2.offsetBottom + gridState2.bottom;
    })), 0);
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$pipe(windowViewportRect, $5fa732a17329782a$var$map((viewportInfo)=>({
            width: viewportInfo.visibleWidth,
            height: viewportInfo.visibleHeight
        }))), viewportDimensions);
    return {
        data: // input
        data,
        totalCount: totalCount,
        viewportDimensions: viewportDimensions,
        itemDimensions: itemDimensions,
        scrollTop: scrollTop,
        scrollHeight: scrollHeight,
        overscan: overscan,
        increaseViewportBy: increaseViewportBy,
        scrollBy: scrollBy,
        scrollTo: scrollTo,
        scrollToIndex: scrollToIndex,
        smoothScrollTargetReached: smoothScrollTargetReached,
        windowViewportRect: windowViewportRect,
        windowScrollTo: windowScrollTo,
        useWindowScroll: useWindowScroll,
        customScrollParent: customScrollParent,
        windowScrollContainerState: windowScrollContainerState,
        deviation: deviation,
        scrollContainerState: scrollContainerState,
        footerHeight: footerHeight,
        headerHeight: headerHeight,
        initialItemCount: initialItemCount,
        gap: gap,
        restoreStateFrom: restoreStateFrom,
        ...scrollSeek,
        initialTopMostItemIndex: initialTopMostItemIndex,
        horizontalDirection: horizontalDirection,
        gridState: // output
        gridState,
        totalListHeight: totalListHeight,
        ...stateFlags,
        startReached: startReached,
        endReached: endReached,
        rangeChanged: rangeChanged,
        stateChanged: stateChanged,
        propsReady: propsReady,
        stateRestoreInProgress: stateRestoreInProgress,
        ...log
    };
}, $5fa732a17329782a$var$tup($5fa732a17329782a$var$sizeRangeSystem, $5fa732a17329782a$var$domIOSystem, $5fa732a17329782a$var$stateFlagsSystem, $5fa732a17329782a$var$scrollSeekSystem, $5fa732a17329782a$var$propsReadySystem, $5fa732a17329782a$var$windowScrollerSystem, $5fa732a17329782a$var$loggerSystem));
function $5fa732a17329782a$var$gridLayout(viewport, gap, item, items) {
    const { height: itemHeight } = item;
    if (itemHeight === void 0 || items.length === 0) return {
        top: 0,
        bottom: 0
    };
    const top = $5fa732a17329782a$var$itemTop(viewport, gap, item, items[0].index);
    const bottom = $5fa732a17329782a$var$itemTop(viewport, gap, item, items[items.length - 1].index) + itemHeight;
    return {
        top: top,
        bottom: bottom
    };
}
function $5fa732a17329782a$var$itemTop(viewport, gap, item, index) {
    const perRow = $5fa732a17329782a$var$itemsPerRow(viewport.width, item.width, gap.column);
    const rowCount = $5fa732a17329782a$var$floor(index / perRow);
    const top = rowCount * item.height + $5fa732a17329782a$var$max(0, rowCount - 1) * gap.row;
    return top > 0 ? top + gap.row : top;
}
function $5fa732a17329782a$var$itemsPerRow(viewportWidth, itemWidth, gap) {
    return $5fa732a17329782a$var$max(1, $5fa732a17329782a$var$floor((viewportWidth + gap) / ($5fa732a17329782a$var$floor(itemWidth) + gap)));
}
const $5fa732a17329782a$var$gridComponentPropsSystem = /* @__PURE__ */ $5fa732a17329782a$var$system(()=>{
    const itemContent = $5fa732a17329782a$var$statefulStream((index)=>`Item ${index}`);
    const components = $5fa732a17329782a$var$statefulStream({});
    const context = $5fa732a17329782a$var$statefulStream(null);
    const itemClassName = $5fa732a17329782a$var$statefulStream("virtuoso-grid-item");
    const listClassName = $5fa732a17329782a$var$statefulStream("virtuoso-grid-list");
    const computeItemKey = $5fa732a17329782a$var$statefulStream($5fa732a17329782a$var$identity);
    const headerFooterTag = $5fa732a17329782a$var$statefulStream("div");
    const scrollerRef = $5fa732a17329782a$var$statefulStream($5fa732a17329782a$var$noop);
    const distinctProp = (propName, defaultValue = null)=>{
        return $5fa732a17329782a$var$statefulStreamFromEmitter($5fa732a17329782a$var$pipe(components, $5fa732a17329782a$var$map((components2)=>components2[propName]), $5fa732a17329782a$var$distinctUntilChanged()), defaultValue);
    };
    const readyStateChanged = $5fa732a17329782a$var$statefulStream(false);
    const reportReadyState = $5fa732a17329782a$var$statefulStream(false);
    $5fa732a17329782a$var$connect($5fa732a17329782a$var$duc(reportReadyState), readyStateChanged);
    return {
        readyStateChanged: readyStateChanged,
        reportReadyState: reportReadyState,
        context: context,
        itemContent: itemContent,
        components: components,
        computeItemKey: computeItemKey,
        itemClassName: itemClassName,
        listClassName: listClassName,
        headerFooterTag: headerFooterTag,
        scrollerRef: scrollerRef,
        FooterComponent: distinctProp("Footer"),
        HeaderComponent: distinctProp("Header"),
        ListComponent: distinctProp("List", "div"),
        ItemComponent: distinctProp("Item", "div"),
        ScrollerComponent: distinctProp("Scroller", "div"),
        ScrollSeekPlaceholder: distinctProp("ScrollSeekPlaceholder", "div")
    };
});
const $5fa732a17329782a$var$combinedSystem$1 = /* @__PURE__ */ $5fa732a17329782a$var$system(([gridSystem2, gridComponentPropsSystem2])=>{
    return {
        ...gridSystem2,
        ...gridComponentPropsSystem2
    };
}, $5fa732a17329782a$var$tup($5fa732a17329782a$var$gridSystem, $5fa732a17329782a$var$gridComponentPropsSystem));
const $5fa732a17329782a$var$GridItems = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).memo(function GridItems2() {
    const gridState = $5fa732a17329782a$var$useEmitterValue$1("gridState");
    const listClassName = $5fa732a17329782a$var$useEmitterValue$1("listClassName");
    const itemClassName = $5fa732a17329782a$var$useEmitterValue$1("itemClassName");
    const itemContent = $5fa732a17329782a$var$useEmitterValue$1("itemContent");
    const computeItemKey = $5fa732a17329782a$var$useEmitterValue$1("computeItemKey");
    const isSeeking = $5fa732a17329782a$var$useEmitterValue$1("isSeeking");
    const scrollHeightCallback = $5fa732a17329782a$var$usePublisher$1("scrollHeight");
    const ItemComponent = $5fa732a17329782a$var$useEmitterValue$1("ItemComponent");
    const ListComponent = $5fa732a17329782a$var$useEmitterValue$1("ListComponent");
    const ScrollSeekPlaceholder = $5fa732a17329782a$var$useEmitterValue$1("ScrollSeekPlaceholder");
    const context = $5fa732a17329782a$var$useEmitterValue$1("context");
    const itemDimensions = $5fa732a17329782a$var$usePublisher$1("itemDimensions");
    const gridGap = $5fa732a17329782a$var$usePublisher$1("gap");
    const log = $5fa732a17329782a$var$useEmitterValue$1("log");
    const stateRestoreInProgress = $5fa732a17329782a$var$useEmitterValue$1("stateRestoreInProgress");
    const reportReadyState = $5fa732a17329782a$var$usePublisher$1("reportReadyState");
    const listRef = $5fa732a17329782a$var$useSize((0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useMemo(()=>(el)=>{
            const scrollHeight = el.parentElement.parentElement.scrollHeight;
            scrollHeightCallback(scrollHeight);
            const firstItem = el.firstChild;
            if (firstItem) {
                const { width: width, height: height } = firstItem.getBoundingClientRect();
                itemDimensions({
                    width: width,
                    height: height
                });
            }
            gridGap({
                row: $5fa732a17329782a$var$resolveGapValue("row-gap", getComputedStyle(el).rowGap, log),
                column: $5fa732a17329782a$var$resolveGapValue("column-gap", getComputedStyle(el).columnGap, log)
            });
        }, [
        scrollHeightCallback,
        itemDimensions,
        gridGap,
        log
    ]), true, false);
    $5fa732a17329782a$var$useIsomorphicLayoutEffect(()=>{
        if (gridState.itemHeight > 0 && gridState.itemWidth > 0) reportReadyState(true);
    }, [
        gridState
    ]);
    if (stateRestoreInProgress) return null;
    return /* @__PURE__ */ (0, $4TLFw.jsx)(ListComponent, {
        ref: listRef,
        className: listClassName,
        ...$5fa732a17329782a$var$contextPropIfNotDomElement(ListComponent, context),
        style: {
            paddingTop: gridState.offsetTop,
            paddingBottom: gridState.offsetBottom
        },
        "data-testid": "virtuoso-item-list",
        children: gridState.items.map((item)=>{
            const key = computeItemKey(item.index, item.data, context);
            return isSeeking ? /* @__PURE__ */ (0, $4TLFw.jsx)(ScrollSeekPlaceholder, {
                ...$5fa732a17329782a$var$contextPropIfNotDomElement(ScrollSeekPlaceholder, context),
                index: item.index,
                height: gridState.itemHeight,
                width: gridState.itemWidth
            }, key) : /* @__PURE__ */ (0, $jbmdS.createElement)(ItemComponent, {
                ...$5fa732a17329782a$var$contextPropIfNotDomElement(ItemComponent, context),
                className: itemClassName,
                "data-index": item.index,
                key: key
            }, itemContent(item.index, item.data, context));
        })
    });
});
const $5fa732a17329782a$var$Header = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).memo(function VirtuosoHeader2() {
    const Header2 = $5fa732a17329782a$var$useEmitterValue$1("HeaderComponent");
    const headerHeight = $5fa732a17329782a$var$usePublisher$1("headerHeight");
    const HeaderFooterTag = $5fa732a17329782a$var$useEmitterValue$1("headerFooterTag");
    const ref = $5fa732a17329782a$var$useSize((0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useMemo(()=>(el)=>headerHeight($5fa732a17329782a$var$correctItemSize(el, "height")), [
        headerHeight
    ]), true, false);
    const context = $5fa732a17329782a$var$useEmitterValue$1("context");
    return Header2 ? /* @__PURE__ */ (0, $4TLFw.jsx)(HeaderFooterTag, {
        ref: ref,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)(Header2, {
            ...$5fa732a17329782a$var$contextPropIfNotDomElement(Header2, context)
        })
    }) : null;
});
const $5fa732a17329782a$var$Footer = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).memo(function VirtuosoGridFooter() {
    const Footer2 = $5fa732a17329782a$var$useEmitterValue$1("FooterComponent");
    const footerHeight = $5fa732a17329782a$var$usePublisher$1("footerHeight");
    const HeaderFooterTag = $5fa732a17329782a$var$useEmitterValue$1("headerFooterTag");
    const ref = $5fa732a17329782a$var$useSize((0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useMemo(()=>(el)=>footerHeight($5fa732a17329782a$var$correctItemSize(el, "height")), [
        footerHeight
    ]), true, false);
    const context = $5fa732a17329782a$var$useEmitterValue$1("context");
    return Footer2 ? /* @__PURE__ */ (0, $4TLFw.jsx)(HeaderFooterTag, {
        ref: ref,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)(Footer2, {
            ...$5fa732a17329782a$var$contextPropIfNotDomElement(Footer2, context)
        })
    }) : null;
});
const $5fa732a17329782a$var$Viewport$1 = ({ children: children })=>{
    const ctx = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useContext($5fa732a17329782a$export$81e3217b4b7a890f);
    const itemDimensions = $5fa732a17329782a$var$usePublisher$1("itemDimensions");
    const viewportDimensions = $5fa732a17329782a$var$usePublisher$1("viewportDimensions");
    const viewportRef = $5fa732a17329782a$var$useSize((0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useMemo(()=>(el)=>{
            viewportDimensions(el.getBoundingClientRect());
        }, [
        viewportDimensions
    ]), true, false);
    (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useEffect(()=>{
        if (ctx) {
            viewportDimensions({
                height: ctx.viewportHeight,
                width: ctx.viewportWidth
            });
            itemDimensions({
                height: ctx.itemHeight,
                width: ctx.itemWidth
            });
        }
    }, [
        ctx,
        viewportDimensions,
        itemDimensions
    ]);
    return /* @__PURE__ */ (0, $4TLFw.jsx)("div", {
        style: $5fa732a17329782a$var$viewportStyle(false),
        ref: viewportRef,
        children: children
    });
};
const $5fa732a17329782a$var$WindowViewport$1 = ({ children: children })=>{
    const ctx = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useContext($5fa732a17329782a$export$81e3217b4b7a890f);
    const windowViewportRect = $5fa732a17329782a$var$usePublisher$1("windowViewportRect");
    const itemDimensions = $5fa732a17329782a$var$usePublisher$1("itemDimensions");
    const customScrollParent = $5fa732a17329782a$var$useEmitterValue$1("customScrollParent");
    const viewportRef = $5fa732a17329782a$var$useWindowViewportRectRef(windowViewportRect, customScrollParent, false);
    (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useEffect(()=>{
        if (ctx) {
            itemDimensions({
                height: ctx.itemHeight,
                width: ctx.itemWidth
            });
            windowViewportRect({
                offsetTop: 0,
                visibleHeight: ctx.viewportHeight,
                visibleWidth: ctx.viewportWidth
            });
        }
    }, [
        ctx,
        windowViewportRect,
        itemDimensions
    ]);
    return /* @__PURE__ */ (0, $4TLFw.jsx)("div", {
        ref: viewportRef,
        style: $5fa732a17329782a$var$viewportStyle(false),
        children: children
    });
};
const $5fa732a17329782a$var$GridRoot = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).memo(function GridRoot2({ ...props }) {
    const useWindowScroll = $5fa732a17329782a$var$useEmitterValue$1("useWindowScroll");
    const customScrollParent = $5fa732a17329782a$var$useEmitterValue$1("customScrollParent");
    const TheScroller = customScrollParent || useWindowScroll ? $5fa732a17329782a$var$WindowScroller$1 : $5fa732a17329782a$var$Scroller$1;
    const TheViewport = customScrollParent || useWindowScroll ? $5fa732a17329782a$var$WindowViewport$1 : $5fa732a17329782a$var$Viewport$1;
    return /* @__PURE__ */ (0, $4TLFw.jsx)(TheScroller, {
        ...props,
        children: /* @__PURE__ */ (0, $4TLFw.jsxs)(TheViewport, {
            children: [
                /* @__PURE__ */ (0, $4TLFw.jsx)($5fa732a17329782a$var$Header, {}),
                /* @__PURE__ */ (0, $4TLFw.jsx)($5fa732a17329782a$var$GridItems, {}),
                /* @__PURE__ */ (0, $4TLFw.jsx)($5fa732a17329782a$var$Footer, {})
            ]
        })
    });
});
const { Component: $5fa732a17329782a$var$Grid, usePublisher: $5fa732a17329782a$var$usePublisher$1, useEmitterValue: $5fa732a17329782a$var$useEmitterValue$1, useEmitter: $5fa732a17329782a$var$useEmitter$1 } = /* @__PURE__ */ $5fa732a17329782a$var$systemToComponent($5fa732a17329782a$var$combinedSystem$1, {
    optional: {
        context: "context",
        totalCount: "totalCount",
        overscan: "overscan",
        itemContent: "itemContent",
        components: "components",
        computeItemKey: "computeItemKey",
        data: "data",
        initialItemCount: "initialItemCount",
        scrollSeekConfiguration: "scrollSeekConfiguration",
        headerFooterTag: "headerFooterTag",
        listClassName: "listClassName",
        itemClassName: "itemClassName",
        useWindowScroll: "useWindowScroll",
        customScrollParent: "customScrollParent",
        scrollerRef: "scrollerRef",
        logLevel: "logLevel",
        restoreStateFrom: "restoreStateFrom",
        initialTopMostItemIndex: "initialTopMostItemIndex",
        increaseViewportBy: "increaseViewportBy"
    },
    methods: {
        scrollTo: "scrollTo",
        scrollBy: "scrollBy",
        scrollToIndex: "scrollToIndex"
    },
    events: {
        isScrolling: "isScrolling",
        endReached: "endReached",
        startReached: "startReached",
        rangeChanged: "rangeChanged",
        atBottomStateChange: "atBottomStateChange",
        atTopStateChange: "atTopStateChange",
        stateChanged: "stateChanged",
        readyStateChanged: "readyStateChanged"
    }
}, $5fa732a17329782a$var$GridRoot);
const $5fa732a17329782a$var$Scroller$1 = /* @__PURE__ */ $5fa732a17329782a$var$buildScroller({
    usePublisher: $5fa732a17329782a$var$usePublisher$1,
    useEmitterValue: $5fa732a17329782a$var$useEmitterValue$1,
    useEmitter: $5fa732a17329782a$var$useEmitter$1
});
const $5fa732a17329782a$var$WindowScroller$1 = /* @__PURE__ */ $5fa732a17329782a$var$buildWindowScroller({
    usePublisher: $5fa732a17329782a$var$usePublisher$1,
    useEmitterValue: $5fa732a17329782a$var$useEmitterValue$1,
    useEmitter: $5fa732a17329782a$var$useEmitter$1
});
function $5fa732a17329782a$var$resolveGapValue(property, value, log) {
    if (value !== "normal" && !(value == null ? void 0 : value.endsWith("px"))) log(`${property} was not resolved to pixel value correctly`, value, $5fa732a17329782a$export$243e62d78d3b544d.WARN);
    if (value === "normal") return 0;
    return parseInt(value != null ? value : "0", 10);
}
const $5fa732a17329782a$export$eef3fd285144b65e = $5fa732a17329782a$var$Grid;
const $5fa732a17329782a$var$tableComponentPropsSystem = /* @__PURE__ */ $5fa732a17329782a$var$system(()=>{
    const itemContent = $5fa732a17329782a$var$statefulStream((index)=>/* @__PURE__ */ (0, $4TLFw.jsxs)("td", {
            children: [
                "Item $",
                index
            ]
        }));
    const context = $5fa732a17329782a$var$statefulStream(null);
    const fixedHeaderContent = $5fa732a17329782a$var$statefulStream(null);
    const fixedFooterContent = $5fa732a17329782a$var$statefulStream(null);
    const components = $5fa732a17329782a$var$statefulStream({});
    const computeItemKey = $5fa732a17329782a$var$statefulStream($5fa732a17329782a$var$identity);
    const scrollerRef = $5fa732a17329782a$var$statefulStream($5fa732a17329782a$var$noop);
    const distinctProp = (propName, defaultValue = null)=>{
        return $5fa732a17329782a$var$statefulStreamFromEmitter($5fa732a17329782a$var$pipe(components, $5fa732a17329782a$var$map((components2)=>components2[propName]), $5fa732a17329782a$var$distinctUntilChanged()), defaultValue);
    };
    return {
        context: context,
        itemContent: itemContent,
        fixedHeaderContent: fixedHeaderContent,
        fixedFooterContent: fixedFooterContent,
        components: components,
        computeItemKey: computeItemKey,
        scrollerRef: scrollerRef,
        TableComponent: distinctProp("Table", "table"),
        TableHeadComponent: distinctProp("TableHead", "thead"),
        TableFooterComponent: distinctProp("TableFoot", "tfoot"),
        TableBodyComponent: distinctProp("TableBody", "tbody"),
        TableRowComponent: distinctProp("TableRow", "tr"),
        ScrollerComponent: distinctProp("Scroller", "div"),
        EmptyPlaceholder: distinctProp("EmptyPlaceholder"),
        ScrollSeekPlaceholder: distinctProp("ScrollSeekPlaceholder"),
        FillerRow: distinctProp("FillerRow")
    };
});
const $5fa732a17329782a$var$combinedSystem = /* @__PURE__ */ $5fa732a17329782a$var$system(([listSystem2, propsSystem])=>{
    return {
        ...listSystem2,
        ...propsSystem
    };
}, $5fa732a17329782a$var$tup($5fa732a17329782a$var$listSystem, $5fa732a17329782a$var$tableComponentPropsSystem));
const $5fa732a17329782a$var$DefaultScrollSeekPlaceholder = ({ height: height })=>/* @__PURE__ */ (0, $4TLFw.jsx)("tr", {
        children: /* @__PURE__ */ (0, $4TLFw.jsx)("td", {
            style: {
                height: height
            }
        })
    });
const $5fa732a17329782a$var$DefaultFillerRow = ({ height: height })=>/* @__PURE__ */ (0, $4TLFw.jsx)("tr", {
        children: /* @__PURE__ */ (0, $4TLFw.jsx)("td", {
            style: {
                height: height,
                padding: 0,
                border: 0
            }
        })
    });
const $5fa732a17329782a$var$ITEM_STYLE = {
    overflowAnchor: "none"
};
const $5fa732a17329782a$var$Items = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).memo(function VirtuosoItems2({ showTopList: showTopList = false }) {
    const listState = $5fa732a17329782a$var$useEmitterValue("listState");
    const computeItemKey = $5fa732a17329782a$var$useEmitterValue("computeItemKey");
    const firstItemIndex = $5fa732a17329782a$var$useEmitterValue("firstItemIndex");
    const isSeeking = $5fa732a17329782a$var$useEmitterValue("isSeeking");
    const ScrollSeekPlaceholder = $5fa732a17329782a$var$useEmitterValue("ScrollSeekPlaceholder") || $5fa732a17329782a$var$DefaultScrollSeekPlaceholder;
    const context = $5fa732a17329782a$var$useEmitterValue("context");
    const TableRowComponent = $5fa732a17329782a$var$useEmitterValue("TableRowComponent");
    const fixedHeaderHeight = $5fa732a17329782a$var$useEmitterValue("fixedHeaderHeight");
    const itemContent = $5fa732a17329782a$var$useEmitterValue("itemContent");
    const topItemOffsets = (showTopList ? listState.topItems : []).reduce((acc, item, index)=>{
        if (index === 0) acc.push(item.size);
        else acc.push(acc[index - 1] + item.size);
        return acc;
    }, []);
    const items = (showTopList ? listState.topItems : listState.items).map((item)=>{
        const index = item.originalIndex;
        const key = computeItemKey(index + firstItemIndex, item.data, context);
        const offsetTop = showTopList ? index === 0 ? 0 : topItemOffsets[index - 1] : 0;
        if (isSeeking) return /* @__PURE__ */ (0, $jbmdS.createElement)(ScrollSeekPlaceholder, {
            ...$5fa732a17329782a$var$contextPropIfNotDomElement(ScrollSeekPlaceholder, context),
            key: key,
            index: item.index,
            height: item.size,
            type: item.type || "item"
        });
        return /* @__PURE__ */ (0, $jbmdS.createElement)(TableRowComponent, {
            ...$5fa732a17329782a$var$contextPropIfNotDomElement(TableRowComponent, context),
            ...$5fa732a17329782a$var$itemPropIfNotDomElement(TableRowComponent, item.data),
            key: key,
            "data-index": index,
            "data-known-size": item.size,
            "data-item-index": item.index,
            style: showTopList ? {
                overflowAnchor: "none",
                position: "sticky",
                zIndex: 2,
                top: fixedHeaderHeight + offsetTop
            } : $5fa732a17329782a$var$ITEM_STYLE
        }, itemContent(item.index, item.data, context));
    });
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $4TLFw.Fragment), {
        children: items
    });
});
const $5fa732a17329782a$var$TableBody = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).memo(function TableVirtuosoBody() {
    const listState = $5fa732a17329782a$var$useEmitterValue("listState");
    const showTopList = $5fa732a17329782a$var$useEmitterValue("topItemsIndexes").length > 0;
    const sizeRanges = $5fa732a17329782a$var$usePublisher("sizeRanges");
    const useWindowScroll = $5fa732a17329782a$var$useEmitterValue("useWindowScroll");
    const customScrollParent = $5fa732a17329782a$var$useEmitterValue("customScrollParent");
    const windowScrollContainerStateCallback = $5fa732a17329782a$var$usePublisher("windowScrollContainerState");
    const _scrollContainerStateCallback = $5fa732a17329782a$var$usePublisher("scrollContainerState");
    const scrollContainerStateCallback = customScrollParent || useWindowScroll ? windowScrollContainerStateCallback : _scrollContainerStateCallback;
    const trackItemSizes = $5fa732a17329782a$var$useEmitterValue("trackItemSizes");
    const itemSize = $5fa732a17329782a$var$useEmitterValue("itemSize");
    const log = $5fa732a17329782a$var$useEmitterValue("log");
    const { callbackRef: callbackRef, ref: ref } = $5fa732a17329782a$var$useChangedListContentsSizes(sizeRanges, itemSize, trackItemSizes, scrollContainerStateCallback, log, void 0, customScrollParent, false, $5fa732a17329782a$var$useEmitterValue("skipAnimationFrameInResizeObserver"));
    const [deviation, setDeviation] = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useState(0);
    $5fa732a17329782a$var$useEmitter("deviation", (value)=>{
        if (deviation !== value) {
            ref.current.style.marginTop = `${value}px`;
            setDeviation(value);
        }
    });
    const EmptyPlaceholder = $5fa732a17329782a$var$useEmitterValue("EmptyPlaceholder");
    const FillerRow = $5fa732a17329782a$var$useEmitterValue("FillerRow") || $5fa732a17329782a$var$DefaultFillerRow;
    const TableBodyComponent = $5fa732a17329782a$var$useEmitterValue("TableBodyComponent");
    const paddingTopAddition = $5fa732a17329782a$var$useEmitterValue("paddingTopAddition");
    const statefulTotalCount = $5fa732a17329782a$var$useEmitterValue("statefulTotalCount");
    const context = $5fa732a17329782a$var$useEmitterValue("context");
    if (statefulTotalCount === 0 && EmptyPlaceholder) return /* @__PURE__ */ (0, $4TLFw.jsx)(EmptyPlaceholder, {
        ...$5fa732a17329782a$var$contextPropIfNotDomElement(EmptyPlaceholder, context)
    });
    const topItemsSize = (showTopList ? listState.topItems : []).reduce((acc, item)=>acc + item.size, 0);
    const paddingTop = listState.offsetTop + paddingTopAddition + deviation - topItemsSize;
    const paddingBottom = listState.offsetBottom;
    const paddingTopEl = paddingTop > 0 ? /* @__PURE__ */ (0, $4TLFw.jsx)(FillerRow, {
        height: paddingTop,
        context: context
    }, "padding-top") : null;
    const paddingBottomEl = paddingBottom > 0 ? /* @__PURE__ */ (0, $4TLFw.jsx)(FillerRow, {
        height: paddingBottom,
        context: context
    }, "padding-bottom") : null;
    return /* @__PURE__ */ (0, $4TLFw.jsxs)(TableBodyComponent, {
        ref: callbackRef,
        "data-testid": "virtuoso-item-list",
        ...$5fa732a17329782a$var$contextPropIfNotDomElement(TableBodyComponent, context),
        children: [
            paddingTopEl,
            showTopList && /* @__PURE__ */ (0, $4TLFw.jsx)($5fa732a17329782a$var$Items, {
                showTopList: true
            }),
            /* @__PURE__ */ (0, $4TLFw.jsx)($5fa732a17329782a$var$Items, {}),
            paddingBottomEl
        ]
    });
});
const $5fa732a17329782a$var$Viewport = ({ children: children })=>{
    const ctx = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useContext($5fa732a17329782a$export$99e9d54e386aea7b);
    const viewportHeight = $5fa732a17329782a$var$usePublisher("viewportHeight");
    const fixedItemHeight = $5fa732a17329782a$var$usePublisher("fixedItemHeight");
    const viewportRef = $5fa732a17329782a$var$useSize((0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useMemo(()=>$5fa732a17329782a$var$compose(viewportHeight, (el)=>$5fa732a17329782a$var$correctItemSize(el, "height")), [
        viewportHeight
    ]), true, $5fa732a17329782a$var$useEmitterValue("skipAnimationFrameInResizeObserver"));
    (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useEffect(()=>{
        if (ctx) {
            viewportHeight(ctx.viewportHeight);
            fixedItemHeight(ctx.itemHeight);
        }
    }, [
        ctx,
        viewportHeight,
        fixedItemHeight
    ]);
    return /* @__PURE__ */ (0, $4TLFw.jsx)("div", {
        style: $5fa732a17329782a$var$viewportStyle(false),
        ref: viewportRef,
        "data-viewport-type": "element",
        children: children
    });
};
const $5fa732a17329782a$var$WindowViewport = ({ children: children })=>{
    const ctx = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useContext($5fa732a17329782a$export$99e9d54e386aea7b);
    const windowViewportRect = $5fa732a17329782a$var$usePublisher("windowViewportRect");
    const fixedItemHeight = $5fa732a17329782a$var$usePublisher("fixedItemHeight");
    const customScrollParent = $5fa732a17329782a$var$useEmitterValue("customScrollParent");
    const viewportRef = $5fa732a17329782a$var$useWindowViewportRectRef(windowViewportRect, customScrollParent, $5fa732a17329782a$var$useEmitterValue("skipAnimationFrameInResizeObserver"));
    (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useEffect(()=>{
        if (ctx) {
            fixedItemHeight(ctx.itemHeight);
            windowViewportRect({
                offsetTop: 0,
                visibleHeight: ctx.viewportHeight,
                visibleWidth: 100
            });
        }
    }, [
        ctx,
        windowViewportRect,
        fixedItemHeight
    ]);
    return /* @__PURE__ */ (0, $4TLFw.jsx)("div", {
        ref: viewportRef,
        style: $5fa732a17329782a$var$viewportStyle(false),
        "data-viewport-type": "window",
        children: children
    });
};
const $5fa732a17329782a$var$TableRoot = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).memo(function TableVirtuosoRoot(props) {
    const useWindowScroll = $5fa732a17329782a$var$useEmitterValue("useWindowScroll");
    const customScrollParent = $5fa732a17329782a$var$useEmitterValue("customScrollParent");
    const fixedHeaderHeight = $5fa732a17329782a$var$usePublisher("fixedHeaderHeight");
    const fixedFooterHeight = $5fa732a17329782a$var$usePublisher("fixedFooterHeight");
    const fixedHeaderContent = $5fa732a17329782a$var$useEmitterValue("fixedHeaderContent");
    const fixedFooterContent = $5fa732a17329782a$var$useEmitterValue("fixedFooterContent");
    const context = $5fa732a17329782a$var$useEmitterValue("context");
    const theadRef = $5fa732a17329782a$var$useSize((0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useMemo(()=>$5fa732a17329782a$var$compose(fixedHeaderHeight, (el)=>$5fa732a17329782a$var$correctItemSize(el, "height")), [
        fixedHeaderHeight
    ]), true, $5fa732a17329782a$var$useEmitterValue("skipAnimationFrameInResizeObserver"));
    const tfootRef = $5fa732a17329782a$var$useSize((0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useMemo(()=>$5fa732a17329782a$var$compose(fixedFooterHeight, (el)=>$5fa732a17329782a$var$correctItemSize(el, "height")), [
        fixedFooterHeight
    ]), true, $5fa732a17329782a$var$useEmitterValue("skipAnimationFrameInResizeObserver"));
    const TheScroller = customScrollParent || useWindowScroll ? $5fa732a17329782a$var$WindowScroller : $5fa732a17329782a$var$Scroller;
    const TheViewport = customScrollParent || useWindowScroll ? $5fa732a17329782a$var$WindowViewport : $5fa732a17329782a$var$Viewport;
    const TheTable = $5fa732a17329782a$var$useEmitterValue("TableComponent");
    const TheTHead = $5fa732a17329782a$var$useEmitterValue("TableHeadComponent");
    const TheTFoot = $5fa732a17329782a$var$useEmitterValue("TableFooterComponent");
    const theHead = fixedHeaderContent ? /* @__PURE__ */ (0, $4TLFw.jsx)(TheTHead, {
        style: {
            zIndex: 2,
            position: "sticky",
            top: 0
        },
        ref: theadRef,
        ...$5fa732a17329782a$var$contextPropIfNotDomElement(TheTHead, context),
        children: fixedHeaderContent()
    }, "TableHead") : null;
    const theFoot = fixedFooterContent ? /* @__PURE__ */ (0, $4TLFw.jsx)(TheTFoot, {
        style: {
            zIndex: 1,
            position: "sticky",
            bottom: 0
        },
        ref: tfootRef,
        ...$5fa732a17329782a$var$contextPropIfNotDomElement(TheTFoot, context),
        children: fixedFooterContent()
    }, "TableFoot") : null;
    return /* @__PURE__ */ (0, $4TLFw.jsx)(TheScroller, {
        ...props,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)(TheViewport, {
            children: /* @__PURE__ */ (0, $4TLFw.jsxs)(TheTable, {
                style: {
                    borderSpacing: 0,
                    overflowAnchor: "none"
                },
                ...$5fa732a17329782a$var$contextPropIfNotDomElement(TheTable, context),
                children: [
                    theHead,
                    /* @__PURE__ */ (0, $4TLFw.jsx)($5fa732a17329782a$var$TableBody, {}, "TableBody"),
                    theFoot
                ]
            })
        })
    });
});
const { Component: $5fa732a17329782a$var$Table, usePublisher: $5fa732a17329782a$var$usePublisher, useEmitterValue: $5fa732a17329782a$var$useEmitterValue, useEmitter: $5fa732a17329782a$var$useEmitter } = /* @__PURE__ */ $5fa732a17329782a$var$systemToComponent($5fa732a17329782a$var$combinedSystem, {
    required: {},
    optional: {
        restoreStateFrom: "restoreStateFrom",
        context: "context",
        followOutput: "followOutput",
        firstItemIndex: "firstItemIndex",
        itemContent: "itemContent",
        fixedHeaderContent: "fixedHeaderContent",
        fixedFooterContent: "fixedFooterContent",
        overscan: "overscan",
        increaseViewportBy: "increaseViewportBy",
        totalCount: "totalCount",
        topItemCount: "topItemCount",
        initialTopMostItemIndex: "initialTopMostItemIndex",
        components: "components",
        groupCounts: "groupCounts",
        atBottomThreshold: "atBottomThreshold",
        atTopThreshold: "atTopThreshold",
        computeItemKey: "computeItemKey",
        defaultItemHeight: "defaultItemHeight",
        fixedItemHeight: "fixedItemHeight",
        itemSize: "itemSize",
        scrollSeekConfiguration: "scrollSeekConfiguration",
        data: "data",
        initialItemCount: "initialItemCount",
        initialScrollTop: "initialScrollTop",
        alignToBottom: "alignToBottom",
        useWindowScroll: "useWindowScroll",
        customScrollParent: "customScrollParent",
        scrollerRef: "scrollerRef",
        logLevel: "logLevel"
    },
    methods: {
        scrollToIndex: "scrollToIndex",
        scrollIntoView: "scrollIntoView",
        scrollTo: "scrollTo",
        scrollBy: "scrollBy",
        getState: "getState"
    },
    events: {
        isScrolling: "isScrolling",
        endReached: "endReached",
        startReached: "startReached",
        rangeChanged: "rangeChanged",
        atBottomStateChange: "atBottomStateChange",
        atTopStateChange: "atTopStateChange",
        totalListHeightChanged: "totalListHeightChanged",
        itemsRendered: "itemsRendered",
        groupIndices: "groupIndices"
    }
}, $5fa732a17329782a$var$TableRoot);
const $5fa732a17329782a$var$Scroller = /* @__PURE__ */ $5fa732a17329782a$var$buildScroller({
    usePublisher: $5fa732a17329782a$var$usePublisher,
    useEmitterValue: $5fa732a17329782a$var$useEmitterValue,
    useEmitter: $5fa732a17329782a$var$useEmitter
});
const $5fa732a17329782a$var$WindowScroller = /* @__PURE__ */ $5fa732a17329782a$var$buildWindowScroller({
    usePublisher: $5fa732a17329782a$var$usePublisher,
    useEmitterValue: $5fa732a17329782a$var$useEmitterValue,
    useEmitter: $5fa732a17329782a$var$useEmitter
});
const $5fa732a17329782a$export$3631598018434e6e = $5fa732a17329782a$var$Table;

});



parcelRegister("fY40Q", function(module, exports) {

$parcel$export(module.exports, "OrgSubNav", function () { return $b0fbf8476ad97057$export$a2673e49b5b28ce5; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $abMiO = parcelRequire("abMiO");
var $ffYB6 = parcelRequire("ffYB6");
var $ewzNm = parcelRequire("ewzNm");
var $eSo00 = parcelRequire("eSo00");
var $hr6cm = parcelRequire("hr6cm");
var $7TXf7 = parcelRequire("7TXf7");

var $38AIP = parcelRequire("38AIP");

var $eGwj2 = parcelRequire("eGwj2");

var $hKvJ8 = parcelRequire("hKvJ8");

var $a3BWW = parcelRequire("a3BWW");

var $6UBLf = parcelRequire("6UBLf");
const $b0fbf8476ad97057$export$a2673e49b5b28ce5 = ()=>{
    const navigate = (0, $6UBLf.useNavigate)();
    const [expandedList, setExpandedList] = (0, $jbmdS.useState)("revenueForecast");
    const revenueForecastReports = (0, $38AIP.useFilteredCacheItems)("revenueForecastReports");
    const resourceScheduleReports = (0, $38AIP.useFilteredCacheItems)("resourceScheduleReports");
    const lists = [
        {
            id: "revenueForecast",
            title: "Revenue Forecast",
            icon: (0, $eSo00.default),
            rootRoute: "/revenue-forecast",
            items: (revenueForecastReports || []).map((r)=>({
                    label: r.name,
                    value: r.id,
                    route: `/revenue-forecast?report=${r.id}`
                })).sort((a, b)=>a.label.localeCompare(b.label))
        },
        {
            id: "resourceSchedule",
            title: "Resource Schedule",
            icon: (0, $7TXf7.default),
            rootRoute: "/resource-schedule",
            items: (resourceScheduleReports || []).map((r)=>({
                    label: r.name,
                    value: r.id,
                    route: `/resource-schedule?report=${r.id}`
                })).sort((a, b)=>a.label.localeCompare(b.label))
        }
    ];
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $eGwj2.SubNavigationSidebar), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $eGwj2.SubNavigationHeading), {
                children: "Organisation"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $eGwj2.SubNavigationBody), {
                children: [
                    lists.map((list)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $hKvJ8.ExpandableList), {
                            title: list.title,
                            items: list.items,
                            isExpanded: expandedList === list.id,
                            icon: list.icon,
                            rootRoute: list.rootRoute,
                            onToggle: ()=>setExpandedList(expandedList === list.id ? null : list.id)
                        }, list.id)),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $a3BWW.SideNavButton), {
                        icon: (0, $hr6cm.default),
                        label: "Weekly Planning",
                        onClick: ()=>{
                            navigate({
                                to: "/weekly-planning"
                            });
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $eGwj2.SubNavigationFooter), {
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $a3BWW.SideNavButton), {
                        icon: (0, $ffYB6.default),
                        label: "Holidays",
                        onClick: ()=>{
                            navigate({
                                to: "/organisation-holidays"
                            });
                        }
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $a3BWW.SideNavButton), {
                        icon: (0, $ewzNm.default),
                        label: "Operational Expenses",
                        onClick: ()=>{
                            navigate({
                                to: "/overhead-expenses"
                            });
                        }
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $a3BWW.SideNavButton), {
                        icon: (0, $abMiO.default),
                        label: "Cost Centres",
                        onClick: ()=>{
                            navigate({
                                to: "/cost-centres"
                            });
                        }
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("abMiO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76b06656149bd48f$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $76b06656149bd48f$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("Boxes", [
    [
        "path",
        {
            d: "M2.97 12.92A2 2 0 0 0 2 14.63v3.24a2 2 0 0 0 .97 1.71l3 1.8a2 2 0 0 0 2.06 0L12 19v-5.5l-5-3-4.03 2.42Z",
            key: "lc1i9w"
        }
    ],
    [
        "path",
        {
            d: "m7 16.5-4.74-2.85",
            key: "1o9zyk"
        }
    ],
    [
        "path",
        {
            d: "m7 16.5 5-3",
            key: "va8pkn"
        }
    ],
    [
        "path",
        {
            d: "M7 16.5v5.17",
            key: "jnp8gn"
        }
    ],
    [
        "path",
        {
            d: "M12 13.5V19l3.97 2.38a2 2 0 0 0 2.06 0l3-1.8a2 2 0 0 0 .97-1.71v-3.24a2 2 0 0 0-.97-1.71L17 10.5l-5 3Z",
            key: "8zsnat"
        }
    ],
    [
        "path",
        {
            d: "m17 16.5-5-3",
            key: "8arw3v"
        }
    ],
    [
        "path",
        {
            d: "m17 16.5 4.74-2.85",
            key: "8rfmw"
        }
    ],
    [
        "path",
        {
            d: "M17 16.5v5.17",
            key: "k6z78m"
        }
    ],
    [
        "path",
        {
            d: "M7.97 4.42A2 2 0 0 0 7 6.13v4.37l5 3 5-3V6.13a2 2 0 0 0-.97-1.71l-3-1.8a2 2 0 0 0-2.06 0l-3 1.8Z",
            key: "1xygjf"
        }
    ],
    [
        "path",
        {
            d: "M12 8 7.26 5.15",
            key: "1vbdud"
        }
    ],
    [
        "path",
        {
            d: "m12 8 4.74-2.85",
            key: "3rx089"
        }
    ],
    [
        "path",
        {
            d: "M12 13.5V8",
            key: "1io7kd"
        }
    ]
]);

});

parcelRegister("ewzNm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a92fd207e82a5977$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $a92fd207e82a5977$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("HousePlug", [
    [
        "path",
        {
            d: "M10 12V8.964",
            key: "1vll13"
        }
    ],
    [
        "path",
        {
            d: "M14 12V8.964",
            key: "1x3qvg"
        }
    ],
    [
        "path",
        {
            d: "M15 12a1 1 0 0 1 1 1v2a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-2a1 1 0 0 1 1-1z",
            key: "ppykja"
        }
    ],
    [
        "path",
        {
            d: "M8.5 21H5a2 2 0 0 1-2-2v-9a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2v-2",
            key: "1gvg2z"
        }
    ]
]);

});

parcelRegister("hr6cm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb19c429ab637f7f$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $cb19c429ab637f7f$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("SquareKanban", [
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "3",
            rx: "2",
            key: "afitv7"
        }
    ],
    [
        "path",
        {
            d: "M8 7v7",
            key: "1x2jlm"
        }
    ],
    [
        "path",
        {
            d: "M12 7v4",
            key: "xawao1"
        }
    ],
    [
        "path",
        {
            d: "M16 7v9",
            key: "1hp2iy"
        }
    ]
]);

});


parcelRegister("lvLif", function(module, exports) {

$parcel$export(module.exports, "ClientsSubNav", function () { return $d5113be1afc9b663$export$d9249edb87cb20d5; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $artg7 = parcelRequire("artg7");
var $9s5Wh = parcelRequire("9s5Wh");

var $38AIP = parcelRequire("38AIP");

var $eGwj2 = parcelRequire("eGwj2");

var $hKvJ8 = parcelRequire("hKvJ8");

var $a3BWW = parcelRequire("a3BWW");
const $d5113be1afc9b663$export$d9249edb87cb20d5 = ()=>{
    const [expandedList, setExpandedList] = (0, $jbmdS.useState)("contacts");
    const clients = (0, $38AIP.useFilteredCacheItems)("contacts");
    const lists = [
        {
            id: "contacts",
            title: "Clients",
            icon: (0, $artg7.default),
            items: (clients || []).map((c)=>({
                    label: `${c.firstName} ${c.lastName} (${c.organisationName})`,
                    value: c.id,
                    route: `/contacts/${c.id}`
                })).sort((a, b)=>a.label.localeCompare(b.label))
        }
    ];
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $eGwj2.SubNavigationSidebar), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $eGwj2.SubNavigationHeading), {
                children: "Clients"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $eGwj2.SubNavigationBody), {
                children: lists.map((list)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $hKvJ8.ExpandableList), {
                        title: list.title,
                        items: list.items,
                        isExpanded: expandedList === list.id,
                        icon: list.icon,
                        onToggle: ()=>setExpandedList(expandedList === list.id ? null : list.id)
                    }, list.id))
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $eGwj2.SubNavigationFooter), {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $a3BWW.SideNavButton), {
                    icon: (0, $9s5Wh.default),
                    label: "Import Clients",
                    onClick: ()=>null
                })
            })
        ]
    });
};

});
parcelRegister("9s5Wh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e1b55f40198b582$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $6e1b55f40198b582$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("Import", [
    [
        "path",
        {
            d: "M12 3v12",
            key: "1x0j5s"
        }
    ],
    [
        "path",
        {
            d: "m8 11 4 4 4-4",
            key: "1dohi6"
        }
    ],
    [
        "path",
        {
            d: "M8 5H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-4",
            key: "1ywtjm"
        }
    ]
]);

});


parcelRegister("7YQNq", function(module, exports) {

$parcel$export(module.exports, "SuppliersSubNav", function () { return $15e98087fcfabb64$export$604180254b4a1e7f; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");


var $eGwj2 = parcelRequire("eGwj2");
parcelRequire("hKvJ8");
parcelRequire("a3BWW");
const $15e98087fcfabb64$var$getProjectTitle = (project)=>project.jobNumber ? `${project.jobNumber}: ${project.name}` : project.name;
const $15e98087fcfabb64$export$604180254b4a1e7f = ()=>{
    const [expandedList, setExpandedList] = (0, $jbmdS.useState)("reports");
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $eGwj2.SubNavigationSidebar), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $eGwj2.SubNavigationHeading), {
                children: "Suppliers"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $eGwj2.SubNavigationBody), {
                children: "TBD"
            })
        ]
    });
};

});

parcelRegister("lGnOi", function(module, exports) {

$parcel$export(module.exports, "InvoicesSubNav", function () { return $174a4d319f6807cf$export$4df4c95f3eb37457; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $bFwIS = parcelRequire("bFwIS");
var $iKmrz = parcelRequire("iKmrz");
var $eSo00 = parcelRequire("eSo00");
var $ks8uR = parcelRequire("ks8uR");

var $38AIP = parcelRequire("38AIP");

var $eGwj2 = parcelRequire("eGwj2");

var $hKvJ8 = parcelRequire("hKvJ8");

var $a3BWW = parcelRequire("a3BWW");
const $174a4d319f6807cf$export$4df4c95f3eb37457 = ()=>{
    const [expandedList, setExpandedList] = (0, $jbmdS.useState)("reports");
    const invoiceReports = (0, $38AIP.useFilteredCacheItems)("organisationReports", (r)=>r.type === "invoice");
    const invoices = (0, $38AIP.useFilteredCacheItems)("invoices");
    const lists = [
        {
            id: "reports",
            title: "Invoice Reports",
            icon: (0, $eSo00.default),
            rootRoute: "/invoices",
            items: (invoiceReports || []).map((r)=>({
                    label: r.name,
                    value: r.id,
                    route: `/invoices?report=${r.id}`
                })).sort((a, b)=>a.label.localeCompare(b.label))
        },
        {
            id: "invoices",
            title: "Invoices",
            icon: (0, $bFwIS.default),
            items: invoices.map((i)=>({
                    label: i.ref,
                    value: i.id,
                    route: `/invoices/${i.id}`
                })).sort((a, b)=>a.label.localeCompare(b.label))
        }
    ];
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $eGwj2.SubNavigationSidebar), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $eGwj2.SubNavigationHeading), {
                children: "Invoices"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $eGwj2.SubNavigationBody), {
                children: lists.map((list)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $hKvJ8.ExpandableList), {
                        title: list.title,
                        rootRoute: list.rootRoute,
                        items: list.items,
                        isExpanded: expandedList === list.id,
                        icon: list.icon,
                        onToggle: ()=>setExpandedList(expandedList === list.id ? null : list.id)
                    }, list.id))
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $eGwj2.SubNavigationFooter), {
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $a3BWW.SideNavButton), {
                        icon: (0, $iKmrz.default),
                        label: "Invoice Templates",
                        onClick: ()=>null
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $a3BWW.SideNavButton), {
                        icon: (0, $ks8uR.default),
                        label: "Invoice Settings",
                        onClick: ()=>null
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("bFwIS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87ece81ab84ef778$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $87ece81ab84ef778$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("FileText", [
    [
        "path",
        {
            d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
            key: "1rqfz7"
        }
    ],
    [
        "path",
        {
            d: "M14 2v4a2 2 0 0 0 2 2h4",
            key: "tnqrlb"
        }
    ],
    [
        "path",
        {
            d: "M10 9H8",
            key: "b1mrlr"
        }
    ],
    [
        "path",
        {
            d: "M16 13H8",
            key: "t4e002"
        }
    ],
    [
        "path",
        {
            d: "M16 17H8",
            key: "z1uh3a"
        }
    ]
]);

});


parcelRegister("mEEFh", function(module, exports) {

$parcel$export(module.exports, "ExpensesSubNav", function () { return $1399351548d93efd$export$d997cedc140fcc59; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $eSo00 = parcelRequire("eSo00");
var $kKuTV = parcelRequire("kKuTV");

var $38AIP = parcelRequire("38AIP");

var $eGwj2 = parcelRequire("eGwj2");

var $hKvJ8 = parcelRequire("hKvJ8");

var $a3BWW = parcelRequire("a3BWW");

var $6UBLf = parcelRequire("6UBLf");
const $1399351548d93efd$export$d997cedc140fcc59 = ()=>{
    const navigate = (0, $6UBLf.useNavigate)();
    const [expandedList, setExpandedList] = (0, $jbmdS.useState)("reports");
    const expenseReports = (0, $38AIP.useFilteredCacheItems)("organisationReports", (r)=>r.type === "expense");
    const lists = [
        {
            id: "reports",
            title: "Expense Reports",
            icon: (0, $eSo00.default),
            rootRoute: "/expense-reports",
            items: (expenseReports || []).map((r)=>({
                    label: r.name,
                    value: r.id,
                    route: `/expense-reports?report=${r.id}`
                })).sort((a, b)=>a.label.localeCompare(b.label))
        }
    ];
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $eGwj2.SubNavigationSidebar), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $eGwj2.SubNavigationHeading), {
                children: "Expenses"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $eGwj2.SubNavigationBody), {
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $a3BWW.SideNavButton), {
                        icon: (0, $kKuTV.default),
                        label: "Track Expenses",
                        onClick: ()=>{
                            navigate({
                                to: "/track-expenses"
                            });
                        }
                    }),
                    lists.map((list)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $hKvJ8.ExpandableList), {
                            title: list.title,
                            items: list.items,
                            isExpanded: expandedList === list.id,
                            icon: list.icon,
                            rootRoute: list.rootRoute,
                            onToggle: ()=>setExpandedList(expandedList === list.id ? null : list.id)
                        }, list.id))
                ]
            })
        ]
    });
};

});

parcelRegister("2DmvN", function(module, exports) {

$parcel$export(module.exports, "TimeSubNav", function () { return $2b920eb0f489d4e7$export$af23f664182976b4; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $aBjoI = parcelRequire("aBjoI");
var $eSo00 = parcelRequire("eSo00");
var $hr6cm = parcelRequire("hr6cm");
var $bvNdZ = parcelRequire("bvNdZ");

var $38AIP = parcelRequire("38AIP");

var $eGwj2 = parcelRequire("eGwj2");

var $hKvJ8 = parcelRequire("hKvJ8");

var $a3BWW = parcelRequire("a3BWW");

var $6UBLf = parcelRequire("6UBLf");
const $2b920eb0f489d4e7$export$af23f664182976b4 = ()=>{
    const navigate = (0, $6UBLf.useNavigate)();
    const [expandedList, setExpandedList] = (0, $jbmdS.useState)("reports");
    const timeReports = (0, $38AIP.useFilteredCacheItems)("organisationReports", (r)=>r.type === "timesheet");
    const lists = [
        {
            id: "reports",
            title: "Time Reports",
            icon: (0, $eSo00.default),
            rootRoute: "/timesheets/report",
            items: (timeReports || []).map((r)=>({
                    label: r.name,
                    value: r.id,
                    route: `/timesheets/report?report=${r.id}`
                })).sort((a, b)=>a.label.localeCompare(b.label))
        }
    ];
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $eGwj2.SubNavigationSidebar), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $eGwj2.SubNavigationHeading), {
                children: "Time"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $eGwj2.SubNavigationBody), {
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $a3BWW.SideNavButton), {
                        icon: (0, $aBjoI.default),
                        label: "Weekly Timesheets",
                        onClick: ()=>{
                            navigate({
                                to: "/timesheets?tab=weekly"
                            });
                        }
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $a3BWW.SideNavButton), {
                        icon: (0, $bvNdZ.default),
                        label: "Daily Timesheets",
                        onClick: ()=>{
                            navigate({
                                to: "/timesheets?tab=daily"
                            });
                        }
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $a3BWW.SideNavButton), {
                        icon: (0, $hr6cm.default),
                        label: "Time Entry Calendar",
                        onClick: ()=>{
                            navigate({
                                to: "/timesheets/calendar"
                            });
                        }
                    }),
                    lists.map((list)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $hKvJ8.ExpandableList), {
                            title: list.title,
                            rootRoute: list.rootRoute,
                            items: list.items,
                            isExpanded: expandedList === list.id,
                            icon: list.icon,
                            onToggle: ()=>setExpandedList(expandedList === list.id ? null : list.id)
                        }, list.id))
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $eGwj2.SubNavigationFooter), {
                children: "Timer here..."
            })
        ]
    });
};

});
parcelRegister("bvNdZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8618c5f3c3e7be1f$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $8618c5f3c3e7be1f$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("Watch", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "6",
            key: "1vlfrh"
        }
    ],
    [
        "polyline",
        {
            points: "12 10 12 12 13 13",
            key: "19dquz"
        }
    ],
    [
        "path",
        {
            d: "m16.13 7.66-.81-4.05a2 2 0 0 0-2-1.61h-2.68a2 2 0 0 0-2 1.61l-.78 4.05",
            key: "18k57s"
        }
    ],
    [
        "path",
        {
            d: "m7.88 16.36.8 4a2 2 0 0 0 2 1.61h2.72a2 2 0 0 0 2-1.61l.81-4.05",
            key: "16ny36"
        }
    ]
]);

});


parcelRegister("9Xt0I", function(module, exports) {

$parcel$export(module.exports, "ResourcesSubNav", function () { return $98671f837ee2397d$export$91c38287e08b73a; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $bsFNa = parcelRequire("bsFNa");
var $53k6d = parcelRequire("53k6d");
var $eSo00 = parcelRequire("eSo00");
var $csYsJ = parcelRequire("csYsJ");
var $7TXf7 = parcelRequire("7TXf7");

var $38AIP = parcelRequire("38AIP");

var $eGwj2 = parcelRequire("eGwj2");

var $hKvJ8 = parcelRequire("hKvJ8");

var $a3BWW = parcelRequire("a3BWW");

var $6UBLf = parcelRequire("6UBLf");
const $98671f837ee2397d$var$getProjectTitle = (project)=>project.jobNumber ? `${project.jobNumber}: ${project.name}` : project.name;
const $98671f837ee2397d$export$91c38287e08b73a = ()=>{
    const navigate = (0, $6UBLf.useNavigate)();
    const [expandedList, setExpandedList] = (0, $jbmdS.useState)("reports");
    const staffReports = (0, $38AIP.useFilteredCacheItems)("organisationReports", (r)=>r.type === "staffMember");
    const activeStaff = (0, $38AIP.useFilteredCacheItems)("staff", (s)=>!s.isArchived);
    const archivedStaff = (0, $38AIP.useFilteredCacheItems)("staff", (s)=>s.isArchived);
    const activeRoles = (0, $38AIP.useFilteredCacheItems)("roles", (r)=>!r.isArchived);
    const archivedRoles = (0, $38AIP.useFilteredCacheItems)("roles", (r)=>r.isArchived);
    const lists = [
        {
            id: "reports",
            title: "Staff Reports",
            icon: (0, $eSo00.default),
            rootRoute: "/staff",
            items: (staffReports || []).map((r)=>({
                    label: r.name,
                    value: r.id,
                    route: `/staff?report=${r.id}`
                })).sort((a, b)=>a.label.localeCompare(b.label))
        },
        {
            id: "activeStaff",
            title: "Active Staff",
            icon: (0, $7TXf7.default),
            items: activeStaff.map((s)=>({
                    label: `${s.firstName} ${s.lastName}`,
                    value: s.id,
                    route: `/staff/${s.id}`
                })).sort((a, b)=>a.label.localeCompare(b.label))
        },
        {
            id: "archivedStaff",
            title: "Archived Staff",
            icon: (0, $bsFNa.default),
            items: archivedStaff.map((s)=>({
                    label: `${s.firstName} ${s.lastName}`,
                    value: s.id,
                    route: `/staff/${s.id}`
                })).sort((a, b)=>a.label.localeCompare(b.label))
        },
        {
            id: "activeRoles",
            title: "Active Roles",
            icon: (0, $53k6d.default),
            items: activeRoles.map((r)=>({
                    label: r.name,
                    value: r.id,
                    route: `/staff-roles/${r.id}`
                })).sort((a, b)=>a.label.localeCompare(b.label))
        },
        {
            id: "archivedRoles",
            title: "Archived Roles",
            icon: (0, $bsFNa.default),
            items: archivedRoles.map((r)=>({
                    label: r.name,
                    value: r.id,
                    route: `/staff-roles/${r.id}`
                })).sort((a, b)=>a.label.localeCompare(b.label))
        }
    ];
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $eGwj2.SubNavigationSidebar), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $eGwj2.SubNavigationHeading), {
                children: "Resources"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $eGwj2.SubNavigationBody), {
                children: lists.map((list)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $hKvJ8.ExpandableList), {
                        title: list.title,
                        items: list.items,
                        icon: list.icon,
                        rootRoute: list.rootRoute,
                        isExpanded: expandedList === list.id,
                        onToggle: ()=>setExpandedList(expandedList === list.id ? null : list.id)
                    }, list.id))
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $eGwj2.SubNavigationFooter), {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $a3BWW.SideNavButton), {
                    icon: (0, $csYsJ.default),
                    label: "Permissions",
                    onClick: ()=>{
                        navigate({
                            to: "/permissions"
                        });
                    }
                })
            })
        ]
    });
};

});
parcelRegister("53k6d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3adcd2d9275a259f$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $3adcd2d9275a259f$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("HardHat", [
    [
        "path",
        {
            d: "M2 18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v2z",
            key: "1dej2m"
        }
    ],
    [
        "path",
        {
            d: "M10 10V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5",
            key: "1p9q5i"
        }
    ],
    [
        "path",
        {
            d: "M4 15v-3a6 6 0 0 1 6-6",
            key: "9ciidu"
        }
    ],
    [
        "path",
        {
            d: "M14 6a6 6 0 0 1 6 6v3",
            key: "1hnv84"
        }
    ]
]);

});

parcelRegister("csYsJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91370022a139c3bc$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $91370022a139c3bc$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("Shield", [
    [
        "path",
        {
            d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
            key: "oel41y"
        }
    ]
]);

});


parcelRegister("26sX2", function(module, exports) {

$parcel$export(module.exports, "usePageTitle", function () { return $487d3e6d5e0ffc19$export$4882d379d640c470; });
$parcel$export(module.exports, "useSubMenu", function () { return $487d3e6d5e0ffc19$export$b359ddbc2eba6d20; });
$parcel$export(module.exports, "useTabs", function () { return $487d3e6d5e0ffc19$export$d2589202ac9c89c3; });
$parcel$export(module.exports, "useShowSubMenu", function () { return $487d3e6d5e0ffc19$export$c548037d275b1f36; });
$parcel$export(module.exports, "setPageTitle", function () { return $487d3e6d5e0ffc19$export$a3727bea9ace182c; });
$parcel$export(module.exports, "setSubMenu", function () { return $487d3e6d5e0ffc19$export$d0e554fabc4e35cd; });
$parcel$export(module.exports, "setShowSubMenu", function () { return $487d3e6d5e0ffc19$export$2af8afa2d2449359; });
$parcel$export(module.exports, "setLayoutDefaults", function () { return $487d3e6d5e0ffc19$export$3259442acb67cb50; });

var $hxM7m = parcelRequire("hxM7m");

var $lJ1OS = parcelRequire("lJ1OS");
// Initial state
const $487d3e6d5e0ffc19$var$initialContext = {
    pageTitle: "",
    subMenu: null,
    tabs: [],
    showSubMenu: true
};
const $487d3e6d5e0ffc19$export$b8cdfd44cddaf07 = (0, $hxM7m.createStore)({
    context: $487d3e6d5e0ffc19$var$initialContext,
    on: {
        setPageTitle: {
            pageTitle: (_, event)=>event.title
        },
        setSubMenu: {
            subMenu: (_, event)=>event.menu
        },
        setTabs: {
            tabs: (_, event)=>event.tabs
        },
        setShowSubMenu: {
            showSubMenu: (_, event)=>event.show
        },
        setDefaults: {
            pageTitle: (_, event)=>event.pageTitle,
            subMenu: (_, event)=>event.subMenu,
            tabs: (_, event)=>event.tabs
        }
    }
});
const $487d3e6d5e0ffc19$export$4882d379d640c470 = ()=>(0, $lJ1OS.useSelector)($487d3e6d5e0ffc19$export$b8cdfd44cddaf07, (state)=>state.context.pageTitle);
const $487d3e6d5e0ffc19$export$b359ddbc2eba6d20 = ()=>(0, $lJ1OS.useSelector)($487d3e6d5e0ffc19$export$b8cdfd44cddaf07, (state)=>state.context.subMenu);
const $487d3e6d5e0ffc19$export$d2589202ac9c89c3 = ()=>(0, $lJ1OS.useSelector)($487d3e6d5e0ffc19$export$b8cdfd44cddaf07, (state)=>state.context.tabs);
const $487d3e6d5e0ffc19$export$c548037d275b1f36 = ()=>(0, $lJ1OS.useSelector)($487d3e6d5e0ffc19$export$b8cdfd44cddaf07, (state)=>state.context.showSubMenu);
const $487d3e6d5e0ffc19$export$a3727bea9ace182c = (title)=>$487d3e6d5e0ffc19$export$b8cdfd44cddaf07.send({
        type: "setPageTitle",
        title: title
    });
const $487d3e6d5e0ffc19$export$d0e554fabc4e35cd = (menu)=>$487d3e6d5e0ffc19$export$b8cdfd44cddaf07.send({
        type: "setSubMenu",
        menu: menu
    });
const $487d3e6d5e0ffc19$export$45d85ff5ef4a8cf8 = (tabs)=>$487d3e6d5e0ffc19$export$b8cdfd44cddaf07.send({
        type: "setTabs",
        tabs: tabs
    });
const $487d3e6d5e0ffc19$export$2af8afa2d2449359 = (show)=>$487d3e6d5e0ffc19$export$b8cdfd44cddaf07.send({
        type: "setShowSubMenu",
        show: show
    });
const $487d3e6d5e0ffc19$export$3259442acb67cb50 = (defaults)=>$487d3e6d5e0ffc19$export$b8cdfd44cddaf07.send({
        type: "setDefaults",
        ...defaults
    });
const $487d3e6d5e0ffc19$export$3d9a71df5a0f855d = ()=>$487d3e6d5e0ffc19$export$b8cdfd44cddaf07.getSnapshot().context;

});


parcelRegister("be27v", function(module, exports) {

$parcel$export(module.exports, "TopBar", function () { return $7f37221ebfa7d921$export$c4e96258f3b6511; });

var $61Ea1 = parcelRequire("61Ea1");

var $fTGwv = parcelRequire("fTGwv");

var $bYl0g = parcelRequire("bYl0g");

var $ioJ5n = parcelRequire("ioJ5n");
var $korfQ = parcelRequire("korfQ");

var $9RsUu = parcelRequire("9RsUu");

var $6UBLf = parcelRequire("6UBLf");
var $1Fr27 = parcelRequire("1Fr27");

var $26sX2 = parcelRequire("26sX2");
const $7f37221ebfa7d921$export$c4e96258f3b6511 = ()=>{
    var _latestLocation$searc, _tabs$find, _tabs$;
    const { latestLocation: latestLocation } = (0, $1Fr27.useRouter)();
    const navigate = (0, $6UBLf.useNavigate)();
    const pageTitle = (0, $26sX2.usePageTitle)();
    const tabs = (0, $26sX2.useTabs)();
    const showSubMenu = (0, $26sX2.useShowSubMenu)();
    const activeTab = tabs !== null && tabs !== void 0 && tabs.length ? (latestLocation === null || latestLocation === void 0 ? void 0 : (_latestLocation$searc = latestLocation.search) === null || _latestLocation$searc === void 0 ? void 0 : _latestLocation$searc.tab) || ((_tabs$find = tabs.find((t)=>t.url === (latestLocation === null || latestLocation === void 0 ? void 0 : latestLocation.pathname))) === null || _tabs$find === void 0 ? void 0 : _tabs$find.id) || ((_tabs$ = tabs[0]) === null || _tabs$ === void 0 ? void 0 : _tabs$.id) : null;
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "w-full bg-background",
        children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            className: "border-b",
            children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "flex items-center justify-between px-6 mx-auto",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                className: "font-semibold text-lg flex items-center space-x-2 my-4  print:text-[1rem]",
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fTGwv.Button), {
                                        className: "print:hidden text-sm",
                                        variant: "outline",
                                        size: "icon",
                                        onClick: ()=>(0, $26sX2.setShowSubMenu)(!showSubMenu),
                                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ioJ5n.default), {
                                            className: "h-4 w-4"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                        children: pageTitle
                                    })
                                ]
                            }),
                            tabs !== null && tabs !== void 0 && tabs.length ? /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "flex justify-center -mt-2",
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bYl0g.Tabs), {
                                    value: activeTab,
                                    className: "inline-block",
                                    onValueChange: (value)=>{
                                        const tab = tabs.find((tab)=>tab.id === value);
                                        if (tab !== null && tab !== void 0 && tab.url) navigate({
                                            to: tab.url
                                        });
                                        else navigate({
                                            to: latestLocation.pathname,
                                            search: (prev)=>({
                                                    ...prev,
                                                    tab: value
                                                })
                                        });
                                    },
                                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bYl0g.TabsList), {
                                        className: "w-full justify-center",
                                        children: tabs.map((tab)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $bYl0g.TabsTrigger), {
                                                value: tab.id,
                                                children: tab.label
                                            }, tab.id))
                                    })
                                })
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "flex flex-1 justify-end space-x-2 py-4 print:hidden content-stretch items-center",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "mx-2 flex-1 max-w-2xl",
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $9RsUu.SearchBox), {})
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fTGwv.Button), {
                                variant: "outline",
                                className: "flex items-center space-x-2",
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $korfQ.default), {
                                        className: "h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                        children: "Create"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

});
parcelRegister("bYl0g", function(module, exports) {

$parcel$export(module.exports, "Tabs", function () { return $0e03d7164a9a0bb9$export$b2539bed5023c21c; });
$parcel$export(module.exports, "TabsList", function () { return $0e03d7164a9a0bb9$export$9712d22edc0d78c1; });
$parcel$export(module.exports, "TabsTrigger", function () { return $0e03d7164a9a0bb9$export$8114b9fdfdf9f3ba; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $jf78a = parcelRequire("jf78a");

var $Yha9m = parcelRequire("Yha9m");
const $0e03d7164a9a0bb9$export$b2539bed5023c21c = $jf78a.Root;
const $0e03d7164a9a0bb9$var$TabsListVariantContext = /*#__PURE__*/ $jbmdS.createContext("line");
const $0e03d7164a9a0bb9$var$variantStyles = {
    line: "flex items-center justify-start border-b border-gray-200 dark:border-gray-800",
    solid: "inline-flex h-10 items-center justify-center rounded-md bg-muted p-1 text-muted-foreground"
};
const $0e03d7164a9a0bb9$export$9712d22edc0d78c1 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, variant: variant = "line", children: children, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)($jf78a.List, {
        ref: ref,
        className: (0, $Yha9m.cn)($0e03d7164a9a0bb9$var$variantStyles[variant], className),
        ...props,
        children: /*#__PURE__*/ (0, $61Ea1.jsx)($0e03d7164a9a0bb9$var$TabsListVariantContext.Provider, {
            value: variant,
            children: children
        })
    }));
$0e03d7164a9a0bb9$export$9712d22edc0d78c1.displayName = $jf78a.List.displayName;
const $0e03d7164a9a0bb9$var$getVariantStyles = (variant)=>{
    switch(variant){
        case "line":
            return (0, $Yha9m.cn)("inline-flex items-center justify-center whitespace-nowrap px-3 py-1.5 text-sm font-medium", "text-gray-500 dark:text-gray-400", "hover:text-gray-700 hover:dark:text-gray-200", "border-b-2 border-transparent", "data-[state=active]:border-gray-900 data-[state=active]:text-gray-900", "data-[state=active]:dark:border-gray-50 data-[state=active]:dark:text-gray-50", "disabled:pointer-events-none disabled:opacity-50", "print:text-[0.6rem]");
        case "solid":
            return (0, $Yha9m.cn)("inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-background transition-all", "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2", "disabled:pointer-events-none disabled:opacity-50", "data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-sm");
    }
};
const $0e03d7164a9a0bb9$export$8114b9fdfdf9f3ba = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>{
    const variant = $jbmdS.useContext($0e03d7164a9a0bb9$var$TabsListVariantContext);
    return /*#__PURE__*/ (0, $61Ea1.jsx)($jf78a.Trigger, {
        ref: ref,
        className: (0, $Yha9m.cn)($0e03d7164a9a0bb9$var$getVariantStyles(variant), className),
        ...props
    });
});
$0e03d7164a9a0bb9$export$8114b9fdfdf9f3ba.displayName = $jf78a.Trigger.displayName;
const $0e03d7164a9a0bb9$export$bd905d70e8fd2ebb = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)($jf78a.Content, {
        ref: ref,
        className: (0, $Yha9m.cn)("mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2", className),
        ...props
    }));
$0e03d7164a9a0bb9$export$bd905d70e8fd2ebb.displayName = $jf78a.Content.displayName;

});
parcelRegister("jf78a", function(module, exports) {

$parcel$export(module.exports, "Root", function () { return $eaaa8e6ce9d767df$export$be92b6f5f03c0fe9; });
$parcel$export(module.exports, "List", function () { return $eaaa8e6ce9d767df$export$54c2e3dc7acea9f5; });
$parcel$export(module.exports, "Trigger", function () { return $eaaa8e6ce9d767df$export$41fb9f06171c75f4; });
$parcel$export(module.exports, "Content", function () { return $eaaa8e6ce9d767df$export$7c6e2c02157bb7d2; });

var $jbmdS = parcelRequire("jbmdS");

var $hFcKE = parcelRequire("hFcKE");

var $f4RZG = parcelRequire("f4RZG");

var $cmy02 = parcelRequire("cmy02");

var $joHB8 = parcelRequire("joHB8");

var $cihg9 = parcelRequire("cihg9");

var $9czjk = parcelRequire("9czjk");

var $1sq0Q = parcelRequire("1sq0Q");

var $g7F3X = parcelRequire("g7F3X");

var $4TLFw = parcelRequire("4TLFw");
"use client";
var $eaaa8e6ce9d767df$var$TABS_NAME = "Tabs";
var [$eaaa8e6ce9d767df$var$createTabsContext, $eaaa8e6ce9d767df$export$355f5bd209d7b13a] = (0, $f4RZG.createContextScope)($eaaa8e6ce9d767df$var$TABS_NAME, [
    (0, $cmy02.createRovingFocusGroupScope)
]);
var $eaaa8e6ce9d767df$var$useRovingFocusGroupScope = (0, $cmy02.createRovingFocusGroupScope)();
var [$eaaa8e6ce9d767df$var$TabsProvider, $eaaa8e6ce9d767df$var$useTabsContext] = $eaaa8e6ce9d767df$var$createTabsContext($eaaa8e6ce9d767df$var$TABS_NAME);
var $eaaa8e6ce9d767df$export$b2539bed5023c21c = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs, value: valueProp, onValueChange: onValueChange, defaultValue: defaultValue, orientation: orientation = "horizontal", dir: dir, activationMode: activationMode = "automatic", ...tabsProps } = props;
    const direction = (0, $9czjk.useDirection)(dir);
    const [value, setValue] = (0, $1sq0Q.useControllableState)({
        prop: valueProp,
        onChange: onValueChange,
        defaultProp: defaultValue
    });
    return /* @__PURE__ */ (0, $4TLFw.jsx)($eaaa8e6ce9d767df$var$TabsProvider, {
        scope: __scopeTabs,
        baseId: (0, $g7F3X.useId)(),
        value: value,
        onValueChange: setValue,
        orientation: orientation,
        dir: direction,
        activationMode: activationMode,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).div, {
            dir: direction,
            "data-orientation": orientation,
            ...tabsProps,
            ref: forwardedRef
        })
    });
});
$eaaa8e6ce9d767df$export$b2539bed5023c21c.displayName = $eaaa8e6ce9d767df$var$TABS_NAME;
var $eaaa8e6ce9d767df$var$TAB_LIST_NAME = "TabsList";
var $eaaa8e6ce9d767df$export$9712d22edc0d78c1 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs, loop: loop = true, ...listProps } = props;
    const context = $eaaa8e6ce9d767df$var$useTabsContext($eaaa8e6ce9d767df$var$TAB_LIST_NAME, __scopeTabs);
    const rovingFocusGroupScope = $eaaa8e6ce9d767df$var$useRovingFocusGroupScope(__scopeTabs);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($cmy02.Root, {
        asChild: true,
        ...rovingFocusGroupScope,
        orientation: context.orientation,
        dir: context.dir,
        loop: loop,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).div, {
            role: "tablist",
            "aria-orientation": context.orientation,
            ...listProps,
            ref: forwardedRef
        })
    });
});
$eaaa8e6ce9d767df$export$9712d22edc0d78c1.displayName = $eaaa8e6ce9d767df$var$TAB_LIST_NAME;
var $eaaa8e6ce9d767df$var$TRIGGER_NAME = "TabsTrigger";
var $eaaa8e6ce9d767df$export$8114b9fdfdf9f3ba = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs, value: value, disabled: disabled = false, ...triggerProps } = props;
    const context = $eaaa8e6ce9d767df$var$useTabsContext($eaaa8e6ce9d767df$var$TRIGGER_NAME, __scopeTabs);
    const rovingFocusGroupScope = $eaaa8e6ce9d767df$var$useRovingFocusGroupScope(__scopeTabs);
    const triggerId = $eaaa8e6ce9d767df$var$makeTriggerId(context.baseId, value);
    const contentId = $eaaa8e6ce9d767df$var$makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    return /* @__PURE__ */ (0, $4TLFw.jsx)($cmy02.Item, {
        asChild: true,
        ...rovingFocusGroupScope,
        focusable: !disabled,
        active: isSelected,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).button, {
            type: "button",
            role: "tab",
            "aria-selected": isSelected,
            "aria-controls": contentId,
            "data-state": isSelected ? "active" : "inactive",
            "data-disabled": disabled ? "" : void 0,
            disabled: disabled,
            id: triggerId,
            ...triggerProps,
            ref: forwardedRef,
            onMouseDown: (0, $hFcKE.composeEventHandlers)(props.onMouseDown, (event)=>{
                if (!disabled && event.button === 0 && event.ctrlKey === false) context.onValueChange(value);
                else event.preventDefault();
            }),
            onKeyDown: (0, $hFcKE.composeEventHandlers)(props.onKeyDown, (event)=>{
                if ([
                    " ",
                    "Enter"
                ].includes(event.key)) context.onValueChange(value);
            }),
            onFocus: (0, $hFcKE.composeEventHandlers)(props.onFocus, ()=>{
                const isAutomaticActivation = context.activationMode !== "manual";
                if (!isSelected && !disabled && isAutomaticActivation) context.onValueChange(value);
            })
        })
    });
});
$eaaa8e6ce9d767df$export$8114b9fdfdf9f3ba.displayName = $eaaa8e6ce9d767df$var$TRIGGER_NAME;
var $eaaa8e6ce9d767df$var$CONTENT_NAME = "TabsContent";
var $eaaa8e6ce9d767df$export$bd905d70e8fd2ebb = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs, value: value, forceMount: forceMount, children: children, ...contentProps } = props;
    const context = $eaaa8e6ce9d767df$var$useTabsContext($eaaa8e6ce9d767df$var$CONTENT_NAME, __scopeTabs);
    const triggerId = $eaaa8e6ce9d767df$var$makeTriggerId(context.baseId, value);
    const contentId = $eaaa8e6ce9d767df$var$makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    const isMountAnimationPreventedRef = $jbmdS.useRef(isSelected);
    $jbmdS.useEffect(()=>{
        const rAF = requestAnimationFrame(()=>isMountAnimationPreventedRef.current = false);
        return ()=>cancelAnimationFrame(rAF);
    }, []);
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $joHB8.Presence), {
        present: forceMount || isSelected,
        children: ({ present: present })=>/* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).div, {
                "data-state": isSelected ? "active" : "inactive",
                "data-orientation": context.orientation,
                role: "tabpanel",
                "aria-labelledby": triggerId,
                hidden: !present,
                id: contentId,
                tabIndex: 0,
                ...contentProps,
                ref: forwardedRef,
                style: {
                    ...props.style,
                    animationDuration: isMountAnimationPreventedRef.current ? "0s" : void 0
                },
                children: present && children
            })
    });
});
$eaaa8e6ce9d767df$export$bd905d70e8fd2ebb.displayName = $eaaa8e6ce9d767df$var$CONTENT_NAME;
function $eaaa8e6ce9d767df$var$makeTriggerId(baseId, value) {
    return `${baseId}-trigger-${value}`;
}
function $eaaa8e6ce9d767df$var$makeContentId(baseId, value) {
    return `${baseId}-content-${value}`;
}
var $eaaa8e6ce9d767df$export$be92b6f5f03c0fe9 = $eaaa8e6ce9d767df$export$b2539bed5023c21c;
var $eaaa8e6ce9d767df$export$54c2e3dc7acea9f5 = $eaaa8e6ce9d767df$export$9712d22edc0d78c1;
var $eaaa8e6ce9d767df$export$41fb9f06171c75f4 = $eaaa8e6ce9d767df$export$8114b9fdfdf9f3ba;
var $eaaa8e6ce9d767df$export$7c6e2c02157bb7d2 = $eaaa8e6ce9d767df$export$bd905d70e8fd2ebb;

});


parcelRegister("ioJ5n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d64d70fa3170e525$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $d64d70fa3170e525$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("PanelLeft", [
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "3",
            rx: "2",
            key: "afitv7"
        }
    ],
    [
        "path",
        {
            d: "M9 3v18",
            key: "fh3hqa"
        }
    ]
]);

});

parcelRegister("korfQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed8b30b8ebcaeb91$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $ed8b30b8ebcaeb91$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("CirclePlus", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M8 12h8",
            key: "1wcyev"
        }
    ],
    [
        "path",
        {
            d: "M12 8v8",
            key: "napkw2"
        }
    ]
]);

});

parcelRegister("9RsUu", function(module, exports) {

$parcel$export(module.exports, "SearchBox", function () { return $0165327a1134e245$export$5a58787633b0b5d8; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $2YJBX = parcelRequire("2YJBX");

var $hAJIP = parcelRequire("hAJIP");

var $fRrIT = parcelRequire("fRrIT");

var $38AIP = parcelRequire("38AIP");

var $49KvR = parcelRequire("49KvR");

var $i1EVi = parcelRequire("i1EVi");

var $kqlQp = parcelRequire("kqlQp");
const $0165327a1134e245$var$generateSubstrings = (str)=>{
    const substrings = new Set();
    for(let i = 0; i < str.length - 2; i++)for(let j = i + 3; j <= str.length; j++)substrings.add(str.slice(i, j).toLowerCase());
    return Array.from(substrings);
};
const $0165327a1134e245$var$HighlightExactMatch = ({ text: text, searchTerm: searchTerm })=>{
    if (!searchTerm || !searchTerm.trim()) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
        children: text
    });
    const searchSubstrings = (0, $jbmdS.useMemo)(()=>$0165327a1134e245$var$generateSubstrings(searchTerm), [
        searchTerm
    ]);
    // Split the text into words, preserving spaces
    const words = text.split(/(\s+)/).map((part, index)=>({
            part: part,
            index: index
        }));
    // Find matches
    let highlightIndices = [];
    searchSubstrings.forEach((substring)=>{
        let startIndex = 0;
        while(true){
            const matchIndex = text.toLowerCase().indexOf(substring, startIndex);
            if (matchIndex === -1) break;
            highlightIndices.push([
                matchIndex,
                matchIndex + substring.length
            ]);
            startIndex = matchIndex + 1;
        }
    });
    // Merge overlapping highlights
    highlightIndices.sort((a, b)=>a[0] - b[0]);
    const mergedIndices = highlightIndices.reduce((acc, curr)=>{
        if (acc.length === 0 || curr[0] > acc[acc.length - 1][1]) acc.push(curr);
        else acc[acc.length - 1][1] = Math.max(acc[acc.length - 1][1], curr[1]);
        return acc;
    }, []);
    // Apply highlights
    let highlightedPart = [];
    let currentIndex = 0;
    words.forEach(({ part: part, index: index })=>{
        const partStart = text.indexOf(part, currentIndex);
        const partEnd = partStart + part.length;
        let highlightedWord = [];
        let lastIndex = 0;
        mergedIndices.forEach(([start, end])=>{
            if (end <= partStart || start >= partEnd) return;
            const hlStart = Math.max(start, partStart) - partStart;
            const hlEnd = Math.min(end, partEnd) - partStart;
            if (hlStart > lastIndex) highlightedWord.push(part.slice(lastIndex, hlStart));
            highlightedWord.push(/*#__PURE__*/ (0, $61Ea1.jsx)("strong", {
                children: part.slice(hlStart, hlEnd)
            }, `hl-${index}-${hlStart}`));
            lastIndex = hlEnd;
        });
        if (lastIndex < part.length) highlightedWord.push(part.slice(lastIndex));
        highlightedPart.push(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $jbmdS.Fragment), {
            children: highlightedWord.length > 0 ? highlightedWord : part
        }, index));
        currentIndex = partEnd;
    });
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
        children: highlightedPart
    });
};
const $0165327a1134e245$var$getUrl = {
    projects: (item)=>`/projects/${item.id}`,
    contacts: (item)=>`/contacts/${item.id}`,
    invoices: (item)=>`/invoices/${item.id}`,
    organisations: (item)=>`/organisations/${item.id}`,
    suppliers: (item)=>`/suppliers/${item.id}`,
    roles: (item)=>`/staff-roles/${item.id}`,
    costCentres: (item)=>`/cost-centres/${item.id}`,
    organisationReports: (item)=>{
        switch(item.type){
            case "project":
                return `/projects?report=${item.id}`;
            case "staff":
                return `/staff?report=${item.id}`;
            case "invoice":
                return `/invoices?report=${item.id}`;
            case "timesheet":
                return `/timesheets/report?report=${item.id}`;
            case "time":
                return `/timesheets/report?report=${item.id}`;
            case "expense":
                return `/expenses-reports?report=${item.id}`;
        }
    },
    resourceScheduleReports: (item)=>`/resource-schedule?report=${item.id}`,
    revenueForecastReports: (item)=>`/revenue-forecast?report=${item.id}`,
    staff: (item)=>`/staff/${item.id}`
};
const $0165327a1134e245$var$getModelTypeLabel = {
    projects: (_item)=>"Project",
    contacts: (_item)=>"Contact",
    invoices: (_item)=>"Invoice",
    organisations: (_item)=>"Organisation",
    suppliers: (_item)=>"Supplier",
    roles: (_item)=>"Role",
    costCentres: (_item)=>"Cost Centre",
    organisationReports: (item)=>{
        switch(item.type){
            case "project":
                return "Project Report";
            case "staff":
                return "Staff Report";
            case "invoice":
                return "Invoice Report";
            case "timesheet":
                return "Time Report";
            case "time":
                return "Time Report";
            case "expense":
                return "Expense Report";
        }
    },
    resourceScheduleReports: (_item)=>"Resource Schedule",
    revenueForecastReports: (_item)=>"Revenue Forecast",
    staff: (_item)=>"Staff"
};
const $0165327a1134e245$export$5a58787633b0b5d8 = ()=>{
    const [search, setSearch] = (0, $jbmdS.useState)("");
    const [showResults, setShowResults] = (0, $jbmdS.useState)(false);
    const inputRef = (0, $jbmdS.useRef)(null);
    const resultsRef = (0, $jbmdS.useRef)(null);
    const searchableModels = [
        "projects",
        "contacts",
        "invoices",
        "organisations",
        "suppliers",
        "roles",
        "costCentres",
        "organisationReports",
        "resourceScheduleReports",
        "revenueForecastReports",
        "staff"
    ];
    const modelMap = (0, $jbmdS.useMemo)(()=>{
        const map = new Map();
        searchableModels.forEach((model)=>{
            map.set(model, [
                model
            ]);
            map.set(model.slice(0, -1), [
                model
            ]); // Add singular form
        });
        map.set("pr", [
            "projects"
        ]); // Add shorthand for projects
        map.set("proj", [
            "projects"
        ]); // Add shorthand for projects
        map.set("cn", [
            "contacts"
        ]); // Add shorthand for contacts
        map.set("con", [
            "contacts"
        ]); // Add shorthand for contacts
        map.set("inv", [
            "invoices"
        ]); // Add shorthand for invoices
        map.set("org", [
            "organisations"
        ]); // Add shorthand for organisations
        map.set("sup", [
            "suppliers"
        ]); // Add shorthand for suppliers
        map.set("rol", [
            "roles"
        ]); // Add shorthand for roles
        map.set("cc", [
            "costCentres"
        ]); // Add shorthand for cost centres
        map.set("rep", [
            "organisationReports",
            "resourceScheduleReports",
            "revenueForecastReports"
        ]); // Add shorthand for organisation reports
        map.set("report", [
            "organisationReports",
            "resourceScheduleReports",
            "revenueForecastReports"
        ]); // Add shorthand for organisation reports
        map.set("st", [
            "staff"
        ]); // Add shorthand for staff
        return map;
    }, [
        searchableModels
    ]);
    const allItems = (0, $jbmdS.useMemo)(()=>{
        return searchableModels.flatMap((model)=>(0, $38AIP.getFilteredCacheItems)(model).map((item)=>({
                    model: model,
                    item: item,
                    label: (0, $49KvR.getLabel)[model](item)
                })));
    }, [
        searchableModels
    ]);
    const fuse = (0, $jbmdS.useMemo)(()=>new (0, $i1EVi.default)(allItems, {
            keys: [
                "label"
            ],
            threshold: 0.3,
            ignoreLocation: true
        }), [
        allItems
    ]);
    const handleSearch = (0, $jbmdS.useCallback)((value)=>{
        setSearch(value);
        setShowResults(value.length > 0);
    }, []);
    const filteredResults = (0, $jbmdS.useMemo)(()=>{
        if (search.length === 0) return [];
        const [modelFilter, searchTerm] = search.split(":");
        if (modelMap.has(modelFilter) && searchTerm) {
            // Filter by specific model (plural or singular)
            const modelNames = modelMap.get(modelFilter);
            const modelItems = allItems.filter((item)=>modelNames.includes(item.model));
            const modelFuse = new (0, $i1EVi.default)(modelItems, {
                keys: [
                    "label"
                ],
                threshold: 0.3,
                ignoreLocation: true
            });
            return modelFuse.search(searchTerm).slice(0, 10);
        } else // Search across all models
        return fuse.search(search).slice(0, 10);
    }, [
        search,
        fuse,
        allItems,
        modelMap
    ]);
    (0, $jbmdS.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (resultsRef.current && !resultsRef.current.contains(event.target) && inputRef.current && !inputRef.current.contains(event.target)) setShowResults(false);
        };
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hAJIP.default), {
                        className: "z-[1] absolute left-2 top-3 h-4 w-4 text-muted-foreground"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $2YJBX.Input), {
                        ref: inputRef,
                        placeholder: "Search all... (e.g., project:test or projects:test)",
                        className: "pl-8",
                        value: search,
                        onChange: (e)=>handleSearch(e.target.value),
                        onFocus: ()=>setShowResults(true)
                    })
                ]
            }),
            showResults && /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                ref: resultsRef,
                className: "absolute z-10 w-full mt-1 bg-background border rounded-md shadow-lg",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fRrIT.Command), {
                    children: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fRrIT.CommandList), {
                        children: [
                            search && search !== "" ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fRrIT.CommandEmpty), {
                                children: "No results found."
                            }) : null,
                            filteredResults.map(({ item: item })=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqlQp.Link), {
                                    to: $0165327a1134e245$var$getUrl[item.model](item.item),
                                    children: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fRrIT.CommandItem), {
                                        value: item.item.id,
                                        className: "whitespace-pre-wrap cursor-pointer",
                                        children: [
                                            /*#__PURE__*/ (0, $61Ea1.jsx)($0165327a1134e245$var$HighlightExactMatch, {
                                                text: item.label,
                                                searchTerm: search.includes(":") ? search.split(":")[1] : search
                                            }),
                                            /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                                                className: "ml-2 text-xs text-muted-foreground",
                                                children: [
                                                    "(",
                                                    $0165327a1134e245$var$getModelTypeLabel[item.model](item.item),
                                                    ")"
                                                ]
                                            })
                                        ]
                                    }, `${item.model}-${item.item.id}`)
                                }))
                        ]
                    })
                })
            })
        ]
    });
};

});
parcelRegister("fRrIT", function(module, exports) {

$parcel$export(module.exports, "Command", function () { return $6feae8b55405e9f8$export$cc7e12c76513e857; });
$parcel$export(module.exports, "CommandInput", function () { return $6feae8b55405e9f8$export$ebdebb88e46df62a; });
$parcel$export(module.exports, "CommandList", function () { return $6feae8b55405e9f8$export$9cffcb65e9381872; });
$parcel$export(module.exports, "CommandEmpty", function () { return $6feae8b55405e9f8$export$f1753c65029fce09; });
$parcel$export(module.exports, "CommandGroup", function () { return $6feae8b55405e9f8$export$c157b9873a7a0fbd; });
$parcel$export(module.exports, "CommandSeparator", function () { return $6feae8b55405e9f8$export$ace649eed6990b42; });
$parcel$export(module.exports, "CommandItem", function () { return $6feae8b55405e9f8$export$b9b346a733d36f61; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $7MfWg = parcelRequire("7MfWg");

var $hAJIP = parcelRequire("hAJIP");

var $Yha9m = parcelRequire("Yha9m");

var $cKXEy = parcelRequire("cKXEy");
const $6feae8b55405e9f8$export$cc7e12c76513e857 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $7MfWg.Command), {
        ref: ref,
        className: (0, $Yha9m.cn)("flex h-full w-full flex-col overflow-hidden rounded-md bg-popover text-popover-foreground", className),
        ...props
    }));
$6feae8b55405e9f8$export$cc7e12c76513e857.displayName = (0, $7MfWg.Command).displayName;
const $6feae8b55405e9f8$export$98f0540b5c04f3e8 = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $cKXEy.Dialog), {
        ...props,
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $cKXEy.DialogContent), {
            className: "overflow-hidden p-0 shadow-lg",
            children: /*#__PURE__*/ (0, $61Ea1.jsx)($6feae8b55405e9f8$export$cc7e12c76513e857, {
                className: "[&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-group]]:px-2 [&_[cmdk-input-wrapper]_svg]:h-5 [&_[cmdk-input-wrapper]_svg]:w-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:h-5 [&_[cmdk-item]_svg]:w-5",
                children: children
            })
        })
    });
};
const $6feae8b55405e9f8$export$ebdebb88e46df62a = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "flex items-center border-b px-3",
        "cmdk-input-wrapper": "",
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hAJIP.default), {
                className: "mr-2 h-4 w-4 shrink-0 opacity-50"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7MfWg.Command).Input, {
                ref: ref,
                className: (0, $Yha9m.cn)("flex h-11 w-full rounded-md bg-transparent py-3 text-sm outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50", className),
                ...props
            })
        ]
    }));
$6feae8b55405e9f8$export$ebdebb88e46df62a.displayName = (0, $7MfWg.Command).Input.displayName;
const $6feae8b55405e9f8$export$9cffcb65e9381872 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $7MfWg.Command).List, {
        ref: ref,
        className: (0, $Yha9m.cn)("max-h-[300px] overflow-y-auto overflow-x-hidden", className),
        ...props
    }));
$6feae8b55405e9f8$export$9cffcb65e9381872.displayName = (0, $7MfWg.Command).List.displayName;
const $6feae8b55405e9f8$export$f1753c65029fce09 = /*#__PURE__*/ $jbmdS.forwardRef((props, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $7MfWg.Command).Empty, {
        ref: ref,
        className: "py-6 text-center text-sm",
        ...props
    }));
$6feae8b55405e9f8$export$f1753c65029fce09.displayName = (0, $7MfWg.Command).Empty.displayName;
const $6feae8b55405e9f8$export$c157b9873a7a0fbd = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $7MfWg.Command).Group, {
        ref: ref,
        className: (0, $Yha9m.cn)("overflow-hidden p-1 text-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground", className),
        ...props
    }));
$6feae8b55405e9f8$export$c157b9873a7a0fbd.displayName = (0, $7MfWg.Command).Group.displayName;
const $6feae8b55405e9f8$export$ace649eed6990b42 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $7MfWg.Command).Separator, {
        ref: ref,
        className: (0, $Yha9m.cn)("-mx-1 h-px bg-border", className),
        ...props
    }));
$6feae8b55405e9f8$export$ace649eed6990b42.displayName = (0, $7MfWg.Command).Separator.displayName;
const $6feae8b55405e9f8$export$b9b346a733d36f61 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $7MfWg.Command).Item, {
        ref: ref,
        className: (0, $Yha9m.cn)("relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none data-[disabled=true]:pointer-events-none hover:bg-accent data-[selected=true]:text-accent-foreground data-[disabled=true]:opacity-50", className),
        ...props
    }));
$6feae8b55405e9f8$export$b9b346a733d36f61.displayName = (0, $7MfWg.Command).Item.displayName;
const $6feae8b55405e9f8$export$8b2995843ab6cf09 = ({ className: className, ...props })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
        className: (0, $Yha9m.cn)("ml-auto text-xs tracking-widest text-muted-foreground", className),
        ...props
    });
};
$6feae8b55405e9f8$export$8b2995843ab6cf09.displayName = "CommandShortcut";

});
parcelRegister("cKXEy", function(module, exports) {

$parcel$export(module.exports, "Dialog", function () { return $78ec87efbc94be88$export$3ddf2d174ce01153; });
$parcel$export(module.exports, "DialogClose", function () { return $78ec87efbc94be88$export$fba2fb7cd781b7ac; });
$parcel$export(module.exports, "DialogContent", function () { return $78ec87efbc94be88$export$b6d9565de1e068cf; });
$parcel$export(module.exports, "DialogHeader", function () { return $78ec87efbc94be88$export$742513523b177e3b; });
$parcel$export(module.exports, "DialogFooter", function () { return $78ec87efbc94be88$export$7bbfb2d443473050; });
$parcel$export(module.exports, "DialogTitle", function () { return $78ec87efbc94be88$export$16f7638e4a34b909; });
$parcel$export(module.exports, "DialogDescription", function () { return $78ec87efbc94be88$export$94e94c2ec2c954d5; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $fDHGo = parcelRequire("fDHGo");

var $Yha9m = parcelRequire("Yha9m");
const $78ec87efbc94be88$export$3ddf2d174ce01153 = $fDHGo.Root;
const $78ec87efbc94be88$export$2e1e1122cf0cba88 = $fDHGo.Trigger;
const $78ec87efbc94be88$export$dad7c95542bacce0 = $fDHGo.Portal;
const $78ec87efbc94be88$export$fba2fb7cd781b7ac = $fDHGo.Close;
const $78ec87efbc94be88$export$bd1d06c79be19e17 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)($fDHGo.Overlay, {
        ref: ref,
        className: (0, $Yha9m.cn)("fixed inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", className),
        ...props
    }));
$78ec87efbc94be88$export$bd1d06c79be19e17.displayName = $fDHGo.Overlay.displayName;
const $78ec87efbc94be88$export$b6d9565de1e068cf = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, children: children, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsxs)($78ec87efbc94be88$export$dad7c95542bacce0, {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)($78ec87efbc94be88$export$bd1d06c79be19e17, {}),
            /*#__PURE__*/ (0, $61Ea1.jsx)($fDHGo.Content, {
                ref: ref,
                className: (0, $Yha9m.cn)("fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg", className),
                ...props,
                children: children
            })
        ]
    }));
$78ec87efbc94be88$export$b6d9565de1e068cf.displayName = $fDHGo.Content.displayName;
const $78ec87efbc94be88$export$742513523b177e3b = ({ className: className, ...props })=>/*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: (0, $Yha9m.cn)("flex flex-col space-y-1.5 text-center sm:text-left", className),
        ...props
    });
$78ec87efbc94be88$export$742513523b177e3b.displayName = "DialogHeader";
const $78ec87efbc94be88$export$7bbfb2d443473050 = ({ className: className, ...props })=>/*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: (0, $Yha9m.cn)("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", className),
        ...props
    });
$78ec87efbc94be88$export$7bbfb2d443473050.displayName = "DialogFooter";
const $78ec87efbc94be88$export$16f7638e4a34b909 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)($fDHGo.Title, {
        ref: ref,
        className: (0, $Yha9m.cn)("text-lg font-semibold leading-none tracking-tight", className),
        ...props
    }));
$78ec87efbc94be88$export$16f7638e4a34b909.displayName = $fDHGo.Title.displayName;
const $78ec87efbc94be88$export$94e94c2ec2c954d5 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)($fDHGo.Description, {
        ref: ref,
        className: (0, $Yha9m.cn)("text-sm text-muted-foreground", className),
        ...props
    }));
$78ec87efbc94be88$export$94e94c2ec2c954d5.displayName = $fDHGo.Description.displayName;

});


parcelRegister("49KvR", function(module, exports) {

$parcel$export(module.exports, "getLabel", function () { return $764600aa0ab581df$export$236350842f3cd9bc; });
const $764600aa0ab581df$export$236350842f3cd9bc = {
    projects: (project)=>project.jobNumber ? `${project.jobNumber}: ${project.name}` : project.name || "No Name",
    phases: (phase)=>phase.jobNumber ? `${phase.jobNumber}: ${phase.name}` : phase.name || "No Name",
    tasks: (task)=>task.name || "No Name",
    contacts: (contact)=>contact.organisationName && contact.firstName && contact.lastName ? `${contact.firstName} ${contact.lastName} (${contact.organisationName})` : contact.firstName && contact.lastName ? `${contact.firstName} ${contact.lastName}` : contact.organisationName ? contact.organisationName : "No Name",
    invoices: (invoice)=>invoice.ref || "No Name",
    organisations: (organisation)=>organisation.name || "No Name",
    suppliers: (supplier)=>(supplier === null || supplier === void 0 ? void 0 : supplier.name) || "No Name",
    roles: (role)=>role.name || "No Name",
    costCentres: (costCentre)=>costCentre.name || "No Name",
    permission: (permission)=>permission.name || "No Name",
    organisationReports: (report)=>report.name || "No Name",
    resourceScheduleReports: (report)=>report.name || "No Name",
    revenueForecastReports: (report)=>report.name || "No Name",
    staff: (staffMember)=>`${staffMember.firstName} ${staffMember.lastName}` || "No Name",
    organisationSubscriptions: ()=>"No Name"
};

});

parcelRegister("i1EVi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4318bb490f1a22e$export$2e2bcd8739ae039; });
/**
 * Fuse.js v7.0.0 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2023 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function $d4318bb490f1a22e$var$isArray(value) {
    return !Array.isArray ? $d4318bb490f1a22e$var$getTag(value) === "[object Array]" : Array.isArray(value);
}
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
const $d4318bb490f1a22e$var$INFINITY = 1 / 0;
function $d4318bb490f1a22e$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    let result = value + "";
    return result == "0" && 1 / value == -$d4318bb490f1a22e$var$INFINITY ? "-0" : result;
}
function $d4318bb490f1a22e$var$toString(value) {
    return value == null ? "" : $d4318bb490f1a22e$var$baseToString(value);
}
function $d4318bb490f1a22e$var$isString(value) {
    return typeof value === "string";
}
function $d4318bb490f1a22e$var$isNumber(value) {
    return typeof value === "number";
}
// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function $d4318bb490f1a22e$var$isBoolean(value) {
    return value === true || value === false || $d4318bb490f1a22e$var$isObjectLike(value) && $d4318bb490f1a22e$var$getTag(value) == "[object Boolean]";
}
function $d4318bb490f1a22e$var$isObject(value) {
    return typeof value === "object";
}
// Checks if `value` is object-like.
function $d4318bb490f1a22e$var$isObjectLike(value) {
    return $d4318bb490f1a22e$var$isObject(value) && value !== null;
}
function $d4318bb490f1a22e$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $d4318bb490f1a22e$var$isBlank(value) {
    return !value.trim().length;
}
// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function $d4318bb490f1a22e$var$getTag(value) {
    return value == null ? value === undefined ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(value);
}
const $d4318bb490f1a22e$var$EXTENDED_SEARCH_UNAVAILABLE = "Extended search is not available";
const $d4318bb490f1a22e$var$INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
const $d4318bb490f1a22e$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
const $d4318bb490f1a22e$var$PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
const $d4318bb490f1a22e$var$MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
const $d4318bb490f1a22e$var$INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
const $d4318bb490f1a22e$var$hasOwn = Object.prototype.hasOwnProperty;
class $d4318bb490f1a22e$var$KeyStore {
    constructor(keys){
        this._keys = [];
        this._keyMap = {};
        let totalWeight = 0;
        keys.forEach((key)=>{
            let obj = $d4318bb490f1a22e$var$createKey(key);
            this._keys.push(obj);
            this._keyMap[obj.id] = obj;
            totalWeight += obj.weight;
        });
        // Normalize weights so that their sum is equal to 1
        this._keys.forEach((key)=>{
            key.weight /= totalWeight;
        });
    }
    get(keyId) {
        return this._keyMap[keyId];
    }
    keys() {
        return this._keys;
    }
    toJSON() {
        return JSON.stringify(this._keys);
    }
}
function $d4318bb490f1a22e$var$createKey(key) {
    let path = null;
    let id = null;
    let src = null;
    let weight = 1;
    let getFn = null;
    if ($d4318bb490f1a22e$var$isString(key) || $d4318bb490f1a22e$var$isArray(key)) {
        src = key;
        path = $d4318bb490f1a22e$var$createKeyPath(key);
        id = $d4318bb490f1a22e$var$createKeyId(key);
    } else {
        if (!$d4318bb490f1a22e$var$hasOwn.call(key, "name")) throw new Error($d4318bb490f1a22e$var$MISSING_KEY_PROPERTY("name"));
        const name = key.name;
        src = name;
        if ($d4318bb490f1a22e$var$hasOwn.call(key, "weight")) {
            weight = key.weight;
            if (weight <= 0) throw new Error($d4318bb490f1a22e$var$INVALID_KEY_WEIGHT_VALUE(name));
        }
        path = $d4318bb490f1a22e$var$createKeyPath(name);
        id = $d4318bb490f1a22e$var$createKeyId(name);
        getFn = key.getFn;
    }
    return {
        path: path,
        id: id,
        weight: weight,
        src: src,
        getFn: getFn
    };
}
function $d4318bb490f1a22e$var$createKeyPath(key) {
    return $d4318bb490f1a22e$var$isArray(key) ? key : key.split(".");
}
function $d4318bb490f1a22e$var$createKeyId(key) {
    return $d4318bb490f1a22e$var$isArray(key) ? key.join(".") : key;
}
function $d4318bb490f1a22e$var$get(obj, path) {
    let list = [];
    let arr = false;
    const deepGet = (obj, path, index)=>{
        if (!$d4318bb490f1a22e$var$isDefined(obj)) return;
        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
        list.push(obj);
        else {
            let key = path[index];
            const value = obj[key];
            if (!$d4318bb490f1a22e$var$isDefined(value)) return;
            // If we're at the last value in the path, and if it's a string/number/bool,
            // add it to the list
            if (index === path.length - 1 && ($d4318bb490f1a22e$var$isString(value) || $d4318bb490f1a22e$var$isNumber(value) || $d4318bb490f1a22e$var$isBoolean(value))) list.push($d4318bb490f1a22e$var$toString(value));
            else if ($d4318bb490f1a22e$var$isArray(value)) {
                arr = true;
                // Search each item in the array.
                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
            } else if (path.length) // An object. Recurse further.
            deepGet(value, path, index + 1);
        }
    };
    // Backwards compatibility (since path used to be a string)
    deepGet(obj, $d4318bb490f1a22e$var$isString(path) ? path.split(".") : path, 0);
    return arr ? list : list[0];
}
const $d4318bb490f1a22e$var$MatchOptions = {
    // Whether the matches should be included in the result set. When `true`, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: false,
    // When `true`, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: false,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
};
const $d4318bb490f1a22e$var$BasicOptions = {
    // When `true`, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: false,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: false,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: true,
    // Default sort function: sort by ascending score, ascending index
    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
};
const $d4318bb490f1a22e$var$FuzzyOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
};
const $d4318bb490f1a22e$var$AdvancedOptions = {
    // When `true`, it enables the use of unix-like search commands
    useExtendedSearch: false,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: $d4318bb490f1a22e$var$get,
    // When `true`, search will ignore `location` and `distance`, so it won't matter
    // where in the string the pattern appears.
    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
    ignoreLocation: false,
    // When `true`, the calculation for the relevance score (used for sorting) will
    // ignore the field-length norm.
    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
    ignoreFieldNorm: false,
    // The weight to determine how much field length norm effects scoring.
    fieldNormWeight: 1
};
var $d4318bb490f1a22e$var$Config = {
    ...$d4318bb490f1a22e$var$BasicOptions,
    ...$d4318bb490f1a22e$var$MatchOptions,
    ...$d4318bb490f1a22e$var$FuzzyOptions,
    ...$d4318bb490f1a22e$var$AdvancedOptions
};
const $d4318bb490f1a22e$var$SPACE = /[^ ]+/g;
// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function $d4318bb490f1a22e$var$norm(weight = 1, mantissa = 3) {
    const cache = new Map();
    const m = Math.pow(10, mantissa);
    return {
        get (value) {
            const numTokens = value.match($d4318bb490f1a22e$var$SPACE).length;
            if (cache.has(numTokens)) return cache.get(numTokens);
            // Default function is 1/sqrt(x), weight makes that variable
            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
            // In place of `toFixed(mantissa)`, for faster computation
            const n = parseFloat(Math.round(norm * m) / m);
            cache.set(numTokens, n);
            return n;
        },
        clear () {
            cache.clear();
        }
    };
}
class $d4318bb490f1a22e$var$FuseIndex {
    constructor({ getFn: getFn = $d4318bb490f1a22e$var$Config.getFn, fieldNormWeight: fieldNormWeight = $d4318bb490f1a22e$var$Config.fieldNormWeight } = {}){
        this.norm = $d4318bb490f1a22e$var$norm(fieldNormWeight, 3);
        this.getFn = getFn;
        this.isCreated = false;
        this.setIndexRecords();
    }
    setSources(docs = []) {
        this.docs = docs;
    }
    setIndexRecords(records = []) {
        this.records = records;
    }
    setKeys(keys = []) {
        this.keys = keys;
        this._keysMap = {};
        keys.forEach((key, idx)=>{
            this._keysMap[key.id] = idx;
        });
    }
    create() {
        if (this.isCreated || !this.docs.length) return;
        this.isCreated = true;
        // List is Array<String>
        if ($d4318bb490f1a22e$var$isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
            this._addString(doc, docIndex);
        });
        else // List is Array<Object>
        this.docs.forEach((doc, docIndex)=>{
            this._addObject(doc, docIndex);
        });
        this.norm.clear();
    }
    // Adds a doc to the end of the index
    add(doc) {
        const idx = this.size();
        if ($d4318bb490f1a22e$var$isString(doc)) this._addString(doc, idx);
        else this._addObject(doc, idx);
    }
    // Removes the doc at the specified index of the index
    removeAt(idx) {
        this.records.splice(idx, 1);
        // Change ref index of every subsquent doc
        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
    }
    getValueForItemAtKeyId(item, keyId) {
        return item[this._keysMap[keyId]];
    }
    size() {
        return this.records.length;
    }
    _addString(doc, docIndex) {
        if (!$d4318bb490f1a22e$var$isDefined(doc) || $d4318bb490f1a22e$var$isBlank(doc)) return;
        let record = {
            v: doc,
            i: docIndex,
            n: this.norm.get(doc)
        };
        this.records.push(record);
    }
    _addObject(doc, docIndex) {
        let record = {
            i: docIndex,
            $: {}
        };
        // Iterate over every key (i.e, path), and fetch the value at that key
        this.keys.forEach((key, keyIndex)=>{
            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
            if (!$d4318bb490f1a22e$var$isDefined(value)) return;
            if ($d4318bb490f1a22e$var$isArray(value)) {
                let subRecords = [];
                const stack = [
                    {
                        nestedArrIndex: -1,
                        value: value
                    }
                ];
                while(stack.length){
                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                    if (!$d4318bb490f1a22e$var$isDefined(value)) continue;
                    if ($d4318bb490f1a22e$var$isString(value) && !$d4318bb490f1a22e$var$isBlank(value)) {
                        let subRecord = {
                            v: value,
                            i: nestedArrIndex,
                            n: this.norm.get(value)
                        };
                        subRecords.push(subRecord);
                    } else if ($d4318bb490f1a22e$var$isArray(value)) value.forEach((item, k)=>{
                        stack.push({
                            nestedArrIndex: k,
                            value: item
                        });
                    });
                }
                record.$[keyIndex] = subRecords;
            } else if ($d4318bb490f1a22e$var$isString(value) && !$d4318bb490f1a22e$var$isBlank(value)) {
                let subRecord = {
                    v: value,
                    n: this.norm.get(value)
                };
                record.$[keyIndex] = subRecord;
            }
        });
        this.records.push(record);
    }
    toJSON() {
        return {
            keys: this.keys,
            records: this.records
        };
    }
}
function $d4318bb490f1a22e$var$createIndex(keys, docs, { getFn: getFn = $d4318bb490f1a22e$var$Config.getFn, fieldNormWeight: fieldNormWeight = $d4318bb490f1a22e$var$Config.fieldNormWeight } = {}) {
    const myIndex = new $d4318bb490f1a22e$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys.map($d4318bb490f1a22e$var$createKey));
    myIndex.setSources(docs);
    myIndex.create();
    return myIndex;
}
function $d4318bb490f1a22e$var$parseIndex(data, { getFn: getFn = $d4318bb490f1a22e$var$Config.getFn, fieldNormWeight: fieldNormWeight = $d4318bb490f1a22e$var$Config.fieldNormWeight } = {}) {
    const { keys: keys, records: records } = data;
    const myIndex = new $d4318bb490f1a22e$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys);
    myIndex.setIndexRecords(records);
    return myIndex;
}
function $d4318bb490f1a22e$var$computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = $d4318bb490f1a22e$var$Config.distance, ignoreLocation: ignoreLocation = $d4318bb490f1a22e$var$Config.ignoreLocation } = {}) {
    const accuracy = errors / pattern.length;
    if (ignoreLocation) return accuracy;
    const proximity = Math.abs(expectedLocation - currentLocation);
    if (!distance) // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
    return accuracy + proximity / distance;
}
function $d4318bb490f1a22e$var$convertMaskToIndices(matchmask = [], minMatchCharLength = $d4318bb490f1a22e$var$Config.minMatchCharLength) {
    let indices = [];
    let start = -1;
    let end = -1;
    let i = 0;
    for(let len = matchmask.length; i < len; i += 1){
        let match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) indices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    // (i-1 - start) + 1 => i - start
    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
        start,
        i - 1
    ]);
    return indices;
}
// Machine word size
const $d4318bb490f1a22e$var$MAX_BITS = 32;
function $d4318bb490f1a22e$var$search(text, pattern, patternAlphabet, { location: location = $d4318bb490f1a22e$var$Config.location, distance: distance = $d4318bb490f1a22e$var$Config.distance, threshold: threshold = $d4318bb490f1a22e$var$Config.threshold, findAllMatches: findAllMatches = $d4318bb490f1a22e$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $d4318bb490f1a22e$var$Config.minMatchCharLength, includeMatches: includeMatches = $d4318bb490f1a22e$var$Config.includeMatches, ignoreLocation: ignoreLocation = $d4318bb490f1a22e$var$Config.ignoreLocation } = {}) {
    if (pattern.length > $d4318bb490f1a22e$var$MAX_BITS) throw new Error($d4318bb490f1a22e$var$PATTERN_LENGTH_TOO_LARGE($d4318bb490f1a22e$var$MAX_BITS));
    const patternLen = pattern.length;
    // Set starting location at beginning text and initialize the alphabet.
    const textLen = text.length;
    // Handle the case when location > text.length
    const expectedLocation = Math.max(0, Math.min(location, textLen));
    // Highest score beyond which we give up.
    let currentThreshold = threshold;
    // Is there a nearby exact match? (speedup)
    let bestLocation = expectedLocation;
    // Performance: only computer matches when the minMatchCharLength > 1
    // OR if `includeMatches` is true.
    const computeMatches = minMatchCharLength > 1 || includeMatches;
    // A mask of the matches, used for building the indices
    const matchMask = computeMatches ? Array(textLen) : [];
    let index;
    // Get all exact matches, here for speed up
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        let score = $d4318bb490f1a22e$var$computeScore$1(pattern, {
            currentLocation: index,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (computeMatches) {
            let i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    // Reset the best location
    bestLocation = -1;
    let lastBitArr = [];
    let finalScore = 1;
    let binMax = patternLen + textLen;
    const mask = 1 << patternLen - 1;
    for(let i = 0; i < patternLen; i += 1){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from the match location we can stray
        // at this error level.
        let binMin = 0;
        let binMid = binMax;
        while(binMin < binMid){
            const score = $d4318bb490f1a22e$var$computeScore$1(pattern, {
                errors: i,
                currentLocation: expectedLocation + binMid,
                expectedLocation: expectedLocation,
                distance: distance,
                ignoreLocation: ignoreLocation
            });
            if (score <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        // Use the result from this iteration as the maximum for the next.
        binMax = binMid;
        let start = Math.max(1, expectedLocation - binMid + 1);
        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        // Initialize the bit array
        let bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i) - 1;
        for(let j = finish; j >= start; j -= 1){
            let currentLocation = j - 1;
            let charMatch = patternAlphabet[text.charAt(currentLocation)];
            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
            matchMask[currentLocation] = +!!charMatch;
            // First pass: exact match
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            // Subsequent passes: fuzzy match
            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = $d4318bb490f1a22e$var$computeScore$1(pattern, {
                    errors: i,
                    currentLocation: currentLocation,
                    expectedLocation: expectedLocation,
                    distance: distance,
                    ignoreLocation: ignoreLocation
                });
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (finalScore <= currentThreshold) {
                    // Indeed it is
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    // Already passed `loc`, downhill from here on in.
                    if (bestLocation <= expectedLocation) break;
                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        const score = $d4318bb490f1a22e$var$computeScore$1(pattern, {
            errors: i + 1,
            currentLocation: expectedLocation,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        if (score > currentThreshold) break;
        lastBitArr = bitArr;
    }
    const result = {
        isMatch: bestLocation >= 0,
        // Count exact matches (those with a score of 0) to be "almost" exact
        score: Math.max(0.001, finalScore)
    };
    if (computeMatches) {
        const indices = $d4318bb490f1a22e$var$convertMaskToIndices(matchMask, minMatchCharLength);
        if (!indices.length) result.isMatch = false;
        else if (includeMatches) result.indices = indices;
    }
    return result;
}
function $d4318bb490f1a22e$var$createPatternAlphabet(pattern) {
    let mask = {};
    for(let i = 0, len = pattern.length; i < len; i += 1){
        const char = pattern.charAt(i);
        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
    }
    return mask;
}
class $d4318bb490f1a22e$var$BitapSearch {
    constructor(pattern, { location: location = $d4318bb490f1a22e$var$Config.location, threshold: threshold = $d4318bb490f1a22e$var$Config.threshold, distance: distance = $d4318bb490f1a22e$var$Config.distance, includeMatches: includeMatches = $d4318bb490f1a22e$var$Config.includeMatches, findAllMatches: findAllMatches = $d4318bb490f1a22e$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $d4318bb490f1a22e$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $d4318bb490f1a22e$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $d4318bb490f1a22e$var$Config.ignoreLocation } = {}){
        this.options = {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.chunks = [];
        if (!this.pattern.length) return;
        const addChunk = (pattern, startIndex)=>{
            this.chunks.push({
                pattern: pattern,
                alphabet: $d4318bb490f1a22e$var$createPatternAlphabet(pattern),
                startIndex: startIndex
            });
        };
        const len = this.pattern.length;
        if (len > $d4318bb490f1a22e$var$MAX_BITS) {
            let i = 0;
            const remainder = len % $d4318bb490f1a22e$var$MAX_BITS;
            const end = len - remainder;
            while(i < end){
                addChunk(this.pattern.substr(i, $d4318bb490f1a22e$var$MAX_BITS), i);
                i += $d4318bb490f1a22e$var$MAX_BITS;
            }
            if (remainder) {
                const startIndex = len - $d4318bb490f1a22e$var$MAX_BITS;
                addChunk(this.pattern.substr(startIndex), startIndex);
            }
        } else addChunk(this.pattern, 0);
    }
    searchIn(text) {
        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
        if (!isCaseSensitive) text = text.toLowerCase();
        // Exact match
        if (this.pattern === text) {
            let result = {
                isMatch: true,
                score: 0
            };
            if (includeMatches) result.indices = [
                [
                    0,
                    text.length - 1
                ]
            ];
            return result;
        }
        // Otherwise, use Bitap algorithm
        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
        let allIndices = [];
        let totalScore = 0;
        let hasMatches = false;
        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
            const { isMatch: isMatch, score: score, indices: indices } = $d4318bb490f1a22e$var$search(text, pattern, alphabet, {
                location: location + startIndex,
                distance: distance,
                threshold: threshold,
                findAllMatches: findAllMatches,
                minMatchCharLength: minMatchCharLength,
                includeMatches: includeMatches,
                ignoreLocation: ignoreLocation
            });
            if (isMatch) hasMatches = true;
            totalScore += score;
            if (isMatch && indices) allIndices = [
                ...allIndices,
                ...indices
            ];
        });
        let result = {
            isMatch: hasMatches,
            score: hasMatches ? totalScore / this.chunks.length : 1
        };
        if (hasMatches && includeMatches) result.indices = allIndices;
        return result;
    }
}
class $d4318bb490f1a22e$var$BaseMatch {
    constructor(pattern){
        this.pattern = pattern;
    }
    static isMultiMatch(pattern) {
        return $d4318bb490f1a22e$var$getMatch(pattern, this.multiRegex);
    }
    static isSingleMatch(pattern) {
        return $d4318bb490f1a22e$var$getMatch(pattern, this.singleRegex);
    }
    search() {}
}
function $d4318bb490f1a22e$var$getMatch(pattern, exp) {
    const matches = pattern.match(exp);
    return matches ? matches[1] : null;
}
// Token: 'file
class $d4318bb490f1a22e$var$ExactMatch extends $d4318bb490f1a22e$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "exact";
    }
    static get multiRegex() {
        return /^="(.*)"$/;
    }
    static get singleRegex() {
        return /^=(.*)$/;
    }
    search(text) {
        const isMatch = text === this.pattern;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !fire
class $d4318bb490f1a22e$var$InverseExactMatch extends $d4318bb490f1a22e$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "inverse-exact";
    }
    static get multiRegex() {
        return /^!"(.*)"$/;
    }
    static get singleRegex() {
        return /^!(.*)$/;
    }
    search(text) {
        const index = text.indexOf(this.pattern);
        const isMatch = index === -1;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: ^file
class $d4318bb490f1a22e$var$PrefixExactMatch extends $d4318bb490f1a22e$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "prefix-exact";
    }
    static get multiRegex() {
        return /^\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^\^(.*)$/;
    }
    search(text) {
        const isMatch = text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !^fire
class $d4318bb490f1a22e$var$InversePrefixExactMatch extends $d4318bb490f1a22e$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "inverse-prefix-exact";
    }
    static get multiRegex() {
        return /^!\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^!\^(.*)$/;
    }
    search(text) {
        const isMatch = !text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: .file$
class $d4318bb490f1a22e$var$SuffixExactMatch extends $d4318bb490f1a22e$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "suffix-exact";
    }
    static get multiRegex() {
        return /^"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^(.*)\$$/;
    }
    search(text) {
        const isMatch = text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                text.length - this.pattern.length,
                text.length - 1
            ]
        };
    }
}
// Token: !.file$
class $d4318bb490f1a22e$var$InverseSuffixExactMatch extends $d4318bb490f1a22e$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "inverse-suffix-exact";
    }
    static get multiRegex() {
        return /^!"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^!(.*)\$$/;
    }
    search(text) {
        const isMatch = !text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
class $d4318bb490f1a22e$var$FuzzyMatch extends $d4318bb490f1a22e$var$BaseMatch {
    constructor(pattern, { location: location = $d4318bb490f1a22e$var$Config.location, threshold: threshold = $d4318bb490f1a22e$var$Config.threshold, distance: distance = $d4318bb490f1a22e$var$Config.distance, includeMatches: includeMatches = $d4318bb490f1a22e$var$Config.includeMatches, findAllMatches: findAllMatches = $d4318bb490f1a22e$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $d4318bb490f1a22e$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $d4318bb490f1a22e$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $d4318bb490f1a22e$var$Config.ignoreLocation } = {}){
        super(pattern);
        this._bitapSearch = new $d4318bb490f1a22e$var$BitapSearch(pattern, {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        });
    }
    static get type() {
        return "fuzzy";
    }
    static get multiRegex() {
        return /^"(.*)"$/;
    }
    static get singleRegex() {
        return /^(.*)$/;
    }
    search(text) {
        return this._bitapSearch.searchIn(text);
    }
}
// Token: 'file
class $d4318bb490f1a22e$var$IncludeMatch extends $d4318bb490f1a22e$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "include";
    }
    static get multiRegex() {
        return /^'"(.*)"$/;
    }
    static get singleRegex() {
        return /^'(.*)$/;
    }
    search(text) {
        let location = 0;
        let index;
        const indices = [];
        const patternLen = this.pattern.length;
        // Get all exact matches
        while((index = text.indexOf(this.pattern, location)) > -1){
            location = index + patternLen;
            indices.push([
                index,
                location - 1
            ]);
        }
        const isMatch = !!indices.length;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: indices
        };
    }
}
// ❗Order is important. DO NOT CHANGE.
const $d4318bb490f1a22e$var$searchers = [
    $d4318bb490f1a22e$var$ExactMatch,
    $d4318bb490f1a22e$var$IncludeMatch,
    $d4318bb490f1a22e$var$PrefixExactMatch,
    $d4318bb490f1a22e$var$InversePrefixExactMatch,
    $d4318bb490f1a22e$var$InverseSuffixExactMatch,
    $d4318bb490f1a22e$var$SuffixExactMatch,
    $d4318bb490f1a22e$var$InverseExactMatch,
    $d4318bb490f1a22e$var$FuzzyMatch
];
const $d4318bb490f1a22e$var$searchersLen = $d4318bb490f1a22e$var$searchers.length;
// Regex to split by spaces, but keep anything in quotes together
const $d4318bb490f1a22e$var$SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const $d4318bb490f1a22e$var$OR_TOKEN = "|";
// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function $d4318bb490f1a22e$var$parseQuery(pattern, options = {}) {
    return pattern.split($d4318bb490f1a22e$var$OR_TOKEN).map((item)=>{
        let query = item.trim().split($d4318bb490f1a22e$var$SPACE_RE).filter((item)=>item && !!item.trim());
        let results = [];
        for(let i = 0, len = query.length; i < len; i += 1){
            const queryItem = query[i];
            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
            let found = false;
            let idx = -1;
            while(!found && ++idx < $d4318bb490f1a22e$var$searchersLen){
                const searcher = $d4318bb490f1a22e$var$searchers[idx];
                let token = searcher.isMultiMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    found = true;
                }
            }
            if (found) continue;
            // 2. Handle single query matches (i.e, once that are *not* quoted)
            idx = -1;
            while(++idx < $d4318bb490f1a22e$var$searchersLen){
                const searcher = $d4318bb490f1a22e$var$searchers[idx];
                let token = searcher.isSingleMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    break;
                }
            }
        }
        return results;
    });
}
// These extended matchers can return an array of matches, as opposed
// to a singl match
const $d4318bb490f1a22e$var$MultiMatchSet = new Set([
    $d4318bb490f1a22e$var$FuzzyMatch.type,
    $d4318bb490f1a22e$var$IncludeMatch.type
]);
/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class $d4318bb490f1a22e$var$ExtendedSearch {
    constructor(pattern, { isCaseSensitive: isCaseSensitive = $d4318bb490f1a22e$var$Config.isCaseSensitive, includeMatches: includeMatches = $d4318bb490f1a22e$var$Config.includeMatches, minMatchCharLength: minMatchCharLength = $d4318bb490f1a22e$var$Config.minMatchCharLength, ignoreLocation: ignoreLocation = $d4318bb490f1a22e$var$Config.ignoreLocation, findAllMatches: findAllMatches = $d4318bb490f1a22e$var$Config.findAllMatches, location: location = $d4318bb490f1a22e$var$Config.location, threshold: threshold = $d4318bb490f1a22e$var$Config.threshold, distance: distance = $d4318bb490f1a22e$var$Config.distance } = {}){
        this.query = null;
        this.options = {
            isCaseSensitive: isCaseSensitive,
            includeMatches: includeMatches,
            minMatchCharLength: minMatchCharLength,
            findAllMatches: findAllMatches,
            ignoreLocation: ignoreLocation,
            location: location,
            threshold: threshold,
            distance: distance
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.query = $d4318bb490f1a22e$var$parseQuery(this.pattern, this.options);
    }
    static condition(_, options) {
        return options.useExtendedSearch;
    }
    searchIn(text) {
        const query = this.query;
        if (!query) return {
            isMatch: false,
            score: 1
        };
        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
        text = isCaseSensitive ? text : text.toLowerCase();
        let numMatches = 0;
        let allIndices = [];
        let totalScore = 0;
        // ORs
        for(let i = 0, qLen = query.length; i < qLen; i += 1){
            const searchers = query[i];
            // Reset indices
            allIndices.length = 0;
            numMatches = 0;
            // ANDs
            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                const searcher = searchers[j];
                const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                if (isMatch) {
                    numMatches += 1;
                    totalScore += score;
                    if (includeMatches) {
                        const type = searcher.constructor.type;
                        if ($d4318bb490f1a22e$var$MultiMatchSet.has(type)) allIndices = [
                            ...allIndices,
                            ...indices
                        ];
                        else allIndices.push(indices);
                    }
                } else {
                    totalScore = 0;
                    numMatches = 0;
                    allIndices.length = 0;
                    break;
                }
            }
            // OR condition, so if TRUE, return
            if (numMatches) {
                let result = {
                    isMatch: true,
                    score: totalScore / numMatches
                };
                if (includeMatches) result.indices = allIndices;
                return result;
            }
        }
        // Nothing was matched
        return {
            isMatch: false,
            score: 1
        };
    }
}
const $d4318bb490f1a22e$var$registeredSearchers = [];
function $d4318bb490f1a22e$var$register(...args) {
    $d4318bb490f1a22e$var$registeredSearchers.push(...args);
}
function $d4318bb490f1a22e$var$createSearcher(pattern, options) {
    for(let i = 0, len = $d4318bb490f1a22e$var$registeredSearchers.length; i < len; i += 1){
        let searcherClass = $d4318bb490f1a22e$var$registeredSearchers[i];
        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
    }
    return new $d4318bb490f1a22e$var$BitapSearch(pattern, options);
}
const $d4318bb490f1a22e$var$LogicalOperator = {
    AND: "$and",
    OR: "$or"
};
const $d4318bb490f1a22e$var$KeyType = {
    PATH: "$path",
    PATTERN: "$val"
};
const $d4318bb490f1a22e$var$isExpression = (query)=>!!(query[$d4318bb490f1a22e$var$LogicalOperator.AND] || query[$d4318bb490f1a22e$var$LogicalOperator.OR]);
const $d4318bb490f1a22e$var$isPath = (query)=>!!query[$d4318bb490f1a22e$var$KeyType.PATH];
const $d4318bb490f1a22e$var$isLeaf = (query)=>!$d4318bb490f1a22e$var$isArray(query) && $d4318bb490f1a22e$var$isObject(query) && !$d4318bb490f1a22e$var$isExpression(query);
const $d4318bb490f1a22e$var$convertToExplicit = (query)=>({
        [$d4318bb490f1a22e$var$LogicalOperator.AND]: Object.keys(query).map((key)=>({
                [key]: query[key]
            }))
    });
// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function $d4318bb490f1a22e$var$parse(query, options, { auto: auto = true } = {}) {
    const next = (query)=>{
        let keys = Object.keys(query);
        const isQueryPath = $d4318bb490f1a22e$var$isPath(query);
        if (!isQueryPath && keys.length > 1 && !$d4318bb490f1a22e$var$isExpression(query)) return next($d4318bb490f1a22e$var$convertToExplicit(query));
        if ($d4318bb490f1a22e$var$isLeaf(query)) {
            const key = isQueryPath ? query[$d4318bb490f1a22e$var$KeyType.PATH] : keys[0];
            const pattern = isQueryPath ? query[$d4318bb490f1a22e$var$KeyType.PATTERN] : query[key];
            if (!$d4318bb490f1a22e$var$isString(pattern)) throw new Error($d4318bb490f1a22e$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
            const obj = {
                keyId: $d4318bb490f1a22e$var$createKeyId(key),
                pattern: pattern
            };
            if (auto) obj.searcher = $d4318bb490f1a22e$var$createSearcher(pattern, options);
            return obj;
        }
        let node = {
            children: [],
            operator: keys[0]
        };
        keys.forEach((key)=>{
            const value = query[key];
            if ($d4318bb490f1a22e$var$isArray(value)) value.forEach((item)=>{
                node.children.push(next(item));
            });
        });
        return node;
    };
    if (!$d4318bb490f1a22e$var$isExpression(query)) query = $d4318bb490f1a22e$var$convertToExplicit(query);
    return next(query);
}
// Practical scoring function
function $d4318bb490f1a22e$var$computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = $d4318bb490f1a22e$var$Config.ignoreFieldNorm }) {
    results.forEach((result)=>{
        let totalScore = 1;
        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
            const weight = key ? key.weight : null;
            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
        });
        result.score = totalScore;
    });
}
function $d4318bb490f1a22e$var$transformMatches(result, data) {
    const matches = result.matches;
    data.matches = [];
    if (!$d4318bb490f1a22e$var$isDefined(matches)) return;
    matches.forEach((match)=>{
        if (!$d4318bb490f1a22e$var$isDefined(match.indices) || !match.indices.length) return;
        const { indices: indices, value: value } = match;
        let obj = {
            indices: indices,
            value: value
        };
        if (match.key) obj.key = match.key.src;
        if (match.idx > -1) obj.refIndex = match.idx;
        data.matches.push(obj);
    });
}
function $d4318bb490f1a22e$var$transformScore(result, data) {
    data.score = result.score;
}
function $d4318bb490f1a22e$var$format(results, docs, { includeMatches: includeMatches = $d4318bb490f1a22e$var$Config.includeMatches, includeScore: includeScore = $d4318bb490f1a22e$var$Config.includeScore } = {}) {
    const transformers = [];
    if (includeMatches) transformers.push($d4318bb490f1a22e$var$transformMatches);
    if (includeScore) transformers.push($d4318bb490f1a22e$var$transformScore);
    return results.map((result)=>{
        const { idx: idx } = result;
        const data = {
            item: docs[idx],
            refIndex: idx
        };
        if (transformers.length) transformers.forEach((transformer)=>{
            transformer(result, data);
        });
        return data;
    });
}
class $d4318bb490f1a22e$export$2e2bcd8739ae039 {
    constructor(docs, options = {}, index){
        this.options = {
            ...$d4318bb490f1a22e$var$Config,
            ...options
        };
        this.options.useExtendedSearch;
        this._keyStore = new $d4318bb490f1a22e$var$KeyStore(this.options.keys);
        this.setCollection(docs, index);
    }
    setCollection(docs, index) {
        this._docs = docs;
        if (index && !(index instanceof $d4318bb490f1a22e$var$FuseIndex)) throw new Error($d4318bb490f1a22e$var$INCORRECT_INDEX_TYPE);
        this._myIndex = index || $d4318bb490f1a22e$var$createIndex(this.options.keys, this._docs, {
            getFn: this.options.getFn,
            fieldNormWeight: this.options.fieldNormWeight
        });
    }
    add(doc) {
        if (!$d4318bb490f1a22e$var$isDefined(doc)) return;
        this._docs.push(doc);
        this._myIndex.add(doc);
    }
    remove(predicate = ()=>false) {
        const results = [];
        for(let i = 0, len = this._docs.length; i < len; i += 1){
            const doc = this._docs[i];
            if (predicate(doc, i)) {
                this.removeAt(i);
                i -= 1;
                len -= 1;
                results.push(doc);
            }
        }
        return results;
    }
    removeAt(idx) {
        this._docs.splice(idx, 1);
        this._myIndex.removeAt(idx);
    }
    getIndex() {
        return this._myIndex;
    }
    search(query, { limit: limit = -1 } = {}) {
        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
        let results = $d4318bb490f1a22e$var$isString(query) ? $d4318bb490f1a22e$var$isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
        $d4318bb490f1a22e$var$computeScore(results, {
            ignoreFieldNorm: ignoreFieldNorm
        });
        if (shouldSort) results.sort(sortFn);
        if ($d4318bb490f1a22e$var$isNumber(limit) && limit > -1) results = results.slice(0, limit);
        return $d4318bb490f1a22e$var$format(results, this._docs, {
            includeMatches: includeMatches,
            includeScore: includeScore
        });
    }
    _searchStringList(query) {
        const searcher = $d4318bb490f1a22e$var$createSearcher(query, this.options);
        const { records: records } = this._myIndex;
        const results = [];
        // Iterate over every string in the index
        records.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$d4318bb490f1a22e$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) results.push({
                item: text,
                idx: idx,
                matches: [
                    {
                        score: score,
                        value: text,
                        norm: norm,
                        indices: indices
                    }
                ]
            });
        });
        return results;
    }
    _searchLogical(query) {
        const expression = $d4318bb490f1a22e$var$parse(query, this.options);
        const evaluate = (node, item, idx)=>{
            if (!node.children) {
                const { keyId: keyId, searcher: searcher } = node;
                const matches = this._findMatches({
                    key: this._keyStore.get(keyId),
                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                    searcher: searcher
                });
                if (matches && matches.length) return [
                    {
                        idx: idx,
                        item: item,
                        matches: matches
                    }
                ];
                return [];
            }
            const res = [];
            for(let i = 0, len = node.children.length; i < len; i += 1){
                const child = node.children[i];
                const result = evaluate(child, item, idx);
                if (result.length) res.push(...result);
                else if (node.operator === $d4318bb490f1a22e$var$LogicalOperator.AND) return [];
            }
            return res;
        };
        const records = this._myIndex.records;
        const resultMap = {};
        const results = [];
        records.forEach(({ $: item, i: idx })=>{
            if ($d4318bb490f1a22e$var$isDefined(item)) {
                let expResults = evaluate(expression, item, idx);
                if (expResults.length) {
                    // Dedupe when adding
                    if (!resultMap[idx]) {
                        resultMap[idx] = {
                            idx: idx,
                            item: item,
                            matches: []
                        };
                        results.push(resultMap[idx]);
                    }
                    expResults.forEach(({ matches: matches })=>{
                        resultMap[idx].matches.push(...matches);
                    });
                }
            }
        });
        return results;
    }
    _searchObjectList(query) {
        const searcher = $d4318bb490f1a22e$var$createSearcher(query, this.options);
        const { keys: keys, records: records } = this._myIndex;
        const results = [];
        // List is Array<Object>
        records.forEach(({ $: item, i: idx })=>{
            if (!$d4318bb490f1a22e$var$isDefined(item)) return;
            let matches = [];
            // Iterate over every key (i.e, path), and fetch the value at that key
            keys.forEach((key, keyIndex)=>{
                matches.push(...this._findMatches({
                    key: key,
                    value: item[keyIndex],
                    searcher: searcher
                }));
            });
            if (matches.length) results.push({
                idx: idx,
                item: item,
                matches: matches
            });
        });
        return results;
    }
    _findMatches({ key: key, value: value, searcher: searcher }) {
        if (!$d4318bb490f1a22e$var$isDefined(value)) return [];
        let matches = [];
        if ($d4318bb490f1a22e$var$isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$d4318bb490f1a22e$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                idx: idx,
                norm: norm,
                indices: indices
            });
        });
        else {
            const { v: text, n: norm } = value;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                norm: norm,
                indices: indices
            });
        }
        return matches;
    }
}
$d4318bb490f1a22e$export$2e2bcd8739ae039.version = "7.0.0";
$d4318bb490f1a22e$export$2e2bcd8739ae039.createIndex = $d4318bb490f1a22e$var$createIndex;
$d4318bb490f1a22e$export$2e2bcd8739ae039.parseIndex = $d4318bb490f1a22e$var$parseIndex;
$d4318bb490f1a22e$export$2e2bcd8739ae039.config = $d4318bb490f1a22e$var$Config;
$d4318bb490f1a22e$export$2e2bcd8739ae039.parseQuery = $d4318bb490f1a22e$var$parse;
$d4318bb490f1a22e$var$register($d4318bb490f1a22e$var$ExtendedSearch);

});



parcelRegister("SRJCe", function(module, exports) {

$parcel$export(module.exports, "useSidebarStack", function () { return $867333686d58b8eb$export$4c81a45f228111ff; });
$parcel$export(module.exports, "Sidebar", function () { return $867333686d58b8eb$export$1ba59dacbcbf90fe; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $5FqxN = parcelRequire("5FqxN");

var $95Evz = parcelRequire("95Evz");
let $867333686d58b8eb$var$listeners = new Set();
let $867333686d58b8eb$var$items = [];
const $867333686d58b8eb$var$emitChange = ()=>{
    $867333686d58b8eb$var$listeners.forEach((listener)=>listener($867333686d58b8eb$var$items));
};
const $867333686d58b8eb$export$4c81a45f228111ff = ()=>{
    const [sidebarItems, setSidebarItems] = (0, $jbmdS.useState)($867333686d58b8eb$var$items);
    (0, $jbmdS.useEffect)(()=>{
        $867333686d58b8eb$var$listeners.add(setSidebarItems);
        return ()=>$867333686d58b8eb$var$listeners.delete(setSidebarItems);
    }, []);
    const addToSidebar = (0, $jbmdS.useCallback)((content, options = {})=>{
        const id = Math.random().toString(36).substring(7);
        $867333686d58b8eb$var$items = [
            {
                id: id,
                content: content,
                ...options
            },
            ...$867333686d58b8eb$var$items
        ];
        $867333686d58b8eb$var$emitChange();
        return id;
    }, []);
    const removeFromSidebar = (0, $jbmdS.useCallback)((id)=>{
        $867333686d58b8eb$var$items = $867333686d58b8eb$var$items.filter((item)=>item.id !== id);
        $867333686d58b8eb$var$emitChange();
        return id;
    }, []);
    const clearSidebar = (0, $jbmdS.useCallback)(()=>{
        $867333686d58b8eb$var$items = [];
        $867333686d58b8eb$var$emitChange();
    }, []);
    return {
        addToSidebar: addToSidebar,
        removeFromSidebar: removeFromSidebar,
        clearSidebar: clearSidebar,
        hasSidebarItems: $867333686d58b8eb$var$items.length > 0
    };
};
const $867333686d58b8eb$var$ANIMATION_DURATION = 300; // ms
// A single sidebar panel that slides in on mount & out on close
function $867333686d58b8eb$var$SidebarPanel({ item: item, offset: offset, isFrontPanel: isFrontPanel, removeFromSidebar: removeFromSidebar, totalWidth: totalWidth, zIndex: zIndex }) {
    // Track whether this panel is "entering" and "exiting"
    const [mounted, setMounted] = (0, $jbmdS.useState)(false); // for slide-in
    const [exiting, setExiting] = (0, $jbmdS.useState)(false); // for slide-out
    // Trigger the "slide in" animation on first mount
    (0, $jbmdS.useEffect)(()=>{
        // Small delay so that the starting position is applied
        // before the transition kicks in
        const t = setTimeout(()=>setMounted(true), 10);
        return ()=>clearTimeout(t);
    }, []);
    // When user closes the panel
    const handleClose = ()=>{
        setExiting(true);
        // Wait for the exit transition before removing from the store
        setTimeout(()=>{
            removeFromSidebar(item.id);
        }, $867333686d58b8eb$var$ANIMATION_DURATION);
    };
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: (0, $95Evz.cn)("absolute inset-0 bg-background flex flex-col h-full", "transition-all duration-300 ease-in-out", !isFrontPanel && "border-l border-border"),
        style: {
            // If not mounted (entering) or currently exiting,
            // shift the panel offscreen (to the right).
            // Otherwise, keep it at `offset`.
            transform: `translateX(${mounted && !exiting ? offset : offset + totalWidth}px)`,
            width: `${totalWidth - offset}px`,
            boxShadow: !isFrontPanel ? "-4px 0 8px -4px rgba(0, 0, 0, 0.1)" : "none",
            zIndex: zIndex
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "flex-1 overflow-auto relative",
                children: [
                    !item.hideClose && /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                        onClick: handleClose,
                        className: "absolute top-2 right-2 text-gray-400 hover:text-gray-600 z-10",
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5FqxN.default), {
                            size: 16
                        })
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "p-4",
                        children: item.content
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "h-28 w-full print:hidden flex-none"
            })
        ]
    });
}
const $867333686d58b8eb$export$1ba59dacbcbf90fe = ()=>{
    const [sidebarItems, setSidebarItems] = (0, $jbmdS.useState)([]);
    const { removeFromSidebar: removeFromSidebar } = $867333686d58b8eb$export$4c81a45f228111ff();
    (0, $jbmdS.useEffect)(()=>{
        // Listen for changes to the global sidebar stack
        const handleItems = (newItems)=>setSidebarItems(newItems);
        $867333686d58b8eb$var$listeners.add(handleItems);
        return ()=>{
            $867333686d58b8eb$var$listeners.delete(handleItems);
        };
    }, []);
    if (sidebarItems.length === 0) return null;
    // Calculate extra width based on number of visible panels
    const visiblePanels = Math.min(sidebarItems.length, 3);
    const extraWidth = (visiblePanels - 1) * 12;
    const totalWidth = 320 + extraWidth;
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: (0, $95Evz.cn)("flex-none border-l border-border", "transition-all duration-300 ease-in-out"),
        style: {
            width: `${totalWidth}px`
        },
        children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            className: "relative h-full",
            children: sidebarItems.slice(0, 3).map((item, index, array)=>{
                const offset = (array.length - 1 - index) * 12;
                const isFrontPanel = index === array.length - 1;
                const zIndex = array.length - index;
                return /*#__PURE__*/ (0, $61Ea1.jsx)($867333686d58b8eb$var$SidebarPanel, {
                    item: item,
                    offset: offset,
                    isFrontPanel: isFrontPanel,
                    removeFromSidebar: removeFromSidebar,
                    totalWidth: totalWidth,
                    zIndex: zIndex
                }, item.id);
            })
        })
    });
};

});
parcelRegister("5FqxN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42055f2ed1bae531$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $42055f2ed1bae531$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("X", [
    [
        "path",
        {
            d: "M18 6 6 18",
            key: "1bl5f8"
        }
    ],
    [
        "path",
        {
            d: "m6 6 12 12",
            key: "d8bk6v"
        }
    ]
]);

});



parcelRegister("lfqR9", function(module, exports) {

$parcel$export(module.exports, "Toaster", function () { return $420904647d451a7e$export$fb98e3a2a4cd92d7; });

var $61Ea1 = parcelRequire("61Ea1");

var $7zCyL = parcelRequire("7zCyL");
const $420904647d451a7e$export$fb98e3a2a4cd92d7 = ({ ...props })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7zCyL.Toaster), {
        className: "toaster group",
        toastOptions: {
            classNames: {
                toast: "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
                description: "group-[.toast]:text-muted-foreground",
                actionButton: "group-[.toast]:bg-background group-[.toast]:text-foreground",
                cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground"
            }
        },
        ...props
    });
};

});
parcelRegister("7zCyL", function(module, exports) {
"use client";
var $5839b6730ea54521$var$Vt = Object.create;
var $5839b6730ea54521$var$q = Object.defineProperty;
var $5839b6730ea54521$var$Ot = Object.getOwnPropertyDescriptor;
var $5839b6730ea54521$var$Kt = Object.getOwnPropertyNames;
var $5839b6730ea54521$var$Xt = Object.getPrototypeOf, $5839b6730ea54521$var$Jt = Object.prototype.hasOwnProperty;
var $5839b6730ea54521$var$Gt = (a, e)=>{
    for(var t in e)$5839b6730ea54521$var$q(a, t, {
        get: e[t],
        enumerable: !0
    });
}, $5839b6730ea54521$var$Dt = (a, e, t, s)=>{
    if (e && typeof e == "object" || typeof e == "function") for (let m of $5839b6730ea54521$var$Kt(e))!$5839b6730ea54521$var$Jt.call(a, m) && m !== t && $5839b6730ea54521$var$q(a, m, {
        get: ()=>e[m],
        enumerable: !(s = $5839b6730ea54521$var$Ot(e, m)) || s.enumerable
    });
    return a;
};
var $5839b6730ea54521$var$Q = (a, e, t)=>(t = a != null ? $5839b6730ea54521$var$Vt($5839b6730ea54521$var$Xt(a)) : {}, $5839b6730ea54521$var$Dt(e || !a || !a.__esModule ? $5839b6730ea54521$var$q(t, "default", {
        value: a,
        enumerable: !0
    }) : t, a)), $5839b6730ea54521$var$qt = (a)=>$5839b6730ea54521$var$Dt($5839b6730ea54521$var$q({}, "__esModule", {
        value: !0
    }), a);
var $5839b6730ea54521$var$ye = {};
$5839b6730ea54521$var$Gt($5839b6730ea54521$var$ye, {
    Toaster: ()=>$5839b6730ea54521$var$be,
    toast: ()=>$5839b6730ea54521$var$Lt,
    useSonner: ()=>$5839b6730ea54521$var$he
});
module.exports = $5839b6730ea54521$var$qt($5839b6730ea54521$var$ye);

var $5839b6730ea54521$var$o = $5839b6730ea54521$var$Q((parcelRequire("jbmdS")));

var $5839b6730ea54521$var$jt = $5839b6730ea54521$var$Q((parcelRequire("jCNM0")));

var $5839b6730ea54521$var$w = $5839b6730ea54521$var$Q((parcelRequire("jbmdS"))), $5839b6730ea54521$var$Ht = (a)=>{
    switch(a){
        case "success":
            return $5839b6730ea54521$var$Zt;
        case "info":
            return $5839b6730ea54521$var$ee;
        case "warning":
            return $5839b6730ea54521$var$te;
        case "error":
            return $5839b6730ea54521$var$oe;
        default:
            return null;
    }
}, $5839b6730ea54521$var$Qt = Array(12).fill(0), $5839b6730ea54521$var$Mt = ({ visible: a })=>$5839b6730ea54521$var$w.default.createElement("div", {
        className: "sonner-loading-wrapper",
        "data-visible": a
    }, $5839b6730ea54521$var$w.default.createElement("div", {
        className: "sonner-spinner"
    }, $5839b6730ea54521$var$Qt.map((e, t)=>$5839b6730ea54521$var$w.default.createElement("div", {
            className: "sonner-loading-bar",
            key: `spinner-bar-${t}`
        })))), $5839b6730ea54521$var$Zt = $5839b6730ea54521$var$w.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    height: "20",
    width: "20"
}, $5839b6730ea54521$var$w.default.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z",
    clipRule: "evenodd"
})), $5839b6730ea54521$var$te = $5839b6730ea54521$var$w.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    height: "20",
    width: "20"
}, $5839b6730ea54521$var$w.default.createElement("path", {
    fillRule: "evenodd",
    d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z",
    clipRule: "evenodd"
})), $5839b6730ea54521$var$ee = $5839b6730ea54521$var$w.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    height: "20",
    width: "20"
}, $5839b6730ea54521$var$w.default.createElement("path", {
    fillRule: "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z",
    clipRule: "evenodd"
})), $5839b6730ea54521$var$oe = $5839b6730ea54521$var$w.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    height: "20",
    width: "20"
}, $5839b6730ea54521$var$w.default.createElement("path", {
    fillRule: "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z",
    clipRule: "evenodd"
}));

var $5839b6730ea54521$var$ft = $5839b6730ea54521$var$Q((parcelRequire("jbmdS"))), $5839b6730ea54521$var$At = ()=>{
    let [a, e] = $5839b6730ea54521$var$ft.default.useState(document.hidden);
    return $5839b6730ea54521$var$ft.default.useEffect(()=>{
        let t = ()=>{
            e(document.hidden);
        };
        return document.addEventListener("visibilitychange", t), ()=>window.removeEventListener("visibilitychange", t);
    }, []), a;
};
var $5839b6730ea54521$var$mt = 1, $5839b6730ea54521$var$pt = class {
    constructor(){
        this.subscribe = (e)=>(this.subscribers.push(e), ()=>{
                let t = this.subscribers.indexOf(e);
                this.subscribers.splice(t, 1);
            });
        this.publish = (e)=>{
            this.subscribers.forEach((t)=>t(e));
        };
        this.addToast = (e)=>{
            this.publish(e), this.toasts = [
                ...this.toasts,
                e
            ];
        };
        this.create = (e)=>{
            var b;
            let { message: t, ...s } = e, m = typeof (e == null ? void 0 : e.id) == "number" || ((b = e.id) == null ? void 0 : b.length) > 0 ? e.id : $5839b6730ea54521$var$mt++, u = this.toasts.find((d)=>d.id === m), h = e.dismissible === void 0 ? !0 : e.dismissible;
            return u ? this.toasts = this.toasts.map((d)=>d.id === m ? (this.publish({
                    ...d,
                    ...e,
                    id: m,
                    title: t
                }), {
                    ...d,
                    ...e,
                    id: m,
                    dismissible: h,
                    title: t
                }) : d) : this.addToast({
                title: t,
                ...s,
                dismissible: h,
                id: m
            }), m;
        };
        this.dismiss = (e)=>(e || this.toasts.forEach((t)=>{
                this.subscribers.forEach((s)=>s({
                        id: t.id,
                        dismiss: !0
                    }));
            }), this.subscribers.forEach((t)=>t({
                    id: e,
                    dismiss: !0
                })), e);
        this.message = (e, t)=>this.create({
                ...t,
                message: e
            });
        this.error = (e, t)=>this.create({
                ...t,
                message: e,
                type: "error"
            });
        this.success = (e, t)=>this.create({
                ...t,
                type: "success",
                message: e
            });
        this.info = (e, t)=>this.create({
                ...t,
                type: "info",
                message: e
            });
        this.warning = (e, t)=>this.create({
                ...t,
                type: "warning",
                message: e
            });
        this.loading = (e, t)=>this.create({
                ...t,
                type: "loading",
                message: e
            });
        this.promise = (e, t)=>{
            if (!t) return;
            let s;
            t.loading !== void 0 && (s = this.create({
                ...t,
                promise: e,
                type: "loading",
                message: t.loading,
                description: typeof t.description != "function" ? t.description : void 0
            }));
            let m = e instanceof Promise ? e : e(), u = s !== void 0;
            return m.then(async (h)=>{
                if ($5839b6730ea54521$var$ne(h) && !h.ok) {
                    u = !1;
                    let b = typeof t.error == "function" ? await t.error(`HTTP error! status: ${h.status}`) : t.error, d = typeof t.description == "function" ? await t.description(`HTTP error! status: ${h.status}`) : t.description;
                    this.create({
                        id: s,
                        type: "error",
                        message: b,
                        description: d
                    });
                } else if (t.success !== void 0) {
                    u = !1;
                    let b = typeof t.success == "function" ? await t.success(h) : t.success, d = typeof t.description == "function" ? await t.description(h) : t.description;
                    this.create({
                        id: s,
                        type: "success",
                        message: b,
                        description: d
                    });
                }
            }).catch(async (h)=>{
                if (t.error !== void 0) {
                    u = !1;
                    let b = typeof t.error == "function" ? await t.error(h) : t.error, d = typeof t.description == "function" ? await t.description(h) : t.description;
                    this.create({
                        id: s,
                        type: "error",
                        message: b,
                        description: d
                    });
                }
            }).finally(()=>{
                var h;
                u && (this.dismiss(s), s = void 0), (h = t.finally) == null || h.call(t);
            }), s;
        };
        this.custom = (e, t)=>{
            let s = (t == null ? void 0 : t.id) || $5839b6730ea54521$var$mt++;
            return this.create({
                jsx: e(s),
                id: s,
                ...t
            }), s;
        };
        this.subscribers = [], this.toasts = [];
    }
}, $5839b6730ea54521$var$v = new $5839b6730ea54521$var$pt(), $5839b6730ea54521$var$ae = (a, e)=>{
    let t = (e == null ? void 0 : e.id) || $5839b6730ea54521$var$mt++;
    return $5839b6730ea54521$var$v.addToast({
        title: a,
        ...e,
        id: t
    }), t;
}, $5839b6730ea54521$var$ne = (a)=>a && typeof a == "object" && "ok" in a && typeof a.ok == "boolean" && "status" in a && typeof a.status == "number", $5839b6730ea54521$var$se = $5839b6730ea54521$var$ae, $5839b6730ea54521$var$re = ()=>$5839b6730ea54521$var$v.toasts, $5839b6730ea54521$var$Lt = Object.assign($5839b6730ea54521$var$se, {
    success: $5839b6730ea54521$var$v.success,
    info: $5839b6730ea54521$var$v.info,
    warning: $5839b6730ea54521$var$v.warning,
    error: $5839b6730ea54521$var$v.error,
    custom: $5839b6730ea54521$var$v.custom,
    message: $5839b6730ea54521$var$v.message,
    promise: $5839b6730ea54521$var$v.promise,
    dismiss: $5839b6730ea54521$var$v.dismiss,
    loading: $5839b6730ea54521$var$v.loading
}, {
    getHistory: $5839b6730ea54521$var$re
});
function $5839b6730ea54521$var$gt(a, { insertAt: e } = {}) {
    if (!a || typeof document == "undefined") return;
    let t = document.head || document.getElementsByTagName("head")[0], s = document.createElement("style");
    s.type = "text/css", e === "top" && t.firstChild ? t.insertBefore(s, t.firstChild) : t.appendChild(s), s.styleSheet ? s.styleSheet.cssText = a : s.appendChild(document.createTextNode(a));
}
$5839b6730ea54521$var$gt(`:where(html[dir="ltr"]),:where([data-sonner-toaster][dir="ltr"]){--toast-icon-margin-start: -3px;--toast-icon-margin-end: 4px;--toast-svg-margin-start: -1px;--toast-svg-margin-end: 0px;--toast-button-margin-start: auto;--toast-button-margin-end: 0;--toast-close-button-start: 0;--toast-close-button-end: unset;--toast-close-button-transform: translate(-35%, -35%)}:where(html[dir="rtl"]),:where([data-sonner-toaster][dir="rtl"]){--toast-icon-margin-start: 4px;--toast-icon-margin-end: -3px;--toast-svg-margin-start: 0px;--toast-svg-margin-end: -1px;--toast-button-margin-start: 0;--toast-button-margin-end: auto;--toast-close-button-start: unset;--toast-close-button-end: 0;--toast-close-button-transform: translate(35%, -35%)}:where([data-sonner-toaster]){position:fixed;width:var(--width);font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;--gray1: hsl(0, 0%, 99%);--gray2: hsl(0, 0%, 97.3%);--gray3: hsl(0, 0%, 95.1%);--gray4: hsl(0, 0%, 93%);--gray5: hsl(0, 0%, 90.9%);--gray6: hsl(0, 0%, 88.7%);--gray7: hsl(0, 0%, 85.8%);--gray8: hsl(0, 0%, 78%);--gray9: hsl(0, 0%, 56.1%);--gray10: hsl(0, 0%, 52.3%);--gray11: hsl(0, 0%, 43.5%);--gray12: hsl(0, 0%, 9%);--border-radius: 8px;box-sizing:border-box;padding:0;margin:0;list-style:none;outline:none;z-index:999999999}:where([data-sonner-toaster][data-x-position="right"]){right:max(var(--offset),env(safe-area-inset-right))}:where([data-sonner-toaster][data-x-position="left"]){left:max(var(--offset),env(safe-area-inset-left))}:where([data-sonner-toaster][data-x-position="center"]){left:50%;transform:translate(-50%)}:where([data-sonner-toaster][data-y-position="top"]){top:max(var(--offset),env(safe-area-inset-top))}:where([data-sonner-toaster][data-y-position="bottom"]){bottom:max(var(--offset),env(safe-area-inset-bottom))}:where([data-sonner-toast]){--y: translateY(100%);--lift-amount: calc(var(--lift) * var(--gap));z-index:var(--z-index);position:absolute;opacity:0;transform:var(--y);filter:blur(0);touch-action:none;transition:transform .4s,opacity .4s,height .4s,box-shadow .2s;box-sizing:border-box;outline:none;overflow-wrap:anywhere}:where([data-sonner-toast][data-styled="true"]){padding:16px;background:var(--normal-bg);border:1px solid var(--normal-border);color:var(--normal-text);border-radius:var(--border-radius);box-shadow:0 4px 12px #0000001a;width:var(--width);font-size:13px;display:flex;align-items:center;gap:6px}:where([data-sonner-toast]:focus-visible){box-shadow:0 4px 12px #0000001a,0 0 0 2px #0003}:where([data-sonner-toast][data-y-position="top"]){top:0;--y: translateY(-100%);--lift: 1;--lift-amount: calc(1 * var(--gap))}:where([data-sonner-toast][data-y-position="bottom"]){bottom:0;--y: translateY(100%);--lift: -1;--lift-amount: calc(var(--lift) * var(--gap))}:where([data-sonner-toast]) :where([data-description]){font-weight:400;line-height:1.4;color:inherit}:where([data-sonner-toast]) :where([data-title]){font-weight:500;line-height:1.5;color:inherit}:where([data-sonner-toast]) :where([data-icon]){display:flex;height:16px;width:16px;position:relative;justify-content:flex-start;align-items:center;flex-shrink:0;margin-left:var(--toast-icon-margin-start);margin-right:var(--toast-icon-margin-end)}:where([data-sonner-toast][data-promise="true"]) :where([data-icon])>svg{opacity:0;transform:scale(.8);transform-origin:center;animation:sonner-fade-in .3s ease forwards}:where([data-sonner-toast]) :where([data-icon])>*{flex-shrink:0}:where([data-sonner-toast]) :where([data-icon]) svg{margin-left:var(--toast-svg-margin-start);margin-right:var(--toast-svg-margin-end)}:where([data-sonner-toast]) :where([data-content]){display:flex;flex-direction:column;gap:2px}[data-sonner-toast][data-styled=true] [data-button]{border-radius:4px;padding-left:8px;padding-right:8px;height:24px;font-size:12px;color:var(--normal-bg);background:var(--normal-text);margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end);border:none;cursor:pointer;outline:none;display:flex;align-items:center;flex-shrink:0;transition:opacity .4s,box-shadow .2s}:where([data-sonner-toast]) :where([data-button]):focus-visible{box-shadow:0 0 0 2px #0006}:where([data-sonner-toast]) :where([data-button]):first-of-type{margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end)}:where([data-sonner-toast]) :where([data-cancel]){color:var(--normal-text);background:rgba(0,0,0,.08)}:where([data-sonner-toast][data-theme="dark"]) :where([data-cancel]){background:rgba(255,255,255,.3)}:where([data-sonner-toast]) :where([data-close-button]){position:absolute;left:var(--toast-close-button-start);right:var(--toast-close-button-end);top:0;height:20px;width:20px;display:flex;justify-content:center;align-items:center;padding:0;background:var(--gray1);color:var(--gray12);border:1px solid var(--gray4);transform:var(--toast-close-button-transform);border-radius:50%;cursor:pointer;z-index:1;transition:opacity .1s,background .2s,border-color .2s}:where([data-sonner-toast]) :where([data-close-button]):focus-visible{box-shadow:0 4px 12px #0000001a,0 0 0 2px #0003}:where([data-sonner-toast]) :where([data-disabled="true"]){cursor:not-allowed}:where([data-sonner-toast]):hover :where([data-close-button]):hover{background:var(--gray2);border-color:var(--gray5)}:where([data-sonner-toast][data-swiping="true"]):before{content:"";position:absolute;left:0;right:0;height:100%;z-index:-1}:where([data-sonner-toast][data-y-position="top"][data-swiping="true"]):before{bottom:50%;transform:scaleY(3) translateY(50%)}:where([data-sonner-toast][data-y-position="bottom"][data-swiping="true"]):before{top:50%;transform:scaleY(3) translateY(-50%)}:where([data-sonner-toast][data-swiping="false"][data-removed="true"]):before{content:"";position:absolute;inset:0;transform:scaleY(2)}:where([data-sonner-toast]):after{content:"";position:absolute;left:0;height:calc(var(--gap) + 1px);bottom:100%;width:100%}:where([data-sonner-toast][data-mounted="true"]){--y: translateY(0);opacity:1}:where([data-sonner-toast][data-expanded="false"][data-front="false"]){--scale: var(--toasts-before) * .05 + 1;--y: translateY(calc(var(--lift-amount) * var(--toasts-before))) scale(calc(-1 * var(--scale)));height:var(--front-toast-height)}:where([data-sonner-toast])>*{transition:opacity .4s}:where([data-sonner-toast][data-expanded="false"][data-front="false"][data-styled="true"])>*{opacity:0}:where([data-sonner-toast][data-visible="false"]){opacity:0;pointer-events:none}:where([data-sonner-toast][data-mounted="true"][data-expanded="true"]){--y: translateY(calc(var(--lift) * var(--offset)));height:var(--initial-height)}:where([data-sonner-toast][data-removed="true"][data-front="true"][data-swipe-out="false"]){--y: translateY(calc(var(--lift) * -100%));opacity:0}:where([data-sonner-toast][data-removed="true"][data-front="false"][data-swipe-out="false"][data-expanded="true"]){--y: translateY(calc(var(--lift) * var(--offset) + var(--lift) * -100%));opacity:0}:where([data-sonner-toast][data-removed="true"][data-front="false"][data-swipe-out="false"][data-expanded="false"]){--y: translateY(40%);opacity:0;transition:transform .5s,opacity .2s}:where([data-sonner-toast][data-removed="true"][data-front="false"]):before{height:calc(var(--initial-height) + 20%)}[data-sonner-toast][data-swiping=true]{transform:var(--y) translateY(var(--swipe-amount, 0px));transition:none}[data-sonner-toast][data-swipe-out=true][data-y-position=bottom],[data-sonner-toast][data-swipe-out=true][data-y-position=top]{animation:swipe-out .2s ease-out forwards}@keyframes swipe-out{0%{transform:translateY(calc(var(--lift) * var(--offset) + var(--swipe-amount)));opacity:1}to{transform:translateY(calc(var(--lift) * var(--offset) + var(--swipe-amount) + var(--lift) * -100%));opacity:0}}@media (max-width: 600px){[data-sonner-toaster]{position:fixed;--mobile-offset: 16px;right:var(--mobile-offset);left:var(--mobile-offset);width:100%}[data-sonner-toaster] [data-sonner-toast]{left:0;right:0;width:calc(100% - var(--mobile-offset) * 2)}[data-sonner-toaster][data-x-position=left]{left:var(--mobile-offset)}[data-sonner-toaster][data-y-position=bottom]{bottom:20px}[data-sonner-toaster][data-y-position=top]{top:20px}[data-sonner-toaster][data-x-position=center]{left:var(--mobile-offset);right:var(--mobile-offset);transform:none}}[data-sonner-toaster][data-theme=light]{--normal-bg: #fff;--normal-border: var(--gray4);--normal-text: var(--gray12);--success-bg: hsl(143, 85%, 96%);--success-border: hsl(145, 92%, 91%);--success-text: hsl(140, 100%, 27%);--info-bg: hsl(208, 100%, 97%);--info-border: hsl(221, 91%, 91%);--info-text: hsl(210, 92%, 45%);--warning-bg: hsl(49, 100%, 97%);--warning-border: hsl(49, 91%, 91%);--warning-text: hsl(31, 92%, 45%);--error-bg: hsl(359, 100%, 97%);--error-border: hsl(359, 100%, 94%);--error-text: hsl(360, 100%, 45%)}[data-sonner-toaster][data-theme=light] [data-sonner-toast][data-invert=true]{--normal-bg: #000;--normal-border: hsl(0, 0%, 20%);--normal-text: var(--gray1)}[data-sonner-toaster][data-theme=dark] [data-sonner-toast][data-invert=true]{--normal-bg: #fff;--normal-border: var(--gray3);--normal-text: var(--gray12)}[data-sonner-toaster][data-theme=dark]{--normal-bg: #000;--normal-border: hsl(0, 0%, 20%);--normal-text: var(--gray1);--success-bg: hsl(150, 100%, 6%);--success-border: hsl(147, 100%, 12%);--success-text: hsl(150, 86%, 65%);--info-bg: hsl(215, 100%, 6%);--info-border: hsl(223, 100%, 12%);--info-text: hsl(216, 87%, 65%);--warning-bg: hsl(64, 100%, 6%);--warning-border: hsl(60, 100%, 12%);--warning-text: hsl(46, 87%, 65%);--error-bg: hsl(358, 76%, 10%);--error-border: hsl(357, 89%, 16%);--error-text: hsl(358, 100%, 81%)}[data-rich-colors=true][data-sonner-toast][data-type=success],[data-rich-colors=true][data-sonner-toast][data-type=success] [data-close-button]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=info],[data-rich-colors=true][data-sonner-toast][data-type=info] [data-close-button]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning],[data-rich-colors=true][data-sonner-toast][data-type=warning] [data-close-button]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=error],[data-rich-colors=true][data-sonner-toast][data-type=error] [data-close-button]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}.sonner-loading-wrapper{--size: 16px;height:var(--size);width:var(--size);position:absolute;inset:0;z-index:10}.sonner-loading-wrapper[data-visible=false]{transform-origin:center;animation:sonner-fade-out .2s ease forwards}.sonner-spinner{position:relative;top:50%;left:50%;height:var(--size);width:var(--size)}.sonner-loading-bar{animation:sonner-spin 1.2s linear infinite;background:var(--gray11);border-radius:6px;height:8%;left:-10%;position:absolute;top:-3.9%;width:24%}.sonner-loading-bar:nth-child(1){animation-delay:-1.2s;transform:rotate(.0001deg) translate(146%)}.sonner-loading-bar:nth-child(2){animation-delay:-1.1s;transform:rotate(30deg) translate(146%)}.sonner-loading-bar:nth-child(3){animation-delay:-1s;transform:rotate(60deg) translate(146%)}.sonner-loading-bar:nth-child(4){animation-delay:-.9s;transform:rotate(90deg) translate(146%)}.sonner-loading-bar:nth-child(5){animation-delay:-.8s;transform:rotate(120deg) translate(146%)}.sonner-loading-bar:nth-child(6){animation-delay:-.7s;transform:rotate(150deg) translate(146%)}.sonner-loading-bar:nth-child(7){animation-delay:-.6s;transform:rotate(180deg) translate(146%)}.sonner-loading-bar:nth-child(8){animation-delay:-.5s;transform:rotate(210deg) translate(146%)}.sonner-loading-bar:nth-child(9){animation-delay:-.4s;transform:rotate(240deg) translate(146%)}.sonner-loading-bar:nth-child(10){animation-delay:-.3s;transform:rotate(270deg) translate(146%)}.sonner-loading-bar:nth-child(11){animation-delay:-.2s;transform:rotate(300deg) translate(146%)}.sonner-loading-bar:nth-child(12){animation-delay:-.1s;transform:rotate(330deg) translate(146%)}@keyframes sonner-fade-in{0%{opacity:0;transform:scale(.8)}to{opacity:1;transform:scale(1)}}@keyframes sonner-fade-out{0%{opacity:1;transform:scale(1)}to{opacity:0;transform:scale(.8)}}@keyframes sonner-spin{0%{opacity:1}to{opacity:.15}}@media (prefers-reduced-motion){[data-sonner-toast],[data-sonner-toast]>*,.sonner-loading-bar{transition:none!important;animation:none!important}}.sonner-loader{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);transform-origin:center;transition:opacity .2s,transform .2s}.sonner-loader[data-visible=false]{opacity:0;transform:scale(.8) translate(-50%,-50%)}
`);
function $5839b6730ea54521$var$U(a) {
    return a.label !== void 0;
}
var $5839b6730ea54521$var$ie = 3, $5839b6730ea54521$var$le = "32px", $5839b6730ea54521$var$de = 4e3, $5839b6730ea54521$var$ce = 356, $5839b6730ea54521$var$ue = 14, $5839b6730ea54521$var$fe = 20, $5839b6730ea54521$var$me = 200;
function $5839b6730ea54521$var$pe(...a) {
    return a.filter(Boolean).join(" ");
}
var $5839b6730ea54521$var$ge = (a)=>{
    var wt, Tt, St, Rt, Et, Nt, Pt, Bt, Ct, It;
    let { invert: e, toast: t, unstyled: s, interacting: m, setHeights: u, visibleToasts: h, heights: b, index: d, toasts: Z, expanded: $, removeToast: V, defaultRichColors: tt, closeButton: i, style: O, cancelButtonStyle: K, actionButtonStyle: et, className: ot = "", descriptionClassName: at = "", duration: X, position: nt, gap: T, loadingIcon: j, expandByDefault: W, classNames: r, icons: I, closeButtonAriaLabel: st = "Close toast", pauseWhenPageIsHidden: k, cn: S } = a, [z, rt] = $5839b6730ea54521$var$o.default.useState(!1), [D, H] = $5839b6730ea54521$var$o.default.useState(!1), [it, N] = $5839b6730ea54521$var$o.default.useState(!1), [M, lt] = $5839b6730ea54521$var$o.default.useState(!1), [c, p] = $5839b6730ea54521$var$o.default.useState(0), [y, R] = $5839b6730ea54521$var$o.default.useState(0), A = $5839b6730ea54521$var$o.default.useRef(null), l = $5839b6730ea54521$var$o.default.useRef(null), _ = d === 0, J = d + 1 <= h, x = t.type, P = t.dismissible !== !1, Yt = t.className || "", Ft = t.descriptionClassName || "", G = $5839b6730ea54521$var$o.default.useMemo(()=>b.findIndex((n)=>n.toastId === t.id) || 0, [
        b,
        t.id
    ]), $t = $5839b6730ea54521$var$o.default.useMemo(()=>{
        var n;
        return (n = t.closeButton) != null ? n : i;
    }, [
        t.closeButton,
        i
    ]), ht = $5839b6730ea54521$var$o.default.useMemo(()=>t.duration || X || $5839b6730ea54521$var$de, [
        t.duration,
        X
    ]), dt = $5839b6730ea54521$var$o.default.useRef(0), Y = $5839b6730ea54521$var$o.default.useRef(0), bt = $5839b6730ea54521$var$o.default.useRef(0), F = $5839b6730ea54521$var$o.default.useRef(null), [yt, Wt] = nt.split("-"), xt = $5839b6730ea54521$var$o.default.useMemo(()=>b.reduce((n, f, g)=>g >= G ? n : n + f.height, 0), [
        b,
        G
    ]), vt = $5839b6730ea54521$var$At(), _t = t.invert || e, ct = x === "loading";
    Y.current = $5839b6730ea54521$var$o.default.useMemo(()=>G * T + xt, [
        G,
        xt
    ]), $5839b6730ea54521$var$o.default.useEffect(()=>{
        rt(!0);
    }, []), $5839b6730ea54521$var$o.default.useLayoutEffect(()=>{
        if (!z) return;
        let n = l.current, f = n.style.height;
        n.style.height = "auto";
        let g = n.getBoundingClientRect().height;
        n.style.height = f, R(g), u((B)=>B.find((E)=>E.toastId === t.id) ? B.map((E)=>E.toastId === t.id ? {
                    ...E,
                    height: g
                } : E) : [
                {
                    toastId: t.id,
                    height: g,
                    position: t.position
                },
                ...B
            ]);
    }, [
        z,
        t.title,
        t.description,
        u,
        t.id
    ]);
    let L = $5839b6730ea54521$var$o.default.useCallback(()=>{
        H(!0), p(Y.current), u((n)=>n.filter((f)=>f.toastId !== t.id)), setTimeout(()=>{
            V(t);
        }, $5839b6730ea54521$var$me);
    }, [
        t,
        V,
        u,
        Y
    ]);
    $5839b6730ea54521$var$o.default.useEffect(()=>{
        if (t.promise && x === "loading" || t.duration === 1 / 0 || t.type === "loading") return;
        let n, f = ht;
        return $ || m || k && vt ? (()=>{
            if (bt.current < dt.current) {
                let C = new Date().getTime() - dt.current;
                f = f - C;
            }
            bt.current = new Date().getTime();
        })() : (()=>{
            f !== 1 / 0 && (dt.current = new Date().getTime(), n = setTimeout(()=>{
                var C;
                (C = t.onAutoClose) == null || C.call(t, t), L();
            }, f));
        })(), ()=>clearTimeout(n);
    }, [
        $,
        m,
        W,
        t,
        ht,
        L,
        t.promise,
        x,
        k,
        vt
    ]), $5839b6730ea54521$var$o.default.useEffect(()=>{
        let n = l.current;
        if (n) {
            let f = n.getBoundingClientRect().height;
            return R(f), u((g)=>[
                    {
                        toastId: t.id,
                        height: f,
                        position: t.position
                    },
                    ...g
                ]), ()=>u((g)=>g.filter((B)=>B.toastId !== t.id));
        }
    }, [
        u,
        t.id
    ]), $5839b6730ea54521$var$o.default.useEffect(()=>{
        t.delete && L();
    }, [
        L,
        t.delete
    ]);
    function Ut() {
        return I != null && I.loading ? $5839b6730ea54521$var$o.default.createElement("div", {
            className: "sonner-loader",
            "data-visible": x === "loading"
        }, I.loading) : j ? $5839b6730ea54521$var$o.default.createElement("div", {
            className: "sonner-loader",
            "data-visible": x === "loading"
        }, j) : $5839b6730ea54521$var$o.default.createElement($5839b6730ea54521$var$Mt, {
            visible: x === "loading"
        });
    }
    return $5839b6730ea54521$var$o.default.createElement("li", {
        "aria-live": t.important ? "assertive" : "polite",
        "aria-atomic": "true",
        role: "status",
        tabIndex: 0,
        ref: l,
        className: S(ot, Yt, r == null ? void 0 : r.toast, (wt = t == null ? void 0 : t.classNames) == null ? void 0 : wt.toast, r == null ? void 0 : r.default, r == null ? void 0 : r[x], (Tt = t == null ? void 0 : t.classNames) == null ? void 0 : Tt[x]),
        "data-sonner-toast": "",
        "data-rich-colors": (St = t.richColors) != null ? St : tt,
        "data-styled": !(t.jsx || t.unstyled || s),
        "data-mounted": z,
        "data-promise": !!t.promise,
        "data-removed": D,
        "data-visible": J,
        "data-y-position": yt,
        "data-x-position": Wt,
        "data-index": d,
        "data-front": _,
        "data-swiping": it,
        "data-dismissible": P,
        "data-type": x,
        "data-invert": _t,
        "data-swipe-out": M,
        "data-expanded": !!($ || W && z),
        style: {
            "--index": d,
            "--toasts-before": d,
            "--z-index": Z.length - d,
            "--offset": `${D ? c : Y.current}px`,
            "--initial-height": W ? "auto" : `${y}px`,
            ...O,
            ...t.style
        },
        onPointerDown: (n)=>{
            ct || !P || (A.current = new Date(), p(Y.current), n.target.setPointerCapture(n.pointerId), n.target.tagName !== "BUTTON" && (N(!0), F.current = {
                x: n.clientX,
                y: n.clientY
            }));
        },
        onPointerUp: ()=>{
            var B, C, E, ut;
            if (M || !P) return;
            F.current = null;
            let n = Number(((B = l.current) == null ? void 0 : B.style.getPropertyValue("--swipe-amount").replace("px", "")) || 0), f = new Date().getTime() - ((C = A.current) == null ? void 0 : C.getTime()), g = Math.abs(n) / f;
            if (Math.abs(n) >= $5839b6730ea54521$var$fe || g > .11) {
                p(Y.current), (E = t.onDismiss) == null || E.call(t, t), L(), lt(!0);
                return;
            }
            (ut = l.current) == null || ut.style.setProperty("--swipe-amount", "0px"), N(!1);
        },
        onPointerMove: (n)=>{
            var kt;
            if (!F.current || !P) return;
            let f = n.clientY - F.current.y, g = n.clientX - F.current.x, C = (yt === "top" ? Math.min : Math.max)(0, f), E = n.pointerType === "touch" ? 10 : 2;
            Math.abs(C) > E ? (kt = l.current) == null || kt.style.setProperty("--swipe-amount", `${f}px`) : Math.abs(g) > E && (F.current = null);
        }
    }, $t && !t.jsx ? $5839b6730ea54521$var$o.default.createElement("button", {
        "aria-label": st,
        "data-disabled": ct,
        "data-close-button": !0,
        onClick: ct || !P ? ()=>{} : ()=>{
            var n;
            L(), (n = t.onDismiss) == null || n.call(t, t);
        },
        className: S(r == null ? void 0 : r.closeButton, (Rt = t == null ? void 0 : t.classNames) == null ? void 0 : Rt.closeButton)
    }, $5839b6730ea54521$var$o.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "12",
        height: "12",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, $5839b6730ea54521$var$o.default.createElement("line", {
        x1: "18",
        y1: "6",
        x2: "6",
        y2: "18"
    }), $5839b6730ea54521$var$o.default.createElement("line", {
        x1: "6",
        y1: "6",
        x2: "18",
        y2: "18"
    }))) : null, t.jsx || $5839b6730ea54521$var$o.default.isValidElement(t.title) ? t.jsx || t.title : $5839b6730ea54521$var$o.default.createElement($5839b6730ea54521$var$o.default.Fragment, null, x || t.icon || t.promise ? $5839b6730ea54521$var$o.default.createElement("div", {
        "data-icon": "",
        className: S(r == null ? void 0 : r.icon, (Et = t == null ? void 0 : t.classNames) == null ? void 0 : Et.icon)
    }, t.promise || t.type === "loading" && !t.icon ? t.icon || Ut() : null, t.type !== "loading" ? t.icon || (I == null ? void 0 : I[x]) || $5839b6730ea54521$var$Ht(x) : null) : null, $5839b6730ea54521$var$o.default.createElement("div", {
        "data-content": "",
        className: S(r == null ? void 0 : r.content, (Nt = t == null ? void 0 : t.classNames) == null ? void 0 : Nt.content)
    }, $5839b6730ea54521$var$o.default.createElement("div", {
        "data-title": "",
        className: S(r == null ? void 0 : r.title, (Pt = t == null ? void 0 : t.classNames) == null ? void 0 : Pt.title)
    }, t.title), t.description ? $5839b6730ea54521$var$o.default.createElement("div", {
        "data-description": "",
        className: S(at, Ft, r == null ? void 0 : r.description, (Bt = t == null ? void 0 : t.classNames) == null ? void 0 : Bt.description)
    }, t.description) : null), $5839b6730ea54521$var$o.default.isValidElement(t.cancel) ? t.cancel : t.cancel && $5839b6730ea54521$var$U(t.cancel) ? $5839b6730ea54521$var$o.default.createElement("button", {
        "data-button": !0,
        "data-cancel": !0,
        style: t.cancelButtonStyle || K,
        onClick: (n)=>{
            var f, g;
            $5839b6730ea54521$var$U(t.cancel) && P && ((g = (f = t.cancel).onClick) == null || g.call(f, n), L());
        },
        className: S(r == null ? void 0 : r.cancelButton, (Ct = t == null ? void 0 : t.classNames) == null ? void 0 : Ct.cancelButton)
    }, t.cancel.label) : null, $5839b6730ea54521$var$o.default.isValidElement(t.action) ? t.action : t.action && $5839b6730ea54521$var$U(t.action) ? $5839b6730ea54521$var$o.default.createElement("button", {
        "data-button": !0,
        "data-action": !0,
        style: t.actionButtonStyle || et,
        onClick: (n)=>{
            var f, g;
            $5839b6730ea54521$var$U(t.action) && (n.defaultPrevented || ((g = (f = t.action).onClick) == null || g.call(f, n), L()));
        },
        className: S(r == null ? void 0 : r.actionButton, (It = t == null ? void 0 : t.classNames) == null ? void 0 : It.actionButton)
    }, t.action.label) : null));
};
function $5839b6730ea54521$var$zt() {
    if (typeof window == "undefined" || typeof document == "undefined") return "ltr";
    let a = document.documentElement.getAttribute("dir");
    return a === "auto" || !a ? window.getComputedStyle(document.documentElement).direction : a;
}
function $5839b6730ea54521$var$he() {
    let [a, e] = $5839b6730ea54521$var$o.default.useState([]);
    return $5839b6730ea54521$var$o.default.useEffect(()=>$5839b6730ea54521$var$v.subscribe((t)=>{
            e((s)=>{
                if ("dismiss" in t && t.dismiss) return s.filter((u)=>u.id !== t.id);
                let m = s.findIndex((u)=>u.id === t.id);
                if (m !== -1) {
                    let u = [
                        ...s
                    ];
                    return u[m] = {
                        ...u[m],
                        ...t
                    }, u;
                } else return [
                    t,
                    ...s
                ];
            });
        }), []), {
        toasts: a
    };
}
var $5839b6730ea54521$var$be = (a)=>{
    let { invert: e, position: t = "bottom-right", hotkey: s = [
        "altKey",
        "KeyT"
    ], expand: m, closeButton: u, className: h, offset: b, theme: d = "light", richColors: Z, duration: $, style: V, visibleToasts: tt = $5839b6730ea54521$var$ie, toastOptions: i, dir: O = $5839b6730ea54521$var$zt(), gap: K = $5839b6730ea54521$var$ue, loadingIcon: et, icons: ot, containerAriaLabel: at = "Notifications", pauseWhenPageIsHidden: X, cn: nt = $5839b6730ea54521$var$pe } = a, [T, j] = $5839b6730ea54521$var$o.default.useState([]), W = $5839b6730ea54521$var$o.default.useMemo(()=>Array.from(new Set([
            t
        ].concat(T.filter((c)=>c.position).map((c)=>c.position)))), [
        T,
        t
    ]), [r, I] = $5839b6730ea54521$var$o.default.useState([]), [st, k] = $5839b6730ea54521$var$o.default.useState(!1), [S, z] = $5839b6730ea54521$var$o.default.useState(!1), [rt, D] = $5839b6730ea54521$var$o.default.useState(d !== "system" ? d : typeof window != "undefined" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"), H = $5839b6730ea54521$var$o.default.useRef(null), it = s.join("+").replace(/Key/g, "").replace(/Digit/g, ""), N = $5839b6730ea54521$var$o.default.useRef(null), M = $5839b6730ea54521$var$o.default.useRef(!1), lt = $5839b6730ea54521$var$o.default.useCallback((c)=>{
        var p;
        (p = T.find((y)=>y.id === c.id)) != null && p.delete || $5839b6730ea54521$var$v.dismiss(c.id), j((y)=>y.filter(({ id: R })=>R !== c.id));
    }, [
        T
    ]);
    return $5839b6730ea54521$var$o.default.useEffect(()=>$5839b6730ea54521$var$v.subscribe((c)=>{
            if (c.dismiss) {
                j((p)=>p.map((y)=>y.id === c.id ? {
                            ...y,
                            delete: !0
                        } : y));
                return;
            }
            setTimeout(()=>{
                $5839b6730ea54521$var$jt.default.flushSync(()=>{
                    j((p)=>{
                        let y = p.findIndex((R)=>R.id === c.id);
                        return y !== -1 ? [
                            ...p.slice(0, y),
                            {
                                ...p[y],
                                ...c
                            },
                            ...p.slice(y + 1)
                        ] : [
                            c,
                            ...p
                        ];
                    });
                });
            });
        }), []), $5839b6730ea54521$var$o.default.useEffect(()=>{
        if (d !== "system") {
            D(d);
            return;
        }
        d === "system" && (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? D("dark") : D("light")), typeof window != "undefined" && window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", ({ matches: c })=>{
            D(c ? "dark" : "light");
        });
    }, [
        d
    ]), $5839b6730ea54521$var$o.default.useEffect(()=>{
        T.length <= 1 && k(!1);
    }, [
        T
    ]), $5839b6730ea54521$var$o.default.useEffect(()=>{
        let c = (p)=>{
            var R, A;
            s.every((l)=>p[l] || p.code === l) && (k(!0), (R = H.current) == null || R.focus()), p.code === "Escape" && (document.activeElement === H.current || (A = H.current) != null && A.contains(document.activeElement)) && k(!1);
        };
        return document.addEventListener("keydown", c), ()=>document.removeEventListener("keydown", c);
    }, [
        s
    ]), $5839b6730ea54521$var$o.default.useEffect(()=>{
        if (H.current) return ()=>{
            N.current && (N.current.focus({
                preventScroll: !0
            }), N.current = null, M.current = !1);
        };
    }, [
        H.current
    ]), T.length ? $5839b6730ea54521$var$o.default.createElement("section", {
        "aria-label": `${at} ${it}`,
        tabIndex: -1
    }, W.map((c, p)=>{
        var A;
        let [y, R] = c.split("-");
        return $5839b6730ea54521$var$o.default.createElement("ol", {
            key: c,
            dir: O === "auto" ? $5839b6730ea54521$var$zt() : O,
            tabIndex: -1,
            ref: H,
            className: h,
            "data-sonner-toaster": !0,
            "data-theme": rt,
            "data-y-position": y,
            "data-x-position": R,
            style: {
                "--front-toast-height": `${((A = r[0]) == null ? void 0 : A.height) || 0}px`,
                "--offset": typeof b == "number" ? `${b}px` : b || $5839b6730ea54521$var$le,
                "--width": `${$5839b6730ea54521$var$ce}px`,
                "--gap": `${K}px`,
                ...V
            },
            onBlur: (l)=>{
                M.current && !l.currentTarget.contains(l.relatedTarget) && (M.current = !1, N.current && (N.current.focus({
                    preventScroll: !0
                }), N.current = null));
            },
            onFocus: (l)=>{
                l.target instanceof HTMLElement && l.target.dataset.dismissible === "false" || M.current || (M.current = !0, N.current = l.relatedTarget);
            },
            onMouseEnter: ()=>k(!0),
            onMouseMove: ()=>k(!0),
            onMouseLeave: ()=>{
                S || k(!1);
            },
            onPointerDown: (l)=>{
                l.target instanceof HTMLElement && l.target.dataset.dismissible === "false" || z(!0);
            },
            onPointerUp: ()=>z(!1)
        }, T.filter((l)=>!l.position && p === 0 || l.position === c).map((l, _)=>{
            var J, x;
            return $5839b6730ea54521$var$o.default.createElement($5839b6730ea54521$var$ge, {
                key: l.id,
                icons: ot,
                index: _,
                toast: l,
                defaultRichColors: Z,
                duration: (J = i == null ? void 0 : i.duration) != null ? J : $,
                className: i == null ? void 0 : i.className,
                descriptionClassName: i == null ? void 0 : i.descriptionClassName,
                invert: e,
                visibleToasts: tt,
                closeButton: (x = i == null ? void 0 : i.closeButton) != null ? x : u,
                interacting: S,
                position: c,
                style: i == null ? void 0 : i.style,
                unstyled: i == null ? void 0 : i.unstyled,
                classNames: i == null ? void 0 : i.classNames,
                cancelButtonStyle: i == null ? void 0 : i.cancelButtonStyle,
                actionButtonStyle: i == null ? void 0 : i.actionButtonStyle,
                removeToast: lt,
                toasts: T.filter((P)=>P.position == l.position),
                heights: r.filter((P)=>P.position == l.position),
                setHeights: I,
                expandByDefault: m,
                gap: K,
                loadingIcon: et,
                expanded: st,
                pauseWhenPageIsHidden: X,
                cn: nt
            });
        }));
    })) : null;
};

});


parcelRegister("7RI9h", function(module, exports) {

$parcel$export(module.exports, "useSaveQueueAction", function () { return $f1960b1a440f0c92$export$cec64d432b9cda69; });
$parcel$export(module.exports, "SaveQueueProcessor", function () { return $f1960b1a440f0c92$export$5c14b3477b374af4; });

var $61Ea1 = parcelRequire("61Ea1");

var $hxM7m = parcelRequire("hxM7m");

var $lJ1OS = parcelRequire("lJ1OS");

var $7zCyL = parcelRequire("7zCyL");

var $jbmdS = parcelRequire("jbmdS");

var $lfqR9 = parcelRequire("lfqR9");
// Initial state
const $f1960b1a440f0c92$var$initialContext = {
    queue: [],
    processingEvent: null,
    isProcessing: false,
    activeToasts: new Set()
};
const $f1960b1a440f0c92$export$a59b939367be8a7 = (0, $hxM7m.createStore)({
    context: $f1960b1a440f0c92$var$initialContext,
    on: {
        addToQueue: {
            queue: (state, event)=>{
                const newEvent = {
                    ...event.saveEvent,
                    timestamp: event.saveEvent.timestamp || Date.now()
                };
                // Only remove if the last item has the same ID
                const queue = [
                    ...state.queue
                ];
                if (queue.length > 0 && queue[queue.length - 1].saveId === newEvent.saveId) queue.pop();
                // Add the new event to the end
                return [
                    ...queue,
                    newEvent
                ];
            }
        },
        removeFromQueue: {
            queue: (state, event)=>state.queue.filter((item)=>item.saveId !== event.saveId)
        },
        startProcessing: {
            isProcessing: ()=>true,
            processingEvent: (state)=>{
                if (state.queue.length === 0) return null;
                // Sort by timestamp to process in order
                const sortedQueue = [
                    ...state.queue
                ].sort((a, b)=>(a.timestamp || 0) - (b.timestamp || 0));
                return sortedQueue[0];
            },
            queue: (state)=>{
                const sortedQueue = [
                    ...state.queue
                ].sort((a, b)=>(a.timestamp || 0) - (b.timestamp || 0));
                return sortedQueue.slice(1);
            }
        },
        finishProcessing: {
            isProcessing: ()=>false,
            processingEvent: ()=>null
        },
        addActiveToast: {
            activeToasts: (state, event)=>new Set([
                    ...Array.from(state.activeToasts),
                    event.toastId
                ])
        },
        removeActiveToast: {
            activeToasts: (state, event)=>{
                const newSet = new Set(state.activeToasts);
                newSet.delete(event.toastId);
                return newSet;
            }
        },
        reset: {
            queue: ()=>[],
            processingEvent: ()=>null,
            isProcessing: ()=>false,
            activeToasts: ()=>new Set()
        }
    }
});
const $f1960b1a440f0c92$export$30665681cb9a2b60 = (saveEvent)=>{
    $f1960b1a440f0c92$export$a59b939367be8a7.send({
        type: "addToQueue",
        saveEvent: {
            ...saveEvent,
            timestamp: saveEvent.timestamp || Date.now()
        }
    });
    // Start processing if not already processing
    const state = $f1960b1a440f0c92$export$d5f148e6ae9a2a68();
    if (!state.isProcessing) $f1960b1a440f0c92$export$5653c93e392575be();
};
const $f1960b1a440f0c92$export$127439b6425a90f6 = (saveId)=>$f1960b1a440f0c92$export$a59b939367be8a7.send({
        type: "removeFromQueue",
        saveId: saveId
    });
const $f1960b1a440f0c92$export$8d3783709eddecb8 = ()=>$f1960b1a440f0c92$export$a59b939367be8a7.send({
        type: "startProcessing"
    });
const $f1960b1a440f0c92$export$5c3e2679f5162c9c = ()=>$f1960b1a440f0c92$export$a59b939367be8a7.send({
        type: "finishProcessing"
    });
const $f1960b1a440f0c92$export$6ee9815116c0ed65 = (toastId)=>$f1960b1a440f0c92$export$a59b939367be8a7.send({
        type: "addActiveToast",
        toastId: toastId
    });
const $f1960b1a440f0c92$export$752e4b45580b76bd = (toastId)=>$f1960b1a440f0c92$export$a59b939367be8a7.send({
        type: "removeActiveToast",
        toastId: toastId
    });
const $f1960b1a440f0c92$export$b1478c2df324f3b4 = ()=>$f1960b1a440f0c92$export$a59b939367be8a7.send({
        type: "reset"
    });
const $f1960b1a440f0c92$export$d5f148e6ae9a2a68 = ()=>$f1960b1a440f0c92$export$a59b939367be8a7.getSnapshot().context;
const $f1960b1a440f0c92$export$5653c93e392575be = async ()=>{
    const state = $f1960b1a440f0c92$export$d5f148e6ae9a2a68();
    if (state.isProcessing || state.queue.length === 0) return;
    $f1960b1a440f0c92$export$8d3783709eddecb8();
    const currentState = $f1960b1a440f0c92$export$d5f148e6ae9a2a68();
    const currentEvent = currentState.processingEvent;
    if (!currentEvent) {
        $f1960b1a440f0c92$export$5c3e2679f5162c9c();
        return;
    }
    // If confirmation is required, show confirmation toast
    if (currentEvent.requireConfirmation) {
        const toastId = Math.random().toString(36).substr(2, 9);
        $f1960b1a440f0c92$export$6ee9815116c0ed65(toastId);
        (0, $7zCyL.toast)(currentEvent.confirmationMessage || "Confirm save?", {
            id: toastId,
            action: {
                label: "Save",
                onClick: ()=>{
                    $f1960b1a440f0c92$export$752e4b45580b76bd(toastId);
                    $f1960b1a440f0c92$var$executeCurrentSave();
                }
            },
            cancel: currentEvent.showCancelButton ? {
                label: "Cancel",
                onClick: ()=>{
                    if (currentEvent.onCancel) currentEvent.onCancel();
                    $f1960b1a440f0c92$export$127439b6425a90f6(currentEvent.saveId);
                    $f1960b1a440f0c92$export$752e4b45580b76bd(toastId);
                    $f1960b1a440f0c92$export$5c3e2679f5162c9c();
                    // Process next after a short delay
                    setTimeout($f1960b1a440f0c92$export$5653c93e392575be, 50);
                }
            } : undefined,
            onDismiss: ()=>{
                if (currentEvent.onCancel) currentEvent.onCancel();
                $f1960b1a440f0c92$export$127439b6425a90f6(currentEvent.saveId);
                $f1960b1a440f0c92$export$752e4b45580b76bd(toastId);
                $f1960b1a440f0c92$export$5c3e2679f5162c9c();
                // Process next after a short delay
                setTimeout($f1960b1a440f0c92$export$5653c93e392575be, 50);
            }
        });
    } else // Execute the save directly if no confirmation needed
    $f1960b1a440f0c92$var$executeCurrentSave();
};
// Execute the current save operation
const $f1960b1a440f0c92$var$executeCurrentSave = async ()=>{
    const state = $f1960b1a440f0c92$export$d5f148e6ae9a2a68();
    const currentEvent = state.processingEvent;
    if (!currentEvent) {
        $f1960b1a440f0c92$export$5c3e2679f5162c9c();
        return;
    }
    // Show loading toast
    const toastId = Math.random().toString(36).substr(2, 9);
    $f1960b1a440f0c92$export$6ee9815116c0ed65(toastId);
    (0, $7zCyL.toast).loading(currentEvent.loadingMessage || "Saving...", {
        id: toastId
    });
    try {
        // Call the save function
        await currentEvent.onSave();
        // Show success toast
        (0, $7zCyL.toast).success(currentEvent.successMessage || "Saved successfully!", {
            id: toastId
        });
        // Call onSuccess callback if provided
        if (currentEvent.onSuccess) currentEvent.onSuccess();
    } catch (error) {
        // Show error toast with retry option
        (0, $7zCyL.toast).error(currentEvent.errorMessage || "Failed to save. Please try again.", {
            id: toastId,
            action: {
                label: "Retry",
                onClick: ()=>{
                    if (currentEvent.onRetry) currentEvent.onRetry();
                    // Add back to queue
                    $f1960b1a440f0c92$export$30665681cb9a2b60(currentEvent);
                }
            }
        });
    } finally{
        $f1960b1a440f0c92$export$752e4b45580b76bd(toastId);
        $f1960b1a440f0c92$export$5c3e2679f5162c9c();
        // Process next after a short delay
        setTimeout($f1960b1a440f0c92$export$5653c93e392575be, 50);
    }
};
const $f1960b1a440f0c92$export$e4c91dba2eaa7bb3 = ()=>(0, $lJ1OS.useSelector)($f1960b1a440f0c92$export$a59b939367be8a7, (state)=>state.context.queue.length > 0 || state.context.isProcessing);
const $f1960b1a440f0c92$export$2b8943eac06d3a08 = ()=>(0, $lJ1OS.useSelector)($f1960b1a440f0c92$export$a59b939367be8a7, (state)=>state.context.queue);
const $f1960b1a440f0c92$export$eb3d433470a446b2 = ()=>(0, $lJ1OS.useSelector)($f1960b1a440f0c92$export$a59b939367be8a7, (state)=>state.context.isProcessing);
const $f1960b1a440f0c92$export$96b9abfc5d7e461a = ()=>(0, $lJ1OS.useSelector)($f1960b1a440f0c92$export$a59b939367be8a7, (state)=>state.context.processingEvent);
const $f1960b1a440f0c92$export$cec64d432b9cda69 = ()=>{
    return (saveEvent)=>{
        $f1960b1a440f0c92$export$30665681cb9a2b60({
            ...saveEvent,
            saveId: saveEvent.saveId,
            timestamp: Date.now()
        });
    };
};
const $f1960b1a440f0c92$export$5c14b3477b374af4 = ({ toasterProps: toasterProps = {
    position: "top-center",
    visibleToasts: 3
} })=>{
    const queue = $f1960b1a440f0c92$export$2b8943eac06d3a08();
    const isProcessing = $f1960b1a440f0c92$export$eb3d433470a446b2();
    (0, $jbmdS.useEffect)(()=>{
        if (queue.length > 0 && !isProcessing) $f1960b1a440f0c92$export$5653c93e392575be();
    }, [
        queue,
        isProcessing
    ]);
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $lfqR9.Toaster), {
        ...toasterProps
    });
};

});

parcelRegister("3tNhL", function(module, exports) {

$parcel$export(module.exports, "useIsFetching", function () { return $288a4f95a7d7d85b$export$625b2ff71316bcd3; });

var $jbmdS = parcelRequire("jbmdS");

var $7jCK0 = parcelRequire("7jCK0");
var $dI9XE = parcelRequire("dI9XE");

var $lK3dc = parcelRequire("lK3dc");

var $9d62S = parcelRequire("9d62S");
"use client";
function $288a4f95a7d7d85b$export$625b2ff71316bcd3(arg1, arg2, arg3) {
    const [filters, options = {}] = (0, $dI9XE.parseFilterArgs)(arg1, arg2, arg3);
    const queryClient = (0, $9d62S.useQueryClient)({
        context: options.context
    });
    const queryCache = queryClient.getQueryCache();
    return (0, $lK3dc.useSyncExternalStore)($jbmdS.useCallback((onStoreChange)=>queryCache.subscribe((0, $7jCK0.notifyManager).batchCalls(onStoreChange)), [
        queryCache
    ]), ()=>queryClient.isFetching(filters), ()=>queryClient.isFetching(filters));
}

});


parcelRegister("1m9MV", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $0fcf703d6c7a0e59$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");
var $gbTjE = parcelRequire("gbTjE");

var $4iw5i = parcelRequire("4iw5i");

var $1BTI2 = parcelRequire("1BTI2");

var $8kZ1o = parcelRequire("8kZ1o");
const $0fcf703d6c7a0e59$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/")({
    beforeLoad: async ({ context: context })=>{
        // Use the context updated in the root route
        if ((0, $8kZ1o.usingNewLogin)() && !context.loaded) return;
        if (!(0, $1BTI2.default).initialized || !(0, $1BTI2.default).authenticated) throw (0, $gbTjE.redirect)({
            to: "/login"
        });
        else throw (0, $gbTjE.redirect)({
            to: "/projects"
        });
    },
    pendingComponent: (0, $4iw5i.default),
    component: $0fcf703d6c7a0e59$var$LayoutComponent
});
function $0fcf703d6c7a0e59$var$LayoutComponent() {
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $4iw5i.default), {});
}

});

parcelRegister("iXYDh", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $dcecc50a6753d864$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");

var $9bFXg = parcelRequire("9bFXg");

var $4iw5i = parcelRequire("4iw5i");

var $1BTI2 = parcelRequire("1BTI2");

var $8kZ1o = parcelRequire("8kZ1o");
const $dcecc50a6753d864$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_public/sign-up")({
    loader: async ({ location: location, context: context })=>{
        try {
            await (0, $1BTI2.default).clearCache();
            await (0, $1BTI2.default).signup();
        } catch (error) {
            var _error$response, _error$response$data;
            console.log("error", error);
            throw (error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.message) || "An error occurred";
        }
        if (!context.organization) window.location.href = "/register-details";
        else window.location.href = (0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "projectList") ? "/projects" : "/timesheets";
    },
    component: $dcecc50a6753d864$var$Wrapper,
    pendingComponent: (0, $4iw5i.default),
    errorComponent: ({ error: error, reset: reset })=>{
        return /*#__PURE__*/ (0, $61Ea1.jsx)($dcecc50a6753d864$var$Wrapper, {
            error: error
        });
    }
});
function $dcecc50a6753d864$var$Wrapper({ error: error }) {
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $9bFXg.default), {
            ...$dcecc50a6753d864$export$e7b0ac011bb776c6.useParams(),
            ...$dcecc50a6753d864$export$e7b0ac011bb776c6.useSearch(),
            error: error
        })
    });
}

});
parcelRegister("9bFXg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b05af7ae0b93fdc$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("02LyB");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

parcelRequire("1BTI2");

var $kqlQp = parcelRequire("kqlQp");
var $6UBLf = parcelRequire("6UBLf");
parcelRequire("lCpBr");
parcelRequire("fEtu5");
var $zyiwQ = parcelRequire("zyiwQ");
parcelRequire("8kZ1o");

var $6b05af7ae0b93fdc$export$2e2bcd8739ae039 = (0, $1EEMt.observer)((props)=>{
    const { error: error } = props;
    const navigate = (0, $6UBLf.useNavigate)();
    const [status, setStatus] = (0, $jbmdS.useState)(error ? "error" : "success");
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "flex items-center justify-center text-center w-full h-full",
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("section", {
            className: "flex flex-col items-center justify-center w-[350px]",
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsxs)("header", {
                    className: "flex items-center flex-col justify-center",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            className: "logo2 s75 size-[10em] flex items-center justify-center",
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)("img", {
                                src: new URL((parcelRequire("hw9H4")))
                            })
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)("h1", {
                            style: {
                                fontSize: "5em"
                            },
                            children: "coincraft"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    children: [
                        status === "success" && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $zyiwQ.SuccessAlert), {
                            children: "Login successful! redirecting..."
                        }),
                        status === "error" && /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $zyiwQ.ErrorAlert), {
                                    children: [
                                        /*#__PURE__*/ (0, $61Ea1.jsx)("p", {
                                            children: `Sorry, we couldn't log you in.`
                                        }),
                                        /*#__PURE__*/ (0, $61Ea1.jsx)("p", {
                                            children: error
                                        })
                                    ]
                                }),
                                " ",
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqlQp.Link), {
                                    to: "/login",
                                    children: "Back to login"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
});

});


parcelRegister("k9jTK", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $eab4154a37633c67$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");

var $9bFXg = parcelRequire("9bFXg");

var $4iw5i = parcelRequire("4iw5i");

var $1BTI2 = parcelRequire("1BTI2");

var $8kZ1o = parcelRequire("8kZ1o");

var $6Q5sp = parcelRequire("6Q5sp");

var $epkc5 = parcelRequire("epkc5");
const $eab4154a37633c67$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_public/sign-in")({
    loader: async ({ location: location, context: context })=>{
        var _clerk$session, _clerk$session$getTok;
        if (usingNewLogin() && !context.loaded) return;
        const encodedToken = await ((0, $6Q5sp.clerk) === null || (0, $6Q5sp.clerk) === void 0 ? void 0 : (_clerk$session = (0, $6Q5sp.clerk).session) === null || _clerk$session === void 0 ? void 0 : (_clerk$session$getTok = _clerk$session.getToken) === null || _clerk$session$getTok === void 0 ? void 0 : _clerk$session$getTok.call(_clerk$session, {
            template: "coincraft"
        }));
        const token = (0, $epkc5.jwtDecode)(encodedToken);
        if (!(token !== null && token !== void 0 && token.userId) || !(token !== null && token !== void 0 && token.organisationId)) {
            window.location.href = "/sign-up";
            return;
        }
        try {
            await (0, $1BTI2.default).clearCache();
            await (0, $1BTI2.default).login({
                token: token
            });
            window.location.href = (0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "projectList") ? "/projects" : "/timesheets";
        } catch (error) {
            var _error$response, _error$response$data;
            console.log("error", error);
            throw (error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.message) || "An error occurred";
        }
    },
    component: $eab4154a37633c67$var$Wrapper,
    pendingComponent: (0, $4iw5i.default),
    errorComponent: ({ error: error, reset: reset })=>{
        return /*#__PURE__*/ (0, $61Ea1.jsx)($eab4154a37633c67$var$Wrapper, {
            error: error
        });
    }
});
function $eab4154a37633c67$var$Wrapper({ error: error }) {
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $9bFXg.default), {
            ...$eab4154a37633c67$export$e7b0ac011bb776c6.useParams(),
            ...$eab4154a37633c67$export$e7b0ac011bb776c6.useSearch(),
            error: error
        })
    });
}

});
parcelRegister("epkc5", function(module, exports) {

$parcel$export(module.exports, "jwtDecode", function () { return $a7d3109c19cf6a85$export$fa1e2fb699b7861e; });
class $a7d3109c19cf6a85$export$b9721ef022f71a68 extends Error {
}
$a7d3109c19cf6a85$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
function $a7d3109c19cf6a85$var$b64DecodeUnicode(str) {
    return decodeURIComponent(atob(str).replace(/(.)/g, (m, p)=>{
        let code = p.charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) code = "0" + code;
        return "%" + code;
    }));
}
function $a7d3109c19cf6a85$var$base64UrlDecode(str) {
    let output = str.replace(/-/g, "+").replace(/_/g, "/");
    switch(output.length % 4){
        case 0:
            break;
        case 2:
            output += "==";
            break;
        case 3:
            output += "=";
            break;
        default:
            throw new Error("base64 string is not of the correct length");
    }
    try {
        return $a7d3109c19cf6a85$var$b64DecodeUnicode(output);
    } catch (err) {
        return atob(output);
    }
}
function $a7d3109c19cf6a85$export$fa1e2fb699b7861e(token, options) {
    if (typeof token !== "string") throw new $a7d3109c19cf6a85$export$b9721ef022f71a68("Invalid token specified: must be a string");
    options || (options = {});
    const pos = options.header === true ? 0 : 1;
    const part = token.split(".")[pos];
    if (typeof part !== "string") throw new $a7d3109c19cf6a85$export$b9721ef022f71a68(`Invalid token specified: missing part #${pos + 1}`);
    let decoded;
    try {
        decoded = $a7d3109c19cf6a85$var$base64UrlDecode(part);
    } catch (e) {
        throw new $a7d3109c19cf6a85$export$b9721ef022f71a68(`Invalid token specified: invalid base64 for part #${pos + 1} (${e.message})`);
    }
    try {
        return JSON.parse(decoded);
    } catch (e) {
        throw new $a7d3109c19cf6a85$export$b9721ef022f71a68(`Invalid token specified: invalid json for part #${pos + 1} (${e.message})`);
    }
}

});


parcelRegister("37AX6", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $245eb084ac2640b5$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");

var $9Q2mE = parcelRequire("9Q2mE");

var $5PXcS = parcelRequire("5PXcS");
const $245eb084ac2640b5$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_public/reset-password")({
    component: $245eb084ac2640b5$var$Wrapper,
    errorComponent: ({ error: error, reset: reset })=>{
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    }
});
function $245eb084ac2640b5$var$Wrapper() {
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $9Q2mE.default), {
            ...$245eb084ac2640b5$export$e7b0ac011bb776c6.useParams(),
            ...$245eb084ac2640b5$export$e7b0ac011bb776c6.useSearch()
        })
    });
}

});
parcelRegister("9Q2mE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $729acde1226b2c3c$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $9mNEQ = parcelRequire("9mNEQ");

var $4iw5i = parcelRequire("4iw5i");

var $iKbxs = parcelRequire("iKbxs");

var $1BTI2 = parcelRequire("1BTI2");

var $iOQGT = parcelRequire("iOQGT");

var $6UBLf = parcelRequire("6UBLf");

var $8kZ1o = parcelRequire("8kZ1o");

var $3H03w = parcelRequire("3H03w");

var $729acde1226b2c3c$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ token: token, redirect: redirect })=>{
    const navigate = (0, $6UBLf.useNavigate)();
    const [password, setPassword] = (0, $jbmdS.useState)("");
    const [resetState, setResetState] = (0, $jbmdS.useState)("idle");
    const [validToken, setValidToken] = (0, $jbmdS.useState)(null);
    (0, $jbmdS.useEffect)(()=>{
        (0, $iOQGT.makeRequest)({
            path: "https://api.coincraft.co/api/v1.5/user/verify-token",
            method: "post",
            data: {
                token: token
            }
        }).then((response)=>{
            setValidToken(true);
        }).catch((error)=>{
            $iKbxs.captureException(error);
            (0, $3H03w.default).captureException(error);
            setValidToken(false);
            (0, $9mNEQ.default)(1000).then(()=>{
                navigate({
                    to: "/login"
                });
            });
        });
    }, [
        token,
        navigate
    ]);
    const handleSubmit = (event)=>{
        event.preventDefault();
        setResetState("pending");
        (0, $iOQGT.makeRequest)({
            path: "https://api.coincraft.co/api/v1.5/user/reset-password",
            method: "post",
            data: {
                password: password,
                token: token
            }
        }).then((response)=>{
            (0, $1BTI2.default).saveLoginResponse(response);
            navigate({
                to: redirect || ((0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "projectList") ? "/projects" : "/timesheets")
            });
        }).catch((error)=>{
            $iKbxs.captureException(error);
            (0, $3H03w.default).captureException(error);
            navigate({
                to: "/login"
            });
        });
    };
    if (validToken === null) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $4iw5i.default), {});
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "flex items-center justify-center text-center w-full h-full",
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("section", {
            className: "flex flex-col items-center justify-center w-[350px]",
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsxs)("header", {
                    className: "flex items-center flex-col justify-center",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            className: "logo2 s75 size-[10em] flex items-center justify-center",
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)("img", {
                                src: new URL((parcelRequire("hw9H4"))),
                                alt: "Coincraft Logo"
                            })
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)("h1", {
                            style: {
                                fontSize: "3em"
                            },
                            children: validToken ? "Reset Password" : "Link expired..."
                        })
                    ]
                }),
                validToken && /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    className: "body w-full",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("h4", {
                            style: {
                                margin: "0em -2em 1em"
                            },
                            children: "Please enter your new password."
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("form", {
                            name: "forgottenPasswordForm",
                            className: "no-margin",
                            onSubmit: handleSubmit,
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("fieldset", {
                                    children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        className: "form-group no-margin",
                                        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                            className: "input-group input-group-lg",
                                            children: [
                                                /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                                    className: "input-group-addon",
                                                    children: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                                        className: "eicon-user"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
                                                    value: password || "",
                                                    onChange: (e)=>setPassword(e.target.value),
                                                    type: "password",
                                                    className: "form-control input-lg h-10 py-2 input-base w-full focus:outline-none hover:border-[#618fb0]",
                                                    placeholder: "Your New Password"
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                    className: "form-actions mt-5",
                                    children: /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                                        type: "submit",
                                        className: "btn btn-block btn-lg btn-primary w-full py-2.5",
                                        children: "Set Password & Login"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
});

});


parcelRegister("93uGj", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $697c319320494540$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");

var $cJ8NP = parcelRequire("cJ8NP");

var $5PXcS = parcelRequire("5PXcS");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");
const $697c319320494540$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_public/register-details")({
    loader: async ({ location: location, context: context })=>{
        if (context.organization) window.location.href = (0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "projectList") ? "/projects" : "/timesheets";
    },
    component: (0, $cJ8NP.default),
    errorComponent: ({ error: error, reset: reset })=>{
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    }
});

});
parcelRegister("cJ8NP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9440840f7306a39e$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $1BTI2 = parcelRequire("1BTI2");

var $ebylM = parcelRequire("ebylM");

var $iKbxs = parcelRequire("iKbxs");

var $iOQGT = parcelRequire("iOQGT");

var $ewAM3 = parcelRequire("ewAM3");

var $6UBLf = parcelRequire("6UBLf");

var $8kZ1o = parcelRequire("8kZ1o");

var $3H03w = parcelRequire("3H03w");

var $9440840f7306a39e$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(()=>{
    const navigate = (0, $6UBLf.useNavigate)();
    const [firstName, setFirstName] = (0, $jbmdS.useState)("");
    const [lastName, setLastName] = (0, $jbmdS.useState)("");
    const [organisationName, setOrganisationName] = (0, $jbmdS.useState)("");
    const [countryCode, setCountryCode] = (0, $jbmdS.useState)(null);
    const [industry, setIndustry] = (0, $jbmdS.useState)("");
    const [otherIndustry, setOtherIndustry] = (0, $jbmdS.useState)("");
    const [companySize, setCompanySize] = (0, $jbmdS.useState)("");
    const [phoneNumber, setPhoneNumber] = (0, $jbmdS.useState)("");
    const [referralSource, setReferralSource] = (0, $jbmdS.useState)("");
    const [otherReferralSource, setOtherReferralSource] = (0, $jbmdS.useState)("");
    const [submitState, setSubmitState] = (0, $jbmdS.useState)("idle");
    (0, $jbmdS.useEffect)(()=>{
        fetch("https://cloudflare.com/cdn-cgi/trace").then((response)=>response.text()).then((data)=>{
            // Parse the response which is in format key1=value1\nkey2=value2
            const parsedData = Object.fromEntries(data.trim().split("\n").map((line)=>line.split("=")));
            // Use the loc field which contains the country code
            if (!countryCode && parsedData.loc) setCountryCode(parsedData.loc.toLowerCase());
        });
    }, []);
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "flex items-center justify-center text-center w-full h-full",
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("section", {
            className: "flex items-center justify-center flex-col w-[350px]",
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsxs)("header", {
                    className: "flex items-center justify-center flex-col w-full",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            className: "logo2 s75 size-[10em] flex items-center justify-center",
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)("img", {
                                src: new URL((parcelRequire("hw9H4"))),
                                alt: "Coincraft Logo"
                            })
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)("h1", {
                            style: {
                                fontSize: "5em"
                            },
                            children: "coincraft"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    className: "body w-full",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("p", {
                            style: {
                                marginBottom: "1.5em"
                            },
                            children: "We just need to know a few more things so we can finish setting up your account."
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)("form", {
                            className: "no-margin",
                            noValidate: true,
                            style: {
                                textAlign: "left"
                            },
                            children: /*#__PURE__*/ (0, $61Ea1.jsxs)("fieldset", {
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                        className: "form-group space-y-6",
                                        children: [
                                            !(0, $8kZ1o.usingNewLogin)() ? /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                                        className: "control-group space-y-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $61Ea1.jsx)("label", {
                                                                className: "control-label",
                                                                htmlFor: "user-details-form__first-name",
                                                                children: "What's your name?"
                                                            }),
                                                            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                                                className: "controls form-group flex items-center gap-3.5",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                                        className: "user_details_form__name-input first w-full",
                                                                        children: /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
                                                                            id: "user-details-form__first-name",
                                                                            value: firstName || "",
                                                                            onChange: (e)=>{
                                                                                setFirstName(e.target.value);
                                                                            },
                                                                            type: "text",
                                                                            className: "form-control h-10 py-2 input-base w-full focus:outline-none hover:border-[#618fb0]",
                                                                            placeholder: "First name"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                                        className: "user_details_form__name-input w-full",
                                                                        children: /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
                                                                            id: "user-details-form__last-name",
                                                                            value: lastName || "",
                                                                            onChange: (e)=>{
                                                                                setLastName(e.target.value);
                                                                            },
                                                                            type: "text",
                                                                            className: "form-control h-10 py-2 input-base w-full focus:outline-none hover:border-[#618fb0]",
                                                                            placeholder: "Last name"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                        className: "control-group",
                                                        children: submitState === "error" && (!firstName.length || !lastName.length) ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                                            className: "popover error-message-popover bottom",
                                                            style: {
                                                                marginBottom: "20px",
                                                                color: "red"
                                                            },
                                                            children: [
                                                                !firstName.length ? /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                                    className: "arrow",
                                                                    style: {
                                                                        left: "25%",
                                                                        borderBottomColor: "red"
                                                                    }
                                                                }) : null,
                                                                !lastName.length ? /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                                    className: "arrow",
                                                                    style: {
                                                                        left: "75%",
                                                                        borderBottomColor: "red"
                                                                    }
                                                                }) : null,
                                                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                                    className: "popover-content",
                                                                    style: {
                                                                        color: "red"
                                                                    },
                                                                    children: "Please enter your name."
                                                                })
                                                            ]
                                                        }) : null
                                                    })
                                                ]
                                            }) : null,
                                            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                                className: "control-group space-y-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $61Ea1.jsx)("label", {
                                                        className: "control-label",
                                                        htmlFor: "user-details-form__organisation-name",
                                                        children: "What is your organisation called?"
                                                    }),
                                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                        className: "controls form-group",
                                                        children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                            children: /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
                                                                value: organisationName || "",
                                                                onChange: (e)=>{
                                                                    setOrganisationName(e.target.value);
                                                                },
                                                                type: "text",
                                                                id: "user-details-form__organisation-name",
                                                                className: "form-control input-lg login-widget__email-input input-base w-full h-10 py-2 focus:outline-none hover:border-[#618fb0]",
                                                                placeholder: "Organisation name"
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                className: "control-group",
                                                children: submitState === "error" && !organisationName.length ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                                    className: "popover error-message-popover bottom",
                                                    style: {
                                                        marginBottom: "20px",
                                                        color: "red"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                            className: "arrow",
                                                            style: {
                                                                borderBottomColor: "red"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                            className: "popover-content",
                                                            style: {
                                                                color: "red"
                                                            },
                                                            children: "Please enter your organisation's name."
                                                        })
                                                    ]
                                                }) : null
                                            }),
                                            !(0, $8kZ1o.usingNewLogin)() ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                                className: "control-group input-group input-group-lg",
                                                children: [
                                                    /*#__PURE__*/ (0, $61Ea1.jsx)("label", {
                                                        className: "control-label",
                                                        htmlFor: "user-details-form__phone-number",
                                                        children: "What's your phone number?"
                                                    }),
                                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                        className: "controls form-group",
                                                        children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                            children: /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
                                                                value: phoneNumber || "",
                                                                onChange: (e)=>{
                                                                    setPhoneNumber(e.target.value);
                                                                },
                                                                type: "tel",
                                                                id: "user-details-form__phone-number",
                                                                className: "form-control h-10 py-2 input-base w-full focus:outline-none hover:border-[#618fb0]",
                                                                placeholder: "Phone number"
                                                            })
                                                        })
                                                    })
                                                ]
                                            }) : null,
                                            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                                className: "control-group space-y-2",
                                                style: {
                                                    clear: "both"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $61Ea1.jsx)("label", {
                                                        className: "control-label",
                                                        htmlFor: "user-details-form__country",
                                                        children: "Which country are you from?"
                                                    }),
                                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                        className: "controls form-group",
                                                        children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                            children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                                className: "user-details-form__country",
                                                                children: /*#__PURE__*/ (0, $61Ea1.jsx)($9440840f7306a39e$var$CountrySelector, {
                                                                    value: countryCode,
                                                                    onChange: (countryCode)=>{
                                                                        setCountryCode(countryCode);
                                                                    },
                                                                    variant: "secondary"
                                                                })
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                className: "control-group",
                                                style: {
                                                    clear: "both"
                                                },
                                                children: submitState === "error" && !countryCode ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                                    className: "popover error-message-popover bottom",
                                                    style: {
                                                        marginBottom: "20px"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                            className: "arrow"
                                                        }),
                                                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                            className: "popover-content",
                                                            children: "Please enter your country."
                                                        })
                                                    ]
                                                }) : null
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                        className: "control-group mb-6",
                                        style: {
                                            clear: "both"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $61Ea1.jsx)("label", {
                                                className: "control-label mb-2",
                                                htmlFor: "user-details-form__industry",
                                                children: "Industry"
                                            }),
                                            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                                className: "controls form-group",
                                                children: [
                                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("select", {
                                                            id: "user-details-form__industry",
                                                            value: industry,
                                                            onChange: (e)=>{
                                                                setIndustry(e.target.value);
                                                                if (e.target.value === "other") setOtherIndustry("");
                                                            },
                                                            className: "form-control h-10 py-2 input-base w-full focus:outline-none hover:border-[#618fb0]",
                                                            children: [
                                                                /*#__PURE__*/ (0, $61Ea1.jsx)("option", {
                                                                    value: "",
                                                                    children: "Select your industry"
                                                                }),
                                                                /*#__PURE__*/ (0, $61Ea1.jsx)("option", {
                                                                    value: "architecture",
                                                                    children: "Architecture"
                                                                }),
                                                                /*#__PURE__*/ (0, $61Ea1.jsx)("option", {
                                                                    value: "engineering",
                                                                    children: "Engineering"
                                                                }),
                                                                /*#__PURE__*/ (0, $61Ea1.jsx)("option", {
                                                                    value: "marketing",
                                                                    children: "Marketing"
                                                                }),
                                                                /*#__PURE__*/ (0, $61Ea1.jsx)("option", {
                                                                    value: "other",
                                                                    children: "Other"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    industry === "other" && /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                        className: "mt-2",
                                                        children: /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
                                                            type: "text",
                                                            id: "user-details-form__other-industry",
                                                            value: otherIndustry,
                                                            onChange: (e)=>setOtherIndustry(e.target.value),
                                                            placeholder: "Please specify your industry",
                                                            className: "form-control h-10 py-2 input-base w-full focus:outline-none hover:border-[#618fb0]"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                        className: "control-group mb-6",
                                        children: [
                                            /*#__PURE__*/ (0, $61Ea1.jsx)("label", {
                                                className: "control-label mb-2",
                                                htmlFor: "user-details-form__company_size",
                                                children: "Company Size"
                                            }),
                                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                className: "controls form-group",
                                                children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $61Ea1.jsxs)("select", {
                                                        id: "user-details-form__company_size",
                                                        value: companySize,
                                                        onChange: (e)=>setCompanySize(e.target.value),
                                                        className: "form-control h-10 py-2 input-base w-full focus:outline-none hover:border-[#618fb0]",
                                                        children: [
                                                            /*#__PURE__*/ (0, $61Ea1.jsx)("option", {
                                                                value: "",
                                                                children: "Select company size"
                                                            }),
                                                            /*#__PURE__*/ (0, $61Ea1.jsx)("option", {
                                                                value: "just-me",
                                                                children: "Just me"
                                                            }),
                                                            /*#__PURE__*/ (0, $61Ea1.jsx)("option", {
                                                                value: "1-5",
                                                                children: "2-5 staff"
                                                            }),
                                                            /*#__PURE__*/ (0, $61Ea1.jsx)("option", {
                                                                value: "6-10",
                                                                children: "6-10 staff"
                                                            }),
                                                            /*#__PURE__*/ (0, $61Ea1.jsx)("option", {
                                                                value: "11-25",
                                                                children: "11-25 staff"
                                                            }),
                                                            /*#__PURE__*/ (0, $61Ea1.jsx)("option", {
                                                                value: "26-50",
                                                                children: "26-50 staff"
                                                            }),
                                                            /*#__PURE__*/ (0, $61Ea1.jsx)("option", {
                                                                value: "51-100",
                                                                children: "51-100 staff"
                                                            }),
                                                            /*#__PURE__*/ (0, $61Ea1.jsx)("option", {
                                                                value: "101-200",
                                                                children: "101-200 staff"
                                                            }),
                                                            /*#__PURE__*/ (0, $61Ea1.jsx)("option", {
                                                                value: "201-500",
                                                                children: "201-500 staff"
                                                            }),
                                                            /*#__PURE__*/ (0, $61Ea1.jsx)("option", {
                                                                value: "500+",
                                                                children: "500+ staff"
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                        className: "control-group mb-6",
                                        style: {
                                            clear: "both"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $61Ea1.jsx)("label", {
                                                className: "control-label mb-2",
                                                htmlFor: "user-details-form__referral_source",
                                                children: "How did you hear about us?"
                                            }),
                                            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                                className: "controls form-group",
                                                children: [
                                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("select", {
                                                            id: "user-details-form__referral_source",
                                                            value: referralSource,
                                                            onChange: (e)=>{
                                                                setReferralSource(e.target.value);
                                                                if (e.target.value === "other") setOtherReferralSource("");
                                                            },
                                                            className: "form-control h-10 py-2 input-base w-full focus:outline-none hover:border-[#618fb0]",
                                                            children: [
                                                                /*#__PURE__*/ (0, $61Ea1.jsx)("option", {
                                                                    value: "",
                                                                    children: "Select an option"
                                                                }),
                                                                /*#__PURE__*/ (0, $61Ea1.jsx)("option", {
                                                                    value: "google_search",
                                                                    children: "Google/Search Engine"
                                                                }),
                                                                /*#__PURE__*/ (0, $61Ea1.jsx)("option", {
                                                                    value: "social_media",
                                                                    children: "Social Media (LinkedIn, Facebook, Twitter, etc.)"
                                                                }),
                                                                /*#__PURE__*/ (0, $61Ea1.jsx)("option", {
                                                                    value: "online_ads",
                                                                    children: "Online Ads"
                                                                }),
                                                                /*#__PURE__*/ (0, $61Ea1.jsx)("option", {
                                                                    value: "word_of_mouth",
                                                                    children: "Word of Mouth/Referral from a Friend"
                                                                }),
                                                                /*#__PURE__*/ (0, $61Ea1.jsx)("option", {
                                                                    value: "review_site",
                                                                    children: "Review Site (e.g., G2, Capterra)"
                                                                }),
                                                                /*#__PURE__*/ (0, $61Ea1.jsx)("option", {
                                                                    value: "blog_article",
                                                                    children: "Blog/Article"
                                                                }),
                                                                /*#__PURE__*/ (0, $61Ea1.jsx)("option", {
                                                                    value: "email_newsletter",
                                                                    children: "Email Newsletter"
                                                                }),
                                                                /*#__PURE__*/ (0, $61Ea1.jsx)("option", {
                                                                    value: "event_webinar",
                                                                    children: "Event/Webinar"
                                                                }),
                                                                /*#__PURE__*/ (0, $61Ea1.jsx)("option", {
                                                                    value: "other",
                                                                    children: "Other"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    referralSource === "other" && /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                        className: "mt-2",
                                                        children: /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
                                                            type: "text",
                                                            value: otherReferralSource,
                                                            onChange: (e)=>setOtherReferralSource(e.target.value),
                                                            placeholder: "Please specify",
                                                            className: "form-control h-10 py-2 input-base w-full focus:outline-none hover:border-[#618fb0]"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            className: "form-actions",
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsxs)("button", {
                                    onClick: ()=>{
                                        if (!organisationName.length || !countryCode) setSubmitState("error");
                                        else {
                                            setSubmitState("pending");
                                            if (!(0, $8kZ1o.usingNewLogin)()) (0, $iOQGT.makeRequest)({
                                                path: "https://api.coincraft.co/api/v1.5/user/register-details",
                                                method: "post",
                                                data: {
                                                    firstName: firstName,
                                                    lastName: lastName,
                                                    organisationName: organisationName,
                                                    country: countryCode,
                                                    phoneNumber: phoneNumber,
                                                    industry: industry !== "other" ? industry : otherIndustry,
                                                    companySize: companySize,
                                                    referralSource: referralSource !== "other" ? referralSource : otherReferralSource
                                                }
                                            }).then(async function(response) {
                                                (0, $1BTI2.default).saveLoginResponse(response);
                                                navigate({
                                                    to: "/projects"
                                                });
                                            }).catch(function(error) {
                                                $iKbxs.captureException(error);
                                                (0, $3H03w.default).captureException(error);
                                                console.error(error);
                                                setSubmitState("error");
                                            });
                                            else (0, $iOQGT.makeRequest)({
                                                path: "https://server2.coincraft.co/auth/register-org",
                                                method: "post",
                                                data: {
                                                    name: organisationName,
                                                    country: countryCode,
                                                    industry: industry !== "other" ? industry : otherIndustry,
                                                    companySize: companySize,
                                                    referralSource: referralSource !== "other" ? referralSource : otherReferralSource
                                                }
                                            }).then(async function(response) {
                                                (0, $1BTI2.default).saveLoginResponse(response);
                                                navigate({
                                                    to: "/projects"
                                                });
                                            }).catch(function(error) {
                                                $iKbxs.captureException(error);
                                                (0, $3H03w.default).captureException(error);
                                                console.error(error);
                                                setSubmitState("error");
                                            });
                                        }
                                    },
                                    className: "btn btn-block btn-lg btn-info user_details_form__submit_button w-full",
                                    children: [
                                        /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                            children: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                                className: "fa fa-play"
                                            })
                                        }),
                                        " ",
                                        "\xa0 Start Using Coincraft!"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                    className: "forgot"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
});
const $9440840f7306a39e$var$CountrySelector = ({ value: value, onChange: onChange, variant: variant })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
        value: value,
        options: (0, $ebylM.countries).map((c)=>({
                label: c.name,
                value: c.code
            })),
        searchMatcher: function(country, searchText) {
            var _country$label;
            return country === null || country === void 0 ? void 0 : (_country$label = country.label) === null || _country$label === void 0 ? void 0 : _country$label.toLowerCase().match(searchText.toLowerCase());
        },
        onChange: (country)=>{
            onChange(country);
        },
        variant: variant
    });
};

});
parcelRegister("ebylM", function(module, exports) {

$parcel$export(module.exports, "countries", function () { return $a53cbd027720f5cb$export$e5ad74579c86b003; });
/**
  * Generated by going here: https://countrycode.org/
  * - Making the window size so that the visible table has three columns
  * - Selecting the visible table in dev tools
  * - Running the following Javascript:

    console.log(JSON.stringify(
      [].slice.call($0.querySelectorAll("tr")).map(function(e, i) {
        if (i > 0) {
          var tds = e.querySelectorAll("td");
          return [
            tds[0].querySelector("a").innerHTML,
            tds[2].innerHTML.split("/")[0].trim().toLowerCase()
          ];
        }
        else {
          return null;
        }
      }).filter(r => r != null),
      null,
      4
    ))

  */ 
var $1I1l5 = parcelRequire("1I1l5");
function $a53cbd027720f5cb$export$2cc4aa3607b4f5d7() {
    return new $1I1l5.Promise(function(resolve, reject) {
        if (navigator.geolocation) navigator.geolocation.getCurrentPosition(function(position) {
            window.$.ajax({
                url: "http://ws.geonames.org/countryCode",
                dataType: "json",
                data: {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                    username: "amagee99",
                    type: "JSON"
                },
                timeout: 5000,
                success: function(result) {
                    if (result.countryCode != null) resolve(result.countryCode.toLowerCase());
                    else reject(result);
                }
            }).fail(function() {
                reject("request_failed");
            });
        }, function() {
            reject("geolocation_failed");
        });
        else reject("no_geolocation");
    });
}
window.getCountryCodeViaGeolocation = $a53cbd027720f5cb$export$2cc4aa3607b4f5d7;
let $a53cbd027720f5cb$var$cs = [
    [
        "Afghanistan",
        "af"
    ],
    [
        "Albania",
        "al"
    ],
    [
        "Algeria",
        "dz"
    ],
    [
        "American Samoa",
        "as"
    ],
    [
        "Andorra",
        "ad"
    ],
    [
        "Angola",
        "ao"
    ],
    [
        "Anguilla",
        "ai"
    ],
    [
        "Antarctica",
        "aq"
    ],
    [
        "Antigua and Barbuda",
        "ag"
    ],
    [
        "Argentina",
        "ar"
    ],
    [
        "Armenia",
        "am"
    ],
    [
        "Aruba",
        "aw"
    ],
    [
        "Australia",
        "au"
    ],
    [
        "Austria",
        "at"
    ],
    [
        "Azerbaijan",
        "az"
    ],
    [
        "Bahamas",
        "bs"
    ],
    [
        "Bahrain",
        "bh"
    ],
    [
        "Bangladesh",
        "bd"
    ],
    [
        "Barbados",
        "bb"
    ],
    [
        "Belarus",
        "by"
    ],
    [
        "Belgium",
        "be"
    ],
    [
        "Belize",
        "bz"
    ],
    [
        "Benin",
        "bj"
    ],
    [
        "Bermuda",
        "bm"
    ],
    [
        "Bhutan",
        "bt"
    ],
    [
        "Bolivia",
        "bo"
    ],
    [
        "Bosnia and Herzegovina",
        "ba"
    ],
    [
        "Botswana",
        "bw"
    ],
    [
        "Brazil",
        "br"
    ],
    [
        "British Indian Ocean Territory",
        "io"
    ],
    [
        "British Virgin Islands",
        "vg"
    ],
    [
        "Brunei",
        "bn"
    ],
    [
        "Bulgaria",
        "bg"
    ],
    [
        "Burkina Faso",
        "bf"
    ],
    [
        "Burundi",
        "bi"
    ],
    [
        "Cambodia",
        "kh"
    ],
    [
        "Cameroon",
        "cm"
    ],
    [
        "Canada",
        "ca"
    ],
    [
        "Cape Verde",
        "cv"
    ],
    [
        "Cayman Islands",
        "ky"
    ],
    [
        "Central African Republic",
        "cf"
    ],
    [
        "Chad",
        "td"
    ],
    [
        "Chile",
        "cl"
    ],
    [
        "China",
        "cn"
    ],
    [
        "Christmas Island",
        "cx"
    ],
    [
        "Cocos Islands",
        "cc"
    ],
    [
        "Colombia",
        "co"
    ],
    [
        "Comoros",
        "km"
    ],
    [
        "Cook Islands",
        "ck"
    ],
    [
        "Costa Rica",
        "cr"
    ],
    [
        "Croatia",
        "hr"
    ],
    [
        "Cuba",
        "cu"
    ],
    [
        "Curacao",
        "cw"
    ],
    [
        "Cyprus",
        "cy"
    ],
    [
        "Czech Republic",
        "cz"
    ],
    [
        "Democratic Republic of the Congo",
        "cd"
    ],
    [
        "Denmark",
        "dk"
    ],
    [
        "Djibouti",
        "dj"
    ],
    [
        "Dominica",
        "dm"
    ],
    [
        "Dominican Republic",
        "do"
    ],
    [
        "East Timor",
        "tl"
    ],
    [
        "Ecuador",
        "ec"
    ],
    [
        "Egypt",
        "eg"
    ],
    [
        "El Salvador",
        "sv"
    ],
    [
        "Equatorial Guinea",
        "gq"
    ],
    [
        "Eritrea",
        "er"
    ],
    [
        "Estonia",
        "ee"
    ],
    [
        "Ethiopia",
        "et"
    ],
    [
        "Falkland Islands",
        "fk"
    ],
    [
        "Faroe Islands",
        "fo"
    ],
    [
        "Fiji",
        "fj"
    ],
    [
        "Finland",
        "fi"
    ],
    [
        "France",
        "fr"
    ],
    [
        "French Polynesia",
        "pf"
    ],
    [
        "Gabon",
        "ga"
    ],
    [
        "Gambia",
        "gm"
    ],
    [
        "Georgia",
        "ge"
    ],
    [
        "Germany",
        "de"
    ],
    [
        "Ghana",
        "gh"
    ],
    [
        "Gibraltar",
        "gi"
    ],
    [
        "Greece",
        "gr"
    ],
    [
        "Greenland",
        "gl"
    ],
    [
        "Grenada",
        "gd"
    ],
    [
        "Guam",
        "gu"
    ],
    [
        "Guatemala",
        "gt"
    ],
    [
        "Guernsey",
        "gg"
    ],
    [
        "Guinea",
        "gn"
    ],
    [
        "Guinea-Bissau",
        "gw"
    ],
    [
        "Guyana",
        "gy"
    ],
    [
        "Haiti",
        "ht"
    ],
    [
        "Honduras",
        "hn"
    ],
    [
        "Hong Kong",
        "hk"
    ],
    [
        "Hungary",
        "hu"
    ],
    [
        "Iceland",
        "is"
    ],
    [
        "India",
        "in"
    ],
    [
        "Indonesia",
        "id"
    ],
    [
        "Iran",
        "ir"
    ],
    [
        "Iraq",
        "iq"
    ],
    [
        "Ireland",
        "ie"
    ],
    [
        "Isle of Man",
        "im"
    ],
    [
        "Israel",
        "il"
    ],
    [
        "Italy",
        "it"
    ],
    [
        "Ivory Coast",
        "ci"
    ],
    [
        "Jamaica",
        "jm"
    ],
    [
        "Japan",
        "jp"
    ],
    [
        "Jersey",
        "je"
    ],
    [
        "Jordan",
        "jo"
    ],
    [
        "Kazakhstan",
        "kz"
    ],
    [
        "Kenya",
        "ke"
    ],
    [
        "Kiribati",
        "ki"
    ],
    [
        "Kosovo",
        "xk"
    ],
    [
        "Kuwait",
        "kw"
    ],
    [
        "Kyrgyzstan",
        "kg"
    ],
    [
        "Laos",
        "la"
    ],
    [
        "Latvia",
        "lv"
    ],
    [
        "Lebanon",
        "lb"
    ],
    [
        "Lesotho",
        "ls"
    ],
    [
        "Liberia",
        "lr"
    ],
    [
        "Libya",
        "ly"
    ],
    [
        "Liechtenstein",
        "li"
    ],
    [
        "Lithuania",
        "lt"
    ],
    [
        "Luxembourg",
        "lu"
    ],
    [
        "Macao",
        "mo"
    ],
    [
        "Macedonia",
        "mk"
    ],
    [
        "Madagascar",
        "mg"
    ],
    [
        "Malawi",
        "mw"
    ],
    [
        "Malaysia",
        "my"
    ],
    [
        "Maldives",
        "mv"
    ],
    [
        "Mali",
        "ml"
    ],
    [
        "Malta",
        "mt"
    ],
    [
        "Marshall Islands",
        "mh"
    ],
    [
        "Mauritania",
        "mr"
    ],
    [
        "Mauritius",
        "mu"
    ],
    [
        "Mayotte",
        "yt"
    ],
    [
        "Mexico",
        "mx"
    ],
    [
        "Micronesia",
        "fm"
    ],
    [
        "Moldova",
        "md"
    ],
    [
        "Monaco",
        "mc"
    ],
    [
        "Mongolia",
        "mn"
    ],
    [
        "Montenegro",
        "me"
    ],
    [
        "Montserrat",
        "ms"
    ],
    [
        "Morocco",
        "ma"
    ],
    [
        "Mozambique",
        "mz"
    ],
    [
        "Myanmar",
        "mm"
    ],
    [
        "Namibia",
        "na"
    ],
    [
        "Nauru",
        "nr"
    ],
    [
        "Nepal",
        "np"
    ],
    [
        "Netherlands",
        "nl"
    ],
    [
        "Netherlands Antilles",
        "an"
    ],
    [
        "New Caledonia",
        "nc"
    ],
    [
        "New Zealand",
        "nz"
    ],
    [
        "Nicaragua",
        "ni"
    ],
    [
        "Niger",
        "ne"
    ],
    [
        "Nigeria",
        "ng"
    ],
    [
        "Niue",
        "nu"
    ],
    [
        "North Korea",
        "kp"
    ],
    [
        "Northern Mariana Islands",
        "mp"
    ],
    [
        "Norway",
        "no"
    ],
    [
        "Oman",
        "om"
    ],
    [
        "Pakistan",
        "pk"
    ],
    [
        "Palau",
        "pw"
    ],
    [
        "Palestine",
        "ps"
    ],
    [
        "Panama",
        "pa"
    ],
    [
        "Papua New Guinea",
        "pg"
    ],
    [
        "Paraguay",
        "py"
    ],
    [
        "Peru",
        "pe"
    ],
    [
        "Philippines",
        "ph"
    ],
    [
        "Pitcairn",
        "pn"
    ],
    [
        "Poland",
        "pl"
    ],
    [
        "Portugal",
        "pt"
    ],
    [
        "Puerto Rico",
        "pr"
    ],
    [
        "Qatar",
        "qa"
    ],
    [
        "Republic of the Congo",
        "cg"
    ],
    [
        "Reunion",
        "re"
    ],
    [
        "Romania",
        "ro"
    ],
    [
        "Russia",
        "ru"
    ],
    [
        "Rwanda",
        "rw"
    ],
    [
        "Saint Barthelemy",
        "bl"
    ],
    [
        "Saint Helena",
        "sh"
    ],
    [
        "Saint Kitts and Nevis",
        "kn"
    ],
    [
        "Saint Lucia",
        "lc"
    ],
    [
        "Saint Martin",
        "mf"
    ],
    [
        "Saint Pierre and Miquelon",
        "pm"
    ],
    [
        "Saint Vincent and the Grenadines",
        "vc"
    ],
    [
        "Samoa",
        "ws"
    ],
    [
        "San Marino",
        "sm"
    ],
    [
        "Sao Tome and Principe",
        "st"
    ],
    [
        "Saudi Arabia",
        "sa"
    ],
    [
        "Senegal",
        "sn"
    ],
    [
        "Serbia",
        "rs"
    ],
    [
        "Seychelles",
        "sc"
    ],
    [
        "Sierra Leone",
        "sl"
    ],
    [
        "Singapore",
        "sg"
    ],
    [
        "Sint Maarten",
        "sx"
    ],
    [
        "Slovakia",
        "sk"
    ],
    [
        "Slovenia",
        "si"
    ],
    [
        "Solomon Islands",
        "sb"
    ],
    [
        "Somalia",
        "so"
    ],
    [
        "South Africa",
        "za"
    ],
    [
        "South Korea",
        "kr"
    ],
    [
        "South Sudan",
        "ss"
    ],
    [
        "Spain",
        "es"
    ],
    [
        "Sri Lanka",
        "lk"
    ],
    [
        "Sudan",
        "sd"
    ],
    [
        "Suriname",
        "sr"
    ],
    [
        "Svalbard and Jan Mayen",
        "sj"
    ],
    [
        "Swaziland",
        "sz"
    ],
    [
        "Sweden",
        "se"
    ],
    [
        "Switzerland",
        "ch"
    ],
    [
        "Syria",
        "sy"
    ],
    [
        "Taiwan",
        "tw"
    ],
    [
        "Tajikistan",
        "tj"
    ],
    [
        "Tanzania",
        "tz"
    ],
    [
        "Thailand",
        "th"
    ],
    [
        "Togo",
        "tg"
    ],
    [
        "Tokelau",
        "tk"
    ],
    [
        "Tonga",
        "to"
    ],
    [
        "Trinidad and Tobago",
        "tt"
    ],
    [
        "Tunisia",
        "tn"
    ],
    [
        "Turkey",
        "tr"
    ],
    [
        "Turkmenistan",
        "tm"
    ],
    [
        "Turks and Caicos Islands",
        "tc"
    ],
    [
        "Tuvalu",
        "tv"
    ],
    [
        "U.S. Virgin Islands",
        "vi"
    ],
    [
        "Uganda",
        "ug"
    ],
    [
        "Ukraine",
        "ua"
    ],
    [
        "United Arab Emirates",
        "ae"
    ],
    [
        "United Kingdom",
        "gb"
    ],
    [
        "United States",
        "us"
    ],
    [
        "Uruguay",
        "uy"
    ],
    [
        "Uzbekistan",
        "uz"
    ],
    [
        "Vanuatu",
        "vu"
    ],
    [
        "Vatican",
        "va"
    ],
    [
        "Venezuela",
        "ve"
    ],
    [
        "Vietnam",
        "vn"
    ],
    [
        "Wallis and Futuna",
        "wf"
    ],
    [
        "Western Sahara",
        "eh"
    ],
    [
        "Yemen",
        "ye"
    ],
    [
        "Zambia",
        "zm"
    ],
    [
        "Zimbabwe",
        "zw"
    ]
];
const $a53cbd027720f5cb$export$e5ad74579c86b003 = $a53cbd027720f5cb$var$cs.map((c)=>({
        name: c[0],
        code: c[1]
    }));

});
parcelRegister("1I1l5", function(module, exports) {

$parcel$export(module.exports, "Promise", function () { return Promise; });
/*!
 * @overview RSVP - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2016 Yehuda Katz, Tom Dale, Stefan Penner and contributors
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/tildeio/rsvp.js/master/LICENSE
 * @version   3.6.2
 */ 
var $2Prz7 = parcelRequire("2Prz7");
function indexOf(callbacks, callback) {
    for(var i = 0, l = callbacks.length; i < l; i++){
        if (callbacks[i] === callback) return i;
    }
    return -1;
}
function callbacksFor(object) {
    var callbacks = object._promiseCallbacks;
    if (!callbacks) callbacks = object._promiseCallbacks = {};
    return callbacks;
}
/**
  @class RSVP.EventTarget
*/ var EventTarget = {
    /**
    `RSVP.EventTarget.mixin` extends an object with EventTarget methods. For
    Example:
     ```javascript
    let object = {};
     RSVP.EventTarget.mixin(object);
     object.on('finished', function(event) {
      // handle event
    });
     object.trigger('finished', { detail: value });
    ```
     `EventTarget.mixin` also works with prototypes:
     ```javascript
    let Person = function() {};
    RSVP.EventTarget.mixin(Person.prototype);
     let yehuda = new Person();
    let tom = new Person();
     yehuda.on('poke', function(event) {
      console.log('Yehuda says OW');
    });
     tom.on('poke', function(event) {
      console.log('Tom says OW');
    });
     yehuda.trigger('poke');
    tom.trigger('poke');
    ```
     @method mixin
    @for RSVP.EventTarget
    @private
    @param {Object} object object to extend with EventTarget methods
  */ mixin: function(object) {
        object["on"] = this["on"];
        object["off"] = this["off"];
        object["trigger"] = this["trigger"];
        object._promiseCallbacks = undefined;
        return object;
    },
    /**
    Registers a callback to be executed when `eventName` is triggered
     ```javascript
    object.on('event', function(eventInfo){
      // handle the event
    });
     object.trigger('event');
    ```
     @method on
    @for RSVP.EventTarget
    @private
    @param {String} eventName name of the event to listen for
    @param {Function} callback function to be called when the event is triggered.
  */ on: function(eventName, callback) {
        if (typeof callback !== "function") throw new TypeError("Callback must be a function");
        var allCallbacks = callbacksFor(this), callbacks = void 0;
        callbacks = allCallbacks[eventName];
        if (!callbacks) callbacks = allCallbacks[eventName] = [];
        if (indexOf(callbacks, callback) === -1) callbacks.push(callback);
    },
    /**
    You can use `off` to stop firing a particular callback for an event:
     ```javascript
    function doStuff() { // do stuff! }
    object.on('stuff', doStuff);
     object.trigger('stuff'); // doStuff will be called
     // Unregister ONLY the doStuff callback
    object.off('stuff', doStuff);
    object.trigger('stuff'); // doStuff will NOT be called
    ```
     If you don't pass a `callback` argument to `off`, ALL callbacks for the
    event will not be executed when the event fires. For example:
     ```javascript
    let callback1 = function(){};
    let callback2 = function(){};
     object.on('stuff', callback1);
    object.on('stuff', callback2);
     object.trigger('stuff'); // callback1 and callback2 will be executed.
     object.off('stuff');
    object.trigger('stuff'); // callback1 and callback2 will not be executed!
    ```
     @method off
    @for RSVP.EventTarget
    @private
    @param {String} eventName event to stop listening to
    @param {Function} callback optional argument. If given, only the function
    given will be removed from the event's callback queue. If no `callback`
    argument is given, all callbacks will be removed from the event's callback
    queue.
  */ off: function(eventName, callback) {
        var allCallbacks = callbacksFor(this), callbacks = void 0, index = void 0;
        if (!callback) {
            allCallbacks[eventName] = [];
            return;
        }
        callbacks = allCallbacks[eventName];
        index = indexOf(callbacks, callback);
        if (index !== -1) callbacks.splice(index, 1);
    },
    /**
    Use `trigger` to fire custom events. For example:
     ```javascript
    object.on('foo', function(){
      console.log('foo event happened!');
    });
    object.trigger('foo');
    // 'foo event happened!' logged to the console
    ```
     You can also pass a value as a second argument to `trigger` that will be
    passed as an argument to all event listeners for the event:
     ```javascript
    object.on('foo', function(value){
      console.log(value.name);
    });
     object.trigger('foo', { name: 'bar' });
    // 'bar' logged to the console
    ```
     @method trigger
    @for RSVP.EventTarget
    @private
    @param {String} eventName name of the event to be triggered
    @param {*} options optional value to be passed to any event handlers for
    the given `eventName`
  */ trigger: function(eventName, options, label) {
        var allCallbacks = callbacksFor(this), callbacks = void 0, callback = void 0;
        if (callbacks = allCallbacks[eventName]) // Don't cache the callbacks.length since it may grow
        for(var i = 0; i < callbacks.length; i++){
            callback = callbacks[i];
            callback(options, label);
        }
    }
};
var config = {
    instrument: false
};
EventTarget["mixin"](config);
function configure(name, value) {
    if (arguments.length === 2) config[name] = value;
    else return config[name];
}
function objectOrFunction(x) {
    var type = typeof x;
    return x !== null && (type === "object" || type === "function");
}
function isFunction(x) {
    return typeof x === "function";
}
function isObject(x) {
    return x !== null && typeof x === "object";
}
function isMaybeThenable(x) {
    return x !== null && typeof x === "object";
}
var _isArray = void 0;
if (Array.isArray) _isArray = Array.isArray;
else _isArray = function(x) {
    return Object.prototype.toString.call(x) === "[object Array]";
};
var isArray = _isArray;
// Date.now is not available in browsers < IE9
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/now#Compatibility
var now = Date.now || function() {
    return new Date().getTime();
};
var queue = [];
function scheduleFlush() {
    setTimeout(function() {
        for(var i = 0; i < queue.length; i++){
            var entry = queue[i];
            var payload = entry.payload;
            payload.guid = payload.key + payload.id;
            payload.childGuid = payload.key + payload.childId;
            if (payload.error) payload.stack = payload.error.stack;
            config["trigger"](entry.name, entry.payload);
        }
        queue.length = 0;
    }, 50);
}
function instrument(eventName, promise, child) {
    if (1 === queue.push({
        name: eventName,
        payload: {
            key: promise._guidKey,
            id: promise._id,
            eventName: eventName,
            detail: promise._result,
            childId: child && child._id,
            label: promise._label,
            timeStamp: now(),
            error: config["instrument-with-stack"] ? new Error(promise._label) : null
        }
    })) scheduleFlush();
}
/**
  `RSVP.Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new RSVP.Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = RSVP.Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {*} object value that the returned promise will be resolved with
  @param {String} label optional string for identifying the returned promise.
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/ function resolve$1(object, label) {
    /*jshint validthis:true */ var Constructor = this;
    if (object && typeof object === "object" && object.constructor === Constructor) return object;
    var promise = new Constructor(noop, label);
    resolve(promise, object);
    return promise;
}
function withOwnPromise() {
    return new TypeError("A promises callback cannot return that same promise.");
}
function noop() {}
var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;
var GET_THEN_ERROR = new ErrorObject();
function getThen(promise) {
    try {
        return promise.then;
    } catch (error) {
        GET_THEN_ERROR.error = error;
        return GET_THEN_ERROR;
    }
}
function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
    try {
        then$$1.call(value, fulfillmentHandler, rejectionHandler);
    } catch (e) {
        return e;
    }
}
function handleForeignThenable(promise, thenable, then$$1) {
    config.async(function(promise) {
        var sealed = false;
        var error = tryThen(then$$1, thenable, function(value) {
            if (sealed) return;
            sealed = true;
            if (thenable !== value) resolve(promise, value, undefined);
            else fulfill(promise, value);
        }, function(reason) {
            if (sealed) return;
            sealed = true;
            reject(promise, reason);
        }, "Settle: " + (promise._label || " unknown promise"));
        if (!sealed && error) {
            sealed = true;
            reject(promise, error);
        }
    }, promise);
}
function handleOwnThenable(promise, thenable) {
    if (thenable._state === FULFILLED) fulfill(promise, thenable._result);
    else if (thenable._state === REJECTED) {
        thenable._onError = null;
        reject(promise, thenable._result);
    } else subscribe(thenable, undefined, function(value) {
        if (thenable !== value) resolve(promise, value, undefined);
        else fulfill(promise, value);
    }, function(reason) {
        return reject(promise, reason);
    });
}
function handleMaybeThenable(promise, maybeThenable, then$$1) {
    var isOwnThenable = maybeThenable.constructor === promise.constructor && then$$1 === then && promise.constructor.resolve === resolve$1;
    if (isOwnThenable) handleOwnThenable(promise, maybeThenable);
    else if (then$$1 === GET_THEN_ERROR) {
        reject(promise, GET_THEN_ERROR.error);
        GET_THEN_ERROR.error = null;
    } else if (isFunction(then$$1)) handleForeignThenable(promise, maybeThenable, then$$1);
    else fulfill(promise, maybeThenable);
}
function resolve(promise, value) {
    if (promise === value) fulfill(promise, value);
    else if (objectOrFunction(value)) handleMaybeThenable(promise, value, getThen(value));
    else fulfill(promise, value);
}
function publishRejection(promise) {
    if (promise._onError) promise._onError(promise._result);
    publish(promise);
}
function fulfill(promise, value) {
    if (promise._state !== PENDING) return;
    promise._result = value;
    promise._state = FULFILLED;
    if (promise._subscribers.length === 0) {
        if (config.instrument) instrument("fulfilled", promise);
    } else config.async(publish, promise);
}
function reject(promise, reason) {
    if (promise._state !== PENDING) return;
    promise._state = REJECTED;
    promise._result = reason;
    config.async(publishRejection, promise);
}
function subscribe(parent, child, onFulfillment, onRejection) {
    var subscribers = parent._subscribers;
    var length = subscribers.length;
    parent._onError = null;
    subscribers[length] = child;
    subscribers[length + FULFILLED] = onFulfillment;
    subscribers[length + REJECTED] = onRejection;
    if (length === 0 && parent._state) config.async(publish, parent);
}
function publish(promise) {
    var subscribers = promise._subscribers;
    var settled = promise._state;
    if (config.instrument) instrument(settled === FULFILLED ? "fulfilled" : "rejected", promise);
    if (subscribers.length === 0) return;
    var child = void 0, callback = void 0, result = promise._result;
    for(var i = 0; i < subscribers.length; i += 3){
        child = subscribers[i];
        callback = subscribers[i + settled];
        if (child) invokeCallback(settled, child, callback, result);
        else callback(result);
    }
    promise._subscribers.length = 0;
}
function ErrorObject() {
    this.error = null;
}
var TRY_CATCH_ERROR = new ErrorObject();
function tryCatch(callback, result) {
    try {
        return callback(result);
    } catch (e) {
        TRY_CATCH_ERROR.error = e;
        return TRY_CATCH_ERROR;
    }
}
function invokeCallback(state, promise, callback, result) {
    var hasCallback = isFunction(callback);
    var value = void 0, error = void 0;
    if (hasCallback) {
        value = tryCatch(callback, result);
        if (value === TRY_CATCH_ERROR) {
            error = value.error;
            value.error = null; // release
        } else if (value === promise) {
            reject(promise, withOwnPromise());
            return;
        }
    } else value = result;
    if (promise._state !== PENDING) ;
    else if (hasCallback && error === undefined) resolve(promise, value);
    else if (error !== undefined) reject(promise, error);
    else if (state === FULFILLED) fulfill(promise, value);
    else if (state === REJECTED) reject(promise, value);
}
function initializePromise(promise, resolver) {
    var resolved = false;
    try {
        resolver(function(value) {
            if (resolved) return;
            resolved = true;
            resolve(promise, value);
        }, function(reason) {
            if (resolved) return;
            resolved = true;
            reject(promise, reason);
        });
    } catch (e) {
        reject(promise, e);
    }
}
function then(onFulfillment, onRejection, label) {
    var parent = this;
    var state = parent._state;
    if (state === FULFILLED && !onFulfillment || state === REJECTED && !onRejection) {
        config.instrument && instrument("chained", parent, parent);
        return parent;
    }
    parent._onError = null;
    var child = new parent.constructor(noop, label);
    var result = parent._result;
    config.instrument && instrument("chained", parent, child);
    if (state === PENDING) subscribe(parent, child, onFulfillment, onRejection);
    else {
        var callback = state === FULFILLED ? onFulfillment : onRejection;
        config.async(function() {
            return invokeCallback(state, child, callback, result);
        });
    }
    return child;
}
var Enumerator = function() {
    function Enumerator(Constructor, input, abortOnReject, label) {
        this._instanceConstructor = Constructor;
        this.promise = new Constructor(noop, label);
        this._abortOnReject = abortOnReject;
        this._init.apply(this, arguments);
    }
    Enumerator.prototype._init = function _init(Constructor, input) {
        var len = input.length || 0;
        this.length = len;
        this._remaining = len;
        this._result = new Array(len);
        this._enumerate(input);
        if (this._remaining === 0) fulfill(this.promise, this._result);
    };
    Enumerator.prototype._enumerate = function _enumerate(input) {
        var length = this.length;
        var promise = this.promise;
        for(var i = 0; promise._state === PENDING && i < length; i++)this._eachEntry(input[i], i);
    };
    Enumerator.prototype._settleMaybeThenable = function _settleMaybeThenable(entry, i) {
        var c = this._instanceConstructor;
        var resolve$$1 = c.resolve;
        if (resolve$$1 === resolve$1) {
            var then$$1 = getThen(entry);
            if (then$$1 === then && entry._state !== PENDING) {
                entry._onError = null;
                this._settledAt(entry._state, i, entry._result);
            } else if (typeof then$$1 !== "function") {
                this._remaining--;
                this._result[i] = this._makeResult(FULFILLED, i, entry);
            } else if (c === Promise) {
                var promise = new c(noop);
                handleMaybeThenable(promise, entry, then$$1);
                this._willSettleAt(promise, i);
            } else this._willSettleAt(new c(function(resolve$$1) {
                return resolve$$1(entry);
            }), i);
        } else this._willSettleAt(resolve$$1(entry), i);
    };
    Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
        if (isMaybeThenable(entry)) this._settleMaybeThenable(entry, i);
        else {
            this._remaining--;
            this._result[i] = this._makeResult(FULFILLED, i, entry);
        }
    };
    Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
        var promise = this.promise;
        if (promise._state === PENDING) {
            if (this._abortOnReject && state === REJECTED) reject(promise, value);
            else {
                this._remaining--;
                this._result[i] = this._makeResult(state, i, value);
                if (this._remaining === 0) fulfill(promise, this._result);
            }
        }
    };
    Enumerator.prototype._makeResult = function _makeResult(state, i, value) {
        return value;
    };
    Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
        var enumerator = this;
        subscribe(promise, undefined, function(value) {
            return enumerator._settledAt(FULFILLED, i, value);
        }, function(reason) {
            return enumerator._settledAt(REJECTED, i, reason);
        });
    };
    return Enumerator;
}();
function makeSettledResult(state, position, value) {
    if (state === FULFILLED) return {
        state: "fulfilled",
        value: value
    };
    else return {
        state: "rejected",
        reason: value
    };
}
/**
  `RSVP.Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = RSVP.resolve(1);
  let promise2 = RSVP.resolve(2);
  let promise3 = RSVP.resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  RSVP.Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `RSVP.all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = RSVP.resolve(1);
  let promise2 = RSVP.reject(new Error("2"));
  let promise3 = RSVP.reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  RSVP.Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/ function all(entries, label) {
    if (!isArray(entries)) return this.reject(new TypeError("Promise.all must be called with an array"), label);
    return new Enumerator(this, entries, true, label).promise;
}
/**
  `RSVP.Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new RSVP.Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new RSVP.Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  RSVP.Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `RSVP.Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new RSVP.Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new RSVP.Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  RSVP.Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  RSVP.Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} entries array of promises to observe
  @param {String} label optional string for describing the promise returned.
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/ function race(entries, label) {
    /*jshint validthis:true */ var Constructor = this;
    var promise = new Constructor(noop, label);
    if (!isArray(entries)) {
        reject(promise, new TypeError("Promise.race must be called with an array"));
        return promise;
    }
    for(var i = 0; promise._state === PENDING && i < entries.length; i++)subscribe(Constructor.resolve(entries[i]), undefined, function(value) {
        return resolve(promise, value);
    }, function(reason) {
        return reject(promise, reason);
    });
    return promise;
}
/**
  `RSVP.Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new RSVP.Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = RSVP.Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {*} reason value that the returned promise will be rejected with.
  @param {String} label optional string for identifying the returned promise.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/ function reject$1(reason, label) {
    /*jshint validthis:true */ var Constructor = this;
    var promise = new Constructor(noop, label);
    reject(promise, reason);
    return promise;
}
var guidKey = "rsvp_" + now() + "-";
var counter = 0;
function needsResolver() {
    throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
}
function needsNew() {
    throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}
/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise’s eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class RSVP.Promise
  @param {function} resolver
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @constructor
*/ var Promise = function() {
    function Promise(resolver, label) {
        this._id = counter++;
        this._label = label;
        this._state = undefined;
        this._result = undefined;
        this._subscribers = [];
        config.instrument && instrument("created", this);
        if (noop !== resolver) {
            typeof resolver !== "function" && needsResolver();
            this instanceof Promise ? initializePromise(this, resolver) : needsNew();
        }
    }
    Promise.prototype._onError = function _onError(reason) {
        var _this = this;
        config.after(function() {
            if (_this._onError) config.trigger("error", reason, _this._label);
        });
    };
    /**
    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
    as the catch block of a try/catch statement.
  
    ```js
    function findAuthor(){
      throw new Error('couldn\'t find that author');
    }
  
    // synchronous
    try {
      findAuthor();
    } catch(reason) {
      // something went wrong
    }
  
    // async with promises
    findAuthor().catch(function(reason){
      // something went wrong
    });
    ```
  
    @method catch
    @param {Function} onRejection
    @param {String} label optional string for labeling the promise.
    Useful for tooling.
    @return {Promise}
  */ Promise.prototype.catch = function _catch(onRejection, label) {
        return this.then(undefined, onRejection, label);
    };
    /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuthor();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuthor();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @param {String} label optional string for labeling the promise.
    Useful for tooling.
    @return {Promise}
  */ Promise.prototype.finally = function _finally(callback, label) {
        var promise = this;
        var constructor = promise.constructor;
        return promise.then(function(value) {
            return constructor.resolve(callback()).then(function() {
                return value;
            });
        }, function(reason) {
            return constructor.resolve(callback()).then(function() {
                throw reason;
            });
        }, label);
    };
    return Promise;
}();
Promise.cast = resolve$1; // deprecated
Promise.all = all;
Promise.race = race;
Promise.resolve = resolve$1;
Promise.reject = reject$1;
Promise.prototype._guidKey = guidKey;
/**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.

  ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```

  Chaining
  --------

  The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.

  ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });

  findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we\'re unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we\'re unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.

  ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```

  Assimilation
  ------------

  Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.

  ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```

  If the assimliated promise rejects, then the downstream promise will also reject.

  ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```

  Simple Example
  --------------

  Synchronous Example

  ```javascript
  let result;

  try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```

  Errback Example

  ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```

  Promise Example;

  ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```

  Advanced Example
  --------------

  Synchronous Example

  ```javascript
  let author, books;

  try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```

  Errback Example

  ```js

  function foundBooks(books) {

  }

  function failure(reason) {

  }

  findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```

  Promise Example;

  ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```

  @method then
  @param {Function} onFulfillment
  @param {Function} onRejection
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise}
*/ Promise.prototype.then = then;
function Result() {
    this.value = undefined;
}
var ERROR = new Result();
var GET_THEN_ERROR$1 = new Result();
function getThen$1(obj) {
    try {
        return obj.then;
    } catch (error) {
        ERROR.value = error;
        return ERROR;
    }
}
function tryApply(f, s, a) {
    try {
        f.apply(s, a);
    } catch (error) {
        ERROR.value = error;
        return ERROR;
    }
}
function makeObject(_, argumentNames) {
    var obj = {};
    var length = _.length;
    var args = new Array(length);
    for(var x = 0; x < length; x++)args[x] = _[x];
    for(var i = 0; i < argumentNames.length; i++){
        var name = argumentNames[i];
        obj[name] = args[i + 1];
    }
    return obj;
}
function arrayResult(_) {
    var length = _.length;
    var args = new Array(length - 1);
    for(var i = 1; i < length; i++)args[i - 1] = _[i];
    return args;
}
function wrapThenable(then, promise) {
    return {
        then: function(onFulFillment, onRejection) {
            return then.call(promise, onFulFillment, onRejection);
        }
    };
}
/**
  `RSVP.denodeify` takes a 'node-style' function and returns a function that
  will return an `RSVP.Promise`. You can use `denodeify` in Node.js or the
  browser when you'd prefer to use promises over using callbacks. For example,
  `denodeify` transforms the following:

  ```javascript
  let fs = require('fs');

  fs.readFile('myfile.txt', function(err, data){
    if (err) return handleError(err);
    handleData(data);
  });
  ```

  into:

  ```javascript
  let fs = require('fs');
  let readFile = RSVP.denodeify(fs.readFile);

  readFile('myfile.txt').then(handleData, handleError);
  ```

  If the node function has multiple success parameters, then `denodeify`
  just returns the first one:

  ```javascript
  let request = RSVP.denodeify(require('request'));

  request('http://example.com').then(function(res) {
    // ...
  });
  ```

  However, if you need all success parameters, setting `denodeify`'s
  second parameter to `true` causes it to return all success parameters
  as an array:

  ```javascript
  let request = RSVP.denodeify(require('request'), true);

  request('http://example.com').then(function(result) {
    // result[0] -> res
    // result[1] -> body
  });
  ```

  Or if you pass it an array with names it returns the parameters as a hash:

  ```javascript
  let request = RSVP.denodeify(require('request'), ['res', 'body']);

  request('http://example.com').then(function(result) {
    // result.res
    // result.body
  });
  ```

  Sometimes you need to retain the `this`:

  ```javascript
  let app = require('express')();
  let render = RSVP.denodeify(app.render.bind(app));
  ```

  The denodified function inherits from the original function. It works in all
  environments, except IE 10 and below. Consequently all properties of the original
  function are available to you. However, any properties you change on the
  denodeified function won't be changed on the original function. Example:

  ```javascript
  let request = RSVP.denodeify(require('request')),
      cookieJar = request.jar(); // <- Inheritance is used here

  request('http://example.com', {jar: cookieJar}).then(function(res) {
    // cookieJar.cookies holds now the cookies returned by example.com
  });
  ```

  Using `denodeify` makes it easier to compose asynchronous operations instead
  of using callbacks. For example, instead of:

  ```javascript
  let fs = require('fs');

  fs.readFile('myfile.txt', function(err, data){
    if (err) { ... } // Handle error
    fs.writeFile('myfile2.txt', data, function(err){
      if (err) { ... } // Handle error
      console.log('done')
    });
  });
  ```

  you can chain the operations together using `then` from the returned promise:

  ```javascript
  let fs = require('fs');
  let readFile = RSVP.denodeify(fs.readFile);
  let writeFile = RSVP.denodeify(fs.writeFile);

  readFile('myfile.txt').then(function(data){
    return writeFile('myfile2.txt', data);
  }).then(function(){
    console.log('done')
  }).catch(function(error){
    // Handle error
  });
  ```

  @method denodeify
  @static
  @for RSVP
  @param {Function} nodeFunc a 'node-style' function that takes a callback as
  its last argument. The callback expects an error to be passed as its first
  argument (if an error occurred, otherwise null), and the value from the
  operation as its second argument ('function(err, value){ }').
  @param {Boolean|Array} [options] An optional paramter that if set
  to `true` causes the promise to fulfill with the callback's success arguments
  as an array. This is useful if the node function has multiple success
  paramters. If you set this paramter to an array with names, the promise will
  fulfill with a hash with these names as keys and the success parameters as
  values.
  @return {Function} a function that wraps `nodeFunc` to return an
  `RSVP.Promise`
  @static
*/ function denodeify(nodeFunc, options) {
    var fn = function() {
        var self1 = this;
        var l = arguments.length;
        var args = new Array(l + 1);
        var promiseInput = false;
        for(var i = 0; i < l; ++i){
            var arg = arguments[i];
            if (!promiseInput) {
                // TODO: clean this up
                promiseInput = needsPromiseInput(arg);
                if (promiseInput === GET_THEN_ERROR$1) {
                    var p = new Promise(noop);
                    reject(p, GET_THEN_ERROR$1.value);
                    return p;
                } else if (promiseInput && promiseInput !== true) arg = wrapThenable(promiseInput, arg);
            }
            args[i] = arg;
        }
        var promise = new Promise(noop);
        args[l] = function(err, val) {
            if (err) reject(promise, err);
            else if (options === undefined) resolve(promise, val);
            else if (options === true) resolve(promise, arrayResult(arguments));
            else if (isArray(options)) resolve(promise, makeObject(arguments, options));
            else resolve(promise, val);
        };
        if (promiseInput) return handlePromiseInput(promise, args, nodeFunc, self1);
        else return handleValueInput(promise, args, nodeFunc, self1);
    };
    fn.__proto__ = nodeFunc;
    return fn;
}
function handleValueInput(promise, args, nodeFunc, self1) {
    var result = tryApply(nodeFunc, self1, args);
    if (result === ERROR) reject(promise, result.value);
    return promise;
}
function handlePromiseInput(promise, args, nodeFunc, self1) {
    return Promise.all(args).then(function(args) {
        var result = tryApply(nodeFunc, self1, args);
        if (result === ERROR) reject(promise, result.value);
        return promise;
    });
}
function needsPromiseInput(arg) {
    if (arg && typeof arg === "object") {
        if (arg.constructor === Promise) return true;
        else return getThen$1(arg);
    } else return false;
}
/**
  This is a convenient alias for `RSVP.Promise.all`.

  @method all
  @static
  @for RSVP
  @param {Array} array Array of promises.
  @param {String} label An optional label. This is useful
  for tooling.
*/ function all$1(array, label) {
    return Promise.all(array, label);
}
function _possibleConstructorReturn(self1, call) {
    if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self1;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var AllSettled = function(_Enumerator) {
    _inherits(AllSettled, _Enumerator);
    function AllSettled(Constructor, entries, label) {
        return _possibleConstructorReturn(this, _Enumerator.call(this, Constructor, entries, false, label));
    }
    return AllSettled;
}(Enumerator);
AllSettled.prototype._makeResult = makeSettledResult;
/**
`RSVP.allSettled` is similar to `RSVP.all`, but instead of implementing
a fail-fast method, it waits until all the promises have returned and
shows you all the results. This is useful if you want to handle multiple
promises' failure states together as a set.
 Returns a promise that is fulfilled when all the given promises have been
settled. The return promise is fulfilled with an array of the states of
the promises passed into the `promises` array argument.
 Each state object will either indicate fulfillment or rejection, and
provide the corresponding value or reason. The states will take one of
the following formats:
 ```javascript
{ state: 'fulfilled', value: value }
  or
{ state: 'rejected', reason: reason }
```
 Example:
 ```javascript
let promise1 = RSVP.Promise.resolve(1);
let promise2 = RSVP.Promise.reject(new Error('2'));
let promise3 = RSVP.Promise.reject(new Error('3'));
let promises = [ promise1, promise2, promise3 ];
 RSVP.allSettled(promises).then(function(array){
  // array == [
  //   { state: 'fulfilled', value: 1 },
  //   { state: 'rejected', reason: Error },
  //   { state: 'rejected', reason: Error }
  // ]
  // Note that for the second item, reason.message will be '2', and for the
  // third item, reason.message will be '3'.
}, function(error) {
  // Not run. (This block would only be called if allSettled had failed,
  // for instance if passed an incorrect argument type.)
});
```
 @method allSettled
@static
@for RSVP
@param {Array} entries
@param {String} label - optional string that describes the promise.
Useful for tooling.
@return {Promise} promise that is fulfilled with an array of the settled
states of the constituent promises.
*/ function allSettled(entries, label) {
    if (!isArray(entries)) return Promise.reject(new TypeError("Promise.allSettled must be called with an array"), label);
    return new AllSettled(Promise, entries, label).promise;
}
/**
  This is a convenient alias for `RSVP.Promise.race`.

  @method race
  @static
  @for RSVP
  @param {Array} array Array of promises.
  @param {String} label An optional label. This is useful
  for tooling.
 */ function race$1(array, label) {
    return Promise.race(array, label);
}
function _possibleConstructorReturn$1(self1, call) {
    if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self1;
}
function _inherits$1(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var hasOwnProperty = Object.prototype.hasOwnProperty;
var PromiseHash = function(_Enumerator) {
    _inherits$1(PromiseHash, _Enumerator);
    function PromiseHash(Constructor, object) {
        var abortOnReject = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        var label = arguments[3];
        return _possibleConstructorReturn$1(this, _Enumerator.call(this, Constructor, object, abortOnReject, label));
    }
    PromiseHash.prototype._init = function _init(Constructor, object) {
        this._result = {};
        this._enumerate(object);
        if (this._remaining === 0) fulfill(this.promise, this._result);
    };
    PromiseHash.prototype._enumerate = function _enumerate(input) {
        var promise = this.promise;
        var results = [];
        for(var key in input)if (hasOwnProperty.call(input, key)) results.push({
            position: key,
            entry: input[key]
        });
        var length = results.length;
        this._remaining = length;
        var result = void 0;
        for(var i = 0; promise._state === PENDING && i < length; i++){
            result = results[i];
            this._eachEntry(result.entry, result.position);
        }
    };
    return PromiseHash;
}(Enumerator);
/**
  `RSVP.hash` is similar to `RSVP.all`, but takes an object instead of an array
  for its `promises` argument.

  Returns a promise that is fulfilled when all the given promises have been
  fulfilled, or rejected if any of them become rejected. The returned promise
  is fulfilled with a hash that has the same key names as the `promises` object
  argument. If any of the values in the object are not promises, they will
  simply be copied over to the fulfilled object.

  Example:

  ```javascript
  let promises = {
    myPromise: RSVP.resolve(1),
    yourPromise: RSVP.resolve(2),
    theirPromise: RSVP.resolve(3),
    notAPromise: 4
  };

  RSVP.hash(promises).then(function(hash){
    // hash here is an object that looks like:
    // {
    //   myPromise: 1,
    //   yourPromise: 2,
    //   theirPromise: 3,
    //   notAPromise: 4
    // }
  });
  ````

  If any of the `promises` given to `RSVP.hash` are rejected, the first promise
  that is rejected will be given as the reason to the rejection handler.

  Example:

  ```javascript
  let promises = {
    myPromise: RSVP.resolve(1),
    rejectedPromise: RSVP.reject(new Error('rejectedPromise')),
    anotherRejectedPromise: RSVP.reject(new Error('anotherRejectedPromise')),
  };

  RSVP.hash(promises).then(function(hash){
    // Code here never runs because there are rejected promises!
  }, function(reason) {
    // reason.message === 'rejectedPromise'
  });
  ```

  An important note: `RSVP.hash` is intended for plain JavaScript objects that
  are just a set of keys and values. `RSVP.hash` will NOT preserve prototype
  chains.

  Example:

  ```javascript
  function MyConstructor(){
    this.example = RSVP.resolve('Example');
  }

  MyConstructor.prototype = {
    protoProperty: RSVP.resolve('Proto Property')
  };

  let myObject = new MyConstructor();

  RSVP.hash(myObject).then(function(hash){
    // protoProperty will not be present, instead you will just have an
    // object that looks like:
    // {
    //   example: 'Example'
    // }
    //
    // hash.hasOwnProperty('protoProperty'); // false
    // 'undefined' === typeof hash.protoProperty
  });
  ```

  @method hash
  @static
  @for RSVP
  @param {Object} object
  @param {String} label optional string that describes the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all properties of `promises`
  have been fulfilled, or rejected if any of them become rejected.
*/ function hash(object, label) {
    if (!isObject(object)) return Promise.reject(new TypeError("Promise.hash must be called with an object"), label);
    return new PromiseHash(Promise, object, label).promise;
}
function _possibleConstructorReturn$2(self1, call) {
    if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self1;
}
function _inherits$2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var HashSettled = function(_PromiseHash) {
    _inherits$2(HashSettled, _PromiseHash);
    function HashSettled(Constructor, object, label) {
        return _possibleConstructorReturn$2(this, _PromiseHash.call(this, Constructor, object, false, label));
    }
    return HashSettled;
}(PromiseHash);
HashSettled.prototype._makeResult = makeSettledResult;
/**
  `RSVP.hashSettled` is similar to `RSVP.allSettled`, but takes an object
  instead of an array for its `promises` argument.

  Unlike `RSVP.all` or `RSVP.hash`, which implement a fail-fast method,
  but like `RSVP.allSettled`, `hashSettled` waits until all the
  constituent promises have returned and then shows you all the results
  with their states and values/reasons. This is useful if you want to
  handle multiple promises' failure states together as a set.

  Returns a promise that is fulfilled when all the given promises have been
  settled, or rejected if the passed parameters are invalid.

  The returned promise is fulfilled with a hash that has the same key names as
  the `promises` object argument. If any of the values in the object are not
  promises, they will be copied over to the fulfilled object and marked with state
  'fulfilled'.

  Example:

  ```javascript
  let promises = {
    myPromise: RSVP.Promise.resolve(1),
    yourPromise: RSVP.Promise.resolve(2),
    theirPromise: RSVP.Promise.resolve(3),
    notAPromise: 4
  };

  RSVP.hashSettled(promises).then(function(hash){
    // hash here is an object that looks like:
    // {
    //   myPromise: { state: 'fulfilled', value: 1 },
    //   yourPromise: { state: 'fulfilled', value: 2 },
    //   theirPromise: { state: 'fulfilled', value: 3 },
    //   notAPromise: { state: 'fulfilled', value: 4 }
    // }
  });
  ```

  If any of the `promises` given to `RSVP.hash` are rejected, the state will
  be set to 'rejected' and the reason for rejection provided.

  Example:

  ```javascript
  let promises = {
    myPromise: RSVP.Promise.resolve(1),
    rejectedPromise: RSVP.Promise.reject(new Error('rejection')),
    anotherRejectedPromise: RSVP.Promise.reject(new Error('more rejection')),
  };

  RSVP.hashSettled(promises).then(function(hash){
    // hash here is an object that looks like:
    // {
    //   myPromise:              { state: 'fulfilled', value: 1 },
    //   rejectedPromise:        { state: 'rejected', reason: Error },
    //   anotherRejectedPromise: { state: 'rejected', reason: Error },
    // }
    // Note that for rejectedPromise, reason.message == 'rejection',
    // and for anotherRejectedPromise, reason.message == 'more rejection'.
  });
  ```

  An important note: `RSVP.hashSettled` is intended for plain JavaScript objects that
  are just a set of keys and values. `RSVP.hashSettled` will NOT preserve prototype
  chains.

  Example:

  ```javascript
  function MyConstructor(){
    this.example = RSVP.Promise.resolve('Example');
  }

  MyConstructor.prototype = {
    protoProperty: RSVP.Promise.resolve('Proto Property')
  };

  let myObject = new MyConstructor();

  RSVP.hashSettled(myObject).then(function(hash){
    // protoProperty will not be present, instead you will just have an
    // object that looks like:
    // {
    //   example: { state: 'fulfilled', value: 'Example' }
    // }
    //
    // hash.hasOwnProperty('protoProperty'); // false
    // 'undefined' === typeof hash.protoProperty
  });
  ```

  @method hashSettled
  @for RSVP
  @param {Object} object
  @param {String} label optional string that describes the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when when all properties of `promises`
  have been settled.
  @static
*/ function hashSettled(object, label) {
    if (!isObject(object)) return Promise.reject(new TypeError("RSVP.hashSettled must be called with an object"), label);
    return new HashSettled(Promise, object, false, label).promise;
}
/**
  `RSVP.rethrow` will rethrow an error on the next turn of the JavaScript event
  loop in order to aid debugging.

  Promises A+ specifies that any exceptions that occur with a promise must be
  caught by the promises implementation and bubbled to the last handler. For
  this reason, it is recommended that you always specify a second rejection
  handler function to `then`. However, `RSVP.rethrow` will throw the exception
  outside of the promise, so it bubbles up to your console if in the browser,
  or domain/cause uncaught exception in Node. `rethrow` will also throw the
  error again so the error can be handled by the promise per the spec.

  ```javascript
  function throws(){
    throw new Error('Whoops!');
  }

  let promise = new RSVP.Promise(function(resolve, reject){
    throws();
  });

  promise.catch(RSVP.rethrow).then(function(){
    // Code here doesn't run because the promise became rejected due to an
    // error!
  }, function (err){
    // handle the error here
  });
  ```

  The 'Whoops' error will be thrown on the next turn of the event loop
  and you can watch for it in your console. You can also handle it using a
  rejection handler given to `.then` or `.catch` on the returned promise.

  @method rethrow
  @static
  @for RSVP
  @param {Error} reason reason the promise became rejected.
  @throws Error
  @static
*/ function rethrow(reason) {
    setTimeout(function() {
        throw reason;
    });
    throw reason;
}
/**
  `RSVP.defer` returns an object similar to jQuery's `$.Deferred`.
  `RSVP.defer` should be used when porting over code reliant on `$.Deferred`'s
  interface. New code should use the `RSVP.Promise` constructor instead.

  The object returned from `RSVP.defer` is a plain object with three properties:

  * promise - an `RSVP.Promise`.
  * reject - a function that causes the `promise` property on this object to
    become rejected
  * resolve - a function that causes the `promise` property on this object to
    become fulfilled.

  Example:

   ```javascript
   let deferred = RSVP.defer();

   deferred.resolve("Success!");

   deferred.promise.then(function(value){
     // value here is "Success!"
   });
   ```

  @method defer
  @static
  @for RSVP
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Object}
 */ function defer(label) {
    var deferred = {
        resolve: undefined,
        reject: undefined
    };
    deferred.promise = new Promise(function(resolve, reject) {
        deferred.resolve = resolve;
        deferred.reject = reject;
    }, label);
    return deferred;
}
/**
 `RSVP.map` is similar to JavaScript's native `map` method, except that it
  waits for all promises to become fulfilled before running the `mapFn` on
  each item in given to `promises`. `RSVP.map` returns a promise that will
  become fulfilled with the result of running `mapFn` on the values the promises
  become fulfilled with.

  For example:

  ```javascript

  let promise1 = RSVP.resolve(1);
  let promise2 = RSVP.resolve(2);
  let promise3 = RSVP.resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  let mapFn = function(item){
    return item + 1;
  };

  RSVP.map(promises, mapFn).then(function(result){
    // result is [ 2, 3, 4 ]
  });
  ```

  If any of the `promises` given to `RSVP.map` are rejected, the first promise
  that is rejected will be given as an argument to the returned promise's
  rejection handler. For example:

  ```javascript
  let promise1 = RSVP.resolve(1);
  let promise2 = RSVP.reject(new Error('2'));
  let promise3 = RSVP.reject(new Error('3'));
  let promises = [ promise1, promise2, promise3 ];

  let mapFn = function(item){
    return item + 1;
  };

  RSVP.map(promises, mapFn).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(reason) {
    // reason.message === '2'
  });
  ```

  `RSVP.map` will also wait if a promise is returned from `mapFn`. For example,
  say you want to get all comments from a set of blog posts, but you need
  the blog posts first because they contain a url to those comments.

  ```javscript

  let mapFn = function(blogPost){
    // getComments does some ajax and returns an RSVP.Promise that is fulfilled
    // with some comments data
    return getComments(blogPost.comments_url);
  };

  // getBlogPosts does some ajax and returns an RSVP.Promise that is fulfilled
  // with some blog post data
  RSVP.map(getBlogPosts(), mapFn).then(function(comments){
    // comments is the result of asking the server for the comments
    // of all blog posts returned from getBlogPosts()
  });
  ```

  @method map
  @static
  @for RSVP
  @param {Array} promises
  @param {Function} mapFn function to be called on each fulfilled promise.
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled with the result of calling
  `mapFn` on each fulfilled promise or value when they become fulfilled.
   The promise will be rejected if any of the given `promises` become rejected.
  @static
*/ function map(promises, mapFn, label) {
    if (!isArray(promises)) return Promise.reject(new TypeError("RSVP.map must be called with an array"), label);
    if (!isFunction(mapFn)) return Promise.reject(new TypeError("RSVP.map expects a function as a second argument"), label);
    return Promise.all(promises, label).then(function(values) {
        var length = values.length;
        var results = new Array(length);
        for(var i = 0; i < length; i++)results[i] = mapFn(values[i]);
        return Promise.all(results, label);
    });
}
/**
  This is a convenient alias for `RSVP.Promise.resolve`.

  @method resolve
  @static
  @for RSVP
  @param {*} value value that the returned promise will be resolved with
  @param {String} label optional string for identifying the returned promise.
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/ function resolve$2(value, label) {
    return Promise.resolve(value, label);
}
/**
  This is a convenient alias for `RSVP.Promise.reject`.

  @method reject
  @static
  @for RSVP
  @param {*} reason value that the returned promise will be rejected with.
  @param {String} label optional string for identifying the returned promise.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/ function reject$2(reason, label) {
    return Promise.reject(reason, label);
}
/**
 `RSVP.filter` is similar to JavaScript's native `filter` method, except that it
  waits for all promises to become fulfilled before running the `filterFn` on
  each item in given to `promises`. `RSVP.filter` returns a promise that will
  become fulfilled with the result of running `filterFn` on the values the
  promises become fulfilled with.

  For example:

  ```javascript

  let promise1 = RSVP.resolve(1);
  let promise2 = RSVP.resolve(2);
  let promise3 = RSVP.resolve(3);

  let promises = [promise1, promise2, promise3];

  let filterFn = function(item){
    return item > 1;
  };

  RSVP.filter(promises, filterFn).then(function(result){
    // result is [ 2, 3 ]
  });
  ```

  If any of the `promises` given to `RSVP.filter` are rejected, the first promise
  that is rejected will be given as an argument to the returned promise's
  rejection handler. For example:

  ```javascript
  let promise1 = RSVP.resolve(1);
  let promise2 = RSVP.reject(new Error('2'));
  let promise3 = RSVP.reject(new Error('3'));
  let promises = [ promise1, promise2, promise3 ];

  let filterFn = function(item){
    return item > 1;
  };

  RSVP.filter(promises, filterFn).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(reason) {
    // reason.message === '2'
  });
  ```

  `RSVP.filter` will also wait for any promises returned from `filterFn`.
  For instance, you may want to fetch a list of users then return a subset
  of those users based on some asynchronous operation:

  ```javascript

  let alice = { name: 'alice' };
  let bob   = { name: 'bob' };
  let users = [ alice, bob ];

  let promises = users.map(function(user){
    return RSVP.resolve(user);
  });

  let filterFn = function(user){
    // Here, Alice has permissions to create a blog post, but Bob does not.
    return getPrivilegesForUser(user).then(function(privs){
      return privs.can_create_blog_post === true;
    });
  };
  RSVP.filter(promises, filterFn).then(function(users){
    // true, because the server told us only Alice can create a blog post.
    users.length === 1;
    // false, because Alice is the only user present in `users`
    users[0] === bob;
  });
  ```

  @method filter
  @static
  @for RSVP
  @param {Array} promises
  @param {Function} filterFn - function to be called on each resolved value to
  filter the final results.
  @param {String} label optional string describing the promise. Useful for
  tooling.
  @return {Promise}
*/ function resolveAll(promises, label) {
    return Promise.all(promises, label);
}
function resolveSingle(promise, label) {
    return Promise.resolve(promise, label).then(function(promises) {
        return resolveAll(promises, label);
    });
}
function filter(promises, filterFn, label) {
    if (!isArray(promises) && !(isObject(promises) && promises.then !== undefined)) return Promise.reject(new TypeError("RSVP.filter must be called with an array or promise"), label);
    if (!isFunction(filterFn)) return Promise.reject(new TypeError("RSVP.filter expects function as a second argument"), label);
    var promise = isArray(promises) ? resolveAll(promises, label) : resolveSingle(promises, label);
    return promise.then(function(values) {
        var length = values.length;
        var filtered = new Array(length);
        for(var i = 0; i < length; i++)filtered[i] = filterFn(values[i]);
        return resolveAll(filtered, label).then(function(filtered) {
            var results = new Array(length);
            var newLength = 0;
            for(var _i = 0; _i < length; _i++)if (filtered[_i]) {
                results[newLength] = values[_i];
                newLength++;
            }
            results.length = newLength;
            return results;
        });
    });
}
var len = 0;
var vertxNext = void 0;
function asap(callback, arg) {
    queue$1[len] = callback;
    queue$1[len + 1] = arg;
    len += 2;
    if (len === 2) // If len is 1, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    scheduleFlush$1();
}
var browserWindow = typeof window !== "undefined" ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === "undefined" && typeof $2Prz7 !== "undefined" && ({}).toString.call($2Prz7) === "[object process]";
// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== "undefined" && typeof importScripts !== "undefined" && typeof MessageChannel !== "undefined";
// node
function useNextTick() {
    var nextTick = $2Prz7.nextTick;
    // node version 0.10.x displays a deprecation warning when nextTick is used recursively
    // setImmediate should be used instead instead
    var version = $2Prz7.versions.node.match(/^(?:(\d+)\.)?(?:(\d+)\.)?(\*|\d+)$/);
    if (Array.isArray(version) && version[1] === "0" && version[2] === "10") nextTick = setImmediate;
    return function() {
        return nextTick(flush);
    };
}
// vertx
function useVertxTimer() {
    if (typeof vertxNext !== "undefined") return function() {
        vertxNext(flush);
    };
    return useSetTimeout();
}
function useMutationObserver() {
    var iterations = 0;
    var observer = new BrowserMutationObserver(flush);
    var node = document.createTextNode("");
    observer.observe(node, {
        characterData: true
    });
    return function() {
        return node.data = iterations = ++iterations % 2;
    };
}
// web worker
function useMessageChannel() {
    var channel = new MessageChannel();
    channel.port1.onmessage = flush;
    return function() {
        return channel.port2.postMessage(0);
    };
}
function useSetTimeout() {
    return function() {
        return setTimeout(flush, 1);
    };
}
var queue$1 = new Array(1000);
function flush() {
    for(var i = 0; i < len; i += 2){
        var callback = queue$1[i];
        var arg = queue$1[i + 1];
        callback(arg);
        queue$1[i] = undefined;
        queue$1[i + 1] = undefined;
    }
    len = 0;
}
function attemptVertex() {
    try {
        var r = undefined;
        var vertx = r("vertx");
        vertxNext = vertx.runOnLoop || vertx.runOnContext;
        return useVertxTimer();
    } catch (e) {
        return useSetTimeout();
    }
}
var scheduleFlush$1 = void 0;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) scheduleFlush$1 = useNextTick();
else if (BrowserMutationObserver) scheduleFlush$1 = useMutationObserver();
else if (isWorker) scheduleFlush$1 = useMessageChannel();
else if (browserWindow === undefined && true) scheduleFlush$1 = attemptVertex();
else scheduleFlush$1 = useSetTimeout();
var platform = void 0;
/* global self */ if (typeof self === "object") platform = self;
else if (typeof $parcel$global === "object") platform = $parcel$global;
else throw new Error("no global: `self` or `global` found");
var _asap$cast$Promise$Ev;
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// defaults
config.async = asap;
config.after = function(cb) {
    return setTimeout(cb, 0);
};
var cast = resolve$2;
var async = function(callback, arg) {
    return config.async(callback, arg);
};
function on() {
    config["on"].apply(config, arguments);
}
function off() {
    config["off"].apply(config, arguments);
}
// Set up instrumentation through `window.__PROMISE_INTRUMENTATION__`
if (typeof window !== "undefined" && typeof window["__PROMISE_INSTRUMENTATION__"] === "object") {
    var callbacks = window["__PROMISE_INSTRUMENTATION__"];
    configure("instrument", true);
    for(var eventName in callbacks)if (callbacks.hasOwnProperty(eventName)) on(eventName, callbacks[eventName]);
}
// the default export here is for backwards compat:
//   https://github.com/tildeio/rsvp.js/issues/434
var rsvp = (_asap$cast$Promise$Ev = {
    asap: asap,
    cast: cast,
    Promise: Promise,
    EventTarget: EventTarget,
    all: all$1,
    allSettled: allSettled,
    race: race$1,
    hash: hash,
    hashSettled: hashSettled,
    rethrow: rethrow,
    defer: defer,
    denodeify: denodeify,
    configure: configure,
    on: on,
    off: off,
    resolve: resolve$2,
    reject: reject$2,
    map: map
}, _defineProperty(_asap$cast$Promise$Ev, "async", async), _defineProperty(_asap$cast$Promise$Ev, "filter", filter), _asap$cast$Promise$Ev);
var $13eaf06d3a42db54$export$2e2bcd8739ae039 = rsvp;

});




parcelRegister("9S1YO", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $72fab157b72d1f99$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");

var $klEb5 = parcelRequire("klEb5");

var $5PXcS = parcelRequire("5PXcS");
const $72fab157b72d1f99$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_public/register")({
    component: $72fab157b72d1f99$var$Wrapper,
    errorComponent: ({ error: error, reset: reset })=>{
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    }
});
function $72fab157b72d1f99$var$Wrapper() {
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $klEb5.default), {
            ...$72fab157b72d1f99$export$e7b0ac011bb776c6.useParams(),
            ...$72fab157b72d1f99$export$e7b0ac011bb776c6.useSearch()
        })
    });
}

});
parcelRegister("klEb5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed04ef493765a100$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $02LyB = parcelRequire("02LyB");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $52dEm = parcelRequire("52dEm");

var $1BTI2 = parcelRequire("1BTI2");
parcelRequire("fEtu5");
var $zyiwQ = parcelRequire("zyiwQ");

var $iKbxs = parcelRequire("iKbxs");

var $kqlQp = parcelRequire("kqlQp");
var $6UBLf = parcelRequire("6UBLf");

var $8kZ1o = parcelRequire("8kZ1o");

var $hzmaq = parcelRequire("hzmaq");

var $3H03w = parcelRequire("3H03w");

var $ed04ef493765a100$export$2e2bcd8739ae039 = (0, $1EEMt.observer)((props)=>{
    const navigate = (0, $6UBLf.useNavigate)();
    const [userAlreadyExists, setUserAlreadyExists] = (0, $jbmdS.useState)(false);
    const [email, setEmail] = (0, $jbmdS.useState)(props.email || "");
    const [password, setPassword] = (0, $jbmdS.useState)("");
    const [acceptedToc, setAcceptedToc] = (0, $jbmdS.useState)(false);
    const [registerState, setRegisterState] = (0, $jbmdS.useState)("idle");
    const isUsingNewLogin = (0, $8kZ1o.usingNewLogin)();
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "flex items-center justify-center text-center w-full h-full",
        children: /*#__PURE__*/ (0, $61Ea1.jsx)("section", {
            className: "flex items-center justify-center flex-col w-[350px]",
            children: !isUsingNewLogin ? /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("header", {
                        className: "flex items-center justify-center flex-col w-full",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "logo2 s75 size-[10em] flex items-center justify-center",
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)("img", {
                                    src: new URL((parcelRequire("hw9H4"))),
                                    alt: "Coincraft Logo",
                                    style: {
                                        marginBottom: isUsingNewLogin ? "4rem" : "0rem"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("h1", {
                                style: {
                                    fontSize: "5em"
                                },
                                children: "coincraft"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "body w-full",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("h4", {
                                style: {
                                    margin: "0em -2em 1em"
                                },
                                children: "Please enter your email address and select a password"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("form", {
                                name: "registerForm",
                                className: "no-margin",
                                noValidate: true,
                                children: /*#__PURE__*/ (0, $61Ea1.jsxs)("fieldset", {
                                    children: [
                                        /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                            className: "form-group mb-5",
                                            children: [
                                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                    className: "input-group input-group-lg",
                                                    children: /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
                                                        name: "email",
                                                        type: "email",
                                                        required: true,
                                                        value: email || "",
                                                        onChange: (e)=>setEmail(e.target.value),
                                                        className: "form-control input-lg login-widget__email-input input-base w-full h-10 py-2 focus:outline-none hover:border-[#618fb0]",
                                                        placeholder: "Your Email"
                                                    })
                                                }),
                                                registerState === "error" && !email.length ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                                    className: "popover error-message-popover bottom",
                                                    children: [
                                                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                            className: "arrow"
                                                        }),
                                                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                            className: "popover-content",
                                                            children: "Please enter your e-mail address."
                                                        })
                                                    ]
                                                }) : null
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                    className: "input-group input-group-lg",
                                                    children: /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
                                                        type: "password",
                                                        name: "password",
                                                        value: password || "",
                                                        onChange: (e)=>setPassword(e.target.value),
                                                        required: true,
                                                        className: "form-control input-lg login-widget__email-input input-base w-full h-10 py-2 focus:outline-none hover:border-[#618fb0]",
                                                        placeholder: "Your Password"
                                                    })
                                                }),
                                                registerState === "error" && !password.length ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                                    className: "popover error-message-popover bottom",
                                                    children: [
                                                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                            className: "arrow"
                                                        }),
                                                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                            className: "popover-content",
                                                            children: "Please enter a password for your account."
                                                        })
                                                    ]
                                                }) : null,
                                                userAlreadyExists ? /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $zyiwQ.ErrorAlert), {
                                                    children: [
                                                        "A user already exists with the email address you entered. Have you",
                                                        " ",
                                                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqlQp.Link), {
                                                            to: `forgotten-password?email=${email}`,
                                                            className: "forgot",
                                                            children: "forgotten your password?"
                                                        })
                                                    ]
                                                }) : null
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                            className: "control-group",
                                            style: {
                                                textAlign: "left"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                    className: "controls form-group",
                                                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                                                        className: "login-widget__toc-checkbox",
                                                        label: /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                                                            className: "text-[#666]",
                                                            children: [
                                                                "I agree to the Coincraft ",
                                                                /*#__PURE__*/ (0, $61Ea1.jsx)("a", {
                                                                    href: "http://www.coincraft.co/terms-of-service",
                                                                    target: "_blank",
                                                                    children: "Terms of Service"
                                                                })
                                                            ]
                                                        }),
                                                        value: acceptedToc,
                                                        onChange: (v)=>setAcceptedToc(v)
                                                    })
                                                }),
                                                registerState === "error" && !acceptedToc ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                                    className: "popover error-message-popover bottom",
                                                    children: [
                                                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                            className: "arrow",
                                                            style: {
                                                                left: "10%"
                                                            }
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                            className: "popover-content",
                                                            children: "Sorry, you need to accept our Terms of Service before we can create your account."
                                                        })
                                                    ]
                                                }) : null
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                className: "form-actions flex flex-col w-full mt-5",
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsxs)("button", {
                                        onClick: ()=>{
                                            if (!email.length || !password.length || !acceptedToc) setRegisterState("error");
                                            else {
                                                setRegisterState("pending");
                                                (0, $1BTI2.default).register(email, password).then(()=>{
                                                    setRegisterState("success");
                                                    navigate({
                                                        to: "/register-details"
                                                    });
                                                }).catch(function(error) {
                                                    $iKbxs.captureException(error);
                                                    (0, $3H03w.default).captureException(error);
                                                    setRegisterState("error");
                                                });
                                            }
                                        },
                                        className: "btn btn-block btn-lg btn-info login-widget__create-account-button py-2.5",
                                        disabled: registerState === "pending",
                                        children: [
                                            /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("fa fa-fw", registerState === "pending" ? "fa-spinner fa-spin" : "fa-plus")
                                            }),
                                            " ",
                                            registerState === "pending" ? "Creating Account..." : "Create a New Account"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        className: "forgot py-4 mt-3.5",
                                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqlQp.Link), {
                                            to: `/login?email=${email}`,
                                            className: "forgot underline text-[1.2em] text-[#808080] text-center",
                                            children: "Log Into Your Existing Account"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hzmaq.SignUp), {
                signInUrl: "/login",
                forceRedirectUrl: "/sign-up"
            })
        })
    });
});

});


parcelRegister("ci48B", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $8f2a6020e4edae3e$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");

var $7bL5p = parcelRequire("7bL5p");

var $5PXcS = parcelRequire("5PXcS");

var $4iw5i = parcelRequire("4iw5i");
const $8f2a6020e4edae3e$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_public/login")({
    component: $8f2a6020e4edae3e$var$Wrapper,
    pendingComponent: (0, $4iw5i.default),
    errorComponent: ({ error: error, reset: reset })=>{
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    }
});
function $8f2a6020e4edae3e$var$Wrapper() {
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7bL5p.default), {
            ...$8f2a6020e4edae3e$export$e7b0ac011bb776c6.useParams(),
            ...$8f2a6020e4edae3e$export$e7b0ac011bb776c6.useSearch()
        })
    });
}

});
parcelRegister("7bL5p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53be15d42577e79e$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $02LyB = parcelRequire("02LyB");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $1BTI2 = parcelRequire("1BTI2");
parcelRequire("fEtu5");
var $zyiwQ = parcelRequire("zyiwQ");

var $iKbxs = parcelRequire("iKbxs");

var $kqlQp = parcelRequire("kqlQp");
var $6UBLf = parcelRequire("6UBLf");

var $8kZ1o = parcelRequire("8kZ1o");

var $hzmaq = parcelRequire("hzmaq");

var $3H03w = parcelRequire("3H03w");

var $53be15d42577e79e$export$2e2bcd8739ae039 = (0, $1EEMt.observer)((props)=>{
    const navigate = (0, $6UBLf.useNavigate)();
    const [loginState, setLoginState] = (0, $jbmdS.useState)("idle");
    const [email, setEmail] = (0, $jbmdS.useState)(props.email || "");
    const [password, setPassword] = (0, $jbmdS.useState)("");
    const isUsingNewLogin = (0, $8kZ1o.usingNewLogin)();
    const handleSubmit = async (event)=>{
        event.preventDefault();
        setLoginState("pending");
        try {
            await (0, $1BTI2.default).clearCache();
            await (0, $1BTI2.default).login({
                email: email,
                password: password
            });
            setLoginState("success");
            navigate({
                to: (0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "projectList") ? "/projects" : "/timesheets"
            });
        } catch (error) {
            $iKbxs.captureException(error);
            (0, $3H03w.default).captureException(error);
            setLoginState("error");
        }
    };
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "flex items-center justify-center text-center w-full h-full",
        children: /*#__PURE__*/ (0, $61Ea1.jsx)("section", {
            className: "flex items-center justify-center flex-col w-[350px]",
            children: !isUsingNewLogin ? /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("header", {
                        className: "flex items-center justify-center flex-col w-full",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "logo2 s75 size-[10em] flex items-center justify-center",
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)("img", {
                                    src: new URL((parcelRequire("hw9H4"))),
                                    alt: "Coincraft Logo"
                                })
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("h1", {
                                style: {
                                    fontSize: "5em"
                                },
                                children: "coincraft"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "body w-full",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsxs)("form", {
                                onSubmit: handleSubmit,
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        className: "form-group mb-5",
                                        children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                            className: "input-group input-group-lg",
                                            children: /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
                                                value: email || "",
                                                onChange: (e)=>setEmail(e.target.value),
                                                type: "email",
                                                className: "form-control input-lg login-widget__email-input input-base w-full h-10 py-2 focus:outline-none hover:border-[#618fb0]",
                                                placeholder: "Your Email"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        className: "form-group mb-5",
                                        children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                            className: "input-group input-group-lg",
                                            children: /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
                                                type: "password",
                                                value: password || "",
                                                onChange: (e)=>setPassword(e.target.value),
                                                className: "form-control input-lg login-widget__password-input input-base w-full h-10 py-2 focus:outline-none hover:border-[#618fb0]",
                                                placeholder: "Your Password"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        className: "form-actions flex flex-col w-full mt-5",
                                        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("button", {
                                            type: "submit",
                                            className: "btn btn-block btn-lg btn-primary w-full flex justify-center py-2.5 mt-1.5",
                                            disabled: loginState === "pending",
                                            children: [
                                                /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("fa fa-fw mr-2.5 w-5", loginState === "pending" ? "fa-spinner fa-spin" : "fa-user")
                                                }),
                                                " ",
                                                "Sign In"
                                            ]
                                        })
                                    })
                                ]
                            }),
                            loginState === "error" && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $zyiwQ.ErrorAlert), {
                                children: `Sorry, we couldn't log you in with those details. Please try again.`
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                className: "form-actions",
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsxs)("button", {
                                        style: {
                                            marginTop: "0.5em"
                                        },
                                        onClick: ()=>navigate({
                                                to: `/register?email=${email}`
                                            }),
                                        className: "btn btn-block btn-lg btn-info login-widget__to-register w-full flex justify-center mt-1.5 py-2.5",
                                        children: [
                                            /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                                className: "fa fa-fw fa-plus mr-2.5 w-5"
                                            }),
                                            " ",
                                            "Create a New Account"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        className: "forgot py-4 mt-3.5",
                                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqlQp.Link), {
                                            to: `/forgotten-password?email=${email}`,
                                            className: "forgot underline  text-[1.2em] text-[#808080] text-center",
                                            children: "Forgotten Your Password?"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hzmaq.SignIn), {
                signUpUrl: "/register",
                forceRedirectUrl: "/sign-in"
            })
        })
    });
});

});


parcelRegister("463Z5", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $2fbad02c1f249050$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");

var $aYP6v = parcelRequire("aYP6v");

var $5PXcS = parcelRequire("5PXcS");
const $2fbad02c1f249050$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_public/invite")({
    component: $2fbad02c1f249050$var$Wrapper,
    errorComponent: ({ error: error, reset: reset })=>{
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    }
});
function $2fbad02c1f249050$var$Wrapper() {
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $aYP6v.default), {
            ...$2fbad02c1f249050$export$e7b0ac011bb776c6.useParams(),
            ...$2fbad02c1f249050$export$e7b0ac011bb776c6.useSearch()
        })
    });
}

});
parcelRegister("aYP6v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7fe72626fd70178e$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $9mNEQ = parcelRequire("9mNEQ");

var $4iw5i = parcelRequire("4iw5i");

var $iKbxs = parcelRequire("iKbxs");

var $1BTI2 = parcelRequire("1BTI2");

var $iOQGT = parcelRequire("iOQGT");

var $6UBLf = parcelRequire("6UBLf");

var $8kZ1o = parcelRequire("8kZ1o");

var $3H03w = parcelRequire("3H03w");

var $7fe72626fd70178e$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ token: token, redirect: redirect })=>{
    const navigate = (0, $6UBLf.useNavigate)();
    const [password, setPassword] = (0, $jbmdS.useState)("");
    const [resetState, setResetState] = (0, $jbmdS.useState)("idle");
    const [validToken, setValidToken] = (0, $jbmdS.useState)(null);
    (0, $jbmdS.useEffect)(()=>{
        (0, $iOQGT.makeRequest)({
            path: "https://api.coincraft.co/api/v1.5/user/verify-token",
            method: "post",
            data: {
                token: token
            }
        }).then((response)=>{
            setValidToken(true);
        }).catch((error)=>{
            $iKbxs.captureException(error);
            (0, $3H03w.default).captureException(error);
            setValidToken(false);
            (0, $9mNEQ.default)(1000).then(()=>{
                navigate({
                    to: "/login"
                });
            });
        });
    }, [
        token,
        navigate
    ]);
    const handleSubmit = (event)=>{
        event.preventDefault();
        setResetState("pending");
        (0, $iOQGT.makeRequest)({
            path: "https://api.coincraft.co/api/v1.5/user/reset-password",
            method: "post",
            data: {
                password: password,
                token: token
            }
        }).then((response)=>{
            (0, $1BTI2.default).saveLoginResponse(response);
            navigate({
                to: redirect || ((0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "projectList") ? "/projects" : "/timesheets")
            });
        }).catch((error)=>{
            $iKbxs.captureException(error);
            (0, $3H03w.default).captureException(error);
            navigate({
                to: "/login"
            });
        });
    };
    if (validToken === null) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $4iw5i.default), {});
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "flex items-center justify-center text-center w-full h-full",
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("section", {
            className: "flex flex-col items-center justify-center w-[350px]",
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsxs)("header", {
                    className: "flex items-center flex-col justify-center",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            className: "logo2 s75 size-[10em] flex items-center justify-center",
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)("img", {
                                src: new URL((parcelRequire("hw9H4"))),
                                alt: "Coincraft Logo"
                            })
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)("h1", {
                            style: {
                                fontSize: "5em"
                            },
                            children: "coincraft"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    className: "body w-full",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("h4", {
                            style: {
                                margin: "0em -2em 1em",
                                fontSize: "1.5em"
                            },
                            children: validToken ? "Welcome To Coincraft" : "Link expired..."
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)("p", {
                            children: "Please enter a password to set up your account."
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("form", {
                            name: "forgottenPasswordForm",
                            className: "no-margin",
                            onSubmit: handleSubmit,
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("fieldset", {
                                    children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        className: "form-group no-margin",
                                        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                            className: "input-group input-group-lg",
                                            children: [
                                                /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                                    className: "input-group-addon",
                                                    children: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                                        className: "eicon-user"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
                                                    value: password || "",
                                                    onChange: (e)=>setPassword(e.target.value),
                                                    type: "password",
                                                    className: "form-control input-lg h-10 py-2 input-base w-full focus:outline-none hover:border-[#618fb0]",
                                                    placeholder: "Your Password"
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                    className: "form-actions",
                                    children: /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                                        type: "submit",
                                        className: "btn btn-block btn-lg btn-primary w-full py-2.5",
                                        children: "Start Using Coincraft"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
});

});


parcelRegister("g96il", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $bc125e9f3b2a2997$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");

var $fal41 = parcelRequire("fal41");

var $5PXcS = parcelRequire("5PXcS");
const $bc125e9f3b2a2997$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_public/forgotten-password")({
    component: $bc125e9f3b2a2997$var$Wrapper,
    errorComponent: ({ error: error, reset: reset })=>{
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    }
});
function $bc125e9f3b2a2997$var$Wrapper() {
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fal41.default), {
        ...$bc125e9f3b2a2997$export$e7b0ac011bb776c6.useParams(),
        ...$bc125e9f3b2a2997$export$e7b0ac011bb776c6.useSearch()
    });
}

});
parcelRegister("fal41", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0a82108c5bde04e$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("fEtu5");
var $zyiwQ = parcelRequire("zyiwQ");

var $iKbxs = parcelRequire("iKbxs");

var $iOQGT = parcelRequire("iOQGT");

var $6UBLf = parcelRequire("6UBLf");

var $3H03w = parcelRequire("3H03w");

var $b0a82108c5bde04e$export$2e2bcd8739ae039 = (0, $1EEMt.observer)((props)=>{
    const navigate = (0, $6UBLf.useNavigate)();
    const [email, setEmail] = (0, $jbmdS.useState)(props.email || "");
    const [resetState, setResetState] = (0, $jbmdS.useState)("idle");
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "flex items-center justify-center text-center w-full h-full",
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("section", {
            className: "flex flex-col items-center justify-center w-[350px]",
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsxs)("header", {
                    className: "flex items-center flex-col justify-center",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            className: "logo2 s75 size-[10em] flex items-center justify-center",
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)("img", {
                                src: new URL((parcelRequire("hw9H4")))
                            })
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)("h1", {
                            style: {
                                fontSize: "5em"
                            },
                            children: "coincraft"
                        })
                    ]
                }),
                resetState === "success" ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $zyiwQ.SuccessAlert), {
                    className: "body",
                    children: "We've sent instructions to reset your password to your email address. Please check your email, and spam folder if you can't find it."
                }) : /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    className: "body w-full",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("h4", {
                            style: {
                                margin: "0em -2em 1em"
                            },
                            children: "Set a New Password"
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)("p", {
                            children: "Please enter your email address and we will email you instructions on how to set a new password."
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)("form", {
                            name: "forgottenPasswordForm",
                            className: "no-margin mt-8",
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)("fieldset", {
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                    className: "form-group no-margin",
                                    children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                        className: "input-group input-group-lg",
                                        children: [
                                            /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                                className: "input-group-addon",
                                                children: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                                    className: "eicon-user"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
                                                value: email || "",
                                                onChange: (e)=>setEmail(e.target.value),
                                                type: "email",
                                                className: "form-control input-lg h-10 py-2 input-base w-full focus:outline-none hover:border-[#618fb0]",
                                                placeholder: "Your Email"
                                            })
                                        ]
                                    })
                                })
                            })
                        }),
                        resetState === "error" ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $zyiwQ.ErrorAlert), {
                            style: {
                                marginTop: 15
                            },
                            children: "Sorry, we couldn't find an email with this e-mail address. Please try again."
                        }) : null,
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            className: "form-actions mt-5",
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                                    onClick: ()=>{
                                        setResetState("pending");
                                        (0, $iOQGT.makeRequest)({
                                            path: "https://api.coincraft.co/api/v1.5/user/send-password-reset",
                                            method: "post",
                                            data: {
                                                email: email
                                            }
                                        }).then((response)=>{
                                            setResetState("success");
                                        }).catch((error)=>{
                                            $iKbxs.captureException(error);
                                            (0, $3H03w.default).captureException(error);
                                            setResetState("error");
                                        });
                                    },
                                    className: "btn btn-block btn-lg btn-primary w-full py-2.5",
                                    children: "Email New Password Instructions"
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                    className: "forgot py-4 mt-3.5",
                                    children: /*#__PURE__*/ (0, $61Ea1.jsx)("a", {
                                        className: "forgot underline text-[1.2em] text-[#808080] text-center",
                                        href: `login?email=${email}`,
                                        onClick: ()=>navigate({
                                                to: `/login?email=${email}`
                                            }),
                                        children: "Sign Into Your Account"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
});

});


parcelRegister("2Mbj3", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $2058d5aa81efa582$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");

var $1mqxk = parcelRequire("1mqxk");

var $5PXcS = parcelRequire("5PXcS");
const $2058d5aa81efa582$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_public/activate-account")({
    component: $2058d5aa81efa582$var$Wrapper,
    errorComponent: ({ error: error, reset: reset })=>{
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    }
});
function $2058d5aa81efa582$var$Wrapper() {
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $1mqxk.default), {
        ...$2058d5aa81efa582$export$e7b0ac011bb776c6.useParams(),
        ...$2058d5aa81efa582$export$e7b0ac011bb776c6.useSearch()
    });
}

});
parcelRegister("1mqxk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0fdc6e2008d2d770$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $9mNEQ = parcelRequire("9mNEQ");

var $4iw5i = parcelRequire("4iw5i");

var $iKbxs = parcelRequire("iKbxs");

var $1BTI2 = parcelRequire("1BTI2");

var $iOQGT = parcelRequire("iOQGT");

var $6UBLf = parcelRequire("6UBLf");

var $8kZ1o = parcelRequire("8kZ1o");

var $3H03w = parcelRequire("3H03w");

var $0fdc6e2008d2d770$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ token: token, redirect: redirect })=>{
    const navigate = (0, $6UBLf.useNavigate)();
    const [validToken, setValidToken] = (0, $jbmdS.useState)(null);
    (0, $jbmdS.useEffect)(()=>{
        (0, $iOQGT.makeRequest)({
            path: "https://api.coincraft.co/api/v1.5/user/verify-token",
            method: "post",
            data: {
                token: token
            }
        }).then((response)=>{
            setValidToken(true);
            (0, $iOQGT.makeRequest)({
                path: "https://api.coincraft.co/api/v1.5/user/activate-account",
                method: "post",
                data: {
                    token: token
                }
            }).then((response)=>{
                (0, $1BTI2.default).saveLoginResponse(response);
                (0, $9mNEQ.default)(500).then(()=>{
                    navigate({
                        to: redirect || ((0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "projectList") ? "/projects" : "/timesheets")
                    });
                });
            }).catch((error)=>{
                (0, $9mNEQ.default)(2000).then(()=>{
                    navigate({
                        to: "/login"
                    });
                });
            });
        }).catch((error)=>{
            $iKbxs.captureException(error);
            (0, $3H03w.default).captureException(error);
            setValidToken(false);
            (0, $9mNEQ.default)(2000).then(()=>{
                navigate({
                    to: "/login"
                });
            });
        });
    }, []);
    if (validToken === null) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $4iw5i.default), {});
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "flex flex-align-items-center flex-justify-content-center",
        style: {
            textAlign: "center",
            alignSelf: "center"
        },
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("section", {
            className: "login-widget",
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsxs)("header", {
                    className: "text-align-center",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            style: {
                                width: "10em",
                                height: "10em"
                            },
                            className: "logo2 s75",
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)("img", {
                                src: new URL((parcelRequire("hw9H4")))
                            })
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)("h1", {
                            style: {
                                fontSize: "3em"
                            },
                            children: validToken ? "Account Activated!" : "Token Expired"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    className: "body",
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)("h4", {
                        style: {
                            margin: "0em -2em 1em",
                            fontSize: "1.2em"
                        },
                        children: "Redirecting..."
                    })
                })
            ]
        })
    });
});

});


parcelRegister("kVeQ2", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $f3b4a413bafba30c$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");

var $4hBm1 = parcelRequire("4hBm1");

var $cjVEm = parcelRequire("cjVEm");

var $bZfKS = parcelRequire("bZfKS");

var $b9nYY = parcelRequire("b9nYY");

var $kuPRw = parcelRequire("kuPRw");

var $4iw5i = parcelRequire("4iw5i");

var $5PXcS = parcelRequire("5PXcS");

var $1BTI2 = parcelRequire("1BTI2");
parcelRequire("jE5CX");

var $8kZ1o = parcelRequire("8kZ1o");

var $7qobO = parcelRequire("7qobO");

var $26sX2 = parcelRequire("26sX2");
const $f3b4a413bafba30c$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_private/weekly-planning")({
    beforeLoad: ({ params: params })=>{
        if (!(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "weeklyPlanning", params)) throw new Error("Permission Denied");
        (0, $26sX2.setLayoutDefaults)({
            pageTitle: "Weekly Planning",
            subMenu: "organisation"
        });
    },
    errorComponent: ({ error: error, reset: reset })=>{
        if (error.message === "Permission Denied") return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7qobO.default), {});
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    },
    pendingComponent: (0, $4iw5i.default),
    loader: async ({ location: location })=>await $f3b4a413bafba30c$var$loader(location.search),
    component: $f3b4a413bafba30c$var$Wrapper
});
const $f3b4a413bafba30c$var$loader = async ({ date: date, staffId: staffId })=>{
    date = date ? (0, $4hBm1.parse)(date, "yyyy-MM-dd", new Date()) : (0, $4hBm1.startOfWeek)(new Date(), {
        weekStartsOn: 1
    });
    const collections = [];
// return await Promise.all(collections.map(fetchData))
};
function $f3b4a413bafba30c$var$Wrapper() {
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kuPRw.default), {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $cjVEm.default), {})
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bZfKS.default), {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $b9nYY.CalendarSidebar), {})
            })
        ]
    });
}

});
parcelRegister("cjVEm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f83fa7c45232b23$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $fgZVx = parcelRequire("fgZVx");
var $8f83fa7c45232b23$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(()=>/*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        style: {
            width: "80em"
        },
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fgZVx.Calendar), {
            mode: "allocation"
        })
    }));

});
parcelRegister("fgZVx", function(module, exports) {

$parcel$export(module.exports, "Calendar", function () { return $b1e86312176a43df$export$e1aef45b828286de; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $1EEMt = parcelRequire("1EEMt");

var $1nRI3 = parcelRequire("1nRI3");

var $4hBm1 = parcelRequire("4hBm1");

var $eUxk9 = parcelRequire("eUxk9");


var $h1TD5 = parcelRequire("h1TD5");
parcelRequire("eBwNQ");


var $1BTI2 = parcelRequire("1BTI2");

var $htkeB = parcelRequire("htkeB");

var $f44xu = parcelRequire("f44xu");

var $QiMYe = parcelRequire("QiMYe");

var $9VnJj = parcelRequire("9VnJj");

var $fM2j4 = parcelRequire("fM2j4");

var $khJQv = parcelRequire("khJQv");


var $8kZ1o = parcelRequire("8kZ1o");

var $ewAM3 = parcelRequire("ewAM3");

var $7GQic = parcelRequire("7GQic");

var $02LyB = parcelRequire("02LyB");

var $6UBLf = parcelRequire("6UBLf");

const $b1e86312176a43df$export$e1aef45b828286de = (0, $1EEMt.observer)(({ mode: mode = "time", date: date, staffId: staffId })=>{
    const navigate = (0, $6UBLf.useNavigate)();
    (0, $jbmdS.useEffect)(()=>{
        (0, $khJQv.default).toggleSidebar(true);
    }, []);
    const settings = (0, $1BTI2.default).organisation.settings;
    const [showCal, setShowCal] = (0, $jbmdS.useState)(false);
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useRef();
    const mouse = (0, $1nRI3.default)(ref, {
        enterDelay: 100,
        leaveDelay: 100
    });
    const calDrag = (0, $h1TD5.useGesture)({
        onDragStart: (state)=>{
            (0, $eUxk9.default).deselectItem();
            (0, $eUxk9.default).setCalendarMouseData(mouse.x, mouse.y, mouse.elementWidth, mouse.elementHeight);
        },
        onDrag: (state)=>{
            if (!(0, $eUxk9.default).newItem) {
                if (state.movement[1] / ((0, $eUxk9.default).calendarMinuteEms * 10) > 7.5) (0, $eUxk9.default).createNewItem(true);
            } else {
                const numMinutes = (0, $eUxk9.default).calendarMouseFloatMinutes - (0, $eUxk9.default).newItem.startMinutes;
                (0, $eUxk9.default).updateNewItem({
                    numMinutes: numMinutes
                });
            }
        },
        onDragEnd: (state)=>{
            if ((0, $eUxk9.default).newItem) {
                let numMinutes = (0, $eUxk9.default).calendarMouseFloatMinutes - (0, $eUxk9.default).newItem.startMinutes;
                const newItem = (0, $eUxk9.default).commitNewItem({
                    numMinutes: numMinutes
                }, true);
                setTimeout(()=>{
                    (0, $eUxk9.default).selectItem(newItem);
                }, 100);
            }
        }
    });
    const [calendarRef, setCalendarRef] = (0, $jbmdS.useState)(null);
    const [calendarBounds, setCalendarBounds] = (0, $jbmdS.useState)({});
    const [calendarMouseDown, setCalendarMouseDown] = (0, $jbmdS.useState)(false);
    const [calendarMouseDownPos, setCalendarMouseDownPos] = (0, $jbmdS.useState)({
        x: 0,
        y: 0
    });
    (0, $jbmdS.useEffect)(()=>{
        // scroll calendar to 7:30am
        (0, $eUxk9.default).init(mode, {
            date: date,
            staffId: staffId
        });
        ref.current.parentNode.scrollTop = (0, $eUxk9.default).calendarMinuteEms * 7440;
        (0, $fM2j4.default).setAutosave(true);
        return ()=>(0, $fM2j4.default).setAutosave(false);
    }, []);
    const weekEndSameMonth = (0, $4hBm1.isSameMonth)((0, $eUxk9.default).weekStart, (0, $eUxk9.default).weekEnd);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "calendar",
        style: {
            fontSize: "1rem"
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "not-calendar",
                style: {
                    textAlign: "center"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("h3", {
                        children: `${mode === "time" ? "Time Entry Calendar" : "Weekly Planning"}`
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("h1", {
                        children: `${(0, $4hBm1.format)((0, $eUxk9.default).weekStart, weekEndSameMonth ? "dd" : "dd MMM")}${weekEndSameMonth ? "-" : " - "}${(0, $4hBm1.format)((0, $eUxk9.default).weekEnd, weekEndSameMonth ? "dd MMMM yyyy" : "dd MMM yyyy")}`
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "flex items-center justify-center",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                                className: "ant-btn",
                                onClick: (e)=>{
                                    (0, $eUxk9.default).setWeekStart((0, $4hBm1.subWeeks)((0, $eUxk9.default).weekStart, 1, {
                                        weekStartsOn: 1
                                    }));
                                },
                                children: "<"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7GQic.default), {
                                value: (0, $eUxk9.default).weekStart,
                                onChange: (date)=>{
                                    (0, $eUxk9.default).setWeekStart(date);
                                },
                                style: {
                                    width: "10rem",
                                    display: "inline-block"
                                }
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                                className: "ant-btn",
                                onClick: (e)=>{
                                    (0, $eUxk9.default).setWeekStart((0, $4hBm1.addWeeks)((0, $eUxk9.default).weekStart, 1, {
                                        weekStartsOn: 1
                                    }));
                                },
                                children: ">"
                            })
                        ]
                    })
                ]
            }),
            mode === "time" && (0, $8kZ1o.canEditStaffTime)((0, $1BTI2.default).user) || mode === "allocation" && (0, $8kZ1o.canEditStaffAllocations)((0, $1BTI2.default).user) ? /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "not-calendar pl-[4rem] pb-[1rem] max-w-max",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.StaffSelector), {
                    className: "timesheet__staff-selector",
                    selectedStaffMember: (0, $htkeB.default).staffById[(0, $eUxk9.default).selectedValues.staffId],
                    allowNull: false,
                    onChange: (staff)=>{
                        (0, $eUxk9.default).updateSelectedStaffId(staff.id);
                        navigate({
                            search: (prev)=>({
                                    ...prev,
                                    staffId: staff.id
                                })
                        });
                    },
                    variant: "secondary"
                })
            }) : null,
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "flex flex-col",
                style: {
                    height: `${window.innerHeight - 150}px`
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "flex",
                        style: {
                            flex: "0 0 auto"
                        },
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "w-[4rem]",
                                style: {
                                    flex: "0 0 auto",
                                    height: `${(0, $eUxk9.default).calendarMinuteEms * 55}rem`
                                }
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("flex flex-1 border border-[#ddd]", mode === "time" ? "bg-[#f0f0f0]" : "bg-[#666]"),
                                ref: ref,
                                style: {
                                    height: `${(0, $eUxk9.default).calendarMinuteEms * 55}rem`,
                                    borderRadius: "1rem 1rem 0 0"
                                },
                                children: (0, $eUxk9.default).weekDays.map((day, i)=>{
                                    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        className: "flex items-center justify-center h-full text-center",
                                        style: {
                                            width: `${100 / 7}%`,
                                            color: [
                                                5,
                                                6
                                            ].includes(i) ? mode === "time" ? "#888" : "#ccc" : mode === "time" ? "#444" : "#fff"
                                        },
                                        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                    className: "text-[1.75rem] mt-1.5 font-semibold",
                                                    children: `${(0, $4hBm1.format)(day, "dd")}`
                                                }),
                                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                    className: "uppercase text-[0.8rem] mt-1.5 font-normal",
                                                    children: `${(0, $4hBm1.format)(day, "EEEE")}`
                                                })
                                            ]
                                        })
                                    });
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "flex",
                        style: {
                            flex: "0 0 auto"
                        },
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "w-[4rem]",
                                style: {
                                    flex: "0 0 auto",
                                    height: `${(0, $eUxk9.default).calendarMinuteEms * 20}rem`
                                }
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                ref: ref,
                                className: "flex flex-1 border-b border-b-[#ddd] bg-[#f0f0f0]",
                                style: {
                                    height: `${(0, $eUxk9.default).calendarMinuteEms * 20}rem`
                                },
                                children: (0, $eUxk9.default).weekDays.map((day, i)=>{
                                    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        className: "h-full text-center flex items-center justify-center",
                                        style: {
                                            width: `${100 / 7}%`,
                                            color: [
                                                5,
                                                6
                                            ].includes(i) ? "#888" : "#444"
                                        },
                                        children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                className: "text-sm font-extrabold",
                                                children: `${(0, $eUxk9.default).dayTotals[i].hours}:${((0, $eUxk9.default).dayTotals[i].minutes < 10 ? "0" : "") + (0, $eUxk9.default).dayTotals[i].minutes}`
                                            })
                                        })
                                    });
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "flex flex-1 overflow-auto",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("svg", {
                                className: "w-[4em] bg-transparent",
                                style: {
                                    flex: "0 0 auto",
                                    height: `${(0, $eUxk9.default).calendarMinuteEms * 1440}rem`
                                },
                                children: [
                                    ...Array(23).keys()
                                ].map((d)=>{
                                    const h24 = d + 1;
                                    const h12 = h24 > 12 ? h24 - 12 : h24;
                                    const ampm = h24 >= 12 ? "pm" : "am";
                                    return /*#__PURE__*/ (0, $61Ea1.jsx)("text", {
                                        style: {
                                            fontSize: "1rem",
                                            fill: "#888"
                                        },
                                        x: `85%`,
                                        y: `${(d + 1) * (0, $eUxk9.default).calendarMinuteEms * 60 + 0.25}rem`,
                                        textAnchor: `end`,
                                        children: `${h12} ${ampm}`
                                    });
                                })
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                className: "flex-1",
                                style: {
                                    height: `${(0, $eUxk9.default).calendarMinuteEms * 1440}rem`
                                },
                                ref: ref,
                                onPointerMove: (e)=>{
                                    (0, $eUxk9.default).setCalendarMouseData(mouse.x, mouse.y, mouse.elementWidth, mouse.elementHeight);
                                },
                                children: [
                                    ((0, $9VnJj.default).dailyAllocationsByStaffIdWeek[(0, $f44xu.default)((0, $eUxk9.default).selectedValues.staffId, (0, $4hBm1.getWeek)((0, $eUxk9.default).weekStart, {
                                        weekStartsOn: 1
                                    }))] || []).map((al)=>{
                                        return /*#__PURE__*/ (0, $61Ea1.jsx)($b1e86312176a43df$var$CalendarAllocation, {
                                            allocation: al,
                                            mouse: mouse
                                        }, al.id);
                                    }),
                                    ((0, $QiMYe.default).timeEntries.filter((te)=>te.numMinutes > 0 && te.staffId === (0, $eUxk9.default).selectedValues.staffId && (0, $4hBm1.isSameWeek)(te.date, (0, $eUxk9.default).weekStart, {
                                            weekStartsOn: 1
                                        }) && !te.deletedAt) || []).map((te)=>{
                                        return /*#__PURE__*/ (0, $61Ea1.jsx)($b1e86312176a43df$var$CalendarTimeEntry, {
                                            timeEntry: te,
                                            mouse: mouse
                                        }, te.id);
                                    }),
                                    (0, $eUxk9.default).newItem && ((0, $eUxk9.default).mode === "allocation" ? /*#__PURE__*/ (0, $61Ea1.jsx)($b1e86312176a43df$var$CalendarAllocation, {
                                        allocation: (0, $eUxk9.default).newItem,
                                        mouse: mouse
                                    }, (0, $eUxk9.default).newItem.id) : /*#__PURE__*/ (0, $61Ea1.jsx)($b1e86312176a43df$var$CalendarTimeEntry, {
                                        timeEntry: (0, $eUxk9.default).newItem,
                                        mouse: mouse
                                    }, (0, $eUxk9.default).newItem.id)),
                                    /*#__PURE__*/ (0, $61Ea1.jsxs)("svg", {
                                        style: {
                                            height: `${(0, $eUxk9.default).calendarMinuteEms * 1440}rem`,
                                            width: "100%",
                                            background: "white",
                                            borderRadius: "0 0 1rem 1rem",
                                            zIndex: 1,
                                            fontSize: "1rem"
                                        },
                                        onClick: (e)=>{
                                            (0, $eUxk9.default).deselectItem();
                                        },
                                        ...calDrag(),
                                        children: [
                                            /*#__PURE__*/ (0, $61Ea1.jsx)("defs", {
                                                children: /*#__PURE__*/ (0, $61Ea1.jsx)("pattern", {
                                                    id: "hatchtile",
                                                    x: "-5",
                                                    y: "-5",
                                                    patternUnits: "userSpaceOnUse",
                                                    height: "5",
                                                    width: "5",
                                                    children: /*#__PURE__*/ (0, $61Ea1.jsx)("image", {
                                                        x: "0",
                                                        y: "0",
                                                        height: "5",
                                                        width: "5",
                                                        xlinkHref: `${new URL((parcelRequire("8XoZg")))}`
                                                    })
                                                })
                                            }),
                                            [
                                                ...Array(7).keys()
                                            ].map((d)=>{
                                                return (0, $eUxk9.default).isDayIndexWeekend(d) ? /*#__PURE__*/ (0, $61Ea1.jsx)("rect", {
                                                    width: `${100 / 7}%`,
                                                    height: "100%",
                                                    x: `${d * (100 / 7)}%`,
                                                    y: "0",
                                                    fill: "url(#hatchtile)",
                                                    opacity: "1"
                                                }) : null;
                                            }),
                                            [
                                                ...Array(95).keys()
                                            ].map((d)=>{
                                                return /*#__PURE__*/ (0, $61Ea1.jsx)("line", {
                                                    x1: `0%`,
                                                    y1: `${(d + 1) * (0, $eUxk9.default).calendarMinuteEms * 15}rem`,
                                                    x2: `100%`,
                                                    y2: `${(d + 1) * (0, $eUxk9.default).calendarMinuteEms * 15}rem`,
                                                    stroke: (d + 1) % 4 ? "#f0f0f0" : "#ddd"
                                                });
                                            }),
                                            [
                                                ...Array(6).keys()
                                            ].map((d)=>{
                                                return /*#__PURE__*/ (0, $61Ea1.jsx)("line", {
                                                    x1: `${(d + 1) * (100 / 7)}%`,
                                                    y1: "0%",
                                                    x2: `${(d + 1) * (100 / 7)}%`,
                                                    y2: "100%",
                                                    stroke: "#ddd"
                                                });
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
const $b1e86312176a43df$var$CalendarAllocation = (0, $1EEMt.observer)(({ allocation: allocation, mouse: mouse })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)($b1e86312176a43df$var$CalendarBlock, {
        item: allocation,
        itemType: "allocation",
        zIndex: (0, $eUxk9.default).mode === "allocation" ? 3 : 2,
        align: "left",
        opacity: (0, $eUxk9.default).mode === "allocation" ? 1 : 0.5,
        mouse: mouse
    });
});
const $b1e86312176a43df$var$CalendarTimeEntry = (0, $1EEMt.observer)(({ timeEntry: timeEntry, mouse: mouse })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)($b1e86312176a43df$var$CalendarBlock, {
        item: timeEntry,
        itemType: "time",
        zIndex: (0, $eUxk9.default).mode === "time" ? 3 : 2,
        align: "right",
        opacity: (0, $eUxk9.default).mode === "time" ? 1 : 0.5,
        mouse: mouse
    }, timeEntry.id);
});
const $b1e86312176a43df$var$CalendarBlock = (0, $1EEMt.observer)(({ item: item, itemType: itemType, zIndex: zIndex, align: align, opacity: opacity, mouse: mouse, ...props })=>{
    var _item$project, _item$projectPhase, _item$task;
    const disabled = itemType !== (0, $eUxk9.default).mode;
    const settings = (0, $1BTI2.default).organisation.settings;
    const diffDays = (0, $4hBm1.differenceInDays)(item.date, (0, $eUxk9.default).weekStart);
    const [hovering, setHovering] = (0, $jbmdS.useState)(false);
    const [changeY, setChangeY] = (0, $jbmdS.useState)(0);
    const [changeLength, setChangeLength] = (0, $jbmdS.useState)(0);
    const [clickOffset, setClickOffset] = (0, $jbmdS.useState)(0);
    const [activeDragType, setActiveDragType] = (0, $jbmdS.useState)(null);
    const [dragDayIndex, setDragDayIndex] = (0, $jbmdS.useState)(-1);
    const y = changeY + item.startMinutes;
    const length = changeLength + item.numMinutes;
    const selected = item === (0, $eUxk9.default).selectedItem;
    const startDrag = (0, $h1TD5.useGesture)({
        onDragStart: ()=>{
            if (activeDragType !== null) return;
            setActiveDragType("start");
            (0, $eUxk9.default).setDragging(true);
            (0, $eUxk9.default).selectItem(item, itemType);
        },
        onDrag: (state)=>{
            if (activeDragType !== "start") return;
            const newY = (0, $eUxk9.default).calendarMouseFloatMinutes;
            const newStartMinutes = newY;
            const newLength = item.startMinutes + item.numMinutes - newY;
            setChangeY(newY - item.startMinutes);
            setChangeLength(Math.max(newLength - item.numMinutes, -item.numMinutes + 15));
            (0, $eUxk9.default).adjustDragMinutes(changeLength);
        },
        onDragEnd: (state)=>{
            if (activeDragType !== "start") return;
            let oldStartMinutes = item.startMinutes;
            let newStartMinutes = changeY + item.startMinutes;
            let newNumMinutes = item.numMinutes - (newStartMinutes - oldStartMinutes);
            (0, $eUxk9.default).editSelectedItem({
                startMinutes: newStartMinutes,
                numMinutes: Math.max(newNumMinutes, 15)
            }, true);
            (0, $eUxk9.default).adjustDragMinutes(0);
            setChangeY(0);
            setChangeLength(0);
            (0, $eUxk9.default).setDragging(false);
            setActiveDragType(null);
        }
    });
    const endDrag = (0, $h1TD5.useGesture)({
        onDragStart: ()=>{
            if (activeDragType !== null) return;
            setActiveDragType("end");
            (0, $eUxk9.default).setDragging(true);
            (0, $eUxk9.default).selectItem(item, itemType);
        },
        onDrag: (state)=>{
            if (activeDragType !== "end") return;
            const newLength = (0, $eUxk9.default).calendarMouseFloatMinutes - y;
            (0, $eUxk9.default).adjustDragMinutes(newLength - item.numMinutes);
            setChangeLength(newLength - item.numMinutes);
        },
        onDragEnd: (state)=>{
            if (activeDragType !== "end") return;
            let newNumMinutes = changeLength + item.numMinutes;
            (0, $eUxk9.default).editSelectedItem({
                numMinutes: Math.max(newNumMinutes, 15)
            }, true);
            (0, $eUxk9.default).adjustDragMinutes(0);
            setChangeLength(0);
            (0, $eUxk9.default).setDragging(false);
            setActiveDragType(null);
        }
    });
    const bodyDrag = (0, $h1TD5.useGesture)({
        onDragStart: ()=>{
            if (activeDragType !== null) return;
            setActiveDragType("body");
            (0, $eUxk9.default).setDragging(true);
            (0, $eUxk9.default).selectItem(item, itemType);
            setClickOffset((0, $eUxk9.default).calendarMouseFloatMinutes - item.startMinutes);
        },
        onDrag: (state)=>{
            if (activeDragType !== "body") return;
            const newY = (0, $eUxk9.default).calendarMouseFloatMinutes - item.startMinutes - clickOffset;
            setChangeY(newY);
            // During drag, we'll update the item's position visually
            // The actual date update will happen on dragEnd
            const currentDayIndex = Math.floor((0, $eUxk9.default).calendarMouseX / ((0, $eUxk9.default).calendarWidth / 7));
            const originalDiffDays = (0, $4hBm1.differenceInDays)(item.date, (0, $eUxk9.default).weekStart);
            // Always update the drag day index if it's a valid day
            if (currentDayIndex >= 0 && currentDayIndex < 7) {
                // If we're back to the original day, set dragDayIndex to -1 to use original positioning
                if (currentDayIndex === originalDiffDays) setDragDayIndex(-1);
                else setDragDayIndex(currentDayIndex);
            }
        },
        onDragEnd: (state)=>{
            if (activeDragType !== "body") return;
            let newStartMinutes = changeY + item.startMinutes;
            // Get the current day index based on mouse position
            const dayIndex = Math.floor((0, $eUxk9.default).calendarMouseX / ((0, $eUxk9.default).calendarWidth / 7));
            // Calculate the new date based on the day index
            const newDate = (0, $4hBm1.addDays)((0, $eUxk9.default).weekStart, dayIndex);
            // Only update the date if it's different from the current date
            // Always update the startMinutes
            const currentDate = item.date;
            const sameDay = (0, $4hBm1.isSameDay)(currentDate, newDate);
            if (sameDay) (0, $eUxk9.default).editSelectedItem({
                startMinutes: newStartMinutes
            }, true);
            else (0, $eUxk9.default).editSelectedItem({
                startMinutes: newStartMinutes,
                date: newDate
            }, true);
            // Reset the drag day index
            setDragDayIndex(-1);
            setChangeY(0);
            (0, $eUxk9.default).setDragging(false);
            setActiveDragType(null);
        }
    });
    const calDrag = (0, $h1TD5.useGesture)({
        onDragStart: (state)=>{
            if (activeDragType !== null) return;
            setActiveDragType("cal");
            (0, $eUxk9.default).deselectItem();
            (0, $eUxk9.default).setCalendarMouseData(mouse.x, mouse.y, mouse.elementWidth, mouse.elementHeight);
        },
        onDrag: (state)=>{
            if (activeDragType !== "cal") return;
            if (!(0, $eUxk9.default).newItem) {
                if (state.movement[1] / ((0, $eUxk9.default).calendarMinuteEms * 10) > 7.5) (0, $eUxk9.default).createNewItem(true);
            } else {
                const numMinutes = (0, $eUxk9.default).calendarMouseFloatMinutes - (0, $eUxk9.default).newItem.startMinutes;
                (0, $eUxk9.default).updateNewItem({
                    numMinutes: numMinutes
                });
            }
        },
        onDragEnd: (state)=>{
            if (activeDragType !== "cal") return;
            if ((0, $eUxk9.default).newItem) {
                let numMinutes = (0, $eUxk9.default).calendarMouseFloatMinutes - (0, $eUxk9.default).newItem.startMinutes;
                const newItem = (0, $eUxk9.default).commitNewItem({
                    numMinutes: Math.max(numMinutes, 15)
                }, true);
                setTimeout(()=>{
                    (0, $eUxk9.default).selectItem(newItem);
                }, 100);
            }
            setActiveDragType(null);
        }
    });
    return diffDays < 7 && diffDays >= 0 && /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: `calendar-item ${align}` + (selected ? " selected" : "") + (itemType === "allocation" ? " allocation" : "") + (activeDragType === "body" && dragDayIndex !== -1 ? " dragging-between-days" : ""),
        style: {
            width: `calc(${100 / 7}% - 2rem - 2px)`,
            height: `calc(${(0, $eUxk9.default).calendarMinuteEms * length}rem - 2px)`,
            left: activeDragType === "body" && dragDayIndex !== -1 ? `calc(${100 / 7 * dragDayIndex}% + ${align === "left" ? "1px" : "2rem + 1px"})` : align === "left" ? `calc(${100 / 7 * diffDays}% + 1px)` : `calc(${100 / 7 * diffDays}% + 2rem + 1px)`,
            top: `calc(${(0, $eUxk9.default).calendarMinuteEms * y}rem + 1px)`,
            zIndex: zIndex + (selected ? 3 : hovering && !(0, $eUxk9.default).dragging ? 2 : 0),
            opacity: opacity + ((selected || hovering) && !(0, $eUxk9.default).dragging ? 0.4 : 0),
            cursor: !disabled ? "default" : "default"
        },
        onPointerOver: (e)=>setHovering(true),
        onPointerOut: (e)=>setHovering(false),
        onClick: (e)=>{
            e.stopPropagation();
            (0, $eUxk9.default).selectItem(item, itemType);
        },
        ...(0, $eUxk9.default).mode === "time" && itemType === "allocation" ? calDrag() : {},
        ...props,
        children: [
            !disabled && /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "body-drag-area",
                style: {
                    position: "absolute",
                    top: "1rem",
                    bottom: "1rem",
                    left: 0,
                    right: 0,
                    cursor: "move",
                    zIndex: 1
                },
                onClick: (e)=>e.stopPropagation(),
                ...bodyDrag()
            }),
            !disabled && /*#__PURE__*/ (0, $61Ea1.jsx)("svg", {
                className: "vertical-drag",
                style: {
                    width: "100%",
                    height: "1rem",
                    position: "absolute",
                    top: "-0.5rem",
                    left: 0,
                    cursor: "ns-resize",
                    zIndex: 2
                },
                onClick: (e)=>e.stopPropagation(),
                ...startDrag()
            }),
            !disabled && /*#__PURE__*/ (0, $61Ea1.jsx)("svg", {
                className: "vertical-drag",
                style: {
                    width: "100%",
                    height: "1rem",
                    position: "absolute",
                    bottom: "-0.5rem",
                    left: 0,
                    cursor: "ns-resize",
                    zIndex: 2
                },
                onClick: (e)=>e.stopPropagation(),
                ...endDrag()
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    fontSize: "0.65rem",
                    position: "relative",
                    zIndex: 0
                },
                children: (_item$project = item.project) === null || _item$project === void 0 ? void 0 : _item$project.title
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    fontSize: "0.65rem",
                    position: "relative",
                    zIndex: 0
                },
                children: (_item$projectPhase = item.projectPhase) === null || _item$projectPhase === void 0 ? void 0 : _item$projectPhase.title
            }),
            settings.useTasks && /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    fontSize: "0.65rem",
                    position: "relative",
                    zIndex: 0
                },
                children: (_item$task = item.task) === null || _item$task === void 0 ? void 0 : _item$task.name
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "time",
                style: {
                    pointerEvents: "none",
                    position: "relative",
                    zIndex: 0
                },
                children: `${Math.floor(Math.round(item.numMinutes + changeLength) / 60)}:${Math.round(item.numMinutes + changeLength) % 60 < 10 ? Math.round(item.numMinutes + changeLength) % 60 + "0" : Math.round(item.numMinutes + changeLength) % 60}`
            })
        ]
    });
});

});
parcelRegister("1nRI3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10219a02e20ae43a$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");

var $bJYb4 = parcelRequire("bJYb4");

var $9fsq6 = parcelRequire("9fsq6");
function $10219a02e20ae43a$var$_ref(state, action) {
    if (typeof window === "undefined") return state;
    const { event: e, element: element } = action;
    let event;
    if ("touches" in e) event = e.touches[0];
    else event = e;
    const { clientX: clientX, clientY: clientY, screenX: screenX, screenY: screenY, pageX: pageX = 0, pageY: pageY = 0 } = event;
    const rect = element.getBoundingClientRect();
    const x = pageX - rect.left - (window.pageXOffset || window.scrollX);
    const y = pageY - rect.top - (window.pageYOffset || window.scrollY); // shims a mouseleave event for touch devices
    if ("touches" in e && (x < 0 || y < 0 || x > rect.width || y > rect.height)) return {
        ...state,
        context: {
            ...state.context,
            hoverStatus: "leave",
            touchStatus: "end"
        }
    };
    return {
        context: {
            ...state.context,
            hoverStatus: "enter"
        },
        mouse: {
            ...state.mouse,
            x: x,
            y: y,
            pageX: pageX,
            pageY: pageY,
            clientX: clientX,
            clientY: clientY,
            screenX: screenX,
            screenY: screenY,
            elementWidth: rect.width,
            elementHeight: rect.height,
            isOver: true,
            isTouch: "touches" in e
        }
    };
}
function $10219a02e20ae43a$var$_ref2(state, action) {
    const { mouse: mouse, context: context } = state;
    const handleDown = $10219a02e20ae43a$var$_ref;
    if (action.type === "mousemove") {
        // Bails out if touch has ended
        if (context.touchStatus === "end") return state;
        return handleDown(state, action);
    } else if (action.type === "touchmove") {
        const nextState = {
            context: {
                ...context,
                touchStatus: "start"
            },
            mouse: mouse
        };
        return handleDown(nextState, action);
    } else if (action.type === "touchdown") {
        const nextState = {
            context: {
                ...context,
                touchStatus: "start"
            },
            mouse: {
                ...mouse,
                isDown: true
            }
        };
        return handleDown(nextState, action);
    } else if (action.type === "mousedown") return {
        context: context,
        mouse: {
            ...mouse,
            isDown: true
        }
    };
    else if (action.type === "mouseup") return {
        context: context,
        mouse: {
            ...mouse,
            isDown: false
        }
    };
    else if (action.type === "mouseleave") return {
        context: {
            ...context,
            hoverStatus: "leave"
        },
        mouse: {
            ...mouse,
            isOver: false
        }
    };
    else if (action.type === "touchleave") return {
        context: {
            ...context,
            hoverStatus: "leave",
            touchStatus: "end"
        },
        mouse: {
            ...mouse,
            isOver: false,
            isDown: false
        }
    };
    else if (action.type === "activeStatus") return {
        context: {
            ...context,
            activeStatus: action.value
        },
        mouse: mouse
    };
    return state;
}
function $10219a02e20ae43a$var$useMouse(target, options = {}) {
    const { fps: fps = 30, enterDelay: enterDelay = 0, leaveDelay: leaveDelay = 0 } = options;
    const [state, dispatch] = $jbmdS.useReducer($10219a02e20ae43a$var$_ref2, {
        mouse: $10219a02e20ae43a$var$initialState,
        context: $10219a02e20ae43a$var$initialContext
    });
    const onMove = (0, $9fsq6.useThrottleCallback)((event)=>{
        const element = target && "current" in target ? target.current : target;
        if (!element) return;
        dispatch({
            type: "mousemove",
            event: event,
            element: element
        });
    }, fps, true);
    const onTouchMove = (0, $9fsq6.useThrottleCallback)((event)=>{
        const element = target && "current" in target ? target.current : target;
        if (!element) return;
        dispatch({
            type: "touchmove",
            event: event,
            element: element
        });
    }, fps, true);
    const onLeave = (0, $9fsq6.useThrottleCallback)(()=>dispatch({
            type: "mouseleave"
        }), fps, // move events.
    false);
    const onDown = (0, $9fsq6.useThrottleCallback)((event)=>{
        const element = target && "current" in target ? target.current : target;
        if (!element) return;
        dispatch("touches" in event ? {
            type: "touchdown",
            element: element,
            event: event
        } : {
            type: "mousedown",
            element: element,
            event: event
        });
    }, fps, true);
    const onUp = (0, $9fsq6.useThrottleCallback)(()=>dispatch({
            type: "mouseup"
        }), fps, // down events.
    false);
    const onTouchEnd = (0, $9fsq6.useThrottleCallback)(()=>dispatch({
            type: "touchleave"
        }), fps, // move events.
    false);
    (0, $bJYb4.default)(target, "mouseenter", onMove);
    (0, $bJYb4.default)(target, "mousemove", onMove);
    (0, $bJYb4.default)(target, "mouseleave", onLeave);
    (0, $bJYb4.default)(target, "mousedown", onDown);
    (0, $bJYb4.default)(typeof window !== "undefined" ? window : null, "mousedown", onDown);
    (0, $bJYb4.default)(typeof window !== "undefined" ? window : null, "mouseup", onUp);
    (0, $bJYb4.default)(target, "touchstart", onDown);
    (0, $bJYb4.default)(target, "touchmove", onTouchMove);
    (0, $bJYb4.default)(target, "touchend", onTouchEnd);
    (0, $bJYb4.default)(target, "touchcancel", onTouchEnd);
    function _ref3() {
        return dispatch({
            type: "activeStatus",
            value: "active"
        });
    }
    function _ref4() {
        return dispatch({
            type: "activeStatus",
            value: "inactive"
        });
    }
    $jbmdS.useEffect(()=>{
        if (state.context.hoverStatus === "enter") {
            if (enterDelay) {
                const timeout = setTimeout(_ref3, enterDelay);
                return ()=>clearTimeout(timeout);
            }
            dispatch({
                type: "activeStatus",
                value: "active"
            });
        } else {
            if (leaveDelay) {
                const timeout = setTimeout(_ref4, leaveDelay);
                return ()=>clearTimeout(timeout);
            }
            dispatch({
                type: "activeStatus",
                value: "inactive"
            });
        }
    }, [
        state.context.hoverStatus,
        enterDelay,
        leaveDelay
    ]);
    return state.context.activeStatus === "active" ? state.mouse : $10219a02e20ae43a$var$initialState;
}
const $10219a02e20ae43a$var$initialState = {
    x: null,
    y: null,
    pageX: null,
    pageY: null,
    clientX: null,
    clientY: null,
    screenX: null,
    screenY: null,
    elementWidth: null,
    elementHeight: null,
    isOver: false,
    isDown: false,
    isTouch: false
};
const $10219a02e20ae43a$var$initialContext = {
    hoverStatus: "idle",
    touchStatus: "idle",
    activeStatus: "inactive"
};
var $10219a02e20ae43a$export$2e2bcd8739ae039 = $10219a02e20ae43a$var$useMouse;

});
parcelRegister("9fsq6", function(module, exports) {

$parcel$export(module.exports, "useThrottleCallback", function () { return $6bbb8f60b3614df3$export$43f0d02427e1c683; });

var $jbmdS = parcelRequire("jbmdS");

var $3R0HB = parcelRequire("3R0HB");
const $6bbb8f60b3614df3$var$perf = typeof performance !== "undefined" ? performance : Date;
const $6bbb8f60b3614df3$var$now = ()=>$6bbb8f60b3614df3$var$perf.now();
function $6bbb8f60b3614df3$export$43f0d02427e1c683(callback, fps = 30, leading = false) {
    const storedCallback = (0, $3R0HB.default)(callback);
    const ms = 1000 / fps;
    const prev = $jbmdS.useRef(0);
    const trailingTimeout = $jbmdS.useRef();
    const clearTrailing = ()=>trailingTimeout.current && clearTimeout(trailingTimeout.current);
    const deps = [
        fps,
        leading,
        storedCallback
    ]; // Reset any time the deps change
    function _ref() {
        prev.current = 0;
        clearTrailing();
    }
    $jbmdS.useEffect(()=>_ref, deps);
    return $jbmdS.useCallback(function() {
        // eslint-disable-next-line prefer-rest-params
        const args = arguments;
        const rightNow = $6bbb8f60b3614df3$var$now();
        const call = ()=>{
            prev.current = rightNow;
            clearTrailing();
            storedCallback.current.apply(null, args);
        };
        const current = prev.current; // leading
        if (leading && current === 0) return call(); // body
        if (rightNow - current > ms) {
            if (current > 0) return call();
            prev.current = rightNow;
        } // trailing
        clearTrailing();
        trailingTimeout.current = setTimeout(()=>{
            call();
            prev.current = 0;
        }, ms);
    }, deps);
}
function $6bbb8f60b3614df3$export$8b7b9481d6186f21(initialState, fps, leading) {
    const state = $jbmdS.useState(initialState);
    return [
        state[0],
        $6bbb8f60b3614df3$export$43f0d02427e1c683(state[1], fps, leading)
    ];
}

});


parcelRegister("h1TD5", function(module, exports) {

$parcel$export(module.exports, "useGesture", function () { return $c65dae8075b9a292$export$ece84446a783717; });

var $jbmdS = parcelRequire("jbmdS");
// vector add
function $c65dae8075b9a292$export$ca6b5e3985063434(v1, v2) {
    return v1.map(function(v, i) {
        return v + v2[i];
    });
} // vector substract
function $c65dae8075b9a292$export$e0f232dd469378a8(v1, v2) {
    return v1.map(function(v, i) {
        return v - v2[i];
    });
}
/**
 * Calculates velocity
 * @param delta the difference between current and previous vectors
 * @param delta_t the time offset
 * @param len the length of the delta vector
 * @returns velocity
 */ function $c65dae8075b9a292$var$calculateVelocity(delta, delta_t, len) {
    len = len || Math.hypot.apply(Math, delta);
    return delta_t ? len / delta_t : 0;
}
/**
 * Calculates velocities vector
 * @template T the expected vector type
 * @param delta the difference between current and previous vectors
 * @param delta_t the time offset
 * @returns velocities vector
 */ function $c65dae8075b9a292$var$calculateVelocities(delta, delta_t) {
    return delta_t ? delta.map(function(v) {
        return v / delta_t;
    }) : Array(delta.length).fill(0);
}
/**
 * Calculates distance
 * @param movement the difference between current and initial vectors
 * @returns distance
 */ function $c65dae8075b9a292$var$calculateDistance(movement) {
    return Math.hypot.apply(Math, movement);
}
/**
 * Calculates direction
 * @template T the expected vector type
 * @param delta
 * @param len
 * @returns direction
 */ function $c65dae8075b9a292$var$calculateDirection(delta, len) {
    len = len || Math.hypot.apply(Math, delta) || 1;
    return delta.map(function(v) {
        return v / len;
    });
}
/**
 * Calculates all kinematics
 * @template T the expected vector type
 * @param movement the difference between current and initial vectors
 * @param delta the difference between current and previous vectors
 * @param delta_t the time difference between current and previous timestamps
 * @returns all kinematics
 */ function $c65dae8075b9a292$var$calculateAllKinematics(movement, delta, delta_t) {
    var len = Math.hypot.apply(Math, delta);
    return {
        velocities: $c65dae8075b9a292$var$calculateVelocities(delta, delta_t),
        velocity: $c65dae8075b9a292$var$calculateVelocity(delta, delta_t, len),
        distance: $c65dae8075b9a292$var$calculateDistance(movement),
        direction: $c65dae8075b9a292$var$calculateDirection(delta, len)
    };
}
/**
 * Because IE doesn't support `Math.sign` function, so we use the polyfill version of the function.
 * This polyfill function is suggested by Mozilla
 * :https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/sign#Polyfill
 * @param x target number
 */ function $c65dae8075b9a292$var$sign(x) {
    if (Math.sign) return Math.sign(x);
    return Number(x > 0) - Number(x < 0) || +x;
}
function $c65dae8075b9a292$var$getIntentionalDisplacement(movement, threshold) {
    var abs = Math.abs(movement);
    return abs >= threshold ? $c65dae8075b9a292$var$sign(movement) * threshold : false;
}
function $c65dae8075b9a292$var$minMax(value, min, max) {
    return Math.max(min, Math.min(value, max));
} // Based on @aholachek ;)
// https://twitter.com/chpwn/status/285540192096497664
// iOS constant = 0.55
// https://medium.com/@nathangitter/building-fluid-interfaces-ios-swift-9732bb934bf5
function $c65dae8075b9a292$var$rubberband2(distance, constant) {
    // default constant from the article is 0.7
    return Math.pow(distance, constant * 5);
}
function $c65dae8075b9a292$var$rubberband(distance, dimension, constant) {
    if (dimension === 0 || Math.abs(dimension) === Infinity) return $c65dae8075b9a292$var$rubberband2(distance, constant);
    return distance * dimension * constant / (dimension + constant * distance);
}
function $c65dae8075b9a292$export$eb62c10c9b08d9ab(position, min, max, constant) {
    if (constant === void 0) constant = 0.15;
    if (constant === 0) return $c65dae8075b9a292$var$minMax(position, min, max);
    if (position < min) return -$c65dae8075b9a292$var$rubberband(min - position, max - min, constant) + min;
    if (position > max) return $c65dae8075b9a292$var$rubberband(position - max, max - min, constant) + max;
    return position;
}
function $c65dae8075b9a292$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $c65dae8075b9a292$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c65dae8075b9a292$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c65dae8075b9a292$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $c65dae8075b9a292$var$_extends() {
    $c65dae8075b9a292$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c65dae8075b9a292$var$_extends.apply(this, arguments);
}
function $c65dae8075b9a292$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $c65dae8075b9a292$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $c65dae8075b9a292$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c65dae8075b9a292$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c65dae8075b9a292$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c65dae8075b9a292$var$_arrayLikeToArray(o, minLen);
}
function $c65dae8075b9a292$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c65dae8075b9a292$var$_createForOfIteratorHelperLoose(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $c65dae8075b9a292$var$_unsupportedIterableToArray(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
// blank function
function $c65dae8075b9a292$var$noop() {} // returns a function that chains all functions given as parameters
var $c65dae8075b9a292$var$chainFns = function chainFns() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return fns.forEach(function(fn) {
            return fn.apply(void 0, args);
        });
    };
};
var $c65dae8075b9a292$var$def = {
    array: function array(value) {
        return Array.isArray(value) ? value : [
            value,
            value
        ];
    },
    withDefault: function withDefault(value, defaultIfUndefined) {
        return value !== void 0 ? value : defaultIfUndefined;
    }
};
function $c65dae8075b9a292$var$matchKeysFromObject(obj, matchingObject) {
    var o = {};
    Object.entries(obj).forEach(function(_ref) {
        var key = _ref[0], value = _ref[1];
        return (value !== void 0 || key in matchingObject) && (o[key] = value);
    });
    return o;
}
function $c65dae8075b9a292$var$valueFn(v) {
    return typeof v === "function" ? v() : v;
}
function $c65dae8075b9a292$var$getInitialState() {
    // common initial state for all gestures
    var initialCommon = {
        _active: false,
        _blocked: false,
        _intentional: [
            false,
            false
        ],
        _movement: [
            0,
            0
        ],
        _initial: [
            0,
            0
        ],
        _lastEventType: undefined,
        event: undefined,
        // currentTarget: undefined,
        // pointerId: undefined,
        values: [
            0,
            0
        ],
        velocities: [
            0,
            0
        ],
        delta: [
            0,
            0
        ],
        movement: [
            0,
            0
        ],
        offset: [
            0,
            0
        ],
        lastOffset: [
            0,
            0
        ],
        direction: [
            0,
            0
        ],
        initial: [
            0,
            0
        ],
        previous: [
            0,
            0
        ],
        first: false,
        last: false,
        active: false,
        timeStamp: 0,
        startTime: 0,
        elapsedTime: 0,
        cancel: $c65dae8075b9a292$var$noop,
        canceled: false,
        memo: undefined,
        args: undefined
    }; // initial state for coordinates-based gestures
    var initialCoordinates = {
        axis: undefined,
        xy: [
            0,
            0
        ],
        vxvy: [
            0,
            0
        ],
        velocity: 0,
        distance: 0
    }; // initial state for distance and angle-based gestures (pinch)
    var initialDistanceAngle = {
        da: [
            0,
            0
        ],
        vdva: [
            0,
            0
        ],
        origin: undefined,
        turns: 0
    }; // initial state object (used by the gesture controller)
    return {
        shared: {
            hovering: false,
            scrolling: false,
            wheeling: false,
            dragging: false,
            moving: false,
            pinching: false,
            touches: 0,
            buttons: 0,
            down: false,
            shiftKey: false,
            altKey: false,
            metaKey: false,
            ctrlKey: false
        },
        drag: $c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, initialCommon), initialCoordinates), {}, {
            _isTap: true,
            _delayedEvent: false,
            tap: false,
            swipe: [
                0,
                0
            ]
        }),
        pinch: $c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, initialCommon), initialDistanceAngle),
        wheel: $c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, initialCommon), initialCoordinates),
        move: $c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, initialCommon), initialCoordinates),
        scroll: $c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, initialCommon), initialCoordinates)
    };
}
var $c65dae8075b9a292$var$setListeners = function setListeners(add) {
    return function(el, listeners, options) {
        var action = add ? "addEventListener" : "removeEventListener";
        listeners.forEach(function(_ref) {
            var eventName = _ref[0], fn = _ref[1];
            return el[action](eventName, fn, options);
        });
    };
};
/**
 * Whether the browser supports GestureEvent (ie Safari)
 * @returns true if the browser supports gesture event
 */ function $c65dae8075b9a292$var$supportsGestureEvents() {
    try {
        // TODO [TS] possibly find GestureEvent definitions?
        // @ts-ignore: no type definitions for webkit GestureEvents
        return "constructor" in GestureEvent;
    } catch (e) {
        return false;
    }
}
var $c65dae8075b9a292$var$addListeners = /*#__PURE__*/ $c65dae8075b9a292$var$setListeners(true);
var $c65dae8075b9a292$var$removeListeners = /*#__PURE__*/ $c65dae8075b9a292$var$setListeners(false);
/**
 * Gets modifier keys from event
 * @param event
 * @returns modifier keys
 */ function $c65dae8075b9a292$var$getModifierKeys(event) {
    var shiftKey = event.shiftKey, altKey = event.altKey, metaKey = event.metaKey, ctrlKey = event.ctrlKey;
    return {
        shiftKey: shiftKey,
        altKey: altKey,
        metaKey: metaKey,
        ctrlKey: ctrlKey
    };
}
function $c65dae8075b9a292$var$getTouchEvents(event) {
    if ("touches" in event) {
        var touches = event.touches, changedTouches = event.changedTouches;
        return touches.length > 0 ? touches : changedTouches;
    }
    return null;
}
function $c65dae8075b9a292$var$getGenericEventData(event) {
    var buttons = "buttons" in event ? event.buttons : 0;
    var touchEvents = $c65dae8075b9a292$var$getTouchEvents(event);
    var touches = touchEvents && touchEvents.length || 0;
    var down = touches > 0 || buttons > 0;
    return $c65dae8075b9a292$var$_extends({
        touches: touches,
        down: down,
        buttons: buttons
    }, $c65dae8075b9a292$var$getModifierKeys(event));
}
/**
 * Gets scroll event values
 * @param event
 * @returns scroll event values
 */ function $c65dae8075b9a292$var$getScrollEventValues(event) {
    // If the currentTarget is the window then we return the scrollX/Y position.
    // If not (ie the currentTarget is a DOM element), then we return scrollLeft/Top
    var _event$currentTarget = event.currentTarget, scrollX = _event$currentTarget.scrollX, scrollY = _event$currentTarget.scrollY, scrollLeft = _event$currentTarget.scrollLeft, scrollTop = _event$currentTarget.scrollTop;
    return {
        values: [
            scrollX || scrollLeft || 0,
            scrollY || scrollTop || 0
        ]
    };
}
/**
 * Gets wheel event values.
 * @param event
 * @returns wheel event values
 */ function $c65dae8075b9a292$var$getWheelEventValues(event) {
    var deltaX = event.deltaX, deltaY = event.deltaY; //TODO implement polyfill ?
    // https://developer.mozilla.org/en-US/docs/Web/Events/wheel#Polyfill
    return {
        values: [
            deltaX,
            deltaY
        ]
    };
}
/**
 * Gets pointer event values.
 * @param event
 * @returns pointer event values
 */ function $c65dae8075b9a292$var$getPointerEventValues(event) {
    var touchEvents = $c65dae8075b9a292$var$getTouchEvents(event);
    var _ref2 = touchEvents ? touchEvents[0] : event, clientX = _ref2.clientX, clientY = _ref2.clientY;
    return {
        values: [
            clientX,
            clientY
        ]
    };
}
var $c65dae8075b9a292$var$WEBKIT_DISTANCE_SCALE_FACTOR = 260;
/**
 * Gets webkit gesture event values.
 * @param event
 * @returns webkit gesture event values
 */ function $c65dae8075b9a292$var$getWebkitGestureEventValues(event) {
    return {
        values: [
            event.scale * $c65dae8075b9a292$var$WEBKIT_DISTANCE_SCALE_FACTOR,
            event.rotation
        ]
    };
}
/**
 * Gets two touches event data
 * @param event
 * @returns two touches event data
 */ function $c65dae8075b9a292$var$getTwoTouchesEventData(event) {
    var touches = event.touches;
    var dx = touches[1].clientX - touches[0].clientX;
    var dy = touches[1].clientY - touches[0].clientY;
    var values = [
        Math.hypot(dx, dy),
        -(Math.atan2(dx, dy) * 180) / Math.PI
    ];
    var origin = [
        (touches[1].clientX + touches[0].clientX) / 2,
        (touches[1].clientY + touches[0].clientY) / 2
    ];
    return {
        values: values,
        origin: origin
    };
}
/**
 * The controller will keep track of the state for all gestures and also keep
 * track of timeouts, and window listeners.
 *
 * @template BinderType the type the bind function should return
 */ var $c65dae8075b9a292$var$Controller = function Controller() {
    var _this = this;
    this.state = $c65dae8075b9a292$var$getInitialState(); // state for all gestures
    this.timeouts = {}; // keeping track of timeouts for debounced gestures (such as move, scroll, wheel)
    this.domListeners = []; // when config.domTarget is set, we attach events directly to the dom
    this.windowListeners = {}; // keeps track of window listeners added by gestures (drag only at the moment)
    this.bindings = {}; // an object holding the handlers associated to the gestures
    /**
   * Function ran on component unmount: cleans timeouts and removes dom listeners set by the bind function.
   */ this.clean = function() {
        _this.resetBindings();
        Object.values(_this.timeouts).forEach(clearTimeout);
        Object.keys(_this.windowListeners).forEach(function(stateKey) {
            return _this.removeWindowListeners(stateKey);
        });
    };
    /**
   * Function run every time the bind function is run (ie on every render).
   * Resets the binding object and remove dom listeners attached to config.domTarget
   */ this.resetBindings = function() {
        _this.bindings = {};
        var domTarget = _this.getDomTarget();
        if (domTarget) {
            $c65dae8075b9a292$var$removeListeners(domTarget, _this.domListeners, _this.config.eventOptions);
            _this.domListeners = [];
        }
    };
    /**
   * Returns the domTarget element and parses a ref if needed.
   */ this.getDomTarget = function() {
        var domTarget = _this.config.domTarget;
        return domTarget && "current" in domTarget ? domTarget.current : domTarget;
    };
    /**
   * Commodity function to let recognizers simply add listeners to config.window.
   */ this.addWindowListeners = function(stateKey, listeners) {
        if (!_this.config.window) return; // we use this.windowListeners to keep track of the listeners we add
        _this.windowListeners[stateKey] = listeners;
        $c65dae8075b9a292$var$addListeners(_this.config.window, listeners, _this.config.eventOptions);
    };
    /**
   * Commodity function to let recognizers simply remove listeners to config.window.
   */ this.removeWindowListeners = function(stateKey) {
        if (!_this.config.window) return;
        var listeners = _this.windowListeners[stateKey];
        if (listeners) {
            $c65dae8075b9a292$var$removeListeners(_this.config.window, listeners, _this.config.eventOptions);
            delete _this.windowListeners[stateKey];
        }
    };
    /**
   * When config.domTarget is set, this function will add dom listeners to it
   */ this.addDomTargetListeners = function(target) {
        /** We iterate on the entries of this.binding for each event, then we chain
     * the array of functions mapped to it and push them to this.domListeners
     */ Object.entries(_this.bindings).forEach(function(_ref) {
            var event = _ref[0], fns = _ref[1];
            _this.domListeners.push([
                event.substr(2).toLowerCase(),
                $c65dae8075b9a292$var$chainFns.apply(void 0, fns)
            ]);
        });
        $c65dae8075b9a292$var$addListeners(target, _this.domListeners, _this.config.eventOptions);
    };
    /**
   * this.bindings is an object which keys match ReactEventHandlerKeys.
   * Since a recognizer might want to bind a handler function to an event key already used by a previously
   * added recognizer, we need to make sure that each event key is an array of all the functions mapped for
   * that key.
   */ this.addBindings = function(eventNames, fn) {
        var eventNamesArray = !Array.isArray(eventNames) ? [
            eventNames
        ] : eventNames;
        eventNamesArray.forEach(function(eventName) {
            if (_this.bindings[eventName]) _this.bindings[eventName].push(fn);
            else _this.bindings[eventName] = [
                fn
            ];
        });
    };
    /**
   * getBindings will return an object that will be bound by users
   * to the react component they want to interact with.
   */ this.getBindings = function() {
        var bindings = {};
        var captureString = _this.config.captureString;
        Object.entries(_this.bindings).forEach(function(_ref2) {
            var event = _ref2[0], fns = _ref2[1];
            var fnsArray = Array.isArray(fns) ? fns : [
                fns
            ];
            var key = event + captureString;
            bindings[key] = $c65dae8075b9a292$var$chainFns.apply(void 0, fnsArray);
        });
        return bindings;
    };
    this.getBind = function() {
        // If config.domTarget is set we add event listeners to it and return the clean function.
        if (_this.config.domTarget) {
            var domTarget = _this.getDomTarget();
            domTarget && _this.addDomTargetListeners(domTarget);
            return _this.clean;
        } // If not, we return an object that contains gesture handlers mapped to react handler event keys.
        return _this.getBindings();
    };
};
/**
 * @private
 *
 * Utility hook called by all gesture hooks and that will be responsible for the internals.
 *
 * @param {Partial<InternalHandlers>} handlers
 * @param {RecognizerClasses} classes
 * @param {InternalConfig} config
 * @param {NativeHandlersPartial} nativeHandlers - native handlers such as onClick, onMouseDown, etc.
 * @returns {(...args: any[]) => HookReturnType<Config>}
 */ function $c65dae8075b9a292$var$useRecognizers(handlers, classes, config, nativeHandlers) {
    // The gesture controller keeping track of all gesture states
    var controller = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useMemo(function() {
        var current = new $c65dae8075b9a292$var$Controller();
        /**
     * The bind function will create gesture recognizers and return the right
     * bind object depending on whether `domTarget` was specified in the config object.
     */ var bind = function bind() {
            current.resetBindings();
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            for(var _iterator = $c65dae8075b9a292$var$_createForOfIteratorHelperLoose(classes), _step; !(_step = _iterator()).done;){
                var RecognizerClass = _step.value;
                new RecognizerClass(current, args).addBindings();
            } // we also add event bindings for native handlers
            if (controller.nativeRefs) for(var eventName in controller.nativeRefs)current.addBindings(eventName, controller.nativeRefs[eventName]);
            return current.getBind();
        };
        return {
            nativeRefs: nativeHandlers,
            current: current,
            bind: bind
        };
    }, []); // We reassign the config and handlers to the controller on every render.
    controller.current.config = config;
    controller.current.handlers = handlers; // We assign nativeHandlers, otherwise they won't be refreshed on the next render.
    controller.nativeRefs = nativeHandlers; // Run controller clean functions on unmount.
    (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useEffect(function() {
        return controller.current.clean;
    }, []);
    return controller.bind;
}
/**
 * @private
 * Recognizer abstract class.
 *
 * @protected
 * @abstract
 * @type {StateKey<T>} whether the Recognizer should deal with coordinates or distance / angle
 */ var $c65dae8075b9a292$var$Recognizer = /*#__PURE__*/ function() {
    /**
   * Creates an instance of a gesture recognizer.
   * @param stateKey drag, move, pinch, etc.
   * @param controller the controller attached to the gesture
   * @param [args] the args that should be passed to the gesture handler
   */ function Recognizer(stateKey, controller, args) {
        var _this = this;
        if (args === void 0) args = [];
        this.stateKey = stateKey;
        this.controller = controller;
        this.args = args;
        this.debounced = true; // Convenience method to set a timeout for a given gesture
        this.setTimeout = function(callback, ms) {
            var _window;
            if (ms === void 0) ms = 140;
            for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
            _this.controller.timeouts[_this.stateKey] = (_window = window).setTimeout.apply(_window, [
                callback,
                ms
            ].concat(args));
        }; // Convenience method to clear a timeout for a given gesture
        this.clearTimeout = function() {
            clearTimeout(_this.controller.timeouts[_this.stateKey]);
        }; // Convenience method to add window listeners for a given gesture
        this.addWindowListeners = function(listeners) {
            _this.controller.addWindowListeners(_this.stateKey, listeners);
        }; // Convenience method to remove window listeners for a given gesture
        this.removeWindowListeners = function() {
            _this.controller.removeWindowListeners(_this.stateKey);
        };
        /**
     * Returns the reinitialized start state for the gesture.
     * Should be common to all gestures.
     *
     * @param {Vector2} values
     * @param {UseGestureEvent} event
     * @returns - the start state for the gesture
     */ this.getStartGestureState = function(values, event) {
            return $c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, $c65dae8075b9a292$var$getInitialState()[_this.stateKey]), {}, {
                _active: true,
                values: values,
                initial: values,
                offset: _this.state.offset,
                lastOffset: _this.state.offset,
                startTime: event.timeStamp
            });
        }; // Runs rubberband on a vector
        this.rubberband = function(vector, rubberband) {
            var bounds = _this.config.bounds;
            /**
       * [x, y]: [rubberband(x, min, max), rubberband(y, min, max)]
       */ return vector.map(function(v, i) {
                return $c65dae8075b9a292$export$eb62c10c9b08d9ab(v, bounds[i][0], bounds[i][1], rubberband[i]);
            });
        };
        /**
     * Fires the gesture handler
     *
     * @param {boolean} [forceFlag] - if true, then the handler will fire even if the gesture is not intentional
     */ this.fireGestureHandler = function(forceFlag) {
            /**
       * If the gesture has been blocked (this can happen when the gesture has started in an unwanted direction),
       * clean everything and don't do anything.
       */ if (_this.state._blocked) {
                // we need debounced gestures to end by themselves
                if (!_this.debounced) {
                    _this.state._active = false;
                    _this.clean();
                }
                return null;
            } // If the gesture has no intentional dimension, don't do fire the handler.
            var _this$state$_intentio = _this.state._intentional, intentionalX = _this$state$_intentio[0], intentionalY = _this$state$_intentio[1];
            if (!forceFlag && intentionalX === false && intentionalY === false) return null;
            var _this$state = _this.state, _active = _this$state._active, active = _this$state.active;
            _this.state.active = _active;
            _this.state.first = _active && !active; // `first` is true when the gesture becomes active
            _this.state.last = active && !_active; // `last` is true when the gesture becomes inactive
            _this.controller.state.shared[_this.ingKey] = _active; // Sets dragging, pinching, etc. to the gesture active state
            var state = $c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, _this.controller.state.shared), _this.state), _this.mapStateValues(_this.state)); // @ts-ignore
            var newMemo = _this.handler(state); // Sets memo to the returned value of the handler (unless it's not undefined)
            _this.state.memo = newMemo !== void 0 ? newMemo : _this.state.memo; // Cleans the gesture when the gesture is no longer active.
            if (!_active) _this.clean();
            return state;
        };
    } // Returns the gesture config
    var _proto = Recognizer.prototype;
    // Conveninence method to update the shared state
    _proto.updateSharedState = function updateSharedState(sharedState) {
        Object.assign(this.controller.state.shared, sharedState);
    } // Conveninence method to update the gesture state
    ;
    _proto.updateGestureState = function updateGestureState(gestureState) {
        Object.assign(this.state, gestureState);
    } /**
   * Returns a generic, common payload for all gestures from an event.
   *
   * @param {UseGestureEvent} event
   * @param {boolean} [isStartEvent]
   * @returns - the generic gesture payload
   */ ;
    _proto.getGenericPayload = function getGenericPayload(event, isStartEvent) {
        var timeStamp = event.timeStamp, type = event.type;
        var _this$state2 = this.state, values = _this$state2.values, startTime = _this$state2.startTime;
        return {
            _lastEventType: type,
            event: event,
            timeStamp: timeStamp,
            elapsedTime: isStartEvent ? 0 : timeStamp - startTime,
            args: this.args,
            previous: values
        };
    } /**
   * Returns state properties depending on the movement and state.
   *
   * Should be overriden for custom behavior, doesn't do anything in the implementation
   * below.
   */ ;
    _proto.checkIntentionality = function checkIntentionality(_intentional, _movement, _state) {
        return {
            _intentional: _intentional,
            _blocked: false
        };
    } /**
   * Returns basic movement properties for the gesture based on the next values and current state.
   */ ;
    _proto.getMovement = function getMovement(values, state) {
        if (state === void 0) state = this.state;
        var _this$config = this.config, initial = _this$config.initial, threshold = _this$config.threshold, rubberband = _this$config.rubberband;
        var t0 = threshold[0], t1 = threshold[1];
        var _state2 = state, _initial = _state2._initial, _active = _state2._active, intentional = _state2._intentional, lastOffset = _state2.lastOffset, prevMovement = _state2.movement;
        var i0 = intentional[0], i1 = intentional[1];
        var _this$getInternalMove = this.getInternalMovement(values, state), _m0 = _this$getInternalMove[0], _m1 = _this$getInternalMove[1];
        /**
     * For both dimensions of the gesture, check its intentionality on each frame.
     */ if (i0 === false) i0 = $c65dae8075b9a292$var$getIntentionalDisplacement(_m0, t0);
        if (i1 === false) i1 = $c65dae8075b9a292$var$getIntentionalDisplacement(_m1, t1);
         // Get gesture specific state properties based on intentionality and movement.
        var intentionalityCheck = this.checkIntentionality([
            i0,
            i1
        ], [
            _m0,
            _m1
        ], state);
        var _intentional = intentionalityCheck._intentional, _blocked = intentionalityCheck._blocked;
        var _i0 = _intentional[0], _i1 = _intentional[1];
        var _movement = [
            _m0,
            _m1
        ];
        if (_i0 !== false && intentional[0] === false) _initial[0] = $c65dae8075b9a292$var$valueFn(initial)[0];
        if (_i1 !== false && intentional[1] === false) _initial[1] = $c65dae8075b9a292$var$valueFn(initial)[1];
        /**
     * If the gesture has been blocked (from gesture specific checkIntentionality),
     * stop right there.
     */ if (_blocked) return $c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, intentionalityCheck), {}, {
            _movement: _movement,
            delta: [
                0,
                0
            ]
        });
        /**
     * The movement sent to the handler has 0 in its dimensions when intentionality is false.
     * It is calculated from the actual movement minus the threshold.
     */ var movement = [
            _i0 !== false ? _m0 - _i0 : $c65dae8075b9a292$var$valueFn(initial)[0],
            _i1 !== false ? _m1 - _i1 : $c65dae8075b9a292$var$valueFn(initial)[1]
        ];
        var offset = $c65dae8075b9a292$export$ca6b5e3985063434(movement, lastOffset);
        /**
     * Rubberband should be 0 when the gesture is no longer active, so that movement
     * and offset can return within their bounds.
     */ var _rubberband = _active ? rubberband : [
            0,
            0
        ];
        movement = this.rubberband($c65dae8075b9a292$export$ca6b5e3985063434(movement, _initial), _rubberband); // rubberbanded movement
        return $c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, intentionalityCheck), {}, {
            _initial: _initial,
            _movement: _movement,
            movement: movement,
            offset: this.rubberband(offset, _rubberband),
            delta: $c65dae8075b9a292$export$e0f232dd469378a8(movement, prevMovement)
        });
    } // Cleans the gesture. Can be overriden by gestures.
    ;
    _proto.clean = function clean() {
        this.clearTimeout();
        this.removeWindowListeners();
    };
    $c65dae8075b9a292$var$_createClass(Recognizer, [
        {
            key: "config",
            get: function get() {
                return this.controller.config[this.stateKey];
            } // Is the gesture enabled
        },
        {
            key: "enabled",
            get: function get() {
                return this.controller.config.enabled && this.config.enabled;
            } // Returns the controller state for a given gesture
        },
        {
            key: "state",
            get: function get() {
                return this.controller.state[this.stateKey];
            } // Returns the gesture handler
        },
        {
            key: "handler",
            get: function get() {
                return this.controller.handlers[this.stateKey];
            }
        }
    ]);
    return Recognizer;
}();
/**
 * @private
 * Abstract class for coordinates-based gesture recongizers
 * @abstract
 * @class CoordinatesRecognizer
 * @extends {Recognizer<T>}
 * @template T
 */ var $c65dae8075b9a292$var$CoordinatesRecognizer = /*#__PURE__*/ function(_Recognizer) {
    $c65dae8075b9a292$var$_inheritsLoose(CoordinatesRecognizer, _Recognizer);
    function CoordinatesRecognizer() {
        return _Recognizer.apply(this, arguments) || this;
    }
    var _proto = CoordinatesRecognizer.prototype;
    /**
   * Returns the real movement (without taking intentionality into acount)
   */ _proto.getInternalMovement = function getInternalMovement(values, state) {
        return $c65dae8075b9a292$export$e0f232dd469378a8(values, state.initial);
    } /**
   * In coordinates-based gesture, this function will detect the first intentional axis,
   * lock the gesture axis if lockDirection is specified in the config, block the gesture
   * if the first intentional axis doesn't match the specified axis in config.
   *
   * @param {[FalseOrNumber, FalseOrNumber]} _intentional
   * @param {Vector2} _movement
   * @param {PartialGestureState<T>} state
   */ ;
    _proto.checkIntentionality = function checkIntentionality(_intentional, _movement, state) {
        var _intentional2 = _intentional, _ix = _intentional2[0], _iy = _intentional2[1];
        var intentionalMovement = _ix !== false || _iy !== false;
        var axis = state.axis;
        var _blocked = false; // If the movement is intentional, we can compute axis.
        if (intentionalMovement) {
            var _movement$map = _movement.map(Math.abs), absX = _movement$map[0], absY = _movement$map[1];
            var _this$config = this.config, configAxis = _this$config.axis, lockDirection = _this$config.lockDirection; // We make sure we only set axis value if it hadn't been detected before.
            axis = axis || (absX > absY ? "x" : absX < absY ? "y" : undefined);
            if (!!configAxis || lockDirection) {
                if (!!axis) {
                    // If the detected axis doesn't match the config axis we block the gesture
                    if (!!configAxis && axis !== configAxis) _blocked = true;
                    else {
                        // Otherwise we prevent the gesture from updating the unwanted axis.
                        var lockedIndex = axis === "x" ? 1 : 0;
                        _intentional[lockedIndex] = false;
                    }
                } else // Until we've detected the axis, we prevent the hnadler from updating.
                _intentional = [
                    false,
                    false
                ];
            }
        }
        return {
            _intentional: _intentional,
            _blocked: _blocked,
            axis: axis
        };
    };
    _proto.getKinematics = function getKinematics(values, event) {
        var timeStamp = this.state.timeStamp;
        var movementDetection = this.getMovement(values, this.state);
        var _blocked = movementDetection._blocked, delta = movementDetection.delta, movement = movementDetection.movement;
        if (_blocked) return movementDetection;
        var delta_t = event.timeStamp - timeStamp;
        var kinematics = $c65dae8075b9a292$var$calculateAllKinematics(movement, delta, delta_t);
        return $c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({
            values: values,
            delta: delta
        }, movementDetection), kinematics);
    };
    _proto.mapStateValues = function mapStateValues(state) {
        return {
            xy: state.values,
            vxvy: state.velocities
        };
    };
    return CoordinatesRecognizer;
}($c65dae8075b9a292$var$Recognizer);
var $c65dae8075b9a292$var$TAP_DISTANCE_THRESHOLD = 3;
var $c65dae8075b9a292$var$SWIPE_MAX_ELAPSED_TIME = 220;
var $c65dae8075b9a292$var$FILTER_REPEATED_EVENTS_DELAY = 200;
var $c65dae8075b9a292$var$DragRecognizer = /*#__PURE__*/ function(_CoordinatesRecognize) {
    $c65dae8075b9a292$var$_inheritsLoose(DragRecognizer, _CoordinatesRecognize);
    function DragRecognizer(controller, args) {
        var _this;
        _this = _CoordinatesRecognize.call(this, "drag", controller, args) || this;
        _this.ingKey = "dragging";
        _this.wasTouch = false;
        _this.isEventTypeTouch = function(type) {
            return !!type && type.indexOf("touch") === 0;
        };
        _this.dragShouldStart = function(event) {
            var _getGenericEventData = $c65dae8075b9a292$var$getGenericEventData(event), touches = _getGenericEventData.touches;
            var _lastEventType = _this.state._lastEventType;
            /**
       * This tries to filter out mouse events triggered by touch screens
       * */ // If the previous gesture was touch-based, and the current one is mouse based,
            // this means that we might be dealing with mouse simulated events if they're close to
            // each other. We're only doing this check when we're not using pointer events.
            if (!_this.controller.config.pointer && _this.isEventTypeTouch(_lastEventType) && !_this.isEventTypeTouch(event.type)) {
                var delay = Math.abs(event.timeStamp - _this.state.startTime);
                if (delay < $c65dae8075b9a292$var$FILTER_REPEATED_EVENTS_DELAY) return false;
            }
            return _this.enabled && touches < 2;
        };
        _this.setPointers = function(event) {
            var currentTarget = event.currentTarget, pointerId = event.pointerId;
            if (currentTarget) currentTarget.setPointerCapture(pointerId);
            _this.updateGestureState({
                currentTarget: currentTarget,
                pointerId: pointerId
            });
        };
        _this.removePointers = function() {
            var _this$state = _this.state, currentTarget = _this$state.currentTarget, pointerId = _this$state.pointerId;
            if (currentTarget && pointerId) currentTarget.releasePointerCapture(pointerId);
        };
        _this.setListeners = function(isTouch) {
            _this.removeWindowListeners();
            var dragListeners = isTouch ? [
                [
                    "touchmove",
                    _this.onDragChange
                ],
                [
                    "touchend",
                    _this.onDragEnd
                ],
                [
                    "touchcancel",
                    _this.onDragEnd
                ]
            ] : [
                [
                    "mousemove",
                    _this.onDragChange
                ],
                [
                    "mouseup",
                    _this.onDragEnd
                ]
            ];
            _this.addWindowListeners(dragListeners);
        };
        _this.onDragStart = function(event) {
            if (!_this.dragShouldStart(event)) return; // if pointers events
            if (_this.controller.config.pointer) _this.setPointers(event);
            else _this.setListeners(_this.isEventTypeTouch(event.type));
            if (_this.config.delay > 0) {
                _this.state._delayedEvent = true;
                if (typeof event.persist === "function") event.persist();
                _this.setTimeout(function() {
                    return _this.startDrag(event);
                }, _this.config.delay);
            } else _this.startDrag(event);
        };
        _this.onDragChange = function(event) {
            var canceled = _this.state.canceled;
            if (canceled) return;
            if (!_this.state._active) {
                if (_this.state._delayedEvent) {
                    _this.clearTimeout();
                    _this.startDrag(event);
                }
                return;
            }
            var genericEventData = $c65dae8075b9a292$var$getGenericEventData(event);
            if (!genericEventData.down) {
                _this.onDragEnd(event);
                return;
            }
            _this.updateSharedState(genericEventData);
            var _getPointerEventValue = $c65dae8075b9a292$var$getPointerEventValues(event), values = _getPointerEventValue.values;
            var kinematics = _this.getKinematics(values, event);
            var _isTap = _this.state._isTap;
            if (_isTap && $c65dae8075b9a292$var$calculateDistance(kinematics._movement) >= $c65dae8075b9a292$var$TAP_DISTANCE_THRESHOLD) _isTap = false;
            _this.updateGestureState($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, _this.getGenericPayload(event)), kinematics), {}, {
                _isTap: _isTap,
                cancel: function cancel() {
                    return _this.onCancel();
                }
            }));
            _this.fireGestureHandler();
        };
        _this.onDragEnd = function(event) {
            _this.state._active = false;
            _this.updateSharedState({
                down: false,
                buttons: 0,
                touches: 0
            });
            var _this$state2 = _this.state, _isTap = _this$state2._isTap, values = _this$state2.values, _this$state2$velociti = _this$state2.velocities, vx = _this$state2$velociti[0], vy = _this$state2$velociti[1], _this$state2$movement = _this$state2.movement, mx = _this$state2$movement[0], my = _this$state2$movement[1], _this$state2$_intenti = _this$state2._intentional, ix = _this$state2$_intenti[0], iy = _this$state2$_intenti[1];
            var endState = $c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, _this.getGenericPayload(event)), _this.getMovement(values));
            var elapsedTime = endState.elapsedTime;
            var _this$config = _this.config, _this$config$swipeVel = _this$config.swipeVelocity, svx = _this$config$swipeVel[0], svy = _this$config$swipeVel[1], _this$config$swipeDis = _this$config.swipeDistance, sx = _this$config$swipeDis[0], sy = _this$config$swipeDis[1];
            var swipe = [
                0,
                0
            ];
            if (elapsedTime < $c65dae8075b9a292$var$SWIPE_MAX_ELAPSED_TIME) {
                if (ix !== false && Math.abs(vx) > svx && Math.abs(mx) > sx) swipe[0] = $c65dae8075b9a292$var$sign(vx);
                if (iy !== false && Math.abs(vy) > svy && Math.abs(my) > sy) swipe[1] = $c65dae8075b9a292$var$sign(vy);
            }
            _this.updateGestureState($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({
                event: event
            }, endState), {}, {
                tap: _isTap,
                swipe: swipe
            }));
            _this.fireGestureHandler(_this.config.filterTaps && _this.state._isTap);
        };
        _this.clean = function() {
            _CoordinatesRecognize.prototype.clean.call($c65dae8075b9a292$var$_assertThisInitialized(_this));
            _this.state._delayedEvent = false;
            if (_this.controller.config.pointer) _this.removePointers();
        };
        _this.onCancel = function() {
            _this.updateGestureState({
                canceled: true,
                cancel: $c65dae8075b9a292$var$noop
            });
            _this.state._active = false;
            _this.updateSharedState({
                down: false,
                buttons: 0,
                touches: 0
            });
            requestAnimationFrame(function() {
                return _this.fireGestureHandler();
            });
        };
        return _this;
    }
    var _proto = DragRecognizer.prototype;
    _proto.startDrag = function startDrag(event) {
        var _this2 = this;
        var _getPointerEventValue2 = $c65dae8075b9a292$var$getPointerEventValues(event), values = _getPointerEventValue2.values;
        this.updateSharedState($c65dae8075b9a292$var$getGenericEventData(event));
        var startState = $c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, this.getStartGestureState(values, event)), this.getGenericPayload(event, true));
        this.updateGestureState($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, startState), this.getMovement(values, startState)), {}, {
            cancel: function cancel() {
                return _this2.onCancel();
            }
        }));
        this.fireGestureHandler();
    };
    _proto.addBindings = function addBindings() {
        if (this.controller.config.pointer) {
            this.controller.addBindings("onPointerDown", this.onDragStart);
            this.controller.addBindings("onPointerMove", this.onDragChange);
            this.controller.addBindings([
                "onPointerUp",
                "onPointerCancel"
            ], this.onDragEnd);
        } else this.controller.addBindings([
            "onTouchStart",
            "onMouseDown"
        ], this.onDragStart);
    };
    return DragRecognizer;
}($c65dae8075b9a292$var$CoordinatesRecognizer);
var $c65dae8075b9a292$var$DEFAULT_DRAG_DELAY = 180;
var $c65dae8075b9a292$var$DEFAULT_RUBBERBAND = 0.15;
var $c65dae8075b9a292$var$DEFAULT_SWIPE_VELOCITY = 0.5;
var $c65dae8075b9a292$var$DEFAULT_SWIPE_DISTANCE = 60;
var $c65dae8075b9a292$var$defaultWindow = typeof window !== "undefined" ? window : undefined;
var $c65dae8075b9a292$var$defaultCoordinatesOptions = {
    lockDirection: false,
    axis: undefined,
    bounds: undefined
};
/**
 * @private
 *
 * Returns the internal generic option object.
 *
 * @param {Partial<GenericOptions>} [config={}]
 * @returns {InternalGenericOptions}
 */ function $c65dae8075b9a292$var$getInternalGenericOptions(config) {
    if (config === void 0) config = {};
    var _config = config, _config$eventOptions = _config.eventOptions;
    _config$eventOptions = _config$eventOptions === void 0 ? {} : _config$eventOptions;
    var _config$eventOptions$ = _config$eventOptions.passive, passive = _config$eventOptions$ === void 0 ? true : _config$eventOptions$, _config$eventOptions$2 = _config$eventOptions.capture, capture = _config$eventOptions$2 === void 0 ? false : _config$eventOptions$2, _config$eventOptions$3 = _config$eventOptions.pointer, pointer = _config$eventOptions$3 === void 0 ? false : _config$eventOptions$3, _config$window = _config.window, window1 = _config$window === void 0 ? $c65dae8075b9a292$var$defaultWindow : _config$window, _config$domTarget = _config.domTarget, domTarget = _config$domTarget === void 0 ? undefined : _config$domTarget, _config$enabled = _config.enabled, enabled = _config$enabled === void 0 ? true : _config$enabled, restConfig = $c65dae8075b9a292$var$_objectWithoutPropertiesLoose(_config, [
        "eventOptions",
        "window",
        "domTarget",
        "enabled"
    ]);
    return $c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, restConfig), {}, {
        enabled: enabled,
        domTarget: domTarget,
        window: window1,
        // passive is always true if there's no domTarget
        eventOptions: {
            passive: !domTarget || !!passive,
            capture: !!capture
        },
        captureString: capture ? "Capture" : "",
        pointer: !!pointer
    });
}
function $c65dae8075b9a292$var$getInternalGestureOptions(gestureConfig) {
    var _gestureConfig$thresh = gestureConfig.threshold, threshold = _gestureConfig$thresh === void 0 ? undefined : _gestureConfig$thresh, _gestureConfig$rubber = gestureConfig.rubberband, rubberband = _gestureConfig$rubber === void 0 ? 0 : _gestureConfig$rubber, _gestureConfig$enable = gestureConfig.enabled, enabled = _gestureConfig$enable === void 0 ? true : _gestureConfig$enable, _gestureConfig$initia = gestureConfig.initial, initial = _gestureConfig$initia === void 0 ? [
        0,
        0
    ] : _gestureConfig$initia;
    if (typeof rubberband === "boolean") rubberband = rubberband ? $c65dae8075b9a292$var$DEFAULT_RUBBERBAND : 0;
    if (threshold === void 0) threshold = 0;
    return {
        enabled: enabled,
        initial: initial,
        threshold: $c65dae8075b9a292$var$def.array(threshold),
        rubberband: $c65dae8075b9a292$var$def.array(rubberband)
    };
}
function $c65dae8075b9a292$var$getInternalCoordinatesOptions(coordinatesConfig) {
    if (coordinatesConfig === void 0) coordinatesConfig = {};
    var _coordinatesConfig = coordinatesConfig, axis = _coordinatesConfig.axis, lockDirection = _coordinatesConfig.lockDirection, _coordinatesConfig$bo = _coordinatesConfig.bounds, bounds = _coordinatesConfig$bo === void 0 ? {} : _coordinatesConfig$bo, internalOptions = $c65dae8075b9a292$var$_objectWithoutPropertiesLoose(_coordinatesConfig, [
        "axis",
        "lockDirection",
        "bounds"
    ]);
    var boundsArray = [
        [
            $c65dae8075b9a292$var$def.withDefault(bounds.left, -Infinity),
            $c65dae8075b9a292$var$def.withDefault(bounds.right, Infinity)
        ],
        [
            $c65dae8075b9a292$var$def.withDefault(bounds.top, -Infinity),
            $c65dae8075b9a292$var$def.withDefault(bounds.bottom, Infinity)
        ]
    ];
    return $c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, $c65dae8075b9a292$var$getInternalGestureOptions(internalOptions)), $c65dae8075b9a292$var$defaultCoordinatesOptions), $c65dae8075b9a292$var$matchKeysFromObject({
        axis: axis,
        lockDirection: lockDirection
    }, coordinatesConfig)), {}, {
        bounds: boundsArray
    });
}
function $c65dae8075b9a292$var$getInternalDistanceAngleOptions(distanceAngleConfig) {
    if (distanceAngleConfig === void 0) distanceAngleConfig = {};
    var _distanceAngleConfig = distanceAngleConfig, _distanceAngleConfig$ = _distanceAngleConfig.distanceBounds, distanceBounds = _distanceAngleConfig$ === void 0 ? {} : _distanceAngleConfig$, _distanceAngleConfig$2 = _distanceAngleConfig.angleBounds, angleBounds = _distanceAngleConfig$2 === void 0 ? {} : _distanceAngleConfig$2, internalOptions = $c65dae8075b9a292$var$_objectWithoutPropertiesLoose(_distanceAngleConfig, [
        "distanceBounds",
        "angleBounds"
    ]);
    var boundsArray = [
        [
            $c65dae8075b9a292$var$def.withDefault(distanceBounds.min, -Infinity),
            $c65dae8075b9a292$var$def.withDefault(distanceBounds.max, Infinity)
        ],
        [
            $c65dae8075b9a292$var$def.withDefault(angleBounds.min, -Infinity),
            $c65dae8075b9a292$var$def.withDefault(angleBounds.max, Infinity)
        ]
    ];
    return $c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, $c65dae8075b9a292$var$getInternalGestureOptions(internalOptions)), {}, {
        bounds: boundsArray
    });
}
function $c65dae8075b9a292$var$getInternalDragOptions(dragConfig) {
    if (dragConfig === void 0) dragConfig = {};
    var _dragConfig = dragConfig, enabled = _dragConfig.enabled, threshold = _dragConfig.threshold, bounds = _dragConfig.bounds, rubberband = _dragConfig.rubberband, initial = _dragConfig.initial, dragOptions = $c65dae8075b9a292$var$_objectWithoutPropertiesLoose(_dragConfig, [
        "enabled",
        "threshold",
        "bounds",
        "rubberband",
        "initial"
    ]);
    var _dragOptions$swipeVel = dragOptions.swipeVelocity, swipeVelocity = _dragOptions$swipeVel === void 0 ? $c65dae8075b9a292$var$DEFAULT_SWIPE_VELOCITY : _dragOptions$swipeVel, _dragOptions$swipeDis = dragOptions.swipeDistance, swipeDistance = _dragOptions$swipeDis === void 0 ? $c65dae8075b9a292$var$DEFAULT_SWIPE_DISTANCE : _dragOptions$swipeDis, _dragOptions$delay = dragOptions.delay, delay = _dragOptions$delay === void 0 ? false : _dragOptions$delay, _dragOptions$filterTa = dragOptions.filterTaps, filterTaps = _dragOptions$filterTa === void 0 ? false : _dragOptions$filterTa, axis = dragOptions.axis, lockDirection = dragOptions.lockDirection;
    if (threshold === void 0) threshold = Math.max(0, filterTaps ? 3 : 0, lockDirection || axis ? 1 : 0);
    else filterTaps = true;
    var internalCoordinatesOptions = $c65dae8075b9a292$var$getInternalCoordinatesOptions($c65dae8075b9a292$var$matchKeysFromObject({
        enabled: enabled,
        threshold: threshold,
        bounds: bounds,
        rubberband: rubberband,
        axis: axis,
        lockDirection: lockDirection,
        initial: initial
    }, dragConfig));
    return $c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, internalCoordinatesOptions), {}, {
        filterTaps: filterTaps || internalCoordinatesOptions.threshold[0] + internalCoordinatesOptions.threshold[1] > 0,
        swipeVelocity: $c65dae8075b9a292$var$def.array(swipeVelocity),
        swipeDistance: $c65dae8075b9a292$var$def.array(swipeDistance),
        delay: typeof delay === "number" ? delay : delay ? $c65dae8075b9a292$var$DEFAULT_DRAG_DELAY : 0
    });
}
/**
 * @public
 *
 * Drag hook.
 *
 * @param {Handler<'drag'>} handler - the function fired every time the drag gesture updates
 * @param {(Config | {})} [config={}] - the config object including generic options and drag options
 * @returns {(...args: any[]) => HookReturnType<Config>}
 */ function $c65dae8075b9a292$export$7941f8aafa4b6021(handler, config) {
    if (config === void 0) config = {};
    var _config = config, domTarget = _config.domTarget, eventOptions = _config.eventOptions, window1 = _config.window, drag = $c65dae8075b9a292$var$_objectWithoutPropertiesLoose(_config, [
        "domTarget",
        "eventOptions",
        "window"
    ]);
    /**
   * TODO: at the moment we recompute the config object at every render
   * this could probably be optimized
   */ var mergedConfig = $c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, $c65dae8075b9a292$var$getInternalGenericOptions({
        domTarget: domTarget,
        eventOptions: eventOptions,
        window: window1
    })), {}, {
        drag: $c65dae8075b9a292$var$getInternalDragOptions(drag)
    });
    return $c65dae8075b9a292$var$useRecognizers({
        drag: handler
    }, [
        $c65dae8075b9a292$var$DragRecognizer
    ], mergedConfig);
}
/**
 * @private
 * Abstract class for distance/angle-based gesture recongizers
 * @abstract
 * @class DistanceAngleRecognizer
 * @extends {Recognizer<T>}
 * @template T
 */ var $c65dae8075b9a292$var$DistanceAngleRecognizer = /*#__PURE__*/ function(_Recognizer) {
    $c65dae8075b9a292$var$_inheritsLoose(DistanceAngleRecognizer, _Recognizer);
    function DistanceAngleRecognizer() {
        return _Recognizer.apply(this, arguments) || this;
    }
    var _proto = DistanceAngleRecognizer.prototype;
    /**
   * Returns the real movement (without taking intentionality into acount)
   */ _proto.getInternalMovement = function getInternalMovement(_ref, state) {
        var d = _ref[0], a = _ref[1];
        var da = state.values, turns = state.turns, initial = state.initial; // angle might not be defined when ctrl wheel is used for zoom only
        // in that case we set it to the previous angle value
        a = a !== void 0 ? a : da[1];
        var delta_a = a - da[1];
        /**
     * The angle value might jump from 179deg to -179deg when we actually want to
     * read 181deg to ensure continuity. To make that happen, we detect when the jump
     * is supsiciously high (ie > 270deg) and increase the `turns` value
     */ var newTurns = Math.abs(delta_a) > 270 ? turns + $c65dae8075b9a292$var$sign(delta_a) : turns; // we update the angle difference to its corrected value
        var movement_d = d - initial[0];
        var movement_a = a - 360 * newTurns - initial[1];
        return [
            movement_d,
            movement_a
        ];
    };
    _proto.getKinematics = function getKinematics(values, event) {
        var _this$state = this.state, timeStamp = _this$state.timeStamp, initial = _this$state.initial;
        var movementDetection = this.getMovement(values, this.state);
        var delta = movementDetection.delta, movement = movementDetection.movement;
        var turns = (values[1] - movement[1] - initial[1]) / 360;
        var delta_t = event.timeStamp - timeStamp;
        var kinematics = $c65dae8075b9a292$var$calculateAllKinematics(movement, delta, delta_t);
        return $c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({
            values: values,
            delta: delta,
            turns: turns
        }, movementDetection), kinematics);
    };
    _proto.mapStateValues = function mapStateValues(state) {
        return {
            da: state.values,
            vdva: state.velocities
        };
    };
    return DistanceAngleRecognizer;
}($c65dae8075b9a292$var$Recognizer);
var $c65dae8075b9a292$var$PinchRecognizer = /*#__PURE__*/ function(_DistanceAngleRecogni) {
    $c65dae8075b9a292$var$_inheritsLoose(PinchRecognizer, _DistanceAngleRecogni);
    function PinchRecognizer(controller, args) {
        var _this;
        _this = _DistanceAngleRecogni.call(this, "pinch", controller, args) || this;
        _this.ingKey = "pinching";
        _this.pinchShouldStart = function(event) {
            var _getGenericEventData = $c65dae8075b9a292$var$getGenericEventData(event), touches = _getGenericEventData.touches;
            return _this.enabled && touches === 2;
        };
        _this.onPinchStart = function(event) {
            if (!_this.pinchShouldStart(event)) return;
            var _getTwoTouchesEventDa = $c65dae8075b9a292$var$getTwoTouchesEventData(event), values = _getTwoTouchesEventDa.values, origin = _getTwoTouchesEventDa.origin;
            _this.updateSharedState($c65dae8075b9a292$var$getGenericEventData(event));
            var startState = $c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, _this.getStartGestureState(values, event)), _this.getGenericPayload(event, true));
            _this.updateGestureState($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, startState), _this.getMovement(values, startState)), {}, {
                origin: origin,
                cancel: function cancel() {
                    return _this.onCancel();
                }
            }));
            _this.fireGestureHandler();
        };
        _this.onPinchChange = function(event) {
            var _this$state = _this.state, canceled = _this$state.canceled, timeStamp = _this$state.timeStamp, _active = _this$state._active;
            if (canceled || !_active) return;
            var genericEventData = $c65dae8075b9a292$var$getGenericEventData(event);
            if (genericEventData.touches !== 2 || event.timeStamp === timeStamp) return;
            _this.updateSharedState(genericEventData);
            var _getTwoTouchesEventDa2 = $c65dae8075b9a292$var$getTwoTouchesEventData(event), values = _getTwoTouchesEventDa2.values, origin = _getTwoTouchesEventDa2.origin;
            var kinematics = _this.getKinematics(values, event);
            _this.updateGestureState($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, _this.getGenericPayload(event)), kinematics), {}, {
                origin: origin,
                cancel: function cancel() {
                    return _this.onCancel();
                }
            }));
            _this.fireGestureHandler();
        };
        _this.onPinchEnd = function(event) {
            if (!_this.state.active) return;
            _this.state._active = false;
            _this.updateSharedState({
                down: false,
                touches: 0
            });
            _this.updateGestureState($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({
                event: event
            }, _this.getGenericPayload(event)), _this.getMovement(_this.state.values)));
            _this.fireGestureHandler();
        };
        _this.onCancel = function() {
            _this.state._active = false;
            _this.updateGestureState({
                canceled: true,
                cancel: $c65dae8075b9a292$var$noop
            });
            _this.updateSharedState({
                down: false,
                touches: 0
            });
            requestAnimationFrame(function() {
                return _this.fireGestureHandler();
            });
        };
        /**
     * PINCH WITH WEBKIT GESTURES
     */ _this.onGestureStart = function(event) {
            if (!_this.enabled) return;
            event.preventDefault();
            var _getWebkitGestureEven = $c65dae8075b9a292$var$getWebkitGestureEventValues(event), values = _getWebkitGestureEven.values;
            _this.updateSharedState($c65dae8075b9a292$var$getGenericEventData(event));
            var startState = $c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, _this.getStartGestureState(values, event)), _this.getGenericPayload(event, true));
            _this.updateGestureState($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, startState), _this.getMovement(values, startState)), {}, {
                cancel: function cancel() {
                    return _this.onCancel();
                }
            }));
            _this.fireGestureHandler();
        };
        _this.onGestureChange = function(event) {
            var _this$state2 = _this.state, canceled = _this$state2.canceled, _active = _this$state2._active;
            if (canceled || !_active) return;
            event.preventDefault();
            var genericEventData = $c65dae8075b9a292$var$getGenericEventData(event);
            _this.updateSharedState(genericEventData);
            var _getWebkitGestureEven2 = $c65dae8075b9a292$var$getWebkitGestureEventValues(event), values = _getWebkitGestureEven2.values;
            var kinematics = _this.getKinematics(values, event);
            _this.updateGestureState($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, _this.getGenericPayload(event)), kinematics), {}, {
                cancel: function cancel() {
                    return _this.onCancel();
                }
            }));
            _this.fireGestureHandler();
        };
        _this.onGestureEnd = function(event) {
            event.preventDefault();
            if (!_this.state.active) return;
            _this.state._active = false;
            _this.updateSharedState({
                down: false,
                touches: 0
            });
            _this.updateGestureState($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({
                event: event
            }, _this.getGenericPayload(event)), _this.getMovement(_this.state.values)));
            _this.fireGestureHandler();
        };
        _this.updateTouchData = function(event) {
            if (!_this.enabled || event.touches.length !== 2 || !_this.state._active) return;
            var _getTwoTouchesEventDa3 = $c65dae8075b9a292$var$getTwoTouchesEventData(event), origin = _getTwoTouchesEventDa3.origin;
            _this.state.origin = origin;
        };
        /**
     * PINCH WITH WHEEL
     */ _this.wheelShouldRun = function(event) {
            return _this.enabled && event.ctrlKey;
        };
        _this.getWheelValuesFromEvent = function(event) {
            var _getWheelEventValues = $c65dae8075b9a292$var$getWheelEventValues(event), _getWheelEventValues$ = _getWheelEventValues.values, delta_d = _getWheelEventValues$[1];
            var _this$state$values = _this.state.values, prev_d = _this$state$values[0], prev_a = _this$state$values[1];
            var d = prev_d - delta_d;
            var a = prev_a !== void 0 ? prev_a : 0;
            return {
                values: [
                    d,
                    a
                ],
                origin: [
                    event.clientX,
                    event.clientY
                ],
                delta: [
                    0,
                    delta_d
                ]
            };
        };
        _this.onWheel = function(event) {
            if (!_this.wheelShouldRun(event)) return;
            _this.clearTimeout();
            _this.setTimeout(_this.onWheelEnd);
            if (!_this.state._active) _this.onWheelStart(event);
            else _this.onWheelChange(event);
        };
        _this.onWheelStart = function(event) {
            var _this$getWheelValuesF = _this.getWheelValuesFromEvent(event), values = _this$getWheelValuesF.values, delta = _this$getWheelValuesF.delta, origin = _this$getWheelValuesF.origin;
            if (!_this.controller.config.eventOptions.passive) event.preventDefault();
            _this.updateSharedState($c65dae8075b9a292$var$getGenericEventData(event));
            var startState = $c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, _this.getStartGestureState(values, event)), _this.getGenericPayload(event, true)), {}, {
                initial: _this.state.values
            });
            _this.updateGestureState($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, startState), _this.getMovement(values, startState)), {}, {
                offset: values,
                delta: delta,
                origin: origin
            }));
            _this.fireGestureHandler();
        };
        _this.onWheelChange = function(event) {
            var genericEventData = $c65dae8075b9a292$var$getGenericEventData(event);
            _this.updateSharedState(genericEventData);
            var _this$getWheelValuesF2 = _this.getWheelValuesFromEvent(event), values = _this$getWheelValuesF2.values, origin = _this$getWheelValuesF2.origin, delta = _this$getWheelValuesF2.delta;
            var kinematics = _this.getKinematics(values, event);
            _this.updateGestureState($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, _this.getGenericPayload(event)), kinematics), {}, {
                origin: origin,
                delta: delta
            }));
            _this.fireGestureHandler();
        };
        _this.onWheelEnd = function() {
            _this.state._active = false;
            _this.updateGestureState(_this.getMovement(_this.state.values));
            _this.fireGestureHandler();
        };
        return _this;
    }
    var _proto = PinchRecognizer.prototype;
    _proto.addBindings = function addBindings() {
        // Only try to use gesture events when they are supported and domTarget is set
        // as React doesn't support gesture handlers.
        if (this.controller.config.domTarget && $c65dae8075b9a292$var$supportsGestureEvents()) {
            this.controller.addBindings("onGestureStart", this.onGestureStart);
            this.controller.addBindings("onGestureChange", this.onGestureChange);
            this.controller.addBindings([
                "onGestureEnd",
                "onTouchCancel"
            ], this.onGestureEnd);
            this.controller.addBindings([
                "onTouchStart",
                "onTouchMove"
            ], this.updateTouchData);
        } else {
            this.controller.addBindings("onTouchStart", this.onPinchStart);
            this.controller.addBindings("onTouchMove", this.onPinchChange);
            this.controller.addBindings([
                "onTouchEnd",
                "onTouchCancel"
            ], this.onPinchEnd);
            this.controller.addBindings("onWheel", this.onWheel);
        }
    };
    return PinchRecognizer;
}($c65dae8075b9a292$var$DistanceAngleRecognizer);
/**
 * @public
 *
 * Pinch hook.
 *
 * @param {Handler<'pinch'>} handler - the function fired every time the pinch gesture updates
 * @param {(Config | {})} [config={}] - the config object including generic options and pinch options
 * @returns {(...args: any[]) => HookReturnType<Config>}
 */ function $c65dae8075b9a292$export$ccc26886ea7dba8f(handler, config) {
    if (config === void 0) config = {};
    var _config = config, domTarget = _config.domTarget, eventOptions = _config.eventOptions, window1 = _config.window, pinch = $c65dae8075b9a292$var$_objectWithoutPropertiesLoose(_config, [
        "domTarget",
        "eventOptions",
        "window"
    ]);
    /**
   * TODO: at the moment we recompute the config object at every render
   * this could probably be optimized
   */ var mergedConfig = $c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, $c65dae8075b9a292$var$getInternalGenericOptions({
        domTarget: domTarget,
        eventOptions: eventOptions,
        window: window1
    })), {}, {
        pinch: $c65dae8075b9a292$var$getInternalDistanceAngleOptions(pinch)
    });
    return $c65dae8075b9a292$var$useRecognizers({
        pinch: handler
    }, [
        $c65dae8075b9a292$var$PinchRecognizer
    ], mergedConfig);
}
var $c65dae8075b9a292$var$WheelRecognizer = /*#__PURE__*/ function(_CoordinatesRecognize) {
    $c65dae8075b9a292$var$_inheritsLoose(WheelRecognizer, _CoordinatesRecognize);
    function WheelRecognizer(controller, args) {
        var _this;
        _this = _CoordinatesRecognize.call(this, "wheel", controller, args) || this;
        _this.ingKey = "wheeling";
        _this.debounced = true;
        _this.wheelShouldRun = function(event) {
            if (event.ctrlKey && "pinch" in _this.controller.handlers) return false;
            return _this.enabled;
        };
        _this.getValuesFromEvent = function(event) {
            var prevValues = _this.state.values;
            var _getWheelEventValues = $c65dae8075b9a292$var$getWheelEventValues(event), values = _getWheelEventValues.values;
            return {
                values: $c65dae8075b9a292$export$ca6b5e3985063434(values, prevValues)
            };
        };
        _this.onWheel = function(event) {
            if (!_this.wheelShouldRun(event)) return;
            _this.clearTimeout();
            _this.setTimeout(_this.onWheelEnd);
            if (!_this.state._active) _this.onWheelStart(event);
            else _this.onWheelChange(event);
        };
        _this.onWheelStart = function(event) {
            var _this$getValuesFromEv = _this.getValuesFromEvent(event), values = _this$getValuesFromEv.values;
            _this.updateSharedState($c65dae8075b9a292$var$getGenericEventData(event));
            var startState = $c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, _this.getStartGestureState(values, event)), _this.getGenericPayload(event, true)), {}, {
                initial: _this.state.values
            });
            var movementDetection = _this.getMovement(values, startState);
            var delta = movementDetection.delta;
            _this.updateGestureState($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, startState), movementDetection), {}, {
                distance: $c65dae8075b9a292$var$calculateDistance(delta),
                direction: $c65dae8075b9a292$var$calculateDirection(delta)
            }));
            _this.fireGestureHandler();
        };
        _this.onWheelChange = function(event) {
            var genericEventData = $c65dae8075b9a292$var$getGenericEventData(event);
            _this.updateSharedState(genericEventData);
            var _this$getValuesFromEv2 = _this.getValuesFromEvent(event), values = _this$getValuesFromEv2.values;
            var kinematics = _this.getKinematics(values, event);
            _this.updateGestureState($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, _this.getGenericPayload(event)), kinematics));
            _this.fireGestureHandler();
        };
        _this.onWheelEnd = function() {
            _this.state._active = false;
            _this.updateGestureState($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, _this.getMovement(_this.state.values)), {}, {
                velocities: [
                    0,
                    0
                ],
                velocity: 0
            }));
            _this.fireGestureHandler();
        };
        return _this;
    }
    var _proto = WheelRecognizer.prototype;
    _proto.addBindings = function addBindings() {
        this.controller.addBindings("onWheel", this.onWheel);
    };
    return WheelRecognizer;
}($c65dae8075b9a292$var$CoordinatesRecognizer);
/**
 * @public
 *
 * Wheel hook.
 *
 * @param {Handler<'wheel'>} handler - the function fired every time the wheel gesture updates
 * @param {(Config | {})} [config={}] - the config object including generic options and wheel options
 * @returns {(...args: any[]) => HookReturnType<Config>}
 */ function $c65dae8075b9a292$export$43260e1b277d5f62(handler, config) {
    if (config === void 0) config = {};
    var _config = config, domTarget = _config.domTarget, eventOptions = _config.eventOptions, window1 = _config.window, wheel = $c65dae8075b9a292$var$_objectWithoutPropertiesLoose(_config, [
        "domTarget",
        "eventOptions",
        "window"
    ]);
    /**
   * TODO: at the moment we recompute the config object at every render
   * this could probably be optimized
   */ var mergedConfig = $c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, $c65dae8075b9a292$var$getInternalGenericOptions({
        domTarget: domTarget,
        eventOptions: eventOptions,
        window: window1
    })), {}, {
        wheel: $c65dae8075b9a292$var$getInternalCoordinatesOptions(wheel)
    });
    return $c65dae8075b9a292$var$useRecognizers({
        wheel: handler
    }, [
        $c65dae8075b9a292$var$WheelRecognizer
    ], mergedConfig);
}
var $c65dae8075b9a292$var$MoveRecognizer = /*#__PURE__*/ function(_CoordinatesRecognize) {
    $c65dae8075b9a292$var$_inheritsLoose(MoveRecognizer, _CoordinatesRecognize);
    function MoveRecognizer(controller, args) {
        var _this;
        _this = _CoordinatesRecognize.call(this, "move", controller, args) || this;
        _this.ingKey = "moving";
        _this.debounced = true;
        _this.moveShouldRun = function() {
            return _this.enabled;
        };
        _this.onMove = function(event) {
            if (!_this.moveShouldRun()) return;
            _this.clearTimeout();
            _this.setTimeout(_this.onMoveEnd);
            if (!_this.state._active) _this.onMoveStart(event);
            else _this.onMoveChange(event);
        };
        _this.onMoveStart = function(event) {
            var _getPointerEventValue = $c65dae8075b9a292$var$getPointerEventValues(event), values = _getPointerEventValue.values;
            _this.updateSharedState($c65dae8075b9a292$var$getGenericEventData(event));
            var startState = $c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, _this.getStartGestureState(values, event)), _this.getGenericPayload(event, true));
            _this.updateGestureState($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, startState), _this.getMovement(values, startState)));
            _this.fireGestureHandler();
        };
        _this.onMoveChange = function(event) {
            var genericEventData = $c65dae8075b9a292$var$getGenericEventData(event);
            _this.updateSharedState(genericEventData);
            var _getPointerEventValue2 = $c65dae8075b9a292$var$getPointerEventValues(event), values = _getPointerEventValue2.values;
            var kinematics = _this.getKinematics(values, event);
            _this.updateGestureState($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, _this.getGenericPayload(event)), kinematics));
            _this.fireGestureHandler();
        };
        _this.onMoveEnd = function() {
            _this.state._active = false;
            _this.updateGestureState($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, _this.getMovement(_this.state.values)), {}, {
                velocities: [
                    0,
                    0
                ],
                velocity: 0
            }));
            _this.fireGestureHandler();
        };
        _this.onPointerEnter = function(event) {
            _this.controller.state.shared.hovering = true;
            if (!_this.controller.config.enabled) return;
            if (_this.controller.config.hover.enabled) {
                var _getPointerEventValue3 = $c65dae8075b9a292$var$getPointerEventValues(event), values = _getPointerEventValue3.values;
                var state = $c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, _this.controller.state.shared), _this.state), _this.getGenericPayload(event, true)), {}, {
                    values: values,
                    active: true,
                    hovering: true
                });
                _this.controller.handlers.hover($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, state), _this.mapStateValues(state)));
            }
            if ("move" in _this.controller.handlers) _this.onMoveStart(event);
        };
        _this.onPointerLeave = function(event) {
            _this.controller.state.shared.hovering = false;
            if ("move" in _this.controller.handlers) _this.onMoveEnd();
            if (_this.controller.config.hover.enabled) {
                var _getPointerEventValue4 = $c65dae8075b9a292$var$getPointerEventValues(event), values = _getPointerEventValue4.values;
                var state = $c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, _this.controller.state.shared), _this.state), _this.getGenericPayload(event)), {}, {
                    values: values,
                    active: false
                });
                _this.controller.handlers.hover($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, state), _this.mapStateValues(state)));
            }
        };
        return _this;
    }
    var _proto = MoveRecognizer.prototype;
    _proto.addBindings = function addBindings() {
        if (this.controller.config.pointer) {
            if ("move" in this.controller.handlers) this.controller.addBindings("onPointerMove", this.onMove);
            if ("hover" in this.controller.handlers) {
                this.controller.addBindings("onPointerEnter", this.onPointerEnter);
                this.controller.addBindings("onPointerLeave", this.onPointerLeave);
            }
        } else {
            if ("move" in this.controller.handlers) this.controller.addBindings("onMouseMove", this.onMove);
            if ("hover" in this.controller.handlers) {
                this.controller.addBindings("onMouseEnter", this.onPointerEnter);
                this.controller.addBindings("onMouseLeave", this.onPointerLeave);
            }
        }
    };
    return MoveRecognizer;
}($c65dae8075b9a292$var$CoordinatesRecognizer);
/**
 * @public
 *
 * Move hook.
 *
 * @param {Handler<'move'>} handler - the function fired every time the move gesture updates
 * @param {(Config | {})} [config={}] - the config object including generic options and move options
 * @returns {(...args: any[]) => HookReturnType<Config>}
 */ function $c65dae8075b9a292$export$36da96379f79f245(handler, config) {
    if (config === void 0) config = {};
    var _config = config, domTarget = _config.domTarget, eventOptions = _config.eventOptions, window1 = _config.window, move = $c65dae8075b9a292$var$_objectWithoutPropertiesLoose(_config, [
        "domTarget",
        "eventOptions",
        "window"
    ]);
    /**
   * TODO: at the moment we recompute the config object at every render
   * this could probably be optimized
   */ var mergedConfig = $c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, $c65dae8075b9a292$var$getInternalGenericOptions({
        domTarget: domTarget,
        eventOptions: eventOptions,
        window: window1
    })), {}, {
        move: $c65dae8075b9a292$var$getInternalCoordinatesOptions(move)
    });
    return $c65dae8075b9a292$var$useRecognizers({
        move: handler
    }, [
        $c65dae8075b9a292$var$MoveRecognizer
    ], mergedConfig);
}
/**
 * @public
 *
 * Hover hook.
 *
 * @param {Handler<'hover'>} handler - the function fired every time the hover gesture updates
 * @param {(Config | {})} [config={}] - the config object including generic options and hover options
 * @returns {(...args: any[]) => HookReturnType<Config>}
 */ function $c65dae8075b9a292$export$ae780daf29e6d456(handler, config) {
    if (config === void 0) config = {};
    var _config = config, domTarget = _config.domTarget, eventOptions = _config.eventOptions, window1 = _config.window, hover = $c65dae8075b9a292$var$_objectWithoutPropertiesLoose(_config, [
        "domTarget",
        "eventOptions",
        "window"
    ]);
    /**
   * TODO: at the moment we recompute the config object at every render
   * this could probably be optimized
   */ var mergedConfig = $c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, $c65dae8075b9a292$var$getInternalGenericOptions({
        domTarget: domTarget,
        eventOptions: eventOptions,
        window: window1
    })), {}, {
        hover: $c65dae8075b9a292$var$_extends({
            enabled: true
        }, hover)
    });
    return $c65dae8075b9a292$var$useRecognizers({
        hover: handler
    }, [
        $c65dae8075b9a292$var$MoveRecognizer
    ], mergedConfig);
}
var $c65dae8075b9a292$var$ScrollRecognizer = /*#__PURE__*/ function(_CoordinatesRecognize) {
    $c65dae8075b9a292$var$_inheritsLoose(ScrollRecognizer, _CoordinatesRecognize);
    function ScrollRecognizer(controller, args) {
        var _this;
        _this = _CoordinatesRecognize.call(this, "scroll", controller, args) || this;
        _this.ingKey = "scrolling";
        _this.debounced = true;
        _this.scrollShouldRun = function() {
            return _this.enabled;
        };
        _this.onScroll = function(event) {
            if (!_this.scrollShouldRun()) return;
            _this.clearTimeout();
            _this.setTimeout(_this.onScrollEnd);
            if (!_this.state._active) _this.onScrollStart(event);
            else _this.onScrollChange(event);
        };
        _this.onScrollStart = function(event) {
            var _getScrollEventValues = $c65dae8075b9a292$var$getScrollEventValues(event), values = _getScrollEventValues.values;
            _this.updateSharedState($c65dae8075b9a292$var$getGenericEventData(event));
            var startState = $c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, _this.getStartGestureState(values, event)), _this.getGenericPayload(event, true)), {}, {
                initial: _this.state.values
            });
            var movementDetection = _this.getMovement(values, startState);
            var delta = movementDetection.delta;
            _this.updateGestureState($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, startState), movementDetection), {}, {
                distance: $c65dae8075b9a292$var$calculateDistance(delta),
                direction: $c65dae8075b9a292$var$calculateDirection(delta)
            }));
            _this.fireGestureHandler();
        };
        _this.onScrollChange = function(event) {
            var genericEventData = $c65dae8075b9a292$var$getGenericEventData(event);
            _this.updateSharedState(genericEventData);
            var _getScrollEventValues2 = $c65dae8075b9a292$var$getScrollEventValues(event), values = _getScrollEventValues2.values;
            var kinematics = _this.getKinematics(values, event);
            _this.updateGestureState($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, _this.getGenericPayload(event)), kinematics));
            _this.fireGestureHandler();
        };
        _this.onScrollEnd = function() {
            _this.state._active = false;
            _this.updateGestureState($c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, _this.getMovement(_this.state.values)), {}, {
                velocities: [
                    0,
                    0
                ],
                velocity: 0
            }));
            _this.fireGestureHandler();
        };
        return _this;
    }
    var _proto = ScrollRecognizer.prototype;
    _proto.addBindings = function addBindings() {
        this.controller.addBindings("onScroll", this.onScroll);
    };
    return ScrollRecognizer;
}($c65dae8075b9a292$var$CoordinatesRecognizer);
/**
 * @public
 *
 * Scroll hook.
 *
 * @param {Handler<'scroll'>} handler - the function fired every time the scroll gesture updates
 * @param {(Config | {})} [config={}] - the config object including generic options and scroll options
 * @returns {(...args: any[]) => HookReturnType<Config>}
 */ function $c65dae8075b9a292$export$d928051c8cd740b(handler, config) {
    if (config === void 0) config = {};
    var _config = config, domTarget = _config.domTarget, eventOptions = _config.eventOptions, window1 = _config.window, scroll = $c65dae8075b9a292$var$_objectWithoutPropertiesLoose(_config, [
        "domTarget",
        "eventOptions",
        "window"
    ]);
    /**
   * TODO: at the moment we recompute the config object at every render
   * this could probably be optimized
   */ var mergedConfig = $c65dae8075b9a292$var$_extends($c65dae8075b9a292$var$_extends({}, $c65dae8075b9a292$var$getInternalGenericOptions({
        domTarget: domTarget,
        eventOptions: eventOptions,
        window: window1
    })), {}, {
        scroll: $c65dae8075b9a292$var$getInternalCoordinatesOptions(scroll)
    });
    return $c65dae8075b9a292$var$useRecognizers({
        scroll: handler
    }, [
        $c65dae8075b9a292$var$ScrollRecognizer
    ], mergedConfig);
}
/**
 * @public
 *
 * The most complete gesture hook, allowing support for multiple gestures.
 *
 * @param {UserHandlersPartial} handlers - an object with on[Gesture] keys containg gesture handlers
 * @param {UseGestureConfig} [config={}] - the full config object
 * @returns {(...args: any[]) => HookReturnType<Config>}
 */ function $c65dae8075b9a292$export$ece84446a783717(handlers, config) {
    if (config === void 0) config = {};
    /**
   * If handlers contains {onDragStart, onDrag, onDragEnd, onMoveStart, onMove}
   * actions will include 'onDrag' and 'onMove.
   */ var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useState(function() {
        return new Set(Object.keys(handlers).map(function(k) {
            return k.replace(/End|Start/, "");
        }));
    }), actions = _React$useState[0];
    /**
   * Here we compute the derived internal config based on the provided config object.
   * We decompose the config into its generic and gesture options and compute each.
   * TODO: this is currently done on every render!
   */ var _config = config, drag = _config.drag, wheel = _config.wheel, move = _config.move, scroll = _config.scroll, pinch = _config.pinch, hover = _config.hover, restConfig = $c65dae8075b9a292$var$_objectWithoutPropertiesLoose(_config, [
        "drag",
        "wheel",
        "move",
        "scroll",
        "pinch",
        "hover"
    ]);
    var mergedConfig = $c65dae8075b9a292$var$getInternalGenericOptions(restConfig);
    var classes = [];
    var internalHandlers = {}; // will hold reference to native handlers such as onClick, onMouseDown, etc.
    var _nativeHandlers = $c65dae8075b9a292$var$_extends({}, handlers);
    if (actions.has("onDrag")) {
        classes.push($c65dae8075b9a292$var$DragRecognizer);
        internalHandlers.drag = $c65dae8075b9a292$var$includeStartEndHandlers(handlers, "onDrag", _nativeHandlers);
        mergedConfig.drag = $c65dae8075b9a292$var$getInternalDragOptions(drag);
    }
    if (actions.has("onWheel")) {
        classes.push($c65dae8075b9a292$var$WheelRecognizer);
        internalHandlers.wheel = $c65dae8075b9a292$var$includeStartEndHandlers(handlers, "onWheel", _nativeHandlers);
        mergedConfig.wheel = $c65dae8075b9a292$var$getInternalCoordinatesOptions(wheel);
    }
    if (actions.has("onScroll")) {
        classes.push($c65dae8075b9a292$var$ScrollRecognizer);
        internalHandlers.scroll = $c65dae8075b9a292$var$includeStartEndHandlers(handlers, "onScroll", _nativeHandlers);
        mergedConfig.scroll = $c65dae8075b9a292$var$getInternalCoordinatesOptions(scroll);
    }
    if (actions.has("onMove")) {
        classes.push($c65dae8075b9a292$var$MoveRecognizer);
        internalHandlers.move = $c65dae8075b9a292$var$includeStartEndHandlers(handlers, "onMove", _nativeHandlers);
        mergedConfig.move = $c65dae8075b9a292$var$getInternalCoordinatesOptions(move);
    }
    if (actions.has("onPinch")) {
        classes.push($c65dae8075b9a292$var$PinchRecognizer);
        internalHandlers.pinch = $c65dae8075b9a292$var$includeStartEndHandlers(handlers, "onPinch", _nativeHandlers);
        mergedConfig.pinch = $c65dae8075b9a292$var$getInternalDistanceAngleOptions(pinch);
    }
    if (actions.has("onHover")) {
        if (!actions.has("onMove")) classes.push($c65dae8075b9a292$var$MoveRecognizer);
        internalHandlers.hover = handlers.onHover;
        mergedConfig.hover = $c65dae8075b9a292$var$_extends({
            enabled: true
        }, hover);
        delete _nativeHandlers.onHover;
    }
    return $c65dae8075b9a292$var$useRecognizers(internalHandlers, classes, mergedConfig, _nativeHandlers);
}
/**
 * @private
 *
 * This utility function will integrate start and end handlers into the regular
 * handler function by using first and last conditions.
 *
 * @param {UserHandlersPartial} handlers - the handlers function object
 * @param {HandlerKey} handlerKey - the key for which to integrate start and end handlers
 * @returns
 */ function $c65dae8075b9a292$var$includeStartEndHandlers(handlers, handlerKey, _nativeHandlers) {
    var startKey = handlerKey + "Start";
    var endKey = handlerKey + "End";
    delete _nativeHandlers[handlerKey];
    delete _nativeHandlers[startKey];
    delete _nativeHandlers[endKey];
    var fn = function fn(state) {
        var memo = undefined;
        if (state.first && startKey in handlers) handlers[startKey](state);
        if (handlerKey in handlers) memo = handlers[handlerKey](state);
        if (state.last && endKey in handlers) handlers[endKey](state);
        return memo;
    };
    return fn;
}

});

parcelRegister("8XoZg", function(module, exports) {
module.exports = new URL("hatchtile.c497156f.png", import.meta.url).toString();

});



parcelRegister("bZfKS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ba19cd6e6f354f1$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $khJQv = parcelRequire("khJQv");
var $8ba19cd6e6f354f1$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ children: children })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "coincraft-page-layout__sidebar relative h-full max-w-xs border-l border-gray-300 flex dont-print overflow-visible",
        style: {
            boxShadow: "0px -2px 10px 0px rgb(0 0 0 / 24%)",
            background: "#fefefe",
            width: (0, $khJQv.default).showSidebar ? "auto" : "0px",
            paddingBottom: "6em"
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "coincraft-page-layout__sidebar-toggle flex-none w-8 bg-gray-500 cursor-pointer absolute top-[8em] right-full h-14 flex items-center justify-center rounded-l-[0.5em]",
                style: {
                    background: "rgb(255 222 102)",
                    boxShadow: "rgba(0, 0, 0, 0.24) -1px 0px 2px 0px inset",
                    zIndex: 10000
                },
                onClick: ()=>(0, $khJQv.default).toggleSidebar(),
                children: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                    style: {
                        margin: 0
                    },
                    className: `text-[#666] fa fa-chevron-${(0, $khJQv.default).showSidebar ? "right" : "left"}`
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "coincraft-page-layout__sidebar-content pb-28 flex-auto overflow-x-hidden w-[325px] overflow-y-auto",
                children: children
            })
        ]
    });
});

});

parcelRegister("7qobO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $567db9a0f4c98e10$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("02LyB");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $1BTI2 = parcelRequire("1BTI2");

var $567db9a0f4c98e10$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(()=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "flex items-center justify-center text-center w-full h-full",
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("section", {
            className: "flex items-center justify-center flex-col",
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsxs)("header", {
                    className: "flex flex-col justify-center items-center",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            className: "logo2 s75 size-[10em] flex items-center justify-center",
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)("img", {
                                src: new URL((parcelRequire("hw9H4"))),
                                alt: "Coincraft Logo"
                            })
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)("h3", {
                            children: "Permission Denied"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    className: "body space-y-[1em] text-[13px] text-[#666] leading-5",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            children: "You do not have permission to view this page."
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            style: {
                                marginTop: "1em"
                            },
                            children: "Please contact your system admin to correct this."
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            children: [
                                "Alternatively you can contact use via the chat or",
                                " ",
                                /*#__PURE__*/ (0, $61Ea1.jsx)("a", {
                                    href: "mailto:support@coincraft.co",
                                    style: {
                                        textDecoration: "underline"
                                    },
                                    children: "support@coincraft.co"
                                }),
                                "."
                            ]
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            style: {
                                marginTop: "1em"
                            },
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                    style: {
                                        display: "inline-block",
                                        marginRight: "1em"
                                    },
                                    children: /*#__PURE__*/ (0, $61Ea1.jsx)("a", {
                                        href: `/`,
                                        style: {
                                            textDecoration: "underline"
                                        },
                                        children: "Home"
                                    })
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                    style: {
                                        display: "inline-block"
                                    },
                                    children: /*#__PURE__*/ (0, $61Ea1.jsx)("a", {
                                        href: "/login",
                                        style: {
                                            textDecoration: "underline"
                                        },
                                        onClick: ()=>(0, $1BTI2.default).logout(),
                                        children: "Login"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
});

});


parcelRegister("iUmlO", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $dc3ecb5f9578aeee$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");

var $1vaPC = parcelRequire("1vaPC");

var $hKXA8 = parcelRequire("hKXA8");

var $kuPRw = parcelRequire("kuPRw");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $7qobO = parcelRequire("7qobO");

var $4iw5i = parcelRequire("4iw5i");

var $5PXcS = parcelRequire("5PXcS");

var $26sX2 = parcelRequire("26sX2");

var $kqntg = parcelRequire("kqntg");
const $dc3ecb5f9578aeee$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_private/track-expenses")({
    beforeLoad: ({ params: params })=>{
        if (!(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "trackExpenses", params)) throw new Error("Permission Denied");
        (0, $26sX2.setLayoutDefaults)({
            pageTitle: "Track Expenses",
            subMenu: "expenses"
        });
    },
    loaderDeps: ({ search: { date: date, staffId: staffId } })=>({
            date: date,
            staffId: staffId
        }),
    errorComponent: ({ error: error, reset: reset })=>{
        if (error.message === "Permission Denied") return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7qobO.default), {});
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    },
    component: $dc3ecb5f9578aeee$var$Wrapper,
    pendingComponent: (0, $4iw5i.default)
});
function $dc3ecb5f9578aeee$var$Wrapper() {
    if ((0, $8kZ1o.migratedToV2)()) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqntg.CenterPadPageBody), {
        className: "pt-0",
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hKXA8.default), {
            ...$dc3ecb5f9578aeee$export$e7b0ac011bb776c6.useParams(),
            ...$dc3ecb5f9578aeee$export$e7b0ac011bb776c6.useSearch()
        })
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $1vaPC.default), {
                ...$dc3ecb5f9578aeee$export$e7b0ac011bb776c6.useParams(),
                ...$dc3ecb5f9578aeee$export$e7b0ac011bb776c6.useSearch()
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kuPRw.default), {
                style: {
                    paddingTop: 0
                },
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hKXA8.default), {
                    ...$dc3ecb5f9578aeee$export$e7b0ac011bb776c6.useParams(),
                    ...$dc3ecb5f9578aeee$export$e7b0ac011bb776c6.useSearch()
                })
            })
        ]
    });
}

});
parcelRegister("1vaPC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $118116a06f093a8a$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $4hBm1 = parcelRequire("4hBm1");
parcelRequire("f44xu");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $ewAM3 = parcelRequire("ewAM3");

var $7GQic = parcelRequire("7GQic");

var $khJQv = parcelRequire("khJQv");

var $1BTI2 = parcelRequire("1BTI2");

var $36Jjh = parcelRequire("36Jjh");

var $8kZ1o = parcelRequire("8kZ1o");

var $73uXY = parcelRequire("73uXY");

var $76Har = parcelRequire("76Har");

var $6UBLf = parcelRequire("6UBLf");
parcelRequire("eat5C");
var $118116a06f093a8a$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ date: date, staffId: staffId })=>{
    const [store, setStore] = (0, $jbmdS.useState)((0, $73uXY.default));
    date = date ? (0, $4hBm1.parse)(date, "yyyy-MM-dd", new Date()) : new Date();
    const startDate = (0, $4hBm1.startOfWeek)(date, {
        weekStartsOn: 1
    });
    const endDate = (0, $4hBm1.endOfWeek)(date, {
        weekStartsOn: 1
    });
    const navigate = (0, $6UBLf.useNavigate)();
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $36Jjh.default), {
        heading: `Expenses: ${(0, $4hBm1.format)(date, "dd MMM yyyy")}`,
        extraContent: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
            children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "flex items-center mt-6",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                        className: "btn btn-default add-timesheet-entry-button plus-btn",
                        style: {
                            margin: "0 1em 0 0"
                        },
                        onClick: ()=>(0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $76Har.default), {
                                modalId: "addExpense",
                                dates: [
                                    store.date
                                ],
                                staff: store.staff,
                                store: store
                            })),
                        children: "+ Add Expense"
                    }),
                    (0, $8kZ1o.canEditStaffExpenses)((0, $1BTI2.default).user) ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.StaffSelector), {
                        className: "timesheet__staff-selector",
                        selectedStaffMember: store.staff,
                        allowNull: false,
                        onChange: (staff)=>{
                            navigate({
                                search: (prev)=>({
                                        ...prev,
                                        staffId: staff.id
                                    })
                            });
                        }
                    }) : null,
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7GQic.default), {
                        value: date,
                        onChange: (date)=>{
                            navigate({
                                search: (prev)=>({
                                        ...prev,
                                        date: (0, $4hBm1.format)(date, "yyyy-MM-dd")
                                    })
                            });
                        },
                        style: {
                            width: "10em",
                            marginLeft: "1em"
                        }
                    })
                ]
            })
        })
    });
});

});
parcelRegister("36Jjh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2435144003795f89$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $ceB8Z = parcelRequire("ceB8Z");
var $2435144003795f89$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ header: header, heading: heading, leftButtons: leftButtons, filter: filter, rightButtons: rightButtons, extraContent: extraContent, subHeading: subHeading, tabs: tabs = null, selectedTab: selectedTab })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "coincraft-page-layout__page-header relative w-full print:h-auto print:block text-white bg-444 pl-6 pr-8 pt-4 pb-4 min-h-32",
        style: {
            zIndex: 999
        },
        children: [
            header,
            heading ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "flex justify-between lg:flex-row flex-col",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                className: "flex items-center flex-1 basis-auto",
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                className: "heading text-4xl inline-block mr-2",
                                                children: heading
                                            }),
                                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                children: subHeading
                                            })
                                        ]
                                    }),
                                    leftButtons != null && leftButtons.length > 0 ? leftButtons : null
                                ]
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                className: "buttons flex items-center justify-end lg:justify-start flex-wrap",
                                children: [
                                    filter != null ? /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        className: "p-[0.5em] inline-block relative dont-print",
                                        children: filter
                                    }) : null,
                                    rightButtons
                                ]
                            })
                        ]
                    }),
                    extraContent
                ]
            }) : null,
            tabs && tabs.length > 0 && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ceB8Z.default), {
                tabs: tabs,
                selectedTab: selectedTab
            })
        ]
    });
});

});
parcelRegister("ceB8Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e839ad9453f035b$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $02LyB = parcelRequire("02LyB");
parcelRequire("7Fn0s");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $kqlQp = parcelRequire("kqlQp");
var $1Fr27 = parcelRequire("1Fr27");
var $8e839ad9453f035b$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ tabs: tabs, selectedTab: selectedTab, tabClick: tabClick, defaultTab: defaultTab })=>{
    const { latestLocation: latestLocation } = (0, $1Fr27.useRouter)();
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: `page-layout__tabs absolute bottom-0 right-11 flex items-center gap-[2px]`,
        children: tabs.map((t)=>{
            var _latestLocation$searc;
            return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqlQp.Link), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("tab text-[#444] text-xs py-2.5 px-6 cursor-pointer", t.id === (latestLocation === null || latestLocation === void 0 ? void 0 : (_latestLocation$searc = latestLocation.search) === null || _latestLocation$searc === void 0 ? void 0 : _latestLocation$searc.tab) || t.id === selectedTab ? "bg-[#fafafa]" : "bg-gold"),
                to: `${latestLocation.pathname}`,
                search: (prev)=>({
                        ...prev,
                        tab: t.id
                    }),
                children: t.label
            }, t.label);
        })
    });
});

});


parcelRegister("73uXY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5230d57d06ff5536$export$2e2bcd8739ae039; });

var $eat5C = parcelRequire("eat5C");

var $4JcCM = parcelRequire("4JcCM");

var $4hBm1 = parcelRequire("4hBm1");

var $1BTI2 = parcelRequire("1BTI2");

var $f44xu = parcelRequire("f44xu");

var $htkeB = parcelRequire("htkeB");

var $8kZ1o = parcelRequire("8kZ1o");

var $evRPQ = parcelRequire("evRPQ");

var $6Q5sp = parcelRequire("6Q5sp");
var $5230d57d06ff5536$var$_dec, $5230d57d06ff5536$var$_dec2, $5230d57d06ff5536$var$_dec3, $5230d57d06ff5536$var$_dec4, $5230d57d06ff5536$var$_dec5, $5230d57d06ff5536$var$_dec6, $5230d57d06ff5536$var$_class, $5230d57d06ff5536$var$_descriptor, $5230d57d06ff5536$var$_descriptor2;
function $5230d57d06ff5536$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $5230d57d06ff5536$var$_defineProperty(e, r, t) {
    return (r = $5230d57d06ff5536$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $5230d57d06ff5536$var$_toPropertyKey(t) {
    var i = $5230d57d06ff5536$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $5230d57d06ff5536$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $5230d57d06ff5536$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $5230d57d06ff5536$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $5230d57d06ff5536$var$TrackExpensesStore = ($5230d57d06ff5536$var$_dec = (0, $4JcCM.action).bound, $5230d57d06ff5536$var$_dec2 = (0, $4JcCM.action).bound, $5230d57d06ff5536$var$_dec3 = (0, $4JcCM.action).bound, $5230d57d06ff5536$var$_dec4 = (0, $4JcCM.action).bound, $5230d57d06ff5536$var$_dec5 = (0, $4JcCM.action).bound, $5230d57d06ff5536$var$_dec6 = (0, $4JcCM.action).bound, $5230d57d06ff5536$var$_class = class TrackExpensesStore {
    constructor(){
        $5230d57d06ff5536$var$_initializerDefineProperty(this, "extraExpenses", $5230d57d06ff5536$var$_descriptor, this);
        $5230d57d06ff5536$var$_initializerDefineProperty(this, "searchParams", $5230d57d06ff5536$var$_descriptor2, this);
        (0, $4JcCM.makeObservable)(this);
    }
    reset() {
        this.extraExpenses = [];
    }
    setSearchParams(params) {
        this.searchParams = params;
    }
    get staffId() {
        var _this$searchParams;
        return (0, $8kZ1o.canEditStaffTime)((0, $1BTI2.default).user) ? ((_this$searchParams = this.searchParams) === null || _this$searchParams === void 0 ? void 0 : _this$searchParams.staffId) || (0, $1BTI2.default).userId : (0, $1BTI2.default).userId;
    }
    get date() {
        var _this$searchParams2, _this$searchParams3;
        return (_this$searchParams2 = this.searchParams) !== null && _this$searchParams2 !== void 0 && _this$searchParams2.date ? (0, $4hBm1.parse)((_this$searchParams3 = this.searchParams) === null || _this$searchParams3 === void 0 ? void 0 : _this$searchParams3.date, "yyyy-MM-dd", new Date()) : (0, $4hBm1.startOfDay)(new Date());
    }
    addExtraExpenses(expenses) {
        this.extraExpenses.push(...expenses);
    }
    get expenses() {
        return [
            ...new Set([
                ...(0, $evRPQ.default).projectExpenseItems.filter((t)=>t.staffId === this.staffId && (0, $4hBm1.isSameDay)(t.date, this.date) && !t.deletedAt),
                ...this.extraExpenses.filter((t)=>t.staffId === this.staffId && (0, $4hBm1.isSameDay)(t.date, this.date) && !t.deletedAt)
            ])
        ];
    }
    get costCentres() {
        return [
            ...new Set(this.expenses.map((t)=>t.project.costCentre))
        ];
    }
    get projectsByCostCentreId() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).groupBy([
            ...new Set(this.expenses.map((t)=>t.project))
        ], (pr)=>pr === null || pr === void 0 ? void 0 : pr.costCentreId);
    }
    get phasesByProjectId() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).mapValues((0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).groupBy(this.expenses, (ph)=>ph === null || ph === void 0 ? void 0 : ph.projectId), (tes)=>[
                ...new Set(tes.map((te)=>te.phase))
            ]);
    }
    get rowsByPhaseId() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).groupBy(this.expenses.filter((exp)=>{
            return exp.cost || exp.description !== "" && exp.description !== null || new Date() - (exp.createdAt || exp.updatedAt) < 43200000 || !this.expenses.find((e)=>e.id !== exp.id && e.date.getTime() === exp.date.getTime() && e.expenseId === exp.expenseId && (e.cost || e.description !== "" && e.description !== null)) && this.expenses.find((e)=>e.date.getTime() === exp.date.getTime() && e.expenseId === exp.expenseId).id === exp.id;
        }), (te)=>(0, $f44xu.default)(te.projectId, te.phaseId));
    }
    get staff() {
        return (0, $htkeB.default).staffsById[this.staffId] || (0, $1BTI2.default).user;
    }
    get startOfWeek() {
        return (0, $4hBm1.startOfWeek)(this.date, {
            weekStartsOn: 1
        });
    }
    get daysOfWeek() {
        return [
            ...Array(7)
        ].map((v, i)=>(0, $4hBm1.addDays)(this.startOfWeek, i));
    }
    get dailyTotals() {
        const totals = this.daysOfWeek.map((day)=>(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(((0, $evRPQ.default).expenseItemsByStaffIdDate[(0, $f44xu.default)(this.staffId, day.getTime())] || []).map((te)=>te.cost)));
        return totals;
    }
    get currentDayTotal() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(((0, $evRPQ.default).expenseItemsByStaffIdDate[(0, $f44xu.default)(this.staffId, this.date.getTime())] || []).map((te)=>te.cost));
    }
    shiftPrevWeek() {
        (0, $6Q5sp.router).navigate({
            search: (prev)=>({
                    ...prev,
                    date: (0, $4hBm1.format)((0, $4hBm1.subWeeks)(this.date, 1), "yyyy-MM-dd")
                })
        });
    }
    shiftNextWeek() {
        (0, $6Q5sp.router).navigate({
            search: (prev)=>({
                    ...prev,
                    date: (0, $4hBm1.format)((0, $4hBm1.addWeeks)(this.date, 1), "yyyy-MM-dd")
                })
        });
    }
    shiftThisWeek() {
        (0, $6Q5sp.router).navigate({
            search: (prev)=>(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).omitBy({
                    ...prev,
                    date: null
                }, (v)=>v === null)
        });
    }
}, $5230d57d06ff5536$var$_descriptor = $5230d57d06ff5536$var$_applyDecoratedDescriptor($5230d57d06ff5536$var$_class.prototype, "extraExpenses", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $5230d57d06ff5536$var$_descriptor2 = $5230d57d06ff5536$var$_applyDecoratedDescriptor($5230d57d06ff5536$var$_class.prototype, "searchParams", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $5230d57d06ff5536$var$_applyDecoratedDescriptor($5230d57d06ff5536$var$_class.prototype, "reset", [
    $5230d57d06ff5536$var$_dec
], Object.getOwnPropertyDescriptor($5230d57d06ff5536$var$_class.prototype, "reset"), $5230d57d06ff5536$var$_class.prototype), $5230d57d06ff5536$var$_applyDecoratedDescriptor($5230d57d06ff5536$var$_class.prototype, "setSearchParams", [
    $5230d57d06ff5536$var$_dec2
], Object.getOwnPropertyDescriptor($5230d57d06ff5536$var$_class.prototype, "setSearchParams"), $5230d57d06ff5536$var$_class.prototype), $5230d57d06ff5536$var$_applyDecoratedDescriptor($5230d57d06ff5536$var$_class.prototype, "staffId", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($5230d57d06ff5536$var$_class.prototype, "staffId"), $5230d57d06ff5536$var$_class.prototype), $5230d57d06ff5536$var$_applyDecoratedDescriptor($5230d57d06ff5536$var$_class.prototype, "date", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($5230d57d06ff5536$var$_class.prototype, "date"), $5230d57d06ff5536$var$_class.prototype), $5230d57d06ff5536$var$_applyDecoratedDescriptor($5230d57d06ff5536$var$_class.prototype, "addExtraExpenses", [
    $5230d57d06ff5536$var$_dec3
], Object.getOwnPropertyDescriptor($5230d57d06ff5536$var$_class.prototype, "addExtraExpenses"), $5230d57d06ff5536$var$_class.prototype), $5230d57d06ff5536$var$_applyDecoratedDescriptor($5230d57d06ff5536$var$_class.prototype, "expenses", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($5230d57d06ff5536$var$_class.prototype, "expenses"), $5230d57d06ff5536$var$_class.prototype), $5230d57d06ff5536$var$_applyDecoratedDescriptor($5230d57d06ff5536$var$_class.prototype, "costCentres", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($5230d57d06ff5536$var$_class.prototype, "costCentres"), $5230d57d06ff5536$var$_class.prototype), $5230d57d06ff5536$var$_applyDecoratedDescriptor($5230d57d06ff5536$var$_class.prototype, "projectsByCostCentreId", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($5230d57d06ff5536$var$_class.prototype, "projectsByCostCentreId"), $5230d57d06ff5536$var$_class.prototype), $5230d57d06ff5536$var$_applyDecoratedDescriptor($5230d57d06ff5536$var$_class.prototype, "phasesByProjectId", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($5230d57d06ff5536$var$_class.prototype, "phasesByProjectId"), $5230d57d06ff5536$var$_class.prototype), $5230d57d06ff5536$var$_applyDecoratedDescriptor($5230d57d06ff5536$var$_class.prototype, "rowsByPhaseId", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($5230d57d06ff5536$var$_class.prototype, "rowsByPhaseId"), $5230d57d06ff5536$var$_class.prototype), $5230d57d06ff5536$var$_applyDecoratedDescriptor($5230d57d06ff5536$var$_class.prototype, "staff", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($5230d57d06ff5536$var$_class.prototype, "staff"), $5230d57d06ff5536$var$_class.prototype), $5230d57d06ff5536$var$_applyDecoratedDescriptor($5230d57d06ff5536$var$_class.prototype, "startOfWeek", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($5230d57d06ff5536$var$_class.prototype, "startOfWeek"), $5230d57d06ff5536$var$_class.prototype), $5230d57d06ff5536$var$_applyDecoratedDescriptor($5230d57d06ff5536$var$_class.prototype, "daysOfWeek", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($5230d57d06ff5536$var$_class.prototype, "daysOfWeek"), $5230d57d06ff5536$var$_class.prototype), $5230d57d06ff5536$var$_applyDecoratedDescriptor($5230d57d06ff5536$var$_class.prototype, "dailyTotals", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($5230d57d06ff5536$var$_class.prototype, "dailyTotals"), $5230d57d06ff5536$var$_class.prototype), $5230d57d06ff5536$var$_applyDecoratedDescriptor($5230d57d06ff5536$var$_class.prototype, "currentDayTotal", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($5230d57d06ff5536$var$_class.prototype, "currentDayTotal"), $5230d57d06ff5536$var$_class.prototype), $5230d57d06ff5536$var$_applyDecoratedDescriptor($5230d57d06ff5536$var$_class.prototype, "shiftPrevWeek", [
    $5230d57d06ff5536$var$_dec4
], Object.getOwnPropertyDescriptor($5230d57d06ff5536$var$_class.prototype, "shiftPrevWeek"), $5230d57d06ff5536$var$_class.prototype), $5230d57d06ff5536$var$_applyDecoratedDescriptor($5230d57d06ff5536$var$_class.prototype, "shiftNextWeek", [
    $5230d57d06ff5536$var$_dec5
], Object.getOwnPropertyDescriptor($5230d57d06ff5536$var$_class.prototype, "shiftNextWeek"), $5230d57d06ff5536$var$_class.prototype), $5230d57d06ff5536$var$_applyDecoratedDescriptor($5230d57d06ff5536$var$_class.prototype, "shiftThisWeek", [
    $5230d57d06ff5536$var$_dec6
], Object.getOwnPropertyDescriptor($5230d57d06ff5536$var$_class.prototype, "shiftThisWeek"), $5230d57d06ff5536$var$_class.prototype), $5230d57d06ff5536$var$_class);
var $5230d57d06ff5536$export$2e2bcd8739ae039 = new $5230d57d06ff5536$var$TrackExpensesStore();

});

parcelRegister("76Har", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52ca941ba956d064$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $1EEMt = parcelRequire("1EEMt");

var $fEcKX = parcelRequire("fEcKX");

var $ewAM3 = parcelRequire("ewAM3");

var $6RcUP = parcelRequire("6RcUP");

var $1BTI2 = parcelRequire("1BTI2");

var $8kZ1o = parcelRequire("8kZ1o");

var $gJT7h = parcelRequire("gJT7h");

var $6Q5sp = parcelRequire("6Q5sp");

var $evRPQ = parcelRequire("evRPQ");

var $47i9t = parcelRequire("47i9t");

var $3h7sC = parcelRequire("3h7sC");
var $52ca941ba956d064$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ modalId: modalId, expenses: expenses, dates: dates, staff: staff, store: store, heading: heading, onSave: onSave, placeholders: placeholders, selectDefaults: selectDefaults = true, defaults: defaults })=>{
    var _expenses$, _expenses$2, _expenses$3, _project$phases, _project$phases2, _project$phases3, _phase$expenses;
    const [project, setProject] = (0, $jbmdS.useState)(defaults ? defaults.project : expenses === null || expenses === void 0 ? void 0 : (_expenses$ = expenses[0]) === null || _expenses$ === void 0 ? void 0 : _expenses$.project);
    const [phase, setPhase] = (0, $jbmdS.useState)(defaults ? defaults.phase : expenses === null || expenses === void 0 ? void 0 : (_expenses$2 = expenses[0]) === null || _expenses$2 === void 0 ? void 0 : _expenses$2.phase);
    const [expense, setExpense] = (0, $jbmdS.useState)(defaults ? defaults.expense : expenses === null || expenses === void 0 ? void 0 : (_expenses$3 = expenses[0]) === null || _expenses$3 === void 0 ? void 0 : _expenses$3.expense);
    const getSelectedData = ()=>{
        return Object.fromEntries([
            project ? [
                "costCentreId",
                project.costCentreId
            ] : null,
            project ? [
                "projectId",
                project.id
            ] : null,
            phase ? [
                "phaseId",
                phase.id
            ] : null,
            expense ? [
                "expenseId",
                expense.id
            ] : null
        ].filter((v)=>v));
    };
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fEcKX.default), {
        modalId: modalId,
        width: "45em",
        heading: heading || (expenses ? "Edit Expenses" : "New Expense"),
        onSave: ()=>{
            if (onSave) return onSave(getSelectedData());
            if (expenses) expenses.forEach((exp)=>{
                exp.update(getSelectedData());
            });
            else {
                const expenses = dates.map((d)=>(0, $evRPQ.default).add({
                        date: d,
                        staffId: staff.id,
                        cost: 0,
                        ...getSelectedData()
                    }, {
                        trackUpdates: true
                    }));
                store.addExtraExpenses(expenses);
            }
        },
        saveLabel: expenses ? "Edit Expenses" : "Add Expense",
        canSave: ()=>project && ((0, $8kZ1o.canLogTimeAgainstNoPhase)() || phase) && ((0, $8kZ1o.canTrackExpenseAgainstGeneral)() || expense),
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            style: {
                padding: "1em",
                display: "grid",
                gridTemplateColumns: "1fr 4fr",
                gridGap: "0.5em"
            },
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    children: "Project: "
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.ProjectSelector), {
                        selectedProject: project,
                        placeholderLabel: placeholders === null || placeholders === void 0 ? void 0 : placeholders.project,
                        projectOptions: (0, $gJT7h.default).projects.filter((p)=>(0, $8kZ1o.canTrackExpenseAgainstProject)((0, $1BTI2.default).user, p)),
                        onChange: (pr)=>{
                            (0, $6Q5sp.queryClient).invalidateQueries([
                                `phases-${pr.id}`
                            ]);
                            setProject(pr);
                            setPhase(null);
                            setExpense(null);
                        },
                        variant: "secondary",
                        className: "max-w-max"
                    })
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    children: "Phase: "
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6RcUP.default), {
                        queryIds: [
                            project ? {
                                id: `phases-${project.id}`,
                                queryFn: async ()=>{
                                    const requestData = await (0, $3h7sC.trpc).legacy.getProjectPhases.query({
                                        projectId: project.id
                                    });
                                    return (0, $47i9t.processTRPCData)(requestData, `phases-${project.id}`);
                                }
                            } : null,
                            project ? {
                                id: `projectExpenses-${project.id}`,
                                queryFn: async ()=>{
                                    const requestData = await (0, $3h7sC.trpc).legacy.getProjectExpenses.query({
                                        projectId: project.id
                                    });
                                    return (0, $47i9t.processTRPCData)(requestData, `projectExpenses-${project.id}`);
                                }
                            } : null
                        ].filter((v)=>v),
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.PhaseSelector), {
                            placeholderLabel: placeholders === null || placeholders === void 0 ? void 0 : placeholders.phase,
                            selectedPhase: phase,
                            onChange: (ph)=>{
                                setPhase(ph);
                            },
                            phaseOptions: (project === null || project === void 0 ? void 0 : (_project$phases2 = project.phases) === null || _project$phases2 === void 0 ? void 0 : _project$phases2.filter((ph)=>(0, $8kZ1o.canTrackExpenseAgainstPhase)((0, $1BTI2.default).user, ph))) || [],
                            variant: "secondary",
                            className: "max-w-max"
                        }, `phase-selector-${project !== null && project !== void 0 && (_project$phases = project.phases) !== null && _project$phases !== void 0 && _project$phases.length ? project === null || project === void 0 ? void 0 : project.id : "null"}`)
                    })
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    children: "Expense: "
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6RcUP.default), {
                        queryIds: [
                            project ? {
                                id: `projectExpenses-${project.id}`,
                                queryFn: async ()=>{
                                    const requestData = await (0, $3h7sC.trpc).legacy.getProjectExpenses.query({
                                        projectId: project.id
                                    });
                                    return (0, $47i9t.processTRPCData)(requestData, `projectExpenses-${project.id}`);
                                }
                            } : null
                        ].filter((v)=>v),
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.ProjectExpenseSelector), {
                            selectedProjectExpense: expense,
                            placeholderLabel: (placeholders === null || placeholders === void 0 ? void 0 : placeholders.expense) || `(General Expense)`,
                            onChange: (expense)=>{
                                setExpense(expense);
                            },
                            projectExpenseOptions: (phase === null || phase === void 0 ? void 0 : phase.expenses) || (project === null || project === void 0 ? void 0 : project.expenses) || [],
                            nullable: true,
                            variant: "secondary",
                            className: "max-w-max"
                        }, `expense-selector-${project !== null && project !== void 0 && (_project$phases3 = project.phases) !== null && _project$phases3 !== void 0 && _project$phases3.length ? project === null || project === void 0 ? void 0 : project.id : "null"}-${phase !== null && phase !== void 0 && (_phase$expenses = phase.expenses) !== null && _phase$expenses !== void 0 && _phase$expenses.length ? phase === null || phase === void 0 ? void 0 : phase.id : "null"}`)
                    })
                })
            ]
        })
    });
});

});


parcelRegister("hKXA8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ced4f3442a796334$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $02LyB = parcelRequire("02LyB");

var $4hBm1 = parcelRequire("4hBm1");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $1BTI2 = parcelRequire("1BTI2");

var $e8Hda = parcelRequire("e8Hda");
parcelRequire("eat5C");

var $khJQv = parcelRequire("khJQv");

var $76Har = parcelRequire("76Har");

var $fM2j4 = parcelRequire("fM2j4");

var $aISc8 = parcelRequire("aISc8");

var $6RcUP = parcelRequire("6RcUP");

var $4iw5i = parcelRequire("4iw5i");
parcelRequire("jE5CX");

var $8kZ1o = parcelRequire("8kZ1o");

var $f44xu = parcelRequire("f44xu");

var $73uXY = parcelRequire("73uXY");

var $ek5Pm = parcelRequire("ek5Pm");

var $12o9H = parcelRequire("12o9H");

var $6UBLf = parcelRequire("6UBLf");

var $3h7sC = parcelRequire("3h7sC");

var $47i9t = parcelRequire("47i9t");
var $ced4f3442a796334$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ date: date, staffId: staffId })=>{
    var _date;
    (_date = date) !== null && _date !== void 0 ? _date : date = (0, $4hBm1.format)(new Date(), "yyyy-MM-dd");
    const [store, setStore] = (0, $jbmdS.useState)((0, $73uXY.default));
    (0, $jbmdS.useEffect)(()=>{
        store.setSearchParams({
            date: date,
            staffId: staffId
        });
    }, [
        date,
        staffId
    ]);
    (0, $jbmdS.useEffect)(()=>{
        (0, $fM2j4.default).setAutosave(true);
        return ()=>(0, $fM2j4.default).setAutosave(false);
    }, []);
    const startDate = (0, $4hBm1.startOfWeek)(store.date);
    const endDate = (0, $4hBm1.endOfWeek)(store.date);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "max-w-[1040px] mx-auto mb-auto w-[1040px]",
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)($ced4f3442a796334$var$DailyNav, {
                monday: store.startOfWeek,
                dayTotals: store.dailyTotals,
                selectedDate: store.date,
                store: store
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6RcUP.default), {
                queryIds: [
                    {
                        queryKey: [
                            "getExpenseTrackingData",
                            store.searchParams
                        ],
                        queryFn: async ()=>{
                            const res = await (0, $3h7sC.trpc).legacy.getExpenseTrackingData.query({
                                staffId: staffId,
                                startDate: (0, $4hBm1.format)(startDate, "yyyy-MM-dd"),
                                endDate: (0, $4hBm1.format)(endDate, "yyyy-MM-dd")
                            });
                            return (0, $47i9t.processTRPCData)(res);
                        }
                    }
                ],
                loading: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    style: {
                        padding: "8em"
                    },
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $4iw5i.default), {})
                }),
                children: /*#__PURE__*/ (0, $61Ea1.jsx)($ced4f3442a796334$var$ExpenseRows, {
                    store: store
                })
            })
        ]
    });
});
const $ced4f3442a796334$var$ExpenseRows = (0, $1EEMt.observer)(({ store: store })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "mt-8",
        children: [
            store.costCentres.sort((a, b)=>{
                var _a$name, _a$name$localeCompare;
                return (_a$name = a.name) === null || _a$name === void 0 ? void 0 : (_a$name$localeCompare = _a$name.localeCompare) === null || _a$name$localeCompare === void 0 ? void 0 : _a$name$localeCompare.call(_a$name, b.name);
            }).map((cc)=>{
                return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)($ced4f3442a796334$var$ExpenseCostCentre, {
                            costCentre: cc
                        }),
                        (store.projectsByCostCentreId[cc.id] || []).sort((a, b)=>{
                            const aName = a.title || "";
                            const bName = b.title || "";
                            return aName.localeCompare(bName);
                        }).map((pr)=>{
                            return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)($ced4f3442a796334$var$ExpenseProject, {
                                        project: pr
                                    }),
                                    (store.phasesByProjectId[pr.id] || []).sort((a, b)=>{
                                        const aName = a.title || "";
                                        const bName = b.title || "";
                                        return aName.localeCompare(bName);
                                    }).map((ph)=>{
                                        return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                            className: "phase-block timesheet-widget__row",
                                            children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                                className: "timesheet-widget__phase-block timesheet-widget__row__inner",
                                                children: [
                                                    /*#__PURE__*/ (0, $61Ea1.jsx)($ced4f3442a796334$var$ExpensePhase, {
                                                        project: pr,
                                                        phase: ph,
                                                        store: store
                                                    }),
                                                    (store.rowsByPhaseId[(0, $f44xu.default)(pr.id, ph === null || ph === void 0 ? void 0 : ph.id)] || []).sort((a, b)=>{
                                                        var _a$task, _b$task;
                                                        const aName = ((_a$task = a.task) === null || _a$task === void 0 ? void 0 : _a$task.name) || "";
                                                        const bName = ((_b$task = b.task) === null || _b$task === void 0 ? void 0 : _b$task.name) || "";
                                                        return aName.localeCompare(bName);
                                                    }).map((row)=>{
                                                        return /*#__PURE__*/ (0, $61Ea1.jsx)($ced4f3442a796334$var$ProjectExpenseRow, {
                                                            store: store,
                                                            row: row
                                                        });
                                                    })
                                                ]
                                            })
                                        });
                                    })
                                ]
                            });
                        })
                    ]
                });
            }),
            !store.costCentres.length && /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            className: "text-[#666666] text-3xl pb-5",
                            children: "No Expenses"
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            className: "text-[#666666] leading-[2em]",
                            children: [
                                "There are no expenses for this day.",
                                /*#__PURE__*/ (0, $61Ea1.jsx)("br", {}),
                                "Please add an entry by clicking the button below."
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                className: "btn btn-lg btn-default add-timesheet-entry-button plus-btn border-[#ccc]",
                onClick: ()=>(0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $76Har.default), {
                        modalId: "addExpense",
                        dates: [
                            store.date
                        ],
                        staff: store.staff,
                        store: store
                    })),
                children: "+ Add Expense"
            })
        ]
    });
});
const $ced4f3442a796334$var$ExpenseCostCentre = (0, $1EEMt.observer)(({ costCentre: costCentre })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        style: {
            fontSize: "1.7em",
            padding: "0.5em 0 0.5em 0",
            textAlign: "left",
            borderBottom: "solid 1px #aaa",
            marginBottom: "0.8em"
        },
        children: costCentre.name
    });
});
const $ced4f3442a796334$var$ExpenseProject = (0, $1EEMt.observer)(({ project: project })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "project-title",
        style: {
            fontSize: "1.4em",
            margin: "1.2em 0 0.2em 0.6em",
            fontWeight: 600,
            width: "50%"
        },
        children: project.title
    });
});
const $ced4f3442a796334$var$ExpensePhase = (0, $1EEMt.observer)(({ project: project, phase: phase, store: store })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "timesheet-widget__phase-row",
        style: {
            display: "flex",
            flexDirection: "column"
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "timesheet-widget__phase-title",
                style: {
                    width: "100%"
                },
                children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    className: "inline-flexbox-container",
                    style: {
                        width: "100%",
                        paddingBottom: "0.1em",
                        alignItems: "flex-end"
                    },
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "phase-block__title flex-1-1-auto",
                        style: {
                            minWidth: 0,
                            flex: "0 0 auto",
                            width: "24%"
                        },
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            className: "text-base",
                            children: (phase === null || phase === void 0 ? void 0 : phase.title) || "No Phase"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "timesheet-widget__progress-bar timesheet-widget__middle-section",
                style: {
                    verticalAlign: "bottom"
                }
            })
        ]
    });
});
const $ced4f3442a796334$var$ProjectExpenseRow = (0, $1EEMt.observer)(({ store: store, row: row, mode: mode })=>{
    const isHighlighted = false;
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("timesheet-widget__task-row", {
            "timesheet-widget__task-row--highlighted": isHighlighted
        }),
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "timesheet-widget__task-title timesheet-widget__left-section",
                children: [
                    (0, $8kZ1o.canEditStaffExpenses)((0, $1BTI2.default).user) && !row.isLocked ? /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                        className: "timesheet-widget__task-lock lock-button",
                        onClick: ()=>{
                            row.update({
                                isLocked: true
                            });
                        },
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                            className: "fa fa-lock fa-fw"
                        })
                    }) : (0, $8kZ1o.canEditStaffExpenses)((0, $1BTI2.default).user) ? /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                        className: "timesheet-widget__task-lock lock-button",
                        onClick: ()=>{
                            row.update({
                                isLocked: false
                            });
                        },
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                            className: "fa fa-unlock fa-fw"
                        })
                    }) : null,
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "text-[0.85em]",
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                            style: {
                                marginLeft: "0.5em"
                            },
                            children: (row === null || row === void 0 ? void 0 : row.expense) != null ? row.expense.name : "(General Expense)"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "timesheet-widget__task-entries timesheet-widget__middle-section",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)($ced4f3442a796334$var$DailyExpense, {
                    expense: row,
                    store: store
                })
            })
        ]
    });
});
const $ced4f3442a796334$var$DailyExpense = (0, $1EEMt.observer)(({ expense: expense, store: store })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "time-entry time-entry--daily",
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ek5Pm.default).currency, {
                style: {
                    width: "8em",
                    fontSize: "0.8em"
                },
                value: expense.cost,
                onChange: (cost)=>{
                    expense.update({
                        cost: cost
                    });
                    expense.attach();
                },
                className: "time-entry__input",
                isEditable: !expense.isLocked
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "time-entry--daily__note",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $aISc8.default), {
                    value: expense.description || "",
                    onChange: (e)=>{
                        expense.update({
                            description: e.target.value
                        });
                        expense.attach();
                    },
                    className: "time-entry__note-input",
                    placeholder: "(No Description)",
                    disabled: expense.isLocked
                })
            })
        ]
    });
});
const $ced4f3442a796334$var$DailyNav = (0, $1EEMt.observer)(({ mode: mode, monday: monday, dayTotals: dayTotals, selectedDate: selectedDate, store: store })=>{
    const navigate = (0, $6UBLf.useNavigate)();
    const formatTotal = (n, type)=>{
        return (0, $e8Hda.isNumber)(n) ? (0, $12o9H.FormatCurrency)(n) : n === "loading" ? /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
            className: "fa fa-spinner fa-spin",
            style: {
                margin: 0
            }
        }) : /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
            className: "fa fa-exclamation-triangle error-highlight-color",
            style: {
                margin: 0
            },
            title: `Some entries for this ${type} have errors.`
        });
    };
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "max-w-[1040px] bg-[#fafafa] z-[1000] pt-8 w-[1040px] sticky top-0",
        children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            className: "border-b border-[#aaa]",
            children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    className: "timesheet-widget__row min-w-[36em] mb-2.5 text-center",
                    style: {
                        fontSize: "1em"
                    },
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "timesheet-widget__row__inner min-[1310px]:w-[92%] w-full mx-auto",
                        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            className: "flex items-start",
                            // to align buttons
                            style: {
                            },
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                    className: "timesheet-widget__left-section min-[1381px]:w-[30%] w-1/4",
                                    children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                        className: "timesheets__navigation flex items-center",
                                        style: {
                                            flex: "0 0 auto"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                className: "flex w-full text-center",
                                                style: {
                                                    textAlign: "center"
                                                },
                                                children: /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                                                    onClick: store.shiftThisWeek,
                                                    className: "btn btn-default w-full py-1.5 px-3 text-sm text-[#333] bg-white border border-[#ccc] text-center whitespace-nowrap rounded hover:bg-[#e0e0e0]",
                                                    children: "Today"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                className: "",
                                                style: {
                                                    flex: "0 0 auto"
                                                },
                                                children: /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                                                    onClick: store.shiftPrevWeek,
                                                    className: "btn btn-default previous-week-button ml-3 py-1.5 px-3 text-[#333] bg-white border border-[#ccc] text-sm rounded",
                                                    style: {
                                                    },
                                                    title: "Previous week",
                                                    children: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                                        className: "fa fa-chevron-left m-0"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                    className: "timesheet-widget__middle-section min-[1381px]:w-[65%] w-3/4",
                                    children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        className: "timesheets__day-nav flex justify-around w-full",
                                        children: dayTotals.map(function(dayTotal, dayIndex) {
                                            var _d1$getTime, _selectedDate$getTime;
                                            let d1 = (0, $4hBm1.addDays)(monday, dayIndex);
                                            let inner = /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                                className: "timesheet__nav__day__date",
                                                children: [
                                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                        className: "text-[10px] leading-[14px]",
                                                        children: (0, $4hBm1.format)(d1, "EEE")
                                                    }),
                                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                        className: "text-xl",
                                                        children: (0, $4hBm1.format)(d1, "dd")
                                                    })
                                                ]
                                            });
                                            return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                                className: "flex-0-0-auto timesheet__nav__day text-center",
                                                "data-date": (0, $4hBm1.format)(d1, "yyyy-MM-dd"),
                                                style: {
                                                    fontSize: "1.1em",
                                                    textAlign: "center"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("btn btn-default timesheets__day-nav-button border hover:m-0 hover:border-2 hover:border-gold text-sm text-[#333] bg-white rounded py-1.5 px-3 whitespace-nowrap", (d1 === null || d1 === void 0 ? void 0 : (_d1$getTime = d1.getTime) === null || _d1$getTime === void 0 ? void 0 : _d1$getTime.call(d1)) === (selectedDate === null || selectedDate === void 0 ? void 0 : (_selectedDate$getTime = selectedDate.getTime) === null || _selectedDate$getTime === void 0 ? void 0 : _selectedDate$getTime.call(selectedDate)) ? "border-2 border-gold m-0" : "border-[#ccc] m-px"),
                                                        style: {
                                                            fontSize: "1.1em",
                                                            textAlign: "center"
                                                        },
                                                        onClick: ()=>{
                                                            navigate({
                                                                search: (prev)=>({
                                                                        ...prev,
                                                                        date: (0, $4hBm1.format)(d1, "yyyy-MM-dd")
                                                                    })
                                                            });
                                                        },
                                                        children: inner
                                                    }),
                                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                        className: "timesheet-widget__hours-cell timesheet__nav__total text-xs text-[#666666] font-semibold mt-[2px]",
                                                        children: formatTotal(dayTotal, "day")
                                                    })
                                                ]
                                            }, dayIndex);
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                    className: "timesheet-widget__right-section",
                                    style: {
                                        flex: "0 0 auto"
                                    },
                                    children: /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                                        onClick: store.shiftNextWeek,
                                        className: "btn btn-default next-week-button py-1.5 px-3 text-[#333] bg-white border border-[#ccc] text-sm rounded",
                                        title: "Next week",
                                        children: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                            className: "fa fa-chevron-right m-0"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
});

});
parcelRegister("aISc8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ce80d662ade8068$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");

var $2MXkj = parcelRequire("2MXkj");

var $5xtSr = parcelRequire("5xtSr");
var $7ce80d662ade8068$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $7ce80d662ade8068$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $7ce80d662ade8068$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $7ce80d662ade8068$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $7ce80d662ade8068$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7ce80d662ade8068$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $7ce80d662ade8068$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $7ce80d662ade8068$var$noop = function noop() {};
var $7ce80d662ade8068$var$TextareaAutosize = function(_React$Component) {
    $7ce80d662ade8068$var$_inherits(TextareaAutosize, _React$Component);
    function TextareaAutosize(props) {
        $7ce80d662ade8068$var$_classCallCheck(this, TextareaAutosize);
        var _this = $7ce80d662ade8068$var$_possibleConstructorReturn(this, _React$Component.call(this, props));
        _this._onRootDOMNode = function(node) {
            _this._rootDOMNode = node;
            if (_this.props.inputRef) _this.props.inputRef(node);
        };
        _this._onChange = function(event) {
            if (!_this._controlled) _this._resizeComponent();
            var _this$props = _this.props, valueLink = _this$props.valueLink, onChange = _this$props.onChange;
            if (valueLink) valueLink.requestChange(event.target.value);
            else onChange(event);
        };
        _this._resizeComponent = function() {
            if (!_this._rootDOMNode) return;
            var _calculateNodeHeight = (0, $5xtSr.default)(_this._rootDOMNode, _this.props.useCacheForDOMMeasurements, _this.props.rows || _this.props.minRows, _this.props.maxRows), height = _calculateNodeHeight.height, minHeight = _calculateNodeHeight.minHeight, maxHeight = _calculateNodeHeight.maxHeight;
            if (_this.state.height !== height || _this.state.minHeight !== minHeight || _this.state.maxHeight !== maxHeight) _this.setState({
                height: height,
                minHeight: minHeight,
                maxHeight: maxHeight
            });
        };
        _this.state = {
            height: props.style && props.style.height || 0,
            minHeight: -Infinity,
            maxHeight: Infinity
        };
        _this._controlled = typeof props.value === "string";
        return _this;
    }
    TextareaAutosize.prototype.render = function render() {
        var _props = this.props, valueLink = _props.valueLink, _minRows = _props.minRows, _maxRows = _props.maxRows, _onHeightChange = _props.onHeightChange, _useCacheForDOMMeasurements = _props.useCacheForDOMMeasurements, _inputRef = _props.inputRef, props = $7ce80d662ade8068$var$_objectWithoutProperties(_props, [
            "valueLink",
            "minRows",
            "maxRows",
            "onHeightChange",
            "useCacheForDOMMeasurements",
            "inputRef"
        ]);
        if ((typeof valueLink === "undefined" ? "undefined" : $7ce80d662ade8068$var$_typeof(valueLink)) === "object") props.value = valueLink.value;
        props.style = $7ce80d662ade8068$var$_extends({}, props.style, {
            height: this.state.height
        });
        var maxHeight = Math.max(props.style.maxHeight || Infinity, this.state.maxHeight);
        if (maxHeight < this.state.height) props.style.overflow = "hidden";
        return (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("textarea", $7ce80d662ade8068$var$_extends({}, props, {
            onChange: this._onChange,
            ref: this._onRootDOMNode
        }));
    };
    TextareaAutosize.prototype.componentDidMount = function componentDidMount() {
        this._resizeComponent();
        window.addEventListener("resize", this._resizeComponent);
    };
    TextareaAutosize.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
        // Re-render with the new content then recalculate the height as required.
        this._clearNextFrame();
        this._onNextFrameActionId = $7ce80d662ade8068$var$onNextFrame(this._resizeComponent);
    };
    TextareaAutosize.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        // Invoke callback when old height does not equal to new one.
        if (this.state.height !== prevState.height) this.props.onHeightChange(this.state.height);
    };
    TextareaAutosize.prototype.componentWillUnmount = function componentWillUnmount() {
        // Remove any scheduled events to prevent manipulating the node after it's
        // been unmounted.
        this._clearNextFrame();
        window.removeEventListener("resize", this._resizeComponent);
    };
    TextareaAutosize.prototype._clearNextFrame = function _clearNextFrame() {
        if (this._onNextFrameActionId) $7ce80d662ade8068$var$clearNextFrameAction(this._onNextFrameActionId);
    };
    /**
   * Put focus on a <textarea /> DOM element.
   */ TextareaAutosize.prototype.focus = function focus() {
        this._rootDOMNode.focus();
    };
    /**
   * Shifts focus away from a <textarea /> DOM element.
   */ TextareaAutosize.prototype.blur = function blur() {
        this._rootDOMNode.blur();
    };
    $7ce80d662ade8068$var$_createClass(TextareaAutosize, [
        {
            key: "value",
            /**
     * Read the current value of <textarea /> from DOM.
     */ get: function get() {
                return this._rootDOMNode.value;
            },
            set: function set(val) {
                this._rootDOMNode.value = val;
            }
        },
        {
            key: "selectionStart",
            get: function get() {
                return this._rootDOMNode.selectionStart;
            },
            set: function set(selectionStart) {
                this._rootDOMNode.selectionStart = selectionStart;
            }
        },
        {
            key: "selectionEnd",
            get: function get() {
                return this._rootDOMNode.selectionEnd;
            },
            set: function set(selectionEnd) {
                this._rootDOMNode.selectionEnd = selectionEnd;
            }
        }
    ]);
    return TextareaAutosize;
}((0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).Component);
$7ce80d662ade8068$var$TextareaAutosize.propTypes = {
    /**
   * Current textarea value.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).string,
    /**
   * Callback on value change.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).func,
    /**
   * Callback on height changes.
   */ onHeightChange: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).func,
    /**
   * Try to cache DOM measurements performed by component so that we don't
   * touch DOM when it's not needed.
   *
   * This optimization doesn't work if we dynamically style <textarea />
   * component.
   */ useCacheForDOMMeasurements: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).bool,
    /**
   * Minimal numbder of rows to show.
   */ rows: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).number,
    /**
   * Alias for `rows`.
   */ minRows: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).number,
    /**
   * Maximum number of rows to show.
   */ maxRows: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).number,
    /**
   * Allows an owner to retrieve the DOM node.
   */ inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).func
};
$7ce80d662ade8068$var$TextareaAutosize.defaultProps = {
    onChange: $7ce80d662ade8068$var$noop,
    onHeightChange: $7ce80d662ade8068$var$noop,
    useCacheForDOMMeasurements: false
};
var $7ce80d662ade8068$export$2e2bcd8739ae039 = $7ce80d662ade8068$var$TextareaAutosize;
function $7ce80d662ade8068$var$onNextFrame(cb) {
    if (window.requestAnimationFrame) return window.requestAnimationFrame(cb);
    return window.setTimeout(cb, 1);
}
function $7ce80d662ade8068$var$clearNextFrameAction(nextFrameId) {
    if (window.cancelAnimationFrame) window.cancelAnimationFrame(nextFrameId);
    else window.clearTimeout(nextFrameId);
}

});
parcelRegister("5xtSr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $408735ca7567f3b5$export$2e2bcd8739ae039; });
/**
 * calculateNodeHeight(uiTextNode, useCache = false)
 */ var $408735ca7567f3b5$var$browser = typeof window !== "undefined" && typeof document !== "undefined";
var $408735ca7567f3b5$var$isIE = $408735ca7567f3b5$var$browser ? !!document.documentElement.currentStyle : false;
var $408735ca7567f3b5$var$boxSizingProp = function() {
    if (!$408735ca7567f3b5$var$browser) return "box-sizing";
    var documentStyle = window.getComputedStyle(document.documentElement);
    // TODO: remove prefixed - they are probably obsolete, were introduced in by df79cf502630744d40233b64cad01770e5584610 in 2014
    return documentStyle.getPropertyValue("box-sizing") ? "box-sizing" : documentStyle.getPropertyValue("-moz-box-sizing") ? "-moz-box-sizing" : documentStyle.getPropertyValue("-webkit-box-sizing") ? "-webkit-box-sizing" : "box-sizing";
}();
var $408735ca7567f3b5$var$HIDDEN_TEXTAREA_STYLE = {
    "min-height": "0",
    "max-height": "none",
    "height": "0",
    "visibility": "hidden",
    "overflow": "hidden",
    "position": "absolute",
    "z-index": "-1000",
    "top": "0",
    "right": "0"
};
var $408735ca7567f3b5$var$SIZING_STYLE = [
    "letter-spacing",
    "line-height",
    "font-family",
    "font-weight",
    "font-size",
    "text-rendering",
    "text-transform",
    "width",
    "text-indent",
    "padding-top",
    "padding-right",
    "padding-bottom",
    "padding-left",
    "border-top-width",
    "border-right-width",
    "border-bottom-width",
    "border-left-width",
    $408735ca7567f3b5$var$boxSizingProp
];
var $408735ca7567f3b5$var$computedStyleCache = {};
var $408735ca7567f3b5$var$hiddenTextarea = void 0;
function $408735ca7567f3b5$export$2e2bcd8739ae039(uiTextNode) {
    var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var minRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var maxRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    if (!$408735ca7567f3b5$var$hiddenTextarea) {
        $408735ca7567f3b5$var$hiddenTextarea = document.createElement("textarea");
        document.body.appendChild($408735ca7567f3b5$var$hiddenTextarea);
    } else if ($408735ca7567f3b5$var$hiddenTextarea.parentNode === null) document.body.appendChild($408735ca7567f3b5$var$hiddenTextarea);
    // Copy all CSS properties that have an impact on the height of the content in
    // the textbox
    var _calculateNodeStyling = $408735ca7567f3b5$var$calculateNodeStyling(uiTextNode, useCache), paddingSize = _calculateNodeStyling.paddingSize, borderSize = _calculateNodeStyling.borderSize, boxSizing = _calculateNodeStyling.boxSizing, sizingStyle = _calculateNodeStyling.sizingStyle;
    // Need to have the overflow attribute to hide the scrollbar otherwise
    // text-lines will not calculated properly as the shadow will technically be
    // narrower for content
    Object.keys(sizingStyle).map(function(key) {
        $408735ca7567f3b5$var$hiddenTextarea.style[key] = sizingStyle[key];
    });
    Object.keys($408735ca7567f3b5$var$HIDDEN_TEXTAREA_STYLE).map(function(key) {
        $408735ca7567f3b5$var$hiddenTextarea.style.setProperty(key, $408735ca7567f3b5$var$HIDDEN_TEXTAREA_STYLE[key], "important");
    });
    $408735ca7567f3b5$var$hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || "x";
    var minHeight = -Infinity;
    var maxHeight = Infinity;
    var height = $408735ca7567f3b5$var$hiddenTextarea.scrollHeight;
    if (boxSizing === "border-box") // border-box: add border, since height = content + padding + border
    height = height + borderSize;
    else if (boxSizing === "content-box") // remove padding, since height = content
    height = height - paddingSize;
    if (minRows !== null || maxRows !== null) {
        // measure height of a textarea with a single row
        $408735ca7567f3b5$var$hiddenTextarea.value = "x";
        var singleRowHeight = $408735ca7567f3b5$var$hiddenTextarea.scrollHeight - paddingSize;
        if (minRows !== null) {
            minHeight = singleRowHeight * minRows;
            if (boxSizing === "border-box") minHeight = minHeight + paddingSize + borderSize;
            height = Math.max(minHeight, height);
        }
        if (maxRows !== null) {
            maxHeight = singleRowHeight * maxRows;
            if (boxSizing === "border-box") maxHeight = maxHeight + paddingSize + borderSize;
            height = Math.min(maxHeight, height);
        }
    }
    return {
        height: height,
        minHeight: minHeight,
        maxHeight: maxHeight
    };
}
function $408735ca7567f3b5$var$calculateNodeStyling(node) {
    var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    // TODO: generate id in constructor + clear cache in componentWillUnmount
    var nodeRef = node.getAttribute("id") || node.getAttribute("data-reactid") || node.getAttribute("name");
    if (useCache && $408735ca7567f3b5$var$computedStyleCache[nodeRef]) return $408735ca7567f3b5$var$computedStyleCache[nodeRef];
    var style = window.getComputedStyle(node);
    var sizingStyle = $408735ca7567f3b5$var$SIZING_STYLE.reduce(function(obj, name) {
        obj[name] = style.getPropertyValue(name);
        return obj;
    }, {});
    var boxSizing = sizingStyle[$408735ca7567f3b5$var$boxSizingProp];
    // IE (Edge has already correct behaviour) returns content width as computed width
    // so we need to add manually padding and border widths
    if ($408735ca7567f3b5$var$isIE && boxSizing === "border-box") sizingStyle.width = parseFloat(sizingStyle.width) + parseFloat(style["border-right-width"]) + parseFloat(style["border-left-width"]) + parseFloat(style["padding-right"]) + parseFloat(style["padding-left"]) + "px";
    var paddingSize = parseFloat(sizingStyle["padding-bottom"]) + parseFloat(sizingStyle["padding-top"]);
    var borderSize = parseFloat(sizingStyle["border-bottom-width"]) + parseFloat(sizingStyle["border-top-width"]);
    var nodeInfo = {
        sizingStyle: sizingStyle,
        paddingSize: paddingSize,
        borderSize: borderSize,
        boxSizing: boxSizing
    };
    if (useCache && nodeRef) $408735ca7567f3b5$var$computedStyleCache[nodeRef] = nodeInfo;
    return nodeInfo;
}

});



parcelRegister("kqntg", function(module, exports) {

$parcel$export(module.exports, "CenterPadPageBody", function () { return $46d14cec3dea9212$export$b0d82bb64a6245b8; });
$parcel$export(module.exports, "PageBody", function () { return $46d14cec3dea9212$export$e2f852c9f5ed53ab; });

var $61Ea1 = parcelRequire("61Ea1");

var $95Evz = parcelRequire("95Evz");
const $46d14cec3dea9212$export$b0d82bb64a6245b8 = ({ children: children, className: className })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: (0, $95Evz.cn)("flex flex-col items-center p-8 flex-auto overflow-auto print:overflow-visible", className),
        children: [
            children,
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "h-28 w-full print:hidden flex-none"
            })
        ]
    });
};
const $46d14cec3dea9212$export$e2f852c9f5ed53ab = ({ children: children, className: className })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: (0, $95Evz.cn)("flex flex-col flex-auto overflow-auto print:overflow-visible", className),
        children: [
            children,
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "h-28 w-full print:hidden flex-none"
            })
        ]
    });
};

});


parcelRegister("dW6fO", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $a2558b0a1bff3cc8$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");

var $da3Z3 = parcelRequire("da3Z3");

var $3jRTN = parcelRequire("3jRTN");

var $kuPRw = parcelRequire("kuPRw");

var $4iw5i = parcelRequire("4iw5i");

var $5PXcS = parcelRequire("5PXcS");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $7qobO = parcelRequire("7qobO");

var $26sX2 = parcelRequire("26sX2");

var $kqntg = parcelRequire("kqntg");

var $3h7sC = parcelRequire("3h7sC");

var $47i9t = parcelRequire("47i9t");
const $a2558b0a1bff3cc8$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_private/suppliers")({
    beforeLoad: ({ params: params })=>{
        if (!(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "suppliers", params)) throw new Error("Permission Denied");
        (0, $26sX2.setLayoutDefaults)({
            pageTitle: "Suppliers",
            subMenu: "suppliers"
        });
    },
    errorComponent: ({ error: error, reset: reset })=>{
        if (error.message === "Permission Denied") return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7qobO.default), {});
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    },
    loader: async ()=>await $a2558b0a1bff3cc8$var$loader(),
    pendingComponent: (0, $4iw5i.default),
    component: $a2558b0a1bff3cc8$var$Wrapper
});
const $a2558b0a1bff3cc8$var$loader = async ()=>{
    const data = await (0, $3h7sC.trpc).legacy.getSuppliersPageData.query();
    return (0, $47i9t.processTRPCData)(data);
};
function $a2558b0a1bff3cc8$var$Wrapper() {
    if ((0, $8kZ1o.migratedToV2)()) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqntg.CenterPadPageBody), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3jRTN.default), {})
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $da3Z3.default), {}),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kuPRw.default), {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3jRTN.default), {})
            })
        ]
    });
}

});
parcelRegister("da3Z3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $994f4c9fb77f2ae6$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $2Zzii = parcelRequire("2Zzii");

var $36Jjh = parcelRequire("36Jjh");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");
var $994f4c9fb77f2ae6$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ extraContent: extraContent })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $36Jjh.default), {
        heading: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: "Suppliers"
            })
        }),
        extraContent: (0, $8kZ1o.canEditSuppliers)((0, $1BTI2.default).user) ? /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
            className: "btn btn-default add-timesheet-entry-button plus-btn mt-6",
            onClick: ()=>{
                const ph = (0, $2Zzii.default).add({}, {
                    trackUpdates: true
                });
                ph.isNew = true;
            },
            children: "+ Add Supplier"
        }) : null
    });
});

});

parcelRegister("3jRTN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26acf4a6568b088e$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $goLmS = parcelRequire("goLmS");

var $2Zzii = parcelRequire("2Zzii");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");
const $26acf4a6568b088e$var$columns = [
    {
        id: "name",
        label: "Name",
        type: "text",
        width: 25,
        editable: (row)=>(0, $8kZ1o.canEditSuppliers)((0, $1BTI2.default).user),
        value: (row)=>{
            return row.name;
        },
        onChange: (row)=>(val)=>row.update({
                    name: val
                })
    },
    {
        label: "",
        width: 4,
        type: "button",
        permissions: (r)=>(0, $8kZ1o.canEditSuppliers)((0, $1BTI2.default).user),
        editable: (r)=>(0, $8kZ1o.canEditSuppliers)((0, $1BTI2.default).user),
        value: (p)=>/*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                className: "fa fa-times",
                style: {
                    marginRight: 0
                }
            }),
        onClick: (r)=>()=>{
                r.update({
                    deletedAt: new Date()
                });
            }
    }
];
var $26acf4a6568b088e$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(()=>{
    var _SupplierCollection$a, _SupplierCollection$a3;
    const [suppliers, setSuppliers] = (0, $jbmdS.useState)([
        ...((0, $2Zzii.default) === null || (0, $2Zzii.default) === void 0 ? void 0 : (_SupplierCollection$a = (0, $2Zzii.default).activeSuppliers) === null || _SupplierCollection$a === void 0 ? void 0 : _SupplierCollection$a.sort((a, b)=>{
            var _a$name, _a$name$localeCompare;
            return (_a$name = a.name) === null || _a$name === void 0 ? void 0 : (_a$name$localeCompare = _a$name.localeCompare) === null || _a$name$localeCompare === void 0 ? void 0 : _a$name$localeCompare.call(_a$name, b.name);
        })) || []
    ]);
    (0, $jbmdS.useEffect)(()=>{
        var _SupplierCollection$a2;
        setSuppliers([
            ...((0, $2Zzii.default) === null || (0, $2Zzii.default) === void 0 ? void 0 : (_SupplierCollection$a2 = (0, $2Zzii.default).activeSuppliers) === null || _SupplierCollection$a2 === void 0 ? void 0 : _SupplierCollection$a2.sort((a, b)=>{
                var _a$name2, _a$name2$localeCompar;
                return (_a$name2 = a.name) === null || _a$name2 === void 0 ? void 0 : (_a$name2$localeCompar = _a$name2.localeCompare) === null || _a$name2$localeCompar === void 0 ? void 0 : _a$name2$localeCompar.call(_a$name2, b.name);
            })) || []
        ]);
    }, [
        (0, $2Zzii.default) === null || (0, $2Zzii.default) === void 0 ? void 0 : (_SupplierCollection$a3 = (0, $2Zzii.default).activeSuppliers) === null || _SupplierCollection$a3 === void 0 ? void 0 : _SupplierCollection$a3.length
    ]);
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
            columns: $26acf4a6568b088e$var$columns,
            rows: suppliers,
            newRowDirection: "asc"
        })
    });
});

});


parcelRegister("dTHhw", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $a1e1fc411155ef00$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");

var $3RUOu = parcelRequire("3RUOu");

var $ieKCe = parcelRequire("ieKCe");

var $kglP9 = parcelRequire("kglP9");

var $kuPRw = parcelRequire("kuPRw");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $7qobO = parcelRequire("7qobO");

var $4iw5i = parcelRequire("4iw5i");

var $5PXcS = parcelRequire("5PXcS");

var $kqntg = parcelRequire("kqntg");

var $26sX2 = parcelRequire("26sX2");

var $MYZTJ = parcelRequire("MYZTJ");
const $a1e1fc411155ef00$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_private/settings")({
    beforeLoad: ({ params: params })=>{
        if (!(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "settings", params)) throw new Error("Permission Denied");
        (0, $26sX2.setLayoutDefaults)({
            pageTitle: "Settings"
        });
    },
    errorComponent: ({ error: error, reset: reset })=>{
        if (error.message === "Permission Denied") return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7qobO.default), {});
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    },
    loader: (0, $MYZTJ.settingsStore).loader,
    pendingComponent: (0, $4iw5i.default),
    component: $a1e1fc411155ef00$var$Wrapper
});
function $a1e1fc411155ef00$var$Wrapper() {
    // The store now handles all the save toast logic internally
    (0, $MYZTJ.settingsStore).useSaveHandler();
    if ((0, $8kZ1o.migratedToV2)()) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqntg.CenterPadPageBody), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kglP9.SettingPage), {})
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3RUOu.default), {
                label: "Settings"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kuPRw.default), {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ieKCe.default), {})
            })
        ]
    });
}

});
parcelRegister("3RUOu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d126448e56f3a62$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $36Jjh = parcelRequire("36Jjh");
var $2d126448e56f3a62$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ label: label })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $36Jjh.default), {
        heading: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: label
            })
        })
    });
});

});

parcelRegister("ieKCe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d46db1b291e2ac54$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $52dEm = parcelRequire("52dEm");

var $kNuKk = parcelRequire("kNuKk");

var $8kZ1o = parcelRequire("8kZ1o");

var $ewAM3 = parcelRequire("ewAM3");
parcelRequire("c86dX");

var $01BMe = parcelRequire("01BMe");
var $d46db1b291e2ac54$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(()=>{
    const [settingsStore, setStore] = (0, $jbmdS.useState)(new (0, $kNuKk.default)());
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "max-w-[60em] py-[2em] px-[4px]",
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "flex items-center py-[2em]",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                        className: "inline-block",
                        children: "Sort Phases By:"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "mx-[1em] w-[12em]",
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                            style: {
                                width: "100%"
                            },
                            value: settingsStore.settings.sortPhasesBy,
                            onChange: function(value) {
                                settingsStore.changeSetting("sortPhasesBy", value);
                            },
                            options: [
                                {
                                    label: "Start Date",
                                    value: "startDate"
                                },
                                {
                                    label: "Title",
                                    value: "tile"
                                }
                            ],
                            variant: "secondary"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                    value: settingsStore.settings.allowNoPhase,
                    onChange: (value)=>{
                        settingsStore.changeSetting("allowNoPhase", value);
                    },
                    label: "Allow time to be logged without a selecting a phase.",
                    variant: "secondary"
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "mt-[2em]",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                    value: settingsStore.settings.useTasks,
                    onChange: function(value) {
                        settingsStore.changeSetting("useTasks", value);
                    },
                    label: "Allow time to be logged against tasks.",
                    variant: "secondary"
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "mt-[2em]",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                    value: settingsStore.settings.allowAfterPhaseEnd,
                    onChange: (value)=>{
                        settingsStore.changeSetting("allowAfterPhaseEnd", value);
                    },
                    label: "Allow time to be logged against a phase that has ended.",
                    variant: "secondary"
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "mt-[3em]",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)("p", {
                    children: "Allow phases with the following statuses to be visible when entering time:"
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "mt-[1em] ml-[2em]",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                    value: settingsStore.settings.timeEntryStatus.includes("active"),
                    onChange: function(value) {
                        if (value) settingsStore.changeSetting("timeEntryStatus", [
                            "active",
                            ...settingsStore.settings.timeEntryStatus
                        ]);
                        else settingsStore.changeSetting("timeEntryStatus", settingsStore.settings.timeEntryStatus.filter((s)=>s !== "active"));
                    },
                    label: "Active",
                    variant: "secondary"
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "ml-[2em]",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                    value: settingsStore.settings.timeEntryStatus.includes("prospective"),
                    onChange: function(value) {
                        if (value) settingsStore.changeSetting("timeEntryStatus", [
                            "prospective",
                            ...settingsStore.settings.timeEntryStatus
                        ]);
                        else settingsStore.changeSetting("timeEntryStatus", settingsStore.settings.timeEntryStatus.filter((s)=>s !== "prospective"));
                    },
                    label: "Prospective",
                    variant: "secondary"
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    marginLeft: "2em"
                },
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                    value: settingsStore.settings.timeEntryStatus.includes("onHold"),
                    onChange: function(value) {
                        if (value) settingsStore.changeSetting("timeEntryStatus", [
                            "onHold",
                            ...settingsStore.settings.timeEntryStatus
                        ]);
                        else settingsStore.changeSetting("timeEntryStatus", settingsStore.settings.timeEntryStatus.filter((s)=>s !== "onHold"));
                    },
                    label: "On Hold",
                    variant: "secondary"
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    marginLeft: "2em"
                },
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                    value: settingsStore.settings.timeEntryStatus.includes("archived"),
                    onChange: function(value) {
                        if (value) settingsStore.changeSetting("timeEntryStatus", [
                            "archived",
                            ...settingsStore.settings.timeEntryStatus
                        ]);
                        else settingsStore.changeSetting("timeEntryStatus", settingsStore.settings.timeEntryStatus.filter((s)=>s !== "archived"));
                    },
                    label: "Archived",
                    variant: "secondary"
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("p", {
                className: "mt-[3em]",
                children: "Allow staff to flag time entries with the following:"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "mt-[1em] ml-[2em]",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                    value: settingsStore.settings.timeEntryFlags.includes("variation"),
                    onChange: function(value) {
                        if (value) settingsStore.changeSetting("timeEntryFlags", [
                            "variation",
                            ...settingsStore.settings.timeEntryFlags
                        ]);
                        else settingsStore.changeSetting("timeEntryFlags", settingsStore.settings.timeEntryFlags.filter((s)=>s !== "variation"));
                    },
                    label: "Variation",
                    variant: "secondary"
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    marginLeft: "2em"
                },
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                    value: settingsStore.settings.timeEntryFlags.includes("billable"),
                    onChange: function(value) {
                        if (value) settingsStore.changeSetting("timeEntryFlags", [
                            "billable",
                            ...settingsStore.settings.timeEntryFlags
                        ]);
                        else settingsStore.changeSetting("timeEntryFlags", settingsStore.settings.timeEntryFlags.filter((s)=>s !== "billable"));
                    },
                    label: "Billable",
                    variant: "secondary"
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    marginLeft: "2em"
                },
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                    value: settingsStore.settings.timeEntryFlags.includes("overtime"),
                    onChange: function(value) {
                        if (value) settingsStore.changeSetting("timeEntryFlags", [
                            "overtime",
                            ...settingsStore.settings.timeEntryFlags
                        ]);
                        else settingsStore.changeSetting("timeEntryFlags", settingsStore.settings.timeEntryFlags.filter((s)=>s !== "overtime"));
                    },
                    label: "Overtime",
                    variant: "secondary"
                })
            }),
            (0, $8kZ1o.canViewRemote)() ? /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    marginLeft: "2em"
                },
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                    value: settingsStore.settings.timeEntryFlags.includes("remote"),
                    onChange: function(value) {
                        if (value) settingsStore.changeSetting("timeEntryFlags", [
                            "remote",
                            ...settingsStore.settings.timeEntryFlags
                        ]);
                        else settingsStore.changeSetting("timeEntryFlags", settingsStore.settings.timeEntryFlags.filter((s)=>s !== "remote"));
                    },
                    label: "Remote",
                    variant: "secondary"
                })
            }) : null,
            (0, $8kZ1o.canViewFlexi)() ? /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    marginLeft: "2em"
                },
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                    value: settingsStore.settings.timeEntryFlags.includes("flexi"),
                    onChange: function(value) {
                        if (value) settingsStore.changeSetting("timeEntryFlags", [
                            "flexi",
                            ...settingsStore.settings.timeEntryFlags
                        ]);
                        else settingsStore.changeSetting("timeEntryFlags", settingsStore.settings.timeEntryFlags.filter((s)=>s !== "flexi"));
                    },
                    label: "Flexi",
                    variant: "secondary"
                })
            }) : null,
            /*#__PURE__*/ (0, $61Ea1.jsx)("p", {
                className: "mt-[3em]",
                children: "Allow staff to enter time against phases:"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "mt-[1em] ml-[2em]",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                    value: settingsStore.settings.timeEntryAllocations.includes("noAllocations"),
                    onChange: function(value) {
                        if (value) settingsStore.changeSetting("timeEntryAllocations", [
                            "noAllocations",
                            ...settingsStore.settings.timeEntryAllocations
                        ]);
                        else settingsStore.changeSetting("timeEntryAllocations", settingsStore.settings.timeEntryAllocations.filter((s)=>s !== "noAllocations"));
                    },
                    label: "Without budgets or allocations for that staff member.",
                    variant: "secondary"
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "mt-[1em] ml-[2em]",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                    value: settingsStore.settings.timeEntryAllocations.includes("budgets"),
                    onChange: function(value) {
                        if (value) settingsStore.changeSetting("timeEntryAllocations", [
                            "budgets",
                            ...settingsStore.settings.timeEntryAllocations
                        ]);
                        else settingsStore.changeSetting("timeEntryAllocations", settingsStore.settings.timeEntryAllocations.filter((s)=>s !== "budgets"));
                    },
                    label: "With budgets for that staff member.",
                    variant: "secondary"
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "mt-[1em] ml-[2em]",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                    value: settingsStore.settings.timeEntryAllocations.includes("allocations"),
                    onChange: function(value) {
                        if (value) settingsStore.changeSetting("timeEntryAllocations", [
                            "allocations",
                            ...settingsStore.settings.timeEntryAllocations
                        ]);
                        else settingsStore.changeSetting("timeEntryAllocations", settingsStore.settings.timeEntryAllocations.filter((s)=>s !== "allocations"));
                    },
                    label: "With monthly allocations for that staff member.",
                    variant: "secondary"
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("p", {
                className: "mt-[3em]",
                children: "Auto-populate timesheets for phases:"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "mt-[1em] ml-[2em]",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                    value: settingsStore.settings.autoPopulate.includes("budgets"),
                    onChange: function(value) {
                        if (value) settingsStore.changeSetting("autoPopulate", [
                            "budgets",
                            ...settingsStore.settings.autoPopulate
                        ]);
                        else settingsStore.changeSetting("autoPopulate", settingsStore.settings.autoPopulate.filter((s)=>s !== "budgets"));
                    },
                    label: "With time budgeted for that staff member.",
                    variant: "secondary"
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "mt-[1em] ml-[2em]",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                    value: settingsStore.settings.autoPopulate.includes("allocations"),
                    onChange: function(value) {
                        if (value) settingsStore.changeSetting("autoPopulate", [
                            "allocations",
                            ...settingsStore.settings.autoPopulate
                        ]);
                        else settingsStore.changeSetting("autoPopulate", settingsStore.settings.autoPopulate.filter((s)=>s !== "allocations"));
                    },
                    label: "With monthly allocations assigned to that staff member.",
                    variant: "secondary"
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "mt-[2em]",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                        value: settingsStore.settings.updateHoursFromRevenue,
                        onChange: function(value) {
                            settingsStore.changeSetting("updateHoursFromRevenue", value);
                        },
                        label: "Automatically adjust Staff Hours when editing Revenue in Forecasts",
                        variant: "secondary"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                        value: settingsStore.settings.updateRevenueFromHours,
                        onChange: function(value) {
                            settingsStore.changeSetting("updateRevenueFromHours", value);
                        },
                        label: "Automatically adjust Revenue when editing Staff Hours in Forecasts",
                        variant: "secondary"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "mt-[4em]",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "flex items-center mb-[0.5em]",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                                style: {
                                    width: "8em",
                                    marginRight: "1em"
                                },
                                value: settingsStore.settings.autoUpdateRevenue.action,
                                onChange: function(value) {
                                    settingsStore.changeSetting("autoUpdateRevenue", {
                                        ...settingsStore.settings.autoUpdateRevenue,
                                        action: value
                                    });
                                },
                                options: [
                                    {
                                        label: "Ask Me to",
                                        value: "ask"
                                    },
                                    {
                                        label: "Always",
                                        value: "automatic"
                                    },
                                    {
                                        label: "Never",
                                        value: "never"
                                    }
                                ],
                                variant: "secondary"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                children: "Automatically adjust the Revenue Forecast when saving Projects and Invoices."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                        value: settingsStore.settings.autoUpdateRevenue.adjustOnLoad,
                        onChange: function(value) {
                            settingsStore.changeSetting("autoUpdateRevenue", {
                                ...settingsStore.settings.autoUpdateRevenue,
                                adjustOnLoad: value
                            });
                        },
                        label: "Automatically adjust Revenue when loading the Revenue Forecast",
                        variant: "secondary"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "flex items-center border-t border-[#eee] p-[2em]",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                className: "inline-block",
                                children: "Distribute"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "mx-[1em] w-[12em]",
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                                    style: {
                                        width: "100%"
                                    },
                                    value: settingsStore.settings.autoUpdateRevenue.budget,
                                    onChange: function(value) {
                                        settingsStore.changeSetting("autoUpdateRevenue", {
                                            ...settingsStore.settings.autoUpdateRevenue,
                                            budget: value
                                        });
                                    },
                                    options: [
                                        {
                                            label: "Total Budget",
                                            value: "total"
                                        },
                                        {
                                            label: "Remaining Budget",
                                            value: "remaining"
                                        }
                                    ],
                                    variant: "secondary"
                                })
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                className: "inline-block",
                                children: "between"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "mx-[1em] w-[9em]",
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                                    style: {
                                        width: "100%"
                                    },
                                    value: settingsStore.settings.autoUpdateRevenue.start,
                                    onChange: function(value) {
                                        settingsStore.changeSetting("autoUpdateRevenue", {
                                            ...settingsStore.settings.autoUpdateRevenue,
                                            start: value
                                        });
                                    },
                                    options: [
                                        {
                                            label: "Start Date",
                                            value: "startDate"
                                        },
                                        {
                                            label: "Current Date",
                                            value: "now"
                                        },
                                        {
                                            label: "End Date",
                                            value: "endDate"
                                        }
                                    ],
                                    variant: "secondary"
                                })
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                className: "inline-block",
                                children: "and"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "mx-[1em] w-[9em]",
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                                    style: {
                                        width: "100%"
                                    },
                                    value: settingsStore.settings.autoUpdateRevenue.end,
                                    onChange: function(value) {
                                        settingsStore.changeSetting("autoUpdateRevenue", {
                                            ...settingsStore.settings.autoUpdateRevenue,
                                            end: value
                                        });
                                    },
                                    options: [
                                        {
                                            label: "Start Date",
                                            value: "startDate"
                                        },
                                        {
                                            label: "End Date",
                                            value: "endDate"
                                        }
                                    ],
                                    variant: "secondary"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "mt-[3em]",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("divs", {
                        style: {
                            display: "flex",
                            alignItems: "center",
                            marginBottom: "0.5em"
                        },
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                                style: {
                                    width: "8em",
                                    marginRight: "1em"
                                },
                                value: settingsStore.settings.autoUpdateHours.action,
                                onChange: function(value) {
                                    settingsStore.changeSetting("autoUpdateHours", {
                                        ...settingsStore.settings.autoUpdateHours,
                                        action: value
                                    });
                                },
                                options: [
                                    {
                                        label: "Ask Me to",
                                        value: "ask"
                                    },
                                    {
                                        label: "Always",
                                        value: "automatic"
                                    },
                                    {
                                        label: "Never",
                                        value: "never"
                                    }
                                ],
                                variant: "secondary"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                children: "Automatically adjust the Resource Schedule when saving Projects and Time entries."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                        value: settingsStore.settings.autoUpdateHours.adjustOnLoad,
                        onChange: function(value) {
                            settingsStore.changeSetting("autoUpdateHours", {
                                ...settingsStore.settings.autoUpdateHours,
                                adjustOnLoad: value
                            });
                        },
                        label: "Automatically adjust Staff Hours when loading the Resource Schedule",
                        variant: "secondary"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "flex items-center border-t border-[#eee] p-[2em]",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                className: "inline-block",
                                children: "Distribute"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "mx-[1em] w-[12em]",
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                                    style: {
                                        width: "100%"
                                    },
                                    value: settingsStore.settings.autoUpdateHours.budget,
                                    onChange: function(value) {
                                        settingsStore.changeSetting("autoUpdateHours", {
                                            ...settingsStore.settings.autoUpdateHours,
                                            budget: value
                                        });
                                    },
                                    options: [
                                        {
                                            label: "Total Budget",
                                            value: "total"
                                        },
                                        {
                                            label: "Remaining Budget",
                                            value: "remaining"
                                        }
                                    ],
                                    variant: "secondary"
                                })
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                className: "inline-block",
                                children: "between"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "mx-[1em] w-[9em]",
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                                    style: {
                                        width: "100%"
                                    },
                                    value: settingsStore.settings.autoUpdateHours.start,
                                    onChange: function(value) {
                                        settingsStore.changeSetting("autoUpdateHours", {
                                            ...settingsStore.settings.autoUpdateHours,
                                            start: value
                                        });
                                    },
                                    options: [
                                        {
                                            label: "Start Date",
                                            value: "startDate"
                                        },
                                        {
                                            label: "Current Date",
                                            value: "now"
                                        },
                                        {
                                            label: "End Date",
                                            value: "endDate"
                                        }
                                    ],
                                    variant: "secondary"
                                })
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                className: "inline-block",
                                children: "and"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "mx-[1em] w-[9em]",
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                                    style: {
                                        width: "100%"
                                    },
                                    value: settingsStore.settings.autoUpdateHours.end,
                                    onChange: function(value) {
                                        settingsStore.changeSetting("autoUpdateHours", {
                                            ...settingsStore.settings.autoUpdateHours,
                                            end: value
                                        });
                                    },
                                    options: [
                                        {
                                            label: "Start Date",
                                            value: "startDate"
                                        },
                                        {
                                            label: "End Date",
                                            value: "endDate"
                                        }
                                    ],
                                    variant: "secondary"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            padding: "4em 0em 1em 0em"
                        },
                        className: "flex flex-align-items-center",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                className: "inline-block",
                                children: "Use Invoice Date Type in Reports:"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "mx-[1em] w-[12em]",
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                                    style: {
                                        width: "100%"
                                    },
                                    value: settingsStore.settings.reportInvoiceDateType,
                                    onChange: function(value) {
                                        settingsStore.changeSetting("reportInvoiceDateType", value);
                                    },
                                    options: [
                                        {
                                            label: "Work Completion",
                                            value: "endDate"
                                        },
                                        {
                                            label: "Issue Date",
                                            value: "issueDate"
                                        },
                                        {
                                            label: "Due Date",
                                            value: "dueDate"
                                        }
                                    ],
                                    variant: "secondary"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            maxWidth: "60em",
                            padding: "0em 0em 2em"
                        },
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("p", {
                                style: {
                                    marginTop: "2em"
                                },
                                children: "When saving Invoices:"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                style: {
                                    marginTop: "1em",
                                    marginLeft: "2em"
                                },
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                                    value: settingsStore.settings.savingInvoices.includes("lockTime"),
                                    onChange: function(value) {
                                        if (value) settingsStore.changeSetting("savingInvoices", [
                                            "lockTime",
                                            ...settingsStore.settings.savingInvoices
                                        ]);
                                        else settingsStore.changeSetting("savingInvoices", settingsStore.settings.savingInvoices.filter((s)=>s !== "lockTime"));
                                    },
                                    label: "Lock time entries.",
                                    variant: "secondary"
                                })
                            })
                        ]
                    }),
                    (0, $8kZ1o.usingNewLogin)() ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            maxWidth: "60em",
                            padding: "0em 0em 2em"
                        },
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("p", {
                                children: "Automatically create accounts for users with the following email domains:"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                style: {
                                    padding: "1em 2em"
                                },
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $01BMe.default), {})
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
});

});
parcelRegister("kNuKk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2403bcc8925fd6a$export$2e2bcd8739ae039; });
parcelRequire("eBwNQ");

var $4JcCM = parcelRequire("4JcCM");

var $1BTI2 = parcelRequire("1BTI2");

var $htkeB = parcelRequire("htkeB");

var $lpKGM = parcelRequire("lpKGM");
var $f2403bcc8925fd6a$var$_dec, $f2403bcc8925fd6a$var$_class, $f2403bcc8925fd6a$var$_descriptor;
function $f2403bcc8925fd6a$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $f2403bcc8925fd6a$var$_defineProperty(e, r, t) {
    return (r = $f2403bcc8925fd6a$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f2403bcc8925fd6a$var$_toPropertyKey(t) {
    var i = $f2403bcc8925fd6a$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $f2403bcc8925fd6a$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $f2403bcc8925fd6a$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $f2403bcc8925fd6a$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $f2403bcc8925fd6a$var$SettingsPageStore = ($f2403bcc8925fd6a$var$_dec = (0, $4JcCM.action).bound, $f2403bcc8925fd6a$var$_class = class SettingsPageStore {
    constructor(){
        var _SessionStore$organis;
        $f2403bcc8925fd6a$var$_initializerDefineProperty(this, "settings", $f2403bcc8925fd6a$var$_descriptor, this);
        (0, $4JcCM.makeObservable)(this);
        this.settings = {
            ...(0, $1BTI2.settingDefaults),
            ...((_SessionStore$organis = (0, $1BTI2.default).organisation) === null || _SessionStore$organis === void 0 ? void 0 : _SessionStore$organis.settings) || {}
        };
    }
    changeSetting(name, value) {
        this.settings[name] = value;
        (0, $1BTI2.default).organisation.update({
            settings: this.settings
        });
    }
    get emailDomainOptions() {
        return [
            ...new Set([
                ...((0, $htkeB.default).activeStaff || []).filter((staff)=>(0, $lpKGM.isCompanyEmail)(staff.email)).map((staff)=>staff.email.split("@")[1]),
                ...this.settings.emailDomains || []
            ])
        ];
    }
}, $f2403bcc8925fd6a$var$_descriptor = $f2403bcc8925fd6a$var$_applyDecoratedDescriptor($f2403bcc8925fd6a$var$_class.prototype, "settings", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $f2403bcc8925fd6a$var$_applyDecoratedDescriptor($f2403bcc8925fd6a$var$_class.prototype, "changeSetting", [
    $f2403bcc8925fd6a$var$_dec
], Object.getOwnPropertyDescriptor($f2403bcc8925fd6a$var$_class.prototype, "changeSetting"), $f2403bcc8925fd6a$var$_class.prototype), $f2403bcc8925fd6a$var$_applyDecoratedDescriptor($f2403bcc8925fd6a$var$_class.prototype, "emailDomainOptions", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($f2403bcc8925fd6a$var$_class.prototype, "emailDomainOptions"), $f2403bcc8925fd6a$var$_class.prototype), $f2403bcc8925fd6a$var$_class);
var $f2403bcc8925fd6a$export$2e2bcd8739ae039 = $f2403bcc8925fd6a$var$SettingsPageStore;

});
parcelRegister("lpKGM", function(module, exports) {
"use strict";
var $0405f019d659606e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DOMAINS = module.exports.isCompanyEmail = module.exports.isFreeEmail = void 0;

var $hbVDx = parcelRequire("hbVDx");
Object.defineProperty(module.exports, "DOMAINS", {
    enumerable: true,
    get: function() {
        return $hbVDx.DOMAINS;
    }
});

const $0405f019d659606e$var$isEmail_1 = $0405f019d659606e$var$__importDefault((parcelRequire("4H8De")));
const $0405f019d659606e$var$isEmailValid = (email, emailValidation = {})=>{
    if (typeof email !== "string") return false;
    return (0, $0405f019d659606e$var$isEmail_1.default)(email, emailValidation);
};
const $0405f019d659606e$var$isFreeEmail = (email, emailValidation = {})=>{
    var _a;
    if (!$0405f019d659606e$var$isEmailValid(email, emailValidation)) return false;
    const domain = (_a = email.split("@")[1]) !== null && _a !== void 0 ? _a : "";
    return $hbVDx.DOMAINS.has(domain);
};
module.exports.isFreeEmail = $0405f019d659606e$var$isFreeEmail;
const $0405f019d659606e$var$isCompanyEmail = (email, emailValidation = {})=>{
    var _a;
    if (!$0405f019d659606e$var$isEmailValid(email, emailValidation)) return false;
    const domain = (_a = email.split("@")[1]) !== null && _a !== void 0 ? _a : "";
    return !$hbVDx.DOMAINS.has(domain);
};
module.exports.isCompanyEmail = $0405f019d659606e$var$isCompanyEmail;

});
parcelRegister("hbVDx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DOMAINS = void 0;
module.exports.DOMAINS = new Set([
    "0-00.usa.cc",
    "0-180.com",
    "0-30-24.com",
    "0-420.com",
    "0-900.com",
    "0-aa.com",
    "0-mail.com",
    "0-z.xyz",
    "0.pl",
    "00.pe",
    "000000pay.com",
    "000476.com",
    "000521.xyz",
    "00082aa.com",
    "00082cc.com",
    "00082ff.com",
    "00082ii.com",
    "00082mm.com",
    "00082rr.com",
    "00082uu.com",
    "00082zz.com",
    "000865b.com",
    "000865e.com",
    "000865g.com",
    "000865j.com",
    "0009827.com",
    "000av.app",
    "000br88.com",
    "001.igg.biz",
    "0010.monster",
    "001913.com",
    "001xs.net",
    "001xs.org",
    "001xs.xyz",
    "002288211.com",
    "002r.com",
    "002t.com",
    "0031casino.com",
    "003271.com",
    "003388211.com",
    "0039.cf",
    "0039.ga",
    "0039.gq",
    "0039.ml",
    "003j.com",
    "004k.com",
    "004r.com",
    "005005.xyz",
    "005588211.com",
    "0058.ru",
    "005f4.xyz",
    "006j.com",
    "006o.com",
    "006z.com",
    "007.surf",
    "007946.com",
    "007948.com",
    "007addict.com",
    "007dotcom.com",
    "007security.com",
    "008106.com",
    "008g8662shjel9p.xyz",
    "0094445.com",
    "009988211.com",
    "009qs.com",
    "00b2bcr51qv59xst2.cf",
    "00b2bcr51qv59xst2.ga",
    "00b2bcr51qv59xst2.gq",
    "00b2bcr51qv59xst2.ml",
    "00b2bcr51qv59xst2.tk",
    "00daipai.com",
    "00g0.com",
    "00xht.com",
    "01-lund.ru",
    "0100110tomachine.com",
    "01011099.com",
    "0101888dns.com",
    "0104445.com",
    "01080.ru",
    "010880.com",
    "01092019.ru",
    "01106.monster",
    "0111vns.com",
    "01122200.com",
    "01122233.com",
    "01122255.com",
    "01133322.com",
    "01133333.com",
    "01133377.com",
    "01144488.com",
    "01144499.com",
    "01155555.com",
    "0124445.com",
    "0134445.com",
    "01428570.xyz",
    "01502.monster",
    "0164445.com",
    "01689306707.mobi",
    "0174445.com",
    "0184445.com",
    "0188.info",
    "0188019.com",
    "01911.ru",
    "019352.com",
    "019625.com",
    "0199903.com",
    "0199906.com",
    "0199908.com",
    "0199912.com",
    "0199917.com",
    "0199918.com",
    "0199919.com",
    "0199920.com",
    "0199921.com",
    "0199923.com",
    "0199924.com",
    "0199926.com",
    "0199930.com",
    "0199931.com",
    "0199934.com",
    "0199935.com",
    "0199938.com",
    "0199941.com",
    "0199942.com",
    "0199945.com",
    "0199946.com",
    "0199947.com",
    "0199948.com",
    "0199949.com",
    "0199950.com",
    "0199952.com",
    "0199954.com",
    "0199956.com",
    "0199959.com",
    "0199960.com",
    "0199961.com",
    "0199963.com",
    "0199965.com",
    "0199968.com",
    "0199970.com",
    "0199971.com",
    "0199972.com",
    "0199973.com",
    "0199974.com",
    "0199976.com",
    "0199980.com",
    "0199983.com",
    "0199984.com",
    "0199985.com",
    "0199986.com",
    "01bktwi2lzvg05.cf",
    "01bktwi2lzvg05.ga",
    "01bktwi2lzvg05.gq",
    "01bktwi2lzvg05.ml",
    "01bktwi2lzvg05.tk",
    "01g.cloud",
    "01mc.ru",
    "020.co.uk",
    "0204445.com",
    "021-club.live",
    "021-game.live",
    "021-games.live",
    "021go.org",
    "021vip.org",
    "0234445.com",
    "02433.monster",
    "02466.cf",
    "02466.ga",
    "02466.gq",
    "02466.ml",
    "02540.xyz",
    "0264445.com",
    "027168.com",
    "02831.monster",
    "02914.monster",
    "0294445.com",
    "02a2k17zaxk9cal.xyz",
    "02bmw.ru",
    "02didi.com",
    "02nss.icu",
    "02zbji.us",
    "03-genkzmail.ga",
    "0304445.com",
    "0317123.cn",
    "031803.com",
    "031804.com",
    "031806.com",
    "031823.com",
    "031825.com",
    "031827.com",
    "031829.com",
    "031834.com",
    "031836.com",
    "031837.com",
    "031839.com",
    "031850.com",
    "031859.com",
    "031870.com",
    "031873.com",
    "031879.com",
    "031892.com",
    "031897.com",
    "031905.com",
    "031906.com",
    "0322.info",
    "03343.monster",
    "0334445.com",
    "0351an.com",
    "0354445.com",
    "0374445.com",
    "039837.com",
    "039mch.info",
    "03group.ru",
    "03riri.com",
    "03vtg9.us",
    "04.biz",
    "04022019usercontent.cf",
    "0403site01.fun",
    "0403site02.fun",
    "04058.monster",
    "0406.group",
    "0440tlrfm056aznoelu9775.com",
    "0440tvrzee5qzzbpreu8481.com",
    "045.net",
    "04514.monster",
    "0454445.com",
    "046189.icu",
    "04700.xyz",
    "04834.xyz",
    "04840.monster",
    "0484445.com",
    "049335.com",
    "049356.com",
    "04ocdi.us",
    "04t687ck855wd6u.xyz",
    "050506.com",
    "05088.xyz",
    "05379.monster",
    "0551149.xyz",
    "0553jt.com",
    "0554445.com",
    "05555.monster",
    "05643.monster",
    "0575520.com",
    "0579city.com",
    "058583.com",
    "05873.monster",
    "05didi.com",
    "05gb.com",
    "05net.info",
    "05ovik.com",
    "0614445.com",
    "061642.icu",
    "0623456.com",
    "0624445.com",
    "062ee.com",
    "062ii.com",
    "062jj.com",
    "062nn.com",
    "0644445.com",
    "06460.monster",
    "064742.com",
    "065260.com",
    "0654445.com",
    "06600.monster",
    "06961616.xyz",
    "069827.com",
    "069837.com",
    "06inci.xyz",
    "07-izvestiya.ru",
    "07-vesti.ru",
    "0704445.com",
    "0713wang.com",
    "07157.com",
    "071qs.com",
    "0734445.com",
    "074445.com",
    "074kiu.us",
    "0752baby.com",
    "0754445.com",
    "0755.us",
    "0755baozhuang.com",
    "0759.us",
    "0764445.com",
    "077112.com",
    "07718888.com",
    "07819.cf",
    "07819.ga",
    "07819.gq",
    "07819.ml",
    "07819.tk",
    "078698.com",
    "0788.info",
    "078qs.com",
    "07900010.com",
    "079827.com",
    "07d.xyz",
    "07didi.com",
    "07habermagazin.com",
    "07lnyi.us",
    "07lxym.info",
    "07riri.com",
    "07stees.online",
    "08-gazeta.ru",
    "08-life.ru",
    "08-mir.ru",
    "08-novosti.ru",
    "08034.monster",
    "080mail.com",
    "0815.ru",
    "0815.ru0clickemail.com",
    "0815.ry",
    "0815.su",
    "08221.monster",
    "08236.monster",
    "082qs.com",
    "0845.ru",
    "084ltxr6.ink",
    "085341.com",
    "0854445.com",
    "08839.club",
    "0884445.com",
    "0888vns.com",
    "08cente.com",
    "08didi.com",
    "08ty8.icu",
    "08yft7.us",
    "09090kosmos.site",
    "092092111.com",
    "0924445.com",
    "092hd.com",
    "092kjw.com",
    "0934445.com",
    "093457.com",
    "095cz.com",
    "095ipnone.com",
    "096206.com",
    "0964445.com",
    "0974445.com",
    "09796.monster",
    "0984445.com",
    "099837.com",
    "0999vns.com",
    "09cente.com",
    "09e14e.club",
    "09stees.online",
    "0a7fk6.info",
    "0adzp1.us",
    "0ak.org",
    "0an.ru",
    "0aswhv.us",
    "0b3dc612.xyz",
    "0box.eu",
    "0box.net",
    "0c4538c.club",
    "0c5139f.xyz",
    "0cadb.club",
    "0celot.com",
    "0cindcywrokv.cf",
    "0cindcywrokv.ga",
    "0cindcywrokv.gq",
    "0cindcywrokv.ml",
    "0cindcywrokv.tk",
    "0clickemail.com",
    "0clock.net",
    "0clock.org",
    "0cv23qjrvmcpt.cf",
    "0cv23qjrvmcpt.ga",
    "0cv23qjrvmcpt.gq",
    "0cv23qjrvmcpt.ml",
    "0cv23qjrvmcpt.tk",
    "0cydlx.stream",
    "0d00.com",
    "0d1vii.us",
    "0d4dcc.xyz",
    "0droow.host",
    "0dyqp.com",
    "0eevsq.online",
    "0ehtkltu0sgd.ga",
    "0ehtkltu0sgd.ml",
    "0ehtkltu0sgd.tk",
    "0experts.com",
    "0f739b2f.xyz",
    "0fcftwpreu5qvxlnreu5201.com",
    "0fit2z.com",
    "0fru8te0xkgfptti.cf",
    "0fru8te0xkgfptti.ga",
    "0fru8te0xkgfptti.gq",
    "0fru8te0xkgfptti.ml",
    "0fru8te0xkgfptti.tk",
    "0gag.com",
    "0gf.com",
    "0havda.us",
    "0hboy.com",
    "0hcow.com",
    "0hdear.com",
    "0hdxlk.us",
    "0hio.net",
    "0hio.org",
    "0hio0ak.com",
    "0hiolce.com",
    "0hioln.com",
    "0hxoea.us",
    "0i5cjq.us",
    "0icdes.us",
    "0igxcd.us",
    "0ils.net",
    "0ils.org",
    "0ioi.net",
    "0ito9e.us",
    "0iz891s1c1whvw0.xyz",
    "0izyq.us",
    "0jralz2qipvmr3n.ga",
    "0jralz2qipvmr3n.ml",
    "0jralz2qipvmr3n.tk",
    "0jylaegwalss9m6ilvq.cf",
    "0jylaegwalss9m6ilvq.ga",
    "0jylaegwalss9m6ilvq.gq",
    "0jylaegwalss9m6ilvq.ml",
    "0jylaegwalss9m6ilvq.tk",
    "0kj4.us",
    "0kok.net",
    "0kok.org",
    "0l87d.com",
    "0lbs.com",
    "0ld0ak.com",
    "0ld0x.com",
    "0live.org",
    "0lm.com",
    "0lsta7.us",
    "0mel.com",
    "0mfs0mxufjpcfc.cf",
    "0mfs0mxufjpcfc.ga",
    "0mfs0mxufjpcfc.gq",
    "0mfs0mxufjpcfc.ml",
    "0mfs0mxufjpcfc.tk",
    "0mixmail.info",
    "0n0ff.net",
    "0nb9zti01sgz8u2a.cf",
    "0nb9zti01sgz8u2a.ga",
    "0nb9zti01sgz8u2a.gq",
    "0nb9zti01sgz8u2a.ml",
    "0nb9zti01sgz8u2a.tk",
    "0nce.net",
    "0ne0ak.com",
    "0ne0ut.com",
    "0ne3qc.us",
    "0nedrive.cf",
    "0nedrive.ga",
    "0nedrive.gq",
    "0nedrive.ml",
    "0nedrive.tk",
    "0nelce.com",
    "0nes.net",
    "0nes.org",
    "0nlinetovar.ru",
    "0nly.org",
    "0nrg.com",
    "0nshwb.club",
    "0nshwb.online",
    "0oxgvfdufyydergd.cf",
    "0oxgvfdufyydergd.ga",
    "0oxgvfdufyydergd.gq",
    "0oxgvfdufyydergd.ml",
    "0oxgvfdufyydergd.tk",
    "0penhouse.com",
    "0peo0pe0.shop",
    "0pkgbj.host",
    "0place.org",
    "0qaakx.info",
    "0r0wfuwfteqwmbt.cf",
    "0r0wfuwfteqwmbt.ga",
    "0r0wfuwfteqwmbt.gq",
    "0r0wfuwfteqwmbt.ml",
    "0r0wfuwfteqwmbt.tk",
    "0rdered.com",
    "0rdering.com",
    "0regon.net",
    "0regon.org",
    "0ryjm.us",
    "0seav.com",
    "0sg.net",
    "0sp.me",
    "0swvak.us",
    "0t5123enk41x6v8.xyz",
    "0t6bsc.us",
    "0t9dl4.us",
    "0tct.icu",
    "0th-world.com",
    "0th-world.net",
    "0th-world.org",
    "0tinak9zyvf.cf",
    "0tinak9zyvf.ga",
    "0tinak9zyvf.gq",
    "0tinak9zyvf.ml",
    "0tinak9zyvf.tk",
    "0tk8a3a1q4t94.space",
    "0tl.org",
    "0to6oiry4ghhscmlokt.cf",
    "0to6oiry4ghhscmlokt.ga",
    "0to6oiry4ghhscmlokt.gq",
    "0to6oiry4ghhscmlokt.ml",
    "0to6oiry4ghhscmlokt.tk",
    "0u.ro",
    "0ub2je.us",
    "0utln.com",
    "0uxpgdvol9n.cf",
    "0uxpgdvol9n.ga",
    "0uxpgdvol9n.gq",
    "0uxpgdvol9n.ml",
    "0uxpgdvol9n.tk",
    "0v.ro",
    "0w.ro",
    "0wenku.com",
    "0wmfq2.us",
    "0wnd.net",
    "0wnd.org",
    "0wos8czt469.ga",
    "0wos8czt469.gq",
    "0wos8czt469.tk",
    "0x00.name",
    "0x000.cf",
    "0x000.ga",
    "0x000.gq",
    "0x000.ml",
    "0x01.gq",
    "0x01.tk",
    "0x02.cf",
    "0x02.ga",
    "0x02.gq",
    "0x02.ml",
    "0x02.tk",
    "0x03.cf",
    "0x03.ga",
    "0x03.gq",
    "0x03.ml",
    "0x03.tk",
    "0x207.info",
    "0x7121.com",
    "0xcafebabe.com",
    "0xpomn.us",
    "0ye1sg.us",
    "0za7vhxzpkd.cf",
    "0za7vhxzpkd.ga",
    "0za7vhxzpkd.gq",
    "0za7vhxzpkd.ml",
    "0za7vhxzpkd.tk",
    "0zc7eznv3rsiswlohu.cf",
    "0zc7eznv3rsiswlohu.ml",
    "0zc7eznv3rsiswlohu.tk",
    "0zspgifzbo.cf",
    "0zspgifzbo.ga",
    "0zspgifzbo.gq",
    "0zspgifzbo.ml",
    "0zspgifzbo.tk",
    "1-3-3-7.net",
    "1-8.biz",
    "1-800-bajafun.com",
    "1-800-cuba-info.com",
    "1-800-free-spirit.com",
    "1-800-rockies.com",
    "1-800-ski-deal.com",
    "1-800-ski-europe.com",
    "1-up.cf",
    "1-up.ga",
    "1-up.gq",
    "1-up.ml",
    "1-up.tk",
    "1-w.net",
    "1.atm-mi.cf",
    "1.atm-mi.ga",
    "1.atm-mi.gq",
    "1.atm-mi.ml",
    "1.atm-mi.tk",
    "1.batikbantul.com",
    "1.kerl.cf",
    "1.localaddres.com",
    "1.sheikhdailyshop.com",
    "10-minuten-mail.de",
    "10.dns-cloud.net",
    "1000.frecciarossa.tk",
    "100008544398863.online",
    "1000kti.xyz",
    "1000maketov.ru",
    "1000rebates.stream",
    "1000segodnia.ru",
    "100101.ru",
    "1001onlinegames.com",
    "1004net.shop",
    "1004toon.shop",
    "1007920195136.icu",
    "100b.live",
    "100b.site",
    "100bet.online",
    "100bet.store",
    "100bet.xyz",
    "100beteto.com",
    "100bets.pro",
    "100biz.ru",
    "100cd.com",
    "100exchange.ru",
    "100female.ru",
    "100guanya.com",
    "100hot.ru",
    "100kkk.ru",
    "100kti.xyz",
    "100likers.com",
    "100meterdash.com",
    "100percentlegal.com",
    "100percentlegal.net",
    "100percentlegal.org",
    "100pet.ru",
    "100projets.com",
    "100ra-design.ru",
    "100stul.ru",
    "100timebet.com",
    "100vesov24.ru",
    "100xbet.com",
    "10100.ml",
    "101027.xyz",
    "1010vision.com",
    "10147.monster",
    "10158a.com",
    "101c62b.club",
    "101cs.ru",
    "101ead9a74b8.club",
    "101price.co",
    "101reasonstoquit.com",
    "101searchen.com",
    "101todaynews.site",
    "1020986532.info",
    "102508.icu",
    "102comfort.site",
    "102ndarmyband.com",
    "102pc.site",
    "102pinbahis.com",
    "1033edge.com",
    "1034493459167.online",
    "1034productions.com",
    "104pinbahis.com",
    "1050.gq",
    "105427.com",
    "105459.com",
    "105472.com",
    "105554.com",
    "10562.app",
    "10564.app",
    "10565.app",
    "10568.app",
    "10569.app",
    "1056windtreetrace.com",
    "105kg.ru",
    "1069wjrj.com",
    "10746.monster",
    "107dronewaiver.com",
    "107punto7.com",
    "10bet881088.com",
    "10bwy.space",
    "10cafe.ru",
    "10fpjo.us",
    "10g.pl",
    "10host.top",
    "10kilo.us",
    "10launcheds.com",
    "10m.in",
    "10mail.com",
    "10mail.org",
    "10mi.org",
    "10minut.com.pl",
    "10minut.xyz",
    "10minute-email.com",
    "10minute.cf",
    "10minutemail.be",
    "10minutemail.cf",
    "10minutemail.co.uk",
    "10minutemail.co.za",
    "10minutemail.com",
    "10minutemail.de",
    "10minutemail.ga",
    "10minutemail.gq",
    "10minutemail.info",
    "10minutemail.ml",
    "10minutemail.net",
    "10minutemail.nl",
    "10minutemail.org",
    "10minutemail.pl",
    "10minutemail.pro",
    "10minutemail.ru",
    "10minutemail.us",
    "10minutemail2.com",
    "10minutemailbox.com",
    "10minutemails.in",
    "10minutenemail.de",
    "10minutesmail.com",
    "10minutesmail.fr",
    "10minutesmail.net",
    "10minutesmail.ru",
    "10minutetempemail.com",
    "10minutmail.pl",
    "10mldl2020.com",
    "10mt.cc",
    "10panx.com",
    "10star.app",
    "10star.casino",
    "10star.events",
    "10star.football",
    "10star.hockey",
    "10star.how",
    "10star.partners",
    "10star.services",
    "10star.soccer",
    "10star.solutions",
    "10star.systems",
    "10star.tools",
    "10star.wiki",
    "10stupidestmistakes.com",
    "10tasty.com",
    "10th-market-shopp.online",
    "10vitalya.fun",
    "10vpn.info",
    "10x.es",
    "10x10-bet.com",
    "10x10.bet",
    "10x9.com",
    "10xbet.org",
    "10xtaas.com",
    "11-32.cf",
    "11-32.ga",
    "11-32.gq",
    "11-32.ml",
    "11-32.tk",
    "1108885.com",
    "1108897.com",
    "111000.shop",
    "11111.ru",
    "11113339.com",
    "111159129.buzz",
    "1111homes.com",
    "111206.cc",
    "11141z.com",
    "11163.com",
    "1119837.com",
    "111btbt.com",
    "111bubu.com",
    "111hhhh.com",
    "111iiii.com",
    "111lulu.com",
    "111pupu.com",
    "111vt.com",
    "11216812520.com",
    "112211111.com",
    "112288211.com",
    "1122fa.info",
    "11277hd.com",
    "11277jgj.com",
    "11296.monster",
    "112f.net",
    "112soeks.ru",
    "11314.monster",
    "113388211.com",
    "113nu.com",
    "113wo.com",
    "113yo.com",
    "113zi.com",
    "114207.com",
    "114dianying5.xyz",
    "115588211.com",
    "115mo.com",
    "115nu.com",
    "115ou.com",
    "115su.com",
    "116ss.com",
    "117.yyolf.net",
    "117788211.com",
    "1177d.com",
    "11974.monster",
    "119988211.com",
    "119mail.com",
    "119winter.com",
    "11ant.org",
    "11cows.com",
    "11fortune.com",
    "11hg.app",
    "11hg.bet",
    "11hhqp.com",
    "11himchistka.ru",
    "11mail.com",
    "11mot.ru",
    "11ngu01.fun",
    "11ngu02.fun",
    "11ngu04.fun",
    "11ngu05.fun",
    "11tn.xyz",
    "11top.xyz",
    "11trafsfdmn.club",
    "11vitalya.icu",
    "11yh.app",
    "12001.net",
    "120mail.com",
    "120wenyi.com",
    "121ac.com",
    "123-m.com",
    "123-weight-loss.com",
    "123.com",
    "123.dns-cloud.net",
    "123.insure",
    "1231247.com",
    "1231253.com",
    "1231254.com",
    "1231266.com",
    "1234567.website",
    "123456798.xyz",
    "1234liuhe.com",
    "1236456.com",
    "1239827.com",
    "123anddone.com",
    "123box.net",
    "123erfgb.xyz",
    "123fsb.com",
    "123fxtrading.com",
    "123gal.com",
    "123india.com",
    "123kid.club",
    "123kissanime.net",
    "123mail.cl",
    "123mail.dk",
    "123mail.net",
    "123mail.org",
    "123movies-to.xyz",
    "123moviesfree.one",
    "123moviesonline.club",
    "123moviesweb.com",
    "123parfemy.sk",
    "123qwe.co.uk",
    "123tlv.com",
    "123w321.ru",
    "123win.club",
    "123worldcup.com",
    "124033.com",
    "12488aaa.com",
    "12488bbb.com",
    "12488cc.com",
    "12488ccc.com",
    "12499aaa.com",
    "12499bb.com",
    "12499bbb.com",
    "12499cc.com",
    "12499ccc.com",
    "125-jahre-kudamm.de",
    "1257.website",
    "125av.net",
    "125mail.cf",
    "125mail.ga",
    "125mail.gq",
    "125mail.ml",
    "125mail.tk",
    "126.cn",
    "126.com",
    "126.net",
    "12602.monster",
    "126game.com",
    "126mali.cn",
    "126ue.space",
    "12734.monster",
    "1281984.com",
    "1281988.com",
    "1281989.com",
    "128dewa.net",
    "128won.com",
    "12ab.info",
    "12bet247.mobi",
    "12clones.com",
    "12freebet.com",
    "12freeukisp.co.uk",
    "12fuel.dk",
    "12funnet.club",
    "12guitar.com",
    "12hosting.net",
    "12houremail.com",
    "12mail.dk",
    "12minutemail.com",
    "12minutemail.net",
    "12monkeystattoo.com",
    "12move.dk",
    "12ny.com",
    "12pkpk.xyz",
    "12playpoker.info",
    "12search.com",
    "12stelle.com",
    "12storage.com",
    "12voice.com",
    "13-stones.ru",
    "131009.com",
    "13195.monster",
    "131qs.com",
    "1333337.xyz",
    "1337.email",
    "1337xx.best",
    "133mail.cn",
    "135mail.cn",
    "13602.monster",
    "136889.com",
    "1373757.info",
    "137mail.cn",
    "13816.xyz",
    "138mail.com",
    "139.com",
    "13929973100.xyz",
    "13976448255.com",
    "139av.net",
    "13coin.ru",
    "13d940.xyz",
    "13dk.net",
    "13e0.xyz",
    "13fishing.ru",
    "13go.site",
    "13hsv.us",
    "13sasytkgb0qobwxat.cf",
    "13sasytkgb0qobwxat.ga",
    "13sasytkgb0qobwxat.gq",
    "13sasytkgb0qobwxat.ml",
    "13sasytkgb0qobwxat.tk",
    "140002.com",
    "140unichars.com",
    "1434f.xyz",
    "144206.com",
    "14546.monster",
    "145484.com",
    "1455a2.xyz",
    "146027.com",
    "147.cl",
    "1481650.xyz",
    "14895.monster",
    "149356.com",
    "149827.com",
    "149837.com",
    "14dayshift.com",
    "14ersposter.com",
    "14f992.xyz",
    "14hgf.us",
    "14n.co.uk",
    "14nikatro.ru",
    "14richiefamous.ru",
    "14ru.com",
    "15057722.com",
    "15057755.com",
    "15057777.com",
    "15057799.com",
    "150bc.com",
    "150mail.com",
    "150ml.com",
    "151qs.com",
    "15207.xyz",
    "1531188.net",
    "153369.com",
    "1534625231.xyz",
    "15349.monster",
    "154884.com",
    "156ac.com",
    "156mail.cn",
    "157mail.cn",
    "1580887.com",
    "1581232.com",
    "1581235.com",
    "1581686.com",
    "158av.net",
    "158dj44.com",
    "158dj55.com",
    "158mail.cn",
    "15906.site",
    "15907.site",
    "15910.site",
    "15asia.com",
    "15darkyears.com",
    "15meg4free.com",
    "15qm-mail.red",
    "15qm.com",
    "1600daily.news",
    "1601617.com",
    "1601619.com",
    "1601628.com",
    "1601629.com",
    "1601646.com",
    "1601654.com",
    "1601656.com",
    "160899.com",
    "160by2.com",
    "161332.com",
    "16178.monster",
    "161936.com",
    "161aaa161.com",
    "161cc161.com",
    "161ee161.com",
    "161fff161.com",
    "161gg161.com",
    "161ii161.com",
    "161jjj161.com",
    "161ooo161.com",
    "161uu161.com",
    "161yyy161.com",
    "1621188.net",
    "163.com",
    "163gx.site",
    "16401.monster",
    "16443.monster",
    "16626.monster",
    "166ac.com",
    "1676.ru",
    "168.com",
    "168.net",
    "1687300.com",
    "16888star.com",
    "168bfo.com",
    "168hy.xyz",
    "168vegus.net",
    "168wbtoto3.club",
    "16b33d.club",
    "16didi.com",
    "16ik7egctrkxpn9okr.ga",
    "16ik7egctrkxpn9okr.ml",
    "16ik7egctrkxpn9okr.tk",
    "16kilogramm.ru",
    "16mail.com",
    "16up.ru",
    "1700599.com",
    "1716000.app",
    "171611.app",
    "171612.app",
    "171616.app",
    "171621.app",
    "171625.app",
    "171626.app",
    "171629.app",
    "171630.app",
    "171631.app",
    "171634.app",
    "171635.app",
    "171637.app",
    "171640.app",
    "171641.app",
    "171644.app",
    "171646.app",
    "171648.app",
    "171650.app",
    "1716555.app",
    "1716666.app",
    "1716888.app",
    "1716aaa.com",
    "1716bbb.com",
    "1716jjj.com",
    "1716kkk.com",
    "1716lll.com",
    "1716www.com",
    "1716xxx.com",
    "174podarka.ru",
    "1756bb.com",
    "1766258.com",
    "1768aa.com",
    "1769022.com",
    "1769050.com",
    "1769070.com",
    "1769113.com",
    "1769117.com",
    "1769220.com",
    "1769221.com",
    "1769225.com",
    "1769300.com",
    "1769330.com",
    "1769337.com",
    "1769553.com",
    "1769660.com",
    "1769779.com",
    "1769aaa.com",
    "1769bbs.com",
    "1769blog.com",
    "1769book.com",
    "1769ccc.com",
    "1769f.com",
    "1769fff.com",
    "1769h.com",
    "1769kk.com",
    "1769ll.com",
    "1769mp4.com",
    "1769sss.com",
    "1769t.com",
    "1769www.com",
    "1769yy.com",
    "1771716.com",
    "1771719.com",
    "1771724.com",
    "1771727.com",
    "1771745.com",
    "1776patriotsupportonline.com",
    "178fo.com",
    "178mem94.monster",
    "179bet.club",
    "17adh.xyz",
    "17co3x74.xyz",
    "17goals.live",
    "17heixiu.com",
    "17moa01.com",
    "18-19.cf",
    "18-19.ga",
    "18-19.gq",
    "18-19.ml",
    "18-19.tk",
    "18-9-2.cf",
    "18-9-2.ga",
    "18-9-2.gq",
    "18-9-2.ml",
    "18-9-2.tk",
    "1800033.com",
    "1800doorpros.com",
    "1800formybaby.com",
    "182100.ru",
    "1824p.com",
    "1824q.com",
    "1824t.com",
    "1824u.com",
    "18273.monster",
    "1831188.net",
    "183carlton.changeip.net",
    "18408180x38.xyz",
    "184717.site",
    "185ac.com",
    "1871188.net",
    "1877production.com",
    "188.com",
    "1881182.com",
    "1881185.com",
    "188133756.ru",
    "1881684.com",
    "1888547.com",
    "1888564.com",
    "188881-e.com",
    "188881-g.com",
    "188881-k.com",
    "188881-p.com",
    "188881-s.com",
    "188881-u.com",
    "188881-y.com",
    "188betqq.com",
    "188indobet.me",
    "188ku.club",
    "188mbsport.net",
    "188xin.com",
    "189.cn",
    "1891188.net",
    "18acabfd.club",
    "18am.ru",
    "18clubin.com",
    "18clubtw.com",
    "18dealblast.com",
    "18dealscash.com",
    "18dno.site",
    "18e95e9.xyz",
    "18moa10.net",
    "18pic.com",
    "18sotok.ru",
    "18x18x.com",
    "18xapp.com",
    "18xtv.com",
    "19-crimes.ru",
    "190326start.website",
    "1913qipai.com",
    "191ac.com",
    "19216811.host",
    "19292.monster",
    "193029.com",
    "193120.ru",
    "193283.com",
    "1935hurricane.com",
    "194kg7.com",
    "195kai.com",
    "196206.com",
    "196ks.com",
    "198208.com",
    "1984tee.com",
    "19879.monster",
    "1991955.com",
    "1991956.com",
    "1991957.com",
    "1991958.com",
    "1991959.com",
    "1991972.com",
    "1991973.com",
    "19922.cf",
    "19922.ga",
    "19922.gq",
    "19922.ml",
    "1998g.com",
    "1999buy.com",
    "199accessories.com",
    "199cases.com",
    "19f6cop53ghzrys.xyz",
    "19kysg.ru",
    "19q.ru",
    "1abvote.com",
    "1afbwqtl8bcimxioz.cf",
    "1afbwqtl8bcimxioz.ga",
    "1afbwqtl8bcimxioz.gq",
    "1afbwqtl8bcimxioz.ml",
    "1afbwqtl8bcimxioz.tk",
    "1airpods.ru",
    "1amdevsites.xyz",
    "1ankh0ngthebjetdc.space",
    "1ano.gratis",
    "1aolmail.com",
    "1apviz.com",
    "1asexchat.com",
    "1aujk9.host",
    "1auto.com",
    "1ayj8yi7lpiksxawav.cf",
    "1ayj8yi7lpiksxawav.ga",
    "1ayj8yi7lpiksxawav.gq",
    "1ayj8yi7lpiksxawav.ml",
    "1ayj8yi7lpiksxawav.tk",
    "1bahisno1.com",
    "1bedpage.com",
    "1biyabet2020.com",
    "1bizshop.ru",
    "1blackmoon.com",
    "1blueymail.gq",
    "1bola88.com",
    "1bola88.social",
    "1bolaku.biz",
    "1bolaku.club",
    "1bolaku88.com",
    "1bstb.ru",
    "1bthd.com",
    "1bup.com",
    "1bxaepy68dgiz63.xyz",
    "1c-spec.ru",
    "1caa4c.club",
    "1cdds.ru",
    "1ce.us",
    "1centdruck.com",
    "1chan.club",
    "1chelper.site",
    "1chuan.com",
    "1ckursy.ru",
    "1claud.site",
    "1clck2.com",
    "1clou.site",
    "1club4d.com",
    "1clublive.com",
    "1clubpoker.com",
    "1clubslot.com",
    "1cmmit.ru",
    "1colony.com",
    "1coolplace.com",
    "1cost.ru",
    "1cp3tnzok0nyr4t.xyz",
    "1d1c.com",
    "1d6c.club",
    "1dask-raxe.ru",
    "1dmedical.com",
    "1drive.cf",
    "1drive.ga",
    "1drive.gq",
    "1dv37p.info",
    "1dxcme.us",
    "1e4e4b.xyz",
    "1e72.com",
    "1e80.com",
    "1email.eu",
    "1email.ru",
    "1errz9femsvhqao6.cf",
    "1errz9femsvhqao6.ga",
    "1errz9femsvhqao6.gq",
    "1errz9femsvhqao6.ml",
    "1errz9femsvhqao6.tk",
    "1euqhmw9xmzn.cf",
    "1euqhmw9xmzn.ga",
    "1euqhmw9xmzn.gq",
    "1euqhmw9xmzn.ml",
    "1euqhmw9xmzn.tk",
    "1eyedg.com",
    "1f4.xyz",
    "1fa2b.club",
    "1fatbitch.com",
    "1feb3.club",
    "1forthemoney.com",
    "1freeemail.com",
    "1fsdfdsfsdf.tk",
    "1funplace.com",
    "1fv.info",
    "1game.store",
    "1gdaily-profit.site",
    "1ghtyu.com",
    "1gi.info",
    "1googlemail.com",
    "1gsn.us",
    "1hdbt.com",
    "1hdd.site",
    "1hi.info",
    "1hiphopfan.com",
    "1hmoxs72qd.cf",
    "1hmoxs72qd.ga",
    "1hmoxs72qd.ml",
    "1hmoxs72qd.tk",
    "1hp0x.us",
    "1hsoagca2euowj3ktc.ga",
    "1hsoagca2euowj3ktc.gq",
    "1hsoagca2euowj3ktc.ml",
    "1hsoagca2euowj3ktc.tk",
    "1ifawc.com",
    "1internetdrive.com",
    "1intimshop.ru",
    "1itsoft.site",
    "1jutakg.com",
    "1kmnorff.com",
    "1kues.info",
    "1l24ac.us",
    "1l9fd.us",
    "1letras.info",
    "1liqu1d.gq",
    "1lp7j.us",
    "1lv.in",
    "1lvt220yzdgn5z1.xyz",
    "1lwr.us",
    "1mail.ml",
    "1mail.net",
    "1mail.uk.to",
    "1mail.x24hr.com",
    "1manbet.info",
    "1marsbet.com",
    "1me.net",
    "1metr.info",
    "1minutemedia.com",
    "1mport.ru",
    "1mqn2g.host",
    "1mspkvfntkn9vxs1oit.cf",
    "1mspkvfntkn9vxs1oit.ga",
    "1mspkvfntkn9vxs1oit.gq",
    "1mspkvfntkn9vxs1oit.ml",
    "1mspkvfntkn9vxs1oit.tk",
    "1mum.com",
    "1musicrow.com",
    "1mz.com",
    "1mz.net",
    "1n220ei4n58hht0.xyz",
    "1n2us.us",
    "1nb7.icu",
    "1nenod.xyz",
    "1netdrive.com",
    "1noc0w.info",
    "1nsyncfan.com",
    "1num.ru",
    "1nut.com",
    "1o4nww.us",
    "1oh1.com",
    "1oim.ru",
    "1oooo.ru",
    "1p6yx8.us",
    "1pad.de",
    "1pap-company.buzz",
    "1pay-o.club",
    "1pay-s.club",
    "1pay1mypay.ru",
    "1paymy1pay.ru",
    "1persian360.site",
    "1pervd.us",
    "1pfeyw.us",
    "1pi.org",
    "1pmok.site",
    "1pornin.xyz",
    "1printkazan.ru",
    "1pt.net",
    "1pw8qy.us",
    "1qpatglchm1.cf",
    "1qpatglchm1.ga",
    "1qpatglchm1.gq",
    "1qpatglchm1.ml",
    "1qpatglchm1.tk",
    "1r7bsm.us",
    "1rentcar.top",
    "1rererer.ru",
    "1rmgqwfno8wplt.cf",
    "1rmgqwfno8wplt.ga",
    "1rmgqwfno8wplt.gq",
    "1rmgqwfno8wplt.ml",
    "1rmgqwfno8wplt.tk",
    "1rnydobtxcgijcfgl.cf",
    "1rnydobtxcgijcfgl.ga",
    "1rnydobtxcgijcfgl.gq",
    "1rnydobtxcgijcfgl.ml",
    "1rnydobtxcgijcfgl.tk",
    "1roff.site",
    "1rzk1ufcirxtg.ga",
    "1rzk1ufcirxtg.ml",
    "1rzk1ufcirxtg.tk",
    "1rzpdv6y4a5cf5rcmxg.cf",
    "1rzpdv6y4a5cf5rcmxg.ga",
    "1rzpdv6y4a5cf5rcmxg.gq",
    "1rzpdv6y4a5cf5rcmxg.ml",
    "1rzpdv6y4a5cf5rcmxg.tk",
    "1s.fr",
    "1s1uasxaqhm9.cf",
    "1s1uasxaqhm9.ga",
    "1s1uasxaqhm9.gq",
    "1s1uasxaqhm9.ml",
    "1s1uasxaqhm9.tk",
    "1scr.ru",
    "1secmail.com",
    "1secmail.net",
    "1secmail.org",
    "1secmail.xyz",
    "1sheshobet.site",
    "1shivom.com",
    "1soq14.club",
    "1soq14.online",
    "1spcziorgtfpqdo.cf",
    "1spcziorgtfpqdo.ga",
    "1spcziorgtfpqdo.gq",
    "1spcziorgtfpqdo.ml",
    "1spcziorgtfpqdo.tk",
    "1sport7.com",
    "1sport7.org",
    "1ss.noip.me",
    "1st-forms.com",
    "1stadhouderskade.com",
    "1stcallsecurity.com",
    "1stcircuit.com",
    "1stcommercialrealty.com",
    "1sthandfoundation.org",
    "1stimme1schritt.com",
    "1stoffer.com",
    "1stopbeautyshop.com",
    "1ststepdetoxcenter.net",
    "1sydney.net",
    "1ta.org",
    "1tasvegas.club",
    "1thecity.biz",
    "1to1mail.org",
    "1tware.com",
    "1tyc222.com",
    "1u3.ru",
    "1u6hqr.us",
    "1under.com",
    "1up.orangotango.gq",
    "1upcyber.com",
    "1usemail.com",
    "1utk81n8xa0p5ue.xyz",
    "1vt.com",
    "1vvb.ru",
    "1wanbet.info",
    "1webave.com",
    "1webhighway.com",
    "1webmail.info",
    "1website.net",
    "1weirdfood.com",
    "1wgapljizpfn3f1.xyz",
    "1wk.site",
    "1x2.run",
    "1x3.download",
    "1xbeet90.org",
    "1xbet-1bet.site",
    "1xbet-web-cm.net",
    "1xbets-bk-onlines.ru",
    "1xbkbet.com",
    "1xgolxdbxt.online",
    "1xkfe3oimup4gpuop.cf",
    "1xkfe3oimup4gpuop.ga",
    "1xkfe3oimup4gpuop.gq",
    "1xkfe3oimup4gpuop.ml",
    "1xkfe3oimup4gpuop.tk",
    "1xnwh.host",
    "1xowua.site",
    "1xstabka.ru",
    "1xstats.com",
    "1xstavka-app.ru",
    "1xy86py.top",
    "1ybm5.us",
    "1zaem.ru",
    "1zc.info",
    "1zd.info",
    "1zhuan.com",
    "1zl.org",
    "1zxzhoonfaia3.cf",
    "1zxzhoonfaia3.ga",
    "1zxzhoonfaia3.gq",
    "1zxzhoonfaia3.ml",
    "1zxzhoonfaia3.tk",
    "2-bee.tk",
    "2-ch.space",
    "2-l.net",
    "2-mail.com",
    "2-zatona.ru",
    "2.0-00.usa.cc",
    "2.batikbantul.com",
    "2.chatpuffs.pro",
    "2.emailfake.ml",
    "2.kerl.cf",
    "2.mmspa.cf",
    "2.pl",
    "2.safemail.cf",
    "2.safemail.tk",
    "2.sexymail.ooo",
    "2.tebwinsoi.ooo",
    "20.dns-cloud.net",
    "2000rebates.stream",
    "2002mm01.fun",
    "2002mm02.fun",
    "2002mm04.fun",
    "2002mm05.fun",
    "200555.com",
    "200740534.xyz",
    "200ok.ru",
    "2012-2016.ru",
    "2012-2019-compensac.site",
    "2013spmd.ru",
    "2014mail.ru",
    "2018-12-23.ga",
    "20181141916151820.com",
    "201813143.com",
    "2019-hydra.com",
    "2019-pozdravleniya.ru",
    "201910031.com",
    "201910032.com",
    "201910041.com",
    "201910042.com",
    "201910044.com",
    "201910055.com",
    "201910056.com",
    "201910066.com",
    "201910068.com",
    "201910073.com",
    "201910077.com",
    "201910078.com",
    "201910082.com",
    "201910083.com",
    "201910086.com",
    "201910093.com",
    "201910094.com",
    "201910095.com",
    "201910162.com",
    "201920047.com",
    "201920054.com",
    "201920065.com",
    "201920100.com",
    "201920103.com",
    "201920108.com",
    "201920110.com",
    "201920113.com",
    "201920116.com",
    "201920119.com",
    "2019x.cf",
    "2019x.ga",
    "2019x.gq",
    "2019x.ml",
    "2019y.cf",
    "2019y.ga",
    "2019y.gq",
    "2019y.ml",
    "2019z.cf",
    "2019z.ga",
    "2019z.gq",
    "2019z.ml",
    "2019z.tk",
    "2020-ford-bronco.com",
    "202064.net",
    "2020ads01.xyz",
    "2020ads03.xyz",
    "2020bearmarket.com",
    "2020yy.net",
    "20218037.com",
    "20223339.com",
    "20258037.com",
    "20268037.com",
    "20288037.com",
    "202qs.com",
    "20303.host",
    "20344445.com",
    "20368037.com",
    "2044445.com",
    "204qs.com",
    "2051333.ru",
    "2054445.com",
    "2061144.com",
    "2061177.com",
    "206154.com",
    "206156.com",
    "206163.com",
    "206164.com",
    "206167.com",
    "206169.com",
    "206176.com",
    "206182.com",
    "206206206.com",
    "206214.com",
    "206224.com",
    "206241.com",
    "206242.com",
    "206243.com",
    "206244.com",
    "206254.com",
    "206261.com",
    "206267.com",
    "206274.com",
    "206304.com",
    "206305.com",
    "206314.com",
    "206324.com",
    "206340.com",
    "206361.com",
    "206367.com",
    "206372.com",
    "206374.com",
    "206376.com",
    "206385.com",
    "206422.com",
    "206423.com",
    "206424.com",
    "206427.com",
    "206438.com",
    "206439.com",
    "2064445.com",
    "206490.com",
    "206514.com",
    "206516.com",
    "206526.com",
    "206534.com",
    "206536.com",
    "206541.com",
    "206547.com",
    "206561.com",
    "206576.com",
    "206584.com",
    "206617.com",
    "206637.com",
    "206701.com",
    "206704.com",
    "206716.com",
    "206726.com",
    "206736.com",
    "206740.com",
    "206748.com",
    "206757.com",
    "206762.com",
    "206763.com",
    "206773.com",
    "206790.com",
    "206802.com",
    "206806.com",
    "206810.com",
    "206816.com",
    "206817.com",
    "206827.com",
    "206830.com",
    "206834.com",
    "206836.com",
    "206841.com",
    "206847.com",
    "206854.com",
    "206859.com",
    "206860.com",
    "206871.com",
    "206873.com",
    "206890.com",
    "206891.com",
    "206892.com",
    "206894.com",
    "206896.com",
    "206897.com",
    "206901.com",
    "206907.com",
    "206912.com",
    "206917.com",
    "206921.com",
    "206923.com",
    "206925.com",
    "206926.com",
    "206927.com",
    "206930.com",
    "206932.com",
    "206942.com",
    "206945.com",
    "206947.com",
    "206948.com",
    "206953.com",
    "206954.com",
    "206956.com",
    "206961.com",
    "206962.com",
    "206963.com",
    "206971.com",
    "206973.com",
    "206975.com",
    "206ddd.com",
    "206fff.com",
    "206hhh.com",
    "206iii.com",
    "206j.net",
    "206jjj.com",
    "206m.net",
    "206n.net",
    "206o.net",
    "206ooo.com",
    "206ppp.com",
    "206q.net",
    "206qqq.com",
    "206rrr.com",
    "206s.net",
    "206vvv.com",
    "206w.net",
    "206x.net",
    "206yth.net",
    "2074445.com",
    "20760.monster",
    "2079shipin.xyz",
    "207am.com",
    "2084-antiutopia.ru",
    "209179.site",
    "2094445.com",
    "209827.com",
    "20abc.ru",
    "20b8d52d.club",
    "20bit.ru",
    "20boxme.org",
    "20daysof.com",
    "20email.eu",
    "20email.it",
    "20german.online",
    "20hsolutions.com",
    "20mail.eu",
    "20mail.in",
    "20mail.it",
    "20min.email",
    "20minute.email",
    "20minutemail.com",
    "20minutemail.it",
    "20mm.eu",
    "20nastya.press",
    "20nastya.tech",
    "20sep.net",
    "20sep.online",
    "20september.online",
    "20wolff.xyz",
    "20yeye.com",
    "21047.monster",
    "21081.monster",
    "2109827.com",
    "210ms.com",
    "211153079.buzz",
    "211157563.buzz",
    "211158710.buzz",
    "211319.xyz",
    "211379.xyz",
    "211619.xyz",
    "212.com",
    "2120001.net",
    "2124445.com",
    "21266.monster",
    "2127.info",
    "212812.com",
    "212912.com",
    "213269.xyz",
    "2134445.com",
    "213969.xyz",
    "213989.xyz",
    "2140884843zll.xyz",
    "2144445.com",
    "21451.xyz",
    "2147483648.com",
    "215329.xyz",
    "215369.xyz",
    "215529.xyz",
    "215579.xyz",
    "215679.xyz",
    "215779.xyz",
    "215819.xyz",
    "215829.xyz",
    "215839.xyz",
    "215859.xyz",
    "215889.xyz",
    "215969.xyz",
    "215979.xyz",
    "216169.xyz",
    "216179.xyz",
    "216219.xyz",
    "216239.xyz",
    "216259.xyz",
    "2164445.com",
    "216539.xyz",
    "216559.xyz",
    "216636.com",
    "216729.xyz",
    "216959.xyz",
    "2174445.com",
    "217lll.com",
    "2184445.com",
    "2188019.com",
    "218bet.com",
    "2194445.com",
    "219ac.com",
    "21cn.com",
    "21cselling.com",
    "21gw.info",
    "21kky.club",
    "21lr12.cf",
    "21sp.xyz",
    "21stcenturyfitness.net",
    "21yyinsani.com",
    "22-bet.life",
    "22-bet.org",
    "22003.fun",
    "220088211.com",
    "22020.ru",
    "221188211.com",
    "2211m.com",
    "221921.com",
    "221ac.com",
    "221bnw15rt.com",
    "221zz.com",
    "222288211.com",
    "2222bienbet.com",
    "2225258.com",
    "2227728.com",
    "2229837.com",
    "222mmmm.com",
    "223388211.com",
    "2234445.com",
    "22443.monster",
    "224eee.com",
    "224hhh.com",
    "224lll.com",
    "224ppp.com",
    "224qs.com",
    "224sss.com",
    "224zzz.com",
    "225522.ml",
    "225588211.com",
    "22602.monster",
    "22613.xyz",
    "2264445.com",
    "226688211.com",
    "2266av.com",
    "2267pp.com",
    "2267vv.com",
    "2267xx.com",
    "2267yy.com",
    "2274445.com",
    "22794.com",
    "228581.com",
    "2288av.com",
    "229988211.com",
    "22aday-notok.info",
    "22aday-notok.mobi",
    "22ccf.com",
    "22eb.club",
    "22ffnrxk11oog.cf",
    "22ffnrxk11oog.ga",
    "22ffnrxk11oog.gq",
    "22ffnrxk11oog.tk",
    "22hg.app",
    "22hg.bet",
    "22hhqp.com",
    "22money.xyz",
    "22mot.ru",
    "22office.com",
    "22ov17gzgebhrl.cf",
    "22ov17gzgebhrl.gq",
    "22ov17gzgebhrl.ml",
    "22ov17gzgebhrl.tk",
    "22pesok.ru",
    "22stttn.xyz",
    "22xx33.xyz",
    "23037.monster",
    "2314445.com",
    "2323bryanstreet.com",
    "2334445.com",
    "2336900.com",
    "233bt.com",
    "233dy.com",
    "23403.monster",
    "23413.monster",
    "23423.ru",
    "2344445.com",
    "23445656.xyz",
    "234546764.xyz",
    "234567875.xyz",
    "234927.com",
    "234dhyjgj.com",
    "237367.com",
    "23791.monster",
    "238ac.com",
    "2394445.com",
    "239qs.com",
    "23all.com",
    "23f951.xyz",
    "23h4y.us",
    "23i9k.site",
    "23owqo5r.xyz",
    "23ox.xyz",
    "23pxdb.us",
    "23swap.site",
    "24-ex.ru",
    "240305.com",
    "24297.monster",
    "24337.xyz",
    "24408.monster",
    "244206.com",
    "244spencer.com",
    "246hltwog9utrzsfmj.cf",
    "246hltwog9utrzsfmj.ga",
    "246hltwog9utrzsfmj.gq",
    "246hltwog9utrzsfmj.ml",
    "246hltwog9utrzsfmj.tk",
    "247blog.com",
    "247emaildata.com",
    "247emails.com",
    "247prohost.com",
    "247web.net",
    "248790.com",
    "2488682.ru",
    "249827.com",
    "24betty.ru",
    "24cable.ru",
    "24cafe.ru",
    "24consulting.ru",
    "24ddw6hy4ltg.cf",
    "24ddw6hy4ltg.ga",
    "24ddw6hy4ltg.gq",
    "24ddw6hy4ltg.ml",
    "24ddw6hy4ltg.tk",
    "24facet.com",
    "24fitness.ru",
    "24hinbox.com",
    "24horas-aust.host",
    "24horas.com",
    "24hourmail.com",
    "24hourmail.net",
    "24hrcalladoctor.info",
    "24hrcallmd.info",
    "24hrphoneadoc.info",
    "24hrphoneamd.info",
    "24kcbd-plus.com",
    "24kcbd.net",
    "24kcbdplus.net",
    "24kinfused.com",
    "24mail.top",
    "24mail.xyz",
    "24medic-news.ru",
    "24na8.ru",
    "24news24.ru",
    "24online-marketing.ru",
    "24openlock.ru",
    "24prm.ru",
    "24repporter.ru",
    "24smartwatch.ru",
    "24tops.site",
    "24vlk.biz",
    "24vlk.link",
    "24vlk.xyz",
    "24volcano.net",
    "24vul-canm.com",
    "24vul-slot.net",
    "24x7daily.com",
    "24xj.us",
    "24youla.ru",
    "2511188.net",
    "2514445.com",
    "2524445.com",
    "252507.com",
    "2525bienbet.com",
    "252hg.com",
    "25310.monster",
    "2534445.com",
    "253lv.com",
    "253mo.com",
    "253ou.com",
    "253pu.com",
    "25419.monster",
    "25430044.com",
    "25430077.com",
    "25430268.com",
    "25431113.com",
    "25431115.com",
    "25431117.com",
    "25431118.com",
    "25431119.com",
    "25431120.com",
    "25431126.com",
    "25432233.com",
    "25433456.com",
    "25434455.com",
    "25436789.com",
    "25438.monster",
    "25438899.com",
    "2554445.com",
    "257379.xyz",
    "2574445.com",
    "25806.monster",
    "2584445.com",
    "2594445.com",
    "25betturka.com",
    "25comp.ru",
    "25fwlp1ih7av5ym.xyz",
    "25mails.com",
    "26032.monster",
    "2614445.com",
    "2621188.net",
    "262fo.com",
    "262gu.com",
    "262ju.com",
    "262lo.com",
    "262lv.com",
    "262pi.com",
    "262re.com",
    "26352.monster",
    "2635yy.com",
    "2636552.com",
    "263mali.cn",
    "26487.com",
    "2654445.com",
    "26564.xyz",
    "26581.monster",
    "265ac.com",
    "265ke.com",
    "265ne.com",
    "265re.com",
    "265sa.com",
    "26610.monster",
    "266ac.com",
    "2674445.com",
    "267918.com",
    "2694445.com",
    "269ac.com",
    "26c7.club",
    "26ca93.xyz",
    "26fuli.com",
    "26llxdhttjb.cf",
    "26llxdhttjb.ga",
    "26llxdhttjb.gq",
    "26llxdhttjb.ml",
    "26llxdhttjb.tk",
    "26m.net",
    "26mishki.ru",
    "26timebet.com",
    "26x8da.us",
    "271529.xyz",
    "2716ca.xyz",
    "271729.xyz",
    "271759.xyz",
    "27422.monster",
    "2750303.site",
    "2754445.com",
    "275ac.com",
    "275d.club",
    "2764445.com",
    "2774445.com",
    "27770.monster",
    "277782474.xyz",
    "2784445.com",
    "27850999.net",
    "278ac.com",
    "27911b.com",
    "27a169.xyz",
    "27casinox.com",
    "2802211.com",
    "2814445.com",
    "28177.monster",
    "2828766.com",
    "2834445.com",
    "283993.com",
    "2844.xyz",
    "284kf.com",
    "28572.monster",
    "2864445.com",
    "2880688.com",
    "2889188.com",
    "28c000.com",
    "28c0033.com",
    "28c0055.com",
    "28c0066.com",
    "28c0088.com",
    "28c11.com",
    "28c33.com",
    "28c333.com",
    "28c44.com",
    "28c555.com",
    "28c66.com",
    "28c777.com",
    "28c888.com",
    "28it.ru",
    "28musicbaran.us",
    "28onnae92bleuiennc1.cf",
    "28onnae92bleuiennc1.ga",
    "28onnae92bleuiennc1.gq",
    "28onnae92bleuiennc1.ml",
    "28onnae92bleuiennc1.tk",
    "28pc888.com",
    "28voma.info",
    "28z8d5fu7yyrdbg.xyz",
    "29007.monster",
    "291.usa.cc",
    "2911.net",
    "291q.com",
    "2924445.com",
    "292892.com",
    "2934445.com",
    "2944445.com",
    "2950d69b.xyz",
    "29530.xyz",
    "296969bb.com",
    "296969tt.com",
    "296969ww.com",
    "296969zz.com",
    "29753.monster",
    "2980.com",
    "2990303.ru",
    "29987.monster",
    "29hoki9.xyz",
    "29t3.com",
    "2a479bf8.club",
    "2ad66df3.club",
    "2adiamonds.com",
    "2adltw.us",
    "2aitycnhnno6.cf",
    "2aitycnhnno6.ga",
    "2aitycnhnno6.gq",
    "2aitycnhnno6.ml",
    "2aitycnhnno6.tk",
    "2all.xyz",
    "2and2mail.tk",
    "2anime.org",
    "2ankemthilamxao.space",
    "2anom.com",
    "2avz.net",
    "2babe.com",
    "2bcgxx.us",
    "2bestbet90.xyz",
    "2bi.ru",
    "2bin.ru",
    "2bmail.co.uk",
    "2bpgta.online",
    "2br.in",
    "2brutus.com",
    "2bucksagig.com",
    "2bussines.ru",
    "2buyshop.ru",
    "2bxapl.info",
    "2c0.net",
    "2c225.club",
    "2c2f494.club",
    "2cdof1.us",
    "2ch.coms.hk",
    "2ch.daemon.asia",
    "2ch.orgs.hk",
    "2china.site",
    "2ckf.com",
    "2cnlh.us",
    "2cny2bstqhouldn.cf",
    "2cny2bstqhouldn.ga",
    "2cny2bstqhouldn.gq",
    "2cny2bstqhouldn.ml",
    "2cny2bstqhouldn.tk",
    "2container.com",
    "2coolforyou.net",
    "2cpeerr.club",
    "2cpezrr.club",
    "2cy123.com",
    "2cyapp.com",
    "2cybbs.com",
    "2cyblog.com",
    "2cybt.com",
    "2cypan.com",
    "2cypic.com",
    "2cyshop.com",
    "2d-art.ru",
    "2d2i.com",
    "2d485c.club",
    "2dapp.com",
    "2dbt.com",
    "2detox.com",
    "2dfmail.ga",
    "2dfmail.ml",
    "2dfmail.tk",
    "2dgate.com",
    "2dge1.us",
    "2dgo.com",
    "2di9ul.us",
    "2die4.com",
    "2dku.com",
    "2edgklfs9o5i.cf",
    "2edgklfs9o5i.ga",
    "2edgklfs9o5i.gq",
    "2edgklfs9o5i.ml",
    "2edgklfs9o5i.tk",
    "2emailock.com",
    "2emea.com",
    "2eq8eaj32sxi.cf",
    "2eq8eaj32sxi.ga",
    "2eq8eaj32sxi.gq",
    "2eq8eaj32sxi.ml",
    "2eq8eaj32sxi.tk",
    "2ether.net",
    "2ewldu.us",
    "2f1fv16ljgb88nj.xyz",
    "2f5b8c.xyz",
    "2fat4me.com",
    "2fdgdfgdfgdf.tk",
    "2ffja3uf.agency",
    "2filmshd.online",
    "2fly.xyz",
    "2folddoor.com",
    "2fyba7.site",
    "2gbndigital.com",
    "2gear.ru",
    "2gep2ipnuno4oc.cf",
    "2gep2ipnuno4oc.ga",
    "2gep2ipnuno4oc.gq",
    "2gep2ipnuno4oc.ml",
    "2gep2ipnuno4oc.tk",
    "2getyou.com",
    "2go-mail.com",
    "2goodnews.site",
    "2gufaxhuzqt2g1h.cf",
    "2gufaxhuzqt2g1h.ga",
    "2gufaxhuzqt2g1h.gq",
    "2gufaxhuzqt2g1h.ml",
    "2gufaxhuzqt2g1h.tk",
    "2gurmana.ru",
    "2gvn.com",
    "2hackermail.com",
    "2hand.xyz",
    "2have.net",
    "2hg000.com",
    "2hg11.com",
    "2hg1111.com",
    "2hg15.com",
    "2hg16.com",
    "2hg17.com",
    "2hg18.com",
    "2hg19.com",
    "2hg22.com",
    "2hg333.com",
    "2hg4.com",
    "2hg55.com",
    "2hg555.com",
    "2hg99.com",
    "2hgw111.com",
    "2hgw22.com",
    "2hgw44.com",
    "2hgw444.com",
    "2hgw666.com",
    "2hgw999.com",
    "2hotforyou.net",
    "2houndsdesigns.com",
    "2hq5om.us",
    "2i3tjz.com",
    "2iikwltxabbkofa.cf",
    "2iikwltxabbkofa.ga",
    "2iikwltxabbkofa.gq",
    "2iikwltxabbkofa.ml",
    "2instagram.ru",
    "2iuzngbdujnf3e.cf",
    "2iuzngbdujnf3e.ga",
    "2iuzngbdujnf3e.gq",
    "2iuzngbdujnf3e.ml",
    "2iuzngbdujnf3e.tk",
    "2j06.buzz",
    "2jckh7.info",
    "2jn.space",
    "2k.vin",
    "2k18.mailr.eu",
    "2k20.mailr.eu",
    "2kolesaclub.ru",
    "2kpda46zg.ml",
    "2kyv36.info",
    "2l7g4s.us",
    "2la.info",
    "2leg.com",
    "2lf.info",
    "2lgvhy.us",
    "2lj.info",
    "2lqkqz.us",
    "2lug.com",
    "2lyvui3rlbx9.cf",
    "2lyvui3rlbx9.ga",
    "2lyvui3rlbx9.gq",
    "2lyvui3rlbx9.ml",
    "2m36.space",
    "2m40.space",
    "2m46.space",
    "2m51.space",
    "2m55.space",
    "2m5u.com",
    "2mailcloud.com",
    "2mailnext.com",
    "2mailnext.top",
    "2mao.xyz",
    "2maudacieuse.org",
    "2mbet.info",
    "2mcfha.site",
    "2mhtw.info",
    "2movierulz.club",
    "2movierulz.one",
    "2movierulz.org",
    "2mydns.com",
    "2nd-mail.xyz",
    "2ndamendmentguns.net",
    "2net.us",
    "2night.dk",
    "2niqqw.us",
    "2npfba.host",
    "2o3ffrm7pm.cf",
    "2o3ffrm7pm.ga",
    "2o3ffrm7pm.gq",
    "2o3ffrm7pm.ml",
    "2o3ffrm7pm.tk",
    "2oceanview.com",
    "2odem.com",
    "2onacxpmdzuco57.xyz",
    "2oqqouxuruvik6zzw9.cf",
    "2oqqouxuruvik6zzw9.ga",
    "2oqqouxuruvik6zzw9.gq",
    "2oqqouxuruvik6zzw9.ml",
    "2oqqouxuruvik6zzw9.tk",
    "2orkid.com",
    "2osq1y.site",
    "2oz.net",
    "2p-mail.com",
    "2p7u8ukr6pksiu.cf",
    "2p7u8ukr6pksiu.ga",
    "2p7u8ukr6pksiu.gq",
    "2p7u8ukr6pksiu.ml",
    "2p7u8ukr6pksiu.tk",
    "2pair.com",
    "2papa.ooo",
    "2pay-e.club",
    "2pay-n.club",
    "2pay-s.club",
    "2pay-w.club",
    "2pays.ru",
    "2prong.com",
    "2pwwbt.us",
    "2pwwmb.us",
    "2r1znbwk.fun",
    "2rix.com",
    "2rna.com",
    "2rntkv.us",
    "2ryajg.us",
    "2rz6no.us",
    "2s2bmanagement.com",
    "2s4uke.us",
    "2s9qa.us",
    "2sap.com",
    "2scxlq.us",
    "2sea.org",
    "2sea.xyz",
    "2senior.dk",
    "2sharp.com",
    "2sim-gsm.ru",
    "2slq5o.us",
    "2snokot.site",
    "2sunssolutions.ru",
    "2svun8.us",
    "2timebet.com",
    "2tl2qamiivskdcz.cf",
    "2tl2qamiivskdcz.ga",
    "2tl2qamiivskdcz.gq",
    "2tl2qamiivskdcz.ml",
    "2tl2qamiivskdcz.tk",
    "2tl9hz.us",
    "2tmk.icu",
    "2trom.com",
    "2tug.com",
    "2twpu9ne.net",
    "2uisk2man.xyz",
    "2ursxg0dbka.cf",
    "2ursxg0dbka.ga",
    "2ursxg0dbka.gq",
    "2ursxg0dbka.ml",
    "2ursxg0dbka.tk",
    "2v3vjqapd6itot8g4z.cf",
    "2v3vjqapd6itot8g4z.ga",
    "2v3vjqapd6itot8g4z.gq",
    "2v3vjqapd6itot8g4z.ml",
    "2v3vjqapd6itot8g4z.tk",
    "2v45m.us",
    "2viewerl.com",
    "2vkahi.host",
    "2vznqascgnfgvwogy.cf",
    "2vznqascgnfgvwogy.ga",
    "2vznqascgnfgvwogy.gq",
    "2vznqascgnfgvwogy.ml",
    "2vznqascgnfgvwogy.tk",
    "2wc.info",
    "2wjxak4a4te.cf",
    "2wjxak4a4te.ga",
    "2wjxak4a4te.gq",
    "2wjxak4a4te.ml",
    "2wjxak4a4te.tk",
    "2wm3yhacf4fvts.ga",
    "2wm3yhacf4fvts.gq",
    "2wm3yhacf4fvts.ml",
    "2wm3yhacf4fvts.tk",
    "2wy9b4h36f6hsw7.xyz",
    "2x45bet.net",
    "2xd.ru",
    "2xfit.site",
    "2xhl.icu",
    "2xxx.com",
    "2y4u.ru",
    "2yannecker.xyz",
    "2ycr9p.us",
    "2yd4bo.site",
    "2ydk.com",
    "2yigoqolrmfjoh.gq",
    "2yigoqolrmfjoh.ml",
    "2yigoqolrmfjoh.tk",
    "2yldy.biz",
    "2young4u.ru",
    "2yvxt8.us",
    "2zozbzcohz3sde.cf",
    "2zozbzcohz3sde.gq",
    "2zozbzcohz3sde.ml",
    "2zozbzcohz3sde.tk",
    "2zpph1mgg70hhub.cf",
    "2zpph1mgg70hhub.ga",
    "2zpph1mgg70hhub.gq",
    "2zpph1mgg70hhub.ml",
    "2zpph1mgg70hhub.tk",
    "3.batikbantul.com",
    "3.kerl.cf",
    "30.dns-cloud.net",
    "300-lukoil.ru",
    "3000.it",
    "300book.info",
    "300ktournament.biz",
    "300mbmovies.shop",
    "30158.monster",
    "301server.net",
    "3023vip.com",
    "3027a.com",
    "303030.ru",
    "3032.ru",
    "30378844.com",
    "303online.org",
    "30669.monster",
    "30718.monster",
    "30739.monster",
    "3074445.com",
    "307468021.xyz",
    "308980.com",
    "309356.com",
    "3094445.com",
    "30abc.ru",
    "30diasparaemagrecer.site",
    "30don.ru",
    "30gigs.com",
    "30it.ru",
    "30madden.com",
    "30mail.ir",
    "30minutemail.com",
    "30minutenmail.eu",
    "30minutesmail.com",
    "30morqca.info",
    "30mot.ru",
    "30rip.ru",
    "30set.ru",
    "30traveller.com",
    "30vcd.com",
    "30wave.com",
    "30yo.site",
    "3104445.com",
    "311156553.buzz",
    "311159521.buzz",
    "311584.com",
    "3126.com",
    "31292.monster",
    "313102.com",
    "3134445.com",
    "31397.monster",
    "313bt1.com",
    "313bt1.net",
    "31415926535.net",
    "316206.com",
    "31711555.com",
    "31711577.com",
    "31711599.com",
    "31711633.com",
    "31711655.com",
    "31711666.com",
    "31711677.com",
    "31711822.com",
    "31711877.com",
    "31711955.com",
    "31711966.com",
    "31711988.com",
    "31722133.com",
    "31722188.com",
    "31722266.com",
    "31722299.com",
    "31722366.com",
    "31722377.com",
    "31722399.com",
    "31722511.com",
    "31722533.com",
    "31722555.com",
    "31722622.com",
    "31722722.com",
    "31722755.com",
    "31722788.com",
    "31722888.com",
    "31722922.com",
    "31722955.com",
    "31733222.com",
    "31733355.com",
    "31733388.com",
    "31733399.com",
    "31733511.com",
    "31733577.com",
    "31733588.com",
    "31733599.com",
    "31733611.com",
    "31733633.com",
    "31733722.com",
    "31733777.com",
    "31733833.com",
    "31733855.com",
    "31733922.com",
    "31733977.com",
    "31733988.com",
    "31755155.com",
    "31755199.com",
    "31755211.com",
    "31755255.com",
    "31755333.com",
    "31755355.com",
    "31755366.com",
    "31755388.com",
    "31755511.com",
    "31755522.com",
    "31755555.com",
    "31755633.com",
    "31755688.com",
    "31755699.com",
    "31755788.com",
    "31755855.com",
    "31755866.com",
    "31755888.com",
    "31755933.com",
    "31755988.com",
    "31862.monster",
    "318factory.com",
    "319358.com",
    "31980.monster",
    "31k.it",
    "31s.info",
    "3202.com",
    "32021.xyz",
    "3204445.com",
    "321-email.com",
    "32194.monster",
    "321appblog.xyz",
    "321appclub.xyz",
    "321ideas.com",
    "321marinetowing.com",
    "321media.com",
    "322appville.xyz",
    "322capital.xyz",
    "322dental.xyz",
    "322events.xyz",
    "322live.xyz",
    "322llc.xyz",
    "322mc.xyz",
    "322nj.xyz",
    "322photo.xyz",
    "322productions.xyz",
    "323ac.com",
    "323designhome.xyz",
    "323enterprises.xyz",
    "323fm.xyz",
    "323grouphome.xyz",
    "323law.xyz",
    "324445.com",
    "32499.monster",
    "32528.monster",
    "3254445.com",
    "3255566.net",
    "325city.xyz",
    "325dayclub.xyz",
    "325designcentre.xyz",
    "325online.xyz",
    "325shop.xyz",
    "3261188.net",
    "3261r.com",
    "326law.xyz",
    "326photo.xyz",
    "326sao.com",
    "326tech.xyz",
    "326usa.xyz",
    "327communications.xyz",
    "327designexperts.xyz",
    "327dev.xyz",
    "327enterprises.xyz",
    "327mag.xyz",
    "327pictures.xyz",
    "327plus.xyz",
    "327studios.xyz",
    "327web.xyz",
    "328037.com",
    "328art.xyz",
    "328center.xyz",
    "328club.xyz",
    "328grouppoint.xyz",
    "328music.xyz",
    "328net.xyz",
    "328photo.xyz",
    "329blog.xyz",
    "329capital.xyz",
    "329club.xyz",
    "329designsolutions.xyz",
    "329events.xyz",
    "329hotel.xyz",
    "329inc.xyz",
    "329music.xyz",
    "329nj.xyz",
    "329pr.xyz",
    "329press.xyz",
    "329ru.com",
    "329shop.xyz",
    "329si.com",
    "329store.xyz",
    "329trading.xyz",
    "329wo.com",
    "329xu.com",
    "32a6.club",
    "32bfe2.xyz",
    "32doso.com",
    "32rnhp.com",
    "32try.com",
    "32y.ru",
    "32zbl.xyz",
    "330561.com",
    "330563.com",
    "330565.com",
    "330a330.com",
    "330d330.com",
    "330g330.com",
    "330j330.com",
    "330n330.com",
    "330o330.com",
    "330q330.com",
    "330r330.com",
    "330x330.com",
    "330z330.com",
    "33212e.com",
    "33212g.com",
    "33212i.com",
    "33212k.com",
    "33212q.com",
    "33212r.com",
    "332288211.com",
    "3324445.com",
    "3325804.com",
    "333-exemptions.net",
    "333.igg.biz",
    "333001d.com",
    "333001e.com",
    "333001h.com",
    "333001x.com",
    "3335258.com",
    "3337426.com",
    "333933.com",
    "3339u.com",
    "333br88.com",
    "333kao.com",
    "333qp.com",
    "333ua.com",
    "333ub.com",
    "333uh.com",
    "333yeye.com",
    "334206.com",
    "334488211.com",
    "335588211.com",
    "33760.xyz",
    "33833.xyz",
    "338888211.com",
    "338aqq.net",
    "339206.com",
    "339ac.com",
    "33bit.ru",
    "33di.club",
    "33hg.bet",
    "33hhqp.com",
    "33jisu.com",
    "33m.co",
    "33mail.com",
    "33protector.ru",
    "33s.info",
    "33sil.site",
    "33xliczvveq9ukw7.best",
    "3404445.com",
    "340c.club",
    "3414445.com",
    "34150c19.xyz",
    "341858.com",
    "34487.fun",
    "344vip31.com",
    "344vip32.com",
    "34545656.xyz",
    "3459827.com",
    "345v345t34t.cf",
    "345v345t34t.ga",
    "345v345t34t.gq",
    "345v345t34t.ml",
    "345v345t34t.tk",
    "346345473.xyz",
    "3464445.com",
    "34828.monster",
    "3484445.com",
    "348es7arsy2.cf",
    "348es7arsy2.ga",
    "348es7arsy2.gq",
    "348es7arsy2.ml",
    "348es7arsy2.tk",
    "349827.com",
    "34favorisen.com",
    "34svet.site",
    "350qs.com",
    "351qs.com",
    "35216.monster",
    "3522173.site",
    "3524445.com",
    "3529842636452.info",
    "35349.monster",
    "3535.site",
    "353ac.com",
    "3554445.com",
    "3555js.com",
    "356qs.com",
    "356ue.space",
    "3574445.com",
    "357ue.space",
    "3584445.com",
    "358ue.space",
    "359956.com",
    "359ue.space",
    "35b638.xyz",
    "35betx.xyz",
    "35bit.ru",
    "35favorisen.com",
    "35german.online",
    "35ihe.us",
    "35top.space",
    "360.auction",
    "360.band",
    "360.bargains",
    "360.black",
    "360.camp",
    "360.catering",
    "360.church",
    "360.clinic",
    "360.dance",
    "360.delivery",
    "360.directory",
    "360.education",
    "360.equipment",
    "360.exposed",
    "360.express",
    "360.forsale",
    "360.furniture",
    "360.gives",
    "360.hosting",
    "360.industries",
    "360.institute",
    "360.lgbt",
    "360.limo",
    "360.markets",
    "360.melbourne",
    "360.monster",
    "360.motorcycles",
    "360.museum",
    "360.navy",
    "360.partners",
    "360.pics",
    "360.recipes",
    "360.ru",
    "360.soccer",
    "360.study",
    "360.surgery",
    "360.tires",
    "360.vet",
    "36061.monster",
    "36080.monster",
    "360832.com",
    "360975.com",
    "360artem.xyz",
    "360casefullprotection.xyz",
    "360chs.site",
    "360cinema.ru",
    "360onefirm.com",
    "360reviews.net",
    "360woodworking.com",
    "3611188.net",
    "3614445.com",
    "36233.monster",
    "362332.com",
    "3629927.com",
    "362ue.space",
    "3634445.com",
    "3637glendonave.com",
    "3644445.com",
    "364ue.space",
    "365-day.ru",
    "365.moe",
    "3651ri.com",
    "3651se.com",
    "3651she.com",
    "36534.monster",
    "36552a.com",
    "36552b.com",
    "36552e.com",
    "36552g.com",
    "36552k.com",
    "36552o.com",
    "36552u.com",
    "36552x.com",
    "36552y.com",
    "36552z.com",
    "365600.info",
    "365600.net",
    "365600.xyz",
    "3657she.com",
    "365generators.com",
    "365scotland.com",
    "365tickets.global",
    "365ue.space",
    "366655.net",
    "3675.mooo.com",
    "36832.monster",
    "368904.com",
    "368pan.com",
    "369mimi.com",
    "36c4.xyz",
    "36fd.club",
    "36poker.ru",
    "36ru.com",
    "36rzd.ru",
    "37.com",
    "37045.monster",
    "370shop.com",
    "370z-uk.com",
    "3714445.com",
    "37146.monster",
    "37285.monster",
    "3754445.com",
    "37556.monster",
    "375piksel.xyz",
    "3761188.net",
    "37613.monster",
    "3764445.com",
    "37870.monster",
    "37art.com",
    "37ddpe.us",
    "37dnah.us",
    "380064.com",
    "3804445.com",
    "38117.monster",
    "38365.monster",
    "38399.host",
    "3844445.com",
    "38488.fun",
    "385manbetx.com",
    "386a101.com",
    "386a102.com",
    "386catering.ru",
    "38759.monster",
    "38768.monster",
    "3880988.com",
    "3882988.com",
    "38850006.com",
    "38850007.com",
    "38850008.com",
    "3885688.com",
    "3885988.com",
    "3886128.com",
    "3886129.com",
    "3886190.com",
    "3886388.com",
    "3887388.com",
    "3887788.com",
    "38992.monster",
    "38bhsx.us",
    "38bvn.net",
    "38favorisen.com",
    "38l0wf.info",
    "38sy.bet",
    "38timebet.com",
    "3903.com",
    "3914445.com",
    "391881.com",
    "3924445.com",
    "3938hg.com",
    "3940hg.com",
    "3942hg.com",
    "3943hg.com",
    "3944hg.com",
    "3945hg.com",
    "3946hg.com",
    "3947hg.com",
    "3948hg.com",
    "3950hg.com",
    "3952hg.com",
    "3954445.com",
    "3955566.net",
    "39584.xyz",
    "3959hg.com",
    "395dy.com",
    "396206.com",
    "3964445.com",
    "3964hg.com",
    "396ac.com",
    "398314.com",
    "3983gg.com",
    "3983ii.com",
    "3983mm.com",
    "3983pp.com",
    "3983tt.com",
    "3983vv.com",
    "3984445.com",
    "398ac.com",
    "39bio.net",
    "39d78.club",
    "39koyr.us",
    "39p.ru",
    "39pop.com",
    "39shipin.xyz",
    "3a-trust.ru",
    "3abenv.us",
    "3ac5e.xyz",
    "3aenuu.us",
    "3agg8gojyj.ga",
    "3agg8gojyj.gq",
    "3agg8gojyj.ml",
    "3aijs.us",
    "3ammagazine.com",
    "3arn.net",
    "3at7w.us",
    "3avz.net",
    "3axe.pro",
    "3b5fzy.com",
    "3ba.online",
    "3bdyw.info",
    "3bffpe.us",
    "3bo1grwl36e9q.cf",
    "3bo1grwl36e9q.ga",
    "3bo1grwl36e9q.gq",
    "3bo1grwl36e9q.ml",
    "3bo1grwl36e9q.tk",
    "3boshi.info",
    "3c0zpnrhdv78n.ga",
    "3c0zpnrhdv78n.gq",
    "3c0zpnrhdv78n.ml",
    "3c0zpnrhdv78n.tk",
    "3c168.com",
    "3c63e56.club",
    "3c9d8ecb.xyz",
    "3chefsoriginal.com",
    "3colormaster.site",
    "3czfe.site",
    "3d-live.ru",
    "3d-magical-magnet.ru",
    "3d-painting.com",
    "3d-sculptor.ru",
    "3d34.space",
    "3d36.space",
    "3d4299.xyz",
    "3d4o.com",
    "3d98mz.us",
    "3dadultdate.com",
    "3dadultsim.com",
    "3dautomobiles.com",
    "3db7.xyz",
    "3dbca2b4.club",
    "3dcamcorders.com",
    "3dcollection.ru",
    "3dgct7.info",
    "3dgit.com",
    "3dgit.info",
    "3dgit.net",
    "3dholography.info",
    "3dhome26.ru",
    "3dhor.com",
    "3dmail.com",
    "3dmail.top",
    "3doggrafx.com",
    "3dollarcafe.net",
    "3dpen-msk01.ru",
    "3dporte.site",
    "3dprinter-vl.ru",
    "3dsculpter.com",
    "3dsculpter.net",
    "3dsimulator.ru",
    "3dstartups.net",
    "3dtovari.ru",
    "3ebdb9.site",
    "3efc7c.club",
    "3eli.ru",
    "3email.com",
    "3enrg.com",
    "3escaladcdh.site",
    "3etvi1zbiuv9n.cf",
    "3etvi1zbiuv9n.ga",
    "3etvi1zbiuv9n.gq",
    "3etvi1zbiuv9n.ml",
    "3etvi1zbiuv9n.tk",
    "3eu2hy.com",
    "3ew.usa.cc",
    "3fb7to.best",
    "3fkq7b.us",
    "3fy1rcwevwm4y.cf",
    "3fy1rcwevwm4y.ga",
    "3fy1rcwevwm4y.gq",
    "3fy1rcwevwm4y.ml",
    "3fy1rcwevwm4y.tk",
    "3g.ua",
    "3g2bpbxdrbyieuv9n.cf",
    "3g2bpbxdrbyieuv9n.ga",
    "3g2bpbxdrbyieuv9n.gq",
    "3g2bpbxdrbyieuv9n.ml",
    "3g2bpbxdrbyieuv9n.tk",
    "3gk2yftgot.cf",
    "3gk2yftgot.ga",
    "3gk2yftgot.gq",
    "3gk2yftgot.ml",
    "3gk2yftgot.tk",
    "3gly.com",
    "3gmtlalvfggbl3mxm.cf",
    "3gmtlalvfggbl3mxm.ga",
    "3gmtlalvfggbl3mxm.gq",
    "3gmtlalvfggbl3mxm.ml",
    "3gmtlalvfggbl3mxm.tk",
    "3gnet.ru",
    "3goam9.xyz",
    "3goodnews.space",
    "3h6tey.us",
    "3hdmku.us",
    "3hvp5pvdzamlkpj.xyz",
    "3imaginarygirls.com",
    "3ipmo.us",
    "3issamewlaidofficail.space",
    "3izo1a.us",
    "3j0rq.us",
    "3j4rnelenwrlvni1t.ga",
    "3j4rnelenwrlvni1t.gq",
    "3j4rnelenwrlvni1t.ml",
    "3j4rnelenwrlvni1t.tk",
    "3jiepai.xyz",
    "3jl.ru",
    "3jq.info",
    "3jxux4awkcrz3oz.xyz",
    "3kbyueliyjkrfhsg.ga",
    "3kbyueliyjkrfhsg.gq",
    "3kbyueliyjkrfhsg.ml",
    "3kbyueliyjkrfhsg.tk",
    "3ker23i7vpgxt2hp.cf",
    "3ker23i7vpgxt2hp.ga",
    "3ker23i7vpgxt2hp.gq",
    "3ker23i7vpgxt2hp.ml",
    "3ker23i7vpgxt2hp.tk",
    "3kh990rrox.cf",
    "3kh990rrox.ml",
    "3kh990rrox.tk",
    "3kk20.com",
    "3kk23.com",
    "3kk27.com",
    "3kk29.com",
    "3kk38.com",
    "3kk41.com",
    "3kk43.com",
    "3kqvns1s1ft7kenhdv8.cf",
    "3kqvns1s1ft7kenhdv8.ga",
    "3kqvns1s1ft7kenhdv8.gq",
    "3kqvns1s1ft7kenhdv8.ml",
    "3kqvns1s1ft7kenhdv8.tk",
    "3krtqc2fr7e.cf",
    "3krtqc2fr7e.ga",
    "3krtqc2fr7e.gq",
    "3krtqc2fr7e.ml",
    "3krtqc2fr7e.tk",
    "3kurge.us",
    "3l6.com",
    "3m8vt.icu",
    "3mail.ga",
    "3mail.gq",
    "3mail.rocks",
    "3mailapp.net",
    "3mbet.info",
    "3mcoin.info",
    "3mcoin.org",
    "3md.xyz",
    "3milyoner365.com",
    "3movierulzz.club",
    "3ndbw8.host",
    "3nixmail.com",
    "3nn0y.site",
    "3ntiqo.info",
    "3ntongm4il.ga",
    "3ntxtrts3g4eko.cf",
    "3ntxtrts3g4eko.ga",
    "3ntxtrts3g4eko.gq",
    "3ntxtrts3g4eko.ml",
    "3ntxtrts3g4eko.tk",
    "3ohwhrgn.website",
    "3on.tech",
    "3p11.club",
    "3p30.club",
    "3p9c2m.racing",
    "3papa.ooo",
    "3pl-distribution.net",
    "3pozsm.us",
    "3pscsr94r3dct1a7.cf",
    "3pscsr94r3dct1a7.ga",
    "3pscsr94r3dct1a7.gq",
    "3pscsr94r3dct1a7.ml",
    "3pscsr94r3dct1a7.tk",
    "3q138.com",
    "3q7j3h.online",
    "3qaths.info",
    "3qi6hy.us",
    "3qpplo4avtreo4k.cf",
    "3qpplo4avtreo4k.ga",
    "3qpplo4avtreo4k.gq",
    "3qpplo4avtreo4k.ml",
    "3qpplo4avtreo4k.tk",
    "3qxfar.us",
    "3qzcpn.us",
    "3r5onu.site",
    "3r8pmr.site",
    "3rdeyeassociates.com",
    "3rdhour.com",
    "3redbatsaffiliates.com",
    "3rmduz.us",
    "3rood.website",
    "3s3n.info",
    "3s3n.org",
    "3s3n.us",
    "3s8831.com",
    "3s8888.net",
    "3skzlr.site",
    "3spoker.com",
    "3spoker.net",
    "3spraut.ru",
    "3sprauts.ru",
    "3sw17d.us",
    "3tcini.info",
    "3tfnnk.us",
    "3th-market-shopp.online",
    "3tp.ru",
    "3trtretgfrfe.tk",
    "3twewx.online",
    "3ucq.us",
    "3uiexk.us",
    "3uptc.us",
    "3utasmqjcv.cf",
    "3utasmqjcv.ga",
    "3utasmqjcv.gq",
    "3utasmqjcv.ml",
    "3utasmqjcv.tk",
    "3utilities.com",
    "3voip.ru",
    "3vuwk8.info",
    "3wbetx.info",
    "3wcgah.us",
    "3win.live",
    "3wmnivgb8ng6d.cf",
    "3wmnivgb8ng6d.ga",
    "3wmnivgb8ng6d.gq",
    "3wmnivgb8ng6d.ml",
    "3wmnivgb8ng6d.tk",
    "3wxhmv.info",
    "3wxoiia16pb9ck4o.cf",
    "3wxoiia16pb9ck4o.ga",
    "3wxoiia16pb9ck4o.ml",
    "3wxoiia16pb9ck4o.tk",
    "3x0ex1x2yx0.cf",
    "3x0ex1x2yx0.ga",
    "3x0ex1x2yx0.gq",
    "3x0ex1x2yx0.ml",
    "3x0ex1x2yx0.tk",
    "3x56.com",
    "3xb90.club",
    "3xjg0x.us",
    "3xk.xyz",
    "3xl.net",
    "3xmoney.ru",
    "3xophlbc5k3s2d6tb.cf",
    "3xophlbc5k3s2d6tb.ga",
    "3xophlbc5k3s2d6tb.gq",
    "3xophlbc5k3s2d6tb.ml",
    "3xophlbc5k3s2d6tb.tk",
    "3ykacb.us",
    "3z1ybp.host",
    "3zar0252773.xyz",
    "3zar0631533.xyz",
    "3zar4406240.xyz",
    "3zar5092660.xyz",
    "3zar5960488.xyz",
    "3zar9560167.xyz",
    "3zar9582935.xyz",
    "3zar9588159.xyz",
    "3zar9610850.xyz",
    "3zar9648137.xyz",
    "3zar9679233.xyz",
    "3zar9711484.xyz",
    "3zar9727694.xyz",
    "3zar9751254.xyz",
    "3zar9754677.xyz",
    "3zar9770435.xyz",
    "3zar9774507.xyz",
    "3zar9817748.xyz",
    "3zar9855085.xyz",
    "3zar9857698.xyz",
    "3zar9869835.xyz",
    "3zar9879852.xyz",
    "3zar9889771.xyz",
    "3zar9902505.xyz",
    "3zar9906626.xyz",
    "3zar9920018.xyz",
    "3zar9928344.xyz",
    "3zar9941846.xyz",
    "3zar9968623.xyz",
    "3zar9979186.xyz",
    "3zumchngf2t.cf",
    "3zumchngf2t.ga",
    "3zumchngf2t.gq",
    "3zumchngf2t.ml",
    "3zumchngf2t.tk",
    "3zxdwj.site",
    "4-n.us",
    "4.batikbantul.com",
    "4.fackme.gq",
    "40.volvo-xc.ml",
    "40.volvo-xc.tk",
    "4004445.com",
    "400br88.com",
    "400domov.ru",
    "40112.monster",
    "4014445.com",
    "401k300.live",
    "401k300.ninja",
    "4034445.com",
    "404qs.com",
    "4057.com",
    "4059.com",
    "405piksel.xyz",
    "4064445.com",
    "406net.works",
    "40837.monster",
    "409356.com",
    "40abc.ru",
    "40andfitformen.com",
    "40bit.ru",
    "40channels.com",
    "40daikonkatsu-kisarazusi.xyz",
    "40e0f2df.xyz",
    "40gm40.club",
    "40rip.ru",
    "40set.ru",
    "410piksel.xyz",
    "411206.com",
    "4114445.com",
    "411beach.com",
    "411beaches.com",
    "411brides.com",
    "411jobsblog.xyz",
    "411jobsclub.xyz",
    "411jobshomes.xyz",
    "411jobslife.xyz",
    "411jobsshop.xyz",
    "411todayblog.xyz",
    "411todayclub.xyz",
    "411todaygroup.xyz",
    "411todayhome.xyz",
    "411todayone.xyz",
    "411todayonline.xyz",
    "411todayshop.xyz",
    "41255.monster",
    "4136552.com",
    "4144445.com",
    "415piksel.xyz",
    "417homesphotography.xyz",
    "417homesservices.xyz",
    "417realtyclub.xyz",
    "418.dk",
    "418.se",
    "4188019.com",
    "419827.com",
    "41baoku.com",
    "41designclub.xyz",
    "41eoyr.us",
    "41plusdrive.xyz",
    "41plusfoundation.xyz",
    "41plusonline.xyz",
    "41plusphotography.xyz",
    "41scu.us",
    "41usa.xyz",
    "41v1relaxn.com",
    "41y.ru",
    "4204445.com",
    "420baby.store",
    "420blaze.it",
    "420ico.bid",
    "424267.com",
    "42507.com",
    "42691.monster",
    "427qs.com",
    "4284445.com",
    "429080.com",
    "429356.com",
    "4294445.com",
    "429827.com",
    "429a5d2.club",
    "42assets.com",
    "42j3qfxroi.xyz",
    "42o.org",
    "42papa.com",
    "42pinbahis.com",
    "42trust.com",
    "42u902u41t0.online",
    "42u902u41t0.space",
    "42u902u41t01t0.online",
    "42u902u41t01t0.space",
    "42u902u41t0924.online",
    "42u902u41t0924.space",
    "42u902u442i90j.online",
    "42u902u442i90j.space",
    "42u902u4924.online",
    "42u902u4924.space",
    "42u902u4924924.space",
    "42u902u4h33u19.online",
    "42u902u4vhh13h.online",
    "42u902u4vhh13h.space",
    "43070.monster",
    "431qs.com",
    "4329827.com",
    "433080.com",
    "433206.com",
    "4333840.site",
    "4334445.com",
    "433qs.com",
    "4344445.com",
    "43601.xyz",
    "438037.com",
    "438800.com",
    "4394445.com",
    "439827.com",
    "43day365.xyz",
    "43daydrive.xyz",
    "43dayone.xyz",
    "43dayshop.xyz",
    "43dayway.xyz",
    "43design365.xyz",
    "43designclub.xyz",
    "43designdrive.xyz",
    "43designone.xyz",
    "43designphotography.xyz",
    "43designshop.xyz",
    "43designway.xyz",
    "43donschool.ru",
    "43events.xyz",
    "43manbetx.com",
    "43papa.com",
    "43site.xyz",
    "4404445.com",
    "441206.com",
    "443206.com",
    "443388211.com",
    "444.net",
    "444044.xyz",
    "44422.app",
    "44443339.com",
    "444449a.com",
    "4444bbb.com",
    "4444gao.com",
    "4444riri.com",
    "4444ru.com",
    "4444sqw.com",
    "4444vod.com",
    "4444yin.com",
    "4445aomenjinsha.com",
    "4445i.com",
    "4445j.com",
    "4445jinsha.com",
    "4445ms.com",
    "4445n.com",
    "4445q.com",
    "4445sc.com",
    "4445v.com",
    "4445wap.com",
    "4445x.com",
    "4449837.com",
    "444gege.com",
    "444riri.com",
    "444yiyi.com",
    "444yyhh.com",
    "44556677.igg.biz",
    "445588211.com",
    "445e8b.club",
    "445t6454545ty4.cf",
    "445t6454545ty4.ga",
    "445t6454545ty4.gq",
    "445t6454545ty4.ml",
    "445t6454545ty4.tk",
    "446206.com",
    "446688211.com",
    "446988.com",
    "447206.com",
    "44741.monster",
    "4474445.com",
    "448440.com",
    "4484445.com",
    "448888211.com",
    "449988211.com",
    "44bit.ru",
    "44bubu.com",
    "44favorisen.com",
    "44hg.app",
    "44mot.ru",
    "44msc.biz",
    "44stttn.xyz",
    "45.biz",
    "4504445.com",
    "45058.monster",
    "450com.com",
    "450piksel.xyz",
    "4510471.com",
    "4510471.xyz",
    "4524445.com",
    "453000.win",
    "453007.site",
    "4533.top",
    "45456455.xyz",
    "45460703.xyz",
    "4547b3.com",
    "454jackpot.com",
    "455206.com",
    "4555yh.com",
    "456.dns-cloud.net",
    "45632155.xyz",
    "4564445.com",
    "45656743.xyz",
    "45656753.xyz",
    "456575675.xyz",
    "4569827.com",
    "456b4564.cf",
    "456b4564.ga",
    "456b4564.gq",
    "456b4564.ml",
    "456b4564ev4.ga",
    "456b4564ev4.gq",
    "456b4564ev4.ml",
    "456b4564ev4.tk",
    "4574445.com",
    "45780b1.club",
    "4584445.com",
    "459356.com",
    "459d.club",
    "45bt2.club",
    "45e6.club",
    "45favorisen.com",
    "45it.ru",
    "45kti.xyz",
    "46018.monster",
    "460328.com",
    "4604445.com",
    "46059e0.xyz",
    "4636552.com",
    "463bv.space",
    "465279.com",
    "466453.usa.cc",
    "46735.xyz",
    "4674445.com",
    "467uph4b5eezvbzdx.cf",
    "467uph4b5eezvbzdx.ga",
    "467uph4b5eezvbzdx.gq",
    "467uph4b5eezvbzdx.ml",
    "468391.com",
    "4685dg.download",
    "468671.info",
    "46885c3f.xyz",
    "469827.com",
    "469837.com",
    "46beton.ru",
    "46designclub.xyz",
    "46designdrive.xyz",
    "46designhotel.xyz",
    "46designplace.xyz",
    "46homes.xyz",
    "46international.xyz",
    "46lclee29x6m02kz.cf",
    "46lclee29x6m02kz.ga",
    "46lclee29x6m02kz.gq",
    "46lclee29x6m02kz.ml",
    "46lclee29x6m02kz.tk",
    "46plusone.xyz",
    "46world.xyz",
    "47057.xyz",
    "470qs.com",
    "4720799.club",
    "476429.com",
    "47660.monster",
    "476812763.info",
    "4774445.com",
    "47871.monster",
    "478webhost.biz",
    "4794445.com",
    "479827.com",
    "47ad119.club",
    "47bit.ru",
    "47c8kp.site",
    "47designhomes.xyz",
    "47designonline.xyz",
    "47designphotography.xyz",
    "47global.xyz",
    "47l6g.us",
    "47webclub.xyz",
    "47webone.xyz",
    "47webonline.xyz",
    "47webplace.xyz",
    "480972.com",
    "48164.monster",
    "4818barsun.com",
    "4824e.xyz",
    "48365.xyz",
    "48411.monster",
    "4844445.com",
    "4849.ru",
    "48643.monster",
    "4864445.com",
    "487.nut.cc",
    "48725.monster",
    "4874445.com",
    "48745.monster",
    "4897c.club",
    "4899w.com",
    "48b3f73f.club",
    "48dayclub.xyz",
    "48daymovie.xyz",
    "48ent.xyz",
    "48marketing.xyz",
    "48plusclub.xyz",
    "48plushomes.xyz",
    "48plusmovie.xyz",
    "48plusone.xyz",
    "48plusphotography.xyz",
    "48plusshop.xyz",
    "48step.xyz",
    "48usa.xyz",
    "48way.xyz",
    "4904445.com",
    "4924445.com",
    "493085.com",
    "4944445.com",
    "495-5454-695.ru",
    "4954445.com",
    "495metrov.ru",
    "4964445.com",
    "49696.xyz",
    "4984445.com",
    "499494a.com",
    "49dayblog.xyz",
    "49daydrive.xyz",
    "49dayhome.xyz",
    "49dayhomes.xyz",
    "49dayonline.xyz",
    "49designblog.xyz",
    "49designhome.xyz",
    "49designone.xyz",
    "49dgx.us",
    "49guide.xyz",
    "49pinbahis.com",
    "49thcoffee.club",
    "49zuhbfwo9pfk13.xyz",
    "4a12003.club",
    "4agr.com",
    "4alltradezmall.store",
    "4alphapro.com",
    "4avz.net",
    "4b5yt45b4.cf",
    "4b5yt45b4.ga",
    "4b5yt45b4.gq",
    "4b5yt45b4.ml",
    "4b5yt45b4.tk",
    "4bb01643e14b.xyz",
    "4bees.org",
    "4bf7eh.us",
    "4brothersdevelopment.com",
    "4bver2tkysutf.cf",
    "4bver2tkysutf.ga",
    "4bver2tkysutf.gq",
    "4bver2tkysutf.ml",
    "4bver2tkysutf.tk",
    "4c5kzxhdbozk1sxeww.cf",
    "4c5kzxhdbozk1sxeww.gq",
    "4c5kzxhdbozk1sxeww.ml",
    "4c5kzxhdbozk1sxeww.tk",
    "4ca0d5c0.club",
    "4callofduty.com",
    "4chan.club",
    "4cloud47.xyz",
    "4cs-laser.com",
    "4d2.online",
    "4d2.rocks",
    "4d2.solutions",
    "4d2.store",
    "4d2.world",
    "4dentalsolutions.com",
    "4diabetes.ru",
    "4dincheon.info",
    "4dincheon.org",
    "4dlive.info",
    "4dm.4dy.org",
    "4dmacan.org",
    "4dpondok.biz",
    "4dtianjin.info",
    "4dtianjin.org",
    "4dx.pw",
    "4e50ky.us",
    "4easyemail.com",
    "4email.com",
    "4email.net",
    "4eofbxcphifsma.cf",
    "4eofbxcphifsma.ga",
    "4eofbxcphifsma.gq",
    "4eofbxcphifsma.ml",
    "4eofbxcphifsma.tk",
    "4etkwggjit7n4o6.xyz",
    "4ex30.us",
    "4fbdeo.us",
    "4fda.club",
    "4fengli.com",
    "4fm9zk.us",
    "4fou.com",
    "4free.li",
    "4funpedia.com",
    "4gamersbygamers.com",
    "4gamesale.club",
    "4gei7vonq5buvdvsd8y.cf",
    "4gei7vonq5buvdvsd8y.ga",
    "4gei7vonq5buvdvsd8y.gq",
    "4gei7vonq5buvdvsd8y.ml",
    "4gei7vonq5buvdvsd8y.tk",
    "4gfdsgfdgfd.tk",
    "4grtkr.site",
    "4gtula.us",
    "4gwpencfprnmehx.cf",
    "4gwpencfprnmehx.ga",
    "4gwpencfprnmehx.gq",
    "4gwpencfprnmehx.ml",
    "4gwpencfprnmehx.tk",
    "4hd8zutuircto.cf",
    "4hd8zutuircto.ga",
    "4hd8zutuircto.gq",
    "4hd8zutuircto.ml",
    "4hd8zutuircto.tk",
    "4heat.ru",
    "4hilton.net",
    "4hsxniz4fpiuwoma.ga",
    "4hsxniz4fpiuwoma.ml",
    "4hsxniz4fpiuwoma.tk",
    "4ima1x.us",
    "4itcv3.us",
    "4j3bvd.stream",
    "4j9tm.com",
    "4jojo.com",
    "4k2glw.us",
    "4kd.ru",
    "4kse.xyz",
    "4kvadro.ru",
    "4kzsjg.com",
    "4l7r.icu",
    "4lasoankhokthich.space",
    "4lfqre.us",
    "4lvpet.us",
    "4mail.cf",
    "4mail.ga",
    "4mail.top",
    "4mbet.info",
    "4mg.com",
    "4milyoner365.com",
    "4mispc8ou3helz3sjh.cf",
    "4mispc8ou3helz3sjh.ga",
    "4mispc8ou3helz3sjh.gq",
    "4mispc8ou3helz3sjh.ml",
    "4mispc8ou3helz3sjh.tk",
    "4mjrad.us",
    "4mnsuaaluts.cf",
    "4mnsuaaluts.ga",
    "4mnsuaaluts.gq",
    "4mnsuaaluts.ml",
    "4mnsuaaluts.tk",
    "4mod.com",
    "4mpdsv.us",
    "4mqrehwp.monster",
    "4mtxds.us",
    "4mwgfceokw83x1y7o.cf",
    "4mwgfceokw83x1y7o.ga",
    "4mwgfceokw83x1y7o.gq",
    "4mwgfceokw83x1y7o.ml",
    "4mwgfceokw83x1y7o.tk",
    "4myloveones.com",
    "4nb.info",
    "4newyork.com",
    "4nextmail.com",
    "4nl.info",
    "4nmpjhlrfp3uy06.xyz",
    "4nmv.ru",
    "4nv9v.us",
    "4oawtg.site",
    "4ocly.us",
    "4oi.ru",
    "4orty.com",
    "4ozqi.us",
    "4padpnhp5hs7k5no.cf",
    "4padpnhp5hs7k5no.ga",
    "4padpnhp5hs7k5no.gq",
    "4padpnhp5hs7k5no.ml",
    "4padpnhp5hs7k5no.tk",
    "4pass.tk",
    "4pet.ro",
    "4pkr15vtrpwha.cf",
    "4pkr15vtrpwha.ga",
    "4pkr15vtrpwha.gq",
    "4pkr15vtrpwha.ml",
    "4pkr15vtrpwha.tk",
    "4q9tw.site",
    "4qmail.com",
    "4rakipbet.com",
    "4rdbt.icu",
    "4red.ru",
    "4rfv6qn1jwvl.cf",
    "4rfv6qn1jwvl.ga",
    "4rfv6qn1jwvl.gq",
    "4rfv6qn1jwvl.ml",
    "4rfv6qn1jwvl.tk",
    "4rl.info",
    "4rxiet.us",
    "4rybu.us",
    "4s9ryg.us",
    "4sakej.us",
    "4sauna.ru",
    "4se.us",
    "4security.ru",
    "4senditnow.com",
    "4simpleemail.com",
    "4siri90.com",
    "4sjgy8.us",
    "4struga.com",
    "4studio43.xyz",
    "4suf6rohbfglzrlte.cf",
    "4suf6rohbfglzrlte.ga",
    "4suf6rohbfglzrlte.gq",
    "4suf6rohbfglzrlte.ml",
    "4suf6rohbfglzrlte.tk",
    "4sygo.com",
    "4tb.host",
    "4tbny5.site",
    "4tmail.com",
    "4tmail.net",
    "4trainers.ru",
    "4u36s.us",
    "4up3vtaxujpdm2.cf",
    "4up3vtaxujpdm2.ga",
    "4up3vtaxujpdm2.gq",
    "4up3vtaxujpdm2.ml",
    "4up3vtaxujpdm2.tk",
    "4vc0pezfz7oppcv.xyz",
    "4vjtan.com",
    "4vn.in",
    "4vny8e.us",
    "4vq19hhmxgaruka.cf",
    "4vq19hhmxgaruka.ga",
    "4vq19hhmxgaruka.gq",
    "4vq19hhmxgaruka.ml",
    "4vq19hhmxgaruka.tk",
    "4w.io",
    "4w0sz.us",
    "4w4w4w.xyz",
    "4wanbet.org",
    "4warding.com",
    "4warding.net",
    "4warding.org",
    "4wpgxw.info",
    "4wu2et.us",
    "4x10.ru",
    "4x1y3n98pdus.online",
    "4x4fan.com",
    "4x4man.com",
    "4x4n.ru",
    "4x5aecxibj4.cf",
    "4x5aecxibj4.ga",
    "4x5aecxibj4.gq",
    "4x5aecxibj4.ml",
    "4x5aecxibj4.tk",
    "4x888.com",
    "4xmail.net",
    "4xmail.org",
    "4xyitv.site",
    "4xzotgbunzq.cf",
    "4xzotgbunzq.ga",
    "4xzotgbunzq.gq",
    "4xzotgbunzq.ml",
    "4xzotgbunzq.tk",
    "4y3zos.us",
    "4yhcmx.us",
    "4yodarbestfdish.xyz",
    "4yooufoodsme.xyz",
    "4youalamitech.xyz",
    "4youbet.info",
    "4youbet.org",
    "4youbuzzza.xyz",
    "4youchoicce.store",
    "4youfoodalami.xyz",
    "4youihibasouit.xyz",
    "4ypbc.us",
    "4ywzd.xyz",
    "4zbt9rqmvqf.cf",
    "4zbt9rqmvqf.ga",
    "4zbt9rqmvqf.gq",
    "4zbt9rqmvqf.ml",
    "4zbt9rqmvqf.tk",
    "4ze1hnq6jjok.cf",
    "4ze1hnq6jjok.ga",
    "4ze1hnq6jjok.gq",
    "4ze1hnq6jjok.ml",
    "4ze1hnq6jjok.tk",
    "4zm1fjk8hpn.cf",
    "4zm1fjk8hpn.ga",
    "4zm1fjk8hpn.gq",
    "4zm1fjk8hpn.ml",
    "4zm1fjk8hpn.tk",
    "5-box.ru",
    "5-mail.info",
    "5-star.repair",
    "500-0-501.ru",
    "500-rub.ru",
    "50000t.com",
    "500555.app",
    "50056.monster",
    "500888.app",
    "5009778.com",
    "500obyavlenii.ru",
    "500qf.com",
    "50271.monster",
    "5044445.com",
    "504718.com",
    "50573c.com",
    "5064445.com",
    "506760.com",
    "5074445.com",
    "508227.com",
    "50abc.ru",
    "50c0bnui7wh.cf",
    "50c0bnui7wh.ga",
    "50c0bnui7wh.gq",
    "50c0bnui7wh.ml",
    "50c0bnui7wh.tk",
    "50daikonkatsu-oumihatimansi.xyz",
    "50it.ru",
    "50jin.ru",
    "50mail.com",
    "50mb.ml",
    "50offsale.com",
    "50plusfitnesscenters.com",
    "50sale.club",
    "50sale.edu.vn",
    "50saleclub.com",
    "50set.ru",
    "510014.com",
    "510520.org",
    "511153126.buzz",
    "511157544.buzz",
    "5114445.com",
    "5124445.com",
    "5129927.com",
    "512jsq.com",
    "51329.monster",
    "514loans.net",
    "5154445.com",
    "5159927.com",
    "5164445.com",
    "516ac.com",
    "516qs.com",
    "517577aa.com",
    "517577ff.com",
    "517577hh.com",
    "517577jj.com",
    "517577oo.com",
    "517she.com",
    "517xc.space",
    "5184445.com",
    "5194445.com",
    "51azinoijefomcf.icu",
    "51cp66.com",
    "51forex.online",
    "51jel.com",
    "51kfb.xyz",
    "51kky.club",
    "51kyb.com",
    "51lya8.site",
    "51lyt.com",
    "51mfty.com",
    "51store.ru",
    "51xh.fun",
    "5200001.top",
    "5202010.com",
    "5202011.com",
    "5202012.com",
    "5202016.com",
    "5204445.com",
    "520mgm1.com",
    "520mgm2.com",
    "520mgm5.com",
    "520mgm9.com",
    "520pp.xyz",
    "520wukong.com",
    "520xjapp.com",
    "52110.monster",
    "52154.monster",
    "5217.website",
    "5218ag.com",
    "523gbt.com",
    "52438.xyz",
    "524713.com",
    "5258aaa.com",
    "5258ccc.com",
    "5258cz.com",
    "5258ddd.com",
    "5258hhh.com",
    "5258iii.com",
    "5258kj.com",
    "5258kkk.com",
    "5258lll.com",
    "5258m.com",
    "5258mmm.com",
    "5258n.com",
    "5258nnn.com",
    "5258rrr.com",
    "5258ttt.com",
    "5258u.com",
    "5258v.com",
    "5258vvv.com",
    "5258www.com",
    "5258xxx.com",
    "5258y.com",
    "5258z.com",
    "5258zf.com",
    "5258zzz.com",
    "5259d1.xyz",
    "5261188.net",
    "52694.xyz",
    "526ba.com",
    "526ca.com",
    "526di.com",
    "526en.com",
    "526ge.com",
    "526ji.com",
    "526ke.com",
    "526li.com",
    "528037.com",
    "52896.monster",
    "5289927.com",
    "5294445.com",
    "52964.xyz",
    "529ac.com",
    "529qs.com",
    "52akb.ru",
    "52avpzg.info",
    "52it.ru",
    "52moe.com",
    "52panda.info",
    "52siwa.xyz",
    "52smooth.com",
    "52xjapp.com",
    "5304445.com",
    "530run.com",
    "530run.net",
    "5311188.net",
    "5314445.com",
    "5325566.net",
    "53256.monster",
    "532qs.com",
    "533ac.com",
    "5351188.net",
    "5354445.com",
    "536898.club",
    "5369927.com",
    "5376k.com",
    "5380b.club",
    "53822.monster",
    "538a.xyz",
    "538hd.com",
    "53978.monster",
    "539b82a0.club",
    "53vtbcwxf91gcar.cf",
    "53vtbcwxf91gcar.ga",
    "53vtbcwxf91gcar.gq",
    "53vtbcwxf91gcar.ml",
    "53vtbcwxf91gcar.tk",
    "54177.monster",
    "541lfh.us",
    "5434445.com",
    "545kp.info",
    "5464445.com",
    "54693.monster",
    "54770.xyz",
    "5485.website",
    "548fqr.us",
    "54916.monster",
    "549356.com",
    "549827.com",
    "54988.com",
    "54artistry.com",
    "54mguitcku64n7f.xyz",
    "54np.club",
    "54pyy.com",
    "54tiljt6dz9tcdryc2g.cf",
    "54tiljt6dz9tcdryc2g.ga",
    "54tiljt6dz9tcdryc2g.gq",
    "54tiljt6dz9tcdryc2g.ml",
    "54tiljt6dz9tcdryc2g.tk",
    "54zxl.info",
    "55002123.com",
    "550088211.com",
    "5500jc4.com",
    "5500jc6.com",
    "5500xz.com",
    "550559.info",
    "552288211.com",
    "55229.net",
    "5524445.com",
    "553388211.com",
    "5534445.com",
    "554206.com",
    "5544445.com",
    "5544499.info",
    "554ds.com",
    "555000jc4.com",
    "555000jc9.com",
    "55555cn.com",
    "5555fun.com",
    "5555lx.com",
    "55581555.com",
    "55586555.com",
    "55593555.com",
    "555gmail.com",
    "555papa.com",
    "555ur.com",
    "5564445.com",
    "5566178.com",
    "5566358.com",
    "5566368.com",
    "5566508.com",
    "5566518.com",
    "5566528.com",
    "5566538.com",
    "556655vn.com",
    "5566598.com",
    "5566617.com",
    "5566623.com",
    "5566627.com",
    "5566628.com",
    "5566653.com",
    "5566658.com",
    "5566659.com",
    "5566672.com",
    "5566681.com",
    "5566682.com",
    "5566693.com",
    "5566738.com",
    "5566758.com",
    "556688211.com",
    "5579927.com",
    "558-10.com",
    "558-11.com",
    "558-22.com",
    "558-33.com",
    "558-44.com",
    "558-66.com",
    "558-77.com",
    "558-8.com",
    "558-88.com",
    "5581788.com",
    "5588600.com",
    "558888211.com",
    "5588rt.space",
    "55919b.com",
    "5594445.com",
    "5599rt.space",
    "55abx.xyz",
    "55c1bda2.xyz",
    "55dy.info",
    "55hg.app",
    "55hg.bet",
    "55hosting.net",
    "55mariettastreet.com",
    "56123m.com",
    "56234m.com",
    "5624445.com",
    "5629927.com",
    "5634445.com",
    "56466233sb1.xyz",
    "564b.club",
    "5654445.com",
    "56567m.com",
    "5664445.com",
    "567107.com",
    "56787.com",
    "5679827.com",
    "568ac.com",
    "56k.tokyo",
    "56toyk.us",
    "570nk.com",
    "5714445.com",
    "571ri.com",
    "571sa.com",
    "571se.com",
    "571te.com",
    "571yi.com",
    "571za.com",
    "5724445.com",
    "57291.xyz",
    "5739222.com",
    "574c9d1.club",
    "5754445.com",
    "576166nn.com",
    "576166ss.com",
    "576166ww.com",
    "576166zz.com",
    "576cce70.xyz",
    "576qs.com",
    "5774445.com",
    "57994.xyz",
    "57timebet.com",
    "57top.ru",
    "57xd.icu",
    "5801000.ru",
    "5801000.xn--p1ai",
    "5804445.com",
    "580628.com",
    "5814445.com",
    "5829927.com",
    "582ds.com",
    "5864445.com",
    "586qs.com",
    "587922.com",
    "588-10.net",
    "588-9.net",
    "5880088.com",
    "5880288.com",
    "5880388.com",
    "5880688.com",
    "5882088.com",
    "5882388.com",
    "5884445.com",
    "5885678.com",
    "5886088.com",
    "588v2.info",
    "5897f.com",
    "58994.xyz",
    "58cam.live",
    "58ec7.club",
    "59188cp.com",
    "5925566.net",
    "592ac.com",
    "593ds.com",
    "594qs.com",
    "595ac.com",
    "597401.com",
    "5979837.com",
    "5989927.com",
    "5994445.com",
    "59avtovokzal.ru",
    "59o.net",
    "59smi.ru",
    "5a58wijv3fxctgputir.cf",
    "5a58wijv3fxctgputir.ga",
    "5a58wijv3fxctgputir.gq",
    "5a58wijv3fxctgputir.ml",
    "5a58wijv3fxctgputir.tk",
    "5aaa.ru",
    "5acmkg8cgud5ky.cf",
    "5acmkg8cgud5ky.ga",
    "5acmkg8cgud5ky.gq",
    "5acmkg8cgud5ky.ml",
    "5acmkg8cgud5ky.tk",
    "5ajfk.us",
    "5am5ung.cf",
    "5am5ung.ga",
    "5am5ung.gq",
    "5am5ung.ml",
    "5am5ung.tk",
    "5avzu4.host",
    "5azino777.org",
    "5b2rak.com",
    "5ballov.ru",
    "5biya2otdnpkd7llam.cf",
    "5biya2otdnpkd7llam.ga",
    "5biya2otdnpkd7llam.gq",
    "5biya2otdnpkd7llam.ml",
    "5blayg.site",
    "5btxankuqtlmpg5.cf",
    "5btxankuqtlmpg5.ga",
    "5btxankuqtlmpg5.gq",
    "5btxankuqtlmpg5.ml",
    "5btxankuqtlmpg5.tk",
    "5c0804b6.xyz",
    "5c86f93c.xyz",
    "5cac.club",
    "5ciyuan.com",
    "5cjvx4dbh4rvv6c.xyz",
    "5cyzrn.us",
    "5d763.xyz",
    "5ddgrmk3f2dxcoqa3.cf",
    "5ddgrmk3f2dxcoqa3.ga",
    "5ddgrmk3f2dxcoqa3.gq",
    "5ddgrmk3f2dxcoqa3.ml",
    "5ddgrmk3f2dxcoqa3.tk",
    "5dsmartstore.com",
    "5e66.xyz",
    "5ekufm.us",
    "5evr3o.site",
    "5f9x2r.stream",
    "5fengli.com",
    "5fm.za.com",
    "5foods.asia",
    "5fp31.site",
    "5fr2hnaflkpl10f.xyz",
    "5fwl03.info",
    "5g.events",
    "5g.glass",
    "5g009.com",
    "5g4.us",
    "5gamdo.com",
    "5game.ink",
    "5gdeos.net",
    "5gdytt.com",
    "5gdyxz.com",
    "5ghgfhfghfgh.tk",
    "5gnulq.us",
    "5gpdx.net",
    "5gr6v4inzp8l.cf",
    "5gr6v4inzp8l.ga",
    "5gr6v4inzp8l.gq",
    "5gr6v4inzp8l.ml",
    "5gramos.com",
    "5gvergelijker.com",
    "5haj3n.us",
    "5hcc9hnrpqpe.cf",
    "5hcc9hnrpqpe.ga",
    "5hcc9hnrpqpe.gq",
    "5hcc9hnrpqpe.ml",
    "5hcc9hnrpqpe.tk",
    "5hcioh.us",
    "5hfmczghlkmuiduha8t.cf",
    "5hfmczghlkmuiduha8t.ga",
    "5hfmczghlkmuiduha8t.gq",
    "5hfmczghlkmuiduha8t.ml",
    "5hfmczghlkmuiduha8t.tk",
    "5hiu2b.site",
    "5i8gvs.us",
    "5ikos.us",
    "5ixa0b.us",
    "5iznnnr6sabq0b6.cf",
    "5iznnnr6sabq0b6.ga",
    "5iznnnr6sabq0b6.gq",
    "5iznnnr6sabq0b6.ml",
    "5iznnnr6sabq0b6.tk",
    "5jchkz.us",
    "5jddaxewlm6gump.xyz",
    "5july.org",
    "5jy5.icu",
    "5kgube.us",
    "5kife.us",
    "5kino.ru",
    "5kmklh82yh72tk0.xyz",
    "5kzdxs.com",
    "5l3jh.us",
    "5ljkf.icu",
    "5lmpsj.com",
    "5lqwcl.us",
    "5lydpa.space",
    "5lzfn.icu",
    "5m6wa.us",
    "5mail.cf",
    "5mail.ga",
    "5mail.xyz",
    "5mails.xyz",
    "5manbetx.info",
    "5manbetx.org",
    "5masters.site",
    "5mi3rb.us",
    "5mot.ru",
    "5music.info",
    "5music.top",
    "5my.ru",
    "5nqkxprvoctdc0.cf",
    "5nqkxprvoctdc0.ga",
    "5nqkxprvoctdc0.gq",
    "5nqkxprvoctdc0.ml",
    "5nqkxprvoctdc0.tk",
    "5oclockmonkey.online",
    "5ocwa7.com",
    "5od56.site",
    "5ogessl0pnue88t.xyz",
    "5osjrktwc5pzxzn.cf",
    "5osjrktwc5pzxzn.ga",
    "5osjrktwc5pzxzn.gq",
    "5osjrktwc5pzxzn.ml",
    "5osjrktwc5pzxzn.tk",
    "5ouce2.us",
    "5ouhkf8v4vr6ii1fh.cf",
    "5ouhkf8v4vr6ii1fh.ga",
    "5ouhkf8v4vr6ii1fh.gq",
    "5ouhkf8v4vr6ii1fh.ml",
    "5ouhkf8v4vr6ii1fh.tk",
    "5oz.ru",
    "5papa.ooo",
    "5qjgt.us",
    "5qq59.xyz",
    "5quickrecipes.com",
    "5quq5vbtzswx.cf",
    "5quq5vbtzswx.ga",
    "5quq5vbtzswx.gq",
    "5quq5vbtzswx.ml",
    "5quq5vbtzswx.tk",
    "5rakipbet.com",
    "5rdqv3.us",
    "5rfscr.us",
    "5rof.cf",
    "5rxsy.us",
    "5se.life",
    "5se.mobi",
    "5se01.com",
    "5se04.com",
    "5se17.com",
    "5se24.com",
    "5se30.com",
    "5se43.com",
    "5se46.com",
    "5se48.com",
    "5se50.com",
    "5se56.com",
    "5se57.com",
    "5se63.com",
    "5se68.com",
    "5se70.com",
    "5se74.com",
    "5se79.com",
    "5se81.com",
    "5se85.com",
    "5se89.com",
    "5se94.com",
    "5slap.com",
    "5so1mammwlf8c.cf",
    "5so1mammwlf8c.ga",
    "5so1mammwlf8c.gq",
    "5so1mammwlf8c.ml",
    "5so1mammwlf8c.tk",
    "5star.com",
    "5starsretail.com",
    "5steps-site.ru",
    "5sun.net",
    "5t2e.us",
    "5t42.space",
    "5u4nms.us",
    "5u612b.com",
    "5uet4izbel.cf",
    "5uet4izbel.ga",
    "5uet4izbel.gq",
    "5uet4izbel.ml",
    "5uet4izbel.tk",
    "5umbw2.us",
    "5urhrt.us",
    "5vaubc.host",
    "5vcxwmwtq62t5.cf",
    "5vcxwmwtq62t5.ga",
    "5vcxwmwtq62t5.gq",
    "5vcxwmwtq62t5.ml",
    "5vcxwmwtq62t5.tk",
    "5vlimcrvbyurmmllcw0.cf",
    "5vlimcrvbyurmmllcw0.ga",
    "5vlimcrvbyurmmllcw0.gq",
    "5vlimcrvbyurmmllcw0.ml",
    "5vlimcrvbyurmmllcw0.tk",
    "5vpn.org",
    "5vviio.us",
    "5wanbetx.org",
    "5watch5.com",
    "5wjft.us",
    "5x2.de",
    "5x25.com",
    "5yatc.site",
    "5ygeqi.us",
    "5yh55.com",
    "5yk.idea-makers.tk",
    "5ymail.com",
    "5ytff56753kkk.cf",
    "5ytff56753kkk.ga",
    "5ytff56753kkk.gq",
    "5ytff56753kkk.ml",
    "5ytff56753kkk.tk",
    "5yxhkg.us",
    "5zan.us",
    "5zvt9h.us",
    "6-6-6.cf",
    "6-6-6.ga",
    "6-6-6.ml",
    "6.emailfake.ml",
    "60-minuten-mail.de",
    "60.volvo-xc.ml",
    "60.volvo-xc.tk",
    "600br88.com",
    "60127.monster",
    "601ds.com",
    "60236.monster",
    "6024445.com",
    "602ds.com",
    "6034500.info",
    "603ds.com",
    "604799588.xyz",
    "605f45.xyz",
    "6060search.com",
    "6064445.com",
    "60950.cn",
    "60g2.icu",
    "60leaves.com",
    "60minutemail.com",
    "60s.in",
    "60set.ru",
    "61042.xyz",
    "610ds.com",
    "6114445.com",
    "612ds.com",
    "6136552.com",
    "613cycling.com",
    "6144445.com",
    "61466.monster",
    "614ds.com",
    "61508.monster",
    "6154445.com",
    "6169927.com",
    "6174445.com",
    "618011.com",
    "61802.xyz",
    "6194445.com",
    "619va2h8.info",
    "61movierulz.com",
    "620047.com",
    "6204445.com",
    "62181.monster",
    "621ac.com",
    "62277.monster",
    "6239927.com",
    "623ac.com",
    "62712.xyz",
    "627ds.com",
    "62897a64.club",
    "62it.ru",
    "62rwb3.info",
    "63086.xyz",
    "630aa.com",
    "630ds.com",
    "6314445.com",
    "631ds.com",
    "6321066.com",
    "6321069.com",
    "6321070.com",
    "6325a.com",
    "63305.monster",
    "6334445.com",
    "6344445.com",
    "6353020.site",
    "6369927.com",
    "636niu.com",
    "6375566.net",
    "638c2997.xyz",
    "638ds.com",
    "63cc.net",
    "6404445.com",
    "640niu.com",
    "64255.xyz",
    "644ds.com",
    "645251.com",
    "645lpd.site",
    "64632.monster",
    "64655.monster",
    "6467.host",
    "646dl1.com",
    "6474445.com",
    "6483769.xyz",
    "6484445.com",
    "649827.com",
    "64a8f.us",
    "64gvj.buzz",
    "64mo7b.online",
    "64uxbcwkcy8.website",
    "650489632148.xyz",
    "6524445.com",
    "6530348.com",
    "6530358.com",
    "6530378.com",
    "6530418.com",
    "6530428.com",
    "6530458.com",
    "6530468.com",
    "6530498.com",
    "6530508.com",
    "6530528.com",
    "6530548.com",
    "653147.com",
    "6533c.club",
    "6534668.com",
    "6534848.com",
    "6534928.com",
    "6534948.com",
    "6534978.com",
    "6534998.com",
    "653niu.com",
    "6542984265429.info",
    "6546500656.info",
    "6549827.com",
    "655qs.com",
    "6564445.com",
    "6568899.com",
    "656niu.com",
    "65705.xyz",
    "657niu.com",
    "658hg.com",
    "659niu.com",
    "65nryny6y7.cf",
    "65nryny6y7.ga",
    "65nryny6y7.gq",
    "65nryny6y7.ml",
    "65nryny6y7.tk",
    "65uwtobxcok66.cf",
    "65uwtobxcok66.ga",
    "65uwtobxcok66.gq",
    "65uwtobxcok66.ml",
    "65uwtobxcok66.tk",
    "6600a10.com",
    "6600a16.com",
    "6600a18.com",
    "6600a19.com",
    "6600a22.com",
    "6600a23.com",
    "6600a25.com",
    "6600a27.com",
    "6600a32.com",
    "6600a33.com",
    "6600a34.com",
    "6600a43.com",
    "6600a48.com",
    "6600a50.com",
    "6600a54.com",
    "6600a56.com",
    "6600a57.com",
    "6600a61.com",
    "6600a62.com",
    "6600a66.com",
    "6600a69.com",
    "6600a71.com",
    "6600a72.com",
    "6600a80.com",
    "6600a83.com",
    "6600a84.com",
    "6600a85.com",
    "6600a86.com",
    "6600a87.com",
    "6600a89.com",
    "6600a92.com",
    "6600a96.com",
    "6600jc3.com",
    "6604445.com",
    "660niu.com",
    "6615566.net",
    "6618ca.com",
    "6624445.com",
    "663388211.com",
    "663niu.com",
    "664niu.com",
    "665588211.com",
    "665niu.com",
    "665qs.com",
    "666-evil.com",
    "666-satan.cf",
    "666-satan.ga",
    "666-satan.gq",
    "666-satan.ml",
    "666-satan.tk",
    "666.run",
    "666002.xyz",
    "66663339.com",
    "666688211.com",
    "6667988.com",
    "6668288.com",
    "6668658.com",
    "666866aa.com",
    "666866bb.com",
    "666866cc.com",
    "666866dd.com",
    "666866ee.com",
    "666866ff.com",
    "666866ii.com",
    "666866jj.com",
    "666866ll.com",
    "666866nn.com",
    "666866rr.com",
    "666866ss.com",
    "666866tt.com",
    "666866uu.com",
    "666866vip.com",
    "666866vv.com",
    "666866ww.com",
    "666866zz.com",
    "6668788.com",
    "6668978.com",
    "6669008.com",
    "6669188.com",
    "6669318.com",
    "6669388.com",
    "6669398.com",
    "6669588.com",
    "6669628.com",
    "6669668.com",
    "6669868.com",
    "6669e.com",
    "666betgiris.net",
    "666fsd.com",
    "666se16.top",
    "666store.xyz",
    "666vu.com",
    "666yiyi.com",
    "666zwzm.com",
    "6672.website",
    "6678.info",
    "6678788.com",
    "667niu.com",
    "667tv.com",
    "6682188.com",
    "6682388.com",
    "6682588.com",
    "6683088.com",
    "6683188.com",
    "6683588.com",
    "6683788.com",
    "6685988.com",
    "6686088.com",
    "6688256.com",
    "6688257.com",
    "6688260.com",
    "668888211.com",
    "6690088.com",
    "6690288.com",
    "6690588.com",
    "6692288.com",
    "6692388.com",
    "6692688.com",
    "6693188.com",
    "6693288.com",
    "6693388.com",
    "6693688.com",
    "6695088.com",
    "6695188.com",
    "6695288.com",
    "6695388.com",
    "6695588.com",
    "6695688.com",
    "6696188.com",
    "6696388.com",
    "6697688.com",
    "6698088.com",
    "6698388.com",
    "669988211.com",
    "66a101.com",
    "66a102.com",
    "66a106.com",
    "66a41.com",
    "66a44.com",
    "66a47.com",
    "66a54.com",
    "66a71.com",
    "66a76.com",
    "66a80.com",
    "66a90.com",
    "66a96.com",
    "66abc.ru",
    "66ddy.com",
    "66ec16.xyz",
    "66fc96b.xyz",
    "66hg.bet",
    "66hhqp.com",
    "66jin.ru",
    "66secao.icu",
    "66shun.biz",
    "66stttn.xyz",
    "66tower.com",
    "66ty.online",
    "66ty.space",
    "66uutt.com",
    "6704445.com",
    "670niu.com",
    "671niu.com",
    "67244de.xyz",
    "672643.net",
    "67296666.com",
    "67297777.com",
    "6734445.com",
    "6736552.com",
    "6751188.net",
    "675hosting.com",
    "675hosting.net",
    "675hosting.org",
    "676199.com",
    "676ac.com",
    "676niu.com",
    "6774445.com",
    "677lu.com",
    "677niu.com",
    "67832.cf",
    "67832.ga",
    "67832.ml",
    "67832.tk",
    "6789038.com",
    "6789058.com",
    "6789108.com",
    "6789128.com",
    "6789138.com",
    "6789158.com",
    "6789178.com",
    "6789208.com",
    "6789248.com",
    "6789258.com",
    "6789358.com",
    "6789548.com",
    "6789618.com",
    "6789648.com",
    "6789658.com",
    "6789827.com",
    "6789848.com",
    "6789938.com",
    "6789978.com",
    "6789v.com",
    "678niu.com",
    "678nu.com",
    "678ou.com",
    "678si.com",
    "679045.icu",
    "67998.monster",
    "679niu.com",
    "679yo.com",
    "679zi.com",
    "67azck3y6zgtxfoybdm.cf",
    "67azck3y6zgtxfoybdm.ga",
    "67azck3y6zgtxfoybdm.gq",
    "67azck3y6zgtxfoybdm.ml",
    "67azck3y6zgtxfoybdm.tk",
    "67nref.info",
    "67qcqm.com",
    "67rzpjb2im3fuehh9gp.cf",
    "67rzpjb2im3fuehh9gp.ga",
    "67rzpjb2im3fuehh9gp.gq",
    "67rzpjb2im3fuehh9gp.ml",
    "67rzpjb2im3fuehh9gp.tk",
    "67sharov.ru",
    "67xxzwhzv5fr.cf",
    "67xxzwhzv5fr.ga",
    "67xxzwhzv5fr.gq",
    "67xxzwhzv5fr.tk",
    "67y9.icu",
    "680niu.com",
    "680rve.us",
    "681hu.com",
    "681lv.com",
    "681ne.com",
    "681niu.com",
    "681pa.com",
    "681pi.com",
    "681qi.com",
    "682ne.com",
    "682niu.com",
    "682pa.com",
    "6831.host",
    "6831.space",
    "684niu.com",
    "68583.xyz",
    "685niu.com",
    "686206.com",
    "6875666.com",
    "6883188.com",
    "6883688.com",
    "6884688.com",
    "6885788.com",
    "6885988.com",
    "6886088.com",
    "6886188.com",
    "6887088.com",
    "6887188.com",
    "6887588.com",
    "6888588.com",
    "6889188.com",
    "6889588.com",
    "688as.org",
    "689ac.com",
    "68apps.com",
    "68mail.com",
    "68s.info",
    "68weijiaoyi.com",
    "69-ew.tk",
    "6904445.com",
    "690805611.xyz",
    "6911666.com",
    "691ds.com",
    "6921666.com",
    "6930666.com",
    "694069190.xyz",
    "6944445.com",
    "6954445.com",
    "6957666.com",
    "695ty.xyz",
    "6961666.com",
    "6964445.com",
    "6965666.com",
    "6967666.com",
    "696ac.com",
    "698024.com",
    "698025.com",
    "698026.com",
    "698027.com",
    "698029.com",
    "698031.com",
    "698035.com",
    "698042.com",
    "698052.com",
    "698053.com",
    "698054.com",
    "698149.com",
    "698154.com",
    "698164.com",
    "698174.com",
    "698180.com",
    "698201.com",
    "698203.com",
    "698204.com",
    "698207.com",
    "698224.com",
    "698240.com",
    "698241.com",
    "698244.com",
    "698246.com",
    "698254.com",
    "698264.com",
    "698274.com",
    "698284.com",
    "698294.com",
    "698309.com",
    "698341.com",
    "698342.com",
    "698343.com",
    "698344.com",
    "698354.com",
    "6983666.com",
    "698394.com",
    "698403.com",
    "698404.com",
    "698405.com",
    "698406.com",
    "698407.com",
    "698409.com",
    "698410.com",
    "698414.com",
    "698416.com",
    "698417.com",
    "698420.com",
    "698424.com",
    "698425.com",
    "698426.com",
    "698427.com",
    "698428.com",
    "698429.com",
    "698430.com",
    "698432.com",
    "698434.com",
    "698435.com",
    "698437.com",
    "698438.com",
    "698443.com",
    "698447.com",
    "698460.com",
    "698464.com",
    "698467.com",
    "698480.com",
    "698485.com",
    "698490.com",
    "698493.com",
    "698497.com",
    "698540.com",
    "698549.com",
    "6985522.com",
    "698554.com",
    "698574.com",
    "698590.com",
    "698604.com",
    "698610.com",
    "698620.com",
    "698634.com",
    "698642.com",
    "698643.com",
    "698674.com",
    "698694.com",
    "698706.com",
    "698742.com",
    "6987711.com",
    "6987722.com",
    "6987733.com",
    "698794.com",
    "698907.com",
    "698914.com",
    "698924.com",
    "698934.com",
    "6989911.com",
    "698994.com",
    "698ac.com",
    "6991666.com",
    "69e10d94.xyz",
    "69postix.info",
    "69s.buzz",
    "69sp.art",
    "69sp.mobi",
    "69sp.red",
    "69sp.sale",
    "69t03rpsl4.cf",
    "69t03rpsl4.ga",
    "69t03rpsl4.gq",
    "69t03rpsl4.ml",
    "69t03rpsl4.tk",
    "69tv.art",
    "69xba.xyz",
    "69xinpian.xyz",
    "69xk4.us",
    "69yogo.xyz",
    "6a1.xyz",
    "6a4.xyz",
    "6a7dtwpreu5qvxlnreu5201.com",
    "6a7dtxpjne1uwxhnelk6136.com",
    "6a81fostts.cf",
    "6a81fostts.ga",
    "6a81fostts.gq",
    "6a81fostts.ml",
    "6a81fostts.tk",
    "6a84da.club",
    "6acg.com",
    "6aplgd.info",
    "6aqm2c.us",
    "6asocx.us",
    "6b58.xyz",
    "6brmwv.cf",
    "6brmwv.ga",
    "6brmwv.gq",
    "6brmwv.ml",
    "6brmwv.tk",
    "6c171.club",
    "6c5bf61.club",
    "6cbc.com",
    "6ceqs4enix.co19.kr",
    "6ciku.us",
    "6cv.info",
    "6cw.info",
    "6d5.xyz",
    "6d6bc6.com",
    "6dadcx.us",
    "6dx.info",
    "6dz.info",
    "6ed.info",
    "6ed9cit4qpxrcngbq.cf",
    "6ed9cit4qpxrcngbq.ga",
    "6ed9cit4qpxrcngbq.gq",
    "6ed9cit4qpxrcngbq.ml",
    "6ed9cit4qpxrcngbq.tk",
    "6ei.info",
    "6ek.info",
    "6en.info",
    "6en9mail2.ga",
    "6eng-zma1lz.ga",
    "6eq.info",
    "6etix1.site",
    "6eu.info",
    "6ev.info",
    "6f4af.club",
    "6faw.icu",
    "6fengli.com",
    "6fihtu.com",
    "6fqwxa.info",
    "6g.glass",
    "6gavlf.online",
    "6gbixl.site",
    "6gotkl.us",
    "6gumwj.us",
    "6hjgjhgkilkj.tk",
    "6hk.info",
    "6hq6.com",
    "6ip.us",
    "6iv1mc.com",
    "6j8onr9olu54u3c.xyz",
    "6k4wm9.info",
    "6kelb5.info",
    "6kg8ddf6mtlyzzi5mm.cf",
    "6kg8ddf6mtlyzzi5mm.ga",
    "6kg8ddf6mtlyzzi5mm.gq",
    "6kg8ddf6mtlyzzi5mm.ml",
    "6kg8ddf6mtlyzzi5mm.tk",
    "6koxz4.us",
    "6lb1kb.us",
    "6lhp5tembvpl.cf",
    "6lhp5tembvpl.ga",
    "6lhp5tembvpl.gq",
    "6lhp5tembvpl.ml",
    "6lhp5tembvpl.tk",
    "6lr.info",
    "6mail.cc",
    "6mail.cf",
    "6mail.ga",
    "6mail.ml",
    "6mail.top",
    "6mails.com",
    "6manbetx.info",
    "6mbetx.info",
    "6nb5.us",
    "6od.info",
    "6osjcz.us",
    "6ox.com",
    "6papa.ooo",
    "6paq.com",
    "6pzukk.host",
    "6q70sdpgjzm2irltn.cf",
    "6q70sdpgjzm2irltn.ga",
    "6q70sdpgjzm2irltn.gq",
    "6q70sdpgjzm2irltn.ml",
    "6q70sdpgjzm2irltn.tk",
    "6qstz1fsm8hquzz.cf",
    "6qstz1fsm8hquzz.ga",
    "6qstz1fsm8hquzz.gq",
    "6qstz1fsm8hquzz.ml",
    "6qstz1fsm8hquzz.tk",
    "6qwkvhcedxo85fni.cf",
    "6qwkvhcedxo85fni.ga",
    "6qwkvhcedxo85fni.gq",
    "6qwkvhcedxo85fni.ml",
    "6qwkvhcedxo85fni.tk",
    "6qzwgn.us",
    "6rndtguzgeajcce.cf",
    "6rndtguzgeajcce.ga",
    "6rndtguzgeajcce.gq",
    "6rndtguzgeajcce.ml",
    "6rndtguzgeajcce.tk",
    "6scwis5lamcv.gq",
    "6somok.ru",
    "6tevf8.us",
    "6th-market-shopp.online",
    "6trsqu.us",
    "6twkd1jggp9emimfya8.cf",
    "6twkd1jggp9emimfya8.ga",
    "6twkd1jggp9emimfya8.gq",
    "6twkd1jggp9emimfya8.ml",
    "6twkd1jggp9emimfya8.tk",
    "6u1fuh.info",
    "6ugzob6xpyzwt.cf",
    "6ugzob6xpyzwt.ga",
    "6ugzob6xpyzwt.gq",
    "6ugzob6xpyzwt.ml",
    "6ugzob6xpyzwt.tk",
    "6url.com",
    "6v9haqno4e.cf",
    "6v9haqno4e.ga",
    "6v9haqno4e.gq",
    "6v9haqno4e.ml",
    "6v9haqno4e.tk",
    "6vdmep.us",
    "6vgflujwsc.cf",
    "6vgflujwsc.ga",
    "6vgflujwsc.gq",
    "6vgflujwsc.ml",
    "6wtms1.com",
    "6xozla.us",
    "6xtx.com",
    "6yh66.com",
    "6yhlim.host",
    "6z2uwj53vosfvgr.xyz",
    "6zbih.us",
    "6zl1e.us",
    "6zxpbk.us",
    "70000000.xyz",
    "7005tkrbne16ttvnale3924.com",
    "7005tkrnne56stforfu2545.com",
    "700br88.com",
    "700m.site",
    "702action.com",
    "702called.xyz",
    "702mail.co.za",
    "702whitepages.xyz",
    "702yl.com",
    "703041.icu",
    "7034445.com",
    "7036552.com",
    "703xanmf2tk5lny.cf",
    "703xanmf2tk5lny.ga",
    "703xanmf2tk5lny.gq",
    "703xanmf2tk5lny.ml",
    "703xanmf2tk5lny.tk",
    "7043w.com",
    "7054445.com",
    "7060dy.com",
    "7064445.com",
    "7068001.com",
    "7068003.com",
    "70742e.club",
    "7088708.biz",
    "708997.com",
    "7094445.com",
    "70abc.ru",
    "70don.ru",
    "70k6ylzl2aumii.cf",
    "70k6ylzl2aumii.ga",
    "70k6ylzl2aumii.gq",
    "70k6ylzl2aumii.ml",
    "70k6ylzl2aumii.tk",
    "70lgat.us",
    "70mot.ru",
    "70rang.net",
    "70rang.org",
    "70s.ink",
    "711.shop",
    "711d895.xyz",
    "7139927.com",
    "713ewm5.com",
    "713ewm6.com",
    "713ewm7.com",
    "713ewm8.com",
    "7154445.com",
    "715801.site",
    "7174445.com",
    "718037.com",
    "71cnb.space",
    "71compete.com",
    "71d0.club",
    "7204445.com",
    "72153.monster",
    "7219ii.com",
    "7219jj.com",
    "7219kk.com",
    "7219ll.com",
    "7219nn.com",
    "7219oo.com",
    "7219pp.com",
    "7219rr.com",
    "7219tt.com",
    "7219xx.com",
    "7219yy.com",
    "7219zz.com",
    "722552.com",
    "7234445.com",
    "72388dzz.com",
    "72388sx.com",
    "72388yh.com",
    "723ds.com",
    "726xhknin96v9oxdqa.cf",
    "726xhknin96v9oxdqa.gq",
    "726xhknin96v9oxdqa.ml",
    "726xhknin96v9oxdqa.tk",
    "727qs.com",
    "72825.monster",
    "7284445.com",
    "729904.com",
    "729ac.com",
    "72hremergencypack.com",
    "72yin.com",
    "730490.com",
    "73052.monster",
    "73189.monster",
    "731ds.com",
    "733ac.com",
    "733manbetx.com",
    "7345.host",
    "734manbetx.com",
    "734santamaria.com",
    "738037.com",
    "7384445.com",
    "738ac.com",
    "739837.com",
    "7399837.com",
    "73999r.com",
    "73ac4b.us",
    "73cnb.space",
    "73n.app",
    "74.ru",
    "7414445.com",
    "741bfa10.xyz",
    "7426118.com",
    "74507.monster",
    "7474445.com",
    "747c67.club",
    "7494445.com",
    "749827.com",
    "749manbetx.com",
    "74cnb.space",
    "74d30a57.club",
    "74jw.com",
    "74shequ.icu",
    "7511188.net",
    "7519927.com",
    "751ac.com",
    "7524445.com",
    "75271.monster",
    "7544445.com",
    "75470.xyz",
    "7555.info",
    "755978.com",
    "7567fdcvvghw2.cf",
    "7567fdcvvghw2.ga",
    "7567fdcvvghw2.gq",
    "7567fdcvvghw2.ml",
    "7567fdcvvghw2.tk",
    "757199.com",
    "7583.host",
    "758ac.com",
    "759b02.com",
    "759b03.com",
    "759b100.com",
    "759b101.com",
    "759b103.com",
    "759b104.com",
    "759b107.com",
    "759b110.com",
    "759b112.com",
    "759b114.com",
    "759b116.com",
    "759b120.com",
    "759b121.com",
    "759b123.com",
    "759b125.com",
    "759b129.com",
    "759b130.com",
    "759b133.com",
    "759b134.com",
    "759b136.com",
    "759b139.com",
    "759b140.com",
    "759b141.com",
    "759b143.com",
    "759b150.com",
    "759b152.com",
    "759b160.com",
    "759b161.com",
    "759b166.com",
    "759b169.com",
    "759b171.com",
    "759b173.com",
    "759b191.com",
    "759b192.com",
    "759b193.com",
    "759b195.com",
    "759b196.com",
    "759b197.com",
    "759b212.com",
    "759b259.com",
    "759b272.com",
    "759b273.com",
    "759b43.com",
    "759b45.com",
    "759b57.com",
    "759b58.com",
    "759b61.com",
    "759b72.com",
    "759b73.com",
    "759b75.com",
    "759b76.com",
    "759b87.com",
    "759b88.com",
    "759b89.com",
    "759b90.com",
    "759b93.com",
    "759b94.com",
    "759c51.com",
    "75bt2y.site",
    "75e6dbc.xyz",
    "75gf7g7h.xyz",
    "75hosting.com",
    "75hosting.net",
    "75hosting.org",
    "75it.ru",
    "7614445.com",
    "7615089.site",
    "7619837.com",
    "765manbetx.com",
    "765qs.com",
    "7664445.com",
    "76654422.com",
    "76654433.com",
    "76654488.com",
    "76654499.com",
    "76655511.com",
    "76655533.com",
    "76655544.com",
    "76655555.com",
    "76655566.com",
    "76655577.com",
    "76655588.com",
    "76655599.com",
    "76656644.com",
    "76656655.com",
    "76656688.com",
    "76657777.com",
    "76657799.com",
    "76658800.com",
    "76658811.com",
    "76658833.com",
    "76658855.com",
    "76658866.com",
    "76658877.com",
    "76659911.com",
    "76659922.com",
    "76659944.com",
    "76659966.com",
    "768037.com",
    "768699.com",
    "76938.monster",
    "76ctr.us",
    "76etij.us",
    "76jdafbnde38cd.cf",
    "76jdafbnde38cd.ga",
    "76jdafbnde38cd.gq",
    "76jdafbnde38cd.ml",
    "76jdafbnde38cd.tk",
    "76l5ht.us",
    "76rcnf.us",
    "76servers.com",
    "7714445.com",
    "771e05.club",
    "772288211.com",
    "77230.monster",
    "7728s.com",
    "7728u.com",
    "7728w.com",
    "7728wx.com",
    "7728x.com",
    "7728y.com",
    "7733111.com",
    "7736552.com",
    "7739927.com",
    "773yz.com",
    "774257.icu",
    "77448b.com",
    "77448bb.com",
    "77448c.com",
    "77448cc.com",
    "77448d.com",
    "77448dd.com",
    "77448e.com",
    "77448f.com",
    "77448g.com",
    "77448h.com",
    "77448ii.com",
    "77448jj.com",
    "77448k.com",
    "77448l.com",
    "77448ll.com",
    "77448m.com",
    "77448mm.com",
    "77448n.com",
    "77448nn.com",
    "77448pp.com",
    "77448qq.com",
    "77448r.com",
    "77448s.com",
    "77448ss.com",
    "77448vv.com",
    "77448ww.com",
    "77448x.com",
    "77448xx.com",
    "77448y.com",
    "77448z.com",
    "77448zz.com",
    "7752050.ru",
    "7754445.com",
    "775588211.com",
    "7755bbb.com",
    "775tit.com",
    "77744.app",
    "77777778888888.com",
    "777788211.com",
    "7777bbtt.com",
    "7777bubu.com",
    "7777lulu.com",
    "7777yeye.com",
    "7779u.com",
    "777azino-duac.icu",
    "777fortune.com",
    "777game1.xyz",
    "777jsc.com",
    "777originals.win",
    "777score-ag.com",
    "777score-ca.com",
    "777score-fj.com",
    "777score-gg.com",
    "777score-gu.com",
    "777score-kn.com",
    "777score-ky.com",
    "777score-lr.com",
    "777score-mv.com",
    "777score-rw.com",
    "777score-sc.com",
    "777score-to.com",
    "777score-vi.com",
    "777y.buzz",
    "777y.monster",
    "778789.com",
    "779118.com",
    "779988211.com",
    "779e0f1u7f7bivc.xyz",
    "77betbet.info",
    "77cnb.space",
    "77corner.com",
    "77game.ru",
    "77jin.ru",
    "77mot.ru",
    "77q2j.com",
    "77q3f.com",
    "77q4g.com",
    "77q4j.com",
    "77q5f.com",
    "77q5g.com",
    "77q6h.com",
    "77q6m.com",
    "77q7g.com",
    "77q8f.com",
    "77q8g.com",
    "77q8k.com",
    "77q8m.com",
    "77q9h.com",
    "77q9j.com",
    "77royal.online",
    "77royal.site",
    "77xht.com",
    "78012m.com",
    "780667.com",
    "78123m.com",
    "7814445.com",
    "78345m.com",
    "7836552.com",
    "7837788.com",
    "78456m.com",
    "784666.net",
    "7854445.com",
    "78567m.com",
    "78678m.com",
    "787199.com",
    "789.dns-cloud.net",
    "789.game",
    "789.tips",
    "789327.app",
    "7894.website",
    "7894445.com",
    "7899w.top",
    "789club.fun",
    "789toto.org",
    "78avalon.green",
    "78avalon.land",
    "78e4f9a.club",
    "78el.ru",
    "78jxs.com",
    "78zjx.com",
    "78zjxs.com",
    "790344.com",
    "7904445.com",
    "7924445.com",
    "7929837.com",
    "7936552.com",
    "79422.monster",
    "7954445.com",
    "796ty.com",
    "798ac.com",
    "7994445.com",
    "79966.xyz",
    "79mail.com",
    "7ag83mwrabz.ga",
    "7ag83mwrabz.ml",
    "7ag83mwrabz.tk",
    "7ahug9.us",
    "7at2psgzt6689u9.xyz",
    "7avz.net",
    "7aw.ru",
    "7awa.live",
    "7azino777.org",
    "7banrz.us",
    "7bcc935.club",
    "7be.org",
    "7belt.com",
    "7beta90.org",
    "7bhmsthext.cf",
    "7bhmsthext.ga",
    "7bhmsthext.gq",
    "7bhmsthext.ml",
    "7bhmsthext.tk",
    "7bhtm0suwklftwx7.cf",
    "7bhtm0suwklftwx7.ga",
    "7bhtm0suwklftwx7.gq",
    "7bhtm0suwklftwx7.ml",
    "7bhtm0suwklftwx7.tk",
    "7c3d0ba2.xyz",
    "7cc8a0.xyz",
    "7dach-market.ru",
    "7days-printing.com",
    "7dd.info",
    "7ddf32e.info",
    "7dewapoker.net",
    "7di5vd603tkzk9h.xyz",
    "7dicas.online",
    "7dmail.com",
    "7doin.info",
    "7e42hrmxv14s.best",
    "7ecdmj.us",
    "7ecfps.us",
    "7ef9e0.club",
    "7efwe0.com",
    "7f20.icu",
    "7f40.club",
    "7fge6u.us",
    "7figureadvisorsecrets.com",
    "7figurealliance.com",
    "7figureconsultants.com",
    "7figurehq.com",
    "7figuresalesmachines.com",
    "7figuresalespipeline.com",
    "7figuresecretsauce.com",
    "7ful.com",
    "7gpvegspglb8x8bczws.cf",
    "7gpvegspglb8x8bczws.ga",
    "7gpvegspglb8x8bczws.gq",
    "7gpvegspglb8x8bczws.ml",
    "7gpvegspglb8x8bczws.tk",
    "7h3ybn.us",
    "7hqcwl.us",
    "7hxt5zbkt7jihsf.xyz",
    "7hy4qy.us",
    "7ijabi.com",
    "7jbsrsj4fzfl61x.xyz",
    "7kcv1y.com",
    "7ki.club",
    "7ktrtk.site",
    "7kuiqff4ay.cf",
    "7kuiqff4ay.ga",
    "7kuiqff4ay.gq",
    "7kuiqff4ay.ml",
    "7kuiqff4ay.tk",
    "7l6qix.us",
    "7lzgfpq05bkumst.com",
    "7m3aq2e9chlicm.cf",
    "7m3aq2e9chlicm.ga",
    "7m3aq2e9chlicm.gq",
    "7m3aq2e9chlicm.ml",
    "7m3aq2e9chlicm.tk",
    "7magazinov.ru",
    "7mail.ga",
    "7mail.io",
    "7mail.ml",
    "7mail.xyz",
    "7mail7.com",
    "7mtff.us",
    "7n2a.us",
    "7ncsjy.us",
    "7nglhuzdtv.cf",
    "7nglhuzdtv.ga",
    "7nglhuzdtv.gq",
    "7nglhuzdtv.ml",
    "7nglhuzdtv.tk",
    "7nka4e.us",
    "7nsska.us",
    "7o3zds.online",
    "7o4g2.us",
    "7oalyv.com",
    "7obgt.us",
    "7ocnju.site",
    "7odibr.us",
    "7oicpwgcc8trzcvvfww.cf",
    "7oicpwgcc8trzcvvfww.ga",
    "7oicpwgcc8trzcvvfww.gq",
    "7oicpwgcc8trzcvvfww.ml",
    "7oicpwgcc8trzcvvfww.tk",
    "7opp2romngiww8vto.cf",
    "7opp2romngiww8vto.ga",
    "7opp2romngiww8vto.gq",
    "7opp2romngiww8vto.ml",
    "7opp2romngiww8vto.tk",
    "7oryat.com",
    "7p29u3zshrfe.com",
    "7p3bme.us",
    "7p6kz0omk2kb6fs8lst.cf",
    "7p6kz0omk2kb6fs8lst.ga",
    "7p6kz0omk2kb6fs8lst.gq",
    "7p6kz0omk2kb6fs8lst.ml",
    "7p6kz0omk2kb6fs8lst.tk",
    "7pccf.cf",
    "7pccf.ga",
    "7pccf.gq",
    "7pccf.ml",
    "7pccf.tk",
    "7pfmnw.us",
    "7pirlh.us",
    "7qrtbew5cigi.cf",
    "7qrtbew5cigi.ga",
    "7qrtbew5cigi.gq",
    "7qrtbew5cigi.ml",
    "7qrtbew5cigi.tk",
    "7qxme5zd.xyz",
    "7rdhli.us",
    "7rent.top",
    "7rtay.info",
    "7sisko.com",
    "7slot.fun",
    "7star.ninja",
    "7tags.com",
    "7th-market-shopp.online",
    "7thcircuitreview.com",
    "7thposition.org",
    "7thsons.org",
    "7tiqqxsfmd2qx5.cf",
    "7tiqqxsfmd2qx5.ga",
    "7tiqqxsfmd2qx5.gq",
    "7tiqqxsfmd2qx5.ml",
    "7tiqqxsfmd2qx5.tk",
    "7tp8b4tfevfpvew.xyz",
    "7tqzu.info",
    "7tsjf6nmvzud3jj.xyz",
    "7txk4c.best",
    "7u2yob.site",
    "7u61.space",
    "7u64.space",
    "7u65.space",
    "7u77.space",
    "7u7rdldlbvcnklclnpx.cf",
    "7u7rdldlbvcnklclnpx.ga",
    "7u7rdldlbvcnklclnpx.gq",
    "7u7rdldlbvcnklclnpx.ml",
    "7u7rdldlbvcnklclnpx.tk",
    "7u80.space",
    "7uoeta.info",
    "7uy35p.cf",
    "7uy35p.ga",
    "7uy35p.gq",
    "7uy35p.ml",
    "7uy35p.tk",
    "7v.app",
    "7vc.info",
    "7vchsh.us",
    "7vcntir8vyufqzuqvri.cf",
    "7vcntir8vyufqzuqvri.ga",
    "7vcntir8vyufqzuqvri.gq",
    "7vcntir8vyufqzuqvri.ml",
    "7vcntir8vyufqzuqvri.tk",
    "7vj.info",
    "7vl.info",
    "7wafa.com",
    "7wager.com",
    "7we2x0.us",
    "7woz2k.us",
    "7wzctlngbx6fawlv.cf",
    "7wzctlngbx6fawlv.ga",
    "7wzctlngbx6fawlv.gq",
    "7wzctlngbx6fawlv.ml",
    "7wzctlngbx6fawlv.tk",
    "7ymdfc.site",
    "7yt1l6.us",
    "7z3026peeg82ay9.xyz",
    "7z4hjm.us",
    "8-sun.com",
    "8.fackme.gq",
    "800sacramento.tk",
    "8020cockpit.com",
    "8020simrig.com",
    "8020wheelstand.com",
    "802260.com",
    "803760.com",
    "8037bet.com",
    "8037by.com",
    "8037dt4.com",
    "8037dt5.com",
    "8037dt8.com",
    "8037kf.com",
    "8037vip.com",
    "8037wap.com",
    "8037xs.com",
    "80401.monster",
    "80476.monster",
    "805318gj11t0.online",
    "805318gj11t0.space",
    "805318gj1924.online",
    "805318gj1924.space",
    "806.flu.cc",
    "80600.net",
    "80665.com",
    "80887.monster",
    "808hjc.com",
    "808qs.com",
    "80abc.ru",
    "80cnb.space",
    "80hcy.com",
    "80i3ba.best",
    "80it.ru",
    "80mot.ru",
    "80r0zc5fxpmuwczzxl.cf",
    "80r0zc5fxpmuwczzxl.ga",
    "80r0zc5fxpmuwczzxl.gq",
    "80r0zc5fxpmuwczzxl.ml",
    "80r0zc5fxpmuwczzxl.tk",
    "80rip.ru",
    "80set.ru",
    "80siri90.com",
    "80smoviequotes.com",
    "80zooiwpz1nglieuad8.cf",
    "80zooiwpz1nglieuad8.ga",
    "80zooiwpz1nglieuad8.gq",
    "80zooiwpz1nglieuad8.ml",
    "80zooiwpz1nglieuad8.tk",
    "81004.xyz",
    "81111199.com",
    "81122266.com",
    "81122277.com",
    "811ac.com",
    "81263.monster",
    "812676354.xyz",
    "8127ep.com",
    "8131.fun",
    "813471.com",
    "813oo.com",
    "813tt.com",
    "813uu.com",
    "813zf.com",
    "81462.site",
    "816206.com",
    "816qs.com",
    "8179927.com",
    "8187222.com",
    "8190.fun",
    "8191.at",
    "819110.com",
    "819760.com",
    "81baby.com",
    "81cnb.space",
    "81iot.com",
    "81qtwk.site",
    "8218d.club",
    "821e54e.xyz",
    "821xc.space",
    "8220.fun",
    "82299pay.com",
    "822xc.space",
    "8236552.com",
    "824351081.xyz",
    "8250o.com",
    "8260213.com",
    "8260613.com",
    "8261013.com",
    "8261313.com",
    "8261513.com",
    "8262413.com",
    "8262513.com",
    "8262613.com",
    "826297.com",
    "8263513.com",
    "8263813.com",
    "8264213.com",
    "8264313.com",
    "8264513.com",
    "8265013.com",
    "8265913.com",
    "8266613.com",
    "8268013.com",
    "8268213.com",
    "8268513.com",
    "8268613.com",
    "8268913.com",
    "8269013.com",
    "8269513.com",
    "826xc.space",
    "8282-tit.com",
    "8282pa.com",
    "82842.monster",
    "8290.com",
    "82c8.com",
    "82cnb.space",
    "82mss4.site",
    "8309.fun",
    "8312.fun",
    "83127.monster",
    "8336552.com",
    "8350.fun",
    "8351399.com",
    "8351699.com",
    "8351799.com",
    "8352099.com",
    "8352299.com",
    "8352599.com",
    "8352p.com",
    "8353099.com",
    "8353199.com",
    "8353299.com",
    "8353399.com",
    "8353599.com",
    "8353799.com",
    "8355.host",
    "8355099.com",
    "8355399.com",
    "8355566.net",
    "8355699.com",
    "8355799.com",
    "8356099.com",
    "8356299.com",
    "8356599.com",
    "8356699.com",
    "8356799.com",
    "8357099.com",
    "8357299.com",
    "8357399.com",
    "8357699.com",
    "8357899.com",
    "8358199.com",
    "8358399.com",
    "8358699.com",
    "8359199.com",
    "8359599.com",
    "8359699.com",
    "835qs.com",
    "8360199.com",
    "8360299.com",
    "8360399.com",
    "8360699.com",
    "8361399.com",
    "8361699.com",
    "8361899.com",
    "8362599.com",
    "8362799.com",
    "8363099.com",
    "8363199.com",
    "8363299.com",
    "8363399.com",
    "8363799.com",
    "8363899.com",
    "8365199.com",
    "8365299.com",
    "8365599.com",
    "8365799.com",
    "8365899.com",
    "8366099.com",
    "8366799.com",
    "8366899.com",
    "8367199.com",
    "8367299.com",
    "8367399.com",
    "8367699.com",
    "8367899.com",
    "8368299.com",
    "8368399.com",
    "8368799.com",
    "8369199.com",
    "8369299.com",
    "8369599.com",
    "837p1070n.site",
    "8382.fun",
    "8392.fun",
    "839604.icu",
    "839qs.com",
    "83a7.icu",
    "83csj0.best",
    "83gd90qriawwf.cf",
    "83gd90qriawwf.ga",
    "83gd90qriawwf.gq",
    "83gd90qriawwf.ml",
    "83gd90qriawwf.tk",
    "84310.xyz",
    "8436552.com",
    "844206.com",
    "8449955.com",
    "845097.com",
    "845102.com",
    "845103.com",
    "845106.com",
    "845137.com",
    "845144.com",
    "84517.xyz",
    "845172.com",
    "845192.com",
    "845227.com",
    "845240.com",
    "845242.com",
    "845269.com",
    "845276.com",
    "845279.com",
    "845280.com",
    "845293.com",
    "845294.com",
    "845297.com",
    "8453.fun",
    "845302.com",
    "845325.com",
    "845343.com",
    "845391.com",
    "845405.com",
    "845418.com",
    "845427.com",
    "845457.com",
    "845470.com",
    "845471.com",
    "845493.com",
    "845512.com",
    "845524.com",
    "845532.com",
    "845542.com",
    "845561.com",
    "845562.com",
    "845574.com",
    "845583.com",
    "84569.xyz",
    "847103.com",
    "847120.com",
    "847125.com",
    "847160.com",
    "847174.com",
    "847187.com",
    "847194.com",
    "847225.com",
    "847262.com",
    "847263.com",
    "847331.com",
    "847391.com",
    "847403.com",
    "847409.com",
    "847425.com",
    "847446.com",
    "847460.com",
    "847467.com",
    "847482.com",
    "847509.com",
    "847524.com",
    "847540.com",
    "847541.com",
    "84758.monster",
    "847583.com",
    "84863.monster",
    "84863.xyz",
    "849356.com",
    "84b16.club",
    "84bit.ru",
    "84mce5gufev8.cf",
    "84mce5gufev8.ga",
    "84mce5gufev8.gq",
    "84mce5gufev8.ml",
    "84mce5gufev8.tk",
    "84rhilv8mm3xut2.cf",
    "84rhilv8mm3xut2.ga",
    "84rhilv8mm3xut2.gq",
    "84rhilv8mm3xut2.ml",
    "84rhilv8mm3xut2.tk",
    "8505.fun",
    "8532.fun",
    "8538.fun",
    "8539927.com",
    "8547.fun",
    "855pkr.life",
    "858585m.com",
    "858585n.com",
    "858585o.com",
    "858585p.com",
    "858585r.com",
    "858585t.com",
    "858585v.com",
    "858585w.com",
    "858585x.com",
    "858585y.com",
    "858585z.com",
    "858ac.com",
    "859ac.com",
    "85fc653.club",
    "85it.ru",
    "85rrt.site",
    "8601.ru",
    "8618.fun",
    "8636.fun",
    "8639927.com",
    "864443.com",
    "865034.com",
    "865qs.com",
    "866303.com",
    "86682.xyz",
    "8673.fun",
    "868757.com",
    "86883hd.online",
    "86883hd.website",
    "8695.fun",
    "8696.fun",
    "8699006.com",
    "86ac26f5.club",
    "86cnb.space",
    "86d14866fx.ml",
    "86uiu.site",
    "86vns.net",
    "86xlig.us",
    "871-tit.com",
    "8715.fun",
    "8723891.com",
    "872953.com",
    "873391.com",
    "873396.com",
    "873827.com",
    "8742.website",
    "8751.fun",
    "8753.host",
    "875369.com",
    "875655234954.xyz",
    "87605599.com",
    "876518.xyz",
    "8768.fun",
    "8769827.com",
    "8769837.com",
    "8769927.com",
    "8772.fun",
    "8787733.com",
    "8789837.com",
    "879023.xyz",
    "879326.com",
    "87959app.com",
    "87959vip.com",
    "879762.com",
    "879828555.xyz",
    "8799837.com",
    "87cnb.space",
    "87e939e.club",
    "87gjgsdre2sv.cf",
    "87gjgsdre2sv.ga",
    "87gjgsdre2sv.gq",
    "87gjgsdre2sv.ml",
    "87gjgsdre2sv.tk",
    "87mmwdtf63b.cf",
    "87mmwdtf63b.ga",
    "87mmwdtf63b.gq",
    "87mmwdtf63b.ml",
    "87mmwdtf63b.tk",
    "88.am",
    "88000234.com",
    "88000345.com",
    "88000567.com",
    "88000789.com",
    "880888e.com",
    "8812.fun",
    "88122.xyz",
    "88123666.com",
    "88126.xyz",
    "88140.xyz",
    "88146.xyz",
    "8815.fun",
    "88152.xyz",
    "88153.xyz",
    "88155.xyz",
    "88161.xyz",
    "88175.xyz",
    "88176.xyz",
    "8819.fun",
    "88200.xyz",
    "88206.xyz",
    "88208.xyz",
    "88209.xyz",
    "882112233.com",
    "882112244.com",
    "882113322.com",
    "882113377.com",
    "882113399.com",
    "882114422.com",
    "882114433.com",
    "882114455.com",
    "882114477.com",
    "882114488.com",
    "882114499.com",
    "882115522.com",
    "882115544.com",
    "882115555.com",
    "882115566.com",
    "882115577.com",
    "882115588.com",
    "882115599.com",
    "882116611.com",
    "882116633.com",
    "882116644.com",
    "882116655.com",
    "882116666.com",
    "882116688.com",
    "882116699.com",
    "882117711.com",
    "882117722.com",
    "882117733.com",
    "882117744.com",
    "882117766.com",
    "882117777.com",
    "882118811.com",
    "882118822.com",
    "882118877.com",
    "882118888.com",
    "882118899.com",
    "882119900.com",
    "882119911.com",
    "882119955.com",
    "88224.xyz",
    "88227.xyz",
    "8822855.com",
    "88230.xyz",
    "88242.xyz",
    "88243.xyz",
    "88244.xyz",
    "88262.xyz",
    "88270.xyz",
    "88277.xyz",
    "8828zhuce.com",
    "88290.xyz",
    "88295.xyz",
    "88296.xyz",
    "88299.xyz",
    "88303.xyz",
    "88304.xyz",
    "88306.com",
    "88309.xyz",
    "88312.xyz",
    "88318.xyz",
    "88325.xyz",
    "88329.xyz",
    "883388211.com",
    "88356.xyz",
    "88357.xyz",
    "88365.xyz",
    "88381.xyz",
    "88387.xyz",
    "88388.org",
    "88393.xyz",
    "8839837.com",
    "88407.xyz",
    "88409.xyz",
    "88410.xyz",
    "88411.monster",
    "88412.xyz",
    "8841778.com",
    "8841878.com",
    "8842958.com",
    "88437.xyz",
    "88448.xyz",
    "884488211.com",
    "88451.xyz",
    "88454.xyz",
    "88477.xyz",
    "8848.net",
    "88492.xyz",
    "88503.xyz",
    "88506.xyz",
    "8852.fun",
    "886688211.com",
    "8867.fun",
    "888-app.ru",
    "888.luk2.com",
    "888.nu",
    "888001.xyz",
    "888005.xyz",
    "888008.xyz",
    "888234.xyz",
    "8883229.com",
    "8883236.com",
    "8883372.com",
    "8883488.com",
    "8883919.com",
    "8883936.com",
    "88868804.com",
    "88868810.com",
    "888888211.com",
    "8888bubu.com",
    "8888iii.com",
    "8888rere.com",
    "888dyqp.com",
    "888qq59.xyz",
    "888tron.biz",
    "888tron.info",
    "888tron.life",
    "888tron.net",
    "888tron.org",
    "888z5.cf",
    "888z5.ga",
    "888z5.gq",
    "888z5.ml",
    "888z5.tk",
    "889931666.com",
    "889988211.com",
    "88av.net",
    "88clean.pro",
    "88cnb.space",
    "88jin.ru",
    "88kaskings.com",
    "88kaskings.net",
    "88macaupools.com",
    "88mon.space",
    "88rbrb.com",
    "88solo.space",
    "88sun11.com",
    "88sun22.com",
    "88sun33.com",
    "88sy000.com",
    "88sy22.com",
    "88sy222.com",
    "88sy33.com",
    "88sy44.com",
    "88sy444.com",
    "88sy55.com",
    "88sy555.com",
    "88sy666.com",
    "88sy77.com",
    "88sy777.com",
    "88sy888.com",
    "88ter.space",
    "88trader.com",
    "88yiyi.com",
    "88zzf.space",
    "8906.fun",
    "891157.com",
    "891172.com",
    "891175.com",
    "8919927.com",
    "89234m.com",
    "8929927.com",
    "8938.fun",
    "893ac.com",
    "8949.fun",
    "8954.fun",
    "895971.com",
    "8959837.com",
    "8959b2.club",
    "897116.com",
    "897152.com",
    "897629.com",
    "89769988.com",
    "897744.app",
    "897925.com",
    "897su.com",
    "897tu.com",
    "897wu.com",
    "8983.fun",
    "89861.monster",
    "898ac.com",
    "899079.com",
    "8993.fun",
    "8999837.com",
    "89b8.club",
    "89dnxs.site",
    "89mom.space",
    "89sese.space",
    "89solo.space",
    "8a37d104.xyz",
    "8a4e.club",
    "8a4wcr.host",
    "8a818.club",
    "8a9itx.online",
    "8avz.net",
    "8b05kwh1y2l90cw.xyz",
    "8ballroulette.com",
    "8c03a46b.xyz",
    "8c8.club",
    "8ca761.xyz",
    "8chan.co",
    "8cl3.icu",
    "8cqznp.us",
    "8dipbk.online",
    "8dizhi.xyz",
    "8e6d9wk7a19vedntm35.cf",
    "8e6d9wk7a19vedntm35.ga",
    "8e6d9wk7a19vedntm35.gq",
    "8e6d9wk7a19vedntm35.ml",
    "8e7168b6.club",
    "8ecaf.club",
    "8eoqovels2mxnxzwn7a.cf",
    "8eoqovels2mxnxzwn7a.ga",
    "8eoqovels2mxnxzwn7a.gq",
    "8eoqovels2mxnxzwn7a.ml",
    "8eoqovels2mxnxzwn7a.tk",
    "8estcommunity.org",
    "8ev9nir3ilwuw95zp.cf",
    "8ev9nir3ilwuw95zp.ga",
    "8ev9nir3ilwuw95zp.gq",
    "8ev9nir3ilwuw95zp.ml",
    "8ev9nir3ilwuw95zp.tk",
    "8f1.club",
    "8f2bf5.club",
    "8fd1v9.us",
    "8ffn7qixgk3vq4z.cf",
    "8ffn7qixgk3vq4z.ga",
    "8ffn7qixgk3vq4z.gq",
    "8ffn7qixgk3vq4z.ml",
    "8ffn7qixgk3vq4z.tk",
    "8fmr93.us",
    "8fuur0zzvo8otsk.cf",
    "8fuur0zzvo8otsk.ga",
    "8fuur0zzvo8otsk.gq",
    "8fuur0zzvo8otsk.ml",
    "8fuur0zzvo8otsk.tk",
    "8ghfai.site",
    "8h40vw.us",
    "8hdjw.us",
    "8hfzqpstkqux.cf",
    "8hfzqpstkqux.ga",
    "8hfzqpstkqux.gq",
    "8hfzqpstkqux.ml",
    "8hfzqpstkqux.tk",
    "8hj3rdieaek.cf",
    "8hj3rdieaek.ga",
    "8hj3rdieaek.gq",
    "8hj3rdieaek.ml",
    "8hj3rdieaek.tk",
    "8hkvcr.us",
    "8i7.net",
    "8imefdzddci.cf",
    "8imefdzddci.ga",
    "8imefdzddci.gq",
    "8imefdzddci.ml",
    "8imefdzddci.tk",
    "8jstc.us",
    "8k4tns.us",
    "8kcpfcer6keqqm.cf",
    "8kcpfcer6keqqm.ml",
    "8kcpfcer6keqqm.tk",
    "8kej4c.us",
    "8klddrkdxoibtasn3g.cf",
    "8klddrkdxoibtasn3g.ga",
    "8klddrkdxoibtasn3g.gq",
    "8klddrkdxoibtasn3g.ml",
    "8klddrkdxoibtasn3g.tk",
    "8kut.us",
    "8laypf.us",
    "8live.biz",
    "8ltepf.info",
    "8m6qu.us",
    "8mail.cf",
    "8mail.ga",
    "8mail.ml",
    "8mailpro.com",
    "8mbetx.info",
    "8mbetx.org",
    "8mhjz.us",
    "8mot.ru",
    "8mpulsa.org",
    "8nbh2m.site",
    "8ndonc.us",
    "8nujq9.us",
    "8oboi80bcv1.cf",
    "8oboi80bcv1.ga",
    "8oboi80bcv1.gq",
    "8os2qr.online",
    "8pukcddnthjql.cf",
    "8pukcddnthjql.ga",
    "8pukcddnthjql.gq",
    "8pukcddnthjql.ml",
    "8pukcddnthjql.tk",
    "8px6jo.us",
    "8pyda.us",
    "8qdanx.us",
    "8qdw3jexxncwd.cf",
    "8qdw3jexxncwd.ga",
    "8qdw3jexxncwd.gq",
    "8qdw3jexxncwd.ml",
    "8qdw3jexxncwd.tk",
    "8qwh37kibb6ut7.cf",
    "8qwh37kibb6ut7.ga",
    "8qwh37kibb6ut7.gq",
    "8qwh37kibb6ut7.ml",
    "8qwh37kibb6ut7.tk",
    "8rp2rre7wn4t98s.xyz",
    "8rskf3xpyq.cf",
    "8rskf3xpyq.ga",
    "8rskf3xpyq.gq",
    "8rskf3xpyq.ml",
    "8rskf3xpyq.tk",
    "8rygn.com",
    "8t0sznngp6aowxsrj.cf",
    "8t0sznngp6aowxsrj.ga",
    "8t0sznngp6aowxsrj.gq",
    "8t0sznngp6aowxsrj.ml",
    "8t0sznngp6aowxsrj.tk",
    "8turbo.com",
    "8ujf53.com",
    "8um9zsaxf4peky7.xyz",
    "8umrsb.us",
    "8urls.gq",
    "8usmwuqxh1s1pw.cf",
    "8usmwuqxh1s1pw.ga",
    "8usmwuqxh1s1pw.gq",
    "8usmwuqxh1s1pw.ml",
    "8usmwuqxh1s1pw.tk",
    "8verxcdkrfal61pfag.cf",
    "8verxcdkrfal61pfag.ga",
    "8verxcdkrfal61pfag.gq",
    "8verxcdkrfal61pfag.ml",
    "8verxcdkrfal61pfag.tk",
    "8vkopg.us",
    "8vnond.us",
    "8wehgc2atizw.cf",
    "8wehgc2atizw.ga",
    "8wehgc2atizw.gq",
    "8wehgc2atizw.ml",
    "8wehgc2atizw.tk",
    "8wkkrizxpphbm3c.cf",
    "8wkkrizxpphbm3c.ga",
    "8wkkrizxpphbm3c.gq",
    "8wkkrizxpphbm3c.ml",
    "8wkkrizxpphbm3c.tk",
    "8wwxmcyntfrf.cf",
    "8wwxmcyntfrf.ga",
    "8wwxmcyntfrf.gq",
    "8wwxmcyntfrf.ml",
    "8x8x.site",
    "8xcdzvxgnfztticc.cf",
    "8xcdzvxgnfztticc.ga",
    "8xcdzvxgnfztticc.gq",
    "8xcdzvxgnfztticc.tk",
    "8xcfu.us",
    "8xduee.us",
    "8xfin.com",
    "8xfing.com",
    "8xfong.com",
    "8xfui.com",
    "8xfve.com",
    "8xgan.com",
    "8xgang.com",
    "8xgei.com",
    "8xgen.com",
    "8xgeng.com",
    "8xger.com",
    "8xgie.com",
    "8xgiu.com",
    "8xgong.com",
    "8xgun.com",
    "8xgve.com",
    "8xyz8.dynu.net",
    "8xzr.com",
    "8ycxiazai.com",
    "8ycxz.com",
    "8ywnv.us",
    "8zbpmvhxvue.cf",
    "8zbpmvhxvue.ga",
    "8zbpmvhxvue.gq",
    "8zbpmvhxvue.ml",
    "8zbpmvhxvue.tk",
    "90.volvo-xc.ml",
    "90.volvo-xc.tk",
    "9006l.com",
    "900br88.com",
    "900dafa.com",
    "900k.es",
    "901.email",
    "9036552.com",
    "90480.xyz",
    "906dafa.com",
    "908997.com",
    "908dafa.com",
    "9090ach.xyz",
    "9090stttn.xyz",
    "9094pay.com",
    "9094vip.com",
    "909dafa.com",
    "909mail.dk",
    "90abc.ru",
    "90bit.ru",
    "90bola.link",
    "90br88.com",
    "90catkrbne16ttvnale3924.com",
    "90catlrnmk1uutroak04863.com",
    "90caturbmk9eqxlorfe0244.com",
    "90cnb.space",
    "90dy.net",
    "90ksb.club",
    "90money90.xyz",
    "90rip.ru",
    "90set.ru",
    "90shemroon.xyz",
    "90siri90.com",
    "90sp.xyz",
    "90stttn.xyz",
    "90vipstttn.xyz",
    "90xbbt.club",
    "90xbt.club",
    "90zakhar.xyz",
    "91.land",
    "91000.com",
    "9120.info",
    "9136552.com",
    "913jg913j1t0.online",
    "913jg913j1t0.space",
    "913jg913j42i90j.online",
    "913jg913j924.online",
    "913jg913jjrbh2h4.online",
    "913jg913jjrbh2h4.space",
    "913qs.com",
    "9154.fun",
    "916w1ckjejaa140.xyz",
    "918.ninja",
    "9199837.com",
    "91b1e.xyz",
    "91cod7mjala7k99.xyz",
    "91gxfl11.info",
    "91gxfl111.info",
    "91gxfl123.info",
    "91gxfl333.info",
    "91gxfl555.info",
    "91gxfl567.info",
    "91gxfl666.info",
    "91gxfl77.info",
    "91gxfl777.info",
    "91gxfl88.info",
    "91gxfl888.info",
    "91gxfl987.info",
    "91gxfl99.info",
    "91gxfl999.info",
    "91gxflaa.info",
    "91gxflclub.info",
    "91gxflgo.info",
    "91gxflok.info",
    "91kanpian.xyz",
    "91mfsp.xyz",
    "91nydh.xyz",
    "91pan.org",
    "91rb6.xyz",
    "91sedh.xyz",
    "91shuxin.com",
    "91taoliuliang.com",
    "91zp6.xyz",
    "91zp7.xyz",
    "91zp8.xyz",
    "920qs.com",
    "921.best",
    "9213606.xn--p1ai",
    "92140.monster",
    "92178b.com",
    "92178c4.com",
    "92178c8.com",
    "92178d.com",
    "92178d1.com",
    "92178d2.com",
    "92178d4.com",
    "92178d8.com",
    "92178e.com",
    "9227bet.com",
    "9227bq.com",
    "9227dh.com",
    "9227jc.com",
    "9227xpj.com",
    "923218.com",
    "9236552.com",
    "925067429.xyz",
    "9260.dk",
    "9279837.com",
    "92macau.com",
    "92no3o.us",
    "92ooxx.xyz",
    "930.dog",
    "93144.info",
    "931512.com",
    "931862.com",
    "93398bb.com",
    "9354445.com",
    "9364943601.com",
    "9369837.com",
    "938.dog",
    "9394445.com",
    "9399837.com",
    "93cdfc.site",
    "93fxf.site",
    "93k0ldakr6uzqe.cf",
    "93k0ldakr6uzqe.ga",
    "93k0ldakr6uzqe.gq",
    "93k0ldakr6uzqe.ml",
    "93k0ldakr6uzqe.tk",
    "93solo.space",
    "9404445.com",
    "940qs.com",
    "9414.fun",
    "9414445.com",
    "9418.fun",
    "9424445.com",
    "942789.com",
    "944.dog",
    "944206.com",
    "94502.info",
    "9454445.com",
    "9461.fun",
    "9474445.com",
    "9476.fun",
    "9484445.com",
    "9495.fun",
    "949lax.com",
    "94bit.ru",
    "9504445.com",
    "9514445.com",
    "95253.monster",
    "9529837.com",
    "9536552.com",
    "95367.fun",
    "9544445.com",
    "95478.monster",
    "956ac.com",
    "957.dog",
    "959.dog",
    "95926.monster",
    "95998833.net",
    "95vbp4.us",
    "96058.monster",
    "96081.monster",
    "961.dog",
    "9619837.com",
    "96303.monster",
    "96320.xyz",
    "9634445.com",
    "964.dog",
    "9644445.com",
    "965334.com",
    "96553b.com",
    "96553c.com",
    "96553d.com",
    "96553e.com",
    "96553f.com",
    "96553g.com",
    "96553h.com",
    "96553j.com",
    "96553r.com",
    "96553ss.com",
    "96553sss.com",
    "96553t.com",
    "96553ttt.com",
    "96553u.com",
    "96553vvv.com",
    "96553w.com",
    "96553x.com",
    "96553xx.com",
    "96553y.com",
    "96553yy.com",
    "96553z.com",
    "96553zz.com",
    "9659837.com",
    "9666z.com",
    "9669837.com",
    "9694445.com",
    "9696.eu",
    "96966data.xyz",
    "9699837.com",
    "96c9236.xyz",
    "96ulas.com",
    "970.dog",
    "970av.com",
    "97138e.xyz",
    "9714445.com",
    "97178b.com",
    "97178c1.com",
    "97178c2.com",
    "97178c5.com",
    "97178c6.com",
    "97207q.com",
    "9724445.com",
    "9727a.com",
    "973.dog",
    "9734445.com",
    "97432.monster",
    "9744445.com",
    "97470.monster",
    "97471.monster",
    "9751188.net",
    "9754445.com",
    "977.dog",
    "977206.com",
    "9784445.com",
    "979.dog",
    "97949.monster",
    "97962.monster",
    "97av4.com",
    "97av5.com",
    "97b23a.club",
    "97bo2.com",
    "97bo5.com",
    "97cos.xyz",
    "97di.club",
    "97dy3.com",
    "97dy4.com",
    "97rock.com",
    "97so1ubz7g5unsqgt6.cf",
    "97so1ubz7g5unsqgt6.ga",
    "97so1ubz7g5unsqgt6.gq",
    "97so1ubz7g5unsqgt6.ml",
    "97so1ubz7g5unsqgt6.tk",
    "97sp4.com",
    "9827aa.com",
    "9827ag.com",
    "9827app.com",
    "9827bet.com",
    "9827cc.com",
    "9827d.com",
    "9827dt.com",
    "9827e.com",
    "9827eee.com",
    "9827fff.com",
    "9827ggg.com",
    "9827h.com",
    "9827hh.com",
    "9827k.com",
    "9827kkk.com",
    "9827l.com",
    "9827ll.com",
    "9827mm.com",
    "9827nn.com",
    "9827oo.com",
    "9827ooo.com",
    "9827p.com",
    "9827pp.com",
    "9827ppp.com",
    "9827qqq.com",
    "9827rrr.com",
    "9827s.com",
    "9827sq.com",
    "9827ss.com",
    "9827ttt.com",
    "9827uu.com",
    "9827uuu.com",
    "9827v.com",
    "9827vv.com",
    "9827vvv.com",
    "9827www.com",
    "9827wz.com",
    "9827xl.com",
    "9827xs.com",
    "9827xxx.com",
    "9827y.com",
    "9827yh.com",
    "9827z.com",
    "9827zz.com",
    "9827zzz.com",
    "9837aomenbaliren.com",
    "9837dl.com",
    "9837hao.com",
    "9837wap.com",
    "9837xl.com",
    "983gan.com",
    "9854445.com",
    "985466.xyz",
    "9859837.com",
    "985box.com",
    "986206.com",
    "98757.app",
    "9880388.com",
    "9880588.com",
    "9884.xyz",
    "98862.monster",
    "9889927.com",
    "9898610.com",
    "9899090.com",
    "9899w.top",
    "98bdii.site",
    "98cfc72.club",
    "98hg.bet",
    "98hgv.app",
    "98usd.com",
    "99-brand.com",
    "99.com",
    "99029.monster",
    "99061.xyz",
    "9908nn.com",
    "990amtheanswer.com",
    "99102.xyz",
    "99104.xyz",
    "99112.xyz",
    "991188211.com",
    "99120.xyz",
    "99129.xyz",
    "99131.xyz",
    "99133.xyz",
    "99140.xyz",
    "99142.xyz",
    "99161.xyz",
    "9916878.xyz",
    "99173.xyz",
    "99181.xyz",
    "99183.xyz",
    "991888h.com",
    "99191.xyz",
    "99194.xyz",
    "99197.xyz",
    "99204.xyz",
    "99211.xyz",
    "992288211.com",
    "99229.xyz",
    "99236.xyz",
    "99238.xyz",
    "99253.xyz",
    "99259.xyz",
    "9927208.com",
    "99278.xyz",
    "9927bc.com",
    "9927dh.com",
    "9927win.com",
    "99281.xyz",
    "99284.xyz",
    "992tv.fun",
    "99308.xyz",
    "99314.xyz",
    "99324.xyz",
    "99326.xyz",
    "993344.xyz",
    "99336208.club",
    "993388211.com",
    "99342.xyz",
    "99345.xyz",
    "99348.xyz",
    "99360.xyz",
    "99369.xyz",
    "99375.xyz",
    "99386.xyz",
    "99390.xyz",
    "99398.xyz",
    "99399.xyz",
    "99405.xyz",
    "99417.xyz",
    "99418.xyz",
    "99446.xyz",
    "994488211.com",
    "99450.xyz",
    "99452.xyz",
    "99458.xyz",
    "99467.xyz",
    "99469.xyz",
    "99470.xyz",
    "99471.xyz",
    "99472.xyz",
    "99484.xyz",
    "99490.xyz",
    "99491.xyz",
    "99498.xyz",
    "99534.monster",
    "995588211.com",
    "99569.monster",
    "99587.monster",
    "996688211.com",
    "997788211.com",
    "9977x.space",
    "99781.monster",
    "997f.club",
    "9985yx.com",
    "998830.xyz",
    "998boss.net",
    "999132.com",
    "9992588.com",
    "99927dh.com",
    "99927xl.com",
    "99976.monster",
    "99993339.com",
    "99999cn.com",
    "9999bbtt.com",
    "9999lulu.com",
    "9999mimi.com",
    "9999pk.xyz",
    "9999x.space",
    "999capital.com",
    "999o.buzz",
    "999rbrb.com",
    "99ac2.xyz",
    "99betbax.club",
    "99br88.com",
    "99celtabet.com",
    "99cows.com",
    "99daohang.xyz",
    "99email.xyz",
    "99experts.com",
    "99hacks.us",
    "99hgv.app",
    "99hhqp.com",
    "99hy.xyz",
    "99lb95.com",
    "99lb96.com",
    "99lb97.com",
    "99mail.cf",
    "99perkasa.com",
    "99price.co",
    "99pubblicita.com",
    "99publicita.com",
    "99rezuixin.com",
    "99sanwen.com",
    "99thstchiropracticclinic.com",
    "99top.ru",
    "99tt9.com",
    "99uuv2.com",
    "99vpn.best",
    "99x99.com",
    "99yh.app",
    "9admor.us",
    "9ale6.us",
    "9avz.net",
    "9awrr.site",
    "9b5ca5af.club",
    "9b678af.xyz",
    "9b84ade.xyz",
    "9beb1.club",
    "9c4s2z.info",
    "9c5ba9.club",
    "9cvlhwqrdivi04.cf",
    "9cvlhwqrdivi04.ga",
    "9cvlhwqrdivi04.gq",
    "9cvlhwqrdivi04.ml",
    "9cvlhwqrdivi04.tk",
    "9d666.app",
    "9daqunfzk4x0elwf5k.cf",
    "9daqunfzk4x0elwf5k.ga",
    "9daqunfzk4x0elwf5k.gq",
    "9daqunfzk4x0elwf5k.ml",
    "9daqunfzk4x0elwf5k.tk",
    "9ded2.club",
    "9dgxw.us",
    "9dp1cl0xf6ewswz.xyz",
    "9dra.us",
    "9dzinw.info",
    "9e2.xyz",
    "9e3.site",
    "9e9c6.xyz",
    "9ebrcj.us",
    "9ebrklpoy3h.cf",
    "9ebrklpoy3h.ga",
    "9ebrklpoy3h.gq",
    "9ebrklpoy3h.ml",
    "9ebrklpoy3h.tk",
    "9ejz6q.us",
    "9en6mail2.ga",
    "9et1spj7br1ugxrlaa3.cf",
    "9et1spj7br1ugxrlaa3.ga",
    "9et1spj7br1ugxrlaa3.gq",
    "9et1spj7br1ugxrlaa3.ml",
    "9et1spj7br1ugxrlaa3.tk",
    "9eyf.us",
    "9f04d.xyz",
    "9f182.xyz",
    "9f3d9ad9.club",
    "9f52.club",
    "9f6819cd.club",
    "9h2020.com",
    "9h35j9031t0.online",
    "9h35j9031t01t0.online",
    "9h35j9031t0924.online",
    "9h35j9031t0924.space",
    "9h35j90342i90j.online",
    "9h35j90342i90j.space",
    "9h35j903924.online",
    "9h35j903924.space",
    "9h35j9039241t0.online",
    "9h35j9039241t0.space",
    "9h35j903924924.online",
    "9h35j903h33u19.online",
    "9h35j903h33u19.space",
    "9h35j903vhh13h.online",
    "9h35j903vhh13h.space",
    "9h3ucx.us",
    "9hjrw90hj1t0.online",
    "9hjrw90hj1t0.space",
    "9hjrw90hj924.online",
    "9hvtig.info",
    "9hxjao.us",
    "9hzfyd7i5sbc.com",
    "9jo05w.site",
    "9k27djbip0.cf",
    "9k27djbip0.ga",
    "9k27djbip0.gq",
    "9k27djbip0.ml",
    "9k27djbip0.tk",
    "9kfttq.best",
    "9kowsr.us",
    "9l58kybst0bepmy.xyz",
    "9lbaqq.us",
    "9ljunl.us",
    "9lvkur.host",
    "9mail.cf",
    "9mail9.cf",
    "9me.site",
    "9mmovies.com",
    "9monsters.com",
    "9mot.ru",
    "9mvjk6.us",
    "9n4msc.us",
    "9nnvwy.online",
    "9nobility.ltd",
    "9nobility.network",
    "9nols.us",
    "9o04xk8chf7iaspralb.cf",
    "9o04xk8chf7iaspralb.ga",
    "9o04xk8chf7iaspralb.gq",
    "9o04xk8chf7iaspralb.ml",
    "9o8ck.us",
    "9oobs.xyz",
    "9ox.net",
    "9p0rmx.us",
    "9papa.ooo",
    "9phum.com",
    "9pmiik.us",
    "9pshkz.us",
    "9ptiwu.site",
    "9pyo.us",
    "9q.ro",
    "9q8eriqhxvep50vuh3.cf",
    "9q8eriqhxvep50vuh3.ga",
    "9q8eriqhxvep50vuh3.gq",
    "9q8eriqhxvep50vuh3.ml",
    "9q8eriqhxvep50vuh3.tk",
    "9qq59.xyz",
    "9qwkev.com",
    "9rakipbet.com",
    "9rtn5qjmug.cf",
    "9rtn5qjmug.ga",
    "9rtn5qjmug.gq",
    "9rtn5qjmug.ml",
    "9rtn5qjmug.tk",
    "9rwjfs.us",
    "9skcqddzppe4.cf",
    "9skcqddzppe4.ga",
    "9skcqddzppe4.gq",
    "9skcqddzppe4.ml",
    "9skcqddzppe4.tk",
    "9t7xuzoxmnwhw.cf",
    "9t7xuzoxmnwhw.ga",
    "9t7xuzoxmnwhw.gq",
    "9t7xuzoxmnwhw.ml",
    "9t7xuzoxmnwhw.tk",
    "9th-market-shopp.online",
    "9to5athomeclub.net",
    "9toplay.com",
    "9ufqd6.us",
    "9ufveewn5bc6kqzm.cf",
    "9ufveewn5bc6kqzm.ga",
    "9ufveewn5bc6kqzm.gq",
    "9ufveewn5bc6kqzm.ml",
    "9ufveewn5bc6kqzm.tk",
    "9ve5dz.us",
    "9vjurc.us",
    "9vlb.us",
    "9vvoccxt8t638iy.xyz",
    "9w93z8ul4e.cf",
    "9w93z8ul4e.ga",
    "9w93z8ul4e.gq",
    "9w93z8ul4e.ml",
    "9w93z8ul4e.tk",
    "9wanbetx.org",
    "9wbetx.info",
    "9wet34.accountant",
    "9x2t2amr.xyz",
    "9xcnp.icu",
    "9xmail.xyz",
    "9y00.app",
    "9y0000.app",
    "9y10.app",
    "9y11.app",
    "9y111.app",
    "9y11111.app",
    "9y222.app",
    "9y2222.app",
    "9y22222.app",
    "9y3.app",
    "9y33.app",
    "9y4.app",
    "9y5555.app",
    "9y55555.app",
    "9y66.app",
    "9y666.app",
    "9y6666.app",
    "9y66666.app",
    "9y666666.app",
    "9y7.app",
    "9y777.app",
    "9y7777.app",
    "9y77777.app",
    "9y8.app",
    "9y88.app",
    "9y888888.app",
    "9y99999.app",
    "9ya.de",
    "9yc4hw.us",
    "9youtodasbech.club",
    "9ziqmkpzz3aif.cf",
    "9ziqmkpzz3aif.ga",
    "9ziqmkpzz3aif.gq",
    "9ziqmkpzz3aif.ml",
    "9ziqmkpzz3aif.tk",
    "a-1.site",
    "a-action.ru",
    "a-b.co.za",
    "a-bc.net",
    "a-cottage.ru",
    "a-creator.ru",
    "a-dnk.ru",
    "a-fdfet.site",
    "a-great-in-jobs-in-ca.zone",
    "a-great-taxprep.fyi",
    "a-mule.cf",
    "a-mule.ga",
    "a-mule.gq",
    "a-mule.ml",
    "a-mule.tk",
    "a-player.org",
    "a-prime-macular-degeneration.fyi",
    "a-sen.ru",
    "a-spy.xyz",
    "a-takamnan.ru",
    "a-tb.biz",
    "a.a.fbmail.usa.cc",
    "a.b.c.netmail.tk",
    "a.betr.co",
    "a.hido.tech",
    "a.kerl.gq",
    "a.mailcker.com",
    "a.org.ua",
    "a.sach.ir",
    "a.uditt.cf",
    "a.vztc.com",
    "a.wxnw.net",
    "a.yertxenor.tk",
    "a0.igg.biz",
    "a01a3c.club",
    "a01h3.com",
    "a02sjv3e4e8jk4liat.cf",
    "a02sjv3e4e8jk4liat.ga",
    "a02sjv3e4e8jk4liat.gq",
    "a02sjv3e4e8jk4liat.ml",
    "a02sjv3e4e8jk4liat.tk",
    "a0f7ukc.com",
    "a0txa.icu",
    "a0ywhm.us",
    "a1.net",
    "a1.usa.cc",
    "a10mail.com",
    "a15jh.site",
    "a1678991.xyz",
    "a1aemail.win",
    "a1b2.cf",
    "a1b2.gq",
    "a1b2.ml",
    "a1bvcfdg.xyz",
    "a1exch.com",
    "a1ymj4ef705tmzm.xyz",
    "a2.flu.cc",
    "a23.buzz",
    "a2hb36-mail.xyz",
    "a2mail.info",
    "a2mail.website",
    "a2miravanbrenk.xyz",
    "a2msolutions.com",
    "a2thfixer.com",
    "a2z4u.net",
    "a389f2.club",
    "a39tx.site",
    "a3an.com",
    "a3ho7tlmfjxxgy4.cf",
    "a3ho7tlmfjxxgy4.ga",
    "a3ho7tlmfjxxgy4.gq",
    "a3ho7tlmfjxxgy4.ml",
    "a3ho7tlmfjxxgy4.tk",
    "a40.com",
    "a41odgz7jh.com",
    "a41odgz7jh.com.com",
    "a45.in",
    "a458a534na4.cf",
    "a46yv.site",
    "a4craft.ru",
    "a4dine.online",
    "a4h4wtikqcamsg.cf",
    "a4h4wtikqcamsg.ga",
    "a4h4wtikqcamsg.gq",
    "a4hk3s5ntw1fisgam.cf",
    "a4hk3s5ntw1fisgam.ga",
    "a4hk3s5ntw1fisgam.gq",
    "a4hk3s5ntw1fisgam.ml",
    "a4hk3s5ntw1fisgam.tk",
    "a4optovik.ru",
    "a4otpg.us",
    "a4papersize.net",
    "a4rpeoila5ekgoux.cf",
    "a4rpeoila5ekgoux.ga",
    "a4rpeoila5ekgoux.gq",
    "a4rpeoila5ekgoux.ml",
    "a4rpeoila5ekgoux.tk",
    "a4snab.ru",
    "a4zerwak0d.cf",
    "a4zerwak0d.ga",
    "a4zerwak0d.gq",
    "a4zerwak0d.ml",
    "a4zerwak0d.tk",
    "a50502.com",
    "a50kvw.info",
    "a52ep.site",
    "a54pd15op.com",
    "a55app.com",
    "a57wb.com",
    "a5freighter.website",
    "a5i7sp.us",
    "a5m9aorfccfofd.cf",
    "a5m9aorfccfofd.ga",
    "a5m9aorfccfofd.gq",
    "a5m9aorfccfofd.ml",
    "a5xi.us",
    "a60609.com",
    "a6185.xyz",
    "a69hi.space",
    "a6a.nl",
    "a6lrssupliskva8tbrm.cf",
    "a6lrssupliskva8tbrm.ga",
    "a6lrssupliskva8tbrm.gq",
    "a6lrssupliskva8tbrm.ml",
    "a6lrssupliskva8tbrm.tk",
    "a6treaty.website",
    "a722552.com",
    "a7665.com",
    "a78qp.com",
    "a78tuztfsh.cf",
    "a78tuztfsh.ga",
    "a78tuztfsh.gq",
    "a78tuztfsh.ml",
    "a78tuztfsh.tk",
    "a7996.com",
    "a7family.net",
    "a7lashe.com",
    "a7qoei.us",
    "a80jx.space",
    "a84doctor.com",
    "a85555.com",
    "a87777.com",
    "a8cycle.website",
    "a8i.cz",
    "a90906.com",
    "a90907.com",
    "a90908.com",
    "a94gl.site",
    "a9523b38.club",
    "a97ag.com",
    "a9jcqnufsawccmtj.cf",
    "a9jcqnufsawccmtj.ga",
    "a9jcqnufsawccmtj.gq",
    "a9jcqnufsawccmtj.ml",
    "a9jcqnufsawccmtj.tk",
    "a9miyu.us",
    "aa-jlb.com",
    "aa.da.mail-temp.com",
    "aa0318.com",
    "aa0765.com",
    "aa1775.com",
    "aa2465.com",
    "aa4773.com",
    "aa57822.com",
    "aa5j3uktdeb2gknqx99.ga",
    "aa5j3uktdeb2gknqx99.ml",
    "aa5j3uktdeb2gknqx99.tk",
    "aa5zy64.com",
    "aa6pmo.us",
    "aa7252.com",
    "aa89.xyz",
    "aa9827.com",
    "aa9vun.us",
    "aaaa22222.info",
    "aaaa66666.info",
    "aaaaaaa.de",
    "aaaagency.net",
    "aaamail.online",
    "aaamail.zzn.com",
    "aaaw45e.com",
    "aabamian.site",
    "aabatriu.site",
    "aabbt.com",
    "aacons.site",
    "aad9qcuezeb2e0b.cf",
    "aad9qcuezeb2e0b.ga",
    "aad9qcuezeb2e0b.gq",
    "aad9qcuezeb2e0b.ml",
    "aad9qcuezeb2e0b.tk",
    "aafabet.com",
    "aafddz.ltd",
    "aag6.live",
    "aagijim.site",
    "aahlife.com",
    "aaimbees.site",
    "aaj-ekb.ru",
    "aajj234.com",
    "aajlayj.website",
    "aakashbansal.info",
    "aakashrelan.com",
    "aakk.de",
    "aalaa4.xyz",
    "aalimli4.site",
    "aalishaan.ooo",
    "aall.de",
    "aallaa.org",
    "aalna.org",
    "aalsmeerrp.online",
    "aalsmeerrp.shop",
    "aamail.co",
    "aamail.net",
    "aamanah.cf",
    "aaoqzf.us",
    "aap79.com",
    "aaphace.ml",
    "aaphace1.ga",
    "aaphace2.cf",
    "aaphace3.ml",
    "aaphace4.ga",
    "aaphace5.cf",
    "aaphace6.ml",
    "aaphace7.ga",
    "aaphace8.cf",
    "aaphace9.ml",
    "aapiesnetwork.online",
    "aaplgroup.info",
    "aapt.net.au",
    "aardvarkcomputers.net",
    "aarkolt.com",
    "aaronbriggs.buzz",
    "aaronkwok.net",
    "aaronson.cf",
    "aarpal.tokyo",
    "aasgashashashajh.cf",
    "aasgashashashajh.ga",
    "aasgashashashajh.gq",
    "aatch.net",
    "aautostabilbetsnup.xyz",
    "aavaceroo.site",
    "aazdey.us",
    "ab-demo.com",
    "ab-institute.com",
    "ab-volvo.cf",
    "ab-volvo.ga",
    "ab-volvo.gq",
    "ab-volvo.ml",
    "ab-volvo.tk",
    "ab0.igg.biz",
    "ab789bet.com",
    "abab11111.info",
    "ababmail.ga",
    "abac-compressoren.ru",
    "abacuswe.us",
    "abagael.best",
    "abakiss.com",
    "abalapmag.ml",
    "abandonee.info",
    "abanksat.us",
    "abanpub.com",
    "abarrotesfanny.com",
    "abarth.ga",
    "abarth.gq",
    "abarth.tk",
    "abasdes.com",
    "abasem.gq",
    "abasem.tk",
    "abaspolybank.com",
    "abastecedoragrafica.com",
    "abaytiegypt.com",
    "abb.dns-cloud.net",
    "abb.dnsabr.com",
    "abbassalameh.website",
    "abbeygate-portugal.com",
    "abbeyroadlondon.co.uk",
    "abbiebarrett.buzz",
    "abbonamenti.click",
    "abbonamenti.gratis",
    "abbonamentigratis.online",
    "abbonamentitv.click",
    "abbonamentitv.gratis",
    "abbonamentitv.net",
    "abbstore.website",
    "abc.com",
    "abc1.ch",
    "abcaga.ga",
    "abcaga.gq",
    "abcaga.ml",
    "abcaptcha.com",
    "abcda.tech",
    "abcdef1234abc.ml",
    "abcdefghijklmnopqrstuvwxyzabcdefghijklmnopqrstuvwxyzabcdefghijk.com",
    "abcdiscoverycenter.com",
    "abcflash.net",
    "abcfunding.xyz",
    "abcinema.xyz",
    "abcmail.email",
    "abcmail.men",
    "abcsport.xyz",
    "abcstore.icu",
    "abctoto.biz",
    "abctoto.live",
    "abctq.com",
    "abcz.info.tm",
    "abdathletics.com",
    "abdominoplastylongisland.com",
    "abdomiylcu.space",
    "abducent.site",
    "abductttmz.site",
    "abdulnour.com",
    "abdvawssas.icu",
    "abednegocoffee.org",
    "abedwvas.icu",
    "abegegr0hl.cf",
    "abegegr0hl.ga",
    "abegegr0hl.gq",
    "abegegr0hl.ml",
    "abegegr0hl.tk",
    "abejar-uy.com",
    "abejn.site",
    "abeloori.com",
    "abenzymes.us",
    "aberdeenfans.co.uk",
    "abereceipes.xyz",
    "aberystwyth.com",
    "abesanss.space",
    "abessdesign.xyz",
    "abexag.ml",
    "abexag.tk",
    "abg0i9jbyd.cf",
    "abg0i9jbyd.ga",
    "abg0i9jbyd.gq",
    "abg0i9jbyd.ml",
    "abg0i9jbyd.tk",
    "abhatil.cf",
    "abhatil.ga",
    "abhatil.gq",
    "abhishek.site",
    "abiasa.online",
    "abigail11halligan.ga",
    "abigail69.sexy",
    "abigcruisesfab.live",
    "abigcruisesfan.live",
    "abigcruisesget.live",
    "abilify.site",
    "abilityskillup.info",
    "abilitywe.us",
    "abillity.tech",
    "abimillepattes.com",
    "abirelwardmaternelle.com",
    "abista.space",
    "abkcnjiga.com",
    "ablegkiy.site",
    "ablombards.info",
    "abloomingscribe.com",
    "ablpoker.online",
    "abmoney.xyz",
    "abnamro.usa.cc",
    "abnasi.cf",
    "abnasi.gq",
    "abnasi.ml",
    "abnasi.tk",
    "abnemd.site",
    "abnermontessori.org",
    "abobrain.mobi",
    "abodemaldives.com",
    "abogadanotariapr.com",
    "abogadodeaccidentehouston.net",
    "abogadomall.com",
    "abogadoporminuto.com",
    "abol.gq",
    "abolition-now.com",
    "abolizers.fun",
    "abondance.info",
    "abone.us",
    "abook.buzz",
    "aboral.xyz",
    "abosgratis.com",
    "abosnypizza.com",
    "about.com",
    "aboutallah.net",
    "aboutfitness.net",
    "aboutphones.club",
    "aboutphones.xyz",
    "abovde.cf",
    "abovde.gq",
    "above-ton.xyz",
    "abovewe.us",
    "abpaness.cf",
    "abpaness.gq",
    "abpaness.ml",
    "abparkncharge.com",
    "abqdubop.site",
    "abredoik.ga",
    "abriment.net",
    "abrminer.com",
    "abrmining.com",
    "abroad.pub",
    "abrs.email",
    "abrucht.site",
    "abs-esp.ru",
    "abs-shaper.info",
    "absetesen.tk",
    "absity.live",
    "absixpack.info",
    "absolut-digital.dev",
    "absolut-partner.ru",
    "absolutecarefunerals.com",
    "absolutepaintingcompany.com",
    "absolutesuccess.win",
    "absolutevitality.com",
    "absolutewe.us",
    "abstract.cafe",
    "abstracter.site",
    "abstractiontechnology.com",
    "abstractmovieposters.com",
    "absurdcam.com",
    "abt-travel.mobi",
    "abt90.design",
    "abt90ap.info",
    "abt90ap.org",
    "abt90bet.net",
    "abt90ll.org",
    "abtw.de",
    "abudhabi-lottery.info",
    "abudhabi-lottery.net",
    "abudhabi-lottery.org",
    "abudhabirealestate.biz",
    "abudhabirentals.net",
    "abundantwe.us",
    "abuseknowledge.info",
    "abusemail.de",
    "abuser.eu",
    "abuyatheem.com",
    "abuzzcreative.host",
    "abv.bg",
    "abvbook.com",
    "abwesend.de",
    "abx90x.xyz",
    "abycrm.ru",
    "abyrnelaw.com",
    "abyssemail.com",
    "abyssmail.com",
    "abza.email",
    "abzaretehran.com",
    "abzokt.ru",
    "ac-jk.com",
    "ac-nation.club",
    "ac-strasbourg.fr",
    "ac20mail.in",
    "ac3d64b9a4n07.cf",
    "ac3d64b9a4n07.ga",
    "ac3d64b9a4n07.gq",
    "ac3d64b9a4n07.tk",
    "ac4d.online",
    "ac895.cf",
    "ac895.ga",
    "ac895.gq",
    "ac895.ml",
    "ac99dollars.com",
    "ac9fqq0qh6ucct.cf",
    "ac9fqq0qh6ucct.ga",
    "ac9fqq0qh6ucct.gq",
    "ac9fqq0qh6ucct.ml",
    "ac9fqq0qh6ucct.tk",
    "acaccoun.ga",
    "acaccoun.ml",
    "acaccoun.tk",
    "academiccommunity.com",
    "academycougars.com",
    "academyofleadership.global",
    "academyofmissionrenewal.com",
    "academywe.us",
    "acaiycongelados.com",
    "acaneed.ga",
    "acaneed.gq",
    "acaneed.ml",
    "acapitolaffair.com",
    "acara-nesa.ru",
    "acbuk.site",
    "acc24h.shop",
    "acc2t9qnrt.cf",
    "acc2t9qnrt.ga",
    "acc2t9qnrt.gq",
    "acc2t9qnrt.ml",
    "acc2t9qnrt.tk",
    "accamail.com",
    "accanext.org",
    "acccheaps.com",
    "accebay.site",
    "acceleratewe.us",
    "accentri.com",
    "accenture-rugby.com",
    "accentwe.us",
    "acceptwe.us",
    "acceso.or.cr",
    "accesorii.info",
    "access4less.net",
    "accesschicago.net",
    "accessgcc.com",
    "accesshigh.win",
    "accessibletraveleurope.com",
    "accessoire-piscine-accessoire.net",
    "accez.site",
    "accidentaladversary.com",
    "accidentalopiodaddiction.info",
    "accidentalopiodaddiction.net",
    "accidentalopiodaddiction.org",
    "accidentattorneyct.net",
    "accidentattorneysalaska.com",
    "accidentes.art",
    "accidentlawcolorado.com",
    "accidentlawyerct.net",
    "acciobit.net",
    "accion.ngo",
    "acclaimwe.us",
    "acclimatize495ok.online",
    "accminscard.com",
    "accmt-servicefundsprefer.com",
    "accord.ong",
    "accordcomm.com",
    "accordwe.us",
    "accordwood.top",
    "accountabilitycalendar.com",
    "accountant.com",
    "accountanten.com",
    "accountantruth.cf",
    "accounts-datalyticsbase.online",
    "accounts-login.ga",
    "accounts4sell.com",
    "accreditedwe.us",
    "accsstripe.com",
    "acctokensme.com",
    "accur8.net",
    "accuranker.tech",
    "accuratecallabs.net",
    "accurateforum.info",
    "accuratehealthman.xyz",
    "acd0.xyz",
    "acdcfan.com",
    "acdczone.com",
    "ace-11111.com",
    "ace-mail.net",
    "ace-of-base.com",
    "ace.ace.gy",
    "ace333.info",
    "aceaf.live",
    "acebabe.com",
    "acee9.live",
    "aceh.coffee",
    "aceiio.space",
    "aceleradionsdaleitura.info",
    "aceleradordaleitura.online",
    "aceleradores-bronceado.com",
    "acem2021.com",
    "acemail.info",
    "acemovingservices.com",
    "acemr.live",
    "acentri.com",
    "aceohm.com",
    "acerest.xyz",
    "acesandale.com",
    "acesatmelb.com",
    "aceslot888.net",
    "aceuh.com",
    "acfddy.ltd",
    "acfunny.site",
    "acg.news",
    "acg11.com",
    "acg8.com",
    "acgapk.com",
    "acgapp.com",
    "acgapp.hk",
    "acgbits.com",
    "acgblog.net",
    "acgcard.com",
    "acgcdn.com",
    "acgchan.com",
    "acgcili.com",
    "acgcms.com",
    "acgdoge.com",
    "acgdown.com",
    "acgfile.com",
    "acghj.com",
    "acgjob.com",
    "acgleaderboard.info",
    "acglib.com",
    "acglist.com",
    "acgmark.com",
    "acgmaster.com",
    "acgmetals.com",
    "acgn.best",
    "acgn.info",
    "acgnapp.com",
    "acgnote.com",
    "acgpad.com",
    "acgpage.com",
    "acgpic.com",
    "acgplan.com",
    "acgproxy.com",
    "acgpt.com",
    "acgpush.com",
    "acgqun.com",
    "acgsearch.com",
    "acgsns.com",
    "acgsong.com",
    "acgstory.com",
    "acgsuki.com",
    "acgtest.com",
    "acgtorrent.com",
    "acgtt.com",
    "acgtube.com",
    "acgtxt.com",
    "acgui.com",
    "acgup.com",
    "acgvpn.com",
    "acgwear.com",
    "acgwiki.org",
    "ach0u.info",
    "ach90.xyz",
    "ach90ach.xyz",
    "achatz.ga",
    "achievementwe.us",
    "achieversconsulting.org",
    "achievewe.us",
    "achievewithdenise.com",
    "achievingbalancedliving.com",
    "achillesinvestment.com",
    "achillesinvestments.com",
    "achoevacu.com",
    "achterhoekrp.online",
    "acidlsdpyshop.com",
    "acipoker.net",
    "aclothespeak.site",
    "acmecity.com",
    "acmeco.tk",
    "acmehpunk.ga",
    "acmehpunk.gq",
    "acmemail.net",
    "acmemessaging.com",
    "acmenet.org",
    "acmilanbangilan.cf",
    "acmuci.org",
    "acnatu.com",
    "acninc.net",
    "acogab.ga",
    "acogab.gq",
    "acogab.ml",
    "acoolday.com",
    "acornwe.us",
    "acousticcafenh.com",
    "acpodo.cf",
    "acpodo.ga",
    "acpodo.gq",
    "acpodo.ml",
    "acpodo.tk",
    "acpokerguide.com",
    "acq.cz",
    "acqm38bmz5atkh3.cf",
    "acqm38bmz5atkh3.ga",
    "acqm38bmz5atkh3.gq",
    "acqm38bmz5atkh3.ml",
    "acqm38bmz5atkh3.tk",
    "acqnl9.download",
    "acquaintance70.cf",
    "acquaintance70.ga",
    "acquaintance70.gq",
    "acquaintance70.ml",
    "acquaintance70.tk",
    "acreno.info",
    "acreno.services",
    "acres.asia",
    "acro.video",
    "acrobatmail.com",
    "acroyoga.academy",
    "acroyoga.agency",
    "acroyoga.app",
    "acroyoga.cam",
    "acroyoga.fun",
    "acroyoga.ltd",
    "acroyogaballet.com",
    "acroyogabook.com",
    "acroyogadance.academy",
    "acroyogadance.club",
    "acroyogadance.coach",
    "acroyogadance.fun",
    "acroyogadanceacademy.com",
    "acroyogadanceteachertraining.online",
    "acroyogateachertraining.online",
    "acroyogavinyasa.com",
    "acrylicnumberplate.com",
    "acrylicwe.us",
    "acs.net",
    "acsalaska.net",
    "acserveur.net",
    "actdiets.com",
    "actemrainformation.net",
    "actemrainfusion.com",
    "actemrainfusion.net",
    "actemrainsights.net",
    "actemraiv.com",
    "actemralawsuit.com",
    "actemralawsuit.net",
    "actemralawsuits.com",
    "actemralies.com",
    "acticipate.com",
    "actimask.info",
    "actingblog.com",
    "actiplaster.com",
    "actipotenssolution.online",
    "activarmisiones.org",
    "activate.insure",
    "activatewe.us",
    "activator.cf",
    "activatormail.com",
    "active-future-vendor.space",
    "active-marketing-official.ru",
    "active.so",
    "activeaginggame.com",
    "activecaptains.com",
    "activecrypto.online",
    "activeonlineshoppers.info",
    "activestore.xyz",
    "activewellnessfitnessbootcamp.com",
    "activist.com",
    "activites-cyclistes-ufolep.info",
    "activity.market",
    "activitywe.us",
    "actrevenge.us",
    "actrosday.site",
    "actrucla.ga",
    "actrucla.tk",
    "acttruckstaffing.us",
    "actual-stv.ru",
    "actyvate.org",
    "acuarun.com",
    "acucre.com",
    "acuitywe.us",
    "acuk.top",
    "acumendart-forcepeace-darter.com",
    "acumensavvyagility-flair.com",
    "acumenwe.us",
    "acunsleep.cf",
    "acunsleep.ga",
    "acunsleep.gq",
    "acunsleep.tk",
    "acusupply.com",
    "acutechrealty.org",
    "acuteiro.space",
    "acuteswor.us",
    "acvihis.cf",
    "acvihis.gq",
    "acvihis.tk",
    "acvllc.org",
    "acwdgq.us",
    "acwiki.com",
    "acwritav.cf",
    "acwritav.ga",
    "acwritav.ml",
    "acyclovir.website",
    "acys.de",
    "acysw.info",
    "aczbej.info",
    "ad-schoonmaak-hygiene.site",
    "ad0676d.xyz",
    "ad165.com",
    "ad1zpg.us",
    "ad2linx.net",
    "ad2linx.org",
    "ad6.net",
    "ada-duit.ga",
    "ada-janda.ga",
    "adadass.cf",
    "adadass.ga",
    "adadass.gq",
    "adadass.ml",
    "adadass.tk",
    "adal33.net",
    "adal34.net",
    "adal36.com",
    "adal38.com",
    "adal39.net",
    "adal40.net",
    "adal41.com",
    "adal41.net",
    "adal43.com",
    "adal45.net",
    "adal46.net",
    "adal47.com",
    "adal48.com",
    "adal49.net",
    "adal50.com",
    "adam.com.au",
    "adamand.info",
    "adamastore.co",
    "adamvelma.com",
    "adanademirsporkulubu.xyz",
    "adapazarihost.xyz",
    "adapazarirehber.xyz",
    "adapticlass.org",
    "adaptivewe.us",
    "adaptivno.icu",
    "adaptwe.us",
    "adasupeyzaj.xyz",
    "adax360.com",
    "adbet.co",
    "adbheg.net",
    "adblockerhyper.us",
    "adblog.com",
    "adc71.space",
    "adcar.pro",
    "adcat.network",
    "adclaborataries.com",
    "adcloud.us",
    "adcpharmaceutical.com",
    "adctreatment.com",
    "add3000.pp.ua",
    "addcharlotte.com",
    "addcom.de",
    "addevalue.com",
    "addgabriella.com",
    "addictedtogirls.com",
    "addictingtrailers.com",
    "addictioncontentwriters.com",
    "addictioncontentwriters.info",
    "addictioncontentwriters.net",
    "addictioninterventionhelp.com",
    "addictionmarketingethics.info",
    "addictionmarketingethics.net",
    "addictionnj.com",
    "addictiontreatmentcenterwebdesign.com",
    "addictiontreatmentethics.info",
    "addictiontreatmentmarketingethics.com",
    "addictiontreatmentmarketingethics.info",
    "addimagestore.com",
    "addio-tossine.com",
    "addiostanchezza.com",
    "addique.com",
    "additiavux.fun",
    "additioncorp.net",
    "addixtions.com",
    "addonupdater.com",
    "address.com",
    "addressunlock.com",
    "adduguesthouses.com",
    "addyoubooks.com",
    "adecad.tk",
    "adel.asia",
    "adelaide.bike",
    "adelakhunova.site",
    "adelarthra.best",
    "adelbets.biz",
    "adelphia.net",
    "adept.dev",
    "adeptwe.us",
    "adesaoapp.online",
    "adesktop.com",
    "adexec.com",
    "adf4th.us",
    "adfarrow.com",
    "adfly.comx.cf",
    "adfuard.com",
    "adgloselche.esmtp.biz",
    "adgrant.services",
    "adguemin.ga",
    "adguemin.ml",
    "adguemin.tk",
    "adhaute.com",
    "adhibit.site",
    "adhong.com",
    "adidasibuni.info",
    "adidasisport.info",
    "adilub.com",
    "adinet.com.uy",
    "adins.website",
    "adios.net",
    "adipex7z.com",
    "adiq.eu",
    "adirondackhearthandhome.com",
    "aditavideo.icu",
    "aditiwedsvinay.com",
    "aditus.info",
    "adiyamanevlilik.xyz",
    "adjun.info",
    "adjustmyfontsize.com",
    "adjwsaws.icu",
    "adk66.ru",
    "adkecochecking.com",
    "adlinking2.com",
    "adlinks.org",
    "adlinx.org",
    "adlioprof.cf",
    "adlioprof.gq",
    "adlioprof.ml",
    "adlioprof.tk",
    "adm2work.xyz",
    "admf12.site",
    "admimailer2.com",
    "admin-jg.com",
    "admin-panels.xyz",
    "admin-pt.com",
    "admin-ru.ru",
    "admin.in.th",
    "admin4cloud.net",
    "adminator.ru",
    "adminiecqp.online",
    "adminiecqp.ru",
    "administratiemedewerkers.com",
    "administrativos.com",
    "adminlette.org",
    "admins.page",
    "admiral-casino.win",
    "admiral1.best",
    "admiral4.best",
    "admiral5.best",
    "admiralcazino777.com",
    "admiralwe.us",
    "admiralx-mobile.xyz",
    "admiralx-vhod.com",
    "admnt-k.net",
    "adnc7mcvmqj0qrb.cf",
    "adnc7mcvmqj0qrb.ga",
    "adnc7mcvmqj0qrb.gq",
    "adnc7mcvmqj0qrb.ml",
    "adnc7mcvmqj0qrb.tk",
    "adnocogtechnologies.com",
    "adnzxh.com",
    "ado888.biz",
    "ado888.xyz",
    "adobe-masters.ru",
    "adobeccepdm.com",
    "adolescenteatingdisorderplan.com",
    "adolescenteatingdisorderprogram.com",
    "adolescenteatingdisorderprogramreviews.com",
    "adolescenteatingdisorderprograms.com",
    "adolescenteatingdisordertreatmentcenters.com",
    "adolescentedtreatmentcenters.com",
    "adolf-hitler.cf",
    "adolf-hitler.ga",
    "adolf-hitler.gq",
    "adolf-hitler.ml",
    "adonghotel.com",
    "adoniswe.us",
    "adoption.com",
    "adoptionfraudnetwork.com",
    "adopzen.com",
    "adorncosmetics.us",
    "ados.fr",
    "adottouncane.net",
    "adpings.com",
    "adpmfxh0ta29xp8.cf",
    "adpmfxh0ta29xp8.ga",
    "adpmfxh0ta29xp8.gq",
    "adpmfxh0ta29xp8.ml",
    "adpmfxh0ta29xp8.tk",
    "adpozium.ru",
    "adprofjub.cf",
    "adprofjub.tk",
    "adpugh.org",
    "adpurl.com",
    "adrakhmanovart.online",
    "adramail.com",
    "adrenalinefreak.com",
    "adres.nl",
    "adresseemailtemporaire.com",
    "adriacardsy.info",
    "adrianou.gq",
    "adrianraharja.uk.to",
    "adriaticmail.com",
    "adriveriep.com",
    "adrmwn.me",
    "adroit.asia",
    "adry.cloud",
    "adscert.net",
    "adsd.org",
    "adsensesite.shop",
    "adshealth.xyz",
    "adsondeal.icu",
    "adsorboil.com",
    "adspecials.us",
    "adsphere.online",
    "adstabym.cf",
    "adstabym.ml",
    "adstabym.tk",
    "adstra.dev",
    "adtalarmsbuffalo.com",
    "adtemps.org",
    "adtraden.cf",
    "adtraden.ga",
    "adtraden.gq",
    "adtraden.tk",
    "adu368.net",
    "adubacarat.org",
    "adubiz.info",
    "adult-biz-forum.com",
    "adult-work.info",
    "adultbabybottles.com",
    "adultbadlist.com",
    "adultcamzlive.com",
    "adultdayhealth.info",
    "adultexile.com",
    "adulthosting.club",
    "adulthublink.org",
    "adultlearner360.com",
    "adultlivingcommunity.org",
    "adultlivingcommunityinfo.com",
    "adultnobl.recipes",
    "adultop.icu",
    "adultop.xyz",
    "adultoper.xyz",
    "adultosmayores.org",
    "adultpian.icu",
    "adulttimestore.com",
    "adultuk.xxx",
    "adultvidlite.com",
    "aduqq.org",
    "adv-ingames.club",
    "adv-plus.ru",
    "advair.website",
    "advalvas.be",
    "advance-edit.com",
    "advanceamk.online",
    "advanced-chiro-center.com",
    "advanced-medical-supplements.app",
    "advanceddiversification.com",
    "advancedinternetmedia.com",
    "advancedmedicalnetwork.info",
    "advancedsurvival.net",
    "advanceedit.com",
    "advanceskinfitness.com",
    "advanstarhealthcare.com",
    "advantage-intentions.site",
    "advantage-smart.site",
    "advantage-study.site",
    "advantagechoice.site",
    "advantageintentions.site",
    "advantagesmart.site",
    "advantagestudy.site",
    "advantagewe.us",
    "advantek1.ru",
    "advantimal.com",
    "advantimals.com",
    "advantimo.com",
    "advapp.ru",
    "advd.site",
    "advdent.net",
    "advents.icu",
    "adventurewe.us",
    "adventwe.us",
    "adventwelfare.global",
    "advertising-digitalsignage.com",
    "advertisingblog.com",
    "advertmix85.xyz",
    "adverts.page",
    "advidsesrest.xyz",
    "advious.net",
    "advious.org",
    "advisercensorshipmark.website",
    "advisorframework.com",
    "advisorwe.us",
    "advocacyanthology.com",
    "advocatewe.us",
    "advogadoespecializado.com",
    "advrocket.com",
    "advrocket.ru",
    "adwaterandstir.com",
    "adwnasw.icu",
    "adwordscontacts.com",
    "adwukong.com",
    "adx-telecom.com",
    "adyladlp.shop",
    "adzek.com",
    "ae.pureskn.com",
    "ae68790.xyz",
    "ae69a50.club",
    "ae9d1t.host",
    "aed-cbdoil.com",
    "aed5lzkevb.cf",
    "aed5lzkevb.ga",
    "aed5lzkevb.gq",
    "aed5lzkevb.ml",
    "aed5lzkevb.tk",
    "aededwed.club",
    "aegde.com",
    "aegia.net",
    "aegiscorp.net",
    "aegiswe.us",
    "aegmefquw.shop",
    "aegoneinsurance.cf",
    "aegonilfe.com",
    "aegyptisches-museum-berlin.info",
    "aeiou.pt",
    "aelbp.info",
    "aelo.es",
    "aemail4u.com",
    "aeneasmail.com",
    "aeon.tk",
    "aeonpsi.com",
    "aeorwbpox.shop",
    "aeotec.xyz",
    "aepc2022.org",
    "aepifoundation.com",
    "aepistore.net",
    "aeriesroboticsai.com",
    "aerion.mobi",
    "aerionaerospace.com",
    "aerioncorp.info",
    "aeriontechnology.com",
    "aeripix.com",
    "aeritoon.cf",
    "aero-fashion.com",
    "aerobia.com",
    "aerobicfresh.com",
    "aerodictionary.com",
    "aeronauticaldictionary.com",
    "aerospaceblog.com",
    "aerospaceglossary.com",
    "aertyeme.site",
    "aesbasns.space",
    "aesirwatches.com",
    "aesopsfables.net",
    "aestabbetting.xyz",
    "aesthetic.dev",
    "aestheticclinic.org",
    "aesthetiqveins.com",
    "aeterna.ru",
    "aetnainsurancecoversrehab.com",
    "aeze0qhwergah70.cf",
    "aeze0qhwergah70.ga",
    "aeze0qhwergah70.gq",
    "aeze0qhwergah70.ml",
    "aeze0qhwergah70.tk",
    "aezga.com",
    "af2przusu74mjzlkzuk.cf",
    "af2przusu74mjzlkzuk.ga",
    "af2przusu74mjzlkzuk.gq",
    "af2przusu74mjzlkzuk.ml",
    "af2przusu74mjzlkzuk.tk",
    "af353.com",
    "af4lqr.com",
    "afadob.cf",
    "afadob.ga",
    "afadob.gq",
    "afadog.cf",
    "afadog.ga",
    "afadog.ml",
    "afadog.tk",
    "afb.business",
    "afb.global",
    "afbarta.ga",
    "afbarta.ml",
    "afcgroup40.com",
    "afcxw.us",
    "afdzj1.site",
    "afelov.ml",
    "afelov.tk",
    "affairsprofiles.com",
    "affebe1.xyz",
    "affiliate-nebenjob.info",
    "affiliate-pari-match.com",
    "affiliatebreakthrough.com",
    "affiliatedwe.us",
    "affiliatehustle.com",
    "affilikingz.de",
    "affinityfci.com",
    "affinitywe.us",
    "affirmationassistant.com",
    "affirmhealth.net",
    "affirmhealthclinic.com",
    "affitti24.com",
    "afflated.site",
    "afflictionmc.com",
    "afflive.gq",
    "affluentwe.us",
    "affordable55apartments.com",
    "affordableattic.net",
    "affordablevisitors.com",
    "affordablewe.us",
    "affricca.com",
    "affstb.com",
    "afftar.site",
    "afganbaba.com",
    "afhu3x.best",
    "afifilm.net",
    "afiliasi-fbs.com",
    "afilmizle.online",
    "afirst.site",
    "afiscreenation.com",
    "afja4u.us",
    "afk.bet",
    "aflam06.com",
    "aflamyclub.com",
    "afmail.com",
    "afqkxvzw.xyz",
    "afrahost.net",
    "afraid.org",
    "afreeinternet.com",
    "africa-11.com",
    "africa-council.com",
    "africalibrary.org",
    "africamail.com",
    "africamel.net",
    "african-mango-opinie-cena.xyz",
    "african3000.com",
    "africanpartnersonline.com",
    "africanprogressiveeconomist.com",
    "africanthoughtpartners.com",
    "africanwildlife.tours",
    "afriel.info",
    "afriend.fun",
    "afriend.site",
    "afrikakonseyi.org",
    "afrobacon.com",
    "afrodizyakdamlalar.xyz",
    "afronorilsk.ru",
    "afroprides.com",
    "afscmelocal2181.org",
    "afsf.de",
    "aftabnetdaily.net",
    "aftarebwie.tk",
    "afteir.com",
    "aftercurro.com",
    "afterhourswe.us",
    "aftermedical.xyz",
    "afternoonchameleon.com",
    "afterpeg.com",
    "afterschoolncac.com",
    "aftership.biz",
    "afterspace.net",
    "aftertherain.icu",
    "aftksrabv.shop",
    "aftnfeyuwtzm.cf",
    "aftnfeyuwtzm.ga",
    "aftnfeyuwtzm.gq",
    "aftnfeyuwtzm.ml",
    "aftnfeyuwtzm.tk",
    "afuture.date",
    "afwira.cf",
    "afwira.ml",
    "afwira.tk",
    "afyonalisveris.xyz",
    "afyonlusanal.com",
    "afyonlusanal.xyz",
    "afyonyumurta.xyz",
    "ag.us.to",
    "ag163.top",
    "ag8.men",
    "ag95.cf",
    "ag95.ga",
    "ag95.gq",
    "ag95.ml",
    "ag95.tk",
    "agaigoizalo.com",
    "againautoparts.info",
    "againautoparts.net",
    "againsughu.website",
    "agamoney.icu",
    "aganardineroporinternet.com",
    "agapenutrition.net",
    "agaqra.cf",
    "agaqra.ga",
    "agaqra.ml",
    "agariohub.org",
    "agartutorials.com",
    "agasolicitors.org",
    "agatho.info",
    "agb7qj.site",
    "agbiome.bio",
    "agbiome.directory",
    "agbiome.live",
    "agbiome.works",
    "age-cool.ru",
    "ageathomehappy.com",
    "agedmail.com",
    "ageing-in-europe.org",
    "agelessemail.com",
    "agen-domino.top",
    "agen-poker.top",
    "agen45.biz",
    "agen45.com",
    "agen45.org",
    "agenciaemdigital.com",
    "agencyad.online",
    "agencyadvert.online",
    "agencygrowthhacking.com",
    "agencynet.us",
    "agendawe.us",
    "agendeto.com",
    "agengaming.net",
    "agengaming.org",
    "agenimc6.com",
    "agenjudieuro.com",
    "agenpulsamabruk.club",
    "agenresmipokeridn.com",
    "agent388a-casinoonline.org",
    "agentoto4d.org",
    "agentshipping.com",
    "agentsosmed.com",
    "agenziaditraduzione.com",
    "ageoftheworld.com",
    "ageofvalor.com",
    "ageousa.shop",
    "agfw01.com",
    "agger.ro",
    "aggrandized673jc.online",
    "aghoriti.website",
    "agilecoding.com",
    "agilefl.xyz",
    "agileflin.xyz",
    "agilekz.com",
    "agilewe.us",
    "agilis.cloud",
    "aginskaya.online",
    "agistore.co",
    "agkut1.site",
    "aglugimp.cf",
    "aglugimp.ga",
    "aglugimp.gq",
    "aglugimp.ml",
    "aglugimp.tk",
    "agmoney.xyz",
    "agmueidq.shop",
    "agn88.net",
    "agnachleo.ga",
    "agnachleo.ml",
    "agnachleo.tk",
    "agnxbhpzizxgt1vp.cf",
    "agnxbhpzizxgt1vp.ga",
    "agnxbhpzizxgt1vp.gq",
    "agnxbhpzizxgt1vp.ml",
    "agnxbhpzizxgt1vp.tk",
    "agocj.us",
    "agogbag.website",
    "agogogames.com",
    "agogotogel.com",
    "agonize535qq.online",
    "agonizingly7gi.online",
    "agoodmail.com",
    "agorawe.us",
    "agostabbet.xyz",
    "agovol.cf",
    "agovol.gq",
    "agq6.com",
    "agramas.cf",
    "agramas.ml",
    "agramerica.com",
    "agrariant.com",
    "agrariant.net",
    "agreeone.ga",
    "agreetoshop.com",
    "agri-profocus.com",
    "agribisnews.xyz",
    "agriculture-ball.xyz",
    "agrif.org",
    "agrifood-ric.org",
    "agrilinkllc.xyz",
    "agriologybg.info",
    "agristyleapparel.us",
    "agriturismocollepaciocco.it",
    "agriturismomontefieno.com",
    "agrofoodstartups.com",
    "agrourense.info",
    "agsf8x.us",
    "agsgames.club",
    "agskincare.us",
    "agterms.com",
    "agtx.net",
    "aguastrieastor1.business",
    "aguide.site",
    "agustaa.top",
    "agustusmp3.xyz",
    "agwbyfaaskcq.cf",
    "agwbyfaaskcq.ga",
    "agwbyfaaskcq.gq",
    "agwbyfaaskcq.ml",
    "agwbyfaaskcq.tk",
    "agwestvalley.com",
    "agxngcxklmahntob.cf",
    "agxngcxklmahntob.ga",
    "agxngcxklmahntob.gq",
    "agxngcxklmahntob.ml",
    "agxngcxklmahntob.tk",
    "ah3mto.us",
    "ahaa.dk",
    "ahamit.com",
    "ahamoney.xyz",
    "aharmovie2.info",
    "ahasavannah.com",
    "ahavastyle.com",
    "ahbapbet26.com",
    "ahbapbet27.com",
    "ahbapbet28.com",
    "ahbz.xyz",
    "aheadwe.us",
    "ahem.email",
    "ahf.ong",
    "ahffilms.com",
    "ahgae-crews.us.to",
    "ahgpharma.info",
    "ahk.jp",
    "ahketevfn4zx4zwka.cf",
    "ahketevfn4zx4zwka.ga",
    "ahketevfn4zx4zwka.gq",
    "ahketevfn4zx4zwka.ml",
    "ahketevfn4zx4zwka.tk",
    "ahmadidik.cf",
    "ahmadidik.ga",
    "ahmadidik.gq",
    "ahmadidik.ml",
    "ahmed-ould-daddah.org",
    "ahmedgomaa.tech",
    "ahmedmouici.xyz",
    "ahmetamanvermez.com",
    "ahomeforjames.org",
    "ahomesolution.com",
    "ahong142.site",
    "ahoora-band.com",
    "ahrr59qtdff98asg5k.cf",
    "ahrr59qtdff98asg5k.ga",
    "ahrr59qtdff98asg5k.gq",
    "ahrr59qtdff98asg5k.ml",
    "ahrr59qtdff98asg5k.tk",
    "ahrt.email",
    "ahsb.de",
    "ahtigames.se",
    "ahtnacontractors.com",
    "ahtnafacilityservices.com",
    "ahtnasts.org",
    "ahtongtailor.monster",
    "ahwbo1.site",
    "ahyars.site",
    "ai-pct.com",
    "ai.aax.cloudns.asia",
    "ai.edu.aiot.ze.cx",
    "ai.hsfz.info",
    "ai.vcss.eu.org",
    "ai2111.com",
    "ai4000.com",
    "ai6554.com",
    "aiadvertising.xyz",
    "aiafrica.xyz",
    "aiatlanta.xyz",
    "aiauction.xyz",
    "aiaustralia.xyz",
    "aiba777.com",
    "aibm.email",
    "aicai8.biz",
    "aicai88.biz",
    "aicai88.org",
    "aicanada.xyz",
    "aicash.one",
    "aicasino.xyz",
    "aichao5.com",
    "aichi.com",
    "aichou.org",
    "aichristmas.xyz",
    "aiciphering.com",
    "aicryptoctrading.com",
    "aidjw.space",
    "aidomain.xyz",
    "aidotcomau.com",
    "aidotcomru.com",
    "aidoushi.net",
    "aidownload.xyz",
    "aidpaidf.shop",
    "aidshops.ru",
    "aidtouchair.website",
    "aiduisoi3456ta.tk",
    "aielders.com",
    "aiemail.xyz",
    "aiemoney.xyz",
    "aienvr.com",
    "aifares.info",
    "aiflesh.com",
    "aifmhymvug7n4.ga",
    "aifmhymvug7n4.gq",
    "aifmhymvug7n4.ml",
    "aifmhymvug7n4.tk",
    "aifootballpredictions.tips",
    "aifree.xyz",
    "aigame.xyz",
    "aihent.com",
    "aihnoa.com",
    "aihongkong.xyz",
    "aiidriver.icu",
    "aiigs.live",
    "aiij8.space",
    "aiindia.xyz",
    "aiindonesia.xyz",
    "aiiots.net",
    "aiislam.xyz",
    "aiisrael.xyz",
    "aiistanbul.xyz",
    "aijiangyuan.com",
    "ailasvegas.xyz",
    "ailem.info",
    "ailluin.site",
    "ailmedia.press",
    "aim-v.ru",
    "aim.com",
    "aim.net",
    "aimeenorman.buzz",
    "aimexico.xyz",
    "aimhire.me",
    "aimodel.xyz",
    "aimupset.com",
    "ainebalara.com",
    "aink.gq",
    "aink.ml",
    "ainmedia.press",
    "ainra.space",
    "aioneclick.com",
    "aionline.xyz",
    "aiot.aiphone.eu.org",
    "aiot.creo.site",
    "aiot.creou.dev",
    "aiot.dmtc.dev",
    "aiot.ptcu.dev",
    "aiot.vuforia.us",
    "aiot.ze.cx",
    "aipi8x.com",
    "aipian.info",
    "aipp.tech",
    "aipp52.com",
    "aipp54.com",
    "aipp59.com",
    "aipp85.com",
    "aipp88.com",
    "aipptech.tech",
    "aiprogenitor.com",
    "aips.store",
    "air-blog.com",
    "air-games.icu",
    "air-tips.com",
    "air2token.com",
    "air3d.icu",
    "airaegeans.info",
    "airballons.ru",
    "airbbs.com",
    "airblasttrampolinepark.com",
    "airbnbexperts.net",
    "airbrushism.com",
    "aircapitol.net",
    "aircareshop.live",
    "aircln.ru",
    "airconditioningservicetampafl.com",
    "aircourriel.com",
    "aircraftfinishing.net",
    "aircraftmail.com",
    "airealestate.xyz",
    "aires.travel",
    "airfareswipe.com",
    "airforce.net",
    "airforceemail.com",
    "airframce.club",
    "airfresco.net",
    "airg.app",
    "airhelp.dev",
    "airhimalayas.net",
    "airhorn.org",
    "airhue.com",
    "airideas.us",
    "airjuniors.info",
    "airknox.com",
    "airlagu.me",
    "airmail.cc",
    "airmail.net",
    "airmail.tech",
    "airmailbox.website",
    "airmailhub.com",
    "airmart.ru",
    "airnons.info",
    "aironheating.com",
    "airplane2.com",
    "airplanedesire.com",
    "airpodscu.site",
    "airpodshop.shop",
    "airport-atirau.ru",
    "airportbusride.com",
    "airportendoscopy.center",
    "airportlimousinenyc.com",
    "airportparkingcincinnati.net",
    "airporttaxisinloughborough.org",
    "airporttaxisinquorn.org",
    "airpost.net",
    "airsi.de",
    "airsight.app",
    "airsofa.icu",
    "airsoftshooters.com",
    "airspaskeb.space",
    "airsport.top",
    "airwayy.us",
    "airyofe.space",
    "aiseattle.xyz",
    "aishenma.xyz",
    "aisingapore.xyz",
    "aisiys.com",
    "aisports.xyz",
    "aist-lipetsk.ru",
    "aistis.xyz",
    "aistocks.xyz",
    "aisushigranada.com",
    "aiswitzerland.xyz",
    "aitaiwan.xyz",
    "aitraffic.xyz",
    "aitravel.xyz",
    "aitu.help",
    "aity.icu",
    "aiutamici.com",
    "aivtxkvmzl29cm4gr.cf",
    "aivtxkvmzl29cm4gr.ga",
    "aivtxkvmzl29cm4gr.gq",
    "aivtxkvmzl29cm4gr.ml",
    "aivtxkvmzl29cm4gr.tk",
    "aiwan-deals.com",
    "aiwashington.xyz",
    "aiwhois.xyz",
    "aiwireless.xyz",
    "aixjbv.space",
    "aizennsasuke.cf",
    "aizennsasuke.ga",
    "aizennsasuke.gq",
    "aizennsasuke.ml",
    "aizennsasuke.tk",
    "ajacied.com",
    "ajaibtogel.website",
    "ajanlatok.online",
    "ajansesperto.site",
    "ajanslog.top",
    "ajansmaster.xyz",
    "ajansparis.xyz",
    "ajanstinder.xyz",
    "ajanstwo.xyz",
    "ajaxapp.net",
    "ajaxdesign.org",
    "ajaxsys.com",
    "ajbrosan.com",
    "ajcreationsonline.com",
    "ajeeb.email",
    "ajeesh.email",
    "ajexen.ga",
    "ajexen.gq",
    "ajexen.ml",
    "ajexen.tk",
    "ajfasy.com",
    "ajfzqs.us",
    "aji.kr",
    "ajiagustian.com",
    "ajmandreampalacespa.info",
    "ajnabar.com",
    "ajoivjortkobptr.info",
    "ajqff.us",
    "ajqn2h.us",
    "ajsd.de",
    "ajsdawks.icu",
    "aju.onlysext.com",
    "ajua.africa",
    "ajua.tech",
    "ajustementsain.club",
    "ajy47.space",
    "ajyuahsj.tech",
    "ak-ex.ru",
    "ak.mintemail.com",
    "ak13.net",
    "ak47.hu",
    "ak751.site",
    "akademichesky.info",
    "akademiyauspexa.xyz",
    "akaliy.com",
    "akamaized.cf",
    "akamaized.ga",
    "akamaized.gq",
    "akanpjoyp.shop",
    "akanshabhatia.com",
    "akapost.com",
    "akara-ise.com",
    "akash9.gq",
    "akaunt.info",
    "akaunt.org",
    "akb-12.icu",
    "akb-75.icu",
    "akbobinajelektrik.xyz",
    "akbqvkffqefksf.cf",
    "akbqvkffqefksf.ga",
    "akbqvkffqefksf.gq",
    "akbqvkffqefksf.ml",
    "akbqvkffqefksf.tk",
    "akbxv.us",
    "akcaoglutesisat.xyz",
    "akcebet1.club",
    "akcebetbonus1.club",
    "akcebetgiris1.club",
    "akcebetgirisadresi1.club",
    "akcebetuyelik1.club",
    "akcneletak.sk",
    "akcritning.ml",
    "akcritning.tk",
    "akd-k.icu",
    "akedits.com",
    "akekee.com",
    "akelshop.net",
    "akemakep.shop",
    "akerd.com",
    "akerin.xyz",
    "akerna.net",
    "akeyt.host",
    "akgq701.com",
    "akhalfpricelisting.com",
    "akhavi.org",
    "akhbarak.org",
    "akhisaranahtar.xyz",
    "akhmadi.cf",
    "akhost.trade",
    "akillietkinlik.xyz",
    "akira4d.info",
    "akissaboe.us",
    "akkiproducts.com",
    "akkivk.ru",
    "aklqo.com",
    "akma.email",
    "akmandken.tk",
    "aknet.kg",
    "akorde.al",
    "akphantom.com",
    "akqgs.live",
    "akqkky.com",
    "akragames.win",
    "akronquote.com",
    "akrula.site",
    "akryn4rbbm8v.cf",
    "akryn4rbbm8v.ga",
    "akryn4rbbm8v.gq",
    "akryn4rbbm8v.tk",
    "aksarayhabertv.com",
    "aksaraylisesi.xyz",
    "aksarayorospulari.xyz",
    "aksarayotoekspertiz.com",
    "aksearches.com",
    "akstel32.icu",
    "aktiefmail.nl",
    "aktionsinfo.com",
    "aktoyota.com",
    "akudik.bid",
    "akunamatata.site",
    "akusayyangkamusangat.ga",
    "akusayyangkamusangat.ml",
    "akusayyangkamusangat.tk",
    "akutamvan.com",
    "akuudahlelah.com",
    "akvabionica.icu",
    "akvaeha.icu",
    "akvaltis.icu",
    "akvaristlerdunyasi.com",
    "akvluzbeo.shop",
    "akwyf.xyz",
    "akxugua0hbednc.cf",
    "akxugua0hbednc.ga",
    "akxugua0hbednc.gq",
    "akxugua0hbednc.ml",
    "akxugua0hbednc.tk",
    "akyildizeticaret.com",
    "akyildizkahve.com",
    "akyildizkahve.org",
    "al-jazeera.comx.cf",
    "al-qaeda.us",
    "al26kt.info",
    "al3a4t.info",
    "alabama-4k.com",
    "alabamaaddictiontreatment.center",
    "alabamacocainerehab.com",
    "alabamadetox.center",
    "alabamaopiaterehab.com",
    "alabamavape.com",
    "aladincash.org",
    "alaeditions.com",
    "alaeditions.net",
    "alahahmohafard.online",
    "alaisfornitura.com",
    "alakart.info",
    "alaki.ga",
    "alalkamalalka.cf",
    "alalkamalalka.ga",
    "alalkamalalka.gq",
    "alalkamalalka.ml",
    "alalkamalalka.tk",
    "alamalfrosiah.icu",
    "alamedahomealarm.com",
    "alameen.ong",
    "alaminews.online",
    "alanadi.xyz",
    "alanci.cf",
    "alanci.ga",
    "alanci.gq",
    "alanci.ml",
    "alanci.tk",
    "alanischaritynetwork.com",
    "alankxp.com",
    "alannahtriggs.ga",
    "alanyadevekusu.xyz",
    "alanyamado.xyz",
    "alappuzhanews.com",
    "alarabi24.com",
    "alaret.ru",
    "alarmclockhq.org",
    "alarmpermits.com",
    "alarmsfire.ru",
    "alasin.site",
    "alaskacocainerehab.com",
    "alaskagrab.com",
    "alaskanartisan.com",
    "alaskaquote.com",
    "alaskavalentine.com",
    "alatechsource.net",
    "albadefilippis.com",
    "albanychristianspirit.com",
    "albasmahart.com",
    "albaspecials.com",
    "albawaba.com",
    "albazzini.com",
    "albendazole.website",
    "albertacan.net",
    "albertlotito.info",
    "albertwang.me",
    "albinupp.xyz",
    "albionwe.us",
    "alblasserwaard.works",
    "alblogic.com",
    "alborzfilms.com",
    "albumlob.com",
    "albumpri.icu",
    "albumpri.xyz",
    "albumpric.icu",
    "albuquerqueaddictiontreatment.com",
    "albuquerquealcoholrehab.com",
    "alburyfloatroom.com",
    "albvid.org",
    "albyjacob.com",
    "alcatraz.org",
    "alcegi.ga",
    "alcegi.gq",
    "alcegi.ml",
    "alcha.ru",
    "alchemywe.us",
    "alchevsk-car.ru",
    "alco-city.site",
    "alco-magazin2.info",
    "alcobar.bar",
    "alcobazar.site",
    "alcobutik2.bar",
    "alcobutik37.ru",
    "alcobutik39.ru",
    "alcodealer12.ru",
    "alcodealer13.ru",
    "alcoholetn.com",
    "alcoholtreatmentdetoxcenters.com",
    "alconight17.site",
    "alconights41.ru",
    "alcoprost-pomoch.ru",
    "alcostar.site",
    "alcosynth.reviews",
    "alcotix.fun",
    "alcsehar.ga",
    "alcsehar.gq",
    "alcsehar.tk",
    "alcsx.site",
    "aldealdi.shop",
    "aldeaminera.info",
    "aldeyaa.ae",
    "aldndcxh.host",
    "aldooshoes.com",
    "ale35anner.ga",
    "aleagustina724.cf",
    "aleaisyah710.ml",
    "aleamanda606.cf",
    "aleanna704.cf",
    "aleanwisa439.cf",
    "alebas.ru",
    "alebutar-butar369.cf",
    "alecsmail.com",
    "alectronik.com",
    "aledestrya671.tk",
    "aledrioroots.youdontcare.com",
    "aleelma686.ml",
    "aleepapalae.gq",
    "alefachria854.ml",
    "alefika98.ga",
    "alegracia623.cf",
    "alegradijital.com",
    "aleherlin351.tk",
    "aleigo.com",
    "alejandroirizarry.com",
    "alekfamili.ru",
    "alekfamily.ru",
    "alekikhmah967.tk",
    "aleks-berlev.ru",
    "alekseyzaharenko.ru",
    "alemail.club",
    "alemalakra.com",
    "alemaureen164.ga",
    "alembic.ltd",
    "alemeutia520.cf",
    "alenina729.tk",
    "alenoor903.tk",
    "alenovita373.tk",
    "aleqodriyah730.ga",
    "alerfv.info",
    "alerioncharleston.com",
    "alerionventures.info",
    "alerionventures.org",
    "alerionventures.us",
    "alert-cellphone.club",
    "alert-cleaner.club",
    "alert-cleaner1.site",
    "alert-fixer.club",
    "alert.ong",
    "alertslit.top",
    "alesam.info",
    "alesapto153.ga",
    "alesaq.info",
    "aleshiami275.ml",
    "alessia1818.site",
    "alessth.shop",
    "alesulalah854.tk",
    "aletar.ga",
    "aletasya616.ml",
    "alex-owens.info",
    "alex.xn--6frz82g",
    "alex4all.com",
    "alexaclub.icu",
    "alexacms.org",
    "alexanas.ru",
    "alexanderfedorov.com",
    "alexandrabielanski.com",
    "alexandravolkova.ru",
    "alexandredossantos.com",
    "alexandria.cc",
    "alexandria.chat",
    "alexandria.codes",
    "alexandria.fund",
    "alexanozkz.website",
    "alexbox.online",
    "alexbrowne.info",
    "alexcampbell.xyz",
    "alexcline.us",
    "alexcowan.net",
    "alexforseth.com",
    "alexhorton.ru",
    "alexis4d.xyz",
    "alexisfawx.best",
    "alexri.icu",
    "alexsolutins.site",
    "alextech-sweetbriar.com",
    "alexwn.us",
    "alfa-memes.shop",
    "alfa-romeo.cf",
    "alfa-romeo.ga",
    "alfa-romeo.gq",
    "alfa-romeo.ml",
    "alfadesignweb.com",
    "alfaex.net",
    "alfaex.org",
    "alfaglobalholding.com",
    "alfamailr.org",
    "alfaomega24.ru",
    "alfapaper.ru",
    "alfaromeo.igg.biz",
    "alfaromeo147.cf",
    "alfaromeo147.gq",
    "alfaromeo147.ml",
    "alfaromeo147.tk",
    "alfastras.info",
    "alfonsodg.info",
    "alfra.ltd",
    "alfredosandor.com",
    "alfredotv.club",
    "alfredsungperfumes.com",
    "alfurqaaninternationalschools.com",
    "algaepanel.com",
    "algaetec.asia",
    "algeco-rus.ru",
    "algeria.com",
    "algeriamail.com",
    "algerie-culture.com",
    "algobot.one",
    "algobot.org",
    "algranut.cf",
    "algranut.ga",
    "algranut.gq",
    "alhadattv.com",
    "alhalfpricelistings.com",
    "alhamadealmeria.com",
    "alhashareslectronics.com",
    "alhilal.net",
    "alhzfw.us",
    "ali-baba.info",
    "aliagaberrakemlak.com",
    "alianza-editores.com",
    "aliases.tk",
    "aliaswave.com",
    "aliaswe.us",
    "alibaba.com",
    "alibestdeal.com",
    "aliblue.top",
    "alice-dsl.net",
    "alice.it",
    "aliceadsl.fr",
    "alicedsl.de",
    "aliceenjoy.com",
    "aliceinchainsmail.com",
    "aliciaflynn.buzz",
    "aliciaspas.info",
    "aliebright.com",
    "aliemli.site",
    "aliens.onl",
    "alienware13.com",
    "aliex.co",
    "aligamel.com",
    "aligmli.site",
    "alignyourtechchakras.com",
    "aligreen.top",
    "alihanlab.com",
    "aliito.icu",
    "alijben.space",
    "alike-position.xyz",
    "alilafe.icu",
    "alilo.toys",
    "alilomalyshariki.ru",
    "alilyaflix.site",
    "alimainemail.cf",
    "alimainemail.gq",
    "alimainemail.ml",
    "alimentarydesign.com",
    "alimli13.site",
    "alimli14.site",
    "alimli15.site",
    "alimli2.site",
    "alimli20.site",
    "alimli3.site",
    "alimunjaya.xyz",
    "alinavits.icu",
    "alindropromo.com",
    "alinfotimes.com",
    "alinmis.best",
    "alired.top",
    "alishafield.buzz",
    "aliskebabandpizzahouse.com",
    "alisonebright.com",
    "alisongamel.com",
    "alisonsheffieldinteriors.com",
    "alisverisistan.net",
    "alitaj.com",
    "alivance.com",
    "alive.cz",
    "alivemail.cf",
    "alivemail.ga",
    "alivemail.gq",
    "alivemail.ml",
    "alivemail.tk",
    "alivewe.us",
    "alivi8.net",
    "aliwegwpvd.ga",
    "aliwegwpvd.gq",
    "aliwegwpvd.ml",
    "aliwegwpvd.tk",
    "aliwhite.top",
    "aliyubillionsblog.com",
    "aliyummail.cf",
    "aliyun.com",
    "aliyunmm.cn",
    "aljoyce.com",
    "alk44.icu",
    "alkalinewaterus.com",
    "alkila-lo.com",
    "alkila-lo.net",
    "alkoprost-lucshy.ru",
    "all-cats.ru",
    "all-inclusive-holiday.com",
    "all-mail.net",
    "all-starninjas.info",
    "all-starninjas.net",
    "all-starninjas.org",
    "all-store24.ru",
    "all2day.info",
    "all4engineering.com",
    "all4piping.com",
    "allaboutebay2012.com",
    "allaccesstixx.net",
    "allaccesswe.us",
    "allacontractors.com",
    "allaelectric.com",
    "allamericanwe.us",
    "allanjosephbatac.com",
    "allardprize.com",
    "allaroundwe.us",
    "allartworld.com",
    "allbags.biz",
    "allbest.site",
    "allbest4u.ru",
    "allbet3vip.com",
    "allbet698.com",
    "allbetauto.com",
    "allbetvip.com",
    "allbitcoinjobs.com",
    "allblogs.com",
    "allboutiques.com",
    "allcalhomes.com",
    "allcards.su",
    "allchart.ru",
    "allclass.club",
    "allcodecenter.com",
    "allcures.info",
    "alldao.org",
    "allday247.ru",
    "alldc.website",
    "alldirectbuy.com",
    "alldiscount.icu",
    "alldude.site",
    "allegiancewe.us",
    "allegrowe.us",
    "allemails.co.uk",
    "allemojikeyboard.com",
    "allen.nom.za",
    "allengrangearms.com",
    "allergibruger.website",
    "allergist.com",
    "allergybuddyapp.com",
    "allergytalk.net",
    "allesoverwebshops.shop",
    "allesoverwebwinkels.shop",
    "allev.net",
    "alleviam.asia",
    "alleviam.org",
    "allevium.org",
    "allfamus.com",
    "allfolk.ru",
    "allforeign.boutique",
    "allforeignboutique.com",
    "allfreer.site",
    "allfregwe.ga",
    "allfrree.xyz",
    "allg00d.com",
    "allgaiermogensen.com",
    "allgolfhats.com",
    "allgoodwe.us",
    "allhomesincharlotte.net",
    "allhostguide.com",
    "allhoz.ru",
    "alliance-writings.club",
    "alliancewe.us",
    "alliedfullmovie.info",
    "alliehenner.com",
    "alliescoin.net",
    "alliescoin.org",
    "alliescoins.com",
    "allincludedpuntacana.com",
    "allinclusivesandiegowedding.com",
    "allinonewe.us",
    "allirelandcarrentals.com",
    "allisonrolish.com",
    "allitevglu.site",
    "allkitchenrecipe.com",
    "allmail.net",
    "allmails.site",
    "allminsk.info",
    "allmtr.com",
    "allnationsuniversity.org",
    "allneedscomputers.com",
    "allnet.org",
    "allnewsblog.ru",
    "allnewsblogs.ru",
    "allnightnews.ru",
    "allofthem.net",
    "allogrkudc.space",
    "allopurinolonline.info",
    "allortech.online",
    "alloutwe.us",
    "allowbuil.icu",
    "allowdram.xyz",
    "allowed.org",
    "allowene.buzz",
    "allowglov.site",
    "allowhea.recipes",
    "allowwidt.email",
    "alloygirl.com",
    "alloymail.com",
    "alloywe.us",
    "allpdfmanuales.xyz",
    "allpk.ru",
    "allpro.plumbing",
    "allprohandyman618-0440.com",
    "allprolert.tk",
    "allprosto.icu",
    "allprowe.us",
    "allracing.com",
    "allresae.site",
    "allretrojordans.com",
    "allroundawesome.com",
    "allsaintsfan.com",
    "allseasonswe.us",
    "allserch.net",
    "allslickdeals.com",
    "allsnap.app",
    "allsportsinc.net",
    "allstar-brisbane-orthodontist.com",
    "allstarload.monster",
    "allstarshowstopperrs.com",
    "allstartop.xyz",
    "allstarwe.us",
    "alltagstipps.site",
    "alltel.net",
    "alltempmail.com",
    "allthegoodnamesaretaken.org",
    "allthemuchiz.icu",
    "alltheweights.top",
    "allthewp.com",
    "allthingsbloodpressure.com",
    "allthingsprogress.com",
    "alltopmail.com",
    "allurewe.us",
    "allviant.net",
    "allvoipphoneok.com",
    "allwatch-shop.icu",
    "allwynrefunds.com",
    "ally-fun.com",
    "allyours.xyz",
    "alma3bet360.xyz",
    "almail.xyz",
    "almanabo.icu",
    "almanara.info",
    "almasbet606.xyz",
    "almascapitalparnters.com",
    "almathemes.info",
    "almazkeys.ru",
    "almikoorfih.xyz",
    "almondcosmetic.com",
    "almondwe.us",
    "almoner.xyz",
    "almostic.ru",
    "almubaroktigaraksa.com",
    "alneboklima.com",
    "alnyus.com",
    "aloceplira.com",
    "aloceplira.net",
    "aloemie.com",
    "aloeverachat.com",
    "alohaball.org",
    "alohagroup808.com",
    "alohagroup808.net",
    "alonbog.cf",
    "alonbog.ml",
    "alonsofans.com",
    "alonto.cf",
    "alonto.ga",
    "alonto.ml",
    "alonto.tk",
    "alonzo1121.club",
    "alonzos-end-of-career.online",
    "aloofdress.email",
    "alooffig.xyz",
    "alooffigh.xyz",
    "aloofivo.email",
    "alooflem.xyz",
    "aloofpo.xyz",
    "aloofpou.xyz",
    "aloofpoun.xyz",
    "aloofweed.us",
    "aloowi.com",
    "alormbf88nd.cf",
    "alormbf88nd.ga",
    "alormbf88nd.gq",
    "alormbf88nd.ml",
    "alormbf88nd.tk",
    "alosttexan.com",
    "alouettethedragon.com",
    "aloutas.cf",
    "alovsur.cf",
    "alovsur.gq",
    "alovsur.tk",
    "alpabuild.ru",
    "alpaltan.com",
    "alpechino.com",
    "alpenjodel.de",
    "alpfabetart.icu",
    "alph.wtf",
    "alpha-jewelry.com",
    "alpha-lamp.ru",
    "alpha-p2.ru",
    "alpha-web.net",
    "alpha3solar.com",
    "alphabooster.com",
    "alphacare4you.site",
    "alphacodeincubate.club",
    "alphadefensegear2.com",
    "alphadelivered.online",
    "alphadev.online",
    "alphafrau.de",
    "alphaluxmusclenow.com",
    "alphanaltan.com",
    "alphaneutron.com",
    "alphaomegawe.us",
    "alphard.works",
    "alpharecipes.com",
    "alphatech.llc",
    "alphavid.net",
    "alpicley.ga",
    "alpicley.gq",
    "alpinecave.com",
    "alpinesg.info",
    "alpinewe.us",
    "alplann.shop",
    "alpnames.xyz",
    "alpoindexter.org",
    "alqiblah.net",
    "alqy5wctzmjjzbeeb7s.cf",
    "alqy5wctzmjjzbeeb7s.ga",
    "alqy5wctzmjjzbeeb7s.gq",
    "alqy5wctzmjjzbeeb7s.ml",
    "alqy5wctzmjjzbeeb7s.tk",
    "alr0.icu",
    "alrabee3.org",
    "alreadypurchase.com",
    "alreemabudhabi.com",
    "alreemisland.org",
    "alrmail.com",
    "alsadeqoun.com",
    "alsaimli.site",
    "alsheim.no-ip.org",
    "alsirajalmonir.org",
    "alsisa.cf",
    "alsisa.ga",
    "alsisa.gq",
    "alsjegeloofd.com",
    "alskens.dk",
    "alsosearch.network",
    "alt.one",
    "alt04i.us",
    "altadefinizione.download",
    "altadefinizione01.buzz",
    "altairwe.us",
    "altavista.com",
    "altavista.net",
    "altavista.se",
    "altcoinadvantage.org",
    "alter.capital",
    "alteredrhythm.com",
    "alterego.life",
    "alterity.xyz",
    "altern.biz",
    "alternate-universe.online",
    "alternatetomattermark.com",
    "alternatetoprospectify.com",
    "alternatetounomy.com",
    "alternatifsbobet.link",
    "alternativagratis.com",
    "alternativedemocratfacts.com",
    "alternativeforminoxidil.com",
    "alternativepropertybuyers.net",
    "alternativeto.online",
    "alternativetoclearbit.com",
    "alternativetodatanyze.com",
    "alternativetominoxidil.com",
    "alternativetoprospectify.com",
    "alternativetounomy.com",
    "alternatormc.com",
    "although-soft-sharp-nothing.xyz",
    "althwho.shop",
    "alti-gor.icu",
    "altincasino.club",
    "altincasino.xyz",
    "altincasino11.com",
    "altincasino13.com",
    "altincasino14.com",
    "altincasino33.com",
    "altinciayak.com",
    "altitudecdn.net",
    "altitudewe.us",
    "altmails.com",
    "altnewshindi.com",
    "altoris.pl",
    "altostima.com",
    "altred.site",
    "altromaliv.gq",
    "alttc.ru",
    "altuswe.us",
    "altxiv.com",
    "altxxx.fun",
    "altxxx.site",
    "aluloronse.icu",
    "aluminumbrush.us",
    "aluminumbrushes.org",
    "aluminumbrushes.us",
    "alumix.cf",
    "alumni.com",
    "alumni.tufts.edu",
    "alumni.uwo.ca",
    "alumnidirector.com",
    "alumnimp3.xyz",
    "aluppriv.ml",
    "aluumi.com",
    "aluzzi.com",
    "alvechurchacousticroots.com",
    "alvemi.cf",
    "alvemi.ga",
    "alvemi.ml",
    "alvemi.tk",
    "alvilag.hu",
    "alvinje.ga",
    "alvob5.info",
    "alwaqtnews.com",
    "always-open.app",
    "alwise.site",
    "alx69.space",
    "alyamanal3raby.org",
    "alyscha.online",
    "alytics.info",
    "alzheimerslibrary.com",
    "alzheimersmemoryloss.com",
    "am-dv.ru",
    "am-koleso.icu",
    "am-static.net",
    "am-static.org",
    "am-usercontent.net",
    "am263.space",
    "am55d.com",
    "am55e.com",
    "am55f.com",
    "am55j.com",
    "am55n.com",
    "am55o.com",
    "am55p.com",
    "am55s.com",
    "am55v.com",
    "am631.site",
    "am66b.com",
    "am66c.com",
    "am66e.com",
    "am66g.com",
    "am66h.com",
    "am66k.com",
    "am66o.com",
    "am66p.com",
    "am66r.com",
    "am66w.com",
    "am66z.com",
    "am990-theanswer.com",
    "am99k.com",
    "am99n.com",
    "am99o.com",
    "am99r.com",
    "am99t.com",
    "am99u.com",
    "ama-trade.de",
    "ama-trans.de",
    "amadaferig.org",
    "amadamus.com",
    "amadeuswe.us",
    "amail.club",
    "amail.com",
    "amail.gq",
    "amail.men",
    "amail1.com",
    "amail3.com",
    "amail4.me",
    "amailr.net",
    "amajority.icu",
    "amal55.link",
    "amalur.icu",
    "amanj.krd",
    "amantapkun.com",
    "amanual.site",
    "amapp01.com",
    "amark-carpet-cleaning.com",
    "amasyamucerentacar.xyz",
    "amateur.monster",
    "amateurbondagesex.com",
    "amateurflixx.com",
    "amateursonly.net",
    "amav.ro",
    "amazing-games-fire.com",
    "amazingclothingandgifts.com",
    "amazingdomain.name",
    "amazingdomaindeals.com",
    "amazingemailsforyou.tk",
    "amazinglifequotes.com",
    "amazingpractice.net",
    "amazon-aws.org",
    "amazon-black-friday99.ru",
    "amazon-blackfriday.host",
    "amazon-travel.info",
    "amazon.coms.hk",
    "amazonbitcoin.net",
    "amazonomat.com",
    "amazonses.com",
    "amazonshopbuy.com",
    "amazonshopcash.com",
    "amazonshopsite.com",
    "amazonshopsource.com",
    "amazonshopzen.com",
    "ambalajciambalaj.com",
    "ambaritaputra.info",
    "ambassadedenhaag.com",
    "ambassadorwe.us",
    "amberwe.us",
    "ambiancewe.us",
    "ambilqq.com",
    "ambimbo.xyz",
    "ambitiouswe.us",
    "ambwd.com",
    "amconcept.xyz",
    "ameba.us",
    "amecve.cf",
    "amecve.ga",
    "amecve.gq",
    "amecve.tk",
    "amedia.life",
    "amelabs.com",
    "amele.com",
    "ameli-fr.club",
    "ameliachoi.com",
    "amelimoncompte.info",
    "amellux.com",
    "amentionq.com",
    "ameraldmail.com",
    "america.hm",
    "americaaa316.xyz",
    "americaatthemoviesafi.com",
    "americacoverage.fun",
    "americacoverage.live",
    "americacoverage.site",
    "americacoverage.world",
    "americacoverage.xyz",
    "americahomecare.net",
    "americajin.com",
    "americamoviesafi.com",
    "americanadvertisingawards.org",
    "americanassociationofnaturalremedies.com",
    "americanawe.us",
    "americancryptonetwork.com",
    "americandistributionco.net",
    "americanelectricsolutionsaz.com",
    "americanevolution.online",
    "americanimportstore.com",
    "americanlibrarieslive.com",
    "americanlibrarieslive.net",
    "americanroofer.xyz",
    "americansystemnetwork.com",
    "americanwealthgap2019.com",
    "americasbestwe.us",
    "americaswe.us",
    "amerikanbuyutucu.online",
    "amerikanbuyutucu.xyz",
    "ameritech.net",
    "amesamed.shop",
    "amex-online.ga",
    "amex-online.gq",
    "amex-online.ml",
    "amex-online.tk",
    "amexjewel.fun",
    "amexyedekparca.com",
    "ameyprice.com",
    "amfm.de",
    "amg-private-lounge.org",
    "amg-recycle.com",
    "amgprivatelounge.org",
    "amgprivateloungeromania.org",
    "amguki.ga",
    "amhar.asia",
    "amicuswe.us",
    "amidevous.tk",
    "amigosdofuturo.website",
    "amigoshosts.com",
    "amigowe.us",
    "amigurumilove.website",
    "amigurumipatterns.website",
    "amilegit.com",
    "amin.consulting",
    "amineoffice.com",
    "aminois.ga",
    "aminudin.me",
    "amiramov.ru",
    "amiri.net",
    "amirig.info",
    "amirig.net",
    "amirig.tech",
    "amiriindustries.com",
    "amitywe.us",
    "amkursk.ru",
    "amlodipin.website",
    "amlopedia.com",
    "amman.site",
    "ammnbabdbeguw.online",
    "ammolite.biz",
    "amnetsal.com",
    "amnicdvuu.space",
    "amnioclepsis.best",
    "amogan.ga",
    "amogan.ml",
    "amokqidwvb630.ga",
    "amoksystems.com",
    "amor-clab.icu",
    "amoran.icu",
    "amorki.pl",
    "amornino.com",
    "amourafrique-mali.org",
    "amourafrique.org",
    "ampasinc.com",
    "ampicillin.website",
    "ampivory.com",
    "ampleglov.xyz",
    "ampleid.fun",
    "amplewe.us",
    "amplifiedwe.us",
    "amplifywe.us",
    "amplimail.com",
    "amproced.cf",
    "amproced.gq",
    "ampsylike.com",
    "ampuleqbxr.space",
    "amrer.net",
    "ams-australia.com",
    "amsellemgourmet.com",
    "amsengineering.app",
    "amsgkmzvhc6.cf",
    "amsgkmzvhc6.ga",
    "amsgkmzvhc6.gq",
    "amsgkmzvhc6.tk",
    "amsignsonline.com",
    "amsoilblog.com",
    "amsspecialist.com",
    "amsterdamhotelsmotels.info",
    "amsterdamsmut.com",
    "amt3security.com",
    "amteyss1.club",
    "amthucvietnam.info",
    "amtibiff.cf",
    "amtibiff.gq",
    "amtibiff.ml",
    "amtibiff.tk",
    "amtmsg.site",
    "amttesting.com",
    "amule.cf",
    "amule.ga",
    "amule.gq",
    "amule.ml",
    "amulet149.ru",
    "amuletph.icu",
    "amunra6.com",
    "amuro.net",
    "amuromail.com",
    "amusedr.icu",
    "amuseid.icu",
    "amusestal.icu",
    "amusewre.xyz",
    "amwaybitva.ru",
    "amyalysonfans.com",
    "amyhref.com",
    "amyhzr1314520.com",
    "amyl112.app",
    "amymary.us",
    "amysdirect.com",
    "amytcon.cf",
    "amytcon.ga",
    "amytcon.gq",
    "amytcon.tk",
    "amyxrolest.com",
    "amz-aws.host",
    "amz-psd2.info",
    "amz30.ru",
    "amz5913.com",
    "amzclub.club",
    "an-it-oxygenconcentrators-ok.live",
    "an-it-tu-new-car-ok.live",
    "an-it-tu-new-car-ok.livecvdsale.top",
    "an.id.au",
    "an78xx.us",
    "ana555.com",
    "anabethonline.xyz",
    "anabolicscreworiginal.com",
    "anabordas.info",
    "anacliri.tk",
    "anacoms.com",
    "anaddo.ga",
    "anaddo.ml",
    "anaddo.tk",
    "anadoluhirdavat.xyz",
    "anadyr-airport.ru",
    "anaglyph.xyz",
    "anahad.ong",
    "anahaton.icu",
    "anaheimcocainerehab.com",
    "anaheimopiaterehab.com",
    "anakavi.net",
    "anakayam99.live",
    "anakjalanan.ga",
    "anakjembutad.cf",
    "anakjembutad.ga",
    "anakjembutad.gq",
    "anakjembutad.ml",
    "anakjembutad.tk",
    "anal.accesscam.org",
    "analabeevers.site",
    "analitics2020.best",
    "analogsky.com",
    "analogwe.us",
    "analysisaot.email",
    "analysiswe.us",
    "analyst-omega.info",
    "analyticahq.com",
    "analyticalwe.us",
    "analyticauto.com",
    "analyticsemails.com",
    "analyticsgurus.net",
    "analyticsmasters.org",
    "analyticswe.us",
    "analyticswebcontacts.com",
    "analyticwe.us",
    "analyza.org",
    "analyzable857ax.online",
    "anamuremlakofisi.xyz",
    "anamz-oubby-con.monster",
    "ananno.cf",
    "ananno.ga",
    "ananno.ml",
    "ananno.tk",
    "ananzi.co.za",
    "anapim.ga",
    "anapim.gq",
    "anapim.ml",
    "anapim.tk",
    "anaploxo.cf",
    "anaploxo.ga",
    "anaploxo.gq",
    "anaploxo.ml",
    "anaploxo.tk",
    "anapoker.website",
    "anappfor.com",
    "anappthat.com",
    "anarice.info",
    "anarki.dk",
    "anasdet.site",
    "anatjosephtherapy.com",
    "anatolygroup.com",
    "anayelizavalacitycouncil.com",
    "anayikt.cf",
    "anayikt.ga",
    "anayikt.gq",
    "anayikt.ml",
    "anbe.ru",
    "anbinhnet.com",
    "ancesan.shop",
    "ancestralfields.com",
    "ancestry.com",
    "ancestryacademy.cloud",
    "anchorageheroinrehab.com",
    "anchorvalelane.com",
    "anchrisbaton.acmetoy.com",
    "ancientalchemy.org",
    "ancientart.co",
    "ancientcivil.com",
    "and-dentalimplants-rad.live",
    "andaluxia.monster",
    "andbest.site",
    "andbitcoins.com",
    "andbwas.icu",
    "anderledes.dk",
    "andersenconsultations.com",
    "andersonfamilysteaks.com",
    "andersonvalley4h.com",
    "andetne.win",
    "andfreekt.ga",
    "andhani.ml",
    "andia.services",
    "andlume.com",
    "andmeatballs.com",
    "andorem.com",
    "andreaauerbach.com",
    "andreabocellimail.com",
    "andreamatt.biz",
    "andreatorreano.com",
    "andreay.codes",
    "andreihusanu.ro",
    "andremanzoni.com",
    "andresandina.com",
    "andrew.com",
    "andrewhopkins.buzz",
    "andrewjanus.com",
    "andrewm.art",
    "andrewmurphy.org",
    "andrewongphotography.com",
    "andrewsbridals.info",
    "andrewssportconditioning.com",
    "andrewssportsacademy.com",
    "andrey-simki.ru",
    "andreych1.host",
    "andreych2.host",
    "andreych4.host",
    "andreych5.host",
    "andreych7.host",
    "andreymaltsev.info",
    "androidevolutions.com",
    "andromedae.xyz",
    "androotosy.icu",
    "andros-greece.com",
    "andruchef.ru",
    "andry.de",
    "andsee.org",
    "andstoneall.website",
    "andthen.us",
    "andthentheresmaude.com",
    "andwalkintubsok.live",
    "andwandt.shop",
    "andwe.site",
    "andweightlosshelpsok.live",
    "andwl.us",
    "andyes.net",
    "andylau.net",
    "andynugraha.net",
    "andysairsoft.com",
    "andywestphotography.com",
    "andyx.com",
    "anearbooks.info",
    "anekad42.asia",
    "anekaqq.best",
    "aneklok.com",
    "anellomom.ru",
    "anemoku.net",
    "anepear.gq",
    "anepear.tk",
    "anesthetic12bd.online",
    "anetsai.ru",
    "aneus.club",
    "anewangleonlife.com",
    "anfk35df.xyz",
    "anfmail.com",
    "anforpost.ru",
    "angeangh.shop",
    "angee.icu",
    "angel-bank.com",
    "angel-cube.icu",
    "angel4djp.com",
    "angel4djp.net",
    "angelacorrias.com",
    "angelads.trade",
    "angelamission.com",
    "angelandcurve.com",
    "angelaslatercomposer.com",
    "angelasupport.com",
    "angelawhite.site",
    "angelbees.com",
    "angeles.live",
    "angeles.team",
    "angeles.tours",
    "angelescity.download",
    "angelfan.com",
    "angelfire.com",
    "angeli-di-pietra.com",
    "angelic.com",
    "angelinthemist.com",
    "angelinway.icu",
    "angeliquecail.com",
    "angelovgabriel.ru",
    "angelpoker.click",
    "angelpoker88.com",
    "angelpoker99.com",
    "angelsoflahore.com",
    "angerha.xyz",
    "angerhab.icu",
    "angerstall.site",
    "angesti.tech",
    "anggraas.club",
    "anggrasaza.xyz",
    "angi.com",
    "angiad.xyz",
    "angiehomeservices.com",
    "angkabursa.org",
    "angkahoki.club",
    "angkajitu.site",
    "angkoair.com",
    "angksoeas.club",
    "angkueastras.club",
    "angleda.icu",
    "angleflin.icu",
    "anglepoise-inc.com",
    "angleprin.recipes",
    "anglesblowers.top",
    "angleseiz.com",
    "angletea.xyz",
    "anglican.xyz",
    "angoplengop.cf",
    "angriasan.club",
    "angriasfa.xyz",
    "angrityas.club",
    "angry-online.icu",
    "angrybirdsbabyj.icu",
    "angushof.de",
    "angyonline.online",
    "anhala.com",
    "anhkhung.tk",
    "anhthu.org",
    "anhxyz.ml",
    "ani24.de",
    "anidub.site",
    "anidub.xyz",
    "anikasharpe.com",
    "anilozturk.tech",
    "animacuratio.ru",
    "animadancegroup.com",
    "animagefromsomewhere.com",
    "animail.net",
    "animal.net",
    "animalalliesnj.org",
    "animalbuildingblocks.com",
    "animalhouse.com",
    "animalize631xu.online",
    "animalrescueprofessional.com",
    "animalwallpaper.site",
    "animalwoman.net",
    "animata.info",
    "animatecss.com",
    "anime365.com",
    "animeappeal.com",
    "animebt.com",
    "animecn.com",
    "animefreakz.xyz",
    "animehasu.net",
    "animeindo.website",
    "animeru.tv",
    "animes-streaming.xyz",
    "animesos.com",
    "animevector.org",
    "aninameu2endijks.xyz",
    "anindaskor.mobi",
    "anindaskor.website",
    "aningres.ru",
    "aningrop.xyz",
    "aningto.xyz",
    "aniplay.xyz",
    "anit.ro",
    "anitdatingnew.live",
    "anitoveractivebladderok.live",
    "anitspanishautoinsurancebay.live",
    "anitspanishautoinsurancebig.live",
    "anitspanishautoinsurancebuy.live",
    "anitspanishautoinsurancefed.live",
    "anitspanishautoinsuranceget.live",
    "anitspanishautoinsurancekey.live",
    "anitspanishautoinsurancenew.live",
    "anitspanishautoinsurancenow.live",
    "anitspanishautoinsuranceone.live",
    "anitspanishautoinsurancerad.live",
    "anitspanishautoinsuranceray.live",
    "anitspanishautoinsurancetab.live",
    "anitspanishautoinsurancetop.live",
    "aniy.site",
    "anjaybgo.com",
    "anjeysatori.com",
    "anjing.cool",
    "anjingkokditolak.cf",
    "anjingkokditolak.ga",
    "anjingkokditolak.gq",
    "anjingkokditolak.ml",
    "anjingkokditolak.tk",
    "anjungcafe.com",
    "ankaclan.com",
    "ankaotel.info",
    "ankarahaliyikamaciniz.xyz",
    "ankarakaraagac.com",
    "ankarakuzey.com",
    "ankarapansiyonlari.com",
    "ankarapazari.xyz",
    "ankarasacsimilasyonu.com",
    "anketka.de",
    "anklefo.email",
    "anklereb.xyz",
    "ankoninc.pw",
    "ankorbeton.icu",
    "ankplacing.com",
    "ankt.de",
    "anliabc.com",
    "anmaya110.com",
    "anmiecon.ga",
    "anmiecon.gq",
    "anmiecon.ml",
    "anmiecon.tk",
    "anmlvapors.com",
    "ann-tiessweetthings.com",
    "annafathir.cf",
    "annalusi.cf",
    "annanakal.ga",
    "annarahimah.ml",
    "annavarikova.ru",
    "annavasina-teacher.ru",
    "annazahra.cf",
    "annesdiary.com",
    "annidh.site",
    "anniefans.com",
    "anniesdorsetkitchencomv.com",
    "annoallestero.info",
    "annoncegratuiteenligne.com",
    "annoncegratuiteliens.com",
    "annonspriser.se",
    "annoor.us",
    "annother-snowstorm.info",
    "annraya.org",
    "annsmail.com",
    "annuaire-ebook.xyz",
    "annuaire-referencement.info",
    "annuaire-seotons.com",
    "annuaire.casa",
    "annualcred8treport.com",
    "annuale.best",
    "annualgatheringint.org",
    "ano-mail.net",
    "anobox.ru",
    "anocinpackpainv2.site",
    "anocor.ga",
    "anocor.gq",
    "anocor.ml",
    "anocor.tk",
    "anodizing781jd.xyz",
    "anogarmoniya.ru",
    "anogenics.info",
    "anom.xyz",
    "anomail.club",
    "anomail.us",
    "anon-mail.de",
    "anonbox.net",
    "anonib.su",
    "anoniemgesprek.online",
    "anonmail.top",
    "anonmail.xyz",
    "anonmails.de",
    "anonpop.com",
    "anonsocks.xyz",
    "anontee.com",
    "anonymagic.icu",
    "anonymail.dk",
    "anonymbox.com",
    "anonymize.com",
    "anonymized.org",
    "anonymous-email.net",
    "anonymous-vfx.com",
    "anonymous.to",
    "anonymousfeedback.net",
    "anonymousmail.org",
    "anonymousness.com",
    "anonymousspeech.com",
    "anonymstermail.com",
    "anorling.com",
    "anote.com",
    "another.com",
    "anotherdomaincyka.tk",
    "anotherwin95.com",
    "anoukmatton.com",
    "anpatoptan.xyz",
    "anperbue.cf",
    "anperbue.ga",
    "anperbue.gq",
    "anperbue.ml",
    "anpost.website",
    "anpravoslavnoe.ru",
    "anprostore.com",
    "anrdiasyuas.club",
    "anrofas.gq",
    "anrofas.ml",
    "ansaldo.cf",
    "ansaldo.ga",
    "ansaldo.gq",
    "ansaldo.ml",
    "ansaldobreda.cf",
    "ansaldobreda.ga",
    "ansaldobreda.gq",
    "ansaldobreda.ml",
    "ansaldobreda.tk",
    "ansatko.cf",
    "ansatko.ga",
    "ansatko.tk",
    "ansenlg.com",
    "anseolio.ga",
    "anseolio.tk",
    "anserva.cf",
    "anserva.gq",
    "anserva.ml",
    "anserva.tk",
    "ansforr.shop",
    "ansibleemail.com",
    "ansmh.us",
    "ansoaco.ml",
    "answers.xyz",
    "answersfortrivia.ml",
    "ant-q.net",
    "antabuse.website",
    "antabuse247.video",
    "antakyamadoevi.xyz",
    "antalex7.ru",
    "antalyaescortlar.site",
    "antalyamasajsalonutr.xyz",
    "antalyamatbaacilari.xyz",
    "antandiante.design",
    "antares-logistic.ru",
    "antarvasna.mobi",
    "antebahis23.com",
    "anteprimaisotta.xyz",
    "anterin.online",
    "antetude.xyz",
    "anteyltd.icu",
    "anthagine.cf",
    "anthagine.ga",
    "anthagine.gq",
    "anthagine.ml",
    "anthologized430ut.online",
    "anthony-junkmail.com",
    "anthonyrhodes.buzz",
    "anthroarts.com",
    "anthropologycommunity.com",
    "anti-aav.com",
    "anti-ignorance.net",
    "anti-p62.com",
    "anti-social.com",
    "anti-staticbrush.net",
    "anti-staticbrush.us",
    "anti-staticbrushes.biz",
    "anti-staticbrushes.net",
    "anti-staticbrushes.org",
    "anti-staticbrushes.us",
    "antiaginggames.com",
    "antiangular.best",
    "anticavetreria.vacations",
    "antichef.com",
    "antichef.net",
    "antichef.org",
    "antico19.online",
    "antico19.ru",
    "anticrisis78.ru",
    "antidrinker.com",
    "antiguaguatemala.org",
    "antika-vintage-smycken.se",
    "antilles.xyz",
    "antilopa.pro",
    "antimbee.xyz",
    "antipolomka.site",
    "antipremia-js.org",
    "antiquebarberchairs.org",
    "antiqueemail.com",
    "antiradar360.ru",
    "antireg.com",
    "antireg.ru",
    "antisocial.com",
    "antispam.de",
    "antispam24.de",
    "antispammail.de",
    "antistaticbrush.biz",
    "antistaticbrush.net",
    "antistaticbrush.us",
    "antistaticbrushes.biz",
    "antistream.cf",
    "antistream.ga",
    "antistream.gq",
    "antistream.ml",
    "antistream.tk",
    "antistress-raskraski.ru",
    "antivirus.casa",
    "antlogic.org",
    "antmine.com",
    "antongijsen.com",
    "antoniamail.club",
    "antonietta1818.site",
    "antoniojaydonmercado.com",
    "antoniou-consulting.com",
    "antonveneta.cf",
    "antonveneta.ga",
    "antonveneta.gq",
    "antonveneta.ml",
    "antonveneta.tk",
    "anttohelp.pet",
    "anttrafik.com",
    "antuong.asia",
    "antwerpen.com",
    "anuan.tk",
    "anuicvqxbvnbuo-ghjj13fggf.buzz",
    "anunturigratis.info",
    "anurbir.cf",
    "anurbir.ga",
    "anurbir.gq",
    "anversahome.se",
    "anvillondon.net",
    "anxincaifu.xyz",
    "anxiousmonk.com",
    "anxjpv.site",
    "anyagrey.com",
    "anyalias.com",
    "anydtf.site",
    "anyett.com",
    "anymate.site",
    "anymoment.com",
    "anypen.accountant",
    "anytimenow.com",
    "anytube.site",
    "anyunda.us",
    "anyvitaminant.website",
    "anyweightlosshelpok.live",
    "anywhere.pw",
    "anywherebusinessbook.com",
    "anyxnxx.fun",
    "anyxxx.fun",
    "anzy.xyz",
    "ao-quadradogaleria.com",
    "ao3wuu.us",
    "ao4ffqty.com",
    "ao5.gallery",
    "aoahomes.com",
    "aoalelgl64shf.ga",
    "aoeiualk36g.ml",
    "aoeuhtns.com",
    "aogmoney.xyz",
    "aojd-online.com",
    "aokfeo.online",
    "aol.co.uk",
    "aol.com",
    "aol.com.au",
    "aol.de",
    "aol.fr",
    "aol.it",
    "aol.jp",
    "aol.net",
    "aol.org",
    "aolinemail.cf",
    "aolinemail.ga",
    "aolmail.com",
    "aolopdep.org",
    "aoltimewarner.cf",
    "aoltimewarner.ga",
    "aoltimewarner.gq",
    "aoltimewarner.ml",
    "aoltimewarner.tk",
    "aon.at",
    "aoneie.site",
    "aonezippers.com",
    "aonhom.org",
    "aopconsultants.com",
    "aophong.org",
    "aorecd.online",
    "aorl.com",
    "aorry.live",
    "aoshihczc.com",
    "aosomi.org",
    "aostats.com",
    "aothunnhom.com",
    "aotuchem.com",
    "aotujx.xyz",
    "aotusp.xyz",
    "aouhxtdiq.shop",
    "aow88.com",
    "aowvihrm.shop",
    "aoxlso.site",
    "aoyou1688.com",
    "ap0w.us",
    "ap4ro8.info",
    "ap7wio.us",
    "apachejunctionapartments.com",
    "apadrinalo.com",
    "apagitu.biz.tm",
    "apagitu.chickenkiller.com",
    "apahalal.com",
    "apalo.tk",
    "apanrai.cf",
    "apanrai.tk",
    "aparades.com",
    "aparelhosmedicos.net",
    "apartcombo.ru",
    "apartment.supplies",
    "apartmentpropertyinvesting.com",
    "apartments-lela.com",
    "apartmentsdubai.biz",
    "apartmentsforrentlittlerockarkansas.com",
    "apartmentsseattlewashington.com",
    "apartnessljh.site",
    "apartotels.com",
    "apasier.com",
    "apcd.online",
    "apcm29te8vgxwrcqq.cf",
    "apcm29te8vgxwrcqq.ga",
    "apcm29te8vgxwrcqq.gq",
    "apcm29te8vgxwrcqq.ml",
    "apcm29te8vgxwrcqq.tk",
    "apebkxcqxbtk.cf",
    "apebkxcqxbtk.ga",
    "apebkxcqxbtk.gq",
    "apebkxcqxbtk.ml",
    "apel88.com",
    "apelsin64.icu",
    "apenpet.ga",
    "apenpet.gq",
    "apenpet.ml",
    "apepic.com",
    "aperal.cf",
    "aperal.ga",
    "aperal.tk",
    "apexize.app",
    "apexmail.com",
    "apexwheelrepair.com",
    "apfelkorps.de",
    "apfzdogpi.shop",
    "aphgcocc.shop",
    "aphlog.com",
    "aphpresyb.cf",
    "aphpresyb.ml",
    "aphpresyb.tk",
    "aphroditehalfmarathon.com",
    "aphthic.best",
    "aphydroming.xyz",
    "api-apps.icu",
    "apicker.online",
    "apidewa.info",
    "apidiligence.net",
    "apidiligence.org",
    "apidle.cf",
    "apidle.gq",
    "apiempat.xyz",
    "apih2h.com",
    "apipulsa.com",
    "apirealty.icu",
    "apis101.us",
    "apivcolon.com",
    "apk-download.site",
    "apk-download.website",
    "apk-download.xyz",
    "apk2download.net",
    "apkload.com",
    "apkmd.com",
    "apkmoe.com",
    "apknew.ru",
    "apkshake.com",
    "apksilo.com",
    "apktoel.website",
    "apkujong.tk",
    "aplando.com",
    "aplay-official.website",
    "apliquedecabelo.net",
    "aplo.me",
    "apluskid.org",
    "aplyurl.com",
    "apmail.com",
    "apmp.info",
    "apnalan.site",
    "apnastreet.com",
    "apokloj.site",
    "apollo-led.ru",
    "apollo.lv",
    "apollogpxrk.email",
    "apollope.tk",
    "apollosclouds.com",
    "apophalypse.com",
    "apophoret.xyz",
    "apophtio.cf",
    "apophtio.ga",
    "apophtio.gq",
    "apophtio.tk",
    "apoplectically.best",
    "apoplenyvb.space",
    "apor.site",
    "aport.ru",
    "aport2000.ru",
    "apotekerid.com",
    "apotheke-ed.org",
    "apown.com",
    "apoyrwyr.gq",
    "apozemail.com",
    "app-expert.com",
    "app-inc-vol.ml",
    "app-lex-acc.com",
    "app-mailer.com",
    "app0vedi.club",
    "app1e.xyz",
    "app2020feb.site",
    "app826.mobi",
    "appaji.net",
    "appc.se",
    "appdeliverynetworks.com",
    "appdev.science",
    "appdev47.best",
    "appdollars.com",
    "appealsassasins.com",
    "appeartiu.tk",
    "appendonly.network",
    "appfellas.com",
    "appflow.design",
    "appgallery.club",
    "appinventor.nl",
    "appixie.com",
    "appl3.cf",
    "appl3.ga",
    "appl3.gq",
    "appl3.ml",
    "appl3.tk",
    "applaudthecause.com",
    "applaudthecause.org",
    "apple-account.app",
    "apple.dnsabr.com",
    "apple.sib.ru",
    "appleaccount.app",
    "applecraft.online",
    "appledev.online",
    "applefaerie.com",
    "applegift.xyz",
    "applejftwn.club",
    "applejftwn.host",
    "applejftwn.site",
    "applejftwn.website",
    "applerewards.live",
    "applerobot.info",
    "apples4sale.com",
    "appleservices.online",
    "appleshps.website",
    "applesmokedmeats.com",
    "applet.live",
    "appleton-lettings.com",
    "appletreecabin.com",
    "applewatchoutlet.com",
    "applg.online",
    "appliance-resource.info",
    "appliancesshop.futbol",
    "applied-cax.com",
    "appliedinclusion.com",
    "apply.health",
    "applyguy.com",
    "applynow0.com",
    "applyremote.online",
    "applyremote.xyz",
    "applyto.study",
    "appmail.top",
    "appmail24.com",
    "appmaillist.com",
    "appmanx1.com",
    "appmarketspy.com",
    "appmingle.com",
    "appmobile-documentneedtoupload.com",
    "appmovel.online",
    "appmyboat.online",
    "appnfo.com",
    "appnode.xyz",
    "appnowl.ml",
    "appointmentone.com",
    "appolicestate.org",
    "apppassionate.com",
    "appraiser.net",
    "apprisens.monster",
    "apprit.live",
    "approvaljmz.email",
    "approvedbydrew-marketing.com",
    "approvedfireextinguishers.com",
    "approvers.net",
    "apps.dj",
    "apps.eus",
    "appsec.link",
    "apptelstabl.monster",
    "apptied.com",
    "apptip.net",
    "appvention.com",
    "appwatch.icu",
    "apqueasmog.ga",
    "apqueasmog.ml",
    "apqueasmog.tk",
    "apra.info",
    "aprazatos.club",
    "aprender-ingles.app",
    "apreprid.com",
    "aprice.co",
    "aprilfoolspranks2014.com",
    "aprilmovo.com",
    "aprimail.com",
    "aprinta.com",
    "aprioridemo.com",
    "aprm-africanunion.org",
    "apssdc.ml",
    "aptaseniorlivingrad.live",
    "aptaseniorlivingray.live",
    "aptaseniorlivingrun.live",
    "aptaweightlosshelpok.live",
    "aptcha.com",
    "aptnumber.com",
    "aptoideforios.website",
    "aptseniorlivingtab.live",
    "aptweightlosshelpok.live",
    "apuns.live",
    "apzipo.cf",
    "aq8kvw.us",
    "aqazstnvw1v.cf",
    "aqazstnvw1v.ga",
    "aqazstnvw1v.gq",
    "aqazstnvw1v.ml",
    "aqazstnvw1v.tk",
    "aqdmg1.us",
    "aqdyed.com",
    "aqdyei.com",
    "aqdyet.com",
    "aqdyez.com",
    "aqgi0vyb98izymp.cf",
    "aqgi0vyb98izymp.ga",
    "aqgi0vyb98izymp.gq",
    "aqgi0vyb98izymp.ml",
    "aqgi0vyb98izymp.tk",
    "aqjy.site",
    "aqqit.com",
    "aqqq.icu",
    "aqqty.live",
    "aqrbdc.us",
    "aqrium.ru",
    "aqst.ru",
    "aqua-gold.shop",
    "aqua-therm-stv.ru",
    "aquabliss.info",
    "aquacreek.ru",
    "aquagrazz-ru.online",
    "aquagrazz-ru.ru",
    "aquaguide.ru",
    "aquamarina.app",
    "aquamarina.online",
    "aquarians.co.uk",
    "aquaticmail.net",
    "aquiesqueretaro.com",
    "aquilesfaillace.com",
    "aqumail.com",
    "aquog.space",
    "aquoralspray.net",
    "aquyo.xyz",
    "aqw88.com",
    "aqwuvy.site",
    "aqxfzrdv.shop",
    "aqyv0c.us",
    "aqzbodr.com",
    "ar0dc0qrkla.cf",
    "ar0dc0qrkla.ga",
    "ar0dc0qrkla.gq",
    "ar0dc0qrkla.ml",
    "ar0dc0qrkla.tk",
    "ar2tingyan.com",
    "arab-internet.com",
    "arabgottalent.net",
    "arabia.com",
    "arabianranchesrent.com",
    "arabiasecret.xyz",
    "arabicliquidman.site",
    "arabshop.biz",
    "arabtabs.com",
    "arabtop.net",
    "aracteria.space",
    "arael.tech",
    "aragonbet3.com",
    "aragonbet5.com",
    "arahal.online",
    "arak.ml",
    "arakcarpet.ir",
    "aralor.cf",
    "aralor.gq",
    "aralor.ml",
    "aralor.tk",
    "arankavto.icu",
    "arantxaalcubierre.com",
    "arapski.website",
    "ararten.ga",
    "ararten.gq",
    "ararten.tk",
    "arasempire.com",
    "arashkarimzadeh.com",
    "arazpardaz.site",
    "arb4-company.site",
    "arbat5.icu",
    "arbitrating.best",
    "arblogal.cf",
    "arblogal.ga",
    "arblogal.gq",
    "arblogal.ml",
    "arburyfoundation.com",
    "arbvc.com",
    "arcademaster.com",
    "arcadiadesigns.site",
    "arcadiafairytales.com",
    "arcarwea.ga",
    "arcarwea.gq",
    "arcarwea.ml",
    "arcarwea.tk",
    "arcelikservisleri.org",
    "archaeologist.com",
    "archbotcher.best",
    "archerrygames.com",
    "archerymail.com",
    "archevron.com",
    "archiveus.best",
    "arclinea-roma.com",
    "arcmarts.com",
    "arconatech.com",
    "arconplast.com",
    "arcor.de",
    "arcotronics.bg",
    "arcticleaf.app",
    "arcticmail.com",
    "arcticside.com",
    "arctocbhuh.info",
    "ardahanvitrin.xyz",
    "ardengiyim.xyz",
    "ardentyoga.com",
    "ardetoxcenter.com",
    "ardianto.net",
    "ardindental.com",
    "ardona.co",
    "ardudi.cf",
    "ardudi.ga",
    "ardudi.gq",
    "ardudi.ml",
    "ardudi.tk",
    "arduino.hk",
    "area-thinking.de",
    "area327.xyz",
    "areacomms.com",
    "aread.shop",
    "arealzestforlife.com",
    "areatoto.us",
    "arecaref.shop",
    "aremania.cf",
    "aremanita.cf",
    "aremop.cf",
    "aremop.ga",
    "aremop.gq",
    "aremop.ml",
    "aremyannuityadvisors.com",
    "arena-sever.ru",
    "arena212.org",
    "arena2betting.org",
    "arenapkr.com",
    "arenda-yamoburakrana.ru",
    "arendabatumi24.ru",
    "arendaspec24.ru",
    "arengvillage.com",
    "areole.ru",
    "aresanob.cf",
    "aresanob.ga",
    "aresanob.gq",
    "aresanob.ml",
    "aresanob.tk",
    "aresting.com",
    "areswebstudio.com",
    "areto.ml",
    "arewealone.space",
    "areweightlosshelpok.live",
    "areweupordown.com",
    "arewhich.com",
    "areyouhealthy.com",
    "areyouthere.org",
    "argame.name",
    "argand.nl",
    "argentina-foro.com",
    "argentina.com",
    "argnt.world",
    "argocasino-official.online",
    "argomax.site",
    "argorouting4.com",
    "arhaelogist.com",
    "arhalfpricedlistings.com",
    "arhalfpricelistings.com",
    "arhidom39.ru",
    "arhizine.ru",
    "arhx1qkhnsirq.cf",
    "arhx1qkhnsirq.ga",
    "arhx1qkhnsirq.gq",
    "arhx1qkhnsirq.ml",
    "arhx1qkhnsirq.tk",
    "ari5p7.site",
    "aria.engineer",
    "aria7bet.org",
    "ariaa8.live",
    "ariacharge.xyz",
    "ariametin2.site",
    "arianbet.info",
    "arianbet.net",
    "arianbet.org",
    "arianbetcas.com",
    "arians.co.uk",
    "ariasexy.tk",
    "ariaz.jetzt",
    "aricen.cf",
    "aricen.ga",
    "aricen.ml",
    "aricen.tk",
    "aricompton.com",
    "ariderclothing.com",
    "ariesqq.com",
    "arietesale.site",
    "arigpol.cf",
    "arigpol.ml",
    "arigpol.tk",
    "arimidex.website",
    "arinakliye.xyz",
    "ariproch.ga",
    "ariproch.gq",
    "ariproch.ml",
    "arisecreation.com",
    "arisgans.xyz",
    "aristino.co.uk",
    "aristockphoto.com",
    "ariston.ml",
    "aristotle.org",
    "aristovamuz.ru",
    "arizona-golf-vacations.com",
    "arizona-rp.space",
    "arizonaaddictiontreatment.center",
    "arizonaalcoholdetox.center",
    "arizonaapr.com",
    "arizonabirthinjurylawyer.com",
    "arizonadrivingschools.net",
    "arizonamovo.com",
    "arizonavalentine.com",
    "arizonavip.com",
    "ark-hunter.com",
    "arkada-audit.ru",
    "arkafort.app",
    "arkafort.org",
    "arkafortdatacentre.com",
    "arkafortvc.com",
    "arkansasbiomechanics.com",
    "arkansasdetox.center",
    "arkansasheroinrehab.com",
    "arkansasloves.com",
    "arkansasopiaterehab.com",
    "arkansasschw.com",
    "arkansasvalentine.com",
    "arkas.site",
    "arkehr.info",
    "arkhamgame.com",
    "arklfchxs.shop",
    "arkonnide.cf",
    "arkresponse.email",
    "arkresponse.net",
    "arkresponse.news",
    "arktive.com",
    "arlenstepanov35.online",
    "arlingtonelectricalcontractor.net",
    "arlingtonopiaterehab.com",
    "arlingtonquote.com",
    "arlingtonrescue.org",
    "arlingtonvillagecourtyard.com",
    "arlowest.net",
    "armabet21.com",
    "armabet22.com",
    "armabet23.com",
    "armabet25.com",
    "armabet29.com",
    "armabet30.com",
    "armada-ekb.ru",
    "armada4d.com",
    "armada4d.net",
    "armadatogel.com",
    "armail.in",
    "armandwii.me",
    "armanichasi.ru",
    "armanik.ru",
    "armanstrong.com",
    "armedlong4.site",
    "armenik.ru",
    "armirotto.com",
    "armocompany.ru",
    "armonitimes.com",
    "armorbag.com",
    "armormail.net",
    "armsrueito.website",
    "armstrongbuildings.com",
    "armstronglove.net",
    "army-news.online",
    "army.net",
    "armyofthought.com",
    "armyourself.online",
    "armyspy.com",
    "armystart.ru",
    "arnalan.site",
    "arnet.com.ar",
    "arno.fi",
    "arnode.com",
    "arnoldwegman.com",
    "arnonidev.com",
    "arnottcapitalbank.com",
    "arockee.com",
    "aromalovers.shop",
    "aromalovers.store",
    "aromaroomonion.xyz",
    "aromatic31ru.ru",
    "aromatics.store",
    "aron.us",
    "aronbet19.com",
    "aronbet20.com",
    "aronek.cf",
    "aronek.ml",
    "aronek.tk",
    "arorle.cf",
    "arorle.ga",
    "arorle.gq",
    "arpahosting.com",
    "arpcog.info",
    "arpqgg.us",
    "arqos-co-uk.monster",
    "arquisul.com",
    "arrai.org",
    "arrels.info",
    "arrendadorazoe.com",
    "arrgenta.icu",
    "arriankorko.com",
    "arrivedercisigaretta.com",
    "arriviture.net",
    "arrl.net",
    "arroisijewellery.com",
    "arrowdentalsmile.com",
    "arrowpointinspect.com",
    "arschloch.com",
    "arseente.site",
    "arsenal-smtp.net",
    "arsenalfans.com",
    "arsenalsmtp.net",
    "arsenalsmtp.us",
    "arsinh.com",
    "arslongaviajes.com",
    "arss.me",
    "arstudioart.com",
    "art-books-monographs.online",
    "art-en-ligne.pro",
    "art-hawk.net",
    "art-oboy.ru",
    "artaa316.xyz",
    "artaak.com",
    "artafericirii.net",
    "artamebel.ru",
    "artatrainslondon.com",
    "artatrainstokyo.com",
    "artdrip.com",
    "arteizle10.com",
    "arteizle3.com",
    "arteizle5.com",
    "arteizle7.com",
    "artemisanet.com",
    "artex-cream.tech",
    "artexplumbing.com",
    "artheyw.shop",
    "arthobbies.info",
    "arthols.ru",
    "artholst-store.ru",
    "arthrorenov.com",
    "arthurmurrayven.com",
    "arthursbox.com",
    "articlesmaximizer.com",
    "artifact.bet",
    "artificial-center.xyz",
    "artificialbelligerence.com",
    "artificialintelligence.productions",
    "artigosusados.xyz",
    "artiidex.space",
    "artikulli.info",
    "artinterpretation.org",
    "artisbokepasia.com",
    "artistemail.com",
    "artistrystrategic.com",
    "artistsfortrauma.com",
    "artlok.space",
    "artlover.com",
    "artlover.com.au",
    "artlover.shop",
    "artman-conception.com",
    "artmedinaeyecare.net",
    "artnet.design",
    "artnetconsignor.com",
    "artnetjobs.com",
    "artnetportfolio.com",
    "artntheory.com",
    "artofboss.com",
    "artofimagine.com",
    "artofmuse.net",
    "artofmuse.org",
    "artofthehearts.com",
    "artpdfmanuales.xyz",
    "artproduct.org",
    "artprophoto.ru",
    "artresources.website",
    "artrit.info",
    "artroodex.site",
    "artrovex-dealer.ru",
    "artshandsa.info",
    "arttte.com",
    "artvindendogal.com",
    "artvinepress.com",
    "arudi.ru",
    "arunachalnews.com",
    "arur01.tk",
    "arurgitu.gq",
    "arurimport.ml",
    "arvato-community.de",
    "arvestloanbalanceeraser.com",
    "arvig.net",
    "arw88.com",
    "arwana21.net",
    "arwana21.org",
    "arwanajp.org",
    "arwanatop.com",
    "arwanatop.net",
    "arwashingtonpost.com",
    "aryagate.net",
    "aryangiftshop.com",
    "aryavpn.site",
    "arybebekganteng.cf",
    "arybebekganteng.ga",
    "arybebekganteng.gq",
    "arybebekganteng.ml",
    "arybebekganteng.tk",
    "aryirawangrop.online",
    "arylabs.co",
    "arypro.tk",
    "arysc.ooo",
    "aryston.xyz",
    "arystonhub.xyz",
    "arzeju.icu",
    "arzplus2.com",
    "as-if.com",
    "as.com",
    "as.onlysext.com",
    "as01.cf",
    "as01.ga",
    "as01.gq",
    "as01.ml",
    "as02.ga",
    "as02.gq",
    "as02.ml",
    "as03.cf",
    "as03.ga",
    "as03.gq",
    "as03.ml",
    "as21.club",
    "as8218.net",
    "asahi.cf",
    "asahi.ga",
    "asahi.one",
    "asana.biz",
    "asapp-consultoria.com",
    "asaroad.com",
    "asart53.com",
    "asbdasds.space",
    "asbdsadss.space",
    "asbet-game.club",
    "asbomsk.ru",
    "ascad-pp.ru",
    "ascendventures.cf",
    "aschenbrandt.net",
    "asclckujx.shop",
    "ascona-discount.com",
    "ascparishad.icu",
    "asd3886uklll.com",
    "asdas.xyz",
    "asdascxz-sadasdcx.icu",
    "asdascxz-sadxzcwaasdcx.icu",
    "asdasd.co",
    "asdasd.nl",
    "asdasd.ru",
    "asdasdadshdasd2.ga",
    "asdasdasd5.site",
    "asdasdasd7.site",
    "asdasdasd9.site",
    "asdbasnds.space",
    "asdbwegweq.xyz",
    "asdf.pl",
    "asdfasd.co",
    "asdfasdf.co",
    "asdfasdfmail.net",
    "asdfghmail.com",
    "asdfhired.com",
    "asdfmail.net",
    "asdfnews.org",
    "asdfpost.com",
    "asdfsdf.co",
    "asdfsearch.com",
    "asdhad12.top",
    "asdhgsad.com",
    "asdsd.co",
    "asean-mail",
    "asean-mail.com",
    "aseas-asdk.ru",
    "aserbo.ga",
    "aserbo.gq",
    "aserbo.tk",
    "asetbet.online",
    "aseztakwholesale.com",
    "asf-stroy-71.ru",
    "asfda.site",
    "asfdasd.com",
    "asgaccse-pt.cf",
    "asgaccse-pt.ga",
    "asgaccse-pt.gq",
    "asgaccse-pt.ml",
    "asgaccse-pt.tk",
    "asgardia-space.tk",
    "asgasgasgasggasg.ga",
    "asgasgasgasggasg.ml",
    "asgasghashashas.cf",
    "asgasghashashas.ga",
    "asgasghashashas.gq",
    "asgasghashashas.ml",
    "asgcxb.icu",
    "asghashasdhasjhashag.ml",
    "asgrad.com",
    "asha-dhsh.ru",
    "ashamelejk.club",
    "ashellgame.net",
    "asheville.com",
    "ashfoundation.com",
    "ashiapjamet.com",
    "ashik2in.com",
    "ashina.men",
    "ashiquichats.com",
    "ashleyandrew.com",
    "ashleyfurniturehomestorenorth.com",
    "ashleystoys.com",
    "ashopping.site",
    "ashotmail.com",
    "asia-links.com",
    "asia-mail.com",
    "asia-me.review",
    "asia-pasifikacces.com",
    "asia.com",
    "asia303.space",
    "asia303.xyz",
    "asiabet66.xyz",
    "asiafetteratom.website",
    "asiafind.com",
    "asiame.review",
    "asiamegagroup.com",
    "asian-wife-finder.com",
    "asianavenue.com",
    "asianbeauty.app",
    "asianbusinesscatalog.com",
    "asiancityweb.com",
    "asiangangsta.site",
    "asianmarket.best",
    "asianmeditations.ru",
    "asianpartsmarket.com",
    "asianpkr88.info",
    "asiansonly.net",
    "asiantakeout.com",
    "asianwired.net",
    "asianyouthchess.com",
    "asiapacificexecutives.org",
    "asiapmail.club",
    "asiapoint.net",
    "asiapoker303.space",
    "asiaprofiles.com",
    "asiaqq59.xyz",
    "asiaqq7.com",
    "asiaqq8.com",
    "asiaqq9.com",
    "asiarap.usa.cc",
    "asiaunited.cloud",
    "asiaunited.directory",
    "asiaunited.network",
    "asiawin77.asia",
    "asifboot.com",
    "asik2in.biz",
    "asik2in.com",
    "asiki2in.com",
    "asikpoker99.com",
    "asikqq168.net",
    "asikqq168.org",
    "asilgrupotomotiv.xyz",
    "asin2ean.com",
    "asino-luck.net",
    "asino7.fun",
    "asino7.site",
    "asinondemand.com",
    "asinproplus.com",
    "asinspector.org",
    "asio.club",
    "asisec.cf",
    "asisec.gq",
    "asisec.ml",
    "asistx.info",
    "asistx.net",
    "asistx.org",
    "ask-bo.co.uk",
    "ask-mail.com",
    "ask2me.online",
    "askaclub.ru",
    "askarturejeki.online",
    "askbam.com",
    "askdigitalgully.com",
    "askhaymond.net",
    "askhaymond.org",
    "askhaymondlaw.info",
    "askhaymondlawfirm.net",
    "askingprice.click",
    "askjob.asia",
    "askmyfaith.org",
    "askoqopoiweiwe.online",
    "askozy.com",
    "askpirate.com",
    "asktheselfstorageexperts.com",
    "askyouth.org",
    "asl13.cf",
    "asl13.ga",
    "asl13.gq",
    "asl13.ml",
    "asl13.tk",
    "aslibayar.com",
    "aslibayar.org",
    "aslldsa.site",
    "asls.ml",
    "asm.snapwet.com",
    "asmryy.xyz",
    "asn.services",
    "asndasbds.space",
    "asndassbs.space",
    "asnpk88.org",
    "asobin.gq",
    "asoes.tk",
    "asofinder.com",
    "asoflex.com",
    "asokla.cf",
    "asokla.ga",
    "asoniashop.ru",
    "asooemail.net",
    "asorent.com",
    "asors.org",
    "asosfr.info",
    "aspasiamaldives.com",
    "aspavabet.com",
    "aspenclean.net",
    "aspfitting.com",
    "asphalt-9-legends.ru",
    "aspiredoge.com",
    "aspiringweb.net",
    "asportscoach.app",
    "ass-o-ass.com",
    "ass.bike",
    "ass.llc",
    "ass.pp.ua",
    "assadvi.ml",
    "assadvi.tk",
    "assala.com",
    "assamesemail.com",
    "assamsales.com",
    "assayplate.com",
    "asseenontvllc.com",
    "assertiongame.com",
    "assetcdn.online",
    "assetcrypto.com",
    "assetfinanceaggregator.com",
    "assetscoin.com",
    "assfire.online",
    "assimiired.space",
    "assimiliate.com",
    "assist-nets-secure.net",
    "assistance-bureautique.com",
    "assistedlivingfacilitesnearme.org",
    "assistedlivingfacilityfinder.org",
    "assistedlivingfacilityinfo.org",
    "assistedlivingfacilitynearme.org",
    "assitance-entreprise.co0-180.com",
    "assitance-entreprise.co0815.ru",
    "assitance-entreprise.com",
    "assitv.site",
    "assmadness.com",
    "associazionearia.org",
    "assohass.com",
    "assortiekb.ru",
    "asspoo.com",
    "asss.com",
    "assuranceprops.fun",
    "assurances-maladie-fr.com",
    "assurancespourmoi.eu",
    "assureplan.info",
    "assurmail.net",
    "astabbettsnupp2020.xyz",
    "astabetsnup.xyz",
    "astabilbettsnapp.xyz",
    "astaghfirulloh.cf",
    "astaghfirulloh.ga",
    "astaghfirulloh.gq",
    "astaghfirulloh.ml",
    "astalias.us",
    "astanahotels.org",
    "astaza.net",
    "asteimmobiliarialert.org",
    "asteraavia.ru",
    "asterialop.site",
    "asteron.info",
    "astheatbu.cf",
    "astheatbu.ga",
    "astheatbu.gq",
    "astibo.com",
    "asticce.gq",
    "astigmatnedir.net",
    "astigmattedavisi.com",
    "astonut.cf",
    "astonut.ga",
    "astonut.ml",
    "astonut.tk",
    "astoriago.com",
    "astoryending.com",
    "astos.online",
    "astos.space",
    "astraeusairlines.xyz",
    "astralcars.com",
    "astralhotel.net",
    "astretsovskayaigrushka.ru",
    "astridmyshop.com",
    "astroboymail.com",
    "astroempires.info",
    "astrofactions.club",
    "astrology.host",
    "astrolover.com",
    "astropaynoktasi.com",
    "astropink.com",
    "astroscardsapp.com",
    "astrosfan.com",
    "astrosfan.net",
    "astrosmurfs.cf",
    "astrotogel.net",
    "astrototog.com",
    "astrototoh.com",
    "astrototoi.com",
    "astutedesignstudio.com",
    "asu.mx",
    "asu.party",
    "asu.su",
    "asuaia.xyz",
    "asuctp.info",
    "asukanet.com",
    "asurfer.com",
    "asurnamealwayspaystheirbills.com",
    "asus-vivostick.online",
    "asus.com",
    "aswaqinfodz.com",
    "asweetuni.ooo",
    "asy1333.com",
    "asyabahis10.com",
    "asyabahis11.com",
    "asyabahis13.com",
    "asyabahis135.com",
    "asyabahis15.com",
    "asyabahis18.com",
    "asyabahis2.com",
    "asyabahis21.com",
    "asyabahis25.com",
    "asyabahis26.com",
    "asyabahis27.com",
    "asyabahis3.com",
    "asyabahis724.com",
    "asyabahis777.com",
    "asyabahis888.com",
    "asyabahis9.com",
    "asyabahisgiris.xyz",
    "asyncekspert.net",
    "asynchbwls.ru",
    "aszx77.xyz",
    "at-band-camp.net",
    "at-desires-unanderra-i.blue",
    "at-funeral.com",
    "at-leads.ru",
    "at-news3.net",
    "at.hm",
    "at0mik.org",
    "ataaalkhayer.net",
    "atadatat.shop",
    "atakanarisoy.online",
    "atakbahis.net",
    "atakei.icu",
    "atakkitap.net",
    "atalai.tk",
    "atansid.cf",
    "atansid.ml",
    "atansid.tk",
    "atarax.website",
    "atariazteca.com",
    "atarif.ga",
    "atarif.gq",
    "atarif.ml",
    "atarif.tk",
    "atarigamepartners.com",
    "atarinewvcs.com",
    "atarivcs.net",
    "atarivideocomputersystem.com",
    "atasehirsuit.com",
    "atatteve.website",
    "atbeoffroad.com",
    "atbhatby.shop",
    "atcuxffg.shop",
    "atearl.com",
    "atech5.com",
    "ateculeal.info",
    "atedateh.shop",
    "atefswalgent.tk",
    "ateliebar.com",
    "atelier-generations.be",
    "atelierprojeturbain.com",
    "ateliersprojeturbain.com",
    "ateng.ml",
    "atengtom.cf",
    "atenk99.ml",
    "atenolol.website",
    "atenolol247.video",
    "atfoak.us",
    "atharroi.cf",
    "atharroi.gq",
    "atharroi.ml",
    "atharroi.tk",
    "athebettsnaps.xyz",
    "atheist.com",
    "athenachu.net",
    "athens-loft.com",
    "athens5.com",
    "athensmaritime.info",
    "athensmaritime.org",
    "athensmusician.org",
    "atherea.info",
    "atherea.org",
    "atherogngm.space",
    "athfacrebes.cf",
    "athleticinterests.com",
    "athleticmen.ru",
    "athomeinjacksonhole.info",
    "athomeinjacksonhole.net",
    "athomeinjacksonhole.org",
    "atihatim.shop",
    "atiku.website",
    "atimp.com",
    "atina.cl",
    "ationalas.icu",
    "ativin.ru",
    "atkirson.press",
    "atl.lv",
    "atlanta-rv-rentals.com",
    "atlanta4d.com",
    "atlantacocainerehab.com",
    "atlantagahomes.com",
    "atlantagaragefloor.com",
    "atlantaquote.com",
    "atlanticbb.net",
    "atlanticcanada-japan.com",
    "atlanticcanadacruise.com",
    "atlanticmc.shop",
    "atlanticyu.com",
    "atlantisbahis6.com",
    "atlantisbahis7.com",
    "atlantisbahis9.com",
    "atlas.cz",
    "atlasaerials.co.uk",
    "atlasbet400.com",
    "atlasbets.com",
    "atlaswatersolutions.net",
    "atlaswebmail.com",
    "atlcarpentry.com",
    "atleha.africa",
    "atlink.com",
    "atlteknet.com",
    "atm-mi.cf",
    "atm-mi.ga",
    "atm-mi.gq",
    "atm-mi.ml",
    "atm-mi.tk",
    "atmc.net",
    "atmosfera-kazan.ru",
    "atms4z.site",
    "atnalan.site",
    "atnextmail.com",
    "atnight.me",
    "ato.check.com",
    "atolyezen.com",
    "atomq.org",
    "atomtoys.ru",
    "atopticus.biz",
    "atoverthetopshop.com",
    "atoyot.cf",
    "atoyot.ga",
    "atoyot.gq",
    "atoyot.ml",
    "atoyot.tk",
    "atoz.community",
    "atoz.support",
    "atozasia.com",
    "atp-dz.com",
    "atpfinals.ru",
    "atpworldtour-2016.com",
    "atrickmail.com",
    "atrus.ru",
    "atscam.online",
    "atstifin.ga",
    "atstifin.gq",
    "atstifin.tk",
    "atsw.de",
    "att-warner.cf",
    "att-warner.ga",
    "att-warner.gq",
    "att-warner.ml",
    "att-warner.tk",
    "att.com",
    "att.net",
    "attaber.cf",
    "attaber.ga",
    "attaber.gq",
    "attaber.ml",
    "attaber.tk",
    "attack.icu",
    "attacking.live",
    "attacking.network",
    "attacking.site",
    "attackonkingslanding.net",
    "attackonknightslanding.net",
    "attacks.cloud",
    "attacks.email",
    "attacks.life",
    "attacks.live",
    "attacks.news",
    "attacks.social",
    "attakka.com",
    "attbi.com",
    "attckdigital.com",
    "attention-message.support",
    "attention.support",
    "attglobal.net",
    "atticforg.icu",
    "atticst.icu",
    "attnetwork.com",
    "attobas.cf",
    "attobas.gq",
    "attobas.ml",
    "attobas.tk",
    "attop46.xyz",
    "attorney-recruiter.com",
    "attpaygopayment.com",
    "attract-sensitive.xyz",
    "attract-too.xyz",
    "attraktiv.nu",
    "attymail.com",
    "atulyahelp.gq",
    "atunendog.tk",
    "atux.de",
    "atvclub.msk.ru",
    "atwankbe3wcnngp.ga",
    "atwankbe3wcnngp.ml",
    "atwankbe3wcnngp.tk",
    "atwerpfj.shop",
    "au.ru",
    "au3.support",
    "au462.site",
    "au651.site",
    "au6msx.com",
    "auauau.host",
    "aub6jbkk.xyz",
    "auburn.edu",
    "aucenter.info",
    "auction315.xyz",
    "auctioneer.net",
    "auctionzones.com",
    "audi-r8.cf",
    "audi-r8.ga",
    "audi-r8.gq",
    "audi-r8.ml",
    "audi-r8.tk",
    "audi-tt.cf",
    "audi-tt.ga",
    "audi-tt.gq",
    "audi-tt.ml",
    "audi-tt.tk",
    "audi.igg.biz",
    "audill.xyz",
    "audio.delivery",
    "audio.now.im",
    "audioalarm.de",
    "audiobrush.com",
    "audioslim.com",
    "audiossl.stream",
    "audipartshub.com",
    "audise.xyz",
    "audit-buhgalteria.ru",
    "auditenvy.org",
    "auditnv.com",
    "audrey11reveley.ga",
    "audvik.ru",
    "aueriq.icu",
    "auey1wtgcnucwr.cf",
    "auey1wtgcnucwr.ga",
    "auey1wtgcnucwr.gq",
    "auey1wtgcnucwr.ml",
    "auey1wtgcnucwr.tk",
    "aufeminin.com",
    "augmentai.org",
    "augmentationtechnology.com",
    "augmentin875mg.info",
    "augrabiesfallsnationalpark.com",
    "augstusproductions.com",
    "augustmovo.com",
    "auiiqj.best",
    "aukcionsaitov.ru",
    "aukcionsajtov.ru",
    "aulaline.com",
    "auntshop.xyz",
    "auoi53la.ga",
    "auoie.com",
    "aupforrez.shop",
    "aupiurao.xyz",
    "aur0vk.us",
    "auraliv.com",
    "aurangabadlive.com",
    "auraqq.com",
    "aurawire.com",
    "aurcasino.com",
    "aureliaprime.net",
    "aurelstyle.ru",
    "aures-autoparts.com",
    "aurile.xyz",
    "aurill.xyz",
    "aurora-flare.com",
    "aurora-flares.com",
    "auroraaddictiontreatment.com",
    "auroraalcoholrehab.com",
    "auroraheroinrehab.com",
    "auroraooo.xyz",
    "aurorapacking.ru",
    "aus-city.com",
    "aus.schwarzmail.ga",
    "ausdance.org",
    "ausdocjobs.com",
    "ausdoctors.info",
    "ausgefallen.info",
    "ausi.com",
    "auslaenderberatunge-erfurt.press",
    "auspaccornerstone.com",
    "auspicy.best",
    "aussie.finance",
    "aussie.loan",
    "aussieboat.loan",
    "aussiebulkdiscounting.com",
    "aussiecampertrailer.loan",
    "aussiecampertrailer.loans",
    "aussiecar.loans",
    "aussiecaravan.loan",
    "aussiegroups.com",
    "aussieknives.club",
    "aussielesiure.loans",
    "aussiemail.com.au",
    "aussiematureclub.com",
    "aussiepersonal.loan",
    "aussiepersonal.loans",
    "austimail.com",
    "austin-njrotc.org",
    "austin.rr.com",
    "austin.utexas.edu",
    "austinbell.name",
    "austincar.club",
    "austincocainerehab.com",
    "austincohousing.org",
    "austincollege.edu",
    "austinheroinrehab.com",
    "austinopiaterehab.com",
    "austinsherman.me",
    "austintexashomebuyers.com",
    "australia.edu",
    "australiadirect.xyz",
    "australiamail.com",
    "australiamining.xyz",
    "australiandoctorplus.com",
    "australianfinefood.com",
    "australianlegaljobs.com",
    "austriayoga.com",
    "austrosearch.net",
    "austrycastillo.com",
    "auta.host",
    "auth.legal",
    "auth.page",
    "authensimilate.com",
    "authenticautograph.net",
    "authenticawakeningadvanced.com",
    "authenticpayments.net",
    "authinfomobupdate.xyz",
    "author24.su",
    "authoritycelebrity.com",
    "authorityleadership.com",
    "authorityredirect.com",
    "authorityvip.com",
    "authorize97pn.online",
    "authorizedoffr.com",
    "authorship.com",
    "authortheme.co",
    "authupdate.biz",
    "auti.st",
    "autismcarecentersnearme.com",
    "autismcentermarketingagency.com",
    "autismcenterwebdesign.com",
    "autismcenterwebmarketing.com",
    "autismtherapycentersforadults.com",
    "autismtreatmentforadults.com",
    "autismtreatmentpractices.com",
    "auto-complete.info",
    "auto-gar.ru",
    "auto-pay.info",
    "auto327.xyz",
    "auto411jobs.xyz",
    "auto417.xyz",
    "autoaa317.xyz",
    "autoadvisorscanada.com",
    "autocardesign.site",
    "autocarinjury.com",
    "autochistka18.ru",
    "autocloud49.xyz",
    "autocpet.ru",
    "autodienstleistungen.de",
    "autodiler.net",
    "autoescuelanerja.com",
    "autofiber.site",
    "autofinity.pro",
    "autograf.pl",
    "autoguruja.com",
    "autohotline.us",
    "autoinsurance-help.zone",
    "autoinsurancesanantonio.xyz",
    "autolainat.com",
    "autoloanhub.online",
    "automail.ru",
    "automatedpersonnel.com",
    "automatedsalesfunneltips.xyz",
    "automatizes768jm.online",
    "automechanics.net",
    "automenosa.info",
    "automisely.org",
    "automiselymail.com",
    "automiselymail.info",
    "automiselymail.net",
    "automisly.info",
    "automisly.org",
    "automizeapi.com",
    "automizely.info",
    "automizelymail.info",
    "automizelymail.net",
    "automizelymail.org",
    "automizen.com",
    "automizly.com",
    "automizly.info",
    "automizly.net",
    "automizly.org",
    "automobiledeals.net",
    "automotive-mediaventions.com",
    "automotiveauthority.com",
    "autoparts73.ru",
    "autopdfmanuales.xyz",
    "autopro24.de",
    "autorambler.ru",
    "autorepairaustralia.xyz",
    "autorepairtech.press",
    "autorijschoolpoul.com",
    "autorim.org",
    "autorobotica.com",
    "autoscan.info",
    "autosearch411.xyz",
    "autosoars.info",
    "autosouvenir39.ru",
    "autostabilbetsnup.xyz",
    "autostupino.ru",
    "autotalon.info",
    "autotest.ml",
    "autotrackeranalyzer.com",
    "autotropic.site",
    "autotwollow.com",
    "autoums.info",
    "autour-des-auteurs.info",
    "autowb.com",
    "autozine.net",
    "autozoomer.ru",
    "autumnfalls.site",
    "autway.agency",
    "auw88.com",
    "auwgo.live",
    "auwinnewphone.site",
    "auxi.auction",
    "auxifyboosting.ga",
    "auxometer.site",
    "auxometer.xyz",
    "auxoqq.com",
    "auzakup979.ru",
    "av-8.buzz",
    "av-ap.pro",
    "av-ap6.pro",
    "av-ap7.pro",
    "av-rent.ru",
    "av112.xyz",
    "av113.xyz",
    "av117.club",
    "av117.news",
    "av117.online",
    "av117.video",
    "av119.xyz",
    "av1639.com",
    "av1684.com",
    "av1689.com",
    "av1719.com",
    "av1726.com",
    "av1729.com",
    "av1730.com",
    "av200.xyz",
    "av300.xyz",
    "av303.xyz",
    "av9090.top",
    "av9090.xyz",
    "avaba.ru",
    "avadickinson.buzz",
    "avaiatorpower.com",
    "avalonpregnancycoaching.com",
    "avalop.org",
    "avanbom.xyz",
    "avangard-kapital.ru",
    "avantatravel.ru",
    "avantcreditoffer.com",
    "avantgardescientificjournal.xyz",
    "avapardaz9.info",
    "avast.ml",
    "avastyble.com",
    "avatastar.com",
    "avatrade.trading",
    "avava.site",
    "avaya.team",
    "avbeafun.gq",
    "avbeafun.ml",
    "avcc.tk",
    "avchina.live",
    "avchina.us",
    "avchoiju.cf",
    "avchoiju.ga",
    "avchoiju.ml",
    "avchoiju.tk",
    "avciseti.xyz",
    "avelani.com",
    "avenir-biz.com",
    "avenirshoes.ru",
    "avenue.careers",
    "avenueway.com",
    "aver.com",
    "averdov.com",
    "averona72.ru",
    "aversale.com",
    "averyhart.com",
    "avglatga.cf",
    "avglatga.ml",
    "avglatga.tk",
    "avgtm3.best",
    "avh.hu",
    "avhmq.icu",
    "avhuanle.com",
    "avia-krepe.online",
    "avia-krepo.online",
    "avia-tonic.fr",
    "aviabilety-kupit-bilety.ru",
    "aviani.com",
    "avibrahimkoyuncu.xyz",
    "avidniro.com",
    "avihefub.shop",
    "avikd.tk",
    "avio.cf",
    "avio.ga",
    "avio.gq",
    "avio.ml",
    "avioaero.cf",
    "avioaero.ga",
    "avioaero.gq",
    "avioaero.ml",
    "avioaero.tk",
    "aviocreditpromocode.com",
    "avisa.blue",
    "avisfarms.com",
    "avishekgyawali.com",
    "avissena.com",
    "avitamedical.info",
    "avito-boxberry.ru",
    "avito-dilivery.ru",
    "avito-office.ru",
    "avito-package.ru",
    "avito-payshops.ru",
    "avito-repayment.online",
    "avito-safe.online",
    "avito-save.online",
    "avitoguard.online",
    "avitosafe.online",
    "avitoxpress.online",
    "avkdubai.com",
    "avls.pt",
    "avmali.club",
    "avmynv.us",
    "avn7t.us",
    "avnews101.net",
    "avnnews.review",
    "avo-ap.pro",
    "avofcb.com",
    "avokhel.ml",
    "avondalefarm.com",
    "avonforlady.ru",
    "avonnychildcare.com",
    "avoori-newsletters.com",
    "avosbka.ru",
    "avosdesign.art",
    "avosdesign.org",
    "avozo.us",
    "avp1brunupzs8ipef.cf",
    "avp1brunupzs8ipef.ga",
    "avp1brunupzs8ipef.gq",
    "avp1brunupzs8ipef.ml",
    "avp1brunupzs8ipef.tk",
    "avpa.nl",
    "avpai.biz",
    "avpai.info",
    "avpai.live",
    "avpai.org",
    "avpai.video",
    "avr.ze.cx",
    "avrbo.org",
    "avrora62.ru",
    "avrupabet151.com",
    "avrupabet154.com",
    "avrupabet164.com",
    "avrupabet170.com",
    "avrupalianne.com",
    "avsow.com",
    "avtarhelp.com",
    "avto-ap.pro",
    "avto-fakt.ru",
    "avto-op.pro",
    "avto-parts24.ru",
    "avtobalans.ru",
    "avtobym.ru",
    "avtoklimatpro.ru",
    "avtomani.com",
    "avtomatika-stout.ru",
    "avtoproin16.ru",
    "avtoritet.ru",
    "avtoservis-acura.ru",
    "avtoservis-bmvv.ru",
    "avtoservis-cadillac.ru",
    "avtoservis-chrysler.ru",
    "avtoservis-citroen.ru",
    "avtoservis-dodge.ru",
    "avtoservis-fiat.ru",
    "avtoservis-ford.ru",
    "avtoservis-geely.ru",
    "avtoservis-honda.ru",
    "avtoservis-isuzu.ru",
    "avtoservis-jeep.ru",
    "avtoservis-kla.ru",
    "avtoservis-lexus.ru",
    "avtoservis-mazda.ru",
    "avtoservis-mercedes.ru",
    "avtoservis-opel.ru",
    "avtoservis-peugeot.ru",
    "avtoservis-porsche.ru",
    "avtoservis-rangerover.ru",
    "avtoservis-seat.ru",
    "avtoservis-ssangyong.ru",
    "avtoservis-subaru.ru",
    "avtoservis-suzuki.ru",
    "avtoservis-v-podolske.ru",
    "avtoservisrus.ru",
    "avtoshkolaexpert.ru",
    "avtoshtorka.ru",
    "avtospasatel39.ru",
    "avtosputnik.ru",
    "avtostiker.ru",
    "avtotalon.com",
    "avtovyshkann.ru",
    "avtt3599.com",
    "avuimkgtbgccejft901.cf",
    "avuimkgtbgccejft901.ga",
    "avuimkgtbgccejft901.gq",
    "avuimkgtbgccejft901.ml",
    "avuimkgtbgccejft901.tk",
    "avukatbul.org",
    "avukatportali.com",
    "avventurepersposati-confirmed.com",
    "avvraedu.online",
    "avwang.club",
    "avxdic.us",
    "avxpay.money",
    "avxpay.org",
    "avz0.net",
    "avz1.net",
    "avz3.net",
    "aw.kikwet.com",
    "aw5u.us",
    "awahal0vk1o7gbyzf0.cf",
    "awahal0vk1o7gbyzf0.ga",
    "awahal0vk1o7gbyzf0.gq",
    "awahal0vk1o7gbyzf0.ml",
    "awahal0vk1o7gbyzf0.tk",
    "awakeningwomenglobal.com",
    "awakmedia.com",
    "awarecro.xyz",
    "awareiv.recipes",
    "awarejune.com",
    "awarenessu.com",
    "awarenj.net",
    "awaresout.xyz",
    "awaretab.icu",
    "awarewri.us",
    "awartisan.com",
    "awatum.de",
    "awayonvacation.com",
    "awchronran.cf",
    "awchronran.ga",
    "awchronran.gq",
    "awchronran.ml",
    "awcon.online",
    "awdrt.com",
    "awdrt.net",
    "awdrt.org",
    "awea.icu",
    "awebo6688.com",
    "aweh.icu",
    "awel.icu",
    "aweo.icu",
    "awep.icu",
    "awep.net",
    "aweq.icu",
    "awer.icu",
    "awesome.reviews",
    "awesomereviews.com",
    "awewallet.com",
    "awex.icu",
    "awez.icu",
    "awholelotofamechi.com",
    "awiki.org",
    "awkrm1.site",
    "awmxcu.site",
    "awngqe4qb3qvuohvuh.cf",
    "awngqe4qb3qvuohvuh.ga",
    "awngqe4qb3qvuohvuh.gq",
    "awngqe4qb3qvuohvuh.ml",
    "awngqe4qb3qvuohvuh.tk",
    "awoiyt.us",
    "awol.fun",
    "aworldof17hats.com",
    "aworldofeasier.com",
    "awpernist.cf",
    "awphj3.us",
    "awprofta.cf",
    "awprofta.ga",
    "awprofta.gq",
    "awprofta.ml",
    "awprofta.tk",
    "awrp3laot.cf",
    "aws.creo.site",
    "aws910.com",
    "awsom.net",
    "awsomesoft.com",
    "awsoo.com",
    "awwm.icu",
    "ax0c.tel",
    "ax80mail.com",
    "axa-hh.com",
    "axactis.com",
    "axaz.email",
    "axbahis77.com",
    "axbet.live",
    "axcenze.cloud",
    "axefactoryrun.com",
    "axeprim.eu",
    "axerupi.ru",
    "axevolution-sf.net",
    "axexch.com",
    "axgd5m2et5kmwdn.xyz",
    "axiomboatworks.com",
    "axiongard.net",
    "axischurchbend.com",
    "axiz.digital",
    "axiz.org",
    "axjpvj.com",
    "axkleinfa.com",
    "axmluf8osv0h.cf",
    "axmluf8osv0h.ga",
    "axmluf8osv0h.gq",
    "axmluf8osv0h.ml",
    "axmluf8osv0h.tk",
    "axnxx.site",
    "axomcinema.com",
    "axon7zte.com",
    "axoskate.com",
    "axsup.net",
    "axt5ub.us",
    "axuwv6wnveqhwilbzer.cf",
    "axuwv6wnveqhwilbzer.ga",
    "axuwv6wnveqhwilbzer.gq",
    "axuwv6wnveqhwilbzer.ml",
    "axuwv6wnveqhwilbzer.tk",
    "axz6ii.us",
    "axzmgl.best",
    "ay33rs.flu.cc",
    "ayabt.com",
    "ayahoo.com",
    "ayakkaoutlet.xyz",
    "ayalu.com",
    "ayamaria.net",
    "ayamrempahdosting.com",
    "ayandon.xyz",
    "ayanyalvarado.com",
    "ayblieufuav.cf",
    "ayblieufuav.ga",
    "ayblieufuav.gq",
    "ayblieufuav.ml",
    "ayblieufuav.tk",
    "aycereview.com",
    "aycnep.com",
    "aydinhafriyat.xyz",
    "aydinlila.com",
    "aydinliq.xyz",
    "aydinmoda.xyz",
    "ayearinmemes.com",
    "ayecapta.in",
    "aygg888.com",
    "ayitimizik.org",
    "ayizkufailhjr.cf",
    "ayizkufailhjr.ga",
    "ayizkufailhjr.gq",
    "ayizkufailhjr.ml",
    "ayizkufailhjr.tk",
    "ayna.com",
    "aynacaphe.com",
    "aynbpx.us",
    "aynginaboys.club",
    "ayobsharafinia.ir",
    "ayohave.fun",
    "ayonae.info",
    "ayopoker.win",
    "ayrintiyayinlari.net",
    "ayro-music.site",
    "aysendemir.com",
    "aytos.ru",
    "ayuawd.com",
    "ayudafacebook.com",
    "ayuh.myvnc.com",
    "ayurvedablog.com",
    "ayurvedamassagen.de",
    "ayurvedanepal.online",
    "ayurvedicresorts.club",
    "ayurvedmedicines.com",
    "ayzrx1.site",
    "az-mob-go.site",
    "az3goods.space",
    "az8fja.us",
    "azacavesuite.com",
    "azaddictiontreatmentcenter.com",
    "azamat-farisovich.ru",
    "azanisgroup.com",
    "azart-player.ru",
    "azartplay-casino-official.online",
    "azartplay.space",
    "azazazatashkent.tk",
    "azcmpu.us",
    "azcomputerworks.com",
    "azcork.com",
    "azehiaxeech.ru",
    "azel.xyz",
    "azemar.cf",
    "azemar.tk",
    "azerion-one.net",
    "azerion.biz",
    "azerion.info",
    "azerion.net",
    "azerion.org",
    "azerionone.com",
    "azerionone.org",
    "azest.us",
    "azet.sk",
    "azfkbayci.shop",
    "azh1tq.site",
    "azhirock.com",
    "azimiweb.com",
    "azino-777.vin",
    "azino7.info",
    "azino7.net",
    "azino7.org",
    "azino777-vip.club",
    "azino7788.ru",
    "azinoobyk777.icu",
    "azipeas.cf",
    "azipeas.ga",
    "azipeas.gq",
    "azipeas.ml",
    "azipeas.tk",
    "azizogludanismanlik.xyz",
    "azjuggalos.com",
    "azjyys.site",
    "azmeil.tk",
    "azmn.info",
    "azmyspace.com",
    "azmziarat.com",
    "azocoin.com",
    "azomain.xyz",
    "azooma.ru",
    "azorescarsrental.com",
    "azote.cf",
    "azote.ga",
    "azote.gq",
    "azqtbv.info",
    "azrooh.ru",
    "azsh0j.us",
    "azspartners.ru",
    "azsportsnetwork.net",
    "azterul.ru",
    "azulgold.com",
    "azure.cloudns.asia",
    "azureexplained.com",
    "azurelend.com",
    "azxhzkohzjwvt6lcx.cf",
    "azxhzkohzjwvt6lcx.ga",
    "azxhzkohzjwvt6lcx.gq",
    "azxhzkohzjwvt6lcx.ml",
    "azxhzkohzjwvt6lcx.tk",
    "azzurro.cf",
    "azzurro.ga",
    "azzurro.gq",
    "azzurro.ml",
    "b-clickp-company.site",
    "b-clicks-company.site",
    "b-expert.xyz",
    "b-idp.com",
    "b-response.com",
    "b-sky-b.cf",
    "b-sky-b.ga",
    "b-sky-b.gq",
    "b-sky-b.ml",
    "b-sky-b.tk",
    "b-ud-s.site",
    "b.cr.cloudns.asia",
    "b.kerl.gq",
    "b.reed.to",
    "b.royal-syrup.tk",
    "b.smelly.cc",
    "b.yertxenor.tk",
    "b0.nut.cc",
    "b002qxsr.online",
    "b003adkl.online",
    "b004cugm.online",
    "b005nwbl.online",
    "b006jftg.club",
    "b007jkkm.club",
    "b008kfni.club",
    "b010keio.club",
    "b011wagq.cloud",
    "b012fvao.cloud",
    "b013qxvb.cloud",
    "b014mafv.cloud",
    "b015hrda.cloud",
    "b0231e60.xyz",
    "b031rapb.best",
    "b032grbd.best",
    "b033wwgw.best",
    "b035oemn.best",
    "b036npuo.monster",
    "b037gmes.monster",
    "b038jnkq.monster",
    "b039syla.monster",
    "b03pg.site",
    "b040ncjr.monster",
    "b042okoy.website",
    "b043nrsq.website",
    "b044lefb.website",
    "b045riie.website",
    "b046fesb.uno",
    "b047fchg.uno",
    "b048jkns.uno",
    "b049eppa.uno",
    "b050yryr.uno",
    "b051ykec.site",
    "b052cqix.site",
    "b053lbrq.site",
    "b054pdzc.site",
    "b055mujo.site",
    "b056luvv.fun",
    "b058xrhd.fun",
    "b059xxsz.fun",
    "b0ts7k.us",
    "b101studio.net",
    "b10sk.site",
    "b12b4d5.club",
    "b18dc.xyz",
    "b1diet.com",
    "b1gmail.epicgamer.org",
    "b1mbt.cloud",
    "b1of96u.com",
    "b1p5xtrngklaukff.cf",
    "b1p5xtrngklaukff.ga",
    "b1p5xtrngklaukff.gq",
    "b1p5xtrngklaukff.tk",
    "b22b80e1.xyz",
    "b24api.xyz",
    "b24api03.xyz",
    "b24api1.xyz",
    "b25fh.space",
    "b272nk.site",
    "b29dc.site",
    "b2bx.net",
    "b2cmail.de",
    "b2csmartshop.com",
    "b2email.win",
    "b2g6anmfxkt2t.cf",
    "b2g6anmfxkt2t.ga",
    "b2g6anmfxkt2t.gq",
    "b2g6anmfxkt2t.ml",
    "b2g6anmfxkt2t.tk",
    "b2y78.us",
    "b33xs.space",
    "b3650010.com",
    "b3651111.com",
    "b3654444.com",
    "b38oa.com",
    "b3duvn.us",
    "b3ed96a.club",
    "b3nxdx6dhq.cf",
    "b3nxdx6dhq.ga",
    "b3nxdx6dhq.gq",
    "b3nxdx6dhq.ml",
    "b43gxf.online",
    "b43ll6sd.info",
    "b43qgo.best",
    "b45win.biz",
    "b45win.org",
    "b45winlaw.biz",
    "b4in.biz",
    "b4je.icu",
    "b4nv.us",
    "b4top.tk",
    "b4umxf.us",
    "b4xfzg.us",
    "b51wc.space",
    "b55b56.cf",
    "b55b56.ga",
    "b55b56.gq",
    "b55b56.ml",
    "b55b56.tk",
    "b59da.xyz",
    "b59qph.us",
    "b5gtfghtt.xyz",
    "b5hjwqda.xyz",
    "b5raj.info",
    "b5safaria.com",
    "b6o7vt32yz.cf",
    "b6o7vt32yz.ga",
    "b6o7vt32yz.gq",
    "b6o7vt32yz.ml",
    "b6o7vt32yz.tk",
    "b6vscarmen.com",
    "b6xh2n3p7ywli01.cf",
    "b6xh2n3p7ywli01.ga",
    "b6xh2n3p7ywli01.gq",
    "b6xufbtfpqco.cf",
    "b6xufbtfpqco.ga",
    "b6xufbtfpqco.gq",
    "b6xufbtfpqco.ml",
    "b6xufbtfpqco.tk",
    "b6yule.biz",
    "b7670c87.xyz",
    "b79pv.com",
    "b7ba4ef3a8f6.ga",
    "b7t98zhdrtsckm.ga",
    "b7t98zhdrtsckm.ml",
    "b7t98zhdrtsckm.tk",
    "b83gritty1eoavex.cf",
    "b83gritty1eoavex.ga",
    "b83gritty1eoavex.gq",
    "b83gritty1eoavex.ml",
    "b83gritty1eoavex.tk",
    "b88sport.info",
    "b88vc.space",
    "b8acfgimyfbkutr.xyz",
    "b8b5txpjne1uwxhnelk6136.com",
    "b8b7w9mejuzoefz.xyz",
    "b911d.xyz",
    "b95md.com",
    "b96620.xyz",
    "b97ae.site",
    "b98.live",
    "b99sj.com",
    "b9adiv5a1ecqabrpg.cf",
    "b9adiv5a1ecqabrpg.ga",
    "b9adiv5a1ecqabrpg.gq",
    "b9adiv5a1ecqabrpg.ml",
    "b9adiv5a1ecqabrpg.tk",
    "b9cash.club",
    "b9x45v1m.com",
    "b9x45v1m.com.com",
    "ba-ca.com",
    "ba572.site",
    "ba616o8hwee96yl.site",
    "ba971a8.club",
    "baacloud7.com",
    "baaio.tk",
    "baao8x.com",
    "baartaxis.info",
    "baat.site",
    "bab81.club",
    "babaaruhaz.info",
    "baban.ml",
    "babau.cf",
    "babau.flu.cc",
    "babau.ga",
    "babau.gq",
    "babau.igg.biz",
    "babau.ml",
    "babau.mywire.org",
    "babau.nut.cc",
    "babau.usa.cc",
    "babayigithukuk.xyz",
    "babe-store.com",
    "babelsrevenge.com",
    "babesstore.com",
    "babevape.xyz",
    "babezprivate.com",
    "babirousa.ml",
    "babiwatch.ru",
    "babknehtpoyas.space",
    "bablukaprimer.space",
    "babmarkapoyas.space",
    "babooncooler.com",
    "babooncoolers.com",
    "babrushnikpal.space",
    "babssaito.com",
    "babssaito.net",
    "babwert.online",
    "baby-loaf.name",
    "baby-loaf.us",
    "babybaby.info",
    "babybet16.xyz",
    "babycounter.com",
    "babyfriendly.app",
    "babygatesshop.life",
    "babygearshop.life",
    "babyiowa.com",
    "babyk.gq",
    "babykefdsdsd0-180.com",
    "babykefdsdsd84.online",
    "babyloaf.name",
    "babyloaf.us",
    "babylonish.com",
    "babylonize.com",
    "babymem.com",
    "babymongoose.info",
    "babymoose.info",
    "babyonlinedress.online",
    "babyqiang.com",
    "babyro.ru",
    "babysfavoritetoys.com",
    "babyshowerandmore.com",
    "babysmartwatchgps.ru",
    "babystaxxx.net",
    "babystuff.icu",
    "babytoysshop.life",
    "babywatches-q360.ru",
    "babyyy.live",
    "bac24.de",
    "bacahavalandirma.xyz",
    "bacapedia.web.id",
    "bacapedia.website",
    "bacarakor.com",
    "bacarakorea.com",
    "baccan.top",
    "bacchumfnr.space",
    "bacf3e20.xyz",
    "bacharg.com",
    "bachelorboy.com",
    "bachelorgal.com",
    "bacillsagc.space",
    "back-replace-happy-speech.xyz",
    "backalleybowling.info",
    "backbone.dk",
    "backbone.works",
    "backcorrector.info",
    "backdropcheck.xyz",
    "backeroo.com",
    "backfensu.cf",
    "backfensu.ga",
    "backfensu.ml",
    "backflip.cf",
    "backfliper.com",
    "backgroundcheck702.xyz",
    "backhardcomp.ml",
    "backhardcomp.tk",
    "backity.com",
    "backlinkseo.monster",
    "backmail.ml",
    "backnopsi.ga",
    "backnopsi.ml",
    "backnopsi.tk",
    "backpack-mam.ru",
    "backpackadore.site",
    "backpackcenter.site",
    "backpackers.com",
    "backpackserbia.com",
    "backpackshops.site",
    "backpacs.online",
    "backrank.com",
    "backrespsa.cf",
    "backrespsa.gq",
    "backrespsa.tk",
    "backsaveagain.com",
    "backspace.nyc",
    "backstreet-boys.com",
    "backstreetboysclub.com",
    "backtax.us",
    "backthatsiteup.com",
    "backtobasicsbluegrass.com",
    "backtoliferecovery.org",
    "backtothefuturefans.com",
    "backtownmic.ga",
    "backupbeaver.com",
    "backupblaze.com",
    "backupbuffalo.com",
    "backupcritic.com",
    "backvictimbald.website",
    "backwards.com",
    "backyard-revolution.online",
    "backyardbff.com",
    "backyardfood.com",
    "bacninhmail.us",
    "bacoem.icu",
    "bacok.org",
    "baconarro.icu",
    "baconflu.site",
    "baconporker.com",
    "baconsoi.tk",
    "baconstor.icu",
    "bacooze.space",
    "bacremedi.ga",
    "bacsinhan.com",
    "bact.site",
    "bacti.org",
    "bacu8x.com",
    "bad4wyoming.com",
    "badamm.us",
    "badatib.cf",
    "badatib.gq",
    "badatib.ml",
    "badatib.tk",
    "badboycompacttractor.com",
    "badboytractorpartsonline.com",
    "baddiefunz.com",
    "badebal.com",
    "badger.tel",
    "badgerbrushes.biz",
    "badgerbrushes.net",
    "badgerbrushes.org",
    "badgerbrushes.us",
    "badgerland.eu",
    "badgo.ru",
    "badgroomer.com",
    "badhus.org",
    "badkubeh.org",
    "badmintonshop.life",
    "badochka.ru",
    "badonz.site",
    "badoo.live",
    "badoop.com",
    "badpotato.tk",
    "badromsrenoveringsodertalje.se",
    "badrooms.online",
    "badrumsrenoveringgavle.se",
    "badtear.buzz",
    "badtzmail.com",
    "badutqiu.website",
    "badutquinza.com",
    "bae-systems.tk",
    "baebaebox.com",
    "baelas.space",
    "baer8x.com",
    "baffin.dev",
    "baffvercba.cf",
    "baffvercba.ga",
    "baffvercba.gq",
    "baffvercba.tk",
    "bafraerisun.xyz",
    "bafzci.com",
    "bag-shopper.ru",
    "bagbackca.cf",
    "bagbackca.ga",
    "bagbackca.gq",
    "bagbot.com",
    "bagcilarinsesi.com",
    "bagcilarinsesi.xyz",
    "baggerpros.com",
    "baggiesfans.co.uk",
    "bagging.site",
    "baghehonar.art",
    "bagherpour.com",
    "bagmommy.ru",
    "bagrgallery.ru",
    "bagscup.club",
    "bagshare.org",
    "bagsops.club",
    "bagsowl.club",
    "bagsray.club",
    "bagsred.club",
    "bagsshop.futbol",
    "bagssun.club",
    "bagszap.club",
    "bagto.earth",
    "baguio-cns2.com",
    "bahcespor.info",
    "bahgcondio.ml",
    "bahisbaronu.com",
    "bahiscarki.com",
    "bahiscasinoparayatirma.xyz",
    "bahisinkralicesi.com",
    "bahislion1.com",
    "bahislion14.com",
    "bahislion2.com",
    "bahislion22.com",
    "bahislion34.com",
    "bahislive.net",
    "bahisno.bet",
    "bahisno.info",
    "bahisno.mobi",
    "bahisno.site",
    "bahisno.website",
    "bahisno23.com",
    "bahisno27.com",
    "bahisnoadresi.com",
    "bahispub.info",
    "bahispub.org",
    "bahisstar208.com",
    "bahisstar209.com",
    "bahisstar211.com",
    "bahisstar213.com",
    "bahisstar221.com",
    "bahisstar226.com",
    "bahisstar228.com",
    "bahisstar229.com",
    "bahisturk14.com",
    "bahisturk23.com",
    "bahisturk44.com",
    "bahisturk6.com",
    "bahisturk61.com",
    "bahisturk65.com",
    "bahisturk67.com",
    "bahisturk72.com",
    "bahisturk78.com",
    "bahisturk79.com",
    "bahisturk85.com",
    "bahisturk91.com",
    "bahisturk95.com",
    "bahisturk98.com",
    "bahisvegas52.com",
    "bahisvegas55.com",
    "bahisvegas73.com",
    "bahiswin.net",
    "bahisyap102.com",
    "bahisyap112.com",
    "bahisyap119.com",
    "bahisyap120.com",
    "bahisyap123.com",
    "bahisyap125.com",
    "bahisyap127.com",
    "bahisyap130.com",
    "bahisyap144.com",
    "bahisyap150.com",
    "bahisyap51.com",
    "bahisyap54.com",
    "bahisyap56.com",
    "bahisyap58.com",
    "bahisyap59.com",
    "bahisyap60.com",
    "bahisyap62.com",
    "bahisyap67.com",
    "bahisyap69.com",
    "bahisyap71.com",
    "bahisyap73.com",
    "bahisyap75.com",
    "bahisyap80.com",
    "bahisyap84.com",
    "bahisyap85.com",
    "bahisyap92.com",
    "bahisyap95.com",
    "bahisyap98.com",
    "bahrainmail.com",
    "bahrithe.ga",
    "bahrithe.ml",
    "bahrithe.tk",
    "bahsinetv12.com",
    "bahsinetv13.com",
    "bahsinetv17.com",
    "bai5010.com",
    "baicaicai.com",
    "baicaill.com",
    "baichuan-yl.com",
    "baicmotormyanmar.com",
    "baiconference.com",
    "baidarank.com",
    "baidea.com",
    "baidu888com.com",
    "baiducloudfile.com",
    "baidulink.xyz",
    "baidulove88.com",
    "baih14.us",
    "baikal-21.ru",
    "baikal-autotravel.ru",
    "baikalconsult.ru",
    "baileyb.best",
    "baileyfamilydental.us",
    "bailingwiredirect.com",
    "baimena.ga",
    "baimena.gq",
    "baimena.ml",
    "baimoe.com",
    "baing123.club",
    "bainspuzzle.com",
    "baireselfie.net",
    "baitify.com",
    "baixarlegenda.com",
    "bajabrewingcompany.org",
    "bajathough.cf",
    "bajathough.ga",
    "bajathough.gq",
    "bajatyoutube.com",
    "baka123.com",
    "bakacloud.com",
    "bakagame.com",
    "bakar.bid",
    "bakaratkeliling.org",
    "bakarina.aa.am",
    "bakatool.com",
    "bakawiki.com",
    "bakerai.space",
    "bakersfield.florist",
    "bakhaus.ru",
    "bakingandfoodconnections.net",
    "bakingonstone.com",
    "baklsera.site",
    "bakpaka.com",
    "bakpaka.net",
    "bala-safa.xyz",
    "balacar.club",
    "balagolfutbal.com",
    "balanc3r.com",
    "balanced.press",
    "balancedbodypractice.org",
    "balancedcannabis.com",
    "balancehomespot.club",
    "balancer.capital",
    "balanest.com",
    "balansfx.info",
    "balanz.asia",
    "balanz.chat",
    "balanz.earth",
    "balanz.farm",
    "balanz.fund",
    "balanz.health",
    "balanz.llc",
    "balanz.marketing",
    "balanz.pet",
    "balanz.plus",
    "balanz.properties",
    "balanz.rentals",
    "balanz.social",
    "balanz.support",
    "balanz.team",
    "balatmakine.xyz",
    "balconat.com",
    "balcovalisesi.xyz",
    "balderdash.org",
    "baldmama.de",
    "baldpapa.de",
    "baldpuppy.info",
    "baldwinparkapartments.com",
    "baldyahea.cf",
    "balenko.site",
    "balibrewcoffee.com",
    "balikesirevdenevenakliyatci.xyz",
    "balikesirgunesplastik.xyz",
    "balikesirotel.xyz",
    "balipropertybuilder.com",
    "balk783ke.online",
    "balkanrrjj.space",
    "ball-religion.xyz",
    "ballardplumbingfox.com",
    "ballavenue.xyz",
    "ballballsoft.com",
    "ballerstatus.net",
    "ballman03.ml",
    "ballman05.ml",
    "ballrosti.cf",
    "ballrosti.ga",
    "ballsod4u.com",
    "ballsofsteel.net",
    "ballstab.us",
    "ballyfinance.com",
    "balochistan.org",
    "balon.dev",
    "baloondf.ga",
    "baloqe.xyz",
    "balparmakaricilikakademisi.com",
    "balpha90.xyz",
    "balsameoiw.ru",
    "baltecosalon.ru",
    "baltimorechildrensbusinessfair.com",
    "baltimoreheroinrehab.com",
    "baltimoreshowerglass.com",
    "baltmetcom.ru",
    "baltvegas.mobi",
    "baluch.com",
    "balujo.info",
    "bam4x5.host",
    "bambee.tk",
    "bambis.cat",
    "bambkroped.cf",
    "bambkroped.gq",
    "bamcall3.com",
    "bamcs2.com",
    "bamcs3.com",
    "bamdal10.com",
    "bamhub02.net",
    "bamhunter.shop",
    "bamsin119.net",
    "bamulatos.net",
    "bamz02.com",
    "bamz03.com",
    "banana18.com",
    "bananabreadrecipes.xyz",
    "bananafarming.net",
    "bananatv.xyz",
    "banatbatouta.com",
    "bancatran.net",
    "banciaoqq59.xyz",
    "bancobit.com",
    "bancoopen.com",
    "band-freier.de",
    "bandafgr.tk",
    "bandai.nom.co",
    "bandamn.ru",
    "bandar6.org",
    "bandar66.website",
    "bandarbolapialadunia.xyz",
    "bandarcolok.info",
    "bandarduniasbobet.com",
    "bandarhk.site",
    "bandarhk.website",
    "bandarindo.casino",
    "bandarisin4d.com",
    "bandarjudiqq.rocks",
    "bandarq.life",
    "bandband1.com",
    "bandeausyi.ru",
    "bandirmagezgini.com",
    "bandobast.xyz",
    "bandon-cheese.us",
    "bandon.name",
    "bandoncheese.biz",
    "bandoncheese.name",
    "bandoncheese.us",
    "bandoncoastfoods.name",
    "bandoneons.info",
    "bandons-cheese.biz",
    "bandons-cheese.us",
    "bandons.name",
    "bandons.us",
    "bandonscheese.name",
    "bandonscheese.us",
    "bandraqq365.life",
    "bandung4d.info",
    "bandung4d.org",
    "bandvegasy.info",
    "bandwidthalliance.com",
    "bandwidthalliance.net",
    "bangaloreinvestments.com",
    "bangers.app",
    "bangilan.ga",
    "bangilan.ml",
    "bangkok.com",
    "bangkok2000.com",
    "bangkok9sonoma.com",
    "bangkokls.com",
    "bangsa365.xyz",
    "bangsat.in",
    "bangsforbuck.com",
    "bangthagrely.xyz",
    "bangumi.party",
    "bangweuluwetlands.com",
    "bangxxx.site",
    "banhammer.network",
    "banhbeovodich.vn",
    "banhga.cf",
    "banhga.ga",
    "banhga.ml",
    "banikata.ru",
    "banistersdirect.com",
    "banit.club",
    "banit.me",
    "banjarworo.ga",
    "banjarworo.ml",
    "banjarworocity.cf",
    "bank-opros1.ru",
    "bank-tinkoff-cabinet.ru",
    "bankcoinreserve.gives",
    "bankcommon.com",
    "bankcreditcardforcredit.xyz",
    "bankermathews.com",
    "bankinginasnap.com",
    "bankingpartneronline.com",
    "bankingresources.xyz",
    "bankings.top",
    "bankloan-offer.xyz",
    "bankofearth.earth",
    "bankomatt.ru",
    "bankonur.com",
    "bankoutsider.com",
    "bankovskaya-karta-tele2.ru",
    "bankownedfairfieldcountyhomes.com",
    "banks-review.ru",
    "banks.africa",
    "banksnearme.net",
    "banktex.ml",
    "banletructuyen.website",
    "bannedpls.online",
    "banner-31.com",
    "banner-41.com",
    "banner-rehabhospitals.org",
    "bannerko.ru",
    "bannertown.net",
    "banofamerican.best",
    "banskocoliving.com",
    "bantenpoker.website",
    "bantin30s.online",
    "bantisik.com",
    "banyakhadiah.xyz",
    "banz.site",
    "baodaoxp.com",
    "baodoisongphunu.com",
    "baojianxue.com",
    "baokecacchaulamviec.tk",
    "baoloc.city",
    "baomoi.site",
    "baordroommedia.com",
    "baos.site",
    "baoslots.info",
    "baovephunu.site",
    "baowengou.com",
    "baoye365.com",
    "baphled.com",
    "bapter.design",
    "baptistcreationcare.org",
    "baptistmail.com",
    "baptized.com",
    "baptizes78lc.online",
    "bapu.gq",
    "bapu.ml",
    "bapumoj.cf",
    "bapumoj.ga",
    "bapumoj.gq",
    "bapumoj.ml",
    "bapumoj.tk",
    "bapumojo.ga",
    "bapumojo.tk",
    "bar24.top",
    "baraccudacoach.ru",
    "barafa.gs",
    "barakademin.se",
    "baramoda.com",
    "barandesho.biz",
    "barandesho.club",
    "barangbekas.market",
    "barangsuntuk221.com",
    "barannoor.com",
    "barasiakoa.mobi",
    "barbabas.space",
    "barbarianfestival.com",
    "barbarianfestival.org",
    "barbarious.best",
    "barbarizes454th.online",
    "barbarrianking.com",
    "barbeariapaulista.com",
    "barbecueliquidators.com",
    "barberinhills.info",
    "barbodae.com",
    "barcakana.tk",
    "barcalovers.club",
    "barcelona.com",
    "barcinohomes.ru",
    "barciq.com",
    "barclays-plc.cf",
    "barclays-plc.ga",
    "barclays-plc.gq",
    "barclays-plc.ml",
    "barclays-plc.tk",
    "barcntenef.cf",
    "barcntenef.tk",
    "bardecor.ru",
    "bardharti.cf",
    "bardharti.ga",
    "bardharti.ml",
    "bards.net",
    "bardsdadgas.space",
    "barebackedtsc.website",
    "bareburgers.com",
    "bareck.net",
    "bareed.ws",
    "bareface.social",
    "barefootcook.com",
    "barefoottheory.com",
    "baregyal.com",
    "baren.org",
    "barenshop.ru",
    "barfanidada.com",
    "barfdastbloc.cf",
    "barfdastbloc.ga",
    "barfdastbloc.tk",
    "bargainthc.com",
    "bargesa.cf",
    "bargesa.gq",
    "bargesa.ml",
    "bargesa.tk",
    "barid.com",
    "baris.shop",
    "barking.design",
    "barlas1.site",
    "barlick.net",
    "barmyarmy.net",
    "barna.bike",
    "barna.futbol",
    "barnebas.space",
    "barny.space",
    "barnyarthartakar.com",
    "barotir.xyz",
    "barping.asia",
    "barrabravaz.com",
    "barrel-of-knowledge.info",
    "barrell-of-knowledge.info",
    "barretodrums.com",
    "barrill.org",
    "barryogorman.com",
    "barrypov.com",
    "barrysbagel.com",
    "barryspov.com",
    "barsan4818.com",
    "barseeker.com",
    "barsikvtumane.cf",
    "barsikvtumane.ga",
    "barsikvtumane.gq",
    "barsikvtumane.ml",
    "barsikvtumane.tk",
    "barsmerco.cf",
    "barsmerco.ga",
    "barsmerco.gq",
    "barsmerco.tk",
    "bart-net.com",
    "bartdevos.be",
    "bartender.net",
    "barterboards.com",
    "barterboards.net",
    "bartholemy.space",
    "bartholomeo.space",
    "bartholomeus.space",
    "bartizan819ch.online",
    "bartolemo.space",
    "bartoparcadecabinet.com",
    "bas0scg0.xyz",
    "basakgidapetrol.com",
    "basakhaber.org",
    "basalts.best",
    "basarhamdionat.com",
    "basbackso.cf",
    "basbackso.ga",
    "basbackso.tk",
    "bascope.icu",
    "basculas.online",
    "base-weight.com",
    "baseball-email.com",
    "baseballmail.com",
    "basedafg.ml",
    "baseddopl.tk",
    "basehipovk.space",
    "baserelief.ru",
    "basetime.us",
    "basharg.com",
    "basharj.com",
    "basharje.com",
    "bashke.info",
    "bashke.org",
    "basic-colo.com",
    "basicgla.buzz",
    "basiclaw.ru",
    "basicmov.xyz",
    "basicseo.top",
    "basicsofinternetmarketing.com",
    "basitcappuccino.com",
    "basjoker.ga",
    "basjoreb.site",
    "basketandbath.com",
    "basketball2in.com",
    "basketballmail.com",
    "basketballontv.com",
    "basogi.xyz",
    "basogu.xyz",
    "basresscam.cf",
    "basresscam.ga",
    "basscisla.ga",
    "basscisla.tk",
    "basscode.org",
    "bassot-genevieve.com",
    "bassottipalermo.info",
    "basssi.today",
    "bastiananke.xyz",
    "bastnone.site",
    "bastore.co",
    "bastsellstripe.com",
    "basurtest55ckr.tk",
    "basvur.xyz",
    "basy.cf",
    "bat-990.com",
    "bat-999.com",
    "batdongsanmiennam.xyz",
    "batefy.info",
    "baterias.xyz",
    "batherforearm.top",
    "bathroomaustralia.xyz",
    "bathrooms1.com",
    "bathshop.live",
    "batiktirnaktedavi.com",
    "batiro.ga",
    "batiro.gq",
    "batiro.ml",
    "batiro.tk",
    "batkyai.com",
    "batlmamad.gq",
    "batman303.biz",
    "batmancocukterapisi.com",
    "batmitzvahmagazine.com",
    "batnacapitaledesaures.com",
    "batonrougealcoholrehab.com",
    "batonrougecocainerehab.com",
    "batonrougeheroinrehab.com",
    "batpeer.site",
    "batstorebuyshop.online",
    "batteri.app",
    "battey.me",
    "battle-royale-games.ru",
    "battledirector.com",
    "battlefield1beta.com",
    "battlegroundnc.org",
    "battleinbmore.com",
    "battlejuicedrink.com",
    "battlengur.space",
    "battlepong.info",
    "battpackblac.cf",
    "battpackblac.ga",
    "battpackblac.gq",
    "battpackblac.ml",
    "battpackblac.tk",
    "battricks.com",
    "batudeco.com",
    "batugoncang.org",
    "batumeskort.com",
    "batuta.net",
    "bau-peler.business",
    "bau-peler.com",
    "baubosgarden.com",
    "bauchtanzkunst.info",
    "baudoinconsulting.com",
    "bauimail.ga",
    "baumhotels.de",
    "bautista.club",
    "bauwerke-online.com",
    "bax0599.com",
    "baxomale.ht.cx",
    "bayani.ru",
    "bayareamobileeventservices.com",
    "bayareavegfest.org",
    "bayburtbal.com",
    "bayburtbal.xyz",
    "bayburtkoyu.xyz",
    "bayelsastatemot.icu",
    "bayendurebeg.website",
    "bayfibmo.cf",
    "bayfibmo.ga",
    "baykers.space",
    "baykuskitabevi.xyz",
    "baykuskitap.xyz",
    "baylor.edu",
    "bayrakligazetesi.xyz",
    "bayriatrap.cf",
    "bayriatrap.ga",
    "bayriatrap.tk",
    "baysidepublishing.org",
    "bazaaboom.com",
    "bazaarcovers.com",
    "bazaarfashionmagazines.com",
    "bazakts.ru",
    "bazaorg.ru",
    "bazarop.com",
    "bazerulodge.com",
    "bazhen.ru",
    "bazi1399.site",
    "bazreno.com",
    "bb1197.com",
    "bb24hr.com",
    "bb24hr.net",
    "bb265.com",
    "bb42d8b5.xyz",
    "bb4f0c2.club",
    "bb57822.com",
    "bb888.tk",
    "bb9827.com",
    "bba24.de",
    "bba42t.us",
    "bbabblebeanh.site",
    "bbabblespherem.site",
    "bbb991.com",
    "bbbb00000.info",
    "bbbb22222.info",
    "bbbb44444.info",
    "bbbbyyzz.info",
    "bbbonus.net",
    "bbc-dz.com",
    "bbc-news-today.host",
    "bbc-news-today.space",
    "bbc-news24.site",
    "bbcaijing.pro",
    "bbcs.me",
    "bbdd.info",
    "bbetweenj.com",
    "bbfishing.ru",
    "bbg123.com",
    "bbhost.us",
    "bbibbaibbobbatyt.cf",
    "bbibbaibbobbatyt.ga",
    "bbibbaibbobbatyt.gq",
    "bbibbaibbobbatyt.ml",
    "bbibbaibbobbatyt.tk",
    "bbintd.com",
    "bbl4.net",
    "bblogstormn.site",
    "bblounge.co.za",
    "bbmail.win",
    "bbn.cloud",
    "bborddd.live",
    "bbov9y.us",
    "bboy.com",
    "bboy.zzn.com",
    "bbq-nation.net",
    "bbq.monster",
    "bbq59.xyz",
    "bbqstore.org",
    "bbreghodogx83cuh.ml",
    "bbrightclubd.site",
    "bbrightflowe.site",
    "bbrowsechato.site",
    "bbruastripe.com",
    "bbryk.live",
    "bbs8den8teudng.xyz",
    "bbs96.us",
    "bbsat.tk",
    "bbse185.com",
    "bbse191.com",
    "bbse193.com",
    "bbse195.com",
    "bbse199.com",
    "bbser.org",
    "bbswordiwc.com",
    "bbtotobet.online",
    "bbubblecubed.site",
    "bbuzzwares.site",
    "bbw.monster",
    "bbwin188.com",
    "bbwin188.net",
    "bbwin99.com",
    "bbyth.com",
    "bc5569.com",
    "bc590d0b.xyz",
    "bc8037.com",
    "bc9827.com",
    "bc9c.com",
    "bcamerapeak.info",
    "bcaoo.com",
    "bcast.store",
    "bcast.vote",
    "bcast.ws",
    "bcb.ro",
    "bcbet8989.com",
    "bcbsla.com",
    "bccecac.club",
    "bccplease.com",
    "bccto.me",
    "bcdick.best",
    "bcdmail.date",
    "bcedetyam.ru",
    "bcedetyam1.ru",
    "bcedetyam2.ru",
    "bcedetyam3.ru",
    "bcfcfans.space",
    "bcflinnovators.com",
    "bcflplanners.com",
    "bchatz.ga",
    "bcjm4.icu",
    "bcle.de",
    "bcnsc.online",
    "bcodes.site",
    "bcompiled3.com",
    "bcoreap.com",
    "bcpl.net",
    "bcqjwz.online",
    "bcs-d.com",
    "bcssupplies.info",
    "bcst8.com",
    "bctqa.host",
    "bcvibes.com",
    "bcvm.de",
    "bcxaiws58b1sa03dz.cf",
    "bcxaiws58b1sa03dz.ga",
    "bcxaiws58b1sa03dz.gq",
    "bcxaiws58b1sa03dz.ml",
    "bcxaiws58b1sa03dz.tk",
    "bcxpartners.com",
    "bd.dns-cloud.net",
    "bd51tf.com",
    "bd9b6555.club",
    "bdbcba.com",
    "bdbdqbdkdx.xyz",
    "bdbdqbdkfb.xyz",
    "bdbdqbdkxx.xyz",
    "bdbdqbikbx.xyz",
    "bdbdqbikfb.xyz",
    "bdbdqbikqb.xyz",
    "bdbdqbxkbx.xyz",
    "bdbdqbxkdx.xyz",
    "bdbdqbxkfb.xyz",
    "bdbdqbxkqb.xyz",
    "bdbdqbxkxx.xyz",
    "bdbdqddkeb.xyz",
    "bdbdqddkib.xyz",
    "bdbdqddkxx.xyz",
    "bdbdqdkbxb.xyz",
    "bdbdqdkibb.xyz",
    "bdbdqdksbb.xyz",
    "bdbdqdxkdx.xyz",
    "bdbdqdxknb.xyz",
    "bdbdqdxkqb.xyz",
    "bdbdqdxkxx.xyz",
    "bdbdqedkbx.xyz",
    "bdbdqedkfb.xyz",
    "bdbdqedknb.xyz",
    "bdbdqedksb.xyz",
    "bdbdqekbxb.xyz",
    "bdbdqekebb.xyz",
    "bdbdqeknbb.xyz",
    "bdbdqekxxb.xyz",
    "bdbdqexkbx.xyz",
    "bdbdqexkeb.xyz",
    "bdbdqexkib.xyz",
    "bdbdqexksb.xyz",
    "bdbdqfdkdx.xyz",
    "bdbdqfdkib.xyz",
    "bdbdqfdknb.xyz",
    "bdbdqfdkqb.xyz",
    "bdbdqfkebb.xyz",
    "bdbdqfkkbb.xyz",
    "bdbdqfknbb.xyz",
    "bdbdqfxkbx.xyz",
    "bdbdqfxkdx.xyz",
    "bdbdqfxkfb.xyz",
    "bdbdqfxkib.xyz",
    "bdbdqfxkkb.xyz",
    "bdbdqfxkqb.xyz",
    "bdbdqfxksb.xyz",
    "bdbdqidkdx.xyz",
    "bdbdqidkeb.xyz",
    "bdbdqidkib.xyz",
    "bdbdqidkkb.xyz",
    "bdbdqidknb.xyz",
    "bdbdqikebb.xyz",
    "bdbdqikfbb.xyz",
    "bdbdqikibb.xyz",
    "bdbdqikxxb.xyz",
    "bdbdqixkeb.xyz",
    "bdbdqixknb.xyz",
    "bdbdqixkqb.xyz",
    "bdbdqixksb.xyz",
    "bdbdqkdkeb.xyz",
    "bdbdqkdkfb.xyz",
    "bdbdqkdknb.xyz",
    "bdbdqkkbxb.xyz",
    "bdbdqkkdxb.xyz",
    "bdbdqkknbb.xyz",
    "bdbdqkkqbb.xyz",
    "bdbdqkxkbx.xyz",
    "bdbdqkxkib.xyz",
    "bdbdqkxkkb.xyz",
    "bdbdqkxknb.xyz",
    "bdbdqndkeb.xyz",
    "bdbdqndkfb.xyz",
    "bdbdqnkebb.xyz",
    "bdbdqnkqbb.xyz",
    "bdbdqnksbb.xyz",
    "bdbdqnxkeb.xyz",
    "bdbdqnxkqb.xyz",
    "bdbdqnxksb.xyz",
    "bdbdqnxkxx.xyz",
    "bdbdqqdkbx.xyz",
    "bdbdqqdkkb.xyz",
    "bdbdqqdknb.xyz",
    "bdbdqqdksb.xyz",
    "bdbdqqkfbb.xyz",
    "bdbdqqknbb.xyz",
    "bdbdqqkqbb.xyz",
    "bdbdqqksbb.xyz",
    "bdbdqqxkbx.xyz",
    "bdbdqqxkdx.xyz",
    "bdbdqqxkeb.xyz",
    "bdbdqqxkfb.xyz",
    "bdbdqqxkkb.xyz",
    "bdbdqqxknb.xyz",
    "bdbdqqxkqb.xyz",
    "bdbdqqxksb.xyz",
    "bdbdqsdkeb.xyz",
    "bdbdqsdkfb.xyz",
    "bdbdqsdkxx.xyz",
    "bdbdqskdxb.xyz",
    "bdbdqskebb.xyz",
    "bdbdqskfbb.xyz",
    "bdbdqskkbb.xyz",
    "bdbdqskqbb.xyz",
    "bdbdqsxksb.xyz",
    "bdbdqxdkfb.xyz",
    "bdbdqxdkxx.xyz",
    "bdbdqxikkb.xyz",
    "bdbdqxkbxb.xyz",
    "bdbdqxkqbb.xyz",
    "bdbdqxksbb.xyz",
    "bdbdqxxkib.xyz",
    "bdbdqxxkkb.xyz",
    "bdbdqxxknb.xyz",
    "bdbdqxxksb.xyz",
    "bdcl73.us",
    "bde.me",
    "bdf118.com",
    "bdigitalsignage.com",
    "bdjb.xyz",
    "bdmobiles.com",
    "bdmuzic.pw",
    "bdv3.icu",
    "be-a-dentalimplants-inone.live",
    "be-a-savingsaccountwow.live",
    "be-a-suvhub.live",
    "be-a-trucksfab.live",
    "be-a-trucksget.live",
    "be-an-intl-new-york-hotelsnow.live",
    "be-breathtaking.net",
    "be-care-giver-medicaids-ok.live",
    "be-creditcardnofeeca-ok.live",
    "be-greatreverse-ok.mortgage",
    "be-intl-new-york-hotels-one.live",
    "be-intravelinsurances-ok.live",
    "be-line.me",
    "be-tax-prep-ok.live",
    "be-trucks-hub.live",
    "be0vsn.com",
    "be321app.xyz",
    "be401kinquiryok.com",
    "bea32.ru",
    "beabedbugremovalok.live",
    "beacepu.cf",
    "beacepu.gq",
    "beacepu.tk",
    "beach-homes.com",
    "beachdormsy.info",
    "beachfront-llc.us",
    "beachhaven.company",
    "beachhaven.fun",
    "beachhouse.online",
    "beachpeopleco.com",
    "beacon-opt.com",
    "beaconhillluxurylisting.com",
    "beaconnewspaper.com",
    "beacordbloodbankhelpok.live",
    "beadgolfper.cf",
    "beadgolfper.ga",
    "beadgolfper.gq",
    "beadgolfper.ml",
    "beadscarbons.top",
    "beaivi.institute",
    "bealector.com",
    "beamcharger.com",
    "bean.farm",
    "beancooker.com",
    "beand.org",
    "beanimplantsjet.live",
    "beanteamstaffing.com",
    "beantein.com",
    "beaplumbereducationok.rocks",
    "beaplumbereducationok.sale",
    "bear.supappl.me",
    "bearcreekauto.com",
    "beardfirst.com",
    "bearegone.pro",
    "bearer.net",
    "bearer.org",
    "bearingman.net",
    "bears-rosessale.ru",
    "bearsarefuzzy.com",
    "bearwork.us",
    "beastagram.com",
    "beastmagic.com",
    "beatboxyedonebashe.xyz",
    "beatcruisesok.live",
    "beatrizppe2enburg.xyz",
    "beatrose.com",
    "beats-discount.ru",
    "beatz-shop.ru",
    "beatztr.com",
    "beaucomte.com",
    "beautifulhomes.us",
    "beautifulifeurns.com",
    "beautifulinhouses.com",
    "beautifullifestyleblog.com",
    "beautifulmassage.ru",
    "beautifulsa.space",
    "beautifulvideo.ru",
    "beautifybrides.com",
    "beauty-gids.shop",
    "beauty-israel.com",
    "beauty-lamp.ru",
    "beauty-mania.monster",
    "beauty-secret.info",
    "beauty.kaufen",
    "beauty1.website",
    "beautybabby.xyz",
    "beautyboo.ru",
    "beautyboost.ru",
    "beautycareklin.xyz",
    "beautycentry.xyz",
    "beautyincbd.com",
    "beautyinthestreet.com",
    "beautykz.store",
    "beautylinks.info",
    "beautysecrets.space",
    "beautyvibesmag.com",
    "beauxgadgets.com",
    "beaverkit.com",
    "beavoipphonerun.com",
    "bebarefoot.com",
    "bebasmovie.com",
    "bebeautyco.com",
    "bebedbugremovalsok.live",
    "bebekbattaniyesi.xyz",
    "bebekliyor.xyz",
    "beben.xyz",
    "bebet322.xyz",
    "bebet327.xyz",
    "beboldbebald.com",
    "bebotoxok.live",
    "bebulen.site",
    "bebwe.com",
    "bec-ing.com",
    "becanada-mail.com",
    "becas.digital",
    "becausethenight.cf",
    "becausethenight.ml",
    "becausethenight.tk",
    "becerromail.club",
    "beck-it.net",
    "becksurbancanvas.com",
    "becky.fitness",
    "beckyandtets.com",
    "becomestions.com",
    "becometime.xyz",
    "becongchongsok.live",
    "becordbloodbankhelpok.live",
    "becordbloodbankhelpsok.live",
    "bedbooms.info",
    "bedbugsize.club",
    "beddingsshop.live",
    "beddly.com",
    "bedebertozino.xyz",
    "bedfadsfaidsok.live",
    "bedore.com",
    "bedpay.net",
    "bedrokcommunity.org",
    "bedroombugs.com",
    "bedstemail.dk",
    "bee-wi.ru",
    "bee.pl",
    "beechatz.ga",
    "beechatzz.ga",
    "beechworthchildcare.com",
    "beed.ml",
    "beeebank.com",
    "beefback.com",
    "beefmilk.com",
    "beefnomination.info",
    "beefstock.buzz",
    "beeg69.site",
    "beejjewels.net",
    "beemabazar.com",
    "beemanagementinc.org",
    "beenhad.com",
    "beep.ru",
    "beer.com",
    "beer911.app",
    "beerandremotes.com",
    "beerchamberbeep.website",
    "beerm.icu",
    "beermash.com",
    "beermonkey.org",
    "beerolympics.se",
    "beethoven.com",
    "beetlecan.com",
    "beeveedigital.com",
    "beeviee.cf",
    "beeviee.ga",
    "beeviee.gq",
    "beeviee1.cf",
    "beeviee1.ga",
    "beeviee1.gq",
    "beeviee1.ml",
    "beeviee1.tk",
    "beewooden.com",
    "beforeveal.icu",
    "begavet.dk",
    "beginagon.icu",
    "beginchart.email",
    "beginmeri.icu",
    "beginnergeek.net",
    "beginsma.xyz",
    "beginsw.xyz",
    "beginswi.xyz",
    "beginswin.xyz",
    "beginwro.recipes",
    "beginwron.recipes",
    "begisobaka.cf",
    "begisobaka.ga",
    "begisobaka.gq",
    "begisobaka.ml",
    "begisobaka.tk",
    "begivverh.xyz",
    "begoz.com",
    "beguh.com",
    "behandlingmarke.website",
    "behavioralhealthdata.info",
    "behavioralhealthdata.org",
    "behavioralhealthoutcomedata.info",
    "behavioraloutcomesdata.info",
    "behindthebubbles.com",
    "behsanacademy.com",
    "bei.kr",
    "beibilga.ga",
    "beibilga.ml",
    "beibilga.tk",
    "beibleid.ru",
    "beijing-devops.com",
    "beijinhuixin.com",
    "beimplantsray.live",
    "beincash.xyz",
    "beiop.com",
    "beirut.com",
    "beitmak.ru",
    "beiwody.info",
    "bekadsjr.host",
    "bekaselektrik.com",
    "bekasiindihome.com",
    "beke.site",
    "bel-airevisual.com",
    "bel-seo.ru",
    "bel.kr",
    "belairdentistry.com",
    "belairshowerglass.com",
    "belamail.org",
    "belanjaonlineku.web.id",
    "belanjaterus.shop",
    "belapoker.biz",
    "belastingdienst-fod.email",
    "belastingdienst.pw",
    "belchertownfuneralhome.com",
    "belediyeevleri2noluasm.com",
    "belekbelediyesi.xyz",
    "belence.cf",
    "belence.ga",
    "belence.gq",
    "belence.ml",
    "belence.tk",
    "belengendwin.com",
    "belfastdistilleryco.com",
    "beli4d.com",
    "belibeli.shop",
    "belice.com",
    "believeintn.org",
    "belisatu.net",
    "belisor.info",
    "belizehome.com",
    "belizemail.net",
    "belizeoasisalabang.com",
    "belizeweb.com",
    "belkacar.online",
    "belkastconsulting.com",
    "bell-bar.com",
    "bell.net",
    "bellacheveuxhairstudio.com",
    "bellair.com",
    "bellair.net",
    "bellaitaliavalencia.com",
    "bellaliant.net",
    "bellanotte.cf",
    "bellasio.net",
    "bellatlantic.net",
    "bellavistacosmetics.shop",
    "bellbet24.org",
    "bellefroghuis.com",
    "bellenuits.com",
    "bellevueboychoir.com",
    "bellezaahora.xyz",
    "belljonestax.com",
    "bellnet.ca",
    "bellshoalsanimalhospitalofbrandon.com",
    "bellshoalsvet.com",
    "bellsouth.net",
    "bellster.biz",
    "bellster.name",
    "bellwellcharters.com",
    "bellyblasterkit.com",
    "belnasil.digital",
    "belorus-kosmetix.ru",
    "belovedhavanese.com",
    "belqa.com",
    "belrochesdistribution.com",
    "belspb.ru",
    "belstilo.com",
    "beltlannio.ga",
    "beltlannio.ml",
    "beltlannio.tk",
    "beltpin.com",
    "beltrik.ru",
    "beluckygame.com",
    "beluowu.xyz",
    "bemacares.info",
    "bembonitastudio.com",
    "bemestarfit.host",
    "bemestarfit.space",
    "bemony.com",
    "bemvip.online",
    "bemvip.xyz",
    "bemybaby.dk",
    "bemynode.com",
    "benashley.net",
    "benchmarkmineralintelligence.com",
    "bendingmc.online",
    "bendini.ga",
    "bendini.gq",
    "bendini.tk",
    "bendlinux.net",
    "bendmerch.com",
    "bendstays.com",
    "benefit-badgal.ru",
    "benefitsofchamomiletea.com",
    "benefitsofflaxseeds.com",
    "benefitsofglutenfree.com",
    "benefitsofkombucha.com",
    "benevolo.us",
    "benforhilldale.com",
    "benfragladb.cf",
    "benfragladb.ga",
    "benfragladb.tk",
    "bengbeng.me",
    "benh34vcb.buzz",
    "benhgaicotsong.info",
    "benhoxie.com",
    "benhvienmatsaigon.com",
    "beni36kjh.buzz",
    "beni37ggb.buzz",
    "beni39ijh.buzz",
    "benimatran.com",
    "benipaula.org",
    "benitomendezsanchez.com",
    "benj40eii.buzz",
    "benjamin-roesch.com",
    "benjaminpflasterer.com",
    "benjaminquinn.com",
    "benjaminquinn.net",
    "benjaminquinn.org",
    "benjis.life",
    "benlotusmail.com",
    "bennistdod.cf",
    "bennistdod.gq",
    "bennistdod.tk",
    "bennyrosen.com",
    "benpict.xyz",
    "bensebbs.org",
    "bental.xyz",
    "bentblogging.com",
    "bentleypaving.com",
    "bentolabs.com",
    "bentonshome.cf",
    "bentonshome.tk",
    "bentonstesting.cf",
    "bentonstesting.tk",
    "bentonvillepropertylistings.com",
    "bentwillys.info",
    "benwoodburn.news",
    "benzi.app",
    "beo.kr",
    "beoemyxa.shop",
    "beoff.me",
    "beoilchangesbuy.live",
    "beoilchangewow.live",
    "beonweb.ru",
    "beoutq.stream",
    "bepackaging.com",
    "bepc417.xyz",
    "bepdfmanuales.xyz",
    "beplumbereducationok.sale",
    "beplumbereducationok.video",
    "bepoibepa.com",
    "beporitukl.ml",
    "beqonay.site",
    "beranabooks.info",
    "beratokus.tk",
    "berawa-beach.com",
    "berbaban.gq",
    "berbowsra.cf",
    "berbowsra.ml",
    "bercstuferca.tk",
    "berdeen.com",
    "bereniki.com",
    "bererece.com",
    "beresleting.cf",
    "beresleting.ga",
    "beresleting.gq",
    "beresleting.ml",
    "beresleting.tk",
    "beret-prolithium.online",
    "berettachiro.net",
    "berettachiropractic.net",
    "bergandridge.shop",
    "bergandridge.store",
    "bergandridge.us",
    "bergmoneyclub.ru",
    "bergpegkupt.gq",
    "bergpegkupt.ml",
    "bergpegkupt.tk",
    "beri-delay.ru",
    "beriarenda.ru",
    "beriastuias.club",
    "beriazadda.club",
    "beribase.ru",
    "beribaza.ru",
    "beridelo.ru",
    "beriglobal.ru",
    "berigroup.ru",
    "beriinfo.ru",
    "berirabotay.ru",
    "berischool.ru",
    "beriseikeb.live",
    "berishkola.ru",
    "beristeam.ru",
    "beritaproperti.com",
    "beritvorit.ru",
    "beriudlugi.ru",
    "beriuslugi.ru",
    "berizals.world",
    "berizter.club",
    "berjaya777.live",
    "berkah-herbal.com",
    "berkahwkr.com",
    "berkatrb.com",
    "berkeleytree.com",
    "berkmj.info",
    "berkscounty.com",
    "berkshireheatingandac.com",
    "berlin.com",
    "berlin.de",
    "berlinexpo.de",
    "berlios.online",
    "berlusconi.cf",
    "berlusconi.ga",
    "berlusconi.gq",
    "berlusconi.ml",
    "bermang.com",
    "bern4love.com",
    "berna.kim",
    "bernieruess.com",
    "bernsja.com",
    "bernsndrs4.us",
    "beroazsd.xyz",
    "beroigased.gq",
    "beroinavik.tk",
    "beroitum.gq",
    "berouzresaan.com",
    "berouzresan.com",
    "berozresaan.com",
    "berquist.org",
    "berry-race.com",
    "berryang.icu",
    "berryclo.xyz",
    "berrycloc.xyz",
    "berrypi.xyz",
    "berrypian.xyz",
    "berrypl.xyz",
    "berryswipe.buzz",
    "berrywh.xyz",
    "bersama365.club",
    "bershka-terim.space",
    "bertackbi.ga",
    "bertackbi.gq",
    "bertarikkofish.xyz",
    "bertiaxza.site",
    "bertisa-store.club",
    "besasang.com",
    "beshc.us",
    "beshox.fun",
    "besltd.net",
    "besome401kinquiriesok.com",
    "besomedfadsfaidok.live",
    "besometopcrossoversonthemarketsok.live",
    "besplatnoigraj.com",
    "besplodie.info",
    "besseller.com",
    "best-2222.com",
    "best-asianbrides.org",
    "best-bet999.com",
    "best-bonus-zone2.life",
    "best-casino.online",
    "best-day.pw",
    "best-deal.host",
    "best-info-greate.ru",
    "best-mail.net",
    "best-news.website",
    "best-nj.com",
    "best-of-british.net",
    "best-personal-loan-in-town.info",
    "best-pneumatics.ru",
    "best-pnevmatic.ru",
    "best-promo-codes.us",
    "best-scifi.com",
    "best-seller.icu",
    "best-tanning-lotions.com",
    "best-womennow2.com",
    "best121adultdates.com",
    "best1x.site",
    "best46.xyz",
    "best8520rv.com",
    "bestad2020.host",
    "bestantiwrinklesolutions.com",
    "bestats.top",
    "bestbagaffordable.online",
    "bestbaltimoreattorney.com",
    "bestbaltimorelawyer.com",
    "bestbanyabochka.ru",
    "bestbargaindealz.org",
    "bestbestbest.club",
    "bestbets123.net",
    "bestbrush.org",
    "bestbrushcompany.net",
    "bestbrushcompany.org",
    "bestbrushcompany.us",
    "bestbrushes.us",
    "bestbuyssites.com",
    "bestbuysswebbs.com",
    "bestbuysswebs.com",
    "bestbuysswebss.com",
    "bestbuyswebs.com",
    "bestbyuaty.ru",
    "bestcanadagoosejacketsoutlet.com",
    "bestcarshost.com",
    "bestchannelstv.info",
    "bestchecker.club",
    "bestchertynore.club",
    "bestchoiceofweb.club",
    "bestchoiceroofingmacon.com",
    "bestchoiceroofingnewportnews.com",
    "bestchoiceusedcar.com",
    "bestcloudhostingforasp.com",
    "bestcoasthomes.app",
    "bestcodingbooks.com",
    "bestcoins.xyz",
    "bestcommercialmortgagerates.com",
    "bestcontractorumbrella.com",
    "bestcouponindia.xyz",
    "bestdates.xyz",
    "bestdateshere23.com",
    "bestday.pw",
    "bestdentistofficenearme.com",
    "bestdizua.cf",
    "bestdizua.ga",
    "bestdizua.ml",
    "bestdizua.tk",
    "bestdogovornyematchi.ru",
    "bestdvdblurayplayer.com",
    "beste-slots-online.host",
    "bestelectroscooters.com",
    "besteurotrip.xyz",
    "besteverseocompany.com",
    "bestevidencebasedpractice.com",
    "bestfaithfilms.com",
    "bestfakenews.xyz",
    "bestfitnessidia.space",
    "bestfitnesstips.site",
    "bestfork0di.com",
    "bestfuelefficientsuvs.com",
    "bestfun88.com",
    "bestfunctionalrehab.com",
    "bestfuture.pw",
    "bestg1rls.ru",
    "bestgamingmonitorden.com",
    "bestgenericviagra.website",
    "bestgifok.ru",
    "bestglockner.com",
    "bestgoodsz.com",
    "besthdtelevisions.com",
    "besthealthinsurance.ru",
    "besthendge.ru",
    "besthistorytour.com",
    "besthomeamateurxxx.info",
    "besthunting.ru",
    "bestindexes.com",
    "bestinfonow.cf",
    "bestinfonow.tk",
    "bestinfurniture.com",
    "bestinstrumentiyq.ru",
    "bestintershop.ru",
    "bestinvertergeneratorinfo.com",
    "bestitb.online",
    "bestitem.icu",
    "bestjewelrycrafts.club",
    "bestkitchenknifeset.today",
    "bestkitchens.fun",
    "bestlakertickets.com",
    "bestlocalrating.net",
    "bestloot.tk",
    "bestlovestatus.website",
    "bestlucky.pw",
    "bestmail.us",
    "bestmailgen.com",
    "bestmogensen.com",
    "bestneuropathytreatment.com",
    "bestnewnashville.com",
    "bestnewvacuums.com",
    "bestnycweb.com",
    "bestofamor.com",
    "bestofbarcelona.net",
    "bestofferguidez.com",
    "bestoffersite.store",
    "bestoffworld.ru",
    "bestofironcounty.com",
    "bestofprice.co",
    "bestoftodaynews.site",
    "bestofyou.blog",
    "bestofyou.news",
    "bestoption25.club",
    "bestowed.ru",
    "bestparfum43.ru",
    "bestpaycenter2.com",
    "bestpdfmanuales.xyz",
    "bestpestsydney.com",
    "bestphilippinebrides.com",
    "bestpieter.com",
    "bestpozitiv.ru",
    "bestpracticesneurologicrehab.com",
    "bestprice.exchange",
    "bestprice2020.store",
    "bestpricehotwater.com",
    "bestprizesinside.com",
    "bestquizmaker.com",
    "bestraros.cf",
    "bestraros.gq",
    "bestraros.ml",
    "bestrecipes99.com",
    "bestregisteredagentservices.org",
    "bestrhinopills.com",
    "bestrhums.com",
    "bestsaid.net",
    "bestsellingbookfunnelsecrets.com",
    "bestsentence2020.host",
    "bestsentence2020.site",
    "bestsentence2020.space",
    "bestservice.me",
    "bestshopcoupon.net",
    "bestshows.xyz",
    "bestsidebiz.com",
    "bestsleeping.com",
    "bestsoundeffects.com",
    "bestspeakingcourses.com",
    "bestspiral.info",
    "bestsportsnutrition.shop",
    "bestsquad.org",
    "besttalent.org",
    "besttandberg.com",
    "besttantvil.ga",
    "besttantvil.ml",
    "besttaxlawfirms.net",
    "besttempmail.com",
    "bestthailandbrides.com",
    "besttonighttopdating.com",
    "besttop.info",
    "besttopadultdating.com",
    "besttopdeals.net",
    "besttrade24.ru",
    "besttrommler.com",
    "besttttparsigrrram.club",
    "bestudio327.xyz",
    "bestudio41.xyz",
    "bestudio48.xyz",
    "bestudio49.xyz",
    "bestuniformscrubs.com",
    "bestvalue-properties.com",
    "bestvashikaran.com",
    "bestvirtualrealitysystems.com",
    "bestvpn.top",
    "bestw.space",
    "bestways.ga",
    "bestweb.net",
    "bestwishes.pw",
    "bestworldsbiz.com",
    "bestworldwidestore.com",
    "bestxfilm.ru",
    "bestyourchoiceofproducts.site",
    "besun.cf",
    "bet-boom202.com",
    "bet-boom203.com",
    "bet-boom206.com",
    "bet-boom208.com",
    "bet-boom209.com",
    "bet-boom210.com",
    "bet-boom212.com",
    "bet-boom215.com",
    "bet-boom216.com",
    "bet-boom219.com",
    "bet-boom223.com",
    "bet-boom224.com",
    "bet-boom225.com",
    "bet-boom227.com",
    "bet-boom228.com",
    "bet-boom231.com",
    "bet-boom232.com",
    "bet-boom233.com",
    "bet-boom236.com",
    "bet-boom237.com",
    "bet-boom242.com",
    "bet-boom243.com",
    "bet-boom246.com",
    "bet-boom249.com",
    "bet-boom252.com",
    "bet-boom253.com",
    "bet-boom255.com",
    "bet-boom257.com",
    "bet-boom258.com",
    "bet-boom259.com",
    "bet-boom260.com",
    "bet-boom261.com",
    "bet-boom262.com",
    "bet-boom263.com",
    "bet-boom264.com",
    "bet-boom265.com",
    "bet-boom266.com",
    "bet-boom267.com",
    "bet-boom270.com",
    "bet-boom271.com",
    "bet-boom274.com",
    "bet-boom275.com",
    "bet-boom276.com",
    "bet-boom281.com",
    "bet-boom283.com",
    "bet-boom284.com",
    "bet-boom285.com",
    "bet-boom286.com",
    "bet-boom289.com",
    "bet-boom290.com",
    "bet-boom291.com",
    "bet-boom292.com",
    "bet-boom294.com",
    "bet-boot.net",
    "bet2c.com",
    "bet321online.xyz",
    "bet321site.xyz",
    "bet323apartments.xyz",
    "bet323service.xyz",
    "bet325group.xyz",
    "bet365agent.com",
    "bet43design.xyz",
    "bet49day.xyz",
    "bet49design.xyz",
    "bet4shop.com",
    "bet79.us",
    "bet9.biz",
    "bet9.mobi",
    "beta-access.online",
    "beta.inter.ac",
    "beta.tyrex.cf",
    "betaboks.com",
    "betaboks.net",
    "betaboks.org",
    "betangeles150.com",
    "betano7.com",
    "betanywhere.com",
    "betaprice.co",
    "betarbeton.ru",
    "betasoftechnologies.net",
    "betasus125.com",
    "betasusgiris1.com",
    "betatomail.com",
    "betauer.com",
    "betayun.com",
    "betbalnew.xyz",
    "betbarg1.org",
    "betbargone.com",
    "betbargone.org",
    "betbax.com",
    "betbet.club",
    "betbien5.com",
    "betbigo100.com",
    "betbigo78.com",
    "betbigo99.com",
    "betbing.com",
    "betbola88.biz",
    "betboss28.com",
    "betboss29.com",
    "betboss31.com",
    "betboss32.com",
    "betboss37.com",
    "betboss38.com",
    "betboyclub.com",
    "betcashafrica.com",
    "betchan22.com",
    "betcity-app.ru",
    "betcity-ok.ru",
    "betcity.app",
    "betclubdf5.site",
    "betcmc.xyz",
    "betcoen.com",
    "betcooks.com",
    "betcups.info",
    "betcups.net",
    "betcups.org",
    "betdepo.com",
    "betdolar4.com",
    "betdolar9.com",
    "betdr7.com",
    "beteajah.ga",
    "beteajah.gq",
    "beteajah.ml",
    "beteajah.tk",
    "betebartarr777.online",
    "betemail.cf",
    "betestream11.com",
    "betestream23.com",
    "betestream25.com",
    "betestream27.com",
    "betestream28.com",
    "betestream29.com",
    "betestream30.com",
    "betestream31.com",
    "betestream32.com",
    "betestream37.com",
    "betestream40.com",
    "betestream41.com",
    "betestream42.com",
    "betestream49.com",
    "betexper23tv.com",
    "betexpertv5.com",
    "betfairinfo.ru",
    "betfenomen.org",
    "betfest10.com",
    "betfest8.com",
    "betflix.ru",
    "betforward.design",
    "betforward.review",
    "betfred888.net",
    "betgen999.com",
    "betgramtv29.com",
    "bethandethan.info",
    "bethanynixon.buzz",
    "bethbrombal.com",
    "bethe401kinquiryok.com",
    "bethesdashowerglass.com",
    "bethesedfadsfaidsok.live",
    "bethesetopcrossoversonthemarketsok.live",
    "bethongkong.live",
    "bethosedfadsfaidok.live",
    "bethoughtfulfox.com",
    "betico47.com",
    "betidn.org",
    "betindo88.com",
    "betinebet105.com",
    "betinebet106.com",
    "betinebet107.com",
    "betinmexico.com",
    "betipster.app",
    "betiran35.bet",
    "betistyenigiris.xyz",
    "betkarat.com",
    "betkarat20.com",
    "betkava.com",
    "betlenssu.cf",
    "betlenssu.ga",
    "betlenssu.gq",
    "betlevis.com",
    "betliketv10.com",
    "betliketv16.com",
    "betliketv17.com",
    "betliketv18.com",
    "betliketv19.com",
    "betliketv20.com",
    "betliketv21.com",
    "betliketv23.com",
    "betliketv24.com",
    "betliketv25.com",
    "betliketv8.com",
    "betliketv9.com",
    "betmahaltv.com",
    "betmanset103.com",
    "betmanset104.com",
    "betmanset111.com",
    "betmarinotv.com",
    "betmarj.com",
    "betmarlo10.com",
    "betmars.net",
    "betmaru.com",
    "betmax88.net",
    "betmili.ga",
    "betmili.ml",
    "betmili.tk",
    "betmoon.net",
    "betmoon.org",
    "betmoon25.com",
    "betmoonaffiliates.net",
    "betmoonaffiliates.org",
    "betmoris126.com",
    "betnano102.direct",
    "betnano104.direct",
    "betnano105.direct",
    "betnano37.direct",
    "betnano44.com",
    "betnano62.direct",
    "betnano68.direct",
    "betnano71.com",
    "betnano72.com",
    "betnano95.direct",
    "betnano99.direct",
    "betnesia.net",
    "betnis40.com",
    "betnis87.com",
    "betnis89.com",
    "betodesa.com",
    "betoffice206.com",
    "betofis.net",
    "betofis10.com",
    "betofis101.com",
    "betofis103.com",
    "betofis105.com",
    "betofis106.com",
    "betofis107.com",
    "betofis108.com",
    "betofis109.com",
    "betofis110.com",
    "betofis111.com",
    "betofis113.com",
    "betofis114.com",
    "betofis115.com",
    "betofis118.com",
    "betofis121.com",
    "betofis123.com",
    "betofis124.com",
    "betofis126.com",
    "betofis127.com",
    "betofis128.com",
    "betofis129.com",
    "betofis130.com",
    "betofis131.com",
    "betofis133.com",
    "betofis134.com",
    "betofis135.com",
    "betofis138.com",
    "betofis14.com",
    "betofis140.com",
    "betofis141.com",
    "betofis142.com",
    "betofis143.com",
    "betofis145.com",
    "betofis146.com",
    "betofis147.com",
    "betofis148.com",
    "betofis149.com",
    "betofis150.com",
    "betofis16.com",
    "betofis18.com",
    "betofis19.com",
    "betofis2.com",
    "betofis20.com",
    "betofis21.com",
    "betofis22.com",
    "betofis23.com",
    "betofis25.com",
    "betofis26.com",
    "betofis28.com",
    "betofis29.com",
    "betofis30.com",
    "betofis31.com",
    "betofis32.com",
    "betofis34.com",
    "betofis37.com",
    "betofis4.com",
    "betofis40.com",
    "betofis41.com",
    "betofis42.com",
    "betofis43.com",
    "betofis47.com",
    "betofis49.com",
    "betofis5.com",
    "betofis50.com",
    "betofis55.com",
    "betofis57.com",
    "betofis58.com",
    "betofis6.com",
    "betofis62.com",
    "betofis63.com",
    "betofis64.com",
    "betofis65.com",
    "betofis66.com",
    "betofis68.com",
    "betofis69.com",
    "betofis7.com",
    "betofis70.com",
    "betofis71.com",
    "betofis73.com",
    "betofis74.com",
    "betofis75.com",
    "betofis76.com",
    "betofis77.com",
    "betofis78.com",
    "betofis8.com",
    "betofis81.com",
    "betofis83.com",
    "betofis85.com",
    "betofis86.com",
    "betofis88.com",
    "betofis90.com",
    "betofis91.com",
    "betofis95.com",
    "betofis96.com",
    "betofis97.com",
    "betofis98.com",
    "betofis99.com",
    "betographs.online",
    "betohas.xyz",
    "betoji38.com",
    "betonchehov.ru",
    "betonhim.ru",
    "betonpolitics.email",
    "betonpolitics.mobi",
    "betonpolitics.news",
    "betonpolitics.social",
    "betonpolitics.support",
    "betonsports.dev",
    "betontv.com",
    "betopcrossoversonthemarketok.live",
    "betpab50.club",
    "betpapel.info",
    "betpara1000.com",
    "betpara200.com",
    "betpara300.com",
    "betpara38.com",
    "betpara400.com",
    "betpara43.com",
    "betpara44.com",
    "betpara46.com",
    "betpara500.com",
    "betpara51.com",
    "betpara52.com",
    "betpara53.com",
    "betpara54.com",
    "betpara55.com",
    "betpara56.com",
    "betpara57.com",
    "betpara59.com",
    "betpara60.com",
    "betpara600.com",
    "betpara63.com",
    "betpara67.com",
    "betpara69.com",
    "betpara71.com",
    "betpara72.com",
    "betpara74.com",
    "betpara76.com",
    "betpara78.com",
    "betpara79.com",
    "betpara80.com",
    "betpara81.com",
    "betpara82.com",
    "betpara83.com",
    "betpara85.com",
    "betpara86.com",
    "betpara88.com",
    "betpara89.com",
    "betpara90.com",
    "betpara92.com",
    "betpara93.com",
    "betpara94.com",
    "betpara95.com",
    "betpara96.com",
    "betpara97.com",
    "betpara98.com",
    "betpara99.com",
    "betperform.fun",
    "betpluton.fun",
    "betpoundsgunceladres.com",
    "betpoundssikayet.com",
    "betr.co",
    "betrax.ml",
    "betrekabet46.com",
    "betriebsdirektor.de",
    "bets10uyeol.co",
    "betsalon004.com",
    "betsalon007.com",
    "betsalon065.com",
    "betsalon37.com",
    "betsalon38.com",
    "betsanal.com",
    "betsat89.com",
    "betsatgirisi.xyz",
    "betsbest24.ru",
    "betscsgo.pro",
    "betscsgo2.org",
    "betsdot22.com",
    "betsdot24.com",
    "betsdot29.com",
    "betsdot34.com",
    "betsend26.com",
    "betsend29.com",
    "betsend30.com",
    "betsend33.xyz",
    "betsendsikayet.com",
    "betshoma.club",
    "betsidney109.com",
    "betsilin4.com",
    "betsilin43.com",
    "betsitem874.com",
    "betsntips.info",
    "betsuing.com",
    "better-built-homes-and-gardens.com",
    "better-than.tv",
    "better.in.net",
    "better06.site",
    "betterathome.live",
    "bettercoffe.com",
    "betterdiagnostics.online",
    "bettergolf.net",
    "betterlab.net",
    "betterlink.info",
    "betterlivingofrochester.com",
    "bettermedicine.net",
    "bettermfg.com",
    "betterorganizedgarages.com",
    "bettersmell.com",
    "bettersmokefree.com",
    "bettersmokefree.net",
    "bettersmokefree.org",
    "betterwisconsin.com",
    "betterwisconsin.net",
    "betterwisconsin.org",
    "bettilt70.com",
    "bettingsnap.xyz",
    "bettiret.tk",
    "bettsnap2020.xyz",
    "betttt.info",
    "betturan.com",
    "bettycropper.com",
    "betvakti55.com",
    "betvakti81.com",
    "betvakti86.com",
    "betvirtus.com",
    "betwim.info",
    "betxlarge14.com",
    "betxtr88.com",
    "betyap12.com",
    "betyap13.com",
    "betyap15.com",
    "betyap17.com",
    "betyap2.com",
    "betyap23.com",
    "betyap25.com",
    "betyap27.com",
    "betyap3.com",
    "betyap49.com",
    "betyap50.com",
    "betyap6.com",
    "betyap7.com",
    "betyap8.com",
    "betzakhar.xyz",
    "beuczbkq.shop",
    "beumebu.cf",
    "beupmore.win",
    "bev.net",
    "bever2ymits.xyz",
    "beveragedictionary.com",
    "beverageglossary.com",
    "beveragesshop.life",
    "beverlyharing55places.com",
    "beverlyhillstelecom.com",
    "beverlytx.com",
    "bevhattaway.com",
    "beweb.xyz",
    "bewedfv.com",
    "beweightlossinfoesok.live",
    "bewleysnorthamerica.com",
    "bewleysusa.com",
    "bewumarkets.site",
    "beyazceviz.xyz",
    "beyazmuzayede.istanbul",
    "beyoglunet.xyz",
    "beyogluprofiloservisi.com",
    "beyoncenetworth.com",
    "beyondecstasy.info",
    "beyondsightfoundation.org",
    "beyondthemall.com",
    "beyondwallssquash.org",
    "beysehirlimited.xyz",
    "beytavder.org",
    "bez-kompleksov.site",
    "bezosfamilyfoundation.ong",
    "bezpartyjnikukiz.org",
    "bezpartyjnisamorzadowcykukiz.org",
    "bezvodki.ru",
    "bezzppearar.cf",
    "bezzppearar.ga",
    "bezzsewheelw.cf",
    "bezzsewheelw.ga",
    "bezzsewheelw.gq",
    "bezzsewheelw.ml",
    "bezzsewheelw.tk",
    "bf053.com",
    "bf8819.org",
    "bf8878.com",
    "bfax.email",
    "bfbr6.us",
    "bfdsfgrg8bnvce.monster",
    "bfdwam.us",
    "bfdyn.com",
    "bffdwgrg.shop",
    "bfg1yh.best",
    "bfgasdsd.site",
    "bfhbrisbane.com",
    "bflier.com",
    "bfo.kr",
    "bfory.ru",
    "bfoyk.live",
    "bfsnan.com",
    "bfuli.xyz",
    "bfull.site",
    "bfzutpeo.shop",
    "bg-di.com",
    "bg-report.com",
    "bg4llrhznrom.cf",
    "bg4llrhznrom.ga",
    "bg4llrhznrom.gq",
    "bg4llrhznrom.ml",
    "bg4llrhznrom.tk",
    "bg613.top",
    "bgboad.ga",
    "bgboad.ml",
    "bgd32.com",
    "bgi-sfr-i.pw",
    "bgisfri.pw",
    "bgmilya.ru",
    "bgmktgsolutions.net",
    "bgolive.org",
    "bgpwall.org",
    "bgsaddrmwn.me",
    "bgsb.site",
    "bgsimpson.com",
    "bgtechnik.tk",
    "bgth.site",
    "bgtmail.com",
    "bgtmirror.ru",
    "bgtservices.com",
    "bgx.ro",
    "bgzbbs.com",
    "bhadoomail.com",
    "bhag.us",
    "bhakti-tree.com",
    "bhambriinternational.com",
    "bharatmail.com",
    "bhbh.online",
    "bhbh.shop",
    "bhbh.space",
    "bhbh.website",
    "bhddmwuabqtd.cf",
    "bhddmwuabqtd.ga",
    "bhddmwuabqtd.gq",
    "bhddmwuabqtd.ml",
    "bhddmwuabqtd.tk",
    "bheriyji.shop",
    "bhfeed.com",
    "bhk.casino",
    "bhkvzgkzx.shop",
    "bhmhg.com",
    "bho.hu",
    "bho.kr",
    "bhqxv.us",
    "bhrenovarb.ru",
    "bhrpsck8oraayj.cf",
    "bhrpsck8oraayj.ga",
    "bhrpsck8oraayj.gq",
    "bhrpsck8oraayj.ml",
    "bhrpsck8oraayj.tk",
    "bhslaughter.com",
    "bhss.de",
    "bhswlx.com",
    "bhtcnpm.ga",
    "bhu1b.info",
    "bhuiyanadagency.com",
    "bhumi.ong",
    "bhuyarey.ga",
    "bhuyarey.ml",
    "bhwshop.com",
    "bhx.money",
    "bhzdqb.us",
    "bi-meca.com",
    "bi.no",
    "bi0qq.us",
    "bi456.com",
    "bia20446216.xyz",
    "bia20645613.xyz",
    "bia21168958.xyz",
    "bia21995383.xyz",
    "bia22010427.xyz",
    "bia23207112.xyz",
    "bia24485224.xyz",
    "bia25249609.xyz",
    "bia25424823.xyz",
    "bia25829333.xyz",
    "bia26272077.xyz",
    "bia27414248.xyz",
    "bia27461573.xyz",
    "bia28413456.xyz",
    "bia28952946.xyz",
    "bia29541220.xyz",
    "bia29548522.xyz",
    "bia29556265.xyz",
    "bia29564886.xyz",
    "bia29582343.xyz",
    "bia29595493.xyz",
    "bia29612283.xyz",
    "bia29621328.xyz",
    "bia29626744.xyz",
    "bia29667004.xyz",
    "bia29701556.xyz",
    "bia29716378.xyz",
    "bia29726932.xyz",
    "bia29734429.xyz",
    "bia29743532.xyz",
    "bia29753640.xyz",
    "bia29782852.xyz",
    "bia29785320.xyz",
    "bia29821800.xyz",
    "bia29882873.xyz",
    "bia29890050.xyz",
    "bia29924068.xyz",
    "bia29926145.xyz",
    "bia29939022.xyz",
    "bia2baazi.com",
    "bian.capital",
    "bianat.net",
    "bianco.cf",
    "bianco.ga",
    "bianco.ml",
    "biaplunsuc.cf",
    "biaplunsuc.gq",
    "biazz2.live",
    "bibars.cloud",
    "bibbiasary.info",
    "bibersurubu.site",
    "bibibet.network",
    "bibicaba.cf",
    "bibicaba.ga",
    "bibicaba.gq",
    "bibicaba.ml",
    "bibizesor.com",
    "bible-survey.com",
    "bibleshark.com",
    "biblesmuggler.com",
    "bibliadoemagracimento.com",
    "bibliapopular.org",
    "bibliavulgata.com",
    "biblica.dev",
    "biblicallongevitymiracle.com",
    "biblider.ru",
    "biblio-globus.space",
    "bibliobot.net",
    "bibliobot.org",
    "bibliographic.info",
    "bibliomani.se",
    "biblioostrov.ru",
    "bibliotecadigital.site",
    "bibnchip.net",
    "biboxcons.cf",
    "biboxcons.ga",
    "biboxcons.gq",
    "biboxcons.ml",
    "biboxcons.tk",
    "bibucabi.cf",
    "bibucabi.ga",
    "bibucabi.gq",
    "bibucabi.ml",
    "bicence.com",
    "biceoutlets.site",
    "bicienvia.com",
    "bickmail.com.au",
    "bickwanck.com",
    "bico.site",
    "bicyclddjg.space",
    "bicyclemaze.com",
    "bicyclesforum.com",
    "bid4wheels.com",
    "bidb8r.xyz",
    "bidcoin.cash",
    "bidcoin.money",
    "bidcoin.site",
    "bidcoin.space",
    "bidcoins.network",
    "bidcoins.online",
    "bidcoins.space",
    "bidjapan.net",
    "bidli.com",
    "bidolukampanya.online",
    "bidolukampanya.xyz",
    "bidourlnks.com",
    "bidplatform.click",
    "bidplatform.org",
    "bidplatform.space",
    "bidu.cf",
    "bidu.gq",
    "bidvmail.cf",
    "biedaw.xyz",
    "biedron2020.com",
    "bienparisy.info",
    "bier.cool",
    "bietthunghiduong.website",
    "bievent.xyz",
    "bifaqp.com",
    "bifaqp.net",
    "bifayl.com",
    "bifayl.net",
    "bifayouxi.net",
    "bifayule.net",
    "bifrost.su",
    "bifvlog.com",
    "big-mro.com",
    "big-news.top",
    "big-phone.ru",
    "big-possible.net",
    "big-prizes-place4.life",
    "big-wife.xyz",
    "big1.us",
    "big2poker.online",
    "big5mail.com",
    "big5time.com",
    "big777a.org",
    "bigassweb.com",
    "bigbangfairy.com",
    "bigbash.ru",
    "bigbearshop.ru",
    "bigbet4d.com",
    "bigbetco.info",
    "bigbetco.org",
    "bigbets90.org",
    "bigblue.net.au",
    "bigbluqffr.space",
    "bigbn.com",
    "bigboab.com",
    "bigboobyasians.com",
    "bigboostmaxpro.com",
    "bigboy.org",
    "bigbro.website",
    "bigbropoker.best",
    "bigbropoker.biz",
    "bigcock.black",
    "bigcoin.best",
    "bigcrop.pro",
    "bigdat.fun",
    "bigdeal.media",
    "bigeasytobacco.com",
    "bigeasytobacconist.com",
    "bigel.com",
    "bigfangroup.info",
    "bigfangroup.name",
    "bigfoot.com",
    "bigfoot.de",
    "biggblamgen.cf",
    "biggblamgen.tk",
    "biggboss12.us",
    "bigger.com",
    "biggerbadder.com",
    "biggestgay.com",
    "bighome.site",
    "bigify.com",
    "biglive.asia",
    "bigload.fun",
    "biglol.club",
    "bigmailbox.com",
    "bigmine.ru",
    "bigmir.net",
    "bigmood.xyz",
    "bigoofficial.com",
    "bigotes.org",
    "bigpicturecharts.com",
    "bigpond.au",
    "bigpond.com",
    "bigpond.com.au",
    "bigpond.net",
    "bigpond.net.au",
    "bigprizesishere10.life",
    "bigprofessor.so",
    "bigramp.com",
    "bigstring.com",
    "bigtetek.cf",
    "bigtetek.ga",
    "bigtetek.gq",
    "bigtetek.ml",
    "bigtetek.tk",
    "bigtoken.cryptolovers.id",
    "bigtokenican2.hmail.us",
    "bigtokenican3.hmail.us",
    "bigtonehorsens.com",
    "bigtuyul.me",
    "bigua.info",
    "bigvalleybingo.com",
    "bigwhoop.co.za",
    "bigwiki.xyz",
    "bigwin333.org",
    "bigxxx.space",
    "bigzmei.site",
    "bih2dd.com",
    "bij.pl",
    "bijouxredo.com",
    "bikebee.ru",
    "bikebee.space",
    "bikebee.website",
    "bikebee.xyz",
    "bikebees.bike",
    "bikebees.biz",
    "bikebees.guru",
    "bikebees.info",
    "bikebees.net",
    "bikebees.online",
    "bikeforthebuns.info",
    "bikehikecanada.com",
    "bikekhabri.com",
    "bikelabel.com",
    "bikemechanics.com",
    "bikeracer.com",
    "bikeracers.co.uk",
    "bikeracers.net",
    "bikerboof.com",
    "bikerider.com",
    "bikesculpture.com",
    "bikesculptures.com",
    "bikesshop.live",
    "bikethebyways.com",
    "biketrend.se",
    "bikeway.online",
    "bikissimo.com",
    "bikser.ru",
    "bikubiku.com",
    "bilbyihva.space",
    "bilderservice.org",
    "bildikyerim.com",
    "bilecikorganizasyon.com",
    "bilestone.best",
    "biletalsat.xyz",
    "biletgrup.com",
    "bileuder.site",
    "bilgetrade.com",
    "bilingualbibles.org",
    "bilisimyayincilik.com",
    "bilistand.site",
    "bill.vote",
    "billardhall.com",
    "billgatescoin.site",
    "billgatescoins.site",
    "billho.website",
    "billiament.info",
    "billig-vvs.se",
    "billiges-notebook.de",
    "billigpillersverige.xyz",
    "billionaire-project777.ru",
    "billiondollargoal.com",
    "billionvj.com",
    "billmooz.com",
    "billofiegb.space",
    "billpayo.com",
    "billpoisonbite.website",
    "billsfan.com",
    "billsfan.net",
    "billspropertymaintenance.com",
    "billsremndr.xyz",
    "billwizardrewards.com",
    "billybasin.online",
    "billycarson.ga",
    "bilovor.ru",
    "bilri-car.ru",
    "bilytica.africa",
    "bim-aloman.ru",
    "bimamail.com",
    "bimarketdigital.com",
    "bimishops.site",
    "bimky.ru",
    "bimla.net",
    "bimmarket.com",
    "bimmerdieselna.com",
    "bimt.us",
    "bin-wieder-da.de",
    "bin.8191.at",
    "binancebbt.net",
    "binarenoptionenhandeln.de",
    "binary7day.com",
    "binatangmall.com",
    "binboss.ru",
    "binbug.xyz",
    "bindware.app",
    "bineshsarmad.com",
    "bing.com",
    "bingakilo.ga",
    "bingakilo.ml",
    "bingbaloney.com",
    "bingo-game-set.com",
    "bingobyen.com",
    "bingoindonesia.com",
    "bingolarackiralama.com",
    "bingzone.net",
    "bingzz.live",
    "binka.me",
    "binkgisjunc.cf",
    "binkgisjunc.gq",
    "binkmail.com",
    "binnary.com",
    "bino-jobs.info",
    "binojobs.info",
    "binoma.biz",
    "binumartep.cf",
    "binwindvil.cf",
    "binwindvil.ga",
    "binwindvil.ml",
    "binwindvil.tk",
    "binxic.ru",
    "bio-bolsas.com",
    "bio-consultant.com",
    "bio-muesli.info",
    "bio-muesli.net",
    "bio-tonus.site",
    "bio.clothing",
    "bio.toys",
    "bio.trade",
    "bio4skin.ru",
    "bioauto.info",
    "biobalance-dietstylenow.com",
    "biobalancefitnow.com",
    "biobalancemaletoday.com",
    "bioberreld.cf",
    "bioberreld.ga",
    "bioberreld.tk",
    "bioblogfi.cf",
    "bioblogfi.ga",
    "bioblogfi.tk",
    "biobreak.net",
    "biocaf.dev",
    "biocharculture.xyz",
    "biocompute.africa",
    "biofitstudios.com",
    "bioflokus.com",
    "biogard24.space",
    "biogardys.space",
    "biogardys.website",
    "biohackworldwide.com",
    "bioinformatics.rocks",
    "biolaqq.com",
    "biolisri.ga",
    "biolisri.ml",
    "biolisri.tk",
    "biologyfan.com",
    "biologyreverse.us",
    "biomba.xyz",
    "biometicsliquidvitamins.com",
    "bionagneu.cf",
    "bionagneu.gq",
    "bionagneu.tk",
    "bionamic.com",
    "bione.co",
    "bionikgame.ru",
    "bionome.com",
    "bionomtherapy.com",
    "bionomtheraworks.com",
    "bioperformancecenter.net",
    "bioperformancecenter.org",
    "bioperformancecenter.us",
    "bioperformancelab.org",
    "bioperformancelab.us",
    "bioplasticproduct.com",
    "bioresonanthome.ru",
    "bioschwartz.ru",
    "bioshure.com",
    "biosmetica.com",
    "biosolarpanels.com",
    "biosor.cf",
    "biosoznanie.ru",
    "biostatistique.com",
    "biosupre.net",
    "biosupre.org",
    "biosyniksx.space",
    "biotechhub.com",
    "biowerk.com",
    "biperca.cf",
    "biperca.ga",
    "biperca.gq",
    "biperca.ml",
    "biperca.tk",
    "bips.best",
    "birabet.xyz",
    "biraci.gq",
    "birangona.org",
    "birbakmobilya.com",
    "bird.support",
    "birdbro.club",
    "birdcagephotobooth.com",
    "birderstravel.net",
    "birdfanatic.com",
    "birdlover.com",
    "birdnacan.gq",
    "birdoneoxl.space",
    "birdowner.net",
    "birdsfly.press",
    "birebirbahis.com",
    "birgind.com",
    "birkenstockadmin.site",
    "birmana.cf",
    "birmana.ml",
    "birmandesign.com",
    "birminghamaddictiontreatment.com",
    "birminghamalcoholrehab.com",
    "birminghamcocainerehab.com",
    "birminghamfans.com",
    "birminghamheroinrehab.com",
    "biro.gq",
    "biro.ml",
    "biro.tk",
    "biroistvan.eu",
    "birsanduskabin.com",
    "birsanmimarlik.com",
    "birthassistant.com",
    "birthcarestaffing.com",
    "birthmomsummit.com",
    "birthmothermentors.com",
    "birthmothersummit.com",
    "birtmail.com",
    "biscutt.us",
    "bisdak.xyz",
    "bishkechki.com",
    "bisiklopedi.net",
    "biskampus.ga",
    "bismillah.com",
    "bisons.com",
    "bisonte.best",
    "bissellballantyne.net",
    "bistroottawa.net",
    "bistrosignatures.net",
    "bisuteriazaiwill.com",
    "bit-degree.com",
    "bit-ion.net",
    "bit-led.ru",
    "bit2tube.com",
    "bit3716.com",
    "bit4826.com",
    "bitassetira.com",
    "bitatilsec.com",
    "bitbaysafe.com",
    "bitbees.com",
    "bitbet.bet",
    "bitbet.xyz",
    "bitbet24.ru",
    "bitbucks.org",
    "bitbuymu.cf",
    "bitbuymu.ga",
    "bitbuymu.gq",
    "bitbuymu.ml",
    "bitchmail.ga",
    "bitco-change.ru",
    "bitcoin-norge.org",
    "bitcoin.ngo",
    "bitcoinandmetals.com",
    "bitcoinarmory.org",
    "bitcoinbattle.fun",
    "bitcoinbattle.org",
    "bitcoinbet.us",
    "bitcoincodesafe.space",
    "bitcoindocumentation.com",
    "bitcoinexchange.cash",
    "bitcoini-bestchange.ru",
    "bitcoininvestmentforum.com",
    "bitcoinisland.org",
    "bitcoinplanning.com",
    "bitcoinrevolt.biz",
    "bitcoins-circuit.com",
    "bitcoinsandblockchainssc.com",
    "bitcointradenow.site",
    "bitcointrader24.site",
    "bitconecct.ru",
    "bitcooker.com",
    "bitcorp.space",
    "biteindustry.tech",
    "bitesatlanta.com",
    "bitevolution.website",
    "bitex.market",
    "biteye.one",
    "bitkey.com",
    "bitkihane.online",
    "bitkiselcozumleri.xyz",
    "bitkizenlosyon.xyz",
    "bitkizenlosyonu.xyz",
    "bitlisisrehberi.xyz",
    "bitlisnemrut.com",
    "bitly.space",
    "bitly.website",
    "bitmail.com",
    "bitmain-antminer-s17.com",
    "bitmarketnow.com",
    "bitmeads.com",
    "bitmonkey.xyz",
    "bitnisse.dk",
    "bitovik-rostov.ru",
    "bitpage.net",
    "bitpk.trade",
    "bitpost.site",
    "bitrage.app",
    "bitrohan.ml",
    "bits-n-bytes2015.com",
    "bitsbuilder.com",
    "bitsbuilder.org",
    "bitsharesbts.com",
    "bitso.design",
    "bitterrootrestoration.com",
    "bittorrentsearchweb.rentals",
    "bituronline.com",
    "bitwerke.com",
    "bitwhites.top",
    "bitx.nl",
    "bitxu.online",
    "bityakuza.com",
    "bitymails.us",
    "bitzonasy.info",
    "bivehe.xyz",
    "bixbet161.com",
    "biyamitibushveldcamp.com",
    "biyeshop.site",
    "biyiklicafe.icu",
    "biz.st",
    "bizbiz.tk",
    "bizcitizens.com",
    "bizcomail.com",
    "bizfi.xyz",
    "bizhacks.org",
    "bizhig.com",
    "bizhosting.com",
    "bizimalem-support.de",
    "bizimbahis.net",
    "bizimbahis133.net",
    "bizimbahis52.net",
    "bizimbahis76.net",
    "bizimbahis87.net",
    "bizimle.net",
    "bizkvadr.ru",
    "bizlaunchuniversity.info",
    "biznagadecolores.com",
    "biznes-pravo.ru",
    "bizoncovers.com",
    "bizsearch.info",
    "biztime.tk",
    "bj-tmg.com",
    "bj027.site",
    "bj1fx.host",
    "bjaum.us",
    "bjdhrtri09mxn.ml",
    "bjhaicheng.net",
    "bjif.net",
    "bjin000.com",
    "bjin333.com",
    "bjj.icu",
    "bjjeex.rest",
    "bjmd.cf",
    "bjmsulawesi.xyz",
    "bjq53.space",
    "bjqjvtodz.shop",
    "bjsnc.com",
    "bjtpg.us",
    "bjwc.us",
    "bjxt.ml",
    "bjzshw.com",
    "bjzxb.com",
    "bk.ru",
    "bk19e6.us",
    "bkbmfb.fun",
    "bkckc.com",
    "bkdmll.fun",
    "bkfarm.fun",
    "bkfturkiye.com",
    "bkg4rk.com",
    "bkhmmb.fun",
    "bki1.ru",
    "bki7rt6yufyiguio.ze.am",
    "bkikontrol.ru",
    "bkiug1.site",
    "bkjmnx.fun",
    "bkjmsk.fun",
    "bkjmtp.fun",
    "bkk-tour.info",
    "bkkmail.com",
    "bkkpkht.cf",
    "bkkpkht.ga",
    "bkkpkht.gq",
    "bkkpkht.ml",
    "bklmbs.fun",
    "bklmyt.host",
    "bklynskyway.com",
    "bkm43.com",
    "bknugywge.shop",
    "bko.kr",
    "bkpmht.fun",
    "bkpmny.fun",
    "bkpmwr.fun",
    "bkqmks.fun",
    "bkrmln.fun",
    "bkrointernational.site",
    "bksho.club",
    "bktmyf.fun",
    "bkukevanittersum.xyz",
    "bkwmpr.fun",
    "bkwmtd.fun",
    "bkxdwnpvje.site",
    "bkxmby.fun",
    "bkxmqm.fun",
    "bl.ctu.edu.gr",
    "bl0.info",
    "bl3xo7.us",
    "bl5ic2ywfn7bo.cf",
    "bl5ic2ywfn7bo.ga",
    "bl5ic2ywfn7bo.gq",
    "bl5ic2ywfn7bo.ml",
    "bl5ic2ywfn7bo.tk",
    "bl60.com",
    "bl70.com",
    "bla-bla.com",
    "blaciser.cf",
    "blaciser.gq",
    "blaciser.ml",
    "blaciser.tk",
    "black-latte24.ru",
    "black-magi.ru",
    "black-magick.ru",
    "black-mountain.tech",
    "black-privoroti.ru",
    "black-sharks.ru",
    "black.bianco.cf",
    "black2x.com",
    "blackbeshop.com",
    "blackbird.ws",
    "blackbox-official.ru",
    "blackburnfans.com",
    "blackburnmail.com",
    "blackcashledger.com",
    "blackdiamondcc.org",
    "blackdns.site",
    "blackfer.xyz",
    "blackfishdiscos.com",
    "blackgarlictea.site",
    "blackgate.tk",
    "blackgoldagency.ru",
    "blackgranitetop.top",
    "blackgreenotl.xyz",
    "blackgreenwastetyre.xyz",
    "blackgreenwt.xyz",
    "blackhawkcurlingclub.com",
    "blackheadkiller.net",
    "blackhole.djurby.se",
    "blackhole.targeter.nl",
    "blackholezero.com",
    "blackjackmeesters.com",
    "blacklab.ru",
    "blacklabhosting.com",
    "blacklatte-natural.ru",
    "blacklattekahve.site",
    "blackmagi.ru",
    "blackmagick.ru",
    "blackmail.ml",
    "blackmarket.su",
    "blackmarket.to",
    "blackmobile-1.info",
    "blackpetty.recipes",
    "blackplanet.com",
    "blackpoolfans.co.uk",
    "blackprivoroti.ru",
    "blackrock-plat.com",
    "blackrutor.site",
    "blacksburg.net",
    "blackshipping.com",
    "blacktiemagician.com",
    "blackwelltechnical.com",
    "blacteocrafworth.tk",
    "blaczajrang.ga",
    "blaczajrang.tk",
    "bladdebbzw.space",
    "blademod.icu",
    "blader.com",
    "bladeshoc.fun",
    "bladesmail.net",
    "blagremont.ru",
    "blahg.net",
    "blahxhou.shop",
    "blairdaly.com",
    "blairhair.com",
    "blakasuthaz52mom.tk",
    "blakekrueger.com",
    "blakesregisteredagents.com",
    "blalachwhi.gq",
    "blan.tech",
    "blandbrin.xyz",
    "blandcoconstruction.com",
    "blangbling784yy.tk",
    "blankalive.us",
    "blankgre.xyz",
    "blankhe.buzz",
    "blankwidth.fun",
    "blarakfight67dhr.ga",
    "blashatuff.cf",
    "blashatuff.ga",
    "blashatuff.ml",
    "blastcloud.com",
    "blastcolos.ru",
    "blastgods.ru",
    "blasthron.ru",
    "blastol.com",
    "blasttru.xyz",
    "blasttrus.xyz",
    "blatchfordrenewableenergy.com",
    "blawg.net",
    "blazemail.com",
    "blazenet.net",
    "blazercast.com",
    "bldg77.org",
    "bldrogy.ru",
    "bleakhalls.info",
    "bleederas.ga",
    "bleederas.gq",
    "bleederas.ml",
    "bleedmaroon.com",
    "bleib-bei-mir.de",
    "blendercompany.com",
    "blendertv.com",
    "blessedwillow.com",
    "blessient.monster",
    "blessingvegetarian.com",
    "blghq.xyz",
    "blgs.xyz",
    "blgshq.xyz",
    "blgsly.xyz",
    "bliear.pro",
    "bliejeans.com",
    "blindpanda.info",
    "blindparrot.info",
    "blindskunk.info",
    "blink182.net",
    "blinkmage.com",
    "blinkmatrix.com",
    "blip.ch",
    "blissmusic.online",
    "blkbright.com",
    "blkchainvrfy.net",
    "blkday.com",
    "blm7.net",
    "blm9.net",
    "blmgw0.com",
    "blmgw6.com",
    "blndrco.com",
    "blnkt.net",
    "blntm.site",
    "bloatbox.com",
    "bloc.quebec",
    "block-account.ru",
    "block-coinhub.info",
    "block-node.com",
    "block-node.net",
    "block-node.org",
    "blockblocks.bid",
    "blockblocks.party",
    "blockbudg.xyz",
    "blockchain-wallet.live",
    "blockchainalternativeinvestment.com",
    "blockchaindesktop.com",
    "blockchainlegal.technology",
    "blockchainworldawards.com",
    "blockchainworldeurope.com",
    "blockchainworldexhibition.com",
    "blockchainworldfund.com",
    "blockchainworldfundmanagement.com",
    "blockchn-fza4i.com",
    "blockdigichain.com",
    "blockenstock.com",
    "blockersspy.com",
    "blockfilter.com",
    "blockgemini.org",
    "blockhousecalifornia.com",
    "blockhouseco.com",
    "blocklattice.xyz",
    "blockmonent.com",
    "blocknames.bid",
    "blocknetdx-coinhub.info",
    "blockopsteam.com",
    "blockoviacoinpay.com",
    "blockoviapay.com",
    "blocktrail.org",
    "blockzer.com",
    "blocurrem.gq",
    "blog-couteau.com",
    "blog-perfect.club",
    "blog-stanislav.ru",
    "blog34.xyz",
    "blog5984.ru",
    "blogcast.blog",
    "blogcast.lgbt",
    "blogdns.com",
    "blogdns.net",
    "blogdns.org",
    "blogdobg.com",
    "blogertsd.net",
    "blogfortetreinosuplementos.com",
    "bloggersxmi.com",
    "bloggingdoc.com",
    "bloggistamomma.info",
    "bloggroups.com",
    "bloghaiti.com",
    "blogisit.cf",
    "blogisit.ga",
    "blogisit.gq",
    "blogisit.tk",
    "blogjamatlantic.com",
    "bloglbs.xyz",
    "bloglurichardnet.info",
    "blogmania.site",
    "blogmaska.ru",
    "blogmulher.online",
    "blogmyway.org",
    "blogneton.site",
    "blogneton.xyz",
    "blogodietax.ru",
    "blogomob.ru",
    "blogos.com",
    "blogos.net",
    "blogoworke.ru",
    "blogpinmag.xyz",
    "blogpress.info",
    "blogpress.pro",
    "blogsapp.xyz",
    "blogsgaia.com",
    "blogsite.org",
    "blogsiteonline.com",
    "blogslabs.xyz",
    "blogslbs.xyz",
    "blogsly.xyz",
    "blogsme.ru",
    "blogsmundi.com",
    "blogspam.ro",
    "blogspangea.com",
    "blogspot.com",
    "blogspot1325.ru",
    "blogspp.xyz",
    "blogues.org",
    "blondandeasy.com",
    "blonded.club",
    "blood.house",
    "blood.link",
    "bloodchain.org",
    "bloodpresssureformula1.online",
    "bloodrunsdownamountain.net",
    "bloodsugarprogram.com",
    "bloodysally.xyz",
    "bloomable.info",
    "bloomable.store",
    "bloomintg.tk",
    "bloominvoice.com",
    "bloompi.ru",
    "bloomsbycelebrations.com",
    "bloop.host",
    "blop.bid",
    "blop.cloud",
    "bloq.ro",
    "bloqmental.ru",
    "bloqstock.com",
    "blow-job.nut.cc",
    "blowersusa.com",
    "blowtac.net",
    "blowterlu.cf",
    "blowterlu.ga",
    "blowterlu.ml",
    "blowterlu.tk",
    "blowzy715pj.online",
    "bloxter.cu.cc",
    "blqthexqfmmcsjc6hy.cf",
    "blqthexqfmmcsjc6hy.ga",
    "blqthexqfmmcsjc6hy.gq",
    "blqthexqfmmcsjc6hy.ml",
    "blqthexqfmmcsjc6hy.tk",
    "blr698.com",
    "blr9837.com",
    "blrt.email",
    "blrt.guru",
    "blrt.link",
    "blrt.mobi",
    "blrt.site",
    "blrt.video",
    "blrtapp.net",
    "blrtplugin.com",
    "bls-v.icu",
    "blspiwvv.shop",
    "blttorrent.site",
    "bltzloto.ru",
    "blu.it",
    "blue-magic.red",
    "blueauramassage.com",
    "bluebabyrecordings.com",
    "bluebottle.com",
    "bluecherry.xyz",
    "bluecitynews.com",
    "bluecollarguitarpickupsonline.com",
    "bluecoreshorties.com",
    "bluecrossrehabcenters.com",
    "bluedelivery.store",
    "bluedeluge.com",
    "bluedomebooks.com",
    "bluedumpling.info",
    "bluefishpond.com",
    "blueforcemedia.net",
    "bluefriday.info",
    "bluefriday.top",
    "bluegorillatradesman.info",
    "bluehyppo.com",
    "bluejube.org",
    "bluelagoonnationalpark.com",
    "bluemail.ch",
    "bluemail.dk",
    "bluemangocafewaterford.com",
    "bluenebula.us",
    "blueorchidballinteer.com",
    "bluepacificcapital.com",
    "bluepage.shop",
    "bluepowersite.com",
    "blueprintbet.com",
    "blueprintconnections.com",
    "blueridgebeast.com",
    "bluerootssparkle.com",
    "blueseashotels.com",
    "bluesestodo.com",
    "bluesfan.com",
    "bluesfans.com",
    "bluespiderart.com",
    "bluetoothmodulefactory.com",
    "bluetree.holiday",
    "bluetreephuket.fun",
    "bluetreephuket.holiday",
    "bluewall.dev",
    "bluewerks.com",
    "bluewin.ch",
    "blueyonder.co.uk",
    "blulapis.com",
    "blumail.org",
    "blumfirmfrog.cf",
    "blumfirmfrog.ga",
    "blumfirmfrog.gq",
    "blumpjam.com",
    "blunomval.cf",
    "blupeardesign.com",
    "blurbulletbody.website",
    "blurp.tk",
    "blushmail.com",
    "blutig.me",
    "blutmapound.tk",
    "bluwinks.com",
    "bluwurmind234.cf",
    "bluwurmind234.ga",
    "bluwurmind234.gq",
    "bluwurmind234.ml",
    "bluwurmind234.tk",
    "blz700.com",
    "blzbd.us",
    "bm-xy.com",
    "bmaker.net",
    "bmall.sk",
    "bmca114.com",
    "bmcmail.org",
    "bmetfy.info",
    "bmi-facts.org",
    "bmllw.com",
    "bmlsports.net",
    "bmpk.org",
    "bmpqx1.site",
    "bmswup.us",
    "bmteach.info",
    "bmtjokqa.shop",
    "bmvcfp.us",
    "bmw-ag.cf",
    "bmw-ag.ga",
    "bmw-ag.gq",
    "bmw-ag.ml",
    "bmw-ag.tk",
    "bmw-i8.gq",
    "bmw-keyauto.site",
    "bmw-mini.cf",
    "bmw-mini.ga",
    "bmw-mini.gq",
    "bmw-mini.ml",
    "bmw-mini.tk",
    "bmw-raspily.ru",
    "bmw-rollsroyce.cf",
    "bmw-rollsroyce.ga",
    "bmw-rollsroyce.gq",
    "bmw-rollsroyce.ml",
    "bmw-rollsroyce.tk",
    "bmw-x5.cf",
    "bmw-x5.ga",
    "bmw-x5.gq",
    "bmw-x5.ml",
    "bmw-x5.tk",
    "bmw-x6.ga",
    "bmw-x6.gq",
    "bmw-x6.ml",
    "bmw-x6.tk",
    "bmw-z4.cf",
    "bmw-z4.ga",
    "bmw-z4.gq",
    "bmw-z4.ml",
    "bmw-z4.tk",
    "bmwgroup.cf",
    "bmwgroup.ga",
    "bmwgroup.gq",
    "bmwgroup.ml",
    "bmwqq.website",
    "bmwqqq.info",
    "bmwriders.com",
    "bmyw.us",
    "bn373.top",
    "bnaishop.site",
    "bnb.monster",
    "bnb.nu",
    "bnbwarnet.com",
    "bnbx.email",
    "bnckms.cf",
    "bnckms.ga",
    "bnckms.gq",
    "bnckms.ml",
    "bnd.app",
    "bndapp.xyz",
    "bneorc.site",
    "bneus.club",
    "bnghdg545gdd.gq",
    "bngui.live",
    "bnimanchesternorth.com",
    "bnintl.com",
    "bnle844z.xyz",
    "bnmjhbkj.site",
    "bnote.com",
    "bntmvo.com",
    "bnuis.com",
    "bnv0qx4df0quwiuletg.cf",
    "bnv0qx4df0quwiuletg.ga",
    "bnv0qx4df0quwiuletg.gq",
    "bnv0qx4df0quwiuletg.ml",
    "bnv0qx4df0quwiuletg.tk",
    "bnwbrg.com",
    "bnxp5h.site",
    "bnyzw.info",
    "bo5e.icu",
    "bo7uolokjt7fm4rq.cf",
    "bo7uolokjt7fm4rq.ga",
    "bo7uolokjt7fm4rq.gq",
    "bo7uolokjt7fm4rq.ml",
    "bo7uolokjt7fm4rq.tk",
    "boabusinessfunding.com",
    "boacoco.cf",
    "boacoco.ga",
    "boacoco.gq",
    "boacoco.tk",
    "boaconsswal.tk",
    "boamericaadvrs.space",
    "boardbets90.net",
    "boardermail.com",
    "boarderzone.com",
    "boardroom.productions",
    "boardroom.video",
    "boardroommedia.asia",
    "boardscriptz.xyz",
    "boardshades.com",
    "boardtime.ru",
    "boarebec.cf",
    "boarebec.ga",
    "boarebec.gq",
    "boarebec.ml",
    "boastfusion.com",
    "boat59.website",
    "boater-x.com",
    "boatgypsys.info",
    "boating.page",
    "boatloanz.com",
    "boatmail.us",
    "boatmoon.com",
    "boatparty.today",
    "boatracers.com",
    "boatrentalsmarcoisland.com",
    "bobablast.com",
    "bobaetown.com",
    "bobandvikki.club",
    "bobashiping4.com",
    "bobashiping5.com",
    "bobasp123.com",
    "bobastore.site",
    "bobazy2.com",
    "bobazy3.com",
    "bobazy6.com",
    "bobazy8.com",
    "bobbal7.net",
    "bobbal9.net",
    "bobbohotel.online",
    "bobby-unique.ru",
    "bobcasino20.com",
    "bobisback.com",
    "bobmail.info",
    "bobmurchison.com",
    "bobocooler.com",
    "bobohieu.tk",
    "bobs.dyndns.org",
    "bobscellju.cf",
    "bobscellju.ga",
    "bobsdetice.ml",
    "bobtix.fun",
    "bobzc.com",
    "bocasartist.net",
    "bochkacraft.ru",
    "bochkovski.ru",
    "bocil.tk",
    "bodeproreview.com",
    "bodhi.lawlita.com",
    "bodlet.com",
    "bodmod.ga",
    "bodrumcozu0-180.com",
    "bodrumcozummilas.xyz",
    "bodrummixs.info",
    "bodrumsozluk.xyz",
    "bodybyrob.org",
    "bodycareshop.life",
    "bodyhackt.com",
    "bodyhealthyself.info",
    "bodylangaugela.com",
    "bodylasergranada.com",
    "bodylinedesign.com",
    "bodyshop.life",
    "bodystyle24.de",
    "bodywraps.us",
    "boee-property.com",
    "boeltehall.com",
    "boementers.ru",
    "boeogoxy.site",
    "boero.info",
    "boes.info",
    "bofamily.ru",
    "bofseme.ga",
    "bofseme.ml",
    "bofthew.com",
    "bofywyi.space",
    "bogalec.cf",
    "bogalec.ga",
    "bogalec.gq",
    "bogalec.ml",
    "bogalec.tk",
    "bogdad.com",
    "boggledosh.com",
    "bogiez.org",
    "bogir.club",
    "bogotaconf.co",
    "bogotadc.info",
    "bogsmoutlet.com",
    "bohani.cf",
    "bohani.ga",
    "bohani.gq",
    "bohani.ml",
    "bohani.tk",
    "bohead.com",
    "bohobuffet.com",
    "bohoce.xyz",
    "bohrer-shop.ru",
    "bohuilc.com",
    "boian.ru",
    "boijitogel.net",
    "boikasedon.ga",
    "boiler-stout.ru",
    "boimail.com",
    "boisebasketbrigade.com",
    "boisecityquote.com",
    "boisevirtual.tours",
    "bojagi.com",
    "bojcheski.dev",
    "bojiaman.com",
    "bojio.online",
    "bojiogame.net",
    "bojogalax.ga",
    "bokel.dev",
    "bokepmelayu.org",
    "bokepmovie.online",
    "bokilaspolit.tk",
    "boklipased.tk",
    "bokllhbehgw9.cf",
    "bokllhbehgw9.ga",
    "bokllhbehgw9.gq",
    "bokllhbehgw9.ml",
    "bokllhbehgw9.tk",
    "bokongindah.com",
    "boks.site",
    "boksclubibelieve.online",
    "bol.com.br",
    "bola208.com",
    "bola228run.com",
    "bola918.com",
    "bola918.net",
    "bola918.org",
    "bolaaman.com",
    "bolaeuro.com",
    "bolagemar.online",
    "bolahokiqq.club",
    "bolahokiqq.online",
    "bolaklikwin188.xyz",
    "bolaku88.xyz",
    "bolalogam.com",
    "bolalogam.online",
    "bolalogam.org",
    "bolamas88.online",
    "bolamivo.net",
    "bolando.com",
    "bolaparis.org",
    "bolaqq11.com",
    "bolaqq11.net",
    "bolaqq11.xyz",
    "bolasedot.com",
    "bolatmakine.xyz",
    "bolawd.org",
    "bolawinner88.org",
    "bold.ovh",
    "boldie.media",
    "boldlifemovement.com",
    "boldlygoingnowhere.org",
    "boldporpa.tk",
    "boldtechusa.com",
    "boletaelectronicachile.com",
    "bolinq.shop",
    "bolinylzc.com",
    "bolisad.com",
    "bollyastro.com",
    "bollywoodbabylon.com",
    "bollywoodu.com",
    "bollywoodz.com",
    "bolshakova-studio.ru",
    "bolshakovastudio.ru",
    "bolsherechye.ru",
    "bolt-bolt.info",
    "bolt-opt.info",
    "bolt.com",
    "bolt.net",
    "boltonfans.com",
    "bolususumerapi.com",
    "boluxman.xyz",
    "bombay-cuisine-carlow.com",
    "bombay-cuisine-takeaway.com",
    "bombay-tandoori-tralee.com",
    "bombayspeaks.com",
    "bombaytandooritakeaway.com",
    "bombdiggity.com",
    "bombermanba.com",
    "bombgovernorbrow.website",
    "bomboladielioperpalloncini.com",
    "bombshellbrewers.com",
    "bombsquad.com",
    "bomcodigo.com",
    "bommails.ml",
    "bomontifiltresiz.com",
    "bomprogram.com",
    "bomtool.com",
    "bon7.icu",
    "bon99.com",
    "bonagany.info",
    "bonbon.net",
    "bonce.site",
    "bonche-tobacco.ru",
    "boncoin.icu",
    "boncommunication.se",
    "bondageglossary.com",
    "bondageresources.com",
    "bondagesimulator.com",
    "bondbahis28.com",
    "bondbahis30.com",
    "bondlayer.net",
    "bondlayer.org",
    "bondmiamis.info",
    "bondrewd.cf",
    "boneng.us",
    "bonfireofthevanities.net",
    "bonfunrun15.site",
    "bongacams.buzz",
    "bongo.gq",
    "bongobank.net",
    "bongobongo.cf",
    "bongobongo.flu.cc",
    "bongobongo.ga",
    "bongobongo.gq",
    "bongobongo.igg.biz",
    "bongobongo.ml",
    "bongobongo.nut.cc",
    "bongobongo.tk",
    "bongobongo.usa.cc",
    "bongoperfectmatch.com",
    "bongopiggybank.com",
    "boniaqq.com",
    "bonicious.xyz",
    "bonkodi.com",
    "bonnellproject.org",
    "bono-777.com",
    "bonobo.email",
    "bonproduction.se",
    "bonus4betting.com",
    "bonusal.club",
    "bonusdominoonline.com",
    "bonusfreerub.ru",
    "bonuslier.ru",
    "bonusoil.ru",
    "bonussaati.site",
    "bonussaati.xyz",
    "bonvoyagetravelnetwork.com",
    "bonw.icu",
    "booaid.com",
    "boobies.pro",
    "boodschappenbezorgen.amsterdam",
    "boogiemunsters.com",
    "book-buzzes.com",
    "book316.com",
    "bookabus.org",
    "bookall.site",
    "bookat.us",
    "bookclick.online",
    "bookhotel.site",
    "booking-event.de",
    "booking-fr.pro",
    "bookingdiving.com",
    "bookingoasis.com",
    "bookingpricewatch.com",
    "bookings.onl",
    "bookingtouch.net",
    "bookingzagreb.com",
    "bookjumpstart.com",
    "bookkeepingitreal.com",
    "bookmabe.cf",
    "bookmabe.gq",
    "bookmabe.ml",
    "bookmarklali.win",
    "bookofhannah.com",
    "bookoneem.ga",
    "bookov.com",
    "bookpinyin.app",
    "bookpinyin.com",
    "bookquoter.com",
    "bookreviewessay.com",
    "booksahara.com",
    "booksdescr.xyz",
    "booksfusion.com",
    "booksmillion.best",
    "booksurvival.com",
    "booksworth.com",
    "booktangier.com",
    "bookthemmore.com",
    "bookthis.biz",
    "booktonlook.com",
    "booktoplady.com",
    "bookwithgeorge.com",
    "bookwrt.com",
    "bookyah.com",
    "bookyourhealer.com",
    "boolify.org",
    "booloo.xyz",
    "boom.com",
    "boomdate.xyz",
    "boomerangcentral.com",
    "boomm.site",
    "boomzik.com",
    "booneoutdoors.net",
    "boopmail.com",
    "boopmail.info",
    "boostingecosystems.org",
    "boostoid.com",
    "bootax.com",
    "bootkp8fnp6t7dh.cf",
    "bootkp8fnp6t7dh.ga",
    "bootkp8fnp6t7dh.gq",
    "bootkp8fnp6t7dh.ml",
    "bootkp8fnp6t7dh.tk",
    "bootlejtsh.space",
    "bootmail.com",
    "bootscootinmusic.com",
    "bootstrade.ru",
    "bootstrapdigitallab.com",
    "bootybay.de",
    "bootynbud.com",
    "boow.cf",
    "boow.ga",
    "boow.gq",
    "boow.ml",
    "boow.tk",
    "bopares.info",
    "boper.xyz",
    "bopra.xyz",
    "bopunkten.se",
    "boquetelifestyle.com",
    "boquetening.net",
    "boraa.xyz",
    "borakvalley.com",
    "boramotels.info",
    "borancaliskan.com",
    "boranora.com",
    "bordersequalzero.com",
    "bordslopare.se",
    "boredbin.com",
    "boreequationcare.website",
    "borged.com",
    "borged.net",
    "borged.org",
    "borgish.com",
    "bornagain.com",
    "bornnaked.com",
    "bornovaboran.xyz",
    "bornprettyjewels.xyz",
    "borntufftrainer.com",
    "boroda.tech",
    "borofans.com",
    "borsa-gayrimenkul.xyz",
    "borschoff.biz",
    "borsety.com",
    "borthutin.cf",
    "borthutin.ga",
    "borthutin.gq",
    "borthutin.ml",
    "borthutin.tk",
    "borwildchels.cf",
    "borwildchels.ga",
    "borwildchels.gq",
    "borwildchels.tk",
    "borza-takeaway.com",
    "borzacastleknock.com",
    "borzalaurellodge.com",
    "borzaparnell.com",
    "bos228.org",
    "bosbeer.best",
    "bosceme.fun",
    "bosceme.site",
    "bosceme.website",
    "bosceme.xyz",
    "bosch-ghg.online",
    "bosch-gpl.online",
    "bosch-pkp.online",
    "boscheasyvac.online",
    "boscialiquor.com",
    "bosdal.com",
    "boshuizen.org",
    "bosi.website",
    "bosific.ga",
    "bosific.gq",
    "bosific.tk",
    "bositoy.ru",
    "bosk1.live",
    "bosletak.com",
    "bosonology.com",
    "bospokers.net",
    "bosqq.mobi",
    "bosquesdeprovidencia.com",
    "bosrekan.com",
    "boss.cf",
    "bosscapsa.xyz",
    "bossceme.xyz",
    "bosscycling.com",
    "bossemail.info",
    "bossesin30s.com",
    "bossesin30seconds.com",
    "bossmail.de",
    "bossmail.ru",
    "bossofthemoss.com",
    "boston-towing-service.info",
    "bostoncocainerehab.com",
    "bostoncreampieco.com",
    "bostonheroinrehab.com",
    "bostonoffice.com",
    "bostonopiaterehab.com",
    "bostonplanet.com",
    "bostontshirtclub.com",
    "bostonwebmedia.com",
    "bot.nu",
    "botaksport.biz",
    "botaksport.net",
    "botal.live",
    "botanizes244tg.online",
    "botay.asia",
    "botcha.org",
    "botellon.website",
    "botenear.com",
    "bothelpdesk.com",
    "bothgames.com",
    "botig.xyz",
    "botinki-rus.site",
    "botkaislove.ru",
    "botkinalop.tk",
    "botrych.ru",
    "botseats.info",
    "botswana-finlife.com",
    "bottinifuels.com",
    "bottlacfue.gq",
    "bottlacfue.ml",
    "bottlacfue.tk",
    "bottlewood.com",
    "botz.online",
    "boudoirbible.com",
    "boudreauxproperties.com",
    "boulahia2.store",
    "boulderproblems.com",
    "boulonnerie-des-quatre-coins.com",
    "boun.cr",
    "boun.cr.",
    "bounce.net",
    "bouncebackcloud.com",
    "bounces.amazon.com",
    "bouncr.com",
    "bouncr.com.",
    "bouncygrape.com",
    "boundles.dev",
    "boundless.app",
    "boundless.deals",
    "boundlesscdn.com",
    "boundlesslabs.dev",
    "boundlesspoint.com",
    "bouquetslule.shop",
    "bourbonintheblind.com",
    "bourkeexecutivecoaching.com",
    "bournemouthfans.co.uk",
    "bournemouthitsolutions.com",
    "bouterkin.tk",
    "bouterpla.cf",
    "bouterpla.gq",
    "bouterpla.ml",
    "bouterpla.tk",
    "boutinc.shop",
    "boutique24.amsterdam",
    "boutiqueaccom.com",
    "boutiquehotelhanoi.com",
    "bovegas.casino",
    "bovinefu.com",
    "bovitin.cf",
    "bovitin.ga",
    "bovitin.gq",
    "bovitin.ml",
    "bovitin.tk",
    "bowelbac.site",
    "bowelkn.xyz",
    "bowelto.xyz",
    "boweltoot.xyz",
    "boweroitik.tk",
    "bowingkgcy.space",
    "bowrescom.org",
    "box.az",
    "box.comx.cf",
    "box.ua",
    "box.yadavnaresh.com.np",
    "box4mls.com",
    "boxaee.xyz",
    "boxbe.com",
    "boxbeats.com",
    "boxberru-pay.ru",
    "boxbg.com",
    "boxcoin-cach.ru",
    "boxemail.com",
    "boxerstore2019.ru",
    "boxescrow.com",
    "boxformail.in",
    "boxfrog.com",
    "boximail.com",
    "boxing55.com",
    "boxingcoalition.com",
    "boxless.info",
    "boxmail.co",
    "boxmail.lol",
    "boxppy.ru",
    "boxsquat.com",
    "boxtemp.com.br",
    "boxxbery.online",
    "boybanger.com",
    "boycey.space",
    "boycie.space",
    "boygenius.com",
    "boygenius.net",
    "boymail.ru",
    "boyracer.net",
    "boysbook.shop",
    "boytim.org",
    "boyu201.com",
    "boyu202.com",
    "boyu207.com",
    "boyzoneclub.com",
    "bozbu.xyz",
    "bp3xxqejba.cf",
    "bp3xxqejba.ga",
    "bp3xxqejba.gq",
    "bp3xxqejba.ml",
    "bp3xxqejba.tk",
    "bpapa.ooo",
    "bpb7l.us",
    "bpcenters.net",
    "bpcenters.org",
    "bpda.cn",
    "bpda.de",
    "bper.cf",
    "bper.ga",
    "bper.gq",
    "bper.tk",
    "bpfgaypi.shop",
    "bpham.info",
    "bpl10.club",
    "bpoint99.live",
    "bpornd.com",
    "bpospe.info",
    "bpqwnefou.com",
    "bpusqfze.xyz",
    "bpvi.cf",
    "bpvi.ga",
    "bpvi.gq",
    "bpvi.ml",
    "bpvi.tk",
    "bqc4tpsla73fn.cf",
    "bqc4tpsla73fn.ga",
    "bqc4tpsla73fn.gq",
    "bqc4tpsla73fn.ml",
    "bqc4tpsla73fn.tk",
    "bqcoffee.ru",
    "bqm2dyl.com",
    "br-plat.com",
    "br.mintemail.com",
    "br53dd.com",
    "br588.fun",
    "br5ns1.site",
    "br6qtmllquoxwa.cf",
    "br6qtmllquoxwa.ga",
    "br6qtmllquoxwa.gq",
    "br6qtmllquoxwa.ml",
    "br6qtmllquoxwa.tk",
    "br88.fun",
    "br88.mobi",
    "br88.trade",
    "br88bet.app",
    "br88helps.com",
    "br88thailand.com",
    "brad-haas.org",
    "bradan.space",
    "bradburntownhomes.com",
    "bradfordfans.com",
    "bradleedental.info",
    "bradypacha.com",
    "braginun.cf",
    "braginun.ml",
    "braginun.tk",
    "bragpackers.com",
    "bragstats.com",
    "braide.app",
    "brain-1-shoping.online",
    "brain-2-shoping.online",
    "brain-4-shoping.online",
    "brain-5-shoping.online",
    "brain-shop.online",
    "brain-shops.online",
    "braindollar.com",
    "brainframes.com",
    "brainfras.cf",
    "brainglue.com",
    "brainhacksonline.com",
    "brainonfire.net",
    "brainpowernootropics.xyz",
    "brains-market.online",
    "brains-shop.online",
    "brainsmix.com",
    "brainsworld.com",
    "braintsunami.com",
    "brainwave.media",
    "brainwire.co",
    "brakecu.xyz",
    "brakecups.info",
    "brakepai.site",
    "brakepl.xyz",
    "brakestor.icu",
    "brakeunc.xyz",
    "brakhman.ru",
    "braless.monster",
    "bramaros.cf",
    "bramaros.ga",
    "bramaros.gq",
    "bramaros.tk",
    "brambletyehomes.com",
    "bramblo.com",
    "bramper.ru",
    "branch.dating",
    "branchxijy.space",
    "brand-horse.ru",
    "brand-like.site",
    "brand-love.ru",
    "brand-sell.ru",
    "brandallday.net",
    "brandbaskit.com",
    "brandbaskit.net",
    "brandbaskit.org",
    "brandcrucial.com",
    "brandcruz.com",
    "brandednumber.com",
    "branden1121.club",
    "branding.ooo",
    "brandjamshop.com",
    "brandlandshop.com",
    "brandlinza.ru",
    "brandly.tech",
    "brandministers.com",
    "brandnameshirts.com",
    "brando.games",
    "brandonivey.info",
    "brandonivey.org",
    "brandonscody.live",
    "brandonstore.com",
    "brandonwhetsel.online",
    "brandroot.info",
    "brandroot.org",
    "brandroot.us",
    "brandroot.xyz",
    "brandsdigitalmedia.com",
    "brandslogisticgroup.com",
    "brandsvip.ru",
    "brandyouressence.com",
    "braninvi.cf",
    "brank.io",
    "branniganslaw.org",
    "bransonchoice.com",
    "brasbeeralcaladehenares.com",
    "brasilia.net",
    "brassbrush.biz",
    "brassbrush.org",
    "brassbrush.us",
    "brassbrushes.biz",
    "brassbrushes.org",
    "brassbrushes.us",
    "brasshardsgroup.com",
    "brassites.com",
    "brasx.org",
    "bratan.ru",
    "bratfond.ru",
    "bratwurst.dnsabr.com",
    "braun4email.com",
    "brave.chat",
    "braveblossom2023.com",
    "bravenewworkforce.us",
    "braveofheart.org",
    "braverish.com",
    "bravesite-info.ru",
    "braveworkforce.com",
    "bravod.ru",
    "brazilbites.com",
    "braziletech.com",
    "brazilmail.com",
    "brazilmail.com.br",
    "brdpkwcty.shop",
    "breach.icu",
    "breachofoath.com",
    "breackingnews.site",
    "bread-and-bones.com",
    "breadglossary.com",
    "breadnbuttershorttermplantrental.com",
    "breadqu.press",
    "breadshape.us",
    "breadtimes.press",
    "breadysmasamagrell.com",
    "break5.gq",
    "breakabal.ga",
    "breakabal.gq",
    "breakabal.ml",
    "breakaxpipilo.host",
    "breakfastnearme.net",
    "breakfastshop.life",
    "breakteala.gq",
    "breakteala.tk",
    "breakthru.com",
    "breaktime.space",
    "brearas.info",
    "breathe.com",
    "breatheandlivegood.com",
    "brecksneverstomac.com",
    "bredband.net",
    "bredimedia.xyz",
    "bredlau.com",
    "breemillsfilms.com",
    "breethase.cf",
    "breetiwe.cf",
    "breeze.eu.org",
    "brefmail.com",
    "brefmail.com.",
    "breitbandanbindung.de",
    "breizhmarechalerie.com",
    "brennanlc.com",
    "brennendesreich.de",
    "brennendesreich.de.",
    "brentchen.com",
    "brentr53-orthn.website",
    "brentstore.org",
    "brentwoodofficial.com",
    "bresanclin.cf",
    "bresanclin.gq",
    "bresanclin.ml",
    "bresanclin.tk",
    "bresnan.net",
    "bresslertech.com",
    "brestonline.com",
    "bretania.tk",
    "brevardgaragedoors.com",
    "brevnopen.ru",
    "brew-master.com",
    "brew-meister.com",
    "brewbuddies.website",
    "brewdin.com",
    "brewkraft.org",
    "brewplans.com",
    "brewposturecart.website",
    "brexitbet.com",
    "brexiten.com",
    "brflix.com",
    "brfree.com.br",
    "brgo.ru",
    "brhelwig.com",
    "brianandbarrybuchanan.com",
    "brianbell.biz",
    "brianclem.org",
    "briandavideoff.org",
    "briandbry.us",
    "brianeoff.com",
    "brianksims.com",
    "brianmcdaniel.org",
    "briarhillmontville.com",
    "brickgrabber.com",
    "brickoll.tk",
    "bricolagecheck.xyz",
    "bricsales.info",
    "bricsets.info",
    "bridalku.com",
    "bridavex.cf",
    "bridavex.gq",
    "bridavex.ml",
    "brides-dating.com",
    "bridescatalog.com",
    "brideselect.com",
    "bridesmailorder.com",
    "bridgecityseed.com",
    "bridgeportchicagobook.com",
    "bridgesacademysc.com",
    "bridgetgonzalez.win",
    "bridgetowneeast.com",
    "briefemail.com",
    "briefkasten2go.de",
    "brigachbreg.com",
    "briggsmarcus.com",
    "bright.net",
    "bright365.org",
    "brightbay.online",
    "brightdefense.net",
    "brightdefense.tech",
    "brightlighttouch.com",
    "brightonfans.co.uk",
    "brightscoe.com",
    "brightscoppe.com",
    "brigsgoevi.download",
    "brigthstorm.icu",
    "brilliantdashboard.cloud",
    "brillianthosting.cloud",
    "brilliantignite.com",
    "brilliantnews.live",
    "brilliantstarsschool.com",
    "brillionhistoricalsociety.com",
    "brillmed.com",
    "brillob.com",
    "bring-luck.pw",
    "bringluck.pw",
    "bringthatnumberdown.info",
    "bringthatnumberdown.org",
    "bringtheclick.com",
    "brinkbr.xyz",
    "brinkstor.xyz",
    "brisbanegastro.com",
    "brisbanelivemusic.com",
    "brisbanelogistics.com",
    "brisbanephotobooth.com",
    "bristlebrush.us",
    "bristlebrushes.biz",
    "bristlebrushes.us",
    "bristolroversfans.co.uk",
    "britbarnmi.ga",
    "britbarnmi.gq",
    "britbarnmi.ml",
    "britbarnmi.tk",
    "british-leyland.cf",
    "british-leyland.ga",
    "british-leyland.gq",
    "british-leyland.ml",
    "british-leyland.tk",
    "britishboy.com",
    "britishintelligence.co.uk",
    "britishpropolis.xyz",
    "britneyclub.com",
    "brittler.online",
    "brittlily.xyz",
    "brittneyamour.website",
    "brittneyhollinger.com",
    "brittneywerthcouseling.com",
    "brittonsign.com",
    "brk4dv.us",
    "brksqx.us",
    "brliffebody.host",
    "brliffebody.online",
    "brlotus.com",
    "brncanta.xyz",
    "brnhhqcya.shop",
    "brniesndrs.us",
    "brnm.me",
    "brnsndrs4.us",
    "brnsrs4.us",
    "bro.fund",
    "bro4xk.us",
    "broadbandninja.com",
    "broadbandninja.com.",
    "broadbandwiring.com",
    "broadcast.net",
    "broadcastsandiego.com",
    "broadman17.com",
    "broadnetalliance.org",
    "broadway-new-york-eatery.com",
    "broadwaybuff.com",
    "broadwaylove.com",
    "broadwaynewyorkeatery.com",
    "broadwaypackagingsolutions.com",
    "broccoli.store",
    "brocvintage.com",
    "brodwaybuzz.com",
    "brofamilys.ru",
    "broilone.com",
    "brokaler.ga",
    "brokaler.gq",
    "brokaler.ml",
    "brokaler.tk",
    "broke-it.net",
    "brokeandhappy.com",
    "brokenemailcheck.com",
    "brokenemailchecker.com",
    "brokenplanet.net",
    "brokenvalve.com",
    "brokersdoor.com",
    "broknote.com",
    "broknotes.com",
    "bromleydotcom.com",
    "bronaotdyhe.site",
    "bronews.ru",
    "bronhit.info",
    "bronix.ru",
    "bronxdentistny.com",
    "brookehorton.buzz",
    "brookewilson.buzz",
    "brookfieldplumbers.com",
    "brooklyn-camera.com",
    "brooklyn.cd",
    "brooklynparkapartments.com",
    "brookwalk.com",
    "broomavenuebr53bs.com",
    "broomwoodroadbr52jj.com",
    "broomwoodroadbr52jp.com",
    "brosbook.shop",
    "broshkindom.ru",
    "brossigscomp.cf",
    "brossigscomp.ga",
    "brossigscomp.gq",
    "brostream.net",
    "brotherprinterdrivershq.com",
    "brotvwxyz.com",
    "brous.ru",
    "browardfamp.com",
    "browebstore.ru",
    "brownbeaver.info",
    "browndril.us",
    "browne-trading.org",
    "brownes.info",
    "brownetrading.net",
    "brownetrading.org",
    "browniesgoreng.com",
    "brownieslumer.com",
    "brownlandscapingutah.com",
    "brownpelican.info",
    "brownricecooker.com",
    "brownsl.xyz",
    "brownslu.xyz",
    "brownsvillequote.com",
    "brownwoodtexasattorney.com",
    "browriter.world",
    "browse-movies.xyz",
    "browserflare.com",
    "browsertab.xyz",
    "browsesafesearch.com",
    "brqh.us",
    "brql.email",
    "brrmedia.asia",
    "brrra-infragrant.com",
    "brrvpuitu8hr.cf",
    "brrvpuitu8hr.ga",
    "brrvpuitu8hr.gq",
    "brrvpuitu8hr.ml",
    "brrvpuitu8hr.tk",
    "brrwd.com",
    "brtonthebridge.org",
    "bru-himki.ru",
    "bru.chat",
    "bruceguetta.com",
    "brudd.me",
    "brujula.net",
    "brunetka.ru",
    "brunhilde.ml",
    "brunico.best",
    "brunotakeaway.com",
    "brunto.ru",
    "brunty.com",
    "brushcros.icu",
    "brushes.org",
    "brushinabox.org",
    "brushmaker.net",
    "brushmaker.us",
    "brushmanufacturer.biz",
    "brushmanufacturer.us",
    "brushvwhite.com",
    "bruson.ru",
    "brusseler.com",
    "brussellottery.net",
    "brussellottery.org",
    "brusselstylelogblog.com",
    "brutaldate.com",
    "brutaljack.com",
    "brvbfj.shop",
    "brxqoy.cf",
    "bryanlgx.com",
    "bryanston.co.uk",
    "brymstonne.org",
    "brypeterson.com",
    "bryskumde.cf",
    "bryskumde.gq",
    "bryskumde.ml",
    "bryzwebcahw.ga",
    "bs-shipsmanagement.net",
    "bs5003.com",
    "bs6006.com",
    "bs6bjf8wwr6ry.cf",
    "bs6bjf8wwr6ry.ga",
    "bs6bjf8wwr6ry.gq",
    "bs6bjf8wwr6ry.ml",
    "bs8005.com",
    "bs8007.com",
    "bsaloving.com",
    "bsbhz1zbbff6dccbia.cf",
    "bsbhz1zbbff6dccbia.ga",
    "bsbhz1zbbff6dccbia.ml",
    "bsbhz1zbbff6dccbia.tk",
    "bschhirdavatcilik.site",
    "bsctoolkit.com",
    "bsdmail.com",
    "bsecure.ir",
    "bsesu.us",
    "bsezjuhsloctjq.cf",
    "bsezjuhsloctjq.ga",
    "bsezjuhsloctjq.gq",
    "bsezjuhsloctjq.ml",
    "bsezjuhsloctjq.tk",
    "bshoespeak.site",
    "bshyetrla.xyz",
    "bsjluitp.shop",
    "bsjnz.com",
    "bskbb.com",
    "bskvzhgskrn6a9f1b.cf",
    "bskvzhgskrn6a9f1b.ga",
    "bskvzhgskrn6a9f1b.gq",
    "bskvzhgskrn6a9f1b.ml",
    "bskvzhgskrn6a9f1b.tk",
    "bskyb.cf",
    "bskyb.ga",
    "bskyb.gq",
    "bskyb.ml",
    "bsmird.site",
    "bsml.de",
    "bsnders.us",
    "bsnmed.com",
    "bsnow.net",
    "bsoundbest.info",
    "bspamfree.org",
    "bspex.com",
    "bspin.club",
    "bspooky.com",
    "bsquochoai.ga",
    "bss19.space",
    "bsservice.info",
    "bst-72.com",
    "bsuakrqwbd.cf",
    "bsuakrqwbd.ga",
    "bsuakrqwbd.gq",
    "bsuakrqwbd.ml",
    "bsuakrqwbd.tk",
    "bsylyp.shop",
    "bt-bitcoin.ru",
    "bt.com",
    "bt0zvsvcqqid8.cf",
    "bt0zvsvcqqid8.ga",
    "bt0zvsvcqqid8.gq",
    "bt0zvsvcqqid8.ml",
    "bt0zvsvcqqid8.tk",
    "bt2022.xyz",
    "bt2pt.com",
    "bt3019k.com",
    "bt369.live",
    "bt757.site",
    "btab.pw",
    "btacg.com",
    "btapi.com",
    "btb-notes.com",
    "btb109.online",
    "btb11.xyz",
    "btb46.club",
    "btbazir.xyz",
    "btbaziran.xyz",
    "btbt588.com",
    "btc-mail.net",
    "btc-worldl.site",
    "btc.email",
    "btcanalizler.com",
    "btcc.org",
    "btchange.xyz",
    "btcmail.pw",
    "btcmod.com",
    "btcomic.com",
    "btconnect.co.uk",
    "btconnect.com",
    "btcontracts.com",
    "btcoon.info",
    "btcoon.org",
    "btcplay777.com",
    "btcprestige.net",
    "btcpurchases.site",
    "btd4p9gt21a.cf",
    "btd4p9gt21a.ga",
    "btd4p9gt21a.gq",
    "btd4p9gt21a.ml",
    "btd4p9gt21a.tk",
    "bteditor.com",
    "btemp.com",
    "btexch.com",
    "btexchange1.live",
    "btgal.com",
    "btglkf.com",
    "btgmka0hhwn1t6.cf",
    "btgmka0hhwn1t6.ga",
    "btgmka0hhwn1t6.ml",
    "btgmka0hhwn1t6.tk",
    "btgo90us.net",
    "btgo90us.org",
    "btgt.email",
    "bti.com",
    "bticigd.xyz",
    "btintenet.com",
    "btinternet.com",
    "btizet.pl",
    "btmoe.com",
    "btmtoon4.com",
    "btmtoon6.com",
    "btob6.club",
    "btopenworld.co.uk",
    "btopenworld.com",
    "btqingwa.xyz",
    "btrabbits.net",
    "btracker.date",
    "btrkwbtfclb89bd.xyz",
    "btrmp6.com",
    "btry56.us",
    "bts-888.com",
    "bts-monitoring.com",
    "btsmerch.shop",
    "btstr.lowbi.xyz",
    "bttime44.xyz",
    "bttime55.xyz",
    "btuglp.us",
    "btukskkzw8z.cf",
    "btukskkzw8z.ga",
    "btukskkzw8z.gq",
    "btukskkzw8z.ml",
    "btukskkzw8z.tk",
    "btv8uy.info",
    "btw.onl",
    "btx3338.com",
    "btx62828.com",
    "btxdtl.ga",
    "btynodozx.shop",
    "btyunsou8.net",
    "btz3kqeo4bfpqrt.cf",
    "btz3kqeo4bfpqrt.ga",
    "btz3kqeo4bfpqrt.ml",
    "btz3kqeo4bfpqrt.tk",
    "bu-ali-takeaway.com",
    "bu.mintemail.com",
    "bu5lhm.info",
    "buam.space",
    "buatwini.tk",
    "buayapoker.online",
    "buayapoker.xyz",
    "bub7yjt5p0uzewl.xyz",
    "bubbasblue.com",
    "bubbkirkpenma.tk",
    "bubblesfloat.com",
    "bubo1.net",
    "bubuface.tv",
    "bucausa.xyz",
    "bucbdlbniz.cf",
    "bucbdlbniz.ga",
    "bucbdlbniz.gq",
    "bucbdlbniz.ml",
    "bucbdlbniz.tk",
    "buccalmassage.ru",
    "buchhandlung24.com",
    "bucketlistfilter.com",
    "bucklafi.cf",
    "bucklafi.ga",
    "bucklafi.gq",
    "bucklafi.tk",
    "buckleysryewhiskey.com",
    "buckrubs.us",
    "bucoscertificate.com",
    "bucoscertificate.pro",
    "bucrita.cf",
    "bucrita.gq",
    "bucrita.ml",
    "bucsc.com",
    "bud-zdorov-03.site",
    "bud-zdorov-07.site",
    "budapest2040.com",
    "budapestdailydeal.com",
    "budaya-tionghoa.com",
    "budayationghoa.com",
    "buddhismglobal.com",
    "buddhistblog.com",
    "buddieswindsor.com",
    "budgeequal.us",
    "budgemars.icu",
    "budgequot.press",
    "budgetdoc.com",
    "budgetgoods.ru",
    "budgetinvestingsite.online",
    "budgetmoscow.com",
    "budgetocean.com",
    "budgjhdh73ctr.gq",
    "budin.men",
    "budmedia.fund",
    "budokainc.com",
    "budtek.info",
    "budylz.xyz",
    "budzdorov-03.site",
    "budzdorov-07.site",
    "budzdorov07.site",
    "buenavidabeograd.com",
    "buenosaireslottery.com",
    "buerotiger.de",
    "bufaloie.site",
    "bufbootcamp.com",
    "buffaloaddictiontreatment.com",
    "buffaloalcoholrehab.com",
    "buffaloopiaterehab.com",
    "buffaloquote.com",
    "buffalorunwinery.com",
    "buffalos-pizza-pie.com",
    "buffbook.shop",
    "buffemail.com",
    "bufferliajy.email",
    "buffymail.com",
    "buford.us.to",
    "bufyrjkdhu.xyz",
    "bug.cl",
    "bugeyedbugs.com",
    "bugmenever.com",
    "bugmenot.com",
    "bugmenot.ml",
    "buhogume.site",
    "buhomail.club",
    "bui-in-samara.ru",
    "buicasino.ru",
    "buidaru.cf",
    "buidaru.ga",
    "buidaru.tk",
    "build-logix.com",
    "buildadefense.com",
    "buildersglossary.com",
    "builderua.online",
    "building-bridges.com",
    "buildingandtech.com",
    "buildlogicsllc.com",
    "buildly.store",
    "buildmydream.kitchen",
    "buildthefutureon.tech",
    "buildwithbubble.com",
    "buildwithdrupal9.com",
    "buinasrad.ml",
    "buissness.com",
    "bujatv7.fun",
    "bujatv8.fun",
    "buk2fw.host",
    "bukalapakqq.club",
    "bukansarjana.com",
    "buketeriya.ru",
    "buketgurmana.ru",
    "bukleti-vizitki.ru",
    "bukmekerskajakontora.ru",
    "bukopet.ru",
    "bukuki.info",
    "bukwos7fp2glo4i30.cf",
    "bukwos7fp2glo4i30.ga",
    "bukwos7fp2glo4i30.gq",
    "bukwos7fp2glo4i30.ml",
    "bukwos7fp2glo4i30.tk",
    "bulaindianandorientalcuisine.com",
    "bulantoto.com",
    "bulantoto.net",
    "bulbasures.com",
    "buldozer-rent92.ru",
    "bulgaria.com",
    "bulgarian.house",
    "bulgogi.xyz",
    "bulgsaltge.gq",
    "bulgsaltge.ml",
    "bulgsaltge.tk",
    "bulguru.com",
    "bulkcleancheap.com",
    "bulkgeocode.com",
    "bullbeer.net",
    "bullbeer.org",
    "bulletinadvice.com",
    "bulleyedarts.com",
    "bullinthesport.com",
    "bullosafe.com",
    "bullseyelink.com",
    "bullseyewebsitedesigns.com",
    "bullsfan.com",
    "bullsgame.com",
    "bullstore.net",
    "bulltime.net",
    "bullystakeaway.com",
    "bulmisen.ga",
    "bulmisen.gq",
    "bulmisen.ml",
    "bulmp3.net",
    "bulrushpress.com",
    "bulumonster.com",
    "bulurhotels.site",
    "bulutdns.com",
    "bulvintorg.ru",
    "bum.net",
    "bum05.xyz",
    "bum06.xyz",
    "bum07.xyz",
    "bum08.xyz",
    "bum09.xyz",
    "bum69.club",
    "bumaga.host",
    "bumbleevbx.space",
    "bumblomti.cf",
    "bumblomti.gq",
    "bumerang.ro",
    "bumingjueli.com",
    "bumppack.com",
    "bumpymail.com",
    "bumrap.com",
    "bun-cha.com",
    "bunbearsligh.gq",
    "buncar.ru",
    "bunchcarsa.info",
    "bunchofidiots.com",
    "bund.us",
    "bundes-li.ga",
    "bundjoca.cf",
    "bundjoca.ga",
    "bundjoca.gq",
    "bundjoca.ml",
    "bunengbumingbai.com",
    "bungabunga.cf",
    "bungatidur.com",
    "bungatogel8.com",
    "bunita.net",
    "bunkmemorialcave.website",
    "bunko.com",
    "bunmoc.website",
    "bunny88vip.com",
    "bunnyhasofficiallypissedoffgreengay.tk",
    "bunnysitesqa.com",
    "bunnyze.info",
    "bunsenhoneydew.com",
    "bunteks.online",
    "buntuty.cf",
    "buntuty.ga",
    "buntuty.ml",
    "buon.club",
    "buphisti.tk",
    "buppel.com",
    "buqre.online",
    "buqre.xyz",
    "burakarda.xyz",
    "buratin7.ru",
    "burcler.site",
    "burdet.xyz",
    "burdurfm.xyz",
    "burenie.space",
    "bureslav.ru",
    "burgas.vip",
    "burgaznet.xyz",
    "burger56.ru",
    "burgercentral.us",
    "burgerjointtakeaway.com",
    "burglighhu.ml",
    "burgoscatchphrase.com",
    "burguesinhas.com",
    "burjkhalifarent.com",
    "burkaukra2.site",
    "burklabs.com",
    "burlingtonxku.com",
    "burner-email.com",
    "burner.fund",
    "burnermail.io",
    "burningasylum.net",
    "burnleyfans.co.uk",
    "burnmail.ca",
    "burnthespam.info",
    "burntmail.com",
    "burritos.ninja",
    "burry.house",
    "bursadekorhaliyikama.online",
    "bursadekorhaliyikama.xyz",
    "bursaevlilikterapisi.com",
    "bursahealth.com",
    "bursakomoditi.xyz",
    "bursaservis.site",
    "bursayolu.xyz",
    "burstmail.info",
    "burtsevy.ru",
    "burundipools.com",
    "burundxkpt.space",
    "burwide.cf",
    "burwide.gq",
    "burwide.tk",
    "buryfans.com",
    "buryticklerchap.website",
    "burzoe.website",
    "bus9alizaxuzupeq3rs.cf",
    "bus9alizaxuzupeq3rs.ga",
    "bus9alizaxuzupeq3rs.gq",
    "bus9alizaxuzupeq3rs.ml",
    "bus9alizaxuzupeq3rs.tk",
    "buscarltd.com",
    "buscarnombre.com",
    "buschgardenshotel.com",
    "buscoempleoya.info",
    "busemdisticaret.com",
    "bushemail.com",
    "bushiresydney.company",
    "bushnellofficial.ru",
    "busidevelops.com",
    "business-agent.info",
    "business-bank-account.com",
    "business-education-system.com",
    "business-goods.ru",
    "business-man.com",
    "business-tv.site",
    "business-tv.website",
    "business-websites-hosting.us",
    "businessaccelerationevents.com",
    "businessagent.email",
    "businessandnews.com",
    "businessattorneysorangecounty.com",
    "businessbackend.com",
    "businessbayproperty.com",
    "businesscny.com",
    "businesscoachitalia.net",
    "businessconstruction.ru",
    "businesscredit.xyz",
    "businesscreditcard.dev",
    "businesselite.site",
    "businessfindernearme.com",
    "businessgig.org",
    "businessmakeoverexperience.com",
    "businessman.net",
    "businessmexicotoday.com",
    "businessowner.money",
    "businessphonelookup.com",
    "businessresourcefindernearme.com",
    "businessscansite.club",
    "businesssitenames.com",
    "businesssource.net",
    "businesssuccessislifesuccess.com",
    "businessvendorsnearme.com",
    "businessweekmail.com",
    "buskingbarangaroo.com",
    "busmys.info",
    "buspad.org",
    "bussdisc.com",
    "bussinessmonkeynews.com",
    "bussinesvortex.ru",
    "bussitussi.com",
    "bussitussi.net",
    "bust.com",
    "busta-rhymes.com",
    "bustedyoke.com",
    "busten.info",
    "busten.site",
    "busthere.ml",
    "bustsa.site",
    "busty.monster",
    "busymail.com",
    "busymail.com.com",
    "busymail.comhomeart.com",
    "butch-femme.net",
    "buthec.xyz",
    "butler.edu",
    "butler411.com",
    "butning.ru",
    "butovo.net",
    "butrew.ru",
    "buttbreeder.com",
    "butter9x.com",
    "butterflycupsusa.com",
    "butterflyeffectsounds.com",
    "butterteddy.ru",
    "buttluvr.com",
    "buttonfans.com",
    "buumew-auto.ru",
    "buvertu.ga",
    "buvertu.gq",
    "buvertu.ml",
    "buxap.com",
    "buxl.com",
    "buxod.com",
    "buy-acomplia.info",
    "buy-car.net",
    "buy-cialis.net",
    "buy-iphone-xs.ru",
    "buy-lp.ru",
    "buy-new-like.ru",
    "buy-ugly-homes.com",
    "buy003.com",
    "buy024.com",
    "buy4me.store",
    "buyad.ru",
    "buyalli.site",
    "buyallopurinol.website",
    "buyamf.com",
    "buyatenolol.website",
    "buyaugmentin.site",
    "buyback.best",
    "buybere.cf",
    "buybere.ga",
    "buybere.ml",
    "buybere.tk",
    "buyblindsnow.com",
    "buycbd2.com",
    "buycialisgennrx.xyz",
    "buycialisz.xyz",
    "buycow.org",
    "buycsgoitems.com",
    "buyday.site",
    "buydfcat9893lk.cf",
    "buydiamox.info",
    "buydispensary.icu",
    "buydubaimarinaproperty.com",
    "buyeqaslim.com",
    "buyersusa.com",
    "buygapfashion.com",
    "buygolfclubscanada.com",
    "buyhousesquickcash.com",
    "buyitforlife.app",
    "buykamagraquick.com",
    "buykyc.com",
    "buylevitra.website",
    "buymethotrexate.info",
    "buymoreplays.com",
    "buymotocyclefairings.com",
    "buymotors.online",
    "buynewtrends.com",
    "buynorcaltickets.com",
    "buynow.host",
    "buyordie.info",
    "buyovz.com",
    "buyprice.co",
    "buyrehabrentrefinancerepeat.com",
    "buyselleos.com",
    "buyseo.services",
    "buyserverpart.com",
    "buyshouses.net",
    "buyspecs.biz",
    "buystlouischeap.com",
    "buyto.website",
    "buytodayproperties.com",
    "buyu0111.com",
    "buyu043.com",
    "buyu046.com",
    "buyu0590.com",
    "buyu082.com",
    "buyu085.com",
    "buyu112.com",
    "buyu117.com",
    "buyu126.com",
    "buyu135.com",
    "buyu139.com",
    "buyu148.com",
    "buyu150.com",
    "buyu153.com",
    "buyu154.com",
    "buyu167.com",
    "buyu172.com",
    "buyu174.com",
    "buyu181.com",
    "buyu182.com",
    "buyu183.com",
    "buyu184.com",
    "buyu190.com",
    "buyu191.com",
    "buyu194.com",
    "buyu199.com",
    "buyu282.com",
    "buyu284.com",
    "buyu286.com",
    "buyu289.com",
    "buyu299.com",
    "buyu304.com",
    "buyu307.com",
    "buyu308.com",
    "buyu310.com",
    "buyu316.com",
    "buyu317.com",
    "buyu319.com",
    "buyu323.com",
    "buyu325.com",
    "buyu336.com",
    "buyu341.com",
    "buyu343.com",
    "buyu345.com",
    "buyu347.com",
    "buyu348.com",
    "buyu368.com",
    "buyu373.com",
    "buyu376.com",
    "buyu377.com",
    "buyu380.com",
    "buyu383.com",
    "buyu387.com",
    "buyu389.com",
    "buyu391.com",
    "buyu398.com",
    "buyu403.com",
    "buyu406.com",
    "buyu407.com",
    "buyu408.com",
    "buyu415.com",
    "buyu416.com",
    "buyu420.com",
    "buyu421.com",
    "buyu422.com",
    "buyu423.com",
    "buyu424.com",
    "buyu427.com",
    "buyu428.com",
    "buyu431.com",
    "buyu434.com",
    "buyu443.com",
    "buyu446.com",
    "buyu447.com",
    "buyu450.com",
    "buyu451.com",
    "buyu455.com",
    "buyu457.com",
    "buyu460.com",
    "buyu465.com",
    "buyu471.com",
    "buyu473.com",
    "buyu476.com",
    "buyu477.com",
    "buyu479.com",
    "buyu481.com",
    "buyu483.com",
    "buyu486.com",
    "buyu489.com",
    "buyu490.com",
    "buyu491.com",
    "buyu492.com",
    "buyu493.com",
    "buyu494.com",
    "buyu495.com",
    "buyu496.com",
    "buyu502.com",
    "buyu508.com",
    "buyu515.com",
    "buyu523.com",
    "buyu529.com",
    "buyu532.com",
    "buyu533.com",
    "buyu538.com",
    "buyu540.com",
    "buyu543.com",
    "buyu544.com",
    "buyu548.com",
    "buyu552.com",
    "buyu564.com",
    "buyu567.com",
    "buyu571.com",
    "buyu573.com",
    "buyu581.com",
    "buyu583.com",
    "buyu585.com",
    "buyu586.com",
    "buyu587.com",
    "buyu592.com",
    "buyu594.com",
    "buyu596.com",
    "buyu610.com",
    "buyu612.com",
    "buyu614.com",
    "buyu616.com",
    "buyu620.com",
    "buyu621.com",
    "buyu626.com",
    "buyu627.com",
    "buyu628.com",
    "buyu629.com",
    "buyu631.com",
    "buyu632.com",
    "buyu634.com",
    "buyu639.com",
    "buyu642.com",
    "buyu645.com",
    "buyu652.com",
    "buyu653.com",
    "buyu654.com",
    "buyu657.com",
    "buyu661.com",
    "buyu662.com",
    "buyu663.com",
    "buyu676.com",
    "buyu680.com",
    "buyu684.com",
    "buyu687.com",
    "buyu690.com",
    "buyu697.com",
    "buyu699.com",
    "buyu730.com",
    "buyu734.com",
    "buyu739.com",
    "buyu745.com",
    "buyu746.com",
    "buyu747.com",
    "buyu751.com",
    "buyu752.com",
    "buyu756.com",
    "buyu757.com",
    "buyu761.com",
    "buyu772.com",
    "buyu775.com",
    "buyu779.com",
    "buyu781.com",
    "buyu784.com",
    "buyu790.com",
    "buyu794.com",
    "buyu795.com",
    "buyu802.com",
    "buyu803.com",
    "buyu807.com",
    "buyu811.com",
    "buyu814.com",
    "buyu816.com",
    "buyu826.com",
    "buyu827.com",
    "buyu828.com",
    "buyu829.com",
    "buyu830.com",
    "buyu831.com",
    "buyu836.com",
    "buyu841.com",
    "buyu843.com",
    "buyu849.com",
    "buyu852.com",
    "buyu855.com",
    "buyu857.com",
    "buyu859.com",
    "buyu883.com",
    "buyu887.com",
    "buyu893.com",
    "buyu894.com",
    "buyu896.com",
    "buyu897.com",
    "buyu901.com",
    "buyu913.com",
    "buyu920.com",
    "buyu924.com",
    "buyu925.com",
    "buyu926.com",
    "buyu930.com",
    "buyu931.com",
    "buyu932.com",
    "buyu935.com",
    "buyu939.com",
    "buyu947.com",
    "buyu950.com",
    "buyu951.com",
    "buyu952.com",
    "buyu953.com",
    "buyu954.com",
    "buyu959.com",
    "buyu960.com",
    "buyu963.com",
    "buyu967.com",
    "buyukbetbayi5.com",
    "buyukcekmeceesnaflari.xyz",
    "buyurightnow.com",
    "buyusedlibrarybooks.org",
    "buyvaltrexonline.store",
    "buyvpn.xyz",
    "buywowgold2.com",
    "buyyourtoledohome.com",
    "buzlat.org",
    "buzy.com",
    "buzzcluby.com",
    "buzzcompact.com",
    "buzzdimo.com",
    "buzzvirale.xyz",
    "buzzzyaskz.site",
    "bv2mpm.us",
    "bvictor3.org",
    "bvigo.com",
    "bvimailbox.com",
    "bvitamini.site",
    "bvkn04.us",
    "bvndah.club",
    "bvqaaivso.shop",
    "bvqk.email",
    "bvs93v.us",
    "bvtravelnews.com",
    "bvuathletics.org",
    "bvz8k1.us",
    "bvzoonm.com",
    "bwa33.net",
    "bwcfn1.site",
    "bwgworldwide.com",
    "bwjdk1.site",
    "bwltir.com",
    "bwnkwx.site",
    "bwtdmail.com",
    "bwwsrvvff3wrmctx.cf",
    "bwwsrvvff3wrmctx.ga",
    "bwwsrvvff3wrmctx.gq",
    "bwwsrvvff3wrmctx.ml",
    "bwwsrvvff3wrmctx.tk",
    "bwww.icu",
    "bx6r9q41bciv.cf",
    "bx6r9q41bciv.ga",
    "bx6r9q41bciv.gq",
    "bx6r9q41bciv.ml",
    "bx6r9q41bciv.tk",
    "bx800.site",
    "bx8w34.us",
    "bx9puvmxfp5vdjzmk.cf",
    "bx9puvmxfp5vdjzmk.ga",
    "bx9puvmxfp5vdjzmk.gq",
    "bx9puvmxfp5vdjzmk.ml",
    "bx9puvmxfp5vdjzmk.tk",
    "bxbjq.site",
    "bxbsale.top",
    "bxfmtktkpxfkobzssqw.cf",
    "bxfmtktkpxfkobzssqw.ga",
    "bxfmtktkpxfkobzssqw.gq",
    "bxfmtktkpxfkobzssqw.ml",
    "bxfmtktkpxfkobzssqw.tk",
    "bxis.email",
    "bxm2bg2zgtvw5e2eztl.cf",
    "bxm2bg2zgtvw5e2eztl.ga",
    "bxm2bg2zgtvw5e2eztl.gq",
    "bxm2bg2zgtvw5e2eztl.ml",
    "bxm2bg2zgtvw5e2eztl.tk",
    "bxs1yqk9tggwokzfd.cf",
    "bxs1yqk9tggwokzfd.ga",
    "bxs1yqk9tggwokzfd.ml",
    "bxs1yqk9tggwokzfd.tk",
    "by-akg.online",
    "by-who.com",
    "by7au1.us",
    "by8006l.com",
    "by8hw.us",
    "by9827.com",
    "bybe.site",
    "bybike.com",
    "bycollective.com",
    "bydenyingh.icu",
    "byebyemail.com",
    "byedacetin.net",
    "byel.email",
    "byespm.com",
    "byeworker.best",
    "byfstg.com",
    "bygga-infrabastu.se",
    "byhabeo.space",
    "byhouse.icu",
    "byke.com",
    "bykefu.online",
    "bykefu.site",
    "bykefu.xyz",
    "bykov-stroj.ru",
    "bykuzen.xyz",
    "bymahades.com",
    "byng.de",
    "byngo.com",
    "bynyqs.com",
    "byom.de",
    "bypebbles.info",
    "bypebbles.net",
    "byporax.live",
    "byq85.com",
    "byredo-parfums.online",
    "byribu.info",
    "byrostudios.com",
    "bytegift.com",
    "byteleaders.amsterdam",
    "byteme.com",
    "bythewater.net",
    "bytik-flower.ru",
    "byukgztw.shop",
    "byustore.xyz",
    "byviuz.site",
    "byw2288.com",
    "byw3388.com",
    "byw4488.com",
    "byw5588.com",
    "bz-365e.com",
    "bz-555.com",
    "bz-888.com",
    "bz-cons.ru",
    "bz-mytyshi.ru",
    "bzdkx.us",
    "bzhso1.info",
    "bzidohaoc3k.cf",
    "bzidohaoc3k.ga",
    "bzidohaoc3k.gq",
    "bzidohaoc3k.ml",
    "bzidohaoc3k.tk",
    "bzmoe.com",
    "bzmt6ujofxe3.cf",
    "bzmt6ujofxe3.ga",
    "bzmt6ujofxe3.gq",
    "bzmt6ujofxe3.ml",
    "bzmt6ujofxe3.tk",
    "bzmxeu.us",
    "bzof89lyd3lfy51.xyz",
    "bzone-111.com",
    "bzone-777.com",
    "bzone234.com",
    "bzone555.com",
    "bztf1kqptryfudz.cf",
    "bztf1kqptryfudz.ga",
    "bztf1kqptryfudz.gq",
    "bztf1kqptryfudz.ml",
    "bztf1kqptryfudz.tk",
    "bztravogd.shop",
    "bzujd1.site",
    "bzymail.top",
    "c-14.cf",
    "c-14.ga",
    "c-14.gq",
    "c-14.ml",
    "c-c-p.de",
    "c-mail.cf",
    "c-mail.gq",
    "c-mail.online",
    "c-newstv.ru",
    "c-onetv.com",
    "c-responses.org",
    "c-resultsfitness.com",
    "c-wrench.com",
    "c.alabamavape.com",
    "c.andreihusanu.ro",
    "c.dk",
    "c.hcac.net",
    "c.kadag.ir",
    "c.kerl.gq",
    "c.nut.emailfake.nut.cc",
    "c.theplug.org",
    "c.wlist.ro",
    "c002hwpf.buzz",
    "c005qmdb.buzz",
    "c006mpkz.buzz",
    "c008ydwu.buzz",
    "c009fkiu.buzz",
    "c012tury.buzz",
    "c013dikj.buzz",
    "c014irpp.buzz",
    "c015smno.buzz",
    "c016bkmw.buzz",
    "c017dkop.buzz",
    "c018jplo.buzz",
    "c021gtyp.buzz",
    "c022byui.buzz",
    "c023gsrk.buzz",
    "c024kius.buzz",
    "c025gsik.buzz",
    "c026dkrn.buzz",
    "c028fsok.buzz",
    "c029ekbb.buzz",
    "c031bbjr.buzz",
    "c032bjik.buzz",
    "c033vusm.buzz",
    "c034hkdv.buzz",
    "c036hsrp.buzz",
    "c037sjut.buzz",
    "c044vhju.buzz",
    "c048bhos.buzz",
    "c049lrdf.buzz",
    "c0cka.info",
    "c0d.club",
    "c0lkp4.us",
    "c0rtana.cf",
    "c0rtana.ga",
    "c0rtana.gq",
    "c0rtana.ml",
    "c0rtana.tk",
    "c0sau0gpflgqv0uw2sg.cf",
    "c0sau0gpflgqv0uw2sg.ga",
    "c0sau0gpflgqv0uw2sg.gq",
    "c0sau0gpflgqv0uw2sg.ml",
    "c0sau0gpflgqv0uw2sg.tk",
    "c1101.club",
    "c1775.com",
    "c17d.club",
    "c1b842.xyz",
    "c1er4u.site",
    "c1jlpo.us",
    "c1obm.icu",
    "c1oramn.com",
    "c1yyad.us",
    "c2.hu",
    "c20vussj1j4glaxcat.cf",
    "c20vussj1j4glaxcat.ga",
    "c20vussj1j4glaxcat.gq",
    "c20vussj1j4glaxcat.ml",
    "c20vussj1j4glaxcat.tk",
    "c21rd.site",
    "c2ccams.com",
    "c2csoft.com",
    "c2i.net",
    "c2nu8i.us",
    "c3.hu",
    "c306bb.com",
    "c306ccc.com",
    "c306dd.com",
    "c306e.com",
    "c306f.com",
    "c306ggg.com",
    "c306h.com",
    "c306hhh.com",
    "c306i.com",
    "c306ii.com",
    "c306mmm.com",
    "c306n.com",
    "c306nnn.com",
    "c306ooo.com",
    "c306qqq.com",
    "c306u.com",
    "c306vv.com",
    "c32tr.site",
    "c3cyt.info",
    "c3e3r7qeuu.cf",
    "c3e3r7qeuu.ga",
    "c3e3r7qeuu.gq",
    "c3e3r7qeuu.ml",
    "c3e3r7qeuu.tk",
    "c3email.win",
    "c3gn9t.us",
    "c3jsw.com",
    "c3rodc.info",
    "c4.com",
    "c40eh.site",
    "c4anec0wemilckzp42.ga",
    "c4anec0wemilckzp42.ml",
    "c4anec0wemilckzp42.tk",
    "c4e34ad.club",
    "c4fe4d1.club",
    "c4jie.us",
    "c4ster.gq",
    "c4u0tn.us",
    "c4ugr9.us",
    "c4utar.cf",
    "c4utar.ga",
    "c4utar.gq",
    "c4utar.ml",
    "c4utar.tk",
    "c51vsgq.com",
    "c520p.com",
    "c52fp4.info",
    "c52p.com",
    "c59io.site",
    "c5a7342v.xyz",
    "c5ccwcteb76fac.cf",
    "c5ccwcteb76fac.ga",
    "c5ccwcteb76fac.gq",
    "c5ccwcteb76fac.ml",
    "c5ccwcteb76fac.tk",
    "c5qawa6iqcjs5czqw.cf",
    "c5qawa6iqcjs5czqw.ga",
    "c5qawa6iqcjs5czqw.gq",
    "c5qawa6iqcjs5czqw.ml",
    "c5qawa6iqcjs5czqw.tk",
    "c60vy.top",
    "c6384.com",
    "c63e.com",
    "c63f.com",
    "c63i.com",
    "c63j.com",
    "c63o.com",
    "c63r.com",
    "c63t.com",
    "c63u.com",
    "c63v.com",
    "c64c6d29.club",
    "c6760db2.club",
    "c68e210.xyz",
    "c6bc07a3.xyz",
    "c6ebii.us",
    "c6h12o6.cf",
    "c6h12o6.ga",
    "c6h12o6.gq",
    "c6h12o6.ml",
    "c6h12o6.tk",
    "c70456.com",
    "c70654.com",
    "c70jm.site",
    "c72iv.space",
    "c72zc.com",
    "c73cd.space",
    "c74pf8.us",
    "c74pt.space",
    "c7665.com",
    "c7fk799.com",
    "c7z3dxb81xns6bz.xyz",
    "c81hofab1ay9ka.cf",
    "c81hofab1ay9ka.ga",
    "c81hofab1ay9ka.gq",
    "c81hofab1ay9ka.ml",
    "c81hofab1ay9ka.tk",
    "c82323.com",
    "c84ih.site",
    "c88987.club",
    "c89taj.info",
    "c8hwap.com",
    "c8pz34.download",
    "c8tdau.us",
    "c99.me",
    "c9ra1v.site",
    "ca.rr.com",
    "ca.verisign.cf",
    "ca.verisign.ga",
    "ca.verisign.gq",
    "ca11.cf",
    "ca203k.com",
    "ca5934ec.club",
    "caadroneregistration.com",
    "caadroneregistry.com",
    "caaspi.live",
    "cab22.com",
    "cab2f8.club",
    "cabacabana.com",
    "caballo-blanco.com",
    "caballosonline.net",
    "cabalpeerage.space",
    "cabddisque.cf",
    "cabddisque.ga",
    "cabddisque.ml",
    "cabekeriting99.com",
    "cabela.ru",
    "cabildocongo.com",
    "cabinet-74.ru",
    "cabinet-benedikt.com",
    "cabinet-valerie-alonso.com",
    "cabinmirosy.info",
    "cable.comcast.com",
    "cablecour.xyz",
    "cablefev.xyz",
    "cablefeve.icu",
    "cableone.net",
    "cablesword.email",
    "cabm114.com",
    "cabm89.com",
    "cabm98.com",
    "cabob.best",
    "caboexpat.org",
    "cabonmania.ga",
    "cabonmania.tk",
    "cabonobaddays.com",
    "cabotog.net",
    "cabrini.edu",
    "cabuddti.cf",
    "cabuddti.ga",
    "cabuddti.tk",
    "cabwclhf.shop",
    "caca69.com",
    "cacanhbaoloc.com",
    "cacao.organic",
    "cachedot.net",
    "cachon.netmail.tk",
    "cacingnaga.net",
    "cacingnaga123.com",
    "cacodemon998od.online",
    "cacoink.ru",
    "cad.edu.creo.tips",
    "cad.edu.gr",
    "caddoazga.space",
    "caden.science",
    "cadetjobs.com",
    "cadewey.com",
    "cadillac-ats.tk",
    "cadillacupstate.com",
    "cadliafor.cf",
    "cadliafor.gq",
    "cadliafor.ml",
    "cadliafor.tk",
    "cadmiurphj.space",
    "cadrbranch.ru",
    "cads.tel",
    "caeboyleg.ga",
    "caeboyleg.ml",
    "caefrj.icu",
    "caere.it",
    "caerwyn.com",
    "caewite.ga",
    "caewite.gq",
    "cafe46design.xyz",
    "cafecar.xyz",
    "cafejomo.com",
    "cafemilano-toomevera.com",
    "cafergot.website",
    "cafergot247.video",
    "caferomatakeaway.com",
    "caffedelpalladio.com",
    "cagoi.net",
    "cagolfboo.cf",
    "cagolfboo.tk",
    "cahalfpricelisting.com",
    "cahalfpricelistings.com",
    "cahayasenja.online",
    "cahkerjo.tk",
    "cahoye.net",
    "cahsintru.cf",
    "cahturbate.club",
    "cai813.com",
    "caidime.ga",
    "caidime.gq",
    "caidime.tk",
    "caifayulezc.com",
    "caih.asia",
    "cailega.cf",
    "cailega.ga",
    "cailega.ml",
    "cainongbang.xyz",
    "caipiao9837.com",
    "cairdominoqq.info",
    "cairomail.com",
    "cais.net",
    "caishang123.xyz",
    "caishangpai.xyz",
    "caishen10.fun",
    "caishen11.fun",
    "caishen13.fun",
    "caishen16.fun",
    "caishen6.fun",
    "caishen8.fun",
    "caishen9.fun",
    "caistore.com",
    "caitlynfarrowphotography.com",
    "cajero.net",
    "cajun-claws.com",
    "cajunglossary.com",
    "cajunricecookers.com",
    "cajydo.info",
    "cakenxibenv.email",
    "cakeonline.ru",
    "cakewalktech.org",
    "cakk.us",
    "cakokalrect.tk",
    "cakottery.com",
    "calagreens.info",
    "calandarstudy.com",
    "calciuvpht.space",
    "calculatedchaos.net",
    "calcuttaads.com",
    "calcy.org",
    "calderonpublicidad.com",
    "calendar-server.bounces.google.com",
    "calffiercechic.website",
    "calfocus.com",
    "caliberaccounting.com",
    "caliberaccountinggroup.com",
    "calibericvilafrancadelpenedes.com",
    "calibra-travel.com",
    "calidifontain.be",
    "califityoga.com",
    "califohdsj.space",
    "california-resident-agent.com",
    "californiaaddictiontreatment.center",
    "californiaaws.com",
    "californiadroneworks.com",
    "californiafarmwedding.com",
    "californiafitnessdeals.com",
    "californiamail.com",
    "californiamovo.com",
    "californianetizen.com",
    "californiaoutdoorwedding.com",
    "californiaquote.com",
    "californiaranchwedding.com",
    "californiaufc.com",
    "californiavalentine.com",
    "calisfei.cf",
    "calisfei.ga",
    "calisfei.gq",
    "calisfei.tk",
    "call-aide.com",
    "call-direct.net",
    "callankebabishandindian.com",
    "callbsa.website",
    "callcenter.works",
    "callcentersolo.online",
    "callcenterthevirtual.online",
    "callcenterthink.online",
    "callejondelosmilagros.com",
    "caller.reviews",
    "calliope2.org",
    "callmsv.website",
    "callnetuk.com",
    "calloneessential.com",
    "callout.app",
    "callrick.properties",
    "callsign.net",
    "callthegymguy.top",
    "callthemainguy.top",
    "calltracks.ru",
    "calmdown.site",
    "calnaser.cf",
    "calnaser.gq",
    "calnaser.ml",
    "calninfculning.ga",
    "caloriebuddyapp.com",
    "calphemi.cf",
    "calphemi.ga",
    "calphemi.tk",
    "caltanet.it",
    "calumeno.net",
    "calvadaho.com",
    "calvarwxnp.space",
    "calvarycloud.com",
    "calver.biz",
    "calverleyparish.host",
    "calyx.site",
    "cam2d.com",
    "cam4you.cc",
    "camaloon.mobi",
    "camaloon.net",
    "camaradamail.club",
    "camaradeaguasdetenerife.com",
    "camau24h.info",
    "cambiadorparabebe.com",
    "cambiardeseguro.com",
    "cambodiaheritage.net",
    "cambridgeapartments.info",
    "cambridgepropertylisting.com",
    "cambridgize.com",
    "camcaribbean.com",
    "camciety.com",
    "camcordershop.life",
    "camcum.ru",
    "camcuypop.cf",
    "camcuypop.ml",
    "camcuypop.tk",
    "camdenchurchofchrist.com",
    "camedicalcannabis.expert",
    "camelisete.ru",
    "camelotcostumes.com",
    "cameratouch-849.ru",
    "cameroncook.buzz",
    "cameroon365.com",
    "camidge.com",
    "camifix.xyz",
    "camille.pw",
    "camilokolomi.com",
    "caminoaholanda.com",
    "camisetascomohongos.com",
    "camlive.ooo",
    "camobet365.com",
    "camoney.xyz",
    "campano.cl",
    "campeonbet24.com",
    "camphillchiropractic.com",
    "camping-grill.info",
    "campingandoutdoorsgear.com",
    "campinghackers.xyz",
    "camposol-linea-etica.com",
    "campouts.app",
    "campsaver.ru",
    "campuscorruption.com",
    "campuscoverage.org",
    "campusofmediators.ong",
    "camrecs.com",
    "camren.club",
    "camsetif19.com",
    "camsuki.com",
    "camxxx.ooo",
    "camxxx.tech",
    "camxxx.xyz",
    "can5292.com",
    "canabisonfire.com",
    "canada-11.com",
    "canada.com",
    "canadalivecasinos.com",
    "canadaweb.info",
    "canadian-fury.com",
    "canadiancourts.com",
    "canadianmail.com",
    "canakkalekartallari.xyz",
    "canakkalelilernakliyat.xyz",
    "canakkalemotorsiklet.xyz",
    "canakkaleotels.xyz",
    "canakkalevillagarden.com",
    "canakkaleyildiznakliyat.com",
    "canalinfo.online",
    "canalpilates.net",
    "canarytool.com",
    "cancecharb.cf",
    "cancecharb.gq",
    "cancecharb.ml",
    "cancecharb.tk",
    "cancerians.co.uk",
    "cancermoon.org",
    "canchimi.cf",
    "canchimi.ga",
    "canchimi.gq",
    "cancun-transfers.us",
    "cancunhikes.online",
    "cancunholidaytours.us",
    "cancunhotelpackages.tech",
    "cancunpackages.space",
    "cancunresortspackages.online",
    "cancunweddingpackages.us",
    "candcluton.com",
    "candesign.systems",
    "candidteenagers.com",
    "candsdenterprises.com",
    "canduqq.best",
    "candy-captcha.com",
    "candyjapane.ml",
    "candylee.com",
    "candymail.de",
    "candynet.shop",
    "candysweetday.com",
    "cane.pw",
    "canextend.net",
    "canextenz.com",
    "canextenz.net",
    "canfima.ml",
    "canfima.tk",
    "cangdazzdec.ga",
    "cangdazzdec.gq",
    "cangdazzdec.tk",
    "cangdet.club",
    "canggih.net",
    "cangrejopistoleroediciones.com",
    "canguroos.ml",
    "cangzm.us",
    "canhardco.cf",
    "canhardco.ga",
    "canhardco.ml",
    "canhoehome4.info",
    "canholaimianquan2.net",
    "canibots.com",
    "canilvonhauseferrer.com",
    "caniracpuebla.com",
    "canitta.icu",
    "cankaushikshave.site",
    "cankirilimited.xyz",
    "canlialem.xyz",
    "canlibahisoyunu.xyz",
    "canlidoviz.site",
    "canligorusme.com",
    "canlimacizler9.club",
    "canlitvizle.pro",
    "cannabel.org",
    "cannabidiol.organic",
    "cannabis-investor.com",
    "cannabis-registration.com",
    "cannabis-registration.net",
    "cannabis-registry.org",
    "cannabis918.shop",
    "cannabisa-net.su",
    "cannabisaktiennews.com",
    "cannabisispiritual.com",
    "cannabisregulacionya.com",
    "cannabisresoulution.net",
    "cannabpharmis.com",
    "cannacbdpharm.com",
    "cannado.art",
    "cannagize.com",
    "cannagize.net",
    "cannalytics.app",
    "cannapharm2relax.com",
    "cannapharmacom.com",
    "cannapharmcybis.com",
    "cannapleaz.com",
    "cannarcrm.com",
    "cannawild.com",
    "cannedsoft.com",
    "cannedsoft.net",
    "canneplex.com",
    "canneplex.net",
    "cannextend.com",
    "cannextenz.net",
    "cannextenze.com",
    "cannextenze.net",
    "cannoncrew.com",
    "canoemail.com",
    "canpu.website",
    "cansome.online",
    "cantadeniziniz.xyz",
    "cantaesin.online",
    "cantamagazam.xyz",
    "canteenfineasiancuisine.com",
    "canterburyaccountancy.com",
    "canthhogem.cf",
    "canthhogem.ml",
    "cantikmanja.online",
    "cantondoctors.com",
    "cantonwaterford.com",
    "cantv.net",
    "canuster.xyz",
    "canvasshoes.club",
    "canvastailoring.com",
    "canwest.net",
    "canwetalk.com",
    "canyonrimhoneybees.com",
    "canyouhearmenow.cf",
    "canytimes.com",
    "cao2sd4.xyz",
    "cao6sd.xyz",
    "caob5c2.xyz",
    "caod4w4.xyz",
    "caoew75.xyz",
    "caof1d2.xyz",
    "caofd21.xyz",
    "caogf1c.xyz",
    "caolh36.xyz",
    "caongo.com",
    "caonima.gq",
    "caoq12df.xyz",
    "caoq5do.xyz",
    "caoser.com",
    "caouyt21.xyz",
    "caow32s.xyz",
    "caoxy.xyz",
    "cap-ogx.com",
    "capablily.xyz",
    "capabraintu.monster",
    "capacitando-me.com",
    "capatal.com",
    "capba.site",
    "capeandislandshearing.com",
    "capeaudiology.com",
    "capecodaudiology.com",
    "capecodear.com",
    "capecodtinnituscenter.com",
    "capecodtinnitustreatment.com",
    "capecoralnailsalons.com",
    "capehearing.com",
    "capehu.ga",
    "capehu.tk",
    "capetownactiva.com",
    "capisci.org",
    "capitakfqe.site",
    "capital-capital.ru",
    "capital-city.info",
    "capital-turkish-kebab-house.com",
    "capitalbasicnews.com",
    "capitalequityreport.com",
    "capitalis-europa.com",
    "capitalme.sk",
    "capitalregionusa.biz",
    "capitalregionusa.info",
    "capitalswarm.com",
    "capitolartscomplex.org",
    "capo-daca1.ru",
    "capper-azia.ru",
    "caprealty-grp.com",
    "capri-crumlin.com",
    "capricornians.co.uk",
    "capriviews.info",
    "capsamu.com",
    "capsaoke.info",
    "capsaoke.net",
    "capsaoke.org",
    "capsaoke.xyz",
    "capsawinshoki88.net",
    "capsawinspkr.com",
    "capsjutab.cf",
    "capsjutab.ga",
    "capsjutab.ml",
    "capsjutab.tk",
    "capsulizing906vc.online",
    "captain4bins.com",
    "captainamericagifts.com",
    "captaindocker.com",
    "captaindocker.org",
    "captainjack.casino",
    "captaintlr.com",
    "capturedbychelle.com",
    "capu.net",
    "caputareg.ga",
    "caputoesp.llc",
    "caqmmw.shop",
    "caqsasxc.art",
    "car-arom.ru",
    "car-fur.ru",
    "car-innovcamera.ru",
    "car-insurances.us",
    "car.storage",
    "car101.pro",
    "car48plus.xyz",
    "caraa317.xyz",
    "caraccidentlawyernetwork.net",
    "carackkat.online",
    "caraff.com",
    "caramail.com",
    "caramail.d3vs.net",
    "caramail.lycos.fr",
    "caramail.pro",
    "carambla.com",
    "caramelize931tp.online",
    "caramelopurohabano.com",
    "caramerica.site",
    "caraper.tk",
    "caratane.com",
    "carati02.online",
    "carati03.online",
    "carautoinjury.com",
    "carazfi.cf",
    "carbazaarchandigarh.com",
    "carbonationsim.com",
    "carbonbrush.us",
    "carbonbrushes.biz",
    "carbonbrushes.us",
    "carbonequity.us",
    "carbonfiberbrush.biz",
    "carbonfiberbrush.com",
    "carbonfiberbrush.net",
    "carbonfiberbrush.us",
    "carbonfiberbrushes.biz",
    "carbonfiberbrushes.net",
    "carbonfiberbrushes.org",
    "carbonfiberbrushes.us",
    "carbonhans.com",
    "carbonia.de",
    "carbonnotr.com",
    "carbtc.net",
    "carcaremag.com",
    "carcloud49.xyz",
    "card.zp.ua",
    "cardifffans.co.uk",
    "cardivings.info",
    "cardmellloshop.com",
    "cardour.com",
    "cardpg90sbt.xyz",
    "cardsagainsthrones.com",
    "cardsjustice.com",
    "cardsthornton.com",
    "cardtested.com",
    "cardtribute.com",
    "care2.com",
    "carearoverseas.com",
    "careceo.com",
    "careerassessmentsystem.org",
    "careerbuildermail.com",
    "careersinentertainmenttour.org",
    "careerwill.com",
    "caregraf.net",
    "carehabcenter.com",
    "careless-whisper.com",
    "carenetdesign.com",
    "carenthusiasts.co.uk",
    "caresforfish.com",
    "careuters.com",
    "cargids.site",
    "cargoefren.cf",
    "carhireok.com",
    "cariadrecords.com",
    "cariari.ucr.ac.cr",
    "caribbeancruisessale.com",
    "carinamiranda.org",
    "carins.io",
    "carinsuranceflorida.fun",
    "carioca.net",
    "caritto.ru",
    "carlavis.info",
    "carlosandrade.co",
    "carlosdejesustotalfitness.com",
    "carloszbs.ru",
    "carlow-kebabish.com",
    "carmafunderburg.co",
    "carmelrealestateagents.com",
    "carminemarceno2020.com",
    "carminemarcenoforsheriff.com",
    "carnavalbetting31.com",
    "carnegieacademyrealestate.com",
    "carnegieacademytaxlien.com",
    "carney.website",
    "carnocha.cf",
    "carnocha.gq",
    "carnuts.co.uk",
    "carny.website",
    "caroil-coupon.xyz",
    "caroil-promo.xyz",
    "carolelectronic.com",
    "carolers754py.online",
    "carolina.rr.com",
    "caroline-petit.com",
    "carolineagreen.com",
    "carolinecrane.net",
    "carolinejeanbaptiste.net",
    "carolserpa.com",
    "carolstaxes.org",
    "carolus.website",
    "carpetblue.shop",
    "carpetcareseattle.com",
    "carpetcareseattle.net",
    "carpetstore.se",
    "carpoo.com",
    "carpool.design",
    "carpuppets.info",
    "carrepair.press",
    "carrereclock.ru",
    "carrick-hut-takeaway.com",
    "carrickfergusknights.com",
    "carriedennis.us",
    "carriwell.us",
    "carrnelpartners.com",
    "carrolltoninjuryattorney.com",
    "carrolltonpersonalinjuryattorneys.com",
    "carrosusadoscostarica.com",
    "carrygian.xyz",
    "carrygr.icu",
    "carrygran.xyz",
    "carrytough.com",
    "cars.cd",
    "cars2.club",
    "carsaa318.xyz",
    "carsabas.info",
    "carsencyclopedia.com",
    "carspost.ru",
    "carsyakaz.xyz",
    "cart.4.0.0.1.com",
    "cartaodetodos.site",
    "cartelera.org",
    "cartelparaeventos.com",
    "carterasdesilicona.com",
    "cartestraina.ro",
    "cartflare.com",
    "cartoonarabia.com",
    "cartoonnet.shop",
    "cartoonsors.com",
    "cartoontextures.com",
    "cartwright-morris.com",
    "carvecolo.site",
    "carvehabi.xyz",
    "carver.website",
    "carverid.xyz",
    "carveride.icu",
    "carvideoshop.life",
    "carwashautopay.com",
    "cary.website",
    "caryamen.com",
    "caryl.website",
    "casa.systems",
    "casa98.bet",
    "casablancaresort.com",
    "casacaymanrealestate.com",
    "casadecampo.online",
    "casadepaellalasrozas.com",
    "casadimilano.com",
    "casampiters.com",
    "casanova-up.pro",
    "casar.website",
    "casaresgolfandcountryclub.com",
    "casaromatakeaway.com",
    "casarosita.info",
    "casaruralsolidariacaceres.com",
    "casavoletv2.com",
    "casavoletv3.com",
    "casaytierrallc.net",
    "cascadevps.com",
    "cascaisnetradio.com",
    "caseedu.tk",
    "caseincancer.com",
    "casekoga.ru",
    "casema.nl",
    "caseritodelibery.com",
    "casesurfer.com",
    "casetine.icu",
    "caseyfarina.net",
    "cash.camera",
    "cash1loans.loans",
    "cash2.xyz",
    "cash4.xyz",
    "cash4houses.us",
    "cash4u.com",
    "cash5.xyz",
    "cash6.xyz",
    "cash7.xyz",
    "cashbabmzp.ru",
    "cashbackr.com",
    "cashbazi.club",
    "cashette.com",
    "cashewnutfromvietnam.com",
    "cashfeed.net",
    "cashfeeding.com",
    "cashforjunkcarsmanhattan.info",
    "cashplus.us",
    "cashproposals.com",
    "cashspincasino.com",
    "cashtogoods.com",
    "casiboom.com",
    "casino-119.com",
    "casino-admiral10.com",
    "casino-champion-official-site.com",
    "casino-joser.com",
    "casino-online.rocks",
    "casino-vulkan-24.win",
    "casino.com",
    "casino4me.ru",
    "casino892.com",
    "casinoaa316.xyz",
    "casinobandar.net",
    "casinobit.bet",
    "casinobit.club",
    "casinobonusual2.com",
    "casinocuan.club",
    "casinoeridanmark.com",
    "casinofundaily.info",
    "casinojack.xyz",
    "casinokun.hu",
    "casinoleaks.info",
    "casinomarin13.com",
    "casinomarin22.com",
    "casinomegapot.com",
    "casinoove5.com",
    "casinoplorer.com",
    "casinoremix.com",
    "casinos-online.ru",
    "casinos.ninja",
    "casinosport88.pro",
    "casinotopwinplay.best",
    "casinoturk.net",
    "casinovaz.com",
    "casinovegas.com",
    "casinovegas69.com",
    "casinowin.us",
    "casinowin88.org",
    "casinoxzerkalo.ru",
    "casinoz777.space",
    "casio-edu.cf",
    "casio-edu.ga",
    "casio-edu.gq",
    "casio-edu.ml",
    "casio-edu.tk",
    "casiobet.live",
    "casitsupartners.com",
    "caslno-faraon.ru",
    "casmud.tk",
    "casperlouis.com",
    "caspianfan.ir",
    "caspianshop.com",
    "caspiantejarat.com",
    "cassaundra.club",
    "cassio3e.club",
    "cassiomurilo.com",
    "cassius.website",
    "casstream.online",
    "castanheiraleilao.com",
    "castellochinese.com",
    "castiron-jeans.com",
    "castiron.clothing",
    "castkidninf.cf",
    "castkidninf.ga",
    "castkidninf.ml",
    "castkidninf.tk",
    "castle-kebab-takeaway.com",
    "castlebranchlogin.com",
    "castlecamelot.net",
    "castlecary.org",
    "castlekebabhouse.com",
    "castlelawoffice.com",
    "castlerockdoctors.com",
    "castles-carey.com",
    "castlevania.online",
    "castlock.us",
    "castlpoir.ga",
    "castmerkezi.net",
    "castplayer.net",
    "castri.com",
    "castudio.shop",
    "castwinners.space",
    "casualdx.com",
    "casualtreff-confirmed.com",
    "casualtreff-meet-backup.com",
    "casualtreff-meet.com",
    "cataloniamail.com",
    "cataloniaoffers.icu",
    "catalystnetwork.info",
    "catalystrealtygroup.com",
    "catalystwallet.info",
    "catamount.wcu.edu",
    "cataratafortuna.com",
    "cataumetclubcamp.com",
    "cataz.com",
    "catcafe.online",
    "catch.everton.com",
    "catcha.com",
    "catchadj.com",
    "catchamail.com",
    "catchletter.com",
    "catchmamo.cf",
    "catchmamo.ga",
    "catchmamo.gq",
    "catchmamo.tk",
    "catchmeifyoucan.xyz",
    "catchmino.xyz",
    "catchonline.ooo",
    "catchthr.xyz",
    "catchtos.info",
    "catchtricop.cf",
    "catchtricop.ga",
    "catchtricop.gq",
    "catchtricop.ml",
    "catchtricop.tk",
    "catcrakzup.website",
    "cate-sd.com",
    "categon.ga",
    "categon.gq",
    "catemail.com",
    "catercla.icu",
    "caterho.icu",
    "caterwatc.xyz",
    "caterwire.com",
    "catfish101.com",
    "cathead.ru",
    "catherina.club",
    "catherinegreco55places.com",
    "catholic.org",
    "catholicsla.com",
    "catholicsla.org",
    "cathouseninja.com",
    "catighpul.cf",
    "catighpul.gq",
    "catighpul.ml",
    "catighpul.tk",
    "catliuxin.xyz",
    "catlover.com",
    "catorpnd.club",
    "catretainerbug.website",
    "catsrule.garfield.com",
    "cattleclub.net",
    "caucomda.cf",
    "caucomda.gq",
    "caucomda.ml",
    "cauf.email",
    "caufurjo.cf",
    "caufurjo.ml",
    "caughtinthemiddle.org",
    "caugiay.tech",
    "cauri.ru",
    "causamail.club",
    "causedelta.org",
    "causeforalife.com",
    "causetoshare.com",
    "causikir.cf",
    "causikir.ga",
    "causikir.ml",
    "cautiocon.cf",
    "cautiocon.ga",
    "cautiocon.gq",
    "cautiocon.tk",
    "cav000.com",
    "cav002.com",
    "cav006.com",
    "cav111.com",
    "cavi.mx",
    "caviarsmoke.store",
    "caviaruruguay.com",
    "cavilers639kx.online",
    "cavisto.ru",
    "cavlbx.us",
    "cawo8x.com",
    "cax-aksmmor.ru",
    "caxa.site",
    "caybrac.com",
    "caywrisun.cf",
    "caywrisun.ml",
    "cazerumka.ru",
    "cazinoid.ru",
    "cazinomolniya.com",
    "cazinoz.biz",
    "cazir.live",
    "cazis.fr",
    "cazzie.website",
    "cazzo.cf",
    "cazzo.ga",
    "cazzo.gq",
    "cb365.space",
    "cb367.space",
    "cb381.space",
    "cb44ay.com",
    "cb4p1f.us",
    "cb5.xyz",
    "cb6ed.xyz",
    "cb6it0.us",
    "cb7ohx6dhgy1ikl.xyz",
    "cbair.com",
    "cbajl.live",
    "cbamboo.com",
    "cbaplex.net",
    "cbarato.vip",
    "cbav12.xyz",
    "cbav9.xyz",
    "cbbwabci.shop",
    "cbca.xyz",
    "cbcfpermanence.com",
    "cbd-bites.net",
    "cbd-direct.net",
    "cbd-mart.net",
    "cbd-pills.net",
    "cbd-snack.net",
    "cbd-snacks.net",
    "cbd-treats.com",
    "cbd-treats.net",
    "cbd.clothing",
    "cbd47.com",
    "cbd4less.net",
    "cbd911.life",
    "cbdarthritisrelief.com",
    "cbdbites.net",
    "cbdbydrakc.com",
    "cbdcake.com",
    "cbdelivered.net",
    "cbdeserts.net",
    "cbdforbirds.com",
    "cbdforcure.com",
    "cbdforless.net",
    "cbdforms.com",
    "cbdgeeks.org",
    "cbdhealthnuts.com",
    "cbdhealthpro.com",
    "cbdhealthpro.net",
    "cbdjungle.com",
    "cbdnut.com",
    "cbdnuts.net",
    "cbdofthemonth.com",
    "cbdol.ru",
    "cbdpackage.net",
    "cbdpicks.com",
    "cbdreleafmedway.com",
    "cbdslim.net",
    "cbdstars.net",
    "cbdtodaynow.com",
    "cbe96.xyz",
    "cbes.net",
    "cbgame.club",
    "cbgh.ddns.me",
    "cbhj.email",
    "cbjr.tk",
    "cbkariyer.com",
    "cbmcalgary.com",
    "cbmg.email",
    "cbms.online",
    "cbs0r3.us",
    "cbspoker.net",
    "cbxapp.com",
    "cbyourself.com",
    "cc-cc.usa.cc",
    "cc-s3x.cf",
    "cc-s3x.ga",
    "cc-s3x.gq",
    "cc-s3x.ml",
    "cc-s3x.tk",
    "cc.liamria",
    "cc0d.com",
    "cc2ilplyg77e.cf",
    "cc2ilplyg77e.ga",
    "cc2ilplyg77e.gq",
    "cc2ilplyg77e.ml",
    "cc2ilplyg77e.tk",
    "cc33.online",
    "cc3770.com",
    "cc4av.info",
    "cc57822.com",
    "cc9356.com",
    "cc9oif.com",
    "ccacomunicacao.com",
    "ccamerapeak.site",
    "ccat.cf",
    "ccat.ga",
    "ccat.gq",
    "ccavinun.gq",
    "ccavinun.ml",
    "ccavinun.tk",
    "ccc-119.com",
    "ccc526.xyz",
    "ccc9827.com",
    "ccccmontreal.com",
    "ccdd.site",
    "cce.coop",
    "cceks.com",
    "ccfcd46.xyz",
    "ccgtoxu3wtyhgmgg6.cf",
    "ccgtoxu3wtyhgmgg6.ga",
    "ccgtoxu3wtyhgmgg6.gq",
    "ccgtoxu3wtyhgmgg6.ml",
    "ccgtoxu3wtyhgmgg6.tk",
    "cchaddie.website",
    "cchatpulsek.site",
    "cchatwarer.site",
    "cchatz.ga",
    "cchetsbdc7.uno",
    "ccid.de",
    "ccikarate.com",
    "ccmail.men",
    "ccmoe.com",
    "ccnmail.com",
    "ccoinxsm.site",
    "ccon4.xyz",
    "ccpad.ml",
    "cctrl.org",
    "cctvcamerasrus.xyz",
    "ccuttonics.com",
    "ccwld.com",
    "cd.mintemail.com",
    "cd2.com",
    "cd212f77.xyz",
    "cd2in.com",
    "cd921a07.club",
    "cd9cki.us",
    "cdaeastlands.com",
    "cdbook.club",
    "cdcbkidsdentist.com",
    "cdcmail.date",
    "cdcovers.icu",
    "cdekhouse.space",
    "cdjcy.com",
    "cdjiazhuang.com",
    "cdmoe.com",
    "cdn.rent",
    "cdnaas.com",
    "cdnaas.net",
    "cdnplayvideos.xyz",
    "cdnqa.com",
    "cdntunnel.com",
    "cdp6.com",
    "cdpa.cc",
    "cdpchurch.com",
    "cdpluss.com",
    "cdpokem.ru",
    "cdr.fastmail.fm",
    "cdsljk.com",
    "cdtwb1.site",
    "ce.mintemail.com",
    "cebaffshop.store",
    "cebahis29.com",
    "cebolsarep.ga",
    "cebong.cf",
    "cebong.ga",
    "cebong.gq",
    "cebong.ml",
    "cebong.tk",
    "cecerbuyshouses.com",
    "cechire.com",
    "ceco3kvloj5s3.cf",
    "ceco3kvloj5s3.ga",
    "ceco3kvloj5s3.gq",
    "ceco3kvloj5s3.ml",
    "ceco3kvloj5s3.tk",
    "cedarcitybusinessbrokers.com",
    "cedarcomputerssite.club",
    "cedarfallsapartments.com",
    "cedarloghomestn.biz",
    "cedarrapidsrealestateagents.com",
    "cedoiruty.cf",
    "cedwa.us",
    "ceed.se",
    "ceefax.co",
    "cefer.xyz",
    "cefind.net",
    "ceftvhxs7nln9.cf",
    "ceftvhxs7nln9.ga",
    "ceftvhxs7nln9.gq",
    "ceftvhxs7nln9.ml",
    "ceftvhxs7nln9.tk",
    "cegisau.space",
    "cehage.ga",
    "cehage.gq",
    "cehage.tk",
    "cehomeagencyinc.org",
    "cehu.site",
    "ceifiohous.ga",
    "ceifiohous.gq",
    "ceifiohous.tk",
    "ceilysa.cf",
    "ceinasu.ru",
    "ceipanto.cf",
    "ceipanto.ga",
    "ceipanto.ml",
    "ceipanto.tk",
    "ceiraafrac.cf",
    "ceiraafrac.gq",
    "cek-resi.website",
    "cek-tagihan.website",
    "cek.pm",
    "cekajahhs.tk",
    "cekc-video.com",
    "cekilisli.space",
    "ceklaww.ml",
    "cekmovie.com",
    "celdelest.cf",
    "celdelest.ga",
    "celdelest.gq",
    "celdelest.tk",
    "celebandtrend.com",
    "celebleak.co",
    "celebmarket.net",
    "celebmetrics.com",
    "celebratelifebc.info",
    "celebritron.app",
    "celebrity-whiz.com",
    "celebrityadz.com",
    "celebritydiscounts.club",
    "celebrityweighthack.com",
    "celebrus.email",
    "celerirouge.com",
    "celiacenzyme.com",
    "celikhanlimited.xyz",
    "celineclub.com",
    "celiro.ru",
    "cellartravel.com",
    "cellmotion.com",
    "cellphoneaccessoriesdepo.com",
    "cellphoneparts.tk",
    "cellsata.ga",
    "cellsata.gq",
    "cellsata.ml",
    "cellular-phone-accessories-center.com",
    "cellulite-clinics.com",
    "cellurl.com",
    "celocopac.fun",
    "celsiuscapitalinc.com",
    "celtabet127.com",
    "celtic.com",
    "celticfans.com",
    "celtode.cf",
    "celtode.ga",
    "celtode.ml",
    "celyi.live",
    "cem.net",
    "cemdevelopers.com",
    "cemdevelopers.info",
    "cemdevelopers.org",
    "cemeqq.poker",
    "cemouton.com",
    "cempece.site",
    "cenglandb.com",
    "cenodrom.ru",
    "center-mail.de",
    "center-sicherheit-abteilung-update.xyz",
    "center-zemli.ru",
    "centercoupon.ru",
    "centerforresponsiveschools.com",
    "centerforresponsiveschools.info",
    "centerforresponsiveschools.org",
    "centerhash.com",
    "centermail.at",
    "centermail.com",
    "centermail.de",
    "centermail.info",
    "centermail.net",
    "centerpointecontractors.info",
    "centerpointecontractors.net",
    "centerpointecontractors.org",
    "centervilleapartments.com",
    "centol.us",
    "centoper.it",
    "centoviki.cf",
    "centoviki.gq",
    "centoviki.ml",
    "centr-doors.ru",
    "centr-fejerverkov28.ru",
    "centr-luch.ru",
    "centr-p-i.ru",
    "central-asia.travel",
    "central-grill-takeaway.com",
    "central-realestate.com",
    "central-series.com",
    "central-servers.xyz",
    "central-teater.ru",
    "centralcomprasanitaria.com",
    "centraldasaude.xyz",
    "centralgrillpizzaandpasta.com",
    "centralizes920zw.online",
    "centraljoinerygroup.com",
    "centrallosana.ga",
    "centralmicro.net",
    "centralniagaraminorhockey.com",
    "centralpets.com",
    "centralstaircases.com",
    "centralstairisers.com",
    "centralteam.org",
    "centraltoto.biz",
    "centreofarmonia.com",
    "centresanteglobaleles4chemins.com",
    "centresanteles4chemins.com",
    "centrodeolhoscampos.com",
    "centrodesaude.website",
    "centrodesaude.xyz",
    "centrosprevencion.com",
    "centrulvechi.info",
    "centrum.cz",
    "centrum.sk",
    "century-pool-advice-make.xyz",
    "century21coloradoriverrealty.com",
    "centuryfinley.site",
    "centurylink.net",
    "centuryminingsr.com",
    "centurytel.net",
    "centvps.com",
    "centy.cf",
    "centy.ga",
    "centy.gq",
    "centy.tk",
    "cenue8x.com",
    "cenun8x.com",
    "ceo-online.ru",
    "ceocili.gq",
    "ceocili.tk",
    "ceos.us",
    "ceos.xyz",
    "cepatbet.com",
    "cepdelira.xyz",
    "cepechil.ml",
    "cephalexin247.video",
    "cepie8x.com",
    "cepin8x.com",
    "cepwslow.works",
    "ceramica-mk.ru",
    "ceramicsbensu.com",
    "ceranode.net",
    "ceranode.org",
    "cerbapp.com",
    "cerbidurch.cf",
    "cerbidurch.ga",
    "cerbidurch.gq",
    "cerbidurch.tk",
    "cerdikiawan.me",
    "cerebal-palsey.com",
    "cerebalpalsyattorneys.com",
    "cerebral-palsey-attorneys.com",
    "cerebral-palsy-law-firm.org",
    "cerebralpalseylawyer.com",
    "cerebralpalsyattorneys.com",
    "cerebralpalsylawyers.org",
    "cereponsu.website",
    "cerf-science.org",
    "cergon.com",
    "ceritaku.me",
    "ceritaseksdewasa.org",
    "cerkesnumunemektebi.org",
    "ceroa.com",
    "ceroitemas.ga",
    "certificatievisure.com",
    "certifiedautismtherapists.com",
    "certifiedautismtherapy.com",
    "certifiedfinancialeducation.com",
    "certifiedmail.com",
    "certifiedorganichairproducts.com",
    "certiflix.com",
    "certphysicaltherapist.com",
    "cerve.site",
    "cervezaartesanal.pub",
    "cerysmclean.buzz",
    "cesbfledin.cf",
    "cesbfledin.gq",
    "cesbfledin.ml",
    "ceshi02.xyz",
    "cesindy2018.com",
    "ceskarapublika.info",
    "cesmecigida.xyz",
    "cesmemarin.xyz",
    "cesmeogretmenevi.online",
    "cesmeogretmenevi.xyz",
    "cesmetatilcesme.xyz",
    "cessmarwa.ml",
    "cessmarwa.tk",
    "cessmonre.cf",
    "cessmonre.ga",
    "cessmonre.gq",
    "cessmonre.ml",
    "cestocon.ga",
    "cetpass.com",
    "cevoboutique.site",
    "cewaby.info",
    "ceweknakal.cf",
    "ceweknakal.ga",
    "ceweknakal.ml",
    "cexkg50j6e.cf",
    "cexkg50j6e.ga",
    "cexkg50j6e.gq",
    "cexkg50j6e.ml",
    "cexkg50j6e.tk",
    "ceyfc.xyz",
    "ceyhantesisat.xyz",
    "ceylonleaf.com",
    "ceylonmusic.com",
    "ceylontravell.icu",
    "cf393.site",
    "cf99ba7f8a69c93729.xyz",
    "cfaffiliateap.com",
    "cfaffiliateapp.com",
    "cfcae.org",
    "cfdripfunnel.com",
    "cfejd.us",
    "cfl.rr.com",
    "cflnja.us",
    "cfmercantile.net",
    "cfml.ninja",
    "cfn.productions",
    "cfo2go.ro",
    "cfocentre.se",
    "cfromero.com",
    "cfskrxfnsuqck.cf",
    "cfskrxfnsuqck.ga",
    "cfskrxfnsuqck.gq",
    "cfskrxfnsuqck.ml",
    "cfskrxfnsuqck.tk",
    "cfspart-impots-gouv.site",
    "cftest123.cam",
    "cftrextriey-manage1.com",
    "cfxsjw.shop",
    "cfzfkypq.shop",
    "cgac.es",
    "cganlefunt.xyz",
    "cgbjxt.tk",
    "cgco.ru",
    "cgfirst.dev",
    "cghdgh4e56fg.ga",
    "cghost.s-a-d.de",
    "cghvj.site",
    "cghyoh6u7b8hjnr.xyz",
    "cgjt0.us",
    "cgls.shop",
    "cgnz7xtjzllot9oc.cf",
    "cgnz7xtjzllot9oc.ga",
    "cgnz7xtjzllot9oc.gq",
    "cgnz7xtjzllot9oc.ml",
    "cgnz7xtjzllot9oc.tk",
    "cgocable.ca",
    "cgrtstm0x4px.cf",
    "cgrtstm0x4px.ga",
    "cgrtstm0x4px.gq",
    "cgrtstm0x4px.ml",
    "cgrtstm0x4px.tk",
    "cgrwmp.icu",
    "cgucpa.org",
    "cgvxoom.com",
    "cgwrgmha.shop",
    "ch.tc",
    "ch13sv.com",
    "ch82sz.us",
    "chabak.net",
    "chabbirtoy.com",
    "chabbirtoy.icu",
    "chabujin.top",
    "chacebao.com",
    "chachyn.site",
    "chacuo.net",
    "chadu8.com",
    "chaeumacademy.com",
    "chaffyboater.icu",
    "chagacup.ru",
    "chahojoon.com",
    "chahuacun.com",
    "chaibehu.cf",
    "chaibehu.ga",
    "chaibehu.gq",
    "chaiberia.us",
    "chaichuang.com",
    "chaincreator.tech",
    "chaincreator.university",
    "chaincreatorexchange.com",
    "chainer.ru",
    "chainius-solutions.biz",
    "chainius-solutions.info",
    "chainius-solutions.net",
    "chainly.net",
    "chainrestaurantsolutions.biz",
    "chainru.xyz",
    "chairmassagekc.com",
    "chairple.us",
    "chaiyo.com",
    "chaiyomail.com",
    "chalemarket.online",
    "chalkfiel.press",
    "chalkmail.net",
    "challengeoo.email",
    "challenges.pub",
    "chalti.com",
    "chalupaurybnicku.cz",
    "chamberofshipping.org",
    "chammy.info",
    "champcaps.com",
    "champing.org",
    "champion-ins.com",
    "championscomputersspot.club",
    "champmails.com",
    "champqryq.space",
    "champtheawa.ml",
    "chanadabilli.shop",
    "chance2mail.com",
    "chancekey.com",
    "chanddonerkebabterrassa.com",
    "chandlerhairsalons.com",
    "chandrasekar.net",
    "chanelkirov43.ru",
    "chanellepace.com",
    "change-bitcoin.ru",
    "change.charity",
    "changethewayyoubank.org",
    "changetheworkclimate.com",
    "changing.info",
    "changingemail.com",
    "changnguyen.com",
    "changshutea-official.ru",
    "chanhleoz.com",
    "chanhxa3offer.xyz",
    "chanic.ru",
    "chanmelon.com",
    "channable.us",
    "channel9.cf",
    "channel9.ga",
    "channel9.gq",
    "channel9.ml",
    "channelbrushes.org",
    "channelbrushes.us",
    "channelized437mh.online",
    "channelmovies.net",
    "channelonetv.com",
    "chans360.xyz",
    "chansdouglas.com",
    "chantel.space",
    "chantellegribbon.com",
    "chanura.website",
    "chaochuiav.com",
    "chaonamdinh.com",
    "chaonhe.club",
    "chaosawa.fun",
    "chaosawful.com",
    "chaosfen.com",
    "chaoshea.us",
    "chaosi0t.com",
    "chaosmachine.net",
    "chaostrut.icu",
    "chaosvalue.us",
    "chaovideo09.com",
    "chaovideo11.com",
    "chaoxs.xyz",
    "chap-chi.com",
    "chapar.cf",
    "chaparmail.tk",
    "chapmanfuel.com",
    "chaptermultimediatumble.website",
    "characterizing205yn.online",
    "charfoce.gq",
    "charfoce.ml",
    "charfoce.tk",
    "chargecell.xyz",
    "chargeco.xyz",
    "chargedmuscles.com",
    "chargekitty.com",
    "chargerin.com",
    "charitablehomesite.club",
    "charityemail.com",
    "charityfloor.com",
    "charitysmith.com",
    "charitysmith.us",
    "charitysmithfunds.org",
    "charjmostaghim.com",
    "charleschadwick.com",
    "charlescottrell.com",
    "charlesmoesch.com",
    "charlieonparole.com",
    "charlotteaddictiontreatment.com",
    "charlottecocainerehab.com",
    "charlotteheroinrehab.com",
    "charlottehomeautomation.com",
    "charlotteixp.com",
    "charlottemajorleaguesoccer.com",
    "charlotteopiaterehab.com",
    "charlottesullivan.buzz",
    "charlotteverywell.com",
    "charltonfans.com",
    "charm.net",
    "charmedmail.com",
    "charmhive.com",
    "charmingdesigngirl.com",
    "charmrealestate.com",
    "charms-shop.com",
    "chartconcierge.com",
    "charter.com",
    "charter.net",
    "charterfouri.com",
    "chartersnyc.com",
    "chartier.name",
    "chartnov.xyz",
    "chartsma.press",
    "chartubate.club",
    "chartubate.xyz",
    "chartube.club",
    "chartube.xyz",
    "chaseharnack.com",
    "chasseurimmobiliernantes.com",
    "chassi-nc.cf",
    "chat.ru",
    "chatbelgique.com",
    "chatbotbucket.com",
    "chatbotpack.net",
    "chatbotpack.org",
    "chatdig.com",
    "chateastern.com",
    "chatflh.net",
    "chatgirl.tech",
    "chatkiste.net",
    "chatlane.ru",
    "chatpolynesie.com",
    "chatsite.shop",
    "chattanoogarealestateagents.com",
    "chatterdrive.xyz",
    "chattown.com",
    "chatur21bate.com",
    "chaturbatism.com",
    "chaturbatist.com",
    "chaturbatoid.com",
    "chauhanweb.com",
    "chauhanz.tk",
    "chaussresbuys.com",
    "chavhanga.com",
    "chay-market.com",
    "chaz.live",
    "chbx7.com",
    "cheap-led-grow-lights.com",
    "cheap.lighting",
    "cheap.photography",
    "cheap3ddigitalcameras.com",
    "cheap43.xyz",
    "cheap46.xyz",
    "cheap4u.ru",
    "cheapcellphonesplus.com",
    "cheapcubatravel.net",
    "cheapdiamond.net",
    "cheapdji.online",
    "cheapershop.host",
    "cheaperthandrit.com",
    "cheapestmaldivespackages.com",
    "cheaphealth.website",
    "cheaphie.com",
    "cheaphorde.com",
    "cheaphub.net",
    "cheapills.info",
    "cheapjerseyssoccer.com",
    "cheapnitros.com",
    "cheapoutlettoms.com",
    "cheaprbsunglasses.website",
    "cheapsphere.com",
    "cheaptomsshoeoutletstore.com",
    "cheapwebtraffic.com",
    "cheatbanned.ru",
    "cheater.com",
    "cheatmail.de",
    "cheblin.ru",
    "chechnya.conf.work",
    "check-prizes-now6.life",
    "check-prizesonline.life",
    "check.com",
    "check.com12",
    "check1check.com",
    "checkacc.org",
    "checkalertfriends.info",
    "checkaskfriends.info",
    "checkbox.biz",
    "checkcow.icu",
    "checken.press",
    "checkertesting.ml",
    "checkforwreck.com",
    "checklepoun.cf",
    "checklepoun.ga",
    "checklepoun.tk",
    "checkmaster-fail-flsitebuilder.com",
    "checkmaster-pass-flsitebuilder.com",
    "checkmatebill.com",
    "checknew.pw",
    "checksbibalance.info",
    "cheeb.com",
    "cheepchix.com",
    "cheerful.com",
    "cheerleading-perm.ru",
    "cheerluiei.space",
    "cheesepin.info",
    "cheetabet.club",
    "cheetabet12.com",
    "cheetahcyprus.com",
    "cheezoo.com",
    "chef.asana.biz",
    "chef.net",
    "chefbowmeow.com",
    "chefmail.com",
    "chefmeaningclay.website",
    "chefs-office.com",
    "chefsipa.cf",
    "chefsipa.ga",
    "chefsipa.ml",
    "chefsipa.tk",
    "chefskitchenfoodservice.com",
    "chefstakeaways.com",
    "chehov-beton-zavod.ru",
    "cheinepi.cf",
    "cheinepi.tk",
    "chejily.com",
    "chek.com",
    "chelahi.tk",
    "chello.at",
    "chello.nl",
    "chelny.press",
    "chelseaartsgroup.com",
    "chelseafans.net",
    "chelseafranklin.buzz",
    "chelseagardensmossvale.com",
    "chelseaheath.buzz",
    "chembidz.com",
    "chemicalmass.com",
    "chemist.com",
    "chemo.space",
    "chempacpharma.com",
    "chengren.ru",
    "chennaidiabetes.com",
    "chennaigip.org",
    "chens-chinese-restaurant.com",
    "chenschineserathfarnham.com",
    "chenshaohua.org",
    "chensimiao.org",
    "chenyue.org",
    "chequeado.ml",
    "chequemail.com",
    "cherbeli.cf",
    "cherbeli.gq",
    "cherbeli.ml",
    "chernokk.ru",
    "chernyshow.ru",
    "cherrycake01.ru",
    "cherryorgems.com",
    "cherrytidu.space",
    "chery-australia.club",
    "chery-clubs.ru",
    "chesapeakecocainerehab.com",
    "chesapeakehairsalons.com",
    "chesapeakeopiaterehab.com",
    "chesapeakequote.com",
    "cheshiremail.com",
    "chessjs.org",
    "chesterfieldfans.co.uk",
    "chesterstyle.ru",
    "chesteryachtsquadron.com",
    "chestnuthillhomelistings.com",
    "chesvlas.website",
    "chetabet.info",
    "chevrolet-aveo.club",
    "chevrolet-tahoe.club",
    "chevybizs.info",
    "chewcow.com",
    "chewiemail.com",
    "chewnchat.com",
    "chewytrain.com",
    "cheyenneweb.com",
    "chez.com",
    "chfound.best",
    "chfp.de",
    "chfromu.shop",
    "chhkhmer.com",
    "chhmail.cf",
    "chhmail.ga",
    "chhmail.gq",
    "chhmail.ml",
    "chhmail.tk",
    "chiangmai4sale.com",
    "chiangmaicellars.com",
    "chiasemienphi.info",
    "chibakenma.ml",
    "chicago-central.com",
    "chicago4d.com",
    "chicagoanprints.com",
    "chicagoconsumerlawblog.com",
    "chicagocuttingtools.com",
    "chicagodress.ru",
    "chicagoguesthouses.com",
    "chicagopetphotoandvideo.com",
    "chicagotribunesnewsa13.com",
    "chicdressing.com",
    "chickditen.ga",
    "chickditen.gq",
    "chickditen.ml",
    "chickditen.tk",
    "chicken-hut-cavan.com",
    "chickenbreeds.net",
    "chickenexpressonline.com",
    "chickenkiller.com",
    "chickenlickn.com",
    "chickenrecipe.net",
    "chickkingtakeaway.com",
    "chickmail.com",
    "chicorealestateagents.com",
    "chicpick.ru",
    "chider.com",
    "chiefab.icu",
    "chiefcoder.com",
    "chieferfoundten.tech",
    "chiefir.icu",
    "chiefpizzalimerick.com",
    "chiefse.xyz",
    "chiefshort.recipes",
    "chiefsmana.com",
    "chiefsustainabilityofficer.courses",
    "chiefsustainabilityofficer.org",
    "chiefyagan.com",
    "chiehalan.ga",
    "chiehalan.gq",
    "chielo.com",
    "chiet.ru",
    "chieusangcaocap.com",
    "chik.cash",
    "chikendinner.com",
    "chikkala.net",
    "chil-e.com",
    "child-ready.xyz",
    "childeatingdisordertreatment.com",
    "childeatingdisordertreatmentcenters.com",
    "childfree.rocks",
    "childrenofprivilege.com",
    "childrens.md",
    "childrensclock.ru",
    "childsavetrust.org",
    "childswirlocean.xyz",
    "chile-cloud.com",
    "chilelinks.cl",
    "chilepro.cc",
    "chiletc.com",
    "chiliclubd2.com",
    "chilicookers.com",
    "chilkat.com",
    "chill81.live",
    "chill89.live",
    "chillikebabish.com",
    "chillleo.com",
    "chilloutpro.me",
    "chimeecom.gq",
    "chimera.pub",
    "chimesearch.com",
    "china-link-takeaway.com",
    "china-palace-finglas.com",
    "china.com",
    "china.net.vg",
    "china188bet.com",
    "chinabaijiaji.com",
    "chinabristlebrush.biz",
    "chinabristlebrushes.org",
    "chinabristlebrushes.us",
    "chinacourttakeaway.com",
    "chinadynastygoatstown.com",
    "chinagardenchinese.com",
    "chinakitchen-bray.com",
    "chinalook.com",
    "chinamail.com",
    "chinamarkets.xyz",
    "chinamoondublin.com",
    "chinaopendata.org",
    "chinapetrochemicals.com",
    "chinapetrochemicals.net",
    "chinashredders.com",
    "chinastar-sallynoggin.com",
    "chinatourcenter.com",
    "chinatov.com",
    "chinatowerletterkenny.com",
    "chinatowertakeaway.com",
    "chinauncombidding.com",
    "chinchai.ru",
    "chineafrique.com",
    "chinescars.ru",
    "chinesecool.com",
    "chinesefoodorlando.com",
    "chinesepoker.website",
    "chinesetomatoes.com",
    "chingbawork.cf",
    "chingbawork.ga",
    "chingbawork.gq",
    "chingbawork.tk",
    "chinglamad.ga",
    "chinookeyecare.com",
    "chiogofun.ml",
    "chiohonsau.cf",
    "chiohonsau.gq",
    "chiohonsau.ml",
    "chiohonsau.tk",
    "chipandbib.com",
    "chipbankasi.com",
    "chipekii.cf",
    "chipekii.ga",
    "chiphop.ru",
    "chipkolik.com",
    "chiplat.online",
    "chiplat.xyz",
    "chipscasinotips.com",
    "chipz2go.com",
    "chique.xyz",
    "chiquimail.club",
    "chirashizushisushibaracoruna.com",
    "chirk.com",
    "chiroinroswell.com",
    "chiromasterclass.com",
    "chironglobaltechnologies.com",
    "chiropracticaction.com",
    "chisel.design",
    "chistopole.ru",
    "chithi.tk",
    "chithi.xyz",
    "chithinh.com",
    "chitofficial.ru",
    "chitrarupacha.com",
    "chitwanholidays.com",
    "chivasso.cf",
    "chivasso.ga",
    "chivasso.gq",
    "chivasso.ml",
    "chivasso.tk",
    "chivesilicone.com",
    "chmembership.com",
    "chmento.com",
    "chnhh.com",
    "chnwfsb.com",
    "choang.asia",
    "chocaholic.com.au",
    "chockandblock.com",
    "chocklet.us",
    "choco-late-portugal.club",
    "choco-late.site",
    "choco.la",
    "chocofan.com",
    "chocolate-hungary.online",
    "chocolate-netherlands.online",
    "chocolate-portugal.live",
    "chocolate-portugal.online",
    "chocolate100.com",
    "chocolateclub.online",
    "chocolatelithuania.club",
    "chocolatelithuania.online",
    "chocolatepoland.club",
    "chocolateportu.club",
    "chocolates-portugal.online",
    "chocolathungary.club",
    "chocourl.com",
    "chodinh.com",
    "chogmail.com",
    "choi789.fun",
    "choice-intentions.site",
    "choice-network.site",
    "choicemail1.com",
    "choiceoneem.ga",
    "choicepointprg.net",
    "choiditermmi.tk",
    "choigamezowin.com",
    "choikingfun.com",
    "choirschool.org",
    "chokehntld.space",
    "chokiwnl.men",
    "cholaban.cf",
    "cholaban.gq",
    "cholaban.ml",
    "cholesterolbuddy.com",
    "cholesterolbuddyapp.com",
    "cholestifinshop.info",
    "chondrumjq.ru",
    "chong-mail.com",
    "chong-mail.net",
    "chong-mail.org",
    "chongsoft.org",
    "chonongnghiep.website",
    "choocho-telegram.ru",
    "choose-health.online",
    "choose-health.store",
    "choose-news.club",
    "choose-news.online",
    "choosebitcash.ru",
    "choosedean.org",
    "chooseyoulearningcenter.com",
    "chooseyourownbizventure.com",
    "chooseyourprizes8.life",
    "chooseyourscent.com",
    "choosietv.com",
    "chop-saratov.ru",
    "chopchopdublin.com",
    "chopsticks-takeaway.com",
    "chopstixchinesetakeaway.com",
    "choqr6r4.com",
    "choquangcao.website",
    "chordguitar.us",
    "chordmi.com",
    "choronosaat.site",
    "chothuevinhomesquan9.com",
    "chothuexeonline.com",
    "chotibachi.club",
    "chotm1.site",
    "choxetoanquoc.com",
    "chp.edu",
    "chr-transactions.com",
    "chratechbeest.club",
    "chris.burgercentral.us",
    "chriscollinsart.com",
    "chrishoffman.info",
    "chrisitina.com",
    "chrislyons.net",
    "christ.show",
    "christ.tools",
    "christadonaldphotography.com",
    "christensen.dk",
    "christian-topics.info",
    "christianity.app",
    "christianmail.net",
    "christiansen.dk",
    "christina365.cn",
    "christinyou-ministries.com",
    "christmas-shindig.com",
    "christmpkz.space",
    "christopherbainryan.com",
    "christopherfretz.com",
    "christopheriqbal.buzz",
    "christopherlittle.buzz",
    "christosia.website",
    "chrisycac.gq",
    "chrisycac.tk",
    "chromatichealthcare.com",
    "chromestreetcars.com",
    "chronic-fatigue.us",
    "chronichealing.net",
    "chronicjunkie.com",
    "chronicspender.com",
    "chronisbo.tk",
    "chronocrusade.com",
    "chronogolf.business",
    "chronogolf.org",
    "chrspkk.ru",
    "chrysant.info",
    "chrysler-india.club",
    "chtrbt.com",
    "chttgdd6.uno",
    "chuaccounting.com",
    "chuachezhei.com",
    "chuangtouquan.app",
    "chuangxueyuan.com",
    "chubby.monster",
    "chubbyteenmodels.com",
    "chubbyvidz.com",
    "chuckbennettcontracting.com",
    "chuckbtelb.space",
    "chucksfamilybuffet.com",
    "chucwopi.cf",
    "chucwopi.ga",
    "chucwopi.gq",
    "chucwopi.ml",
    "chucwopi.tk",
    "chudmailer2.com",
    "chudosbor-yagodnica.ru",
    "chue.today",
    "chuj.de",
    "chukenpro.tk",
    "chulavistahairsalons.com",
    "chulavistaheroinrehab.com",
    "chumpstakingdumps.com",
    "chungcumienbac24h.xyz",
    "chungfundraiser.com",
    "chunglede.net",
    "chungnhanisocert.com",
    "chungricto.cf",
    "chungricto.ga",
    "chungricto.gq",
    "chungricto.ml",
    "chungricto.tk",
    "chungtatre.com",
    "chunjanet.shop",
    "churchofo.com",
    "churchtactue.cf",
    "churchtactue.ga",
    "churchtactue.gq",
    "churchusa.com",
    "churning.app",
    "churreriachocolateriaroncerosalamanca.com",
    "chutichdisopam.space",
    "chuyennha37.com",
    "chuzx.com",
    "chxxfm.com",
    "chydesad.ru",
    "ci26vmxukn.xyz",
    "cia-agent.com",
    "cia.hu",
    "ciaburgca.cf",
    "ciaburgca.gq",
    "ciaburgca.tk",
    "cialisorderbymail.website",
    "cialisqw.com",
    "cianehigh.cf",
    "cianehigh.ga",
    "cianehigh.ml",
    "cianehigh.tk",
    "cianicu.cf",
    "cianicu.ga",
    "cianicu.gq",
    "cianicu.ml",
    "cianicu.tk",
    "ciaoweb.it",
    "ciaplugas.ga",
    "ciaplugas.ml",
    "ciaplugas.tk",
    "ciastannews.cf",
    "ciastannews.ga",
    "ciastannews.gq",
    "ciastannews.ml",
    "ciastannews.tk",
    "ciberbrain.ru",
    "ciberdietas.com",
    "cibernews.ru",
    "cibidi.ru",
    "cicciociccio.com",
    "cicek46.com",
    "cicek5.xyz",
    "cicekcibatman.xyz",
    "ciceronespanish.org",
    "ciceroneuk.org",
    "cickoz.info",
    "ciconia.tours",
    "cicop.ru",
    "cid.kr",
    "cidagift.cf",
    "cidagift.ga",
    "cidagift.gq",
    "cidagift.tk",
    "cidecitalia.org",
    "cideckkrik.cf",
    "cideckkrik.ga",
    "cideckkrik.gq",
    "cideckkrik.ml",
    "cideckkrik.tk",
    "cidstudio.ru",
    "ciecaperc.ga",
    "ciefenslink.cf",
    "ciefenslink.gq",
    "ciefenslink.ml",
    "ciefenslink.tk",
    "cieloglobalhealthmedia.com",
    "cientifica.org",
    "cieraheadphone.com",
    "ciesforec.cf",
    "ciesforec.gq",
    "ciesperu.com",
    "cifa.info",
    "cifamall.site",
    "cifjxgapk.shop",
    "cifra-pro.ru",
    "cigar-auctions.com",
    "cigar-vape.com",
    "cigdemakin.com",
    "ciglionline.xyz",
    "cignainsurancecoversrehab.info",
    "cihancaglarcankaya.online",
    "cihancaglarcankaya.xyz",
    "cikamalls.site",
    "cikhuh.us",
    "cikveyika.com",
    "cileepen.cf",
    "cileepen.ga",
    "cileepen.gq",
    "cileepen.ml",
    "cileepen.tk",
    "cilemail.ga",
    "cilikuaisou.com",
    "cililianfuli.net",
    "cililianfuli.org",
    "cilimao8.net",
    "cilo.us",
    "cimaclub.app",
    "cimaclub.fan",
    "cimaclub.network",
    "cimaclub.rocks",
    "cimaclub.social",
    "cimaclub.world",
    "cimaclub.zone",
    "cimas.info",
    "cimkocar-lor.ru",
    "cinchapi.org",
    "cinci.rr.com",
    "cincihandyman.com",
    "cincinnatiaddictiontreatment.com",
    "cincinnatialcoholrehab.com",
    "cincinnatialliance.com",
    "cincinnatihairsalons.com",
    "cincinnatiopiaterehab.com",
    "cincinow.net",
    "cincogotas.com",
    "cincyhotdeals.com",
    "cincyrealestatedeal.com",
    "cinderear.com",
    "cineblog01.pub",
    "cinema-online.net",
    "cinemacollection.ru",
    "cinemaestelar.com",
    "cinemaplaces.ru",
    "cinematicgames.com",
    "cinemay.icu",
    "cinetrika.ru",
    "cingcaroug.cf",
    "cingcaroug.ga",
    "cingcaroug.gq",
    "cingcaroug.tk",
    "cingram.org",
    "cingular.us",
    "cinhog.us",
    "cinj0q.info",
    "cinnamondread.com",
    "cintaipoker.net",
    "cintaqq.net",
    "ciobanu-art.com",
    "ciosopka.cf",
    "ciosopka.ml",
    "ciosopka.tk",
    "ciosose.cf",
    "ciosose.ga",
    "ciosose.ml",
    "cioudusrei.gq",
    "cioudusrei.tk",
    "cipadam.xyz",
    "cipaxa.gq",
    "cipaxa.ml",
    "cipaxa.tk",
    "cipchotab.cf",
    "cipchotab.ga",
    "cipchotab.gq",
    "cipchotab.tk",
    "cipher.onl",
    "ciprofloxacin500mg.store",
    "ciputraceme.com",
    "ciquren.com",
    "circchondbrac.cf",
    "circchondbrac.ga",
    "circchondbrac.tk",
    "circle.gift",
    "circlechat.org",
    "circlenervesmooth.website",
    "circlingtables.com",
    "circularindustries.com",
    "cireslie.gq",
    "cireslie.ml",
    "cirquefans.com",
    "cirugiaestetica10.com",
    "cispikt.ru",
    "cists.site",
    "cit-progress.ru",
    "citadel-nn.ru",
    "citadelcorp.net",
    "citasyencuentros-meet-backup.com",
    "citationslist.com",
    "cite.name",
    "citeme.info",
    "citeweb.net",
    "citippgad.ga",
    "citippgad.gq",
    "citippgad.ml",
    "citippgad.tk",
    "citiz.net",
    "citizenguide.earth",
    "citizenkane.us",
    "citizens.earth",
    "citizensearth.org",
    "citizensvegas.com",
    "citlink.net",
    "citoyensdefrance.ngo",
    "citrines.store",
    "citroen-argentina.club",
    "citroen-mexico.club",
    "citromail.hu",
    "citron-client.ru",
    "citrusheightsattorneys.com",
    "city-of-bath.org",
    "city-of-birmingham.com",
    "city-of-brighton.org",
    "city-of-cambridge.com",
    "city-of-coventry.com",
    "city-of-edinburgh.com",
    "city-of-lichfield.com",
    "city-of-lincoln.com",
    "city-of-liverpool.com",
    "city-of-manchester.com",
    "city-of-nottingham.com",
    "city-of-oxford.com",
    "city-of-swansea.com",
    "city-of-westminster.com",
    "city-of-westminster.net",
    "city-of-york.net",
    "city.dk",
    "city2city.com",
    "citybeautifulnews.com",
    "citycentrehotelslondon.com",
    "citydent96.ru",
    "cityguide.store",
    "citylightsart.com",
    "citymdisp.ga",
    "citymdisp.gq",
    "citymdisp.ml",
    "citynetusa.com",
    "cityofcardiff.net",
    "cityoflondon.org",
    "cityofnah.com",
    "cityroyal.org",
    "citytorate.ru",
    "citytowercasino.com",
    "citytrendspainting.com",
    "cityverve.com",
    "citywinerytest.com",
    "citywinetour.com",
    "cityxp.app",
    "ciudad-activa.com",
    "ciudad.com.ar",
    "ciudadano.net",
    "ciutada.net",
    "ciutada.org",
    "civbc.com",
    "civic-link.org",
    "civicviz.com",
    "civilium.com",
    "civilizationdesign.xyz",
    "civilokant903.cf",
    "civilokant903.ga",
    "civilokant903.gq",
    "civilokant903.ml",
    "civilokant903.tk",
    "civoo.com",
    "civvic.ro",
    "civx.org",
    "ciweltrust33deep.tk",
    "cix07.space",
    "ciyeshops.site",
    "ciyuan.moe",
    "cizulaa.space",
    "cjfs8z.us",
    "cjkvd.top",
    "cjnep.us",
    "cjpcoqha.shop",
    "cjpeg.com",
    "cjr99.com",
    "cjuprf2tcgnhslvpe.cf",
    "cjuprf2tcgnhslvpe.ga",
    "cjuprf2tcgnhslvpe.gq",
    "cjuprf2tcgnhslvpe.ml",
    "cjuprf2tcgnhslvpe.tk",
    "cjymanbetx.com",
    "ck1024.rocks",
    "ck12.cf",
    "ck12.ga",
    "ck12.gq",
    "ck12.ml",
    "ck12.tk",
    "ck2ts.site",
    "ckaazaza.tk",
    "ckancheck.xyz",
    "ckc9du.xyz",
    "ckcarpetcare.com",
    "ckcltd.ru",
    "ckcmzm.fun",
    "ckfibyvz1nzwqrmp.cf",
    "ckfibyvz1nzwqrmp.ga",
    "ckfibyvz1nzwqrmp.gq",
    "ckfibyvz1nzwqrmp.ml",
    "ckfibyvz1nzwqrmp.tk",
    "ckfmqf.fun",
    "ckfsunwwtlhwkclxjah.cf",
    "ckfsunwwtlhwkclxjah.ga",
    "ckfsunwwtlhwkclxjah.gq",
    "ckfsunwwtlhwkclxjah.ml",
    "ckfsunwwtlhwkclxjah.tk",
    "ckhmfk.fun",
    "ckicp.ru",
    "ckiso.com",
    "ckjmpt.fun",
    "ckjmyn.fun",
    "ckjmyp.fun",
    "ckk59.xyz",
    "ckkmkm.fun",
    "ckkmnh.fun",
    "ckland.ru",
    "cklmbx.fun",
    "ckme1c0id1.cf",
    "ckme1c0id1.ga",
    "ckme1c0id1.gq",
    "ckme1c0id1.ml",
    "ckme1c0id1.tk",
    "ckmmfg.fun",
    "ckmmfm.fun",
    "cknmsm.fun",
    "cknoell.best",
    "cko.kr",
    "ckoie.com",
    "ckpmlk.fun",
    "ckw3vt.best",
    "ckwmzm.fun",
    "ckxen.info",
    "ckxmct.fun",
    "ckxoe.us",
    "ckymgw.fun",
    "ckymyx.fun",
    "ckyxtcva19vejq.cf",
    "ckyxtcva19vejq.ga",
    "ckyxtcva19vejq.gq",
    "ckyxtcva19vejq.ml",
    "ckyxtcva19vejq.tk",
    "ckzmyd.fun",
    "cl-cl.org",
    "cl.gl",
    "cl0ne.net",
    "claimab.com",
    "claimdai.xyz",
    "claimdair.xyz",
    "claimmea.xyz",
    "claimmean.xyz",
    "claimspree.club",
    "claimspree.xyz",
    "claimtaxrebate.com",
    "claimyourprize.life",
    "claimyourprize46.life",
    "claire.moe",
    "clairefernandes.com",
    "clairelomas.com",
    "clairvoir.com",
    "clamiver.ga",
    "clamiver.ml",
    "clamiver.tk",
    "clamor584kf.online",
    "clamresdeu.ga",
    "clamresdeu.gq",
    "clamsight.com",
    "clanbase.club",
    "clanbase.xyz",
    "clancygreen55places.com",
    "clandest.in",
    "clanlenpa.cf",
    "clanlenpa.ga",
    "clanlenpa.gq",
    "clanlenpa.ml",
    "clanlenpa.tk",
    "clanopia.com",
    "clanrank.com",
    "clanranks.com",
    "clanstorm.com",
    "clapmers.cf",
    "clapnaser.tk",
    "clapryocon.ga",
    "clapryocon.gq",
    "claracosmo.com",
    "claramail.com",
    "claresguide.com",
    "claritance.xyz",
    "clarkgriswald.net",
    "clarksvillecomputers.com",
    "clarksvillequote.com",
    "clarksvilleshowerglass.com",
    "clashatclintonemail.com",
    "clashkings.ru",
    "clashlive.com",
    "clashofclanshackdeutsch.xyz",
    "clashroyale-br.com",
    "clasicoloto.ru",
    "clasponoti.gq",
    "class1air.com",
    "classactioner.com",
    "classactshop.xyz",
    "classesmail.com",
    "classic-buy-outlet.host",
    "classicalconvert.com",
    "classicalfan.com",
    "classicaltantra.com",
    "classicdom.com",
    "classicexch.com",
    "classicjewelryboutiques.com",
    "classicjewelrygroups.com",
    "classicmail.co.za",
    "classicopizza.online",
    "classicudderbalm.net",
    "classicustyle.com",
    "classified.zone",
    "classitheme.com",
    "classivmvm.ru",
    "classivox.com",
    "classydeveloper.com",
    "classytrump.works",
    "classywebsite.co",
    "clathasul.cf",
    "clathasul.gq",
    "clathasul.tk",
    "claudiaamaya.com",
    "claudialmeida.com",
    "claus.tk",
    "clavlisor.ga",
    "clavlisor.gq",
    "clavlisor.tk",
    "clawpaw.xyz",
    "clay.xyz",
    "clayandplay.ru",
    "claymorepool.com",
    "clayponds.net",
    "claytonnashhomes.com",
    "clayware.com",
    "clckgumshoe.us",
    "cldqbt.icu",
    "clds.net",
    "cldsale.top",
    "clean-living-ventures.com",
    "clean.pro",
    "cleanad.icu",
    "cleanandgreencar.com",
    "cleanandgreencar.org",
    "cleanauthz.com",
    "cleaneatingmoms.com",
    "cleaning-co.ru",
    "cleaningdirectllc.com",
    "cleaningpluscompany.com",
    "cleaningshop.futbol",
    "cleanmoraled.us",
    "cleanpat.xyz",
    "cleanroombrush.net",
    "cleanroombrush.org",
    "cleanroombrush.us",
    "cleanroombrushes.us",
    "cleansafemail.com",
    "cleansidingmd.com",
    "cleansu.xyz",
    "clear-code.ru",
    "clear-project.ru",
    "clear.com",
    "clear.net.nz",
    "clear23.rest",
    "clear2join.com",
    "clear2pray.com",
    "clear2school.com",
    "clear2vote.com",
    "clearbri.xyz",
    "clearbrookatbanyan.com",
    "clearjaxfl.com",
    "clearlyskinroutine.com",
    "clearmail.online",
    "clearpia.us",
    "clearwatermail.info",
    "clearwaycommumitysolar.com",
    "clearwire.net",
    "clearworry.com",
    "cledbel-24k-gold-kupit.ru",
    "clegesli.cf",
    "clegesli.gq",
    "clegesli.tk",
    "clemons-law.com",
    "clendere.asia",
    "clene.xyz",
    "cleonika.ru",
    "clericisbc.site",
    "clerk.com",
    "clerk.legal",
    "clesasiv.cf",
    "clesasiv.ga",
    "clesasiv.gq",
    "clesasiv.ml",
    "clesasiv.tk",
    "clesrora.cf",
    "clesrora.ml",
    "clevahub.com",
    "clevelandaddictiontreatment.com",
    "clevelandalcoholrehab.com",
    "clevelandheroinrehab.com",
    "clever-game.ru",
    "clever-reporterflair-blogger-brilliance.com",
    "clever4you.ru",
    "clevinab.ga",
    "clevinab.gq",
    "clevinab.ml",
    "clfkzc.icu",
    "clfpt.com",
    "clhscy.icu",
    "clic8edgt.monster",
    "clicbiober.cf",
    "clicbiober.gq",
    "clicbiober.ml",
    "clicbiober.tk",
    "click-email.com",
    "click-mail.net",
    "click-mail.top",
    "click-me2.com",
    "click-me3.com",
    "click-me4.com",
    "click-me5.com",
    "click-me6.com",
    "click24.site",
    "click2mail.net",
    "clickandgo-do-go.space",
    "clickanerd.net",
    "clickas.ru",
    "clickbank.life",
    "clickbank.name",
    "clickbank.today",
    "clickbank.world",
    "clickcws.online",
    "clickdeal.co",
    "clickforadate.com",
    "clickfun.ru",
    "clicklinksolutions.com",
    "clicklo.site",
    "clickmagnit.ru",
    "clickmail.info",
    "clicknett.com",
    "clickpet.online",
    "clickpricing.com",
    "clickrebill.com",
    "clicksearch.network",
    "clicktrack.ru",
    "clientologist.net",
    "clientreviews.org",
    "clientsconnector.com",
    "cliffcarrs.info",
    "cliffhanger.com",
    "cliffsvillage.com",
    "clikco.ru",
    "clil53drf.buzz",
    "clil54ghf.buzz",
    "clim59iyy.buzz",
    "climchabjale.tk",
    "climdo.app",
    "clin60oio.buzz",
    "clindamycin.website",
    "clinerut.cf",
    "clinerut.ga",
    "clinerut.gq",
    "clinerut.tk",
    "clinicacarabanchel.com",
    "clinicalcellculture.com",
    "clinicane.com",
    "clinicatbf.com",
    "clintonemailhearing.com",
    "clintonemerson.com",
    "clintonsparks.com",
    "clip-hot-philippin.tk",
    "clipclip.email",
    "clipmail.cf",
    "clipmail.eu",
    "clipmail.ga",
    "clipmail.gq",
    "clipmail.ml",
    "clipmail.tk",
    "clipmails.com",
    "clips.pics",
    "clipscreen.com",
    "cliptik.net",
    "clit.games",
    "clit.loan",
    "clitinrasphi.ml",
    "clitlickers.com",
    "clixser.com",
    "clk-safe.com",
    "clk2020.co",
    "clk2020.com",
    "clk2020.info",
    "clk2020.net",
    "clk2020.org",
    "clk2021.com",
    "clmkoc.us",
    "clnsandbox.com",
    "cloacking.space",
    "clock-sale24.ru",
    "clock64.ru",
    "clockat.xyz",
    "clockatt.xyz",
    "clockequi.us",
    "clockkne.recipes",
    "clockobes.xyz",
    "clockstr.xyz",
    "clockups.recipes",
    "clockus.ru",
    "clockworkpropmgmt.com",
    "clocupproj.cf",
    "clocupproj.ga",
    "clocupproj.gq",
    "clocupproj.ml",
    "clonchectu.ga",
    "clonchectu.gq",
    "clonefbtmc1.club",
    "cloneforsale.com",
    "clonequick.com",
    "cloneroad.com",
    "cloneviptmc1.club",
    "clonidine.website",
    "clord.online",
    "closdeal.net",
    "close-room.ru",
    "close.vote",
    "close2you.ne",
    "close2you.net",
    "closed-rooms.ru",
    "closerscrm.org",
    "closesla.buzz",
    "closetcreative.org",
    "closeticv.space",
    "closetraid.me",
    "closevide.xyz",
    "closewo.xyz",
    "closium.com",
    "closurist.com",
    "closurize.com",
    "clothinglias.com",
    "clothingshop.info",
    "clotrack.online",
    "cloud-casts.com",
    "cloud-mail.net",
    "cloud-mail.top",
    "cloud-node.online",
    "cloud-server.email",
    "cloud22020.xyz",
    "cloud41photography.xyz",
    "cloud41productions.xyz",
    "cloud41service.xyz",
    "cloud41studios.xyz",
    "cloud43er.xyz",
    "cloud43films.xyz",
    "cloud43music.xyz",
    "cloud43productions.xyz",
    "cloud47art.xyz",
    "cloud47design.xyz",
    "cloud47photo.xyz",
    "cloud47photography.xyz",
    "cloud47shop.xyz",
    "cloud49plus.xyz",
    "cloud49services.xyz",
    "cloud99.pro",
    "cloud99.top",
    "cloudcamber.com",
    "cloudcarib.net",
    "cloudcasts.xyz",
    "cloudcohol.com",
    "cloudcohol.net",
    "cloudcohol.org",
    "clouddisruptor.com",
    "cloudemail.xyz",
    "cloudflare-london.com",
    "cloudflare.community",
    "cloudflaremedia.com",
    "cloudflaremedia.net",
    "cloudflaremedia.org",
    "cloudhorizon.org",
    "cloudido.com",
    "cloudinfo.website",
    "cloudlfront.com",
    "cloudmail.gq",
    "cloudmail.tk",
    "cloudmarriage.com",
    "cloudmchost.tk",
    "cloudns.asia",
    "cloudns.cc",
    "cloudns.cf",
    "cloudns.cx",
    "cloudns.gq",
    "cloudonf.com",
    "cloudosys.com",
    "cloudpath.dev",
    "cloudpush.com",
    "cloudsaveapp.com",
    "cloudserver.store",
    "cloudstat.top",
    "cloudstreaming.info",
    "cloudsyou.com",
    "cloudt12server01.com",
    "cloudyfood.com",
    "clounatiks.ru",
    "cloverdelldesign.com",
    "clovermail.net",
    "clovisattorneys.com",
    "clowncloudmusic.com",
    "clownflair.com",
    "clpers.us",
    "clpuqprtxtxanx.cf",
    "clpuqprtxtxanx.ga",
    "clpuqprtxtxanx.gq",
    "clpuqprtxtxanx.ml",
    "clpuqprtxtxanx.tk",
    "clqmgytk.club",
    "clrjjsnsl.shop",
    "clrmail.com",
    "cls-audio.club",
    "clsaimli.space",
    "clsn.top",
    "clsn1.com",
    "clt.dev",
    "cltj5.us",
    "club-internet.fr",
    "club-pchelka.ru",
    "club127.com",
    "club4skin.ru",
    "club4x4.net",
    "clubalfa.com",
    "clubam.ru",
    "clubaprilia.com",
    "clubatv.ru",
    "clubaudi.co.uk",
    "clubaustin.co.uk",
    "clubbeast.com",
    "clubbeetle.co.uk",
    "clubbentley.co.uk",
    "clubbers.net",
    "clubbingfrance.com",
    "clubbmw.com",
    "clubcadete.biz",
    "clubcarpcon.cf",
    "clubcarpcon.ga",
    "clubcarpcon.ml",
    "clubcarpcon.tk",
    "clubcaterham.co.uk",
    "clubdelgusto.info",
    "clubdiariodeyucatan.com",
    "clubducati.com",
    "clubeovelhas.com",
    "clubexnis.ga",
    "clubexnis.gq",
    "clubexnis.ml",
    "clubexnis.tk",
    "clubfier.com",
    "clubforthefuture.org",
    "clubharley.co.uk",
    "clubhonda.net",
    "clubhowse.com",
    "clubhyatt.com",
    "clubjaguar.com",
    "clubkawasaki.com",
    "clublamborghini.co.uk",
    "clublexus.co.uk",
    "clublife.ga",
    "clublotus.com",
    "clubmailonline.com",
    "clubmclaren.com",
    "clubmember.org",
    "clubmercedes.net",
    "clubmg.co.uk",
    "clubmini.co.uk",
    "clubmorgan.com",
    "clubmorris.co.uk",
    "clubnetnoir.com",
    "clubonline.top",
    "clubporsche.com",
    "clubrenault.net",
    "clubscountries.com",
    "clubstt.com",
    "clubsubaru.com",
    "clubsuzuki.com",
    "clubtestsa.info",
    "clubtoyota.co.uk",
    "clubtriumph.com",
    "clubvdo.net",
    "clubwilliams.com",
    "clubyamaha.com",
    "clucentmeri.site",
    "clue-1.com",
    "cluemail.com",
    "cluevoid.com",
    "cluevoid.org",
    "clunker.org",
    "clunkymembrane.com",
    "clusterconference2016.eu",
    "clutunpodli.ddns.info",
    "cluu.de",
    "cly1au.us",
    "cm01b5.us",
    "cm2019.net",
    "cm4s.com",
    "cm69.club",
    "cm6slv.us",
    "cma4x3.com",
    "cmail.club",
    "cmail.com",
    "cmail.net",
    "cmail.org",
    "cmail.ru",
    "cmailg.com",
    "cmailing.com",
    "cmamso.site",
    "cmastertrk.com",
    "cmawfxtdbt89snz9w.cf",
    "cmawfxtdbt89snz9w.ga",
    "cmawfxtdbt89snz9w.gq",
    "cmawfxtdbt89snz9w.ml",
    "cmawfxtdbt89snz9w.tk",
    "cmbapp.net",
    "cmbet365.com",
    "cmbjsn.com",
    "cmc88.tk",
    "cmcbet88.xyz",
    "cmccarbuyers.com",
    "cmconv.com",
    "cmcosmetics.ru",
    "cmdgame.ru",
    "cmdmadecheck.xyz",
    "cmdshare.com",
    "cmdsync.com",
    "cmdvao.ru",
    "cmecsgocup.ru",
    "cmepexpo.com",
    "cmewin.pro",
    "cminulfi.ga",
    "cminulfi.ml",
    "cmjinc.com",
    "cmksquared.com",
    "cmm-moving.com",
    "cmmgtuicmbff.ga",
    "cmmgtuicmbff.ml",
    "cmmgtuicmbff.tk",
    "cmoki.pl",
    "cmoplay.us",
    "cmpmail.com",
    "cmpnetmail.com",
    "cmqtt.com",
    "cms-rt.com.com",
    "cms8hz.us",
    "cmsalpha.net",
    "cmsp3.com",
    "cmsp4.com",
    "cmsp5.com",
    "cmsp6.com",
    "cmsq0.com",
    "cmsq2.com",
    "cmsq3.com",
    "cmsq4.com",
    "cmtt3.com",
    "cmtt5.com",
    "cmuddshc.shop",
    "cmyk.se",
    "cmykyazilim.xyz",
    "cn.ibm.com",
    "cnamed.com",
    "cnba.xyz",
    "cnbishi.com",
    "cncb.de",
    "cncfabrication.us",
    "cncnfc.com",
    "cncsystems.de",
    "cnctape.com",
    "cncy69.xyz",
    "cnd8704.com",
    "cndps.com",
    "cnegal.com",
    "cnetmail.net",
    "cnew.ir",
    "cnfrmtion.xyz",
    "cnh.industrial.ga",
    "cnh.industrial.gq",
    "cnhdjf.com",
    "cnhhs.net",
    "cnhindustrial.cf",
    "cnhindustrial.ga",
    "cnhindustrial.gq",
    "cnhindustrial.ml",
    "cnhindustrial.tk",
    "cni9jz.us",
    "cninefails.us",
    "cnj.agency",
    "cnkacyoz.shop",
    "cnlesson.com",
    "cnlgaming.site",
    "cnmk3t950vo5x2c.xyz",
    "cnmsg.net",
    "cnn.com",
    "cnn.coms.hk",
    "cnnenc.com",
    "cnnsimail.com",
    "cnovelhu.com",
    "cnplace.com",
    "cnsa.biz",
    "cnsds.de",
    "cnsg-host.com",
    "cnshosti.in",
    "cntt.in",
    "cntv.cn",
    "cnwyxq.com",
    "cnzhongtuo.net",
    "co-aa214.stream",
    "co-uk-online.xyz",
    "co.cc",
    "co.nr",
    "co1vgedispvpjbpugf.cf",
    "co1vgedispvpjbpugf.ga",
    "co1vgedispvpjbpugf.gq",
    "co1vgedispvpjbpugf.ml",
    "co1vgedispvpjbpugf.tk",
    "co2-regulator.com",
    "co3i.icu",
    "coaatal24.com",
    "coachexile.us",
    "coachfit.ru",
    "coaching-supervision.at",
    "coachingmarketingdereseau.com",
    "coachlea.xyz",
    "coachmaverick.com",
    "coachmavericks.com",
    "coachnetworkmarketing.com",
    "coachoutletstoreonlinenyc.com",
    "coachplea.icu",
    "coachquest.net",
    "coachtransformationacademy.com",
    "coahla.net",
    "coahla.org",
    "coalamails.com",
    "coalitionfightmusic.com",
    "coalizaopeloevangelho.com",
    "coapp.net",
    "coareli.gq",
    "coareli.tk",
    "coastalantennas.com",
    "coastalnow.net",
    "coastalwindspublishinghouse.com",
    "coastertools.com",
    "coastglas.us",
    "coastlay.xyz",
    "coastlinebaptistchurch.org",
    "coaststoo.us",
    "coaxregimentcopy.website",
    "cobaltcrowproductions.com",
    "cobaltcrowproductions.xyz",
    "cobarekyo1.ml",
    "cobete.cf",
    "cobhammurphy.com",
    "cobin2hood.com",
    "cobin2hood.company",
    "cobizfunding.com",
    "cobratandooritakeaway.com",
    "cobrei.app",
    "cocacomi.com",
    "cocaine.ninja",
    "cocainerehab.center",
    "coccx1ajbpsz.cf",
    "coccx1ajbpsz.ga",
    "coccx1ajbpsz.gq",
    "coccx1ajbpsz.ml",
    "coccx1ajbpsz.tk",
    "cochatz.ga",
    "cochisi.cf",
    "cochisi.gq",
    "cochisi.tk",
    "cocinacadadia.com",
    "cock.li",
    "cocknass.com",
    "cockpitdigital.com",
    "cocloseams.gq",
    "cocloseams.ml",
    "cocoacars.info",
    "cocoaplrqm.space",
    "cocobahis40.com",
    "cocobahis47.com",
    "cocobahis48.com",
    "cocobahis49.com",
    "cocobahis50.com",
    "cocobet77.com",
    "cocodani.cf",
    "cocodivo.com",
    "cocoivy.site",
    "cocomobay.com",
    "coconuthotelguest.com",
    "cocosaiindia.com",
    "cocosandcoffee.net",
    "cocotakeaway.com",
    "cocovpn.com",
    "cocreators.tech",
    "cocreatorsinstitute.com",
    "cocreatorsinstitute.net",
    "cocreatorsinstitute.org",
    "cocreatorsnetwork.org",
    "cocreatorstech.net",
    "cocreatorstech.org",
    "cocreatorsventures.com",
    "cocureate.org",
    "codaoutlets.site",
    "code-mail.com",
    "code4less.biz",
    "codealam.com",
    "codealam.org",
    "codeandscotch.com",
    "codebandits.com",
    "codebender.org",
    "codec.ro",
    "codec.ro.ro",
    "codec.roemail.ro",
    "codecamerica.net",
    "codefarm.dev",
    "codeforgerycrab.website",
    "codefree24.de",
    "codegency.com",
    "codehermit.net",
    "codenative.info",
    "codenexty.com",
    "codeorbecoded.com",
    "codepromo.cc",
    "coder.hu",
    "coderconfs.com",
    "coderpixel.com",
    "codersandfounders.org",
    "coderspeech.top",
    "codetox.center",
    "codetoxcenter.com",
    "codeulous.com",
    "codingfury.tv",
    "codingliteracy.com",
    "codingschool.dev",
    "codivide.com",
    "codiviti.com",
    "codupmyspace.com",
    "codyting.com",
    "coemecal.ga",
    "coemecal.ml",
    "coemecal.tk",
    "coepoe.cf",
    "coepoe.ga",
    "coepoe.tk",
    "coepoebete.ga",
    "coepoekorea.ml",
    "coercivity.best",
    "coexistglobal.org",
    "coezhojz.shop",
    "cofactormarketing.com",
    "coffee-26.ru",
    "coffee-time.online",
    "coffeecruelty.org",
    "coffeelovers.life",
    "coffeemakers101.info",
    "coffeeok.net",
    "coffeepancakewafflebacon.com",
    "coffeepoint.tech",
    "coffeeseur.com",
    "coffeeshipping.com",
    "cogeco.ca",
    "cognalize.com",
    "cognalizer.com",
    "cognalsearch.com",
    "cognitiveways.xyz",
    "cogpal.com",
    "cohalfpricedlisting.com",
    "cohchecovet.com",
    "coid.biz",
    "coidrafho.cf",
    "coidrafho.ml",
    "coieo.com",
    "coilbrush.net",
    "coilbrush.us",
    "coilbrushes.us",
    "coin-bearer.net",
    "coin-games.com",
    "coin-host.net",
    "coin-hub.net",
    "coin-link.com",
    "coin-mail.com",
    "coin-one.com",
    "coin114.net",
    "coin888.host",
    "coinalgotrader.com",
    "coinbearer.com",
    "coinbearer.net",
    "coinbet.games",
    "coinbin.cafe",
    "coinbroker.club",
    "coincal.org",
    "coincheckup.net",
    "coincrowd.ventures",
    "coindie.com",
    "coinecon.com",
    "coinero.com",
    "coinexchange365.com",
    "coinfinexx.exchange",
    "coinhelp123.com",
    "coinific.com",
    "coinlez.com",
    "coinlife.net",
    "coinlink.club",
    "coinlocal.com",
    "coinmasterhack.website",
    "coinmati.net",
    "coinnect.net",
    "coinshop24.biz",
    "coinsmail.net",
    "coinspices.com",
    "coinsteemit.com",
    "coinstrade.biz",
    "cointunnel.com",
    "coinvers.com",
    "coinyoutube.com",
    "coinzone.pro",
    "coinzs.us",
    "coiosidkry57hg.gq",
    "cojqh5.com",
    "cok.3utilities.com",
    "cokils.com",
    "cokxj.us",
    "cola.cool",
    "colabcolibri.site",
    "colabital.com",
    "colacoce.com",
    "colafanta.cf",
    "colaik.com",
    "colchesterelderlawgroup.com",
    "colchicine247.video",
    "coldcoldstorage.xyz",
    "coldemail.info",
    "coldenent.com",
    "coldirondesign.com",
    "coldmail.com",
    "coldmail.ga",
    "coldmail.gq",
    "coldmail.ml",
    "coldmail.tk",
    "coldstreamforge.com",
    "colebrager.com",
    "coledawson.com",
    "colefamilydentistcom.com",
    "colegio-frances.edu.mx",
    "colemantaylorreman.com",
    "coleure.com",
    "colevillecapital.com",
    "colicinbabies.online",
    "colicinbabies.xyz",
    "colinabet.com",
    "colinzaug.net",
    "colitasdeangel.com",
    "colivingbansko.com",
    "collabio.dev",
    "collablayer.com",
    "collapse3b.com",
    "collapsehtn.website",
    "collectiblesuperstore.com",
    "collectionsohio.com",
    "collectivemtl.com",
    "collector.org",
    "collectors.global",
    "collectors.international",
    "collectors.solutions",
    "colledoo.com",
    "collegebeat.com",
    "collegeclub.com",
    "collegedate.online",
    "collegedate.store",
    "collegeforcanon.org",
    "collegelakesdentistry.com",
    "collegemail.com",
    "collegeofpublicspeaking.com",
    "collegepolos.com",
    "colleges.com",
    "collegetester.com",
    "collisiondatabase.com",
    "collnaca.cf",
    "colloidalsilversolutions.com",
    "colmek.xyz",
    "colmeks.com",
    "colnoiball.cf",
    "colobus.best",
    "colocimmo.org",
    "cologies.site",
    "cologno.cf",
    "cologuard.us",
    "cologuard45plus.com",
    "cologuardcrc.net",
    "colokjeep.org",
    "coloniallifee.com",
    "coloninsta.tk",
    "colonized736my.xyz",
    "coloplus.ru",
    "colopnw.com",
    "coloquintida.best",
    "color4you.ru",
    "coloradoaddictiontreatment.center",
    "coloradocattlefeeders.com",
    "coloradodetoxcenter.com",
    "coloradofieldhockey.com",
    "coloradofreshstart.com",
    "coloradoheroinrehab.com",
    "coloradomarijuanadispensaries.com",
    "coloradospringscocainerehab.com",
    "coloradospringsheroinrehab.com",
    "colorants656em.online",
    "colorflower.net",
    "colorflowers.net",
    "colorists889fc.online",
    "colorweb.cf",
    "colorworld.info",
    "colosgods.ru",
    "coloshild.ru",
    "coloshron.ru",
    "colossuscloud.us",
    "colt45forsale.tk",
    "coltonattorneys.com",
    "columbia.edu",
    "columbiacable.net",
    "columbus.rr.com",
    "columbuscasino.design",
    "columbusinfo.xyz",
    "columbusnm.net",
    "columbusrr.com",
    "columnist.com",
    "com-04536875422364784521.top",
    "com-101634586696.help",
    "com-1024493459167.online",
    "com-1028952384656065698650.top",
    "com-14147678891143.top",
    "com-19428504172.icu",
    "com-21036823570248695140.top",
    "com-358207258746541784.xyz",
    "com-54547894563525454.top",
    "com-access-wallet.info",
    "com-bqdf8uzwyo.com",
    "com-bv8e8b9ond.com",
    "com-d804xgpj8j.com",
    "com-daily.win",
    "com-dailywin.cloud",
    "com-dailywin.live",
    "com-dailywin.online",
    "com-dailywin.site",
    "com-g5rjsgg93w.com",
    "com-gh.xyz",
    "com-hr0s02qp09.com",
    "com-log.xyz",
    "com-ma.net",
    "com-mobilealert.com",
    "com-surveywin.info",
    "com-surveywin.online",
    "com-surveywin.site",
    "com-tca64rtel.xyz",
    "com-ty.biz",
    "com-xd5r29y97r.com",
    "com-xvrv6yt51g.com",
    "com.ar",
    "com.au.pn",
    "com.ninja",
    "com.nu",
    "com3b.com",
    "comam.ru",
    "comarchiemountbattenwindsor.com",
    "comarketpartners.com",
    "comaro-compressoren.ru",
    "comast.com",
    "comast.net",
    "combicheria.com",
    "combindjqy.space",
    "combined.investments",
    "combined.site",
    "combinedinvestments.org",
    "combo88.com",
    "combofan.space",
    "comboparlay.com",
    "combrotech77rel.gq",
    "combustore.co",
    "comcapfactoring.org",
    "comcast.com",
    "comcast.net",
    "come-on-day.pw",
    "come.vn",
    "comeclosertojesus.com",
    "comectrix.com",
    "comedy-battl.best",
    "comeonday.pw",
    "comeonfind.me",
    "comeporon.ga",
    "comercialsindexa.com",
    "comersant7.site",
    "cometloansonline.com",
    "comfortmamia.ru",
    "comic.com",
    "comilzilla.org",
    "cominghamm.com",
    "comingsoon.support",
    "comitatofesteteolo.com",
    "comitatofesteteolo.xyz",
    "comlive.ga",
    "comlive.gq",
    "comlive.ml",
    "comlive.tk",
    "comm.craigslist.org",
    "commande-sp.com",
    "comments2g.com",
    "commercant.online",
    "commerce-magazine-undersell.ru",
    "commerce-now.online",
    "commercecrypto.com",
    "commercemix.com",
    "commerchand.com",
    "commercialpropertiesphilippines.com",
    "commercialunits.com",
    "commercialwindowcoverings.org",
    "commercieel.works",
    "commergot.cf",
    "commicoastroly.us",
    "commoditymantra.com",
    "commonentranceexam.net",
    "commonentrancelaw.com",
    "commonmangazette.com",
    "commonred.net",
    "commonwalk.org",
    "communicate-with-women.com",
    "communifin.com",
    "communitybuildingworks.xyz",
    "communityconnect.com",
    "communitymarketleader.net",
    "commutwqtw.space",
    "comnorerk.cf",
    "comnorerk.ga",
    "comnorerk.tk",
    "comnow.icu",
    "comnya.com",
    "comofazernegociosonline.com",
    "comogin.com",
    "comohacer.club",
    "comoplantartomates.com",
    "comostevyal.tech",
    "comostsicurezza.com",
    "compali.com",
    "compandlap.xyz",
    "company.legal",
    "companycoder.com",
    "companynotifier.com",
    "comparatable.com",
    "comparatore.xyz",
    "comparecyan.com",
    "compareimports.com",
    "compareshippingrates.org",
    "compass4x.asia",
    "compasschat.ru",
    "compbooksra.tk",
    "compcoddmeg.ga",
    "compcoddmeg.gq",
    "competenergy.com",
    "competeshop.xyz",
    "competirinternacional.website",
    "competition-black.xyz",
    "compgentcrev.tk",
    "comphelpforu.ru",
    "complet.stream",
    "completecleaningmaintenance.com",
    "completedesign.info",
    "completegolfswing.com",
    "completelycruising.com",
    "complexitygaming.net",
    "complextender.ru",
    "complicatedsound.com",
    "complikqhg.space",
    "complimentaryxae.website",
    "complxmind.com",
    "comporium.net",
    "compositional.best",
    "compostrevolution.net",
    "compoundtown.com",
    "compradacasa.online",
    "comprafacilpe.com",
    "compraho.ml",
    "compraho.tk",
    "comprarfarmacia.site",
    "comprarsoatenlinea.com",
    "comprehensivesearchinitiatives.com",
    "comprendemail.com",
    "compressionrelief.com",
    "compuofertas.net",
    "compupedia.com",
    "compuserve.com",
    "computations.me",
    "computedsharing.com",
    "computer-expert.net",
    "computer-freak.com",
    "computer-remont21.ru",
    "computer4u.com",
    "computerconfused.com",
    "computerdrucke.de",
    "computermail.net",
    "computernaked.com",
    "computers-wizards.ru",
    "computerslistnews.site",
    "computersshop.futbol",
    "compvershy.cf",
    "compvershy.ga",
    "compvershy.gq",
    "compvershy.ml",
    "compvershy.tk",
    "compwilbi.ga",
    "compwilbi.gq",
    "compwilbi.ml",
    "compwilbi.tk",
    "compxino.cf",
    "comremas.cf",
    "comremas.ga",
    "comremas.gq",
    "comremas.ml",
    "coms.hk",
    "comsafe-mail.net",
    "comunidadmujer.app",
    "comunique.net",
    "comvicheria.com",
    "comwest.de",
    "comwtf.com",
    "comyci.website",
    "conbactgab.cf",
    "conbactgab.gq",
    "conbactgab.ml",
    "conbactgab.tk",
    "conboxtv.com",
    "concdysre.ga",
    "concdysre.gq",
    "concdysre.ml",
    "concealed.company",
    "concentric.net",
    "concentriccreativity.com",
    "concepac.ga",
    "concepac.ml",
    "concepac.tk",
    "conceptionmayday.com",
    "conceptiontragedy.com",
    "conceptprojectawards.com",
    "concertized570lt.online",
    "conchiform.xyz",
    "conchonddis.cf",
    "conchonddis.ga",
    "conchonddis.tk",
    "conciertocostarica.com",
    "concisestudy.com",
    "concordpayments.net",
    "concoursedb.org",
    "concoursup.com",
    "concretebotherroad.website",
    "concretecheck.xyz",
    "concretegrinding.melbourne",
    "concursosoftwarelibremalaga.org",
    "concussia.info",
    "condaliv.com",
    "condico.cf",
    "condico.ga",
    "condico.ml",
    "conditionalbreakpoint.com",
    "condominiumcollection.com",
    "condorsnestprophouse.com",
    "condovestments.com",
    "conduct.vote",
    "conductivebrush.biz",
    "conduscient.org",
    "condys.app",
    "conexcol.com",
    "conf.work",
    "confeccionesdelnorte.com",
    "confeitariaelaine.online",
    "conferencenationale.org",
    "conferencewallingford.com",
    "confidencemakeover.net",
    "confidential.life",
    "confidential.tips",
    "config.work",
    "confir-mail1.com",
    "confirm.live",
    "confirma.center",
    "confirma.express",
    "confirmist.com",
    "conflict-theory.org",
    "conflicttheory.net",
    "conforkxum.space",
    "confriti.gq",
    "confriti.ml",
    "confriti.tk",
    "confrontationfuel.buzz",
    "confrontstars.net",
    "confrontstars.org",
    "confsisal.ga",
    "confsisal.ml",
    "cong.ru",
    "congdong.mobi",
    "congdong43.com",
    "congdongmu.net",
    "congdongviettrung.com",
    "congdongxaydung.com",
    "congmart.live",
    "congnghemoi.top",
    "congress.earth",
    "congroli.ml",
    "congthanhtoan.website",
    "congtymaydongphuc.org",
    "congtythangmay.top",
    "conicode.com",
    "coniemporium.site",
    "conk.com",
    "conkeafe.cf",
    "conkeafe.ga",
    "conkeafe.gq",
    "conkeafe.ml",
    "conmato.cf",
    "conmato.ml",
    "conmato.tk",
    "conmochila.app",
    "connacle.com",
    "connatser.com",
    "connect-auto.info",
    "connect1to1.com",
    "connect365.us",
    "connect4free.net",
    "connectbox.com",
    "connected-project.online",
    "connecticutdetox.center",
    "connectiontheory.org",
    "connectme.name",
    "connectwithjournalists.com",
    "connexion.website",
    "connorgoodwin.buzz",
    "conok.com",
    "conqfmnwo.shop",
    "conquergods.net",
    "conquest.shop",
    "conquestchain.icu",
    "conquestofcastles.ru",
    "conrafo.gq",
    "conrafo.ml",
    "conravi.cf",
    "conravi.gq",
    "conreaquar.gq",
    "conreaquar.ml",
    "conreaquar.tk",
    "conreva.cf",
    "conreva.tk",
    "conroymultimedia.com",
    "consciousagingconference.com",
    "consciousbreathing.net",
    "conseilaf-energie.com",
    "conselhosaude.org",
    "consentientgroup.com",
    "conservation.africa",
    "conservativedaily.org",
    "conservativegetaway.com",
    "conservativerepublican.news",
    "conservativesagainstbush.com",
    "conservativeworlddaily.com",
    "consignag.com",
    "console3.net",
    "consolumb.cf",
    "consolumb.ga",
    "consolumb.gq",
    "consolumb.ml",
    "consphlegin.cf",
    "consphlegin.ga",
    "conspiracygraph.com",
    "consrapo.cf",
    "consrapo.ga",
    "consrapo.gq",
    "consrapo.tk",
    "constantandassociates.com",
    "constelacaofamiliar.website",
    "constelacaonerd.com",
    "constellational.com",
    "constructionandesign.xyz",
    "constructiondojo.com",
    "construinforme.net",
    "construtrabajo.com",
    "construyendovidas.org",
    "constuctech.com",
    "consul.dev",
    "consultant.com",
    "consultantneuropsychiatrist.com",
    "consultationfluctuationsulphur.website",
    "consultoriaempresarialgo.info",
    "consultus-dz.com",
    "consumablespointofsale.com",
    "consumer-oriented.host",
    "consumerdictionary.com",
    "consumerreports.space",
    "consumerriot.com",
    "consumestl.com",
    "consuna.cf",
    "consuna.ga",
    "consuna.gq",
    "consuna.tk",
    "contact-munchet.club",
    "contact-munchet.ltd",
    "contact.fifieldconsulting.com",
    "contactos-casuales.us",
    "contactout1000.ga",
    "contbay.com",
    "contcalpa.cf",
    "contcalpa.ga",
    "contcalpa.gq",
    "contcalpa.ml",
    "contecksto.club",
    "contemis.gq",
    "content.rocks",
    "contentcreatorshub.com",
    "contentculturegroup.com",
    "contentmarketing.community",
    "contentmarketingconferences.com",
    "contentpeacock.com",
    "contentsmagazine.net",
    "contentwanted.com",
    "contestincentiveawardnational.club",
    "contextconversation.com",
    "contextconversation.org",
    "contextmenu.org",
    "contfiripre.tk",
    "conthydterp.gq",
    "conthydterp.tk",
    "contingency-power.com",
    "continuationbushdifficulty.website",
    "contiocho.cf",
    "contiocho.ga",
    "contiocho.gq",
    "contiocho.tk",
    "contract431.xyz",
    "contractnotify.com",
    "contractor.net",
    "contractor.tax",
    "contractoraccountant.ltd",
    "contractorssupplydepot.com",
    "contractorsupport.org",
    "contractortax.contractors",
    "contrarygarden.com",
    "contrasted.org",
    "contrasto.cu.cc",
    "contravu.xyz",
    "control-bki.ru",
    "controllernation.com",
    "conttirdia.cf",
    "conttirdia.ml",
    "conttirdia.tk",
    "conttogon.cf",
    "conttogon.gq",
    "contywil.gq",
    "conuos.net",
    "convectair.net",
    "conventionalizing691bj.online",
    "conventionstrategy.win",
    "conversyo.org",
    "convert.blue",
    "convertallvideo.org",
    "convertonline.com",
    "convertor.app",
    "conveyancersnsw.com",
    "conveyorbrush.net",
    "conveyorbrush.org",
    "conveyorbrush.us",
    "conveyorbrushes.us",
    "convivemail.club",
    "convoswithcosmo.info",
    "conwayinterfaithclinic.org",
    "conwex.cf",
    "conwex.ml",
    "conwex.tk",
    "conyiz.us",
    "coo621.com",
    "coo68141.com",
    "coo721.com",
    "coo8171.com",
    "coobz0gobeptmb7vewo.cf",
    "coobz0gobeptmb7vewo.ga",
    "coobz0gobeptmb7vewo.gq",
    "coobz0gobeptmb7vewo.ml",
    "coobz0gobeptmb7vewo.tk",
    "coochie.pro",
    "cooconti.ga",
    "cooconti.ml",
    "cooconti.tk",
    "cooiblue.online",
    "cook-islands-accommodation.com",
    "cook-islands-holiday.com",
    "cookiecollector.com",
    "cookiecooker.de",
    "cookiemonster.com",
    "cookingbooko.club",
    "cookingclassesnapavalley.com",
    "cookinghelpsite.com",
    "cookingonthecar.com",
    "cookiriebooks.com",
    "cookmasterok.ru",
    "cookskill.com",
    "cookwareshop.live",
    "cookwsyc.space",
    "cool-your.pw",
    "cool.br",
    "cool.dk",
    "cool.fr.nf",
    "coolandwacky.us",
    "coolbaby.org",
    "coolbild.ru",
    "coolbye2.fun",
    "coolchinaconference.com",
    "coolclimatesolutions.com",
    "coolcombine.com",
    "coolcompanychallenge.com",
    "cooldestinationshq.com",
    "coole-files.de",
    "coolgadge.com",
    "coolgoodsmarket.info",
    "coolgoose.ca",
    "coolgoose.com",
    "coolgranny.net",
    "coolhobbyideas.club",
    "coolidgeproject.org",
    "coolimpool.org",
    "coolkeywestwatersports.com",
    "coolkiwi.com",
    "coollist.com",
    "coollyjuti-ro.com",
    "coolmail.com",
    "coolmail.net",
    "coolmail.ooo",
    "coolmailcool.com",
    "coolmecca.com",
    "coolminigift.com",
    "coolorganizertraining.com",
    "coolplaceto.bike",
    "coolplut.ru",
    "coolpoland.com",
    "coolrio.com",
    "coolsend.com",
    "coolshopsing.ru",
    "coolsite.net",
    "coolsouthbeach.com",
    "cooltoad.com",
    "coolurl.tk",
    "coolvirginislands.com",
    "coolwisconsindells.com",
    "coolyour.pw",
    "coolzurich.com",
    "coomungiechelseagardens.com",
    "coonalleystudios.com",
    "coonvo.care",
    "cooola.info",
    "cooooool.com",
    "cooperation.net",
    "cooperationtogo.net",
    "coordinator.earth",
    "cop5.net",
    "copacabana.com",
    "copagratis.com",
    "copasi.ga",
    "copastore.co",
    "copdfmanuales.xyz",
    "copenhagenstreet-art.com",
    "copi.site",
    "copistaed.ga",
    "copiv8.us",
    "copjlix.de.vc",
    "copland-os.com",
    "copones.cf",
    "copones.ml",
    "copones.tk",
    "copot.info",
    "copper.lighting",
    "copper.net",
    "copperascoveapartments.com",
    "copperbacksplash.us",
    "coppercounter.us",
    "copperemail.com",
    "coppersmithfamily.com",
    "copticmail.com",
    "copticnn.net",
    "copycookbook.com",
    "copyrightdesk.com",
    "copytrade.investments",
    "coracleansehelp.com",
    "coral-tour.space",
    "coralgablesstraighttalk.com",
    "coralsnake.studio",
    "cordcutting.news",
    "cordfreevacuum.com",
    "cordisresortnvillas.com",
    "cordivamedical.com",
    "cordlessduoclean.com",
    "cordlessshark.com",
    "core-pack.at",
    "core-rehab.org",
    "core4.app",
    "coreblockchain.academy",
    "coreclip.com",
    "corelife.biz",
    "corelife.org",
    "corenels.xyz",
    "corepliantcuff.website",
    "coreral.cf",
    "coreral.ga",
    "coreral.gq",
    "corewi.cf",
    "corewi.ga",
    "corewi.gq",
    "corewi.ml",
    "corewi.tk",
    "corhandpevol.ml",
    "corianiofoundation.com",
    "corleone.org",
    "cormg.net",
    "cornavirus.attorney",
    "cornells.com",
    "cornerfraud.us",
    "cornerpub.com",
    "cornerstitchdesigns.com",
    "cornerstonebapt.org",
    "corngroupsupplies-au.com",
    "cornmusihr.space",
    "cornstowagecure.website",
    "cornwallmotorfactors.com",
    "corona-virus-live.ru",
    "corona-virus.institute",
    "corona.how",
    "coronacijfers.shop",
    "coronaflix.xyz",
    "coronagg.com",
    "coronahulpdeliemers.online",
    "coronanewsupdate.com",
    "coronaotel.com",
    "coronascan.ru",
    "coronastats.shop",
    "coronatest-ig.online",
    "coronavirus-covid-19.today",
    "coronavirus-mir.com",
    "coronavirusrecoverycommission.com",
    "corosocial.net",
    "corouge.best",
    "corp.ereality.org",
    "corpoalnaturale.com",
    "corporate.doctor",
    "corporate.foundation",
    "corporatedirtbag.com",
    "corporatelitigationlawyerboston.com",
    "corporateplaydays.info",
    "corporateplaydays.net",
    "corporatesocialresponsibilityatlcbo.com",
    "corpuschristicocainerehab.com",
    "corpuschristiopiaterehab.com",
    "corpuscqyd.space",
    "correllohome.info",
    "correllohome.org",
    "correo.blogos.net",
    "correo.terra.com.gt",
    "correoparacarlos.ga",
    "correos-es.site",
    "corrientelatina.net",
    "corrsfan.com",
    "corrupt.life",
    "corsairdre.com",
    "corsanywhere.tech",
    "corsarius.net",
    "cortex.kicks-ass.net",
    "cortexconcept.com",
    "cortexnode.online",
    "cortinet.com",
    "cortneysplace.com",
    "corumkardesleremlak.com",
    "corvallisdoctors.com",
    "corveelijst.online",
    "corveelijsten.online",
    "corveelijstje.online",
    "corveelijstjes.online",
    "corychase.site",
    "corychase.xyz",
    "cos9c.us",
    "cosasuccede.info",
    "coseh6.us",
    "cosmela.ru",
    "cosmeticprocedure.org",
    "cosmeticsdermatology.com",
    "cosmetixs.ru",
    "cosmetwzzi.space",
    "cosmo.com",
    "cosmogame.site",
    "cosmogia.net",
    "cosmogulf.xyz",
    "cosmohealth.care",
    "cosmolot-slot.site",
    "cosmopokers.net",
    "cosmorph.com",
    "cosmoshost.com",
    "cosmyc.network",
    "cosmycnetwork.com",
    "cosnx.com",
    "cosplayblog.com",
    "cosplays.pro",
    "cosplaystores.com",
    "cosplaystrippers.com",
    "cospolspen.cf",
    "cospolspen.ga",
    "cospolspen.gq",
    "cospolspen.tk",
    "costaakkan.xyz",
    "costablancaphoto.com",
    "costaricabestrips.com",
    "costco.tel",
    "costcompared.com",
    "costhewca.cf",
    "costhewca.gq",
    "costprogbou.ml",
    "cotas.net",
    "cotastic.com",
    "cotatiphil.org",
    "cotefi.site",
    "cotenets.info",
    "cotlmk.us",
    "cotmandenecrescentbr5.com",
    "cotodaynews.site",
    "cotro.fun",
    "cottage-delight.com",
    "cottageoakpropertie.com",
    "cottongods.net",
    "cottonnovdx.email",
    "cottonwoodcoveresort.net",
    "couchhappens.org",
    "coudmango.com",
    "coudmango.net",
    "coudmango.org",
    "cougargonzo.com",
    "coughone.com",
    "couhl.live",
    "couldbe.shop",
    "couleurelle.com",
    "coullion.com",
    "coulterberrytales.com",
    "council.vote",
    "councous.shop",
    "counntryfinancial.com",
    "counsellingmenbrisbane.com",
    "counsellor.com",
    "counterduster.biz",
    "counterduster.net",
    "counterduster.us",
    "counterdusters.biz",
    "counterdusters.us",
    "counterempiricaldamage.website",
    "countertracking.com",
    "counterweigh.com",
    "countkilo.cf",
    "countrryfinancial.com",
    "countryfinaancial.com",
    "countryfinabcial.com",
    "countryfinanncial.com",
    "countrylover.com",
    "countryofearth.app",
    "countryofearth.foundation",
    "countryroadsbaseball.org",
    "countrysong.ru",
    "countryyfinancial.com",
    "coupandev.shop",
    "coupdefoudre.immo",
    "couplesandtantra.com",
    "couponcode.agency",
    "couponcodey.com",
    "couponsdisco.com",
    "couponx.ru",
    "couponyes.ru",
    "coupor.com",
    "courriel.fr.nf",
    "courrieltemporaire.com",
    "courses.farm",
    "court-records.org",
    "courtatcrossroads.com",
    "courtch.xyz",
    "courtesans.international",
    "courtfi.icu",
    "courtfib.icu",
    "courthousehotelcarlow.com",
    "courtivo.space",
    "courtrf.com",
    "courtstreetofficesupplies.com",
    "courtun.icu",
    "cousinit.mooo.com",
    "coutinho.news",
    "covad.net",
    "covechurch.mobi",
    "covelocoop.com",
    "coventryfans.com",
    "cover360.net",
    "coverglar.icu",
    "coverhove.us",
    "coverification.org",
    "covermebag.global",
    "coveryo.xyz",
    "coveryout.xyz",
    "coveted-clicks.site",
    "covfefe-mail.gq",
    "covfefe-mail.tk",
    "covid2020.online",
    "covidfinder.asia",
    "covidfinder.best",
    "covidfinder.club",
    "covidfinder.digital",
    "covidfinder.network",
    "covidfinder.rocks",
    "covidfinder.space",
    "covidfinder.xyz",
    "covteh37.ru",
    "cowaramupwines.com",
    "cowavewifi.net",
    "cowaway.com",
    "cowboyglossary.com",
    "cowboywmk.com",
    "cowcell.com",
    "cowerkn.com",
    "cowisdom.com",
    "cowokbete.ga",
    "cowokbete.ml",
    "cowork.click",
    "coworking-bansko.com",
    "coworkingabroad.com",
    "coworkingabroad.org",
    "coworkinghalifax.com",
    "coworkrating.com",
    "cowshipin.net",
    "cowstore.net",
    "cowstore.org",
    "cowtube.club",
    "cowtv.club",
    "cowvideo.info",
    "cowvtjui.xyz",
    "cox.com",
    "cox.net",
    "coxbete.cf",
    "coxbete99.cf",
    "coxinet.net",
    "coxmail.com",
    "coxnet.cf",
    "coxnet.ga",
    "coxnet.gq",
    "coxnet.ml",
    "coyotebio-usa.com",
    "coystigis.cf",
    "coystigis.ga",
    "coystigis.gq",
    "coza.ro",
    "cozmingusa.info",
    "cozre.site",
    "cozyboomerangllc.com",
    "cp0730.com",
    "cp668y.com",
    "cpa.digital",
    "cpaawards.ru",
    "cpabn.com",
    "cpacartago.site",
    "cpafhd.us",
    "cpamail.net",
    "cpanelhome.com",
    "cpanellicense.shop",
    "cpaonline.net",
    "cpaoz.com",
    "cpapa.ooo",
    "cpaycard.asia",
    "cpb-online.com",
    "cpc.cx",
    "cpederal.com",
    "cpelws.tokyo",
    "cpffinanceiro.club",
    "cpg39b-mail.xyz",
    "cphoneos.com",
    "cpib.email",
    "cpinternet.com",
    "cpizgz.site",
    "cpldevice.com",
    "cpluldsvd.shop",
    "cplusfinanzen.com",
    "cpmail.life",
    "cpmm.ru",
    "cpno.email",
    "cpo-inc.net",
    "cppvwb6vjocx2zf.xyz",
    "cps.edu",
    "cpsboard.com",
    "cpsboard.net",
    "cpshomebuys.com",
    "cpsipalmsprings.com",
    "cpspainshop.com",
    "cpsystems.ru",
    "cpuk3zsorllc.cf",
    "cpuk3zsorllc.ga",
    "cpuk3zsorllc.gq",
    "cpuk3zsorllc.ml",
    "cpuk3zsorllc.tk",
    "cpuwindows.com",
    "cpviy.com",
    "cq5j.icu",
    "cqczth.com",
    "cqdebryansk.ru",
    "cqebhyy.com",
    "cqj1ht.site",
    "cqn1.com",
    "cqrax.live",
    "cqrenben.com",
    "cqtest.ru",
    "cqtnbyy.com",
    "cqutssntx9356oug.cf",
    "cqutssntx9356oug.ga",
    "cqutssntx9356oug.gq",
    "cqutssntx9356oug.ml",
    "cqutssntx9356oug.tk",
    "cqweqe-naonc.icu",
    "cqwmokhnv6.xyz",
    "cqzktj.com",
    "cr.cloudns.asia",
    "cr01.xyz",
    "cr219.com",
    "cr3wmail.sytes.net",
    "cr3wxmail.servequake.com",
    "cr8.website",
    "cr8robotics.online",
    "cr97mt49.com",
    "cra1g.com",
    "crabsheadache.com",
    "crabtreejewelers.com",
    "crabvietnam.com",
    "crackdra.icu",
    "cracker.hu",
    "crackfreedown.com",
    "crackherakati.me",
    "crackingaccounts.ga",
    "crackmail.cc",
    "crackmail.thekingstim.tk",
    "crackofdawnale.com",
    "cracksens.us",
    "crackthematch.com",
    "cracowtoday.com",
    "craftbrands.net",
    "craftcate.us",
    "craftd.org",
    "craftemail.com",
    "craftfiga.site",
    "craftletter.com",
    "craftpixel.online",
    "craftsfrommissouri.com",
    "craftsrussia.ru",
    "crafttheweb.com",
    "crafttigh.press",
    "craftval.xyz",
    "craftvalu.xyz",
    "craftygardening.solutions",
    "craftymall.com",
    "cragavpivo.tk",
    "crana.us",
    "crankhole.com",
    "crankmails.com",
    "cranpiwy.gq",
    "cranpiwy.ml",
    "crap.kakadua.net",
    "crapcoin.com",
    "crapiris.cf",
    "crapiris.ga",
    "crapiris.ml",
    "crapmail.org",
    "crappertracker.com",
    "crappykickstarters.com",
    "crapsonline.com",
    "crapsseal.se",
    "crapulo.us",
    "crashkiller.ovh",
    "crashlandstudio.com",
    "crashproofcryptocurrency.com",
    "crashquota.com",
    "crastination.de",
    "cratcrao.shop",
    "crates.blog",
    "cratfoutlet.com",
    "cratorster.cf",
    "cratorster.ga",
    "cratorster.gq",
    "cratorster.tk",
    "cratos724.com",
    "cratosslot202.com",
    "cratosslot206.com",
    "cratosslot210.com",
    "cratosslot211.com",
    "cravenpublishing.com",
    "craveyatq.space",
    "cravinger.xyz",
    "cravingery.online",
    "cravingify.xyz",
    "crawler.report",
    "crazaholic.xyz",
    "crazedanddazed.com",
    "crazeoutlets.site",
    "crazepage.com",
    "crazespaces.pw",
    "crazies.club",
    "crazies.dev",
    "crazies.love",
    "crazies.photos",
    "crazies.rocks",
    "crazies.today",
    "crazikim.club",
    "crazy.ru",
    "crazydoll.us",
    "crazykittens.xyz",
    "crazylemonssafe.space",
    "crazymail.info",
    "crazymail.online",
    "crazymailing.com",
    "crazypro.xyz",
    "crazysexycool.com",
    "crazyworldshop.ru",
    "crazywot.net",
    "crazzzyballs.ru",
    "crc20.com",
    "crdyzx.info",
    "cre8to6blf2gtluuf.cf",
    "cre8to6blf2gtluuf.ga",
    "cre8to6blf2gtluuf.gq",
    "cre8to6blf2gtluuf.ml",
    "cre8to6blf2gtluuf.tk",
    "creality3dturkiye.com",
    "creality3dturkiye.xyz",
    "cream.pink",
    "creambrak.icu",
    "creamcras.fun",
    "creamgl.icu",
    "creamglo.icu",
    "creampiemoviez.com",
    "creamwor.buzz",
    "crearartearacataca2019.com",
    "crearenmexico.com",
    "creasily.xyz",
    "creasimkor.cf",
    "creasimkor.ga",
    "creasimkor.gq",
    "creasimkor.tk",
    "creasite-auvergne.com",
    "creaspere.cf",
    "creaspere.ga",
    "creaspere.gq",
    "creaspere.ml",
    "create-email.com",
    "createabooking.com",
    "createaliar.com",
    "createaonlineincome.com",
    "createavatar.org",
    "createdrive.com",
    "createdrive.net",
    "createhut.ml",
    "createlink.xyz",
    "createphase.com",
    "createyourcream.com",
    "creatingyournew.website",
    "creatingyourstyles.com",
    "creation-site-web-bordeaux.net",
    "creationmeditation.org",
    "creationsfestives.com",
    "creationsgrecques.com",
    "creationuq.com",
    "creativainc.com",
    "creativas.de",
    "creative-mates.sk",
    "creative365.ru",
    "creativecommonsza.org",
    "creativedynamics.pro",
    "creativeenergyworks.com",
    "creativeinfo.ru",
    "creativelicenseshop.com",
    "creativemates.sk",
    "creativemix.info",
    "creativepantry.online",
    "creativeshocker.com",
    "creativesystemsconsulting.net",
    "creativeweddingphotograph.org",
    "creazionisa.com",
    "crebbo.org",
    "credd.me",
    "credenic.cf",
    "credenic.ga",
    "credenic.ml",
    "credenic.tk",
    "credeqclev.ga",
    "credeqclev.ml",
    "credeqclev.tk",
    "credinti.cf",
    "credinti.ml",
    "credinti.tk",
    "credit-007.com",
    "credit-alter.online",
    "credit-card-98.ru",
    "credit-credit.ru",
    "creditaccesshub.com",
    "creditcardcounsel.com",
    "creditcarddumpsites.ru",
    "creditcardforums.org",
    "creditcards.land",
    "creditcards.ninja",
    "creditcardsfinancial.com",
    "crediti-banki.ru",
    "creditonegocios.com",
    "creditrepair4u.site",
    "creditsafesverige.biz",
    "creditsafesverige.info",
    "creditsafesverige.net",
    "crednomas.cf",
    "crednomas.ga",
    "crednomas.gq",
    "crednomas.ml",
    "credopizzaitalian.com",
    "credtaters.cf",
    "credtaters.ga",
    "credtaters.gq",
    "credtaters.ml",
    "credtaters.tk",
    "credup.ru",
    "creekwooddesoto.com",
    "cremationcon.com",
    "cremcalsult.gq",
    "cremcalsult.tk",
    "creo.cloudns.cc",
    "creo.ctu.edu.gr",
    "creo.iotu.nctu.me",
    "creo.nctu.me",
    "cresquiju.cf",
    "cresquiju.gq",
    "cresquiju.ml",
    "cresquiju.tk",
    "cresset.site",
    "crestonstudents.org",
    "crestwave.online",
    "cretovcae.cf",
    "cretovcae.ga",
    "cretovcae.gq",
    "cretovcae.tk",
    "crevus.org",
    "crewefans.com",
    "crewinsurance.ru",
    "crewstart.com",
    "criarblogue.com",
    "cricbett.icu",
    "cricerev.cf",
    "cricerev.gq",
    "cricerev.ml",
    "cricketcraft.net",
    "cricketersfoodtruck.com",
    "cricketnigeria.org",
    "crillix.com",
    "crim3-house.ml",
    "crimea-kurort-online.ru",
    "criminality.biz",
    "criminalize9pk.online",
    "criminalizes233iy.online",
    "crimpastprep.cf",
    "crimpastprep.ga",
    "crimpastprep.ml",
    "crimpastprep.tk",
    "crimson.ua.edu",
    "criptoluxury.store",
    "criptonic.co",
    "criptonic.xyz",
    "criqclscdl.space",
    "crisis-media.ru",
    "crisiscrisis.co.uk",
    "cristal365.ru",
    "cristalin.ru",
    "cristauxinc.com",
    "cristianemail.com",
    "cristicookeprograms.com",
    "cristlocksapt.buzz",
    "cristywhitman.com",
    "crisuabil.cf",
    "crisuabil.ga",
    "crisuabil.tk",
    "critcijo.cf",
    "critcijo.ga",
    "critcijo.gq",
    "critical-studies.info",
    "criticalcaremonthly.com",
    "critterpost.com",
    "crjtvgaj.shop",
    "crk.review",
    "crm-mebel.ru",
    "crm-souz.ru",
    "crmartinrealestate.com",
    "crmplant.ru",
    "crnr.store",
    "croatiaresidence.com",
    "croboldu.gq",
    "croboldu.ml",
    "crockegecy.space",
    "croeso.com",
    "croftcare.group",
    "cromelet.ga",
    "cromelet.gq",
    "cron.black",
    "cron.network",
    "cronostv.site",
    "cronx.com",
    "croontites.cf",
    "croontites.ga",
    "croontites.gq",
    "croontites.ml",
    "cropshots.org",
    "cropyloc.com",
    "cross-group.ru",
    "cross-law.ga",
    "cross-law.gq",
    "cross.cash",
    "crossborderapps.net",
    "crossbrand.ru",
    "crosscree.icu",
    "crosscwums.host",
    "crosscwums.site",
    "crossed.de",
    "crossfirecheats.org",
    "crossfitbaza.ru",
    "crossfitcoastal.com",
    "crossfra.email",
    "crosshairs.com",
    "crossingbridgeestates.com",
    "crosslink.net",
    "crossroadsmail.com",
    "crossroadsone.org",
    "crosstroo.email",
    "crosswatershed.org",
    "crosswinds.net",
    "crosswordchecker.com",
    "crosswordtracker.net",
    "crotslep.ml",
    "crotslep.tk",
    "crow.gq",
    "crow.ml",
    "crowd-mail.com",
    "crowd-mobile.com",
    "crowd.works",
    "crowdaffiliates.com",
    "crowdali.icu",
    "crowdaliv.xyz",
    "crowdanimoji.com",
    "crowdanimoji.net",
    "crowdcate.us",
    "crowdcoin.biz",
    "crowdcoinnetwork.com",
    "crowdcoins.info",
    "crowdeos.com",
    "crowdga.icu",
    "crowdgeographer.com",
    "crowdlegal.org",
    "crowdlycoin.com",
    "crowdmobile.biz",
    "crowdmobile.org",
    "crowdpiggybank.com",
    "crowdpiggybank.org",
    "crowdpl.xyz",
    "crowdplea.xyz",
    "crowdstoo.site",
    "crowdwi.xyz",
    "crowdwid.xyz",
    "crowity.com",
    "crowndata.com",
    "crowned.global",
    "crownestates20.com",
    "crsqdy.info",
    "crstl.net",
    "crstnvrn.website",
    "crtrecycling.net",
    "crturner.com",
    "crub.cf",
    "crub.ga",
    "crub.gq",
    "crub.ml",
    "crub.tk",
    "crudeillustratecontent.website",
    "crudeoildemulsifier.com",
    "crudewag.icu",
    "cruisecentraladviser.com",
    "cruisefloppy.com",
    "crulle.ru",
    "crumlin-grill.com",
    "crunchcompass.com",
    "crunchsharing.com",
    "crunchybiscuits.space",
    "crunkmail.com",
    "crushfilix.site",
    "crushnova.com",
    "crusronhorn.cf",
    "crusronhorn.ga",
    "crusronhorn.ml",
    "crusronhorn.tk",
    "crusthost.com",
    "cruzenow.com",
    "crwmail.com",
    "cry.pub",
    "cry4helponline.com",
    "crydeck.com",
    "cryingmail.com",
    "crymail2.com",
    "cryodrakon.com",
    "cryodrakon.info",
    "cryodrakon.pro",
    "cryodrakon.space",
    "cryojo.xyz",
    "cryotik.com",
    "cryozzy.xyz",
    "cryp.email",
    "crypecar.cf",
    "crypecar.ml",
    "crypecar.tk",
    "crypemail.info",
    "crypinchom.cf",
    "crypinchom.gq",
    "crypinchom.tk",
    "crypstats.top",
    "cryptca.net",
    "crypticelement.cloud",
    "crypticelement.club",
    "crypticelement.games",
    "crypticinvestments.com",
    "crypto-lock.net",
    "crypto-net.club",
    "crypto-rates.info",
    "crypto.tyrex.cf",
    "crypto1x1.info",
    "crypto1x1.org",
    "crypto1x1.xyz",
    "crypto3pl.net",
    "cryptocapitalism.pro",
    "cryptocean.cards",
    "cryptocean.info",
    "cryptocean.online",
    "cryptocitycenter.com",
    "cryptocrowd.mobi",
    "cryptodinbog.com",
    "cryptodough.life",
    "cryptofriends.network",
    "cryptofuture.website",
    "cryptogameshub.com",
    "cryptogamming.net",
    "cryptogrow.global",
    "cryptogrow.store",
    "cryptogrow.tech",
    "cryptoinvestar.com",
    "cryptoinvestmentsummit.com",
    "cryptoiravault.com",
    "cryptolist.cf",
    "cryptoloot.life",
    "cryptomoments24.com",
    "cryptone.market",
    "cryptone.tel",
    "cryptonet.top",
    "cryptontrade.ga",
    "cryptopatron.org",
    "cryptopda.com",
    "cryptope.xyz",
    "cryptopiggybank.info",
    "cryptopiggybank.mobi",
    "cryptopiggybank.org",
    "cryptoprobes.com",
    "cryptoprocessingnow.com",
    "cryptosimple.club",
    "cryptoslant.com",
    "cryptosmileys.com",
    "cryptosoloira.com",
    "cryptostack401k.com",
    "cryptostackcapital.com",
    "cryptostackfund.com",
    "cryptostackfunds.com",
    "cryptostackrothira.com",
    "cryptostackventurefund.com",
    "cryptoszone.ga",
    "cryptotravis.com",
    "cryptoupdates.live",
    "cryptowalletstore.com",
    "cryptowned.com",
    "cryptstagram.com",
    "crystal7.biz",
    "crystalbahis4.com",
    "crystalbahis5.com",
    "crystalfallsfas.com",
    "crystalgroupind.com",
    "crystalkckq.email",
    "crystalmoon.org",
    "crystalplatter.com",
    "crystalrp.ru",
    "crystle.club",
    "crytpocurrency.biz",
    "cryxus.net",
    "cryxus.org",
    "cs-24.ru",
    "cs-go-club.ru",
    "cs.com",
    "cs.email",
    "cs4h4nbou3xtbsn.cf",
    "cs4h4nbou3xtbsn.ga",
    "cs4h4nbou3xtbsn.gq",
    "cs4h4nbou3xtbsn.ml",
    "cs4h4nbou3xtbsn.tk",
    "cs5xugkcirf07jk.cf",
    "cs5xugkcirf07jk.ga",
    "cs5xugkcirf07jk.gq",
    "cs5xugkcirf07jk.ml",
    "cs5xugkcirf07jk.tk",
    "cs715a3o1vfb73sdekp.cf",
    "cs715a3o1vfb73sdekp.ga",
    "cs715a3o1vfb73sdekp.gq",
    "cs715a3o1vfb73sdekp.ml",
    "cs715a3o1vfb73sdekp.tk",
    "csbfr8.site",
    "csccblida.com",
    "csccsports.com",
    "cschammel.com",
    "cscrddata.com",
    "csdm73.ru",
    "csdoland.net",
    "csek.net",
    "csepxf.com",
    "csf24.de",
    "csfait.com",
    "csfav4mmkizt3n.cf",
    "csfav4mmkizt3n.ga",
    "csfav4mmkizt3n.gq",
    "csfav4mmkizt3n.ml",
    "csfav4mmkizt3n.tk",
    "csgo-funknife.ru",
    "csgo-market.ru",
    "csgo2.org",
    "csgoaim.ru",
    "csgoanalyzer.com",
    "csgoauth.fun",
    "csgobomj.com",
    "csgodeal.net",
    "csgodemos.win",
    "csgodose.com",
    "csgodumbaz.ru",
    "csgofan.club",
    "csgofast2.com",
    "csgofast3.com",
    "csgofreem4.fun",
    "csgokyril.fun",
    "csgologin5.site",
    "csgopositive.xyz",
    "csgosave.ru",
    "csgoterem.fun",
    "csh.ro",
    "cshauthor.biz",
    "cshauthor.com",
    "cshoesfirst.info",
    "csi-miami.cf",
    "csi-miami.ga",
    "csi-miami.gq",
    "csi-miami.ml",
    "csi-miami.tk",
    "csi-newyork.cf",
    "csi-newyork.ga",
    "csi-newyork.gq",
    "csi-newyork.ml",
    "csi-newyork.tk",
    "csi.com",
    "csinibaba.hu",
    "csoftmail.cn",
    "csomerlotdesign.com",
    "csontvary.org",
    "cspeakingbr.com",
    "cspfbyy.com",
    "cspointblank.com",
    "cspsid-rodnik.ru",
    "csrbot.com",
    "csrbots.com",
    "csreports.space",
    "csringreece.me",
    "cssccw.com",
    "cssisfun.com",
    "csstestapp.xyz",
    "cssu.wiki",
    "csvpubblicita.com",
    "csweihua.com",
    "cswnet.com",
    "csys.host",
    "cszbl.com",
    "ct345fgvaw.cf",
    "ct345fgvaw.ga",
    "ct345fgvaw.gq",
    "ct345fgvaw.ml",
    "ct345fgvaw.tk",
    "ct3bowties.com",
    "ct4lpj.us",
    "cta.cq.cn",
    "ctav.es",
    "ctdetoxcenter.com",
    "ctdfms.us",
    "ctexas.net",
    "ctgbrdlpe.shop",
    "ctkcec.org",
    "ctmailing.us",
    "ctmhwbc.site",
    "cto-on.com",
    "ctorssu.shop",
    "ctos.ch",
    "ctoyule.com",
    "ctrehabcenters.com",
    "ctrpgz.us",
    "cts-lk-i.cf",
    "cts-lk-i.ga",
    "cts-lk-i.gq",
    "cts-lk-i.ml",
    "cts-lk-i.tk",
    "cttlju.us",
    "ctznqsowm18ke50.cf",
    "ctznqsowm18ke50.ga",
    "ctznqsowm18ke50.gq",
    "ctznqsowm18ke50.ml",
    "ctznqsowm18ke50.tk",
    "cu.cc",
    "cu8wzkanv7.cf",
    "cu8wzkanv7.gq",
    "cu8wzkanv7.ml",
    "cu8wzkanv7.tk",
    "cuadongplaza.com",
    "cuantoesta.com",
    "cubabrothers.com",
    "cubanculturalheritage.org",
    "cubanschool.info",
    "cubavision.info",
    "cubb6mmwtzbosij.cf",
    "cubb6mmwtzbosij.ga",
    "cubb6mmwtzbosij.gq",
    "cubb6mmwtzbosij.ml",
    "cubb6mmwtzbosij.tk",
    "cubecart-demo.com",
    "cubehost.us",
    "cubeschina.fun",
    "cubeunlimited.co.uk",
    "cubiclink.com",
    "cubitoid.com",
    "cubitoids.com",
    "cuc.edu.cn",
    "cuci4scr.info",
    "cucummail.com",
    "cuddlybuddys.com",
    "cuddlysingles.com",
    "cuedingsi.cf",
    "cuedingsi.gq",
    "cuedingsi.tk",
    "cuemail.com",
    "cuentamelotodo.com",
    "cuentamemas.website",
    "cueslumpbuy.website",
    "cuevanago.net",
    "cuffa.com",
    "cufibr.com",
    "cufibr.net",
    "cufibrazil.com",
    "cufibrazil.org",
    "cufihn.org",
    "cufihonduras.com",
    "cufihonduras.net",
    "cufihonduras.org",
    "cufikids.net",
    "cugod.com",
    "cuibap.vn",
    "cuidado-ancianos.com",
    "cuidado-mayores.info",
    "cuikezhijia.com",
    "cuirushi.org",
    "cuisi.xyz",
    "cuisinorama.org",
    "cukurovailan.xyz",
    "cul0.cf",
    "cul0.ga",
    "cul0.gq",
    "cul0.ml",
    "cul0.tk",
    "culapotu.site",
    "culinary-rus.ru",
    "culletonstakeaway.com",
    "culletonstraditional-kilkenny.com",
    "culnetfcyc.tk",
    "culoareacurcubeului.club",
    "culsanab.cf",
    "culsanab.ml",
    "culsanab.tk",
    "cult-labs.net",
    "cult2day.ru",
    "cultcounselling.org",
    "cultmovie.com",
    "culturafr.com",
    "culturallyconnectedcook.org",
    "culturallyconnectedcooking.org",
    "culture-nsk.ru",
    "culturemachines.info",
    "cultureofideas.org",
    "culvercitydoctors.com",
    "culvercityrealestateagents.com",
    "cum.camera",
    "cum.sborra.tk",
    "cumallover.me",
    "cumangeblog.net",
    "cumanuallyo.com",
    "cumbriamail.com",
    "cumedes.ga",
    "cumedes.ml",
    "cumidbins.cf",
    "cumidbins.ga",
    "cumidbins.tk",
    "cumonherface.org",
    "cunhamail.gq",
    "cunngregco.com",
    "cunnilingus.party",
    "cunnntf.website",
    "cuocquangtri.club",
    "cuoilendi24h.com",
    "cuoly.com",
    "cupaoutlet.site",
    "cupcakemine.ru",
    "cupeda.info",
    "cupf6mdhtujxytdcoxh.cf",
    "cupf6mdhtujxytdcoxh.ga",
    "cupf6mdhtujxytdcoxh.gq",
    "cupf6mdhtujxytdcoxh.ml",
    "cupf6mdhtujxytdcoxh.tk",
    "cupideyes.info",
    "cupomzeiro.com",
    "cuppingtherapy.info",
    "cupq.net",
    "cupu.site",
    "curajare.site",
    "curechs.org",
    "curediseases.info",
    "curednow.com",
    "curentjobs.info",
    "curhalller.gq",
    "curhalller.tk",
    "curiaregis.net",
    "curinpie.cf",
    "curinpie.ga",
    "curinpie.ml",
    "curio-city.com",
    "curity.shop",
    "curitya.shop",
    "curlhph.tk",
    "curlycollection.com",
    "curongwang.com",
    "currencyassistant.com",
    "currencyglossary.com",
    "currencyy.xyz",
    "current.best",
    "currentmatch.tk",
    "curriculumsystems.com",
    "curryandricedublin.com",
    "currygardenindian.com",
    "curryhouseoriental.com",
    "curryspeedformapollo.xyz",
    "curryworld.de",
    "cursedmoons.com",
    "curseforgeminecraft.com",
    "cursitor.best",
    "curso-de-escrita-audiovisual.com",
    "curso.tech",
    "cursocrocheonline.site",
    "cursodeinglesgratis.us",
    "cursodemicropigmentacao.us",
    "cursosonlinechefcarlamaia.com",
    "cursusbeffen.online",
    "curtebebe.com",
    "curtise.live",
    "curtsmail.com",
    "curtwphillips.com",
    "cushions.ru",
    "cuspy.ru",
    "cust.in",
    "custmon.net",
    "custom12.tk",
    "customanu.ru",
    "customaxima.com",
    "custombrush.org",
    "custombrush.us",
    "custombrushes.biz",
    "custombrushes.org",
    "custombrushes.us",
    "customcoconut.com",
    "customdesigner.site",
    "customdevices.ru",
    "customer-poll-zone.online",
    "customer-surveys-panel.online",
    "customercove.com",
    "customerplaner.online",
    "customersupportdepartment.ga",
    "customframingby2vets.com",
    "customice.app",
    "customizedsolar.com",
    "customizing225ll.online",
    "customrifles.info",
    "customs.red",
    "customs2g3.com",
    "customshop4us.com",
    "customusli.ru",
    "customweightlossplan.com",
    "customwriting.company",
    "cut-the-cord.news",
    "cute-girl.com",
    "cuteandcuddly.com",
    "cutecloud.fun",
    "cutekinks.com",
    "cutekittens.com",
    "cutey.com",
    "cutiemporium.site",
    "cutivnpt.biz",
    "cutivnpt.com",
    "cutivnpt.info",
    "cutivnpt.org",
    "cutivnpt.us",
    "cutjhw.ml",
    "cutlerbayapartments.com",
    "cutout.club",
    "cutthrrcpc.space",
    "cutti.net",
    "cuttingedgeprospects.com",
    "cutwoeq.space",
    "cuuhorobot.info",
    "cuvox.de",
    "cuvvgwo3j064hl8.xyz",
    "cuwinmyu.shop",
    "cuxade.xyz",
    "cuxen4.us",
    "cuzuryy.space",
    "cv-tt.com",
    "cv436.site",
    "cv4s7.host",
    "cvbqfl.info",
    "cvbshopbuy.com",
    "cvd8idprbewh1zr.cf",
    "cvd8idprbewh1zr.ga",
    "cvd8idprbewh1zr.gq",
    "cvd8idprbewh1zr.ml",
    "cvd8idprbewh1zr.tk",
    "cvdkr.us",
    "cvdsale.top",
    "cveiguulymquns4m.cf",
    "cveiguulymquns4m.ga",
    "cveiguulymquns4m.gq",
    "cveiguulymquns4m.ml",
    "cveiguulymquns4m.tk",
    "cvetmet124.ru",
    "cvetomuzyk-achinsk.ru",
    "cvety-russia.ru",
    "cvetynadom.site",
    "cvijqth6if8txrdt.cf",
    "cvijqth6if8txrdt.ga",
    "cvijqth6if8txrdt.gq",
    "cvijqth6if8txrdt.ml",
    "cvijqth6if8txrdt.tk",
    "cvlvp.site",
    "cvo9ym.us",
    "cvscool.com",
    "cvscout.com",
    "cvse.icu",
    "cvstr.us",
    "cvu0at.online",
    "cvurb5g2t8.cf",
    "cvurb5g2t8.ga",
    "cvurb5g2t8.gq",
    "cvurb5g2t8.ml",
    "cvurb5g2t8.tk",
    "cvxnoom.com",
    "cvxooms.com",
    "cvzzoom.com",
    "cw8xkyw4wepqd3.cf",
    "cw8xkyw4wepqd3.ga",
    "cw8xkyw4wepqd3.gq",
    "cw8xkyw4wepqd3.ml",
    "cw8xkyw4wepqd3.tk",
    "cw9bwf5wgh4hp.cf",
    "cw9bwf5wgh4hp.ga",
    "cw9bwf5wgh4hp.gq",
    "cw9bwf5wgh4hp.ml",
    "cw9bwf5wgh4hp.tk",
    "cwdt5owssi.cf",
    "cwdt5owssi.ga",
    "cwdt5owssi.gq",
    "cwdt5owssi.ml",
    "cwdt5owssi.tk",
    "cwduhb.online",
    "cwembk.site",
    "cwiprojects.icu",
    "cwkdx3gi90zut3vkxg5.cf",
    "cwkdx3gi90zut3vkxg5.ga",
    "cwkdx3gi90zut3vkxg5.gq",
    "cwkdx3gi90zut3vkxg5.ml",
    "cwkdx3gi90zut3vkxg5.tk",
    "cwmco.com",
    "cwn1r.us",
    "cwrn3b.us",
    "cwuekt.us",
    "cww.de",
    "cwyk.us",
    "cx.de-a.org",
    "cxago.com",
    "cxbhxb.site",
    "cxcc.cf",
    "cxcc.gq",
    "cxcc.ml",
    "cxcc.tk",
    "cxcycn.com",
    "cxdina1117.info",
    "cxkpbaeb.shop",
    "cxoc.us",
    "cxosbv.us",
    "cxpcgwodagut.cf",
    "cxpcgwodagut.ga",
    "cxpcgwodagut.gq",
    "cxpcgwodagut.ml",
    "cxpcgwodagut.tk",
    "cxt66.com",
    "cxvooc.com",
    "cxxom.com",
    "cxzpkbspi.shop",
    "cxzvx.site",
    "cyaffshop.store",
    "cyantools.com",
    "cyaovox.site",
    "cybanlhyb.site",
    "cyber-africa.net",
    "cyber-audit.com",
    "cyber-host.net",
    "cyber-innovation.club",
    "cyber-matrix.com",
    "cyber-phone.eu",
    "cyber-security-career.com",
    "cyber-team.us",
    "cyber-tron.ru",
    "cyber-wizard.com",
    "cyber4all.com",
    "cyberbabies.com",
    "cybercafemaui.com",
    "cybercity-online.net",
    "cybercommunist.com",
    "cybercommunist.org",
    "cybercommunistparty.org",
    "cyberdude.com",
    "cyberdude.dk",
    "cyberforeplay.net",
    "cybergal.com",
    "cybergrrl.com",
    "cyberguilds.org",
    "cyberhardening.com",
    "cyberinbox.com",
    "cyberintel.onl",
    "cyberjunkie.dk",
    "cyberkumbh.org",
    "cyberleports.com",
    "cybermail.net",
    "cybernet.it",
    "cyberoligarch.ru",
    "cyberpay.shop",
    "cyberpointeservices.com",
    "cyberresponse.link",
    "cybersecurity.mba",
    "cybersecurityforentrepreneurs.com",
    "cyberservices.com",
    "cybersex.com",
    "cyberspace-asia.com",
    "cyberspatial.org",
    "cybersporttour.ru",
    "cyberstreamz.online",
    "cyberstudio.company",
    "cyberstudio.digital",
    "cybertrains.org",
    "cybervm.shop",
    "cybrew.com",
    "cybsec.shop",
    "cyciha.cf",
    "cyciha.ml",
    "cyciha.tk",
    "cycleaccess.com",
    "cyclebrowser.com",
    "cyclecrm.com",
    "cycledynamicexert.site",
    "cyclefanz.com",
    "cycleflo.xyz",
    "cyclejudg.recipes",
    "cyclingshop.live",
    "cyclisme-roltiss-over.com",
    "cyclo.co",
    "cyclocart.icu",
    "cyclonetree.net",
    "cydco.org",
    "cydotic.cf",
    "cydotic.ga",
    "cydotic.ml",
    "cyfu.icu",
    "cygcoquan.gq",
    "cygcoquan.ml",
    "cyjg66k85khvl1d.xyz",
    "cylab.org",
    "cylinderbrush.biz",
    "cylinderbrushes.biz",
    "cylinderbrushes.net",
    "cylinderbrushes.us",
    "cylindricalbrush.us",
    "cylindricalbrushes.us",
    "cylzcyned.shop",
    "cymail.net",
    "cyme.ru",
    "cymuj1.site",
    "cynetcity.com",
    "cyormedia.com",
    "cypher.onl",
    "cyphershop.net",
    "cypseline.site",
    "cyrptocurrencyforecasts.com",
    "cytm1p.club",
    "cytphebes.gq",
    "cytphebes.ml",
    "cytphebes.tk",
    "cyu404.com",
    "cyyl-hyzc.com",
    "cyzoone.xyz",
    "cz.cc",
    "cz076.com",
    "cz3gknv9phg3a7j.xyz",
    "cz4kdk.us",
    "czaresy.info",
    "czbird.com",
    "czc66.xyz",
    "czershiasa.icu",
    "czguangyus.com",
    "czip.site",
    "czn-sait.ru",
    "cznyaw.us",
    "czpanda.cn",
    "czpivquq.shop",
    "czqjii8.com",
    "czsabidbs.shop",
    "czwtky.us",
    "czxc16a1-qwewqqw.icu",
    "d-cont.biz",
    "d-gray-man.com",
    "d-health.site",
    "d-link.cf",
    "d-link.ga",
    "d-link.gq",
    "d-link.ml",
    "d-link.tk",
    "d-prov.se",
    "d-race5.com",
    "d-sadokam.ru",
    "d-skin.com",
    "d-v-w.de",
    "d.bgsaddrmwn.me",
    "d.megafon.org.ua",
    "d.umn.edu",
    "d029ksfd.buzz",
    "d0ipqg.info",
    "d10ftkrnne56stforfu2545.com",
    "d10fturbmk9eqxlorfe0244.com",
    "d10ftvrrnu5qazjoamm9667.com",
    "d12kj.space",
    "d1333.com",
    "d154cehtp3po.cf",
    "d154cehtp3po.ga",
    "d154cehtp3po.gq",
    "d154cehtp3po.ml",
    "d154cehtp3po.tk",
    "d15a6s1d6-sadxzcwaasdcx.icu",
    "d18ux.space",
    "d190c0a5.xyz",
    "d1xs.net",
    "d1yun.com",
    "d220.club",
    "d2dtoolbox.com",
    "d2pwqdcon5x5k.cf",
    "d2pwqdcon5x5k.ga",
    "d2pwqdcon5x5k.gq",
    "d2pwqdcon5x5k.ml",
    "d2pwqdcon5x5k.tk",
    "d2v3yznophac3e2tta.cf",
    "d2v3yznophac3e2tta.ga",
    "d2v3yznophac3e2tta.gq",
    "d2v3yznophac3e2tta.ml",
    "d2v3yznophac3e2tta.tk",
    "d301da66.xyz",
    "d34b.club",
    "d39oh.space",
    "d3mrz2.us",
    "d3obcy.us",
    "d3omilitary.com",
    "d3p.dk",
    "d47uz.site",
    "d4923.club",
    "d4eclvewyzylpg7ig.cf",
    "d4eclvewyzylpg7ig.ga",
    "d4eclvewyzylpg7ig.gq",
    "d4eclvewyzylpg7ig.ml",
    "d4eclvewyzylpg7ig.tk",
    "d4ffwamjrua3ayp.xyz",
    "d4jgpnug.xyz",
    "d4networks.org",
    "d50az.com",
    "d52.online",
    "d52tm.com",
    "d54a169.club",
    "d5721c98.xyz",
    "d58pb91.com",
    "d5ewoi.us",
    "d5ipveksro9oqo.cf",
    "d5ipveksro9oqo.ga",
    "d5ipveksro9oqo.gq",
    "d5ipveksro9oqo.ml",
    "d5ipveksro9oqo.tk",
    "d5qlcz.us",
    "d5xb7.us",
    "d62f78c.club",
    "d64qb.site",
    "d65faf2.club",
    "d66rc.site",
    "d6gypc.site",
    "d74qp.space",
    "d75d8ntsa0crxshlih.cf",
    "d75d8ntsa0crxshlih.ga",
    "d75d8ntsa0crxshlih.gq",
    "d75d8ntsa0crxshlih.ml",
    "d75d8ntsa0crxshlih.tk",
    "d7665.com",
    "d77wt.site",
    "d78.xyz",
    "d7899.com",
    "d78qp.com",
    "d7bpgql2irobgx.cf",
    "d7bpgql2irobgx.ga",
    "d7bpgql2irobgx.gq",
    "d7bpgql2irobgx.ml",
    "d7crews.com",
    "d7curtainwalls.com",
    "d7design.com",
    "d7electrical.com",
    "d7floors.com",
    "d7kj.net",
    "d7lights.com",
    "d7painting.com",
    "d7paving.com",
    "d7restoration.com",
    "d7storefronts.com",
    "d8db.club",
    "d8tam.space",
    "d8u.us",
    "d8yvf0.us",
    "d8zzxvrpj4qqp.cf",
    "d8zzxvrpj4qqp.ga",
    "d8zzxvrpj4qqp.gq",
    "d8zzxvrpj4qqp.ml",
    "d8zzxvrpj4qqp.tk",
    "d90b.xyz",
    "d90bs8.us",
    "d93xxp.us",
    "d9jdnvyk1m6audwkgm.cf",
    "d9jdnvyk1m6audwkgm.ga",
    "d9jdnvyk1m6audwkgm.gq",
    "d9jdnvyk1m6audwkgm.ml",
    "d9jdnvyk1m6audwkgm.tk",
    "d9tl8drfwnffa.cf",
    "d9tl8drfwnffa.ga",
    "d9tl8drfwnffa.gq",
    "d9tl8drfwnffa.ml",
    "d9tl8drfwnffa.tk",
    "da-da-da.cf",
    "da-da-da.ga",
    "da-da-da.gq",
    "da-da-da.ml",
    "da-da-da.tk",
    "da4it.buzz",
    "da829.xyz",
    "daabox.com",
    "daahjy.tokyo",
    "daawah.info",
    "dab.ro",
    "dab.systems",
    "dabbhouti.ga",
    "dabbhouti.gq",
    "dabbhouti.ml",
    "dabbhouti.tk",
    "dabest.ru",
    "dabsol.net",
    "dabstuff.com",
    "dabstuff.net",
    "dabtatinar.gq",
    "dacasjahr.cf",
    "dacasjahr.ga",
    "dacasjahr.gq",
    "dacasjahr.ml",
    "dacasjahr.tk",
    "dacentecrefugees.com",
    "dacha-24.ru",
    "dachahut.com",
    "dacia-sandero.club",
    "daciasandero.cf",
    "daciasandero.ga",
    "daciasandero.gq",
    "daciasandero.ml",
    "daciasandero.tk",
    "daconfrontare.com",
    "dacoolest.com",
    "dacre.us",
    "dacredit365.online",
    "dacsancantho.net",
    "dacsanxuthanh.com",
    "dadacasa.com",
    "dadamoffice.shop",
    "dadc.space",
    "dadc.website",
    "dadc.xyz",
    "dadd.kikwet.com",
    "daddah.org",
    "daddybegood.com",
    "daddykeys.ru",
    "dadensa.online",
    "dadensa.shop",
    "dadukiukiu.com",
    "dae-bam.net",
    "dae.h4ck.me",
    "daef.cn",
    "daekano.com",
    "daelogi.ga",
    "daelogi.gq",
    "daelogi.ml",
    "daelogi.tk",
    "daemsteam.com",
    "daewoo.gq",
    "daewoo.ml",
    "dafa107.com",
    "dafa109.com",
    "dafa215.com",
    "dafa510.com",
    "dafa572.com",
    "dafa576.com",
    "dafa580.com",
    "dafa581.com",
    "dafaapp55.com",
    "dafabetfun.com",
    "dafconsde.tk",
    "daffstyle.shop",
    "dafinally.com",
    "daftardetikcapsa.com",
    "daftarkoinqq.site",
    "daftarpokerhokibet88.net",
    "daftarpokerhokibet88.org",
    "daftm.ru",
    "dag8gi7ryh893b4.xyz",
    "dagodiscoentertainment.com",
    "dagougou.org",
    "daha.com",
    "dahelvets.cf",
    "dahelvets.ga",
    "dahelvets.gq",
    "dahelvets.ml",
    "dahelvets.tk",
    "dahongying.net",
    "dahypy.info",
    "daibond.info",
    "daicliclong.cf",
    "daicliclong.ga",
    "daicliclong.ml",
    "daifopour.ga",
    "daifopour.gq",
    "daifopour.ml",
    "daigleconstructioninc.com",
    "daikin-centr.ru",
    "daily-email.com",
    "daily-today-flashemoteobserver-vitality.com",
    "dailyawesomedeal.com",
    "dailybanhtrungthubrodard.com",
    "dailybible.xyz",
    "dailycryptomedia.com",
    "dailydeliverykw.com",
    "dailydichos.com",
    "dailyideas.me",
    "dailyladylog.com",
    "dailylaunchoffers.com",
    "dailyloon.com",
    "dailymicrosoft.com",
    "dailymovies.biz",
    "dailypioneer.com",
    "dailypublish.com",
    "dailywebnews.info",
    "daimlerag.cf",
    "daimlerag.ga",
    "daimlerag.gq",
    "daimlerag.ml",
    "daimlerag.tk",
    "daimlerchrysler.cf",
    "daimlerchrysler.gq",
    "daimlerchrysler.ml",
    "daintly.com",
    "dairyawf.icu",
    "dairyawfu.xyz",
    "dairyfarm-residences-sg.com",
    "dairygreat.email",
    "dairyque.icu",
    "dairythank.site",
    "dairythig.xyz",
    "dairywiselabs.us",
    "daisymacgardens.com",
    "dait.cf",
    "dait.ga",
    "dait.gq",
    "dait.ml",
    "dait.tk",
    "daitarli.cf",
    "daitarli.ga",
    "daitarli.gq",
    "daitarli.tk",
    "daithresdoor.cf",
    "daithresdoor.gq",
    "daithresdoor.tk",
    "daivatal.ga",
    "daivatal.ml",
    "daiwa-kohga.online",
    "dajin18.com",
    "dajreamdigital.com",
    "dajuju.com",
    "daki6v.us",
    "dakimakura.com",
    "dakkapellenbreda.com",
    "dakshub.org",
    "dalailamahindi.org",
    "dalamananadolulisesi.xyz",
    "dalamanporttransfer.xyz",
    "dalamanturkishvillas.xyz",
    "dalanila.tk",
    "dalbam7.net",
    "daleadershipinstitute.org",
    "daleloan.com",
    "dalexport.ru",
    "dali-guard.online",
    "dali-vdali.ru",
    "dalianseasun.com",
    "dalis-kursu.xyz",
    "dallas-ix.org",
    "dallas.theboys.com",
    "dallas4d.com",
    "dallasbuzz.org",
    "dallascheapdrinks.com",
    "dallascolo.biz",
    "dallasdaybook.com",
    "dallasdebtsettlement.com",
    "dallasftworthdaybook.com",
    "dallaslandscapearchitecture.com",
    "dallasmail.com",
    "dallaspentecostal.org",
    "dallaspooltableinstallers.com",
    "dallassalons.com",
    "dalremi.cf",
    "dalremi.ga",
    "dalremi.tk",
    "daltonmillican.com",
    "daltv14.com",
    "daltv15.com",
    "daltv20.com",
    "dalyoko.com",
    "dalyoko.ru",
    "damachinegame.net",
    "damaginghail.com",
    "damai.webcam",
    "damanik.ga",
    "damanik.tk",
    "damastand.site",
    "damatiy.space",
    "damde.space",
    "daminhptvn.com",
    "daminnes.info",
    "damirtursunovic.com",
    "damistso.cf",
    "damistso.ml",
    "damistso.tk",
    "dammexe.net",
    "damnthespam.com",
    "damonacos.info",
    "damonza.net",
    "damoreavenue.icu",
    "damvl.site",
    "damwolves.shop",
    "dan-it.site",
    "dan.lol",
    "dan72.com",
    "dana-markovskaya.ru",
    "danamon66.net",
    "danapointsmile.com",
    "danavibeauty.com",
    "dance4z.info",
    "dance4zz.info",
    "dancealb.com",
    "dancefibr.icu",
    "danceinwords.com",
    "danceliketiffanyswatching.org",
    "dancemail.dk",
    "dancemanual.com",
    "danceml.win",
    "dancend.info",
    "dandcbuilders.com",
    "dandikmail.com",
    "dandinoo.com",
    "dandrewsify.com",
    "danecarsa.info",
    "dangbatdongsan.com",
    "dangerbox.org",
    "dangerous-minds.com",
    "dangerouscriminal.com",
    "dangerousdickdan.com",
    "dangersdesmartphone.site",
    "dangkibum.org",
    "dangkibum.xyz",
    "dangkygame.win",
    "dangwild.xyz",
    "danhenry.watch",
    "daniarturos.club",
    "danica1121.club",
    "danielcisar.com",
    "danielfrysinger.com",
    "danielfrysinger.net",
    "danielfrysinger.org",
    "danielgemp.info",
    "danielgemp.net",
    "danieljweb.net",
    "danielkennedyacademy.com",
    "danielkrout.info",
    "danielsagi.xyz",
    "danielurena.com",
    "daniilhram.info",
    "danilkinanton.ru",
    "danilwsus.online",
    "danirafsanjani.com",
    "danklitmemes.com",
    "dankmedical.com",
    "dankmeme.zone",
    "dankq.com",
    "dankrangan77jui.ga",
    "danlathel.ga",
    "danlathel.gq",
    "danlathel.ml",
    "danlingjewelry.com",
    "danncollier.com",
    "danneocheck.xyz",
    "danns.cf",
    "danny-mickey.ru",
    "dannycrichton.org",
    "dannystonecelebrant.com",
    "danoiara.xyz",
    "danollascastlebar.com",
    "danora.cf",
    "danora.gq",
    "danora.ml",
    "danring.org",
    "dansegulvet.com",
    "dansova.online",
    "dantevirgil.com",
    "danycompay.com",
    "danycomsms.com",
    "danzlogo.com",
    "dao7j4.us",
    "daoduytu.net",
    "daofengyun.com",
    "daotan.org",
    "daotzimin.cf",
    "daotzimin.ga",
    "daotzimin.gq",
    "daotzimin.ml",
    "daoxiangpalmademallorca.com",
    "dap38.space",
    "daphnee1818.site",
    "dapk.site",
    "dapopo.xyz",
    "dapplica.com",
    "daqbank.net",
    "daqbank.org",
    "daqbit.org",
    "daqexc.org",
    "daqianbet.com",
    "daqmart.one",
    "daqmart.org",
    "daqsec.org",
    "daquytinnghia.tech",
    "dar098.xyz",
    "dar123.xyz",
    "dar23.xyz",
    "daracombe.com",
    "darblaga.ru",
    "darcagold.cf",
    "darcagold.ga",
    "darcagold.gq",
    "darcagold.ml",
    "darcagold.tk",
    "darcheteb.cf",
    "darcheteb.ga",
    "darcheteb.gq",
    "darcheteb.ml",
    "darcypierlot.com",
    "darcyzhang.com",
    "darenmclean.com",
    "darga24.space",
    "darga24.website",
    "dargah120.club",
    "dargah9090.xyz",
    "dargahian2.xyz",
    "dargahparsi.xyz",
    "dargahvaset2.xyz",
    "daridarkom.com",
    "darienelderlawgroup.com",
    "darina12.ru",
    "dariosblanchardstown.com",
    "dark-tempmail.zapto.org",
    "dark.support",
    "dark2.ru",
    "darkabyss.studio",
    "darkbluevandred.ru",
    "darkclubintheworld.ru",
    "darkcolo.net",
    "darkcoremu.online",
    "darkest-dungeon.ru",
    "darkharvestfilms.com",
    "darklabpc.ru",
    "darklenta.online",
    "darkmarket.live",
    "darknet.technology",
    "darknode.org",
    "darkstone.com",
    "darkwulu79jkl.ga",
    "darlene.club",
    "darlenemerronemarie.us",
    "darlingtonradio.net",
    "darloneaphyl.cf",
    "darnellmooremusic.com",
    "darporalgo.info",
    "darrowsponds.com",
    "darrylcharrison.com",
    "darsbyscman.ga",
    "darsbyscman.tk",
    "darsonline.com",
    "dartak.site",
    "darter-empirehonest-monk-honest.com",
    "dartsoftwareautomation.com",
    "dartwader.club",
    "darv.xyz",
    "darwinantivirus.net",
    "darwinav.net",
    "darwins.app",
    "darwinsgame.app",
    "daryun.ru",
    "daryxfox.net",
    "das-abitur-nachholen.net",
    "das-polopom1.ru",
    "das.market",
    "dasayo.space",
    "dasayo.website",
    "dasayo.xyz",
    "dasbeers.com",
    "dasdasdas23123.xyz",
    "dasdasdascyka.tk",
    "dasefashion.com",
    "dasegr.club",
    "dash-pads.com",
    "dash8pma.com",
    "dashabase.com",
    "dashalens.ru",
    "dashanddot.club",
    "dashbpo.net",
    "dashengpk.com",
    "dashiav.xyz",
    "dashifood.com",
    "dashoffer.com",
    "dasmarc.net",
    "dasoft-hosting.com",
    "dasprinting.com",
    "daspsinc.com",
    "dasttanday.ga",
    "dasttanday.gq",
    "dasxe.online",
    "data-003.com",
    "data1.nu",
    "data54.com",
    "dataarca.com",
    "datab.info",
    "databootcamp.org",
    "datacenteritalia.cloud",
    "datacion.icu",
    "datacion.pw",
    "datacion.top",
    "datacion.xyz",
    "datacoeur.com",
    "datafordinner.com",
    "datafundcapital.com",
    "dataharga.org",
    "dataminors.com",
    "datamodelingwiki.com",
    "datapaneli.xyz",
    "datapurse.com",
    "datarator.com",
    "datarca.com",
    "datasoma.com",
    "datasurvey.org",
    "dataworldclub.com",
    "datazo.ca",
    "datcaexpres.xyz",
    "datdiamh.shop",
    "date.by",
    "dateligenu-confirmed.com",
    "dateligenu-meet-backup.com",
    "dateligenu-meet.com",
    "datendesf.ml",
    "datendesf.tk",
    "datenschutz.ru",
    "datesofevents.com",
    "datesweetcherrygirls.xyz",
    "dathingspool.cf",
    "dathingspool.gq",
    "dathingspool.ml",
    "dathingspool.tk",
    "dating-right-now2.com",
    "dating-sky.ru",
    "dating2020.top",
    "dating4you-cc.net",
    "datinganalysis.com",
    "datingapr.website",
    "datinggetdown.website",
    "datinghacks.org",
    "datingmm.uk",
    "datlab.space",
    "datotira.cf",
    "datrainternusa.com",
    "datrr.gq",
    "datsun311parts.com",
    "datthocu.xyz",
    "datum2.com",
    "datumdelugeexile.site",
    "daufzq.us",
    "daughterplastic.xyz",
    "daum.net",
    "daun4d.live",
    "daunpkr2.org",
    "daunplay.org",
    "davedrapeau.com",
    "davegoodine.com",
    "davegracey.com",
    "davemartin.today",
    "davening613.com",
    "davenportiowachiropractic.com",
    "davenportiowachiropractor.com",
    "davesbillboard.biz",
    "davesbillboard.com",
    "davetiyesokagi.xyz",
    "davewomach.com",
    "david279.us",
    "davidandmarc.com",
    "davidcasinghino.com",
    "davidcrozier.com",
    "daviddjroy.com",
    "davidedeluca.com",
    "davidhathawayconsulting.com",
    "davidjrparker.com",
    "davidkoh.net",
    "davidlcreative.com",
    "davidmorgenstein.org",
    "davido.africa",
    "davidodere.com",
    "davidorlic.com",
    "davidqq.net",
    "davidqq.org",
    "davidsaunders.buzz",
    "davidsonschiller.com",
    "davidtaylormp.com",
    "davidvogellandscaping.com",
    "davies-club.com",
    "daviiart.com",
    "davikla.com",
    "davilo-press.ru",
    "davinci-dent.ru",
    "davinci-institute.org",
    "davincidiamonds.com",
    "davis.exchange",
    "davomo.com",
    "davuboutique.site",
    "davutkavranoglu.com",
    "dawaa.xyz",
    "dawang777.org",
    "dawcraft.com",
    "dawetgress72njx.cf",
    "dawin.com",
    "dawnnews.live",
    "dawnsonmail.com",
    "dawoosoft.com",
    "dawozopa.site",
    "dawri.live",
    "dawsonmail.com",
    "daxfi1.info",
    "day-holiday.ru",
    "day-one.pw",
    "dayemall.site",
    "daygrandprizes9.life",
    "daykemmonhoa.icu",
    "daylive.ru",
    "dayloo.com",
    "daymail.life",
    "daymailonline.com",
    "daynightstory.com",
    "dayone.pw",
    "dayrep.com",
    "dayreth.site",
    "dayrosre.cf",
    "dayrosre.ga",
    "dayrosre.gq",
    "dayrosre.tk",
    "daysgox.ru",
    "dayshow100.cn",
    "daytrippers.org",
    "dayuzxg.com",
    "dazate.gq",
    "dazedandconfused.com",
    "dazere.info",
    "dazzlingcountertops.com",
    "dazzvijump.cf",
    "dazzvijump.ga",
    "db2sports.com",
    "db2zudcqgacqt.cf",
    "db2zudcqgacqt.ga",
    "db2zudcqgacqt.gq",
    "db2zudcqgacqt.ml",
    "db4t534.cf",
    "db4t534.ga",
    "db4t534.gq",
    "db4t534.ml",
    "db4t534.tk",
    "db4t5e4b.cf",
    "db4t5e4b.ga",
    "db4t5e4b.gq",
    "db4t5e4b.ml",
    "db4t5e4b.tk",
    "db4t5tes4.cf",
    "db4t5tes4.ga",
    "db4t5tes4.gq",
    "db4t5tes4.ml",
    "db4t5tes4.tk",
    "dbanote.net",
    "dbatalk.com",
    "dbatlogistics.com",
    "dbawgrvxewgn3.cf",
    "dbawgrvxewgn3.ga",
    "dbawgrvxewgn3.gq",
    "dbawgrvxewgn3.ml",
    "dbawgrvxewgn3.tk",
    "dbb-valve.com",
    "dbbd8.club",
    "dbcvdo.com",
    "dbenoitcosmetics.com",
    "dblets.com",
    "dbo.kr",
    "dbook.site",
    "dbseo.ru",
    "dbsocd.com",
    "dbst.band",
    "dbunker.com",
    "dbvirtualizer.com",
    "dbxola.rest",
    "dbycivil.com",
    "dbyrfpnd.xyz",
    "dbz5mchild.com",
    "dbzmail.com",
    "dc-business.com",
    "dc0hah.us",
    "dc7f8.xyz",
    "dc9a7694.xyz",
    "dca.net",
    "dcabmyoi.shop",
    "dcantextli.ml",
    "dcantey.ru",
    "dcapsul.xyz",
    "dcastello.ru",
    "dccsvbtvs32vqytbpun.ga",
    "dccsvbtvs32vqytbpun.ml",
    "dccsvbtvs32vqytbpun.tk",
    "dce0.xyz",
    "dcemail.com",
    "dcemail.men",
    "dcfnw.us",
    "dcgs.ru",
    "dcibb.xyz",
    "dcmnbb.com",
    "dcndiox5sxtegbevz.cf",
    "dcndiox5sxtegbevz.ga",
    "dcndiox5sxtegbevz.gq",
    "dcndiox5sxtegbevz.ml",
    "dcndiox5sxtegbevz.tk",
    "dcnlive.com",
    "dconpla.biz",
    "dcrnkqdn.space",
    "dcru.email",
    "dcscgroup.com",
    "dcsi.net",
    "dcstranded.ru",
    "dct-art.com",
    "dct-industries.com",
    "dct-web.com",
    "dctm.de",
    "dcv583.com",
    "dcverowjd.shop",
    "dcyfsu.stream",
    "dd-lucky9.com",
    "dd18269.com",
    "dd57822.com",
    "dd8833.com",
    "dd9nax.us",
    "dda1fd.club",
    "ddancestudio.ru",
    "ddataliste.site",
    "ddbb99.xyz",
    "ddcrew.com",
    "ddd.ru",
    "ddd062.com",
    "ddd9827.com",
    "dddddd.com",
    "dddk.de",
    "ddemilrk.site",
    "ddevbotm.site",
    "ddevtabd.site",
    "ddg70.navy.mil",
    "ddgame999.org",
    "ddigiwirew.site",
    "ddimsfjr.shop",
    "ddividegs.com",
    "ddkin.com",
    "ddlg.info",
    "ddllkg.info",
    "ddload3.xyz",
    "ddlre.com",
    "ddmail.win",
    "ddmp3.com",
    "ddnkinvestglobal.com",
    "ddns.ml",
    "ddns.net",
    "ddns.org",
    "ddns.plus",
    "ddnsfree.com",
    "ddorai.net",
    "ddosed.us",
    "ddrf00.com",
    "ddrt66.com",
    "ddukbam03.com",
    "ddynaliay.site",
    "ddyy531.com",
    "ddyy537.com",
    "ddyy538.com",
    "ddyy539.com",
    "ddyy555.com",
    "ddyy557.com",
    "ddyy565.com",
    "ddyy567.com",
    "ddyy571.com",
    "ddyy579.com",
    "ddyy597.com",
    "ddyy599.com",
    "ddyy611.com",
    "ddz79.com",
    "de-2019-datenschutz-aktualisierung.xyz",
    "de-a.org",
    "de-fake.instafly.cf",
    "de-lyrics.ru",
    "de.introverted.ninja",
    "de.newhorizons.gq",
    "de.sytes.net",
    "de.vipqq.eu.org",
    "de4ce.gq",
    "de5m7y56n5.cf",
    "de5m7y56n5.ga",
    "de5m7y56n5.gq",
    "de5m7y56n5.ml",
    "de5m7y56n5.tk",
    "de6a6f.club",
    "de99.xyz",
    "dea-love.net",
    "dea.soon.it",
    "deadaddress.com",
    "deadchildren.org",
    "deadfake.cf",
    "deadfake.ga",
    "deadfake.ml",
    "deadfake.tk",
    "deadliftexercises.com",
    "deadlinehomesite.club",
    "deadlymob.org",
    "deadlyspace.com",
    "deadmobsters.com",
    "deadproject.ru",
    "deadspam.com",
    "deafemail.net",
    "deagot.com",
    "deahs.com",
    "deaimagazine.xyz",
    "deal-maker.com",
    "deal-mega-original.ru",
    "deal-retail-prod.ru",
    "deal-store-seasons.ru",
    "dealble.com",
    "dealcost.com",
    "dealer.name",
    "dealeredit.adult",
    "dealersautoweb.com",
    "dealgongmail.com",
    "dealingwithabully.com",
    "dealja.com",
    "dealligg.com",
    "dealrek.com",
    "dealremod.com",
    "deals-from-wheels.com",
    "dealsbath.com",
    "dealsealer.org",
    "dealshare.info",
    "dealsoc.info",
    "dealsopedia.com",
    "dealthrifty.com",
    "dealtim.shop",
    "dealvn.info",
    "dealzbrow.com",
    "deamless.com",
    "deamuseum.online",
    "dean8x.com",
    "deanoumik.tk",
    "dearisi.cf",
    "dearisi.ga",
    "dearisi.ml",
    "dearisi.tk",
    "dearistanbul.xyz",
    "dearlittlegirl.com",
    "dearoid.xyz",
    "dearputin.net",
    "dearriba.com",
    "deasod.com",
    "death-ko.xyz",
    "death-star.com",
    "deathbycounciltax.com",
    "deathliteracy.org",
    "deba8x.com",
    "debak.host",
    "debak.xyz",
    "debaresporrota.com",
    "debaresporsanlucar.com",
    "debate.vote",
    "debatedeals.com",
    "debb.me",
    "debela.cf",
    "debela.gq",
    "debela.ml",
    "debela.tk",
    "debet.asia",
    "debet.info",
    "debetvn.xyz",
    "debizuqiu.com",
    "deborahpodolsky.org",
    "deborahvess.org",
    "debradelfino.com",
    "debran-indian-swords.com",
    "debrauwadvocaten.online",
    "debspetandhousesitting.com",
    "debtdestroyers.com",
    "debuglab.net",
    "debuilding.ru",
    "deby.site",
    "decantr.com",
    "decao88.org",
    "decassisya.info",
    "decavn.org",
    "deccore.tk",
    "decembermovo.com",
    "decentraland.website",
    "decentralproject.net",
    "decentrust.com",
    "deceptionindustries.com",
    "decibalblue.com",
    "decibelblue.net",
    "decibelworship.org",
    "decidaenriquecer.com",
    "decimalizes270zr.online",
    "decirculated.com",
    "decisijevo.space",
    "deckerniles.com",
    "deckfasli.gq",
    "deckfasli.tk",
    "deckscrubbrush.biz",
    "deckscrubbrush.us",
    "deckscrubbrushes.org",
    "declined-active.best",
    "decobar.ru",
    "decode.ist",
    "decodeexpo.xyz",
    "decodefuar.com",
    "decography.ru",
    "decolabsinc.com",
    "decolonizes941gc.xyz",
    "decoplagerent.com",
    "decor-idea.ru",
    "decorandhouse.com",
    "decoratingfromtheheart.com",
    "decorationdiy.site",
    "decorativeaccents.exposed",
    "decoratupiel.com",
    "decorigin.com",
    "decox.ru",
    "decoymail.com",
    "decoymail.mx",
    "decoymail.net",
    "decreas.ru",
    "decriminalization90lw.online",
    "decriminalizes610vv.online",
    "dector.live",
    "ded-moroz-vesti.ru",
    "dedd.email",
    "dedetox.center",
    "dedicateddivorcelawyer.com",
    "dedimath.com",
    "dedmoroz-vesti.ru",
    "dedmorozkoz.ru",
    "dedom.info",
    "deeded.best",
    "deekayen.us",
    "deekris.info",
    "deemail.xyz",
    "deemfit.com",
    "deemzjewels.com",
    "deepadnetwork.net",
    "deepankar.info",
    "deepbreedr.com",
    "deepcleanac.com",
    "deepdicker.com",
    "deeper-sonar.online",
    "deepexam.com",
    "deepfsisob.ga",
    "deepfsisob.ml",
    "deepfsisob.tk",
    "deepgameslab.org",
    "deeplysimple.org",
    "deepseafisherman.net",
    "deepshop.space",
    "deepshop.xyz",
    "deepsouthclothingcompany.com",
    "deepstore.online",
    "deepstore.site",
    "deepstore.space",
    "deepthroat.monster",
    "deepttoiy.cf",
    "deepvpn.site",
    "deerest.co",
    "deerparkrealestateagents.com",
    "deezstore.website",
    "defandit.com",
    "defaultdomain.ml",
    "defdb.com",
    "defeet.ru",
    "defenceds.com",
    "defend-pc-servlce3.info",
    "defenderyou.com",
    "defendpay.com",
    "defendrrg.info",
    "defendthemaarket.com",
    "defengyaoye07.com",
    "defensemart.com",
    "defenseoutfitter.ru",
    "deferrableassets.info",
    "defi-printemps.org",
    "defiant.poker",
    "definesmain.com",
    "definingjtl.com",
    "defmyx.xyz",
    "defomail.com",
    "deforestationsucks.com",
    "degoo.com",
    "degradedfun.net",
    "degrowlight.net",
    "degrowlights.com",
    "degwl4e.xyz",
    "degydi.info",
    "dehalfpricelistings.com",
    "dei.uminho.pt",
    "deiforce.com",
    "deifreegup.cf",
    "deifreegup.ga",
    "deifreegup.gq",
    "deifreegup.ml",
    "deinbox.com",
    "deintier.shop",
    "deinwebradio.com",
    "deionized129br.online",
    "deipostoe.cf",
    "deipostoe.ga",
    "deipostoe.gq",
    "deipostoe.tk",
    "deityproject.net",
    "deityproject.org",
    "dejamart.site",
    "dejanews.com",
    "dejavu.moe",
    "dekabet56.com",
    "dekartaboards.ru",
    "dekatri.cf",
    "dekatri.ga",
    "dekatri.gq",
    "dekatri.ml",
    "dekmauricie.com",
    "dekorated.com",
    "dekoratifkaplamalar.net",
    "dekuki.info",
    "delaemsami18.ru",
    "delaladz.com",
    "delanazwetsloot.info",
    "delanoforeclosures.com",
    "delawarecocainerehab.com",
    "delawaredropbox.com",
    "delawareheroinrehab.com",
    "delawareo.com",
    "delawaresecure.com",
    "delawareshowerglass.com",
    "delaxoft.cf",
    "delaxoft.ga",
    "delaxoft.gq",
    "delaxoft.tk",
    "delayequa.xyz",
    "delayload.com",
    "delayload.net",
    "delayover.com",
    "delaysvoe.ru",
    "delcan.me",
    "delcomweb.com",
    "deldoor.ru",
    "delefonkia.info",
    "deleomotosho.com",
    "delepoted.email",
    "deleriousdrip.tk",
    "deletedmessages.net",
    "deletme.xyz",
    "delhipalacemallow.com",
    "delhispicetakeaway.com",
    "delichev.su",
    "deliciousnutritious.com",
    "deliciousthings.net",
    "delieus.site",
    "delightbox.com",
    "delightfulpayroll.com",
    "delightfulworkspace.org",
    "delighthimalaya.com",
    "delignate.xyz",
    "delikkt.de",
    "delimiter.cloud",
    "delimiterrefugees.com",
    "deliomart.com",
    "deliriumshop.de",
    "deliverfreak.com",
    "deliverme.top",
    "deliveryconcierge.com",
    "deliveryman.com",
    "deliveryquebec.com",
    "deliveu.site",
    "delivvr.com",
    "deliy.ru",
    "dell.com",
    "dellfroi.ga",
    "dellingr.com",
    "delmang.com",
    "deln.info",
    "delonguiseavolt.ca",
    "delorieas.cf",
    "delorieas.ml",
    "delphinine.xyz",
    "delphiniza.xyz",
    "delrikid.cf",
    "delrikid.gq",
    "delrikid.ml",
    "delrikid.tk",
    "delta8cartridge.com",
    "deltanet.com",
    "deltapearl.partners",
    "deltashop-4g.ru",
    "deluxedesy.info",
    "demalasprontas.net",
    "demand56.website",
    "demanddawgs.info",
    "demandfull.date",
    "demandmagic.com",
    "demandrelationship.com",
    "demandsxz.com",
    "demen.ml",
    "demencia.page",
    "dementiaforumx.se",
    "demesmaeker.fr",
    "demgau.com",
    "demienb.ru",
    "demirelotomanisa.online",
    "demirelotomanisa.xyz",
    "demlik.org",
    "demo-royamhotel.website",
    "demo.neetrix.com",
    "democratic.army",
    "democratized730yw.online",
    "demodaas.host",
    "demodron.tech",
    "demoforeks24.com",
    "demokrasiveatilimpartisi.net",
    "demonetizes756hm.online",
    "demonpo.gq",
    "demopitora.space",
    "demotea.com",
    "dena.ga",
    "dena.ml",
    "denationalization534lc.online",
    "denationalizing899ee.xyz",
    "denattehond.online",
    "denaturalizing603oc.online",
    "dendomrecptic.website",
    "dendrions.ga",
    "deneg.net",
    "denehznoe-derevo.ru",
    "denemebonuslari.info",
    "denemeincele.com",
    "deneukboot.online",
    "dengekibunko.cf",
    "dengekibunko.ga",
    "dengekibunko.gq",
    "dengekibunko.ml",
    "dengi-news.ru",
    "dengi-pod-zalok-pts.ru",
    "dengivbank.ru",
    "dengizaotvet.ru",
    "denhues.info",
    "denisderzhavin.com",
    "denisecase.com",
    "denispushkin.ru",
    "denithor.gq",
    "denizlimedyaajansi.xyz",
    "denizlipostasi.com",
    "denizyolulashing.com",
    "denniehoopingarner.info",
    "dennisburge.com",
    "dennisgabor.com",
    "dennisgpike.com",
    "dennisss.top",
    "dennmail.win",
    "denomla.com",
    "denovocompany.com",
    "denovocybersecurity.com",
    "denracad.cf",
    "denracad.ga",
    "denracad.ml",
    "denracad.tk",
    "denseregencyexpel.site",
    "denservise.ru",
    "densify.org",
    "density2v.com",
    "dentafinder.com",
    "dentaldiscover.com",
    "dentaldoctornearme.com",
    "dentalemergencyroom.com",
    "dentalexcellencephoenix.com",
    "dentalhealthline.info",
    "dentallabmanager.com",
    "dentalmarketingcouncil.com",
    "dentalmdnearme.com",
    "dentalpracticedigitalmarketing.com",
    "dentalpracticeseoagency.com",
    "dentalpracticeweb.com",
    "dentalpride.ru",
    "dentalscript.com",
    "dentcarepro.website",
    "dentegi.cf",
    "dentegi.ga",
    "dentegi.gq",
    "dentegi.ml",
    "dentegi.tk",
    "denthite.ga",
    "denthite.gq",
    "denthite.ml",
    "dentistmarketplace.com",
    "dentistry32norma.ru",
    "dentistrybuzz.com",
    "dentistryoffer.com",
    "dentists.digital",
    "dentistwebsitepackages.com",
    "dentoiwama.ru",
    "dentonaccidentattorney.com",
    "dentonaccidentattorneys.com",
    "dentonaccidentlawyer.com",
    "dentoninjurylawyer.com",
    "dentonpersonalinjury.com",
    "dentz.net",
    "denvercocainerehab.com",
    "denvercyberdefence.com",
    "denvergeek.com",
    "denverquote.com",
    "denverwebhost.net",
    "denyfromall.org",
    "deoanthitcho.site",
    "deoanthitdau.site",
    "deocaaocaelvallenosetoca.cf",
    "deocamno.cf",
    "deocamno.ga",
    "deocamno.gq",
    "deocrystal.ru",
    "deodorizing465uh.online",
    "deorehigh.cf",
    "deorehigh.ga",
    "deorehigh.gq",
    "deorehigh.ml",
    "deos.email",
    "deos.onl",
    "deos.tech",
    "deov5x.info",
    "dep88.win",
    "depauw.edu",
    "depdfmanuales.xyz",
    "depechemode.com",
    "dependenceinspiretelevision.website",
    "depented.space",
    "deplatform.live",
    "deployeasy.com",
    "deployments.pro",
    "depogross.com",
    "depoidn.poker",
    "depoladang.com",
    "depolitika.com",
    "deponote.org",
    "depopar.net",
    "depors12.xyz",
    "deposit.ml",
    "depositbtc.ru",
    "depositshub2.com",
    "deposma.cf",
    "deposma.ga",
    "deposma.gq",
    "depostventaindustrial.com",
    "deposventa.com",
    "depotviolet.com",
    "depradoork.gq",
    "depradoork.ml",
    "depressurizes908qo.online",
    "deps-way2.com",
    "deptgadcha.cf",
    "deptgadcha.gq",
    "deptgadcha.ml",
    "deput.site",
    "der-kombi.de",
    "der.madhuratri.com",
    "derano.site",
    "derblitithe.tk",
    "derbmalo.ga",
    "derbmalo.gq",
    "derbmalo.ml",
    "derbydales.co.uk",
    "derbydancefestival.com",
    "derbyfans.com",
    "derder.net",
    "derdisoft.com",
    "deredik.info",
    "derefed.com",
    "derektwilight.com",
    "derevenka.biz",
    "derg.pro",
    "dergmirbio.cf",
    "dergmirbio.ga",
    "dergmirbio.gq",
    "dergmirbio.tk",
    "derhaai.com",
    "deribitguide.org",
    "derickventer.com",
    "derinbet14.com",
    "derivative.studio",
    "derkombi.de",
    "derlusac.cf",
    "derlusac.gq",
    "derluxuswagen.de",
    "dermacareshop.life",
    "dermatologistaportoalegre.com",
    "dermatologistasaopaulo.com",
    "dermatologycenterofboston.com",
    "dermoli.xyz",
    "dermorab.xyz",
    "dermote.xyz",
    "dermozi.xyz",
    "dernie.best",
    "derpfactor.com",
    "derpfactor.net",
    "derphouse.com",
    "derpingfordays.com",
    "derpy.info",
    "derraro.cf",
    "derraro.ga",
    "derraro.gq",
    "derraro.ml",
    "derraro.tk",
    "derroce.cf",
    "derroce.ga",
    "derroce.gq",
    "derroce.ml",
    "derroce.tk",
    "dersdern.shop",
    "derssataff.cf",
    "derssataff.gq",
    "derssataff.tk",
    "derstefo.cf",
    "derstefo.ga",
    "derstefo.gq",
    "derstefo.ml",
    "derstefo.tk",
    "derthtsz.shop",
    "desaptoh07yey.gq",
    "desarrollo.online",
    "desarte.info",
    "desayuno-\xe9tnico.info",
    "descarga.gratis",
    "descargalo.org",
    "descargar-mp3.name",
    "descargar-mp3.one",
    "descargar-mp3.uno",
    "descargarhotmail.com",
    "descargarjuegosswitch.com",
    "descargarplaystore.app",
    "deschprochel.cf",
    "deschprochel.ga",
    "deschprochel.ml",
    "deschprochel.tk",
    "desconecta.info",
    "desecratedsorrow.com",
    "deselcard.cf",
    "deselcard.ga",
    "deselcard.gq",
    "deseretmail.com",
    "desert49.website",
    "desertfinancoal.com",
    "desertinancial.com",
    "desertmail.com",
    "desertonline.com",
    "desertsaintsmail.com",
    "desertstardesign.com",
    "deshevo.travel",
    "deshiz.net",
    "desi-tashan.su",
    "design-42.ru",
    "design-generator.ru",
    "design.tours",
    "designable.info",
    "designagency.ooo",
    "designalpha.site",
    "designavenue.info",
    "designbydelacruz.com",
    "designbyparts.com",
    "designcreativegroup.com",
    "designdemo.website",
    "designea.ru",
    "designereasy.ru",
    "designergeneral.com",
    "designersadda.com",
    "designforleadership.com",
    "designfortwayne.com",
    "designfox.org",
    "designfreebies.ru",
    "designfuture.info",
    "designingenium.com",
    "designingknights.com",
    "designland.info",
    "designmint.site",
    "designmybrick.com",
    "designobserverconference.com",
    "designsbydelacruz.com",
    "designsolutionstl.com",
    "designstudien.de",
    "designthinkingcenter.com",
    "designvk.ru",
    "designwaretech.com",
    "designyourbrick.com",
    "desiheroine.com",
    "desilota.com",
    "desinfestacao.com",
    "desingerexperience.com",
    "desinghw.ga",
    "desioutlets.site",
    "desisdesis.com",
    "desitashan.su",
    "desitvforums.su",
    "deskality.net",
    "deskinsagriculture.com",
    "deskinsmanure.com",
    "deskinswatertreatment.com",
    "deskmail.com",
    "deskova.com",
    "deskpilot.com",
    "desktimeaustin.com",
    "desktimechicago.com",
    "desktop.events",
    "desktopbitcoin.com",
    "deskwareapp.com",
    "desloratadipris.website",
    "desmo.cf",
    "desmo.ga",
    "desmo.gq",
    "desmodfhye.space",
    "desmoinesquote.com",
    "desouth.net",
    "desouth.org",
    "desoutilspourapprendre.com",
    "desoz.com",
    "despairsquid.xyz",
    "despalar.ml",
    "despalar.tk",
    "despam.it",
    "despammed.com",
    "despgilpers.cf",
    "despgilpers.ga",
    "desplainesapartments.com",
    "dessertideasnowa14.com",
    "dessuitesy.info",
    "desteketut.com",
    "destent.net",
    "destin.com",
    "destinationbrazil.com",
    "destinationsouthernafrica.xyz",
    "destinour.tk",
    "destjusbaff.tk",
    "destkinggen.cf",
    "destkinggen.gq",
    "destkinggen.tk",
    "destroyertactics.com",
    "destructocat.com",
    "destypad.gq",
    "destypad.ml",
    "destypad.tk",
    "desultorydrivel.com",
    "desuze.info",
    "deszn1d5wl8iv0q.cf",
    "deszn1d5wl8iv0q.ga",
    "deszn1d5wl8iv0q.gq",
    "deszn1d5wl8iv0q.ml",
    "deszn1d5wl8iv0q.tk",
    "detailernews.com",
    "detalii.ru",
    "detalushka.ru",
    "detayappliances.online",
    "detayappliances.xyz",
    "deteenergy.com",
    "detentroom.ru",
    "determing.website",
    "dethedown.cf",
    "dethedown.gq",
    "dethzoo.xyz",
    "detik.com",
    "detikcapsa.biz",
    "detikcapsa.net",
    "detikcapsa.org",
    "detikcapsaonline.com",
    "detikcash.com",
    "detikpoker88.net",
    "detipoisk.ru",
    "detkisad.ru",
    "detonic02.ru",
    "detox.marketing",
    "detoxcenterfinder.com",
    "detoxcontentwriters.net",
    "detoxprogram.center",
    "detoxstartsnow.com",
    "detoxstartsnow.org",
    "detribalizing644gz.online",
    "detroitalcoholrehab.com",
    "detroitberlin.org",
    "detroithairsalons.com",
    "detroitheroinrehab.com",
    "detroitmipersonalinjurylawyer.com",
    "detroitopiaterehab.com",
    "detskiechasy72.ru",
    "detskietime.ru",
    "detsky-pokoj.net",
    "dettol.cf",
    "dettol.ga",
    "dettol.gq",
    "dettol.ml",
    "dettol.tk",
    "deubomac.ga",
    "deubomac.gq",
    "deubomac.ml",
    "deubomac.tk",
    "deucemail.com",
    "deuplus.com",
    "deutchto.ru",
    "deutestax.xyz",
    "deutsch-sprachschule.de",
    "deutschland-net.com",
    "deutschland-sicherheit.top",
    "deutschland-update-sicherheit-241236.top",
    "deutschlandcasinos.host",
    "dev-api.ru",
    "dev-mclub.com",
    "dev-null.cf",
    "dev-null.ga",
    "dev-null.gq",
    "dev-null.ml",
    "dev-point.biz",
    "dev-testing.website",
    "dev-tips.com",
    "dev01d.ml",
    "dev286.com",
    "devachek.org",
    "devadeva.ru",
    "devakaudicien.net",
    "devapartisi.name",
    "devbahis666.com",
    "devbaris.info",
    "devblock.com",
    "devcard.com",
    "devcourse.ru",
    "devdeb.ru",
    "developer401k.com",
    "developers401k.com",
    "developing.org",
    "developmentaldesigns.net",
    "developmentaldesignsms.com",
    "developmentstack.com",
    "devere-group-banking.com",
    "devere-malta.com",
    "deverob.com",
    "devexp.us",
    "devge.com",
    "devicemods.ru",
    "devildollar.com",
    "devilrainstudio.com",
    "devilsasians.com",
    "devilsgrannies.com",
    "devilsredheads.com",
    "devist.com",
    "devletgirisimcidestekleri.com",
    "devmoe.com",
    "devmongo.com",
    "devnaught.com",
    "devnullmail.com",
    "devo.black",
    "devo.blog",
    "devo.dance",
    "devo.dating",
    "devo.deals",
    "devo.direct",
    "devo.events",
    "devo.fitness",
    "devo.gallery",
    "devo.management",
    "devo.photos",
    "devo.productions",
    "devo.reviews",
    "devo.style",
    "devo.tech",
    "devo.tours",
    "devo.training",
    "devo.ventures",
    "devo.vision",
    "devoidgpoc.space",
    "devonandamanda.com",
    "devone.cf",
    "devone.ga",
    "devonki.mobi",
    "devonxdavon.com",
    "devops.cheap",
    "devops.country",
    "devopsjournal.net",
    "devopsmeetup.live",
    "devosair.site",
    "devotedcouples.com",
    "devotedent.com",
    "devotedparents.com",
    "devotions316.com",
    "devreg.org",
    "devrient.gent",
    "devrient.info",
    "devself.com",
    "devset.space",
    "devskateboards.com",
    "devuan.online",
    "devxtesting.info",
    "devxtesting.net",
    "devxtesting.org",
    "devyun.com",
    "dewa-lotto.club",
    "dewa-lotto.org",
    "dewa-sgp.net",
    "dewa189qq.net",
    "dewa633.online",
    "dewa855.com",
    "dewabet99.net",
    "dewabola303.com",
    "dewadaun.xyz",
    "dewadaunqq.com",
    "dewadaunqq.net",
    "dewadewipoker.com",
    "dewahk.info",
    "dewahk.live",
    "dewahk.online",
    "dewahkb.net",
    "dewajudi368.live",
    "dewajudi999.com",
    "dewakartu.org",
    "dewaklik388.com",
    "dewanagatoto.net",
    "dewaneon.net",
    "dewanonton21.com",
    "dewapkvdomino.com",
    "dewarsengines.com",
    "dewascore.info",
    "dewayim.site",
    "dewchenkam.ru",
    "dewi368.net",
    "dewightanderson.com",
    "dewightssalon.com",
    "dewihk.xyz",
    "dewly9.info",
    "dexhibition.com",
    "dexibu.xyz",
    "dextm.ro",
    "dextzobur.cf",
    "dextzobur.gq",
    "dextzobur.ml",
    "dextzobur.tk",
    "deyom.com",
    "dezcentr56.ru",
    "dezenfekteurunlerim.xyz",
    "dezigner.ru",
    "dezitouch.com",
    "df-re.com",
    "df59e.com",
    "df7d95.xyz",
    "dfb55.com",
    "dfcmdgame1.com",
    "dfde7.club",
    "dfdfdfd.site",
    "dfdgfsdfdgf.ga",
    "dfeatherston.com",
    "dfet356ads1.cf",
    "dfet356ads1.ga",
    "dfet356ads1.gq",
    "dfet356ads1.ml",
    "dfet356ads1.tk",
    "dff.buzz",
    "dff55.dynu.net",
    "dffhfjfj.website",
    "dffwer.com",
    "dfg456ery.ga",
    "dfg6.kozow.com",
    "dfgggg.org",
    "dfgh.net",
    "dfghj.ml",
    "dfiles.fun",
    "dfiles.online",
    "dfind.online",
    "dfjunkmail.co.uk",
    "dfmjvd.com",
    "dfqpqwsawe5566.com",
    "dfre.ga",
    "dfshndls.com",
    "dfthna.us",
    "dfwaccidentattorneys.com",
    "dfwatson.com",
    "dfwautoaccidentlawyer.com",
    "dfwcaraccidentattorneys.com",
    "dfwdaybook.com",
    "dfwin88.info",
    "dfwk968gbin4o1z.xyz",
    "dfwlqp.com",
    "dfwpauzbc.shop",
    "dfwyard.com",
    "dfy2413negmmzg1.ml",
    "dfy2413negmmzg1.tk",
    "dg27jv.us",
    "dgame.site",
    "dgb-toon4.com",
    "dgbikejxw.shop",
    "dgcustomerfirst.site",
    "dgd.mail-temp.com",
    "dgdbmhwyr76vz6q3.cf",
    "dgdbmhwyr76vz6q3.ga",
    "dgdbmhwyr76vz6q3.gq",
    "dgdbmhwyr76vz6q3.ml",
    "dgdbmhwyr76vz6q3.tk",
    "dggslwdn.shop",
    "dghyxu.xyz",
    "dgidpo.icu",
    "dgiuqr.us",
    "dgjsrajh.shop",
    "dgjxh9.us",
    "dgkcismd.shop",
    "dglnet.com.br",
    "dgmarbie.com",
    "dgnghjr5ghjr4h.cf",
    "dgnxcc.com",
    "dgoh.org",
    "dgpoker88.online",
    "dgpqdpxzaw.cf",
    "dgpqdpxzaw.ga",
    "dgpqdpxzaw.gq",
    "dgpqdpxzaw.ml",
    "dgpqdpxzaw.tk",
    "dgseoorg.org",
    "dgthailand.net",
    "dgtotu-tada.ru",
    "dgvjjcgf.xyz",
    "dgyx.xyz",
    "dh03.xyz",
    "dh04.xyz",
    "dh05.xyz",
    "dh06.xyz",
    "dh07.xyz",
    "dh08.xyz",
    "dh09.xyz",
    "dh2cuj.us",
    "dh545.site",
    "dh98.xyz",
    "dh9837.com",
    "dhabfontdec.ga",
    "dhabfontdec.gq",
    "dhabjouanes.cf",
    "dhabjouanes.gq",
    "dhana.info",
    "dharatal.org",
    "dharmaspirituality.com",
    "dharmatel.net",
    "dharoharfarms.com",
    "dhbeuxet.shop",
    "dhc6parts.com",
    "dhc6pma.com",
    "dhc8pma.com",
    "dhcustombaling.com",
    "dhfyqn.shop",
    "dhhmxmwo.shop",
    "dhivutsicing.tk",
    "dhl-uk.cf",
    "dhl-uk.ga",
    "dhl-uk.gq",
    "dhl-uk.ml",
    "dhl-uk.tk",
    "dhlzpjppr.shop",
    "dhm.ro",
    "dhmu5ae2y7d11d.cf",
    "dhmu5ae2y7d11d.ga",
    "dhmu5ae2y7d11d.gq",
    "dhmu5ae2y7d11d.ml",
    "dhmu5ae2y7d11d.tk",
    "dhooniraajje.xyz",
    "dhr1wm.us",
    "dhtdht.com",
    "dhudinuaj.xyz",
    "dhufjnaunstop.club",
    "dhwilp.com",
    "dhy.cc",
    "di-ve.com",
    "di9yy.info",
    "dia-gram.ru",
    "dia-rus.ru",
    "diaaline.ru",
    "diabasil.com",
    "diabet4k.top",
    "diabetesbuddyapp.com",
    "diabeteschennai.net",
    "diabetesresearchchennai.com",
    "diabetestelemedicine.com",
    "diabeticcakerecipes.org",
    "diabeticlotion.com",
    "diablodawg.com",
    "diablowallpapers.com",
    "diabolizing227ni.online",
    "diacamelia.online",
    "diacelte.ga",
    "diacelte.ml",
    "diachidulich.com",
    "diacustin.com",
    "diademail.com",
    "diadeoclic.cf",
    "diadeoclic.gq",
    "diadoo.xyz",
    "diagnosisdoublecheck.com",
    "diagnosistreatmentprograms.com",
    "diagnostic-kit.com",
    "diagnostikaavtov.ru",
    "diagrams.online",
    "dialarabia.com",
    "dialinee.ru",
    "dialogmagazine.org",
    "dialognt.ru",
    "dialogus.com",
    "dialsweetlydeny.website",
    "dialtools.ru",
    "dialtrust.ru",
    "diamond9casino.com",
    "diamondbar.online",
    "diamondbarestates.com",
    "diamondemail.com",
    "diamondglass.website",
    "diamondlogistics.se",
    "diamondt201.com",
    "diamondvalleytri.com",
    "dian.ge",
    "dianamora.com",
    "diandrade2den.xyz",
    "dianhabis.ml",
    "dianjing068.com",
    "dianjing166.com",
    "dianjing700.com",
    "dianjing800.com",
    "dianjing900.com",
    "dianlanwangtao.com",
    "dianyingzhongguo.cn",
    "diapacham.cf",
    "diapacham.ga",
    "diapacham.ml",
    "diapacham.tk",
    "diaparji.ga",
    "diaparji.gq",
    "diaparji.tk",
    "diapaulpainting.com",
    "diapoberf.cf",
    "diapoberf.ga",
    "diapoberf.gq",
    "diapoberf.tk",
    "diaraizi.cf",
    "diaraizi.ga",
    "diaraizi.tk",
    "diariocolatino.net",
    "diariodigital.info",
    "diaryinza.com",
    "diaryofahairtransplant.com",
    "diascan24.de",
    "diasisindia.com",
    "diasumpha.gq",
    "diazincenter.xyz",
    "dibisen.cf",
    "dibisen.ga",
    "dibisen.gq",
    "dibisen.tk",
    "dibon.site",
    "diboride.info",
    "dibtec.store",
    "dicasdacasabaher.com",
    "dicedica.shop",
    "dicejobalertsa13.com",
    "dicepic.com",
    "dicepicks.com",
    "dicerollplease.com",
    "diceservices.com",
    "diceservices.net",
    "diceservices.org",
    "dichthuattructuyen.com",
    "dichvugroupc.com",
    "dickdoc.net",
    "dickdoc.org",
    "dickmorrisservice.com",
    "dickrx.net",
    "dicksinhisan.us",
    "dicksinmyan.us",
    "dicksoncountyag.com",
    "dickwangdong.net",
    "dickwangdong.org",
    "dicycfeo.cf",
    "dicycfeo.ga",
    "dicycfeo.tk",
    "dicyemail.com",
    "didacvidal.com",
    "didamail.com",
    "didawljy.com",
    "didikselowcoffee.cf",
    "didikselowcoffee.ga",
    "didikselowcoffee.gq",
    "didikselowcoffee.ml",
    "didim-altinkum.xyz",
    "didimaraja.xyz",
    "didimkontor.com",
    "didimreizen.xyz",
    "didjinnal.com",
    "didncego.ru",
    "dido-peinture.com",
    "die-besten-bilder.de",
    "die-genossen.de",
    "die-optimisten.de",
    "die-optimisten.net",
    "die.life",
    "diecastsuperstore.com",
    "diehardmail.com",
    "diemailbox.de",
    "diennuocnghiahue.com",
    "diepesi.ga",
    "diepesi.gq",
    "diepesi.ml",
    "diepesi.tk",
    "dieran.info",
    "diesacan.gq",
    "diesel-bullery-armani.ru",
    "dieselcbd.com",
    "dieselexhaustfluid.biz",
    "diet-eating.site",
    "diethenorp.cf",
    "diethenorp.gq",
    "diethenorp.ml",
    "diethenorp.tk",
    "dietinsight.org",
    "dietmastery.org",
    "dietology-quest.online",
    "dietrich-group.com",
    "dietsvegetarian.com",
    "dievemar.cf",
    "dievemar.ga",
    "dievemar.tk",
    "diffamr.com",
    "differencefactory.com",
    "difora.cf",
    "difora.gq",
    "difora.ml",
    "diforcejobs.com",
    "diforceworks.com",
    "difwestnun.ml",
    "difwestnun.tk",
    "difz.de",
    "digading.com",
    "digdown.xyz",
    "digestletter.com",
    "diggcrypto.com",
    "diggiesupport.com",
    "digh.net",
    "digi-games.ru",
    "digi-women.com",
    "digibel.be",
    "digibet.biz",
    "digibet.net",
    "digibet.org",
    "digibetbox.com",
    "digibetwetten.com",
    "digicampus.dev",
    "digicampus.info",
    "digicash.org",
    "digicontentnetwork.com",
    "digimktgworld.com",
    "digimuse.org",
    "digiprice.co",
    "digisam.repair",
    "digisam.services",
    "digisamservice.com",
    "digisimpli.com",
    "digisnaxxx.com",
    "digital-bootcamp.com",
    "digital-designs.ru",
    "digital-doctrine.ru",
    "digital-email.com",
    "digital-everest.ru",
    "digital-filestore.de",
    "digital-garage.app",
    "digital-message.com",
    "digital-resilience.info",
    "digital-signage.ru",
    "digital-work.net",
    "digitalagency.ooo",
    "digitalbankingsummits.com",
    "digitalbristol.org",
    "digitalbull.net",
    "digitalbutler.biz",
    "digitalcameradevice.com",
    "digitalcasanet.com",
    "digitalcashnews.com",
    "digitalcoldwallet.com",
    "digitalcustomeracquisition.info",
    "digitalcustomeracquisition.org",
    "digitaldefencesystems.com",
    "digitaldron.com",
    "digitalesbusiness.info",
    "digitalforeplay.net",
    "digitalgadget.info",
    "digitaljobs.press",
    "digitalmail.info",
    "digitalmariachis.com",
    "digitalmarketingcoursesusa.com",
    "digitalmarketingpositions.com",
    "digitalmktgworld.com",
    "digitalmobster.com",
    "digitalnewspaper.de",
    "digitalnomad.exchange",
    "digitalpdfmanuales.xyz",
    "digitalryno.net",
    "digitalsanctuary.com",
    "digitalsearch.info",
    "digitalsignage.ru",
    "digitalsole.info",
    "digitalsolutionsdaraz.com",
    "digitalstoragepro.com",
    "digitaltechnic.ru",
    "digitaltechsf.com",
    "digitaltransarchive.net",
    "digitaltrueindia.com",
    "digitalvideoexperts.net",
    "digitalwebring.com",
    "digitalwebus.com",
    "digitalxpozure.com",
    "digitalyou.media",
    "digitalzeroone.com",
    "digitava.com",
    "digitex.ga",
    "digitex.gq",
    "digiwood.design",
    "digizoom.ru",
    "digl-team.net",
    "digmeha.cf",
    "digmeha.ga",
    "dignityhealthazcancer.biz",
    "digosnet.com",
    "digsandcribs.com",
    "digsignals.com",
    "digstaug.org",
    "digumo.com",
    "dihistores.site",
    "dihuantech.com",
    "diialine.ru",
    "diifo.com",
    "dijesupermart.site",
    "dijibilisim.xyz",
    "dijitalbulten.com",
    "dikbzn.site",
    "dikeyzebraperde.com",
    "dikop.ru",
    "dikriemangasu.cf",
    "dikriemangasu.ga",
    "dikriemangasu.gq",
    "dikriemangasu.ml",
    "dikriemangasu.tk",
    "dilapidation.org",
    "dilaracelikyapi.com",
    "dildemi.xyz",
    "dildosfromspace.com",
    "dilekevsen.com",
    "dilemmaggar.email",
    "dilipits.cf",
    "dilipits.ga",
    "dillonbrooks.com",
    "dilofoud.ga",
    "dilofoud.ml",
    "dilofoud.tk",
    "dilon-rp.ru",
    "dilusol.cf",
    "dilusol.ml",
    "dim-coin.com",
    "dimadde.cf",
    "dimadde.ga",
    "dimadde.gq",
    "dimasdomeni.press",
    "dimasprofit.press",
    "dimia.xyz",
    "dimimail.ga",
    "dimjkfsh.shop",
    "dimlruzz.shop",
    "dimpusburger.com",
    "dimsumbuffet.com",
    "dinaattar.com",
    "dinamika96.ru",
    "dinamikser44.ru",
    "dinarsanjaya.com",
    "dinasti4d.xyz",
    "dinastitoto.club",
    "dinbang.com",
    "dinbogcoin.com",
    "dinbogtoken.com",
    "dincama.cf",
    "dincama.ga",
    "dincama.ml",
    "dincelemlak.xyz",
    "dincoin.biz",
    "dincon.ru",
    "dineroparacasa.com",
    "dineroua.xyz",
    "dingbone.com",
    "dingdong4d.com",
    "dingeno.shop",
    "dingi-rekoi.ru",
    "dingniu00.com",
    "dingtorbi.ml",
    "dingyizixin.com",
    "dinhatban.info",
    "dinheiroextranaweb.com",
    "dinheironet.life",
    "dinhtamdan.com",
    "dinic.xyz",
    "dining-car.app",
    "dinkmail.com",
    "dinksai.ga",
    "dinksai.ml",
    "dinly.icu",
    "dinnernorthconway.com",
    "dinnersbydiane.com",
    "dino56pey.com",
    "dinoandnight.com",
    "dinoautomation.com",
    "dinocaira.com",
    "dinogam.com",
    "dinorc.com",
    "dinoschristou.com",
    "dinosloto7.ru",
    "dinoza.pro",
    "dinozorcocuk.com",
    "dinozorcocuk.net",
    "dinozy.net",
    "dinsfirsgu.ga",
    "dinsfirsgu.gq",
    "dinsfirsgu.ml",
    "dinsfirsgu.tk",
    "dintughreb.fun",
    "dinubaforeclosures.com",
    "diodecom.net",
    "dioemail.ml",
    "diofeci.tk",
    "diogenov.ru",
    "diokgadwork.cf",
    "diokgadwork.ga",
    "diokgadwork.ml",
    "diokgadwork.tk",
    "diolid.ru",
    "dioneijunior.com",
    "diopire.ga",
    "diopire.gq",
    "diopire.ml",
    "diopire.tk",
    "dioplumar.cf",
    "dioplumar.ml",
    "dioplumar.tk",
    "dioscolwedddas.3-a.net",
    "diotedpers.cf",
    "diotedpers.ga",
    "diotedpers.ml",
    "diotedpers.tk",
    "diotelli.cf",
    "diotelli.ga",
    "diotelli.gq",
    "diotelli.ml",
    "diotimen.cf",
    "diotimen.ml",
    "diovaqe.cf",
    "diovaqe.ml",
    "dioxv.us",
    "dipalmadental.com",
    "dipath.com",
    "diphtherotoxin.info",
    "diplom-voronesh.ru",
    "diploma-of-human-resource-management.com",
    "diplomadviser.info",
    "diplomats.com",
    "diplomnaya-jakutsk.ru",
    "diplomvirkutske.ru",
    "dipoelast.ru",
    "dipontio.gq",
    "dipontio.tk",
    "dipremp.ru",
    "dipsdhilwan.com",
    "dipshitz.net",
    "diputadobeltrones.com",
    "dipworld.ru",
    "diq0wq.info",
    "diral.ru",
    "dircuti.ga",
    "dircuti.ml",
    "direct-mail.info",
    "direct-mail.top",
    "directbox.com",
    "directdepositviaach.com",
    "directhatch.com",
    "directmail.top",
    "directmail24.net",
    "directmessenger.app",
    "directmonitor.nl",
    "director-general.com",
    "directpaymentviaach.com",
    "directphp.com",
    "directproductinvesting.com",
    "directsea.icu",
    "directworldusa.com",
    "direcway.com",
    "direness.com",
    "diretrizecese.org",
    "dirgapoker.com",
    "diri.com",
    "dirkandarrow.com",
    "dirkdigler.online",
    "dirlend.xyz",
    "dirtbikebits.com",
    "dirtdrooperver.ru",
    "dirtmail.ga",
    "dirtracer.com",
    "dirtracers.com",
    "dirtsportklop.ru",
    "dirtybeg.press",
    "dirtycam.tech",
    "dirtydicksrub.com",
    "dirtyloos.fun",
    "dirtymailer.cf",
    "dirtymailer.ga",
    "dirtymailer.gq",
    "dirtymailer.ml",
    "dirtymailer.tk",
    "dirtymax.com",
    "dirtyoffset.com",
    "dirtypetrol.com",
    "dirtyplai.email",
    "dirtyplain.email",
    "dirtysex.top",
    "dirtysli.email",
    "dirtyslice.email",
    "dirtyvagu.icu",
    "dis59cikygm5j3k.xyz",
    "disabilitylawatlanta.com",
    "disabilitylawyersatlanta.com",
    "disadapt.org",
    "disapprover.best",
    "disaq.com",
    "disario.info",
    "disastermare.com",
    "disasterserviceleads.com",
    "disavow.social",
    "disbox.net",
    "disbox.org",
    "discar.club",
    "discard-email.cf",
    "discard.cf",
    "discard.email",
    "discard.ga",
    "discard.gq",
    "discard.ml",
    "discard.tk",
    "discardmail.com",
    "discardmail.de",
    "discfoo.com",
    "disciples.com",
    "discjumsa.tk",
    "disckracuvna.cf",
    "disclasuc.cf",
    "disclasuc.gq",
    "disclasuc.ml",
    "disclasuc.tk",
    "discmarpe.cf",
    "discmarpe.ml",
    "discmarpe.tk",
    "discobolus.site",
    "discofan.com",
    "discolo.red",
    "discord.ml",
    "discordapp.app",
    "discordbotlist.xyz",
    "discordbots.ovh",
    "discordguide.xyz",
    "discordmail.com",
    "discordreviews.org",
    "discos4.com",
    "discosubjectfixed.site",
    "discount-stock-factory.ru",
    "discount-undersell-wow.space",
    "discountcasino15.com",
    "discountcasino23.com",
    "discountcasino24.com",
    "discountchargeback.com",
    "discounted-glasses.com",
    "discounted-store.com",
    "discountgaslantern.com",
    "discountmall.site",
    "discountscrubsuniforms.com",
    "discountwinkscrubs.com",
    "discountz.uno",
    "discoveraviationcenter.net",
    "discovermanuals.com",
    "discovermystrengthsnow.com",
    "discoverportugaltravel.site",
    "discoverwatch.com",
    "discovery.com",
    "discoverymail.com",
    "discoverymail.net",
    "discoveryparksofamerica.net",
    "discovino.com",
    "discreet-romance.com",
    "discreetfuck.top",
    "discreetvpn.com",
    "discretevtd.com",
    "discslot.com",
    "disctase.ga",
    "disctase.gq",
    "disctase.ml",
    "disctase.tk",
    "discus24.de",
    "discussads.com",
    "discussion.website",
    "diseasetrackers.net",
    "disenfects.com",
    "diseni.info",
    "disfkeenews.cf",
    "disfkeenews.ga",
    "disfkeenews.ml",
    "disfrazables.net",
    "dishmail.net",
    "dishscience.com",
    "dishwashers-list.space",
    "disign-concept.eu",
    "disign-revelation.com",
    "disignblog.ru",
    "disillo.cf",
    "disillo.ga",
    "disillo.ml",
    "disillo.tk",
    "disincniua.online",
    "disinfo.net",
    "diskilandcruiser.ru",
    "diskobmizik.net",
    "diskslot.com",
    "dislike.cf",
    "disneka.info",
    "disnessta.ga",
    "disnessta.gq",
    "disnessta.ml",
    "disnessta.tk",
    "disneyfox.cf",
    "disneykinderfietsen.online",
    "dispatchers.top",
    "dispatchsolutions.club",
    "displaying.page",
    "displayverse.com",
    "dispo.in",
    "dispomail.eu",
    "dispomail.win",
    "dispomail.xyz",
    "disporthcoc.cf",
    "disposable-e.ml",
    "disposable-email.ml",
    "disposable-mail.com",
    "disposable.al-sudani.com",
    "disposable.cf",
    "disposable.com",
    "disposable.dhc-app.com",
    "disposable.ga",
    "disposable.ml",
    "disposable.nogonad.nl",
    "disposable.site",
    "disposableaddress.com",
    "disposableemail.org",
    "disposableemailaddresses.com",
    "disposableemailaddresses.emailmiser.com",
    "disposableinbox.com",
    "disposablemail.space",
    "disposablemail.top",
    "disposablemails.com",
    "dispose.it",
    "disposeamail.com",
    "disposemail.com",
    "disposicaosaudavel.com",
    "dispostable.com",
    "dispotomen.tk",
    "disppropli.ga",
    "disquieted.best",
    "disrawhen.ga",
    "disrupting.tech",
    "dissertatsija.ru",
    "dissonance.app",
    "dissonant-tech.com",
    "distainess.cf",
    "distainess.tk",
    "distancerei.email",
    "distant-info.ru",
    "distanzechilometriche.org",
    "disterubebdfsd.xyz",
    "distnewskhal.cf",
    "distnewskhal.gq",
    "distnewskhal.ml",
    "distnewskhal.tk",
    "distorylty.host",
    "distplo.cc",
    "distrackbos.com",
    "distrelec-noroeste.com",
    "distressed.club",
    "distribuidorafloral.com",
    "distributorphuceng.online",
    "distrify.net",
    "distrow.info",
    "distrowstore.com",
    "disusedtube.com",
    "diswino.ga",
    "ditac.site",
    "ditchpa.press",
    "ditchpr.icu",
    "ditchtaste.recipes",
    "ditigal-brand.com",
    "ditills.ru",
    "ditsantjob.com",
    "diujungsenja.online",
    "diutiurnal.site",
    "diuz.com",
    "diva.live",
    "divad.ga",
    "divalith.ru",
    "divamodelslive.com",
    "divan-stroy.ru",
    "divaphone.com",
    "divaphone.net",
    "divasantiques.com",
    "divchata.ru",
    "divcot.ru",
    "diveaboardtheconception.com",
    "diveandseek.com",
    "divelogconception.com",
    "divemasterconception.com",
    "divermail.com",
    "diversaoemcasa.site",
    "diversaoemcasa.website",
    "diversitycheckup.com",
    "diversitygaming.online",
    "diverslogconception.com",
    "divertidoemcasa.site",
    "divfree.com",
    "divfree.net",
    "divfree.org",
    "divideandconquerdesigns.com",
    "dividendxk.com",
    "dividerecords.com",
    "divinecakestudio.com",
    "divinecaketoppers.com",
    "divinehealthcenter.info",
    "divinekine.com",
    "divinerecords.com",
    "divisionzerocup.com",
    "divismail.ru",
    "diviwoolayouts.com",
    "divorcedandhappy.com",
    "divorcelawyersguide.xyz",
    "divorcenapa.com",
    "divrsicon.com",
    "divrush.com",
    "divtz1.us",
    "diwanieh.org",
    "diwanx.com",
    "diwaq.com",
    "diwudao.com",
    "dixonpilotshop.com",
    "diyadeja.site",
    "diyarbakir-nakliyat.xyz",
    "diyarbakirengelliler.xyz",
    "diyarbakirhaberler.xyz",
    "diyarbakirisitmemerkezi.xyz",
    "diyarbakirkiralikaraba.com",
    "diyarbakirlilardernegi.xyz",
    "diyarbakirtmgd.xyz",
    "diybookmarks.com",
    "diyfilms.com",
    "diyfurnituremakeovers.net",
    "diygardeningtips.shop",
    "diyhomedecorz.me",
    "diyixs.xyz",
    "diymail.cf",
    "diymarketing.academy",
    "diymarketinguniversity.com",
    "diypostconpi.ml",
    "diywithpaul.com",
    "diz-store.online",
    "dizibb.org",
    "dizifenomeny.xyz",
    "diziizle.tube",
    "dizinmarket.online",
    "dizinmarket.xyz",
    "dj5882.com",
    "dj9887.com",
    "djan.de",
    "djdfkwro182-privdfejt.host",
    "djdnq.online",
    "djdwzaty3tok.cf",
    "djdwzaty3tok.ga",
    "djdwzaty3tok.gq",
    "djdwzaty3tok.ml",
    "djdwzaty3tok.tk",
    "djeada.live",
    "djembassy.ru",
    "djennam.xyz",
    "djhy888.com",
    "djigurdagox.online",
    "djj82.com",
    "djmag.digital",
    "djnkkout.tk",
    "djqueue.com",
    "djrh.email",
    "djrqta.com",
    "djsfw.com",
    "djsys.xyz",
    "djubya.us",
    "djuncan-shop.space",
    "djxky.com",
    "djyoli.us",
    "djzqswix.shop",
    "dk-osaka.ru",
    "dk-volgodon.ru",
    "dk0aip.us",
    "dk3vokzvucxolit.cf",
    "dk3vokzvucxolit.ga",
    "dk3vokzvucxolit.gq",
    "dk3vokzvucxolit.ml",
    "dk3vokzvucxolit.tk",
    "dkbmpm.fun",
    "dkbmsc.fun",
    "dkcfineart.com",
    "dkdmsq.fun",
    "dkdmxy.fun",
    "dkert2mdi7sainoz.cf",
    "dkert2mdi7sainoz.ga",
    "dkert2mdi7sainoz.gq",
    "dkert2mdi7sainoz.ml",
    "dkert2mdi7sainoz.tk",
    "dkfgnjfd.xyz",
    "dkfmrt.fun",
    "dkgmkc.fun",
    "dkgmkp.fun",
    "dkgmzt.fun",
    "dkgram.com",
    "dkhhf.club",
    "dkhmyd.fun",
    "dkids.xyz",
    "dkjmkc.fun",
    "dkjmks.fun",
    "dkjmtc.fun",
    "dkjmxh.fun",
    "dkkmjq.fun",
    "dkkmjz.fun",
    "dkljfkbvdf4.club",
    "dklmln.fun",
    "dklmmd.fun",
    "dknmhq.fun",
    "dknmjw.fun",
    "dko.kr",
    "dkpkepri.info",
    "dkpnpmfo2ep4z6gl.cf",
    "dkpnpmfo2ep4z6gl.ga",
    "dkpnpmfo2ep4z6gl.gq",
    "dkpnpmfo2ep4z6gl.ml",
    "dkpnpmfo2ep4z6gl.tk",
    "dkqhx.xyz",
    "dks97.space",
    "dksmnm.fun",
    "dkt24.de",
    "dkthervr.shop",
    "dktmnb.fun",
    "dkuinjlst.shop",
    "dkymjf.fun",
    "dl-thegedsection.com",
    "dl5oc2.info",
    "dl812pqedqw.cf",
    "dl812pqedqw.ga",
    "dl812pqedqw.gq",
    "dl812pqedqw.ml",
    "dl812pqedqw.tk",
    "dl9227.com",
    "dl9827.com",
    "dldbpj.icu",
    "dlemail.net",
    "dlemail.ru",
    "dlesha.ru",
    "dlexpert.com",
    "dlfree.net",
    "dlhaiteng.com",
    "dlink.cf",
    "dlink.gq",
    "dlinlyga.ga",
    "dlinlyga.gq",
    "dlinlyga.ml",
    "dlipb2.com",
    "dlj6pdw4fjvi.cf",
    "dlj6pdw4fjvi.ga",
    "dlj6pdw4fjvi.gq",
    "dlj6pdw4fjvi.ml",
    "dlj6pdw4fjvi.tk",
    "dljzuqnx.com",
    "dlkwbs.icu",
    "dll-ne-nayden.ru",
    "dllonhquan.com",
    "dllpiper.com",
    "dllyjamalk.com",
    "dlmkme.ga",
    "dlmkme.ml",
    "dload.fun",
    "dload.site",
    "dlpfbyy.com",
    "dlpt7ksggv.cf",
    "dlpt7ksggv.ga",
    "dlpt7ksggv.gq",
    "dlpt7ksggv.ml",
    "dlpt7ksggv.tk",
    "dls-ecme.com",
    "dlservermods.xyz",
    "dltjitu.net",
    "dluxuriousvehicles.com",
    "dlwdudtwlt557.ga",
    "dlxglamour.com",
    "dlyasnoff.ru",
    "dlyavasfrend.ru",
    "dlyemail.com",
    "dlyludeey.ru",
    "dlympics.com",
    "dm-project.ru",
    "dm.w3internet.co.uk",
    "dm.w3internet.co.ukexample.com",
    "dm3zv0.online",
    "dm7xse.us",
    "dm9bqwkt9i2adyev.ga",
    "dm9bqwkt9i2adyev.ml",
    "dm9bqwkt9i2adyev.tk",
    "dma.in-ulm.de",
    "dma2x7s5w96nw5soo.cf",
    "dma2x7s5w96nw5soo.ga",
    "dma2x7s5w96nw5soo.gq",
    "dma2x7s5w96nw5soo.ml",
    "dma2x7s5w96nw5soo.tk",
    "dmackag.com",
    "dmail.kyty.net",
    "dmail.unrivaledtechnologies.com",
    "dmail1.net",
    "dmailman.com",
    "dmailpro.net",
    "dmailz.tech",
    "dmaji.ddns.net",
    "dmaji.ml",
    "dmarc.ro",
    "dmarksagency.com",
    "dmarshallmarketing.com",
    "dmaster39.ru",
    "dmc-12.cf",
    "dmc-12.ga",
    "dmc-12.gq",
    "dmc-12.ml",
    "dmc-12.tk",
    "dmc4u.tk",
    "dmcchampion.site",
    "dmcd.ctu.edu.gr",
    "dmcforex.com",
    "dmcgames.store",
    "dmcqcnzq.shop",
    "dmdea.com",
    "dmedicals.com",
    "dmetzh.us",
    "dmfm7b.site",
    "dmg-consulting.org",
    "dmhy.moe",
    "dmirekt.ru",
    "dmitemtikog.gq",
    "dmitrovka.net",
    "dmitry.ru",
    "dmitrysushenkov.ru",
    "dmkt.studio",
    "dmkyb.live",
    "dmnservtrcksrvr.xyz",
    "dmnwnkanj.shop",
    "dmslovakiat.com",
    "dmt-project.com",
    "dmtc.edu.pl",
    "dmtqrnqrb.shop",
    "dmtu.ctu.edu.gr",
    "dmv.com",
    "dmwiki.com",
    "dmxs8.com",
    "dmzj.moe",
    "dmzyhe.xyz",
    "dn293633.xyz",
    "dn5eoc.us",
    "dn98n.buzz",
    "dna.holiday",
    "dnabdsns.icu",
    "dnaglobalpartners.site",
    "dnaindebouw.com",
    "dnainternet.net",
    "dnaradiuscap.website",
    "dnatestingaidforyou.live",
    "dnatestingaidsforyou.com",
    "dnatestingaidsforyou.live",
    "dnatestingforyou.live",
    "dnatestingsforyou.live",
    "dncjdh665.com",
    "dndbs.net",
    "dndcak.us",
    "dndent.com",
    "dndiprlondon.com",
    "dndoqi.tokyo",
    "dndpoker.xyz",
    "dnek.com",
    "dnestrauto.com",
    "dnhddoszz.shop",
    "dnkpc.com",
    "dnld.fun",
    "dnld.online",
    "dnld.site",
    "dnocoin.com",
    "dnplayer.com",
    "dnqq6.us",
    "dns-cloud.net",
    "dns-privacy.com",
    "dns4urpns.com",
    "dns889.com",
    "dns9227.com",
    "dns9827.com",
    "dns9837.com",
    "dnsabr.com",
    "dnsalias.com",
    "dnsalias.net",
    "dnsalias.org",
    "dnsbridge.com",
    "dnsdeer.com",
    "dnsdojo.com",
    "dnsdojo.net",
    "dnsdojo.org",
    "dnses.ro",
    "dnsguard.net",
    "dnsmadeeasy.com",
    "dnsxdns.com",
    "dnsxdns.net",
    "dnt-domain-test.com",
    "dnw1wp.us",
    "dnyeemail.com",
    "dnzhb.com",
    "do-be-french-cars-ok.live",
    "do-creditcardnofeecas-ok.live",
    "do-in-dental-implant-ok.live",
    "do-in-luxury-suvs-ok.live",
    "do-intl-austin-real-estate-ok.live",
    "do-steel.com",
    "doa-game.com",
    "doabedbugremovalok.live",
    "doameyux.com",
    "doanart.com",
    "doar.net",
    "doatre.com",
    "dob.jp",
    "dobedbugremovalok.live",
    "dobidding.net",
    "doblyat.site",
    "dobor-pozyczek.info",
    "dobord.land",
    "dobrabet56.com",
    "dobraya-italia.ru",
    "dobrodeyarf.ru",
    "dobrodomik.com",
    "dobroholod.ru",
    "dobrychvirta.ru",
    "dobywe.info",
    "doc-jukebox.info",
    "doc-mail.net",
    "doc6.xyz",
    "doc8.xyz",
    "docasnyemail.cz",
    "docasnymail.cz",
    "docconnect.com",
    "doceke.ru",
    "docent.ml",
    "docesgourmetlucrativo.com",
    "docib.us",
    "docinsider.com",
    "dock.city",
    "dock.direct",
    "docker-news.com",
    "docker-news.org",
    "dockerpeer.com",
    "dockhaus.com",
    "dockwa.net",
    "doclist.bounces.google.com",
    "docmail.com",
    "docmail.cz",
    "docmana.ga",
    "docmana.gq",
    "docmana.tk",
    "docomo.ne.jp",
    "docordbloodbankhelpok.live",
    "docordbloodbankhelpsok.live",
    "docs.coms.hk",
    "docs.google.com",
    "doctgifma.cf",
    "doctgifma.tk",
    "doctor-slim.ru",
    "doctor.com",
    "doctoralaurasanchez.com",
    "doctorbarron.com",
    "doctorbgarlictea.site",
    "doctorbranding.co",
    "doctordieu.xyz",
    "doctorfitness.net",
    "doctorgarter.ru",
    "doctorlane.info",
    "doctormcknight.com",
    "doctornilangi.com",
    "doctornilangi.net",
    "doctorsimsoffice.com",
    "doctorspopper.com",
    "doctorz.app",
    "doctruyemoi.com",
    "doctxyle.cf",
    "doctxyle.gq",
    "doctxyle.ml",
    "doctxyle.tk",
    "docu.me",
    "documentstorage4.com",
    "doddleandco.ru",
    "dodeltas.info",
    "dodge-challenger.club",
    "dodge-india.club",
    "dodge-ram.club",
    "dodgeit.com",
    "dodgemail.de",
    "dodgit.com",
    "dodgit.org",
    "dodo.com.au",
    "dodogame88.info",
    "dodogame88.org",
    "dodongdaibai.info",
    "dodorito.ru",
    "dodsi.com",
    "dodungjapan.com",
    "does-it.net",
    "doesntexist.com",
    "doesntexist.org",
    "doetsreizen.net",
    "dofile.pl",
    "dofree4k.com",
    "dog-n-cats-shelter.ru",
    "dog.com",
    "dog.ms1.email",
    "dogberries.ru",
    "dogcastmedia.com",
    "dogdaydevelopers.com",
    "doge-mail.net",
    "dogelux.ir",
    "dogestake.site",
    "doggamenew.ru",
    "dogit.com",
    "doglisteneroftheeast.com",
    "doglover.com",
    "dogmail.co.uk",
    "dogobet109.com",
    "dogobet110.com",
    "dogodesignandart.com",
    "dogood.news",
    "dogpoop.app",
    "dogrkd.site",
    "dogs-blog.ru",
    "dogsines.ml",
    "dogsines.tk",
    "dogsnob.net",
    "dogsportshop.de",
    "dogstarclothing.com",
    "dogtrainersnewjersey.com",
    "dogtrainingobedienceschool.com",
    "dogtravelreviews.net",
    "dogwood.website",
    "dogzoa.shop",
    "dohalatharin.host",
    "dohangdaquan.xyz",
    "dohodi.info",
    "doiea.com",
    "doierk.club",
    "doimatch.com",
    "doinformowani.online",
    "doinformowani.site",
    "doinicioaolucro.com",
    "dointo.com",
    "doipor.site",
    "doiposle28.ru",
    "doitagile.com",
    "doitnao.com",
    "doityourself.com",
    "dok4.ru",
    "dokaker.xyz",
    "dokist.net",
    "dokist.org",
    "doknews.ru",
    "dokterns.info",
    "doktor-div.ru",
    "doktordiv.ru",
    "dokumakonserbileklik.com",
    "dokuzbilisim.com",
    "dolcher.ru",
    "dolequ.com",
    "dolina2018.ru",
    "dolinak.ru",
    "dollar-plus.ru",
    "dollargoback.com",
    "dollars4homes.com",
    "dollartreeseeds.com",
    "dollarzone.ru",
    "dolldrooperver.ru",
    "dollingrel.gq",
    "dollpolemicdraw.website",
    "dollsshop.live",
    "dollxbetpinup.ru",
    "dolmentor.com",
    "dolnaa.asia",
    "doloresantander.org",
    "dolphiding.icu",
    "dolphincityrecords.com",
    "dolphinhost.space",
    "dolphinnet.net",
    "doludunya.xyz",
    "dolunitra.cf",
    "dom-cleverland.ru",
    "dom-drakona.ru",
    "dom-mo.ru",
    "dom855.live",
    "doma-sad.ru",
    "domain-99k.com",
    "domain1dolar.com",
    "domainabuser.com",
    "domainaing.cf",
    "domainaing.ga",
    "domainaing.gq",
    "domainaing.ml",
    "domainaing.tk",
    "domaindan.com",
    "domaindomain5.com",
    "domaindoug.com",
    "domainegorn.com",
    "domainleak.com",
    "domainlease.xyz",
    "domainnameoffice.com",
    "domainresellerinindia.com",
    "domajabro.ga",
    "domamulet.ru",
    "domapress.ru",
    "domast.ru",
    "domavnegoroda.ru",
    "dombio.ru",
    "domby.ru",
    "dome-camp.ru",
    "domeek.ru",
    "domen-treker.space",
    "domeninfo.info",
    "domenvds135.ru",
    "domerdi.cf",
    "domerdi.ga",
    "domerdi.ml",
    "domerdi.tk",
    "domforfb1.tk",
    "domforfb18.tk",
    "domforfb19.tk",
    "domforfb2.tk",
    "domforfb23.tk",
    "domforfb27.tk",
    "domforfb29.tk",
    "domforfb3.tk",
    "domforfb4.tk",
    "domforfb5.tk",
    "domforfb6.tk",
    "domforfb7.tk",
    "domforfb8.tk",
    "domforfb9.tk",
    "domi855.live",
    "domiansoch.ru",
    "domiclips.com",
    "domien.ru",
    "domil.xyz",
    "dominatingg.top",
    "dominicanreload.com",
    "dominionbotarena.com",
    "dominivohw.ru",
    "domino789.com",
    "domino789.info",
    "domino789.net",
    "dominoasli.website",
    "dominoemas.org",
    "dominoitu.com",
    "dominoqq855.com",
    "dominoqq855.live",
    "dominototo.com",
    "dominuzxpe.space",
    "domitai.net",
    "domitai.org",
    "domnster.site",
    "domodedovo-beton-zavod.ru",
    "domorewhlrv.com",
    "domorewithheartlandrv.com",
    "domostroy18.ru",
    "domozmail.com",
    "dompetpt.com",
    "domremonta-nv.ru",
    "domru.online",
    "domshops.site",
    "domstroitell.ru",
    "domstroytv.ru",
    "domtecnologi.ru",
    "domusasset.net",
    "domwahlwin.cf",
    "domwahlwin.gq",
    "domwahlwin.ml",
    "domy.me",
    "don-m.online",
    "donagoyas.info",
    "donaldvandrewsscholarship.org",
    "donat.club",
    "donatedollar.com",
    "donboz.ru",
    "dondom.ru",
    "doneasy.com",
    "doneck24.ru",
    "donegal.net",
    "donemail.ru",
    "donevest.ru",
    "donew.fun",
    "donew.host",
    "donew.space",
    "donew.website",
    "donewithacne.com",
    "dongen.info",
    "dongeng.site",
    "dongfangzx.com",
    "donghogiare.org",
    "dongisi.ga",
    "dongisi.gq",
    "dongisi.tk",
    "dongphucaokhoac.net",
    "dongphucaophong.org",
    "dongphucbongda.net",
    "dongphuchocsinh.org",
    "dongphucnhahang.net",
    "dongqing365.com",
    "dongru.top",
    "dongyoubaohujh.xyz",
    "doni42.com",
    "donikolupr.cf",
    "donjuan.com",
    "donkers.icu",
    "donkey-out.xyz",
    "donn6.xyz",
    "donnaappell.com",
    "donnlasher.com",
    "donnyandmarietour.com",
    "donnyboypony.com",
    "donnybrook-fair-d4.com",
    "donnystiefel.com",
    "donoboz.ru",
    "donor-penza.ru",
    "donorfr.xyz",
    "donorfro.xyz",
    "donorthcoworking.org",
    "donortigh.us",
    "donorto.icu",
    "donorwide.xyz",
    "donot-reply.com",
    "donotconvert.com",
    "donotpetme.com",
    "donsalvatorepalmademallorca.com",
    "donsfans.com",
    "dontblameyourears.com",
    "dontcallmeanartist.com",
    "dontexist.net",
    "dontexist.org",
    "dontgocuba.com",
    "dontgotmail.com",
    "dontmail.net",
    "dontmesswithmypet.org",
    "dontmesswithtexas.com",
    "dontreg.com",
    "dontrushhub.info",
    "dontsendmespam.de",
    "dony24.shop",
    "dooboop.com",
    "dooel.info",
    "doohee.email",
    "dooi.email",
    "doolanlawoffice.com",
    "doom898.xyz",
    "doomdns.com",
    "doomdns.org",
    "doomein.com",
    "doomsdayapocalypse.com",
    "doomsdayprep.org",
    "doonung2u.com",
    "doonungonlinefree.com",
    "doorbloq.biz",
    "doorgifted.com",
    "doorlocker.shop",
    "doorprice.icu",
    "doory.sk",
    "doospage.host",
    "dopabiotics.com",
    "dopepedalers.com",
    "dophs.stream",
    "dopp.me",
    "doppelgengler.com",
    "dopsy.ru",
    "doquier.tk",
    "doramail.com",
    "doranscale.com",
    "dorcasinofeet.ru",
    "dorelliphotographie.com",
    "dorivaimoveis.site",
    "dorjq.buzz",
    "dormokis.cf",
    "dormokis.ml",
    "dormokis.tk",
    "dormontazh.ru",
    "dorne.ml",
    "doroobo-bet.ru",
    "dorotheastuart.com",
    "dorrkupong.com",
    "dorrkupongen.com",
    "dosait.ru",
    "doscobal.com",
    "dosirakm.com",
    "dosmallishthings.com",
    "dostavim1.xyz",
    "dostavimpokazani.ru",
    "dostavka-24-7.ru",
    "dostavka-avito.site",
    "dostavkakazani.ru",
    "dostavkapokazani.ru",
    "dostavkapoz.ru",
    "dostmail.com",
    "dostupnaya-ipoteka.ru",
    "dosug-kolomna.ru",
    "dosug-nevinnomyssk.ru",
    "dosugryazan1.com",
    "dosusra.cf",
    "dosusra.ga",
    "dosusra.gq",
    "dosusra.ml",
    "dosusra.tk",
    "dot-coin.com",
    "dot-mail.top",
    "dot-ml.ml",
    "dot-ml.tk",
    "dota-leader.fun",
    "dota2-tapedjtape.info",
    "dota2bets.net",
    "dotabet105.com",
    "dotabet107.com",
    "dotabet109.com",
    "dotabet110.com",
    "dotabet112.com",
    "dotabet113.com",
    "dotabet114.com",
    "dotabet115.com",
    "dotabet116.com",
    "dotabet117.com",
    "dotabet118.com",
    "dotabet119.com",
    "dotabet120.com",
    "dotabet123.com",
    "dotabet126.com",
    "dotabet127.com",
    "dotabet128.com",
    "dotabet129.com",
    "dotabet130.com",
    "dotabet131.com",
    "dotabet132.com",
    "dotabet134.com",
    "dotabet136.com",
    "dotabet137.com",
    "dotabet138.com",
    "dotabet140.com",
    "dotabet141.com",
    "dotabet142.com",
    "dotabet143.com",
    "dotabet144.com",
    "dotabet145.com",
    "dotabet146.com",
    "dotabet147.com",
    "dotabet148.com",
    "dotabet149.com",
    "dotabet150.com",
    "dotastat.ru",
    "dotcmscheck.xyz",
    "dotcom.fr",
    "dotcompliance.online",
    "dotcrown.com",
    "dothisforyourself.info",
    "dotland.net",
    "dotlethu.cf",
    "dotlethu.gq",
    "dotlethu.ml",
    "dotlethu.tk",
    "dotlvay3bkdlvlax2da.cf",
    "dotlvay3bkdlvlax2da.ga",
    "dotlvay3bkdlvlax2da.gq",
    "dotlvay3bkdlvlax2da.ml",
    "dotlvay3bkdlvlax2da.tk",
    "dotman.de",
    "dotmsg.com",
    "dotnetnukeskins.net",
    "dotnow.com",
    "dotph.website",
    "dotproperty.asia",
    "dots.market",
    "dotslashrage.com",
    "dott.it",
    "dottyproducts.com",
    "dottyprojects.com",
    "doublemail.de",
    "doublescanner.com",
    "doubletale.com",
    "doublewave.ru",
    "douchelounge.com",
    "doughblogger.com",
    "doughmaine.xyz",
    "doughnuts21.ru",
    "doughty-australia.com",
    "dougkrever.com",
    "douithardt.xyz",
    "doulabee.com",
    "doulocracy.site",
    "dourvhna.space",
    "dousmakos.com",
    "douyin888.xyz",
    "dov86hacn9vxau.ga",
    "dov86hacn9vxau.ml",
    "dov86hacn9vxau.tk",
    "dovequando.info",
    "dovereducationlink.com",
    "dovizapi.xyz",
    "dovqz6.host",
    "dowloadplus.xyz",
    "downersgroveattorneys.com",
    "downgentai.cf",
    "downgentai.ga",
    "downgentai.gq",
    "downgentai.ml",
    "downlayer.com",
    "download-privat.de",
    "downloadarea.net",
    "downloadclub.ru",
    "downloadeguide.mywire.org",
    "downloadfree.space",
    "downloadplaystore.app",
    "downloadplaystore.org",
    "downloadvideo.biz",
    "downloadvideotiktok.net",
    "downpoza.ga",
    "downpoza.ml",
    "downquibbledung.website",
    "downsizingandestates.com",
    "downtownabilene.com",
    "downtownanchorage.com",
    "downtownaurora.com",
    "downtownbeaumont.com",
    "downtowncalhoun.com",
    "downtownfremont.com",
    "downtowngarland.com",
    "downtownhomeboston.com",
    "downtownisthe.place",
    "downtowntulsaoffice.com",
    "dowsaajung.cf",
    "dowsaajung.gq",
    "dowsaajung.ml",
    "dowsaajung.tk",
    "doxamall.site",
    "doxcity.net",
    "doxeo.global",
    "doxeo.info",
    "doxeo.live",
    "doxeo.net",
    "doxeo.org",
    "doxod-v-seti.ru",
    "doxsale.top",
    "doxycycline247.video",
    "doy.kr",
    "doyouneedrenovation.id",
    "doyouneedrenovation.net",
    "doyousonder.com",
    "doyuoutlets.site",
    "dozarb.agency",
    "dozarb.online",
    "dozarb.org",
    "dozarb.space",
    "dozarb.store",
    "dozarb.tech",
    "dozen-spins1.ru",
    "dozenspins-cas.ru",
    "dozenspinsonline.ru",
    "dozvon-spb.ru",
    "dp76.com",
    "dp84vl63fg.cf",
    "dp84vl63fg.ga",
    "dp84vl63fg.gq",
    "dp84vl63fg.ml",
    "dp84vl63fg.tk",
    "dpanel.site",
    "dpapa.ooo",
    "dpasanhall.host",
    "dpaydpal.shop",
    "dpbbo5bdvmxnyznsnq.ga",
    "dpbbo5bdvmxnyznsnq.ml",
    "dpbbo5bdvmxnyznsnq.tk",
    "dpdf.site",
    "dpfbilling.com",
    "dpgwzwy.site",
    "dpics.fun",
    "dplanet.ch",
    "dplmek.ga",
    "dpluse.net",
    "dpm5g8.us",
    "dpmchqfi.shop",
    "dpmcinternational.com",
    "dpmwybaff.shop",
    "dpnwoyov.shop",
    "dpokesheat.cf",
    "dpokesheat.ga",
    "dpokesheat.gq",
    "dpokesheat.ml",
    "dpokesheat.tk",
    "dport.fun",
    "dport.site",
    "dprots.com",
    "dpsrs.org",
    "dpttso8dag0.cf",
    "dpttso8dag0.ga",
    "dpttso8dag0.gq",
    "dpttso8dag0.ml",
    "dpttso8dag0.tk",
    "dpworld.net",
    "dq4yvh.com",
    "dqajb1.site",
    "dqb9zj.info",
    "dqchx.com",
    "dqhs.site",
    "dqkerui.com",
    "dqkjt6.com",
    "dqnwara.com",
    "dqpw7gdmaux1u4t.cf",
    "dqpw7gdmaux1u4t.ga",
    "dqpw7gdmaux1u4t.gq",
    "dqpw7gdmaux1u4t.ml",
    "dqpw7gdmaux1u4t.tk",
    "dqtpwv.us",
    "dqw58.space",
    "dr-hospitals.ru",
    "dr-mail.net",
    "dr-nasir-alzahrani.org",
    "dr-sinan-goker.com",
    "dr.com",
    "dr0m.ru",
    "dr0pb0x.ga",
    "dr5.xyz",
    "dr69.site",
    "dr7.xyz",
    "dracaras.cf",
    "dracaras.gq",
    "dracaras.ml",
    "dracaras.tk",
    "dracc.me",
    "draconites.xyz",
    "drafpalo.cf",
    "drafpalo.ga",
    "drafpalo.ml",
    "drafpalo.tk",
    "draftanimals.ru",
    "draftfirs.icu",
    "draftfosterfloat.site",
    "drafthabi.xyz",
    "draftsheetpro.com",
    "drag1metal.ru",
    "dragao31.com",
    "dragcok2.cf",
    "dragcok2.gq",
    "dragcok2.ml",
    "dragcok2.tk",
    "dragfalsbag.cf",
    "dragfalsbag.ga",
    "dragfalsbag.gq",
    "dragfalsbag.ml",
    "dragome.fun",
    "dragon-palace-glanmire.com",
    "dragon-pool.com",
    "dragonboatchinese.com",
    "dragoncapital.us",
    "dragoncitydanang.com",
    "dragoncon.net",
    "dragonfly.africa",
    "dragonflydanlier.com",
    "dragonflyna.com",
    "dragonflypure.com",
    "dragonmanialegendshacks.website",
    "dragonprana.com",
    "dragons-spirit.org",
    "dragonsborn.com",
    "dragonslair.site",
    "dragontigerseal-my.com",
    "dragracer.com",
    "dragwave.us",
    "drainage-birmingham.net",
    "drainservices.com",
    "drake.casino",
    "drakeslansdowne.com",
    "drakorfor.me",
    "draktar.online",
    "dralselahi.com",
    "drama.tw",
    "drama2tv.com",
    "dramabt.com",
    "dramatization758is.online",
    "dramdesra.ga",
    "dramdesra.ml",
    "drameral.cf",
    "drameral.ml",
    "drameral.tk",
    "drangeladraughon.com",
    "dranitajohnson.com",
    "draperacupuncture.com",
    "drar.de",
    "drawify.art",
    "drawme.site",
    "drawmedia.org",
    "drawquest.net",
    "drazen.dev",
    "drcanadasa.info",
    "drcoppersmith.com",
    "drcynthiah.com",
    "drdr.email",
    "drdrb.com",
    "drdrb.net",
    "dream417.xyz",
    "dreamact.com",
    "dreamaror.ga",
    "dreamaror.gq",
    "dreamaror.ml",
    "dreambuket.ru",
    "dreamcatcher.email",
    "dreamed776ll.online",
    "dreamersglobal.com",
    "dreamfin.ru",
    "dreamfishfoundation.org",
    "dreamhacker.xyz",
    "dreamhomes4u.net",
    "dreamingcleaning.com",
    "dreamingtrack.com",
    "dreamlover.dating",
    "dreamoz.info",
    "dreampian.xyz",
    "dreamsareforliving.com",
    "dreamsat.ru",
    "dreamscape.marketing",
    "dreamscapemobile.com",
    "dreamsindex.com",
    "dreamsink.com",
    "dreamsites.xyz",
    "dreamstar1.com",
    "dreamvotes.com",
    "dreamyfinance.ru",
    "dreamyoursoulhome.com",
    "drechsler.digital",
    "dred.ru",
    "dregvide.cf",
    "dregvide.ga",
    "dregvide.tk",
    "drehstuhl.discount",
    "dremixd.com",
    "drempleo.com",
    "drentfotografengroep.online",
    "drepinym.cf",
    "drepinym.ga",
    "drepinym.ml",
    "drepinym.tk",
    "dress9x.com",
    "dresscomeon.online",
    "dressfactories.com",
    "dressfess.com",
    "dresspo.icu",
    "dressunawaretruth.website",
    "dressyouressence.com",
    "dretety.ru",
    "drevo.si",
    "drevobrus.ru",
    "drevorouz.ru",
    "drewry.info",
    "drexel.edu",
    "drexenterprises.com",
    "dreylefilsdepute.cf",
    "drf.email",
    "drfarukerzengin.com",
    "drfindia.com",
    "drgokhanakturk.com",
    "drgpay.xyz",
    "drgpayir.xyz",
    "drgrinesdds.com",
    "drharini.com",
    "drharrymlohmeyer.info",
    "drhassanidds.com",
    "driankorp.com",
    "drid1gs.com",
    "driedflowertea.com",
    "driftcabo.com",
    "driftcasino-in.ru",
    "driftcasino.design",
    "driftrig.xyz",
    "driftwr.icu",
    "drillbitcrypto.info",
    "drillbitcrypto.net",
    "drillroad.ru",
    "drimnaghtakeaway.com",
    "drinkchaser.com",
    "drinkcola.ga",
    "drinkhealthywaters.biz",
    "drinkquot.xyz",
    "drinktruvi.com",
    "dripgit.app",
    "dripovin.ml",
    "dripovin.tk",
    "drisc.org",
    "drive-v.com",
    "drivecompanies.com",
    "drivecruzenow.com",
    "drivedisputeflood.site",
    "driveguar.email",
    "drivehq.com",
    "drivehublernissan.com",
    "driveleave.email",
    "drivenbyjam.site",
    "drivenyvss.space",
    "drivepolitely.com",
    "driverakademi.online",
    "driverbooster-soft.ru",
    "drivesotp7.com",
    "drivetagdev.com",
    "drivewayrepairburbank.info",
    "drizzers.life",
    "drizzersturkiye.life",
    "drjocept.com",
    "drjoelangel.com",
    "drjohnbodycombe.com",
    "drkenfreedmanblog.com",
    "drkenfreedmanblog.xyz",
    "drkenlaw.net",
    "drlucky.xyz",
    "drmail.net",
    "drmail.pw",
    "drmaryannscaccia.com",
    "drmohansdiabetes.org",
    "drmonetas.info",
    "drnatashafinlay.com",
    "drobbase.xyz",
    "drocun.net",
    "drocun.org",
    "drogistxxl.com",
    "droidcloud.mobi",
    "droide.ru",
    "droidmill.com",
    "droits-de-revente.site",
    "drolembu.cf",
    "drolembu.gq",
    "drolembu.ml",
    "drolembu.tk",
    "drolwestces.ga",
    "drolwestces.gq",
    "drolwestces.ml",
    "drolzucby.cf",
    "drolzucby.ga",
    "drolzucby.gq",
    "drolzucby.ml",
    "drolzucby.tk",
    "dromancehu.com",
    "drone-waiver.com",
    "dronedeals.trade",
    "dronemini.rest",
    "dronerealestatevideo.net",
    "dronespot.net",
    "dronesshop.futbol",
    "dronesshop.live",
    "dronolater.com",
    "dronplace.info",
    "dronstroi16.ru",
    "dronuregemen.com",
    "droolingfanboy.de",
    "droomhuisje.com",
    "drop.ekholm.org",
    "dropcake.de",
    "dropclubamz.com",
    "dropcramponpencil.ru",
    "dropcramponpig.ru",
    "dropd.ru",
    "dropdetecter.com",
    "drope.ml",
    "dropfinerball.ru",
    "dropfinercat.ru",
    "dropfinerdirt.ru",
    "dropfinerhat.ru",
    "dropfinermeat.ru",
    "dropfinermen.ru",
    "dropfinerpig.ru",
    "dropfinerriver.ru",
    "dropjar.com",
    "droplar.com",
    "droplister.com",
    "dropmail.cc",
    "dropmail.cf",
    "dropmail.ga",
    "dropmail.gq",
    "dropmail.me",
    "dropmail.ml",
    "dropmail.tk",
    "dropmire.org",
    "dropshipbikinis.com",
    "dropshipguitars.com",
    "dropshipjackets.com",
    "dropshiplego.com",
    "dropshipping.bio",
    "dropshipping.click",
    "dropshipping.gratis",
    "dropshipwallart.com",
    "dropstart.site",
    "droptechnologies.info",
    "dropthespot.com",
    "droptools.store",
    "dropzone.com",
    "drotposta.hu",
    "drovarouz.ru",
    "droverpzq.com",
    "drovharsubs.cf",
    "drovharsubs.gq",
    "drovharsubs.ml",
    "drovi.cf",
    "drovi.ga",
    "drovi.gq",
    "drovi.ml",
    "drovi.tk",
    "drovyanik.ru",
    "drowcash.ru",
    "drowdrow.ru",
    "drowfast.ru",
    "drowfox.ru",
    "drowfraaaank.ru",
    "drowizi.ru",
    "drowlink.ru",
    "drowlist.ru",
    "droworne.ga",
    "droworne.ml",
    "drowpin.ru",
    "drowpups.ru",
    "drowtitle.ru",
    "drpangolin.com",
    "drpphreviews.com",
    "drrodos.info",
    "drsiebelacademy.com",
    "drsiriusa.info",
    "drt8c.us",
    "drthst4wsw.tk",
    "druckpatronenshop.de",
    "drueckglueck.se",
    "druhbeltsireland.com",
    "drumimul.cf",
    "drumimul.ga",
    "drumimul.gq",
    "drumimul.ml",
    "drumimul.tk",
    "druniskaa.ga",
    "druniskaa.gq",
    "druniskaa.ml",
    "druniskaa.tk",
    "drunix.site",
    "drunkmunki.stream",
    "drunolgret.cf",
    "drunolgret.gq",
    "drupalcamponline.net",
    "drupalnc.org",
    "drushmake.org",
    "drusigpren.cf",
    "drusigpren.ga",
    "drusigpren.gq",
    "drusigpren.tk",
    "druz.cf",
    "drvictorbellera.com.ve",
    "drvideosreport.com",
    "drvmohan.net",
    "drwo.de",
    "drwunderlich.com",
    "dryfrosty.ru",
    "drygulch.xyz",
    "drylonganfruit.com",
    "dryly962kt.online",
    "drymop.us",
    "drymops.biz",
    "drymops.org",
    "drymops.us",
    "drymulov.ga",
    "drymulov.ml",
    "drynic.com",
    "dryriverboys.com",
    "drzibners.com",
    "ds-3.cf",
    "ds-3.ga",
    "ds-3.gq",
    "ds-3.ml",
    "ds-3.tk",
    "ds24.media",
    "ds8vmg-mail.xyz",
    "dsad.de",
    "dsaevents.com",
    "dsas.de",
    "dsatrack.ru",
    "dsda.de",
    "dsdadas.website",
    "dsecurelyx.com",
    "dsepimis.gq",
    "dserv.site",
    "dsewas.online",
    "dsfgbb.com",
    "dsgmsystems.com",
    "dsgs.com",
    "dsgvo.ru",
    "dshidshe.shop",
    "dshqughcoin9nazl.cf",
    "dshqughcoin9nazl.ga",
    "dshqughcoin9nazl.gq",
    "dshqughcoin9nazl.ml",
    "dshqughcoin9nazl.tk",
    "dsiay.com",
    "dskin.com",
    "dskkolovrat.ru",
    "dsleeping09.com",
    "dslextreme.com",
    "dslrclub.ru",
    "dspmok.us",
    "dspwebservices.com",
    "dsrkjj.us",
    "dssvet.ru",
    "dsvgfdsfss.tk",
    "dsweetuni.info",
    "dszg2aot8s3c.cf",
    "dszg2aot8s3c.ga",
    "dszg2aot8s3c.gq",
    "dszg2aot8s3c.ml",
    "dszg2aot8s3c.tk",
    "dt.com",
    "dt2g5427.com",
    "dt2p9.site",
    "dt3456346734.ga",
    "dt35428.com",
    "dt8037.com",
    "dtb.news",
    "dtbgllc.com",
    "dtby888.com",
    "dtcleanertab.site",
    "dtcuawg6h0fmilxbq.ml",
    "dtcuawg6h0fmilxbq.tk",
    "dtdh.xyz",
    "dte3fseuxm9bj4oz0n.cf",
    "dte3fseuxm9bj4oz0n.ga",
    "dte3fseuxm9bj4oz0n.gq",
    "dte3fseuxm9bj4oz0n.ml",
    "dte3fseuxm9bj4oz0n.tk",
    "dtfnow.fun",
    "dtfx.buzz",
    "dtfyes.site",
    "dtgo.app",
    "dthlxnt5qdshyikvly.cf",
    "dthlxnt5qdshyikvly.ga",
    "dthlxnt5qdshyikvly.gq",
    "dthlxnt5qdshyikvly.ml",
    "dthlxnt5qdshyikvly.tk",
    "dtkrcs.us",
    "dtkursk.ru",
    "dtlabs.org",
    "dtlx.us",
    "dtmricambi.com",
    "dtools.info",
    "dtrendsolution.com",
    "dtrspypkxaso.cf",
    "dtrspypkxaso.ga",
    "dtrspypkxaso.gq",
    "dtrspypkxaso.ml",
    "dtrspypkxaso.tk",
    "dtspf8pbtlm4.cf",
    "dtspf8pbtlm4.ga",
    "dtspf8pbtlm4.gq",
    "dtspf8pbtlm4.ml",
    "dtspf8pbtlm4.tk",
    "dttt9egmi7bveq58bi.cf",
    "dttt9egmi7bveq58bi.ga",
    "dttt9egmi7bveq58bi.gq",
    "dttt9egmi7bveq58bi.ml",
    "dttt9egmi7bveq58bi.tk",
    "dtv42wlb76cgz.cf",
    "dtv42wlb76cgz.ga",
    "dtv42wlb76cgz.gq",
    "dtv42wlb76cgz.ml",
    "dtv42wlb76cgz.tk",
    "dtv7600teyp.xyz",
    "dtvcloud.net",
    "dtwihk.us",
    "dualajans.xyz",
    "dualpouchunderwear.com",
    "duam.net",
    "duanedegler.net",
    "duanedegler.org",
    "duanlaimiangalaxy.com",
    "duanxian8.com",
    "dubai22.com",
    "dubai33.com",
    "dubaicurrencyexchange.com",
    "dubaiexperiment.com",
    "dubaigifts.website",
    "dubaimail.com",
    "dubainaturalsoap.com",
    "dubbunnies.com",
    "dubee.xyz",
    "dubilowski.com",
    "dubinbikepolo.com",
    "dublin.com",
    "dublin.ie",
    "dubo.email",
    "dubzone.com",
    "duck.com",
    "duck2.club",
    "duckbao.com",
    "duckcover.com",
    "duckerfiveone.online",
    "duckling.us",
    "ducklingapp.com",
    "ducklingapp.net",
    "ducklingapp.us",
    "ducklington.org",
    "duckreliablecold.website",
    "ducmaca.ga",
    "ducmaca.tk",
    "ducquan91.tk",
    "ducquangialai.com",
    "ductdota.ga",
    "ductdota.ml",
    "ductdota.tk",
    "dudddede.ga",
    "dudddede.tk",
    "dudecloo.tk",
    "dudinkonstantin.ru",
    "dudmail.com",
    "dudumail.com",
    "dufu.site",
    "duhocnhatban.org",
    "duj25.space",
    "dujgpddc.shop",
    "duk33.com",
    "dukatikas.tk",
    "dukcasinosoda.ru",
    "dukecitymedia.com",
    "dukedish.com",
    "dulapchiy.info",
    "dulcefunfreakybabemia.com",
    "dulei.ml",
    "dullynwu.info",
    "duluaqpunyateman.com",
    "dulycoded.com",
    "dumankayamodern.com",
    "dumbledore.cf",
    "dumbledore.ga",
    "dumbledore.gq",
    "dumbledore.ml",
    "dumena.com",
    "dumlipa.cf",
    "dumlipa.ga",
    "dumlupinarteknokent.online",
    "dumlupinarteknokent.xyz",
    "dumoac.net",
    "dump-email.info",
    "dumpandjunk.com",
    "dumpmail.com",
    "dumpmail.de",
    "dumprestaurantpressure.website",
    "dumpsterfire.space",
    "dumpsters-ks.com",
    "dumpyemail.com",
    "dun985.com",
    "dunakeyandklattpc.com",
    "duncanmassink.online",
    "dundeerootcanals.com",
    "dunderbookie.com",
    "dundermifflin.site",
    "dundersport.net",
    "dundersportsbook.com",
    "dundersportwetten.com",
    "dundo.tk",
    "dunesmail.com",
    "dunflimblag.mailexpire.com",
    "dungeon-mini.com",
    "dungzvip.best",
    "duniacewek.net",
    "duniawirosableng.com",
    "dunkathon.com",
    "dunlopdriver.com",
    "dunloprider.com",
    "dunmauwel.ga",
    "dunmauwel.gq",
    "dunmauwel.ml",
    "dunmauwel.tk",
    "duno.com",
    "dunprx9u4gv1ji9.xyz",
    "dunyacasino.bet",
    "dunyacasino.net",
    "duocaidou.xyz",
    "duocpham.website",
    "duocphamchinhhang.online",
    "duodana.com",
    "duodeka.academy",
    "duodeo.xyz",
    "duoduo.cafe",
    "duogasm.club",
    "duotravel.ru",
    "dupaci.com",
    "dupazsau2f.cf",
    "dupazsau2f.ga",
    "dupazsau2f.gq",
    "dupazsau2f.ml",
    "dupazsau2f.tk",
    "duplipho.ga",
    "duplipho.ml",
    "duplipho.tk",
    "dupontdevelopment.com",
    "duqhkdg.site",
    "durandinterstellar.com",
    "durexguy.com",
    "durhamheroinrehab.com",
    "durhamopiaterehab.com",
    "duroroot.com",
    "durosoft.net",
    "durpdv.site",
    "durttime.com",
    "durukurdoglu.com",
    "duskmail.com",
    "dusmvudq.tech",
    "dusnedesigns.ml",
    "dustdevil.com",
    "dusterpickup.ru",
    "dustfreetileremovalofflorida.org",
    "dustinandsharon.com",
    "dustinplains.buzz",
    "dustreaming.host",
    "dustreaming.info",
    "dustreaming.live",
    "dustreaming.pro",
    "dustreaming.website",
    "dustreaming.xyz",
    "duta303.net",
    "duta303.org",
    "dutch-central.online",
    "dutchcabinhouses.com",
    "dutchmail.com",
    "dutchmeadows.com",
    "dutchpoldering.org",
    "dutchselected.online",
    "dutco.org",
    "duthuyenhoanglong.com",
    "dutiesu0.com",
    "duukies-beachsocks.ru",
    "duvaoutlet.site",
    "duvazu.com",
    "duvmont.com",
    "duwy.site",
    "duxberg.net",
    "duximall.site",
    "duybuy.com",
    "duzceekran.xyz",
    "duzcefenlisesi.xyz",
    "duzcevitrin.xyz",
    "dv24.store",
    "dvaar.com",
    "dvd-fan.net",
    "dvd.dns-cloud.net",
    "dvd.dnsabr.com",
    "dvd315.xyz",
    "dvdcloset.net",
    "dvdxpress.biz",
    "dvej3i.us",
    "dveri-okna-vorota.ru",
    "dveri5.ru",
    "dverikupit96.ru",
    "dvery35.ru",
    "dvigatelsaita.ru",
    "dvmap.ru",
    "dvojnayradost.ru",
    "dvrdns.org",
    "dvrupdates.com",
    "dvs18.ru",
    "dvsdg34t6ewt.ga",
    "dvspitfuh434.cf",
    "dvspitfuh434.ga",
    "dvspitfuh434.gq",
    "dvspitfuh434.ml",
    "dvspitfuh434.tk",
    "dvsplus18.ru",
    "dvstolyarchuk.ru",
    "dvsusa.ru",
    "dvtr4i.us",
    "dvvxwaub.shop",
    "dvx.dnsabr.com",
    "dvyqnf.us",
    "dvzmd.zapto.org",
    "dw.now.im",
    "dw2fmp.us",
    "dw8u7.buzz",
    "dwango.cf",
    "dwango.ga",
    "dwango.gq",
    "dwango.ml",
    "dwango.tk",
    "dwboya.org",
    "dweezlemail.crabdance.com",
    "dweldimang.cf",
    "dweldimang.ga",
    "dweldimang.gq",
    "dweldimang.ml",
    "dweldimang.tk",
    "dwikuyz.com",
    "dwipalinggantengyanglainlewat.cf",
    "dwipalinggantengyanglainlewat.ga",
    "dwipalinggantengyanglainlewat.gq",
    "dwipalinggantengyanglainlewat.ml",
    "dwipalinggantengyanglainlewat.tk",
    "dwj455.com",
    "dwj773.com",
    "dwj774.com",
    "dwj775.com",
    "dwj884.com",
    "dwj886.com",
    "dwj955.com",
    "dwj990.com",
    "dwj994.com",
    "dwjbtr0403bzri7.xyz",
    "dwn2ubltpov.cf",
    "dwn2ubltpov.ga",
    "dwn2ubltpov.gq",
    "dwn2ubltpov.ml",
    "dwn2ubltpov.tk",
    "dwp.net",
    "dwqmgi.rest",
    "dwqsrp.info",
    "dwse.edu.pl",
    "dwsfhe.us",
    "dwswd8ufd2tfscu.cf",
    "dwswd8ufd2tfscu.ga",
    "dwswd8ufd2tfscu.gq",
    "dwswd8ufd2tfscu.ml",
    "dwswd8ufd2tfscu.tk",
    "dwsywm.us",
    "dwutuemzudvcb.cf",
    "dwutuemzudvcb.ga",
    "dwutuemzudvcb.gq",
    "dwutuemzudvcb.ml",
    "dwutuemzudvcb.tk",
    "dx.abuser.eu",
    "dx.allowed.org",
    "dx.awiki.org",
    "dx.ez.lv",
    "dx.sly.io",
    "dx01.space",
    "dx03.space",
    "dx05.space",
    "dx08.space",
    "dx10.space",
    "dx11.space",
    "dx17.space",
    "dx6600.com",
    "dx8804.com",
    "dx8805.com",
    "dx8808.com",
    "dx8809.com",
    "dx8tkk.com",
    "dxitv.com",
    "dxmk148pvn.cf",
    "dxmk148pvn.ga",
    "dxmk148pvn.gq",
    "dxmk148pvn.ml",
    "dxmk148pvn.tk",
    "dy138t.com",
    "dy138t.net",
    "dy187.info",
    "dy190.info",
    "dy191.info",
    "dy3033.com",
    "dy7fpcmwck.cf",
    "dy7fpcmwck.ga",
    "dy7fpcmwck.gq",
    "dy7fpcmwck.ml",
    "dy7fpcmwck.tk",
    "dyajer-alaod.com",
    "dyca4d.us",
    "dyceroprojects.com",
    "dyfealu.cf",
    "dyfealu.ml",
    "dyfealu.tk",
    "dyfxosaj.shop",
    "dyggo.com",
    "dygo.com",
    "dygr9y.host",
    "dyinglanguage.com",
    "dyinglanguage.net",
    "dyjfp0.us",
    "dykcj4.info",
    "dylanharris.buzz",
    "dylansummers.buzz",
    "dylib.dev",
    "dymuitmwq.shop",
    "dyn-o-saur.com",
    "dynafuze-malenow.com",
    "dynafuzemaletoday.com",
    "dynafuzeproductsnow.com",
    "dynalias.com",
    "dynalias.net",
    "dynalias.org",
    "dynamicdiet.com",
    "dynamicdietplan.com",
    "dynamicsmoneynews.com",
    "dynamiteendurance.coach",
    "dynamitemail.com",
    "dynamitetype.nyc",
    "dynaro.online",
    "dynathome.net",
    "dyndns.org",
    "dyndns.ws",
    "dynlitypy.monster",
    "dynqtu.site",
    "dynu.net",
    "dyre.site",
    "dyru.site",
    "dysjzp09.com",
    "dyspdh.xyz",
    "dyspharnprep.ga",
    "dyspharnprep.gq",
    "dyspharnprep.tk",
    "dyspnea659fk.online",
    "dystopianamerica.com",
    "dyuvpl.us",
    "dywg0e.us",
    "dyx9th0o1t5f.cf",
    "dyx9th0o1t5f.ga",
    "dyx9th0o1t5f.gq",
    "dyx9th0o1t5f.ml",
    "dyx9th0o1t5f.tk",
    "dyybartti.cf",
    "dyybartti.gq",
    "dyybartti.ml",
    "dyynamic.net",
    "dz-bac.com",
    "dz-geek.org",
    "dz-madwana-tech.com",
    "dz17.net",
    "dz57taerst4574.ga",
    "dzaf.net",
    "dzagi.site",
    "dzalaev-advokat.ru",
    "dzank.cn",
    "dzavnvqr.shop",
    "dzddouvgi.shop",
    "dzeucq.com",
    "dzewa6nnvt9fte.cf",
    "dzewa6nnvt9fte.ga",
    "dzewa6nnvt9fte.gq",
    "dzewa6nnvt9fte.ml",
    "dzewa6nnvt9fte.tk",
    "dzfphcn47xg.ga",
    "dzfphcn47xg.gq",
    "dzfphcn47xg.ml",
    "dzfphcn47xg.tk",
    "dzhesopr.ru",
    "dzimbabwegq.com",
    "dzinerchic.com",
    "dzinoy58w12.ga",
    "dzinoy58w12.gq",
    "dzinoy58w12.ml",
    "dzinoy58w12.tk",
    "dzip.site",
    "dzubn.ru",
    "dzw6np36h84j05p.xyz",
    "dzxsx.com",
    "dzxtvl.com",
    "e-apollo.lv",
    "e-apteka24.ru",
    "e-box.dk",
    "e-cig36.ru",
    "e-clicks.online",
    "e-commex.ru",
    "e-comsupport.com",
    "e-globe.xyz",
    "e-hamilegiyim.com",
    "e-hkma.com",
    "e-hospitals.com",
    "e-kpd.ru",
    "e-mail-amazon.cf",
    "e-mail.cafe",
    "e-mail.com",
    "e-mail.com.tr",
    "e-mail.comx.cf",
    "e-mail.dk",
    "e-mail.igg.biz",
    "e-mail.jp",
    "e-mail.net",
    "e-mail.org",
    "e-mail.ru",
    "e-mail.ua",
    "e-mailanywhere.com",
    "e-mailbox.comx.cf",
    "e-mailbox.ga",
    "e-mails.ru",
    "e-marketstore.ru",
    "e-medicum.com",
    "e-mule.cf",
    "e-mule.ga",
    "e-mule.gq",
    "e-mule.ml",
    "e-mule.tk",
    "e-nrg.us",
    "e-nsk.ru",
    "e-pay.icu",
    "e-postboks.dk",
    "e-postkasten.com",
    "e-postkasten.de",
    "e-postkasten.eu",
    "e-postkasten.info",
    "e-postman.host",
    "e-radio.africa",
    "e-radio.app",
    "e-s-m.ru",
    "e-shoponline.info",
    "e-snab.ru",
    "e-taksa.com",
    "e-tapaal.com",
    "e-tikhvin.ru",
    "e-tomarigi.com",
    "e-torrent.ru",
    "e-trader.live",
    "e-webtec.com",
    "e-zlunchbox.com",
    "e.4pet.ro",
    "e.amav.ro",
    "e.arno.fi",
    "e.benlotus.com",
    "e.bgsaddrmwn.me",
    "e.blogspam.ro",
    "e.discard-email.cf",
    "e.l5.ca",
    "e.milavitsaromania.ro",
    "e.nodie.cc",
    "e.shapoo.ch",
    "e.wupics.com",
    "e04ajj.site",
    "e08yw.site",
    "e0iulu.us",
    "e0jak.us",
    "e0yk-mail.ml",
    "e10digital.com",
    "e164-deos.net",
    "e164-deos.org",
    "e168.online",
    "e16cs.space",
    "e1775.com",
    "e17gx.com",
    "e1dn7v.us",
    "e1u.xyz",
    "e1y4anp6d5kikv.cf",
    "e1y4anp6d5kikv.ga",
    "e1y4anp6d5kikv.gq",
    "e1y4anp6d5kikv.ml",
    "e1y4anp6d5kikv.tk",
    "e27dxbe4.xyz",
    "e27wo.site",
    "e283c52d.club",
    "e2e4d7d5.ru",
    "e2ento.us",
    "e2estudios.com",
    "e2m.store",
    "e2n11lm1.buzz",
    "e2qoitlrzw6yqg.cf",
    "e2qoitlrzw6yqg.ga",
    "e2qoitlrzw6yqg.gq",
    "e2qoitlrzw6yqg.ml",
    "e2qoitlrzw6yqg.tk",
    "e3011.club",
    "e30d.xyz",
    "e32b66b7.xyz",
    "e33ta.com",
    "e3b.org",
    "e3z.de",
    "e423z5ffcc5o94t.xyz",
    "e425lr.live",
    "e44db.club",
    "e46me.space",
    "e4febx.us",
    "e4i.ru",
    "e4ivstampk.com",
    "e4t5exw6aauecg.ga",
    "e4t5exw6aauecg.ml",
    "e4t5exw6aauecg.tk",
    "e4ward.com",
    "e4wfnv7ay0hawl3rz.cf",
    "e4wfnv7ay0hawl3rz.ga",
    "e4wfnv7ay0hawl3rz.gq",
    "e4wfnv7ay0hawl3rz.ml",
    "e4wfnv7ay0hawl3rz.tk",
    "e501eyc1m4tktem067.cf",
    "e501eyc1m4tktem067.ga",
    "e501eyc1m4tktem067.ml",
    "e501eyc1m4tktem067.tk",
    "e56r5b6r56r5b.cf",
    "e56r5b6r56r5b.ga",
    "e56r5b6r56r5b.gq",
    "e56r5b6r56r5b.ml",
    "e58xn.site",
    "e5by64r56y45.cf",
    "e5by64r56y45.ga",
    "e5by64r56y45.gq",
    "e5by64r56y45.ml",
    "e5by64r56y45.tk",
    "e5ki3ssbvt.cf",
    "e5ki3ssbvt.ga",
    "e5ki3ssbvt.gq",
    "e5ki3ssbvt.ml",
    "e5ki3ssbvt.tk",
    "e5r6ynr5.cf",
    "e5r6ynr5.ga",
    "e5r6ynr5.gq",
    "e5r6ynr5.ml",
    "e5r6ynr5.tk",
    "e5txqn.us",
    "e5z1lhl9k7dd2bo.xyz",
    "e66.buzz",
    "e67dz.com",
    "e71e.ru",
    "e72sh.com",
    "e73ca.xyz",
    "e7666.com",
    "e7ghn0.com",
    "e7n06wz.com",
    "e7xcfk7etkjxjnb.xyz",
    "e82323.com",
    "e84ywua9hxr5q.cf",
    "e84ywua9hxr5q.ga",
    "e84ywua9hxr5q.gq",
    "e84ywua9hxr5q.ml",
    "e84ywua9hxr5q.tk",
    "e85dh.site",
    "e88zl.space",
    "e8999.com",
    "e89fi5kt8tuev6nl.cf",
    "e89fi5kt8tuev6nl.ga",
    "e89fi5kt8tuev6nl.gq",
    "e89fi5kt8tuev6nl.ml",
    "e89fi5kt8tuev6nl.tk",
    "e8g93s9zfo.com",
    "e8ref.com",
    "e8tzp9.us",
    "e9557.com",
    "e9561.com",
    "e9563.com",
    "e9568.com",
    "e9581.com",
    "e9586.com",
    "e9592.com",
    "e96xlm.stream",
    "e9886.com",
    "e9f4e664.club",
    "e9jfq.info",
    "e9khcd.host",
    "ea.luk2.com",
    "ea7qpw.info",
    "ea9.org",
    "eaaeus.com",
    "eaclub.bet",
    "eads0w.us",
    "eadskj.rest",
    "eaek.cc",
    "eafabet.com",
    "eaganapartments.com",
    "eagermiserlyflour.site",
    "eaglegroup.us",
    "eagleholsters.com",
    "eaglelondon.net",
    "eaglemail.top",
    "eaglerder.com",
    "eaglespo.xyz",
    "eagroup.me",
    "eahmoney.icu",
    "eahzla.site",
    "eail.com",
    "eajfciwvbohrdbhyi.cf",
    "eajfciwvbohrdbhyi.ga",
    "eajfciwvbohrdbhyi.gq",
    "eajfciwvbohrdbhyi.ml",
    "eajfciwvbohrdbhyi.tk",
    "eakga.com",
    "eamon.online",
    "ean2asin.com",
    "eanb.email",
    "eandeanr.shop",
    "eanok.com",
    "eanreand.shop",
    "eapncs.com",
    "eaqb4.us",
    "eaqso209ak.cf",
    "eaqso209ak.ga",
    "eaqso209ak.gq",
    "eaqso209ak.ml",
    "ear.ong",
    "earlybirdandtheworm.com",
    "earlychurchlessons.com",
    "earlyvotingstats.org",
    "earn-now.ru",
    "earndaily.com",
    "earnfrom.website",
    "earning2x.online",
    "earningsonline2you.ru",
    "earningsph.com",
    "earnlink.ooo",
    "earnosethroatcareers.com",
    "earnripplecoin.online",
    "earntrontokens.xyz",
    "earth.doesntexist.org",
    "earthalliance.com",
    "earthbonus.host",
    "earthcam.net",
    "earthdome.com",
    "earthdrygoods.com",
    "earthforhealth.club",
    "earthling.net",
    "earthlink.net",
    "earthonline.net",
    "earthorbit.net",
    "earthorbit.org",
    "earthtod.site",
    "earthtrekkers.net",
    "earthtrekkers.org",
    "earthwindandsnow.com",
    "earthworksyar.cf",
    "earthworksyar.ml",
    "earzx.us",
    "easemail.com",
    "easinoschrom.tk",
    "easporrts.com",
    "east-west-conference.ru",
    "eastagusall.email",
    "eastboundtravels.com",
    "eastcoast.co.za",
    "easternhempco.com",
    "easteuropepa.com",
    "eastlansingdentists.com",
    "eastlink.ca",
    "eastmail.com",
    "eastmail.info",
    "eastmanww.com",
    "eastpolknews.net",
    "eastrivergondola.com",
    "eastrockchiro.net",
    "eastrolog.com",
    "eastsideag.com",
    "eastsidecounselingcenters.com",
    "eastwan.net",
    "eastwestcargo.ru",
    "easy-apps.info",
    "easy-deploy.com",
    "easy-magazine-offer.host",
    "easy-mail.top",
    "easy-trash-mail.com",
    "easy-vdi.com",
    "easy-winner.net",
    "easy.com",
    "easy.to",
    "easyacord.com",
    "easyasphi.com",
    "easybedb.site",
    "easybirthingsolutions.com",
    "easybranches.ru",
    "easybuyol.store",
    "easydinnerrecipes.net",
    "easydrop.shop",
    "easyemail.info",
    "easyico.org",
    "easymail.ga",
    "easymail.top",
    "easymarry.com",
    "easymedgo.com",
    "easymylife.org",
    "easynetwork.info",
    "easyonlinecollege.com",
    "easyopenpay.com",
    "easyopros6-ml.website",
    "easypeasy.com",
    "easypost.com",
    "easyrecipesguide.life",
    "easyricecooker.com",
    "easyriders.co.uk",
    "easyshortcut.com",
    "easystabilitybetsnupp20.xyz",
    "easysystem.cash",
    "easytotrip.ru",
    "easytrashmail.com",
    "easyustaad.com",
    "easyweathercheck.com",
    "eat-drink.live",
    "eatbeat.com",
    "eatdrink518.com",
    "eaterytools.com",
    "eatgood.site",
    "eatlogs.com",
    "eatlove.com",
    "eatme69.top",
    "eatmea2z.club",
    "eatmea2z.top",
    "eatmydirt.com",
    "eatrnet.com",
    "eatsleepwoof.com",
    "eauctiontrade.com",
    "eawm.de",
    "eay.jp",
    "eazedeliverynow.com",
    "eb1ey.site",
    "eb2cda7c.xyz",
    "eb46r5r5e.cf",
    "eb46r5r5e.ga",
    "eb46r5r5e.gq",
    "eb46r5r5e.ml",
    "eb46r5r5e.tk",
    "eb4te5.cf",
    "eb4te5.ga",
    "eb4te5.gq",
    "eb4te5.ml",
    "eb4te5.tk",
    "eb56b45.cf",
    "eb56b45.ga",
    "eb56b45.gq",
    "eb56b45.ml",
    "eb56b45.tk",
    "eb609s25w.com",
    "eb655b5.cf",
    "eb655b5.ga",
    "eb655b5.gq",
    "eb655b5.ml",
    "eb655b5.tk",
    "eb655et4.cf",
    "eb655et4.ga",
    "eb655et4.gq",
    "eb655et4.ml",
    "eb7gxqtsoyj.cf",
    "eb7gxqtsoyj.ga",
    "eb7gxqtsoyj.gq",
    "eb7gxqtsoyj.ml",
    "eb7gxqtsoyj.tk",
    "eb9b1d.club",
    "ebacus.gq",
    "ebacus.ml",
    "ebacus.tk",
    "ebahczno.shop",
    "ebamen.gq",
    "ebamen.tk",
    "ebanglanewspaper.com",
    "ebano.campano.cl",
    "ebbie.ru",
    "ebbob.com",
    "ebectren.cf",
    "ebenebiz.online",
    "ebeschlussbuch.de",
    "ebhiq.us",
    "ebijouterie.com",
    "ebilsad.net",
    "ebimpactcompany.com",
    "ebizblog.com",
    "ebjza.space",
    "ebloodbanking.org",
    "ebm7.com",
    "ebmzh1.site",
    "ebnaoqle657.cf",
    "ebnaoqle657.ga",
    "ebnaoqle657.gq",
    "ebnaoqle657.ml",
    "ebnaoqle657.tk",
    "ebnsya.com",
    "ebogk4.host",
    "eboise.com",
    "ebolawho.com",
    "ebonized995jc.online",
    "ebony.monster",
    "ebookdesign.pro",
    "ebookway.us",
    "ebookwiki.org",
    "ebprofits.net",
    "ebrightskinbatam.com",
    "ebrolift.com",
    "ebruaryand.net",
    "ebruaryand.org",
    "ebruaryh.com",
    "ebruaryh.org",
    "ebs.com.ar",
    "ebtekar-semnan.com",
    "ebtukukxnn.cf",
    "ebtukukxnn.ga",
    "ebtukukxnn.gq",
    "ebtukukxnn.ml",
    "ebtukukxnn.tk",
    "ebv9rtbhseeto0.cf",
    "ebv9rtbhseeto0.ga",
    "ebv9rtbhseeto0.gq",
    "ebv9rtbhseeto0.ml",
    "ebv9rtbhseeto0.tk",
    "ebvaus.us",
    "ebvvlrf.ru",
    "ec-app-ios.com",
    "ec-app-windows.com",
    "ec.rr.com",
    "ec8sli.us",
    "ec97.cf",
    "ec97.ga",
    "ec97.gq",
    "ec97.ml",
    "ec97.tk",
    "ecaihang.xyz",
    "ecallen.com",
    "ecallheandi.com",
    "ecaoffl.org",
    "ecardmail.com",
    "ecbsolutions.net",
    "eccayk.icu",
    "eccgulf.net",
    "ecclighting.com",
    "ecco-discount-shoes.ru",
    "ecco-shoes.store",
    "ecco-shoes24.ru",
    "ecea.de",
    "ecf730de.club",
    "echathouse.com",
    "echendia.ga",
    "echendia.gq",
    "echendia.ml",
    "echina.com",
    "echocbd.com",
    "echodarlings.com",
    "echoroukonline.org",
    "echosgraphics.online",
    "echosofspirit.com",
    "echt-mail.de",
    "echta.com",
    "echtacard.com",
    "echtheidskenmerken.com",
    "echtzeit.website",
    "ecidirecto.cat",
    "ecig36.ru",
    "ecigarette.ru",
    "ecigwizard.net",
    "ecigwizardrmu.net",
    "eciresidential.com",
    "eckendonkverwarming.online",
    "eclaecll.shop",
    "eclipsey.online",
    "eclipso.at",
    "eclipso.ch",
    "eclipso.de",
    "eclipso.eu",
    "ecllecla.shop",
    "ecmij0.us",
    "ecn37.ru",
    "ecni1.us",
    "eco-brand.com",
    "eco-crimea.ru",
    "eco-xmas.com",
    "eco.ilmale.it",
    "ecoamulet.ru",
    "ecoarabia.space",
    "ecoblogger.com",
    "ecobution.com",
    "ecocap.cf",
    "ecocap.ga",
    "ecocap.gq",
    "ecocap.ml",
    "ecocap.tk",
    "ecochecking.com",
    "ecodecouverte.com",
    "ecodiemlatam.com",
    "ecodom75.ru",
    "ecoe.de",
    "ecoforfun.website",
    "ecoforsea.website",
    "ecoforsky.website",
    "ecoglace.com",
    "ecogribnica.ru",
    "ecokrasota-kz.ru",
    "ecole-post-bac.org",
    "ecolith.xyz",
    "ecolivingshake.xyz",
    "ecollum.org",
    "ecolo-online.fr",
    "ecologyguys.xyz",
    "ecolvita.com",
    "ecomclubadvisers.com",
    "ecomclubcoach.com",
    "ecommbbq.dev",
    "ecommerceaustria.com",
    "ecommercebaltics.com",
    "ecommercebbq.dev",
    "ecommerceslovakia.com",
    "ecompare.com",
    "ecomrevealed.com",
    "ecomsecure.org",
    "econaturella.store",
    "econconferences.net",
    "econconferences.org",
    "econducts.icu",
    "economic-articles.ru",
    "economicrethink.com",
    "economideslaw.com",
    "ecooktops.com",
    "ecoonly.com",
    "ecoorno.com",
    "ecorepast.ru",
    "ecoresort.club",
    "ecosdelpamplonita.com",
    "ecoshed.org",
    "ecosmartfire.us",
    "ecotrafik-spb.ru",
    "ecotrekking.africa",
    "ecovosearch.com",
    "ecowhey.com",
    "ecqmuskw.shop",
    "ecsite.info",
    "ecsporra.tk",
    "ecstasyworld.ru",
    "ectix.fun",
    "ectncenter.com",
    "ectseep.site",
    "ecuadoranfood.com",
    "ecumenopolis.online",
    "ecumte.cf",
    "ecumte.ga",
    "ecumte.tk",
    "ecunflec.cf",
    "ecunflec.ml",
    "ecunflec.tk",
    "ecvashop.ru",
    "eczadanstoklusatis.site",
    "eczanedenurunler3.site",
    "eczavm.net",
    "eczema.red",
    "eczemared.com",
    "ed101.org",
    "ed1crhaka8u4.cf",
    "ed1crhaka8u4.ga",
    "ed1crhaka8u4.gq",
    "ed1crhaka8u4.ml",
    "ed1crhaka8u4.tk",
    "ed1de2f.xyz",
    "ed235.com",
    "edagolic.ru",
    "edaned.ga",
    "edaned.tk",
    "edapovara.ru",
    "edarwn.site",
    "edavpohod.ru",
    "edaysdeal.com",
    "edcs.de",
    "edcstore.website",
    "eddieawards.org",
    "eddyhotels.info",
    "ede47t2wgee4og4.xyz",
    "edealclip.com",
    "edealcode.com",
    "edealdash.com",
    "edealgolf.com",
    "edealhome.com",
    "edealmove.com",
    "edealpets.com",
    "edeals420.com",
    "edealspet.com",
    "edealtogo.com",
    "edelion.site",
    "edelweis.website",
    "edenbrides.com",
    "edenizli.net",
    "edenprairieapartments.com",
    "edenris.info",
    "edfinanciall.com",
    "edgac.com",
    "edgdcfwp.shop",
    "edge-of-oblivion.com",
    "edge.net",
    "edgehillcenter.org",
    "edgenet.dev",
    "edgenet.monster",
    "edgenet.today",
    "edgeseeker.com",
    "edgeserviceworkers.net",
    "edgex.ru",
    "edibles-cannabis.com",
    "edifice.ga",
    "edigitalwaves.com",
    "edinacabs.info",
    "edinardiamond.com",
    "edinburgh-airporthotels.com",
    "edirnearackiralama.com",
    "edirneligheyeti.xyz",
    "edirnetasarim.xyz",
    "edirneulkuocaklari.com",
    "edisar.cf",
    "edisar.gq",
    "edisar.ml",
    "edisar.tk",
    "editengine.org",
    "edithis.info",
    "editingmagzines.live",
    "editorialize498ay.online",
    "editory.design",
    "edkfnget.shop",
    "edkvq9wrizni8.cf",
    "edkvq9wrizni8.ga",
    "edkvq9wrizni8.gq",
    "edkvq9wrizni8.ml",
    "edkvq9wrizni8.tk",
    "edlweise.com",
    "edmail.com",
    "edmontonportablesigns.com",
    "ednatx.com",
    "edoamb.site",
    "edopegitim.com",
    "edotzxdsfnjvluhtg.cf",
    "edotzxdsfnjvluhtg.ga",
    "edotzxdsfnjvluhtg.gq",
    "edotzxdsfnjvluhtg.ml",
    "edotzxdsfnjvluhtg.tk",
    "edouardkouzougiandmd.com",
    "edproblem.com",
    "edqpra.us",
    "edqy3g.us",
    "edras-hosting.com",
    "edrashosting.net",
    "edrashosting.ovh",
    "edremitmehmetakif.xyz",
    "edrishn.xyz",
    "edsocia.shop",
    "edsxwu.info",
    "edsym.com",
    "edtnmail.com",
    "edu-archive.com",
    "edu-track.net",
    "edu.aiot.ze.cx",
    "edu.auction",
    "edu.creo.site",
    "edu.dmtc.dev",
    "edu.dmtc.press",
    "edu.hstu.eu.org",
    "eduahora.com",
    "educacao.te.pt",
    "educastmail.com",
    "educate316.com",
    "educationalretirementplanning.com",
    "educationvn.cf",
    "educationvn.ga",
    "educationvn.gq",
    "educationvn.ml",
    "educationvn.tk",
    "educatolica.org",
    "eduenterprise.net",
    "eduinfoline.com",
    "edukat.com",
    "edukid.online",
    "edusamail.net",
    "eduverum.com",
    "eduverum.org",
    "edv.fund",
    "edv.to",
    "edwardsullivan.buzz",
    "edwardsvillevisioncenter.info",
    "edystne.com",
    "edzjrd.rest",
    "ee062.com",
    "ee1.pl",
    "ee18269.com",
    "ee2.pl",
    "ee8ty.com",
    "eea888.com",
    "eeanoodlem.site",
    "eeaum.us",
    "eedgechatk.site",
    "eedgewaree.site",
    "eedgez.site",
    "eee062.com",
    "eeemail.win",
    "eeeverything.com",
    "eeifi.site",
    "eeinduo.site",
    "eeligib.shop",
    "eellee.org",
    "eelmail.com",
    "eemeklilik.com",
    "eeolk.us",
    "eetcafedebrakkegrond.com",
    "eexie.space",
    "eexndi.us",
    "eezojq3zq264gk.cf",
    "eezojq3zq264gk.ga",
    "eezojq3zq264gk.gq",
    "eezojq3zq264gk.ml",
    "eezojq3zq264gk.tk",
    "ef0o2i.us",
    "ef2files.com",
    "ef2qohn1l4ctqvh.cf",
    "ef2qohn1l4ctqvh.ga",
    "ef2qohn1l4ctqvh.gq",
    "ef2qohn1l4ctqvh.ml",
    "ef2qohn1l4ctqvh.tk",
    "ef4l.us",
    "ef87cg.accountant",
    "ef88.xyz",
    "ef8f.com",
    "ef8udz.info",
    "ef9ppjrzqcza.cf",
    "ef9ppjrzqcza.ga",
    "ef9ppjrzqcza.gq",
    "ef9ppjrzqcza.ml",
    "ef9ppjrzqcza.tk",
    "efago.space",
    "efcdn3.info",
    "efd.buzz",
    "efd0x.us",
    "efdal.info",
    "efelermt2.com",
    "efesbahi60.com",
    "efesbahi61.com",
    "efesnahis47.com",
    "effacers.best",
    "effect-help.ru",
    "effective-neurosystem.ru",
    "effective-thai.com",
    "effectivebusinessgrowth.xyz",
    "effectivelyweb.com",
    "effectual.net",
    "effiemena.com",
    "effrvjpn.shop",
    "efhmerides.com",
    "efiterra.ru",
    "efitgro.shop",
    "eflstudyabroad.com",
    "efmitoc.cf",
    "efmitoc.ga",
    "efmitoc.ml",
    "efo.kr",
    "efo8r.us",
    "efoiefol.shop",
    "efolefoi.shop",
    "eforefor.shop",
    "eformula.ru",
    "efratsadeli.xyz",
    "eft.one",
    "eftura.cf",
    "eftura.gq",
    "eftura.ml",
    "efu114.com",
    "efxi.us",
    "efxs.ca",
    "eg0tm3.us",
    "eg723.com",
    "eg85qf.com",
    "egafar.cf",
    "egafar.ga",
    "egafar.gq",
    "egafar.ml",
    "egafar.tk",
    "egava.ru",
    "egawc6234.tech",
    "egberghs.online",
    "egbest.net",
    "egdrop.online",
    "egear.store",
    "egebahis.com",
    "egeg-990.com",
    "egenes.ga",
    "egenes.gq",
    "egenes.ml",
    "egg-fri.org",
    "eggcelentecafe.com",
    "eggfri.org",
    "eggharborfesthaus.com",
    "eggnova.com",
    "eggplantplay.net",
    "eggrade.com",
    "eggscryptoinvest.xyz",
    "egibet101.com",
    "egitimlekazan.net",
    "eglenceliokul.net",
    "eglenkazan.site",
    "eglft.in",
    "ego-in-bmw.ru",
    "egobomb.com",
    "egocp17.net",
    "egocp21.net",
    "egocp27.net",
    "egocp28.net",
    "egocp35.net",
    "egocp41.net",
    "egocp54.net",
    "egocp58.net",
    "egocp68.net",
    "egocp71.net",
    "egocp74.net",
    "egocp75.net",
    "egocp80.net",
    "egocp83.net",
    "egocp84.net",
    "egocp90.net",
    "egocp96.net",
    "egocp97.net",
    "egolottery.com",
    "egoqp.com",
    "egorkanorka.space",
    "egrn-ofical.ru",
    "egs8zzgzsjo05090.buzz",
    "egvxoqfhz.shop",
    "egwuvbsdx.online",
    "egypthacker.com",
    "eh2jvt.site",
    "eh4rlw.info",
    "ehawehav.shop",
    "ehdigsi.cf",
    "ehdigsi.ml",
    "ehealthcareconsultants.com",
    "eherbaly.com",
    "ehgrg.live",
    "ehhxbsbbdhxcsvzbdv.ml",
    "ehhxbsbbdhxcsvzbdv.tk",
    "ehleber.cf",
    "ehleber.ga",
    "ehleber.ml",
    "ehleber.tk",
    "ehlp.us",
    "ehmail.com",
    "ehmwi6oixa6mar7c.cf",
    "ehmwi6oixa6mar7c.ga",
    "ehmwi6oixa6mar7c.gq",
    "ehmwi6oixa6mar7c.ml",
    "ehmwi6oixa6mar7c.tk",
    "eho.kr",
    "ehoie03og3acq3us6.cf",
    "ehoie03og3acq3us6.ga",
    "ehoie03og3acq3us6.gq",
    "ehoie03og3acq3us6.ml",
    "ehoie03og3acq3us6.tk",
    "ehomeconnect.net",
    "ehousesdev.com",
    "ehsanalrifai.com",
    "ehvgfwayspsfwukntpi.cf",
    "ehvgfwayspsfwukntpi.ga",
    "ehvgfwayspsfwukntpi.gq",
    "ehvgfwayspsfwukntpi.ml",
    "ehvgfwayspsfwukntpi.tk",
    "ehwj.com",
    "ehyafest.com",
    "ehyvaz.faith",
    "eiappleshoes.com",
    "eids.de",
    "eiendomme.info",
    "eighty-seven-chinese-takeaway.com",
    "eightysevenchinese.com",
    "eigoemail.com",
    "eik3jeha7dt1as.cf",
    "eik3jeha7dt1as.ga",
    "eik3jeha7dt1as.gq",
    "eik3jeha7dt1as.ml",
    "eik3jeha7dt1as.tk",
    "eik8a.avr.ze.cx",
    "eikadb.rest",
    "eikfr.club",
    "eilersmail.com",
    "eimadness.com",
    "einfach.to",
    "einmalmail.de",
    "einmeinr.shop",
    "einrot.com",
    "einrot.de",
    "eins-zwei.cf",
    "eins-zwei.ga",
    "eins-zwei.gq",
    "eins-zwei.ml",
    "eins-zwei.tk",
    "eintagsmail.de",
    "eircom.net",
    "eiren.dev",
    "eiriyqaab.shop",
    "eisenbergpublishing.com",
    "eisenfall.de",
    "eisenhemds.info",
    "eislumpwejr57.ru",
    "eitan-ofer.biz",
    "eitan-ofer.com",
    "eitan-ofer.info",
    "eitanofer.biz",
    "eitanofer.info",
    "eitanofer.net",
    "eitanofer.org",
    "eithern.website",
    "eitude.xyz",
    "eiu.edu",
    "ejerciciossalud.com",
    "ejh3ztqvlw.cf",
    "ejh3ztqvlw.ga",
    "ejh3ztqvlw.gq",
    "ejh3ztqvlw.ml",
    "ejh3ztqvlw.tk",
    "ejjsuspw.shop",
    "ejnzj.com",
    "ejucbb.us",
    "ejuhv6.us",
    "ejustinsimone.com",
    "ek8wqatxer5.cf",
    "ek8wqatxer5.ga",
    "ek8wqatxer5.gq",
    "ek8wqatxer5.ml",
    "ek8wqatxer5.tk",
    "ekaap.site",
    "ekalbet.xyz",
    "ekapoker.com",
    "ekapoker.net",
    "ekapoker.xyz",
    "ekata.tech",
    "ekbep.live",
    "ekcuzkux.shop",
    "ekdcp1.site",
    "ekforha.ga",
    "ekforha.gq",
    "ekholotdeeper.ru",
    "ekibim.design",
    "ekidz.com.au",
    "ekii.cf",
    "ekiiajah.ga",
    "ekiibete.ml",
    "ekiibeteaja.cf",
    "ekiibetekorea.tk",
    "ekiikorea99.cf",
    "ekiikorea99.ga",
    "ekiilinkinpark.ga",
    "ekmektarifi.com",
    "ekmekvepasta.online",
    "ekmekvepasta.xyz",
    "ekmqkw.com",
    "eknowapp.com",
    "eknqgq.info",
    "ekocosmetika.ru",
    "ekodi.ga",
    "ekohash.com",
    "ekomaski.ru",
    "ekomoyka.com",
    "ekor.info",
    "ekotuman54.ru",
    "ekphm.site",
    "ekpzsec3.xyz",
    "ekselyapi.com",
    "eksenler.site",
    "ekspresambalaj.xyz",
    "ekspresforeks.com",
    "ekupa.xyz",
    "ekyku.site",
    "ekzi.info",
    "el-mundo.website",
    "el-toro-takeaway.com",
    "el-tulipan.com",
    "el.cash",
    "el4nyw.us",
    "el6jkb.us",
    "elaffshop.store",
    "elaineshoes.com",
    "elalinosantafe.com",
    "elangqq.fun",
    "elangquiqiu.net",
    "elaparatico.net",
    "elapou.info",
    "elappi.site",
    "elastichealth.com",
    "elatscal.ga",
    "elatscal.gq",
    "elatscal.ml",
    "elatscal.tk",
    "elaven.cf",
    "elaven.ga",
    "elaven.gq",
    "elaven.ml",
    "elazigcozumguvenlik.com",
    "elaziggaziosmanpasa.xyz",
    "elazigmezaryapi.online",
    "elazigmezaryapi.xyz",
    "elazigturkocaklari.xyz",
    "elazigugurluemlak.xyz",
    "elbenyamins.com",
    "elbomboncito.net",
    "elbow4.tk",
    "elcajonrentals.com",
    "elcalless.cf",
    "elcalless.ga",
    "elcalless.gq",
    "elcalless.ml",
    "elcejas.org",
    "elcentrodentists.com",
    "elcid-dz.com",
    "elcyberbrujo.com",
    "eldertraining.com",
    "eldiam.ru",
    "eleanorallen.me",
    "elearningjournal.org",
    "elearningtopia.net",
    "electcr.icu",
    "electcra.xyz",
    "electdesean.com",
    "electionwatch.info",
    "electpreoccupationhandy.website",
    "electricalchemy.org",
    "electricalpowertransmissiononlineclasses.com",
    "electricbikemotor.org",
    "electriccarvehicle.com",
    "electrician-colchester.com",
    "electricistas.cat",
    "electriclongboard.online",
    "electro-roliki.ru",
    "electro.mn",
    "electrodrone.ru",
    "electrofic.xyz",
    "electroheatchina.com",
    "electronexpress.ru",
    "electrongem.buzz",
    "electronicenergycoins.com",
    "electronicgate-annabi.net",
    "electronicmail.us",
    "electronicpostcards.net",
    "electronicsbrushes.com",
    "electronicsbrushes.us",
    "electronicsearch.solutions",
    "electronicshotv.xyz",
    "electronicshotx.info",
    "electronicsvipa.xyz",
    "electronicsvipc.info",
    "electronicsvipf.xyz",
    "electronicvonfrey.com",
    "electronizer.com",
    "electroprem.se",
    "electrosamokat2.ru",
    "electrostal-dveri.ru",
    "electrostaticbrush.net",
    "electrostaticbrush.us",
    "electrostaticbrushes.us",
    "electrumlove.com",
    "electrumly.pro",
    "electrumsecuredownload.com",
    "electrumtravel.com",
    "eleganaff.com",
    "elegantdir.com",
    "elegantmessblog.com",
    "elektrik03.ru",
    "elektro-roliki.ru",
    "elektroniksigara.xyz",
    "elektroninenurheilu.net",
    "elektroninenurheilu.org",
    "elelhal.xyz",
    "elemedialabs.com",
    "elementalstorm.com",
    "elementosdejuicio.com",
    "elementsofjoy.org",
    "elenagolunova.site",
    "elenamiller-shop.ru",
    "elenasport.com",
    "eleniumania.site",
    "elenon.com",
    "elepam.ga",
    "elepam.gq",
    "elepam.ml",
    "elepam.tk",
    "elephantlae.email",
    "elephantpizza-cabra.com",
    "elephantvalleylodge.org",
    "elestella.blog",
    "eletp6.info",
    "eletrium.com",
    "eletskyart.ru",
    "elettrofaidate.com",
    "elevareurhealth.com",
    "elevationplatform.net",
    "elevationrecoverycenter.info",
    "elevatn.net",
    "eleven-wet-rubbed-rise.xyz",
    "elevens4d.net",
    "elevmedia.net",
    "elexbetgunceladres.com",
    "elexbetguncelgiris.com",
    "elexusbet159.com",
    "elexusbet165.com",
    "elfagrsports.net",
    "elfagrsports.org",
    "elfbt.com",
    "elhddbha.com",
    "eliconomy.site",
    "elifestyle.tk",
    "elijahgray.pro",
    "elilind.info",
    "elimam.org",
    "eliminategout.com",
    "eliminatetrend.info",
    "elinakamiren.ru",
    "elinore1818.site",
    "elinstallatoer.dk",
    "elipsys.ru",
    "elisanet.fi",
    "eliselifewire.com",
    "elisioyuncak.net",
    "elisioyuncak.xyz",
    "elisium.org",
    "elispector.com",
    "elisspizzeria.com",
    "elite-trend.ru",
    "eliteadultdating.com",
    "elitebabeslondon.com",
    "elitebusinessphone.com",
    "elitecolor.us",
    "eliteeventvenue.net",
    "elitegunshop.com",
    "elitehostmanagement.com",
    "elitemail.org",
    "eliteseniors.online",
    "eliteseo.net",
    "elitesinglejdhj.xyz",
    "elitestoneimporters.net",
    "elitethetrend.com",
    "elitevipatlantamodels.com",
    "elitewot.ru",
    "elitewou.press",
    "elitistarmory.com",
    "elixircycles.com",
    "elizabeadan.com",
    "elizabelder.com",
    "elizabethjacques.com",
    "elizabethlacio.com",
    "elizabethporterdesigns.com",
    "elizstudio.ru",
    "eljkblwjys.icu",
    "eljzcl.us",
    "elkathy.cf",
    "elkathy.ga",
    "elkathy.ml",
    "elkgroveses.com",
    "elkhornautocare.com",
    "elki-iskusstvennie.ru",
    "elki-mkzn.ru",
    "elki-v-chelyabinske.ru",
    "elkwielp.site",
    "ellendino.com",
    "ellesecret.com",
    "ellesoufi.com",
    "ellight.ru",
    "ellingtonmarascio.com",
    "ellingtonvets.com",
    "ellinismosonline.com",
    "elliotbuckley.buzz",
    "elliotcavanaugh.com",
    "elliotmccarthy.buzz",
    "elliotrhodes.buzz",
    "ellmh.us",
    "elloimmigration.com",
    "ellstromstrafikskola.se",
    "ellur.ru",
    "elmcoin.com",
    "elmenormi.tk",
    "elmexicanodebcn.com",
    "elmontaitocaceres.com",
    "elmundillodental.com",
    "elograder.com",
    "elon-spb.ru",
    "eloom.live",
    "elorios.info",
    "eloud.info",
    "elp.rr.com",
    "elp0xn.us",
    "elpacar.cf",
    "elpacar.ga",
    "elpasoaddictiontreatment.com",
    "elpasococainerehab.com",
    "elpatio.su",
    "elqaelsc.shop",
    "elreykebabbarcelona.com",
    "elrincondelbarbudo.ovh",
    "els396lgxa6krq1ijkl.cf",
    "els396lgxa6krq1ijkl.ga",
    "els396lgxa6krq1ijkl.gq",
    "els396lgxa6krq1ijkl.ml",
    "els396lgxa6krq1ijkl.tk",
    "elsa.su",
    "elsajean.mobi",
    "elsayoung.world",
    "elscootersverige.se",
    "else.watch",
    "elsecity.cash",
    "elsecity.email",
    "elsecity.info",
    "elsecity.life",
    "elsecity.link",
    "elsecity.org",
    "elsecity.today",
    "elsecity.xyz",
    "elseme.com",
    "elsethriftexam.website",
    "elsew0rld.org",
    "elseworld.info",
    "elseworld.net",
    "elsiedrs.info",
    "elsitio.com",
    "elsker.dk",
    "elslotsredirect.com",
    "elsoberano.net",
    "elsotanoderadiobelgrado.com",
    "elswabad.cf",
    "elswabad.gq",
    "elswabad.ml",
    "elswabad.tk",
    "eltasmu.cf",
    "eltasmu.ml",
    "eltimon.com",
    "eltronx.org",
    "elunenna.tk",
    "elus-rsm.net",
    "elusiveprime.net",
    "elva.app",
    "elvavgiyim.com",
    "elversoft.space",
    "elverturkiye.com",
    "elvis-pizza.com",
    "elvis.com",
    "elvis.dk",
    "elvisfan.com",
    "elvisor.org",
    "elwafidinetours.com",
    "ely.kr",
    "elyamnel3raby.org",
    "elyamnelaraby.org",
    "elysium.ml",
    "elysiumfund.com",
    "elysiumfund.net",
    "elysiumfund.org",
    "elysiumfundation.net",
    "elysiumfundation.org",
    "elzyro.com",
    "em-box.ru",
    "emab4i.us",
    "emacs.info",
    "emadisonriver.com",
    "emadisonriver.net",
    "emagrecendocomasol.com",
    "emagrecendocomrenata.com",
    "emagrecendototal.com",
    "emagrecer-rapido-urgente.com",
    "emagrecerapidohoje.com",
    "emagrecimentoagil.com",
    "emagrecimentodiadia.com",
    "email-24x7.com",
    "email-9.com",
    "email-fake.cf",
    "email-fake.com",
    "email-fake.ga",
    "email-fake.gq",
    "email-fake.ml",
    "email-fake.tk",
    "email-host.info",
    "email-jetable.fr",
    "email-lab.com",
    "email-list.online",
    "email-london.co.uk",
    "email-mail.pw",
    "email-reviews.com",
    "email-server.info",
    "email-sms.com",
    "email-sms.net",
    "email-splashbeachresort.com",
    "email-t.cf",
    "email-t.ga",
    "email-t.gq",
    "email-t.ml",
    "email-t.tk",
    "email-temp.com",
    "email-value.com",
    "email-vigrish.ru",
    "email-wizard.com",
    "email.a51.fr",
    "email.biz",
    "email.cbes.net",
    "email.com",
    "email.comx.cf",
    "email.cz",
    "email.de",
    "email.dk",
    "email.ee",
    "email.freecrypt.org",
    "email.infokehilangan.com",
    "email.it",
    "email.net",
    "email.nu",
    "email.org",
    "email.phoenix.edu",
    "email.plala.or.jp",
    "email.ro",
    "email.ru",
    "email.si",
    "email.su",
    "email.tst",
    "email.ua",
    "email.wassusf.online",
    "email.women.com",
    "email0.cf",
    "email0.ga",
    "email0.gq",
    "email0.ml",
    "email0.tk",
    "email1.gq",
    "email1.pro",
    "email2.cf",
    "email2.gq",
    "email2.ml",
    "email2.tk",
    "email2020.mehrpoy.ir",
    "email2an.ga",
    "email2me.com",
    "email2me.net",
    "email3.cf",
    "email3.ga",
    "email3.gq",
    "email3.ml",
    "email3.tk",
    "email4spam.org",
    "email4u.info",
    "email4work.xyz",
    "email5.net",
    "email60.com",
    "emailacc.com",
    "emailaccount.com",
    "emailaddresses.com",
    "emailage.cf",
    "emailage.ga",
    "emailage.gq",
    "emailage.ml",
    "emailage.tk",
    "emailahi.com",
    "emailanto.com",
    "emailappp.com",
    "emailapps.in",
    "emailapps.info",
    "emailasso.net",
    "emailate.com",
    "emailautomator.com",
    "emailay.com",
    "emailbaruku.com",
    "emailbox.comx.cf",
    "emailchepas.cf",
    "emailchepas.ga",
    "emailchepas.gq",
    "emailchepas.ml",
    "emailchepas.tk",
    "emailchoice.com",
    "emailcorner.net",
    "emailcu.icu",
    "emaildienst.de",
    "emaildrop.io",
    "emaileen.com",
    "emailem.com",
    "emailengine.net",
    "emailengine.org",
    "emailer.hubspot.com",
    "emailfake.cf",
    "emailfake.com",
    "emailfake.ga",
    "emailfake.gq",
    "emailfake.ml",
    "emailfake.nut.cc",
    "emailfalsa.cf",
    "emailfalsa.ga",
    "emailfalsa.gq",
    "emailfalsa.ml",
    "emailfalsa.tk",
    "emailforyou.net",
    "emailfowarding.com",
    "emailfreedom.ml",
    "emailgap.com",
    "emailgaul.com",
    "emailgenerator.de",
    "emailgo.de",
    "emailgroups.net",
    "emailguy.info",
    "emailhearing.com",
    "emailhost99.com",
    "emailias.com",
    "emailibre.com",
    "emailigo.de",
    "emailinbox.xyz",
    "emailinfive.com",
    "emailirani.ir",
    "emailist.tk",
    "emailisvalid.com",
    "emailit.com",
    "emailket.online",
    "emailkoe.com",
    "emaillime.com",
    "emaillist.fun",
    "emailll.org",
    "emailmarket.fun",
    "emailmarket.space",
    "emailmenow.info",
    "emailmiser.com",
    "emailmktsolutions.com",
    "emailmonkey.club",
    "emailna.co",
    "emailna.life",
    "emailnode.net",
    "emailnope.com",
    "emailnube.com",
    "emailo.pro",
    "emailofnd.cf",
    "emailondeck.com",
    "emailonline.me",
    "emailoo.cf",
    "emailoregon.com",
    "emailpinoy.com",
    "emailplanet.com",
    "emailplus.org",
    "emailportal.info",
    "emailpro.cf",
    "emailproxsy.com",
    "emailr.win",
    "emailresort.com",
    "emails.ga",
    "emails.incisivemedia.com",
    "emails.ru",
    "emailsecurer.com",
    "emailsensei.com",
    "emailservice.com",
    "emailsingularity.net",
    "emailspam.cf",
    "emailspam.ga",
    "emailspam.gq",
    "emailspam.ml",
    "emailspam.tk",
    "emailspot.org",
    "emailspro.site",
    "emailsteel.com",
    "emailsy.info",
    "emailsydney.com",
    "emailtea.com",
    "emailtech.info",
    "emailtemporal.org",
    "emailtemporanea.com",
    "emailtemporanea.net",
    "emailtemporar.ro",
    "emailtemporario.com.br",
    "emailtex.com",
    "emailthe.net",
    "emailtmp.com",
    "emailto.de",
    "emailtocard.com",
    "emailtocard.site",
    "emailtoo.ml",
    "emailtown.club",
    "emailure.net",
    "emailuser.net",
    "emailvenue.com",
    "emailwarden.com",
    "emailworth.com",
    "emailx.at.hm",
    "emailx.net",
    "emailxfer.com",
    "emailz.cf",
    "emailz.ga",
    "emailz.gq",
    "emailz.ml",
    "emakmintadomain.co",
    "emale.ru",
    "emall.ir",
    "emall.ml",
    "emanuele.dev",
    "emarketeng.com",
    "emarktshop.com",
    "emarkwebsolutions.com",
    "emasqiuqiu.info",
    "emasqiuqiu.org",
    "emasqq.info",
    "ematic.com",
    "embarqmail.com",
    "embeddedconsulting.com",
    "embeddedresearch.com",
    "embedhelp.com",
    "embergone.cf",
    "embergone.ga",
    "embergone.gq",
    "embergone.ml",
    "embergone.tk",
    "embergonebro.cf",
    "embergonebro.ga",
    "embergonebro.gq",
    "embergonebro.ml",
    "embergonebro.tk",
    "emblemail.com",
    "embower.site",
    "embraceqqef.email",
    "embracetheminivan.com",
    "emcchicago.com",
    "emdwgsnxatla1.cf",
    "emdwgsnxatla1.ga",
    "emdwgsnxatla1.gq",
    "emdwgsnxatla1.ml",
    "emdwgsnxatla1.tk",
    "emegaplex.com",
    "emeil.cf",
    "emeil.in",
    "emeil.ir",
    "emember.site",
    "emerald-court-takeaway.com",
    "emerald-shop.ru",
    "emeraldcluster.com",
    "emeraldsocietynews.club",
    "emeraldwebmail.com",
    "emergen.biz",
    "emergency-alert.org",
    "emergency-alerts.org",
    "emergencyredalerts.org",
    "emergenie.net",
    "emerial.su",
    "emext.com",
    "emeyle.com",
    "emfucan.cf",
    "emfucan.gq",
    "emfucan.tk",
    "emfunhigh.gq",
    "emfunhigh.ml",
    "emfunhigh.tk",
    "emi360.net",
    "emial.com",
    "emicomfort.com",
    "emigrantdfz.fun",
    "emigration.blog",
    "emil.com",
    "emilee.best",
    "emilybeckner.com",
    "emilydates.review",
    "emilylawson.buzz",
    "emilynall.com",
    "emilywillis.site",
    "emina7.com",
    "emina7.net",
    "eminempwu.com",
    "eminent.property",
    "eminitrading.net",
    "emirmail.ga",
    "emiro.ru",
    "emissarycsr.com",
    "emisser.ru",
    "emjvbq.com",
    "emkei.cf",
    "emkei.ga",
    "emkei.gq",
    "emkei.ml",
    "emkei.tk",
    "eml.cc",
    "eml.pp.ua",
    "emlhub.com",
    "emlpro.com",
    "emltmp.com",
    "emm.pet",
    "emmamolly.net",
    "emmasart.com",
    "emmasmale.com",
    "emmetttillmuseum.com",
    "emmtjv.best",
    "emmune.com",
    "emmys.life",
    "emnbp6.us",
    "emobilidade.net",
    "emohawk.xyz",
    "emojit.net",
    "emojit.org",
    "emolmot.cf",
    "emolmot.gq",
    "emolmot.ml",
    "emolmot.tk",
    "emoneysecrets.com",
    "emonroy.site",
    "emops.net",
    "emops.us",
    "emoreno.tk",
    "emoser.ga",
    "emoser.gq",
    "emoser.ml",
    "emoshin.com",
    "emotetimingleft-bright-bright.com",
    "emotionengineering.com",
    "emp3i.info",
    "emp4lbr3wox.ga",
    "empaltahu24best.gq",
    "empas.com",
    "empayna.cf",
    "empayna.ml",
    "empayna.tk",
    "empdesguace.com",
    "empek.tk",
    "empereur.com",
    "empik.photo",
    "empikmuzyka.com",
    "empire-report.com",
    "empire-subtleagility.com",
    "empireanime.ga",
    "empiremail.de",
    "empiremonk-timeagilefitness.com",
    "empiresro.com",
    "empiricalnerd.com",
    "empistllc.com",
    "emplathe.monster",
    "emplawyernet.com",
    "empleoentuciudad.com",
    "empleoline.com",
    "emplkbilety.com",
    "employeedictionary.com",
    "employeeglossary.com",
    "employerdictionary.com",
    "employerglossary.com",
    "employmentagencyusa.com",
    "employmentcontract.works",
    "empowerbyte.com",
    "empowerdcu.com",
    "empoweredservices.org",
    "empowerffcu.com",
    "empowering.zapto.org",
    "empoweringgirlz.com",
    "empoweringgirlz.net",
    "empowermentparent.com",
    "empowerplasticsurgery.com",
    "empowerrfcu.com",
    "empowerrss.com",
    "empowerslife.com",
    "empreendasemfronteiras.com",
    "empregoaqui.site",
    "empregosdesucesso.com",
    "empresagloriasamotderoman.com",
    "empty.support",
    "emptymail.com",
    "empurarefrigeration.com",
    "emqe.email",
    "emran.cf",
    "emroligh.cf",
    "emroligh.ga",
    "emroligh.gq",
    "emroligh.ml",
    "emroligh.tk",
    "emrullahakgun.xyz",
    "emsapp.net",
    "emscentr.ru",
    "emstjzh.com",
    "emtdevhouse.com",
    "emtepsi.cf",
    "emtepsi.ga",
    "emtepsi.gq",
    "emtepsi.ml",
    "emtrn9cyvg0a.cf",
    "emtrn9cyvg0a.ga",
    "emtrn9cyvg0a.gq",
    "emtrn9cyvg0a.ml",
    "emtrn9cyvg0a.tk",
    "emucasino.app",
    "emule.cf",
    "emule.ga",
    "emule.gq",
    "emumail.com",
    "emuvig.us",
    "emuwarez.com",
    "emvil.com",
    "emvnf.live",
    "emvr.net",
    "emwe.ru",
    "emwuzoom.com",
    "emy.kr",
    "emydsu.us",
    "emysg.icu",
    "emz.net",
    "en2dhm.us",
    "en565n6yt4be5.cf",
    "en565n6yt4be5.ga",
    "en565n6yt4be5.gq",
    "en565n6yt4be5.ml",
    "en565n6yt4be5.tk",
    "en5ew4r53c4.cf",
    "en5ew4r53c4.ga",
    "en5ew4r53c4.gq",
    "en5ew4r53c4.ml",
    "en5ew4r53c4.tk",
    "enabi.best",
    "enablediversity.com",
    "enables.us",
    "enagav.cf",
    "enagav.ga",
    "enagav.gq",
    "enagav.ml",
    "enagav.tk",
    "enagicman.com",
    "enaksekali.ga",
    "enamproshed.tk",
    "enasyn.com",
    "enayu.com",
    "enbago.net",
    "enbdmh.ml",
    "encadreurcycliste.com",
    "encandenados.com",
    "encartes.online",
    "enchantedindiancoffee.com",
    "enciar.xyz",
    "encinodata.com",
    "encloudhd.com",
    "encorehighenddesigners.com",
    "encoybet1.com",
    "encryptedmail.xyz",
    "encuentra24.app",
    "encuestas-diarias.online",
    "encyclopedia-annabi.com",
    "end-war.com",
    "endamoebic.best",
    "endeffectgaming.com",
    "endgamez.live",
    "endler.network",
    "endodonticassociate.com",
    "endofinternet.net",
    "endofinternet.org",
    "endoftheinternet.org",
    "endohost.com",
    "endosferes.ru",
    "endozogkqq.site",
    "endpoint-hosting.online",
    "endrix.org",
    "enduranceblue-original.website",
    "endzonebet.net",
    "eneasun.gq",
    "enedes.cf",
    "enedes.ml",
    "enedes.tk",
    "enel.net",
    "enelaw.ga",
    "enelaw.ml",
    "enelaw.tk",
    "enelpunto.net",
    "enemiesofman.com",
    "enemydon.xyz",
    "enemydono.icu",
    "enemyxuyj.space",
    "energeticcity.net",
    "energiedeals.online",
    "energieloket.tools",
    "energon-co.ru",
    "energy-analyzer.com",
    "energycomplianceinsight.com",
    "energyfriendlyhome.com",
    "energylord.best",
    "energymedicineglobal.com",
    "energysavvy.info",
    "energysavvy.org",
    "energysavvyoptix.com",
    "energywatch.mobi",
    "energywidetimes.com",
    "enetis.net",
    "enevthom.ml",
    "enevthom.tk",
    "enewscoralgables.com",
    "enf9m.live",
    "enfejar90.xyz",
    "enfgrs.site",
    "enformakhirdavat.site",
    "enfsmq2wel.cf",
    "enfsmq2wel.ga",
    "enfsmq2wel.gq",
    "enfsmq2wel.ml",
    "enfsmq2wel.tk",
    "enfusion.systems",
    "eng-learning.ru",
    "engadinstmoritz-booking.com",
    "engagecoin.info",
    "engagecoin.net",
    "engagecoin.org",
    "engagementfirm.com",
    "engagextremely.com",
    "engelwaldfarm.com",
    "enggalman.ga",
    "enggalman.ml",
    "engine110.com",
    "engineemail.com",
    "engineer.com",
    "engineeredforsimplicity.com",
    "engineeredforsimplicity.net",
    "engineering-ai.com",
    "enginetuwh.site",
    "engit.live",
    "england.com",
    "england.edu",
    "england4d.com",
    "englandmail.com",
    "englandvs.com",
    "englearner.ru",
    "englewoodedge.net",
    "englishexp.com",
    "englishmiaskype.ru",
    "englishviaskypes.ru",
    "engsocial.com",
    "engteach.com",
    "enhancedsurgicalrecovery.com",
    "enhanceronly.com",
    "enhancingworkforceleadership.com",
    "eniddoctors.com",
    "enidford.net",
    "enigmagames.net",
    "enigmaticowl.com",
    "enikova.ru",
    "eniyikahve.online",
    "enj0yourfile.com",
    "enjeolonmoda.xyz",
    "enjoy.email.ne.jp",
    "enjoybag.website",
    "enjoyingeachjourney.com",
    "enjoyiqos.ru",
    "enjoypixel.com",
    "enkayasam.net",
    "enkeldate-meet-backup.com",
    "enkeldate-meet.com",
    "enligent.com",
    "enmail1.com",
    "enmenli.cf",
    "enmenli.ga",
    "enmenli.gq",
    "enmenli.ml",
    "enmenli.tk",
    "enmtuxjil7tjoh.cf",
    "enmtuxjil7tjoh.ga",
    "enmtuxjil7tjoh.gq",
    "enmtuxjil7tjoh.ml",
    "enmtuxjil7tjoh.tk",
    "enneagramglobalschool.com",
    "ennemail.ga",
    "ennyslau.gq",
    "ennyslau.ml",
    "enobu.live",
    "enokgreen.cf",
    "enokgreen.ga",
    "enokgreen.gq",
    "enokgreen.ml",
    "enokgreen.tk",
    "enometry.com",
    "enonenerjiotomasyon.com",
    "enpeare.ga",
    "enpeare.tk",
    "enput.com",
    "enqd.com",
    "enqd.net",
    "enriched-health.site",
    "enrollyourhealth.net",
    "enron.cf",
    "enron.ga",
    "enron.gq",
    "enron.ml",
    "enroncorp.cf",
    "enroncorp.ga",
    "enroncorp.gq",
    "enroncorp.ml",
    "enroncorp.tk",
    "enseade.ga",
    "enseade.gq",
    "enseade.ml",
    "enseade.tk",
    "ensembledynamics.com",
    "ensight-usa.com",
    "ensight-vn.com",
    "ensotv.net",
    "enspara.energy",
    "enspiral.mobi",
    "entekhab.group",
    "enter.net",
    "enterbles.fun",
    "enterprisebitcoin.com",
    "enterpriseln.us",
    "enterprisepackets.com",
    "entertainerblog.com",
    "entertainmebillings.com",
    "entertainmentphuket.fun",
    "entertainmentstockmarket.com",
    "enterto.com",
    "enterxxx.net",
    "entibeatz.online",
    "entopios.net",
    "entopios.org",
    "entrate.info",
    "entrega-transportadora.ml",
    "entregandobiblia.com.br",
    "entrenuvols.net",
    "entrenuvols.org",
    "entreum.com",
    "entropy.email",
    "entrupy.info",
    "entrupy.net",
    "entrybl.xyz",
    "entrylunc.us",
    "entsm.com",
    "entuziast-center.ru",
    "enu.kr",
    "enuygunbankalar.online",
    "enuygunbankalar.xyz",
    "enuygunfinansman.online",
    "enuygunfinansman.xyz",
    "envatobundles.com",
    "enveloped.org",
    "enviroconceptinternational.com",
    "enviroconceptinternational.net",
    "environmentastwork.com",
    "envolplus.com",
    "envy17.com",
    "enwi7gpptiqee5slpxt.cf",
    "enwi7gpptiqee5slpxt.ga",
    "enwi7gpptiqee5slpxt.gq",
    "enwi7gpptiqee5slpxt.ml",
    "enwi7gpptiqee5slpxt.tk",
    "eny.kr",
    "enypoh.us",
    "enythgehiqe.ru",
    "enzomail.tk",
    "enzooty.best",
    "enzos-parnell-st-ennis.com",
    "eo5ser.us",
    "eob6sd.info",
    "eocilspf.shop",
    "eodfku.info",
    "eoffice.top",
    "eoinbalara.com",
    "eojiu1.site",
    "eolif.com",
    "eoncasino.com",
    "eonmech.com",
    "eoopy.com",
    "eopleopp.shop",
    "eoppeopl.shop",
    "eorbs.com",
    "eos-ram.info",
    "eos24.media",
    "eos2mail.com",
    "eosonlinelearning.com",
    "eot.com",
    "eovdfezpdto8ekb.cf",
    "eovdfezpdto8ekb.ga",
    "eovdfezpdto8ekb.gq",
    "eovdfezpdto8ekb.ml",
    "eovdfezpdto8ekb.tk",
    "epage.ru",
    "epaj40wss.buzz",
    "eparty.online",
    "epatra.com",
    "epayvip88.com",
    "epb.ro",
    "epcgpn.site",
    "epchurchgh.org",
    "epdsale.top",
    "ephemail.net",
    "ephemeral.black",
    "ephemeral.email",
    "ephysiotherapist.com",
    "epiar.net",
    "epic-forum.org",
    "epic-tech.org",
    "epic.swat.rip",
    "epicallies.org",
    "epicbait.site",
    "epiccarry.ru",
    "epicentrogt.com",
    "epicgamers.mooo.com",
    "epicmoney.gold",
    "epicpresence.company",
    "epicqq.info",
    "epics.cards",
    "epicsap.site",
    "epicsmagazine.com",
    "epicwave.desi",
    "epicxel.com",
    "epidamnus.com",
    "epideme.xyz",
    "epidifiak.info",
    "epigeneticsconference.org",
    "epigeneticstest.com",
    "epiglotteres.com",
    "epinzen.site",
    "epionepavilion.com",
    "epiqmail.com",
    "episcope.site",
    "episodul.online",
    "epitheaurq.space",
    "epitin.cf",
    "epitin.ga",
    "epitin.tk",
    "epix.net",
    "eplixs.com",
    "epmnko.site",
    "epnleqj.site",
    "epomail.com",
    "epoqjoie.shop",
    "epost.de",
    "eposta.hu",
    "epostmail.comx.cf",
    "epot.ga",
    "epot.pro",
    "epowerhousepc.com",
    "eppik.ru",
    "eppvcanks.shop",
    "epreng.net",
    "eprompter.com",
    "epropertytaxappeal.net",
    "epropertytaxappeal.org",
    "epscinc.com",
    "epshop.online",
    "eptnxuffm.shop",
    "epulat.com",
    "epvmo.us",
    "epw88.com",
    "epwenner.de",
    "epweqdlzy.shop",
    "epwnhsss.xyz",
    "epxs.email",
    "epyc.asia",
    "epycn1.site",
    "epypqm.shop",
    "eq-trainer.ru",
    "eq2shs5rva7nkwibh6.cf",
    "eq2shs5rva7nkwibh6.ga",
    "eq2shs5rva7nkwibh6.gq",
    "eq2shs5rva7nkwibh6.ml",
    "eq2shs5rva7nkwibh6.tk",
    "eqbill.com",
    "eqbo62qzu2r8i0vl.cf",
    "eqbo62qzu2r8i0vl.ga",
    "eqbo62qzu2r8i0vl.gq",
    "eqbo62qzu2r8i0vl.ml",
    "eqbo62qzu2r8i0vl.tk",
    "eqeqeqeqe.tk",
    "eqgigyhce.shop",
    "eqiluxspam.ga",
    "eqlifecoaching.com",
    "eqqsale.top",
    "eqqu.com",
    "eqr.luk2.com",
    "eqra.news",
    "eqstqbh7hotkm.cf",
    "eqstqbh7hotkm.ga",
    "eqstqbh7hotkm.gq",
    "eqstqbh7hotkm.ml",
    "eqstqbh7hotkm.tk",
    "eqtlvr.us",
    "equalizer700je.online",
    "equalla.icu",
    "equallyblessed.com",
    "equalpi.xyz",
    "equalscra.fun",
    "equalsn.icu",
    "equerrenjv.space",
    "eques.jobs",
    "equestrianjump.com",
    "equfic.xyz",
    "equiapp.men",
    "equicapital.net",
    "equicapital.org",
    "equicrypto.com",
    "equiemail.com",
    "equility.info",
    "equiparen.buzz",
    "equipde.icu",
    "equipdeb.xyz",
    "equipgl.icu",
    "equiphub.us",
    "equipment.solutions",
    "equipmentglossary.com",
    "equipmentshop.futbol",
    "equipoidexa.org",
    "equityen.com",
    "equonecredite.com",
    "equorum.nu",
    "equorum.online",
    "equorum.se",
    "equpio.com",
    "equuate.ru",
    "eqzvvsyx.shop",
    "er0ysu.us",
    "er98.top",
    "era-logic.com",
    "era7mail.com",
    "eradio.africa",
    "eraghou.cf",
    "eraghou.ga",
    "eraghou.gq",
    "eraghou.ml",
    "eraghou.tk",
    "erajuditogel.org",
    "eramail.co.za",
    "eramis.ga",
    "eramupload.website",
    "eranhome.com",
    "erarkhol.ga",
    "erarkhol.gq",
    "erarkhol.ml",
    "erarkhol.tk",
    "erasedebt.gq",
    "erasedpaining.xyz",
    "erasf.com",
    "eratetlo.tech",
    "erauiltyn.com",
    "erbfdssdgdg.xyz",
    "erbreathox.cf",
    "erbreathox.ga",
    "erbreathox.gq",
    "erbreathox.ml",
    "erbs-palsy-attorney.com",
    "erc.city",
    "ercanzincir.com",
    "erciyesbali.com",
    "erconserva.icu",
    "erdem.se",
    "erdemkitap.com",
    "erdyufaelesa.space",
    "ereaper.best",
    "erec.tel",
    "erecete.org",
    "erectiele-nl.info",
    "erectiestoornisoplossing.com",
    "erectil-es.info",
    "erektil-no.info",
    "erelthy.cf",
    "erelthy.ga",
    "erelthy.gq",
    "erelthy.ml",
    "erelthy.tk",
    "erematotupet.host",
    "ereroc.gq",
    "ereroc.ml",
    "eresmas.com",
    "erethism.site",
    "eretoth.cf",
    "eretoth.ga",
    "eretoth.gq",
    "eretoth.ml",
    "eretoth.tk",
    "erevusolutions.com",
    "erexgxddbx.site",
    "erge-grev-efef.online",
    "ergma.ru",
    "ergo-ryukzak.ru",
    "ergobabyrussian.ru",
    "ergthh34gefg43g.xyz",
    "erguvanhaber.xyz",
    "erh375j.xyz",
    "eriakis.biz",
    "eriakis.info",
    "eriakis.net",
    "eriakis.org",
    "ericasfinejewelry.com",
    "ericdmcguire.com",
    "ericfilson.com",
    "ericfress.com",
    "ericjohnson.ml",
    "erickmadrigal.ml",
    "ericrberg.com",
    "ericreyess.com",
    "ericsieker.com",
    "erictelford.com",
    "eriell.info",
    "eriell.life",
    "eriell.live",
    "eriell.xyz",
    "eriga.lv",
    "erikharvey.com",
    "eriksen.dk",
    "eriksendesign.com",
    "erikthorsen.com",
    "erinaria.info",
    "erindalton.net",
    "erinfe.cf",
    "erinfe.tk",
    "erinfortney.com",
    "eringking.com",
    "erinmccoycoaching.com",
    "erinparkstud.com",
    "erisfika.online",
    "erk7oorgaxejvu.cf",
    "erk7oorgaxejvu.ga",
    "erk7oorgaxejvu.gq",
    "erk7oorgaxejvu.ml",
    "erk7oorgaxejvu.tk",
    "erkadekorasyon.xyz",
    "erkeksentikla.com",
    "erkeksoru.xyz",
    "erlera.cf",
    "erlera.ga",
    "erlera.gq",
    "erlera.tk",
    "ermail.cf",
    "ermail.ga",
    "ermail.gq",
    "ermail.ml",
    "ermail.tk",
    "ermawork.ga",
    "ermawork.ml",
    "ermcousa.net",
    "ermcousa.us",
    "ermeson.tk",
    "ermusyapiinsaat.xyz",
    "ernplk.tech",
    "ero-tube.org",
    "ero-vr-matome.xyz",
    "ero123.com",
    "erocewar.site",
    "erofan.org",
    "erofree.pro",
    "erols.com",
    "erothde.cf",
    "erothde.gq",
    "erothde.ml",
    "eroticplanet24.de",
    "erotopathy.site",
    "erotubes.pro",
    "erovideo.pro",
    "erovidos.com",
    "eroxs.info",
    "eroyal.net",
    "erpratgey.cf",
    "erpratgey.ga",
    "erpratgey.gq",
    "erpratgey.ml",
    "erpratgey.tk",
    "err33.com",
    "error-10by25.stream",
    "error-codexx159.xyz",
    "errorsinlogic.com",
    "errorstud.io",
    "ersatzauto.ch",
    "ersaym.com",
    "ersbizz.com",
    "erseolog.cf",
    "erseolog.ml",
    "erseolog.tk",
    "erslni.net",
    "erslni.org",
    "erstelecom.com",
    "ersyersy.shop",
    "ertacperde.com",
    "erti.de",
    "erttobacco.online",
    "erttobacco.xyz",
    "eruj33y5g1a8isg95.cf",
    "eruj33y5g1a8isg95.ga",
    "eruj33y5g1a8isg95.gq",
    "eruj33y5g1a8isg95.ml",
    "eruj33y5g1a8isg95.tk",
    "erunko.cf",
    "erunko.gq",
    "erunko.tk",
    "eruopwfv.shop",
    "eruslook.ru",
    "ervackrdes.xyz",
    "ervgre-rfer.online",
    "erwinvanstrien.online",
    "erwsh.live",
    "eryoritwd1.cf",
    "eryoritwd1.ga",
    "eryoritwd1.gq",
    "eryoritwd1.ml",
    "eryoritwd1.tk",
    "erythromycin.website",
    "erzashelby.com",
    "erzincanalperen.xyz",
    "erzincankurufasulye.com",
    "erzincanyildizbakir.com",
    "erzurumankaranakliyat.com",
    "erzurumemlaklari.online",
    "erzurumhaberi.xyz",
    "erzurumkizyurdu.online",
    "erzurumsesveisik.xyz",
    "erzurumyildizevdenevenakliyat.com",
    "es2kbi.us",
    "es2wyvi7ysz1mst.com",
    "esa-today.com",
    "esabwhiua.shop",
    "esaccas.cf",
    "esaccas.ga",
    "esaccas.gq",
    "esaccas.tk",
    "esamario.com",
    "esanimalhospital.net",
    "esarwes.gq",
    "esawblin.ga",
    "esawblin.gq",
    "esawblin.tk",
    "esbano-magazin.ru",
    "esbano-online.ru",
    "esbano-ru.ru",
    "esc.la",
    "escacd.com",
    "escalaaotronivel.com",
    "escanor99.com",
    "escapadas.online",
    "escapecomponents.store",
    "escapehatchapp.com",
    "escapeling.com",
    "escherfeynman.organic",
    "eschooltopia.net",
    "esckiz.xyz",
    "escolesobertes.cat",
    "escondidoflorists.net",
    "esconlu.cf",
    "esconlu.gq",
    "esconlu.ml",
    "esconlu.tk",
    "escorpianas.com",
    "escortworcester.co.uk",
    "escritoriolojacenter1.site",
    "escritossad.net",
    "escsft.com",
    "escuelanegociodigital.com",
    "escuelaspoderosainfancia.com",
    "esdbrush.us",
    "esdbrushes.biz",
    "esdbrushes.net",
    "ese.kr",
    "esemail.club",
    "esemay.com",
    "esenyurt-travesti.online",
    "esenyurt-travesti.xyz",
    "esenyurttravesti.fun",
    "esenyurttravesti.info",
    "esenyurttravesti.website",
    "eset.t28.net",
    "esfahanfood.com",
    "esgecsesli.xyz",
    "esgeneri.com",
    "eshche.net",
    "eshta-cdn.com",
    "eshta-studio.com",
    "eshta.com",
    "eshtacapital.com",
    "eshtacdn.com",
    "eshtafinance.com",
    "eshtajobs.com",
    "eshtapay.com",
    "eshtr.online",
    "esidin.cf",
    "esidin.tk",
    "esipfed.online",
    "esiresid.shop",
    "esishyd.cf",
    "esishyd.ga",
    "esivkov-spb.ru",
    "esj1r8odwoo7eui.xyz",
    "eskisehirhgm.xyz",
    "eskortbayanizmir.net",
    "eslechealth.cf",
    "eslechealth.ga",
    "eslechealth.ml",
    "eslechealth.tk",
    "eslicepizzaboqueriabarcelona.com",
    "esltmc.online",
    "esmagpe.cf",
    "esmailweb.net",
    "esmeraldamagina.com",
    "esmqp.com",
    "esmst.ru",
    "esmuse.me",
    "esmvke.com",
    "esonesox.shop",
    "esoumail.com",
    "esoundbest.info",
    "esoxeson.shop",
    "esoxy.xyz",
    "espaceclient.live",
    "espacepersonnel.pro",
    "espamted3kepu.cf",
    "espamted3kepu.ga",
    "espamted3kepu.gq",
    "espamted3kepu.ml",
    "espamted3kepu.tk",
    "espana-official.com",
    "espanafarmaciaonline.xyz",
    "espavosolutions.ru",
    "espcialidadedacasa.website",
    "especially-beam.xyz",
    "espera-supplements.app",
    "espera-supplements.ru",
    "espera-supplements.us",
    "espheratus.com",
    "espiritusanto.org",
    "esportmeesters.com",
    "esportscoaching.net",
    "esprit-pixel.com",
    "esprity.com",
    "esr.foundation",
    "esrialternative.com",
    "essanorakglad.site",
    "essaouira.xyz",
    "essaypian.email",
    "essayrigh.space",
    "essaysandthesis.online",
    "essaysofthelight.org",
    "essayto.buzz",
    "essecs.com",
    "essenard.gq",
    "essentiaionized.com",
    "essentialm2.com",
    "essentialsecurity.com",
    "esseriod.com",
    "essgladsuhoy.site",
    "essjayar.com",
    "esskernkofta.site",
    "esspurgaparka.site",
    "esssuhoyshuba.site",
    "est-a-la-maison.com",
    "est-le-patron.com",
    "est-mon-blogueur.com",
    "est.une.victime.ninja",
    "esta-system.com",
    "estabbetting.xyz",
    "estalya.us",
    "estate-invest.fr",
    "estateboss.com",
    "estatenearby.com",
    "estateplanninglawyerscalifornia.com",
    "estaterussia.info",
    "estekiskele.online",
    "estekiskele.xyz",
    "estelove.com",
    "estesacekim.com",
    "esteticum.ru",
    "estimacao.ngo",
    "estimat.info",
    "estimatd.com",
    "estivates793kg.online",
    "estkolonya.site",
    "eston.best",
    "estoniacv.online",
    "estoniacv.xyz",
    "estopg.com",
    "estranet.it",
    "estrate.ga",
    "estudiarcurso.online",
    "estudio-gato.com",
    "eswobd.info",
    "eswseswo.shop",
    "esy.es",
    "eszksy.us",
    "eszmflzd.shop",
    "et4veh6lg86bq5atox.cf",
    "et4veh6lg86bq5atox.ga",
    "et4veh6lg86bq5atox.gq",
    "et4veh6lg86bq5atox.tk",
    "et9p6.site",
    "etaajir.net",
    "etachkila.com",
    "etaetae46gaf.ga",
    "etagirf.best",
    "etaksa.com",
    "etalase1.com",
    "etarochester.org",
    "etbiym.rest",
    "etcmail.com",
    "etcone.net",
    "etdcr5arsu3.cf",
    "etdcr5arsu3.ga",
    "etdcr5arsu3.gq",
    "etdcr5arsu3.ml",
    "etdcr5arsu3.tk",
    "etdkewlpzb.space",
    "etelford.net",
    "etermin.info",
    "eternalfitonline.com",
    "eternalnymphets.net",
    "eternity-craft.ru",
    "etfstudies.com",
    "etgdev.de",
    "etgm9v.us",
    "eth2btc.info",
    "ethanolmarketplace.com",
    "ethanschutzman.net",
    "ether123.net",
    "ethereal.email",
    "ethereum-bestchange.ru",
    "ethereum-code.site",
    "ethereum1.top",
    "ethereum24.ru",
    "ethereumru.ru",
    "ethermes.com",
    "ethermes.org",
    "etherpress.com",
    "ethersports.org",
    "ethersportz.info",
    "etherstorm.org",
    "ethicallystrapped.com",
    "ethicsdishmoving.website",
    "ethicsiq.org",
    "ethicsliteracy.org",
    "ethicusassetmanagement.com",
    "ethnicfoodrestaurants.com",
    "ethnicingredients.com",
    "ethos.st",
    "ethreach.org",
    "ethweneam.info",
    "ethworks.org",
    "etican.ga",
    "etican.gq",
    "etican.ml",
    "eticaret.cloud",
    "eticof.cf",
    "eticof.ga",
    "eticof.gq",
    "eticof.ml",
    "eticof.tk",
    "etinpsychel.tk",
    "etio90.org",
    "etio90day.biz",
    "etiology167vz.online",
    "etiquetteconfidencecredibility.com",
    "etisun.com",
    "etj64.space",
    "etkilihaber.com",
    "etlbox.com",
    "etlgr.com",
    "etlmgr.shop",
    "etmexplorer.com",
    "etnipuzzle.com",
    "etoaffo.shop",
    "etoast.com",
    "etobx.xyz",
    "etoic.com",
    "etondy.com",
    "etopmail.com",
    "etoreo.com",
    "etorrent.shop",
    "etotaal.info",
    "etotvibor.ru",
    "etoymail.com",
    "etpgajol.shop",
    "etr500.cf",
    "etr500.ga",
    "etr500.gq",
    "etr500.ml",
    "etr500.tk",
    "etr610.cf",
    "etr610.ga",
    "etr610.gq",
    "etr610.ml",
    "etr610.tk",
    "etrackarchitect.com",
    "etrademail.com",
    "etranquil.com",
    "etranquil.net",
    "etranquil.org",
    "etras.ru",
    "etravelgo.info",
    "etreband.ru",
    "etruxiod.shop",
    "ets-products.ru",
    "ets2android.mobi",
    "ets6y.com",
    "etsiptv.xyz",
    "etspirt.ru",
    "etszys.com",
    "ettke.com",
    "ettsetth.shop",
    "etunad.cf",
    "etunad.ga",
    "etunad.tk",
    "etvdruqm.shop",
    "etwienmf7hs.cf",
    "etwienmf7hs.ga",
    "etwienmf7hs.gq",
    "etwienmf7hs.ml",
    "etxm.gq",
    "etzdnetx.com",
    "eu-med4.site",
    "eu-portals.info",
    "eu.dlink.cf",
    "eu.dlink.gq",
    "eu.igg.biz",
    "eu42ti.site",
    "eu6genetic.com",
    "eu83t4nncmxv3g2.xyz",
    "euaqa.com",
    "euchante.com",
    "euchlidlabs.com",
    "eudemon422po.xyz",
    "eudoramail.com",
    "eue51chyzfil0.cf",
    "eue51chyzfil0.ga",
    "eue51chyzfil0.gq",
    "eue51chyzfil0.ml",
    "eue51chyzfil0.tk",
    "eugenecentral.com",
    "eugeneexperiencedrealtors.com",
    "eugenehairsalons.com",
    "euieua.com",
    "eujyrtrffvdtrts.xyz",
    "eukip.site",
    "euleadong.site",
    "eulogized693df.online",
    "eunet.rs",
    "eupandevae.icu",
    "euparknow.com",
    "eur-sec1.cf",
    "eur-sec1.ga",
    "eur-sec1.gq",
    "eur-sec1.ml",
    "eur-sec1.tk",
    "eur0.cf",
    "eur0.ga",
    "eur0.gq",
    "eur0.ml",
    "eurasiamedia.biz",
    "eurasiandigitalventures.fund",
    "eureka.edu",
    "euro24.bet",
    "euro24.casino",
    "euro24bet11.com",
    "euro24bet12.com",
    "euroaromalab.org",
    "eurobet88.net",
    "eurobrazilcorretora.com",
    "eurocasinos.biz",
    "eurochocolate.club",
    "eurochocolates.online",
    "eurogenet.com",
    "eurohoopsdome.com",
    "eurokool.com",
    "euromail.hu",
    "euromail.tk",
    "euromech.com",
    "europa-takeaway.com",
    "europakebabdos.com",
    "europamel.net",
    "europartsmarket.com",
    "europe-daily-news.host",
    "europe.com",
    "europeaa318.xyz",
    "europeamericabanglanews.com",
    "europeanestate.com",
    "europeanopenseries.online",
    "europeanvoice.info",
    "europecruisessale.com",
    "europeforcreators.com",
    "europeforcreators.org",
    "europemail.com",
    "europeproducts2020.website",
    "europesurgery-uk.com",
    "euroseek.com",
    "eurosport.com",
    "eurostyle46.ru",
    "eurotrip-now.xyz",
    "eurotripdeal.xyz",
    "eurouniversitybahrain.com",
    "eurovag.com",
    "euroweb.email",
    "eusale2020.website",
    "euwbvkhuqwdrcp8m.cf",
    "euwbvkhuqwdrcp8m.ml",
    "euwbvkhuqwdrcp8m.tk",
    "euwettensy.info",
    "ev-ee.com",
    "ev-mc.ru",
    "ev.camp",
    "ev1.nl",
    "eva.fyi",
    "evacuator-bronnitcy.ru",
    "evaelfie.mobi",
    "evafan.com",
    "evaforum.info",
    "evaherbals.info",
    "evakuator-teh.ru",
    "evalovia.best",
    "evaluatorapp.com",
    "evalusave.com",
    "evanackmann.net",
    "evanfox.info",
    "evanhamilton.buzz",
    "evanlifesciences.com",
    "evanodonnell.buzz",
    "evansimmonsmft.net",
    "evaonspace.com",
    "evasea.com",
    "evashirts.net",
    "evavbe.ga",
    "evavbe.tk",
    "evavoyance.com",
    "evbank.ru",
    "evcmail.com",
    "evcr8twoxifpaw.cf",
    "evcr8twoxifpaw.ga",
    "evcr8twoxifpaw.gq",
    "evcr8twoxifpaw.ml",
    "evcr8twoxifpaw.tk",
    "evdemutfakta.com",
    "evdenevenakliyat.link",
    "evdy5rwtsh.cf",
    "evdy5rwtsh.ga",
    "evdy5rwtsh.gq",
    "evdy5rwtsh.ml",
    "evdy5rwtsh.tk",
    "eveav.com",
    "eveaz.xyz",
    "eveb5t5.cf",
    "eveb5t5.ga",
    "eveb5t5.gq",
    "eveb5t5.ml",
    "eveb5t5.tk",
    "evelandtrading.com",
    "evelinecharlespro.com",
    "evelineshoes.com",
    "evelynnichols.com",
    "evendmjishj.email",
    "evengtough.xyz",
    "evengwassevent.xyz",
    "evenmoralistface.website",
    "evenor-tech.net",
    "eventao.com",
    "eventplanneradvisor.com",
    "eventpronto.com",
    "eventsmith.net",
    "eventtrainingsingapore.com",
    "ever-market.ru",
    "everlest.ru",
    "everleto.ru",
    "evertonfans.com",
    "everwallapi.com",
    "everwallwedding.com",
    "every1.net",
    "everybabes.com",
    "everyday.com.kh",
    "everyday1234.live",
    "everydroid.com",
    "everyhomeforchrist.live",
    "everyhomeforchrist.net",
    "everymail.net",
    "everyone.net",
    "everyoneapparel.com",
    "everyoneisdisappointed.com",
    "everyshop.us",
    "everytg.ml",
    "everything-it.us",
    "everythingcqc.org",
    "everythingpages.com",
    "everythingstyle.com",
    "everythingtheory.club",
    "everythingtheory.org",
    "everythingtheory.science",
    "everyusb.org",
    "everywhen.best",
    "evesage.com",
    "evgaumgfh.shop",
    "evgmodern.ru",
    "evhybrid.club",
    "evictionlawyersflorida.com",
    "evidencebasedhealthclinic.com",
    "evidencebasedneurologyclinic.com",
    "eviemccarthy.buzz",
    "evilbruce.com",
    "evilcomputer.com",
    "evilempire.website",
    "evilin-expo.ru",
    "evinad.cf",
    "evinad.gq",
    "evinad.ml",
    "evironmentalrefugee.com",
    "evisumloket.com",
    "evitamini.site",
    "eviteuk.live",
    "evkiwi.de",
    "evlenmiyorum.com",
    "evliyaogluotel.com",
    "evlon1.us",
    "evo.financial",
    "evo.gold",
    "evo.industries",
    "evo.institute",
    "evo.legal",
    "evoaled091h.cf",
    "evoaled091h.ga",
    "evoaled091h.gq",
    "evoaled091h.ml",
    "evoaled091h.tk",
    "evoandroidevo.me",
    "evocurrencies.com",
    "evodigital.global",
    "evodinner.com",
    "evolueselon.site",
    "evolution.financial",
    "evolution24.de",
    "evolutiongene.com",
    "evolutionofintelligence.com",
    "evolve-fireworks.com",
    "evolveconsulting.biz",
    "evolvedworld.net",
    "evolvedworld.online",
    "evomindset.org",
    "evonb.com",
    "evonse.com",
    "evopad.cf",
    "evopad.ga",
    "evopad.gq",
    "evopad.ml",
    "evopad.tk",
    "evopeak-malenow.com",
    "evopo.com",
    "evoraclinic.com",
    "evoseed.com",
    "evosocceronline.com",
    "evotimer.com",
    "evoveo.com",
    "evpatiy.ru",
    "evpskp.site",
    "evq2.com",
    "evt5et4.cf",
    "evt5et4.ga",
    "evt5et4.gq",
    "evt5et4.ml",
    "evt5et4.tk",
    "evuwbapau3.cf",
    "evuwbapau3.ga",
    "evuwbapau3.gq",
    "evuwbapau3.ml",
    "evwig.com",
    "evxmail.net",
    "evyush.com",
    "ewa.kr",
    "eweathervane.com",
    "ewebzine.net",
    "ewer.ml",
    "ewerewea.shop",
    "ewfcfew.online",
    "ewgzsi.us",
    "ewhig.xyz",
    "ewjklflets.com",
    "ewjklfmy.com",
    "ewjklfweb.com",
    "ewjklfyour.com",
    "eworldplaza.com",
    "ewpropertymanagement.info",
    "ewpropertymanagement.org",
    "ewrfw17.xyz",
    "ewroteed.com",
    "ewt35ttwant35.tk",
    "ewuobxpz47ck7xaw.cf",
    "ewuobxpz47ck7xaw.ga",
    "ewuobxpz47ck7xaw.gq",
    "ewuobxpz47ck7xaw.ml",
    "ewuobxpz47ck7xaw.tk",
    "eww.ro",
    "ewxvrbhl.shop",
    "ex21pars.com",
    "exactfitrepaircoupling.com",
    "examanedemanejocr.com",
    "examentechnique-site.com",
    "exammission.website",
    "examnotes.net",
    "example.com",
    "examsread.com",
    "exas20.site",
    "exathat.cf",
    "exathat.gq",
    "exathat.tk",
    "exatpay.gq",
    "exatpay.ml",
    "exatpay.tk",
    "exbcgj.rest",
    "exboag.us",
    "exbte.com",
    "exbts.com",
    "excavateljb.email",
    "excavationmoon.xyz",
    "excavatorhydrostaticpumps.biz",
    "excavatorpumpparts.info",
    "excavatorpumps.biz",
    "exceedexpose.us",
    "exceedlaw.buzz",
    "exceedproducts.club",
    "excel-biz.ru",
    "excel-guru.ru",
    "excel-master.ru",
    "excel-seminar.ru",
    "exceleste.online",
    "excellencance.xyz",
    "excellencery.online",
    "excellent-supporting.com",
    "excellentpro.ru",
    "excelta.us",
    "exceptionance.xyz",
    "excersisedaystas.xyz",
    "exchange-wallet.info",
    "excho.ru",
    "excipientadvisor.com",
    "excipientbook.com",
    "excipientnet.com",
    "excipientnetwork.com",
    "excipientregister.com",
    "excipientsadvisor.com",
    "excipientshome.com",
    "excipientstrade.com",
    "excipientswiki.com",
    "excipientwiki.com",
    "excisemanship.best",
    "excite.co.jp",
    "excite.co.uk",
    "excite.com",
    "excite.it",
    "excitedchat.com",
    "excitingz.club",
    "exclusivemail.co.za",
    "exclusivetravels.ru",
    "excursionista.ru",
    "excursionshop.ru",
    "exdocor.ml",
    "exdocor.tk",
    "execnursetech.com",
    "execs.com",
    "execs2k.com",
    "executive-protection.org",
    "executive.co.za",
    "executive.name",
    "executiveleadershipsummit.com",
    "executivelounge.media",
    "executivemail.co.za",
    "executjcjh.bar",
    "execuzio.xyz",
    "exelica.com",
    "exemail.com.au",
    "exemptchildprefer.website",
    "exent.global",
    "exent.melbourne",
    "exent.online",
    "exent.sydney",
    "exentv1.com",
    "exercio.online",
    "exercisechain.com",
    "exerdi.cf",
    "exerdi.ga",
    "exerdi.ml",
    "exerdi.tk",
    "exergaming.academy",
    "exf5iqst87.icu",
    "exfactor.com",
    "exfcui.rest",
    "exg6.exghost.com",
    "exhesi.ga",
    "exhesi.gq",
    "exhesi.ml",
    "exi.kr",
    "exi8tlxuyrbyif5.cf",
    "exi8tlxuyrbyif5.ga",
    "exi8tlxuyrbyif5.gq",
    "exi8tlxuyrbyif5.ml",
    "exile-rp.xyz",
    "exileslime.buzz",
    "exiq0air0ndsqbx2.cf",
    "exiq0air0ndsqbx2.ga",
    "exiq0air0ndsqbx2.ml",
    "existiert.net",
    "exisys.com",
    "exitlag.ru",
    "exitstageleft.net",
    "exkiyx.xyz",
    "exmichaled.tk",
    "exmoordistillery.com",
    "exmooroajn.space",
    "exmx.icu",
    "exneta.ga",
    "exneta.gq",
    "exneta.ml",
    "exnhxagu.site",
    "exo6s.site",
    "exocmet.cf",
    "exocmet.ga",
    "exocmet.gq",
    "exocmet.ml",
    "exocmet.tk",
    "exolozinium.ru",
    "exoly.com",
    "exoticcoupons.com",
    "exovel.ga",
    "exovel.gq",
    "exovel.ml",
    "expandcode.com",
    "expansioncharm.com",
    "expansivehr.com",
    "expanstbrn.space",
    "expatjourney.app",
    "expatjourney.world",
    "expatmama.net",
    "expectationsmusic.com",
    "expeditionunderdog.com",
    "expensa.com",
    "experianprotect.com",
    "experiencenormandy.com",
    "experimentaljetset.xyz",
    "experis-technology-solutions.com",
    "expert-a.ru",
    "expert-ufo.ru",
    "experthoney.com",
    "expertmanager.ru",
    "expertmarketinginfo.com",
    "expirebox.com",
    "expirebox.email",
    "expirebox.me",
    "expirebox.net",
    "expirebox.org",
    "expl0rer.cf",
    "expl0rer.ga",
    "expl0rer.gq",
    "expl0rer.ml",
    "expl0rer.tk",
    "explicitgamer.com",
    "explicitnwg.email",
    "explodemail.com",
    "explorandoorlando.com",
    "explorativeeng.com",
    "exploredcmetro.com",
    "exploreonlinecolleges.com",
    "exploresplit.com",
    "explosin.online",
    "explosivecandy.com",
    "expo2020.media",
    "expo2021dubai.media",
    "expobids.info",
    "expos3d.com",
    "exposifood.com",
    "expotavrida.ru",
    "expresgrup.com",
    "express-date-having-else.xyz",
    "express-mvr.com",
    "express-souq.website",
    "express.net.ua",
    "express1040.space",
    "expressambalaj.com",
    "expressambalaj.online",
    "expressambalaj.xyz",
    "expressasia.com",
    "expressbahiscasino.xyz",
    "expressbest.ru",
    "expresscashcanada.com",
    "expressmedtransportation.com",
    "expressnote.press",
    "expressyourselfceramics.com",
    "expreswin42.com",
    "expreswin77.com",
    "expwebdesign.com",
    "exrelay.app",
    "exrutor.site",
    "exserver.top",
    "exsyde.com",
    "ext-where-is-the-panel.info",
    "extafas.gq",
    "extafas.ml",
    "extanewsmi.zzux.com",
    "extels.ru",
    "extenda.net",
    "extended.com",
    "extendmale.com",
    "extendswindows.com",
    "extgeo.com",
    "extic.com",
    "extinheck.ga",
    "extinheck.ml",
    "extinheck.tk",
    "extra.oscarr.nl",
    "extraaaa.tk",
    "extraaaa2.ga",
    "extraaaa2.tk",
    "extraam.loan",
    "extraguide.site",
    "extraguides.site",
    "extramama.ru",
    "extramanual.site",
    "extramanuals.site",
    "extraprofit.ru",
    "extrarole.com",
    "extraterretstrial.store",
    "extravangantlyloved.life",
    "extremail.ru",
    "extremedown.ninja",
    "extremeeasy.com",
    "extremeideasnow.info",
    "extry.org",
    "exttract.email",
    "extureme.com",
    "exwta.us",
    "exxale.shop",
    "exxon-mobil.tk",
    "exxoncars.com",
    "exxx.club",
    "eyandex.ru",
    "eyaok1.us",
    "eybnmgbd.shop",
    "eybtjr.us",
    "eyecaredoctors.net",
    "eyecaremangement.net",
    "eyeemail.com",
    "eyelashextensionsinottawa.com",
    "eyelashinottawa.com",
    "eyepain.org",
    "eyepaste.com",
    "eyepatchesforboys.com",
    "eyesandfruitloops.com",
    "eyespains.info",
    "eyesshop.live",
    "eylulbasimevi.com",
    "eym69.com",
    "eym69.me",
    "eyou.com",
    "eyqkwn.info",
    "eyso.de",
    "eytnpggb.xyz",
    "eyusedf.shop",
    "eywa-stroy.ru",
    "eywheywi.shop",
    "eyx4g9.com",
    "eyyvuguo.shop",
    "ez.lv",
    "ez2zc.com",
    "ezagenda.com",
    "ezbatteryconditioning.com",
    "ezbetlive.com",
    "ezcybersearch.com",
    "ezdato.com",
    "ezeble.site",
    "ezehe.com",
    "ezekush.com",
    "ezentreeslt.com",
    "ezetpar.cf",
    "ezetpar.ga",
    "ezetpar.tk",
    "ezfill.club",
    "ezfill.com",
    "ezico.loan",
    "ezinmj.us",
    "ezisource.com",
    "ezlearningcourses.com",
    "ezlk0.info",
    "ezlo.co",
    "ezmaexprees.com",
    "ezmail.egine.com",
    "ezmail.ru",
    "ezmail.top",
    "ezmine.online",
    "eznul.live",
    "ezoworld.info",
    "ezpackandpost.com",
    "ezprice.co",
    "ezprvcxickyq.cf",
    "ezprvcxickyq.ga",
    "ezprvcxickyq.gq",
    "ezprvcxickyq.ml",
    "ezprvcxickyq.tk",
    "ezpulse.com",
    "ezralandry.com",
    "ezriderairshocks.com",
    "ezrs.com",
    "ezsi.email",
    "ezskoolz.com",
    "ezstest.com",
    "ezvsmk.tk",
    "ezweb.ne.jp",
    "ezy.net",
    "ezyscholarships.com",
    "ezz.bid",
    "f-ckjack.com",
    "f-itnes.com",
    "f-look.ru",
    "f-m.fm",
    "f-nacarisk.ru",
    "f-neyrosystem.ru",
    "f-oproz.ru",
    "f-response.net",
    "f-response.org",
    "f-unicorn.com",
    "f.bgsaddrmwn.me",
    "f.moza.pl",
    "f00d-network.com",
    "f0ae7.club",
    "f0k4vk.us",
    "f0nbot.us",
    "f1775.com",
    "f18yqi.info",
    "f1batt.com",
    "f1batteries.com",
    "f1betiran.net",
    "f1betiran.org",
    "f1drivers.com",
    "f1fan.xyz",
    "f1fans.net",
    "f1kzc0d3.cf",
    "f1kzc0d3.ga",
    "f1kzc0d3.gq",
    "f1kzc0d3.ml",
    "f1kzc0d3.tk",
    "f1mohsc5r17tuv8.xyz",
    "f1pt.com",
    "f1s4rr.us",
    "f1ty6b.site",
    "f1wr04.us",
    "f2bcasino.info",
    "f2bcasino.net",
    "f2bcasino.org",
    "f2dtransfer10.com",
    "f2ht.us",
    "f2i.ru",
    "f2ksirhlrgdkvwa.cf",
    "f2ksirhlrgdkvwa.ga",
    "f2ksirhlrgdkvwa.gq",
    "f2ksirhlrgdkvwa.ml",
    "f2ksirhlrgdkvwa.tk",
    "f2movies.club",
    "f2movies.fun",
    "f2movies.online",
    "f2movies.xyz",
    "f301.com",
    "f31dc8.info",
    "f342.club",
    "f39mltl5qyhyfx.cf",
    "f39mltl5qyhyfx.ga",
    "f39mltl5qyhyfx.gq",
    "f39mltl5qyhyfx.ml",
    "f3a2kpufnyxgau2kd.cf",
    "f3a2kpufnyxgau2kd.ga",
    "f3a2kpufnyxgau2kd.gq",
    "f3a2kpufnyxgau2kd.ml",
    "f3a2kpufnyxgau2kd.tk",
    "f3c1jl.online",
    "f3r2x5.com",
    "f3wv61.us",
    "f4445.com",
    "f44el.site",
    "f499a.club",
    "f49e4ad.xyz",
    "f4af545634b4a6ae0c.xyz",
    "f4i20j.casa",
    "f4k.es",
    "f5.si",
    "f538.xyz",
    "f53tuxm9btcr.cf",
    "f53tuxm9btcr.ga",
    "f53tuxm9btcr.gq",
    "f53tuxm9btcr.ml",
    "f53tuxm9btcr.tk",
    "f5brmn.us",
    "f5cb9.site",
    "f5d0b.club",
    "f5f6a.xyz",
    "f5foster.com",
    "f5tv.site",
    "f5u3m.top",
    "f5xzer.site",
    "f64kn.site",
    "f64uf.com",
    "f691.club",
    "f6g2w9.accountant",
    "f6kbl.cloud",
    "f6vexe.us",
    "f6w0tu0skwdz.cf",
    "f6w0tu0skwdz.ga",
    "f6w0tu0skwdz.gq",
    "f6w0tu0skwdz.ml",
    "f6w0tu0skwdz.tk",
    "f7e6.xyz",
    "f7qmww.online",
    "f7scene.com",
    "f81tl.site",
    "f843de1a.xyz",
    "f8r1ux.site",
    "f8x1eb.us",
    "f9094.com",
    "f9164.club",
    "f921935.xyz",
    "f97vfopz932slpak.cf",
    "f97vfopz932slpak.ga",
    "f97vfopz932slpak.gq",
    "f97vfopz932slpak.ml",
    "f97vfopz932slpak.tk",
    "f9827.com",
    "f9c3df.club",
    "f9ut7.icu",
    "fa38.club",
    "fa416.site",
    "fa452.xyz",
    "fa4pmz.us",
    "faa-certification.com",
    "faaakb000ktai.ga",
    "faacertificateofwaiver.com",
    "faadictionary.com",
    "faadronewaiver.com",
    "faaliyetim.xyz",
    "faan.de",
    "faatest.info",
    "faatest.net",
    "faawaiver.info",
    "faawaiver.net",
    "fabaporter.com",
    "fabfabhome.com",
    "fabianschlaepfer.com",
    "fabnicalsa.tk",
    "fabricrebublic.store",
    "fabrum.ru",
    "fabstract.org",
    "fabu11.site",
    "fabulouslifestyle.tips",
    "face-club.website",
    "face-tamtam.site",
    "face2face-cafe.site",
    "facebaby.life",
    "facebook-adult.com",
    "facebook-arenda.ru",
    "facebook-email.cf",
    "facebook-email.ga",
    "facebook-email.ml",
    "facebook.com",
    "facebook199.xyz",
    "facebookmail.com",
    "facebookmail.gq",
    "facebookmail.ml",
    "facedropship.com",
    "facemaskbox.com",
    "facenewsk.fun",
    "faceplacefoto.com",
    "facepook.ru",
    "facerodate.fun",
    "facestate.com",
    "facetlabs.net",
    "facewaka.site",
    "facialboook.site",
    "facilesend.com",
    "facilityservices24.de",
    "fackme.gq",
    "facpidif.ga",
    "facpidif.gq",
    "facpidif.ml",
    "factnotfiction.org",
    "factorizalo.com",
    "factorlibidox.icu",
    "factory-action-hit.space",
    "factoryfutsal.com",
    "factoryhealth.website",
    "factorypeople.com",
    "factsabouteverything.org",
    "factsandtops.ru",
    "factsofturkey.net",
    "factume.shop",
    "facturecolombia.info",
    "factuur.org",
    "factwalk.com",
    "faculdade.global",
    "facy-jp.com",
    "fada6868.com",
    "fades-sad.ru",
    "fadingemail.com",
    "fadingemails.com",
    "fadluna.com",
    "fadrasha.net",
    "fadrasha.org",
    "fadve.ru",
    "faecesmail.me",
    "faer.oazis.site",
    "faer2.oazis.site",
    "faer3.oazis.site",
    "faer5.oazis.site",
    "faeress.ru",
    "faerynicethings.info",
    "faerynicethings.net",
    "faerynicethings.org",
    "faes-dev1.info",
    "faesdev1.host",
    "faesiher.cf",
    "faesiher.ga",
    "faesiher.tk",
    "fag.wf",
    "fagbxy1iioa3ue.cf",
    "fagbxy1iioa3ue.ga",
    "fagbxy1iioa3ue.gq",
    "fagbxy1iioa3ue.ml",
    "fagbxy1iioa3ue.tk",
    "fagkn.live",
    "fahad-tamimi.info",
    "fahastores.site",
    "fahmi-amirudin.tech",
    "fahr-zur-hoelle.org",
    "fahutanpraise.website",
    "faicarde.cf",
    "faicarde.ga",
    "faicarde.gq",
    "faicarde.ml",
    "faicarde.tk",
    "faiencaqkw.space",
    "failbone.com",
    "failgifs.com",
    "failinga.nl",
    "failoftheweek.com",
    "failoftheweek.net",
    "failoftheyear.com",
    "failure.zone",
    "failureoftheday.com",
    "failureoftheweek.com",
    "faiphoge.cf",
    "faiphoge.gq",
    "faiphoge.ml",
    "faiphoge.tk",
    "fair-tour.ru",
    "fairchildsystems.com",
    "fairdealing.org",
    "fairfaxbracesdoctor.com",
    "fairmontzimbalilodge.com",
    "fairocketsmail.com",
    "fairprice.house",
    "fairwammqi.space",
    "fairylig.xyz",
    "fairynicethings.net",
    "faisalnabulsi.com",
    "faispechab.cf",
    "faispechab.ml",
    "faithbox.email",
    "faithbox.us",
    "faithecchurch.org",
    "faithkills.com",
    "faithkills.org",
    "faithmountainbaptist.net",
    "faithq.org",
    "faithrelegateframe.site",
    "faizsizaraba.com",
    "faizsizev.net",
    "fajarqq.org",
    "fajeras.design",
    "fake-box.com",
    "fake-email.pp.ua",
    "fake-mail.cf",
    "fake-mail.ga",
    "fake-mail.gq",
    "fake-mail.live",
    "fake-mail.ml",
    "fake-mail.tk",
    "fake.goodge.ca",
    "fake.i-3gk.cf",
    "fake.i-3gk.ga",
    "fake.i-3gk.gq",
    "fake.i-3gk.ml",
    "fakecallapp.com",
    "fakedemail.com",
    "fakeemail.de",
    "fakeemail.tk",
    "fakeinbox.cf",
    "fakeinbox.com",
    "fakeinbox.ga",
    "fakeinbox.info",
    "fakeinbox.ml",
    "fakeinbox.tk",
    "fakeinformation.com",
    "fakemail.fr",
    "fakemail.win",
    "fakemailgenerator.com",
    "fakemailgenerator.net",
    "fakemails.cf",
    "fakemails.ga",
    "fakemails.gq",
    "fakemails.ml",
    "fakemailz.com",
    "fakemyinbox.cf",
    "fakemyinbox.com",
    "fakemyinbox.ga",
    "fakemyinbox.gq",
    "fakemyinbox.ml",
    "fakesatiricfeud.website",
    "faketemp.email",
    "fakewings.com",
    "fakher.dev",
    "fakima.com",
    "fakiralio.ga",
    "fakiralio.ml",
    "faktionlabs.com",
    "fakyah.ga",
    "fakyah.ml",
    "falcer.xyz",
    "falconcapital.investments",
    "falconheavylaunch.net",
    "fald.dk",
    "falffers.com",
    "falguckpet.tk",
    "fallmt2.com",
    "fallog.com",
    "fallschurchdentalwellnesscenter.com",
    "fallschurchshowerglass.com",
    "fallsforyou.com",
    "fallstyleforu.com",
    "falmeto.cf",
    "falmeto.ga",
    "falmeto.gq",
    "falmeto.ml",
    "falmeto.tk",
    "falove.com",
    "falrxnryfqio.cf",
    "falrxnryfqio.ga",
    "falrxnryfqio.gq",
    "falrxnryfqio.ml",
    "falrxnryfqio.tk",
    "falseaddress.com",
    "famail.win",
    "famalsa.cf",
    "famalsa.gq",
    "famalsa.ml",
    "famalsa.tk",
    "famemma.net",
    "famenyc.org",
    "familia-forum.ru",
    "familiashop.ru",
    "familiekersten.tk",
    "familienhomepage.de",
    "family-class.ru",
    "family-medical.website",
    "familyandlife.ru",
    "familycreeps.com",
    "familyfive.ru",
    "familyhomesecurity.com",
    "familyindependent.com",
    "familyprqs.club",
    "familyprqs.host",
    "familysavingsz.com",
    "familytoday.us",
    "fammix.com",
    "famoustwitter.com",
    "famsend.com",
    "fan.com",
    "fan.theboys.com",
    "fanabulous.page",
    "fanack.info",
    "fanatxclub.com",
    "fanbasic.org",
    "fancinematoday.com",
    "fancung.com",
    "fancung.net",
    "fancung.org",
    "fancy-tapes.com",
    "fancygee.xyz",
    "fandastico.com",
    "fandaygames.com",
    "fandemic.co",
    "fanemone.com",
    "fangchemao.com",
    "fangdaige.com",
    "fangdrooperver.ru",
    "fangeradelman.com",
    "fangfoundry.com",
    "fanghuayuanyule.com",
    "fangoh.com",
    "fangsustri.cf",
    "fangsustri.gq",
    "fangsustri.ml",
    "fanhaodaquan.xyz",
    "fanlogs.com",
    "fanmonero.dns.navy",
    "fannclub.com",
    "fannny.cf",
    "fannny.ga",
    "fannny.gq",
    "fannny.ml",
    "fanonne.ru",
    "fanow1.site",
    "fanpagenews.com",
    "fanpoush.com",
    "fanpoush.net",
    "fanrecognition.com",
    "fansgrid.net",
    "fansgrid.org",
    "fansonlymail.com",
    "fansub.us",
    "fansubgroup.com",
    "fansworldwide.de",
    "fanta24.com",
    "fantalk.ru",
    "fantaseri.ru",
    "fantask.online",
    "fantasque.best",
    "fantasticmail.com",
    "fantastictask.info",
    "fantastictask.org",
    "fantastictasks.org",
    "fantastictees.us",
    "fantasyfootballhacks.com",
    "fantasyhatch.com",
    "fantasymail.de",
    "fantasyri.ru",
    "fantelu7.com",
    "fanters.site",
    "fantoma.best",
    "fanzer.com",
    "fanzuku.com",
    "fap.buzz",
    "fapestore.site",
    "fapeta.info",
    "fapfiction.com",
    "fapfiction.net",
    "fapfiction.org",
    "fapfl1.us",
    "faphd.pro",
    "fapinghd.com",
    "fapvideo.pro",
    "fapxxx.pro",
    "faqewebvizional.website",
    "far-king.com",
    "far51.website",
    "farang.net",
    "farbar.site",
    "farebooking.online",
    "faremart.website",
    "faremzon.com",
    "farendear.com",
    "farenga.fun",
    "farewelltothee.com",
    "farfrontier.net",
    "farfurmail.tk",
    "farifluset.mailexpire.com",
    "farijagiratikamiki10.ru",
    "farimusicgroup.com",
    "farinut.club",
    "farkhi5oiy.com",
    "farma-shop24.com",
    "farmacialoreto.shop",
    "farmasine.online",
    "farmaz.space",
    "farmbotics.com",
    "farmbotics.net",
    "farmdeu.com",
    "farmerlife.us",
    "farmersdictionary.com",
    "farmerstrader.adult",
    "farmingdictionary.com",
    "farmingglossary.com",
    "farmisa.info",
    "farmphuel.com",
    "farmsteadwines.com",
    "farmtoday.us",
    "farn0n.us",
    "farolillos.online",
    "faroweb.com",
    "farr40.ru",
    "farrse.co.uk",
    "farsbet.net",
    "farsionebet.info",
    "farsionebet.org",
    "fartbet.ru",
    "fartcasino1.fun",
    "fartcazino.fun",
    "farteam.ru",
    "fartovoe1.fun",
    "fartwallet.com",
    "fasciaklinikerna.se",
    "fasciaspa.com",
    "fascinery.com",
    "fasf-wf-stsd01.xyz",
    "fashionbeauty.website",
    "fashionbets13.com",
    "fashionbets14.com",
    "fashionbets18.com",
    "fashionbets2.com",
    "fashionbets24.com",
    "fashionbets26.com",
    "fashionbets3.com",
    "fashionbets30.com",
    "fashionbets32.com",
    "fashionbets34.com",
    "fashionbets4.com",
    "fashionbettv10.com",
    "fashionbettv3.com",
    "fashionelect.com",
    "fashionfwd.net",
    "fashionlibrary.online",
    "fashionplugfans.ru",
    "fashionplugnews.ru",
    "fashionqq59.xyz",
    "fashionsealhealthcareuniforms.net",
    "fashionstresser.online",
    "fashionstudios.ru",
    "fashiontips.net",
    "fashionturktv.com",
    "fashionturktv.info",
    "fashionturktv.org",
    "fask1300.info",
    "faspoto.ga",
    "faspoto.ml",
    "fassagforpresident.ga",
    "fast-coin.com",
    "fast-email.com",
    "fast-email.info",
    "fast-mail.fr",
    "fast-mail.one",
    "fast-mail.org",
    "fast-mart-like.space",
    "fast1688.com",
    "fast2bet.asia",
    "fastacura.com",
    "fastair.info",
    "fastboattolembongan.com",
    "fastcashohhomes.com",
    "fastcashorhomes.com",
    "fastcashwahomes.com",
    "fastchevy.com",
    "fastchrysler.com",
    "fasteacher.com",
    "fastedates.ru",
    "fastem.com",
    "fastemail.us",
    "fastemailer.com",
    "fastemailextractor.net",
    "fastemails.us",
    "fasterino.ru",
    "fastermail.com",
    "fasternet.biz",
    "fastest.cc",
    "fastestpurchase.com",
    "fastfilemover.com",
    "fastfoodlife.com",
    "fastfords.co.uk",
    "fastfwd.dev",
    "fastgrowthpodcast.com",
    "fastighetsmaklarenerja.com",
    "fastimap.com",
    "fastinfra.net",
    "fastkawasaki.com",
    "fastleads.in",
    "fastlottery.net",
    "fastmail.ca",
    "fastmail.cn",
    "fastmail.co.uk",
    "fastmail.com",
    "fastmail.com.au",
    "fastmail.es",
    "fastmail.fm",
    "fastmail.gr",
    "fastmail.im",
    "fastmail.in",
    "fastmail.jp",
    "fastmail.mx",
    "fastmail.net",
    "fastmail.nl",
    "fastmail.se",
    "fastmail.to",
    "fastmail.tw",
    "fastmail.us",
    "fastmailbox.net",
    "fastmailforyou.net",
    "fastmailnow.com",
    "fastmazda.com",
    "fastmeetup.site",
    "fastmessaging.com",
    "fastmitsubishi.com",
    "fastmoney.pro",
    "fastmsg.us",
    "fastnissan.com",
    "fastnotify.press",
    "fastpass.com",
    "fastpolin.cf",
    "fastseller.icu",
    "fastserna.cf",
    "fastserna.gq",
    "fastservice.com",
    "fastshippingrus.com",
    "fastshippingweed.com",
    "fastspacea.ru",
    "fastsubaru.com",
    "fastsurf.com",
    "fastsuzuki.com",
    "fasttoyota.com",
    "fastupgrade.website",
    "fastwebmail.it",
    "fastwebnet.it",
    "fastxxx.site",
    "fasty.site",
    "fasty.xyz",
    "fastyamaha.com",
    "fat-buddha-tallaght-village.com",
    "fat-larrys-athlone.com",
    "fata2b.site",
    "fatalorbit.com",
    "fatbelly-cork.com",
    "fatboyschippy.com",
    "fatcock.net",
    "fateh-kimouche.net",
    "fatehkimouche.biz",
    "fatehkimouche.org",
    "fatetiz.ru",
    "fatfinger.co",
    "fatflap.com",
    "fathersrightsne.org",
    "fathir.cf",
    "fathoni.info",
    "fatjukebox.com",
    "fatk2b.site",
    "fatnbald.com",
    "fattahkus.app",
    "fatter.cat",
    "fatty.run",
    "fatum.info",
    "fatwhs.us",
    "fatyachts.com",
    "faucetpay.ru",
    "faultbaselinefrock.site",
    "fauna1flora.ru",
    "favfav.com",
    "favo360.com",
    "favochat.com",
    "favochat.net",
    "favorbag.site",
    "favoribahis.org",
    "favoribahis79.com",
    "favoribahis99.com",
    "favorite-number.com",
    "favoriticket.com",
    "favouritefriedchicken.com",
    "fawem-ridnga.ru",
    "fawiwasi.site",
    "fawr-danas.ru",
    "fawwaz.cf",
    "fawwaz.ga",
    "fawwaz.gq",
    "fawwaz.ml",
    "fax.dix.asia",
    "fax.ru",
    "faxarounddos.website",
    "faxbet2.com",
    "faxbet3.com",
    "faxbet30.com",
    "faxbet34.com",
    "faxbet35.com",
    "faxjet.com",
    "fayd13b.site",
    "fayd14b.site",
    "fayesilag.com",
    "fayiman.com",
    "faze.biz",
    "fazeclan.space",
    "fazipic.site",
    "faziti.info",
    "fazpaso.ru",
    "fb2obd.com",
    "fb53c2.club",
    "fb8753.site",
    "fbceminence.org",
    "fbd37.space",
    "fbdata.ru",
    "fbeaveraqb.com",
    "fbender.ml",
    "fbf24.de",
    "fbfriendbb.site",
    "fbfriendtq.site",
    "fbi-agent.com",
    "fbi.coms.hk",
    "fbi.hu",
    "fbjs15.com",
    "fblike.app",
    "fbma.tk",
    "fbmail.usa.cc",
    "fbmail1.ml",
    "fbooktracking.info",
    "fbooktracking.online",
    "fbpintl.asia",
    "fbpubi.com",
    "fbq4diavo0xs.cf",
    "fbq4diavo0xs.ga",
    "fbq4diavo0xs.gq",
    "fbq4diavo0xs.ml",
    "fbq4diavo0xs.tk",
    "fbr20.xyz",
    "fbr24.xyz",
    "fbr26.xyz",
    "fbr27.xyz",
    "fbrfj.live",
    "fbs-afiliasi.com",
    "fbsaffiliate.com",
    "fbseu.finance",
    "fbseu.financial",
    "fbseu.link",
    "fbsh.org",
    "fbsturkiye.com",
    "fbsukien2019.com",
    "fbv89.us",
    "fbvyb.us",
    "fc01a.xyz",
    "fc66998.com",
    "fc69e.xyz",
    "fca-nv.cf",
    "fca-nv.ga",
    "fca-nv.gq",
    "fca-nv.ml",
    "fca-nv.tk",
    "fca3nh.us",
    "fcamerapeak.info",
    "fcc.net",
    "fcccanton.org",
    "fcf6.xyz",
    "fcgfdsts.ga",
    "fchgvj.site",
    "fchina.net",
    "fchn2b.site",
    "fchs.network",
    "fcinter.info",
    "fcit.de",
    "fcka.email",
    "fckingnomad.se",
    "fckrylatskoe2000.ru",
    "fckxmu.us",
    "fcml.mx",
    "fcn08.space",
    "fcna3b.site",
    "fcna5b.site",
    "fcq82r.us",
    "fcqddz.rest",
    "fcrpg.org",
    "fctemp.top",
    "fcucfzg.site",
    "fd99nhm5l4lsk.cf",
    "fd99nhm5l4lsk.ga",
    "fd99nhm5l4lsk.gq",
    "fd99nhm5l4lsk.ml",
    "fd99nhm5l4lsk.tk",
    "fdata004.live",
    "fdata009.live",
    "fddeutschb.com",
    "fddns.ml",
    "fderf.com",
    "fdfdsfds.com",
    "fdffdffd.tk",
    "fdgdfgdfgf.ml",
    "fdgh5rb.online",
    "fdmuov.com",
    "fdniw.live",
    "fdrsdp.com",
    "fdstlm.us",
    "fdtle8.us",
    "fdtn.email",
    "fdxglo.info",
    "fdze1mdi.rocks",
    "fdzs.info",
    "fe-pj.com",
    "fe26.club",
    "fe325.com",
    "fea.st",
    "feadutalca.tk",
    "feaethplrsmel.cf",
    "feaethplrsmel.ga",
    "feaethplrsmel.gq",
    "feaethplrsmel.ml",
    "feaethplrsmel.tk",
    "feamail.com",
    "feanfilms.ru",
    "feartoclear.app",
    "featsure.com",
    "featuredyacht.club",
    "feaubl.us",
    "febbraio.cf",
    "febbraio.gq",
    "febrararas.net",
    "feceso.online",
    "fechl.com",
    "fectsrelam.cf",
    "fectsrelam.gq",
    "feculent.xyz",
    "federalcontractors.com",
    "federalemployeeconsultant.com",
    "federalflaws.com",
    "federalwayautorepair.com",
    "fedfaiz.com",
    "fedfaizorani.com",
    "fedfaizoranikarari.com",
    "fedghwpa.shop",
    "fedrw.org",
    "fedt.dk",
    "fedupe.com",
    "feeblily.xyz",
    "feecoins.com",
    "feedback60.website",
    "feedbackads.com",
    "feedbackadvantage.com",
    "feedbackadvertising.com",
    "feedbackadvertising.org",
    "feedbackvase.com",
    "feedblade.com",
    "feeder-club.ru",
    "feedinghungrykids.org",
    "feedmob.org",
    "feedmycloud.info",
    "feedthezombiechildren.org",
    "feeloaders.com",
    "feelogfd.xyz",
    "feesearac.cf",
    "feesearac.ga",
    "feesearac.ml",
    "feestoverpass.buzz",
    "feeteves.com",
    "feibet.com",
    "feic.icu",
    "feieda.com",
    "feifan123.com",
    "feifeijiasuqi.org",
    "feignbloc.xyz",
    "feignlarg.xyz",
    "feignmedal.recipes",
    "feikamjue.cf",
    "feikamjue.ml",
    "feilongyule.net",
    "feinripptraeger.de",
    "feirujlingnad.tk",
    "feizhailol.xyz",
    "fekcasinocrow.ru",
    "fekemanko.rocks",
    "fela.site",
    "felcromatizma.com",
    "feleohe.com",
    "felesteen.net",
    "felhler.best",
    "felhonetwork.space",
    "feliciapressdepot.com",
    "felicity.com",
    "felicitymail.com",
    "felinibrand.com",
    "felipealmeyda.ga",
    "felixbaby.net",
    "felixscent.com",
    "felizpago.com",
    "feljackpun.cf",
    "feljackpun.ml",
    "feljackpun.tk",
    "fellow-me.pw",
    "fellowme.pw",
    "felmoca.best",
    "felmondas.info",
    "felpega.cf",
    "felpega.tk",
    "feltutorscan.gq",
    "fema.email",
    "femailtor.com",
    "female.ru",
    "femaleprofiles.com",
    "femaleviagra100.com",
    "femalexl.site",
    "femenino.com",
    "feminatup.net",
    "feminin.dk",
    "feminineembodimentcourse.com",
    "femininestyle.ru",
    "feminism.app",
    "feminosent.net",
    "feminyx.biz",
    "femme-dresses.ru",
    "fenceessa.xyz",
    "fencemeup.net",
    "fenceshe.icu",
    "fenceve.com",
    "fenda.us",
    "fenesitz.cf",
    "fenesitz.gq",
    "fenesitz.ml",
    "fenesitz.tk",
    "fengli4.com",
    "fengli5.com",
    "fengli8.com",
    "fengli9.com",
    "fengyunzaqi.xyz",
    "fenix-band.online",
    "fenomen.net",
    "fenwazi.com",
    "feoeha.rest",
    "fepalh.com",
    "fepg.net",
    "feqiba.info",
    "fer-gabon.org",
    "ferastya.cf",
    "ferastya.ga",
    "ferastya.gq",
    "ferastya.ml",
    "ferastya.tk",
    "fereycorp.com",
    "ferial.site",
    "feridunyilmazlar.xyz",
    "ferins.xyz",
    "ferm-kinder.ru",
    "ferma-lambertov.ru",
    "fermathadaproof.com",
    "fermaxxi.ru",
    "fermaxxl.ru",
    "fermer1.ru",
    "fern2b.site",
    "fernandogrillo.net",
    "fernblade.com",
    "feroxhosting.online",
    "feroxhosting.shop",
    "ferraletrx.com",
    "ferrdechi.cf",
    "ferrdechi.gq",
    "ferrdechi.ml",
    "ferrdechi.tk",
    "ferrexalostoc-online.com",
    "ferringfamily.com",
    "ferrydr.icu",
    "ferryswor.com",
    "fertigschleifen.de",
    "fertilityapp.com",
    "fertilityplanit.net",
    "fertilization488zh.online",
    "fertilizing991jp.online",
    "ferton.com",
    "fervip999.xyz",
    "ferzplaybar.ru",
    "festetics.org",
    "festie.net",
    "festivalofpensions.com",
    "festtycon.ga",
    "festtycon.gq",
    "festtycon.ml",
    "festtycon.tk",
    "fetch-an-in-jobs-in-ca.fyi",
    "fetch-in-jobs-in-ca.fyi",
    "fetchbarry.com",
    "fetchmail.co.uk",
    "fetchmail.com",
    "fetchnet.co.uk",
    "fethiyecruises.com",
    "fethiyedeyim.xyz",
    "fetih1453istanbul.xyz",
    "feto.site",
    "fettabernett.de",
    "fettol.info",
    "fettometern.com",
    "fetzhosi.cf",
    "fetzhosi.gq",
    "feudalist.best",
    "feuerlauf-deutschland.com",
    "fever.camera",
    "feverboard.com",
    "fevercamera.shop",
    "fevercameras.shop",
    "feverche.xyz",
    "feverdetection.camera",
    "feverdetectioncamera.shop",
    "feverout.xyz",
    "fevkuulb.shop",
    "fevziuzun.com",
    "fewminor.men",
    "fexa.site",
    "feyenoorder.com",
    "feyerhermt.ws",
    "ff-flow.com",
    "ff-stickers.website",
    "ff16222.com",
    "ff18269.com",
    "ff9ee.xyz",
    "ffamilyaa.com",
    "ffanet.com",
    "ffctfcts.xyz",
    "ffeedzonea.site",
    "fff062.com",
    "fff813.com",
    "ffgoodfoodeco.xyz",
    "ffjweosyoljm001.com",
    "fflipsharee.site",
    "ffmovies.su",
    "ffoffer.com",
    "fforeffort.info",
    "fft-mail.com",
    "fftjxfxn.shop",
    "ffwebookun.com",
    "ffxw4i.site",
    "fg2cj7.us",
    "fgaqkx.rest",
    "fgbocp.us",
    "fgdg.de",
    "fgfg999.com",
    "fgfpnd.rest",
    "fggfqoim.shop",
    "fggjghkgjkgkgkghk.ml",
    "fghmail.net",
    "fgjnxcps.site",
    "fgmx.de",
    "fgohhn.host",
    "fgonki.ru",
    "fgopeat.com",
    "fgr20u.stream",
    "fgsd.de",
    "fgsoas.top",
    "fguncxc.com",
    "fgywvb.tokyo",
    "fhaloancalifornia.net",
    "fhapp55.com",
    "fhccc30.com",
    "fhccc32.com",
    "fhccc34.com",
    "fhccc37.com",
    "fhccc39.com",
    "fhccc41.com",
    "fhccc44.com",
    "fhccc45.com",
    "fhccc47.com",
    "fhccc49.com",
    "fhccc56.com",
    "fhccc59.com",
    "fhccc64.com",
    "fhccc66.com",
    "fhccc68.com",
    "fhccc70.com",
    "fhccc71.com",
    "fhccc74.com",
    "fhccc77.com",
    "fhccc79.com",
    "fhccc80.com",
    "fhccc81.com",
    "fhccc83.com",
    "fhccc86.com",
    "fhccc87.com",
    "fhccc89.com",
    "fhccc90.com",
    "fhccc94.com",
    "fhccc95.com",
    "fhccc97.com",
    "fhczy5.us",
    "fhfcmffub.shop",
    "fhgjlhwxv.shop",
    "fhhy66.com",
    "fhir.cloud",
    "fhjkh.host",
    "fhldj.live",
    "fhlij.us",
    "fhole.us",
    "fhrvm9.online",
    "fhtsystem.com",
    "fhuai.live",
    "fhvnzk.us",
    "fhvvbbvvbb.com",
    "fhvxkg2t.xyz",
    "fhylonline.com",
    "fhyve5.us",
    "fi-pdl.cf",
    "fi-pdl.ga",
    "fi-pdl.gq",
    "fi-pdl.ml",
    "fi-pdl.tk",
    "fi3k.icu",
    "fi5qy.us",
    "fiannaoshea.com",
    "fiastubof.cf",
    "fiastubof.gq",
    "fiastubof.ml",
    "fiastubof.tk",
    "fiat-brasil.club",
    "fiat-chrysler.cf",
    "fiat-chrysler.ga",
    "fiat-chrysler.gq",
    "fiat-chrysler.ml",
    "fiat-chrysler.tk",
    "fiat-india.club",
    "fiat-rs.ru",
    "fiat500.cf",
    "fiat500.ga",
    "fiat500.gq",
    "fiat500.ml",
    "fiat500.tk",
    "fiatcare.com",
    "fiatgroup.cf",
    "fiatgroup.ga",
    "fiatgroup.gq",
    "fiatgroup.ml",
    "fibered763aa.online",
    "fiberia.com",
    "fibermother.top",
    "fiberoptics4tn.com",
    "fibertel.com.ar",
    "fibram.tech",
    "fibredrama.com",
    "fibrelayer.com",
    "fibremarkupgland.site",
    "fibresp.icu",
    "fibrethe.xyz",
    "fibretr.xyz",
    "fibretrac.xyz",
    "fica.ga",
    "fica.gq",
    "fica.ml",
    "fica.tk",
    "fichet-lisboa.com",
    "fichetlisboa.com",
    "fichetservice.com",
    "ficken.de",
    "fickremis.gq",
    "fickremis.ml",
    "fickremis.tk",
    "fictional.group",
    "fictionalize112co.online",
    "fictionsite.com",
    "fid-x.net",
    "fidawines.com",
    "fidelio.best",
    "fidelium10.com",
    "fidellemusic.com",
    "fido.be",
    "fidxrecruiting.com",
    "fiechecklib.cf",
    "fiechecklib.ml",
    "fieldbredspaniel.com",
    "fieldcasinoopi.ru",
    "fieldfin.press",
    "fieldguideadvv.icu",
    "fieldleaf.com",
    "fieldopolis.com",
    "fieldriv.xyz",
    "fieldtheory.club",
    "fiemountaingems.com",
    "fierymeets.xyz",
    "fif55.company",
    "fifa555.biz",
    "fifa555x.com",
    "fifa55cen.name",
    "fifa55cen.tel",
    "fifa55credit.site",
    "fifa55credit.space",
    "fifa55credit.top",
    "fifa55credit.xyz",
    "fifa55nut.com",
    "fifa55pug.com",
    "fifa55rs.com",
    "fifa55w.net",
    "fifalottoasia.com",
    "fifalottoking.com",
    "fifalottou.com",
    "fifamain.com",
    "fificorp.com",
    "fificorp.net",
    "fifthdesign.com",
    "fifthleisure.com",
    "fifthminuteloan.com",
    "fiftyfootmedia.com",
    "figastand.site",
    "figgma.com",
    "fighpromol.cf",
    "fighpromol.gq",
    "fighpromol.ml",
    "fighpromol.tk",
    "fight-zorge.ru",
    "fightallspam.com",
    "fightbacknews.info",
    "fightbreach.top",
    "fightth.press",
    "figjs.com",
    "figlmueller-lugeck.com",
    "figly.net",
    "figmail.me",
    "figshot.com",
    "figueredo.info",
    "figurescoin.com",
    "fiheartly.ml",
    "fiheartly.tk",
    "fiifke.de",
    "fiiritsmini.tk",
    "fiix-lweracn.ru",
    "fika-lamfesa.ru",
    "fika.website",
    "fikachovlinks.ru",
    "fikada.com",
    "fiki1.site",
    "fikrihidayah.cf",
    "fikrihidayah.ga",
    "fikrihidayah.gq",
    "fikrihidayah.ml",
    "fikrihidayah.tk",
    "fikrinhdyh.cf",
    "fikrinhdyh.ga",
    "fikrinhdyh.gq",
    "fikrinhdyh.ml",
    "fikrinhdyh.tk",
    "fikstore.com",
    "filager.com",
    "filakhbar.com",
    "filbert4u.com",
    "filberts4u.com",
    "file-hipo.info",
    "file-rutor.org",
    "fileboutiques.site",
    "filebyter.com",
    "filecakefree.com",
    "fileconverterexpress.com",
    "filefugu.com",
    "filegrotto.com",
    "filemakertechniques.com",
    "filemark.com",
    "filerforma.site",
    "filerpost.xyz",
    "files-disk.org",
    "filespike.com",
    "filezilla.info",
    "filingsportal.com",
    "filipinolinks.com",
    "fillari.net",
    "fillersmedals.top",
    "fillyflair.info",
    "film-blog.biz",
    "film-online.xyz",
    "filmabin.com",
    "filmaticsvr.com",
    "filmbr.net",
    "filmesemcasa.site",
    "filmexxx.site",
    "filmflix.space",
    "filmfrancais2019.com",
    "filmifundey.xyz",
    "filmindo89.com",
    "filmlicious.club",
    "filmlicious.host",
    "filmlicious.online",
    "filmlicious.site",
    "filmlicious.xyz",
    "filmottola.com",
    "filmprenser.gq",
    "filmprenser.ml",
    "filmprenser.tk",
    "films-online-kino.ru",
    "filmscool.xyz",
    "filmsemi.mobi",
    "filmsfrombeyond.info",
    "filmsseller1.ru",
    "filmstreaming.cash",
    "filmsuggest.com",
    "filmtop10.com",
    "filmtupia.com",
    "filmvf.stream",
    "filmwedding.ru",
    "filmyonli.ru",
    "filmyou.org",
    "filmyzilla.network",
    "filomesh.ru",
    "filomoplace.ru",
    "filoppy.net",
    "filoppy.org",
    "filqmuu.site",
    "filsgg.ru",
    "filterr.com",
    "filtidysuqqpg.site",
    "filtracoms.info",
    "filtresizefes.com",
    "filzmail.com",
    "fimghkumv.shop",
    "fimoulchoi.ga",
    "fimoulchoi.gq",
    "fimoulchoi.ml",
    "fimoulchoi.tk",
    "fin-ans.ru",
    "fin-assistant.ru",
    "fin-guru.ru",
    "finaldes.com",
    "finaldraftmerchandise.com",
    "finaldraftsstore.com",
    "finalep.fun",
    "finalevil.com",
    "finalexpenseguru.com",
    "finalfinalfinal.com",
    "finalflu.xyz",
    "finalize595jg.online",
    "finaljewe.press",
    "finalpan.us",
    "finaltig.us",
    "finaltoo.us",
    "financas.online",
    "finance-simply.ru",
    "financeand.coffee",
    "financefan.net",
    "financegoldbling.com",
    "financehy.com",
    "financemagazinespot.com",
    "financemail.net",
    "financementor.ru",
    "financemoneyblog.club",
    "financeprosto.ru",
    "financetimes.tech",
    "financialabundance.org",
    "financialabundanceuniversity.com",
    "financialadvicescheme.org",
    "financialaid35.us",
    "financialaid39.us",
    "financialblog.club",
    "financialchannel.ru",
    "financialgerontology.com",
    "financialmarketsadvisor.com",
    "financialpublishingsystems.com",
    "financialsocietynews.club",
    "financier.com",
    "financnimagazin.com",
    "finans-disciplina.ru",
    "finans-edenitsa.ru",
    "finans-zapas.ru",
    "finansblogs.ru",
    "finansmobil.com",
    "finchsoftware.com",
    "find-brides.org",
    "find-new-cars-option.market",
    "find-new-ride-online.market",
    "find-suv-pricing-guides.rocks",
    "find-your-men10.com",
    "findacriminalrecord.com",
    "findafriendlynow.com",
    "findahomeonline.info",
    "findalawyerct.info",
    "findanopportunity.org",
    "findazey.space",
    "findbankrates.com",
    "findbetterwhatever.com",
    "findbrides.us",
    "findcurtio.ga",
    "findcurtio.ml",
    "findcurtio.tk",
    "finddocter.com",
    "findebooktoday.com",
    "findemail.info",
    "findep.xyz",
    "findercos.com",
    "findexpertcare.pro",
    "findexperthub.pro",
    "findflightstatus.com",
    "findfo.com",
    "findfreejamaica.com",
    "findgeras.ga",
    "findguides.site",
    "findhealthcareproviders.org",
    "findhere.com",
    "findingremedy.xyz",
    "findingyourfinancialpower.com",
    "finditfoxvalley.com",
    "findlayhomeshow.com",
    "findleyfit.com",
    "findmail.com",
    "findmanual.site",
    "findmanualx.site",
    "findme.land",
    "findmemail.com",
    "findmolik.tk",
    "findmovieonline.website",
    "findmyappraisal.com",
    "findpassage.com",
    "findu.pl",
    "findwater.ru",
    "findwindowtinting.com",
    "fineartadoption.net",
    "fineartpetsketches.com",
    "finebody.com",
    "fineemail.com",
    "finefact.info",
    "fineoddity.com",
    "finfin.com",
    "fingalcafe-swords.com",
    "fingermouse.org",
    "fingersystemeurope.com",
    "finikeakdeniz.xyz",
    "finishtimingtrailers.com",
    "finkin.com",
    "finklfan.com",
    "finlaygreen.buzz",
    "finleywarner.buzz",
    "finlitca.com",
    "finnahappen.com",
    "finne.online",
    "finney4.com",
    "finnstromsentreprenad.se",
    "fino-case.ru",
    "finpar.ru",
    "finprokachka.ru",
    "finrigtht.finance",
    "finrigthtfinance.com",
    "finseti.ru",
    "finsilan.gq",
    "finsilan.tk",
    "fintechistanbul.net",
    "fintechturkiye.net",
    "fintechturkiye.org",
    "fintemax.com",
    "finuprbal.ru",
    "finxmail.com",
    "fiocharrest.cf",
    "fiocharrest.ga",
    "fiocharrest.tk",
    "fiqueisemdividas.com",
    "fir.hk",
    "firamax.club",
    "firasbizzari.com",
    "fire-brigade.com",
    "fireads.best",
    "fireads.shop",
    "fireads.work",
    "firearmsglossary.com",
    "firebit.online",
    "fireboxmail.lol",
    "fireclones.com",
    "fireconsole.com",
    "firecookie.ml",
    "firedepartment.ru",
    "firef0x.cf",
    "firef0x.ga",
    "firef0x.gq",
    "firef0x.ml",
    "firef0x.tk",
    "fireiptv.net",
    "firekassa.com",
    "firekiwi.xyz",
    "firema.cf",
    "firema.ga",
    "firema.ml",
    "firema.tk",
    "firemail.de",
    "fireman.net",
    "firemansbalm.com",
    "firemanscream.com",
    "firemapprints.com",
    "firematchvn.cf",
    "firematchvn.ga",
    "firematchvn.gq",
    "firematchvn.ml",
    "firematchvn.tk",
    "fireontheconception.com",
    "firesalemanager.com",
    "firesigns.xyz",
    "firesters.com",
    "firestryke.com",
    "firevisa.com",
    "firewiredigital.com",
    "firezomibies.com",
    "firlvdftp.shop",
    "firmspp.com",
    "firmtoon.com",
    "firrior.ru",
    "firsharlea.cf",
    "firsharlea.gq",
    "firsharlea.tk",
    "first-class-oriental-takeaway.com",
    "first-email.net",
    "first-mail.info",
    "first-mood.fun",
    "firstaidglossary.com",
    "firstaidsupplies.futbol",
    "firstalaskansinstitute.net",
    "firstalaskansinstitute.org",
    "firstaust.com",
    "firstbet10.com",
    "firstbitelife.com",
    "firstcapitalfibers.com",
    "firstcount.com",
    "firste.ml",
    "firstelit.icu",
    "firsthingsu.net",
    "firsthingsu.org",
    "firsthyip.com",
    "firstineu.site",
    "firstloannow.com",
    "firstmeta.com",
    "firstnamesmeanings.com",
    "firstpressumter.info",
    "firstpressumter.net",
    "firstresponderrehab.com",
    "firstrest.com",
    "firstrow.app",
    "firstshoes.club",
    "firststepdetoxcenter.net",
    "firststepfloridadetox.com",
    "firstthingsu.net",
    "firul.ru",
    "fish.skytale.net",
    "fishandchips.website",
    "fishandchipsinlondon.com",
    "fishandgamemagazine.com",
    "fishantibioticsdirect.org",
    "fishburne.org",
    "fishchiro.com",
    "fishchiropractic.com",
    "fishdating.net",
    "fishdoctor.vet",
    "fisher19851231.xyz",
    "fisherinvestments.site",
    "fishfortomorrow.xyz",
    "fishfuse.com",
    "fishgame.net",
    "fishing-break.ru",
    "fishing.cam",
    "fishingmobile.org",
    "fishingshop.live",
    "fishingtackle.net",
    "fishlozktm.space",
    "fishnets.xyz",
    "fishslack.com",
    "fishwater.ru",
    "fistclick-company.ru",
    "fit-7979.com",
    "fitanu.info",
    "fitanu.net",
    "fitanu.org",
    "fitbizbooster.com",
    "fitbody2020.website",
    "fitchyasociados.com",
    "fitcommons.com",
    "fitfoodieindia.com",
    "fitforme.app",
    "fithikerchick.com",
    "fitimail.eu",
    "fitmotiv.ru",
    "fitneeses.site",
    "fitneesx.site",
    "fitneezz.info",
    "fitneezz.site",
    "fitnesrezink.ru",
    "fitnessdigest.ru",
    "fitnessmail.net",
    "fitnessondemand.net",
    "fitnessuniverse.africa",
    "fitnestv.best",
    "fitnr.net",
    "fitnr.org",
    "fito.de",
    "fitofive.ru",
    "fitscapital.top",
    "fitshopp.space",
    "fitsport.shop",
    "fitwell.org",
    "fivatu.info",
    "five-club.com",
    "five-plus.net",
    "five88.bet",
    "fiveasidegame.com",
    "fivedollardomains.com",
    "fivemail.de",
    "fivemice.ru",
    "fiveofus.info",
    "fiveoutingfile.website",
    "fiveqs.com",
    "fiver5.ru",
    "fiverme.cf",
    "fiverme.ga",
    "fiverme.ml",
    "fiverrfan.com",
    "fivestarclt.com",
    "fivestars-market.com",
    "fivgenetic.com",
    "fivoca.com",
    "fix-macosx.org",
    "fix-phones.ru",
    "fix-prise-bonus.ru",
    "fix-up48.ru",
    "fixblurryphotos.com",
    "fixcabletvok.live",
    "fixee.net",
    "fixethernet.com",
    "fixifu.info",
    "fixiva.com",
    "fixkauf24.de",
    "fixl.ru",
    "fixlab.tel",
    "fixmail.tk",
    "fixmydiesel.com",
    "fixnums.best",
    "fixturelibrary.com",
    "fixxashop.xyz",
    "fizmail.com",
    "fizmail.win",
    "fizzyroute66.xyz",
    "fjer.info",
    "fjer.us",
    "fjfj.de",
    "fjiepz.us",
    "fjindan.com",
    "fjklm.xyz",
    "fjltcgcp.shop",
    "fjm0k3.us",
    "fjmjqd.us",
    "fjqbdg5g9fycb37tqtv.cf",
    "fjqbdg5g9fycb37tqtv.ga",
    "fjqbdg5g9fycb37tqtv.gq",
    "fjqbdg5g9fycb37tqtv.ml",
    "fjqbdg5g9fycb37tqtv.tk",
    "fjrhp5.us",
    "fjs4xawnej1ky7l.xyz",
    "fjsxco.site",
    "fjtjh.com",
    "fjtsale.top",
    "fjumlcgpcad9qya.cf",
    "fjumlcgpcad9qya.ga",
    "fjumlcgpcad9qya.gq",
    "fjumlcgpcad9qya.ml",
    "fjumlcgpcad9qya.tk",
    "fjxh-meirong.com",
    "fjzxjscl.com",
    "fkbmhj.fun",
    "fke1o.us",
    "fkgmrn.fun",
    "fkinyu.com",
    "fklbiy3ehlbu7j.cf",
    "fklbiy3ehlbu7j.ga",
    "fklbiy3ehlbu7j.gq",
    "fklbiy3ehlbu7j.ml",
    "fklbiy3ehlbu7j.tk",
    "fknblqfoet475.cf",
    "fknmwk.fun",
    "fkoh1p.us",
    "fkoljpuwhwm97.cf",
    "fkoljpuwhwm97.ga",
    "fkoljpuwhwm97.gq",
    "fkoljpuwhwm97.ml",
    "fkpmkb.fun",
    "fkrcdwtuykc9sgwlut.cf",
    "fkrcdwtuykc9sgwlut.ga",
    "fkrcdwtuykc9sgwlut.gq",
    "fkrcdwtuykc9sgwlut.ml",
    "fkrcdwtuykc9sgwlut.tk",
    "fkrmdr.fun",
    "fksmpx.fun",
    "fksmyx.fun",
    "fktflex.com",
    "fktmpn.fun",
    "fkul2b.site",
    "fkxf888.com",
    "fkxmcw.fun",
    "fkyg10b.site",
    "fkyg11b.site",
    "fkyg12b.site",
    "fl.hatberkshire.com",
    "fl158.site",
    "fl1zr6.us",
    "fl2nyhomes.com",
    "flackrzjh.space",
    "flagai.org",
    "flagelcivr.space",
    "flagstaffdoctors.com",
    "flagtoflagvideo.com",
    "flagxbetpinup.ru",
    "flairvigor.com",
    "flais.space",
    "flame-asian-tapasbar.com",
    "flamesindiantakeaway.com",
    "flamingchicken.org",
    "flamingogo.info",
    "flaresand.top",
    "flarmail.ga",
    "flaselektronik.online",
    "flash-mail.pro",
    "flash-mail.xyz",
    "flash-sale.icu",
    "flashbjgsp.site",
    "flashbox.5july.org",
    "flashcom.net",
    "flashdelivery.com",
    "flashdis.email",
    "flashearcelulares.com",
    "flashemail.com",
    "flashgh.icu",
    "flashhasabigforehead.xyz",
    "flashmail.co",
    "flashmail.com",
    "flashmail.net",
    "flashmail.pro",
    "flashpdf.com",
    "flashpressa.ru",
    "flashrews.site",
    "flashsaletoday.com",
    "flashservice.online",
    "flashtatto.ru",
    "flashuni.press",
    "flashvoi.recipes",
    "flashvoice.email",
    "flat150.com",
    "flatanssanov.tk",
    "flatdisruptfind.website",
    "flatfilecms.com",
    "flatothout.ml",
    "flatriverwrestling.com",
    "flauntify.com",
    "flavejmi.cf",
    "flavejmi.gq",
    "flavejmi.tk",
    "flaviacadime.com",
    "flavotcon.cf",
    "flavotcon.ga",
    "flavotcon.gq",
    "flavotcon.ml",
    "flavrpill.com",
    "flavrwire.com",
    "flawedcrashgrain.website",
    "flawless-cream.ru",
    "flawless-epilation.ru",
    "flax.organic",
    "flax3.com",
    "flaxseedlemonoilfacewash.com",
    "flb718.info",
    "flbdhphtz.shop",
    "flbrittanyrescue.com",
    "flbrittanyrescue.org",
    "flcp919.com",
    "flcp921.com",
    "flcp929.com",
    "flcp934.com",
    "fldatacenter.com",
    "fldetoxcenters.com",
    "fleabitesinfo.com",
    "fleckens.hu",
    "fleggins-official.ru",
    "flekto.shop",
    "flemail.com",
    "flemail.ru",
    "flemieux.com",
    "flesh-tattoo.ru",
    "fleshcape.top",
    "fletesya.com",
    "fleurdsign.online",
    "fleurs-fabrique.space",
    "flexapplab.com",
    "flexcellent.com",
    "flexeerous.ga",
    "flexeerous.gq",
    "flexeerous.ml",
    "flexeerous.tk",
    "flexfactor.info",
    "flexhosting.xyz",
    "flexiblebrushes.org",
    "flexiblebrushes.us",
    "flexibleled.com",
    "flexibleleds.com",
    "flexibleleds.net",
    "flexibleleds.org",
    "flexionars.info",
    "flexlimosy.info",
    "flexmotivatie.info",
    "flexninori.ga",
    "flexreicnam.cf",
    "flexreicnam.tk",
    "flg100.xyz",
    "flhalfpricedlistings.com",
    "flhalfpricelistings.com",
    "flickershoppe.com",
    "flickshot.id",
    "flidel.xyz",
    "flier345xr.online",
    "flightcaster.com",
    "flightdictionary.com",
    "flightsap.com",
    "flightsavebyme.site",
    "flimcirckill.ga",
    "flimcirckill.tk",
    "flindevqaj.space",
    "flingmark.com",
    "flintcasino.online",
    "flipcode.com",
    "fliperama.org",
    "flipflopgal.com",
    "flipflopsqueegee.net",
    "flipinvestclub.com",
    "flipob2b.com",
    "flipob2b.net",
    "flipping.biz",
    "fliptags.xyz",
    "fliqse.com",
    "flirt.dk",
    "flirtey.pw",
    "flitafir.de",
    "flitify.com",
    "flixdot.com",
    "flixen.net",
    "flld8d.us",
    "flnm1bkkrfxah.cf",
    "flnm1bkkrfxah.ga",
    "flnm1bkkrfxah.gq",
    "flnm1bkkrfxah.ml",
    "flnm1bkkrfxah.tk",
    "float247.com",
    "floatation.tv",
    "floatcart.com",
    "floatplane.store",
    "floatplane.tech",
    "floatpodpersonal.com",
    "floatpools.com",
    "flockdete.xyz",
    "flockresemblegravy.site",
    "flok.us",
    "floodbrother.com",
    "floodcaus.icu",
    "flooded.site",
    "floodiwac.cf",
    "floodiwac.ga",
    "floodiwac.gq",
    "floodpla.press",
    "floodto.press",
    "flooha.com",
    "floorbroom.net",
    "floorbroom.org",
    "floorbroom.us",
    "floorbrooms.biz",
    "floorbrooms.net",
    "floorbrooms.org",
    "floorbrooms.us",
    "floorcra.xyz",
    "floorcro.icu",
    "floordri.fun",
    "floorimot.cf",
    "floorimot.gq",
    "floorimot.ml",
    "floorimot.tk",
    "flooringuj.com",
    "floorma.xyz",
    "floororde.icu",
    "floorpayablegraze.site",
    "floorsqueegee.org",
    "floorsqueegee.us",
    "floorsqueegees.biz",
    "floorsqueegees.org",
    "floorsqueegees.us",
    "floorstr.icu",
    "floorvelsia.cf",
    "floorvelsia.ml",
    "flop.cloud",
    "florafauna.cf",
    "floralparknyattorney.com",
    "florapetit.com",
    "floreall.ru",
    "florean.org",
    "floreatriversidelodge.com",
    "floregtor.cf",
    "floregtor.gq",
    "floregtor.ml",
    "floregtor.tk",
    "floresans.com",
    "floresansprint.com",
    "floresta.ml",
    "floridaaug.com",
    "floridabookshop.com",
    "floridacims.com",
    "floridacnn.com",
    "floridaemail.net",
    "floridaharvard.com",
    "floridahome.store",
    "floridamovo.com",
    "floridanettv.com",
    "floridaopiatereliefcenter.com",
    "floridaproductdesign.com",
    "floridaquote.com",
    "floridarains.com",
    "floridarlt.com",
    "floridianprints.com",
    "floriscope.site",
    "florissantattorneys.com",
    "florissantrentals.com",
    "florium.ru",
    "florokerama.ru",
    "flossed.org",
    "flossic.com",
    "flourdlqvwr.email",
    "flourpar.icu",
    "flourworr.icu",
    "flowathes.cf",
    "flowathes.ga",
    "flowathes.gq",
    "flowathes.ml",
    "flowathes.tk",
    "flowbolt.com",
    "flowcoachingpro.com",
    "flowcontrolsystems.us",
    "flower-russia.ru",
    "flowerdija.space",
    "floweretta.ru",
    "flowerkey.ru",
    "flowermoundapartments.com",
    "flowerpot.rest",
    "flowers-dreams.ru",
    "flowersetcfresno.com",
    "flowerss.website",
    "flowexa.com",
    "flowfthroughbrush.net",
    "flowfthroughbrush.org",
    "flowfthroughbrush.us",
    "flowthroughbrushes.com",
    "flowthroughbrushes.us",
    "flowthrubrush.biz",
    "flowthrubrush.us",
    "flowthrubrushes.com",
    "flowthrubrushes.org",
    "flowthrubrushes.us",
    "flowu.com",
    "flpay.org",
    "flpropinvest.com",
    "flq912.info",
    "fls4.gleeze.com",
    "flsaid.com",
    "flsb03.com",
    "flsb04.com",
    "flsb05.com",
    "flsb06.com",
    "flsb07.com",
    "flsb08.com",
    "flsb09.com",
    "flsb10.com",
    "flsb11.com",
    "flsb13.com",
    "flsb14.com",
    "flsb15.com",
    "flsb16.com",
    "flsb17.com",
    "flsb18.com",
    "flsb19.com",
    "flsb20.com",
    "flshirts.xyz",
    "flu-cc.flu.cc",
    "flu.cc",
    "flucc.flu.cc",
    "flucteausonc.cf",
    "flucteausonc.ga",
    "flucteausonc.gq",
    "flucteausonc.ml",
    "flucteausonc.tk",
    "fluenthealthspot.com",
    "flufarm.com",
    "fluffsac.com",
    "fluffysamoyedgarden.us",
    "fluidensity.com",
    "fluidensity.info",
    "fluidensity.org",
    "fluidsoft.us",
    "fluidvpn.com",
    "fluidway.net",
    "fluinsureebb.website",
    "flukify.com",
    "fluorescentcat.info",
    "flurre.com",
    "flurred.com",
    "flurred.ru",
    "flushawfu.icu",
    "flushblast.buzz",
    "flushsc.xyz",
    "fluthelpnac.cf",
    "fluthelpnac.gq",
    "fluthelpnac.tk",
    "flutiner.cf",
    "flutiner.gq",
    "fluxfinancial.com",
    "fluz-fluz.ru",
    "flvtomp3.xyz",
    "flwgenixfiber.site",
    "flxam1.us",
    "fly-ts.de",
    "flyalmostfree.net",
    "flyalmostfree.org",
    "flyashbricksmanufacturers.com",
    "flycasual.org",
    "flychooses.site",
    "flycocoons.info",
    "flyer24.shopping",
    "flyeragency.com",
    "flyhack.com",
    "flyingbundle.com",
    "flyingfakir.com",
    "flyinggeek.net",
    "flyingmminiamericans.org",
    "flyingmouse.info",
    "flyjet.net",
    "flymir.ru",
    "flynauru.com",
    "flynauru.net",
    "flyognivo.ru",
    "flyoveraerials.com",
    "flypdx.org",
    "flypicks.com",
    "flyplut.ru",
    "flyspam.com",
    "flyte.design",
    "flytecrew.com",
    "flytvdigital.ltd",
    "flyvid.ru",
    "flyvivo.ru",
    "flywheel-exchange.com",
    "flywheel-labs.com",
    "flyxnet.pw",
    "fm1055.org",
    "fm19.app",
    "fm21.app",
    "fm22.app",
    "fm23.app",
    "fm24.app",
    "fm25.app",
    "fm26.app",
    "fm30.app",
    "fm31.app",
    "fm34.app",
    "fm35.app",
    "fm36.app",
    "fm37.app",
    "fm42.app",
    "fm43.app",
    "fm44.app",
    "fm45.app",
    "fm46.app",
    "fm48.app",
    "fm52.app",
    "fm53.app",
    "fm55.app",
    "fm56.app",
    "fm58.app",
    "fm59.app",
    "fm60.app",
    "fm62.app",
    "fm64.app",
    "fm66.app",
    "fm69.cf",
    "fm69.ga",
    "fm69.gq",
    "fm69.ml",
    "fm69.tk",
    "fm7.app",
    "fm72.app",
    "fm73.app",
    "fm74.app",
    "fm76.app",
    "fm77.app",
    "fm79.app",
    "fm8.app",
    "fm80.app",
    "fm81.app",
    "fm82.app",
    "fm83.app",
    "fm86.app",
    "fm88.app",
    "fm89.app",
    "fm90.app",
    "fm94.app",
    "fm96.app",
    "fm97.app",
    "fm98.app",
    "fmail.co.uk",
    "fmail.online",
    "fmail.ooo",
    "fmail.party",
    "fmail.pw",
    "fmail10.de",
    "fmailbox.com",
    "fmailx.tk",
    "fmctc.com",
    "fmft.email",
    "fmgirl.com",
    "fmguy.com",
    "fmicloud.tk",
    "fmiv2r.com",
    "fmmxnskw.site",
    "fmovies-se.best",
    "fmovies-to.best",
    "fmpromagazine.com",
    "fmproworld.com",
    "fmrecipes.com",
    "fmrecipes.org",
    "fmv13ahtmbvklgvhsc.cf",
    "fmv13ahtmbvklgvhsc.ga",
    "fmv13ahtmbvklgvhsc.gq",
    "fmv13ahtmbvklgvhsc.ml",
    "fmv13ahtmbvklgvhsc.tk",
    "fmv69.com",
    "fmzhwa.info",
    "fn5258.com",
    "fn6yzx.us",
    "fn7p2ay310.site",
    "fnap1x.ru",
    "fnbmail.co.za",
    "fnhzl.live",
    "fnisj892kosoks29293939.heliohost.org",
    "fnkzwmhyv.shop",
    "fnmail.com",
    "fnmedia.site",
    "fnnus3bzo6eox0.cf",
    "fnnus3bzo6eox0.ga",
    "fnnus3bzo6eox0.gq",
    "fnnus3bzo6eox0.ml",
    "fnnus3bzo6eox0.tk",
    "fnord.me",
    "fnrehab.com",
    "fnsese.xyz",
    "fnujwkthy.shop",
    "fnuxu6.us",
    "fnwv73le26z90cz.xyz",
    "fnx65ktx4b98it7.xyz",
    "fnxm.xyz",
    "fnyt.xyz",
    "fnzm.net",
    "fo9t34g3wlpb0.cf",
    "fo9t34g3wlpb0.ga",
    "fo9t34g3wlpb0.gq",
    "fo9t34g3wlpb0.ml",
    "fo9t34g3wlpb0.tk",
    "foakibu.ga",
    "foakibu.gq",
    "foakibu.tk",
    "foamform.com",
    "foamiranclub.ru",
    "fobjsr.us",
    "fobsos.ml",
    "fobunbindeel.website",
    "focallhprj.space",
    "focavas.info",
    "foclient.com",
    "focus-proxy.com",
    "focus-proxy.net",
    "focusapp.com",
    "focusdiscover.com",
    "focusial.com",
    "focusingministries.com",
    "focusingministry.com",
    "focusingministry.net",
    "focusingministry.org",
    "focusproxy.com",
    "focussocialshop.com",
    "fod-belastingdienst.online",
    "fodl.net",
    "fodmaster21pbjp.cf",
    "foeencuu.shop",
    "fogenoughera.website",
    "fogeycnsd.space",
    "fogostakeaway.com",
    "fogsportjop.ru",
    "fogusa.ru",
    "fojcyi.xyz",
    "foktura.ru",
    "fokusmrt.ga",
    "folardeche.com",
    "foldbagsy.info",
    "folderiowa.com",
    "foleyarmory.com",
    "folhadesaopaulo.club",
    "folhadesaopaulo.site",
    "folhadesaopaulo.website",
    "folhadesaopaulo.xyz",
    "folieshops.com",
    "folietemperatur.website",
    "folkfan.com",
    "folkfena.cf",
    "folkfena.ml",
    "folkfena.tk",
    "folklofolie.com",
    "follargratis-confirmed.com",
    "follargratis-meet-backup.com",
    "followbrand.net",
    "followerfilter.com",
    "follownews.press",
    "followthewhiterabbit.ru",
    "folpjp.site",
    "fomohosting.com",
    "fomorno.cf",
    "fomorno.ga",
    "fomorno.ml",
    "fomorno.tk",
    "fonbet-app.ru",
    "fonbet-faq.ru",
    "fonbetik.ru",
    "fondationdusport.org",
    "fondato.com",
    "fondgoroddetstva.ru",
    "fones.site",
    "fongozg.com",
    "foninanator.com",
    "fonnection.org",
    "fonsview.ml",
    "fontaccusefish.website",
    "fontak.com",
    "fontconf.com",
    "fontspring.net",
    "fontspring.org",
    "fontzillion.net",
    "foobarbot.net",
    "food-fusion-takeaway.com",
    "food-journals.com",
    "food-like-art.com",
    "food-tribes.com",
    "food315.xyz",
    "foodbank150.com",
    "foodbank150.net",
    "foodblogs.blog",
    "foodblogs.media",
    "foodbooto.com",
    "foodenset.com",
    "foodgurutakeaway.com",
    "foodhallimburg.com",
    "foodhat.net",
    "foodics.store",
    "foodinnballyfermot.com",
    "foodlabelling.info",
    "foodmail.com",
    "foodprint.net",
    "foodreamer.com",
    "foodsfever.com",
    "foodtherapy.top",
    "foodwheel.net",
    "foomboo.best",
    "fooremost.com",
    "foot-streaming.online",
    "foot.stream",
    "footangelsocks.com",
    "footard.com",
    "football.theboys.com",
    "footballmail.com",
    "footballsaintsstore.online",
    "footballstats24.com",
    "footbcharlea.cf",
    "footbcharlea.ga",
    "footcareshop.life",
    "foothardnfes.cf",
    "foothardnfes.ga",
    "foothardnfes.gq",
    "foothardnfes.ml",
    "foothills.net",
    "footprinttrading.wtf",
    "footstrat.com",
    "footstreaming.biz",
    "fopamarkets.site",
    "foquita.com",
    "for-better.biz",
    "for-more.biz",
    "for-our.info",
    "for-president.com",
    "for-some.biz",
    "for-the.biz",
    "for4mail.com",
    "foradoexpediente.com",
    "forafore.shop",
    "foragentsonky.com",
    "forasy.host",
    "forbesa.com",
    "forbet321.xyz",
    "force-loving-brilliancedart-clever.com",
    "force9.co.uk",
    "ford-edge.club",
    "ford-escape.club",
    "ford-flex.club",
    "ford-fusion.club",
    "ford-trucks.us",
    "fordanceusa.com",
    "forddomsy.info",
    "fordinettelc.monster",
    "fordonofritid.nu",
    "fordson.club",
    "forecastertests.com",
    "foreeyesa.info",
    "foreksinfo.ru",
    "foremostt.com",
    "forening.dk",
    "foreo-luna2.ru",
    "foreranks.best",
    "foreriver.org",
    "foresightpropertyinspections.org",
    "foreskin.cf",
    "foreskin.ga",
    "foreskin.gq",
    "foreskin.ml",
    "foreskin.tk",
    "forest-reach-agree-snow.xyz",
    "forestbeekeeping.com",
    "forestbeekeeping.us",
    "forestfans.com",
    "forestguardspro.info",
    "foresthope.com",
    "forestwards.best",
    "foreveriptv.host",
    "forewarn.us",
    "forex-demo.net",
    "forex-gv.ru",
    "forex-iphone.com",
    "forexaccessfx.com",
    "forexblogs.ru",
    "forexbum.ru",
    "forexcoin.trade",
    "forexgost.ru",
    "forexhub.online",
    "forexjobing.ml",
    "forexmany777.ru",
    "forexregulator.info",
    "forexregulator.net",
    "forexregulator.org",
    "forexshop.website",
    "forextra.online",
    "forfilmsone.com",
    "forfree.at",
    "forgedfactions.net",
    "forgetmail.com",
    "forgetmenot.love",
    "forgetmenotbook.com",
    "forgevpn.com",
    "forgot.her.name",
    "forgot.his.name",
    "forgottenrelicsbooks.com",
    "forhousandlife.ru",
    "fork.codes",
    "fork.support",
    "forkai.cloud",
    "forkanddumbbell.com",
    "forkbot.cloud",
    "formaa.ru",
    "formauqua.ga",
    "formauqua.ml",
    "formauqua.tk",
    "formleads123.com",
    "formmazi.us",
    "formnitrogenflex.website",
    "formonsdy.cf",
    "formonsdy.ga",
    "formonsdy.gq",
    "formonsdy.ml",
    "formonsdy.tk",
    "formulafridays.com",
    "formulanegociodesucesso.com",
    "formulaqq.com",
    "formulath.ru",
    "formulemos.com",
    "fornattodental.com",
    "fornow.eu",
    "foronebuy.com",
    "foronenight.best",
    "forotenis.com",
    "forp.us",
    "forponto.club",
    "forpresident.com",
    "forprice.co",
    "forremost.com",
    "forsearchbo.cf",
    "forsearchbo.gq",
    "forserumsif.nu",
    "forsgame.ru",
    "forskolinwalmart.xyz",
    "forsofort.info",
    "forsoni.cf",
    "forsoni.tk",
    "forspam.net",
    "forstreamer.com",
    "forsy546854.site",
    "forsythie.com",
    "fortalease.com",
    "fortbendbuyersgroup.com",
    "fortcollinshairsalons.com",
    "fortescent.xyz",
    "fortfalday.ga",
    "fortfalday.ml",
    "fortforum.org",
    "fortheloveofdog.info",
    "fortheloveofourchildren.org",
    "forthgoing.best",
    "forthnet.gr",
    "fortinopizzabarmadrid.com",
    "fortitortoise.com",
    "fortlangleybeercompany.com",
    "fortlangleybrewery.org",
    "fortnite-accs.ru",
    "fortnitebuy.ru",
    "fortnitehub.ru",
    "fortniteskill.com",
    "fortpeckmarinaandbar.com",
    "forttorssand.ru",
    "forttuity.com",
    "fortuacc.com",
    "fortuncity.com",
    "fortune-star-waterford.com",
    "fortunecity.com",
    "fortwayneclearbraces.com",
    "fortwaynehairsalons.com",
    "fortwayneheroinrehab.com",
    "fortworthheroinrehab.com",
    "forum-bank.ru",
    "forum-consumo.org",
    "forum-edu.ru",
    "forum-feringer.ru",
    "forum-guns.ru",
    "forum.dk",
    "forumbegi.xyz",
    "forumfi.xyz",
    "forumies.com",
    "forumrou.com",
    "forumtroo.site",
    "forusine.net",
    "forvetbahis.org",
    "forvetbet777.com",
    "forvetbet788.net",
    "forvetbet80.net",
    "forvetbet89.net",
    "forvetbetgrup.net",
    "forvitta.com",
    "forvk.ru",
    "forward.cat",
    "forward50.us",
    "forwardhome.app",
    "forwardshop.pro",
    "forwardshop.site",
    "forwardshop.store",
    "forwardto.email",
    "foryoumyfriend.online",
    "foryoumyfriend.ru",
    "foryoumyfriend.space",
    "forzandoarts.us",
    "forzaneftchi.info",
    "foshata.com",
    "fosil.pro",
    "fosinon.cf",
    "fosrenstit.gq",
    "fosrenstit.tk",
    "fosse776nr.online",
    "fossefans.com",
    "fosterpromise.org",
    "fostervet.net",
    "fostervet.org",
    "fota.email",
    "fotmvpe26.host",
    "foto-en-el-\xe1lbum.info",
    "fotoglamour.ru",
    "fotografium.tv",
    "fotomontagem.info",
    "fotonmail.com",
    "fotonmotors.ru",
    "fotons.ru",
    "fotooboi-deluxe.ru",
    "fotooboi-russ.ru",
    "fotooboy-art.ru",
    "fotoplenka.ru",
    "fotopromo.ru",
    "fotosta.ru",
    "fouadsarkisksa.com",
    "fouin.icu",
    "found-riches.com",
    "foundationbay.com",
    "foundationmorgan.com",
    "foundersthatfight.com",
    "foundklinop.gq",
    "foundlowell.com",
    "fountainsandgardens.com",
    "four.fackme.gq",
    "fourdesign.info",
    "fouristic.us",
    "fourminutemorgages.com",
    "fourprosku.cf",
    "fourprosku.ga",
    "fourprosku.ml",
    "fourprosku.tk",
    "foursubjects.com",
    "fourthminuteloan.com",
    "fourx.store",
    "fouter.xyz",
    "fowlereabe.space",
    "fowre.com",
    "fox-skin.fun",
    "fox-wolf.ru",
    "fox4news.info",
    "foxbanjo.com",
    "foxbltt.com",
    "foxedcraft.space",
    "foxhaq.site",
    "foxja.com",
    "foxmail.cn",
    "foxmail.com",
    "foxmail.com.cn",
    "foxmontes.info",
    "foxopros.ru",
    "foxspizzadiberville.com",
    "foxspizzanorthhuntingdon.com",
    "foxtrotter.info",
    "foy.kr",
    "fp321.org",
    "fpapa.ooo",
    "fpc54.ru",
    "fperson.shop",
    "fpf.team",
    "fpfnlgaw.shop",
    "fpga.monster",
    "fpgfz.us",
    "fpgh0blaxh3cmst.com",
    "fphiulmdt3utkkbs.cf",
    "fphiulmdt3utkkbs.ga",
    "fphiulmdt3utkkbs.gq",
    "fphiulmdt3utkkbs.ml",
    "fphiulmdt3utkkbs.tk",
    "fpkdbn.shop",
    "fpkfdyed.shop",
    "fplt21b.site",
    "fplt22b.site",
    "fplyk.fun",
    "fpmo.cn",
    "fpt.in",
    "fptnamdinh.site",
    "fpuob0sn0awiei3.xyz",
    "fputra.xyz",
    "fpvweb.com",
    "fq1my2c.com",
    "fq248.site",
    "fq8sfvpt0spc3kghlb.cf",
    "fq8sfvpt0spc3kghlb.ga",
    "fq8sfvpt0spc3kghlb.gq",
    "fq8sfvpt0spc3kghlb.ml",
    "fq8sfvpt0spc3kghlb.tk",
    "fqing7.us",
    "fqjfslpb.xyz",
    "fqtxjxmtsenq8.cf",
    "fqtxjxmtsenq8.ga",
    "fqtxjxmtsenq8.gq",
    "fqtxjxmtsenq8.ml",
    "fqtxjxmtsenq8.tk",
    "fqyrnuzn.club",
    "fr-fr.live",
    "fr-good.xyz",
    "fr.nf",
    "fr33mail.info",
    "fr3546ruuyuy.cf",
    "fr3546ruuyuy.ga",
    "fr3546ruuyuy.gq",
    "fr3546ruuyuy.ml",
    "fr3546ruuyuy.tk",
    "fractal.golf",
    "fractal.international",
    "fractalauto.com",
    "fractalforge.cloud",
    "fractalforge.online",
    "fractionalapartmentsflorence.com",
    "fraekkert.dk",
    "fragiletime.org",
    "fragolina2.tk",
    "fragranceplanet.com",
    "frainklygaming.me",
    "framean.xyz",
    "frameang.xyz",
    "frameappllance.xyz",
    "frameitwintonsalem.com",
    "frameless-chairs.ru",
    "framemail.cf",
    "framemod.email",
    "framesconfigurator.com",
    "framinger.online",
    "frananorver.cf",
    "francamoveis.com",
    "francanet.com.br",
    "france-goto.xyz",
    "francefans.com",
    "francemel.fr",
    "francemeteo.club",
    "francescaross.buzz",
    "franchioffice.com",
    "franchisemeter.com",
    "franchiseremark.xyz",
    "francia2018.com",
    "francioni.dev",
    "francistan.com",
    "francisxkelly.com",
    "franding.info",
    "frandsen.dk",
    "frank-magazine.ru",
    "frank1swv.site",
    "frankandfed.poker",
    "frankcasino7.com",
    "frankcraf.icu",
    "franken2020senate.com",
    "frankenforall.com",
    "frankflin.icu",
    "frankfurtchevalierpremiademar.com",
    "franklinpierce.edu",
    "franklinschooleagles.com",
    "franklintemoleton.com",
    "franklintransportservices.com",
    "franks-takeaway-prosperous.com",
    "frankstakeaway.com",
    "franksunter.ml",
    "frapmail.com",
    "frappina.tk",
    "frappina99.tk",
    "frasabeq.cf",
    "frasabeq.ga",
    "frasabeq.tk",
    "fraternityofsound.org",
    "fraternization946vg.xyz",
    "fraudcaller.com",
    "frazerltd.com",
    "frdibill.icu",
    "frdylicaniax.host",
    "freadingsq.com",
    "freakanin.cf",
    "freakanin.ga",
    "freakanin.ml",
    "freakfm.ru",
    "freakosop.ga",
    "freakosop.gq",
    "freakosop.ml",
    "freakosop.tk",
    "freaksnap.xyz",
    "freakzmia.com",
    "freally.com",
    "frecciarossa.tk",
    "frecklecertain.buzz",
    "fredanthropist.com",
    "freddymail.com",
    "frederiks.icu",
    "frederiksen.dk",
    "fredol.live",
    "free-backlinks.ru",
    "free-email.cf",
    "free-email.ga",
    "free-flash-games.com",
    "free-gay-chat.club",
    "free-installs-application-mine.club",
    "free-installs-software-mine.club",
    "free-lancelot.com",
    "free-like.xyz",
    "free-online-roulette.org",
    "free-online.net",
    "free-org.com",
    "free-rutorg.site",
    "free-store.ru",
    "free-temp.net",
    "free.com",
    "free.com.pe",
    "free.fr",
    "free.mail52.cf",
    "free.mail52.ga",
    "free.mail52.gq",
    "free.mail52.ml",
    "free.mail52.tk",
    "free.yhstw.org",
    "freeaa317.xyz",
    "freeaccess.nl",
    "freeaccnt.ga",
    "freeaccount.com",
    "freeachievement.info",
    "freeadverts.org",
    "freealtgen.com",
    "freeandsingle.com",
    "freeandsingle.us",
    "freebabysittercam.com",
    "freebeautyofsweden.se",
    "freebie4teachers.com",
    "freebies-daily.com",
    "freebiker.su",
    "freebin.ru",
    "freebitcoinlottery.xyz",
    "freeblackbootytube.com",
    "freebnas.site",
    "freeboost.su",
    "freebox.com",
    "freebullets.net",
    "freecat.net",
    "freechargevn.cf",
    "freechargevn.ga",
    "freechargevn.gq",
    "freechargevn.ml",
    "freechargevn.tk",
    "freechickenbiscuit.com",
    "freechristianbookstore.com",
    "freecoolemail.com",
    "freecrocobet.com",
    "freecrot.undo.it",
    "freedamoneway.blue",
    "freedealworld.com",
    "freedfromdesirly.website",
    "freedoghouses.com",
    "freedom-mail.ga",
    "freedom.casa",
    "freedom.usa.com",
    "freedom4you.info",
    "freedomains.site",
    "freedomcinema.ru",
    "freedomfrompsychopaths.org",
    "freedomlover.com",
    "freedompop.us",
    "freedomroad.info",
    "freedomweb.org",
    "freedomworkingcapital.com",
    "freeebooksusa.best",
    "freeeducationvn.cf",
    "freeeducationvn.ga",
    "freeeducationvn.gq",
    "freeeducationvn.ml",
    "freeeducationvn.tk",
    "freeeerf.com",
    "freeekrat.cf",
    "freeemail.online",
    "freefanmail.com",
    "freefattymovies.com",
    "freefoodforest.com",
    "freefoodforest.org",
    "freeforall.site",
    "freegamenjoy.com",
    "freegamercards.com",
    "freegates.be",
    "freegatlinburg.com",
    "freeghana.com",
    "freegift.sale",
    "freegmail.ga",
    "freehealthytips.xyz",
    "freehold-lawyer.com",
    "freehosting.men",
    "freehotmail.net",
    "freehsm.com",
    "freehsm.net",
    "freeinbox.email",
    "freeinstallssoftwaremine.club",
    "freeir90.net",
    "freekashmir.info",
    "freekashmir.live",
    "freelance-france.eu",
    "freelanceposition.com",
    "freelancergate.shop",
    "freelancergoal.shop",
    "freeler.nl",
    "freeletter.me",
    "freelifetimexxxdates.com",
    "freelocalbusiness.com",
    "freemail.bozz.com",
    "freemail.c3.hu",
    "freemail.com.au",
    "freemail.com.pk",
    "freemail.de",
    "freemail.et",
    "freemail.gr",
    "freemail.hu",
    "freemail.it",
    "freemail.lt",
    "freemail.ms",
    "freemail.nl",
    "freemail.org.mk",
    "freemail.ru",
    "freemail.trankery.net",
    "freemail.tweakly.net",
    "freemaillink.com",
    "freemailnow.net",
    "freemails.cf",
    "freemails.ga",
    "freemails.ml",
    "freemanual.asia",
    "freemanualonline.asia",
    "freemarket.site",
    "freemask.ru",
    "freemeil.ga",
    "freemeil.gq",
    "freemeil.ml",
    "freemeil.tk",
    "freemindstrongbody.com",
    "freemommyvids.com",
    "freemr.site",
    "freemusicdownload.website",
    "freemymail.org",
    "freemyworld.cf",
    "freemyworld.ga",
    "freemyworld.gq",
    "freemyworld.ml",
    "freemyworld.tk",
    "freenet.de",
    "freenet.kg",
    "freeneurons.com",
    "freeola.com",
    "freeola.net",
    "freeolamail.com",
    "freeoptics-els.site",
    "freeoptics.site",
    "freeparur.cf",
    "freeparur.ga",
    "freeparur.gq",
    "freeparur.ml",
    "freepdfmagazines.club",
    "freepdfmanuales.xyz",
    "freeplongmels.ml",
    "freeplongmels.tk",
    "freeplumpervideos.com",
    "freeporttoenaillasertreatment.com",
    "freeprice.co",
    "freeproblem.com",
    "freeqi.xyz",
    "freeroid.com",
    "freerubli.ru",
    "freesatom.cf",
    "freesatom.gq",
    "freesatom.ml",
    "freesatom.tk",
    "freesbee.fr",
    "freeschoolgirlvids.com",
    "freesearchany.info",
    "freeserve.co.uk",
    "freeservers.com",
    "freeshemaledvds.com",
    "freesistercam.com",
    "freesistervids.com",
    "freeskier.us",
    "freespin.ru",
    "freestamp.com",
    "freestart.hu",
    "freestrategy.info",
    "freestreamboxwizard.com",
    "freestyle-heliopark.ru",
    "freesurf.fr",
    "freesurf.nl",
    "freesystemtech.info",
    "freeteenbums.com",
    "freethemusic.net",
    "freethought.ml",
    "freetimeandfunallaround.info",
    "freetmail.in",
    "freetmail.net",
    "freetraffictracker.com",
    "freetubearchive.com",
    "freeuk.com",
    "freeuk.net",
    "freeukisp.co.uk",
    "freeusenet.rocks",
    "freevid.site",
    "freewalet.website",
    "freewatpret.tk",
    "freewayverhuur.net",
    "freeweb.email",
    "freeweb.org",
    "freewebemail.com",
    "freewebmail.ga",
    "freeyellow.com",
    "freezersshop.live",
    "freezipcode.com",
    "freezone.co.uk",
    "freezzzm.site",
    "freis.ru",
    "fremiumhosting.icu",
    "fremontalcoholrehab.com",
    "frenk.dev",
    "frenteadventista.com",
    "frenzybudgeter.com",
    "frenzytiger.com",
    "freresphone.com",
    "fresco-pizzeria-ballybrittas.com",
    "fresent.com",
    "freshappcasgreen.ru",
    "freshestcoffeeyoucanbuy.com",
    "freshflowersindoorplantscheap.net",
    "freshkeys.ru",
    "freshly.cloud",
    "freshpato.com",
    "freshpondcinema.com",
    "freshportal.ru",
    "freshspike.com",
    "freshthinkinggroup.group",
    "freshviralnewz.club",
    "freshwear.space",
    "freshyoutop.ru",
    "fresnococainerehab.com",
    "fresnoforeclosures.com",
    "fresnoheroinrehab.com",
    "fresnomail.com",
    "fresnoopiaterehab.com",
    "freson.info",
    "freson.org",
    "fressmind.us",
    "fretcraft.com",
    "freudenkinder.de",
    "freunde.ru",
    "freundin.ru",
    "freybet40.com",
    "freybet5.com",
    "freybet6.com",
    "freybet60.com",
    "frezerovka-nsk.ru",
    "friction.net",
    "frictionla.com",
    "fridastoreh.xyz",
    "fridaylaura.com",
    "fridaymovo.com",
    "friedchitlins.com",
    "friedmansfinder.com",
    "friendlyanarchists.org",
    "friendlydevices.com",
    "friendlymail.co.uk",
    "friendlypanther.info",
    "friendlypuppy.info",
    "friends-cafe.com",
    "friendsfan.com",
    "friendship-u.com",
    "friendsofgypsycats.org",
    "friendsofretiredgreyhounds.info",
    "friendsofriviera.com",
    "friendsofsophiasurf.com",
    "friendsofstpatricks.org",
    "friendstotravel.info",
    "friendtracking.ru",
    "frightnight.org",
    "frinselva.tk",
    "friomp.stream",
    "friscaa.cf",
    "friscaa.ga",
    "friscaa.gq",
    "friscaa.ml",
    "friscaa.tk",
    "frishastmigfors.tk",
    "friskytaphouse.com",
    "frisyrer.website",
    "frite-haus-takeaway.com",
    "frith.site",
    "fritzkunze.net",
    "frizzart.ru",
    "frkdp.net",
    "frl973.us",
    "frmturkiye.com",
    "frnfre.shop",
    "frogdesign.info",
    "frogflux.website",
    "froglie.website",
    "froidgaming.host",
    "froking.xyz",
    "froknowsphoto.org",
    "frolrecam.cf",
    "frolrecam.gq",
    "frolrecam.ml",
    "frolrecam.tk",
    "from-africa.com",
    "from-ak.com",
    "from-al.com",
    "from-america.com",
    "from-ar.com",
    "from-argentina.com",
    "from-asia.com",
    "from-australia.com",
    "from-az.net",
    "from-belgium.com",
    "from-brazil.com",
    "from-ca.com",
    "from-canada.com",
    "from-china.net",
    "from-co.net",
    "from-ct.com",
    "from-dc.com",
    "from-de.com",
    "from-england.com",
    "from-europe.com",
    "from-fl.com",
    "from-france.net",
    "from-ga.com",
    "from-germany.net",
    "from-hi.com",
    "from-holland.com",
    "from-ia.com",
    "from-id.com",
    "from-il.com",
    "from-in.com",
    "from-israel.com",
    "from-italy.net",
    "from-japan.net",
    "from-korea.com",
    "from-ks.com",
    "from-ky.com",
    "from-la.net",
    "from-ma.com",
    "from-md.com",
    "from-me.org",
    "from-mexico.com",
    "from-mi.com",
    "from-mn.com",
    "from-mo.com",
    "from-ms.com",
    "from-mt.com",
    "from-nc.com",
    "from-nd.com",
    "from-ne.com",
    "from-nh.com",
    "from-nj.com",
    "from-nm.com",
    "from-nv.com",
    "from-ny.net",
    "from-oh.com",
    "from-ok.com",
    "from-or.com",
    "from-outerspace.com",
    "from-pa.com",
    "from-pr.com",
    "from-ri.com",
    "from-russia.com",
    "from-sc.com",
    "from-sd.com",
    "from-spain.net",
    "from-tn.com",
    "from-tx.com",
    "from-ut.com",
    "from-va.com",
    "from-vt.com",
    "from-wa.com",
    "from-wi.com",
    "from-wv.com",
    "from-wy.com",
    "from.onmypc.info",
    "fromalabama.com",
    "fromalaska.com",
    "fromarizona.com",
    "fromarkansas.com",
    "fromcalifornia.com",
    "fromcolorado.com",
    "fromconnecticut.com",
    "fromdelaware.com",
    "fromdos.best",
    "fromflorida.net",
    "fromgeorgia.com",
    "fromhawaii.net",
    "fromidaho.com",
    "fromillinois.com",
    "fromindiana.com",
    "frominter.net",
    "fromiowa.com",
    "fromjupiter.com",
    "fromkansas.com",
    "fromkentucky.com",
    "fromlitic.gq",
    "fromlitic.ml",
    "fromlitic.tk",
    "fromlouisiana.com",
    "frommaine.net",
    "frommalaysiawithlove.com",
    "frommaryland.com",
    "frommassachusetts.com",
    "frommiami.com",
    "frommichigan.com",
    "fromminnesota.com",
    "frommississippi.com",
    "frommissouri.com",
    "frommontana.com",
    "frommywithlove.com",
    "fromnebraska.com",
    "fromnevada.com",
    "fromnewhampshire.com",
    "fromnewjersey.com",
    "fromnewmexico.com",
    "fromnewyork.net",
    "fromnorthcarolina.com",
    "fromnorthdakota.com",
    "fromohio.com",
    "fromoklahoma.com",
    "fromoregon.net",
    "frompennsylvania.com",
    "fromrhodeisland.com",
    "fromru.com",
    "fromru.ru",
    "fromsgwithlove.com",
    "fromsouthcarolina.com",
    "fromsouthdakota.com",
    "fromtennessee.com",
    "fromtexas.com",
    "fromthestates.com",
    "fromutah.com",
    "fromvermont.com",
    "fromvirginia.com",
    "fromwashington.com",
    "fromwashingtondc.com",
    "fromwestvirginia.com",
    "fromwisconsin.com",
    "fromwyoming.com",
    "fromyourphone.com",
    "fronation.com",
    "front-end-dev.ru",
    "front.ru",
    "front14.org",
    "frontier.com",
    "frontierfactions.org",
    "frontiernet.net",
    "frontlinemanagementinstitute.com",
    "frontoid.xyz",
    "frontpointreview.com",
    "frontspor.press",
    "frost-online.de",
    "frost2d.net",
    "frostbyte.uk.net",
    "frostpaper.ru",
    "frownmarc.email",
    "frpinventory.info",
    "frpinventory.org",
    "frpinventory.us",
    "frpscheduler.com",
    "frso.info",
    "frst-node.shop",
    "fructuary.site",
    "fruhaufsteher.com",
    "fruitandvegetable.xyz",
    "fruitclos.buzz",
    "fruitsforreal.org",
    "fruitshps.website",
    "fruittrus.email",
    "frusellboa.monster",
    "frusidoc.ml",
    "frusidoc.tk",
    "fruticool.com",
    "frutlinaepekarina.site",
    "fryzer.com",
    "fs-fitzgerald.cf",
    "fs-fitzgerald.ga",
    "fs-fitzgerald.gq",
    "fs-fitzgerald.ml",
    "fs-fitzgerald.tk",
    "fs-rs.net",
    "fs00h.xyz",
    "fs16dubzzn0.cf",
    "fs16dubzzn0.ga",
    "fs16dubzzn0.gq",
    "fs16dubzzn0.ml",
    "fs16dubzzn0.tk",
    "fsagc.xyz",
    "fsbi.online",
    "fsbo-nc-coastal.com",
    "fsbtrj.com",
    "fsbusiness.co.uk",
    "fsdfsdf.icu",
    "fsdtgfgbhhrtpro.club",
    "fse1xs.us",
    "fsfsdf.org",
    "fsgnq.xyz",
    "fshncgoqn.shop",
    "fshopping.site",
    "fsjautohub.com",
    "fskatt.se",
    "fslife.co.uk",
    "fslm.de",
    "fsmail.net",
    "fsmilitary.com",
    "fsnet.co.uk",
    "fsociety-br.online",
    "fsociety.org",
    "fsreg.cf",
    "fsrfwwsugeo.cf",
    "fsrfwwsugeo.ga",
    "fsrfwwsugeo.gq",
    "fsrfwwsugeo.ml",
    "fsrfwwsugeo.tk",
    "fstoner.com",
    "fstopinterviews.com",
    "fsuvoh.com",
    "fsworld.co.uk",
    "fsxtrade.com",
    "ft1dox.us",
    "ftazl.buzz",
    "ftc-i.net",
    "ftcgroup.xyz",
    "ftcrafdwp.shop",
    "ftea.site",
    "ftg8aep4l4r5u.cf",
    "ftg8aep4l4r5u.ga",
    "ftg8aep4l4r5u.gq",
    "ftg8aep4l4r5u.ml",
    "ftg8aep4l4r5u.tk",
    "ftgb2pko2h1eyql8xbu.cf",
    "ftgb2pko2h1eyql8xbu.ga",
    "ftgb2pko2h1eyql8xbu.gq",
    "ftgb2pko2h1eyql8xbu.ml",
    "ftgb2pko2h1eyql8xbu.tk",
    "ftgxn.site",
    "fti3ht.club",
    "ftkgnb.tokyo",
    "ftml.net",
    "ftoflqad9urqp0zth3.cf",
    "ftoflqad9urqp0zth3.ga",
    "ftoflqad9urqp0zth3.gq",
    "ftoflqad9urqp0zth3.ml",
    "ftoflqad9urqp0zth3.tk",
    "ftp.sh",
    "ftpaccess.cc",
    "ftpbd.com",
    "ftpinc.ca",
    "ftr4transcribers.com",
    "ftr4transcript.com",
    "ftrader.net",
    "ftrltd.org",
    "ftrserver.info",
    "ftrtranscript.com",
    "ftsalons.com",
    "ftsxthiw.site",
    "ftuns.live",
    "ftworld.ru",
    "ftwzg1.site",
    "ftyjyq.rest",
    "ftzvsn.us",
    "fu014.site",
    "fu6znogwntq.cf",
    "fu6znogwntq.ga",
    "fu6znogwntq.gq",
    "fu6znogwntq.ml",
    "fu6znogwntq.tk",
    "fuadd.me",
    "fubsale.top",
    "fubuki.shp7.cn",
    "fuchsringqg.icu",
    "fuckedupload.com",
    "fuckingduh.com",
    "fuckmail.me",
    "fuckme69.club",
    "fucknloveme.top",
    "fuckrosoft.com",
    "fuckxxme.top",
    "fucsovics.com",
    "fucsovics.net",
    "fucsovics.org",
    "fudbuc.com",
    "fudgerub.com",
    "fuefreehzon.ga",
    "fuefreehzon.gq",
    "fuefreehzon.tk",
    "fuelyourtypography.com",
    "fuesculling.cf",
    "fuesculling.ga",
    "fuesculling.tk",
    "fuettertdasnetz.de",
    "fufrh4xatmh1hazl.cf",
    "fufrh4xatmh1hazl.ga",
    "fufrh4xatmh1hazl.gq",
    "fufrh4xatmh1hazl.ml",
    "fufrh4xatmh1hazl.tk",
    "fuheqy.info",
    "fuhil.xyz",
    "fuhoy.com",
    "fuirio.com",
    "fujefa.info",
    "fujifilmkaizen.com",
    "fujifilmlifescienceusa.com",
    "fujitv.cf",
    "fujitv.ga",
    "fujitv.gq",
    "fukaru.com",
    "fuke0551.com",
    "fuktard.co.in",
    "fulahx.ru",
    "fulhamfans.com",
    "fuliansan.com",
    "fullalts.cf",
    "fullbet88.org",
    "fullchannel.net",
    "fullfilmizle2.com",
    "fulll.stream",
    "fullmail.com",
    "fullmoviesonline.space",
    "fulloirai.cf",
    "fulloirai.ga",
    "fulloirai.ml",
    "fulloirai.tk",
    "fullsemntg.ru",
    "fullsignal.net",
    "fullsohbetler.xyz",
    "fullssa-naver.xyz",
    "fullstackscrum.com",
    "fultonsheen.net",
    "fulvie.com",
    "fuming.net",
    "fumosity.site",
    "fumw7idckt3bo2xt.ga",
    "fumw7idckt3bo2xt.ml",
    "fumw7idckt3bo2xt.tk",
    "fun-cook.info",
    "fun-dot.ru",
    "fun-kk.com",
    "fun2.biz",
    "fun2night.club",
    "fun417.xyz",
    "fun64.com",
    "fun64.net",
    "funaro.org",
    "funb201.com",
    "funb301.com",
    "funb401.com",
    "funbangsan.ga",
    "funbangsan.gq",
    "funbangsan.ml",
    "funbet360.xyz",
    "funcat.best",
    "functionalfullstackenterprise.com",
    "functionalgeekery.net",
    "functionalneurologicrehab.com",
    "functionaryyyu.fun",
    "funda-foundation.com",
    "fundacionretoaguasabiertas.org",
    "fundadream.online",
    "fundament.site",
    "fundamentallifescore.com",
    "fundamenty-pod-klyuch.ru",
    "fundewa.com",
    "fundgrowth.club",
    "fundingsources.info",
    "fundoomails.com",
    "fundraisingak.com",
    "fundry.xyz",
    "funeralservicesgoldcoast.com",
    "funexpert.info",
    "funfriends.org",
    "fungiftsforher.com",
    "funhie.com",
    "funinn.biz",
    "funiran.com",
    "funiyipe.site",
    "funkfan.com",
    "funkleswhiru.tk",
    "funktionsstrumpor.se",
    "funky4.com",
    "funkyboxer.com",
    "funkymail.dk",
    "funlete.cf",
    "funlete.ga",
    "funlete.gq",
    "funlocen.ga",
    "funlocen.tk",
    "funminecraftservers.us",
    "funnel.events",
    "funnelcouponbook.com",
    "funnelpipe.net",
    "funnelpipe.org",
    "funnelpipes.org",
    "funnelprofitswebinar.com",
    "funnelvswebsite.com",
    "funnet.shop",
    "funnfests.com",
    "funnieday.online",
    "funny-ecards.com",
    "funny-mom.ru",
    "funny-moments.site",
    "funny9flix.site",
    "funnycodesnippets.com",
    "funnyfev.xyz",
    "funnyinde.buzz",
    "funnylawyer.com",
    "funnymail.de",
    "funnypetpictures.com",
    "funnyrabbit.icu",
    "funnysmell.info",
    "funnyve.icu",
    "funprogoods.ru",
    "funriataty.com",
    "funriataty.icu",
    "funsportsgames.com",
    "funsv.shop",
    "funthingsoutdoor.com",
    "funtriviagame.com",
    "funxl.tk",
    "funxmail.ga",
    "funxs.tk",
    "funxxxx.xyz",
    "funyou.info",
    "fuorissimo.com",
    "fupdate.site",
    "fuqi.info",
    "fuqq.org",
    "fuqus.com",
    "fureverafteradopt.org",
    "furieus.com",
    "furigo.ru",
    "furiousangel.com",
    "furmol.website",
    "furnicular.site",
    "furnitureliquidationconsultants.com",
    "furnitureprovider.com",
    "furnituresanddecor.com",
    "furnitureshop.futbol",
    "furnitureshop.life",
    "furosemide247.video",
    "furrydesires.info",
    "furryprofiles.com",
    "fursuit.info",
    "fursuitcircus.com",
    "furthernewsun.best",
    "furusato.tokyo",
    "furycraft.ru",
    "furzauflunge.de",
    "fuse.net",
    "fusemail.com",
    "fusioninvoice.net",
    "fusixgasvv1gbjrbc.cf",
    "fusixgasvv1gbjrbc.ga",
    "fusixgasvv1gbjrbc.gq",
    "fusixgasvv1gbjrbc.ml",
    "fusixgasvv1gbjrbc.tk",
    "fussilblld.site",
    "fusskitzler.de",
    "fussycataractgrove.site",
    "fut.es",
    "futoboutique.site",
    "futod.xyz",
    "future-buy-mega.ru",
    "future-planet.ru",
    "future-sale-buy.ru",
    "futureallstars.net",
    "futurebuckets.com",
    "futureforkid.org",
    "futuregood.pw",
    "futureneutral.online",
    "futureof2019.info",
    "futureofscholarship.org",
    "futureon.tech",
    "futureplan4u.com",
    "futureteam.club",
    "futurevoicesofnewmexico.blog",
    "futzal.org",
    "fuuken.com",
    "fuuyoh.com",
    "fuvesupermart.site",
    "fuvptgcriva78tmnyn.cf",
    "fuvptgcriva78tmnyn.ga",
    "fuvptgcriva78tmnyn.gq",
    "fuvptgcriva78tmnyn.ml",
    "fuw65d.cf",
    "fuw65d.ga",
    "fuw65d.gq",
    "fuw65d.ml",
    "fuw65d.tk",
    "fuwa.be",
    "fuwa.li",
    "fuwamofu.com",
    "fuwwoi.info",
    "fuwy.site",
    "fux0ringduh.com",
    "fuxufilter.online",
    "fuxufilter.xyz",
    "fuxufiltration.xyz",
    "fuxufiltre.xyz",
    "fuyapiinsaat.com",
    "fuzimill.site",
    "fuzzpopstudio.com",
    "fuzzytoad.com",
    "fveiowmi.space",
    "fvg5fvrv4.win",
    "fvhnqf7zbixgtgdimpn.cf",
    "fvhnqf7zbixgtgdimpn.ga",
    "fvhnqf7zbixgtgdimpn.gq",
    "fvhnqf7zbixgtgdimpn.ml",
    "fvhnqf7zbixgtgdimpn.tk",
    "fvmpt7.club",
    "fvqpejsutbhtm0ldssl.ga",
    "fvqpejsutbhtm0ldssl.ml",
    "fvqpejsutbhtm0ldssl.tk",
    "fvsxedx6emkg5eq.gq",
    "fvsxedx6emkg5eq.ml",
    "fvsxedx6emkg5eq.tk",
    "fvuch7vvuluqowup.cf",
    "fvuch7vvuluqowup.ga",
    "fvuch7vvuluqowup.gq",
    "fvuch7vvuluqowup.ml",
    "fvuch7vvuluqowup.tk",
    "fvurtzuz9s.cf",
    "fvurtzuz9s.ga",
    "fvurtzuz9s.gq",
    "fvurtzuz9s.ml",
    "fvurtzuz9s.tk",
    "fvusale.top",
    "fvwozi.us",
    "fw-nietzsche.cf",
    "fw-nietzsche.ga",
    "fw-nietzsche.gq",
    "fw-nietzsche.ml",
    "fw-nietzsche.tk",
    "fw.moza.pl",
    "fw2.me",
    "fw4px9.com",
    "fw6m0bd.com",
    "fw9tkv.us",
    "fwbfleamarket.gccoxmail.com",
    "fwca.xyz",
    "fwd2m.eszett.es",
    "fweurccje.shop",
    "fwgybr.us",
    "fwiqvv.site",
    "fwnb.com",
    "fx15.website",
    "fx3666.com",
    "fx3777.com",
    "fx3888.com",
    "fx4666.com",
    "fx5666.com",
    "fx5999.com",
    "fx6111.com",
    "fx6333.com",
    "fx7444.com",
    "fx8333.com",
    "fx8999.com",
    "fx9111.com",
    "fx9555.com",
    "fxfmail.com",
    "fxgirl.net",
    "fxkuva.us",
    "fxmail.ws",
    "fxmarkets1000.com",
    "fxmender.com",
    "fxnxs.com",
    "fxokpp.rest",
    "fxprix.com",
    "fxsmails.com",
    "fxsuppose.com",
    "fxunity.biz",
    "fxvks.site",
    "fxxx.site",
    "fy4rro.us",
    "fy6.app",
    "fy9.app",
    "fyad7b.site",
    "fybdc1.site",
    "fybglz.tokyo",
    "fycu.site",
    "fydffh1-priviut.fun",
    "fydffh1-priviut.info",
    "fydffh1-priviut.site",
    "fydffh1-priviut.space",
    "fydffh1-priviut.xyz",
    "fyii.de",
    "fyimm.com",
    "fyjiwa.com",
    "fynuas6a64z2mvwv.cf",
    "fynuas6a64z2mvwv.ga",
    "fynuas6a64z2mvwv.gq",
    "fynuas6a64z2mvwv.ml",
    "fynuas6a64z2mvwv.tk",
    "fyov.email",
    "fyvznloeal8.cf",
    "fyvznloeal8.ga",
    "fyvznloeal8.gq",
    "fyvznloeal8.ml",
    "fyvznloeal8.tk",
    "fyys.life",
    "fyziotrening.sk",
    "fyzjgt.site",
    "fz-gamvar1.ru",
    "fzahafriyat.xyz",
    "fzbdfyy.com",
    "fziex.com",
    "fzlol.us",
    "fztvgltjbddlnj3nph6.cf",
    "fztvgltjbddlnj3nph6.ga",
    "fztvgltjbddlnj3nph6.gq",
    "fztvgltjbddlnj3nph6.ml",
    "fzyutqwy3aqmxnd.cf",
    "fzyutqwy3aqmxnd.ga",
    "fzyutqwy3aqmxnd.gq",
    "fzyutqwy3aqmxnd.ml",
    "fzyutqwy3aqmxnd.tk",
    "g-2018.ru",
    "g-asdjafwer.online",
    "g-chance.ru",
    "g-ffd.ru",
    "g-mailer.site",
    "g-mailer.xyz",
    "g-mailix.com",
    "g-meil.com",
    "g-neurosystem.ru",
    "g-o-o-g-l-e.cf",
    "g-o-o-g-l-e.ga",
    "g-o-o-g-l-e.gq",
    "g-o-o-g-l-e.ml",
    "g-oproz.ru",
    "g-secretclass.website",
    "g-shoponline.info",
    "g-timyoot.ga",
    "g.hmail.us",
    "g.pl",
    "g.risd.edu",
    "g.ycn.ro",
    "g00g.cf",
    "g00g.ga",
    "g00g.gq",
    "g00g.ml",
    "g00g13.tk",
    "g00gl3.gq",
    "g00gl3.ml",
    "g00glechr0me.cf",
    "g00glechr0me.ga",
    "g00glechr0me.gq",
    "g00glechr0me.ml",
    "g00glechr0me.tk",
    "g00gledrive.ga",
    "g00ib.com",
    "g04p3.us",
    "g05uo.site",
    "g05zeg9i.com",
    "g0qva.us",
    "g0zr2ynshlth0lu4.cf",
    "g0zr2ynshlth0lu4.ga",
    "g0zr2ynshlth0lu4.gq",
    "g0zr2ynshlth0lu4.ml",
    "g0zr2ynshlth0lu4.tk",
    "g1118.com",
    "g1119.com",
    "g14l71lb.com",
    "g1bet.com",
    "g1ca82.us",
    "g1hgun.us",
    "g1xmail.top",
    "g20-publications.org",
    "g2020.ru",
    "g212dnk5.com",
    "g22444.com",
    "g22666.com",
    "g2dcli.us",
    "g2tpv9tpk8de2dl.cf",
    "g2tpv9tpk8de2dl.ga",
    "g2tpv9tpk8de2dl.gq",
    "g2tpv9tpk8de2dl.ml",
    "g2tpv9tpk8de2dl.tk",
    "g2xmail.top",
    "g368.online",
    "g3nk2m41ls.ga",
    "g3nkz-m4ils.ga",
    "g3nkzmailone.ga",
    "g3xmail.top",
    "g4444mail.com",
    "g4hdrop.us",
    "g4o.ru",
    "g4qmkw.us",
    "g4re71kk.xyz",
    "g50hlortigd2.ga",
    "g50hlortigd2.ml",
    "g50hlortigd2.tk",
    "g50pb.site",
    "g56ce.com",
    "g57sn.site",
    "g59xg.space",
    "g5tony.ru",
    "g66ez.space",
    "g6cjd4.site",
    "g6ijuf.site",
    "g7665.com",
    "g77og.site",
    "g78qp.com",
    "g7kvam.us",
    "g7lkrfzl7t0rb9oq.cf",
    "g7lkrfzl7t0rb9oq.ga",
    "g7lkrfzl7t0rb9oq.gq",
    "g7lkrfzl7t0rb9oq.ml",
    "g7lkrfzl7t0rb9oq.tk",
    "g7n.xyz",
    "g7rnu96pk4zv5mu.xyz",
    "g7sz9n.online",
    "g7tsiv.us",
    "g9dxbu.us",
    "g9pneh.info",
    "ga-shop.online",
    "ga46kd.xyz",
    "ga7yhd.host",
    "ga9dho.info",
    "gaaffshop.store",
    "gaairlines.com",
    "gababiotics.com",
    "gabbf.com",
    "gabbygiffords.com",
    "gabbysgoodstuff.info",
    "gabbysgoodstuff.net",
    "gabbysgoodstuff.org",
    "gabekey.ru",
    "gabescott.co",
    "gabice.info",
    "gabineteeconomico.com",
    "gableavlf.space",
    "gabooster.com",
    "gabox.store",
    "gabrieldunn.buzz",
    "gabrieljarvis.buzz",
    "gabrielshmidt.com",
    "gaby.social",
    "gabydino.com",
    "gacas-1dax.ru",
    "gacaterpillar.com",
    "gaccula.ga",
    "gaccula.ml",
    "gaccula.tk",
    "gachngay.com",
    "gacifa.info",
    "gacoky.info",
    "gacus5.us",
    "gadefejer.dk",
    "gadenmonastery.org",
    "gadgethitsshop.com",
    "gadgetliv.club",
    "gadgetsparadijs.online",
    "gadingbola.info",
    "gads-88.com",
    "gadsnela.ga",
    "gadsnela.gq",
    "gadsnela.ml",
    "gadsnela.tk",
    "gaf-net.dk",
    "gaf.oseanografi.id",
    "gaf4uv.us",
    "gafemarket.site",
    "gafslr.icu",
    "gafy.net",
    "gag16dotw7t.cf",
    "gag16dotw7t.ga",
    "gag16dotw7t.gq",
    "gag16dotw7t.ml",
    "gag16dotw7t.tk",
    "gagainter.com",
    "gagalive.shop",
    "gaggle.net",
    "gaha.site",
    "gaiaplanet.org",
    "gaiasgarden.online",
    "gaiasgarden.shop",
    "gaibrubfor.cf",
    "gaierdun.com",
    "gailymealtimegrown.site",
    "gainready.com",
    "gainstronghealthymuscles.com",
    "gainyournewsmarttech.review",
    "gaivolgsi.cf",
    "gaivolgsi.ga",
    "gajahtoto.org",
    "gajesajflk.cf",
    "gajesajflk.gq",
    "gajjmorit.ru",
    "gakbec.us",
    "gakkurang.com",
    "gal5.com",
    "gal8.com",
    "galabettv22.com",
    "galabettv25.com",
    "galainfos.com",
    "galamat.ru",
    "galamb.net",
    "galangshop.ga",
    "galangstore.live",
    "galasewrq.online",
    "galaxy-s9.cf",
    "galaxy-s9.ga",
    "galaxy-s9.gq",
    "galaxy-s9.ml",
    "galaxy-s9.tk",
    "galaxy.tv",
    "galaxy20.xyz",
    "galaxy5.com",
    "galaxyarmy.tech",
    "galaxybetting48.com",
    "galaxybetting50.com",
    "galaxyhit.com",
    "galaxyrc.online",
    "galaxyrc.store",
    "galaxys8giveaway.us",
    "galbuluueg.space",
    "galcake.com",
    "galco.dev",
    "galdb.com",
    "galenwalter.com",
    "galerielarochelle.com",
    "galeswordfoul.website",
    "gali-village.ru",
    "galice.info",
    "galinastadnik.ru",
    "galismarda.com",
    "gallatinriver.net",
    "galleriafourty.com",
    "gallerwdcm.space",
    "gallery-annabi.org",
    "gallery-des-artistes.com",
    "gallerypruva.xyz",
    "gallfly.online",
    "gallowayandfern.com",
    "gallowspointgg.com",
    "gally.jp",
    "galmarino.com",
    "galotrf.site",
    "galshotel.ru",
    "galsns.com",
    "galtool.com",
    "galurl.com",
    "galuzino.ru",
    "gam1fy.com",
    "gamail.top",
    "gamar.fun",
    "gamarraonline.com",
    "gambling-land.ru",
    "gambling4me.ru",
    "gamdspot.com",
    "game-drop.ru",
    "game-host.org",
    "game-plus.online",
    "game-rus.com",
    "game-server.cc",
    "game-stock.ru",
    "game-with.com",
    "game-zakup.ru",
    "game.com",
    "game1922.com",
    "game2.de",
    "game2533.com",
    "game5262.com",
    "gameaddiction.rehab",
    "gameazart.ru",
    "gamebaikingfun.net",
    "gamebean.ru",
    "gamebox.com",
    "gamebox.net",
    "gamechangingsalesperformance.com",
    "gamecheats.best",
    "gamecity888.com",
    "gamecredits.shop",
    "gamecrook.net",
    "gamecrook.org",
    "gamedeal.ru",
    "gamedevshop.ru",
    "gamedistri.com",
    "gamedistribution.app",
    "gamedoithuongking.com",
    "gameforlove.org",
    "gamegeek.com",
    "gamegild.ru",
    "gamegoldies.org",
    "gamegowin.net",
    "gamegregious.com",
    "gameloli.com",
    "gamemacao.site",
    "gamemanoidstore.com",
    "gameme.men",
    "gamemoney.app",
    "gamenewclam.ru",
    "gamenewkite.ru",
    "gamenewpen.ru",
    "gamenewrat.ru",
    "gameon1ine.ru",
    "gameonsports.live",
    "gameonsportscenter.com",
    "gameonsportslive.com",
    "gamepi.ru",
    "gamepromotion.ru",
    "gameps5.ga",
    "gameps5.ml",
    "gamequocte.com",
    "gamer-market.net",
    "gamer.watch",
    "gameran.ru",
    "gamerfu.com",
    "gamersbrand.com",
    "gamersland.club",
    "gamerslive-shop.ru",
    "games-box.info",
    "games-germany.xyz",
    "games-hosts.com",
    "games.com",
    "games4free.flu.cc",
    "gamescouncilsite.com",
    "gamesemperiom.net",
    "gameslabs.org",
    "gamesliga.biz",
    "gamesliga.net",
    "gamesofthefarm.com",
    "gamespoool.org",
    "gamesportal.me",
    "gamespotmail.com",
    "gamesredsite.club",
    "gamesstreetnews.com",
    "gamestips.ru",
    "gametalks.ru",
    "gameterrain.info",
    "gamethegames.com",
    "gametv.biz",
    "gametv.pro",
    "gamgling.com",
    "gamil.com",
    "gamil.com.au",
    "gaming90.org",
    "gamingant.com",
    "gamingday.com",
    "gaminoageny.com",
    "gamisfolia.com",
    "gammageandburnham.com",
    "gammicism.site",
    "gamno.config.work",
    "gamora274ey.cf",
    "gamora274ey.ga",
    "gamora274ey.gq",
    "gamora274ey.ml",
    "gamora274ey.tk",
    "gamosbaptish.com",
    "gamosvaptisi.net",
    "gamr15.org",
    "gamvip-com.app",
    "gandepiaoliang.com",
    "ganeshajitu.net",
    "ganeshajitu.org",
    "ganeshatogel.com",
    "gangbazip2.club",
    "gangcheng-guoji.com",
    "gangchengguoji.com",
    "gangkindter.ga",
    "gangkindter.gq",
    "gangkindter.tk",
    "gangu.cf",
    "gangu.gq",
    "gangu.ml",
    "gangy.world",
    "ganhardinheironainternethj.com",
    "ganjipakhsh.shop",
    "ganninarnold.com",
    "ganohoy.com",
    "ganslodot.top",
    "gansupwdjs.ru",
    "gantellikz.info",
    "gantellir.info",
    "gantraca.ga",
    "ganyanhesaplama.xyz",
    "ganymexujl.space",
    "ganzhe4.app",
    "ganzhe6.app",
    "ganzhe7.app",
    "ganzhe8.app",
    "ganzhe9.app",
    "gaojie.live",
    "gaolcostingfuse.website",
    "gaoqingtaotu.com",
    "gaoqingwuma.com",
    "gaoxiao2.biz",
    "gap0.net",
    "gap0.social",
    "gapemail.ga",
    "gapl.ru",
    "gapo.club",
    "gapo.info",
    "gapo.pro",
    "gapo.vip",
    "gapsapp.com",
    "gapu23n23swc08f.xyz",
    "garage-saint-chamond.xyz",
    "garage46.com",
    "garageamazon.com",
    "garagecfcaron.com",
    "garagedoor.marketing",
    "garagedoors-pa.com",
    "garantibuyutucu.xyz",
    "garantipazar.com",
    "garantweb.com",
    "garapraisal.com",
    "garasikita.pw",
    "garatoi.com",
    "garbage.com",
    "garbagecollector.org",
    "garbagemail.org",
    "garbagepossessionensure.website",
    "garcia-y-vega.biz",
    "gardel.org",
    "gardemaks-official.space",
    "gardemaks-official.website",
    "garden-of-vegan.com",
    "gardencourt.online",
    "gardener.com",
    "gardengift.info",
    "gardeningtips.shop",
    "gardeniom.com",
    "gardenpavingonline.net",
    "gardenscape.ca",
    "gardensgrow.com",
    "gardenshop.futbol",
    "gardentamcoc.com",
    "gardgispa.cf",
    "gardgispa.ga",
    "gardn.net",
    "garfield-game.ru",
    "garfieldsurvival.info",
    "garingsin.cf",
    "garingsin.ga",
    "garingsin.gq",
    "garingsin.ml",
    "garizo.com",
    "garlandaccidentlawyers.com",
    "garlandnailsalons.com",
    "garliclife.com",
    "garlicmedia.site",
    "garlicteaorjinal.site",
    "garlictearesmi.site",
    "garlictearesmisatis.info",
    "garlictearesmisatis.site",
    "garlictesatis.site",
    "garmineshop.com",
    "garnettinvestmentstrategies.com",
    "garnettmailer.com",
    "garoth.com",
    "garqelo.com",
    "garrifulio.mailexpire.com",
    "garruko.ga",
    "garrulous.me",
    "garry-potter.net",
    "garrymccooey.com",
    "garrynacov.cf",
    "garsasd.club",
    "garsvisi.gq",
    "garsvisi.ml",
    "garu.site",
    "garudaesports.com",
    "garyburge.net",
    "garykruegerdds.com",
    "garyshaw.net",
    "gasech.xyz",
    "gashik.site",
    "gasly.info",
    "gasofmass.com",
    "gason.dk",
    "gasp.live",
    "gaspariniadv.com",
    "gaspworkoutwear.com",
    "gasspecsa.info",
    "gasssboss.club",
    "gastchalga.ga",
    "gastchalga.ml",
    "gastchalga.tk",
    "gastivist.org",
    "gastroioyb.space",
    "gastrolekars.ru",
    "gastsandang.ga",
    "gastsandang.ml",
    "gastterpie.gq",
    "gastterpie.ml",
    "gastterpie.tk",
    "gasztrofalu.com",
    "gatamala.com",
    "gate-repair-thousandoaks.info",
    "gateway.net",
    "gatewaytube.com",
    "gathelabuc.almostmy.com",
    "gatherenmedia.com",
    "gatlisheco.icu",
    "gatmoka.com",
    "gato.com",
    "gato.gq",
    "gatosdebotella.icu",
    "gatosk.net",
    "gatwickemail.com",
    "gaubonghn.com",
    "gaudianosporthorses.com",
    "gauzemolv.space",
    "gav0.com",
    "gavasol-url1.ru",
    "gavelhost.com",
    "gavinmeetings.com",
    "gavyedekparca.com",
    "gawab.com",
    "gawhatsapp.com",
    "gawuxu.xyz",
    "gay-kontakte.online",
    "gay.com",
    "gay.theworkpc.com",
    "gayboysi.com",
    "gaybrighton.co.uk",
    "gaycock.ru",
    "gaydaddy.ga",
    "gaydatingheaven.com",
    "gayflorida.net",
    "gayken.org",
    "gaymail2020.com",
    "gaymoskva.net",
    "gaynewworkforce.com",
    "gayoranges.com",
    "gayrimenkuluniversitesi.com",
    "gaytag.club",
    "gaz-inv1st.space",
    "gaz-invesst.space",
    "gaz-promihlinost.space",
    "gaz-prominvest.ru",
    "gaza.net",
    "gazeta.pl",
    "gazetajavore.net",
    "gazetecizgi.com",
    "gaziantepara.xyz",
    "gaziantepbaca.online",
    "gaziantepbaca.xyz",
    "gazianteplitatlici.xyz",
    "gazibooks.com",
    "gaziemirfm.xyz",
    "gaziemirlisesi.xyz",
    "gazipasaklimaservisi.com",
    "gazoproekct.space",
    "gb-1004.com",
    "gb186.site",
    "gb6.ru",
    "gbamld.best",
    "gbcmail.win",
    "gbf48123.com",
    "gbgb1234.com",
    "gbh1h.us",
    "gbkfho.us",
    "gbkutf8.com",
    "gbmail.top",
    "gbmouldings.com",
    "gbnbancorp.com",
    "gbois-stav.ru",
    "gbouquete.com",
    "gbqetv.info",
    "gbqtfm.com",
    "gbuyeasy.com",
    "gbvm.email",
    "gbxuums.com",
    "gbz01nn6.xyz",
    "gcamhmgt.shop",
    "gcaoa.org",
    "gcasino.fun",
    "gcbcdiet.com",
    "gcc-ibt.us",
    "gcc.edu",
    "gcc138.com",
    "gcciw.org",
    "gcdj168.com",
    "gcei3r.com",
    "gcf84z.us",
    "gchatz.ga",
    "gci.net",
    "gckgw.info",
    "gclubscr888.com",
    "gcmail.top",
    "gcosmic.ru",
    "gcp.ong",
    "gcsoftware.ru",
    "gctqlypk.shop",
    "gcvqin.us",
    "gcwjw.info",
    "gcyacademy.com",
    "gczbpbe.site",
    "gcznu5lyiuzbudokn.ml",
    "gcznu5lyiuzbudokn.tk",
    "gd5ose.online",
    "gd6ubc0xilchpozgpg.cf",
    "gd6ubc0xilchpozgpg.ga",
    "gd6ubc0xilchpozgpg.gq",
    "gd6ubc0xilchpozgpg.ml",
    "gd6ubc0xilchpozgpg.tk",
    "gdacg.com",
    "gdbpag.site",
    "gdcmedia.info",
    "gdcp84.com",
    "gdcp868.com",
    "gde-vzyat-ipoteku.ru",
    "gde-zaim.online",
    "gdekupit5.ru",
    "gdemuzon.ru",
    "gdfsafdhbag.website",
    "gdgoodjob.com",
    "gdgreat.online",
    "gdgreat.ru",
    "gdhkftp.com",
    "gdi.net",
    "gdjdjqok.shop",
    "gdkhox.us",
    "gdl1rr.site",
    "gdmail.top",
    "gdmalls.com",
    "gdprcompliance.expert",
    "gdprcompliance.solutions",
    "gdqdp2.us",
    "gdqzhv.com",
    "gdtjh.com",
    "gdyiyh.us",
    "gdynia.ru",
    "ge991.buzz",
    "geadventure.com",
    "geararticles.com",
    "gearhead.app",
    "gearheads.us",
    "geartower.com",
    "gearyourfuture.com",
    "geauxday.com",
    "geaviation.cf",
    "geaviation.ga",
    "geaviation.gq",
    "geaviation.ml",
    "geaviation.tk",
    "gebicy.info",
    "gebyarbet.info",
    "gecici.ml",
    "gecotspeed04flash.ml",
    "gedagang.com",
    "geddesandjill.com",
    "gedmail.win",
    "gedore-rus.ru",
    "gedotvtan.shop",
    "gedungqq.site",
    "gee-wiz.com",
    "geecities.com",
    "geedt.icu",
    "geek-poster.ru",
    "geek.com",
    "geek.hu",
    "geekcheatsheets.com",
    "geekchiccouture.com",
    "geekforex.com",
    "geekhack.network",
    "geekhack.report",
    "geeklife.com",
    "geekology.com",
    "geekpursuits.com",
    "geekyogurt.tech",
    "geeqs.ru",
    "geew.ru",
    "geezmail.ga",
    "gef.global",
    "gefestglass.ru",
    "gefpmjsfq.shop",
    "gegealabama.com",
    "gegealaska.com",
    "gegearizona.com",
    "gegearkansas.com",
    "gehensiemirnichtaufdensack.de",
    "gehmitmiraus.xyz",
    "gehu.site",
    "geidragdio.ga",
    "geidragdio.gq",
    "geilmacher.com",
    "geimager.com",
    "gejaagd.online",
    "gekokerpde.tk",
    "gekury4221mk.cf",
    "gekury4221mk.ga",
    "gekury4221mk.gq",
    "gekury4221mk.ml",
    "gekury4221mk.tk",
    "gelarqq.com",
    "gelatinize510jw.xyz",
    "gelddestges.cf",
    "gelddestges.ga",
    "geldverdienenalstiener.online",
    "geldwaschmaschine.de",
    "gelegenheidsdatingsites.online",
    "gelendgiklove.ru",
    "gelenekselgulsuyu.com",
    "gelenium.ru",
    "geleti.cf",
    "geleti.ml",
    "gelitik.in",
    "gelnhausen.net",
    "gelomart.site",
    "geltopmarl.site",
    "geludkita.cf",
    "geludkita.ga",
    "geludkita.gq",
    "geludkita.ml",
    "geludkita.tk",
    "gemar-qq.live",
    "gemarbola.icu",
    "gemarbola.life",
    "gemarbola.link",
    "gemarbola.news",
    "gemardepo.online",
    "gemeentebanen.works",
    "gemient.com",
    "gemineans.co.uk",
    "gemmation.site",
    "gemsgallerythailand.ru",
    "gemsro.xyz",
    "gen.uu.gl",
    "gen16.me",
    "genallinutritionals.com",
    "genazvales.world",
    "genclikvemedeniyet.online",
    "genclikvemedeniyet.xyz",
    "gencmail.com",
    "gencurebiomanufacturing.com",
    "genderfuck.net",
    "genderuzsk.com",
    "gendutpoker.net",
    "gendutpoker.org",
    "genelmuteahhitlik.com",
    "genelmuteahhitlik.net",
    "generador.app",
    "general-casino.info",
    "general-electric.cf",
    "general-electric.ga",
    "general-electric.gq",
    "general-electric.ml",
    "general-hospital.com",
    "general-motors.tk",
    "generalbatt.com",
    "generalhost.online",
    "generalinguistics.com",
    "generaltranz.top",
    "generationcrypto.ru",
    "generationscommunity.com",
    "generationym.org",
    "generator.email",
    "genericcrestor.website",
    "genericmedrol.info",
    "genericsautralia.com",
    "genericventolin.info",
    "generoushomebuyersllc.net",
    "generousoptions4all.net",
    "geneseeit.com",
    "geneticdisease.org",
    "genetics.farm",
    "genetics.shop",
    "genetiklab.com",
    "genetoken.community",
    "genevoid.com",
    "genicraft.ru",
    "geniusf.actor",
    "geniusfactor.dev",
    "genk5mail2.ga",
    "genkibit.com",
    "genkpoker2.xyz",
    "genmobile.net",
    "gennowhosting.com",
    "genoa-cafe-rush.com",
    "genoa-takeaway-athlone.com",
    "genoacaferush.com",
    "genoacafesallins.com",
    "genonema.com",
    "genserv.xyz",
    "gensetgas.com",
    "genshure.com",
    "gentakusumo.xyz",
    "gentlemancasino.com",
    "gentlemansclub.de",
    "gentlemensbarbershop.club",
    "genuosofa.com",
    "genusneyee.ru",
    "genusvnabf.space",
    "genx-training.com",
    "genxemail.com",
    "genys.best",
    "geo-crypto.com",
    "geo.gallery",
    "geobroodun.cf",
    "geobroodun.ga",
    "geobroodun.ml",
    "geocities.com",
    "geoclaven.ml",
    "geoclaven.tk",
    "geoclsbjevtxkdant92.cf",
    "geoclsbjevtxkdant92.ga",
    "geoclsbjevtxkdant92.gq",
    "geoclsbjevtxkdant92.ml",
    "geoclsbjevtxkdant92.tk",
    "geodeticdirections.info",
    "geodoo.xyz",
    "geography.net",
    "geokomponent.ru",
    "geologicpublications.net",
    "geologist.com",
    "geomail.win",
    "geopia.com",
    "georaster.info",
    "georestti.gq",
    "georestti.tk",
    "george-pooley.com",
    "georgeharvey.buzz",
    "georgehood.com",
    "georgeslaan.buzz",
    "georgeztxc.host",
    "georgia-tut.ru",
    "georgiamcdonald.buzz",
    "georgiamorley.buzz",
    "georgiamountainlakehouses.com",
    "georgiapearson.buzz",
    "georide2.app",
    "geospirit.de",
    "geostall.com",
    "geotage.gq",
    "geotage.tk",
    "geotamar.ga",
    "geotamar.gq",
    "geotamar.ml",
    "geotamar.tk",
    "geotemp.de",
    "geposel.gq",
    "geposel.ml",
    "geposel.tk",
    "geraldbull.org",
    "geraldinemoo.com",
    "geraldlover.org",
    "gerdese.online",
    "gerdimenta.ru",
    "gere.oazis.site",
    "gerenciagran.com",
    "gergilimembran.com",
    "gerhanajitu.net",
    "gerher3-privberh.fun",
    "gerher3-privberh.host",
    "gerher3-privberh.press",
    "gerher3-privberh.site",
    "gerher3-privberh.space",
    "gerher3-privberh.website",
    "geriatricos.page",
    "geristore.xyz",
    "gerkava.website",
    "germanmails.biz",
    "germanymail.com",
    "germanytoday.club",
    "germanyxon.com",
    "germemembran.com",
    "germinahah.space",
    "germred.site",
    "germsurfacegain.website",
    "gerncompmas.ga",
    "gerncompmas.tk",
    "gero.us",
    "geroev.net",
    "geronra.com",
    "gers-phyto.com",
    "gertenisembul.xyz",
    "gertyisacas.club",
    "gertyni.xyz",
    "ges-online.ru",
    "geschcahers.cf",
    "geschcahers.gq",
    "geschcahers.ml",
    "geschenk-ak.club",
    "geschenk-am.club",
    "geschenk-an.club",
    "geschenk-v.club",
    "geschenk-z.club",
    "geschent.biz",
    "gesotyb.tech",
    "gestiondefortune.info",
    "get-best-datings1.com",
    "get-best-prize11.life",
    "get-best-prize13.life",
    "get-best-prize4.life",
    "get-best-prize6.life",
    "get-best-proxy.xyz",
    "get-bestprize14.life",
    "get-bestprize2.life",
    "get-bestprize5.life",
    "get-biobalancelashes.com",
    "get-data-id-2.space",
    "get-dental-implants-key.live",
    "get-dental-implants-new.live",
    "get-dynafuzelash.com",
    "get-house-security-offer.market",
    "get-insurance.com",
    "get-interfxglassluxury.com",
    "get-interfxproductsofluxury.com",
    "get-liposuction-weightloss.live",
    "get-mail.cf",
    "get-mail.ga",
    "get-mail.ml",
    "get-mail.tk",
    "get-my-offer.club",
    "get-papistop.site",
    "get-psoriasis-solutions.market",
    "get-psoriasis-treatment.market",
    "get-thebonus-now6.life",
    "get-thebonus-now9.life",
    "get-truck-auto-spot.sale",
    "get-ultrazeel-luxury.com",
    "get.pp.ua",
    "get.tokyo",
    "get1mail.com",
    "get2mail.fr",
    "get365.pw",
    "get365.tk",
    "get3bs.com",
    "get417.xyz",
    "getairmail.cf",
    "getairmail.com",
    "getairmail.ga",
    "getairmail.gq",
    "getairmail.ml",
    "getairmail.tk",
    "getamailbox.org",
    "getandklj.gq",
    "getapet.info",
    "getapet.net",
    "getapp.company",
    "getappraisers.com",
    "getaqu.info",
    "getautoloan.website",
    "getbet.host",
    "getblg.xyz",
    "getblgs.xyz",
    "getblogs.xyz",
    "getbonce.com",
    "getbreathegreencharcoal.com",
    "getbreathtaking.com",
    "getbriefr.com",
    "getcashstash.com",
    "getceen.com",
    "getcelloskinbylittlemonkey.com",
    "getchina.ru",
    "getcloudmango.net",
    "getcmoji.com",
    "getcoolmail.info",
    "getcorkgenius.com",
    "getcustomdesigns.site",
    "getdarkfast.com",
    "getdocumentsdone.info",
    "getdocumentsdone.org",
    "getebookclick.com",
    "geteit.com",
    "getemail9.com",
    "getevange.com",
    "getevangelised.com",
    "getfrntrw.online",
    "getfun.men",
    "gethappysound.com",
    "getimpromptu.com",
    "getinboxes.com",
    "getinsuranceforyou.com",
    "getintopci.com",
    "getisrael.com",
    "getjulia.com",
    "getkl.site",
    "getknot.app",
    "getlesshot.cf",
    "getlesshot.ga",
    "getlesshot.ml",
    "getlink.website",
    "getllcservices.com",
    "getlostin.com",
    "getmaidanapinola.com",
    "getmails.eu",
    "getmails.tk",
    "getmaptab.com",
    "getmba.ru",
    "getmemyname.com",
    "getmethefouttahere.com",
    "getmy417.xyz",
    "getmygoods.cloud",
    "getmygooods.store",
    "getmyip.com",
    "getnada.cf",
    "getnada.com",
    "getnada.ga",
    "getnada.gq",
    "getnada.ml",
    "getnada.tk",
    "getnetfx.website",
    "getnflxnw.website",
    "getnowdirect.com",
    "getnowtoday.cf",
    "getobeslim.host",
    "getocity.com",
    "getofferoline.space",
    "getoffmylawn.org",
    "getoffrentohio.com",
    "getonemail.com",
    "getonemail.net",
    "getpdfmanuales.xyz",
    "getprogramstart.com",
    "getridofsteve.com",
    "getruvi.com",
    "gets-it.net",
    "getsamar.com",
    "getscripts.org",
    "getsewingfit.website",
    "getsimpleemail.com",
    "getspringsfast.com",
    "getstructuredsettlement.com",
    "getstuffedgoogle.com",
    "gett.icu",
    "gettempmail.com",
    "getthemp3.com",
    "gettinga.buzz",
    "gettinhas.ml",
    "gettopubg.com",
    "gettruck-autospot.sale",
    "gettruvi.com",
    "getty-home.com",
    "getty-lab.com",
    "getty-labs.com",
    "gettyam.com",
    "gettycap.com",
    "gettycm.com",
    "gettyeng.com",
    "gettyfamilyoffice.com",
    "gettyfo.com",
    "gettyfour.com",
    "gettygolf.com",
    "gettygrowth.com",
    "gettyinvest.com",
    "gettyoffice.com",
    "gettyprojects.com",
    "gettysburgfoundation.info",
    "gettysburgleadership.org",
    "gettyscienceengineering.com",
    "gettysecretariat.com",
    "gettysf.com",
    "gettysp.com",
    "getupagain.org",
    "getvid.me",
    "getvmail.net",
    "getvpn.net",
    "getwaterpulse.com",
    "getworlddirect.com",
    "getyougadgets.com",
    "getyourstudy.ru",
    "getyourtantraon.com",
    "gevemarket.site",
    "gewinner-pose.com",
    "geykurword.cf",
    "geykurword.ga",
    "geykurword.gq",
    "geykurword.tk",
    "gezikolik.com",
    "gf15f1g.live",
    "gf7w.com",
    "gfades.site",
    "gfan.gvoice.men",
    "gfbjnu.com",
    "gfcnet.com",
    "gfcom.com",
    "gfdbnmy21.info",
    "gfdbnmy21.website",
    "gfdc-bfdvd-dvs.online",
    "gfdyhrtyre.site",
    "gffcqpqrvlps.cf",
    "gffcqpqrvlps.ga",
    "gffcqpqrvlps.gq",
    "gffcqpqrvlps.tk",
    "gfftxn.com",
    "gflwpmvasautt.cf",
    "gflwpmvasautt.ga",
    "gflwpmvasautt.gq",
    "gflwpmvasautt.ml",
    "gflwpmvasautt.tk",
    "gfmail.cf",
    "gfmail.ga",
    "gfmail.gq",
    "gfmail.tk",
    "gfpiz1.site",
    "gfpqlk.info",
    "gfqmpn.tokyo",
    "gfsbilling.com",
    "gfsc.global",
    "gfsw.de",
    "gftodtyl.shop",
    "gftpf.live",
    "gful.fun",
    "gful.store",
    "gful.us",
    "gfwjrmpa.shop",
    "gfwlist.com",
    "gfwsbs.us",
    "gfxartist.ru",
    "gfxtool.buzz",
    "gfyule8.com",
    "gfzju.site",
    "gg-byron.cf",
    "gg-byron.ga",
    "gg-byron.gq",
    "gg-byron.ml",
    "gg-byron.tk",
    "gg-maramont.ru",
    "gg-squad.ml",
    "gg-zma1lz.ga",
    "gg018.space",
    "gg019.space",
    "gg022.space",
    "gg023.space",
    "gg024.space",
    "gg025.space",
    "gg18269.com",
    "gg57822.com",
    "gg7665.com",
    "gg9094.com",
    "ggame3.site",
    "ggame3.xyz",
    "ggamerandomly.buzz",
    "ggbb45452.com",
    "ggbc.email",
    "ggbrop.net",
    "ggedell.site",
    "ggergerherhhrehrgfd.club",
    "ggfd.de",
    "ggfutsal.cf",
    "ggg.pp.ua",
    "ggg062.com",
    "ggg813.com",
    "ggg9827.com",
    "gggt.de",
    "gggzh.com",
    "ggigasetk.site",
    "ggigasharee.site",
    "ggijhd.com",
    "ggiq.cn",
    "ggmail.guru",
    "ggmob-us.fun",
    "ggobu.net",
    "ggp58.com",
    "ggpb.us",
    "ggqfuc.rest",
    "ggr-supportservices.com",
    "ggroop.info",
    "ggworxrld.shop",
    "gh2000.com",
    "gh2xuwenobsz.cf",
    "gh2xuwenobsz.ga",
    "gh2xuwenobsz.gq",
    "gh2xuwenobsz.ml",
    "gh2xuwenobsz.tk",
    "gh5tdr.com",
    "gh8bk.us",
    "ghabzak.com",
    "ghanalandbank.com",
    "ghanamail.com",
    "ghanun.info",
    "ghdshophot.com",
    "ghea.ml",
    "gheadfisa.ga",
    "gheadfisa.gq",
    "gheadfisa.ml",
    "ghettoize768xv.online",
    "ghfh.de",
    "ghgluiis.tk",
    "ghiglianocinzia.com",
    "ghkyukjb7-privytfg.host",
    "ghkyukjb7-privytfg.press",
    "ghkyukjb7-privytfg.space",
    "ghkyukjb7-privytfg.xyz",
    "ghodrancomplex.com",
    "ghomonnirtel.site",
    "ghor.us",
    "ghork.live",
    "ghost4snapchat.com",
    "ghostbustersgeneration.com",
    "ghostcheck.xyz",
    "ghostgoop.icu",
    "ghostmail.com",
    "ghosttexter.de",
    "ghosttownmall.net",
    "ghosttownmall.org",
    "ghostyforinstagram.com",
    "ghqqmdqtgtqustunutqg.ru",
    "ghtr1q.us",
    "ghtreihfgh.xyz",
    "ghulamid.me",
    "ghxdw.info",
    "ghymau.us",
    "ghynvm.com",
    "gi816.space",
    "gi9z54.us",
    "giabbse.com",
    "giacmosuaviet.info",
    "giaiphapmuasam.com",
    "giallo.cf",
    "giallo.gq",
    "giallo.ml",
    "giallo.tk",
    "gianmendez.com",
    "gianna1121.club",
    "giantmail.de",
    "giantnetwerk.online",
    "giantsfan.com",
    "giantsuperstores.com",
    "giaoisgla35ta.cf",
    "giapham.com",
    "giapham.org",
    "giapratescon.tk",
    "giaveum.info",
    "gibejo.cf",
    "gibejo.ga",
    "gibejo.gq",
    "gibejo.ml",
    "gibejo.tk",
    "gibit.us",
    "gibligens.gq",
    "gibligens.ml",
    "gibligens.tk",
    "gibran88.com",
    "gibsonbigiron.net",
    "gibtelecom.net",
    "gicarep.cf",
    "gicarep.ga",
    "gicarep.tk",
    "gicua.com",
    "gidabankaciligizirvesi.com",
    "gidabankaciligizirvesi.info",
    "gidabankaciligizirvesi.net",
    "gidra-onion.club",
    "gidstomm.website",
    "gidtraveler.ru",
    "gidzdorov.ru",
    "giedewly.cf",
    "giedewly.gq",
    "giedewly.ml",
    "giedewly.tk",
    "giessdorf.eu.org",
    "gifanu.ga",
    "gifanu.ml",
    "gifenix.com.mx",
    "gifexpress.com",
    "gifjlc.tokyo",
    "gifletter.com",
    "gifmoe.com",
    "gifora.com",
    "gift-2020.site",
    "gift-link.com",
    "gift-listed.online",
    "gift-listed.space",
    "giftasdjafwer.online",
    "giftbasketinformation.com",
    "giftcardsgen.me",
    "giftedandcyber.com",
    "giftloss.us",
    "giftmobile.space",
    "giftnotruf.org",
    "gifto12.com",
    "giftproject.org",
    "giftsales.store",
    "giftsfromwalmart18.us",
    "giftsshopuss.com",
    "giftsspaces.com",
    "giftyello.ga",
    "giftyello.gq",
    "giga4u.de",
    "gigaclick.tech",
    "gigacylydm.space",
    "gigantmass.ru",
    "gigapesen.ru",
    "gigileung.org",
    "gigilyn.com",
    "gigisalumificio.biz",
    "gign-40.com",
    "gigpurchase.com",
    "gigs.craigslist.org",
    "gihybe.us",
    "gikemart.site",
    "gilaayam.com",
    "gilababi1.ml",
    "gilberthairsalons.com",
    "gilertelogg.xyz",
    "giles020.top",
    "giles037.top",
    "giles117.top",
    "giles129.top",
    "giles157.top",
    "giles164.top",
    "giles197.top",
    "giles198.top",
    "giles220.top",
    "giles232.top",
    "giles263.top",
    "giles291.top",
    "giles449.top",
    "gilfun.com",
    "gilireyke.com",
    "gillann.site",
    "gillovhjol.space",
    "gillsfans.co.uk",
    "gilmoreforpresident.com",
    "gilo.ml",
    "gilray.net",
    "gimal.com",
    "gimbalsstabilizer.futbol",
    "gimei.live",
    "gimesson.pe.hu",
    "gimmedat.info",
    "gimnasiolleno.com",
    "gimp.us",
    "gimpu.ru",
    "gimsa-renamun.ru",
    "gimshl.us",
    "gina18.online",
    "gina18.site",
    "gina18.space",
    "gina18.website",
    "ginbottlelamps.com",
    "gindatng.ga",
    "ginel.com",
    "gingerbruce55places.com",
    "gingervietnamese.com",
    "gingmeten.ga",
    "gingmeten.gq",
    "gingmeten.ml",
    "gingmeten.tk",
    "gingreree.cf",
    "gingreree.gq",
    "gingreree.ml",
    "gingreree.tk",
    "ginkkvetbor.cf",
    "ginkkvetbor.ga",
    "ginkkvetbor.gq",
    "ginkkvetbor.ml",
    "ginkkvetbor.tk",
    "ginn.cf",
    "ginn.gq",
    "ginn.ml",
    "ginn.tk",
    "ginnio.com",
    "ginnygorgeousleaf.com",
    "gino-takeaway.com",
    "ginos-takeaway-navan.com",
    "ginsarin.ga",
    "ginsarin.gq",
    "ginzi.be",
    "ginzi.co.uk",
    "ginzi.es",
    "ginzi.eu",
    "ginzi.net",
    "ginzy.co.uk",
    "ginzy.eu",
    "ginzy.org",
    "giocorsio.tk",
    "giogio.cf",
    "giogio.gq",
    "giogio.ml",
    "giohyrown.cf",
    "giohyrown.ga",
    "giohyrown.tk",
    "giooig.cf",
    "giooig.ga",
    "giooig.gq",
    "giooig.ml",
    "giooig.tk",
    "giordanofoundation.com",
    "giorgio.ga",
    "giotisi.cf",
    "giotisi.ga",
    "giotisi.gq",
    "giourabca.ga",
    "giourabca.gq",
    "giourabca.ml",
    "giourabca.tk",
    "giozs.us",
    "gipasco.cf",
    "gipasco.ga",
    "gipasco.gq",
    "gipasco.ml",
    "giplwsaoozgmmp.ga",
    "giplwsaoozgmmp.gq",
    "giplwsaoozgmmp.ml",
    "giplwsaoozgmmp.tk",
    "giqsru.com",
    "giraffe-school.online",
    "giran.club",
    "girbot.com",
    "giresunanaokulu.xyz",
    "giresunfoto.xyz",
    "giresunsuturunleri.com",
    "giresuntasari.com",
    "girisx.club",
    "girl-beautiful.com",
    "girl-cute.com",
    "girl-nice.com",
    "girl4god.com",
    "girlbo.shop",
    "girldiary.ru",
    "girlgear.us",
    "girlkiss.site",
    "girlmail.ru",
    "girlmail.win",
    "girlmanss.info",
    "girlmogulmagazine.com",
    "girlncool.com",
    "girlorgy.site",
    "girlpower2022.com",
    "girls54.pro",
    "girlsforfun.tk",
    "girlsindetention.com",
    "girlsu.com",
    "girlsundertheinfluence.com",
    "girlsx.online",
    "giromail.club",
    "girosgriegozaragoza.com",
    "gisella.herbert1818.site",
    "gishpuppy.com",
    "gisont.site",
    "gispgeph6qefd.cf",
    "gispgeph6qefd.ga",
    "gispgeph6qefd.gq",
    "gispgeph6qefd.ml",
    "gispgeph6qefd.tk",
    "gisthafea.cf",
    "gisthafea.ga",
    "gisthafea.gq",
    "gistnewgkal.cf",
    "gistnewgkal.gq",
    "gistnewgkal.ml",
    "gisttimens.cf",
    "gisttimens.ml",
    "gisttimens.tk",
    "git--help.com",
    "git-help.com",
    "gitarrenschule24.de",
    "github.best",
    "gitog.biz",
    "gitpost.icu",
    "gitstage.net",
    "gitumau.ga",
    "gitumau.ml",
    "gitumau.tk",
    "gityun.com",
    "giuras.club",
    "giutrtf6-privtuyfy.fun",
    "giutrtf6-privtuyfy.host",
    "giutrtf6-privtuyfy.press",
    "giutrtf6-privtuyfy.site",
    "giutrtf6-privtuyfy.space",
    "giutrtf6-privtuyfy.xyz",
    "giuypaiw8.com",
    "givdgive.shop",
    "giveaspyt.com",
    "giveaway-national-gift-weekly.club",
    "givecoast.com",
    "givedrop.xyz",
    "givegivd.shop",
    "giveh2o.info",
    "givememail.club",
    "givemeyourhand.info",
    "givemoney2018.ru",
    "givepeaceachance.com",
    "giverank.us",
    "giverprosperhotel.site",
    "givinglottery.org",
    "givity.ru",
    "givluip.ml",
    "givmail.com",
    "givmy.com",
    "givorlnjc.shop",
    "giyam.com",
    "gizlicennetkibris.com",
    "gizmobd.com",
    "gj96m.info",
    "gjbmyn.com",
    "gjbnyb.com",
    "gjcwao.com",
    "gjgklp.us",
    "gjhdizhi.com",
    "gjjgg.com",
    "gjkk.de",
    "gjknbb.com",
    "gjnqv.us",
    "gjrpegj15.host",
    "gjscw.info",
    "gjsrestoration.com",
    "gjysaw.info",
    "gjyuqd.us",
    "gk-konsult.ru",
    "gkcgrp.com",
    "gkcmds.fun",
    "gkcmfk.fun",
    "gkcmkk.fun",
    "gkcrhl.us",
    "gkd06.space",
    "gkdcsi.ru",
    "gkhmpj.fun",
    "gkjgsxupc.shop",
    "gklohe.rest",
    "gkmmcg.fun",
    "gkmmhq.fun",
    "gknmgd.fun",
    "gknmwk.fun",
    "gkolimp.ru",
    "gkplogistics.com",
    "gkqmfl.fun",
    "gkrmck.fun",
    "gkrmfz.fun",
    "gkrmnx.fun",
    "gkuaisyrsib8fru.cf",
    "gkuaisyrsib8fru.ga",
    "gkuaisyrsib8fru.gq",
    "gkuaisyrsib8fru.ml",
    "gkuaisyrsib8fru.tk",
    "gkvse.live",
    "gkwerto4wndl3ls.cf",
    "gkwerto4wndl3ls.ga",
    "gkwerto4wndl3ls.gq",
    "gkwerto4wndl3ls.ml",
    "gkwerto4wndl3ls.tk",
    "gkx87f-mail.xyz",
    "gkxmmk.fun",
    "gkxuem.site",
    "gkzbwv.com",
    "gkzmwf.fun",
    "gkznls.us",
    "gl-wk.com",
    "glabinas.ga",
    "glabinas.gq",
    "glabinas.ml",
    "glacialbottle.nu",
    "glacialbottle.org",
    "glacierfx.com",
    "glad-lottery.com",
    "gladchenko-coach.ru",
    "gladiator.org",
    "glados.life",
    "glakon.ru",
    "glareinstalmosquito.website",
    "glashatay.info",
    "glasrose.de",
    "glass-cleaner.ru",
    "glassaas.site",
    "glassdisplaydoorgaskets.com",
    "glasshorseventures.com",
    "glassided.space",
    "glassok-cheff.ru",
    "glasstowerwindows.com",
    "glasswareexchange.com",
    "glassworks.cf",
    "glastore.uno",
    "glatjobs.com",
    "glavlead.com",
    "glavsliv.club",
    "glawsaibrak.cf",
    "glawsaibrak.gq",
    "glawsaibrak.tk",
    "glay.org",
    "gle.best",
    "gleamlaau.space",
    "gleeze.com",
    "glendale.net",
    "glendalequote.com",
    "glendalerealestateagents.com",
    "glendenningflowerdesign.com",
    "glendepe.cf",
    "glendepe.gq",
    "glendepe.tk",
    "glenmontshoppingcenter.com",
    "glennvhalado.tech",
    "glenresearch.net",
    "glenresearch.org",
    "glessyturismo.com",
    "glfjvfqzo.shop",
    "glick.tk",
    "glidefea.xyz",
    "glidefun.xyz",
    "glidescal.us",
    "glidesh.icu",
    "glidesh.xyz",
    "gligsfall.ru",
    "glissecompany.ru",
    "glitch.sx",
    "glitchwave.it",
    "gliuk.ru",
    "gllwgnlzv.shop",
    "glmknm.com",
    "global-4d.com",
    "global-4d.online",
    "global-loto.ru",
    "global.coach",
    "global1markets.com",
    "global1trader.com",
    "global2.xyz",
    "global4d.online",
    "globalccashcard.com",
    "globalcitizenhub.com",
    "globaldisciple.org",
    "globaldomainnetwork.com",
    "globalelectrum.com",
    "globaleuro.net",
    "globalfinanceblog.club",
    "globalfree.it",
    "globalgossip.me",
    "globalii.xyz",
    "globalimiz.xyz",
    "globalinvestblog.club",
    "globalitcert.com",
    "globaliting.net",
    "globalkino.ru",
    "globallowdown.net",
    "globallowdown.org",
    "globalmarijuanashop.com",
    "globalmarketingcourse.com",
    "globalmeshlabs.dev",
    "globalmillionaire.com",
    "globalmotorsalgeria.com",
    "globalpagan.com",
    "globalpoker99.club",
    "globalpokerqq.net",
    "globalpolicynetwork.org",
    "globalsilverhawk.com",
    "globalsite.com.br",
    "globaltechnologyinnovation.info",
    "globaltechnologyinnovation.online",
    "globaltechnologyinnovation.org",
    "globaltouron.com",
    "globalwarmingproblemsolvers.org",
    "globegro.com",
    "globepaymentway2.com",
    "globetrotter.net",
    "globistackcampaign.com",
    "globlenews.xyz",
    "globlh.com",
    "globo.com",
    "globobet.com",
    "globocg.com",
    "globomail.com",
    "glocality.com",
    "glocalrecognition.com",
    "glocalrecognition.org",
    "glockneronline.com",
    "glocknershop.com",
    "glodaldate.fun",
    "gloflycbd.com",
    "glome.world",
    "glomtiotu.cf",
    "glomtiotu.gq",
    "glomtiotu.ml",
    "glomtiotu.tk",
    "gloomage.buzz",
    "gloomju.email",
    "gloomspeed.fun",
    "gloopyrobot.icu",
    "gloriajeens.ru",
    "gloryamuse.email",
    "glorych.xyz",
    "gloryfra.xyz",
    "glorylottory.com",
    "glorysteak.email",
    "glorytr.xyz",
    "glorytru.xyz",
    "glosspremierideal.site",
    "glossybee.com",
    "glowglories.com",
    "glowrecip.com",
    "glpbalcashcard.com",
    "glppncife.shop",
    "glqbsobn8adzzh.cf",
    "glqbsobn8adzzh.ga",
    "glqbsobn8adzzh.gq",
    "glqbsobn8adzzh.ml",
    "glqbsobn8adzzh.tk",
    "glrbio.com",
    "glsaimli.space",
    "glservice.online",
    "glspring.com",
    "gltrgundx.shop",
    "glu64.space",
    "glubex.com",
    "glucconsmi.ga",
    "glucconsmi.gq",
    "glucconsmi.ml",
    "glucconsmi.tk",
    "glucogen.store",
    "glucophage.website",
    "glucosegrin.com",
    "glues1.com",
    "glutenfreeallpurposebread.com",
    "glutenfreestaples.com",
    "glutesyourunlock.xyz",
    "glvihqen.xyz",
    "glxynews.site",
    "glycb.com",
    "glyctistre.cf",
    "glyctistre.ga",
    "glyctistre.gq",
    "glyctistre.ml",
    "glynda.space",
    "glynns-kitchen-pizzeria.com",
    "glyphosaurus.com",
    "gm-slots-casino.win",
    "gm-slots24.online",
    "gm5om.info",
    "gmabrands.com",
    "gmai.com",
    "gmaiil.ml",
    "gmaiil.us",
    "gmaiilll.cf",
    "gmaiilll.gq",
    "gmaiils.club",
    "gmail-fiji.gq",
    "gmail.ax",
    "gmail.cm",
    "gmail.cn",
    "gmail.co",
    "gmail.co.uk",
    "gmail.co.za",
    "gmail.com",
    "gmail.com.247blog.com",
    "gmail.com.au",
    "gmail.com.br",
    "gmail.com.cad.creou.dev",
    "gmail.com.com",
    "gmail.com.commercecrypto.com",
    "gmail.com.creou.dev",
    "gmail.com.derdisoft.com",
    "gmail.com.digitalmarketingcoursesusa.com",
    "gmail.com.dirtypetrol.com",
    "gmail.com.disusedtube.com",
    "gmail.com.diybookmarks.com",
    "gmail.com.elitegunshop.com",
    "gmail.com.filemakertechniques.com",
    "gmail.com.firstrest.com",
    "gmail.com.gabrielshmidt.com",
    "gmail.com.gmail.com.m.oazis.site",
    "gmail.com.hassle-me.com",
    "gmail.com.healthyheartforall.com",
    "gmail.com.herbalsoftware.com",
    "gmail.com.hitechinfo.com",
    "gmail.com.mahoteki.com",
    "gmail.com.matt-salesforce.com",
    "gmail.com.nicolhampel.com",
    "gmail.com.pesquisaplaca.com",
    "gmail.com.ph",
    "gmail.com.researchdetectors.com",
    "gmail.com.skvorets.com",
    "gmail.com.standeight.com",
    "gmail.com.thetybeetimes.net",
    "gmail.com.tokencoach.com",
    "gmail.com.urbanban.com",
    "gmail.com.waterbedblog.com",
    "gmail.gr.com",
    "gmail.hu",
    "gmail.it",
    "gmail.om",
    "gmail.pp.ua",
    "gmail.ru",
    "gmail.sk",
    "gmail.yopmail.fr",
    "gmail.zalvisual.us",
    "gmailbete.cf",
    "gmaildottrick.com",
    "gmaile.design",
    "gmailer.top",
    "gmailkeeper.org",
    "gmailll.cf",
    "gmailll.ga",
    "gmailll.gq",
    "gmaillll.ga",
    "gmaillll.ml",
    "gmailllll.ga",
    "gmailserver.org",
    "gmailssdf.com",
    "gmailup.com",
    "gmailvn.net",
    "gmailx.xyz",
    "gmal.com",
    "gmatch.org",
    "gmaul.com",
    "gmblmania.club",
    "gmc-sierra.club",
    "gmcd.de",
    "gmdabuwp64oprljs3f.ga",
    "gmdabuwp64oprljs3f.ml",
    "gmdabuwp64oprljs3f.tk",
    "gmeil.me",
    "gmgmne.site",
    "gmgmu.live",
    "gmial.com",
    "gmil.com",
    "gmiosaummi.host",
    "gmjszulw.shop",
    "gmkuwsnb.shop",
    "gmleeuruki.com",
    "gmm59.live",
    "gmoinside.net",
    "gmp3.info",
    "gmpartssale.com",
    "gms-deluxe-casino.win",
    "gmsb-media.com",
    "gmscourier.com",
    "gmsdluxx.com",
    "gmsinvest.ru",
    "gmx-ist-cool.de",
    "gmx-topmail.de",
    "gmx.at",
    "gmx.ca",
    "gmx.ch",
    "gmx.co.uk",
    "gmx.com",
    "gmx.de",
    "gmx.dns-cloud.net",
    "gmx.dnsabr.com",
    "gmx.es",
    "gmx.fr",
    "gmx.fr.nf",
    "gmx.hk",
    "gmx.ie",
    "gmx.info",
    "gmx.li",
    "gmx.net",
    "gmx.org",
    "gmx.pt",
    "gmx.sg",
    "gmx.tw",
    "gmx.us",
    "gmx1mail.top",
    "gmxip8vet5glx2n9ld.cf",
    "gmxip8vet5glx2n9ld.ga",
    "gmxip8vet5glx2n9ld.gq",
    "gmxip8vet5glx2n9ld.ml",
    "gmxip8vet5glx2n9ld.tk",
    "gmxmail.cf",
    "gmxmail.gq",
    "gmxmail.tk",
    "gmxmail.top",
    "gmxmail.win",
    "gn655.top",
    "gn7567dh.com",
    "gn8.cc",
    "gnail.pw",
    "gnajuk.me",
    "gnbhjm.com",
    "gnctr-calgary.com",
    "gndtul.info",
    "gndxdl.com",
    "gnetnagiwd.xyz",
    "gnew.site",
    "gnews.media",
    "gnipgykdv94fu1hol.cf",
    "gnipgykdv94fu1hol.ga",
    "gnipgykdv94fu1hol.gq",
    "gnipgykdv94fu1hol.ml",
    "gnipgykdv94fu1hol.tk",
    "gniwal.us",
    "gnlu.ac.in",
    "gnocesunglass.com",
    "gnocewatch.com",
    "gnomecollective.com",
    "gnomi.ru",
    "gnon.org",
    "gnorimies.xyz",
    "gnqp26.com",
    "gnqp29.com",
    "gnqp32.com",
    "gnqp33.com",
    "gnqp37.com",
    "gnqp38.com",
    "gnqp39.com",
    "gnqp40.com",
    "gns22.com",
    "gns44.com",
    "gns5.com",
    "gns55.com",
    "gns77.com",
    "gns99.com",
    "gnsk6gdzatu8cu8hmvu.cf",
    "gnsk6gdzatu8cu8hmvu.ga",
    "gnsk6gdzatu8cu8hmvu.gq",
    "gnsk6gdzatu8cu8hmvu.ml",
    "gnsk6gdzatu8cu8hmvu.tk",
    "gnwmail.com",
    "go-a-creditcardnofeecaok.live",
    "go-a-tu-new-carok.live",
    "go-creditcardnofeeca-ok.live",
    "go-creditcardnofeecas-ok.live",
    "go-moscow.ru",
    "go-parkinsons-ok.live",
    "go-trade.dev",
    "go-trade.org",
    "go-tu-new-cars-ok.live",
    "go-vegas.ru",
    "go.com",
    "go.dyndns.org",
    "go.irc.so",
    "go.ro",
    "go.ru",
    "go1.site",
    "go2.com.py",
    "go2.pl",
    "go2019.site",
    "go220.icu",
    "go222.site",
    "go2myportals.com",
    "go2net.com",
    "go2usa.info",
    "go2vpn.net",
    "go2xal.us",
    "go333.site",
    "go345.icu",
    "go4.it",
    "go4mail.net",
    "go4organic.coffee",
    "go4v.info",
    "go555.site",
    "goabaltihouse.com",
    "goacardonationok.haus",
    "goacc.ru",
    "goaction.club",
    "goadjunipergive.website",
    "goafterdark.com",
    "goal-city.ru",
    "goalofgtr.tk",
    "goalraitdvq.email",
    "goalstats.net",
    "goandrate.com",
    "goat.si",
    "goaustralianow.com",
    "gob0u9.site",
    "gobahis98.com",
    "gobar.app",
    "gobedbugremovalok.live",
    "gobimission.org",
    "gobizpros.com",
    "goblinhammer.com",
    "gobo-projectors.ru",
    "gobodoc.xyz",
    "gobola.com",
    "gobrainstorm.net",
    "gobuffy.ru",
    "gobumall.site",
    "gocardless.app",
    "gocardless.dev",
    "gocardonationsok.haus",
    "gocase.ru",
    "gocekyatdoseme.xyz",
    "gocengqq.us",
    "gocfunny.info",
    "gociboutique.site",
    "gocollege.com",
    "gocubs.com",
    "god-from-the-machine.com",
    "godaddyrenewalcoupon.net",
    "godataflow.xyz",
    "godcomplexuk.com",
    "goddysey.com",
    "godev083.site",
    "godiox.com",
    "godmail.dk",
    "godmail.gq",
    "godman.club",
    "godoityourself.club",
    "godrej-forest-grove.info",
    "godrej-forestgrove.com",
    "godrej-park-greens.info",
    "godrej-serenity.net",
    "godrej-the-river-retreat.com",
    "godrej-the-river-retreat.net",
    "godrejnurturebangalore.com",
    "godrejnurturebangalore.info",
    "godrejnurtureecity.com",
    "godrejpark-springs.net",
    "godrejparkgreens.info",
    "godrejproperties-forestgrove.com",
    "godrejproperties-forestgrove.info",
    "godrejproperties-parkgreens.org",
    "godrejpropertiesforestgrove.com",
    "godrejpropertiesforestgrove.info",
    "godrejpropertiesnurture.com",
    "godrejpropertiesparkgreens.net",
    "godrejtheriverretreat.net",
    "godrejtheriverretreat.org",
    "godsale.ru",
    "godsayluxsit.xyz",
    "godslot.one",
    "godude.site",
    "godut.com",
    "godwinpartners.com",
    "goear.name",
    "goear.net",
    "goedkope-batterijen.online",
    "goedkopeminecraftserver.online",
    "goemailgo.com",
    "gofindbrides.com",
    "gofree.co.uk",
    "gofuckporn.com",
    "gog4dww762tc4l.cf",
    "gog4dww762tc4l.ga",
    "gog4dww762tc4l.gq",
    "gog4dww762tc4l.ml",
    "gog4dww762tc4l.tk",
    "gogigsgo.com",
    "goglemail.cf",
    "goglemail.ga",
    "goglemail.ml",
    "gogoanimes.xyz",
    "gogoeyesa.info",
    "gogogohome.club",
    "gogolfalberta.com",
    "gogomp3.ru",
    "gogoogleitnow.com",
    "gogreekfishbar.com",
    "gogreeninc.ga",
    "gogreenon.com",
    "gohomeinspections.com",
    "gohoslya.ga",
    "gohoslya.tk",
    "goimlive.space",
    "gojek303.info",
    "gojinkatakeaway.com",
    "gok.kr",
    "gokey.info",
    "gokhankag.xyz",
    "gokmeesters.info",
    "gokmen.kim",
    "gokturkist.com",
    "gokturkokullariobs.online",
    "gokturkokullariobs.xyz",
    "gol.com",
    "gol60f.site",
    "golbengi.shop",
    "golc.de",
    "gold-bowling.ru",
    "gold-cup.org",
    "gold-mania.com",
    "gold-now.icu",
    "gold-recepts.ru",
    "goldbarcube.com",
    "goldcoastswimstars.com",
    "golddietplus.com",
    "golddurwyh.space",
    "golden-cup.info",
    "golden-cup.net",
    "golden-mine.site",
    "golden-skate.com",
    "goldenbahistv1.com",
    "goldenbrow.com",
    "goldencbddrops.com",
    "goldendragontakeaway.com",
    "goldeneggbrand.com",
    "goldeneggbrands.com",
    "goldenegginvesting.net",
    "goldenelephantdunlaoghaire.com",
    "goldenguy.gq",
    "goldenjeux.com",
    "goldenlifewire.com",
    "goldenlilyglanmire.com",
    "goldenllama.us",
    "goldenmail.ru",
    "goldenmountainchinesetakeaway.com",
    "goldenplaycasino.ru",
    "goldenpowerball2.com",
    "goldensandbeachclub.com",
    "goldenseatakeaway.com",
    "goldenseniors.club",
    "goldenslots2018.ru",
    "goldensochi-remont.ru",
    "goldenstarchinesetakeaway.com",
    "goldensunsetresort.com",
    "goldenteebanger.com",
    "goldenwest.net",
    "goldenwokchinesetakeaway.com",
    "goldenwords.club",
    "goldfishka97.com",
    "goldfishka98.com",
    "goldfishkadownload10.com",
    "goldfishkadownload7.com",
    "goldfox.ru",
    "goldfruittrust.com",
    "goldinbox.net",
    "goldiphone.site",
    "goldlabletech.com",
    "goldmail.ru",
    "goldmanhomeblog.site",
    "goldmtoken.com",
    "goldnewsbc.site",
    "goldridgedevco.com",
    "goldstar365avm.com",
    "goldswitzerland.org",
    "goldtamil.info",
    "goldtimecasino6.com",
    "goldtoolbox.com",
    "goldtopia.online",
    "goldtube.site",
    "goldvid.site",
    "golead.pro",
    "golegol58.com",
    "golegol64.com",
    "golegol65.com",
    "golegol72.com",
    "golegol73.com",
    "golegol74.com",
    "golegol75.com",
    "golegol76.com",
    "golegol78.com",
    "golegol80.com",
    "golegol85.com",
    "golegol86.com",
    "golegol87.com",
    "golegol90.com",
    "golegol91.com",
    "golegol92.com",
    "golegol93.com",
    "golegol97.com",
    "golemico.com",
    "goler.org",
    "golf417homes.xyz",
    "golfcam.info",
    "golfcloud.app",
    "golfemail.com",
    "golfilla.info",
    "golfmail.be",
    "golfonthesquare.net",
    "golfshop.live",
    "golftravelreview.com",
    "golfwidows.com",
    "goliathhost.com",
    "golidi.net",
    "golighcars.ml",
    "goliokao.cf",
    "goliokao.ga",
    "goliokao.gq",
    "goliokao.ml",
    "goliszek.net",
    "golld.us",
    "golneypread.cf",
    "golneypread.ga",
    "golneypread.gq",
    "golneypread.ml",
    "golneypread.tk",
    "golottowinner.com",
    "golovolomka-money.ru",
    "gomail.in",
    "gomail.pgojual.com",
    "gomailbox.info",
    "gomedal4.xyz",
    "gomedal5.xyz",
    "gomedal6.xyz",
    "gomedal7.xyz",
    "gomedal8.xyz",
    "gomelkosmos.site",
    "gomessage.ml",
    "gometrodesign.com",
    "gomiso.com",
    "gomogoor.com",
    "gomovies-free.site",
    "gonah.ru",
    "gonationmedia.com",
    "gonavy.net",
    "goncangan.com",
    "gondiel.space",
    "gondskumis69.me",
    "gone-fishing.xyz",
    "gonetrippin.us",
    "gonfalon.com",
    "gongchinese.com",
    "gongdelin.org",
    "gongj5.com",
    "gongj6.com",
    "gongog.store",
    "goninja.com",
    "gonuts4free.com",
    "gonzaloerize.org",
    "goocalt-car.ru",
    "good-little.space",
    "good-luck-inchicore.com",
    "good-method.club",
    "good-product.website",
    "good-recept.ru",
    "good-sells.ru",
    "good-things-only.site",
    "good2culawn.com",
    "good2cuwindows.com",
    "gooday.pw",
    "goodbakes.com",
    "goodbussines.ru",
    "gooddaystakeaway.com",
    "gooddd.ru",
    "gooddebird.ru",
    "gooddllc.ru",
    "goode.agency",
    "goode.services",
    "goode.solutions",
    "goodelivery.ru",
    "goodessays.website",
    "goodfood-perm.ru",
    "goodfood-store-dublin.com",
    "goodjab.club",
    "goodlifeenergysaver.com",
    "goodlifeoutpost.com",
    "goodluckforu.cn.com",
    "goodmatik.ru",
    "goodnessdetox.com",
    "goodnewsbadnewsmusic.com",
    "goodnewsmail.com",
    "goodnewsworld.space",
    "goodpay-out.press",
    "goodportal.info",
    "goodprice.icu",
    "goods4home.ru",
    "goodseller.co",
    "goodsforyours.com",
    "goodsforyours.site",
    "goodshepherdclinic.com",
    "goodshepheredchurchseeta.com",
    "goodshowsco.com",
    "goodsmart.pw",
    "goodspitanie.ru",
    "goodstick.com",
    "goodtee.online",
    "goodthanks.media",
    "goodtmail.com",
    "goodturntable.com",
    "goodvibes.ga",
    "goodwinazart.com",
    "goodwincasino.asia",
    "goodwincasino.live",
    "goodwinpoker.com",
    "goodwritingservices.website",
    "goodyearchiropractic.club",
    "goofybee.info",
    "goofycats.info",
    "goofycopilot.com",
    "goofyhippos.info",
    "goofyostrich.info",
    "googdad.tk",
    "googlays.com",
    "google-clicker.com",
    "google-email.ml",
    "google-mail.me",
    "google-mail.ooo",
    "googleappmail.com",
    "googledottrick.com",
    "googlegarbage.com",
    "googlegroups.com",
    "googlelogin.online",
    "googlelogin.site",
    "googlemail.com",
    "googlemail.press",
    "googlesite.org",
    "googoolshop.xyz",
    "googulliver.site",
    "goomagnet.com",
    "goons.us",
    "goooogle.flu.cc",
    "goooogle.igg.biz",
    "goooogle.nut.cc",
    "goooogle.usa.cc",
    "goooomail.com",
    "gooresctars.cf",
    "gooresctars.ga",
    "gooresctars.gq",
    "gooresctars.ml",
    "goosemoose.com",
    "gooseneckwines.com",
    "goosenetwork.org",
    "gopdfmanuales.xyz",
    "gopherzaly.life",
    "goplay.com",
    "goplaygame.ru",
    "gopldropbox1.tk",
    "goplf1.cf",
    "goplf1.ga",
    "goplmega.tk",
    "goplmega1.tk",
    "gopo.email",
    "gopoker303.org",
    "gopowerlevel.com",
    "gopty.xyz",
    "gopu.site",
    "gor-bilet.ru",
    "goranko.ga",
    "gorbapa.com",
    "gorbapa4u.com",
    "gordanbrush.com",
    "gordanbrush.net",
    "gordanbrush.us",
    "gorden-spb.ru",
    "gordenbrush.biz",
    "gordenbrush.net",
    "gordenbrush.us",
    "gordon1121.club",
    "gordonbrush.net",
    "gordonbrushes.com",
    "gordonbrushes.org",
    "gordonbrushwisconsin.com",
    "gordonbrushwisconsin.org",
    "gordoncastlehighlandgames.com",
    "goremekelebek.com",
    "gorgeousfirst.com",
    "gorgi.ru",
    "gorilanetwork.us",
    "gorilla-bett.ru",
    "gorillainventory.com",
    "gorillasharware.com",
    "gorillaswithdirtyarmpits.com",
    "gorkacabinet.com",
    "gormandizing232vg.online",
    "gormandizing699en.xyz",
    "gorod-pobratim.ru",
    "gorodrabotka.ru",
    "goromail.ga",
    "gorontalo.net",
    "gorosc.ru",
    "goroscop2019.ru",
    "goround.info",
    "gorpy.net",
    "gorukledeyasam.xyz",
    "goryachie-tury.ru",
    "gos-money-programm.site",
    "gos-money-programm.website",
    "gos-money-programm.xyz",
    "gos-pay-programm.space",
    "gos-pay-programm.website",
    "gos-pay-programm.xyz",
    "gosait.icu",
    "goscompxka.club",
    "gosearchcity.us",
    "gosfinances.ru",
    "goshisolo.ru",
    "goshoppingt.xyz",
    "goslippy.com",
    "goslot88.com",
    "gosne.com",
    "gospaper.ru",
    "gospelfan.com",
    "gossippolitics.com",
    "gossiprap.com",
    "gostabbet.xyz",
    "gosteitoy.cf",
    "gosteitoy.ga",
    "gosteitoy.gq",
    "gosteitoy.tk",
    "gostina.com",
    "gosumarket.ru",
    "gosumarkt.ru",
    "gosuslugi-info.ru",
    "gosuslugi-spravka.ru",
    "gosyslugi.host",
    "gotartowice.pl",
    "gotc.de",
    "gotcertify.com",
    "gotdns.com",
    "gotdns.org",
    "gotelefons.info",
    "goth-friends.com",
    "gothere.biz",
    "gothere.uk.com",
    "gothetalent.com",
    "gothill.com",
    "gotimes.xyz",
    "gotkmail.com",
    "gotmail.com",
    "gotmail.net",
    "gotmail.org",
    "goto1xbet.ru",
    "gotoluxurycountry.monster",
    "gotomy.com",
    "gotosite.ru",
    "gotovte-doma.ru",
    "gotowebshop.site",
    "gotowim-doma.ru",
    "gotpayments.net",
    "gotradecoin.net",
    "gotruvi.com",
    "gotti.otherinbox.com",
    "gotunhien.info",
    "goty-alocalemail.com",
    "gotyalocal-email.com",
    "gotyalocale-mail.com",
    "gouanomarba.tk",
    "gouapatpoa.cf",
    "gouapatpoa.gq",
    "gouapatpoa.ml",
    "gouguolu.com",
    "gouhehe.com",
    "goumang.top",
    "goupgouo.shop",
    "gourmetburgercork.com",
    "gourmetkitchen-cabra.com",
    "gourmetoliveoilclub.com",
    "gouruu.xyz",
    "gouuadays.ru",
    "govalvee.com",
    "govcities.com",
    "govdep5012.com",
    "governmentgis.com",
    "governmentpromises.com",
    "governo.ml",
    "govno.online",
    "govnomail.xyz",
    "govolsfan.com",
    "govoxy.com",
    "goweightlossinfoesok.live",
    "gowhere.site",
    "gowhere.tech",
    "gowikibooks.com",
    "gowikicampus.com",
    "gowikicars.com",
    "gowikifilms.com",
    "gowikigames.com",
    "gowikimusic.com",
    "gowikimusic.great-host.in",
    "gowikinetwork.com",
    "gowikitravel.com",
    "gowikitv.com",
    "gowingo.xyz",
    "gowion.com",
    "gowj.com",
    "gowngraphicsgolf.website",
    "gox2lfyi3z9.ga",
    "gox2lfyi3z9.gq",
    "gox2lfyi3z9.ml",
    "gox2lfyi3z9.tk",
    "goxa.site",
    "goxsoday.ru",
    "goyingagashop.com",
    "gozicimercek.com",
    "gp2277.com",
    "gp2858.com",
    "gp2cache.info",
    "gp5155.com",
    "gp66gvwi.xyz",
    "gp7777.com",
    "gp9ghb.us",
    "gpapa.ooo",
    "gpcharlie.com",
    "gpfedh.us",
    "gphsw.info",
    "gpi10.xyz",
    "gpi8eipc5cntckx2s8.cf",
    "gpi8eipc5cntckx2s8.ga",
    "gpi8eipc5cntckx2s8.gq",
    "gpi8eipc5cntckx2s8.ml",
    "gpi8eipc5cntckx2s8.tk",
    "gpipes.com",
    "gpisbcmd.com",
    "gpk99.live",
    "gpkhb.com",
    "gplvuka4fcw9ggegje.cf",
    "gplvuka4fcw9ggegje.ga",
    "gplvuka4fcw9ggegje.gq",
    "gplvuka4fcw9ggegje.ml",
    "gplvuka4fcw9ggegje.tk",
    "gpoker.online",
    "gportal.hu",
    "gpouwumwp.shop",
    "gppoww.info",
    "gppozm.icu",
    "gppreferral.com",
    "gpsprosahop.xyz",
    "gpssport.com",
    "gptennislyon.com",
    "gpui.ru",
    "gpuj.us",
    "gpwgw.info",
    "gpxohp.club",
    "gpy4f.us",
    "gpy6f.us",
    "gqioxnibvgxou.cf",
    "gqioxnibvgxou.ga",
    "gqioxnibvgxou.gq",
    "gqioxnibvgxou.ml",
    "gqioxnibvgxou.tk",
    "gqlsryi.xyz",
    "gqpujjnsf.shop",
    "gqtyojzzqhlpd5ri5s.cf",
    "gqtyojzzqhlpd5ri5s.ga",
    "gqtyojzzqhlpd5ri5s.gq",
    "gqtyojzzqhlpd5ri5s.ml",
    "gqtyojzzqhlpd5ri5s.tk",
    "gqubjbngp.shop",
    "gr5edu.info",
    "gr5kfhihqa3y.cf",
    "gr5kfhihqa3y.ga",
    "gr5kfhihqa3y.gq",
    "gr5kfhihqa3y.ml",
    "gr5kfhihqa3y.tk",
    "grabit.xyz",
    "grabitfast.co",
    "grabmail.com",
    "grabonyourway.com",
    "gracehaven.info",
    "gracesingles.com",
    "graciovfvh.space",
    "grade-quick-cell-actually.xyz",
    "gradeweb.org",
    "gradilium.xyz",
    "gradozashita46.ru",
    "graduate.org",
    "graeinc.info",
    "graeinc.net",
    "graeinc.org",
    "graffiti.net",
    "graffitt.ru",
    "grafikerburada.online",
    "grafisch.works",
    "grafixmaven.com",
    "grafluent.site",
    "graftonbaptistchurchsbc.com",
    "graham-clan.net",
    "grahamcentre.nyc",
    "grails-comment.website",
    "grainfr.xyz",
    "grainglossary.com",
    "graingue.fun",
    "grainprinter.com",
    "grainprinters.com",
    "grainsh.xyz",
    "grainsha.icu",
    "grainsha.xyz",
    "gralaborek.info",
    "gramail.ga",
    "gramlisjudg.ga",
    "gramlisjudg.tk",
    "grammarbeats.com",
    "grammasystems.com",
    "gramszu.net",
    "grand-registration.ru",
    "grandambar.ru",
    "grandbonuzz.ru",
    "grandcheap.site",
    "grandclone.com",
    "grandconnaughtrooms-media.com",
    "grandherbalistoils.com",
    "grandintim.ru",
    "grandlaketheband.com",
    "grandmamail.com",
    "grandmasmail.com",
    "grandmine.su",
    "grandmothers.co.uk",
    "grandoodlez.com",
    "grandopros.ru",
    "grandparents.co.uk",
    "grandpaswine.com",
    "grandplug.com",
    "grandrapidskids.info",
    "grandrapidsnailsalons.com",
    "grandrapidspropertyfinders.com",
    "grandspecs.info",
    "grandstore.pro",
    "grandtheftdeath.com",
    "grandw88.info",
    "grandw88.org",
    "grandxxi.video",
    "grangmi.cf",
    "grangmi.ga",
    "grangmi.gq",
    "grangmi.ml",
    "granhotelreymar.cat",
    "granigranita.ru",
    "graninclas.cf",
    "graninclas.ga",
    "graninclas.ml",
    "graninul.ml",
    "graninul.tk",
    "granitebaydesign.net",
    "granitegravestone.xyz",
    "granitememorial.xyz",
    "granitklg.ru",
    "granosma.ga",
    "granosma.gq",
    "granosma.tk",
    "granoutan.gq",
    "granoutan.ml",
    "granoutan.tk",
    "granpors.info",
    "grantdon.xyz",
    "grantdono.icu",
    "grantfamilyonline.com",
    "grantor-shadow.com",
    "grantor-shadow.org",
    "grantorshadow.org",
    "grantur.ru",
    "grantutter.buzz",
    "granurim.cf",
    "granurim.ga",
    "granurim.gq",
    "granurim.ml",
    "grape-com.com",
    "grapefznws.space",
    "graphic-arts-international.com",
    "graphic-designer.com",
    "graphictee.store",
    "graphriro.cf",
    "graphriro.ml",
    "graphriro.tk",
    "graphtech.ru",
    "graphtiobull.cf",
    "graphtiobull.ga",
    "graphtiobull.ml",
    "graphtiobull.tk",
    "graphway.com",
    "grapplers.com",
    "grasslandtechnology.com",
    "grassless.best",
    "grateful.adult",
    "grateful.associates",
    "grateful.black",
    "grateful.blue",
    "grateful.coach",
    "grateful.engineer",
    "grateful.engineering",
    "grateful.family",
    "grateful.fitness",
    "grateful.fun",
    "grateful.health",
    "grateful.host",
    "grateful.jewelry",
    "grateful.llc",
    "grateful.ltd",
    "grateful.partners",
    "grateful.red",
    "grateful.services",
    "grateful.site",
    "grateful.store",
    "grateful.toys",
    "gratefulvnf.email",
    "grateshop24.xyz",
    "gratis-gratis.com",
    "gratisbumsen-confirmed.com",
    "gratisbumsen-meet-backup.com",
    "gratislose.de",
    "gratisneuke.be",
    "gratisweb.com",
    "gratitip.com",
    "gratosmail.fr.nf",
    "graur.ru",
    "grauzone.pro",
    "gravatavip.com",
    "gravedag.cf",
    "gravedag.ga",
    "gravedag.tk",
    "gravit-e.dev",
    "gravitcraft.ru",
    "gravitio.info",
    "gravitio.net",
    "gravitio.us",
    "gravitytextile.com",
    "gravsefor.cf",
    "gravsefor.ga",
    "gravsefor.ml",
    "gravsefor.tk",
    "gray.li",
    "grayfortune.tech",
    "grayfox.org",
    "graygardens.info",
    "grayhatcash.tech",
    "grayistxxr.space",
    "graylineportland.com",
    "graymail.ga",
    "grbei6.com",
    "grcanyon.com",
    "grdy.news",
    "grdy.sale",
    "greasymedia.com",
    "great-host.in",
    "great2matchmaker3.com",
    "greatbearcanoes.com",
    "greatble.xyz",
    "greatdas.site",
    "greatditc.xyz",
    "greate-easy-product.ru",
    "greate-inform-mall.host",
    "greateraustin.homes",
    "greatergoodpoker.com",
    "greaterhouse.org",
    "greaterhoustonlivingteam.com",
    "greatfait.recipes",
    "greatfallsdentureclinic.com",
    "greatferg.gq",
    "greatgrainsbrewery.com",
    "greathimalayangrowers.com",
    "greatigtota.tk",
    "greatindiaportarlington.com",
    "greatlastminutegifts.com",
    "greatmiin.gq",
    "greatoutdoorpaintingchallenge.com",
    "greatpl.xyz",
    "greatpla.xyz",
    "greatstuff.website",
    "greattimes.ga",
    "greatuncl.icu",
    "greatwall-dublin1.com",
    "grecbibte.ga",
    "grecbibte.gq",
    "grecbibte.ml",
    "grecc.me",
    "gree.gq",
    "greecealive.com",
    "greeceinvestorguide.online",
    "greedy.link",
    "greekbag.website",
    "greekcampus.org",
    "greekforks.com",
    "greekkindlejudge.site",
    "green-septik.ru",
    "green-stone.info",
    "greenapi1.club",
    "greenassetdisposal.com",
    "greenbarley.net",
    "greenbellfinance.com",
    "greencardsco.com",
    "greencityhome.store",
    "greencoepoe.cf",
    "greencozy.icu",
    "greendike.com",
    "greendipbench.cf",
    "greendipbench.ga",
    "greendipbench.gq",
    "greendipbench.tk",
    "greendom67.ru",
    "greenekiikoreabete.cf",
    "greenerykingdom.com",
    "greenestaes.com",
    "greenforce.cf",
    "greenforce.tk",
    "greengenahead.com",
    "greengridnewmexico.org",
    "greenholidayresorts.com",
    "greenhomelove.com",
    "greenhousemail.com",
    "greenicspir.cf",
    "greenicspir.ml",
    "greenicspir.tk",
    "greenlabs.ltd",
    "greenleafmail.com",
    "greenlifedergi.com",
    "greenmail.net",
    "greenmilehigh.info",
    "greenmilehigh.online",
    "greenmilehigh.store",
    "greenpdfmanuales.xyz",
    "greenpowerexplorer.com",
    "greenreliefcream.com",
    "greensboronailsalons.com",
    "greensboroopiaterehab.com",
    "greenscreen.agency",
    "greensforsydney.org",
    "greenslim.site",
    "greensloth.com",
    "greenspin1.bet",
    "greenst.info",
    "greenstreev.xyz",
    "greentear.com",
    "greenteareviewer.com",
    "greentech5.com",
    "greenthumbdrives.info",
    "greenthumbdrives.net",
    "greentouwn.ru",
    "greentravelblog.org",
    "greentreeheavyequipment.com",
    "greenvillebankruptcyattorneys.com",
    "greenwavefilters.net",
    "greenwooddoctors.com",
    "greenwoodrealestateagents.com",
    "greenzclvea.email",
    "greeriptv.live",
    "greetingily.email",
    "greetingsbot.com",
    "greetsealedknife.site",
    "gregbritton.com",
    "gregcompany.ru",
    "greggamel.com",
    "greggamel.net",
    "gregoria1818.site",
    "gregorsky.zone",
    "gregorygamel.com",
    "gregorygamel.net",
    "gregroita.cf",
    "gregroita.gq",
    "gregroita.ml",
    "grenaddfqb.space",
    "grencex.cf",
    "grenoble-avocats.com",
    "grenso.com",
    "grepekhyo65hfr.tk",
    "gretl.info",
    "grew-sheridan.com",
    "greyhouseatthewallacelodge.com",
    "greyjack.com",
    "greystonessc.com",
    "greywool.ru",
    "grib04.ru",
    "grib58.ru",
    "grics.net",
    "grietjie.org",
    "griffininnovation.com",
    "grigio.cf",
    "grill-tandoori-dunshaughlin.com",
    "grillertakeaway.com",
    "grillishtakeaway.com",
    "grilltown-dublin.com",
    "grimjjowjager.cf",
    "grimjjowjager.ga",
    "grimjjowjager.gq",
    "grimjjowjager.ml",
    "grimjjowjager.tk",
    "grimper-a-vue.com",
    "grimsbybd.online",
    "grimsbyfans.com",
    "grin.dk",
    "grina.biz",
    "grinagclev.cf",
    "grinagclev.ga",
    "grinagclev.ml",
    "grinagclev.tk",
    "grinbatolect.cf",
    "grindandseal.melbourne",
    "grindevald.ru",
    "grindli.icu",
    "grindwea.xyz",
    "grinn.in",
    "gripbarchess.cf",
    "gripbarchess.ga",
    "gripbarchess.ml",
    "gripbarchess.tk",
    "gripspolice.top",
    "grish.de",
    "gritbasketheir.website",
    "gritscooker.com",
    "griuc.schule",
    "grizzlyfruit.gq",
    "grmvn.cf",
    "grn.cc",
    "grnpublication.org",
    "gro2soil.com",
    "groceriesshop.futbol",
    "grocerysavings.online",
    "grocerystars.site",
    "grodins.ml",
    "groei-vandaag.online",
    "grokosan.website",
    "groks-the.info",
    "groks-this.info",
    "grom-muzi.ru",
    "groobler.com",
    "groots.ong",
    "groovetrove.com",
    "groovymail.dk",
    "groovypandas.info",
    "groovypanthers.info",
    "groovysquid.info",
    "groovywolf.info",
    "grosjoumouff.cf",
    "grosjoumouff.ga",
    "grosjoumouff.gq",
    "groundedradio.com",
    "grounduktg.space",
    "grounduowpx.email",
    "groundworkusa.net",
    "grounurur.cf",
    "grounurur.ga",
    "grounurur.gq",
    "group-llc.cf",
    "group-llc.ga",
    "group-llc.gq",
    "group-llc.ml",
    "group-llc.tk",
    "group-stock-store.ru",
    "group2motorsports.com",
    "groupbuff.com",
    "groupe-acorus.com",
    "groupe-psa.cf",
    "groupe-psa.gq",
    "groupe-psa.ml",
    "groupe-psa.tk",
    "groupfunds.club",
    "groupkami.com",
    "groupmail.com",
    "groupoches.cf",
    "groupoches.ga",
    "groupoches.gq",
    "groupous.com",
    "groupteleserye.ru",
    "grouserealty.com",
    "grouvity.com",
    "grov.dk",
    "grovebra.cf",
    "grovebra.gq",
    "grovebra.tk",
    "groveled59ee.xyz",
    "grow-russia.ru",
    "growaparts.info",
    "growfitaccelerator.com",
    "growhpostmi.cf",
    "growhpostmi.gq",
    "growhpostmi.tk",
    "growintelligence.com",
    "growlcombine.com",
    "growlightkits.net",
    "growndiamonds.com",
    "grownwomen.biz",
    "growseedsnow.com",
    "growshop-moskva.ru",
    "growsites.us",
    "growsocial.net",
    "growth-tools.fr",
    "growth-tools.tk",
    "growthers.com",
    "growtopia.store",
    "growyou.info",
    "grpbbq.us",
    "grqhly.site",
    "grr.la",
    "grubsnapper.com",
    "grud-devushki.ru",
    "grue.de",
    "grufefse.cf",
    "grugrug.ru",
    "grumlylesite.com",
    "grumpy-phpunit.com",
    "grumpyglobetroter.com",
    "grumpyrobot.icu",
    "grumpyspaint.com",
    "grungecafe.com",
    "gruntimaps.org",
    "gruperio.net",
    "grupik.ru",
    "grupocapoeirabrasilraleigh.com",
    "grupos-telegram.com",
    "gruppa.club",
    "gruppatelika.ru",
    "gruppsakerhetssystem.se",
    "gruz-m.ru",
    "gruz-man.ru",
    "gruzovyezapchasti.ru",
    "gs-arc.org",
    "gs516.ru",
    "gsbalumni.com",
    "gsdcoalition.org",
    "gseevqvve.shop",
    "gsfwg.com",
    "gsfwz.icu",
    "gsg-exchange.com",
    "gshopping.site",
    "gsnuyq.us",
    "gspam.mooo.com",
    "gspousea.com",
    "gsredcross.org",
    "gsrscs.xyz",
    "gsrv.co.uk",
    "gssa9fa5.fun",
    "gstatic-cache-fra1.xyz",
    "gstx1.xyz",
    "gsweetuni.space",
    "gsxjwd.us",
    "gsxstring.ga",
    "gsyqbkyng.shop",
    "gt446443ads.cf",
    "gt446443ads.ga",
    "gt446443ads.gq",
    "gt446443ads.ml",
    "gt446443ads.tk",
    "gta-5.space",
    "gta-offline.ru",
    "gta4etw4twtan53.gq",
    "gta5mp.com",
    "gta5mp.net",
    "gtaa6.ru",
    "gtafzq.tokyo",
    "gtagolfers.com",
    "gtamp.app",
    "gtarp.app",
    "gtbanger.com",
    "gtcdqpctc.shop",
    "gtemail.net",
    "gtfaway.net",
    "gtfaway.org",
    "gthgvt.site",
    "gthosing.net",
    "gti.net",
    "gti8xq.us",
    "gtkesh.com",
    "gtmail.com",
    "gtmc.net",
    "gtnv.email",
    "gtoalumni.com",
    "gtq59.xyz",
    "gtrcinmdgzhzei.cf",
    "gtrcinmdgzhzei.ga",
    "gtrcinmdgzhzei.gq",
    "gtrcinmdgzhzei.ml",
    "gtrcinmdgzhzei.tk",
    "gtsmov.info",
    "gtuae.us",
    "gtxorv.us",
    "gtymj2pd5yazcbffg.cf",
    "gtymj2pd5yazcbffg.ga",
    "gtymj2pd5yazcbffg.gq",
    "gtymj2pd5yazcbffg.ml",
    "gtymj2pd5yazcbffg.tk",
    "gu.luk2.com",
    "gu0x9z.us",
    "gu3x7o717ca5wg3ili.cf",
    "gu3x7o717ca5wg3ili.ga",
    "gu3x7o717ca5wg3ili.gq",
    "gu3x7o717ca5wg3ili.ml",
    "gu3x7o717ca5wg3ili.tk",
    "gua.net",
    "gualpeling.cf",
    "gualpeling.ga",
    "gualpeling.tk",
    "guangxibxyl.com",
    "guanyacn.com",
    "guanyuky.com",
    "guarali.cf",
    "guarali.ga",
    "guarali.gq",
    "guarali.ml",
    "guarali.tk",
    "guaranteed-position.com",
    "guaranteedinsuranceoptions.com",
    "guarddimnlg.email",
    "guarden.icu",
    "guatemala.org",
    "guayturwork.cf",
    "gucejanu.club",
    "gud-game.ru",
    "gud-magaz.ru",
    "gudang0.net",
    "gudang1.net",
    "gudang2.net",
    "gudang3.net",
    "gudang5.net",
    "gudanglowongan.com",
    "gudilika.fun",
    "gudluck.ru",
    "gudyejcia.xyz",
    "gueecd.xyz",
    "guefontmo.cf",
    "guefontmo.ga",
    "guefontmo.gq",
    "guefontmo.ml",
    "guegeldfor.cf",
    "guegeldfor.ml",
    "guegeldfor.tk",
    "guehomo.top",
    "guelmorper.icu",
    "guelphdowntown.com",
    "guepoker.org",
    "guerillamail.biz",
    "guerillamail.com",
    "guerillamail.de",
    "guerillamail.info",
    "guerillamail.net",
    "guerillamail.org",
    "guerillamailblock.com",
    "guernseynaturereserve.com",
    "guerrillamail.biz",
    "guerrillamail.com",
    "guerrillamail.de",
    "guerrillamail.info",
    "guerrillamail.net",
    "guerrillamail.org",
    "guerrillamailblock.com",
    "guessju.buzz",
    "guessmail.com",
    "guessswin.site",
    "guesstimatr.com",
    "guesstri.xyz",
    "guest-lock.com",
    "guestblogify.com",
    "guestlock.net",
    "gueto2009.com",
    "guewkw.us",
    "gufum.com",
    "guge.de",
    "guge.website",
    "guhan.ru",
    "guhandmade.com",
    "guhu.site",
    "guia59.com",
    "guiadelcusco.com",
    "guiadomilionario.com",
    "guiavip.net",
    "guide4fit.ru",
    "guidebate.fun",
    "guidebate.online",
    "guidebate.site",
    "guidebated.site",
    "guidebates.site",
    "guideborn.site",
    "guidebut.site",
    "guidebuted.site",
    "guideflyfishing.com",
    "guideformy.site",
    "guideformyx.site",
    "guidelbe.site",
    "guidelberg.site",
    "guidelbert.site",
    "guidelepwu.space",
    "guidelia.site",
    "guidelian.site",
    "guideliber.site",
    "guidelible.site",
    "guidelic.site",
    "guidelican.site",
    "guidelicoe.site",
    "guidelicon.site",
    "guidelics.site",
    "guidelings.site",
    "guideliot.site",
    "guidelis.site",
    "guideliter.site",
    "guideliver.fun",
    "guideliver.online",
    "guideliver.site",
    "guidelous.site",
    "guidelphia.site",
    "guidelyu.site",
    "guidemic.site",
    "guidemical.site",
    "guidemics.site",
    "guidences.site",
    "guidency.site",
    "guidential.site",
    "guidention.site",
    "guideral.site",
    "guidered.fun",
    "guidered.online",
    "guidered.site",
    "guides4my.site",
    "guidesandmanual.site",
    "guidesforkids.com",
    "guidespire.site",
    "guidespita.site",
    "guidespite.fun",
    "guidespite.online",
    "guidespite.site",
    "guidetomentone.com",
    "guidewal.site",
    "guidewalls.site",
    "guidewan.fun",
    "guidewan.online",
    "guidewan.site",
    "guidewey.site",
    "guidings.info",
    "guilotle.ml",
    "guilotle.tk",
    "guineavgzo.space",
    "guineegames.net",
    "guiolpht.xyz",
    "guitar.asia",
    "guitardaddy.org",
    "guitarsxltd.com",
    "guitoco.ga",
    "guiwoallam.cf",
    "guiwoallam.ml",
    "guiwoallam.tk",
    "guizefacefx.net",
    "gujaratpetro.com",
    "gujpocel.gq",
    "gujpocel.ml",
    "gujpocel.tk",
    "guju.net",
    "gukibur.cf",
    "gukibur.ga",
    "gukibur.tk",
    "gulfcoastcooking.com",
    "gulfcoastcuisine.com",
    "gulfcoastfoods.com",
    "gulfmedic.org",
    "gulfshoreshotels.org",
    "gulftechology.com",
    "gulftel.com",
    "gulipine.site",
    "guliverenergija-igraonica.com",
    "gulkokulukoy.com",
    "gullaneplaygroup.com",
    "gumhome.ru",
    "gummosity.xyz",
    "gumrukkayip.com",
    "gun1k.ru",
    "gunapedia.org",
    "guncelco.com",
    "guncelhesap.com",
    "gundam-plamodel.info",
    "gundamfan.com",
    "gundogsclub.com",
    "gundogtrainerarkansas.com",
    "gunnersfans.com",
    "gunscutlo.ml",
    "gunscutlo.tk",
    "gunsportklop.ru",
    "gunzuki.info",
    "gunzuki.site",
    "guojihui3.com",
    "guojihui888.com",
    "guojihuidizhi.net",
    "guonancai.shop",
    "guotongholdings.com",
    "guowaishipin.xyz",
    "gupiaozhenduanpt.com",
    "guqage.ru",
    "guqoo.com",
    "gurgpola.cf",
    "gurgpola.ga",
    "gurgpola.ml",
    "gurgpola.tk",
    "gurgtapar.gq",
    "gurgtapar.ml",
    "gurgtapar.tk",
    "gurlmail.com",
    "gurman1.space",
    "gurmanabuket.ru",
    "gurmeneczadepo1.club",
    "gurneytintblog.com",
    "gurrifa.cf",
    "gurrifa.ga",
    "gurrifa.gq",
    "gurrifa.ml",
    "gurrifa.tk",
    "gurumail.xyz",
    "gurungkhabar.com",
    "gurutransfer.com",
    "gusarkazino777.com",
    "guscares.com",
    "gusevandy.ru",
    "gussocu.cf",
    "gussocu.gq",
    "gussocu.ml",
    "gussocu.tk",
    "gustidharya.com",
    "gustlabs.com",
    "gustore.co",
    "gustpay.com",
    "gustr.com",
    "gutenmorgen.site",
    "gutmensch.foundation",
    "gutmenschen.center",
    "gutmenschen.com",
    "gutmenschen.company",
    "gutmenschen.email",
    "gutmenschen.expert",
    "gutmenschen.guru",
    "gutmenschen.money",
    "gutmenschen.photos",
    "gutmenschen.realty",
    "gutmenschen.space",
    "gutmenschen.systems",
    "gutmenschen.tickets",
    "gutmenschen.tools",
    "gutmenschen.watch",
    "gutmenschen.website",
    "gutmenschen.works",
    "gutmenschen.zone",
    "gutterguard.xyz",
    "gutterscleanedmd.com",
    "guuao.info",
    "guudbzgeg.shop",
    "guvenliklietiket.xyz",
    "guvewfmn7j1dmp.cf",
    "guvewfmn7j1dmp.ga",
    "guvewfmn7j1dmp.gq",
    "guvewfmn7j1dmp.ml",
    "guvewfmn7j1dmp.tk",
    "guwjetsxm.shop",
    "guwvje.us",
    "guy.com",
    "guy2.com",
    "guyanafriends.com",
    "guycuco.gq",
    "guycuco.ml",
    "guycuco.tk",
    "guyfawkesfireworks.biz",
    "guyfawkesfireworks.net",
    "guykoshop.xyz",
    "guyrkkyy.shop",
    "guyromaniafor.website",
    "guysdobi.com",
    "guystelchim.gq",
    "guystelchim.ml",
    "guystelchim.tk",
    "guzelborc.online",
    "guzelim.net",
    "guzik-bux.ru",
    "guzik-game.ru",
    "guzik-loto.ru",
    "guzzthickfull.cf",
    "guzzthickfull.ga",
    "guzzthickfull.tk",
    "gvano.com",
    "gveihw.com",
    "gvnuclear.com",
    "gvquij.rest",
    "gvztim.gq",
    "gw5jy.us",
    "gwaqiz.us",
    "gwarpi.com",
    "gwfezmxd.shop",
    "gwfh.cf",
    "gwfh.ga",
    "gwfh.gq",
    "gwfh.ml",
    "gwfh.tk",
    "gwfmuaqt.xyz",
    "gwhnhz.shop",
    "gwhsgeckos.com",
    "gwix.net",
    "gwkmw.info",
    "gwllw.info",
    "gwm1ws.site",
    "gwm5a.us",
    "gwmail.gwu.edu",
    "gwmogi.gq",
    "gwn0zh.com",
    "gwp2.com",
    "gwspt71.com",
    "gwt0402.online",
    "gwt2201.buzz",
    "gwtc.net",
    "gwtvmeqy.shop",
    "gwyww.info",
    "gwzjoaquinito01.cf",
    "gx0n5n.best",
    "gx161.site",
    "gx2d.com",
    "gx2k24xs49672.cf",
    "gx2k24xs49672.ga",
    "gx2k24xs49672.gq",
    "gx2k24xs49672.ml",
    "gx2k24xs49672.tk",
    "gx7v4s7oa5e.cf",
    "gx7v4s7oa5e.ga",
    "gx7v4s7oa5e.gq",
    "gx7v4s7oa5e.ml",
    "gx7v4s7oa5e.tk",
    "gxbaw.com",
    "gxbnaloxcn.ga",
    "gxbnaloxcn.ml",
    "gxbnaloxcn.tk",
    "gxchaincapital.cn",
    "gxdbfe.us",
    "gxdmw.info",
    "gxemail.men",
    "gxglixaxlzc9lqfp.cf",
    "gxglixaxlzc9lqfp.ga",
    "gxglixaxlzc9lqfp.gq",
    "gxglixaxlzc9lqfp.ml",
    "gxglixaxlzc9lqfp.tk",
    "gxhy1ywutbst.cf",
    "gxhy1ywutbst.ga",
    "gxhy1ywutbst.gq",
    "gxhy1ywutbst.ml",
    "gxhy1ywutbst.tk",
    "gxklbl.us",
    "gxlmw.info",
    "gxlrgo.shop",
    "gxm90b.us",
    "gxmail.ga",
    "gxtyfetry-manage5.com",
    "gxvps.com",
    "gxwww.com",
    "gxxjld.com",
    "gxyl666.net",
    "gxyl666.org",
    "gxzsrr.info",
    "gy273.site",
    "gybatu.info",
    "gyberstore.top",
    "gyblerefy.host",
    "gyddd.com",
    "gydhru.us",
    "gyheqi.info",
    "gyigfoisnp560.ml",
    "gymdep.site",
    "gymgay.com",
    "gymkampen.se",
    "gymnasium-alsfeld.de",
    "gymnasty.life",
    "gymnasty.tech",
    "gynn.org",
    "gynzi.co.uk",
    "gynzi.com",
    "gynzi.es",
    "gynzi.nl",
    "gynzi.org",
    "gynzy.at",
    "gynzy.es",
    "gynzy.eu",
    "gynzy.gr",
    "gynzy.info",
    "gynzy.lt",
    "gynzy.mobi",
    "gynzy.pl",
    "gynzy.ro",
    "gynzy.ru",
    "gynzy.sk",
    "gyorsposta.com",
    "gyorsposta.hu",
    "gyp1.site",
    "gyp4.site",
    "gyp5.site",
    "gyp7.site",
    "gyro-net.ru",
    "gyroproject.com",
    "gyrosmalta.com",
    "gytiyu.com",
    "gyu3on.us",
    "gyul.ru",
    "gyxohy.info",
    "gyxq2d.us",
    "gyzb.email",
    "gza5op.us",
    "gzb.ro",
    "gzdkjxlw.shop",
    "gzdqg.us",
    "gzhenghua112.com",
    "gzip-proxy.ru",
    "gzjz.email",
    "gzlsw.info",
    "gznf.cc",
    "gzns.cc",
    "gzpl.cc",
    "gzpljm.us",
    "gzpq.cc",
    "gzqg.cc",
    "gzrf.cc",
    "gzrwx.com",
    "gzvmwiqwycv8topg6zx.cf",
    "gzvmwiqwycv8topg6zx.ga",
    "gzvmwiqwycv8topg6zx.gq",
    "gzvmwiqwycv8topg6zx.ml",
    "gzvmwiqwycv8topg6zx.tk",
    "gzxingbian.com",
    "gzykw.info",
    "gzziojhta.shop",
    "h-b-p.com",
    "h-mail.us",
    "h-response.com",
    "h.mintemail.com",
    "h.thc.lv",
    "h0116.top",
    "h02vat.host",
    "h05fypawbzlg017.xyz",
    "h09yb.space",
    "h0i.ru",
    "h0nwrgppwk8ryyt.xyz",
    "h1769.com",
    "h1775.com",
    "h1hecsjvlh1m0ajq7qm.cf",
    "h1hecsjvlh1m0ajq7qm.ga",
    "h1hecsjvlh1m0ajq7qm.gq",
    "h1hecsjvlh1m0ajq7qm.ml",
    "h1hecsjvlh1m0ajq7qm.tk",
    "h1tler.cf",
    "h1tler.ga",
    "h1tler.gq",
    "h1tler.ml",
    "h1tler.tk",
    "h1z8ckvz.com",
    "h2-yy.nut.cc",
    "h2.delivery",
    "h2.supplies",
    "h20powerinc.com",
    "h219.com",
    "h2o-gallery.ru",
    "h2o-web.cf",
    "h2o-web.ga",
    "h2o-web.gq",
    "h2o-web.ml",
    "h2o-web.tk",
    "h2ocn8f78h0d0p.cf",
    "h2ocn8f78h0d0p.ga",
    "h2ocn8f78h0d0p.gq",
    "h2ocn8f78h0d0p.ml",
    "h2ocn8f78h0d0p.tk",
    "h2ocoffe.ru",
    "h2otony.com",
    "h2sprey.ru",
    "h2wefrnqrststqtip.cf",
    "h2wefrnqrststqtip.ga",
    "h2wefrnqrststqtip.gq",
    "h2wefrnqrststqtip.ml",
    "h2wefrnqrststqtip.tk",
    "h323.ru",
    "h333.cf",
    "h333.ga",
    "h333.gq",
    "h333.ml",
    "h333.tk",
    "h37jbl.us",
    "h3fyu.us",
    "h3o2.us",
    "h3ssk4p86gh4r4.cf",
    "h3ssk4p86gh4r4.ga",
    "h3ssk4p86gh4r4.gq",
    "h3ssk4p86gh4r4.ml",
    "h3ssk4p86gh4r4.tk",
    "h3yv.us",
    "h42fu.space",
    "h467etrsf.cf",
    "h467etrsf.gq",
    "h467etrsf.ml",
    "h467etrsf.tk",
    "h546ns6jaii.cf",
    "h546ns6jaii.ga",
    "h546ns6jaii.gq",
    "h546ns6jaii.ml",
    "h546ns6jaii.tk",
    "h5dslznisdric3dle0.cf",
    "h5dslznisdric3dle0.ga",
    "h5dslznisdric3dle0.gq",
    "h5dslznisdric3dle0.ml",
    "h5dslznisdric3dle0.tk",
    "h5pstore.com",
    "h5qaz.cn",
    "h5srocpjtrfovj.cf",
    "h5srocpjtrfovj.ga",
    "h5srocpjtrfovj.gq",
    "h5srocpjtrfovj.ml",
    "h5srocpjtrfovj.tk",
    "h5svo0.us",
    "h5xepuv8eor7sd9.xyz",
    "h635.com",
    "h65syz4lqztfrg1.cf",
    "h65syz4lqztfrg1.ga",
    "h65syz4lqztfrg1.gq",
    "h65syz4lqztfrg1.ml",
    "h65syz4lqztfrg1.tk",
    "h6gyj.us",
    "h6kepf-mail.xyz",
    "h6xoap.us",
    "h7665.com",
    "h78qp.com",
    "h79ig.site",
    "h7hfeo.xyz",
    "h7ke6lb7rmqlhga0.buzz",
    "h7l3jvlv40oot8y.xyz",
    "h7qns.buzz",
    "h7vpvodrtkfifq35z.cf",
    "h7vpvodrtkfifq35z.ga",
    "h7vpvodrtkfifq35z.gq",
    "h7vpvodrtkfifq35z.ml",
    "h7vpvodrtkfifq35z.tk",
    "h7xbkl9glkh.cf",
    "h7xbkl9glkh.ga",
    "h7xbkl9glkh.gq",
    "h7xbkl9glkh.ml",
    "h7xbkl9glkh.tk",
    "h80nm.site",
    "h82323.com",
    "h84tmp.us",
    "h88fun.com",
    "h8s.org",
    "h8usp9cxtftf.cf",
    "h8usp9cxtftf.ga",
    "h8usp9cxtftf.gq",
    "h8usp9cxtftf.ml",
    "h8usp9cxtftf.tk",
    "h8vk9uk6g0o3f2c3vi7v.com",
    "h8y8n.site",
    "h91.info",
    "h9js8y6.com",
    "h9lxd2.info",
    "h9uqwr.info",
    "h9x3bz.online",
    "ha1dq.us",
    "ha4xwq.info",
    "ha7d2.stream",
    "haanybano.net",
    "haar52.com",
    "haatma.com",
    "hab-verschlafen.de",
    "habacityi.com",
    "habad.win",
    "habb.futbol",
    "haberarena.com",
    "habere-maximus.info",
    "haberfa.com",
    "haberoku24.com",
    "habitue.net",
    "hablas.com",
    "hablemosdeorgasmos.com",
    "habmalnefrage.de",
    "habnetfm.online",
    "habrack.ru",
    "habrew.de",
    "hac1.com",
    "hacccc.com",
    "hackart.ru",
    "hackdenver.com",
    "hacked.jp",
    "hackedflashgame.com",
    "hacken.company",
    "hackepic.org",
    "hacker.onl",
    "hackermail.com",
    "hackermail.net",
    "hackerndgiveaway.ml",
    "hackers.onl",
    "hackersquad.tk",
    "hackervietnam.mobi",
    "hackhack.org",
    "hacking.onl",
    "hackinglatinoamerica.net",
    "hackingtruths.net",
    "hackingyourfunnel.com",
    "hacklet.com",
    "hacknophobia.net",
    "hackrz.xyz",
    "hacksleague.ru",
    "hacksly.com",
    "hackspace.org",
    "hackthatbit.ch",
    "hacktherules.com",
    "hackwish.com",
    "hackwish.net",
    "hackzone.club",
    "hactzayvgqfhpd.cf",
    "hactzayvgqfhpd.ga",
    "hactzayvgqfhpd.gq",
    "hactzayvgqfhpd.ml",
    "hactzayvgqfhpd.tk",
    "haddego.cf",
    "haddego.ml",
    "haddo.eu",
    "hade.com",
    "hadesa.info",
    "hadge.xyz",
    "hadits.app",
    "hadits9imam.com",
    "haditspilihan.com",
    "haecvx.tokyo",
    "haerdmoc.shop",
    "hafan.sk",
    "hafbak-reg.online",
    "hafhvt.com",
    "hafluzzter.cf",
    "hafluzzter.gq",
    "hafluzzter.tk",
    "hafnia.biz",
    "haft-time.com",
    "hafzo.net",
    "haggreroren.gq",
    "hagiasophiagroup.com",
    "hagiasophiaonline.com",
    "hagomedia.com",
    "hahabu.net",
    "hahawrong.com",
    "haiapoteker.com",
    "haicao45.com",
    "haicao47.com",
    "haicao48.com",
    "haicao54.com",
    "haicao55.com",
    "haicao77.com",
    "haicao80.com",
    "haicao83.com",
    "haicao99.com",
    "haicaotv2.com",
    "haicaotv3.com",
    "haida-edu.cn",
    "haidang.co",
    "haier-mail.com",
    "haierair.biz",
    "haierair.com",
    "haieramerica.us",
    "haieramerica.xyz",
    "haieramericas.com",
    "haieramericashop.com",
    "haihantnc.xyz",
    "haikuforlovers.com",
    "haikuinthemiddle.info",
    "hailchat.com",
    "hailmail.net",
    "hailuwuliu.com",
    "haimai.pro",
    "hainescitynews.net",
    "hainopalm.cf",
    "hainopalm.ga",
    "hainopalm.ml",
    "hainopalm.tk",
    "haiok.cf",
    "hair-shoponline.info",
    "hairbeautysave.com",
    "hairbrushescombs.futbol",
    "hairdresser.com",
    "hairdresser.net",
    "hairgrwetp.site",
    "hairjournal.com",
    "hairjuiceformula.shop",
    "hairpenaltyhigh.website",
    "hairs-shoponline.info",
    "hairs24.ru",
    "hairsite.website",
    "hairstylesbase.com",
    "hairstylesforshorthair.website",
    "hairstyleszon.xyz",
    "hairwizard.in",
    "hairyvideos.pro",
    "haitaous.com",
    "haitiassurances.com",
    "haitibateau.com",
    "haitibox.com",
    "haitibrasil.com",
    "haiticadeau.com",
    "haiticell.com",
    "haiticonsult.com",
    "haiticonsultants.com",
    "haitiexchange.com",
    "haitiholdings.com",
    "haitilearning.com",
    "haitiloan.com",
    "haitimoto.com",
    "haitipret.com",
    "haitiproducts.com",
    "haitirelief.org",
    "haitirhum.com",
    "haitisecurit.com",
    "haitisell.com",
    "haitisound.com",
    "haititicket.com",
    "haititraining.com",
    "haititransfers.com",
    "haitmail.ga",
    "haitt-54.com",
    "haitu.info",
    "haiyundata.com",
    "haizap.com",
    "haizi360.com",
    "hakimisoap.com",
    "hakinsiyatifi.org",
    "hakkarifotokopiservisi.com",
    "hakwefs.online",
    "hakwefs.xyz",
    "hala-tv.net",
    "halafun.com",
    "halaltech.net",
    "halamed724.com",
    "halapenz.com",
    "haldihouse.net",
    "haledamn.us",
    "half-blue.com",
    "halfpricedlistingak.com",
    "halfpricedlistingal.com",
    "halfpricedlistingaz.com",
    "halfpricedlistingct.com",
    "halfpricedlistingin.com",
    "halfpricedlistingky.com",
    "halfpricedlistingla.com",
    "halfpricedlistingmd.com",
    "halfpricedlistingmi.com",
    "halfpricedlistingmt.com",
    "halfpricedlistingnc.com",
    "halfpricedlistingoh.com",
    "halfpricedlistingpa.com",
    "halfpricedlistingsak.com",
    "halfpricedlistingsca.com",
    "halfpricedlistingsco.com",
    "halfpricedlistingsde.com",
    "halfpricedlistingsin.com",
    "halfpricedlistingsks.com",
    "halfpricedlistingsma.com",
    "halfpricedlistingsmd.com",
    "halfpricedlistingsnh.com",
    "halfpricedlistingsnj.com",
    "halfpricedlistingsny.com",
    "halfpricedlistingsor.com",
    "halfpricedlistingspa.com",
    "halfpricedlistingssc.com",
    "halfpricedlistingstn.com",
    "halfpricedlistingsvt.com",
    "halfpricedlistingswa.com",
    "halfpricedlistingvt.com",
    "halfpricedlistingwy.com",
    "halfpricelistingal.com",
    "halfpricelistingca.com",
    "halfpricelistingco.com",
    "halfpricelistingde.com",
    "halfpricelistingin.com",
    "halfpricelistingks.com",
    "halfpricelistingky.com",
    "halfpricelistingla.com",
    "halfpricelistingma.com",
    "halfpricelistingme.com",
    "halfpricelistingnc.com",
    "halfpricelistingne.com",
    "halfpricelistingnj.com",
    "halfpricelistingnm.com",
    "halfpricelistingok.com",
    "halfpricelistingor.com",
    "halfpricelistingpa.com",
    "halfpricelistingri.com",
    "halfpricelistingsal.com",
    "halfpricelistingsaz.com",
    "halfpricelistingsc.com",
    "halfpricelistingsco.com",
    "halfpricelistingsde.com",
    "halfpricelistingsia.com",
    "halfpricelistingsin.com",
    "halfpricelistingsks.com",
    "halfpricelistingsmd.com",
    "halfpricelistingsmn.com",
    "halfpricelistingsmo.com",
    "halfpricelistingssd.com",
    "halfpricelistingstx.com",
    "halfpricelistingswv.com",
    "halfpricelistingswy.com",
    "halfpricelistingut.com",
    "halfpricelistingva.com",
    "halfpricelistingwa.com",
    "halfpricelistingwv.com",
    "halfsale.info",
    "halftisca.tk",
    "halfwayhomepets.com",
    "halgum.ru",
    "halhuel.info",
    "halibiotic.xyz",
    "halidepo.com",
    "halil.ml",
    "halkmedia.xyz",
    "hallacamail.xyz",
    "hallbarhetschefen.se",
    "hallovisa.site",
    "hallsportklop.ru",
    "hallsulrics.cf",
    "hallsulrics.ga",
    "hallsulrics.gq",
    "hallsulrics.tk",
    "halltail.info",
    "halltail.org",
    "halltail.us",
    "halltale.info",
    "halltale.org",
    "halltale.us",
    "hallvulcan.ru",
    "halmstadstad.com",
    "halofarmasi.com",
    "halogeterer.monster",
    "halopets.net",
    "haloqq.info",
    "halqaran.org",
    "halsbrandburp.website",
    "halsey3.com",
    "haltospam.com",
    "ham-radio-op.net",
    "hamarikahani.gq",
    "hamburguesas.net",
    "hamcagers.cf",
    "hamcagers.gq",
    "hamcagers.ml",
    "hamcagers.tk",
    "hamcollege.com",
    "hamformrum.ga",
    "hamformrum.gq",
    "hamiltonfans.co.uk",
    "hamiltongiftbaskets.com",
    "hamishdurkin.com",
    "hamitk.info",
    "hammbur.com",
    "hammel-shredder-repair.com",
    "hammer53.website",
    "hammerdin.com",
    "hammergod.dk",
    "hammersfans.com",
    "hammerthor.solutions",
    "hamonclub.ru",
    "hampanel.com",
    "hampel.co",
    "hamptonroads.com",
    "hampusidan.com",
    "hamroagro.com",
    "hamrobeema.com",
    "hamsagiftshop.com",
    "hamsterx.club",
    "hamusoku.cf",
    "hamusoku.ga",
    "hamusoku.gq",
    "hamusoku.ml",
    "hamusoku.tk",
    "hamzayousfi.tk",
    "hana-toge.online",
    "hanatravel.ru",
    "handavesa.info",
    "handavesy.info",
    "handaxisy.info",
    "handbag.com",
    "handcareshop.life",
    "handcleanser.net",
    "handcrafted.market",
    "handcrafters.shop",
    "handev.ru",
    "handgling.website",
    "handionline.org",
    "handjobfantasy.com",
    "handleit.com",
    "handlingus.com",
    "handlmassager.com",
    "handmadecrochet.website",
    "handprep.vision",
    "handsanitizer.health",
    "handskinat.ga",
    "handskinat.ml",
    "handskinat.tk",
    "handsntzr.com",
    "handsojcwd.ru",
    "handstand.cam",
    "handsupot.net",
    "handysca.xyz",
    "handysnif.email",
    "handystag.xyz",
    "handywa.icu",
    "handywast.xyz",
    "handywi.press",
    "handzonhealth.store",
    "hanesamazon.com",
    "hanfordlawyers.com",
    "hang-ten.com",
    "hangersshop.live",
    "hanggiagoc.website",
    "hangglidemail.com",
    "hanghot.club",
    "hangifinansman.xyz",
    "hangisiyi.online",
    "hangisiyi.xyz",
    "hangtimeimageclub.com",
    "hangxomcuatoilatotoro.cf",
    "hangxomcuatoilatotoro.ga",
    "hangxomcuatoilatotoro.gq",
    "hangxomcuatoilatotoro.ml",
    "hangxomcuatoilatotoro.tk",
    "hangzhoubarcelona.com",
    "hangzhousongtang.com",
    "hanhhuyen.ml",
    "haningtonbrothers.xyz",
    "haniv.ignorelist.com",
    "hankbed.site",
    "hankbike.site",
    "hankboy.site",
    "hankbun.site",
    "hankcan.site",
    "hankclover.site",
    "hankcrowd.site",
    "hankday.site",
    "hankfan.site",
    "hankflag.site",
    "hankjar.site",
    "hankwards.info",
    "hanleft.com",
    "hanlinpalace.com",
    "hanmail.net",
    "hanmama.zz.am",
    "hannahbarclay.net",
    "hannahphillipsreal.net",
    "hannahsphotos.com",
    "hanoi.video",
    "hanoi24h.site",
    "hanoigeckohotel.com",
    "hanoimail.us",
    "hanoimoi.site",
    "hanoinews.org",
    "hanoisapphirehotel.com",
    "hanoitohalongbay.com",
    "hanoitraveladvisor.com",
    "hanoiyeuvn.website",
    "hanquanlalala.xyz",
    "hansactic.online",
    "hansahost.net",
    "hansen.dk",
    "hanswurst.gmbh",
    "hantem.bid",
    "haoacg.com",
    "haodd173.com",
    "haodd178.com",
    "haodd191.com",
    "haodd193.com",
    "haodi123.com",
    "haofangbi.com",
    "haofangpo.com",
    "haofangsa.com",
    "haofangsi.com",
    "haogltoqdifqq.cf",
    "haogltoqdifqq.ga",
    "haogltoqdifqq.gq",
    "haogltoqdifqq.ml",
    "haogltoqdifqq.tk",
    "haohuihh.com",
    "haomei456.com",
    "haotuk.site",
    "haoy678.com",
    "haoyaogeccx.com",
    "haoyouo.com",
    "haozanding.com",
    "hapancy.ru",
    "happelyhealthy.com",
    "happemail.com",
    "happiness-and-success.ru",
    "happinesseveryday.ru",
    "happinessz.club",
    "happiray.com",
    "happityhill.com",
    "happy-ate.com",
    "happy-garden-waterford.com",
    "happy-house-tramore.com",
    "happy-kz.club",
    "happy-relat.ru",
    "happy-times-sallynoggin.com",
    "happy-training.ru",
    "happyallsizes.com",
    "happyalmostfriday.com",
    "happybaby-store.ru",
    "happybirthdayrishanth.live",
    "happycar24.space",
    "happycash.app",
    "happycashbox.com",
    "happycat.space",
    "happychance13.icu",
    "happychance15.icu",
    "happychangelog.com",
    "happycore.shop",
    "happycounsel.com",
    "happydatingyou.site",
    "happydoggies.xyz",
    "happydomik.ru",
    "happyellygoes.com",
    "happyfamilysavings.site",
    "happyfamilysavings.space",
    "happyfreshdrink.com",
    "happygoluckyclub.com",
    "happyhealthtoday.com",
    "happyhealthypeacefullife.com",
    "happyhealthyvegan.life",
    "happykorea.club",
    "happykoreas.xyz",
    "happymail.guru",
    "happymovies.ru",
    "happynsimple.com",
    "happypath.land",
    "happypuppy.com",
    "happyselling.com",
    "happysilktravel.com",
    "happysinner.co.uk",
    "happywifree.com",
    "happyyou.pw",
    "haqed.com",
    "haqoci.com",
    "harakirimail.com",
    "haramamba.ru",
    "harassduejockey.website",
    "harbibet11.com",
    "harbibet13.com",
    "harborgoos.xyz",
    "harbourtradecredit.com",
    "hard-life.online",
    "hard-life.org",
    "hard-mark.ru",
    "hardassetalliance.com",
    "hardbrewcoffee.club",
    "hardclossio.ga",
    "hardclossio.gq",
    "hardclossio.tk",
    "hardcorefreak.com",
    "harddep.website",
    "hardergames.eu",
    "hardily.site",
    "hardleanbodies.com",
    "hardmughven.ga",
    "hardmughven.gq",
    "hardmughven.ml",
    "hardmughven.tk",
    "hardpersonalblog.club",
    "hardvecgeme.tk",
    "hardwarewalletira.com",
    "hardwarewalletrothira.com",
    "hardwoodflooringinla.com",
    "hardworking.dk",
    "hardyhouse.online",
    "hardyoungbabes.com",
    "hareshop.site",
    "hargadiskon.xyz",
    "hargaku.org",
    "haribu.com",
    "haribu.net",
    "harite.space",
    "harkerheightsapartments.com",
    "harleyspencer.com",
    "harlingenapartments.com",
    "harlowe-galway.com",
    "harmampirs.com",
    "harmonikka.space",
    "harmonized511uj.online",
    "harmonyfiberart.com",
    "harmonyradio.org",
    "harmonyst.xyz",
    "harmonystarkennelfrenchbulldogs.com",
    "harmonystime.net",
    "harmsreach.com",
    "harmsreach.org",
    "harmwepa.ga",
    "harmwepa.gq",
    "harmwepa.ml",
    "harmwepa.tk",
    "harnessmedia.dev",
    "harnosubs.cf",
    "harnosubs.ga",
    "harnosubs.gq",
    "harnosubs.tk",
    "haroldrappiii.com",
    "harpbenefitsurvey.com",
    "harpeligibilityquiz.com",
    "harperforarizona.com",
    "harrietrobertson.buzz",
    "harrisburgbankrupctylawyers.com",
    "harriscountycriminallawfirm.com",
    "harrisonartanddesign.com",
    "harrisonburgbaptist.com",
    "harrisonms.com",
    "harrisonms.org",
    "harryhome.net",
    "harrykneifel.com",
    "harrymorrison.buzz",
    "harrys-casino.com",
    "harsh.best",
    "harshmeet.com",
    "harshrajput.website",
    "harshrastogi.com",
    "harshreadinglevel.site",
    "harsoftpunis.gq",
    "hart-macher.com",
    "hartapkr.online",
    "hartapoker88.site",
    "hartbot.de",
    "hartfordlibrary.info",
    "hartini.ga",
    "hartini.ml",
    "hartmann-powermix.ru",
    "hartogbaer.com",
    "hartstonge-bar-restaurant.com",
    "hartyfarm.com",
    "harukana.press",
    "harukanaru.ru",
    "harvard-ac-uk.tk",
    "harvesinvestmentgroup.com",
    "harvestacademydz.com",
    "harvestcentre.org",
    "harvesteco.com",
    "harvestingharlow.com",
    "harvestmendoza.icu",
    "harveynaylor.buzz",
    "harysetiabudi.site",
    "has.ninja",
    "hasanatilan.xyz",
    "hasanmail.ml",
    "hasanz.kiwi",
    "hasegawa.cf",
    "hasegawa.gq",
    "haselperus.info",
    "haseo.ru",
    "hasgama.cf",
    "hasgama.ga",
    "hasgama.gq",
    "hasgama.ml",
    "hasgama.tk",
    "hash.moe",
    "hash.pp.ua",
    "hashback.com",
    "hashban.org",
    "hashicorp.asia",
    "hashicorp.best",
    "hashicorp.blog",
    "hashicorp.buzz",
    "hashicorp.careers",
    "hashicorp.chat",
    "hashicorp.club",
    "hashicorp.consulting",
    "hashicorp.contractors",
    "hashicorp.dev",
    "hashicorp.domains",
    "hashicorp.education",
    "hashicorp.engineer",
    "hashicorp.exposed",
    "hashicorp.fans",
    "hashicorp.finance",
    "hashicorp.financial",
    "hashicorp.foundation",
    "hashicorp.global",
    "hashicorp.info",
    "hashicorp.legal",
    "hashicorp.life",
    "hashicorp.link",
    "hashicorp.ltd",
    "hashicorp.media",
    "hashicorp.page",
    "hashicorp.plus",
    "hashicorp.pub",
    "hashicorp.report",
    "hashicorp.reviews",
    "hashicorp.rip",
    "hashicorp.sale",
    "hashicorp.shop",
    "hashicorp.sk",
    "hashicorp.social",
    "hashicorp.solutions",
    "hashicorp.store",
    "hashicorp.tech",
    "hashicorp.technology",
    "hashicorp.today",
    "hashicorp.training",
    "hashicorp.us",
    "hashicorp.website",
    "hashicorp.world",
    "hashicorp.xyz",
    "hashratehunters.com",
    "hashratetest.com",
    "hashtagblock.com",
    "hashtagbyte.com",
    "hashtagcandy.com",
    "hashtagdiamond.com",
    "hashtagmarijuana.com",
    "hashtagtesla.com",
    "hashtagtours.com",
    "hashtagvacationrentals.com",
    "hashtagweed.com",
    "hashwiki.com",
    "hasilon.com",
    "hassle-me.com",
    "hasslemail.top",
    "hasslex.com",
    "hassyaku.tk",
    "hastarlat.site",
    "hastingsrealestateagents.com",
    "hastisub2.xyz",
    "hastnyi-dom.ru",
    "hat-geld.de",
    "hat-muzika.ru",
    "hatayantakyamobilya.xyz",
    "hatayboru.xyz",
    "hataygercegi.com",
    "hataystratton.xyz",
    "hataysusofrasi.com",
    "hatberkshire.com",
    "hatchinglab.com",
    "hatchroads.info",
    "hatchspaceship.com",
    "hate.cf",
    "hate.cloud",
    "hatechoice.com",
    "hatespam.org",
    "hatiyangpatah.online",
    "hatmail.ir",
    "hatonly.shop",
    "haugenvet.com",
    "hauharcugi.tk",
    "haultale.info",
    "haultale.org",
    "haultale.us",
    "hauptmanfamilyhealthcenter.com",
    "hauswirtschaft.wiki",
    "haute.red",
    "havadari.online",
    "havadari.world",
    "havadari.xyz",
    "havaliyedekparca.com",
    "havdhave.shop",
    "haveacreditcardmall.com",
    "haveanotion.com",
    "havehavd.shop",
    "haveplant.site",
    "haverp.online",
    "haverti.cf",
    "haverti.gq",
    "haverti.tk",
    "havevi.info",
    "havilahdefilippis.com",
    "havitaring.xyz",
    "havocranasia.site",
    "havwatch.com",
    "haw88.com",
    "hawahome.info",
    "hawaii.rr.com",
    "hawaiiantel.net",
    "hawaiihomesurfer.com",
    "hawdam.com",
    "hawkblack.xyz",
    "hawkcreek.info",
    "hawkhomeservices.com",
    "hawkosmosishour.website",
    "hawkwoodpreschool.com",
    "hawrong.com",
    "hawrteq.online",
    "hax0r.id",
    "hayalhost.com",
    "hayamisanhamegamienai.xyz",
    "hayatadairhyk.xyz",
    "hayattankopma.org",
    "haycoudo.cf",
    "haycoudo.ga",
    "haycoudo.gq",
    "haycoudo.ml",
    "haydegidelim.com",
    "haydenjennings.buzz",
    "haydidi.com",
    "haydoo.com",
    "hayirlieller.ong",
    "haylam.com",
    "haymala.best",
    "haymond.legal",
    "haymondgirls.net",
    "haymondlaw.info",
    "haymondlaw.net",
    "haymondlaw.org",
    "haymondrides.info",
    "haymondrides.net",
    "hays.ml",
    "hayycj.icu",
    "hazarat.design",
    "hazarat90.com",
    "hazayuno.com",
    "hazelmczwu.space",
    "hazelnut4u.com",
    "hazelnuts4u.com",
    "hazelwoodgrove.net",
    "hazirmesaj.info",
    "hazirsite.site",
    "hazmatdictionary.com",
    "hazmatshipping.org",
    "hazziz.ze.cx",
    "hb-120.com",
    "hb-1tvm.com",
    "hb-3tvm.com",
    "hb5.ru",
    "hb6008.com",
    "hba4nr0lh16mg4y.xyz",
    "hbastien.com",
    "hbbbtttt.club",
    "hbbig.us",
    "hbdya.info",
    "hbent.site",
    "hbgrkzqx.shop",
    "hbhgdq.com",
    "hbikpo.rest",
    "hbjfhc.com",
    "hbkm.de",
    "hble6r6s.xyz",
    "hbo.dns-cloud.net",
    "hbo.dnsabr.com",
    "hbontqv90dsmvko9ss.cf",
    "hbontqv90dsmvko9ss.ga",
    "hbontqv90dsmvko9ss.gq",
    "hbontqv90dsmvko9ss.ml",
    "hbontqv90dsmvko9ss.tk",
    "hboqce.info",
    "hbqjw.info",
    "hbrjn.space",
    "hbs-group.ru",
    "hbsc.de",
    "hbsl10.com",
    "hbt02y.host",
    "hbtfty.com",
    "hburl.xyz",
    "hbwgw.info",
    "hbwr166.com",
    "hbxrlg4sae.cf",
    "hbxrlg4sae.ga",
    "hbxrlg4sae.gq",
    "hbxrlg4sae.ml",
    "hbxrlg4sae.tk",
    "hc2gw.com",
    "hc44.net",
    "hc49.net",
    "hc59.net",
    "hc72.net",
    "hc73.net",
    "hc74.net",
    "hc76.net",
    "hc94.net",
    "hc96.net",
    "hcac.net",
    "hcathcar.shop",
    "hccg.net",
    "hccmail.win",
    "hccmmis.com",
    "hccnis.com",
    "hciiyl.com",
    "hckefu.online",
    "hckefu.site",
    "hckefu.xyz",
    "hclrizav2a.cf",
    "hclrizav2a.ga",
    "hclrizav2a.gq",
    "hclrizav2a.ml",
    "hclrizav2a.tk",
    "hcmvbg.site",
    "hcnxmvdo.shop",
    "hcoupledp.com",
    "hcuglasgow.com",
    "hcvoid.us",
    "hcxnw.info",
    "hcyb.email",
    "hcysw.info",
    "hcyxrnhrl.shop",
    "hczx.email",
    "hczx8888.com",
    "hd-mail.com",
    "hd3vmbtcputteig.cf",
    "hd3vmbtcputteig.ga",
    "hd3vmbtcputteig.gq",
    "hd3vmbtcputteig.ml",
    "hd3vmbtcputteig.tk",
    "hd731.com",
    "hd88156.com",
    "hd9837.com",
    "hdapps.com",
    "hdc9.us",
    "hdcanlimacizle.org",
    "hdcp345.com",
    "hdczu7uhu0gbx.cf",
    "hdczu7uhu0gbx.ga",
    "hdczu7uhu0gbx.gq",
    "hdczu7uhu0gbx.ml",
    "hdczu7uhu0gbx.tk",
    "hddiziizle.mobi",
    "hddotcom.com",
    "hdexch.com",
    "hdf6ibwmredx.cf",
    "hdf6ibwmredx.ga",
    "hdf6ibwmredx.gq",
    "hdf6ibwmredx.ml",
    "hdf6ibwmredx.tk",
    "hdfgh45gfjdgf.tk",
    "hdfshsh.stream",
    "hdgana.website",
    "hdhkmbu.ga",
    "hdhkmbu.ml",
    "hdiganaz.ga",
    "hdiganaz.gq",
    "hdiganaz.ml",
    "hdiganaz.tk",
    "hditalia.space",
    "hdkinofan.ru",
    "hdkinosh.online",
    "hdko1.online",
    "hdlipocenters.com",
    "hdlords.online",
    "hdmoviestore.us",
    "hdo.net",
    "hdonroerendgoed.com",
    "hdparts.de",
    "hdplayer.shop",
    "hdprice.co",
    "hdqlxtlmm.shop",
    "hdrezka.press",
    "hdrlf.us",
    "hdsdentistportal.org",
    "hdserialonline.ru",
    "hdserialy.ru",
    "hdspot.de",
    "hdszw.info",
    "hdtube.site",
    "hdvideo-kontent.ru",
    "hdvideo-smotry.ru",
    "hdvxxx.space",
    "hdylzcym.com",
    "he-creditcardnofeeca-ok.live",
    "he-tu-new-car-ok.live",
    "he-tu-new-cars-ok.live",
    "he1079.com",
    "he3mdb.us",
    "he8he.com",
    "heaa.info",
    "headbone.com",
    "headphones4you.info",
    "headphonesifans1.ru",
    "headphonestest.com",
    "headset5pl.com",
    "headstrong.de",
    "heajsdh298.xyz",
    "healbutty.info",
    "healingthemhealingus.org",
    "healratur.cf",
    "healratur.ga",
    "healsmybdy.online",
    "healt-diet.ru",
    "health-1-beauty.ru",
    "health-2-beauty.ru",
    "health-blog1.xyz",
    "health-blog2.xyz",
    "health-club.pro",
    "health-insurance-for-minnesota.com",
    "health-insurance-for-texas.com",
    "health-nutrition.xyz",
    "health-puzzle.com",
    "health112.ru",
    "healthaccessories.exposed",
    "healtharise.com",
    "healthbeam.site",
    "healthbeautynatural.site",
    "healthbiotrim.com",
    "healthcarealliancegroups.com",
    "healthcarepractitionersnearme.com",
    "healthcareprovidersnearme.com",
    "healthcareprovidersnearme.org",
    "healthcareseoagency.com",
    "healthchoicemaryland.info",
    "healthcoachali.press",
    "healthcoachpractitioner.com",
    "healthdata.ru",
    "healthemail.net",
    "healthfalkten.cf",
    "healthfalkten.gq",
    "healthfalkten.ml",
    "healthfitnesschannel.club",
    "healthfitnews.club",
    "healthforhelp.org",
    "healthgransal.cf",
    "healthgransal.gq",
    "healthgransal.tk",
    "healthlium.com",
    "healthlivingcoach.com",
    "healthlycbd.com",
    "healthmensstyle.info",
    "healthmeup.club",
    "healthmuseum.org",
    "healthnews.biz",
    "healthnutexpress.com",
    "healthoutlet.ru",
    "healthpositive.site",
    "healthpoweredkids.net",
    "healthrahis.ga",
    "healthrahis.gq",
    "healthranli.cf",
    "healthranli.ga",
    "healthranli.gq",
    "healthranli.ml",
    "healthranli.tk",
    "healthroutecard.com",
    "healthscatter.net",
    "healthsciencetrust.com",
    "healthshop.futbol",
    "healthy-happy-life8.xyz",
    "healthy-line.online",
    "healthyalkalinewater.us",
    "healthybody.store",
    "healthydiets.ru",
    "healthyfoodandlife.club",
    "healthyheartforall.com",
    "healthyheartforall.org",
    "healthyhikers.net",
    "healthyhydrofarm.net",
    "healthyhydrofarms.net",
    "healthymanreviews.website",
    "healthypetscbd.com",
    "healthypetscbd.net",
    "healthyphalkalinewater.us",
    "healthysocialnews.com",
    "healthyteethandgums.net",
    "healthyyouinc.com",
    "healvalg.host",
    "healyourself.xyz",
    "heangdilly.icu",
    "heari.net",
    "hearpower.us",
    "heartandhopefund.com",
    "heartfair.xyz",
    "heartgrantsimple.com",
    "heartland-arnone.xyz",
    "heartlandrv4life.com",
    "heartmcanof.ga",
    "heartmcanof.gq",
    "heartmcanof.ml",
    "heartmcanof.tk",
    "heartno.xyz",
    "heartnob.xyz",
    "heartofiowa.net",
    "heartofrecycling.net",
    "heartofrecycling.org",
    "heartowhatisay.club",
    "heartpou.press",
    "heartsfans.com",
    "heartstargreetings.com",
    "heartthrob.com",
    "hearyousay.club",
    "heatabzxup.space",
    "heathcotebarr.eu",
    "heathealthv.xyz",
    "heathenhammer.com",
    "heathenhero.com",
    "heathenhq.com",
    "heatingandplumbingnearme.com",
    "heatroosterinfo.website",
    "heatssova.cf",
    "heatssova.ga",
    "heaven.dk",
    "heavycloth.com",
    "heavymail.dk",
    "heavymetalparkinglot.net",
    "heavynoize.net",
    "heavyst.xyz",
    "heb-it.com",
    "hebagfu.cf",
    "hebagfu.gq",
    "hebatmart.xyz",
    "hebedbugremovalok.live",
    "hebeos.online",
    "hebohdomino88.com",
    "hebohpkv.design",
    "hebohpkv2.com",
    "hebohpkv88.com",
    "hebohpkv88.net",
    "hebpfyy.com",
    "hebron.academy",
    "hecat.es",
    "hecktiga.xyz",
    "hectoliter216ug.online",
    "hedcet.com",
    "hedefajans.site",
    "hedgehog.us",
    "hedsatemi.tk",
    "heduian.space",
    "hedy.gq",
    "heebqn.info",
    "heeco.me",
    "heeeet.site",
    "heeneman.group",
    "heerlijkbezorgen.com",
    "heerman.best",
    "heerschap.com",
    "heesun.net",
    "heett.best",
    "heffernanonline.com",
    "heftrack.com",
    "hegeblacker.com",
    "hegfqn.us",
    "hehe.com",
    "heheai.info",
    "heidengardens.com",
    "heiditates.info",
    "heightsheaters.top",
    "heihamail.com",
    "heikouzi.com",
    "heinribenj.space",
    "heinrich-group.com",
    "heirret.shop",
    "heisei.be",
    "heisserreifen.com",
    "heistnukes.com",
    "hejumarket.site",
    "hekisha.com",
    "hekvxdcww.info",
    "helados.online",
    "helbest.site",
    "hele12300.online",
    "hele8game.org",
    "helenastripsearch.com",
    "helenmackreath.com",
    "helenmariefoundation.com",
    "helichinanz.net",
    "helicolsafety.com",
    "heliozivor.space",
    "heliqq.online",
    "hell.plus",
    "hell3.ru",
    "hellenicfeta.com",
    "hellenion.com",
    "hellheater.ru",
    "hellmode.com",
    "hello-volgograd.ru",
    "hello.hu",
    "hello.net.au",
    "hello.to",
    "helloairfares.com",
    "hellobali.online",
    "hellobuurman.com",
    "hellobuurvrouw.com",
    "hellocab.biz",
    "hellocab.city",
    "hellocab.club",
    "hellocab.online",
    "hellocab.shop",
    "hellocab.site",
    "hellocab.store",
    "hellocab.taxi",
    "hellocab.tips",
    "hellocab.today",
    "hellocab.us",
    "hellocab.world",
    "hellocab.xyz",
    "hellocheese.online",
    "hellococonono.site",
    "hellococonono.website",
    "hellococonono.xyz",
    "hellodream.mobi",
    "helloedo.com",
    "hellohuman.dev",
    "hellokitty.com",
    "hellolinked.net",
    "hellolive.xyz",
    "hellomail.fun",
    "hellomore.com",
    "hellopizza-sligo.com",
    "helloricky.com",
    "helloteststore.com",
    "hellow-man.pw",
    "hellowhoopsie.com",
    "hellowman.pw",
    "hellowperson.pw",
    "helloyii.com",
    "helloyyh.com",
    "hells-heater.ru",
    "hellsheater.ru",
    "helm.ml",
    "helmade.xyz",
    "heloca.cf",
    "heloca.ml",
    "heloca.tk",
    "help-desk-manager.com",
    "help-find-number.com",
    "help-medical.fun",
    "help-medical.host",
    "help-medical.icu",
    "help-medical.info",
    "help-medical.press",
    "help-medical.pro",
    "help-medical.site",
    "help-medical.space",
    "help-medical.website",
    "help24assist.site",
    "help4hedgehogs.org",
    "helpcryptocurrency.com",
    "helpcustomerdepartment.ga",
    "helpemails.com",
    "helpforblood.com",
    "helpfored.club",
    "helpformyreactivedog.com",
    "helpforstudents.ru",
    "helpfulriddles.com",
    "helphosting.online",
    "helpi.club",
    "helpinghandtaxcenter.org",
    "helpjobs.ru",
    "helpline174.ru",
    "helpmail.cf",
    "helpmebuysomething.com",
    "helpmegrowmysales.com",
    "helpotdeitit-confirmed.com",
    "helpotdeitit-meet-backup.com",
    "helpotdeitit-meet.com",
    "helpwesearch.com",
    "helrey.cf",
    "helrey.ga",
    "helrey.gq",
    "helrey.ml",
    "helter-skelter.com",
    "helthcare.store",
    "helthyandfitnesslife.com",
    "hemanthkumar.biz",
    "hematological290ta.online",
    "hemenal5.space",
    "hemenbahis101.com",
    "hemenbahis102.com",
    "hemenbahis104.com",
    "hemenbahis105.com",
    "hemenbahis107.com",
    "hemenbahis109.com",
    "hemenbahis111.com",
    "hemenbahis112.com",
    "hemenbahis113.com",
    "hemenbahis115.com",
    "hemenbahis64.com",
    "hemenbahis65.com",
    "hemenbahis67.com",
    "hemenbahis68.com",
    "hemenbahis71.com",
    "hemenbahis72.com",
    "hemenbahis79.com",
    "hemenbahis88.com",
    "hemenbahis92.com",
    "hemenbahis96.com",
    "hemenbahis97.com",
    "hemenfinansman.online",
    "hemetapartments.com",
    "hemetshopping.com",
    "hemic493iq.online",
    "hemin539kw.online",
    "hemmelig.dk",
    "hemohim-atomy.ru",
    "hemonjs.site",
    "hemoroidy-leczenie-domowe.xyz",
    "hemostatic249tx.online",
    "hemp.organic",
    "hempcrete.us",
    "hempdeho.cf",
    "hempdeho.gq",
    "hempdeho.ml",
    "hempdeho.tk",
    "hempjh.com",
    "hempnoticblends.com",
    "hempseed.com",
    "hempshop.life",
    "hempshop.organic",
    "hemptodayshop.com",
    "hempwell.green",
    "hempworkz.org",
    "hempworld.net",
    "hendersonnailsalons.com",
    "hendigrepair.com",
    "hendlexseramiksatisi.site",
    "hendoc.pro",
    "hendrickplumbing.com",
    "hendrikarifqiariza.cf",
    "hendrikarifqiariza.ga",
    "hendrikarifqiariza.gq",
    "hendrikarifqiariza.ml",
    "hendrikarifqiariza.tk",
    "hendrixapp.com",
    "hendrixheatandair.com",
    "hengcaiii.com",
    "hengy2zc.com",
    "henhed.ru",
    "henho24h.info",
    "hennetdphar.cf",
    "hennetdphar.tk",
    "henningsen.dk",
    "henrikoffice.us",
    "henriksen.dk",
    "henry-mail.ml",
    "henrylin.xyz",
    "henrymfpfx.website",
    "henryripplingergallery.com",
    "hensleyshop.space",
    "hentaref.cf",
    "hentaref.ml",
    "hentodr.shop",
    "heovang68.net",
    "hepcatstudio.com",
    "hepria.pro",
    "hepsimaras.com",
    "hepta.games",
    "her-102.com",
    "heraldnznew.site",
    "heramicher.com",
    "herb-e.net",
    "herbadvisor.org",
    "herbalcorner.org",
    "herbalifemedico.com",
    "herbalsoftware.com",
    "herbalsolutions.llc",
    "herbamart.xyz",
    "herbaworks2u.com",
    "herbert1818.site",
    "herbsvigour.com",
    "hercn.com",
    "herculestoto.com",
    "herdtrack.com",
    "here-for-more.info",
    "hereabkhel.ru",
    "herediano.com",
    "herediumabogados.net",
    "herediumabogados.org",
    "heremail.com",
    "heremart.com",
    "herforklo.site",
    "hergrteyye8877.cf",
    "hergrteyye8877.ga",
    "hergrteyye8877.gq",
    "hergrteyye8877.ml",
    "hergrteyye8877.tk",
    "herh2-privntur.fun",
    "herh2-privntur.site",
    "herh2-privntur.xyz",
    "herien.design",
    "herlesi.cf",
    "herlesi.ga",
    "herlesi.gq",
    "herlesi.tk",
    "herlitthis.press",
    "hermesdesigner.store",
    "hermesjs.dev",
    "hermesvm.dev",
    "hermitcraft.cf",
    "hernote.com",
    "herocalce.com",
    "herochecklist.com",
    "herocopters.com",
    "heroeskaring.org",
    "heroesmag.online",
    "heroesofblood.com",
    "heroicepics.com",
    "heroindetoxcenterguide.com",
    "heroine-cruhser.cf",
    "heroinrehabcenterprograms.com",
    "herono1.com",
    "heros3.com",
    "herosamericancafe.com",
    "heroshirts.net",
    "herp.in",
    "herpderp.nl",
    "herplan.com",
    "herr-der-mails.de",
    "herrek.online",
    "herriring.cf",
    "herriring.ga",
    "herriring.ml",
    "herschl.com",
    "herseyburadaa.online",
    "hersfund.org",
    "hertader.site",
    "hertheshisdires.info",
    "hertogscholars.org",
    "hertzsybilliver.site",
    "herunterladen-1.xyz",
    "herwaylifestyle.com",
    "heryerokulum.xyz",
    "hesaplikontor.online",
    "hesaplikontor.xyz",
    "heshengcai.xyz",
    "hestra.build",
    "het-familiehuis.site",
    "hetbudgets.info",
    "hetedater.com",
    "hetekontakter.com",
    "heterokyuq.space",
    "heterozuvi.space",
    "heterto.ru",
    "hethox.com",
    "hetkanmijnietschelen.space",
    "hetnet.nl",
    "heure.shop",
    "heuschrecken.kaufen",
    "hewgen.ru",
    "hewke.xyz",
    "hewthewa.shop",
    "hewuko.site",
    "hewushops.site",
    "hex2.com",
    "hexa.click",
    "hexa.photo",
    "hexagonmail.com",
    "hexapi.ga",
    "hexasploit.xyz",
    "hexatown.ru",
    "hexeby.info",
    "hexiecom.com",
    "heximail.com",
    "hexkf.live",
    "hexqr84x7ppietd.cf",
    "hexqr84x7ppietd.ga",
    "hexqr84x7ppietd.gq",
    "hexqr84x7ppietd.ml",
    "hexqr84x7ppietd.tk",
    "hey.com",
    "hey.to",
    "heyitsvanessa.com",
    "heyveg.com",
    "hezarpay.com",
    "hezemail.ga",
    "hezll.com",
    "hezupe.info",
    "hf-playing.ru",
    "hf2sko.us",
    "hf83tx-mail.xyz",
    "hfcee.com",
    "hfctd1.site",
    "hfd-house.site",
    "hfdh7y458ohgsdf.tk",
    "hfengshui.com",
    "hffgyn.us",
    "hffinrsmud.fun",
    "hfggw.info",
    "hfgponshops.com",
    "hfmf.cf",
    "hfmf.ga",
    "hfmf.gq",
    "hfmf.ml",
    "hfmf.tk",
    "hfpd.net",
    "hfq09.space",
    "hfsym.com",
    "hg0cp.monster",
    "hg14.app",
    "hg15.app",
    "hg16.app",
    "hg17.app",
    "hg188198.com",
    "hg19.app",
    "hg20.app",
    "hg21.app",
    "hg23.app",
    "hg25.app",
    "hg29.app",
    "hg32.app",
    "hg34.app",
    "hg37.app",
    "hg39.app",
    "hg40.app",
    "hg520666.com",
    "hg7akt.us",
    "hg8n415.com",
    "hgame.org",
    "hgcash2.com",
    "hgcash678.com",
    "hgdideyd.shop",
    "hgdvwzdno.shop",
    "hgfh.de",
    "hghnaturals.com",
    "hgomw4.site",
    "hgpoker9.com",
    "hgqcol.com",
    "hgrmnh.cf",
    "hgrmnh.ga",
    "hgrmnh.gq",
    "hgrmnh.ml",
    "hgsygsgdtre57kl.tk",
    "hguopd.info",
    "hgwdjx.com",
    "hgxin44.com",
    "hgxw9k.us",
    "hgxxsycdj.shop",
    "hh-ee.com",
    "hh5608.com",
    "hh8058.com",
    "hh8061.com",
    "hh8690.com",
    "hhasdgyyyiii.xyz",
    "hhbj.host",
    "hhbj.website",
    "hhbwikdcq.shop",
    "hhcqldn00euyfpqugpn.cf",
    "hhcqldn00euyfpqugpn.ga",
    "hhcqldn00euyfpqugpn.gq",
    "hhcqldn00euyfpqugpn.ml",
    "hhcqldn00euyfpqugpn.tk",
    "hhd1212.com",
    "hhdevel.com",
    "hhdyw.info",
    "hhdzy3.us",
    "hhgg33.com",
    "hhh.sytes.net",
    "hhhh9927.com",
    "hhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh.info",
    "hhhhyl.com",
    "hhioscar.com",
    "hhitbridgee.site",
    "hhitlytick.site",
    "hhjdw.info",
    "hhkai.com",
    "hhkmp.us",
    "hhmmds2t.net",
    "hhn2n.us",
    "hhnet.net",
    "hhomesite.com",
    "hhpiffho.shop",
    "hhthyw.com",
    "hhu911.com",
    "hhudra2web.com",
    "hhutdden.shop",
    "hhxo.com",
    "hhylgjgw.com",
    "hi07zggwdwdhnzugz.cf",
    "hi07zggwdwdhnzugz.ga",
    "hi07zggwdwdhnzugz.gq",
    "hi07zggwdwdhnzugz.ml",
    "hi07zggwdwdhnzugz.tk",
    "hi1dcthgby5.cf",
    "hi1dcthgby5.ga",
    "hi1dcthgby5.gq",
    "hi1dcthgby5.ml",
    "hi1dcthgby5.tk",
    "hi2.in",
    "hi3rt6.us",
    "hi427.site",
    "hi5.si",
    "hi645.com",
    "hi6547mue.com",
    "hialeah-towing-miami.info",
    "hiapig.ru",
    "hiatrante.ml",
    "hibareview.com",
    "hibernates.best",
    "hiboowe.xyz",
    "hibsfans.co.uk",
    "hibya.xyz",
    "hicgxwwum.shop",
    "hicloud.life",
    "hicmd.net",
    "hicnsoft.com",
    "hicostand.site",
    "hicuspee.ga",
    "hicuspee.gq",
    "hidayahcentre.com",
    "hidden-code.org",
    "hiddencorner.xyz",
    "hiddencovepark.com",
    "hiddentragedy.com",
    "hide-mail.net",
    "hideakifan.com",
    "hidebox.org",
    "hidebusiness.xyz",
    "hideemail.net",
    "hidemail.de",
    "hidemail.pro",
    "hidemail.us",
    "hideme.be",
    "hidemyass.com",
    "hideweb.xyz",
    "hidjuhxanx9ga6afdia.cf",
    "hidjuhxanx9ga6afdia.ga",
    "hidjuhxanx9ga6afdia.gq",
    "hidjuhxanx9ga6afdia.ml",
    "hidjuhxanx9ga6afdia.tk",
    "hidkey.ru",
    "hidra2web.site",
    "hidzz.com",
    "hielilis.cf",
    "hielilis.gq",
    "hielilis.tk",
    "hifa-oil.com",
    "higcentral.ga",
    "higcentral.gq",
    "higcentral.tk",
    "high.tips",
    "highbeam.io",
    "highbros.org",
    "highcafe-athlone.com",
    "highdesertturf.net",
    "higherac.com",
    "higherwxum.space",
    "highestinfluence.com",
    "highganic.com",
    "highground.store",
    "highgroundjiujitsu.com",
    "highlanddoctors.com",
    "highlandparkrealestateagents.com",
    "highlevel.store",
    "highlevelcoder.cf",
    "highlevelcoder.ga",
    "highlevelcoder.gq",
    "highlevelcoder.ml",
    "highlevelcoder.tk",
    "highlevelgamer.cf",
    "highlevelgamer.ga",
    "highlevelgamer.gq",
    "highlevelgamer.ml",
    "highlevelgamer.tk",
    "highme.store",
    "highmilton.com",
    "highonline.store",
    "highperformanceevent.com",
    "highpoint-holistic-cleansing.com",
    "highpointspineandjoint.com",
    "highprice.store",
    "highquality.com",
    "highsite.store",
    "highsouvro.tk",
    "highspace.store",
    "highstatusleader.com",
    "highsulln.us",
    "highteher.tk",
    "highticketaudit.com",
    "highveldmail.co.za",
    "highvideo.ru",
    "highwayeqe.com",
    "highweb.store",
    "highwranim.cf",
    "highwranim.gq",
    "highwranim.tk",
    "higogoya.com",
    "hihalfpricedlistings.com",
    "hihalfpricelisting.com",
    "hihalfpricelistings.com",
    "hiholerd.ru",
    "hii5pdqcebe.cf",
    "hii5pdqcebe.ga",
    "hii5pdqcebe.gq",
    "hii5pdqcebe.ml",
    "hii5pdqcebe.tk",
    "hijayt.shop",
    "hijijy.info",
    "hijrahusahawan.com",
    "hijyendelisi.xyz",
    "hikali90.bid",
    "hikeeastcoasttrail.com",
    "hikeforcam.com",
    "hikelists.info",
    "hikingwithdogs.xyz",
    "hikitas-rnim.ru",
    "hilarious.com",
    "hilarymacmillan.ru",
    "hilbetgirisyap.com",
    "hilbetmobil.com",
    "hilbetonline.com",
    "hilbettr.com",
    "hilfe-24.info",
    "hili.site",
    "hill63.org",
    "hillary-email.com",
    "hillatimels.tk",
    "hillcountryone.com",
    "hillopy.ru",
    "hillpturser.cf",
    "hillpturser.ga",
    "hillpturser.gq",
    "hillsong.events",
    "hilltop-pizzeria.com",
    "hilocals.net",
    "hiltonbet38.com",
    "hiltonbet40.com",
    "hiltonbet45.com",
    "hiltonbet71.com",
    "hiltonbet73.com",
    "hiltonbet75.com",
    "hiltonbet76.com",
    "hiltonbet87.com",
    "hiltonbet92.com",
    "hiltonbet93.com",
    "hiltonbettv21.com",
    "hiltonbettv22.com",
    "hiltonbettv23.com",
    "hiltonbettv27.com",
    "hiltonbettv30.com",
    "hiltonvr.com",
    "hilvarenbeek.info",
    "hilwellchev.cf",
    "hilwellchev.ga",
    "hilwellchev.gq",
    "hilwellchev.ml",
    "himail.online",
    "himaksiunmul.site",
    "himdhima.shop",
    "himkinet.ru",
    "himovies.club",
    "himovies.fun",
    "himovies.host",
    "himovies.website",
    "himpxn.us",
    "himte.xyz",
    "himtee.com",
    "hincisy.cf",
    "hincisy.ga",
    "hincisy.gq",
    "hincisy.ml",
    "hincisy.tk",
    "hindam.net",
    "hindbuzz.info",
    "hindimeinhelp.com",
    "hindimusic.info",
    "hindiroman.com",
    "hindugoddessempowerment.com",
    "hinduhome.com",
    "hinfalitt.ru",
    "hingis.org",
    "hinhanhdep.pro",
    "hinhnen.asia",
    "hinkrigi.cf",
    "hinktacell.gq",
    "hinmatof.xyz",
    "hioscat.com",
    "hiotwb.us",
    "hipay.dev",
    "hiperbet.info",
    "hiperbet.net",
    "hiperbet.org",
    "hiperbetbahis.net",
    "hiperbetbonus.com",
    "hiperbetgiris.bet",
    "hipermetropameliyati.com",
    "hipflexs.com",
    "hiphop-fotografiach.com",
    "hiphopfan.com",
    "hipmi.net",
    "hipmisfitgui.website",
    "hippie.dk",
    "hippolyt.help",
    "hipponut.net",
    "hippymulch.com",
    "hiprootjwr.space",
    "hips-trainer.ru",
    "hiq90.space",
    "hiqbiz.com",
    "hiqkr7.info",
    "hiqny3.us",
    "hiraethgroup.com",
    "hire4less.net",
    "hirebi.cf",
    "hirebi.ml",
    "hirebi.tk",
    "hireelectricbike.com",
    "hiremystyle.com",
    "hirikajagani.com",
    "hiringup.net",
    "hiru-dea.com",
    "hirunger.space",
    "hisalotk.cf",
    "hisalotk.ga",
    "hisalotk.gq",
    "hisalotk.ml",
    "hisarlondon.xyz",
    "hischist.shop",
    "hisense.org",
    "hishark.best",
    "hishatak.com",
    "hishescape.space",
    "hishyau.cf",
    "hishyau.ga",
    "hishyau.gq",
    "hishyau.ml",
    "hisiwjw8293939.fnisj892kosoks29293939.heliohost.org",
    "hismetons.xyz",
    "hispavista.com",
    "hispeed.ch",
    "hisrelentlesslove.com",
    "hissfuse.com",
    "histhisc.shop",
    "historicallybent.com",
    "historicoldhomes.com",
    "historicstalphonsus.org",
    "historictheology.com",
    "historidie.ru",
    "historyalone.com",
    "historyofsoca.com",
    "historyship.ru",
    "hit-best-buy.ru",
    "hit-magazine-buy.ru",
    "hit4sale.icu",
    "hitachirail.cf",
    "hitachirail.ga",
    "hitachirail.gq",
    "hitachirail.ml",
    "hitachirail.tk",
    "hitachirailsts.cf",
    "hitale.ru",
    "hitbase.net",
    "hitbet58.com",
    "hitbet59.com",
    "hitbts.com",
    "hitchhikingthe7seas.com",
    "hitechbank.org",
    "hitechinfo.com",
    "hitetogogoda.ru",
    "hitler-adolf.cf",
    "hitler-adolf.ga",
    "hitler-adolf.gq",
    "hitler-adolf.ml",
    "hitler-adolf.tk",
    "hitlive.ru",
    "hitmail.com",
    "hitmanrecords.com",
    "hitokoto.org",
    "hitons.ru",
    "hitprice.co",
    "hitradiopatrick.online",
    "hitseller.host",
    "hitsfit.com",
    "hitsmag.ru",
    "hitsproduct.top",
    "hitthe.net",
    "hitysi.info",
    "hiva.world",
    "hive306.com",
    "hivemusic.org",
    "hiveos.org",
    "hiwager.games",
    "hiwager.plus",
    "hiwave.org",
    "hiweb.org",
    "hiwxfn.com",
    "hix.kr",
    "hixtory.com",
    "hiyaa.site",
    "hiyofr.us",
    "hiyrey.cf",
    "hiyrey.ga",
    "hiyrey.gq",
    "hiyrey.ml",
    "hiz.kr",
    "hizbd8.us",
    "hizirisg.xyz",
    "hizlieticaret.com",
    "hizliodegec.com",
    "hizliodevegec.com",
    "hj9ll8spk3co.cf",
    "hj9ll8spk3co.ga",
    "hj9ll8spk3co.gq",
    "hj9ll8spk3co.ml",
    "hj9ll8spk3co.tk",
    "hjdosage.com",
    "hjfgyjhfyjfytujty.ml",
    "hjfsupport.com",
    "hjfzn1.site",
    "hjgh545rghf5thfg.gq",
    "hjhs777.com",
    "hjios.us",
    "hjirnbt56g.xyz",
    "hjkcfa3o.com",
    "hjkhgh6ghkjfg.ga",
    "hjkkb.host",
    "hjnmyp.com",
    "hjprw.info",
    "hjtopoker.net",
    "hjvnjv.com",
    "hk-50.com",
    "hk18.space",
    "hk188188.com",
    "hk20.space",
    "hk23pools.info",
    "hk23pools.net",
    "hk23pools.org",
    "hk25.space",
    "hk29.space",
    "hk44238.com",
    "hk7727.com",
    "hk7767.com",
    "hk8858.com",
    "hkapa.edu",
    "hkbplw.icu",
    "hkbpoker.com",
    "hkbxclub.com",
    "hkbxgwpuq.shop",
    "hkcmgx.fun",
    "hkcmxr.fun",
    "hkcp87.com",
    "hkd6ewtremdf88.cf",
    "hkdewa.org",
    "hkee1.xyz",
    "hkfmkp.fun",
    "hkfs.ru",
    "hkft7pttuc7hdbnu.cf",
    "hkft7pttuc7hdbnu.ga",
    "hkft7pttuc7hdbnu.ml",
    "hkfy2424.com",
    "hkg.net",
    "hkglotto.com",
    "hkhangsen.ru",
    "hkhk.de",
    "hkhmyn.fun",
    "hkjinhuarun.com",
    "hkjmnp.fun",
    "hkjmtw.fun",
    "hklove.ml",
    "hkmbqmubyx5kbk9t6.cf",
    "hkmbqmubyx5kbk9t6.ga",
    "hkmbqmubyx5kbk9t6.gq",
    "hkmbqmubyx5kbk9t6.ml",
    "hkmbqmubyx5kbk9t6.tk",
    "hkpmst.fun",
    "hkrmpx.fun",
    "hkrmxr.fun",
    "hksmnm.fun",
    "hkstarphoto.com",
    "hkstorey.com",
    "hksuning.store",
    "hktmrd.fun",
    "hku.us.to",
    "hkww1.xyz",
    "hkxmck.fun",
    "hkxmld.fun",
    "hkxmqp.fun",
    "hky6f9.us",
    "hkypw.info",
    "hkzg.email",
    "hl11277.com",
    "hl353.online",
    "hl51.com",
    "hl7.cloud",
    "hlawfirm.net",
    "hlcrw.info",
    "hldgeraldton.website",
    "hldn.de",
    "hldv.info",
    "hlfbgv.site",
    "hlgame9.com",
    "hlgjsy.com",
    "hlinsd.us",
    "hliwa.cf",
    "hljxtjs.com",
    "hlmvf9.us",
    "hlooy.com",
    "hlopshueh.xyz",
    "hlqp11277.com",
    "hlw12.life",
    "hlw13.life",
    "hlw14.life",
    "hlw20.life",
    "hlw21.life",
    "hlw24.life",
    "hlw25.life",
    "hlw28.life",
    "hlw29.life",
    "hlw30.life",
    "hlw31.life",
    "hlw34.life",
    "hlw35.life",
    "hlw38.life",
    "hlw44.life",
    "hlw45.life",
    "hlw48.life",
    "hlw49.life",
    "hlw5.life",
    "hlw6.life",
    "hlw8.life",
    "hlw9.life",
    "hlwmbl.net",
    "hlwsp9.com",
    "hlwxoq.best",
    "hm02.app",
    "hm03.app",
    "hm07.app",
    "hm08.app",
    "hm09.app",
    "hm10.app",
    "hm13.app",
    "hm16.app",
    "hm18.app",
    "hm19.app",
    "hm20.app",
    "hm21.app",
    "hm25.app",
    "hm3o8w.host",
    "hmail.top",
    "hmail.us",
    "hmamail.com",
    "hmchat.ru",
    "hmcq4e.site",
    "hmcu.edu.vn",
    "hmfgw.info",
    "hmh.ro",
    "hmhrvmtgmwi.cf",
    "hmhrvmtgmwi.ga",
    "hmhrvmtgmwi.gq",
    "hmhrvmtgmwi.ml",
    "hmhrvmtgmwi.tk",
    "hmhshops.com",
    "hmhu.com",
    "hmhwords.com",
    "hmjjne.rest",
    "hmjm.de",
    "hmkmedical.com",
    "hmmarketru.ru",
    "hmmbswlt5ts.cf",
    "hmmbswlt5ts.ga",
    "hmmbswlt5ts.gq",
    "hmmbswlt5ts.ml",
    "hmmbswlt5ts.tk",
    "hmos.systems",
    "hmotomotiv.xyz",
    "hmx.at",
    "hmyisitme.xyz",
    "hn-lb01.xyz",
    "hn1548.us",
    "hn5nfo.us",
    "hnbjs.us",
    "hndard.com",
    "hndifeng.com",
    "hndj365.com",
    "hnfk5o.us",
    "hngwrb7ztl.ga",
    "hngwrb7ztl.gq",
    "hngwrb7ztl.ml",
    "hngwrb7ztl.tk",
    "hnhlenchtumba.site",
    "hnhobedlekalo.space",
    "hnhtipzavtrak.space",
    "hniiywf.site",
    "hnkyho.us",
    "hnlmtoxaxgu.cf",
    "hnlmtoxaxgu.ga",
    "hnlmtoxaxgu.gq",
    "hnlmtoxaxgu.tk",
    "hnndw.info",
    "hnpnw.info",
    "hntr93vhdv.uy.to",
    "hntth.com",
    "hnyl67.com",
    "hnyl69.com",
    "hnyl96.com",
    "ho-707.com",
    "ho2zgi.host",
    "ho3twwn.com",
    "ho770.site",
    "hoa-collect.com",
    "hoa-collect.net",
    "hoa-collect.org",
    "hoa-southbend.com",
    "hoabinhmail.us",
    "hoacollect.com",
    "hoangduc.best",
    "hoangdz11.tk",
    "hoanggiaanh.com",
    "hoanglong.tech",
    "hoangmanhtuong.ml",
    "hoangmyhanh.ga",
    "hoangnghiale.ml",
    "hoangngocviet.ga",
    "hoangthanhtam.ga",
    "hoangthaonguyen.ml",
    "hoangthihoa.ga",
    "hoangthikimlien.ml",
    "hoangthimyhanh.ga",
    "hoangvannam.ga",
    "hoangvuson.ga",
    "hoarderhousebuyers.com",
    "hobartrealestateagents.com",
    "hobbi-dlj-myzchin.ru",
    "hobby-site.com",
    "hobby-site.org",
    "hobbybreak.site",
    "hobbyhand.ru",
    "hobbyhure.online",
    "hobbyspo.xyz",
    "hobbyspor.icu",
    "hobbysuit.site",
    "hobbywe.recipes",
    "hobicapsa.org",
    "hobitogelapps.com",
    "hobocolo.info",
    "hocaninyeri.xyz",
    "hocantonese.com",
    "hocgaming.com",
    "hochiminhflorist.net",
    "hochsitze.com",
    "hocibbo.cf",
    "hocibbo.ga",
    "hocibbo.ml",
    "hockeymail.com",
    "hockeyshop.live",
    "hockeytrek.com",
    "hockinhdoanh.info",
    "hocl.hospital",
    "hoclaiotocaptoc.com",
    "hocseo.top",
    "hocsinh.asia",
    "hocsinh.mobi",
    "hoctiengquangdong.com",
    "hodady.club",
    "hodady.online",
    "hodady.site",
    "hodler.land",
    "hodu24.net",
    "hodu30.net",
    "hodu52.net",
    "hodutv.fun",
    "hodutv7.fun",
    "hodutv8.fun",
    "hodutv9.fun",
    "hody.site",
    "hoekiesikstudie.online",
    "hoer.pw",
    "hoerhelfer.com",
    "hoesmistreatgut.website",
    "hofato.info",
    "hofffe.site",
    "hofmannfilms.com",
    "hofo0i.us",
    "hofu.site",
    "hoga.site",
    "hoganmachine.com",
    "hoganpwst.space",
    "hogee.com",
    "hoggr.com",
    "hoggtheroad.com",
    "hogzilla.biz",
    "hohiny.info",
    "hohows.club",
    "hoi-poi.com",
    "hoianancienttownhotel.com",
    "hoichoonline.website",
    "hoinnchinese.com",
    "hoistsec.com",
    "hojfccubvv.ml",
    "hokicmcbet.xyz",
    "hokijeep.club",
    "hokipuma.com",
    "hokpoker.org",
    "hol.gr",
    "hola.org",
    "holaveso.website",
    "holcombefinancial.net",
    "holdandgrow.com",
    "holdfit.info",
    "holdup.me",
    "holeio1.net",
    "holeio2.net",
    "holidayrelief.online",
    "holidaytraveling.site",
    "holiganbetkayit.com",
    "holl.ga",
    "holliefindlaymusic.com",
    "holly-randall.com",
    "hollymccravy.com",
    "hollywood-spb.ru",
    "hollywoodkids.com",
    "holocart.com",
    "holod93.ru",
    "holodol.ru",
    "holodos18.ru",
    "holodosov.ru",
    "hologramskies.com",
    "holoholopu.club",
    "holr.us",
    "holstenwall.top",
    "holstory.ru",
    "holy-nevis.ru",
    "holyevents.net",
    "holypet.ru",
    "holywaiveknee.website",
    "holzwohnbau.de",
    "holzzwerge.de",
    "homa14.live",
    "homa19.live",
    "homail.com",
    "homal.com",
    "homaring.xyz",
    "hombre.fun",
    "hombressimbolicos.com",
    "home-1shop.website",
    "home-care-assistance-leger-agency.com",
    "home-email.com",
    "home-gym-direct.com",
    "home-sales-by-owner.com",
    "home-tech.fun",
    "home.de",
    "home.dyndns.org",
    "home.news.cn",
    "home.nl",
    "home.no.net",
    "home.ro",
    "home.se",
    "home.tennis",
    "home2busova.ru",
    "home411insurance.xyz",
    "home411now.xyz",
    "home411online.xyz",
    "home411services.xyz",
    "home5858.com",
    "homeaa318.xyz",
    "homearragement.site",
    "homeart.com",
    "homebasednetworks.com",
    "homebusinesshosting.us",
    "homecareandhospital.com",
    "homecareoptical.com",
    "homedalian.se",
    "homedecoideas.info",
    "homedecorcafe.com",
    "homedecoretips.com",
    "homedecorunique.com",
    "homedepinst.com",
    "homedesignideas.website",
    "homedesignsidea.info",
    "homedns.org",
    "homedonation.org",
    "homeesite.com",
    "homeextensionsperth.com",
    "homeforsale225.com",
    "homeftp.net",
    "homeftp.org",
    "homegadgeteer.com",
    "homehunterdallas.com",
    "homeinsuranceagentsnearme.com",
    "homeinteriorcorner.com",
    "homeip.net",
    "homekittools.com",
    "homelab.reviews",
    "homelanddiamondvillage.com",
    "homelavka.ru",
    "homelinux.com",
    "homelinux.net",
    "homelinux.org",
    "homelistingsbackbay.com",
    "homelivingusa.store",
    "homelocator.com",
    "homeluxuryvillas.com",
    "homemail.co.za",
    "homemail.com",
    "homemaraiz.online",
    "homemarkethome.com",
    "homemarketing.ru",
    "homemediaworld.com",
    "homenetmail.com",
    "homenmoderno.life",
    "homeofficetelecom.com",
    "homeonthethrone.com",
    "homeopathicinjectiontherapy.com",
    "homeopcost.com",
    "homepels.ru",
    "homeprofessional.org",
    "homepwner.com",
    "homeremodelingportal.com",
    "homerentall.com",
    "homeroomtechnologies.com",
    "homesaleswoodbury.com",
    "homesandvillas.marriott",
    "homescreen.store",
    "homesecuritytv.org",
    "homesforsalegrandjunciton.com",
    "homesiite.com",
    "homesinalamedacouty.com",
    "homesrockwallgroup.com",
    "homestead.com",
    "homesweetporchswing.com",
    "hometownliving.net",
    "hometrendsdecor.xyz",
    "homeunix.com",
    "homeunix.net",
    "homeunix.org",
    "homevia3.club",
    "homevia4.club",
    "homeworkcentral.com",
    "homeworkonline24.ru",
    "homeworkserver.com",
    "homeyou.org",
    "homeyrealestate.com",
    "homgrouprealty.com",
    "homienotes.com",
    "hominghen.com",
    "hominidviews.com",
    "homk.zone",
    "hommim.ru",
    "homorcu.com",
    "homosaosjy.ru",
    "homstel.website",
    "homude.info",
    "homycons.com",
    "homyfootprint.com",
    "homymail.ml",
    "honater.ga",
    "honater.gq",
    "honda-brasil.club",
    "honda-fit.club",
    "hondaautomotivepart.com",
    "hondahrv.club",
    "hondamotors.email",
    "hondamotors.fun",
    "hondamotors.loan",
    "hondamotors.rocks",
    "hondasukha3.com",
    "hondenstore.com",
    "honduras.com",
    "honestcto.com",
    "honestwealthblog.com",
    "honeybet90.org",
    "honeyedoakforge.com",
    "honeyfragilelodge.site",
    "honeygain.house",
    "honeygain.shop",
    "honeygain.tech",
    "honeymoonpackagesmauritius.com",
    "honeynet.us",
    "honeys.be",
    "hong-kee-glasnevin.com",
    "hong-kong.guide",
    "hongbao.app",
    "hongkee-glasnevin.com",
    "hongkong.com",
    "hongkongpools.one",
    "hongkongpools.uno",
    "hongpress.com",
    "hongyun-yule.com",
    "honid.live",
    "honk.network",
    "honl2isilcdyckg8.cf",
    "honl2isilcdyckg8.ga",
    "honl2isilcdyckg8.gq",
    "honl2isilcdyckg8.ml",
    "honl2isilcdyckg8.tk",
    "honoluluhairsalons.com",
    "honor-8.com",
    "honorably909ya.online",
    "honoraryufa.email",
    "honorcl.xyz",
    "honorcli.xyz",
    "honorquiet.com",
    "honorskat.icu",
    "honorsolidlucid.site",
    "honorvenu.icu",
    "honourbasedviolence.com",
    "honourfcnj.space",
    "honourslist.org",
    "honst.best",
    "hoodet.ru",
    "hoodsshop.live",
    "hooglygoogly.com",
    "hook-up1.com",
    "hook-up2.com",
    "hook2up2.com",
    "hookah-love.ru",
    "hookup.net",
    "hooli.me",
    "hoomdesign.xyz",
    "hoonle.com",
    "hooohush.ai",
    "hoopsmail.com",
    "hoopwell.com",
    "hoosiereliteheat.com",
    "hoosuu.com",
    "hooters.org",
    "hootttbbbtt.club",
    "hoovering.com",
    "hop-on-hop-off-agianapa.com",
    "hop-on-hop-off-nicosia.com",
    "hopbrook.net",
    "hopeajans.com",
    "hopeeyesa.info",
    "hopefulservices.com",
    "hopelcqcxmj.email",
    "hopemail.biz",
    "hopesweets.org",
    "hopikoglu.club",
    "hoponhopofflarnaca.com",
    "hoponhopoffpafos.com",
    "hopoverview.com",
    "hoppinessdelivered.org",
    "hoppumyu.website",
    "hopqey.info",
    "hopswitch.com",
    "hopto.org",
    "horanferguson.com",
    "horas24news.host",
    "horbahotel.online",
    "horecalt.com",
    "horecaplekreserveren.online",
    "horitomo.xyz",
    "horizonremovalists.com",
    "horizonview.net",
    "horizonx.host",
    "hormannequine.com",
    "hormuziki.ru",
    "hornsipe.tk",
    "horny-datings2.com",
    "hornyalwary.top",
    "horol.info",
    "horosho-spat.ru",
    "horoshomne24.ru",
    "horrible.best",
    "horrormail.com",
    "horrorplaybook.com",
    "horsebrai.press",
    "horsebrow.email",
    "horsefucker.org",
    "horserashnesslumen.site",
    "horserecords.net",
    "horserecords.org",
    "horsesportnetwork.com",
    "horsesteengirls.com",
    "horsestor.press",
    "horstenegger.site",
    "horswerifdig.xyz",
    "horvathurtablahoz.ml",
    "hos24.de",
    "hosmebow.cf",
    "hosmebow.ga",
    "hosmebow.gq",
    "hosmebow.ml",
    "hospitalingles.com",
    "hospkerhy.cf",
    "hospkerhy.ml",
    "hospkerhy.tk",
    "hospowho.cf",
    "hospowho.ga",
    "hospowho.ml",
    "host-info.com",
    "host-it.com.sg",
    "host-play.ru",
    "hostballball.com",
    "hostcalls.com",
    "hostclick.website",
    "hostcloudservers.com",
    "hostconflict.online",
    "hostdesign.com",
    "hostedemail.org",
    "hostelam.ru",
    "hostelland.ru",
    "hostguru.info",
    "hostguru.top",
    "hosthansa.com",
    "hostilucve.site",
    "hostingarif.me",
    "hostingballball.com",
    "hostingdomain.blog",
    "hostingersfix.ru",
    "hostingextrem.com",
    "hostingitgreen.com",
    "hostinglinuxperu.com",
    "hostingoptim.com",
    "hostkisx.space",
    "hostlaba.com",
    "hostlabs.ru",
    "hostload.com.br",
    "hostmagento.com",
    "hostman.org",
    "hostmebro.com",
    "hostmijnwebshop.com",
    "hostmonitor.net",
    "hostpapa.photo",
    "hostpapa.pics",
    "hostpapa.reviews",
    "hostpapa.shop",
    "hosts-flx.website",
    "hostsign.com",
    "hosttitan.net",
    "hosur.info",
    "hot-acc.ru",
    "hot-blog2.site",
    "hot-blog3.site",
    "hot-corner-pizza-kebabs.com",
    "hot-de-offers.info",
    "hot-jc.com",
    "hot-mail.cf",
    "hot-mail.ga",
    "hot-mail.gq",
    "hot-mail.ml",
    "hot-mail.tk",
    "hot-shop.com",
    "hot-shot.com",
    "hot.ee",
    "hot.rr.com",
    "hot4ksale.online",
    "hotakama.tk",
    "hotamil.com",
    "hotandcoldwaterworks.com",
    "hotbet.website",
    "hotbet.world",
    "hotbot.com",
    "hotbox.ru",
    "hotbrev.com",
    "hotcakeaudio.com",
    "hotchomisk.icu",
    "hotcoldwaterworks.com",
    "hotcoolmail.com",
    "hotdogsbar.ru",
    "hotel-salyut.ru",
    "hotel-venue.com",
    "hotel411today.xyz",
    "hotel47design.xyz",
    "hotelaster.fr",
    "hotelblanchard.com",
    "hoteldajti.com",
    "hotelduval.org",
    "hotelenaviles.com",
    "hotelfinderz.com",
    "hotelmirandadodouro.com",
    "hotelnextmail.com",
    "hoteloutdoor.com",
    "hotelqq59.xyz",
    "hotelrenaissance-bg.com",
    "hotelsatparis.com",
    "hotelsatudaipur.com",
    "hotelsbest.com",
    "hotelsdot.co",
    "hotelurraoantioquia.com",
    "hotelvozdvizhenskoe.ru",
    "hotenergynews.info",
    "hotenergynews.mobi",
    "hotepmail.com",
    "hoters.org",
    "hotfaka.com",
    "hotfire.net",
    "hotforexnews.biz",
    "hotfoto.org",
    "hotibex.cam",
    "hotizledim.club",
    "hotkornernewport.com",
    "hotletter.com",
    "hotlinemail.com",
    "hotlook.com",
    "hotlunches.ga",
    "hotma.com",
    "hotmai.com",
    "hotmaiils.xyz",
    "hotmail-s.com",
    "hotmail.be",
    "hotmail.ca",
    "hotmail.ch",
    "hotmail.cm",
    "hotmail.co",
    "hotmail.co.il",
    "hotmail.co.in",
    "hotmail.co.jp",
    "hotmail.co.kr",
    "hotmail.co.nz",
    "hotmail.co.th",
    "hotmail.co.uk",
    "hotmail.co.za",
    "hotmail.com",
    "hotmail.com.ar",
    "hotmail.com.au",
    "hotmail.com.br",
    "hotmail.com.friskytaphouse.com",
    "hotmail.com.hitechinfo.com",
    "hotmail.com.hk",
    "hotmail.com.kids316.com",
    "hotmail.com.mx",
    "hotmail.com.plentyapps.com",
    "hotmail.com.standeight.com",
    "hotmail.com.tr",
    "hotmail.com.tw",
    "hotmail.commsn.com",
    "hotmail.con",
    "hotmail.cz",
    "hotmail.de",
    "hotmail.dk",
    "hotmail.es",
    "hotmail.fi",
    "hotmail.fr",
    "hotmail.gr",
    "hotmail.hu",
    "hotmail.info",
    "hotmail.it",
    "hotmail.jp",
    "hotmail.kg",
    "hotmail.kz",
    "hotmail.my",
    "hotmail.nl",
    "hotmail.no",
    "hotmail.ph",
    "hotmail.red",
    "hotmail.ro",
    "hotmail.roor",
    "hotmail.ru",
    "hotmail.se",
    "hotmail.sg",
    "hotmail.work",
    "hotmail4.com",
    "hotmaill.com",
    "hotmailpro.info",
    "hotmailproduct.com",
    "hotmails.com",
    "hotmali.cn",
    "hotmanpariz.com",
    "hotmao.live",
    "hotmcail.com",
    "hotmessage.info",
    "hotmial.com",
    "hotmil.com",
    "hotnewthailand.online",
    "hotofficemaxstoresale.net",
    "hotpcompnet.ml",
    "hotpop.com",
    "hotpop3.com",
    "hotprice.co",
    "hotproduct.icu",
    "hotpush998.com",
    "hotroactive.tk",
    "hotsell.icu",
    "hotselling.online",
    "hotshoptoday.com",
    "hotshotstockalerts.com",
    "hotshotvr.com",
    "hotspotmichigan.com",
    "hotspotwi.com",
    "hotssarrafiipaaarsii.live",
    "hotstorecoupononline.net",
    "hottarrts.com",
    "hottbbbttt.club",
    "hottbett.xyz",
    "hottienikki.com",
    "hottkerio4.xyz",
    "hottosale.com",
    "hotttbettt.xyz",
    "hotun.xyz",
    "hotvoice.com",
    "hotwaterwatch.net",
    "hotwhitecum.com",
    "houjate.cf",
    "houjate.ga",
    "houjate.gq",
    "houjate.ml",
    "houlad.site",
    "houndscatterlurch.site",
    "hour-biz.ru",
    "hourglassinitiative.org",
    "hourlymail.pw",
    "hourmade.com",
    "hous.craigslist.org",
    "housat.com",
    "house-clean.pro",
    "house-farm.site",
    "house-sauna.online",
    "housebeautiful.se",
    "housecentral.info",
    "housedecorationideas.website",
    "housefan.com",
    "housefancom",
    "housefea.xyz",
    "housefeas.xyz",
    "housefordog.ru",
    "household-go.ru",
    "houselfamily.info",
    "housemail.com",
    "housemail.ga",
    "houseofcamelot.us",
    "houseofgreekyogurt.us",
    "houseofqueued.com",
    "houseofwi.com",
    "housesh.press",
    "housetas.email",
    "housetrai.xyz",
    "housewashingmaryland.xyz",
    "housewr.xyz",
    "housewris.icu",
    "houston.marketing",
    "houston.storage",
    "houstonamazinggaragefloors.com",
    "houstoncomputer.net",
    "houstonethnicfoods.com",
    "houstonocdprogram.com",
    "houstonvideoandphoto.com",
    "houyiyy.com",
    "hovcu3.info",
    "hoversullenmabel.site",
    "hovr.link",
    "how-much-is-car-insurance.com",
    "how2dl.xyz",
    "howardcountyshowerglass.com",
    "howbetnow.ru",
    "howbigdata.com",
    "howbird.com",
    "howdididothatagain.com",
    "howdoyoumountain.com",
    "howiknewhewastheone.com",
    "howiknewshewastheone.com",
    "howlpaw.top",
    "howoldis1.club",
    "howp.me",
    "howquery.com",
    "howrppaysclosingcost.com",
    "howt.site",
    "howtall-is.com",
    "howtinzr189muat0ad.cf",
    "howtinzr189muat0ad.ga",
    "howtinzr189muat0ad.gq",
    "howtinzr189muat0ad.ml",
    "howtinzr189muat0ad.tk",
    "howtobt.com",
    "howtobuyfollowers.co",
    "howtocharmlady.ru",
    "howtogodown.com",
    "howtomusicvideo.com",
    "howtoremovestretchmarksafterpregnancy.com",
    "howtoruay.com",
    "howtowoodcrafts.xyz",
    "howzthatworkingforyou.com",
    "hoxderpy.shop",
    "hozi.site",
    "hozuniversal24.ru",
    "hpc-edge.com",
    "hpc.tw",
    "hpiinspectionservices.com",
    "hpkgrimbsytakeaway.com",
    "hpmembership.com",
    "hpnknivesg.com",
    "hprehf28r8dtn1i.cf",
    "hprehf28r8dtn1i.ga",
    "hprehf28r8dtn1i.gq",
    "hprehf28r8dtn1i.ml",
    "hprehf28r8dtn1i.tk",
    "hps-grow-lights.net",
    "hpsyw.info",
    "hptxw.info",
    "hpxn.net",
    "hq22.net",
    "hq565.com",
    "hq569.com",
    "hq676.com",
    "hq7979.com",
    "hqcatbgr356z.ga",
    "hqjzb9shnuk3k0u48.cf",
    "hqjzb9shnuk3k0u48.ga",
    "hqjzb9shnuk3k0u48.gq",
    "hqjzb9shnuk3k0u48.ml",
    "hqjzb9shnuk3k0u48.tk",
    "hqlbdenz.site",
    "hqltui.us",
    "hqmu.net",
    "hqnlpqal.shop",
    "hqnnmq.icu",
    "hqstone.xyz",
    "hqv8grv8dxdkt1b.cf",
    "hqv8grv8dxdkt1b.ga",
    "hqv8grv8dxdkt1b.gq",
    "hqv8grv8dxdkt1b.ml",
    "hqv8grv8dxdkt1b.tk",
    "hqzx6.com",
    "hr3xkssvn8ek1ex.xyz",
    "hr7gsn.site",
    "hraff.org",
    "hrb67.cf",
    "hrb67.ga",
    "hrb67.gq",
    "hrb67.ml",
    "hrb67.tk",
    "hrbfmd.us",
    "hrbsg.ru",
    "hrbuck.site",
    "hrcpw.info",
    "hrexamcenter.com",
    "hrgmgka.cf",
    "hrgmgka.ga",
    "hrgmgka.gq",
    "hrgmgka.ml",
    "hrjxf.com",
    "hrkdw.info",
    "hrl0bn.us",
    "hrlamp.com",
    "hrma4a4hhs5.gq",
    "hrmicrowave.us",
    "hrn3bt.us",
    "hro30.com",
    "hrof.net",
    "hroncolos.ru",
    "hronjoy.ru",
    "hrose.com",
    "hroundb.com",
    "hrpfd.us",
    "hrrdka.us",
    "hrsco.info",
    "hrske8.us",
    "hrsroute.com",
    "hrtgr.cf",
    "hrtgr.ga",
    "hrtgr.gq",
    "hrtgr.ml",
    "hrtgr.tk",
    "hrtgre4.cf",
    "hrtgre4.ga",
    "hrtgre4.gq",
    "hrtgre4.ml",
    "hrtgre4.tk",
    "hrustalnye-shtory.ru",
    "hrvatski.cloud",
    "hrwns.live",
    "hrwrbi.info",
    "hs.vc",
    "hs11.info",
    "hs12.info",
    "hs123.ml",
    "hs13.info",
    "hs130.com",
    "hsa-asle1.ru",
    "hsbc-us-com.xyz",
    "hsbc.coms.hk",
    "hsbr.net",
    "hsc7uc.com",
    "hsdjyaw.ga",
    "hsehfr.us",
    "hskdae.com",
    "hsls5guu0cv.cf",
    "hsls5guu0cv.ga",
    "hsls5guu0cv.gq",
    "hsls5guu0cv.ml",
    "hsls5guu0cv.tk",
    "hsmty.com",
    "hsnsw.info",
    "hsoshow.com",
    "hspcomplete.ru",
    "hsseeds.com",
    "hstermail.com",
    "hstutunsue7dd.ml",
    "hstvq.us",
    "hsuchi.net",
    "hsudhjashku.xyz",
    "hsvn.us",
    "hsweetuni.website",
    "hsykgv.shop",
    "hsyl188.net",
    "ht.cx",
    "ht264.site",
    "ht8wx03.com",
    "htaae8jvikgd3imrphl.ga",
    "htaae8jvikgd3imrphl.gq",
    "htaae8jvikgd3imrphl.ml",
    "htaae8jvikgd3imrphl.tk",
    "htcvive.online",
    "htdig.org",
    "htenparlans.gq",
    "htenparlans.tk",
    "hteysy5yys66.cf",
    "htfmw.info",
    "htglobalhealthcare.xyz",
    "hths.mcvsd.org",
    "htmajv.info",
    "html.tou.com",
    "htngroup.com",
    "htnhw.info",
    "htnsu.com",
    "htp8qq.com",
    "hts4ci.us",
    "htsfv.live",
    "htsghtsd.shop",
    "htstar.tk",
    "httpglobesbestgrill.com",
    "httplove.live",
    "httpsouq-dot.com",
    "httpswigsgoldtouchstore.net",
    "httpswwwjasongaophotography.com",
    "httpta.com",
    "htttbt.online",
    "httttmdtqusqututqp.ru",
    "htwergbrvysqs.cf",
    "htwergbrvysqs.ga",
    "htwergbrvysqs.gq",
    "htwergbrvysqs.ml",
    "htwergbrvysqs.tk",
    "htwern.com",
    "hu2.ru",
    "hu4ht.com",
    "hua-hin.directory",
    "hua85.com",
    "huachichi.info",
    "huahin.directory",
    "huajiachem.cn",
    "huamicme.cf",
    "huamicme.ga",
    "huamicme.tk",
    "huangboyu.com",
    "huanggg.fun",
    "huangniu8.com",
    "huangniu8.online",
    "huangouquan.com",
    "huangpuxueyuan.net",
    "huangyus.cn",
    "huangzefan.xyz",
    "huanhuayulept.com",
    "huaweimaik.ml",
    "huaweimali.cn",
    "huaxiayun.top",
    "huaxintui.biz",
    "hub-pizzeria-takeaway.com",
    "hub-spot.us",
    "hubbu.online",
    "huberheightsapartments.com",
    "hubgrubs.net",
    "hubii-network.com",
    "hubiopharm.ru",
    "hubmail.info",
    "hubopss.com",
    "hubsoftly.com",
    "hubticks.com",
    "hubtixs.com",
    "hubwebsite.tk",
    "huck.ml",
    "huckbrry.com",
    "hucknalltownfc.net",
    "huclberry.com",
    "hudakov.ru",
    "hudatedi.xyz",
    "huddiez.net",
    "huddiez.org",
    "huddmarme.cf",
    "huddmarme.ga",
    "huddmarme.gq",
    "hudra2webs.online",
    "hudraruzxpnew4af.com",
    "hudsonncdentists.com",
    "hudspethinn.com",
    "huecar.com",
    "huerto.online",
    "huetreasure.com",
    "hugah.dev",
    "hugbenefits.ga",
    "hugesale.in",
    "huggybotforum.cf",
    "hughes.net",
    "hugmaew.com",
    "hugmovo.com",
    "hugoandborg.us",
    "hugowhiteleaf.com",
    "hugs-linen.com",
    "huihuangbeiye.com",
    "huikao.online",
    "huiledargane.com",
    "huitrebjjh.space",
    "hukkmu.tk",
    "hukmdy92apdht2f.cf",
    "hukmdy92apdht2f.ga",
    "hukmdy92apdht2f.gq",
    "hukmdy92apdht2f.ml",
    "hukmdy92apdht2f.tk",
    "hulaboola.com",
    "hulafa.info",
    "hulapla.de",
    "hulasen10.xyz",
    "hulasen14.xyz",
    "hulasen16.xyz",
    "hulasen17.xyz",
    "hulasen18.xyz",
    "hulasen29.xyz",
    "hulasen30.xyz",
    "hulasen33.xyz",
    "hulasen35.xyz",
    "hulasen36.xyz",
    "hulasen37.xyz",
    "hulasen41.xyz",
    "hulasen45.xyz",
    "hulasen47.xyz",
    "hulasen48.xyz",
    "hulasen50.xyz",
    "hulasen8.xyz",
    "huleboer.dk",
    "hulewn.com",
    "hulibet80.com",
    "hulksales.com",
    "hulpuitdebuurt.site",
    "hulrtt.us",
    "huluwa.life",
    "huluwa10.life",
    "huluwa12.life",
    "huluwa13.life",
    "huluwa14.life",
    "huluwa21.life",
    "huluwa22.life",
    "huluwa25.life",
    "huluwa26.life",
    "huluwa27.life",
    "huluwa31.life",
    "huluwa34.life",
    "huluwa35.life",
    "huluwa37.life",
    "huluwa38.life",
    "huluwa44.life",
    "huluwa49.life",
    "huluwa5.life",
    "huluwa7.life",
    "huluwa8.life",
    "humaility.com",
    "humanecosmetics.net",
    "humanflashcards.com",
    "humanimpacted.com",
    "humanitycalls.org",
    "humanityenterprise.asia",
    "humanityenterprise.com",
    "humanityenterprise.org",
    "humanityenterprises.asia",
    "humanityenterprises.com",
    "humanlight.org",
    "humanloop.xyz",
    "humanoid.net",
    "humanone.org",
    "humans-souls.ru",
    "humanux.com",
    "humble.digital",
    "humbleciviccenter.net",
    "humgruffin.site",
    "humidorai.com",
    "humidorai.org",
    "humika.com",
    "hummer-h3.ml",
    "hummingbirdhealingoils.com",
    "humn.ws.gy",
    "humoram.xyz",
    "humordaddy.ru",
    "humordecolor.info",
    "humorkne.com",
    "humormoldingmangy.site",
    "humorous-conclusion.com",
    "humour.com",
    "humphfecsa.ga",
    "humphfecsa.gq",
    "humphfecsa.ml",
    "humphfecsa.tk",
    "humsc.org",
    "hunchmilig.cf",
    "hunchmilig.gq",
    "hunchmilig.tk",
    "hunck.live",
    "hundemassage.de",
    "hundredhills.net",
    "hundredkit.com",
    "hundsige.cf",
    "hundsige.gq",
    "hungarbuty.xyz",
    "hungary-choco-late.club",
    "hungaryhotels.info",
    "hungly.xyz",
    "hungpackage.com",
    "hungrybosstakeaway.com",
    "hungrymexicandublin.com",
    "hungwandublin.com",
    "hunks.co.uk",
    "hunnur.com",
    "hunnyberry.com",
    "hunrap.usa.cc",
    "hunredy.site",
    "hunrtiace.club",
    "hunsa.com",
    "huntarapp.com",
    "huntclubindoors.com",
    "huntdistantlamb.website",
    "hunter-games.ru",
    "huntersgreenhotel.com",
    "huntfootandankleclinics.com",
    "huntfootclinics.com",
    "huntforyou.ru",
    "huntpodiatricmedicine.com",
    "huntpx.com",
    "huntsvillerealestateagents.com",
    "huong-dan-blog.com",
    "hup.xyz",
    "hupdns.online",
    "huracan95.ru",
    "hureimbettmutteraufderstrasse.vision",
    "hureimbettmutteraufderstrasse.works",
    "hurify1.com",
    "hurooutlets.site",
    "hurr.ru",
    "hurramm.us",
    "hurricanetooi.com",
    "hurrijian.us",
    "hurriyetseriilanmerkezi.xyz",
    "hurstdevelopment.com",
    "hurt.net",
    "hurtigt.website",
    "hurting.com",
    "huseynovf.ru",
    "hush.ai",
    "hush.com",
    "hushline.com",
    "hushmail.cf",
    "hushmail.com",
    "hushmail.me",
    "husk-mig.dk",
    "huskion.net",
    "husseinight.com",
    "hustler.africa",
    "hustletussle.com",
    "hustq7tbd6v2xov.cf",
    "hustq7tbd6v2xov.ga",
    "hustq7tbd6v2xov.gq",
    "hustq7tbd6v2xov.ml",
    "hustq7tbd6v2xov.tk",
    "hutchings.org",
    "hututoo.com",
    "huuthi.website",
    "huvacliq.com",
    "huweimail.cn",
    "huydgdyehj.xyz",
    "huydjfihbds.xyz",
    "huytdgte.xyz",
    "huyzmod.asia",
    "huyzpro.uk",
    "huyzvip.best",
    "hv112.com",
    "hv1slb.site",
    "hv654.site",
    "hvac5starclub.com",
    "hvastudiesucces.nl",
    "hvb-pay.com",
    "hvba.us",
    "hvc.rr.com",
    "hvndrljdm.shop",
    "hvnphp.com",
    "hvrn.email",
    "hvs4hdtric4s6p3.xyz",
    "hvtechnical.com",
    "hvyji.us",
    "hvzoi.com",
    "hw-sec.com",
    "hw-sec.net",
    "hw01.xyz",
    "hw85ys.us",
    "hwa.best",
    "hwapp9.com",
    "hwbhw.info",
    "hwdiscount.online",
    "hwhabm.us",
    "hwhealthsystem.com",
    "hwiseroa.com",
    "hwjt8.com",
    "hwkp.email",
    "hwkvsvfwddeti.cf",
    "hwkvsvfwddeti.ga",
    "hwkvsvfwddeti.gq",
    "hwkvsvfwddeti.ml",
    "hwkvsvfwddeti.tk",
    "hwmrs.us",
    "hwomg.us",
    "hwpawvgea.shop",
    "hwsdkrj4bviwzya.xyz",
    "hwsnw.info",
    "hwsye.net",
    "hwuifkidy.shop",
    "hwwxry.site",
    "hwxist3vgzky14fw2.cf",
    "hwxist3vgzky14fw2.ga",
    "hwxist3vgzky14fw2.gq",
    "hwxist3vgzky14fw2.ml",
    "hwxist3vgzky14fw2.tk",
    "hwysobin.cf",
    "hwysobin.gq",
    "hwysobin.tk",
    "hx2.us",
    "hx39i08gxvtxt6.cf",
    "hx39i08gxvtxt6.ga",
    "hx39i08gxvtxt6.gq",
    "hx39i08gxvtxt6.ml",
    "hx39i08gxvtxt6.tk",
    "hx9kth.host",
    "hxav1.com",
    "hxav2.com",
    "hxc7gj.us",
    "hxck8inljlr.cf",
    "hxck8inljlr.ga",
    "hxck8inljlr.gq",
    "hxck8inljlr.tk",
    "hxcp990.com",
    "hxd104.com",
    "hxdfa5.info",
    "hxhbnqhlwtbr.ga",
    "hxhbnqhlwtbr.ml",
    "hxhbnqhlwtbr.tk",
    "hxisewksjskwkkww89101929.unaux.com",
    "hxqmail.com",
    "hxrt9w.us",
    "hxsq.bet",
    "hxsq.us",
    "hxuvo2.online",
    "hxvxxo1v8mfbt.cf",
    "hxvxxo1v8mfbt.ga",
    "hxvxxo1v8mfbt.gq",
    "hxvxxo1v8mfbt.ml",
    "hxvxxo1v8mfbt.tk",
    "hxwlw.info",
    "hxxww.info",
    "hy1o87ww.xyz",
    "hy2bc0a279f6esc.xyz",
    "hy888.info",
    "hyab.de",
    "hybride.nu",
    "hybridhazards.info",
    "hybridization963of.online",
    "hycrafting.ru",
    "hydcalo.cf",
    "hydcalo.gq",
    "hydra-hydra.online",
    "hydra-onion-shop.xyz",
    "hydra2.website",
    "hydra2vvab.ru",
    "hydra2w3b.biz",
    "hydra2weed.com",
    "hydramarketsnjmd.com",
    "hydramarketsnjmd.online",
    "hydramarketsnjmd.shop",
    "hydrantsteel.club",
    "hydraruzxpnev4af.xyz",
    "hydraruzxpnew4afxn--nion-k3acom.com",
    "hydrasport.com",
    "hydrasport.xyz",
    "hydraulics360.ru",
    "hydraza.com",
    "hydro-algerie.com",
    "hydrochlorothiazide247.video",
    "hydrogenic.site",
    "hydrolinepro.ru",
    "hydrolinerus.ru",
    "hydrolyzed220bk.online",
    "hydronoodle.xyz",
    "hydrostarghana.com",
    "hydrostore.net",
    "hyds24cs.com",
    "hydsw.info",
    "hyecourtdot.cf",
    "hyecourtdot.ga",
    "hygenicbrushes.org",
    "hygenicbrushes.us",
    "hygge.camp",
    "hyggerus.ru",
    "hygienicbrush.us",
    "hygvxr.us",
    "hygxw.info",
    "hyh07.space",
    "hyhisla.gq",
    "hyhisla.tk",
    "hyhsale.top",
    "hyip-monitor.xyz",
    "hyip.market",
    "hyipiran.ir",
    "hylja.tech",
    "hylwdlapp1.com",
    "hyly.online",
    "hymnologyhg.info",
    "hynlw.info",
    "hypbtt.xyz",
    "hypefreehealth.com",
    "hypeinteractive.org",
    "hypeinteractive.us",
    "hyper-tec.store",
    "hyperactivist.info",
    "hypercomplete.net",
    "hyperile.xyz",
    "hyperland.tools",
    "hypernautica.com",
    "hyperportalvr.org",
    "hyperpost.dk",
    "hyperreactive.best",
    "hypertext.exchange",
    "hypertranscend.org",
    "hyperx-cloud.online",
    "hypha.fund",
    "hypha.group",
    "hyphemail.com",
    "hypnoforsuccess.com",
    "hypnosischangelife.com",
    "hypnotic-storytelling.com",
    "hypnotic-storytelling.net",
    "hypnotizes894yn.online",
    "hypoadvisor.com",
    "hypori.us",
    "hypotekyonline.cz",
    "hypowhal.ml",
    "hypowhal.tk",
    "hypoxiuqch.space",
    "hypoyo.xyz",
    "hyqzvprb.site",
    "hyservers.ru",
    "hyt45763ff.cf",
    "hyt45763ff.ga",
    "hyt45763ff.gq",
    "hyt45763ff.ml",
    "hyt45763ff.tk",
    "hytaleforums.net",
    "hytalemonitoring.ru",
    "hytaleservers.net",
    "hytaleservers.ru",
    "hyticy.site",
    "hytura.cf",
    "hytura.gq",
    "hyuhuv.info",
    "hyundai-promo.site",
    "hyundaiaritmakusadasi.xyz",
    "hyv9nc.us",
    "hyveephoto.com",
    "hyvuokmhrtkucn5.cf",
    "hyvuokmhrtkucn5.ga",
    "hyvuokmhrtkucn5.gq",
    "hyvuokmhrtkucn5.ml",
    "hyxhw.info",
    "hyxnw.info",
    "hyyhh.com",
    "hyze.site",
    "hyzhsx.com",
    "hz-business.net",
    "hz408.site",
    "hz6m.com",
    "hz7rfc.us",
    "hz8816.com",
    "hz8819.com",
    "hzbdfyy.com",
    "hzbtw.info",
    "hzcn.cc",
    "hzdpw.com",
    "hzerm1.site",
    "hzeyeis.com",
    "hzflsz.us",
    "hzjww.info",
    "hzmjfy.com",
    "hznth.com",
    "hzqhjc.com",
    "hzrxw.info",
    "hztnbyy.com",
    "hzx3mqob77fpeibxomc.cf",
    "hzx3mqob77fpeibxomc.ga",
    "hzx3mqob77fpeibxomc.ml",
    "hzx3mqob77fpeibxomc.tk",
    "hzxsy1.com",
    "hzz90.xyz",
    "hzz92.com",
    "hzzcw.info",
    "hzzg4a.best",
    "i-3gk.cf",
    "i-3gk.ga",
    "i-3gk.gq",
    "i-3gk.ml",
    "i-booking.us",
    "i-carpets.ru",
    "i-class.org",
    "i-connect.com",
    "i-ebookaz.com",
    "i-france.com",
    "i-gakamted.ru",
    "i-grest.ru",
    "i-heart.org",
    "i-love-cats.com",
    "i-m-qq.com",
    "i-mail.com.au",
    "i-mail.jp",
    "i-mailbox.net",
    "i-mirpodnogami.ru",
    "i-p.com",
    "i-phone.nut.cc",
    "i-phones.shop",
    "i-plus.net",
    "i-r-p.ru",
    "i-robots.org",
    "i-shop-go.ru",
    "i-sp.cf",
    "i-sp.ga",
    "i-sp.gq",
    "i-sp.ml",
    "i-sp.tk",
    "i-speak-spoke-spoken.com",
    "i-speak-spoke-spoken.info",
    "i-speak-spoke-spoken.net",
    "i-speak-spoke-spoken.org",
    "i-taiwan.tv",
    "i-tell-net2.ru",
    "i-tell-net4.ru",
    "i.am",
    "i.am.to",
    "i.amhey.to",
    "i.bgsaddrmwn.me",
    "i.e-tpc.online",
    "i.istii.ro",
    "i.klipp.su",
    "i.ryanb.com",
    "i.softbank.jp",
    "i.ua",
    "i.wawi.es",
    "i.xcode.ro",
    "i03hoaobufu3nzs.cf",
    "i03hoaobufu3nzs.ga",
    "i03hoaobufu3nzs.gq",
    "i03hoaobufu3nzs.ml",
    "i03hoaobufu3nzs.tk",
    "i04mo.site",
    "i054egtx083f8mb.xyz",
    "i0fkmr.us",
    "i11e5k1h6ch.cf",
    "i11e5k1h6ch.ga",
    "i11e5k1h6ch.gq",
    "i11e5k1h6ch.ml",
    "i11e5k1h6ch.tk",
    "i12.com",
    "i128.xyz",
    "i16my.site",
    "i1775.com",
    "i1blr.us",
    "i1dqp6.us",
    "i1nlem.host",
    "i1uc44vhqhqpgqx.cf",
    "i1uc44vhqhqpgqx.ga",
    "i1uc44vhqhqpgqx.gq",
    "i1uc44vhqhqpgqx.ml",
    "i1uc44vhqhqpgqx.tk",
    "i1xslq9jgp9b.ga",
    "i1xslq9jgp9b.ml",
    "i1xslq9jgp9b.tk",
    "i201zzf8x.com",
    "i2828.com",
    "i29rj.space",
    "i2a9ni.site",
    "i2pmail.org",
    "i35t0a5.com",
    "i3pv1hrpnytow.cf",
    "i3pv1hrpnytow.ga",
    "i3pv1hrpnytow.gq",
    "i3pv1hrpnytow.ml",
    "i3pv1hrpnytow.tk",
    "i3success.online",
    "i47iq.com",
    "i4cfuq.site",
    "i4eoww.com",
    "i4j0j3iz0.com",
    "i4racpzge8.cf",
    "i4racpzge8.ga",
    "i4racpzge8.gq",
    "i4racpzge8.ml",
    "i4racpzge8.tk",
    "i537244.cf",
    "i537244.ga",
    "i537244.ml",
    "i54o8oiqdr.cf",
    "i54o8oiqdr.ga",
    "i54o8oiqdr.gq",
    "i54o8oiqdr.ml",
    "i54o8oiqdr.tk",
    "i55du.com",
    "i5n7p4.site",
    "i5ocfa.online",
    "i5pronay.top",
    "i6.cloudns.cc",
    "i6.cloudns.cx",
    "i66g2i2w.com",
    "i6appears.com",
    "i6t0n.icu",
    "i73lp.com",
    "i75rwe24vcdc.cf",
    "i75rwe24vcdc.ga",
    "i75rwe24vcdc.gq",
    "i75rwe24vcdc.ml",
    "i75rwe24vcdc.tk",
    "i774uhrksolqvthjbr.cf",
    "i774uhrksolqvthjbr.ga",
    "i774uhrksolqvthjbr.gq",
    "i774uhrksolqvthjbr.ml",
    "i774uhrksolqvthjbr.tk",
    "i7e2cf.us",
    "i7fvgq.us",
    "i7nv.com",
    "i82323.com",
    "i85uct.us",
    "i88fj.space",
    "i8e2lnq34xjg.cf",
    "i8e2lnq34xjg.ga",
    "i8e2lnq34xjg.gq",
    "i8e2lnq34xjg.ml",
    "i8e2lnq34xjg.tk",
    "i8jvo.icu",
    "i8tvebwrpgz.cf",
    "i8tvebwrpgz.ga",
    "i8tvebwrpgz.gq",
    "i8tvebwrpgz.ml",
    "i8tvebwrpgz.tk",
    "i8xe.us",
    "i9094.com",
    "i91.info",
    "i95pp.com",
    "i9827.com",
    "i9rkgm.us",
    "i9startup.com",
    "ia04fx.us",
    "ia4stypglismiks.cf",
    "ia4stypglismiks.ga",
    "ia4stypglismiks.gq",
    "ia4stypglismiks.ml",
    "ia4stypglismiks.tk",
    "iaca-aligner.com",
    "iafrica.com",
    "iag1gu.us",
    "iainsinclair.ru",
    "iam4msu.com",
    "iamallama.com",
    "iamamaker.shop",
    "iamaproductmanager.com",
    "iamasterfx.com",
    "iamawoman.com",
    "iamcholo.com",
    "iamcoder.ru",
    "iamconsciouis.com",
    "iamfinallyonline.com",
    "iamguide.ru",
    "iamipl.icu",
    "iamnicolas.com",
    "iampalau.com",
    "iamsasha.info",
    "iamusic.online",
    "iamusic.ru",
    "iamwaiting.com",
    "iamwasted.com",
    "iamyoga.website",
    "iamyours.com",
    "iancasinorat.ru",
    "ianisthe.best",
    "ianqm.live",
    "iansdonatellos.com",
    "ianstapadu.site",
    "ianwookim.org",
    "ianz.pro",
    "iaoss.com",
    "iapermisul.ro",
    "iapneocon2019bengaluru.com",
    "iaptkapkl53.tk",
    "iassafety.com",
    "iastabettingsnupp.xyz",
    "iat6.icu",
    "iatarget.com",
    "iautostabilbetsnup.xyz",
    "ib0ixy.site",
    "ib48.xyz",
    "ib49.xyz",
    "ib50.xyz",
    "ib55.xyz",
    "ib58.xyz",
    "ib5dy8b0tip3dd4qb.cf",
    "ib5dy8b0tip3dd4qb.ga",
    "ib5dy8b0tip3dd4qb.gq",
    "ib5dy8b0tip3dd4qb.ml",
    "ib5dy8b0tip3dd4qb.tk",
    "ib60.xyz",
    "ib62.xyz",
    "ibabni.ml",
    "ibabni.tk",
    "ibadan.site",
    "ibanque.net",
    "ibantool.com",
    "ibaoju.com",
    "ibaxdiqyauevzf9.cf",
    "ibaxdiqyauevzf9.ga",
    "ibaxdiqyauevzf9.gq",
    "ibaxdiqyauevzf9.ml",
    "ibaxdiqyauevzf9.tk",
    "ibazpixrxhjjeae.xyz",
    "ibenat.ga",
    "ibenat.gq",
    "ibenat.ml",
    "ibericadesentupimentos.com",
    "ibericaesgotos.com",
    "ibet01.club",
    "ibetatest.com",
    "ibetkiukiu.com",
    "ibexiran.net",
    "ibitcoini.ru",
    "ibiz-info.ru",
    "ibizapics.info",
    "iblplay.info",
    "ibm.coms.hk",
    "ibm.net",
    "ibmpc.cf",
    "ibmpc.ga",
    "ibmpc.gq",
    "ibmpc.ml",
    "ibnisina.club",
    "ibnuh.bz",
    "ibondeplan.com",
    "ibook.moe",
    "ibqmanufz.shop",
    "ibrahimuzun.xyz",
    "ibrnj.us",
    "ibsats.com",
    "ibstreatmentcenters.com",
    "ibsura.ga",
    "ibsura.tk",
    "ibsvxa.info",
    "ibt7tv8tv7.cf",
    "ibt7tv8tv7.ga",
    "ibt7tv8tv7.gq",
    "ibt7tv8tv7.ml",
    "ibt7tv8tv7.tk",
    "ibuydayton.net",
    "ibuydaytonhomes.com",
    "ibuydaytonproperties.com",
    "ibuydaytonrealestate.com",
    "ibuyjp.org",
    "ibyhrlc08fokf5f.xyz",
    "ibypebbles.com",
    "ic-interiors.com",
    "ic046.site",
    "icaimiao.xyz",
    "icaisen.xyz",
    "icaisui.xyz",
    "icaiying.xyz",
    "icakurien.se",
    "icanfatbike.com",
    "icantab.com",
    "icantbelieveineedtoexplainthisshit.com",
    "icao6.us",
    "icaoviedo.es",
    "icar-air.com",
    "icasinogroup.net",
    "icasinogroup.org",
    "icasinos.ru",
    "icbcc.org",
    "icbls.org",
    "icc-alliance.org",
    "icccd.org",
    "iccima.biz",
    "iccmail.men",
    "icdn.ooo",
    "icdoggud.xyz",
    "ice-rulet.ru",
    "ice444.com",
    "icecapsoftserve.com",
    "icecreamyjt.email",
    "icedmilk.com",
    "icefishingnetwork.com",
    "icegbrow.cf",
    "icegbrow.ga",
    "icegbrow.gq",
    "icegbrow.ml",
    "icegbrow.tk",
    "icehousesupply.com",
    "icemail.club",
    "icemovie.link",
    "icerink.tech",
    "icerion.site",
    "iceseries.com",
    "icestorm.com",
    "icetmail.ga",
    "icetyznetwork.xyz",
    "icfbe.org",
    "icfgwn.site",
    "icfriend.com",
    "icfu.mooo.com",
    "icgrlb.info",
    "icgs.de",
    "ich-bin-verrueckt-nach-dir.de",
    "ich-will-net.de",
    "ichatz.ga",
    "ichbinvollcool.de",
    "ichecksdqd.com",
    "ichehol.ru",
    "ichibata.online",
    "ichichich.faith",
    "ichigo.me",
    "ichimail.com",
    "ichwilldichhaltmalsorichtig.vision",
    "iciarcosmeticos.com",
    "icinki.cf",
    "icinki.ga",
    "icinki.tk",
    "icj3e.us",
    "icjmc.org",
    "ick0h.site",
    "ickx.de",
    "iclim52.ru",
    "icloud.com",
    "icloud.do",
    "icloud.nl",
    "icloudbusiness.net",
    "icloudsendfirefox.online",
    "icmo.org",
    "icmp.best",
    "icmsconsultants.com",
    "icnbet.website",
    "icnopuvdi.shop",
    "icntogel.net",
    "icntoto.net",
    "ico-decenturion.ru",
    "icoachbranding.com",
    "icoconf.ru",
    "icode.best",
    "icodeltd.com",
    "icodepromo.com",
    "icon256.info",
    "icon256.tk",
    "iconda.site",
    "iconflooring.net",
    "iconicgoal.com",
    "iconscoins.ru",
    "iconsultant.me",
    "icontactreviews.com",
    "iconze.com",
    "icopoc.cf",
    "icopoc.ga",
    "icotir.cf",
    "icotir.ga",
    "icotir.ml",
    "icotir.tk",
    "icotoken.bid",
    "icpst.org",
    "icq.com",
    "icqmail.com",
    "icraftx.net",
    "icralti.cf",
    "icralti.ga",
    "icralti.gq",
    "icralti.ml",
    "icralti.tk",
    "icrazy.com",
    "icrrr.org",
    "icslecture.com",
    "ict-4u.com",
    "ict0crp6ocptyrplcr.cf",
    "ict0crp6ocptyrplcr.ga",
    "ict0crp6ocptyrplcr.gq",
    "ict0crp6ocptyrplcr.ml",
    "ict0crp6ocptyrplcr.tk",
    "ictaintict.date",
    "icu.md",
    "icunet.icu",
    "icx.in",
    "icx.ro",
    "icys2011.ru",
    "id-base.com",
    "id-ins.com",
    "id-nn.ru",
    "id-pubgm.shop",
    "id.ru",
    "id10tproof.com",
    "id4sqj.us",
    "id7ak.com",
    "idaccept.com",
    "idaccept.net",
    "idaccept.org",
    "idacsplus.com",
    "idaholands.info",
    "idahowine.tours",
    "idat.buzz",
    "idat.site",
    "iddaairan.website",
    "iddaalabayi.com",
    "iddoescul.ga",
    "idea-mail.com",
    "idea-mail.net",
    "ideadesignlab.net",
    "ideal-art.ru",
    "ideal-gk.ru",
    "idealencounters.com",
    "idealhomeautomation.com",
    "idealizes254vc.online",
    "idealniy.site",
    "idealweightsystemsct.com",
    "ideamarts.net",
    "idearia.org",
    "ideaservers.com",
    "ideati.site",
    "idecyt.org",
    "ideeinrete.info",
    "ideenbuero.de",
    "ideepmind.pw",
    "ideer.msk.ru",
    "ideer.pro",
    "ideiadenegocio.com",
    "iden65.space",
    "idenced.xyz",
    "identifyandclassify.com",
    "identifyandclassify.org",
    "identity-confermation.com",
    "ideondo.xyz",
    "ideozz.xyz",
    "idepoker88.net",
    "idevy.site",
    "idgreat.online",
    "idgreat.ru",
    "idhalfpricedlistings.com",
    "idhie.com",
    "idi-k-mechte.ru",
    "idid11.com",
    "idid36.com",
    "idid42.com",
    "idid55.com",
    "ididitmyway.com",
    "ididv.com",
    "idigjesus.com",
    "idigo.org",
    "idihgabo.cf",
    "idihgabo.gq",
    "idiomm.xyz",
    "idiondo.xyz",
    "idirect.com",
    "idjbet.net",
    "idjplay.site",
    "idkartu.org",
    "idkcoin.com",
    "idktoken.com",
    "idkytoxz.shop",
    "idl99.net",
    "idlefriends.com",
    "idlestormlaze.website",
    "idmail.me",
    "idn.vn",
    "idnaco.ga",
    "idnaco.ml",
    "idnaco.tk",
    "idnbet.net",
    "idnbet118.net",
    "idnkil.cf",
    "idnkil.ga",
    "idnkil.gq",
    "idnkil.ml",
    "idnolive.info",
    "idnolive.net",
    "idnolive.org",
    "idnpoker33.club",
    "idnpoker33.info",
    "idocuments.website",
    "idonea.ru",
    "idotem.cf",
    "idotem.ga",
    "idotem.gq",
    "idotem.ml",
    "idpoker888.com",
    "idpoker888.org",
    "idpro.life",
    "idpzynat.shop",
    "idqzfl.site",
    "idrcapsa.com",
    "idreams.club",
    "idrehabcenters.com",
    "idrifla.com",
    "idrplay.info",
    "idsearth.com",
    "idsee.app",
    "idsee.org",
    "idspin.net",
    "idstc.org",
    "idt8wwaohfiru7.cf",
    "idt8wwaohfiru7.ga",
    "idt8wwaohfiru7.gq",
    "idt8wwaohfiru7.ml",
    "idt8wwaohfiru7.tk",
    "idtv.site",
    "idush.ru",
    "idx4.com",
    "idxfinity.com",
    "idxue.com",
    "idxxi.video",
    "idy1314.com",
    "idyllwild.vacations",
    "idyro.com",
    "ie9myl.us",
    "ieaaql.net",
    "ieasymail.net",
    "ieasystabilitybetsnupp20.xyz",
    "ieatspam.eu",
    "ieatspam.info",
    "iecusa.net",
    "iefbcieuf.cf",
    "iefbcieuf.ml",
    "iefbcieuf.tk",
    "ieh-mail.de",
    "ieit9sgwshbuvq9a.cf",
    "ieit9sgwshbuvq9a.ga",
    "ieit9sgwshbuvq9a.gq",
    "ieit9sgwshbuvq9a.ml",
    "ieit9sgwshbuvq9a.tk",
    "iel.pw",
    "iemm.ru",
    "iencm.com",
    "ienergize.com",
    "iens7a.us",
    "ieo.group",
    "ieorace.com",
    "iersetaal.com",
    "ies76uhwpfly.cf",
    "ies76uhwpfly.ga",
    "ies76uhwpfly.gq",
    "ies76uhwpfly.ml",
    "ies76uhwpfly.tk",
    "iesande.shop",
    "iesco.info",
    "iespana.es",
    "iestabbetting.xyz",
    "iestiest.shop",
    "ietaietr.shop",
    "iethiopian.com",
    "iew88.com",
    "iexh1ybpbly8ky.cf",
    "iexh1ybpbly8ky.ga",
    "iexh1ybpbly8ky.gq",
    "iexh1ybpbly8ky.ml",
    "iexh1ybpbly8ky.tk",
    "if-store.ru",
    "if.money",
    "if.uj.edu.pl",
    "if58.cf",
    "if58.ga",
    "if58.gq",
    "if58.ml",
    "if58.tk",
    "if914.site",
    "ifa2s5.info",
    "ifaiqis.com",
    "ifans-electronics.ru",
    "ifans-headphone.ru",
    "ifans-i9s-tws.ru",
    "ifans-mad.ru",
    "ifansforyou.ru",
    "ifansim.ru",
    "ifastme.com",
    "ifavorsprt.com",
    "ifcelite.com",
    "ifchuck.com",
    "ifd8tclgtg.cf",
    "ifd8tclgtg.ga",
    "ifd8tclgtg.gq",
    "ifd8tclgtg.ml",
    "ifd8tclgtg.tk",
    "ifdvd.com",
    "iffuci.com",
    "iffymedia.com",
    "ificifin.shop",
    "ifightexpress.com",
    "ifinific.shop",
    "ifixticket.com",
    "iflix4kmovie.us",
    "ifneick22qpbft.cf",
    "ifneick22qpbft.ga",
    "ifneick22qpbft.gq",
    "ifneick22qpbft.ml",
    "ifneick22qpbft.tk",
    "ifoam.ru",
    "ifobu.science",
    "ifoodpe19.ml",
    "ifoward.com",
    "ifozgz.us",
    "ifpodef.cf",
    "ifpodef.ga",
    "ifpodef.tk",
    "ifrance.site",
    "ifs-eventum.com",
    "iftzjlhlb.shop",
    "ifunnelhack.com",
    "ifwzhzyr.shop",
    "ifxif.com",
    "ig.com.br",
    "ig.kiwi",
    "ig.support",
    "ig9kxv6omkmxsnw6rd.cf",
    "ig9kxv6omkmxsnw6rd.ga",
    "ig9kxv6omkmxsnw6rd.gq",
    "ig9kxv6omkmxsnw6rd.ml",
    "ig9kxv6omkmxsnw6rd.tk",
    "igame22.com",
    "igbet69.online",
    "igbobook.com",
    "igcl5axr9t7eduxkwm.cf",
    "igcl5axr9t7eduxkwm.gq",
    "igcl5axr9t7eduxkwm.ml",
    "igcl5axr9t7eduxkwm.tk",
    "igcwellness.us",
    "igdirfm.xyz",
    "igdirinkucukmucitleri.com",
    "igdirrezidans.com",
    "ige.es",
    "igeco.ru",
    "igeeksoccer.org",
    "igelonline.de",
    "igendigits.com",
    "igenservices.com",
    "igg.biz",
    "iggqnporwjz9k33o.ga",
    "iggqnporwjz9k33o.ml",
    "ighestpro.com",
    "ighjbhdf890fg.cf",
    "igintang.ga",
    "iginting.cf",
    "igiveu.win",
    "igluanalytics.com",
    "igmoo.org",
    "ignazio.it",
    "ignite5.consulting",
    "igniter.education",
    "igniter200.com",
    "igniteweb.net",
    "igniteyourourney.com",
    "ignmail.com",
    "ignoremail.com",
    "ignutvie.tk",
    "igogog.ru",
    "igogok.ru",
    "igostabbet.xyz",
    "igpicnic.site",
    "igqtrustee.com",
    "igra-na-stavke.site",
    "igrai999.ru",
    "igrat-v-igrovie-avtomati.com",
    "igros.fun",
    "igrovoi-avtomat.ru",
    "igrovoyvulcan.ru",
    "igullo.site",
    "igvaku.cf",
    "igvaku.ga",
    "igvaku.gq",
    "igvaku.ml",
    "igvaku.tk",
    "igvault.club",
    "igxppre7xeqgp3.cf",
    "igxppre7xeqgp3.ga",
    "igxppre7xeqgp3.gq",
    "igxppre7xeqgp3.ml",
    "igxppre7xeqgp3.tk",
    "ih0hl1.us",
    "ih2vvamet4sqoph.cf",
    "ih2vvamet4sqoph.ga",
    "ih2vvamet4sqoph.gq",
    "ih2vvamet4sqoph.ml",
    "ih2vvamet4sqoph.tk",
    "ihae.ru",
    "ihalematik.net",
    "ihankbaby.com",
    "ihateclowns.com",
    "ihateyoualot.info",
    "ihaveapersonalproblem.com",
    "ihavedildo.tk",
    "ihawk360.com",
    "ihaxyour.info",
    "ihazspam.ca",
    "ihbkvw.us",
    "ihckz1.site",
    "ihdbt.com",
    "iheartspam.org",
    "ihelpubet.com",
    "ihhjomblo.online",
    "ihi.today",
    "ihiministries.info",
    "ihlopbrfm.shop",
    "ihm6rq.com",
    "ihonregre.online",
    "ihowto.site",
    "ihquex.com",
    "ihtkr1.site",
    "ihwy.com",
    "ihwyum.icu",
    "ii062.com",
    "ii57822.com",
    "iibat.site",
    "iifinder.com",
    "iigmail.com",
    "iigo.de",
    "iigtzic3kesgq8c8.cf",
    "iigtzic3kesgq8c8.ga",
    "iigtzic3kesgq8c8.gq",
    "iigtzic3kesgq8c8.ml",
    "iigtzic3kesgq8c8.tk",
    "iii062.com",
    "iii813.com",
    "iiifans.ru",
    "iiko-rf.ru",
    "iikr.net",
    "iillii.org",
    "iillusionist.com",
    "iimagesquotes.icu",
    "iimepn.com",
    "iimlmanfest.com",
    "iindoxx1.info",
    "iinet.net.au",
    "iinlp.com",
    "iipl.de",
    "iiron.us",
    "iis.buzz",
    "iitdmefoq9z6vswzzua.cf",
    "iitdmefoq9z6vswzzua.ga",
    "iitdmefoq9z6vswzzua.gq",
    "iitdmefoq9z6vswzzua.ml",
    "iitdmefoq9z6vswzzua.tk",
    "iiv55.com",
    "iivro.com",
    "iivs8l.com",
    "ij1iat.us",
    "ij3j.com",
    "ij3zvea4ctirtmr2.cf",
    "ij3zvea4ctirtmr2.ga",
    "ij3zvea4ctirtmr2.gq",
    "ij3zvea4ctirtmr2.ml",
    "ij3zvea4ctirtmr2.tk",
    "ijgk9e.us",
    "ijgur.com",
    "ijustdontcare.com",
    "ik7gzqu2gved2g5wr.cf",
    "ik7gzqu2gved2g5wr.ga",
    "ik7gzqu2gved2g5wr.gq",
    "ik7gzqu2gved2g5wr.ml",
    "ik7gzqu2gved2g5wr.tk",
    "ik7i6iai1z8u7ok.xyz",
    "ika4l.site",
    "ikandewa.club",
    "ikapia.com",
    "ikaren-suma.ru",
    "ikaza.info",
    "ikbenspamvrij.nl",
    "ikbrip.tokyo",
    "ike3a.com",
    "ikebal.com",
    "ikelsik.cf",
    "ikelsik.ga",
    "ikelsik.gq",
    "ikelsik.ml",
    "ikgfrr.site",
    "iki.kr",
    "ikimaru.com",
    "ikimuslimngaji.com",
    "ikke.win",
    "ikkjacket.com",
    "ikkookvoormijnhond.com",
    "iklankeren.pw",
    "iklf0.info",
    "ikmov.com",
    "ikoplak.cf",
    "ikoplak.ga",
    "ikoplak.gq",
    "ikoplak.ml",
    "ikproekt-nn.ru",
    "ikra-ufa.ru",
    "ikrinka-msk.ru",
    "iktxn.com",
    "iku.us",
    "ikursovik.ru",
    "ikuvdvkp.shop",
    "ikuzus.cf",
    "ikuzus.ga",
    "ikuzus.gq",
    "ikuzus.ml",
    "ikuzus.tk",
    "ikvy.email",
    "ila.ong",
    "ilandingvw.com",
    "ilank6.xyz",
    "ilank7.xyz",
    "ilank8.xyz",
    "ilario.me",
    "ilashed.com",
    "ilazero.com",
    "ilbe2.cf",
    "ilbien-paul.com",
    "ilboard.r-e.kr",
    "ilbombardone.com",
    "ilcapriccio-erding.de",
    "ilcommunication.com",
    "ilderthers.tk",
    "ildivo-restaurant.com",
    "ildz.com",
    "ilebaz.ga",
    "ilebaz.tk",
    "iledyxuu.shop",
    "ilele.site",
    "ilh0c2.us",
    "ilhalfpricelisting.com",
    "ilhamhomedecorations.com",
    "ilhandemirok.com",
    "ilico.info",
    "iligansocial.info",
    "ilikespam.com",
    "iliterallywrotethebook.com",
    "iliterallywrotethebookonit.com",
    "iliterallywrotethebookonitseries.com",
    "ilivemusic.ru",
    "iljkd.xyz",
    "iljmmz.us",
    "ilkecza.site",
    "ilkecza.website",
    "ilkeczahub.club",
    "ilkposta.com",
    "illegalize262mp.online",
    "illinoisfamilylawyers.xyz",
    "illioni.shop",
    "illistnoise.com",
    "illumbolighus.com",
    "illuminatist.best",
    "ilmadia.site",
    "ilmale.it",
    "ilmuanmuda.com",
    "ilnostrogrossograssomatrimoniomolisano.com",
    "ilove-apnastyle.com",
    "ilove-vegout.com",
    "ilove39.ru",
    "ilovechocolate.com",
    "ilovefood-dublin.com",
    "ilovegiraffes.net",
    "ilovejesus.com",
    "ilovelionking.com",
    "ilovemyniggers.club",
    "ilovemywaterbed.com",
    "ilovepeachcobbler.com",
    "ilovepokemonmail.com",
    "ilovespam.com",
    "ilovethemovies.com",
    "ilovetocollect.net",
    "iloveu.dk",
    "ilpersonalepa.org",
    "ilqlaq.download",
    "ilrem.com",
    "ilsalento.info",
    "ilschool-wiesbaden.com",
    "ilse.nl",
    "ilsongzung.com",
    "ilt.ctu.edu.gr",
    "ilthomar.cf",
    "ilthomar.gq",
    "ilthomar.tk",
    "ilucki.net",
    "ilusila.com",
    "ilvain.com",
    "ilvplay.com",
    "ilxm21.info",
    "ilyasozkurt.online",
    "ilyseiris.xyz",
    "ilzida-ismagilovna.ru",
    "im-irsyad.tech",
    "im148.site",
    "imacpro.ml",
    "image0226.online",
    "image24.de",
    "image360windowfilm.com",
    "imagebed.com",
    "imageboard4free.com",
    "imagedew.com",
    "imagehouse.online",
    "imagictech.com",
    "imaginegiants.com",
    "imagineinvestments.com",
    "imaginemail.com",
    "imaginethelearning.com",
    "imagiscape.pictures",
    "imagiscape.us",
    "imail.com",
    "imail.org",
    "imail.ru",
    "imail1.net",
    "imail5.net",
    "imail8.net",
    "imailbox.com",
    "imailcloud.net",
    "imaild.com",
    "imaillink.com",
    "imailpro.net",
    "imails.info",
    "imailt.com",
    "imailto.net",
    "imailweb.top",
    "imailzone.ml",
    "imakeitrain.com",
    "imamail1928.cf",
    "imankul.com",
    "imanual.site",
    "imap-mail.com",
    "imap.cc",
    "imapmail.org",
    "imasoft.com",
    "imatrixglassdoor-reviews.com",
    "imatrixglassdoor-reviews.net",
    "imatrixglassdoor-reviews.org",
    "imatrixglassdoor.info",
    "imatrixglassdoor.org",
    "imatrixglassdoorreviews.com",
    "imatrixglassdoorreviews.info",
    "imatrixglassdoorreviews.org",
    "imavex.ru",
    "imaxinterior.com",
    "imbc.xyz",
    "imbizu.com",
    "imboondelivery.com",
    "imbricate.xyz",
    "imbuyba.cf",
    "imbuyba.ga",
    "imbuyba.gq",
    "imbuyba.ml",
    "imbuyba.tk",
    "imcyork.net",
    "imd044u68tcc4.cf",
    "imd044u68tcc4.ga",
    "imd044u68tcc4.gq",
    "imd044u68tcc4.ml",
    "imd044u68tcc4.tk",
    "imdo.ru",
    "imecjunior.org",
    "imeil.tk",
    "imel.org",
    "imerchantinternational.com",
    "imeretinskiyhotel.ru",
    "imetocl.shop",
    "imexcointernational.com",
    "imfilons.ru",
    "imfriendly.org",
    "imfsiteamenities.com",
    "imgcdn.us",
    "imgjar.com",
    "imgof.com",
    "imgrpost.xyz",
    "imgv.de",
    "imh.life",
    "imhtcut.xyz",
    "imhungry.xyz",
    "iminform.ru",
    "iminimalm.com",
    "imismarketplace.info",
    "imismarketplace.net",
    "imitationchicken.com",
    "imitationmilk.com",
    "imjetpack.xyz",
    "imknurbel.cf",
    "imknurbel.ga",
    "imknurbel.tk",
    "imlearners.net",
    "imlivecgo.site",
    "imlpipchat.com",
    "immacrealty.org",
    "immaculateused.com",
    "immaginando.info",
    "immatetmnn.space",
    "immense.org",
    "immensematurity.club",
    "immenso-studios.com",
    "immigratic.icu",
    "imminni.cf",
    "imminni.gq",
    "imminni.tk",
    "immo-gerance.info",
    "immobilizes279ls.online",
    "immortalcraft.ru",
    "immortalizes459px.online",
    "immortalizes61hr.online",
    "immutable.chat",
    "imnarbi.cf",
    "imnarbi.gq",
    "imnarbi.tk",
    "imneverwrong.com",
    "imobiliare.blog",
    "imontalika.icu",
    "imoutel.cf",
    "imoutel.gq",
    "imouto-h.xyz",
    "imouto.pro",
    "imovie.link",
    "imozmail.com",
    "impactcommunications.us",
    "impactsib.ru",
    "impactspeaks.com",
    "impactstat.com",
    "impactwriter.com",
    "impairmentevaluator.com",
    "impastore.co",
    "imperfectron.com",
    "imperia-school.ru",
    "imperia-vega.ru",
    "imperialcity.co.uk",
    "imperialdynastytakeaway.com",
    "imperialwesternbeercompany.com",
    "imperiumoffice.com",
    "imperiya1.ru",
    "impetus-limitless.net",
    "implantway.ru",
    "implausibility.info",
    "imponfigh.cf",
    "imponfigh.gq",
    "imponfigh.tk",
    "importfirst.ru",
    "impos.melbourne",
    "impos.mobi",
    "imposition.online",
    "imposter.co.uk",
    "imposter52.website",
    "impostore.co",
    "impotscoursparticuliers.com",
    "impotsgouv.pro",
    "impotsgouvfr.pro",
    "impotsgouvliens.com",
    "impregn.best",
    "impregnator.com",
    "impressedhub.com",
    "impressiveelectricalandsolar.com",
    "impressivepennystocks.com",
    "imprimart-dz.com",
    "imprisonedwithisis.com",
    "imprisonedwithisis.org",
    "imprisonedwithisisbook.org",
    "improvedtt.com",
    "improvementshop.futbol",
    "improveweb.store",
    "improvolympic.com",
    "impulse2019.com",
    "impulse2019.online",
    "impulse2019.ru",
    "imrekoglukoleksiyon.online",
    "imrekoglukoleksiyon.xyz",
    "imrekoglutesbih.online",
    "imrekoglutesbih.xyz",
    "imrew.com",
    "ims-institute-turkey.org",
    "ims-turkey.org",
    "ims-turkiye.com",
    "imsbet.net",
    "imsend.ru",
    "imsoboring.com",
    "imsoeasy.com",
    "imstations.com",
    "imstressed.com",
    "imtek.uni-freiburg.de",
    "imtolkvx.shop",
    "imtoosexy.com",
    "imtoz.ru",
    "imtravin.tk",
    "imul.info",
    "imunlocked.com",
    "imunofan.online",
    "imvalg.us",
    "imw88.com",
    "imy69.space",
    "imysa.org",
    "in-a-multiplesclerosistreatmentsok.live",
    "in-a-tu-new-carok.live",
    "in-box.net",
    "in-dating.org",
    "in-iraq.com",
    "in-ntech.com",
    "in-poker.net",
    "in-poker.org",
    "in-spinalmuscularatrophies-ok.live",
    "in-the-band.net",
    "in-tu-new-car-ok.live",
    "in-tu-new-cars-ok.live",
    "in.com",
    "in.mailsac.com",
    "in2jesus.com",
    "in5minutes.net",
    "in888b.org",
    "in888b.site",
    "inaby.com",
    "inacup.cf",
    "inacup.ga",
    "inacup.gq",
    "inacup.tk",
    "inalgeria.net",
    "iname.com",
    "inandout-christchurch.com",
    "inaodongphuc.org",
    "inapplicable.org",
    "inappmail.com",
    "inaptcertainmarry.site",
    "inarbicloud.ru",
    "inarbicrm.ru",
    "inarbisoft.ru",
    "inasoc.gq",
    "inasoc.tk",
    "inasvab.cf",
    "inasvab.ga",
    "inasvab.tk",
    "inbaca.com",
    "inbax.ga",
    "inbax.ml",
    "inbax.tk",
    "inbet.online",
    "inbet.pro",
    "inbet24.net",
    "inbet24.pro",
    "inbet4.com",
    "inbetz.cafe",
    "inboedelverzekeringkiezen.online",
    "inbound.dk",
    "inbound.plus",
    "inbov03.com",
    "inbox-me.top",
    "inbox-my-articles.com",
    "inbox.com",
    "inbox.comx.cf",
    "inbox.loseyourip.com",
    "inbox.lt",
    "inbox.lv",
    "inbox.net",
    "inbox.ru",
    "inbox.si",
    "inbox2.info",
    "inbox888.com",
    "inboxalias.com",
    "inboxbear.com",
    "inboxclean.com",
    "inboxclean.org",
    "inboxdesign.me",
    "inboxed.im",
    "inboxed.pw",
    "inboxhub.net",
    "inboxkitten.com",
    "inboxmail.world",
    "inboxproxy.com",
    "inboxstore.me",
    "inbrisbane.org",
    "incaltaminteoriginala.info",
    "incaltamintesport.info",
    "incamail.com",
    "incandescent.nyc",
    "incapacitacion.info",
    "incapcont.cf",
    "incasecontact.com",
    "incastavto.ru",
    "incentibuy.net",
    "incestry.co.uk",
    "includingarabia.com",
    "inclusionchecklist.com",
    "inclusioncheckup.com",
    "inclusiveprogress.com",
    "incognitomail.com",
    "incognitomail.net",
    "incognitomail.org",
    "incolnsbolton.com",
    "incomecountry.com",
    "incomego.ru",
    "incomei.shop",
    "incomservice.com",
    "inconsopka.icu",
    "incowy.cf",
    "incowy.gq",
    "incowy.ml",
    "incowy.tk",
    "incq.com",
    "increase5f.com",
    "increaseed.top",
    "increater.ru",
    "incredibleproduct.ru",
    "incrediemail.com",
    "incredimail.com",
    "incubatank.asia",
    "incubator-hostel.com",
    "incubatorhostel.com",
    "ind.st",
    "indal23.com",
    "indamail.hu",
    "indbakke.dk",
    "indcomm.net",
    "indebted.uk",
    "indeecsam.ru",
    "indeedasessment.com",
    "indeedasessments.com",
    "indeedassesment.com",
    "indeedemail.com",
    "indeedlebeans.com",
    "indeedtime.us",
    "independentclaims.info",
    "independentimmigration.ru",
    "independentsucks.twilightparadox.com",
    "independentvpn.com",
    "indepthicefishing.com",
    "index-x.net",
    "index.ua",
    "indexa.fr",
    "indexbuffalomaths.site",
    "indexzero.dev",
    "india.com",
    "india2in.com",
    "indiadiabetesresearch.com",
    "indiagatenutgrove.com",
    "indiagatetakeaway.com",
    "indiamoney.club",
    "indian-moon-takeaway.com",
    "indianaibm.com",
    "indianapolishairsalons.com",
    "indianapolismortgagerates.website",
    "indianapolisnailsalons.com",
    "indianarchitect.com",
    "indiancurrymonasterevin.com",
    "indianecommerce.com",
    "indianengineer.com",
    "indianoceantakeawayclonmel.com",
    "indianrestauranttakeaway.com",
    "indiansignature.com",
    "indianxxxbabes.mobi",
    "indianxxxbhabhi.mobi",
    "indiatimes.com",
    "indiaunrestmauve.site",
    "indicting.com",
    "indidn.xyz",
    "indieartists.org",
    "indieclad.com",
    "indigo-makiyaz.ru",
    "indir.pet",
    "indir.red",
    "indiratakeaway.com",
    "indirect.ws",
    "indirim-haberi.club",
    "indirim-haberi.live",
    "indirim-haberi.site",
    "indirimfirsatlar.xyz",
    "indirimhaberi.club",
    "indirimsepetin.xyz",
    "indisgi.gq",
    "indiszu.ga",
    "indiszu.ml",
    "individualbased.com",
    "individuative.best",
    "indo-mail.com",
    "indo228.ninja",
    "indo32.net",
    "indo365.biz",
    "indo365.ninja",
    "indo7poker.info",
    "indobetklik.club",
    "indobetklik.xyz",
    "indobetting.net",
    "indobola.us",
    "indobola.win",
    "indobola118.com",
    "indobola118.info",
    "indobola228.net",
    "indobookies99.com",
    "indocarib.com",
    "indochinadestination.com",
    "indochinadream.com",
    "indocities.com",
    "indofilm.store",
    "indoforum.biz",
    "indogame.site",
    "indokitchen-rush.com",
    "indokomshop.com",
    "indoliga7.org",
    "indoliqueur.com",
    "indomacau88.com",
    "indomaed.pw",
    "indomail.com",
    "indomina.cf",
    "indomovie21.me",
    "indonesianherbalmedicine.com",
    "indopaito.com",
    "indoplay303.com",
    "indopvp.info",
    "indosat.net.id",
    "indosearch.shop",
    "indoserver.stream",
    "indosukses.press",
    "indotagram.com",
    "indototo.club",
    "indototo.space",
    "indotrader.net",
    "indowps.com",
    "indoxxitv.org",
    "indrawcrxa.space",
    "indumento.club",
    "indus.ru",
    "indus.tech",
    "industrialbrush.us",
    "industrialbrushmanufacturer.us",
    "industrialelectronica.com",
    "industrialhome.club",
    "industrialshapeandform.com",
    "industryix0.com",
    "industryleaks.com",
    "industyle.com",
    "indx-it-ggl-2.site",
    "indx-it-ggl-3.site",
    "indyracers.com",
    "ineec.net",
    "inegollu.xyz",
    "inegolmodef.xyz",
    "inelav.gq",
    "inelav.ml",
    "inend.xyz",
    "inerted.com",
    "inertiafm.ru",
    "inet.com",
    "inet.net.au",
    "inetworkcards.com",
    "inewx.com",
    "inf39.ru",
    "infalled.com",
    "infamisslife.com",
    "infaqu.com",
    "inferno.cd",
    "infession.xyz",
    "infest.org",
    "inficti.ga",
    "inficti.ml",
    "inficti.tk",
    "infideles.nu",
    "infile.dk",
    "infiltraitor.com",
    "infinitearcher.com",
    "infiniteleaks.xyz",
    "infinitevistaspress.org",
    "infiniti-africa.club",
    "infinitiypoker.com",
    "infinitomail.com",
    "infinitum.icu",
    "infinityangelhealingpathways.com",
    "infinitybooksjapan.org",
    "infinityclippingpath.com",
    "infitter.ru",
    "inflammationpills.info",
    "inflatableslife.com",
    "inflatob.ga",
    "inflatob.gq",
    "inflatob.ml",
    "inflavma.cf",
    "inflavma.gq",
    "inflavma.ml",
    "inflavma.tk",
    "inflight.media",
    "infloo.biz",
    "infloo.global",
    "infloo.info",
    "influ.network",
    "influencersconf.com",
    "influenceya.com",
    "influencialladies.com",
    "influenciapositiva.org",
    "influenza.video",
    "info-24tv.site",
    "info-action-sale.space",
    "info-b1ogs.fun",
    "info-b1ogs.space",
    "info-bl0gs.fun",
    "info-blogs.fun",
    "info-blogs.space",
    "info-easy-med.ru",
    "info-fast-group.ru",
    "info-klub.ru",
    "info-media.de",
    "info-radio.ml",
    "info-tamtam.xyz",
    "info-vendor-buy.ru",
    "info.al",
    "info.com",
    "info.dk",
    "info.tm",
    "info6.ru",
    "info66.com",
    "infoaa316.xyz",
    "infoaa317.xyz",
    "infoaa318.xyz",
    "infoaccount-team.news",
    "infoads.pro",
    "infoalgers.info",
    "infoapex.com",
    "infob10gs.fun",
    "infob10gs.space",
    "infob1ogs.space",
    "infobiz9.ru",
    "infobl0gs.space",
    "infoblogs.space",
    "infobolamania.com",
    "infobsae.com",
    "infobumer.ru",
    "infochange.icu",
    "infoclew.com",
    "infocom.zp.ua",
    "infocoronavirus.net",
    "infodatas.online",
    "infodaunemas.online",
    "infoembaixada.com",
    "infoembassy.com",
    "infoentertogel.com",
    "infofinacancas.com",
    "infogerbangemas.xyz",
    "infografiek.com",
    "infografisdikbudbkt.tech",
    "infohq.com",
    "infoislamweb.com",
    "infokehilangan.com",
    "infolaju.com",
    "infomail.club",
    "infomail.es",
    "infomal.ru",
    "infomarketer.ru",
    "infomart.or.jp",
    "infomedia.ga",
    "infomedic.icu",
    "infomotocyclefairings.com",
    "infomum.xyz",
    "infoneatwork.xyz",
    "infonegocios.mobi",
    "infonewmobupdate.com",
    "infonewusermob.xyz",
    "infopaas.com",
    "infoportalchik.ru",
    "infoprediksi4d.com",
    "infoprice.tech",
    "infoqq24jam.xyz",
    "inform-mart-deal.ru",
    "inform-new-like.ru",
    "inform-store-active.ru",
    "inform-union-undersell.ru",
    "inform6-ru.xyz",
    "informacion-residencias.com",
    "informacion-residencias.info",
    "informaldatingsites.com",
    "informasikuyuk.com",
    "informaticos.com",
    "information-account.net",
    "informatus.org",
    "informecomomanejo.com",
    "informed.online",
    "informeeldaten.online",
    "informeeldaten.space",
    "informeledating.online",
    "informeledatingsites.online",
    "informeledatingsites.space",
    "informoteur.com",
    "inforuinfo.ru",
    "infoseek.jp",
    "infospacemail.com",
    "infostructor.net",
    "infosubs.cf",
    "infosubs.gq",
    "infosubs.ml",
    "infosubs.tk",
    "infosuppository.com",
    "infotriage.com",
    "infovia.com.ar",
    "infowaka.site",
    "infowars.tel",
    "infowellsauthmob.com",
    "infowellsnewmob.com",
    "infowordpress.info",
    "infoworldcenter.info",
    "infralium.xyz",
    "infrastructuredevelopglobal.website",
    "infrazoom.com",
    "inftail.com",
    "ingabhagwandin.xyz",
    "ingday.com",
    "ingenieriasinfronteras.com",
    "ingersollfootclinic.com",
    "inggo.org",
    "ingles90dias.space",
    "ingradmap.ru",
    "ingreso-no-voluntario.com",
    "ingridyrodrigo.com",
    "ingrok.win",
    "ingrup.site",
    "ingrup.xyz",
    "ingyour.shop",
    "inhalfpricedlisting.com",
    "inhalfpricelisting.com",
    "inhello.com",
    "inhen.live",
    "inhomeideas.com",
    "inibuatkhoirul.cf",
    "inibuatsgb.cf",
    "inibuatsgb.ga",
    "inibuatsgb.gq",
    "inibuatsgb.ml",
    "inibuatsgb.tk",
    "inicia.es",
    "inidewa.org",
    "iniheat.cf",
    "iniheat.ga",
    "iniheat.tk",
    "inikita.online",
    "inillab.cf",
    "inillab.gq",
    "inillab.ml",
    "ininghai.com",
    "inipunyakitasemua.cf",
    "inipunyakitasemua.ga",
    "inipunyakitasemua.gq",
    "inipunyakitasemua.ml",
    "inipunyakitasemua.tk",
    "inisin.gq",
    "inisin.tk",
    "injecties.info",
    "injhcohjq.shop",
    "inji4voqbbmr.cf",
    "inji4voqbbmr.ga",
    "inji4voqbbmr.gq",
    "inji4voqbbmr.ml",
    "inji4voqbbmr.tk",
    "injuredbabydefense.com",
    "injuryattorneyct.net",
    "injuryhelpnewyork.net",
    "injurylawyersfortworth.com",
    "inkbete90.net",
    "inkbete90.org",
    "inkgraphicspublicidad.com",
    "inkmapper.com",
    "inknowation.org",
    "inkomail.com",
    "inkonre.cf",
    "inkonre.gq",
    "inkonre.ml",
    "inkonre.tk",
    "inlacourt.cf",
    "inlacourt.ga",
    "inlacourt.gq",
    "inlacourt.ml",
    "inlandharmonychorus.org",
    "inlaunceston.org",
    "inlek.icu",
    "inlepe.ga",
    "inlepe.gq",
    "inlepe.ml",
    "inlepe.tk",
    "inletentreatmaven.site",
    "inlhw.us",
    "inliafa.cf",
    "inlightwellness.org",
    "inmail.cz",
    "inmail.site",
    "inmail.sk",
    "inmail.xyz",
    "inmail24.com",
    "inmail3.com",
    "inmano.com",
    "inmebi.ga",
    "inmebi.tk",
    "inmisli.cf",
    "inmisli.ga",
    "inmisli.gq",
    "inmisli.ml",
    "inmisli.tk",
    "inmobis.ru",
    "inmoldtech.ru",
    "inmonorsk.com",
    "inmugood.ga",
    "inmugood.ml",
    "inmynetwork.cf",
    "inmynetwork.ga",
    "inmynetwork.gq",
    "inmynetwork.ml",
    "inmynetwork.tk",
    "innatepractice.net",
    "innatesoft.com",
    "innatesoft.net",
    "inndalens.info",
    "innercharmyogaretreats.com",
    "innercirclemasterminds.com",
    "innersystem.com",
    "inno.bet",
    "inno.tel",
    "innobet.online",
    "innocent.com",
    "innorack.net",
    "innovap.ru",
    "innovateccc.org",
    "innovationbay.info",
    "innovationira.com",
    "innovativebacksolutions.com",
    "innove.solutions",
    "innoventonline.com",
    "innstakit.site",
    "innsystems.net",
    "inoctei.cf",
    "inoctei.tk",
    "inoculukdb.site",
    "inoflis.cf",
    "inoflis.gq",
    "inoflis.ml",
    "inoflis.tk",
    "inonesearch.com",
    "inorbit.com",
    "inosat-turkey.com",
    "inosatglobal.com",
    "inoton-shop.ru",
    "inoue3.com",
    "inousdi.cf",
    "inousdi.gq",
    "inousdi.ml",
    "inoutbox.com",
    "inoutfiga.xyz",
    "inoutmail.de",
    "inoutmail.eu",
    "inoutmail.info",
    "inoutmail.net",
    "inower.cf",
    "inower.ml",
    "inower.tk",
    "inowex.cf",
    "inowex.gq",
    "inpdfmanuales.xyz",
    "inpirar.com",
    "inplay.online",
    "inplay.red",
    "inplay888.org",
    "inpoker3.net",
    "inpoker3.org",
    "inpos.ru",
    "inpowiki.xyz",
    "inprisonwithisis.com",
    "inprisonwithisis.net",
    "inprisonwithisis.org",
    "inprisonwithisisbook.org",
    "inpursuitofyourcure.org",
    "inqmuseum.org",
    "inr681.us",
    "inrak.site",
    "inretail.ru",
    "inrim.cf",
    "inrim.ga",
    "inrim.gq",
    "inrim.ml",
    "inrim.tk",
    "ins.ooo",
    "insaneservers.com",
    "insanumingeniumhomebrew.com",
    "inscriptio.in",
    "insellage.de",
    "insertwhat.space",
    "insgit.com",
    "inshapeactive.ru",
    "insidebaltimore.net",
    "insidebizness.ru",
    "insidecondoclub.com",
    "insidejobboard.org",
    "insidepcgames.com",
    "insiderbundles.com",
    "insiemeperilpane.it",
    "insight.rr.com",
    "insightbb.com",
    "insigno.com",
    "insipe.store",
    "insipitnal.ru",
    "insitedesignlab.com",
    "insmathi.ml",
    "insmathi.tk",
    "insorg-mail.info",
    "inspace-media.ru",
    "inspectorjavert.com",
    "inspira.space",
    "inspiraretirement.com",
    "inspiraseniorliving.com",
    "inspiredking.com",
    "inspiremelabs.agency",
    "inspirepulse.com",
    "inspiringfreedom.health",
    "insta-ground.ru",
    "insta-local-datings5.com",
    "insta.monster",
    "instabackdrop.com",
    "instabf.ru",
    "instaboothsnj.com",
    "instacrush.online",
    "instaflowers.shop",
    "instaforex-info.ru",
    "instafuel.space",
    "instafun.men",
    "instagopedia.com",
    "inst\xe1gram.com",
    "instagramfood.com",
    "instagrammableproperties.com",
    "instagrampoker.info",
    "instagrampoker.org",
    "instaindofree.com",
    "instaku-media.com",
    "instalacioneswifigj.tk",
    "instalked.xyz",
    "installing.page",
    "instamaniya.ru",
    "instamed.live",
    "instamotornepal.com",
    "instance-email.com",
    "instant-mail.de",
    "instantblingmail.info",
    "instantbummer.com",
    "instantcriminalrecordsearch.com",
    "instantdirectionsfinder.com",
    "instantemailaddress.com",
    "instantlyemail.com",
    "instantmail.de",
    "instantmail.fr",
    "instantmailaddress.com",
    "instantnewsnow.icu",
    "instantwebsites.online",
    "instaopros.xyz",
    "instapay.one",
    "instapay.store",
    "instapixel.com",
    "instaprice.co",
    "instatienda.com",
    "instator.ru",
    "instatransact.org",
    "instatrendz.xyz",
    "instaview.org",
    "insti.shop",
    "instinctive.marketing",
    "instituteforadvancedlearning.club",
    "institutionalizing492be.online",
    "instmyapp.ru",
    "instpic.club",
    "instruction.com",
    "instructor.net",
    "instrutex.ru",
    "insulium.com",
    "insulize.xyz",
    "insumixturkiye.xyz",
    "insuranceair.com",
    "insurancealign.com",
    "insurancecoverageguaranteed.com",
    "insuranceone.xyz",
    "insuranceonlinequotes.info",
    "insuranceopportunitymail.net",
    "insurancereport.today",
    "insuranceschoolofflorida.com",
    "insureloveones.com",
    "insurer.com",
    "insurgency.stream",
    "insurgood.com",
    "insydney.org",
    "insyghtssecurity.com",
    "int-cash.ru",
    "intamo.cf",
    "intamo.ml",
    "intamo.tk",
    "intaso.cf",
    "intaso.ga",
    "intaso.ml",
    "intblrnet.ru",
    "intecorn.cf",
    "intecorn.gq",
    "intecorn.tk",
    "integra.net",
    "integratedtelehealthsolutions.info",
    "integrateinc.com",
    "integrately.info",
    "integrately.net",
    "integrately.org",
    "integrationiseasy.com",
    "integris.dev",
    "integritygaragedoors.info",
    "integritypay4u.com",
    "integrityseminar.com",
    "integritysupport.net",
    "intel.coms.hk",
    "intelea.shop",
    "intellectualization195pv.online",
    "intellectualization225oc.online",
    "intelli.solutions",
    "intelligence.zone",
    "intelligentp.com",
    "intellisport.net",
    "intelliwebconcepts.com",
    "intempmail.com",
    "intentions-advantage.site",
    "intentions-network.site",
    "intentionsadvantage.site",
    "intentsalumina.icu",
    "intenttodestroy.org",
    "inter-dohod.ru",
    "inter7.jp",
    "interaccess.com",
    "interacialsimulator.com",
    "interactionpolls.com",
    "interactiveeconomicsleak.com",
    "interaxfxl.space",
    "interbahisguncel.xyz",
    "interburp.com",
    "intercom1000.ru",
    "interent.xyz",
    "interesno-prosto.ru",
    "interesnoe-v-seti.ru",
    "interesting-rus.ru",
    "interexchange.ong",
    "interfree.it",
    "interfxmalenow.com",
    "intergate.bc.ca",
    "interia.eu",
    "interia.pl",
    "interiordesignideas.website",
    "interkross.biz",
    "interkross.org",
    "interlap.com.ar",
    "interlockhose.com",
    "intermail.co.il",
    "internal-resources.org",
    "internalized343wm.online",
    "internat-sosnovka.ru",
    "international.mba",
    "internationalconsulting.space",
    "internationalcosplayday.com",
    "internationale.su",
    "internationallanguageschool.com",
    "internationalstudents.xyz",
    "internationalyellow.com",
    "internet-basvuru.site",
    "internet-club.com",
    "internet-e-mail.com",
    "internet-kampanyalar.online",
    "internet-kampanyalari.online",
    "internet-mail.org",
    "internet-marketing-companies.com",
    "internet-police.com",
    "internet-rabota-088.ru",
    "internet-v-astrakhani.ru",
    "internet-v-belgorode.ru",
    "internet-v-kaluge.ru",
    "internet-v-krasnodare.ru",
    "internet-v-kurske.ru",
    "internet-v-moskve.ru",
    "internet-v-orle.ru",
    "internet-v-rostove.ru",
    "internet-v-ryazani.ru",
    "internet-v-samare.ru",
    "internet-v-saratove.ru",
    "internet-v-shakhti.ru",
    "internet-v-stavropole.ru",
    "internet-v-tule.ru",
    "internet-v-volgograde.ru",
    "internet2.dev",
    "internetaa317.xyz",
    "internetaboneligi.online",
    "internetbiz.com",
    "internetbiz63.ru",
    "internetchoice.blog",
    "internetdrive.com",
    "internetedirne.xyz",
    "internetegypt.com",
    "internetelearning.com",
    "internetemails.net",
    "internetenthusiast.me",
    "internetidentityworkshop.org",
    "internetineczanesi.xyz",
    "internetionalbusiness.host",
    "internetkeno.com",
    "internetmailing.net",
    "internetmarketingcasts.com",
    "internetmarketingperth.com",
    "internetmci.com",
    "internetnetzwerk.de",
    "internetnovine.info",
    "internetoftags.com",
    "internetqq59.xyz",
    "internetreputationconsultant.com",
    "internetsatinal.xyz",
    "internetsuperpac.com",
    "internetthings.partners",
    "internode.on.net",
    "interosis.club",
    "interpath.com",
    "interruption-exact.xyz",
    "interserver.ga",
    "intersquared.com",
    "interstats.org",
    "intersteller.com",
    "interstock24.com",
    "intertur-live.ru",
    "interval-bistro-tallaght.com",
    "intervesp-wood.ru",
    "interviewingthecrisis.org",
    "intervuse.me",
    "interwin1.net",
    "interwin99.info",
    "interwin99.org",
    "intexcamp.ru",
    "inthenhuahanoi.com",
    "intigame.net",
    "intim-dreams.ru",
    "intim-moskva.org",
    "intim-plays.ru",
    "intim-ryazan.ru",
    "intimiadyj.space",
    "intimm-shop.ru",
    "intimpremium.ru",
    "intimred.com",
    "intiona.com",
    "intisari.news",
    "intoa.bar",
    "intocommunity.org",
    "intort.best",
    "intowncm.com",
    "intowncm.net",
    "intrepidhome.tech",
    "intrepidwarriorehab.net",
    "intrepidwarriorrehab.net",
    "intrinor.ga",
    "intrinor.ml",
    "intrusted.net",
    "intrxi6ti6f0w1fm3.cf",
    "intrxi6ti6f0w1fm3.ga",
    "intrxi6ti6f0w1fm3.gq",
    "intrxi6ti6f0w1fm3.ml",
    "intrxi6ti6f0w1fm3.tk",
    "intuitivemachine.com",
    "intyre.ru",
    "inuitartsurvey.com",
    "inunglove.cf",
    "inunmomento.com",
    "inupab.cf",
    "inupab.tk",
    "inuvu.com",
    "inv.moe",
    "invadarecords.com",
    "invalid.com",
    "invalidmarket.ru",
    "invelmex.com",
    "invergroveheightsapartments.com",
    "invert.us",
    "invertrax.com",
    "investhaiti.org",
    "investinemsworkers.com",
    "investinhaiti.org",
    "investirparagarantir.com",
    "investmentbeaver.com",
    "investoday.info",
    "investor.xyz",
    "investore.co",
    "investormail.com",
    "investovanie.plus",
    "investsan.com",
    "investsmartusa.net",
    "investtips.club",
    "investxxtrade.ru",
    "invictus.games",
    "invictuswebportalservices.com",
    "inviersu.com",
    "invincible-wear.com",
    "invisiblevalid.buzz",
    "invistechitsupport.com",
    "inviteevbzw.email",
    "invitepal.com",
    "invizair.com",
    "invoicing.page",
    "involvementpractice.com",
    "invopeo.org",
    "invsetpo.cf",
    "invsetpo.tk",
    "invtribe01.xyz",
    "invtribe02.xyz",
    "invtribe03.xyz",
    "invtribe05.xyz",
    "inw88.com",
    "inwebtm.com",
    "inweightlossinfoesok.live",
    "inwind.it",
    "inwmail.net",
    "inzh-s.ru",
    "inzicht-uden.online",
    "io-scan.info",
    "io-wallet-lite.info",
    "io.dk",
    "ioa-s.icu",
    "iob.capital",
    "iobar.club",
    "iobox.com",
    "iobox.fi",
    "iocloud.su",
    "iodic.agency",
    "iodizc3krahzsn.cf",
    "iodizc3krahzsn.ga",
    "iodizc3krahzsn.gq",
    "iodizc3krahzsn.ml",
    "iodizc3krahzsn.tk",
    "ioemail.win",
    "ioetr.us",
    "iof09.space",
    "ioio.eu",
    "iol.it",
    "iol.pt",
    "iolkjk.cf",
    "iolkjk.ga",
    "iolkjk.gq",
    "iolkjk.ml",
    "iolokdi.ga",
    "iolokdi.ml",
    "ion-craft.ru",
    "ionando.shop",
    "ionb1ect2iark1ae1.cf",
    "ionb1ect2iark1ae1.ga",
    "ionb1ect2iark1ae1.gq",
    "ionb1ect2iark1ae1.ml",
    "ionb1ect2iark1ae1.tk",
    "ionbet.com",
    "ionemail.net",
    "ionet.net",
    "ionianpharm.com",
    "ionionweb.com",
    "ionwiont.shop",
    "iopgox.ru",
    "iopmail.com",
    "iopmail.net",
    "iorbita.ru",
    "iordanii.ru",
    "iosglyphs.com",
    "iosil.info",
    "iostwatch.com",
    "iosvzq.site",
    "iot.aiphone.eu.org",
    "iot.dmtc.dev",
    "iot.ptcu.dev",
    "iot.vuforia.us",
    "iotaph.ink",
    "iothome.dev",
    "iothomesmart.com",
    "iotrh5667.cf",
    "iotrh5667.ga",
    "iotrh5667.gq",
    "iotrh5667.ml",
    "iotu.creo.site",
    "iotu.de.vipqq.eu.org",
    "iotu.hstu.eu.org",
    "iotu.nctu.me",
    "ioubuy.com",
    "ioucai.xyz",
    "iouy67cgfss.cf",
    "iouy67cgfss.ga",
    "iouy67cgfss.gq",
    "iouy67cgfss.ml",
    "iouy67cgfss.tk",
    "iov.fund",
    "iowachevron.com",
    "iowacityrealestateagents.com",
    "iowaemail.com",
    "iowaexxon.com",
    "iowagstatic.com",
    "iowametaldesigns.net",
    "iowanvidia.com",
    "iowd.info",
    "iozak.com",
    "iozduc.site",
    "ip3.com",
    "ip4.pp.ua",
    "ip6.li",
    "ip6.pp.ua",
    "ip91vpn.com",
    "ipapa.ooo",
    "iparkandcharge.com",
    "iparladmin.com",
    "iparts96.ru",
    "ipasvnzm.shop",
    "ipay-i.club",
    "ipay-m.club",
    "ipb789.xyz",
    "ipdeer.com",
    "ipdf.site",
    "ipekecza.com",
    "ipemail.win",
    "ipex.ru",
    "ipffans.xyz",
    "ipfs.ru",
    "ipgenerals.com",
    "ipharchenko.ru",
    "iphd.online",
    "iphoneaccount.com",
    "iphonees.info",
    "iphonemail.cf",
    "iphonemail.ga",
    "iphonemail.gq",
    "iphonemail.tk",
    "iphonerestor.ru",
    "iphonex-shop.ru",
    "ipictures.xyz",
    "ipindetail.com",
    "ipinfo.pub",
    "ipingfan.com",
    "ipiranga.dynu.com",
    "ipizza24.ru",
    "ipl-schedule.com",
    "iplaytv.org",
    "ipledger.ru",
    "ipledges.info",
    "ipmaximus.ru",
    "ipnfo.com",
    "ipofnmicrocap.com",
    "ipofnvideo.com",
    "ipoo.org",
    "ipoodle.ru",
    "iportalexpress.com",
    "iposmobi.xyz",
    "ipostpix.com",
    "ippandansei.tk",
    "ipractice.ch",
    "iprayercenter.net",
    "iprimus.com.au",
    "ipriva.com",
    "ipriva.info",
    "iprocom.ru",
    "iproject.tech",
    "iprzbgsl.shop",
    "ipsur.org",
    "ipsuztqg.shop",
    "ipswell.com",
    "iptv.ski",
    "iptvcccam.club",
    "iptvmaximum.online",
    "iptvpro.host",
    "iptvservice.info",
    "ipukta.site",
    "ipuyallup.com",
    "ipv6-addr.com",
    "ipv6-addr.info",
    "ipv6-addr.org",
    "ipv6-addr.pro",
    "ipv6-addr.us",
    "ipv6-addr.zone",
    "ipveez.us",
    "ipvideo63.ru",
    "ipw88.com",
    "ipyzqshop.com",
    "iq1.live",
    "iq2kq5bfdw2a6.cf",
    "iq2kq5bfdw2a6.ga",
    "iq2kq5bfdw2a6.gq",
    "iq2kq5bfdw2a6.ml",
    "iq888.life",
    "iq8apc.us",
    "iq8xt.info",
    "iqbaby-toys.ru",
    "iqcfpcrdahtqrx7d.cf",
    "iqcfpcrdahtqrx7d.ga",
    "iqcfpcrdahtqrx7d.gq",
    "iqcfpcrdahtqrx7d.ml",
    "iqcfpcrdahtqrx7d.tk",
    "iqclubs.com",
    "iqemail.com",
    "iqemail.win",
    "iqhlenvz.site",
    "iqjiuo.us",
    "iqjty8.us",
    "iqos33.com",
    "iqprofx.biz",
    "iqsfu65qbbkrioew.cf",
    "iqsfu65qbbkrioew.ga",
    "iqsfu65qbbkrioew.gq",
    "iqsfu65qbbkrioew.ml",
    "iqsfu65qbbkrioew.tk",
    "iqvydg.us",
    "iqxyziua.shop",
    "ir35contractorguide.com",
    "ir4.tech",
    "irabops.com",
    "irahardwarewallet.com",
    "irainvestmentadviser.com",
    "irainvestmentadvisers.com",
    "irainvestmentadvisors.com",
    "iral.de",
    "irallc.net",
    "iran1music.com",
    "iranartan.com",
    "iranecar.org",
    "iranfilms.email",
    "iranforums.shop",
    "iranfsc.org",
    "irangate.net",
    "iranian-export.com",
    "iranluxury.tours",
    "iranmarket.info",
    "iranpb2.com",
    "iranpb9.com",
    "iranvolvos.info",
    "iraqbazar.com",
    "iraqbazzar.com",
    "iraqi-iod.net",
    "iraqmail.com",
    "iraqoilreport.net",
    "iraud.info",
    "iravag.com",
    "irc.so",
    "ircbox.xyz",
    "ircdrive.com",
    "ircdrive.net",
    "irdnd.live",
    "ireccomend.ru",
    "irecired.shop",
    "irefurbishlcd.com",
    "ireland.com",
    "irelandmail.com",
    "iremail.de",
    "iremel.cf",
    "iren24.ru",
    "irfnd1.site",
    "irhfa.com",
    "irimfi.gq",
    "irimfi.ml",
    "irimfi.tk",
    "irina-kusik.ru",
    "irish2me.com",
    "irishhome.net",
    "irishspringrealty.com",
    "iriver-grant.ru",
    "irj.hu",
    "irknim.ru",
    "irlandia4d.info",
    "irmoycos.cf",
    "irmoycos.gq",
    "irmoycos.ml",
    "irmoycos.tk",
    "irnipich.site",
    "irobotlab.ru",
    "iroid.com",
    "iroirorussia.ru",
    "irolli.se",
    "iron-dd.ru",
    "iron-pet.com",
    "iron-pets.com",
    "ironcompany.net",
    "ironfire.net",
    "ironflagcompany.org",
    "irongalaxy.com",
    "ironiebehindert.de",
    "ironside.systems",
    "ironsodiumlazy.website",
    "ironsshop.live",
    "ironwoodresearch.biz",
    "irpanenjin.com",
    "irpishbini2.com",
    "irpjg1.site",
    "irqgbs.site",
    "irr.kr",
    "irreproductive.best",
    "irsguidelines.net",
    "irssi.tv",
    "irtrade.org",
    "irtranslate.net",
    "irum6v.info",
    "irussoturisto.ru",
    "irvegasbet.com",
    "irvingaccidentlawyers.com",
    "irvingnailsalons.com",
    "irvingpersonalinjurylawyers.com",
    "irwvsm.com",
    "irxxz.live",
    "is-a-anarchist.com",
    "is-a-blogger.com",
    "is-a-bookkeeper.com",
    "is-a-bruinsfan.org",
    "is-a-bulls-fan.com",
    "is-a-candidate.org",
    "is-a-caterer.com",
    "is-a-celticsfan.org",
    "is-a-chef.com",
    "is-a-chef.net",
    "is-a-chef.org",
    "is-a-conservative.com",
    "is-a-cpa.com",
    "is-a-cubicle-slave.com",
    "is-a-democrat.com",
    "is-a-designer.com",
    "is-a-doctor.com",
    "is-a-financialadvisor.com",
    "is-a-geek.com",
    "is-a-geek.net",
    "is-a-geek.org",
    "is-a-green.com",
    "is-a-guru.com",
    "is-a-hard-worker.com",
    "is-a-hunter.com",
    "is-a-knight.org",
    "is-a-landscaper.com",
    "is-a-lawyer.com",
    "is-a-liberal.com",
    "is-a-libertarian.com",
    "is-a-linux-user.org",
    "is-a-llama.com",
    "is-a-musician.com",
    "is-a-nascarfan.com",
    "is-a-nurse.com",
    "is-a-painter.com",
    "is-a-patsfan.org",
    "is-a-personaltrainer.com",
    "is-a-photographer.com",
    "is-a-player.com",
    "is-a-republican.com",
    "is-a-rockstar.com",
    "is-a-socialist.com",
    "is-a-soxfan.org",
    "is-a-student.com",
    "is-a-teacher.com",
    "is-a-techie.com",
    "is-a-therapist.com",
    "is-an-accountant.com",
    "is-an-actor.com",
    "is-an-actress.com",
    "is-an-anarchist.com",
    "is-an-artist.com",
    "is-an-engineer.com",
    "is-an-entertainer.com",
    "is-by.us",
    "is-certified.com",
    "is-found.org",
    "is-gone.com",
    "is-into-anime.com",
    "is-into-cars.com",
    "is-into-cartoons.com",
    "is-into-games.com",
    "is-leet.com",
    "is-lost.org",
    "is-not-certified.com",
    "is-saved.org",
    "is-slick.com",
    "is-the-bestway.ru",
    "is-uberleet.com",
    "is-very-bad.org",
    "is-very-evil.org",
    "is-very-good.org",
    "is-very-nice.org",
    "is-very-sweet.org",
    "is-with-theband.com",
    "is.af",
    "isa-geek.com",
    "isa-geek.net",
    "isa-geek.org",
    "isa-hockeynut.com",
    "isabe2017.com",
    "isabellahunt.buzz",
    "isacmar.ga",
    "isacmar.gq",
    "isacmar.ml",
    "isacmar.tk",
    "isadiva.com",
    "isaffshop.store",
    "isaidmaybe.online",
    "isaimini.app",
    "isaiminida.org",
    "isaiminii.buzz",
    "isaiminii.host",
    "isaiminiya.org",
    "isaps.ru",
    "isbetter20.xyz",
    "isbgpsafe.com",
    "isbjct4e.com",
    "isblip.com",
    "iscacorp.com",
    "isccall.com",
    "iscfrc.com",
    "iscidayanismasi.org",
    "iscooler.com",
    "iscover.press",
    "isdaq.com",
    "isdp.ong",
    "ise4mqle13.o-r.kr",
    "iseeprojects.com",
    "isekaiplay.com",
    "isellcars.com",
    "isemmm.org",
    "isensy.ru",
    "iservejesus.com",
    "iservis.ist",
    "isf4e2tshuveu8vahhz.cf",
    "isf4e2tshuveu8vahhz.ga",
    "isf4e2tshuveu8vahhz.gq",
    "isf4e2tshuveu8vahhz.ml",
    "isf4e2tshuveu8vahhz.tk",
    "isfahantourism.info",
    "ishetalgedaan.site",
    "ishis.site",
    "ishkinn.ru",
    "ishockey.se",
    "ishootraw.net",
    "ishop-go.ru",
    "ishoppress.com",
    "ishuhome.com",
    "isi-group.ru",
    "isimnumara.com",
    "isistakeaway.com",
    "isitright4you.com",
    "isittheworldcup.info",
    "isitts.club",
    "isjer.icu",
    "iskcondc.org",
    "iskus-elki.ru",
    "islam.igg.biz",
    "islamicwisdomsummit.com",
    "islamm.cf",
    "islamm.gq",
    "islamonline.net",
    "islandbreeze-holidays.com",
    "islandemail.net",
    "islanderapp.com",
    "islandholidays-maldives.com",
    "islandkeysproperty.com",
    "islandproperties.info",
    "islandrisers.com",
    "islesfoundation.com",
    "isletmeyorum.com",
    "isleuthmail.com",
    "ismailgul.net",
    "ismart.net",
    "ismcentral.online",
    "ismem.ru",
    "ismyannuityadvisor.com",
    "ismyconsultant.com",
    "ismykek.xyz",
    "ismyspecialist.com",
    "isnapbet2020.xyz",
    "isnipeit.net",
    "isobelcarter.buzz",
    "isocar.ru",
    "isochor.site",
    "isocials.online",
    "isolationideas.info",
    "isomnio.com",
    "isonews2.com",
    "isonfire.com",
    "isosq.com",
    "isot.se",
    "isotac.site",
    "isp.fun",
    "isp9.net",
    "ispartaligheyeti.xyz",
    "ispartamutluapartlari.com",
    "ispartaonuryurtlari.xyz",
    "ispbd.xyz",
    "ispeak-spoke-spoken.info",
    "ispeak-spoke-spoken.net",
    "ispeak-spoke-spoken.org",
    "ispuntheweb.com",
    "ispyco.ru",
    "israelibandages.ru",
    "israelmail.com",
    "isrindustrialsafetyandrescue.com",
    "issanda.com",
    "issmarterthanyou.com",
    "issthnu7p9rqzaew.cf",
    "issthnu7p9rqzaew.ga",
    "issthnu7p9rqzaew.gq",
    "issthnu7p9rqzaew.ml",
    "issthnu7p9rqzaew.tk",
    "isstitap.gq",
    "issuebless.us",
    "issueca.icu",
    "issuechas.xyz",
    "issueenf.xyz",
    "issuerat.xyz",
    "issuerati.xyz",
    "ist-allein.info",
    "ist-einmalig.de",
    "ist-ganz-allein.de",
    "ist-genial.at",
    "ist-genial.info",
    "ist-genial.net",
    "ist-willig.de",
    "istabbettingsnapp.xyz",
    "istabbettsnupp2020.xyz",
    "istabetsnup.xyz",
    "istabetting.xyz",
    "istabilbettingsnap.xyz",
    "istabilbettsnapp.xyz",
    "istabilitybetsnapp.xyz",
    "istakalisa.club",
    "istanbularbitrationcentre.org",
    "istanbulbga.com",
    "istanbulcasino10.com",
    "istanbulcasino11.com",
    "istanbulcasino12.com",
    "istanbulcasino14.com",
    "istanbulcasino15.com",
    "istanbulcasino16.com",
    "istanbulcasino17.com",
    "istanbulcasino18.com",
    "istanbulcasino19.com",
    "istanbulcasino20.com",
    "istanbulcasino21.com",
    "istanbulcasino22.com",
    "istanbulcasino23.com",
    "istanbulcasino25.com",
    "istanbulcasino26.com",
    "istanbulcasino27.com",
    "istanbulcasino29.com",
    "istanbulcasino30.com",
    "istanbulcasino31.com",
    "istanbulcasino32.com",
    "istanbulcasino33.com",
    "istanbulcasino34.com",
    "istanbulcasino4.com",
    "istanbulcasino43.com",
    "istanbulcasino45.com",
    "istanbulcasino47.com",
    "istanbulcasino5.com",
    "istanbulcasino53.com",
    "istanbulcasino54.com",
    "istanbulcasino6.com",
    "istanbulcasino60.com",
    "istanbulcasino8.com",
    "istanbulcdmbg.org",
    "istanbulemlakuskudar.com",
    "istanbulrehberleri.com",
    "istanbulservisicagrimerkezi.xyz",
    "istanbulsiiri.com",
    "istatth.shop",
    "isteingeek.de",
    "istii.ro",
    "istinaf.net",
    "istirdad.website",
    "istlecker.de",
    "istmail.tk",
    "istmein.de",
    "istnistr.shop",
    "istoktepla.ru",
    "istore-x.ru",
    "istreamingtoday.com",
    "istroimvse.ru",
    "isukrainestillacountry.com",
    "isutdnov.shop",
    "isuzu-argentina.club",
    "isuzuserviskirsehir.xyz",
    "isvegan.com",
    "isweetuni.best",
    "isxuldi8gazx1.ga",
    "isxuldi8gazx1.ml",
    "isxuldi8gazx1.tk",
    "isyouco.space",
    "isyourspecialist.com",
    "isyszh.icu",
    "it-an-oxygenconcentratorsok.live",
    "it-awt.ru",
    "it-expert-service.ru",
    "it-italy.cf",
    "it-italy.ga",
    "it-italy.gq",
    "it-italy.ml",
    "it-italy.tk",
    "it-miracles.net",
    "it-nativesuvs-wish.live",
    "it-obuv.ru",
    "it-shoponline.info",
    "it-simple.net",
    "it-smart.org",
    "it-support-shanghai.com",
    "it-ua.ru",
    "it.dk",
    "it2-mail.tk",
    "it7.ovh",
    "itailorphuket.com",
    "itajaivip.com",
    "italia.flu.cc",
    "italia.igg.biz",
    "italiaaffitta.click",
    "italianpads.com",
    "italiavendecommerciale.com",
    "italiavendecommerciali.com",
    "italiavendecommerciali.online",
    "italienbuchen.com",
    "italsalz.shop",
    "italy-mail.com",
    "italymail.com",
    "italysource.com",
    "itangkas88.biz",
    "itangkas88.net",
    "itascahealthandchiropractic.com",
    "itaspanishautoinsurancebay.live",
    "itaspanishautoinsurancebig.live",
    "itaspanishautoinsurancebuy.live",
    "itaspanishautoinsurancefab.live",
    "itaspanishautoinsurancefed.live",
    "itaspanishautoinsurancehub.live",
    "itaspanishautoinsurancemax.live",
    "itaspanishautoinsurancenow.live",
    "itaspanishautoinsuranceone.live",
    "itaspanishautoinsurancerun.live",
    "itaspanishautoinsurancetop.live",
    "itboa.org",
    "itchapchap.com",
    "itchsoberlyleap.website",
    "itchyeye.xyz",
    "itchytoes.net",
    "itclub-smanera.tech",
    "itcompu.com",
    "itdeinter.cf",
    "itdeinter.ga",
    "itdeinter.ml",
    "itdeinter.tk",
    "iteachnet.com",
    "itechtrands.xyz",
    "itecsgroup.org",
    "itefus.cf",
    "itefus.gq",
    "itefus.tk",
    "itele.com",
    "itelefonica.com.br",
    "itemef.bid",
    "itemp.email",
    "itempmail.tk",
    "itesm.mx",
    "itfast.net",
    "itfilmes.ru",
    "itfinity.space",
    "itfornonit.com",
    "itgire.ga",
    "itgire.gq",
    "itgire.ml",
    "itgmusic.net",
    "ithacavineyard.com",
    "ithallamineparke.xyz",
    "ithconbi.ml",
    "ithconbi.tk",
    "ithebettsnaps.xyz",
    "itid.info",
    "itidata.asia",
    "itidata.global",
    "itidata.nyc",
    "itilchange.com",
    "itimes.com",
    "itinmar.cf",
    "itinmar.ga",
    "itinmar.gq",
    "itinmar.ml",
    "itiomail.com",
    "itis0k.com",
    "itj.cloud",
    "itks-it.ru",
    "itksit.ru",
    "itlawer.ru",
    "itleadersfestival.com",
    "itlek.ru",
    "itloox.com",
    "itmailr.com",
    "itmepher.ga",
    "itmepher.gq",
    "itmepher.tk",
    "itmiracles.net",
    "itmiracles.org",
    "itmlekethaber.online",
    "itmom.com",
    "itmtx.com",
    "itnews-group.ru",
    "itnewsport.ru",
    "itnfo.com",
    "itntucson.com",
    "itoasatinal.com",
    "itogether.club",
    "itoh.de",
    "itol.com",
    "itoldtech.org",
    "itomo.ru",
    "itopif.online",
    "itoup.com",
    "itoxwehnbpwgr.cf",
    "itoxwehnbpwgr.ga",
    "itoxwehnbpwgr.gq",
    "itoxwehnbpwgr.ml",
    "itoxwehnbpwgr.tk",
    "itpbppjhj.shop",
    "itportalnews.ru",
    "itqabkastz.fun",
    "itraconazolbivir.website",
    "itrental.com",
    "itreplace.com",
    "itri.de",
    "its-systems.com",
    "its0k.com",
    "itsbox.site",
    "itscaptain.com",
    "itsdata.org",
    "itserveis.com",
    "itshopwom.site",
    "itsiconsulting.com",
    "itsme.edu.pl",
    "itspanishautoinsurancebuy.live",
    "itspanishautoinsurancefab.live",
    "itspanishautoinsurancefed.live",
    "itspanishautoinsuranceget.live",
    "itspanishautoinsurancejet.live",
    "itspanishautoinsurancekey.live",
    "itspanishautoinsurancemax.live",
    "itspanishautoinsurancenew.live",
    "itspanishautoinsuranceray.live",
    "itspanishautoinsurancesbig.live",
    "itspanishautoinsurancesbuy.live",
    "itspanishautoinsurancesfan.live",
    "itspanishautoinsurancesget.live",
    "itspanishautoinsuranceshub.live",
    "itspanishautoinsurancesjet.live",
    "itspanishautoinsuranceskey.live",
    "itspanishautoinsurancesnew.live",
    "itspanishautoinsurancesnow.live",
    "itspanishautoinsurancesrad.live",
    "itspanishautoinsurancesray.live",
    "itspanishautoinsurancesrun.live",
    "itspanishautoinsurancestop.live",
    "itspanishautoinsurancesway.live",
    "itspanishautoinsurancetab.live",
    "itspanishautoinsurancetop.live",
    "itsrecess.com",
    "itsshelbystyles.com",
    "itst.icu",
    "itsx.icu",
    "itsyogacincinnati.com",
    "ittina.cf",
    "ittina.ga",
    "ittina.gq",
    "ittina.ml",
    "ittool.host",
    "ittybittybayou.com",
    "itue33ubht.ga",
    "itue33ubht.gq",
    "itue33ubht.tk",
    "itunes-soft.ru",
    "itunesgiftcodegenerator.com",
    "itutiod.ru",
    "itw88.com",
    "itxiaom.online",
    "itymail.com",
    "ityys.xyz",
    "iu54edgfh.cf",
    "iu54edgfh.ga",
    "iu54edgfh.gq",
    "iu54edgfh.ml",
    "iu54edgfh.tk",
    "iu66sqrqprm.cf",
    "iu66sqrqprm.ga",
    "iu66sqrqprm.gq",
    "iu66sqrqprm.ml",
    "iu66sqrqprm.tk",
    "iuavc.info",
    "iubuf.live",
    "iuemail.men",
    "iufs.xyz",
    "iuil87l.live",
    "iulconsultant.com",
    "iusecoins.com",
    "iuxguy.tokyo",
    "iuzyqp.us",
    "iv-fr.net",
    "iv.pl",
    "iv3xdy.us",
    "iv4vp.site",
    "iv51g4f4.info",
    "ivan-topor.ru",
    "ivant-eml.ru",
    "ivant-sr.ru",
    "ivant-srn.ru",
    "ivant-srv.ru",
    "ivant-srw.ru",
    "ivb2aa.us",
    "iveai.com",
    "ivebeenframed.com",
    "ivecotrucks.cf",
    "ivecotrucks.ga",
    "ivecotrucks.gq",
    "ivecotrucks.ml",
    "ivecotrucks.tk",
    "ivedisease.com",
    "ivehiv.com",
    "iversen.dk",
    "ivfufc.cf",
    "ivgxsljxu.shop",
    "ivideo1.com",
    "ivillage.com",
    "ivipo.com",
    "ivonline.live",
    "ivory-coast.com",
    "ivprictia.cf",
    "ivprictia.ga",
    "ivrm.email",
    "ivsusi.cf",
    "ivsusi.ga",
    "ivsusi.gq",
    "ivsusi.ml",
    "ivsusi.tk",
    "ivuhma.tokyo",
    "ivyandmarj.com",
    "ivycompete.com",
    "ivylim.com",
    "ivysheirlooms.net",
    "ivystocks.com",
    "iw0cef.us",
    "iw409uttadn.cf",
    "iw409uttadn.ga",
    "iw409uttadn.gq",
    "iw409uttadn.ml",
    "iw409uttadn.tk",
    "iwan-fals.com",
    "iwanbanjarworo.cf",
    "iwancorp.cf",
    "iwankopi.cf",
    "iwantmyname.com",
    "iwanttointerviewyou.com",
    "iwantumake.us",
    "iwasbornready.net",
    "iway.na",
    "iwebtm.com",
    "iwerxdesign.com",
    "iwi.net",
    "iwin.ga",
    "iwkb7o.com",
    "iwkfa.com",
    "iwmail.com",
    "iwmfuldckw5rdew.cf",
    "iwmfuldckw5rdew.ga",
    "iwmfuldckw5rdew.gq",
    "iwmfuldckw5rdew.ml",
    "iwmfuldckw5rdew.tk",
    "iwoc.de",
    "iwon.com",
    "iworld-travel.ru",
    "iwrk.ru",
    "iwrservices.com",
    "iwrservices.net",
    "iwsi.ru",
    "iwuhan.net",
    "iwv06uutxic3r.cf",
    "iwv06uutxic3r.ga",
    "iwv06uutxic3r.gq",
    "iwv06uutxic3r.ml",
    "iwv06uutxic3r.tk",
    "ix.netcom.com",
    "ix.pxwsi.com",
    "ix9bal.us",
    "ixaks.com",
    "ixfwfabka.shop",
    "ixkxirzvu10sybu.cf",
    "ixkxirzvu10sybu.ga",
    "ixkxirzvu10sybu.gq",
    "ixkxirzvu10sybu.ml",
    "ixkxirzvu10sybu.tk",
    "ixtwhjqz4a992xj.cf",
    "ixtwhjqz4a992xj.ga",
    "ixtwhjqz4a992xj.gq",
    "ixtwhjqz4a992xj.ml",
    "ixtwhjqz4a992xj.tk",
    "ixvfhtq1f3uuadlas.cf",
    "ixvfhtq1f3uuadlas.ga",
    "ixvfhtq1f3uuadlas.gq",
    "ixvfhtq1f3uuadlas.ml",
    "ixvfhtq1f3uuadlas.tk",
    "ixx.io",
    "ixxycatmpklhnf6eo.cf",
    "ixxycatmpklhnf6eo.ga",
    "ixxycatmpklhnf6eo.gq",
    "ixyncm.us",
    "ixyrgr.us",
    "ixzuln.info",
    "iy47wwmfi6rl5bargd.cf",
    "iy47wwmfi6rl5bargd.ga",
    "iy47wwmfi6rl5bargd.gq",
    "iy47wwmfi6rl5bargd.ml",
    "iy47wwmfi6rl5bargd.tk",
    "iy54ac.us",
    "iyadqadi.com",
    "iyapk.poker",
    "iyeni.com",
    "iyerb.com",
    "iyikidevarim.com",
    "iying65.com",
    "iying67.com",
    "iying69.com",
    "iyongcaplong.com",
    "iyouwe.com",
    "iz0tvkxu43buk04rx.cf",
    "iz0tvkxu43buk04rx.ga",
    "iz0tvkxu43buk04rx.gq",
    "iz0tvkxu43buk04rx.ml",
    "iz0tvkxu43buk04rx.tk",
    "iz3oht8hagzdp.cf",
    "iz3oht8hagzdp.ga",
    "iz3oht8hagzdp.gq",
    "iz3oht8hagzdp.ml",
    "iz3oht8hagzdp.tk",
    "iz4acijhcxq9i30r.cf",
    "iz4acijhcxq9i30r.ga",
    "iz4acijhcxq9i30r.gq",
    "iz4acijhcxq9i30r.ml",
    "iz4acijhcxq9i30r.tk",
    "iz5kf.us",
    "izadpanah.com",
    "izbahis.com",
    "izbashop.ru",
    "izbud1.site",
    "izbunet.ru",
    "izbzm.com",
    "izcmqm.com",
    "izendustriyel.org",
    "izhevsk24.ru",
    "izhsmi.site",
    "izicmil.cf",
    "izicmil.ga",
    "izicmil.gq",
    "izicmil.ml",
    "izicmil.tk",
    "izip.site",
    "izkyqr.xyz",
    "izlvsmyl.shop",
    "izmenamuzha.ru",
    "izmir35gayrimenkul.xyz",
    "izmirasmolen.com",
    "izmiringilizcedilkursu.com",
    "izmirotomobil.xyz",
    "izmirseyirtepe.net",
    "izmitvestelservis.com",
    "izmoscowpo.ru",
    "izobretateli59.ru",
    "izoli9afsktfu4mmf1.cf",
    "izoli9afsktfu4mmf1.ga",
    "izoli9afsktfu4mmf1.gq",
    "izoli9afsktfu4mmf1.ml",
    "izoli9afsktfu4mmf1.tk",
    "izquierdadiario.org",
    "iztaki.xyz",
    "izvif.us",
    "izwuhkxra.shop",
    "j-keats.cf",
    "j-keats.ga",
    "j-keats.gq",
    "j-keats.ml",
    "j-keats.tk",
    "j-p.us",
    "j-response.com",
    "j.aq.si",
    "j.fairuse.org",
    "j.rvb.ro",
    "j0axz.online",
    "j0hoi.us",
    "j0mail.com",
    "j15ug1ltxd7iugr.xyz",
    "j1zr8d.us",
    "j25bk.com",
    "j2anellschild.ga",
    "j2ltgr.us",
    "j2ukcy.us",
    "j2voip.com",
    "j2websolutions.com",
    "j30nz.space",
    "j3olp.icu",
    "j3rik.info",
    "j3rqt89ez.com",
    "j3xbes.us",
    "j4ckpd.us",
    "j4hyc.us",
    "j4rang0y4nk.ga",
    "j54wn.site",
    "j59nx.site",
    "j5kic.us",
    "j5vhmmbdfl.cf",
    "j5vhmmbdfl.ga",
    "j5vhmmbdfl.gq",
    "j5vhmmbdfl.ml",
    "j5vhmmbdfl.tk",
    "j6ev3l.space",
    "j6gpvz.us",
    "j6qr1q.us",
    "j6qwq4.host",
    "j7665.com",
    "j7exus.com",
    "j8-freemail.cf",
    "j80zn.site",
    "j83tb.site",
    "j85xm.com",
    "j8ivlsb169o2w4t.xyz",
    "j8k2.usa.cc",
    "j8pxy.us",
    "j8rigs.us",
    "j90jj.com",
    "j90yb.com",
    "j9356.com",
    "j94gq.space",
    "j9dtuy.site",
    "j9gekl.us",
    "j9gzp3.us",
    "j9k.org",
    "jaaj.cf",
    "jaalaa4.xyz",
    "jaarvandemolens.online",
    "jabatankopi.com",
    "jabble.com",
    "jabbyhotel.online",
    "jabiruowners.org",
    "jabkagames.ru",
    "jabqjgxo.shop",
    "jaccede.net",
    "jacckpot.site",
    "jackdouglas.online",
    "jackiespetsupply.com",
    "jackjackjack.net",
    "jackmailer.com",
    "jacknini.cf",
    "jacknini.ml",
    "jacknini.tk",
    "jackopmail.tk",
    "jackpire.com",
    "jackpot-info.ru",
    "jackpotjoy.biz",
    "jackpotred.nu",
    "jackro.online",
    "jackrosi.ml",
    "jacksonbarton.com",
    "jacksonhole.homes",
    "jacksonhole.house",
    "jacksonvillequote.com",
    "jackstale.com",
    "jackymail.top",
    "jacmelinter.xyz",
    "jacobmorgancapital.com",
    "jacobsen.dk",
    "jacobsewell.com",
    "jacops.art",
    "jacquaknga.online",
    "jacquardcurtain.com",
    "jacquelx.com",
    "jacques-thomann.com",
    "jad32.cf",
    "jad32.ga",
    "jad32.gq",
    "jadamspam.pl",
    "jade-as9.com",
    "jadecourtmeal.com",
    "jades-garden.com",
    "jadikedi.club",
    "jadku.icu",
    "jadopado.com",
    "jadwalbola.link",
    "jaewoonglee.com",
    "jafethuis.shop",
    "jafhd.com",
    "jafps.com",
    "jafufq.us",
    "jagdglas.de",
    "jagongan.ml",
    "jagr88.net",
    "jaguar-landrover.cf",
    "jaguar-landrover.ga",
    "jaguar-landrover.gq",
    "jaguar-landrover.ml",
    "jaguar-landrover.tk",
    "jaguar-xj.ml",
    "jaguar-xj.tk",
    "jaguarxtype.info",
    "jahoopa.com",
    "jaimenwo.cf",
    "jaimenwo.ga",
    "jaimenwo.gq",
    "jaimenwo.tk",
    "jajxz.com",
    "jakefaulkner.buzz",
    "jakepearse.com",
    "jakesfamous.us",
    "jakesfamousfoods.info",
    "jakesfamousfoods.org",
    "jakf.email",
    "jakiyo.site",
    "jakjtavvtva8ob2.cf",
    "jakjtavvtva8ob2.ga",
    "jakjtavvtva8ob2.gq",
    "jakjtavvtva8ob2.ml",
    "jakjtavvtva8ob2.tk",
    "jakobsen.dk",
    "jakuza.hu",
    "jalcemail.net",
    "jalhaja.net",
    "jama.trenet.eu",
    "jamaicaawareness.net",
    "jamaicatirediscountergroup.com",
    "jamalfishbars.com",
    "jamaw-ewad.ru",
    "jambcbtsoftware.com",
    "jambuti.com",
    "jamcup.xyz",
    "jamere.site",
    "jamesbild.com",
    "jamesbond.flu.cc",
    "jamesbond.igg.biz",
    "jamesbond.nut.cc",
    "jamesbond.usa.cc",
    "jamesbradystewart.com",
    "jamesfabiebailbonds.com",
    "jamesmaylovescabbage.xyz",
    "jamesorjamie.com",
    "jameszol.net",
    "jameszol.org",
    "jametjay.com",
    "jamiecooper.buzz",
    "jamielayne.com",
    "jamieziggers.nl",
    "jamikait.cf",
    "jamikait.ga",
    "jamikait.gq",
    "jamikait.ml",
    "jamisonadvertising.com",
    "jamit.com.au",
    "jampamovel.tk",
    "jamstats.com",
    "jamusic.online",
    "jan-sramek.com",
    "jan64b.space",
    "janatatelevision.com",
    "jancloud.net",
    "jancok.in",
    "jancokancene.cf",
    "jancokancene.ga",
    "jancokancene.gq",
    "jancokancene.ml",
    "jancokcp.com",
    "jancoklah.com",
    "jancuk.tech",
    "jancukqq.com",
    "jandaulet.ru",
    "jandetin.cf",
    "jandetin.ga",
    "jandetin.gq",
    "jandetin.ml",
    "janet-online.com",
    "janeweb.ru",
    "janganjadiabu1.tk",
    "janganjadiabu10.gq",
    "janganjadiabu2.ml",
    "janganjadiabu3.ga",
    "janganjadiabu4.cf",
    "janganjadiabu5.gq",
    "janganjadiabu6.tk",
    "janganjadiabu7.ml",
    "janganjadiabu8.ga",
    "janganjadiabu9.cf",
    "jangkrikbosku.com",
    "janicegriffith.xyz",
    "janicemichellefoundation.net",
    "janicemichellefoundation.org",
    "janitorservices.com",
    "janivahenry.com",
    "janlanser.shop",
    "janmail.org",
    "janproz.com",
    "jans-koschek.info",
    "janshirts.club",
    "jansmithcannon.com",
    "jansutita.com",
    "janusoffical.com",
    "janvan.gent",
    "janverschuuren.com",
    "janym.ru",
    "janza.ru",
    "janza.site",
    "japan-exitwidget.com",
    "japan.com",
    "japanaa318.xyz",
    "japanakiba.com",
    "japanawesome.com",
    "japanerpjr.space",
    "japanjoayo.com",
    "japanonly.com",
    "japanresearch.com",
    "japanyn7ys.com",
    "japaventura.net",
    "japaventura.org",
    "japjytgzw.shop",
    "jaqis.com",
    "jaqueline1121.club",
    "jaqueslucont.icu",
    "jarcasinoalf.ru",
    "jarconsultoresfiscalycontable.com",
    "jardinroyaltakeaway.com",
    "jarestores.site",
    "jargonize97qj.online",
    "jarraci.gq",
    "jartiyericgiyim.online",
    "jarxs-vpn.ml",
    "jasa4d.online",
    "jasa855.com",
    "jasa855.net",
    "jasa855.org",
    "jasabyte.shop",
    "jasajudi.com",
    "jasaseo.info",
    "jasbell-carda.de",
    "jasegot.store",
    "jasmierodgers.ga",
    "jasmin-masaj.xyz",
    "jasolen.cf",
    "jasolen.gq",
    "jasolen.ml",
    "jasongalvin.com",
    "jasonlaughlin.org",
    "jasonmadama.com",
    "jasonprycememorial.org",
    "jateamssign.cf",
    "jateamssign.ga",
    "jateamssign.ml",
    "jateamssign.tk",
    "jatfvn.xyz",
    "jathqy.xyz",
    "jatillivet.xyz",
    "jatmikav.top",
    "jatpai.xyz",
    "jauhari.cf",
    "jauhari.ga",
    "jauhari.gq",
    "jaujqt.site",
    "jaumin.best",
    "jav.bike",
    "jav.cash",
    "jav.codes",
    "jav.support",
    "jav12.xyz",
    "jav333.net",
    "jav99-0.com",
    "jav99-7.com",
    "javamail.org",
    "javaprogrammingpoursesusa.com",
    "javedic.cf",
    "javedic.ml",
    "javhd.buzz",
    "javkojima.club",
    "javmail.tech",
    "javmaniac.co",
    "javo.email",
    "javoei.com",
    "javopgan.ru",
    "javrdv.com",
    "javrkf.com",
    "javsbk.com",
    "javsin.best",
    "javzog.com",
    "jawaramantul.info",
    "jaxoxx.se",
    "jaya5758.com",
    "jayapoker99.net",
    "jayaprakashmenon.com",
    "jaycrouch.org",
    "jaydemail.com",
    "jaydeninc.com",
    "jayhotz.com",
    "jayjessup.com",
    "jaymoviedownload.xyz",
    "jayphimar.cf",
    "jayphimar.ga",
    "jayphimar.ml",
    "jayphimar.tk",
    "jaysachdev.com",
    "jaysclay.org",
    "jayyidumroh.com",
    "jayzbook.com",
    "jayzeh.com",
    "jazzandjava.com",
    "jazzbo.site",
    "jazzcommons.com",
    "jazzfan.com",
    "jazzgame.com",
    "jazztrumpet.ru",
    "jazzzespo.cf",
    "jazzzespo.ga",
    "jazzzespo.gq",
    "jazzzespo.ml",
    "jb73bq0savfcp7kl8q0.ga",
    "jb73bq0savfcp7kl8q0.ml",
    "jb73bq0savfcp7kl8q0.tk",
    "jbasm.us",
    "jbbqny.com",
    "jbbtest.com",
    "jbegn.info",
    "jbfqc8.us",
    "jbhhgbuz.shop",
    "jbl-4.site",
    "jbl-russia.ru",
    "jblacust.ru",
    "jblpoker.net",
    "jblpoker.org",
    "jblrus.online",
    "jblshop.ru",
    "jbmbet.info",
    "jbmbet.online",
    "jbmnoi.com",
    "jbnote.com",
    "jbnyfd.com",
    "jbopoker.org",
    "jbp22.space",
    "jbso8.us",
    "jbydress.online",
    "jc-decaux.tk",
    "jc254.com",
    "jc2vnr.us",
    "jc7m.tel",
    "jcaf.icu",
    "jcalvert.net",
    "jcamerahot.info",
    "jcbwy.com",
    "jcdmail.men",
    "jcdz.email",
    "jcenergyworks.info",
    "jcfug.us",
    "jchez.com",
    "jciphilippines.org",
    "jcjnet.com",
    "jcll.buzz",
    "jcnai1.site",
    "jcom.home.ne.jp",
    "jcp3rq.info",
    "jcpclothing.ga",
    "jcredding.com",
    "jcs-studio.ru",
    "jcv2yv.com",
    "jdasdhj.cf",
    "jdasdhj.ga",
    "jdasdhj.gq",
    "jdasdhj.ml",
    "jdasdhj.tk",
    "jdb81.space",
    "jdd06.com",
    "jddapi.app",
    "jde53sfxxbbd.cf",
    "jde53sfxxbbd.ga",
    "jde53sfxxbbd.gq",
    "jde53sfxxbbd.ml",
    "jde53sfxxbbd.tk",
    "jdfqxtap.shop",
    "jdgang.com",
    "jdkmusic.us",
    "jdkpcl.us",
    "jdl5wt6kptrwgqga.cf",
    "jdl5wt6kptrwgqga.ga",
    "jdl5wt6kptrwgqga.gq",
    "jdl5wt6kptrwgqga.ml",
    "jdl5wt6kptrwgqga.tk",
    "jdmadventures.com",
    "jdmbenefits.info",
    "jdmhero.com",
    "jdmzci.us",
    "jdnirm.site",
    "jdsrealtygrouppr.com",
    "jdtfdf55ghd.ml",
    "jdub.de",
    "jdvmail.com",
    "jdxsqz.tokyo",
    "jdy01.xyz",
    "jdz.gov.cn",
    "jdz.ro",
    "je-recycle.info",
    "je2tjeraafmans.xyz",
    "je7f7muegqi.ga",
    "je7f7muegqi.gq",
    "je7f7muegqi.ml",
    "je7f7muegqi.tk",
    "jeanhamiltonvoice.com",
    "jeannelepellee.com",
    "jeannerussellchiropractic.com",
    "jeanvaljean.com",
    "jeasysux.agency",
    "jebabu.com",
    "jebacdisaskurwysyna.xyz",
    "jebratikfersokilo.xyz",
    "jeeb.trade",
    "jeeet9.live",
    "jeemboo.ru",
    "jeep-australia.club",
    "jeep-cherokee.club",
    "jeep-chile.club",
    "jeep-official.cf",
    "jeep-official.ga",
    "jeep-official.gq",
    "jeep-official.ml",
    "jeep-official.tk",
    "jeepsafarialbania.com",
    "jeet16.live",
    "jeet20.live",
    "jeetmr.live",
    "jeff.ml",
    "jeffdenzra.cf",
    "jeffdenzra.ga",
    "jeffdenzra.ml",
    "jeffersonandassociates.com",
    "jeffersonms.org",
    "jeffexotica.com",
    "jeffjeeps.info",
    "jeffmerkeley.org",
    "jeffmerkly.com",
    "jeffnelson.org",
    "jeffpeterson.info",
    "jeffreyhunt.org",
    "jeffreypeterson.info",
    "jefricrak12.ml",
    "jeg5ym.us",
    "jeie.igg.biz",
    "jejinger.info",
    "jejofo.info",
    "jekadok.xyz",
    "jekeshkumaroad.icu",
    "jelascasino.host",
    "jelenajensentube.com",
    "jelldiving.com",
    "jellow.ml",
    "jellybeanplop.org",
    "jellycabi.icu",
    "jellyeyelidmeant.site",
    "jellyrolls.com",
    "jellytast.buzz",
    "jelm.de",
    "jembotbrodol.com",
    "jembott.com",
    "jembud.icu",
    "jembulan.bounceme.net",
    "jembut142.cf",
    "jembut142.ga",
    "jembut142.gq",
    "jembut142.ml",
    "jembut142.tk",
    "jemchujinka.info",
    "jemmasplayground.com",
    "jennarhodes.com",
    "jennifergallagher.buzz",
    "jenskiymir.ru",
    "jensonchiropracticdecatur.com",
    "jentro.com",
    "jeodumifi.ns3.name",
    "jeomychort.cf",
    "jeomychort.ga",
    "jepijopiijo.cf",
    "jepijopiijo.ga",
    "jepijopiijo.gq",
    "jepijopiijo.ml",
    "jepijopiijo.tk",
    "jeralo.de",
    "jeramywebb.com",
    "jerapah993r.gq",
    "jeremyfocus.com",
    "jeremyteale.com",
    "jeremywood.xyz",
    "jerf.de",
    "jeriofad.site",
    "jerk.com",
    "jeromesam.cat",
    "jerseen.world",
    "jerseycityhairsalons.com",
    "jerseycityrealestateagents.com",
    "jertistore.xyz",
    "jertroskinscsgo.fun",
    "jerusalem-dublin2.com",
    "jerusalem-takeaway.com",
    "jerusalem.fyxo.ml",
    "jerusalemcall.org",
    "jerusalemmail.com",
    "jerusatyhn.space",
    "jes96x.us",
    "jesflk.com",
    "jesisale.site",
    "jessarhodes.site",
    "jessicahernanez.xyz",
    "jessicalife.com",
    "jessie.tokyo",
    "jessietv.tokyo",
    "jestbet65.com",
    "jestyayin27.com",
    "jesus-shop.ru",
    "jesusanswers.com",
    "jesuschrist.fund",
    "jesuschrist.icu",
    "jesuschrist.productions",
    "jesusnotjunk.org",
    "jesusygema.online",
    "jet-renovation.fr",
    "jet10bet14.com",
    "jetable.com",
    "jetable.de",
    "jetable.fr.nf",
    "jetable.net",
    "jetable.org",
    "jetable.pp.ua",
    "jetableemail.com",
    "jetableemails.com",
    "jetagram.com",
    "jetanime.xyz",
    "jetemail.net",
    "jeternet.com",
    "jetflzz.ru",
    "jetiamb.icu",
    "jetlogcomex.com",
    "jetmembranehit.website",
    "jetonkartsatinal.com",
    "jetrelocation.us",
    "jetsearches.com",
    "jetsmails.com",
    "jetstardutyfreepreorder.com",
    "jetstash.site",
    "jettcohen.com",
    "jettisonsaga.com",
    "jetub.xyz",
    "jeupronostic.com",
    "jevtw6.host",
    "jewelfishcreations.com",
    "jewelhaven.net",
    "jewelinthecrowntakeaway.com",
    "jewelry497tq.online",
    "jewelrycellar.com",
    "jewelrycrafts.world",
    "jewelrymakingideas.site",
    "jewishfraternities.org",
    "jewishfraternity.org",
    "jewishmail.com",
    "jewishrewj.space",
    "jewishwisdomsummit.com",
    "jewqlfqo.xyz",
    "jewsagainsttrump.org",
    "jewsoncampus.org",
    "jexopozam.shop",
    "jeyuvido.site",
    "jezera.info",
    "jezwg.live",
    "jfaccupuncture.com",
    "jfaiz5gz.xyz",
    "jfgfgfgdfdder545yy.ml",
    "jfhd.us",
    "jfhf9954.com",
    "jfhhm.com",
    "jfiee.tk",
    "jfkislanders.com",
    "jfmjw.com",
    "jftruyrfghd8867.cf",
    "jftruyrfghd8867.ga",
    "jftruyrfghd8867.gq",
    "jftruyrfghd8867.ml",
    "jftruyrfghd8867.tk",
    "jfwkttkh.shop",
    "jfwrt.com",
    "jfxklwyj.shop",
    "jgerbn4576aq.cf",
    "jgerbn4576aq.ga",
    "jgerbn4576aq.gq",
    "jgerbn4576aq.ml",
    "jgerbn4576aq.tk",
    "jgfrpy.us",
    "jgj11277.com",
    "jglobal.org",
    "jglopez.net",
    "jgro1c.us",
    "jgyjt.live",
    "jh24promo.ru",
    "jhalakibs21.gq",
    "jhehfweo.site",
    "jhfg.us",
    "jhgnnb.com",
    "jhhgcv54367.cf",
    "jhhgcv54367.ga",
    "jhhgcv54367.ml",
    "jhhgcv54367.tk",
    "jhib.de",
    "jhjo6m.us",
    "jhjty56rrdd.cf",
    "jhjty56rrdd.ga",
    "jhjty56rrdd.gq",
    "jhjty56rrdd.ml",
    "jhjty56rrdd.tk",
    "jhkggv4-privzsra.press",
    "jhkggv4-privzsra.space",
    "jhkggv4-privzsra.xyz",
    "jhmkai.site",
    "jhow.cf",
    "jhow.ga",
    "jhow.gq",
    "jhow.ml",
    "jhqqmczmu.shop",
    "jhtzu.live",
    "jhxl.org",
    "ji4zwf.site",
    "jiahezaixian.biz",
    "jiahyl.com",
    "jiahylzc.com",
    "jiancok.cf",
    "jiancok.ga",
    "jiancok.gq",
    "jiancokowe.cf",
    "jiancokowe.ga",
    "jiancokowe.gq",
    "jiancokowe.ml",
    "jiangpeng.xyz",
    "jianguo1111.com",
    "jianguo1112.com",
    "jianguo1115.com",
    "jianguo234.com",
    "jianguo345.com",
    "jianguo432.com",
    "jianguo543.com",
    "jianguo678.com",
    "jiankangzaji.com",
    "jiaoya.net",
    "jiaxin8736.com",
    "jibaiwan.xyz",
    "jibitpay.com",
    "jic4pn.us",
    "jieber.net",
    "jiemoyan.com",
    "jiez00veud9z.cf",
    "jiez00veud9z.ga",
    "jiez00veud9z.gq",
    "jiez00veud9z.ml",
    "jiez00veud9z.tk",
    "jiga.site",
    "jiggermast.site",
    "jigjournal.org",
    "jigoloajanslari.org",
    "jihlmnvkp.shop",
    "jijedcei.ga",
    "jijedcei.gq",
    "jijedcei.tk",
    "jijianhufu.com",
    "jijixiaozhen.cn",
    "jikex.org",
    "jikilifina11.ru",
    "jil.kr",
    "jiljadid.com",
    "jiljadid.info",
    "jilliangiardullomemorialfund.com",
    "jillshaver.com",
    "jilossesq.com",
    "jilyva.info",
    "jimandalisandra.com",
    "jimans.pro",
    "jimboba.ru",
    "jimbombey.ru",
    "jimdahl.com",
    "jimfaddismusic.com",
    "jimgrieve.net",
    "jimhansonhomes.com",
    "jimhoyd.com",
    "jimmyasaro.com",
    "jimmyhqdjj.space",
    "jimmynewdomain123345.biz",
    "jimmys-takeaway-kilkenny.com",
    "jimmysweblog.net",
    "jimoruxue.com",
    "jimster.site",
    "jin638.com",
    "jinchuan.xyz",
    "jindingguojiyule.com",
    "jindunssc.com",
    "jinefur.press",
    "jinfu10.com",
    "jingcaizaixian.net",
    "jinggakop.ga",
    "jinggakop.gq",
    "jinggakq.ml",
    "jinghe-ep.com",
    "jingjo.net",
    "jinguanghu.com",
    "jingvesouff.cf",
    "jingvesouff.ga",
    "jinhaobj.com",
    "jinnmail.net",
    "jinrongpaizhao2006.com",
    "jinschinese.com",
    "jinsha3421.com",
    "jintogel.net",
    "jiojiogrejoigre.info",
    "jiovaj.best",
    "jiplant.xyz",
    "jippii.fi",
    "jiprbr.rest",
    "jiqe.info",
    "jirafikcraft.ru",
    "jiromail.com",
    "jiskhdgbgsytre43vh.ga",
    "jitenei6.site",
    "jitimarkets.site",
    "jitterx.com",
    "jitulive.xyz",
    "jituloh.com",
    "jiu8cp.com",
    "jiuba222.com",
    "jiuba777.com",
    "jiucaojj.com",
    "jiucaoll.com",
    "jiuhe-auto.com",
    "jiuling-yule.com",
    "jiulingyule.com",
    "jiuseyy.club",
    "jiuseyy.site",
    "jiuseyy.xyz",
    "jiusp6.com",
    "jiveline.com",
    "jivotik.info",
    "jiwatoto.org",
    "jixa.site",
    "jixe.site",
    "jixyvu.info",
    "jiyoshops.site",
    "jiyue.org",
    "jiyun123.com",
    "jizdjq.info",
    "jj18269.com",
    "jj3385.com",
    "jj3i.com",
    "jj57822.com",
    "jj7665.com",
    "jj8848.com",
    "jj9827.com",
    "jjabberifye.site",
    "jjabbervine.site",
    "jjchoosetp.com",
    "jjdong15.com",
    "jjdong16.com",
    "jjdong17.com",
    "jjdong18.com",
    "jjdong23.com",
    "jjdong24.com",
    "jjdong25.com",
    "jjdong28.com",
    "jjdong29.com",
    "jjdong30.com",
    "jjdong32.com",
    "jjdong35.com",
    "jjdong37.com",
    "jjdong38.com",
    "jjdong39.com",
    "jjdong40.com",
    "jjdong41.com",
    "jjdong44.com",
    "jjdong45.com",
    "jjdong46.com",
    "jjdong47.com",
    "jjdong48.com",
    "jjdong49.com",
    "jjdong7.com",
    "jjdong8.com",
    "jjdong9.com",
    "jjeqfu.site",
    "jjetbot.site",
    "jjetfoxw.site",
    "jjetworksk.site",
    "jjgg.de",
    "jjj813.com",
    "jjkgrtteee098.cf",
    "jjkgrtteee098.ga",
    "jjkgrtteee098.gq",
    "jjkgrtteee098.ml",
    "jjkgrtteee098.tk",
    "jjlhm.live",
    "jjlink.cn",
    "jjmsb.eu.org",
    "jjo77.space",
    "jjohbqppg.shop",
    "jjosale.top",
    "jjvv.biz",
    "jk141.site",
    "jk3k.com",
    "jk7ir.us",
    "jkbmdp.fun",
    "jkcbpp.host",
    "jkcntadia.cf",
    "jkcntadia.ga",
    "jkcntadia.gq",
    "jkcntadia.ml",
    "jkcntadia.tk",
    "jke79o.site",
    "jkeyes.com",
    "jkgbvc.com",
    "jkgihjk.website",
    "jkgmkp.fun",
    "jkhk.de",
    "jkhmmx.fun",
    "jkio-90.xyz",
    "jkjsrdtr35r67.cf",
    "jkjsrdtr35r67.ga",
    "jkjsrdtr35r67.gq",
    "jkjsrdtr35r67.ml",
    "jkjsrdtr35r67.tk",
    "jkk9d98grwo2cwz.xyz",
    "jkkmdm.fun",
    "jklasdf.com",
    "jkljkl.cf",
    "jkljkl.ga",
    "jklmxl.fun",
    "jkmmks.fun",
    "jkpinturas.com",
    "jkpmqh.fun",
    "jkqmxw.fun",
    "jkqssvmf.shop",
    "jkr.ovh",
    "jkrmrw.fun",
    "jkrowlg.cf",
    "jkrowlg.ga",
    "jkrowlg.gq",
    "jkrowlg.ml",
    "jktif.live",
    "jktmjx.fun",
    "jktmmz.fun",
    "jkwmxk.fun",
    "jkwmzd.fun",
    "jkymbw.fun",
    "jkymnw.fun",
    "jkyvznnqlrc.gq",
    "jkyvznnqlrc.ml",
    "jkyvznnqlrc.tk",
    "jl.biz",
    "jlajah.com",
    "jlauryn.com",
    "jlctvmlxq.shop",
    "jljc.site",
    "jlle.tk",
    "jllxup.us",
    "jlmq3b.us",
    "jlqiqd.tokyo",
    "jls4.com",
    "jlylc66.com",
    "jlynchfamily.com",
    "jm-ac.com",
    "jm24i0.site",
    "jm3456.com",
    "jm60.xyz",
    "jm7000.com",
    "jm8000.com",
    "jm9797.com",
    "jmail.co.za",
    "jmail.fr.nf",
    "jmail.ovh",
    "jmail.ro",
    "jmail7.com",
    "jmcei.us",
    "jmetg8.us",
    "jmkbwfyo.tech",
    "jmsbbs.com",
    "jmutang.com",
    "jmwbac.com",
    "jmwv6z.us",
    "jmxapp.com",
    "jmzhufu.com",
    "jmzlzl.com",
    "jnbzcl.com",
    "jnggachoc.cf",
    "jnggachoc.gq",
    "jnifyqit.shop",
    "jnpayy.com",
    "jnru.email",
    "jntaobao.com",
    "jnthn39vr4zlohuac.cf",
    "jnthn39vr4zlohuac.ga",
    "jnthn39vr4zlohuac.gq",
    "jnthn39vr4zlohuac.ml",
    "jnthn39vr4zlohuac.tk",
    "jnxjn.com",
    "jnyfyxdhrx85f0rrf.cf",
    "jnyfyxdhrx85f0rrf.ga",
    "jnyfyxdhrx85f0rrf.gq",
    "jnyfyxdhrx85f0rrf.ml",
    "jnyfyxdhrx85f0rrf.tk",
    "jnyveoha.shop",
    "jo-mail.com",
    "jo.pl",
    "jo3b14.info",
    "jo8otki4rtnaf.cf",
    "jo8otki4rtnaf.ga",
    "jo8otki4rtnaf.gq",
    "jo8otki4rtnaf.ml",
    "jo8otki4rtnaf.tk",
    "joajecjb.tech",
    "joajoa.xyz",
    "joakarond.tk",
    "joao.ga",
    "joaquinito01.servehttp.com",
    "joasantos.ga",
    "job-monger.com",
    "job.craigslist.org",
    "job11.fun",
    "job4u.com",
    "jobba.nu",
    "jobbersmartcredit.us",
    "jobbersonline.com",
    "jobbikszimpatizans.hu",
    "jobbsnackisar.com",
    "jobchart.shop",
    "jobdesk.org",
    "jobhm1.site",
    "jobinja.org",
    "jobku.id",
    "joblessness.best",
    "joblike.com",
    "joboak.com",
    "jobposts.net",
    "jobreadyedge.com",
    "jobrpq.us",
    "jobs-to-be-done.net",
    "jobs.photography",
    "jobsaa317.xyz",
    "jobsappmatch.com",
    "jobsblog.africa",
    "jobsenbloc.com",
    "jobsfind.ru",
    "jobssearch.online",
    "jobsunleashed.net",
    "jobsunleashed.vet",
    "jobtoto6.net",
    "jobzzz.ru",
    "jocerset.ru",
    "jodhpurbazar.icu",
    "joe2116.com",
    "joef.de",
    "joelonsoftware.com",
    "joelpet.com",
    "joeltine.com",
    "joeneo.com",
    "joeofarc.com",
    "joeong.com",
    "joepredin.cf",
    "joepredin.gq",
    "joepredin.tk",
    "joerotts.info",
    "joetestalot.com",
    "joeypatino.com",
    "joeystays.info",
    "joforce.us",
    "joggtorra.cf",
    "joggtorra.ga",
    "joggtorra.ml",
    "joggtorra.tk",
    "jogosdemaquiar.info",
    "johanmena.com",
    "johansen.dk",
    "johhgapa.gq",
    "johhgapa.tk",
    "johl.dev",
    "john-doe.cf",
    "john-doe.ga",
    "john-doe.gq",
    "john-doe.ml",
    "john.express",
    "johnalvbage.se",
    "johnathanwelsh.com",
    "johnderasia.com",
    "johndoe.tech",
    "johndollin.info",
    "johnfabio.online",
    "johnftocci.net",
    "johngallant.com",
    "johnhaymond.net",
    "johnhaymondlawfirm.net",
    "johnmagnifico.name",
    "johnmoriarity.com",
    "johnnycondon.com",
    "johnnyduel.com",
    "johnnyimpossible.com",
    "johnpo.cf",
    "johnpo.ga",
    "johnpo.gq",
    "johnpo.ml",
    "johnpo.tk",
    "johnrisky.cf",
    "johnrisky.ga",
    "johnrisky.gq",
    "johnrisky.tk",
    "johnrisky4u.cf",
    "johnrisky4u.ga",
    "johnrisky4u.gq",
    "johnrisky4u.ml",
    "johnrisky4u.tk",
    "johnsfinefoods.com",
    "johnslocalhandyman.com",
    "johntalbotdev.com",
    "johnwickfullmovie.online",
    "johonkemana.com",
    "johonmasalalu.com",
    "join-taxi.ru",
    "join-the-lo-down.net",
    "joinaics.com",
    "joinfunnelprofits.com",
    "joinmanialiga.net",
    "joinmaniaqq.com",
    "joinmaniaqq.global",
    "joinme.com",
    "joinoorddal.gq",
    "joinoorddal.tk",
    "joint-fix.site",
    "joint.website",
    "jointeleport.xyz",
    "jointreniuym.com",
    "jointruvi.com",
    "joinville.tk",
    "joji.site",
    "jojomail.com",
    "jokeengine.com",
    "jokenaka.press",
    "joker-dostavka.ru",
    "jokerbet93.com",
    "jokerbetcasino.xyz",
    "jokerbetgiris.info",
    "jokerdd.com",
    "jokerkard.ru",
    "jokerpoker.best",
    "jokes.com",
    "jokespedia.com",
    "jollydisclosemedal.site",
    "jombase.com",
    "jomiemporium.site",
    "jomo.online",
    "jomusic.live",
    "jonathanbailey.buzz",
    "jonathanbennett.net",
    "jonathanbruner.com",
    "jonathanfrazierphotography.com",
    "jonathanstephenson.buzz",
    "jonotaegi.net",
    "jonotaegi.org",
    "jonrepoza.ml",
    "jonslabaugh.com",
    "joojm.com",
    "joomlaccano.com",
    "joomladome.org",
    "joomlaprofi.ru",
    "joopal.app",
    "joopeerr.com",
    "jopho.com",
    "joplay.com",
    "joplin.xyz",
    "joplindoctors.com",
    "joq7slph8uqu.cf",
    "joq7slph8uqu.ga",
    "joq7slph8uqu.gq",
    "joq7slph8uqu.ml",
    "joq7slph8uqu.tk",
    "joqalbania.net",
    "jordanfitzgerald.buzz",
    "jordanmail.com",
    "jordansneaker.ru",
    "jordansneakers.ru",
    "jorickjuhproductions.shop",
    "jorja344cc.tk",
    "jormout.ml",
    "jormungandr.ru",
    "jornalcarioca.site",
    "jornalcarioca.website",
    "jornalcarioca2019.site",
    "jornalcarioca2019.xyz",
    "jornalcidade.com",
    "jorosc.cf",
    "jorosc.ga",
    "jorosc.gq",
    "jorosc.ml",
    "jorosc.tk",
    "jorysma.xyz",
    "josadelia100.tk",
    "josafeth.com",
    "josalita95.ml",
    "josalyani102.ml",
    "josamadea480.ga",
    "josamanda777.tk",
    "josangel381.ml",
    "josanng.ru",
    "josasjari494.ml",
    "josbet88.cash",
    "josbet88.fun",
    "josdita632.ml",
    "josealamos.info",
    "josefadventures.org",
    "joseihorumon.info",
    "josekacowicz.com",
    "josephdesaram.com",
    "josephjasinski.com",
    "josephswingle.com",
    "josfitrawati410.ga",
    "josfrisca409.tk",
    "josgishella681.cf",
    "josh4jersey.com",
    "joshdanielsphotography.com",
    "joshendriyawati219.tk",
    "joshforjersey.com",
    "joshjoffen.com",
    "joshmanders.dev",
    "joshtucker.net",
    "joshuadweston.com",
    "josivangkia341.tk",
    "josjihaan541.cf",
    "josnarendra746.tk",
    "josnurul491.ga",
    "jososkkssippsos8910292992.epizy.com",
    "josprayugo291.tk",
    "josresa306.tk",
    "josrustam128.cf",
    "josse.ltd",
    "josuajfr.shop",
    "josyahya751.tk",
    "jotmail.ml",
    "jotqo.xyz",
    "jotyaduolchaeol2fu.cf",
    "jotyaduolchaeol2fu.ga",
    "jotyaduolchaeol2fu.gq",
    "jotyaduolchaeol2fu.ml",
    "jotyaduolchaeol2fu.tk",
    "jouasicni.ga",
    "jouasicni.gq",
    "jouasicni.ml",
    "jouasicni.tk",
    "journalismcoursesusa.com",
    "journalist.com",
    "journalistiek.works",
    "journalmy.ru",
    "journeyliquids.com",
    "journeylocal.com",
    "journeys.group",
    "jourrapide.com",
    "jouwbhv.com",
    "jouwplatform.shop",
    "jovem.te.pt",
    "jovianorbit.com",
    "jovo.app",
    "jowabols.com",
    "joybc.net",
    "joycasino-m.net",
    "joycedu.xyz",
    "joyexporthub.info",
    "joyfulczzp.space",
    "joyfullife.style",
    "joygoods.space",
    "joyispain.com",
    "joyledhe.ml",
    "joyledhe.tk",
    "joymail.com",
    "joynet.info",
    "joyoriginalhub.website",
    "joysclick.ru",
    "jp-morgan.cf",
    "jp-morgan.ga",
    "jp-morgan.gq",
    "jp-morgan.ml",
    "jp-news10.net",
    "jp-news12.net",
    "jp-news13.net",
    "jp.bigplanet.com",
    "jp.ftp.sh",
    "jp.hopto.org",
    "jp4420.com",
    "jp4999.com",
    "jp888.com",
    "jpacg.com",
    "jpanel.xyz",
    "jpapa.ooo",
    "jpbum.com",
    "jpchannels.info",
    "jpco.org",
    "jpcservicesinc.com",
    "jpemail.club",
    "jpemail.xyz",
    "jpggh76ygh0v5don1f.cf",
    "jpggh76ygh0v5don1f.ga",
    "jpggh76ygh0v5don1f.gq",
    "jpggh76ygh0v5don1f.ml",
    "jpggh76ygh0v5don1f.tk",
    "jphousecleaningsvcs.com",
    "jpinvest.ml",
    "jpjgroupplc.com",
    "jpjtdv.site",
    "jpleadershipcourse.com",
    "jpmoe.com",
    "jpopmail.com",
    "jppsqc.site",
    "jpsong.com",
    "jpsqcaub.tech",
    "jptb2motzaoa30nsxjb.cf",
    "jptb2motzaoa30nsxjb.ga",
    "jptb2motzaoa30nsxjb.gq",
    "jptb2motzaoa30nsxjb.ml",
    "jptb2motzaoa30nsxjb.tk",
    "jptogel.online",
    "jpuser.com",
    "jpwoxm.info",
    "jpzgjh.org",
    "jq310.site",
    "jq4zdy.com",
    "jq59.xyz",
    "jqblog.com",
    "jqj03.com",
    "jqkaemail.tk",
    "jqkpoker.info",
    "jqkpoker.net",
    "jqkpoker.org",
    "jqlyu.us",
    "jqqwv.site",
    "jqrolmvkq.shop",
    "jqt0wg.info",
    "jquyji.icu",
    "jqvwjo.us",
    "jqweblogs.com",
    "jqwgmzw73tnjjm.cf",
    "jqwgmzw73tnjjm.ga",
    "jqwgmzw73tnjjm.gq",
    "jqwgmzw73tnjjm.ml",
    "jqwgmzw73tnjjm.tk",
    "jqwns2.us",
    "jqx9zy.us",
    "jqyy6.us",
    "jr0emu.host",
    "jr46wqsdqdq.cf",
    "jr46wqsdqdq.ga",
    "jr46wqsdqdq.gq",
    "jr46wqsdqdq.ml",
    "jr46wqsdqdq.tk",
    "jralalk263.tk",
    "jrcs61ho6xiiktrfztl.cf",
    "jrcs61ho6xiiktrfztl.ga",
    "jrcs61ho6xiiktrfztl.gq",
    "jrcs61ho6xiiktrfztl.ml",
    "jrcs61ho6xiiktrfztl.tk",
    "jredm.com",
    "jrejfrrfgkew10.host",
    "jrgkew1.host",
    "jrinkkang97oye.cf",
    "jrjrj4551wqe.cf",
    "jrjrj4551wqe.ga",
    "jrjrj4551wqe.gq",
    "jrjrj4551wqe.ml",
    "jrjrj4551wqe.tk",
    "jrntmenoh.shop",
    "jroxmv.site",
    "jrqtgq.icu",
    "jrrich.info",
    "jrtcwabd.shop",
    "jrudgsqq.shop",
    "jruvz.icu",
    "jryt7555ou9m.cf",
    "jryt7555ou9m.ga",
    "jryt7555ou9m.gq",
    "jryt7555ou9m.ml",
    "jryt7555ou9m.tk",
    "js-fks.com",
    "js10012.com",
    "js10013.com",
    "js10015.com",
    "js33a.com",
    "js99922.com",
    "jscrip.com",
    "jsdbxd.com",
    "jsdwqz.site",
    "jsfc88.com",
    "jsftitle.icu",
    "jsgtdsf12.com",
    "jshrtwg.com",
    "json24.com",
    "jsonp.ro",
    "jspvm.com",
    "jsqcz.com",
    "jsquaredigital.com",
    "jsrqa.us",
    "jsrsolutions.com",
    "jssd.email",
    "jssdikpd.ga",
    "jssghengheng.com",
    "jstarmarketing.com",
    "jstart.com",
    "jstatic.org",
    "jstln.com",
    "jstongge.com",
    "jstzamo.com",
    "jsw119.com",
    "jsweetuni.icu",
    "jswfdb48z.com",
    "jsyant.tokyo",
    "jszmail.com",
    "jt-369.com",
    "jt5ntn.us",
    "jt90.live",
    "jtansa.com",
    "jtcote.net",
    "jtdesantis.org",
    "jtelwb.ml",
    "jtfashionss.com",
    "jtfdirect.com",
    "jtfdiscountclubonline.com",
    "jtfdiscountonline.com",
    "jtfdiscountstore.com",
    "jtfhomeandgarden.com",
    "jtfonline.com",
    "jtfoutlet.com",
    "jtfpromo.com",
    "jtfretailclubonline.com",
    "jtfrgo.site",
    "jtfshopping.com",
    "jtgwpv.site",
    "jtkgatwunk.cf",
    "jtkgatwunk.ga",
    "jtkgatwunk.gq",
    "jtkgatwunk.ml",
    "jtkgatwunk.tk",
    "jtm-2030.com",
    "jtmalwkpcvpvo55.cf",
    "jtmalwkpcvpvo55.ga",
    "jtmalwkpcvpvo55.gq",
    "jtmalwkpcvpvo55.ml",
    "jtmalwkpcvpvo55.tk",
    "jto.kr",
    "jtovjcat.shop",
    "jtpcgg.us",
    "jtrcc.us",
    "jtst.dev",
    "jtvtad.tokyo",
    "jtwnfc.icu",
    "jtzjsc.com",
    "juarabola.org",
    "juarabola.site",
    "juarakiukiu.com",
    "jubii.dk",
    "jubiichat.dk",
    "jubiiconnect.dk",
    "jubiigames.dk",
    "jubiimail.dk",
    "jubiipost.dk",
    "jubiipostadresse.dk",
    "jubilate.site",
    "judabla.cf",
    "judabla.ga",
    "judabla.tk",
    "juddcomm.com",
    "judethomas.info",
    "judgedoug.us",
    "judgeweav.xyz",
    "judglarsting.cf",
    "judglarsting.ml",
    "judglarsting.tk",
    "judgteso.cf",
    "judgteso.ga",
    "judgteso.tk",
    "judibola118.com",
    "judicialnetwork.org",
    "judiking4d.net",
    "judipasar.online",
    "judipasar.site",
    "judipasar.xyz",
    "judiremi.com",
    "judybernard.com",
    "jue.lu",
    "jueg.app",
    "juegabet.net",
    "juegos.ninja",
    "jug1.com",
    "jugglepile.com",
    "juhuagu.net",
    "juicephoenixmedia.site",
    "juiceyvapemods.com",
    "juicynewsdaily.club",
    "juikonaser.tk",
    "juiupsnmgb4t09zy.cf",
    "juiupsnmgb4t09zy.ga",
    "juiupsnmgb4t09zy.gq",
    "juiupsnmgb4t09zy.ml",
    "juiupsnmgb4t09zy.tk",
    "jujuspot.com",
    "julaha.xyz",
    "julc4a.us",
    "juliafinnegan.com",
    "julian.buzz",
    "juliaotilia.cloud",
    "juliawang.online",
    "juliman.me",
    "jullieta.info",
    "jullieta.net",
    "julnic.ru",
    "julymovo.com",
    "juma.store",
    "jumaelda4846.ml",
    "jumanindya8240.cf",
    "jumaprilia4191.cf",
    "jumba.shop",
    "jumbo-casino.com",
    "jumbo-chinese.com",
    "jumbo4d.club",
    "jumbunga3502.cf",
    "jumeiliangpin.com",
    "jumgita6884.tk",
    "jumlatifani8910.tk",
    "jummario7296.ml",
    "jummayang1472.ml",
    "jumnia4726.ga",
    "jumnoor4036.ga",
    "jumnugroho6243.cf",
    "jumonji.tk",
    "jumossi51.ml",
    "jump.com",
    "jumpdada.com",
    "jumperhighs.ru",
    "jumperocio.com",
    "jumpmicro.com",
    "jumponopgq.space",
    "jumps.online",
    "jumpvillagelest.website",
    "jumpy.it",
    "jumpy5678.cf",
    "jumpy5678.ga",
    "jumpy5678.gq",
    "jumpy5678.ml",
    "jumpy5678.tk",
    "jumrestia9994.ga",
    "jumreynard5211.ml",
    "jumreza258.tk",
    "jumveronica8959.tk",
    "jun8yt.cf",
    "jun8yt.ga",
    "jun8yt.gq",
    "jun8yt.ml",
    "jun8yt.tk",
    "junaudio.site",
    "juncoarte.com",
    "junctiondx.com",
    "junemovo.com",
    "jungkamushukum.com",
    "jungle-experience-kp.com",
    "junior-rowing.com",
    "juniorcarrillo.tech",
    "junioriot.net",
    "juniormail.com",
    "junk.beats.org",
    "junk.googlepedia.me",
    "junk.ihmehl.com",
    "junk.noplay.org",
    "junk.to",
    "junk.vanillasystem.com",
    "junk.yourdomain.com",
    "junk1e.com",
    "junkmail.com",
    "junkmail.ga",
    "junkmail.gq",
    "junkmassarie.com",
    "junkouture.com",
    "junkyardpalmdale.com",
    "junnuok.com",
    "juno.com",
    "junostore.site",
    "junrecetas.com",
    "juntaupwardmercy.site",
    "juo.com",
    "juoksutek.com",
    "jupimail.com",
    "jupiterblock.com",
    "jupiterlab.ml",
    "jupiterm.com",
    "jur-likbez.ru",
    "jurabet101.com",
    "jurabet102.com",
    "jurabet103.com",
    "jurcasinorock.ru",
    "jurgisdidziulis.com",
    "jurnaliki.com",
    "jurrevhvn.shop",
    "jurvansuu.org",
    "jusdawho.tk",
    "jusefuli.club",
    "jusefuli.info",
    "jusefuli.life",
    "jusefuli.xyz",
    "jusemao.xyz",
    "juski.site",
    "jusomoa05.com",
    "jusomoa06.com",
    "just-email.com",
    "just-games.ru",
    "just-newsit.site",
    "just.partners",
    "just4spam.com",
    "justademo.cf",
    "justbaavideos.com",
    "justbegood.pw",
    "justbet.world",
    "justblueclubappnew.ru",
    "justbrewit.org",
    "justcook.su",
    "justdeals.net",
    "justdoiit.com",
    "justdoit132.cf",
    "justdoit132.ga",
    "justdoit132.gq",
    "justdoit132.ml",
    "justdoit132.tk",
    "justemail.ml",
    "justemail.net",
    "justen.rocks",
    "justenmartin.dev",
    "justforclicks.com",
    "justfun88.com",
    "justgetitdone.vision",
    "justice.gov.za",
    "justiceacrossborders.org",
    "justicemail.com",
    "justicewoodworks.com",
    "justifans.ru",
    "justin.reviews",
    "justinachang.com",
    "justinbet.fun",
    "justinet237.com",
    "justintv.us",
    "justitnews.site",
    "justjuss.shop",
    "justlynhfks.email",
    "justmagicalevents.org",
    "justmail.de",
    "justmailorderbrides.com",
    "justmailz.com",
    "justmarriedmail.com",
    "justmiret.site",
    "justmysocks5.net",
    "justmysocks6.net",
    "justmysocks7.net",
    "justnope.com",
    "justnowmail.com",
    "justoldschool.com",
    "juston-latinbeat.com",
    "justonemail.net",
    "justonetworks.site",
    "justpositiveweblog.club",
    "justreadit.ru",
    "justruninabox.com",
    "justsend.online",
    "justshoes.gq",
    "justtoy.ru",
    "justweddingband.com",
    "justxxx.site",
    "justyland.ru",
    "juts.us",
    "juusbaa.com",
    "juveajon.cf",
    "juveajon.ga",
    "juveajon.gq",
    "juveajon.tk",
    "juvenileeatingdisordertreatment.com",
    "juventudecuatoriana.com",
    "juxtaposejs.com",
    "juyouxi.com",
    "juyuncai.com",
    "juzfc.us",
    "jv6hgh1.com",
    "jv7ykxi7t5383ntrhf.cf",
    "jv7ykxi7t5383ntrhf.ga",
    "jv7ykxi7t5383ntrhf.gq",
    "jv7ykxi7t5383ntrhf.ml",
    "jv7ykxi7t5383ntrhf.tk",
    "jv9wdq.us",
    "jvdailypick.com",
    "jvhclpv42gvfjyup.cf",
    "jvhclpv42gvfjyup.ml",
    "jvhclpv42gvfjyup.tk",
    "jvimail.com",
    "jvk84x-mail.xyz",
    "jvlbigband.ru",
    "jvlicenses.com",
    "jvo5iw.us",
    "jvoqotvi.tech",
    "jvsdailypick.com",
    "jvswoznq.shop",
    "jvvr.email",
    "jvx21.com",
    "jvyomi.icu",
    "jvz18.com",
    "jw-hot.com",
    "jwcdi.com",
    "jwf.email",
    "jwguanacastegolf.com",
    "jwheim.com",
    "jwk4227ufn.com",
    "jwl3uabanm0ypzpxsq.cf",
    "jwl3uabanm0ypzpxsq.ga",
    "jwl3uabanm0ypzpxsq.gq",
    "jwom.ru",
    "jwork.ru",
    "jwoug2rht98plm3ce.cf",
    "jwoug2rht98plm3ce.ga",
    "jwoug2rht98plm3ce.ml",
    "jwoug2rht98plm3ce.tk",
    "jwoxy.com",
    "jwptesiiv.shop",
    "jwpwnzobs.shop",
    "jwsei.club",
    "jwtukew1xb1q.cf",
    "jwtukew1xb1q.ga",
    "jwtukew1xb1q.gq",
    "jwtukew1xb1q.ml",
    "jwtukew1xb1q.tk",
    "jx-club.ru",
    "jx2team.online",
    "jx575.com",
    "jx576.com",
    "jxcp365.com",
    "jxcyzw.com",
    "jxfpbv.icu",
    "jxgj777.com",
    "jxgqkw.site",
    "jxji.top",
    "jxjyi.com",
    "jxoo.us",
    "jxsbby.com",
    "jxyh168.com",
    "jxyzu.com",
    "jy.biz",
    "jycaqi.info",
    "jyde.dk",
    "jydocnqz.shop",
    "jyecuh.cf",
    "jyh2888.com",
    "jyliananderik.com",
    "jymfit.info",
    "jymu.site",
    "jyn4.us",
    "jypm5.us",
    "jyrbayli9jezk4i.xyz",
    "jyrki.me",
    "jytwf.icu",
    "jyy66.space",
    "jyzaustin.com",
    "jyzhuji.com",
    "jz118899.com",
    "jzcfto.us",
    "jzfswn.com",
    "jzhkby.us",
    "jziad5qrcege9.cf",
    "jziad5qrcege9.ga",
    "jziad5qrcege9.gq",
    "jziad5qrcege9.ml",
    "jziad5qrcege9.tk",
    "jzkn1.us",
    "jzxsportgw.xyz",
    "jzxsportipom.xyz",
    "k-12stem.org",
    "k-d-m.de",
    "k-l-k.ru",
    "k-mail.top",
    "k-response.com",
    "k.fido.be",
    "k.ro",
    "k.schimu.com",
    "k02sx.com",
    "k0mzao.us",
    "k0ujhl.us",
    "k105.club",
    "k1069.com",
    "k111.club",
    "k115.club",
    "k11wf.com",
    "k12hw.net",
    "k15ri.space",
    "k17tcth11b.me",
    "k1bob.com",
    "k1etvm.us",
    "k1ftcgr8.xyz",
    "k1h6cy.info",
    "k2-herbal-incenses.com",
    "k2-zero.com",
    "k2dfcgbld4.cf",
    "k2dfcgbld4.ga",
    "k2dfcgbld4.gq",
    "k2dfcgbld4.ml",
    "k2dfcgbld4.tk",
    "k2eztto1yij4c.cf",
    "k2eztto1yij4c.ga",
    "k2eztto1yij4c.gq",
    "k2eztto1yij4c.ml",
    "k2eztto1yij4c.tk",
    "k2idacuhgo3vzskgss.cf",
    "k2idacuhgo3vzskgss.ga",
    "k2idacuhgo3vzskgss.gq",
    "k2idacuhgo3vzskgss.ml",
    "k2idacuhgo3vzskgss.tk",
    "k2kgab2uxxpoiwg.xyz",
    "k31wsx.us",
    "k33s.club",
    "k34k.com",
    "k3663a40w.com",
    "k3bbgnk72oake6e.xyz",
    "k3opticsf.com",
    "k3rx8f.us",
    "k3tfb8.us",
    "k3wa8y-mail.xyz",
    "k3zaraxg9t7e1f.cf",
    "k3zaraxg9t7e1f.ga",
    "k3zaraxg9t7e1f.gq",
    "k3zaraxg9t7e1f.ml",
    "k3zaraxg9t7e1f.tk",
    "k4afcp-mail.xyz",
    "k4ds.org",
    "k4exffd51yzwu77.xyz",
    "k4fl2v.us",
    "k4tbtqa7ag5m.cf",
    "k4tbtqa7ag5m.ga",
    "k4tbtqa7ag5m.gq",
    "k4tbtqa7ag5m.ml",
    "k4tbtqa7ag5m.tk",
    "k59ula.info",
    "k60.info",
    "k6556.com",
    "k6g4mvd5.xyz",
    "k78qp.com",
    "k7k5tuccmaptnsc.xyz",
    "k80fv.space",
    "k82323.com",
    "k84r5e.us",
    "k8bnfweqq.xyz",
    "k8dwsb.us",
    "k8r0ml.us",
    "k8w329-mail.xyz",
    "k95iqh.com",
    "k9ifse3ueyx5zcvmqmw.cf",
    "k9ifse3ueyx5zcvmqmw.ga",
    "k9ifse3ueyx5zcvmqmw.ml",
    "k9ifse3ueyx5zcvmqmw.tk",
    "k9teens.com",
    "ka-naslednik.ru",
    "ka1ovm.net",
    "ka9kckl07g0erfh.xyz",
    "kaafein.com",
    "kaakaao.com",
    "kaaleej.com",
    "kaapiroyalecoffee.com",
    "kaaw39hiawtiv1.ga",
    "kaaw39hiawtiv1.gq",
    "kaaw39hiawtiv1.ml",
    "kaaw39hiawtiv1.tk",
    "kaazoo.com",
    "kabarunik.xyz",
    "kabelmail.de",
    "kabirsigh.ga",
    "kabissa.org",
    "kablee.net",
    "kabukio.com",
    "kabumarkets.site",
    "kachargina.ru",
    "kaconri.cf",
    "kaconri.gq",
    "kaconri.ml",
    "kaconri.tk",
    "kad00.cf",
    "kad00.ga",
    "kad00.gq",
    "kad00.ml",
    "kad01.cf",
    "kad01.ga",
    "kad01.gq",
    "kad01.ml",
    "kad02.cf",
    "kad02.ga",
    "kad02.gq",
    "kad02.ml",
    "kad03.cf",
    "kad03.ga",
    "kad03.gq",
    "kad03.ml",
    "kad04.cf",
    "kad04.ga",
    "kad04.gq",
    "kad04.ml",
    "kad11.cf",
    "kad11.ga",
    "kad11.gq",
    "kad11.ml",
    "kad14.cf",
    "kad14.ga",
    "kad14.ml",
    "kad15.cf",
    "kad15.ga",
    "kad15.ml",
    "kadag.ir",
    "kademen.com",
    "kadeshop.site",
    "kadett-e.info",
    "kadingir.org",
    "kadinsibakis.online",
    "kadinsibakis.xyz",
    "kadokatelco.com",
    "kadokawa.cf",
    "kadokawa.ga",
    "kadokawa.gq",
    "kadokawa.ml",
    "kadokawa.tk",
    "kadokawa.top",
    "kadrajmagazin.xyz",
    "kaduku.net",
    "kadw.xyz",
    "kaefv.us",
    "kaengu.ru",
    "kaewvscnb.shop",
    "kaffeeschluerfer.com",
    "kaffeeschluerfer.de",
    "kagi.be",
    "kagta0.us",
    "kaguya.tk",
    "kah.pw",
    "kahndefense.com",
    "kahootninja.com",
    "kahramanmarashaberler.xyz",
    "kahramanmarasprefabrikyapi.xyz",
    "kaialiikahele.com",
    "kaidh.xyz",
    "kaijenwan.com",
    "kailaitakeaway.com",
    "kaiqumb.com",
    "kairo-lottery.info",
    "kairo-lottery.net",
    "kaisa365.org",
    "kaishinkaidojoseattle.com",
    "kaiwh.us",
    "kaixo.com",
    "kaj3goluy2q.cf",
    "kaj3goluy2q.ga",
    "kaj3goluy2q.gq",
    "kaj3goluy2q.ml",
    "kaj3goluy2q.tk",
    "kajgnpuan.shop",
    "kak-gotovit-prosto.ru",
    "kak-gotovit-vkusno.ru",
    "kakadua.net",
    "kakao.world",
    "kakasgp.info",
    "kakashi1223e.cf",
    "kakashi1223e.ga",
    "kakashi1223e.ml",
    "kakashi1223e.tk",
    "kaku92.com",
    "kaku97.com",
    "kalagar.net",
    "kalamani.website",
    "kalapi.org",
    "kalebet519.com",
    "kalebet530.com",
    "kalebet541.com",
    "kalebet544.com",
    "kalebet546.com",
    "kalebet550.com",
    "kalebor.com",
    "kalemproje.com",
    "kalford.best",
    "kalifragilistic.us",
    "kalitebet4.com",
    "kalitebet6.com",
    "kalitebet9.com",
    "kalixfinans.se",
    "kaljakartta.com",
    "kalmhain.net",
    "kaloolas.shop",
    "kalpoint.com",
    "kalsesli.xyz",
    "kaltimpoker.com",
    "kalvertgroup.com",
    "kalyanhut.ru",
    "kamagraoraljelly.website",
    "kamchajeyf.space",
    "kamclip.ru",
    "kamen-market.ru",
    "kamenrider.ru",
    "kamhl.com",
    "kamibakier.com",
    "kamin-hous.ru",
    "kamin-portal.ru",
    "kamismail.com",
    "kamostand.site",
    "kampoeng3d.club",
    "kampouts.com",
    "kampspor.com",
    "kampwa.com",
    "kamsg.com",
    "kamu-sudahh.top",
    "kamuihale.org",
    "kamvoda.site",
    "kamx0-nacal.ru",
    "kan2222.com",
    "kana-entertainment.com",
    "kana420.site",
    "kanansoldit.com",
    "kanbantasks.com",
    "kanciang.faith",
    "kandidoz.info",
    "kandrai.tips",
    "kandymail.com",
    "kanganstx.net",
    "kangcaiwang.xyz",
    "kangeasy.com",
    "kangenlifetime.com",
    "kangenshui.com",
    "kangentruewealth.com",
    "kangenwaterpilipinas.com",
    "kangirl.com",
    "kangkunk44lur.cf",
    "kangmipon.cf",
    "kangmipon.ga",
    "kangmipon.gq",
    "kangmipon.ml",
    "kangmipon.tk",
    "kangsmo.ru",
    "kanjiukan.com",
    "kankabal.com",
    "kanker.website",
    "kanmathi.shop",
    "kannapolisdentists.com",
    "kanokla.net",
    "kanoodle-navan.com",
    "kansasboas.com",
    "kansascity.com",
    "kansascitypigrescue.org",
    "kansasquote.com",
    "kanum-thai-park-west.com",
    "kanzanishop.com",
    "kanzhubo.xyz",
    "kaodesar.tk",
    "kaoqwr.us",
    "kaovo.com",
    "kaoyoo.group",
    "kaoyoo.net",
    "kaphoe.site",
    "kapitalbuks.ru",
    "kapitulin.ru",
    "kapnik.ru",
    "kapody.info",
    "kapoorweb.com",
    "kappala.info",
    "kapptiger.com",
    "kapstroyservice.ru",
    "kaptina.ru",
    "kaptsittia.cf",
    "kaptsittia.gq",
    "kaptsittia.ml",
    "kaptsittia.tk",
    "kapumamatata.cf",
    "kapumamatata.ga",
    "kapumamatata.gq",
    "kapumamatata.ml",
    "kapumamatata.tk",
    "kapustanet.ru",
    "karabas777.ru",
    "karabukburada.xyz",
    "karabukciceksiparisi.xyz",
    "karabukluyuz.xyz",
    "karachian.com",
    "karachioye.com",
    "karadiners.site",
    "karam.host",
    "karamanbasari.xyz",
    "karamanrehber.xyz",
    "karamansoneremlak.com",
    "karamanvitrin.xyz",
    "karamelbilisim.com",
    "karangtelurvusuk-store21.com",
    "karaoke-spider.ru",
    "karaokemike.ru",
    "karatebeltsanduniforms.com",
    "karateuniformsandbelts.com",
    "karatraman.ml",
    "karbasi.com",
    "karbonbet.com",
    "karcherpremium.online",
    "kareemshammout.com",
    "kareicon.org",
    "karel-bani.ru",
    "karenbarnaby.com",
    "karengostudy.com",
    "kareto.xyz",
    "karfashion.store",
    "karibbalakata.cf",
    "karibbalakata.ga",
    "karibbalakata.gq",
    "karibbalakata.ml",
    "karibbalakata.tk",
    "karibu-piratai.ru",
    "karichisholm.com",
    "karinmk-wolf.eu",
    "kariotor.online",
    "kariplan.com",
    "karitas.com.br",
    "karizmakala.com",
    "karkaspen.ru",
    "karldeleon.com",
    "karma.show",
    "karnali.best",
    "karnatakaedu.info",
    "karofur.online",
    "karou.best",
    "karovale3.com",
    "karpathos.sk",
    "karpsr.site",
    "karsers.ru",
    "karsiyakadenizsurucukursu.com",
    "karsiyakaeml.xyz",
    "karso.info",
    "karster.site",
    "karta-kykyruza.ru",
    "karta-tahografa.ru",
    "kartal-store.com",
    "kartalodge.xyz",
    "kartaskiipim.com",
    "kartel46.ru",
    "kartinari65.club",
    "kartinohigh.ru",
    "kartk5.com",
    "kartpardakht.xyz",
    "kartsitze.de",
    "kartu8m.com",
    "kartu8m.org",
    "kartugaple.org",
    "kartuhoki.biz",
    "kartujituceme.com",
    "kartuliga.poker",
    "kartupoker.us",
    "karturoyalking.com",
    "kartustraightflush.com",
    "kartvelo.com",
    "kartvelo.me",
    "karuniapoker.net",
    "karusel-kard.ru",
    "karuselsp.ru",
    "karya4d.org",
    "karyatogel.net",
    "karyatoto.com",
    "karyatoto.net",
    "karzpay.xyz",
    "kas-cenas.com",
    "kasak.cf",
    "kasankanationalpark.org",
    "kasdelta.ru",
    "kaserdase.cf",
    "kaseroutr.cf",
    "kasevdeneve.online",
    "kasevdeneve.xyz",
    "kaseyshop.com",
    "kashel.info",
    "kashenko.site",
    "kashmirindian.com",
    "kasian.ru",
    "kasiatee.com",
    "kasilohiter.website",
    "kasino-spin-city.online",
    "kasking33.com",
    "kasko-group.ru",
    "kasmabirader.com",
    "kasmail.com",
    "kasmirkebabhouse.com",
    "kaspop.com",
    "kassenbon.cloud",
    "kastamonugezi.xyz",
    "kastamonuyogder.xyz",
    "kastapolikas.ga",
    "kastavillam.xyz",
    "kastnomiu.gq",
    "kastsono.cf",
    "kastsono.gq",
    "kasucako.site",
    "katakidz.com",
    "katamail.com",
    "katamo1.com",
    "katarinakp.se",
    "katava.ru",
    "katcang.tk",
    "katergizmo.de",
    "katesport.club",
    "katherinemurphy55places.com",
    "katherineyan.dev",
    "kathleenkellet.com",
    "kathmandumart.net",
    "kathymackechney.com",
    "kathyschneiders.com",
    "kathysthings.com",
    "katie11muramats.ga",
    "katieclemens.com",
    "katieclemons.net",
    "katieclemons.org",
    "katiina.com",
    "katipo.ru",
    "katipunankrafts.com",
    "katlas.best",
    "katra.ovh",
    "kattenstore.com",
    "kattmanmusicexpo.com",
    "katwassenaar.com",
    "katztube.com",
    "katzwyfy.shop",
    "kaudat.com",
    "kaufshop.ru",
    "kauinginpergi.cf",
    "kauinginpergi.ga",
    "kauinginpergi.gq",
    "kauinginpergi.ml",
    "kavabox.com",
    "kavbc6fzisxzh.cf",
    "kavbc6fzisxzh.ga",
    "kavbc6fzisxzh.gq",
    "kavbc6fzisxzh.ml",
    "kavbc6fzisxzh.tk",
    "kavbet70.com",
    "kavbet71.com",
    "kavbet72.com",
    "kavisto.ru",
    "kavory.site",
    "kavysy.info",
    "kawaiishojo.com",
    "kawasakihavaliyedekparca.com",
    "kawu.site",
    "kaxks55ofhkzt5245n.cf",
    "kaxks55ofhkzt5245n.ga",
    "kaxks55ofhkzt5245n.gq",
    "kaxks55ofhkzt5245n.ml",
    "kaxks55ofhkzt5245n.tk",
    "kayafmmail.co.za",
    "kayaqq.com",
    "kaye.ooo",
    "kaygob.info",
    "kayipesyadepolari.com",
    "kaykaykay.net",
    "kaymima.ga",
    "kaymima.gq",
    "kaymima.ml",
    "kayserigirls.com",
    "kayserisucuklari.xyz",
    "kayvsj.us",
    "kazaf.ru",
    "kazan-elki.ru",
    "kazan-hotel.com",
    "kazansana47.com",
    "kazansana57.com",
    "kazelink.ml",
    "kazimirovo.ru",
    "kazinocorona.com",
    "kazper.net",
    "kb-222.com",
    "kb7.app",
    "kb7h1.us",
    "kbaf2v.us",
    "kbakvkwvsu857.cf",
    "kbbxowpdcpvkxmalz.cf",
    "kbbxowpdcpvkxmalz.ga",
    "kbbxowpdcpvkxmalz.gq",
    "kbbxowpdcpvkxmalz.ml",
    "kbbxowpdcpvkxmalz.tk",
    "kbcfikhyh.shop",
    "kbclu.us",
    "kbdevelop.net",
    "kbdjvgznhslz.ga",
    "kbdjvgznhslz.ml",
    "kbdjvgznhslz.tk",
    "kbellebeauty.com",
    "kbhufd.site",
    "kbjnx1.site",
    "kbjrmail.com",
    "kblaoshi.com",
    "kblim.us",
    "kbmei.com",
    "kbox.li",
    "kbscnp.tokyo",
    "kbt-234.com",
    "kbt-33.com",
    "kbt-345.com",
    "kbt-365.com",
    "kbt-55.com",
    "kbtblh.com",
    "kbvqfr.com",
    "kbwventures.com",
    "kbzdl1.site",
    "kc-leasemanagement.com",
    "kc-ufa.ru",
    "kc.rr.com",
    "kc123app.com",
    "kc2888.com",
    "kc3fsx.net",
    "kc59.xyz",
    "kc6888.com",
    "kc9888.com",
    "kc9983.com",
    "kc9985.com",
    "kcba.xyz",
    "kcdrivewaysealing.com",
    "kcf7lv.us",
    "kchkch.com",
    "kcks.com",
    "kcldps.tokyo",
    "kclkuiah.xyz",
    "kcorcm.site",
    "kcrw.de",
    "kcs-th.com",
    "kctoto.site",
    "kcuxfb.us",
    "kcxdi2.com",
    "kcyjfp.rest",
    "kd-attractive-bg.site",
    "kdc.support",
    "kdeos.ru",
    "kdfgedrdf57mmj.ga",
    "kdgpht.site",
    "kdgreat.ru",
    "kdh.kiwi",
    "kdjfvkdf8.club",
    "kdjngsdgsd.tk",
    "kdk-opt.ru",
    "kdl8zp0zdh33ltp.ga",
    "kdl8zp0zdh33ltp.gq",
    "kdl8zp0zdh33ltp.ml",
    "kdl8zp0zdh33ltp.tk",
    "kdpgzzh.com",
    "kdpxae.com",
    "kdrplast.com",
    "kdswdg.host",
    "kdtuo.live",
    "kdublinstj.com",
    "kdwaxdzt.shop",
    "kdweed.com",
    "ke3981.com",
    "ke3996.com",
    "ke3999.com",
    "ke4004.com",
    "ke4005.com",
    "ke4006.com",
    "ke4008.com",
    "keatonbeachproperties.com",
    "keauhoubayresort.com",
    "keauhouresortandspa.com",
    "kebab-house-takeaway.com",
    "kebabamirsafriedchickenmadrid.com",
    "kebabestambulvalenzabarbadas.com",
    "kebabgironacoloma.com",
    "kebabhouse-kilkenny.com",
    "kebabhouse-laois.com",
    "kebabishcosladacoslada.com",
    "kebi.com",
    "kebl0bogzma.ga",
    "kec59.xyz",
    "kecaleki.site",
    "kecambahijo89klp.ml",
    "kecasinos.com",
    "ked6f9.us",
    "kedikumu.net",
    "kedipansiyonu.net",
    "kedrovskiy.ru",
    "kedwo.top",
    "kedy6.us",
    "keecalculator.com",
    "keeleproperties.com",
    "keeleranderson.net",
    "keelungqq59.xyz",
    "keemail.me",
    "keeperr.ru",
    "keepillinoisbeautiful.org",
    "keeplucky.pw",
    "keepmymail.com",
    "keepmyshitprivate.com",
    "keepntg.tk",
    "keepoor.com",
    "keepsave.club",
    "keepthebest.com",
    "keeptoolkit.com",
    "keepyourshitprivate.com",
    "keftamail.com",
    "kefyci.info",
    "keg-party.com",
    "kegangraves.club",
    "kegangraves.online",
    "kegangraves.org",
    "kegangraves.site",
    "kegangraves.us",
    "kegangraves.xyz",
    "kehangatan.ga",
    "kehonkoostumusmittaus.com",
    "kein.hk",
    "keinhirn.de",
    "keinpardon.de",
    "keipino.de",
    "keiqpm.site",
    "keiraicumb.cf",
    "keiraicumb.ga",
    "keistopdow.ga",
    "keistopdow.gq",
    "keistopdow.tk",
    "keite-ro1.info",
    "keithbukoski.com",
    "keithurbanmates.net",
    "keizercentral.com",
    "kejenx.com",
    "kejw1t.us",
    "kek.institute",
    "kekecog.com",
    "kekita.com",
    "keko.com.ar",
    "kekote.xyz",
    "keks.page",
    "kelasio.website",
    "kelaskonversi.com",
    "kellerslableakcompanies.site",
    "kelleyships.com",
    "kelloggchurch.org",
    "kellychen.com",
    "kellyodwyer.ca",
    "kellyodwyer.net",
    "kellyrandin.com",
    "keloahdsk12.xyz",
    "kelosolor.com",
    "kelseyball.com",
    "kelseyball.xyz",
    "keluargabesarpeduli.club",
    "keluruk.fun",
    "kemailuo.com",
    "kemampuan.me",
    "kematary.ru",
    "kembangpasir.website",
    "kemeneur.org",
    "kemerhanotel.xyz",
    "kemexet.ru",
    "kemonkoreeitaholoto.tk",
    "kemptvillebaseball.com",
    "kemska.pw",
    "kemulastalk.https443.org",
    "kenal-saya.ga",
    "kenaripoker.info",
    "kendralust.club",
    "kendrickzhu.xyz",
    "kenecrehand.port25.biz",
    "kenhdeals.com",
    "kenhgiamgia.website",
    "kenhqpvn.net",
    "kenmaar.com",
    "kennebunkportems.org",
    "kennedy808.com",
    "kennethpaskett.name",
    "kenney.codes",
    "kennysmusicbox.com",
    "kenshuwo.com",
    "kenspeckle.site",
    "kentbtt.com",
    "kenticocheck.xyz",
    "kentspurid.cf",
    "kentspurid.ga",
    "kentspurid.gq",
    "kentspurid.ml",
    "kentspurid.tk",
    "kenttenhaber.xyz",
    "kentucky-inc.com",
    "kentucky-indianalumber.com",
    "kentuckygamerss.com",
    "kentuckyopiaterehab.com",
    "kenvanharen.com",
    "kenwestlund.com",
    "kenyamedicine.com",
    "kenyanfoodtx.us",
    "kenyangsekali.com",
    "kenyayouth.org",
    "kenzo-official.ru",
    "kenzoget.club",
    "kenzototo.site",
    "keortge.org",
    "keosdevelopment.com",
    "kepeznakliyat.com",
    "kepeztesisat.xyz",
    "kepezun.xyz",
    "keptprivate.com",
    "keqptg.com",
    "keralaairport.net",
    "keraladinam.com",
    "keralamserials.com",
    "keralapoliticians.com",
    "keralaproperty123.com",
    "keramzit-komi.ru",
    "keraorganica.ru",
    "kerasine.xyz",
    "keratontoto.info",
    "kerchboxing.ru",
    "kerclivhuck.tk",
    "kerfuffle.me",
    "kerithbrookretreat.org",
    "kerjqv.us",
    "kermancerafair.com",
    "kernersvilleapartments.com",
    "keromail.com",
    "kerrytonys.info",
    "kershostter.cf",
    "kershostter.ga",
    "kershostter.tk",
    "kersp.lat",
    "kertasqq.com",
    "kerupukmlempem.ml",
    "kerupukmlempem.tk",
    "kerupukmlempem1.cf",
    "kerupukmlempem1.ga",
    "kerupukmlempem2.cf",
    "kerupukmlempem3.cf",
    "kerupukmlempem3.ml",
    "kerupukmlempem4.cf",
    "kerupukmlempem4.ml",
    "kerupukmlempem5.cf",
    "kerupukmlempem6.cf",
    "kerupukmlempem6.ml",
    "kerupukmlempem7.cf",
    "kerupukmlempem7.ga",
    "kerupukmlempem8.ga",
    "kerupukmlempem9.cf",
    "kesepara.com",
    "kesfiru.cf",
    "kesfiru.ga",
    "kesfiru.gq",
    "kesfiru.ml",
    "kesiqadi.club",
    "kesports.net",
    "ketababan.com",
    "ketabsar.com",
    "ketcauviet.website",
    "ketiksms.club",
    "keto4life.media",
    "ketoblazepro.com",
    "ketocorner.net",
    "ketodietbasics.org",
    "ketodrinks.org",
    "ketoflashfitclub.com",
    "ketogenicrecipe.club",
    "ketoke.info",
    "ketonedealer.com",
    "ketonewstrends.com",
    "ketorezepte24.com",
    "ketoultramax.com",
    "ketoxprodiet.net",
    "ketpgede.ga",
    "ketpgede.ml",
    "ketsode.gq",
    "ketsode.tk",
    "kettcopla.cf",
    "kettcopla.ga",
    "kettcopla.gq",
    "kettcopla.ml",
    "ketule.info",
    "keuad.us",
    "keupartlond.cf",
    "keupartlond.gq",
    "keupartlond.ml",
    "keupartlond.tk",
    "keverb-vreivn-wneff.online",
    "kevertio.ml",
    "kevertio.tk",
    "kevincramp.com",
    "kevinekaputra.com",
    "kevinhanes.net",
    "kevinkrout.com",
    "kevinschneller.com",
    "kevintrankt.com",
    "kevm.org",
    "kevu.site",
    "kewkece.com",
    "kewpee.com",
    "kewrg.com",
    "kewupy.info",
    "kexi.info",
    "kexukexu.xyz",
    "key--biscayne.com",
    "key-mail.net",
    "key2funnels.com",
    "keyboardsshop.life",
    "keydcatvi.cf",
    "keydcatvi.ga",
    "keydcatvi.ml",
    "keydcatvi.tk",
    "keyemail.com",
    "keyesrealtors.tk",
    "keygenninjas.com",
    "keyifiptv.com",
    "keykeykelyns.cf",
    "keykeykelyns.ga",
    "keykeykelyns.gq",
    "keykeykelyns.ml",
    "keykeykelyns.tk",
    "keykeykelynss.cf",
    "keykeykelynss.ga",
    "keykeykelynss.gq",
    "keykeykelynss.ml",
    "keykeykelynss.tk",
    "keykeykelynsss.cf",
    "keykeykelynsss.ga",
    "keykeykelynsss.gq",
    "keykeykelynsss.ml",
    "keykeykelynsss.tk",
    "keykeykelynz.cf",
    "keykeykelynz.ga",
    "keykeykelynz.gq",
    "keykeykelynz.ml",
    "keykeykelynz.tk",
    "keynote.com",
    "keynoteplanner.com",
    "keyprocal.cf",
    "keyprocal.ml",
    "keyprocal.tk",
    "keyritur.gq",
    "keyritur.ml",
    "keyritur.tk",
    "keysbb.com",
    "keysinspectorinc.com",
    "keysmedia.org",
    "keystonemoldings.com",
    "keytarbear.net",
    "keywestmuseum.com",
    "keywestrealestateagents.com",
    "keywordhub.com",
    "keyzerbuilding.com",
    "kf2ddmce7w.cf",
    "kf2ddmce7w.ga",
    "kf2ddmce7w.gq",
    "kf2ddmce7w.ml",
    "kf2ddmce7w.tk",
    "kf8037.com",
    "kfcbet.asia",
    "kffjf.live",
    "kfgretgf.site",
    "kfhgrftcvd.cf",
    "kfhgrftcvd.ga",
    "kfhgrftcvd.gq",
    "kfhgrftcvd.ml",
    "kfhgrftcvd.tk",
    "kfs92.space",
    "kftdcmmn.shop",
    "kg-happy-pt.site",
    "kg1cz7xyfmps.cf",
    "kg1cz7xyfmps.gq",
    "kg1cz7xyfmps.tk",
    "kg4dtgl.info",
    "kgalagaditransfrontier.com",
    "kgb-rsfsr.su",
    "kgb-sssr.su",
    "kgb.hu",
    "kgcglobal.com",
    "kgcp11.com",
    "kgcp55.com",
    "kgcp88.com",
    "kgduw2umqafqw.ga",
    "kgduw2umqafqw.ml",
    "kgduw2umqafqw.tk",
    "kgdxwx.site",
    "kgelkdhm.website",
    "kghf.de",
    "kghjpp.us",
    "kgjuww.best",
    "kgjwn.live",
    "kgmail.us",
    "kgmndh.xyz",
    "kgohjniyrrgjp.cf",
    "kgohjniyrrgjp.ga",
    "kgohjniyrrgjp.gq",
    "kgohjniyrrgjp.ml",
    "kgohjniyrrgjp.tk",
    "kgoodfamily.com",
    "kgpnk.icu",
    "kgqkay.site",
    "kgt2in.us",
    "kgxz6o3bs09c.cf",
    "kgxz6o3bs09c.ga",
    "kgxz6o3bs09c.gq",
    "kgxz6o3bs09c.ml",
    "kgxz6o3bs09c.tk",
    "kgyzbm.us",
    "kh0hskve1sstn2lzqvm.ga",
    "kh0hskve1sstn2lzqvm.gq",
    "kh0hskve1sstn2lzqvm.ml",
    "kh0hskve1sstn2lzqvm.tk",
    "kh1uz.xyz",
    "kh1xv.xyz",
    "kh75g.xyz",
    "khachsandailac.com",
    "khachsanthanhhoa.com",
    "khadem.com",
    "khafaga.com",
    "khait.ru",
    "khaitulov.com",
    "khajatakeaway.com",
    "khalifahallah.com",
    "khalinin.gq",
    "khalinin.ml",
    "khalinin.tk",
    "khalpacor.cf",
    "khaltoor.com",
    "khaltor.com",
    "khaltor.net",
    "khaltour.net",
    "khamati.com",
    "khan007.cf",
    "khanh688k.ga",
    "kharchy-zaim.ru",
    "kharidenet.xyz",
    "kharidetalaei.shop",
    "khateb-alsunnah.com",
    "khauhieu.website",
    "khaze.xyz",
    "khbfzlhayttg.cf",
    "khbfzlhayttg.ga",
    "khbfzlhayttg.gq",
    "khbfzlhayttg.ml",
    "khbfzlhayttg.tk",
    "khbikemart.com",
    "khea.info",
    "khedgeydesigns.com",
    "kheex.xyz",
    "kheig.ru",
    "khel.de",
    "khfi.net",
    "khgkrsxc.shop",
    "khjadv.site",
    "khlbws.online",
    "khmer.loan",
    "khnews.cf",
    "khoabung.com",
    "khoahochot.com",
    "khoiho.com",
    "khoinghiephalong.com",
    "khongsocho.xyz",
    "khorinis.org",
    "khorshidi.xyz",
    "khosropour.com",
    "khotuisieucap.com",
    "khpci.xyz",
    "khpl.email",
    "khruyu.us",
    "khtyler.com",
    "khujenao.net",
    "khuong899.ml",
    "khuyenmai.asia",
    "khuyenmaiviet.website",
    "khwtf.xyz",
    "khyuz.ru",
    "ki5co.com",
    "ki7hrs5qsl.cf",
    "ki7hrs5qsl.ga",
    "ki7hrs5qsl.gq",
    "ki7hrs5qsl.ml",
    "ki7hrs5qsl.tk",
    "kiani.com",
    "kiaunioncounty.com",
    "kiawah-island-hotels.com",
    "kibarasi2h.xyz",
    "kiber-magazin.ru",
    "kiberkubik.ru",
    "kibriscikbeled.xyz",
    "kibrisclubhizmeti.xyz",
    "kibriscontinentalbank.xyz",
    "kibrisevtemizliksirketleri.com",
    "kibrishabertv.xyz",
    "kibrisligazete.xyz",
    "kibristasirketkur.com",
    "kibristurkhavayollari.xyz",
    "kichco.com",
    "kichimail.com",
    "kickasscamera.com",
    "kickassmail.com",
    "kickers.online",
    "kickit.ga",
    "kicklie.com",
    "kickmark.com",
    "kickmarx.net",
    "kickmature.xyz",
    "kicks-ass.net",
    "kicks-ass.org",
    "kid-car.ru",
    "kidbemus.cf",
    "kidbemus.gq",
    "kidbemus.ml",
    "kidbemus.tk",
    "kidfuture.org",
    "kidlist.buzz",
    "kids316.com",
    "kidsarella.ru",
    "kidscy.com",
    "kidsdiyideas.club",
    "kidsfitness.website",
    "kidsgreatminds.net",
    "kidsphuket.com",
    "kidsphuket.net",
    "kidspocketmoney.org",
    "kidstory35.ru",
    "kidswebmo.cf",
    "kidswebmo.gq",
    "kidswebmo.tk",
    "kidtoy.net",
    "kiejls.com",
    "kiepy.fun",
    "kieranharte.dev",
    "kiev-lottery.net",
    "kiev-lottery.org",
    "kigonet.xyz",
    "kiham.club",
    "kijmjb.com",
    "kik-store.ru",
    "kiki.clothing",
    "kiki.shopping",
    "kikivip.shop",
    "kikoxltd.com",
    "kiksorganicbeauty.com",
    "kikuchifamily.com",
    "kikuimo.biz",
    "kila.app",
    "kilauqq.xyz",
    "kilicerotomatikkapi.xyz",
    "kilimino.site",
    "kiliskasifgenclik.com",
    "kill-me.tk",
    "killa.pro",
    "killamail.com",
    "killarguitar.icu",
    "killergreenmail.com",
    "killermail.com",
    "killerwords.com",
    "killinglyelderlawgroup.com",
    "killmail.com",
    "killmail.net",
    "killmasterino.site",
    "killtheinfidels.com",
    "kilomando.site",
    "kiloyard.com",
    "kilton2001.ml",
    "kilvi.biz",
    "kim-rikil.ru",
    "kimavet.website",
    "kimchichi.com",
    "kimfetme.com",
    "kimfetsnj.com",
    "kimfetsnx.com",
    "kimfetspa.com",
    "kimfetstx.com",
    "kimirsen.ru",
    "kimmygranger.xyz",
    "kimo.com",
    "kimouche-fateh.net",
    "kimpro-77.com",
    "kimpro-78.com",
    "kimsalterationsmaine.com",
    "kimsdisk.com",
    "kimtex.tech",
    "kimxxe.gq",
    "kimyapti.com",
    "kin-dan.info",
    "kin1s.us",
    "kinafex.icu",
    "kinbam10.com",
    "kinbam5.com",
    "kinbam8.com",
    "kinderaid.ong",
    "kinderbook-inc.com",
    "kinderspanish4k.com",
    "kinderworkshops.de",
    "kindpostcot.gq",
    "kindpostcot.tk",
    "kindvenge.ml",
    "kindvenge.tk",
    "kindvideo.ru",
    "kinescop.ru",
    "kinetic.lighting",
    "kineticleadershipinstitute.net",
    "king-bricks.com",
    "king-csgo.ru",
    "king-sniper.com",
    "king-yaseen.cf",
    "king.buzz",
    "king2003.ml",
    "king2r123.com",
    "king33.asia",
    "king368aff.com",
    "king4dstar.com",
    "kingairpma.com",
    "kingbaltihouse.com",
    "kingbetting.org",
    "kingbillycasino3.com",
    "kingclickcompany.ru",
    "kingdentalhuntsville.com",
    "kingding.net",
    "kingdom-mag.com",
    "kingdomchecklist.com",
    "kingdomthemes.net",
    "kingfun.info",
    "kingfun79.com",
    "kingfunonline.com",
    "kingfunsg.com",
    "kingfunvn.com",
    "kingfuvirus.com",
    "kinggame247.club",
    "kinggame247.site",
    "kingleo.us",
    "kinglibrary.net",
    "kingmain.ru",
    "kingnews1.online",
    "kingnonlei.ga",
    "kingnonlei.gq",
    "kingnonlei.ml",
    "kingnonlei.tk",
    "kingofmarket.ru",
    "kingofminisplit.com",
    "kingofnopants.com",
    "kingofpowergreen.net",
    "kingortak.com",
    "kingpixelbuilder.com",
    "kingpizzatakeaway.com",
    "kingplus88.site",
    "kingpolloasadoelcasar.com",
    "kingreadse.cf",
    "kingreadse.ml",
    "kingreadse.tk",
    "kings-game.ru",
    "kings-garden-dublin.com",
    "kingsbbq.biz",
    "kingsbeachclub.com",
    "kingsbythebay.com",
    "kingsizesirect.com",
    "kingsleyofthehighlands.com",
    "kingsleyrussell.com",
    "kingsooperd.com",
    "kingsq.ga",
    "kingssupportservice.com",
    "kingssupportservices.com",
    "kingssupportservices.net",
    "kingstar4d.com",
    "kingstoncs.com",
    "kingstonjugglers.org",
    "kingswaymortgage.com",
    "kingtigerparkrides.com",
    "kingtornado.net",
    "kingtornado.org",
    "kingwely.com",
    "kingwin222.com",
    "kingwin365.com",
    "kingyslmail.com",
    "kingyslmail.top",
    "kingzippers.com",
    "kinhdoanhtructuyen.website",
    "kinhphongto.shop",
    "kinitawowis.xyz",
    "kink4sale.com",
    "kinkbuzz.net",
    "kinki-kids.com",
    "kinkyalice.com",
    "kino-100.ru",
    "kino-go.su",
    "kino-kingdom.net",
    "kino-maniya.ru",
    "kino24.ru",
    "kinobrod.online",
    "kinoget.ru",
    "kinogo-20.club",
    "kinogo-2020.club",
    "kinogo-club.fun",
    "kinogo-x.space",
    "kinogo-xo.club",
    "kinogo.one",
    "kinohook.ru",
    "kinoiks.ru",
    "kinokatushka.ru",
    "kinolife.club",
    "kinomaxsimus.ru",
    "kinoplask.tk",
    "kinopovtor2.online",
    "kinovideohit.ru",
    "kinox.life",
    "kinox.website",
    "kinoxa.one",
    "kinozor4.ru",
    "kinrose.care",
    "kintils.com",
    "kintravel.com",
    "kinx.cf",
    "kinx.gq",
    "kinx.ml",
    "kinx.tk",
    "kiohi.com",
    "kiois.com",
    "kioralsolution.net",
    "kipavlo.ru",
    "kiperzona.ru",
    "kipeyine.site",
    "kipina.space",
    "kiprhotels.info",
    "kipv.ru",
    "kir.ch.tc",
    "kirael.ru",
    "kiranaankan.net",
    "kirchdicka.cf",
    "kirchdicka.ga",
    "kirchdicka.gq",
    "kirchdicka.tk",
    "kirifurian.com",
    "kirikkaleanadolulisesi.xyz",
    "kirklandcounselingcenter.com",
    "kirklandcounselor.com",
    "kirklareliprefabrik.xyz",
    "kiro22.com",
    "kironpoint.com",
    "kirurgkliniken.nu",
    "kiryubox.cu.cc",
    "kisan.org",
    "kiscover.com",
    "kishen.dev",
    "kishopbags.club",
    "kishu.online",
    "kisiihft2hka.cf",
    "kisiihft2hka.ga",
    "kisiihft2hka.gq",
    "kisiihft2hka.ml",
    "kisiihft2hka.tk",
    "kismail.ru",
    "kiss1688.com",
    "kiss918.info",
    "kiss918bet.info",
    "kiss918vip.com",
    "kissfans.com",
    "kisshq.com",
    "kissmum.store",
    "kissmyapps.store",
    "kisstwink.com",
    "kissyou.biz",
    "kitanroipl.tk",
    "kitc9.com",
    "kitchen-beautybar.ru",
    "kitchen-tvs.ru",
    "kitchenanddining.company",
    "kitchencraft39.ru",
    "kitchenlean.fun",
    "kitchenplatforms.com",
    "kitchentvs.ru",
    "kite008.xyz",
    "kitedrooperver.ru",
    "kitefly.pl",
    "kitemail.com",
    "kiteshot.ru",
    "kitesportklop.ru",
    "kitezh-grad.ru",
    "kithjiut.cf",
    "kithjiut.ga",
    "kithjiut.gq",
    "kithjiut.ml",
    "kitmifit.ru",
    "kitnastar.com",
    "kitoz.net",
    "kitten-mittons.com",
    "kittencoding.com",
    "kittenemail.com",
    "kittenemail.xyz",
    "kitteninspace.com",
    "kittiza.com",
    "kittyallure.net",
    "kittydress.online",
    "kittymail.com",
    "kittymoney.info",
    "kittymoney.net",
    "kitznet.at",
    "kiustdz.com",
    "kiuyex.us",
    "kiuyutre.ga",
    "kiuyutre.ml",
    "kivoid.blog",
    "kiwami-group.ru",
    "kiwi10.xyz",
    "kiwi9.xyz",
    "kiwibox.com",
    "kiwitimber.kiwi",
    "kiwitown.com",
    "kiwlo.com",
    "kiwsz.com",
    "kix-tioman.ru",
    "kiyastand.site",
    "kiyonna.ru",
    "kiyua.com",
    "kiz10.games",
    "kizvm.net",
    "kj243.site",
    "kj5255.com",
    "kj5258.com",
    "kj8qtb.host",
    "kjdo9rcqnfhiryi.cf",
    "kjdo9rcqnfhiryi.ga",
    "kjdo9rcqnfhiryi.ml",
    "kjdo9rcqnfhiryi.tk",
    "kjdtgp.us",
    "kjg.website",
    "kjghbn.com",
    "kjgmwhwh.xyz",
    "kjhjb.site",
    "kjhjgyht6ghghngh.ml",
    "kjjeggoxrm820.gq",
    "kjjit.eu",
    "kjkj99.net",
    "kjmnui.com",
    "kjqwvg.site",
    "kjx9ba.site",
    "kjyhh.com",
    "kk18269.com",
    "kk3l.com",
    "kk903.site",
    "kkahbb.site",
    "kkaycero.site",
    "kkb2323.com",
    "kkbmkz.fun",
    "kkcmmf.fun",
    "kkffw.com",
    "kkfmyb.fun",
    "kkgame168.com",
    "kkgmxd.fun",
    "kkiblerk.site",
    "kkinderh.site",
    "kkiva.site",
    "kkjef655grg.cf",
    "kkjef655grg.ga",
    "kkjef655grg.gq",
    "kkjef655grg.ml",
    "kkjef655grg.tk",
    "kkjmdg.fun",
    "kkk385.com",
    "kkkmail.tk",
    "kkkmjg.fun",
    "kkkmzz.fun",
    "kklmsh.fun",
    "kkm35.ru",
    "kkmail.be",
    "kkmmtl.fun",
    "kknmmn.fun",
    "kkpmjf.fun",
    "kkpmnl.fun",
    "kkr47748fgfbef.cf",
    "kkr47748fgfbef.ga",
    "kkr47748fgfbef.gq",
    "kkr47748fgfbef.ml",
    "kkr47748fgfbef.tk",
    "kkrb.com",
    "kkrmcj.fun",
    "kksahsap.com",
    "kksm.be",
    "kkss33.com",
    "kktmfx.fun",
    "kktmpk.fun",
    "kktmqk.fun",
    "kkvlwj.ga",
    "kkwbeauty54.ru",
    "kkwiyor.site",
    "kkwmcj.fun",
    "kky20.club",
    "kkyf1.site",
    "kkymgx.fun",
    "kkzntk868mail.gq",
    "kl99.xyz",
    "klaass.ru",
    "klammlose.org",
    "klarasaty25rest.cf",
    "klarasfree09net.ml",
    "klasdoseme.online",
    "klasepin.xyz",
    "klassmaster.com",
    "klassmaster.net",
    "klassotvetgdz.ru",
    "klausuren.download",
    "kldfjs.com",
    "kleanr.org",
    "klebaqdtob.cf",
    "klebaqdtob.ga",
    "klebaqdtob.gq",
    "klebaqdtob.tk",
    "klee-brig.info",
    "kleebrig.org",
    "kleekai.rocks",
    "klefv.com",
    "klefv6.com",
    "kleiderboutique.de",
    "klembaxh23oy.gq",
    "klemeo.icu",
    "klepa.info",
    "klexch.com",
    "klglawnyc.com",
    "klgn8f.info",
    "klichapdi.tk",
    "klick-tipp.us",
    "klik-survey.com",
    "klik338a.com",
    "klikjackpot.net",
    "kliknflip.com",
    "klikovskiy.ru",
    "klin-ff.ru",
    "klindom.com",
    "klinikvidya.com",
    "kliningovq.site",
    "kliposad.space",
    "klipp.su",
    "klipschx12.com",
    "kljonline.net",
    "kljvjulr.shop",
    "klmcivil.com",
    "klnjlb.host",
    "kloap.com",
    "klog.dk",
    "kloiman.space",
    "klondike34.ru",
    "klonteskacondos.com",
    "kloplj.com",
    "klosnecni.cf",
    "klosnecni.ga",
    "klrrfjnk.shop",
    "kltrgroup.com",
    "klub21n.se",
    "klubap.ru",
    "kluceka.com",
    "kludgemush.com",
    "klun.info",
    "klun.us",
    "kluofficer.com",
    "klvm.gq",
    "klwrea.site",
    "klzlk.com",
    "klzmedia.com",
    "km.ru",
    "km1iq.xyz",
    "km239.site",
    "km69ax.site",
    "km6uj.xyz",
    "km7p7.xyz",
    "km7st.xyz",
    "kmail.com.au",
    "kmail.li",
    "kmail.mooo.com",
    "kmbr.de",
    "kmco-uae.com",
    "kmd4t8.site",
    "kme6g.xyz",
    "kmeaq.xyz",
    "kmebk.xyz",
    "kmhow.com",
    "kmkl.de",
    "kmlueh.shop",
    "kmonkeyd.com",
    "kmqqu.live",
    "kmqtqs.rest",
    "kmr14.xyz",
    "kmrx1hloufghqcx0c3.cf",
    "kmrx1hloufghqcx0c3.ga",
    "kmrx1hloufghqcx0c3.gq",
    "kmrx1hloufghqcx0c3.ml",
    "kmrx1hloufghqcx0c3.tk",
    "kmu3m.xyz",
    "kmuydm.xyz",
    "kmuye.xyz",
    "kmvdizyz.shop",
    "kmvwz.xyz",
    "kmw34.xyz",
    "kmwtevepdp178.gq",
    "kmydrb.us",
    "kmyolw.host",
    "kmzems.tokyo",
    "kmzi6.xyz",
    "kmzxsp.life",
    "kne2.club",
    "kneeguardkids.ru",
    "kneelos.com",
    "kngiuh.us",
    "kngwhp.us",
    "knhqzovn.shop",
    "knifepick.fun",
    "knifeple.press",
    "knifero.buzz",
    "knightsworth.com",
    "knightwar.xyz",
    "knime.app",
    "knime.online",
    "knime.tech",
    "knime.us",
    "knirell.com",
    "knitrearresource.website",
    "knitting-bordado.website",
    "knittingcrochet.website",
    "knittingcrochetideas.website",
    "knlfmk.site",
    "knnl.ru",
    "knokermer.com",
    "knol-power.nl",
    "knology.net",
    "knolselder.cf",
    "knolselder.ga",
    "knolselder.gq",
    "knolselder.ml",
    "knolselder.tk",
    "knotdictionary.com",
    "knotencyclopedia.com",
    "knotglossary.com",
    "knothandbook.com",
    "knotindex.com",
    "knotsillustrated.com",
    "know-mag.com",
    "know-magazine.com",
    "knowatef.cf",
    "knowatef.ga",
    "knowatef.gq",
    "knowatef.ml",
    "knowbius.com",
    "knowhowitaly.com",
    "knowincar.cf",
    "knowincar.gq",
    "knowincar.ml",
    "knownsecretblog.club",
    "knowsitall.info",
    "knowsutic.cf",
    "knowsutic.ga",
    "knowsutic.tk",
    "knowsysgroup.com",
    "knowwar.org",
    "knowyourfaqs.com",
    "knoxvillequote.com",
    "knpo.email",
    "knptest.com",
    "kntelectric.org",
    "kntilo.org",
    "kntl.me",
    "knudsen.dk",
    "knurl.xyz",
    "knus.dk",
    "knuw.us",
    "knw4maauci3njqa.cf",
    "knw4maauci3njqa.gq",
    "knw4maauci3njqa.ml",
    "knw4maauci3njqa.tk",
    "ko-pk.xyz",
    "koalabot.xyz",
    "koaladir.com",
    "kobzitroma.website",
    "kocaeliesnafrehberi.xyz",
    "koch.ml",
    "kocheme.com",
    "kochen24.de",
    "kochkurse-online.info",
    "kocokkartu.xyz",
    "kocoks.com",
    "kocsandingil.xyz",
    "kodaka.cf",
    "kodaka.ga",
    "kodaka.gq",
    "kodaka.ml",
    "kodaka.tk",
    "koddruay.one",
    "kodealam.center",
    "kodemail.ga",
    "kodesitus.xyz",
    "kodex-pirate.ru",
    "kodifinder.com",
    "kodifyqa.com",
    "kodorsex.cf",
    "kodylloyd.com",
    "koekenbakker.shop",
    "koeternity.com",
    "kofe-black-latte.ru",
    "kofustand.site",
    "kogal.info",
    "koged1.site",
    "kogu.site",
    "kohtaoweighlossretreat.com",
    "koibasicstore.com",
    "koicige.tk",
    "koin-qq.top",
    "koineraset.tk",
    "koipoker.com",
    "koiqe.com",
    "koismwnndnbfcswte.cf",
    "koismwnndnbfcswte.ga",
    "koismwnndnbfcswte.gq",
    "koismwnndnbfcswte.ml",
    "koismwnndnbfcswte.tk",
    "koitedis.cf",
    "koitedis.ga",
    "koitedis.gq",
    "koitedis.tk",
    "kokencocinas.com",
    "koko.com",
    "kokohawke.com",
    "kokorot.cf",
    "kokorot.ga",
    "kokorot.gq",
    "kokorot.ml",
    "kokorot.tk",
    "kokosik.site",
    "kokteyl365.site",
    "kolasin.net",
    "kolaybet99.com",
    "kolayfinansman.xyz",
    "kolayhemenara.com",
    "koliman.me",
    "koliter.xyz",
    "kolkadrov.ru",
    "kolkmendbobc.gq",
    "kolkmendbobc.tk",
    "kollabkonceps.com",
    "kollective.agency",
    "kollektor-stout.ru",
    "kollibry.ru",
    "kolodec-legko.ru",
    "kolonkop.space",
    "kolonyaci.site",
    "kolotoparaka.icu",
    "kolovbo.icu",
    "kolpm.icu",
    "kolpoiy12.xyz",
    "kolumbus.fi",
    "kolxo3nik.ru",
    "kolxo3pro.ru",
    "komaxann.com",
    "kombimonster.com",
    "kombinebet113.com",
    "kombinebet62.xyz",
    "kombiservisler.com",
    "kombuchadad.com",
    "komkomp.ru",
    "kommespaeter.de",
    "kommunity.biz",
    "kompakteruss.cf",
    "komparte.org",
    "kompbez.ru",
    "kompens-viplati-rf.site",
    "kompetisipoker.world",
    "kompressorkupi.ru",
    "komunitastogelindonesia.info",
    "komuvi.info",
    "komys.com",
    "kon42.com",
    "konacode.com",
    "konaklayan.com",
    "konaksgb.xyz",
    "konbat.ru",
    "kondadra.ru",
    "kondomeri.se",
    "konect.site",
    "koneshtech.org",
    "konetzke.net",
    "konferansnasyonal.org",
    "kongdombli.ga",
    "kongdombli.gq",
    "kongdombli.ml",
    "kongdombli.tk",
    "kongfunkitchen.com",
    "kongs-chinese-takeaway.com",
    "konicy.pro",
    "konikode.org",
    "koning.icu",
    "konkenist.com",
    "konkovo.net",
    "konkursoteka.com",
    "konno.tk",
    "konstmusik.se",
    "konsul.ru",
    "kontak-whats.app",
    "kontaktniy-centr.ru",
    "kontcasino.net",
    "kontol.city",
    "kontol.co.uk",
    "kontormatik.org",
    "kontrabet13.com",
    "kontrabet14.com",
    "kontraktsfinansiering.se",
    "konultant-jurist.ru",
    "konumin.cf",
    "konveksigue.com",
    "konx.com",
    "konyad.org",
    "konyakarataylisesi.com",
    "konyaliservis.xyz",
    "konyawa.xyz",
    "kooaxwlal.shop",
    "koodidojo.com",
    "koogis-cream.ru",
    "kook.ml",
    "kookaburrawindows.com",
    "koolgosto.com",
    "koomaps.com",
    "koopret.ga",
    "koorabia.net",
    "koorabia.org",
    "koorstvrij.events",
    "koortscamera.shop",
    "koortscameras.shop",
    "koortsdetectie.camera",
    "koortsdetectie.events",
    "kopagas.com",
    "kopaka.net",
    "kopakorkortonline.com",
    "koparatnewtoncondo-cel.site",
    "kopdarec.gq",
    "kopdarec.ml",
    "kopdarec.tk",
    "kopecun.ru",
    "kopergaons.info",
    "kopf.pro",
    "kopg0y.site",
    "kopher.com",
    "kopiacehgayo15701806.cf",
    "kopiacehgayo15701806.ga",
    "kopiacehgayo15701806.ml",
    "kopiacehgayo15701806.tk",
    "kopibajawapunya15711640.cf",
    "kopibajawapunya15711640.ga",
    "kopibajawapunya15711640.ml",
    "kopibajawapunya15711640.tk",
    "kopikapalapi11821901.cf",
    "kopikapalapi11821901.ga",
    "kopikapalapi11821901.ml",
    "kopikapalapi11821901.tk",
    "kopiko.ml",
    "kopipahit.ga",
    "koplexcat.ru",
    "koporton.club",
    "kopqi.com",
    "koprkr.shop",
    "korabora.ong",
    "koralldesign.se",
    "koran3000.com",
    "korankiu.info",
    "korcan.org",
    "korea-beaytu.ru",
    "korea.com",
    "korea315.xyz",
    "koreaaa316.xyz",
    "koreaaa317.xyz",
    "koreamail.cf",
    "koreamail.com",
    "koreamail.ml",
    "koreamedis.ru",
    "korean-brides.com",
    "koreantranslators.org",
    "koreautara.cf",
    "koreautara.ga",
    "korinthiakos.net",
    "korjk.com",
    "korkorts-foto.se",
    "korma-at-home-dunboyne.com",
    "kormail.xyz",
    "korona-nedvizhimosti.ru",
    "korrichttur.ml",
    "korsakm.com",
    "kortom.site",
    "korutbete.cf",
    "kosciuszkofoundation.com",
    "kosgcg0y5cd9.cf",
    "kosgcg0y5cd9.ga",
    "kosgcg0y5cd9.gq",
    "kosgcg0y5cd9.ml",
    "kosgcg0y5cd9.tk",
    "kosherlunch.com",
    "kosholoka.space",
    "koshu.ru",
    "koshua.com",
    "kosino.net",
    "koskiandsyvari.com",
    "kosma33.ru",
    "kosmetik-obatkuat.com",
    "kosmetika-korei.ru",
    "kosmoart.world",
    "kosmoworld.ru",
    "kosoffertest.ru",
    "kosova24.info",
    "kosrze.site",
    "kost.party",
    "kostenlose-browsergames.info",
    "kostenlosemailadresse.de",
    "koszm.us",
    "koszmail.pl",
    "kotao.xyz",
    "kotastone.org",
    "kotidian.com",
    "kotlinmagic.com",
    "koto.agency",
    "kotoled.mobi",
    "kotsu01.info",
    "kottochblod.se",
    "kotymac.pro",
    "kouattre38t.cf",
    "kouattre38t.ga",
    "kouattre38t.gq",
    "kouattre38t.ml",
    "kouattre38t.tk",
    "kounes.com",
    "kounnes.com",
    "koutburgvil.gq",
    "koutburgvil.ml",
    "koval68.ru",
    "kovfzt1m.info",
    "kovi.bike",
    "kovi.cab",
    "kovi.care",
    "kovi.center",
    "kovi.media",
    "kovi.site",
    "kovi.store",
    "kovi.ventures",
    "kovi.website",
    "kovi.world",
    "kovi.zone",
    "kow-game.xyz",
    "koweancenjancok.cf",
    "koweancenjancok.ga",
    "koweancenjancok.gq",
    "koweancenjancok.ml",
    "kowgame.online",
    "kowsderun.ga",
    "kowsderun.ml",
    "koyocah.ml",
    "koypeyniri.online",
    "kozacki.pl",
    "kozelkrug.xyz",
    "kozing.net",
    "kozmail.com",
    "kozow.com",
    "kp033.club",
    "kp2008.com",
    "kp54ujf6z173r2i.xyz",
    "kp77777.com",
    "kpapa.ooo",
    "kpar30b.club",
    "kpay.be",
    "kpgfjrje.shop",
    "kpgindia.com",
    "kpmnw1.site",
    "kpnmail.nl",
    "kpnplanet.nl",
    "kpolikaret.ga",
    "kpooa.com",
    "kpoppeiro.com",
    "kpops.info",
    "kpost.be",
    "kpostmagazin.xyz",
    "kppfib.com",
    "kppseulh.shop",
    "kpvubc.com",
    "kq094.site",
    "kqeogb.us",
    "kqeutmuv.shop",
    "kqhs4jbhptlt0.cf",
    "kqhs4jbhptlt0.ga",
    "kqhs4jbhptlt0.gq",
    "kqhs4jbhptlt0.ml",
    "kqhs4jbhptlt0.tk",
    "kqhwojmb.shop",
    "kqimvj.info",
    "kqis.de",
    "kqo0p9vzzrj.ga",
    "kqo0p9vzzrj.gq",
    "kqo0p9vzzrj.ml",
    "kqo0p9vzzrj.tk",
    "kqqe.email",
    "kqtsg.com",
    "kqwyqzjvrvdewth81.cf",
    "kqwyqzjvrvdewth81.ga",
    "kqwyqzjvrvdewth81.gq",
    "kqwyqzjvrvdewth81.ml",
    "kqwyqzjvrvdewth81.tk",
    "kqxs168.org",
    "kr207.site",
    "kracih.ru",
    "kradrider.com",
    "kradrider.info",
    "kradrider.net",
    "kradrider.org",
    "kraftbeer.org",
    "kraftimir.ru",
    "kraftmann-compressoren.ru",
    "kraftur.se",
    "krakov.net",
    "kraldostfm.online",
    "kramatjegu.com",
    "kran-ua.ru",
    "kranewaresolutions.com",
    "kras-ses.ru",
    "krasaeva.ru",
    "krascos.ru",
    "krasfasad24.ru",
    "krasim-nogti.ru",
    "krasivie-parki.ru",
    "kraskaekb.ru",
    "kraslotenoverzicht.com",
    "krasnikovalexandr.ru",
    "krassnodar.ru",
    "kratebike.net",
    "kratom.ist",
    "kratomseeds.us",
    "kratoso.com",
    "kraunch.com",
    "krausewebservices.com",
    "krazymail.com",
    "krb.asia",
    "krd.ag",
    "kreativsad.ru",
    "kreatoracademy.asia",
    "kredim.website",
    "kredinn.xyz",
    "kredit-maps.ru",
    "krediti-dlya-biznesa.ru",
    "kreditkartenvergleich.jetzt",
    "kreditnyefakty76.ru",
    "kreditor.ru",
    "kreeist.space",
    "kreig.ru",
    "kreigkent.us",
    "kreldon.co",
    "kreldon.me",
    "kremlin-russia.ru",
    "kremlin2018ru.ru",
    "krepekraftonline.com",
    "kreusgravois.net",
    "krgyui7svgomjhso.cf",
    "krgyui7svgomjhso.ga",
    "krgyui7svgomjhso.gq",
    "krgyui7svgomjhso.ml",
    "krgyui7svgomjhso.tk",
    "krhgkreb.shop",
    "kri1d12p1dgpc62.xyz",
    "krillio.com",
    "krim.ws",
    "kriminal.online",
    "kriminal.website",
    "krioo.club",
    "kriptocucesi.com",
    "kriptokartel.ru",
    "kriptozin.com",
    "kriqziol.shop",
    "kriseos.com",
    "krish.sydney",
    "krishnamurthyt2smenu.com",
    "krissfamily.online",
    "kristall2.ru",
    "kristeven.tk",
    "kristiannoya.com",
    "kristinejane.com",
    "kristophersage.com",
    "kriunoper.tk",
    "kriyakinesis.com",
    "krjjqt.us",
    "krle.us",
    "krmgp1.site",
    "krnf.de",
    "kro.kr",
    "kro65.space",
    "kromechains.com",
    "kromeem.com",
    "krompakan.xyz",
    "krone-24.ru",
    "kronedigits.ru",
    "kronen-zeitung.site",
    "krongthip.com",
    "kronoparkenspizzeria.se",
    "kross-style.ru",
    "kross-torg.ru",
    "krosstorg.ru",
    "kroswalt.com",
    "krovatka.net",
    "krovatka.su",
    "kroyalebeautysalon.com",
    "krsw.sonshi.cf",
    "krsw.tk",
    "krtdvuyj.shop",
    "krte3562nfds.cf",
    "krte3562nfds.ga",
    "krte3562nfds.gq",
    "krte3562nfds.ml",
    "krte3562nfds.tk",
    "krtjrzdt1cg2br.cf",
    "krtjrzdt1cg2br.ga",
    "krtjrzdt1cg2br.gq",
    "krtjrzdt1cg2br.ml",
    "krtjrzdt1cg2br.tk",
    "krudt.dk",
    "krugerreserve.com",
    "krull.com",
    "krunis.com",
    "krunkosaurus.com",
    "krupp.cf",
    "krupp.ga",
    "krupp.ml",
    "krupukhslide86bze.gq",
    "krvjna.ml",
    "krvps.com",
    "krwzgt.us",
    "krypcall.com",
    "krypton.tk",
    "kryptone.market",
    "kryptonqq.com",
    "kryptonqq.net",
    "kryptonqq.org",
    "krystabledsoe.com",
    "kryukvoron.ru",
    "ks-sports.net",
    "ks7h.com",
    "ks87.igg.biz",
    "ks87.usa.cc",
    "ksadrc.com",
    "ksaleshow.site",
    "ksanax.site",
    "ksanmail.com",
    "ksao.club",
    "ksao.store",
    "ksdcdecusklh1sk.xyz",
    "ksee24mail.com",
    "ksframem.com",
    "ksgfu.live",
    "ksidemdi.ga",
    "ksidemdi.gq",
    "ksisil.us",
    "ksiskdiwey.cf",
    "ksjdhlka.xyz",
    "ksjivxt.com",
    "kskbd.com",
    "kslokogm-fm.com",
    "kslweddings.com",
    "ksmtrck.cf",
    "ksmtrck.ga",
    "ksmtrck.rf.gd",
    "ksmtrck.tk",
    "ksoftgames10.com",
    "ksoftgames18.com",
    "ksoftgames19.com",
    "ksoftgames3.com",
    "kspa.xyz",
    "ksportscoin.com",
    "ksportscoin.net",
    "ksqpmcw8ucm.cf",
    "ksqpmcw8ucm.ga",
    "ksqpmcw8ucm.gq",
    "ksqpmcw8ucm.ml",
    "ksqpmcw8ucm.tk",
    "kstater.press",
    "kstnu4.info",
    "kstrong.info",
    "kstyleworld.com",
    "ksustine.com",
    "ksylonmartin.com",
    "kszsae.us",
    "kt-static.com",
    "kt1k.com",
    "kt1k.net",
    "kt3qiv.info",
    "ktajnnwkzhp9fh.cf",
    "ktajnnwkzhp9fh.ga",
    "ktajnnwkzhp9fh.gq",
    "ktajnnwkzhp9fh.ml",
    "ktajnnwkzhp9fh.tk",
    "ktbk.ru",
    "kterer.com",
    "ktexaf.icu",
    "kth.kiwi",
    "ktm303.org",
    "ktopomozeseniorom.sk",
    "kttc.space",
    "ktumail.com",
    "ktvblog.com",
    "ktwoan.com",
    "ku-rong.com",
    "ku1hgckmasms6884.cf",
    "ku1hgckmasms6884.ga",
    "ku1hgckmasms6884.gq",
    "ku1hgckmasms6884.ml",
    "ku1hgckmasms6884.tk",
    "ku4b1.us",
    "kuai909.com",
    "kuaijenwan.com",
    "kuaizhufang.com",
    "kualitasqq.com",
    "kualitasqq.net",
    "kuatcak.cf",
    "kuatcak.tk",
    "kuatkanakun.com",
    "kuatmail.gq",
    "kuatmail.tk",
    "kuatocokjaran.cf",
    "kuatocokjaran.ga",
    "kuatocokjaran.gq",
    "kuatocokjaran.ml",
    "kuatocokjaran.tk",
    "kube93mail.com",
    "kubqs.live",
    "kubzone.ru",
    "kuciangxtify-store1.com",
    "kucing99.com",
    "kucingarong.cf",
    "kucingarong.ga",
    "kucingarong.gq",
    "kucingarong.ml",
    "kucinge.site",
    "kucoba.ml",
    "kucoin.one",
    "kud0ng.com",
    "kudanilshop.com",
    "kudaponiea.cf",
    "kudaponiea.ga",
    "kudaponiea.ml",
    "kudaponiea.tk",
    "kudaterbang.gq",
    "kudefu.info",
    "kudeha.info",
    "kudlatamewa.se",
    "kue747rfvg.cf",
    "kue747rfvg.ga",
    "kue747rfvg.gq",
    "kue747rfvg.ml",
    "kue747rfvg.tk",
    "kueh.shop",
    "kuehmueh.shop",
    "kuehraya.shop",
    "kuemail.men",
    "kuewne.site",
    "kuf.us",
    "kuffrucrei.cf",
    "kuffrucrei.gq",
    "kufyguy.space",
    "kugua1-99.xyz",
    "kuheco.xyz",
    "kuhioshore.com",
    "kuhmebelmos.ru",
    "kuhni-kuk.ru",
    "kuhnya-msk.ru",
    "kuhnyamarket.ru",
    "kuhrap.com",
    "kuhybe.info",
    "kuickulture.asia",
    "kuihmuih.shop",
    "kuihraya.shop",
    "kuikytut.review",
    "kuiljunyu69lio.cf",
    "kuingin.ml",
    "kuiqa.com",
    "kujishops.site",
    "kukamail.com",
    "kukeboutique.site",
    "kukizbezpartyjnisamorzadowcy.org",
    "kukuka.org",
    "kukuljanovo.info",
    "kukuljanovo.net",
    "kulinarry.ru",
    "kulitlumpia.ml",
    "kulitlumpia1.ga",
    "kulitlumpia2.cf",
    "kulitlumpia3.ml",
    "kulitlumpia4.ga",
    "kulitlumpia5.cf",
    "kulitlumpia6.ml",
    "kulitlumpia7.ga",
    "kulitlumpia8.cf",
    "kulmeo.com",
    "kulmio.dev",
    "kulogu.cf",
    "kulogu.ml",
    "kulpvalinafizkayali.net",
    "kulturapitaniya.ru",
    "kulturbetrieb.info",
    "kultureco.space",
    "kulturel.dk",
    "kum38p0dfgxz.cf",
    "kum38p0dfgxz.ga",
    "kum38p0dfgxz.gq",
    "kum38p0dfgxz.ml",
    "kum38p0dfgxz.tk",
    "kumail8.info",
    "kumarweb.com",
    "kumisgonds69.me",
    "kumiteregistration.com",
    "kumlucahalkegitim.xyz",
    "kuncibengkel.com",
    "kundenserver.website",
    "kune.app",
    "kunespace.net",
    "kunfou.com",
    "kunghourpa.ga",
    "kunghourpa.tk",
    "kunimedesu.com",
    "kunitzsch-kfz-service.de",
    "kunrong.info",
    "kunststofdeureneindhoven.com",
    "kunwardanishali.com",
    "kunwojituan.com",
    "kuonicreative.com",
    "kupi.dev",
    "kupiarmaturu.ru",
    "kupiprodaiauto.ru",
    "kupiprodaimetal.ru",
    "kupit-aviabilety-na-samolet.ru",
    "kupit-kurt.ru",
    "kupit-spravka-lipetsk.ru",
    "kupit-spravka-v-sochax.ru",
    "kupitdiplom.info",
    "kupon4d.xyz",
    "kuponjitu.info",
    "kuram.host",
    "kurawapoker.club",
    "kurawapoker.fun",
    "kurd.link",
    "kurdbeen.net",
    "kurdit.se",
    "kurdsatnews.net",
    "kurdsatnews.org",
    "kurior.com",
    "kuroate.info",
    "kurort-rf.ru",
    "kurpar.ru",
    "kurs-excel.ru",
    "kursekle.xyz",
    "kurszarrqx.club",
    "kurtbayt.icu",
    "kurtizanka.net",
    "kurtsax.us",
    "kurtzrealty.com",
    "kurubands.info",
    "kurumama.org",
    "kurupee.com",
    "kuryshkina.ru",
    "kurzepost.de",
    "kusadasiemlakofis.com",
    "kusadasipalmresort.com",
    "kusam.ga",
    "kuskonmazciftligi.com",
    "kusma.org",
    "kusrc.com",
    "kusyuvalari.com",
    "kut-mail1.com",
    "kutahyaggk.com",
    "kutahyapostasi.xyz",
    "kutahyasairseyhiioo.com",
    "kutahyasairseyhiioo.xyz",
    "kutahyasiirsevenlerdernegi.com",
    "kutahyasiirsevenlerdernegi.xyz",
    "kutakbisadekatdekat.cf",
    "kutakbisadekatdekat.ml",
    "kutakbisadekatdekat.tk",
    "kutakbisajauhjauh.cf",
    "kutakbisajauhjauh.ga",
    "kutakbisajauhjauh.gq",
    "kutakbisajauhjauh.ml",
    "kutakbisajauhjauh.tk",
    "kutcuibui.ml",
    "kutcuibui.tk",
    "kuwait-mail.com",
    "kuwaiyedekparca.com",
    "kuy.bet",
    "kuyberuntung.com",
    "kuyhaa-android19.bid",
    "kuymubows.tk",
    "kuzady.info",
    "kuzminki.net",
    "kuzumo.com",
    "kv272.site",
    "kv8v0bhfrepkozn4.cf",
    "kv8v0bhfrepkozn4.ga",
    "kv8v0bhfrepkozn4.gq",
    "kv8v0bhfrepkozn4.ml",
    "kv8v0bhfrepkozn4.tk",
    "kvacdoor.xyz",
    "kvadrokopter-s-kameroj.ru",
    "kvail.se",
    "kvajy.live",
    "kvalme.dk",
    "kvartira-volgograd.ru",
    "kvc67.space",
    "kvcoredemo.us",
    "kvcoredemo.xyz",
    "kvfg.com",
    "kvfyn.us",
    "kvkailashahar.in",
    "kvl.ink",
    "kvnforall.ru",
    "kvouthmnu.shop",
    "kvr8.dns-stuff.com",
    "kvs24.de",
    "kvvaiu.ru",
    "kw890.site",
    "kw9gnq7zvnoos620.cf",
    "kw9gnq7zvnoos620.ga",
    "kw9gnq7zvnoos620.gq",
    "kw9gnq7zvnoos620.ml",
    "kw9gnq7zvnoos620.tk",
    "kwa-law.com",
    "kwacollections.com",
    "kwalidd.cf",
    "kweci.com",
    "kwestlund.com",
    "kwickcom.com",
    "kwickcovers.com",
    "kwift.net",
    "kwii.org",
    "kwikturnhosting.com",
    "kwilco.net",
    "kwishop.com",
    "kwj0sq.us",
    "kwmarketplace.com",
    "kwondang.com",
    "kwrffm.ml",
    "kwsnqggvd.shop",
    "kwvnr.com",
    "kwzi0a.com",
    "kx561.site",
    "kxlkze.site",
    "kxmvdvop.shop",
    "kxo7.us",
    "kxtshe.us",
    "kxvps.com",
    "kxzaten9tboaumyvh.cf",
    "kxzaten9tboaumyvh.ga",
    "kxzaten9tboaumyvh.gq",
    "kxzaten9tboaumyvh.ml",
    "kxzaten9tboaumyvh.tk",
    "ky019.com",
    "kyaffshop.store",
    "kyal.pl",
    "kydigo.com",
    "kydovekame.ru",
    "kydro.com",
    "kyebosh.pro",
    "kyfsh.com",
    "kyhalfpricelistings.com",
    "kyhealthcoverage.bid",
    "kyilasninsky.com",
    "kyj27.com",
    "kyjewa.info",
    "kykarachy.site",
    "kykareku.ru",
    "kylegrenell.club",
    "kylemorin.co",
    "kyliekkwbeauty.ru",
    "kylinarnierecepti.ru",
    "kymogen.com",
    "kymun.site",
    "kynoeajq.xyz",
    "kyobars.icu",
    "kyois.com",
    "kyoketsu.com",
    "kyokodate.com",
    "kyokofukada.net",
    "kyokushinkarate.co",
    "kyoto.email.ne.jp",
    "kypi74.ru",
    "kyq3pa.com",
    "kys3pw.us",
    "kystj.us",
    "kytozu.info",
    "kyvoxio.space",
    "kywiyoy.site",
    "kyzisu.xyz",
    "kyzo.site",
    "kz0mjs.info",
    "kz64vewn44jl79zbb.cf",
    "kz64vewn44jl79zbb.ga",
    "kz64vewn44jl79zbb.gq",
    "kz64vewn44jl79zbb.ml",
    "kz64vewn44jl79zbb.tk",
    "kz9tev-mail.xyz",
    "kzbvyq.host",
    "kzcontractors.com",
    "kzctsgdo.shop",
    "kzednftik.shop",
    "kzfnl.site",
    "kzfzwc.site",
    "kzk2o.club",
    "kzn.us",
    "kzone88.com",
    "kzq6zi1o09d.cf",
    "kzq6zi1o09d.ga",
    "kzq6zi1o09d.gq",
    "kzq6zi1o09d.ml",
    "kzq6zi1o09d.tk",
    "kzw1miaisea8.cf",
    "kzw1miaisea8.ga",
    "kzw1miaisea8.gq",
    "kzw1miaisea8.ml",
    "kzw1miaisea8.tk",
    "l-100-super-lotos.site",
    "l-baget.ru",
    "l-c-a.us",
    "l-egenda.com",
    "l-okna.ru",
    "l-response.com",
    "l-shoponline.info",
    "l.bgsaddrmwn.me",
    "l.r3-r4.tk",
    "l.safdv.com",
    "l0.l0l0.xyz",
    "l00s9ukoyitq.cf",
    "l00s9ukoyitq.ga",
    "l00s9ukoyitq.gq",
    "l00s9ukoyitq.ml",
    "l00s9ukoyitq.tk",
    "l0eea8.us",
    "l0ktji.us",
    "l0l.l1l.ink",
    "l0llbtp8yr.cf",
    "l0llbtp8yr.ga",
    "l0llbtp8yr.gq",
    "l0llbtp8yr.ml",
    "l0llbtp8yr.tk",
    "l0real.net",
    "l107h9.info",
    "l111.tk",
    "l1775.com",
    "l1a2ds.online",
    "l1rwscpeq6.cf",
    "l1rwscpeq6.ga",
    "l1rwscpeq6.gq",
    "l1rwscpeq6.ml",
    "l1rwscpeq6.tk",
    "l1viwy.us",
    "l2creed.ru",
    "l2n5h8c7rh.com",
    "l2tmsp.site",
    "l337.store",
    "l33r.eu",
    "l33t.support",
    "l36i2hbk.fun",
    "l3nckt.com",
    "l3ywy6aarag6nri.xyz",
    "l4dz6h.us",
    "l4fom5.us",
    "l4usikhtuueveiybp.cf",
    "l4usikhtuueveiybp.gq",
    "l4usikhtuueveiybp.ml",
    "l4usikhtuueveiybp.tk",
    "l5.ca",
    "l529u.live",
    "l5c7zu.us",
    "l5prefixm.com",
    "l6.org",
    "l64pk.com",
    "l6emr0.us",
    "l6factors.com",
    "l6hmt.us",
    "l745pejqus6b8ww.cf",
    "l745pejqus6b8ww.ga",
    "l745pejqus6b8ww.gq",
    "l745pejqus6b8ww.ml",
    "l745pejqus6b8ww.tk",
    "l78qp.com",
    "l79od.com",
    "l7b2l47k.com",
    "l7k8jy.site",
    "l7sol.com",
    "l7wnrm.us",
    "l7zbsj.us",
    "l80v.us",
    "l81ref.us",
    "l82323.com",
    "l8g9so.us",
    "l8oaypr.com",
    "l90pm.us",
    "l9gmbx.us",
    "l9qwduemkpqffiw8q.cf",
    "l9qwduemkpqffiw8q.ga",
    "l9qwduemkpqffiw8q.gq",
    "l9qwduemkpqffiw8q.ml",
    "l9qwduemkpqffiw8q.tk",
    "l9tmlcrz2nmdnppabik.cf",
    "l9tmlcrz2nmdnppabik.ga",
    "l9tmlcrz2nmdnppabik.gq",
    "l9tmlcrz2nmdnppabik.ml",
    "l9tmlcrz2nmdnppabik.tk",
    "la-boutique.shop",
    "la-creme-de-la-creme.com",
    "la-p2.com",
    "la.com",
    "la0u56qawzrvu.cf",
    "la0u56qawzrvu.ga",
    "la2walker.ru",
    "la9kqq.us",
    "laatorneys.com",
    "labetteraverouge.at",
    "labgrowndiamond.online",
    "labhyto.cf",
    "labhyto.ga",
    "labhyto.gq",
    "labhyto.ml",
    "labhyto.tk",
    "labiblia.digital",
    "labiblia.live",
    "labibliotheque.site",
    "labo.ch",
    "labodina.ru",
    "labogili.ga",
    "labontemty.com",
    "labored673vl.online",
    "laboriously.com",
    "laborstart.org",
    "labratrace.com",
    "labreportaid.com",
    "labrums.us",
    "labs-getty.com",
    "labtau.com",
    "labtoad.com",
    "lacabina.info",
    "lacafenligne.com",
    "lacageadomicile.com",
    "lacantinadelariaaviles.com",
    "lacaraota.com",
    "lacedmail.com",
    "lacer-pokacar.ru",
    "lacercadecandi.ml",
    "laceylist.com",
    "lachorrera.com",
    "lachzentrum-wiesbaden.de",
    "lackmail.net",
    "lackmail.ru",
    "lacky-shop.ru",
    "laclapalace.design",
    "laconte.ga",
    "laconte.gq",
    "laconte.tk",
    "lacosye.com",
    "lacrosselocator.com",
    "lactigo.ru",
    "lacto.info",
    "lacviet.org",
    "lada-granta-fanclub.ru",
    "ladah.info",
    "ladapickup.ru",
    "ladaran.cf",
    "ladaran.ga",
    "ladaran.gq",
    "ladaran.ml",
    "ladaran.tk",
    "ladder-simplicity.xyz",
    "laddoublinghut.website",
    "laddsmarina.com",
    "laddyhammercasino.com",
    "ladege.gq",
    "ladege.ml",
    "ladege.tk",
    "ladellecorp.com",
    "ladeweile.com",
    "ladiesbeachresort.com",
    "ladieshightea.info",
    "ladiesshaved.us",
    "ladohucu.site",
    "ladsad.ru",
    "laduree-dublin.com",
    "lady-journal.ru",
    "ladyanndesigns.com",
    "ladyfire.com",
    "ladylounge.de",
    "ladymacbeth.tk",
    "ladymail.cz",
    "ladymjsantos.net",
    "ladymjsantos.org",
    "ladyonline.com",
    "ladyrelax28.ru",
    "ladyshelly.com",
    "ladystores.ru",
    "ladyturnerlime.website",
    "laendle.dev",
    "lafelisas.info",
    "lafibretubeo.net",
    "lafz1.us",
    "laga525252.com",
    "lagane.info",
    "lagardochicho.ovh",
    "lagcc.cuny.edu",
    "lagchouco.cf",
    "lagchouco.ga",
    "lagchouco.tk",
    "lagerarbetare.se",
    "lageris.cf",
    "lageris.ga",
    "lagerlouts.com",
    "laggybit.com",
    "lagiapa.online",
    "lagicantiik.com",
    "lagify.com",
    "lagochapos.info",
    "lagooorka.ru",
    "lagoriver.com",
    "lagotos.net",
    "lags.us",
    "lagsixtome.com",
    "lagubagus.shop",
    "lagugratis.net",
    "laguia.legal",
    "lagunaproducts.com",
    "lagushare.me",
    "lahaciendacoronado.com",
    "lahainataxi.com",
    "lahamnakam.me",
    "laheny.site",
    "lahi.me",
    "lahoreoye.com",
    "lahorerecord.com",
    "lahta9qru6rgd.cf",
    "lahta9qru6rgd.ga",
    "lahta9qru6rgd.gq",
    "lahta9qru6rgd.ml",
    "lahta9qru6rgd.tk",
    "laibasxiou.cf",
    "laibasxiou.gq",
    "laibf1.site",
    "laicasinoroad.ru",
    "laicizing986jn.online",
    "laika999.ml",
    "laikacyber.cf",
    "laikacyber.ga",
    "laikacyber.gq",
    "laikacyber.ml",
    "laikacyber.tk",
    "laimian-quan2.com",
    "laimianquan2.com",
    "laimianquan2.net",
    "laimibe.cf",
    "laimibe.tk",
    "lain.ch",
    "lainitu.cf",
    "lainitu.ga",
    "lainitu.gq",
    "lainitu.ml",
    "lainitu.tk",
    "lajoska.pe.hu",
    "lajt.hu",
    "lak.pp.ua",
    "lakaraka.website",
    "lakarunyha65jjh.ga",
    "lake411today.xyz",
    "lakecharleslandsurveying.com",
    "lakeelsinorerentals.com",
    "lakeid.com",
    "lakeland-laboratories.com",
    "lakeland-laboratory.com",
    "lakelbjlakelife.com",
    "lakelivingstonrealestate.com",
    "lakesidde.com",
    "lakesofthenorthwinterfest.com",
    "lakevilleapartments.com",
    "lakewater.org",
    "lakexbetpinup.ru",
    "lakmail.com",
    "lakngin.ga",
    "lakngin.ml",
    "lakocloud.store",
    "lakomoda.com",
    "lakqs.com",
    "lal.kr",
    "lala-mailbox.club",
    "lala-mailbox.online",
    "lalaboutique.com",
    "lalala.fun",
    "lalala.site",
    "lalamailbox.com",
    "lalashop.asia",
    "lalasin.club",
    "lalasin.xyz",
    "laldo.com",
    "lalegionseguridad.com",
    "laleyendadelvino.com",
    "lalimat.gq",
    "lalimat.ml",
    "lallaalia.com",
    "lalunelab.com",
    "lam0k.com",
    "lamahometextile.com",
    "lamaisonducachemire.com",
    "lamarengineering.com",
    "lamasbonitadetodasmix.com",
    "lambadarew90bb.gq",
    "lambandstine.com",
    "lambanh.info",
    "lambdasu.com",
    "lambinganteleserye.ru",
    "lamdx.com",
    "lamer.hu",
    "lamgme.xyz",
    "lami4you.info",
    "laminaatdirect.com",
    "lamiradaautorepair.com",
    "lamiradarentals.com",
    "lamongan.cf",
    "lamongan.gq",
    "lamongan.ml",
    "lamosqe.com",
    "lamp-crime.xyz",
    "lampadaire.cf",
    "lampadlyagellaka.ru",
    "lampsbeautiful.mobi",
    "lampsbeautiful.net",
    "lampsbeautiful.org",
    "lampshynesslimp.website",
    "lamzakcool.ru",
    "lanaburl.com",
    "lanatease.com",
    "lancasterandstlouislaw.com",
    "lancasterdining.net",
    "lancego.space",
    "lancia.ga",
    "lancia.gq",
    "lancrowd.com",
    "land-4-sale.us",
    "land-ck.com",
    "land.ru",
    "landasanqq.com",
    "landexnetwork.online",
    "landfoster.com",
    "landhq.rest",
    "landingcenter.ru",
    "landlooto.cf",
    "landlooto.ml",
    "landmail.co",
    "landmark.io",
    "landmilmumb.cf",
    "landmilmumb.ga",
    "landmilmumb.gq",
    "landnsky.info",
    "landnsky.org",
    "landofhopeorlando.org",
    "landravphillips.com",
    "landrop.me",
    "landroverrepair.com",
    "landscapeandplanning.com",
    "landstopdrop.space",
    "landsurfigh.ga",
    "landsurfigh.gq",
    "landsurfigh.tk",
    "landtire.ga",
    "landtire.gq",
    "landtire.ml",
    "l\xe1ndwirt.com",
    "lanepoll.com",
    "langclubs.ru",
    "langitbiru.info",
    "langitpoker.org",
    "langk.club",
    "langleycitizen.com",
    "langleycourier.net",
    "langleyfirst.com",
    "langleyfirst.net",
    "langleyfirst.org",
    "langleyherald.org",
    "langleyjournal.net",
    "langleyrecord.com",
    "langleyrecord.org",
    "langleyreview.com",
    "langoo.com",
    "languagera.online",
    "lanha-tours.com",
    "laniferous.site",
    "lanimaresorts.com",
    "lanimasaudi.com",
    "laninna.online",
    "laninternational.com",
    "lanjuecg.com",
    "lankamail.com",
    "lankezhou.com",
    "lanless.net",
    "lanorthface.com",
    "lanquiplod.gq",
    "lanquiplod.ml",
    "lanscieze.club",
    "lantai6.org",
    "lantderdi.cf",
    "lantderdi.gq",
    "lantderdi.ml",
    "lantic.net",
    "lantofe.ga",
    "lantofe.gq",
    "lanyard.plus",
    "lanydar.site",
    "laoeq.com",
    "laoheritage.net",
    "laoho.com",
    "laokzmaqz.tech",
    "laonanrenj.com",
    "laoshandicraft.com",
    "lapak21.video",
    "lapakbanyumas.com",
    "lapakpokers.net",
    "laparbgt.cf",
    "laparbgt.ga",
    "laparbgt.gq",
    "laparbgt.ml",
    "lapeksp.ru",
    "lapetcent.cf",
    "lapetcent.gq",
    "lapetcent.ml",
    "lapetiteetincellecoaching.com",
    "lapita.cf",
    "lapita.gq",
    "lapita.tk",
    "lapizzolettasoria.com",
    "laporinaja.com",
    "laposhe.net",
    "laposte.net",
    "laptopamerica.net",
    "laptopss.xyz",
    "laptopsshop.live",
    "laptrinhapp.top",
    "laptrinhwp.com",
    "lapwas.xyz",
    "laraladies.com",
    "laramail.io",
    "laras.ru",
    "laravelbuilder.com",
    "laredonailsalons.com",
    "laredophysiciansgroup.info",
    "laredophysiciansgroup.net",
    "larepublica.host",
    "larepublica.website",
    "large-cock.com",
    "largech.icu",
    "largechai.icu",
    "largeco.xyz",
    "largedebu.email",
    "largedebut.email",
    "largelift.com",
    "largelyavailable.net",
    "largelyavailable.org",
    "largeshop.futbol",
    "largeteach.email",
    "larisa-firdusovna.ru",
    "larisia.com",
    "larjem.com",
    "larkfieldkebabandpizza.com",
    "larosetantrique.com",
    "larping.dev",
    "larrry.host",
    "larrynichols.news",
    "larrywinn.com",
    "larsen.dk",
    "lasaliberator.org",
    "lasaliberator.us",
    "lasdunsti.cf",
    "lasdunsti.ml",
    "lasdunsti.tk",
    "laser-dental.com",
    "laser88.com",
    "laserevent.com",
    "laserlip.com",
    "lasersaber.com",
    "lasfobiasa.info",
    "lasg.info",
    "lash.email",
    "lasip.org",
    "lasirenatakeaway.com",
    "lasischa.gq",
    "lasischa.ml",
    "lasischa.tk",
    "laskar4d.website",
    "laskarxebe.space",
    "lasnoticias.net",
    "lasojcyjrcwi8gv.cf",
    "lasojcyjrcwi8gv.ga",
    "lasojcyjrcwi8gv.gq",
    "lasojcyjrcwi8gv.ml",
    "lasojcyjrcwi8gv.tk",
    "lass-es-geschehen.de",
    "lasselong.ru",
    "lassunshaltkurzmalso.vision",
    "last-chance.pro",
    "lastbilsmodeller.se",
    "lastchaosraiz.com",
    "lastconn.site",
    "laste.ml",
    "lastenergycall.com",
    "lastmail.co",
    "lastmail.com",
    "lastminute.dev",
    "lastminute365.ru",
    "lastminutemarket.org",
    "lastmx.com",
    "lastogor.xyz",
    "lastpostapp.com",
    "lastskiveline.website",
    "laststand.xyz",
    "lastxxx.com",
    "lasupsi.ga",
    "lasupsi.tk",
    "lasvegasaroundtheclock.com",
    "lasvegasdictionary.com",
    "lasvegastries.com",
    "lasvegasvirusremoval.com",
    "latechnologie.site",
    "latelierduchef.biz",
    "latemail.tech",
    "latemodels.com",
    "latestprojectors.com",
    "lateststylenews.xyz",
    "latexbimbo.com",
    "latheflauntmoral.site",
    "latinmail.com",
    "latino.com",
    "latinonthebeach.com",
    "latitant.xyz",
    "latives.info",
    "latte-ro.com",
    "lattestdaysaints.com",
    "latvene.site",
    "latviansmn.com",
    "latwebmedia.com",
    "latypografille.com",
    "lauderdalebeachsidehotel.com",
    "launcestonpools.com",
    "launch.vote",
    "launchfunnelsecrets.com",
    "launchpadapp.com",
    "launchwithrica.com",
    "laurapliss.com",
    "lauratrapp.org",
    "laurelgrey.org",
    "laurelmountainmustang.com",
    "laurenbt.com",
    "laurenmyers.buzz",
    "laurennolan.buzz",
    "laurenperugini.info",
    "laurentsmadja.com",
    "laursen.dk",
    "lautaroramirez.com",
    "lauthreadce.gq",
    "lauthreadce.tk",
    "lavabit.com",
    "lavache.com",
    "lavaiis.info",
    "lavalleeheureuse.club",
    "lavanamakeup.com",
    "lavastockrom.info",
    "lavazzaturkiye.net",
    "lavendel24.de",
    "lavenderresorts.com",
    "lavendettastadriadebesos.com",
    "lavinity.ru",
    "lavish-cork.com",
    "lavp.de",
    "law-plus.ru",
    "law.com",
    "law2lawyer.com",
    "lawaa317.xyz",
    "lawaifu.pro",
    "lawbmydi.ml",
    "lawbmydi.tk",
    "lawbrsoli.ru",
    "lawcenter-1.ru",
    "lawfia.com",
    "lawioutlets.site",
    "lawlita.com",
    "lawlz.net",
    "lawncorwoo.cf",
    "lawncorwoo.ga",
    "lawncorwoo.gq",
    "lawndaleapartments.com",
    "lawpages.site",
    "lawpress.ru",
    "lawrence1121.club",
    "lawsentinel.com",
    "lawson.cf",
    "lawson.ga",
    "lawson.gq",
    "lawsone.best",
    "lawsubsqua.ga",
    "lawsubsqua.gq",
    "lawsubsqua.ml",
    "lawsuh.com",
    "lawtelegraph.com",
    "lawvii.com",
    "lawyer.com",
    "lawyerinfo.ru",
    "lawyernear-me.com",
    "laxyeu.us",
    "layananemail.com",
    "layarkaca21.uno",
    "layarqq.life",
    "layarqq.loan",
    "laychuatrenxa.ga",
    "laycounre.cf",
    "laycounre.ga",
    "laycounre.ml",
    "laycounre.tk",
    "layonchambers.com",
    "layout-webdesign.de",
    "layquili.cf",
    "layquili.ga",
    "layquili.gq",
    "layquili.ml",
    "layquili.tk",
    "layupixwn.space",
    "lazghem.cf",
    "lazghem.ga",
    "lazghem.gq",
    "lazghem.ml",
    "lazghem.tk",
    "lazizakebab.com",
    "lazy.dk",
    "lazyfire.com",
    "lazyinbox.com",
    "lazyinbox.us",
    "lazymail.me",
    "lazymail.ooo",
    "lazymansmarketingfunnel.com",
    "lazymanssalesfunnel.com",
    "lazymanssalesleads.com",
    "lazyrabbit.org",
    "lazzarincafesaudia.com",
    "lb1333.com",
    "lbamilitarysorority.org",
    "lbbxyhyf.shop",
    "lbe.kr",
    "lbedhm.us",
    "lbhuxcywcxjnh.cf",
    "lbhuxcywcxjnh.ga",
    "lbhuxcywcxjnh.gq",
    "lbhuxcywcxjnh.ml",
    "lbhuxcywcxjnh.tk",
    "lbicamera.com",
    "lbicameras.com",
    "lbicams.com",
    "lbjmail.com",
    "lbox.de",
    "lbpoa.com",
    "lbpoa.net",
    "lbse.net",
    "lbusapac.cf",
    "lbusapac.ga",
    "lbusapac.ml",
    "lbusapac.tk",
    "lbuvfg.us",
    "lbyledindia.icu",
    "lc0eb2.com",
    "lc2jt0.info",
    "lc360.site",
    "lcahzw.info",
    "lcamerapeak.site",
    "lcb63i1bgwe7sxy.xyz",
    "lcboreadytodrink.com",
    "lccweb.org",
    "lcdweixiu.com",
    "lce0ak.com",
    "lcebull.com",
    "lceland.net",
    "lceland.org",
    "lcelander.com",
    "lcelandic.com",
    "lcgqvd.best",
    "lchapl.us",
    "lchecperki.cf",
    "lchecperki.ga",
    "lchecperki.gq",
    "lchecperki.ml",
    "lcirailgroup.com",
    "lckiq1.site",
    "lcumof.ga",
    "ld748.site",
    "ld7z1y.us",
    "ldabconnins.cf",
    "ldabconnins.ml",
    "ldabconnins.tk",
    "ldaho.biz",
    "ldaho.net",
    "ldaho0ak.com",
    "ldaholce.com",
    "ldbet.net",
    "ldbwebdev.com",
    "ldebaat9jp8x3xd6.cf",
    "ldebaat9jp8x3xd6.ga",
    "ldebaat9jp8x3xd6.gq",
    "ldebaat9jp8x3xd6.ml",
    "ldebaat9jp8x3xd6.tk",
    "ldefsyc936cux7p3.cf",
    "ldefsyc936cux7p3.ga",
    "ldefsyc936cux7p3.gq",
    "ldefsyc936cux7p3.ml",
    "ldefsyc936cux7p3.tk",
    "ldentertainment.net",
    "ldgufvctc.shop",
    "ldh80hrnfauehks.xyz",
    "ldlvqf.shop",
    "ldnblockchainweek.com",
    "ldop.com",
    "ldovehxbuehf.cf",
    "ldovehxbuehf.ga",
    "ldovehxbuehf.gq",
    "ldovehxbuehf.ml",
    "ldovehxbuehf.tk",
    "ldssharingtable.com",
    "ldtp.com",
    "ldzg.email",
    "le-book.info",
    "le-diamonds.com",
    "le-speak-show.com",
    "le-tim.ru",
    "le.monchu.fr",
    "le50le5i.shop",
    "le5ile50.shop",
    "lea-ca-ales-ia.online",
    "leabelvei.cf",
    "leabelvei.ga",
    "leabelvei.gq",
    "leabelvei.ml",
    "leachim.org",
    "lead-contact.ru",
    "lead-tour.ru",
    "leadcoat.website",
    "leader-traffic.ru",
    "leaderlawabogados.com",
    "leadermedalsink.website",
    "leaderportes-dz.com",
    "leadersinevents.com",
    "leadgeneration.doctor",
    "leadgeneration.systems",
    "leadingageco.org",
    "leadingemail.com",
    "leadingeu.site",
    "leadmagnetgenerator.com",
    "leadnurseafrica.com",
    "leadsafestlouis.org",
    "leadscentre.online",
    "leadscopy.com",
    "leadsflow.info",
    "leadsintoloans.com",
    "leadssimple.com",
    "leadsystemthatworks.com",
    "leadwojzer.space",
    "leafmanager.com",
    "league0.com",
    "leaguecms.com",
    "leaguedump.com",
    "leakazanclari.com",
    "leakazancplani.com",
    "leakcloaker.online",
    "leakcloaker.xyz",
    "leaked.directory",
    "leakems.org",
    "leakygutawarness.com",
    "lealifen.cf",
    "lealifen.ga",
    "lealifen.gq",
    "lealifen.ml",
    "lealifen.tk",
    "leanedir.com",
    "leanlad.com",
    "leanxtractor.com",
    "leapercliff.top",
    "leapradius.com",
    "leapshoot.com",
    "learn2compute.net",
    "learnalot.xyz",
    "learncore.org",
    "learnearntoday.com",
    "learnhome.org",
    "learning-a1.ru",
    "learning-b2.ru",
    "learning-blog.ru",
    "learning-counts.net",
    "learning-ser.ru",
    "learning-sr.ru",
    "learningbunny.com",
    "learningmakingmoney.com",
    "learningnets.net",
    "learningstylesurvey.org",
    "learnislaminbangla.com",
    "learnmyanmar.online",
    "learnphotoshop.info",
    "learnqolapp.com",
    "learnskillsforlife.us",
    "learnwithvideo.org",
    "lease4less.com",
    "leasecha.icu",
    "leasefling.us",
    "leaseranc.icu",
    "leasero.cf",
    "leasero.ga",
    "leasero.gq",
    "leasero.ml",
    "leasero.tk",
    "leasesoun.email",
    "leasespine.email",
    "leashoes.com",
    "leasnet.net",
    "leather-dozen-warn-third.xyz",
    "leatherseatcovers.net",
    "leaveover.xyz",
    "leaver.ru",
    "leavr.com",
    "lebang.site",
    "lebanonatlas.com",
    "lebanonrealestateagents.com",
    "lebenkapinda.com",
    "lebenskunst.vision",
    "lebilli.cf",
    "lebilli.ml",
    "lebilli.tk",
    "lebo1314.com",
    "lebo134.com",
    "lebo137.com",
    "lebo246.com",
    "lebo7474.com",
    "lebo7733.com",
    "lebtimnetz.de",
    "lecadeaucurtumecasa.com",
    "lecgrowlight.net",
    "lechimgipertoniyu.ru",
    "leclairknives.com",
    "leclubconcept.com",
    "lecsaljuk.club",
    "lecturebmls.email",
    "lecturn.digital",
    "lecturn.online",
    "lecturn.site",
    "lectverli.ga",
    "lectverli.ml",
    "lectverli.tk",
    "lecz6s2swj1kio.cf",
    "lecz6s2swj1kio.ga",
    "lecz6s2swj1kio.gq",
    "lecz6s2swj1kio.ml",
    "lecz6s2swj1kio.tk",
    "led-mask.com",
    "led-spb.ru",
    "led-trainers.com",
    "ledaroy.site",
    "ledarskolan.se",
    "ledcaps.de",
    "leddispsor.cf",
    "leddispsor.ga",
    "leddispsor.tk",
    "lederbehang.com",
    "lediponto.com",
    "ledmedia92.ru",
    "lednlux.com",
    "ledoktre.com",
    "ledoutdoorfloodlights.com",
    "leds-4you.de",
    "ledskor.com",
    "ledticker.ru",
    "lee.mx",
    "leeching.net",
    "leefirm.net",
    "leehom.net",
    "leejihua.com",
    "leelighting-stage.com",
    "leemail.me",
    "leerling.ml",
    "leernoca.monster",
    "leessummitapartments.com",
    "leet.support",
    "leeviate.com",
    "leeyoder.com",
    "lefaqr5.com",
    "lefli.ru",
    "lefortovo.net",
    "leftimouse.com",
    "leftymouse.com",
    "legacyangusranch.com",
    "legacyfinanceblog.club",
    "legacysummit.com",
    "legacytractorsales.com",
    "legal-highs.org",
    "legal.fail",
    "legalactions.com",
    "legalalien.net",
    "legalclub.net",
    "legalizer.website",
    "legalrc.cash",
    "legalrc.loan",
    "legalrobot.dev",
    "legalslot.ru",
    "legalslots.ru",
    "legaly.us",
    "legatine.xyz",
    "legato.agency",
    "legato.dev",
    "legato.media",
    "legend-rpg.ru",
    "legendary2019.ru",
    "legendaryrealtyal.info",
    "legendauthorisetone.website",
    "legendsofnorrath.ru",
    "legendsvegas.com",
    "legiastore.com",
    "legiondesign.ru",
    "legioninvestingleak.com",
    "legionzoocentr.ru",
    "legislator.com",
    "legistrator.com",
    "legitimationsprozess.info",
    "legitimationsservice.info",
    "legitimatizes716hb.online",
    "legitimized162ei.online",
    "legkospet.ru",
    "legocp66.com",
    "legooolise.ru",
    "legozolder.online",
    "legumennvj.online",
    "lehanhphuc.ml",
    "lehelti.ga",
    "lehelti.gq",
    "lehelti.tk",
    "lehman.cf",
    "lehman.ga",
    "lehman.gq",
    "lehman.ml",
    "lehman.tk",
    "lehner576.com",
    "lehoang.online",
    "lehrxira.cf",
    "lehrxira.ga",
    "lehrxira.gq",
    "lehrxira.ml",
    "lei.kr",
    "leifitne.gq",
    "leifitne.ml",
    "leiladismalmufti.site",
    "leinkblabk.site",
    "leisu.link",
    "leisu.ltd",
    "leisu.site",
    "leiteophi.ga",
    "leiteophi.gq",
    "leiteophi.ml",
    "leiteophi.tk",
    "leitestudio.com",
    "leitungsen.de",
    "leituraacelerada.website",
    "leituraagil.website",
    "lekarstva-bezrezeptof.site",
    "lekarstva.info",
    "lekarstvopodnogami.ru",
    "lekeda.ru",
    "lekhanhphi.com",
    "leks.me",
    "lelastar.site",
    "lella.co",
    "lellno.gq",
    "lelove.ru",
    "lemajesticglobal.org",
    "lemano.se",
    "lemantcom.ga",
    "lemantcom.gq",
    "lemantcom.ml",
    "lembarancerita.ga",
    "lembarancerita.ml",
    "lembeh-shootout.com",
    "leminbenp.cf",
    "leminbenp.ga",
    "leminbenp.gq",
    "leminbenp.ml",
    "lemonde-fr.space",
    "lemonde24fr.host",
    "lemonde24fr.site",
    "lemondedufairepart.com",
    "lemongeek.best",
    "lemooreforeclosures.com",
    "lemoshop.com",
    "lemouvement.ngo",
    "lemper.cf",
    "lemycam.ml",
    "lenalimas.info",
    "lenamanh.ga",
    "lenbobit.cf",
    "lenbobit.ml",
    "lenbobit.tk",
    "lenderfacts.com",
    "lendlesssn.com",
    "lendoapp.co",
    "lenestate.ru",
    "lengworcomp.gq",
    "lenhisun.ga",
    "lenhisun.ml",
    "leningrad.space",
    "lenkino.name",
    "lenlinza.ru",
    "lenlusiana5967.ga",
    "lenmawarni5581.ml",
    "lennonthemusical.com",
    "lennurfitria2852.ml",
    "lenovo120s.cf",
    "lenovo120s.gq",
    "lenovo120s.ml",
    "lenovo120s.tk",
    "lenovog4.com",
    "lenpitchna.tk",
    "lenprayoga2653.ml",
    "lenputrima5494.cf",
    "lensbuffs.info",
    "lenscleaningbrush.us",
    "lenscleaningbrushes.biz",
    "lenscleaningbrushes.us",
    "lensservoptical.com",
    "lenta-bukv.ru",
    "lenta-receptov.ru",
    "lenta.ru",
    "lentoarea.com",
    "leoandassoc.com",
    "leohlch.com",
    "leomnascx.xyz",
    "leon-app.ru",
    "leon13.ru",
    "leonardo.it",
    "leonardolobo.top",
    "leonelahmad.cf",
    "leonfamily.ru",
    "leonghupgroup.com",
    "leonians.co.uk",
    "leonlai.net",
    "leopardstyle.com",
    "leopardstyles.com",
    "leoplethbi.ml",
    "leoplethbi.tk",
    "leopon.site",
    "leopuden.ru",
    "leos.org.uk",
    "leosibiot.online",
    "lepadoid.site",
    "lepetitcabanon.com",
    "lepetitensemble.com",
    "lepetitprince.life",
    "lepezh.ru",
    "lepgrowlight.com",
    "lepoxo.xyz",
    "lepretaplanter.com",
    "lepsiobec.sk",
    "lepti-health.com",
    "lepti-science.org",
    "leptin-solution.org",
    "leptisolution.com",
    "leptisolution.org",
    "leptitox-news.org",
    "leptitox-research.com",
    "leptitox-research.org",
    "leptitox-science.org",
    "lequitywk.com",
    "lerbhe.com",
    "lerch.ovh",
    "lercjy.com",
    "lerepo.ga",
    "lerepo.gq",
    "lerepo.ml",
    "lerepo.tk",
    "leribigb.cf",
    "leribigb.ga",
    "leribigb.gq",
    "leribigb.tk",
    "lernerfahrung.de",
    "leroidurelax.com",
    "leroymyers.org",
    "lerwfv.com",
    "les-bons-tomes.com",
    "les-bouquetins.com",
    "lesabahis18.com",
    "lesabahis20.com",
    "lesabahis23.com",
    "lesabahis28.com",
    "lesabahis30.com",
    "lesabahis34.com",
    "lesabahis40.com",
    "lesabahis48.com",
    "lesabahis49.com",
    "lesabahis55.com",
    "lesastroi.ru",
    "lesbugs.com",
    "lesfineslamesdechicoutimi.com",
    "lesgermaines.site",
    "leshang-yl.com",
    "leshiz.website",
    "lesleyhampton.ru",
    "lesmarchesdeparisconnectes.com",
    "lesnistsup.cf",
    "lesnistsup.ga",
    "lesnistsup.gq",
    "lesnistsup.ml",
    "lesnistsup.tk",
    "lesoir-24-be.space",
    "lesoir-24-be.website",
    "lesoir-24be.space",
    "lesoir24.host",
    "lesoir24.space",
    "lespitonsy.info",
    "lespooche.org",
    "lesproekt.info",
    "lesprosdela.photo",
    "lesrecettesdebomma.com",
    "lessdinal.cf",
    "lesseriestreaming.xyz",
    "lesserkcqn.space",
    "lessgime.ga",
    "lessgime.gq",
    "lesslenett.cf",
    "lesslenett.gq",
    "lesslenett.tk",
    "lessnentdar.cf",
    "lessnentdar.ga",
    "lessnentdar.ml",
    "lessnentdar.tk",
    "lestoutes.com",
    "lestoutes.store",
    "leswebmasters.info",
    "letaemvisokovse.xyz",
    "letairbag.com",
    "letempledelavie.paris",
    "letfreedomring.site",
    "lethbridgepropertymanagement.com",
    "lethedtling.xyz",
    "lethitham.ml",
    "letian1999.com",
    "letihsrret.ga",
    "letipue.ru",
    "letmebefrankproduction.com",
    "letmecheck.adult",
    "letmeinonthis.com",
    "letmymail.com",
    "letmypeopleshop.com",
    "letnanqq.com",
    "leto-dance.ru",
    "letras.xyz",
    "letrungtruc.ml",
    "lets-open.com",
    "letschat365.info",
    "letsgomets.net",
    "letsgotech.org",
    "letsgoystoas.site",
    "letsmail9.com",
    "letstalkaboutsex.org",
    "letstestsa.info",
    "letstoeasyearn.xyz",
    "lettelet.cf",
    "lettelet.ga",
    "lettelet.gq",
    "letterbox.com",
    "letterboxes.org",
    "letterfew.online",
    "lettersnew5fact.space",
    "letthemeatspam.com",
    "lettresfree.com",
    "letumeatcake.com",
    "letw1xabmtbuf34.xyz",
    "leukorrhea811cd.online",
    "leurre.xyz",
    "leutromcoo.ga",
    "leutromcoo.ml",
    "leutromcoo.tk",
    "levcentr.ru",
    "level-3.cf",
    "level-3.ga",
    "level-3.gq",
    "level-3.ml",
    "level-3.tk",
    "leveldesign.site",
    "levele.com",
    "levele.hu",
    "levelmebel.ru",
    "levelrat.xyz",
    "levelscal.us",
    "levelupworker.com",
    "levelwre.email",
    "levelwrec.recipes",
    "levendislaw.com",
    "leverbox.online",
    "leverboxpay.com",
    "leviatereview.com",
    "levis-jeans.us",
    "levis-shoes.com",
    "levitic.us",
    "levitron-shop.ru",
    "levitycraft.ru",
    "levy.ml",
    "lew2sv9bgq4a.cf",
    "lew2sv9bgq4a.ga",
    "lew2sv9bgq4a.gq",
    "lew2sv9bgq4a.ml",
    "lew2sv9bgq4a.tk",
    "lewat.ga",
    "lewineryguide.com",
    "lewisbarnes.buzz",
    "lewiseffectfoundation.com",
    "lewiseffectfoundation.org",
    "lewisivbhn.space",
    "lewistweedtastic.com",
    "lewkaki.ru",
    "lex.bg",
    "lexabet.net",
    "lexaha.info",
    "lexdrive.com",
    "lexi.rocks",
    "lexidot.com",
    "lexingtnlaw.com",
    "lexingtonnailsalons.com",
    "lexingtonquote.com",
    "lexis-nexis-mail.com",
    "lexisense.com",
    "lexishoki.net",
    "lexisparkles.fun",
    "lexisparkles.online",
    "lexisparkles.space",
    "lexispoker.online",
    "lexmark.com",
    "lexpowerperks.info",
    "lexu4g.com",
    "lexus138.net",
    "leycryppink.cf",
    "leycryppink.gq",
    "leycryppink.ml",
    "leycryppink.tk",
    "leyesmessenger.shop",
    "leyfamug.gq",
    "leyfamug.tk",
    "leyleori.cf",
    "leyleori.gq",
    "leyleori.ml",
    "leyleori.tk",
    "leysatuhell.sendsmtp.com",
    "lez.se",
    "lezamedia.net",
    "lf-jy.com",
    "lf271.site",
    "lfapku.tokyo",
    "lfc.best",
    "lfcaafazw.shop",
    "lfcdaco.us",
    "lfgtsoft.com",
    "lfhc.email",
    "lfifet19ax5lzawu.ga",
    "lfifet19ax5lzawu.gq",
    "lfifet19ax5lzawu.ml",
    "lfifet19ax5lzawu.tk",
    "lfjjjp.shop",
    "lfruits.com",
    "lftjaguar.com",
    "lfwiki.com",
    "lg-g7.cf",
    "lg-g7.ga",
    "lg-g7.gq",
    "lg-g7.ml",
    "lg-g7.tk",
    "lg88.site",
    "lgclub.org",
    "lgeacademy.com",
    "lgfvh9hdvqwx8.cf",
    "lgfvh9hdvqwx8.ga",
    "lgfvh9hdvqwx8.gq",
    "lgfvh9hdvqwx8.ml",
    "lgfvh9hdvqwx8.tk",
    "lghjgbh89xcfg.cf",
    "lgjiw1iaif.gq",
    "lgjiw1iaif.ml",
    "lgjiw1iaif.tk",
    "lgloo.net",
    "lgloos.com",
    "lgmyholsg.shop",
    "lgt8pq4p4x.cf",
    "lgt8pq4p4x.ga",
    "lgt8pq4p4x.gq",
    "lgt8pq4p4x.ml",
    "lgt8pq4p4x.tk",
    "lgtix.fun",
    "lgubas.space",
    "lgxscreen.com",
    "lgyimi5g4wm.cf",
    "lgyimi5g4wm.ga",
    "lgyimi5g4wm.gq",
    "lgyimi5g4wm.ml",
    "lgyimi5g4wm.tk",
    "lh0hd.us",
    "lh2ulobnit5ixjmzmc.cf",
    "lh2ulobnit5ixjmzmc.ga",
    "lh2ulobnit5ixjmzmc.gq",
    "lh2ulobnit5ixjmzmc.ml",
    "lh2ulobnit5ixjmzmc.tk",
    "lh451.cf",
    "lh451.ga",
    "lh451.gq",
    "lh451.ml",
    "lh451.tk",
    "lh4phi.us",
    "lhda.email",
    "lhkjfg45bnvg.gq",
    "lhmulk.com",
    "lhqc9s.us",
    "lhsdv.com",
    "lhsg4p.us",
    "lhtcdh.com",
    "lhtcdh.xyz",
    "lhtn.email",
    "lhxj.email",
    "li-al.ru",
    "li8vejasmin.com",
    "liabravin.cf",
    "liabravin.ga",
    "liabravin.ml",
    "liabravin.tk",
    "liacos.tech",
    "liacredfun.cf",
    "liacredfun.ga",
    "liacredfun.gq",
    "liadisma.cf",
    "liadisma.ga",
    "liadisma.gq",
    "liadisma.ml",
    "liadreamva.cf",
    "liadreamva.ga",
    "liadreamva.ml",
    "liadreamva.tk",
    "lialaise.tk",
    "liamases.cf",
    "liamases.gq",
    "liamases.ml",
    "liamcyrus.com",
    "liamekaens.com",
    "liamgoodact.ru",
    "liamhosford.com",
    "lianerosebunce.com",
    "lianewsnews.cf",
    "lianewsnews.gq",
    "lianewsnews.ml",
    "lianewsnews.tk",
    "liang.zone",
    "lianhe.in",
    "lianlifang.com",
    "lianmengku.com",
    "lianozovo.net",
    "liaohigh.com",
    "liarath.info",
    "liargroup.com",
    "liargroup.org",
    "liaryo.pro",
    "liaryo.site",
    "liatranat.ga",
    "liatranat.gq",
    "liatranat.ml",
    "liatranat.tk",
    "liaz.fun",
    "libeling328ei.online",
    "libenoun.cf",
    "libenoun.ml",
    "libenoun.tk",
    "libeoweb.info",
    "liber.press",
    "liberalize557we.online",
    "liberalizing483lb.online",
    "liberiaom.com",
    "libero.it",
    "liberomail.com",
    "libertabet4.com",
    "libertarian.network",
    "liberto.it",
    "libertychristianchurch.org",
    "libertyconservativedaily.com",
    "libertycontent.dev",
    "libertydental.info",
    "libertylawnetwork.com",
    "libertymail.info",
    "libertymu5ual.com",
    "libertyskillcenter.com",
    "libertyvf.xyz",
    "libertyvillesaddleshop.com",
    "libidipvde.space",
    "libido.events",
    "libido.wiki",
    "libidopluses.ru",
    "libinailstyle.ru",
    "liboor.com",
    "liboove.com",
    "libox.fr",
    "libpotassium.com",
    "librainvesting.com",
    "libraloan.xyz",
    "librans.co.uk",
    "librarium.org",
    "library-annabi.org",
    "libraryofbussiness.com",
    "librielibri.info",
    "libroncos.com",
    "libuna.info",
    "licaipa.xyz",
    "licence.legal",
    "licenserights.com",
    "licensestore.ru",
    "licensingsalestool.com",
    "lichthidauworldcup.net",
    "lichtstark.media",
    "licinusrance.com",
    "licitando.com",
    "lick101.com",
    "liclifeinusrance.com",
    "licof.us",
    "licontu.cf",
    "licontu.ga",
    "licontu.gq",
    "licorne.ml",
    "licycnint.cf",
    "licycnint.ga",
    "licycnint.gq",
    "licycnint.ml",
    "liddr.com",
    "lidepre.cf",
    "lidepre.ga",
    "lidepre.ml",
    "lideravtoshkola.ru",
    "liderbahis2.com",
    "liderbahis52.com",
    "liderbahis78.com",
    "liderbahis82.com",
    "liderbahis97.com",
    "lidercert.com",
    "lido.site",
    "lidprep.vision",
    "lidwa.net",
    "liebenswerter.de",
    "liebesbeweis-reise.com",
    "liebesbeweisreise.com",
    "liebesparade.party",
    "lieblingsmann.love",
    "liebt-dich.info",
    "liedjesaanvragen.online",
    "liedjesaanvragen.site",
    "liedjesaanvragen.space",
    "lieeliev.shop",
    "liefanaticjar.website",
    "lieflorul.cf",
    "lieflorul.ga",
    "lieflorul.gq",
    "lieflorul.tk",
    "liefracbo.cf",
    "liefracbo.ga",
    "liefracbo.tk",
    "liegarbu.cf",
    "liegarbu.ga",
    "liegarbu.ml",
    "liegarbu.tk",
    "lienutile.com",
    "liepaven.ga",
    "liepu3vjxfuov06.xyz",
    "liesesscont.cf",
    "liesesscont.ga",
    "liesesscont.ml",
    "liesesscont.tk",
    "lifanapp.com",
    "lifanblog.com",
    "life-bets.ru",
    "life-coder.com",
    "life-online1.ru",
    "life-smile.ru",
    "life17.icu",
    "life22.icu",
    "lifeafterlabels.org",
    "lifebloominvest.ru",
    "lifebyfood.com",
    "lifebythegrapes.com",
    "lifecoach4elite.net",
    "lifedens.online",
    "lifefamilly.com",
    "lifefinanceblog.club",
    "lifeforceschool.com",
    "lifeguru.online",
    "lifeinsurancecoverageguaranteed.com",
    "lifeinsuranceforcancerpatient.com",
    "lifeinsurancewithnoquestions.com",
    "lifeirrigationgardens.com",
    "lifeisapingpong.com",
    "lifeisgood.uno",
    "lifejaszzzv.email",
    "lifekazino.ru",
    "lifemail.tech",
    "lifeofacowboy.com",
    "lifeperformers.com",
    "lifeprotips.org",
    "lifes-days.club",
    "lifesaglitch.tv",
    "lifestyle-trends-today.com",
    "lifestyle24x7.com",
    "lifestyleretail.website",
    "lifestylerunsbig.com",
    "lifesupportband.com",
    "lifetalkrc.org",
    "lifetime-income.org",
    "lifetimeappdeal.com",
    "lifetimeappdeals.com",
    "lifetimecms.com",
    "lifetimefriends.info",
    "lifetimeincomejournal.com",
    "lifetotech.com",
    "lifetransition.info",
    "lifetribes.net",
    "lifeuh.com",
    "lifevantageqc.com",
    "lifewirekeys.com",
    "lifeyogaelements.net",
    "liffebody.host",
    "liffebody.site",
    "liffebody.store",
    "lift-renew.com",
    "lifted.cc",
    "liftforwardstore.com",
    "liftharmfulloll.website",
    "liftingbridges.org",
    "liftitcargo.com",
    "liftticketsystem.com",
    "liftvblh.space",
    "liga-kamcartit.ru",
    "liga.my",
    "liga108.club",
    "liga228.fun",
    "liga88.website",
    "ligadc.club",
    "ligadepo.com",
    "ligagame.net",
    "ligahoki168.com",
    "ligai.ru",
    "ligaku.com",
    "ligaolmecaoficial.net",
    "ligaolmecaoficial.org",
    "ligapalapa.org",
    "ligasbo.club",
    "ligastavki.ru",
    "ligastavok-app.ru",
    "ligaz888.com",
    "ligazth888.com",
    "ligbet25.com",
    "ligerautos.info",
    "lighcolve.cf",
    "lighcolve.ga",
    "lighcolve.gq",
    "lighcolve.ml",
    "lighcolve.tk",
    "ligheveng.ru",
    "lighhecktof.world",
    "lighnucta.ga",
    "light-android.space",
    "light-beauty.ru",
    "light-marketing.ru",
    "lightbcrny.space",
    "lightbild.ru",
    "lightboxelectric.com",
    "lightboxsigns.com",
    "lightca.icu",
    "lightcenter.top",
    "lightcrop.ru",
    "lightdog.ru",
    "lighthouseinvestments.org",
    "lightinggalleryoc.net",
    "lightivor.icu",
    "lightlabel.com",
    "lightningcomputers.com",
    "lightofasia.ml",
    "lightognivo.ru",
    "lightplut.ru",
    "lightpower.pw",
    "lightrumo.xyz",
    "lightseekers.chat",
    "lightseekers.games",
    "lightseekers.stream",
    "lightserv.net",
    "lightshar.xyz",
    "lightspeed.store",
    "lightspeedgolf.app",
    "lightswea.icu",
    "lightvid.ru",
    "lightvivo.ru",
    "lighvanrau.ga",
    "ligobet56.com",
    "ligobet59.com",
    "ligsb.com",
    "ligtvkafe.website",
    "lihaoxiaoxi.com",
    "lihjmb.icu",
    "liitokala.cf",
    "liitokala.ga",
    "liitokala.gq",
    "liitokala.ml",
    "liitokala.tk",
    "lijeuki.co",
    "lijwlwkd.shop",
    "likability992hc.online",
    "likeable.social",
    "likedz.world",
    "likelucky.ru",
    "likemauscub.ru",
    "likemausfield.ru",
    "likemausfog.ru",
    "likemausrose.ru",
    "likemilkingacow.com",
    "likeonline.xyz",
    "likepoe.space",
    "likeproekt.ru",
    "likes-pie.com",
    "likescandy.com",
    "likesyouback.com",
    "liketobuy.ru",
    "likevipfb.cf",
    "lilactrustnoble.site",
    "lilianmagdalen.com",
    "lilifer.ga",
    "lilifer.gq",
    "lilifer.tk",
    "lilittka.cf",
    "lilittka.gq",
    "lilittka.tk",
    "liliyakunitskaya.ru",
    "lillemap.net",
    "lilliejeter.com",
    "lilo.me",
    "lilyclears.com",
    "lilyjeter.com",
    "lilylee.com",
    "lilyverywell.com",
    "limacitasa.info",
    "limacology.xyz",
    "limahfjdhn89nb.tk",
    "limang.ru",
    "limberzbmn.space",
    "limboflow.com",
    "limboo.ga",
    "limcorp.net",
    "lime-cb8.com",
    "limee.ru",
    "limeleaftakeaway.com",
    "limeline.in",
    "limetreetraining.com",
    "limilime.shop",
    "liminality.info",
    "liming.de",
    "limitless-request.net",
    "limnhaisbag.website",
    "limon.biz.tm",
    "limon1.bet",
    "limon3.bet",
    "limonadainc.com",
    "limonapi.com",
    "limonfill.com",
    "limpa-chamine.com",
    "limpeza-de-chamine.com",
    "limpoponationalpark.org",
    "limumuee.club",
    "limumuee.site",
    "linap1.site",
    "lincahqq.info",
    "lincahqq.net",
    "lincahqq.org",
    "lincolnnailsalons.com",
    "lindaclothing.com",
    "lindaxa.site",
    "lindbarsand.cf",
    "lindbarsand.ga",
    "lindbarsand.gq",
    "lindbarsand.tk",
    "lindenbaumjapan.com",
    "lindendaleridge.com",
    "lindendentists.com",
    "linders.icu",
    "lindo-dublin.com",
    "lindsayjanestore.com",
    "lindsaylangford.com",
    "lindseyallen.net",
    "lindwards.info",
    "linea-stile.ru",
    "lineadesoporte.com",
    "linearapp.com",
    "linejust.info",
    "linenelbo.fun",
    "linenhe.buzz",
    "linenlim.xyz",
    "linenstudy.buzz",
    "lineode.com",
    "lineode.net",
    "lineone.net",
    "linerneitheronset.site",
    "linforthwith.cf",
    "linforthwith.ga",
    "linforthwith.ml",
    "lingang.city",
    "lingmarbi.cf",
    "lingmarbi.tk",
    "lingmulbe.cf",
    "lingmulbe.ml",
    "lingpicsu.cf",
    "lingpicsu.ga",
    "lingpicsu.gq",
    "lingpicsu.ml",
    "lingpicsu.tk",
    "linguistic.ml",
    "lingyuncq.com",
    "lininas-auvim.ru",
    "linind.ru",
    "liningnoses.top",
    "link.cloudns.asia",
    "link2dolar.xyz",
    "link2go.online",
    "link2mail.net",
    "link3mail.com",
    "link98.site",
    "linkalternatif.site",
    "linkandluggage.com",
    "linkbet88.club",
    "linkbet88.info",
    "linkbet88.online",
    "linkbet88.org",
    "linkbet88.xyz",
    "linkbuilding.pro",
    "linkcibaba.site",
    "linkedintuts2016.pw",
    "linkedupdesign.com",
    "linkgoitr.ml",
    "linkhound.net",
    "linkibcbet.club",
    "linkingcablebest.faith",
    "linkloadingloom.website",
    "linkmadang1.com",
    "linkmam2.com",
    "linkmanialiga.website",
    "linkmaniaqq.live",
    "linkmaniaqq.online",
    "linkmaniaqq.website",
    "linkmaster.com",
    "linkmaxbet.xyz",
    "linkmehrcrom.cf",
    "linkod.press",
    "linkpaneli.online",
    "linkredirekt.ru",
    "linkrun.xyz",
    "links-age.com",
    "linksbobet.mobi",
    "linkscy.com",
    "linkserver.es",
    "linksgold.ru",
    "linksmaximiser.com",
    "linkstinad.cf",
    "linkstinad.ga",
    "linkstinad.gq",
    "linkstinad.tk",
    "linksysrouterlogin.net",
    "linktown1.net",
    "linktown2.com",
    "linktown2.net",
    "linktrader.com",
    "linku-2.icu",
    "linku-3.icu",
    "linkwithstyle.store",
    "linkyard.net",
    "linkzimra.cf",
    "linkzimra.ml",
    "linkzimra.tk",
    "linlowebp.cf",
    "linlowebp.ga",
    "linlowebp.gq",
    "linlowebp.ml",
    "linlowebp.tk",
    "linodecdn.org",
    "linodevps.com",
    "linostakeaway.com",
    "linpie.com",
    "linsabe.cf",
    "linsabe.ga",
    "linsabe.gq",
    "linsabe.ml",
    "linsabe.tk",
    "linsang.site",
    "linshiyouxiang.net",
    "linshuhang.com",
    "linsila.com",
    "linsoutorf.com",
    "linsoutorf.icu",
    "linspalace-ringsend.com",
    "linux.7m.ro",
    "linuxfreemail.com",
    "linuxguru.network",
    "linuxmade.ru",
    "linuxmail.com",
    "linuxmail.org",
    "linuxmail.so",
    "linuxmail.tk",
    "linuxpl.eu",
    "linx.email",
    "linzacolor.ru",
    "liodernlen.ga",
    "liodernlen.gq",
    "liodernlen.ml",
    "liodernlen.tk",
    "lion-and-rose.ru",
    "lionbet777.info",
    "lionbullion.org",
    "lioncoin.info",
    "lionize.dev",
    "lionize.page",
    "lionnitrousloth.website",
    "lionplas.ga",
    "lionqq.com",
    "lions.gold",
    "lionsfan.com.au",
    "lionsmoh.com",
    "lionsmoh.net",
    "liontrucks.com",
    "lipasda.cf",
    "liphesa.cf",
    "liphesa.ga",
    "liphesa.gq",
    "liphesa.ml",
    "liphesa.tk",
    "lipmanbetx.com",
    "lipoqiuqiu.org",
    "liporecovery.com",
    "liposuction-procedure-now.rocks",
    "liposuction-procedure-site.live",
    "lipozinweightloss.com",
    "lipskydeen.ga",
    "liputen.cf",
    "liputen.ga",
    "lipweiness.cf",
    "lipweiness.gq",
    "lipweiness.ml",
    "liqorice.com",
    "liquidfastrelief.com",
    "liquidherbalincense.com",
    "liquidinformation.net",
    "liquidmail.de",
    "lirabetpartners.com",
    "liraclinical.net",
    "lirats.com",
    "lirikkuy.cf",
    "lirili.info",
    "lirratobacco.online",
    "lirratobacco.xyz",
    "lisabecclothing.com",
    "lisabosborn.com",
    "lisacorino55places.com",
    "lisafoxy.website",
    "lisagenkigibson.com",
    "lisahazletonclothing.com",
    "lisakiss.website",
    "lisansmerkezi.xyz",
    "lisaqchinesecuisine.com",
    "lisaslensphoto.com",
    "lisasolventlove.website",
    "lisastyle.se",
    "lisboagamesworld.com",
    "lisbon-guesthouse.com",
    "lisciotto.com",
    "lisemene.com",
    "lishi321.xyz",
    "lissamail.com",
    "list.moe",
    "list.ru",
    "listen-to-her.info",
    "listentogoodsay.club",
    "listentowhatisaynow.club",
    "listentowhatisaystar.club",
    "listentowhatisaystudio.club",
    "listentowhatisaytech.club",
    "listentowhatistate.club",
    "listentowhatsaid.club",
    "listentowhensay.club",
    "listimi.ga",
    "listimi.gq",
    "listimi.tk",
    "listingleadsforyou.biz",
    "listingsnob.com",
    "listme.best",
    "listmoe.com",
    "listofmovies.website",
    "listomail.com",
    "listopay.net",
    "listspider.com",
    "listtagshopshop.com",
    "listthehyt.ga",
    "lit-plast.ru",
    "litbnno874tak6nc2oh.cf",
    "litbnno874tak6nc2oh.ga",
    "litbnno874tak6nc2oh.ml",
    "litbnno874tak6nc2oh.tk",
    "litchivietnam.com",
    "lite-bit.com",
    "litearyfaeriepublishing.com",
    "litebit.sk",
    "litecos.com",
    "litedrop.com",
    "liteify.xyz",
    "liteikin.ru",
    "litemineservers.ru",
    "litenero.info",
    "litepay.space",
    "literallywrotethebook.com",
    "literallywrotethebookon.com",
    "literallywrotethebookseries.com",
    "literarum.website",
    "literaryweddings.com",
    "literatecamel.com",
    "literatecamel.net",
    "literaturelover.com",
    "litetolife.com",
    "lithoist.com",
    "lithuangpu.world",
    "litici.cf",
    "litici.tk",
    "lititua.cf",
    "lititua.ga",
    "lititua.gq",
    "litom.icu",
    "litrenativo.com",
    "litrgol.ru",
    "little-backpacks.com",
    "littleapple.com",
    "littlebamboo.org",
    "littleblackleaf.com",
    "littleblueroom.com",
    "littlebox.site",
    "littlebuddha.info",
    "littlecaprice.site",
    "littlechip-inn-rush.com",
    "littlecppa.space",
    "littleheartpie.com",
    "littleindiaphibsboro.com",
    "littlejerusalemrathmines.com",
    "littlekasino.com",
    "littleneroni.com",
    "littlepetesphilly.com",
    "littlepotato.org",
    "littlepreview.com",
    "littleroach.net",
    "littlescouts.com",
    "litvinovarchitects.com",
    "litwickimedia.com",
    "liu.se",
    "liucher.host",
    "liul14.app",
    "liul19.app",
    "liul2.app",
    "liul21.app",
    "liul23.app",
    "liul25.app",
    "liul28.app",
    "liul3.app",
    "liul31.app",
    "liul32.app",
    "liul36.app",
    "liul37.app",
    "liul38.app",
    "liul39.app",
    "liul43.app",
    "liul45.app",
    "liul48.app",
    "liul5.app",
    "liul7.app",
    "lius.info",
    "liuvplus.su",
    "liuyijun.me",
    "liuyiyis.xyz",
    "liv3jasmin.com",
    "liva-der.com",
    "livakum-autolar.ru",
    "livall-bling.online",
    "livcam.online",
    "live-casinos-online.com",
    "live-ep.com",
    "live-gaming.net",
    "live-perisa.com",
    "live-pop.com",
    "live-shop24.ru",
    "live-woman.ru",
    "live.at",
    "live.be",
    "live.ca",
    "live.cl",
    "live.cn",
    "live.co.kr",
    "live.co.uk",
    "live.co.za",
    "live.com",
    "live.com.ar",
    "live.com.au",
    "live.com.mx",
    "live.com.my",
    "live.com.pt",
    "live.com.sg",
    "live.de",
    "live.dk",
    "live.fr",
    "live.hk",
    "live.ie",
    "live.in",
    "live.it",
    "live.jp",
    "live.mdx.ac.uk",
    "live.nl",
    "live.no",
    "live.ru",
    "live.se",
    "live.ucl.ac.uk",
    "live.vu.edu.au",
    "live2.icu",
    "live24dns.com",
    "live2d.moe",
    "live4life.online",
    "liveaboardtheconception.com",
    "liveadultcams.org",
    "liveamericans.com",
    "livebet75.com",
    "livebraverish.com",
    "livecare.info",
    "livecric.info",
    "livederbygirls.com",
    "livedosug.com",
    "liveemail.xyz",
    "livefo.works",
    "livefo.xyz",
    "liveforeverphotos.com",
    "livegolftv.com",
    "livehk.online",
    "livejasminhd.com",
    "livekid.net",
    "livekurs.ru",
    "liveles.cf",
    "liveles.gq",
    "livelinessinstitute.com",
    "livellyme.com",
    "livelylawyer.com",
    "livemail.pro",
    "livemarketquotes.com",
    "livemoviehd.site",
    "livenode.info",
    "livenode.org",
    "liveradio.tk",
    "liverfcshop.com",
    "liverpoolfans.com",
    "liverpoollaser.com",
    "livesamet.com",
    "livesgp.best",
    "livesgp.kim",
    "livesgp.monster",
    "liveskiff.us",
    "livestreamingnfl.com",
    "livetimlifestyle.com",
    "liviahotel.net",
    "livingbeyondbethesdaministries.org",
    "livingclone.com",
    "livinginsurance.eu",
    "livingmarried.com",
    "livingmetaphor.org",
    "livingprojectcontainer.com",
    "livingsalty.us",
    "livingshoot.com",
    "livingsimplybeautiful.info",
    "livingsimplybeautiful.net",
    "livingsmart.press",
    "livn.de",
    "livrare-rapida.info",
    "livrepas.club",
    "livriy.com",
    "livs.online",
    "liwa.site",
    "liwa1-afekis.ru",
    "liwondenationalpark.com",
    "lixian8.com",
    "lixin1688.net",
    "lixo.loxot.eu",
    "liyaxiu.com",
    "liybt.live",
    "lizardrich.com",
    "lizclothig.com",
    "lizenzzentrale.com",
    "lizjacket.com",
    "lizom.academy",
    "lizpafe.gq",
    "lizziegraceallen.com",
    "lj8c7u.info",
    "ljewelrymost.site",
    "ljhjhkrt.cf",
    "ljhjhkrt.ga",
    "ljhjhkrt.ml",
    "ljiljan.com",
    "ljnapp.best",
    "ljpremiums.xyz",
    "ljsafkdua.shop",
    "ljungsbro-sportfiskare.se",
    "ljunrockcheck.tk",
    "ljye2f.info",
    "lk21.website",
    "lkbmjm.fun",
    "lkcmmw.fun",
    "lkdmpx.fun",
    "lkerito.mobi",
    "lkfblewfefew2eew.club",
    "lkfeybv43ws2.cf",
    "lkfeybv43ws2.ga",
    "lkfeybv43ws2.gq",
    "lkfeybv43ws2.ml",
    "lkfeybv43ws2.tk",
    "lkfmby.fun",
    "lkgn.se",
    "lkhmzn.fun",
    "lkim1wlvpl.com",
    "lkjghn.com",
    "lkkmqy.fun",
    "lklmgy.fun",
    "lkmlksilkma.design",
    "lknmcg.fun",
    "lko.co.kr",
    "lko.kr",
    "lkooksmart.com",
    "lkoqmcvtjbq.cf",
    "lkoqmcvtjbq.ga",
    "lkoqmcvtjbq.gq",
    "lkoqmcvtjbq.ml",
    "lkoqmcvtjbq.tk",
    "lkpress.ru",
    "lkqmcj.fun",
    "lksuej.info",
    "lktix.fun",
    "lkwmhl.fun",
    "lkxloans.com",
    "lkymng.fun",
    "lkzmtj.fun",
    "ll47.net",
    "ll4cki.us",
    "ll6l4le.xyz",
    "llamame.online",
    "llandudno.com",
    "llangollen.com",
    "llccheckbook.com",
    "llcs.xyz",
    "llegitnon.ga",
    "llegitnon.gq",
    "llegitnon.tk",
    "llerchaougin.ga",
    "llerchaougin.gq",
    "llerchaougin.ml",
    "llerchaougin.tk",
    "llil.icu",
    "llkp.xyz",
    "llllll.tech",
    "lllllll.site",
    "lllooch.ru",
    "llogin.net",
    "llogin.ru",
    "llotfourco.ga",
    "llotfourco.gq",
    "llotfourco.tk",
    "llsaa.com",
    "llsszh.xyz",
    "lltibtuis7.uno",
    "llventures.co",
    "llzali3sdj6.cf",
    "llzali3sdj6.ga",
    "llzali3sdj6.gq",
    "llzali3sdj6.ml",
    "llzali3sdj6.tk",
    "lm-wadakan.com",
    "lm0k.com",
    "lm1.de",
    "lm4dk6.com",
    "lmav17n.xyz",
    "lmav3y8.xyz",
    "lmav5ek.xyz",
    "lmav6ua.xyz",
    "lmavcfy.xyz",
    "lmavegm.xyz",
    "lmavfov.xyz",
    "lmavksy.xyz",
    "lmavqlg.xyz",
    "lmavyb9.xyz",
    "lmcudh4h.com",
    "lmitxg.us",
    "lmkspz.us",
    "lmomentsf.com",
    "lmqx.email",
    "lmxmail.sk",
    "lmypasla.gq",
    "lmypasla.ml",
    "lmypasla.tk",
    "ln0hio.com",
    "ln0rder.com",
    "ln0ut.com",
    "ln0ut.net",
    "ln9uih.us",
    "lnank.live",
    "lnbtc.ru",
    "lncjh.com",
    "lncoin.ru",
    "lncredibleadventures.com",
    "lndex.net",
    "lndex.org",
    "lneus.club",
    "lngscreen.com",
    "lngwhjtk.shop",
    "lnjgco.com",
    "lnko.site",
    "lnmbeauty.com",
    "lnmbeauty.net",
    "lnmdje.us",
    "lnnic.com",
    "lnongqmafdr7vbrhk.cf",
    "lnongqmafdr7vbrhk.ga",
    "lnongqmafdr7vbrhk.gq",
    "lnongqmafdr7vbrhk.ml",
    "lnongqmafdr7vbrhk.tk",
    "lnr9ry.us",
    "lns-411.net",
    "lnsilver.com",
    "lnternatlonal-bittrex.com",
    "lnvd.email",
    "lnvoke.net",
    "lnvoke.org",
    "lnwiptv.com",
    "lnxwalt.org",
    "lo9ege.xyz",
    "loa-kanaloa.org",
    "loa22ttdnx.cf",
    "loa22ttdnx.ga",
    "loa22ttdnx.gq",
    "loa22ttdnx.ml",
    "loa22ttdnx.tk",
    "loachrisfal.cf",
    "loachrisfal.ml",
    "loachrisfal.tk",
    "loadby.us",
    "loadfree.site",
    "loadingya.com",
    "loan101.pro",
    "loan2.xyz",
    "loan5.xyz",
    "loan6.xyz",
    "loan7.xyz",
    "loan9.xyz",
    "loaneotal.cf",
    "loaneotal.ml",
    "loaneotal.tk",
    "loanins.org",
    "loans4u5.us",
    "loaoa.com",
    "loapq.com",
    "loaprofin.ga",
    "loaprofin.ml",
    "loaprofin.tk",
    "lobahgla.xyz",
    "lobbyist.com",
    "lobictubly.xyz",
    "loblaw.twilightparadox.com",
    "lobotomize516vk.online",
    "loc123.com",
    "locabet67.com",
    "locabet68.com",
    "locabet69.com",
    "locabet70.com",
    "locabet71.com",
    "locabet72.com",
    "locabet74.com",
    "locabet75.com",
    "locabet76.com",
    "locabet77.com",
    "locabet78.com",
    "locabet79.com",
    "locabet84.com",
    "locabet90.com",
    "locabet92.com",
    "locabet93.com",
    "locabet95.com",
    "locabet96.com",
    "locabet98.com",
    "locablu.com",
    "local-onlinedating3.com",
    "local.training",
    "local120.com",
    "local120.net",
    "local2164.com",
    "local411jobs.xyz",
    "local77777.com",
    "localbar.com",
    "localbitcoin.tech",
    "localbuilder.xyz",
    "localcarrentals.ru",
    "localchiangmai.com",
    "localddsnearme.com",
    "localempleo.com",
    "localgenius.com",
    "localheroes.ru",
    "localhomepro.com",
    "localini.com",
    "localinternetbrandingsecrets.com",
    "localintucson.com",
    "localiqemail.com",
    "localityhq.com",
    "localnewstime.site",
    "localorthodontistnearme.com",
    "localpassport.org",
    "localppc.us",
    "localsem.us",
    "localserv.no-ip.org",
    "localshredding.com",
    "localvideoclips.com",
    "localwomen-meet.cf",
    "localwomen-meet.ga",
    "localwomen-meet.gq",
    "localwomen-meet.ml",
    "locamoja.com",
    "locanto1.club",
    "locantofuck.top",
    "locantospot.top",
    "locantowsite.club",
    "located6j.com",
    "locateme10.com",
    "locationvibe.com",
    "locbbs.com",
    "locellus.xyz",
    "lockacct.com",
    "lockdown.africa",
    "lockedintheconception.com",
    "lockedsyz.com",
    "lockersinthecity.com",
    "locklisa.cf",
    "locklisa.ga",
    "locklisa.gq",
    "locklisa.ml",
    "locklisa.tk",
    "lockmyaccount.com",
    "locksis.site",
    "locksmangaragedoors.info",
    "locksmithcourses.us",
    "locksync.com",
    "locoblogs.com",
    "locoloco.ovh",
    "locoloco.shop",
    "locomobile.xyz",
    "locomodev.net",
    "loconetinvestments.org",
    "locoonoo.xyz",
    "locos.com",
    "locose.xyz",
    "locpecom.cf",
    "locpecom.gq",
    "locra.com",
    "locwiki.com",
    "lodefidel.com",
    "loders.ru",
    "lodevil.cf",
    "lodevil.ga",
    "lodevil.gq",
    "lodevil.tk",
    "lodewijk.coach",
    "lodgecolibrionline.com",
    "lodgemerc.fun",
    "lodgeparktc.com",
    "lodgetouch.buzz",
    "lodgetrend.fun",
    "lodgewast.space",
    "lodiapartments.com",
    "lodistri.com",
    "lodkataxi.ru",
    "lodur.best",
    "lofi.systems",
    "loft-stile.ru",
    "lofteone.ru",
    "log-manga.ru",
    "logaelda603.ml",
    "logambola88.com",
    "logamqq.online",
    "loganisha253.ga",
    "loganrussacklaw.com",
    "loganstewartrealty.net",
    "logardha605.ml",
    "logartika465.ml",
    "logatarita892.cf",
    "logatarita947.tk",
    "logavrilla544.ml",
    "logdewi370.ga",
    "logdufay341.ml",
    "logefrinda237.ml",
    "logertasari851.cf",
    "logesra202.cf",
    "logeva564.ga",
    "logfauziyah838.tk",
    "logfika450.cf",
    "logfitriani914.ml",
    "logfrisaha808.ml",
    "loghermawaty297.ga",
    "loghermawaty297.ml",
    "loghermawaty297.tk",
    "loghning469.cf",
    "loghusnah2.cf",
    "logicielsvinity.com",
    "logiclaser.com",
    "logicpowerbooster.com",
    "logike708.cf",
    "login-email.cf",
    "login-email.ga",
    "login-email.ml",
    "login-email.tk",
    "login-moon.xyz",
    "login-to.online",
    "logindominoonline.com",
    "logingar.cf",
    "logingar.ga",
    "logingar.gq",
    "logingar.ml",
    "loginlapp.com",
    "loginoff.su",
    "loginpage-documentneedtoupload.com",
    "logins.page",
    "logins.ru",
    "logintoemail.online",
    "logismi227.ml",
    "logisti-k.global",
    "logistica40.com",
    "logistica40.net",
    "logisticscorp.us",
    "logitechg.online",
    "logmardhiyah828.ml",
    "logmatoys.ru",
    "logmaureen141.tk",
    "logmoerdiati40.tk",
    "lognadiya556.ml",
    "lognoor487.cf",
    "logodesignshark.com",
    "logoktafiyanti477.cf",
    "logos.team",
    "logos.vlaanderen",
    "logosbet.com",
    "logosooo.ru",
    "logpabrela551.ml",
    "logrialdhie62.ga",
    "logrialdhie707.cf",
    "logrozi350.tk",
    "logs.xyz",
    "logsharifa965.ml",
    "logsinuka803.ga",
    "logstefanny934.cf",
    "logsutanti589.tk",
    "logsyarifah77.tk",
    "logtanuwijaya670.tk",
    "logtheresia637.cf",
    "logtiara884.ml",
    "logular.com",
    "logutomo880.ml",
    "logvirgina229.tk",
    "logw735.ml",
    "logwan245.ml",
    "logwibisono870.ml",
    "logwulan9.ml",
    "logyanti412.ga",
    "loh.pp.ua",
    "lohipod.site",
    "lohsrestaurant.com",
    "loife5l.xyz",
    "loikoi.store",
    "loin.in",
    "loischilds.com",
    "lojacane.com",
    "lojacentrobenessere.shop",
    "lojaibizas.info",
    "lojajled.com",
    "lojasmax.ml",
    "lojistiklashing.com",
    "lojkjcwj.shop",
    "lojy.site",
    "lok3.site",
    "lokcl.us",
    "loker4d.pro",
    "lokerupdate.me",
    "loketa.com",
    "lokingmi.cf",
    "lokingmi.gq",
    "lokingmi.ml",
    "lokitwcx.space",
    "lokum.nu",
    "lokzhguof.shop",
    "lol.com",
    "lol.it",
    "lol.ovpn.to",
    "lol2020.online",
    "lol2020.site",
    "lolco.xyz",
    "lole.link",
    "lolfhxvoiw8qfk.cf",
    "lolfhxvoiw8qfk.ga",
    "lolfhxvoiw8qfk.gq",
    "lolfhxvoiw8qfk.ml",
    "lolfhxvoiw8qfk.tk",
    "lolfreak.net",
    "loli123.com",
    "loli3.com",
    "loli8.space",
    "loli88.space",
    "loliacg.com",
    "lolianime.com",
    "loliapp.com",
    "lolibox.ml",
    "lolibuy.com",
    "lolimail.cf",
    "lolimail.com",
    "lolimail.ga",
    "lolimail.gq",
    "lolimail.ml",
    "lolimail.tk",
    "lolimailer.gq",
    "lolimailer.ml",
    "lolimailer.tk",
    "lolitka.cf",
    "lolitka.ga",
    "lolitka.gq",
    "lolito.tk",
    "lolivip.com",
    "lollard.best",
    "lolllipop.stream",
    "lolmail.biz",
    "lolnetwork.net",
    "lolnow.store",
    "lolnow.xyz",
    "lolposters.com",
    "lolpro.club",
    "lolpro.space",
    "lols.store",
    "lolshirts.net",
    "lolshirts.org",
    "lolspace.xyz",
    "lolstore.xyz",
    "lolwtf.1337.cx",
    "lom-vid8.site",
    "lom.kr",
    "lomahskdbag.website",
    "lomanget.ru",
    "lombard-zvonok.ru",
    "lombok-spas.com",
    "lombokbeachvillas.com",
    "lomboksparesort.com",
    "lombokspas.com",
    "lomistores.site",
    "lompocplumbers.com",
    "lomwnomwns.club",
    "lon7e.buzz",
    "loncoca.org",
    "lonct.icu",
    "londh.site",
    "london-live.info",
    "london.com",
    "london2.space",
    "londondesign.ru",
    "londondotcom.com",
    "londonfootspecialists.com",
    "londonpoker77.org",
    "londontheatrereview.com",
    "lonelyshe.com",
    "lonezoos.info",
    "long-blog.site",
    "long-blog.space",
    "long-blog24.host",
    "long-differ.xyz",
    "long-sin-takeaway.com",
    "long.idn.vn",
    "longanltd.info",
    "longanltd.net",
    "longanltd.org",
    "longanvietnamese.com",
    "longbeachislandcam.com",
    "longbeachquote.com",
    "longbl0g.space",
    "longblog24.host",
    "longboatkey.store",
    "longboatwines.com",
    "longchaflong.cf",
    "longchaflong.gq",
    "longchaflong.ml",
    "longer-aboard-hungry-wheat.xyz",
    "longerb.website",
    "longidaza-rf.ru",
    "longio.org",
    "longislandvero.com",
    "longmontpooltablerepair.com",
    "longtime.us",
    "longueur.site",
    "lonthe.ml",
    "loobie.com",
    "look4chocolate.ru",
    "looketop.site",
    "lookfeelflowbetter.com",
    "lookingthe.com",
    "lookinsideimaging.com",
    "looklikecheap.site",
    "lookminor.tk",
    "lookmymoney.ru",
    "looknikes.ru",
    "looksmart.co.uk",
    "looksmart.com",
    "looksmart.com.au",
    "lookugly.com",
    "lookupworks.com",
    "loongrtk.tk",
    "loonlite.com",
    "loooms.icu",
    "loopcrashs.info",
    "loopstack.com",
    "loot-fern.site",
    "lootx.cf",
    "lopeure.com",
    "lopezclub.com",
    "lopezfood.com",
    "lopgesi.cf",
    "lopgesi.gq",
    "lopgesi.ml",
    "lopgesi.tk",
    "lopit.icu",
    "lopl.co.cc",
    "loqueseve.net",
    "loqueseve.org",
    "loranund.world",
    "lord2film.online",
    "lordbet105.com",
    "lordcheez.com",
    "lordfilms.press",
    "lordfkas.tk",
    "lordjohnsbootery.com",
    "lordsofts.com",
    "lordssfilm.online",
    "lordvold.cf",
    "lordvold.ga",
    "lordvold.gq",
    "lordvold.ml",
    "lordzeeblog.com",
    "lorel.best",
    "lorenzidecks.com",
    "lorimer.co",
    "lorslufmea.cf",
    "lorslufmea.ga",
    "lorsque.us",
    "lortemail.dk",
    "losangeles.storage",
    "losangelescountypretrialservices.com",
    "losangelesquote.com",
    "loselta.cf",
    "losemymail.com",
    "losethed.com",
    "loskutnat.ru",
    "lossless.capital",
    "lostandalone.com",
    "lostbooks.net",
    "lostfilm-hd-1086.online",
    "lostfilm-hd-1158.online",
    "lostfilm-hd-1165.online",
    "lostfilm-hd-1191.online",
    "lostfilm-hd-1207.online",
    "lostfilm-hd-1365.online",
    "lostfilm-hd-1379.online",
    "lostfilm-hd-1500.online",
    "lostfilm-hd-1586.online",
    "lostfilm-hd-1720.online",
    "lostfilm-hd-219.online",
    "lostfilm-hd-2570.online",
    "lostfilm-hd-3203.online",
    "lostfilm-hd-3429.online",
    "lostfilm-hd-3489.online",
    "lostfilm-hd-3618.online",
    "lostfilm-hd-3665.online",
    "lostfilm-hd-434.online",
    "lostfilm-hd-658.online",
    "lostfilm-hd-927.online",
    "lostgikom.tk",
    "lostingaf.ga",
    "lostnzttu.win",
    "lostoddies.com",
    "lostpositive.xyz",
    "losvolosy.info",
    "lotclubs.com",
    "loteamentos.club",
    "lotesan.cf",
    "lotesan.gq",
    "lotesan.ml",
    "lotesan.tk",
    "lotls.com",
    "loto-sto-cool.host",
    "loto-sto-cool.press",
    "loto-sto-cool.space",
    "lotogoldclub.online",
    "lotogoldclub.site",
    "lotsavaslari1.com",
    "lotsofcrazykittens.site",
    "lottery-weekly.com",
    "lotteryfordream.com",
    "lotteryforwin.com",
    "lotto-mn.com",
    "lotto-vip.click",
    "lotto-vip.shop",
    "lotto191.com",
    "lotto4winner.com",
    "lottoaddict.online",
    "lottobag.live",
    "lottobeat.online",
    "lottobenefit.com",
    "lottobestwinner.com",
    "lottoboard.online",
    "lottobudget.live",
    "lottobuild.live",
    "lottocave.online",
    "lottochild.live",
    "lottocounter.live",
    "lottocove.online",
    "lottocreed.live",
    "lottocritic.live",
    "lottodrawer.live",
    "lottoegg.live",
    "lottoeo.online",
    "lottofever.online",
    "lottofinish.live",
    "lottoflow.online",
    "lottogate.live",
    "lottogo.link",
    "lottogossip.live",
    "lottohousing.live",
    "lottoinc.online",
    "lottoisland.live",
    "lottojet.live",
    "lottolink.live",
    "lottomargin.live",
    "lottoo.online",
    "lottoorgan.live",
    "lottooutlet.live",
    "lottoowl.live",
    "lottopaint.live",
    "lottoryshow.com",
    "lottosight.online",
    "lottosport.live",
    "lottotalent.com",
    "lottothai888.com",
    "lottovalley.online",
    "lottovip900.online",
    "lottovvip.com",
    "lottowingot.com",
    "lottowinnerboy.com",
    "lottowinnerbuy.com",
    "lottowinnerdaily.com",
    "lottowinnerfolk.com",
    "lotuses.xyz",
    "lotusflowertea.com",
    "lotusphysicaltherapy.com",
    "lotusrobot.com",
    "lotusteavietnam.com",
    "lotyh.xyz",
    "louboutinadmin.site",
    "louboutinit.com",
    "loudcannabisapp.com",
    "loudouncolo.com",
    "louedepot.com",
    "loufad.com",
    "louhansonpottery.com",
    "louieliu.com",
    "louipomi.cf",
    "louipomi.ga",
    "louipomi.gq",
    "louipomi.ml",
    "louis918.com",
    "louiscasinos.com",
    "louisct.com",
    "louisemccarthy.buzz",
    "louiskoo.com",
    "louisloock.com",
    "louisphilippeconstantin.com",
    "louistanis.ga",
    "louistanis.gq",
    "louistanis.tk",
    "louisvienna.com",
    "louisvillequote.com",
    "louisvilleskatingacademy.org",
    "loujtj.rest",
    "louli08.com",
    "loumoen.info",
    "lous-photos.com",
    "lous.photos",
    "lov.ru",
    "lova-madeinglass.com",
    "lovabloazf.ru",
    "lovane.info",
    "love-amigurumi.website",
    "love-brand.ru",
    "love-handmade.site",
    "love-history.ru",
    "love-matchs2.club",
    "love-to-cook.ru",
    "love-yarn.site",
    "love-youboy.ru",
    "love.com",
    "love.cz",
    "love079.com",
    "love2.tennis",
    "love2212.com",
    "love365.ru",
    "love388.net",
    "love399.net",
    "love488.net",
    "love669.net",
    "love676.net",
    "love686.com",
    "love686.net",
    "love866.net",
    "love877.com",
    "love888test.xyz",
    "love889.com",
    "love889.net",
    "love8baidu.com",
    "loveable.com",
    "loveandotherstuff.co",
    "lovebet44.net",
    "lovebitco.in",
    "lovecat.com",
    "loveday1.info",
    "loveenit.com",
    "loveesq.com",
    "lovefall.ml",
    "lovefans.com",
    "lovefootball.com",
    "loveforlostcats.com",
    "loveknitting.website",
    "lovelacelabs.net",
    "lovely-photo.ru",
    "lovelyfont.com",
    "lovelygirl.net",
    "lovelynhatrang.ru",
    "lovelyshowcase.com",
    "lovelytype.com",
    "lovemail.com",
    "lovematters.africa",
    "lovemeet.faith",
    "lovemeleaveme.com",
    "lovemydoggy.shop",
    "lovemytrail.org",
    "lovepdfmanuales.xyz",
    "loveplanetx.com",
    "lover-boy.com",
    "lovergirl.com",
    "loversalvagepains.site",
    "loves.dicksinhisan.us",
    "loves.dicksinmyan.us",
    "lovesea.gq",
    "lovesfire.club",
    "lovestream.live",
    "lovethe90smalaga.com",
    "lovethebroncos.com",
    "lovethecowboys.com",
    "lovethetuentisfestival.com",
    "lovetocook.net",
    "lovetohike.com",
    "lovetuan.com",
    "loveunitesus.live",
    "lovewisher.com",
    "lovework.jp",
    "loveyouforever.de",
    "lovingjesus.com",
    "lovingmydentist.com",
    "lovingr3co.ga",
    "lovingyoujewelry.com",
    "lovlyn.com",
    "lovrent.com",
    "lovxwyzpfzb2i4m8w9n.cf",
    "lovxwyzpfzb2i4m8w9n.ga",
    "lovxwyzpfzb2i4m8w9n.gq",
    "lovxwyzpfzb2i4m8w9n.tk",
    "low-buy.site",
    "lowandslow.com",
    "lowassfi.xyz",
    "lowatt.ru",
    "lowcanceljaw.website",
    "lowco.com",
    "lowcost.solutions",
    "lowdh.com",
    "lowendjunk.com",
    "lowermortgagerates.org",
    "lowermybloodpressure.info",
    "lowlifeairride.com",
    "lowpricefireworks.com",
    "lowrance-elite.online",
    "lowttfinin.ga",
    "lowttfinin.gq",
    "lowttfinin.ml",
    "lowttfinin.tk",
    "loy.kr",
    "loyalherceghalom.ml",
    "loycal.shop",
    "loz0se.us",
    "lp-rimarkets.com",
    "lp.express",
    "lp1hoanews.com",
    "lpalgcisp.shop",
    "lpaoaoao80101919.ibaloch.com",
    "lpapa.ooo",
    "lpe88-singapore.com",
    "lpfmgmtltd.com",
    "lpgrnerator.ru",
    "lphqvz.host",
    "lphrx.us",
    "lpi1iyi7m3zfb0i.cf",
    "lpi1iyi7m3zfb0i.ga",
    "lpi1iyi7m3zfb0i.gq",
    "lpi1iyi7m3zfb0i.ml",
    "lpi1iyi7m3zfb0i.tk",
    "lpiloanscash.com",
    "lpjx3n.site",
    "lpmwebconsult.com",
    "lpo.ddnsfree.com",
    "lpolijkas.ga",
    "lpoty3.us",
    "lppde.com",
    "lptbjh.site",
    "lpva5vjmrzqaa.cf",
    "lpva5vjmrzqaa.ga",
    "lpva5vjmrzqaa.gq",
    "lpva5vjmrzqaa.ml",
    "lpva5vjmrzqaa.tk",
    "lpwteu.icu",
    "lq59.xyz",
    "lqaqgbrw.shop",
    "lqdaal.us",
    "lqghzkal4gr.cf",
    "lqghzkal4gr.ga",
    "lqghzkal4gr.gq",
    "lqghzkal4gr.ml",
    "lqis2k.us",
    "lqlz8snkse08zypf.cf",
    "lqlz8snkse08zypf.ga",
    "lqlz8snkse08zypf.gq",
    "lqlz8snkse08zypf.ml",
    "lqlz8snkse08zypf.tk",
    "lqonrq7extetu.cf",
    "lqonrq7extetu.ga",
    "lqonrq7extetu.gq",
    "lqonrq7extetu.ml",
    "lqonrq7extetu.tk",
    "lqplz.live",
    "lqvip0.com",
    "lqvip2.com",
    "lqvip4.com",
    "lr425b.live",
    "lr526.site",
    "lr7.us",
    "lr78.com",
    "lr888.com",
    "lrdbet.com",
    "lrebzs.us",
    "lrelsqkgga4.cf",
    "lrelsqkgga4.ml",
    "lrelsqkgga4.tk",
    "lrenjg.us",
    "lresultss.icu",
    "lrfnygeef.shop",
    "lrjvsu.us",
    "lrland.net",
    "lroid.com",
    "lroiub.online",
    "lroiub.ru",
    "lron0re.com",
    "lrsxk.live",
    "lrtax.online",
    "lrtndrdqk.shop",
    "lrtptf0s50vpf.cf",
    "lrtptf0s50vpf.ga",
    "lrtptf0s50vpf.gq",
    "lrtptf0s50vpf.ml",
    "lrtptf0s50vpf.tk",
    "lru.me",
    "lrwz.site",
    "lrymxmci.site",
    "ls-server.ru",
    "lsalemost.site",
    "lsamennbx.shop",
    "lsecuri.shop",
    "lsepakbola.net",
    "lshoespeak.site",
    "lshunter.site",
    "lsjapp.com",
    "lsjbt.com",
    "lskqds.site",
    "lsktdr.us",
    "lslwcqvro.shop",
    "lsmcae.com",
    "lsos.xyz",
    "lsrtsgjsygjs34.gq",
    "lstore.moscow",
    "lstuqc.com",
    "lsv3.com",
    "lsvtaffiliate.com",
    "lsweetuni.pro",
    "lsxprelk6ixr.cf",
    "lsxprelk6ixr.ga",
    "lsxprelk6ixr.gq",
    "lsxprelk6ixr.ml",
    "lsxprelk6ixr.tk",
    "lsylgw.com",
    "lsylzcym.com",
    "lsyx0.rr.nu",
    "lt7n4p.us",
    "ltaffshop.store",
    "ltblu3.com",
    "ltc5ro.com",
    "ltcorp.org",
    "ltdtab9ejhei18ze6ui.cf",
    "ltdtab9ejhei18ze6ui.ga",
    "ltdtab9ejhei18ze6ui.gq",
    "ltdtab9ejhei18ze6ui.ml",
    "ltdtab9ejhei18ze6ui.tk",
    "ltesbn.us",
    "lteselnoc.cf",
    "lteselnoc.ml",
    "lteselnoc.tk",
    "ltfg92mrmi.cf",
    "ltfg92mrmi.ga",
    "ltfg92mrmi.gq",
    "ltfg92mrmi.ml",
    "ltfg92mrmi.tk",
    "lthaltha.shop",
    "lthz1v.us",
    "ltiosmjo.shop",
    "ltkuib.us",
    "ltt.us",
    "ltt0zgz9wtu.cf",
    "ltt0zgz9wtu.gq",
    "ltt0zgz9wtu.ml",
    "ltt0zgz9wtu.tk",
    "lttcloud.com",
    "lttiibtusu8.uno",
    "lttl.org",
    "lttmail.com",
    "lttmobile.com",
    "lttsd.com",
    "lttusers.com",
    "lttusers.net",
    "ltuc.edu.eu.org",
    "ltuiwz.us",
    "luadao.club",
    "luarleare.cf",
    "luarleare.ga",
    "luarleare.tk",
    "luarte.info",
    "lubbockhairsalons.com",
    "lubbockquote.com",
    "lubisbukalapak.tk",
    "lubovnik.ru",
    "lubuqa.xyz",
    "lucah.video",
    "luce-lp.biz",
    "luce-lp.net",
    "lucha.shoes",
    "luchocharovanii.xyz",
    "luchthaven.org",
    "lucian.dev",
    "lucianoslodo.com",
    "lucidmation.com",
    "lucidseats.com",
    "luciferous.site",
    "luciferparfume.xyz",
    "lucifunzgl.club",
    "lucifunzgl.host",
    "lucigenic.com",
    "luck-bet.online",
    "luck-outside.tech",
    "luck-win.com",
    "luck8.com",
    "luckboy.pw",
    "luckeyinvest.com",
    "luckjob.pw",
    "luckuclick.ru",
    "lucky-gambler.com",
    "lucky.wiki",
    "lucky238.org",
    "lucky4u.site",
    "luckydragon-cabra.com",
    "luckygambling.net",
    "luckygay.xyz",
    "luckyhour.xyz",
    "luckylion.su",
    "luckylolly.com",
    "luckymail.org",
    "luckypick.net",
    "luckyquest.net",
    "luckyskill.club",
    "luckyspin-s12.com",
    "luckyspin.ru",
    "luckysportwin88.club",
    "luckyvictims.com",
    "luckywinner.vegas",
    "luclyvitamin.com",
    "lucrandoonline.tech",
    "lucrumbet.ru",
    "lucubunga.org",
    "lucyd.xyz",
    "lucyintmhk.space",
    "lucypoker.net",
    "lucys.mobi",
    "lucyu.com",
    "luddo.me",
    "luderi.cf",
    "luderi.ga",
    "luderi.gq",
    "ludovicomedia.com",
    "ludzieswiatowi.site",
    "luengosweb.se",
    "luepotho.ga",
    "luepotho.gq",
    "lufcfans.website",
    "luffem.com",
    "lufrand.ru",
    "luftcinbull.ga",
    "luftcinbull.tk",
    "lufyalp.best",
    "luggageandbag.com",
    "luhorla.cf",
    "luhorla.gq",
    "luhorla.ml",
    "luicesdass.cf",
    "luicesdass.ga",
    "luigisfinglas.com",
    "luigiskimmage.com",
    "luigitakeaway.com",
    "luilkkgtq43q1a6mtl.cf",
    "luilkkgtq43q1a6mtl.ga",
    "luilkkgtq43q1a6mtl.gq",
    "luilkkgtq43q1a6mtl.ml",
    "luilkkgtq43q1a6mtl.tk",
    "luisdelavegarealestate.us",
    "luisgiisjsk.tk",
    "luisparisy.info",
    "luk2.com",
    "lukecarriere.com",
    "lukemail.info",
    "lukeskybroker.com",
    "lukespencer.buzz",
    "lukesrcplanes.com",
    "lukeyoquinto.com",
    "lukhovi.com",
    "lukop.dk",
    "luksarcenter.ru",
    "luky88.info",
    "luleburgazrehber.xyz",
    "lulexia.com",
    "lulluna.com",
    "lulluna.org",
    "lululu19.info",
    "lulumelulu.org",
    "lumb.net",
    "lumetric-testing.space",
    "lumi-ceuticals.com",
    "luminario.com",
    "luminous-cabal.site",
    "luminoustracts.club",
    "luminu.com",
    "lumivisions.net",
    "lumpylump.com",
    "lunabit1.com",
    "lunar4d.org",
    "lunaticfest.store",
    "lunatikcase.ru",
    "lunchbuild.recipes",
    "lunchdoze.fun",
    "lunent.xyz",
    "lungallowedmace.website",
    "lungmater.ga",
    "lungmater.tk",
    "lunive.xyz",
    "lunsbt.xyz",
    "lunvli.icu",
    "lunyingge.com",
    "luo.kr",
    "luocentce.gq",
    "luocentce.ml",
    "luohunzu.com",
    "luomeng.info",
    "luonchia.online",
    "luotishow.xyz",
    "lupabapak.org",
    "luq1fe.us",
    "lurelight.com",
    "lurepam.com",
    "lurralife.org",
    "lusesupermart.site",
    "lusianna.ml",
    "luso.pt",
    "lussierdesign.com",
    "lustelo.com",
    "lustrapay.org",
    "lutcha.africa",
    "luteous.site",
    "lutherhild.ga",
    "luukku.com",
    "luutrudulieu.net",
    "luutrudulieu.online",
    "luv2.us",
    "luvmsg.com",
    "luvrhino.com",
    "luwdutjza.shop",
    "luwysi.info",
    "lux-building.ru",
    "luxeic.com",
    "luxemine.ru",
    "luxentic.com",
    "luxetrader.net",
    "luxline.com",
    "luxmet.ru",
    "luxurating.com",
    "luxury-travel.xyz",
    "luxuryalcoholrehabprograms.com",
    "luxurybet138.com",
    "luxurydate.online",
    "luxuryflights.xyz",
    "luxurypenswatches.com",
    "luxuryrehabprogram.com",
    "luxuryscentboxes.com",
    "luxurytogel.com",
    "luxusmail.gq",
    "luxusmail.tk",
    "luxusmail.uk",
    "luxusroleplay.us",
    "luxvil.ru",
    "luzhilu3.com",
    "luzoom.net",
    "lv1-love.ru",
    "lvbq5bc1f3eydgfasn.cf",
    "lvbq5bc1f3eydgfasn.ga",
    "lvbq5bc1f3eydgfasn.gq",
    "lvbq5bc1f3eydgfasn.ml",
    "lvbq5bc1f3eydgfasn.tk",
    "lvc2txcxuota.cf",
    "lvc2txcxuota.ga",
    "lvc2txcxuota.gq",
    "lvc2txcxuota.ml",
    "lvc2txcxuota.tk",
    "lvey.luk2.com",
    "lvfityou.com",
    "lvhan.net",
    "lvheye.com",
    "lvie.com.sg",
    "lviv.in",
    "lvlxd.ru",
    "lvory.net",
    "lvpux8.us",
    "lvrwvc.ga",
    "lvs788.club",
    "lvvif.live",
    "lvwebmail.com",
    "lvword.com",
    "lvxutizc6sh8egn9.cf",
    "lvxutizc6sh8egn9.ga",
    "lvxutizc6sh8egn9.gq",
    "lvxutizc6sh8egn9.ml",
    "lvxutizc6sh8egn9.tk",
    "lvy4.us",
    "lwapv.us",
    "lwcplror.shop",
    "lweohkvh.shop",
    "lwhzgl.us",
    "lwjsmj.shop",
    "lwmarketing.club",
    "lwmaxkyo3a.cf",
    "lwmaxkyo3a.ga",
    "lwmaxkyo3a.gq",
    "lwmaxkyo3a.ml",
    "lwmaxkyo3a.tk",
    "lwmhcka58cbwi.cf",
    "lwmhcka58cbwi.ga",
    "lwmhcka58cbwi.gq",
    "lwmhcka58cbwi.ml",
    "lwmhcka58cbwi.tk",
    "lwu9l.us",
    "lwwz3zzp4pvfle5vz9q.cf",
    "lwwz3zzp4pvfle5vz9q.ga",
    "lwwz3zzp4pvfle5vz9q.gq",
    "lwwz3zzp4pvfle5vz9q.ml",
    "lwwz3zzp4pvfle5vz9q.tk",
    "lx-97.com",
    "lxnshavo.shop",
    "lxream-player.com",
    "lxtx-yl.com",
    "lxtxdl.com",
    "lxty8.com",
    "lxupukiw4dr277kay.cf",
    "lxupukiw4dr277kay.ga",
    "lxupukiw4dr277kay.gq",
    "lxupukiw4dr277kay.ml",
    "lxupukiw4dr277kay.tk",
    "lxwwp.icu",
    "ly631c.com",
    "lyahoo.com",
    "lyaliume.site",
    "lyamda.ru",
    "lybaba.xyz",
    "lybe.info",
    "lycos.at",
    "lycos.co.kr",
    "lycos.co.uk",
    "lycos.com",
    "lycos.comx.cf",
    "lycos.de",
    "lycos.es",
    "lycos.it",
    "lycos.ne.jp",
    "lycos.nl",
    "lycos.ru",
    "lycosemail.com",
    "lycosmail.com",
    "lydia-uniform.com",
    "lydias-scrubs.com",
    "lydiascrubs.com",
    "lydiasprofessionaluniforms.com",
    "lydiasscrubs.com",
    "lydiasuniform.com",
    "lydiasuniform.info",
    "lydiasuniform.net",
    "lydiauniform.com",
    "lyepictver.cf",
    "lyepictver.ml",
    "lyepictver.tk",
    "lyesikon.cf",
    "lyfestylecreditsolutions.com",
    "lyfrabom.cf",
    "lyfrabom.ga",
    "lyfrabom.ml",
    "lygardendublin16.com",
    "lyhert.com",
    "lyhirame.website",
    "lyjnhkmpe1no.cf",
    "lyjnhkmpe1no.ga",
    "lyjnhkmpe1no.gq",
    "lyjnhkmpe1no.ml",
    "lyjnhkmpe1no.tk",
    "lyjtjgjy.xyz",
    "lykamspam.pl",
    "lykaon.com",
    "lymaza.info",
    "lymdownmer.gq",
    "lymdownmer.tk",
    "lynchtopkslop.cf",
    "lynchtopkslop.ga",
    "lyolersi.cf",
    "lyolersi.ga",
    "lyolersi.gq",
    "lyolersi.ml",
    "lyolersi.tk",
    "lyq8i1.xyz",
    "lyqayi.xyz",
    "lyqe.site",
    "lyqenz.xyz",
    "lyqmeu.xyz",
    "lyqo9g.xyz",
    "lyqqp1.xyz",
    "lyqqqv.xyz",
    "lyqxe8.xyz",
    "lyqxh2.xyz",
    "lyrical.icu",
    "lyrics-lagu.me",
    "lyrics-translation.com",
    "lysszy.com",
    "lystig.dk",
    "lyttres.ru",
    "lyuke.ru",
    "lyv1at.us",
    "lyvqj.us",
    "lywenw.com",
    "lyzzgc.com",
    "lzcai168.net",
    "lzcai888.net",
    "lzcxssxirzj.cf",
    "lzcxssxirzj.ga",
    "lzcxssxirzj.gq",
    "lzcxssxirzj.ml",
    "lzcxssxirzj.tk",
    "lzfkvktj5arne.cf",
    "lzfkvktj5arne.ga",
    "lzfkvktj5arne.gq",
    "lzfkvktj5arne.tk",
    "lzgyigfwf2.cf",
    "lzgyigfwf2.ga",
    "lzgyigfwf2.gq",
    "lzgyigfwf2.ml",
    "lzgyigfwf2.tk",
    "lzmjgc.com",
    "lzoaq.com",
    "lzqm.us",
    "lzqt.us",
    "lzs1.us",
    "lztoek.us",
    "lzw1o5.us",
    "m-a-i-l.com",
    "m-baraxolka.ru",
    "m-c-e.de",
    "m-chem.org",
    "m-cms.net",
    "m-dot.com",
    "m-hmail.com",
    "m-lidov.ru",
    "m-m.live",
    "m-mail.cf",
    "m-mail.ga",
    "m-mail.gq",
    "m-mail.ml",
    "m-p-s.cf",
    "m-p-s.ga",
    "m-p-s.gq",
    "m-passport.ru",
    "m-response.com",
    "m-rinok.ru",
    "m.2pai-dev.com",
    "m.arkf.xyz",
    "m.bccto.me",
    "m.beedham.org",
    "m.codng.com",
    "m.convulse.net",
    "m.ddcrew.com",
    "m.girl-viet.com",
    "m.nik.me",
    "m.nosuchdoma.in",
    "m.svlp.net",
    "m.u-torrent.cf",
    "m.u-torrent.ga",
    "m.u-torrent.gq",
    "m0.guardmail.cf",
    "m00b2sryh2dt8.cf",
    "m00b2sryh2dt8.ga",
    "m00b2sryh2dt8.gq",
    "m00b2sryh2dt8.ml",
    "m00b2sryh2dt8.tk",
    "m015j4ohwxtb7t.cf",
    "m015j4ohwxtb7t.ga",
    "m015j4ohwxtb7t.gq",
    "m015j4ohwxtb7t.ml",
    "m015j4ohwxtb7t.tk",
    "m0411.com",
    "m0451.com",
    "m07.ovh",
    "m09n80ac9rp31rt.xyz",
    "m0rrisdickson.com",
    "m0ve.club",
    "m0y1mqvqegwfvnth.cf",
    "m0y1mqvqegwfvnth.ga",
    "m0y1mqvqegwfvnth.gq",
    "m0y1mqvqegwfvnth.ml",
    "m0y1mqvqegwfvnth.tk",
    "m1.guardmail.cf",
    "m11pk.net",
    "m1t95z.us",
    "m1ufp7.com",
    "m2.guardmail.cf",
    "m21.cc",
    "m234666.com",
    "m25lettings.com",
    "m2hotel.com",
    "m2project.xyz",
    "m2r60ff.com",
    "m2zznc.us",
    "m3-academy.net",
    "m3.guardmail.cf",
    "m301111.com",
    "m3enterprise.us",
    "m3vksa.us",
    "m4-e.club",
    "m4.org",
    "m4dw79.site",
    "m4ilweb.info",
    "m4oczo7ni4awcrw.xyz",
    "m56123.com",
    "m56345.com",
    "m56456.com",
    "m5gcz.info",
    "m5wgcm.us",
    "m68al2oevblfr3m.xyz",
    "m6n7008.com",
    "m7665.com",
    "m77b9emzt2xr2bf.xyz",
    "m78012.com",
    "m78123.com",
    "m78345.com",
    "m78567.com",
    "m78678.com",
    "m78qp.com",
    "m7apqm.site",
    "m7lotto.com",
    "m88888.com",
    "m88laos.com",
    "m88pk.com",
    "m89345.com",
    "m89456.com",
    "m8cu8xgnu92kj.site",
    "m8gj8lsd0i0jwdno7l.cf",
    "m8gj8lsd0i0jwdno7l.ga",
    "m8gj8lsd0i0jwdno7l.gq",
    "m8gj8lsd0i0jwdno7l.ml",
    "m8gj8lsd0i0jwdno7l.tk",
    "m8h63kgpngwo.cf",
    "m8h63kgpngwo.ga",
    "m8h63kgpngwo.gq",
    "m8h63kgpngwo.ml",
    "m8h63kgpngwo.tk",
    "m8r.davidfuhr.de",
    "m8r.mcasal.com",
    "m8r.r-66y.com",
    "m8r8ltmoluqtxjvzbev.cf",
    "m8r8ltmoluqtxjvzbev.ga",
    "m8r8ltmoluqtxjvzbev.gq",
    "m8r8ltmoluqtxjvzbev.ml",
    "m8r8ltmoluqtxjvzbev.tk",
    "m8tro.net",
    "m9262.com",
    "m9282.com",
    "m9827.com",
    "m9enrvdxuhc.cf",
    "m9enrvdxuhc.ga",
    "m9enrvdxuhc.gq",
    "m9enrvdxuhc.ml",
    "m9enrvdxuhc.tk",
    "m9evcp.com",
    "ma-boite-aux-lettres.infos.st",
    "ma-didoma.website",
    "ma-perceuse.net",
    "ma.rr.com",
    "ma1l.bij.pl",
    "ma1lgen622.ga",
    "ma2limited.com",
    "ma8cfo.us",
    "maaill.com",
    "maart.ml",
    "maasaicricketwarriors.org",
    "maazios.com",
    "mabarpubg.zapto.org",
    "mabh65.ga",
    "maboard.com",
    "mabuklagi.ga",
    "mabulareserve.com",
    "mac.com",
    "mac.hush.com",
    "macaniuo235.cf",
    "macankumbang.com",
    "macaoguojihui.com",
    "macaototo.com",
    "macarparke.xyz",
    "macasoul.com",
    "macau-8882.net",
    "macau-8884.net",
    "macau-8885.net",
    "macau22.com",
    "macau333.com",
    "macau66.com",
    "macaudrs.com",
    "macbasics101.com",
    "macbookrepairvancouver.com",
    "macbox.com",
    "macbox.ru",
    "maccholnee.cf",
    "maccholnee.ga",
    "macdermidperformancesolutions.info",
    "macfreak.com",
    "macgamedeveloper.com",
    "macgames.site",
    "macgcanhau.cf",
    "macgcanhau.gq",
    "macgcanhau.ml",
    "macgcanhau.tk",
    "machinalix.biz",
    "machinalix.net",
    "machinecandy.com",
    "machinelearningpositions.com",
    "machineproseo.net",
    "machineproseo.org",
    "machineshop.de",
    "machinetest.com",
    "machlovi.com",
    "machmeschrzec.cf",
    "machmeschrzec.ml",
    "machmeschrzec.tk",
    "machutka-n.ru",
    "macintoshfiles.com",
    "macmail.com",
    "macmillanlarning.com",
    "macnotification.com",
    "maconchesp.ga",
    "maconchesp.ml",
    "maconchesp.tk",
    "macosa.cf",
    "macosa.ml",
    "macosa.tk",
    "macphersonford.com",
    "macplus-vrn.ru",
    "macr2.com",
    "macredit.site",
    "macroaligned.com",
    "macrobabyparcela.com",
    "macromaid.com",
    "macromancy.com",
    "macromice.info",
    "macsoftware.de",
    "macspeedtest.com",
    "macts.org",
    "macys-secure-login.com",
    "mad.scientist.com",
    "madaboutpawsuk.com",
    "madarinorientalcondos.com",
    "madberry.org",
    "madconcrete.com",
    "madcowcheesesteaks.com",
    "madcowtgp.com",
    "madcrazy.com",
    "madcreations.com",
    "maddash.org",
    "maddftp.online",
    "maddftp.xyz",
    "maddimilewskiofficial.com",
    "maddisonrobson.buzz",
    "maddy36523.ru",
    "made.ninja",
    "madebid.com",
    "madebygrace.se",
    "madecassol78.ru",
    "madeinak.com",
    "madeinbrazill.tech",
    "madeinsrq.com",
    "madeinthiscity.com",
    "madeirapakistan.com",
    "madeto.gq",
    "madeto.ml",
    "madeto.tk",
    "madhobitakeaway.com",
    "madhosi.com",
    "madiba-shirt.com",
    "madibashirts.com",
    "madikwetours.com",
    "madisonliddic.com",
    "madisonriver.biz",
    "madisonyouth.com",
    "madmerchantjew.website",
    "madnatextiles.com",
    "madnesse.site",
    "madobetooko.net",
    "madobetooko.org",
    "madonnafan.com",
    "madrid.com",
    "madridbet.social",
    "madrivertennis.com",
    "madsen.dk",
    "madstack.com",
    "madtoppings.com",
    "madurahoki.com",
    "maduras.blog",
    "madurasentuciudad.com",
    "maedamis.ga",
    "maedamis.gq",
    "maedamis.ml",
    "maedys.ru",
    "maennerversteherin.com",
    "maennerversteherin.de",
    "maep-ua.org",
    "maep-unionafricaine.org",
    "maerdaifuyule0.com",
    "maerdevol.com",
    "maestroqq.com",
    "maf-bet.info",
    "mafbet.biz",
    "mafbet.info",
    "maffia.hu",
    "mafiaa.cf",
    "mafiaa.ga",
    "mafiaa.gq",
    "mafiaa.ml",
    "mafiacapsaidn.com",
    "mafiken.gq",
    "mafiken.ml",
    "mafiken.tk",
    "mafmkkjxi.shop",
    "mafoosh.com",
    "mafproffitcasino.ru",
    "magamail.com",
    "magareports.cloud",
    "magaspice.com",
    "magaspices.com",
    "magaziles.com",
    "magazin-elok69.ru",
    "magazin-op.online",
    "magazine-action-marketing.ru",
    "magazine-shop.site",
    "magazinebemestar.com",
    "magazinefoodie.com",
    "magazinkachelis.ru",
    "magbo.info",
    "mage-tr.xyz",
    "magecamera.com",
    "magegraf.com",
    "magentatax.com",
    "magentiamoday.com",
    "magento-sa.online",
    "magento-sa.xyz",
    "magentomancer.com",
    "maggotymeat.ga",
    "maghassistance.com",
    "magi666.ru",
    "magia-sna.com",
    "magicalsys.site",
    "magicbeep.com",
    "magicblock.ru",
    "magicblocks.ru",
    "magicbox.ro",
    "magicclick.ru",
    "magicdrop.info",
    "magicmail.co.za",
    "magicmail01.ml",
    "magicmarkerbea.xyz",
    "magicvapp.com",
    "magikalworld.com",
    "magiushosting.site",
    "maglienflpocoprezzo.com",
    "magmamine.ru",
    "magn01ia.com",
    "magn0lia.com",
    "magnar.ru",
    "magnestabil.com",
    "magnetgoos.xyz",
    "magnetiner.com",
    "magnetoes.com",
    "magnetsandbox.com",
    "magnificentvideo.ru",
    "magnifyaid.com",
    "magniglobal.org",
    "magnoliacheck.xyz",
    "magnoliya-52.site",
    "magnum.plus",
    "magnumbet.online",
    "magnumbet.xyz",
    "magnumx.site",
    "magonline24.ru",
    "magspam.net",
    "maguoxin1.com",
    "magur.shop",
    "magura.shop",
    "magusae.space",
    "maguttha.cf",
    "mahabhart.tk",
    "mahadewapoker.site",
    "mahailadesigns.com",
    "mahalimountains.com",
    "mahan95.ir",
    "mahantejarat.com",
    "maharadg.ru",
    "maharajahtakeaway.com",
    "mahatqeo.online",
    "mahdevip.com",
    "mahewov.tripod.com",
    "mahiidev.site",
    "mahjonggplayzone.com",
    "mahjongseal.se",
    "mahkota33.org",
    "mahmoodweb.com",
    "mahoteki.com",
    "mahutv.com",
    "mahycu.site",
    "mai84.com",
    "maicheckfal.cf",
    "maicox.com",
    "maid-service.info",
    "maiddropcrampon.ru",
    "maidensportal.com",
    "maidlow.info",
    "maidstoneinventoryservices.com",
    "maigrirdes40ans.com",
    "maigw.us",
    "maiiamfoodsolutions.com",
    "maikai.me",
    "mail-2-you.com",
    "mail-address.live",
    "mail-app.net",
    "mail-apps.com",
    "mail-apps.net",
    "mail-awu.de",
    "mail-box.cz",
    "mail-c.cf",
    "mail-c.ga",
    "mail-c.gq",
    "mail-c.ml",
    "mail-c.tk",
    "mail-card.com",
    "mail-card.net",
    "mail-cart.com",
    "mail-center.com",
    "mail-central.com",
    "mail-click.net",
    "mail-cryz.ru",
    "mail-desk.net",
    "mail-dj.com",
    "mail-easy.fr",
    "mail-fake.com",
    "mail-file.net",
    "mail-filter.com",
    "mail-finder.net",
    "mail-fix.com",
    "mail-fix.net",
    "mail-gen.xyz",
    "mail-group.net",
    "mail-guru.net",
    "mail-help.net",
    "mail-hub.info",
    "mail-hub.top",
    "mail-it24.com",
    "mail-j.cf",
    "mail-j.ga",
    "mail-j.gq",
    "mail-j.ml",
    "mail-j.tk",
    "mail-lab.net",
    "mail-line.net",
    "mail-list.top",
    "mail-maker.net",
    "mail-me.com",
    "mail-mig.dk",
    "mail-now.top",
    "mail-on.us",
    "mail-owl.com",
    "mail-page.com",
    "mail-podarki.ru",
    "mail-point.net",
    "mail-pro.info",
    "mail-register.com",
    "mail-reply.net",
    "mail-search.com",
    "mail-security.xyz",
    "mail-share.com",
    "mail-share.net",
    "mail-space.net",
    "mail-temp.com",
    "mail-temporaire.com",
    "mail-temporaire.fr",
    "mail-tester.com",
    "mail-v.net",
    "mail-w.cf",
    "mail-w.ga",
    "mail-w.gq",
    "mail-w.ml",
    "mail-w.tk",
    "mail-z.gq",
    "mail-z.ml",
    "mail-z.tk",
    "mail.202y.cn",
    "mail.anhthu.org",
    "mail.ankokufs.us",
    "mail.atomeca.com",
    "mail.austria.com",
    "mail.aws910.com",
    "mail.az",
    "mail.backflip.cf",
    "mail.bbexcite.jp",
    "mail.bccto.com",
    "mail.bccto.me",
    "mail.bcu.ac.uk",
    "mail.be",
    "mail.bentrask.com",
    "mail.bestoption25.club",
    "mail.bg",
    "mail.bulgaria.com",
    "mail.by",
    "mail.byte.it",
    "mail.ch",
    "mail.co.za",
    "mail.com",
    "mail.com.tr",
    "mail.comx.cf",
    "mail.crowdpress.it",
    "mail.dcu.ie",
    "mail.de",
    "mail.defaultdomain.ml",
    "mail.dk",
    "mail.ee",
    "mail.entrepeneurmag.com",
    "mail.fast10s.design",
    "mail.fettometern.com",
    "mail.fgoyq.com",
    "mail.fr",
    "mail.freetown.com",
    "mail.fsmash.org",
    "mail.goo.ne.jp",
    "mail.goucher.edu",
    "mail.gr",
    "mail.h0h0h0.tk",
    "mail.hanungofficial.club",
    "mail.hitthebeach.com",
    "mail.hlhtool.com",
    "mail.htl22.at",
    "mail.ie",
    "mail.illistnoise.com",
    "mail.inforoca.ovh",
    "mail.it-byen.dk",
    "mail.jpgames.net",
    "mail.junwei.co",
    "mail.kmsp.com",
    "mail.libivan.com",
    "mail.lv",
    "mail.mailinator.com",
    "mail.md",
    "mail.me",
    "mail.mezimages.net",
    "mail.minecraftfuns.tk",
    "mail.misterpinball.de",
    "mail.mixhd.xyz",
    "mail.mnisjk.com",
    "mail.myde.ml",
    "mail.myserv.info",
    "mail.mzr.me",
    "mail.neynt.ca",
    "mail.nu",
    "mail.omahsimbah.com",
    "mail.org.uk",
    "mail.partskyline.com",
    "mail.pf",
    "mail.pharmacy.com",
    "mail.piaa.me",
    "mail.pt",
    "mail.ptcu.dev",
    "mail.r-o-o-t.com",
    "mail.rossam.com",
    "mail.rthyde.com",
    "mail.ru",
    "mail.salu.net",
    "mail.sisna.com",
    "mail.spaceports.com",
    "mail.stars19.xyz",
    "mail.svenz.eu",
    "mail.theboys.com",
    "mail.thesolidfirm.com",
    "mail.ticket-please.ga",
    "mail.tmcc.edu",
    "mail.tom.com",
    "mail.twfaka.com",
    "mail.txsb.ml",
    "mail.txzs188.com",
    "mail.ua",
    "mail.uc.edu",
    "mail.unionpay.pl",
    "mail.usa.com",
    "mail.vasarhely.hu",
    "mail.vrfarm.com.tw",
    "mail.vu",
    "mail.vuforia.us",
    "mail.wlu.edu",
    "mail.wtf",
    "mail.wvwvw.tech",
    "mail.zinn.gq",
    "mail.zp.ua",
    "mail0.cf",
    "mail0.ga",
    "mail0.gq",
    "mail0.ml",
    "mail1.cf",
    "mail1.drama.tw",
    "mail1.hacked.jp",
    "mail1.i-taiwan.tv",
    "mail1.ismoke.hk",
    "mail1.kaohsiung.tv",
    "mail1.kein.hk",
    "mail1.mungmung.o-r.kr",
    "mail1.top",
    "mail10.cf",
    "mail10.ga",
    "mail10.gq",
    "mail10.ml",
    "mail11.cf",
    "mail11.gq",
    "mail11.ml",
    "mail114.net",
    "mail15.com",
    "mail166.cn",
    "mail1999.cf",
    "mail1999.ga",
    "mail1999.gq",
    "mail1999.ml",
    "mail1999.tk",
    "mail1a.de",
    "mail1st.com",
    "mail1web.org",
    "mail2.cf",
    "mail2.drama.tw",
    "mail2.info.tm",
    "mail2.ntuz.me",
    "mail2.space",
    "mail2.worksmobile.ml",
    "mail2000.cf",
    "mail2000.ga",
    "mail2000.gq",
    "mail2000.ml",
    "mail2000.ru",
    "mail2000.tk",
    "mail2001.cf",
    "mail2001.ga",
    "mail2001.gq",
    "mail2001.ml",
    "mail2001.tk",
    "mail2007.com",
    "mail21.cc",
    "mail22.club",
    "mail22.space",
    "mail2aaron.com",
    "mail2abby.com",
    "mail2abc.com",
    "mail2actor.com",
    "mail2admiral.com",
    "mail2adorable.com",
    "mail2adoration.com",
    "mail2adore.com",
    "mail2adventure.com",
    "mail2aeolus.com",
    "mail2aether.com",
    "mail2affection.com",
    "mail2afghanistan.com",
    "mail2africa.com",
    "mail2agent.com",
    "mail2aha.com",
    "mail2ahoy.com",
    "mail2aim.com",
    "mail2air.com",
    "mail2airbag.com",
    "mail2airforce.com",
    "mail2airport.com",
    "mail2alabama.com",
    "mail2alan.com",
    "mail2alaska.com",
    "mail2albania.com",
    "mail2alcoholic.com",
    "mail2alec.com",
    "mail2alexa.com",
    "mail2algeria.com",
    "mail2alicia.com",
    "mail2alien.com",
    "mail2allan.com",
    "mail2allen.com",
    "mail2allison.com",
    "mail2alpha.com",
    "mail2alyssa.com",
    "mail2amanda.com",
    "mail2amazing.com",
    "mail2amber.com",
    "mail2america.com",
    "mail2american.com",
    "mail2andorra.com",
    "mail2andrea.com",
    "mail2andy.com",
    "mail2anesthesiologist.com",
    "mail2angela.com",
    "mail2angola.com",
    "mail2ann.com",
    "mail2anna.com",
    "mail2anne.com",
    "mail2anthony.com",
    "mail2anything.com",
    "mail2aphrodite.com",
    "mail2apollo.com",
    "mail2april.com",
    "mail2aquarius.com",
    "mail2arabia.com",
    "mail2arabic.com",
    "mail2architect.com",
    "mail2ares.com",
    "mail2argentina.com",
    "mail2aries.com",
    "mail2arizona.com",
    "mail2arkansas.com",
    "mail2armenia.com",
    "mail2army.com",
    "mail2arnold.com",
    "mail2art.com",
    "mail2artemus.com",
    "mail2arthur.com",
    "mail2artist.com",
    "mail2ashley.com",
    "mail2ask.com",
    "mail2astronomer.com",
    "mail2athena.com",
    "mail2athlete.com",
    "mail2atlas.com",
    "mail2atom.com",
    "mail2attitude.com",
    "mail2auction.com",
    "mail2aunt.com",
    "mail2australia.com",
    "mail2austria.com",
    "mail2azerbaijan.com",
    "mail2baby.com",
    "mail2bahamas.com",
    "mail2bahrain.com",
    "mail2ballerina.com",
    "mail2ballplayer.com",
    "mail2band.com",
    "mail2bangladesh.com",
    "mail2bank.com",
    "mail2banker.com",
    "mail2bankrupt.com",
    "mail2baptist.com",
    "mail2bar.com",
    "mail2barbados.com",
    "mail2barbara.com",
    "mail2barter.com",
    "mail2basketball.com",
    "mail2batter.com",
    "mail2beach.com",
    "mail2beast.com",
    "mail2beatles.com",
    "mail2beauty.com",
    "mail2becky.com",
    "mail2beijing.com",
    "mail2belgium.com",
    "mail2belize.com",
    "mail2ben.com",
    "mail2bernard.com",
    "mail2beth.com",
    "mail2betty.com",
    "mail2beverly.com",
    "mail2beyond.com",
    "mail2biker.com",
    "mail2bill.com",
    "mail2billionaire.com",
    "mail2billy.com",
    "mail2bio.com",
    "mail2biologist.com",
    "mail2black.com",
    "mail2blackbelt.com",
    "mail2blake.com",
    "mail2blind.com",
    "mail2blonde.com",
    "mail2blues.com",
    "mail2bob.com",
    "mail2bobby.com",
    "mail2bolivia.com",
    "mail2bombay.com",
    "mail2bonn.com",
    "mail2bookmark.com",
    "mail2boreas.com",
    "mail2bosnia.com",
    "mail2boston.com",
    "mail2botswana.com",
    "mail2bradley.com",
    "mail2brazil.com",
    "mail2breakfast.com",
    "mail2brian.com",
    "mail2bride.com",
    "mail2brittany.com",
    "mail2broker.com",
    "mail2brook.com",
    "mail2bruce.com",
    "mail2brunei.com",
    "mail2brunette.com",
    "mail2brussels.com",
    "mail2bryan.com",
    "mail2bug.com",
    "mail2bulgaria.com",
    "mail2business.com",
    "mail2buy.com",
    "mail2ca.com",
    "mail2california.com",
    "mail2calvin.com",
    "mail2cambodia.com",
    "mail2cameroon.com",
    "mail2canada.com",
    "mail2cancer.com",
    "mail2capeverde.com",
    "mail2capricorn.com",
    "mail2cardinal.com",
    "mail2cardiologist.com",
    "mail2care.com",
    "mail2caroline.com",
    "mail2carolyn.com",
    "mail2casey.com",
    "mail2cat.com",
    "mail2caterer.com",
    "mail2cathy.com",
    "mail2catlover.com",
    "mail2catwalk.com",
    "mail2cell.com",
    "mail2chad.com",
    "mail2champaign.com",
    "mail2charles.com",
    "mail2chef.com",
    "mail2chemist.com",
    "mail2cherry.com",
    "mail2chicago.com",
    "mail2chile.com",
    "mail2china.com",
    "mail2chinese.com",
    "mail2chocolate.com",
    "mail2christian.com",
    "mail2christie.com",
    "mail2christmas.com",
    "mail2christy.com",
    "mail2chuck.com",
    "mail2cindy.com",
    "mail2clark.com",
    "mail2classifieds.com",
    "mail2claude.com",
    "mail2cliff.com",
    "mail2clinic.com",
    "mail2clint.com",
    "mail2close.com",
    "mail2club.com",
    "mail2coach.com",
    "mail2coastguard.com",
    "mail2colin.com",
    "mail2college.com",
    "mail2colombia.com",
    "mail2color.com",
    "mail2colorado.com",
    "mail2columbia.com",
    "mail2comedian.com",
    "mail2composer.com",
    "mail2computer.com",
    "mail2computers.com",
    "mail2concert.com",
    "mail2congo.com",
    "mail2connect.com",
    "mail2connecticut.com",
    "mail2consultant.com",
    "mail2convict.com",
    "mail2cook.com",
    "mail2cool.com",
    "mail2cory.com",
    "mail2costarica.com",
    "mail2country.com",
    "mail2courtney.com",
    "mail2cowboy.com",
    "mail2cowgirl.com",
    "mail2craig.com",
    "mail2crave.com",
    "mail2crazy.com",
    "mail2create.com",
    "mail2croatia.com",
    "mail2cry.com",
    "mail2crystal.com",
    "mail2cuba.com",
    "mail2culture.com",
    "mail2curt.com",
    "mail2customs.com",
    "mail2cute.com",
    "mail2cutey.com",
    "mail2cynthia.com",
    "mail2cyprus.com",
    "mail2czechrepublic.com",
    "mail2dad.com",
    "mail2dale.com",
    "mail2dallas.com",
    "mail2dan.com",
    "mail2dana.com",
    "mail2dance.com",
    "mail2dancer.com",
    "mail2danielle.com",
    "mail2danny.com",
    "mail2darlene.com",
    "mail2darling.com",
    "mail2darren.com",
    "mail2daughter.com",
    "mail2dave.com",
    "mail2dawn.com",
    "mail2dc.com",
    "mail2dealer.com",
    "mail2deanna.com",
    "mail2dearest.com",
    "mail2debbie.com",
    "mail2debby.com",
    "mail2deer.com",
    "mail2delaware.com",
    "mail2delicious.com",
    "mail2demeter.com",
    "mail2democrat.com",
    "mail2denise.com",
    "mail2denmark.com",
    "mail2dennis.com",
    "mail2dentist.com",
    "mail2derek.com",
    "mail2desert.com",
    "mail2devoted.com",
    "mail2devotion.com",
    "mail2diamond.com",
    "mail2diana.com",
    "mail2diane.com",
    "mail2diehard.com",
    "mail2dilemma.com",
    "mail2dillon.com",
    "mail2dinner.com",
    "mail2dinosaur.com",
    "mail2dionysos.com",
    "mail2diplomat.com",
    "mail2director.com",
    "mail2dirk.com",
    "mail2disco.com",
    "mail2dive.com",
    "mail2diver.com",
    "mail2divorced.com",
    "mail2djibouti.com",
    "mail2doctor.com",
    "mail2doglover.com",
    "mail2dominic.com",
    "mail2dominica.com",
    "mail2dominicanrepublic.com",
    "mail2don.com",
    "mail2donald.com",
    "mail2donna.com",
    "mail2doris.com",
    "mail2dorothy.com",
    "mail2doug.com",
    "mail2dough.com",
    "mail2douglas.com",
    "mail2dow.com",
    "mail2downtown.com",
    "mail2dream.com",
    "mail2dreamer.com",
    "mail2dude.com",
    "mail2dustin.com",
    "mail2dyke.com",
    "mail2dylan.com",
    "mail2earl.com",
    "mail2earth.com",
    "mail2eastend.com",
    "mail2eat.com",
    "mail2economist.com",
    "mail2ecuador.com",
    "mail2eddie.com",
    "mail2edgar.com",
    "mail2edwin.com",
    "mail2egypt.com",
    "mail2electron.com",
    "mail2eli.com",
    "mail2elizabeth.com",
    "mail2ellen.com",
    "mail2elliot.com",
    "mail2elsalvador.com",
    "mail2elvis.com",
    "mail2emergency.com",
    "mail2emily.com",
    "mail2engineer.com",
    "mail2english.com",
    "mail2environmentalist.com",
    "mail2eos.com",
    "mail2eric.com",
    "mail2erica.com",
    "mail2erin.com",
    "mail2erinyes.com",
    "mail2eris.com",
    "mail2eritrea.com",
    "mail2ernie.com",
    "mail2eros.com",
    "mail2estonia.com",
    "mail2ethan.com",
    "mail2ethiopia.com",
    "mail2eu.com",
    "mail2europe.com",
    "mail2eurus.com",
    "mail2eva.com",
    "mail2evan.com",
    "mail2evelyn.com",
    "mail2everything.com",
    "mail2exciting.com",
    "mail2expert.com",
    "mail2fairy.com",
    "mail2faith.com",
    "mail2fanatic.com",
    "mail2fancy.com",
    "mail2fantasy.com",
    "mail2farm.com",
    "mail2farmer.com",
    "mail2fashion.com",
    "mail2fat.com",
    "mail2feeling.com",
    "mail2female.com",
    "mail2fever.com",
    "mail2fighter.com",
    "mail2fiji.com",
    "mail2filmfestival.com",
    "mail2films.com",
    "mail2finance.com",
    "mail2finland.com",
    "mail2fireman.com",
    "mail2firm.com",
    "mail2fisherman.com",
    "mail2flexible.com",
    "mail2florence.com",
    "mail2florida.com",
    "mail2floyd.com",
    "mail2fly.com",
    "mail2fond.com",
    "mail2fondness.com",
    "mail2football.com",
    "mail2footballfan.com",
    "mail2found.com",
    "mail2france.com",
    "mail2frank.com",
    "mail2frankfurt.com",
    "mail2franklin.com",
    "mail2fred.com",
    "mail2freddie.com",
    "mail2free.com",
    "mail2freedom.com",
    "mail2french.com",
    "mail2freudian.com",
    "mail2friendship.com",
    "mail2from.com",
    "mail2fun.com",
    "mail2gabon.com",
    "mail2gabriel.com",
    "mail2gail.com",
    "mail2galaxy.com",
    "mail2gambia.com",
    "mail2games.com",
    "mail2gary.com",
    "mail2gavin.com",
    "mail2gemini.com",
    "mail2gene.com",
    "mail2genes.com",
    "mail2geneva.com",
    "mail2george.com",
    "mail2georgia.com",
    "mail2gerald.com",
    "mail2german.com",
    "mail2germany.com",
    "mail2ghana.com",
    "mail2gilbert.com",
    "mail2gina.com",
    "mail2girl.com",
    "mail2glen.com",
    "mail2gloria.com",
    "mail2goddess.com",
    "mail2gold.com",
    "mail2golfclub.com",
    "mail2golfer.com",
    "mail2gordon.com",
    "mail2government.com",
    "mail2grab.com",
    "mail2grace.com",
    "mail2graham.com",
    "mail2grandma.com",
    "mail2grandpa.com",
    "mail2grant.com",
    "mail2greece.com",
    "mail2green.com",
    "mail2greg.com",
    "mail2grenada.com",
    "mail2gsm.com",
    "mail2guard.com",
    "mail2guatemala.com",
    "mail2guy.com",
    "mail2hades.com",
    "mail2haiti.com",
    "mail2hal.com",
    "mail2handhelds.com",
    "mail2hank.com",
    "mail2hannah.com",
    "mail2harold.com",
    "mail2harry.com",
    "mail2hawaii.com",
    "mail2headhunter.com",
    "mail2heal.com",
    "mail2heather.com",
    "mail2heaven.com",
    "mail2hebe.com",
    "mail2hecate.com",
    "mail2heidi.com",
    "mail2helen.com",
    "mail2hell.com",
    "mail2help.com",
    "mail2helpdesk.com",
    "mail2henry.com",
    "mail2hephaestus.com",
    "mail2hera.com",
    "mail2hercules.com",
    "mail2herman.com",
    "mail2hermes.com",
    "mail2hespera.com",
    "mail2hestia.com",
    "mail2highschool.com",
    "mail2hindu.com",
    "mail2hip.com",
    "mail2hiphop.com",
    "mail2holland.com",
    "mail2holly.com",
    "mail2hollywood.com",
    "mail2homer.com",
    "mail2honduras.com",
    "mail2honey.com",
    "mail2hongkong.com",
    "mail2hope.com",
    "mail2horse.com",
    "mail2hot.com",
    "mail2hotel.com",
    "mail2houston.com",
    "mail2howard.com",
    "mail2hugh.com",
    "mail2human.com",
    "mail2hungary.com",
    "mail2hungry.com",
    "mail2hygeia.com",
    "mail2hyperspace.com",
    "mail2hypnos.com",
    "mail2ian.com",
    "mail2ice-cream.com",
    "mail2iceland.com",
    "mail2idaho.com",
    "mail2idontknow.com",
    "mail2illinois.com",
    "mail2imam.com",
    "mail2in.com",
    "mail2india.com",
    "mail2indian.com",
    "mail2indiana.com",
    "mail2indonesia.com",
    "mail2infinity.com",
    "mail2intense.com",
    "mail2iowa.com",
    "mail2iran.com",
    "mail2iraq.com",
    "mail2ireland.com",
    "mail2irene.com",
    "mail2iris.com",
    "mail2irresistible.com",
    "mail2irving.com",
    "mail2irwin.com",
    "mail2isaac.com",
    "mail2israel.com",
    "mail2italian.com",
    "mail2italy.com",
    "mail2jackie.com",
    "mail2jacob.com",
    "mail2jail.com",
    "mail2jaime.com",
    "mail2jake.com",
    "mail2jamaica.com",
    "mail2james.com",
    "mail2jamie.com",
    "mail2jan.com",
    "mail2jane.com",
    "mail2janet.com",
    "mail2janice.com",
    "mail2japan.com",
    "mail2japanese.com",
    "mail2jasmine.com",
    "mail2jason.com",
    "mail2java.com",
    "mail2jay.com",
    "mail2jazz.com",
    "mail2jed.com",
    "mail2jeffrey.com",
    "mail2jennifer.com",
    "mail2jenny.com",
    "mail2jeremy.com",
    "mail2jerry.com",
    "mail2jessica.com",
    "mail2jessie.com",
    "mail2jesus.com",
    "mail2jew.com",
    "mail2jeweler.com",
    "mail2jim.com",
    "mail2jimmy.com",
    "mail2joan.com",
    "mail2joann.com",
    "mail2joanna.com",
    "mail2jody.com",
    "mail2joe.com",
    "mail2joel.com",
    "mail2joey.com",
    "mail2john.com",
    "mail2join.com",
    "mail2jon.com",
    "mail2jonathan.com",
    "mail2jones.com",
    "mail2jordan.com",
    "mail2joseph.com",
    "mail2josh.com",
    "mail2joy.com",
    "mail2juan.com",
    "mail2judge.com",
    "mail2judy.com",
    "mail2juggler.com",
    "mail2julian.com",
    "mail2julie.com",
    "mail2jumbo.com",
    "mail2junk.com",
    "mail2justin.com",
    "mail2justme.com",
    "mail2k.ru",
    "mail2kansas.com",
    "mail2karate.com",
    "mail2karen.com",
    "mail2karl.com",
    "mail2karma.com",
    "mail2kathleen.com",
    "mail2kathy.com",
    "mail2katie.com",
    "mail2kay.com",
    "mail2kazakhstan.com",
    "mail2keen.com",
    "mail2keith.com",
    "mail2kelly.com",
    "mail2kelsey.com",
    "mail2ken.com",
    "mail2kendall.com",
    "mail2kennedy.com",
    "mail2kenneth.com",
    "mail2kenny.com",
    "mail2kentucky.com",
    "mail2kenya.com",
    "mail2kerry.com",
    "mail2kevin.com",
    "mail2kim.com",
    "mail2kimberly.com",
    "mail2king.com",
    "mail2kirk.com",
    "mail2kiss.com",
    "mail2kosher.com",
    "mail2kristin.com",
    "mail2kurt.com",
    "mail2kuwait.com",
    "mail2kyle.com",
    "mail2kyrgyzstan.com",
    "mail2la.com",
    "mail2lacrosse.com",
    "mail2lance.com",
    "mail2lao.com",
    "mail2larry.com",
    "mail2latvia.com",
    "mail2laugh.com",
    "mail2laura.com",
    "mail2lauren.com",
    "mail2laurie.com",
    "mail2lawrence.com",
    "mail2lawyer.com",
    "mail2lebanon.com",
    "mail2lee.com",
    "mail2leo.com",
    "mail2leon.com",
    "mail2leonard.com",
    "mail2leone.com",
    "mail2leslie.com",
    "mail2letter.com",
    "mail2liberia.com",
    "mail2libertarian.com",
    "mail2libra.com",
    "mail2libya.com",
    "mail2liechtenstein.com",
    "mail2life.com",
    "mail2linda.com",
    "mail2linux.com",
    "mail2lionel.com",
    "mail2lipstick.com",
    "mail2liquid.com",
    "mail2lisa.com",
    "mail2lithuania.com",
    "mail2litigator.com",
    "mail2liz.com",
    "mail2lloyd.com",
    "mail2lois.com",
    "mail2lola.com",
    "mail2london.com",
    "mail2looking.com",
    "mail2lori.com",
    "mail2lost.com",
    "mail2lou.com",
    "mail2louis.com",
    "mail2louisiana.com",
    "mail2lovable.com",
    "mail2love.com",
    "mail2lucky.com",
    "mail2lucy.com",
    "mail2lunch.com",
    "mail2lust.com",
    "mail2luxembourg.com",
    "mail2luxury.com",
    "mail2lyle.com",
    "mail2lynn.com",
    "mail2madagascar.com",
    "mail2madison.com",
    "mail2madrid.com",
    "mail2maggie.com",
    "mail2mail.site",
    "mail2mail4.com",
    "mail2maine.com",
    "mail2malawi.com",
    "mail2malaysia.com",
    "mail2maldives.com",
    "mail2mali.com",
    "mail2malta.com",
    "mail2mambo.com",
    "mail2man.com",
    "mail2mandy.com",
    "mail2manhunter.com",
    "mail2mankind.com",
    "mail2many.com",
    "mail2marc.com",
    "mail2marcia.com",
    "mail2margaret.com",
    "mail2margie.com",
    "mail2marhaba.com",
    "mail2maria.com",
    "mail2marilyn.com",
    "mail2marines.com",
    "mail2mark.com",
    "mail2marriage.com",
    "mail2married.com",
    "mail2marries.com",
    "mail2mars.com",
    "mail2marsha.com",
    "mail2marshallislands.com",
    "mail2martha.com",
    "mail2martin.com",
    "mail2marty.com",
    "mail2marvin.com",
    "mail2mary.com",
    "mail2maryland.com",
    "mail2mason.com",
    "mail2massachusetts.com",
    "mail2matt.com",
    "mail2matthew.com",
    "mail2maurice.com",
    "mail2mauritania.com",
    "mail2mauritius.com",
    "mail2max.com",
    "mail2maxwell.com",
    "mail2maybe.com",
    "mail2mba.com",
    "mail2me4u.com",
    "mail2mechanic.com",
    "mail2medieval.com",
    "mail2megan.com",
    "mail2mel.com",
    "mail2melanie.com",
    "mail2melissa.com",
    "mail2melody.com",
    "mail2member.com",
    "mail2memphis.com",
    "mail2methodist.com",
    "mail2mexican.com",
    "mail2mexico.com",
    "mail2mgz.com",
    "mail2miami.com",
    "mail2michael.com",
    "mail2michelle.com",
    "mail2michigan.com",
    "mail2mike.com",
    "mail2milan.com",
    "mail2milano.com",
    "mail2mildred.com",
    "mail2milkyway.com",
    "mail2millennium.com",
    "mail2millionaire.com",
    "mail2milton.com",
    "mail2mime.com",
    "mail2mindreader.com",
    "mail2mini.com",
    "mail2minister.com",
    "mail2minneapolis.com",
    "mail2minnesota.com",
    "mail2miracle.com",
    "mail2missionary.com",
    "mail2mississippi.com",
    "mail2missouri.com",
    "mail2mitch.com",
    "mail2model.com",
    "mail2moldova.com",
    "mail2moldova.commail2molly.com",
    "mail2molly.com",
    "mail2mom.com",
    "mail2monaco.com",
    "mail2money.com",
    "mail2mongolia.com",
    "mail2monica.com",
    "mail2montana.com",
    "mail2monty.com",
    "mail2moon.com",
    "mail2morocco.com",
    "mail2morpheus.com",
    "mail2mors.com",
    "mail2moscow.com",
    "mail2moslem.com",
    "mail2mouseketeer.com",
    "mail2movies.com",
    "mail2mozambique.com",
    "mail2mp3.com",
    "mail2mrright.com",
    "mail2msright.com",
    "mail2museum.com",
    "mail2music.com",
    "mail2musician.com",
    "mail2muslim.com",
    "mail2my.com",
    "mail2myboat.com",
    "mail2mycar.com",
    "mail2mycell.com",
    "mail2mygsm.com",
    "mail2mylaptop.com",
    "mail2mymac.com",
    "mail2mypager.com",
    "mail2mypalm.com",
    "mail2mypc.com",
    "mail2myphone.com",
    "mail2myplane.com",
    "mail2namibia.com",
    "mail2nancy.com",
    "mail2nasdaq.com",
    "mail2nathan.com",
    "mail2nauru.com",
    "mail2navy.com",
    "mail2neal.com",
    "mail2nebraska.com",
    "mail2ned.com",
    "mail2neil.com",
    "mail2nelson.com",
    "mail2nemesis.com",
    "mail2nepal.com",
    "mail2netherlands.com",
    "mail2network.com",
    "mail2nevada.com",
    "mail2newhampshire.com",
    "mail2newjersey.com",
    "mail2newmexico.com",
    "mail2newyork.com",
    "mail2newzealand.com",
    "mail2nicaragua.com",
    "mail2nick.com",
    "mail2nicole.com",
    "mail2niger.com",
    "mail2nigeria.com",
    "mail2nike.com",
    "mail2no.com",
    "mail2noah.com",
    "mail2noel.com",
    "mail2noelle.com",
    "mail2normal.com",
    "mail2norman.com",
    "mail2northamerica.com",
    "mail2northcarolina.com",
    "mail2northdakota.com",
    "mail2northpole.com",
    "mail2norway.com",
    "mail2notus.com",
    "mail2noway.com",
    "mail2nowhere.cf",
    "mail2nowhere.com",
    "mail2nowhere.ga",
    "mail2nowhere.gq",
    "mail2nowhere.ml",
    "mail2nowhere.tk",
    "mail2nuclear.com",
    "mail2nun.com",
    "mail2ny.com",
    "mail2oasis.com",
    "mail2oceanographer.com",
    "mail2ohio.com",
    "mail2ok.com",
    "mail2oklahoma.com",
    "mail2oliver.com",
    "mail2oman.com",
    "mail2one.com",
    "mail2onfire.com",
    "mail2online.com",
    "mail2oops.com",
    "mail2open.com",
    "mail2ophthalmologist.com",
    "mail2optometrist.com",
    "mail2oregon.com",
    "mail2oscars.com",
    "mail2oslo.com",
    "mail2painter.com",
    "mail2pakistan.com",
    "mail2palau.com",
    "mail2pan.com",
    "mail2panama.com",
    "mail2paraguay.com",
    "mail2paralegal.com",
    "mail2paris.com",
    "mail2park.com",
    "mail2parker.com",
    "mail2party.com",
    "mail2passion.com",
    "mail2pat.com",
    "mail2patricia.com",
    "mail2patrick.com",
    "mail2patty.com",
    "mail2paul.com",
    "mail2paula.com",
    "mail2pay.com",
    "mail2peace.com",
    "mail2pediatrician.com",
    "mail2peggy.com",
    "mail2pennsylvania.com",
    "mail2perry.com",
    "mail2persephone.com",
    "mail2persian.com",
    "mail2peru.com",
    "mail2pete.com",
    "mail2peter.com",
    "mail2pharmacist.com",
    "mail2phil.com",
    "mail2philippines.com",
    "mail2phoenix.com",
    "mail2phonecall.com",
    "mail2phyllis.com",
    "mail2pickup.com",
    "mail2pilot.com",
    "mail2pisces.com",
    "mail2planet.com",
    "mail2platinum.com",
    "mail2plato.com",
    "mail2pluto.com",
    "mail2pm.com",
    "mail2podiatrist.com",
    "mail2poet.com",
    "mail2poland.com",
    "mail2policeman.com",
    "mail2policewoman.com",
    "mail2politician.com",
    "mail2pop.com",
    "mail2pope.com",
    "mail2popular.com",
    "mail2portugal.com",
    "mail2poseidon.com",
    "mail2potatohead.com",
    "mail2power.com",
    "mail2presbyterian.com",
    "mail2president.com",
    "mail2priest.com",
    "mail2prince.com",
    "mail2princess.com",
    "mail2producer.com",
    "mail2professor.com",
    "mail2protect.com",
    "mail2psychiatrist.com",
    "mail2psycho.com",
    "mail2psychologist.com",
    "mail2qatar.com",
    "mail2queen.com",
    "mail2rabbi.com",
    "mail2race.com",
    "mail2racer.com",
    "mail2rachel.com",
    "mail2rage.com",
    "mail2rainmaker.com",
    "mail2ralph.com",
    "mail2randy.com",
    "mail2rap.com",
    "mail2rare.com",
    "mail2rave.com",
    "mail2ray.com",
    "mail2raymond.com",
    "mail2realtor.com",
    "mail2rebecca.com",
    "mail2recruiter.com",
    "mail2recycle.com",
    "mail2redhead.com",
    "mail2reed.com",
    "mail2reggie.com",
    "mail2register.com",
    "mail2rent.com",
    "mail2republican.com",
    "mail2resort.com",
    "mail2rex.com",
    "mail2rhodeisland.com",
    "mail2rich.com",
    "mail2richard.com",
    "mail2ricky.com",
    "mail2ride.com",
    "mail2riley.com",
    "mail2rita.com",
    "mail2rob.com",
    "mail2robert.com",
    "mail2roberta.com",
    "mail2robin.com",
    "mail2rock.com",
    "mail2rocker.com",
    "mail2rod.com",
    "mail2rodney.com",
    "mail2romania.com",
    "mail2rome.com",
    "mail2ron.com",
    "mail2ronald.com",
    "mail2ronnie.com",
    "mail2rose.com",
    "mail2rosie.com",
    "mail2roy.com",
    "mail2rss.org",
    "mail2rudy.com",
    "mail2rugby.com",
    "mail2runner.com",
    "mail2russell.com",
    "mail2russia.com",
    "mail2russian.com",
    "mail2rusty.com",
    "mail2ruth.com",
    "mail2rwanda.com",
    "mail2ryan.com",
    "mail2sa.com",
    "mail2sabrina.com",
    "mail2safe.com",
    "mail2sagittarius.com",
    "mail2sail.com",
    "mail2sailor.com",
    "mail2sal.com",
    "mail2salaam.com",
    "mail2sam.com",
    "mail2samantha.com",
    "mail2samoa.com",
    "mail2samurai.com",
    "mail2sandra.com",
    "mail2sandy.com",
    "mail2sanfrancisco.com",
    "mail2sanmarino.com",
    "mail2santa.com",
    "mail2sara.com",
    "mail2sarah.com",
    "mail2sat.com",
    "mail2saturn.com",
    "mail2saudi.com",
    "mail2saudiarabia.com",
    "mail2save.com",
    "mail2savings.com",
    "mail2school.com",
    "mail2scientist.com",
    "mail2scorpio.com",
    "mail2scott.com",
    "mail2sean.com",
    "mail2search.com",
    "mail2seattle.com",
    "mail2secretagent.com",
    "mail2senate.com",
    "mail2senegal.com",
    "mail2sensual.com",
    "mail2seth.com",
    "mail2sevenseas.com",
    "mail2sexy.com",
    "mail2seychelles.com",
    "mail2shane.com",
    "mail2sharon.com",
    "mail2shawn.com",
    "mail2ship.com",
    "mail2shirley.com",
    "mail2shoot.com",
    "mail2shuttle.com",
    "mail2sierraleone.com",
    "mail2simon.com",
    "mail2singapore.com",
    "mail2single.com",
    "mail2site.com",
    "mail2skater.com",
    "mail2skier.com",
    "mail2sky.com",
    "mail2sleek.com",
    "mail2slim.com",
    "mail2slovakia.com",
    "mail2slovenia.com",
    "mail2smile.com",
    "mail2smith.com",
    "mail2smooth.com",
    "mail2soccer.com",
    "mail2soccerfan.com",
    "mail2socialist.com",
    "mail2soldier.com",
    "mail2somalia.com",
    "mail2son.com",
    "mail2song.com",
    "mail2sos.com",
    "mail2sound.com",
    "mail2southafrica.com",
    "mail2southamerica.com",
    "mail2southcarolina.com",
    "mail2southdakota.com",
    "mail2southkorea.com",
    "mail2southpole.com",
    "mail2spain.com",
    "mail2spanish.com",
    "mail2spare.com",
    "mail2spectrum.com",
    "mail2splash.com",
    "mail2sponsor.com",
    "mail2sports.com",
    "mail2srilanka.com",
    "mail2stacy.com",
    "mail2stan.com",
    "mail2stanley.com",
    "mail2star.com",
    "mail2state.com",
    "mail2stephanie.com",
    "mail2steve.com",
    "mail2steven.com",
    "mail2stewart.com",
    "mail2stlouis.com",
    "mail2stock.com",
    "mail2stockholm.com",
    "mail2stockmarket.com",
    "mail2storage.com",
    "mail2store.com",
    "mail2strong.com",
    "mail2student.com",
    "mail2studio.com",
    "mail2studio54.com",
    "mail2stuntman.com",
    "mail2subscribe.com",
    "mail2sudan.com",
    "mail2superstar.com",
    "mail2surfer.com",
    "mail2suriname.com",
    "mail2susan.com",
    "mail2suzie.com",
    "mail2swaziland.com",
    "mail2sweden.com",
    "mail2sweetheart.com",
    "mail2swim.com",
    "mail2swimmer.com",
    "mail2swiss.com",
    "mail2switzerland.com",
    "mail2sydney.com",
    "mail2sylvia.com",
    "mail2syria.com",
    "mail2taboo.com",
    "mail2taiwan.com",
    "mail2tajikistan.com",
    "mail2tammy.com",
    "mail2tango.com",
    "mail2tanya.com",
    "mail2tanzania.com",
    "mail2tara.com",
    "mail2taurus.com",
    "mail2taxi.com",
    "mail2taxidermist.com",
    "mail2taylor.com",
    "mail2taz.com",
    "mail2teacher.com",
    "mail2technician.com",
    "mail2ted.com",
    "mail2telephone.com",
    "mail2teletubbie.com",
    "mail2tenderness.com",
    "mail2tennessee.com",
    "mail2tennis.com",
    "mail2tennisfan.com",
    "mail2terri.com",
    "mail2terry.com",
    "mail2test.com",
    "mail2texas.com",
    "mail2thailand.com",
    "mail2therapy.com",
    "mail2think.com",
    "mail2tickets.com",
    "mail2tiffany.com",
    "mail2tim.com",
    "mail2time.com",
    "mail2timothy.com",
    "mail2tina.com",
    "mail2titanic.com",
    "mail2toby.com",
    "mail2todd.com",
    "mail2togo.com",
    "mail2tom.com",
    "mail2tommy.com",
    "mail2tonga.com",
    "mail2tony.com",
    "mail2tor.com",
    "mail2touch.com",
    "mail2tourist.com",
    "mail2tracey.com",
    "mail2tracy.com",
    "mail2tramp.com",
    "mail2travel.com",
    "mail2traveler.com",
    "mail2travis.com",
    "mail2trekkie.com",
    "mail2trex.com",
    "mail2triallawyer.com",
    "mail2trick.com",
    "mail2trillionaire.com",
    "mail2troy.com",
    "mail2truck.com",
    "mail2trump.com",
    "mail2try.com",
    "mail2tunisia.com",
    "mail2turbo.com",
    "mail2turkey.com",
    "mail2turkmenistan.com",
    "mail2tv.com",
    "mail2tycoon.com",
    "mail2tyler.com",
    "mail2u4me.com",
    "mail2uae.com",
    "mail2uganda.com",
    "mail2uk.com",
    "mail2ukraine.com",
    "mail2uncle.com",
    "mail2unsubscribe.com",
    "mail2uptown.com",
    "mail2uruguay.com",
    "mail2usa.com",
    "mail2utah.com",
    "mail2uzbekistan.com",
    "mail2v.com",
    "mail2vacation.com",
    "mail2valentines.com",
    "mail2valerie.com",
    "mail2valley.com",
    "mail2vamoose.com",
    "mail2vanessa.com",
    "mail2vanuatu.com",
    "mail2venezuela.com",
    "mail2venous.com",
    "mail2venus.com",
    "mail2vermont.com",
    "mail2vickie.com",
    "mail2victor.com",
    "mail2victoria.com",
    "mail2vienna.com",
    "mail2vietnam.com",
    "mail2vince.com",
    "mail2virginia.com",
    "mail2virgo.com",
    "mail2visionary.com",
    "mail2vodka.com",
    "mail2volleyball.com",
    "mail2waiter.com",
    "mail2wallstreet.com",
    "mail2wally.com",
    "mail2walter.com",
    "mail2warren.com",
    "mail2washington.com",
    "mail2wave.com",
    "mail2way.com",
    "mail2waycool.com",
    "mail2wayne.com",
    "mail2web.com",
    "mail2webmaster.com",
    "mail2webtop.com",
    "mail2webtv.com",
    "mail2weird.com",
    "mail2wendell.com",
    "mail2wendy.com",
    "mail2westend.com",
    "mail2westvirginia.com",
    "mail2whether.com",
    "mail2whip.com",
    "mail2white.com",
    "mail2whitehouse.com",
    "mail2whitney.com",
    "mail2why.com",
    "mail2wilbur.com",
    "mail2wild.com",
    "mail2willard.com",
    "mail2willie.com",
    "mail2wine.com",
    "mail2winner.com",
    "mail2wired.com",
    "mail2wisconsin.com",
    "mail2woman.com",
    "mail2wonder.com",
    "mail2world.com",
    "mail2worship.com",
    "mail2wow.com",
    "mail2www.com",
    "mail2wyoming.com",
    "mail2xfiles.com",
    "mail2xox.com",
    "mail2yachtclub.com",
    "mail2yahalla.com",
    "mail2yemen.com",
    "mail2yes.com",
    "mail2yoga.com",
    "mail2yugoslavia.com",
    "mail2zack.com",
    "mail2zambia.com",
    "mail2zenith.com",
    "mail2zephir.com",
    "mail2zeus.com",
    "mail2zipper.com",
    "mail2zoo.com",
    "mail2zoologist.com",
    "mail2zurich.com",
    "mail3.drama.tw",
    "mail3.top",
    "mail3000.com",
    "mail333.com",
    "mail35.net",
    "mail3plus.net",
    "mail3tech.com",
    "mail3x.net",
    "mail4-us.org",
    "mail4.dk",
    "mail4.drama.tw",
    "mail4.online",
    "mail4gmail.com",
    "mail4trash.com",
    "mail4u.info",
    "mail4you.usa.cc",
    "mail5.drama.tw",
    "mail52.cf",
    "mail52.ga",
    "mail52.gq",
    "mail52.ml",
    "mail52.tk",
    "mail56.me",
    "mail6.dk",
    "mail6.jpimebbs.tk",
    "mail62.net",
    "mail666.ru",
    "mail7.cf",
    "mail7.ga",
    "mail7.gq",
    "mail707.com",
    "mail72.com",
    "mail777.cf",
    "mail8.com",
    "mail8.dk",
    "mail8.ga",
    "mail8.gq",
    "mail8app.com",
    "mailabconline.com",
    "mailadadad.org",
    "mailadda.cf",
    "mailadda.ga",
    "mailadda.gq",
    "mailadda.ml",
    "mailadresim.site",
    "mailandftp.com",
    "mailandnews.com",
    "mailapi.ru",
    "mailapp.top",
    "mailapps.online",
    "mailart.top",
    "mailart.ws",
    "mailas.com",
    "mailasia.com",
    "mailautomated01.com",
    "mailb.tk",
    "mailback.com",
    "mailbidon.com",
    "mailbiz.biz",
    "mailblocks.com",
    "mailblog.biz",
    "mailbolt.com",
    "mailbomb.net",
    "mailboom.com",
    "mailbox.as",
    "mailbox.co.za",
    "mailbox.comx.cf",
    "mailbox.gr",
    "mailbox.hu",
    "mailbox.r2.dns-cloud.net",
    "mailbox2go.de",
    "mailbox52.ga",
    "mailbox72.biz",
    "mailbox80.biz",
    "mailbox82.biz",
    "mailbox87.de",
    "mailbox92.biz",
    "mailbox92.com",
    "mailboxer.ru",
    "mailboxok.club",
    "mailboxonline.org",
    "mailboxt.com",
    "mailboxt.net",
    "mailboxvip.com",
    "mailboxy.fun",
    "mailbr.com.br",
    "mailbucket.org",
    "mailbus.ml",
    "mailc.cf",
    "mailc.gq",
    "mailc.net",
    "mailc.tk",
    "mailcan.com",
    "mailcard.net",
    "mailcat.biz",
    "mailcatch.com",
    "mailcatch.xyz",
    "mailcc.cf",
    "mailcc.com",
    "mailcc.ga",
    "mailcc.gq",
    "mailcc.ml",
    "mailcc.tk",
    "mailcdn.ml",
    "mailchimpreview.com",
    "mailchoose.co",
    "mailchop.com",
    "mailcity.com",
    "mailcker.com",
    "mailclient.com",
    "mailclub.fr",
    "mailclub.net",
    "mailcom.cf",
    "mailcom.ga",
    "mailcom.gq",
    "mailcom.ml",
    "mailcupp.com",
    "mailcx.cf",
    "mailcx.ga",
    "mailcx.gq",
    "mailcx.ml",
    "mailcx.tk",
    "maildanmark.dk",
    "mailde.de",
    "mailde.info",
    "maildrop.cc",
    "maildrop.cf",
    "maildrop.ga",
    "maildrop.gq",
    "maildrop.ml",
    "maildu.de",
    "maildump.tk",
    "maildx.com",
    "maileater.com",
    "mailed.in",
    "mailed.ro",
    "maileimer.de",
    "maileme101.com",
    "mailer.makodon.com",
    "mailer9.net",
    "mailernam.com",
    "mailese.ga",
    "mailexcite.com",
    "mailexpire.com",
    "mailezee.com",
    "mailf5.com",
    "mailfa.cf",
    "mailfa.tk",
    "mailfall.com",
    "mailfavorite.com",
    "mailfence.com",
    "mailfile.net",
    "mailfile.org",
    "mailfirst.icu",
    "mailfish.de",
    "mailflix1.it.o-r.kr",
    "mailfly.com",
    "mailforce.net",
    "mailformail.com",
    "mailforspam.com",
    "mailfort-a.com",
    "mailforwarding.amsterdam",
    "mailfree.ga",
    "mailfree.gq",
    "mailfree.ml",
    "mailfreeonline.com",
    "mailfreeway.com",
    "mailfs.com",
    "mailfs.tk",
    "mailftp.com",
    "mailgate.gr",
    "mailgate.ru",
    "mailgate.shop",
    "mailgc.com",
    "mailgen.biz",
    "mailgen.club",
    "mailgen.fun",
    "mailgen.info",
    "mailgen.pro",
    "mailgen.pw",
    "mailgen.xyz",
    "mailgenie.net",
    "mailginza.com",
    "mailglobe.club",
    "mailglobe.org",
    "mailgokurort.ru",
    "mailgov.info",
    "mailgrupobancolombia.online",
    "mailguard.me",
    "mailgutter.com",
    "mailhaven.com",
    "mailhazard.com",
    "mailhazard.us",
    "mailhero.io",
    "mailhex.com",
    "mailhood.com",
    "mailhost.com",
    "mailhost.top",
    "mailhub.pro",
    "mailhub.top",
    "mailhub24.com",
    "mailhubpros.com",
    "mailhz.me",
    "mailimail.com",
    "mailimails.patzleiner.net",
    "mailimate.com",
    "mailin8r.com",
    "mailinatar.com",
    "mailinater.com",
    "mailinator.cf",
    "mailinator.cl",
    "mailinator.co",
    "mailinator.co.uk",
    "mailinator.com",
    "mailinator.ga",
    "mailinator.gq",
    "mailinator.info",
    "mailinator.linkpc.net",
    "mailinator.ml",
    "mailinator.net",
    "mailinator.org",
    "mailinator.pl",
    "mailinator.site",
    "mailinator.us",
    "mailinator.usa.cc",
    "mailinator0.com",
    "mailinator1.com",
    "mailinator2.com",
    "mailinator2.net",
    "mailinator3.com",
    "mailinator4.com",
    "mailinator5.com",
    "mailinator6.com",
    "mailinator7.com",
    "mailinator8.com",
    "mailinator9.com",
    "mailinatorzz.mooo.com",
    "mailinblack.com",
    "mailinbox.cf",
    "mailinbox.co",
    "mailinbox.ga",
    "mailinbox.gq",
    "mailinbox.guru",
    "mailinbox.ml",
    "mailincubator.com",
    "mailing.o-r.kr",
    "mailing.one",
    "mailingaddress.org",
    "mailingforever.biz",
    "mailingweb.com",
    "mailinit.com",
    "mailisent.com",
    "mailismagic.com",
    "mailita.tk",
    "mailite.com",
    "mailj.tk",
    "mailjet.com",
    "mailjunk.cf",
    "mailjunk.ga",
    "mailjunk.gq",
    "mailjunk.ml",
    "mailjunk.tk",
    "mailjuose.ga",
    "mailking.ru",
    "mailkor.xyz",
    "mailkuatjku2.ga",
    "mailkutusu.site",
    "maillak.com",
    "maillei.com",
    "mailline.net",
    "maillink.in",
    "maillink.info",
    "maillink.live",
    "maillink.top",
    "maillist.in",
    "mailly.xyz",
    "mailmail.biz",
    "mailmaniacs.com",
    "mailmate.com",
    "mailme.dk",
    "mailme.gq",
    "mailme.ir",
    "mailme.judis.me",
    "mailme.lv",
    "mailme24.com",
    "mailmetal.com",
    "mailmetrash.com",
    "mailmetrash.comilzilla.org",
    "mailmight.com",
    "mailmij.nl",
    "mailmink.com",
    "mailmix.pl",
    "mailmoat.com",
    "mailmoth.com",
    "mailms.com",
    "mailmu.ml",
    "mailmyrss.com",
    "mailn.tk",
    "mailna.biz",
    "mailna.co",
    "mailna.in",
    "mailna.me",
    "mailnails.com",
    "mailnator.com",
    "mailnd7.com",
    "mailnesia.com",
    "mailnet.top",
    "mailnew.com",
    "mailnow2.com",
    "mailnowapp.com",
    "mailnull.com",
    "mailo.cf",
    "mailo.com",
    "mailo.tk",
    "mailon.ws",
    "mailonaut.com",
    "mailop7.com",
    "mailops.com",
    "mailorc.com",
    "mailorderbrides4u.net",
    "mailorderbridesreviews.com",
    "mailorg.org",
    "mailox.biz",
    "mailox.fun",
    "mailoye.com",
    "mailpanda.com",
    "mailperfetch.com",
    "mailpick.biz",
    "mailplus.pl",
    "mailpm.live",
    "mailpokemon.com",
    "mailpooch.com",
    "mailpost.comx.cf",
    "mailpost.ga",
    "mailpost.gq",
    "mailpost.zzn.com",
    "mailpoubelle.yenoussa.fr",
    "mailpremium.net",
    "mailpress.gq",
    "mailpride.com",
    "mailprohub.com",
    "mailprotech.com",
    "mailproxsy.com",
    "mailpti.ga",
    "mailpuppy.com",
    "mailquack.com",
    "mailr24.com",
    "mailrard01.ga",
    "mailrazer.com",
    "mailrc.biz",
    "mailres.net",
    "mailrnl.com",
    "mailrock.biz",
    "mailroom.com",
    "mailroyal.dk",
    "mailru.com",
    "mailrunner.net",
    "mails-24.net",
    "mailsac.cf",
    "mailsac.com",
    "mailsac.ga",
    "mailsac.gq",
    "mailsac.ml",
    "mailsac.tk",
    "mailscdn.com",
    "mailschain.com",
    "mailscheap.us",
    "mailscrap.com",
    "mailseal.de",
    "mailsearch.net",
    "mailsent.net",
    "mailseo.net",
    "mailserver.ru",
    "mailserver2.cf",
    "mailserver2.ga",
    "mailserver2.ml",
    "mailserver2.tk",
    "mailserver89.com",
    "mailservice.ms",
    "mailserviceforfree.info",
    "mailseverywhere.net",
    "mailshell.com",
    "mailshiv.com",
    "mailshiv.me",
    "mailshuttle.com",
    "mailsiphon.com",
    "mailslapping.com",
    "mailslite.com",
    "mailsnails.com",
    "mailsnare.net",
    "mailsor.com",
    "mailsoul.com",
    "mailsource.info",
    "mailspam.me",
    "mailspam.xyz",
    "mailspeed.ru",
    "mailspro.net",
    "mailssa5.com",
    "mailssa6.com",
    "mailstart.com",
    "mailstartplus.com",
    "mailster.dk",
    "mailstudio.tech",
    "mailsuckbro.cf",
    "mailsuckbro.ga",
    "mailsuckbro.gq",
    "mailsuckbro.ml",
    "mailsuckbro.tk",
    "mailsuckbrother.cf",
    "mailsuckbrother.ga",
    "mailsuckbrother.gq",
    "mailsuckbrother.ml",
    "mailsuckbrother.tk",
    "mailsucker.net",
    "mailsucker1.cf",
    "mailsucker1.ga",
    "mailsucker1.gq",
    "mailsucker1.ml",
    "mailsucker1.tk",
    "mailsucker11.cf",
    "mailsucker11.ga",
    "mailsucker11.gq",
    "mailsucker11.ml",
    "mailsucker11.tk",
    "mailsucker14.cf",
    "mailsucker14.ga",
    "mailsucker14.gq",
    "mailsucker14.ml",
    "mailsucker14.tk",
    "mailsucker2.cf",
    "mailsucker2.ga",
    "mailsucker2.gq",
    "mailsucker2.ml",
    "mailsucker2.tk",
    "mailsucker34.cf",
    "mailsucker34.ga",
    "mailsucker34.gq",
    "mailsucker34.ml",
    "mailsucker34.tk",
    "mailsucre.com",
    "mailsurf.com",
    "mailsy.top",
    "mailsys.site",
    "mailt.net",
    "mailt.top",
    "mailtag.com",
    "mailtanpakaudisini.com",
    "mailtechx.com",
    "mailtemp.info",
    "mailtemp.net",
    "mailtemp1123.ml",
    "mailtempmha.tk",
    "mailtemporaire.com",
    "mailtemporaire.fr",
    "mailthunder.ml",
    "mailto.de",
    "mailtome.de",
    "mailtothis.com",
    "mailtoyou.top",
    "mailtraps.com",
    "mailtrash.net",
    "mailtrix.net",
    "mailtv.net",
    "mailtv.tv",
    "mailu.cf",
    "mailu.gq",
    "mailu.ml",
    "mailueberfall.de",
    "mailup.net",
    "mailverificationupdate.xyz",
    "mailvxin.com",
    "mailw.cf",
    "mailw.ga",
    "mailw.gq",
    "mailw.info",
    "mailw.ml",
    "mailw.tk",
    "mailway.com",
    "mailwire.com",
    "mailwithyou.com",
    "mailworks.org",
    "mailwriting.com",
    "mailz.info",
    "mailz.info.tm",
    "mailzen.win",
    "mailzi.ru",
    "mailzilla.com",
    "mailzilla.org",
    "mailzilla.orgmbx.cc",
    "mailzinoit.com",
    "maimare.site",
    "main-release.com",
    "maindomino88.com",
    "maine.rr.com",
    "mainegotrain.com",
    "mainely-dogs.com",
    "mainerfolg.info",
    "maineyoutube.com",
    "mainkartuonline.live",
    "mainketoportal.com",
    "mainmacio.com",
    "mainmait.shop",
    "mainpasaran88.net",
    "mainphenom.com",
    "mainphp.cf",
    "mainphp.ga",
    "mainphp.gq",
    "mainphp.ml",
    "mainpkv.com",
    "mainpokemon.com",
    "mainpokerv.net",
    "mainprise.site",
    "mainsportss.com",
    "mainsydney.com",
    "maiqing-yule.com",
    "maisdeliveryapp.com",
    "maisonoud.com",
    "maissmartwatch.com",
    "maisvolume.space",
    "maiu.tk",
    "majdsyria.com",
    "majiidxchangee.com",
    "majminhouse.com",
    "majolicas.best",
    "major1688.com",
    "majoralbu.recipes",
    "majorbleeding.online",
    "majorcaholidayhouse.com",
    "majorexil.xyz",
    "majorfans.zone",
    "majorleaguemail.com",
    "majorleaguestore.com",
    "majorminormedia.us",
    "majorspukvw.email",
    "majorstea.buzz",
    "majortv.best",
    "majortv.club",
    "majostores.site",
    "makapay.online",
    "makasarpost.cf",
    "makeacase.com",
    "makebigmoneybro.ru",
    "makefriends.ru",
    "makeitdiy.ru",
    "makeiteasy.ml",
    "makelifebetter.blog",
    "makemebettr.site",
    "makemenaughty.club",
    "makemer.ru",
    "makemetheking.com",
    "makemind.ru",
    "makemycourier.com",
    "makepleasure.club",
    "makeplugin.com",
    "makerinist.com",
    "makersxq.com",
    "maket-saita.ru",
    "makethebadmanstop.org",
    "makeunrao.com",
    "makeupaccessories.company",
    "makeupbali.com",
    "makeupkiller.website",
    "makeupreviews.info",
    "makeupshop.live",
    "makeuseofoffers.com",
    "makiartist.com",
    "makimeore.com",
    "makingamericabetterthanever.com",
    "makingamericabetterthanever.org",
    "makingmichigan.org",
    "makinlabels.online",
    "makita-max.com",
    "makita-profi.store",
    "makkahimages.com",
    "makkan-auto.ru",
    "makomalls.site",
    "makov-ml.ru",
    "makrobet84.club",
    "maksatbahis3.com",
    "maksimumprodazh.ru",
    "maksymkrippa.com",
    "maktabatna.com",
    "maktoob.com",
    "maktwb.net",
    "makvik.ru",
    "makyn.ml",
    "mal-mal.ru",
    "mal3ab.online",
    "malagaapparel.com",
    "malahov.de",
    "malakies.tk",
    "malamutepuppies.org",
    "malarenorrkoping.se",
    "malaria.asia",
    "malaria.desi",
    "malatyagenclikmeclisi.com",
    "malatyaprefabrikyapi.xyz",
    "malatyaticaretrehberi.xyz",
    "malawiorphancare.org",
    "malayalamdtp.com",
    "malayalamtelevision.net",
    "malayalapathram.com",
    "malayaleaf.com",
    "malaysianrealty.com",
    "malboxe.com",
    "malchikzer.cf",
    "malchikzer.gq",
    "maldives-holiday-package.com",
    "maldonado-clientes.online",
    "maldonfilmclub.info",
    "male.ru",
    "maleckigastro.com",
    "malelanesatellitecamp.com",
    "malemjumat.fun",
    "malemjumat.live",
    "maletraveller.com",
    "maliberty.com",
    "malibucoding.com",
    "malicious.today",
    "maliesed.com",
    "maliesedau.com",
    "maliesedauaq.com",
    "malinagames.ru",
    "malinator.com",
    "malinger.org",
    "malishlandiya.ru",
    "maliya520.xyz",
    "maliya522.xyz",
    "maliyetineambalaj.online",
    "maliyetineambalaj.xyz",
    "mall.tko.co.kr",
    "mallbaricadeprotection.tech",
    "mallfamily.ru",
    "mallinator.com",
    "malloryecunningham.com",
    "malloryecunninghamlaw.com",
    "mallyeah.com",
    "malomies.com",
    "malomiesed.com",
    "malovay.site",
    "malove.site",
    "malrekel.ga",
    "malrekel.gq",
    "malrekel.tk",
    "maltacentralbank.org",
    "maltepeingilizcekurslari.com",
    "maltepelisesi.xyz",
    "maltesemail.com",
    "maltiy.space",
    "maltsev2018.ru",
    "malurl.com",
    "malvolion.com",
    "malware.icu",
    "malwarehub.org",
    "mam-pap.ru",
    "mama-bag-sochi.ru",
    "mamadoma.net",
    "mamalenta.ru",
    "mamamintaemail.com",
    "mamaumki.ru",
    "mambanalibre.xyz",
    "mamber.net",
    "mamin-shop.ru",
    "mamisa.shop",
    "mamkinarbuzer.cf",
    "mamkinarbuzer.ga",
    "mamkinarbuzer.gq",
    "mamkinarbuzer.ml",
    "mamkinarbuzer.tk",
    "mamkinrazboinik.cf",
    "mamkinrazboinik.ga",
    "mamkinrazboinik.gq",
    "mamkinrazboinik.ml",
    "mammothexploration.com",
    "mammybagmoscow.ru",
    "mamsy-bags.ru",
    "mamu786.xyz",
    "mamulenok.ru",
    "mamulyam.ru",
    "man-day-for-you.website",
    "man-or-machine.com",
    "man580.com",
    "man675.com",
    "man752.com",
    "man909.com",
    "mana-jp.com",
    "manabisagan.com",
    "manage-11.com",
    "managementinstruction.buzz",
    "managements.best",
    "manager.de",
    "manager.in.th",
    "managerpayservice.club",
    "manam.ru",
    "manaritiplumbing.com",
    "manatelugupaatalu.com",
    "manavgatkaymakamligi.xyz",
    "manavgatx.xyz",
    "manbetx.ltd",
    "manbetxsff.com",
    "manbetxyzn.com",
    "manbox.site",
    "manchesterboy.com",
    "mancity.net",
    "mandalabet.net",
    "mandalapoker.net",
    "mandalorian.info",
    "mandarin-house-rathcoole.com",
    "mandarincastle.com",
    "mandibuliform.best",
    "mandirihoki188.net",
    "mandirimutupratama.com",
    "mandorqq.com",
    "mandownle.cf",
    "mandownle.ga",
    "mandownle.gq",
    "mandownle.tk",
    "mandraghen.cf",
    "mandua.best",
    "mandyfairy.com",
    "mandysayer.com",
    "manekicasino2.com",
    "manekicasino3.com",
    "manekicasino7.com",
    "manekicasino8.com",
    "manetormonet.com",
    "manfgo.com",
    "manga8.com",
    "mangagoku.com",
    "mangakun.net",
    "mangbongda.biz",
    "mangbongda.site",
    "mangbongda.tech",
    "mangbongda.xyz",
    "mangbongda.zone",
    "mangiamediterraneo.club",
    "mangohik.xyz",
    "mangonet.shop",
    "mangopro.site",
    "mangovision.com",
    "mangulaas.eu",
    "mania-qq.website",
    "mania99.org",
    "maniabola.info",
    "maniabola.org",
    "maniabola.website",
    "maniabola365.com",
    "manialiga.global",
    "maniaqq.global",
    "maniashrinepatch.site",
    "manic-adas.ru",
    "manifestgenerator.com",
    "manifestqld.com",
    "manigraavertu.ru",
    "manikot.info",
    "maninblacktequila.com",
    "manisabelediyesi.xyz",
    "manisagunlukkiralikdaire.xyz",
    "manisalilardernegi.com",
    "manisalilardernegi.xyz",
    "manisancikyon.com",
    "maniskata.online",
    "manivsem.ru",
    "mankyrecords.com",
    "manly.app",
    "manlymail.net",
    "manlysurftv.com",
    "manmail.dk",
    "manmancao3.com",
    "manna-haus.org",
    "manningvalleyrifleclub.online",
    "mannitol.net",
    "mannnwii.site",
    "mannogem.com",
    "mannogem.net",
    "manocong.ga",
    "manocong.gq",
    "manogat.news",
    "manogat.online",
    "manogifts.com",
    "manolis.co",
    "manor-motel.net",
    "mansetbet.com",
    "mansion4d.net",
    "mansion4d.org",
    "mansiondev.com",
    "mansione.site",
    "mansonusa.com",
    "mansosolascos.com",
    "mantra.ventures",
    "mantrafreenet.com",
    "mantragro.com",
    "mantramail.com",
    "mantraonline.com",
    "mantrasindian.com",
    "manualace.online",
    "manualace.site",
    "manualame.site",
    "manualand.site",
    "manualandguides.site",
    "manualans.online",
    "manualans.site",
    "manualant.online",
    "manualant.site",
    "manualany.online",
    "manualany.site",
    "manualar.online",
    "manualar.site",
    "manualard.online",
    "manualard.site",
    "manualare.online",
    "manualare.site",
    "manualars.site",
    "manualart.site",
    "manualary.site",
    "manualast.site",
    "manualate.site",
    "manualave.site",
    "manualber.site",
    "manualbet.site",
    "manualcal.site",
    "manualcan.site",
    "manualced.site",
    "manualces.site",
    "manualded.site",
    "manualder.site",
    "manualdes.site",
    "manualead.site",
    "manualean.site",
    "manualear.site",
    "manualeas.site",
    "manualeat.site",
    "manualect.site",
    "manualed.online",
    "manualed.site",
    "manualeir.site",
    "manualely.site",
    "manualend.site",
    "manualent.site",
    "manualere.site",
    "manualern.site",
    "manualers.site",
    "manualery.site",
    "manuales.site",
    "manualese.site",
    "manualess.site",
    "manualest.site",
    "manualformy.fun",
    "manualformy.online",
    "manualformy.site",
    "manualformy.space",
    "manualformy.website",
    "manualged.site",
    "manualges.site",
    "manualgon.site",
    "manualhan.site",
    "manualhat.site",
    "manualhed.site",
    "manualhen.site",
    "manualher.site",
    "manualhey.site",
    "manualhin.site",
    "manualhis.site",
    "manualial.site",
    "manualian.site",
    "manualic.online",
    "manualic.site",
    "manualid.online",
    "manualid.site",
    "manually.online",
    "manually.site",
    "manualso.online",
    "manualso.site",
    "manubrium.site",
    "manufcaturamc.com",
    "manumail.club",
    "manutdfans.com",
    "manwithwheels.icu",
    "manxapp2.com",
    "manxapp3.com",
    "many-slots.ru",
    "manybat.ru",
    "manybrain.com",
    "manycrow.ru",
    "manyhaywire.com",
    "manyhod.space",
    "manyirka.ru",
    "manyme.com",
    "manymenofthewild.com",
    "manymilk.ru",
    "manymom.ru",
    "manyriver.ru",
    "manystorybooks.com",
    "manytan364.cf",
    "manytan364.ga",
    "manytan364.gq",
    "manytan364.ml",
    "manytan364.tk",
    "manyvids.app",
    "manywave.com",
    "manzoox.com",
    "mao.igg.biz",
    "mao.services",
    "maobohe.com",
    "maocloud.world",
    "maokai-lin.com",
    "map-academy.net",
    "map-academy.org",
    "map-us.info",
    "mapadebuenosaires.com",
    "mapadeconocimiento.info",
    "mapadels.info",
    "mapadeonce.com",
    "mapamayas.info",
    "mapaspromocionales.com",
    "mapfnetpa.gq",
    "mapfnetpa.ml",
    "mapigraavertu.ru",
    "mapleemail.com",
    "mapname.com",
    "mapnamrc.org",
    "mapol.ru",
    "mappys.club",
    "mapq.us",
    "mapquesttab.com",
    "maprealty.capital",
    "maprealty.net",
    "mapsable.com",
    "mapsjos.net",
    "mapsjos1.net",
    "mapsjos2.net",
    "mapsjos3.net",
    "mapsmarketing.com",
    "mapspagesy.info",
    "maqus-opl.best",
    "mar.email.ne.jp",
    "marafonbetru110.ru",
    "marafonhudeiki.ru",
    "marasanov.ru",
    "marastesbih.com",
    "marataba.org",
    "maratabagamereserve.com",
    "marathifacebook.icu",
    "marathon-des-erables.com",
    "marathon-official.ru",
    "marathonguru.win",
    "marawa.africa",
    "marcachis.info",
    "marceneiro.website",
    "marchmail.com",
    "marchmarditc.cf",
    "marchmarditc.tk",
    "marchmovo.com",
    "marchodler.com",
    "marcospecpinball.com",
    "marcostens.info",
    "marcoy.website",
    "marcsplaza.com",
    "marcuswarner.com",
    "mardincafem.xyz",
    "mardinface.online",
    "marektplace.site",
    "maret-genkzmail.ga",
    "marfa-lago.com",
    "marfino.net",
    "marfito.gq",
    "marfito.ml",
    "margaretanna.com",
    "margaretesterdijk.xyz",
    "margaretmerrifield.com",
    "margarette1818.site",
    "margarita.ru",
    "margaritaraces.com",
    "margeguzellik.net",
    "marginalmom.com",
    "marginsy.com",
    "margocopy.ru",
    "margust.ru",
    "marhakxjaytyx8.site",
    "marhendte.ml",
    "marhendte.tk",
    "mariah-carey.ml.org",
    "mariahc.com",
    "marialarssonsevigaogonblick.se",
    "mariannehallberg.se",
    "marianpissaridi.com",
    "mariasbox.com",
    "marib5ethmay.ga",
    "maricher.xyz",
    "maricopa.edu",
    "mariebyrdland.us",
    "marieke-mulder.online",
    "mariela1121.club",
    "marihow.ga",
    "marihow.gq",
    "marihow.ml",
    "marihow.tk",
    "marijuana.com",
    "marijuana.nl",
    "marijuanafertilizer.organic",
    "marijuananews.xyz",
    "marikacarlsson.se",
    "marikkwigmans.xyz",
    "marimalina.website",
    "marimari.website",
    "marimastu98huye.cf",
    "marimastu98huye.gq",
    "marimbagun.com",
    "marimbahq.com",
    "marimbamassage.com",
    "marimbamassagegun.com",
    "marimbamassager.com",
    "marimbashop.com",
    "marinamilitareshop.com",
    "marinanhatrangbay.net",
    "marinapirozhkova.ru",
    "marinaprecision.com",
    "marinax.net",
    "marinebrush.com",
    "marinebrush.net",
    "marinebrush.org",
    "marinebrush.us",
    "marinebrushes.net",
    "marinebrushes.us",
    "marinepaintbrush.biz",
    "marinepaintbrush.org",
    "marinepaintbrush.us",
    "marinepaintbrushes.biz",
    "marinepaintbrushes.com",
    "marinepaintbrushes.net",
    "marinerscc.com",
    "marioads.xyz",
    "marioandsons-monkstown.com",
    "mariomaker.tech",
    "maripottery.com",
    "marissasbunny.com",
    "maritimeglossary.com",
    "mariusblack.net",
    "mark-compressoren.ru",
    "market-beatz.ru",
    "market-csgotm.fun",
    "market-map.ru",
    "market-open-trade.site",
    "market177.ru",
    "market2018-77.ru",
    "market4play.ru",
    "marketabot.com",
    "marketbard.com",
    "marketing-commerce-retail.site",
    "marketing-formula-inform.ru",
    "marketing-new-info.ru",
    "marketing.lu",
    "marketing4karting.com",
    "marketingagency.tips",
    "marketingeffekt.de",
    "marketingfanatic.com",
    "marketingforpastors.com",
    "marketingondigital.info",
    "marketingsecretsapp.com",
    "marketingsummit.online",
    "marketingtheory.club",
    "marketintelligencesystems.live",
    "marketlance.com",
    "marketlink.info",
    "marketpad.net",
    "marketplace-lab.com",
    "marketplaceloans.xyz",
    "marketplacemuzza.com",
    "marketplaceselector.com",
    "marketprofilescanner.net",
    "marketsinitiative.org",
    "marketspacepro.com",
    "markettechno.ru",
    "marketweighton.com",
    "markhornsby.org",
    "markmail.site",
    "markmurfin.com",
    "markonedesign.info",
    "markopinball.info",
    "markopinball.org",
    "markreturn.top",
    "marksave.com",
    "marksearcher.com",
    "markthemann.net",
    "markuscerenak.net",
    "markuschkamei.xyz",
    "markvangossum.space",
    "marlboroughdentists.com",
    "marlisapunzalanofficial.com",
    "marmail.club",
    "marmaladis.ru",
    "marmaratasev.xyz",
    "marmaryta.com",
    "marmaryta.email",
    "marmaryta.life",
    "marmaryta.space",
    "marmitasfitlucrativas.com",
    "marmotmedia.com",
    "marnari.ga",
    "maroneymedia.com",
    "maroonecho.com",
    "marquissevenhillshenderson.com",
    "marrakech-airport.com",
    "marresa.cf",
    "marresa.ml",
    "marresa.tk",
    "marriagecounseling.tech",
    "marriagedate.net",
    "marriageguide.org",
    "marriageisamarathon.org",
    "married-not.com",
    "marriedandlovingit.com",
    "marrkt.sale",
    "marromeunationalreserve.com",
    "marrone.cf",
    "marry.ru",
    "mars-bet.com",
    "mars-bet.net",
    "marsattack.com",
    "marsbahisuyelik.com",
    "marsbahisyeniadres.com",
    "marsbet.biz",
    "marsbet.net",
    "marsbet.org",
    "marsbetting.com",
    "marschinesetakeaway.com",
    "marseillemetropoleaudacieuse.biz",
    "marseillemetropoleaudacieuse.info",
    "marseillemetropoleaudacieuse.net",
    "marseillesoap.net",
    "marseillesoap.us",
    "marsellas-takeaway.com",
    "marsellasrathcoole.com",
    "marsellastraditionaltakeaway.com",
    "marshahickeydds.com",
    "marshalheadphones.com",
    "marshallheadphone.com",
    "marshch.icu",
    "marshche.xyz",
    "marshl.ru",
    "marshord.icu",
    "marshpr.xyz",
    "marshpri.xyz",
    "marshwatc.buzz",
    "marsmecar.cf",
    "marsmecar.ga",
    "marsmecar.gq",
    "marsmecar.ml",
    "marsmecar.tk",
    "marstore.site",
    "marstur.com",
    "mart-hit-real.site",
    "mart-nsk.ru",
    "mart-trade-zero.ru",
    "mart.monster",
    "martasarimat.club",
    "martech-a2z.xyz",
    "martelli.shoes",
    "martin.securehost.com.es",
    "martin1minley2.com",
    "martincondosvegas.com",
    "martindalemail.com",
    "martinguerre.net",
    "martinmarch.shop",
    "martinocreative.com",
    "martinopodcasts.com",
    "martinoscabinteely.com",
    "martinospodcast.com",
    "martlet.site",
    "martynakubiak.com",
    "martyvole.ml",
    "marumaru2.com",
    "marun.shop",
    "maruti365.bet",
    "marutv.fun",
    "marutv7.fun",
    "marutv8.fun",
    "marutv9.fun",
    "marvelpress.com",
    "marvinlee.com",
    "marvinoka.com",
    "marwelax.com",
    "marwellhard.cf",
    "marwellhard.ga",
    "marwellhard.gq",
    "marxistlibrary.com",
    "mary.organic",
    "maryandmikebiz.com",
    "maryanncassidy.com",
    "marylacmzh.club",
    "marylacmzh.site",
    "marylacmzh.space",
    "marylacmzh.website",
    "marylandadoption.org",
    "marylandbbc.com",
    "marylandbookkeeping.com",
    "marylandpropertyfinders.com",
    "marylandwind.org",
    "maryscaccia.com",
    "maryscake.ru",
    "maryvallely55places.com",
    "mas-omkia.ru",
    "masafiagrofood.com",
    "masafigroupbd.com",
    "masaindah.online",
    "masala-twist-trim.com",
    "masasih.loan",
    "mascpottho.ga",
    "mascpottho.gq",
    "mascpottho.ml",
    "masd.pro",
    "masdihoo.cf",
    "masdihoo.ga",
    "masdihoo.gq",
    "masdihoo.tk",
    "maserathe.ml",
    "maserderas.ga",
    "mash4077.com",
    "mashasemenenko.art",
    "mashhosting.shop",
    "masihingat.xyz",
    "masikmama.ru",
    "masivepic.com",
    "mask-cledbel.ru",
    "mask03.ru",
    "maskads.xyz",
    "maskbistsmar.cf",
    "maskbistsmar.gq",
    "maskbistsmar.ml",
    "maskbistsmar.tk",
    "maskedmails.com",
    "maskedsingerbingo.com",
    "maskedsingercasino.com",
    "maskedsingergames.com",
    "maskercorona.online",
    "maskercorona.space",
    "maskgamenew.ru",
    "maski-russia-shop.ru",
    "maski-shop-russia.ru",
    "maskitop.cf",
    "maskmail.net",
    "masks-muzik.ru",
    "maskstore.world",
    "maskulin.dk",
    "maslokkd.gq",
    "masoncity-iowa.com",
    "masoneriavalencia.org",
    "masongazard.com",
    "masonhussain.buzz",
    "masonic.tech",
    "masonicslot.com",
    "masonline.info",
    "masonryky.com",
    "masonryservicesatokatn.com",
    "maspay.ru",
    "masrawy.com",
    "massachusettsadobe.com",
    "massachusettsroofingrepair.com",
    "massage-top.site",
    "massage2.ru",
    "massageinsurancequote.com",
    "massagenerdshow.com",
    "massagepraktijkmiranda.com",
    "massager-tpgun.ru",
    "masseffect1weightloss.world",
    "masshook.us",
    "massiftours.com",
    "massiftrails.com",
    "massivemalee.best",
    "massrewardgiveaway.gq",
    "masssky.com",
    "masstoly.ru",
    "massyacquaintpecan.site",
    "mastahype.net",
    "mastds.ru",
    "mastella.com",
    "master-crm.ru",
    "master-mail.net",
    "master-mind.site",
    "master-start61.ru",
    "masteravto777.ru",
    "masterbuiltoutlet.com",
    "masterbuiltoutlet.info",
    "masterbuiltoutlet.net",
    "masterbuiltoutlet.org",
    "mastercard-3d.cf",
    "masterclassediting.com",
    "masterclassretreat.com",
    "mastercodeteam.tech",
    "masterdominoqq.win",
    "masterfori.com",
    "masterfrioequipamentos.com",
    "mastergardens.org",
    "masterjudionline.com",
    "masterkudrovo.ru",
    "masterlightingcourse.com",
    "mastermine.website",
    "masternv.ru",
    "masterqiu9.com",
    "masterscollectionvegas.com",
    "mastersduel.com",
    "mastersoka.ru",
    "masterur.xyz",
    "masterwallact.com",
    "masterwallnsw.com",
    "masterwallnt.com",
    "masterwallsa.com",
    "masterwish.com",
    "masteryjsut.com",
    "mastihy.party",
    "masto.link",
    "masuk.shop",
    "masukbosku88.com",
    "maswae.world",
    "mataharipoker.info",
    "mataikan.club",
    "matamuasu.cf",
    "matamuasu.ga",
    "matamuasu.gq",
    "matamuasu.ml",
    "matanyashope.com",
    "match365.soccer",
    "match365.us",
    "matchcomputersspot.club",
    "matchdir.xyz",
    "matchdoug.space",
    "matchen.direct",
    "matchendirect.cloud",
    "matchgloo.xyz",
    "matchlessrecordings.org",
    "matchlitha.cf",
    "matchlitha.gq",
    "matchlitha.ml",
    "matchlitha.tk",
    "matchpol.net",
    "matchsingles2.us",
    "matchsingles7.us",
    "matchsingles8.us",
    "matchsingles9.us",
    "matchstickball.info",
    "matchthe.icu",
    "matchtvonline.ru",
    "matchup.site",
    "matcjesfashion.com",
    "matenow.site",
    "matepay.space",
    "mateplays.xyz",
    "materi.website",
    "materiali.ml",
    "materialos.com",
    "materialshop.net",
    "maternidadenaintegra.com",
    "maters968ba.xyz",
    "mathews.com",
    "mathiesen.dk",
    "mathslowsso.cf",
    "mathslowsso.ga",
    "mathslowsso.gq",
    "mathslowsso.ml",
    "matildadahlquist.se",
    "matildaj.se",
    "matmail.com",
    "matmee.net",
    "matobonationalpark.com",
    "matoji.info",
    "matra.site",
    "matra.top",
    "matrix-istanbul.xyz",
    "matrix.gallery",
    "matrixtechlab.com",
    "matrixyourreality.com",
    "matseborg.cf",
    "matseborg.ga",
    "matseborg.tk",
    "matt-salesforce.com",
    "mattbob.info",
    "mattbrock.com",
    "mattersjf8.com",
    "mattersofaging.com",
    "matthenry.name",
    "matthewguy.info",
    "matthewmagellan.com",
    "matthewservices.com",
    "matthewsnow.org",
    "matti.life",
    "mattmason.xyz",
    "mattschifrin.com",
    "maturejob.xyz",
    "maturemovie.info",
    "matureprofiles.com",
    "maturevirgin.club",
    "matzan-fried.com",
    "mauimail.com",
    "maumeehomesforsale.net",
    "mauo.xyz",
    "mauriciobento.top",
    "mauritius.com",
    "mauritzujn.space",
    "maurya.ml",
    "maverickcreativegroup.org",
    "maverickprocessing.net",
    "mavi-serum.online",
    "mavibebegim.com",
    "mavicmini.shop",
    "maviorjinal.xyz",
    "mavisacsuyu.xyz",
    "mavx.us",
    "mawaidha.info",
    "mawrkn.us",
    "max-direct.com",
    "max-gta.ru",
    "max-loto.ru",
    "max-mail.com",
    "max-mail.info",
    "max-mail.org",
    "max300fps.ru",
    "max66.live",
    "max7.site",
    "max88.club",
    "max99.xyz",
    "maxbetslots-zerkalo.ru",
    "maxcreditratings.com",
    "maxcro.com",
    "maxdatamail.com",
    "maxedoutgamers.com",
    "maxgate.org",
    "maxho.ru",
    "maxi-shop1.ru",
    "maxi.capital",
    "maximalbonus.de",
    "maximisereservices.com",
    "maximiserindia.com",
    "maximiserservices.com",
    "maximizelinks.com",
    "maximizer988vp.online",
    "maximloginov.net",
    "maximumbahis70.com",
    "maximumedge.com",
    "maximumoutdoors.net",
    "maxinim.ru",
    "maxiyoyo.com",
    "maxleft.com",
    "maxmail.co.uk",
    "maxmail.in",
    "maxmail.info",
    "maxmyprivacy.org",
    "maxnetflix.host",
    "maxnfl.com",
    "maxpanel.id",
    "maxprice.co",
    "maxrevues.info",
    "maxsize.online",
    "maxstylehome.com",
    "maxtommy-ra.ru",
    "maxtoy3d.club",
    "may-bk.org",
    "may17kural.net",
    "mayaaaa.cf",
    "mayaaaa.ga",
    "mayaaaa.gq",
    "mayaaaa.ml",
    "mayaaaa.tk",
    "mayantrainmap.com",
    "mayaple.ru",
    "mayatv.org",
    "mayba.live",
    "maybaoholaodong.net",
    "maybe.host",
    "maybeitworks.com",
    "maybeuploads.info",
    "maycatherenhat.com",
    "maycumbtib.ga",
    "maycumbtib.ml",
    "maycumbtib.tk",
    "maydayconception.com",
    "maydaytheconception.com",
    "maydongphucdep.org",
    "mayerman.ru",
    "mayflowerchristianschool.org",
    "maygiuxecamtay.com",
    "mayhannahs.info",
    "mayhutbuiquangngai.com",
    "mayimed.com",
    "maymovo.com",
    "mayoralo.press",
    "mayorfl.xyz",
    "mayorho.icu",
    "mayorpoker.net",
    "mayorwago.xyz",
    "mayposre.cf",
    "mayposre.ga",
    "mayposre.gq",
    "mayposre.ml",
    "mayposre.tk",
    "maz-gaminas.ru",
    "mazadaa.com",
    "mazaeff.ru",
    "mazaevka.ru",
    "mazda-6.club",
    "mazda.de",
    "mazdasa.site",
    "mb3boxers.com",
    "mb69.cf",
    "mb69.ga",
    "mb69.gq",
    "mb69.ml",
    "mb69.tk",
    "mb7y5hkrof.cf",
    "mb7y5hkrof.ga",
    "mb7y5hkrof.gq",
    "mb7y5hkrof.ml",
    "mb7y5hkrof.tk",
    "mbacolleges.info",
    "mbadicole.info",
    "mbahtekno.net",
    "mbangilan.ga",
    "mbap.ml",
    "mbavu.live",
    "mbccn.org",
    "mbclub.org",
    "mbconsult.online",
    "mbdnsmail.mooo.com",
    "mbe.kr",
    "mbeki.ru",
    "mbets.ru",
    "mbetxapp4.com",
    "mbf8ny.online",
    "mbfc6ynhc0a.cf",
    "mbfc6ynhc0a.ga",
    "mbfc6ynhc0a.gq",
    "mbfc6ynhc0a.ml",
    "mbfc6ynhc0a.tk",
    "mbitcasino1.com",
    "mbmraq.com",
    "mboarhndhalfd1o.xyz",
    "mboled.ml",
    "mbox.com.au",
    "mbox.re",
    "mbpro2.xyz",
    "mbroundhouseaquarium.org",
    "mbt01.cf",
    "mbt01.ga",
    "mbt01.gq",
    "mbt01.ml",
    "mbtech.id",
    "mbuhragagas.com",
    "mbuluzigamereserve.com",
    "mbutm4xjem.ga",
    "mbuy-cheap.ru",
    "mbvgook.com",
    "mbvn.us",
    "mbwedong.ru",
    "mbx.cc",
    "mbx80.com",
    "mbzl.xyz",
    "mc-17.com",
    "mc28.club",
    "mc32.club",
    "mc33.club",
    "mc36.club",
    "mc43.club",
    "mc45.club",
    "mc8xbx5m65trpt3gs.ga",
    "mc8xbx5m65trpt3gs.ml",
    "mc8xbx5m65trpt3gs.tk",
    "mcache.net",
    "mcapsa.com",
    "mcarnandgift.cf",
    "mcarnandgift.ga",
    "mcarnandgift.gq",
    "mcarnandgift.ml",
    "mcb1w.be",
    "mcb64dfwtw.cf",
    "mcb64dfwtw.ga",
    "mcb64dfwtw.gq",
    "mcb64dfwtw.ml",
    "mcb64dfwtw.tk",
    "mcbafrho.shop",
    "mcc-gsd.org",
    "mccarrol.best",
    "mccreedymail.com",
    "mccz.us",
    "mcdonald.cf",
    "mcdonald.gq",
    "mcfashion.online",
    "mcfire.online",
    "mcgratte.com",
    "mcgvau.shop",
    "mchsi.com",
    "mchurchapp.com",
    "mci.edu",
    "mciek.com",
    "mciworldcom.net",
    "mckenze.com",
    "mckenzieworldwide.net",
    "mckinneycaraccidentattorney.com",
    "mckinneypersonalinjurylawyers.com",
    "mckinseygovernmentandtheopposite.vision",
    "mckjotaelectronics.com",
    "mcklinkyblog.com",
    "mclegends.ru",
    "mclub-test.com",
    "mcm.dev",
    "mcmedia.com.au",
    "mcmillansmith.com",
    "mcmullenhomes.app",
    "mcoi.us",
    "mcoin-ex.net",
    "mcoin-ex.org",
    "mcoin-mmm.net",
    "mcoinex.net",
    "mcoll-original.com",
    "mcpego.ru",
    "mcpt.online",
    "mcrmail.com",
    "mcsafedata.com",
    "mcst-sd.net",
    "mcthomaslaw.com",
    "mcudj.us",
    "mcvip.es",
    "mcwanerd.com",
    "mcya.info",
    "mcyq.us",
    "md-thinking.com",
    "md0009.com",
    "md2ngb.info",
    "md5hashing.net",
    "mdaiac.org",
    "mdaix.us",
    "mdbr6a.host",
    "mdd100.com",
    "mddatabank.com",
    "mdfoj0.info",
    "mdfwg.space",
    "mdfworldgroup.com",
    "mdfworldgroup.fun",
    "mdfworldgroup.net",
    "mdfworldgroup.online",
    "mdfworldgroup.site",
    "mdfworldgroup.space",
    "mdhalfpricedlisting.com",
    "mdhalfpricedlistings.com",
    "mdhalfpricelistings.com",
    "mdhc.tk",
    "mdjwuw.com",
    "mdk5yi.us",
    "mdl90.xyz",
    "mdoe.de",
    "mdozdqrto.shop",
    "mdpc.de",
    "mdr188togel.net",
    "mdregistry.com",
    "mdriver.site",
    "mdstakeaway.com",
    "mdt.creo.site",
    "mdtk.us",
    "mdtqqtuszuqutqu.ru",
    "mdu.edu.rs",
    "mdut.us",
    "mdwo.com",
    "mdz39f-mail.xyz",
    "mdzcl1.site",
    "me-mail.hu",
    "me.com",
    "me22anysnkeij.xyz",
    "me2ikakkrn.xyz",
    "me2view.com",
    "meachi.site",
    "meadiamonds.com",
    "meadowbrookwaunakee.net",
    "meadowutilities.com",
    "meadowviewchurch.org",
    "meaistunac.cf",
    "meaistunac.tk",
    "mealaroc.cf",
    "mealaroc.ml",
    "mealaroc.tk",
    "mealcash.com",
    "mealigraavertu.ru",
    "mealprepware.com",
    "mealswithmilton.ru",
    "mealthys.com",
    "meandoofn.ml",
    "meanjames.com",
    "meanpeoplesuck.com",
    "meansfan.info",
    "meansfor.xyz",
    "meansforu.xyz",
    "meansoute.email",
    "meanspl.icu",
    "meanstem.com",
    "meanstreets405.com",
    "meantein.com",
    "meantinc.com",
    "measurecolor.team",
    "measuringthedream.com",
    "measurmzjs.site",
    "meatismurder.net",
    "mebbo.net",
    "mebel-v-rostove-na-donu.ru",
    "mebel-v-vykse.ru",
    "mebelapex.ru",
    "mebeldomoi.com",
    "mebelenok63.ru",
    "mebeleven.ru",
    "mebelgrafika.ru",
    "mebellstore.ru",
    "mebelnovation.ru",
    "mebelnu.info",
    "mebelwest.ru",
    "mebgrans.ru",
    "meboxmedia.us",
    "mebtel.net",
    "mec755.com",
    "mecamping.com",
    "mecbuc.cf",
    "mecbuc.ga",
    "mecbuc.gq",
    "mecbuc.ml",
    "mecbuc.tk",
    "mecg.us",
    "mechanicalresumes.com",
    "mechanization139xh.online",
    "mechb2b.com",
    "mechteda.ru",
    "mecip.net",
    "meckakorp.site",
    "mecs.de",
    "med-expertlife.ru",
    "med-factory-classic.ru",
    "med-knijka-ryazan.ru",
    "med-note.ru",
    "med.gd",
    "medaccess.space",
    "medaggregator.ru",
    "medagregator.ru",
    "medaille-precieuse.com",
    "medal365.biz",
    "medalists493ua.online",
    "medan4d.live",
    "medan4d.online",
    "medan4d.top",
    "medbat.ru",
    "medbiding.online",
    "medbiding.xyz",
    "medclick.org",
    "medcyber.com",
    "mededy.xyz",
    "medevacquote.com",
    "medevacratings.com",
    "medfaid.org",
    "medfederation.ru",
    "medflavor.com",
    "medfordcentral.com",
    "medfornorm.ru",
    "medhelperssustav.icu",
    "medhelperssustav.site",
    "medhelperssustav.space",
    "medhelperssustav.website",
    "medhelperssustav.xyz",
    "media-library.app",
    "media-maghreb.com",
    "media4ad.com",
    "mediabox-iptv.com",
    "mediaho.net",
    "mediakavkaz.ru",
    "mediamaid.net",
    "mediareserve.com",
    "medias24.org",
    "mediaseo.de",
    "mediaset.cf",
    "mediaset.gq",
    "mediastudio-dz.com",
    "mediatrack.ga",
    "mediatui.com",
    "medib.site",
    "medica2.com",
    "medical-malpractice.us",
    "medical-missions.org",
    "medical.net.au",
    "medical315.xyz",
    "medicalalert.app",
    "medicalanchor.com",
    "medicalbenefitexchange.com",
    "medicalbillingprogramzone.xyz",
    "medicalbrush.us",
    "medicalbrushes.biz",
    "medicalbrushes.us",
    "medicalclinicnearme.org",
    "medicalcontent.ru",
    "medicaldetoxprograms.com",
    "medicalmalpracticelawyersct.net",
    "medicalmarketingcouncil.com",
    "medicalservice.su",
    "medicaltravel24.com",
    "medicc.app",
    "mediciine.site",
    "medicinewaters.org",
    "medicinfo.icu",
    "mediciquestresearchgroup.net",
    "medid.site",
    "medif.site",
    "medig.site",
    "medil.site",
    "medimedr.shop",
    "medimom.com",
    "medione.net",
    "medirectwealth.net",
    "medit.site",
    "meditandocombah.com",
    "meditation-techniques-for-happiness.com",
    "meditationmuseumtci.com",
    "meditsinskie-uslugi.online",
    "meditsinskiekliniki.ru",
    "medjugorje-nel-cuore.com",
    "medkabinet-uzi.ru",
    "medleafcbd.com",
    "medmail.com",
    "medmaska.xyz",
    "medotikmas.gq",
    "medoviyspas.ru",
    "medpsychfinderonline.com",
    "medremservis.ru",
    "medrol.website",
    "meds-spravki.ru",
    "medscape.com",
    "medsestra-msk.ru",
    "medsheet.com",
    "medspauniversity.com",
    "medstudent.ga",
    "medtechweek.com",
    "medtryck.nu",
    "medvii.com",
    "medw.site",
    "medyayayincilik.com",
    "medyumhanimaga.com",
    "medzdrav-online.ru",
    "meellcm.ga",
    "meelot55.com",
    "meenakshisilks.com",
    "meensdert.ga",
    "meepsheep.eu",
    "meet-and-seed.com",
    "meet-me.live",
    "meet-now-here4.com",
    "meet45us.com",
    "meet908now.com",
    "meetandf.com",
    "meetandseed.com",
    "meethornygirls.top",
    "meetingmall.com",
    "meetingsbyevent.com",
    "meetlocalhorny.top",
    "meetupmonkey.com",
    "meetyourlove.com",
    "meey.tech",
    "meeyraro.cf",
    "meeyraro.gq",
    "meeyraro.ml",
    "mefemen.cf",
    "mefemen.ga",
    "mefemen.gq",
    "meg-ardis.xyz",
    "meg0ch0pik.site",
    "mega-base.xyz",
    "mega-classic-offer.site",
    "mega-cleanvoice.ru",
    "mega-kb.ru",
    "mega-rp.ru",
    "mega-sell8.ru",
    "mega-water.ru",
    "mega-wiki.ru",
    "mega.zik.dj",
    "mega303.bid",
    "mega303.website",
    "mega77.xyz",
    "megabitcard.net",
    "megabox.ru",
    "megadiscountonline.com",
    "megago.com",
    "megagrill.online",
    "megamacas.info",
    "megamail.cx",
    "megamail.pt",
    "megaoproc.site",
    "megapathdsl.net",
    "megapoint.com",
    "megarifa.xyz",
    "megaslots2016.ru",
    "megatir.ru",
    "megawhat.group",
    "megaxxi.com",
    "megbaystore.ru",
    "meghna-tandoori-takeaway.com",
    "megoism.net",
    "megotmail.com",
    "megrampedia.com",
    "meha.site",
    "mehalfpricedlisting.com",
    "mehalfpricelistings.com",
    "meharibache.fr",
    "mehditech.info",
    "mehmetbilir.xyz",
    "mehome.best",
    "mehrad.site",
    "mehrani.com",
    "mehrpoy.ir",
    "mehtaweb.com",
    "mehusupermart.site",
    "mehweb.com",
    "meiatx.tokyo",
    "meibokele.com",
    "meibreathpa.cf",
    "meibreathpa.ga",
    "meibreathpa.gq",
    "meibreathpa.ml",
    "meieark.online",
    "meieark.xyz",
    "meiguosaver.com",
    "meihuajun76.com",
    "meilleureexcuse.com",
    "meimeimail.cf",
    "meimeimail.gq",
    "meimeimail.ml",
    "meimeimail.tk",
    "mein-panel-post.life",
    "meine-dateien.info",
    "meine-diashow.de",
    "meine-fotos.info",
    "meine-urlaubsfotos.de",
    "meineinkaufsladen.de",
    "meingrosserkredit.club",
    "meinspamschutz.de",
    "meintick.com",
    "meirapy.ga",
    "meirapy.ml",
    "meirapy.tk",
    "meirhyther.ga",
    "meirhyther.gq",
    "meirhyther.ml",
    "meirhyther.tk",
    "meirmoses.com",
    "meirodu.cf",
    "meirodu.ga",
    "meirodu.gq",
    "meirodu.ml",
    "meisteralltrades.com",
    "meisterwerk-leben.com",
    "meitianlu04.xyz",
    "meitianlu06.xyz",
    "meitianlu07.xyz",
    "meitu.us",
    "meituxiezhen.xyz",
    "meja855.live",
    "meji.site",
    "mejjang.xyz",
    "mejores.best",
    "mejoresabogadosenvalencia.com",
    "mejoresgestorias.com",
    "mejorestenis.com",
    "mekacsmemy.sk",
    "mekazar.com",
    "meken.ru",
    "mekhong.com",
    "mekongchurchtown.com",
    "mekongheritage.net",
    "mekongtransfer.com",
    "melapatas.space",
    "melastdpwv.space",
    "melbetts2.ru",
    "melbournepte.com",
    "melhoramentos.net",
    "melhoresuavidahoje.com",
    "meliece.com",
    "meliinse.ru",
    "melindanash.com",
    "meliput.com",
    "melisarrs.xyz",
    "melisingapore.com",
    "melissastark.net",
    "melite.shop",
    "melitta-remont.ru",
    "melliap.com",
    "mellieswelding.com",
    "melloskin.ru",
    "melneyprep.cf",
    "meloc.ru",
    "melodicrock.net",
    "melodized655aq.online",
    "melodymail.com",
    "melodyservice.ru",
    "melon-beyond.com",
    "meloo.com",
    "melresa.cf",
    "melresa.ml",
    "melroseparkapartments.com",
    "melsyrup.com",
    "meltedbrownies.com",
    "meltel.net",
    "meltmail.com",
    "membed.xyz",
    "memberdadu.com",
    "memberdds.org",
    "memberheality.ga",
    "members.student.com",
    "memberskp.icu",
    "membransistemler.com",
    "meme-ultrasonu.com",
    "memecituenakganasli.cf",
    "memecituenakganasli.ga",
    "memecituenakganasli.gq",
    "memecituenakganasli.ml",
    "memecituenakganasli.tk",
    "memeil.top",
    "mememug.club",
    "memequeen.club",
    "memequeen.dev",
    "memequeen.fun",
    "memes.watch",
    "memescribe.com",
    "memeware.net",
    "memgrid.net",
    "memgrid.org",
    "memleket-haber.club",
    "memleket-haber.fun",
    "memleket-haber.live",
    "memleket-haber.website",
    "memlekethaber.club",
    "memlekethaber.fun",
    "memlekethaber.live",
    "memlekethaber.online",
    "memlekethaber.site",
    "memlekethaberonline.club",
    "memlekettenevime.xyz",
    "memo-news.com",
    "memonetwork.net",
    "memoney.site",
    "memoovie.site",
    "memoovo.com",
    "memori.ru",
    "memorizer76lw.online",
    "memotivas.com",
    "memotyr.xyz",
    "memphisnailsalons.com",
    "memphistaxgroup.com",
    "memphistechnologyfoundation.net",
    "memprof.com",
    "memsg.site",
    "memtv.ru",
    "memuremeklilik.com",
    "men-at-wok-takeaway.com",
    "men-finder2.com",
    "menacehvud.site",
    "menacehvud.website",
    "menanginstan.com",
    "menanid.buzz",
    "menara99.club",
    "menara99.net",
    "mendoan.uu.gl",
    "mendoanmail.club",
    "mendycady.com",
    "menealacola.com",
    "menflo.com",
    "mengatur.com",
    "mengchong.info",
    "mengdanai.com",
    "menggu720.com",
    "mengxiang-edu.com",
    "menhitects.com",
    "menja.net",
    "menjual.xyz",
    "menmosi.cf",
    "menmosi.gq",
    "meno4.xyz",
    "menph.info",
    "menqin.site",
    "mensbreakfast.app",
    "menscareshop.life",
    "mensdivorcearkansas.com",
    "mensdivorcecalifornia.com",
    "mensdivorcedelaware.com",
    "mensdivorceflorida.com",
    "mensdivorceindiana.com",
    "mensdivorceiowa.com",
    "mensdivorcemichigan.com",
    "mensdivorcemississippi.com",
    "mensdivorcenebraska.com",
    "mensdivorcesouthcarolina.com",
    "mensdivorcesouthdakota.com",
    "mensdivorcewyoming.com",
    "menseage.cf",
    "menseage.tk",
    "menshealth.science",
    "menshealthjournal.online",
    "menskartel.ru",
    "mensmusclefit.com",
    "mensshop.futbol",
    "menssubstanceabusetreatment.com",
    "mentalevolution.club",
    "mentalhealthdepressiondoctor.com",
    "mentalhealthdepressiontherapist.com",
    "mentalhealththerapyprograms.com",
    "mentalhealthtreatmentscenter.com",
    "mentalism.site",
    "mentdama.gq",
    "mentdama.ml",
    "mentdama.tk",
    "mentechtma.website",
    "mentesquevendem.com",
    "mentnetla.cf",
    "mentnetla.ga",
    "mentnetla.gq",
    "mentnetla.ml",
    "mentnetla.tk",
    "mentoggrup.tk",
    "mentoredbymillionaires.org",
    "mentorphrase.com",
    "mentorsbureau.org",
    "menu-go.com",
    "menurehberi.com",
    "meokhuyenmai.com",
    "mepf1zygtuxz7t4.cf",
    "mepf1zygtuxz7t4.ga",
    "mepf1zygtuxz7t4.gq",
    "mepf1zygtuxz7t4.ml",
    "mepf1zygtuxz7t4.tk",
    "mephistore.co",
    "mepost.pw",
    "meprice.co",
    "meprorlai.com",
    "mepubnai.cf",
    "mepubnai.gq",
    "mepubnai.ml",
    "mepw6u.site",
    "meqa1f.xyz",
    "mera.money",
    "meraciousmotyxskin.com",
    "merakigrown.com",
    "merameri.shop",
    "merantikk.cf",
    "merantikk.ga",
    "merantikk.gq",
    "merantikk.ml",
    "merantikk.tk",
    "mercadodeactivos.com",
    "mercadoofertas.ml",
    "mercevpn.xyz",
    "merchantpalace.store",
    "merched.dev",
    "merchize.wiki",
    "merchpay3ds.ru",
    "merchstore.store",
    "mercurecasino10.com",
    "mercurecasino3.com",
    "mercurecasino5.com",
    "mercurecasino9.com",
    "mercury-global-pro.ru",
    "mercury-globalmir.ru",
    "mercurybetsuper6.com",
    "mercuryhub.com",
    "mercuryinsutance.com",
    "mercy.cf",
    "mercyea.icu",
    "merd6i.xyz",
    "merda.cf",
    "merda.flu.cc",
    "merda.ga",
    "merda.gq",
    "merda.igg.biz",
    "merda.ml",
    "merda.nut.cc",
    "merda.usa.cc",
    "meredithmanor.info",
    "mergaab.me",
    "meridyendernegi.com",
    "merijn.app",
    "merimera.shop",
    "merintasa.best",
    "merisaloer.club",
    "merisaza.club",
    "meritbet57.com",
    "meritbl.xyz",
    "meritbonus.info",
    "meritcasinos.biz",
    "meritcasinos.ist",
    "meritcasinos.kim",
    "meritcasinos.net",
    "meritjackpods.com",
    "meritp10.best",
    "meritpummelpence.site",
    "meritroyal.online",
    "meritroyalbet.info",
    "meritroyalbet.online",
    "meritroyalchocolatepalace.net",
    "meritroyalgiris.online",
    "meritslot60.com",
    "meritsport.com",
    "meritum.dev",
    "merituminteractive.net",
    "meritwast.recipes",
    "meritwaste.recipes",
    "merizadcw.club",
    "merizateax.club",
    "merkezefendisinav.xyz",
    "merliaz.xyz",
    "merlincase.com",
    "mermaid-construction.com",
    "meroba.cf",
    "meroba.ga",
    "meroba.gq",
    "meroba.ml",
    "merpare.tk",
    "merrilgentle.com",
    "merrittnils.ga",
    "merry.pink",
    "merrylanguidperch.site",
    "merseine.nu",
    "merseymail.com",
    "mersinaft.ga",
    "mersincast.com",
    "mersincilekroom.xyz",
    "mersinli.info",
    "mersinlicigercimucahid.com",
    "mersinrentals.online",
    "mersinrentals.xyz",
    "mertiansaacco21-met.com",
    "mertolinaperoti.xyz",
    "merysee.space",
    "mesaamado.com",
    "mesama.gq",
    "mesama.ml",
    "mesavegas.com",
    "mesbagall.ru",
    "mesbeci.cf",
    "mesbeci.ml",
    "mesbeci.tk",
    "mesberlins.info",
    "mescevo.cf",
    "mescevo.ga",
    "mescevo.gq",
    "mescevo.tk",
    "mesdemarchesadministratives.com",
    "mesedidu.site",
    "mesef.fun",
    "mesili.ga",
    "mesili.gq",
    "mesinkoin.org",
    "mesmerized883ib.online",
    "mesmi.site",
    "mesoindonesia.com",
    "mesotheliomaattorneyvirginia.com",
    "mesotheliomalawyervirginia.com",
    "mesotheliomasrates.ml",
    "mesotheliomatrustfund.net",
    "mesquiteinjurylawyers.com",
    "mesquitetexaschiropractor.com",
    "mesra.net",
    "mesradsfi.cf",
    "mesradsfi.ml",
    "messaeg.gq",
    "messagdo.com",
    "message-station.com",
    "message.hu",
    "message.myspace.com",
    "messagea.gq",
    "messagebeamer.de",
    "messagecenter.com",
    "messageden.com",
    "messageden.net",
    "messageme.ga",
    "messageproof.gq",
    "messageproof.ml",
    "messager.cf",
    "messages.to",
    "messagesafe.co",
    "messagesafe.io",
    "messagesafe.ninja",
    "messagetop.site",
    "messagez.com",
    "messaging.page",
    "messagugi.com",
    "messengermarketingstrategist.com",
    "messengers.email",
    "messiahmbc.com",
    "messihalocal.com",
    "messing.life",
    "messsalons.info",
    "messwiththebestdielikethe.rest",
    "messymeek.com",
    "mestechnik.de",
    "mestgersta.cf",
    "mestgersta.ga",
    "mestgersta.gq",
    "mestgersta.tk",
    "met-coin.com",
    "met5fercj18.cf",
    "met5fercj18.ga",
    "met5fercj18.gq",
    "met5fercj18.ml",
    "met5fercj18.tk",
    "meta-bet.ru",
    "meta-gas-in.ru",
    "meta.ua",
    "metabolicbalance.sk",
    "metabox.info",
    "metacrawler.com",
    "metacrunch.com",
    "metahero.net",
    "metalfan.com",
    "metalhalidegrowlights.com",
    "metall-tradenn.ru",
    "metalliccut.com",
    "metallymc.shop",
    "metalrika.club",
    "metalstroj.sk",
    "metameto.shop",
    "metamodel.dev",
    "metamorphosisproducts.com",
    "metamusic.blog",
    "metaping.com",
    "metaprice.co",
    "metareview.ru",
    "metashooting.com",
    "metatader4.com",
    "metatrader5.blog",
    "metavivor.net",
    "metesandbounds.co",
    "methemoglobin790kx.online",
    "metkan-akmola.ru",
    "metkomsplav.ru",
    "metlif3.com",
    "metocape.email",
    "metodoacta.com",
    "metodoremoto.site",
    "metometa.shop",
    "metoosummit.com",
    "metro-grill-carlow.com",
    "metroautoexchange.com",
    "metrobtc.com",
    "metroclone.com",
    "metroeu.host",
    "metrofoodtours.com",
    "metropoligon.club",
    "metroset.net",
    "metroweekly.net",
    "metta.lk",
    "mettamarketingsolutions.com",
    "metuwar.tk",
    "metvauproph.cf",
    "meu.plus",
    "meubelocorpo.com",
    "meucoach.page",
    "meulilis.cf",
    "meulilis.gq",
    "meulilis.ml",
    "meulilis.tk",
    "meumapa.com",
    "meumestredigital.store",
    "mevall.com",
    "meve8fekkes.xyz",
    "meveatan.cf",
    "meveatan.ga",
    "meveatan.gq",
    "mevityny.tk",
    "mevj.de",
    "mevoty.xyz",
    "mew88.com",
    "mewinsni.cf",
    "mewinsni.ga",
    "mewinsni.ml",
    "mewinsni.tk",
    "mewprulu.shop",
    "mex.broker",
    "mexaqy.info",
    "mexh.us",
    "mexicanalia.com",
    "mexico500.com",
    "mexicomail.com",
    "mexicons.com",
    "mexylocu.website",
    "meybet52.com",
    "meybet57.com",
    "meyfugo.ga",
    "meyfugo.gq",
    "meyfugo.tk",
    "meymey.website",
    "meyvaagacim.com",
    "meyveli.site",
    "mezartemizligi.xyz",
    "mezimages.net",
    "mezime.xyz",
    "mf8a5b.us",
    "mfano.cf",
    "mfano.ga",
    "mfano.gq",
    "mfano.tk",
    "mfautxy57ntizy9.xyz",
    "mfayp.site",
    "mfbb8.com",
    "mfbh.cf",
    "mfbog1.site",
    "mfbunkoj.online",
    "mfbx.org",
    "mfdn.ru",
    "mfghrtdf5bgfhj7hh.tk",
    "mfhelicopters.com",
    "mfil4v88vc1e.cf",
    "mfil4v88vc1e.ga",
    "mfil4v88vc1e.gq",
    "mfil4v88vc1e.ml",
    "mfil4v88vc1e.tk",
    "mflfdgsa.shop",
    "mfsa.info",
    "mfsa.ru",
    "mft1199240.xyz",
    "mft3019470.xyz",
    "mft5593946.xyz",
    "mft7412888.com",
    "mft9534720.xyz",
    "mft9542713.xyz",
    "mft9545932.xyz",
    "mft9552245.xyz",
    "mft9574808.xyz",
    "mft9576391.xyz",
    "mft9603894.xyz",
    "mft9630791.xyz",
    "mft9641640.xyz",
    "mft9648484.xyz",
    "mft9714057.xyz",
    "mft9714425.xyz",
    "mft9714650.xyz",
    "mft9721847.xyz",
    "mft9736417.xyz",
    "mft9755259.xyz",
    "mft9759510.xyz",
    "mft9785411.xyz",
    "mft9797712.xyz",
    "mft9820886.xyz",
    "mft9850605.xyz",
    "mft9857521.xyz",
    "mft9864784.xyz",
    "mft9867978.xyz",
    "mft9876343.xyz",
    "mft9883173.xyz",
    "mft9911897.xyz",
    "mft9920868.xyz",
    "mfuil.us",
    "mfvn.us",
    "mfxs.us",
    "mfzwhd.us",
    "mg-rover.cf",
    "mg-rover.ga",
    "mg-rover.gq",
    "mg-rover.ml",
    "mg-rover.tk",
    "mg520520.com",
    "mgangabet.com",
    "mgapoker88.org",
    "mgclimat.ru",
    "mgdchina.com",
    "mgeladze.ru",
    "mgfstripe.com",
    "mgm920.com",
    "mgm999lao.net",
    "mgmawa.org",
    "mgmdomino.org",
    "mgme.xyz",
    "mgoiv.site",
    "mgt.miansheng.men",
    "mgt4rwssl.com",
    "mgtu-volley.ru",
    "mgtwzp.site",
    "mgve.us",
    "mgwear.ru",
    "mgwned.com",
    "mgzzy.com",
    "mh-pt09.com",
    "mh3fypksyifllpfdo.cf",
    "mh3fypksyifllpfdo.ga",
    "mh3fypksyifllpfdo.gq",
    "mh3fypksyifllpfdo.ml",
    "mh3fypksyifllpfdo.tk",
    "mhahk.site",
    "mhairitaylor.com",
    "mhcnt.icu",
    "mhcolimpia.ru",
    "mhdbilling.com",
    "mhdpower.me",
    "mhdsl.cf",
    "mhdsl.ddns.net",
    "mhdsl.dynamic-dns.net",
    "mhdsl.ga",
    "mhdsl.gq",
    "mhdsl.ml",
    "mhdsl.tk",
    "mhimail.com",
    "mhirhdon.shop",
    "mhkttmknx4fxts8.xyz",
    "mhmht.com",
    "mhmmmkumen.cf",
    "mhmmmkumen.ga",
    "mhmmmkumen.gq",
    "mhmmmkumen.ml",
    "mhmotoren.nl",
    "mhnb27.com",
    "mhnb4.com",
    "mhnb81.com",
    "mhnb84.com",
    "mhog.shop",
    "mhotel.us",
    "mhov.us",
    "mhqxl.us",
    "mhs78.space",
    "mhtqq.icu",
    "mhwolf.net",
    "mhxcpxbna.shop",
    "mi-turisto.ru",
    "mi.meon.be",
    "mi1-gazil.ru",
    "mia6ben90uriobp.cf",
    "mia6ben90uriobp.ga",
    "mia6ben90uriobp.gq",
    "mia6ben90uriobp.ml",
    "mia6ben90uriobp.tk",
    "miaferrari.com",
    "miaflorido.com",
    "miakhalifa.mobi",
    "mial.cf",
    "mial.com.creou.dev",
    "mial.tk",
    "miam.kd2.org",
    "miami-invest.ru",
    "miamicolo.com",
    "miamifalls.info",
    "miamifldoubledeckertours.com",
    "miamihotel.space",
    "miamiquote.com",
    "miamislime.com",
    "miamitourssightseeing.com",
    "miamiwrongfuldeathattorneys.com",
    "miao-youxi.xyz",
    "miaobidu.com",
    "miaohaha.com",
    "miaomiewang.com",
    "miasionfed.com",
    "miatadriver.com",
    "miauj.com",
    "miaw.guru",
    "mibaopay.com",
    "mibet.net",
    "mibm.email",
    "mibomart.site",
    "mic3eggekteqil8.cf",
    "mic3eggekteqil8.ga",
    "mic3eggekteqil8.gq",
    "mic3eggekteqil8.ml",
    "mic3eggekteqil8.tk",
    "micalmo.org",
    "micasapropia.com",
    "michaelalamillo.com",
    "michaelbberger.com",
    "michaelbea.com",
    "michaelbollhoefer.com",
    "michaeldurante.com",
    "michaelgballard.com",
    "michaelkimball.info",
    "michaelkorsoutletstoresinc.com",
    "michaellees.net",
    "michaelr.org",
    "michaelrader.biz",
    "michaelstenta.net",
    "michaelvelardelaw.net",
    "michaelwheaton.us",
    "michaleway.buzz",
    "michegen.xyz",
    "michelangelomedia.com",
    "michelinmape.info",
    "michellejondall.com",
    "michellelagasse.com",
    "michellemjondall.com",
    "michianahotairballoonrides.com",
    "michigandiscdogclub.com",
    "michiganmobilemedia.com",
    "michiganpepsi.com",
    "michiganprospect.org",
    "michigansmok.com",
    "michiganswingdance.com",
    "michingmalicho.com",
    "michingmalicho.org",
    "micleber.gq",
    "micleber.ml",
    "micleber.tk",
    "micll.com",
    "micll.net",
    "miclonegroup.com",
    "micmeore.cf",
    "micmeore.ml",
    "microcenter.io",
    "microhealthworld.com",
    "microlium.xyz",
    "micromentors.org",
    "micromobix.com",
    "micronti.xyz",
    "micropaleontologies453wm.online",
    "micropaleontology867pf.online",
    "micros-solutions.live",
    "microsaledirect.com",
    "microsofl.website",
    "microsoftarticles.info",
    "microsoftopedia.com",
    "microsotft.org",
    "microspeed.life",
    "microwavetechnology.xyz",
    "microzaempromo.ru",
    "micsocks.net",
    "midaimupfhj.email",
    "midas-panel.site",
    "midcoastcustoms.com",
    "midcoastcustoms.net",
    "midcoastsolutions.com",
    "midcoastsolutions.net",
    "midcontflyway.com",
    "middaybublo.email",
    "middleeasthealthcareportal.com",
    "middletownpolice.org",
    "mideastpower.com",
    "midebalonu.org",
    "midekelepcesi.org",
    "midemidd.shop",
    "midesafio.com",
    "mideuda.com",
    "midfloridaa.com",
    "midfloridda.com",
    "midhy.me",
    "midlandquote.com",
    "midlertidig.com",
    "midlertidig.net",
    "midlertidig.org",
    "midnightsketches.org",
    "midoggshop.com",
    "midtoco.ga",
    "midtoco.tk",
    "midtownatlanta.us",
    "midtownmadness.org",
    "midtzatfo.ga",
    "midtzatfo.gq",
    "midtzatfo.tk",
    "midway-travel.xyz",
    "miegrg.ga",
    "miegrg.ml",
    "miehejus.ga",
    "miehejus.gq",
    "miehejus.ml",
    "miehejus.tk",
    "miend.live",
    "mienphiphanmem.com",
    "mieqas.com",
    "mierdamail.com",
    "miesto.sk",
    "mietpreisbremse.works",
    "miewest.com",
    "mig-filltide.rest",
    "mig-zaym.ru",
    "might.sale",
    "mightcubed.com",
    "mightcubed.org",
    "mightuvi.cf",
    "mightuvi.ga",
    "mightuvi.ml",
    "mighty.co.za",
    "mighty.technivant.net",
    "migloveusa.com",
    "migmail.net",
    "migmail.pl",
    "migraene-forum.info",
    "migrate.cash",
    "migrate.codes",
    "migserver2.gq",
    "migserver2.ml",
    "migumail.com",
    "mihalfpricedlisting.com",
    "mihanmail.ir",
    "mihealthpx.com",
    "mihep.com",
    "mihhaboe.us",
    "miho-nakayama.com",
    "miissionfed.com",
    "miisxw.com",
    "mijacknews.cf",
    "mijacknews.gq",
    "mijacknews.tk",
    "mijnbestanden.shop",
    "mijnfileserver.online",
    "mijnhva.nl",
    "mijnroosters.online",
    "mijnzoekmaatje.online",
    "mijumail.com",
    "mikaelsen.dk",
    "mikaelskin.com",
    "mikazi.club",
    "mikcasinoboy.ru",
    "mikebehar2020.com",
    "mikebehar2020.org",
    "mikecampbellracing.com",
    "mikefranken.org",
    "mikejacobson.org",
    "mikescomputersga.net",
    "mikessupermarket.com",
    "mikidolenz.com",
    "mikkelsen.dk",
    "mikolastro.ml",
    "mikos1.site",
    "mikrotamanet.com",
    "mikrotik.website",
    "miksa.store",
    "mikuwiki.com",
    "mila-levchyk.info",
    "miladamalich.ru",
    "miladexchange.com",
    "milandwi.cf",
    "milankashop.ru",
    "milanotransex.com",
    "milaspc.com",
    "milavitsaromania.ro",
    "milcepoun.cf",
    "milcepoun.ga",
    "milcepoun.gq",
    "milcepoun.ml",
    "milcepoun.tk",
    "milcvp.shop",
    "mildin.org.ua",
    "mildunity.us",
    "milesroger.com",
    "miletance.com",
    "milionariosdobitcoin.com",
    "militarizes572bb.online",
    "militarybrush.net",
    "militarybrushes.us",
    "militaryencyclopedia.com",
    "milittis.com",
    "miljaye.ga",
    "milk.gage.ga",
    "milkdrooperver.ru",
    "milke.ru",
    "milkteam.ru",
    "milkyplasticperky.site",
    "millelacsanglers.com",
    "milleniatakeaway.com",
    "millennialistbook.com",
    "millennialswedding.club",
    "millennium-marines.ru",
    "millertavernbay.com",
    "millertavernyonge.com",
    "millervet.info",
    "milliebarry.buzz",
    "milliemaidcleaning.com",
    "millimailer2.com",
    "millimentor.com",
    "millionahair.com",
    "millionaireintraining.com",
    "millionairemail.com",
    "milliondollarchica.com",
    "millionertut.ru",
    "millironfarm.online",
    "millkvoyage.host",
    "millnevi.cf",
    "millnevi.gq",
    "millnevi.tk",
    "millstonepenyffordd.com",
    "millvalleyflowerdelivery.com",
    "millz.ru",
    "milmail.com",
    "milmail.com15",
    "miloandpi.com",
    "milohe.info",
    "milosbet100.com",
    "milosbet1000.com",
    "milosbet68.com",
    "milouikn2.site",
    "milpitas.net",
    "milsaborespuertollano.com",
    "miluscasno.best",
    "milwaukeedustless.net",
    "milwaukeedustless.org",
    "milwaukeedustless.us",
    "milwaukeedustlessbrush.us",
    "mimarifuarlar.com",
    "mimarinos.info",
    "mimcasinocrowd.ru",
    "mimemoi.online",
    "mimemorre.site",
    "mimi-go.com",
    "mimijkng.xyz",
    "miminko.net",
    "mimispantry.org",
    "mimiuuu.com",
    "mimko.com",
    "mimmospizzacubellescubelles.com",
    "mimpaharpur.cf",
    "mimpaharpur.ga",
    "mimpaharpur.gq",
    "mimpaharpur.ml",
    "mimpaharpur.tk",
    "min-group.club",
    "min-postkasse.dk",
    "min.burningfish.net",
    "minadentist.com",
    "minbise.cf",
    "minbise.gq",
    "minbise.tk",
    "mindandbodydaily.com",
    "mindbodylab.org",
    "mindbodytraining.org",
    "mindcloud.app",
    "mindfase.tk",
    "mindfery.tk",
    "mindfulnessinlaw.org",
    "mindfulpainreliefcourse.com",
    "mindless.com",
    "mindmail.ga",
    "mindmatho.ml",
    "mindmatho.tk",
    "mindmyonlinebiz.com",
    "mindrise.info",
    "minds.exchange",
    "mindsetup.us",
    "mindspring.com",
    "mindyrose.online",
    "mine-web-application-dev.club",
    "mine.nu",
    "mineadsaiinstalls.club",
    "mineblue.ru",
    "minecraft-dungeons.ru",
    "minecraft-keys.com",
    "minecraftaccountfree.com",
    "minecraftinfo.ru",
    "minecraftproject.ru",
    "minecraftrabbithole.com",
    "minecraftul.ru",
    "minedon.online",
    "minelk-gazik.ru",
    "minephysics.com",
    "mineprinter.us",
    "mineralize.best",
    "mineralka1.cf",
    "mineralka1.ga",
    "mineralka1.gq",
    "mineralka1.ml",
    "mineralka1.tk",
    "mineralwnx.com",
    "minercontrolpanel.com",
    "minergate.download",
    "minerhouse.ru",
    "minermail.com",
    "minerpanel.com",
    "minerscamp.org",
    "minershe.us",
    "minerspl.press",
    "minerworth.email",
    "minesox.info",
    "minetopiaworld.online",
    "minex-coin.com",
    "mingbocor.ga",
    "mingbocor.ml",
    "minggardentakeaway.com",
    "mingnickta.gq",
    "mingshengylc.com",
    "minhazfb.cf",
    "minhazfb.ga",
    "minhazfb.ml",
    "minhazfb.tk",
    "mini-kraanhuren.com",
    "mini-mail.com",
    "mini-mail.net",
    "mini-quadcopter.ru",
    "mini-traktor56.ru",
    "miniaturebrush.net",
    "miniaturebrush.us",
    "miniaturebrushes.com",
    "minibilgi.net",
    "minibubo.com",
    "minicamera-dv.info",
    "minikokul.net",
    "minimail.club",
    "minimal.homes",
    "minimiseapp.com",
    "minimized409gz.online",
    "minimized606ok.online",
    "minimized705mz.online",
    "minimizer343rl.online",
    "minimoifactory.info",
    "minimoifactory.org",
    "minimotorsscooter.com",
    "minionsofgygax.com",
    "minishop.site",
    "minister.com",
    "ministry-of-silly-walks.de",
    "ministryofinnovation.ru",
    "ministrysites.host",
    "ministrysupport.app",
    "minitrailersusa.com",
    "minkh.ru",
    "minletoy.com",
    "minnacarter.com",
    "minnesota-fishing.com",
    "minnesotahomeonthelake.com",
    "minnesotahomesonthelake.com",
    "minnesotaopera.org",
    "minnesotapheasants.com",
    "minnesotawalleyeguide.com",
    "mino855.com",
    "mino855.social",
    "minoreatingdisordertreatment.com",
    "minprivatemail.dk",
    "minscamep.cf",
    "minscamep.ga",
    "minscamep.gq",
    "minscamep.ml",
    "minscamep.tk",
    "minskimedia.com",
    "minsmail.com",
    "mintadomaindong.cf",
    "mintadomaindong.ga",
    "mintadomaindong.gq",
    "mintadomaindong.ml",
    "mintadomaindong.tk",
    "mintcbg.com",
    "mintconditionin.ga",
    "mintemail.cf",
    "mintemail.com",
    "mintemail.ga",
    "mintemail.gq",
    "mintemail.ml",
    "mintemail.tk",
    "mintsbolts.top",
    "mintsportjop.ru",
    "mintstresms.xyz",
    "minumeroweb.com",
    "minustaliya.ru",
    "minutasim.ml",
    "minutemusic.monster",
    "minutesolar.com",
    "minutious.site",
    "minxstar.fun",
    "minyakbuasir.com",
    "minyon.info",
    "minzdravros.ru",
    "miochas.info",
    "miodonski.ch",
    "miodowadolina.com",
    "miolayfran.cf",
    "miolayfran.ml",
    "miolayfran.tk",
    "mionetwork.email",
    "miototo.com",
    "miototo.net",
    "miowiki.com",
    "miplan.info",
    "mipodon.ga",
    "mir-ori.ru",
    "mir-sveta52.ru",
    "mir-venka.ru",
    "mirabellebra.com",
    "mirabelleslim.com",
    "mirablu.shop",
    "miraciousmoty.com",
    "miraclepc.ru",
    "miradorveleia.xyz",
    "miraigames.net",
    "miramulet.ru",
    "miranda1121.club",
    "mirautoportal.ru",
    "mirchi-malahide.com",
    "mirchifun.tech",
    "mirelt.su",
    "miretig.cf",
    "miretig.ga",
    "miretig.tk",
    "miriarab.ru",
    "mirider.cf",
    "mirider.ga",
    "mirider.gq",
    "mirimbaklava.com",
    "mirimus.org",
    "mirinfomed.ru",
    "mirkarkas.ru",
    "mirker-mag64.host",
    "mirkvadro.ru",
    "mirmirchi.site",
    "mirnes.store",
    "mirnichtsdirnichts.love",
    "mironovskaya.ru",
    "mirori.ru",
    "mirpiknika.ru",
    "mirproektorov.ru",
    "mirror37.ru",
    "mirror49.ru",
    "mirror53.ru",
    "mirror86.ru",
    "mirror89.ru",
    "mirrorrr.asia",
    "mirrorsstorms.top",
    "mirrror.asia",
    "mirtazapine.life",
    "mirteka.ru",
    "mirtopseo.ru",
    "mirtox.com",
    "mirturistic.ru",
    "mirzaindian.com",
    "mirzamail.app",
    "misbondis.com",
    "miscbrunei.net",
    "miscil.best",
    "misconfused.org",
    "misdemeanors337dr.online",
    "misdivisas.app",
    "miselgulsuyu.com",
    "miseoutlet.site",
    "misery.net",
    "miseryloves.co",
    "misgotten.best",
    "misha-rosestoy.ru",
    "misha-roza.ru",
    "mishawakadentists.com",
    "mishel-hotel.ru",
    "mishka-dacha.ru",
    "mishka-iz-roz-official.ru",
    "mishka-iz-roz-v-moscow.ru",
    "mishki-mimi.ru",
    "mishkirose.ru",
    "mishooklaw.com",
    "mishov.org",
    "mishovforex.net",
    "mishreid.net",
    "misiakmasonry.com",
    "misiry.info",
    "misitionline.com",
    "misjudgments473zr.online",
    "misol.dev",
    "misonet.shop",
    "misotorrent2.com",
    "misous.xyz",
    "miss-cosmo.ru",
    "missalkaram.com",
    "misseat.ru",
    "missfacts.com",
    "missfitenergy.com",
    "missing-e.com",
    "missiobfed.com",
    "missionfedd.com",
    "missionvisi.xyz",
    "missionwildbird.net",
    "mississaugafiberglasspools.com",
    "missjones.info",
    "misslana.ru",
    "missniuniu.com",
    "missoulajewelrybuyer.com",
    "missouricityapartments.com",
    "misspentsonicyouth.com",
    "misspomps.info",
    "missride.info",
    "misssiliconvalley.org",
    "missthegame.com",
    "mistatera.email",
    "mistatera.international",
    "mistaterra.com",
    "misteioslybanand.fun",
    "mister-puzzle.ru",
    "mister-stak.ru",
    "misterbeads.ru",
    "misterbearsky.com",
    "mistercursos.org",
    "misterhoki.online",
    "mistermelodyshopchik.host",
    "mistermelodyshopchik.online",
    "mistermelodyshopchik.site",
    "mistermelodyshopchik.space",
    "mistermelodyshopchik.website",
    "mistermosquitos.com",
    "misterpinball.de",
    "misterstiff.com",
    "mistindu.xyz",
    "mistlink.us",
    "mistridai.com",
    "mistyle.ru",
    "misvetun.cf",
    "misvetun.ga",
    "misvetun.gq",
    "misvetun.ml",
    "misworkbar.cf",
    "misworkbar.ga",
    "misworkbar.gq",
    "misworkbar.tk",
    "mit.tc",
    "mitchbroderick.com",
    "mite.tk",
    "mithrabvtd.space",
    "mitid.site",
    "mitie.site",
    "mitir.site",
    "mitiz.site",
    "mitmona.com",
    "mitobet.com",
    "mitori.org",
    "mitracore.net",
    "mitrasbo.com",
    "mitretek.info",
    "mitssupppsych.ga",
    "mitssupppsych.gq",
    "mitssupppsych.ml",
    "mitsubishi-asx.cf",
    "mitsubishi-asx.ga",
    "mitsubishi-asx.gq",
    "mitsubishi-asx.ml",
    "mitsubishi-asx.tk",
    "mitsubishi-pajero.cf",
    "mitsubishi-pajero.ga",
    "mitsubishi-pajero.gq",
    "mitsubishi-pajero.ml",
    "mitsubishi-pajero.tk",
    "mitsubishi2.cf",
    "mitsubishi2.ga",
    "mitsubishi2.gq",
    "mitsubishi2.ml",
    "mitsubishi2.tk",
    "mittalweb.com",
    "mittidikhushboo.com",
    "mittrykte.se",
    "mituvn.com",
    "miumiubags.site",
    "miur.cf",
    "miur.ga",
    "miur.gq",
    "miur.ml",
    "miur.tk",
    "mivyky.info",
    "miwhibi.ml",
    "miwhibi.tk",
    "mix-90.com",
    "mix-mail.org",
    "mix-spice-takeaway.com",
    "mix90.black",
    "mix90.blue",
    "mixbeads.ru",
    "mixbiki.ga",
    "mixbiki.ml",
    "mixbiki.tk",
    "mixbox.pl",
    "mixchains.win",
    "mixcloud-downloader.club",
    "mixcomps.com",
    "mixely.com",
    "mixetf.com",
    "mixi.gq",
    "mixmail.com",
    "mixmailer.info",
    "mixoxo.com",
    "mixspicetakeaway.com",
    "mixtrewards.com",
    "mizgold.net",
    "mizohillsa.info",
    "mizugiq2efhd.cf",
    "mizugiq2efhd.ga",
    "mizugiq2efhd.gq",
    "mizugiq2efhd.ml",
    "mizugiq2efhd.tk",
    "mjasodel.ru",
    "mjbach.com",
    "mjelthvv.shop",
    "mjfrogmail.com",
    "mjgl62.us",
    "mjhqz.com",
    "mjhtr43.xyz",
    "mji.ro",
    "mjifmd.site",
    "mjjbbs.com",
    "mjjdns.com",
    "mjjhub.com",
    "mjjpy.com",
    "mjlf.space",
    "mjpxvm.com",
    "mjsantos.org",
    "mjsuxsm.xyz",
    "mjtsupport.com",
    "mjuifg5878xcbvg.ga",
    "mjukglass.nu",
    "mjusq5.us",
    "mjut.ml",
    "mjxfghdfe54bnf.cf",
    "mk.netmail.tk",
    "mk24.at",
    "mk9fad.us",
    "mkb-phone.com",
    "mkbtelefoonservice.com",
    "mkbw3iv5vqreks2r.ga",
    "mkbw3iv5vqreks2r.ml",
    "mkbw3iv5vqreks2r.tk",
    "mkcmqs.fun",
    "mkcxbx2f1te6nta.xyz",
    "mkdigehg.shop",
    "mkdshhdtry546bn.ga",
    "mkfmqp.fun",
    "mkfmrq.fun",
    "mkgmss.fun",
    "mkh-agri.com",
    "mkiauz.site",
    "mkinmotion.com",
    "mkjmhy.fun",
    "mkjmls.fun",
    "mkjmwx.fun",
    "mkk-finsoyuznik.ru",
    "mkk-inkubator.ru",
    "mkk83.top",
    "mkk84.top",
    "mkljyurffdg987.cf",
    "mkljyurffdg987.ga",
    "mkljyurffdg987.gq",
    "mkljyurffdg987.ml",
    "mkljyurffdg987.tk",
    "mklmbx.fun",
    "mklmqf.fun",
    "mklyy.live",
    "mkm24.de",
    "mknmwc.fun",
    "mko.kr",
    "mkosa.com",
    "mkpfilm.com",
    "mkpmbj.fun",
    "mkpmqx.fun",
    "mkpodoloji.online",
    "mkrecondition.ru",
    "mksmhz.fun",
    "mkstodboende.nu",
    "mktorrent.com",
    "mkwmjj.fun",
    "mkwojj.us",
    "mkymnm.fun",
    "mkypbb.us",
    "mkzmkt.fun",
    "mkzmtm.fun",
    "mkzmzg.fun",
    "ml1.net",
    "ml244.site",
    "ml8.ca",
    "mlanime.com",
    "mlb.bounce.ed10.net",
    "mlessa.com",
    "mlhelp247.com",
    "mlidov.ru",
    "mlinck.com",
    "mlkchamber.org",
    "mlldh.site",
    "mllimousine.com",
    "mllpru.us",
    "mlmonlineformula.com",
    "mlmtechnology.com",
    "mlnd8834.cf",
    "mlnd8834.ga",
    "mlnd8834.gq",
    "mlnd8834.ml",
    "mlnd8834.tk",
    "mlny.icu",
    "mlo.kr",
    "mlo60n.online",
    "mlogicali.com",
    "mlojjb.us",
    "mlpxlb.us",
    "mlq6wylqe3.cf",
    "mlq6wylqe3.ga",
    "mlq6wylqe3.gq",
    "mlq6wylqe3.ml",
    "mlq6wylqe3.tk",
    "mlqsz.xyz",
    "mltkfqoee.shop",
    "mlx.ooo",
    "mm.my",
    "mm.st",
    "mm18269.com",
    "mm378.com",
    "mm5.se",
    "mm88bar.com",
    "mm88link.org",
    "mm88sport.net",
    "mm88steam.com",
    "mm904.xyz",
    "mm9827.com",
    "mmaignite.com",
    "mmail.com",
    "mmail.igg.biz",
    "mmailinater.com",
    "mmaprognoz.ru",
    "mmastavka.ru",
    "mmatica.ru",
    "mmbola.online",
    "mmccproductions.com",
    "mmclobau.top",
    "mmcounceling.com",
    "mmdshe.com",
    "mmdz7li.xyz",
    "mmdzkxn.xyz",
    "mmdzllu.xyz",
    "mmdzlmx.xyz",
    "mmdzohp.com",
    "mmdzous.com",
    "mmdzre6.xyz",
    "mmdzsfs.xyz",
    "mmdzsxl.xyz",
    "mmdzuii.xyz",
    "mmdzv7m.com",
    "mmeefid.site",
    "mmeefyh.site",
    "mmigroup.xyz",
    "mmikal-auvn.ru",
    "mminsurancemarketplace.com",
    "mmint99.com",
    "mmk323.com",
    "mmkozmetik.com",
    "mmlaaxhsczxizscj.cf",
    "mmlaaxhsczxizscj.ga",
    "mmlaaxhsczxizscj.gq",
    "mmlaaxhsczxizscj.tk",
    "mmlaipoowo.xyz",
    "mmm-coinex.info",
    "mmmcoin-ex.com",
    "mmmmail.com",
    "mmmoe.com",
    "mmo365.co.uk",
    "mmohdjsgdhgjs.xyz",
    "mmoonz.faith",
    "mmoshop.live",
    "mmoyka5.ru",
    "mmpan.com",
    "mmq8r0.site",
    "mmshe.com",
    "mmsp12.xyz",
    "mmsp14.xyz",
    "mmsp15.xyz",
    "mmsp16.xyz",
    "mmsp17.xyz",
    "mmsp18.xyz",
    "mmsp19.xyz",
    "mmsp21.xyz",
    "mmsp22.xyz",
    "mmsp23.xyz",
    "mmsp24.xyz",
    "mmsp25.xyz",
    "mmsp26.xyz",
    "mmsp27.xyz",
    "mmsp28.xyz",
    "mmsp29.xyz",
    "mmsp30.xyz",
    "mmsp31.xyz",
    "mmsp33.xyz",
    "mmsp34.xyz",
    "mmsp35.xyz",
    "mmsp36.xyz",
    "mmsp37.xyz",
    "mmsp38.xyz",
    "mmsp40.xyz",
    "mmsp41.xyz",
    "mmsp42.xyz",
    "mmsp43.xyz",
    "mmsp44.xyz",
    "mmsp45.xyz",
    "mmsp46.xyz",
    "mmsp47.xyz",
    "mmspa.cf",
    "mmtscotw.shop",
    "mmtt1.com",
    "mmtt16.com",
    "mmtt56.com",
    "mmtt67.com",
    "mmtt69.com",
    "mmtt7.com",
    "mmtt9.com",
    "mmublera.site",
    "mmvcplc.com",
    "mn.curppa.com",
    "mn.j0s.eu",
    "mn.riaki.com",
    "mn51.ru",
    "mn8dmmens.xyz",
    "mnage-ctrl-aplex.com",
    "mnbj.xyz",
    "mncrafting.com",
    "mnemonicedu.com",
    "mnen8.com",
    "mnexq7nf.rocks",
    "mng333.live",
    "mngmining.com",
    "mnhalfpricedlistings.com",
    "mnhomeonthelake.com",
    "mnhomesonthelake.com",
    "mnibank.ru",
    "mniloasderf.tk",
    "mnjp.us",
    "mnjvma.org",
    "mnmarriott.com",
    "mnocash.com",
    "mnocoins.org",
    "mnode.me",
    "mnogikanpolit.ga",
    "mnogobux.ru",
    "mnotoken.com",
    "mnotoken.org",
    "mnriver.com",
    "mns.ru",
    "mnst.de",
    "mnstoryworks.com",
    "mntechcare.com",
    "mnv4u8zitnxlhpo.xyz",
    "mnzs.xyz",
    "mo3gov.net",
    "mo4p.com",
    "mo5xnj.us",
    "moabjeeprental.com",
    "moagloves.com",
    "moakt.cc",
    "moakt.co",
    "moakt.com",
    "moakt.ws",
    "moathrababah.com",
    "moaz5orm.ml",
    "mobamouse.com",
    "mobanche.xyz",
    "mobaratopcinq.life",
    "mobasher24.net",
    "mobegifts.com",
    "mobelej3nm4.ga",
    "mobi-az.site",
    "mobi.web.id",
    "mobico.ru",
    "mobiepic.site",
    "mobilbagus.club",
    "mobilbatam.com",
    "mobile-gto.ru",
    "mobileapplicationbuilder.com",
    "mobileapps.monster",
    "mobilebankapp.org",
    "mobileemail.vodafone.net",
    "mobilehypnosisandcoaching.com",
    "mobilejudi.net",
    "mobilelacky.info",
    "mobilemeworld.com",
    "mobileninja.co.uk",
    "mobilerealty.net",
    "mobilespielbewertung2019.online",
    "mobilesportsapp.site",
    "mobilevpn.top",
    "mobilevpn.xyz",
    "mobilewashenvironmental.com",
    "mobilhondasidoarjo.com",
    "mobiliddaakayit.com",
    "mobility.camp",
    "mobility.energy",
    "mobility.fitness",
    "mobilmatrak.xyz",
    "mobinovations.xyz",
    "mobleies.shop",
    "mobler.org",
    "moblibrary.com",
    "moboinfo.xyz",
    "mobtuts.net",
    "moburl.com",
    "mobx.pub",
    "mobxxx.site",
    "mocb.us",
    "mocbddelivery.com",
    "mochamail.com",
    "mochibooks.com",
    "mochonai.com",
    "mochris.com",
    "mockbee-energy.com",
    "mockmyid.co",
    "mockmyid.com",
    "mockup.express",
    "mockups.express",
    "mocw.ru",
    "modabet365.com",
    "modabetdestek.org",
    "modabuolsun.xyz",
    "modalova.biz",
    "modalova.online",
    "modalova.se",
    "modalova.shop",
    "modalova.xyz",
    "modanaobuv.ru",
    "modastroy.site",
    "modasupport.org",
    "moddema.ga",
    "modejudnct4432x.cf",
    "modelegitimobs.xyz",
    "modelfe.space",
    "modelfindme.ru",
    "modelingblog.com",
    "modelix.ru",
    "modellase.site",
    "modelly.site",
    "models-of-germany.com",
    "modemanioutlet.se",
    "modemnet.net",
    "modeng-yule.biz",
    "moderassmb.space",
    "modern-prints.com",
    "modernangleiron.us",
    "modernasalonstudios.com",
    "moderndaysurvivalgearshop.com",
    "moderne-raumgestaltung.de",
    "modernenglish.com",
    "modernenglish.ru",
    "moderneyes.life",
    "modernindependent.com",
    "modetoxcenter.com",
    "modety.online",
    "modhack.net",
    "modicadacademy.com",
    "modish.net",
    "modjunkies.com",
    "modomail.com",
    "modul-rf.ru",
    "modularla.com",
    "modulecraft.org",
    "modum-trans.xyz",
    "moe.app",
    "moe.codes",
    "moe365.com",
    "moeapi.com",
    "moeapp.com",
    "moebits.com",
    "moeblogs.com",
    "moebot.com",
    "moebt.com",
    "moecoin.com",
    "moeday.com",
    "moedh.com",
    "moeimage.com",
    "moeju.com",
    "moekino.club",
    "moekoe.com",
    "moemark.com",
    "moemh.com",
    "moepay.com",
    "moeri.org",
    "moerss.com",
    "moesao.com",
    "moesian.com",
    "moesite.com",
    "moesns.com",
    "moetube.com",
    "moeup.com",
    "moewave.com",
    "moewiki.com",
    "moewp.com",
    "moewww.com",
    "mofiduljamal.com",
    "mofkac.tk",
    "mofox.store",
    "mofsdemo.ru",
    "mofu.be",
    "mogcosing.cf",
    "mogcosing.ga",
    "mogcosing.gq",
    "mogcosing.ml",
    "moge.site",
    "mogensenonline.com",
    "mogiwap.icu",
    "mogotech.com",
    "mogpipin.ga",
    "mogs.live",
    "moguapp.org",
    "mogulemperor.com",
    "mogur.us",
    "moh-nitor-api.xyz",
    "mohalfpricelisting.com",
    "mohamadkarimian.com",
    "mohammed.com",
    "mohammedleach.buzz",
    "mohammedstokes.buzz",
    "mohanatakeaway.com",
    "moharramgroup.com",
    "mohisi.ml",
    "mohmal.com",
    "mohmal.im",
    "mohmal.in",
    "mohmal.tech",
    "mohsenfb.com",
    "moi-diabet.ru",
    "moidolgi.org",
    "moienge.space",
    "moigadjet.ru",
    "moigauhyd.cf",
    "moigauhyd.ga",
    "moigauhyd.tk",
    "moimalap.cf",
    "moimoi.re",
    "moiprint.ru",
    "moisait-spb.ru",
    "moishop-online.ru",
    "moisoveti.ru",
    "moissonlongueuil.org",
    "moitari.ga",
    "moitari.ml",
    "moja-ipoteka.ru",
    "mojaemigracja.online",
    "mojarranna.net",
    "mojemoj.tk",
    "mojilodayro.ga",
    "mojito.org",
    "mojitos.online",
    "mojok34.xyz",
    "mojok88.net",
    "mojoski.net",
    "mokcasinomorning.ru",
    "mokimasopl.cf",
    "moko.cloud",
    "mokxmp.us",
    "mol-vidi.net",
    "mol-vidi.org",
    "molallaorsa.info",
    "molasedoitr.ga",
    "molded660xq.online",
    "moldered494dn.online",
    "moldova.cc",
    "moldova.com",
    "moldova.uno",
    "moldovacc.com",
    "moldujgkcqb.email",
    "molkq.site",
    "moll.express",
    "mollieconway.buzz",
    "mollmax.ru",
    "molluskit.gq",
    "mollypeters.buzz",
    "mollyposts.com",
    "mollyteeny1.com",
    "mollywheeler.buzz",
    "molms.com",
    "molojo.com",
    "molsbet.icu",
    "molvidi.org",
    "mom-mail.com",
    "momenrt.ga",
    "momentics.ru",
    "momento-conmovedor.info",
    "momentofjoy.net",
    "mommylongue.com",
    "mommystoopphial.site",
    "momo-cx.com",
    "momo365.net",
    "momobet-8.com",
    "momobet-888.com",
    "momobet-vip.com",
    "momodewa.com",
    "momomarket.ru",
    "momopokeridn.net",
    "momostreaming.com",
    "momotrack.ru",
    "mompreneur.today",
    "momrell.ru",
    "momsbackpack.ru",
    "momslife.com",
    "momsportjop.ru",
    "momtest.club",
    "momtips.info",
    "momtour.ru",
    "mon-compte-nickel.cc",
    "mon-espace.club",
    "mona.farm",
    "monachat.tk",
    "monadi.ml",
    "monadium.net",
    "monadress.online",
    "monagame.club",
    "monalisa-galway.com",
    "monalisadublin12.com",
    "monalisatouchmarketing.com",
    "monarch.wtf",
    "monarchdaddy.us",
    "monarkdesigns.com",
    "monasticts.xyz",
    "moncel.se",
    "moncomodz.com",
    "moncompteclient.cc",
    "moncomptes.club",
    "moncourrier.fr.nf",
    "moncourrier.ml",
    "moncstonar.cf",
    "moncstonar.gq",
    "moncstonar.ml",
    "moncstonar.tk",
    "monctl.com",
    "mondayarr.host",
    "mondayfirst.site",
    "mondaylaura.com",
    "mondaymariska.com",
    "mondaymovo.com",
    "mondconglesm.gq",
    "mondconglesm.ml",
    "mondkap-drukkerij.online",
    "mondrian.wiki",
    "monedix.com",
    "monedocard.com",
    "monedonow.com",
    "monemail.com",
    "monemail.fr.nf",
    "moneroexpert.com",
    "monespace.cc",
    "monespace.info",
    "monetaros.com",
    "monetizes686vr.online",
    "monettka.ru",
    "money.net",
    "moneyalphaspot.com",
    "moneyboxtvc.com",
    "moneyconnexion.net",
    "moneygive.xyz",
    "moneyhere.ru",
    "moneyinpolitics.org",
    "moneylac.ru",
    "moneymailersms.com",
    "moneypipe.net",
    "moneyprofit.online",
    "moneyqube.info",
    "moneyslon.ru",
    "moneyway.shop",
    "mongabrothersfilms.com",
    "mongol.net",
    "mongrelize881tf.online",
    "mongrelized473kd.online",
    "mongsteep.xyz",
    "monicagrace.site",
    "moniclick.ru",
    "monihaerd.tk",
    "monikolas.cf",
    "monikure.ga",
    "monipozeo8igox.cf",
    "monipozeo8igox.ga",
    "monipozeo8igox.gq",
    "monipozeo8igox.ml",
    "monipozeo8igox.tk",
    "moniqueaimone.com",
    "moniqueknowsmusic.us",
    "monitoragenzie.click",
    "monitoragenzie.com",
    "monitoramentofera.com",
    "monitorbbb.xyz",
    "monitoruleconomic.com",
    "monkandbard.org",
    "monkeyforex.com",
    "monkeypoker.net",
    "monkeysatmidnight.com",
    "monkeystore.online",
    "monmail.fr.nf",
    "monngongiadinh.info",
    "monnoyra.gq",
    "monobud.com",
    "monobuds.com",
    "monoktr.ru",
    "monomorphic.best",
    "monopoliya2.ru",
    "monot.xyz",
    "monotheism.net",
    "monsetof.ru",
    "monsheribridal.net",
    "monsieurbiz.wtf",
    "monsieurcinema.com",
    "monsieurcoin.com",
    "monsoon-indian.com",
    "monsoontakeaway.com",
    "monstage-dz.com",
    "monster.org",
    "monsterandme.net",
    "monsterblender.ru",
    "monsterbubu.degree",
    "monsterjcy.com",
    "monsterspain.site",
    "montagebridalsalon.com",
    "montanachoicerealestate.com",
    "montclairpodiatry.com",
    "montefino.cf",
    "montepaschi.cf",
    "montepaschi.ga",
    "montepaschi.gq",
    "montepaschi.ml",
    "montepaschi.tk",
    "monterra.tk",
    "montesofia.com",
    "montevideo.com.uy",
    "montevigorpiety.site",
    "montgomeryquote.com",
    "monthesour.cf",
    "monthesour.ga",
    "monthesour.ml",
    "monthesour.tk",
    "monthlyoportynity.com",
    "monthlypill.com",
    "montiardxd.space",
    "montokop.pw",
    "montrealdio.com",
    "montrealists.com",
    "montrealjetboating.com",
    "montrealrafting.com",
    "montrowa.cf",
    "montrowa.ga",
    "montrowa.gq",
    "montrowa.ml",
    "montsettsa.ga",
    "montsettsa.tk",
    "montwayautotransportonline.com",
    "monumentalize178lr.online",
    "monumentalized432wf.online",
    "monumentmail.com",
    "mooandpierre.com",
    "mooblan.ml",
    "moodarttekstil.xyz",
    "moodleclub.org",
    "moodleforworkplace.info",
    "moodleforworkplace.net",
    "moodleforworkplace.org",
    "moodleinspire.info",
    "moodletest-vps.website",
    "moodleworkplace.info",
    "moodmatter.buzz",
    "mooecofficail.club",
    "moogtones.com",
    "moogtrailerparts.shop",
    "mooiamsterdamevents.online",
    "mookkaz.ga",
    "moomia.com",
    "moon-piano.online",
    "moonfaire.com",
    "mooniac.com",
    "moonjumppress.com",
    "moonkased.ga",
    "moonki.shop",
    "moonkupla.ga",
    "moonlightbed.com",
    "moonm.review",
    "moonman.com",
    "moonrakefile.com",
    "moonwake.com",
    "mooo.com",
    "mooo.ml",
    "mooonity.com",
    "moose-mail.com",
    "moosehollowtradingco.com",
    "moot.es",
    "moovengers.com",
    "mooviflix.online",
    "moparayes.site",
    "moparmediagroup.se",
    "mopemi.ga",
    "mopemi.ml",
    "mopeyj.us",
    "mopustores.site",
    "mor19.uu.gl",
    "moragfels.cf",
    "moragfels.ga",
    "moragfels.tk",
    "morahdsl.cf",
    "moralitywars.net",
    "moralizer906bg.online",
    "morallystrapped.com",
    "morana.icu",
    "moravekinternational.info",
    "moraveli.live",
    "morbolatino.com",
    "morcagumd.ga",
    "morcagumd.gq",
    "morcagumd.tk",
    "morcasinohat.ru",
    "morcego.org",
    "more2explore4you.site",
    "more4chat.com",
    "more4you.org",
    "moreawesomethanyou.com",
    "morecoolstuff.net",
    "morefunmart.com",
    "morefunsports.com",
    "moremarijuanamarketplace.com",
    "moreno1999.xyz",
    "moreorcs.com",
    "morerake.com",
    "morestonn.tk",
    "morethanjustavoice.info",
    "morethanvacs.com",
    "morethanweknow.com",
    "morfelpde.cf",
    "morfelpde.ga",
    "morfelpde.gq",
    "morfelpde.ml",
    "morfelpde.tk",
    "morganbrookewright.com",
    "morganfranklinconsulting.com",
    "morganlowis.com",
    "morina.me",
    "mormal.site",
    "mormoncoffee.com",
    "mornayoovm.space",
    "morningtw.com",
    "mornsoft.com",
    "moroz-it.ru",
    "morriesworld.ml",
    "morrisoncreek.net",
    "morrlibsu.cf",
    "morrlibsu.ga",
    "morrlibsu.gq",
    "morrlibsu.ml",
    "morrsferin.cf",
    "morrsferin.gq",
    "morrsferin.tk",
    "morselsdxsv.email",
    "morsin.com",
    "mortaza.com",
    "mortcountgi.gq",
    "mortcountgi.ml",
    "mortcountgi.tk",
    "morteinateb.xyz",
    "mortensen.dk",
    "mortgagebrief.com",
    "mortgagecalculators.online",
    "mortgagefinancialvermont.com",
    "mortgagelends.com",
    "mortgebi.cf",
    "mortgebi.ga",
    "mortgebi.tk",
    "mortjusqui.cf",
    "mortjusqui.ga",
    "mortjusqui.gq",
    "mortjusqui.ml",
    "mortjusqui.tk",
    "mortmesttesre.wikaba.com",
    "mortystore.cf",
    "moruzza.com",
    "mos-kwa.ru",
    "mosaferbaar.com",
    "mosaferkade.org",
    "mosaicfx.com",
    "mosamulet.ru",
    "moscowmail.com",
    "moscowrealestateagents.com",
    "mosertelor.ga",
    "mosk.ru",
    "moskow-lottery.info",
    "moskow-lottery.net",
    "moskow-lottery.org",
    "moslic.ru",
    "mosmebelcentr.ru",
    "mosrafaacademy.com",
    "most-wanted.com",
    "mostafapour.com",
    "mostbet-official.ru",
    "mostbet.casino",
    "mostbet7.ru",
    "mostlysunny.com",
    "mosttrends.info",
    "mosvv.us",
    "mot1zb3cxdul.cf",
    "mot1zb3cxdul.ga",
    "mot1zb3cxdul.gq",
    "mot1zb3cxdul.ml",
    "mot1zb3cxdul.tk",
    "motel5music.com",
    "motelfive.com",
    "mother-russia.ru",
    "motherindiatakeaway.com",
    "motherreviews.futbol",
    "motiexis.ru",
    "motifdou.xyz",
    "motifliv.buzz",
    "motifpet.xyz",
    "motique.de",
    "motivationalasmr.com",
    "motivationasmr.com",
    "motomarkets.site",
    "motorcritics.com",
    "motorcycle-rental.info",
    "motorcycleaccidentlawyertampa.com",
    "motorcyclefan.net",
    "motorisation-plus.com",
    "motorize540ab.online",
    "motormania.com",
    "motorsshop.futbol",
    "motorvationist.com",
    "motrkadust.ru",
    "mottel.fr",
    "mottobuttonpizza.site",
    "motybas.xyz",
    "mouadslider.site",
    "moud.us",
    "moueur.website",
    "moukhjconmeab.cf",
    "moukhjconmeab.tk",
    "moulinsdebordeaux.com",
    "moundcityhistory.org",
    "mountaingoatcycles.com",
    "mountainhighminiatures.com",
    "mountainregionallibrary.net",
    "mountainviewgarden.com",
    "mountainviewgarden.org",
    "mountdasw.ga",
    "mountjulietapartments.com",
    "mountpleasantrealestateagents.com",
    "mourntailedplaza.site",
    "mourouzis.com",
    "mousearis.icu",
    "mouseexi.us",
    "mousefe.icu",
    "mousefl.icu",
    "mouselesstails.com",
    "mousergup.space",
    "mouthmi.icu",
    "mouthube0t.com",
    "movanfj.ml",
    "movavi.tech",
    "move2.ru",
    "move2inbox.net",
    "move2loveland.info",
    "moveer.ru",
    "moveleg.com",
    "movemail.com",
    "movements.best",
    "moversferndalemi.com",
    "moveworks.co",
    "movie-streams-online.best",
    "movie.finance",
    "movie4k-free.site",
    "movie4k.app",
    "movie4khd.net",
    "moviedaynight.com",
    "movieemail.net",
    "moviefreedo.com",
    "movieluver.com",
    "movienox.com",
    "movies-box.ru",
    "movies123-star-movie.xyz",
    "movies123.news",
    "movies123free.best",
    "moviesjoy.online",
    "moviesjoy.site",
    "moviesjoy.space",
    "moviesjoy.website",
    "moviesmarket.place",
    "moviespur.xyz",
    "movietavern.us",
    "movietaverngc.net",
    "movietaverntickets.net",
    "movietheaterapp.com",
    "movietour.ru",
    "moviezt.us",
    "moviflix.tk",
    "movima.info",
    "moving2.com",
    "movingex.com",
    "movingforwardsj.com",
    "movingmatterkc.com",
    "movply.site",
    "movstoreoffc.com",
    "movx.us",
    "mowgli.jungleheart.com",
    "mowtpk.us",
    "mox.pp.ua",
    "moxcasonaixe.xyz",
    "moxremodel.com",
    "moy-elektrik.ru",
    "moydoctor.online",
    "moyjivot.ru",
    "moypmoub.shop",
    "moysat.ru",
    "moyuzi.com",
    "moyy.net",
    "moz-clinic.info",
    "moza.pl",
    "mozartfwkg.website",
    "mozartmail.com",
    "mozej.com",
    "mozhno.net",
    "mozhua.xyz",
    "moziahssecretplan.com",
    "mozillafirefox.cf",
    "mozillafirefox.ga",
    "mozillafirefox.gq",
    "mozillafirefox.ml",
    "mozillafirefox.tk",
    "mozzasiatopizzavalencia.com",
    "mp-j.cf",
    "mp-j.ga",
    "mp-j.gq",
    "mp-j.igg.biz",
    "mp-j.ml",
    "mp-j.tk",
    "mp.igg.biz",
    "mp3-cube.com",
    "mp3-line.ru",
    "mp3-pleeri.ru",
    "mp3-tut.org",
    "mp3.3dxtras.com",
    "mp3afrique.com",
    "mp3cc-top.biz",
    "mp3charm.com",
    "mp3diamond.com",
    "mp3freed.net",
    "mp3genteflow.biz",
    "mp3geulis.net",
    "mp3haze.com",
    "mp3indirbey.info",
    "mp3lemoon.ru",
    "mp3nt.net",
    "mp3sa.my.to",
    "mp3toys.online",
    "mp3tubidy.one",
    "mp3zvukoff.ru",
    "mp4.it",
    "mpaaf.cf",
    "mpaaf.ga",
    "mpaaf.gq",
    "mpaaf.ml",
    "mpaaf.tk",
    "mpayshop.info",
    "mpdf.site",
    "mpegsuite.com",
    "mpfqxeoo.fun",
    "mpfsy.icu",
    "mpg0e.us",
    "mpgmarine.com",
    "mpictureb.com",
    "mpihomecare.net",
    "mpkjr.org",
    "mplusmail.com",
    "mpm-motors.cf",
    "mpmmaketmarka.space",
    "mpmps160.tk",
    "mpmshleyatip.site",
    "mpmzagibshema.space",
    "mpmzagibtyazh.space",
    "mpo303.xyz",
    "mpo365idn.net",
    "mpo39.com",
    "mpo818.com",
    "mpocketbank.com",
    "mpop.app",
    "mpoplaytech.net",
    "mpos247.com",
    "mps3andvideoconverter.com",
    "mpsupport247.com",
    "mptalegacymedia.com",
    "mptgqustuputqp.ru",
    "mptncvtx0zd.cf",
    "mptncvtx0zd.ga",
    "mptncvtx0zd.gq",
    "mptncvtx0zd.ml",
    "mptncvtx0zd.tk",
    "mptrance.com",
    "mpvnvwvflt.cf",
    "mpvnvwvflt.ga",
    "mpvnvwvflt.gq",
    "mpvnvwvflt.ml",
    "mpvnvwvflt.tk",
    "mpwindows.icu",
    "mpxfcm.us",
    "mpystsgituckx4g.cf",
    "mpystsgituckx4g.gq",
    "mpzjno.us",
    "mpzoom.com",
    "mq4rzy.site",
    "mqcs.us",
    "mqfep.online",
    "mqg77378.cf",
    "mqg77378.ga",
    "mqg77378.ml",
    "mqg77378.tk",
    "mqhtukftvzcvhl2ri.cf",
    "mqhtukftvzcvhl2ri.ga",
    "mqhtukftvzcvhl2ri.gq",
    "mqhtukftvzcvhl2ri.ml",
    "mqhtukftvzcvhl2ri.tk",
    "mqipm.com",
    "mqkivwkhyfz9v4.cf",
    "mqkivwkhyfz9v4.ga",
    "mqkivwkhyfz9v4.gq",
    "mqkivwkhyfz9v4.ml",
    "mqkivwkhyfz9v4.tk",
    "mqmize.shop",
    "mqnpuu.site",
    "mqqzkj.us",
    "mqtpe8.us",
    "mquote.tk",
    "mr-meshkat.com",
    "mr-noodle-takeaway.com",
    "mr-potatohead.com",
    "mr138bet.org",
    "mr1web.ru",
    "mr24.co",
    "mr907tazaxe436h.cf",
    "mr907tazaxe436h.ga",
    "mr907tazaxe436h.gq",
    "mr907tazaxe436h.tk",
    "mragon.xyz",
    "mrain.ru",
    "mrakosin.site",
    "mrbeads.ru",
    "mrblacklist.gq",
    "mrchinh.com",
    "mrclipper.com",
    "mrcraftyconsultant.com",
    "mrctacoma.com",
    "mrdjg.live",
    "mrdv7w.info",
    "mreazi.africa",
    "mrentauto.ru",
    "mrf9t.us",
    "mrflibble.icu",
    "mrichacrown39dust.tk",
    "mrisemail.com",
    "mrj08.space",
    "mrlagu.best",
    "mrmail.info",
    "mrmerritt.com",
    "mrmrise.com",
    "mroe-kino.ru",
    "mroneeye.com",
    "mrossi.cf",
    "mrossi.ga",
    "mrossi.gq",
    "mrossi.ml",
    "mrplay.store",
    "mrpost.com",
    "mrprojects.info",
    "mrqqwo.us",
    "mrramtruck.com",
    "mrresourcepacks.tk",
    "mrrobot.life",
    "mrs24.de",
    "mrscript.ru",
    "mrsikitjoefxsqo8qi.cf",
    "mrsikitjoefxsqo8qi.ga",
    "mrsikitjoefxsqo8qi.gq",
    "mrsikitjoefxsqo8qi.ml",
    "mrsikitjoefxsqo8qi.tk",
    "mrsnotarios.com",
    "mrsnwk.us",
    "mrsortie.xyz",
    "mrspender.com",
    "mrtsport.com",
    "mrugesh.tk",
    "mrvevoyu.shop",
    "mryup.com",
    "mrzero.tk",
    "ms.email",
    "ms.land",
    "ms.rentals",
    "ms.vcss.eu.org",
    "ms1.email",
    "ms365.ml",
    "ms788.site",
    "ms9.mailslite.com",
    "msa.minsmail.com",
    "msaffshop.store",
    "msb.minsmail.com",
    "msback.com",
    "msbestlotto.com",
    "mscold.com",
    "msd-tech.com",
    "msdc.co",
    "msdosarena.com",
    "mservices.life",
    "msft.cloudns.asia",
    "msg.mailslite.com",
    "msg2phone.com",
    "msgbox.com",
    "msgden.com",
    "msgden.net",
    "msghideaway.net",
    "msgos.com",
    "msgsafe.io",
    "msgsafe.ninja",
    "msgwire.com",
    "mshalfpricedlistings.com",
    "mshri.com",
    "msidhuy.net",
    "msinternationalfederation.com",
    "msiwkzihkqifdsp3mzz.cf",
    "msiwkzihkqifdsp3mzz.ga",
    "msiwkzihkqifdsp3mzz.gq",
    "msiwkzihkqifdsp3mzz.ml",
    "msiwkzihkqifdsp3mzz.tk",
    "msjyd.com",
    "msk-farm.ru",
    "msk-pharm.ru",
    "msk-prokat.ru",
    "msk.ru",
    "mskey.co",
    "mskglobaltraining.com",
    "msladyloki.live",
    "msmwxc.site",
    "msn.cn",
    "msn.co.uk",
    "msn.com",
    "msn.com.au",
    "msn.nl",
    "msndubai.net",
    "msnmrhhzr.shop",
    "msnumsno.shop",
    "msnw.ru",
    "msoexbr.ru",
    "msoftkeyupdateerror4004.xyz",
    "msoi.us",
    "msovh.com",
    "mspeciosa.com",
    "mspforum.com",
    "msqd7.us",
    "msqtbill247.com",
    "msquarehotelbudapest.com",
    "msrc.ml",
    "msrisg.site",
    "msromaballinagh.com",
    "mst.edu",
    "mstar69.club",
    "mstenta.com",
    "mstream.host",
    "mstyfdrydz57h6.cf",
    "mstyfv.info",
    "msugcf.org",
    "msvh.us",
    "msvvscs6lkkrlftt.cf",
    "msvvscs6lkkrlftt.ga",
    "msvvscs6lkkrlftt.gq",
    "mswork.ru",
    "mswx.email",
    "msx.ru",
    "msxd.com",
    "msyl6.com",
    "mt-tele.club",
    "mt-tele.today",
    "mt2009.com",
    "mt2014.com",
    "mt2015.com",
    "mt2016.com",
    "mt2017.com",
    "mt210.com",
    "mt25.org",
    "mt4o.us",
    "mt66ippw8f3tc.gq",
    "mtaby.com",
    "mtajer.online",
    "mtasa.ga",
    "mtawnecno.cf",
    "mtbitreatmentclinic.com",
    "mtbtrailreview.com",
    "mte5.net",
    "mtgbvfxn.com",
    "mthalfpricelistings.com",
    "mtmdev.com",
    "mtqjsd.com",
    "mtrainierphoto.com",
    "mtrucqthtco.cf",
    "mtrucqthtco.ga",
    "mtrucqthtco.gq",
    "mtrucqthtco.ml",
    "mtrucqthtco.tk",
    "mtservers.online",
    "mtsg.me",
    "mtsmy2.com",
    "mtsmy4.com",
    "mttdfen.xyz",
    "mttestdriver.com",
    "mtzx4.xyz",
    "mu3dtzsmcvw.cf",
    "mu3dtzsmcvw.ga",
    "mu3dtzsmcvw.gq",
    "mu3dtzsmcvw.ml",
    "mu3dtzsmcvw.tk",
    "mu956.com",
    "mua0gn.us",
    "muaban12fun.com",
    "muaban12fun.net",
    "muabanchothue.website",
    "muabanhang.website",
    "muabanhangviet.website",
    "muabansanpham.website",
    "muagiasi.website",
    "muamuawrtcxv7.cf",
    "muamuawrtcxv7.ga",
    "muamuawrtcxv7.gq",
    "muamuawrtcxv7.ml",
    "muamuawrtcxv7.tk",
    "muasamtructuyen.info",
    "muathegame.com",
    "mubby.ml",
    "mucbvhxt.shop",
    "much-hyped.club",
    "muchina.website",
    "muchmal.com",
    "muchomail.com",
    "muciboutiques.site",
    "mucillo.com",
    "mucincanon.com",
    "mucizejel.xyz",
    "mucwegsns.shop",
    "mudanya118.xyz",
    "mudbox.ml",
    "mudhighmar.ga",
    "mudhighmar.gq",
    "mudhighmar.tk",
    "mudjigbsd.shop",
    "muehlacker.tk",
    "muell.email",
    "muell.icu",
    "muell.monster",
    "muell.xyz",
    "muellemail.com",
    "muellmail.com",
    "muellpost.de",
    "muezafgse3lhny3.xyz",
    "muffkisses.com",
    "mufmg2.us",
    "muftappu.online",
    "mufux.com",
    "mugamesandsoft.info",
    "mugestores.site",
    "mugglenet.org",
    "muggycloc.us",
    "muggyfunny.com",
    "mughbecur.cf",
    "mughbecur.tk",
    "mughftg5rtgfx.gq",
    "mugladatemizlik.com",
    "muglaelitmermer.com",
    "muglakaptanoperatorluk.com",
    "muglakonut.xyz",
    "muglamarket.online",
    "muglavo.cf",
    "muglavo.ga",
    "muglavo.ml",
    "muglavo.tk",
    "mugshots.fun",
    "mugsnbuds.com",
    "mugua1.com",
    "muhamadnurdin.us",
    "muhammad-ali-trophy.ru",
    "muhammadafandi.com",
    "muhasebe.app",
    "muhdioso8abts2yy.cf",
    "muhdioso8abts2yy.ga",
    "muhdioso8abts2yy.gq",
    "muhdioso8abts2yy.ml",
    "muhdioso8abts2yy.tk",
    "muimail.com",
    "muirlea.com",
    "muj10.space",
    "mujaz.net",
    "mujiuazhai.com",
    "mujizatqq.com",
    "mujizatqq.info",
    "muju.site",
    "mukund.info",
    "muleno.info",
    "mulfide.ga",
    "mulfide.tk",
    "mulitcloud.ninja",
    "mulix.info",
    "mulix.online",
    "mulix.tech",
    "m\xfcll.email",
    "m\xfcllemail.com",
    "mullervzcn.space",
    "mulligan.leportage.club",
    "m\xfcllmail.com",
    "mulrogar.cf",
    "mulrogar.ga",
    "mulrogar.gq",
    "mulrogar.ml",
    "mulrogar.tk",
    "mulseehal.tk",
    "multaneohe.icu",
    "multech-pbc.com",
    "multerchanez.com",
    "multfilmmoney.ru",
    "multibus.info",
    "multicard.club",
    "multicultural.center",
    "multidresses.com",
    "multidrone.ru",
    "multielektonik.com",
    "multifocal.haus",
    "multihosted.online",
    "multihosted.site",
    "multilingual-health-education.net",
    "multimediag.online",
    "multinetwork.online",
    "multiplanet.de",
    "multiplechoices",
    "multipleorgasmman.com",
    "multiplexer.us",
    "multisourceproductsandservicesportals.com",
    "multispecialtyaestheticacademy.org",
    "multitip.email",
    "multitul-lath.ru",
    "multy-2019.ru",
    "mumajun.com",
    "mumba.website",
    "mummies.co.uk",
    "mummybags.ru",
    "mumoda.info",
    "mumspousallot.website",
    "mumulacy.com",
    "munchiejanefoods.com",
    "munchnburritobarkildare.com",
    "munchtalk.net",
    "muncloud.online",
    "mundobatala.com",
    "mundodalele.com",
    "mundodeamor.org",
    "mundodigital.me",
    "mundoflix.net",
    "mundohispanico.mobi",
    "mundohobby.net",
    "mundomail.net",
    "mundopregunta.com",
    "mundoregistral.com",
    "mundosmart.life",
    "mundri.tk",
    "munich.com",
    "munichmail.online",
    "munired.org",
    "munis.site",
    "munoubengoshi.gq",
    "muohio.edu",
    "muonline.monster",
    "muora.com",
    "mupload.nl",
    "mupre.xyz",
    "muq.orangotango.tk",
    "muqaise.com",
    "muqoel.shop",
    "muqwftsjuonmc2s.cf",
    "muqwftsjuonmc2s.ga",
    "muqwftsjuonmc2s.gq",
    "muqwftsjuonmc2s.ml",
    "muqwftsjuonmc2s.tk",
    "muran.best",
    "muratpasagenclik.xyz",
    "murattomruk.com",
    "murcasinotoe.ru",
    "murghantakeaway.com",
    "murlioter.cf",
    "murlioter.ga",
    "murlioter.gq",
    "murlioter.ml",
    "murlioter.tk",
    "murphyfg.com",
    "mus.email",
    "musashiazeem.com",
    "musashisakai.life",
    "musashisakai.site",
    "musclecarcorvettenationals.com",
    "musclemailbox.com",
    "musclesbet21.com",
    "musclesbet22.com",
    "musealike.com",
    "musealike.org",
    "museodelalibertad.info",
    "museumblog.com",
    "museumplanet.com",
    "musey-uglich.ru",
    "mushroomadventure.net",
    "mushroomadventures.info",
    "mushroomadventures.us",
    "mushtaqclothstore.com",
    "music.com",
    "music.com19",
    "music.maigate.ru",
    "music2or.com",
    "music4me.xyz",
    "musica-clasica.com",
    "musical-images.com",
    "musicalmax.com",
    "musicalnr.com",
    "musicandmotivationmj.com",
    "musicandsunshine.com",
    "musicaz.net",
    "musicbaran54.com",
    "musiccityusa.com",
    "musicety.com",
    "musicfictionpoint.site",
    "musicforallpro.info",
    "musicfun.shop",
    "musicha93.com",
    "musichq.online",
    "musichq.site",
    "musichq.xyz",
    "musician.com",
    "musician.org",
    "musiciantelevision.com",
    "musick.store",
    "musicmakes.us",
    "musicmattersmobiledj.com",
    "musicosapp.com",
    "musicscene.org",
    "musictracker.ru",
    "musicu.ru",
    "musicvideo.africa",
    "musicyou.tube",
    "musiiday.com",
    "musikayok.ru",
    "musikprojektet.se",
    "musikqqpoker.com",
    "musimliga.net",
    "musiqfile.xyz",
    "musiqstream.com",
    "muskelshirt.de",
    "muskify.com",
    "muskokacomputerservices.com",
    "muslim.com",
    "muslim3000.com",
    "muslimahcollection.online",
    "muslimemail.com",
    "muslimjewishadvisorycouncil.org",
    "muslimsonline.com",
    "musling.dk",
    "muslumbabaninyeri.online",
    "muslumbabaninyeri.xyz",
    "musony.site",
    "mustache888rp.online",
    "mustafayvaz.com",
    "mustakilart.com",
    "mustang-ford.club",
    "mustbe.ignorelist.com",
    "mustbedestroyed.org",
    "mustbeit.com",
    "mustgread.gq",
    "musthave.properties",
    "musthavesharpener.ooo",
    "mustopmarket.ru",
    "musttufa.site",
    "mutant.me",
    "mutantweb.com",
    "mutantz.xyz",
    "mutationstormjournal.website",
    "muthinc.net",
    "mutik.ru",
    "mutirokas.gq",
    "muttonvindaloobeast.xyz",
    "muttvomit.com",
    "muttwalker.net",
    "mutualbags.com",
    "mutualmed.net",
    "mutualmedinsuranceservices.com",
    "mutualmedsd.com",
    "muutrk.com",
    "muuyharold.com",
    "muvilo.net",
    "muwawa.ru",
    "muwgnresz.shop",
    "muwiki.net",
    "muxcheng.xyz",
    "muyoc.com",
    "muyrte4dfjk.cf",
    "muyrte4dfjk.ga",
    "muyrte4dfjk.gq",
    "muyrte4dfjk.ml",
    "muyrte4dfjk.tk",
    "muzamarket.com",
    "muzhskoye.ru",
    "muziekreleasen.com",
    "muzik-fermer.ru",
    "muzikaper.ru",
    "muzikcim.xyz",
    "muzitp.com",
    "muzlishko.com",
    "muzmes.ru",
    "muzolabs.net",
    "muzoo.online",
    "muzotop.online",
    "muzzamarket.com",
    "muzzmo.online",
    "mv1951.cf",
    "mv1951.ga",
    "mv1951.gq",
    "mv1951.ml",
    "mv1951.tk",
    "mv6uylrxk46yv1h.xyz",
    "mvat.de",
    "mvb2x.us",
    "mvd-trading.com",
    "mvdlnl.shop",
    "mvdmail.com",
    "mvhjmc.com",
    "mvkuznecov.ru",
    "mvlaw.us",
    "mvmbetting.com",
    "mvom.us",
    "mvoudzz34rn.cf",
    "mvoudzz34rn.ga",
    "mvoudzz34rn.gq",
    "mvoudzz34rn.ml",
    "mvoudzz34rn.tk",
    "mvrht.co",
    "mvrht.com",
    "mvrht.net",
    "mvsbesbuy.com",
    "mvssv.com",
    "mvtoe.xyz",
    "mvtqea.us",
    "mw763w3f640hasc.xyz",
    "mwabviwildlifereserve.com",
    "mwarner.org",
    "mwbos.com",
    "mwddbdqy.shop",
    "mwdsgtsth1q24nnzaa3.cf",
    "mwdsgtsth1q24nnzaa3.ga",
    "mwdsgtsth1q24nnzaa3.gq",
    "mwdsgtsth1q24nnzaa3.ml",
    "mwdsgtsth1q24nnzaa3.tk",
    "mweb.co.za",
    "mwforum.org",
    "mwfptb.gq",
    "mwgwqe.us",
    "mwh.group",
    "mwoi.us",
    "mwp4wcqnqh7t.cf",
    "mwp4wcqnqh7t.ga",
    "mwp4wcqnqh7t.gq",
    "mwp4wcqnqh7t.ml",
    "mwp4wcqnqh7t.tk",
    "mwwcaq.com",
    "mx.dysaniac.net",
    "mx0.wwwnew.eu",
    "mx1.site",
    "mx18.mailr.eu",
    "mx19.mailr.eu",
    "mx40bu.com",
    "mxapp.info",
    "mxbin.net",
    "mxbing.com",
    "mxcn.tk",
    "mxfuel.com",
    "mxheesfgh38tlk.cf",
    "mxheesfgh38tlk.ga",
    "mxheesfgh38tlk.gq",
    "mxheesfgh38tlk.ml",
    "mxheesfgh38tlk.tk",
    "mxinspect.org",
    "mxit.im",
    "mxivs.com",
    "mxl4ix.us",
    "mxmigration.com",
    "mxnfashion.info",
    "mxoi.us",
    "mxollc.com",
    "mxp.dns-cloud.net",
    "mxp.dnsabr.com",
    "mxrmedia.com",
    "mxrsale.top",
    "mxsxyfcyyclvip1668.com",
    "mxzvbzdrjz5orbw6eg.cf",
    "mxzvbzdrjz5orbw6eg.ga",
    "mxzvbzdrjz5orbw6eg.gq",
    "mxzvbzdrjz5orbw6eg.ml",
    "mxzvbzdrjz5orbw6eg.tk",
    "my-bestnews.ru",
    "my-big-market-online.net",
    "my-birds.club",
    "my-birds.fun",
    "my-birds.space",
    "my-email.gq",
    "my-eslbookclub.com",
    "my-fashion.online",
    "my-films.xyz",
    "my-grapes.ru",
    "my-group223.ru",
    "my-health.site",
    "my-home-beautiful.com",
    "my-kapriz.ru",
    "my-link.cf",
    "my-maculardegenerations-ok.live",
    "my-markey-shop-of-goods.us",
    "my-miracle-bust.com",
    "my-movement.online",
    "my-newsgroups.com",
    "my-pomsies.ru",
    "my-savings-tips.com",
    "my-sell-shini.space",
    "my-server-online.gq",
    "my-teddyy.ru",
    "my-top5.ru",
    "my-turisto.ru",
    "my-webmail.cf",
    "my-webmail.ga",
    "my-webmail.gq",
    "my-webmail.ml",
    "my-webmail.tk",
    "my-world24.de",
    "my.apsu.edu",
    "my.com",
    "my.efxs.ca",
    "my.email.ne.jp",
    "my.fsu.edu",
    "my.liu.edu",
    "my.longaid.net",
    "my.mcphs.edu",
    "my.ndsu.edu",
    "my.safe-mail.gq",
    "my.softbank.jp",
    "my.uri.edu",
    "my.vondata.com.ar",
    "my10minutemail.com",
    "my123.live",
    "my1bet.biz",
    "my1bet.info",
    "my1travel.ru",
    "my1x2.com",
    "my365.tw",
    "my365office.pro",
    "my3mail.cf",
    "my3mail.ga",
    "my3mail.gq",
    "my3mail.ml",
    "my3mail.tk",
    "my48day.xyz",
    "my66plus.com",
    "my6mail.com",
    "myaa316.xyz",
    "myaa318.xyz",
    "myabbruzzo.com",
    "myactv.net",
    "myafricanherbaloils.xyz",
    "myaibos.com",
    "myakapulko.cf",
    "myakapulko.ga",
    "myakapulko.gq",
    "myakapulko.ml",
    "myakapulko.tk",
    "myalahqui.ga",
    "myalahqui.ml",
    "myalahqui.tk",
    "myalias.pw",
    "myallgaiermogensen.com",
    "myallsmiledentals.com",
    "myalphax.tech",
    "myamberpharmacy.net",
    "myandroidforum.ru",
    "myanmar11.com",
    "myanmar222.com",
    "myanmar33.com",
    "myanmar88889.com",
    "myanmarems.info",
    "myannuityadvisors.com",
    "myanny.ru",
    "myanytimedr.com",
    "myapexevent.net",
    "myareasales.com",
    "myasshole.online",
    "myaudio24.ru",
    "myausithelp.net",
    "myautomationmarketing.com",
    "myautomizely.net",
    "myautomizely.org",
    "myazg.ru",
    "myb267.com",
    "mybaby-store.ru",
    "myback1.xyz",
    "myback2.xyz",
    "mybackup.com",
    "mybackup.xyz",
    "mybaggage.ru",
    "mybalancebracelets.com",
    "mybandwallet.com",
    "mybankcards.ru",
    "mybaseballcareer.com",
    "mybelka.ru",
    "mybestcasino2018.ru",
    "mybestmail.com",
    "mybestpoker77.com",
    "mybestrecipes.ru",
    "mybicyclepost.com",
    "mybirthday.com",
    "mybisnis.online",
    "mybitti.de",
    "mybizarreclips.com",
    "mybizloans.xyz",
    "myblogos.ru",
    "myboatsibiza.com",
    "mybook.vegas",
    "mybovip.com",
    "mybox.it",
    "mybpay.shop",
    "mybreathegreenpure.com",
    "mybridesguide.com",
    "mybx.site",
    "mycabin.com",
    "mycampus.com",
    "mycamworld.online",
    "mycard.net.ua",
    "mycarepack.online",
    "mycarfranchise.ru",
    "mycarfranshiza.ru",
    "mycasecompetition.com",
    "mycashbt.club",
    "mycasino.space",
    "mycasinopartner.com",
    "mycasualclothing.com",
    "mycasualclothing.net",
    "mycasualtshirt.com",
    "myccav.tk",
    "myccscollection.com",
    "mycfee.com",
    "mychatscloud.com",
    "mycherry.org",
    "mycity.com",
    "mycleaninbox.net",
    "myclicknflipplan.com",
    "mycloudmail.tech",
    "mycobal.com",
    "mycobotanica.org",
    "mycool.com",
    "mycopperridgefarm.com",
    "mycorneroftheinter.net",
    "mycorsly.com",
    "mycreatures.org",
    "mycreatures.shop",
    "mycrowdcoins.com",
    "mycsbin.site",
    "mycsgo.online",
    "mydata.mobi",
    "mydaughtersarmy.net",
    "mydb.com",
    "myde.ml",
    "mydealgenie.com",
    "mydefipet.live",
    "mydemo.equipment",
    "mydentalpracticemarketing.com",
    "mydesoho.info",
    "mydietinfo.ru",
    "mydigitallogic.com",
    "mydn2-yl.com",
    "mydn2yl.com",
    "mydocpro.info",
    "mydomain.com",
    "mydomainc.cf",
    "mydomainc.ga",
    "mydomainc.gq",
    "mydomainc.ml",
    "mydomainc.tk",
    "mydotcomaddress.com",
    "mydreamspots.net",
    "myeacf.com",
    "myecho.es",
    "myecomclubreview.com",
    "myeheterrwallet.com",
    "myelementzodiac.com",
    "myelousro.gq",
    "myelousro.ml",
    "myelousro.tk",
    "myemail.gic.edu.vn",
    "myemail.my",
    "myemail1.cf",
    "myemail1.ga",
    "myemail1.ml",
    "myemailaddress.co.uk",
    "myemailboxy.com",
    "myemaildotcom.com",
    "myemaill.com",
    "myemployeragreement.com",
    "myeslbookclub.com",
    "myestuftomb.cf",
    "myestuftomb.tk",
    "myeyesurgeons.org",
    "myezymaps.com",
    "myfaceb00k.cf",
    "myfaceb00k.ga",
    "myfaceb00k.gq",
    "myfaceb00k.ml",
    "myfaceb00k.tk",
    "myfairpoint.net",
    "myfake.cf",
    "myfake.ga",
    "myfake.gq",
    "myfake.ml",
    "myfake.tk",
    "myfakemail.cf",
    "myfakemail.ga",
    "myfakemail.gq",
    "myfakemail.tk",
    "myfamily.com",
    "myfap.online",
    "myfastmail.com",
    "myfavelatinas.com",
    "myfavorite.info",
    "myfinanceblog.club",
    "myfirst100recipes.com",
    "myfirstdomainname.cf",
    "myfirstdomainname.ga",
    "myfirstdomainname.gq",
    "myfirstdomainname.ml",
    "myfirstdomainname.tk",
    "myfirstdomains1x.ml",
    "myfirstphp.com",
    "myfitness24.de",
    "myfixafone.com",
    "myfmmmso.shop",
    "myfortune.com",
    "myfreemail.space",
    "myfreemanual.asia",
    "myfullstore.fun",
    "myfunnymail.com",
    "myfunnymoney.ru",
    "mygames24.ru",
    "mygenechain.net",
    "mygeoweb.info",
    "mygermancar.com",
    "myglockner.com",
    "myglocknergroup.com",
    "myglockneronline.com",
    "mygo.com",
    "mygoldenmail.co",
    "mygoldenmail.com",
    "mygoldenmail.online",
    "mygoodapps.ru",
    "mygooyoo.com",
    "mygrammarly.co",
    "mygreenstyle.ru",
    "myguides.site",
    "myguidesx.site",
    "mygwinin.com",
    "myhagiasophia.com",
    "myhairbest.ru",
    "myhashpower.com",
    "myhf.de",
    "myhistoryok.online",
    "myhiteswebsite.website",
    "myholidaymaldives.com",
    "myhomedesigns.info",
    "myhomesbeautiful.com",
    "myhoneymy.site",
    "myhoroscope.com",
    "myhosteldom.ru",
    "myhostingbg.xyz",
    "myhtml5game.com",
    "myidealica.site",
    "myilitka.site",
    "myimmunitydrink.com",
    "myimpressedsite.com",
    "myinbox.icu",
    "myindohome.services",
    "myinternetcoupon.com",
    "myinterserver.ml",
    "myiris.com",
    "myiulagent.com",
    "myjazzmail.com",
    "myjourneymychoices.com",
    "myjourneymychoices.info",
    "myjubaopen.com",
    "myjunkmail.ovh",
    "mykanpurs.info",
    "mykas-cenas.com",
    "mykem.ru",
    "mykickassideas.com",
    "mykidsfuture.com",
    "mykiss.fr",
    "mykonosbet17.com",
    "mykqsp.shop",
    "mylapak.info",
    "mylaserlevelguide.com",
    "mylastdomainname.cf",
    "mylastdomainname.ga",
    "mylastdomainname.gq",
    "mylastdomainname.ml",
    "mylastdomainname.tk",
    "myled68456.cf",
    "myled68456.ga",
    "myled68456.gq",
    "myled68456.ml",
    "myled68456.tk",
    "mylenecholy.com",
    "mylenobl.ru",
    "myletter.online",
    "mylgbt.social",
    "mylgbtdirectory.com",
    "mylilan.site",
    "mylinkedinsolution.com",
    "myliroy.site",
    "mylisot.site",
    "mylittleali.cf",
    "mylittleali.ga",
    "mylittleali.gq",
    "mylittleali.ml",
    "mylittleali.tk",
    "mylittlebigbook.com",
    "mylittleprofessor.com",
    "mylittlepwny.com",
    "myloans.space",
    "myloanusanetwork.com",
    "mylollitoys.ru",
    "mylomagazin.ru",
    "mylove55.com",
    "mylovetrack.ru",
    "myltqa.com",
    "myluxurybeijing.com",
    "mymac.ru",
    "mymacaulay.org",
    "mymacmail.com",
    "mymadhwa.com",
    "mymail-in.net",
    "mymail.com",
    "mymail.nku.edu",
    "mymail.ro",
    "mymail90.com",
    "mymailbest.com",
    "mymailboxpro.org",
    "mymailcr.com",
    "mymailjos.cf",
    "mymailjos.ga",
    "mymailjos.tk",
    "mymaill.sirket.ltd",
    "mymailoasis.com",
    "mymailto.cf",
    "mymailto.ga",
    "mymaily.lol",
    "mymanual.fun",
    "mymanual.online",
    "mymanual.site",
    "mymanual.space",
    "mymanual.website",
    "mymhc.ca",
    "mymicme.com",
    "mymicroleap.com",
    "mymobilehut.icu",
    "mymodernhome.ca",
    "mymogensen.com",
    "mymogensenonline.com",
    "mymovement.online",
    "mymovement.space",
    "mymovietv.site",
    "mymp3dl.com",
    "mymrocrib.com",
    "mymss.com",
    "mymy.cf",
    "myn4s.ddns.net",
    "mynamedot.com",
    "mynatim.ga",
    "mynatim.ml",
    "mynatim.tk",
    "mynaxodki.ru",
    "myneocards.cz",
    "mynes.com",
    "mynet.com",
    "mynetaddress.com",
    "mynetstore.de",
    "mynetwork.cf",
    "mynetwork.com",
    "mynewplayers.com",
    "mynewsqa.xyz",
    "mynewsqd.xyz",
    "mynewsqe.xyz",
    "mynewsqg.xyz",
    "mynewsqi.xyz",
    "mynewsqp.xyz",
    "mynewsqr.xyz",
    "mynewsqs.xyz",
    "mynewsqt.xyz",
    "mynewsqu.xyz",
    "mynewsqw.xyz",
    "mynewsqy.xyz",
    "myngstyh.shop",
    "myninhhatay.ga",
    "mynning-proxy.ga",
    "myntra.live",
    "myofarm.org",
    "myology.site",
    "myomax.com",
    "myonepercentclub.com",
    "myonlinemobilesubapplication.site",
    "myopang.com",
    "myopera.com",
    "myotpp.xyz",
    "myotw.net",
    "myoverlandtandberg.com",
    "myownemail.com",
    "myownfriends.com",
    "mypacks.net",
    "mypad.com",
    "mypartyclip.de",
    "mypatioshield.com",
    "mypdfbook.ru",
    "mypdfmanuales.xyz",
    "mypensionchain.cf",
    "mypeopleent.com",
    "myperfume.website",
    "myperfumeshop.net",
    "mypersonalemail.com",
    "mypets.ws",
    "myphantomemail.com",
    "myphotos.cc",
    "mypieter.com",
    "mypietergroup.com",
    "mypieteronline.com",
    "mypilotsupply.com",
    "mypiratebay.space",
    "myplace.com",
    "myplanmypackage.com",
    "mypmoc.com",
    "mypool.live",
    "mypremiumvault.com",
    "mypressreleasetoday.com",
    "mypricelessheritage.com",
    "myprofilejob.info",
    "mypropmaster.com",
    "myproximity.us",
    "mypsgr579.com",
    "mypurchasingtoday.com",
    "mypvc.org",
    "myqera.info",
    "myr49v.us",
    "myrambler.ru",
    "myrates.ru",
    "myrealbox.com",
    "myreferralconnection.com",
    "myremarq.com",
    "myriadseries.com",
    "myrichglobal.club",
    "myrileyreid.com",
    "myriotrichiaceous.best",
    "myriwell-msk.ru",
    "myriwellsale.ru",
    "myrockywave.com",
    "myroobee.ru",
    "myroutly.xyz",
    "myrtc.org",
    "mysafe.ml",
    "mysafemail.cf",
    "mysafemail.ga",
    "mysafemail.gq",
    "mysafemail.ml",
    "mysafemail.tk",
    "mysamp.de",
    "mysanity.space",
    "mysavedmoney.com",
    "myscretarea.site",
    "mysecurebox.online",
    "myself.com",
    "mysentmail.com",
    "myseocompanyfinder.com",
    "myserver.monster",
    "myshopos.ru",
    "myshoptrennd.ru",
    "mysignaturecleaners.us",
    "mysipa.net",
    "mysistersvids.com",
    "myskaterti.ru",
    "myskin.club",
    "myslipsgo.ga",
    "myslipsgo.gq",
    "myslipsgo.ml",
    "mysmartadmirror.com",
    "mysmartfinance.online",
    "mysms.website",
    "mysneaker.ru",
    "mysoftbase.com",
    "mysoicialbrothers.com",
    "mysooti.com",
    "mysophiaonline.com",
    "myspaceinc.com",
    "myspaceinc.net",
    "myspaceinc.org",
    "myspacepimpedup.com",
    "myspamless.com",
    "mystery-samurai.com",
    "mystufffb.fun",
    "mystupidjob.com",
    "mystvpn.com",
    "mystyleuae.xyz",
    "mysudo.net",
    "mysugartime.ru",
    "mysunrise.tech",
    "mysuperipfs3434.com",
    "mysupersonic.xyz",
    "mysweetpete.com",
    "myswisswallet.com",
    "mytabor.ru",
    "mytalentpantry.com",
    "mytamilyogi.site",
    "mytandberg.com",
    "mytandbergonline.com",
    "mytdss.ru",
    "mytech-surprise.com",
    "mytemp.email",
    "mytempdomain.tk",
    "mytempemail.com",
    "mytempmail.com",
    "mythereesa.com",
    "mythirdage.com",
    "mythnick.club",
    "mythpunkart.com",
    "mythrashmail.net",
    "mytizer111.ru",
    "mytmail.in",
    "mytmail.net",
    "mytools-ipkzone.gq",
    "mytop-in.net",
    "mytop48.xyz",
    "mytopface.ru",
    "mytrafficsecretsbook.com",
    "mytrashmail.com",
    "mytrashmail.net",
    "mytrashmailer.com",
    "mytrashmailr.com",
    "mytravelstips.com",
    "mytrommler.com",
    "mytrommlergroup.com",
    "mytrommleronline.com",
    "mytrumail.com",
    "myturisto.ru",
    "mytuscsanaria.com",
    "mytvc.ru",
    "mytvisonfire.com",
    "mytyrizm.ru",
    "myukrainebrides.com",
    "myupdates.me",
    "myurbanwork.com",
    "myvacation.mobi",
    "myvaultsophia.com",
    "myversebook.net",
    "myversebook.org",
    "myvien88suongnguyetanh.net",
    "myvineyard.ru",
    "myviol12ation.site",
    "myvip11.com",
    "myvisionpractice.com",
    "mywallets.ru",
    "mywarnernet.net",
    "myway.com",
    "mywdn2.us",
    "mywegolo.com",
    "mywheelchairspace.info",
    "mywholeworld.site",
    "mywhtx.icu",
    "mywiemyto.online",
    "mywikitree.com",
    "mywondersbook.com",
    "mywoolie.ru",
    "myworkhelper.com",
    "myworkturk.online",
    "myworldfame.digital",
    "myworldfame.online",
    "myworldfame.site",
    "myworldfame.store",
    "myworldmail.com",
    "mywow2020.xyz",
    "mywrld.site",
    "mywrld.top",
    "myxl.xyz",
    "myxnode.online",
    "myxxx-video.ru",
    "myyahoo.com",
    "myylytica.site",
    "myyogurtkingdom.com",
    "myzat.com",
    "myzhkt.ru",
    "myzmail.email",
    "myzx.com",
    "myzx9.com",
    "myzygadoc.online",
    "myzygadoc.tech",
    "mzdhfv.info",
    "mzfactoryy.com",
    "mzfranchising.com",
    "mzhhqo.ga",
    "mzigg6wjms3prrbe.cf",
    "mzigg6wjms3prrbe.ga",
    "mzigg6wjms3prrbe.gq",
    "mzigg6wjms3prrbe.ml",
    "mzigg6wjms3prrbe.tk",
    "mziqo.com",
    "mzlcd.us",
    "mzlmptvf.shop",
    "mzoneoo1.com",
    "mztravels.com",
    "mzxwvrrhh.shop",
    "mzzlmmuv.shop",
    "n-gtld-servers.com",
    "n-gtld-servers.net",
    "n-mikamc.ru",
    "n-response.com",
    "n-root-servers.com",
    "n-videostudio.ru",
    "n-y-a.com",
    "n.ra3.us",
    "n.spamtrap.co",
    "n.zavio.nl",
    "n00btajima.ga",
    "n0100.fun",
    "n0100.online",
    "n0100.space",
    "n0qyrwqgmm.cf",
    "n0qyrwqgmm.ga",
    "n0qyrwqgmm.gq",
    "n0qyrwqgmm.ml",
    "n0qyrwqgmm.tk",
    "n0te.tk",
    "n120.fun",
    "n1775.com",
    "n1nja.org",
    "n2.com",
    "n21jl.com",
    "n2baseball.com",
    "n2business.com",
    "n2fnvtx7vgc.cf",
    "n2fnvtx7vgc.ga",
    "n2fnvtx7vgc.gq",
    "n2fnvtx7vgc.ml",
    "n2fnvtx7vgc.tk",
    "n2gsq.us",
    "n2ikcp.us",
    "n2mail.com",
    "n2soccer.com",
    "n2software.com",
    "n3dzpn.host",
    "n43bwg.us",
    "n4445.com",
    "n4hvqy.us",
    "n4paml3ifvoi.cf",
    "n4paml3ifvoi.ga",
    "n4paml3ifvoi.gq",
    "n4paml3ifvoi.ml",
    "n4paml3ifvoi.tk",
    "n4qjue.us",
    "n4v.shop",
    "n58n.com",
    "n5fo2.us",
    "n5iny.us",
    "n5q6jh.us",
    "n5r0au.us",
    "n74fzg-mail.xyz",
    "n78qp.com",
    "n7i8yjto1nkf7do.xyz",
    "n7o3hg.com",
    "n8.gs",
    "n89p.press",
    "n8he49dnzyg.cf",
    "n8he49dnzyg.ga",
    "n8he49dnzyg.ml",
    "n8he49dnzyg.tk",
    "n8tini3imx15qc6mt.cf",
    "n8tini3imx15qc6mt.ga",
    "n8tini3imx15qc6mt.gq",
    "n8tini3imx15qc6mt.ml",
    "n8tini3imx15qc6mt.tk",
    "n9fjzj8t.xyz",
    "na-cheky.ru",
    "na-dengy-admiralx.link",
    "na-start.com",
    "na505.site",
    "na872.site",
    "naaag6ex6jnnbmt.ga",
    "naaag6ex6jnnbmt.ml",
    "naaag6ex6jnnbmt.tk",
    "naacim-car.ru",
    "naadqm.xyz",
    "naagle.com",
    "naandroid.club",
    "naaughty.club",
    "nabatan.cf",
    "nabatan.ml",
    "nabatan.tk",
    "nabc.biz",
    "nabclient.com",
    "naberswealthadvisor.com",
    "nableali.ga",
    "nableali.ml",
    "naboostso.cf",
    "naboostso.ga",
    "naboostso.gq",
    "naboostso.ml",
    "naboostso.tk",
    "nabsic.shop",
    "nabufan.com",
    "nabuma.com",
    "nabumage.com",
    "nabv.icu",
    "nabz-iran.org",
    "naceenelah.icu",
    "nacho.pw",
    "nacritical.space",
    "nada.email",
    "nada.ltd",
    "nadbeqx.site",
    "nadbwnas.icu",
    "nadolpu.cf",
    "nadolpu.gq",
    "nadolpu.ml",
    "nadolpu.tk",
    "nadzorsb.ru",
    "naeglesbagels.com",
    "nafe.com",
    "nafihet.xyz",
    "nafilllo.ga",
    "nafilllo.gq",
    "nafilllo.ml",
    "nafko.cf",
    "naga.email",
    "naga303.us",
    "nagabos.com",
    "nagaikan.asia",
    "nagambett.net",
    "nagambtt.com",
    "nagambtt.net",
    "nagamems.com",
    "nagarealm.com",
    "nagemen.shop",
    "naghini.cf",
    "naghini.ga",
    "naghini.gq",
    "naghini.ml",
    "nagljadnye-posobija.ru",
    "nagpal.net",
    "naguarmora.icu",
    "nahanbooks.com",
    "naheno.gq",
    "naheno.tk",
    "nahibe.xyz",
    "nahidcavadov.com",
    "nahlxyvr.shop",
    "nahrm.org",
    "naicomle.gq",
    "naicomle.tk",
    "naiditceo.cf",
    "naiditceo.ga",
    "naiditceo.gq",
    "naiditceo.ml",
    "naiditceo.tk",
    "naierhua.com",
    "nailba.info",
    "naildiscount24.de",
    "naim.mk",
    "nainiutv.info",
    "naipode.ga",
    "naipode.gq",
    "naipode.ml",
    "naipode.tk",
    "naitimp3.org",
    "naiv.guru",
    "najiumai.com",
    "najthjihj.shop",
    "najverea.cf",
    "najverea.ga",
    "najverea.ml",
    "najverea.tk",
    "naka-popa.icu",
    "nakaan.com",
    "nakachat.com",
    "nakam.xyz",
    "nakammoleb.xyz",
    "nake.cam",
    "nakedgreens.com",
    "nakedmixtapes.com",
    "nakedtruth.biz",
    "nakil-rannes.ru",
    "nakugames.ru",
    "nakzvpn.xyz",
    "nala-besxav.ru",
    "nalchikbroiler.ru",
    "nalejlabs.org",
    "nalevo.xyz",
    "nalichnik78.ru",
    "naligi.ga",
    "naligi.ml",
    "naligi.tk",
    "nalkte.us",
    "naloglo.ru",
    "nalquitwen.cf",
    "nalquitwen.ga",
    "nalquitwen.gq",
    "nalquitwen.ml",
    "nalquitwen.tk",
    "nalrini.ga",
    "nalrini.ml",
    "nalrini.tk",
    "nalukers.life",
    "nam10.org",
    "nam4.org",
    "nam6.org",
    "namakuirfan.com",
    "namaquanationalpark.com",
    "namasteyogasupply.com",
    "namche.org",
    "namde.net",
    "name.com",
    "nameaaa.myddns.rocks",
    "namefake.com",
    "namemail.xyz",
    "namepicker.com",
    "nameplanet.com",
    "nameq.io",
    "namesever.website",
    "namesperplexpower.site",
    "namesportklop.ru",
    "nametrans.net",
    "nametron.net",
    "namibiansafari.org",
    "namify.services",
    "namilu.com",
    "naminady.ru",
    "namkr.com",
    "namloongjewellery.com",
    "namm-cakaut.ru",
    "namste99.com",
    "namtinh.top",
    "namtovarovedam.ru",
    "namtruong318.com",
    "namunathapa.com.np",
    "namuoutlets.site",
    "namushops.site",
    "namuwikiusercontent.com",
    "namyn.com",
    "nan.us.to",
    "nana10.co.il",
    "nanadee.com",
    "nanafit.host",
    "nanafit.press",
    "nanafit.site",
    "nanafit.store",
    "nanaimo.tech",
    "nanaimotech.com",
    "nanaseaikawa.com",
    "nancyorlandobooks.com",
    "nancypen.com",
    "nandini.com",
    "nando1.com",
    "nandomail.com",
    "nano-baby.ru",
    "nano-scaffolding.com",
    "nanobeerandfood.site",
    "nanobrewbakery.com",
    "nanobumper.com",
    "nanocentcard.com",
    "nanodegrees.mobi",
    "nanofielznan3s5bsvp.cf",
    "nanofielznan3s5bsvp.ga",
    "nanofielznan3s5bsvp.gq",
    "nanofielznan3s5bsvp.ml",
    "nanofielznan3s5bsvp.tk",
    "nanokeycard.com",
    "nanokoruyucumaske.xyz",
    "nanonym.ch",
    "nanoxbio.ru",
    "nanrosub.ga",
    "nanrosub.gq",
    "nansanyule.com",
    "nanshan-yule.com",
    "nanshanys.info",
    "nansyiiah.xyz",
    "nanyang.news",
    "nanyangpost.net",
    "naogaon.gq",
    "naoug.com",
    "napaeyes.com",
    "napalm51.cf",
    "napalm51.flu.cc",
    "napalm51.ga",
    "napalm51.gq",
    "napalm51.igg.biz",
    "napalm51.ml",
    "napalm51.nut.cc",
    "napalm51.tk",
    "napalm51.usa.cc",
    "nape.net",
    "napkinfolding.club",
    "naplesmanatees.com",
    "naplesnews.net",
    "napolix.it",
    "nappamurra.com",
    "nappassportmrs.website",
    "nappillows.info",
    "napston.org",
    "napwa.org",
    "naquke.info",
    "naradi.online",
    "naramatapress.com",
    "narcardsearch.gq",
    "narcardsearch.tk",
    "narcologist.ru",
    "narcotizes67sd.online",
    "nares.de",
    "nargileal.xyz",
    "narliderecooperative.info",
    "narodnydoctor.ru",
    "narrec10.club",
    "narsan.ru",
    "narthehpnk.space",
    "narushiteli.info",
    "narvetsfebv.ga",
    "narvetsfebv.gq",
    "narvetsfebv.ml",
    "narvetsfebv.tk",
    "narwhalsecurity.com",
    "narwhalsecurity.net",
    "nasa.iotu.nctu.me",
    "nasaert2.website",
    "nasamdele.ru",
    "nascimento.com",
    "nasedra.site",
    "naseej.com",
    "nasepismos.info",
    "nash.ml",
    "nasha-rasha-sezon.ru",
    "nashaobuvka.ru",
    "nashipodarky.ru",
    "nashitufelki.ru",
    "nashnettest.com",
    "nashproekt2019.ru",
    "nashvillenailsalons.com",
    "nashvillequote.com",
    "nasimpourya.com",
    "nasinyang.cf",
    "nasinyang.ga",
    "nasinyang.gq",
    "nasinyang.ml",
    "nasise.ga",
    "nasise.gq",
    "nasise.ml",
    "naskotk.cf",
    "naskotk.ga",
    "naskotk.ml",
    "naslazhdai.ru",
    "nasobef.xyz",
    "nasolalxnd.space",
    "nasosdozator.ru",
    "nasrinmoh45.ir",
    "nasscopund.icu",
    "nassecams.online",
    "nastroikalinuksa.ru",
    "nastroykaastralinux.ru",
    "nastroykalinuxa.ru",
    "nastroykamagento.ru",
    "nat4.us",
    "natacion.online",
    "natafaka.online",
    "natal.store",
    "nataliacioffi.com",
    "natalies.info",
    "natalnaiakarta.ru",
    "natalurbano.com",
    "natashaparkinson.buzz",
    "natchaler.store",
    "nate.com",
    "nateshops.site",
    "nathanexplosion.com",
    "nathangould.com",
    "national-alert.org",
    "national.shitposting.agency",
    "nationalartsstandard.org",
    "nationalassociationoftinyhouses.com",
    "nationalcbdcorporation.com",
    "nationalchalkassociation.com",
    "nationaldictionary.xyz",
    "nationalgardeningclub.com",
    "nationalgerometrics.com",
    "nationalhealthsystem.site",
    "nationalizing203nb.online",
    "nationallists.com",
    "nationalspeedwaystadium.co",
    "nationalwholeblood.org",
    "nationchange.com",
    "nationz.poker",
    "nativestar.net",
    "nativeweb.net",
    "natomar.cf",
    "natomar.ga",
    "natomar.ml",
    "natomar.tk",
    "natomasnorthlake.com",
    "natteliv.dk",
    "natter.dev",
    "natterstefan.dev",
    "natuche.ru",
    "naturadomy.com",
    "natural-helpfored.site",
    "naturalapiary.us",
    "naturalbodybuildingevents.net",
    "naturalious.com",
    "naturalizes488ls.online",
    "naturalnoemylo.ru",
    "naturalstonetables.com",
    "naturaltai.ru",
    "nature-me.site",
    "naturegift.ru",
    "naturesfood.shop",
    "naturopathequipment.com",
    "naubuti.ga",
    "naubuti.ml",
    "nauchi-online.ru",
    "naucrary.site",
    "naucrary.xyz",
    "naudlenku.ru",
    "naughty-blog.com",
    "naui.net",
    "naupegical.xyz",
    "naupoge.cf",
    "naupoge.ga",
    "naupoge.ml",
    "naureico.cf",
    "naureico.ga",
    "naureico.gq",
    "nauticalconsultingservices.com",
    "nauticom.net",
    "nauticsteel.com",
    "nautoriuses.website",
    "nauyr.site",
    "navadb90b.net",
    "navadbet90.online",
    "navarroinsurancesolutions.com",
    "navelgazingmidwife.com",
    "navelnaivetyprice.site",
    "navendazanist.net",
    "naveon.ru",
    "naver.com",
    "navientlogin.net",
    "navigandopisa.com",
    "navigationre.com",
    "navigator.lv",
    "navistarcumminskenworthdetroit.com",
    "navoff.com",
    "navy.org",
    "navyhodnye.ru",
    "nawe-videohd.ru",
    "nawmin.info",
    "naxsw5.us",
    "nayatelier.com",
    "naybackmig.cf",
    "naybackmig.ga",
    "naybackmig.ml",
    "naydrakem.ga",
    "nayshki.ru",
    "naz.com",
    "nazdem.info",
    "nazimail.cf",
    "nazimail.ga",
    "nazimail.gq",
    "nazimail.ml",
    "nazimail.tk",
    "nazuboutique.site",
    "nb-me.com",
    "nb-om.com",
    "nb-sg.com",
    "nb1008.com",
    "nb3gw8-mail.xyz",
    "nb4tx2.us",
    "nb55.org",
    "nb8qadcdnsqxel.cf",
    "nb8qadcdnsqxel.ga",
    "nb8qadcdnsqxel.gq",
    "nb8qadcdnsqxel.ml",
    "nb8qadcdnsqxel.tk",
    "nbaclubuniversity.com",
    "nbaknicksx.xyz",
    "nbantw.us",
    "nbapredictor.com",
    "nbcstech.com",
    "nbd.biz",
    "nbdhny.com",
    "nbenealto.cf",
    "nbenealto.ga",
    "nbenealto.ml",
    "nbenealto.tk",
    "nbhsssib.fun",
    "nbjnmj.com",
    "nbnb168.com",
    "nbnb88.com",
    "nbnce00.com",
    "nbox.notif.me",
    "nbrdaudi.com",
    "nbrst7e.top",
    "nbrzsrri.shop",
    "nbvojcesai5vtzkontf.cf",
    "nbvwtibt.shop",
    "nbxtou.info",
    "nbzmr.com",
    "nbzqpv.site",
    "nc.rr.com",
    "nc.ru",
    "nc0817.net",
    "nc6lhu.us",
    "ncaaomg.com",
    "ncaccenture.com",
    "ncatdamge.ga",
    "ncatdamge.ml",
    "ncatdamge.tk",
    "ncbdfyy.com",
    "ncbi.nlm.nih.gov",
    "ncced.org",
    "nccmontreal.org",
    "ncco.de",
    "ncdc-laborers.net",
    "ncdentalimplants.com",
    "ncdrw.info",
    "nce2x8j4cg5klgpupt.cf",
    "nce2x8j4cg5klgpupt.ga",
    "nce2x8j4cg5klgpupt.gq",
    "nce2x8j4cg5klgpupt.ml",
    "nce2x8j4cg5klgpupt.tk",
    "ncedetrfr8989.cf",
    "ncedetrfr8989.ga",
    "ncedetrfr8989.gq",
    "ncedetrfr8989.ml",
    "ncedetrfr8989.tk",
    "nceng.dev",
    "ncenucra.cf",
    "ncenucra.gq",
    "ncenucra.ml",
    "ncenucra.tk",
    "ncewy646eyqq1.cf",
    "ncewy646eyqq1.ga",
    "ncewy646eyqq1.gq",
    "ncewy646eyqq1.ml",
    "ncewy646eyqq1.tk",
    "ncf.edu",
    "ncfastdeals.com",
    "nchalfpricedlisting.com",
    "nchalfpricelistings.com",
    "nchoicemail.com",
    "ncid.xyz",
    "ncixp.com",
    "nclean.us",
    "nclouddns.com",
    "ncmarket.site",
    "ncmlw.info",
    "ncncinc.com",
    "ncov.office.gy",
    "ncpine.com",
    "ncreseachsociety.org",
    "ncs-3.com",
    "ncs-5.com",
    "ncs-777.com",
    "ncseculogin.info",
    "ncsoft.top",
    "ncstore.email",
    "ncstore.me",
    "nctlab.ru",
    "nctm.de",
    "nctuiem.xyz",
    "ncxunaxu.shop",
    "ncyoungliving.com",
    "nd-re.com",
    "nd0qm6.com",
    "ndayav.com",
    "ndcpmarketplace.net",
    "ndcpmarketplace.org",
    "nddgxslntg3ogv.cf",
    "nddgxslntg3ogv.ga",
    "nddgxslntg3ogv.gq",
    "nddgxslntg3ogv.ml",
    "nddgxslntg3ogv.tk",
    "ndek4g0h62b.cf",
    "ndek4g0h62b.ga",
    "ndek4g0h62b.gq",
    "ndek4g0h62b.ml",
    "ndek4g0h62b.tk",
    "ndemail.ga",
    "ndeooo.club",
    "ndeooo.com",
    "ndeooo.xyz",
    "nderndeu.shop",
    "ndeunder.shop",
    "ndfakemail.ga",
    "ndfbmail.ga",
    "ndgamer.online",
    "ndgsw.info",
    "ndhalfpricelistings.com",
    "ndif8wuumk26gv5.cf",
    "ndif8wuumk26gv5.ga",
    "ndif8wuumk26gv5.gq",
    "ndif8wuumk26gv5.ml",
    "ndif8wuumk26gv5.tk",
    "ndihisucy.shop",
    "ndinstamail.ga",
    "ndiqj1.site",
    "ndmail.cf",
    "ndnaction.com",
    "ndnaction.net",
    "ndprndpa.shop",
    "ndrb.us",
    "nds-abilities.host",
    "nds-assurance.website",
    "nds-was.space",
    "nds8ufik2kfxku.cf",
    "nds8ufik2kfxku.ga",
    "nds8ufik2kfxku.gq",
    "nds8ufik2kfxku.ml",
    "nds8ufik2kfxku.tk",
    "ndscalc.site",
    "ndscalc.store",
    "ndsupernet.com",
    "ndtglossary.com",
    "ndtx74.online",
    "ndxgokuye98hh.ga",
    "ndyj.xyz",
    "ndzalo.africa",
    "ne4382.com",
    "nealyauto.com",
    "neam3b.info",
    "neanta.ru",
    "nearbyharvest.org",
    "nearcomet.net",
    "nearify.com",
    "neat-url.com",
    "neatbetting.com",
    "neatgrosshandel.com",
    "neathandvi.cf",
    "neathandvi.tk",
    "neatopod.store",
    "neatslots.com",
    "neatstats.com",
    "neb.rr.com",
    "nebbishes.best",
    "nebbo.online",
    "nebltiten0p.cf",
    "nebltiten0p.gq",
    "nebltiten0p.ml",
    "nebltiten0p.tk",
    "neboleim.site",
    "nebraskaquote.com",
    "nebraskawomensbar.org",
    "nebulaserve.com",
    "neccomputers.com",
    "necessure.site",
    "nechasa.tk",
    "necsilan.cf",
    "nedcxim-likimam.ru",
    "nederchan.org",
    "nedevit1.icu",
    "nedf.de",
    "nediyor.net",
    "nediyor.org",
    "nedmin.com",
    "nedrk.com",
    "neds.cards",
    "neds.cash",
    "neds.coupons",
    "neds.fail",
    "neds.fund",
    "neds.gold",
    "neds.live",
    "neds.promo",
    "nedv-stupino.ru",
    "needcore.ru",
    "needdentistnearme.com",
    "needfogr.cf",
    "needfulhost.com",
    "needhamspine.com",
    "needkasoi.tk",
    "needlilog.xyz",
    "neednow.org",
    "needrabit.cf",
    "needrabit.ga",
    "needrabit.tk",
    "neenahdqgrillchill.com",
    "neet123.com",
    "neetbt.com",
    "neetwiki.com",
    "neeva.net",
    "nefariousunion.com",
    "neft.club",
    "negated.com",
    "negrofilio.com",
    "negruz.ru",
    "nehalfpricedlisting.com",
    "nehartcan.cf",
    "nehartcan.ga",
    "nehartcan.ml",
    "neibu306.com",
    "neibu963.com",
    "neic.com",
    "neicastpos.cf",
    "neicastpos.ga",
    "neicastpos.gq",
    "neicastpos.ml",
    "neighborhood765jh.online",
    "neighbour.expert",
    "neiro777-official.ru",
    "neiroseven-official.ru",
    "neiroseven.ru",
    "neirosonic.ru",
    "neirosystem7-store.ru",
    "neit.email",
    "nejatngo.info",
    "nekiga.ga",
    "nekiga.ml",
    "neko2.net",
    "nekojita.blog",
    "nekomi.net",
    "nekopoker.com",
    "nekopoker.net",
    "nekopoker.org",
    "nekto.com",
    "nekto.net",
    "nekto.ru",
    "nekursam.com",
    "nel21.cc",
    "nel21.me",
    "nela.site",
    "nelasat.com",
    "nelasoft.com",
    "nellolitoday.com",
    "nelriona.ga",
    "nelriona.gq",
    "nelsontvip.site",
    "nemhgjujdj76kj.tk",
    "nemisupermart.site",
    "nempo.net",
    "nemra1.com",
    "nemtxjjblt.icu",
    "nenengsaja.cf",
    "nenproso.tech",
    "nenrile.ga",
    "nenrile.gq",
    "nenrile.ml",
    "nenter.com",
    "nentorit.ga",
    "nentorit.gq",
    "nentorit.ml",
    "neo.rr.com",
    "neo10.xyz",
    "neo11.xyz",
    "neo17.xyz",
    "neo18.xyz",
    "neo19.xyz",
    "neo6.xyz",
    "neocede.gq",
    "neocivil.com",
    "neoconstruction.net",
    "neocri.me",
    "neoditho.cf",
    "neodito.cf",
    "neodito.gq",
    "neodito.tk",
    "neoghost.com",
    "neohkj.info",
    "neololyc.ga",
    "neololyc.gq",
    "neololyc.ml",
    "neomailbox.com",
    "neonaerospace.net",
    "neonbees.info",
    "neonclub.com",
    "neonexchange.company",
    "neonigratonline.ru",
    "neonmask-official.ru",
    "neontogel.com",
    "neontogel.org",
    "neontology.xyz",
    "neonwolf.info",
    "neore.xyz",
    "neoscmscheck.xyz",
    "neosilico.com",
    "neoss.ru",
    "neoterism.site",
    "neoterize359cm.online",
    "neotlozhniy-zaim.ru",
    "neotrade.ru",
    "neovalorinvestimento.com",
    "nepalecolodges.com",
    "nepbt.com",
    "nepgame.com",
    "nepheme.live",
    "nepnut.com",
    "neptun-pro.ru",
    "nepwk.com",
    "neq.us",
    "neracapoker.net",
    "nerasto.gq",
    "nerasto.tk",
    "nercatu.ga",
    "nerd.click",
    "nerdmail.co",
    "nerdonamission.com",
    "nerds.dating",
    "nerdtechgroup.com",
    "nerimosaja.cf",
    "nerjasolar.com",
    "nerjavei.ru",
    "nermin.ru",
    "nerocommerce.shop",
    "nerroiuty.tk",
    "nerud-domodedovo.ru",
    "nerveequa.press",
    "nervegl.xyz",
    "nervhq.org",
    "nervmich.net",
    "nervtmich.net",
    "nescafelatte.com",
    "neseltekstil.xyz",
    "nesine-iddaa.org",
    "nesita.gq",
    "nesita.ml",
    "nesita.tk",
    "neslihanozmert.com",
    "neslon1.site",
    "neslon6.site",
    "neslon8.site",
    "nespaneed.ml",
    "nespaneed.tk",
    "nessmolo.cf",
    "nessmolo.ga",
    "nessmolo.ml",
    "nessmolo.tk",
    "nessnirap.cf",
    "nessnirap.ga",
    "nessnirap.tk",
    "nessterba.cf",
    "nessterba.ga",
    "nessterba.gq",
    "nessterba.ml",
    "nestkenyas.info",
    "nestle-usa.cf",
    "nestle-usa.ga",
    "nestle-usa.gq",
    "nestle-usa.ml",
    "nestle-usa.tk",
    "nestspace.co",
    "nesuppe.site",
    "nesy.site",
    "net-c.be",
    "net-c.ca",
    "net-c.cat",
    "net-c.com",
    "net-c.es",
    "net-c.fr",
    "net-c.it",
    "net-c.lu",
    "net-c.nl",
    "net-c.pl",
    "net-list.com",
    "net-pager.net",
    "net-piyango.biz",
    "net-privichkam.ru",
    "net-shopping.com",
    "net-solution.info",
    "net.email.ne.jp",
    "net.tf",
    "net.ua",
    "net1mail.com",
    "net2222.com",
    "net2mail.top",
    "net3mail.com",
    "net4b.pt",
    "net4you.at",
    "net6host.com",
    "net8mail.com",
    "neta123.com",
    "netaa318.xyz",
    "netactive.co.za",
    "netaddres.ru",
    "netaddress.com",
    "netaddress.ru",
    "netatv.com",
    "netawiki.com",
    "netbonking.com",
    "netbounce.com",
    "netbroadcaster.com",
    "netbruger.dk",
    "netby.dk",
    "netc.eu",
    "netc.fr",
    "netc.it",
    "netc.lu",
    "netc.pl",
    "netcenter-vn.net",
    "netcity.ru",
    "netcmail.com",
    "netcologne.de",
    "netcom.ca",
    "netcom.com",
    "netcom.ws",
    "netcourrier.com",
    "netctrcon.live",
    "netdisk.life",
    "netdove.net",
    "netexchangeclient.com",
    "netexecutive.com",
    "netexpressway.com",
    "netfercloud.com",
    "netfirms.com",
    "netflixaddons.xyz",
    "netflixcostarica.com",
    "netflixmexico.net",
    "netflixweb.com",
    "netgainmedia.com",
    "netgenie.com",
    "netgo.chat",
    "nethost5.com",
    "nethotmail.com",
    "nethubcommunity.com",
    "nethurra.com",
    "netian.com",
    "netins.net",
    "netipun.cf",
    "netipun.ga",
    "netipun.gq",
    "netipun.ml",
    "netipun.tk",
    "netizen.com.ar",
    "netjex.xyz",
    "netkao.xyz",
    "netkushi.com",
    "netlane.com",
    "netlawlifevault.com",
    "netlimit.com",
    "netmail-pro.com",
    "netmail.kg",
    "netmail.tk",
    "netmail3.net",
    "netmail8.com",
    "netmail9.com",
    "netmails.com",
    "netmails.info",
    "netmails.net",
    "netman.ru",
    "netmanor.com",
    "netmarketingforum.com",
    "netmidiadesign.com",
    "netmongol.com",
    "netnet.com.sg",
    "netnoir.net",
    "netomon.com",
    "netouyo.net",
    "netozyr.xyz",
    "netp22.xyz",
    "netpaper.eu",
    "netpdfmanuales.xyz",
    "netpiper.com",
    "netpiyango.biz",
    "netpiyango.info",
    "netpiyango.org",
    "netplix.site",
    "netpoker303.net",
    "netposta.net",
    "netprofitfunnels.com",
    "netradiomail.com",
    "netralink.com",
    "netricity.nl",
    "netris.net",
    "netscape.com",
    "netscape.net",
    "netscapeonline.co.uk",
    "netsec.onl",
    "netsense.us",
    "netsero.net",
    "netsgo.com",
    "netspace.net.au",
    "netspeedway.com",
    "netsputnik.ru",
    "netsquare.com",
    "netster.com",
    "nettaxi.com",
    "nettefinansman.xyz",
    "nettemail.com",
    "netterchef.de",
    "nettetasarruf.xyz",
    "netti.fi",
    "nettikasinot24.org",
    "nettogar.ml",
    "nettrosrest.cf",
    "nettrosrest.ga",
    "nettrosrest.gq",
    "nettrosrest.ml",
    "netupskiy.ru",
    "netuygun.online",
    "netvaiclus.cf",
    "netvaiclus.ga",
    "netvaiclus.gq",
    "netvaiclus.tk",
    "netviewer-france.com",
    "netvigator.com",
    "netvision.net.il",
    "network-advantage.site",
    "network-smart.site",
    "network-source.com",
    "networkafter.org",
    "networkafter.us",
    "networkapps.info",
    "networkbio.com",
    "networkchoice.site",
    "networkersjunction.com",
    "networkintentions.site",
    "networkofemail.com",
    "networkrank.com",
    "networksfs.com",
    "networktv.online",
    "networthdetail.club",
    "networthtop.club",
    "netxservices.net",
    "netzero.com",
    "netzero.net",
    "netzeroexpo.com",
    "netzerofestivallondon.com",
    "netzerofestivaluk.com",
    "netzidiot.de",
    "netzoola.com",
    "netzwerk-industrie.de",
    "neucasinoslots.com",
    "neue-dateien.de",
    "neuemode85.site",
    "neuf.fr",
    "neufunria.gq",
    "neufunria.ml",
    "neujajunc.gq",
    "neujajunc.tk",
    "neulanso.cf",
    "neulanso.gq",
    "neulanso.tk",
    "neundetav.cf",
    "neundetav.ga",
    "neundetav.gq",
    "neundetav.tk",
    "neuquen-labs.com",
    "neural.host",
    "neuro-safety.net",
    "neuro-safety.org",
    "neuro.md",
    "neuro7-shop.ru",
    "neuro7system.ru",
    "neuroect.com",
    "neuroleadershipsolutions.org",
    "neurologicrehabcenter.com",
    "neuronx.trade",
    "neurosize.com",
    "neurosystem-cool.ru",
    "neurosystem7-coolshop.ru",
    "neurosystem7-org.ru",
    "neurosystemseven-store.ru",
    "neurosystemseven.ru",
    "neustreet.com",
    "neutibu.cf",
    "neutibu.tk",
    "neutroncloudtesting.com",
    "nevadafastoffers.com",
    "nevadaibm.com",
    "nevadamar.com",
    "nevadaquote.com",
    "nevadasnow.com",
    "nevears.info",
    "neverbox.com",
    "neverbox.net",
    "neverbox.org",
    "neverenuff.com",
    "nevermail.de",
    "nevernameless.com",
    "neverneverland.ru",
    "neverwype.com",
    "nevfam.ru",
    "new-action-clear.host",
    "new-berrystats.com",
    "new-card.website",
    "new-dragon-takeaway.com",
    "new-eckwu.club",
    "new-games.space",
    "new-health-nutrition.com",
    "new-health.space",
    "new-marketing-official.ru",
    "new-moon-tullow.com",
    "new-outlet-mart.ru",
    "new-purse.com",
    "new-sunrise-takeaway.com",
    "new-tisar.ru",
    "new-victoria-dublin.com",
    "new-wow-info.ru",
    "new-yea-action.ru",
    "new-year-gadgets.monster",
    "new-year-lucky-gift.icu",
    "new-year-lucky-gifts.monster",
    "new-year-special-gift.icu",
    "new-year-special-gift.monster",
    "new-york-wedding.com",
    "new.eu",
    "new.rr.com",
    "new688e.ga",
    "newa.wtf",
    "newagebotanicalsllc.com",
    "newageprovision.net",
    "newageprovisions.net",
    "newairmail.com",
    "newakie.space",
    "newap.ru",
    "newappsusa.com",
    "newarbat.net",
    "newarktribune.com",
    "newatarivcs.com",
    "newattacks.com",
    "newaybag.com",
    "newayshome.ru",
    "newbal.xyz",
    "newbeatslive.club",
    "newbeekeepers.us",
    "newberlindentists.com",
    "newberry-stats.com",
    "newberrystat-s.com",
    "newberrytully.com",
    "newborn24.com",
    "newbpotato.tk",
    "newbridesguide.com",
    "newbrunswickdentists.com",
    "newbrunswickdoctors.com",
    "newburghapartments.com",
    "newc.site",
    "newceilingsbrevard.com",
    "newcentermc.ru",
    "newcentglos.ga",
    "newcentglos.ml",
    "newcentglos.tk",
    "newclarkcity.guide",
    "newcoloringpage.club",
    "newcolumbiainc.com",
    "newcomerprograms.org",
    "newdawnnm.xyz",
    "newdaydevelopment.org",
    "newdesignmedia.info",
    "newdragonchinese.com",
    "newe-mail.com",
    "neweasy2.net",
    "neweducations.ru",
    "neweducationtools.ru",
    "newemperorcity-galway.com",
    "newenglandmotorvehicleaccident.com",
    "neweranews1.com",
    "neweranews15.com",
    "neweranews16.com",
    "neweranews19.com",
    "neweranews20.com",
    "neweranews3.com",
    "neweranews4.com",
    "neweranews5.com",
    "neweranews8.com",
    "newerasolutions.co",
    "newesttestament.us",
    "newfilm24.ru",
    "newfinances.ru",
    "newfloridavisionpac.live",
    "newformcontent.com",
    "newfoundlandchocolatecompany.ca",
    "newgameexpert.ru",
    "newgrandx.com",
    "newhalik.club",
    "newhampshirecareers.com",
    "newhampshirequote.com",
    "newhempcbd.com",
    "newhomepizza.com",
    "newhopebaptistaurora.com",
    "newhorizons.gq",
    "newhorrizon.ru",
    "newia.site",
    "newideasfornewpeople.info",
    "newik.site",
    "newim.site",
    "newio.site",
    "newiq.site",
    "newiz.site",
    "newj.site",
    "newjerseyaddictionrehab.com",
    "newjerseybrasil.com",
    "newjerseyjewishmonuments.com",
    "newjetsadabet.com",
    "newjp-100.xyz",
    "newjp-102.xyz",
    "newjp-103.xyz",
    "newkebabpalace.com",
    "newland-dublin8.com",
    "newleaf-tallaght.com",
    "newlifelogs.com",
    "newlifepathways.com",
    "newljeti.cf",
    "newljeti.gq",
    "newljeti.ml",
    "newmail.com",
    "newmail.net",
    "newmail.ru",
    "newmail.top",
    "newmandarinmalahide.com",
    "newmangroupstore.com",
    "newmarlborough.icu",
    "newmesotheliomalaywers.com",
    "newmexicoelevatorsolutions.com",
    "newmexicoquote.com",
    "newmobiledevtop.club",
    "newmoneymemo.com",
    "newmotionrp.ru",
    "newmovietrailers.biz",
    "newmrkebabmalaga.com",
    "newmuzon.ru",
    "newnetfx.website",
    "newneurosystem7.ru",
    "newnewsforex.ru",
    "newnodepositcasinobonuses.com",
    "newo.site",
    "newoa.site",
    "newob.site",
    "newop.site",
    "neworderofthenorthandsouthmrcinc.com",
    "neworleansopiaterehab.com",
    "newpdfmanuales.xyz",
    "newpekingtakeaway.com",
    "newportcosmeceuticalsinc.com",
    "newportunderthestars.com",
    "newpotolok24.ru",
    "newproduct2.xyz",
    "newproduct2020.site",
    "newproxy.site",
    "newpupclub.com",
    "newreal-dating1.com",
    "newrezadarg.xyz",
    "newrezagozel.xyz",
    "newrezka.online",
    "news-2in1.ru",
    "news-education.ru",
    "news-online24.info",
    "news-perviy.ru",
    "news-trends.online",
    "news-videohd.ru",
    "news-whiz.com",
    "news-year.ru",
    "newsaa318.xyz",
    "newsbook.se",
    "newsboysmail.com",
    "newsbrut.club",
    "newscoin.club",
    "newscorp.cf",
    "newscorp.gq",
    "newscorp.ml",
    "newsdubi.cf",
    "newsdubi.ga",
    "newserver.website",
    "newsfeeder.org",
    "newsgru.com",
    "newshoneybhealthyliving.com",
    "newslent.space",
    "newsletterbroadcaster.info",
    "newsletterbroadcaster.net",
    "newsm.info",
    "newsmag.us",
    "newsmaramax.ru",
    "newsmatix.com",
    "newsmonger.ru",
    "newsmonster.info",
    "newsnodewire.com",
    "newspdf.online",
    "newspro.fun",
    "newss-8.online",
    "newstantre.cf",
    "newstantre.ga",
    "newstantre.gq",
    "newstantre.ml",
    "newstantre.tk",
    "newstarss.ru",
    "newstekno.review",
    "newstheday.net",
    "newstudio48.xyz",
    "newsunrisedublin7.com",
    "newsusfun.com",
    "newtempmail.com",
    "newtmail.com",
    "newtogel.xyz",
    "newton.money",
    "newtopian.org",
    "newtrendmag.xyz",
    "newtrierliving.info",
    "newtuber.info",
    "newulife.global",
    "newunionnyc.com",
    "newuserdev.org",
    "newviral.fun",
    "newvol.info",
    "newway-sy.com",
    "newwinterrss.com",
    "newworimjq.space",
    "newyearfreepas.ws",
    "newyearnewchance.faith",
    "newyearsevela.com",
    "newyork.com",
    "newyorkcity.com",
    "newyorkfamilyhistoryschool.com",
    "newyorkfamilyhistoryschool.org",
    "newyorkjan.com",
    "newyorkmonthlyherald.com",
    "newyorkoaks.com",
    "newyorkoliveoilcompany.com",
    "newyorkpaas.com",
    "newyorkpersonalinjurylawyers.com",
    "newyorkskyride.net",
    "newzherald.com",
    "nexbet40.online",
    "nexgen-buysrentals.com",
    "nexhibit.com",
    "nexio.us",
    "nexitele.com",
    "nexofinance.us",
    "nexostartups.com",
    "nexral.com",
    "nexriseinfo.tech",
    "nexscience.tk",
    "nexsman.com",
    "nexswiss.org",
    "next-mail.info",
    "next-mail.online",
    "next.net",
    "next.ovh",
    "next2cloud.info",
    "nextbasic.store",
    "nextcase.foundation",
    "nextcloud.design",
    "nextderm.com",
    "nextdoorfamilypov.com",
    "nextemail.in",
    "nextemail.net",
    "nextgenadmin.com",
    "nextgencoaching.org",
    "nextgenmail.cf",
    "nextlevelesport.com",
    "nextmail.com",
    "nextmail.in",
    "nextmail.info",
    "nextmail.ru",
    "nextmarketer.com",
    "nextmin.com",
    "nextmola.com",
    "nextoc.com",
    "nextracom.info",
    "nextshop.host",
    "nextstopvalhalla.com",
    "nextthingsecrets.com",
    "nexus188.org",
    "nexus388.org",
    "nexussupplys.com",
    "nexxmail.com",
    "nexyfo.info",
    "neyann.site",
    "neystipan.cf",
    "neystipan.ga",
    "neystipan.gq",
    "neystipan.ml",
    "neystipan.tk",
    "nezamiyi.site",
    "nezdiro.org",
    "nezid.com",
    "nezzart.com",
    "nf151.top",
    "nf2m6z-mail.xyz",
    "nf2v9tc4iqazwkl9sg.cf",
    "nf2v9tc4iqazwkl9sg.ga",
    "nf2v9tc4iqazwkl9sg.ml",
    "nf2v9tc4iqazwkl9sg.tk",
    "nf5pxgobv3zfsmo.cf",
    "nf5pxgobv3zfsmo.ga",
    "nf5pxgobv3zfsmo.gq",
    "nf5pxgobv3zfsmo.ml",
    "nf5pxgobv3zfsmo.tk",
    "nf607.site",
    "nfast.net",
    "nfcbilekliksistem.com",
    "nfcq.email",
    "nfdhelp.com",
    "nffwrc.com",
    "nfl5.com",
    "nflixnow.pl",
    "nflxnw.website",
    "nfmail.com",
    "nfmfharates.us",
    "nfmqh.us",
    "nfnov28y9r7pxox.ga",
    "nfnov28y9r7pxox.gq",
    "nfnov28y9r7pxox.ml",
    "nfnov28y9r7pxox.tk",
    "nfnyvbxt.shop",
    "nforinpo.cf",
    "nforinpo.ga",
    "nforinpo.gq",
    "nforinpo.ml",
    "nforinpo.tk",
    "nforunen.ga",
    "nfovhqwrto1hwktbup.cf",
    "nfovhqwrto1hwktbup.ga",
    "nfovhqwrto1hwktbup.gq",
    "nfovhqwrto1hwktbup.ml",
    "nfovhqwrto1hwktbup.tk",
    "nfrk.us",
    "nfs-xgame.ru",
    "nft0hi.us",
    "nftaac.com",
    "nftuij.us",
    "nfzead.us",
    "ng9rcmxkhbpnvn4jis.cf",
    "ng9rcmxkhbpnvn4jis.ga",
    "ng9rcmxkhbpnvn4jis.gq",
    "ng9rcmxkhbpnvn4jis.ml",
    "ng9rcmxkhbpnvn4jis.tk",
    "ngayngo.asia",
    "ngc.team",
    "ngeme.me",
    "ngentodgan-awewe.club",
    "ngentot.info",
    "ngg1bxl0xby16ze.cf",
    "ngg1bxl0xby16ze.ga",
    "ngg1bxl0xby16ze.gq",
    "ngg1bxl0xby16ze.ml",
    "ngg1bxl0xby16ze.tk",
    "nghiduonghoian.com",
    "nghiencuuquocte.com",
    "nginbox.tk",
    "ngipsq.com",
    "ngit9.us",
    "ngobakha.ga",
    "ngoctravel.net",
    "ngopy.com",
    "ngplayer.com",
    "ngqn.icu",
    "ngreasr.ru",
    "ngroove.com",
    "ngs.ru",
    "ngscloud.space",
    "ngspi.ru",
    "ngstudio.org",
    "ngt-taxi.ru",
    "ngt7nm4pii0qezwpm.cf",
    "ngt7nm4pii0qezwpm.ml",
    "ngt7nm4pii0qezwpm.tk",
    "ngtheir.shop",
    "ngtierlkexzmibhv.ga",
    "ngtierlkexzmibhv.ml",
    "ngtierlkexzmibhv.tk",
    "ngtix.com",
    "ngtlcz.us",
    "ngtohl.us",
    "ngtrw.info",
    "nguhoc.xyz",
    "nguoigocviet.info",
    "nguyenduyphong.tk",
    "nguyentamvinh.ga",
    "nguyentuanvu.asia",
    "nguyenusedcars.com",
    "ngwsw.info",
    "nh3.ro",
    "nha.best",
    "nhacai88.online",
    "nhadatdai.com",
    "nhadatgiaviet.com",
    "nhadephm.com",
    "nhadepnhat.com",
    "nhahangmuoiot.com",
    "nhakhoa.xyz",
    "nhakhokygui.com",
    "nhanhdinhbongda.net",
    "nhanpro.net",
    "nhaphovinhomesquan9.com",
    "nhatdinhmuaduocxe.info",
    "nhatvip.us",
    "nhaxinh.xyz",
    "nhazmp.us",
    "nhbrqigc.shop",
    "nhcareerinstitute.org",
    "nhdental.co",
    "nhfg5b.online",
    "nhghotels.net",
    "nhhalfpricelisting.com",
    "nhhalfpricelistings.com",
    "nhhjgses.xyz",
    "nhhkernpurga.site",
    "nhhkernshtorm.site",
    "nhhparkapurga.site",
    "nhhzvenokern.site",
    "nhi9ti90tq5lowtih.cf",
    "nhi9ti90tq5lowtih.ga",
    "nhi9ti90tq5lowtih.gq",
    "nhi9ti90tq5lowtih.tk",
    "nhifswkaidn4hr0dwf4.cf",
    "nhifswkaidn4hr0dwf4.ga",
    "nhifswkaidn4hr0dwf4.gq",
    "nhifswkaidn4hr0dwf4.ml",
    "nhifswkaidn4hr0dwf4.tk",
    "nhkt5f.com",
    "nhmail.com",
    "nhmicrosoft.com",
    "nhryw.info",
    "nhs0armheivn.cf",
    "nhs0armheivn.ga",
    "nhs0armheivn.gq",
    "nhs0armheivn.ml",
    "nhs0armheivn.tk",
    "nhserr.com",
    "nhuconcack.top",
    "nhuconcack.xyz",
    "nhvdwl.com",
    "nhvlrc.space",
    "nhzbw.info",
    "nhzjbi.info",
    "ni-so.com",
    "ni24.club",
    "ni29.club",
    "ni35.club",
    "ni36.club",
    "ni37.club",
    "ni520wo.com",
    "ni64ru.host",
    "ni6tdw.us",
    "niachecomp.ga",
    "niacinamok.space",
    "niagarafallsrealestateagents.com",
    "niamhstorey.buzz",
    "niassanationalreserve.org",
    "niatob.us",
    "nibinsurance.com",
    "nibphina.ml",
    "nibphina.tk",
    "nic.aupet.it",
    "nic.info",
    "nice-4u.com",
    "nice-postel.ru",
    "nice-tits.info",
    "nicebush.com",
    "nicecardstores.com",
    "nicechas.info",
    "nicecorset.com",
    "nicedropshop.ru",
    "nicegal.com",
    "nicegarden.us",
    "nicegashs.info",
    "nicehao.com",
    "nicehash-alternative.com",
    "nicehash.review",
    "nicehotels.live",
    "nicelodsy.ru",
    "nicely.info",
    "nicemail.dk",
    "nicemail.pro",
    "nicerams.info",
    "nicewoodenbaskets.com",
    "niceyou06.site",
    "niceyou07.site",
    "niceyou13.site",
    "niceyou14.site",
    "niceyou16.site",
    "niceyou17.site",
    "nicheowl.net",
    "nichess.cf",
    "nichess.ga",
    "nichess.gq",
    "nichess.ml",
    "nichestack.wiki",
    "nicholaiburton.com",
    "nicholascalice.com",
    "nicholastse.net",
    "nicico.net",
    "nick-s.info",
    "nickbizimisimiz.ml",
    "nickelkbau.space",
    "nickholmesfineart.net",
    "nicknassar.com",
    "nickrizos.com",
    "nickshankland.com",
    "nicktac.xyz",
    "nickyheat.net",
    "nicolastse.com",
    "nicoleaniston.site",
    "nicolhampel.com",
    "nicomeyers.site",
    "nicoobook.net",
    "nicooprost.space",
    "nicos-kebabs-takeaway.com",
    "nicton.ru",
    "nid.edu",
    "nidama.ga",
    "nidama.gq",
    "nideno.cf",
    "nideno.ga",
    "nideshops.site",
    "nidomeed.ga",
    "nidomeed.gq",
    "nidomeed.tk",
    "nie-podam.pl",
    "niechlorpe.cf",
    "niechlorpe.ga",
    "niechlorpe.gq",
    "niechlorpe.ml",
    "nieciaco.cf",
    "nieciaco.ml",
    "nieciaco.tk",
    "niepodam.pl",
    "niesumpspyg.ga",
    "niesumpspyg.ml",
    "nieuwe.shop",
    "niewoiem.space",
    "nieworld.website",
    "nifewe.info",
    "nificio.ru",
    "nigeria1.website",
    "nigerialog.org",
    "nigge.rs",
    "night.monster",
    "nightalone.com",
    "nightaw.xyz",
    "nightimeuk.com",
    "nightmail.com",
    "nightmail.ru",
    "nighton.net",
    "nightstiffprize.site",
    "nihilista.ru",
    "nihondirect.net",
    "niibb.com",
    "niicaz.club",
    "niickel.us",
    "niid-fino-official.ru",
    "niid-unofficial.ru",
    "niiduno-official.ru",
    "nijefu.best",
    "nika-market24.ru",
    "nikami.net",
    "nikanewspro.ru",
    "nike.coms.hk",
    "nike270scontate.com",
    "nikeblazershop.com",
    "nikerosherunshoes.xyz",
    "nikezoomkobevenomenon5.website",
    "niki-car.ru",
    "niki-van1.ru",
    "nikitsvetkov.com",
    "nikkibars.icu",
    "nikoa.best",
    "nikojii.com",
    "nikola-tver.ru",
    "nikolib.ru",
    "nikoliba.ru",
    "nikolibs.ru",
    "nikolice.ru",
    "nikolize.ru",
    "nikoniko.ga",
    "nikopage.com",
    "nikulino.net",
    "nikvlad.ru",
    "niliis90.org",
    "nilufer.org",
    "niluferevleri.xyz",
    "nilyazilim.com",
    "nilynaje.com",
    "nimail.com",
    "nimajalali.info",
    "nimble.icu",
    "nimbponmi.cf",
    "nimbponmi.gq",
    "nimbponmi.tk",
    "nimcasa-carsiam.ru",
    "nimiety.xyz",
    "nimir.org",
    "nimonti.ga",
    "nimonti.gq",
    "nimonti.ml",
    "ninagarbiras.net",
    "ninayorks.info",
    "nincsmail.com",
    "nincsmail.hu",
    "ninelyn.ru",
    "ninesclothiers.com",
    "ninezro.com",
    "ninfan.com",
    "ningconra.gq",
    "ninhbinhbackpackershostel.com",
    "ninhoverde.club",
    "ninhxuangiang.ml",
    "ninin.host",
    "ninja-mail.com",
    "ninja-sale.com",
    "ninja-u.com",
    "ninja0p0v3spa.ga",
    "ninjacat.dev",
    "ninjadoll.international",
    "ninjadoll.org",
    "ninjaenterprises.com",
    "ninjafav.net",
    "ninjaget.net",
    "ninjagg.com",
    "ninjasystem.info",
    "ninunne.gq",
    "niofreeprob.cf",
    "niofreeprob.ga",
    "niofreeprob.gq",
    "niofreeprob.ml",
    "niofreeprob.tk",
    "nipponian.com",
    "nirapatta24.com",
    "niro-sistema-7.site",
    "nirojan.shop",
    "nirvanafan.com",
    "nisankiralamacim.com",
    "nisantasiclinic.com",
    "nisasya.com",
    "nisc.me",
    "nishansahib.us",
    "nishima.live",
    "nishtyakshop.ru",
    "nisl.com",
    "nisoskos.com",
    "nissanleaf.club",
    "nissanofcolumbus.online",
    "nisvibet.cf",
    "nisvibet.ga",
    "nitaaidhyan.org",
    "nitebitestakeaway.com",
    "nitecorestore.online",
    "niter.xyz",
    "nitish.page",
    "nitricolin.com",
    "nitro-service.xyz",
    "nitrohjbba.space",
    "nittraproject.com",
    "nitza.ga",
    "niujkasdi.tk",
    "niumasoitr.gq",
    "niuyitupob.xyz",
    "nivelirgll3.site",
    "nivsale.top",
    "niwl.net",
    "niwpd4.info",
    "nixemail.net",
    "niydomen897.cf",
    "niydomen897.ga",
    "niydomen897.gq",
    "niydomen897.ml",
    "niydomen897.tk",
    "nizabelt.xyz",
    "nj0ut9.info",
    "nj3dprinting.com",
    "njc65c15z.com",
    "njcomicanimecon.com",
    "njd2o3.us",
    "njelarubangilan.cf",
    "njelarucity.cf",
    "njetzisz.ga",
    "njhalfpricedlisting.com",
    "njhalfpricelisting.com",
    "njhyvz.host",
    "njjhjz.com",
    "njlsrp.org",
    "njmsm.com",
    "njneuropathyhealing.com",
    "njordcybersecurity.com",
    "njordsecurity.com",
    "njswnh.site",
    "njt2mb-mail.xyz",
    "njtec.com",
    "njwgw.info",
    "nkbmrd.fun",
    "nkc2w.us",
    "nkdmly.fun",
    "nkdmtc.fun",
    "nkeepracga.cf",
    "nkhfmnt.xyz",
    "nkiehjhct76hfa.ga",
    "nkjdgidtri89oye.gq",
    "nkjmdj.fun",
    "nkjmrh.fun",
    "nkjun2ocvybkiae.xyz",
    "nkk86.com",
    "nkm2ab.xyz",
    "nkm449.xyz",
    "nkm69q.xyz",
    "nkm7qw.xyz",
    "nkm839.xyz",
    "nkm8tg.xyz",
    "nkm9gj.xyz",
    "nkmije.xyz",
    "nkml5j.xyz",
    "nkmmbj.fun",
    "nkmmpg.work",
    "nkmms1.xyz",
    "nkmq32.xyz",
    "nkmq7i.xyz",
    "nkmqel.xyz",
    "nkmuiu.xyz",
    "nkmvgg.xyz",
    "nkmx8h.xyz",
    "nknk29.com",
    "nko.kr",
    "nkpmhg.fun",
    "nkpmxh.fun",
    "nkqmwg.fun",
    "nkqmyl.fun",
    "nkrozy9wr2snrcj.xyz",
    "nkshdkjshtri24pp.ml",
    "nktltpoeroe.cf",
    "nktwhg.com",
    "nkwmfz.fun",
    "nkxmjw.fun",
    "nkyebkix.shop",
    "nkyelectric.com",
    "nkymmc.fun",
    "nkymxg.fun",
    "nl-200.xyz",
    "nl-201.xyz",
    "nl.szucsati.net",
    "nlfjsx.us",
    "nljke.com",
    "nljrkz.us",
    "nlquery.com",
    "nlspam.cf",
    "nlspamm.cf",
    "nlxgwi.us",
    "nlzl6f.info",
    "nm.ru",
    "nm7.cc",
    "nmagazinec.com",
    "nmail.cf",
    "nmarticles.com",
    "nmav.xyz",
    "nmbxw.info",
    "nmfefq.us",
    "nmfrvry.cf",
    "nmfrvry.ga",
    "nmfrvry.gq",
    "nmfrvry.ml",
    "nmfxyx.us",
    "nmgszsm.com",
    "nmhalfpricelisting.com",
    "nmhalfpricelistings.com",
    "nmkwgo.com",
    "nmn2xki8vgt6ln2.xyz",
    "nmotion.net",
    "nmpkkr.cf",
    "nmpkkr.ga",
    "nmpkkr.gq",
    "nmpkkr.ml",
    "nmtheguardian.com",
    "nmupnwph.shop",
    "nmxjvsbhnli6dyllex.cf",
    "nmxjvsbhnli6dyllex.ga",
    "nmxjvsbhnli6dyllex.gq",
    "nmxjvsbhnli6dyllex.ml",
    "nmxjvsbhnli6dyllex.tk",
    "nn2d.com",
    "nn358.com",
    "nn46gvcnc84m8f646fdy544.tk",
    "nn57822.com",
    "nn5ty85.cf",
    "nn5ty85.ga",
    "nn5ty85.gq",
    "nn5ty85.tk",
    "nn7665.com",
    "nn8ty.com",
    "nnaannah.shop",
    "nnacg.com",
    "nnambuzzdimp.cf",
    "nnambuzzdimp.gq",
    "nnambuzzdimp.ml",
    "nnambuzzdimp.tk",
    "nnb532.com",
    "nnb545.com",
    "nnbgzy.com",
    "nneczwcql.shop",
    "nneqqj.rest",
    "nneynfpif.shop",
    "nnh.com",
    "nnhyysbcr.shop",
    "nnidea.com",
    "nnj123.com",
    "nnjie.com",
    "nnkgjc.rest",
    "nnlyf.com",
    "nnmoe.com",
    "nnmqustumutqp.ru",
    "nnn062.com",
    "nnn88.net",
    "nnn9827.com",
    "nnnnnn.com",
    "nnot.net",
    "nnov.ru",
    "nnoway.ru",
    "nnpmnclgj.shop",
    "nnpqyl.us",
    "nnpsz.com",
    "nnshe.com",
    "nntv.club",
    "nnyes.com",
    "nnzeg6.us",
    "nnztu.live",
    "nnzvh2axk4ncejm.xyz",
    "nnzzy.com",
    "no-365.com",
    "no-spam.hu",
    "no-spam.ws",
    "no-spammers.com",
    "no-sugar-recipes.com",
    "no-ux.com",
    "no-vax.cf",
    "no-vax.ga",
    "no-vax.gq",
    "no-vax.ml",
    "no-vax.tk",
    "no.tap.tru.io",
    "no1-ayo.com",
    "no1.vn",
    "no19rentalhaus.xyz",
    "no1bahis77.com",
    "no4ma.ru",
    "noa98.space",
    "noaado-shop.ru",
    "noaddedpulp.com",
    "noalatrata.org",
    "noattr.com",
    "noattrib.com",
    "noattribution.com",
    "noav9h.us",
    "noavar.com",
    "nob.sh",
    "nobaproject.org",
    "nobarid.com",
    "nobiga.ga",
    "nobiga.gq",
    "nobiga.ml",
    "nobiga.tk",
    "nobihu.tokyo",
    "nobilionrestaurant.com",
    "nobla.org",
    "noblechevy.com",
    "noblepioneer.com",
    "noblequotes.com",
    "nobstyther.cf",
    "nobstyther.ga",
    "nobstyther.gq",
    "nobstyther.tk",
    "nobugmail.com",
    "nobulk.com",
    "nobuma.com",
    "noc0szetvvrdmed.cf",
    "noc0szetvvrdmed.ga",
    "noc0szetvvrdmed.gq",
    "noc0szetvvrdmed.ml",
    "noc0szetvvrdmed.tk",
    "noc1tb4bfw.cf",
    "noc1tb4bfw.ga",
    "noc1tb4bfw.gq",
    "noc1tb4bfw.ml",
    "noc1tb4bfw.tk",
    "noclickemail.com",
    "nocodewp.dev",
    "nocontestcommunication.com",
    "nocontexto.com",
    "nocthenet.com",
    "nodebalancer.net",
    "nodeclinecoverage.com",
    "nodeclineinsurance.com",
    "nodehaus.com",
    "nodehaus.net",
    "nodehouse.net",
    "nodehouse.org",
    "nodemix.com",
    "nodenycoverage.com",
    "nodenyinsurance.com",
    "nodepositslotcasino.com",
    "nodepozits.info",
    "nodesauce.com",
    "nodezine.com",
    "nodie.cc",
    "nodnor.club",
    "noedgetest.space",
    "noelflowers.com",
    "noemail.com",
    "noemfasten.com",
    "noexamcoverage.com",
    "nofbi.com",
    "nofocodobrasil.tk",
    "nofok.club",
    "nogblor.online",
    "nogbon.com",
    "nogmailspam.info",
    "nogoku.org",
    "nohallta.cf",
    "nohallta.ga",
    "nohallta.gq",
    "noicd.com",
    "noifeelings.com",
    "noip.today",
    "noisefag.tk",
    "noit14.com",
    "noiuihg2erjkzxhf.cf",
    "noiuihg2erjkzxhf.ga",
    "noiuihg2erjkzxhf.gq",
    "noiuihg2erjkzxhf.ml",
    "noiuihg2erjkzxhf.tk",
    "nojkishop.top",
    "nokiahere.cf",
    "nokiahere.ga",
    "nokiahere.gq",
    "nokiahere.ml",
    "nokiahere.tk",
    "nokiamail.cf",
    "nokiamail.com",
    "nokiamail.ga",
    "nokiamail.gq",
    "nokiamail.ml",
    "nokilaser.cf",
    "nokiratenkpol.tk",
    "nokorweb.com",
    "noktabet.info",
    "noktabet111.com",
    "nola.church",
    "nolabelunlimited.info",
    "nolazada.com",
    "nolemail.ga",
    "nolic.ru",
    "nolikasdop.tk",
    "nolkbacteria.host",
    "nolofilms.info",
    "nologyt.shop",
    "nolpokh.site",
    "nolted.ru",
    "nolvadex.website",
    "nom.za",
    "nomadproject.dev",
    "nomadsretire.com",
    "nomadtraderoute.com",
    "nomail.cf",
    "nomail.ch",
    "nomail.ga",
    "nomail.kerenon.com",
    "nomail.nodns.xyz",
    "nomail.pw",
    "nomail.top",
    "nomail.xl.cx",
    "nomail2me.com",
    "nomailthanks.com",
    "nomailthankyou.com",
    "nomeoutlet.site",
    "nomeucu.ga",
    "nomik.space",
    "nominex.space",
    "nomogeny.xyz",
    "nomor7up.com",
    "nomore-hairloss.info",
    "nomoremeat.online",
    "nomorespamemails.com",
    "nomorkeluar.xyz",
    "nomqllnb.shop",
    "nomsaudiology.com",
    "nomusnik.tk",
    "non-shop-sale.ru",
    "nona5758.com",
    "nonamuda1.com",
    "nonamuda3.com",
    "nonano.site",
    "nonasouq.com",
    "nonbuss.site",
    "noncfl.com",
    "nonciclopedia.cf",
    "nonciclopedia.ga",
    "nonciclopedia.gq",
    "nonconductors.com",
    "noncsc.com",
    "noncteam.com",
    "noncyclical.best",
    "nondtenon.cf",
    "nondtenon.ga",
    "nondtenon.ml",
    "nondtenon.tk",
    "nonegray.info",
    "nonescent.xyz",
    "nonewanimallab.com",
    "nonexisted.nondomain",
    "nongame.best",
    "nonglex.tech",
    "nongzaa.cf",
    "nongzaa.gq",
    "nongzaa.ml",
    "nongzaa.tk",
    "nonlowor.cf",
    "nonlowor.gq",
    "nonlowor.ml",
    "nonom.live",
    "nonpartisan.com",
    "nonprofit-al.org",
    "nonspam.eu",
    "nonspammer.de",
    "nonstopcinema.com",
    "nontmita.cf",
    "nontmita.ga",
    "nontmita.tk",
    "nontransient.best",
    "nonudle.net",
    "nonuserans.rest",
    "nonze.ro",
    "noobermm.tk",
    "noobjs.org",
    "noobswhatelse.com",
    "noodle-club-takeaway.com",
    "noodlesnwraps.com",
    "nooklan.org",
    "noonecandoit.xyz",
    "noopept.store",
    "noos.fr",
    "nootrolovers.shop",
    "nootrolovers.site",
    "nootrolovers.space",
    "nootropicstackblog.xyz",
    "nootropicstudy.xyz",
    "nopecon.org",
    "nopethsijezy.ru",
    "noquestionsaskedinsurance.com",
    "noquestionsaskedlifeinsurance.com",
    "noquierobasura.ga",
    "norabeachclub.com",
    "norbal.org",
    "norbukingdom.online",
    "norcalsecurityca.com",
    "norcurtainmud.website",
    "nordaxon.se",
    "nordlockerbusiness.com",
    "nordpozitronik.ru",
    "noref.in",
    "noreferrer.net",
    "norefusals.info",
    "noreply.fr",
    "norfolkquote.com",
    "norguedeu.cf",
    "norguedeu.gq",
    "norguedeu.ml",
    "norguedeu.tk",
    "norih.com",
    "norika-fujiwara.com",
    "norikomail.com",
    "norishops.site",
    "normalteste.xyz",
    "normasdeinformacionfinanciera.com",
    "normpage.us",
    "norseforce.com",
    "norstil.com",
    "nortedecorrientes.com",
    "north-atlanta-rv-rentals.com",
    "north-user.monster",
    "northadamschamber.com",
    "northbrookcpa.net",
    "northcarolinaultimate.com",
    "northchicagoapartments.com",
    "northdallas-plasticsurgeons.com",
    "northdallashomebuyers.com",
    "northemquest.com",
    "northentr.buzz",
    "northernrescue.kiwi",
    "northfr.xyz",
    "northfro.xyz",
    "northfrow.xyz",
    "northgates.net",
    "northibm.com",
    "northlakenatomas.com",
    "northlibertyblog.com",
    "northmiamibeachapartments.com",
    "northof9equine.com",
    "northofbostonsports.net",
    "northolmstedapartments.com",
    "northroyaltonapartments.com",
    "northscituate.buzz",
    "northshorelaserclinic.com",
    "northshoresecondmortgage.com",
    "northtaranaki.com",
    "northtips.com",
    "northwaybaptistchurch.org",
    "northwesthair.net",
    "northwoodsmmj.com",
    "norules.zone",
    "norwaydata.com",
    "norwaymail.com",
    "norwichfans.com",
    "nos-adasr.ru",
    "nosemail.com",
    "nosh.ml",
    "nosinga.cf",
    "nosinga.gq",
    "nosinga.tk",
    "nosings.com",
    "nosmasderroches.com",
    "nospam.allensw.com",
    "nospam.barbees.net",
    "nospam.dk",
    "nospam.thurstons.us",
    "nospam.wins.com.br",
    "nospam.ze",
    "nospam.ze.tc",
    "nospam2me.com",
    "nospam4.us",
    "nospamfor.us",
    "nospammail.net",
    "nospamme.com",
    "nospammer.ovh",
    "nospamthanks.info",
    "nostockui.com",
    "nostrabirra.com",
    "nostradamus.best",
    "nostrajewellery.xyz",
    "nosuger.coffee",
    "not0k.com",
    "notabackdoor.xyz",
    "notable.de",
    "notapokemon.info",
    "notapokemon.live",
    "notaryaccounting.com",
    "notarymarketing.com",
    "notatempmail.info",
    "notcuttsgifts.com",
    "notcuttshampers.com",
    "notdus.xyz",
    "notebookware.de",
    "noteexpress.press",
    "notemaws.site",
    "noteregales.com",
    "notes.ovh",
    "notesell.ru",
    "noteswithwings.com",
    "notflys.info",
    "notfond.404.mn",
    "nothingtoseehere.ca",
    "notice-booster1.site",
    "notice-cellphone.club",
    "notice-iphone.club",
    "notice-microsoft.com",
    "notice-phone.club",
    "notice-phone1.site",
    "noticiasgospel.net",
    "noticiaswordpress.com",
    "noticiero.press",
    "notif.cf",
    "notif.me",
    "notification-booster.club",
    "notification-cellphone.club",
    "notification-cleaner.club",
    "notification-iphone.club",
    "notification.agency",
    "notification.promo",
    "notifier.app",
    "notion-corp.com",
    "notion.work",
    "notionametf.email",
    "notionignitenegotiation.website",
    "notivsjt0uknexw6lcl.ga",
    "notivsjt0uknexw6lcl.gq",
    "notivsjt0uknexw6lcl.ml",
    "notivsjt0uknexw6lcl.tk",
    "notmail.com",
    "notmail.ga",
    "notmail.gq",
    "notmail.ml",
    "notmailinator.com",
    "notmyemail.tech",
    "notrema.ru",
    "notrnailinator.com",
    "notsharingmy.info",
    "notua.com",
    "notvn.com",
    "notyouagain.com",
    "nountafor.ga",
    "nountafor.ml",
    "nountree.com",
    "nourashop.com",
    "nousavons.online",
    "nousavons.store",
    "nousonderwijs.online",
    "nousurf.space",
    "nouvellakay.com",
    "nouvelles.pro",
    "nov-today.ru",
    "nov-vek.ru",
    "nova-entre.ga",
    "novabrana.sk",
    "novagift.ru",
    "novagun.com",
    "novaivyi.com",
    "novamcleanpsych.com",
    "novastark.ru",
    "novastreams661.xyz",
    "novazil.com",
    "noveltycars.com",
    "novembermovo.com",
    "noveoninternational.com",
    "novidadenobrasil.com",
    "novinki.club",
    "novinkikino2019.ru",
    "novipsao.club",
    "novisad360.info",
    "novmed1.ru",
    "novogireevo.net",
    "novokosino.net",
    "novosti-pro-turizm.ru",
    "novosti-rus.club",
    "novostinfo.ru",
    "novostroika76.ru",
    "novostroiki-moscow.ru",
    "novostroiufa.ru",
    "novostroyka76.ru",
    "novus.mobi",
    "novusvision.net",
    "novusvision.org",
    "novzve.ru",
    "now-fleet.com",
    "now.im",
    "now.mefound.com",
    "nowaittrend.com",
    "noway.pw",
    "noways.ddns.net",
    "nowdrafo.site",
    "nowemail.ga",
    "nowgoals.xyz",
    "nowhere.org",
    "nowheybebe.com",
    "nowheycafe.com",
    "nowheymay.com",
    "nowifizone.com",
    "nowmount.com",
    "nowmymail.com",
    "nowmymail.net",
    "nownaw.ml",
    "nowstates.tk",
    "nowstore19.space",
    "nowtec.ru",
    "nowwin100.com",
    "nowwin13.com",
    "nowwin3.com",
    "nowwin33.com",
    "nowwin37.com",
    "nowwin40.com",
    "nowwin42.com",
    "nowwin49.com",
    "nowwin57.com",
    "nowwin74.com",
    "nowwin77.com",
    "nowwin8.com",
    "nowwin92.com",
    "nowwin94.com",
    "nox.llc",
    "nox88th.com",
    "noyon.poker",
    "noyycolympics.org",
    "nozala-company.ru",
    "np.by",
    "npbulletin.com",
    "npcisthere.monster",
    "npenergyfoundation.org",
    "npf-energetik.ru",
    "npfbw.info",
    "npfd.de",
    "npgzd1.site",
    "npjcby.vip",
    "npltsy.host",
    "npnks.live",
    "npsyw.info",
    "nptzw.info",
    "npug4.us",
    "npv.kr",
    "npv6r1.info",
    "npvea.us",
    "npwfnvfdqogrug9oanq.cf",
    "npwfnvfdqogrug9oanq.ga",
    "npwfnvfdqogrug9oanq.gq",
    "npwfnvfdqogrug9oanq.ml",
    "npwfnvfdqogrug9oanq.tk",
    "npwyh.fun",
    "npxm.xyz",
    "npyjpo.online",
    "npzs.info",
    "nqav95zj0p.kro.kr",
    "nqeq3ibwys0t2egfr.cf",
    "nqeq3ibwys0t2egfr.ga",
    "nqeq3ibwys0t2egfr.gq",
    "nqeq3ibwys0t2egfr.ml",
    "nqeq3ibwys0t2egfr.tk",
    "nqetqos.site",
    "nqftsd.us",
    "nqjht1.site",
    "nqrdq1.us",
    "nqrk.luk2.com",
    "nqvyo4.info",
    "nqwfw.info",
    "nr89.xyz",
    "nrfd9h.us",
    "nrhskhmb6nwmpu5hii.cf",
    "nrhskhmb6nwmpu5hii.ga",
    "nrhskhmb6nwmpu5hii.gq",
    "nrhskhmb6nwmpu5hii.ml",
    "nrhskhmb6nwmpu5hii.tk",
    "nrmlresearch.ru",
    "nrnvac.site",
    "nroc2mdfziukz3acnf.cf",
    "nroc2mdfziukz3acnf.ga",
    "nroc2mdfziukz3acnf.gq",
    "nroc2mdfziukz3acnf.ml",
    "nroc2mdfziukz3acnf.tk",
    "nroevi.rest",
    "nrwxw.info",
    "nrzrw.info",
    "ns12qg.us",
    "ns21.xyz",
    "ns2dxp.us",
    "ns4.website",
    "ns4veh.us",
    "nsabdev.com",
    "nsacademy.info",
    "nsadvr.site",
    "nsaking.de",
    "nsalevip.info",
    "nsandu.com",
    "nsawsvedq.shop",
    "nsbwsgctktocba.cf",
    "nsbwsgctktocba.ga",
    "nsbwsgctktocba.gq",
    "nsbwsgctktocba.ml",
    "nsbwsgctktocba.tk",
    "nscoy.com",
    "nshgxx.com",
    "nshoesfirst.info",
    "nshqw.info",
    "nsjcxs.tokyo",
    "nsk1vbz.cf",
    "nsk1vbz.ga",
    "nsk1vbz.gq",
    "nsk1vbz.ml",
    "nsk1vbz.tk",
    "nslpck.us",
    "nslrw.info",
    "nsn22.com",
    "nsoreds.shop",
    "nsqcw.info",
    "nssa.org.zw",
    "nsufllibguides.best",
    "nsvcb.us",
    "nsw-flag.info",
    "nswmartialarts.com",
    "nt6868.org",
    "ntb9oco3otj3lzskfbm.cf",
    "ntb9oco3otj3lzskfbm.ga",
    "ntb9oco3otj3lzskfbm.gq",
    "ntb9oco3otj3lzskfbm.ml",
    "ntb9oco3otj3lzskfbm.tk",
    "ntc.keio.ac.jp",
    "ntdx.pw",
    "ntdx.xyz",
    "ntegelan.cf",
    "ntegelan.ga",
    "ntelos.net",
    "nteltec.com",
    "nterdawebs.cf",
    "nterdawebs.ga",
    "nterdawebs.gq",
    "ntfifhzgy.shop",
    "ntflx.store",
    "ntfqw.info",
    "ntgyeyme.shop",
    "nthanthe.shop",
    "nthentha.shop",
    "nthings.best",
    "ntilboimbyt.ga",
    "ntilboimbyt.gq",
    "ntilboimbyt.ml",
    "ntilboimbyt.tk",
    "ntilsibi.cf",
    "ntilsibi.ga",
    "ntkah7.com",
    "ntlhelp.net",
    "ntllma3vn6qz.cf",
    "ntllma3vn6qz.ga",
    "ntllma3vn6qz.gq",
    "ntllma3vn6qz.ml",
    "ntllma3vn6qz.tk",
    "ntlshopus.com",
    "ntlworld.com",
    "ntnrw.info",
    "ntscan.com",
    "ntsj8vn8ssedt.xyz",
    "ntt.gotdns.ch",
    "ntub.cf",
    "ntudofutluxmeoa.cf",
    "ntudofutluxmeoa.ga",
    "ntudofutluxmeoa.gq",
    "ntudofutluxmeoa.ml",
    "ntudofutluxmeoa.tk",
    "ntutnvootgse.cf",
    "ntutnvootgse.ga",
    "ntutnvootgse.gq",
    "ntutnvootgse.ml",
    "ntutnvootgse.tk",
    "ntuv4sit2ai.cf",
    "ntuv4sit2ai.ga",
    "ntuv4sit2ai.gq",
    "ntuv4sit2ai.ml",
    "ntuv4sit2ai.tk",
    "ntvsportbet.com",
    "nty5upcqq52u3lk.cf",
    "nty5upcqq52u3lk.ga",
    "nty5upcqq52u3lk.gq",
    "nty5upcqq52u3lk.ml",
    "nty5upcqq52u3lk.tk",
    "ntzdvaon.shop",
    "nu-costs.com",
    "nuacasinonest.ru",
    "nualloydpactive.com",
    "nuamulet.ru",
    "nub3zoorzrhomclef.cf",
    "nub3zoorzrhomclef.ga",
    "nub3zoorzrhomclef.gq",
    "nub3zoorzrhomclef.ml",
    "nub3zoorzrhomclef.tk",
    "nubescontrol.com",
    "nucleoescuela.com",
    "nucor.ru",
    "nudayhuq.space",
    "nudgegame.net",
    "nudinar.net",
    "nuevaagroindustriasdelnorte.com",
    "nuevomail.com",
    "nufc.xyz",
    "nujsixm.xyz",
    "nukahome.com",
    "nuliferecords.com",
    "nuligepe.site",
    "null.k3vin.net",
    "null.net",
    "nullbox.info",
    "nulledsec.club",
    "nullmachine.org",
    "nullscriptz.online",
    "nullwasp.net",
    "nultxb.us",
    "numail.org",
    "numandfio.gq",
    "numberclimbing.xyz",
    "numbersstationmovie.com",
    "numbobulator.com",
    "numenism.xyz",
    "numep.ru",
    "numericable.fr",
    "numerology.zone",
    "numikrest.cf",
    "numitas.ga",
    "numitas.gq",
    "nummbereins.xyz",
    "nummumcanada.com",
    "numoika.ml",
    "numunemektebi.org",
    "numutore63.bid",
    "numwert.tk",
    "nunagom.shop",
    "nunscore.com",
    "nunung.cf",
    "nunungcantik.ga",
    "nunungnakal.ga",
    "nunungsaja.cf",
    "nuny.ru",
    "nuo.co.kr",
    "nuo.kr",
    "nuovi-incontri.com",
    "nupagadi.ru",
    "nuprice.co",
    "nupurer.ru",
    "nuqhvb1lltlznw.cf",
    "nuqhvb1lltlznw.ga",
    "nuqhvb1lltlznw.gq",
    "nuqhvb1lltlznw.ml",
    "nuqhvb1lltlznw.tk",
    "nur-fuer-spam.de",
    "nuras.site",
    "nurbahar.com",
    "nurdea.biz",
    "nurdea.com",
    "nurdea.net",
    "nurdead.biz",
    "nurdeal.biz",
    "nurdeal.com",
    "nurdeas.biz",
    "nurdeas.com",
    "nurdintv.com",
    "nurefy.info",
    "nurfuerspam.de",
    "nurotohaliyikama.xyz",
    "nurpharmacy.com",
    "nursalive.com",
    "nurseryshop.live",
    "nursinghomecareinformation.com",
    "nursinghomecarenearme.com",
    "nursinkfky.space",
    "nursultancity.info",
    "nurturemeal.site",
    "nurturingrecipes.com",
    "nuruvi.com",
    "nus.edu.sg",
    "nusaas.com",
    "nusamart.site",
    "nussc.com",
    "nustudiekiezen.online",
    "nut-cc.nut.cc",
    "nut.cc",
    "nutaart.ru",
    "nutcc.nut.cc",
    "nutimaintegrative.com",
    "nutimaintegrativehealth.com",
    "nutimamed.com",
    "nutimamedicine.com",
    "nutimanaturalhealth.com",
    "nutimanaturopathicmedicine.com",
    "nutimand.com",
    "nutodaynews.site",
    "nutpa.net",
    "nutravie.org",
    "nutremom.com",
    "nutrice.xyz",
    "nutriciademo.com",
    "nutrifood.us",
    "nutrinesweets.com",
    "nutrition-chi.online",
    "nutritionalpsychiatry.org",
    "nutritionreporter.com",
    "nutrizin.com",
    "nutroastingmachine.net",
    "nuts2trade.com",
    "nutssocrazy.com",
    "nuuo3n.us",
    "nuvast.com",
    "nuvexcloud.com",
    "nuvi.site",
    "nuvohu.info",
    "nuvse.com",
    "nuxuzi.info",
    "nuzee.com",
    "nuzhnaeda18.ru",
    "nuzuoutlet.site",
    "nvapplelab.com",
    "nvb467sgs.cf",
    "nvb467sgs.ga",
    "nvb467sgs.gq",
    "nvb467sgs.ml",
    "nvb467sgs.tk",
    "nvbxenro.shop",
    "nvc-e.com",
    "nvcc.org",
    "nvce.net",
    "nvenuntgeg.cf",
    "nvenuntgeg.gq",
    "nvenuntgeg.tk",
    "nvgf3r56raaa.cf",
    "nvgf3r56raaa.ga",
    "nvgf3r56raaa.gq",
    "nvgf3r56raaa.ml",
    "nvgf3r56raaa.tk",
    "nvhalfpricelistings.com",
    "nvinsxnv.shop",
    "nvjohndeere.com",
    "nvn1024.us",
    "nvnav.com",
    "nvnav.net",
    "nvnav.us",
    "nvnestle.com",
    "nvntv.top",
    "nvntv.us",
    "nvnvideo.net",
    "nvnvideo.us",
    "nvpdq3.site",
    "nvr.services",
    "nvr7uy.info",
    "nvunitedfc.com",
    "nvuti.studio",
    "nvv1vcfigpobobmxl.cf",
    "nvv1vcfigpobobmxl.gq",
    "nvv1vcfigpobobmxl.ml",
    "nvw10v.us",
    "nvwang58.com",
    "nw7cxrref2hjukvwcl.cf",
    "nw7cxrref2hjukvwcl.ga",
    "nw7cxrref2hjukvwcl.gq",
    "nw7cxrref2hjukvwcl.ml",
    "nw7cxrref2hjukvwcl.tk",
    "nw7tnm.us",
    "nwautoleather.com",
    "nwcqw.info",
    "nwcvzkhf.shop",
    "nwds-support.com",
    "nweenweh.shop",
    "nwehnwee.shop",
    "nwesmail.com",
    "nwldx.com",
    "nwldx.net",
    "nwlnpy.online",
    "nwmhsc.us",
    "nwmob.site",
    "nwpi.email",
    "nwqmiw.us",
    "nwrailnews.org",
    "nwrealestateroots.com",
    "nwser.us",
    "nwsgrps.com",
    "nwtsk5.com",
    "nwtvqc.us",
    "nwufewum9kpj.gq",
    "nwumkcte.shop",
    "nwyorkpass.com",
    "nwytg.com",
    "nwytg.net",
    "nwz6q5.us",
    "nx1.de",
    "nx365.net",
    "nxaipannationalpark.com",
    "nxbclg.us",
    "nxbrasil.net",
    "nxbxni.us",
    "nxdata.site",
    "nxdgrll3wtohaxqncsm.cf",
    "nxdgrll3wtohaxqncsm.gq",
    "nxdgrll3wtohaxqncsm.ml",
    "nxdgrll3wtohaxqncsm.tk",
    "nxeswavyk6zk.cf",
    "nxeswavyk6zk.ga",
    "nxeswavyk6zk.gq",
    "nxeswavyk6zk.ml",
    "nxeswavyk6zk.tk",
    "nxewh1.stream",
    "nxfikjjbg.shop",
    "nxgnsoftwaresolutions.com",
    "nxgwr24fdqwe2.cf",
    "nxgwr24fdqwe2.ga",
    "nxgwr24fdqwe2.gq",
    "nxgwr24fdqwe2.ml",
    "nxgwr24fdqwe2.tk",
    "nxhji1.site",
    "nxhlgt.com",
    "nxllw.info",
    "nxm3zar0d.xyz",
    "nxpeakfzp5qud6aslxg.cf",
    "nxpeakfzp5qud6aslxg.ga",
    "nxpeakfzp5qud6aslxg.gq",
    "nxpeakfzp5qud6aslxg.ml",
    "nxpeakfzp5qud6aslxg.tk",
    "nxt.ru",
    "nxy73j.us",
    "ny-auto-sterilization.com",
    "ny-zp.com",
    "ny.com",
    "ny3mlv.us",
    "ny7.me",
    "nya365.com",
    "nya5.com",
    "nyaatv.com",
    "nyabook.com",
    "nyagan-airport.ru",
    "nyahome.com",
    "nyahvkge2zang.xyz",
    "nyalist.com",
    "nyamail.com",
    "nyanime.gq",
    "nyanote.com",
    "nyapic.com",
    "nyatempto.cf",
    "nyatempto.ga",
    "nyatempto.gq",
    "nyattorneys.org",
    "nyaweb.com",
    "nyawiki.com",
    "nyayou.com",
    "nybbl12.com",
    "nybce.com",
    "nybella.com",
    "nyc-md.com",
    "nyc.com",
    "nyc.rr.com",
    "nycap.rr.com",
    "nyccaner.cf",
    "nyccaner.ga",
    "nyccaner.ml",
    "nyccaner.tk",
    "nyccoronavirusbankruptcy.com",
    "nycdatascienceacademy.com",
    "nychealthtech.com",
    "nycmail.com",
    "nyconsale.com",
    "nycthing.com",
    "nyctoursdiscounted.com",
    "nyctoursonsale.com",
    "nycvpn.com",
    "nycwebsite.design",
    "nydfw.info",
    "nyeoa.live",
    "nyfashionphotographers.com",
    "nygmkv.icu",
    "nyhalfpricedlistings.com",
    "nyhalfpricelisting.com",
    "nyhetsbrev.xyz",
    "nyhjsydr.shop",
    "nyic.nyc",
    "nyikanationalpark.org",
    "nyiwreakun.ga",
    "nyiwreakun.gq",
    "nyjd.xyz",
    "nylonbrush.biz",
    "nylonbrush.us",
    "nylonbrushes.biz",
    "nylonbrushes.org",
    "nylonbrushes.us",
    "nym.hush.com",
    "nymathacademy.org",
    "nyne.site",
    "nyoliveoil.org",
    "nyoregan09brex.ml",
    "nyovur.us",
    "nypato.com",
    "nypdchange.net",
    "nypdchange.org",
    "nypinterest.com",
    "nypost.best",
    "nyrmusic.com",
    "nyscengage.com",
    "nysmail.com",
    "nyter44.website",
    "nyusul.com",
    "nywcmiftn8hwhj.cf",
    "nywcmiftn8hwhj.ga",
    "nywcmiftn8hwhj.gq",
    "nywcmiftn8hwhj.ml",
    "nywcmiftn8hwhj.tk",
    "nyxc1.us",
    "nz-post.press",
    "nz11.com",
    "nzach4.info",
    "nzb.fish",
    "nzb.land",
    "nzbeez.com",
    "nzdigitalmarketingpodcast.com",
    "nzfadz.us",
    "nzids.com",
    "nzkfgb.site",
    "nzmotorbikes.com",
    "nzmymg9aazw2.cf",
    "nzmymg9aazw2.ga",
    "nzmymg9aazw2.gq",
    "nzmymg9aazw2.ml",
    "nzmymg9aazw2.tk",
    "nzntdc4dkdp.cf",
    "nzntdc4dkdp.ga",
    "nzntdc4dkdp.gq",
    "nzntdc4dkdp.ml",
    "nzntdc4dkdp.tk",
    "nzoomail.com",
    "nztiea.site",
    "nzv0rz.us",
    "nzvjv.live",
    "o-128.asia",
    "o-amz.xyz",
    "o-e-z.ru",
    "o-kee-dundrum.com",
    "o-nalogah.ru",
    "o-pribaltike.ru",
    "o-response.com",
    "o-taxi31.ru",
    "o-tay.com",
    "o-tonarum.ru",
    "o.cat",
    "o.cfo2go.ro",
    "o.idigo.org",
    "o.muti.ro",
    "o.oai.asia",
    "o.opendns.ro",
    "o.spamtrap.ro",
    "o000.ml",
    "o060bgr3qg.com",
    "o0em7j.us",
    "o0i.es",
    "o128.us",
    "o13mbldrwqwhcjik.cf",
    "o13mbldrwqwhcjik.ga",
    "o13mbldrwqwhcjik.gq",
    "o13mbldrwqwhcjik.ml",
    "o13mbldrwqwhcjik.tk",
    "o1775.com",
    "o1z.ru",
    "o2.co.uk",
    "o2.pl",
    "o2020-au.best",
    "o2020-ay.best",
    "o2020-ek.best",
    "o2020-ow.best",
    "o22.info",
    "o2gr8p.us",
    "o2hkcb.us",
    "o2m.org",
    "o2stk.org",
    "o32c.com",
    "o3dkxw.best",
    "o3enzyme.com",
    "o3j5hv.us",
    "o3vd6blm73xkgtd.xyz",
    "o3vgl9prgkptldqoua.cf",
    "o3vgl9prgkptldqoua.ga",
    "o3vgl9prgkptldqoua.gq",
    "o3vgl9prgkptldqoua.ml",
    "o3vgl9prgkptldqoua.tk",
    "o473ufpdtd.ml",
    "o473ufpdtd.tk",
    "o48ok.com",
    "o4pmme4o0r6jk48.xyz",
    "o4zkthf48e46bly.cf",
    "o4zkthf48e46bly.ga",
    "o4zkthf48e46bly.gq",
    "o4zkthf48e46bly.ml",
    "o4zkthf48e46bly.tk",
    "o5b0hg64wmgepnj.xyz",
    "o6hcvq.online",
    "o6liak.us",
    "o7665.com",
    "o78qp.com",
    "o7i.net",
    "o7mbr0.us",
    "o7t2auk8msryc.cf",
    "o7t2auk8msryc.ga",
    "o7t2auk8msryc.gq",
    "o7t2auk8msryc.ml",
    "o7t2auk8msryc.tk",
    "o7vvj8.us",
    "o87fn.com",
    "o88s9d.site",
    "o8ih.us",
    "o8oedrrev40d5rg.xyz",
    "o8t30wd3pin6.cf",
    "o8t30wd3pin6.ga",
    "o8t30wd3pin6.gq",
    "o8t30wd3pin6.ml",
    "o8t30wd3pin6.tk",
    "o9i.space",
    "oa5lqy.com",
    "oahudoctorse.info",
    "oai.asia",
    "oaipofgs.shop",
    "oakbrookofficecleaning.com",
    "oakfirepizzeria.com",
    "oakhdu.info",
    "oakjestfood.website",
    "oakland4d.com",
    "oakland4d.info",
    "oakland4d.net",
    "oakland4d.org",
    "oaklandas-fan.com",
    "oaklandhairsalons.com",
    "oaklandlotto.org",
    "oakleyfancyflea.com",
    "oakmannersnew.website",
    "oakmountainholdings.com",
    "oakmountaintech.com",
    "oakparkattorneys.com",
    "oakpatch.org",
    "oaksw.com",
    "oakwoodtrading.com",
    "oala11.host",
    "oalc.ru",
    "oallenlj.com",
    "oalsp.com",
    "oao-aso.ru",
    "oasansor.com",
    "oasessystem.com",
    "oath.com",
    "oathijs.info",
    "oatmealsshop.life",
    "oaudienceij.com",
    "oayjx.live",
    "ob145.top",
    "ob5d31gf3whzcoo.cf",
    "ob5d31gf3whzcoo.ga",
    "ob5d31gf3whzcoo.gq",
    "ob5d31gf3whzcoo.ml",
    "ob5d31gf3whzcoo.tk",
    "ob5ml80wd1v83sx.xyz",
    "ob7eskwerzh.cf",
    "ob7eskwerzh.ga",
    "ob7eskwerzh.gq",
    "ob7eskwerzh.ml",
    "ob7eskwerzh.tk",
    "obane.org",
    "obateksim.info",
    "obatmata.co",
    "obczqk.site",
    "obdeni.cf",
    "obdeni.gq",
    "obdeni.ml",
    "obedrulit.ru",
    "obelisk4000.cf",
    "obelisk4000.ga",
    "obelisk4000.gq",
    "obenilac.com",
    "oberegzamok.ru",
    "obesesto.icu",
    "obeseunio.xyz",
    "obfuscumlc.space",
    "obfusko.com",
    "obitoto.com",
    "obitoto2.com",
    "obitoto88.com",
    "obizh.com",
    "object.space",
    "objectmail.com",
    "objk.site",
    "oblate.site",
    "obleceni-kenvelo.info",
    "obmaiqiu.com",
    "obmen-realty.ru",
    "obmw.ru",
    "obo.kr",
    "obobbo.com",
    "oboigroup.ru",
    "obol.space",
    "oboostdz.com",
    "oboriza.space",
    "oborudovanieizturcii.ru",
    "obovseminfo.ru",
    "obox.zone",
    "oboymail.ga",
    "oboz-digital.ru",
    "obr60.space",
    "obraslivres.com",
    "obraz-i-krasota.ru",
    "obrezinim.ru",
    "obrimlesescoles.cat",
    "obriuescoles.cat",
    "observer-timesubtle-flairvitality-press.com",
    "obsoft.ru",
    "obtainips.com",
    "obtqadqunonkk1kgh.cf",
    "obtqadqunonkk1kgh.ga",
    "obtqadqunonkk1kgh.gq",
    "obtqadqunonkk1kgh.ml",
    "obtqadqunonkk1kgh.tk",
    "obtruncate.xyz",
    "obuchenie-zarabotku.online",
    "obufwzem.xyz",
    "obuv-stoks.ru",
    "obvapos.cf",
    "obvapos.gq",
    "obvapos.ml",
    "obvapos.tk",
    "obxpestcontrol.com",
    "obychnaya-zhenshchina.ru",
    "obzor-it.ru",
    "obzornakurs.ru",
    "oc810.site",
    "ocamerapeak.shop",
    "occand.ru",
    "occo-paris.com",
    "ocdvenpe.cf",
    "ocdvenpe.ga",
    "ocdvenpe.tk",
    "oceancares.xyz",
    "oceanchinesefood.com",
    "oceanevineyard.com",
    "oceanfree.net",
    "oceangardenvillashoa.com",
    "oceanpalacechinese.com",
    "oceanplanetchannel.com",
    "oceanscienceanalytics.org",
    "oceansidenailsalons.com",
    "oceansofwaves.com",
    "oceansummerlinagreenblog.site",
    "oceantly.info",
    "oceantly.us",
    "oceanviewtobago.com",
    "ocebet.mobi",
    "ocebet.org",
    "ocenka-krym.ru",
    "ocenkalipeck.ru",
    "oceqq.biz",
    "ochakovo.net",
    "ochkimoscow.ru",
    "ochlocracy.site",
    "ocinjuryattorneys.com",
    "ocitdoctors.com",
    "ocksweet.online",
    "ocktogram.com",
    "ocl-ltd.com",
    "ocn.gold",
    "ocn.ne.jp",
    "ocna.info",
    "ocnegib.cf",
    "ocnegib.ga",
    "ocnegib.tk",
    "ocotbukanmain.club",
    "ocqduuqha.shop",
    "ocqxnxnoox.icu",
    "octagon-projects.info",
    "octagon-projects.org",
    "octagonn.club",
    "octalmoltenquasi.site",
    "octetresearch.info",
    "octobermovo.com",
    "octolive.xyz",
    "octomba.info",
    "octopoda.ru",
    "octopoos.news",
    "octopoos.social",
    "octopushome.ru",
    "octowall.com",
    "octoyo.xyz",
    "oculist.space",
    "ocwrqnsbv.shop",
    "od21gwnkte.cf",
    "od21gwnkte.ga",
    "od21gwnkte.gq",
    "od21gwnkte.ml",
    "od21gwnkte.tk",
    "od6tdo.us",
    "od9b0vegxj.cf",
    "od9b0vegxj.ga",
    "od9b0vegxj.gq",
    "od9b0vegxj.ml",
    "od9b0vegxj.tk",
    "odaafariste.org",
    "odatv19.com",
    "odatv24.com",
    "odatv26.com",
    "odatv34.com",
    "odatv36.com",
    "odatv40.com",
    "odauco.website",
    "odavissza.hu",
    "odaymail.com",
    "oddcriticalnod.website",
    "oddfactor.net",
    "oddpost.com",
    "oddsbucket.com",
    "oddsends.se",
    "oddsmma.se",
    "oddtheory.com",
    "odem.com",
    "odesentupidor.com",
    "odessabet.org",
    "odessabetgirisadresi.com",
    "odessabetsikayet.com",
    "odezhdu-zhenshinam.ru",
    "odin.city",
    "odishakenduleaves.com",
    "odmail.com",
    "odnkonxt.shop",
    "odnolube.ru",
    "odnorazkacatalog.ru",
    "odnorazovoe.ru",
    "odnxkkxi.shop",
    "odtcabling.org",
    "oduemy.tokyo",
    "oduyzrp.com",
    "odyssey.gold",
    "odysseyaerocell.com",
    "odysseyholdingsinc.com",
    "oe1f42q.com",
    "oeai.com",
    "oechzm.site",
    "oecs-systems-international.com",
    "oekakies.com",
    "oeltzl.site",
    "oem5w6.us",
    "oembrush.us",
    "oembrushes.biz",
    "oembrushes.org",
    "oembrushes.us",
    "oemlibidoxis.icu",
    "oempleo.com",
    "oemzpa.cf",
    "oepia.com",
    "oeppeo.com",
    "oerpub.org",
    "oeu4sdyoe7llqew0bnr.cf",
    "oeu4sdyoe7llqew0bnr.ga",
    "oeu4sdyoe7llqew0bnr.gq",
    "oeu4sdyoe7llqew0bnr.ml",
    "oeu4sdyoe7llqew0bnr.tk",
    "of-maculardegeneration-ok.live",
    "of-maculardegenerations-ok.live",
    "of16v.us",
    "of934.site",
    "ofansifbet2.com",
    "ofauseniorlivingsok.live",
    "ofboxcursos.com",
    "ofc-migrate3.com",
    "ofc-migrate4.com",
    "ofc-migrate5.com",
    "ofcstripe.com",
    "ofe0vj.us",
    "ofer-eitan.biz",
    "ofer-eitan.net",
    "ofer-eitan.org",
    "ofereitan.xyz",
    "ofertebune.info",
    "oferteo.org",
    "off-keys.ru",
    "offclktrak.com",
    "offense.red",
    "offensive.red",
    "offer-like-seasons.ru",
    "offerdne.com",
    "offerinvestteam.ru",
    "offersmartlinks.xyz",
    "offertemobiliari.net",
    "offgrid-house.com",
    "office-dateien.de",
    "office-email.com",
    "office-on-the.net",
    "office.ms365.ml",
    "officebotics.com",
    "officedomain.com",
    "officeglossary.com",
    "officemalaga.com",
    "officespacemohanestate.com",
    "officesupport.fun",
    "offichoss.site",
    "official-bears-of-roses.ru",
    "official-iconed.website",
    "official-pomsies.ru",
    "official-site-admiralx.xyz",
    "official-sunveno.ru",
    "official-trailer.ru",
    "official.republican",
    "officialairpods.ru",
    "officialbigo.com",
    "officialbrands.shop",
    "officialdiesel10bar.ru",
    "officialdistributor.shop",
    "officialfentybeauty.ru",
    "officialh.tech",
    "officialjeep.ru",
    "officiallifans.ru",
    "officialmovieclub.com",
    "officialngentot.cf",
    "officialngentot.ga",
    "officialngentot.gq",
    "officialngentot.ml",
    "officialngentot.tk",
    "officialnhlstar.com",
    "officialphotoshop.com",
    "officialrolex.ru",
    "officialsnapfish.com",
    "officialstore-ifans.ru",
    "officialstoremonica.com",
    "officialtolol.ga",
    "officialwatchv8.ru",
    "offisgossip.com",
    "offreendirect.xyz",
    "offroadwarrior.com",
    "offsavi.shop",
    "offsetmail.com",
    "offsetprint.cloud",
    "offshore-proxies.net",
    "offshorebookies.com",
    "offshorepa.com",
    "offsidegaming.info",
    "offsidegaming.net",
    "offtherecordmail.com",
    "offthewalt.com",
    "offwhitesale.xyz",
    "ofgmail.com",
    "ofhyh.live",
    "oficcial-server-v.ru",
    "oficialnii-sait-zerkalo.ru",
    "oficinadobitcoin.com",
    "ofmuse.net",
    "ofosp.xyz",
    "ofrnj.us",
    "ofstanimmi.site",
    "ofth3crumrhuw.cf",
    "ofth3crumrhuw.ga",
    "ofth3crumrhuw.gq",
    "ofth3crumrhuw.ml",
    "ofth3crumrhuw.tk",
    "ofvn.com",
    "ofwlvh.tokyo",
    "ofzsy5.us",
    "og107lso1tgkd3h.xyz",
    "og7nz.us",
    "oga.bet",
    "ogabet.casino",
    "oganijuana.com",
    "ogcdhkvdw.shop",
    "ogclone.com",
    "ogdencondos.com",
    "oghilj.com",
    "oginski.ru",
    "oginskiy.ru",
    "oginskji.ru",
    "oginskyi.ru",
    "ogirisim.xyz",
    "ogirock.website",
    "ogktbh.site",
    "ogmdqv.accountant",
    "ogmwk.us",
    "ogonma-kaima.ru",
    "ogorodah-rossii.ru",
    "ogorodnikpro.ru",
    "ogretio.com",
    "ogrlaw.net",
    "ogrn2.ru",
    "ogronompro.ru",
    "oguzhansusam.xyz",
    "oguzkaanbekci.xyz",
    "ogxservices.com",
    "oh.rr.com",
    "ohaaa.de",
    "ohauszho.shop",
    "ohdiker.news",
    "ohdomain.xyz",
    "ohhalfpricedlisting.com",
    "ohhmyohhmy.com",
    "ohhqq.club",
    "ohhqq.life",
    "ohi.tw",
    "ohins.info",
    "ohinspection.com",
    "ohiogems.com",
    "ohioonational.com",
    "ohioticketpayments.xyz",
    "ohk.life",
    "ohkogtsh.ga",
    "ohkogtsh.ml",
    "ohkrn.us",
    "ohmb6j.us",
    "ohmbet.biz",
    "ohmbet.org",
    "ohmbet.poker",
    "ohmbet.soccer",
    "ohmbet.us",
    "ohmbetcommunity.com",
    "ohmbetmma.com",
    "ohmbetodds.se",
    "ohmyaffiliates.com",
    "ohmyholyeco.xyz",
    "ohmytalents.co",
    "ohmytechnologies.com",
    "ohneworte.love",
    "ohpmao.com",
    "ohrana-biysk.ru",
    "ohrzi.us",
    "ohsdirect.net",
    "ohsjgkqur.shop",
    "ohsnap.us",
    "ohsu.edu",
    "ohuyln.us",
    "ohw88.com",
    "ohwonder.fun",
    "ohwonders.fun",
    "oi.com.br",
    "oibo.xyz",
    "oicexchange.com",
    "oida.icu",
    "oidzc1zgxrktxdwdkxm.cf",
    "oidzc1zgxrktxdwdkxm.ga",
    "oidzc1zgxrktxdwdkxm.gq",
    "oidzc1zgxrktxdwdkxm.ml",
    "oidzc1zgxrktxdwdkxm.tk",
    "oiibp.site",
    "oiio.ltd",
    "oiio.tech",
    "oiiux.live",
    "oiizz.com",
    "oikrach.com",
    "oil-and-cheese.ru",
    "oil360.ru",
    "oilgazinvest.ru",
    "oiljje.com",
    "oilkem.ru",
    "oilpatchasia.com",
    "oilpatchasiajobs.com",
    "oils4g.info",
    "oiml0m.us",
    "oing.cf",
    "oink8jwx7sgra5dz.cf",
    "oink8jwx7sgra5dz.ga",
    "oink8jwx7sgra5dz.gq",
    "oink8jwx7sgra5dz.ml",
    "oink8jwx7sgra5dz.tk",
    "ointeractive.net",
    "oinvest.capetown",
    "oinvest.durban",
    "oinvest.joburg",
    "oiplikai.ml",
    "oiqas.com",
    "oiunpt.shop",
    "oiwiqe.info",
    "oiwkxms.xyz",
    "oizxwhddxji.cf",
    "oizxwhddxji.ga",
    "oizxwhddxji.gq",
    "oizxwhddxji.ml",
    "oizxwhddxji.tk",
    "oj2dfa.us",
    "ojdad.us",
    "ojdh71ltl0hsbid2.cf",
    "ojdh71ltl0hsbid2.ga",
    "ojdh71ltl0hsbid2.gq",
    "ojdh71ltl0hsbid2.ml",
    "ojdh71ltl0hsbid2.tk",
    "ojekqq.com",
    "ojg2.icu",
    "ojikfw.com",
    "ojl16bxv.fun",
    "ojnbqjtc.shop",
    "ojolbet.com",
    "ojooo.com",
    "ojosambat.cf",
    "ojosambat.ml",
    "ojpvym3oarf3njddpz2.cf",
    "ojpvym3oarf3njddpz2.ga",
    "ojpvym3oarf3njddpz2.gq",
    "ojpvym3oarf3njddpz2.ml",
    "ojpvym3oarf3njddpz2.tk",
    "ojrcdzkbf.shop",
    "ojsflnbu.shop",
    "ojypfszj.shop",
    "ok-body.pw",
    "ok-play.ru",
    "ok.kz",
    "ok.net",
    "ok.ru",
    "ok1756.com",
    "ok420dr.com",
    "ok4ov3.us",
    "ok8037.com",
    "ok888.site",
    "ok9227.com",
    "okabashidonerkebabmadrid.com",
    "okakambe.com",
    "okalexandria.com",
    "okanchorage.com",
    "okarlington.com",
    "okathens.com",
    "okatlanta.com",
    "okauseniorlivingsok.live",
    "okaybet11.com",
    "okaybet169.com",
    "okaybet22.com",
    "okaybet248.com",
    "okaybet369.com",
    "okaybet44.com",
    "okaybet456.com",
    "okaybet55.com",
    "okaybet777.com",
    "okaybet888.com",
    "okays378su.online",
    "okbackpainreliefok.live",
    "okbank.com",
    "okbatonrogue.com",
    "okbayarea.com",
    "okbiloxi.com",
    "okbimini.com",
    "okbismarck.com",
    "okbody.pw",
    "okbradenton.com",
    "okbrookhaven.com",
    "okcancun.com",
    "okcanton.com",
    "okcarmel.com",
    "okcasper.com",
    "okcatskills.com",
    "okcharleston.com",
    "okchattanooga.com",
    "okcincinnati.com",
    "okclearwater.com",
    "okclprojects.com",
    "okcoloradosprings.com",
    "okcoronado.com",
    "okcostarica.com",
    "okcovington.com",
    "okcozumel.com",
    "okculvercity.com",
    "okdallas.com",
    "okdayton.com",
    "okdelmar.com",
    "okdelray.com",
    "okdenver.com",
    "okdominican.com",
    "okean-doors.ru",
    "okece.xyz",
    "okedison.com",
    "okeek.live",
    "okelpaso.com",
    "okeoceapasajaoke.com",
    "okeyeglassesok.live",
    "okeyif.xyz",
    "okezone.bid",
    "okfargo.com",
    "okfonow.site",
    "okfortlauderdale.com",
    "okfoxborough.com",
    "okfreeport.com",
    "okgreensboro.com",
    "okhalfpricedlistings.com",
    "okhalfpricelistings.com",
    "okharrisburg.com",
    "okhempstead.com",
    "okhonolulu.com",
    "okhuman.com",
    "okhykxeew.shop",
    "okinawamealprep.club",
    "okkansascity.com",
    "okkendall.com",
    "okla.ltd",
    "oklahomacityquote.com",
    "oklakeland.com",
    "oklaredo.com",
    "oklavastore.com",
    "oklittleton.com",
    "oklogu.tk",
    "oklosalamos.com",
    "oklosangeles.com",
    "oklubbock.com",
    "okmacon.com",
    "okmad.com",
    "okmagic.com",
    "okmarthasvineyard.com",
    "okmiamilakes.com",
    "okmilton.com",
    "okmodesto.com",
    "okmontevideo.com",
    "okmoseslake.com",
    "oknaest.ru",
    "okname.net",
    "oknantucket.com",
    "oknapa.com",
    "oknapai.ru",
    "oknaprima.ru",
    "okndrt2ebpshx5tw.cf",
    "okndrt2ebpshx5tw.ga",
    "okndrt2ebpshx5tw.gq",
    "okndrt2ebpshx5tw.ml",
    "okndrt2ebpshx5tw.tk",
    "oknorthlasvegas.com",
    "okocala.com",
    "okoceancity.com",
    "okokay.xyz",
    "okoxnard.com",
    "okoysterbay.com",
    "okpanama.com",
    "okparkcity.com",
    "okpawtucket.com",
    "okplatya.ru",
    "okpoconos.com",
    "okportland.com",
    "okprinceton.com",
    "okpuntacana.com",
    "okqm.com",
    "okredondobeach.com",
    "okredwoodcity.com",
    "okrent.us",
    "okriodejaneiro.com",
    "okriyadh.com",
    "okrochester.com",
    "okrockford.com",
    "oksalisbury.com",
    "oksaltlakecity.com",
    "oksanantonio.com",
    "oksanclemente.com",
    "oksanjose.com",
    "oksantaana.com",
    "oksantamonica.com",
    "oksantodomingo.com",
    "okseattle.com",
    "oksihum.com",
    "okspringfield.com",
    "okstamford.com",
    "okstatenisland.com",
    "okstlouis.com",
    "oksttropez.com",
    "oksuvsjet.live",
    "oksuvsone.live",
    "oksuvstop.live",
    "oktai.ru",
    "oktempe.com",
    "oktoscrape.com",
    "oktrips.com",
    "okujoyun.pro",
    "okuk.com",
    "okuldanismanlik.xyz",
    "okuldokuman.online",
    "okuldokuman.xyz",
    "okuruguay.com",
    "okventura.com",
    "okwashingtondc.com",
    "okwprzemysl.org",
    "okyanusreklamsinop.com",
    "okzk.com",
    "okzmvp.site",
    "ol7se6.us",
    "olabahis.tv",
    "olanagolar.icu",
    "olaq.store",
    "olatheschools.org",
    "olb855.com",
    "olbosi.ga",
    "olbosi.gq",
    "olbpoker.online",
    "olc.one",
    "olcanoclub.one",
    "olchromlei.ga",
    "olchromlei.gq",
    "olchromlei.ml",
    "old-recipes.com",
    "old-street.info",
    "oldacg.com",
    "oldbt.com",
    "oldbuthealthy.com",
    "oldcity56.ru",
    "oldcitycenter.net",
    "oldcitycenter.org",
    "oldgreenlawlochy.com",
    "oldgwt.space",
    "oldies1041.com",
    "oldies104mail.com",
    "oldlaptop.ru",
    "oldmadein.com",
    "oldmine.ru",
    "oldmmogamers.net",
    "oldmummail.online",
    "oldroons.com",
    "oldschoolarcade.net",
    "oldschoolgoeshightech.com",
    "oldshoolrunescape.com",
    "ole.com",
    "oledemades.ru",
    "olegfineev.site",
    "oleginshop.ru",
    "olemail.com",
    "olesen.dk",
    "olesres.ml",
    "olesres.tk",
    "oleybet243.com",
    "oleybet244.com",
    "oleybet245.com",
    "oleybet246.com",
    "oleybet249.com",
    "oleytuttu.com",
    "olg.com",
    "olga9.ru",
    "olgamag.ru",
    "olgsale.top",
    "olgt6etnrcxh3.cf",
    "olgt6etnrcxh3.ga",
    "olgt6etnrcxh3.gq",
    "olgt6etnrcxh3.ml",
    "olgt6etnrcxh3.tk",
    "olia.website",
    "olibro.page",
    "oligarh.ru",
    "olimagsimple.com",
    "olimp-case.ru",
    "olinbzt.ga",
    "olinel.cf",
    "olinel.ga",
    "olinel.gq",
    "olinel.ml",
    "olinel.tk",
    "olinetus.com",
    "oliosales.info",
    "oliva-patronage.ru",
    "olivebranchapartments.com",
    "oliveli.com",
    "oliveoilanalysis.com",
    "oliveoilbank.org",
    "oliveoilbook.com",
    "oliveoilbuyer.com",
    "oliveoilclass.com",
    "oliveoilconnoisseur.com",
    "oliveoilfarm.com",
    "oliveoilforlife.org",
    "oliveoilhandbook.org",
    "oliveoillab.com",
    "oliveoillawsuit.com",
    "oliveoilmagic.com",
    "oliveoilmonthclub.com",
    "oliveoilquality.org",
    "oliveoilscore.com",
    "oliveoilscore.org",
    "oliveoilscores.com",
    "oliveoilshop.net",
    "oliveoilsnob.com",
    "oliveoiltest.org",
    "oliveoiltimes.net",
    "oliveoiltimes.org",
    "oliveoilweek.org",
    "olivepizza.net",
    "olivers.kiwi",
    "oliveruniq.com",
    "olivesoap.com",
    "oliwonders.com",
    "olixao.ml",
    "oljdsjncat80kld.gq",
    "ollowsea.com",
    "oln8.us",
    "olnzd.us",
    "olobmai.ga",
    "olobmai.gq",
    "ololenses.com",
    "ololzi.ga",
    "ololzi.ml",
    "olplq6kzeeksozx59m.cf",
    "olplq6kzeeksozx59m.ga",
    "olplq6kzeeksozx59m.gq",
    "olplq6kzeeksozx59m.ml",
    "olplq6kzeeksozx59m.tk",
    "olqe.info",
    "olqenotes.com",
    "olqenotes.net",
    "olsnornec.tk",
    "olsonassociates.com",
    "olvqnr7h1ssrm55q.cf",
    "olvqnr7h1ssrm55q.ga",
    "olvqnr7h1ssrm55q.gq",
    "olvqnr7h1ssrm55q.ml",
    "olvqnr7h1ssrm55q.tk",
    "olxtoto.net",
    "olymbecusa.com",
    "olymcart.com",
    "olymcms.com",
    "olympiaeconomicsspot.com",
    "olympiaha.net",
    "olympist.net",
    "olympus4kids.se",
    "olypmall.ru",
    "olzopoopume.ru",
    "omahachurchofchrist.net",
    "omahsimbah.com",
    "omail.com",
    "omail.pro",
    "omailer.xyz",
    "omamh.info",
    "omaninfo.com",
    "omanizdjm.ru",
    "omarquesantiguidades.com",
    "ombreshorthair.com",
    "omdo.xyz",
    "omeaaa124.ddns.net",
    "omega3nutrition.com",
    "omegacoin.org",
    "omegafive.net",
    "omego.ru",
    "omeie.com",
    "omen.ru",
    "omenwi.ga",
    "omenwi.gq",
    "omessage.gq",
    "ometofu.shop",
    "omfcanada.ong",
    "omfh.net",
    "omgameshop.com",
    "omi4.net",
    "omidbet.name",
    "omiptras.cf",
    "omiptras.gq",
    "omiptras.tk",
    "omk24.de",
    "omkostningertil.website",
    "oml72.space",
    "omni-sports.com",
    "omni.nu",
    "omnicro.com",
    "omnievents.org",
    "omnimart.store",
    "omnius-solutions.com",
    "omnyo.com",
    "omoomn.host",
    "ompokerasia.com",
    "omskinport.cf",
    "omskinport.gq",
    "omskinport.tk",
    "omsvet.ru",
    "omtamvan.com",
    "omtnrye.site",
    "omwe.ru",
    "omxeepez.shop",
    "omypoker.com",
    "omypokers.com",
    "omzae.com",
    "omzg5sbnulo1lro.cf",
    "omzg5sbnulo1lro.ga",
    "omzg5sbnulo1lro.gq",
    "omzg5sbnulo1lro.ml",
    "omzg5sbnulo1lro.tk",
    "on-the-web.tv",
    "on888b.life",
    "onamulet.ru",
    "onani777.com",
    "onarleyeman.xyz",
    "onayost.info",
    "onbachin.cf",
    "onbachin.gq",
    "onbachin.ml",
    "onbehalfof.store",
    "onbet.org",
    "onc12.space",
    "onca03.com",
    "onca04.com",
    "oncapol2.com",
    "once-repeat.xyz",
    "oncemusic.ru",
    "onchainwallet.com",
    "onclimate.com",
    "oncloud.ws",
    "oncloudsaves.email",
    "ondeler.site",
    "ondemandemail.top",
    "ondemandroadsidehelp.com",
    "ondeondp.shop",
    "ondikoi.com",
    "ondponde.shop",
    "one-exposure.com",
    "one-mail.top",
    "one-n-only.ru",
    "one-shoes.ru",
    "one-time.email",
    "one.pl",
    "one.sch.lv",
    "one2mail.info",
    "one55.app",
    "oneamericca.com",
    "oneamerixa.com",
    "onebiginbox.com",
    "onebox.com",
    "onebyzero.net",
    "onecalltrack.com",
    "onecasinos.net",
    "onecitymail.com",
    "onecj.com",
    "oneclickauth.com",
    "onedayconnecticut.com",
    "onedaymail.cf",
    "onedaymail.ga",
    "onedie.club",
    "onedie.xyz",
    "onedonation.com",
    "onefivepro.se",
    "onehandtyper.com",
    "onehundredmice.com",
    "oneid.club",
    "oneindia.in",
    "oneinfra.net",
    "oneinfra.online",
    "onelastebyte.com",
    "onelastebyte.net",
    "onelegalplan.com",
    "onelivefestival.com",
    "onemail.host",
    "onemail1.com",
    "onemediail.com",
    "onemillionlightbulbs.com",
    "onemoremail.net",
    "onenet.com.ar",
    "onenime.ga",
    "oneoc.com",
    "oneoffemail.com",
    "oneoffmail.com",
    "oneooneproperty.com",
    "onepageaway.live",
    "onepageaway.org",
    "onepiece-vostfr.stream",
    "oneplan.pics",
    "oneplus.events",
    "onerealbox.com",
    "oneredirecwins.icu",
    "onergeinsaat.xyz",
    "onesecond365.cn",
    "oneshot-fluxe.xyz",
    "oneshot07.com",
    "oneshot119.com",
    "oneshot63.com",
    "onesiewereld.online",
    "onesjoy.com",
    "onespeles.ru",
    "onestarlight.xyz",
    "onestopcodeshop.com",
    "onestopcy.com",
    "onestopiguanashop.com",
    "onestopinfo.ga",
    "onestopinfo.ml",
    "onet.com.pl",
    "onet.eu",
    "onet.pl",
    "onetag.org",
    "onetaipeis.info",
    "onetap.marketing",
    "onetap.site",
    "onetonco2.com",
    "onetouchllc.com",
    "onetouchtv.com",
    "oneuk.com",
    "oneultimatehealth.com",
    "onewalldecorblog.website",
    "onewaymail.com",
    "oneworldhull.com",
    "oneworldtales.com",
    "onfave.info",
    "onforth.shop",
    "onfractalforge.com",
    "ongc.ga",
    "ongdia.com",
    "ongoingwall.com",
    "ongpkr.org",
    "ongridhost.com",
    "ongtroi.com",
    "onhealth.tech",
    "onhfcridg.shop",
    "onhide.com",
    "onhoonhe.shop",
    "oni49.space",
    "oninet.pt",
    "onitaps.com",
    "onitfitness.com",
    "oniun.ru",
    "onjckuoj.shop",
    "onkolojidoktoru.org",
    "onkolojiokulu.info",
    "onlatedotcom.info",
    "onlime-24.website",
    "online-1-shop1.info",
    "online-2-shop1.info",
    "online-3-shop1.info",
    "online-4-shop1.info",
    "online-5-shop1.info",
    "online-6-shop1.info",
    "online-7-shop1.info",
    "online-8-shop1.info",
    "online-9-shop1.info",
    "online-business-directory.xyz",
    "online-discount-shopping.online",
    "online-fly.com",
    "online-lvs788.com",
    "online-marketing-university.org",
    "online-mipowerbank.ru",
    "online-secure-uk.xyz",
    "online-secure.monster",
    "online-sokolov.ru",
    "online-webtools.com",
    "online.de",
    "online.ie",
    "online.ms",
    "online.nl",
    "online.ru",
    "online315.xyz",
    "online5.ru",
    "onlineautomatenspiele.host",
    "onlinebakarat.org",
    "onlinebooking.deals",
    "onlinecasinobonus6167.net",
    "onlinecasinogamblings.com",
    "onlinecasinostop.ru",
    "onlinecasinosunion.com",
    "onlineclub.website",
    "onlinecomputerhelp.net",
    "onlinecoursesidehustle.com",
    "onlinedars.com",
    "onlinedating-site-guide.rocks",
    "onlinedoctor.link",
    "onlineempireguide.com",
    "onlinegoods.store",
    "onlinehome.de",
    "onlinehoping58.ru",
    "onlinehunter.ml",
    "onlineidea.info",
    "onlinejazz.poker",
    "onlinekampanyalar.site",
    "onlinekindergartencourse.com",
    "onlinelender.xyz",
    "onlinelenders.xyz",
    "onlinelending.xyz",
    "onlinemail.xyz",
    "onlinemarket100.ru",
    "onlinemarket360.ru",
    "onlinemarket365.ru",
    "onlinemarketingclass.org",
    "onlinemaster.xyz",
    "onlinemaximizer.net",
    "onlinemaximizers.com",
    "onlinemutualfund.xyz",
    "onlinenet.info",
    "onlinenewyorksingles.com",
    "onlinepokerdom.online",
    "onlineprintspain.com",
    "onlineproffitslots.ru",
    "onlineresellerdvd.com",
    "onlinesafedating.com",
    "onlinescore-iq.com",
    "onlinescore-jo.com",
    "onlineslostsdeposits.ru",
    "onlinestoress.ru",
    "onlinetantraclasses.com",
    "onlinetantracourses.com",
    "onlinete-bfirsati.org",
    "onlinetrafficmachine.com",
    "onlinetravel.discount",
    "onlinetravelagency.xyz",
    "onlinevideochat.net",
    "onlinevideomusic.xyz",
    "onlineviewwx35.com",
    "onlinevoucher.biz",
    "onlinevulkandengi.tech",
    "onlinewebmail.top",
    "onlinewiz.com",
    "onlinework-project.ru",
    "only-marrakech.online",
    "only2weeks.com",
    "onlybarkplaza.com",
    "onlyformen.club",
    "onlymyshop.ru",
    "onlyrefo.ru",
    "onlytoserve.com",
    "onmail.com",
    "onmail.top",
    "onmail.win",
    "onmailserver.me",
    "onmailzone.com",
    "onmenbr1.xyz",
    "onmicrosoft.com",
    "onmilwaukee.com",
    "onmsfjgv.shop",
    "onmytee.info",
    "ono.com",
    "onobox.com",
    "ononymous.com",
    "onousmykonos.com",
    "onp9ue.us",
    "onpersu.ga",
    "onpersu.gq",
    "onpersu.ml",
    "onphlegeal.cf",
    "onphlegeal.gq",
    "onphlegeal.ml",
    "onpointjobs.org",
    "onpotencialex.ru",
    "onprice.co",
    "onqin.com",
    "onqus.com",
    "onr.cloud",
    "onsailbooking.net",
    "onsailbooking.org",
    "onsailcharter.info",
    "onsailcharter.org",
    "onsailcharter.us",
    "onsetingamed.rest",
    "onskulls.com",
    "onstochin.ml",
    "onstochin.tk",
    "onsunpantry.com",
    "onsuvhub.live",
    "onsuvsget.live",
    "ontarioedu.com",
    "ontariofishingreports.com",
    "ontechnews.xyz",
    "ontelist.ga",
    "ontelist.gq",
    "ontelist.ml",
    "ontelist.tk",
    "onterakt.com",
    "ontheroxmag.com",
    "onthestreet.shop",
    "ontheweblearning.com",
    "onthwmarket.com",
    "ontostack.com",
    "ontracademy.com",
    "ontrvx.xyz",
    "ontyne.biz",
    "onu.edu",
    "onuadon.cf",
    "onuadon.ga",
    "onuadon.gq",
    "onvaou.club",
    "onvillage.com",
    "onviselki.ru",
    "onw88.com",
    "onyeabor.info",
    "onyxek.us",
    "onzberam.ga",
    "onzberam.gq",
    "onzberam.ml",
    "onzberam.tk",
    "oo-mail.net",
    "oo18269.com",
    "oo408.site",
    "oo57822.com",
    "oo8037.com",
    "oo813.com",
    "ooacsf.com",
    "ooani.net",
    "oodlesnormantonroad.com",
    "ooeawtppmznovo.cf",
    "ooeawtppmznovo.ga",
    "ooeawtppmznovo.gq",
    "ooeawtppmznovo.ml",
    "ooeawtppmznovo.tk",
    "oofmail.tk",
    "oogxi.us",
    "oohioo.com",
    "oohotmail.club",
    "oohotmail.com",
    "oohotmail.online",
    "oohshiny.us",
    "oohwin.com",
    "oojy.com",
    "oolhoazul.com",
    "oolloo.cf",
    "oolloo.org",
    "oolus.com",
    "oonabrangamsnell.com",
    "oonies-balls.ru",
    "oonies-game.ru",
    "oonies-shoprus.ru",
    "oonieser.ru",
    "ooniesoriginal.ru",
    "ooniez.ru",
    "ooo813.com",
    "ooodesi.club",
    "ooogrinvich.ru",
    "ooorosso.ru",
    "oooxx00.xyz",
    "oopi.org",
    "oopsmotorinsurance.com",
    "oorcmskl.shop",
    "oot-m.ru",
    "ootriy.site",
    "oou.us",
    "oovy.org",
    "ooxka.site",
    "ooxx520.com",
    "ooxx69.xyz",
    "ooyoho.com",
    "op.pl",
    "op82new.shop",
    "opay.money",
    "opayq.com",
    "opaywallet.info",
    "opaywallet.org",
    "opbergrekken.com",
    "opc-888.com",
    "opdota.ru",
    "opdrsinangoker.com",
    "ope037.com",
    "open-active-future.ru",
    "open-economy.org",
    "open-info-outlet.ru",
    "open-market-easy.ru",
    "open-position.info",
    "open.brainonfire.net",
    "openafortune.com",
    "openavz.com",
    "openbasecode.com",
    "opencartmarket.com",
    "opencmscheck.xyz",
    "openconstruction.org",
    "openculture.best",
    "opendbs.com",
    "opendbs.net",
    "opendbs.org",
    "opende.de",
    "opendecoder.com",
    "opendiary.com",
    "opendns.ro",
    "openeats.org",
    "openedtechfestival.info",
    "openedtechfestival.org",
    "opengafas.tk",
    "openhippel.org",
    "openhousesonmaui.com",
    "openinvoice.us",
    "openkaser.cf",
    "openkc.com",
    "openlate.co.uk",
    "openmail.ga",
    "openmail.ml",
    "openmail.tk",
    "openmail330.sale",
    "openmailbox.org",
    "openmailbox.tk",
    "openmailservice.com",
    "openmindedzone.club",
    "openmoneyclick.ru",
    "openneural.host",
    "openneural.net",
    "openpoland.org",
    "opensans.ru",
    "openskj.com",
    "opensourceed.app",
    "openspacenn.ru",
    "openssource.site",
    "openstate.info",
    "openstaxtutor.com",
    "opentrash.com",
    "openuni.org",
    "openves.org",
    "openvitality.com",
    "openvpc.com",
    "openvpc.net",
    "operafan.com",
    "operamail.com",
    "operationcrossroadsafrica.com",
    "operationhopeshelter.com",
    "operationsuperdad.com",
    "operatowermanagment.com",
    "operazhi.space",
    "opertali.info",
    "opew.pro",
    "opgram19.com",
    "opgram22.com",
    "opgram24.com",
    "opgram25.com",
    "opgram27.com",
    "opgram30.com",
    "ophaltde.com",
    "ophdoghau.ga",
    "ophdoghau.ml",
    "ophdoghau.tk",
    "opinion-bank.ru",
    "opinionbank.biz",
    "opinionbank.global",
    "opiratinha.info",
    "opjhjhy.xyz",
    "opka.org",
    "opkhronvj.shop",
    "oplaskit.ml",
    "ople5c.info",
    "opline2.net",
    "oplk71fvf.buzz",
    "oplk72vmj.buzz",
    "oplk73prn.buzz",
    "oplo78xry.buzz",
    "opmadot.cf",
    "opmadot.ga",
    "opmadot.tk",
    "opmania2.net",
    "opmania3.net",
    "opmania5.net",
    "opmania6.net",
    "opmmail.com",
    "opmmax.com",
    "opmmedia.ga",
    "opmtr.online",
    "opmtr.xyz",
    "opna.me",
    "opoczta.pl",
    "opoezdke.com",
    "opojare.org",
    "opop00002.com",
    "opop00003.com",
    "opoprclea.website",
    "opowlitowe53.tk",
    "opp24.com",
    "oppamail.com",
    "oppax.com",
    "opportunityarabic.xyz",
    "oppubg.ru",
    "oprety.site",
    "opros-giveaway.ru",
    "opros.money",
    "opros2020eb.site",
    "opros2020em.site",
    "opros2020en.site",
    "opros2020ra.site",
    "opros2020re.site",
    "opros2020ri.site",
    "opros2020rp.site",
    "opros2020rq.site",
    "opros2020rt.site",
    "opros2020rw.site",
    "opros2020ry.site",
    "opros2020td.xyz",
    "opros2020tf.xyz",
    "opros2020tk.xyz",
    "opros2020tl.xyz",
    "opros2020ts.xyz",
    "opros2020tz.xyz",
    "opros2020ua.xyz",
    "opros2020ub.xyz",
    "opros2020uc.xyz",
    "opros2020ud.xyz",
    "opros2020ue.xyz",
    "opros2020uf.xyz",
    "opros2020ug.xyz",
    "opros2020uh.xyz",
    "opros2020uj.xyz",
    "opros2020uk.xyz",
    "opros2020ul.xyz",
    "opros2020un.xyz",
    "opros2020uo.xyz",
    "opros2020up.xyz",
    "opros2020uq.xyz",
    "opros2020ur.xyz",
    "opros2020us.xyz",
    "opros2020ut.xyz",
    "opros2020uu.xyz",
    "opros2020uv.xyz",
    "opros2020uw.xyz",
    "opros2020ux.xyz",
    "opros2020uy.xyz",
    "opros2020uz.xyz",
    "opros2020wf.site",
    "opros2020ya.xyz",
    "opros2020yb.xyz",
    "opros2020yc.xyz",
    "opros2020yf.xyz",
    "opros2020yg.xyz",
    "opros2020yh.xyz",
    "opros2020yj.xyz",
    "opros2020yk.xyz",
    "opros2020yl.xyz",
    "opros2020yn.xyz",
    "opros2020yo.xyz",
    "opros2020yp.xyz",
    "opros2020ys.xyz",
    "opros2020yv.xyz",
    "opros2020yx.xyz",
    "opros2020yz.xyz",
    "oproseasyfunny3-ml.fun",
    "oprosonline.xyz",
    "oprosworld2-ml.info",
    "opsdojo.net",
    "opsdojo.org",
    "opss40.net",
    "opss60.com",
    "opssfriend4.com",
    "opt-pricesru.ru",
    "opt3ornot.com",
    "optchina-trade.ru",
    "optelcom.ru",
    "opten.email",
    "opthila.cf",
    "opthila.ga",
    "opthila.gq",
    "opthila.ml",
    "opticagauss.com",
    "opticalplaces.com",
    "optician.com",
    "optician.net",
    "optik-turkey.org",
    "optikabiz.ru",
    "optikavid.ru",
    "optiksgaming.com",
    "optimabusinessconsulting.com",
    "optimalhealthchoices.com",
    "optimaweb.me",
    "optimisticheart.com",
    "optimisticheart.org",
    "optimizationcomputersspot.com",
    "optimum.net",
    "optitum.com",
    "optju.ru",
    "optobiotics.com",
    "optom-sumki.ru",
    "optometrist-jacksonville-fl.com",
    "optonline.net",
    "optoseo.com",
    "optph.ru",
    "optpz.ru",
    "optsales.site",
    "optusnet.com.au",
    "opusbanes.gq",
    "opusmusicaltheatreworks.com",
    "opussasy.info",
    "oputin.cf",
    "oputin.ga",
    "oputin.gq",
    "oputin.ml",
    "oputin.tk",
    "opvcfhue.shop",
    "opwaty.gq",
    "opwaty.ml",
    "opwebw.com",
    "opya1.shop",
    "opya3.shop",
    "opzeo.com",
    "oqcal1.site",
    "oqeib.us",
    "oqiwq.com",
    "oqshae.us",
    "oqta.net",
    "oqvftzzj.shop",
    "oqzpv.us",
    "or988.site",
    "oralatlasa.info",
    "oranek.com",
    "orange-bonplan.com",
    "orange.fr",
    "orange.mu",
    "orange.net",
    "orangecamel.info",
    "orangecountycotillion.com",
    "orangecountycouplescounseling.org",
    "orangecountyrefinishing.com",
    "orangehome.co.uk",
    "orangemail.bet",
    "orangerealestateagents.com",
    "orangotango.cf",
    "orangotango.ga",
    "orangotango.gq",
    "orangotango.ml",
    "orangotango.tk",
    "oranje-fans-limburg.com",
    "orantcharities.com",
    "orante.xyz",
    "oras-market.ru",
    "oratalk.com",
    "orbitel.bg",
    "orbitforce.com",
    "orchang.shop",
    "orchardmgr.com",
    "orchesoldw.online",
    "orchidgrows.com",
    "ordenadores.online",
    "ordercelloskinbylittlemonkey.com",
    "orderevdln.ru",
    "orderru.website",
    "orderwindows.com",
    "ordimo.app",
    "ordinaryamerican.net",
    "ordinaryyz1.com",
    "orduavcilardernegi.com",
    "orducadirfestivali.com",
    "orducadirkamp.com",
    "ordulugencler.xyz",
    "ordyspost.cf",
    "ordyspost.ga",
    "ordyspost.gq",
    "ordyspost.ml",
    "ordyspost.tk",
    "oreidresume.com",
    "orelregion.ru",
    "oremdoctors.com",
    "orendagan.com",
    "orescom.cf",
    "orescom.tk",
    "oreshkis.site",
    "orewscircle.site",
    "orexrep.ga",
    "orexrep.gq",
    "orexrep.tk",
    "orfensea.cf",
    "orfensea.ga",
    "orfensea.gq",
    "orfensea.ml",
    "orfensea.tk",
    "orfulle.cf",
    "orfulle.ga",
    "orfulle.gq",
    "orfulle.ml",
    "orfulle.tk",
    "org-archive.com",
    "org.ua",
    "organic.in",
    "organicgardenchannel.com",
    "organicgardensupply.net",
    "organisologue.com",
    "organizationid.com",
    "organizechallengeclick.com",
    "organjuana.com",
    "organophilic.best",
    "orgasm.cheap",
    "orgasm.university",
    "orgasmostelefonicos.com",
    "orgiesimulator.com",
    "orgmail.net",
    "orgmbx.cc",
    "orgonum.ru",
    "orgpoint.org",
    "orgtracks.com",
    "orgzxncin.shop",
    "orhalfpricedlisting.com",
    "orhalfpricelisting.com",
    "oriental.digital",
    "oriental.network",
    "oriental.wiki",
    "orientaltakeaway.com",
    "orientalwokwaterford.com",
    "orientchinesetakeaway.com",
    "orientomg.com",
    "oriete.cf",
    "origamilinux.com",
    "origin.pink",
    "original-bayernsound.de",
    "original-hit-like.ru",
    "original-oonies.ru",
    "original-product.ru",
    "original-trilogy.com",
    "originalmacgames.com",
    "orinsport.com",
    "orinsport.org",
    "orinsports.org",
    "orioni.org",
    "orions-code.site",
    "orionsbelt.download",
    "oririnablueappclubnew.ru",
    "oriwijn.com",
    "orjinalvirfort.space",
    "orjm.ru",
    "orkida.com",
    "orlandopianoservice.com",
    "orlandotimeshareforrent.com",
    "orleanssightseeing.com",
    "orlighme.club",
    "orluxwellness.com",
    "ormanlarda.space",
    "orngwjrncx352.xyz",
    "ornova.org",
    "oro153.online",
    "oroki.de",
    "orotab.com",
    "orpenrestcamp.com",
    "orpxp547tsuy6g.cf",
    "orpxp547tsuy6g.ga",
    "orpxp547tsuy6g.gq",
    "orpxp547tsuy6g.ml",
    "orpxp547tsuy6g.tk",
    "orq1ip6tlq.cf",
    "orq1ip6tlq.ga",
    "orq1ip6tlq.gq",
    "orq1ip6tlq.ml",
    "orq1ip6tlq.tk",
    "orrara.ml",
    "orresponsibleserving.com",
    "orrgzn.tokyo",
    "orsa-studio.com",
    "orsg.xyz",
    "ortaklartl.com",
    "orthodontist.net",
    "orthodontistseoagency.com",
    "orthomed.org",
    "orthopedist620tz.online",
    "orthowall.com",
    "ortigasbylyndon.icu",
    "ortutay.best",
    "oruse.xyz",
    "orviaarabia.space",
    "orviaksarabia.site",
    "orwf.icu",
    "orxy.tech",
    "oryjcqzx.shop",
    "oryol-dosug.ru",
    "os131.com",
    "os2eagle.net",
    "os3m.icu",
    "osaimiword.com",
    "osakaasiaticogranollers.com",
    "osakawiduerr.cf",
    "osakawiduerr.gq",
    "osakawiduerr.ml",
    "osaki-itokon.com",
    "osakis.us",
    "osatna.cf",
    "osatna.ga",
    "osatna.tk",
    "oscar-dz.com",
    "oscarpeacock.buzz",
    "oscarpostlethwaite.com",
    "oscillaterecordings.com",
    "oscubdea.cf",
    "oscubdea.ga",
    "oscubdea.gq",
    "oscubdea.ml",
    "osdf.space",
    "osendingwr.com",
    "oseuvitortv.site",
    "osfujhtwrblkigbsqeo.cf",
    "osfujhtwrblkigbsqeo.ga",
    "osfujhtwrblkigbsqeo.gq",
    "osfujhtwrblkigbsqeo.ml",
    "osfujhtwrblkigbsqeo.tk",
    "osg168live.asia",
    "osg168live.us",
    "osgame.online",
    "osgpoker.us",
    "oshietechan.link",
    "osite.com.br",
    "osiyocomm.com",
    "osk-d.com",
    "oskadonpancenoye.com",
    "osl8s9.us",
    "oslobet34.com",
    "oslobet36.com",
    "oslobet38.com",
    "osmangaziuniversitesi.xyz",
    "osmaniyem.xyz",
    "osmaniyeprefabrikyapi.xyz",
    "osmonit.com",
    "osmosworld.ru",
    "osmqgmam5ez8iz.cf",
    "osmqgmam5ez8iz.ga",
    "osmqgmam5ez8iz.gq",
    "osmqgmam5ez8iz.ml",
    "osmqgmam5ez8iz.tk",
    "osned.ru",
    "osnovnoy-kapital.ru",
    "osnspo.com",
    "oso.com",
    "osoboekb.ru",
    "osocogroup.com",
    "osodthia.cf",
    "osodthia.gq",
    "osodthia.ml",
    "ososos.ml",
    "ostah.ru",
    "ostarsqooq.ru",
    "ostartt.shop",
    "osteoaneurysm.best",
    "osteofluidica.net",
    "ostepterp.cf",
    "ostepterp.ga",
    "ostepterp.gq",
    "ostepterp.ml",
    "ostepterp.tk",
    "ostio.com",
    "ostracizing937lm.online",
    "osveber.ga",
    "osveber.gq",
    "osveber.ml",
    "osveber.tk",
    "osvjk.us",
    "osvvenice.com",
    "osxos.net",
    "osxos.org",
    "osyokoruku02.xyz",
    "ot-pryschei.tk",
    "otakumail.com",
    "otakusoftware.net",
    "otakusoftware.org",
    "otanhome.com",
    "otdel-proklyatiy.ru",
    "otekikonular.xyz",
    "otel-rehberi.com",
    "otelsi.info",
    "otenet.gr",
    "oteuecra.site",
    "otherbla.icu",
    "otherdog.net",
    "otherene.icu",
    "otherinbox.codupmyspace.com",
    "otherinbox.com",
    "othersmodesto.com",
    "otip.lawyer",
    "otitrluh.shop",
    "otkat.info",
    "otkrit-ooo.ru",
    "otkrivator.ru",
    "otktimqc.shop",
    "otnasus.xyz",
    "otobakim.live",
    "otoborsam.com",
    "otobusistanbul.xyz",
    "otoeqis66avqtj.cf",
    "otoeqis66avqtj.ga",
    "otoeqis66avqtj.gq",
    "otoeqis66avqtj.ml",
    "otoeqis66avqtj.tk",
    "otogazmontaji.online",
    "otogazmontaji.xyz",
    "otomasyontr.org",
    "otomax-pro.com",
    "otonmail.ga",
    "otoplenie-stout.ru",
    "otostiker.com",
    "ototarz.com",
    "otrabajo.com",
    "otsos96.link",
    "otsrochki.su",
    "ott-mvp16.com",
    "ott-mvp25.com",
    "ottawa-lottery.info",
    "ottencoffee.net",
    "otterrep.stream",
    "ottocalling.com",
    "ottoform.net",
    "ottopetra.com",
    "ottotech.net",
    "otu1txngoitczl7fo.cf",
    "otu1txngoitczl7fo.ga",
    "otu1txngoitczl7fo.gq",
    "otu1txngoitczl7fo.ml",
    "otu1txngoitczl7fo.tk",
    "otucri.cf",
    "otucri.ga",
    "otucri.gq",
    "otucri.ml",
    "otucri.tk",
    "otwetka.com",
    "otye.us",
    "otymutre.site",
    "otziv63pokupki.ru",
    "ou-se-baigner.com",
    "ou127.space",
    "ou129.space",
    "ou131.space",
    "ou136.space",
    "ou140.space",
    "ou141.space",
    "ou143.space",
    "ou144.space",
    "ou6tcm.site",
    "ou7g32rye.com",
    "oualmdxit.shop",
    "oubgusax.site",
    "oucaiwang.xyz",
    "oucvvwsb.shop",
    "oudelandsrundvlees.com",
    "oudtrees.com",
    "oudturnhout.com",
    "ouenkwxrm.shop",
    "oughtdetailrabbi.site",
    "ouhihu.cf",
    "ouhihu.ga",
    "ouhihu.gq",
    "ouhihu.ml",
    "ouhk.edu.hk",
    "ouhvjg.com",
    "oulaiqi.com",
    "oulqic.ga",
    "ouncil.info",
    "ount.ru",
    "oup3kcpiyuhjbxn.cf",
    "oup3kcpiyuhjbxn.ga",
    "oup3kcpiyuhjbxn.gq",
    "oup3kcpiyuhjbxn.ml",
    "oup3kcpiyuhjbxn.tk",
    "oupt02.com",
    "oupt03.com",
    "ouqrp.us",
    "our-computer.com",
    "our-office.com",
    "our-products.ru",
    "our.st",
    "ourawesome.life",
    "ourawesome.online",
    "ourbrisbane.com",
    "ourchurch.app",
    "ourconnectedhistory.com",
    "ourcritters.net",
    "ourday.info",
    "ourensetv.gal",
    "ourfgv.us",
    "ourhosting.xyz",
    "ourklips.com",
    "ourladyoftheelms.org",
    "ourloveones.com",
    "ourmudce.ga",
    "ourmudce.gq",
    "ourmudce.tk",
    "ournet.md",
    "ouroboros.icu",
    "ourobouros.net",
    "ourpreviewdomain.com",
    "oursecure.com",
    "ourstoryislove.org",
    "oursuperhealth.ru",
    "ourtrailer.com",
    "ourupad.cf",
    "ourupad.ga",
    "ourupad.gq",
    "ousbyrpe.cf",
    "ousbyrpe.gq",
    "ousbyrpe.tk",
    "outcomes-insite.org",
    "outcross.site",
    "outdoopaintingchallenge.com",
    "outdoor-experience.info",
    "outdoorlightingreviewshq.com",
    "outdoornd.com",
    "outdoorproseries.com",
    "outdoorsd.com",
    "outdoorsonwheels.com",
    "outdoorsshop.futbol",
    "outdoorwaterprooffloor.com",
    "outel.com",
    "outercab.buzz",
    "outercabin.buzz",
    "outernet.nu",
    "outernet.shop",
    "outerpic.site",
    "outershout.space",
    "outfoxes.com",
    "outfring.info",
    "outfu.com",
    "outfurra.cf",
    "outfurra.ga",
    "outfurra.gq",
    "outfurra.ml",
    "outgie.com",
    "outgun.com",
    "outhouse.best",
    "outikoumail.com",
    "outime.ru",
    "outlandlabs.com",
    "outlawfrontier.com",
    "outlawspam.com",
    "outlet-adidas.info",
    "outletadidasi.info",
    "outletbrasileiro.com",
    "outletcheap.net",
    "outletimg.com",
    "outletsport.org",
    "outlettomsshoescheap.com",
    "outlettomsshoesstore.com",
    "outlok.site",
    "outlook.at",
    "outlook.be",
    "outlook.cl",
    "outlook.co.id",
    "outlook.co.il",
    "outlook.co.nz",
    "outlook.co.th",
    "outlook.com",
    "outlook.com.ar",
    "outlook.com.au",
    "outlook.com.br",
    "outlook.com.gr",
    "outlook.com.hotpusssy69.host",
    "outlook.com.pe",
    "outlook.com.tr",
    "outlook.com.vn",
    "outlook.cz",
    "outlook.de",
    "outlook.dk",
    "outlook.es",
    "outlook.fr",
    "outlook.hu",
    "outlook.ie",
    "outlook.in",
    "outlook.it",
    "outlook.jp",
    "outlook.kr",
    "outlook.lv",
    "outlook.my",
    "outlook.nl",
    "outlook.ph",
    "outlook.pt",
    "outlook.sa",
    "outlook.sg",
    "outlook.sk",
    "outlookkk.online",
    "outlookpro.net",
    "outloook.com",
    "outlyca.cf",
    "outlyca.gq",
    "outlyca.tk",
    "outmail.win",
    "outoffice.online",
    "outoffice.ru",
    "outomcam.cf",
    "outomcam.tk",
    "outpaas.com",
    "outpatientaddictionrehabs.com",
    "outragesia.online",
    "outriggerasia.com",
    "outriggeratkoloalanding.com",
    "outriggerbusinessadvantage.com",
    "outriggerhospitalitygroup.com",
    "outriggerinternational.com",
    "outriggerkamaaina.com",
    "outriggerkeauhoubay.com",
    "outriggerkeauhoubeachresortandspa.com",
    "outriggerkonabeachclub.com",
    "outriggerkonabeachresort.com",
    "outriggerkonabeachsparesort.com",
    "outriggerkonacoastsparesort.com",
    "outriggerkonagolf.com",
    "outriggerkonaresort.com",
    "outriggerkonaresortandspa.com",
    "outriggerkonaspa.com",
    "outriggerreefwaikikibeachresort.com",
    "outriggersports.com",
    "outriggersydney.com",
    "outriggervietnam.com",
    "outriggerwaikikibeachresort.com",
    "outriggerwaikikiconnection.com",
    "outriggerwaipoulibeach.com",
    "outroteste.xyz",
    "outsourcing-centre.com",
    "outtradesa.info",
    "ouwoanmz.shop",
    "ov3u841.com",
    "ovaf8g.site",
    "ovalsbybeth.icu",
    "ovathebridge.com",
    "ovejes.gq",
    "ovejes.ml",
    "ovenprices.com",
    "oveodewa.org",
    "over-craft.ru",
    "over-the-rainbow.com",
    "overagent.com",
    "overdaxilket.ru",
    "overgoal.net",
    "overgol.net",
    "overheid.works",
    "overkidlde.space",
    "overmetre.com",
    "overreader.com",
    "overseas.vote",
    "overtijdpil.com",
    "overy.ru",
    "ovhns.net",
    "ovi.com",
    "ovi.usa.cc",
    "ovi9bc.us",
    "ovicellular.best",
    "ovik-servis.ru",
    "ovimail.cf",
    "ovimail.com",
    "ovimail.ga",
    "ovimail.gq",
    "ovimail.ml",
    "ovimail.tk",
    "ovinh.com",
    "ovismuapyr.space",
    "ovlov.cf",
    "ovlov.ga",
    "ovlov.gq",
    "ovlov.ml",
    "ovlov.tk",
    "ovmau.us",
    "ovo365.xyz",
    "ovoskv.shop",
    "ovotogel.org",
    "ovowin.biz",
    "ovpn.site",
    "ovpn.to",
    "ovtracker.org",
    "ovukfi.us",
    "ovv20p.site",
    "ovvamaviyesil.com",
    "ovvd20.site",
    "ovvdt.site",
    "ovvee.com",
    "ovvpq.site",
    "ovvpt.site",
    "owa.kr",
    "owawkrmnpx876.tk",
    "owee.org",
    "oweiidfjjif.cf",
    "oweiidfjjif.ga",
    "oweiidfjjif.gq",
    "oweiidfjjif.ml",
    "oweiidfjjif.tk",
    "oweshapeoil.website",
    "owga67admhbf5p0.xyz",
    "owh.ooo",
    "owibi.site",
    "owingsmillsshowerglass.com",
    "owl-dr.com",
    "owlies.com",
    "owljh1.site",
    "owlowl.fish",
    "owlpic.com",
    "owlymail.com",
    "ownchatserver.com",
    "owncloud.design",
    "ownerba.xyz",
    "ownerbasi.xyz",
    "ownerfinancezone.com",
    "ownerflus.us",
    "ownerpre.xyz",
    "ownerpres.xyz",
    "ownerupse.press",
    "ownhome.xyz",
    "ownmail.net",
    "ownrd.us",
    "ownrespects.host",
    "ownsyou.de",
    "ownyourapps.com",
    "ownyourown.today",
    "owrdonjk6quftraqj.cf",
    "owrdonjk6quftraqj.ga",
    "owrdonjk6quftraqj.gq",
    "owrdonjk6quftraqj.ml",
    "owrdonjk6quftraqj.tk",
    "owstracker.com",
    "owwapp.com",
    "owz83.space",
    "ox5bk.us",
    "oxalamid.best",
    "oxbridgeeight.com",
    "oxddadul.cf",
    "oxddadul.ga",
    "oxddadul.gq",
    "oxddadul.ml",
    "oxfarm1.com",
    "oxg9a.us",
    "oxid2828.com",
    "oxid2828.org",
    "oxinchannel.net",
    "oxjfqcgff.shop",
    "oxjl.com",
    "oxjsa9.us",
    "oxkvj25a11ymcmbj.cf",
    "oxkvj25a11ymcmbj.ga",
    "oxkvj25a11ymcmbj.gq",
    "oxkvj25a11ymcmbj.tk",
    "oxopin.com",
    "oxopoha.com",
    "oxplay.ru",
    "oxul.us",
    "oxx3ta.us",
    "oxxbcnqi.shop",
    "oxxx.bid",
    "oxyelitepro.ru",
    "oyekgaring.ml",
    "oyetalove.com",
    "oyj32.us",
    "oyjob.com",
    "oykw.us",
    "oylstze9ow7vwpq8vt.cf",
    "oylstze9ow7vwpq8vt.ga",
    "oylstze9ow7vwpq8vt.gq",
    "oylstze9ow7vwpq8vt.ml",
    "oylstze9ow7vwpq8vt.tk",
    "oyma9q.com",
    "oynabingo.com",
    "oyncki.us",
    "oyogscanada.com",
    "oyu.kr",
    "oyuhfer.cf",
    "oyuhfer.ga",
    "oyuhfer.gq",
    "oyuhfer.ml",
    "oyukikoy.site",
    "oyuncaak.net",
    "oyuncakantika.online",
    "oyuncakantika.xyz",
    "oyuncountry.xyz",
    "oyw9wj.online",
    "oywjgkpc.icu",
    "ozabor.xyz",
    "ozanilan8.xyz",
    "ozaudio.ru",
    "ozbytes.net.au",
    "ozbzt.live",
    "ozeflowers.com",
    "ozelevrenbey.com",
    "ozelguvenlikbul.net",
    "ozemail.com.au",
    "ozgunvjbi.shop",
    "ozjwuo.site",
    "ozlaq.com",
    "ozleh.info",
    "ozogaming.com",
    "ozonehumourrainy.site",
    "ozoopoker.net",
    "ozoozon.ru",
    "ozost.com",
    "ozozwd2p.com",
    "ozqn1it6h5hzzxfht0.cf",
    "ozqn1it6h5hzzxfht0.ga",
    "ozqn1it6h5hzzxfht0.gq",
    "ozqn1it6h5hzzxfht0.ml",
    "ozqn1it6h5hzzxfht0.tk",
    "ozsanlojistik.com",
    "ozsanlojistik.online",
    "ozsanlojistik.xyz",
    "ozsoymesrubat.online",
    "ozsoymesrubat.xyz",
    "oztasmermer.com",
    "oztemizlikmalzemeleri.xyz",
    "ozumz.com",
    "ozuturkisg.com",
    "ozuygunemlak.com",
    "ozweddings.com",
    "ozxxta.us",
    "ozxzd.live",
    "ozyl.de",
    "ozz.ru",
    "ozzstream.com",
    "ozzytoto.info",
    "ozzytoto.net",
    "ozzytoto.shop",
    "p-31.ru",
    "p-banlis.ru",
    "p-bonus.ru",
    "p-fishing.ru",
    "p-g-7.com",
    "p-gdl.cf",
    "p-gdl.ga",
    "p-gdl.gq",
    "p-gdl.ml",
    "p-gdl.tk",
    "p-i-x.fun",
    "p-oops.com",
    "p-response.com",
    "p-value.ga",
    "p-value.tk",
    "p-winning.com",
    "p.9q.ro",
    "p.k4ds.org",
    "p.mrrobotemail.com",
    "p.new-mgmt.ga",
    "p0r2h.us",
    "p0yxlf.us",
    "p0z.xyz",
    "p1316.xyz",
    "p1775.com",
    "p180.cf",
    "p180.ga",
    "p180.gq",
    "p180.ml",
    "p180.tk",
    "p1g5.icu",
    "p1g5online.com",
    "p1nhompdgwn.cf",
    "p1nhompdgwn.ga",
    "p1nhompdgwn.gq",
    "p1nhompdgwn.ml",
    "p1nhompdgwn.tk",
    "p1vdbe.com",
    "p2m3i.us",
    "p2pget.com",
    "p2pnote.com",
    "p2puniversity.com",
    "p2purl.com",
    "p2uqyf.site",
    "p2wnow.com",
    "p2x.site",
    "p2zyvhmrf3eyfparxgt.cf",
    "p2zyvhmrf3eyfparxgt.ga",
    "p2zyvhmrf3eyfparxgt.gq",
    "p2zyvhmrf3eyfparxgt.ml",
    "p2zyvhmrf3eyfparxgt.tk",
    "p33.org",
    "p3334.xyz",
    "p3531.xyz",
    "p3gvm.us",
    "p3sync.com",
    "p58fgvjeidsg12.cf",
    "p58fgvjeidsg12.ga",
    "p58fgvjeidsg12.gq",
    "p58fgvjeidsg12.ml",
    "p58fgvjeidsg12.tk",
    "p5gby.cloud",
    "p5m7n6.us",
    "p5mail.com",
    "p5raoy.site",
    "p62qcn.us",
    "p684.com",
    "p68p68.com",
    "p6c5fi.us",
    "p6udt9.us",
    "p71ce1m.com",
    "p7665.com",
    "p7998.com",
    "p8oan2gwrpbpvbh.cf",
    "p8oan2gwrpbpvbh.ga",
    "p8oan2gwrpbpvbh.gq",
    "p8oan2gwrpbpvbh.ml",
    "p8oan2gwrpbpvbh.tk",
    "p8y51.us",
    "p8y56fvvbk.cf",
    "p8y56fvvbk.ga",
    "p8y56fvvbk.gq",
    "p8y56fvvbk.ml",
    "p8y56fvvbk.tk",
    "p92qe4-mail.xyz",
    "p99520.com",
    "p9fnveiol8f5r.cf",
    "p9fnveiol8f5r.ga",
    "p9fnveiol8f5r.gq",
    "p9fnveiol8f5r.ml",
    "p9fnveiol8f5r.tk",
    "p9u6crt8xk4lgh1.xyz",
    "pa912.com",
    "pa913.com",
    "pa916.com",
    "pa921.com",
    "pa927.com",
    "pa928.com",
    "pa972.com",
    "pa975.com",
    "pa9e.com",
    "paabbbblloo.club",
    "paabbbiillo.club",
    "paabbbiilloo.club",
    "paabbillo.club",
    "paaffshop.store",
    "pabiyy.club",
    "pablo20.xyz",
    "pabloalcalde.com",
    "pablobar.ru",
    "pabooli.club",
    "paboyewe.site",
    "pabuksat.ml",
    "pabulum.xyz",
    "pabypay4.club",
    "pabyy3.club",
    "pacbell.net",
    "pacemls.com",
    "paceshops.site",
    "pachilly.com",
    "pachinkostudio.com",
    "pacific-ocean.com",
    "pacific-re.com",
    "pacificcollege.edu",
    "pacificsportboats.com",
    "pacificwest.com",
    "pacifiersshop.life",
    "packageholidaystohawaii.com",
    "packagetrackingplus.com",
    "packer.dev",
    "packersfan.com",
    "packiu.com",
    "packsec.com",
    "padanghijau.online",
    "paddgapho.cf",
    "paddgapho.tk",
    "paddle-board-yoga.com",
    "paddlepanel.com",
    "paddockpools.net",
    "padfoundationnwi.org",
    "padisabilitylawfirm.com",
    "padkwhzff.shop",
    "padlet-alternate.link",
    "padonkit.online",
    "padonko.online",
    "paeharmpa.cf",
    "paeharmpa.ga",
    "paeharmpa.gq",
    "paeharmpa.ml",
    "paeharmpa.tk",
    "paennsthaidelivery.se",
    "pafnuty.com",
    "pafoshalfmarathon.com",
    "paftelous.website",
    "pafuribordercamp.com",
    "pagaconvinti.com",
    "pagalworldg.info",
    "pagamenti.tk",
    "pagamentos.tk",
    "page-aca.com",
    "page2podcast.org",
    "pagedesignnet.com",
    "pagefault.xyz",
    "pagesblanchesannuaire.com",
    "pagesblanchesannuaires.net",
    "pagesblanchesjaunes.com",
    "pagesjaunesblanches.com",
    "pagina.de",
    "paglask.ru",
    "paglife.online",
    "pagodagardentakeaway.com",
    "pagons.org",
    "pagossnr.com",
    "pagr.dev",
    "pahalfpricedlisting.com",
    "pahalfpricedlistings.com",
    "pahalfpricelisting.com",
    "pahalfpricelistings.com",
    "paharpurmim.cf",
    "paharpurmim.ga",
    "paharpurmim.gq",
    "paharpurmim.ml",
    "paharpurmim.tk",
    "paharpurtitas.cf",
    "paharpurtitas.ga",
    "paharpurtitas.gq",
    "paharpurtitas.ml",
    "paharpurtitas.tk",
    "pahazife.space",
    "pahazp.info",
    "pahe21.club",
    "paherowalk.org",
    "paherpur.ga",
    "paherpur.gq",
    "paherpur.ml",
    "pahilldob.ga",
    "pahilldob.gq",
    "pahilldob.ml",
    "pahilldob.tk",
    "pahiref.ru",
    "paideia.foundation",
    "paideia.university",
    "paidforsurf.com",
    "paigecourtneyphotography.com",
    "paikhuuok.com",
    "paimadoc.cf",
    "paimadoc.gq",
    "paimadoc.tk",
    "paimu.space",
    "painmitt.com",
    "painperformancesolutions.com",
    "painsocks.com",
    "paintapplicator.biz",
    "paintapplicator.net",
    "paintapplicator.us",
    "paintapplicators.net",
    "paintapplicators.org",
    "paintapplicators.us",
    "paintcl.buzz",
    "paintebkhz.space",
    "painter-pete.com",
    "painting-commission.com",
    "painting-stamps.info",
    "paintingeasy.club",
    "paintingideas.online",
    "painttr.icu",
    "paipesro.cf",
    "paipesro.tk",
    "pairefan.cf",
    "pairefan.gq",
    "pairefan.ml",
    "pairefan.tk",
    "pairiewa.gq",
    "pairiewa.ml",
    "pairiewa.tk",
    "pairing.info",
    "paisaazaar.com",
    "paito.news",
    "paito.ninja",
    "paito4d.org",
    "pajarillamail.club",
    "pajazzos.online",
    "pajjys.com",
    "pak-ab.company",
    "pak-ab.net",
    "pak-ab.shop",
    "pakadebu.ga",
    "pakde21.xyz",
    "pakistanmail.com",
    "pakistanoye.com",
    "pakvsindia.live",
    "palacebowlinglanes.com",
    "palaciosvinodefinca.com",
    "paladin.rocks",
    "palaeocreations.com",
    "palatenstation.xyz",
    "palauaquarium.org",
    "palauisy.info",
    "palaulifes.info",
    "paleofix.xyz",
    "paleregression.space",
    "palermo-pizza.ru",
    "palestinemail.com",
    "paletteswap.com",
    "palgong80.com",
    "palingbaru.tech",
    "paliny.com",
    "palkarouz.ru",
    "pallacemax.store",
    "paller.cf",
    "palma4d.org",
    "palmantdo.ml",
    "palmantdo.tk",
    "palmdalechildrendental.com",
    "palmdelgolf.com",
    "palmdirun.ga",
    "palmdirun.gq",
    "palmdirun.ml",
    "palmdirun.tk",
    "palmoilmill.com",
    "palmviewdentist.com",
    "palpialula.gq",
    "pals-pay54.cf",
    "palsengineering.com",
    "paltalkurl.com",
    "pamanollo.com",
    "pamanpk.net",
    "pamapamo.com",
    "pame888.com",
    "pamidor714.info",
    "pampanga.news",
    "pampe.ru",
    "pamplomail.club",
    "pamposhtrophy.com",
    "pamptingprec.gq",
    "pamptingprec.ml",
    "pamukkaletraverten.xyz",
    "pan6974.com",
    "panagra.site",
    "panama-real-estate.cf",
    "panamacityairport.net",
    "panamaverdad.com",
    "panamawmlx.ru",
    "panamiapizza.com",
    "pancakemail.com",
    "panchasefm.com",
    "panchen.info",
    "panchitocastellodelaplana.com",
    "panchoalts.com",
    "pancosj.cf",
    "pancosj.ga",
    "pancosj.gq",
    "pancosj.ml",
    "panda-money1.ru",
    "pandaarkit.com",
    "pandacn8app.com",
    "pandacoin.shop",
    "pandafan.one",
    "pandafan.run",
    "pandafan.website",
    "pandafan.xyz",
    "pandafit.ru",
    "pandawa.com",
    "pandemic.cloud",
    "pandemic.holdings",
    "pandemic8.com",
    "pandora-watch1.ru",
    "pandora.be",
    "pandorabet95.com",
    "pandoramaps.com",
    "pandostore.co",
    "panduanliga88.com",
    "panel-admin.0rg.us",
    "panel.contractors",
    "panelistan.site",
    "panelpros.gq",
    "panelps.ru",
    "panels.contractors",
    "panels.top",
    "panelyikqsl.email",
    "panelyou.xyz",
    "panen228.net",
    "panen228.org",
    "panenpoker.email",
    "panentogel.com",
    "panicchaos.us",
    "paniclim.xyz",
    "panicsug.xyz",
    "panicsweeptech.info",
    "panix.com",
    "pankasyno30.com",
    "pankx.cf",
    "pankx.ga",
    "pankx.ml",
    "pankx.tk",
    "panmoe.com",
    "pannangua.xyz",
    "panolams.org",
    "panonyyhwd.space",
    "panoptive-inc.com",
    "panoramicdentalclinic.com",
    "panquecamail.xyz",
    "panskillet.ru",
    "pantagor-gel.ru",
    "pantalftwt.ru",
    "pantazislawfirm.com",
    "panteon7.ru",
    "panthere.store",
    "pantherscharlotte.com",
    "pantofisport.info",
    "pantogor-dealer.ru",
    "pantophilus.com",
    "pants24.ru",
    "pantspro.ru",
    "panwithsse.cf",
    "panwithsse.ga",
    "panwithsse.ml",
    "panzer-corps.com",
    "paoh9a36.xyz",
    "paolavazquez.com",
    "paosk.com",
    "papa.email.ne.jp",
    "papa86.com",
    "papachka.ru",
    "papaglitch.com",
    "papai.cf",
    "papai.ga",
    "papai.gq",
    "papai.ml",
    "papai.tk",
    "papajp.xyz",
    "paparazzi-ongar.com",
    "paparoatrackhike.com",
    "paparoatrackmtb.com",
    "papaxj.info",
    "papayes.space",
    "paperab.icu",
    "paperbagimprints.com",
    "paperfu.com",
    "paperimprints.com",
    "papermakers.ml",
    "paperoper.xyz",
    "paperpixels.net",
    "papershelpers.website",
    "papertravellers.org",
    "papertri.email",
    "papierkorb.me",
    "papillionapartments.com",
    "papirobizurado.com",
    "papl.icu",
    "papl46tbu.buzz",
    "papl47ynu.buzz",
    "papl48imo.buzz",
    "paplease.com",
    "papo.store",
    "papolog.com",
    "papuaqq.org",
    "papuaqq.site",
    "papystreaming.llc",
    "paqli.us",
    "para2019.ru",
    "paracat.org",
    "paradigmclimbing.com",
    "paradigmexplorer.net",
    "paradise-massage.ru",
    "paradise.net.nz",
    "paradiseemail.com",
    "paradiselleida.com",
    "parador.media",
    "paraisotropicalflorida.com",
    "paralamb.ga",
    "paralamb.ml",
    "parallelizes587nt.online",
    "paralyzenetwork.shop",
    "paramail.cf",
    "paramedicimprovementacademy.com",
    "paranaguia.com",
    "paranakit.net",
    "parangsoca.com",
    "parasizonq.space",
    "paraska.host",
    "parasmi.club",
    "paraterdeco.site",
    "parawansaassoniwora.id",
    "parayum.net",
    "parayum.org",
    "parazit-ua4.website",
    "parazit-ua5.website",
    "parbapcrat.ga",
    "parbapcrat.ml",
    "parbehon.cf",
    "parbehon.tk",
    "parborental.com",
    "parcel4.net",
    "parcimen.cf",
    "parcimen.ga",
    "parcimen.gq",
    "pardakhtinano.xyz",
    "pardakhtinanox.xyz",
    "pardakhtinanoxy.xyz",
    "pardazpara8.xyz",
    "pardintret.xyz",
    "pardisyadak.com",
    "paredav.site",
    "parent.rip",
    "parentby.design",
    "parenthesizes360sc.online",
    "parentingabahihsan.com",
    "parentrescue.website",
    "parents.lol",
    "parents.wtf",
    "parestate.xyz",
    "parezvan.com",
    "parfar.ru",
    "parfum33.ru",
    "parfumcinta.club",
    "pari-match-affiliate.com",
    "parichitta.xyz",
    "paridisa.cf",
    "paridisa.ga",
    "paridisa.gq",
    "paridisa.ml",
    "paridisa.tk",
    "parikmakher.ru",
    "parimatch-1xbet.site",
    "parimatch-affiliates.com",
    "parimatch-app.ru",
    "parimatch-best4.com",
    "parimatch-chance10.com",
    "parimatch-chance7.com",
    "parimatch-chance8.com",
    "parimatch-chance9.com",
    "parimatch-fast7.com",
    "parimatch-fast9.com",
    "parimatch-great7.com",
    "parimatch-great9.com",
    "parimatch-start10.com",
    "parimatch-start9.com",
    "parimatch-stavka10.com",
    "parimatch-stavki10.com",
    "parimatch-stavki7.com",
    "parimatch-stavki8.com",
    "parimatch-stavki9.com",
    "parimatch-top10.com",
    "parimatch-top7.com",
    "parimatch-top8.com",
    "parimatch-top9.com",
    "parimatchchance10.com",
    "parimatchchance7.com",
    "parimatchchance8.com",
    "parimatchchance9.com",
    "parimatchfast10.com",
    "parimatchfast7.com",
    "parimatchfast9.com",
    "parimatchgreat7.com",
    "parimatchgreat9.com",
    "parimatchstart7.com",
    "parimatchstart8.com",
    "parimatchstart9.com",
    "parimatchstavka10.com",
    "parimatchstavki9.com",
    "parimatchtop10.com",
    "parimatchtop7.com",
    "parimatchtop8.com",
    "parimatchuz.com",
    "paripartners164.com",
    "paripartners41.com",
    "paripartners496.com",
    "paripartners499.com",
    "paris-attractions.com",
    "paris-golfette.com",
    "paris.com",
    "paris.company",
    "parisannonce.com",
    "parisbahis117.com",
    "parisbahis129.com",
    "parisbahis138.com",
    "parisbahis139.com",
    "parisbahis6.com",
    "parisbahistv2.com",
    "parisbahistv3.com",
    "parisdentists.com",
    "parisdolmus.com",
    "parisgadgets.com",
    "parishcouncilsnearme.com",
    "parisprivatetaxi.com",
    "parisrealestateagents.com",
    "parisvipescorts.com",
    "parkabotties.club",
    "parkarans.info",
    "parkbeep.com",
    "parkbiper.com",
    "parkbipper.com",
    "parkcrestlakewood.xyz",
    "parkerparts.net",
    "parkersabby.net",
    "parkhiker.org",
    "parkinggarage.xyz",
    "parkingnearby.com",
    "parkinshops.com",
    "parkjiyoon.com",
    "parkpeeper.com",
    "parkpie.com",
    "parkpluscharge.com",
    "parkservice.shop",
    "parkspot.info",
    "parktheshark.com",
    "parkviewchristianchuch.net",
    "parkwaypolice.com",
    "parkya.org",
    "parleasalwebp.zyns.com",
    "parlimentpetitioner.tk",
    "parmageddon.net",
    "parnex.fun",
    "parobet10.com",
    "parobet2.com",
    "parobet3.com",
    "parobet5.com",
    "parobet7.com",
    "parobet9.com",
    "parodyinvite.com",
    "parque-principado.com",
    "parquedafeira.online",
    "parrat.ru",
    "parrot.com",
    "parrotingtheright.com",
    "parrrsssiigggraaammm.club",
    "parrrsssiigraaammm.club",
    "parsecfrontiers.net",
    "parsgurup.com",
    "parsi24.xyz",
    "parsiboys.com",
    "parsigirl.com",
    "parsigm.club",
    "parsigramcocoli.xyz",
    "parsimani.xyz",
    "parsmail.com",
    "part-time.dev",
    "part107tests.com",
    "part107waiver.com",
    "partcobbsi.ga",
    "partcobbsi.ml",
    "partfold.us",
    "particitoyen.com",
    "particuliers.pro",
    "partidecitoyens.org",
    "partimestudent.com",
    "partlycloudy.com",
    "partner-tex.ru",
    "partner1bizmoney.ru",
    "partnerbetrayalrecovery.com",
    "partnerconsulting.net",
    "partskyline.com",
    "party4you.me",
    "partybombe.de",
    "partyfun.info",
    "partyheld.de",
    "partynight.at",
    "partyofregions.info",
    "partyonmycock.com",
    "partyoverhere.live",
    "partyshka.ru",
    "partyswin.icu",
    "parusie.de",
    "parvazi.com",
    "parwehrnumb.ga",
    "parwehrnumb.gq",
    "parwehrnumb.ml",
    "pasang4d.com",
    "pasaoutlet.xyz",
    "pasaranbola168.com",
    "pasarnmurah.biz",
    "pasarslot.info",
    "pasarslot.life",
    "pasarslot.monster",
    "pasca22eempe2.xyz",
    "pascaleelie.com",
    "pasco.store",
    "pashabg.org",
    "pashagamingbonus.com",
    "pashagamingyeniadres.com",
    "pasinn.ru",
    "paskero.cf",
    "paskero.gq",
    "paskero.tk",
    "paslanmazhurdasi.net",
    "pasobahis13.com",
    "pasobahis18.com",
    "pasobahis22.com",
    "pasobahis45.com",
    "pasobahis47.com",
    "pasobahis50.com",
    "passagehalfdriver.website",
    "passas7.com",
    "passatudotv.site",
    "passava.com",
    "passdsinterview.com",
    "passed-them.com",
    "passgrumqui.cf",
    "passgrumqui.gq",
    "passionbet.space",
    "passionforfoodtakeaway.com",
    "passionhd.pro",
    "passionwear.us",
    "passmail.net",
    "passmymatric.com",
    "passrountomb.ga",
    "passrountomb.gq",
    "passrountomb.tk",
    "passsbolt.com",
    "passss.website",
    "passw0rd.cf",
    "passw0rd.ga",
    "passw0rd.gq",
    "passw0rd.ml",
    "passw0rd.tk",
    "password.colafanta.cf",
    "password.nafko.cf",
    "passwordconfirmation.com",
    "passwordmail.com",
    "passwort.schwarzmail.ga",
    "passyourjoy.com",
    "pastadetectrange.site",
    "pastafori.com",
    "pastbox.net",
    "pastcave.com",
    "pastebitch.com",
    "pastel-de-pan.com",
    "pastesqf.xyz",
    "pastplay.info",
    "pasukanganas.tk",
    "patacore.com",
    "patagon.website",
    "patalchj.pro",
    "patchag.xyz",
    "patchagre.xyz",
    "patchde.icu",
    "patchspl.icu",
    "patcourtna.cf",
    "patcourtna.ga",
    "patcourtna.tk",
    "pateba.cf",
    "pateba.ga",
    "pateba.gq",
    "pateba.ml",
    "patedi.ga",
    "patekphilippe-watch.ru",
    "patent-tree.info",
    "patentree.net",
    "paterndolg.space",
    "pathfinder-publications.com",
    "pathfindermail.com",
    "pathogen.org",
    "pathsavvy.net",
    "pathstop.info",
    "pathtogodsglory.org",
    "pathtohealth.ru",
    "pathtoig.com",
    "pating5566.com",
    "patinthinhnguyen.info",
    "patinthinhnguyen.org",
    "patiorostrumrealm.site",
    "patmail.com",
    "patmedia.net",
    "patmortspac.cf",
    "patmortspac.gq",
    "patmortspac.ml",
    "patmortspac.tk",
    "patodiproperty.com",
    "patoentaccess.com",
    "patonce.com",
    "patongbaybeachclub.com",
    "patra.net",
    "patriciaclothing.com",
    "patriciate.com",
    "patrickdennis.buzz",
    "patrickhaynes.com",
    "patriotauction.org",
    "patriothomebuilders.com",
    "patriotmanifesto.com",
    "patriotpartnersrestoration.us",
    "patriotpost.net",
    "patrisander.com",
    "patrix1.com",
    "patro.space",
    "patronage-365.ru",
    "patronage-msk.ru",
    "patronmail.club",
    "patronmail.icu",
    "patronmail.online",
    "patronmail.press",
    "patronmail.site",
    "patronmail.space",
    "patswelti.cf",
    "patswelti.ml",
    "patswelti.tk",
    "patteracids.top",
    "pattersonforeclosures.com",
    "patwww.com",
    "paulajapaneserecur.site",
    "paulfucksallthebitches.com",
    "paulistaportal.club",
    "paulkippes.com",
    "paullandsberg.com",
    "paulmadey.net",
    "paulmalyschko.org",
    "paulmcilwaine.com",
    "paulmfarnsworth.com",
    "paulpartington.com",
    "paulwilden.com",
    "paulwnielsen.com",
    "pausebasi.icu",
    "pausemarsh.email",
    "pausepla.xyz",
    "pauseprinterrelay.site",
    "pausnaarnederland.online",
    "pautriphhea.cf",
    "pautriphhea.ga",
    "pautriphhea.gq",
    "pautriphhea.ml",
    "pautriphhea.tk",
    "pauvoiplek.cf",
    "pauvoiplek.ga",
    "pauvoiplek.ml",
    "pauvoiplek.tk",
    "pav2r.site",
    "pavel-kochkin.ru",
    "pavelostapchuk.ru",
    "pavementconference.org",
    "paverol.ru",
    "pavidity.best",
    "pavilionx2.com",
    "pavimentosdune.online",
    "pavn9k.us",
    "pawcco.info",
    "pawn-coder.ru",
    "pawofjustice.org",
    "pawpawfestival.com",
    "pawsmarts.com",
    "pawssentials.com",
    "pawygu.info",
    "paxdealsy.info",
    "paxiq.click",
    "pay-for-win.xyz",
    "pay-mon.com",
    "pay-my9pay.ru",
    "pay-mysupplier.com",
    "pay-pal48996.ml",
    "pay-pal55424.ml",
    "pay-pal63.tk",
    "pay-pal8585.ml",
    "pay-pal8978746.tk",
    "pay-pals.cf",
    "pay-pals.ga",
    "pay-pals.ml",
    "pay-pals54647.cf",
    "pay-pals5467.ml",
    "pay.rentals",
    "pay2-pay-s.top",
    "pay4d.live",
    "pay4d.space",
    "pay88.cash",
    "pay99.cash",
    "pay999.cash",
    "payadd.org",
    "payadoctoronline.com",
    "payaenable.com",
    "payaengage.com",
    "payasnap.com",
    "payaut.online",
    "paybycar.us",
    "paybycard.best",
    "paybycard.shop",
    "paycard.net",
    "paycheckprotectionprogram2020.com",
    "paychip.xyz",
    "payco.shop",
    "paydo.uno",
    "payeer-bonus32.ru",
    "payeer-com.online",
    "payeer-org.online",
    "payeer-ru.site",
    "payforclick.net",
    "payforclick.org",
    "payforcu.cf",
    "payforcu.ml",
    "payforpost.net",
    "payforpost.org",
    "paylasimisi.com",
    "paylevo.net",
    "paymaya.cf",
    "payment1ab1.com",
    "paymentfortoday.com",
    "paymentfortoday1.com",
    "paymentsbotswana.com",
    "paynetcollect.com",
    "payo22.xyz",
    "payot.club",
    "payotta.net",
    "paypal.comx.cf",
    "paypalserviceirc.com",
    "paypaywin.fun",
    "paypaywin.host",
    "paypaywin.site",
    "paypaywin.website",
    "payperdonation.org",
    "payperex2.com",
    "paypirus.com",
    "payprinar.ga",
    "payprinar.ml",
    "payprinar.tk",
    "payru-avito.ru",
    "payseho.ga",
    "payseho.gq",
    "payseho.ml",
    "payseho.tk",
    "paysgateway.com",
    "payshow.website",
    "payslink.best",
    "payspun.com",
    "payterking.gq",
    "payterking.tk",
    "paytopay.xyz",
    "paytv.rent",
    "paytvgratis.click",
    "paytvgratis.info",
    "paytvgratis.net",
    "paytvgratis.online",
    "payxinsijitv.info",
    "pb-shelley.cf",
    "pb-shelley.ga",
    "pb-shelley.gq",
    "pb-shelley.ml",
    "pb-shelley.tk",
    "pb2019zone.com",
    "pb3rr.us",
    "pb5g.com",
    "pb641.site",
    "pbbilling.com",
    "pbesjk.site",
    "pbestore.com",
    "pbjmpgne.shop",
    "pbmbill247.com",
    "pbqr.org",
    "pbs83c.us",
    "pbvm.ru",
    "pc07.app",
    "pc08.app",
    "pc09.app",
    "pc1520.com",
    "pc16.app",
    "pc23.app",
    "pc27.app",
    "pc30.app",
    "pc4pc4.com",
    "pcamerabest.site",
    "pcapcompany.com",
    "pcaudioshop.life",
    "pcbshack.com",
    "pcc1.com",
    "pccareit.com",
    "pccw.com",
    "pccwch.space",
    "pcdd000.com",
    "pcdd7654.com",
    "pcdd8765.com",
    "pcdd9876.com",
    "pces.cloud",
    "pcg.earth",
    "pchatz.ga",
    "pchelovodstvo-tut.ru",
    "pchogwbcx.shop",
    "pcijztufv1s4lqs.cf",
    "pcijztufv1s4lqs.ga",
    "pcijztufv1s4lqs.gq",
    "pcijztufv1s4lqs.ml",
    "pcijztufv1s4lqs.tk",
    "pcincutthter.ga",
    "pcincutthter.tk",
    "pcjbomaina.com",
    "pcjmx.com",
    "pcknowhow.de",
    "pcmnt.live",
    "pcmo.de",
    "pcmylife.com",
    "pconnections.net",
    "pcpostal.com",
    "pcrc.de",
    "pcsb.org",
    "pcshe.com",
    "pcsr.net",
    "pcsrock.com",
    "pcurk.site",
    "pcusers.otherinbox.com",
    "pcvb.site",
    "pcwldalgj.shop",
    "pcyi.xyz",
    "pd2mwh.site",
    "pd5qjy.us",
    "pd675.site",
    "pd6badzx7q8y0.cf",
    "pd6badzx7q8y0.ga",
    "pd6badzx7q8y0.gq",
    "pd6badzx7q8y0.ml",
    "pd6badzx7q8y0.tk",
    "pdazllto0nc8.cf",
    "pdazllto0nc8.ga",
    "pdazllto0nc8.gq",
    "pdazllto0nc8.ml",
    "pdazllto0nc8.tk",
    "pdcqvirgifc3brkm.cf",
    "pdcqvirgifc3brkm.ga",
    "pdcqvirgifc3brkm.gq",
    "pdcqvirgifc3brkm.ml",
    "pdcqvirgifc3brkm.tk",
    "pderg.live",
    "pdf24-ch.org",
    "pdfinvoice.com",
    "pdfsolo.com",
    "pdgvja.best",
    "pdh22.space",
    "pdk93.us",
    "pdkmanbetx.com",
    "pdmlink.ze.cx",
    "pdmmedical.org",
    "pdold.com",
    "pdpm6o.us",
    "pdq-dispatch.com",
    "pdqnx.club",
    "pduluo.us",
    "pdx5g.com",
    "pdxgolffitness.com",
    "pdxtrust.com",
    "pdzgle.site",
    "pe-sky.com",
    "pe.hu",
    "pe19et59mqcm39z.cf",
    "pe19et59mqcm39z.ga",
    "pe19et59mqcm39z.gq",
    "pe19et59mqcm39z.ml",
    "pe19et59mqcm39z.tk",
    "peabodyrentals.com",
    "peaceacu.xyz",
    "peacefultomorrow.org",
    "peacemail.com",
    "peaceoutpops.com",
    "peaceridesla.org",
    "peachtreeresidencescondo.com",
    "peachworld.com",
    "peacockbrowser.com",
    "peakcfg.com",
    "peakfree.net",
    "peakfree.org",
    "peaksun.com",
    "pealuh.com",
    "peanjx.rest",
    "peapz.com",
    "pearldintho.cf",
    "pearldintho.ga",
    "pearldintho.ml",
    "pearldintho.tk",
    "pearpay.xyz",
    "pebblegarden.org",
    "pebesupermart.site",
    "pebkit.ga",
    "peblandkrum.com",
    "pebti.us",
    "pec.it",
    "pecdo.com",
    "pecerwell.ml",
    "pechkin.ru",
    "pecinan.com",
    "pecinan.net",
    "pecinan.org",
    "pecintapoker.com",
    "pecmail.gq",
    "pecmail.tk",
    "pecom-check.ru",
    "pecosdesign.com",
    "pectcandtive.gettrials.com",
    "pedal.dk",
    "pedalcallingreuse.site",
    "pedersen.dk",
    "pedestrianize440cz.online",
    "pedia-egypt.org",
    "pediacode.com",
    "pediaexploler.site",
    "pediatrician.com",
    "pedigolaw.com",
    "pedimed-szczecin.pl",
    "pedmas.com",
    "pedregosamail.club",
    "pedusupermart.site",
    "peekbrush.us",
    "peekbrushes.biz",
    "peekra.com",
    "peepto.me",
    "peertopeerlendinginfo.com",
    "peew.ru",
    "peewee-sweden.com",
    "peezy.fun",
    "pefabde.gq",
    "pefabde.ml",
    "pefabde.tk",
    "pefehe.xyz",
    "pegabooksp.monster",
    "pegandocredito.com",
    "pegas-touristic.space",
    "pegellinux.ga",
    "peggconsulting.com",
    "peggyreduceriver.site",
    "pegmarketcap.com",
    "pegsnzphk.shop",
    "pegweuwffz.cf",
    "pegweuwffz.ga",
    "pegweuwffz.gq",
    "pegweuwffz.ml",
    "pegweuwffz.tk",
    "pegysaconsultores.com",
    "pejovideomaker.tk",
    "pejr1l.com",
    "pejuangkecantikan.com",
    "pejuangwin.com",
    "pekcashop.com",
    "peking-takeaway-dundrum.com",
    "pekinginntakeaway.com",
    "pekingting.cf",
    "pekingting.ga",
    "pekingting.gq",
    "pekingting.ml",
    "pekklemail.com",
    "pekow.org",
    "pekow.us",
    "pekow.xyz",
    "pekwbx.us",
    "pelagonia.capital",
    "pelagonia.studio",
    "pelagonia.ventures",
    "pelagonia.works",
    "pelagonialaw.com",
    "pelaiswealthonline.com",
    "pelandoh.site",
    "pelangiangka.org",
    "pelangiqq188.info",
    "pelangiqq188.net",
    "pelav.org",
    "pelecandesign.com",
    "peli.site",
    "pelicula-completa.online",
    "peliculasonlinegratis.net",
    "pelip.cc",
    "peliscloud.com",
    "pelisflix.site",
    "pelisplus.ru",
    "pelisplusvip.info",
    "pelleti-deshevo.ru",
    "pelor.ga",
    "pelor.tk",
    "pelorqq.com",
    "pelorqq.net",
    "pelrofis.cf",
    "pelrofis.ga",
    "pelrofis.gq",
    "pelusa.info",
    "pemail.net",
    "pembeliananda.info",
    "pemel.best",
    "pemwe.com",
    "pen-drevo.ru",
    "penatik.ru",
    "pencalc.xyz",
    "pencemaran.com",
    "pencildropcrampon.ru",
    "pendikucakbileti.com",
    "pendnorsubg.cf",
    "pendnorsubg.ga",
    "pendnorsubg.gq",
    "pendnorsubg.ml",
    "pendnorsubg.tk",
    "pendokngana.cf",
    "pendokngana.ga",
    "pendokngana.gq",
    "pendokngana.ml",
    "pendokngana.tk",
    "pengangguran.me",
    "pengemand.dk",
    "penghacurlemak.top",
    "penghasilan.online",
    "penguincreationdate.pw",
    "peniaze.app",
    "penienet.ru",
    "penijel.site",
    "peninsulamartialartsacademy.online",
    "penis.computer",
    "penisgoes.in",
    "penjualanbatu.com",
    "penkyx.me",
    "penndustna.cf",
    "penndustna.gq",
    "pennyagi.site",
    "pennyas.press",
    "pennyauctionwizards.com",
    "pennybag.com",
    "pennycl.xyz",
    "pennydram.icu",
    "pennyfre.xyz",
    "pennyfres.xyz",
    "pennyrif.xyz",
    "pennystar.icu",
    "peno-blok1.ru",
    "penoto.tk",
    "penpen.com",
    "pensfalloss.cf",
    "pensfalloss.ga",
    "pensfalloss.gq",
    "pensionadvicevoucher.com",
    "pensionadvicevoucher.org",
    "pensionnayareforma.ru",
    "pensionsfestival.com",
    "pensortearvi.monster",
    "penspam.com",
    "pent.top",
    "pentagon.info",
    "pentestacademy.online",
    "penthouse4d.org",
    "pentowerdublin8.com",
    "penythgehiqe.ru",
    "penzahleb.ru",
    "peonyinn-athy.com",
    "peonysecluderogue.site",
    "peopledrivecompanies.com",
    "peoplefood.top",
    "peoplehavethepower.cf",
    "peoplehavethepower.ga",
    "peoplehavethepower.gq",
    "peoplehavethepower.ml",
    "peoplehavethepower.tk",
    "peoplehubs.com",
    "peoplemail.vip",
    "peoplepc.com",
    "peoples-health.site",
    "peoplesovreignfund.com",
    "peoplesscience.com",
    "peopletalktv.ru",
    "peopleweb.com",
    "peoplewillbuyanything.com",
    "peosporym.ga",
    "peosporym.gq",
    "peosporym.ml",
    "peotanbart.ga",
    "peotanbart.gq",
    "peotanbart.ml",
    "pepbot.com",
    "pepbridge.com",
    "pepeth.info",
    "peppe.usa.cc",
    "peppercorn-initiatives.com",
    "pepperload.com",
    "pepsi.coms.hk",
    "peptide-conference.com",
    "peptize29nq.online",
    "pequenosnegocioslucrativos.com",
    "peqxfmyff.shop",
    "peracid3lv.online",
    "peramatozoa.info",
    "peramoon.space",
    "peraningrepher.press",
    "peras.space",
    "perasut.us",
    "percale.site",
    "perceptium.com",
    "perclesning.cf",
    "perclesning.ga",
    "perclesning.gq",
    "perclesning.tk",
    "percolfklw.space",
    "percutianaceh.com",
    "percypierre.com",
    "perdeciertac.com",
    "pereezd-deshevo.ru",
    "peregroqkm.ru",
    "pereho.site",
    "perekrestok-bonus.ru",
    "perennialpatch.net",
    "perere.cf",
    "perere.gq",
    "peresvetov.ru",
    "perevbistroz.ru",
    "perevezi-gruz.ru",
    "perevodc.club",
    "perevozkabolnykh24.ru",
    "perevozov.com",
    "perfect-brides.com",
    "perfect-smile-shop.site",
    "perfect-u.pw",
    "perfectbags.ru",
    "perfection-challenge.com",
    "perfectmail.com",
    "perfectmatchevents.biz",
    "perfectmatchevents.org",
    "perfectnetworksbd.com",
    "perfectsite.website",
    "perfectsmail.ru",
    "perfectu.pw",
    "perfectwebinarscript.com",
    "perfetchapp.com",
    "perfo.best",
    "performancesciencesllc.biz",
    "performant.dev",
    "performyork.com",
    "perfumeachelois.com",
    "perfumeaffluence.com",
    "perfumeappear.com",
    "perfumeathens.com",
    "perfumeattractive.com",
    "perfumebeguiling.com",
    "perfumebite.com",
    "perfumeblended.com",
    "perfumecaptivating.com",
    "perfumeclass.com",
    "perfumecoco.com",
    "perfumecontact.com",
    "perfumedarling.com",
    "perfumedelicacy.com",
    "perfumeeclipse.com",
    "perfumeextravagant.com",
    "perfumeinfatuate.com",
    "perfumeintensity.com",
    "perfumeintrigue.com",
    "perfumelambent.com",
    "perfumelavish.com",
    "perfumeorchid.com",
    "perfumephoenix.com",
    "perfumephotogenic.com",
    "perfumepurity.com",
    "perfumeray.com",
    "perfumeregency.com",
    "perfumeregenerate.com",
    "perfumereign.com",
    "perfumerichness.com",
    "perfumeritual.com",
    "perfumetease.com",
    "perfumevelocity.com",
    "perfumevenom.com",
    "perfumevixen.com",
    "perfumewarrior.com",
    "perhea.info",
    "peri-peri-chicken-kebab.com",
    "perilpeeperrower.site",
    "perimetr-okna.ru",
    "perimeubels.online",
    "perimeubels.site",
    "perindu.xyz",
    "periodontistwebsitedesign.com",
    "perios-grill-takeaway.com",
    "peripherocentral.best",
    "perisarsas.club",
    "periscian.xyz",
    "periskole.ru",
    "periwonen.online",
    "perjalanandinas.cf",
    "perjalanandinas.ga",
    "perjalanandinas.gq",
    "perjalanandinas.ml",
    "perjalanandinas.tk",
    "perk.vision",
    "perkdaily.com",
    "perkypoll.com",
    "perkypoll.net",
    "perm-master.ru",
    "permacultureconsultants.org",
    "permispno.ga",
    "permispno.gq",
    "permispno.ml",
    "permispno.tk",
    "permundi.net",
    "permvisa.ru",
    "perni22ademire2.xyz",
    "perolas.com",
    "perovo.net",
    "perpetualblonde.com",
    "perpetualsecurities.com",
    "perpiogreen.cf",
    "perpiogreen.ga",
    "perpiogreen.gq",
    "perpiogreen.ml",
    "perpiogreen.tk",
    "perpostlop.cf",
    "perpostlop.ml",
    "perpostlop.tk",
    "perrackdo.ga",
    "perrackdo.gq",
    "perrackdo.tk",
    "perresu.cf",
    "perresu.ga",
    "perresu.gq",
    "perross.ml",
    "perrybear.com",
    "perryboy.com",
    "perryms.com",
    "perryms.org",
    "pers.craigslist.org",
    "persbericht.org",
    "persebaya1981.cf",
    "persebaya1999.cf",
    "persenta.se",
    "pershart.com",
    "persian360.xyz",
    "persianbet.site",
    "persianpay.club",
    "persicoin.com",
    "persiscreations.com",
    "persistnwcd.email",
    "perslihelp.cf",
    "perslihelp.ga",
    "persmacge.cf",
    "persmacge.ga",
    "persmacge.gq",
    "persmacge.ml",
    "persningko.ml",
    "perso.be",
    "personae.us",
    "personae.vote",
    "personal-email.ml",
    "personal.ro",
    "personalandlifecoach.com",
    "personalassistant.expert",
    "personalassistant.live",
    "personalcok.cf",
    "personalcok.ga",
    "personalcok.gq",
    "personalcok.ml",
    "personalcok.tk",
    "personales.com",
    "personalfloattank.com",
    "personalinjurylawyerct.net",
    "personalize81ry.xyz",
    "personalizedvegan.com",
    "personaltrainerinsurancequote.com",
    "perspexcuttosize.com",
    "perspuhow.cf",
    "perspuhow.gq",
    "perspuhow.tk",
    "perstand.fun",
    "pertade.cf",
    "pertade.ga",
    "pertade.gq",
    "pertade.ml",
    "pertade.tk",
    "perthhousecleaning.services",
    "peru.com",
    "peruadventureblog.com",
    "perubests.info",
    "peruvianize.best",
    "perviysad.ru",
    "pervoevideo.ru",
    "pesachmeals.com",
    "pesele.cf",
    "pesele.ga",
    "pesele.gq",
    "pesele.ml",
    "pesiar4d.com",
    "pesiartoto.com",
    "pesna.com",
    "pesnibeez.ru",
    "pesowuwzdyapml.cf",
    "pesowuwzdyapml.ga",
    "pesowuwzdyapml.gq",
    "pesowuwzdyapml.ml",
    "pesowuwzdyapml.tk",
    "pesquisaplaca.com",
    "pessoa-juridica.com",
    "pestabet.com",
    "pestycraft.tk",
    "petadigital.net",
    "petalheiressruddy.site",
    "petalsandquill.com",
    "petanque-echt.online",
    "petberries.ru",
    "petbuysmart.com",
    "petearrings.com",
    "petebarterondrums.com",
    "petebrigham.net",
    "peterayres.info",
    "peterbrookes.buzz",
    "peterburgskaya-orhideya.ru",
    "peterdethier.com",
    "petergunter.com",
    "peterhoffmanlaw.com",
    "peterjasek.com",
    "peterjasek.org",
    "peterjohnson.dev",
    "petersen.dk",
    "peterteneyck.com",
    "petertijj.com",
    "peterung.com",
    "petistisajoc.host",
    "petiteblondemoviez.com",
    "petitebrunettes.com",
    "petitemargot.com",
    "petlover.com",
    "petmem.net",
    "petmem.org",
    "petml.com",
    "petpal-sale.ru",
    "petpawprint.com",
    "petphotographer.photography",
    "petproductreviews.site",
    "petprotect.club",
    "petr.ru",
    "petrib.com",
    "petrinibellteam.com",
    "petrlvur14.website",
    "petrobahis107.com",
    "petroflex-sever.ru",
    "petroleous.site",
    "petrolgames.com",
    "petronas.cf",
    "petronas.gq",
    "petrovac.net",
    "petruhino2.ru",
    "petrus-shop.ru",
    "petrzilka.net",
    "petsburb.com",
    "petsday.org",
    "petsfoodresearch.com",
    "petsitterlive.com",
    "petstoresusa.xyz",
    "pettypool.com",
    "petuh.org",
    "petworld.site",
    "petypals.com",
    "peugeot-argentina.club",
    "peugeot-australia.club",
    "peugeot-citroen-fiat.ru",
    "peugeot206.cf",
    "peugeot206.ga",
    "peugeot206.gq",
    "peugeot206.ml",
    "peuvolsi.ga",
    "pewariskeramat.com",
    "pewebnont.ga",
    "pewebnont.gq",
    "pewebnont.ml",
    "pewebnont.tk",
    "pewpewpewpew.pw",
    "pexda.co.uk",
    "peybet22.com",
    "peybet26.com",
    "peybet28.com",
    "peybet29.com",
    "peypel.online",
    "peyuuv.xyz",
    "peyvandzendegi.com",
    "peza.site",
    "pezeshkpour.com",
    "pfgaoq.shop",
    "pfiizer.com",
    "pfingstfest.info",
    "pflugervilleautorepair.com",
    "pfmarket.org",
    "pfmretire.com",
    "pfnvjn.top",
    "pfqcn1.site",
    "pfui.ru",
    "pfvmedia.com",
    "pfwt9.us",
    "pfyhlp.com",
    "pg1kmh.xyz",
    "pg444.site",
    "pg7700.com",
    "pg77by.com",
    "pg77dns.com",
    "pg77hb.com",
    "pg9327.com",
    "pgbs.de",
    "pgdln.cf",
    "pgdln.ga",
    "pgdln.gq",
    "pgdln.ml",
    "pgeriiyd.shop",
    "pghwct.us",
    "pgioa4ta46.ga",
    "pgjgzjpc.shop",
    "pgkenzo2.club",
    "pgkl.icu",
    "pgoinfo.online",
    "pgq0x1.us",
    "pgqudxz5tr4a9r.cf",
    "pgqudxz5tr4a9r.ga",
    "pgqudxz5tr4a9r.gq",
    "pgqudxz5tr4a9r.ml",
    "pgqudxz5tr4a9r.tk",
    "pgribahra.shop",
    "pgslot78.net",
    "pgtdbo.us",
    "pgu.us",
    "pgwb1u.us",
    "pgxrx.com",
    "ph-shop.pro",
    "ph0jt.us",
    "ph6xhw.us",
    "phaantm.de",
    "phagy.com",
    "phahuy.com",
    "phaiyeu.net",
    "phallobase.org",
    "phamcpa.com",
    "pharmaceuticalbrush.com",
    "pharmaceuticalbrush.net",
    "pharmaceuticalbrush.org",
    "pharmaceuticalbrush.us",
    "pharmacycenter.online",
    "pharmacygulf.xyz",
    "pharmacystorebags.com",
    "pharmaexcipients.info",
    "pharmaexcipients.org",
    "pharmaexcipientwiki.com",
    "pharmaingredient.com",
    "pharmasiana.com",
    "pharmatiq.com",
    "pharmphuel.com",
    "pharveta.cf",
    "pharveta.gq",
    "pharveta.ml",
    "pharveta.tk",
    "phas.ubc.ca",
    "phase4.app",
    "phasupplies.com",
    "phattich.com",
    "phayze.com",
    "phbikemart.com",
    "phc-valeo.info",
    "phclip.com",
    "phcphs.com",
    "phd-com.ml",
    "phd-com.tk",
    "phdzso.info",
    "pheasantridgeestates.com",
    "phecrex.cf",
    "phecrex.ga",
    "phecrex.gq",
    "phecrex.ml",
    "phecrex.tk",
    "phecti.com",
    "pheed.app",
    "phefinsi.ga",
    "phefinsi.gq",
    "phefinsi.ml",
    "phenergan.website",
    "phenixanima.com",
    "phenixcityapartments.com",
    "phentermine-mortgages-texas-holdem.biz",
    "pheolutdi.ga",
    "pheolutdi.tk",
    "phgfve.us",
    "phi-crea.com",
    "philadelphiaarthotel.com",
    "philadelphiasanswer-am990.com",
    "philadelphiasansweram990.com",
    "philae.pictures",
    "philassist.com",
    "philatelicenthusiast.com",
    "philgrove.com",
    "philihp.org",
    "philip.pro",
    "philippine.monster",
    "philippines-cloud.center",
    "philippinesheritage.net",
    "philippinesingles.org",
    "philipuss.ml",
    "phillipsd.net",
    "phillysmallbusinesses.com",
    "philosophicalresearch.org",
    "philsdesign.pro",
    "philuent.com",
    "phim.best",
    "phim.icu",
    "phimtop1.tk",
    "phisbe.site",
    "phjouoznu.shop",
    "phlhomesolutions1.com",
    "phoebegibson.buzz",
    "phoenix-ws.pro",
    "phoenixquote.com",
    "phone-accessories.ga",
    "phone-customer-services.com",
    "phone-elkey.ru",
    "phone-speed-mine-installs.club",
    "phone-top-new-speed.club",
    "phone-victory.ru",
    "phone.net",
    "phone11pro.com",
    "phonearea.us",
    "phonebookofgrenoble.xyz",
    "phonecase-tetris.ru",
    "phonefeeder.com",
    "phonegirl4you.com",
    "phonepacket.com",
    "phoneshrub.com",
    "phonetopnewspeed.club",
    "phonetroll.org",
    "phongcach.top",
    "phonghoithao.net",
    "phongthuyhomenh.store",
    "phoninator.com",
    "phonollbyu.site",
    "phonyprofanerumor.site",
    "phonyyorker.com",
    "photo-impact.eu",
    "photoboothdallas.com",
    "photofile.ru",
    "photographer.net",
    "photoguru.site",
    "photoica.com",
    "photoimaginganddesign.com",
    "photomark.net",
    "photonspower.com",
    "photoprint.ga",
    "photoroid.com",
    "photoscycling.com",
    "photosynthesizes190aw.online",
    "php3.ru",
    "phpbb.uu.gl",
    "phpcode.website",
    "phpduglist.info",
    "phpieso.com",
    "phptutorial.org",
    "phrasepaper.com",
    "phreaker.net",
    "phsacca.com",
    "phtunneler.ga",
    "phubinh.asia",
    "phubinh.us",
    "phuked.net",
    "phuketthai.ru",
    "phukettrail.com",
    "phukienrobot.info",
    "phulkari.online",
    "phuminhnguyen.ml",
    "phuongblue1507.xyz",
    "phuongphapdautu.com",
    "phuongpt9.tk",
    "phuongsimonlazy.ga",
    "phus8kajuspa.cu.cc",
    "phyllostomatoid.best",
    "phymix.de",
    "physicalescrow.com",
    "physicist.net",
    "physics.ubc.ca",
    "pi-ka.ru",
    "pi-note.online",
    "pi-note.xyz",
    "pi-squaredpizzstaverns.com",
    "pi.vu",
    "pi8.com",
    "pi8lvj.us",
    "piaa.me",
    "piabellacasino.com",
    "piaggio.cf",
    "piaggio.ga",
    "piaggio.gq",
    "piaggio.ml",
    "piaggioaero.cf",
    "piaggioaero.ga",
    "piaggioaero.gq",
    "piaggioaero.ml",
    "piaggioaero.tk",
    "piala188.com",
    "pialaeropa180.com",
    "piamendi.cf",
    "piamendi.ga",
    "piamendi.gq",
    "pianoamus.icu",
    "pianofe.press",
    "pianomail.com",
    "pianoprojectrit.com",
    "pianounlimited.com",
    "pianowou.icu",
    "pianoxltd.com",
    "piaster415ir.online",
    "pic0226.online",
    "picanya.net",
    "picbop.com",
    "picfame.com",
    "picfection.com",
    "picfibum.cf",
    "picfibum.ga",
    "picfibum.ml",
    "picfibum.tk",
    "pichak.com",
    "pickatyre.com",
    "pickawash.com",
    "pickemid.site",
    "pickettproperties.org",
    "pickissy.site",
    "picknameme.fun",
    "pickupfinder.org",
    "pickuplanet.com",
    "pickupman.com",
    "pickupwo.com",
    "pickyourcontractor.com",
    "pickyroadwayrunny.site",
    "picnicandbeach.live",
    "picogram.website",
    "picomedicine.com",
    "picoteka.site",
    "picous.com",
    "picpegasus.com",
    "picsala.com",
    "picsedate.com",
    "pictureframe.com",
    "picturepuzzles.club",
    "picturetellers.com",
    "picusnet.com",
    "piczomat.site",
    "pid.mx",
    "pidati.gq",
    "pidati.ml",
    "pidmail.com",
    "pidoseme.online",
    "pidox.org",
    "piebombing.com",
    "piececoun.icu",
    "piecemoderatosaber.site",
    "pieceni.email",
    "piecerang.email",
    "piecerange.email",
    "piecethigh.us",
    "piedmont-energy.net",
    "piepeka.cf",
    "piepeka.ga",
    "piepeka.ml",
    "piepeka.tk",
    "piercedallover.com",
    "piersonvet.com",
    "piesackdes.cf",
    "piesackdes.gq",
    "piespeed.buzz",
    "pietergroup.com",
    "pietershop.com",
    "piewish.com",
    "pig.pp.ua",
    "pig04.com",
    "pigbrachialone.website",
    "pigdog1.ru",
    "pigeonhall.com",
    "pigeonor.com",
    "pigeonportal.com",
    "piggybankcrypto.com",
    "piggybankcrypto.net",
    "piggybankcrypto.org",
    "piggybankcryptosavings.net",
    "piggycoins.info",
    "piggyvest.tech",
    "pigmail.net",
    "pigpig.net",
    "pigybankcoin.com",
    "pigybankcoin.net",
    "pigybankcoin.org",
    "pigycoins.net",
    "pihai.net",
    "pii.at",
    "pika.pc486.net",
    "pikabu.press",
    "pikchaser.com",
    "pikhoy.site",
    "piki.si",
    "pikirkumu.cf",
    "pikirkumu.ga",
    "pikirkumu.gq",
    "pikirkumu.ml",
    "pikoclick.ru",
    "pikolanitto.cf",
    "pikolanitto.ga",
    "pikolanitto.gq",
    "pikolanitto.ml",
    "pikolanitto.tk",
    "pilatesretreatscrete.com",
    "pilatesshop.live",
    "piledriving911.com",
    "pilicinhikayesi.com",
    "pilira.ga",
    "pillbiddit.com",
    "pillbuddyapp.com",
    "pilomaterial57.ru",
    "pilotemail.com",
    "pilotreellive.net",
    "pilpres2018.ga",
    "pilpres2018.ml",
    "pilpres2018.tk",
    "pilsosign.cf",
    "pilsosign.gq",
    "pilsosign.tk",
    "pimaapparel.net",
    "pimagop.com",
    "pimeclegaltech.cat",
    "pimgcx.us",
    "pimolo.ga",
    "pimolo.gq",
    "pimolo.ml",
    "pimpedupmyspace.com",
    "pinballcoil.com",
    "pinbhs1.com",
    "pinbhs2.com",
    "pinbhs3.com",
    "pinbhs4.com",
    "pinbury.me",
    "pincerpdwm.space",
    "pincoffee.com",
    "pineappledisco.com",
    "pinebelt.org",
    "pinebelt.us",
    "pinehill-seattle.org",
    "pinellas.store",
    "pinetreesports.com",
    "pinetum.xyz",
    "pingdom.live",
    "pingheads.com",
    "pingir.com",
    "pingp.ngo",
    "pinicolous.best",
    "pink-party.ru",
    "pink4ever.net",
    "pinkbestpage.ru",
    "pinkcam.tech",
    "pinkco.co.uk",
    "pinkgirl.online",
    "pinkmoonfarms.com",
    "pinknbo.cf",
    "pinknbo.ga",
    "pinknbo.gq",
    "pinknbo.ml",
    "pinlianew.cf",
    "pinlook.site",
    "pinnaclecenturies.com",
    "pinnaclekor.com",
    "pinnaclekor2.com",
    "pinnaclekor3.com",
    "pino99.info",
    "pinoy-tambayan.ru",
    "pinoy.monster",
    "pinoy1tv.ru",
    "pinoychannelofw.ru",
    "pinoylambingantv.ru",
    "pinoymail.com",
    "pinoytambayanako.ru",
    "pinoytambayanz.ru",
    "pinoytvlambingan.ru",
    "pinprints.com",
    "pinsonian.org",
    "pinsup.ru",
    "pintaresfacilconsapolin.com",
    "pintechpinball.com",
    "pinterest-seo.online",
    "pinterests.pro",
    "pinterestworldrecipes.xyz",
    "pintssaddles.top",
    "pinup26.com",
    "pinuscrxiz.space",
    "pinweixiaoshuo.com",
    "pinyifen.com",
    "piodeadmou.gq",
    "piodeadmou.tk",
    "piogroup.software",
    "pioneeri.com",
    "pioneeringplaces.org",
    "pipadanfittinghdpe.website",
    "pipaltree.ong",
    "pipe.doctor",
    "pipebrush.net",
    "pipebrush.org",
    "pipebrush.us",
    "pipebrushes.biz",
    "pipebrushes.net",
    "pipebrushes.us",
    "pipeline.com",
    "pipenny.com",
    "pipikitchen.com",
    "pipim.net",
    "pipiska6879.cf",
    "pipiska6879.ga",
    "pipiska6879.gq",
    "pipiska6879.ml",
    "pipiska6879.tk",
    "pippieterskn.xyz",
    "pippop.cf",
    "pippopmig33.cf",
    "pippopmigme.cf",
    "pippuzzo.gq",
    "pipsbeachouses.com",
    "piquemortarsadly.site",
    "piracha.net",
    "piramitpoker.com",
    "pirassssigggrrram.club",
    "pirate-faction.ru",
    "piratebayproxy.direct",
    "piratebayproxy.online",
    "piratedgiveaway.ml",
    "pirategy.com",
    "piratesdelivery.ru",
    "piribet100.com",
    "piribet13.com",
    "piribet14.com",
    "piribet18.com",
    "piribet20.com",
    "piribet22.com",
    "piribet23.com",
    "piribet24.com",
    "piribet26.com",
    "piribet28.com",
    "piribet40.com",
    "piribet60.com",
    "pisarniskajoga.com",
    "piscateniw.space",
    "pisceans.co.uk",
    "pischevik24.ru",
    "piscosf.com",
    "pisem.net",
    "pishbiniroyal.site",
    "pishgamdsevents.com",
    "pishpeshuk.com",
    "pisichka.com",
    "pisisi.biz",
    "pisisi.info",
    "pisisi.net",
    "pisls.com",
    "pisolaminado.club",
    "pisoos.com",
    "pispis.xyz",
    "pistoletow-blog.ru",
    "pitaniezdorovie.ru",
    "pitapan.org",
    "pitayadetoks.site",
    "piter-potolki.ru",
    "pithyn.org",
    "pitlokjob.com",
    "pitonresources.org",
    "pitostrax.com",
    "pittsborochiro.com",
    "pittsburghheroinrehab.com",
    "pitynorm.host",
    "piuonsales.com",
    "piupiz.com",
    "piusmbleee49hs.cf",
    "piusmbleee49hs.ga",
    "piusmbleee49hs.gq",
    "piusmbleee49hs.ml",
    "piusmbleee49hs.tk",
    "pivo-bar.ru",
    "pivotfurthersally.site",
    "pivrtks.com",
    "pivrw.us",
    "pivxambassador.com",
    "pixaco.info",
    "pixaco.org",
    "pixego.com",
    "pixelated.nyc",
    "pixelboats.info",
    "pixelcomparison.com",
    "pixelmark.online",
    "pixelnod.com",
    "pixelrealms.net",
    "pixelsendhere.icu",
    "pixelsorcery.net",
    "pixelsorcery.org",
    "pixeltips.xyz",
    "pixieapp.com",
    "pixiv365.com",
    "pixiv8.com",
    "pixivtool.com",
    "piyahkc.xyz",
    "piyamipi.site",
    "pizhama-hotel.ru",
    "pizza-bay-dungarvan.com",
    "pizza-point-takeaway.com",
    "pizza.cool",
    "pizza4app.site",
    "pizzabonus.fun",
    "pizzacookiegaming.com",
    "pizzahot-tipperary.com",
    "pizzahut.org",
    "pizzakababish.com",
    "pizzaload.net",
    "pizzamarketespluguesesplugues.com",
    "pizzamarketsants.com",
    "pizzamayorimperial.com",
    "pizzanadiapro.website",
    "pizzandfriedchicken.com",
    "pizzapastatakeaway.com",
    "pizzaplus-limerick.com",
    "pizzashacktakeaway.com",
    "pizzaslicedelivery.com",
    "pizzaslicetakeaway.com",
    "pizzasncream.com",
    "pizzeria-cashel.com",
    "pizzeriacolonmarbella.com",
    "pizzeriagreco.com",
    "pizzeriailmercato.com",
    "pizzeriakebabalcantarillaalcantarilla.com",
    "pizzeriakebabestambulmurcia.com",
    "pizzeriavallecasdonerkebab.com",
    "pj.today",
    "pj12l3paornl.cf",
    "pj12l3paornl.ga",
    "pj12l3paornl.gq",
    "pj12l3paornl.ml",
    "pj12l3paornl.tk",
    "pji40o094c2abrdx.cf",
    "pji40o094c2abrdx.ga",
    "pji40o094c2abrdx.gq",
    "pji40o094c2abrdx.ml",
    "pji40o094c2abrdx.tk",
    "pjjkp.com",
    "pjkmanbetx.com",
    "pjlounge.com",
    "pjoh.us",
    "pjsky.net",
    "pk007.shop",
    "pk008.shop",
    "pk009.shop",
    "pk015.shop",
    "pk018.shop",
    "pk019.shop",
    "pk020.shop",
    "pk025.shop",
    "pk026.shop",
    "pk027.shop",
    "pk028.shop",
    "pk029.shop",
    "pk030.shop",
    "pk031.shop",
    "pk032.shop",
    "pk033.shop",
    "pk034.shop",
    "pk035.shop",
    "pk036.shop",
    "pk037.shop",
    "pk038.shop",
    "pk039.shop",
    "pk041.shop",
    "pk042.shop",
    "pk044.shop",
    "pk046.shop",
    "pk048.shop",
    "pk051.shop",
    "pk052.shop",
    "pk055.shop",
    "pk056.shop",
    "pk057.shop",
    "pk058.shop",
    "pk059.shop",
    "pk061.shop",
    "pk062.shop",
    "pk063.shop",
    "pk065.shop",
    "pk066.shop",
    "pk067.shop",
    "pk068.shop",
    "pk069.shop",
    "pk070.shop",
    "pk071.shop",
    "pk072.shop",
    "pk073.shop",
    "pk074.shop",
    "pk075.shop",
    "pk076.shop",
    "pk077.shop",
    "pk078.shop",
    "pk079.shop",
    "pk081.shop",
    "pk082.shop",
    "pk083.shop",
    "pk085.shop",
    "pk086.shop",
    "pk087.shop",
    "pk088.shop",
    "pk091.shop",
    "pk092.shop",
    "pk3000.club",
    "pk6699.xyz",
    "pkbmdq.fun",
    "pkbmmx.fun",
    "pkcabyr.cf",
    "pkcabyr.ml",
    "pkdnht.us",
    "pkinform.ru",
    "pklmck.fun",
    "pklmlc.fun",
    "pklwsg.us",
    "pkmail.cf",
    "pknmcf.fun",
    "pkrhk.us",
    "pkvdewaq.com",
    "pkvheboh.net",
    "pkvkartu.com",
    "pkwaf.com",
    "pkwt.luk2.com",
    "pkxmbh.fun",
    "pkxy8.us",
    "pl-mail.ru",
    "pl-us22.com",
    "pl85s5iyhxltk.cf",
    "pl85s5iyhxltk.ga",
    "pl85s5iyhxltk.gq",
    "pl85s5iyhxltk.ml",
    "pl85s5iyhxltk.tk",
    "placathic.ga",
    "placathic.gq",
    "placathic.ml",
    "placathic.tk",
    "placdescre.gq",
    "placdescre.ml",
    "placdescre.tk",
    "place.vote",
    "place2win.net",
    "placeftg.tk",
    "placemail.online",
    "placemslcp.space",
    "placentiaapartments.com",
    "placentiadentists.com",
    "placepages.com",
    "placertitlecompany.net",
    "placertitlecompany.org",
    "placertitlecompany.us",
    "placertitlee.net",
    "placertitlee.org",
    "placertitlee.us",
    "placertitleescrow.net",
    "placertitleescrow.us",
    "placertitles.net",
    "placertltie.com",
    "placetitle.net",
    "placetitle.ru",
    "placetopay.biz",
    "placetopay.net",
    "placeu.org",
    "placrospho.ga",
    "placrospho.gq",
    "placrospho.ml",
    "plagiarismcheck.online",
    "plagiarizers320ze.online",
    "plague.chat",
    "plaindesire.com",
    "plaipal3.xyz",
    "plaitbarrierscion.site",
    "plandoreview.app",
    "planeselect.com",
    "planet-kebabish-limerick.com",
    "planet-mail.com",
    "planet-travel.club",
    "planet.nl",
    "planeta-samsung.ru",
    "planetaccess.com",
    "planetall.com",
    "planetarymotion.net",
    "planetbeatrix.com",
    "planetcomputers.net",
    "planetdirect.com",
    "planetearthinter.net",
    "planethaze.net",
    "planetkebabish-cahir.com",
    "planetlive.online",
    "planetmail.com",
    "planetmail.net",
    "planetout.com",
    "planetside2players.com",
    "planetvirtworld.ru",
    "planetwin365winall.net",
    "planeze.com",
    "planfin.online",
    "plangeeks.com",
    "planhorsehill.com",
    "planiplans.com",
    "planiste-francophone.com",
    "planiwpreap.ga",
    "planiwpreap.gq",
    "plankperishscree.site",
    "planmy.menu",
    "plannedparenthood.health",
    "plannedparenthoodasegurate.com",
    "planodesaudecarloslira.top",
    "planodesaudeleonardolobo.top",
    "planoheroinrehab.com",
    "planoquote.com",
    "planorealestateagents.com",
    "plans-b.ru",
    "plansulcutt.gq",
    "plansulcutt.ml",
    "plansulcutt.tk",
    "plant.energy",
    "plant.events",
    "plant.fitness",
    "plant.global",
    "plant.recipes",
    "plant.vegas",
    "plant1plant.com",
    "plantbased.date",
    "plantbased.doctor",
    "plantbased.healthcare",
    "plantbasedbacon.com",
    "plantbasedbeef.com",
    "plantbasedfish.com",
    "plantbasedholidays.com",
    "plantbasedlamb.com",
    "plantbasedmacaron.com",
    "plantbasedpork.com",
    "plantbasedproteinbar.com",
    "plantbasedshrimp.com",
    "plantbasedsteak.com",
    "plantbasedtoys.com",
    "plantbasedvaccine.com",
    "plantbasedvaccines.com",
    "plantcab.xyz",
    "plantcarbs.com",
    "plantchocolate.com",
    "plantcream.com",
    "planteral\xe4tt.com",
    "planteralatt.nu",
    "planteralatt.se",
    "plantfeels.com",
    "plantfoodie.com",
    "plantiary.com",
    "plantkado.space",
    "plantla.xyz",
    "plantlas.xyz",
    "plantmedicineglobal.com",
    "plantnog.com",
    "plantnove.press",
    "plantoneplant.com",
    "plantpolish.com",
    "plantsalmon.com",
    "plantscan.online",
    "plantshrimp.com",
    "plantsvszombies.ru",
    "planttoys.com",
    "plasa.com",
    "plashmoistenscrew.site",
    "plaspayti.ga",
    "plaspayti.gq",
    "plaspayti.ml",
    "plaspayti.tk",
    "plasticizers180if.online",
    "plasticizing753kl.online",
    "plasticsurgeonmarketingagency.com",
    "plastikaspb.ru",
    "plaswillno.cf",
    "plaswillno.gq",
    "platedeph.ml",
    "platedeph.tk",
    "platformassociates.com",
    "platin.dev",
    "platingaming.dev",
    "platinhosting.cloud",
    "platinize755rx.online",
    "platinum.cam",
    "platypdmeb.site",
    "platyrexgk.space",
    "play-minevra.xyz",
    "play-store.app",
    "play-store.biz",
    "play-vulkan-club.ru",
    "play-wap.org",
    "play2vulkan.net",
    "play2x.land",
    "play2x.link",
    "play2x.zone",
    "play338.org",
    "play3n1.com",
    "play3n11.com",
    "play3n18.com",
    "play3nclub.com",
    "play3ncn.com",
    "play3nfair.com",
    "play3niu18.com",
    "play3niu88.com",
    "play3niua.com",
    "play3niub.com",
    "play3niuc.com",
    "play3nlive.com",
    "play3nsb.com",
    "play3nvip.com",
    "play3nwin.com",
    "play3nwin8.com",
    "play4gold.net",
    "play999spin.com",
    "playamo.casino",
    "playbaocasino.info",
    "playbetcasino.com",
    "playcanvas.net",
    "playcard-semi.com",
    "playdiablo4.ru",
    "player-casino.ru",
    "playersodds.com",
    "playerspc.net",
    "playforfun.ru",
    "playforpc.icu",
    "playfortuna-in.ru",
    "playfortuna-official.ru",
    "playful.com",
    "playgamesgo.club",
    "playgirl4d.net",
    "playhabnet.online",
    "playhardjoinville.tk",
    "playhosting.ru",
    "playkres.com",
    "playlablondon.com",
    "playmtv.com",
    "plaync.top",
    "plaync.xyz",
    "playnposm.com",
    "playon.fun",
    "playonlinecasino.tech",
    "playouisi.com",
    "playpharaon.fun",
    "playpokergame.net",
    "playretro.online",
    "playsbc.info",
    "playsbc.org",
    "playsbox.ru",
    "playsetsshop.life",
    "playsims.ru",
    "playsoffstream.live",
    "playsquareland.com",
    "playstation.sony.com",
    "playsto.bet",
    "playstore.best",
    "playstube.com",
    "playthemarket.com",
    "playtubemusic.com",
    "playtubepk.com",
    "playtubes.net",
    "playyo88.info",
    "playyo88.win",
    "pldppd.site",
    "pleadfl.xyz",
    "pleadid.email",
    "pleadlea.xyz",
    "pleasantfantastic.com",
    "pleasanthillapartments.com",
    "pleasantinsterest.com",
    "pleasanttransform.com",
    "pleasantuniques.com",
    "pleasedonotpurchasethedomain.com",
    "pleasenoham.org",
    "pleasherrnan.cf",
    "pleasherrnan.ga",
    "pleasherrnan.gq",
    "pleasherrnan.ml",
    "plecertitle.com",
    "pledge.xyz",
    "plee.nyc",
    "pleinairconventionfall.com",
    "pleinairconventionwest.com",
    "pleinairspring.com",
    "pleinr.com",
    "plemedci.ga",
    "plemedci.gq",
    "plemedci.ml",
    "plemedci.tk",
    "plemrapen.cf",
    "plemrapen.ga",
    "plemrapen.ml",
    "plenbundden.cf",
    "plenbundden.gq",
    "plenbundden.ml",
    "plenbundden.tk",
    "plenty.su",
    "plentyapps.com",
    "plescheevo-mayak.ru",
    "plethurir.cf",
    "plethurir.ga",
    "plethurir.gq",
    "plethurir.ml",
    "plethurir.tk",
    "plexamab.cf",
    "plexamab.ga",
    "plexamab.gq",
    "plexamab.ml",
    "plexamab.tk",
    "plexolan.de",
    "plez.org",
    "plgbgus.ga",
    "plgbgus.ml",
    "plgjhm.us",
    "plhk.ru",
    "pliego.dev",
    "plitkaua.site",
    "ploae.com",
    "plombierleblancmesnil.com",
    "plonecheck.xyz",
    "plonkxicg.space",
    "plopgroep.shop",
    "ploraqob.cf",
    "ploraqob.tk",
    "plorhosva.cf",
    "plorhosva.ga",
    "plorhosva.gq",
    "plorhosva.tk",
    "plotblip.com",
    "plotfifth.com",
    "plotsandfoils.com",
    "ploutos.ong",
    "ployapp.com",
    "plpfq.us",
    "plrdn.com",
    "plsh.xyz",
    "pluccb.xyz",
    "plufix.net",
    "pluflex.com",
    "plugfield.com",
    "plughorn.us",
    "plugindesiger.com",
    "plugsolo.com",
    "plumbadzul.space",
    "plumberdelray.com",
    "plumberslive.com",
    "plumfox.com",
    "plumlytics.net",
    "plumosxxtz.space",
    "plumrelrei.ga",
    "plumrelrei.gq",
    "plumrelrei.tk",
    "plumripe.com",
    "plumrite.com",
    "pluno.com",
    "pluralizes785ql.online",
    "plus.com",
    "plus.google.com",
    "plus1vps.com",
    "plushington.ru",
    "plusjlle.com",
    "plusjlle12.tk",
    "pluskatv.sk",
    "plusmail.cf",
    "plusmail.com.br",
    "plussreklam.xyz",
    "plustrak.ga",
    "plutbild.ru",
    "plutcrop.ru",
    "plutlight.ru",
    "plutmir.ru",
    "plutobet.com",
    "plutocow.com",
    "plutofox.com",
    "plutognivo.ru",
    "plutoillumination.ru",
    "plutus.family",
    "plutus.social",
    "plutvivo.ru",
    "plw.me",
    "plxrd1.site",
    "plymouthfans.co.uk",
    "plymouthrrock.com",
    "plyplace.com",
    "plz-mail.online",
    "pm-200.info",
    "pm-386.info",
    "pm-773.info",
    "pm.me",
    "pm244.site",
    "pm7if.us",
    "pmail.net",
    "pmarketst.com",
    "pmcasino-online.ru",
    "pmchtv.info",
    "pmck.info",
    "pmelegend-footwear.com",
    "pmelegend.clothing",
    "pmeshki.ru",
    "pmivsmvc.shop",
    "pmldmt.com",
    "pmlep.de",
    "pmmgrafavenec.site",
    "pmmkernstylyy.site",
    "pmmkoftaglad.site",
    "pmmparkaglad.site",
    "pmob.online",
    "pmottc.com",
    "pmq0yk.us",
    "pmshelf.com",
    "pmta01.us",
    "pmyojana.website",
    "pn2ulj.site",
    "pn8282.com",
    "pncmarkets.com",
    "pneumo360.ru",
    "pnevmo360.ru",
    "pnhez.com",
    "pnhrpna.com",
    "pnina-inbar.com",
    "pnizgotten.com",
    "pnmproduction.com",
    "pnmxb1.site",
    "pnn79.com",
    "pnpaxl.site",
    "pnqzqoryz.shop",
    "pntrvx.xyz",
    "pnvp7zmuexbqvv.cf",
    "pnvp7zmuexbqvv.ga",
    "pnvp7zmuexbqvv.gq",
    "pnvp7zmuexbqvv.ml",
    "pnvp7zmuexbqvv.tk",
    "pnwgenetics.com",
    "pny0if.us",
    "po.bot.nu",
    "po0rasiiigraaam.club",
    "po0rttttoo90.club",
    "po209.space",
    "po210.space",
    "po211.space",
    "po218.space",
    "po221.space",
    "po228.space",
    "po4tamt.org",
    "po8flz.us",
    "poalmail.ga",
    "poanunal.cf",
    "poanunal.ga",
    "poanunal.gq",
    "poanunal.ml",
    "poanunal.tk",
    "pob2.club",
    "pobbbilocf.club",
    "pobedamailer2.com",
    "pobedit-ves.ru",
    "pobox.com",
    "pobox.hu",
    "pobox.ru",
    "pobox.sk",
    "pochatkivkarmane.cf",
    "pochatkivkarmane.ga",
    "pochatkivkarmane.gq",
    "pochatkivkarmane.ml",
    "pochatkivkarmane.tk",
    "pochta.by",
    "pochta.com",
    "pochta.ru",
    "pochta.ws",
    "pochtamt.ru",
    "pocketmortyreceipes.org",
    "pocketpleaser.com",
    "pocontbest.cf",
    "pocontbest.tk",
    "pocupki.ru",
    "poczta.fm",
    "poczta.onet.eu",
    "poczta.onet.pl",
    "pocztex.epizy.com",
    "pod72.com",
    "podam.pl",
    "podatki-kog.com",
    "podboremavto.ru",
    "podcastflow.com",
    "podcastfunnel.com",
    "podcekay.ru",
    "poddon-13.ru",
    "poderatiop.space",
    "poderosamulher.com",
    "podguznik38.ru",
    "podiform.xyz",
    "podil.xyz",
    "podlipskiy.ru",
    "podlqop.ru",
    "podmosk.ru",
    "podmozon.ru",
    "podotherapie.frl",
    "podscripts.online",
    "podscripts.pro",
    "podscripts.website",
    "podstrigus.ru",
    "podsvetkakuhni.ru",
    "podveska-nn.ru",
    "podzone.net",
    "podzone.org",
    "poehali-otdihat.ru",
    "poetic.com",
    "poh.ong",
    "poh.pp.ua",
    "pohotmi.cf",
    "pohotmi.ga",
    "pohotmi.ml",
    "pohotmi.tk",
    "pohydalka.ru",
    "poi123.com",
    "point2usa.com",
    "pointampl.xyz",
    "pointcreator.com",
    "pointfe.xyz",
    "pointklick.com",
    "pointklick.net",
    "pointmade.pro",
    "pointri.email",
    "pointslot.com",
    "pointssurvey.com",
    "pointstr.cf",
    "pointstraffictickets.com",
    "pointtstrafficticket.com",
    "pointvisible.company",
    "poioijnkjb.cf",
    "poioijnkjb.ml",
    "poipet2go.com",
    "pois0n.su",
    "poisoncycles.com",
    "poisontech.net",
    "poissonsvivants.info",
    "poistaphdes.tk",
    "poiuuiop23.xyz",
    "pojieyuanma.com",
    "pojok.ml",
    "pokecalc.online",
    "pokeett.site",
    "pokemail.net",
    "pokemon-video.ru",
    "pokemongocoins.website",
    "pokemongodatabreach.com",
    "pokemonpost.com",
    "pokepost.com",
    "poker-boya.com",
    "poker837.online",
    "poker837.org",
    "poker855.mobi",
    "poker88asia.net",
    "poker933.net",
    "pokerasean.com",
    "pokerbandar77.com",
    "pokerbandar77.org",
    "pokerbaz.club",
    "pokerbet99.com",
    "pokercad47.net",
    "pokercashqq.biz",
    "pokercashqq.net",
    "pokercemeku.com",
    "pokercmi.info",
    "pokercuan.club",
    "pokerdomonline.online",
    "pokerdong88.com",
    "pokerduo.com",
    "pokerface.dk",
    "pokergemini.org",
    "pokeriran.info",
    "pokeriran.net",
    "pokerkilat.org",
    "pokerlegendanew.com",
    "pokerlena.club",
    "pokermilenia.info",
    "pokermilenia.net",
    "pokermilenia.org",
    "pokeronlinecc1.xyz",
    "pokerorion.biz",
    "pokerorion.online",
    "pokersaya.com",
    "pokersbo338.club",
    "pokersbo338.org",
    "pokersctv.biz",
    "pokerseal-my.com",
    "pokersgg.com",
    "pokersolusiwin.com",
    "pokerterpercaya.fun",
    "pokertexas1001.com",
    "pokertexas77.com",
    "pokertexasidn.com",
    "pokerting.org",
    "pokerwalet123.com",
    "pokerwin99.com",
    "pokerzilla126.xyz",
    "pokerzilla127.xyz",
    "pokerzo.biz",
    "poketta.cf",
    "poketta.gq",
    "poketta.ml",
    "poketta.tk",
    "pokeymoms.org",
    "pokiemobile.com",
    "pokoshop.se",
    "pokostand.se",
    "pokostore.se",
    "pokupai-mili.ru",
    "pokupai-vsegda.ru",
    "pokupaska24.ru",
    "polaab.com",
    "polacy-dungannon.tk",
    "polandmail.com",
    "polarcdn-static-staging.com",
    "polarkingxx.ml",
    "polasela.com",
    "polatlicocukdiyari.com",
    "polbox.com",
    "polemarh.ru",
    "polenokol.ru",
    "polenomir.ru",
    "polespanki.icu",
    "polet-pallet.ru",
    "polezno-znati.ru",
    "policeoffice.com",
    "policity.ml",
    "policity.tk",
    "policyofliberty.com",
    "poliden.me",
    "poliglot-16.ru",
    "polija.ru",
    "polikaser.tk",
    "polikasret.ml",
    "polimi.ml",
    "polina777.ru",
    "polinom.ga",
    "polioneis-reborb.com",
    "polisabrn.gq",
    "polisetr.ml",
    "polishxwyb.com",
    "polistand.site",
    "polit-konsultant.ru",
    "polit-tehnologiya.ru",
    "polit-tekhnologiya.ru",
    "politgator.ru",
    "political101.com",
    "politicalcripple.com",
    "politicfree.news",
    "politichesko.info",
    "politician.com",
    "politicsultra.com",
    "politika24.info",
    "politikerclub.de",
    "politprognoz.club",
    "polittehnologiya.ru",
    "polittekhnologiya.ru",
    "poliusraas.tk",
    "polizasaduana.com",
    "polizisten-duzer.de",
    "polka-shkaff.ru",
    "polkaarsenal.com",
    "polkadot.tk",
    "polkaidot.ml",
    "polkars.online",
    "polkarsenal.com",
    "polkretoiut.gq",
    "pollardbase.com",
    "pollrokr.net",
    "pollsthatpay.com",
    "pollys.me",
    "polmaru.cf",
    "polmaru.ga",
    "polnaserdew.ga",
    "polobet312.com",
    "polobet313.com",
    "polobet314.com",
    "poloozz.cloud",
    "polopowdhz.space",
    "polosous.com",
    "polovaz.website",
    "polplitka.ru",
    "polpuzzcrab.ga",
    "polpuzzcrab.gq",
    "polpuzzcrab.tk",
    "polres-aeknabara.cf",
    "polskaprawna.site",
    "poltovec.com",
    "poly-swarm.com",
    "polybrow.com",
    "polycast-china.com",
    "polycast-suzhou.com",
    "polycoco.com",
    "polyfaust.com",
    "polyformat.media",
    "polymnestore.co",
    "polymorph.icu",
    "polynoxe.ru",
    "polyor.xyz",
    "polyswarms.com",
    "polyvore.name",
    "polzavredka.com",
    "pomeranianboo.org",
    "pomeroyohs.info",
    "pomifo.info",
    "pomsiese.ru",
    "pomsux.xyz",
    "ponabana.info",
    "ponabana.org",
    "ponahakizaki.xyz",
    "ponatcyrr.ga",
    "ponatcyrr.tk",
    "ponce.works",
    "ponenes.info",
    "poney.xyz",
    "pongueme.cf",
    "pongueme.ga",
    "pongueme.tk",
    "pongwonproductions.com",
    "ponibo.com",
    "ponili.cf",
    "ponili.ga",
    "ponili.gq",
    "ponili.ml",
    "ponili.tk",
    "ponmejudg.cf",
    "ponmejudg.ga",
    "ponmejudg.gq",
    "ponmejudg.tk",
    "ponp.be",
    "pontorez.site",
    "pontstoudar.tk",
    "pony-shop.ru",
    "ponyxchange.store",
    "pooae.com",
    "poochtimberscuba.site",
    "poofy.org",
    "poohfan.com",
    "pookmail.com",
    "pool-plastering.com",
    "pool-sharks.com",
    "poolandliving.com",
    "poolfared.ml",
    "poond.com",
    "poopiebutt.club",
    "poopouri.ru",
    "pop-under.ru",
    "pop3.ru",
    "pop3.xyz",
    "popaccount.com",
    "popanda.website",
    "popander.net",
    "popbangphotography.com",
    "popbum.com",
    "popcavmire.ru",
    "popconn.party",
    "popcornflix-free.site",
    "popcornforrefugees.com",
    "popculturetopics.com",
    "popdrunk.com",
    "popesodomy.com",
    "popgeekcollectables.com",
    "popgx.com",
    "popinapp.com",
    "popinfo.ru",
    "popinmusic.com",
    "popjav.ninja",
    "popjob.us",
    "popk-77.com",
    "popk-me.com",
    "popmail.com",
    "popmail.io",
    "popmailserv.org",
    "popme.dk",
    "popmints.app",
    "popofish.com",
    "poppadomtakeaway.com",
    "poppermccormick.com",
    "poppopbattlej.com",
    "poppyalwaz.site",
    "poppyscroll.com",
    "popsissi.com",
    "popsmail.com",
    "popso.cf",
    "popso.ga",
    "popso.gq",
    "popso.ml",
    "popso.tk",
    "popsok.cf",
    "popsok.ga",
    "popsok.gq",
    "popsok.ml",
    "popsok.tk",
    "popstar.com",
    "popteen4u.com",
    "populaire.pro",
    "popularabutiker.se",
    "popularbook.se",
    "populatin.space",
    "populus.net",
    "popunder.biz",
    "poq9sm.us",
    "poradcamaklera.sk",
    "poraza.com",
    "porch-pride-slight-feathers.xyz",
    "porco.cf",
    "porco.ga",
    "porco.gq",
    "porco.ml",
    "pordiosw.com",
    "porfitdota.fun",
    "poring-ro.com",
    "porkpolice.com",
    "porno-figa.online",
    "pornoseti.com",
    "pororogoreng.top",
    "porororebus.top",
    "porovozik.ru",
    "porrect.xyz",
    "porschcourtsettlement.com",
    "porschcourtsettlements.com",
    "porsche-brasil.club",
    "porsche-destination-charging.com",
    "porsche-emisiones0.com",
    "porsche-macan.club",
    "porschedealersacramento.com",
    "porsh.net",
    "porta.loyalherceghalom.ml",
    "portableearthing.com",
    "portableoffice.com",
    "portageut.buzz",
    "portailbijou.com",
    "portal56.xyz",
    "portal7.ru",
    "portalbrasileiro.online",
    "portaldenoticiasbrasil.site",
    "portaldenovidades.site",
    "portaldoagora.xyz",
    "portaldosbrasileiros.site",
    "portaleanimali.com",
    "portaleanimali.net",
    "portalninjas.com",
    "portalprimavera.xyz",
    "portalweb.icu",
    "portatiles.online",
    "portelatutoriais.com",
    "porterandclarkchiropractic.com",
    "portesdegarage.quebec",
    "portha-stephane.space",
    "porthtatin.ga",
    "porthtatin.gq",
    "porthtatin.ml",
    "porthtatin.tk",
    "portic.xyz",
    "porticoresidence.com",
    "porticullus.com",
    "portland5g.net",
    "portland5g.org",
    "portlandintegritasadvisors.info",
    "portlandnailsalons.com",
    "portlandsocietypage.net",
    "portlenso.cf",
    "portlenso.ga",
    "portobello-pizza-cafe.com",
    "portobelobrew.com",
    "portobet2019.club",
    "portosharmelsheikhresort.xyz",
    "portovelo.com",
    "portsefor.ga",
    "portsefor.ml",
    "portsefor.tk",
    "porttttooo90.club",
    "portubeautiful.tech",
    "portugal-choco-late.online",
    "portugal-chocolate.club",
    "portugal-chocolate.online",
    "portugalchocolate.host",
    "portugalmail.com",
    "portugalmail.pt",
    "portugalnet.com",
    "portugalresidencial.com",
    "portxedna.cf",
    "portxedna.ga",
    "portxedna.gq",
    "portxedna.tk",
    "pos-graduacao-lato-sensu.com",
    "posatlanta.net",
    "posdz.com",
    "posehigm.space",
    "poselokvoskresenki.ru",
    "poserpostageserif.site",
    "poseyweddings.com",
    "poshdine.com",
    "positive-thinking.com",
    "positive.bet",
    "posmayma.cf",
    "posmayma.gq",
    "posmayma.ml",
    "posmayma.tk",
    "posov.info",
    "post-shift.ru",
    "post.com",
    "post.cz",
    "post.melkfl.es",
    "post.sk",
    "post.tele.dk",
    "post0.profimedia.net",
    "posta.net",
    "posta.ro",
    "posta.rosativa.ro.org",
    "posta.store",
    "postaccesslite.com",
    "postacin.com",
    "postafiok.hu",
    "postafree.com",
    "postalmail.biz",
    "postaweb.com",
    "postbenua.ru",
    "postcards4change.net",
    "postcardsfromukraine.crowdpress.it",
    "postcm.com",
    "postdated.email",
    "poste-it.xyz",
    "poste-recherche.xyz",
    "poste.it",
    "postely-dream.ru",
    "postemail.net",
    "posteo.af",
    "posteo.at",
    "posteo.be",
    "posteo.ch",
    "posteo.cl",
    "posteo.co",
    "posteo.co.uk",
    "posteo.com.br",
    "posteo.cr",
    "posteo.cz",
    "posteo.de",
    "posteo.dk",
    "posteo.ee",
    "posteo.es",
    "posteo.eu",
    "posteo.fi",
    "posteo.gl",
    "posteo.gr",
    "posteo.hn",
    "posteo.hr",
    "posteo.hu",
    "posteo.ie",
    "posteo.in",
    "posteo.is",
    "posteo.jp",
    "posteo.la",
    "posteo.li",
    "posteo.lt",
    "posteo.lu",
    "posteo.me",
    "posteo.mx",
    "posteo.my",
    "posteo.net",
    "posteo.nl",
    "posteo.no",
    "posteo.nz",
    "posteo.org",
    "posteo.pe",
    "posteo.pl",
    "posteo.pm",
    "posteo.pt",
    "posteo.ro",
    "posteo.ru",
    "posteo.se",
    "posteo.sg",
    "posteo.si",
    "posteo.tn",
    "posteo.uk",
    "posteo.us",
    "posterxmtw.space",
    "postfach.cc",
    "postfach2go.de",
    "postgres-replication.org",
    "posthava.cf",
    "posthava.ga",
    "posthava.gq",
    "posthava.tk",
    "posthectomie.info",
    "postheo.de",
    "posthet.stream",
    "posthoxnxx.space",
    "postinbox.com",
    "postino.ch",
    "postino.de",
    "postino.it",
    "postkaso.tk",
    "postlame.cf",
    "postlame.ga",
    "postlame.gq",
    "postlame.ml",
    "postlame.tk",
    "postmail1.ru",
    "postman.dk",
    "postmark.net",
    "postmaster.co.uk",
    "postmaster.twitter.com",
    "postmate.delivery",
    "postmen.online",
    "postnetftent.gq",
    "postnetftent.ml",
    "postnetftent.tk",
    "postonline.me",
    "postpro.net",
    "postshift.ru",
    "poststand.com",
    "posttrade360.se",
    "posurl.ga",
    "posvabotma.x24hr.com",
    "poszkodowani.info",
    "potasf.com",
    "potdropcrampo123n.ru",
    "potdropcrampon.ru",
    "potechinltd.ru",
    "potemalls.site",
    "potencialex-it.site",
    "potencialexone.ru",
    "potencialexstore.ru",
    "potencialis.info",
    "potencid.ru",
    "potencis.ru",
    "potencyalex.ru",
    "potenz-drink.com",
    "potenzialex149.ru",
    "potenzshot.com",
    "potolki-voronezh.ru",
    "potshisha.com",
    "potterymediaco.com",
    "pottingerperspectives.com",
    "pottytrainingchamp.com",
    "poulsen.dk",
    "pounduni.us",
    "poundwise.app",
    "pourforme.com",
    "pourover.dev",
    "pousa.com",
    "poutineyourface.com",
    "poutokilas.ga",
    "povesticopii.info",
    "povu.site",
    "povuoutlet.site",
    "povzcz.shop",
    "pow.photo",
    "powaylawyers.com",
    "powcoin.net",
    "powcoins.com",
    "power5mastermind.com",
    "powerbank-russia.ru",
    "powerbike.de",
    "powercontinuitysystems.com",
    "powerdivas.com",
    "powerdra.us",
    "powered.name",
    "powerempleo.com",
    "powerencry.com",
    "powerexsys.com",
    "powerfan.com",
    "powerfivemastermind.com",
    "powerforce.site",
    "powerfulultraextract.com",
    "powerhousedyno.com",
    "powerin.site",
    "powerlea.xyz",
    "powerlear.xyz",
    "powerlink.com.np",
    "powermass.site",
    "powerml.racing",
    "powerpages.website",
    "powerpls.xyz",
    "powerpressed.com",
    "powerpressites.com",
    "powersala.com",
    "powertaser.tk",
    "powerwashchemicals.com",
    "powerwashcompany.org",
    "powerwashersmd.com",
    "powerwashersmd.xyz",
    "powewashing.mobi",
    "powlearn.com",
    "poww.me",
    "poxot.org",
    "poxudeykina.ru",
    "poy.e-paws.net",
    "poy.kr",
    "pozitiv.ru",
    "poznakomstvy.ru",
    "pozunusec.com",
    "pp.inet.fi",
    "pp.ua",
    "pp18269.com",
    "pp57822.com",
    "pp916.com",
    "pp98.cf",
    "pp98.ga",
    "pp98.gq",
    "pp98.ml",
    "pp98.tk",
    "ppabldwzsrdfr.cf",
    "ppabldwzsrdfr.ga",
    "ppabldwzsrdfr.gq",
    "ppabldwzsrdfr.ml",
    "ppabldwzsrdfr.tk",
    "ppapa.ooo",
    "pparlrrraaiggraaam.club",
    "pparsgorrem.club",
    "ppav05.xyz",
    "ppav07.xyz",
    "ppb778.com",
    "ppbill247.com",
    "ppc-e.com",
    "ppc-trafic.ru",
    "ppcoy.com",
    "ppcwoo.org",
    "ppdev.org",
    "ppdhub.best",
    "ppetw.com",
    "ppgu8mqxrmjebc.ga",
    "ppgu8mqxrmjebc.gq",
    "ppgu8mqxrmjebc.ml",
    "ppgu8mqxrmjebc.tk",
    "ppiqglobal.com",
    "ppixorea.site",
    "ppldnzyo.pro",
    "ppmoazqnoip2s.cf",
    "ppmoazqnoip2s.ga",
    "ppmoazqnoip2s.gq",
    "ppmoazqnoip2s.ml",
    "ppnet.ru",
    "ppnncc.com",
    "ppodkeye.site",
    "ppodkeyr.site",
    "ppoker99.com",
    "ppp9827.com",
    "pppoirasigram.club",
    "pprostitutki-samara.info",
    "ppsapta.info",
    "ppsapta.net",
    "ppsekosovo.org",
    "ppsindonesia.com",
    "ppstat.ru",
    "ppx219.com",
    "ppx225.com",
    "ppymail.win",
    "pq6fbq3r0bapdaq.cf",
    "pq6fbq3r0bapdaq.ga",
    "pq6fbq3r0bapdaq.gq",
    "pq6fbq3r0bapdaq.ml",
    "pq6fbq3r0bapdaq.tk",
    "pqhwcf.us",
    "pqoia.com",
    "pqoss.com",
    "pqpk.us",
    "pqtoxevetjoh6tk.cf",
    "pqtoxevetjoh6tk.ga",
    "pqtoxevetjoh6tk.gq",
    "pqtoxevetjoh6tk.ml",
    "pqtoxevetjoh6tk.tk",
    "pquoil.site",
    "pquw0o.com",
    "pqxdig.info",
    "pr0jectn1ne.com",
    "pr1ngsil4nmu.ga",
    "pr253.site",
    "pr5.info",
    "pr6312.xyz",
    "pr7979.com",
    "pra-22.com",
    "prabudhatravels.com",
    "pracapoplaca.online",
    "prachylith.ga",
    "prachylith.ml",
    "prachylith.tk",
    "pracnila.ga",
    "pracnila.gq",
    "pracnila.tk",
    "pracroxtdel.ga",
    "pracroxtdel.gq",
    "practicalfinace.com",
    "practicalsight.com",
    "practitionergrowthinstitute.com",
    "practitionerhosting.com",
    "practivity.net",
    "practizkts.ru",
    "pracylca.cf",
    "pracylca.ga",
    "pracylca.gq",
    "pracylca.ml",
    "pracylca.tk",
    "pradipmodi.website",
    "prado-mail.ru",
    "pradvice.ru",
    "praemj.us",
    "pragbet7.com",
    "pragmatic.rocks",
    "pragmatic.website",
    "prahalottery.info",
    "prahalottery.net",
    "prahalottery.org",
    "praize.com",
    "praktika.site",
    "pramitcasino.com",
    "prankish.buzz",
    "prankish.online",
    "prankish.site",
    "prankmarketing.com",
    "pranobun.cf",
    "pranobun.gq",
    "pranobun.ml",
    "pranobun.tk",
    "pranto.me",
    "prass.me",
    "pratik-ik.com",
    "pratincole.xyz",
    "pratlaydi.tk",
    "pratt.edu",
    "prava-ab.ru",
    "praveen.win",
    "pravorobotov.ru",
    "pravovoe-upravlenie.ru",
    "prawa-moskwa.ru",
    "prawa-msk.ru",
    "prawamoskva.ru",
    "prawamoskwa.ru",
    "pray247.com",
    "prayatnafikrkalki.ong",
    "prayersa3.com",
    "prazdnik-37.ru",
    "prazdnik-moy.ru",
    "prcclosings.com",
    "prcclosings.net",
    "prcclosings.us",
    "prchained.com",
    "prclez.website",
    "prclosing.info",
    "prclosing.org",
    "prclosing.us",
    "prclosings.biz",
    "prclosings.info",
    "prclosings.mobi",
    "prclosings.net",
    "prclosinqs.com",
    "prcloslngs.com",
    "prduefed.com",
    "pre188.website",
    "pre21marketing.com",
    "prebuilding.com",
    "preccompdes.cf",
    "preccompdes.gq",
    "preccompdes.ml",
    "precconta.cf",
    "precdate.ga",
    "precdate.gq",
    "precdate.ml",
    "precdate.tk",
    "precision.management",
    "precisiondoorhillsborough.com",
    "precisionmarina.management",
    "precisionmarinamanagement.com",
    "precisionroof.xyz",
    "precitpren.cf",
    "precitpren.gq",
    "predatorrat.cf",
    "predatorrat.ga",
    "predatorrat.gq",
    "predatorrat.ml",
    "predatorrat.tk",
    "predeathblog.com",
    "prediksihkjitu.online",
    "predilectionaz.com",
    "predizot.ga",
    "predizot.gq",
    "predizot.ml",
    "predmarkcent.ga",
    "predmarkcent.gq",
    "predmarkcent.tk",
    "predolenta.ru",
    "predprinimatel.ru",
    "predstalicinforofficial.ru",
    "prefactura.org",
    "prefixcom.com",
    "prefpargue.gq",
    "prefpargue.ml",
    "pregabalin-lyrica.site",
    "pregenicks.com",
    "pregnancybuddyapp.com",
    "pregunmer.cf",
    "pregunmer.ga",
    "pregunmer.gq",
    "pregunmer.ml",
    "preicfes.online",
    "prekuldown47mmi.ml",
    "preludelights.com",
    "premarex.ga",
    "premarex.ml",
    "premarex.tk",
    "prematurecope.info",
    "prembus.com",
    "premeiracharters.com",
    "premi2019.club",
    "premiair.media",
    "premier-coworking.com",
    "premier-reverse.com",
    "premierbetcasino.com",
    "premierclosing.com",
    "premiereatlantarealestate.com",
    "premierelivecasino.com",
    "premierloto.info",
    "premierlotto.net",
    "premieroralsurgeryandimplantsplc.info",
    "premieroralsurgeryandimplantsplc.us",
    "premierprivacy.com",
    "premierpropertymanagementde.com",
    "premiertech.africa",
    "premiertechapps.com",
    "premiertitle.biz",
    "premiertitle.info",
    "premiertitle.org",
    "premiertitleagency.net",
    "premiertitles.agency",
    "premisesplacegroup.com",
    "premium-mail.fr",
    "premiumail.ml",
    "premiumcannabis.online",
    "premiumcchelp.com",
    "premiumlabels.de",
    "premiumnezhealthcare.shop",
    "premiumneznaturalbeauty.shop",
    "premiumperson.website",
    "premiumproducts.com",
    "premiumservice.com",
    "premiumservisak.tk",
    "premiumsmartphonebonus.bid",
    "premiumvulkan.ru",
    "premmiere.biz",
    "premmiere.info",
    "prenekiz.cf",
    "prenekiz.ga",
    "prenekiz.gq",
    "prenekiz.ml",
    "prenu.icu",
    "preownedcarsdirect.com",
    "preownedluxurycars.com",
    "prepaidgallery.com",
    "preparedwealth.com",
    "preparee.top",
    "prepodavatel.ru",
    "preporod.online",
    "preridcer.cf",
    "preridcer.ga",
    "preridcer.ml",
    "presale.tk",
    "presanec.cf",
    "presanec.ga",
    "presanec.ml",
    "presanec.tk",
    "presaper.cf",
    "presaper.ga",
    "presaper.gq",
    "presaper.ml",
    "presblok.ru",
    "presci22ahkekstra.xyz",
    "prescriptionbagimprints.com",
    "prescriptiondeliveryservice.org",
    "presence.red",
    "preseven.com",
    "presfecdee.cf",
    "presfecdee.ga",
    "presfecdee.gq",
    "presfecdee.tk",
    "presidency.com",
    "presidentbidencoin.com",
    "presidentoto.com",
    "presinnil.cf",
    "presinnil.ga",
    "presinnil.gq",
    "presmolthi.cf",
    "presmolthi.ga",
    "presmolthi.ml",
    "presmolthi.tk",
    "presnya.net",
    "press-citrus.ru",
    "press-peacetalkwisdomdarter.com",
    "press.co.jp",
    "pressciynn.site",
    "presslemon.ru",
    "presslov.icu",
    "presster.com",
    "pressurecleaningperth.com",
    "pressurecookermadness.com",
    "pressuredell.com",
    "prestamosurgente.com",
    "prestashopcheck.xyz",
    "prestativo.pro",
    "presteg.com",
    "prestiligh.ga",
    "prestiligh.ml",
    "prestore.co",
    "prestudio48.xyz",
    "presunad.cf",
    "presunad.ga",
    "presunad.gq",
    "presunad.ml",
    "presunad.tk",
    "presuntab.cf",
    "presuntab.gq",
    "pret-a-renover-rona.com",
    "pret-a-renover.com",
    "preterits242ei.online",
    "pretesor.ga",
    "pretesor.ml",
    "prethlah907huir.cf",
    "pretoriuskoprestcamp.com",
    "prettierthanher.com",
    "prettileaves.com",
    "prettyandhealth.info",
    "prettybet1688.com",
    "prettylashes.co",
    "prettymanprettyman.com",
    "preventativeaction.com",
    "prevesme.cf",
    "prevesme.ga",
    "prevesme.gq",
    "prevesme.ml",
    "previewsitedesign.com",
    "previouslyknown.com",
    "prevueinfocus.com",
    "prewx.com",
    "preyantitheft.org",
    "preyapp.org",
    "preyhq.net",
    "preylondon.com",
    "preysecurity.com",
    "preytracker.com",
    "prhuws.shop",
    "price-depot.com",
    "price-shop-sale.ru",
    "priceantiques.info",
    "pricebit.co",
    "priceblog.co",
    "pricecanine.com",
    "pricegues.xyz",
    "priceio.co",
    "priceleech.xyz",
    "pricelinemovingandstorage.com",
    "pricemobile.info",
    "pricenew.co",
    "pricenow.co",
    "priceonline.co",
    "pricepage.co",
    "priceplunges.com",
    "pricetag.ru",
    "pricetegy.com",
    "pricetrac.xyz",
    "pricewarriors.com",
    "priceworld.co",
    "pricraball.cf",
    "pricraball.gq",
    "pricraball.tk",
    "pride.nafko.cf",
    "pride1.info",
    "pridemail.co",
    "pridetw.com",
    "priest.com",
    "priffer.net",
    "prigovormodoi.ru",
    "prihshop.ru",
    "prijzenfeest.com",
    "prilution-ag.info",
    "prilution-gmbh.com",
    "prilution-gmbh.org",
    "prilution.com",
    "prilution.info",
    "prim1v.us",
    "primabananen.net",
    "primaryvideos.com",
    "primasecure.cd",
    "primate.de",
    "prime-diets-plusstoresales.com",
    "primechoice.store",
    "primecostsolution.com",
    "primedenverrealty.com",
    "primejewlery.com",
    "primemedya.net",
    "primetbx.com",
    "primeturbinessms.com",
    "primevaluebeauty.com",
    "primevaluedeals.com",
    "primevaluedigital.com",
    "primevaluenutrition.com",
    "primevaluevitamins.com",
    "primewire-movies.biz",
    "primex.club",
    "primotor.com",
    "primposta.com",
    "primposta.hu",
    "primres.ru",
    "primrosejewelry.com",
    "primusmarkets.us",
    "prin.be",
    "princ-ro.com",
    "prince-khan.tk",
    "princeandassociatesrealty.com",
    "princecss.com",
    "princess4d.club",
    "princessbahis1.com",
    "princessbets.com",
    "princessbetsikayet1.com",
    "princessgardentakeaway.com",
    "princessgirisyap.com",
    "princeton2008.com",
    "principleinvestigator.com",
    "pringlang.cf",
    "pringlang.ga",
    "pringlang.gq",
    "pringlang.ml",
    "prinicad.cf",
    "prinicad.gq",
    "print.domains",
    "printala.cf",
    "printala.ga",
    "printala.gq",
    "printala.tk",
    "printcalendar.website",
    "printedposrolls.com",
    "printesamargareta.ro",
    "printf.cf",
    "printf.ga",
    "printf.ml",
    "printgh.icu",
    "printingchoice.com",
    "printingeveryday.com",
    "printlang.com",
    "println.fun",
    "printlu.recipes",
    "printofart.ru",
    "printsomemore.com",
    "printsui.xyz",
    "priobx.com",
    "priobx.net",
    "priorfiscalshake.site",
    "prioritysharpener.xyz",
    "priorityxn5.com",
    "priorlearningassessment.org",
    "prisellels.icu",
    "prismlasers.tk",
    "prisonerresources.com",
    "prisongarde.com",
    "pristinenaturecourse.com",
    "pristineused.com",
    "pristupozhireniya.ru",
    "prity.org",
    "priv.beastemail.com",
    "priv8dns.net",
    "privacy-mail.top",
    "privacy-protect-online.com",
    "privacy.net",
    "privacygirl.com",
    "privacygladiators.us",
    "privacyscores.com",
    "privacywi.com",
    "privat.dk",
    "privatdemail.net",
    "private-investigator-fortlauderdale.com",
    "private-mail.pro",
    "private-mail.se",
    "private-top-speed-webs.club",
    "privateeyemarketing.biz",
    "privategoldbanking.com",
    "privatehost.xyz",
    "privateinternetaccessz.com",
    "privateinvestigationschool.com",
    "privatemail.com",
    "privatemailinator.nl",
    "privatemassage.ru",
    "privateme.site",
    "privatemusicteacher.com",
    "privateprofileviewerforinsta.com",
    "privaterelay.appleid.com",
    "privatmail.dk",
    "privatpost.dk",
    "privebet7.com",
    "privebet9.com",
    "privilege.ru",
    "privilegebuzios.com",
    "privy-mail.com",
    "privy-mail.de",
    "privyinternet.com",
    "privyinternet.net",
    "privymail.de",
    "privyonline.com",
    "privyonline.net",
    "prixfixeny.com",
    "prixfor.com",
    "priyaanjalirai.us",
    "prize4d.net",
    "prizebaco.com",
    "prizeboxes.life",
    "prizepl.icu",
    "prizes-for-you.life",
    "prizes-place-here16.life",
    "prizes-place-here19.life",
    "prizesli.icu",
    "prizeslift.com",
    "prizmabet33.com",
    "prizmabet34.com",
    "prizmabet36.com",
    "prizmabet41.com",
    "prizmabet43.com",
    "prizmabet44.com",
    "prizmabet45.com",
    "prizmabet46.com",
    "prizmabet47.com",
    "prizmabet48.com",
    "prizmabet49.com",
    "prizmabet54.com",
    "prmail.top",
    "prn18.fun",
    "prn18.space",
    "prn18.website",
    "prn90.online",
    "prnewsnodes.com",
    "prnvid.fun",
    "prnvid.online",
    "prnvid.site",
    "prnvid.space",
    "prnvid.website",
    "pro-baby-dom.ru",
    "pro-hindey.ru",
    "pro-ribak.ru",
    "pro-salomon.ru",
    "pro-stg.com",
    "pro-stringers-shop.com",
    "pro-tab.site",
    "pro-tag.org",
    "pro-turism.ru",
    "pro-turisto.ru",
    "pro-zakony.ru",
    "pro.cloudns.asia",
    "pro.hu",
    "pro100girl.ru",
    "pro100magazine.ru",
    "pro33.icu",
    "proactivechirowellness.net",
    "proamulet.ru",
    "prob.icu",
    "probatelawarizona.com",
    "probemail.com",
    "probestsales.online",
    "probiv.xyz",
    "problematist.best",
    "problemreactionsolution.today",
    "problemreactionsolution.xyz",
    "probrali.cf",
    "probrali.ga",
    "probrali.ml",
    "proc.icu",
    "prochmalgvi.ml",
    "prochmalgvi.tk",
    "prochorpol.tk",
    "procrackers.com",
    "procturksen.ml",
    "procturksen.tk",
    "procvetaeva.ru",
    "prod-factory-official.ru",
    "prodence.com",
    "prodercei.ga",
    "prodercei.gq",
    "prodercei.ml",
    "prodesign.codes",
    "prodigy.net",
    "prodigy.net.mx",
    "prodigyproject.site",
    "prodleskea.ga",
    "prodleskea.tk",
    "prodmorlooo.cf",
    "prodmorlooo.ml",
    "prodojiz.ga",
    "prodojiz.gq",
    "prodojiz.ml",
    "produatthe.cf",
    "produatthe.gq",
    "produatthe.tk",
    "producerow.xyz",
    "product-27.ru",
    "productevo.com",
    "productfeedmanagement.com",
    "productpacking.com",
    "productrdr.com",
    "produktu.ru",
    "produtosdevendas.online",
    "proeasyweb.com",
    "proek-tmebel.ru",
    "proektsro.ru",
    "proelectrum.com",
    "proemail.ml",
    "proemlak.com",
    "proeng.se",
    "profane.ru",
    "profast.top",
    "profesional.ovh",
    "profesorsaracoglu.com",
    "professecrets.space",
    "professionaldentistfinder.com",
    "professionegommista.com",
    "professor.ru",
    "professoruniforms.com",
    "profetish.ru",
    "profileliving.com",
    "profilewatcher.website",
    "profiliebakankisiler1.club",
    "profilific.com",
    "profinin.cf",
    "profinin.ga",
    "profinin.tk",
    "profit-mats.ru",
    "profitableroimetrics.com",
    "profitresult.su",
    "profitresult.tech",
    "profitsave.online",
    "profitsmaximizer.net",
    "profizum.ru",
    "profmistde.cf",
    "profmistde.ga",
    "profmistde.gq",
    "profound.cloud",
    "profrasound.cf",
    "profrasound.ga",
    "profrasound.gq",
    "profrasound.tk",
    "profriend.ru",
    "proftippers.online",
    "proftruck.ru",
    "profwatereco.ru",
    "progameonline.ru",
    "progardens.website",
    "progdaly.gq",
    "progdaly.ml",
    "progdaly.tk",
    "progefel.cf",
    "progefel.ga",
    "progefel.gq",
    "progefel.ml",
    "progetplus.it",
    "prognozmk.ru",
    "programist.ru",
    "programmer.net",
    "programmingant.com",
    "programmingtree.ml",
    "programmymets.ru",
    "programozo.hu",
    "progrdessive.com",
    "progressi8ve.com",
    "progressive.tools",
    "progressiveenvironment.com",
    "progressiveenvironments.com",
    "progressproduction.org",
    "prohost24.ru",
    "prohostadvice.website",
    "proinbox.com",
    "projavys.gq",
    "projavys.ml",
    "projavys.tk",
    "project-xhabbo.com",
    "project2k.com",
    "projectcl.com",
    "projectearth.earth",
    "projecthollandia.shop",
    "projectku.me",
    "projectoxygen.com",
    "projectqq59.xyz",
    "projectsaam.com",
    "projectsgrid.com",
    "projekt.blue",
    "projexpartners.com",
    "projmenkows.cf",
    "projmenkows.ga",
    "projmenkows.gq",
    "projmenkows.tk",
    "proknowsphoto.com",
    "prokonto.pl",
    "prokuratura.ru",
    "prol.icu",
    "prolagu.pro",
    "prolaunch.com",
    "prolimeserver.com",
    "proljiggbo.gq",
    "proll.love",
    "promail.site",
    "promail9.net",
    "promaild.com",
    "promaill.com",
    "promails.xyz",
    "promailsite.info",
    "promailt.com",
    "promedcostarica.net",
    "promedicales.com",
    "promessage.com",
    "prometheusmedia.xyz",
    "promin-33.com",
    "prominentapp.com",
    "promisetoact.info",
    "promisetoact.org",
    "promisingartists.org",
    "promist-sa.com",
    "promistral.website",
    "promo-10let.online",
    "promo-claim.com",
    "promo-msk.com",
    "promo10let.online",
    "promocionespublicidad.com",
    "promoesperta.live",
    "promofessional.com",
    "promogsi.cf",
    "promogsi.ga",
    "promogsi.gq",
    "promogsi.ml",
    "promogsi.tk",
    "promoguven.xyz",
    "promokod-lamoda.ru",
    "promoonline.info",
    "promosbc.com",
    "promosbcbet.net",
    "promosbclive.com",
    "promosegur.com",
    "promot.site",
    "promotemd.com",
    "promotor.website",
    "promovizio.com",
    "promplast-okna.ru",
    "promptly700.com",
    "promsky.ru",
    "promstroy76.ru",
    "promtmt.ru",
    "pronailz.com",
    "pronkede.gq",
    "pronkede.ml",
    "pronkede.tk",
    "pronouns.org",
    "pronovopartners.com",
    "prontomail.com",
    "prontomail.compopulus.net",
    "prontonmail.com",
    "pronuncil.xyz",
    "proof-of-works.info",
    "proofridg.email",
    "prooftoug.xyz",
    "prooftrading.ru",
    "prooutboardmarine.com",
    "propagandizing586fv.online",
    "propartsupply.com",
    "propay-gate1.com",
    "propay-way1.com",
    "properevod.ru",
    "properpizzafinglas.com",
    "propertycockpit.com",
    "propertynath.icu",
    "propertyreal.rocks",
    "propertytalking.com",
    "prophballand.cf",
    "prophballand.ga",
    "prophballand.ml",
    "prophballand.tk",
    "prophecygamesnews.club",
    "propinned.cf",
    "propinned.ga",
    "propinned.gq",
    "propinned.ml",
    "propinned.tk",
    "proposal-store.site",
    "proppemus.ml",
    "proppemus.tk",
    "propranolol.website",
    "propressa.ru",
    "proprice.co",
    "proprietativalcea.ro",
    "propscore.com",
    "proptrader.site",
    "proq.icu",
    "prorabstroj.ru",
    "prosalab.ml",
    "prosalab.tk",
    "prosaransk.ru",
    "prosatdz.com",
    "prosatnab.ml",
    "prosequrity.com",
    "prosfereisimera.online",
    "prositeportal.ru",
    "prosperformula.com",
    "prosquashtour.net",
    "prosselte.ga",
    "prosselte.gq",
    "prosselte.ml",
    "prostitutki-kaliningrad.xyz",
    "prostitutki-kaluga-sochnie.xyz",
    "prostitutki-pskov.xyz",
    "prostitutki-saransk.xyz",
    "prostitutki-saratov.xyz",
    "prostitutki-tambov.xyz",
    "prostitutki-tomsk.xyz",
    "prostitutki-tver.xyz",
    "prostitutki-tyumen.xyz",
    "prosto-loto.press",
    "prosto-loto.website",
    "prosto-videohd.ru",
    "prosto-znai.ru",
    "prostoeseo.ru",
    "prostypodatek.info",
    "protechskillsinstitute.com",
    "protect-download.com",
    "protectanimals.com",
    "protection-0ffice365.com",
    "protectionmanagers.com",
    "protectrep.com",
    "protectsrilanka.com",
    "protectsyourmortgage.com",
    "protein-krasnodar.ru",
    "protein-razves.ru",
    "protein-saratov.ru",
    "proteintopper.com",
    "protempmail.com",
    "protestant.com",
    "protestly.com",
    "protestore.co",
    "protileroofing.com",
    "proto1rnfg.com",
    "proto2mail.com",
    "protologism.com",
    "proton-team.com",
    "proton.me",
    "protongras.ga",
    "protonmail.ch",
    "protonmail.com",
    "protovu.xyz",
    "proudtra.xyz",
    "proulx.site",
    "prousability.ru",
    "provable.cash",
    "provamail.com",
    "provebas.icu",
    "provera.website",
    "provetable.us",
    "provewai.xyz",
    "provewais.xyz",
    "providenceiloilo.com",
    "providencenailsalons.com",
    "providencestartups.com",
    "providentassetmanagement.org",
    "providier.com",
    "providkwtv.space",
    "provinceandstatepermitting.com",
    "provlst.com",
    "provmail.net",
    "provodow-net.ru",
    "provsoftprov.ga",
    "provsoftprov.gq",
    "prow.cf",
    "prow.ga",
    "prow.gq",
    "prow.ml",
    "prowerl.com",
    "proxsei.com",
    "proxymail.eu",
    "proxyparking.com",
    "proxysite.rocks",
    "proyectoser.org",
    "proyectosoft.com",
    "proz.icu",
    "prprtv.com",
    "prrassiigggrram.club",
    "prrply.com",
    "prrqll.site",
    "prs7.xyz",
    "prsg333.com",
    "prsg33c.com",
    "prsg3ab.com",
    "prsnly.com",
    "prspaybooking90.net",
    "prsym.info",
    "prtaxisy.info",
    "prtnx.com",
    "prtpoker.club",
    "prtshr.com",
    "prtxw.com",
    "prtz.eu",
    "pruchcongpo.cf",
    "pruchcongpo.ga",
    "prudesierrasheen.site",
    "prudigital.org",
    "prurls.com",
    "prwmqbfoxdnlh8p4z.cf",
    "prwmqbfoxdnlh8p4z.ga",
    "prwmqbfoxdnlh8p4z.gq",
    "prwmqbfoxdnlh8p4z.ml",
    "prwmqbfoxdnlh8p4z.tk",
    "prxnzb4zpztlv.cf",
    "prxnzb4zpztlv.ga",
    "prxnzb4zpztlv.gq",
    "prxnzb4zpztlv.ml",
    "prxnzb4zpztlv.tk",
    "pryamieruki.ru",
    "prydirect.info",
    "pryfix.com",
    "prymer.com",
    "ps-gr5-79-online.com",
    "ps160.mpm-motors.cf",
    "ps21cn.com",
    "ps3pay.ru",
    "ps4pay.ru",
    "ps4plus.tk",
    "ps5.community",
    "ps9000.com",
    "psa18.com",
    "psacake.me",
    "psaleshow.site",
    "psalmody.site",
    "psb55.space",
    "psbzu8.com",
    "psecu.xyz",
    "psellhit.online",
    "psettinge5.com",
    "pseudobslq.site",
    "pseudoname.io",
    "pseudorlhc.ru",
    "psfy.net",
    "psg-45-r.top",
    "psg45r.one",
    "psgr579online.com",
    "psh.me",
    "psh15.info",
    "psi.net",
    "psilocybindispensary.com",
    "psilocybindosing.com",
    "psilocybinfacts.com",
    "psilotech.com",
    "psiolog.com",
    "psirens.icu",
    "psk3n.com",
    "pskov.website",
    "psles.com",
    "pslog.ru",
    "psmi.club",
    "psminds.online",
    "psnator.com",
    "psncl.com",
    "psnplus.cf",
    "psnplus.ml",
    "pso365.org",
    "psomiadis.shop",
    "psoriasisvrij.online",
    "psoxs.com",
    "psppaygate.info",
    "psppaygate.org",
    "psqf.xyz",
    "psr1225.club",
    "pstv.live",
    "psv-supporter.com",
    "psych.social",
    "psychclinicsmd.com",
    "psychdegreedeal.xyz",
    "psychdegreenow.xyz",
    "psychedelicwarrior.xyz",
    "psychiccrystalsunshine.com",
    "psychmdconsulting.com",
    "psychmdus.com",
    "psychmdus.org",
    "psychological.fun",
    "psychologist-prof.ru",
    "psychologize694rf.online",
    "psychologues-clermont-ferrand.com",
    "psyhicsydney.com",
    "psylrd.com",
    "pszxxh.us",
    "pt-bt.com",
    "pt-cto.net",
    "pt-cto.org",
    "pt062.site",
    "pt3-ggle.com",
    "ptaddfan.com",
    "ptautomation.us",
    "ptbm.net",
    "ptc.vuforia.us",
    "ptcks1ribhvupd3ixg.cf",
    "ptcks1ribhvupd3ixg.ga",
    "ptcks1ribhvupd3ixg.gq",
    "ptcks1ribhvupd3ixg.ml",
    "ptcks1ribhvupd3ixg.tk",
    "ptcto.net",
    "ptd.net",
    "pterippi.info",
    "pterodactyl.email",
    "ptfawyuwk.shop",
    "ptgeua.us",
    "ptgptgmdzsmqtutqg.ru",
    "ptgtar7lslnpomx.ga",
    "ptgtar7lslnpomx.ml",
    "ptgtar7lslnpomx.tk",
    "pth82.space",
    "pthoe.live",
    "pticamp.com",
    "ptilonorhynchinae.best",
    "ptimtailis.cf",
    "ptimtailis.ga",
    "ptimtailis.gq",
    "ptll5r.us",
    "ptmm.com",
    "ptolbv.info",
    "ptpigeaz0uorsrygsz.cf",
    "ptpigeaz0uorsrygsz.ga",
    "ptpigeaz0uorsrygsz.gq",
    "ptpigeaz0uorsrygsz.ml",
    "ptpigeaz0uorsrygsz.tk",
    "ptprosetown.com",
    "ptsdcure.us",
    "ptsdhelp.club",
    "ptsystemsandautomation.com",
    "pttj.de",
    "pttmdtquszututqu.ru",
    "ptulce.icu",
    "ptv98667.xyz",
    "ptvans.com",
    "ptxaez.us",
    "ptyuch.ru",
    "ptzprint.ru",
    "puabezwzj.shop",
    "pubfgyh.com",
    "pubfilmz.com",
    "pubgasdw.xyz",
    "pubgeresnrpxsab.cf",
    "pubgeresnrpxsab.ga",
    "pubgeresnrpxsab.gq",
    "pubgeresnrpxsab.ml",
    "pubgeresnrpxsab.tk",
    "pubgm.website",
    "pubgmlive.shop",
    "pubgmplay.shop",
    "pubjye.us",
    "publeocasa.com",
    "publi.innovatio.es",
    "public-files.de",
    "public.usa.com",
    "publicdomain.graphics",
    "publichosting.org",
    "publichub-vpn.net",
    "publicist.com",
    "publicobituary.com",
    "publicreports.net",
    "publicreports.org",
    "publicschooltalk.com",
    "publictracker.com",
    "publish316.com",
    "pubmail886.com",
    "pubpng.com",
    "pubs.ga",
    "pubwarez.com",
    "puchimail.club",
    "puchmlt0mt.ga",
    "puchmlt0mt.gq",
    "puchmlt0mt.tk",
    "puchong.org",
    "puckingstinks.com",
    "puclyapost.ga",
    "pucp.de",
    "pudra-style.ru",
    "puds5k7lca9zq.cf",
    "puds5k7lca9zq.ga",
    "puds5k7lca9zq.gq",
    "puds5k7lca9zq.ml",
    "puds5k7lca9zq.tk",
    "pueblosabandonados.com",
    "puerentdeepf.ga",
    "puertoricodmv.com",
    "puevwwfo.shop",
    "pufcava.ga",
    "puffandscruff.com",
    "puffsreworksheet.site",
    "puglieisi.com",
    "puh4iigs4w.cf",
    "puh4iigs4w.ga",
    "puh4iigs4w.gq",
    "puh4iigs4w.ml",
    "puh4iigs4w.tk",
    "puhetrade37.xyz",
    "puhetrade8.xyz",
    "puhgva.us",
    "puhovska.ru",
    "puhuleather.com",
    "puipui1012.online",
    "puiw.website",
    "puji.pro",
    "puju.site",
    "puk.us.to",
    "pukaemporium.site",
    "pukeymcpukerson.com",
    "pukimay.cf",
    "pukimay.ga",
    "pukimay.gq",
    "pukimay.ml",
    "pukimay.tk",
    "puks.de",
    "pulford.ru",
    "pulibetyenigiris.xyz",
    "pulivetv17.com",
    "pulivetv19.com",
    "pullcombine.com",
    "pullmail.info",
    "pullovitos.com",
    "pulltract.info",
    "pulocasino.com",
    "pulp-fiction.com",
    "pulpieve.cf",
    "pulpieve.gq",
    "pulpieve.ml",
    "pulpmail.us",
    "pulsarfinans.ru",
    "pulsarpay.net",
    "pulse-original.ru",
    "pulsedlife.com",
    "pulseofthestreets.com",
    "pulsepad.com",
    "pulverize136es.online",
    "pulwarm.net",
    "pumamaning.cf",
    "pumamaning.ml",
    "pumapumayes.cf",
    "pumapumayes.ml",
    "pumaturkiye.net",
    "pumps-fashion.com",
    "pumznyto.shop",
    "puncakyuk.com",
    "punchclose.us",
    "punchhillaryclinton.com",
    "punchothe.icu",
    "punchratio.buzz",
    "punchs.solutions",
    "punchsl.fun",
    "punchst.xyz",
    "punctal.site",
    "punctuahoud.cf",
    "punctuahoud.gq",
    "punggur.tk",
    "pungkiparamitasari.com",
    "punjabibynatureranelagh.com",
    "punjabihousetakeaway.com",
    "punkass.com",
    "puperopres.site",
    "puphemfm.shop",
    "pupilaren.email",
    "pupilfeig.us",
    "pupillbpei.space",
    "pupilpa.icu",
    "pupilpri.xyz",
    "pupilsout.icu",
    "puppers.world",
    "puppetmail.de",
    "puppy.com.my",
    "puppy.watch",
    "puppyhome.us",
    "puppynames.info",
    "puppyplace.xyz",
    "puppyproduct.com",
    "purati.cf",
    "purati.ga",
    "purati.tk",
    "purcell.email",
    "purchasight.com",
    "purchasingdvdonline.com",
    "purchasingdvdonline.info",
    "purchasingdvdonline.net",
    "purchasingdvdonline.org",
    "purchasingpatty.com",
    "purdue.edu",
    "pure-indian-takeaway.com",
    "pureaucratic.info",
    "pureclean.ltd",
    "purecleanwipes.com",
    "purefitness.xyz",
    "pureindianrathcoole.com",
    "pureindianrush.com",
    "pureindiantakeaway.com",
    "pureism.org",
    "purelogistics.org",
    "purelycasual.com",
    "purelyrics.biz",
    "purenudist.site",
    "pureoxide.net",
    "pureoxide.org",
    "purepsilocin.com",
    "purestagioni.com",
    "pureunderwater.com",
    "purewcms.com",
    "purimaslombok.com",
    "purimasresort.com",
    "purinmail.com",
    "purism.net",
    "purist.info",
    "puristical.best",
    "puristparty.com",
    "purists.info",
    "puritagpax.space",
    "puritis.org",
    "puriwaki.com",
    "purlvvhz.space",
    "purple.amsterdam",
    "purple.dev",
    "purple.flu.cc",
    "purple.igg.biz",
    "purple.nut.cc",
    "purple.usa.cc",
    "purplea.com",
    "purpleflowerdesignshop.com",
    "purplegracecrafts.com",
    "purpleheartcoffee.com",
    "purplemail.ga",
    "purplemail.gq",
    "purplemail.ml",
    "purplemail.tk",
    "purplepuppy.info",
    "purplest.dev",
    "purpleturtle.com",
    "purposeinvestmentclub.com",
    "purposeinvestor.com",
    "purposeinvestorclub.com",
    "purposeinvestors.com",
    "purposeinvestorsclub.com",
    "purposepottery.com",
    "pursm.org",
    "purtus.com",
    "purves-fan.club",
    "pusakaqq.org",
    "pusclekra.cf",
    "pusclekra.gq",
    "pusclekra.tk",
    "push19.ru",
    "pushbroom.biz",
    "pushbroom.us",
    "pushechkin.ru",
    "pushmojo.com",
    "pushstate.xyz",
    "pushxxx.ru",
    "pushysbikes.bike",
    "pustaka-anime.com",
    "pustakapagi.xyz",
    "pustmati.cf",
    "pustmati.ga",
    "pustmati.gq",
    "pustmati.ml",
    "put2.net",
    "putfs6fbkicck.cf",
    "putfs6fbkicck.ga",
    "putfs6fbkicck.gq",
    "putfs6fbkicck.ml",
    "putfs6fbkicck.tk",
    "putinism.org",
    "putlocker-free.site",
    "putlockerfree.biz",
    "putlockerold.com",
    "putlockers1.club",
    "putonyourbigboypants.com",
    "putoshops.site",
    "putrashop.online",
    "putsbox.com",
    "puttana.cf",
    "puttana.ga",
    "puttana.gq",
    "puttana.ml",
    "puttana.tk",
    "puttanamaiala.tk",
    "putthidkr.ga",
    "putthisinyourspamdatabase.com",
    "puttingpv.com",
    "puukkoknives.com",
    "puurspa.com",
    "puxyzufi.space",
    "puyenkgel50ccb.ml",
    "puzzspychmusc.ga",
    "pv575.top",
    "pvccbyat.shop",
    "pvccephe.com",
    "pvccephegiydirme.com",
    "pvcfigure.net",
    "pvckomplekt.ru",
    "pvlnpa.shop",
    "pvmail.pw",
    "pvo-korf.ru",
    "pvokhu.shop",
    "pvoqwm.com",
    "pvqotb.com",
    "pvtnetflix.com",
    "pvvfir2emwv8yoz.xyz",
    "pw-mail.cf",
    "pw-mail.ga",
    "pw-mail.gq",
    "pw-mail.ml",
    "pw-mail.tk",
    "pw.epac.to",
    "pw.flu.cc",
    "pw.igg.biz",
    "pw.islam.igg.biz",
    "pw.loyalherceghalom.ml",
    "pw.nut.cc",
    "pw.r4.dns-cloud.net",
    "pw8999.com",
    "pwbs.de",
    "pwddslwk.shop",
    "pwjsdgofya4rwc.cf",
    "pwjsdgofya4rwc.ga",
    "pwjsdgofya4rwc.gq",
    "pwjsdgofya4rwc.ml",
    "pwjsdgofya4rwc.tk",
    "pwl7xn.us",
    "pwm0vr.com",
    "pwn-me.org",
    "pwnhome.org",
    "pwp.lv",
    "pwrby.com",
    "pwstory.com",
    "pwt9azutcao7mi6.ga",
    "pwt9azutcao7mi6.ml",
    "pwt9azutcao7mi6.tk",
    "pwvco.us",
    "pwyc.us",
    "pwyopkfyh.shop",
    "px0dqqkyiii9g4fwb.cf",
    "px0dqqkyiii9g4fwb.ga",
    "px0dqqkyiii9g4fwb.gq",
    "px0dqqkyiii9g4fwb.ml",
    "px0dqqkyiii9g4fwb.tk",
    "px1978.com",
    "px1982.com",
    "px1993.com",
    "px1995.com",
    "px2019.com",
    "px2022.com",
    "px2027.com",
    "px2030.com",
    "pxddcpf59hkr6mwb.cf",
    "pxddcpf59hkr6mwb.ga",
    "pxddcpf59hkr6mwb.gq",
    "pxddcpf59hkr6mwb.ml",
    "pxddcpf59hkr6mwb.tk",
    "pxdhx.com",
    "pxenc1.site",
    "pxey8q.us",
    "pxkejz.site",
    "pxlink.xyz",
    "pxltrck.site",
    "pxqpma.ga",
    "pxtv02fbb830f53fcd46.xyz",
    "pxtv052d46b7e333b664.xyz",
    "pxtv0e80b6e5b469e8dc.xyz",
    "pxtv15c3f2c6e0ce2b37.xyz",
    "pxtv1c4cb8a428306c18.xyz",
    "pxtv2a957f7925521397.xyz",
    "pxtv2ba2369697313665.xyz",
    "pxtv2bcdd23327c95645.xyz",
    "pxtv2d9adfcce7badf9a.xyz",
    "pxtv2da8c6b4f6c5f609.xyz",
    "pxtv47938c1abc5b0fb2.xyz",
    "pxtv4975b124e768c0c5.xyz",
    "pxtv56c76c80b948b92a.xyz",
    "pxtv5a9713e9f4884e77.xyz",
    "pxtv5f3e9d6d504d3747.xyz",
    "pxtv76d86c9fb5842817.xyz",
    "pxtv7ffb0688ed4b62d3.xyz",
    "pxtv92b6bc897bd3ae7e.xyz",
    "pxtv9d1d82bf02769321.xyz",
    "pxtv9fc0a7ba354c7414.xyz",
    "pxtv9fdb408c839f7bef.xyz",
    "pxtvaca2f59556310d1a.xyz",
    "pxtvb1cd59241d2ecad0.xyz",
    "pxtvb41725948393cdb1.xyz",
    "pxtvb7ecc35998763423.xyz",
    "pxtvba9f33264c730559.xyz",
    "pxtvc43ceea8c19f8b8f.xyz",
    "pxtvc730cd765f8ccaa6.xyz",
    "pxtvcdf107c513b6bbed.xyz",
    "pxtvce6bfea0acc199ac.xyz",
    "pxtvd2d53c5962145210.xyz",
    "pxtvd4b4f44519b19133.xyz",
    "pxtvd57d8c47cdc4d157.xyz",
    "pxtvd858ed4383c32edf.xyz",
    "pxtvd8d2938503a8b98b.xyz",
    "pxtvda22249eee0a5404.xyz",
    "pxtve0a673c78100922a.xyz",
    "pxtve75a99c51a60b4bf.xyz",
    "pxtvf8512d95d986b2c2.xyz",
    "pxtvfd5b6b0fb2c72eca.xyz",
    "pxtvff80d85f158b627e.xyz",
    "pxzsonxu.shop",
    "py0x.icu",
    "pyadu.com",
    "pyahoo.com",
    "pyatigorskhot.info",
    "pyekwl1.com",
    "pyevr6.us",
    "pygmypuff.com",
    "pyhtml.com",
    "pyiauje42dysm.cf",
    "pyiauje42dysm.ga",
    "pyiauje42dysm.gq",
    "pyiauje42dysm.ml",
    "pyiauje42dysm.tk",
    "pyiev.com",
    "pyjrn.us",
    "pylondata.com",
    "pylonhub.com",
    "pymjj.com",
    "pymjrhwu.shop",
    "pynbwr.us",
    "pynsak.us",
    "pyongyanglottery.info",
    "pyribby.live",
    "pyrokiwi.xyz",
    "pyrolatpha.space",
    "pyrozu.xyz",
    "pyrrhujyuc.space",
    "pystnv.site",
    "pytehestvie.ru",
    "pythoncloud.website",
    "pyxyvy.info",
    "pyymool.com",
    "pyyzxo.us",
    "pyzaro.info",
    "pyzy9.com",
    "pzcsy.us",
    "pzfgef.us",
    "pzhpckj.com",
    "pzklt.com",
    "pzlhjgbud.shop",
    "pzpitjxi.shop",
    "pzxuva.site",
    "pzznqcgcc.shop",
    "q-kassa.online",
    "q-kassa.ru",
    "q-profitsystem.site",
    "q-urotrin.ru",
    "q-world.online",
    "q.com",
    "q.new-mgmt.ga",
    "q.xtc.yt",
    "q0bcg1druy.ga",
    "q0bcg1druy.ml",
    "q0bcg1druy.tk",
    "q0bhn.icu",
    "q11toto.online",
    "q1775.com",
    "q1fdsfrtu.xyz",
    "q1lqeo.info",
    "q27uo.com",
    "q2b.ru",
    "q2gfiqsi4szzf54xe.cf",
    "q2gfiqsi4szzf54xe.ga",
    "q2gfiqsi4szzf54xe.gq",
    "q2gfiqsi4szzf54xe.ml",
    "q2gfiqsi4szzf54xe.tk",
    "q2lofok6s06n6fqm.cf",
    "q2lofok6s06n6fqm.ga",
    "q2lofok6s06n6fqm.gq",
    "q2lofok6s06n6fqm.ml",
    "q2lofok6s06n6fqm.tk",
    "q2o.events",
    "q2o.life",
    "q2o.live",
    "q2o.online",
    "q2oapp.com",
    "q2w6b.us",
    "q2xfln.us",
    "q314.net",
    "q4heo7ooauboanqh3xm.cf",
    "q4heo7ooauboanqh3xm.ga",
    "q4heo7ooauboanqh3xm.gq",
    "q4heo7ooauboanqh3xm.ml",
    "q4heo7ooauboanqh3xm.tk",
    "q5kb8t.us",
    "q5prxncteag.cf",
    "q5prxncteag.ga",
    "q5prxncteag.gq",
    "q5prxncteag.ml",
    "q5prxncteag.tk",
    "q5rbp7.us",
    "q5vm7pi9.com",
    "q5wx1t.host",
    "q6efmm.host",
    "q6suiq1aob.cf",
    "q6suiq1aob.ga",
    "q6suiq1aob.gq",
    "q6suiq1aob.ml",
    "q6suiq1aob.tk",
    "q6ts3c.us",
    "q74.ru",
    "q7hccq.us",
    "q7t43q92.com",
    "q7t43q92.com.com",
    "q7vwu0.us",
    "q8cbwendy.com",
    "q8ec97sr791.cf",
    "q8ec97sr791.ga",
    "q8ec97sr791.gq",
    "q8ec97sr791.ml",
    "q8ec97sr791.tk",
    "q8fcmf.com",
    "q8fqrwlxehnu.cf",
    "q8fqrwlxehnu.ga",
    "q8fqrwlxehnu.gq",
    "q8fqrwlxehnu.ml",
    "q8fqrwlxehnu.tk",
    "q8i4v1dvlsg.ga",
    "q8i4v1dvlsg.ml",
    "q8i4v1dvlsg.tk",
    "q9094.com",
    "q99919.com",
    "q9byhh.us",
    "q9yepn.us",
    "q9zqpu.us",
    "qa.team",
    "qaalby.com",
    "qaaw.ga",
    "qabuka.us",
    "qabvwr.online",
    "qacquirep.com",
    "qacyvy.info",
    "qaetaldkgl64ygdds.gq",
    "qafatwallet.com",
    "qaioz.com",
    "qaiwm.us",
    "qalbi.ru",
    "qalirar.site",
    "qamisy.com",
    "qampxu.us",
    "qantas.rentals",
    "qartoskd.shop",
    "qasd2qgznggjrl.cf",
    "qasd2qgznggjrl.ga",
    "qasd2qgznggjrl.ml",
    "qasd2qgznggjrl.tk",
    "qasti.com",
    "qatar.io",
    "qatarbahis12.com",
    "qatarmail.com",
    "qaum.org",
    "qav59.xyz",
    "qazulbaauct.cf",
    "qazulbaauct.ga",
    "qazulbaauct.gq",
    "qazulbaauct.ml",
    "qazulbaauct.tk",
    "qb-cms.com",
    "qb10em.info",
    "qb23c60behoymdve6xf.cf",
    "qb23c60behoymdve6xf.ga",
    "qb23c60behoymdve6xf.gq",
    "qb23c60behoymdve6xf.ml",
    "qb23c60behoymdve6xf.tk",
    "qbaydx2cpv8.cf",
    "qbaydx2cpv8.ga",
    "qbaydx2cpv8.gq",
    "qbaydx2cpv8.ml",
    "qbaydx2cpv8.tk",
    "qbesar.net",
    "qbfree.us",
    "qbi.kr",
    "qbikgcncshkyspoo.cf",
    "qbikgcncshkyspoo.ga",
    "qbikgcncshkyspoo.gq",
    "qbikgcncshkyspoo.ml",
    "qbikgcncshkyspoo.tk",
    "qbjnx.live",
    "qblti0.us",
    "qbmail.bid",
    "qbnifofx.shop",
    "qbooker.pro",
    "qbotrade.top",
    "qbpgqo.us",
    "qbqbtf4trnycocdg4c.cf",
    "qbqbtf4trnycocdg4c.ga",
    "qbqbtf4trnycocdg4c.gq",
    "qbqbtf4trnycocdg4c.ml",
    "qbrejwmo.shop",
    "qbsef.us",
    "qbuog1cbktcy.cf",
    "qbuog1cbktcy.ga",
    "qbuog1cbktcy.gq",
    "qbuog1cbktcy.ml",
    "qbuog1cbktcy.tk",
    "qbyccoxi.shop",
    "qbyyb.com",
    "qc.to",
    "qc0lipw1ux.cf",
    "qc0lipw1ux.ga",
    "qc0lipw1ux.ml",
    "qc0lipw1ux.tk",
    "qcddd.com",
    "qcgj333.com",
    "qcgowz.com",
    "qciesgjp.shop",
    "qcjrx.us",
    "qclothesbest.site",
    "qclsrecruitment.com",
    "qcmail.qc.to",
    "qcmgem.rest",
    "qcrtkdpas.xyz",
    "qczjaj.gq",
    "qd9ews.info",
    "qdbhu.com",
    "qddkztk.com",
    "qdebhyy.com",
    "qdice.com",
    "qdiian.com",
    "qdjlwqdj.space",
    "qdjlwqdj.xyz",
    "qdmug1.site",
    "qdpfbyy.com",
    "qdpjw.com",
    "qdrwriterx.com",
    "qdv9c0.us",
    "qdwvzq.site",
    "qe41hqboe4qixqlfe.gq",
    "qe41hqboe4qixqlfe.ml",
    "qe41hqboe4qixqlfe.tk",
    "qedwardr.com",
    "qege.site",
    "qeispacesq.com",
    "qeko.site",
    "qenori.info",
    "qeotxmwotu.cf",
    "qeotxmwotu.ga",
    "qeotxmwotu.gq",
    "qeotxmwotu.ml",
    "qeotxmwotu.tk",
    "qepad1.site",
    "qeps.de",
    "qer3f4.stream",
    "qesvt.us",
    "qeuuva.us",
    "qeva.site",
    "qewase.info",
    "qewyehthuh.website",
    "qexdb6.us",
    "qf1tqu1x124p4tlxkq.cf",
    "qf1tqu1x124p4tlxkq.ga",
    "qf1tqu1x124p4tlxkq.gq",
    "qf1tqu1x124p4tlxkq.ml",
    "qf1tqu1x124p4tlxkq.tk",
    "qf669.top",
    "qf7xkp.info",
    "qfhh3mmirhvhhdi3b.cf",
    "qfhh3mmirhvhhdi3b.ga",
    "qfhh3mmirhvhhdi3b.gq",
    "qfhh3mmirhvhhdi3b.ml",
    "qfhh3mmirhvhhdi3b.tk",
    "qfmwvcny.shop",
    "qfqpy.com",
    "qfrsxco1mkgl.ga",
    "qfrsxco1mkgl.gq",
    "qfrsxco1mkgl.ml",
    "qfsda.site",
    "qfwwdt.site",
    "qg2f9r.com",
    "qg8zn7nj8prrt4z3.cf",
    "qg8zn7nj8prrt4z3.ga",
    "qg8zn7nj8prrt4z3.gq",
    "qg8zn7nj8prrt4z3.ml",
    "qg8zn7nj8prrt4z3.tk",
    "qgaff.com",
    "qgfkslkd1ztf.cf",
    "qgfkslkd1ztf.ga",
    "qgfkslkd1ztf.gq",
    "qgfkslkd1ztf.ml",
    "qgriffith.com",
    "qguc.xyz",
    "qhdpyzm.com",
    "qhesnwv.com",
    "qhfc48-mail.xyz",
    "qhhqtaqi.shop",
    "qhhub.com",
    "qhi.us",
    "qhjpa.live",
    "qhjq5l.site",
    "qhm59.xyz",
    "qhqhidden.com",
    "qhrgzdqthrqocrge922.cf",
    "qhrgzdqthrqocrge922.ga",
    "qhrgzdqthrqocrge922.gq",
    "qhrgzdqthrqocrge922.ml",
    "qhrgzdqthrqocrge922.tk",
    "qhstreetr.com",
    "qhzfjt.com",
    "qi2i.com",
    "qi3ivu.com",
    "qiangdan168.com",
    "qianglong.asia",
    "qiantangylzc.com",
    "qiaoleng.com",
    "qiarog.us",
    "qiaua.com",
    "qibl.at",
    "qibode.site",
    "qicgco.com",
    "qidld.live",
    "qifunue.space",
    "qiglqgzg.shop",
    "qigongglobalhub.com",
    "qigongglobalwisdom.com",
    "qihceoils.shop",
    "qihwfscc.shop",
    "qijobv.us",
    "qikhnv.rest",
    "qimican.xyz",
    "qimla.us",
    "qingbiletherapeutics.biz",
    "qingdm.com",
    "qinghaidgw.com",
    "qinhuangyuan.com",
    "qinspections.online",
    "qiott.com",
    "qip.ru",
    "qipaomei.com",
    "qipmail.net",
    "qipufy.info",
    "qiq.us",
    "qirzgl53rik0t0hheo.cf",
    "qirzgl53rik0t0hheo.ga",
    "qirzgl53rik0t0hheo.gq",
    "qirzgl53rik0t0hheo.ml",
    "qirzgl53rik0t0hheo.tk",
    "qis.net",
    "qisdo.com",
    "qisoa.com",
    "qiuaja.info",
    "qiuchuchu.com",
    "qiufanyi.com",
    "qiukui.com",
    "qiupey.com",
    "qiuxiadyy.info",
    "qiwicasino.online",
    "qiyunwuliu.com",
    "qiziriq.uz",
    "qj59.xyz",
    "qj97r73md7v5.com",
    "qjipim.tokyo",
    "qjnnbimvvmsk1s.cf",
    "qjnnbimvvmsk1s.ga",
    "qjnnbimvvmsk1s.gq",
    "qjnnbimvvmsk1s.ml",
    "qjnnbimvvmsk1s.tk",
    "qkbzptliqpdgeg.cf",
    "qkbzptliqpdgeg.ga",
    "qkbzptliqpdgeg.gq",
    "qkbzptliqpdgeg.ml",
    "qkbzptliqpdgeg.tk",
    "qkecil.net",
    "qkerbl.com",
    "qkjkgv.shop",
    "qkjmkd.fun",
    "qkjmrq.fun",
    "qkk59.xyz",
    "qkl65.host",
    "qkpmqs.fun",
    "qkqmds.fun",
    "qksmkg.fun",
    "qksmpt.fun",
    "qksmxn.fun",
    "qktmcx.fun",
    "qktmkn.fun",
    "qkw4ck7cs1hktfba.cf",
    "qkw4ck7cs1hktfba.ga",
    "qkw4ck7cs1hktfba.gq",
    "qkw4ck7cs1hktfba.ml",
    "qkw4ck7cs1hktfba.tk",
    "qkx18.xyz",
    "qkxmhl.fun",
    "ql66dh.xyz",
    "qlearer.com",
    "qlevjh.com",
    "qlhnu526.com",
    "qlivecasino.com",
    "qlnajv.site",
    "qlniocsnvn.com",
    "qloob.net",
    "qlqprv.us",
    "qlrp5.us",
    "qlt2jf.online",
    "qltuo1.site",
    "qluiwa5wuctfmsjpju.cf",
    "qluiwa5wuctfmsjpju.ga",
    "qluiwa5wuctfmsjpju.gq",
    "qluiwa5wuctfmsjpju.ml",
    "qluwxfa.site",
    "qlvxfbzz.pro",
    "qlwivwia.shop",
    "qm1717.com",
    "qm3370.com",
    "qmail.com",
    "qmail2.net",
    "qmailers.com",
    "qmailshop.com",
    "qmfi4i.us",
    "qmhzh.site",
    "qmj38.us",
    "qmperehpsthiu9j91c.ga",
    "qmperehpsthiu9j91c.ml",
    "qmperehpsthiu9j91c.tk",
    "qmrbe.com",
    "qmsgvx.site",
    "qmtrdcxr.shop",
    "qmwparouoeq0sc.cf",
    "qmwparouoeq0sc.ga",
    "qmwparouoeq0sc.gq",
    "qmwparouoeq0sc.ml",
    "qmwparouoeq0sc.tk",
    "qn5egoikcwoxfif2g.cf",
    "qn5egoikcwoxfif2g.ga",
    "qn5egoikcwoxfif2g.gq",
    "qn5egoikcwoxfif2g.ml",
    "qn5egoikcwoxfif2g.tk",
    "qnb.io",
    "qnbz8.com",
    "qnetd.live",
    "qnhwc.info",
    "qninnng.best",
    "qnksojyh.shop",
    "qnkznwsrwu3.cf",
    "qnkznwsrwu3.ga",
    "qnkznwsrwu3.gq",
    "qnkznwsrwu3.ml",
    "qnkznwsrwu3.tk",
    "qntrvx.xyz",
    "qnuqgrfujukl2e8kh3o.cf",
    "qnuqgrfujukl2e8kh3o.ga",
    "qnuqgrfujukl2e8kh3o.gq",
    "qnuqgrfujukl2e8kh3o.ml",
    "qnuqgrfujukl2e8kh3o.tk",
    "qnzkugh2dhiq.cf",
    "qnzkugh2dhiq.ga",
    "qnzkugh2dhiq.gq",
    "qnzkugh2dhiq.ml",
    "qnzkugh2dhiq.tk",
    "qocya.com",
    "qofocused.com",
    "qogipo.info",
    "qoika.com",
    "qokpdm.shop",
    "qokuti.info",
    "qonfident.com",
    "qonuxo.info",
    "qoo-10.id",
    "qopls.live",
    "qopmail.com",
    "qoqb0.us",
    "qorikan.com",
    "qortu.com",
    "qoshnrdb.xyz",
    "qot.us",
    "qovu.site",
    "qovwi.us",
    "qoxurohi.cf",
    "qoz7xct.xyz",
    "qp11111.net",
    "qp22222.net",
    "qp4.bet",
    "qp87fb.us",
    "qpalong.com",
    "qpapa.ooo",
    "qpi8iqrh8wtfpee3p.ga",
    "qpi8iqrh8wtfpee3p.ml",
    "qpi8iqrh8wtfpee3p.tk",
    "qplh.us",
    "qpptplypblyp052.cf",
    "qprfans.com",
    "qpsrefugees.com",
    "qpulsa.com",
    "qpwnwmvo.shop",
    "qpxxis.com",
    "qq.cn",
    "qq.com",
    "qq.com.cn",
    "qq.my",
    "qq1775.com",
    "qq4889.org",
    "qq568.top",
    "qq57822.com",
    "qq59.xyz",
    "qq5901.xyz",
    "qq705358368.xyz",
    "qq77jj.com",
    "qq77vv.com",
    "qq88gg.com",
    "qq88oo.com",
    "qq9827.com",
    "qq998.xyz",
    "qq99bb.com",
    "qq99hh.com",
    "qq99kk.com",
    "qq99nn.com",
    "qq99tt.com",
    "qq99zz.com",
    "qqao.net",
    "qqbolaku.net",
    "qqcmail7.com",
    "qqcmail8.com",
    "qqcv7f2.com",
    "qqfullbet.club",
    "qqgenk.com",
    "qqhokibola.xyz",
    "qqhokipoker.org",
    "qqig88.info",
    "qqipgthtrlm.cf",
    "qqipgthtrlm.ga",
    "qqipgthtrlm.gq",
    "qqipgthtrlm.ml",
    "qqipgthtrlm.tk",
    "qqj84n.us",
    "qqketua.com",
    "qqmail.ir",
    "qqmba122.top",
    "qqmdu4.us",
    "qqmegawin77d.xyz",
    "qqmenang101.top",
    "qqmm518.com",
    "qqole.org",
    "qqowl.club",
    "qqpj.org",
    "qqqwwwil.men",
    "qqrss.net",
    "qqservice.com",
    "qqspot.com",
    "qqspot.net",
    "qqsssj.com",
    "qqturkiye.com",
    "qqzymail.win",
    "qr6g.com",
    "qraround.com",
    "qrc1t.us",
    "qrezkqqen.shop",
    "qrio.com",
    "qrmte1.site",
    "qrno1i.info",
    "qrohoteles.com",
    "qrrdja.info",
    "qrrnc.com",
    "qrryxk.site",
    "qrs3un.us",
    "qrucav.com",
    "qrxqdwmw.shop",
    "qs.dp76.com",
    "qs2k.com",
    "qs34.com",
    "qsb5.us",
    "qsc95.com",
    "qsg9ne.us",
    "qsl.ro",
    "qssapps.website",
    "qsxheepv.shop",
    "qt-top.com",
    "qt.dprots.com",
    "qt1.ddns.net",
    "qtask.pro",
    "qtauckland.com",
    "qtcairns.com",
    "qtellaplaza.com",
    "qtfxtbxudvfvx04.cf",
    "qtfxtbxudvfvx04.ga",
    "qtfxtbxudvfvx04.gq",
    "qtfxtbxudvfvx04.ml",
    "qtfxtbxudvfvx04.tk",
    "qtgptmututqg.ru",
    "qtlhkpfx3bgdxan.cf",
    "qtlhkpfx3bgdxan.ga",
    "qtlhkpfx3bgdxan.gq",
    "qtlhkpfx3bgdxan.ml",
    "qtlhkpfx3bgdxan.tk",
    "qtooth.org",
    "qtpjl.us",
    "qtpozl.us",
    "qtpxsvwifkc.cf",
    "qtpxsvwifkc.ga",
    "qtpxsvwifkc.gq",
    "qtpxsvwifkc.ml",
    "qtpxsvwifkc.tk",
    "qtqvyklv.shop",
    "qtresorts.com",
    "qtsfxxxxf.shop",
    "qtt4e.us",
    "qtthredbo.com",
    "qtujmiwzb.shop",
    "qtum-ico.com",
    "qtvg1y.us",
    "qtvpatxl.shop",
    "qtxm.us",
    "qtyciz.com",
    "qtyllhhtt.shop",
    "quaatiorup.gq",
    "quaatiorup.ml",
    "quabbinmediation.net",
    "quackquack.com",
    "quactaci.cf",
    "quactaci.tk",
    "quadixrefugees.com",
    "quadluve.gq",
    "quadluve.ml",
    "quadluve.tk",
    "quadparts.ru",
    "quadrafit.com",
    "quadrant99.com",
    "quadrigae-zeus.com",
    "quaestore.co",
    "quaihopli.gq",
    "quaihopli.ml",
    "quaipragma.ga",
    "quaipragma.tk",
    "quake.dk",
    "quake.ru",
    "quakemail.com",
    "qualia.cash",
    "qualia.exchange",
    "qualitatsproduktgeschenke.men",
    "qualitybrush.net",
    "qualitybrush.us",
    "qualitybrushes.biz",
    "qualitybrushes.org",
    "qualitybrushes.us",
    "qualitymedicarehelp.com",
    "qualityservice.com",
    "quallary.com",
    "qualmweirdshove.site",
    "quaminigames.xyz",
    "quan9nhadat.com",
    "quantentunnel.de",
    "quanticmedia.co",
    "quantize587rc.online",
    "quantobasta.ru",
    "quants.school",
    "quantumreality.dev",
    "quantums-code.site",
    "quaracta.cf",
    "quaracta.gq",
    "quarentinetips.com",
    "quarida.com",
    "quarl.xyz",
    "quarnipe.cf",
    "quarnipe.ga",
    "quarnipe.ml",
    "quarnipe.tk",
    "quarrycoin.com",
    "quartz-co.ru",
    "quasoro.ga",
    "quasoro.gq",
    "quasoro.ml",
    "quasoro.tk",
    "quassia.xyz",
    "quatangdinhcao.com",
    "quattro.best",
    "quattro.monster",
    "quattro.network",
    "quaykingfun.com",
    "qubecorp.tk",
    "qubitoid.com",
    "qubitoids.com",
    "qubyafahg.shop",
    "qucaiguoji111.com",
    "qucaiguoji222.com",
    "qucaiguoji333.com",
    "qudsmail.com",
    "quduq.org",
    "que-les-meilleurs-gagnent.com",
    "quean.xyz",
    "quebecstart.com",
    "quecarrera.com",
    "quecompde.cf",
    "quecompde.ga",
    "quecompde.gq",
    "quecompde.tk",
    "quediode.ga",
    "quediode.ml",
    "queeejkdfg7790.cf",
    "queeejkdfg7790.ga",
    "queeejkdfg7790.gq",
    "queeejkdfg7790.ml",
    "queeejkdfg7790.tk",
    "queenbeauty.top",
    "queenbet201.com",
    "queenbet202.com",
    "queenbet222.com",
    "queenbet333.com",
    "queenbet555.com",
    "queenbet999.com",
    "queencreekapartments.com",
    "queenma.xyz",
    "queenslandfoodandwinefestival.com",
    "queenslxcc.space",
    "queentein.com",
    "queentemp.site",
    "queentempt.site",
    "queerasfolk.ru",
    "queerlyawkward.com",
    "queersinproperty.melbourne",
    "quehuongta.com",
    "quelldropoutshown.site",
    "quemaryndirt.host",
    "quemede.ga",
    "quemede.ml",
    "quemillgyl.ga",
    "quemillgyl.gq",
    "quemillgyl.ml",
    "quentinpelletier.com",
    "quepasa.com",
    "quepedi.gq",
    "quepizzamassanassa.com",
    "querl.xyz",
    "querydirect.com",
    "queryshuttle.com",
    "queserchea.cf",
    "queso-tillamook.name",
    "quesomail.xyz",
    "quesoran.cf",
    "quesoran.ga",
    "quesoran.ml",
    "quesotillamook.name",
    "quesotillamook.us",
    "questali.xyz",
    "questaliv.xyz",
    "questdr.xyz",
    "questdri.xyz",
    "questner.xyz",
    "questore.co",
    "questoru.com",
    "questshaf.xyz",
    "quetronis.cf",
    "quetronis.ga",
    "quetronis.gq",
    "quetronis.ml",
    "quetronis.tk",
    "queuegr.icu",
    "queuem.com",
    "queueplan.xyz",
    "quichebedext.freetcp.com",
    "quick-mail.cc",
    "quick-mail.club",
    "quick-mail.info",
    "quick-mail.online",
    "quick-shopping.online",
    "quickcashinstant.com",
    "quickemail.info",
    "quickemail.top",
    "quickhosts.com",
    "quickinbox.com",
    "quickmail.best",
    "quickmail.in",
    "quickmail.nl",
    "quickmail.rocks",
    "quickmail.ru",
    "quickmakeupbag-shop.ru",
    "quicknet.nl",
    "quickock.icu",
    "quickreport.it",
    "quickresponsefund.com",
    "quickspect.com",
    "quickstore.club",
    "quicktech.repair",
    "quicktricepguide.com",
    "quicktv.xyz",
    "quickty.org",
    "quickwebmail.com",
    "quicooking-oita.com",
    "quicooti.cf",
    "quicooti.ga",
    "quicooti.gq",
    "quicooti.tk",
    "quid4pro.com",
    "quidoli.cf",
    "quidoli.ga",
    "quidoli.gq",
    "quidoli.tk",
    "quiecht.space",
    "quienesjorge.com",
    "quierolasvegas.com",
    "quierolondres.com",
    "quieroparis.com",
    "quietcre.us",
    "quietth.icu",
    "quietthe.icu",
    "quifacto.cf",
    "quifacto.gq",
    "quifacto.ml",
    "quifacto.tk",
    "quiflexaf.cf",
    "quiflexaf.ml",
    "quiflexaf.tk",
    "quikdrycarpet.com",
    "quiklinks.com",
    "quikmail.com",
    "quilfast.com",
    "quill-star.ru",
    "quiller-star.ru",
    "quiller.ru",
    "quillstar.ru",
    "quilon.net",
    "quiltforest.online",
    "quilthub.store",
    "quiltshoppress.com",
    "quiltslover.store",
    "quimaress.cf",
    "quimaress.ga",
    "quimaress.gq",
    "quimaress.ml",
    "quimaress.tk",
    "quinoadesavoie.net",
    "quinoadesavoie.org",
    "quintania.top",
    "quintasystems.com",
    "quintuqzwv.club",
    "quiperge.ga",
    "quiperge.gq",
    "quiperge.ml",
    "quiperge.tk",
    "quiprol.com",
    "quiprol.farm",
    "quismutach.cf",
    "quismutach.gq",
    "quismutach.ml",
    "quismutach.tk",
    "quisquous.site",
    "quitadoptpop.website",
    "quite-bag-seed-catch.xyz",
    "quithic.site",
    "quitmanms.org",
    "quivilo.gq",
    "quivilo.ml",
    "quivilo.tk",
    "quixoticals.com",
    "quizee.ru",
    "quizitaly.com",
    "quizr.org",
    "quizuetran.ga",
    "quizuetran.gq",
    "quodro.com",
    "quoiceneck.site",
    "quotable.email",
    "quotadr.press",
    "quotaglas.press",
    "quotale.xyz",
    "quotaleav.xyz",
    "quotasu.xyz",
    "quotationgo.email",
    "quotedakotacare.com",
    "quoteko.ga",
    "quoteko.gq",
    "quoteko.tk",
    "ququb.com",
    "qureta.net",
    "quto.site",
    "quuradminb.com",
    "quvshine.ru",
    "quw88.com",
    "quwdo.us",
    "quwo.site",
    "quxx14.com",
    "quxx150.com",
    "quxx152.com",
    "quxx158.com",
    "quxx159.com",
    "quxx160.com",
    "quxx162.com",
    "quxx168.com",
    "quxx174.com",
    "quxx176.com",
    "quxx178.com",
    "quxx183.com",
    "quxx186.com",
    "quxx189.com",
    "quxx190.com",
    "quxx198.com",
    "quxx200.com",
    "quyao.online",
    "quyi.info",
    "quyi88.com",
    "quzrisomzon.best",
    "qv7.info",
    "qvady.fun",
    "qvady.group",
    "qvady.life",
    "qvady.live",
    "qvady.network",
    "qvap.ru",
    "qvcpv.com",
    "qvlar.se",
    "qvo6jm.us",
    "qvpod.xyz",
    "qvvcuk.com",
    "qvvoxjfb.shop",
    "qvwthrows.com",
    "qvy.me",
    "qwanton.xyz",
    "qwarmingu.com",
    "qwe-qwe.com",
    "qweiop.xyz",
    "qwekssxt6624.cf",
    "qwekssxt6624.ga",
    "qwekssxt6624.gq",
    "qwekssxt6624.ml",
    "qwekssxt6624.tk",
    "qwelth.com",
    "qwerasd1.ru",
    "qwerqwerty.ga",
    "qwerqwerty.ml",
    "qwerqwerty.tk",
    "qwertymail.cf",
    "qwertymail.ga",
    "qwertymail.gq",
    "qwertymail.ml",
    "qwertymail.tk",
    "qwertyuiop.tk",
    "qwertyuiopasdfghjklzxcvbnm.info",
    "qwest.net",
    "qwestoffice.net",
    "qwewe2.top",
    "qwfox.com",
    "qwgll.com",
    "qwickmail.com",
    "qwkk111.com",
    "qwmmanbetx.com",
    "qwnxf1.us",
    "qwop.space",
    "qwqrwsf.date",
    "qwsa.ga",
    "qwtof1c6gewti.cf",
    "qwtof1c6gewti.ga",
    "qwtof1c6gewti.gq",
    "qwtof1c6gewti.ml",
    "qwtof1c6gewti.tk",
    "qx93.com",
    "qx95.com",
    "qx96.com",
    "qx98.com",
    "qxkneives.shop",
    "qxlvqptiudxbp5.cf",
    "qxlvqptiudxbp5.ga",
    "qxlvqptiudxbp5.gq",
    "qxlvqptiudxbp5.ml",
    "qxlvqptiudxbp5.tk",
    "qxpaperk.com",
    "qxtgd.com",
    "qxxx.site",
    "qy5p96.us",
    "qydwa.live",
    "qyfaka.info",
    "qyhty.com",
    "qyj101.com",
    "qymuhu.info",
    "qyp6sr.us",
    "qysyny.site",
    "qytue.site",
    "qywbz1.site",
    "qzav69.com",
    "qzdsx1.us",
    "qzdynxhzj71khns.cf",
    "qzdynxhzj71khns.gq",
    "qzdynxhzj71khns.ml",
    "qzdynxhzj71khns.tk",
    "qzepg0.info",
    "qzgqzgdtqumszututqg.ru",
    "qzilx1.site",
    "qzvbxqe5dx.cf",
    "qzvbxqe5dx.ga",
    "qzvbxqe5dx.gq",
    "qzvbxqe5dx.ml",
    "qzvbxqe5dx.tk",
    "qzwdim.us",
    "r-fasket.ru",
    "r-mail.cf",
    "r-mail.ga",
    "r-mail.gq",
    "r-mail.ml",
    "r-o-o-t.com",
    "r-shopinline.info",
    "r.yasser.ru",
    "r0.igg.biz",
    "r0kdgx.us",
    "r0ywhqmv359i9cawktw.cf",
    "r0ywhqmv359i9cawktw.ga",
    "r0ywhqmv359i9cawktw.gq",
    "r0ywhqmv359i9cawktw.ml",
    "r0ywhqmv359i9cawktw.tk",
    "r115pwhzofguwog.cf",
    "r115pwhzofguwog.ga",
    "r115pwhzofguwog.gq",
    "r115pwhzofguwog.ml",
    "r115pwhzofguwog.tk",
    "r14y.com",
    "r18app.com",
    "r18bt.com",
    "r18h.com",
    "r18mmd.com",
    "r1b3d9.us",
    "r1qaihnn9wb.cf",
    "r1qaihnn9wb.ga",
    "r1qaihnn9wb.gq",
    "r1qaihnn9wb.ml",
    "r1qaihnn9wb.tk",
    "r2cakes.com",
    "r2vw8nlia9goqce.cf",
    "r2vw8nlia9goqce.ga",
    "r2vw8nlia9goqce.gq",
    "r2vw8nlia9goqce.ml",
    "r2vw8nlia9goqce.tk",
    "r2vxkpb2nrw.cf",
    "r2vxkpb2nrw.ga",
    "r2vxkpb2nrw.gq",
    "r2vxkpb2nrw.ml",
    "r2vxkpb2nrw.tk",
    "r3-r4.tk",
    "r31s4fo.com",
    "r3hyegd84yhf.cf",
    "r3hyegd84yhf.ga",
    "r3hyegd84yhf.gq",
    "r3hyegd84yhf.ml",
    "r3hyegd84yhf.tk",
    "r3kihu.us",
    "r3z4.com",
    "r4.dns-cloud.net",
    "r425s.live",
    "r4gmw5fk5udod2q.cf",
    "r4gmw5fk5udod2q.ga",
    "r4gmw5fk5udod2q.gq",
    "r4gmw5fk5udod2q.ml",
    "r4gmw5fk5udod2q.tk",
    "r4nd0m.de",
    "r4ntwsd0fe58xtdp.cf",
    "r4ntwsd0fe58xtdp.ga",
    "r4ntwsd0fe58xtdp.gq",
    "r4ntwsd0fe58xtdp.ml",
    "r4ntwsd0fe58xtdp.tk",
    "r4unxengsekp.cf",
    "r4unxengsekp.ga",
    "r4unxengsekp.gq",
    "r4unxengsekp.ml",
    "r4unxengsekp.tk",
    "r513s.live",
    "r529n.live",
    "r56r564b.cf",
    "r56r564b.ga",
    "r56r564b.gq",
    "r56r564b.ml",
    "r56r564b.tk",
    "r5hbb.cloud",
    "r664mxb3kh3ff39.xyz",
    "r6cnjv0uxgdc05lehvs.cf",
    "r6cnjv0uxgdc05lehvs.ga",
    "r6cnjv0uxgdc05lehvs.gq",
    "r6cnjv0uxgdc05lehvs.ml",
    "r6cnjv0uxgdc05lehvs.tk",
    "r6ho.us",
    "r6motorsportmarketing.com",
    "r7.com",
    "r88mobile.com",
    "r8ca4d.us",
    "r8lirhrgxggthhh.cf",
    "r8lirhrgxggthhh.ga",
    "r8lirhrgxggthhh.ml",
    "r8lirhrgxggthhh.tk",
    "r8mwf.us",
    "r8p0xh.host",
    "r8r4p0cb.com",
    "r9-nalarum.ru",
    "r93k.us",
    "r97il.com",
    "r9827.com",
    "r9eypf-mail.xyz",
    "r9jebqouashturp.cf",
    "r9jebqouashturp.ga",
    "r9jebqouashturp.gq",
    "r9jebqouashturp.ml",
    "r9jebqouashturp.tk",
    "r9qych.us",
    "r9x5ce.us",
    "r9ycfn3nou.cf",
    "r9ycfn3nou.ga",
    "r9ycfn3nou.gq",
    "r9ycfn3nou.ml",
    "r9ycfn3nou.tk",
    "ra-st.ru",
    "ra0099.com",
    "ra3.us",
    "ra5qke.us",
    "ra72a3.online",
    "raagevents.com",
    "raakim.com",
    "rabbit168.info",
    "rabdm.ru",
    "rabet3.com",
    "rabfibird.cf",
    "rabfibird.ga",
    "rabfibird.ml",
    "rabganglu.cf",
    "rabganglu.ga",
    "rabganglu.gq",
    "rabganglu.ml",
    "rabhjzwst.shop",
    "rabin.ca",
    "rabiot.reisen",
    "rabomo.com",
    "rabota24-v-internet.ru",
    "rabuberkah.cf",
    "racedriver.com",
    "racefanz.com",
    "racesimulator.ru",
    "racetire.us",
    "racevietnam.info",
    "racevietnam.net",
    "rache2.net",
    "rachelatkinson.buzz",
    "rachsu.ru",
    "racialcomfort.com",
    "racinetech.org",
    "racingfan.com.au",
    "racingmail.com",
    "racingmtbiketeam.club",
    "racingwire.info",
    "rackabzar.com",
    "racksandlockers.com",
    "racnewsmela.tech",
    "racoga.cf",
    "racoga.ga",
    "racoga.tk",
    "racounso.cf",
    "racounso.ga",
    "racounso.gq",
    "racounso.tk",
    "racseho.ml",
    "racsubsphar.ga",
    "racsubsphar.gq",
    "racsubsphar.tk",
    "radade.com",
    "radardetectorshuck.site",
    "radarssalts.top",
    "radcliffeconstructionllc.com",
    "radecoratingltd.com",
    "radede.com",
    "radees.net",
    "radhuni-indian-cuisine.com",
    "radiator-stout.ru",
    "radicalclub.net",
    "radicalclub.org",
    "radicalizes637qv.online",
    "radicalsecurity.info",
    "radicalsecurity.org",
    "radicalz.com",
    "radicorn.com",
    "radiku.ye.vc",
    "radinex.com",
    "radiodale.com",
    "radiodirectory.ru",
    "radiofmwolf.site",
    "radiofurqaan.com",
    "radioldz.info",
    "radiologist.net",
    "radionaylamp.com",
    "radioquebec.info",
    "radioriki.com",
    "radiostockyards.net",
    "radiotra.icu",
    "radiowhite.net",
    "raditya.website",
    "radius-patio.com",
    "radiven.com",
    "radostnyy-krik.ru",
    "radskirip.cf",
    "radskirip.ga",
    "radskirip.ml",
    "radskirip.tk",
    "radugachudes.ru",
    "radugateplo.ru",
    "radux.online",
    "radyohost.xyz",
    "radyopozitif.xyz",
    "rael.cc",
    "raespital.cf",
    "raespital.ga",
    "raespital.ml",
    "raetp9.com",
    "raf-store.com",
    "rafaelsantos.info",
    "rafahidalvarez.com",
    "raffle-fr.info",
    "raffles.gg",
    "rafmail.cf",
    "rafmailku.ml",
    "rafmix.site",
    "rafxnwqrl.shop",
    "ragclwzns.shop",
    "ragebite.net",
    "ragebite.org",
    "ragel.me",
    "ragevpn.net",
    "ragingbull.com",
    "ragitone.com",
    "ragutti.date",
    "ragvenetstor.website",
    "ragzwtna4ozrbf.cf",
    "ragzwtna4ozrbf.ga",
    "ragzwtna4ozrbf.gq",
    "ragzwtna4ozrbf.ml",
    "ragzwtna4ozrbf.tk",
    "rahabionic.com",
    "rahavpn.men",
    "rahimis.com",
    "raiasu.cf",
    "raiasu.ga",
    "raiasu.gq",
    "raiasu.ml",
    "raiasu.tk",
    "raicaltie.ga",
    "raicaltie.gq",
    "raicaltie.ml",
    "raicaltie.tk",
    "raichanlogistics.com",
    "raichartsu.ga",
    "raichartsu.gq",
    "raichartsu.tk",
    "raidiran.cf",
    "raidiran.ga",
    "raidiran.gq",
    "raidiran.ml",
    "raidot.org",
    "raidtalk.com",
    "raiffmob2.ru",
    "raifgo.space",
    "raifzus.website",
    "raikas77.eu",
    "rail-news.info",
    "railroadcheckinn.com",
    "railsmerchant.com",
    "railway-shop.ru",
    "raimne.site",
    "raimonbundo.com",
    "raimond.ru",
    "raimu.cf",
    "raimucok.cf",
    "raimucok.ga",
    "raimucok.gq",
    "raimucok.ml",
    "raimucul.ga",
    "raimucul.gq",
    "raimucul.ml",
    "raimuwedos.cf",
    "raimuwedos.ga",
    "raimuwedos.gq",
    "raimuwedos.ml",
    "rainbocorns.ru",
    "rainbow-vanilla.ru",
    "rainbowdelco.com",
    "rainbowdungeon.com",
    "rainbowflowersaz.com",
    "rainbowgelati.com",
    "rainbowly.ml",
    "rainbowrecess.com",
    "raincode.ru",
    "rainet.online",
    "rainlear.com",
    "rainmail.biz",
    "rainplatform.cloud",
    "rainproofresidual.com",
    "rainture.com",
    "rainwaterstudios.org",
    "rainycitynights.com",
    "raiplay.cf",
    "raiplay.ga",
    "raiplay.gq",
    "raiplay.ml",
    "raiplay.tk",
    "rairecomp.cf",
    "rairecomp.gq",
    "rairecomp.ml",
    "rairyri.cf",
    "rairyri.gq",
    "rairyri.tk",
    "raisedhomes.com",
    "raisedviaz.space",
    "raiseenf.buzz",
    "raisegl.com",
    "raisemoneyfaster.com",
    "raisemorecapital.com",
    "raisero.com",
    "raisethought.com",
    "raisnacur.cf",
    "raisnacur.ga",
    "raisnacur.gq",
    "raisnacur.ml",
    "raisraiu.shop",
    "raitingslots.ru",
    "raiurais.shop",
    "raiway.cf",
    "raiway.ga",
    "raiway.gq",
    "raiway.ml",
    "raiway.tk",
    "raja333.net",
    "raja69toto.com",
    "rajaayam.net",
    "rajaayam.org",
    "rajamahakal.com",
    "rajamainonline.com",
    "rajapkr.online",
    "rajapoker.rocks",
    "rajapoker333.org",
    "rajapokerz88.xyz",
    "rajarajut.co",
    "rajas-grill-athlone.com",
    "rajaserverpkv.club",
    "rajasgrill-athlone.com",
    "rajasoal.online",
    "rajatharshada.shop",
    "rajavivobet.org",
    "rajegsquad.site",
    "rajemail.tk",
    "rajeshcon.cf",
    "rajetempmail.com",
    "rajo.site",
    "rajonmi.cf",
    "rajonmi.ga",
    "rajonmi.gq",
    "rajonmi.ml",
    "rajshreetrading.com",
    "raketenmann.de",
    "rakfurniture.com",
    "rakhi.online",
    "rakinvymart.com",
    "rakipbetvip.com",
    "rakipbetvip1.com",
    "rakipbetvip8.com",
    "rakipkart6.online",
    "rakipkart6.xyz",
    "rakippro10.com",
    "rakippro2.com",
    "rakippro7.com",
    "rakippro8.com",
    "rakippro9.com",
    "rakmalhatif.com",
    "raksasadomino.com",
    "raksasapkr.online",
    "raldo.ru",
    "raleighalcoholrehab.com",
    "raleighquote.com",
    "raleighshoebuddy.com",
    "ralib.com",
    "rallralo.shop",
    "rallyraf.cf",
    "rallyraf.gq",
    "rallyraf.ml",
    "rallyraf.tk",
    "ralree.com",
    "ralutnabhod.xyz",
    "ramail.co.uk",
    "ramaninio.cf",
    "ramaninio.ga",
    "ramaninio.gq",
    "ramaninio.ml",
    "ramaninio.tk",
    "rambakcor44bwd.ga",
    "rambgarbe.ga",
    "rambgarbe.gq",
    "rambgarbe.tk",
    "rambler.ru",
    "rambotogel.com",
    "rambutpantene.online",
    "ramireshop.ru",
    "ramjane.mooo.com",
    "ramkolz.xyz",
    "rampas.ml",
    "rampasboya.ml",
    "rampyourbiz.com",
    "ramserog.ga",
    "ramserog.ml",
    "ramshop.live",
    "ramswares.com",
    "ramundur.se",
    "ramurop.ml",
    "ramurop.tk",
    "ranaphe.ga",
    "ranaphe.ml",
    "ranas.ml",
    "rancenylt.cf",
    "rancenylt.ga",
    "rancenylt.gq",
    "rancenylt.ml",
    "ranchocucamonganailsalons.com",
    "ranchosantamargaritadentists.com",
    "ranchpanic.com",
    "ranchpres.xyz",
    "ranchweddinginsandiego.com",
    "rancidhome.net",
    "rancidkawing.me",
    "rancilan.gq",
    "rancilan.ml",
    "rancilan.tk",
    "randelstravel.info",
    "randich.info",
    "randofficcloth.com",
    "randomactsofkindness.site",
    "randomail.net",
    "randombook.com",
    "randomcsorg.ru",
    "randomdrink.com",
    "randomgamen.online",
    "randomgetaway.com",
    "randomgift.com",
    "randomniydomen897.cf",
    "randomniydomen897.ga",
    "randomniydomen897.gq",
    "randomniydomen897.ml",
    "randomniydomen897.tk",
    "randomseantheblogger.xyz",
    "randomwinner.net",
    "randycloting.com",
    "randyfitshoes.com",
    "rangerapp.com",
    "rangereviewer.com",
    "rangetige.xyz",
    "rangevid.us",
    "ranggasra.club",
    "rangisre.me",
    "ranhen.ru",
    "rank.exchange",
    "rankgapla.cf",
    "rankgapla.ga",
    "rankgapla.gq",
    "ranking-tabletek-na-odchudzanie.xyz",
    "rankingc3.global",
    "ranktong7.com",
    "rankupcommunity.com",
    "ranmamail.com",
    "ranpack.online",
    "ransern.com",
    "ransranbo.ml",
    "ransranbo.tk",
    "ransvershill.cf",
    "ransvershill.gq",
    "ransvershill.ml",
    "ranuless.cf",
    "ranuless.ga",
    "ranuless.ml",
    "ranuless.tk",
    "ranur.ru",
    "rao-network.com",
    "rao.kr",
    "raoviet.website",
    "rapadura.tech",
    "rapaschi.gq",
    "rapaschi.ml",
    "rapenakyodilakoni.cf",
    "rapidbeos.net",
    "rapiddecisiontermlife.com",
    "rapidmailbox.com",
    "rapidnet.com",
    "rapidpay.asia",
    "rapidprotect.ml",
    "rapidpulse.tech",
    "rapidreceiptsidle.site",
    "rapidrootermn.com",
    "rapidspool.info",
    "raplico.asia",
    "rappere.com",
    "rapquangtri.com",
    "rapt.be",
    "rapture.bio",
    "rapturetiger.com",
    "rapyhu.info",
    "rapzip.com",
    "raq4iq.xyz",
    "raqal.com",
    "raqid.com",
    "rarame.club",
    "rarissima.site",
    "rarlclasem.tk",
    "rary0.site",
    "rasedaoip.ga",
    "rasedily.info",
    "raskhin54swert.ml",
    "rasmussen.dk",
    "raspaty.cf",
    "raspaty.ml",
    "raspaty.tk",
    "raspberrypi123.ddns.net",
    "raspberrypibra.com",
    "raspberrypiguy.com",
    "raspedc.org",
    "rasprodazha365.ru",
    "rastabettingsnupp.xyz",
    "rastenivod.ru",
    "rastogi.net",
    "rasubsto.ga",
    "rasubsto.gq",
    "rasubsto.tk",
    "ratcher5648.cf",
    "ratcher5648.ga",
    "ratcher5648.gq",
    "ratcher5648.ml",
    "ratcher5648.tk",
    "ratedmildewsimon.site",
    "ratedquote.com",
    "rateiobarato.net",
    "rateiovirtual.biz",
    "rateiovirtual.club",
    "rateiovirtual.xyz",
    "rateiovirtualbr.org",
    "ratel.org",
    "ratemytravelagency.com",
    "ratepro.site",
    "rateslending.pro",
    "ratharsben.com",
    "ratibe.ga",
    "ratihof.cf",
    "ratihof.gq",
    "ratioan.icu",
    "ratiomars.email",
    "rationalizer176ov.online",
    "ratiorei.fun",
    "ratiosha.xyz",
    "ratiosk.xyz",
    "ratioska.xyz",
    "ratsnaijie.space",
    "ratsup.com",
    "ratt-n-roll.com",
    "ratta.cf",
    "ratta.ga",
    "ratta.gq",
    "ratta.ml",
    "ratta.tk",
    "rattle-snake.com",
    "rattlearray.com",
    "rattlecore.com",
    "rattlesnakecanyon.org",
    "ratu228.net",
    "ratu855.com",
    "ratu855.net",
    "ratuayam.info",
    "ratuayam.net",
    "ratuayam.org",
    "ratugaming.com",
    "ratuibc.com",
    "ratutoto4d.org",
    "raubtierbaendiger.de",
    "raucuquadalat.net",
    "raulenhou.cf",
    "raulenhou.ga",
    "raulenhou.gq",
    "raulenhou.ml",
    "raulenhou.tk",
    "rauljhwsw.shop",
    "raurua.com",
    "rautostabilbetsnup.xyz",
    "rauxa.seny.cat",
    "rav-4.cf",
    "rav-4.ga",
    "rav-4.gq",
    "rav-4.ml",
    "rav-4.tk",
    "rav-apsl.ru",
    "rav4.tk",
    "rave-cage.org",
    "ravearena.com",
    "ravefan.com",
    "ravemail.co.za",
    "ravemail.com",
    "ravenom.ru",
    "ravenplug.com",
    "raventurres.net",
    "raviswiss.com",
    "ravnica.org",
    "ravpowers.com",
    "ravusraven.monster",
    "ravyn.xyz",
    "rawbeerfreighter.website",
    "rawbucks.net",
    "rawhidefc.org",
    "rawkitchen.ru",
    "rawmails.com",
    "rawpitcher.com",
    "rawreredc.cf",
    "rawreredc.ga",
    "rawreredc.ml",
    "rawrr.ga",
    "rawscore.app",
    "rawscore.cash",
    "rawscore.org",
    "rawscored.com",
    "rawscorer.com",
    "rawscores.app",
    "rawscores.net",
    "rawscoring.com",
    "rax.la",
    "raxomart.site",
    "raxtest.com",
    "raya.gq",
    "rayacasino.info",
    "raycaster.info",
    "raychat.xyz",
    "rayenventures.com",
    "rayetailor.com",
    "rayfaulkner.com",
    "raylee.ga",
    "raymondheaden.com",
    "raymondvase.com",
    "raywvjt.space",
    "razbor54.ru",
    "razemail.com",
    "razernv.com",
    "razinrocks.me",
    "razkruti.ru",
    "razorkast.com",
    "razormail.com",
    "razorwoodworks.com",
    "razpayprim.cf",
    "razsor.adult",
    "razumkoff.ru",
    "rbatz.net",
    "rbaynf.site",
    "rbb.org",
    "rbbyr.com",
    "rbcmail.ru",
    "rbcom.ru",
    "rbdh.xyz",
    "rbeiter.com",
    "rbet260.com",
    "rbezwx.com",
    "rbgwmlrt.shop",
    "rbiwc.com",
    "rbkwd.us",
    "rblrobot.com",
    "rblx.site",
    "rblxrewards.xyz",
    "rbmtzy.icu",
    "rbnej.xyz",
    "rbnv.org",
    "rbo88.xyz",
    "rbpc6x9gprl.cf",
    "rbpc6x9gprl.ga",
    "rbpc6x9gprl.gq",
    "rbpc6x9gprl.ml",
    "rbpc6x9gprl.tk",
    "rbq123.com",
    "rbvboox.com",
    "rc-note.biz",
    "rc8o6b7lhuyxvtj.xyz",
    "rc94stgoffreg1.com",
    "rcamerabest.info",
    "rcasd.com",
    "rcaynoye.shop",
    "rcbuy.info",
    "rccew.site",
    "rccgmail.org",
    "rcelectricalcontractorsltd.com",
    "rchd.de",
    "rchub.ru",
    "rcinvn408nrpwax3iyu.cf",
    "rcinvn408nrpwax3iyu.ga",
    "rcinvn408nrpwax3iyu.gq",
    "rcinvn408nrpwax3iyu.ml",
    "rcinvn408nrpwax3iyu.tk",
    "rclasmile.ru",
    "rcm-coach.net",
    "rcn.com",
    "rcode.net",
    "rcode.site",
    "rcpt.at",
    "rcr0hs.us",
    "rcruiying.com",
    "rcs.gaggle.net",
    "rcs7.xyz",
    "rcshost.ru",
    "rctfood.com",
    "rctkmijw.shop",
    "rcuznkkw.shop",
    "rd2ae.info",
    "rdahb3lrpjquq.cf",
    "rdahb3lrpjquq.ga",
    "rdahb3lrpjquq.gq",
    "rdahb3lrpjquq.ml",
    "rdahb3lrpjquq.tk",
    "rdiffmail.com",
    "rdjoi.us",
    "rdklcrv.xyz",
    "rdom3t.host",
    "rdqea1.site",
    "rdr2native.com",
    "rdresolucoes.com",
    "rdrt.ml",
    "rdrunner.net",
    "rdssiro.space",
    "rdstreetwear.com",
    "rdyn171d60tswq0hs8.cf",
    "rdyn171d60tswq0hs8.ga",
    "rdyn171d60tswq0hs8.gq",
    "rdyn171d60tswq0hs8.ml",
    "rdyn171d60tswq0hs8.tk",
    "rdzbwm.icu",
    "re-gister.com",
    "re7zf1.info",
    "reacc.me",
    "reachby.com",
    "reachingthemedia.com",
    "reachintegra.mobi",
    "reachniy.ml",
    "reachun.xyz",
    "reachwheat.us",
    "reacsoca.cf",
    "reactbooks.com",
    "reactive-eng.com",
    "reactive-school.ru",
    "reactripostesinew.site",
    "read-wordld.website",
    "readanybook.best",
    "readershealthdigest.com",
    "readied.com",
    "readinghippo.com",
    "readingkeylightning.net",
    "readingroombookreviews.com",
    "readlistenlearn.info",
    "readm.club",
    "readmyblog.org",
    "readwritehustle.training",
    "ready.dk",
    "readycollect.biz",
    "readycollect.info",
    "readycollect.org",
    "readyforchristmas.net",
    "readyforfirstgradeworkshop.com",
    "readyforschooltraining.com",
    "readyforyou.cf",
    "readyforyou.ga",
    "readyforyou.gq",
    "readyforyou.ml",
    "readyhostel.com",
    "readysetgaps.com",
    "readyslo.net",
    "readyslocounty.net",
    "readystoo.email",
    "reagan.com",
    "reakisynch.ga",
    "reakisynch.gq",
    "reakisynch.ml",
    "reakisynch.tk",
    "reaktor51.online",
    "real-dating-finder12.com",
    "real-estate-net.com",
    "real-market-buy.ru",
    "real-partner-dating1.com",
    "real-prizeszone.life",
    "real-undersell-commerce.ru",
    "realbahis41.com",
    "realbahis43.com",
    "realbahis45.com",
    "realbahis46.com",
    "realbahis60.com",
    "realbahis74.com",
    "realbahis90.com",
    "realchangepodcast.live",
    "realdemocracy.vision",
    "realdemocracy.works",
    "realemail.net",
    "realestateagent401k.com",
    "realestatecont.info",
    "realestatehotlineonline.com",
    "realestateinfohotline.com",
    "realestateinvestorsassociationoftoledo.com",
    "realestatemail.net",
    "realestatemarketcap.com",
    "realestpeople.asia",
    "realevoo.com",
    "realexchangerates.com",
    "realfoxj.site",
    "realfun.info",
    "realhoustondeals.com",
    "realidindiana.com",
    "realidma.com",
    "realidmi.com",
    "realidmichigan.com",
    "realieee.com",
    "realieee.org",
    "realinflo.net",
    "realistiskamassagestavar.se",
    "reality-concept.club",
    "realizerecords.net",
    "realjoe1.ru",
    "really.istrash.com",
    "reallyfast.biz",
    "reallyfast.info",
    "reallymymail.com",
    "reallyneatgames.com",
    "reallyshittycoffee.com",
    "realmoviedd.com",
    "realmpilot.com",
    "realmx.se",
    "realneoharry.ru",
    "realpetnatural.com",
    "realpetnatural.net",
    "realpokerschool.com",
    "realportal.online",
    "realradiomail.com",
    "realrisotto.com",
    "realsoul.in",
    "realstlouisdeals.com",
    "realtor-chelny.ru",
    "realtyagent.com",
    "realtyalerts.ca",
    "realtyexpertise.us",
    "realyour-girls1.com",
    "reaneta.ga",
    "reaneta.tk",
    "reankpek.xyz",
    "reapermachine.com",
    "rearepe.shop",
    "reasons-to-use-3ds-max.com",
    "reasontocelebrate.org",
    "reasystabilitybetsnupp20.xyz",
    "reauflabit.cf",
    "reauflabit.ga",
    "reauflabit.ml",
    "rebami.cf",
    "rebami.ga",
    "rebami.gq",
    "rebatedates.com",
    "rebates.stream",
    "rebeccabad.website",
    "rebeccadavidson.buzz",
    "rebeccadear.website",
    "rebekahcarney.net",
    "rebelexac.icu",
    "rebelfi.icu",
    "rebelvo.xyz",
    "reberpzyl.cf",
    "reberpzyl.ga",
    "reberpzyl.gq",
    "reberpzyl.ml",
    "rebertboxing.ru",
    "rebnt55-otymry.site",
    "reboot-sec.net",
    "reboot-secure.com",
    "reboot-security.com",
    "rebootsecure.com",
    "rebootsecure.net",
    "rebootsecurity.net",
    "reborn-propertes.com",
    "reborn.com",
    "rebornlibrary.com",
    "rebornlover.club",
    "rebotec24.ru",
    "recastclassics.com",
    "recaudoalinstante.com",
    "receeptionist.ru",
    "receipt.legal",
    "receiptroyalty.mobi",
    "receitasdaju.com",
    "receiveee.chickenkiller.com",
    "receiveee.com",
    "recept-edy.ru",
    "recept-sekret.ru",
    "receptest.ru",
    "receptsu.ru",
    "recepty-mira.ru",
    "recepty-prigotovleniya.ru",
    "recettesla.store",
    "rechargenavkar.com",
    "rechnoclick.com",
    "reciclaje.xyz",
    "recipeforfailure.com",
    "recipeinternasional.com",
    "recipie-for.com",
    "reclaimbellydancing.com",
    "reclaimyourtimemasterclass.com",
    "recode.me",
    "recogeme.com",
    "recognised.win",
    "recognizably452yw.online",
    "recognizance975sx.online",
    "recognizers974rc.xyz",
    "recoil.training",
    "recolonization955nf.online",
    "recombinati.xyz",
    "recommendedstampedconcreteinma.com",
    "reconbirdmedia.com",
    "reconbirdsoftware.com",
    "reconmail.com",
    "record01.site",
    "record01.xyz",
    "recordedvids.com",
    "recordially.com",
    "recoverharddisk.org",
    "recoverpoint.online",
    "recoveryhealth.site",
    "recoveryhealth.space",
    "recoveryhealth.xyz",
    "recpersonred.site",
    "recreatie.works",
    "recreationactivesite.club",
    "recreationlogspot.club",
    "recroyal.com",
    "recruitaware.com",
    "recruitingfriend.com",
    "recruitment.works",
    "rectalcancer.ru",
    "rectono.cf",
    "rectono.ga",
    "rectono.gq",
    "rectono.ml",
    "rectono.tk",
    "recurrenta.com",
    "recursor.net",
    "recyclabledisplays.com",
    "recyclate.org",
    "recycledmail.com",
    "recyclemail.dk",
    "recycleocean.info",
    "recycleocean.net",
    "recycleocean.org",
    "recycler.com",
    "recyclermail.com",
    "recyclingjobs.org",
    "recycraft.ru",
    "red-mail.info",
    "red-mail.top",
    "red12030505.xyz",
    "red18sports.org",
    "red88.org",
    "red88.us",
    "red88.vin",
    "redalbu.cf",
    "redalbu.ga",
    "redalbu.gq",
    "redalbu.ml",
    "redalbu.tk",
    "redapplecasino.com",
    "redarrowcorp.com",
    "redbahis22.com",
    "redbahis23.com",
    "redbarnfleamarket.org",
    "redbats.info",
    "redbird.live",
    "redbmailer2.com",
    "redbullpoker.club",
    "redbullpoker.site",
    "redbullpoker.xyz",
    "redcarpet-agency.ru",
    "redchan.it",
    "redchillieskincardine.com",
    "redchoco.xyz",
    "redcityrose.ru",
    "redcolony.info",
    "reddcoin2.com",
    "reddcore.com",
    "reddduslim.ru",
    "reddeal6.site",
    "reddenimhaven.com",
    "redderex.com",
    "reddiffusionpro.top",
    "reddishearth.tk",
    "reddit.usa.cc",
    "reddithub.com",
    "reddogspecials.com",
    "reddoorresort.com",
    "reddoors.ru",
    "redefiningrealestate.us",
    "redemptioncalvary.net",
    "redesimpacto.site",
    "redetm.online",
    "redews.online",
    "redfeathercrow.com",
    "redflashgroup.net",
    "redflpay.xyz",
    "redfoxbet13.com",
    "redfoxbet30.com",
    "redfoxbet31.com",
    "redfoxbet33.com",
    "redfoxbet36.com",
    "redfoxbet38.com",
    "redfoxbet39.com",
    "redfoxbet50.com",
    "redfoxbet60.com",
    "redfoxbet62.com",
    "redfoxbet64.com",
    "redfoxbet65.com",
    "redfoxbet68.com",
    "redfoxbet74.com",
    "redfoxbet77.com",
    "redfoxbet87.com",
    "redfuli999.club",
    "redgil.com",
    "redheadcuties.com",
    "redhet.xyz",
    "redhoney.info",
    "redhoney.site",
    "redhoney.xyz",
    "redhoneypower.com",
    "redhornet.info",
    "redhorsegaming.com",
    "rediff.com",
    "rediffmail.com",
    "rediffmailpro.com",
    "redigesso.ru",
    "redirect.plus",
    "redissoft.site",
    "redkeyproperties.net",
    "redkings.org",
    "redkings.us",
    "redleuplas.cf",
    "redleuplas.ga",
    "redleuplas.tk",
    "redline-shimonoseki.com",
    "redmail.agency",
    "redmail.tech",
    "redmob.site",
    "redmp4.site",
    "rednecks.com",
    "redopikas.cf",
    "redounrsyi.space",
    "redovisningdanderyd.nu",
    "redovisningsbyra.nu",
    "redpeanut.com",
    "redpen.trade",
    "redpepumya.space",
    "redrabbit1.cf",
    "redrabbit1.ga",
    "redrabbit1.gq",
    "redrabbit1.ml",
    "redrabbit1.tk",
    "redrect.site",
    "redring.org",
    "redrivervalleyacademy.com",
    "redrockdigital.net",
    "redropeapp.com",
    "redseven.de",
    "redsfans.com",
    "redstar.online",
    "redteddy.ru",
    "redtiger.info",
    "redtopgames.com",
    "redtreebrush.biz",
    "redtreebrush.org",
    "redtreebrush.us",
    "redtreebrushes.biz",
    "redtreebrushes.net",
    "redtreebrushes.us",
    "redtreeind.us",
    "redtreeindustries.net",
    "reduced.link",
    "reduceyourrecurrence.net",
    "reduitec.org",
    "redundancy.dev",
    "reduslim-dealer.ru",
    "reduslim-dly-vas.ru",
    "reduslim-originals.ru",
    "reduslimf.ru",
    "reduslimius.ru",
    "redusslimium.ru",
    "redvid.cf",
    "redvid.gq",
    "redvid.ml",
    "redvid.site",
    "redvid.space",
    "redvid.tk",
    "redvideo.ga",
    "redvideo.site",
    "redviet.com",
    "redvwap.fun",
    "redwhitearmy.com",
    "redwoodrehab.org",
    "redwrapping.com",
    "redxnxx.site",
    "redxwap.site",
    "redxxx.fun",
    "redyspot.com",
    "redyspots.com",
    "redza.online",
    "reedy.rocks",
    "reedy.space",
    "reefbarandmarket.com",
    "reegasubs.ga",
    "reegasubs.gq",
    "reegasubs.ml",
    "reegasubs.tk",
    "reel-innovation.com",
    "reelsgyptio.cf",
    "reelsgyptio.ga",
    "reelsgyptio.gq",
    "reelsgyptio.ml",
    "reelslunorth.cf",
    "reelslunorth.ga",
    "reelslunorth.gq",
    "reelslunorth.ml",
    "reesman.xyz",
    "reevolution.live",
    "reeyna.com",
    "ref01-payoffers.site",
    "ref01-useroffers.info",
    "ref01-useroffers.site",
    "ref02-infopay.site",
    "ref8cw.online",
    "refacna.cf",
    "refacna.ga",
    "refacna.ml",
    "refacna.tk",
    "refawra.cf",
    "refawra.ga",
    "refawra.gq",
    "refawra.ml",
    "refawra.tk",
    "refbets.com",
    "refeele.live",
    "refei\xe7\xe3o.online",
    "referalu.ru",
    "referans.xyz",
    "referol.info",
    "referralroutenight.website",
    "refina.cf",
    "refina.ga",
    "refina.ml",
    "refina.tk",
    "refinance-credit.ru",
    "refinance-your-mortgage.org",
    "refinita.com",
    "reflectcreed.info",
    "refleqted.com",
    "refleqtive.com",
    "reformbigo.xyz",
    "reformoyik.space",
    "reformpila.space",
    "refpiwork.cf",
    "refpiwork.ga",
    "refpiwork.gq",
    "refstar.com",
    "reftoken.net",
    "refuger.fun",
    "refund.fun",
    "refurhost.com",
    "refy.site",
    "reg-builder.xyz",
    "reg19.ml",
    "regalforex.com",
    "regalsz.com",
    "regbypass.com",
    "regbypass.comsafe-mail.net",
    "regcart.com",
    "regencyatbeachwalk.com",
    "regeneratefootprint.com",
    "regentparkhall.com",
    "reggaefan.com",
    "reggafan.com",
    "reggioemiliadaycare.com",
    "regimen-skin.com",
    "reginaclothing.com",
    "reginao.se",
    "region13.cf",
    "region13.ga",
    "region13.gq",
    "region13.ml",
    "region13.tk",
    "region42-tur.ru",
    "regional-wolfsburg.com",
    "regional.boutique",
    "regional.catering",
    "regional.delivery",
    "regionalrideshare.com",
    "regionalrideshare.org",
    "regionless.com",
    "regiononline.com",
    "regionteks.ru",
    "regiopage-deutschland.de",
    "register-form.online",
    "registerednurses.com",
    "registermyninja.com",
    "registerrequest.com",
    "registersky777.club",
    "registgmbw.space",
    "registraciya-bank.ru",
    "registratuimei.org",
    "regivx.com",
    "regmarerketss.ru",
    "regoox.com",
    "regopas.online",
    "regpp7arln7bhpwq1.cf",
    "regpp7arln7bhpwq1.ga",
    "regpp7arln7bhpwq1.gq",
    "regpp7arln7bhpwq1.ml",
    "regpp7arln7bhpwq1.tk",
    "regroom.host",
    "regroom.website",
    "regspaces.tk",
    "reguded.cf",
    "reguded.ga",
    "reguded.tk",
    "regutav.xyz",
    "rehabcenterwebdesign.com",
    "rehabonmymind.com",
    "rehashes.com",
    "rehau39.ru",
    "rehlatti.com",
    "reicono.cf",
    "reicono.ga",
    "reicorming.gq",
    "reicorming.tk",
    "reiffspank.site",
    "reifreakop.ga",
    "reifreakop.gq",
    "reifreakop.tk",
    "reignblad.icu",
    "reignict.com",
    "reignsa.buzz",
    "reignsoli.icu",
    "reignwast.space",
    "reigpartner.com",
    "reik.net",
    "reikilove.ru",
    "reilidust.cf",
    "reilidust.ga",
    "reillycars.info",
    "reima-kinsei.online",
    "reimalaplander.online",
    "reincarnate.com",
    "reinforcedpaper.com",
    "reinvestors.cloud",
    "reiprivre.cf",
    "reiprivre.gq",
    "reiprivre.tk",
    "reirepa.cf",
    "reirepa.ml",
    "reisezeit.site",
    "reisteepin.cf",
    "reisteepin.ml",
    "reitarme.tk",
    "reitralsa.cf",
    "reitralsa.ga",
    "reitralsa.gq",
    "reitralsa.ml",
    "reitralsa.tk",
    "reiwa.photos",
    "reja9i.site",
    "rejectmail.com",
    "rejeki303.org",
    "rejestraptek.com",
    "rejestrsuplementow.com",
    "rejo.technology",
    "rejudi.cf",
    "rejudsue.cf",
    "rejudsue.ga",
    "rejudsue.gq",
    "rejudsue.ml",
    "rejudsue.tk",
    "rekap.sk",
    "rekeyko.press",
    "reklamad.site",
    "reklambladerbjudande.se",
    "reklambladerbjudanden.se",
    "reklamhome1.xyz",
    "reklamilanlar005.xyz",
    "reklamilanlar007.xyz",
    "reklamilanlar009.xyz",
    "reklamtr81.website",
    "rekorber67.com",
    "rekorbet100.com",
    "rekorbet50.com",
    "rekorbet66.com",
    "rekorbet80.com",
    "rekorbet90.com",
    "reksareksy78oy.ml",
    "reksatal-effective.ru",
    "rekt.ml",
    "rekthosting.ml",
    "relaet.com",
    "relationbreakthrough.com",
    "relationbreakthroughsecrets.com",
    "relationdevelopment.com",
    "relationsansprisdetete-confirmed.com",
    "relationsansprisdetete-meet-backup.com",
    "relationsansprisdetete-meet.com",
    "relationsansprisedetete-confirmed.com",
    "relationsansprisedetete-meet-backup.com",
    "relationsansprisedetete-meet.com",
    "relationsdesk.com",
    "relationship-transformers.com",
    "relationshipbreakthroughsecrets.net",
    "relationshipdevelop.com",
    "relationshiphotline.com",
    "relationshippanecia.site",
    "relationshiptransformer.org",
    "relationshipwebinar.com",
    "relax59.com",
    "relaxbahis11.xyz",
    "relaxbahis12.xyz",
    "relaxbahis13.com",
    "relaxbahis82.com",
    "relaxbahis95.com",
    "relaxeyesasmr.online",
    "relaxeyesasmr.xyz",
    "relaxforyou.space",
    "relaxiro.site",
    "relaxirony.site",
    "relaxology.ru",
    "relaxst.icu",
    "relaxwrec.icu",
    "relay-bossku3.com",
    "relay-bossku4.com",
    "relayed.org",
    "relayimmo.com",
    "relazionifacili-confirmed.com",
    "relazionifacili-meet-backup.com",
    "relazionifacili-meet.com",
    "relcasecrm.com",
    "release-o-matic.com",
    "releasepal.com",
    "releasethekraken.online",
    "releaseyourmusic.com",
    "releri.cf",
    "releri.ga",
    "relevart.com",
    "relia.com",
    "reliable-mail.com",
    "reliablespell.xyz",
    "reliantcapitalgroup.com",
    "reliefieut.site",
    "reliefteam.com",
    "religious.com",
    "relika.cf",
    "relika.ga",
    "relith.xyz",
    "reliz46.ru",
    "reloadbet55.com",
    "reloadbet78.com",
    "reloadpoint.ru",
    "relom.online",
    "relrb.com",
    "relscience.us",
    "reludexo.site",
    "relxdzy.com",
    "relyst.store",
    "remail.cf",
    "remail.ga",
    "remail7.com",
    "remailer.tk",
    "remailsky.com",
    "remann.com",
    "remarkable.rocks",
    "remaster.su",
    "remaxofnanaimopropertymanagement.com",
    "rembitmaster.ru",
    "remedio-para-emagrecer.com",
    "remehan.ga",
    "remehan.ml",
    "remembrance.ooo",
    "rementb.shop",
    "remgelind.cf",
    "remgelind.ml",
    "remicon.cf",
    "remicon.gq",
    "remicon.ml",
    "remicon.tk",
    "remilitarizes329uj.online",
    "remisde.cf",
    "remisde.tk",
    "remisra.gq",
    "remisra.tk",
    "remisyrer.club",
    "remitano.biz",
    "remitano.dev",
    "remitano.us",
    "remixify.com",
    "remocalifornia.com",
    "remodalista.com",
    "remomer.ga",
    "remomer.gq",
    "remomer.tk",
    "remont-92.ru",
    "remont-dubai.ru",
    "remont-iq.ru",
    "remont-stoy.ru",
    "remontholoda36.ru",
    "remontvuu.ru",
    "remonty-v-sochi.ru",
    "remospizza-ashbourne.com",
    "remote.li",
    "removfap.com",
    "remprojects.com",
    "remusi.cf",
    "remusi.gq",
    "remusi.tk",
    "remythompsonphotography.com",
    "renalremission.net",
    "renault-brasil.club",
    "renault-duster-online.ru",
    "renault-forums.ru",
    "renault-kangoo.club",
    "renault-sa.cf",
    "renault-sa.ga",
    "renault-sa.gq",
    "renault-sa.ml",
    "renault-sa.tk",
    "renaulttrucks.cf",
    "renaulttrucks.ga",
    "renaulttrucks.gq",
    "renaulttrucks.ml",
    "renaulttrucks.tk",
    "renchah.com",
    "rencontresannonces.com",
    "rendek.info",
    "render.community",
    "rendimenttogold.xyz",
    "rendymail.com",
    "renesilva.net",
    "renewinsidergift.com",
    "renewitcarsales.com",
    "renewtechnologyinc.com",
    "rengginangred95btw.cf",
    "reninimpressskulk.site",
    "renlet.ru",
    "renliner.cf",
    "renliner.ga",
    "renliner.gq",
    "rennoverahuset.nu",
    "renobussines.com",
    "renodepot.net",
    "renomitt.ml",
    "renoquote.com",
    "renostory.com",
    "renoszrtqw.club",
    "renovacaorg.site",
    "renovateur.com",
    "renovation-building.ru",
    "renoveringshuset.nu",
    "renraku.in",
    "renren.com",
    "rentadeautoscancun.uno",
    "rentaharleybike.com",
    "rentalmobilyogyakarta.biz",
    "rentberry-scam.com",
    "rentberryscam.com",
    "rentd.info",
    "rentinmilwaukee.com",
    "rentitthento.press",
    "rentlyna.cf",
    "rentlyna.ga",
    "rentlyna.gq",
    "rentlyna.tk",
    "rentmotivenow.info",
    "rentoilfieldequipment.com",
    "rentpober.cf",
    "rentpober.gq",
    "rentpober.ml",
    "renumax-dealer.ru",
    "renwoying.org",
    "renx.de",
    "reo2lease.com",
    "reobreakti.gq",
    "reobreakti.tk",
    "reogland.com",
    "reollink.com",
    "reopenireland.com",
    "reorganize953mr.online",
    "reossanyth.cf",
    "reossanyth.ga",
    "reossanyth.gq",
    "reossanyth.ml",
    "reossanyth.tk",
    "reostream.site",
    "reotractant.tk",
    "rep3-payment.site",
    "rep5-german.site",
    "rep6-payment.club",
    "repair.su",
    "repairalliance.org",
    "repairman.com",
    "repargy.cf",
    "repargy.ga",
    "repargy.gq",
    "repargy.ml",
    "repargy.tk",
    "repdom.info",
    "repeatxdu.com",
    "repetitorka.ru",
    "repetitoronlayn.ru",
    "repfootballpop.website",
    "rephyre.ga",
    "rephyre.gq",
    "replacedocs.com",
    "replacementd.email",
    "replacementwindowsnearme.net",
    "replatform.live",
    "replay-wg.site",
    "replica-surfaces.com",
    "reply.hu",
    "reply.ticketmaster.com",
    "repmyfgaj.ga",
    "repobet6.com",
    "repobet7.com",
    "repolusi.com",
    "reportes.ml",
    "reportgate.net",
    "reportptol.tk",
    "represantive.com",
    "representative.com",
    "reprisalist.com",
    "reprocar.com",
    "reproductivestrategies.com",
    "reproductivestrategies.info",
    "reprogramforhealth.com",
    "repsandri.ga",
    "repsandri.tk",
    "repsec.com",
    "repshop.net",
    "reptech.org",
    "reptileextinctrecovery.website",
    "reptilegenetics.com",
    "repubblica-24it.website",
    "republikjaket.com",
    "repubstore.ru",
    "repufire.com",
    "repumazing.com",
    "repuno.net",
    "repushit.com",
    "req.rest",
    "reqaxv.com",
    "rerajut.com",
    "rere.site",
    "rerecircle.com",
    "rereferenced.com",
    "rerollers.com",
    "res.craigslist.org",
    "resadjro.cf",
    "resadjro.ga",
    "resadjro.tk",
    "resalefx.ru",
    "resantamiass.ru",
    "rescoatran.gq",
    "rescoatran.ml",
    "rescoatran.tk",
    "rescue-cash.com",
    "rescuemountain.org",
    "rescueteam.com",
    "rescuewildlife.com",
    "resealzfuc.space",
    "research-paper-writingservice.com",
    "researchdetectors.com",
    "researchgems.com",
    "researchmob.com",
    "researchsafety.org",
    "researchstage.com",
    "resellermurah.me",
    "resellhotel.site",
    "resellking.ru",
    "resepku.site",
    "reservefxnf.email",
    "reservelp.de",
    "reservoirsource.com",
    "reset-secure.com",
    "resetsecure.org",
    "resgedvgfed.tk",
    "resgranpalacio.com",
    "reshaping.biz",
    "reshuolimp.ru",
    "residencesdesroyetfils.com",
    "residencialgenova.com",
    "residencias-ancianos.info",
    "residencias-baratas.com",
    "residencias-mayores.info",
    "residencias-rehabilitacion.com",
    "residencymail.com",
    "residentialpacifist.com",
    "resifi.com",
    "resifi.net",
    "resignationcustodyoffend.website",
    "resimbudur.online",
    "resimbudur.xyz",
    "resin-board.com",
    "resinboard.com",
    "resindeca.xyz",
    "resinlqdtk.space",
    "resintesshop.xyz",
    "resirtest.club",
    "resistore.co",
    "resize.email",
    "resla-rasxaer.ru",
    "reslifestaff.com",
    "resmail24.com",
    "resmigazete.net",
    "resneti.ga",
    "resneti.ml",
    "resneti.tk",
    "resolution4print.info",
    "resorings.com",
    "resortmapprinters.com",
    "resortmapprints.com",
    "resortsp.club",
    "resounkffh.space",
    "resource.calendar.google.com",
    "resource.vote",
    "resources.vote",
    "resourcesfordancers.com",
    "resourcingchristianity.com",
    "respectabrew.com",
    "respectabrew.net",
    "respectanimals.com",
    "responsiveclassroom.info",
    "responsiveclassrooms.org",
    "respublica.app",
    "resseru.ga",
    "ressources-solidaires.info",
    "rest-top.ru",
    "restabbetting.xyz",
    "restarteurope.com",
    "restartmotora.ru",
    "restaurangselins.se",
    "restauranteasturianoelraitan.com",
    "restauranteatarantella.com",
    "restaurantechinolitualicante.com",
    "restaurantechinoyongfeng.com",
    "restauranteindiangardenmadrid.com",
    "restaurantekansasburger.com",
    "restaurantemaxim.com",
    "restauranteoishiizaragoza.com",
    "restauranthosting.com",
    "restaurantmarketinglasvegas.com",
    "restaurantsnearme.life",
    "restbetgir.site",
    "resthinstbah.cf",
    "resthinstbah.ga",
    "resthinstbah.tk",
    "restilogic.xyz",
    "restingcamel.net",
    "restnotes.com",
    "restonstartups.com",
    "restoraninovisad.info",
    "restorationcoffee.us",
    "restorativedentistnearme.com",
    "restorefitnessplan.com",
    "restudwimukhfian.com",
    "restwin.com",
    "restyourlife.org",
    "result-api.shop",
    "resultaat.marketing",
    "resultaatmarketing.com",
    "resultadodehoje.org",
    "resumemail.com",
    "resumeshortly.com",
    "resx.net",
    "ret35363ddfk.cf",
    "ret35363ddfk.ga",
    "ret35363ddfk.gq",
    "ret35363ddfk.ml",
    "ret35363ddfk.tk",
    "retailadservices.com",
    "retailer.report",
    "retailfan.com",
    "retailingcbd.com",
    "retailofferunion.host",
    "retailr.org",
    "retailreserve.com",
    "retailsolutionadvisors.com",
    "retailswitching.com",
    "retajjgroup.com",
    "retapps.cloud",
    "retep.com.au",
    "rethmail.ga",
    "retinaeyehealth.com",
    "retirementandincomeacademy.com",
    "retirementhomefinder.org",
    "retirementhomelocator.com",
    "retirementhomestoday.com",
    "retkesbusz.nut.cc",
    "retlayrei.ga",
    "retlayrei.ml",
    "retlayrei.tk",
    "retnooktapratama.me",
    "retourjustepourlefun.com",
    "retreatyourselfwell.net",
    "retrewqa.online",
    "retrocityarcade.net",
    "retrocityarcade.org",
    "retrolith.xyz",
    "retrolium.xyz",
    "retromail.dk",
    "retropup.com",
    "retrubio.press",
    "retsept18.ru",
    "return0.ga",
    "return0.gq",
    "return0.ml",
    "returnhealth.ru",
    "returns-center.com",
    "returnsify.com",
    "retvtoday.com",
    "reubidium.com",
    "reuglenpet.cf",
    "reuglenpet.ml",
    "reuglenpet.tk",
    "reunion-multimedia.com",
    "reusablejutetotes.com",
    "rev-amz.xyz",
    "rev-mail.net",
    "rev-zone.net",
    "rev-zone.xyz",
    "revampdiaries.com",
    "revarix.com",
    "revealbid.com",
    "reveate.com",
    "revelationsbotique.com",
    "revelationschool.net",
    "revelryshindig.com",
    "revenge.vote",
    "revenue.com",
    "revenueengineers.group",
    "reverancevegas.com",
    "reverenddanger.com",
    "reversapal.com",
    "reversed.photo",
    "reversefone.com",
    "reversefrachise.com",
    "reverseimage.photo",
    "reversemortgage2020.com",
    "revhairproducts.com",
    "revi.ltd",
    "revieoo.com",
    "review4bonus.net",
    "reviewcasino.ru",
    "reviewedtv.com",
    "reviewlately.com",
    "reviewndecide.com",
    "reviewsblog.org",
    "reviewscasino.ru",
    "reviewsforproduct.info",
    "reviewsofhandbags.com",
    "reviewsofpsychics.com",
    "revistaanabel.com",
    "revistavanguardia.com",
    "revivalstock.com",
    "revive.bio",
    "revodac.site",
    "revolunity.com",
    "revolute-org.xyz",
    "revoluthp.xyz",
    "revolutionalgorithm.com",
    "revolutionaryabolitionist.org",
    "revolutionpowersolutions.online",
    "revolvingdoorhoax.org",
    "revy.com",
    "rew.team",
    "rewalle.ga",
    "rewardsforjustice.org",
    "rewas-app-lex.com",
    "rewood.us",
    "reword.press",
    "rewste.online",
    "rewtorsfo.ru",
    "rex-app-lexc.com",
    "rex01.xyz",
    "rex4sheriff16.com",
    "rexagod-freeaccount.cf",
    "rexagod-freeaccount.ga",
    "rexagod-freeaccount.gq",
    "rexagod-freeaccount.ml",
    "rexagod-freeaccount.tk",
    "rexagod.cf",
    "rexagod.ga",
    "rexagod.gq",
    "rexagod.ml",
    "rexagod.tk",
    "rexburgwebsites.com",
    "rexian.com",
    "rexuejianghusifu.com",
    "reydonerkebabmalaga.com",
    "reyw3.us",
    "rezablog.com",
    "rezadrese.live",
    "rezai.com",
    "rezepi.info",
    "rezolventa.ru",
    "rfavy2lxsllh5.cf",
    "rfavy2lxsllh5.ga",
    "rfavy2lxsllh5.gq",
    "rfavy2lxsllh5.ml",
    "rfc822.org",
    "rfd-mauritanie.org",
    "rfdlsmkx.shop",
    "rfgt.ga",
    "rfgym.ru",
    "rfirewallj.com",
    "rfjrx1.info",
    "rfkstm.icu",
    "rfm-analysis.com",
    "rfreedomj.com",
    "rfsa8h-mail.xyz",
    "rftix.fun",
    "rftt.de",
    "rfuvault.com",
    "rfvqi.us",
    "rfx2h.us",
    "rfxe.us",
    "rfzaym.ru",
    "rgames.us",
    "rgarch.info",
    "rgb9000.net",
    "rgcincy.com",
    "rgdoubtdhq.com",
    "rggmtoxv.tech",
    "rgjae5.best",
    "rgmedianetwork.com",
    "rgmediapartners.com",
    "rgoponga.gq",
    "rgoponga.tk",
    "rgostabbet.xyz",
    "rgphotos.net",
    "rgtvtnxvci8dnwy8dfe.cf",
    "rgtvtnxvci8dnwy8dfe.ga",
    "rgtvtnxvci8dnwy8dfe.gq",
    "rgtvtnxvci8dnwy8dfe.ml",
    "rgtvtnxvci8dnwy8dfe.tk",
    "rgwfagbc9ufthnkmvu.cf",
    "rgwfagbc9ufthnkmvu.ml",
    "rgwfagbc9ufthnkmvu.tk",
    "rgxuty.site",
    "rh0d1um.online",
    "rh0d1um.org",
    "rh3qqqmfamt3ccdgfa.cf",
    "rh3qqqmfamt3ccdgfa.ga",
    "rh3qqqmfamt3ccdgfa.gq",
    "rh3qqqmfamt3ccdgfa.ml",
    "rh3qqqmfamt3ccdgfa.tk",
    "rhabne.us",
    "rhapsodytakeaway.com",
    "rhcassist.com",
    "rhdxzn.top",
    "rheank.com",
    "rheeebstore.com",
    "rheophile.site",
    "rheotaxis.site",
    "rheumview.com",
    "rhexis.xyz",
    "rhinoplastynashville.com",
    "rhn0hg.us",
    "rhnqxt.site",
    "rho44.com",
    "rhodecoders.online",
    "rhodeislandquote.com",
    "rhodium.llc",
    "rhodiumgroup.llc",
    "rhombushorizons.com",
    "rhondawilcoxfitness.com",
    "rhotacism.xyz",
    "rhouseh.shop",
    "rhpzrwl4znync9f4f.cf",
    "rhpzrwl4znync9f4f.ga",
    "rhpzrwl4znync9f4f.gq",
    "rhpzrwl4znync9f4f.ml",
    "rhpzrwl4znync9f4f.tk",
    "rhrrsbqp.shop",
    "rhubgrmq.shop",
    "rhumbrun.com",
    "rhumworld.com",
    "rhvsxf.us",
    "rhymon.com",
    "rhyta.com",
    "rhythbagza.cf",
    "rhythbagza.ga",
    "rhythbagza.ml",
    "rhythmerp.com",
    "ri9lhx.us",
    "riabervie.cf",
    "riabervie.ga",
    "riabervie.ml",
    "riabervie.tk",
    "riacomponents.com",
    "rialisis.cf",
    "rialisis.ga",
    "rialisis.gq",
    "rialisis.ml",
    "riamitpo.cf",
    "riamitpo.ga",
    "riamitpo.gq",
    "riamof.club",
    "riaquili.cf",
    "riaquili.ml",
    "riaquili.tk",
    "riarotta.cf",
    "riarotta.ga",
    "riarotta.gq",
    "riarotta.ml",
    "riarysem.cf",
    "riarysem.ga",
    "riarysem.ml",
    "riarysem.tk",
    "riasdevil.graphics",
    "riasporem.gq",
    "riaucyberart.ga",
    "riavisoop.ml",
    "riba-4ok.ru",
    "riba-stillorgan.com",
    "ribalka-info.ru",
    "ribenhao.com",
    "ribenjia.com",
    "ribenjiameng.com",
    "ribenpu.com",
    "ribenre.com",
    "ribenshanghui.com",
    "ribentu.com",
    "ribenwo.com",
    "ribenzhaoshang.com",
    "ribenzhifu.com",
    "ricarice.shop",
    "riccardobrinkman.online",
    "rice.edu",
    "ricelandtakeaway.com",
    "rich-mail.net",
    "rich-money.pw",
    "rich-rp.com",
    "rich-sk.com",
    "rich-town.site",
    "richard.salon",
    "richardbenesti.com",
    "richardlivolsi.com",
    "richardsonpersonalinjury.com",
    "richardtoon.net",
    "richardyoung55places.com",
    "richday.xyz",
    "richdi.ru",
    "riches222.com",
    "riches333.com",
    "riches567.com",
    "riches789.com",
    "richestweb.com",
    "richesxo.com",
    "richfinances.pw",
    "richfunds.pw",
    "richinssuresh.ga",
    "richmondcosmeticsurgery.com",
    "richmondhairsalons.com",
    "richmondhill.com",
    "richmondindepotdistrict.com",
    "richmondlaundry.com",
    "richmondnailsalons.com",
    "richmondpride.org",
    "richmondvadogtrainer.com",
    "richmoney.pw",
    "richonedai.pw",
    "richpoker88.org",
    "richsmart.pw",
    "richtoon.lawyer",
    "richtoon.net",
    "richtoon.org",
    "richtoonlaw.com",
    "ricimail.com",
    "ricirich22.com",
    "rickbuys.house",
    "rickiemetal.com",
    "rickifoodpatrocina.tk",
    "rickmoriarity.com",
    "rickpaquin.com",
    "rickpropertiesllc.com",
    "ricks-properties.com",
    "ricks.plumbing",
    "ricksfund.com",
    "rickshawchinesetakeaway.com",
    "rickspropertiesllc.com",
    "rickthorpefund.org",
    "rickyinthepark.com",
    "rickymail.com",
    "rickymetal.com",
    "rickysfundamentals.com",
    "rickztah.best",
    "rico.cool",
    "ricret.com",
    "ricrk.com",
    "ridaky.gq",
    "ridaky.tk",
    "riddermark.de",
    "rideclickbas.com",
    "ridepple.cf",
    "ridepple.gq",
    "ridepple.ml",
    "ridesharedriver.org",
    "ridethechain.com",
    "ridgeado.xyz",
    "ridgeleyig.org",
    "ridgevide.fun",
    "ridicom.ru",
    "ridpaisess.ga",
    "ridwabar.ga",
    "ridwabar.ml",
    "riecrimal.ga",
    "riecrimal.gq",
    "riecrimal.ml",
    "riecrimal.tk",
    "riel5.ru",
    "rielunu.ml",
    "rielunu.tk",
    "riemsi.space",
    "riewonmo.cf",
    "riewonmo.gq",
    "rif-ramarew.ru",
    "rifkian.cf",
    "rifkian.ga",
    "rifkian.gq",
    "rifkian.ml",
    "rifkian.tk",
    "rifo.ru",
    "rigedeers.cf",
    "rigedeers.ga",
    "rigedeers.tk",
    "rigel6.com",
    "right-leftempire.com",
    "rightbet1a.pro",
    "rightca.email",
    "rightexch.com",
    "rightheapun.ga",
    "rightheapun.ml",
    "rightheapun.tk",
    "righthirlo.cf",
    "righthirlo.gq",
    "righthirlo.ml",
    "rightmom.net",
    "rightnownotes.com",
    "rightonfact.rest",
    "rightsh.xyz",
    "rigolo.ru",
    "rigormentorslang.site",
    "rik-morty.ru",
    "rika-santila.ru",
    "rikekvinner.com",
    "rikka-weaka.ru",
    "riko.site",
    "rikputs.space",
    "riks1337.site",
    "rilholding.net",
    "rilingna.cf",
    "rilingna.ga",
    "rilingna.gq",
    "rilingna.ml",
    "rilohaf.gq",
    "rilohaf.ml",
    "rim7lth8moct0o8edoe.cf",
    "rim7lth8moct0o8edoe.ga",
    "rim7lth8moct0o8edoe.gq",
    "rim7lth8moct0o8edoe.ml",
    "rim7lth8moct0o8edoe.tk",
    "rimmerworld.xyz",
    "rimonabant.website",
    "rimoralliance.info",
    "rims.rocks",
    "rin.ru",
    "rin71.space",
    "rinaddresmo.com",
    "rindupoker.com",
    "ring.by",
    "ringier.tech",
    "ringmybell.dk",
    "ringobaby344.cf",
    "ringobaby344.ga",
    "ringobaby344.gq",
    "ringobaby344.ml",
    "ringobaby344.tk",
    "ringobot.ru",
    "ringofyourpower.info",
    "ringwesttran.ga",
    "ringwesttran.gq",
    "ringwesttran.tk",
    "rinheverci.site",
    "rinit.info",
    "rinito.cf",
    "rinito.gq",
    "rinota.cf",
    "rinota.ga",
    "rinota.gq",
    "rinota.tk",
    "rintisus.cf",
    "rintisus.ga",
    "rintisus.gq",
    "rintupo.cf",
    "rintupo.gq",
    "rintupo.tk",
    "rioadgqn.shop",
    "riobetpromokod1.ru",
    "rioclub.site",
    "riodejaneironews.site",
    "riogoj.tech",
    "riojaqvkl.space",
    "riomaglo.cf",
    "riomaglo.ga",
    "riomaglo.gq",
    "riomaglo.tk",
    "riopiwatch.ga",
    "riopiwatch.gq",
    "riopreto.com.br",
    "riopromun.cf",
    "riopromun.gq",
    "riopromun.ml",
    "riopromun.tk",
    "riorovi.cf",
    "riorovi.gq",
    "riorovi.ml",
    "riotap.com",
    "riotel.xyz",
    "riotesli.ga",
    "riotesli.ml",
    "riotesli.tk",
    "riotete.cf",
    "riotete.ml",
    "riotlogwong.cf",
    "riotlogwong.ga",
    "riotlogwong.gq",
    "riotlogwong.tk",
    "rioveli.cf",
    "rioveli.ga",
    "rioveli.ml",
    "rioveli.tk",
    "ripioutlets.site",
    "ripiste.cf",
    "ripiste.ga",
    "ripiste.gq",
    "ripoepa.space",
    "ripohand.cf",
    "ripohand.ml",
    "ripohand.tk",
    "rippadakidmusic.com",
    "ripparewards.net",
    "riqsiv.site",
    "risbobi.cf",
    "risbobi.ga",
    "risbobi.gq",
    "risbobi.ml",
    "risbobi.tk",
    "rise.de",
    "risencraft.ru",
    "risesturizm.online",
    "risesturizm.xyz",
    "rising-phoenix-takeaway.com",
    "risingsuntouch.com",
    "riski.cf",
    "ristorantepizzeriadamarc.com",
    "ristoranteromanocork.com",
    "risu.be",
    "rit.edu",
    "ritade.com",
    "ritadecrypt.net",
    "ritalinus.site",
    "ritamt2.xyz",
    "ritighpi.cf",
    "ritighpi.gq",
    "ritighpi.tk",
    "ritoper.ml",
    "ritualhwdz.space",
    "ritualkisdj.email",
    "ritugon.host",
    "ritun.xyz",
    "riujnivuvbxe94zsp4.ga",
    "riujnivuvbxe94zsp4.ml",
    "riujnivuvbxe94zsp4.tk",
    "riukafo.cf",
    "riukafo.ga",
    "riukafo.ml",
    "riulandtv.site",
    "riut.ru",
    "riuyt.com",
    "riv3r.net",
    "rival-abroad.xyz",
    "rivalbox.info",
    "rivalbox.net",
    "rivalro.us",
    "river-branch.com",
    "rivercityferries.com",
    "rivercityhomespot.club",
    "riverdale.club",
    "riverha.press",
    "riverob.press",
    "riverpu.xyz",
    "riverpun.xyz",
    "riverpunc.xyz",
    "riverregionfood.org",
    "riversidebaitruong.com",
    "riversidehoteldominica.com",
    "riversideinjurylawyers.com",
    "riversidenailsalons.com",
    "riversidequote.com",
    "rivertondoctors.com",
    "rivervalleyrep.com",
    "riverview-takeaway.com",
    "riverviewcontractors.com",
    "rivierawellnessretreat.org",
    "rivimeo.com",
    "rixcloud00010.xyz",
    "rixcloud00040.xyz",
    "rixcloud00050.xyz",
    "rixcloud00080.xyz",
    "rixcloud00090.xyz",
    "rixos.media",
    "rixoscasino36.com",
    "rixoscasino37.com",
    "riytita.cf",
    "riytita.ml",
    "riytita.tk",
    "riywelctrig.cf",
    "riywelctrig.ml",
    "riywelctrig.tk",
    "rizadr.xyz",
    "rizberk.com",
    "rizberkcloud.com",
    "rizberkserviscloud.com",
    "rizedance.com",
    "rizeligencler.com",
    "rizeligencler.xyz",
    "rizeliguney.xyz",
    "rizemobese.com",
    "rizisowa.site",
    "rj-11.cf",
    "rj-11.ga",
    "rj-11.gq",
    "rj-11.ml",
    "rj-11.tk",
    "rj11.cf",
    "rj11.ga",
    "rj11.gq",
    "rj11.ml",
    "rj11.tk",
    "rj2tpm.us",
    "rj7zmu.us",
    "rjbemestarfit.host",
    "rjbemestarfit.site",
    "rjbtech.com",
    "rjcfu0.best",
    "rjclctin.tech",
    "rjdwpxykkv.fun",
    "rjfencesandgates.com",
    "rjhhgl.com",
    "rjjsz.live",
    "rjkl.us",
    "rjmerah.com",
    "rjof.info",
    "rjolympics.com",
    "rjopoker88.com",
    "rjopoker88.net",
    "rjpqnu.site",
    "rjxewz2hqmdshqtrs6n.cf",
    "rjxewz2hqmdshqtrs6n.ga",
    "rjxewz2hqmdshqtrs6n.gq",
    "rjxewz2hqmdshqtrs6n.ml",
    "rjxewz2hqmdshqtrs6n.tk",
    "rk0fd.info",
    "rk2w4c.us",
    "rk4vgbhzidd0sf7hth.cf",
    "rk4vgbhzidd0sf7hth.ga",
    "rk4vgbhzidd0sf7hth.gq",
    "rk4vgbhzidd0sf7hth.ml",
    "rk4vgbhzidd0sf7hth.tk",
    "rk5dfj-mail.xyz",
    "rk9.chickenkiller.com",
    "rkbxm1.site",
    "rkcmfn.fun",
    "rkdmjz.fun",
    "rkhmjl.fun",
    "rkhmqh.fun",
    "rkjaufps.shop",
    "rkjmwy.fun",
    "rkkmsp.fun",
    "rklips.com",
    "rko.kr",
    "rkofgttrb0.cf",
    "rkofgttrb0.ga",
    "rkofgttrb0.gq",
    "rkofgttrb0.ml",
    "rkofgttrb0.tk",
    "rkomo.com",
    "rkrmjk.fun",
    "rktp.dev",
    "rktwm.club",
    "rkwdpa.com",
    "rkwmhn.fun",
    "rkxmhk.fun",
    "rkympw.fun",
    "rl425u.live",
    "rl513a.live",
    "rl75me8c.site",
    "rlkwud.us",
    "rlodvh.us",
    "rlqjr8.info",
    "rlrrcj.site",
    "rlw999.com",
    "rm-law.org",
    "rm-tour.ru",
    "rm2rf.com",
    "rm7d3rzx.xyz",
    "rma.ec",
    "rmail.cf",
    "rmailcloud.com",
    "rmailgroup.in",
    "rmakbe.best",
    "rmas0.us",
    "rmcecommerce.online",
    "rmcp.cf",
    "rmcp.ga",
    "rmcp.gq",
    "rmcp.ml",
    "rmcp.tk",
    "rmjd3z-mail.xyz",
    "rmmakw.rest",
    "rmoaz.live",
    "rmocybsl7.space",
    "rmocybsl7.website",
    "rmocybsl7.xyz",
    "rmorin.com",
    "rmpc.de",
    "rmpropane.com",
    "rmqkr.net",
    "rmsql.info",
    "rmtbgn.site",
    "rmtmarket.ru",
    "rmwluudf.shop",
    "rmwndknfo.shop",
    "rn.com",
    "rnabr.com",
    "rnailinator.com",
    "rnc69szk1i0u.cf",
    "rnc69szk1i0u.ga",
    "rnc69szk1i0u.gq",
    "rnc69szk1i0u.ml",
    "rnc69szk1i0u.tk",
    "rnd7e.us",
    "rnewstabilbettingsnapp.xyz",
    "rng.one",
    "rnghlfwp.shop",
    "rnh71.space",
    "rniab.us",
    "rnjc8wc2uxixjylcfl.cf",
    "rnjc8wc2uxixjylcfl.ga",
    "rnjc8wc2uxixjylcfl.gq",
    "rnjc8wc2uxixjylcfl.ml",
    "rnjc8wc2uxixjylcfl.tk",
    "rnm-aude.com",
    "rnohnp.com",
    "rnydx.us",
    "rnzcomesth.com",
    "ro-dev.online",
    "ro-na.com",
    "ro.lt",
    "ro.ru",
    "ro6b3.us",
    "road2recovery.online",
    "roadcasinogam.ru",
    "roadigraavertu.ru",
    "roadkingoutdoor.com",
    "roadrunner.com",
    "roadshowdahua.com",
    "roahenself.cf",
    "roamvegas.com",
    "roanawel.ga",
    "roanawel.gq",
    "roanokemail.com",
    "roar.capital",
    "roargame.com",
    "roaring.pro",
    "roastermachines.org",
    "roastscreen.com",
    "roawintio.cf",
    "roawintio.tk",
    "rob4sib.org",
    "robaxin.website",
    "robbogans.info",
    "robbolahta.ru",
    "robchicly.com",
    "robentowels.com",
    "robergwo.gq",
    "robergwo.ml",
    "robergwo.tk",
    "robertdipietro.com",
    "robertiazx.ru",
    "robertmowlavi.com",
    "robertodure.tech",
    "robertos-takeaway-louth.com",
    "robertspcrepair.com",
    "robind.dev",
    "robinsnestfurnitureandmore.com",
    "robinzonshop.ru",
    "robkanass.ml",
    "robkanass.tk",
    "robmita.cf",
    "robmita.ga",
    "robmita.gq",
    "robmita.tk",
    "robmorgblack.com",
    "robo-opus.com",
    "robo.poker",
    "robo3.club",
    "robo3.co",
    "robo3.me",
    "robo3.site",
    "roboku.com",
    "robomart.net",
    "robot-alice.ru",
    "robot-mail.com",
    "robot2.club",
    "robot2.me",
    "robotappstore.info",
    "robotbobot.ru",
    "robotent.org",
    "robothorcrux.com",
    "robotichomecenter.com",
    "robotickee.com",
    "roboticpenguina.com",
    "robotinc.net",
    "robotizes167vl.online",
    "robotjobs.org",
    "robotodo.ru",
    "robox.agency",
    "robsden.info",
    "robsradio.com",
    "robufo.info",
    "robytoy.com",
    "rocanoapp.ru",
    "roccard.com",
    "roccas-takeaway.com",
    "rochelleskincareasli.com",
    "rochester.rr.com",
    "rochesterquote.com",
    "rochmeve.cf",
    "rochmeve.ga",
    "rochmeve.ml",
    "rochmeve.tk",
    "rocibou.cf",
    "rocibou.gq",
    "rocibou.ml",
    "rocibou.tk",
    "rock.com",
    "rockabubz.com",
    "rockandrollglossary.com",
    "rockdaleumc.org",
    "rockdunna.cf",
    "rockdunna.gq",
    "rockdunna.tk",
    "rocket201.com",
    "rocketfuelforyourbrain.rocks",
    "rockethosting.xyz",
    "rocketleague-team.com",
    "rocketmail.cf",
    "rocketmail.com",
    "rocketmail.ga",
    "rocketmail.gq",
    "rocketship.com",
    "rocketshipstudio.net",
    "rockfan.com",
    "rockfordnailsalons.com",
    "rockhamptonworkshops.com",
    "rockhillcareers.com",
    "rockislandapartments.com",
    "rockkes.us",
    "rockmail.top",
    "rockmailapp.com",
    "rockmailgroup.com",
    "rockofagesranch.org",
    "rockpooldiningroup.com",
    "rockstarkelly.com",
    "rocktheheads.com",
    "rocktoberfishing.org",
    "rockwoolstock.ru",
    "rockyboots.ru",
    "rockyoujit.icu",
    "rockypointfamilydentist.net",
    "rockytheraccoon.com",
    "rockzoppten.ga",
    "rockzoppten.gq",
    "rockzoppten.ml",
    "rockzoppten.tk",
    "rodapoker.xyz",
    "rodax-software.online",
    "roddrodden.com",
    "roderina.com",
    "rodeslava.ru",
    "rodewayinnmuskogee.com",
    "rodfirearms.com",
    "rodionder63.ru",
    "rodjohnsonswienershack.net",
    "rodjohnsonwienershack.com",
    "rodneywebb2023.com",
    "rodneywebb2024.com",
    "rodriguealcazar.com",
    "rodrun.com",
    "rodrunner.ru",
    "rodumre.gq",
    "rodumre.tk",
    "roduret.site",
    "rodwhifa.cf",
    "rodwhifa.ga",
    "rodwhifa.tk",
    "roegegna.tk",
    "roetrisjohn.cf",
    "roetrisjohn.ga",
    "roetrisjohn.gq",
    "roetrisjohn.ml",
    "roewe.cf",
    "roewe.ga",
    "roewe.gq",
    "roewe.ml",
    "rofacme.cf",
    "rofacme.gq",
    "rogacomp.cf",
    "rogacomp.ga",
    "rogacomp.gq",
    "rogapartsllc.com",
    "rogeoi.xyz",
    "rogerbradburyphotography.com",
    "rogerin.space",
    "rogers.com",
    "rogerwisor.com",
    "rogge.best",
    "rogpasimp.cf",
    "rogpasimp.gq",
    "rogpasimp.ml",
    "rogpasimp.tk",
    "roguesec.net",
    "roguesec.org",
    "roguewavecoffee.com",
    "roguewaveroasting.com",
    "rohandoge.ml",
    "rohingga.xyz",
    "roi50.ru",
    "roi70.ru",
    "roigiayto.website",
    "roikased.ga",
    "roiturater.tk",
    "rojadirecta.best",
    "rojname.com",
    "rojomorgan.com",
    "roketus.com",
    "roksbahis61.online",
    "roksbahis61.xyz",
    "roksbahis79.com",
    "roksbahis82.com",
    "rokucollection.com",
    "rokzrdprvt.space",
    "rol.ro",
    "rolex19bet.com",
    "rolex31bet.com",
    "rolexbahis.com",
    "rolipic.site",
    "rollegal.site",
    "rollerbrush.org",
    "rollerbrushes.net",
    "rollercover.org",
    "rollercover.us",
    "rollercovers.net",
    "rollercovers.us",
    "rollerlaedle.de",
    "rollh4.live",
    "rollh49.live",
    "rollindo.agency",
    "rolling-discs.ru",
    "rollingvase.com",
    "rollsroyce-plc.cf",
    "rollsroyce-plc.ga",
    "rollsroyce-plc.gq",
    "rollsroyce-plc.ml",
    "rollsroyce-plc.tk",
    "rolndedip.cf",
    "rolndedip.ga",
    "rolndedip.gq",
    "rolndedip.ml",
    "rolndedip.tk",
    "rolorin.space",
    "rolvh.us",
    "roma-clondalkin.com",
    "roma-drogheda.com",
    "roma-fish-chips.com",
    "roma-takeaway.com",
    "romabeto.xyz",
    "romabetz.xyz",
    "romaclondalkin.com",
    "romaitaliantakeaway.com",
    "romana.site",
    "romania-news.space",
    "romaniansalsafestival.com",
    "romanibm.site",
    "romanibv.site",
    "romanict.site",
    "romanidd.site",
    "romanidq.site",
    "romanies.site",
    "romanticizing335sg.online",
    "romanticsgarden.com",
    "romantiskt.se",
    "romareusa.ru",
    "romasense.ru",
    "rombertoni.ru",
    "rome.com",
    "romecapitol.org",
    "romemcguigan.com",
    "romeotourism.com",
    "romeoturizm.com",
    "romeovilleapartments.com",
    "romforyous.info",
    "romymichele.com",
    "ronabuildingcentre.com",
    "ronadecoration.com",
    "ronadvantage.com",
    "ronahomecenter.com",
    "ronahomegarden.com",
    "ronalansing.com",
    "ronaldperlman.com",
    "ronalerenovateur.com",
    "ronbennettmemorialfund.org",
    "ronell.me",
    "rongchuang-pz.com",
    "rongs2gw.com",
    "rongs2yl.com",
    "rongwei-organic.com",
    "roninmt2.xyz",
    "ronipidp.ga",
    "ronipidp.gq",
    "ronnierage.net",
    "ronstasmoove.com",
    "ronter.com",
    "ronvfiuj.shop",
    "roofcleanermd.com",
    "roofingcontractormassachusetts.com",
    "rooftest.net",
    "roofwashmd.com",
    "roomservicemassage.com",
    "roomy-hostel.ru",
    "roosh.com",
    "rooster-pil-pil-ballincollig.com",
    "rooststellarsmelt.site",
    "root-servers.site",
    "rootbrand.com",
    "rootdz.com",
    "rootfest.net",
    "rootprompt.org",
    "roots31.ru",
    "rootsfarmllc.net",
    "rootsfarmllc.org",
    "roozu.xyz",
    "ropgoraws.cf",
    "ropgoraws.ga",
    "ropgoraws.ml",
    "ropgoraws.tk",
    "rophievisioncare.com",
    "rorarbeten.se",
    "rosaceans.info",
    "rosadvocati.ru",
    "rosbelmash.ru",
    "rose-garden-finglas.com",
    "rosebear21.ru",
    "rosebearmylove.ru",
    "rosegarden-chinese.com",
    "rosejellyyoga.com",
    "roselism.com",
    "roseltorg-info.ru",
    "roselug.org",
    "rosendalerapids.net",
    "roseofwind.ru",
    "rosepokers.com",
    "roshaveno.com",
    "rosiemorton.buzz",
    "roskaltprec.cf",
    "roskaltprec.ga",
    "roskaltprec.ml",
    "roskaltprec.tk",
    "roslit.pro",
    "roslit.site",
    "rosmillo.com",
    "rosnefl.ru",
    "rospravosudie.info",
    "rosreestr-50.ru",
    "rosreestr-77.ru",
    "rossifans.com",
    "rossminer.online",
    "rossminzdrav.site",
    "rosso.ml",
    "rossocorso.online",
    "rossowoodfiredpizza.com",
    "roswelltransmissions.com",
    "rot3k.com",
    "rotadrs.info",
    "rotakurumsal.xyz",
    "rotaniliam.com",
    "rotaparts.com",
    "rotaract2420.net",
    "rotarybrush.biz",
    "rotarybrush.us",
    "rotarybrushes.org",
    "rotarybrushes.us",
    "rotate.pw",
    "rotfl.com",
    "roth-group.com",
    "rothesayrepair.com",
    "rothschildsbeware.vision",
    "rotingchi.ga",
    "rotingchi.gq",
    "rotiyu1-privdkrt.press",
    "rotiyu1-privdkrt.space",
    "rotiyu1-privdkrt.website",
    "rotmiss.com",
    "rotrpg.com",
    "rotterdamdevelopers.online",
    "rottingdean.property",
    "rotupush.com",
    "rou.us",
    "rou31.space",
    "roughch.press",
    "roughess.xyz",
    "roughidioe.space",
    "roughiv.email",
    "roughlive.recipes",
    "roughmout.email",
    "roughnet.com",
    "roughreunitesmirk.site",
    "roughvali.site",
    "roulette-megasystem.com",
    "roulettesuperpieno.com",
    "roumeans.com",
    "roundbrush.net",
    "roundbrushes.org",
    "roundcessqah.cf",
    "roundcessqah.ga",
    "roundcessqah.ml",
    "roundclap.fun",
    "roundclean.fun",
    "roundhouseaquarium.com",
    "roundpolik.ml",
    "roundsnac.email",
    "roundtabletechnology.info",
    "roundtheweb.com",
    "roundtowe.icu",
    "rounduni.xyz",
    "rousalmon.com",
    "rout66.ru",
    "routeegyptiansnack.site",
    "routegogo.com",
    "routesofsoul.net",
    "rouverpa.ga",
    "rouverpa.gq",
    "rouwbloemen.nu",
    "rouyuba.xyz",
    "rover.org",
    "rover100.cf",
    "rover100.ga",
    "rover100.gq",
    "rover100.ml",
    "rover100.tk",
    "rover400.cf",
    "rover400.ga",
    "rover400.gq",
    "rover400.ml",
    "rover400.tk",
    "rover75.cf",
    "rover75.ga",
    "rover75.gq",
    "rover75.ml",
    "rover75.tk",
    "roverbedf.cf",
    "roverbedf.ml",
    "roverbedf.tk",
    "row.kr",
    "rowantreepublishing.com",
    "rowe-solutions.com",
    "rowingbreak.com",
    "rowingbreak.org",
    "rowmin.com",
    "rowmoja6a6d9z4ou.cf",
    "rowmoja6a6d9z4ou.ga",
    "rowmoja6a6d9z4ou.gq",
    "rowmoja6a6d9z4ou.ml",
    "rowmoja6a6d9z4ou.tk",
    "rowtaefo.site",
    "roxtransit.com",
    "roxz.app",
    "roxz.bargains",
    "roxz.best",
    "roxz.blog",
    "roxz.business",
    "roxz.care",
    "roxz.cash",
    "roxz.chat",
    "roxz.cheap",
    "roxz.codes",
    "roxz.company",
    "roxz.deals",
    "roxz.digital",
    "roxz.discount",
    "roxz.guru",
    "roxz.link",
    "roxz.live",
    "roxz.money",
    "roxz.ninja",
    "roxz.party",
    "roxz.pro",
    "roxz.promo",
    "roxz.review",
    "roxz.reviews",
    "roxz.rocks",
    "roxz.sale",
    "roxz.tips",
    "royacupuncture.com",
    "royal-centre.com",
    "royal-host.su",
    "royal-mali.art",
    "royal-pay.ru",
    "royal-soft.net",
    "royal.net",
    "royalbetin49.com",
    "royalbetin50.com",
    "royalbetin51.com",
    "royalbetin52.com",
    "royalbetin53.com",
    "royalbetin55.com",
    "royalbetingiris1.xyz",
    "royalbetingiris3.xyz",
    "royalchocolatepalace.com",
    "royalcitytakeaway.com",
    "royaldoodles.org",
    "royale-dns.online",
    "royalepizzaandburgers.com",
    "royalflush128.live",
    "royalgardenchinesetakeaway.com",
    "royalgifts.info",
    "royalgreencondosg.com",
    "royalhost.info",
    "royalmail.top",
    "royalmarket.club",
    "royalmarket.life",
    "royalmarket.online",
    "royalpizzaonline.com",
    "royalpizzatakeaway.com",
    "royalpresents.ru",
    "royalpretendsnowy.site",
    "royalranch.org",
    "royalrosebrides.com",
    "royalsgame.com",
    "royalspicetakeaway.com",
    "royaltangkas.xyz",
    "royaltowerssanfrancisco202.com",
    "royalvip.win",
    "royalweb.email",
    "royandk.com",
    "royinnandsuits.com",
    "royprimaf.gq",
    "royprimaf.ml",
    "royprimaf.tk",
    "roys.ml",
    "royssbet1.xyz",
    "royssbet10.com",
    "royssbet8.com",
    "roza-rouz.ru",
    "roza-tmn.ru",
    "rozadrevo.ru",
    "rozanamarketing.com",
    "rozavk.ru",
    "rozebet.com",
    "rozkamao.in",
    "rozwojosobisty.site",
    "rp-attract.ru",
    "rpaowpro3l5ha.tk",
    "rpfundingoklahoma.com",
    "rpgitxp6tkhtasxho.cf",
    "rpgitxp6tkhtasxho.ga",
    "rpgitxp6tkhtasxho.gq",
    "rpgitxp6tkhtasxho.ml",
    "rpgitxp6tkhtasxho.tk",
    "rpgkeronbeta.ru",
    "rpgxxxgames.com",
    "rpharmacist.com",
    "rpl-id.com",
    "rplid.com",
    "rpm.social",
    "rpmgmt.network",
    "rpmleadgeneration.marketing",
    "rpmleadgeneration.net",
    "rppkn.com",
    "rpx12k.us",
    "rq1.in",
    "rq1h27n291puvzd.cf",
    "rq1h27n291puvzd.ga",
    "rq1h27n291puvzd.gq",
    "rq1h27n291puvzd.ml",
    "rq1h27n291puvzd.tk",
    "rq4oid.us",
    "rq6668f.com",
    "rqhpce.us",
    "rqjjf.live",
    "rqlrf.com",
    "rqmtg.com",
    "rqt8bw.info",
    "rqvph.site",
    "rr-0.cu.cc",
    "rr-1.cu.cc",
    "rr-2.cu.cc",
    "rr-3.cu.cc",
    "rr-ghost.cf",
    "rr-ghost.ga",
    "rr-ghost.gq",
    "rr-ghost.ml",
    "rr-ghost.tk",
    "rr-group.cf",
    "rr-group.ga",
    "rr-group.gq",
    "rr-group.ml",
    "rr-group.tk",
    "rr.ccs.pl",
    "rr.com",
    "rr18269.com",
    "rr57822.com",
    "rr7665.com",
    "rr9827.com",
    "rrasianp.com",
    "rrasinstar.cf",
    "rrasinstar.ga",
    "rrasinstar.tk",
    "rrbonmrrt.shop",
    "rrc6lf.info",
    "rrckefu.site",
    "rrilnanan.gq",
    "rrilnanan.tk",
    "rrjpwb.us",
    "rrkk99.com",
    "rrkvacanthomes.com",
    "rrocket.ru",
    "rrohio.com",
    "rrosesarered.com",
    "rrq.us",
    "rrqkd9t5fhvo5bgh.cf",
    "rrqkd9t5fhvo5bgh.ga",
    "rrqkd9t5fhvo5bgh.gq",
    "rrqkd9t5fhvo5bgh.ml",
    "rrqkd9t5fhvo5bgh.tk",
    "rrr062.com",
    "rrr813.com",
    "rrwbltw.xyz",
    "rrxnt.com",
    "rs-76.ru",
    "rs2gw.com",
    "rs2gwzc.com",
    "rs311e8.com",
    "rs9i4.us",
    "rsaw68.info",
    "rsbersbe.shop",
    "rsbetter20.xyz",
    "rsbysdmxi9.cf",
    "rsbysdmxi9.ga",
    "rsbysdmxi9.gq",
    "rsbysdmxi9.ml",
    "rsbysdmxi9.tk",
    "rsco.email",
    "rseryl-sy.com",
    "rsf.world",
    "rsfdgtv4664.cf",
    "rsfdgtv4664.ga",
    "rsfdgtv4664.gq",
    "rsfdgtv4664.ml",
    "rsfdgtv4664.tk",
    "rsgkefu.online",
    "rsgkefu.site",
    "rsjp.tk",
    "rsma.de",
    "rsmix.ru",
    "rsnapbet2020.xyz",
    "rsnfoopuc0fs.cf",
    "rsnfoopuc0fs.ga",
    "rsnfoopuc0fs.gq",
    "rsnfoopuc0fs.ml",
    "rsnfoopuc0fs.tk",
    "rsnwachg.tech",
    "rsqaat.site",
    "rsqytx.com",
    "rssbt.com",
    "rssfwu9zteqfpwrodq.ga",
    "rssfwu9zteqfpwrodq.gq",
    "rssfwu9zteqfpwrodq.ml",
    "rssfwu9zteqfpwrodq.tk",
    "rssmtp.com",
    "rsstao.com",
    "rstabbettingsnapp.xyz",
    "rstabbettsnupp2020.xyz",
    "rstabetting.xyz",
    "rstabilbett.xyz",
    "rstabilbettsnapp.xyz",
    "rstabilitybetsnapp.xyz",
    "rstabilitybettingsnapp.xyz",
    "rstarmail.com",
    "rsub.com",
    "rsvhr.com",
    "rsvpee.com",
    "rswilson.com",
    "rswoodwinds.info",
    "rsx.cash",
    "rt.nl",
    "rt58cq.us",
    "rtard.com",
    "rtb20.com",
    "rtcxstore.com",
    "rtechcrm.com",
    "rtechmedia.com",
    "rthomellc.com",
    "rtji9c.us",
    "rtn37n.xyz",
    "rtotlmail.net",
    "rtpcornpany.com",
    "rtr6nj.info",
    "rtrtr.com",
    "rts137.com",
    "rts6ypzvt8.ga",
    "rts6ypzvt8.gq",
    "rts6ypzvt8.ml",
    "rts6ypzvt8.tk",
    "rtsauth.shop",
    "rtskiya.xyz",
    "rtyreszxl.ru",
    "ru-api-id-dns-cgi-bin.ru",
    "ru-casinos.com",
    "ru-emailru.host",
    "ru-wargamming-net.icu",
    "ru.coffee",
    "ru.ru",
    "ru196595463.ru",
    "ruafdulw9otmsknf.cf",
    "ruafdulw9otmsknf.ga",
    "ruafdulw9otmsknf.ml",
    "ruafdulw9otmsknf.tk",
    "ruallnews.ru",
    "ruangbagus.com",
    "ruangjawa.com",
    "ruay028.com",
    "ruay046.com",
    "ruay047.com",
    "ruay048.com",
    "ruay053.com",
    "ruay061.com",
    "ruay070.com",
    "ruay076.com",
    "ruay084.com",
    "ruay089.com",
    "ruay090.com",
    "ruay108.com",
    "ruay116.com",
    "ruay117.com",
    "ruay127.com",
    "ruay134.com",
    "ruay149.com",
    "ruay151.com",
    "ruay152.com",
    "ruay156.com",
    "ruay166.com",
    "ruay184.com",
    "ruay185.com",
    "ruay187.com",
    "ruay189.com",
    "ruay196.com",
    "ruay200.com",
    "ruay206.com",
    "ruay219.com",
    "ruay220.com",
    "ruay235.com",
    "ruay244.com",
    "ruay247.com",
    "ruay272.com",
    "ruay278.com",
    "ruay283.com",
    "ruay292.com",
    "ruay301.com",
    "ruay305.com",
    "ruay307.com",
    "ruay314.com",
    "ruay326.com",
    "ruay332.com",
    "ruay337.com",
    "ruay342.com",
    "ruay353.com",
    "ruay358.com",
    "ruay362.com",
    "ruay369.com",
    "ruay372.com",
    "ruay376.com",
    "ruay386.com",
    "ruay399.com",
    "ruay406.com",
    "ruay407.com",
    "ruay412.com",
    "ruay415.com",
    "ruay418.com",
    "ruay419.com",
    "ruay420.com",
    "ruay430.com",
    "ruay436.com",
    "ruay437.com",
    "ruay457.com",
    "ruay465.com",
    "ruay472.com",
    "ruay479.com",
    "ruay480.com",
    "ruay482.com",
    "ruay490.com",
    "ruay493.com",
    "ruay497.com",
    "ruay500.com",
    "ruay503.com",
    "ruay504.com",
    "ruay505.com",
    "ruay506.com",
    "ruay511.com",
    "ruay513.com",
    "ruay520.com",
    "ruay521.com",
    "ruay531.com",
    "ruay533.com",
    "ruay538.com",
    "ruay547.com",
    "ruay548.com",
    "ruay550.com",
    "ruay551.com",
    "ruay552.com",
    "ruay554.com",
    "ruay566.com",
    "ruay567.com",
    "ruay569.com",
    "ruay576.com",
    "ruay584.com",
    "ruay594.com",
    "ruay595.com",
    "ruay599.com",
    "ruay608.com",
    "ruay610.com",
    "ruay613.com",
    "ruay622.com",
    "ruay623.com",
    "ruay624.com",
    "ruay630.com",
    "ruay633.com",
    "ruay639.com",
    "ruay651.com",
    "ruay652.com",
    "ruay654.com",
    "ruay656.com",
    "ruay658.com",
    "ruay659.com",
    "ruay660.com",
    "ruay662.com",
    "ruay663.com",
    "ruay669.com",
    "ruay671.com",
    "ruay676.com",
    "ruay678.com",
    "ruay679.com",
    "ruay684.com",
    "ruay688.com",
    "ruay697.com",
    "ruay702.com",
    "ruay709.com",
    "ruay710.com",
    "ruay713.com",
    "ruay714.com",
    "ruay719.com",
    "ruay724.com",
    "ruay725.com",
    "ruay729.com",
    "ruay733.com",
    "ruay736.com",
    "ruay739.com",
    "ruay741.com",
    "ruay746.com",
    "ruay747.com",
    "ruay748.com",
    "ruay758.com",
    "ruay766.com",
    "ruay775.com",
    "ruay776.com",
    "ruay780.com",
    "ruay783.com",
    "ruay787.com",
    "ruay790.com",
    "ruay791.com",
    "ruay792.com",
    "ruay793.com",
    "ruay796.com",
    "ruay800.com",
    "ruay805.com",
    "ruay811.com",
    "ruay812.com",
    "ruay818.com",
    "ruay824.com",
    "ruay828.com",
    "ruay830.com",
    "ruay831.com",
    "ruay832.com",
    "ruay834.com",
    "ruay840.com",
    "ruay843.com",
    "ruay845.com",
    "ruay848.com",
    "ruay851.com",
    "ruay860.com",
    "ruay870.com",
    "ruay871.com",
    "ruay874.com",
    "ruay875.com",
    "ruay876.com",
    "ruay879.com",
    "ruay883.com",
    "ruay884.com",
    "ruay885.com",
    "ruay895.com",
    "ruay896.com",
    "ruay901.com",
    "ruay902.com",
    "ruay908.com",
    "ruay912.com",
    "ruay913.com",
    "ruay919.com",
    "ruay924.com",
    "ruay928.com",
    "ruay929.com",
    "ruay930.com",
    "ruay938.com",
    "ruay945.com",
    "ruay948.com",
    "ruay949.com",
    "ruay953.com",
    "ruay956.com",
    "ruay965.com",
    "ruay969.com",
    "ruay976.com",
    "ruay977.com",
    "ruay980.com",
    "ruay984.com",
    "ruay986.com",
    "ruay988.com",
    "ruay994.com",
    "rubbank.ru",
    "rubberbunnys.icu",
    "rubbishmaestro.info",
    "rubinetta.com",
    "rubioproperties.com",
    "rubitcoini.ru",
    "rubro-59.com",
    "ruby-keys.ru",
    "ruby.business",
    "rubyandbettysattic.com",
    "rubyblogger.com",
    "rubyridge.com",
    "rubysec.org",
    "rubystore.store",
    "rucenrmf.shop",
    "ruclawwzy3.xyz",
    "rudicle.xyz",
    "rudimentapp.com",
    "rudistettner.com",
    "ruditnugnab.xyz",
    "rudymail.ml",
    "rueportcent.cf",
    "rueportcent.ga",
    "rueportcent.gq",
    "ruetin.online",
    "ruffrey.com",
    "rufiysmbz.shop",
    "rufoej.us",
    "rugbyfixtures.com",
    "rugbymov.icu",
    "rugbytru.icu",
    "rugedgrade.com",
    "ruggedinbox.com",
    "ruhdwb.us",
    "ruhklasn.website",
    "ruhq1o.us",
    "ruhshe5uet547.tk",
    "rui-yun.com",
    "rujhuk.us",
    "ruki-master.ru",
    "rule.moscow",
    "ruletka-online.ru",
    "ruletkacsgo.com",
    "rullezslots.ru",
    "ruloli.com",
    "rumgel.com",
    "rumorattic.us",
    "rumorbrai.xyz",
    "rumored562ws.online",
    "rumorsto.xyz",
    "rumplenewskins.com",
    "rumtos.info",
    "rumuspoker.stream",
    "rumweni.cf",
    "rumweni.tk",
    "run600.net",
    "runball.us",
    "runballrally.us",
    "runbhumi.club",
    "runbhumi.live",
    "runbox.com",
    "rundablage.com",
    "runeclient.com",
    "runeclient.net",
    "runelite.best",
    "runemax.net",
    "runemax.org",
    "runews11.ru",
    "runfoxyrun.com",
    "runi.ca",
    "runjoehalerun.com",
    "runled-official.ru",
    "runmail.club",
    "runmail.info",
    "runnersreference.com",
    "running-mushi.com",
    "running-shoes-for-men.com",
    "runningdivas.com",
    "runningreel.com",
    "runninnqey.space",
    "runsarahrun.com",
    "runyainvestments.com",
    "runyaproperties.com",
    "runz.education",
    "ruoleng.com",
    "ruonion.su",
    "ruorgs.ru",
    "rupayamail.com",
    "rupe4ora.ru",
    "rupeeathome.com",
    "ruprom.info",
    "ruptteco.cf",
    "ruptteco.gq",
    "ruptteco.ml",
    "ruptteco.tk",
    "rupya.info",
    "rupya.xyz",
    "ruqi.site",
    "ruracgent.cf",
    "ruracgent.ga",
    "ruracgent.tk",
    "ruralrentals.net",
    "ruralscreensorry.site",
    "rurealjoe1.ru",
    "ruru.be",
    "rus-oonies.ru",
    "rusdoc.xyz",
    "rusecoflot.ru",
    "rusellhobss.online",
    "rusellhobss.site",
    "rusgilcorporate.com",
    "rush.ovh",
    "rushingfeet.com",
    "rushmails.com",
    "rushmorekm.com",
    "rushmotelm.com",
    "rushotel24.ru",
    "rushpost.com",
    "rusita.ru",
    "ruskasino.info",
    "ruskovka.ru",
    "ruslantm.ru",
    "ruslep.com",
    "rusmednews.ru",
    "rusnewsfeed.ru",
    "rusop.space",
    "ruspalfinger.ru",
    "ruspool.org",
    "russ-samsung.ru",
    "russellandnatasha.com",
    "russelljohn.info",
    "russia-champion.ru",
    "russian-elka.ru",
    "russianizba.ru",
    "russianvolumesottawa.com",
    "russianwebgirls.ru",
    "russiarp04.online",
    "russkovach.com",
    "russtavki.ru",
    "rust-inside.ru",
    "rust-kr.com",
    "rustetoone.icu",
    "rusticcel.com",
    "rusticdecorstuff.com",
    "rustinside.ru",
    "rustrilca.ml",
    "rustrilca.tk",
    "rusturistik.ru",
    "rusturne.ru",
    "rustydoor.com",
    "rusvet.org",
    "rusvideos.su",
    "rusvidos.online",
    "rusvisit.ru",
    "rutafagre.ru",
    "rutale.ru",
    "ruthann.best",
    "ruthservicios.net",
    "rutracker.moscow",
    "ruttolibero.com",
    "rutv.site",
    "ruu.kr",
    "ruvidrinks.com",
    "ruvinow.com",
    "ruvinutrition.com",
    "ruwe.site",
    "ruyadasarilmak.com",
    "ruzavod.ru",
    "ruzsbpyo1ifdw4hx.cf",
    "ruzsbpyo1ifdw4hx.ga",
    "ruzsbpyo1ifdw4hx.gq",
    "ruzsbpyo1ifdw4hx.ml",
    "ruzsbpyo1ifdw4hx.tk",
    "rv-br.com",
    "rv.storage",
    "rvb.ro",
    "rvbspending.com",
    "rvctf.com",
    "rvdogs.com",
    "rviixj.us",
    "rvjtudarhs.cf",
    "rvjtudarhs.ga",
    "rvjtudarhs.gq",
    "rvjtudarhs.ml",
    "rvjtudarhs.tk",
    "rvlatinamerica.com",
    "rvrentalsatlanta.org",
    "rvrentalsinatlanta.com",
    "rvshop.com",
    "rvslideout.com",
    "rvspedals.com",
    "rvstep.com",
    "rvtiaqwf.shop",
    "rvwt4s.us",
    "rvx9p.us",
    "rvxwdz.site",
    "rw0vps.com",
    "rw24.de",
    "rward.se",
    "rwhhbpwfcrp6.cf",
    "rwhhbpwfcrp6.ga",
    "rwhhbpwfcrp6.gq",
    "rwhhbpwfcrp6.ml",
    "rwhhbpwfcrp6.tk",
    "rwinner2020emailup.xyz",
    "rwww1.buzz",
    "rx-seer.com",
    "rx.dred.ru",
    "rx.qc.to",
    "rxbagimprints.com",
    "rxcbilling.com",
    "rxdoc.biz",
    "rxdtlfzrlbrle.cf",
    "rxdtlfzrlbrle.ga",
    "rxdtlfzrlbrle.gq",
    "rxdtlfzrlbrle.ml",
    "rxlakbrw.site",
    "rxmail.us",
    "rxmaof5wma.cf",
    "rxmaof5wma.ga",
    "rxmaof5wma.gq",
    "rxmaof5wma.ml",
    "rxmaof5wma.tk",
    "rxnts2daplyd0d.cf",
    "rxnts2daplyd0d.ga",
    "rxnts2daplyd0d.gq",
    "rxnts2daplyd0d.tk",
    "rxr6gydmanpltey.cf",
    "rxr6gydmanpltey.ml",
    "rxr6gydmanpltey.tk",
    "rxtmk.us",
    "rxtx.us",
    "ryan1home.buzz",
    "ryanb.com",
    "ryanlackey.org",
    "ryanlester.name",
    "ryanreedy.com",
    "ryanswebsite.xyz",
    "ryanswebsite1.xyz",
    "ryanswebsite2.xyz",
    "ryanswebsite5.xyz",
    "ryazanpressa.ru",
    "rybalkovedenie.ru",
    "rychal-de-carne.com",
    "rychzd.best",
    "rycz2fd2iictop.cf",
    "rycz2fd2iictop.ga",
    "rycz2fd2iictop.gq",
    "rycz2fd2iictop.ml",
    "rycz2fd2iictop.tk",
    "rydh.xyz",
    "rydjfs.site",
    "rye6mi.us",
    "ryen15ypoxe.ga",
    "ryen15ypoxe.ml",
    "ryen15ypoxe.tk",
    "ryldnwp4rgrcqzt.cf",
    "ryldnwp4rgrcqzt.ga",
    "ryldnwp4rgrcqzt.gq",
    "ryldnwp4rgrcqzt.ml",
    "ryldnwp4rgrcqzt.tk",
    "rym84t-mail.xyz",
    "ryno-4wd.com",
    "rynooffroad.com",
    "ryo.shp7.cn",
    "ryoblog.com",
    "ryqi.com",
    "ryqila.info",
    "ryrixu.info",
    "rytwjg.site",
    "ryukyuxxrf.space",
    "ryukyuzxis.space",
    "ryumail.net",
    "ryumail.ooo",
    "ryvima.cf",
    "ryvima.ml",
    "ryxns.xyz",
    "ryxuzt.us",
    "ryzdgwkhkmsdikmkc.cf",
    "ryzdgwkhkmsdikmkc.ga",
    "ryzdgwkhkmsdikmkc.gq",
    "ryzdgwkhkmsdikmkc.tk",
    "rz5ha8.site",
    "rzbt8u-mail.xyz",
    "rzcbqdmj.shop",
    "rzdxpnzipvpgdjwo.cf",
    "rzdxpnzipvpgdjwo.ga",
    "rzdxpnzipvpgdjwo.gq",
    "rzdxpnzipvpgdjwo.ml",
    "rzdxpnzipvpgdjwo.tk",
    "rzesbt.us",
    "rzh4xc.site",
    "rzhaoyun.com",
    "rzjzi.live",
    "rzm-mebel.ru",
    "rzn.host",
    "rznf6v.us",
    "rznsco.shop",
    "rzuduuuaxbqt.cf",
    "rzuduuuaxbqt.ga",
    "rzuduuuaxbqt.gq",
    "rzuduuuaxbqt.ml",
    "rzuduuuaxbqt.tk",
    "rzvwgr.host",
    "rzwiocso.shop",
    "rzxmoog.com",
    "rzzr9.site",
    "s-health.site",
    "s-lashes.info",
    "s-mail.com",
    "s-mail.ga",
    "s-mail.gq",
    "s-motor.ru",
    "s-mythink.tk",
    "s-rnow.net",
    "s-s.flu.cc",
    "s-sakamas.ru",
    "s-shoponline.info",
    "s-silaman.ru",
    "s.bloq.ro",
    "s.bungabunga.cf",
    "s.dextm.ro",
    "s.ea.vu",
    "s.proprietativalcea.ro",
    "s.s2cloud.pro",
    "s.sa.igg.biz",
    "s.vdig.com",
    "s.wkeller.net",
    "s0.at",
    "s00.orangotango.ga",
    "s0129.com",
    "s0146.com",
    "s0147.com",
    "s0181.com",
    "s0185.com",
    "s0190.com",
    "s0204.com",
    "s0214.com",
    "s0216.com",
    "s0217.com",
    "s0224.com",
    "s0264.com",
    "s0313.com",
    "s0315.com",
    "s0337.com",
    "s0341.com",
    "s0346.com",
    "s0352.com",
    "s0384.com",
    "s0389.com",
    "s0407.com",
    "s0439.com",
    "s0450.com",
    "s0458.com",
    "s0467.com",
    "s0470.com",
    "s0509.com",
    "s0574.com",
    "s0585.com",
    "s0641.com",
    "s0652.com",
    "s0737.com",
    "s0835.com",
    "s0837.com",
    "s0846.com",
    "s0872.com",
    "s0924.com",
    "s0926.com",
    "s0971.com",
    "s0982.com",
    "s0ny.cf",
    "s0ny.ga",
    "s0ny.gq",
    "s0ny.ml",
    "s0ny.net",
    "s0ojarg3uousn.cf",
    "s0ojarg3uousn.ga",
    "s0ojarg3uousn.gq",
    "s0ojarg3uousn.ml",
    "s0ojarg3uousn.tk",
    "s10ss10r.shop",
    "s15qo.site",
    "s1775.com",
    "s188game.com",
    "s188live.com",
    "s1nj8nx8xf5s1z.cf",
    "s1nj8nx8xf5s1z.ga",
    "s1nj8nx8xf5s1z.gq",
    "s1nj8nx8xf5s1z.ml",
    "s1nj8nx8xf5s1z.tk",
    "s1xssanlgkgc.cf",
    "s1xssanlgkgc.ga",
    "s1xssanlgkgc.gq",
    "s1xssanlgkgc.ml",
    "s1xssanlgkgc.tk",
    "s29-megamoney.site",
    "s29-megamoney.website",
    "s2d4o1b3t2.fun",
    "s2drawoff.com",
    "s2dsan.info",
    "s2f14n.best",
    "s2znxa.com",
    "s333pro.com",
    "s33db0x.com",
    "s35-cashworld.website",
    "s37ukqtwy2sfxwpwj.cf",
    "s37ukqtwy2sfxwpwj.ga",
    "s37ukqtwy2sfxwpwj.gq",
    "s37ukqtwy2sfxwpwj.ml",
    "s385u.site",
    "s3mle.us",
    "s3rttar9hrvh9e.cf",
    "s3rttar9hrvh9e.ga",
    "s3rttar9hrvh9e.gq",
    "s3rttar9hrvh9e.ml",
    "s3rttar9hrvh9e.tk",
    "s3s4.tk",
    "s3wrtgnn17k.cf",
    "s3wrtgnn17k.ga",
    "s3wrtgnn17k.gq",
    "s3wrtgnn17k.ml",
    "s3wrtgnn17k.tk",
    "s42n6w7pryve3bpnbn.cf",
    "s42n6w7pryve3bpnbn.ga",
    "s42n6w7pryve3bpnbn.gq",
    "s42n6w7pryve3bpnbn.ml",
    "s42n6w7pryve3bpnbn.tk",
    "s43n0sklopxmtar.xyz",
    "s48aaxtoa3afw5edw0.cf",
    "s48aaxtoa3afw5edw0.ga",
    "s48aaxtoa3afw5edw0.gq",
    "s48aaxtoa3afw5edw0.ml",
    "s48aaxtoa3afw5edw0.tk",
    "s4a5gb.us",
    "s4f.co",
    "s4m1ye.us",
    "s51zdw001.com",
    "s5jw.us",
    "s5p.site",
    "s6.weprof.it",
    "s68betyes.com",
    "s6a5ssdgjhg99.cf",
    "s6a5ssdgjhg99.ga",
    "s6a5ssdgjhg99.gq",
    "s6a5ssdgjhg99.ml",
    "s6a5ssdgjhg99.tk",
    "s6d9o1bt2.fun",
    "s6qjunpz9es.ga",
    "s6qjunpz9es.ml",
    "s6qjunpz9es.tk",
    "s709l5d6.fun",
    "s7665.com",
    "s77win.com",
    "s77win.net",
    "s78poker.biz",
    "s78qp.com",
    "s80aaanan86hidoik.cf",
    "s80aaanan86hidoik.ga",
    "s80aaanan86hidoik.gq",
    "s80aaanan86hidoik.ml",
    "s8304.com",
    "s8323.com",
    "s8325.com",
    "s8486.com",
    "s8610.com",
    "s8617.com",
    "s8625.com",
    "s88u.net",
    "s88v.net",
    "s88y.net",
    "s8sigmao.com",
    "s9094.com",
    "s96lkyx8lpnsbuikz4i.cf",
    "s96lkyx8lpnsbuikz4i.ga",
    "s96lkyx8lpnsbuikz4i.ml",
    "s96lkyx8lpnsbuikz4i.tk",
    "s97998.com",
    "s9827.com",
    "sa-001.com",
    "sa-cf.com",
    "sa-ci.com",
    "sa.igg.biz",
    "sa6hpayn.online",
    "saaabbt2019.club",
    "saaabt2019.club",
    "saab9-3.cf",
    "saab9-3.ga",
    "saab9-3.gq",
    "saab9-3.ml",
    "saab9-3.tk",
    "saab9-4x.cf",
    "saab9-4x.ga",
    "saab9-4x.gq",
    "saab9-4x.ml",
    "saab9-4x.tk",
    "saab9-5.cf",
    "saab9-5.ga",
    "saab9-5.gq",
    "saab9-5.ml",
    "saab9-5.tk",
    "saab9-7x.cf",
    "saab9-7x.ga",
    "saab9-7x.gq",
    "saab9-7x.ml",
    "saab9-7x.tk",
    "saab900.cf",
    "saab900.ga",
    "saab900.gq",
    "saab900.ml",
    "saab900.tk",
    "saabaru.cf",
    "saabaru.ga",
    "saabaru.gq",
    "saabaru.ml",
    "saabaru.tk",
    "saabcars.cf",
    "saabcars.ga",
    "saabcars.gq",
    "saabcars.ml",
    "saabcars.tk",
    "saabgroup.cf",
    "saabgroup.ga",
    "saabgroup.gq",
    "saabgroup.ml",
    "saabgroup.tk",
    "saabsalon.com",
    "saabscania.cf",
    "saabscania.ga",
    "saabscania.gq",
    "saabscania.ml",
    "saabscania.tk",
    "saadatkhodro.com",
    "saagartakeaway.com",
    "saaheel.biz",
    "saaheel.online",
    "saas-sd.com",
    "saas.ong",
    "saasbackups.com",
    "saascity.asia",
    "saatchirt.com",
    "saatmod.net",
    "sabahekonomi.xyz",
    "sabahvolunteer.org",
    "sabaka.host",
    "sabet11.com",
    "sabinati.com",
    "sabitspor.xyz",
    "saboraliagirona.com",
    "saborsabormadrid.com",
    "saborsaudavel.top",
    "sabotaj.info",
    "sabreshockey.com",
    "sabrestlouis.com",
    "sabrgist.com",
    "sabrinawurmbrand.net",
    "sabrituncer.site",
    "sabtekarimkhan.com",
    "sabuyjai.info",
    "sabzshopp.com",
    "sac-zbcg.com",
    "sacar-news.tk",
    "sacbakim.info",
    "sacbeemail.com",
    "sacekiminasilolur.xyz",
    "sach.ir",
    "sackboii.com",
    "sackdicam.cf",
    "sackdicam.ga",
    "sackdicam.ml",
    "sackdicam.tk",
    "sacporschedealer.com",
    "sacramentohairsalons.com",
    "sacredaction.app",
    "sacredcitizen.com",
    "sacredcitizensummit.com",
    "sacredencountersthroughnaturaldreamwork.com",
    "sacredoriginsnutrition.com",
    "sactownsoftball.com",
    "sacvalleypet.com",
    "sad495.ru",
    "sadakaonline.ru",
    "sadasdasc-naonc.icu",
    "sadasdsada.xyz",
    "sadd.us",
    "saddafi.icu",
    "saddamcom.com",
    "saddspyper.ga",
    "saddstore.com",
    "sadecekoyden.com",
    "sadehyd.cf",
    "sadehyd.gq",
    "sadesoru.net",
    "sadfopp.gq",
    "sadness.website",
    "sado-das.ru",
    "sadsagsaa.space",
    "saedicon.cf",
    "saedicon.ga",
    "saedicon.ml",
    "saedicon.tk",
    "saegu.space",
    "saentologik.ru",
    "saeuferleber.de",
    "safa8.xyz",
    "safaat.cf",
    "safarimail.com",
    "safarjo.com",
    "safber.com",
    "safe-mail.ga",
    "safe-mail.gq",
    "safe-mail.net",
    "safe-pay.icu",
    "safe-planet.com",
    "safe.equipment",
    "safe.pics",
    "safe.singles",
    "safeautobuy.com",
    "safebolt.xyz",
    "safebox.ru",
    "safecash.online",
    "safecash.site",
    "safecash.store",
    "safecash.tech",
    "safecointalk.com",
    "safecointalk.org",
    "safecollegealerts.org",
    "safecreditunion.coop",
    "safecreditunion.info",
    "safecreditunion.name",
    "safecreditunion.org",
    "safecreditunion.us",
    "safecu.care",
    "safecu.cash",
    "safecu.com",
    "safecu.community",
    "safecu.coop",
    "safecu.creditunion",
    "safecu.finance",
    "safecu.financial",
    "safecu.foundation",
    "safecu.gives",
    "safecu.help",
    "safecu.investments",
    "safecu.loan",
    "safecu.loans",
    "safecu.mobi",
    "safecu.name",
    "safecu.news",
    "safecu.tax",
    "safecu.us",
    "safecuhb.biz",
    "safecuhb.com",
    "safecuhb.info",
    "safecuhb.name",
    "safedrgh.net",
    "safedye.com",
    "safeemail.xyz",
    "safefcu.com",
    "safefcu.coop",
    "safefcu.net",
    "safefcu.us",
    "safegirldate.com",
    "safeity.tech",
    "safelistmarketing.com",
    "safemail.cf",
    "safemail.icu",
    "safemail.tk",
    "safemov.site",
    "safenord.com",
    "safepla.online",
    "safer.gq",
    "safermail.info",
    "saferoomstogo.com",
    "safersignup.com",
    "safersignup.de",
    "safeschoolalert.com",
    "safeschoolsalerts.com",
    "safesextour.com",
    "safeshare.app",
    "safeshare.email",
    "safetempmail.com",
    "safetm.mobi",
    "safetydiary.com",
    "safetymail.info",
    "safetypost.de",
    "safetyrzxt.space",
    "safetyrzxt.website",
    "safewarp.org",
    "safewithsurfeasy.com",
    "saffront.info",
    "safinancecenter.org",
    "safirbahis.com",
    "safrica.com",
    "saga-asian-street-food.com",
    "saga4d.net",
    "sagame.academy",
    "sagame.accountant",
    "sagame.accountants",
    "sagame.adult",
    "sagame.amsterdam",
    "sagame.archi",
    "sagame.associates",
    "sagame.bar",
    "sagame.berlin",
    "sagame.bid",
    "sagame.bike",
    "sagame.black",
    "sagame.blackfriday",
    "sagame.build",
    "sagame.buzz",
    "sagame.camp",
    "sagame.capetown",
    "sagame.cash",
    "sagame.christmas",
    "sagame.city",
    "sagame.cleaning",
    "sagame.cloud",
    "sagame.desi",
    "sagame.design",
    "sagame.diet",
    "sagame.durban",
    "sagame.fans",
    "sagame.flowers",
    "sagame.gold",
    "sagame.green",
    "sagame.guru",
    "sagame.hiphop",
    "sagame.ink",
    "sagame.investments",
    "sagame.irish",
    "sagame.joburg",
    "sagame.lol",
    "sagame.ltd",
    "sagame.markets",
    "sagame.men",
    "sagame.menu",
    "sagame.mobi",
    "sagame.mom",
    "sagame.nagoya",
    "sagame.name",
    "sagame.nyc",
    "sagame.ooo",
    "sagame.photo",
    "sagame.photography",
    "sagame.physio",
    "sagame.pics",
    "sagame.promo",
    "sagame.property",
    "sagame.racing",
    "sagame.rest",
    "sagame.science",
    "sagame.shop",
    "sagame.shopping",
    "sagame.solar",
    "sagame.solutions",
    "sagame.stream",
    "sagame.study",
    "sagame.tattoo",
    "sagame.tips",
    "sagame.tools",
    "sagame.toys",
    "sagame.trade",
    "sagame.tube",
    "sagame.us",
    "sagame.vegas",
    "sagame.webcam",
    "sagame.win",
    "sagame.zone",
    "sagame25.asia",
    "sagame357.asia",
    "sagame358.com",
    "sagerfireprotection.com",
    "sagetsand.cf",
    "sagetsand.gq",
    "sagetsand.ml",
    "sagetsand.tk",
    "sagheh.com",
    "sagiri.aa.am",
    "sagittarians.co.uk",
    "saglikclub.net",
    "sagliklisac.online",
    "sagliklisac.xyz",
    "sagliktanyana.site",
    "sagosupermart.site",
    "sagra.lu",
    "sagra.lu.lu",
    "sagra.lumarketing.lu",
    "sags-per-mail.de",
    "sagun.info",
    "sahaiicharity.com",
    "sahampemenang.net",
    "saharaforest.org",
    "saharanightstempe.com",
    "sahdisus.online",
    "sahealthter.cf",
    "sahealthter.gq",
    "sahealthter.ml",
    "sahealthter.tk",
    "sahidlakhanmarathon.com",
    "sahinbeybldspor.xyz",
    "sahipalace.com",
    "sahishop.online",
    "sahitya.com",
    "sahivi.ru",
    "sahnebet9.com",
    "sahrulselow.cf",
    "sahrulselow.ga",
    "sahrulselow.gq",
    "sahrulselow.ml",
    "saibaagora.website",
    "saidbetanzos.info",
    "saidwise.com",
    "saifix.xyz",
    "saigoncity-dublin.com",
    "saigonmail.us",
    "saigonoi.org",
    "saikishoremv.com",
    "sail.today",
    "sailaway-yacht.com",
    "sailormoon.com",
    "sailorplastic.com",
    "sain2o.site",
    "saint-martin.ru",
    "saint-mike.org",
    "saintcharles.online",
    "saintignatiusloyola.nyc",
    "saintly.com",
    "saintmail.net",
    "sait-kirov.ru",
    "saitama.email.ne.jp",
    "saitrajsu.cf",
    "saitrajsu.gq",
    "saitrajsu.ml",
    "saitrajsu.tk",
    "saivon.com",
    "sajowi.site",
    "sakam.info",
    "sakanasoft.biz",
    "sakanasoft.com",
    "sakaryaanket.xyz",
    "sakaryabayan.xyz",
    "sakaryaozguvenemlak.com",
    "sakaryapimapen.com",
    "s\xe4kerhetsv\xe4st.se",
    "sakila.cf",
    "sakila.ga",
    "sakila.gq",
    "sakila.ml",
    "sakila.tk",
    "saktiemel.com",
    "sakura.ne.jp",
    "sakuramechanicsburg.com",
    "sakurina.online",
    "salabiltvaett.se",
    "saladsni.xyz",
    "saladsnif.xyz",
    "salahkahaku.cf",
    "salahkahaku.ga",
    "salahkahaku.gq",
    "salahkahaku.ml",
    "salamanderbaseball.com",
    "salamfilm.xyz",
    "salaopm.ml",
    "salariominimo21.info",
    "salary-able.xyz",
    "salata.city",
    "salavip.media",
    "salbol.com",
    "salcantaywalks.com",
    "sald.de",
    "sale-market-classic.ru",
    "sale-market24.host",
    "sale-perfect-smile.site",
    "sale-russia.store",
    "sale-sale-sale.com",
    "sale-store365.online",
    "sale-trade-active.info",
    "sale-veneers.site",
    "sale-wow.ru",
    "sale.craigslist.org",
    "sale24shop.website",
    "sale500.ru",
    "salebots.ru",
    "salecse.cf",
    "salecse.ga",
    "salecse.gq",
    "salecse.ml",
    "salecse.tk",
    "salehi.net",
    "saleiphone.ru",
    "salem.media",
    "salemnewschannel.com",
    "salemovobit.com",
    "salemovohet.com",
    "salemsuperstars.com",
    "salemtwincities.com",
    "salemwebdesign.online",
    "sales-perfect-smile.site",
    "sales.lol",
    "salesac.xyz",
    "salesaf.xyz",
    "salesbb.xyz",
    "salesbc.xyz",
    "salesfind.org",
    "saleshare.app",
    "salesjs.ru",
    "salesmanagementconference.org",
    "salesoperations.net",
    "salesoperationsconference.org",
    "salesperson.net",
    "salesresult.online",
    "saless.store",
    "salesstack2017.com",
    "salestodaygreat.xyz",
    "salinadentists.com",
    "salingshop.info",
    "salisburyrealestateagents.com",
    "salla.dev",
    "sallatna.net",
    "salles-vestrepain-toulouse.com",
    "salles-vestrepain-toulouse.org",
    "sallesbank.com",
    "salmanbyxn.ru",
    "salmeow.tk",
    "salmo-us.com",
    "salmo-usa.com",
    "salomaslozapadlo.info",
    "salon-kalipso.ru",
    "salonantigenspank.site",
    "salonelizabeth.net",
    "salonkommunist.company",
    "salonkommunist.cool",
    "salonkommunist.expert",
    "salonkommunist.guru",
    "salonkommunist.money",
    "salonkommunist.photos",
    "salonkommunist.solutions",
    "salonkommunist.space",
    "salonkommunist.systems",
    "salonkommunist.tools",
    "salonkommunist.watch",
    "salonkommunist.website",
    "salonme.ru",
    "salonre.xyz",
    "salonrebe.xyz",
    "salonvalu.icu",
    "salonyfryzjerskie.info",
    "saloonbahis7.com",
    "saloudi.com",
    "salsasmexican.com",
    "salsoowi.site",
    "saltanera.net",
    "saltcityfiberworks.com",
    "saltjp.com",
    "saltlakecitybusinessadvisors.com",
    "saltlakecitynailsalons.com",
    "saltreactor.org",
    "saltysushi.com",
    "salud-es.site",
    "salud.unm.edu",
    "saludbuy.com",
    "saludyconsuegra.com",
    "salvatore1818.site",
    "salventrex.com",
    "sam-dizainer.ru",
    "sam-serial2.xyz",
    "sam-serial5.xyz",
    "sam-serial7.space",
    "sam-serial7.xyz",
    "sam-serial8.xyz",
    "sam-serial9.xyz",
    "samalert.org",
    "samamul.ga",
    "samamul.gq",
    "samamul.ml",
    "samamul.tk",
    "samar.money",
    "samarachisto.ru",
    "samaralimuzin.ru",
    "samarasantoss.site",
    "samasdecor.com",
    "samatante.ml",
    "samateochiropracticclinic.com",
    "sambabebe.com",
    "sambalenak.com",
    "samblad.ga",
    "samblad.ml",
    "sambuzh.com",
    "sameaccountmanage765.com",
    "samenli.cf",
    "samenli.ga",
    "samenli.ml",
    "samenli.tk",
    "samenwerkingskunde.nu",
    "sameoneto.ru",
    "samerica.com",
    "samerooteigelonline.co",
    "samharnack.dev",
    "samilan.net",
    "samireunanen.com",
    "samiznaetekogo.net",
    "samjhoquran.com",
    "sammail.ws",
    "sammasati.info",
    "sammimail.com",
    "sammnabisoli.xyz",
    "samogonda.ru",
    "samokat-mir.ru",
    "samokat-msk.ru",
    "samosters.site",
    "samp-shop.ru",
    "samp-soft.ru",
    "samp-win.ru",
    "sampleapp.com",
    "samplefy.com",
    "samplehomedesign.com",
    "samplelab.com",
    "sampotechnologies.com",
    "sampsonteam.com",
    "samrise.name",
    "sams-dels.ru",
    "sams-gearfit2.site",
    "samsclass.info",
    "samsoniteshops.club",
    "samstore.store",
    "samsunaraccekici.com",
    "samsung-galaxy9.ru",
    "samsung-x5.online",
    "samsunggalaxys9.cf",
    "samsunggalaxys9.ga",
    "samsunggalaxys9.gq",
    "samsunggalaxys9.ml",
    "samsunggalaxys9.tk",
    "samsungtftlcd.xyz",
    "samsuniyiolacak.com",
    "samuelcarlsson.se",
    "samuelstcyr.com",
    "san-maria-takeaway.com",
    "san.rr.com",
    "sana-all.com",
    "sanaewesthkff.xyz",
    "sanalada.com",
    "sanalalem.com",
    "sanalankara.xyz",
    "sanalyzer.com",
    "sanangelopestcontrol.com",
    "sanaoils.ml",
    "sanatoriizheleznovodska.ru",
    "sanbernardinoaddictiontreatment.com",
    "sanbernardinoheroinrehab.com",
    "sanbosco.com",
    "sanchezsharks.com",
    "sanctuaryvpn.com",
    "sandbagsandballoons.com",
    "sandcars.net",
    "sandcohoo.cf",
    "sandcohoo.ga",
    "sandcohoo.gq",
    "sandcohoo.ml",
    "sandcohoo.tk",
    "sandelf.de",
    "sanders4.us",
    "sandf.space",
    "sandhilllservice.net",
    "sandiagauno.club",
    "sandiegoallinclusivewedding.com",
    "sandiegobeer.com",
    "sandiegofarmwedding.com",
    "sandiegolifescience.com",
    "sandiegolifescience.org",
    "sandiegolifesciencenetwork.com",
    "sandiegoranchwedding.com",
    "sandre.cf",
    "sandre.ga",
    "sandre.gq",
    "sandre.ml",
    "sandre.tk",
    "sandrinilix.pw",
    "sandstorm.site",
    "sanduteo.online",
    "sandwhichvideo.com",
    "sandybusinessbrokers.com",
    "sanering-stockholm.nu",
    "sanetris.org",
    "sanetrix.com",
    "sanetrus.com",
    "sanfinder.com",
    "sanfordfibromyalgia.com",
    "sanfordfibromyalgia.org",
    "sanfranmail.com",
    "sangabazarshar.com",
    "sangaritink09gkgk.tk",
    "sangeks.com",
    "sangiangphim.com",
    "sangokutenbu-kouryaku.xyz",
    "sangqiao.net",
    "sangrlaaq.space",
    "sangsters.us",
    "sanibact-errecom.com",
    "sanim.net",
    "sanioma.club",
    "sanitasint.net",
    "sanjaylaladds.com",
    "sanjesh3.info",
    "sankosolar.com",
    "sanliurfaaktuel.xyz",
    "sanliurfaemeksinemalari.xyz",
    "sanliurfagelisim.xyz",
    "sanliurfarehberim.xyz",
    "sanliurfavefadernegi.com",
    "sanliurfavitrin.xyz",
    "sanliurfawebyazilim.com",
    "sanlorenzodentalcare.com",
    "sanluisobispoattorneys.com",
    "sanmarcospanthers.com",
    "sanmh.ru",
    "sannyaephc.online",
    "sannyaephc.ru",
    "sanook.com",
    "sanporeta.ddns.name",
    "sanprp.com",
    "sanriotown.com",
    "sanskrititoday.com",
    "sanslisin11.com",
    "sanstr.com",
    "santa-liria.ru",
    "santanmail.com",
    "santannaenergyservices.biz",
    "santannawarrantyservices.info",
    "santaonoriginal4.xyz",
    "santasbooksforkids.com",
    "santateresacostarica.com",
    "santehmarket-43.ru",
    "santhia.cf",
    "santhia.ga",
    "santhia.gq",
    "santhia.ml",
    "santhia.tk",
    "santiagogomezalcalde.com",
    "santiagonino.org",
    "santikadyandra.cf",
    "santikadyandra.ga",
    "santikadyandra.gq",
    "santikadyandra.ml",
    "santikadyandra.tk",
    "santimetr.xyz",
    "santorini-holiday.com",
    "santoriniflyingdress.com",
    "santorinitoptours.com",
    "sanvekhuyenmai.com",
    "sanvetetre.com",
    "sanvosport.com",
    "sanwubapartners.org",
    "sanxuat.top",
    "saobse.xyz",
    "saol.com",
    "saomoe.com",
    "saotom.info",
    "saoxianggan.com",
    "sapbox.bid",
    "sapcom.org",
    "sapo.pt",
    "sapogikupitru.ru",
    "sapor138ot.online",
    "sapoyr.best",
    "sappartners.net",
    "sapphiccb.xyz",
    "sapphikn.xyz",
    "sapphipap.xyz",
    "sapphireluxuryspa.xyz",
    "sapphiskm.xyz",
    "sapphitte.xyz",
    "sapphiwqr.xyz",
    "sapphizzc.xyz",
    "saprofit.ru",
    "sapsan-24.com",
    "sapsan-go.com",
    "sapsan-russian.com",
    "saptrangsuc.com",
    "sapunda.com",
    "sapya.com",
    "saqixe.info",
    "saqlamheyat.space",
    "sar-asatun.ru",
    "sarahcarsontherapies.com",
    "sarahfordrealtor.com",
    "sarahglenn.net",
    "sarahpark.org",
    "sarahstashuk.com",
    "sarajohnorg.org",
    "sarangbam5.com",
    "sarapanakun.com",
    "sarasotacountyguides.org",
    "sarasotacountyvisitorguides.com",
    "sarasotalifestyles.com",
    "sarasotaluxuryagent.com",
    "saraycasino.bet",
    "saraycasinobonus.com",
    "saraycasinogiris.net",
    "saraycasinoyeniadresi.com",
    "sarayferforje.xyz",
    "sarchawa.krd",
    "sargrip.asia",
    "sarieddinegroup.com",
    "sarinaadams.com",
    "sarkaeeresult.info",
    "sarkariyojana.xyz",
    "sarkodie.africa",
    "sarofimcapital.com",
    "sarofimcapitalpartner.com",
    "sarofimfamily.com",
    "sarofimfamilycapital.com",
    "sarofimfamilycapitalpartners.com",
    "sarofimfamilyholdings.com",
    "sarofimfamilyoffice.com",
    "sarofimholdings.com",
    "sarofimvc.com",
    "sarofimventure.com",
    "sarofimventurecapital.com",
    "sarofimventurecapitalpartners.com",
    "sarofimventures.com",
    "sarrafiipaaarsii.live",
    "sas100.xyz",
    "sasa22.usa.cc",
    "sasababy.info",
    "sashadean.com",
    "sashagrey.mobi",
    "sashifernandez.com",
    "sasmanbetx.com",
    "sasshost.net",
    "sast.ro",
    "satan.gq",
    "satana.cf",
    "satana.ga",
    "satana.gq",
    "satcom.cf",
    "satcom.ga",
    "satcom.gq",
    "satcom.ml",
    "satelliteheroes.com",
    "satenkumasbileklik.com",
    "satepoker.org",
    "sathinews.com",
    "sathio.website",
    "satined.best",
    "satisageldim.com",
    "satisfyme.club",
    "satishikayeleri.com",
    "satisviag.site",
    "sativa.ro.org",
    "sativajesus.org",
    "satkhiramail.tk",
    "satline.info",
    "satorisciencespot.com",
    "satoshibox.store",
    "satsport.fun",
    "sattcipe.cf",
    "sattcipe.ga",
    "sattcipe.gq",
    "sattcipe.ml",
    "sattebangladesh.net",
    "satubandar.club",
    "satubandar.com",
    "satubandar.us",
    "satukosong.com",
    "saturdaylaura.com",
    "saturnbet-official.ru",
    "saturnfans.com",
    "saturnperformance.com",
    "satusatu.online",
    "satutogel3.bar",
    "satvpn.club",
    "satx.rr.com",
    "satyfor.gq",
    "saubandvor.ga",
    "saubandvor.gq",
    "saubandvor.tk",
    "saucey-one.com",
    "saucyaugmentspire.site",
    "saude-digital.org",
    "saudeebom.club",
    "saudemasculina.icu",
    "saudemasculina.press",
    "saudenatural.live",
    "saudenatural.xyz",
    "saudia.com",
    "saufoolbeachf.cf",
    "saufoolbeachf.ga",
    "saufoolbeachf.tk",
    "saukute.me",
    "sauna-na-sverdlova-9.ru",
    "sauna-tomila.ru",
    "saupecmay.cf",
    "saupecmay.gq",
    "saupecmay.ml",
    "sausen.com",
    "saut-elastique.club",
    "sauyh.com",
    "savageattitude.com",
    "savagepublishing.com",
    "savaryseachest.com",
    "savbus.info",
    "save-on-energy.org",
    "save55.org",
    "saveboxmail.ga",
    "savecashusingsolar.com",
    "savecougars.com",
    "saveeagan.org",
    "savefreg.ga",
    "savelife.ml",
    "savelives.org",
    "saveowls.com",
    "saveoxfordstreet.com",
    "saverpa.ga",
    "saverpa.gq",
    "saverpa.ml",
    "saverpa.tk",
    "saves-the-whales.com",
    "savethechildrenactionnetwork.com",
    "savetimeerr.fun",
    "saveuhealth.com",
    "savevid.ga",
    "savewildlife.com",
    "savingnyhomes.com",
    "savingsearcher.com",
    "savinpaiva.com",
    "saviorreds.com",
    "savip168.com",
    "savondemarseille.info",
    "savondemarseille.us",
    "savondemarseilles.com",
    "savored973cf.online",
    "savoytv17.com",
    "savran.de",
    "savvyadvisor.net",
    "savvyartshop.com",
    "savvyautosolutions.com",
    "savvybusinessshow.com",
    "savvyvibe.com",
    "sawages.net",
    "sawas.ru",
    "sawoe.com",
    "sawroutingrum.website",
    "sax-lift.us",
    "saxfun.party",
    "saxlift.us",
    "saxophonexltd.com",
    "sayano.ru",
    "sayeghlawfirm.com",
    "sayfa.info",
    "sayfabir.com",
    "sayfillzin.cf",
    "sayfillzin.ga",
    "sayfillzin.gq",
    "sayfillzin.tk",
    "saygioca.cf",
    "saygioca.ga",
    "saygioca.gq",
    "saygioca.ml",
    "saygioca.tk",
    "sayhi.net",
    "saymeow.de",
    "saymuscge.ga",
    "saymuscge.ml",
    "saynotospams.com",
    "sayonara.gq",
    "sayonara.ml",
    "sayyes-shop.ru",
    "saz753.com",
    "sazaury.com",
    "sazco.net",
    "sazdauttt.shop",
    "sazhimail.ooo",
    "sb40.icu",
    "sb88.online",
    "sbash.ru",
    "sbb.rs",
    "sbb89c.com",
    "sbcglbal.net",
    "sbcglobal.com",
    "sbcglobal.net",
    "sbcplay.club",
    "sbcplay.org",
    "sbcpoker.info",
    "sbcseo.net",
    "sberemec.cf",
    "sberemec.ga",
    "sberemec.ml",
    "sberwick.com",
    "sbg-museum.se",
    "sbgcd.org",
    "sbhk004.com",
    "sbksacbakimkuru.online",
    "sbnations.us",
    "sbndetdc.shop",
    "sbnsale.top",
    "sbo1168.com",
    "sbo21x.com",
    "sbo62.net",
    "sboassociation.com",
    "sbobetpk.website",
    "sbong88.online",
    "sbong88.xyz",
    "sbopk.website",
    "sboro.ru",
    "sborra.tk",
    "sbpoloclub.com",
    "sbprceyewear.com",
    "sbs.onl",
    "sbs66.xyz",
    "sbt90ir.info",
    "sbt90ir.org",
    "sburningk.com",
    "sbuttone.com",
    "sbuyam.site",
    "sc-shoe.com",
    "sc.rr.com",
    "sc8156.com",
    "sc888u.com",
    "sc91pbmljtunkthdt.cf",
    "sc91pbmljtunkthdt.ga",
    "sc91pbmljtunkthdt.gq",
    "sc91pbmljtunkthdt.ml",
    "sc91pbmljtunkthdt.tk",
    "sc96mam3y2pmpa4.xyz",
    "scadaerp.com",
    "scaisirg.shop",
    "scalablefile.network",
    "scalalearn.net",
    "scalatrain.com",
    "scalech.email",
    "scaletrai.xyz",
    "scaleyourads.com",
    "scalpongs.com",
    "scamerahot.info",
    "scamkoreans.xyz",
    "scamorlegit.review",
    "scams.website",
    "scanandfun.ru",
    "scanapa.com",
    "scandales.ru",
    "scandalmail.com",
    "scandiafelt.se",
    "scandiciptv.info",
    "scandinavianhairacademy.com",
    "scandynashop.com",
    "scanf.ga",
    "scanf.gq",
    "scania.gq",
    "scania.tk",
    "scanitxtr.com",
    "scanning.app",
    "scanonline.mobi",
    "scanonline.org",
    "scanor69.xyz",
    "scanova.in",
    "scanova.io",
    "scantobrowser.com",
    "scarfga.com",
    "scarlet.nl",
    "scarry-rp.com",
    "scarymovies.biz",
    "scatibna.tk",
    "scatindiashow.com",
    "scatmail.com",
    "scay.net",
    "scbet88.net",
    "scbox.one.pl",
    "sccdomoter.site",
    "sccoast.net",
    "sccountybank.us",
    "scdn.ooo",
    "sceenic.com",
    "scenarioh.com",
    "scenero.com",
    "sceneslink.com",
    "scennonpda.cf",
    "scennonpda.gq",
    "scennonpda.ml",
    "scennonpda.tk",
    "scenpucu.cf",
    "scenpucu.ga",
    "scentathome-dublin.com",
    "scerpio.com",
    "scfastoffers.com",
    "scfn.net",
    "schachrol.com",
    "schadizun.ga",
    "schadizun.gq",
    "schadizun.tk",
    "schafmail.de",
    "schalfpricedlisting.com",
    "schalfpricedlistings.com",
    "schaumburgofficecleaning.com",
    "schi-zo.de",
    "schiebetore.biz",
    "schilan.site",
    "schilderkunst.de",
    "schilderpro.com",
    "schizo.com",
    "schlankheit.info",
    "schmalwieser.info",
    "schmeissweg.tk",
    "schmid.cf",
    "schmid.ga",
    "schmitt-tm-ltd.com",
    "schmitt-tm-ltd.org",
    "schmuckfiguren.de",
    "schmusemail.de",
    "schnabbel.app",
    "schokopudding.vision",
    "scholapp.cat",
    "scholarreinsurance.org",
    "schone-lucht.shop",
    "schone-lucht.space",
    "schoolemail.com",
    "schoolforharvest.com",
    "schoolgirlslive.com",
    "schoolingherring.com",
    "schoolmail.com",
    "schoolreal.info",
    "schoolrooster.net",
    "schoolsoflove.com",
    "schoolsucks.com",
    "schooltechnology.site",
    "schoonheidsbar.com",
    "schreib-doch-mal-wieder.de",
    "schreib-mir.tk",
    "schreiber-group.com",
    "schreinermeister24.de",
    "schrijf.nu",
    "schrott-email.de",
    "schtep.ru",
    "schwartzmediapro.com",
    "schwarzmail.ga",
    "schweiz.org",
    "schweizer-auto-des-jahres.swiss",
    "schwerlastspedition.de",
    "schwoer.de",
    "sci.fi",
    "sci.mak.ac.ug",
    "sci44.space",
    "sciatique.info",
    "sciegenics.com",
    "science-aviation.org",
    "science.com.au",
    "scienceacademicnews.site",
    "sciencepub.news",
    "sciencestill.com",
    "sciencestry.com",
    "scientist.com",
    "scifi-writers.com",
    "scifianime.com",
    "scififaster.com",
    "scilerap.cf",
    "scilerap.gq",
    "scilerap.ml",
    "scinnovator.com",
    "scinnovators.org",
    "scireq.asia",
    "scireq.net",
    "scireq.org",
    "scissel.xyz",
    "scit.app",
    "scities.pro",
    "scjtzy.com",
    "sclc2.com",
    "scleraxmwa.space",
    "sclgdetbm.shop",
    "sclwu7.com",
    "scmail.cf",
    "sco388.com",
    "sco388.net",
    "sco388.org",
    "scoalaceptura.info",
    "scoldremovedsplit.site",
    "scollay.com",
    "scoopper.ru",
    "scoopsimplespume.site",
    "scootersshop.life",
    "scopdefi.cf",
    "scopdefi.gq",
    "scopdefi.tk",
    "scope4.store",
    "scopus-wos.com",
    "scoredream.ru",
    "scoreek.com",
    "scorefor.xyz",
    "scoremaru.com",
    "scorestats.net",
    "scoretroo.email",
    "scorezq.com",
    "scorpions.co.uk",
    "scotassociation.org",
    "scoteckleyinc.com",
    "scotland.com",
    "scotlandmail.com",
    "scotshome.com",
    "scott-lee-heating.com",
    "scottdesmet.com",
    "scotterkinz.com",
    "scottishmail.co.uk",
    "scottishtories.com",
    "scottivester.com",
    "scottpearson.net",
    "scottpetersondaniel.us",
    "scottrohe.com",
    "scottsboro.org",
    "scottscitylimits.com",
    "scottsdale-resorts.com",
    "scottsdalesgaragedoor.com",
    "scottwestfamily.com",
    "scottytoddmessages.com",
    "scouringsfe.info",
    "scoutprissysteak.site",
    "scouts.onl",
    "scraggbwfw.space",
    "scrapbookingforprofit.com",
    "scrapbookscrapbook.com",
    "scrapcar.money",
    "scrapeemails.com",
    "scrapii.com",
    "scrapper-site.net",
    "scrapping.cc",
    "scraptrend.recipes",
    "scratchcarddonation.com",
    "scratchcuisine.com",
    "screamfused.com",
    "screamingfist.xyz",
    "screechcontrol.com",
    "screen-img.com",
    "screen2.site",
    "screenartisans.com",
    "screencodr.com",
    "screenlink.email",
    "screenlobbydive.website",
    "screenprintingtape.com",
    "screenshottop.info",
    "screwdon.recipes",
    "screwdriveraction.com",
    "screwthe.xyz",
    "scribble.uno",
    "scribeorigins.org",
    "script.click",
    "scriptscdn.pro",
    "scriptsdota2.ru",
    "scriptureboard.com",
    "scrmnto.cf",
    "scrmnto.ga",
    "scrmnto.gq",
    "scrmnto.ml",
    "scroball.com",
    "scrofuqlaj.ru",
    "scroll-through.club",
    "scrptshop.space",
    "scrsot.com",
    "scrubted.com",
    "scruff-a-luvs-shop.ru",
    "scrumbai.live",
    "scrumexperts.com",
    "scruto.xyz",
    "scs188live.net",
    "scs188live.news",
    "scs188live.site",
    "scs188live.space",
    "scs188rocks.com",
    "scs188today.com",
    "scsef.site",
    "scst-nstp.site",
    "scsvw.com",
    "sctbmkxmh0xwt3.cf",
    "sctbmkxmh0xwt3.ga",
    "sctbmkxmh0xwt3.gq",
    "sctbmkxmh0xwt3.ml",
    "sctbmkxmh0xwt3.tk",
    "sctcwe1qet6rktdd.cf",
    "sctcwe1qet6rktdd.ga",
    "sctcwe1qet6rktdd.gq",
    "sctcwe1qet6rktdd.ml",
    "sctcwe1qet6rktdd.tk",
    "scubadiving.com",
    "scubado.info",
    "scufupzil.ga",
    "scufupzil.ml",
    "scufupzil.tk",
    "scuputta.cf",
    "scuputta.ga",
    "scuputta.ml",
    "scurcernbac.ga",
    "scurcernbac.gq",
    "scurcernbac.ml",
    "scuregoto.website",
    "scutranti.cf",
    "scutranti.ml",
    "scutranti.tk",
    "scxt1wis2wekv7b8b.cf",
    "scxt1wis2wekv7b8b.ga",
    "scxt1wis2wekv7b8b.gq",
    "scxt1wis2wekv7b8b.ml",
    "scxt1wis2wekv7b8b.tk",
    "sd3.in",
    "sd71bt2.fun",
    "sdashi.xyz",
    "sdayheou.icu",
    "sdbmz.us",
    "sdcrfmyj.com",
    "sdelaemdeputatom.ru",
    "sdenhaoquangphat.com",
    "sdevicem.com",
    "sdew.cf",
    "sdf.org",
    "sdff.de",
    "sdfggre.xyz",
    "sdfghyj.tk",
    "sdfr.de",
    "sdfsdf.co",
    "sdfsdfsadf.xyz",
    "sdfu8hu.com",
    "sdg34563yer.ga",
    "sdg4643ty34.ga",
    "sdgewrt43terdsgt.ga",
    "sdhalfpricedlisting.com",
    "sdhalfpricelisting.com",
    "sdhalfpricelistings.com",
    "sdigbw.us",
    "sdirchildbus.cf",
    "sdirchildbus.ga",
    "sdirchildbus.gq",
    "sdirchildbus.ml",
    "sdirchildbus.tk",
    "sdireqta.cf",
    "sdireqta.gq",
    "sdireqta.tk",
    "sdkaakjsj.xyz",
    "sdkasjd.xyz",
    "sdlyzlxa.shop",
    "sdnh.pro",
    "sdnr.it",
    "sdo6k.info",
    "sdo71bt2.fun",
    "sdo91bt2.fun",
    "sdom-96.ru",
    "sdpkl.live",
    "sdqbbj.info",
    "sdqlz.us",
    "sdrmyshop.com",
    "sdsas.xyz",
    "sdsgshizheng.com",
    "sdxgalzn.tech",
    "se-center.ru",
    "se223.buzz",
    "se666.net",
    "se668.net",
    "se7encityjlt.com",
    "sea.plala.or.jp",
    "seabedharvesting.com",
    "seabreezeswaves.com",
    "seafoodglossary.com",
    "seafoodpn.com",
    "seag7r.site",
    "sealized.info",
    "seanet.com",
    "seankoybread.gq",
    "seankoybread.ml",
    "seankoybread.tk",
    "seanmetzs.info",
    "seansun.ru",
    "search-clients.info",
    "search-dating-site-deal.rocks",
    "search-dating-site-deals.live",
    "search-home-security-now.market",
    "search-home-security-sites.live",
    "search-liposuction-fat-now.live",
    "search-psoriasis-topicals.live",
    "search.ua",
    "search417.com",
    "searchfather.com",
    "searchformeaning.net",
    "searchindog.com",
    "searchrocketgroup.com",
    "searchtermsmatch.com",
    "searchwales.com",
    "searocketadventures.com",
    "searzh.com",
    "seascoutbeta.org",
    "seasearch.network",
    "seasiapoker.info",
    "seasidebrighton.com",
    "seasideorient.com",
    "seasoftdigital.icu",
    "seasons-easy-info.ru",
    "seasons-group-info.ru",
    "seatga.institute",
    "seatist.com",
    "seatjejbxly.email",
    "seattguru.com",
    "seattleethnicfoods.com",
    "seattlehypnobirthing.org",
    "seattlelaptoprepair.org",
    "seattleplumbing.reviews",
    "seattleroll.net",
    "seattlescooter.com",
    "seattletummytuck.com",
    "seattravels.com",
    "seawgame168.com",
    "seawgame66.com",
    "seawgame77.com",
    "seawgame88.com",
    "seawgame99.com",
    "seazrem.com",
    "sebastianwarren.buzz",
    "sebatdekor.com",
    "seberkd.com",
    "sebil.com",
    "sebilsepeti.com",
    "sebnemisiguzel.net",
    "sebobapark.com",
    "secandocomsaude.com",
    "secbadger.info",
    "secencode.xyz",
    "secfeaturerye.website",
    "secfvc.site",
    "secinvaders.org",
    "seckinmail.com",
    "secknow.info",
    "seclolu.cf",
    "secmail.ga",
    "secmail.gq",
    "secmail.ml",
    "secmail.pro",
    "secmail.pw",
    "secmobi.net",
    "secondmindsoftware.com",
    "seconomies.info",
    "secops.app",
    "secret-area.tk",
    "secret-cinema.online",
    "secret-cinema24.online",
    "secret-police.com",
    "secret.dk",
    "secretagehy.info",
    "secretarias.com",
    "secretary.net",
    "secretbet5.com",
    "secretbet7.com",
    "secretemail.de",
    "secretlenders.online",
    "secretmovie.online",
    "secrets.name",
    "secretsaiyan.xyz",
    "secretsdepeou.com",
    "secretservices.net",
    "secsforall.com",
    "secsforall.org",
    "sector2.org",
    "sectormediastrategies.org",
    "secularized818mw.online",
    "secur.page",
    "securaname.com",
    "securblockchain.net",
    "secure-0nline-uk.xyz",
    "secure-box.info",
    "secure-box.online",
    "secure-fb.com",
    "secure-mail.biz",
    "secure-mail.cc",
    "secure-mail.cn",
    "secure-net-uk.buzz",
    "secure-online-uk.buzz",
    "secure-online-uk.monster",
    "secure-online.monster",
    "secured-link.net",
    "secureddegrees.com",
    "securehost.com.es",
    "secureinvox.com",
    "securemail.flu.cc",
    "securemail.gq",
    "securemail.igg.biz",
    "securemail.nut.cc",
    "securemail.usa.cc",
    "securemailserver.cf",
    "securemailserver.ga",
    "securemailserver.gq",
    "securemailserver.ml",
    "securemailserver.tk",
    "securemedikal.xyz",
    "secureorder.online",
    "secureschoolalliance.com",
    "secureschoolalliance.net",
    "secureschoolalliance.org",
    "secureschoolsalliance.net",
    "secureschoolsalliance.us",
    "secureserver.usa.cc",
    "secureserver01.net",
    "securesys.cf",
    "securesys.ga",
    "securesys.gq",
    "securesys.ml",
    "securesys.tk",
    "securesystems-corp.cf",
    "securesystems-corp.ga",
    "securesystems-corp.gq",
    "securesystems-corp.ml",
    "securesystems-corp.tk",
    "securetel-big.tel",
    "securiblog.com",
    "securitycamerasinstallation.net",
    "securityconsulting.tech",
    "securityfirstbook.com",
    "securityfixed.com",
    "securityinsight.net",
    "securityriskexpert.com",
    "sedansis.info",
    "sedasagreen01try.tk",
    "sedewoge.site",
    "seductiondictionary.com",
    "seductive.com",
    "seductivestarletzz.net",
    "seductiveturtle.org",
    "seealmeria.com",
    "seed.ml",
    "seed2tree.com",
    "seedbankcoin.com",
    "seedboha.cf",
    "seedboha.ga",
    "seedboha.gq",
    "seedboha.ml",
    "seedboha.tk",
    "seedcommerce.shop",
    "seedcommons.com",
    "seednest.us",
    "seek-online-degrees-deal.live",
    "seek-voiceoverip-service.live",
    "seek-voip-systems-today.rocks",
    "seekapps.com",
    "seekbeacon.com",
    "seekbusinessblog.club",
    "seekfindask.com",
    "seekincentives.com",
    "seeking-arrangements.review",
    "seekjobs4u.com",
    "seekstoyboy.com",
    "seelak.site",
    "seelenders.net",
    "seemyplace.xyz",
    "seenontvclub.com",
    "seenparisy.info",
    "seeout.us",
    "seer-rx.com",
    "seesli.com",
    "seeyuan.com",
    "segabandemcross74new.ml",
    "segalnet.net",
    "segawayofhawaii.com",
    "segayazilim.com",
    "segoviavegas.com",
    "segredosdaaudienciaonline.com",
    "segundolance.site",
    "seguo10.xyz",
    "segurado.org",
    "seguridadinformatica.ninja",
    "seguro.bet",
    "seguros.com.br",
    "segwrgna.shop",
    "sehitkamilbelediyespor.xyz",
    "sehnqv.info",
    "seibersbach.net",
    "seidistdi.cf",
    "seidistdi.gq",
    "seigaterc.cf",
    "seigaterc.gq",
    "seigaterc.ml",
    "seigaterc.tk",
    "seikki.com",
    "seikopoker.com",
    "seinebreachsteer.site",
    "seiox.com",
    "seizefai.xyz",
    "seizin737lr.online",
    "sejaa.lv",
    "sejavistoo.com",
    "sejohnsonandsons.com",
    "sekarjagat.com",
    "sekas.fun",
    "sekdongsan.com",
    "sekerhastaligi.mobi",
    "sekizbir.com",
    "sekomaonline.com",
    "seksbuiten.online",
    "sektorpoker.info",
    "sektorpoker.net",
    "sektorpoker.org",
    "selaevent.com",
    "selamtatube.com",
    "selang3.xyz",
    "selbcitbears.cf",
    "selbcitbears.gq",
    "selbcitbears.tk",
    "selcukayanoglu.xyz",
    "selcukluemlakkonya.com",
    "seldc.org",
    "seleb2toto.com",
    "selectionsart.com",
    "selectivestars.com",
    "selectmcohio.net",
    "selector-casino.host",
    "selector-casino.online",
    "seleramakngah.com",
    "self.direct",
    "selfbonds.info",
    "selfdestructingmail.com",
    "selfdestructingmail.org",
    "selfdirected401ksecrets.com",
    "selfdirectedadviser.com",
    "selfdirectedadvisers.com",
    "selfdirectedadvisor.com",
    "selfdirectediraadvisers.com",
    "selfdirectediraadvisor.com",
    "selfdirectirallc.com",
    "selfgard.com",
    "selfhelptoolbox.com",
    "selfie-cam.online",
    "selfie-roipro.ru",
    "selfiecard.com",
    "selfieled.ru",
    "selfietobacco.online",
    "selfietobacco.xyz",
    "selfimasajes.com",
    "selfimvement.pro",
    "selfip.biz",
    "selfip.com",
    "selfip.info",
    "selfip.net",
    "selfip.org",
    "selfmedicine.ru",
    "selftanningpills.net",
    "selindaconcession.com",
    "selipico.site",
    "selkamedya.com",
    "sell-brends.ru",
    "sell-market1.ru",
    "sellcircuitboards.com",
    "sellcow.net",
    "seller1hit.website",
    "sellerku.info",
    "sellerku.us",
    "sellerku.xyz",
    "sellfb.xyz",
    "sellgallery.space",
    "sellgallery.website",
    "sellim.site",
    "sellingogos.com",
    "sellingshop.online",
    "sellingspree.com",
    "selljar.com",
    "sellmine.ru",
    "sellmyexpirednow.com",
    "sellmymichiganproperty.com",
    "sellodeconfianza.online",
    "sells-for-less.com",
    "sells-for-u.com",
    "sells-it.net",
    "sellscopedata.com",
    "sellscopemturk.com",
    "sellscopeprospecting.com",
    "sellscopeprospects.com",
    "sellscoperesearch.com",
    "sellstorevero.com",
    "sellsyourhome.org",
    "selluh.com",
    "sellusyourhouse.net",
    "sellyouroldmobile.info",
    "sellyourstocks2019.com",
    "selmaforeclosures.com",
    "selowcoffee.cf",
    "selowcoffee.ga",
    "selowcoffee.gq",
    "selowcoffee.ml",
    "selowhellboy.cf",
    "selowhellboy.ga",
    "selowhellboy.gq",
    "selowhellboy.ml",
    "seltaire.cf",
    "seltaire.ga",
    "seltaire.ml",
    "seltaire.tk",
    "seluang.com",
    "selyatino-beton-zavod.ru",
    "semahua.com",
    "semail.us",
    "semangat99.cf",
    "semarcomputama.tk",
    "semarhouse.ga",
    "semarhouse.ml",
    "semarhouse.tk",
    "sembwebba.ga",
    "sembwebba.gq",
    "sembwebba.tk",
    "semei6.fun",
    "semena-moskva.ru",
    "semenula.site",
    "semestatogel.com",
    "semeynayakl.ru",
    "semi168.live",
    "seminairehorizons.com",
    "seminaroil.info",
    "semiotik.co",
    "semited.fun",
    "semleter.gq",
    "semmos.com",
    "semogaderes.com",
    "sempakk.com",
    "sempuranadi.cf",
    "sempuranadi.ga",
    "sempuranadi.ml",
    "sempuranadi.tk",
    "semsipasapasaji.xyz",
    "semuaduit.org",
    "semusimbersama.online",
    "semut-kecil.com",
    "semutkecil.com",
    "senangpoker.site",
    "senanurie2ens.xyz",
    "send-email.org",
    "send-money.ru",
    "send.hu",
    "send22u.info",
    "send360.de",
    "sendbananas.website",
    "sendcertifiedletters.com",
    "sendfree.org",
    "sendify.email",
    "sendify.org",
    "sendingspecialflyers.com",
    "sendmail.ru",
    "sendme.cz",
    "sendmesome.cash",
    "sendmesomemails.biz",
    "sendrule.com",
    "sendspamhere.com",
    "sendthemails.com",
    "sendto.cf",
    "senduvu.com",
    "senerza.press",
    "senfmoka.cf",
    "senfmoka.gq",
    "senfmoka.ml",
    "sengkang-grand-residences-sg.com",
    "senguanteng.com",
    "sengyindang.com",
    "senintenin.xyz",
    "senior4d.info",
    "seniorcareandtransport.com",
    "seniorcaremarketingcouncil.com",
    "seniorforless.net",
    "seniorhomecareprograms.com",
    "seniorhomes.ru",
    "seniorlivingcenterfinder.com",
    "seniorlivingcenterinfo.org",
    "seniorlivingcenterinformation.com",
    "seniorlivingcentersfinder.org",
    "seniormarketingcouncil.com",
    "sennafans.com",
    "sennbox.cf",
    "sennbox.ga",
    "sennbox.gq",
    "sennbox.ml",
    "sennbox.tk",
    "sennheiser-ru.online",
    "senoonmarket.com",
    "senpaigamer.com",
    "sensearticle.com",
    "senseblan.recipes",
    "sensecloc.us",
    "sensegrie.icu",
    "sensehab.us",
    "sensejoint.xyz",
    "sensel.ru",
    "senseless-entertainment.com",
    "sensemo.xyz",
    "senseradios.com",
    "senseswe.icu",
    "sensibvwjt.space",
    "sensika.email",
    "sensika.global",
    "sensika.news",
    "sensika.online",
    "sensika.page",
    "sensitivityculture.com",
    "sensorfkgg.space",
    "sensorynopain.online",
    "sensorynopain.xyz",
    "sensualerotics.date",
    "sensualitemovement.com",
    "sensualizes731kd.online",
    "sent.as",
    "sent.at",
    "sent.com",
    "sentapoker.live",
    "sentigizmo.com",
    "sentitle.ru",
    "sentrismail.com",
    "sentry-e3taxservice.com",
    "sentryenis.site",
    "senttmail.ga",
    "seo-bux.ru",
    "seo-cdn.ru",
    "seo-clicker.com",
    "seo-delo.ru",
    "seo-google.site",
    "seo-local.site",
    "seo-mailer.com",
    "seo-search.site",
    "seoankur.info",
    "seobich.ru",
    "seoblogger.net",
    "seobot.com",
    "seobungbinh.com",
    "seobusinessclub1.com",
    "seocdn.ru",
    "seocy.us",
    "seoexperindia.online",
    "seofun.ru",
    "seogern.ru",
    "seomail.net",
    "seomail.org",
    "seomail.top",
    "seomediadesign.online",
    "seorankhistory.com",
    "seorolas.gq",
    "seoservicespk.com",
    "seosie.com",
    "seoufo.net",
    "seoulmusicawards.net",
    "seovestmont.cf",
    "seovestmont.ga",
    "seovestmont.gq",
    "seovestmont.ml",
    "seoysemweb.com",
    "separajvlx.space",
    "sepatuanak.online",
    "sepatusupeng.gq",
    "sepci-saneva.tk",
    "septembermovo.com",
    "septicinspectionjacksonnj.com",
    "septiko-unilos.ru",
    "septozer.com",
    "septrail.info",
    "sepulcher667sz.xyz",
    "seputarbet.live",
    "seputarti.com",
    "sequipment.ru",
    "ser2201b.buzz",
    "seraji.info",
    "serapoker.com",
    "serdin.site",
    "serebro32.ru",
    "serena-pass.online",
    "serenadestrings.com",
    "serenadethailand.com",
    "serendipityloves.website",
    "serendipitysugarscrub.com",
    "serenite.site",
    "serenitynorth.org",
    "serenitysjournal.com",
    "seret.video",
    "serga.com.ar",
    "sergepreventstill.site",
    "sergeykudria.com",
    "sergiogaete.com",
    "sergiovillellacorporate.com",
    "sergiowatches.com",
    "serhatcakar.online",
    "serhuwadewtr.website",
    "serial-hd.online",
    "serializing971ze.online",
    "serialkillers.us",
    "serialreview.com",
    "series-online.club",
    "serieson.best",
    "seriesonlinegratis.org",
    "seriestreaming.website",
    "seriesvip.club",
    "seriiletisimreklam.xyz",
    "serik.website",
    "serimet.ru",
    "seringolt.ru",
    "seriousalts.de",
    "serkankalemcilerkimdir.org",
    "sermonizer853ip.online",
    "sernativo.com",
    "serosurvey.ru",
    "serp-clicker.com",
    "serpclicker.com",
    "serpina.website",
    "serrurierperigny.com",
    "sersageurn.icu",
    "sersandsol.cf",
    "sersandsol.ga",
    "sersandsol.gq",
    "sersandsol.ml",
    "sersandsol.tk",
    "sersome2201c.monster",
    "sert2201a.site",
    "sertecfarma.cat",
    "serupedia.info",
    "serv.craigslist.org",
    "serv20.website",
    "servachok-top.ru",
    "servaux.org",
    "servdorda.cf",
    "servdorda.ga",
    "servdorda.gq",
    "servdorda.ml",
    "servebbs.com",
    "servebbs.net",
    "servebbs.org",
    "servebeer.com",
    "servedi.email",
    "serveextra.com",
    "serveftp.net",
    "serveftp.org",
    "servegame.org",
    "servemymail.com",
    "server-rus-v.ru",
    "server.ms",
    "serverfor.email",
    "servergal.com",
    "serverhytale.ru",
    "serverjavascript.com",
    "serverlessintelligence.com",
    "servermaps.net",
    "servermuoihaikhongbon.com",
    "serverpro.cf",
    "serverqiu.com",
    "servetserifoglu.com",
    "serveup.press",
    "serveurweb.org",
    "servewareshop.life",
    "service-911.ru",
    "service-telecom.us",
    "service-xiaomi.ru",
    "service4.ml",
    "servicebusinessmagazine.com",
    "serviced.site",
    "servicefile.ru",
    "services391.com",
    "services4you.de",
    "servicesbydeluxe.com",
    "servicesfor.us",
    "servicevideos.org",
    "servicewhirlpool.ru",
    "servicioymantenimientos.com",
    "servinghamptonroads.net",
    "servisetcs.info",
    "servismerkezi.info",
    "servisy-acura.ru",
    "servisy-alfaromeo.ru",
    "servisy-bentley.ru",
    "servisy-byd.ru",
    "servisy-chery.ru",
    "servisy-daihatsu.ru",
    "servisy-dodge.ru",
    "servisy-jaguar.ru",
    "servisy-lincoln.ru",
    "servisy-mini.ru",
    "servisy-oldsmobile.ru",
    "servisy-pontiac.ru",
    "servisy-rangerover.ru",
    "servisy-saab.ru",
    "servisy-smart.ru",
    "servisy-vaz.ru",
    "servizioeuropeodisolidarieta.com",
    "servizioeuropeodisolidarieta.info",
    "servizioeuropeodisolidarieta.net",
    "servonews.ru",
    "servus-mail.de",
    "ses4energy.org",
    "seshirpetfood.com",
    "sesknehtmarka.space",
    "seskvizyon.com",
    "seslibayrak.xyz",
    "seslifake.xyz",
    "seslikalbimsin.com",
    "seslikum.online",
    "sesliloca.xyz",
    "seslimaya.xyz",
    "seslinokta.xyz",
    "sesliozgurce.online",
    "sesliozgurce.xyz",
    "seslipak.xyz",
    "seslisaha.online",
    "seslisaha.xyz",
    "seslisaklimdasin.xyz",
    "seslisato.xyz",
    "seslisinemce.xyz",
    "seslisizle.xyz",
    "sesliturku.xyz",
    "sesmail.com",
    "sesmale.us",
    "sesnsesy.shop",
    "sespovodkneht.space",
    "sestitoboysbmx.com",
    "sesysesn.shop",
    "setabahis.net",
    "setabahis.org",
    "setbet.icu",
    "setefi.tk",
    "setekshome.site",
    "sethighknav.ga",
    "sethighknav.gq",
    "sethighknav.ml",
    "sethighknav.tk",
    "setiabudihitz.com",
    "setiantang168.com",
    "setki-optovik.ru",
    "setrabet1.com",
    "setrabet13.com",
    "setrabet3.com",
    "setrabet4.com",
    "setrabet6.com",
    "setrabet7.com",
    "settcyre.cf",
    "settcyre.ga",
    "settcyre.gq",
    "settcyre.ml",
    "settleddivorce.com",
    "settleforagoodcause.org",
    "settsunmang.cf",
    "settsunmang.tk",
    "setun-alg.online",
    "setuperu.ru",
    "setupexpress.com",
    "setupgamblingstink.site",
    "setutime.com",
    "setvolta.com",
    "setyourownfee.com",
    "setzd.us",
    "seulasgoo.gq",
    "seulasgoo.ml",
    "seulasgoo.tk",
    "seuvi8.us",
    "sev-relax.ru",
    "sev-vybor2020.ru",
    "sevac.info",
    "sevadus.net",
    "sevadusgaming.org",
    "sevemy.us",
    "seven-hotels.com",
    "seven-neuro.ru",
    "seven-shoes.ru",
    "seven6s.com",
    "sevenfigureadvisorsecrets.com",
    "sevenforce.su",
    "sevengame.live",
    "sevengame.ninja",
    "sevengame.wtf",
    "sevenpalms30a.net",
    "sevensenseagency.com",
    "severimlers.site",
    "sevgisoysal.org",
    "sevilshop.ir",
    "sevkiakdemir.xyz",
    "sevsotreasure.com",
    "sewafotocopy-xerox.com",
    "sewaipad.com",
    "sewesi.info",
    "sewmanyblanks.com",
    "sex.dns-cloud.net",
    "sexboxx.cf",
    "sexboxx.ga",
    "sexboxx.gq",
    "sexboxx.ml",
    "sexboxx.tk",
    "sexforswingers.com",
    "sexical.com",
    "sexmagnet.com",
    "sexxfun69.site",
    "sexy.camdvr.org",
    "sexyalwasmi.top",
    "sexyalwax.online",
    "sexymail.gq",
    "sexymail.ooo",
    "sexysurfer.dk",
    "sexytoys24.de",
    "sey6cs.us",
    "seychelles-holiday.com",
    "seyf.kim",
    "seymourelderlawgroup.com",
    "seymourindustries.com",
    "seymourrealestateagents.com",
    "seymourstudio.us",
    "sez68r.us",
    "sezet.com",
    "seznam.cz",
    "sezon.life",
    "sf-nero.site",
    "sf15.space",
    "sf16.space",
    "sf23.space",
    "sfa.app",
    "sfab.nu",
    "sfamo.com",
    "sfbottlebank.com",
    "sfc3files.com",
    "sfd-aa.com",
    "sfd-bb.com",
    "sfdsci.us",
    "sfer.com",
    "sferamk.ru",
    "sferyshar.xyz",
    "sfes.de",
    "sfgov.net",
    "sfgpros.com",
    "sfmail.top",
    "sfolkar.com",
    "sforvike.cf",
    "sforvike.ga",
    "sforvike.ml",
    "sforvike.tk",
    "sfpc.de",
    "sfr.fr",
    "sfs.com",
    "sfsa.de",
    "sfsu.edu",
    "sfzh6p.info",
    "sfznix.club",
    "sg4d.club",
    "sgafest.ru",
    "sgag.de",
    "sgb-itu-anjeng.cf",
    "sgb-itu-anjeng.ga",
    "sgb-itu-anjeng.gq",
    "sgb-itu-anjeng.ml",
    "sgb-itu-anjeng.tk",
    "sgb-itu-bangsat.cf",
    "sgb-itu-bangsat.ga",
    "sgb-itu-bangsat.gq",
    "sgb-itu-bangsat.ml",
    "sgb-itu-bangsat.tk",
    "sgb-sukabumi.com",
    "sgb.jembud.icu",
    "sgb.team",
    "sgbteam.hostingarif.me",
    "sgbteambalikpapan.me",
    "sgbtukangsuntik.club",
    "sgcarpool.com",
    "sgdati.com",
    "sgdetian.com",
    "sge-energia.com",
    "sgep0o70lh.cf",
    "sgep0o70lh.ga",
    "sgep0o70lh.gq",
    "sgep0o70lh.ml",
    "sgep0o70lh.tk",
    "sgfqqz.site",
    "sgilde.com",
    "sgilder.com",
    "sgizdkbck4n8deph59.cf",
    "sgizdkbck4n8deph59.gq",
    "sgizuw.us",
    "sgphoki.com",
    "sgraf.ru",
    "sgsf5y.us",
    "sgskaters.com",
    "sgtmozag.shop",
    "sgxboe1ctru.cf",
    "sgxboe1ctru.ga",
    "sgxboe1ctru.gq",
    "sgxboe1ctru.ml",
    "sgxboe1ctru.tk",
    "sgxwv.com",
    "sh-ftjs.com",
    "sh-jnd.com",
    "sh22.space",
    "sh25.space",
    "sh26.space",
    "sh29.space",
    "sh3rl0ck.com",
    "sh90be.club",
    "sha2iniekaa.xyz",
    "shaadfamily.com",
    "shaadiperfect.com",
    "shabablad3m.info",
    "shababu.site",
    "shabbag.net",
    "shacasinoheat.ru",
    "shackachaga.com",
    "shacknet.nu",
    "shadap.org",
    "shadesofopera.com",
    "shadesstreet.com",
    "shadezbyj.com",
    "shadion.com",
    "shadow-net.ml",
    "shadowcraft.online",
    "shadowis.site",
    "shadowlinepos.com",
    "shadowpowered.com",
    "shadowslots.info",
    "shadys.biz",
    "shaghayegh1.com",
    "shagranch.com",
    "shagun-swords.com",
    "shahabart.com",
    "shahbendar.com",
    "shahidkamal.com",
    "shahimul.tk",
    "shahobt.info",
    "shahobt.org",
    "shahrvandyar.com",
    "shahs.best",
    "shahweb.net",
    "shahzad.org",
    "shake.monster",
    "shakebr.xyz",
    "shakebrow.xyz",
    "shakecove.xyz",
    "shakemain.com",
    "shaken.baby",
    "shakensoftware.org",
    "shakerou.buzz",
    "shakewor.xyz",
    "shakirabalti.com",
    "shakpotok.com",
    "shalar.net",
    "shamanowners.com",
    "shamansglobalhub.com",
    "shamechao.press",
    "shamepian.icu",
    "shameweekendstrap.site",
    "shamsalma3aref.xyz",
    "shan999.net",
    "shang-hai-chinese.com",
    "shangbad.xyz",
    "shanghaichinesedublin.com",
    "shanghaithai-dublin1.com",
    "shangtwo.com",
    "shaniastuff.com",
    "shanieports.buzz",
    "shanitakeaway.com",
    "shannon.host",
    "shannonil.buzz",
    "shannonkweston.com",
    "shannonrichmond.com",
    "shantale.ru",
    "shaparak90.xyz",
    "shapeej.xyz",
    "shapeeje.xyz",
    "shapelybottom.com",
    "shaperu.xyz",
    "shapewearinfo.online",
    "shapka-fashion.ru",
    "shapoo.ch",
    "shar-kov.ru",
    "sharaproctor.com",
    "shardleo.com",
    "share4charity.net",
    "sharebooklib.com",
    "sharecaregiver.net",
    "shared-files.de",
    "sharedmailbox.org",
    "sharedzone.org",
    "shareess.icu",
    "shareflix.xyz",
    "sharehaus.org",
    "sharehealthspot.club",
    "sharela.xyz",
    "sharelay.xyz",
    "sharelaye.xyz",
    "sharelist.tech",
    "sharem.store",
    "shareman-rus.ru",
    "sharemycoachindio.com",
    "sharepoint-consultants.sydney",
    "shares.tel",
    "sharespace.school",
    "sharesupermarket.com",
    "sharetime.app",
    "sharewaredevelopers.com",
    "shargemostagim.com",
    "shargmostaghim.com",
    "sharing-storage.com",
    "sharingit.net",
    "sharjemostagim.com",
    "sharjeno.xyz",
    "shark-flexi.com",
    "sharkcordfree.com",
    "sharkflexi.com",
    "sharkgamer.com",
    "sharklasers.com",
    "sharkliferp.ru",
    "sharklove.life",
    "sharmanetworksolutions.biz",
    "sharmaweb.com",
    "sharmmassage.ru",
    "sharpfibre.fr",
    "shartse.org",
    "sharyndoll.com",
    "shat.biz",
    "shat.gives",
    "shat.info",
    "shat.live",
    "shat.ninja",
    "shat.tech",
    "shatelvpn.com",
    "shatelvpn.xyz",
    "shattuck.network",
    "shattuck.ninja",
    "shattuck.online",
    "shattuck.services",
    "shattucks.us",
    "shavawnforester.org",
    "shaveling.best",
    "shaw.ca",
    "shawarmarealalgeciras.com",
    "shayanashop.biz",
    "shayuav.com",
    "shayzam.net",
    "shb90b.club",
    "shbe90.club",
    "she.com",
    "sheareddeals.com",
    "shearerpain.com",
    "shebabu.site",
    "shebenbeton.ru",
    "shedplan.info",
    "shedplan3547.xyz",
    "sheepstai.press",
    "sheepwatc.fun",
    "sheepwo.xyz",
    "sheepwor.xyz",
    "sheepwort.xyz",
    "sheerglove.com",
    "sheetbooks.com",
    "sheetguestwarm.website",
    "sheetknee.press",
    "shefruneta.ru",
    "sheikhdailyshop.com",
    "shejiapu.com",
    "shelbymattingly.com",
    "sheldh.xyz",
    "shelfdeb.xyz",
    "shelffe.icu",
    "shelfte.xyz",
    "shelfteac.xyz",
    "shelkovo-3.ru",
    "shellenge.net",
    "shellfamilywellness.com",
    "shellhenry.com",
    "shellov.net",
    "shellylawpc.info",
    "shellylawpc.org",
    "shelmerston.net",
    "shelord.site",
    "shelovestogive.org",
    "shelterinnovations.com",
    "sheltex.blog",
    "shemlmstore.com",
    "shenangovalleyareascalemodelers.com",
    "shengda2.net",
    "shengshi.bet",
    "shenlex.com",
    "shenmefan.com",
    "shenmege.com",
    "shenmidaima.com",
    "shenmzycj.com",
    "shenqiancun.com",
    "shenshahfood.com",
    "shenshizhan.com",
    "shepherdscrusade.com",
    "shequechicago.com",
    "sherepunjabtakeaway.com",
    "sherlockholmesforkids.com",
    "sherrtty.xyz",
    "sherry-rb.com",
    "sherryrb.com",
    "sherrywilliamsoncollection.com",
    "sherrywilliamsondesign.com",
    "sherrywilliamsondesigninc.com",
    "sherwab.ru",
    "shewantshim.com",
    "shewishop.ru",
    "shey-sama.ru",
    "sheybe.live",
    "sheytg56.ga",
    "shh10.space",
    "shhmail.com",
    "shhuut.org",
    "shi173.com",
    "shiakidi.com",
    "shiales.com",
    "shibabu.site",
    "shibo338.net",
    "shichuan.website",
    "shicoast.com",
    "shid.de",
    "shieldedmail.com",
    "shieldemail.com",
    "shift-coin.com",
    "shiftcampaigns.com",
    "shiftcenters.com",
    "shifted.media",
    "shiftfeig.xyz",
    "shifthealth.online",
    "shiftincubator.com",
    "shiftixiaj.space",
    "shiftmail.com",
    "shiftmayo.us",
    "shiftnewyorkcity.com",
    "shiftsacramento.com",
    "shiftsanfrancisco.com",
    "shiftstation.com",
    "shifttr.xyz",
    "shifttruc.icu",
    "shiftwomenglobal.com",
    "shifty.ninja",
    "shigellainformation.com",
    "shijieyinyangzhai.com",
    "shijihuazhong.com",
    "shiklebas.info",
    "shiliao.info",
    "shiloa.com",
    "shim.tech",
    "shimano-catan.ru",
    "shimano-nasci.online",
    "shimano-sedona.online",
    "shineal.xyz",
    "shineali.icu",
    "shineali.xyz",
    "shinedonor.buzz",
    "shinedyoureyes.com",
    "shineru.ru",
    "shinewago.buzz",
    "shiniseshop.com",
    "shiniseshop.net",
    "shinisetoriyose.com",
    "shinisetoriyose.net",
    "shinnemo.com",
    "shinyandchrome.xyz",
    "shinystagesecretsreviews.com",
    "shio365.com",
    "shiok88.info",
    "shiok888.com",
    "ship-from-to.com",
    "shipboard.ru",
    "shipfromto.com",
    "shiphazmat.org",
    "shipping-regulations.com",
    "shippingterms.org",
    "shiprol.com",
    "shipyoufurniture.com",
    "shirleybowman.com",
    "shirleyespinozachiropractic.com",
    "shiroinime.ga",
    "shironime.ga",
    "shironime.ml",
    "shironime.tk",
    "shirtical.com",
    "shirtmakers.de",
    "shirtstopshop.site",
    "shirttwo.com",
    "shisas.com",
    "shisazabenie.fun",
    "shishie.com",
    "shishire6.xyz",
    "shishire8.xyz",
    "shishire9.xyz",
    "shishish.cf",
    "shishish.ga",
    "shishish.gq",
    "shishish.ml",
    "shishuai0511.com",
    "shit.cards",
    "shit.dns-cloud.net",
    "shit.dnsabr.com",
    "shit.exposed",
    "shit.tools",
    "shitaiqi.com",
    "shitaway.cf",
    "shitaway.cu.cc",
    "shitaway.flu.cc",
    "shitaway.ga",
    "shitaway.gq",
    "shitaway.igg.biz",
    "shitaway.ml",
    "shitaway.nut.cc",
    "shitaway.tk",
    "shitaway.usa.cc",
    "shitmail.cf",
    "shitmail.de",
    "shitmail.ga",
    "shitmail.gq",
    "shitmail.me",
    "shitmail.ml",
    "shitmail.org",
    "shitmail.tk",
    "shitmycatkills.com",
    "shitposting.agency",
    "shitservices.online",
    "shittymail.cf",
    "shittymail.ga",
    "shittymail.gq",
    "shittymail.ml",
    "shittymail.tk",
    "shitware.nl",
    "shiva-spirit.com",
    "shivanienkij.xyz",
    "shivaspirittv.com",
    "shiyakila.cf",
    "shiyakila.ga",
    "shiyakila.gq",
    "shiyakila.ml",
    "shizana.com",
    "shizanasaeed.com",
    "shjdmedical.com",
    "shkololo.org",
    "shluy.com",
    "shm-au.host",
    "shm-au.site",
    "shmeriously.com",
    "shmlkg.club",
    "shobeh.com",
    "shockhorror.com",
    "shockinmytown.cu.cc",
    "shockmail.win",
    "shocknewsru.ru",
    "shocktours.com",
    "shoddyaf.com",
    "shoejanitor.com",
    "shoes-market.cf",
    "shoes-sneakers2.site",
    "shoesmall.site",
    "shoesstock.ru",
    "shoesusale.com",
    "shoklin.cf",
    "shoklin.ga",
    "shoklin.gq",
    "shoklin.ml",
    "shokoshop.ru",
    "shomalbet.site",
    "shomeimprovementz.com",
    "shonky.info",
    "shoo-v777.com",
    "shoo-v888.com",
    "shoot2splatter.com",
    "shooters-ott.com",
    "shootingstarrealty.com",
    "shootmail.com",
    "shop-action-zero.ru",
    "shop-csskin.ru",
    "shop-discount-med.info",
    "shop-horse.ru",
    "shop-konditer.ru",
    "shop-krossovki.ru",
    "shop-massage.site",
    "shop-nakidki.ru",
    "shop-store-prod.ru",
    "shop-teh.host",
    "shop-veneers-smile.site",
    "shop-wow-sale.ru",
    "shop.lalaboutique.com",
    "shop2021.club",
    "shop2021.online",
    "shop349forus.com",
    "shop4mail.net",
    "shop4seals.com",
    "shopaa318.xyz",
    "shopaepi.com",
    "shopaepi.net",
    "shopasrss.com",
    "shopatrips.com",
    "shopbaby.me",
    "shopback.tech",
    "shopbackgo.com",
    "shopballball.com",
    "shopcartaillightsonline.site",
    "shopdream1.ru",
    "shopeng.website",
    "shopepikg.club",
    "shopgiatot.website",
    "shopgtvs.ru",
    "shophuge.com",
    "shopicron.com",
    "shopikcentr.ru",
    "shopilingo.xyz",
    "shoping25.ru",
    "shopingmax.ru",
    "shopingmir.ru",
    "shopingwatch.biz",
    "shopinia.com",
    "shopins4.site",
    "shopjumy.com",
    "shopkaws.com",
    "shopkeepers.co.uk",
    "shoplargeappliances.com",
    "shopliterallymagic.live",
    "shopmail.ga",
    "shopmayruamat.com",
    "shopmoza.com",
    "shopn2017.com",
    "shopoglot.ru",
    "shoponlinewithoutcvv.ru",
    "shoporder.xyz",
    "shopperseeking.com",
    "shoppibooks.com",
    "shopping-1-go.online",
    "shopping-3-go.online",
    "shopping-4-go.online",
    "shopping-5-go.online",
    "shopping-6-go.online",
    "shopping-7-go.online",
    "shopping-8-go.online",
    "shopping-9-go.online",
    "shopping-real-factory.site",
    "shoppingballball.com",
    "shoppingcabinets.com",
    "shoppingsecretnews.club",
    "shoppingtostore.com",
    "shoppingtrends24.de",
    "shoppyhunt.com",
    "shoppymarket.shop",
    "shoppypay.shop",
    "shoproyal.net",
    "shopru.host",
    "shopser.ru",
    "shopsgid.ru",
    "shopshopboongaja.com",
    "shopsmartclassified.com",
    "shopsport.xyz",
    "shopsred20.site",
    "shopsza.com",
    "shoptheshadowconspiracy.com",
    "shoptragop.net",
    "shoptumen.ru",
    "shopuniformswarehouse.com",
    "shopuniformwarehouse.com",
    "shopussy.com",
    "shopwalmarte.com",
    "shopylingo.xyz",
    "shorefitmb.com",
    "shorelinehotelguest.com",
    "short-haircuts.co",
    "shorten.tempm.ml",
    "shorterurl.biz",
    "shortmail.com",
    "shortmail.me",
    "shortmail.net",
    "shortopapp.site",
    "shortpacket.org",
    "shortsaleadv.com",
    "shorttermstaynyc.com",
    "shorttimemail.com",
    "shortybud.com",
    "shortyliqs.net",
    "shortyour.com",
    "shotarvaladze.site",
    "shotflow.net",
    "shotgun.hu",
    "shotmail.ru",
    "shouldercut.com",
    "shouldpjr.com",
    "shoutissu.site",
    "shoutitout.biz",
    "shoutworthy.com",
    "showboxmovies.club",
    "showboxmovies.site",
    "showcasebrand.com",
    "showfans.com",
    "showme.social",
    "showmeyourbest.design",
    "showpets.store",
    "showslow.de",
    "showstorm.com",
    "shp7.cn",
    "shpaten.site",
    "shqiptar.eu",
    "shrib.com",
    "shrinkedin.net",
    "shsbhns.xyz",
    "shtf2020.online",
    "shubhlabh.ong",
    "shuf.com",
    "shuffle.email",
    "shufflingzebra.com",
    "shuifuli.com",
    "shuimitaoshipin.xyz",
    "shulmansystem.com",
    "shupat.site",
    "shurs.xyz",
    "shusheyv.xyz",
    "shut.name",
    "shut.ws",
    "shuttee.com",
    "shutterupsports.com",
    "shutupandbet.com",
    "shved-auto.ru",
    "shvejnyevojska.ru",
    "shwetaungcement.org",
    "shwg.de",
    "shwnshops.com",
    "shy5mz.us",
    "shyamguesthouse.icu",
    "shyguymlm.com",
    "shyuanjing.com",
    "si7kuh5p7hghha7.xyz",
    "si94ve.com",
    "sialkotcity.com",
    "sialkotian.com",
    "sialkotoye.com",
    "siambretta.com",
    "siamhd.com",
    "sianautocentre.com",
    "siapaitu.online",
    "siararab.cf",
    "siararab.gq",
    "siararab.tk",
    "siavisos.com",
    "sib-podarki.ru",
    "sib3.xyz",
    "sibc6f.site",
    "siberask.com",
    "siberiancontext.online",
    "siberiasite.ru",
    "sibirskiereki.ru",
    "siblaka.ga",
    "siblaka.tk",
    "sibliecent.cf",
    "sibliecent.ml",
    "sibliecent.tk",
    "sibmail.com",
    "siboneycubancuisine.com",
    "sibphistband.cf",
    "sibphistband.gq",
    "sibphistband.ml",
    "sibphistband.tk",
    "sibtehnosnab.ru",
    "sibulifi.shop",
    "siburabem.host",
    "sicamail.ga",
    "sicasa.casa",
    "sicherere-verbindungen.xyz",
    "sicheresleben.com",
    "sichtdtelar.ga",
    "sichtdtelar.gq",
    "sicure.gq",
    "sicurello.website",
    "sid63.space",
    "sidamail.ga",
    "siddhacademy.com",
    "sidebysidecycle.com",
    "sidelka-msk.ru",
    "sidelka-mytischi.ru",
    "sidelka-pogilie24.ru",
    "sidelkadlyalezhachego.ru",
    "siderurgybu.info",
    "sidetech.info",
    "sidhutravel.com",
    "sidlece.xyz",
    "sidosa.info",
    "siegeshin.us",
    "siegesteam.buzz",
    "siejieriau.info",
    "siejieriau.org",
    "siejieriau.xyz",
    "siembrahotel.com",
    "sienna12bourne.ga",
    "siennajones.buzz",
    "siennazolman.com",
    "sieprogoun.cf",
    "sieprogoun.ga",
    "sieprogoun.ml",
    "sieprogoun.tk",
    "sieprovev.cf",
    "sieprovev.gq",
    "sierra-leone.com",
    "sieteluchas.com",
    "sieuthidvd.com",
    "sieuthifb.work",
    "sieuthimayhutbui.website",
    "sieuthirau.website",
    "sieuthitihon.com",
    "sieviatoua.cf",
    "sieviatoua.ga",
    "sieviatoua.tk",
    "siftportal.ru",
    "sify.com",
    "sigarapazari.xyz",
    "sigaret.net",
    "sigarety.info",
    "sigbackmi.cf",
    "sigbackmi.ga",
    "sigbackmi.gq",
    "sigbackmi.ml",
    "sigbackmi.tk",
    "sighspecuab.cf",
    "sighspecuab.gq",
    "sighspecuab.tk",
    "sightcoas.xyz",
    "sightdir.com",
    "sighzove.cf",
    "sighzove.ga",
    "sighzove.gq",
    "sighzove.tk",
    "sigmabestshop.online",
    "sign-up.website",
    "signal.best",
    "signal.sale",
    "signal.tools",
    "signaled.live",
    "signaled.pro",
    "signaled.us",
    "signals.reviews",
    "signals.sale",
    "signalstore.ru",
    "signaltoto.com",
    "signaltoto.net",
    "signatureburgerculvercity.com",
    "signaturefencecompany.com",
    "signaturehomegroup.net",
    "signdastsaq.cf",
    "signdastsaq.ga",
    "signdastsaq.gq",
    "signintoemail.net",
    "signnanlu.ga",
    "signnanlu.tk",
    "signstaller.com",
    "signstallers.info",
    "signstallers.net",
    "signstallers.org",
    "signup.vote",
    "sihirfm.net",
    "sihupe.info",
    "siirtfirmarehberi.xyz",
    "siis3s18lwdax43.xyz",
    "siitk.live",
    "sijeeri.cf",
    "sijeeri.ga",
    "sijeeri.tk",
    "sika3.com",
    "sikataja.tech",
    "sikatan.co",
    "sikauni.com",
    "sikdar.site",
    "sikharchives.com",
    "sikinchel.info",
    "sikis31.com",
    "sikomo.cf",
    "sikomo.ga",
    "sikomo.gq",
    "sikomo.ml",
    "sikomo.tk",
    "sikseydin.info",
    "sikuder.me",
    "sikumedical.com",
    "sikux.com",
    "silaaccounting.com",
    "silacon.com",
    "silahkanbeli.com",
    "silaleg.cf",
    "silaleg.gq",
    "silaleg.tk",
    "silda8vv1p6qem.cf",
    "silda8vv1p6qem.ga",
    "silda8vv1p6qem.gq",
    "silda8vv1p6qem.ml",
    "silda8vv1p6qem.tk",
    "sildalis.website",
    "silencejunb.email",
    "silent-art.ru",
    "silentdarkness.net",
    "silentsuite.com",
    "silesian.design",
    "silicimhyr.space",
    "silico.llc",
    "silicolens.com",
    "siliconarabia.com",
    "siliconboost.com",
    "siliconvip.com",
    "silimo.rocks",
    "siliwangi.ga",
    "silkbrush.net",
    "silkbrush.us",
    "silkbrushes.biz",
    "silkbrushes.com",
    "silkbrushes.net",
    "silkbrushes.us",
    "silkgram.xyz",
    "silkroad.net",
    "sillver.us",
    "silmond.com",
    "silnie-privoroti.ru",
    "silpay3s.ru",
    "silsilah.life",
    "silver-bullet.se",
    "silver-liningcleaning.com",
    "silvercheck.xyz",
    "silvercoin.life",
    "silverflare.com",
    "silverfox.dev",
    "silverfox.icu",
    "silverfoxpocket.com",
    "silvergoldbull.global",
    "silverlinecap.com",
    "silverliningreflections.com",
    "silverpromask.com",
    "silverseacruises.org",
    "silverstarmarine.com",
    "silviadistefano.it",
    "sim-simka.ru",
    "sim25.com",
    "simaenaga.com",
    "simari.tk",
    "simasdia.cf",
    "simasdia.ga",
    "simasdia.tk",
    "simba88club.com",
    "simba88play.com",
    "simbamail.fm",
    "simbet33.com",
    "simbet55.com",
    "simbet66.com",
    "simbolospatrios.info",
    "simbos.pro",
    "simcity.hirsemeier.de",
    "simcoepainting.com",
    "simemia.co",
    "simonsen.dk",
    "simonstreams.live",
    "simpacked.com",
    "simpgava.ga",
    "simpgava.gq",
    "simple-dinner-recipes.com",
    "simple-url.com",
    "simplebox.email",
    "simplebrackets.com",
    "simplebt.com",
    "simplecoffeehouse.com",
    "simpledress.online",
    "simpleemail.in",
    "simpleemail.info",
    "simplehouseexit.com",
    "simpleitsecurity.info",
    "simplejourneyguide.com",
    "simplelifetimeincome.com",
    "simplelifthub.com",
    "simplelogin.com",
    "simplemail.in",
    "simplemail.top",
    "simplenews.info",
    "simplepaylink.com",
    "simplepeacock.com",
    "simplesport.ru",
    "simpleverification.com",
    "simpleverni.icu",
    "simplictylegal.com",
    "simply.cheap",
    "simply4seniors.com",
    "simplyamulet.ru",
    "simplyaremailer.info",
    "simplydelivered.online",
    "simplyfireworksdirect.com",
    "simplypottytrain.com",
    "simplysweeps.org",
    "simplytastythaijax.com",
    "simplythcfreecbd.com",
    "simplyui.com",
    "simpsmarex.cf",
    "simpsmarex.ga",
    "simpsmarex.gq",
    "simpsmarex.tk",
    "simrig.shop",
    "simscity.cf",
    "simsession.com",
    "simsmail.ga",
    "simtoanquoc.com",
    "simu.solar",
    "simulink.cf",
    "simulink.ga",
    "simulink.gq",
    "simulink.ml",
    "sin.cl",
    "sin88.org",
    "sina.cn",
    "sina.com",
    "sina.com.cn",
    "sinalke.cf",
    "sinalke.ga",
    "sinalke.gq",
    "sinalke.tk",
    "sinamail.com",
    "sinangokergoz.com",
    "sincanankara.xyz",
    "sincankombiteknikservisi.com",
    "sincitymurrcon.org",
    "sincroaste.com",
    "sinda.club",
    "sindhcollegeeducation.com",
    "sindu.org",
    "sinema.ml",
    "sinemalab.com",
    "sinfiltro.cl",
    "singapore.com",
    "singaporetriennale.com",
    "singatoto.net",
    "single-lady-looking-for-man.club",
    "singleearbud.com",
    "singleearphone.com",
    "singles-day.global",
    "singles4jesus.com",
    "singlespride.com",
    "singlesx.site",
    "singlex.site",
    "singlexx.site",
    "singmail.com",
    "singnet.com.sg",
    "singotes.xyz",
    "singpost.com",
    "singpost.space",
    "singpost.website",
    "singssungg.faith",
    "singtechsingapore.com",
    "singulptxr.online",
    "singyeang.com",
    "sinhsins.shop",
    "sinhvien.asia",
    "sink.fblay.com",
    "sinkingbody.com",
    "sinkorswimcg.com",
    "sinnlichemittel.info",
    "sinnlos-mail.de",
    "sinnott.us",
    "sino.tw",
    "sinology.com",
    "sinomd.com",
    "sinopite.xyz",
    "sinopotocilingir.xyz",
    "sinplefx.com",
    "sinplego.com",
    "sinsinfo.com",
    "sinterklaasactie.net",
    "sinvis.ru",
    "sinyomail.gq",
    "sio.midco.net",
    "siofreelan.cf",
    "siofreelan.ga",
    "siofreelan.gq",
    "siofreelan.ml",
    "siofreelan.tk",
    "siomangwezinationalpark.org",
    "siononpa.cf",
    "siononpa.ga",
    "siononpa.gq",
    "siononpa.ml",
    "sionumin.monster",
    "siosfatuat.cf",
    "siosfatuat.tk",
    "siostocet.ga",
    "siostocet.ml",
    "siostocet.tk",
    "siouxvalley.net",
    "sipbone.com",
    "siphonula.best",
    "sipinitial.top",
    "sippingonhistory.org",
    "sir1ddnkurzmg4.cf",
    "sir1ddnkurzmg4.ga",
    "sir1ddnkurzmg4.gq",
    "sir1ddnkurzmg4.ml",
    "sir1ddnkurzmg4.tk",
    "sirf.ong",
    "sirhenibushveldcamp.com",
    "siri-dublin.com",
    "sirihealthcare.com",
    "sirindia.com",
    "siriuscoffee.online",
    "sirjan.shop",
    "sirji.ru",
    "sirostand.site",
    "sirplusplus.com",
    "sirr.de",
    "sis-informatique.com",
    "sis52.xyz",
    "sisahy.info",
    "sisipizzatakeaway.com",
    "sisko7.com",
    "sislietfal2kbb.xyz",
    "sislovesme.pro",
    "sismeyapi.com",
    "sissyproducts.com",
    "sistemasderadiocomunicacionaxc.com",
    "sisterjaneshop.com",
    "sistewep.online",
    "sisvode.cf",
    "sisvode.ga",
    "sisvode.ml",
    "site-566g.online",
    "site-bites.design",
    "site-flowers.ru",
    "site-imperial.ru",
    "site-recette.com",
    "site-student.online",
    "site-value.us",
    "site24.site",
    "site2apps.com",
    "site4you.site",
    "siteasa.website",
    "sitefilm10.xyz",
    "sitegoooroo.com",
    "sitehost.shop",
    "sitehosting.shop",
    "sitenet.site",
    "sitengin.com",
    "siteparis.com",
    "sitepenguin.com",
    "siteposter.net",
    "sitereplicator.net",
    "sitersz.site",
    "sites4friends.com",
    "sitetechnician.com",
    "sitetosite.site",
    "sitetwass.fun",
    "sitkowskischool.com",
    "sitlicou.cf",
    "sitlicou.ml",
    "sitlicou.tk",
    "sitnicely.com",
    "sitnjoybalivillas.com",
    "sitoautos.info",
    "sitolowcost.com",
    "sitroningdown.website",
    "sitss.biz",
    "situationwa.email",
    "situsbandarqiu.website",
    "situsbola88.asia",
    "situsjudibola88.com",
    "situsjudionline.rocks",
    "situsoke.online",
    "situspoker.monster",
    "situspokergo.info",
    "situspokergo.net",
    "siuleong.com",
    "siundcu.com",
    "siux3aph7ght7.cf",
    "siux3aph7ght7.ga",
    "siux3aph7ght7.gq",
    "siux3aph7ght7.ml",
    "siux3aph7ght7.tk",
    "sivago.xyz",
    "sivasakthitravels.xyz",
    "sivasgrandmasaldugunsarayi.com",
    "sivashaberci.xyz",
    "sivashaykoop.com",
    "sivasisitmeengelliler.com",
    "sivasliderfm.xyz",
    "sivasligardaslar.xyz",
    "sivassecimanketi.com",
    "sivasspo.xyz",
    "sivassporluyuz.xyz",
    "sivasticaretmerkezi.xyz",
    "siverekkuce.xyz",
    "sivtmwumqz6fqtieicx.ga",
    "sivtmwumqz6fqtieicx.gq",
    "sivtmwumqz6fqtieicx.ml",
    "sivtmwumqz6fqtieicx.tk",
    "sivu.site",
    "sivwb.us",
    "siwonmail.com",
    "six-six-six.cf",
    "six-six-six.ga",
    "six-six-six.gq",
    "six-six-six.ml",
    "six-six-six.tk",
    "sixbeagle.com",
    "sixfgasgdo.ga",
    "sixfgasgdo.gq",
    "sixfgasgdo.ml",
    "sixfgasgdo.tk",
    "sixfigureactions.com",
    "sixhappinessbettystown.com",
    "sixpackdifference.com",
    "sixsharp.com",
    "sixsigmaconsultants.com",
    "sixt7.com",
    "sixteenmeasures.dev",
    "sixthsolid.com",
    "sixtptsw6f.cf",
    "sixtptsw6f.ga",
    "sixtptsw6f.gq",
    "sixtptsw6f.ml",
    "sixtptsw6f.tk",
    "sixtysixx-winter-sale.ru",
    "sixxx.ga",
    "sixyxi.cf",
    "sixyxi.tk",
    "siyahsarimsak.info",
    "siyahsarimsak.online",
    "siyahsarimsakresmi.site",
    "siyahsarimsaksatis.info",
    "siyamkhanbd.tk",
    "siyerrehberi.xyz",
    "siyeu.com",
    "sizespeed.com",
    "sizeviewtrading.com",
    "sizincarsi.xyz",
    "sizzlemctwizzle.com",
    "sizzmurke.cf",
    "sizzmurke.ga",
    "sizzmurke.ml",
    "sj206.com",
    "sj20bt.net",
    "sjck.icu",
    "sjl0ec.us",
    "sjmcfaculty.org",
    "sjnq9o.us",
    "sjokbl.shop",
    "sjp.nyc",
    "sjqmiihs.shop",
    "sjrajufhwlb.cf",
    "sjrajufhwlb.ga",
    "sjrajufhwlb.gq",
    "sjrajufhwlb.ml",
    "sjrajufhwlb.tk",
    "sjuaq.com",
    "sjukvardsmaterial.se",
    "sjwg.us",
    "sjzetyy.com",
    "sk-vodoley.ru",
    "sk6859.com",
    "ska1218.ru",
    "skaba.xyz",
    "skachat-888poker.ru",
    "skadel.xyz",
    "skafan.com",
    "skafi.xyz",
    "skagen.xyz",
    "skaipopia.space",
    "skalcongress.com",
    "skalith.xyz",
    "skamia.xyz",
    "skandiasport.com",
    "skanu.xyz",
    "skanyx.xyz",
    "skaram.host",
    "skateboarding-aficionados.com",
    "skatingequipment.org",
    "skavo.xyz",
    "skbhcnai.shop",
    "skdl.de",
    "skechers-store.net",
    "skechers-store.site",
    "skedelweiss.ru",
    "skedules.com",
    "skeefmail.com",
    "skeleton.us",
    "skeletoncoastnationalpark.com",
    "skellbox.ru",
    "skema.edu",
    "skerin.com",
    "sketchlib.ru",
    "sketchlord.com",
    "skettiobo.gq",
    "skettiobo.ml",
    "skettiobo.tk",
    "skfmfr.fun",
    "skg3qvpntq.cf",
    "skg3qvpntq.ga",
    "skg3qvpntq.ml",
    "skg3qvpntq.tk",
    "skgtvp.us",
    "skh.kim",
    "skh.one",
    "skhlist.net",
    "skhnlm.cf",
    "skhnlm.ga",
    "skhnlm.gq",
    "skhnlm.ml",
    "skhstudio.com",
    "ski-larosiere.com",
    "skiagram.xyz",
    "skideo.xyz",
    "skidubaimoments.com",
    "skifi.xyz",
    "skifrance.website",
    "skifsmm.ru",
    "skigh.net",
    "skilaphab.cf",
    "skilaphab.gq",
    "skilaphab.ml",
    "skillion.org",
    "skillion.store",
    "skillionebikes.com",
    "skillmachine.net",
    "skillsprivateacademy.net",
    "skillsprivatetutoring.net",
    "skilltag.com",
    "skilsiri.ga",
    "skilsiri.gq",
    "skim.com",
    "skimba.xyz",
    "skimlinks.site",
    "skin-barone.site",
    "skin-therapy.shop",
    "skinadvancedstore.com",
    "skinaspoun.cf",
    "skinaspoun.ml",
    "skinaspoun.tk",
    "skinbionom.com",
    "skincareadvises.com",
    "skindu.xyz",
    "skinnyhandw.com",
    "skinnyskinnysoaps.com",
    "skinoodle.xyz",
    "skinrustz.fun",
    "skinsboom.xyz",
    "skinsjar.icu",
    "skinsosmoothpro.com",
    "skinsuction.com",
    "skinti.xyz",
    "skinzrust.fun",
    "skipbot.xyz",
    "skipbyte.xyz",
    "skiphire.network",
    "skiprnet.com",
    "skishop24.de",
    "skittlrrcd.space",
    "skiwgeoslav.gq",
    "skiwhivap.ga",
    "skiwhivap.ml",
    "skiwhivap.tk",
    "skizo.hu",
    "skkk.edu.my",
    "sklazer.ru",
    "sklep-motocyklowy.xyz",
    "skm-ritual.ru",
    "skodaauto.cf",
    "skoghallpirates.se",
    "skokiecpa.net",
    "skolioz.info",
    "skomedlys.com",
    "skoozipasta.com",
    "skor72.online",
    "skorbola.club",
    "skorbolaeuro.net",
    "skorcomp.ru",
    "skore.org",
    "skorexpres.com",
    "skoronaekane.ru",
    "skoshkami.ru",
    "skqmph.fun",
    "skqmtf.fun",
    "skra.de",
    "skrattonnet.se",
    "skrenvar.com",
    "skrivnu.dk",
    "skrmgx.fun",
    "skrmsw.fun",
    "skrx.tk",
    "sksfullskin.ga",
    "sksmgc.fun",
    "sktmzg.fun",
    "skummi-service.ru",
    "skunkapps.com",
    "skunkbox.com",
    "skurkcasino.se",
    "skv-object.ru",
    "skvorets.com",
    "skwbet.info",
    "skxmdx.fun",
    "skxmh.com",
    "sky-grad.com",
    "sky-inbox.com",
    "sky-mail.ga",
    "sky-ts.de",
    "sky.com",
    "sky.dnsabr.com",
    "skyadvert.info",
    "skybahis.info",
    "skybahis11.com",
    "skybahisyenigiris.com",
    "skybestyool.site",
    "skycityproductions.com",
    "skycustomhomes.com",
    "skydragon112.cf",
    "skydragon112.ga",
    "skydragon112.gq",
    "skydragon112.ml",
    "skydragon112.tk",
    "skydrive.tk",
    "skyfi.org.ru",
    "skyflowers.info",
    "skyflyhd.com",
    "skyhard.online",
    "skyinet.net",
    "skylablearning.com",
    "skymail.gq",
    "skymailapp.com",
    "skymailgroup.com",
    "skymountbahamas.com",
    "skymountgovernmentservices.com",
    "skymovieshd.space",
    "skymovieshd.store",
    "skynet.be",
    "skynetfli.xyz",
    "skynetflix.xyz",
    "skyoid.xyz",
    "skyometric.com",
    "skypaluten.de",
    "skyrtiador.ga",
    "skyrtiador.tk",
    "skyterracecondos.com",
    "skytopconstruction.info",
    "skytopconstruction.net",
    "skytowerwindows.com",
    "skyvendersar.website",
    "skyvia.info",
    "skyworldtech.com",
    "skz.us",
    "skzc.net",
    "skzmzs.fun",
    "skzokgmueb3gfvu.cf",
    "skzokgmueb3gfvu.ga",
    "skzokgmueb3gfvu.gq",
    "skzokgmueb3gfvu.ml",
    "skzokgmueb3gfvu.tk",
    "sl-ph.com",
    "slaappleks.info",
    "slabefotke.com",
    "slack.best",
    "slambanglodge.com",
    "slamdunkfan.com",
    "slane-kebabish-takeaway.com",
    "slane-kebabish.com",
    "slantmean.us",
    "slantta.icu",
    "slapsfromlastnight.com",
    "slaskpost.rymdprojekt.se",
    "slaskpost.se",
    "slatmolda.cf",
    "slatmolda.ga",
    "slatmolda.ml",
    "slaughsages.com",
    "slave-auctions.net",
    "slayam.site",
    "slayress.com",
    "sldindustries.com",
    "sledhoops.net",
    "sleeck.website",
    "sleepary.com",
    "sleepeasy.club",
    "sleeperout.ga",
    "sleeperout.tk",
    "sleepesder.gq",
    "sleepesder.ml",
    "sleepesder.tk",
    "sleepimportance.com",
    "sleepinggiantliving.com",
    "sleeprevital.com",
    "sleepy.dk",
    "sleepyninjagames.com",
    "slefcare.com",
    "sleij.host",
    "slekepeth78njir.ga",
    "sleppersl.xyz",
    "slexpress.ru",
    "slfmade.media",
    "slgd.icu",
    "slicediceandspiceny.com",
    "sliceottawa.com",
    "slicescheadle.com",
    "slicesl.xyz",
    "slicesle.xyz",
    "sliceslee.xyz",
    "slickriffs.co.uk",
    "slidegl.xyz",
    "slidegla.xyz",
    "slidejud.site",
    "slideshowapp.net",
    "slikroad.show",
    "slim-geld-lenen.info",
    "slimagic.pro",
    "slimboefje.online",
    "slimdown1.ru",
    "slimdown1.site",
    "slimeangl.email",
    "slimeco.xyz",
    "slimecrea.xyz",
    "slimefi.xyz",
    "slimefina.xyz",
    "slimeke03.site",
    "slimfort.ru",
    "slimkasinos.website",
    "slimmepil.com",
    "slimmer.cloud",
    "slimmex.info",
    "slimor.site",
    "slimwaists.fun",
    "slimwaists.space",
    "slimwaits.space",
    "slingomother.ru",
    "slingshot.co.nz",
    "slingshot.com",
    "slinng.ru",
    "sliped.com",
    "slippery.email",
    "slippinband.com",
    "slipry.net",
    "slipshore.com",
    "slipunob.cf",
    "slipunob.gq",
    "slipunob.ml",
    "slitko.xyz",
    "slittrbmbz.space",
    "sliv-cash.ru",
    "slivap.com",
    "slivmag.ru",
    "slivtika.cf",
    "slivtika.gq",
    "slivtika.ml",
    "slix.dev",
    "sljcsb.com",
    "slkjghsx77sx.ru",
    "slmshf.cf",
    "slo.net",
    "slobodanetivana.com",
    "slofuxhl.pro",
    "slogangraduateperforate.website",
    "slogramming.com",
    "slopeintend.com",
    "slopjockeys.com",
    "slopsbox.com",
    "slopsegrex.space",
    "slot118.org",
    "slot7.club",
    "slot7.fun",
    "slot889.net",
    "slotbet24.bet",
    "slothmail.net",
    "slotino.xyz",
    "slotobet.win",
    "slotogod.club",
    "slotojam.com",
    "slotoking.city",
    "slotoking.live",
    "slotopin.fun",
    "slotopin.online",
    "slotopin.website",
    "slotorotation.site",
    "slotozal-casino.win",
    "slotreward.com",
    "slotrotation.icu",
    "slots4you.ru",
    "slotsawasdee.net",
    "slotsbestproffit.ru",
    "slotsrasafe.space",
    "slotstation26.com",
    "slotstation29.com",
    "slotstation3.com",
    "slotstation30.com",
    "slotstation35.com",
    "slotstation39.com",
    "slotter.com",
    "slotticaksn.online",
    "slottojam.casino",
    "slottojam1.com",
    "slottojam21.com",
    "slottojam28.com",
    "slovect.pro",
    "slovenianschool.info",
    "slovinskylawoffice.com",
    "slovmeralgl.site",
    "slowfoodfoothills.xyz",
    "slowgramming.com",
    "slowslow.de",
    "sls.us",
    "slsp10.xyz",
    "slsrs.ru",
    "sltmail.com",
    "sltng.com",
    "slu21svky.com",
    "slugmail.ga",
    "slumppeac.icu",
    "slumpwat.email",
    "slushmail.com",
    "slushyhut.com",
    "sluteen.com",
    "slutty.horse",
    "slvbus.com",
    "slwedding.ru",
    "slwyqbu.com",
    "sly.io",
    "sm.westchestergov.com",
    "sm51qc.info",
    "smaakt.naar.gravel",
    "smaekets.com",
    "smahtin.ru",
    "smailpro.com",
    "smallanawanginbeach.com",
    "smallbizla.com",
    "smallbizloans.xyz",
    "smallbudg.xyz",
    "smallbusinessacct.info",
    "smallbusinessacct.us",
    "smallbusinessmindset.com",
    "smallbusinessownergrants.com",
    "smallbusinessseoagency.com",
    "smallcleaningbrush.com",
    "smallcleaningbrush.org",
    "smallcleaningbrush.us",
    "smallcleaningbrushes.com",
    "smallcleaningbrushes.org",
    "smallcleaningbrushes.us",
    "smallcolor.store",
    "smallcrud.email",
    "smallfrank.com",
    "smallgroups.app",
    "smallironabsorption.website",
    "smallker.tk",
    "smallpe.icu",
    "sman14kabtangerang.site",
    "smanual.shop",
    "smanual.site",
    "smap.4nmv.ru",
    "smapfree24.com",
    "smapfree24.de",
    "smapfree24.eu",
    "smapfree24.info",
    "smapfree24.org",
    "smapxsmap.net",
    "smardebtra.ga",
    "smardebtra.gq",
    "smardebtra.ml",
    "smardebtra.tk",
    "smaretboy.pw",
    "smarshevent.com",
    "smart-1-shop.online",
    "smart-10-shop.online",
    "smart-11-shop.online",
    "smart-13-shop.online",
    "smart-19-shop.online",
    "smart-20-shop.online",
    "smart-21-shop.online",
    "smart-23-shop.online",
    "smart-25-shop.online",
    "smart-27-shop.online",
    "smart-28-shop.online",
    "smart-29-shop.online",
    "smart-32-shop.online",
    "smart-33-shop.online",
    "smart-35-shop.online",
    "smart-4-shop.online",
    "smart-5-shop.online",
    "smart-6-shop.online",
    "smart-7-shop.online",
    "smart-email.me",
    "smart-intentions.site",
    "smart-mail.info",
    "smart-mail.top",
    "smart-mask.online",
    "smart-medic.ru",
    "smart-movie.biz",
    "smartalls.ru",
    "smartbee.website",
    "smartbusiness.me",
    "smartcharts.pro",
    "smartdedicated.site",
    "smartdigitalone.com",
    "smarteu.site",
    "smartfotobudka.ru",
    "smartfuture.space",
    "smarthq.com",
    "smartify.homes",
    "smartinstaprint.online",
    "smartintentions.site",
    "smartmasterkz.ru",
    "smartmobility2016.shop",
    "smartnator.com",
    "smartphoneaddictionprogram.com",
    "smartphonedangers.site",
    "smartphonescreen.ru",
    "smartphonesukraine.ru",
    "smartphonesukraine.website",
    "smartpikes.site",
    "smartpranks.com",
    "smartpro.tips",
    "smartshop.futbol",
    "smarttalent.pw",
    "smarttestztn.site",
    "smarttipsannie.com",
    "smarttrut.space",
    "smarttvshop.life",
    "smartvanlines.com",
    "smartvds.xyz",
    "smartvp.xyz",
    "smartvps.xyz",
    "smartvs.xyz",
    "smartwatch-9.ru",
    "smartworkcenter013.nl",
    "smartworldaccountants.com",
    "smartyzaim.store",
    "smashchao.fun",
    "smashmail.de",
    "smashtherecord.com",
    "smbc-card.xyz",
    "smcalv.host",
    "smellfear.com",
    "smellqu.xyz",
    "smellrear.com",
    "smellri.xyz",
    "smellslikehypocrisy.com",
    "smellypotato.tk",
    "smeltitdealtit.com",
    "smena-rabota.ru",
    "smetenzonenpromoties.site",
    "smfg-law.com",
    "smh08888.com",
    "smh18888.com",
    "smh24-news.site",
    "smh38888.com",
    "smh78888.com",
    "smi.ooo",
    "smile-king.site",
    "smilefaceexpression.com",
    "smilevxer.com",
    "smileyet.tk",
    "smileyface.com",
    "smileyface.comsmithemail.net",
    "smime.ninja",
    "sminicca.gq",
    "sminicca.tk",
    "sminkymail.com",
    "smirusn6t7.cf",
    "smirusn6t7.ga",
    "smirusn6t7.gq",
    "smirusn6t7.ml",
    "smirusn6t7.tk",
    "smithandjones.us",
    "smithemail.net",
    "smithfieldkebabhouse.com",
    "smithinsurer.com",
    "smithschevron.net",
    "smldv.ru",
    "smlmail.com",
    "smlmail.net",
    "smm-drom.ru",
    "smnagyaw.shop",
    "smokdunyasi.xyz",
    "smoke-allnight.ru",
    "smoke-hollow.org",
    "smokedril.press",
    "smokehollow.org",
    "smokehollowsmokers.com",
    "smokeli.icu",
    "smokemarket.org",
    "smokengunsmusic.com",
    "smokeru.us",
    "smokestackhobbyshop.com",
    "smoketoas.email",
    "smokeyridgewinery.com",
    "smokingcessationandpregnancy.org",
    "smokinwingsspartanburg.com",
    "smoklounge.ru",
    "smokovik.com",
    "smoksigara.xyz",
    "smokymountain.guide",
    "smokymountain.shop",
    "smokymountain.store",
    "smokymountains.shop",
    "smoothmail.com",
    "smosh.org",
    "smotret-video.ru",
    "smotretvideotut.ru",
    "smotry-v-glaza.ru",
    "smoug.net",
    "smrltd.xyz",
    "smrn420.com",
    "smrtwyt.site",
    "sms-analytical.net",
    "sms-analytical.org",
    "sms-express.us",
    "sms.at",
    "smsanalytical.net",
    "smsazart.ru",
    "smsbaka.ml",
    "smscashpro.xyz",
    "smsforum.ro",
    "smsplanets.net",
    "smswan.com",
    "smtp.docs.edu.vn",
    "smtp.ru",
    "smtp33.com",
    "smtp99.com",
    "smugarur.gq",
    "smugarur.ml",
    "smugarur.tk",
    "smuguk.com",
    "smuktliv.com",
    "smuse.me",
    "smwg.info",
    "smyrnaattorneys.com",
    "smzppk.shop",
    "sn-em.com",
    "sn3bochroifalv.cf",
    "sn3bochroifalv.ga",
    "sn3bochroifalv.gq",
    "sn3bochroifalv.ml",
    "sn3bochroifalv.tk",
    "sn55nys5.cf",
    "sn55nys5.ga",
    "sn55nys5.gq",
    "sn55nys5.ml",
    "sn55nys5.tk",
    "snabbel.app",
    "snack-bar.name",
    "snack-bar.us",
    "snackbar.name",
    "snackfood.com.cn",
    "snackmango.com",
    "snad1faxohwm.cf",
    "snad1faxohwm.ga",
    "snad1faxohwm.gq",
    "snad1faxohwm.ml",
    "snad1faxohwm.tk",
    "snafoss.com",
    "snag.org",
    "snaganautoloan.com",
    "snahandric.icu",
    "snail-mail.net",
    "snail-mail.ney",
    "snailda.xyz",
    "snaipau.online",
    "snajtv.us",
    "snakebite.com",
    "snakecharm.ru",
    "snakeiptv.live",
    "snakemail.com",
    "snakket.com",
    "snaknoc.cf",
    "snaknoc.ga",
    "snaknoc.gq",
    "snaknoc.ml",
    "snam.cf",
    "snam.ga",
    "snam.gq",
    "snam.tk",
    "snamaii.ru",
    "snap.monster",
    "snapbet20.xyz",
    "snapbet2020.xyz",
    "snapbett.xyz",
    "snapblack.site",
    "snapbrentwood.org",
    "snapfish77.com",
    "snapfishhsn.com",
    "snapfishvaluepass.com",
    "snapmaps360.com",
    "snapmoms.org",
    "snappedly.xyz",
    "snapunit.com",
    "snapwet.com",
    "snasu.info",
    "snazzysnoodsandmore.com",
    "sncnsl.site",
    "sndae5.us",
    "sndbtp.host",
    "sndt.net",
    "sneakalfi.cf",
    "sneakalfi.gq",
    "sneakalfi.ml",
    "sneakemail.com",
    "sneakerbunko.cf",
    "sneakerbunko.ga",
    "sneakerbunko.gq",
    "sneakerbunko.ml",
    "sneakerbunko.tk",
    "sneakerhub.ru",
    "sneakmail.de",
    "sneeuwbeukers.online",
    "snellerherstel.nu",
    "snelschilder.com",
    "snet.net",
    "sngcentric.com",
    "sngcom.ru",
    "snif-acc.online",
    "snikersrules.ru",
    "snip.net",
    "snip707.com",
    "snipbingra.ga",
    "snipbingra.gq",
    "snipbingra.tk",
    "sniper.hu",
    "snipsandiego.org",
    "snkmail.com",
    "snkml.com",
    "snkno.com",
    "snkplayer.com",
    "snkqun.com",
    "snktop.com",
    "snl9lhtzuvotv.cf",
    "snl9lhtzuvotv.ga",
    "snl9lhtzuvotv.gq",
    "snl9lhtzuvotv.ml",
    "snl9lhtzuvotv.tk",
    "snmotcpg.shop",
    "snncnaydin.xyz",
    "snobbob.com",
    "snocespalk.icu",
    "snollygoster.space",
    "snoofi-shop.ru",
    "snoom.com",
    "snoopymail.com",
    "snoosnot.shop",
    "snoppeak.us",
    "snorcoundo.cf",
    "snorcoundo.ga",
    "snorcoundo.ml",
    "snore-therapy.com",
    "snotis.icu",
    "snotsnoo.shop",
    "snouy.ru",
    "snovosty.ru",
    "snowbirdsfloridausdaytracker.com",
    "snowboarding.com",
    "snowboots.site",
    "snowcrest.net",
    "snowdenlimited.com",
    "snowdonia.net",
    "snowf0x.com",
    "snowflakescustomjewelry.xyz",
    "snowprozone.com",
    "snpsex.ga",
    "snqfl.xyz",
    "sns.moe",
    "snugmail.net",
    "snugsconcertseries.com",
    "snytax.host",
    "snz873.com",
    "so-com.tk",
    "so-net.cf",
    "so-net.ga",
    "so-net.gq",
    "so-net.ml",
    "so-simple.org",
    "so1.in",
    "so1ffy.online",
    "so873g.site",
    "soap2day.best",
    "soapa.solutions",
    "soapmarket.com",
    "soaronwings.shop",
    "sobakanazaice.cf",
    "sobakanazaice.ga",
    "sobakanazaice.gq",
    "sobakanazaice.ml",
    "sobakanazaice.tk",
    "sobdollfab.cf",
    "sobdollfab.ga",
    "sobdollfab.gq",
    "sobill247.com",
    "soblaznvip.ru",
    "sobmarinos.info",
    "sobrietybuddyapp.com",
    "sobterstread.cf",
    "sobterstread.ga",
    "sobterstread.ml",
    "soc.vn",
    "socal.rr.com",
    "socalbrewnet.com",
    "socamail.com",
    "socampeoes.com",
    "socbusinesstraining.com",
    "soccer-fanatics.space",
    "soccer365.space",
    "socceracademy.vegas",
    "socceraccess.com",
    "socceramerica.net",
    "soccerazzo.com",
    "soccerfans.space",
    "soccerinstyle.com",
    "soccermail.com",
    "soccermomz.com",
    "soccertop.website",
    "soccertotalstats.com",
    "sochipools.com",
    "social-bookmarking-site.info",
    "social-mailer.tk",
    "socialayz.xyz",
    "socialfresh.website",
    "socialfurry.org",
    "socialimdb.xyz",
    "socialisaso.com",
    "sociallifes.club",
    "sociallinks.info",
    "socialmasta.org",
    "socialmediaepic.com",
    "socialtalker.com",
    "socialtracking.live",
    "socialventuresglobal.com",
    "socialviplata.club",
    "socialworker.net",
    "socialxbounty.info",
    "sociative.xyz",
    "societycampblog.site",
    "societylionnews.club",
    "sociocrisio.com",
    "sociologist.com",
    "sociotasking.online",
    "sociotasking.site",
    "socitude.xyz",
    "sockpockers.com",
    "socksbest.com",
    "sockshare.watch",
    "socprodvizheniye.ru",
    "socratesmuniz.com",
    "socrazy.club",
    "socrazy.online",
    "socvideo.ru",
    "soda55.com",
    "sodalithite.best",
    "sodap4.org",
    "sodatorrent.website",
    "sodertornsfjarrvarme.nu",
    "sodertornsfjarrvarme.se",
    "sodiumysszd.email",
    "soeo4am81j.cf",
    "soeo4am81j.ga",
    "soeo4am81j.gq",
    "soeo4am81j.ml",
    "soeo4am81j.tk",
    "soeveryonecangame.info",
    "sofialenaliving.com",
    "sofian.website",
    "sofimail.com",
    "sofodac.ru",
    "sofolgia.com",
    "sofort-mail.de",
    "sofort.group",
    "sofortmail.de",
    "sofos.host",
    "soft-utorrent.ru",
    "soft4load.xyz",
    "softballball.com",
    "softbank.ne.jp",
    "softbank.tk",
    "softboxtv.ru",
    "softfaber.org",
    "softgel.biz",
    "softhome.net",
    "softistic.net",
    "softistic.org",
    "softkey-office.ru",
    "softonics.site",
    "softpaws.ru",
    "softpls.asia",
    "softswiss.today",
    "softvanria.cf",
    "softvanria.ga",
    "softvanria.gq",
    "softvanria.ml",
    "softviagra.info",
    "software-sekolah.net",
    "software.golf",
    "software315.xyz",
    "softwareaa316.xyz",
    "softwareabilities.com",
    "softwaredeals.site",
    "softwareengineer.info",
    "softwareprofs.dev",
    "softwaresekolah.net",
    "softwareversus.com",
    "softwash.xyz",
    "softwiretechnology.com",
    "soganliadaklikkurban.online",
    "soganliadaklikkurban.xyz",
    "sogetthis.com",
    "soglasie.info",
    "sogopo.ga",
    "sogopo.ml",
    "sogopo.tk",
    "sogou.com",
    "sohai.ml",
    "sohbet10.com",
    "sohbet17.com",
    "sohbetac.com",
    "sohbetamk.xyz",
    "sohbethattibu.xyz",
    "sohosale.com",
    "sohu.com",
    "sohu.net",
    "sohufre.gq",
    "sohufre.ml",
    "sohus.cn",
    "soillost.us",
    "soiloptimizer.com",
    "soioa.com",
    "soisz.com",
    "soitanve.cf",
    "soitanve.tk",
    "sojnd7.us",
    "sojuqq.com",
    "sokahplanet.com",
    "sokeorganizasyon.xyz",
    "sokolniki.net",
    "sokosquare.com",
    "sokvi.us",
    "sol.dk",
    "solar-apricus.com",
    "solar-impact.pro",
    "solar.pizza",
    "solaraction.network",
    "solarbet99.site",
    "solarclassroom.net",
    "solareclipsemud.com",
    "solaredgelights.com",
    "solaren-power.review",
    "solarflight.org",
    "solarfor99dollars.com",
    "solarforninetyninedollars.com",
    "solarquick.africa",
    "solarwinds-msp.biz",
    "solatint.com",
    "solcon.nl",
    "solddit.com",
    "soldesnice.com",
    "soldier.hu",
    "soldierofthecross.us",
    "soldnmyyb.shop",
    "soleli.com",
    "soleme.info",
    "solidbots.net",
    "solidframework.com",
    "solidframeworks.com",
    "solidgoldop.biz",
    "solidstepper.top",
    "solidtrianglegroup.com",
    "solinvictusguild.com",
    "solioutlets.site",
    "solirallc.com",
    "solitaire-sunshine.com",
    "sollie-legal.online",
    "sollieja.online",
    "solliejuridischadvies.online",
    "solomasks.com",
    "solopreneur365crm.com",
    "solosoloku.com",
    "solotioner.site",
    "solotouchofficial.ru",
    "solotrasmakinasi.site",
    "solovevz.ru",
    "solovyova.org",
    "solu.gq",
    "solu7ions.com",
    "soluje.info",
    "soluteconsulting.com",
    "soluteconsulting.us",
    "solution-space.biz",
    "solution4u.com",
    "solutionsmagazine.org",
    "solutyn.net",
    "solvabbolm.space",
    "solve-anxiety.com",
    "solvedbycitizens.com",
    "solvemail.info",
    "solventtrap.wiki",
    "somaderm.health",
    "somalipress.com",
    "sombra-company.ru",
    "sombracorporation.ru",
    "some.us",
    "somebodyswrong.com",
    "somechoice.ga",
    "somecool.xyz",
    "somera.org",
    "someredirectpartneral.info",
    "someredirectpartnerance.info",
    "someredirectpartnerery.info",
    "someredirectpartnerify.info",
    "someredirectpartnerious.info",
    "someredirectpartnerly.info",
    "someredirectpartneroid.info",
    "someredirectpartnery.info",
    "somethingsirious.com",
    "sometimesbee.top",
    "sommys.space",
    "somonbrand.com",
    "somoslantian.net",
    "somoslantian.org",
    "soms-software.net",
    "son-haber.live",
    "son-haber.site",
    "son-haber.website",
    "sonaluma.com",
    "sonamyr.shop",
    "sonasoft.net",
    "sonata-krasotavn.ru",
    "sonderagency.org",
    "sondwantbas.cf",
    "sondwantbas.tk",
    "sonesont.shop",
    "songart.ru",
    "songbomb.com",
    "songiang.xyz",
    "songjiancai.com",
    "songjianglushi.info",
    "songpong.net",
    "songshuxb.com",
    "songwriter.net",
    "songyangguang.com",
    "sonhaber.fun",
    "sonhaber.live",
    "sonic.net",
    "sonicx-pro.shop",
    "sonifia.site",
    "sonindirimler.xyz",
    "sonnarapp.com",
    "sonnenkinder.org",
    "sonohilight.com",
    "sonophon.ru",
    "sonshi.cf",
    "sonsporttpinup.ru",
    "sontearssat.website",
    "sonu.com",
    "sony4d.best",
    "sony4d.xyz",
    "sonyclub.online",
    "sonytoto.org",
    "soodbet.site",
    "soodbt.club",
    "soodmail.com",
    "soodomail.com",
    "soodonims.com",
    "soogalsudan.com",
    "soombo.com",
    "soon.com",
    "soon.it",
    "soon2open.com",
    "soonerinvestmentsint.com",
    "soonso.com",
    "sooq.live",
    "sootbet90s.org",
    "soozoop.com",
    "sopatrack.com",
    "sophiamartins.online",
    "sophiejenkins.buzz",
    "sopotstyle.com",
    "sopotstyle.xyz",
    "sopowstran.cf",
    "sopowstran.gq",
    "sopowstran.tk",
    "sopranospizzeriawaterford.com",
    "sopsandqs.com",
    "sopuhi.info",
    "sora11.shop",
    "soraly.cf",
    "soraly.gq",
    "soraly.ml",
    "soranet.shop",
    "sorbapackp.space",
    "sorcios.com",
    "sordeti.cf",
    "sordeti.ga",
    "sordeti.ml",
    "sordeti.tk",
    "sordiri.ga",
    "sorensen.dk",
    "soricident.site",
    "soriro.info",
    "soroboutique.site",
    "sororitree.com",
    "sorpresa-continua.info",
    "sorrentos-takeaway.com",
    "sorrownadj.space",
    "sortado.com",
    "sortado.sk",
    "sortgleams.top",
    "sortirlyon.org",
    "soruvi.com",
    "soshanti.org",
    "soslukedi.xyz",
    "sosmanga.com",
    "sosmedpokeronline.net",
    "sosojd.com",
    "sosvoyants.net",
    "sosxao.xyz",
    "sosyalmedyayonetimi.online",
    "sosyalmerlin.online",
    "sosyalmerlin.xyz",
    "sotahmailz.ga",
    "sote-muncete.club",
    "soten.info",
    "sothich.com",
    "sotisoth.shop",
    "sotnwh.shop",
    "soton.ac.uk",
    "sotosegerr.xyz",
    "sotres.ru",
    "sottomarina.org",
    "soudcuvea.cf",
    "soudcuvea.gq",
    "soudcuvea.ml",
    "soudcuvea.tk",
    "soudeel.com",
    "soufflesinlive.com",
    "sougalsudan.com",
    "souhon.com",
    "soukalsudan.com",
    "soulfoodcookbook.com",
    "soulmate-search.com",
    "soundagencystring.website",
    "soundfg.gq",
    "soundmovie.biz",
    "soundofmusicfans.com",
    "soundwid.com",
    "sounlali.cf",
    "sounlali.ml",
    "souqdeal.site",
    "sourcenet.online",
    "sourceri.space",
    "sourcewithimpact.org",
    "sourijboopn.email",
    "sourtrush.site",
    "soushuba.xyz",
    "southamericangenweb.org",
    "southamptonprintings.press",
    "southamptonwebdesign.com",
    "southasianfloods.org",
    "southburyelderlawgroup.com",
    "southcarolina.company",
    "southeastaddictiontreatment.com",
    "southeastasiaheritage.net",
    "southerncloseouts.com",
    "southerndrinking.com",
    "southernhighlandsgolfhomes.com",
    "southernkiving.com",
    "southernlegends.com",
    "southernmovingsystems.com",
    "southernpetservices.com",
    "southernstarsvacations.info",
    "southernup.org",
    "southfloridaprivateinvestigator.com",
    "southfloridaprivateinvestigators.org",
    "southjordanapartments.com",
    "southkorea.dev",
    "southlakeapartments.com",
    "southlaketahoeapartments.com",
    "southmiamirealestateblog.com",
    "southparkmail.com",
    "southpasadenaapartments.com",
    "southphillyrambots.com",
    "southshoreadclub.com",
    "southshoreaudi.net",
    "southshoreauto.net",
    "southshoremotors.net",
    "southshorerover.net",
    "southsidescout.com",
    "soutong001.com",
    "souvlakimalta.com",
    "souvps.com",
    "sovactha.cf",
    "sovactha.ga",
    "sovactha.gq",
    "sovactha.ml",
    "sovactha.tk",
    "sovereignvpn.com",
    "sovietizing684ig.online",
    "sovsem.net",
    "sowmyapatapati.com",
    "sowpropelsea.website",
    "sowvet.org",
    "sowwcharity.org",
    "soxisipa.site",
    "soxivu.info",
    "soxoshops.site",
    "soycasasy.info",
    "soydemkt.com",
    "soyuz-zvezda.ru",
    "sozdanie-websaita.ru",
    "sozfilmi.com",
    "sozialismusoderbarberei.vision",
    "sozzlefdvb.space",
    "sp-aa.com",
    "sp-market.ru",
    "sp.nl",
    "sp.woot.at",
    "spa-fish.ru",
    "spa-resort-lombok.com",
    "spa.com",
    "spacalar.cf",
    "spacalar.ga",
    "space-bank.com",
    "space-company.ru",
    "space-for-dates1.com",
    "space-man.com",
    "space-ship.com",
    "space-to-rent.com",
    "space-travel.com",
    "space.com",
    "spaceart.com",
    "spacebank.com",
    "spacebazzar.ru",
    "spaceepics.com",
    "spaceflowers.ru",
    "spaceinvadas.com",
    "spacemart.com",
    "spacepush.org",
    "spacerust.net",
    "spaceshop.website",
    "spaceterm.info",
    "spacetowns.com",
    "spacewalker.cf",
    "spacewalker.ga",
    "spacewalker.gq",
    "spacewalker.ml",
    "spacewar.com",
    "spaceybodycount.com",
    "spacherry.com",
    "spacibbacmo.lflink.com",
    "spaclick.online",
    "spaereplease.com",
    "spainmail.com",
    "spainreview.net",
    "spaintoday.club",
    "spajek.com",
    "spam-be-gone.com",
    "spam-en.de",
    "spam-nicht.de",
    "spam.2012-2016.ru",
    "spam.9001.ovh",
    "spam.care",
    "spam.coroiu.com",
    "spam.deluser.net",
    "spam.dexter0.xyz",
    "spam.dhsf.net",
    "spam.dnsx.xyz",
    "spam.fassagforpresident.ga",
    "spam.flu.cc",
    "spam.igg.biz",
    "spam.janlugt.nl",
    "spam.jasonpearce.com",
    "spam.la",
    "spam.loldongs.org",
    "spam.lucatnt.com",
    "spam.lyceum-life.com.ru",
    "spam.mccrew.com",
    "spam.netpirates.net",
    "spam.no-ip.net",
    "spam.nut.cc",
    "spam.org.es",
    "spam.ozh.org",
    "spam.pyphus.org",
    "spam.rogers.us.com",
    "spam.shep.pw",
    "spam.su",
    "spam.tla.ro",
    "spam.trajano.net",
    "spam.usa.cc",
    "spam.visuao.net",
    "spam.wtf.at",
    "spam.wulczer.org",
    "spam4.me",
    "spamail.de",
    "spamail.typhon.ga",
    "spamama.uk.to",
    "spamarrest.com",
    "spamassage-nsk.ru",
    "spamavert.com",
    "spambob.com",
    "spambob.net",
    "spambob.org",
    "spambog.com",
    "spambog.de",
    "spambog.net",
    "spambog.ru",
    "spambooger.com",
    "spambox.info",
    "spambox.irishspringrealty.com",
    "spambox.me",
    "spambox.org",
    "spambox.us",
    "spambox.win",
    "spambox.xyz",
    "spamcannon.com",
    "spamcannon.net",
    "spamcero.com",
    "spamcon.org",
    "spamcorptastic.com",
    "spamcowboy.com",
    "spamcowboy.net",
    "spamcowboy.org",
    "spamday.com",
    "spamdecoy.net",
    "spameater.com",
    "spameater.org",
    "spamex.com",
    "spamfighter.cf",
    "spamfighter.ga",
    "spamfighter.gq",
    "spamfighter.ml",
    "spamfighter.tk",
    "spamfree.eu",
    "spamfree24.com",
    "spamfree24.de",
    "spamfree24.eu",
    "spamfree24.info",
    "spamfree24.net",
    "spamfree24.org",
    "spamgoes.in",
    "spamgourmet.com",
    "spamgourmet.net",
    "spamgourmet.org",
    "spamherelots.com",
    "spamhereplease.com",
    "spamhole.com",
    "spamify.com",
    "spaminator.de",
    "spamkill.info",
    "spaml.com",
    "spaml.de",
    "spamlot.net",
    "spammail.me",
    "spammedic.com",
    "spammehere.com",
    "spammehere.net",
    "spammer.fail",
    "spammingemail.com",
    "spammotel.com",
    "spammy.host",
    "spamobox.com",
    "spamoff.de",
    "spamsalad.in",
    "spamserver.cf",
    "spamserver.ga",
    "spamserver.gq",
    "spamserver.ml",
    "spamserver.tk",
    "spamserver2.cf",
    "spamserver2.ga",
    "spamserver2.gq",
    "spamserver2.ml",
    "spamserver2.tk",
    "spamslicer.com",
    "spamspameverywhere.org",
    "spamsphere.com",
    "spamspot.com",
    "spamstack.net",
    "spamthis.co.uk",
    "spamthis.network",
    "spamthisplease.com",
    "spamtrail.com",
    "spamtrap.co",
    "spamtrap.ro",
    "spamtroll.net",
    "spamwc.cf",
    "spamwc.de",
    "spamwc.ga",
    "spamwc.gq",
    "spamwc.ml",
    "spamyourbot.com",
    "spandrel.xyz",
    "spaneger.club",
    "spaniaflyplasstransport.com",
    "spanien-immobilie-kaufen.com",
    "spanienflygplatstransfer.com",
    "spanishprofestore.com",
    "spankthedonkey.com",
    "spapa.ooo",
    "spapaketleri.com",
    "sparc.media",
    "sparfaclust.org",
    "spark-short.ru",
    "sparkaddress.com",
    "sparket.com",
    "sparkgnome.com",
    "sparkgrowthteam.com",
    "sparkles.rocks",
    "sparklogics.com",
    "sparkofone.com",
    "sparkpensions.com",
    "sparkstreet.dev",
    "sparrowcrew.org",
    "sparruthetti.site",
    "spartanburgkc.org",
    "spartapiet.com",
    "spase.website",
    "spasuren.cf",
    "spasuren.ga",
    "spasuren.gq",
    "spasuren.ml",
    "spasuren.tk",
    "spavinbxxs.site",
    "spavinbxxs.website",
    "spawnet.ru",
    "spawnitaustralia.com",
    "spawnitaustralia.online",
    "spayment.ru",
    "spayneutersaveslives.org",
    "spazmail.com",
    "spb.ru",
    "spbemestarfit.host",
    "spbemestarfit.online",
    "spbladiestrophy.ru",
    "spblt.ru",
    "spbsquash.ru",
    "spbtcdev.com",
    "spd.dcu.ie",
    "spe24.de",
    "speakers401k.com",
    "speakfimal.cf",
    "speakfimal.ga",
    "speakfimal.ml",
    "speakfimal.tk",
    "speakfreely.email",
    "speakfreely.legal",
    "speaktion.com",
    "speakuptampabay.com",
    "spearsreunion.com",
    "speasfarm.us",
    "spec-energo.ru",
    "spec7rum.me",
    "speciaalmachinebouw.com",
    "specialbrush.biz",
    "specialbrush.net",
    "specialbrush.us",
    "specialbrushes.net",
    "specialbrushes.us",
    "specialinoevideo.ru",
    "specialinternetsite.com",
    "specialistperformanceclassics.com",
    "specialrate.xyz",
    "specialshares.com",
    "specialtcomfortcookies.com",
    "specialty208uq.online",
    "specialtybrushes.biz",
    "specialtylightingandbulb.com",
    "specialuxe.com",
    "specialzone.xyz",
    "specnondse.cf",
    "specnondse.ml",
    "specnondse.tk",
    "specsantehnika.ru",
    "specsecurity.ru",
    "spectacularevents.org",
    "specterius.ru",
    "spectexremont.ru",
    "spectralbodywork.com",
    "spectro.icu",
    "spectroscopy.tech",
    "speechdova.space",
    "speechiebusiness.com",
    "speechlanguagetherapy.org",
    "speed.1s.fr",
    "speedcha.xyz",
    "speedchal.icu",
    "speedcloud.tokyo",
    "speeddataanalytics.com",
    "speedemail.net",
    "speedemre.ga",
    "speedemre.gq",
    "speedemre.ml",
    "speedemre.tk",
    "speedfreaks.org",
    "speedgaus.net",
    "speedily.site",
    "speedlab.com",
    "speedmag.com",
    "speedorspir.cf",
    "speedorspir.ga",
    "speedorspir.ml",
    "speedorspir.tk",
    "speedpizza.ru",
    "speedpost.net",
    "speedrules.com",
    "speedrulz.com",
    "speedsogolink.com",
    "speedspecial.club",
    "speedsweep.net",
    "speedsweepbroom.biz",
    "speedsweepbroom.org",
    "speedsweepbroom.us",
    "speedsweepbrooms.biz",
    "speedsweepbrooms.com",
    "speedsweepbrooms.us",
    "speedwayhealthspot.com",
    "speedwayroadcarriers.com",
    "speedy.com.ar",
    "speedycorn.biz",
    "speedycorn.com",
    "speedycorn.net",
    "speedycorn.us",
    "speedycornbroom.com",
    "speedycornbroom.us",
    "speedycornbrooms.biz",
    "speedycornbrooms.org",
    "speedyenglish.xyz",
    "speedymail.org",
    "speedymop.org",
    "spektech.ru",
    "spektrsteel.ru",
    "spellas.email",
    "spelled962tz.online",
    "spellgla.press",
    "spelovo.ru",
    "spemail.xyz",
    "spendbitcoin.com",
    "spendbitcoins.net",
    "spenden.app",
    "sperke.net",
    "sperma.cf",
    "sperma.gq",
    "spetsinger.ru",
    "spga.de",
    "spgen.net",
    "spheresdesign.com",
    "spheretqoz.club",
    "spherinde.ga",
    "spherinde.gq",
    "spherinde.ml",
    "spicate.xyz",
    "spiceblogger.com",
    "spiceglossary.com",
    "spicehuttakeaway.com",
    "spiceindiatakeaway.com",
    "spiceitl.ru",
    "spiceoflifetakeaway.com",
    "spicesncurry.com",
    "spicy-grill-kebabish.com",
    "spicybites-clonmel.com",
    "spidalar.ga",
    "spidalar.gq",
    "spidalar.ml",
    "spidalar.tk",
    "spider.co.uk",
    "spiderbabygrafix.com",
    "spidercoal.icu",
    "spiderfracture.com",
    "spikebase.com",
    "spikemargin.com",
    "spikesstation.top",
    "spikeworth.com",
    "spikio.com",
    "spillcar.xyz",
    "spillfres.xyz",
    "spillplea.red",
    "spils.com",
    "spilt-test.bar",
    "spilt-test.ru",
    "spin-city-casino.com",
    "spin-city-casino.info",
    "spin-city.ru",
    "spin-stickers.ru",
    "spin24.com",
    "spin720.com",
    "spinamrai.tk",
    "spinanit.cf",
    "spinanit.ga",
    "spinanit.tk",
    "spindl-e.com",
    "spindye.se",
    "spinefruit.com",
    "spinerin.cf",
    "spinerin.ga",
    "spinerin.gq",
    "spinerin.ml",
    "spinfinder.com",
    "spingame.ru",
    "spingenie.net",
    "spingenie.org",
    "spinghar-takeaway.com",
    "spinia9.com",
    "spinners.se",
    "spinoffer.ru",
    "spinofis.gq",
    "spinofis.ml",
    "spinofis.tk",
    "spinsterism.best",
    "spinthis.biz",
    "spipharma.net",
    "spiral-of-life.ru",
    "spiraled205ep.online",
    "spiraling894vg.online",
    "spirende.ga",
    "spiripvan.tk",
    "spiritedmusepress.com",
    "spiriti.tk",
    "spiritofradio.com",
    "spiritofradio.info",
    "spiritofradio.org",
    "spiritseekers.com",
    "spiritsingles.com",
    "spiritualfriendship.site",
    "spiritualgemstones.info",
    "spiritualgemstones.net",
    "spiritualized243ee.online",
    "spirituallabs.com",
    "spirituallifesociety.org",
    "spirituelle.design",
    "spiritvuym.space",
    "spirityxcc.space",
    "spirliro.gq",
    "spirliro.tk",
    "spirtofrespect.com",
    "spirutda.cf",
    "spirutda.gq",
    "spirutda.ml",
    "spit-fire-productions.com",
    "spitdesk.us",
    "spitminuteremind.website",
    "spittingup.com",
    "spk9s.us",
    "spkr-info.online",
    "spkvariant.ru",
    "spl.at",
    "splashdogs.net",
    "splashjunglewaterpark.com",
    "splendidgifts.com",
    "splintergroup.com",
    "splitauto.info",
    "splitsl.icu",
    "splitstuf.us",
    "splitzauayy.email",
    "spmy.netpage.dk",
    "spo777.com",
    "spoilandsplendor.com",
    "spoilhor.xyz",
    "spoilhors.xyz",
    "spokanenailsalons.com",
    "spokaneparks.com",
    "spokaneparks.net",
    "spokedcity.com",
    "spoko.pl",
    "spolujizda.info",
    "spomus.site",
    "spondylodymus.best",
    "spongemop.net",
    "spongemops.biz",
    "spongemops.us",
    "sponsorhq.com",
    "spontomleo.cf",
    "spontomleo.gq",
    "spontomleo.tk",
    "spoof.global",
    "spoofmail.de",
    "spookwarehouse.com",
    "spooltacount.cf",
    "spooltacount.ga",
    "spoom.pro",
    "spoonelastic.com",
    "spooofcard.com",
    "spoortnews.info",
    "sporbaydar.cf",
    "sporbaydar.ga",
    "sporbaydar.tk",
    "sporethob.cf",
    "sporethob.gq",
    "sporethob.ml",
    "sporethob.tk",
    "sporexbet.com",
    "sporogenus-probiotics.com",
    "sporsalonuankara.com",
    "sport-gesundheit.de",
    "sport-life24.ru",
    "sport-outlet.info",
    "sport-partners.ru",
    "sport-souvenirs.ru",
    "sport-web.ru",
    "sportanchik.ru",
    "sportbro.tech",
    "sportbro666.com",
    "sportbro72.com",
    "sportbrobananat.ru",
    "sportbrohome.ru",
    "sportchek.ru",
    "sportcrownt.ru",
    "sportdsirect.com",
    "sportemail.com",
    "sporterona.ru",
    "sporteventmanager.net",
    "sportfitne.com",
    "sporthitbatt.ru",
    "sporthitbrobanana.ru",
    "sporthitbrobananat.ru",
    "sporthitbrocub.ru",
    "sporthitbrofan.ru",
    "sporthitbrojar.ru",
    "sporthitbromask.ru",
    "sporthitbromaskt.ru",
    "sporthitbroroad.ru",
    "sporthitcrownt.ru",
    "sporthitdresst.ru",
    "sporthitmask.ru",
    "sporthitmilkt.ru",
    "sporthitrockt.ru",
    "sporthittutcrown.ru",
    "sporthittutmilk.ru",
    "sportinize.icu",
    "sportiotdyhvmeste.ru",
    "sportivnoetv.ru",
    "sportmail.ru",
    "sportmasina.com",
    "sportmay.icu",
    "sportmilkt.ru",
    "sportnbet.ru",
    "sportprediction.com",
    "sports-mud.com",
    "sports3888.com",
    "sportsaa317.xyz",
    "sportsbarrie.com",
    "sportsbettingblogio.com",
    "sportsbettingcheat.com",
    "sportscentertltc.com",
    "sportscoring.org",
    "sportseventmanager.net",
    "sportsflownews.club",
    "sportsfoo.com",
    "sportsgobet.com",
    "sportsheadbasketball.com",
    "sportshqip.org",
    "sportsintheraw.com",
    "sportsmail.com",
    "sportsnews.xyz",
    "sportsokworld.com",
    "sportsraw.com",
    "sportsscoring.org",
    "sportsterandme.com",
    "sporttruckdriver.com",
    "sporttutbat.ru",
    "sporttutmom.ru",
    "sporty.dk",
    "sportylife.us",
    "sporunaf.ga",
    "sporunaf.gq",
    "spot12.icu",
    "spotcome.com",
    "spotevents.online",
    "spotify.best",
    "spotifyupgrade.life",
    "spotlessmamma.online",
    "spotlittle.com",
    "spotmyworld.com",
    "spotoaaa.com",
    "spotoid.com",
    "spotream.online",
    "spotspeople.com",
    "spottswoods.com",
    "spoutserver.com",
    "spoutsocial.ru",
    "spoy.cn",
    "spp878.com",
    "spr.io",
    "sprak.us",
    "spranklesmeatclub.com",
    "sprauncy.site",
    "spravkajurist.ru",
    "spray.no",
    "spray.se",
    "spraycrea.xyz",
    "spraysalo.space",
    "spreaddashboard.com",
    "spreadoutlaugh.club",
    "sprend.ru",
    "sprin.tf",
    "springfactoring.com",
    "springfield.clinic",
    "springfieldnailsalons.com",
    "springhotsale.com",
    "springmelodyteashop.website",
    "springrive.com",
    "springtowngeneralstore.com",
    "sprinklerareus.com",
    "sprintmail.com",
    "sprintpal.com",
    "spritelayer.net",
    "spritepromo.eu",
    "spritzzone.de",
    "sproces.shop",
    "sprosistalina.ru",
    "sprynet.com",
    "sprypixel.net",
    "spryte.co",
    "spsnoforeclosure.com",
    "spsu2o.us",
    "spt-sun.ru",
    "sptgaming.com",
    "spuddgunner.xyz",
    "spudiuzdsm.cf",
    "spudiuzdsm.ga",
    "spudiuzdsm.gq",
    "spudiuzdsm.ml",
    "spudiuzdsm.tk",
    "spumartes.cf",
    "spumartes.ga",
    "spumartes.tk",
    "spurahome.se",
    "spurgs.us",
    "spvantispam.com",
    "spy700.com",
    "spybox.de",
    "spycamp.ml",
    "spychelin.cf",
    "spychelin.ml",
    "spychelin.tk",
    "spydictionary.com",
    "spylive.ru",
    "spymac.com",
    "spyrointeractive.com",
    "spywtarpa.ga",
    "spywtarpa.gq",
    "spywtarpa.tk",
    "sq322.com",
    "sq711.com",
    "sqadekc.com",
    "sqairwave.com",
    "sqcysm.com",
    "sqfbin.xyz",
    "sqfec.us",
    "sqftselfstorage.com",
    "sqgpru.us",
    "sqhbdl.site",
    "sqoai.com",
    "sqpw35.us",
    "sqqh9w.us",
    "sqsiil.com",
    "sqttr.com",
    "squadmetrics.net",
    "squadmetrix.com",
    "squadmetrix.net",
    "squafb.us",
    "square-seal.com",
    "squaredsmp.com",
    "squaredsuppliers.com",
    "squareseal.com",
    "squarevjpe.space",
    "squarsonry.best",
    "squawvalleyprom.net",
    "squawvalleyresorts.com",
    "squeeze.gq",
    "squeezedconsumer.com",
    "squeezedconsumer.org",
    "squeezetv.com",
    "squidforhire.com",
    "squirrelcagefan.net",
    "squirt.school",
    "squirtblurt.com",
    "squirtsnap.com",
    "squizzy.de",
    "squizzy.eu",
    "squizzy.net",
    "sqwawky.com",
    "sqwqdc.com",
    "sqxx.net",
    "sr-wa.com",
    "sr.ro.lt",
    "sr5qyp.us",
    "sraka.xyz",
    "srariityyy88.xyz",
    "sravnizaimi.ru",
    "srb10n.com",
    "srbhomessellfast.com",
    "srbolik.com",
    "srcoqhkc.shop",
    "srcpls.ru",
    "srenco.com",
    "srewerty.ru",
    "srgb.de",
    "srgfesa21.online",
    "srhcp.org",
    "sri-consulting.com",
    "srilankan.net",
    "srinkaweb.website",
    "srjq.us",
    "srkonduskar.com",
    "srku7ktpd4kfa5m.cf",
    "srku7ktpd4kfa5m.ga",
    "srku7ktpd4kfa5m.gq",
    "srku7ktpd4kfa5m.ml",
    "srku7ktpd4kfa5m.tk",
    "srm76.ru",
    "srodaumvj7yvg76.xyz",
    "sroff.com",
    "srproductiononline.com",
    "srqstudies.com",
    "srquiz.com",
    "srrowuvqlcbfrls4ej9.cf",
    "srrowuvqlcbfrls4ej9.ga",
    "srrowuvqlcbfrls4ej9.gq",
    "srrowuvqlcbfrls4ej9.ml",
    "srsbizns.com",
    "srsconsulting.com",
    "srsxsx.shop",
    "srt.com",
    "srtchaplaincyofcanada.com",
    "srtnr.info",
    "srtnr.org",
    "srub48.ru",
    "srubstroy35.ru",
    "srv-aple-scr.xyz",
    "srvais.online",
    "srwatch.us",
    "sry.li",
    "srzio2.com",
    "ss-hitler.cf",
    "ss-hitler.ga",
    "ss-hitler.gq",
    "ss-hitler.ml",
    "ss-hitler.tk",
    "ss.undo.it",
    "ss00.cf",
    "ss00.ga",
    "ss00.gq",
    "ss00.ml",
    "ss01.ga",
    "ss01.gq",
    "ss02.cf",
    "ss02.ga",
    "ss02.gq",
    "ss02.ml",
    "ss02.tk",
    "ss1775.com",
    "ss4pfk.us",
    "ssabmocon.cf",
    "ssabmocon.ga",
    "ssabmocon.gq",
    "ssabmocon.ml",
    "ssabmocon.tk",
    "ssahgfemrl.com",
    "ssakda2.net",
    "ssande.site",
    "ssangyong.cf",
    "ssangyong.ga",
    "ssangyong.gq",
    "ssangyong.ml",
    "ssanphone.me",
    "ssanphones.com",
    "ssantswilliams.icu",
    "ssapp222.xyz",
    "ssapp555.xyz",
    "ssapp777.xyz",
    "ssasalliance.com",
    "ssassto.ru",
    "ssbhtcvm.shop",
    "ssbt-russia.info",
    "ssc52.top",
    "sscclub.com",
    "sschmid.ml",
    "sscr7q.icu",
    "ssd24.de",
    "ssdhfh7bexp0xiqhy.cf",
    "ssdhfh7bexp0xiqhy.ga",
    "ssdhfh7bexp0xiqhy.gq",
    "ssdhfh7bexp0xiqhy.ml",
    "ssdhfh7bexp0xiqhy.tk",
    "ssdsrvd.com",
    "ssecured.com",
    "ssegrub.best",
    "ssekableat.top",
    "ssfaa.com",
    "ssfehtjoiv7wj.cf",
    "ssfehtjoiv7wj.ga",
    "ssfehtjoiv7wj.gq",
    "ssfehtjoiv7wj.ml",
    "ssfehtjoiv7wj.tk",
    "ssg24.de",
    "ssgjylc1013.com",
    "sshd520.com",
    "sshid.com",
    "sskifym.site",
    "sskinus.site",
    "sskitriy.site",
    "sskmail.top",
    "sskstroy.ru",
    "sskynderg.site",
    "sskyreo.site",
    "ssl-aktualisierung-des-server-2019.icu",
    "ssl-mail.com",
    "ssl-trusted.com",
    "ssl-verify.xyz",
    "ssl.tls.cloudns.asia",
    "ssl9mail.xyz",
    "ssldigitalcertificate.com",
    "sslgen.org",
    "sslgsms.ru",
    "ssml.app",
    "ssmstem.net",
    "ssn8ed.us",
    "ssnapbridgee.site",
    "ssnapclube.site",
    "ssnapmarkm.site",
    "ssnp5bjcawdoby.cf",
    "ssnp5bjcawdoby.ga",
    "ssnp5bjcawdoby.gq",
    "ssnp5bjcawdoby.ml",
    "ssnp5bjcawdoby.tk",
    "sso-demo-okta.com",
    "ssoia.com",
    "ssongs34f.com",
    "ssqiancha.com",
    "ssrpink.club",
    "ssslideserve.icu",
    "ssspan.com",
    "sssppua.cf",
    "sssppua.ga",
    "sssppua.gq",
    "sssppua.ml",
    "sssppua.tk",
    "ssst-zar.ru",
    "sstata.com",
    "sstorer.com",
    "sstsy.net",
    "ssudanhmis.org",
    "ssunz.cricket",
    "ssv5jc.us",
    "ssvm.xyz",
    "ssww.ml",
    "ssykxh.us",
    "sszeyg24.xyz",
    "sszxapi.com",
    "sszzzz99.com",
    "st-davids.net",
    "st-exp.net",
    "st-m.cf",
    "st-m.ga",
    "st-m.gq",
    "st-m.ml",
    "st-m.tk",
    "st33.xyz",
    "stabbettsnupp2020.xyz",
    "stabbying.monster",
    "stabetingsnup.xyz",
    "stabetting.xyz",
    "stabilbettsnapp.xyz",
    "stabilitybetsnapp.xyz",
    "stabilitybettingsnapp.xyz",
    "stablecoininterest.com",
    "stachebarbershop.com",
    "stackedlayers.com",
    "stackinglayers.com",
    "stacklance.com",
    "stackled.com",
    "stackleds.com",
    "stackparts.com",
    "stackupapp.com",
    "stade.fr",
    "stadia.codes",
    "stadiumtrucks.net",
    "stadyumdan.com",
    "stafabands.info",
    "staff7.ml",
    "staffchat.tk",
    "staffmessages.com",
    "staffprime.com",
    "stafimre.cf",
    "stafimre.ga",
    "stafimre.gq",
    "stafimre.ml",
    "stagarti.cf",
    "stagarti.ga",
    "stagarti.gq",
    "stagarti.tk",
    "stagazvi.ga",
    "stagazvi.ml",
    "stagazvi.tk",
    "stage-dz.com",
    "stagebla.xyz",
    "stagenext.co",
    "stagewate.xyz",
    "stagingdisco.com",
    "stagingsever.com",
    "stagmoli.cf",
    "stagmoli.ga",
    "stagmoli.gq",
    "stagmoli.ml",
    "stagmoli.tk",
    "stagnations.best",
    "stagricomp.cf",
    "stagricomp.ga",
    "stagricomp.gq",
    "stagricomp.ml",
    "stagricomp.tk",
    "stailas.club",
    "staindrea.xyz",
    "stainlesssteelbrush.biz",
    "stainlesssteelbrush.net",
    "stainlesssteelbrush.org",
    "stainlesssteelbrushes.us",
    "staircraft5.com",
    "staishansteel.com",
    "stakegrace.com",
    "stakehab.xyz",
    "stakeholderexchange.org",
    "staking-live.com",
    "stalag13.com",
    "stalenvilla.com",
    "stalingradd.ru",
    "stalingulag.com",
    "stalker22.ru",
    "stallbla.recipes",
    "stallde.icu",
    "stallfev.icu",
    "stallspine.recipes",
    "stalnoj.ru",
    "stamathioudaki.xyz",
    "stambytesundsvall.se",
    "stamcoral.cf",
    "stamcoral.ga",
    "stamcoral.gq",
    "stamforddoctors.com",
    "staminafamily.com",
    "stampfrui.fun",
    "stampguid.fun",
    "stamppot.media",
    "stampsprint.com",
    "stan-stan.com",
    "stanalandgroup.com",
    "standais.xyz",
    "standaisl.xyz",
    "standalone.net",
    "standardhome.org",
    "standardsoptical.fun",
    "standartnewsbg.online",
    "standclea.icu",
    "standeight.com",
    "standeputatom.ru",
    "standfl.xyz",
    "standhover.email",
    "standing-desk-office-expert.zone",
    "stando-borescope.com",
    "standothe.xyz",
    "standrewavellinorcchurch.com",
    "standrewavellinorcchurch.info",
    "standrewavellinorcchurch.us",
    "standupforyourrightswisconsin.org",
    "standupstories.com",
    "standwo.icu",
    "stanford-edu.tk",
    "stanford.edu",
    "stanfordujjain.com",
    "stanmody.cf",
    "stanmody.ga",
    "stanmody.gq",
    "stanmody.ml",
    "stanmody.tk",
    "stanniiffu.space",
    "stansade.cf",
    "stansade.ga",
    "stansade.tk",
    "stanthonycroatianchurchla.org",
    "stantondoctors.com",
    "stantonwhite.com",
    "stanungrab.cf",
    "stanungrab.gq",
    "stanungrab.ml",
    "staplefy.com",
    "star-context.site",
    "star-court-chinese-shannon.com",
    "star-goroscop.org",
    "star-trek.online",
    "starb5t5.com",
    "starbasket.camp",
    "starbet.xyz",
    "starbittest.xyz",
    "starblogsthai.com",
    "starbola.com",
    "starboptyd.space",
    "starbuzz.com",
    "starcitycards.biz",
    "starcitycards.net",
    "starcitycards.org",
    "starcraftwallpapers.com",
    "stardefcon.com",
    "stardiesel.biz",
    "stardiesel.info",
    "stardiesel.org",
    "stargateradio.com",
    "stargentumcraft.ru",
    "starherz.ru",
    "starinfluencer.org",
    "starkaraoke.ru",
    "starkfoundries.com",
    "starkjoyas.com",
    "starkrecords.com",
    "starlegboa.cf",
    "starlegboa.ga",
    "starlight-breaker.net",
    "starlimo.cf",
    "starlimo.ml",
    "starmagsigh.cf",
    "starmagsigh.gq",
    "starmagsigh.ml",
    "starmail.co.za",
    "starmail.com",
    "starmail.org",
    "starmedia.com",
    "starmetalsatlanta.us",
    "starmyace.ga",
    "starpl.com",
    "starplace.com",
    "starpopco.cf",
    "starpopco.gq",
    "starpopco.ml",
    "starpower.net",
    "starpower.space",
    "starpreneur.com",
    "starspath.com",
    "starstablecheats.com",
    "starstaboos.com",
    "starstatemachine.org",
    "starstruckcommerce.com",
    "start-me.ru",
    "start-money39.ru",
    "start-vr.online",
    "start.com.au",
    "startafreeblog.com",
    "startank.icu",
    "startap731.ru",
    "startawinecollection.com",
    "startbags.ru",
    "startcreate.ru",
    "startersite.ru",
    "startfu.com",
    "starthand.icu",
    "startidc.com",
    "startimetable.com",
    "starting-point.com",
    "startkeys.com",
    "startkni.icu",
    "startmail.xyz",
    "startoon02.com",
    "startoon5.com",
    "startoon8.com",
    "startoon9.com",
    "startpaya.com",
    "startrekmail.com",
    "startsgreat.ga",
    "startuphusky.com",
    "startupmystartup.com",
    "startupschwag.com",
    "startupsjournal.com",
    "startupstartertoolkit.com",
    "startuptees.com",
    "startuptulsa.com",
    "startuup.co",
    "startwithone.ga",
    "starvalley.homes",
    "starvalleyranchrvpark.com",
    "starvalleyrentals.com",
    "starveyourego.com",
    "starveyourego.org",
    "starwars-fans.com",
    "starwaytollers.com",
    "starwin365.biz",
    "starx.pw",
    "staryoskol.info",
    "staryzones.com",
    "starzip.link",
    "stashsheet.com",
    "statdvr.com",
    "stateblin.space",
    "statecollegedoctors.com",
    "statecollegeplumbers.com",
    "stateflee.xyz",
    "statelawsuitreform.org",
    "stateofoyo.com",
    "statetaxreview.com",
    "stathost.net",
    "staticcontrolbrush.net",
    "staticcontrolbrushes.biz",
    "staticcontrolbrushes.net",
    "staticdissipativebrush.com",
    "staticdissipativebrushes.us",
    "staticintime.de",
    "staticpad.com",
    "statiix.com",
    "station.poker",
    "stationatprominence.com",
    "statisticalbreviary.com",
    "statisticalbreviary.net",
    "statisticalbreviary.org",
    "statloan.info",
    "staton-time.com",
    "statontime.com",
    "statpill.com",
    "statravel.ru",
    "statrep.com",
    "stats-on-time.com",
    "statsbet.ru",
    "statsbot.xyz",
    "statson-time.com",
    "statsondemand.com",
    "statsontime.com",
    "stattech.info",
    "statuaxkwo.space",
    "status.vote",
    "statusa.shop",
    "statusinforming.xyz",
    "statuspage.ga",
    "statusqm.biz",
    "statusqm.com",
    "statusqm.net",
    "statusqm.org",
    "statusqms.biz",
    "statusqms.net",
    "statusqms.org",
    "statutoryregisters.com",
    "statx.ga",
    "stavkapromokod10.ru",
    "stavki-na-sport-online.ru",
    "stayarch.us",
    "staytoppop.com",
    "stclairlawofficewa.com",
    "stcloudstate.edu",
    "stcnedu.com",
    "stcroixboatrentals.com",
    "steadying.com",
    "steakej.icu",
    "steakhe.us",
    "steakhors.xyz",
    "steakinde.xyz",
    "steakreb.xyz",
    "steakrebe.xyz",
    "steakshoo.email",
    "stealbets.ru",
    "stealth-check.space",
    "stealthmail.com",
    "stealthypost.net",
    "stealthypost.org",
    "steam-area.ru",
    "steam-brush.net",
    "steam-inventory-helper.com",
    "steam-love.ru",
    "steamak.ru",
    "steambot.net",
    "steamcases.ru",
    "steamcomunity.ru",
    "steamdiscoveryhomeschool.com",
    "steamgg.ru",
    "steamgreenlight.ml",
    "steampowered.games",
    "steamprank.com",
    "steampunkrider.com",
    "steamsupport-tr.tk",
    "steamth.com",
    "steamvip.ml",
    "steamyliasons.com",
    "steamyprofiles.com",
    "steclin.net",
    "stecloochistitel.ru",
    "steel-pipes.com",
    "steemail.ga",
    "steepeli.icu",
    "steericjpz.space",
    "stefangorzkiewicz.com",
    "stefanspooren.online",
    "stefantoresson.se",
    "stefhf.nl",
    "steganpsmc.space",
    "stegodons.best",
    "stehkragenhemd.de",
    "steifftier.de",
    "steklosila.ru",
    "steklozona.ru",
    "stekolko.ru",
    "stelgames.com",
    "stelkendh00.ga",
    "stellarleagues.com",
    "stelliteop.info",
    "stels26.ru",
    "stemcca123.xyz",
    "stemfor.ru",
    "stemsurgery.com",
    "stendsad.gq",
    "steorn.cf",
    "steorn.ga",
    "steorn.gq",
    "steorn.ml",
    "steorn.tk",
    "stephaniefords.com",
    "stephs.site",
    "stepitup.solutions",
    "steprepeatsbackdrop.com",
    "steps-of-rome-restaurant.com",
    "stepsofromeitalian.com",
    "steptobusiness.ru",
    "steptohs.gq",
    "stepundum.ga",
    "stepundum.gq",
    "stepundum.ml",
    "stepundum.tk",
    "stepx100.company",
    "stepx100.name",
    "stepx100.one",
    "stepx100.ru",
    "stereoreceivers.info",
    "sterfastspir.ga",
    "sterfastspir.gq",
    "sterfastspir.tk",
    "sterlingheightsquote.com",
    "sterlingtelecom.ru",
    "steumcommunytl.ru",
    "steumcomunitu.ru",
    "steumcomuunniti.ru",
    "steumcoommunytiu.ru",
    "steunhandelaars.vlaanderen",
    "steunhoreca.site",
    "steuwo.site",
    "steveharrismedia.com",
    "steveholmesphoto.com",
    "stevenbaker.com",
    "stevenledford.com",
    "stevenolls.info",
    "stevenspointapartments.com",
    "stevesmale.com",
    "stevesmusclecars.arcoxmail.com",
    "stevyal.tech",
    "stewartscyclecity.com",
    "stewarttalentchicago.com",
    "stexsy.com",
    "stf8.wtf",
    "stg.malibucoding.com",
    "stgj68.com",
    "stgmm.live",
    "sthaniyasarkar.com",
    "stichtowear.com",
    "stickersy.website",
    "stickmansurf.com",
    "stickyfaith.com",
    "stickywarrior.com",
    "sticypil.cf",
    "sticypil.ga",
    "sticypil.gq",
    "stifemar.gq",
    "stifemar.ml",
    "stifemar.tk",
    "stiffgirls.com",
    "stihi-poeziya.ru",
    "stiistim.shop",
    "stillchronic.com",
    "stillfeas.icu",
    "stillshee.recipes",
    "stillsheep.recipes",
    "stimstii.shop",
    "stimulanti.com",
    "stinghors.buzz",
    "stingsma.xyz",
    "stinkefinger.net",
    "stinkypoopoo.com",
    "stiop.website",
    "stipte.nl",
    "stireazilei.ru",
    "stitchingbelle.com",
    "stjamesplantationrealestateproperties.com",
    "stjohninglewood.net",
    "stlouisquote.com",
    "stlzen.company",
    "stmargarets.site",
    "stmentm.shop",
    "stnds.ru",
    "stny.rr.com",
    "sto-loto-prise.press",
    "stoboss.com",
    "stoc24.info",
    "stocherin.cf",
    "stocherin.ga",
    "stocherin.gq",
    "stocherin.ml",
    "stocherin.tk",
    "stocilat.cf",
    "stocilat.ga",
    "stocilat.ml",
    "stock-discount-retail.space",
    "stockblinds.ca",
    "stockburger.solutions",
    "stockguru.net",
    "stockholmmarkis.nu",
    "stockmarketnigeria.com",
    "stockmount.info",
    "stockmount.xyz",
    "stockpedia.xyz",
    "stockpicclub.com",
    "stockpickcentral.com",
    "stockracer.com",
    "stocksaa317.xyz",
    "stocksaa318.xyz",
    "stockservers.host",
    "stocksforjocks.org",
    "stockstorm.com",
    "stocktonnailsalons.com",
    "stocosur.ml",
    "stocosur.tk",
    "stocxingsgen.tk",
    "stoenco.shop",
    "stofaline.ru",
    "stoffreich.de",
    "stofverpoi.cf",
    "stofverpoi.gq",
    "stofverpoi.ml",
    "stofverpoi.tk",
    "stogigabit.ru",
    "stohastik.tel",
    "stokyards.info",
    "stolbbrus.ru",
    "stolica35.ru",
    "stolidwiid.space",
    "stolovaya-hutorok.ru",
    "stomach4m.com",
    "stonamab.ml",
    "stonamab.tk",
    "stonebahis25.com",
    "stonecanyonvegas.com",
    "stonecoal.space",
    "stoned.com",
    "stonedogdigital.com",
    "stonedrones.com",
    "stoneflylab.com",
    "stoneflylabs.com",
    "stonemountaindentistry.com",
    "stonerfans.com",
    "stonerunapts.com",
    "stones.com",
    "stop-alert.site",
    "stop-my-spam.cf",
    "stop-my-spam.com",
    "stop-my-spam.ga",
    "stop-my-spam.ml",
    "stop-my-spam.pp.ua",
    "stop-my-spam.tk",
    "stop-working.ru",
    "stopcomgi.ga",
    "stopcomgi.gq",
    "stopcomgi.ml",
    "stopcomgi.tk",
    "stopdropandroll.com",
    "stophabbos.tk",
    "stopharlownorth.com",
    "stopsesta.com",
    "stopshooting.com",
    "stopshowcontrol.com",
    "stoptalonserrurerie.com",
    "stopvulcancomalcountyquarry.org",
    "stopwhitecollarcrime.com",
    "storabim.cf",
    "storabim.gq",
    "storageshop.futbol",
    "storageunits.app",
    "storal.co",
    "storant.co",
    "store-clear-fast.ru",
    "store-krosi.ru",
    "store-official-offer.ru",
    "store-perfume.ru",
    "store-sumky.ru",
    "store-tshirt.com",
    "store389.top",
    "storeamnos.co",
    "storeandgo.ru",
    "storebero.club",
    "storebestsale.ru",
    "storeclsrn.xyz",
    "storectic.co",
    "storective.co",
    "storegmail.com",
    "storeillet.co",
    "storellin.co",
    "storendite.co",
    "storenia.co",
    "storennnews.com",
    "storent.co",
    "storeodon.co",
    "storeodont.co",
    "storeodoxa.co",
    "storeortyx.co",
    "storeotragus.co",
    "storerecon.net",
    "storero.co",
    "storestean.co",
    "storesteia.co",
    "storesuccpix.host",
    "storeupdate.live",
    "storeutics.co",
    "storevisibility.com",
    "storeweed.co",
    "storewood.co",
    "storeyee.com",
    "storeyoga.mobi",
    "storeyoga.vip",
    "storiqax.com",
    "storiqax.top",
    "storist.co",
    "storj99.com",
    "storj99.top",
    "storkbot.com",
    "storksite.com",
    "storm-gain.biz",
    "storm-gain.com",
    "storm-gain.net",
    "storm-gain.ru",
    "storm-gain.us",
    "storm-news.ru",
    "storm.cloudwatch.net",
    "stormacu.press",
    "stormarea51festival.com",
    "stormcoalition.org",
    "stormdrone.ru",
    "stormenra.cf",
    "stormenra.ga",
    "stormenra.ml",
    "stormenra.tk",
    "stormfai.icu",
    "stormflush.space",
    "stormgain.club",
    "stormgain.info",
    "stormgain.net",
    "stormgain.sk",
    "stormiro.com",
    "stornoway-angling-association.com",
    "storos.ru",
    "storpool.info",
    "storybicycle.com",
    "storydrivenretail.com",
    "storyjoke.xyz",
    "storylensmarketing.com",
    "storymed.icu",
    "storyst.xyz",
    "storysta.xyz",
    "storywat.xyz",
    "stoya.tech",
    "stpattys5k.com",
    "stpaulfcu.biz",
    "stpaulfcu.name",
    "stpaulfcu.us",
    "stpc.de",
    "stpetebungalows.com",
    "stpetersandstpauls.xyz",
    "stpetersburgmap360.com",
    "stpetersburgnailsalons.com",
    "stqffouerchjwho0.cf",
    "stqffouerchjwho0.ga",
    "stqffouerchjwho0.gq",
    "stqffouerchjwho0.ml",
    "stqffouerchjwho0.tk",
    "str.cash",
    "strahovanie-tinkoff.ru",
    "strahovkavita.ru",
    "straightening-solution.com",
    "straightupfarms.com",
    "strakkebuikbijbel.net",
    "strandpromenaden9.site",
    "strandsbar.online",
    "strangersinstereo.com",
    "strapedfortime.com",
    "straply.com",
    "straponmoviez.com",
    "strat0s.earth",
    "strategicalbrand.com",
    "strategicprospecting.com",
    "strategyzr.info",
    "stratfordfootclinic.com",
    "strath.ac.uk",
    "strathearnmasons.org",
    "stratosphericheights.org",
    "strattera.website",
    "strauss.best",
    "strawar.xyz",
    "strawberry-game.online",
    "strawcabl.recipes",
    "strawdi.works",
    "strawdre.xyz",
    "strawfei.fun",
    "strawgri.email",
    "strawhat.design",
    "strawhous.icu",
    "strawsig.icu",
    "strawwa.xyz",
    "stream-lite.monster",
    "streamcomplet.one",
    "streamdotshop.com",
    "streamdrop.org",
    "streamfly.biz",
    "streamfly.link",
    "streaming-films-gratuit.xyz",
    "streaming-foot.biz",
    "streaming-foot.online",
    "streaming-manga-vf.com",
    "streaming-mangas.net",
    "streaming.cash",
    "streamingbokepx.info",
    "streamingfoot.biz",
    "streamingz.xyz",
    "streamlifecoin.com",
    "streamlifeproductions.live",
    "streamlifestudio.com",
    "streamlines.us",
    "streamnvr.net",
    "streamnvr.org",
    "streamonsport.stream",
    "streamsentiment.net",
    "streamup.ru",
    "streamwatchtv.live",
    "streamzt.org",
    "streber24.de",
    "street.network",
    "streetbroom.net",
    "streetbroom.org",
    "streetbrooms.net",
    "streetbrooms.us",
    "streetevolution.club",
    "streetfeetdance.com",
    "streetsyouwalk.com",
    "streetwisemail.com",
    "strengthvcf.email",
    "stresser.store",
    "stresser.tk",
    "stressylglf.email",
    "stribmail.com",
    "strictddwxs.email",
    "stringcool.com",
    "striorttedavisi.xyz",
    "striorttreatment.xyz",
    "striortturkey.xyz",
    "stripadvisor.xyz",
    "stripbrush.biz",
    "stripbrush.us",
    "stripbrushes.net",
    "stripbrushes.us",
    "stripmsk.ru",
    "stripouts.melbourne",
    "stripquiz.ru",
    "stripstu.us",
    "strivingman.com",
    "strkt.website",
    "strmail.site",
    "stroemka.ru",
    "stroi-pro.store",
    "stroiitelstvo.ru",
    "stroimvseinfo.ru",
    "strokegenius.net",
    "stromans.space",
    "stromgain.biz",
    "stromgain.com",
    "stromgain.net",
    "stromgain.ru",
    "stromgain.us",
    "stromox.com",
    "strompost.com",
    "strong-muscle.com",
    "strongan.com",
    "strongerads.com",
    "strongerwomandiet.com",
    "strongerwomanlabs.com",
    "strongguy.com",
    "strongmd.com",
    "strongpeptides.com",
    "strongpesny.ru",
    "strongsvilleapartments.com",
    "strovolos.xyz",
    "stroy-montage777.ru",
    "stroydom54.ru",
    "stroyka-34.ru",
    "stroymetalls.ru",
    "stroymetals.ru",
    "stroymontazh24.ru",
    "stroynovv.ru",
    "stroyopt-31.ru",
    "stroyportrus.ru",
    "stroytell.ru",
    "sts.ansaldo.cf",
    "sts.ansaldo.ga",
    "sts.ansaldo.gq",
    "sts.ansaldo.ml",
    "sts.hitachirail.cf",
    "sts.hitachirail.ga",
    "sts.hitachirail.gq",
    "sts.hitachirail.ml",
    "sts.hitachirail.tk",
    "sts9d93ie3b.cf",
    "sts9d93ie3b.ga",
    "sts9d93ie3b.gq",
    "sts9d93ie3b.ml",
    "sts9d93ie3b.tk",
    "ststwmedia.com",
    "stt1188.com",
    "stt288.com",
    "stt3344.com",
    "stt9888.com",
    "stt991.com",
    "stuckhere.ml",
    "stuckmail.com",
    "stucwerkrepareren.com",
    "stud.uni-sb.de",
    "student-loan-consolidation-programs.us",
    "student-web-design.com",
    "student.american.edu",
    "student.edu.creo.tips",
    "student.framingham.edu",
    "student.gla.ac.uk",
    "student.kaplan.edu",
    "student.liu.se",
    "student.onsow.k12nc.us",
    "student.su",
    "studentcenter.org",
    "studentdaysout.com",
    "studentloantherapist.com",
    "studentmail.me",
    "students-class1.ml",
    "studi24.de",
    "studiegids.org",
    "studiekiezenhulp.online",
    "studio-mojito.ru",
    "studio300.com",
    "studioaslka.email",
    "studiodesain.me",
    "studiomeha.ru",
    "studiopolka.tokyo",
    "studioro.review",
    "studiouberhaupt.com",
    "studioverity.com",
    "study-advantage.site",
    "study-intentions.site",
    "study-network.site",
    "studychoicebes.com",
    "studyeainja.email",
    "studytantra.com",
    "studytitl.fun",
    "stuen.site",
    "stuff-4-sale.org",
    "stuff-4-sale.us",
    "stuff.munrohk.com",
    "stuffmail.de",
    "stuffsti.xyz",
    "stumblemanage.com",
    "stumblingbee.info",
    "stumblingzebra.info",
    "stumpfwerk.com",
    "stunde.shop",
    "stupid.pet",
    "stupid.tube",
    "sturalray.ml",
    "sturdynews.com",
    "sturetattoo.online",
    "sturetattoo.se",
    "sturgeonpointchurch.com",
    "sturroperp.cf",
    "sturroperp.ga",
    "sturroperp.gq",
    "sturroperp.tk",
    "stusnem.ru",
    "stuy-wash-n-dry.com",
    "stvj.com",
    "stvmanbetx.com",
    "stvp.dev",
    "stx.rr.com",
    "stxsports.org",
    "styl-stroy.ru",
    "style-sporty.ru",
    "stylearis.xyz",
    "stylebostononline.com",
    "stylechec.recipes",
    "stylemail.cz.cc",
    "stylen.info",
    "stylenjeagn.email",
    "stylepi.icu",
    "stylesp.icu",
    "stylght.com",
    "stylishwaka.com",
    "stylist-volos.ru",
    "styliste.pro",
    "stylizes318cf.online",
    "su3cl3.com",
    "su4gc.us",
    "su7u.com",
    "suagiagoc.com",
    "suamgtpk.shop",
    "sub2qp.us",
    "sub4d.org",
    "suba3b.info",
    "subaru-brz.cf",
    "subaru-brz.ga",
    "subaru-brz.gq",
    "subaru-brz.ml",
    "subaru-brz.tk",
    "subaru-wrx.cf",
    "subaru-wrx.ga",
    "subaru-wrx.gq",
    "subaru-wrx.ml",
    "subaru-wrx.tk",
    "subaru-xv.cf",
    "subaru-xv.ga",
    "subaru-xv.gq",
    "subaru-xv.ml",
    "subaru-xv.tk",
    "subaxillary.best",
    "subcblognus.cf",
    "subcblognus.ga",
    "subcblognus.gq",
    "subcblognus.ml",
    "subcblognus.tk",
    "subccybd.site",
    "subchina.com",
    "subgauge.com",
    "subgold.ru",
    "subiri.cf",
    "subiri.ga",
    "subiri.gq",
    "subiri.tk",
    "subivari.site",
    "subkeyten.cf",
    "subkeyten.ga",
    "subleasehub.com",
    "sublime-shop.site",
    "submail.dk",
    "submoti.ga",
    "submoti.gq",
    "submoti.tk",
    "subneking.tk",
    "subnest.net",
    "subnetwork.com",
    "suboog.fun",
    "subpastore.co",
    "subqouisom.cf",
    "subqouisom.ml",
    "subqouisom.tk",
    "subram.com",
    "subrendo.ml",
    "subrolive.com",
    "subscrib.ru",
    "subscribe.rocks",
    "subscribershub.online",
    "subset.support",
    "subsidrlnq.space",
    "substidehz.space",
    "subsxchange.com",
    "subtilizes150yj.online",
    "subtle-love-brightimperial.com",
    "subtogel.com",
    "subtogel.net",
    "subtoto.com",
    "subtoto.net",
    "subtverpthe.ga",
    "subtverpthe.gq",
    "subulog.xyz",
    "suburbanthug.com",
    "suburqq.club",
    "suburqq.live",
    "suburqq.net",
    "subwaysgfm.space",
    "suby.site",
    "subzone.space",
    "succcardnach.cf",
    "succcardnach.gq",
    "succcardnach.ml",
    "succcardnach.tk",
    "succeedabw.com",
    "succesgscv.space",
    "success.ooo",
    "successagency.website",
    "successclick.ru",
    "successforu.pw",
    "successfulvideo.ru",
    "successlocation.work",
    "successmvp.com",
    "successstylesstories.com",
    "sucile.xyz",
    "sucirve.ga",
    "sucirve.gq",
    "sucirve.ml",
    "suckmyd.com",
    "sucknfuck.date",
    "sucknfuck.site",
    "sucuqeu.space",
    "sucvat.dog",
    "sudanfreedom.org",
    "sudanmail.net",
    "sudannews365.net",
    "suddenlink.net",
    "suddenlinkmail.com",
    "suddenlystrangers.com",
    "sudloisirs-nc.com",
    "sudolife.me",
    "sudolife.net",
    "sudomail.biz",
    "sudomail.com",
    "sudomail.net",
    "sudoverse.com",
    "sudoverse.net",
    "sudoweb.net",
    "sudoworld.com",
    "sudoworld.net",
    "suedcore.com",
    "sueddeutsche.de",
    "suenodelcamino.com",
    "suestetcomp.cf",
    "suestetcomp.ga",
    "suestetcomp.gq",
    "suestetcomp.ml",
    "suffisa.com",
    "suffocationlive.info",
    "suffrueguj.space",
    "sufipreneur.org",
    "sufismglobalcircle.com",
    "sugabuzx.com",
    "sugar-daddy-meet.review",
    "sugarcane.de",
    "sugardaddypardise.com",
    "suger-ro.com",
    "suggiewuggies.com",
    "suggstimbermachining.net",
    "suhabi.com",
    "suhov-media.ru",
    "suhuempek.cf",
    "suhuempek.ga",
    "suhuempek.gq",
    "suhuempek.ml",
    "suhuempek.tk",
    "suhugatel.cf",
    "suhugatel.ga",
    "suhugatel.gq",
    "suhugatel.ml",
    "suhugatel.tk",
    "suhusangar.ml",
    "suibox.com",
    "suiliu.com",
    "suioe.com",
    "suipostsil.ml",
    "suiratelier.com",
    "suireka.cf",
    "suireka.tk",
    "suirovig.cf",
    "suirovig.ga",
    "suirovig.tk",
    "suisse.org",
    "suitableland.net",
    "suiteange.xyz",
    "suitesatkillington.com",
    "suitetru.xyz",
    "suitetrun.icu",
    "suitewea.fun",
    "suivicolissimo.cc",
    "sukaalkuma.com",
    "sukapkv.xyz",
    "sukasukasuka.me",
    "suke2.us",
    "sukhumvit.net",
    "sukienb24.com",
    "suksescasino.info",
    "suksesnet.com",
    "suksesnet.net",
    "suksessin.net",
    "sul.com.br",
    "sulari.cf",
    "sulari.gq",
    "sulari.ml",
    "sulari.tk",
    "sulitapp.com",
    "sull.ga",
    "sullivan11thward.org",
    "sullivanemail.net",
    "sulpehost.cf",
    "sultanbaptist.space",
    "sultanbetcasino3.club",
    "sultanbetgiris.org",
    "sultanbetgiris2.club",
    "sultanbetuyelik2.club",
    "sultanbetyeniadresi2.club",
    "sultandomino.info",
    "sultandomino.org",
    "sultandomino99.org",
    "sulut365.com",
    "sulut88.com",
    "sulutbet.com",
    "suma-group.com",
    "sumaestrategias.com",
    "sumaidaandkhurana.com",
    "sumbatouristic.com",
    "sumberkadalnya.com",
    "sumerzhang.xyz",
    "sumidouros.info",
    "sumitra.ga",
    "sumitra.tk",
    "sumka-trands.ru",
    "summarization92fv.online",
    "summarization948gb.online",
    "summationstaffing.com",
    "summavocarefoundation.org",
    "summer-boxoffice.com",
    "summerblaze.site",
    "summerbloggreenoceanlina.site",
    "summerinnswords.com",
    "summerlinmedia.net",
    "summeroceangreenbloglina.site",
    "summerolympics.tokyo",
    "summertalbot.buzz",
    "summerwedding.club",
    "summis.com",
    "summitcountylibraries.com",
    "summitgg.com",
    "summitmedweb.com",
    "summonsinstinct.site",
    "sumofsums.com",
    "sump3min.ru",
    "sumpbiro.ga",
    "sumpbiro.gq",
    "sumpbiro.ml",
    "sumpbiro.tk",
    "sumpscufna.cf",
    "sumpscufna.tk",
    "sumurborjogjakarta.com",
    "sun-star-takeaway.com",
    "sunbatem.online",
    "sunbuh.asia",
    "sunburyohs.info",
    "sunbzarra.ga",
    "sunbzarra.gq",
    "sunbzarra.ml",
    "sunbzarra.tk",
    "suncareersolution.com",
    "sundaylaura.com",
    "sundaymariska.com",
    "sundaymovo.com",
    "sundriesday.com",
    "sunflower-hotel.com",
    "sunflowermls.org",
    "sungin-jp.com",
    "sunglasseslabs.com",
    "sunglassesshop.futbol",
    "sunglie-mind.xyz",
    "suning.one",
    "sunmail.ga",
    "sunmail.ml",
    "sunmail1.com",
    "sunmeni.com",
    "sunnyleonexxx.mobi",
    "sunnynet.shop",
    "sunpoint.net",
    "sunpolis.site",
    "sunprairieapartments.com",
    "sunramea.cf",
    "sunramea.gq",
    "sunramea.ml",
    "sunramea.tk",
    "sunrayod.com",
    "sunrice-shop.ru",
    "sunrise-sunset.com",
    "sunrisebayleh.net",
    "sunrisebayleh.org",
    "sunrisespasaz.com",
    "sunsetgames.social",
    "sunsgame.com",
    "sunsggcvj7hx0ocm.cf",
    "sunsggcvj7hx0ocm.ga",
    "sunsggcvj7hx0ocm.gq",
    "sunsggcvj7hx0ocm.ml",
    "sunsggcvj7hx0ocm.tk",
    "sunshine-mistery-villas.com",
    "sunshine-takeaway.com",
    "sunshinedesign.info",
    "sunshinehousespa.com",
    "sunspouurw.online",
    "suntory.ga",
    "suntory.gq",
    "sunumail.sn",
    "sunvamor.ml",
    "sunvamor.tk",
    "sunvictorytale.com",
    "sunyarme.com",
    "sunydaylunh.email",
    "sunyggless.com",
    "suomi24.fi",
    "suoox.com",
    "sup998.com",
    "supa4.com",
    "supaplex.site",
    "supappl.me",
    "supascan.com",
    "super-100-loto.press",
    "super-100-loto.site",
    "super-100-loto.website",
    "super-auswahl.de",
    "super-date-now3.com",
    "super-incomes.online",
    "super-lodka.ru",
    "super-mag-orange.space",
    "super-swift-grey.space",
    "super-videos.info",
    "super-wifi.online",
    "super10.space",
    "super6al.com",
    "superalts.gq",
    "superauto8.com",
    "superbags.de",
    "superbahisbonus.info",
    "superbahiscanlicasino.info",
    "superbahiscanlicasino.net",
    "superbahisguvenilirmi.info",
    "superbahiskampanya.info",
    "superbahisokey.com",
    "superbahisokey.info",
    "superbahisokey.net",
    "superbahissikayet.net",
    "superbahistavla.info",
    "superbahistavla.net",
    "superbalist.info",
    "superbeingdiet.com",
    "superbet777.net",
    "superbiteslimerick.com",
    "superbitestakeaway.com",
    "superbruger.dk",
    "supercache-bhs1.ovh",
    "supercem.net",
    "supercoinmail.com",
    "superdada.com",
    "superdiplomnik.ru",
    "superdom.site",
    "supere.ml",
    "supereme.com",
    "superenalottoonline.it",
    "supereva.it",
    "supergadgets.xyz",
    "supergelmarl.site",
    "supergirl.fun",
    "supergreatmail.com",
    "supergreen.com",
    "supergreentonic.com",
    "superhappyfunnyseal.com",
    "superhostformula.com",
    "superig.com.br",
    "superioroliveoils.com",
    "superkardioru.ru",
    "superleocasino.com",
    "superleopoker.com",
    "superlistas.info",
    "superluckyslots.ru",
    "supermacsmaynooth.com",
    "supermail.cf",
    "supermail.ru",
    "supermailer.jp",
    "supermall.xyz",
    "superman.ru",
    "superminicase.rest",
    "superminicraft.com",
    "supermoji.app",
    "supernewsavto.ru",
    "supernova-light.com",
    "supernozhmarket.ru",
    "superoeuhe.space",
    "superplatyna.com",
    "superposta.com",
    "superpotencialex.ru",
    "superputovanja.com",
    "superraise.com",
    "superreload.site",
    "superrico.market",
    "superrito.com",
    "supersaiyagod.com",
    "supersentai.ru",
    "supersentai.space",
    "superstachel.de",
    "superstarvideo.ru",
    "supersufficiency.best",
    "supertechguys.com",
    "supertemporarymails.tk",
    "supertotobet.tv",
    "supertux.net",
    "superurotrinz.ru",
    "supervet.nu",
    "supervideofriends.com",
    "superweblink.ga",
    "superwork-ufa.ru",
    "superxml.icu",
    "superyacht-glass.com",
    "superzaym.ru",
    "suplemento.club",
    "supopenersir.website",
    "suport.com",
    "suppdiwaren.ddns.me.uk",
    "supperesierfaster.xyz",
    "supplement-analysis.com",
    "supplyhuse.com",
    "supplylist.org",
    "suppoint.ru",
    "support-tes.ru",
    "support22services.com",
    "supporthpprinters.com",
    "supporttheroundhouse.org",
    "supportusdad.org",
    "suppreme.ru",
    "supras.xyz",
    "supremeairbnb.com",
    "suprememedicinal.com",
    "supremepowerblog.com",
    "supremesewingmachines.com",
    "supremesteroids.se",
    "supremun.com",
    "suprisez.com",
    "supstat.us",
    "surabayakerja.info",
    "surat.com",
    "surat.ddnsfree.com",
    "suratku.dynu.net",
    "suratuntukpresiden.org",
    "surdany.site",
    "suredisc.info",
    "surely-group.com",
    "surelyfocus.com",
    "suremail.info",
    "suremail.ml",
    "sureoffers.com",
    "surewest.com",
    "surf3.net",
    "surfando.info",
    "surfcasino6.club",
    "surfdayz.com",
    "surfingwithsarah.com",
    "surflepo.cf",
    "surflepo.ga",
    "surflepo.gq",
    "surflepo.ml",
    "surflepo.tk",
    "surfmail.tk",
    "surfree.com",
    "surfsupnet.net",
    "surfy.net",
    "surga.ga",
    "surgical.net",
    "surimail.com",
    "surjuebu.cf",
    "surjuebu.ga",
    "surjuebu.ml",
    "surjuebu.tk",
    "surl2.info",
    "surou.xyz",
    "surpluscartridges.com",
    "surpriseinbox.ru",
    "surveihtyf.space",
    "surveillancefast.xyz",
    "surveyrecruiters.com",
    "surveyrnonkey.net",
    "surveysaypanel.com",
    "surveyswingnut.top",
    "survivalgearsrocks.com",
    "survivalistmagazine.net",
    "survivan.com",
    "survivormail.com",
    "survivvruscorona.us",
    "susanwatkin.com",
    "susbeicent.cf",
    "susbeicent.ga",
    "susbeicent.ml",
    "susbeicent.tk",
    "suscenko.com",
    "suschnost.ru",
    "suse.de",
    "sushi10valladolid.com",
    "sushiandsteak.com",
    "sushibartor.com",
    "sushida-dublin.com",
    "sushimail.xyz",
    "sushiojibarcelona.com",
    "sushisalonbadalona.com",
    "sushitrifasicrubi.com",
    "susi.ml",
    "susictlano.com",
    "susictlano.icu",
    "susmaso.ml",
    "susmaso.tk",
    "susmed.site",
    "sustainable.style",
    "sustainable.trade",
    "sustainabledevelopmentexperts.com",
    "sustaingoods.com",
    "sustalifes.website",
    "sustavampomogi1.host",
    "sustavampomogi2.host",
    "sustpro.host",
    "sustpro1.host",
    "sustpro2.host",
    "sustvervia.ml",
    "sustvervia.tk",
    "susudomino.net",
    "susuk99.net",
    "susungaple.org",
    "susupk.com",
    "susupoker.biz",
    "sususegarcoy.tk",
    "sutann.us",
    "sutbet71.com",
    "sutbet72.com",
    "sutbet77.com",
    "sutbet78.com",
    "sute.jp",
    "sutener.academy",
    "sutener.life",
    "sutgetel.cf",
    "sutgetel.ml",
    "sutiami.cf",
    "sutiami.ga",
    "sutiami.gq",
    "sutiami.ml",
    "sutoplamasi.org",
    "sutratoto.net",
    "sutratoto.org",
    "suttonsales.com",
    "sutuosi.com",
    "suubuapp.com",
    "suvidok.com",
    "sux47.top",
    "suxt3eifou1eo5plgv.cf",
    "suxt3eifou1eo5plgv.ga",
    "suxt3eifou1eo5plgv.gq",
    "suxt3eifou1eo5plgv.ml",
    "suxt3eifou1eo5plgv.tk",
    "suzki.us",
    "suzukilab.net",
    "sv-rs.org",
    "svadba-city.ru",
    "svaekrut.ru",
    "svaffshop.store",
    "svapomaxi.store",
    "svapostore.online",
    "svbil.nu",
    "svblime.org",
    "svblog.com",
    "svbrokers.tech",
    "svds.de",
    "svedaengineering.com",
    "svegott.com",
    "svegott.se",
    "svelteschool.net",
    "svendsen.dk",
    "svenskonlinebingo.se",
    "sverigeloparen.online",
    "sverigespel.com",
    "svet-web.ru",
    "svetanet.ru",
    "svetavarganova.ru",
    "svetekonom.ru",
    "svetlana-vesna.ru",
    "svetlie-okna.ru",
    "svhu5u.us",
    "svi.space",
    "svi88.com",
    "sviblovo.net",
    "svileetrw.shop",
    "svino.ru",
    "svinomir.ru",
    "svip520.cn",
    "svk.jp",
    "svobodaototnoshenii.ru",
    "svobodnayapressa.ru",
    "svoedingen.club",
    "svojhozdom.ru",
    "svoystvaproduktov.ru",
    "svoyzarabotokvinternete.ru",
    "svpmail.com",
    "svpowo.com",
    "svptkdkk.shop",
    "svsmoney.ru",
    "svws-tbr.com",
    "svxr.org",
    "sw-mg.com",
    "sw2244.com",
    "sw8.dev",
    "sw8y2c.stream",
    "swagflavor.com",
    "swagmami.com",
    "swakdesigns.info",
    "swankyfood.us",
    "swap-crypto.site",
    "swapandbid.com",
    "swapinsta.com",
    "swappingfantasy.com",
    "swarmbra.xyz",
    "swarmhabi.us",
    "swarmonio.us",
    "swarmrout.email",
    "swarmroute.recipes",
    "swbell.net",
    "swbpepper.com",
    "sweang.club",
    "sweatankreq.email",
    "sweatmail.com",
    "sweatwaterbrew.com",
    "sweb.cz",
    "swedenmail.com",
    "swedishcomics.se",
    "swedishpalms.online",
    "sweely.net",
    "sweeneybuildings.com",
    "sweepstakes956zh.online",
    "sweet-emotions.ru",
    "sweet-ro.com",
    "sweet3d.com",
    "sweet82.com",
    "sweetagsfer.cf",
    "sweetagsfer.gq",
    "sweetagsfer.ml",
    "sweetbac.xyz",
    "sweetcrac.email",
    "sweetlarep.cf",
    "sweetlarep.gq",
    "sweetmatch.se",
    "sweetmemories.shop",
    "sweetmessage.ga",
    "sweetob.email",
    "sweetobe.email",
    "sweetpotato.ml",
    "sweetpotatoconvention2019.com",
    "sweetrea.icu",
    "sweetreac.xyz",
    "sweetstory.info",
    "sweetswallet.com",
    "sweetuni.icu",
    "sweetvibes-bakery.com",
    "sweetvibes-weddingcakes.com",
    "sweetville.net",
    "sweetwaters.site",
    "sweetxxx.de",
    "sweetyberry.ru",
    "swellslu.space",
    "swerpossa.ga",
    "swerpossa.gq",
    "swerpossa.tk",
    "swibe.space",
    "swift-auto.info",
    "swift-mail.com",
    "swift-mail.net",
    "swift10minutemail.com",
    "swiftcoin.org",
    "swiftdesk.com",
    "swiftselect.com",
    "swiftsnapshot.com",
    "swimdies.com",
    "swimmingpoolbuildersleecounty.com",
    "swimmingshop.life",
    "swimskivvies.com",
    "swimweear.ru",
    "swindonfans.com",
    "swinefu.com",
    "swingeasyhithard.com",
    "swingers.dance",
    "swingers69colombia.com",
    "swingery.com",
    "swingfan.com",
    "swipeche.icu",
    "swipeeat.com",
    "swipermail.zzn.com",
    "swipesei.xyz",
    "swippii.com",
    "swipwebma.cf",
    "swipwebma.ga",
    "swipwebma.gq",
    "swipwebma.ml",
    "swipwebma.tk",
    "swirve.com",
    "swiss-bank-advisory.org",
    "swissbupx.space",
    "swissinfo.org",
    "swissmail.com",
    "swissmail.net",
    "swissonline.ch",
    "swissreplicawatches.info",
    "swisssportsblog.site",
    "switchboardmail.com",
    "switchbrand.com",
    "switchmyrb.space",
    "switunfuh.ga",
    "switunfuh.gq",
    "switunfuh.ml",
    "switzerland.org",
    "swkvbo.us",
    "swlnrf.com",
    "swlrhqhz.pro",
    "swmhw.com",
    "swngkng.info",
    "swngkng.org",
    "swnws.press",
    "swomc.com",
    "sworda.com",
    "swordange.com",
    "swordcapital.com",
    "swordsgarden-ongar.com",
    "swordsstreets.top",
    "swordssword.com",
    "swosswou.shop",
    "swq213567mm.cf",
    "swq213567mm.ga",
    "swq213567mm.gq",
    "swq213567mm.ml",
    "swq213567mm.tk",
    "swskrgg4m9tt.cf",
    "swskrgg4m9tt.ga",
    "swskrgg4m9tt.gq",
    "swskrgg4m9tt.ml",
    "swskrgg4m9tt.tk",
    "swva.net",
    "swype.dev",
    "sx172.com",
    "sxatli.info",
    "sxbsfz.info",
    "sxfkln.com",
    "sxh-auto.com",
    "sxiii.design",
    "sxkhyxy.com",
    "sxouq.com",
    "sxv5e.xyz",
    "sxxx.ga",
    "sxxx.gq",
    "sxxx.ml",
    "sxylc113.com",
    "sxzevvhpmitlc64k9.cf",
    "sxzevvhpmitlc64k9.ga",
    "sxzevvhpmitlc64k9.gq",
    "sxzevvhpmitlc64k9.ml",
    "sxzevvhpmitlc64k9.tk",
    "sy-honda.com",
    "sy168.cash",
    "sy90xo.us",
    "syadouchebag.com",
    "syandard.com",
    "sycdns.com",
    "sycoshoppers.com",
    "sydney-feuerwerk.info",
    "sydneydeluxe.com",
    "sydneyheraldmorning.site",
    "sydneypoolstoday.one",
    "syf51.space",
    "syfer.shop",
    "syfyfigi.website",
    "sygaxa.info",
    "sygj3.com",
    "sygj6065.com",
    "sygj6067.com",
    "sygj7070.com",
    "sygj7073.com",
    "sygj7076.com",
    "sygj7077.com",
    "sygj7078.com",
    "sygj8081.com",
    "sygj8086.com",
    "sygj9090.com",
    "sygj9096.com",
    "sygodainetlikereward.top",
    "syhyma.info",
    "syihpo.com",
    "syjiga.info",
    "syjxwlkj.com",
    "sykcloud.live",
    "syktyv.ru",
    "sylvannet.com",
    "sylviabartley.com",
    "sylxe8.us",
    "symatoys.ru",
    "symbiote.network",
    "symeil.fun",
    "sympathizing615ve.online",
    "sympatico.ca",
    "symphonyresume.com",
    "symphouva.gq",
    "symphouva.ml",
    "symphouva.tk",
    "symplysliphair.com",
    "symposium.site",
    "symproti.ga",
    "symproti.tk",
    "symptombrick.us",
    "symptomsofdiabetes.us",
    "synagogue3000.org",
    "synami.com",
    "synapse.foundation",
    "synb.loan",
    "syncbt.com",
    "synchrosign.net",
    "synchrpny.com",
    "syncretizes167mg.online",
    "syncrome.com",
    "synecious17mc.online",
    "synergie.tk",
    "synergisticmel.com",
    "synergygrapeandwinesolutions.com",
    "synergyj.com",
    "synonem.com",
    "synonyme.email",
    "syntexhosting.space",
    "syntheticsportsgroup.com",
    "syntrop.com",
    "syom.com",
    "syosetu.gq",
    "syozv.us",
    "syracusequote.com",
    "syriamail.com",
    "syrlzyw.com",
    "syrus.website",
    "sysblogd.com",
    "sysnon.com",
    "sysology.tech",
    "syssnaapbet.xyz",
    "system-2123.com",
    "system-2125.com",
    "system-765.com",
    "system-765.info",
    "system-962.com",
    "system-962.org",
    "system573.org",
    "systemnet.club",
    "systemoases.com",
    "systemslender.com",
    "sysv2.com",
    "syswars.com",
    "sytadel.net",
    "sytes.net",
    "syujob.accountants",
    "sywa4c.us",
    "sywjgl.com",
    "syyuledl.com",
    "syyulept.com",
    "syzyjd.com",
    "sz-wbqz.com",
    "sz13l7k9ic5v9wsg.cf",
    "sz13l7k9ic5v9wsg.ga",
    "sz13l7k9ic5v9wsg.gq",
    "sz13l7k9ic5v9wsg.ml",
    "sz13l7k9ic5v9wsg.tk",
    "szbxlp.cn",
    "szccc.org",
    "szcyd6.info",
    "szela.net",
    "szeptem.pl",
    "szerz.com",
    "szgztxh.com",
    "szhtkyj.com",
    "szi4edl0wnab3w6inc.cf",
    "szi4edl0wnab3w6inc.ga",
    "szi4edl0wnab3w6inc.gq",
    "szi4edl0wnab3w6inc.ml",
    "szi4edl0wnab3w6inc.tk",
    "szsb.de",
    "szsboiler.group",
    "szseo.info",
    "sztyweta46.ga",
    "szucsati.net",
    "szvezhsuu.shop",
    "szxkjx.com",
    "szyk10.com",
    "t-brand.online",
    "t-email.org",
    "t-kitchen.online",
    "t-knife.store",
    "t-online.biz",
    "t-online.ch",
    "t-online.co",
    "t-online.de",
    "t-online.hu",
    "t-online.info",
    "t-rexcomfort.ru",
    "t-s-k.net",
    "t-shirtcasual.com",
    "t-shoponline.info",
    "t-student.cf",
    "t-student.ga",
    "t-student.gq",
    "t-student.ml",
    "t-student.tk",
    "t.119fk.com",
    "t.odmail.cn",
    "t.pl",
    "t.psh.me",
    "t.zibet.net",
    "t099.tk",
    "t0hedz.us",
    "t0tsdf.com",
    "t13kli.info",
    "t165.xyz",
    "t166.xyz",
    "t167.xyz",
    "t16nmspsizvh.cf",
    "t16nmspsizvh.ga",
    "t16nmspsizvh.gq",
    "t16nmspsizvh.ml",
    "t16nmspsizvh.tk",
    "t171.xyz",
    "t1bkooepcd.cf",
    "t1bkooepcd.ga",
    "t1bkooepcd.gq",
    "t1bkooepcd.ml",
    "t1bkooepcd.tk",
    "t1g2vf.us",
    "t1osie.us",
    "t24e4p7.com",
    "t2mail.com",
    "t3-travel.com",
    "t30ks.us",
    "t3echmoflhipro.ga",
    "t3g29.com",
    "t3lam.com",
    "t3mtxgg11nt.cf",
    "t3mtxgg11nt.ga",
    "t3mtxgg11nt.gq",
    "t3mtxgg11nt.ml",
    "t3mtxgg11nt.tk",
    "t3sl4.xyz",
    "t3t97d1d.com",
    "t3transitions.com",
    "t4eas6.us",
    "t4jpol.us",
    "t4ruhk.us",
    "t500track6.com",
    "t55r.com",
    "t5h65t54etttr.cf",
    "t5h65t54etttr.ga",
    "t5h65t54etttr.gq",
    "t5h65t54etttr.ml",
    "t5h65t54etttr.tk",
    "t5it.icu",
    "t5jnghjjh.xyz",
    "t5mrk3.site",
    "t5vbxkpdsckyrdrp.cf",
    "t5vbxkpdsckyrdrp.ga",
    "t5vbxkpdsckyrdrp.gq",
    "t5vbxkpdsckyrdrp.ml",
    "t5vbxkpdsckyrdrp.tk",
    "t60111.com",
    "t60222.com",
    "t60444.com",
    "t60555.com",
    "t60999.com",
    "t6ixy.us",
    "t6khsozjnhqr.cf",
    "t6khsozjnhqr.ga",
    "t6khsozjnhqr.gq",
    "t6khsozjnhqr.ml",
    "t6khsozjnhqr.tk",
    "t6xeiavxss1fetmawb.ga",
    "t6xeiavxss1fetmawb.ml",
    "t6xeiavxss1fetmawb.tk",
    "t7qriqe0vjfmqb.ga",
    "t7qriqe0vjfmqb.ml",
    "t7qriqe0vjfmqb.tk",
    "t822.com",
    "t8kco4lsmbeeb.cf",
    "t8kco4lsmbeeb.ga",
    "t8kco4lsmbeeb.gq",
    "t8kco4lsmbeeb.ml",
    "t8kco4lsmbeeb.tk",
    "t8ndq7.site",
    "t8oka.us",
    "t97998.com",
    "t9lw.us",
    "t9trqb.us",
    "ta100.app",
    "ta16.app",
    "ta17.app",
    "ta18.app",
    "ta19.app",
    "ta1ysd.us",
    "ta20.app",
    "ta21.app",
    "ta22.app",
    "ta23.app",
    "ta25.app",
    "ta26.app",
    "ta27.app",
    "ta28.app",
    "ta29.app",
    "ta30.app",
    "ta35.app",
    "ta36.app",
    "ta37.app",
    "ta39.app",
    "ta40.app",
    "ta42.app",
    "ta43.app",
    "ta48.app",
    "ta49.app",
    "ta50.app",
    "ta52.app",
    "ta53.app",
    "ta54.app",
    "ta56.app",
    "ta58.app",
    "ta60.app",
    "ta61.app",
    "ta62.app",
    "ta64.app",
    "ta65.app",
    "ta67.app",
    "ta68.app",
    "ta69.app",
    "ta70.app",
    "ta72.app",
    "ta74.app",
    "ta75.app",
    "ta77.app",
    "ta78.app",
    "ta7qcm-mail.xyz",
    "ta83.app",
    "ta85.app",
    "ta88.app",
    "ta89.app",
    "ta91.app",
    "ta93.app",
    "ta96.app",
    "taac.space",
    "taago.app",
    "taalunie43.gq",
    "taate.live",
    "tab365.asia",
    "tabanpuanlaritr.com",
    "tabcomons.cf",
    "tabcomons.gq",
    "tabcomons.tk",
    "tabcupen.ml",
    "tabcupen.tk",
    "tabelon.com",
    "tabienrayong.com",
    "tablebla.icu",
    "tabledoug.icu",
    "tableexi.icu",
    "tablegdwnzx.email",
    "tablegu.icu",
    "tableri.xyz",
    "tablerive.xyz",
    "tabletcraze.com",
    "tabletmop.shop",
    "tabletshop.live",
    "tabletsshop.futbol",
    "tabpheket.ml",
    "tabpheket.tk",
    "tabtop.site",
    "tac-c.center",
    "tac0hlfp0pqqawn.cf",
    "tac0hlfp0pqqawn.ga",
    "tac0hlfp0pqqawn.ml",
    "tac0hlfp0pqqawn.tk",
    "tacanas.com",
    "tacc.center",
    "tacdasupp.cf",
    "tacdasupp.gq",
    "tacdasupp.ml",
    "tacdasupp.tk",
    "tacemonarim.net",
    "tacodelphia.com",
    "tacomaquote.com",
    "tactmagfi.cf",
    "tactmagfi.gq",
    "tactmagfi.ml",
    "tactmagfi.tk",
    "tadabe.cf",
    "tadabe.ga",
    "tadabe.gq",
    "tadabe.ml",
    "tadena.cf",
    "tadena.ga",
    "tadena.gq",
    "tadena.ml",
    "tafayati.com",
    "taffeta.xyz",
    "tafhxx.com",
    "tafilfa.gq",
    "tafilfa.ml",
    "tafilfa.tk",
    "tafmail.com",
    "tafo.site",
    "tafoi.gr",
    "tagasayolf.site",
    "tagcchandda.cf",
    "tagcchandda.ga",
    "tagcchandda.gq",
    "tagcchandda.ml",
    "tagcchandda.tk",
    "tagebuch-online.de",
    "taginsa.ml",
    "taglead.com",
    "tagmymedia.com",
    "tagsmiths.com",
    "tagyourself.com",
    "tahhkm.site",
    "tahiroztan.com",
    "tahltan.best",
    "tahminbet33.com",
    "taho21.ru",
    "tahoemediacenter.com",
    "tahss.us",
    "tahutex.online",
    "tahutex.xyz",
    "tai-asu.cf",
    "tai-asu.ga",
    "tai-asu.gq",
    "tai-asu.ml",
    "tai789.fun",
    "taicaiwang.xyz",
    "taichinh.icu",
    "taichungpools.com",
    "taijic.com",
    "taikhoanao.tk",
    "taikz.com",
    "taileqzu.site",
    "tailfinsports.com",
    "tailoredsuit.net",
    "tailorgolfclub.se",
    "tailormailed.online",
    "taimeha.cf",
    "taimeha.gq",
    "taimladpho.cf",
    "taimladpho.ga",
    "taimladpho.gq",
    "taimladpho.ml",
    "taimladpho.tk",
    "tainerfitness.com",
    "taipand4d.xyz",
    "taiqicc.com",
    "taitro.asia",
    "taiv8.fun",
    "taiv8.win",
    "taiviani.cf",
    "taiviani.gq",
    "taiviani.ml",
    "taiviani.tk",
    "taivic.win",
    "taivin.club",
    "taiwanlegacy.com",
    "taiwanzijia.com",
    "taix8.fun",
    "taixiu88.com",
    "tajmahalgallery.org",
    "tajmahalterrassa.com",
    "takaphis.cf",
    "takaphis.ga",
    "takaphis.tk",
    "takasimurah.xyz",
    "takato.shop",
    "takawin.com",
    "takbt1.xyz",
    "takcasinocrayon.ru",
    "takdhinadhin.com",
    "take-great-prize2.life",
    "take-prizes-away13.life",
    "take-prizes-away14.life",
    "take-scroll.xyz",
    "takeawaymessenger.com",
    "takeawayonlineordering.com",
    "takebacktheregent.com",
    "takecafxte.space",
    "takedowns.org",
    "takegatgame.fun",
    "takeitme.site",
    "takemeback.net",
    "takemehome188.com",
    "takemy.xyz",
    "takeny18.com",
    "takeshobo.cf",
    "takeshobo.ga",
    "takeshobo.gq",
    "takeshobo.ml",
    "takeshobo.tk",
    "takesmymoney.com",
    "takevps.com",
    "takewokmadrid.com",
    "takeyourkids2vote.org",
    "takhfifweb.net",
    "takipcisatinal.shop",
    "takipsel.com",
    "takmemberi.cf",
    "takmemberi.gq",
    "takoe.com",
    "takoe.net",
    "takopok32.xyz",
    "takotook.xyz",
    "takradgivning.se",
    "takrayaneh.com",
    "takshoot21.online",
    "takshotgh16.site",
    "taksi-bonus.ru",
    "taksibu.com",
    "taksicininkeyfi.com",
    "taksiklin.ru",
    "taktikbet.xyz",
    "taktikvip.xyz",
    "takuino.app",
    "takuyakimura.com",
    "talamovieoo.xyz",
    "talamovieqq.xyz",
    "talamoviess.xyz",
    "talamoviett.xyz",
    "talamovieuu.xyz",
    "talamovievv.xyz",
    "talamovieww.xyz",
    "talaskayadibi.xyz",
    "talduken.com",
    "taledhosting.online",
    "taleem.life",
    "talenastemerick.com",
    "talent.dk",
    "talentasolutions.org",
    "talentstar.news",
    "talifornialegal.com",
    "taliforniaras.com",
    "talifors.com",
    "talile.org",
    "talismana.ru",
    "taliumhealthkick.com",
    "talk-brilliance.com",
    "talk21.com",
    "talkcity.com",
    "talken.net",
    "talkinator.com",
    "talkingnews.media",
    "talkmises.com",
    "talktalk.co.uk",
    "talktalk.net",
    "talktocoupons.com",
    "talktoip.com",
    "talktravel.net",
    "tallcity.email",
    "tallcitysportsnetwork.com",
    "talldry.com",
    "taller-de-escritura-mallorca.com",
    "tallerdeescrituracreativa.org",
    "tallerfor.xyz",
    "tallerplural.org",
    "tallyscrapper.com",
    "talmdesign.com",
    "talmo.online",
    "talnarow.cf",
    "talnarow.ga",
    "talnarow.tk",
    "talterat.site",
    "taluabushop.com",
    "talwellden.ga",
    "talwellden.ml",
    "tamarahillard.com",
    "tamb.ru",
    "tambahlagi.online",
    "tambakrejo.cf",
    "tambakrejo.ga",
    "tambakrejo.tk",
    "tambalamin.info",
    "tambour.site",
    "tambroker.ru",
    "tamcasinomice.ru",
    "tamfiyat.online",
    "tamgulsuyu.com",
    "tamil.com",
    "tamiljukes.info",
    "tamilnadumillsstores.org",
    "tamkorumafiltre.club",
    "tammaihes.cf",
    "tammaihes.ga",
    "tammaihes.ml",
    "tammaihes.tk",
    "tampabay.rr.com",
    "tampabayluxuryagent.com",
    "tampadates.info",
    "tampaorthopedicsurgeon.com",
    "tamparealty.store",
    "tampicobrush.org",
    "tampicobrushes.com",
    "tampicobrushes.us",
    "tamtam-buzz.xyz",
    "tamtam-info.site",
    "tamtam-info.xyz",
    "tamtam-minute.site",
    "tamtam-minute.xyz",
    "tamtam-topinfo.site",
    "tamtam-topinfo.xyz",
    "tamtam-topnews.site",
    "tamu99.info",
    "tamu99.net",
    "tamuhost.me",
    "tanahsubur.net",
    "tandberggroup.com",
    "tandbergonline.com",
    "tandcpg.com",
    "tandoori-bite-takeaway.com",
    "tandy.co",
    "tangelo.dev",
    "tangkaskitaid.org",
    "tangkasnetid.site",
    "tanglotto.net",
    "tangmonkey.com",
    "tani-japanese-takeaway.com",
    "taniesianie.online",
    "tanivi.ga",
    "tanivi.gq",
    "tanivi.ml",
    "tanivi.tk",
    "tanjorepalacetakeaway.com",
    "tankbrush.us",
    "tankbrushes.net",
    "tanke.dk",
    "tanklipho.cf",
    "tanklipho.ml",
    "tanklipho.tk",
    "tankpolice.com",
    "tankult-tech.com",
    "tankult.com",
    "tanning-bed-bulbs.com",
    "tanningcoupon.com",
    "tanqeep.com",
    "tansmail.ga",
    "tansof.press",
    "tanstipplesix.website",
    "tantbepha.cf",
    "tantbepha.ga",
    "tantbepha.ml",
    "tantedewi.ml",
    "tantennajz.com",
    "tantifilm.tools",
    "tantra-for-couples.com",
    "tantraclassesonline.com",
    "tantrafirefitness.com",
    "tantraforhealth.com",
    "tantralube.com",
    "tantraprostatehealing.com",
    "tantrareview.com",
    "tantraspeeddating.com",
    "tantratv.com",
    "tantricrose.net",
    "tantricrose.org",
    "tanttermerk.tk",
    "tanukis.org",
    "tanya-odintsova.ru",
    "tanyamauldin.com",
    "tanzaniawild.life",
    "tao-fitness.ru",
    "taobao0710.com",
    "taohoso.com",
    "taojav.club",
    "taojav.life",
    "taolan68.com",
    "taosjw.com",
    "taotaotano.com",
    "taoyuan.chat",
    "taoyuanguo.chat",
    "taoyuanguo.network",
    "taozuizhi.com",
    "tap.vin",
    "tap7p4.site",
    "tapchicuoihoi.com",
    "tapeamos.com",
    "tapecompany.com",
    "tapecopy.net",
    "taperianuevoriofrio.com",
    "taphear.com",
    "tapi.re",
    "tapiitudulu.com",
    "tapkat.net",
    "tapmups.space",
    "tapreport.net",
    "tapreta.cf",
    "tapreta.ga",
    "tapreta.gq",
    "tapreta.ml",
    "tapreta.tk",
    "tapsitoaktl353t.ga",
    "taptype.me",
    "tapvpnfree.website",
    "tar00ih60tpt2h7.cf",
    "tar00ih60tpt2h7.ga",
    "tar00ih60tpt2h7.gq",
    "tar00ih60tpt2h7.ml",
    "tar00ih60tpt2h7.tk",
    "taraftarium.xyz",
    "taraftartekstil.com",
    "taramsinc.com",
    "taranfilm.ru",
    "taranpa.ga",
    "tarassis.xyz",
    "tarbity.cf",
    "tarbity.tk",
    "tarbyti.cf",
    "tarbyti.gq",
    "tarbyti.ml",
    "tarcompme.cf",
    "tarcompme.tk",
    "tardharto.cf",
    "tardharto.ga",
    "tardharto.gq",
    "tardharto.ml",
    "tardharto.tk",
    "taresz.ga",
    "tarfand.city",
    "target35.ru",
    "targeting.space",
    "targetqq.live",
    "tarifmanya.com",
    "tariqa-burhaniya.com",
    "tarisjohn.cf",
    "tarisjohn.gq",
    "tarisjohn.ml",
    "taritensystems.com",
    "tarjetasdecredito.company",
    "tarjoman.shop",
    "tarlancapital.com",
    "tarma.cf",
    "tarma.ga",
    "tarma.ml",
    "tarma.tk",
    "tarminolek.ru",
    "tarocena.com",
    "tarpiohumph.ga",
    "tarpiohumph.gq",
    "tarponspringsapartments.com",
    "tarriqaw.cf",
    "tarriqaw.ga",
    "tarriqaw.gq",
    "tarrylforsenate.com",
    "tarsiergames.com",
    "tartoor.club",
    "tartoor.com",
    "tartoor.fun",
    "tartoor.space",
    "taruhangame.com",
    "taruhantop.com",
    "tarzanmail.cf",
    "tarzanmail.ml",
    "tarzinaslibu.xyz",
    "tarzkombin.xyz",
    "tarzmen.site",
    "tasarimsozluk.xyz",
    "tasarrufdostu.com",
    "tasarrufladugun.com",
    "tascon.com",
    "taserra.ga",
    "tasgourmettour.com",
    "tashjw.com",
    "tasityonetimmerkezi.com",
    "taskboard.app",
    "taskforcetech.com",
    "taskscbo.com",
    "tastaravalli.tk",
    "taste2table.com",
    "tastefuldeparture.info",
    "tastemyjuices.press",
    "tastiethc.com",
    "tastmig.dk",
    "tastrg.com",
    "tasty-burger-takeaway.com",
    "tasty-drop.org",
    "tasty-garden-takeaway.com",
    "tastychina-dundalk.com",
    "tastycold.com",
    "tastydota.net",
    "tastydrop.online",
    "tastydrops.net",
    "tastyemail.xyz",
    "tastygo.info",
    "tastygo.org",
    "tastygo.ru",
    "tastygo.su",
    "tastygra.icu",
    "tastylacks.info",
    "tastytri.icu",
    "tastywide.xyz",
    "tat4free.ru",
    "tataba.com",
    "tatanova.com",
    "tatasteellongproducts.net",
    "tatasteellongproductslimited.net",
    "tatasteellpl.com",
    "tatasteellpl.info",
    "tatekub.info",
    "tatibu.cf",
    "tatibu.ga",
    "tatibu.gq",
    "tatibu.ml",
    "tatibu.tk",
    "tatisa.cf",
    "tatisa.ga",
    "tatisa.gq",
    "tatlihesap.org",
    "tattooedallover.com",
    "tattoofanatic.com",
    "tattoos.name",
    "tattooscollectionforgirl.site",
    "tatubet.biz",
    "tatulivescream.com",
    "tau.io",
    "taucoindo.site",
    "taufik.sytes.net",
    "taufikrt.ddns.net",
    "taupoker.org",
    "taureans.co.uk",
    "taureesur.cf",
    "taureesur.ga",
    "taureesur.gq",
    "taureesur.ml",
    "taurefor.cf",
    "taurefor.ga",
    "taurefor.gq",
    "taurefor.ml",
    "taurefor.tk",
    "taurusbet.org",
    "tauttjar3r46.cf",
    "tav7px.com",
    "tavares.com",
    "tavinmathai.com",
    "tavridatreks.ru",
    "tawaza.ru",
    "tawnygrammar.org",
    "taworle.cf",
    "taworle.ga",
    "taworle.gq",
    "taworle.ml",
    "tawowk.com",
    "tawserdog.com",
    "tax315.xyz",
    "taxfilingsite.com",
    "taxi-bonus.ru",
    "taxi-france.com",
    "taxi2malagaairport.com",
    "taxiaugsburg.de",
    "taxidriver.dk",
    "taxififes.info",
    "taxilodka.ru",
    "taximone.ru",
    "taxinyk\xf6ping.se",
    "taxqueries.com",
    "taxsaleclub.com",
    "taxslayerinfo.com",
    "tayk5.com",
    "taylorventuresllc.com",
    "taynguyen24h.net",
    "tayo.ooo",
    "tayohei-official.com",
    "taysirnabulsi.com",
    "tayspirec.ml",
    "tayspirec.tk",
    "tayur-boilers.ru",
    "tb-on-line.net",
    "tb1ou.us",
    "tb20x7cwkmoz738.xyz",
    "tbbo.de",
    "tbeach.ru",
    "tbet90.xyz",
    "tbfnp1.site",
    "tbi0jd.com",
    "tbnovin.org",
    "tboostpro.com",
    "tbs35.ru",
    "tbupapxq.shop",
    "tbwt.com",
    "tbwzidal06zba1gb.cf",
    "tbwzidal06zba1gb.ga",
    "tbwzidal06zba1gb.gq",
    "tbwzidal06zba1gb.ml",
    "tbwzidal06zba1gb.tk",
    "tbxmakazxsoyltu.cf",
    "tbxmakazxsoyltu.ga",
    "tbxmakazxsoyltu.gq",
    "tbxmakazxsoyltu.ml",
    "tbxmakazxsoyltu.tk",
    "tbxqzbm9omc.cf",
    "tbxqzbm9omc.ga",
    "tbxqzbm9omc.gq",
    "tbxqzbm9omc.ml",
    "tbxqzbm9omc.tk",
    "tc.vipset.me",
    "tc4q7muwemzq9ls.ml",
    "tc4q7muwemzq9ls.tk",
    "tcafe.shop",
    "tcbbk.com",
    "tcc.on.ca",
    "tcd.ie",
    "tcfr2ulcl9cs.cf",
    "tcfr2ulcl9cs.ga",
    "tcfr2ulcl9cs.gq",
    "tcfr2ulcl9cs.ml",
    "tcfr2ulcl9cs.tk",
    "tcgun.ru",
    "tchatrencontrenc.com",
    "tchatsenegal.com",
    "tchuestore.xyz",
    "tchvn.tk",
    "tckefu.online",
    "tckefu.site",
    "tckefu.xyz",
    "tcmrw.info",
    "tcmselangor.com",
    "tcnmistakes.com",
    "tcoe.foundation",
    "tcom6a.us",
    "tconamear.cf",
    "tconamear.ga",
    "tconamear.gq",
    "tconamear.ml",
    "tconamear.tk",
    "tcsh6f.site",
    "tcsqzc04ipp9u.cf",
    "tcsqzc04ipp9u.ga",
    "tcsqzc04ipp9u.gq",
    "tcsqzc04ipp9u.ml",
    "tcsqzc04ipp9u.tk",
    "tctp69.xyz",
    "tcua9bnaq30uk.cf",
    "tcua9bnaq30uk.ga",
    "tcua9bnaq30uk.gq",
    "tcua9bnaq30uk.ml",
    "tcua9bnaq30uk.tk",
    "tcxd.xyz",
    "tcyl78.com",
    "td71.us",
    "tda4gi.us",
    "tdbusinessfinancing.com",
    "tdedbaccarat.net",
    "tdf-illustration.com",
    "tdf2623.online",
    "tdfwld7e7z.cf",
    "tdfwld7e7z.ga",
    "tdfwld7e7z.gq",
    "tdfwld7e7z.ml",
    "tdfwld7e7z.tk",
    "tdmoip.ru",
    "tdn-online.info",
    "tdnarat.ru",
    "tdnonline.net",
    "tdpqhr.us",
    "tdrop.ru",
    "tds.net",
    "tdtraveljobs.melbourne",
    "tdtraveljobs.net",
    "tdtraveljobs.sydney",
    "te.caseedu.tk",
    "te2jrvxlmn8wetfs.gq",
    "te2jrvxlmn8wetfs.ml",
    "te2jrvxlmn8wetfs.tk",
    "te5s5t56ts.ga",
    "teachber.com",
    "teachcar.xyz",
    "teacher.com",
    "teachermail.net",
    "teachers.org",
    "teaches-yoga.com",
    "teachfr.xyz",
    "teachglo.xyz",
    "teachmoodle.info",
    "teachmoodle.org",
    "teachsn.xyz",
    "teachsnak.xyz",
    "teachtrun.press",
    "teal.delivery",
    "teal.dev",
    "tealeafdevelopers.com",
    "tealeafexperts.com",
    "tealeafhacker.org",
    "tealeafsolution.com",
    "tealeavesone.com",
    "team30.live",
    "teamandclub.ga",
    "teambogor.online",
    "teamdiscovery.com",
    "teamflow.works",
    "teamjulie.com",
    "teamkg.tk",
    "teamkiller.net",
    "teamliquid.org",
    "teamlogicnj.com",
    "teamopros.com",
    "teamrnd.win",
    "teamrubicon.ong",
    "teamsidealphysiques.com",
    "teamsl.xyz",
    "teamsnacks.online",
    "teamspeak3.ga",
    "teamster.com",
    "teamtimspencer.com",
    "teamtournamenttravel.com",
    "teamtulsa.net",
    "teamwyden.net",
    "teamxpress.org",
    "teardown.site",
    "teasealoo.buzz",
    "teasebre.icu",
    "teaser-team.ru",
    "teasetige.icu",
    "teasetract.us",
    "teasevague.buzz",
    "teasewate.icu",
    "teasewor.xyz",
    "teaseworl.xyz",
    "teatre-afisha.ru",
    "tebaknomor.info",
    "tebardo.cf",
    "tebardo.gq",
    "tebardo.ml",
    "tebardo.tk",
    "teblife.com",
    "tebwinsoi.ooo",
    "tecampto.ga",
    "tecampto.ml",
    "tecbnb.com",
    "tech-center.com",
    "tech-guru.site",
    "tech-mail.net",
    "tech-suit.org",
    "tech.madrid",
    "tech2fly.com",
    "tech4peace.org",
    "tech5group.com",
    "tech69.com",
    "techballball.com",
    "techbike.ru",
    "techblast.ch",
    "techblogs.site",
    "techchakras.com",
    "techdevacademy.info",
    "techdigitalinc.com",
    "techdiver.com",
    "techehouse.com",
    "techemail.com",
    "techeno.com",
    "techenus.com",
    "techewaste.site",
    "techfevo.info",
    "techgroup.me",
    "techgroup.top",
    "techie.com",
    "techiedeals.xyz",
    "techiedevadssecure.club",
    "techiessecrets.com",
    "techiewall.com",
    "techinc.top",
    "techindo.web.id",
    "techjmx.com",
    "techknowlogy.com",
    "techmail.info",
    "techmaximous.com",
    "techmeets.biz",
    "technet.mobi",
    "technicalchartalerts.com",
    "technicolor.cf",
    "technicolor.ga",
    "technicolor.gq",
    "technicolor.ml",
    "techniek.works",
    "techniekgeniek.online",
    "techniekgeniek.shop",
    "techniekgeniek.site",
    "technik-bedarf.com",
    "technikue.men",
    "technisamail.co.za",
    "technivant.net",
    "techno5.club",
    "technoharness.com",
    "technoinsights.info",
    "technoliczni.pl",
    "technologist.com",
    "technologyaddicttreatment.com",
    "technologyaddicttreatmentprogram.com",
    "technologyandstocks.com",
    "technologycipher.com",
    "technopark.site",
    "technoproxy.ru",
    "technotrends-tradingservices.site",
    "technoworks.club",
    "technoworldd.com",
    "technt.org",
    "techpaisa.com",
    "techpointer.com",
    "techpress.info",
    "techproductinfo.com",
    "techreactor.net",
    "techretro.club",
    "techscout.com",
    "techseek.com",
    "techshucareers.com",
    "techsio.pro",
    "techsniper.com",
    "techspot.com",
    "techstore2019.com",
    "techthehalls.nyc",
    "techtrage.com",
    "techtribeph.com",
    "techworm.org",
    "techxs.dx.am",
    "techysocietykisan.xyz",
    "tecinnova.solutions",
    "tecla.ml",
    "teclody.com",
    "tecmur2.org",
    "tecniblend.net",
    "tecnicasdecorativas.com",
    "tecninja.xyz",
    "tecnoleds.net",
    "tecnotutos.com",
    "ted-dhanik.biz",
    "ted-dhanik.net",
    "ted-dhanik.org",
    "ted-dhanik.us",
    "teddhanik.biz",
    "teddhanik.info",
    "teddy-rose-present.ru",
    "tedesafia.com",
    "tedflower.ru",
    "tedguissan.ga",
    "tedguissan.ml",
    "tedguissan.tk",
    "tedlirol.gq",
    "tedlirol.tk",
    "tedlivechat.com",
    "tedspetcountryclub.com",
    "tedswoodworking.science",
    "tedxibadan.com",
    "tedxsziu.ru",
    "tee800.com",
    "teebaum-oel.info",
    "teecheap.store",
    "teedinnan.com",
    "teemia.com",
    "teemo.site",
    "teenadvisors.com",
    "teenagedirtbag.com",
    "teencaptures.com",
    "teeneatingdisordertreatmentcenter.com",
    "teeneatingdisordertreatmentcenters.com",
    "teeneatingdisordertreatmentoptions.com",
    "teenhealth.space",
    "teenhub.online",
    "teenloss.com",
    "teens.dk",
    "teenyscat.com",
    "teeprint.online",
    "teerest.com",
    "teesheet.app",
    "teesheet.golf",
    "teethsowhitepro.com",
    "teewars.org",
    "teezinou.online",
    "teffire.cf",
    "teffire.gq",
    "teffire.ml",
    "teffire.tk",
    "tefibbumb.cf",
    "tefibbumb.ga",
    "tefibbumb.gq",
    "tefibbumb.ml",
    "tefl.ro",
    "teflonbrush.biz",
    "teflonbrush.net",
    "teflonbrush.us",
    "teflonbrushes.us",
    "tefuncsym.tk",
    "tegnabrapal.me",
    "tehdini.cf",
    "tehdini.ga",
    "tehdini.gq",
    "tehdini.ml",
    "tehfor.ru",
    "tehkom-sz.ru",
    "tehno-d.ru",
    "tehnodans.ru",
    "tehnoleader.ru",
    "tehoopcut.info",
    "tehosmotr86.ru",
    "tehran120.xyz",
    "tehs8ce9f9ibpskvg.cf",
    "tehs8ce9f9ibpskvg.ga",
    "tehs8ce9f9ibpskvg.gq",
    "tehs8ce9f9ibpskvg.ml",
    "tehs8ce9f9ibpskvg.tk",
    "tehsliv.ru",
    "tehsusu.cf",
    "tehsusu.ga",
    "tehsusu.gq",
    "tehsusu.ml",
    "tehubpmw.shop",
    "teicrimta.ga",
    "teicrimta.gq",
    "teicrimta.ml",
    "teicrimta.tk",
    "teinfo.ru",
    "tejahomes.icu",
    "tejas21.com",
    "tejeiro.best",
    "tejsolpro.us",
    "tekear.com",
    "tekfenyem.com",
    "tekhletbo.cf",
    "tekhletbo.ga",
    "tekhletbo.gq",
    "tekhletbo.ml",
    "tekhnoiservis.ru",
    "tekhsnab.ru",
    "tekirdagdagyenicesi.xyz",
    "tekirdagemlakcilar.xyz",
    "tekirdagtanitim.com",
    "tekirdagtanitim.xyz",
    "tekknos.com",
    "tekkoree.cf",
    "tekkoree.ga",
    "tekkoree.gq",
    "tekkulanim.com",
    "teknik.dk",
    "teknikservisglobal.xyz",
    "teknodiot.net",
    "teknopena.com",
    "teknostar.ru",
    "teknow.site",
    "tekrefurb.com",
    "tekstilcephegiydirme.com",
    "tekstilmimarisi.com",
    "tekstilyapilar.com",
    "telasmercamoda.com",
    "telcosan.net",
    "telcosan.org",
    "telcosantechnology.com",
    "telcosanteknoloji.com",
    "tele1europe.online",
    "tele2.at",
    "tele2.nl",
    "teleasistencia.page",
    "telebot.com",
    "telebot.net",
    "telecama.com",
    "telechargement-film.net",
    "telechargement-film.xyz",
    "telechargermusique.live",
    "telecineon.co",
    "telecomhomeservice.com",
    "telecomix.pl",
    "telecomuplinks.com",
    "telectrl.com",
    "telefan.ru",
    "telefondacanlisohbetler.site",
    "telefone-ping.ru",
    "telefonica.net",
    "telefoondock.online",
    "telegilit.monster",
    "telegmail.com",
    "telego446.com",
    "telegraaf-24.host",
    "telegraf-sppbb.ru",
    "telegram.moe",
    "telegraph.co.uk",
    "telekgaring.cf",
    "telekgaring.ga",
    "telekgaring.gq",
    "telekgaring.ml",
    "telekom-mail.com",
    "telekteles.cf",
    "telekteles.ga",
    "telekteles.gq",
    "telekteles.ml",
    "telekucing.cf",
    "telekucing.ga",
    "telekucing.gq",
    "telekucing.ml",
    "teleline.es",
    "telelogs.net",
    "telemetricop.com",
    "telenet.be",
    "telenormail.rs",
    "teleosaurs.xyz",
    "telepac.pt",
    "telephone-conferencing.com",
    "telephonesystemsforbusiness.com",
    "teleport-pskov.ru",
    "teleport.ch",
    "telerymd.com",
    "teleserve.dynip.com",
    "teleseryegroup.ru",
    "teleshop.org",
    "teletu.it",
    "televega.net",
    "teleworm.com",
    "teleworm.us",
    "telexplorer.info",
    "telfordpasy.info",
    "telfort.nl",
    "telfortglasvezel.nl",
    "telia.com",
    "telinco.net",
    "telkom.net",
    "telkomsa.net",
    "tellectualpress.com",
    "tellno1.com",
    "tellos.xyz",
    "tellsearch.network",
    "tellthestory.info",
    "telly.app",
    "tellyoursurvivorstory.org",
    "telmedchiropractic.com",
    "telmex.com",
    "telnoratti.net",
    "telo5.ru",
    "telpage.net",
    "tels920cb.online",
    "telsmart.info",
    "telstra.com",
    "telstra.com.au",
    "telugump3hits.com",
    "telugusongs.info",
    "telukmeong1.ga",
    "telukmeong2.cf",
    "telukmeong3.ml",
    "telus.net",
    "teman-bangsa.com",
    "tembak4d.online",
    "temecon.cf",
    "temecon.gq",
    "temecon.ml",
    "temeculahomecenter.com",
    "temengaming.com",
    "temhuv.com",
    "temiznetwork.xyz",
    "temp-cloud.net",
    "temp-emails.com",
    "temp-link.net",
    "temp-mail.com",
    "temp-mail.de",
    "temp-mail.info",
    "temp-mail.life",
    "temp-mail.live",
    "temp-mail.ml",
    "temp-mail.net",
    "temp-mail.org",
    "temp-mail.pp.ua",
    "temp-mail.ru",
    "temp-mails.com",
    "temp.aogoen.com",
    "temp.bartdevos.be",
    "temp.cloudns.asia",
    "temp.emeraldwebmail.com",
    "temp.headstrong.de",
    "temp.mail.y59.jp",
    "temp.qwertz.me",
    "temp.wheezer.net",
    "temp1.club",
    "temp15qm.com",
    "temp2.club",
    "tempail.com",
    "tempalias.com",
    "tempat-main-poker.xyz",
    "tempathiburan.com",
    "tempathiburan.net",
    "tempatmainpoker.info",
    "tempatmainpoker.online",
    "tempatmainpoker.xyz",
    "tempatspa.com",
    "tempcloud.in",
    "tempcloud.info",
    "tempe-mail.com",
    "tempekmuta.cf",
    "tempekmuta.ga",
    "tempekmuta.gq",
    "tempekmuta.ml",
    "tempemail.biz",
    "tempemail.co",
    "tempemail.co.za",
    "tempemail.com",
    "tempemail.info",
    "tempemail.net",
    "tempemail.org",
    "tempemail.pro",
    "tempemailaddress.com",
    "tempemailco.com",
    "tempemails.io",
    "tempes.gq",
    "tempfishthedrift.com",
    "tempimbox.com",
    "tempinbox.co.uk",
    "tempinbox.com",
    "tempinbox.xyz",
    "templategeek.net",
    "temple-project.info",
    "templefr.com",
    "templefunctionalrehab.com",
    "templerehab.com",
    "tempm.cf",
    "tempm.com",
    "tempm.ga",
    "tempm.gq",
    "tempm.ml",
    "tempmail.co",
    "tempmail.de",
    "tempmail.eu",
    "tempmail.io",
    "tempmail.it",
    "tempmail.ninja",
    "tempmail.pp.ua",
    "tempmail.pro",
    "tempmail.space",
    "tempmail.sytes.net",
    "tempmail.top",
    "tempmail.us",
    "tempmail.website",
    "tempmail.win",
    "tempmail.ws",
    "tempmail2.com",
    "tempmailapp.com",
    "tempmaildemo.com",
    "tempmailer.com",
    "tempmailer.de",
    "tempmailid.com",
    "tempmailid.net",
    "tempmailid.org",
    "tempmails.cf",
    "tempmails.gq",
    "tempmails.org",
    "tempomail.fr",
    "tempor.site",
    "temporagourmet.com",
    "temporamail.com",
    "temporarily.de",
    "temporarioemail.com.br",
    "temporary-email-address.com",
    "temporary-email.com",
    "temporary-email.world",
    "temporary-mail.net",
    "temporaryemail.com",
    "temporaryemail.net",
    "temporaryemail.us",
    "temporaryforwarding.com",
    "temporaryinbox.com",
    "temporarymail.ga",
    "temporarymail.org",
    "temporarymailaddress.com",
    "temporfkcn.space",
    "tempr.email",
    "temprazzsoft.cf",
    "temprazzsoft.gq",
    "temprazzsoft.tk",
    "tempremail.cf",
    "tempremail.tk",
    "tempsky.com",
    "temptacon.cf",
    "temptacon.ga",
    "temptacon.gq",
    "temptacon.ml",
    "temptam.site",
    "temptbla.icu",
    "temptbla.xyz",
    "temptblan.icu",
    "temptca.xyz",
    "temptcat.xyz",
    "temptcatc.xyz",
    "tempthe.net",
    "temptifi.gq",
    "temptifi.ml",
    "temptifi.tk",
    "temptlaye.icu",
    "temptsteam.email",
    "temptti.buzz",
    "tempttrend.email",
    "tempxd.tk",
    "tempymail.com",
    "tempzo.info",
    "temr0520cr4kqcsxw.cf",
    "temr0520cr4kqcsxw.ga",
    "temr0520cr4kqcsxw.gq",
    "temr0520cr4kqcsxw.ml",
    "temr0520cr4kqcsxw.tk",
    "temsagroup.com",
    "temtulsa.net",
    "ten-invest.ru",
    "ten-thousand-dublin.com",
    "tenalbums.com",
    "tenchiclub.com",
    "tendance.xyz",
    "tenderkiss.com",
    "tendermemoryforever.com",
    "tenesu.tk",
    "tengyunyule.com",
    "tenia578at.online",
    "tenikla.cf",
    "tenikla.ml",
    "tenipen.ga",
    "tenipen.ml",
    "tenipen.tk",
    "tenkkeys.site",
    "tenmiensieure.com",
    "tennbuilder.com",
    "tenndoe.com",
    "tenney.tech",
    "tennisfans.net",
    "tennismail.com",
    "tennisshop.live",
    "tennuicei.ml",
    "tennuicei.tk",
    "tenormin.website",
    "tenorplanet.com",
    "tenraica.gq",
    "tenraica.tk",
    "tensi.org",
    "tensilemembrane.com",
    "tensionrelief.com",
    "tensmetconc.ga",
    "tensmetconc.ml",
    "tensmetconc.tk",
    "tentigor.ga",
    "tentigor.gq",
    "tentigor.tk",
    "tentntable.com",
    "tenup.com",
    "tenweekchallenge.net",
    "tenxtenb.com",
    "tenzoves.ru",
    "teocarsa.ga",
    "teocarsa.gq",
    "teocarsa.ml",
    "teogansse.gq",
    "teogansse.tk",
    "teompm.shop",
    "teonanakatl.info",
    "teonufest.ml",
    "teorlfs.com",
    "teoutelba.ml",
    "teoutelba.tk",
    "tepas.ru",
    "teplobur.ru",
    "tepzo.com",
    "ter.com",
    "terafile.xyz",
    "terbuny.net",
    "tercasinosnow.ru",
    "tercsash.online",
    "tercupu.gq",
    "tercupu.ml",
    "terdwa.online",
    "terfullvert.ga",
    "terfullvert.gq",
    "tergvikerp.cf",
    "tergvikerp.ga",
    "terirem.com",
    "terleani.ml",
    "terleani.tk",
    "terluboul.cf",
    "terluboul.ga",
    "terluboul.gq",
    "termallo.site",
    "terminalerror.com",
    "terminate.tech",
    "terminverpennt.de",
    "ternaklele.ga",
    "terokops.press",
    "teronamay.tk",
    "terpistick.com",
    "terra-incognita.co",
    "terra-real-estate.com",
    "terra.cl",
    "terra.com",
    "terra.com.ar",
    "terra.com.br",
    "terra.com.pe",
    "terra.es",
    "terracash.org",
    "terrafirmacollective.org",
    "terraform.cloud",
    "terraform.dev",
    "terraformproject.com",
    "terrainshift.info",
    "terranasaurus.com",
    "terraorousa.com",
    "terrasavvy.com",
    "terrascope.online",
    "terraverge.org",
    "terrehautedentists.com",
    "terrelac.cf",
    "terreni.click",
    "terreno.ml",
    "terribgsbl.space",
    "terrificbusinesses.com",
    "territors.club",
    "terrkrasoty.ru",
    "terroni-per-salvini.it",
    "terrorcmll.space",
    "terrprib.ru",
    "terryjohnson.online",
    "tersdiper.cf",
    "tersdiper.gq",
    "tershaber.com",
    "tersime.ga",
    "tersime.gq",
    "tersime.ml",
    "tersime.tk",
    "tert353ayre6tw.ml",
    "teruio.host",
    "terustegang.xyz",
    "tervalis.gq",
    "tervalis.ml",
    "tervalis.tk",
    "tesco.net",
    "teses.club",
    "tesghj4656.xyz",
    "tesgurus.net",
    "teshushihao.xyz",
    "teslaenergyoptima.com",
    "teslahome.sk",
    "teslasteel.com",
    "teslime.ga",
    "teslime.gq",
    "teslime.ml",
    "teslime.tk",
    "tesqas.online",
    "tesresidusdangereux.net",
    "tessaflower.com",
    "tessauto.info",
    "test-acs.com",
    "test.actess.fr",
    "test.com",
    "test.crowdpress.it",
    "test.de",
    "test0108-domain.xyz",
    "test1111.host",
    "test130.com",
    "testa-lot.net",
    "testadobe.ru",
    "testclean.org",
    "testclubs.com",
    "testdom34533663.host",
    "testdom345336633.host",
    "testdomain1808-34365.se",
    "testdomain1808-39235.se",
    "testdomain20191307.host",
    "testdomain220191307.host",
    "testdomains3244.host",
    "testdoors.ru",
    "teste445k.ga",
    "testebarato.xyz",
    "testeidenovo.xyz",
    "testenormal.xyz",
    "testerino.tk",
    "testextensile.com",
    "testfastspendslow.com",
    "testguma.cf",
    "testguma.ga",
    "testguma.gq",
    "testi.com",
    "testicles.com",
    "testincorp.xyz",
    "testinger.ru",
    "testingprog.com",
    "testlatcei.cf",
    "testlatcei.tk",
    "testlink24.com",
    "testlire.cf",
    "testlire.gq",
    "testlire.ml",
    "testlire.tk",
    "testoh.cf",
    "testoh.ga",
    "testoh.gq",
    "testoh.ml",
    "testoh.tk",
    "testore.co",
    "testose.website",
    "testosxboost.com",
    "testosxboost.net",
    "testosxmax.org",
    "testoxl.net",
    "testperfectlittlebirdy.info",
    "testtomoc.cf",
    "testtomoc.ga",
    "testtomoc.gq",
    "testtomoc.ml",
    "testtomoc.tk",
    "testtruthinmydays.com",
    "testudine.com",
    "testytestermcgee-11.com",
    "tesvama.cf",
    "tesvama.ga",
    "tesvama.gq",
    "tesvama.ml",
    "tesxco.com",
    "tetacouch.ru",
    "tetdoanvien.com",
    "tetivil.ga",
    "tetivil.gq",
    "tetivil.ml",
    "tetivil.tk",
    "tetohe.com",
    "tetrads.ru",
    "teubenart.com",
    "teufelsweb.com",
    "teugterpa.cf",
    "teugterpa.ga",
    "teugterpa.gq",
    "teuzml.ml",
    "teverjo.com",
    "tevhiddersleri.com",
    "tevkanlartur.xyz",
    "tewame.info",
    "tewassbures.press",
    "tewijihu.site",
    "tewsere.online",
    "tewua.ru",
    "tex-line.ru",
    "texac0.cf",
    "texac0.ga",
    "texac0.gq",
    "texac0.ml",
    "texac0.tk",
    "texas88poker.info",
    "texasaol.com",
    "texascityplumbers.com",
    "texasconservationcorps.org",
    "texascrimedefense.com",
    "texasdriverhandbook.com",
    "texaselevatorsolutions.com",
    "texasgunowners.com",
    "texaslibertynetwork.org",
    "texasmovo.com",
    "texasnationallaw.org",
    "texasnationallaw.us",
    "texasnationaltitle.biz",
    "texasnationaltitle.info",
    "texasnationaltitle.land",
    "texasnationaltitle.org",
    "texasnationaltitle.us",
    "texasnationaltitlee.net",
    "texasnationaltltle.com",
    "texasnationatite.com",
    "texasnationatltle.com",
    "texasorangepages.com",
    "texasorganized.com",
    "texasrealestatebrokers.com",
    "texasretirementservice.info",
    "texasyrs.com",
    "texi-connect.pro",
    "text.gq",
    "textagrams.biz",
    "textagrams.org",
    "textagrams.website",
    "textannons.se",
    "textbooksandtickets.com",
    "textcasi.cf",
    "textcasi.gq",
    "textcasi.ml",
    "texters.ru",
    "textil-home24.ru",
    "textildesign24.de",
    "textile-23.ru",
    "textilelife.ru",
    "textileroofs.org",
    "textjobs.ru",
    "textmarken.de",
    "textmaster.app",
    "textmedude.cf",
    "textmedude.ga",
    "textmedude.gq",
    "textmedude.ml",
    "textmedude.tk",
    "textoverip.com",
    "textpro.site",
    "textrelaxs.info",
    "textriot.com",
    "textstep.info",
    "textu.site",
    "texvembterp.cf",
    "texvembterp.ga",
    "texvembterp.ml",
    "teyostore.xyz",
    "teypstore.com",
    "tezdbz8aovezbbcg3.cf",
    "tezdbz8aovezbbcg3.ga",
    "tezdbz8aovezbbcg3.gq",
    "tezdbz8aovezbbcg3.ml",
    "tezdbz8aovezbbcg3.tk",
    "tezeger.xyz",
    "teziver.com",
    "tezos.charity",
    "tezosclassic.com",
    "tezwork.com",
    "tezy.site",
    "tezzmail.com",
    "tf-373.com",
    "tf2statistical.com",
    "tf5bh7wqi0zcus.cf",
    "tf5bh7wqi0zcus.ga",
    "tf5bh7wqi0zcus.gq",
    "tf5bh7wqi0zcus.ml",
    "tf5bh7wqi0zcus.tk",
    "tf7nzhw.com",
    "tf888.com",
    "tfajf.us",
    "tfanus.com.er",
    "tfasesoria.com",
    "tfbnw.net",
    "tfclw.info",
    "tfdkpn.shop",
    "tfiadvocate.com",
    "tfq.us",
    "tftitem.com",
    "tfwno.gf",
    "tfz.net",
    "tfzav6iptxcbqviv.cf",
    "tfzav6iptxcbqviv.ga",
    "tfzav6iptxcbqviv.gq",
    "tfzav6iptxcbqviv.ml",
    "tfzav6iptxcbqviv.tk",
    "tg-elektra.ru",
    "tg7.net",
    "tgasa.ru",
    "tgcn.live",
    "tgd9.us",
    "tgftmyjy.com",
    "tghenterprise.com",
    "tgiq9zwj6ttmq.cf",
    "tgiq9zwj6ttmq.ga",
    "tgiq9zwj6ttmq.gq",
    "tgiq9zwj6ttmq.ml",
    "tgiq9zwj6ttmq.tk",
    "tgisindia.com",
    "tgma.ru",
    "tgmanetwork.com",
    "tgngu.ru",
    "tgproxy.site",
    "tgres24.com",
    "tgspb.app",
    "tgstation.org",
    "tgszgot72lu.cf",
    "tgszgot72lu.ga",
    "tgszgot72lu.gq",
    "tgszgot72lu.ml",
    "tgszgot72lu.tk",
    "tgtshop.com",
    "tgu.ru",
    "tguide.site",
    "tgw48y.online",
    "tgwegame-44.xyz",
    "tgwnw.info",
    "tgwrzqr.top",
    "tgxvhp5fp9.cf",
    "tgxvhp5fp9.ga",
    "tgxvhp5fp9.gq",
    "tgxvhp5fp9.ml",
    "tgxvhp5fp9.tk",
    "tgyup.us",
    "th-garciniaextract-plus.site",
    "th-garciniaextractplus.site",
    "th-trend.com",
    "th398gij3fjndoip3.com",
    "th3glw.us",
    "th3ts2zurnr.cf",
    "th3ts2zurnr.ga",
    "th3ts2zurnr.gq",
    "th3ts2zurnr.ml",
    "th3ts2zurnr.tk",
    "th6008.com",
    "th9ekodo77wkv8k.xyz",
    "tha2itkkiman.xyz",
    "thai-palace-inn-takeaway.com",
    "thai.com",
    "thai4u.info",
    "thaifoodkinkin.com",
    "thaigarciniaextract.site",
    "thailand-estelle.website",
    "thailandforyou.site",
    "thaimail.com",
    "thaimail.net",
    "thaiparadisetakeaway.com",
    "thaishop.email",
    "thaishop.info",
    "thaispiceathome.com",
    "thaliaesmivida.com",
    "thambdistpec.ga",
    "thambdistpec.ml",
    "thambdistpec.tk",
    "thamesvalley.exposed",
    "thampvinig.cf",
    "thampvinig.gq",
    "thampvinig.ml",
    "thampvinig.tk",
    "than.one",
    "thangberus.net",
    "thanhbaohan.com",
    "thanhhoagroup.com",
    "thanhhoaonline.com",
    "thankams.com",
    "thankch.icu",
    "thankenstein.net",
    "thankhors.xyz",
    "thankinator.com",
    "thanklov.icu",
    "thanksala.xyz",
    "thanksgiving.company",
    "thanksgiving.digital",
    "thanksnospam.info",
    "thanktrac.xyz",
    "thankworl.xyz",
    "thankyou2010.com",
    "thanoper.cf",
    "thanoper.ga",
    "thanthoai.ml",
    "thassoshotelleri.com",
    "that-web.com",
    "that.gives",
    "thatim.info",
    "thatleft.com",
    "thatswhatcheesesaidtruck.com",
    "thatswhatyouneed.fun",
    "thatswhatyouneed.site",
    "thatswhatyouneed.xyz",
    "thatthing.org",
    "thbr88.com",
    "thc.st",
    "thcmsa.site",
    "the-african.com",
    "the-airforce.com",
    "the-aliens.com",
    "the-american.com",
    "the-animal.com",
    "the-army.com",
    "the-astronaut.com",
    "the-beauty.com",
    "the-big-apple.com",
    "the-biker.com",
    "the-bitcoins-era.net",
    "the-blockchainnews.xyz",
    "the-bloggers-exchange.org",
    "the-boss.com",
    "the-brazilian.com",
    "the-business-execution-system.com",
    "the-canadian.com",
    "the-canuck.com",
    "the-captain.com",
    "the-celebrity-confessed.info",
    "the-central-hotel-lamai.com",
    "the-chinese.com",
    "the-country.com",
    "the-cowboy.com",
    "the-cryptovipclub.site",
    "the-davis-home.com",
    "the-dutchman.com",
    "the-eagles.com",
    "the-englishman.com",
    "the-ethereumcode.site",
    "the-eyesp.us",
    "the-fastest.net",
    "the-first.email",
    "the-fool.com",
    "the-frenchman.com",
    "the-galaxy.net",
    "the-genius.com",
    "the-gentleman.com",
    "the-german.com",
    "the-greateststat.com",
    "the-gremlin.com",
    "the-grill-house-clondalkin.com",
    "the-hbswiss.site",
    "the-hill-leixlip.com",
    "the-hill-takeaway.com",
    "the-hooligan.com",
    "the-infiniateastcoast.com",
    "the-italian.com",
    "the-japanese.com",
    "the-johnsons.family",
    "the-johnsons.net",
    "the-kitchen-dundrum.com",
    "the-lair.com",
    "the-madman.com",
    "the-mailinglist.com",
    "the-marine.com",
    "the-master.com",
    "the-mexican.com",
    "the-ministry.com",
    "the-monkey.com",
    "the-movie-resort.biz",
    "the-newsletter.net",
    "the-om-shoppe.com",
    "the-pentagon.com",
    "the-pharmacy.info",
    "the-pill.info",
    "the-police.com",
    "the-prayer.com",
    "the-professional.com",
    "the-quickest.com",
    "the-raj-passage-west.com",
    "the-river-retreat.com",
    "the-russian.com",
    "the-seasiders.com",
    "the-skyeverton.com",
    "the-snake.com",
    "the-snapcashb.site",
    "the-spaceman.com",
    "the-stock-market.com",
    "the-student.net",
    "the-tarot-guy.com",
    "the-unknown.app",
    "the-valley-macaris-moate.com",
    "the-web-writer.com",
    "the-whitehouse.net",
    "the-wild-west.com",
    "the-wondrous-pattaya.com",
    "the-wondrous.com",
    "the-wondrouz-pattaya.com",
    "the-x.agency",
    "the18th.com",
    "the2012riots.info",
    "the21nation.com",
    "the2jacks.com",
    "the2percentlisting.com",
    "the3percentlisting.com",
    "the4you.ru",
    "theaahatel.cf",
    "theaahatel.ga",
    "theaahatel.gq",
    "theaahatel.ml",
    "theaahatel.tk",
    "theactionplaybook.com",
    "theactualnews.online",
    "theaddesk.com",
    "theaddyshow.com",
    "theadmiralcodrington.com",
    "theadvertisingdesk.com",
    "theajmorganfoundation.org",
    "theallardprize.com",
    "theallgaiermogensen.com",
    "theallmightyyes.com",
    "thealohagroup.international",
    "thealth.shop",
    "theamazingcomic.com",
    "theambersea.com",
    "theambulance.com",
    "theanatoly.com",
    "theanewdaycenter.com",
    "theangelhack.ru",
    "theanswer-am990.com",
    "theanywherebusinessbook.com",
    "theaperturelabs.com",
    "theaperturescience.com",
    "theapp.agency",
    "thearcarcade.com",
    "thearch-info.com",
    "thearcticbears.com",
    "thearketekt.com",
    "theartistpainting.info",
    "theartofrecharge.com",
    "theautomaticmovement.com",
    "theautothority.us",
    "theavatar11.com",
    "theaviors.com",
    "thebabiescares.com",
    "thebaby.blog",
    "thebagbook.com",
    "thebankofwestindies.com",
    "thebargainsuperstore.com",
    "thebarkerychch.com",
    "thebearshark.com",
    "thebeatcolumbus.com",
    "thebeautifullyrics.com",
    "thebeautybargain.one",
    "thebegoodtanyas.com",
    "thebenefit.xyz",
    "thebest4ever.com",
    "thebestacupuncturedavenport.com",
    "thebestforex.ru",
    "thebestmedicinecomedyclub.com",
    "thebestofscrubs.com",
    "thebestorchards.com",
    "thebestremont.ru",
    "thebetterrelationship.com",
    "thebibleen.com",
    "thebitcoincircuit.net",
    "theblackmagiccafe.com",
    "theblg.xyz",
    "theblocnola.com",
    "theblogprofboe.info",
    "theblownwhistle.com",
    "theboatcycle.com",
    "thebogdiaries.com",
    "thebongjournal.com",
    "thebonusaction.site",
    "theboogiecats.com",
    "thebrainzen.com",
    "thebridgelincoln.org",
    "thebridgespangroup.ngo",
    "thebrilliantvault.com",
    "thebrokenhands.com",
    "thebrothersgreens.com",
    "thebudhound.com",
    "thebuildingteamandsons.com",
    "thebusinessmakeover.net",
    "thebusinessmakeoverexperience.com",
    "thebuyinghub.net",
    "thecall.media",
    "thecapeswalk.com",
    "thecathyeffect.com",
    "thecatstaleusedbooks.org",
    "thechapel.space",
    "thechattapp.com",
    "thecherry.club",
    "thecherrypress.net",
    "thechesschool.net",
    "thecitiescafe.com",
    "thecity.biz",
    "theclassroomla.com",
    "theclearproject.net",
    "theclinicshield.com",
    "thecloudindex.com",
    "thecocreatornetwork.net",
    "thecocreatornetwork.org",
    "thecocreators.net",
    "thecoffeetender.com",
    "thecoincasino.com",
    "thecolabclub.com",
    "thecolemanlawgroup.net",
    "thecollegeessayistblog.com",
    "thecolonydoctors.com",
    "thecolorsofblue.com",
    "thecomcommunity.com",
    "thecomebackalliance.com",
    "thecomedyfilmplaybook.com",
    "thecomeup.com",
    "thecommunityky.org",
    "theconsciouspractice.com",
    "thecookoffboard.com",
    "thecoolguy.com",
    "thecouchpotatomillionaire.com",
    "thecouragetobeyou.net",
    "thecovidhygiene.report",
    "thecraftytalk.com",
    "thecreativefoundry.sydney",
    "thecricket.co.za",
    "thecriminals.com",
    "theculturallyconnectedcook.org",
    "thecuomoteam.com",
    "thecyberpunk.space",
    "thecybervolunteers.com",
    "thedanye.tk",
    "thedarkcorner.org",
    "thedarkcorner.tk",
    "thedarkmaster097.sytes.net",
    "thedavosman.store",
    "thedearnest.com",
    "thedeepbox.com",
    "thedenatlicon.com",
    "thedenovocompany.com",
    "thedentalshop.xyz",
    "thediamants.org",
    "thedigitalbrandbox.com",
    "thedirhq.info",
    "thediscountbag.com",
    "thediscountmart.net",
    "thedishrag.com",
    "thedistrictbook.com",
    "thedoghousemail.com",
    "thedollymix.com",
    "thedorm.com",
    "thedowntowndiva.com",
    "thedowntowndivas.com",
    "thedowntowndivas.net",
    "thedragonsmokeshop.com",
    "thedriveinn.com",
    "theeagleselement.com",
    "theeasttrain.com",
    "theeasymail.com",
    "theedgesignals.com",
    "theelysianbrand.com",
    "theemailprogram.com",
    "theencorehall.com",
    "theend.hu",
    "theengagement.group",
    "theengagementtest.com",
    "theeriviera.com",
    "theestateplanning.org",
    "theestateplanningatty.com",
    "theestateplanningatty.net",
    "theexclusiveonnew.com",
    "thefaceofbrazil.com",
    "thefairyprincessshop.com",
    "thefakechef.com",
    "thefallsmt.net",
    "thefarmlane.com",
    "thefinalhero.com",
    "thefirstticket.com",
    "thefishbarcrumlin.com",
    "thefivem.com",
    "theflanneleffect.com",
    "theflatwater.com",
    "theflavr.com",
    "thefocusfolks.com",
    "theforexdivision.com",
    "thefreedomdaily.com",
    "thefreefamily.xyz",
    "thefreemanual.asia",
    "thefriendsit.com",
    "thefrntrw.online",
    "thefryerysmithfield.com",
    "thefvs.info",
    "thefxpro.com",
    "thega.ga",
    "thegachi.cf",
    "thegachi.ga",
    "thegachi.gq",
    "thegachi.ml",
    "thegachi.tk",
    "thegamersclub.ru",
    "thegappers.net",
    "thegarageprofessionals.com",
    "thegathering.xyz",
    "thegazgroup.com",
    "thegenuineoriginal.xyz",
    "theghostofjeffersom.com",
    "thegigabithk.com",
    "thegioibepga.com",
    "thegioidat.info",
    "thegioididong.asia",
    "thegioigiamgia.website",
    "thegioitiepthi.website",
    "thegioixinhdep.info",
    "thegirlcute.com",
    "thegirlhot.com",
    "theglobalsdgawards.com",
    "theglobe.com",
    "theglockner.com",
    "theglockneronline.com",
    "thegoldishere.com",
    "thegolf.co.za",
    "thegolfcourse.com",
    "thegolfshopnc.com",
    "thegoodherbals.com",
    "thegoodwork.club",
    "thegooner.com",
    "thegreasegun.com",
    "thegreatcommission.cloud",
    "thegreatest-stats.com",
    "thegreatindian.ooo",
    "thegrilltakeaway.com",
    "thegrovebandb.com",
    "thegrovebnb.com",
    "thegrumpyglobetroter.com",
    "theguardian.best",
    "thehagiasophia.com",
    "theheadoffice.com",
    "thehealingroom.info",
    "thehealingstream.com",
    "thehempstore.com",
    "theherochecklist.com",
    "theholeinthewallfinglas.com",
    "theholeinthewalltakeaway.com",
    "thehoroscopereview.com",
    "thehotlist.vote",
    "thehouseofrock.org",
    "thehoustoninnerloop.com",
    "thehubdublin.com",
    "thehudsonsheafoundation.org",
    "thehumanlongevityproject.org",
    "thehungryrabbit.com",
    "thehygiene.report",
    "theimagetrader.com",
    "theindiaproject.org",
    "theinevitablezombieapocalypse.com",
    "theinquisitor.xyz",
    "theinternationaltinkler.com",
    "theinternetemail.com",
    "theintim.ru",
    "theitdoc.com",
    "thejerniganagency.com",
    "thejerseykid.icu",
    "thejesusclubs.org",
    "thejewishfraternity.org",
    "thejmrcompany.com",
    "thejoaocarlosblog.tk",
    "thejupiterblues.com",
    "thekaleofoundation.net",
    "thekebabandindiancurryjoint.com",
    "theketodiet.club",
    "thekimagency.biz",
    "thekindredcompany.co",
    "thekingcasino.shop",
    "thekitchen-dundalk.com",
    "theklister.com",
    "thekoots.com",
    "thelanddownunder.com",
    "thelanterntakeaway.com",
    "thelastshred.com",
    "thelearning.cloud",
    "thelearningcurve.org",
    "thelenfestcenter.org",
    "thelightningmail.net",
    "thelimestones.com",
    "thelittlechicboutique.com",
    "thelocalcarrentals.ru",
    "thelol.space",
    "thelol.xyz",
    "thelonestarbrewery.com",
    "thelordofpdf.info",
    "thelostway.blog",
    "thelouisvillelady.com",
    "thelsatprofessor.com",
    "thelurelounge.com",
    "theluxplanet.com",
    "theluxurycloset.info",
    "themadfishicist.com",
    "themadhipster.com",
    "themail.com",
    "themail.krd.ag",
    "themail3.net",
    "themailpro.net",
    "themailredirector.info",
    "themailworld.info",
    "themandalawnian.com",
    "themandarinorientalvegas.com",
    "themarket-delivery.ru",
    "themaskedsingerslot.com",
    "themaslowcollection.com",
    "themasterminds.us",
    "thembones.com.au",
    "themcminshuck.cf",
    "themcminshuck.ga",
    "themecpak.com",
    "themediant.com",
    "themediaspark.info",
    "themediaspark.net",
    "themediaspark.org",
    "themediterraneinn.com",
    "themediummaria.com",
    "themeg.co",
    "themegreview.com",
    "themegxit.life",
    "themelizer.com",
    "themenswellnesscenters.com",
    "themeritstore.com",
    "themesavegas.com",
    "themidwood-sg.com",
    "themigration.us",
    "themillionairenetworkmarketer.com",
    "themillionare.net",
    "themindfullearningpath.com",
    "theminimarriage.com",
    "theminimumviableteam.com",
    "theminorityvotefilm.com",
    "themodernlad.store",
    "themogensen.com",
    "themonroy.site",
    "themonthly.app",
    "themoon.co.uk",
    "themostemail.com",
    "themotowners.info",
    "themoviestudio.biz",
    "thenaborsgroup.com",
    "thenaturalfoodshow.com",
    "thenaturalhairdiva.com",
    "thenetcare.net",
    "thenetfx.website",
    "thenewenglandhouse.com",
    "thenewjubilee.com",
    "thenewmombod.com",
    "thenewrustic.club",
    "thenewsdhhayy.com",
    "thenewtinsomerset.news",
    "thenickensfamily.com",
    "thenightmareofgaza.com",
    "thenodehouse.net",
    "theodelo.cf",
    "theodelo.ml",
    "theodore1818.site",
    "theoffice.net",
    "theoliveoiltimes.com",
    "theomastix.xyz",
    "theone2017.us",
    "theonedinline.com",
    "theopendoorwayinc.com",
    "theopposition.club",
    "theoptimizedmarketinggroup.net",
    "theorientaltakeaway.com",
    "theorlandoblog.com",
    "theothermail.com",
    "theoutriggeradvantage.com",
    "theoverlandtandberg.com",
    "theoxygenator.com",
    "thepacificmansionresidences.com",
    "thepaperbackshop.com",
    "theparaclete.org",
    "theparlordowntown.club",
    "thepartsden.com",
    "thepathwayout.africa",
    "thepathwayout.global",
    "thepathwayout.org",
    "thepathwayout.tokyo",
    "thepathwayout.world",
    "thepatriotchannel.info",
    "thepcad.tech",
    "thepenshield.com",
    "theperformancecenterformen.com",
    "thepetaclouds.com",
    "thephillycalendar.com",
    "thepichuleiros.com",
    "thepieter.com",
    "thepieteronline.com",
    "thepill360.com",
    "thepirate.download",
    "thepirat\xe9bay.org",
    "thepiratebay.space",
    "thepiratefilmeshd.org",
    "thepiratesmc.online",
    "thepit.ml",
    "thepitujk79mgh.tk",
    "theplate.com",
    "theplug.org",
    "theplugchange.com",
    "thepoisonmag.ru",
    "thepokerface.com",
    "thepostmaster.net",
    "thepowerofuniverse.com",
    "thepreppybrunette.com",
    "theprinterwizards.com",
    "theprojectcitybus.com",
    "thepub.co.za",
    "thepunjabpantry.com",
    "theqbn.com",
    "theraces.com",
    "theracetrack.com",
    "theradicalprogressive.com",
    "therapeats.info",
    "therapist.net",
    "therapyservicesllc.org",
    "therateguide.website",
    "therattler.site",
    "theraworkplus.com",
    "theraworksactive.com",
    "theraworksbionom.com",
    "theraworksbionometherapies.com",
    "theraworkstech.com",
    "theraworkstechnologys.com",
    "theraworxactiv.com",
    "theraworxbionomtherapies.com",
    "theraworxcramp.com",
    "theraworxtechnologies.com",
    "theraworxtowels.com",
    "thereboost.info",
    "therecepts.com",
    "thereddoors.online",
    "therednecklipstick.com",
    "thereefbarandmarket.com",
    "thereefbarandmarketgrill.com",
    "thereisnogod.com",
    "theresawylie.com",
    "theresorts.ru",
    "therestaurantstore.info",
    "therinro.stream",
    "theriworks.com",
    "therkoda.cf",
    "therkoda.ml",
    "therkoda.tk",
    "thermacel-patio.com",
    "thermesthesia863lh.online",
    "therndentsur.cf",
    "therndentsur.ga",
    "therndentsur.gq",
    "therndentsur.tk",
    "theroarroarwentzoom.xyz",
    "therodrigos.com",
    "theromatakeaway.com",
    "therookharrison.com",
    "theroundhouseaquarium.org",
    "theroyalweb.club",
    "therugby.co.za",
    "therustichome.club",
    "theryanschmidt.com",
    "thesacredmist.icu",
    "thesahaty.com",
    "thesarasoulatihealthforlifepro.icu",
    "thesaturdaypaper.app",
    "thesavvybusiness.academy",
    "thesavvybusinessnetwork.com",
    "thesavvymarketing.agency",
    "thesavvymarketingagency.com",
    "thesbnation.com",
    "thescalinggroup.com",
    "thescanner.com",
    "theschreibertimes.org",
    "thescrappermovie.com",
    "thesdfsfgdf345353.com",
    "these.reviews",
    "these.tips",
    "theseamstress.online",
    "thesearchmarkefirm.net",
    "thesector.org",
    "theseobarn.com",
    "theseoexperts.net",
    "theshadowconspiracy.us",
    "theshamrockcarlow.com",
    "thesheermcgoldrickness.com",
    "theshiftcoin.com",
    "theshopisme.com",
    "theshortop.site",
    "thesickest.co",
    "thesierrasanctuary.com",
    "thesieve.info",
    "thesimplegiant.com",
    "thesimpletraders.com",
    "thesimpsonsfans.com",
    "thesinandtonics.com",
    "thesio.net",
    "thesio.org",
    "thesipcalculator.com",
    "thesistersvn.icu",
    "theskymail.com",
    "theslatch.com",
    "theslave.network",
    "thesnapmom.org",
    "thesneakerswarehouse.com",
    "thesoccerdoc.com",
    "thesocialchaingroup.life",
    "thesoftwareresource.com",
    "thesolutions.guru",
    "thesophiaonline.com",
    "thesoupkid.com",
    "thesourcefilm.org",
    "thesouthdakotaclub.com",
    "thespacemarine.com",
    "thespawningpool.com",
    "thespinningbur.com",
    "thesporters.com",
    "thespotonfifth.com",
    "thespringreveal.com",
    "thesqueeze.pro",
    "thesquirrelsnuts.online",
    "thestamp.app",
    "thestansberryfoundation.org",
    "thestarwars.xyz",
    "thestatesman.org",
    "thestats.top",
    "thestonedcrab.com",
    "thestonedcrabbrewingcompany.com",
    "thestopplus.com",
    "thestoryofbookworm.com",
    "thestraightshooterband.com",
    "thestreetfighter.com",
    "thestyleneur.com",
    "thestyleneur.xyz",
    "thesudokulegend.com",
    "thesunshinecrew.com",
    "thesunshinetoker.com",
    "theswanfactory.com",
    "thesweetshop.me",
    "thesweetshop.tech",
    "theswingking.info",
    "theswingking.org",
    "theswisschaletinthevillages.com",
    "theta-time.ru",
    "thetabletswindows.net",
    "thetalento.com",
    "thetaletop.com",
    "thetantraoils.com",
    "theteastory.info",
    "thetechnicaladviser.com",
    "theteebox.com",
    "thetempmail.com",
    "thethyroiddiseasesecret.com",
    "thetimeplease.com",
    "thetlilin.gq",
    "thetlilin.tk",
    "thetopsale2015.com",
    "thetouch.xyz",
    "thetraditionalpizza.com",
    "thetrash.email",
    "thetraumamama.info",
    "thetrendprime.com",
    "thetrommler.com",
    "thetwil.com",
    "thetybeetimes.net",
    "theukmassageguide.com",
    "theulogo.org",
    "theunicornpower.us",
    "theunitestars.com",
    "theupscalecircle.com",
    "thevaltrexnetwork.online",
    "thevapeonator.com",
    "theversatileme.shop",
    "theviastudy.com",
    "thevibet.site",
    "thevillageslifeeventcenter.com",
    "thevinewexford.com",
    "thevisioncenterofwesttexas.com",
    "thewarofus.shop",
    "thewarpandweft.com",
    "thewatercooler.com",
    "thewaterworld.ru",
    "thewaybetween.net",
    "theweatherplease.com",
    "thewebpros.co.uk",
    "theweepingdragon.net",
    "thewhitehouse.ml",
    "thewidowscry.com",
    "thewileychronicles.com",
    "thewirelessmicrophone.com",
    "thewisehomesellers.com",
    "thewizzard.com",
    "thewizzkid.com",
    "thewondrouzpattaya.com",
    "theworldisyours.ru",
    "theworldof17hats.com",
    "theworldofeasier.com",
    "theworldofespn.com",
    "theworldofworks.works",
    "theworldremembers.com",
    "theworldwewant.live",
    "theworm.company",
    "thex.ro",
    "thexfactorweb.com",
    "thexlist.net",
    "thexxx.site",
    "thexyz.ca",
    "thexyz.cn",
    "thexyz.com",
    "thexyz.es",
    "thexyz.fr",
    "thexyz.in",
    "thexyz.mobi",
    "thexyz.net",
    "thexyz.org",
    "they-sell-these.com",
    "theyarepodcasting.us",
    "theyearsface.com",
    "thezarara.com",
    "thezhangs.net",
    "thfulhaggder.cf",
    "thfulhaggder.ga",
    "thfulhaggder.gq",
    "thfulhaggder.ml",
    "thg24.de",
    "thianingle.cf",
    "thianingle.ga",
    "thianingle.gq",
    "thibault-calderon-andre.com",
    "thidoper.cf",
    "thidoper.gq",
    "thidoper.ml",
    "thidoper.tk",
    "thidthid.cf",
    "thidthid.ga",
    "thidthid.gq",
    "thidthid.ml",
    "thiegravit.gq",
    "thiegravit.tk",
    "thiennhatnguyen.shop",
    "thiepcuoibeloved.net",
    "thietbivanphong.asia",
    "thiethin.shop",
    "thietkeweb.org",
    "thighagree.us",
    "thighfo.xyz",
    "thighforc.xyz",
    "thighs.chat",
    "thinbrush.net",
    "thinbrush.us",
    "thinbrushes.us",
    "thindiancollection.com",
    "thinges.site",
    "thingexpress.com",
    "thinggebli.cf",
    "thinggebli.ml",
    "thinglayer.com",
    "thinglingo.com",
    "thingsandstuff.rocks",
    "thingssimple.site",
    "think316.com",
    "thinkaboutb.top",
    "thinkbait.media",
    "thinkbikeaustralia.com",
    "thinkfuxglv.email",
    "thinkhive.com",
    "thinkingus24.com",
    "thinklocalsantacruz.com",
    "thinkmerkdo.ga",
    "thinkmerkdo.ml",
    "thinkmerkdo.tk",
    "thinktimessolve.info",
    "thinkun.live",
    "thinkun.shop",
    "thinkunportfolio.com",
    "thinthe.shop",
    "thinwooldstiv.cf",
    "thinwooldstiv.ga",
    "thinwooldstiv.tk",
    "thirdage.com",
    "thirdbear.net",
    "thirdbrother.coffee",
    "thirdbrothercoffee.com",
    "thirdhome.media",
    "thirdminuteloan.com",
    "thirdwrist.com",
    "thirstybear.icu",
    "thirstycat.icu",
    "thirstycow.icu",
    "thirstytree.org",
    "thirteenscissors.com",
    "thirthis.shop",
    "this-is-a-free-domain.usa.cc",
    "this.gallery",
    "thischarmlessgirl.com",
    "thisemailis.absolutelyleg.it",
    "thisgirl.com",
    "thisisatrick.com",
    "thisisfamilytree.net",
    "thisisfashion.net",
    "thisisfashion.org",
    "thisishowyouplay.org",
    "thisisnotmyrealemail.com",
    "thislifechoseme.com",
    "thislifefoundme.com",
    "thismail.net",
    "thismail.ru",
    "thisshipping.xyz",
    "thisthin.shop",
    "thisurl.website",
    "thiswildsong.com",
    "thitchua.info",
    "thkig7.xyz",
    "thlingo.com",
    "thnikka.com",
    "thnk.de",
    "thnyqy.xyz",
    "thoas.ru",
    "thodien247.com",
    "thoic.com",
    "thoitrangtructuyen.website",
    "tholo.energy",
    "thompsogna.host",
    "thomsen.dk",
    "thoppilbuildersinc.com",
    "thoraxjs.org",
    "thorfun.org",
    "thornyscrate.com",
    "thorouashi.online",
    "thoroughbreddailynews.net",
    "thoroughbredhistory.com",
    "thorplat.ru",
    "thorpoker.com",
    "those-guys.com",
    "thosefeard.xyz",
    "thoskin.site",
    "thought-police.net",
    "thoughtconventioneasy.website",
    "thoughtcrate.com",
    "thoughtfulbit.com",
    "thoughtsofanangel.com",
    "thousandoaksdoctors.com",
    "thousandoaksdrilling.com",
    "thpenza.ru",
    "thpoq1.site",
    "thraml.com",
    "thrashers.net",
    "threadnecre.cf",
    "threadnecre.ga",
    "threadnecre.gq",
    "threadnecre.ml",
    "threadneedlepress.com",
    "threatstreams.com",
    "threatvectorsecurity.org",
    "thredbo60.com",
    "three-fellas-pizza-waterford.com",
    "threeday.site",
    "threedollarcafe.net",
    "threeeight.ru",
    "threeframes.ru",
    "thremagforspace20.site",
    "thriftypro.xyz",
    "thritorbo.ga",
    "thritorbo.gq",
    "thritorbo.ml",
    "thritorbo.tk",
    "thrivetemplates.club",
    "thrma.com",
    "throam.com",
    "throopllc.com",
    "thropasach.cf",
    "thropasach.ml",
    "thropasach.tk",
    "thrott.com",
    "throwam.com",
    "throwawayemail.com",
    "throwawayemailaddress.com",
    "throwawaymail.com",
    "throwawaymail.pp.ua",
    "throwblanket.net",
    "throya.com",
    "thrubay.com",
    "thruhere.net",
    "thsehouseof.house",
    "thsiisxgood2020.site",
    "thtt.us",
    "thtvbc.xyz",
    "thucdon365.net",
    "thucml.com",
    "thuducnhadat.com",
    "thuehost.net",
    "thuexemay.top",
    "thug.pw",
    "thuguimomo.ga",
    "thulsitvuk.com",
    "thumoi.com",
    "thund.cf",
    "thund.ga",
    "thund.gq",
    "thund.ml",
    "thund.tk",
    "thunderbolt.science",
    "thundermail.com",
    "thundernetwerk.online",
    "thunderonbrush.biz",
    "thunderonbrush.net",
    "thunderonbrush.us",
    "thunderonbrushes.biz",
    "thunderonbrushes.org",
    "thunderonbrushes.us",
    "thunix.org",
    "thunkinator.org",
    "thunnus.best",
    "thuocclub.club",
    "thuocclub.fun",
    "thuocvip.fun",
    "thuyloi.ga",
    "thwequ.xyz",
    "thxmate.com",
    "thxrnhiual.host",
    "thybet24.com",
    "thyfootball.ru",
    "thyfre.cf",
    "thyfre.ga",
    "thyfre.gq",
    "thyfre.ml",
    "thyia1.us",
    "thyroidportal.com",
    "thyroidsaver.com",
    "thyroidsaver.org",
    "thyxwenu.shop",
    "tiabami.cf",
    "tiabami.ga",
    "tiabami.gq",
    "tiabami.ml",
    "tiabami.tk",
    "tiacrystalcases.com",
    "tiam24.com",
    "tianadonerkebabpizzeriatiana.com",
    "tiancaiyy.info",
    "tiandeonline.ru",
    "tianjijinrong.net",
    "tiaotiaoylezc.com",
    "tiapz.com",
    "tiarabet99.info",
    "tiarabet99.org",
    "tiba8q.info",
    "tiberia.net",
    "tibetemail.com",
    "tibetsmen.ru",
    "tibia7.com",
    "tibpftbz.site",
    "tic.ec",
    "ticareh.com",
    "ticgris.com",
    "ticket-please.ga",
    "ticket.gifts",
    "ticket4one.com",
    "ticketmarket.place",
    "ticketsdiscounter.com",
    "ticklecontrol.com",
    "ticlesen.cf",
    "ticlesen.ga",
    "ticlesen.gq",
    "ticpire.gq",
    "ticpire.ml",
    "ticpire.tk",
    "tidc.dev",
    "tide-fillmig.rest",
    "tidemigfill.rest",
    "tidni.com",
    "tidyupjunkremoval.com",
    "tiebajian.com",
    "tieboppda.cf",
    "tieboppda.ga",
    "tiedupnivc.space",
    "tieindeedted.website",
    "tieit.app",
    "tielu168.com",
    "tiemmeservice.net",
    "tiendacars.net",
    "tiendamaravilla.com",
    "tiendamia.africa",
    "tiendamia.shop",
    "tienduoc.win",
    "tiengtrungmoingay.online",
    "tiepoes.com",
    "tieportsi.cf",
    "tieportsi.gq",
    "tieportsi.ml",
    "tieportsi.tk",
    "tierahs.com",
    "tiesmares.ml",
    "tiesmares.tk",
    "tieungoc.life",
    "tievah.com",
    "tievol.com",
    "tiffanyclarkwriter.com",
    "tiffanyelite.com",
    "tiffanymarascio.com",
    "tiffanypower.com",
    "tiffanysbnb.com",
    "tiffanywishes.com",
    "tiffin-maynooth.com",
    "tifosi.net",
    "tigerch.xyz",
    "tigerlilyflowershop.net",
    "tigermou.icu",
    "tigersuga.press",
    "tigerwoodsdesign.org",
    "tigerwoodsmobile.com",
    "tigerwoodsonline.com",
    "tigerzindahaicollection.info",
    "tighmarta.cf",
    "tighmarta.ga",
    "tighmarta.ml",
    "tigmon.club",
    "tigo.cr",
    "tijdelijke-email.nl",
    "tijdelijkmailadres.nl",
    "tijuanatexmexsevilla.com",
    "tika-gil.ru",
    "tikiboutiques.site",
    "tikichoy.com",
    "tikima.cf",
    "tikima.tk",
    "tikisalesa.info",
    "tikkahutindian.com",
    "tikkaindiantakeaway.com",
    "tikkieme.tech",
    "tikkunology.ong",
    "tiko-wabe.ru",
    "tikusqq.org",
    "tikvahhertogfellows.org",
    "tilamook.name",
    "tilamook.us",
    "tilanhem.site",
    "tilehi.cf",
    "tilehi.ga",
    "tilehi.gq",
    "tilien.com",
    "tillamook-cheese.name",
    "tillamook-cheese.us",
    "tillamook.name",
    "tillamookcheese.name",
    "tillamookfoodsales.biz",
    "tillamookfoodsales.name",
    "tillamookfoodsales.us",
    "tillid.ru",
    "tilnopen.cf",
    "tilnopen.ga",
    "tilnopen.ml",
    "tim.it",
    "timail.ml",
    "timalti.shop",
    "timanac.ga",
    "timanac.ml",
    "timanac.tk",
    "timberland-rus.site",
    "timberlandboots.biz",
    "timberulove.com",
    "timcooper.org",
    "time-for-dating2.com",
    "time-tamtam.site",
    "time-tamtam.xyz",
    "time.dating",
    "time4wine.xyz",
    "time789.com",
    "timeand.shop",
    "timebet12.com",
    "timebet26.com",
    "timebet29.com",
    "timebet34.com",
    "timebet38.com",
    "timebet63.com",
    "timebetting.org",
    "timebit.store",
    "timeforex.ru",
    "timein.net",
    "timekr.xyz",
    "timeleone.info",
    "timepad.com",
    "timesharerentalorlando.com",
    "timesua.com",
    "timewasterarcade.com",
    "timewillshow.com",
    "timfesenko.com",
    "timfosterarchitects.com",
    "timgiarevn.com",
    "timiko.ru",
    "timishop.site",
    "timjarrett.net",
    "timkassouf.com",
    "timmatheson.com",
    "timmphiha.cf",
    "timmphiha.ga",
    "timmphiha.gq",
    "timmphiha.tk",
    "timmyknowlesofficial.com",
    "timnas88.biz",
    "timormail.com",
    "timphongsamson.net",
    "timrad.ru",
    "timsautorepair-subaguru.com",
    "timspeak.ru",
    "timvieclamnhanh.net",
    "tin.it",
    "tinbitcoin.net",
    "tinbitcoin.org",
    "tinderajans.club",
    "tinderajans.online",
    "tinderajans.site",
    "tinfb.org",
    "tinfoto.ru",
    "tingcamptic.ml",
    "tingmoe.com",
    "tingnewsre.cf",
    "tingnewsre.gq",
    "tingnewsre.ml",
    "tingnewsre.tk",
    "tingsihop.cf",
    "tingsihop.ga",
    "tingsihop.gq",
    "tingsihop.ml",
    "tinhay.info",
    "tinhaynhat.net",
    "tinhnguyen0202.uk",
    "tinhyeu.mobi",
    "tinikok2.ru",
    "tinkeringpans.com",
    "tinkiremote.site",
    "tinkoff-strahovanie-cabinet.ru",
    "tinkoff-strahovanie-kabinet.ru",
    "tinleyparkplumbers.com",
    "tinmail.tk",
    "tinman.jobs",
    "tinmorrluzz.cf",
    "tinmorrluzz.gq",
    "tinmorrluzz.ml",
    "tinmorrluzz.tk",
    "tinnituscentercapecod.com",
    "tinoza.org",
    "tinsieuchuoi.com",
    "tinsignifytoe.website",
    "tinsology.net",
    "tintanenlingro.info",
    "tintinnabulation.space",
    "tintorama.ru",
    "tintuceva.org",
    "tintucphunu.org",
    "tinviahe.top",
    "tiny.ms1.email",
    "tinybt.com",
    "tinymill.org",
    "tinypc.reviews",
    "tinystoves.net",
    "tinyurl24.com",
    "tinywiki.com",
    "tiobichieu.site",
    "tiodarrigh.ga",
    "tiodarrigh.tk",
    "tiofolva.ga",
    "tiofolva.gq",
    "tiofolva.ml",
    "tiohulfi.cf",
    "tiohulfi.gq",
    "tiohulfi.ml",
    "tiolabal.cf",
    "tiolabal.ga",
    "tiomahecon.tech",
    "tiongbahrusocialclub.com",
    "tiopreslasz.cf",
    "tiopreslasz.ga",
    "tiopreslasz.gq",
    "tiopreslasz.ml",
    "tiopreslasz.tk",
    "tiosiro.cf",
    "tiosiro.ga",
    "tiosiro.gq",
    "tiosiro.ml",
    "tiosiro.tk",
    "tiosparhar.cf",
    "tiosparhar.ga",
    "tiosparhar.gq",
    "tiosparhar.tk",
    "tioswerar.cf",
    "tioswerar.ga",
    "tiotego.ga",
    "tiotego.ml",
    "tiovamons.cf",
    "tiovamons.tk",
    "tipartre.gq",
    "tipasza.ga",
    "tipasza.gq",
    "tipasza.ml",
    "tipasza.tk",
    "tipertbubb.cf",
    "tipertbubb.ga",
    "tipertbubb.gq",
    "tipertbubb.ml",
    "tipertbubb.tk",
    "tipheaven.com",
    "tipicopr.site",
    "tipidkorpoldakalteng.info",
    "tipo24.com",
    "tipo34.com",
    "tipo35.com",
    "tipo37.com",
    "tipo38.com",
    "tipo39.com",
    "tipobet.host",
    "tipobetbahis.com",
    "tipsandadvice.com",
    "tipsb.com",
    "tipsbankforyou.com",
    "tipsfortechteams.email",
    "tipsochtricks.site",
    "tipsvk.best",
    "tiptopik.tech",
    "tiptrip.ru",
    "tiramisumail.xyz",
    "tiran.ru",
    "tirbom.ru",
    "tiredbr.xyz",
    "tiredbri.xyz",
    "tireddo.buzz",
    "tiredfl.xyz",
    "tiredflo.xyz",
    "tiredfloo.xyz",
    "tirednoble.com",
    "tireesc.shop",
    "tiresandmorekent.com",
    "tiresflint.com",
    "tirestdi.gq",
    "tirestdi.ml",
    "tiretaine.site",
    "tirgiji.com",
    "tiriacgroup.com",
    "tiriacmanagement.com",
    "tirisfal-project.org",
    "tiroshops.site",
    "tirreno.cf",
    "tirreno.ga",
    "tirreno.gq",
    "tirreno.ml",
    "tirreno.tk",
    "tirthajatra.com",
    "tiscali.at",
    "tiscali.be",
    "tiscali.co.uk",
    "tiscali.it",
    "tiscali.lu",
    "tiscali.se",
    "tisokoljert.tk",
    "tisrendvi.ml",
    "tisrendvi.tk",
    "tisubgi.cf",
    "tisubgi.gq",
    "tisubgi.ml",
    "tisubgi.tk",
    "tit8282.com",
    "titafeminina.com",
    "titan-host.cf",
    "titan-host.ga",
    "titan-host.gq",
    "titan-host.ml",
    "titan-host.tk",
    "titan-original.ru",
    "titan4d.com",
    "titan4d.net",
    "titanbrojart.ru",
    "titandansatislar.xyz",
    "titandansatislar1.xyz",
    "titangelsrbija.com",
    "titanit.de",
    "titanitelife.com",
    "titaniumbrush.biz",
    "titaniumbrush.net",
    "titaniumbrush.org",
    "titaniumbrush.us",
    "titaniumbrushes.net",
    "titaniumbrushes.us",
    "titanmine.ru",
    "titanopto.com",
    "titantytcrownt.ru",
    "titas.cf",
    "titaskotom.cf",
    "titaskotom.ga",
    "titaskotom.gq",
    "titaskotom.ml",
    "titaskotom.tk",
    "titaspaharpur.cf",
    "titaspaharpur.ga",
    "titaspaharpur.gq",
    "titaspaharpur.ml",
    "titaspaharpur.tk",
    "titaspaharpur1.cf",
    "titaspaharpur1.ga",
    "titaspaharpur1.gq",
    "titaspaharpur1.ml",
    "titaspaharpur1.tk",
    "titaspaharpur2.cf",
    "titaspaharpur2.ga",
    "titaspaharpur2.gq",
    "titaspaharpur2.ml",
    "titaspaharpur2.tk",
    "titaspaharpur3.cf",
    "titaspaharpur3.ga",
    "titaspaharpur3.gq",
    "titaspaharpur3.ml",
    "titaspaharpur3.tk",
    "titaspaharpur4.cf",
    "titaspaharpur4.ga",
    "titaspaharpur4.gq",
    "titaspaharpur4.ml",
    "titaspaharpur4.tk",
    "titaspaharpur5.cf",
    "titaspaharpur5.ga",
    "titaspaharpur5.gq",
    "titaspaharpur5.ml",
    "titaspaharpur5.tk",
    "titipoker.net",
    "titipoker.org",
    "title1program.com",
    "title1reading.com",
    "title1readingprogram.com",
    "title1readingresources.com",
    "titleblee.buzz",
    "titlehumo.site",
    "titlemora.space",
    "titlermedicin.website",
    "titoronde.ru",
    "titrevy.tech",
    "tittbit.in",
    "tiuyretgr.gq",
    "tiv.cc",
    "tiverton-town-council.org",
    "tivowxl7nohtdkoza.cf",
    "tivowxl7nohtdkoza.ga",
    "tivowxl7nohtdkoza.gq",
    "tivowxl7nohtdkoza.ml",
    "tivowxl7nohtdkoza.tk",
    "tix.onl",
    "tixonicindia.icu",
    "tiyanxing.com",
    "tiyucp.net",
    "tiyx.party",
    "tiyx.trade",
    "tizanidinorifarm.website",
    "tizi.com",
    "tj2-sygw.com",
    "tj28.app",
    "tj2851.com",
    "tj2852.com",
    "tj4.app",
    "tj5.app",
    "tj6.app",
    "tj7.app",
    "tjampoer.events",
    "tjbma5.us",
    "tjbpoker.vip",
    "tjbwgyxx.com",
    "tjcy.us",
    "tjd93.space",
    "tjdh.xyz",
    "tjebhyy.com",
    "tjekket.dk",
    "tjkjzjel.shop",
    "tjmn.cc",
    "tjnf.cc",
    "tjthklnbx.shop",
    "tjtnbyy.com",
    "tjuew56d0xqmt.cf",
    "tjuew56d0xqmt.ga",
    "tjuew56d0xqmt.gq",
    "tjuew56d0xqmt.ml",
    "tjuew56d0xqmt.tk",
    "tjzbd.com",
    "tk-intercom.ru",
    "tk218.com",
    "tk3od4c3sr1feq.cf",
    "tk3od4c3sr1feq.ga",
    "tk3od4c3sr1feq.gq",
    "tk3od4c3sr1feq.ml",
    "tk3od4c3sr1feq.tk",
    "tk4ck8.us",
    "tk8phblcr2ct0ktmk3.ga",
    "tk8phblcr2ct0ktmk3.gq",
    "tk8phblcr2ct0ktmk3.ml",
    "tk8phblcr2ct0ktmk3.tk",
    "tkbmwr.fun",
    "tkcity.com",
    "tkcmbp.fun",
    "tkcpw.info",
    "tkdirvine.com",
    "tkdmzs.fun",
    "tkdtustin.com",
    "tkeiyaku.cf",
    "tkeycoin.art",
    "tkeycoin.fun",
    "tkgmmj.fun",
    "tkhmlp.fun",
    "tkijuu.tokyo",
    "tkitc.de",
    "tkitchen.online",
    "tkjmsf.fun",
    "tkjngulik.com",
    "tkkbw.info",
    "tkmy88m.com",
    "tknife.online",
    "tknmqb.fun",
    "tknmwf.fun",
    "tko-ply.online",
    "tko.co.kr",
    "tko.kr",
    "tkpard90.com",
    "tkpgy.live",
    "tkpmxt.fun",
    "tkrofg.us",
    "tkroycap.tk",
    "tktkdata.com",
    "tktoursamui.xyz",
    "tkvf9p.us",
    "tkxmll.fun",
    "tkyoko8787.online",
    "tkzumbsbottzmnr.cf",
    "tkzumbsbottzmnr.ga",
    "tkzumbsbottzmnr.gq",
    "tkzumbsbottzmnr.ml",
    "tkzumbsbottzmnr.tk",
    "tl.community",
    "tl8dlokbouj8s.cf",
    "tl8dlokbouj8s.gq",
    "tl8dlokbouj8s.ml",
    "tl8dlokbouj8s.tk",
    "tlachustpe.ga",
    "tlachustpe.gq",
    "tlachustpe.ml",
    "tlaun.ru",
    "tlccafeteriawexford.com",
    "tlcfan.com",
    "tlcministries.info",
    "tldoe8nil4tbq.cf",
    "tldoe8nil4tbq.ga",
    "tldoe8nil4tbq.gq",
    "tldoe8nil4tbq.ml",
    "tldoe8nil4tbq.tk",
    "tleecinnue.ga",
    "tleecinnue.gq",
    "tlen.pl",
    "tlgr.live",
    "tlgrcn.live",
    "tlhjw.info",
    "tlichemras.tk",
    "tliel.live",
    "tlifestore.website",
    "tlpn.org",
    "tlraob.tokyo",
    "tls.cloudns.asia",
    "tlv70.us",
    "tlvl8l66amwbe6.cf",
    "tlvl8l66amwbe6.ga",
    "tlvl8l66amwbe6.gq",
    "tlvl8l66amwbe6.ml",
    "tlvl8l66amwbe6.tk",
    "tlvm.us",
    "tlvsmbdy.cf",
    "tlvsmbdy.ga",
    "tlvsmbdy.gq",
    "tlvsmbdy.ml",
    "tlvsmbdy.tk",
    "tlw-cz.info",
    "tm-organicfood.ru",
    "tm-ramana.ru",
    "tm.in-ulm.de",
    "tm.slsrs.ru",
    "tm.tosunkaya.com",
    "tm2mail.com",
    "tm3ful.com",
    "tm95xeijmzoxiul.cf",
    "tm95xeijmzoxiul.ga",
    "tm95xeijmzoxiul.gq",
    "tm95xeijmzoxiul.ml",
    "tm95xeijmzoxiul.tk",
    "tmail.com",
    "tmail.run",
    "tmail.ws",
    "tmail1.com",
    "tmail1.tk",
    "tmail15.com",
    "tmail2.com",
    "tmail2.tk",
    "tmail3.tk",
    "tmail4.tk",
    "tmail5.tk",
    "tmail7.com",
    "tmailcloud.com",
    "tmailcloud.net",
    "tmailer.org",
    "tmailinator.com",
    "tmailpro.net",
    "tmails.net",
    "tmails.top",
    "tmailservices.com",
    "tmajre.com",
    "tmatthew.net",
    "tmavfitness.com",
    "tmaxxpro.com",
    "tmbox.xyz",
    "tmcburger.com",
    "tmethicac.ml",
    "tmhit.ru",
    "tmhound.com",
    "tmhsale.top",
    "tmicha.net",
    "tmin360.com",
    "tmj1lmtkc5lydcl.xyz",
    "tmljw.info",
    "tmlwell.org",
    "tmlzsehta.shop",
    "tmnxw.info",
    "tmo.kr",
    "tmobile.com",
    "tmp.k3a.me",
    "tmp.refi64.com",
    "tmpemails.com",
    "tmpeml.info",
    "tmpjr.me",
    "tmpmail.net",
    "tmpmail.org",
    "tmpromo.online",
    "tmtfdpxpmm12ehv0e.cf",
    "tmtfdpxpmm12ehv0e.ga",
    "tmtfdpxpmm12ehv0e.gq",
    "tmtfdpxpmm12ehv0e.ml",
    "tmtfdpxpmm12ehv0e.tk",
    "tmtrackr.com",
    "tmwlad.info",
    "tmzkvqam.shop",
    "tnblackrock.com",
    "tnblw.info",
    "tncitsolutions.com",
    "tnhalfpricedlistings.com",
    "tnhalfpricelisting.com",
    "tnhalfpricelistings.com",
    "tningedi.cf",
    "tningedi.ga",
    "tningedi.ml",
    "tningedi.tk",
    "tnkf8.us",
    "tnmsabac.website",
    "tnnsw.info",
    "tnoz1n.us",
    "tnpepsico.com",
    "tnrbw.info",
    "tnrwj1.site",
    "tnt.land",
    "tntitans.club",
    "tnuxqbra.shop",
    "tnvj6r.us",
    "tnvrtqjhqvbwcr3u91.cf",
    "tnvrtqjhqvbwcr3u91.ga",
    "tnvrtqjhqvbwcr3u91.gq",
    "tnvrtqjhqvbwcr3u91.ml",
    "tnvrtqjhqvbwcr3u91.tk",
    "to-iran.info",
    "to-rena.com",
    "to-team7.com",
    "to77rosreestr.ru",
    "to79.xyz",
    "toana.com",
    "toaraichee.cf",
    "toaraichee.ga",
    "toaraichee.gq",
    "toast.com",
    "toastcrow.fun",
    "toastdram.icu",
    "toastmatrix.com",
    "toastsum.com",
    "toasttrain.email",
    "toastwid.xyz",
    "toastwide.xyz",
    "tobaccodebate.com",
    "tobeate.cf",
    "tobeate.ga",
    "tobeate.gq",
    "tobeate.ml",
    "tobeblossom.store",
    "tobobet.mobi",
    "tobuso.com",
    "toby.click",
    "tocabsui.cf",
    "tocabsui.ga",
    "tocabsui.gq",
    "tocabsui.tk",
    "tochintper.cf",
    "tochintper.ga",
    "tochintper.gq",
    "tochintper.ml",
    "toconnell.org",
    "tocufull.cf",
    "tocufull.ga",
    "tocufull.gq",
    "tocz.us",
    "tod2020.xyz",
    "todanpho.com",
    "today-amigurumi.site",
    "today-payment.com",
    "today24bet.com",
    "todayamazonquiz.com",
    "todayamigurumi.website",
    "todaybestnovadeals.club",
    "todayemail.ga",
    "todayhistory.org",
    "todayjustsport.online",
    "todaymednews.site",
    "todayprizes2.life",
    "todayspennystocks.com",
    "todaysvisionlascolinas.com",
    "todaytaxis.info",
    "todaywebz.com",
    "toddbach.com",
    "toddsbighug.com",
    "toddwebbcpa.com",
    "toditokard.pw",
    "todslonesaddles.com",
    "togame.ru",
    "togel.news",
    "togel.one",
    "togel00.com",
    "togelapi.org",
    "togelbet8887.com",
    "togelbet8888.info",
    "togelcyber.com",
    "togelfortuna.club",
    "togelhin.xyz",
    "togelhin88.com",
    "togelkami.xyz",
    "togelmain.net",
    "togelnusa.live",
    "togelonline1.com",
    "togelonline88.org",
    "togelounge99.asia",
    "togeltotojitu.com",
    "togeltotojitu.info",
    "togetherwethrive.us",
    "togirls.site",
    "toglobalist.org",
    "tohive.org",
    "tohurt.me",
    "toi.kr",
    "toictp.us",
    "toiea.com",
    "toihocweb.best",
    "toikehos.cf",
    "toikehos.tk",
    "toiletries1.com",
    "tojbet.com",
    "tokai.tk",
    "tokatgunestv.xyz",
    "tokatinadresi.com",
    "tokbeat.com",
    "toke.com",
    "toke88.co",
    "tokem.co",
    "token-improve.host",
    "tokencoach.com",
    "tokencoach.net",
    "tokenized-equity.com",
    "tokenized-equity.info",
    "tokenized-equity.net",
    "tokenized-equity.org",
    "tokenized-shares.com",
    "tokenized-shares.info",
    "tokenized-shares.org",
    "tokenizedequity.org",
    "tokenizedshares.org",
    "tokenmail.de",
    "tokenvesto.com",
    "tokenvesto.net",
    "toker.city",
    "toker.shop",
    "tokeracademy.com",
    "tokeradvertising.com",
    "tokercollege.com",
    "tokerdolls.com",
    "tokerdude.com",
    "tokerholding.company",
    "tokermap.com",
    "tokermuseum.com",
    "tokernetwork.com",
    "tokeroutfitters.com",
    "tokerparties.com",
    "tokerphotos.com",
    "tokerpipes.com",
    "tokerplanet.com",
    "tokerrecipes.com",
    "tokerreviews.com",
    "tokertrail.com",
    "tokertribe.com",
    "toko3d.com",
    "tokoarmys.info",
    "tokofavorit.com",
    "tokoperfume.com",
    "tokot.ru",
    "tokuriders.club",
    "tokyo.com",
    "tokyotogel.online",
    "tol.net",
    "tol.ooo",
    "tolasoft.net",
    "tolatech.com",
    "tolbet23.com",
    "tolbet4.com",
    "toldhistory.xyz",
    "toldtec.com",
    "toldtech.org",
    "toledoarearealtor.com",
    "toleme.gq",
    "tolkuchi-rinok.ru",
    "tollfreehomehotline.com",
    "tollsjoforsamling.online",
    "tologvo.works",
    "tolongsaya.me",
    "tols-ex.ru",
    "tolteca-camden-street.com",
    "tom.cn",
    "tom.com",
    "tom.com.cn",
    "tom083.com",
    "tomacupon.com",
    "tomali.cn",
    "tomasaro.com",
    "tomatillosatinal.xyz",
    "tomatoeshb.com",
    "tomatoon.net",
    "tombalanet.com",
    "tombolatica.org",
    "tomcail.com",
    "tomevault.com",
    "tomevault.net",
    "tomjoneswatches.net",
    "tommer.store",
    "tommoore.net",
    "tommynilssonbil.online",
    "tommyphomeimprovements.com",
    "tomogavk.online",
    "tomoworks.tech",
    "tomsawyer.camp",
    "tomsemmmai.company",
    "tomsshoesoutletssales.com",
    "tomx.de",
    "tonall.com",
    "tonaroca.com",
    "tondar-shop.xyz",
    "tondar-vpn.xyz",
    "tondar-vpns.xyz",
    "tonehy.info",
    "tonicronk.com",
    "tonigcrash.club",
    "toningtheflab.com",
    "tonirovkaclub.ru",
    "tonne.to",
    "tonneau-covers-4you.com",
    "tonno.cf",
    "tonno.gq",
    "tonno.ml",
    "tonno.tk",
    "tonolon.cf",
    "tonolon.gq",
    "tonolon.ml",
    "tonolon.tk",
    "tonpetitlait.com",
    "tonpetitmec.com",
    "tonplancul-page.com",
    "tony-casino.com",
    "tonyandtinosmacroom.com",
    "tonyandtinostakeaway.com",
    "tonyclass.com",
    "tonycuffe.com",
    "tonymanso.com",
    "tonys-takeaway-carlow.com",
    "tonytinostakeaway.com",
    "toodagos.cf",
    "toodagos.ga",
    "toodagos.gq",
    "toodagos.tk",
    "tooeasybuy.ru",
    "toogether.digital",
    "tool.pp.ua",
    "toolreviews.tech",
    "toolsource.com",
    "tooltackle.ru",
    "toomail.biz",
    "toomtam.com",
    "toomuchabout.com",
    "toon.ml",
    "toone.best",
    "toonfirm.com",
    "toonlawtulsa.com",
    "toonmoa48.com",
    "toonusfit.space",
    "toootook.shop",
    "toopitoo.com",
    "toothandmail.com",
    "toothdecay.website",
    "toothfairy.com",
    "toothfqualmo.cf",
    "toothfqualmo.ga",
    "toothfqualmo.gq",
    "tootrendavto.ru",
    "tooxet.ru",
    "top-annuaire.com",
    "top-elka.ru",
    "top-email.org",
    "top-freza.ru",
    "top-help.ru",
    "top-life-insurance-today.live",
    "top-magazine.site",
    "top-mailer.net",
    "top-mails.net",
    "top-onlinecasino.info",
    "top-opros.best",
    "top-seller15.ru",
    "top-seller24.ru",
    "top-setbpp.ru",
    "top-sh0ps.fun",
    "top-shop-tovar.ru",
    "top-shop24info.ru",
    "top-shopz.online",
    "top-start.ru",
    "top-store11.ru",
    "top-telechargement-sites.com",
    "top-trends1.ru",
    "top-veneers.ru",
    "top021.site",
    "top10-voto.com",
    "top101.de",
    "top10cpm.com",
    "top10extreme.com",
    "top1mail.ir",
    "top1mail.ru",
    "top1post.ru",
    "top4bum.com",
    "top4butt.com",
    "top5heelinsertscom.com",
    "top5news.fun",
    "top5znakomstv.space",
    "top777.site",
    "top9appz.info",
    "topaddress.com",
    "topairdrops.site",
    "topamulet.ru",
    "topand.best",
    "topar.pro",
    "toparama.com",
    "topbabygirl.com",
    "topbak.ru",
    "topbooksites.com",
    "topboombeet.xyz",
    "topbuyer.xyz",
    "topbuzz-tamtam.xyz",
    "topbwin.com",
    "topcarlawyer.com",
    "topcash18indo.xyz",
    "topchat.com",
    "topchik.xyz",
    "topcoin.business",
    "topcoolemail.com",
    "topcuponesdescuento.com",
    "topdait.icu",
    "topdcevents.com",
    "topdeadcentermusic.com",
    "topdealoffering.com",
    "topdepcasinos.ru",
    "topdropcase.ru",
    "topechelonsoftware.com",
    "topeducationvn.cf",
    "topeducationvn.ga",
    "topeducationvn.gq",
    "topeducationvn.ml",
    "topeducationvn.tk",
    "topemail.us",
    "topfivestars.fun",
    "topfreeemail.com",
    "topgads.com",
    "topgamers.co.uk",
    "topgif.ru",
    "topgjali.cf",
    "topgjali.ga",
    "topgjali.gq",
    "tophdmovies.biz",
    "tophit-mzg.ru",
    "tophouseforsale.com",
    "tophyhar.cf",
    "tophyhar.ga",
    "tophyhar.gq",
    "tophyhar.ml",
    "tophyhar.tk",
    "topiasolutions.net",
    "topiasolutions.org",
    "topic-books.com",
    "topicalbionom.com",
    "topicalspectrumhemp.com",
    "topigrok-online.ru",
    "topikt.com",
    "topinrock.cf",
    "topiphone.icu",
    "topiratu.info",
    "topitiji.site",
    "topjuju.com",
    "topkek.pro",
    "topladygirl.com",
    "toplampy.online",
    "toplessbucksbabes.us",
    "topletter.com",
    "toplinewindow.com",
    "toplinktap.ru",
    "toplistcasinovideo.tech",
    "toplistninja.com",
    "topmaidanapinola.com",
    "topmail-files.de",
    "topmail.co.uk",
    "topmail.com.ar",
    "topmail.ws",
    "topmail1.net",
    "topmail2.com",
    "topmail2.net",
    "topmail24.ru",
    "topmailer.info",
    "topmailings.com",
    "topmall.com",
    "topmall.info",
    "topmall.org",
    "topmoviesonline.co",
    "topmum.net",
    "topmusicas.club",
    "topmusiklist.com",
    "topnewest.com",
    "topnewride-now.sale",
    "topnewswaka.site",
    "topnewz.net",
    "topnnov.ru",
    "topnolan.com",
    "topnovosti-russia.ru",
    "topofertasdehoy.com",
    "topofthehilldining.com",
    "toporra.cf",
    "topp10topp.ru",
    "toppartners.cf",
    "toppartners.ga",
    "toppartners.gq",
    "toppartners.ml",
    "toppartners.tk",
    "topphouse.ru",
    "toppieter.com",
    "topping.com.ua",
    "topplase-es.site",
    "topplayers.fun",
    "topranklist.de",
    "topread.fun",
    "toprecipecenter.com",
    "topretirements.org",
    "topricedublin3.com",
    "toprucasino2018.ru",
    "toprucasinos.ru",
    "toprumours.com",
    "topsale.uno",
    "topsecretvn.cf",
    "topsecretvn.ga",
    "topsecretvn.gq",
    "topsecretvn.ml",
    "topsecretvn.tk",
    "topsellingtools.com",
    "topseptik.site",
    "topseriestreaming.site",
    "topseriestreaming.xyz",
    "topshoemall.org",
    "topshop123.ru",
    "topskin.online",
    "topsml4you.xyz",
    "topspizza-crumlin.com",
    "topspizzaandfriedchicken.com",
    "topsuccsesspeople.site",
    "topsuccsesspeople.space",
    "topsuccsesspeople.website",
    "topsurf.com",
    "topswisswatch.ru",
    "topsydodo.com",
    "toptalentsearchexperts.com",
    "toptalentsearchexperts.xyz",
    "topteam.bg",
    "topteengirl.com",
    "toptenformen.com",
    "toptenplaces.net",
    "topthailandsport.com",
    "topthingsstore.info",
    "toptransfer.cf",
    "toptransfer.ga",
    "toptransfer.gq",
    "toptransfer.ml",
    "toptransfer.tk",
    "toptrend777.ru",
    "toptrendnews.net",
    "topusaclassifieds.com",
    "toputaer.ga",
    "topvacationhomes.rentals",
    "topvideogames.ninja",
    "topvidnow.com",
    "topvpnfree.ooo",
    "topzpost.com",
    "toqire.info",
    "toqpoj.com",
    "toquedequeda.com",
    "toqza5.com",
    "tor13.site",
    "toracw.com",
    "torahcenter-chabad.org",
    "torawa.info",
    "torba.com",
    "torbix.site",
    "torch.space",
    "torch.yi.org",
    "torchmail.com",
    "torg-06.ru",
    "torgorama.com",
    "torickcryp.gq",
    "torm.xyz",
    "tormail.net",
    "tormail.org",
    "tornadobet11.net",
    "tornadobet365.net",
    "torneodeljoropo.com",
    "torontoincometax.com",
    "torontomail.com",
    "torontopropertyhousehunters.com",
    "toropic.site",
    "torquatoasociados.com",
    "torrent0.com",
    "torrent9-fr.site",
    "torrentbebe10.com",
    "torrentcache.com",
    "torrentgirl.shop",
    "torrenthaja.shop",
    "torrentjoa.shop",
    "torrentmoa.shop",
    "torrentmovies.biz",
    "torrentqq33.com",
    "torrentqq36.com",
    "torrentqq37.com",
    "torrentqq38.com",
    "torrents.click",
    "torrents9.red",
    "torrents9.rip",
    "torrentshow.net",
    "torrenttool.com",
    "torrentupload.com",
    "torrentwiki.com",
    "torrenty.plus",
    "torressecuritygroup.com",
    "torrhost.com",
    "torsighpost.cf",
    "torsighpost.tk",
    "tort64.ru",
    "tortconli.ml",
    "tortconli.tk",
    "tortenboxer.de",
    "tortilla.xyz",
    "torvice.cf",
    "torvice.ga",
    "torvice.gq",
    "torvice.ml",
    "torvice.tk",
    "torwotool.com",
    "torwotools.com",
    "torzsasztal.hu",
    "tosciencebible.ru",
    "toshiba-premium.online",
    "toshibaqq.com",
    "toshine.org",
    "tosiga.info",
    "tosilday.ml",
    "tosms.ru",
    "tosonyhari.online",
    "toss.pw",
    "tostiepo.cf",
    "tostiepo.ga",
    "tostiepo.ml",
    "tosunkaya.com",
    "tot.net",
    "total-sportek.net",
    "total.com",
    "totalcoders.com",
    "totalfanhub.com",
    "totalhealthy.fun",
    "totalistasyonlari.com",
    "totalizer311wf.xyz",
    "totalkw.com",
    "totallynotfake.net",
    "totallypianos.com",
    "totalmail.com",
    "totalmail.de",
    "totalmanpower.kiwi",
    "totalmusic.net",
    "totalreconautocenter.com",
    "totalsolv.icu",
    "totalsurf.com",
    "totalvista.com",
    "totalwellnesswi.com",
    "totebagimprints.com",
    "totesmail.com",
    "tothelab.com",
    "tothesis.com",
    "totnet.xyz",
    "toto88.bet",
    "toto88.org",
    "toto96.com",
    "totoan.info",
    "totobet.club",
    "totobo200.com",
    "totobt22.com",
    "totobt23.com",
    "totochi.online",
    "totochi.org",
    "totochi.site",
    "totochi.space",
    "totochi.xyz",
    "totojek.tech",
    "totoson.com",
    "tototaman.com",
    "tototogel4d.xyz",
    "totovip.online",
    "totse1voqoqoad.cf",
    "totse1voqoqoad.ga",
    "totse1voqoqoad.gq",
    "totse1voqoqoad.ml",
    "totse1voqoqoad.tk",
    "totty.ru",
    "toucai131.com",
    "toucai151.com",
    "touchain.net",
    "touchain.one",
    "touchchas.com",
    "touchhcs.com",
    "touchsout.xyz",
    "touchtosuccess.com",
    "toudiswe.gq",
    "tough.cf",
    "toughblarbarw.cf",
    "toughblarbarw.ml",
    "toughcov.icu",
    "toughguy.net",
    "touranya.com",
    "tourbalitravel.com",
    "tourdepeaks.com",
    "tourdulichviet.net",
    "tourerr.space",
    "tourism-life.ru",
    "tourism-live.ru",
    "tourism-ok.ru",
    "tourism.expert",
    "tourism.support",
    "tourismsilverstar.org",
    "tourist-live.ru",
    "tourist61.website",
    "touristguidenepal.com",
    "touristinfo.news",
    "touristoz.ru",
    "touristpower.ru",
    "touristravel.ru",
    "tournament62.website",
    "tours-turizm.ru",
    "toursyogas.info",
    "tourtripbali.com",
    "touseshop.com",
    "tovar-off.ru",
    "tovar-tyt.ru",
    "tovar-zdes.ru",
    "tovarsales70.ru",
    "tovarshopmoscow.ru",
    "tovartovar.site",
    "tovarvtope.site",
    "tovemen.tk",
    "tovhtjd2lcp41mxs2.cf",
    "tovhtjd2lcp41mxs2.ga",
    "tovhtjd2lcp41mxs2.gq",
    "tovhtjd2lcp41mxs2.ml",
    "tovhtjd2lcp41mxs2.tk",
    "tow23g.us",
    "towardstarsgame.com",
    "towb.cf",
    "towb.ga",
    "towb.gq",
    "towb.ml",
    "towb.tk",
    "towerdom.space",
    "towergames.ru",
    "towerlifeglobal.com",
    "towheeci.cf",
    "towheeci.ml",
    "towheeci.tk",
    "towing-services-sandiego.info",
    "towistand.site",
    "townehousediner.com",
    "townisp.com",
    "townofstonington.com",
    "townomics.com",
    "towsempro.cf",
    "towsempro.ml",
    "towsonshowerglass.com",
    "towtravels.info",
    "toxtalk.org",
    "toy-me.ru",
    "toy-tech.ru",
    "toy68n55b5o8neze.cf",
    "toy68n55b5o8neze.ga",
    "toy68n55b5o8neze.gq",
    "toy68n55b5o8neze.ml",
    "toy68n55b5o8neze.tk",
    "toyebet196.com",
    "toygunmarch.com",
    "toyhacking.org",
    "toymalling.site",
    "toyojitu.net",
    "toyoonies.ru",
    "toyota-avalon.club",
    "toyota-chr.club",
    "toyota-clubs.ru",
    "toyota-prius.club",
    "toyota-rav-4.cf",
    "toyota-rav-4.ga",
    "toyota-rav-4.gq",
    "toyota-rav-4.ml",
    "toyota-rav-4.tk",
    "toyota-rav4.cf",
    "toyota-rav4.ga",
    "toyota-rav4.gq",
    "toyota-rav4.ml",
    "toyota-rav4.tk",
    "toyota-sequoia.club",
    "toyota-sequoia.com",
    "toyota-yaris.tk",
    "toyota123.xyz",
    "toyotacorolla.club",
    "toyotamisiones.com",
    "toyotataganka.ru",
    "toyotavlzh.com",
    "toysshop.futbol",
    "toywoz.com",
    "toyzzclubkart.com",
    "toyzzshop.ru",
    "tozmaskesi.com",
    "tozustore.site",
    "tp-qa-mail.com",
    "tp54lxfshhwik5xuam.cf",
    "tp54lxfshhwik5xuam.ga",
    "tp54lxfshhwik5xuam.gq",
    "tp54lxfshhwik5xuam.ml",
    "tp54lxfshhwik5xuam.tk",
    "tpaglucerne.dnset.com",
    "tpahometeam.org",
    "tpapa.ooo",
    "tpass.xyz",
    "tpb-mirror.tk",
    "tpbank.gq",
    "tpbonion.win",
    "tpcebm.tokyo",
    "tpcom.store",
    "tpfqxbot4qrtiv9h.cf",
    "tpfqxbot4qrtiv9h.ga",
    "tpfqxbot4qrtiv9h.gq",
    "tpfqxbot4qrtiv9h.ml",
    "tpfqxbot4qrtiv9h.tk",
    "tpg.com.au",
    "tpg24.com",
    "tph.red",
    "tphqmdtqustuzptqu.ru",
    "tpib5y.us",
    "tpiecer.best",
    "tpk.community",
    "tplccioef.shop",
    "tplqbom.com",
    "tpnyx.fun",
    "tpper.shop",
    "tpq1.com",
    "tpqmanbetx.com",
    "tprtm.shop",
    "tprtmwxh.shop",
    "tprugu.us",
    "tpsdq0kdwnnk5qhsh.ml",
    "tpsdq0kdwnnk5qhsh.tk",
    "tptxiz.us",
    "tpwvawf.space",
    "tpxnu1s3lotyaj6.xyz",
    "tpxvre.us",
    "tq84vt9teyh.cf",
    "tq84vt9teyh.ga",
    "tq84vt9teyh.gq",
    "tq84vt9teyh.ml",
    "tq84vt9teyh.tk",
    "tqbe1b.us",
    "tqc-sheen.com",
    "tql4swk9wqhqg.gq",
    "tqoai.com",
    "tqophzxzixlxf3uq0i.cf",
    "tqophzxzixlxf3uq0i.ga",
    "tqophzxzixlxf3uq0i.gq",
    "tqophzxzixlxf3uq0i.ml",
    "tqophzxzixlxf3uq0i.tk",
    "tqosi.com",
    "tqpxdj.us",
    "tqqun.com",
    "tr-1s.xyz",
    "tr-2s.xyz",
    "tr-3s.xyz",
    "tr-4s.xyz",
    "tr-5s.xyz",
    "tr-bet.com",
    "tr2k.cf",
    "tr2k.ga",
    "tr2k.gq",
    "tr2k.ml",
    "tr2k.tk",
    "tr3s.tech",
    "traanhosting.shop",
    "traapn.rest",
    "trabajan2nos.com",
    "trabalharnashorasvagas.com",
    "trabesp.com",
    "trabzonisilanlari.xyz",
    "trabzonpostasi.xyz",
    "tracanmi.cf",
    "tracanmi.ml",
    "tracciabi.li",
    "tracenstar.cf",
    "tracenstar.ga",
    "tracenstar.gq",
    "tracenstar.ml",
    "tracenstar.tk",
    "traceyhughesbutters.com",
    "tracimna.cf",
    "tracimna.ga",
    "tracimna.gq",
    "tracimna.ml",
    "tracimna.tk",
    "track-custom.com",
    "trackarry.com",
    "trackbillion.live",
    "trackdriver.com",
    "tracker-fb.online",
    "tracking.army",
    "tracking.democrat",
    "tracking.navy",
    "tracking.republican",
    "trackinghub.org",
    "tracklady.club",
    "trackmenow.ru",
    "trackmo.icu",
    "trackmusic.info",
    "trackmyflightnow.com",
    "trackpai.fun",
    "trackprov.icu",
    "tracksalon.club",
    "tracksame.com",
    "tracksnac.xyz",
    "trackspor.us",
    "tracktoolbox.com",
    "trackwatch.ru",
    "trackyourcraft.com",
    "traclecfa.cf",
    "traclecfa.ml",
    "traclecfa.tk",
    "tracsistads.com",
    "tracsistrafficsurveys.com",
    "tractcoun.com",
    "tractionbusinessblog.com",
    "tractitto.cf",
    "tractitto.ml",
    "tractitto.tk",
    "tractors24.com",
    "tractswar.com",
    "tractswor.site",
    "trade-magazine-product.ru",
    "tradebea.us",
    "tradebitrage.com",
    "tradecnyo.cf",
    "tradecnyo.ga",
    "tradecnyo.gq",
    "tradecnyo.ml",
    "tradecnyo.tk",
    "tradecomnn.ru",
    "tradeelb.us",
    "tradeivo.icu",
    "tradelix.club",
    "trader-en-ligne.net",
    "trader-test.site",
    "tradercomputersspot.club",
    "traderlink.adult",
    "tradermail.info",
    "tradersoffortune.com",
    "tradertest.site",
    "tradeseze.com",
    "tradeskins.ru",
    "tradesl.xyz",
    "tradesna.buzz",
    "tradespo.xyz",
    "tradeswallet.online",
    "tradewithrichard.com",
    "tradexan.cf",
    "tradexan.ga",
    "tradexan.gq",
    "tradexan.ml",
    "tradexan.tk",
    "tradexvirtualevents.app",
    "tradiated.com",
    "trading.social",
    "tradingedu.site",
    "tradingtourney.com",
    "traditionalimpacts.com",
    "traducatoriromana.com",
    "traducereenglezaromana.com",
    "tradunen.ml",
    "traeumtgerade.de",
    "traff1c.xyz",
    "traffic-make.ru",
    "trafficmanager.cloud",
    "trafficmanager.link",
    "traffshop.store",
    "trafikcafeer.online",
    "tragaver.ga",
    "tragedyontheconception.com",
    "tragop.shop",
    "trah.fun",
    "trailerplus.shop",
    "trailhero.com",
    "trailmail.org",
    "trailockusa.com",
    "trailslee.com",
    "trailwor.xyz",
    "trailworl.xyz",
    "training-radiopharmacy.com",
    "trainingandnutrtiontruth.com",
    "trainingpedia.co.id",
    "trainingpedia.online",
    "trainingpracticum.ru",
    "trainingstandardsinternational.com",
    "trainingvideos.xyz",
    "trainspottingfan.com",
    "traitclim.us",
    "trak4mandela.africa",
    "trakable.com",
    "traklabs.tech",
    "trakpomo.com",
    "traksta.com",
    "trakyanetiletisim.xyz",
    "tralalajos.ga",
    "tralalajos.gq",
    "tralalajos.ml",
    "tralalajos.tk",
    "tramepel.cf",
    "tramepel.gq",
    "tranbo.site",
    "tranceversal.com",
    "trands-shoes.ru",
    "tranghuudongchieu.ml",
    "tranhelan.ga",
    "tranlamanh.ml",
    "tranmailinh.ga",
    "tranminhphuong.ga",
    "tranquillpoet.com",
    "transactionscenter1.com",
    "transactionshub2.com",
    "transcience.org",
    "transcript-xpress.com",
    "transend.click",
    "transfergoods.com",
    "transferinn.com",
    "transformationalsurgery.com",
    "transformers-zone.ru",
    "transformingz.club",
    "transformyourelationshipsnow.com",
    "transgressiveart.com",
    "transistore.co",
    "translity.ru",
    "translyhhh.space",
    "transmatter.xyz",
    "transmissionmechanism.info",
    "transparenzinitiative.jetzt",
    "transphaeton.com",
    "transporteszuniga.cl",
    "transselfies.com",
    "trantamnhu.ga",
    "trantrungdan.ga",
    "tranyenvy.website",
    "traoluu.com",
    "trap-mail.de",
    "trapassa.ga",
    "trapassa.ml",
    "trapassa.tk",
    "traphouse.party",
    "traplogce.ga",
    "traplogce.gq",
    "traplogce.tk",
    "trasatad.cf",
    "trasatad.ga",
    "trasatad.gq",
    "trasatad.ml",
    "trasatad.tk",
    "trash-amil.com",
    "trash-mail.at",
    "trash-mail.cf",
    "trash-mail.com",
    "trash-mail.de",
    "trash-mail.ga",
    "trash-mail.gq",
    "trash-mail.ml",
    "trash-mail.net",
    "trash-mail.tk",
    "trash-me.com",
    "trash.vikt0ry.com",
    "trash2009.com",
    "trash2010.com",
    "trash2011.com",
    "trash247.com",
    "trash4.me",
    "trashbin.cf",
    "trashbox.eu",
    "trashbox.gq",
    "trashcan.dk",
    "trashcanmail.com",
    "trashdevil.com",
    "trashdevil.de",
    "trashemail.de",
    "trashemails.de",
    "trashimail.de",
    "trashinbox.com",
    "trashinbox.net",
    "trashmail.app",
    "trashmail.at",
    "trashmail.com",
    "trashmail.de",
    "trashmail.ga",
    "trashmail.gq",
    "trashmail.io",
    "trashmail.me",
    "trashmail.net",
    "trashmail.org",
    "trashmail.pw",
    "trashmail.tk",
    "trashmail.ws",
    "trashmailer.com",
    "trashmails.com",
    "trashpandacookbook.com",
    "trashspam.com",
    "trashy.buzz",
    "trashymail.com",
    "trashymail.net",
    "trashyourspouse.com",
    "trast12.icu",
    "trasunram.ml",
    "trasunram.tk",
    "trasz.com",
    "trata.xyz",
    "tratenun.cf",
    "tratenun.ga",
    "tratenun.gq",
    "tratenun.ml",
    "tratenun.tk",
    "trathofun.ga",
    "trathofun.gq",
    "trathofun.ml",
    "tratratratomatra.com",
    "tratrek.com",
    "tratsch.party",
    "traumatherapycenters.com",
    "traumcapital.us",
    "trav3lers.com",
    "trava-kavkaza.ru",
    "travala10.com",
    "travel-venezuela.com",
    "travel.li",
    "traveladaleaders.com",
    "travelandtourismmedia.com",
    "travelbenz.com",
    "travelbestbets.club",
    "travelblogplace.com",
    "traveldesk.com",
    "traveldestination.ru",
    "travelfleet.net",
    "travelforjob.ru",
    "travelhacking4life.com",
    "travelhelps.ru",
    "traveling.monster",
    "travelitis.site",
    "travelkot.ru",
    "travellaptop.net",
    "travellenta.ru",
    "travelnewnews.ru",
    "traveloffers.services",
    "travelopedia.site",
    "travelovelinka.club",
    "travelpointbuilders.com",
    "travelshotels.org",
    "travelsmith.info",
    "traveltagged.com",
    "traveltourist.ru",
    "traveltovegasdeals.com",
    "traveltraderating.com",
    "travelvance.com",
    "traverrateso.host",
    "travertineinstallersofflorida.com",
    "travforross.ga",
    "travforross.ml",
    "travforross.tk",
    "travunen.ga",
    "travunen.gq",
    "travunen.ml",
    "travunen.tk",
    "trayjust.us",
    "trayna.com",
    "trazodone247.video",
    "trbbw.info",
    "trbet277.com",
    "trbet350.com",
    "trbet351.com",
    "trbet477.com",
    "trbet591.com",
    "trbvm.com",
    "trbvn.com",
    "trbvo.com",
    "trckonliserv.xyz",
    "trcpin.com",
    "trdhw.info",
    "treadetaf.cf",
    "treadetaf.ga",
    "treadetaf.gq",
    "treadetaf.ml",
    "treadpoun.icu",
    "treadsl.xyz",
    "treadthi.xyz",
    "treap.net",
    "treasure-inn.com",
    "treasureinntakeaway.com",
    "treatalpa.cf",
    "treatalpa.gq",
    "treatalpa.ml",
    "treatalpa.tk",
    "treatbas.xyz",
    "treatent.icu",
    "treathinan.ga",
    "treathinan.gq",
    "treatmentcanwork.com",
    "trebeshina.com",
    "treblebet.com",
    "trebusinde.cf",
    "trebusinde.ml",
    "tree-some.com",
    "tree-someclothing.com",
    "treebate.org",
    "treeflat.info",
    "treefreeresumes.com",
    "treehealth.site",
    "treepickle.ru",
    "treepnihis.cf",
    "treepnihis.ga",
    "treepnihis.tk",
    "treeringrecords.com",
    "tregame.site",
    "treguboof.ru",
    "treillage.xyz",
    "trek-planet.com",
    "trekholidays.com",
    "trekwire.com",
    "trelephant.com",
    "tremontoworks.info",
    "tremubtib.cf",
    "tremubtib.ga",
    "tremubtib.gq",
    "tremubtib.ml",
    "tremubtib.tk",
    "trenager-ems.ru",
    "trend-maker.ru",
    "trend-on.ru",
    "trend-tovar.ru",
    "trend.lol",
    "trend70.xyz",
    "trendauto.info",
    "trendbet51.com",
    "trendblogmag.site",
    "trendblogmag.xyz",
    "trenddriv.xyz",
    "trendfinance.ru",
    "trendforc.site",
    "trendingtopic.cl",
    "trendinx.com",
    "trendnail.ru",
    "trendshop95.ru",
    "trendsonnet.com",
    "trendstalks.fyi",
    "trendsux.com",
    "trendtattoo.ru",
    "trendunas.ru",
    "trendytoday.live",
    "trendyworldinc.com",
    "trenerov.ru",
    "trengo.me",
    "treniraj.info",
    "trenitalia.gq",
    "trenmayamx.com",
    "trenord.cf",
    "trenord.ga",
    "trenord.gq",
    "trenord.ml",
    "trenord.tk",
    "trentarnettegary.com",
    "treon.info",
    "treon.org",
    "trepicas.gq",
    "trepicas.tk",
    "trerwe.online",
    "trestle.com",
    "treudad.ru",
    "trevas.net",
    "trezvostrus.ru",
    "trf20.online",
    "trg.pw",
    "trgeforcenow.me",
    "trgoals1.club",
    "trgoals3.club",
    "trgovinanaveliko.info",
    "tri-katushki.ru",
    "triad.rr.com",
    "triadstore.ru",
    "trialaloo.xyz",
    "trialbytrivia.com",
    "trialmail.de",
    "triathlongreyhounds.com",
    "triathlonpavese.info",
    "tribalvoices.africa",
    "tribonox79llr.tk",
    "tribora.com",
    "tribsearno.cf",
    "tribsearno.ga",
    "tribsearno.gq",
    "triceptacorecs.com",
    "trickbr.icu",
    "trickcate.fun",
    "trickervip.tk",
    "trickmail.net",
    "tricksho.icu",
    "trickwidth.recipes",
    "tricnabobs.ga",
    "tricnabobs.tk",
    "tricokin.ga",
    "tricokin.gq",
    "tricokin.ml",
    "tricokin.tk",
    "triderprez.cf",
    "triderprez.gq",
    "triderprez.tk",
    "trifectafunnel.com",
    "triginar.ml",
    "triginar.tk",
    "triho.ru",
    "triipmiles.info",
    "trikavli.cf",
    "trikavli.gq",
    "trikavli.tk",
    "trilkompas.com",
    "trillianpro.com",
    "trimbakeshwarhotels.com",
    "trimcams.com",
    "trimix.cn",
    "trimjoper.cf",
    "trimjoper.ga",
    "trimjoper.gq",
    "trimjoper.ml",
    "trimsj.com",
    "trindepcomm.gq",
    "trindepcomm.tk",
    "tringle.online",
    "trinidad.nyc",
    "trinilive.com",
    "trinityfellowshipchurches.org",
    "trinityoee.com",
    "triolus.com",
    "trionym.best",
    "triosc.best",
    "tripanfinance.com",
    "tripecmal.gq",
    "tripecmal.tk",
    "tripinofpa.space",
    "tripjeeps.info",
    "triplejackpoker.com",
    "triplun.xyz",
    "tripmusic.ru",
    "tripmymetrip.site",
    "tripotcher.cf",
    "tripotcher.ga",
    "tripotcher.ml",
    "trippenadmin.site",
    "triprain.info",
    "trips-shop.ru",
    "trisana.net",
    "trisanreeno.club",
    "trishkimbell.com",
    "tristanteo.net",
    "tristanwoodworks.com",
    "tristarcremation.info",
    "triteksolution.info",
    "tritium.net",
    "triton-service.ru",
    "triumphworld.education",
    "triumphworld.school",
    "triumphworldschool.online",
    "triumphworldschools.online",
    "triunemasteryinstitute.com",
    "trivecgroup.se",
    "trivialization494jg.online",
    "trixtrax1.ru",
    "trixtrux1.ru",
    "triz4you.site",
    "trjam.net",
    "trjnd1.site",
    "trmailbox.com",
    "trnyor28-privnrkty.website",
    "trobertqs.com",
    "trobosajalah.ga",
    "trocas.top",
    "trocgoogri.cf",
    "trocgoogri.ml",
    "trocgoogri.tk",
    "trochoi.asia",
    "trock.cf",
    "trogonidae.best",
    "troikasedro.ml",
    "trojanmail.ga",
    "trollandtad.com",
    "trollingforgamers.com",
    "trollproject.com",
    "tromba.best",
    "trombonetube.com",
    "trommlergroup.com",
    "trommleronline.com",
    "trommlershop.com",
    "trompetti.net",
    "tromsomar.ga",
    "tromsomar.ml",
    "tromsomar.tk",
    "tron.care",
    "tron2019.ru",
    "troncomail.club",
    "tronmuzika.ru",
    "tronvenho.cf",
    "tronvenho.ga",
    "tronvenho.gq",
    "tronvenho.ml",
    "tronvenho.tk",
    "troofer.com",
    "troopflash.email",
    "troopsto.press",
    "tropica-asian-cuisine-dalkey.com",
    "tropica-asian-cuisine.com",
    "tropicalbass.info",
    "tropicalstorm.com",
    "tropicpvp.ml",
    "trops888.ru",
    "troserat.cf",
    "troserat.gq",
    "trotebag.com",
    "troubsellpost.cf",
    "troubsellpost.ga",
    "trousdaleassociates.com",
    "trousdalevcholdings.com",
    "trousdaleventurecapitalpartners.com",
    "troxy.us",
    "troyakebabs.com",
    "trrqo.com",
    "trsrrtire.com",
    "trtd.info",
    "trtkitap.com",
    "truartist360.com",
    "truba-stout.ru",
    "trucchisca.cf",
    "trucchisca.ga",
    "trucchisca.tk",
    "truck-autos-zone.sale",
    "truck-dealersspot.live",
    "truckcashoffer.com",
    "truckcoa.buzz",
    "truckeremail.net",
    "truckerlifestyles.com",
    "truckers.com",
    "truckerz.com",
    "truckfault.com",
    "truckhob.icu",
    "truckracer.com",
    "truckracers.com",
    "trucktrader.adult",
    "truckwashbrush.com",
    "truckwashbrush.org",
    "truckwashbrush.us",
    "trucmai.cf",
    "trucmai.ml",
    "trucmai.tk",
    "trucosdemagia.online",
    "trucosymas.com",
    "trucweedra.cf",
    "trucweedra.gq",
    "trucweedra.ml",
    "trucweedra.tk",
    "trud.media",
    "trudoc.net",
    "true-portall1.club",
    "true-secure00.ru",
    "trueallergytesting.com",
    "trueattractions.com",
    "trueblueaff.com",
    "trueblueglobalfranchisinggroup.com",
    "truecoinvalues.com",
    "truecryptorothira.com",
    "truecs.com",
    "truefile.org",
    "truefitt.net",
    "truegoldcenter.com",
    "truegravitydistribution.com",
    "truehealthdentistry.com",
    "truehelpbox.site",
    "truelifecanada.org",
    "truelivewebcams.com",
    "truenaturenetwork.info",
    "truesimplesoft.com",
    "trueyoueats.com",
    "trufficial.com",
    "truhealth.shop",
    "truinstall.com",
    "truly-stunning-skin.com",
    "trum.win",
    "trum86.club",
    "trumbullelderlawgroup.com",
    "trumgamevn.ml",
    "trump.flu.cc",
    "trump.igg.biz",
    "trumpmail.cf",
    "trumpmail.ga",
    "trumpmail.gq",
    "trumpmail.ml",
    "trumpmail.tk",
    "trumptowerscondo.com",
    "trumptowersvegascondos.com",
    "trumpupclose.com",
    "trumpwasgood.com",
    "trumtaixiu.net",
    "trumtn.com",
    "trung.name.vn",
    "trungtamtoeic.com",
    "trungthu.ga",
    "trunorth.coop",
    "trupho.us",
    "truskwashbrushes.org",
    "truskwashbrushes.us",
    "trussinteriors.site",
    "trust-advisor.ru",
    "trust-deals.ru",
    "trust-me.com",
    "trust.games",
    "trustatscale.com",
    "trustcoin.tech",
    "trusted.camera",
    "trusted.clothing",
    "trusted.diamonds",
    "trusted.parts",
    "trusted.photos",
    "trusted.shoes",
    "trusted.style",
    "trusted.trading",
    "trusted.wine",
    "trustedchest.site",
    "trustedcvvshop.ru",
    "trustedhosts.net",
    "trustfb.online",
    "trustfb.site",
    "trustfb.xyz",
    "trustflash.fun",
    "trustfractalforge.com",
    "trustgames.vip",
    "trusthalal.com",
    "trusthomesmidsouth.com",
    "trustinj.trade",
    "trustinthe.cloud",
    "trustjudg.fun",
    "trustlending.pro",
    "trustmall.online",
    "trustme.dk",
    "trustmymeat.com",
    "trustpiiot.site",
    "trustsieg.us",
    "trusttravellive.biz",
    "trusttravellive.info",
    "trusttravellive.net",
    "trusttravellive.org",
    "trusttravellive.travel",
    "trustur.ru",
    "trustware.coach",
    "trustware.us",
    "trustxm.com",
    "truth-publications.com",
    "truth247.com",
    "truthaboutgluten.com",
    "truthandlibertycoalition.com",
    "truthdaredo.com",
    "truthdaredo.net",
    "truthfulintegrity.com",
    "truthmail.com",
    "truthorconsequences.net",
    "truthpowe.buzz",
    "truthye.com",
    "truuhost.com",
    "truvabetgiris.website",
    "truvifoods.com",
    "truvinutrition.com",
    "truvisionhealth.global",
    "truviz.shop",
    "truxbox.ru",
    "trwfey.us",
    "trxubcfbyu73vbg.ga",
    "trxubcfbyu73vbg.ml",
    "trxubcfbyu73vbg.tk",
    "tryalert.com",
    "tryblgs.xyz",
    "tryblog.xyz",
    "trybookr.com",
    "trycatchrepeat.info",
    "tryclickfunnels.com",
    "trymindstein.com",
    "tryninja.io",
    "trynugentix.com",
    "tryorganictips.site",
    "trypayroll.com",
    "trypedoc.cf",
    "trypedoc.ga",
    "trypedoc.gq",
    "trypedoc.ml",
    "tryppin.site",
    "trypregenix.com",
    "tryprice.co",
    "trysubj.com",
    "trytopstaminxtestoboost.com",
    "trytwp.com",
    "tryuf5m9hzusis8i.cf",
    "tryuf5m9hzusis8i.ga",
    "tryuf5m9hzusis8i.gq",
    "tryuf5m9hzusis8i.ml",
    "tryuf5m9hzusis8i.tk",
    "tryvertty.services",
    "tryworks.xyz",
    "tryzoe.com",
    "ts-by-tashkent.cf",
    "ts-by-tashkent.ga",
    "ts-by-tashkent.gq",
    "ts-by-tashkent.ml",
    "ts-by-tashkent.tk",
    "t\u015B.xyz",
    "ts2menswear.com",
    "ts30.club",
    "ts5.xyz",
    "ts93crz8fo5lnf.cf",
    "ts93crz8fo5lnf.ga",
    "ts93crz8fo5lnf.gq",
    "ts93crz8fo5lnf.ml",
    "ts93crz8fo5lnf.tk",
    "tsa8ii.us",
    "tsamail.co.za",
    "tsapplications.com",
    "tsassoo.shop",
    "tsba.xyz",
    "tscamp.ru",
    "tscursos1.com",
    "tscuties.com",
    "tscyule.com",
    "tsczxzc.com",
    "tsdivas.com",
    "tsedalel.cf",
    "tsedalel.ga",
    "tsedalel.ml",
    "tseh10.ru",
    "tsendzerusticcampsite.com",
    "tsgelas.club",
    "tshirt.center",
    "tsikarstak.cf",
    "tsikarstak.ga",
    "tsikarstak.ml",
    "tsikarstak.tk",
    "tsiklessla.ga",
    "tsiklessla.tk",
    "tsipnn.site",
    "tsjp.xyz",
    "tskduz.cf",
    "tsluoli.xyz",
    "tsmc.mx",
    "tsnhw.info",
    "tsoundmost.shop",
    "tsource.ist",
    "tsptw.info",
    "tspzeoypw35.ml",
    "tsrpay.info",
    "tssdz.com",
    "tst69.space",
    "tstcasino.com",
    "tsternie.com",
    "tstetsto.shop",
    "tstoto21.org",
    "tsukushiakihito.gq",
    "tsv00.com",
    "tswd.de",
    "tsyatsys.shop",
    "tsystsya.shop",
    "tsyuan.xyz",
    "tt1775.com",
    "tt18269.com",
    "tt2dx90.com",
    "tta17.com",
    "ttcccs.com",
    "ttchx.com",
    "ttckefu.site",
    "ttcrtk.ru",
    "ttcscan.org",
    "ttdfytdd.ml",
    "ttds.space",
    "ttedttei.shop",
    "ttekstormw.site",
    "tteotted.shop",
    "ttfans.com",
    "tthatin.shop",
    "tthdtquszptutqu.ru",
    "tthemos.shop",
    "tthettha.shop",
    "ttht.us",
    "ttieu.com",
    "ttirv.com",
    "ttirv.net",
    "ttirv.org",
    "ttitoolsale.com",
    "ttkkk2.xyz",
    "ttlalloe.xyz",
    "ttlzw.info",
    "ttman.dns.navy",
    "ttml.co.in",
    "ttmpoker.club",
    "ttmpoker.website",
    "ttmpoker.xyz",
    "ttobogo5.net",
    "ttokto0up00.club",
    "ttomorrow.com",
    "ttopclubr.site",
    "ttopfeedt.site",
    "ttopicopian.site",
    "ttopzf.site",
    "ttoubdzlowecm7i2ua8.cf",
    "ttoubdzlowecm7i2ua8.ga",
    "ttoubdzlowecm7i2ua8.gq",
    "ttoubdzlowecm7i2ua8.ml",
    "ttoubdzlowecm7i2ua8.tk",
    "ttqp101.com",
    "ttr6.su",
    "ttrimbai.site",
    "ttrinet.site",
    "ttrulanea.site",
    "ttrzgbpu9t6drgdus.cf",
    "ttrzgbpu9t6drgdus.ga",
    "ttrzgbpu9t6drgdus.gq",
    "ttrzgbpu9t6drgdus.ml",
    "ttrzgbpu9t6drgdus.tk",
    "ttsbcq.us",
    "ttsi.de",
    "ttsport42.ru",
    "ttszuo.xyz",
    "ttt062.com",
    "ttt324.com",
    "ttt552.com",
    "ttt72pfc0g.cf",
    "ttt72pfc0g.ga",
    "ttt72pfc0g.gq",
    "ttt72pfc0g.ml",
    "ttt72pfc0g.tk",
    "ttt9827.com",
    "tttbhgfdfdsmjhh.monster",
    "tttbvbnv.com",
    "tttcem.xyz",
    "tttfvmknbhkcmk.xyz",
    "tttooo.online",
    "tttv1.com",
    "ttweetlounget.site",
    "ttwijis.site",
    "ttxcom.info",
    "ttxx6868.com",
    "ttytgyh56hngh.cf",
    "ttzbw.info",
    "tu3x8h.us",
    "tu6oiu4mbcj.cf",
    "tu6oiu4mbcj.ga",
    "tu6oiu4mbcj.gq",
    "tu6oiu4mbcj.ml",
    "tu6oiu4mbcj.tk",
    "tualias.com",
    "tuan889p.ga",
    "tuana31.com",
    "tuantoto.com",
    "tuatupo.tk",
    "tubanmentol.ml",
    "tubcasinomek.ru",
    "tubdk2dersum.xyz",
    "tubebrushes.biz",
    "tubecandy.site",
    "tubegalore.site",
    "tubegod.net",
    "tubehide.site",
    "tubehub.net",
    "tubepack.site",
    "tubered.site",
    "tuberkulez.info",
    "tubesurf.net",
    "tubev.site",
    "tubex.buzz",
    "tubexnxx.site",
    "tubeyes.site",
    "tubi-tv.best",
    "tubidy9.com",
    "tubruk.trade",
    "tubzoos.info",
    "tucash1.icu",
    "tuckschool.com",
    "tucogough.cf",
    "tucogough.ml",
    "tucogough.tk",
    "tucsonbesthomes.com",
    "tucsonfreewifi.net",
    "tucuman.shop",
    "tucumcaritonite.com",
    "tudena.pro",
    "tudesearch.cf",
    "tudesearch.ga",
    "tudesearch.gq",
    "tudesearch.ml",
    "tudesearch.tk",
    "tudicthurn.ga",
    "tudicthurn.gq",
    "tudicthurn.ml",
    "tudicthurn.tk",
    "tudouindex.com",
    "tuembarazoymas.com",
    "tuesdaylaura.com",
    "tuesdaymariska.com",
    "tuesdaymovo.com",
    "tufbcdgr18-privcnvfjtu.press",
    "tuferni.club",
    "tuffautos.info",
    "tug.minecraftrabbithole.com",
    "tuga4you.site",
    "tugboater.com",
    "tugobro.ml",
    "tugxbd.online",
    "tuholesa.site",
    "tuhzih.icu",
    "tuiberga.ga",
    "tuiberga.gq",
    "tuiberga.ml",
    "tuiberga.tk",
    "tuimoe.com",
    "tuipharmacy.info",
    "tuipharmacy.net",
    "tujimastr09lioj.ml",
    "tujuhonline.com",
    "tujuhsatusatu.com",
    "tukno.online",
    "tukp.com",
    "tukudawet.tk",
    "tukulyagan.com",
    "tukupedia.co",
    "tukz.net",
    "tular.online",
    "tulipsmail.net",
    "tuljaenak.com",
    "tulsabud.delivery",
    "tulsacannabisdoctor.com",
    "tulsalaw.org",
    "tulsaopiaterehab.com",
    "tulsaprofessionalmatchmakers.com",
    "tulsaspecialtysales.com",
    "tulsi-takeaway.com",
    "tulsitakeaway.com",
    "tumblegroup.com",
    "tumihaleler.xyz",
    "tumima.cf",
    "tumima.ga",
    "tumima.gq",
    "tumima.tk",
    "tumiqq.info",
    "tunaeffect.com",
    "tunasbola.site",
    "tunasbola.website",
    "tuncelidemirkapikoyu.com",
    "tuncpersonel.com",
    "tundy.us",
    "tune.guide",
    "tunisiamail.com",
    "tunnelbeear.com",
    "tunneler.cf",
    "tunnell.org",
    "tunzees.com",
    "tuoficina.online",
    "tuofs.com",
    "tuoihoctro.site",
    "tuoiteen.asia",
    "tuongtactot.tk",
    "tuopzyzc.shop",
    "tuoslo.info",
    "tup.best",
    "tupel.org",
    "tuppencehalfpennyentertainment.com",
    "tur-3tur.ru",
    "tur-top.ru",
    "tur-yog.ru",
    "tur-zoloto.ru",
    "turabet129.com",
    "turabkentseldonusum.com",
    "turava.site",
    "turbiki.ga",
    "turbiki.ml",
    "turbiki.tk",
    "turbobahis6.com",
    "turbonutter.com",
    "turbonzb.com",
    "turboparts.info",
    "turboprinz.de",
    "turboprinzessin.de",
    "turboshack.biz",
    "turboshopes.ru",
    "turbovoicebox.com",
    "turbu.pro",
    "turcaro.ru",
    "turcasinosofa.ru",
    "turekdesigns.com",
    "turekskursiya.ru",
    "turenbox.ru",
    "turf.exchange",
    "turfaq.ru",
    "turfoptimization.com",
    "turfoptimizer.com",
    "turihom.host",
    "turihom.space",
    "turismnews.ru",
    "turismoemcanelars.com",
    "turismohuaraz.com",
    "turist-tur.ru",
    "turistiobro.ru",
    "turistogid.ru",
    "turistoinfo.ru",
    "turizm-okey.ru",
    "turka71.com",
    "turkbet.live",
    "turkbet100.com",
    "turkbet27.com",
    "turkbet3.com",
    "turkbet31.com",
    "turkbet34.com",
    "turkbet35.com",
    "turkbet41.com",
    "turkbet46.com",
    "turkbet5.com",
    "turkbet56.com",
    "turkbet58.com",
    "turkbet60.com",
    "turkbet62.com",
    "turkbet63.com",
    "turkbet66.com",
    "turkbet67.com",
    "turkbet72.com",
    "turkbet73.com",
    "turkbet76.com",
    "turkbet77.com",
    "turkbet79.com",
    "turkbet80.com",
    "turkbet81.com",
    "turkbet83.com",
    "turkbet85.com",
    "turkbet88.com",
    "turkbet9.com",
    "turkbet92.com",
    "turkbet95.com",
    "turkbet97.com",
    "turkdizifilm.xyz",
    "turkey.com",
    "turkeyalerts.com",
    "turkeybeachweddings.com",
    "turkeymedical.tours",
    "turkeyvillasales.com",
    "turkint.ru",
    "turkish-kebab-house-takeaway.com",
    "turkishairlinesopen.golf",
    "turkishrealestates.net",
    "turkiyegercekleri.xyz",
    "turkko.xyz",
    "turkserial.club",
    "turksey.org",
    "turkuazballooning.com",
    "turkuazkebab.com",
    "turkudiyari-sesli.online",
    "turkudiyari-sesli.xyz",
    "turleyprandpublicaffairs.com",
    "turly.site",
    "turma6.com",
    "turn.capital",
    "turnabaikal.ru",
    "turnabet37.com",
    "turnabet40.com",
    "turnabet44.com",
    "turnabet45.com",
    "turnabet51.com",
    "turnback-time.com",
    "turnberrypl.com",
    "turnerdigitalsales.com",
    "turnerlegalpllc.com",
    "turningpoint.store",
    "turnkeyliberty.com",
    "turnkeyprivacy.com",
    "turnpokerid.com",
    "turnpokeronline.com",
    "turntenpe.cf",
    "turntenpe.ga",
    "turoid.com",
    "turrifi.cf",
    "turrifi.ga",
    "turrifi.tk",
    "turs.pro",
    "turtle01.info",
    "turturizm.ru",
    "turual.com",
    "turvichurch.cf",
    "turvichurch.ga",
    "turvichurch.ml",
    "turvichurch.tk",
    "tushi.icu",
    "tushino.net",
    "tusslemyax.space",
    "tustoredigital.es",
    "tuswatchslic.cf",
    "tuswatchslic.ga",
    "tuswatchslic.gq",
    "tuswatchslic.ml",
    "tuswatchslic.tk",
    "tut-turist.ru",
    "tut.by",
    "tuta.io",
    "tutadocs.com",
    "tutadocs.net",
    "tutadocs.site",
    "tutadox.net",
    "tutadox.online",
    "tutadox.site",
    "tutadox.store",
    "tutadox.tech",
    "tutamail.com",
    "tutanota.com",
    "tutanota.de",
    "tutckc.site",
    "tutela-adultos.info",
    "tuthit.com",
    "tutorcolumbus.info",
    "tutordocs.net",
    "tutordocs.site",
    "tutordox.net",
    "tutoringhotline.com",
    "tutsimer.space",
    "tutye.com",
    "tuubz.com",
    "tuulu-altai.ru",
    "tuvimoingay.us",
    "tuvsu-fmf.ru",
    "tuyen889.ml",
    "tuyensinhonline.info",
    "tuyistand.site",
    "tuymades.ga",
    "tuymades.tk",
    "tuyuejiaqi.com",
    "tuyulmokad.ml",
    "tuyulmokad.tk",
    "tuzlaforklift.com",
    "tuzplay33.com",
    "tuzuwa.info",
    "tv-cinema.pro",
    "tv-informacje.site",
    "tv-licensing.xyz",
    "tv-ooh.com",
    "tv-real.com",
    "tv123movies.info",
    "tv24-info.website",
    "tv552.com",
    "tv7bcx8o6wh7pyp.xyz",
    "tvacx0.us",
    "tvaplet.com",
    "tvasiadrama.com",
    "tvb.com.hk",
    "tvbong.fun",
    "tvbong8.fun",
    "tvbong9.fun",
    "tvbrcjnj.shop",
    "tvcablenet.be",
    "tvcablesshop.life",
    "tvccsport.com",
    "tvccsports.org",
    "tvchd.com",
    "tvdj9x.info",
    "tvelef2khzg79i.cf",
    "tvelef2khzg79i.ga",
    "tvelef2khzg79i.gq",
    "tvelef2khzg79i.ml",
    "tvelef2khzg79i.tk",
    "tver-dveri.ru",
    "tverpost.ru",
    "tverpravo.ru",
    "tverskie.net",
    "tverskoe.net",
    "tverya.com",
    "tvetxs.site",
    "tvexpedite.com",
    "tvforanyone.life",
    "tvg-watch-rasshia.ru",
    "tvhdnova.site",
    "tvi72tuyxvd.cf",
    "tvi72tuyxvd.ga",
    "tvi72tuyxvd.gq",
    "tvi72tuyxvd.ml",
    "tvi72tuyxvd.tk",
    "tvinfo.site",
    "tvkey.site",
    "tvlagu.com",
    "tvlicensing-co-uk.xyz",
    "tvmarin.net",
    "tvmoe.com",
    "tvmovies.biz",
    "tvnamu.fun",
    "tvnamu8.fun",
    "tvnawa9.fun",
    "tvnet.lv",
    "tvnxygrn.site",
    "tvoe-videohd.ru",
    "tvoi-mishka.ru",
    "tvoiavigoda.ru",
    "tvoitovarysoskidkoy.ru",
    "tvopros.space",
    "tvoyastihiya4.icu",
    "tvoyastihiya5.icu",
    "tvoyastihiya6.icu",
    "tvoyastihiya7.icu",
    "tvoymanager.ru",
    "tvoyryukzak.ru",
    "tvoyshoping.ru",
    "tvparatv.site",
    "tvst.de",
    "tvstar.com",
    "tvtaxcos.info",
    "tvtnvn.com",
    "tvtoiptv.com",
    "tvtv1234.xyz",
    "tvv55.ru",
    "tvzion.info",
    "twablocose.icu",
    "twanakta.tk",
    "twaucmyrovy.xyz",
    "twc.com",
    "twcny.com",
    "twcny.rr.com",
    "twddos.net",
    "twdesign.org",
    "tweakacapun.wwwhost.biz",
    "tweakcity.city",
    "tweakly.net",
    "tweaks.org",
    "twearch.com",
    "tweatme.com",
    "tweedvalleyicecream.com",
    "tweeflood.com",
    "tweetuphiq.cf",
    "tweetuphiq.ml",
    "tweles.site",
    "twelveaward.com",
    "twelvee.us",
    "twenties.nu",
    "twentybet5.ru",
    "twentylanding.ru",
    "twentylove.com",
    "tweta.site",
    "twevvm.us",
    "twfsale.top",
    "twichzhuce.com",
    "twiclorddhun.ga",
    "twiclorddhun.gq",
    "twiclorddhun.ml",
    "twiclorddhun.tk",
    "twiink.com",
    "twilightsterror.com",
    "twinducedz.com",
    "twinh.info",
    "twinmail.de",
    "twinotterpma.com",
    "twinpoolsandspa.com",
    "twinslabs.com",
    "twinstarsmail.com",
    "twistcasino.ru",
    "twistedpaiwd.com",
    "twistedtortillafreshmexgrill.com",
    "twistersbedandbreakfast.com",
    "twisty-petz-optom.ru",
    "twit-mail.com",
    "twitchieleaks.com",
    "twitchsoftdomen.xyz",
    "twitguide.com",
    "twitlebrities.com",
    "twitlebrity.com",
    "twitt3r.cf",
    "twitt3r.ga",
    "twitt3r.gq",
    "twitt3r.ml",
    "twitt3r.tk",
    "twitter-accs.ru",
    "twitter-sign-in.cf",
    "twitter.com",
    "twitterfact.com",
    "twitterplus.org",
    "twixoutweb.cf",
    "twixoutweb.ga",
    "twixoutweb.gq",
    "twixoutweb.tk",
    "twizadmu.cf",
    "twizadmu.ga",
    "twkj.xyz",
    "twkly.ml",
    "twlcd4i6jad6.cf",
    "twlcd4i6jad6.ga",
    "twlcd4i6jad6.gq",
    "twlcd4i6jad6.ml",
    "twlcd4i6jad6.tk",
    "twlemt.us",
    "twlnw.info",
    "twmail.tk",
    "twn3d.site",
    "two-bet.xyz",
    "two-better-than.one",
    "two-harbors.net",
    "two-shoes.ru",
    "two-tiered.host",
    "two0aks.com",
    "twocolor.ru",
    "twocowmail.net",
    "twofachpen.ga",
    "twofachpen.gq",
    "twofachpen.ml",
    "twofachpen.tk",
    "twohourtop.com",
    "twoindians.com",
    "twojbiznesowydziennik.online",
    "twolyn.com",
    "tworiversbaptist.org",
    "tworkarbou.cf",
    "tworkarbou.ga",
    "tworkarbou.ml",
    "twosale.ru",
    "twoweirdtricks.com",
    "twpride.com",
    "twpsw.info",
    "twsurgeon.com",
    "twt33.xyz",
    "twtscript.com",
    "twvvvfrgjxplpv5.xyz",
    "twymverpworl.ga",
    "twymverpworl.tk",
    "tx.rr.com",
    "tx4000.com",
    "tx5551.com",
    "tx6ufp.info",
    "txairpods.com",
    "txantxiku.tk",
    "txbnyp.us",
    "txd58.space",
    "txedu.org",
    "txhalfpricelistings.com",
    "txhlkbhbs.shop",
    "txii.com",
    "txlq3i.us",
    "txrsvu8dhhh2znppii.cf",
    "txrsvu8dhhh2znppii.ga",
    "txrsvu8dhhh2znppii.gq",
    "txrsvu8dhhh2znppii.ml",
    "txrsvu8dhhh2znppii.tk",
    "txsgw.info",
    "txt10xqa7atssvbrf.cf",
    "txt10xqa7atssvbrf.ga",
    "txt10xqa7atssvbrf.gq",
    "txt10xqa7atssvbrf.ml",
    "txt10xqa7atssvbrf.tk",
    "txt7e99.com",
    "txtadvertise.com",
    "txunilever.com",
    "txwebsiteusa.com",
    "txxiomi.com",
    "txyl168.com",
    "ty.ceed.se",
    "ty.squirtsnap.com",
    "ty068.space",
    "ty069.space",
    "ty072.space",
    "ty073.space",
    "ty075.space",
    "ty081.space",
    "ty082.space",
    "ty11139.xyz",
    "ty119.xyz",
    "ty3322.com",
    "ty355355.com",
    "ty3cgx.us",
    "ty7799.com",
    "ty8800.com",
    "tyagbookd.site",
    "tyagflyd.site",
    "tybreho.ga",
    "tyc.fan",
    "tyc.sk",
    "tyc1158.com",
    "tyc1164.com",
    "tyc33a.com",
    "tyc33b.com",
    "tyc33c.com",
    "tyc33f.com",
    "tyc33g.com",
    "tyc33i.com",
    "tyc33k.com",
    "tyc33m.com",
    "tyc33p.com",
    "tyc33q.com",
    "tyc33s.com",
    "tyc33u.com",
    "tyc33v.com",
    "tyc33x.com",
    "tyc33y.com",
    "tyc33z.com",
    "tyc66b.com",
    "tyc66d.com",
    "tyc66e.com",
    "tyc66f.com",
    "tyc66g.com",
    "tyc66h.com",
    "tyc66m.com",
    "tyc66n.com",
    "tyc66o.com",
    "tyc66r.com",
    "tyc66t.com",
    "tyc66u.com",
    "tyc66w.com",
    "tyc66x.com",
    "tyc66z.com",
    "tyc77a.com",
    "tyc77c.com",
    "tyc77d.com",
    "tyc77e.com",
    "tyc77h.com",
    "tyc77k.com",
    "tyc77l.com",
    "tyc77p.com",
    "tyc77r.com",
    "tyc77s.com",
    "tyc77u.com",
    "tyc77v.com",
    "tyc77w.com",
    "tyc77x.com",
    "tycacmo9best.website",
    "tycai.net",
    "tychangfang.com",
    "tyclonecuongsach.site",
    "tycoma.cf",
    "tycoma.ga",
    "tycoma.gq",
    "tycoma.ml",
    "tycoma.tk",
    "tyconme.ga",
    "tyconme.gq",
    "tyconme.ml",
    "tyconme.tk",
    "tycoonmail.com",
    "tydaab.ru",
    "tydakyda.ru",
    "tydanu.info",
    "tydgr.com",
    "tydnao.com",
    "tydy.site",
    "tyeo.ga",
    "tyeyy.com",
    "tygamusic.net",
    "tyhe.ro",
    "tyhlw.com",
    "tyjiy.live",
    "tyldd.com",
    "tylerellis.org",
    "tylerellisllc.com",
    "tylerseymour.org",
    "tymber.online",
    "tymeiron-pro.ru",
    "tymicep.cf",
    "tymicep.gq",
    "tymicep.tk",
    "tymkvheyo.shop",
    "tympe.net",
    "tynick.win",
    "tyofflof.shop",
    "tyoftyoi.shop",
    "tyopitchsy.cf",
    "tyopitchsy.gq",
    "tyopitchsy.ml",
    "tyopitchsy.tk",
    "typecho.asia",
    "typechocheck.xyz",
    "typemail.com",
    "typesofrehab.com",
    "typestring.com",
    "typity.net",
    "typo3check.xyz",
    "typografille.com",
    "tyrauber.org",
    "tyristo-zen.ru",
    "tyristo.ru",
    "tyrmas.ru",
    "tyrosine.store",
    "tysonsdivorce.party",
    "tysu.site",
    "tyt.by",
    "tytfhcghb.ga",
    "tyuioiuyt.site",
    "tyuobq.space",
    "tyurist.ru",
    "tyuweaw.xyz",
    "tyweetflowy.site",
    "tywmp.com",
    "tyxinc.com",
    "tyxtzioco.shop",
    "tyycmbw8.xyz",
    "tyyel.live",
    "tz-zina.ru",
    "tz.tz",
    "tz3vk1.us",
    "tzfww.com",
    "tzkmp.us",
    "tzlxlwp003.site",
    "tzlxlwp005.site",
    "tzlxlwp006.site",
    "tzlxlwp007.site",
    "tzlxlwp008.site",
    "tzlxlwp009.site",
    "tznlulmxe.shop",
    "tznohv.shop",
    "tzqmirpz0ifacncarg.cf",
    "tzqmirpz0ifacncarg.gq",
    "tzqmirpz0ifacncarg.tk",
    "tzqnw.info",
    "tzrtrapzaekdcgxuq.cf",
    "tzrtrapzaekdcgxuq.ga",
    "tzrtrapzaekdcgxuq.gq",
    "tzrtrapzaekdcgxuq.ml",
    "tzrtrapzaekdcgxuq.tk",
    "tzstudio.ru",
    "tzt22.com",
    "tzxec.com",
    "tzzcw.info",
    "u-cco.org",
    "u-mail.us",
    "u-torrent.cf",
    "u-torrent.ga",
    "u-torrent.gq",
    "u-wills-uc.pw",
    "u.0u.ro",
    "u.10x.es",
    "u.2sea.org",
    "u.900k.es",
    "u.civvic.ro",
    "u.dmarc.ro",
    "u.labo.ch",
    "u.qvap.ru",
    "u0nuw4hnawyec6t.xyz",
    "u0qbtllqtk.cf",
    "u0qbtllqtk.ga",
    "u0qbtllqtk.gq",
    "u0qbtllqtk.ml",
    "u0qbtllqtk.tk",
    "u1.myftp.name",
    "u14269.gq",
    "u14269.ml",
    "u1775.com",
    "u1cykv.us",
    "u1gdt8ixy86u.cf",
    "u1gdt8ixy86u.ga",
    "u1gdt8ixy86u.gq",
    "u1gdt8ixy86u.ml",
    "u1gdt8ixy86u.tk",
    "u1liwc.us",
    "u1pvwg.us",
    "u1z.ru",
    "u2b.comx.cf",
    "u2casino.net",
    "u2casino.org",
    "u2club.com",
    "u30cir.info",
    "u3kvj.us",
    "u3t9cb3j9zzmfqnea.cf",
    "u3t9cb3j9zzmfqnea.ga",
    "u3t9cb3j9zzmfqnea.gq",
    "u3t9cb3j9zzmfqnea.ml",
    "u3t9cb3j9zzmfqnea.tk",
    "u423jf.us",
    "u4iiaqinc365grsh.cf",
    "u4iiaqinc365grsh.ga",
    "u4iiaqinc365grsh.gq",
    "u4iiaqinc365grsh.ml",
    "u4iiaqinc365grsh.tk",
    "u4jhrqebfodr.cf",
    "u4jhrqebfodr.ml",
    "u4jhrqebfodr.tk",
    "u4nzbr5q3.com",
    "u4ves.us",
    "u59wl.space",
    "u5clwe.us",
    "u5i2je.us",
    "u5tbrlz3wq.cf",
    "u5tbrlz3wq.ga",
    "u5tbrlz3wq.gq",
    "u5tbrlz3wq.ml",
    "u5tbrlz3wq.tk",
    "u6lvty2.com",
    "u6spng.info",
    "u6wv97.info",
    "u6yksh-mail.xyz",
    "u7665.com",
    "u7l9s6.com",
    "u7vt7vt.cf",
    "u7vt7vt.ga",
    "u7vt7vt.gq",
    "u7vt7vt.ml",
    "u7vt7vt.tk",
    "u86d8.site",
    "u8mpjsx0xz5whz.cf",
    "u8mpjsx0xz5whz.ga",
    "u8mpjsx0xz5whz.gq",
    "u8mpjsx0xz5whz.ml",
    "u8mpjsx0xz5whz.tk",
    "u9gtz.us",
    "u9nlyx.us",
    "u9y7m8zvi3jhypb.xyz",
    "ua.fm",
    "ua0ole.info",
    "ua10whyx559huni.xyz",
    "ua3jx7n0w3.com",
    "ua6htwfwqu6wj.cf",
    "ua6htwfwqu6wj.ga",
    "ua6htwfwqu6wj.gq",
    "ua6htwfwqu6wj.ml",
    "ua6htwfwqu6wj.tk",
    "uabrandsinternational.com",
    "uacognacfoot.com",
    "uacro.com",
    "uacrossad.com",
    "uae-eko-store.com",
    "uae.ac",
    "uaegiftat.com",
    "uaemail.com",
    "uafsomlp.com",
    "uagtl.us",
    "uagyp.com",
    "uaix.info",
    "ualmail.com",
    "uamtlrlr.shop",
    "uannfamd.ru",
    "uapproves.com",
    "uarara5ryura46.ga",
    "uas-certification.com",
    "uasregistry.net",
    "uathg.live",
    "uautfgdu35e71m.cf",
    "uautfgdu35e71m.ga",
    "uautfgdu35e71m.gq",
    "uautfgdu35e71m.ml",
    "uautfgdu35e71m.tk",
    "uav3pl.com",
    "uavpad.net",
    "uavpowerstation.com",
    "uawlocal94.net",
    "uawycw.ml",
    "uaxary.tokyo",
    "ub288.com",
    "ub5kat.us",
    "ub858.com",
    "ubars.ru",
    "ubavxxbd.shop",
    "ubbi.com",
    "ubbi.com.br",
    "ubcpk0.com",
    "ubdeexu2ozqnoykoqn8.ml",
    "ubdeexu2ozqnoykoqn8.tk",
    "uber-mail.com",
    "uber333.com",
    "uber69route.com",
    "uberketing.com",
    "uberone.info",
    "ubersetzer.nyc",
    "ubicloud.com",
    "ubiqi.net",
    "ubismail.net",
    "ubl-astanalytics.com",
    "ublast-analytics.com",
    "ublastanalytic-s.com",
    "ublastanalytics.com",
    "ubm.md",
    "ubnqpm.ml",
    "uboot.com",
    "ubssvlkv.shop",
    "ubt-uni.info",
    "ubuntu-users.info",
    "ubuntu.dns-cloud.net",
    "ubuntu.dnsabr.com",
    "ubyopa.us",
    "uc.edu",
    "uc132.com",
    "ucakfiyat.com",
    "ucalgaryujgnlh.net",
    "ucandobest.pw",
    "ucansuc.pw",
    "ucarplastikkimya.xyz",
    "ucavlq9q3ov.cf",
    "ucavlq9q3ov.ga",
    "ucavlq9q3ov.gq",
    "ucavlq9q3ov.ml",
    "ucavlq9q3ov.tk",
    "ucche.us",
    "uccstudenthousing.com",
    "uccuyosanjuan.com",
    "ucdn.ooo",
    "ucfcn.net",
    "ucfz1d.us",
    "uchasim.shop",
    "uchiyazik.ru",
    "ucho.top",
    "uci.cu",
    "ucitelka.info",
    "uclacbam.com",
    "ucnezavisimost.com",
    "ucnp.info",
    "uco.es",
    "ucombinator.com",
    "ucourse.club",
    "ucq9vbhc9mhvp3bmge6.cf",
    "ucq9vbhc9mhvp3bmge6.ga",
    "ucq9vbhc9mhvp3bmge6.gq",
    "ucq9vbhc9mhvp3bmge6.ml",
    "ucr.ac.cr",
    "ucr6pb.site",
    "uct.ac.za",
    "uctqoj.us",
    "uctwh.us",
    "ucupdong.ml",
    "ucuzlukpazarim.xyz",
    "ucuzteyp.xyz",
    "ucuzucakbiletin.online",
    "ucw8rp2fnq6raxxm.cf",
    "ucw8rp2fnq6raxxm.ga",
    "ucw8rp2fnq6raxxm.gq",
    "ucw8rp2fnq6raxxm.ml",
    "ucw8rp2fnq6raxxm.tk",
    "ucylu.com",
    "ud0hzn.best",
    "udacityy.com",
    "udaepyo11.net",
    "udaepyo13.net",
    "udasity.com",
    "udcuf4ijm6tpbnv.xyz",
    "udel.edu",
    "udemypack.com",
    "uditkarode.shop",
    "udlmiuojt.shop",
    "udnr.net",
    "udns.cf",
    "udns.gq",
    "udns.tk",
    "udohka-avtomat1990.ru",
    "udoiswell.pw",
    "udrotu.site",
    "udrpattorney.net",
    "udubnation.com",
    "udumu.com",
    "udyrc.site",
    "uedbet333.net",
    "uedhot855.com",
    "uefabucharest.com",
    "uefia.com",
    "uefpr.us",
    "uejumk4yslktvhi.xyz",
    "uemail99.com",
    "uemfpu.us",
    "uemliiawz.shop",
    "ueqj91t0.online",
    "ueqj91t0.space",
    "ueqj91t01t0.online",
    "ueqj91t01t0.space",
    "ueqj91t01t01t0.space",
    "ueqj91t01t0924.online",
    "ueqj91t01t0924.space",
    "ueqj91t042i90j.online",
    "ueqj91t042i90j.space",
    "ueqj91t0924.space",
    "ueqj91t09241t0.online",
    "ueqj91t09241t0.space",
    "ueqj91t0924924.online",
    "ueqj91t0924924.space",
    "ueqj91t0h33u19.online",
    "ueqj91t0h33u19.space",
    "ueqj91t0vhh13h.online",
    "ueqj91t0vhh13h.space",
    "ueqj942i90j.online",
    "ueqj942i90j.space",
    "ueqj942i90j1t0.online",
    "ueqj942i90j1t0.space",
    "ueqj942i90j924.online",
    "ueqj942i90j924.space",
    "ueqj9924.online",
    "ueqj9924.space",
    "ueqj99241t0.online",
    "ueqj99241t0.space",
    "ueqj99241t01t0.online",
    "ueqj99241t01t0.space",
    "ueqj99241t0924.online",
    "ueqj99241t0924.space",
    "ueqj992442i90j.online",
    "ueqj992442i90j.space",
    "ueqj9924924.online",
    "ueqj9924924.space",
    "ueqj99249241t0.online",
    "ueqj99249241t0.space",
    "ueqj9924924924.online",
    "ueqj9924924924.space",
    "ueqj9924h33u19.online",
    "ueqj9924vhh13h.space",
    "ueqj9bn9fbwv.online",
    "ueqj9bn9fbwv.space",
    "ueqj9h33u19.space",
    "ueqj9h33u191t0.online",
    "ueqj9h33u19924.online",
    "ueqj9h33u19924.space",
    "ueqj9jrbh2h4.online",
    "ueqj9vhh13h.online",
    "ueqj9vhh13h.space",
    "ueqj9vhh13h1t0.online",
    "ueqj9vhh13h1t0.space",
    "ueqj9vhh13h924.online",
    "ueqj9vhh13h924.space",
    "ueses.club",
    "uestabbetting.xyz",
    "uetimer.com",
    "uew0i.us",
    "ufa-moscow.ru",
    "ufa090.info",
    "ufa8989.info",
    "ufa9898.info",
    "ufaamigo.site",
    "ufabetapi.com",
    "ufabystore.com",
    "ufacturing.com",
    "ufascr168.com",
    "ufatoday88.net",
    "ufbpq9hinepu9k2fnd.cf",
    "ufbpq9hinepu9k2fnd.ga",
    "ufbpq9hinepu9k2fnd.gq",
    "ufbpq9hinepu9k2fnd.ml",
    "ufbpq9hinepu9k2fnd.tk",
    "ufcticket.ru",
    "uffdacap.com",
    "uffdacapital.com",
    "uffdo.com",
    "uffm.de",
    "ufgqgrid.xyz",
    "ufiwmslou.shop",
    "ufkakaya.ru",
    "ufkhhsov.shop",
    "ufl.edu",
    "ufoairs.info",
    "ufoeq.live",
    "ufrdtrdv.shop",
    "uftmjcsuh.shop",
    "ufukbagci.icu",
    "ufxcnboh4hvtu4.cf",
    "ufxcnboh4hvtu4.ga",
    "ufxcnboh4hvtu4.gq",
    "ufxcnboh4hvtu4.ml",
    "ufxcnboh4hvtu4.tk",
    "ug02.icu",
    "ug080593nubrm09.xyz",
    "ugandasports.online",
    "ugandi.com",
    "uganondee.host",
    "ugbisp.gq",
    "ugbwy.com",
    "ugf9bd.host",
    "ugg-495.ru",
    "uggbootssale2011.info",
    "uggi-chelyabinsk.ru",
    "uggi-kurgan.ru",
    "uggi-kzn.ru",
    "uggi-magadan.ru",
    "uggi-nvartovsk.ru",
    "uggi-rostov.ru",
    "uggi-simferopol.ru",
    "uggi-ufa.ru",
    "uggi-volgograd.ru",
    "uggibelgorod.ru",
    "uggibryansk.ru",
    "uggiizhevsk.ru",
    "uggikaluga.ru",
    "uggikirov.ru",
    "uggikursk.ru",
    "uggilipeck.ru",
    "uggisaratov.ru",
    "uggitambov.ru",
    "uggitomsk.ru",
    "uggitver.ru",
    "uggityumen.ru",
    "uggiulyanovsk.ru",
    "uggkids.online",
    "uggout.com",
    "uggsrock.com",
    "ugimail.net",
    "ugjfzx.info",
    "ugkal.site",
    "ugkugbkh5-privjpjp.fun",
    "ugkugbkh5-privjpjp.host",
    "ugkugbkh5-privjpjp.site",
    "ugkugbkh5-privjpjp.space",
    "ugkugbkh5-privjpjp.website",
    "ugkugbkh5-privjpjp.xyz",
    "ugogi.com",
    "ugoxxf.tokyo",
    "ugpna.com",
    "ugreatejob.pw",
    "uguisudanideli.net",
    "ugusre.tokyo",
    "uguuchantele.com",
    "uh7w5t.us",
    "uha.kr",
    "uhbqsboyg.shop",
    "uhcbook.tk",
    "uhds.tk",
    "uhewl684.monster",
    "uhfnk1.site",
    "uhhu.ru",
    "uho1nhelxmk.ga",
    "uho1nhelxmk.gq",
    "uho1nhelxmk.ml",
    "uho1nhelxmk.tk",
    "uhodmsk.ru",
    "uhoxiy.us",
    "uhsbriarp.shop",
    "uhtgq.com",
    "uhtso.com",
    "uhyea.com",
    "uiaep1.site",
    "uibbahwsx.xyz",
    "uibc.club",
    "uidckjut.shop",
    "uikd.com",
    "uinta.tech",
    "uipvu.site",
    "uish6.info",
    "uiu.us",
    "uiy7ob.info",
    "uj0sx.info",
    "ujames3nh.com",
    "ujapbk1aiau4qwfu.cf",
    "ujapbk1aiau4qwfu.ga",
    "ujapbk1aiau4qwfu.gq",
    "ujapbk1aiau4qwfu.ml",
    "ujapbk1aiau4qwfu.tk",
    "ujaw.net",
    "ujbsale.top",
    "ujcss.live",
    "ujdah.us",
    "ujgmn.us",
    "ujicoba12.xyz",
    "ujicoba14.xyz",
    "ujicoba8.xyz",
    "ujijima1129.gq",
    "ujkuwkni.shop",
    "ujl1gf.us",
    "ujm1ck.us",
    "ujxspots.com",
    "uk-unitedkingdom.cf",
    "uk-unitedkingdom.ga",
    "uk-unitedkingdom.gq",
    "uk-unitedkingdom.ml",
    "uk-unitedkingdom.tk",
    "uk.flu.cc",
    "uk.igg.biz",
    "uk.nut.cc",
    "uk.pl",
    "uk.to",
    "uk2.net",
    "uk2k.com",
    "uk2net.com",
    "uk7.net",
    "uk8.net",
    "uk90es.us",
    "ukbikers.net",
    "ukbuilder.com",
    "ukcleaners.com",
    "ukcool.com",
    "ukcraps.com",
    "ukdhv.live",
    "ukdreamcast.com",
    "ukelsd.us",
    "ukexample.com",
    "ukflooringdirect.com",
    "ukfun.com",
    "ukgaw.com",
    "ukgaw.org",
    "ukgeq.us",
    "ukgfw.net",
    "ukhome.net",
    "ukhotels.org",
    "ukilo3.site",
    "ukipbroadband.com",
    "ukiperemastetesendirishop.com",
    "ukjton.cf",
    "ukjton.ga",
    "ukjton.gq",
    "ukjton.ml",
    "ukjton.tk",
    "ukladkaasfalt.ru",
    "uklandlords.com",
    "ukld.ru",
    "ukmail.com",
    "ukmail.org",
    "ukmax.com",
    "ukno.com",
    "uknuts.com",
    "uko.kr",
    "uko6nx.us",
    "ukonline.com",
    "ukoxqt.us",
    "ukpeople.com",
    "ukr.net",
    "ukraine-gox.ru",
    "ukraingate.news",
    "ukrainianidea.org",
    "ukrainigate.news",
    "ukrgov.com",
    "ukrolika.ru",
    "ukrpost.net",
    "ukrtop.com",
    "ukschool.com",
    "ukshoppers.com",
    "uksmm.biz",
    "ukswingersmeet.com",
    "uktf3s.online",
    "ukttht.xyz",
    "uku.co.uk",
    "ukuni.com",
    "ukvisa.space",
    "ukxgvjxxx.shop",
    "uky.edu",
    "ukyjgs.us",
    "ukzjrnmfguxm7rp.xyz",
    "ul.ie",
    "ulahadigung.cf",
    "ulahadigung.ga",
    "ulahadigung.gq",
    "ulahadigung.ml",
    "ulahadigung.tk",
    "ulahadigungproject.cf",
    "ulahadigungproject.ga",
    "ulahadigungproject.gq",
    "ulahadigungproject.ml",
    "ulahadigungproject.tk",
    "ulaptopsn.com",
    "ularonline.net",
    "ularonline.org",
    "ulck4w.us",
    "ulconto.cf",
    "ulconto.ga",
    "ulconto.ml",
    "ulconto.tk",
    "uletqq.com",
    "ulgran-stav.ru",
    "ulidgid.cf",
    "ulidgid.ml",
    "ulidgid.tk",
    "ulipox.xyz",
    "ullife.info",
    "ullyyd.icu",
    "ulolan.host",
    "ulotrichous.site",
    "ulovdu.cf",
    "ulovdu.gq",
    "ulovdu.tk",
    "uloxh.icu",
    "ulpxot.us",
    "ulqoirraschifer.cf",
    "ulqoirraschifer.ga",
    "ulqoirraschifer.gq",
    "ulqoirraschifer.ml",
    "ulqoirraschifer.tk",
    "ulsters.best",
    "ultamaytumpools.net",
    "ultapulta.com",
    "ultdeliquid.com",
    "ultdesign.ru",
    "ulteja.cf",
    "ulteja.gq",
    "ulteja.ml",
    "ultiemestudent.online",
    "ultijar.cf",
    "ultijar.ga",
    "ultijar.gq",
    "ultijar.ml",
    "ultimateaussieadventure.com",
    "ultimateheartvisions.com",
    "ultimatelimos.com",
    "ultimatemediaconcepts.net",
    "ultimatesystems.xyz",
    "ultimi-prodotti.fun",
    "ultimotech45.xyz",
    "ultiselect-malelifestyletoday.com",
    "ultiselect-malenow.com",
    "ultra-craft.ru",
    "ultra.fyi",
    "ultrabet128.com",
    "ultrabet144.com",
    "ultrabet184.com",
    "ultrabet189.com",
    "ultrabet200.com",
    "ultrada.ru",
    "ultrafan.site",
    "ultraimperialism.best",
    "ultraleverage.com",
    "ultraliffe.space",
    "ultramovie.biz",
    "ultraocr.com",
    "ultraperformans.online",
    "ultrapostman.com",
    "ultraschallanlagen.de",
    "ultraslimdvr.com",
    "ultrasoundtherapies.com",
    "ultrasoundtreatments.com",
    "ultrawebb.com",
    "ultrawit.online",
    "ultrazeelwatchluxnow.com",
    "ultronbet.com",
    "ulucky.net",
    "ulumdocab.xyz",
    "ulunpasadgo.ru",
    "ulusalmedya.net",
    "ulxag.us",
    "ulyufyjwwrm4sni.xyz",
    "ulzlfh.us",
    "um0vwn.us",
    "um2dq7.us",
    "umail.net",
    "umail2.com",
    "umail365.com",
    "umailbox.net",
    "umailz.com",
    "umakanth.online",
    "umanit.cloud",
    "umanit.dev",
    "umanit.net",
    "umanit.online",
    "umanit.space",
    "umanit.store",
    "umanit.us",
    "umbrellainvesting.xyz",
    "umbrila.com",
    "umc67.space",
    "umedis.org",
    "umessage.cf",
    "umgqpw.info",
    "umgwali.org",
    "umhyri.site",
    "umica.com",
    "umich.edu",
    "umicon-crimea.ru",
    "umin12.com",
    "uminu.com",
    "umka-mgn.ru",
    "umlesin.ru",
    "umm77.com",
    "ummah.org",
    "umn.edu",
    "umode.net",
    "umpire.com",
    "umprotat.cf",
    "umprotat.ga",
    "umprotat.gq",
    "umprotat.tk",
    "umraniyeanadolulisesi.xyz",
    "umrika.com",
    "umrn.ga",
    "umrn.gq",
    "umrn.ml",
    "umrohdulu.com",
    "umss.de",
    "umtmusic.com",
    "umuey.com",
    "umy.kr",
    "umyld5.us",
    "umynv.us",
    "un99ulq.xyz",
    "unabla.cf",
    "unabla.ga",
    "unabla.ml",
    "unaccompaniedminers.com",
    "unadmo.cf",
    "unadmo.gq",
    "unadmo.ml",
    "unakihn.info",
    "unalbaby.biz",
    "unalcas.cf",
    "unalcas.ga",
    "unalcas.gq",
    "unalcas.ml",
    "unalcas.tk",
    "unalstore.xyz",
    "unama.br",
    "unamiradafinanciera.com",
    "unanon.cf",
    "unanon.tk",
    "unappartalacle.com",
    "unasolaviva.com",
    "unbanq.com",
    "unbedarft.love",
    "unblock.dog",
    "unblockedgamesrun.com",
    "unblockit.club",
    "unblockit.link",
    "unblockproxy.one",
    "unbounded.com",
    "unc.app",
    "uncause.org",
    "uncensored.rf.gd",
    "uncg.edu",
    "unchained.city",
    "unchanti.cf",
    "unchanti.ga",
    "unchanti.ml",
    "unclecode.stream",
    "unclepetestakeaway.com",
    "unclesamswexford.com",
    "unclest.icu",
    "uncletha.us",
    "uncletr.icu",
    "unclick.ru",
    "unco.edu",
    "uncoma.cf",
    "uncoma.gq",
    "uncoma.tk",
    "uncommonsenseunlimited.com",
    "uncond.us",
    "uncoy.live",
    "uncuvend.ga",
    "undefinedtreat.xyz",
    "under30finance.com",
    "underangelswing.org",
    "undercases.com",
    "underemphasize323ug.online",
    "underfetwx.space",
    "undergmail.com",
    "underirxtd.site",
    "underlipserv.info",
    "underpoddk.space",
    "undersdotw.space",
    "undersell-info-shop.site",
    "undersell-stock-sale.site",
    "undertheradar.site",
    "underwriters.com",
    "undeva.net",
    "undfans.com",
    "undiagnosed.net",
    "undime.ru",
    "undme.xyz",
    "undo.it",
    "undochemo.com",
    "undol-kazanskijhram.ru",
    "undoredo.online",
    "undroldintho.website",
    "undwelsu.cf",
    "undwelsu.ga",
    "undwelsu.gq",
    "undwelsu.tk",
    "uneccu.ga",
    "uneccu.ml",
    "uneccu.tk",
    "unelignepourlavie.com",
    "unelos.cf",
    "unelos.ml",
    "unelos.tk",
    "unenex.cf",
    "unenex.gq",
    "unenex.ml",
    "unetus.online",
    "uneverse.ru",
    "unfao.net",
    "unfibbed.best",
    "unfollowersforinsta.com",
    "unforenppf.space",
    "unforgettable.com",
    "ungdom.dk",
    "ungenickt-183g5s0.tk",
    "ungenickt-ah3qz6d.tk",
    "ungenickt-ah47am9.tk",
    "ungenickt-freshmen.ml",
    "ungenickt-rubymail.tk",
    "ungeniert.love",
    "unggulpkr.com",
    "unggulpoker.com",
    "ungjuris.site",
    "unhoused.network",
    "uni-miskolc.hu",
    "uni-proxies.com",
    "uni.de",
    "uni.de.de",
    "uni.demailto.de",
    "uni.me",
    "unibahis3.com",
    "unibloom.host",
    "unican.es",
    "unicersalcreditsolved.com",
    "unichell.fun",
    "unicity.name",
    "unicity.shop",
    "unicity.tech",
    "unicodeworld.com",
    "unicorn-restaurant.com",
    "unicorntoday.com",
    "unicreatures.com",
    "unicredit.tk",
    "unids.com",
    "uniduniv.shop",
    "unif8nthemsmnp.cf",
    "unif8nthemsmnp.ga",
    "unif8nthemsmnp.gq",
    "unif8nthemsmnp.ml",
    "unif8nthemsmnp.tk",
    "unifaction.com",
    "unifyfxu.com",
    "unihash.info",
    "unihash.net",
    "unihome.com",
    "unikafester.se",
    "unikle.com",
    "unilend.info",
    "unimark.org",
    "union-trade-hit.ru",
    "unioncity.florist",
    "uniontou.us",
    "uniqmachines.com",
    "unique3d.com",
    "uniqueqq.info",
    "uniqweb.space",
    "unirom.ga",
    "unirom.gq",
    "unirom.ml",
    "unirom.tk",
    "uniruniv.shop",
    "unisal.ngo",
    "unisystem.store",
    "unit7lahaina.com",
    "unitconversiontool.com",
    "unite.cloudns.asia",
    "unitedasia.club",
    "unitedasia.marketing",
    "unitedasia.network",
    "unitedasia.online",
    "unitedjiu-jitsu.com",
    "unitedmartialartskaty.com",
    "unitednpeace.org",
    "unitedstatesvdonaldtrump.com",
    "unitedstormadjusters.org",
    "unitelsd.com",
    "unitmate.com",
    "unitybox.de",
    "unitycaus.xyz",
    "unityofgulfbreeze.org",
    "unityofstudents.com",
    "univ21.com",
    "universablockchain.tech",
    "universal.pt",
    "universal388.net",
    "universal388.org",
    "universalassetsportfolio.com",
    "universalcreditbuilder.com",
    "universalcreditfile.com",
    "universalcreditlimit.com",
    "universalcreditor.com",
    "universalcreditscores.com",
    "universalfilm.ru",
    "universalkabbalahcommunities.org",
    "universaltextures.com",
    "universenews.site",
    "universidadditella.org",
    "univestycoty.com",
    "univibrasyon.com",
    "univision.com",
    "univocal.site",
    "univocalic.xyz",
    "univunid.shop",
    "uniwetten.com",
    "unix.university",
    "unixproject.ru",
    "unjabazaar.com",
    "unjhaapmcbazar.com",
    "unkempocys.space",
    "unkn0wn.ws",
    "unknmail.com",
    "unknown.pizza",
    "unlightly.site",
    "unlimit.com",
    "unlimit.email",
    "unlimitedlinuxresellerhosting.com",
    "unlimitedwebhostingindia.com",
    "unlockallnetflix.com",
    "unlofty.best",
    "unmadeinchina.net",
    "unmail.ru",
    "unmetered.ltd",
    "unmetered.se",
    "unmoeglich.love",
    "unnarf.icu",
    "unnitv.com",
    "unnuhol.ga",
    "unnuhol.gq",
    "unnuhol.ml",
    "uno.ee",
    "uno.it",
    "unofree.it",
    "unofyfcu.com",
    "unogoalz.club",
    "unomail.com",
    "unomail9.com",
    "unorid.cf",
    "unorid.tk",
    "unoutta.cf",
    "unoutta.ga",
    "unoutta.gq",
    "unoutta.tk",
    "unpastore.co",
    "unpermwbru.space",
    "unpresumidence.xyz",
    "unpromptedhappiness.com",
    "unquesvsoy.space",
    "unrafo.cf",
    "unrafo.ga",
    "unrafo.gq",
    "unrafo.ml",
    "unraveled.us",
    "unregenerate.best",
    "unrodi.xyz",
    "unsacred.net",
    "unseen.eu",
    "unseen.is",
    "unshift.com",
    "unspokendad.com",
    "unstcdskz.shop",
    "untehal.cf",
    "untehal.gq",
    "untehal.ml",
    "untehal.tk",
    "unterderbruecke.de",
    "unthunpanb.gq",
    "untleecsio.ga",
    "untouchedsiberia.ru",
    "untract.com",
    "untuk.us",
    "unubvq.us",
    "ununlai.ga",
    "ununlai.ml",
    "ununlai.tk",
    "unusov.online",
    "unvaledpsychological.net",
    "unvaledpsychological.org",
    "unvaledpsychological.us",
    "unwiki.org",
    "uny.kr",
    "unzabajaar.com",
    "unzabazar.com",
    "uo8fylspuwh9c.cf",
    "uo8fylspuwh9c.ga",
    "uo8fylspuwh9c.gq",
    "uo8fylspuwh9c.ml",
    "uo8fylspuwh9c.tk",
    "uof-assoc.org",
    "uof196ye8i3v3j8.xyz",
    "uogtritons.com",
    "uohqbb.site",
    "uojjhyhih.cf",
    "uojjhyhih.ga",
    "uojjhyhih.gq",
    "uojjhyhih.ml",
    "uol.com.ar",
    "uol.com.br",
    "uol.com.co",
    "uol.com.mx",
    "uol.com.ve",
    "uola.org",
    "uole.com",
    "uole.com.ve",
    "uolmail.com",
    "uomail.com",
    "uomhtf.icu",
    "uowonb.shop",
    "up2date-nutzer-deutschland-12315242-de-checker.ru",
    "up9zow.us",
    "upak-vakuum.ru",
    "upakologiya.ru",
    "upapa.ooo",
    "upatient.com",
    "upb.university",
    "upbrellastore.ru",
    "upc.nl",
    "upclube.com",
    "upcmail.ie",
    "upcmail.nl",
    "upcmaill.com",
    "update-today.xyz",
    "update-tpday.xyz",
    "update1c.ru",
    "updateinfodev.net",
    "updates9z.com",
    "updateusermob.xyz",
    "updating.page",
    "updmysoft.icu",
    "upentors.ru",
    "upetreal.ru",
    "upf.org",
    "upf7qtcvyeev.cf",
    "upf7qtcvyeev.ga",
    "upf7qtcvyeev.gq",
    "upf7qtcvyeev.tk",
    "upgcsjy.com",
    "upgrademyconsciousness.com",
    "uphere.net",
    "uphold.financial",
    "upholdfinancial.financial",
    "upholdfinancial.holdings",
    "upholdfinancial.management",
    "upholdfinancial.ventures",
    "upholdpay.com",
    "upholsbyeo.space",
    "uphomail.ga",
    "uphomeideas.info",
    "upizzatakeaway.com",
    "upl0adand1nsta11.com",
    "uplay-store.ru",
    "upliftnow.com",
    "uplinkdesign.com",
    "uplipht.com",
    "uploadboy.net",
    "uploadnolimit.com",
    "uploads.page",
    "uploadscript.com",
    "uploadshare.ru",
    "uplvbg.com",
    "upmoe.com",
    "upmovies.me",
    "upnutrition.app",
    "upoker.site",
    "uponshoes.org",
    "upozowac.info",
    "uppror.se",
    "upraink.ru",
    "uprightbroom.biz",
    "uprightbroom.com",
    "uprightbroom.us",
    "uprightbrooms.biz",
    "uprightbrooms.net",
    "uprightbrooms.us",
    "uproarinteractive.com",
    "uprsoft.ru",
    "upsetac.buzz",
    "upsetbrav.icu",
    "upsetbrav.xyz",
    "upsetfo.email",
    "upsetmone.space",
    "upsetstudy.email",
    "upside.blog",
    "upsiderealty.store",
    "upskirt-central.com",
    "upskirtscr.com",
    "upskrcnd.ml",
    "upspecul.cf",
    "upspecul.ga",
    "upspecul.tk",
    "upstairsgallery.org",
    "upstate.dev",
    "upstatecadillacdealers.com",
    "upterip.cf",
    "upterip.gq",
    "upterip.ml",
    "upterip.tk",
    "uptin.net",
    "uptiwin.cf",
    "uptiwin.ga",
    "uptiwin.tk",
    "upto1.shop",
    "uptodate.tech",
    "uptownartsgranburytx.com",
    "uptrendwindsor.com",
    "upvid.website",
    "upwithme.com",
    "upwwpgjvj.shop",
    "upy.kr",
    "upyou.online",
    "uq8c.us",
    "uq8kpl.us",
    "uqcgga04i1gfbqf.cf",
    "uqcgga04i1gfbqf.ga",
    "uqcgga04i1gfbqf.gq",
    "uqcgga04i1gfbqf.ml",
    "uqcgga04i1gfbqf.tk",
    "uqghq6tvq1p8c56.cf",
    "uqghq6tvq1p8c56.ga",
    "uqghq6tvq1p8c56.gq",
    "uqghq6tvq1p8c56.ml",
    "uqghq6tvq1p8c56.tk",
    "uqofr.com",
    "uqxcmcjdvvvx32.cf",
    "uqxcmcjdvvvx32.ga",
    "uqxcmcjdvvvx32.gq",
    "uqxcmcjdvvvx32.ml",
    "uqxcmcjdvvvx32.tk",
    "uqxgbt.us",
    "uqxgz.com",
    "urabbow.cf",
    "urabbow.tk",
    "uradresnsk.ru",
    "uralidze.ru",
    "uralmaxx.ru",
    "uralmer.ru",
    "uralplay.ru",
    "uralsk-airport.ru",
    "uralviayli.host",
    "uran.realty",
    "uranai-soudan.info",
    "uraniomail.com",
    "urayuliya.ru",
    "urbanban.com",
    "urbanblackpix.space",
    "urbancampout.icu",
    "urbanchannel.info",
    "urbanchannel.live",
    "urbanchickencoop.com",
    "urbancowboypoetry.com",
    "urbanfamilyfoundation.org",
    "urbanlanguageadventures.com",
    "urbannw.org",
    "urbanoaks.community",
    "urbanoaks.properties",
    "urbanoaks.us",
    "urbanquarter.co",
    "urbanspacepractice.com",
    "urbanstudios.online",
    "urbanvelo.ru",
    "urbaza.com",
    "urbismail.com",
    "urcarfresheners.irish",
    "urchatz.ga",
    "ureach.com",
    "uredemail.com",
    "ureee.us",
    "ureforp.com",
    "uremno.ga",
    "uremno.ml",
    "urepair.site",
    "urewsao.online",
    "urfadegerkaybi.com",
    "urfalimrestaurant.com",
    "urfalimrestaurant.xyz",
    "urfapazari.net",
    "urfavtech.biz",
    "urfey.com",
    "urfunktion.se",
    "urgamebox.com",
    "urgeinnovationlesson.website",
    "urgentmail.biz",
    "urhen.com",
    "urlina.ru",
    "urlmoe.com",
    "urlre.com",
    "urltc.com",
    "urlux.ru",
    "urlwiki.com",
    "urmoney.icu",
    "urmosa.ru",
    "uroid.com",
    "uroki-logopeda.ru",
    "urokitv.ru",
    "urotrin-supershop.ru",
    "urotrin62.ru",
    "urotrinium.ru",
    "urotrinz-supershop.ru",
    "urrala.cf",
    "urrala.ga",
    "urrala.tk",
    "urs4kd9f2aufma7.xyz",
    "ursdursh.shop",
    "urshursd.shop",
    "ursms.ru",
    "urstar.site",
    "urta.cz",
    "urthmovement.org",
    "urtinu.cf",
    "urtinu.ga",
    "urtinu.gq",
    "urtinu.ml",
    "uruarurqup5ri9s28ki.cf",
    "uruarurqup5ri9s28ki.ga",
    "uruarurqup5ri9s28ki.gq",
    "uruarurqup5ri9s28ki.ml",
    "uruarurqup5ri9s28ki.tk",
    "urules.ru",
    "urulsour.cf",
    "urzelni.cf",
    "urzelni.ga",
    "urzelni.gq",
    "urzelni.tk",
    "us-cup.com",
    "us-ranch.com",
    "us.af",
    "us.armymil.com",
    "us.dlink.cf",
    "us.dlink.gq",
    "us.monkeywerks.net",
    "us.to",
    "us315.xyz",
    "us3day.com",
    "us7day.com",
    "usa-cc.usa.cc",
    "usa-gov.cf",
    "usa-gov.ga",
    "usa-gov.gq",
    "usa-gov.ml",
    "usa-gov.tk",
    "usa-lasvegas.com",
    "usa-nevada.com",
    "usa-newjersey.com",
    "usa-newyorkcity.com",
    "usa-northcarolina.com",
    "usa.cc",
    "usa.com",
    "usa.isgre.at",
    "usa.net",
    "usa623.gq",
    "usaaccess.net",
    "usaacrdmail.com",
    "usaagents.com",
    "usaairjordann.com",
    "usabemestarfit.icu",
    "usabestturmeric.net",
    "usabookies.com",
    "usabrains.us",
    "usabrandhover.space",
    "usabs.org",
    "usacentrall.com",
    "usachan.cf",
    "usachan.gq",
    "usachan.ml",
    "usacityfacts.com",
    "usactive.ru",
    "usadaniesstore.com",
    "usaf.dmtc.press",
    "usahapoker.org",
    "usahavanastore.com",
    "usaindiananewyear.com",
    "usakataturkioo.xyz",
    "usakca.xyz",
    "usakliuncular.xyz",
    "usako.be",
    "usako.net",
    "usakteknikyapi.xyz",
    "usaliffebody.online",
    "usaliffebody.site",
    "usaliffebody.store",
    "usanetmail.com",
    "usaohionewyears.com",
    "usaoppo.com",
    "usaotong.com",
    "usapodcasd.com",
    "usarealme.com",
    "usariderclothing.com",
    "usartroreser.ru",
    "usask.ca",
    "usasyracuseoffc.com",
    "usatelor.com",
    "usatennesseenewyears.com",
    "usatexasnewyears.com",
    "usaultraliffe.host",
    "usaultraliffe.website",
    "usaunldqc.shop",
    "usaveroofficial.com",
    "usavsdonaldtrump.com",
    "usavtrump.com",
    "usawers.online",
    "usawisconsinnewyear.com",
    "usayoman.com",
    "usayummy.com",
    "usbeefcompany.com",
    "usbing.club",
    "uscaves.com",
    "uscemrounds.com",
    "uschalap.website",
    "uschroniclenews.com",
    "usdebate.com",
    "usdx.org",
    "usdy.org",
    "use.startmail.com",
    "useaipins.com",
    "useamerica.info",
    "useblgs.xyz",
    "useblog.xyz",
    "useblogs.xyz",
    "used-cars-uae.com",
    "used-product.fr",
    "usedcarsinqatar.com",
    "usedtoloves.com",
    "useful-page.club",
    "usefultipsforme.com",
    "useglmrlds.site",
    "useithtra.site",
    "usemail.xyz",
    "usenet.deals",
    "usenet.sale",
    "usenetmail.tk",
    "user.school",
    "userbeam.com",
    "usercoupon.com",
    "userfus.cf",
    "useriostligg-confirmed.com",
    "useriostligg-meet-backup.com",
    "useriostligg-meet.com",
    "usermail.com",
    "usermobinfonew.top",
    "usermobinfoupdate.com",
    "username.e4ward.com",
    "userology.com",
    "users.idbloc.co",
    "users.sourceforge.net",
    "users.totaldrama.net",
    "userseo.ga",
    "userwfargoupdate.com",
    "userwfnewdev.com",
    "userzap.com",
    "usf.biz",
    "usfai.xyz",
    "usfeu-nich.ru",
    "usharingk.com",
    "ushijima1129.cf",
    "ushijima1129.ga",
    "ushijima1129.gq",
    "ushijima1129.ml",
    "ushijima1129.tk",
    "ushortop.site",
    "ushwy287.com",
    "usiaj.com",
    "usingin.shop",
    "usit.net",
    "usitv.ga",
    "uslgwcxmk.shop",
    "uslove.xyz",
    "usma.net",
    "usmc.net",
    "usn-dlya-ipe.ru",
    "usn.pw",
    "usnacewf.site",
    "usnetads.online",
    "usoiv.com",
    "uspeakw.com",
    "uspermitservices.com",
    "usps9.com",
    "uspyparky.com",
    "usrrs.us",
    "ussolarpump.com",
    "ussv.club",
    "ustabbettsnupp2020.xyz",
    "ustabilbettingsnap.xyz",
    "ustabilbettsnapp.xyz",
    "ustabilitybettingsnapp.xyz",
    "ustayapisoke.xyz",
    "ustc.edu",
    "ustins.ru",
    "usurpator.ru",
    "uswestmail.net",
    "usywjsm.xyz",
    "uszrn.us",
    "ut432.com",
    "ut6rtiy1ajr.ga",
    "ut6rtiy1ajr.gq",
    "ut6rtiy1ajr.ml",
    "ut6rtiy1ajr.tk",
    "ut7pf.us",
    "ut990.com",
    "utacloud.com",
    "utahcann.org",
    "utahdispensaryassociation.org",
    "utahmicrosoft.com",
    "utahrockproducts.com",
    "utanet.at",
    "utangsss.online",
    "utc7xrlttynuhc.cf",
    "utc7xrlttynuhc.ga",
    "utc7xrlttynuhc.gq",
    "utc7xrlttynuhc.ml",
    "utc7xrlttynuhc.tk",
    "utcfxpbva.shop",
    "utclubsxu.com",
    "utcoiproc.cf",
    "utcoiproc.ga",
    "ute15.space",
    "utechcomp.ru",
    "utelzcpd.shop",
    "utgreto.org",
    "utgunlistings.com",
    "uthalfpricedlistings.com",
    "uthebettsnaps.xyz",
    "uthruthg.shop",
    "uthwellsnewuser.com",
    "utiket.us",
    "utilitcrgg.space",
    "utilities-online.info",
    "utilitiesshop.futbol",
    "utilitservis.ru",
    "utilized659gg.online",
    "utilqr.com",
    "utimatebuilder.com",
    "utimatesports.com",
    "utjuji.site",
    "utma.com",
    "utoken.fund",
    "utoledo.edu",
    "utoo.email",
    "utooemail.com",
    "utool.com",
    "utool.us",
    "utopiacosmetic.xyz",
    "utplexpotrabajos.com",
    "utsav-food.com",
    "utsupma.cf",
    "utsupma.ga",
    "utsupma.ml",
    "utsupma.tk",
    "utterloos.us",
    "utterrug.us",
    "utterse.email",
    "utthere.shop",
    "uttmkl.site",
    "uttoymdkyokix6b3.cf",
    "uttoymdkyokix6b3.ga",
    "uttoymdkyokix6b3.gq",
    "uttoymdkyokix6b3.ml",
    "uttoymdkyokix6b3.tk",
    "uttvgar633r.cf",
    "uttvgar633r.ga",
    "uttvgar633r.gq",
    "uttvgar633r.ml",
    "uttvgar633r.tk",
    "utubemp3.net",
    "utwevq886bwc.cf",
    "utwevq886bwc.ga",
    "utwevq886bwc.gq",
    "utwevq886bwc.ml",
    "utwevq886bwc.tk",
    "utxre1.site",
    "utyneypmn.shop",
    "uu.gl",
    "uu.net",
    "uu18269.com",
    "uu2.ovh",
    "uu34.space",
    "uu36.space",
    "uu38.space",
    "uu39.space",
    "uu41.space",
    "uu42.space",
    "uu486.com",
    "uu57822.com",
    "uu7wqv.ru",
    "uu9827.com",
    "uufan.xyz",
    "uuhhxk.us",
    "uuigjm.shop",
    "uujewellrys.site",
    "uujrh3886ffc.com",
    "uultraashop.space",
    "uuluu.net",
    "uuluu.org",
    "uurbeheer.online",
    "uurksjb7guo0.cf",
    "uurksjb7guo0.ga",
    "uurksjb7guo0.gq",
    "uurksjb7guo0.ml",
    "uurksjb7guo0.tk",
    "uuroalaldoadkgk058.cf",
    "uushoes.ru",
    "uuu062.com",
    "uuu813.com",
    "uv7v.com",
    "uv8w.com",
    "uvelichenie-grudi-kak.ru",
    "uvelichit-grud.ru",
    "uvidetsmotret.ru",
    "uvsgpctdl.shop",
    "uvsvalue.com",
    "uvy.kr",
    "uvyuviyopi.cf",
    "uvyuviyopi.ga",
    "uvyuviyopi.gq",
    "uvyuviyopi.ml",
    "uvyuviyopi.tk",
    "uw.edu",
    "uw5t6ds54.com",
    "uw88.info",
    "uw88.online",
    "uw88.org",
    "uwa7tq.info",
    "uwag.org",
    "uwalumni.com",
    "uwated.win",
    "uwciw.us",
    "uwdiscount.online",
    "uwebmail.live",
    "uwhouse.com",
    "uwhouse.net",
    "uwillsuc.pw",
    "uwin90.online",
    "uwington.icu",
    "uwjtid.shop",
    "uwn5.xyz",
    "uwonym.ga",
    "uwork4.us",
    "uwsp.edu",
    "uwtahw.site",
    "uwuefr.com",
    "uwwmog.com",
    "ux.dob.jp",
    "ux.uk.to",
    "uxcez1.site",
    "uxdes54.com",
    "uxqp2019.com",
    "uxqp2020.com",
    "uxs14gvxcmzu.cf",
    "uxs14gvxcmzu.ga",
    "uxs14gvxcmzu.gq",
    "uxs14gvxcmzu.ml",
    "uxs14gvxcmzu.tk",
    "uxtpht.us",
    "uxxx.fun",
    "uxyvyq.best",
    "uy77.xyz",
    "uydagdmzsc.cf",
    "uydagdmzsc.ga",
    "uydagdmzsc.gq",
    "uydagdmzsc.ml",
    "uydagdmzsc.tk",
    "uyfs58-mail.xyz",
    "uyhip.com",
    "uyinnerssa.space",
    "uyinnerssa7.space",
    "uyjo.com",
    "uymail.com",
    "uyp5qbqidg.cf",
    "uyp5qbqidg.ga",
    "uyp5qbqidg.gq",
    "uyp5qbqidg.ml",
    "uyp5qbqidg.tk",
    "uypcv.club",
    "uyu.kr",
    "uyuyuy.com",
    "uyv2d.us",
    "uywnfoymy.shop",
    "uywxa2.com",
    "uyx3rqgaghtlqe.cf",
    "uyx3rqgaghtlqe.ga",
    "uyx3rqgaghtlqe.gq",
    "uyx3rqgaghtlqe.ml",
    "uyx3rqgaghtlqe.tk",
    "uz6tgwk.com",
    "uzbekbazaar.com",
    "uzbet.com",
    "uzgrthjrfr4hdyy.gq",
    "uzhe.net",
    "uziblt.us",
    "uzmanlarteknik.xyz",
    "uzmanolsun.com",
    "uzmanyakala.com",
    "uzn5sw.info",
    "uzo-amsterdam.com",
    "uzrip.com",
    "uzu6ji.info",
    "uzundiz.best",
    "uzxia.cf",
    "uzxia.com",
    "uzxia.ga",
    "uzxia.gq",
    "uzxia.ml",
    "uzxia.tk",
    "v-a-v.de",
    "v-kirove.ru",
    "v-kuhne.ru",
    "v-kv.com",
    "v-mail.xyz",
    "v-on-honey.com",
    "v-pizdu.net",
    "v-pyti.ru",
    "v-rewards32.info",
    "v-rros.ru",
    "v-sexi.com",
    "v-wiz.com",
    "v-wiz.net",
    "v.0v.ro",
    "v.jsonp.ro",
    "v.northibm.com",
    "v.olvos90.tk",
    "v00qy9qx4hfmbbqf.cf",
    "v00qy9qx4hfmbbqf.ga",
    "v00qy9qx4hfmbbqf.gq",
    "v00qy9qx4hfmbbqf.ml",
    "v00qy9qx4hfmbbqf.tk",
    "v0domwwkbyzh1vkgz.cf",
    "v0domwwkbyzh1vkgz.ga",
    "v0domwwkbyzh1vkgz.gq",
    "v0domwwkbyzh1vkgz.ml",
    "v0domwwkbyzh1vkgz.tk",
    "v0p1gm.info",
    "v13.com",
    "v17001.com",
    "v1ael70wn6387fb.xyz",
    "v1bob.com",
    "v1vnks.us",
    "v21.me.uk",
    "v250.cf",
    "v250.ga",
    "v250.gq",
    "v250.ml",
    "v250.tk",
    "v27hb4zrfc.cf",
    "v27hb4zrfc.ga",
    "v27hb4zrfc.gq",
    "v27hb4zrfc.ml",
    "v27hb4zrfc.tk",
    "v2fly.xyz",
    "v2oekh.us",
    "v2poker.org",
    "v3bsb9rs4blktoj.cf",
    "v3bsb9rs4blktoj.ga",
    "v3bsb9rs4blktoj.gq",
    "v3bsb9rs4blktoj.ml",
    "v3bsb9rs4blktoj.tk",
    "v3gate.net",
    "v3lrsh.us",
    "v4gdm4ipndpsk.cf",
    "v4gdm4ipndpsk.ga",
    "v4gdm4ipndpsk.gq",
    "v4gdm4ipndpsk.ml",
    "v4gdm4ipndpsk.tk",
    "v4hgfjhgf.xyz",
    "v4p.ru",
    "v4uryn.site",
    "v58tk1r6kp2ft01.cf",
    "v58tk1r6kp2ft01.ga",
    "v58tk1r6kp2ft01.gq",
    "v58tk1r6kp2ft01.ml",
    "v58tk1r6kp2ft01.tk",
    "v5mec.us",
    "v5qnoc.online",
    "v5r6e.us",
    "v6hosting.com",
    "v6iexwlhb6n2hf.ga",
    "v6iexwlhb6n2hf.gq",
    "v6iexwlhb6n2hf.ml",
    "v6iexwlhb6n2hf.tk",
    "v6ready.xyz",
    "v6test.tokyo",
    "v6uk95.site",
    "v6v.dev",
    "v7ecub.com",
    "v7nk.us",
    "v8.vin",
    "v840xt.us",
    "v8email.com",
    "v8jumd.us",
    "v8man.com",
    "v8win.com",
    "v8ze.icu",
    "v9fxq.us",
    "v9paying.com",
    "v9pays.com",
    "va-medic1.site",
    "va5vsqerkpmsgibyk.cf",
    "va5vsqerkpmsgibyk.ga",
    "va5vsqerkpmsgibyk.gq",
    "va5vsqerkpmsgibyk.ml",
    "va5vsqerkpmsgibyk.tk",
    "vaasfc4.tk",
    "vaati.org",
    "vacancydom.ru",
    "vacation-voyage-now.sale",
    "vacationrental.zone",
    "vacationrentals.business",
    "vacationrentals.directory",
    "vacations.company",
    "vacationwithjason.com",
    "vacavaca.ru",
    "vacavillerentals.com",
    "vaccimnatlod.xyz",
    "vaccinepre.xyz",
    "vachwu.com",
    "vacuus.gq",
    "vacwdlenws604.ml",
    "vadable.xyz",
    "vadaway.icu",
    "vadelect.xyz",
    "vadlag.xyz",
    "vadosh.website",
    "vaefwm.us",
    "vaffanculo.gq",
    "vagenland.ga",
    "vagenland.gq",
    "vagifx.net",
    "vagilthe.ga",
    "vagilthe.gq",
    "vagilthe.ml",
    "vagiserum.com",
    "vagnerlove.ru",
    "vagrant.dev",
    "vagsuerokgxim1inh.cf",
    "vagsuerokgxim1inh.ga",
    "vagsuerokgxim1inh.gq",
    "vagsuerokgxim1inh.ml",
    "vagsuerokgxim1inh.tk",
    "vaguebuil.xyz",
    "vagueen.xyz",
    "vagueenfi.xyz",
    "vaguefa.icu",
    "vaguemodel.us",
    "vaguetast.xyz",
    "vahalfpricedlisting.com",
    "vahalfpricelisting.com",
    "vahallamarketing.net",
    "vahomeloansl1.com",
    "vahoo.com",
    "vahsc.us",
    "vaik.cf",
    "vaik.ga",
    "vaik.gq",
    "vaik.ml",
    "vaik.tk",
    "vailhealthjobs.com",
    "vailkilo.online",
    "vailsnowboardlessons.com",
    "vailuyen688.ga",
    "vaimumi.tk",
    "vainamail.club",
    "vairs.org",
    "vajdica.com",
    "vajeri.info",
    "vajobsri.cf",
    "vajobsri.ga",
    "vajobsri.gq",
    "vajobsri.ml",
    "vajobsri.tk",
    "vajq8t6aiul.cf",
    "vajq8t6aiul.ga",
    "vajq8t6aiul.gq",
    "vajq8t6aiul.ml",
    "vajq8t6aiul.tk",
    "vajra4d.com",
    "vakifarabam.com",
    "vaktarjobb.se",
    "valdisttul.gq",
    "valdisttul.ml",
    "valdisttul.tk",
    "valemail.net",
    "valenceinvestment.com",
    "valenciabackpackers.com",
    "valencianista.com",
    "valentinagrib.ru",
    "valentinka.host",
    "valentinobet2.online",
    "valentinostakeaway.com",
    "valentop.com",
    "valerabet.ru",
    "valeraverim.ru",
    "valerieallenpowell.com",
    "valhalladev.com",
    "valiantgaming.net",
    "valiantvineyards.net",
    "valiantvineyardswinery.com",
    "valibri.com",
    "valid.digital",
    "validsiegetech.info",
    "valimodert.ru",
    "valionkd.online",
    "vallate.xyz",
    "valledds.com",
    "valleybrains.tech",
    "valleyedit.com",
    "valleyhealthphysicians.net",
    "valleyhealthphysicians.org",
    "valleyinvestmentproperty.com",
    "valleyrust.top",
    "valleystudies.top",
    "valmosergraphics.com",
    "valorant-case.ru",
    "valorant-drop.ru",
    "valorant.codes",
    "valordinmuscle.com",
    "valudeal.net",
    "value-digital.net",
    "value-establish-point-stomach.xyz",
    "value-group.net",
    "valuebl.icu",
    "valued.guide",
    "valuemailers.com",
    "valveball.net",
    "valvebrush.biz",
    "valvebrush.net",
    "valvebrush.us",
    "valvebrushes.biz",
    "valvebrushes.us",
    "valyutniy-kontrol.ru",
    "vamosconfe.com",
    "vampiregirl.xyz",
    "vampirehunter.com",
    "vampresent.ru",
    "van87.com",
    "vanacken.xyz",
    "vanairlines.xyz",
    "vanbalen.icu",
    "vanbil.tk",
    "vanclifts.info",
    "vancouverhairsalons.com",
    "vancouverislandrealestatecareer.com",
    "vandstabmar.ml",
    "vanevans.xyz",
    "vanheusden.site",
    "vanhoangtn1.ga",
    "vanhoangtn1.ooo",
    "vanhoangtn1.us",
    "vaniercup52.com",
    "vankin.de",
    "vanlilardernegi.com",
    "vanneerbos.site",
    "vanpirly.com",
    "vanpoint.net",
    "vantagepayment.com",
    "vanturtransfer.com",
    "vanturtransfer.xyz",
    "vanvlachsen.com",
    "vanxardmedia.com",
    "vaparisy.info",
    "vapecentral.ru",
    "vapecpd.com",
    "vapetaxi.ru",
    "vapewildd.com",
    "vapordu.cf",
    "vapordu.ga",
    "vapordu.gq",
    "vapordu.ml",
    "vapordu.tk",
    "vaporizers776cv.online",
    "vaporware.xyz",
    "vappewild.com",
    "var-2.site",
    "varadeals.com",
    "varag88.com",
    "varantsigorta.com",
    "varbizmail.com",
    "vardanes.net",
    "vardanes.org",
    "varese-secure.com",
    "varietyecompartners.com",
    "varimlimon.com",
    "variouscraft.ru",
    "varmakir.cf",
    "varmakir.ga",
    "varmakir.gq",
    "varna.vip",
    "varnerllc.com",
    "varnishbrush.net",
    "varnishbrush.us",
    "varnishbrushes.net",
    "varout.com",
    "varushka.ru",
    "varyag51.ru",
    "varzish-1xbet.net",
    "vasashing.fun",
    "vasectomize375xh.online",
    "vash--mishka.ru",
    "vasir.site",
    "vasosrojosamericanos.com",
    "vasschlorin.cf",
    "vasschlorin.ga",
    "vasschlorin.gq",
    "vasschlorin.ml",
    "vast-03.com",
    "vastkey.com",
    "vastorestaurante.net",
    "vasvast.shop",
    "vasyna.space",
    "vaszerkolig.ru",
    "vaszily.com",
    "vatclinics.info",
    "vatrel.com",
    "vaughn.life",
    "vault.camp",
    "vaultautoparts.com",
    "vaultpoint.us",
    "vaultproject.dev",
    "vaultsophia.com",
    "vaultsophiaonline.com",
    "vaultvision.app",
    "vavacash.org",
    "vavadacazino.com",
    "vawamu.info",
    "vaxce.com",
    "vaxport.online",
    "vaxxport.online",
    "vay.kr",
    "vaybet38.com",
    "vb17100astridcoleman.info",
    "vb17101tesswalton.info",
    "vb4cte.us",
    "vb9vwd.us",
    "vba.kr",
    "vbalakovo.ru",
    "vbet.network",
    "vbetstar.com",
    "vbfaps.us",
    "vbha0moqoig.ga",
    "vbha0moqoig.ml",
    "vbha0moqoig.tk",
    "vbhoa.com",
    "vbilet.com",
    "vbkb050288.com",
    "vbo.buzz",
    "vbotanicalspa.com",
    "vbpqap.us",
    "vbshopper.com",
    "vbtsystem.site",
    "vbwarez.net",
    "vc58bo.info",
    "vc9.net",
    "vcamp.co",
    "vcbmail.ga",
    "vcbox.pro",
    "vcgciw.club",
    "vcgenk.com",
    "vcghv0eyf3fr.cf",
    "vcghv0eyf3fr.ga",
    "vcghv0eyf3fr.gq",
    "vcghv0eyf3fr.ml",
    "vcghv0eyf3fr.tk",
    "vchunger.games",
    "vcip5.us",
    "vcm.sk",
    "vcmail.com",
    "vcmatchmaker.com",
    "vcnbzvers.site",
    "vcplxm.us",
    "vctel.com",
    "vcticngsh5.ml",
    "vctlwl.info",
    "vcu26q-mail.xyz",
    "vcwql.us",
    "vcz.us",
    "vcznb.us",
    "vda.ro",
    "vdaily.biz",
    "vdaily.info",
    "vdaymyvg.shop",
    "vdbirxhg.shop",
    "vdcasino366.com",
    "vdcxnf.us",
    "vddhs90.online",
    "vdemegtic.shop",
    "vdggehha.xyz",
    "vdh.us",
    "vdi-ms.com",
    "vdieasy.com",
    "vdig.com",
    "vdims.com",
    "vdione.com",
    "vdlh0.us",
    "vdmmhozx5kxeh.cf",
    "vdmmhozx5kxeh.ga",
    "vdmmhozx5kxeh.gq",
    "vdmmhozx5kxeh.ml",
    "vdmmhozx5kxeh.tk",
    "vdobromzdravyy.ru",
    "vdomemilo.ru",
    "vdsound.ru",
    "vdxm.com",
    "vdzbot.xyz",
    "ve-101.com",
    "ve-v5.com",
    "ve1droid.host",
    "ve1f.net",
    "ve1g.net",
    "ve1i.net",
    "ve1n.net",
    "ve1u.net",
    "ve1x.net",
    "ve8zum01pfgqvm.cf",
    "ve8zum01pfgqvm.ga",
    "ve8zum01pfgqvm.gq",
    "ve8zum01pfgqvm.ml",
    "ve8zum01pfgqvm.tk",
    "ve9xvwsmhks8wxpqst.cf",
    "ve9xvwsmhks8wxpqst.ga",
    "ve9xvwsmhks8wxpqst.gq",
    "ve9xvwsmhks8wxpqst.ml",
    "ve9xvwsmhks8wxpqst.tk",
    "vealtex.online",
    "veanlo.com",
    "veat.ch",
    "vebilewu.space",
    "veboieye.space",
    "veckopengen.nu",
    "veco.site",
    "vecom.ltd",
    "vect.org",
    "vector-rzn.ru",
    "vedalholding.com",
    "vedic.site",
    "vedmail.com",
    "vedojy.online",
    "vedrolet.ru",
    "veduco.xyz",
    "vedula.com",
    "vedv.de",
    "veebee.cf",
    "veebee.ga",
    "veebee.gq",
    "veebee.ml",
    "veebee.tk",
    "veee113.vip",
    "veepex.com",
    "veertjku.tk",
    "veesms.com",
    "veevacertification.com",
    "vefdrq.us",
    "vefspchlzs2qblgoodf.ga",
    "vefspchlzs2qblgoodf.ml",
    "vefspchlzs2qblgoodf.tk",
    "vega100mgtr.com",
    "vegabet137.com",
    "vegan-in-frankenthal.info",
    "veganbargains.com",
    "veganlifecoach.net",
    "veganlogical.xyz",
    "vegas-skills.com",
    "vegas-x.app",
    "vegas-x.biz",
    "vegas368e.net",
    "vegascasino.casino",
    "vegaslim-official.online",
    "vegaslimshop.online",
    "vegasrealestate.company",
    "vegastour.pro",
    "vegemail.com",
    "veggdekorasjon.site",
    "veggiephiles.com",
    "vegly.app",
    "vegly.network",
    "vehicle-blackbox-dvr.ru",
    "vehiclestorageyubacity.com",
    "vehinho.xyz",
    "vehkud.us",
    "veholdy.cf",
    "veholdy.ga",
    "veholdy.tk",
    "veibelda.ga",
    "veibelda.gq",
    "veibelda.ml",
    "veibelda.tk",
    "vein-com.ru",
    "veinaha.ga",
    "veinaha.gq",
    "veinaha.ml",
    "veinaha.tk",
    "veiudo.tech",
    "vejaalagoas.com",
    "vejohy.info",
    "vekavu.info",
    "vektik.com",
    "vektor-shop.ru",
    "velar.cloud",
    "velar.site",
    "velarhost.com",
    "velasdo.ml",
    "velasdo.tk",
    "velavadar.com",
    "velbettdomino.com",
    "veldmail.ga",
    "velikos.host",
    "velkam.org",
    "velkanol.ru",
    "velnet.co.uk",
    "velnet.com",
    "velobotanicals.com",
    "velobro.space",
    "velocall.com",
    "velocilight.com",
    "velocities.space",
    "velocity-digital.com",
    "velocitydigital.net",
    "velomandryvo.xyz",
    "veloped.us",
    "velosegway.ru",
    "velosiped-go.ru",
    "velostocrat.com",
    "veloxmail.com.br",
    "velvetaroma.com",
    "velvetshopping.net",
    "veminia.com",
    "vemmaelijahcarter.site",
    "vemomail.win",
    "vemple.info",
    "vemrecik.com",
    "vemser.com",
    "ven8mf.com",
    "venagoo.website",
    "venanation.info",
    "vendasml.ml",
    "vendedores-premium.ml",
    "vendedoresplatinum.ml",
    "vendx.us",
    "veneersofficial.ru",
    "veneersperfectsmile.ru",
    "venesialottery.info",
    "venesialottery.net",
    "venesialottery.org",
    "venged.com",
    "vengodwin.store",
    "venicedays.info",
    "venka.host",
    "venmirack.cf",
    "venmirack.gq",
    "venok-mir.ru",
    "venompen.com",
    "venomteam.ru",
    "venosy.site",
    "vent-krasnodar.ru",
    "ventamark.net",
    "ventanasvegas.com",
    "ventastx.net",
    "ventesflash75.com",
    "ventgelteo.cf",
    "ventgelteo.ga",
    "ventgelteo.gq",
    "ventgelteo.ml",
    "ventgelteo.tk",
    "venttanip.cf",
    "venttanip.tk",
    "venturawaterwell.com",
    "venuedot.com",
    "venuscicekcilik.xyz",
    "venuselbow.recipes",
    "venusen.press",
    "venusgmv.net",
    "venusocks.ru",
    "venusstri.com",
    "venweld.site",
    "veo.kr",
    "veomideg.cf",
    "veomideg.ga",
    "veomideg.gq",
    "veperon.net",
    "ver0.cf",
    "ver0.ga",
    "ver0.gq",
    "ver0.ml",
    "ver0.tk",
    "veraandaudrey.com",
    "verajenkins.xyz",
    "veralucia.top",
    "verarays.info",
    "veratoiun.ga",
    "verbee.ru",
    "verboseguides.com",
    "vercameab.cf",
    "vercameab.gq",
    "vercameab.ml",
    "vercameab.tk",
    "vercelli.cf",
    "vercelli.ga",
    "vercelli.gq",
    "vercelli.ml",
    "verconspat.cf",
    "verconspat.ml",
    "verconspat.tk",
    "vercutemp.cf",
    "verdejo.com",
    "verdoto.cf",
    "verdoto.ml",
    "verenoxnetwork.online",
    "vergiora.ga",
    "vergiora.gq",
    "vergiora.ml",
    "verhonicaryan.com",
    "verificadas.tk",
    "verified-real.net",
    "verified.vote",
    "verifiedbuyerscheme.com",
    "verifiedbuyerscheme.org",
    "verifykero.com",
    "verifymail.cf",
    "verifymail.ga",
    "verifymail.gq",
    "verifymail.ml",
    "verifymail.win",
    "veriguvenlik.com",
    "veriifmail.com",
    "verinic.net",
    "verisign.cf",
    "verisign.ga",
    "verisign.gq",
    "verissl.com",
    "veriyaz.com",
    "veriyaz.net",
    "verizon.com",
    "verizon.net",
    "verizondw.com",
    "verizonmail.com",
    "verizonwireless.com",
    "verkaufsstelle24.de",
    "verlass-mich-nicht.de",
    "verlo.casa",
    "verlustfic.cf",
    "verlustfic.gq",
    "verlustfic.ml",
    "vermagerentips24.xyz",
    "vermontamazon.com",
    "vermontcareers.com",
    "vermontlaw.edu",
    "vermontlinkedin.com",
    "vermutlich.net",
    "verni-svoel.fun",
    "vernichel.host",
    "verniinternational.icu",
    "vernipay.ru",
    "verniplanet.icu",
    "vernisystem.icu",
    "vernivychet.ru",
    "vernz.cf",
    "vernz.ga",
    "vernz.gq",
    "vernz.ml",
    "vernz.tk",
    "veroikasd.ml",
    "veronateam.ru",
    "veronisy.com",
    "veropopshop.com",
    "verossa-rp.ru",
    "verozo.info",
    "verprerock.ga",
    "verprerock.gq",
    "verprerock.ml",
    "verrando.net",
    "verrighde.cf",
    "verrighde.ga",
    "verrighde.ml",
    "verrighde.tk",
    "versatel.nl",
    "versaupe.cf",
    "versaupe.ga",
    "versaupe.ml",
    "versaupe.tk",
    "verseboard.com",
    "versmesi.ga",
    "verstanttran.cf",
    "verstanttran.ga",
    "verstanttran.gq",
    "versteabags.gq",
    "versteabags.ml",
    "versteabags.tk",
    "versuplitt.site",
    "versusbooks.com",
    "vertamo.cf",
    "vertamo.ga",
    "vertamo.gq",
    "vertamo.ml",
    "verticalheaven.com",
    "verticalscope.com",
    "verticedecabo.com",
    "vertigo.cd",
    "vertigueiros.website",
    "vertikali.site",
    "vertraut.love",
    "vertraute.love",
    "verweisnip.cf",
    "verweisnip.gq",
    "verweisnip.ml",
    "very-cheap-car-insurance.online",
    "very.vn",
    "verybig.co.uk",
    "verycheapcarinsurance.online",
    "veryday.ch",
    "veryday.eu",
    "veryday.info",
    "veryfast.biz",
    "veryprice.co",
    "veryrealemail.com",
    "veryrealmail.com",
    "veryspeedy.net",
    "verytrendyshop.com",
    "verywild.co.uk",
    "vesa.pw",
    "vesiquvece.website",
    "vespor.biz",
    "vespor.info",
    "vespor.net",
    "vespor.online",
    "vespor.org",
    "vespor.xyz",
    "vesteddjrr.space",
    "vestergaard.dk",
    "vestgreensig.tk",
    "vestimed.ru",
    "vestnikao.ru",
    "vestniktm.ru",
    "vestrelis.ga",
    "vestrelis.ml",
    "vestrelis.tk",
    "vestrilga.cf",
    "vestrilga.ml",
    "vet-impact.ong",
    "vetaucanthocondao.com",
    "vetechpayments.com",
    "vetementuss.com",
    "veteransbenefitsinc.icu",
    "veterinarnaya-kurkino11.ru",
    "veterinaryproviders.org",
    "vetklinikadmitrov.ru",
    "vetlinkos.ru",
    "vetofunhes.art",
    "vetonound.site",
    "vetriangle.eu",
    "vets-victories-dreams.net",
    "vetsvictoriesdreams.net",
    "vettelfans.co.uk",
    "vettery.cf",
    "vettery.gq",
    "vettery.ml",
    "vettery.tk",
    "vety.site",
    "veuduchalk.gq",
    "veuduchalk.ml",
    "vevpqk.host",
    "vewku.com",
    "vewovegady.space",
    "vexbug.us",
    "vexotrol.com",
    "veycanle.cf",
    "veycanle.ga",
    "veycanle.gq",
    "veycanle.tk",
    "veyschoolsubt.cf",
    "veyschoolsubt.gq",
    "veyschoolsubt.ml",
    "veyschoolsubt.tk",
    "vezdehod-rent.ru",
    "vfbpdh.site",
    "vfdvuo.us",
    "vfemail.net",
    "vffelbqst.shop",
    "vfienvtua2dlahfi7.cf",
    "vfienvtua2dlahfi7.ga",
    "vfienvtua2dlahfi7.gq",
    "vfienvtua2dlahfi7.ml",
    "vfienvtua2dlahfi7.tk",
    "vfile.org",
    "vfj9g3vcnj7kadtty.cf",
    "vfj9g3vcnj7kadtty.ga",
    "vfj9g3vcnj7kadtty.gq",
    "vfj9g3vcnj7kadtty.ml",
    "vfj9g3vcnj7kadtty.tk",
    "vfnvls.site",
    "vfpkta.site",
    "vfr3tz.site",
    "vfru80.info",
    "vgamers.win",
    "vgb758.com",
    "vgdbankrotstvo.ru",
    "vge88.com",
    "vgfhfghfghfgh.tech",
    "vgfxks.online",
    "vglasses.com",
    "vglobalnews.asia",
    "vgmlnw.com",
    "vgo-roulette.com",
    "vgo-roulette.net",
    "vgo-roulette.ru",
    "vgoldmailer2.com",
    "vgqgzqwg.shop",
    "vgryhm.site",
    "vgs33.com",
    "vgsbet.com",
    "vgsreqqr564.cf",
    "vgsreqqr564.ga",
    "vgsreqqr564.gq",
    "vgsreqqr564.ml",
    "vgsreqqr564.tk",
    "vhak.org",
    "vhan.tech",
    "vhcoqj.us",
    "vhglvi6o.com",
    "vhmmanbetx.com",
    "vhntp15yadrtz0.cf",
    "vhntp15yadrtz0.ga",
    "vhntp15yadrtz0.gq",
    "vhntp15yadrtz0.ml",
    "vhntp15yadrtz0.tk",
    "vhobbi.ru",
    "vhpsc.us",
    "vhw5ie.us",
    "vhwiz8.us",
    "vhwuph.rest",
    "via.tokyo.jp",
    "viableshoppingblog.club",
    "viadodinheiro.com",
    "viaferrata.net",
    "viagra-be.info",
    "viagra34.xyz",
    "viagra88.shop",
    "viagrafoxcer.xyz",
    "viagrakaufen.com",
    "viagranrxbuyonlinerx.com",
    "viagraya.com",
    "viajesatope.online",
    "viamobile.app",
    "viarasno.cf",
    "viarasno.ga",
    "viarasno.ml",
    "viarasno.tk",
    "viasatelital.us",
    "viascales.cf",
    "viascales.gq",
    "viascales.ml",
    "viascales.tk",
    "viata.site",
    "viata.space",
    "viataestefrumoasa.site",
    "vibejsk.host",
    "viberi-tur.ru",
    "vibhavram.com",
    "vibi.cf",
    "vibi4f1pc2xjk.cf",
    "vibi4f1pc2xjk.ga",
    "vibi4f1pc2xjk.gq",
    "vibi4f1pc2xjk.ml",
    "vibi4f1pc2xjk.tk",
    "viblab.today",
    "vibrantfaithmilestones.org",
    "vibronic.site",
    "vibupis.cf",
    "vibupis.ga",
    "vibupis.gq",
    "vibupis.ml",
    "vibupis.tk",
    "vic-allen.com",
    "vicdanhukuku.com",
    "vicdanhukuku.xyz",
    "vicfoban.cf",
    "vicfoban.ga",
    "vicfoban.ml",
    "vicfoban.tk",
    "vicious.email",
    "vicious.life",
    "vickaentb.cf",
    "vickaentb.ga",
    "vickaentb.gq",
    "vickaentb.ml",
    "vickaentb.tk",
    "vickeyhouse.com",
    "vicloning.net",
    "victime.ninja",
    "victimization206na.online",
    "victor1.club",
    "victorgabrielg.com",
    "victoriagreen.mobi",
    "victoriahousetakeaway.com",
    "victoriaking55places.com",
    "victoriantwins.com",
    "victoriarcail.com",
    "victoriasslots.com",
    "victoriousrestoration.com",
    "victorserge.ru",
    "victory-mag.ru",
    "victoryboats.ru",
    "victoryfarmsuganda.com",
    "victorypointgames.org",
    "victoryseminary.net",
    "vidaneh.org",
    "vidasole.com",
    "vidchart.com",
    "viddly.online",
    "viddly.plus",
    "viddly.site",
    "viddsy.net",
    "video-dlj-tebya.ru",
    "video-klass.ru",
    "video-step.ru",
    "video.dk",
    "video4less.net",
    "videoarenda.ru",
    "videobest-for-you.ru",
    "videochat.band",
    "videochat.exposed",
    "videochat.watch",
    "videochat.wtf",
    "videocht.com",
    "videocorporation.ru",
    "videodig.tk",
    "videodr.us",
    "videoeditors.org",
    "videofilling.ru",
    "videogo49.com",
    "videographer.agency",
    "videographer.city",
    "videographer.education",
    "videographer.equipment",
    "videographer.expert",
    "videographer.global",
    "videographer.group",
    "videographer.legal",
    "videographer.link",
    "videographer.llc",
    "videographer.ltd",
    "videographer.productions",
    "videographer.review",
    "videographer.reviews",
    "videographer.school",
    "videographer.store",
    "videographer.stream",
    "videographer.studio",
    "videographer.style",
    "videographer.university",
    "videographers.boutique",
    "videographers.city",
    "videographers.college",
    "videographers.community",
    "videographers.company",
    "videographers.exchange",
    "videographers.fan",
    "videographers.global",
    "videographers.guide",
    "videographers.guru",
    "videographers.legal",
    "videographers.llc",
    "videographers.ltd",
    "videographers.page",
    "videographers.productions",
    "videographers.tips",
    "videographers.website",
    "videography.camera",
    "videography.city",
    "videography.click",
    "videography.college",
    "videography.community",
    "videography.education",
    "videography.equipment",
    "videography.events",
    "videography.foundation",
    "videography.gallery",
    "videography.global",
    "videography.help",
    "videography.productions",
    "videography.review",
    "videography.reviews",
    "videography.site",
    "videography.us",
    "videohandle.com",
    "videohandles.com",
    "videohd-clip.ru",
    "videohd-club.ru",
    "videohdtv.site",
    "videohdtv.tk",
    "videojunke2018.com",
    "videojurnal.ru",
    "videokazdyideni.ru",
    "videolovelock.net",
    "videonyanya.site",
    "videoonlinecasino.tech",
    "videoprosmotr.ru",
    "videorealm.net",
    "videored.site",
    "videoregistrator-rus.space",
    "videos-de-chasse.com",
    "videossl.stream",
    "videosx.blog",
    "videotoob.ru",
    "videotron.ca",
    "videotubegames.ru",
    "videowap.site",
    "videoxnxx.site",
    "videoxred.site",
    "vidhosters.org",
    "vidiboutique.site",
    "viditag.com",
    "vidltpvm.shop",
    "vidnoe-beton-zavod.ru",
    "vidoc.ru",
    "vidred.cf",
    "vidred.ga",
    "vidred.gq",
    "vidred.ml",
    "vidred.tk",
    "vidspot.xyz",
    "vidup.us",
    "vidvila.icu",
    "vidxnxx.site",
    "vidxxx.fun",
    "vidyo.site",
    "vidywi.info",
    "vieebee.cf",
    "vieebee.ga",
    "vieebee.gq",
    "vieebee.tk",
    "viehelpfolk.ga",
    "viehelpfolk.gq",
    "viehelpfolk.ml",
    "vielove.com",
    "vienna.cf",
    "vientianebackpackershostel.com",
    "vientianecarrental.net",
    "vientianehostel.com",
    "vieremat.cf",
    "viergroup.ru",
    "vieserli.cf",
    "vieserli.ga",
    "vieserli.gq",
    "vieserli.tk",
    "vietcafe.net",
    "vietnam-travel-tours.info",
    "vietnamsflorist.net",
    "vietnamsgift.net",
    "vietnamtour360.com",
    "vietnamtoursnews.com",
    "vietnamtoursnews.net",
    "vietnamvisas.net",
    "vietpay.org",
    "vietuctour.com",
    "vievibrant.com",
    "viewcastmedia.com",
    "viewcastmedia.net",
    "viewcastmedia.org",
    "viewinglifedictionary.com",
    "viewleaders.com",
    "viewpay.club",
    "viewsitedesign.com",
    "viewworlds.com",
    "vifes.se",
    "viflix.site",
    "vigee.com",
    "viggomobil.se",
    "vigilantkeep.net",
    "vigorhealth.ru",
    "vigorstratagem-intellectualwisdomwisdominsider.com",
    "vihost.ml",
    "vihost.tk",
    "vihxan.us",
    "viinnovation.com",
    "viitorultau.club",
    "viivaofficial.com",
    "vijoto.info",
    "vikaslin-ruraten.ru",
    "vikfocye.shop",
    "vikikredit.ru",
    "vikingpuresolutions.com",
    "vikingsilkroad.xyz",
    "vikingsonly.com",
    "vikram-rao.com",
    "viktorgladchenko.ru",
    "viktorina-2018.ru",
    "viktorkedrovskiy.ru",
    "vikylov.ru",
    "vikyol.com",
    "vil7xp.us",
    "vilbarcpil.ga",
    "vilbarcpil.gq",
    "vilbarcpil.tk",
    "vile.ninja",
    "vileblakkey.africa",
    "villa-aina.com",
    "villa-in-altea.site",
    "villabhj.com",
    "villagecrestrehab.net",
    "villagesoffairlakes.org",
    "villagethemeparks.com",
    "villageville.org",
    "villascondosamerica.com",
    "villascondoseurope.com",
    "villascondosusa.com",
    "villastream.xyz",
    "villatriestevegas.com",
    "villekulla.email",
    "villemolaque.info",
    "vilnapresa.com",
    "vilrata.cf",
    "vilrata.ga",
    "vilrata.gq",
    "vilrata.tk",
    "viltioni.cf",
    "viltioni.ga",
    "viltioni.tk",
    "vilvefa.ga",
    "vilvefa.ml",
    "vilvefa.tk",
    "vimail24.com",
    "vimailpro.net",
    "vimi-kan.ru",
    "vimmeter.com",
    "vin-diesel.com",
    "vinaclicks.com",
    "vinas.host",
    "vinbazar.com",
    "vincenoffc.com",
    "vincentcreations.com",
    "vincentjoness.com",
    "vincentlegall.org",
    "vincenza1818.site",
    "vincenzosdrimnagh.com",
    "vincilamusica.shop",
    "vincitop.com",
    "vinclub.win",
    "vincode24.ru",
    "vinde.ru",
    "vinder-life.ru",
    "vineal.xyz",
    "vinedali.site",
    "vinernet.com",
    "vinetack.com",
    "vineyardclinic.org",
    "vineyardmetronorth.org",
    "vingcesscar.cf",
    "vingcesscar.ga",
    "vingcesscar.gq",
    "vingcesscar.ml",
    "vingcesscar.tk",
    "vingdera.cf",
    "vingdera.ga",
    "vingdera.ml",
    "vingnammigh.cf",
    "vingnammigh.ga",
    "vingnammigh.tk",
    "vinicolatresraices.com",
    "vinnow.info",
    "vino-sf.com",
    "vino-veritas.ru",
    "vino.ma",
    "vinogradcentr.com",
    "vinohrad.info",
    "vinordknkz.ru",
    "vinshipper.com",
    "vinsmoke.tech",
    "vinsshoptop.club",
    "vintage-interior.ru",
    "vintagecardiff.com",
    "vintagecurrent.net",
    "vintagefashion.de",
    "vintageranchwedding.com",
    "vintageshop.store",
    "vintagetrailer.info",
    "vintange.com",
    "vinted.org",
    "vintee.club",
    "vinviper.dev",
    "vinviper.info",
    "vinviper.org",
    "vinyljudge.com",
    "viocrypot.cf",
    "viocrypot.ga",
    "viocrypot.ml",
    "viola.gq",
    "violinmakers.co.uk",
    "viotypog.gq",
    "viotypog.tk",
    "viouratel.ga",
    "viouratel.gq",
    "viouratel.tk",
    "viovideo.com",
    "viox.app",
    "vip-aiptv.xyz",
    "vip-asbet.site",
    "vip-avtos.ru",
    "vip-bal.ru",
    "vip-clicker.ru",
    "vip-food.biz",
    "vip-lovemagic.ru",
    "vip-mail.ml",
    "vip-mail.tk",
    "vip-smule.info",
    "vip-timeclub.ru",
    "vip.126.com",
    "vip.163.com",
    "vip.188.com",
    "vip.21cn.com",
    "vip.aiot.eu.org",
    "vip.boxmaill.com",
    "vip.citiz.net",
    "vip.cool",
    "vip.dmtc.press",
    "vip.gr",
    "vip.hstu.eu.org",
    "vip.onet.pl",
    "vip.qq.com",
    "vip.sina.com",
    "vip.sohu.com",
    "vip.sohu.net",
    "vip.stu.office.gy",
    "vip.tom.com",
    "vip52.online",
    "vip52.pro",
    "vip5319.com",
    "vip6372.com",
    "vip9227.com",
    "vip9stn.xyz",
    "vipattendance.com",
    "vipbd4.info",
    "vipbet5.biz",
    "vipclub.icu",
    "vipconverter.org",
    "vipdewapoker.com",
    "vipdieta.info",
    "vipdom-agoy.com",
    "vipelin.site",
    "vipenglishlearning.com",
    "vipepe.com",
    "vipflix.xyz",
    "vipgamemarket.ru",
    "viphone.eu.org",
    "viphop.ru",
    "vipilitka.buzz",
    "vipjis.top",
    "viplasvegasparty.com",
    "viplinz.ru",
    "viplotto.net",
    "viplovemagic.ru",
    "vipmagi.ru",
    "vipmail.hu",
    "vipmail.name",
    "vipmail.pw",
    "vipmail.ru",
    "vipmgm10.com",
    "vipmp3.site",
    "vippark29.com",
    "vippark31.com",
    "vippark37.com",
    "vippark40.com",
    "vippoker88.info",
    "vippoker88.online",
    "vippoker88.org",
    "vipsale2015online.com",
    "vipsentence.ru",
    "vipshkatulki.ru",
    "vipsohu.net",
    "viptoto.info",
    "viptupperware.ru",
    "vipvolvos.info",
    "vipweinisiren.com",
    "vipxm.net",
    "viracochastore.xyz",
    "viraginous.xyz",
    "viral-hub.xyz",
    "viral-science.fun",
    "viral-update.xyz",
    "viralclothes.com",
    "viralhits.org",
    "virallifestyles.com",
    "viralplays.com",
    "viraltoken.co",
    "viransehirlimited.xyz",
    "viransehirtv.com",
    "viraorg.com",
    "virarowing.com",
    "virasailingrowing.com",
    "viraskibreak.com",
    "vircaiget.cf",
    "vircaiget.ml",
    "virdettype.xyz",
    "vireopartners.com",
    "virgilbunaophotography.com",
    "virgilio.ga",
    "virgilio.gq",
    "virgilio.it",
    "virgilio.ml",
    "virgiliomail.cf",
    "virgiliomail.ga",
    "virgiliomail.gq",
    "virgiliomail.ml",
    "virgiliomail.tk",
    "virgin-eg.com",
    "virgin.net",
    "virginal.site",
    "virginbroadband.com.au",
    "virginfavorableanalysis.website",
    "virginia.edu",
    "virginiabasketballassociation.com",
    "virginiabeachnailsalons.com",
    "virginiabeachopiaterehab.com",
    "virginiaintel.com",
    "virginislandcharteryachts.com",
    "virginmedia.co.uk",
    "virginmedia.com",
    "virginshuttle.com",
    "virginsrus.xyz",
    "virgoans.co.uk",
    "virgos.co.uk",
    "virgotv.com",
    "virkbhandari.com",
    "virol.club",
    "viroleni.cu.cc",
    "virtania.site",
    "virtize.com",
    "virtual-agent.org",
    "virtual-bank.live",
    "virtual-email.com",
    "virtual-generations.com",
    "virtual-mail.com",
    "virtual-mail.net",
    "virtualactive.com",
    "virtualemail.info",
    "virtualguam.com",
    "virtualjunkie.com",
    "virtualmail.com",
    "virtualmail.gq",
    "virtualprivateserversindia.com",
    "virtualrunninguk.com",
    "virtualserver.pro",
    "virtualtrainingprograms.com",
    "virtualveggiepatch.com",
    "virtualxxxteens.site",
    "virtuatest.com",
    "virtuosoy.xyz",
    "virtuswin.com",
    "virtznakomstva.ru",
    "viruscan.ru",
    "virushelp.site",
    "virusonlya.space",
    "virusremovallosangeles.com",
    "virusremovalseattle.com",
    "virusuneet.site",
    "visa-pl.com",
    "visa-securepay.cf",
    "visa-securepay.ga",
    "visa-securepay.gq",
    "visa-securepay.ml",
    "visa-securepay.tk",
    "visa.coms.hk",
    "visa.dns-cloud.net",
    "visa.dnsabr.com",
    "visa159.ru",
    "visaabudhabi.com",
    "visal007.tk",
    "visal168.cf",
    "visal168.ga",
    "visal168.gq",
    "visal168.ml",
    "visal168.tk",
    "visantia.ru",
    "viscidkluu.space",
    "visconte.store",
    "viseur.xyz",
    "visiems.info",
    "visiokatu.xyz",
    "visionariesglobal.com",
    "visit-twin-peaks.com",
    "visit24.ru",
    "visitaislamujeres.com",
    "visitcassi.com",
    "visitfindhorn.com",
    "visitguernsey.org",
    "visitingob.com",
    "visitmail.com",
    "visitnycdeals.com",
    "visitor99.info",
    "visitors-tracker.ru",
    "visitvlore.com",
    "visitweb.com",
    "visitworldheritage.org",
    "vismecpazarlama.com",
    "vismos-news.ru",
    "visozial-backup.org",
    "vispif.com",
    "vist.video",
    "vistadulcevegas.com",
    "vistanavegas.com",
    "vistm.ru",
    "visto.com",
    "vistomail.com",
    "vistore.co",
    "visualarguments.com",
    "visualcities.com",
    "visualcluster.com",
    "visualkonzept.de",
    "visualpro.online",
    "visuellewelt.xyz",
    "visuvu.com",
    "visweden.com",
    "vit-toy.site",
    "vita-healthcare.com",
    "vitaelix.dev",
    "vitaj.org",
    "vital-medizin.info",
    "vitalavita24.ru",
    "vitalbeginning.com",
    "vitaldevelopmentsolutions.com",
    "vitaldrama.xyz",
    "vitaliebblkuet.fun",
    "vitaliemoscow.fun",
    "vitaliemoscow.space",
    "vitalitygang.com",
    "vitalizebaby.com",
    "vitalizebeauty.com",
    "vitalizedelhi.com",
    "vitalizedia.com",
    "vitalizehairgummy.com",
    "vitalizehairmen.com",
    "vitalizehairvitamins.com",
    "vitalizeindian.com",
    "vitalizemen.com",
    "vitalizeskinforwomen.com",
    "vitalizewomen.com",
    "vitalpetprovisions.com",
    "vitalslab.org",
    "vitaminb12direct.org",
    "vitaminglossary.com",
    "vitaminpassion.com",
    "vitaminshope.org",
    "vitaminydlyadushi.ru",
    "vitamixcostco.us",
    "vitapersonal.com",
    "vitapure.org",
    "vitarosehealthoffers.site",
    "vitedomain.com",
    "vithub.net",
    "vitiferous.site",
    "vitobet11.com",
    "vitrina82.ru",
    "vitstratumfho.site",
    "vittig.dk",
    "vityarustov.com",
    "vivabem.xyz",
    "vivabet91.online",
    "vivabets90.info",
    "vivafranco.tk",
    "vivalafiestapuertosherry.com",
    "vivaldi.media",
    "vivaldi.net",
    "vivamogul.org",
    "vivarack.com",
    "vivaroaffiliates.com",
    "vivavelocity.com",
    "viventel.com",
    "viverdemonetizze.com",
    "viverointernacional.com",
    "viversemdrama.com",
    "vivianhsu.net",
    "vivigle.org",
    "vivliopoli.xyz",
    "vivo4d.online",
    "vivocrop.ru",
    "vivogame11.net",
    "vivogame168.com",
    "vivogame33.net",
    "vivogame55.com",
    "vivolight.ru",
    "vivopelafe.com",
    "vivrela.store",
    "vivshine.com",
    "vivusbet60.com",
    "viwanet.ru",
    "viwsala.com",
    "vixiohosting.shop",
    "vixletdev.com",
    "vixodkyh.shop",
    "vizedf.site",
    "vizit-fabric.xyz",
    "vizyondafilm.info",
    "vizzapizzeria.com",
    "vjav.info",
    "vjav.site",
    "vjmail.com",
    "vjogpb.cf",
    "vjr.luk2.com",
    "vjrkvx.site",
    "vjsbdp.com",
    "vjtimail.com",
    "vjvqdl.us",
    "vjwwgppcf.shop",
    "vk-com-golosa.site",
    "vk-comm.ru",
    "vk-id5099994-loh.xyz",
    "vk-skachat.ru",
    "vk-ssl-support5.host",
    "vkchat.ru",
    "vkcode.ru",
    "vkfwzulon.shop",
    "vkgdno.us",
    "vkhelp-com.online",
    "vkhotkevich.ru",
    "vkinomax.ru",
    "vkitgm.com",
    "vkjncf.com",
    "vknmanbetx.com",
    "vknumber.website",
    "vkopssite.site",
    "vksaver-pc.ru",
    "vkusnosam.ru",
    "vkusnyj-recept-foto.ru",
    "vkusup.ru",
    "vkvhod.ru",
    "vkzbfuvrx.shop",
    "vl-pla.ru",
    "vl2ivlyuzopeawoepx.cf",
    "vl2ivlyuzopeawoepx.ga",
    "vl2ivlyuzopeawoepx.gq",
    "vl2ivlyuzopeawoepx.ml",
    "vl2ivlyuzopeawoepx.tk",
    "vlad-webdevelopment.ru",
    "vladinews.space",
    "vladomusic.com",
    "vlan.global",
    "vlbjx6.info",
    "vlcity.ru",
    "vlfbvia.design",
    "vlifeinsure.com",
    "vlinder.icu",
    "vlinitial.com",
    "vlipbttm9p37te.cf",
    "vlipbttm9p37te.ga",
    "vlipbttm9p37te.gq",
    "vlipbttm9p37te.ml",
    "vlipbttm9p37te.tk",
    "vlivki.ru",
    "vlk-gold.org",
    "vlk-neon-online.com",
    "vlk-pltnm.ru",
    "vlk-prestige.net",
    "vlkstil-6.com",
    "vlkstil-7.com",
    "vlkstl-3.com",
    "vlmail.com",
    "vln.io",
    "vloggerusa.com",
    "vlogino.pro",
    "vloux.com",
    "vlquark.com",
    "vlrnt.com",
    "vlsca8nrtwpcmp2fe.cf",
    "vlsca8nrtwpcmp2fe.ga",
    "vlsca8nrtwpcmp2fe.gq",
    "vlsca8nrtwpcmp2fe.ml",
    "vlsca8nrtwpcmp2fe.tk",
    "vlstwoclbfqip.cf",
    "vlstwoclbfqip.ga",
    "vlstwoclbfqip.gq",
    "vlstwoclbfqip.ml",
    "vlstwoclbfqip.tk",
    "vlvstech.com",
    "vlvtsmtx.com",
    "vlvwine.com",
    "vlzpji.com",
    "vm009.com",
    "vm088.com",
    "vm2016.com",
    "vmadhavan.com",
    "vmail.co.il",
    "vmail.me",
    "vmail.tech",
    "vmailcloud.com",
    "vmailing.info",
    "vmailpro.net",
    "vmani.com",
    "vmaryus.iogmail.com.urbanban.com",
    "vmbkbs.us",
    "vmentorgk.com",
    "vmhdisfgxxqoejwhsu.cf",
    "vmhdisfgxxqoejwhsu.ga",
    "vmhdisfgxxqoejwhsu.gq",
    "vmhdisfgxxqoejwhsu.ml",
    "vmhdisfgxxqoejwhsu.tk",
    "vmi13l.us",
    "vmirenas.ru",
    "vmish.icu",
    "vmlfwgjgdw2mqlpc.cf",
    "vmlfwgjgdw2mqlpc.ga",
    "vmlfwgjgdw2mqlpc.ml",
    "vmlfwgjgdw2mqlpc.tk",
    "vmo.exchange",
    "vmpanda.com",
    "vmpanel.shop",
    "vmpsd.com",
    "vmvgoing.com",
    "vmwgfaop.shop",
    "vmy49.space",
    "vmzll.com",
    "vn009900.com",
    "vn7ag6.us",
    "vn8b3.us",
    "vn92wutocpclwugc.cf",
    "vn92wutocpclwugc.ga",
    "vn92wutocpclwugc.gq",
    "vn92wutocpclwugc.ml",
    "vn92wutocpclwugc.tk",
    "vna1ra.us",
    "vna68.space",
    "vncoders.net",
    "vnd3yf.us",
    "vndeal.info",
    "vnedorognik-yeti.ru",
    "vnedu.me",
    "vnet.citiz.net",
    "vnexpaawj.shop",
    "vngbam.us",
    "vnitsolution.com",
    "vnjpny.site",
    "vnn.vn",
    "vnpnet.com",
    "vnr98.com",
    "vnrrdjhl.shop",
    "vns2640.com",
    "vns72h.com",
    "vnshare.info",
    "vnsl.com",
    "vnukovo.net",
    "vnuova.icu",
    "vnvejjlh.shop",
    "vnwcs9.us",
    "vnxteam.xyz",
    "vnznetve.online",
    "voati.pro",
    "vocabook.win",
    "vocobe.com",
    "vocupeo.space",
    "voda-v-tule.ru",
    "vodadesk.info",
    "vodafone-au.info",
    "vodafone-au.space",
    "vodafone-nz.site",
    "vodafone-nz.space",
    "vodafone.ie",
    "vodafone.nl",
    "vodafonethuis.nl",
    "vodes.xyz",
    "vodgard.ru",
    "vodlockerseries.online",
    "vodmir.com",
    "vodtv.xyz",
    "voedselbosnistelrode.com",
    "voemail.com",
    "vofnbz.site",
    "vofu.ru",
    "vogayervaluation.com",
    "vogons.ru",
    "vogue.sk",
    "vohashops.site",
    "vohjzw.com",
    "voiceclasses.com",
    "voicefeas.xyz",
    "voicememe.com",
    "voiceseoservices.com",
    "voicesheep.email",
    "voicevictory.site",
    "void.maride.cc",
    "voidbay.com",
    "voided.host",
    "voikaserd.ga",
    "voikskrant.online",
    "voila.fr",
    "voilans.com",
    "voip-torg.ru",
    "voip4.ru",
    "voip5.ru",
    "voip6.ru",
    "voip8.ru",
    "voipjury.com",
    "voiptrade.ru",
    "voiquitruc.ga",
    "voiquitruc.gq",
    "voiquitruc.ml",
    "voiquitruc.tk",
    "voir-animes.xyz",
    "voir-film1.website",
    "voirfilms.blue",
    "voirfilms.stream",
    "voirfilmsgratuit.net",
    "voirseries-streaming.com",
    "voirseriestreaming.online",
    "voisonnhots.ga",
    "voisonnhots.gq",
    "voisonnhots.ml",
    "voisonnhots.tk",
    "voize.biz",
    "voize.online",
    "voizeapi.net",
    "voizemall.com",
    "vokbu0.info",
    "volary.site",
    "volcano-wings.com",
    "volcanomail.com",
    "volestream.com",
    "volestream19.com",
    "volestream22.com",
    "volestream24.com",
    "volestream25.com",
    "volestream26.com",
    "volestream34.com",
    "volestream35.com",
    "volestream38.com",
    "volestream40.com",
    "volestream42.com",
    "volestream43.com",
    "volestream46.com",
    "volestream47.com",
    "volestream48.com",
    "volestream50.com",
    "volkemol.ru",
    "volknakone.cf",
    "volknakone.ga",
    "volknakone.gq",
    "volknakone.ml",
    "volknakone.tk",
    "volkskran.online",
    "volkswagen-ag.cf",
    "volkswagen-ag.ga",
    "volkswagen-ag.gq",
    "volkswagen-ag.ml",
    "volkswagen-ag.tk",
    "vollbio.de",
    "vollfertig.vision",
    "volloeko.de",
    "volniisas.space",
    "volny.cz",
    "volodya-stavit.site",
    "vologdalestopprom.ru",
    "volshebstii.xyz",
    "volshebstiiluch.xyz",
    "volsingume.ru",
    "volssecsy.info",
    "voltaer.com",
    "voltalin.site",
    "voltanord.org",
    "volthdas.gq",
    "voltxsports.com",
    "volumaska.host",
    "volumehd.com",
    "volumetudo.website",
    "volumkas.cf",
    "volunteergarden.org",
    "voluptuary.site",
    "volvo-ab.cf",
    "volvo-ab.ga",
    "volvo-ab.gq",
    "volvo-ab.ml",
    "volvo-ab.tk",
    "volvo-s60.cf",
    "volvo-s60.ga",
    "volvo-s60.gq",
    "volvo-s60.ml",
    "volvo-s60.tk",
    "volvo-v40.ml",
    "volvo-v40.tk",
    "volvo-xc.ml",
    "volvo-xc.tk",
    "volvogroup.ga",
    "volvogroup.gq",
    "volvogroup.ml",
    "volvogroup.tk",
    "volvopenta.tk",
    "vomadig.ga",
    "vomadig.gq",
    "vomadig.tk",
    "vomechild.cf",
    "vomechild.tk",
    "vomega.org",
    "vomiqo.info",
    "vomoto.com",
    "vomvos.org",
    "vomwege.net",
    "vonbe.tk",
    "vonumalls.site",
    "voo.be",
    "vook.host",
    "voopee.net",
    "vootin.com",
    "voozadnetwork.com",
    "vopikaslukda.gq",
    "vorarlberg.dev",
    "vorga.org",
    "vorimo.ru",
    "voron-kryuk.ru",
    "voronkryuk.ru",
    "vorpostport.ga",
    "vorpostport.gq",
    "vorpostport.ml",
    "vors.info",
    "vorscorp.mooo.com",
    "vorsicht-bissig.de",
    "vorsicht-scharf.de",
    "vosomart.site",
    "vospitanievovrema.ru",
    "vosts.com",
    "vote-democrats.com",
    "vote-hillary.com",
    "vote-republicans.com",
    "vote4gas.org",
    "vote4gop.org",
    "vote4today.org",
    "vote4tomorrow.org",
    "votebestofsu.com",
    "votejohnfisher.com",
    "votenet.com",
    "voteulp.net",
    "votiputox.org",
    "votofeliz.com",
    "votretableaupersonnalise.fr",
    "vouchfor.app",
    "vouhotpcrib.ga",
    "vouhotpcrib.gq",
    "vouhotpcrib.tk",
    "voujoncafe.com",
    "vouk.cf",
    "vouk.gq",
    "vouk.ml",
    "vouk.tk",
    "voulesrandom.com",
    "vovan.ru",
    "vovva.ru",
    "vowallco.cf",
    "vowallco.ga",
    "vowallco.gq",
    "vowallco.ml",
    "voxcj.com",
    "voxelcore.com",
    "voxpronoia.com",
    "voxsox.com",
    "voyuboutique.site",
    "voz79.shop",
    "vozmi-instrument.ru",
    "vozsensual.com",
    "vozvratpravrf.ru",
    "vp.pl",
    "vp.ycare.de",
    "vp4zy.us",
    "vp8xi3.us",
    "vp93.com",
    "vpapa.ooo",
    "vpexpositor.com",
    "vpfbattle.com",
    "vphnfuu2sd85w.cf",
    "vphnfuu2sd85w.ga",
    "vphnfuu2sd85w.gq",
    "vphnfuu2sd85w.ml",
    "vphnfuu2sd85w.tk",
    "vpidcvzfhfgxou.cf",
    "vpidcvzfhfgxou.ga",
    "vpidcvzfhfgxou.gq",
    "vpidcvzfhfgxou.ml",
    "vpidcvzfhfgxou.tk",
    "vpmaj.us",
    "vpn-ike.net",
    "vpn-tondar.xyz",
    "vpn.st",
    "vpn33.top",
    "vpnexpress.best",
    "vpnfinity.com",
    "vpnforever.space",
    "vpngermany.company",
    "vpngratuit.company",
    "vpnnotsafe.zone",
    "vpnopenvpn.zone",
    "vpnprivacy.fund",
    "vpnprivate.fund",
    "vpnratings.fail",
    "vpnsupport.cool",
    "vpntochina.city",
    "vpntracker.band",
    "vpoker99domino.com",
    "vpomosmame.ru",
    "vprice.co",
    "vprintall.com",
    "vprinter.com",
    "vps.reviews",
    "vps30.com",
    "vps911.net",
    "vpsbots.com",
    "vpscloudvntoday.com",
    "vpsconfig.com",
    "vpsdb.com",
    "vpsdown.com",
    "vpsera.com",
    "vpsera.net",
    "vpsfox.com",
    "vpshi.com",
    "vpslists.com",
    "vpsmobilecloudkb.com",
    "vpsorg.pro",
    "vpsorg.top",
    "vpsscaler.com",
    "vpstalk.com",
    "vpstraffic.com",
    "vpstube.com",
    "vpsuniverse.com",
    "vpswatch.com",
    "vpswins.site",
    "vpvtou.us",
    "vpxdxsor.site",
    "vq8nr.us",
    "vqgaakece.shop",
    "vqqhry1j.xyz",
    "vqrbaq.site",
    "vqsjpy.com",
    "vqzdwm.us",
    "vr066.com",
    "vr068.com",
    "vr087.com",
    "vr096.com",
    "vr1ly4.us",
    "vr360listings.info",
    "vr3s61.us",
    "vr4x4.ru",
    "vr5gpowerv.com",
    "vr9.com",
    "vrabote-doma.ru",
    "vracg.com",
    "vradportal.com",
    "vram.xyz",
    "vrcard.ru",
    "vrdhy6.club",
    "vredirect.com",
    "vregion.ru",
    "vremonte24-store.ru",
    "vreqfbev.shop",
    "vrgu4x.com",
    "vrgwkwab2kj5.cf",
    "vrgwkwab2kj5.ga",
    "vrgwkwab2kj5.gq",
    "vrgwkwab2kj5.ml",
    "vrgwkwab2kj5.tk",
    "vrheroes.info",
    "vridhi.org",
    "vripnc.us",
    "vrjsoq.ru",
    "vrjw.com",
    "vrloco.com",
    "vrmmeh.com",
    "vrmqacrq.shop",
    "vrmtr.com",
    "vroomvroomvroom.rentals",
    "vrou.cf",
    "vrou.ga",
    "vrou.gq",
    "vrou.ml",
    "vrou.tk",
    "vrpitch.com",
    "vrsim.ir",
    "vrstripshows.com",
    "vrsykk.xyz",
    "vrtgog.us",
    "vrvrx.com",
    "vryyqtgz.shop",
    "vrzpoker.com",
    "vs-ad.com",
    "vs3ir4zvtgm.cf",
    "vs3ir4zvtgm.ga",
    "vs3ir4zvtgm.gq",
    "vs3ir4zvtgm.ml",
    "vs3ir4zvtgm.tk",
    "vs7wgz.host",
    "vs904a6.com",
    "vs9992.net",
    "vsalmonusq.com",
    "vsc3bf.us",
    "vsds.pro",
    "vsdv.pro",
    "vse-casino.com",
    "vse-dveriru.ru",
    "vse-massageri.ru",
    "vse-nyew.ru",
    "vse-oboiru.ru",
    "vse-polyru.ru",
    "vse-serii.xyz",
    "vse-smi.ru",
    "vse-strany.ru",
    "vse-zamkiru.ru",
    "vse-zdes.website",
    "vseadvokati.ru",
    "vsebrigadi.ru",
    "vsedirect.ru",
    "vsedveriru.ru",
    "vsegirect.ru",
    "vsekatal.ru",
    "vsembiznes.ru",
    "vsemkvarti.ru",
    "vsemotdihat.ru",
    "vsemsoft.ru",
    "vseoboiru.ru",
    "vseoneyrosisteme7.ru",
    "vseosade.ru",
    "vsepolyru.ru",
    "vseturist.ru",
    "vsevnovosti.ru",
    "vsezamkiru.ru",
    "vsezdorovie-vsem.ru",
    "vsibkb.com",
    "vsimcard.com",
    "vsix.de",
    "vsjfashions.com",
    "vsmartdata.com",
    "vsmartsync.com",
    "vspiderf.com",
    "vsshevvq.shop",
    "vssms.com",
    "vsszone.com",
    "vstahigherlearning.com",
    "vstarbliss.org",
    "vstartup4q.com",
    "vsv1js1belhluaw.xyz",
    "vsxz.pro",
    "vsz63.space",
    "vt0bk.us",
    "vt0uhhsb0kh.cf",
    "vt0uhhsb0kh.ga",
    "vt0uhhsb0kh.gq",
    "vt0uhhsb0kh.ml",
    "vt0uhhsb0kh.tk",
    "vt6k5.us",
    "vt8khiiu9xneq.cf",
    "vt8khiiu9xneq.ga",
    "vt8khiiu9xneq.gq",
    "vt8khiiu9xneq.ml",
    "vt8khiiu9xneq.tk",
    "vt8zilugrvejbs.tk",
    "vtaffiliate.com",
    "vtallinn.info",
    "vtavte.xyz",
    "vtb365.com",
    "vtbapp.com",
    "vtbcn.com",
    "vtbfan.com",
    "vtbja.us",
    "vtblist.com",
    "vtbnews.com",
    "vtbshe.com",
    "vtbsub.com",
    "vtbt.design",
    "vtbtt.com",
    "vtbvtb.com",
    "vtbvup.com",
    "vtc.edu.hk",
    "vtdetoxcenter.com",
    "vteachesb.com",
    "vteensp.com",
    "vthalfpricelisting.com",
    "vthalfpricelistings.com",
    "vtol.us",
    "vtolat.icu",
    "vtormetresyrs.ru",
    "vtsm.net",
    "vtuber.fan",
    "vtuber365.com",
    "vtubercn.com",
    "vtuberlist.com",
    "vtuberlive.com",
    "vtubernews.com",
    "vtubershe.com",
    "vtuberworld.com",
    "vtwelves.com",
    "vtwumka.xyz",
    "vtxmail.us",
    "vu981s5cexvp.cf",
    "vu981s5cexvp.ga",
    "vu981s5cexvp.gq",
    "vu981s5cexvp.ml",
    "vuabai.info",
    "vuacado.xyz",
    "vuadoithuong.xyz",
    "vuasanca.com",
    "vuathethao.pro",
    "vubby.com",
    "vubori13.space",
    "vuemail.com",
    "vufe.site",
    "vufkbrsdd.shop",
    "vuihet.ga",
    "vuive.shop",
    "vuiy.pw",
    "vujave.info",
    "vukdfe.us",
    "vulcan-platinum24.com",
    "vulcandengy.ru",
    "vulcanrussia.club",
    "vulccanstars.live",
    "vulkan-hot.online",
    "vulkan-maximum-scachat.org",
    "vulkan-olimp.info",
    "vulkan-olymp-mobile.xyz",
    "vulkan-original.ru",
    "vulkan-platinum-casino777.com",
    "vulkan-russkiy.tech",
    "vulkan365-vhod.xyz",
    "vulkanavtomatmaid.ru",
    "vulkanstavka.center",
    "vulkanstl-8.com",
    "vulkastars.ru",
    "vulkhan-vip.ru",
    "vulktee.com",
    "vullesmemes.online",
    "vuln.space",
    "vulnerable.host",
    "vulsiket.ga",
    "vulsiket.tk",
    "vultiasu.cf",
    "vultiasu.ga",
    "vultiasu.gq",
    "vultiasu.ml",
    "vumaenergy.com",
    "vumaevergy.com",
    "vungchom.net",
    "vunjrc.online",
    "vuongquocgowin.com",
    "vup.moe",
    "vupnews.com",
    "vupvtb.com",
    "vupwiki.com",
    "vuqpid.us",
    "vurbmedia.com",
    "vurzoukewaq.ru",
    "vusd.net",
    "vusra.com",
    "vutdrenaf56aq9zj68.cf",
    "vutdrenaf56aq9zj68.ga",
    "vutdrenaf56aq9zj68.gq",
    "vutdrenaf56aq9zj68.ml",
    "vutdrenaf56aq9zj68.tk",
    "vuv9hhstrxnjkr.cf",
    "vuv9hhstrxnjkr.ga",
    "vuv9hhstrxnjkr.gq",
    "vuv9hhstrxnjkr.ml",
    "vuv9hhstrxnjkr.tk",
    "vuvomarket.site",
    "vuvuive.xyz",
    "vuylkan.com",
    "vuylu5.host",
    "vuzimir.cf",
    "vv18269.com",
    "vv3b.icu",
    "vv7665.com",
    "vv9094.com",
    "vv9827.com",
    "vvb3sh5ie0kgujv3u7n.cf",
    "vvb3sh5ie0kgujv3u7n.ga",
    "vvb3sh5ie0kgujv3u7n.gq",
    "vvb3sh5ie0kgujv3u7n.ml",
    "vvb3sh5ie0kgujv3u7n.tk",
    "vve-ripperdahof.online",
    "vventrachicago.com",
    "vvg94.space",
    "vvimbog.site",
    "vvimboo.site",
    "vvitrik.site",
    "vvizion.site",
    "vvlvmrutenfi1udh.ga",
    "vvlvmrutenfi1udh.ml",
    "vvlvmrutenfi1udh.tk",
    "vvng8xzmv2.cf",
    "vvng8xzmv2.ga",
    "vvng8xzmv2.gq",
    "vvng8xzmv2.ml",
    "vvng8xzmv2.tk",
    "vvolkov.top",
    "vvoondun.site",
    "vvoozzyl.site",
    "vvopzc.shop",
    "vvs3s.com",
    "vvuti.ru",
    "vvvulek8.xyz",
    "vvvv.de",
    "vvwbaidu.com",
    "vvx046q.com",
    "vvyolr.site",
    "vw-ag.tk",
    "vw-audi.ml",
    "vw-cc.cf",
    "vw-cc.ga",
    "vw-cc.gq",
    "vw-cc.ml",
    "vw-cc.tk",
    "vw-eos.cf",
    "vw-eos.ga",
    "vw-eos.gq",
    "vw-eos.ml",
    "vw-eos.tk",
    "vw-seat.ml",
    "vw-skoda.ml",
    "vw5opi.us",
    "vw7w.com",
    "vw8w.com",
    "vwavkb.info",
    "vwazamarshwildlifereserve.com",
    "vwdiscount.online",
    "vwdvpnxsm.shop",
    "vwengh.xyz",
    "vwhitetoothbrush.com",
    "vwhomedecor.com",
    "vwivod.rest",
    "vwlk1i.us",
    "vwqftf.us",
    "vwstk.buzz",
    "vwtedx7d7f.cf",
    "vwtedx7d7f.ga",
    "vwtedx7d7f.gq",
    "vwtedx7d7f.ml",
    "vwtedx7d7f.tk",
    "vwwbaidu.com",
    "vwydus.icu",
    "vwzagoujq.shop",
    "vxc.edgac.com",
    "vxcs.pro",
    "vxhdtlud.shop",
    "vxinzlno.xyz",
    "vxmail.top",
    "vxmail2.net",
    "vxqkogil.shop",
    "vxqt4uv19oiwo7p.cf",
    "vxqt4uv19oiwo7p.ga",
    "vxqt4uv19oiwo7p.gq",
    "vxqt4uv19oiwo7p.ml",
    "vxqt4uv19oiwo7p.tk",
    "vxvv.net",
    "vxwiew.site",
    "vxxx.fun",
    "vxznq.com",
    "vy69pr.us",
    "vy7c9u.com",
    "vy8iyh.com",
    "vydoei.rest",
    "vyehg.us",
    "vygsale.top",
    "vyhade3z.gq",
    "vyhino.net",
    "vyineily.com",
    "vyjeku.info",
    "vykupavto1.ru",
    "vylqsc.us",
    "vympelpravo.ru",
    "vyrski4nwr5.cf",
    "vyrski4nwr5.ga",
    "vyrski4nwr5.gq",
    "vyrski4nwr5.ml",
    "vyrski4nwr5.tk",
    "vzanguard.com",
    "vze0w.us",
    "vzlom4ik.tk",
    "vzml.us",
    "vzodv.com",
    "vzpuj.com",
    "vzroslyekartinki.ru",
    "vztc.com",
    "vztu4a1r21hkmst.com",
    "vzvqdh.site",
    "vzwrdwggkv.host",
    "vzwv6test.com",
    "vzyat-ssudy.ru",
    "w-amst.ru",
    "w-asertun.ru",
    "w-oproz.ru",
    "w-shoponline.info",
    "w.0w.ro",
    "w.cn",
    "w0ht.us",
    "w12io.space",
    "w12qt.space",
    "w12wc.space",
    "w13sr.space",
    "w15xx.space",
    "w1775.com",
    "w17ac.space",
    "w17hs.space",
    "w19oi.space",
    "w1pars.online",
    "w20al.space",
    "w20tb.space",
    "w2203.com",
    "w22fe21.com",
    "w22pj.space",
    "w23ex.space",
    "w24gs.space",
    "w25nx.space",
    "w25vz.buzz",
    "w27qo.space",
    "w2858.com",
    "w2fdsqdhgr.xyz",
    "w2yq4x-mail.xyz",
    "w3.to",
    "w30gw.space",
    "w310.club",
    "w312.club",
    "w313.club",
    "w315.club",
    "w31cy.space",
    "w32qm.space",
    "w33wq.space",
    "w33yu.space",
    "w34ct.space",
    "w34nu.space",
    "w34sf.space",
    "w35ez.space",
    "w35so.space",
    "w37il.space",
    "w3internet.co.uk",
    "w3k6sm.info",
    "w3kit.ru",
    "w3kv2e.us",
    "w3mailbox.com",
    "w3ur4.com",
    "w3windsor.com",
    "w41di.space",
    "w41dm.space",
    "w41lj.space",
    "w41yn.space",
    "w42fq.space",
    "w42hm.space",
    "w44hh.space",
    "w44xf.space",
    "w45678.com",
    "w45ex.space",
    "w46db.space",
    "w47al.space",
    "w47rl.space",
    "w4files.xyz",
    "w4i3em6r.com",
    "w4iaj.us",
    "w4ms.ga",
    "w4ms.ml",
    "w50h.com",
    "w58h.com",
    "w5955.com",
    "w5gpurn002.cf",
    "w5gpurn002.ga",
    "w5gpurn002.gq",
    "w5gpurn002.ml",
    "w5gpurn002.tk",
    "w5p.ru",
    "w5q.ru",
    "w5t.ru",
    "w634634.ga",
    "w656n4564.cf",
    "w656n4564.ga",
    "w656n4564.gq",
    "w656n4564.ml",
    "w656n4564.tk",
    "w6840.com",
    "w6867.com",
    "w6890.com",
    "w68vn.com",
    "w6att2c39zyj22i.xyz",
    "w6mail.com",
    "w6r9cs71xbbzwod.xyz",
    "w6rz6j0ply1oppp.xyz",
    "w6veyq.com",
    "w7082.com",
    "w70h.com",
    "w70ptee1vxi40folt.cf",
    "w70ptee1vxi40folt.ga",
    "w70ptee1vxi40folt.gq",
    "w70ptee1vxi40folt.ml",
    "w70ptee1vxi40folt.tk",
    "w777info.ru",
    "w7l6tv.us",
    "w7vcxs.online",
    "w7wdhuw9acdwy.cf",
    "w7wdhuw9acdwy.ga",
    "w7wdhuw9acdwy.gq",
    "w7wdhuw9acdwy.ml",
    "w7wdhuw9acdwy.tk",
    "w8196.com",
    "w888b.com",
    "w888info.com",
    "w888me.com",
    "w88biz.com",
    "w88first.com",
    "w88id.xyz",
    "w88shop.com",
    "w88th.asia",
    "w88th.one",
    "w88vipen.com",
    "w88w88.info",
    "w88yd0.com",
    "w88yd2.com",
    "w88yd4.com",
    "w88yd5.com",
    "w8fll.info",
    "w8i8n.com",
    "w8u55.com",
    "w8u66.com",
    "w8u77.com",
    "w8u88.com",
    "w8xo.us",
    "w90h.com",
    "w918bsq.com",
    "w9339.com",
    "w93o.us",
    "w94ofm0z.icu",
    "w9969.com",
    "w9d23w.us",
    "w9f.de",
    "w9y9640c.com",
    "w9zen.com",
    "wa010.com",
    "waariswaldo.online",
    "wackov.com",
    "wadawdawd.ru",
    "waddayareckon.com",
    "wadeeni.net",
    "wadegriffinroofing.com",
    "wadfes.ml",
    "wadifa55.work",
    "wadigum.cf",
    "wadigum.gq",
    "wadigum.ml",
    "wadigum.tk",
    "wadiz.blog",
    "wafege.info",
    "waffwlwolf.live",
    "waftage.site",
    "wafture.site",
    "wagerrcore.com",
    "wagerrcore.org",
    "wagerrwallet.com",
    "wagertalkpicks.com",
    "wagfused.com",
    "waggy.media",
    "waggy.toys",
    "waggy.vacations",
    "wagon58.website",
    "wahalfpricedlistings.com",
    "wahalfpricelisting.com",
    "wahalfpricelistings.com",
    "wahana888.org",
    "wahl-beret.online",
    "wahlprofessional.ru",
    "wahoye.com",
    "waibavic.cf",
    "waibavic.gq",
    "waibavic.ml",
    "waifufigures.com",
    "waikikieasthotel.com",
    "waikinyxt.site",
    "wait.cf",
    "waitingjwo.com",
    "waitslab.site",
    "waitulea.cf",
    "waitulea.ga",
    "waitulea.ml",
    "waitulea.tk",
    "waivcoin.com",
    "wajikethanh96ger.gq",
    "wakabook.xyz",
    "wakaface.site",
    "wakaface.xyz",
    "wakainfo.site",
    "wakatopinfo.site",
    "wakingupesther.com",
    "walala.org",
    "waldboard.biz",
    "waldboard.com",
    "waldemar.ru",
    "waldlecum.gq",
    "waldlecum.ml",
    "waldlecum.tk",
    "wales2000.net",
    "walgioci.cf",
    "walgioci.ga",
    "walgioci.gq",
    "walgioci.ml",
    "walgioci.tk",
    "walizu.com",
    "walk2metro.com",
    "walkandtalk.app",
    "walkerhill.shop",
    "walkerroadchiropractic.com",
    "walking-holiday-in-spain.com",
    "walking-water.com",
    "walkinremembrance.com",
    "walkkiyo.ml",
    "walkmail.net",
    "walkmail.ru",
    "walkthiswaypaths.shop",
    "wall5droid.ru",
    "walla.co.il",
    "walla.com",
    "walldepha.cf",
    "walldepha.gq",
    "walldepha.ml",
    "walldepha.tk",
    "wallfit.me",
    "wallm.com",
    "wallofcoins.org",
    "wallpaperfren.com",
    "wallpaperlive.org",
    "wallrkvagfg.email",
    "wallsoo.com",
    "wallstreetcn.live",
    "walmart-eshop.com",
    "walmart-site.com",
    "walmart-web.com",
    "walmarte-shop.com",
    "walmarteshop.com",
    "walmarteshops.com",
    "walmartnet.com",
    "walmartonlines.com",
    "walmartpartners.com",
    "walmartshops.com",
    "walmartsites.com",
    "walmartsoftware.com",
    "walmartsshop.com",
    "walmarttonlines.com",
    "walmarttshops.com",
    "walmartttonlines.com",
    "walmartttshops.com",
    "walmarttttonlines.com",
    "walmarttttshops.com",
    "walmartttttonlines.com",
    "walmartttttshops.com",
    "walmartwebs.com",
    "walmartwebsites.com",
    "walotu.site",
    "walshpoems.com",
    "walsinghamsociety.org",
    "walterchu.com",
    "walterhgottschalk.org",
    "walternal.info",
    "waltonor.buzz",
    "waltpanko.net",
    "waltsbeefjerky.net",
    "waltsworkwearstore.com",
    "walvoper.cf",
    "walvoper.ga",
    "walvoper.gq",
    "wam-blog7.site",
    "wam-blog8.site",
    "wam.co.za",
    "wamail.net",
    "wamdabiz.com",
    "wanaboo.com",
    "wanadoo.co.uk",
    "wanadoo.es",
    "wanadoo.fr",
    "wanari.info",
    "wander.love",
    "wanderdszx.site",
    "wanderingstarstudio.com",
    "wandershopper.xyz",
    "wanetwork.us",
    "wangansheep.com",
    "wangiparfum.info",
    "wanglouyouxiluntan.xyz",
    "wangluojingyingchangsuo.shop",
    "wangsili.space",
    "wangye.pub",
    "wanhuiyule.net",
    "wanko.be",
    "wanlzy.xyz",
    "wanminle.com",
    "wannabuyit.website",
    "want2lov.us",
    "want2makemoneynow.com",
    "wantisol.gq",
    "wantisol.ml",
    "wantisol.tk",
    "wantplay.site",
    "wantresult71.online",
    "wantresultkzn.ru",
    "wants.dicksinhisan.us",
    "wants.dicksinmyan.us",
    "wantsuccess.ru",
    "wanttocum.com",
    "wantwasherdryerparts.site",
    "wanxing-yl.com",
    "wap8037.com",
    "wap9827.com",
    "wapclub.ru",
    "wapda.com",
    "wapenshaw.xyz",
    "wapgwh.site",
    "wapl.ga",
    "wappay.xyz",
    "wappia.app",
    "wapqus.com",
    "wapsound.ru",
    "wapstores.org",
    "waptube.site",
    "wapxxx.site",
    "wapyello.gq",
    "war-im-urlaub.de",
    "warau-kadoni.com",
    "warbet365.net",
    "warbfisa.gq",
    "warbfisa.tk",
    "warblespe.cf",
    "warblespe.ga",
    "warblespe.gq",
    "warcandde.cf",
    "warcandde.ga",
    "warcandde.gq",
    "warcraftwallpapers.com",
    "wardcabinetworks.com",
    "wardlile.cf",
    "wardlile.ga",
    "wardlile.tk",
    "wardprodun.ga",
    "wardprodun.ml",
    "wardwamse.cf",
    "wardwamse.ga",
    "wardwamse.gq",
    "wardwamse.tk",
    "waredbarn.com",
    "warehambowls.club",
    "warehouse-flooring.com",
    "warepool.com",
    "warfile.ru",
    "warfingers.xyz",
    "waridsolutions.info",
    "warman.global",
    "warmiki.ru",
    "warmmail.com",
    "warmorop.gq",
    "warmorop.ml",
    "warmorop.tk",
    "warmynfh.ru",
    "warna222.com",
    "warnabandarqnet.com",
    "warnatoto.com",
    "warnbuilding.com",
    "warned.email",
    "warnednl2.com",
    "warnerbrobrewco.com",
    "warnerwave.xyz",
    "warning-10by25.stream",
    "warnomics.com",
    "waronrent.org",
    "warp2p.com",
    "warpmail.net",
    "warranty.legal",
    "warrenbuffetsnextdoor.com",
    "warrenbuffett.org",
    "warrenforpresident.com",
    "warringalpublications.com",
    "warrior.hu",
    "warriorhaze.com",
    "warriorpls.com",
    "warriorsoul.clothing",
    "warriorssweat.com",
    "warruga.com",
    "warschauermusicstore.com",
    "waru88.xyz",
    "waruh.com",
    "warungku.me",
    "warungsanak.com",
    "warwickattorneys.com",
    "warwickrealestateagents.com",
    "wasabi-75.ru",
    "wasabimalahide.com",
    "wasanii.africa",
    "wasatchpestcontrol.net",
    "waschservice.de",
    "wasd.10mail.org",
    "wasd.dropmail.me",
    "wasd.netmail.tk",
    "wasdfgh.cf",
    "wasdfgh.ga",
    "wasdfgh.gq",
    "wasdfgh.ml",
    "wasdfgh.tk",
    "wasenm12.xyz",
    "wasenm15.xyz",
    "wasenm16.xyz",
    "wasenm19.xyz",
    "wasenm22.xyz",
    "wasenm25.xyz",
    "wasenm26.xyz",
    "wasenm33.xyz",
    "wasenm36.xyz",
    "wasenm39.xyz",
    "wasenm40.xyz",
    "wasenm41.xyz",
    "wasenm42.xyz",
    "wasenm45.xyz",
    "wasenm46.xyz",
    "wasenm47.xyz",
    "wasenm53.xyz",
    "wasenm55.xyz",
    "wasenm6.xyz",
    "wasenm64.xyz",
    "wasenm68.xyz",
    "wasenm71.xyz",
    "wasenm72.xyz",
    "wasenm78.xyz",
    "wasenm83.xyz",
    "wasenm85.xyz",
    "wasenm86.xyz",
    "wasenm87.xyz",
    "wasenm89.xyz",
    "wasevgjkg.shop",
    "washdye.com",
    "washi.store",
    "washington-ttv.com",
    "washingtonfeb.com",
    "washingtongarricklawyers.com",
    "washingtonmsn.com",
    "washingtonrose.org",
    "washingtontitleandescrow.org",
    "washingtonttv.com",
    "washingtonweddingco.com",
    "washstnqzz.ru",
    "wasimismail.com",
    "waskitacorp.cf",
    "waskitacorp.ga",
    "waskitacorp.gq",
    "waskitacorp.ml",
    "waskitacorp.tk",
    "waslangewaehrtwirdendlichwar.love",
    "wasp-reach.com",
    "wasptemo.cf",
    "wasptemo.ga",
    "wasptemo.gq",
    "wasptemo.tk",
    "wasse-asxzer.ru",
    "wastecrea.xyz",
    "wastefulaf.com",
    "wasteland.rfc822.org",
    "wastesli.xyz",
    "wasteslic.xyz",
    "wastespac.buzz",
    "wastimenin.site",
    "watashiyuo.cf",
    "watashiyuo.ga",
    "watashiyuo.gq",
    "watashiyuo.ml",
    "watashiyuo.tk",
    "watch-arb8.site",
    "watch-harry-potter.com",
    "watchbotmail.org",
    "watchdairy.site",
    "watchelements.asia",
    "watchesshop.futbol",
    "watchever.biz",
    "watchforums.org",
    "watchfree.org",
    "watchfull.net",
    "watchfull.org",
    "watchhaking.cf",
    "watchhaking.tk",
    "watchhosfold.cf",
    "watchhosfold.ga",
    "watchhosfold.gq",
    "watchhosfold.tk",
    "watchironman3onlinefreefullmovie.com",
    "watchkingofthehill.info",
    "watchmail.com",
    "watchofficial.ru",
    "watchpart.com",
    "watchshak.recipes",
    "watchstifva.cf",
    "watchstifva.ga",
    "watchstifva.ml",
    "watchti.icu",
    "watchtre.xyz",
    "watchtrea.xyz",
    "watchtvcoin.com",
    "watcstation.com",
    "watdafuq.com",
    "water-freedom.com",
    "waterbedblog.com",
    "watercoloraquariumgallery.com",
    "waterhudcj.space",
    "waterloodoctors.com",
    "waterloorealestateagents.com",
    "watermarkmoso.com",
    "waterparkphuket.fun",
    "waterpointemortgage.com",
    "waterqualityassociation.net",
    "waterservice.xyz",
    "watersit.site",
    "waterso.com",
    "watertaxionlakegeorge.com",
    "wateruh.com",
    "watfordfans.com",
    "wathuncont.cf",
    "wathuncont.tk",
    "watsonvilleapartments.com",
    "watsonvilledoctors.com",
    "watsonvillerentals.com",
    "waucisni.gq",
    "waumail.com",
    "wavemail.ir",
    "waveneyhousehotel.com",
    "waverlyohsa.info",
    "wavesplatfom.ru",
    "wavesplotform.ru",
    "wawaterfilters.com",
    "wawi.es",
    "wawobuild.com",
    "waxyme.info",
    "way-to-pay.space",
    "way2bargain.com",
    "way2iceland.ru",
    "waybet.ru",
    "waybmw.com",
    "wayofthesufi.com",
    "wayto.info",
    "wazabi.club",
    "wazino.bet",
    "wazino777.bet",
    "wazqup.us",
    "wb24.de",
    "wbdet.com",
    "wbdev.tech",
    "wbdymzon.shop",
    "wbfxaffiliate.com",
    "wbhyzb.com",
    "wbidfc.com",
    "wbieszczady.xyz",
    "wbkqcw.site",
    "wbmkr0.us",
    "wbml.net",
    "wbngl0bal.net",
    "wbr.global",
    "wbr.reviews",
    "wbr21.site",
    "wbseoseo.com",
    "wbt24f.us",
    "wbwck.us",
    "wc-api-fjc--2.com",
    "wc-api-fjc--4.com",
    "wc2ttpxd7o0y9np.xyz",
    "wca.cn.com",
    "wcapedhgh.shop",
    "wccoba.org",
    "wcddvezl974tnfpa7.cf",
    "wcddvezl974tnfpa7.ga",
    "wcddvezl974tnfpa7.gq",
    "wcddvezl974tnfpa7.ml",
    "wcddvezl974tnfpa7.tk",
    "wcfzw.info",
    "wcgnv.us",
    "wchatz.ga",
    "wcheat.xyz",
    "wchhka.us",
    "wclc.net",
    "wclxwo.site",
    "wco9zb.us",
    "wcpuid.com",
    "wcpww.info",
    "wcrpw.info",
    "wcsoxefen.shop",
    "wctpw.info",
    "wcus6s.us",
    "wcxnbu.best",
    "wd-shop.online",
    "wd0payo12t8o1dqp.cf",
    "wd0payo12t8o1dqp.ga",
    "wd0payo12t8o1dqp.gq",
    "wd0payo12t8o1dqp.ml",
    "wd0payo12t8o1dqp.tk",
    "wdaus1.us",
    "wdbanyak.org",
    "wdcloud.ru",
    "wddgw.info",
    "wddsocial.com",
    "wdge.de",
    "wdinengz.shop",
    "wdiscount.online",
    "wdjc.us",
    "wdplgwfsi.shop",
    "wdr8tx.info",
    "wdsfbghfg77hj.gq",
    "wdvhw1.site",
    "wdx4.com",
    "wdzsw.info",
    "we-are-replay.com",
    "we.lovebitco.in",
    "we.qq.my",
    "we1j3y.us",
    "we33pin.xyz",
    "we34.space",
    "we37.space",
    "we40.space",
    "we43.space",
    "we55pin.xyz",
    "we66pin.xyz",
    "we77pin.xyz",
    "we9pnv.us",
    "weahteronline.com",
    "wealth-mastermind.com",
    "wealthru.club",
    "wealthymoney.pw",
    "weammo.xyz",
    "wearab.net",
    "wearablesculpture.com",
    "weareallcavemen.com",
    "weareallgamers.com",
    "wearechange.site",
    "wearefairfashion.cat",
    "wearefairfashion.se",
    "wearerootedinexcellence.com",
    "wearethepeople.site",
    "weareworkcomp.com",
    "wearewynwood.com",
    "wearewynwood.org",
    "wearsti19.tk",
    "weaseling606tw.online",
    "weasity.ru",
    "weatherest.com",
    "weatherrootfirefight.best",
    "weatherslawblog.com",
    "weave.email",
    "weave.xyz",
    "weavingbeads.host",
    "web-contact.info",
    "web-development-companies-uae.info",
    "web-email.eu",
    "web-emailbox.eu",
    "web-experts.net",
    "web-gravitation.ru",
    "web-ideal.fr",
    "web-inc.net",
    "web-kamere-za-odrasle-online.fun",
    "web-mail.com.ar",
    "web-mail.de",
    "web-mail.pp.ua",
    "web-novosti.ru",
    "web-police.com",
    "web-ryugaku.net",
    "web-wingmen.com",
    "web.de",
    "web.discard-email.cf",
    "web.id",
    "web2mailco.com",
    "web2rss.com",
    "webaddressbook.com",
    "webadicta.org",
    "webadilly.com",
    "webadsprotectonline.club",
    "webaheadstudios.com",
    "webanalyticsalert.com",
    "webarnak.fr.eu.org",
    "webasto.ltd",
    "webauth.shop",
    "webauthn.cloud",
    "webave.com",
    "webaward.online",
    "webbamail.com",
    "webbiesharing.com",
    "webbithosting.org",
    "webbizprofit.com",
    "webbsfunny.com",
    "webbworks.com",
    "webcache.site",
    "webcamchiks.com",
    "webcammail.com",
    "webcamrobots.com",
    "webcamtests.net",
    "webcarta.com",
    "webcchelp.com",
    "webcity.ca",
    "webcms.app",
    "webcontact-france.eu",
    "webcool.club",
    "webcoworking.ru",
    "webcperbri.cf",
    "webcperbri.gq",
    "webcperbri.tk",
    "webdesignlabratory.com",
    "webdream.com",
    "webemail.me",
    "webemaillist.com",
    "weber.edu",
    "webet188tiga.net",
    "webet24.biz",
    "webet24.live",
    "webex.expert",
    "webfreemanual.asia",
    "webgameawards.com",
    "webgenic.online",
    "webgirlsinternational.com",
    "webgmail.info",
    "webgravitation.ru",
    "webharden.com",
    "webharden.net",
    "webhomes.net",
    "webhook.online",
    "webhop.biz",
    "webhop.info",
    "webhop.net",
    "webhop.org",
    "webhostchart.com",
    "webhostfarm.com",
    "webhostingbuzz.org",
    "webhostingdomain.ga",
    "webhostingsimplicity.com",
    "webhostingtable.com",
    "webhostingwatch.ru",
    "webide.ga",
    "webinar-kochandkarki.live",
    "webinbox.com",
    "webindia123.com",
    "webingways.com",
    "webird.se",
    "webjet.rentals",
    "webjump.com",
    "webkiff.info",
    "webkiper.ru",
    "webkitfoundation.net",
    "webkitfoundation.org",
    "webkizlar.com",
    "webkoffe.ru",
    "weblab34.ru",
    "weblenders.ru",
    "webleverancier.com",
    "weblima.info",
    "webm4il.in",
    "webm4il.info",
    "webmail.bellsouth.net",
    "webmail.blue",
    "webmail.co.yu",
    "webmail.co.za",
    "webmail.de",
    "webmail.fish",
    "webmail.hu",
    "webmail.igg.biz",
    "webmail.kolmpuu.net",
    "webmail.lawyer",
    "webmail.ru",
    "webmail.wiki",
    "webmail24.to",
    "webmail24.top",
    "webmaild.net",
    "webmails.com",
    "webmails.top",
    "webmailv.com",
    "webmastercommerce.com",
    "webmcampvi.cf",
    "webmcampvi.gq",
    "webmcampvi.ml",
    "webmeetme.com",
    "webmind-glu.online",
    "webname.cloud",
    "webname.com",
    "webnavster.com",
    "webphanmem.net",
    "webpinoyako.ru",
    "webpinoyteleserye.ru",
    "webpinoyteleserye.su",
    "webpoker99.live",
    "webpozdravka.ru",
    "webpreserv.com",
    "webpro24.ru",
    "webprogramming.com",
    "webrepository.ru",
    "webryugaku.com",
    "websecuremail.com",
    "webshop.website",
    "websitecheckin.com",
    "websiteconcierge.net",
    "websitedesignjb.com",
    "websitedomain.website",
    "websiteflags.com",
    "websiteforbusiness.info",
    "websitehostingserverindia.com",
    "websiteproekt.ru",
    "websiteregistrationrequest.com",
    "websitevsfunnel.com",
    "webskulker.com",
    "websorcery.com",
    "webstable.net",
    "webstarter.xyz",
    "webstation.com",
    "webstoremy.site",
    "websubtopnew.club",
    "websurfer.co.za",
    "webtare.cf",
    "webtare.ga",
    "webtare.gq",
    "webtempmail.online",
    "webtimereport.com",
    "webtoon.club",
    "webtopmail.com",
    "webtown2.com",
    "webtown3.net",
    "webtribe.net",
    "webtrip.ch",
    "webtv.net",
    "webuiltyoursite.com",
    "webuser.in",
    "webuyahouse.com",
    "webuydayton.net",
    "webuyhudsonvalleyhouses.com",
    "webwallet.exchange",
    "webx5.royal-almas.it",
    "webxengine.com",
    "webxphp.ru",
    "webzone.icu",
    "wecantaffordtowait.com",
    "wecell.net",
    "weclickers.ru",
    "wecmon.org",
    "wecookittakeaway.com",
    "wedbank.ru",
    "wedding-lombok.com",
    "weddingalley.net",
    "weddingcopenhagen.com",
    "weddinglombok.com",
    "weddingofficiant.vegas",
    "weddingrepublic.com",
    "weddingringsinfo.com",
    "weddingslombok.com",
    "weddingtop.site",
    "wedeliverknowdledge.info",
    "wederaser.cf",
    "wediapanel.online",
    "wediapanel.xyz",
    "wediasoft.com",
    "wednesdaylaura.com",
    "wednesdaymovo.com",
    "wedooos.cf",
    "wedooos.ga",
    "wedooos.gq",
    "wedooos.ml",
    "wedostuffwell.net",
    "wedpurpleyet.website",
    "wedvine.com",
    "wee.my",
    "weed.monster",
    "weedmail.com",
    "weegal.com",
    "weekendemail.com",
    "weeklion.com",
    "weekmail.com",
    "weekmovie.org",
    "weekom.fr",
    "weekonline.com",
    "weemanlivetv.live",
    "weenmyip.com",
    "weeping-willow.shop",
    "weer.de",
    "weeya22.com",
    "wef.gr",
    "wefjo.grn.cc",
    "wefky.com",
    "wefod1.site",
    "weftsealer.com",
    "weg-beschlussbuch.de",
    "weg-werf-email.de",
    "wegas.ru",
    "wegenbouw.works",
    "wegetall.store",
    "wego-delivery.com",
    "wegolo.se",
    "wegoloblogs.com",
    "wegwerf-email-addressen.de",
    "wegwerf-email-adressen.de",
    "wegwerf-email.at",
    "wegwerf-email.de",
    "wegwerf-email.net",
    "wegwerf-emails.de",
    "wegwerfadresse.de",
    "wegwerfemail.com",
    "wegwerfemail.de",
    "wegwerfemail.info",
    "wegwerfemail.net",
    "wegwerfemail.org",
    "wegwerfemailadresse.com",
    "wegwerfmail.de",
    "wegwerfmail.info",
    "wegwerfmail.net",
    "wegwerfmail.org",
    "wegwerpmailadres.nl",
    "wegwrfmail.de",
    "wegwrfmail.net",
    "wegwrfmail.org",
    "wehealasone.cf",
    "wehnerrapids.buzz",
    "weho.monster",
    "wehshee.com",
    "weiborss.com",
    "weibsvolk.de",
    "weibsvolk.org",
    "weighted.reviews",
    "weightlossidealiss.com",
    "weightlossketo.shop",
    "weightlosspak.space",
    "weightlossremedy.icu",
    "weikemm.com",
    "weildasjaklarist.vision",
    "weildworks.org",
    "weimoe.com",
    "weimoe.net",
    "weinenvorglueck.de",
    "weinjobs.org",
    "weipafa.ga",
    "weipafa.tk",
    "weipai.ws",
    "weirenqs.space",
    "weishanghl.com",
    "weishiwave.monster",
    "weissdesignlab.online",
    "weitong001.com",
    "weiwep.us",
    "weixincom1341.xyz",
    "weixyz.com",
    "weiyitou.net",
    "weja.site",
    "welcome33.ru",
    "welcomecitydublin.com",
    "welcometocheap.site",
    "welcoming.ong",
    "weldir.cf",
    "welgati.cf",
    "welgati.ga",
    "welgati.ml",
    "welikecookies.com",
    "well-well.xyz",
    "well108.biz",
    "welldonev.xyz",
    "wellhungup.dynu.net",
    "wellmaek.com",
    "wellmiderg.cf",
    "wellmiderg.ga",
    "wellmiderg.ml",
    "wellmiderg.tk",
    "wellnessanalytics.com",
    "wellnesscentersofnorthtx.com",
    "wellnesscreativemarketing.org",
    "wellnessdom.ru",
    "wellnessgeeksview.com",
    "wellnessmarketing.solutions",
    "wellnessthroughliving.com",
    "wello.systems",
    "wellsauthuserinfo.com",
    "wellsfargoclassactionlawsuit.com",
    "wellsummary.site",
    "wellsupdatenewinfo.com",
    "welltop24.ru",
    "wellys37.ru",
    "weloveketodiet.store",
    "welsh-lady.com",
    "weltentor.info",
    "welypower.com",
    "wem.com",
    "wemel.site",
    "wemel.top",
    "wemoveit2.com",
    "wemzi.com",
    "wencyphrasepedia.com",
    "wendyalper.net",
    "wendyalper.org",
    "wendygoodhealthblog.com",
    "wenegey.ru",
    "wenghuo.com",
    "wenjiong.com",
    "wenku.moe",
    "wenkuapp.com",
    "wensjuweel.online",
    "wensjuweel.site",
    "wentzvilleeyecenter.info",
    "weoieng.space",
    "wepaycashforyourhouses.com",
    "wephrr.us",
    "weprof.it",
    "wer.ez.lv",
    "wer34276869j.ga",
    "wer34276869j.gq",
    "wer34276869j.ml",
    "wer34276869j.tk",
    "werbtghtry007fdgbn.monster",
    "wercessdown.cf",
    "wercessdown.ga",
    "wercessdown.tk",
    "werdiwerp.cf",
    "werdiwerp.ga",
    "werdiwerp.gq",
    "werdiwerp.ml",
    "were-having-a-party.life",
    "werfat.xyz",
    "weritharter.gq",
    "werkprocessen.app",
    "werkr.com",
    "weroityr.ml",
    "werpbuna.ml",
    "werpbuna.tk",
    "wersollesdennsonstmachenaussergutti.vision",
    "wertacy.ga",
    "wertacy.ml",
    "wertdrivatmo.website",
    "wertheforscv.org",
    "wertuoicikax10.site",
    "wertuoicikax11.site",
    "wertuoicikax8.site",
    "wertxdn253eg.cf",
    "wertxdn253eg.ga",
    "wertxdn253eg.gq",
    "wertxdn253eg.ml",
    "wertxdn253eg.tk",
    "werw436526.cf",
    "werw436526.ga",
    "werw436526.gq",
    "werw436526.ml",
    "werw436526.tk",
    "wes-x.net",
    "wesandrianto241.ml",
    "wesatikah407.cf",
    "wesatikah407.ml",
    "wesazalia927.ga",
    "wesd.icu",
    "weselvina200.tk",
    "weseni427.tk",
    "wesfajria37.tk",
    "wesfajriah489.ml",
    "wesgaluh852.ga",
    "weshasni356.ml",
    "weship2you.ru",
    "weshutahaean910.ga",
    "wesjuliyanto744.ga",
    "weskusumawardhani993.ga",
    "wesleyan.edu",
    "wesleymail.com",
    "wesleytatibana.com",
    "wesmubasyiroh167.ml",
    "wesmuharia897.ga",
    "wesnadya714.tk",
    "wesnurullah701.tk",
    "wesruslian738.cf",
    "wessastra497.tk",
    "west-african-energy.com",
    "west-africanenergy.com",
    "west.shop",
    "westayyoung.com",
    "westbendrental.com",
    "westchicagoofficecleaning.com",
    "westconsin.mobi",
    "westerlaken.icu",
    "westernavenuenissanespanol.com",
    "westernbloggen.online",
    "westervilleapartments.com",
    "westin.media",
    "westjeffersonarts.net",
    "westjeffersonweddings.com",
    "westjeffersonweddings.net",
    "westlaketakeaway.com",
    "westleyrichardsstore.com",
    "westlocationserver921.com",
    "westmichiganclones.com",
    "westmontchiropractor.com",
    "westmontphysicaltherapist.com",
    "westmontphysicaltherapyandrehab.com",
    "westmountains.site",
    "westmountains.website",
    "westnet.com",
    "westnet.com.au",
    "westozzie.com",
    "westpointbodrum.xyz",
    "westsacramentodentists.com",
    "westshockey.net",
    "westsideservicecenter.net",
    "weststarrealestate.com",
    "westuckvethospital.com",
    "westvalleyhospice.com",
    "westvalleyhospicecare.com",
    "westvirginiabbb.com",
    "wesw881.ml",
    "weswibowo593.cf",
    "weswidihastuti191.ml",
    "wesyuliyansih469.tk",
    "weszwestyningrum767.cf",
    "wetacompany.ru",
    "wetheprotocol.net",
    "wetrainbayarea.com",
    "wetrainbayarea.org",
    "wetreasureyoursmiles.com",
    "wetteliga25.com",
    "wettish.best",
    "wexdh.info",
    "wexdh.ooo",
    "weyfamily.com",
    "wezo.tech",
    "wf558.com",
    "wfconcepts.info",
    "wfdongyu.com",
    "wfes.site",
    "wfewyibw.shop",
    "wffxtr.site",
    "wfgdfhj.tk",
    "wfggh995.com",
    "wfgoldpin.ru",
    "wfgun.ru",
    "wfjngl.com",
    "wfjsiks854.com",
    "wfmeat.com",
    "wfought0o.com",
    "wfpukr.us",
    "wfrijgt4ke.cf",
    "wfrijgt4ke.ga",
    "wfrijgt4ke.gq",
    "wfrijgt4ke.ml",
    "wfrijgt4ke.tk",
    "wfsbw.com",
    "wfuij1.site",
    "wfupdateauthuser.com",
    "wfupdatenewdev.com",
    "wfwddl.com",
    "wfxegkfrmfvyvzcwjb.cf",
    "wfxegkfrmfvyvzcwjb.ga",
    "wfxegkfrmfvyvzcwjb.gq",
    "wfxegkfrmfvyvzcwjb.ml",
    "wfxegkfrmfvyvzcwjb.tk",
    "wg-replays.online",
    "wg0.com",
    "wg48fr-mail.xyz",
    "wg7aey.us",
    "wgberlin.org",
    "wgbrothers.com",
    "wgc89.com",
    "wgdbwu.site",
    "wgdmensmuscle.com",
    "wgetcu0qg9kxmr9yi.ga",
    "wgetcu0qg9kxmr9yi.ml",
    "wgetcu0qg9kxmr9yi.tk",
    "wgfrankfurt.org",
    "wgfvim.us",
    "wgkfdq.host",
    "wgkoeln.org",
    "wgnyw.info",
    "wgrazd.site",
    "wgweddxy.shop",
    "wgwsgz.tokyo",
    "wh419.site",
    "wh4f.org",
    "wha.la",
    "whaaso.tk",
    "whackedgangsters.com",
    "whackedmobsters.com",
    "whalbum.ru",
    "whale-mail.com",
    "whale-should-cow-stuck.xyz",
    "whalechip.fund",
    "whaletrue.com",
    "whartontx.com",
    "what-the-falafal-dublin.com",
    "whatdaywasthemost.com",
    "whatharam.com",
    "whatiaas.com",
    "whatifanalytics.com",
    "whatifcapital.com",
    "whatifpartners.org",
    "whatisbitcoin.org",
    "whatisforskolin.xyz",
    "whatistrust.org",
    "whatlovers.com",
    "whatpaas.com",
    "whatsaas.com",
    "whatsaduckdo.com",
    "whatshalal.delivery",
    "whatshouldibuypetetoday.com",
    "whatsmyfeed.com",
    "whatsmyspeed.info",
    "whatsnew.events",
    "whatsonmyballot.com",
    "whatsresfa.gq",
    "whatsresfa.ml",
    "whatsresfa.tk",
    "whatsthepointofaventura.com",
    "whatthefeast.com",
    "whatwewant.live",
    "whatworkscsc.org",
    "wheelbalancetraining.net",
    "wheelbarrow.red",
    "wheelemail.com",
    "wheels-club.ru",
    "wheelweb.com",
    "whemmle.xyz",
    "whenex.com",
    "whenkids.ru",
    "whentheycry.com",
    "whenxrp.com",
    "wherebeesmeet.com",
    "whereismyairport.com",
    "whereonrch.space",
    "whereuntil.xyz",
    "whguyr.site",
    "whichfoodsareinseason.com",
    "whidbees.com",
    "whidbey.com",
    "whidbey.net",
    "whiffles.org",
    "whikere.ga",
    "whikere.gq",
    "whimdinil.cf",
    "whimdinil.ga",
    "whimdinil.gq",
    "whimdinil.ml",
    "whimdinil.tk",
    "whipamo.tk",
    "whipmail.com",
    "whirdilt.website",
    "whirlwinds.xyz",
    "whiskeynotes.com",
    "whislmilsfar.cf",
    "whislmilsfar.ga",
    "whislmilsfar.gq",
    "whislmilsfar.ml",
    "whispercities.org",
    "whisperfocus.com",
    "whispersum.com",
    "whitdentezk.com",
    "white-hands.net",
    "white-hands.org",
    "white-oak-brain.com",
    "whitealligator.info",
    "whitearkitekter.us",
    "whiteazurro.com",
    "whitebeachresort.net",
    "whitebearlakeapartments.com",
    "whitebison.info",
    "whiteboss.net",
    "whitebot.ru",
    "whiteboxnetwork.org",
    "whitedentezm.com",
    "whitedentezn.com",
    "whiteflowers.site",
    "whitehat.markets",
    "whitehousemeats.com",
    "whitelabelextracts.org",
    "whitelinehat.com",
    "whitemail.ga",
    "whiteowlcigars.biz",
    "whitepeoplearesoweird.com",
    "whiterhum.com",
    "whitesearch.net",
    "whiteseoromania.tk",
    "whiteskgfv.space",
    "whitespee.icu",
    "whitesteak.com",
    "whitesteaks.com",
    "whitetaildreamsre.com",
    "whiteteeth-tcmpc.com",
    "whitetiger.tools",
    "whiteunit.icu",
    "whiteutt.icu",
    "whitewaterawards.org",
    "whitewro.recipes",
    "whitneyartparty.org",
    "whiz.dev",
    "whizdom.app",
    "whizdom.biz",
    "whizdom.net",
    "whj1wwre4ctaj.ml",
    "whj1wwre4ctaj.tk",
    "whkart.com",
    "whkfyy.com",
    "whkwj.com",
    "whmailtop.com",
    "whnp.us",
    "who95.com",
    "whoamail.co",
    "whocalled.xyz",
    "whodamanny.com",
    "whodj.com",
    "whodj.net",
    "whoever.com",
    "whohq.us",
    "whoisandygrant.com",
    "whoishussainiran.com",
    "whoisless.com",
    "whoisya.com",
    "whole-foods.ru",
    "wholebet3.com",
    "wholecustomdesign.com",
    "wholefitness.com",
    "wholegraincooker.com",
    "wholegrainresources.com",
    "wholeranc.xyz",
    "wholesaleelec.tk",
    "wholesalefavor.com",
    "wholesalepsilocybin.com",
    "wholesn.xyz",
    "wholesna.icu",
    "wholesomebotanical.com",
    "wholesomefamilycooking.com",
    "wholesomeniggamemes.com",
    "wholestee.icu",
    "wholete.xyz",
    "wholetea.xyz",
    "wholewidget.com",
    "whomshoulditip.com",
    "whoold.site",
    "whoopymail.com",
    "whoox.com",
    "whopy.com",
    "whoshoulditip.com",
    "whotravel.ru",
    "whowlft.com",
    "whoyoushouldvotefor.com",
    "whqywc.com",
    "whstores.com",
    "whszum.com",
    "wht004.com",
    "whtjddn.33mail.com",
    "whu.edu.cn",
    "whydelhis.info",
    "whyglu.us",
    "whyiwantout.com",
    "whymustcodes.net",
    "whymustyarz.com",
    "whynotjazz.org",
    "whynottos.info",
    "whyspam.me",
    "whyworkhard.com",
    "whzqozx.site",
    "wi.rr.com",
    "wibblesmith.com",
    "wibu.online",
    "wicepay.org",
    "wichitahometeam.net",
    "wicked-game.cf",
    "wicked-game.ga",
    "wicked-game.gq",
    "wicked-game.ml",
    "wicked-game.tk",
    "wicked-teens.com",
    "wicked.cricket",
    "wickeddvdsales.com",
    "wickedgames.net",
    "wickedmail.com",
    "wickedsecure.net",
    "wickerby.com",
    "wickerbydesign.com",
    "wickerparkdentalil.com",
    "wickmail.net",
    "wicoco.com",
    "wicollar.site",
    "widaryanto.info",
    "widelettings.xyz",
    "wideline-studio.com",
    "widelo.ru",
    "widencatc.buzz",
    "widencycl.xyz",
    "widenequ.email",
    "widenmeta.site",
    "widenvide.xyz",
    "wideopencomputer.com",
    "wideopenwest.com",
    "widerska.ovh",
    "widerwhite.com",
    "wideserv.com",
    "widewhy.com",
    "widewilliam.com",
    "widgepaste.com",
    "widget.gg",
    "widgmit.com",
    "widows.info",
    "widthgaf.email",
    "widthgr.fun",
    "widthgre.recipes",
    "widthmouth.com",
    "wie-zwischen-himmel-und-erde.de",
    "wiebunkgi.ga",
    "wiebunkgi.gq",
    "wiebunkgi.ml",
    "wiebunkgi.tk",
    "wierie.tk",
    "wiersmatenten.frl",
    "wiesekey.com",
    "wifesutensils.com",
    "wifi-boost.shop",
    "wifi-map.net",
    "wifi-surge.com",
    "wiganfans.co.uk",
    "wighn.icu",
    "wigo4d.net",
    "wigoclub.net",
    "wigolive.com",
    "wihalfpricelistings.com",
    "wikaya.org",
    "wiki.8191.at",
    "wiki24.ga",
    "wiki24.ml",
    "wikiafterdark.com",
    "wikibola.net",
    "wikidocuslava.ru",
    "wikifar.com",
    "wikilibhub.ru",
    "wikilimpieza.com",
    "wikipedia-inc.cf",
    "wikipedia-inc.ga",
    "wikipedia-inc.gq",
    "wikipedia-inc.ml",
    "wikipedia-inc.tk",
    "wikipedia-llc.cf",
    "wikipedia-llc.ga",
    "wikipedia-llc.gq",
    "wikipedia-llc.ml",
    "wikipedia-llc.tk",
    "wikiserie.online",
    "wikiserie.org",
    "wikiserie.website",
    "wikisite.co",
    "wikitunner.com",
    "wiklysale.online",
    "wikuiz.com",
    "wil.kr",
    "wilayone.com",
    "wilbrahamhomevalue.com",
    "wilbrahammahomevalue.com",
    "wilburnbuckingbulls.com",
    "wild-game.ru",
    "wild.wiki",
    "wildbeard.ru",
    "wildblue.net",
    "wildbluepublishing.com",
    "wildcardstudio.art",
    "wildfilms.ru",
    "wildlifepen.com",
    "wildmail.com",
    "wildmountainseed.com",
    "wildorqwpr.space",
    "wildorqwpr.website",
    "wildrasthr.space",
    "wildsusta.ml",
    "wildwildweb.dk",
    "wilemail.com",
    "wiliserie.club",
    "wiliserie.host",
    "wiliserie.online",
    "wiliserie.org",
    "wiliserie.site",
    "wiliserie.website",
    "wiliserie.xyz",
    "wilkeaardema.info",
    "wilkinsonms.com",
    "wilkun.xyz",
    "will-hier-weg.de",
    "will-yum.com",
    "willemwakker.com",
    "willhackforfood.biz",
    "william-tell-ballistics.com",
    "williamcastillo.me",
    "williamkew.com",
    "williamkhalick.realtor",
    "williamrobinson.buzz",
    "williamsburgisforgolflovers.com",
    "williatkte.space",
    "williaucvu.space",
    "willloc.com",
    "willner-ventures.com",
    "willosel.ga",
    "willosel.gq",
    "willosel.ml",
    "willosel.tk",
    "willowclothing.shop",
    "willowhavenhome.com",
    "willowkleding.online",
    "willowkleding.shop",
    "willowmattresses.com",
    "willowtreeddental.com",
    "willrazsi.cf",
    "willrazsi.ga",
    "willrazsi.gq",
    "willrazsi.ml",
    "willrazsi.tk",
    "wills.guru",
    "willselfdestruct.com",
    "willymailly.com",
    "willypopper.com",
    "wilmatalks.se",
    "wilmhba.com",
    "wilmingtonrealestateagents.com",
    "wilon0706384.xyz",
    "wilon3000018.xyz",
    "wilon3631867.xyz",
    "wilon3951350.xyz",
    "wilon4461641.xyz",
    "wilon5707450.xyz",
    "wilon6097856.xyz",
    "wilon6322863.xyz",
    "wilon6478376.xyz",
    "wilon6702026.xyz",
    "wilon7053973.xyz",
    "wilon7746360.xyz",
    "wilon9533166.xyz",
    "wilon9600861.xyz",
    "wilon9602154.xyz",
    "wilon9630049.xyz",
    "wilon9634055.xyz",
    "wilon9634558.xyz",
    "wilon9649506.xyz",
    "wilon9651371.xyz",
    "wilon9658322.xyz",
    "wilon9674110.xyz",
    "wilon9676273.xyz",
    "wilon9691114.xyz",
    "wilon9698394.xyz",
    "wilon9711272.xyz",
    "wilon9714738.xyz",
    "wilon9714965.xyz",
    "wilon9739931.xyz",
    "wilon9756029.xyz",
    "wilon9757869.xyz",
    "wilon9759538.xyz",
    "wilon9782174.xyz",
    "wilon9783874.xyz",
    "wilon9819104.xyz",
    "wilon9825173.xyz",
    "wilon9830966.xyz",
    "wilon9859733.xyz",
    "wilon9955293.xyz",
    "wilon9978419.xyz",
    "wilroptit.xyz",
    "wilson-hsu.com",
    "wilsonsaberdare.com",
    "wilsonsleather.info",
    "wimsg.com",
    "win-123.com",
    "win-777.net",
    "win-bet.space",
    "win-cool-prizes-today.buzz",
    "win-get.online",
    "win-reward-award-national.club",
    "win-win-win-win-win-win.site",
    "win-winto.site",
    "win-your.site",
    "win4d.online",
    "win789.net",
    "win9rolet.xyz",
    "winallinpro.xyz",
    "winalways.ru",
    "winandplay.com",
    "winaniphone7.info",
    "winbro.online",
    "wincep.com",
    "windharpswindchimes.com",
    "windmaweek.cf",
    "windmaweek.ga",
    "windmaweek.gq",
    "windmaweek.ml",
    "windowconfigurator.com",
    "windowsdedicatedserversindia.com",
    "windowshelpme.ru",
    "windowslive.com",
    "windowsmanageddedicatedserver.com",
    "windowsmembership.com",
    "windowsresellerwebhostinginindia.com",
    "windowsunlimitedwebhosting.com",
    "windrivers.net",
    "windrow.xyz",
    "windsandfa.cf",
    "windsandfa.ga",
    "windsandfa.tk",
    "windscribe.lol",
    "windscribe.wtf",
    "windscribeindir.com",
    "windscriber.com",
    "windshieldrepairtech.com",
    "windsorrealestateagents.com",
    "windstream.com",
    "windstream.net",
    "windytransit.com",
    "winecorkus.com",
    "winedaddy.com",
    "winemail.net",
    "winemaven.in",
    "winemaven.info",
    "winesoda.com",
    "winetastingdriver.net",
    "winetastingdrivers.net",
    "winetypeslist.com",
    "winfire.com",
    "winfirst.com",
    "winfreegifts.xyz",
    "winftime.cf",
    "winftime.ml",
    "winftime.tk",
    "winginus.xyz",
    "wingnutz.com",
    "wingspkr.net",
    "wingybubble.icu",
    "winifi.info",
    "wink-scrubs.com",
    "winkuniformscrubs.com",
    "winliga365.tips",
    "winline-bonus.ru",
    "winlinee.ru",
    "winmail.com.au",
    "winmail.world",
    "winmails.net",
    "winmiosports.com",
    "winner-foryour-prizes11.life",
    "winner-win.site",
    "winneroqqld.email",
    "winnersom.space",
    "winnersom7.space",
    "winnersqa7.space",
    "winnersstores.com",
    "winnerto.site",
    "winneryourprize-supergut1.life",
    "winniejames.com",
    "winning.com",
    "winning365.social",
    "winnipegeventvideo.com",
    "winnipegvideorecording.com",
    "winnweb.net",
    "winnweb.win",
    "winong.top",
    "winonlinerewards9.site",
    "winoptimizer.com",
    "winpayawardnational.club",
    "winplay303.com",
    "winpupe.cf",
    "winpupe.ga",
    "winregion.com",
    "winrere.xyz",
    "winrewardawardnational.club",
    "winrz.com",
    "wins.com.br",
    "wins.vote",
    "winsdar.com",
    "winslot97.net",
    "winsrezde.ga",
    "winsrezde.gq",
    "winsrezde.ml",
    "winsrezde.tk",
    "winstanleyspramworld.com",
    "winteries.xyz",
    "winterize843tp.online",
    "wintershop.icu",
    "wintopaywin.fun",
    "wintopaywin.host",
    "wintopaywin.press",
    "wintopaywin.space",
    "wintopaywin.xyz",
    "wintowin18.com",
    "wintowinz.site",
    "winwin-77.net",
    "winwin.realestate",
    "winwincool.site",
    "winwincool.website",
    "winwinni.site",
    "winwinus.xyz",
    "wipaffillate.com",
    "wipbet400.com",
    "wipbet73.com",
    "wipesshop.live",
    "wir-haben-nachwuchs.de",
    "wir-sind-cool.org",
    "wira6d.info",
    "wirasempana.com",
    "wirawan.cf",
    "wirawanakhmadi.cf",
    "wirebrush.biz",
    "wirebrush.us",
    "wirebrushes.us",
    "wired-usa.com",
    "wiredlifemag.com",
    "wiredlifemagazine.com",
    "wiredlivingmag.com",
    "wiredlivingmagazine.com",
    "wirednyc.com",
    "wiredparis.com",
    "wirepark.us",
    "wirkoennenjaauchgleichmckinseyanheuernwennssoweitergeht.vision",
    "wirlwide.com",
    "wirsindcool.de",
    "wirsindneuland.vision",
    "wirull.site",
    "wirwollenkeingelabermehr.vision",
    "wirwox.com",
    "wisatajogja.xyz",
    "wisataoperasiplastik.com",
    "wisbuy.shop",
    "wisconsincomedy.com",
    "wisconsinlakehomefinder.com",
    "wisdomtime-healthmethod.com",
    "wise-07.com",
    "wiserspots.com",
    "wisewad.net",
    "wisfkzmitgxim.cf",
    "wisfkzmitgxim.ga",
    "wisfkzmitgxim.gq",
    "wisfkzmitgxim.ml",
    "wisfkzmitgxim.tk",
    "wish-shoponline.info",
    "wishan.net",
    "wishboneengineering.se",
    "wisheswide.com",
    "wispkz.ga",
    "wit.coffee",
    "witchermedallion.ru",
    "witecollar.site",
    "witel.com",
    "with-u.us",
    "withapi.net",
    "withlove.sk",
    "withlovedenise.com",
    "withsflussurf.ga",
    "withsflussurf.tk",
    "withspark.com",
    "withstar.se",
    "wittenbergpartnership.com",
    "wittfest.net",
    "witty.com",
    "wity.site",
    "wityjs.com",
    "wiu.edu",
    "wix.creou.dev",
    "wix.ptcu.dev",
    "wixgdu.info",
    "wiz.cc",
    "wiz2.site",
    "wizerco.org",
    "wizkids.co.uk",
    "wizzcar.space",
    "wj5514.com",
    "wj5517.com",
    "wj7qzenox9.cf",
    "wj7qzenox9.ga",
    "wj7qzenox9.gq",
    "wj7qzenox9.ml",
    "wj7qzenox9.tk",
    "wjblw.info",
    "wjhndxn.xyz",
    "wjjxxlib.com",
    "wjkyw.info",
    "wjs1001.com",
    "wjs1006.com",
    "wjs1007.com",
    "wjs1009.com",
    "wjzldt.us",
    "wk5btj.info",
    "wk853.com",
    "wkbmcw.fun",
    "wkbmwf.fun",
    "wkbwmail.com",
    "wkcqw.info",
    "wkd0as.info",
    "wkdmyq.fun",
    "wkernl.com",
    "wkgmbb.fun",
    "wkhaiii.cf",
    "wkhaiii.ga",
    "wkhaiii.gq",
    "wkhaiii.ml",
    "wkhaiii.tk",
    "wkhmsr.fun",
    "wklik.com",
    "wkmmzn.fun",
    "wknmfp.fun",
    "wkobe.us",
    "wkpmjm.fun",
    "wkpmxt.fun",
    "wkqmgq.fun",
    "wkrmwr.fun",
    "wkschemesx.com",
    "wksmdn.fun",
    "wktmpq.fun",
    "wktmxd.fun",
    "wkuteraeus.xyz",
    "wkzmnp.fun",
    "wkzrw.info",
    "wla2d.info",
    "wla2d.net",
    "wla2d.xyz",
    "wla9c4em.com",
    "wladyslawa.xyz",
    "wletu1.site",
    "wlht8w.info",
    "wlist.ro",
    "wljia.com",
    "wljkj3.com",
    "wljycs.online",
    "wloahs.icu",
    "wlpyt.com",
    "wlvwv.us",
    "wlwzvd.tokyo",
    "wm335.com",
    "wm336.com",
    "wm5x.us",
    "wm88th.com",
    "wmail.cf",
    "wmail.club",
    "wmail.tk",
    "wmail1.com",
    "wmail2.com",
    "wmail2.net",
    "wmaqw.space",
    "wmbadszand2varyb7.cf",
    "wmbadszand2varyb7.ga",
    "wmbadszand2varyb7.gq",
    "wmbadszand2varyb7.ml",
    "wmbadszand2varyb7.tk",
    "wmcsale.top",
    "wmesale.top",
    "wmgame88.com",
    "wmik.de",
    "wmjqzp.us",
    "wmlorgana.com",
    "wmpezacn.shop",
    "wmrmail.com",
    "wmux.ru",
    "wmwha0sgkg4.ga",
    "wmwha0sgkg4.ml",
    "wmwha0sgkg4.tk",
    "wmxhj3.us",
    "wmzgen.ru",
    "wmzgjewtfudm.cf",
    "wmzgjewtfudm.ga",
    "wmzgjewtfudm.gq",
    "wmzgjewtfudm.ml",
    "wmzgjewtfudm.tk",
    "wn01kb.xyz",
    "wn3wq9irtag62.cf",
    "wn3wq9irtag62.ga",
    "wn3wq9irtag62.gq",
    "wn3wq9irtag62.ml",
    "wn3wq9irtag62.tk",
    "wn8c38i.com",
    "wnacg.xyz",
    "wncbigfoot.com",
    "wncbigfoot.info",
    "wndcw.info",
    "wnextaudit.com",
    "wnptdb.com",
    "wns777.info",
    "wnsymb.us",
    "wntmw.info",
    "wnu8lg.us",
    "wnvpedwag.shop",
    "wnyrcfl.org",
    "wo-gg.com",
    "wo.com.cn",
    "wo295ttsarx6uqbo.cf",
    "wo295ttsarx6uqbo.ga",
    "wo295ttsarx6uqbo.gq",
    "wo295ttsarx6uqbo.ml",
    "wo295ttsarx6uqbo.tk",
    "wo52ni.com",
    "woae0g.site",
    "wobblysausage.site",
    "woberim.live",
    "wobvmihyy.shop",
    "woc-news.ru",
    "wocowstore.com",
    "wocy.info",
    "wodeyars.com",
    "wodtorec.cf",
    "wodtorec.ml",
    "wodtorec.tk",
    "wodtrials.com",
    "wodulaw.com",
    "wody.site",
    "wofa0.com",
    "wofeshops.site",
    "wofsrm6ty26tt.cf",
    "wofsrm6ty26tt.ga",
    "wofsrm6ty26tt.gq",
    "wofsrm6ty26tt.ml",
    "wofsrm6ty26tt.tk",
    "woh.rr.com",
    "wohbjs.online",
    "wohiza.info",
    "wohlbarkfeeb.cf",
    "wohlbarkfeeb.ga",
    "wohlbarkfeeb.ml",
    "wohlbarkfeeb.tk",
    "wohoho.xyz",
    "woikalsderf.tk",
    "wokanguode.com",
    "wokcy.com",
    "wokecus.com",
    "woktowalk-tallaght.com",
    "wolaf.com",
    "wolbac.club",
    "wolbettv3.com",
    "wolbettv4.com",
    "wolbettv5.com",
    "wolbettv6.com",
    "wolbettv9.com",
    "wolckano24.website",
    "wolcottelderlawgroup.com",
    "wolf-web.com",
    "wolff00.xyz",
    "wolfmail.ml",
    "wolfmedia.solutions",
    "wolfmission.com",
    "wolfnetworksecurity.com",
    "wolfslag.info",
    "wolfsmail.ml",
    "wolfsmail.tk",
    "wolfsmails.tk",
    "wolfyx.xyz",
    "wolij1.club",
    "wolitwo.club",
    "wolke7.net",
    "wollan.info",
    "wolljk.club",
    "wolukieh89gkj.tk",
    "wolukiyeh88jik.ga",
    "wolurem.ru",
    "wolven.xyz",
    "wolverinebaseball.us",
    "womackautomation.com",
    "woman-blog-list.info",
    "woman2019.ru",
    "womanolog.ru",
    "womanshealth.online",
    "wombles.com",
    "women-at-work.org",
    "women-g.ru",
    "women-only.net",
    "womenbay.ru",
    "womenbox.ru",
    "womenhealthcare.ooo",
    "womeninaccountancyawards.com",
    "womenklab.ru",
    "womenofjewelry.online",
    "womenoutfitters.xyz",
    "womens.vote",
    "womensmentalhealthcenters.com",
    "womenssubstanceabusetreatmentprograms.com",
    "womenstuff.icu",
    "womenstuff.xyz",
    "womenvetsrun.com",
    "womenvetsrun.org",
    "wommangotobuy.site",
    "womxht.us",
    "wonaffiliate.com",
    "wonder-net.com",
    "wonderfulgifts.ru",
    "wonderouz.com",
    "wonderphotobooth.site",
    "wondersteri.com",
    "wonderstwo.top",
    "wongfaye.com",
    "wongndeso.gq",
    "wongplay.com",
    "wonlexofficial.ru",
    "wonodds41.com",
    "wonodds87.com",
    "wonwwf.com",
    "woodblittde.cf",
    "woodblittde.ga",
    "woodblittde.tk",
    "woodbridgeelderlawgroup.com",
    "woodchristmasornaments.com",
    "woodecorfurniture.com",
    "woodfrek.tk",
    "woodgribla.gq",
    "woodgribla.tk",
    "woodlandplace.info",
    "woodlandplumbers.com",
    "woodlandsnashville.us",
    "woodmachinery-group.ru",
    "woodmillcafe.com",
    "woodoostudio.ru",
    "woodroastedcoffee.store",
    "woodwilder.com",
    "woodwindshop.life",
    "woodworkingforum.life",
    "woodykit43.ru",
    "woodzone.info",
    "woofee.ru",
    "woollens.ru",
    "woolop.best",
    "woolyburger.com",
    "woonq.info",
    "wooow.it",
    "wooricasino.shop",
    "woosh.co.nz",
    "woosha.se",
    "wootap.me",
    "wopc.cf",
    "wopcmtdnqr.space",
    "wopizza.ru",
    "worcesterbaseballclub.com",
    "worcesterpartnership.com",
    "word-literature.xyz",
    "word.monster",
    "wordfromthebirdblog.com",
    "wordme.stream",
    "wordmedia.site",
    "wordpress.com",
    "wordsajtg.ru",
    "wordsorcerer.com",
    "wordsyimages.com",
    "work-info.ru",
    "work-is-play.com",
    "work4teens.com",
    "work4uber.us",
    "work66.ru",
    "workcareer.site",
    "workcareer.today",
    "workconsfun.ga",
    "workconsfun.gq",
    "workconsfun.ml",
    "workconsfun.tk",
    "workdinser.ru",
    "workemail5.ru",
    "worker.com",
    "workersunity.org",
    "workfast24.ru",
    "workflowtest.xyz",
    "workflowy.club",
    "workflowy.cn",
    "workflowy.top",
    "workflowy.work",
    "workfromhome365.org",
    "workfromhomegroups.com",
    "workhard.by",
    "workingzlq.space",
    "worklists.ru",
    "workmail.co.za",
    "workmail.com",
    "workmail.life",
    "worknetli.cf",
    "worknetli.gq",
    "worknetli.ml",
    "workplacemoodle.info",
    "workplacemoodle.org",
    "worksctory.email",
    "workshopbrouwen.com",
    "workshopwha.email",
    "worksmail.cf",
    "worksmail.ga",
    "worksmail.gq",
    "worksmail.ml",
    "worksmail.tk",
    "worksoho.cf",
    "worksoho.ga",
    "worksoho.gq",
    "worksoho.ml",
    "worksoho.tk",
    "worktgfkcwt.email",
    "worktogetherbetter.com",
    "workwolf.fun",
    "workwolf.host",
    "workwolf.site",
    "world-champion.ru",
    "world-news-pers.site",
    "world-sale.ru",
    "world-surprising.ru",
    "world-travel.online",
    "world4ch.org",
    "worldatnet.com",
    "worldawaits.org",
    "worldbestoliveoils.com",
    "worldbibleschool.name",
    "worldbreak.com",
    "worldcenter.ru",
    "worldcoinmap.online",
    "worldcoinmap.xyz",
    "worldcpa.ru",
    "worldcup2019-10.xyz",
    "worldcup2019-11.xyz",
    "worldcup2019-12.xyz",
    "worldcup2019-13.xyz",
    "worldcup2019-14.xyz",
    "worldcup2019-15.xyz",
    "worldcup2019-16.xyz",
    "worldcup2019-17.xyz",
    "worldcup2019-18.xyz",
    "worldcup2019-2.xyz",
    "worldcup2019-21.xyz",
    "worldcup2019-23.xyz",
    "worldcup2019-24.xyz",
    "worldcup2019-3.xyz",
    "worldcup2019-5.xyz",
    "worldcup2019-6.xyz",
    "worldcup2019-7.xyz",
    "worldcup2019-8.xyz",
    "worlddidac.com",
    "worlddonation.org",
    "worldemail.com",
    "worldfinanceloancompany.host",
    "worldfowheels.com",
    "worldgovernmentsummit.media",
    "worldimprovementlabs.org",
    "worldinvent.com",
    "worldjournal.info",
    "worldlivecams.com",
    "worldluckyclubwons.ru",
    "worldmailer.com",
    "worldmuz.org",
    "worldnet.att.net",
    "worldnewstoday.ru",
    "worldof.works",
    "worldof17hats.com",
    "worldofeasier.com",
    "worldofgamedesign.com",
    "worldofrichworks.com",
    "worldofzoe.com",
    "worldopros3-ml.fun",
    "worldpetcare.cf",
    "worldrabiesday.asia",
    "worldrabiesday.net",
    "worldrabiesday.tel",
    "worldrevolution.info",
    "worldsbestever.company",
    "worldsbestoliveoil.org",
    "worldsbestoliveoils.com",
    "worldsonlineradios.com",
    "worldspace.link",
    "worldsquare.sydney",
    "worldstarbetting7.com",
    "worldstarbetting8.com",
    "worldtaxback.com",
    "worldturinfo.ru",
    "worldw88.com",
    "worldwideprayerchain.org",
    "worldwideviews.ru",
    "worldwidewholesale.company",
    "worldwidewholesalecompany.com",
    "worlhydlo.cf",
    "worlhydlo.ml",
    "worlhydlo.tk",
    "worllofa.ga",
    "worllofa.gq",
    "worllofa.ml",
    "worllofa.tk",
    "worlsiftfil.ga",
    "worlsiftfil.gq",
    "worlsiftfil.ml",
    "wormbrand.net",
    "wormikj12.xyz",
    "wormseo.cn",
    "wormusiky.ru",
    "wornbyacelebrity.com",
    "worrybr.icu",
    "worrybre.xyz",
    "worrycro.xyz",
    "worrygrav.site",
    "worryunc.xyz",
    "worrywas.xyz",
    "worrywh.xyz",
    "worse-than.tv",
    "worstautos.info",
    "worthitmarketing.com",
    "worthniza.cf",
    "worthniza.ga",
    "worthniza.gq",
    "worthniza.ml",
    "worthshake.email",
    "worthtri.recipes",
    "worthwre.com",
    "wortsesfa.ga",
    "wortsesfa.gq",
    "wortsesfa.ml",
    "worxsites.net",
    "wosaddict.com",
    "wosostand.site",
    "wossm.site",
    "wot-booster.ru",
    "wot-replay.online",
    "wotgjv.site",
    "would-battle-toy-cheese.xyz",
    "would.dev",
    "wouldilie.com",
    "woundje.icu",
    "woundy.site",
    "wovfkp.icu",
    "wovz.cu.cc",
    "wow-h2.com",
    "wow-logic.com",
    "wow-tb.com",
    "wow.com",
    "wow.royalbrandco.tk",
    "wowbd.fun",
    "wowchina.club",
    "wowclassicbot.com",
    "wowcorp.com",
    "wowgirl.com",
    "wowgoldy.cz",
    "wowgrill.ru",
    "wowgua.com",
    "wowhair.ru",
    "wowhundred.com",
    "wowico.org",
    "wowishop.ru",
    "wowizmir.com",
    "wowjk.site",
    "wowklas.site",
    "wowlogik.com",
    "wowmail.com",
    "wowmail.gq",
    "wowmyksd.gq",
    "wowokan.com",
    "wowosp.xyz",
    "wowsale.website",
    "wowthis.space",
    "wowway.com",
    "woxvf3xsid13.cf",
    "woxvf3xsid13.ga",
    "woxvf3xsid13.gq",
    "woxvf3xsid13.ml",
    "woxvf3xsid13.tk",
    "wp-admins.com",
    "wp-ap.com",
    "wp-coop.net",
    "wp-global.ru",
    "wp.company",
    "wp.eu",
    "wp.pl",
    "wp2romantic.com",
    "wp485k.us",
    "wp568.com",
    "wpaimj.us",
    "wpbbq.dev",
    "wpbinaq3w7zj5b0.cf",
    "wpbinaq3w7zj5b0.ga",
    "wpbinaq3w7zj5b0.ml",
    "wpbinaq3w7zj5b0.tk",
    "wpblogbuilders.com",
    "wpbsw.info",
    "wpcrash.site",
    "wpdeveloperguides.com",
    "wpdfs.com",
    "wpeopwfp099.tk",
    "wperts.com",
    "wpflsp.xyz",
    "wpg.im",
    "wphacks.online",
    "wpjigg.best",
    "wpkg.de",
    "wpkppihh.shop",
    "wplusley.site",
    "wpmail.org",
    "wpondersteuning.com",
    "wpower.info",
    "wppremiumclub.com",
    "wpredis.com",
    "wpservices.expert",
    "wpstorage.org",
    "wptamail.com",
    "wputils.online",
    "wpwjlr.site",
    "wpxlgh.site",
    "wqh0o.us",
    "wqqkg5.com",
    "wqsaunas.com",
    "wqwhw.info",
    "wqxhasgkbx88.cf",
    "wqxhasgkbx88.ga",
    "wqxhasgkbx88.gq",
    "wqxhasgkbx88.ml",
    "wqxhasgkbx88.tk",
    "wqypw.info",
    "wr.moeri.org",
    "wr29zi.us",
    "wr9v6at7.com",
    "wracesis.cf",
    "wracesis.gq",
    "wracesis.tk",
    "wracked.space",
    "wralawfirm.com",
    "wraped.net",
    "wrappedinit.com",
    "wrappedstudio.com",
    "wrapplese.ru",
    "wrcbsaei.shop",
    "wrdtme.us",
    "wrenchenbt.space",
    "wrestlingpages.com",
    "wrexham.net",
    "wrf7vx.info",
    "wrgs.icu",
    "wrinadstal.cf",
    "wrinadstal.gq",
    "wrinadstal.tk",
    "wristawf.icu",
    "wristpl.icu",
    "wristpla.icu",
    "wristqueen.recipes",
    "wristwast.xyz",
    "wristwidt.com",
    "writability.net",
    "writegoodessay.website",
    "writehag.ga",
    "writeme.com",
    "writeme.us",
    "writeme.xyz",
    "writemeback.com",
    "writemyessays.onl",
    "writemypaper.onl",
    "writenownote.com",
    "writeremail.com",
    "writersefx.com",
    "writesthisblog.com",
    "writingforpennies.pro",
    "writsenle.cf",
    "writsenle.ga",
    "writsenle.ml",
    "wrld.community",
    "wrlnewstops.space",
    "wrlxw.info",
    "wroc.space",
    "wrongfuldeathattorneyct.com",
    "wronggrin.space",
    "wronghead.com",
    "wrongli.xyz",
    "wrongmail.com",
    "wronsu.com",
    "wrpd4y.us",
    "wrqbw.info",
    "wrysutgst57.ga",
    "ws.gy",
    "wsacommunications.com",
    "wsap.site",
    "wsb-delta.ru",
    "wsbclusterdelta.ru",
    "wsbdelta.ru",
    "wsbet.info",
    "wscu73sazlccqsir.cf",
    "wscu73sazlccqsir.ga",
    "wscu73sazlccqsir.gq",
    "wscu73sazlccqsir.ml",
    "wscu73sazlccqsir.tk",
    "wsdbet88.net",
    "wsen1.ru",
    "wsfjtyk29-privtnyu.fun",
    "wsfjtyk29-privtnyu.host",
    "wsfjtyk29-privtnyu.site",
    "wsfjtyk29-privtnyu.website",
    "wsfjtyk29-privtnyu.xyz",
    "wsfr.luk2.com",
    "wsh1q4.us",
    "wsh72eonlzb5swa22.cf",
    "wsh72eonlzb5swa22.ga",
    "wsh72eonlzb5swa22.gq",
    "wsh72eonlzb5swa22.ml",
    "wsh72eonlzb5swa22.tk",
    "wsiconsultant.com",
    "wsifenetondr.host",
    "wsimediagroup.com",
    "wsimiami.com",
    "wsiyb.com",
    "wsmeu.com",
    "wsodrg.us",
    "wsqaxdezxc.net",
    "wsswoodstock.com",
    "wsswoodstock.xyz",
    "wstc8d.us",
    "wsuoptimize.org",
    "wswseo.com",
    "wswsw.info",
    "wt-rus.ru",
    "wt0vkmg1ppm.cf",
    "wt0vkmg1ppm.ga",
    "wt0vkmg1ppm.gq",
    "wt0vkmg1ppm.ml",
    "wt0vkmg1ppm.tk",
    "wt2.orangotango.cf",
    "wtcnoida2.com",
    "wtdmugimlyfgto13b.cf",
    "wtdmugimlyfgto13b.ga",
    "wtdmugimlyfgto13b.gq",
    "wtdmugimlyfgto13b.ml",
    "wtdmugimlyfgto13b.tk",
    "wteoq7vewcy5rl.cf",
    "wteoq7vewcy5rl.ga",
    "wteoq7vewcy5rl.gq",
    "wteoq7vewcy5rl.ml",
    "wteoq7vewcy5rl.tk",
    "wtf-man.net",
    "wtfdesign.ru",
    "wtflagu.bid",
    "wtfzbg.ml",
    "wtguns.com",
    "wth0v.us",
    "wtic.de",
    "wtnw4.us",
    "wtprlf.com",
    "wtransit.ru",
    "wtrckhertz.com",
    "wtskw.info",
    "wttmw.info",
    "wtu1sv.us",
    "wtudeevd.shop",
    "wtvhmail.com",
    "wu138.club",
    "wu138.top",
    "wu158.club",
    "wu158.top",
    "wu189.top",
    "wu2vf.site",
    "wu8vx48hyxst.cf",
    "wu8vx48hyxst.ga",
    "wu8vx48hyxst.gq",
    "wu8vx48hyxst.ml",
    "wu8vx48hyxst.tk",
    "wucaitang.com",
    "wudet.men",
    "wudtee.online",
    "wuespdj.xyz",
    "wueycgwuyebc.club",
    "wufoshops.site",
    "wufuya.com",
    "wuhl.de",
    "wuhuw.com",
    "wujaze.info",
    "wuji37.com",
    "wuji38.com",
    "wuji39.com",
    "wujlsahrr.shop",
    "wujy.site",
    "wulcaner24.website",
    "wum5sr-mail.xyz",
    "wunderkraut.ru",
    "wunschbaum.info",
    "wunvdh.xyz",
    "wupics.com",
    "wurasu.info",
    "wurer.live",
    "wusrmp.best",
    "wuvamarket.site",
    "wuvoo.com",
    "wuwaqu.info",
    "wuwnxia.xyz",
    "wuxoby.ru",
    "wuxoshop.site",
    "wuxq.xyz",
    "wuyc41hgrf.cf",
    "wuyc41hgrf.ga",
    "wuyc41hgrf.gq",
    "wuyc41hgrf.ml",
    "wuyc41hgrf.tk",
    "wuyebcuywebc.club",
    "wuyecili.net",
    "wuyecuwyec.club",
    "wuzhou333.com",
    "wuzup.net",
    "wuzupmail.net",
    "wv4t2k.info",
    "wvgtc.us",
    "wvhalfpricedlisting.com",
    "wvhalfpricelisting.com",
    "wvipapp.com",
    "wvjmpysbh.shop",
    "wvl238skmf.com",
    "wvmih7.site",
    "wvppz7myufwmmgh.cf",
    "wvppz7myufwmmgh.ga",
    "wvppz7myufwmmgh.gq",
    "wvppz7myufwmmgh.ml",
    "wvppz7myufwmmgh.tk",
    "wvpzbsx0bli.cf",
    "wvpzbsx0bli.ga",
    "wvpzbsx0bli.gq",
    "wvpzbsx0bli.ml",
    "wvpzbsx0bli.tk",
    "wvrbee.org",
    "wvrdwomer3arxsc4n.cf",
    "wvrdwomer3arxsc4n.ga",
    "wvrdwomer3arxsc4n.gq",
    "wvrdwomer3arxsc4n.tk",
    "wvulm5.us",
    "wvv360.com",
    "wvw3421.com",
    "ww-ww.su",
    "ww00.com",
    "ww00bb.com",
    "ww00ee.com",
    "ww00ii.com",
    "ww00qq.com",
    "ww00xx.com",
    "ww1775.com",
    "ww33aa.com",
    "ww33ii.com",
    "ww33qq.com",
    "ww33vv.com",
    "ww33zz.com",
    "wwah.org",
    "wwatme7tpmkn4.cf",
    "wwatme7tpmkn4.ga",
    "wwatme7tpmkn4.gq",
    "wwatme7tpmkn4.tk",
    "wwcp0000.com",
    "wwcuh5.us",
    "wwdd22.com",
    "wwdg.com",
    "wwee00.com",
    "wwfontsele.com",
    "wwhbvoic.shop",
    "wwii-1940s.com",
    "wwii00.com",
    "wwikiyas.site",
    "wwjj55.com",
    "wwjltnotun30qfczaae.cf",
    "wwjltnotun30qfczaae.ga",
    "wwjltnotun30qfczaae.gq",
    "wwjltnotun30qfczaae.ml",
    "wwjltnotun30qfczaae.tk",
    "wwkk00.com",
    "wwkk55.com",
    "wwmails.com",
    "wwnewstop.site",
    "wwordbridgeg.site",
    "wwordcluba.site",
    "wworddogn.site",
    "wwpshop.com",
    "wwqysw.com",
    "wwrmails.com",
    "wwstockist.com",
    "wwsww.info",
    "wwvhaosou.com",
    "www-011usafuspzporpuss01.xyz",
    "www-0419.com",
    "www-123movies.best",
    "www-3886.com",
    "www-49149.com",
    "www-5875k.com",
    "www-5875n.com",
    "www-5875r.com",
    "www-5875x.com",
    "www-5875y.com",
    "www-5875z.com",
    "www-733555.com",
    "www-88591.com",
    "www-9424.com",
    "www-9908818.com",
    "www-9968818.com",
    "www-bm1234.com",
    "www-cx888.com",
    "www-hk09.com",
    "www-hk288.com",
    "www-ky5500.com",
    "www-lr888.com",
    "www-odqp.com",
    "www-putlockers.best",
    "www.barryogorman.com",
    "www.bccto.com",
    "www.bccto.me",
    "www.com",
    "www.cqnhtgs.top",
    "www.dmtc.edu.pl",
    "www.e4ward.com",
    "www.eairmail.com",
    "www.gishpuppy.com",
    "www.live.co.kr.beo.kr",
    "www.mailinator.com",
    "www.redpeanut.com",
    "www111elexbet.xyz",
    "www111gao.com",
    "www11rsx.net",
    "www188gao.com",
    "www2000.net",
    "www22rsx.com",
    "www24ruru.com",
    "www25ruru.com",
    "www33rsx.com",
    "www41ruru.com",
    "www44rsx.net",
    "www55rsx.com",
    "www55rsx.net",
    "www6234.net",
    "www700ruru.com",
    "www77rsx.com",
    "www800ruru.com",
    "www880883.com",
    "www99rsx.com",
    "www99rsx.net",
    "wwwap.ru",
    "wwwblooom.com",
    "wwwbm1234.com",
    "wwwbox.tk",
    "wwwbrightscope.com",
    "wwwcruiseone.com",
    "wwweaglerider.com",
    "wwweb.cf",
    "wwweb.ga",
    "wwwerincondren.com",
    "wwwerr.com",
    "wwwfiserv.com",
    "wwwh567.com",
    "wwwhaodiaonv.com",
    "wwwhaodiaopao.com",
    "wwwhk09.com",
    "wwwht.com",
    "wwwlh8828.com",
    "wwwlr888.com",
    "wwwmail.gq",
    "wwwmetatrader5.com",
    "wwwmontanatitle.info",
    "wwwncslenders.net",
    "wwwnew.de",
    "wwwnew.eu",
    "wwwpao00.com",
    "wwwpapa26.com",
    "wwwpapa39.com",
    "wwwpapa57.com",
    "wwwplacertitle.mobi",
    "wwwprclosings.net",
    "wwwprepscholar.com",
    "wwwptanow.us",
    "wwwruru02.com",
    "wwwruru03.com",
    "wwwruru10.com",
    "wwwruru13.com",
    "wwwruru18.com",
    "wwwruru21.com",
    "wwwruru24.com",
    "wwwruru32.com",
    "wwwruru45.com",
    "wwwruru98.com",
    "wwwsafecu.org",
    "wwwtexasnationaltitle.com",
    "wwwtexasnationaltitle.us",
    "wwwtexasnationaltltle.net",
    "wwwtexasnationatite.org",
    "wwwtm55.com",
    "wwwtradervue.com",
    "wwwuedfa.info",
    "wwwuna.com",
    "wwwvbaidu.com",
    "wwww-011uspush-notification-af-uss08.xyz",
    "wwww-011uspush-notification-af-uss09.xyz",
    "wwwwp888.com",
    "wwwwyomingtitle.com",
    "wwwwyomingtitle.info",
    "wwwwyomingtitle.net",
    "wwwyp888.com",
    "wwwyugeeson.xyz",
    "wwzm8r.site",
    "wx6018.com",
    "wx7008.com",
    "wx88.net",
    "wxgsln.us",
    "wxkmbrgh.shop",
    "wxnw.net",
    "wxs.net",
    "wxt2.icu",
    "wxyuetu.com",
    "wy6klk.us",
    "wyandotcountyfair.net",
    "wybuwy.xyz",
    "wyeransmax.gq",
    "wyfeedburner.com",
    "wyfhyx.com",
    "wygc2.info",
    "wygjgg.com",
    "wyhalfpricelistings.com",
    "wyioum.shop",
    "wyjatkoweokazje.online",
    "wymeno.info",
    "wymote.best",
    "wynbud.com",
    "wynncash01.com",
    "wynncash13.com",
    "wynwoodfarms.com",
    "wyomingaluminum.xyz",
    "wyomingtitl.us",
    "wyomingtitle.info",
    "wyomingtitle.org",
    "wyomingtitle.us",
    "wyrm.supernews.com",
    "wyseo.net",
    "wyuqois.site",
    "wyvernia.net",
    "wyvy.site",
    "wyzwt.com",
    "wz69j3ah3uaa2b1.xyz",
    "wz9227.com",
    "wz9827.com",
    "wz9837.com",
    "wzgrupos.com",
    "wzhn34.us",
    "wzjqg1.site",
    "wzm7.us",
    "wzofwtsry.shop",
    "wzukltd.com",
    "wzxmtb3stvuavbx9hfu.cf",
    "wzxmtb3stvuavbx9hfu.ga",
    "wzxmtb3stvuavbx9hfu.gq",
    "wzxmtb3stvuavbx9hfu.ml",
    "wzxmtb3stvuavbx9hfu.tk",
    "wzxsbz.com",
    "wzyk.tech",
    "wzzhjl.com",
    "x-8.buzz",
    "x-cocaine3.online",
    "x-fails.com",
    "x-izvestiya.ru",
    "x-mail.cf",
    "x-mail.net",
    "x-mule.cf",
    "x-mule.ga",
    "x-mule.gq",
    "x-mule.ml",
    "x-mule.tk",
    "x-netmail.com",
    "x-networks.net",
    "x-new-ru-news.ru",
    "x-pod.ru",
    "x-rugazeta.ru",
    "x-runovosti.ru",
    "x-rutochka.ru",
    "x-v-x.com",
    "x-vestnik.ru",
    "x.dc74.cf",
    "x.dc74.ml",
    "x.ip6.li",
    "x.nadazero.net",
    "x.tonno.cf",
    "x.tonno.gq",
    "x.tonno.ml",
    "x.tonno.tk",
    "x01porn.xyz",
    "x0dj2u.info",
    "x0m4nr.com",
    "x0zj6k8.com",
    "x1-payfree.info",
    "x1-payfree.site",
    "x1069x.com",
    "x13.dev",
    "x13.services",
    "x13x13x13.com",
    "x1bkskmuf4.cf",
    "x1bkskmuf4.ga",
    "x1bkskmuf4.gq",
    "x1bkskmuf4.ml",
    "x1bkskmuf4.tk",
    "x1cult.ru",
    "x1econ.ru",
    "x1lion.ru",
    "x1news.ru",
    "x1sci.ru",
    "x1x.spb.ru",
    "x1x22716.com",
    "x1xthj.us",
    "x2-greatfaro.site",
    "x220.xyz",
    "x24.com",
    "x25rn1.us",
    "x2bhv4.us",
    "x2c.ru",
    "x2ewzd983ene0ijo8.cf",
    "x2ewzd983ene0ijo8.ga",
    "x2ewzd983ene0ijo8.gq",
    "x2ewzd983ene0ijo8.ml",
    "x2ewzd983ene0ijo8.tk",
    "x2fsqundvczas.cf",
    "x2fsqundvczas.ga",
    "x2fsqundvczas.gq",
    "x2fsqundvczas.ml",
    "x2fsqundvczas.tk",
    "x2lap6.us",
    "x2news.ru",
    "x2qys9.us",
    "x2science.ru",
    "x2t0n.us",
    "x2x.foundation",
    "x3-faropaymenrs.info",
    "x3-faropaymenrs.site",
    "x30-coolmoney.host",
    "x31-funnycash.xyz",
    "x33-funnymonney.website",
    "x33-funnymonney.xyz",
    "x33567.com",
    "x3551.com",
    "x37-megacashsait.host",
    "x39-saitjoy.space",
    "x3gaev.us",
    "x3gsbkpu7wnqg.cf",
    "x3gsbkpu7wnqg.ga",
    "x3gsbkpu7wnqg.gq",
    "x3gsbkpu7wnqg.ml",
    "x3lbhdmnd206onc.xyz",
    "x3m8pu.us",
    "x3mailer.com",
    "x3us.us",
    "x3w875ioakdvmst.com",
    "x4y.club",
    "x58ff.com",
    "x58ii.com",
    "x5a9m8ugq.com",
    "x5bj6zb5fsvbmqa.ga",
    "x5bj6zb5fsvbmqa.ml",
    "x5bj6zb5fsvbmqa.tk",
    "x5ep20.info",
    "x5g.com",
    "x5n.net",
    "x5nw.com",
    "x5sk7ofi.xyz",
    "x5wcbd.us",
    "x5wila.us",
    "x6z72z.com",
    "x77.club",
    "x777.icu",
    "x777x.host",
    "x78qp.com",
    "x7971.com",
    "x7ca5blmxvskfoj.xyz",
    "x7mail.com",
    "x7tzhbikutpaulpb9.cf",
    "x7tzhbikutpaulpb9.ga",
    "x7tzhbikutpaulpb9.gq",
    "x7tzhbikutpaulpb9.ml",
    "x7xjou.us",
    "x8h8x941l.com",
    "x8rbn.cloud",
    "x8vplxtmrbegkoyms.cf",
    "x8vplxtmrbegkoyms.ga",
    "x8vplxtmrbegkoyms.gq",
    "x8vplxtmrbegkoyms.ml",
    "x8vplxtmrbegkoyms.tk",
    "x9094.com",
    "x90b.club",
    "x9dofwvspm9ll.cf",
    "x9dofwvspm9ll.ga",
    "x9dofwvspm9ll.gq",
    "x9dofwvspm9ll.ml",
    "x9dofwvspm9ll.tk",
    "x9y9.com",
    "xa9f9hbrttiof1ftean.cf",
    "xa9f9hbrttiof1ftean.ga",
    "xa9f9hbrttiof1ftean.gq",
    "xa9f9hbrttiof1ftean.ml",
    "xa9f9hbrttiof1ftean.tk",
    "xabe.site",
    "xacbdxbjd.shop",
    "xady.info",
    "xadzbill247.com",
    "xaffz.com",
    "xagloo.co",
    "xagloo.com",
    "xairbo.club",
    "xakas-online.ru",
    "xaker.ru",
    "xakishop.site",
    "xakomsung.cf",
    "xakomsung.ga",
    "xalipcode.xyz",
    "xalipcodes.online",
    "xaotxauf.pro",
    "xap.chat",
    "xapocopi.site",
    "xarakter.org",
    "xaralabs.com",
    "xas04oo56df2scl.cf",
    "xas04oo56df2scl.ga",
    "xas04oo56df2scl.gq",
    "xas04oo56df2scl.ml",
    "xas04oo56df2scl.tk",
    "xasamail.com",
    "xaugroup.com",
    "xautostabilbetsnup.xyz",
    "xav.buzz",
    "xaxx.ml",
    "xaynetsss.ddns.net",
    "xb07.xyz",
    "xb709.com",
    "xbaby69.top",
    "xbapi.xyz",
    "xbbprgxrl.shop",
    "xbetpinupflag.ru",
    "xbfby.xyz",
    "xblbet.com",
    "xbm7bx391sm5owt6xe.cf",
    "xbm7bx391sm5owt6xe.ga",
    "xbm7bx391sm5owt6xe.gq",
    "xbm7bx391sm5owt6xe.ml",
    "xbm7bx391sm5owt6xe.tk",
    "xbmm.xyz",
    "xbmyv8qyga0j9.cf",
    "xbmyv8qyga0j9.ga",
    "xbmyv8qyga0j9.gq",
    "xbmyv8qyga0j9.ml",
    "xbmyv8qyga0j9.tk",
    "xbnxnf.com",
    "xbombo.site",
    "xboxonelove.com",
    "xbpybglk.shop",
    "xbtcpro.com",
    "xbtpro.tech",
    "xbtybo.info",
    "xbusinesnews.com",
    "xbvrfy45g.ga",
    "xbwgfx.com",
    "xbxjvl.online",
    "xbziv2krqg7h6.cf",
    "xbziv2krqg7h6.ga",
    "xbziv2krqg7h6.gq",
    "xbziv2krqg7h6.ml",
    "xbziv2krqg7h6.tk",
    "xc05fypuj.com",
    "xc40.cf",
    "xc40.ga",
    "xc40.gq",
    "xc40.ml",
    "xc40.tk",
    "xc60.cf",
    "xc60.ga",
    "xc60.gq",
    "xc60.ml",
    "xc60.tk",
    "xc90.cf",
    "xc90.ga",
    "xc90.gq",
    "xc90.ml",
    "xc90.tk",
    "xca.cz",
    "xcameravip.info",
    "xcasino-mega.ru",
    "xcc-999.com",
    "xcdn.ooo",
    "xcfehg.com",
    "xchanghe6majid.com",
    "xchita.com",
    "xckerkorkf33.info",
    "xcnvmf3-privbmngt.info",
    "xcnvmf3-privbmngt.press",
    "xcnvmf3-privbmngt.space",
    "xcode.ro",
    "xcodes.net",
    "xcoex.asia",
    "xcoex.chat",
    "xcoex.email",
    "xcoex.mobi",
    "xcoex.net",
    "xcoex.org",
    "xcoex.ru",
    "xcoex.trade",
    "xcompress.com",
    "xconvict-vpn.technology",
    "xconvictz.com",
    "xcoryo.site",
    "xcoxc.com",
    "xcpy.com",
    "xcq61r.us",
    "xctc5r.us",
    "xcvitir-account1manager1.com",
    "xcxqtsfd0ih2l.cf",
    "xcxqtsfd0ih2l.ga",
    "xcxqtsfd0ih2l.gq",
    "xcxqtsfd0ih2l.ml",
    "xcxqtsfd0ih2l.tk",
    "xcy8gl.site",
    "xczffumdemvoi23ugfs.cf",
    "xczffumdemvoi23ugfs.ga",
    "xczffumdemvoi23ugfs.gq",
    "xczffumdemvoi23ugfs.ml",
    "xczffumdemvoi23ugfs.tk",
    "xd.ae",
    "xd7ueb.com",
    "xdatel.com",
    "xdatelocal.com",
    "xdavpzaizawbqnivzs0.cf",
    "xdavpzaizawbqnivzs0.ga",
    "xdavpzaizawbqnivzs0.gq",
    "xdavpzaizawbqnivzs0.ml",
    "xdavpzaizawbqnivzs0.tk",
    "xdbdqdkxbb.xyz",
    "xdbdqkkxbb.xyz",
    "xdbdqnkxbb.xyz",
    "xdbdqskxbb.xyz",
    "xdbdqxkxbb.xyz",
    "xdeyegrymfw0w0e.xyz",
    "xdfav.com",
    "xdofud.info",
    "xdoqsh.site",
    "xdtf.fun",
    "xdtf.site",
    "xdumb.com",
    "xdvsagsdg4we.ga",
    "xe8kc.us",
    "xeasystabilitybetsnupp20.xyz",
    "xebrcxcfey.xyz",
    "xecautaiquangngai.com",
    "xedoiutret.cf",
    "xefezi.info",
    "xefthth.xyz",
    "xegi.net",
    "xekeshop.site",
    "xelacade.site",
    "xemaps.com",
    "xemne.com",
    "xemnhantuong.com",
    "xemrelim.cf",
    "xemrelim.ga",
    "xemrelim.gq",
    "xemrelim.ml",
    "xemrelim.tk",
    "xenodate.com",
    "xenogamy.site",
    "xents.com",
    "xeon-e3.ovh",
    "xeon.net",
    "xeosa9gvyb5fv.cf",
    "xeosa9gvyb5fv.ga",
    "xeosa9gvyb5fv.gq",
    "xeosa9gvyb5fv.ml",
    "xeosa9gvyb5fv.tk",
    "xeripu.info",
    "xerothworld.com",
    "xerqhpmma.shop",
    "xesaxesb.shop",
    "xet0p.us",
    "xetaithanhvinh.com",
    "xeti.com",
    "xeu2ot.us",
    "xevents.buzz",
    "xevents.site",
    "xex66.com",
    "xex88.com",
    "xezbii.us",
    "xf.sluteen.com",
    "xf5di7.us",
    "xf7asj.us",
    "xfamiliar9.com",
    "xfdmwbbx.shop",
    "xffbe2l8xiwnw.cf",
    "xffbe2l8xiwnw.ga",
    "xffbe2l8xiwnw.gq",
    "xffbe2l8xiwnw.ml",
    "xffbe2l8xiwnw.tk",
    "xfghzdff75zdfhb.ml",
    "xfind.online",
    "xfinder.site",
    "xfitkmvt.space",
    "xfjyn.com",
    "xfkfdmam.shop",
    "xfriend.fun",
    "xfriend.site",
    "xfriends.site",
    "xfwb7l.us",
    "xfwlcq.com",
    "xfxbfv.us",
    "xfzvtxrhu.shop",
    "xg6sn5.us",
    "xgaming.ca",
    "xgeuyh.icu",
    "xgfpg.site",
    "xgk6dy3eodx9kwqvn.cf",
    "xgk6dy3eodx9kwqvn.ga",
    "xgk6dy3eodx9kwqvn.gq",
    "xgk6dy3eodx9kwqvn.tk",
    "xgl4nb.com",
    "xgmailoo.com",
    "xgnowherei.com",
    "xgoiuu.xyz",
    "xgold.fun",
    "xgqwpv.us",
    "xgrxsuldeu.cf",
    "xgrxsuldeu.ga",
    "xgrxsuldeu.gq",
    "xgrxsuldeu.ml",
    "xgrxsuldeu.tk",
    "xgsj.xyz",
    "xguy.net",
    "xgzslm.com",
    "xh4388.com",
    "xh5ef.info",
    "xh8988.com",
    "xhamster.ltd",
    "xhanimatedm.com",
    "xhcav.top",
    "xhcbtduey.shop",
    "xhd09.us",
    "xhfc6m.us",
    "xhhc123.com",
    "xhiaxhik.shop",
    "xhmdh99.xyz",
    "xho8i.info",
    "xhouse.xyz",
    "xhr10.com",
    "xht00.com",
    "xht77.com",
    "xhusjsx.xyz",
    "xhxynyfbb.shop",
    "xhybdnhyr.shop",
    "xhyemail.com",
    "xi2.net",
    "xi6.buzz",
    "xiacorilop.icu",
    "xiangjiaodaohang.live",
    "xiaoai.net",
    "xiaobi100.com",
    "xiaobi101.com",
    "xiaobi110.com",
    "xiaobi112.com",
    "xiaobi115.com",
    "xiaobi119.com",
    "xiaobi126.com",
    "xiaobi132.com",
    "xiaobi133.com",
    "xiaobi137.com",
    "xiaobi139.com",
    "xiaobi140.com",
    "xiaobi142.com",
    "xiaobi143.com",
    "xiaobi146.com",
    "xiaobi149.com",
    "xiaobi153.com",
    "xiaobi155.com",
    "xiaobi156.com",
    "xiaobi157.com",
    "xiaobi159.com",
    "xiaobi162.com",
    "xiaobi164.com",
    "xiaobi167.com",
    "xiaobi168.com",
    "xiaobi170.com",
    "xiaobi171.com",
    "xiaobi173.com",
    "xiaobi175.com",
    "xiaobi177.com",
    "xiaobi178.com",
    "xiaobi181.com",
    "xiaobi182.com",
    "xiaobi187.com",
    "xiaobi188.com",
    "xiaobi191.com",
    "xiaobi195.com",
    "xiaobi196.com",
    "xiaobi198.com",
    "xiaobi200.com",
    "xiaojifang.com",
    "xiaolaoshu.site",
    "xiaomico.ru",
    "xiaomimiband03.ru",
    "xiaominglu88.com",
    "xiaomitvplus.com",
    "xiaoshuo.ru",
    "xiaoyangera.com",
    "xiaoyocc.xyz",
    "xiaoyodd.xyz",
    "xiaoyogg.xyz",
    "xiaoyohh.xyz",
    "xiaoyokk.xyz",
    "xiaoyomm.xyz",
    "xiaoyonn.xyz",
    "xiaoyorr.xyz",
    "xiaoyoss.xyz",
    "xiaoyott.xyz",
    "xiaoyoyy.xyz",
    "xiaozao66.com",
    "xias-daman1.ru",
    "xiayuanpan.com",
    "xiazaidang.com",
    "xicoda.cf",
    "xicoda.ga",
    "xicoda.gq",
    "xicoda.ml",
    "xicoda.tk",
    "xidy.site",
    "xiehuomeitu.xyz",
    "xieyugui.online",
    "xifer.xyz",
    "xifhbnqyi.shop",
    "xihunwo.com",
    "xihunwu.com",
    "xikihn.us",
    "xilinous.xyz",
    "ximant.pro",
    "ximtyl.com",
    "xin7749.info",
    "xin88088.com",
    "xin88288.com",
    "xin88688.com",
    "xing886.uu.gl",
    "xingc3yl.com",
    "xingfushiguangktv.com",
    "xinglossne.cf",
    "xinglossne.gq",
    "xinglossne.tk",
    "xingmadh.site",
    "xingwater.com",
    "xingyaoyule.biz",
    "xingyaoyule77.com",
    "xinhao102.com",
    "xinhao103.com",
    "xinhao106.com",
    "xinhao107.com",
    "xinhao108.com",
    "xinhao109.com",
    "xinhuanet.ru",
    "xinjiacp.com",
    "xinli18.info",
    "xinmeng8.xyz",
    "xinqpi.com",
    "xinsiji.info",
    "xinsiji.org",
    "xinsiji.xyz",
    "xinsijifuli.org",
    "xinsijifuli.xyz",
    "xinsijitv.info",
    "xinsijitv.xyz",
    "xinsijitv00.info",
    "xinsijitv11.info",
    "xinsijitv13.info",
    "xinsijitv14.info",
    "xinsijitv15.info",
    "xinsijitv16.info",
    "xinsijitv17.info",
    "xinsijitv18.info",
    "xinsijitv2.info",
    "xinsijitv20.info",
    "xinsijitv22.info",
    "xinsijitv23.info",
    "xinsijitv25.info",
    "xinsijitv26.info",
    "xinsijitv28.info",
    "xinsijitv29.info",
    "xinsijitv3.info",
    "xinsijitv32.info",
    "xinsijitv33.info",
    "xinsijitv34.info",
    "xinsijitv35.info",
    "xinsijitv36.info",
    "xinsijitv37.info",
    "xinsijitv38.info",
    "xinsijitv4.info",
    "xinsijitv40.info",
    "xinsijitv41.info",
    "xinsijitv42.info",
    "xinsijitv43.info",
    "xinsijitv45.info",
    "xinsijitv46.info",
    "xinsijitv47.info",
    "xinsijitv49.info",
    "xinsijitv50.info",
    "xinsijitv52.info",
    "xinsijitv53.info",
    "xinsijitv54.info",
    "xinsijitv55.info",
    "xinsijitv56.info",
    "xinsijitv57.info",
    "xinsijitv58.info",
    "xinsijitv59.info",
    "xinsijitv60.info",
    "xinsijitv63.info",
    "xinsijitv64.info",
    "xinsijitv65.info",
    "xinsijitv66.info",
    "xinsijitv67.info",
    "xinsijitv68.info",
    "xinsijitv69.info",
    "xinsijitv70.info",
    "xinsijitv72.info",
    "xinsijitv73.info",
    "xinsijitv74.info",
    "xinsijitv76.info",
    "xinsijitv77.info",
    "xinsijitv79.info",
    "xinsijitv8.info",
    "xinsijitv82.info",
    "xinsijitv83.info",
    "xinsijitv84.info",
    "xinsijitv86.info",
    "xinsijitv87.info",
    "xinsijitv88.info",
    "xinsijitv89.info",
    "xinsijitv9.info",
    "xinsijitv90.info",
    "xinsijitv91.info",
    "xinsijitv92.info",
    "xinsijitv93.info",
    "xinsijitv95.info",
    "xinsijitv96.info",
    "xinwangcai.xyz",
    "xinwangyl.net",
    "xinxianguo.xyz",
    "xinzhi.org",
    "xinzk1ul.com",
    "xio7s7zsx8arq.cf",
    "xio7s7zsx8arq.ga",
    "xio7s7zsx8arq.gq",
    "xio7s7zsx8arq.ml",
    "xio7s7zsx8arq.tk",
    "xionprotocol.com",
    "xiotel.com",
    "xipcj6uovohr.cf",
    "xipcj6uovohr.ga",
    "xipcj6uovohr.gq",
    "xipcj6uovohr.ml",
    "xipcj6uovohr.tk",
    "xiqfyn.us",
    "xiqing11.com",
    "xiqing22.com",
    "xiqing55.com",
    "xiqing66.com",
    "xir7hi.site",
    "xishibbs.com",
    "xitedegaming.online",
    "xiteen.asia",
    "xitercs.ml",
    "xitercs.tk",
    "xiunhl.us",
    "xiwa1e.us",
    "xiyi12348.xyz",
    "xizang.us",
    "xizqxhuq.shop",
    "xj1234.xyz",
    "xj520aa.com",
    "xj5237.com",
    "xjav52.com",
    "xjav58.com",
    "xjav77.com",
    "xjaymn.com",
    "xjbpav.com",
    "xjedu1.site",
    "xjgbw.com",
    "xjghm.com",
    "xjhytkjutk2er.xyz",
    "xjin.xyz",
    "xjmjt.com",
    "xjmwtk.info",
    "xjoi.com",
    "xjolfx.site",
    "xjp991.com",
    "xjpzit.us",
    "xjshutdownbaychiro.com",
    "xjsjbd.com",
    "xjsp123.xyz",
    "xjsp55.xyz",
    "xjwmp.us",
    "xk39zh.us",
    "xk6.net",
    "xk81g9.us",
    "xkbmxs.fun",
    "xkcmkl.fun",
    "xkcmmg.fun",
    "xkjmfw.fun",
    "xklmlm.fun",
    "xklmnj.fun",
    "xklonecde.shop",
    "xklt4qdifrivcw.cf",
    "xklt4qdifrivcw.ga",
    "xklt4qdifrivcw.gq",
    "xklt4qdifrivcw.ml",
    "xklt4qdifrivcw.tk",
    "xklzdv.site",
    "xkmmpw.fun",
    "xkmpkjhth.shop",
    "xknmxt.fun",
    "xkpmbc.fun",
    "xkpmrp.fun",
    "xkpmzf.fun",
    "xkqukjsq.shop",
    "xkqvlbva.shop",
    "xkrmkd.fun",
    "xksmbc.fun",
    "xksmfx.fun",
    "xksmhp.fun",
    "xksovk34k.dns04.com",
    "xktmfp.fun",
    "xktmyb.fun",
    "xkwmjn.fun",
    "xkx.me",
    "xkymcw.fun",
    "xkzmgj.fun",
    "xl.cx",
    "xl7fnr.us",
    "xl8037.com",
    "xl9837.com",
    "xlarge.kiwi",
    "xlgaokao.com",
    "xlgria.us",
    "xlhf.us",
    "xljelarabic.site",
    "xljmz1.site",
    "xlmx5p.host",
    "xlootgame.fun",
    "xloveme.top",
    "xlpaketinternet.com",
    "xlra5cuttko5.cf",
    "xlra5cuttko5.ga",
    "xlra5cuttko5.gq",
    "xlra5cuttko5.ml",
    "xlra5cuttko5.tk",
    "xltbz8eudlfi6bdb6ru.cf",
    "xltbz8eudlfi6bdb6ru.ga",
    "xltbz8eudlfi6bdb6ru.gq",
    "xltbz8eudlfi6bdb6ru.ml",
    "xltbz8eudlfi6bdb6ru.tk",
    "xmail.com",
    "xmail2.net",
    "xmail365.net",
    "xmailpro.tech",
    "xmailsme.com",
    "xmailweb.com",
    "xmaily.com",
    "xmaq1.us",
    "xmastime.com",
    "xmatch.buzz",
    "xmatch.site",
    "xmatchup.online",
    "xmatchup.site",
    "xmate.fun",
    "xmate.online",
    "xmate.site",
    "xmdszg.com",
    "xmeetup.buzz",
    "xmeetup.fun",
    "xmeetup.site",
    "xmenfans.com",
    "xmgzyw.com",
    "xmhaoduoxie.com",
    "xmjxcy.com",
    "xmlat.com",
    "xmljk.us",
    "xmlkvr.us",
    "xmma4c.xyz",
    "xmmar3.xyz",
    "xmmbas.xyz",
    "xmmcou.xyz",
    "xmme81.xyz",
    "xmmf4u.xyz",
    "xmmg8u.xyz",
    "xmmhce.xyz",
    "xmmiiu.xyz",
    "xmmliq.xyz",
    "xmmmx1.xyz",
    "xmmoln.xyz",
    "xmmtgp.xyz",
    "xmmtxf.xyz",
    "xmmybf.xyz",
    "xmov.site",
    "xmovies8.tech",
    "xmovies8.today",
    "xmp9o.us",
    "xmpr.cf",
    "xmpr.tk",
    "xms.nl",
    "xmsg.com",
    "xmule.cf",
    "xmule.ga",
    "xmule.gq",
    "xmule.ml",
    "xmv6txw5xtpsd65.xyz",
    "xmyguides.site",
    "xmymanuals.site",
    "xmz73.com",
    "xmze8t.us",
    "xn--------4vefhccz6bxah2aaqfdkf1aebizq7vla7j.xn--p1ai",
    "xn-------53ddjcb4azdubcg7a0bizb1aegfpcl6w.xn--p1ai",
    "xn------5cdbcaf0bogcrcuiptdpk2g.xn--p1ai",
    "xn------8cdamqaebbskmalnmmwxj6bjhk6m9d.xn--p1ai",
    "xn-----6kcabakf8asse6afefna5agcwjlb4ezi.xn--p1ai",
    "xn-----6kcatfxlkvplkf4d.xn--p1ai",
    "xn-----6kcpc1bhcrdk5h1d.com",
    "xn-----6kcvbftdvihgg4ap6n.xn--p1ai",
    "xn-----7kcb1amadqghijfdjs7o7dii.xn--p1ai",
    "xn-----7kcbtgrbihdshendbp0cenidu0l6c.xn--p1ai",
    "xn-----7kcfchkxffqf0affjvcsqed9jwdxa.xn--p1ai",
    "xn-----8kcsndjkdlgameeiuyemki5fxfrc.xn--p1ai",
    "xn-----vldobenmaicb2b8bfb9kwahk.xn--9dbq2a",
    "xn----0hcns4anp6av.xyz",
    "xn----0tbcfcjbai.xn--p1ai",
    "xn----2019-iofqgcb4aasj1c8cik0c5k.xn--p1ai",
    "xn----7sba2bgi3agqk.xn--p1ai",
    "xn----7sbaaidejk5a2cybdme.xn--p1acf",
    "xn----7sbabbb3cco5ay6b7bav.xn--p1ai",
    "xn----7sbajaiddea6a9auudng1a.xn--p1ai",
    "xn----7sbalvgbqkpbam0d.xn--p1ai",
    "xn----7sbbabca5a2csf5b3g8d.xn--p1ai",
    "xn----7sbbabzqeflcdd7a1d2a.xn--p1ai",
    "xn----7sbbagu5abnaht2d.xn--p1ai",
    "xn----7sbbaohxcapcngdub6cgc3b.xn--p1ai",
    "xn----7sbbay2aja7a.xn--p1ai",
    "xn----7sbbc2akvnhbkkcrp2a.xn--p1acf",
    "xn----7sbbd5biaefsc.xn--p1ai",
    "xn----7sbbd7ddw.xn--p1ai",
    "xn----7sbbhoqnn0aakrcdfk8o.xn--p1ai",
    "xn----7sbbiighd9f7a.xn--p1ai",
    "xn----7sbblhresffmfcnu6v.xn--p1ai",
    "xn----7sbbzlcmmddg.xn--p1ai",
    "xn----7sbeel7acr9bn.xn--p1ai",
    "xn----7sbhefbvqzhjc4b5b5f.xn--p1ai",
    "xn----7sbhh4aiifgm2bx6k.xn--p1ai",
    "xn----7sbihd3ajpqi.xn--p1ai",
    "xn----7sbkfq2bbwef1c.xn--p1ai",
    "xn----7sblsrjcf7c.xn--p1ai",
    "xn----8sb0bw7d.xn--p1ai",
    "xn----8sbacsar9a9ac3b.xn--p1ai",
    "xn----8sbalhqcf3abbroo2c.xn--p1ai",
    "xn----8sbalvgbhjmiic2l0bo.xn--p1ai",
    "xn----8sbau0adckdeguzo7i0a.xn--p1ai",
    "xn----8sbcnqckej2ag1bk3k.xn--p1ai",
    "xn----8sbeefhvqxcgc7c2b3e.xn--p1ai",
    "xn----8sbelvhbwiemgzd9j.xn--p1ai",
    "xn----8sbem1b0aj.xn--p1ai",
    "xn----8sbfkpbkbcgh0ahnn8ae7gsd8b.xn--p1ai",
    "xn----8sbfwfkp1a2dg2b.xn--p1ai",
    "xn----8sbhe5adun.xn--p1ai",
    "xn----btbbcm0chbdb5bl.xn--p1ai",
    "xn----btbetghhmiu2b5f.xn--p1ai",
    "xn----btbhfc8ef4h.xn--p1ai",
    "xn----btbkoggogeajz6f1bn2d.xn--p1ai",
    "xn----ctbhdabgt2alg7ao.xn--p1ai",
    "xn----ctbjn3bdlp7a8a.xn--p1ai",
    "xn----dtbe2aqatj3a3dvb.xn--p1ai",
    "xn----etbecqrm.xn--p1ai",
    "xn----etbglcjc2anedjoghf0n.xn--p1ai",
    "xn----etbhmopjnjb2c6c.xn--p1ai",
    "xn----ftb5amn7d.xn--p1ai",
    "xn----ftbeohexbaiieu4m.xn--p1ai",
    "xn----gtbdh5aha5aq.xn--p1ai",
    "xn----htbbcpth8bc6f.xn--p1ai",
    "xn----htbkcy0a0f.xn--p1ai",
    "xn----htbqakn6b.xn--p1ai",
    "xn----jtbaw2ae1c.xn--p1ai",
    "xn----jtbhaxvl7g.xn--p1ai",
    "xn----jtbhjkdhcklur4hk4a.xn--p1ai",
    "xn----ttbbeidn9a.xn--p1ai",
    "xn----zhcqo4atp6am.com",
    "xn----zhcqo4atp6am.net",
    "xn----zhcqo4atp6am.xyz",
    "xn---1-6kc5aaamcecxgm.xn--p1ai",
    "xn---1-6kcat8awipfg.xn--p1ai",
    "xn---1-9kcpq5cfd.xn--p1ai",
    "xn---2019-3veag6fj6c1h.xn--p1ai",
    "xn---3333-3vea4b0c6cjcv5i.xn--p1ai",
    "xn---35-bedk3a.xn--p1ai",
    "xn---39-2ddzg5b.xn--p1ai",
    "xn--04-jlceoalydfe0a7e.xn--p1ai",
    "xn--1--8kcaakij2f6ad.xn--p1ai",
    "xn--1--clcpq4cbj.xn--p1ai",
    "xn--12-6kce9ag1aw7a8a8b.xn--p1ai",
    "xn--12-flcef3d.xn--p1ai",
    "xn--12cmd0bjwv5auyea8pldh5jrj.com",
    "xn--1389-43d9dogi6n.com",
    "xn--17-0j9i78yt70a.com",
    "xn--1iq230dcq9as1a.xn--6qq986b3xl",
    "xn--1iqx62bu97b.xn--6qq986b3xl",
    "xn--1lqx47cqwv.app",
    "xn--2-v30fu36e.com",
    "xn--2019-43daf7ei1cxh.xn--p1ai",
    "xn--220b70t2ube1ltzb.com",
    "xn--299as8e18g.org",
    "xn--2h3b21h6yfmub61a.com",
    "xn--2h3bi8t39h.com",
    "xn--2hvrvk92j.xn--6qq986b3xl",
    "xn--2i0by5tlwa.com",
    "xn--2n1b.com",
    "xn--2o2b1x16o.com",
    "xn--2p7bp2h.net",
    "xn--31bsue4aj8a5mua.com",
    "xn--365-hy7mu67i.com",
    "xn--3e0bu9ybmaw5m.com",
    "xn--3oqt7hvrnu9zfgg.com",
    "xn--3zvt89cs7e.xn--6qq986b3xl",
    "xn--42-6kctoa3aghsn.xn--p1ai",
    "xn--42c6aa8cyaxn9mqc.com",
    "xn--42c6bxagvbqjd8ded7s5c.com",
    "xn--45-jlcdgv2a6aa.xn--p1ai",
    "xn--46-ylcmickhfeg.xn--p1ai",
    "xn--4dbceig1b7e.com",
    "xn--4dbjnyln2as.com",
    "xn--4dbjnyln2as.xyz",
    "xn--4dd.com",
    "xn--4gqt6ffycq7dca9225a3tp9e0d.top",
    "xn--50talsklder-s8a.se",
    "xn--51xyz-308h91u.xyz",
    "xn--5dbki3af.xn--9dbq2a",
    "xn--5dd.com",
    "xn--61-6kch9agsibavln.xn--p1ai",
    "xn--63--lddegwf9aeffhqlqr0m.xn--p1ai",
    "xn--6dd.com",
    "xn--6xwx64c.xn--6qq986b3xl",
    "xn--72c5ai8avd1a7nla2d.net",
    "xn--72cm8acj4ezas8a6bb1bzgrfc.com",
    "xn--74-vlciicfbib5n.xn--p1ai",
    "xn--747-v18mt43c.com",
    "xn--78-jlcy8a.xn--p1ai",
    "xn--7gqvd.com",
    "xn--7hvr7ae9s.top",
    "xn--7tt47n.xn--6qq986b3xl",
    "xn--7ttu7r4vk.xn--6qq986b3xl",
    "xn--80a2adkdg.xn--p1ai",
    "xn--80aaacoue2coi.xn--p1ai",
    "xn--80aaadcsvqdhbw8a2av3km0d.xn--p1ai",
    "xn--80aaah3bqlqbqf6j.xn--p1ai",
    "xn--80aaahb7al3ajo.xn--p1ai",
    "xn--80aaalgubaobmgdsb3cgc1b.xn--p1ai",
    "xn--80aaapmrywy.xn--p1ai",
    "xn--80aaas0adkjgreodg6l.xn--p1ai",
    "xn--80aab4ajehd7bces.xn--p1ai",
    "xn--80aab7afbgzsu.xn--p1ai",
    "xn--80aabpao5a5ac9a.xn--p1ai",
    "xn--80aac1bsjrb.xn--p1ai",
    "xn--80aac2akox3a.xn--p1ai",
    "xn--80aac7ahaderb.xn--p1ai",
    "xn--80aaccckhb5elybu8jg.xn--p1ai",
    "xn--80aacrj6aghkho.xn--p1ai",
    "xn--80aae1cmie.xn--p1ai",
    "xn--80aaf2dvb.xn--p1ai",
    "xn--80aafk4baiso9a9ch.xn--p1ai",
    "xn--80aafsr8j.online",
    "xn--80aafzid0cq9b.xn--p1ai",
    "xn--80aafzipdbbdcusoc2b.xn--p1ai",
    "xn--80aagahcdda3a6atsdmgz.xn--p1ai",
    "xn--80aaggfgd9e4a.xn--p1ai",
    "xn--80aagwisbbaehxgoc7c.xn--p1ai",
    "xn--80aahhbuurda8al0bfuf.xn--p1ai",
    "xn--80aai7abedm0a3l.xn--p1ai",
    "xn--80aaicuoui2b.xn--p1ai",
    "xn--80aainegbzokw0b0l.xn--p1ai",
    "xn--80aalacch7bkahfu8cwk.xn--p1ai",
    "xn--80aalfzekf3cg.xn--p1ai",
    "xn--80aamqhktnjjbm.xn--p1ai",
    "xn--80aanzpjadly.xn--p1ai",
    "xn--80aaoa1amfllc8g1cc.xn--p1ai",
    "xn--80aapkpad1a9d.xn--p1ai",
    "xn--80aartii4c.xn--p1ai",
    "xn--80aavhnye.xn--p1ai",
    "xn--80abbekfwmdoyd3bv7j.xn--p1ai",
    "xn--80abdl4as.online",
    "xn--80abdx1adapdf4i6b.xn--p1ai",
    "xn--80abghr1aceuqh.xn--p1ai",
    "xn--80ablladjokfzow.xn--p1ai",
    "xn--80abuba2azw.xn--p1ai",
    "xn--80ac0aofq.xn--p1ai",
    "xn--80achdprc1akhw.xn--p1ai",
    "xn--80ache5a3bk4e.xn--p1ai",
    "xn--80acifeidcays9achvhfehg5v.xn--p1ai",
    "xn--80actcwyh.xn--p1ai",
    "xn--80ad6adbdiq.xn--p1ai",
    "xn--80adakoaccjvmeald0apcqd6g.xn--p1ai",
    "xn--80adbmpmfrc3ajdz.space",
    "xn--80adfdqcwlak4g3e.xn--p1ai",
    "xn--80adje3afestfecq3a6f.xn--p1ai",
    "xn--80adjlztie3a.xn--p1ai",
    "xn--80adjuryc.com",
    "xn--80ae6au1a7b.xn--p1ai",
    "xn--80aeedcpbd2ap2agle.xn--p1ai",
    "xn--80aehaocnfpdiln9ax9igj.xn--p1ai",
    "xn--80aehysbgfdq.xn--p1ai",
    "xn--80aeihafl1aj7a.xn--p1acf",
    "xn--80aeihafl1aj7a.xn--p1ai",
    "xn--80afa8afcebtvj.xn--p1ai",
    "xn--80afebb8bccamn0a.xn--p1ai",
    "xn--80afenxdjla3at.xn--p1ai",
    "xn--80affoaracdok1n.xn--p1ai",
    "xn--80agbeqfhfv7a5a.xn--p1ai",
    "xn--80agmgtehmfy8f.xn--p1ai",
    "xn--80agoh5aebdhhc.xn--p1ai",
    "xn--80agohvmm.xn--p1ai",
    "xn--80ahbatauh2l.xn--p1ai",
    "xn--80ahci1bx.xn--p1ai",
    "xn--80ahhi0aagizsx.xn--p1ai",
    "xn--80ahlkbi1b.xn--p1ai",
    "xn--80aibbabagtydscgeeegimin1x.xn--p1ai",
    "xn--80aibwmaihjxj1a1ej.xn--p1ai",
    "xn--80ajbbnaaicbe8ab2btj.org",
    "xn--80ajbsfhxv2a.xn--p1ai",
    "xn--80ajgdancodgb9an5d1a5c6d.xn--p1ai",
    "xn--80ajigvuebev.xn--p1ai",
    "xn--80ajixegdgzc.xn--p1ai",
    "xn--80ajzj5b.xn--p1ai",
    "xn--80akjkmgd9dzb.xn--p1ai",
    "xn--80aneinf7d.xn--p1ai",
    "xn--80apfmadb1e.xn--p1ai",
    "xn--80aplhbdkjj0e7ay.xn--p1ai",
    "xn--80asehdbfhkho.com",
    "xn--89-dlcm9dva2b.xn--p1ai",
    "xn--8dbcf0bzc.xn--9dbq2a",
    "xn--8dd.com",
    "xn--90abkocegtcd1a3f.xn--p1ai",
    "xn--90abvrccwbp.xn--p1acf",
    "xn--90acrbhdiqadvkjq0h.xn--p1ai",
    "xn--90adoc0b.xn--p1ai",
    "xn--90af4abj.online",
    "xn--90af4abj.su",
    "xn--90aglaal2anlg.xn--p1ai",
    "xn--90ahaqfgcpikzq.xn--p1ai",
    "xn--90ahk7ag.xn--p1ai",
    "xn--90aiahljqfu5i.xn--p1ai",
    "xn--90aifdivcrocc1io.online",
    "xn--90aiijdrbqly.xn--p1ai",
    "xn--90aithxo.xn--p1ai",
    "xn--90ansbjdcfd7bxc.xn--p1ai",
    "xn--90aoebdlgbrt7i.xn--p1ai",
    "xn--90aofbflgbrt7i.xn--p1ai",
    "xn--90aorghche9b.xn--p1ai",
    "xn--90asmen.xn--p1ai",
    "xn--950bt9so0e0pfctjn4i.com",
    "xn--950bt9so0e0pfctjn4i.net",
    "xn--9fyue625bora.top",
    "xn--9i4b.net",
    "xn--9kq967o.com",
    "xn--9kqp1stng.top",
    "xn--9l4b91e9xcm2a.com",
    "xn--9l4b91i3dx8cc2a.net",
    "xn--9l4bn3j2ta380a7zc.net",
    "xn--9uv034f.top",
    "xn--aliexprss-1f7d.com",
    "xn--alln-s6b.com",
    "xn--almazaradefiana-9qb.com",
    "xn--alsverismarketiniz-f0c.com",
    "xn--amonn-9ra.xyz",
    "xn--ateliergzel-0hb.com",
    "xn--atlantismhendislik-u6b.com",
    "xn--b-dga.vn",
    "xn--b1a1abc.xn--p1ai",
    "xn--b1aafdb5arfuvgeebq7a2a1e.xn--p1ai",
    "xn--b1aagcxqjep.xn--p1ai",
    "xn--b1aaick1b3a.xn--p1ai",
    "xn--b1abhzzbj.xn--p1ai",
    "xn--b1abpofgbbqvv9b.xn--p1ai",
    "xn--b1acb7a.xn--p1ai",
    "xn--b1adaea1a0agbkzk3ewb.xn--p1ai",
    "xn--b1adaeab4amujl1al8eyb.xn--p1ai",
    "xn--b1adcwkxs1e.xn--p1ai",
    "xn--b1addaba0dwdo6ae.xn--p1ai",
    "xn--b1aecabfrykg4an.xn--p1ai",
    "xn--b1aecknxciv.xn--p1ai",
    "xn--b1afb8bben.xn--p1ai",
    "xn--b1afjaavi5bm2f.xn--p1ai",
    "xn--b1aga4aooe.xn--p1ai",
    "xn--b1agad8acbstfeeo3a6f.xn--p1ai",
    "xn--b1aq.space",
    "xn--b3c3ap8a0c0a.xyz",
    "xn--bei.cf",
    "xn--bei.ga",
    "xn--bei.gq",
    "xn--bei.ml",
    "xn--bei.tk",
    "xn--bfr83ulwq.xn--6qq986b3xl",
    "xn--bichosdeestimao-xkb1e.com",
    "xn--bka.net",
    "xn--blckchain-66a.site",
    "xn--blckchan-i2a8c.site",
    "xn--blckchn-mwa2i6b.site",
    "xn--blockchaj-t6a.com",
    "xn--blockchan-n5a.site",
    "xn--bluewn-7va.cf",
    "xn--bnqv7k.net",
    "xn--byggfretagistockholm-79b.nu",
    "xn--c1acbqdxear.xn--p1ai",
    "xn--c1ajialcnp.xn--p1acf",
    "xn--c3cralk2a3ak7a5gghbv.com",
    "xn--c3cralk2a3ak7a5gnbdr.com",
    "xn--c3cralk2a3ak7a8c7anddj0t.com",
    "xn--c3cralk2a3ak7a8c7angjb8s.com",
    "xn--c3cralk2a3ak7a8c7anpbd4s.com",
    "xn--c3cralk2a3ak7a8ce5aoqf4s.com",
    "xn--c3cranh6a3ae7a0d7andcr3s.com",
    "xn--c3cranh6a3ae7a0d7aqchj3s.com",
    "xn--c3cranh6a3ae7a0d7ashdf3s.com",
    "xn--c3cranh6a3ae7a0db8aulf3s.com",
    "xn--c3cranh6a3ae7a1d7bjfq.com",
    "xn--c3cranh6a3ae7a2hfdfq.com",
    "xn--c3cranh6a3ae7a8gdcpq.com",
    "xn--c3crat5cva1fdm.com",
    "xn--c3crat5cva4edv.com",
    "xn--c3crat5cva5bbzz9l.com",
    "xn--c3crat5cva5byakd0n.com",
    "xn--c3crat5cva5byatd9l.com",
    "xn--c3crat5cva6b4bm.com",
    "xn--c3cro5br0ed.com",
    "xn--caddeparfm-ieb.com",
    "xn--canldabahis-2zb.com",
    "xn--centresantles4chemins-k5b.com",
    "xn--cest9b816c0pi.top",
    "xn--ciqp94mlxb.com",
    "xn--cjr6vo4e4za759t.site",
    "xn--clodflare-is7d.net",
    "xn--cloudflar-3f7d.com",
    "xn--cloudflar-3f7d.net",
    "xn--cloudflre-676d.com",
    "xn--cloudflre-676d.net",
    "xn--clouflare-t05d.com",
    "xn--cludflare-ml7d.com",
    "xn--cludflare-ml7d.net",
    "xn--comunicaci21-9hb.cat",
    "xn--coudflare-qd6d.com",
    "xn--coudflare-qd6d.net",
    "xn--cret-bpa.holiday",
    "xn--cretholiday-bbb.com",
    "xn--cykelfrmjandet-cib.se",
    "xn--d-bga.net",
    "xn--d1abanakcffihf.xn--p1ai",
    "xn--d1abbzibngdp5b.com",
    "xn--d1abvjohn.xn--p1ai",
    "xn--d1accgi1b.xn--p1ai",
    "xn--d1acfzfa1ao.xn--p1ai",
    "xn--d2q.net",
    "xn--darma-2ta.xyz",
    "xn--desayuno-tnico-jkb.info",
    "xn--dimensin-normalizada-h8b.info",
    "xn--dlqv1x88bf9qm66a.xyz",
    "xn--dncesizlerkulbesi-22bam97r.xyz",
    "xn--dqrq6ooqkh75c.xn--6qq986b3xl",
    "xn--duzv1q24e.top",
    "xn--dveloppersaconfiance-b2b.com",
    "xn--dy-hpa.shop",
    "xn--e1aajicnj.xn--p1ai",
    "xn--e1aanqhdr3a2d.xn--p1ai",
    "xn--e1aef6b4c.xn--p1ai",
    "xn--e1afgidgbjksq6gj2a.xn--p1ai",
    "xn--e1afhbdbtuhcg3i.xn--p1ai",
    "xn--e1afkbvo.xn--p1ai",
    "xn--e1agcemeeaqni.xn--p1ai",
    "xn--e1aggeflfmdhfk9bc5f.xn--p1ai",
    "xn--e5xx98d.top",
    "xn--efvt95f.com",
    "xn--efvw9ai28f.xn--6qq986b3xl",
    "xn--ehquh6ex304a.top",
    "xn--f1ahmbfbv.xn--p1acf",
    "xn--f5qp63o.xn--6qq986b3xl",
    "xn--farr-epa.cat",
    "xn--faturakart-6ub.com",
    "xn--fed.com",
    "xn--fiq06l2rdsvs.online",
    "xn--fiq06l2rdsvs.site",
    "xn--fiq06l2rdsvs.tech",
    "xn--fiq64f9jv65a.com",
    "xn--fiqz9sm5fhob0y1f.xn--czru2d",
    "xn--fnva655m.xn--6qq986b3xl",
    "xn--fnvur060a.xn--6qq986b3xl",
    "xn--fnvv98hjkf.xn--6qq986b3xl",
    "xn--foto-en-el-lbum-xjb.info",
    "xn--gilnationalreserve-dwb.com",
    "xn--gorrinrosa-kbb.info",
    "xn--gratislna-c3a.se",
    "xn--grqt44d.xn--6qq986b3xl",
    "xn--gteborgbergvrme-clb80a.se",
    "xn--gtvz22d7vt.com",
    "xn--gvsy1c432dt4b73w.com",
    "xn--gzr198hqyb.xn--6qq986b3xl",
    "xn--h1aaiwdck.xn--p1ai",
    "xn--h1adgawn.xn--p1ai",
    "xn--h1afienjpoj.xn--p1ai",
    "xn--h3t3kv19csvc4qh.wang",
    "xn--h3t41m4st.com",
    "xn--h3t41m4stzge.com",
    "xn--h3t41m6yx.com",
    "xn--h43axb.asia",
    "xn--hilbetyenigiri-8zc.com",
    "xn--hospedagem-de-vdeo-vyb.info",
    "xn--hottetser-q8a.com",
    "xn--hrrw02b809a.xn--6qq986b3xl",
    "xn--huslkaren-y2a.se",
    "xn--hxyvmr52c.xn--6qq986b3xl",
    "xn--hyra-buss-gteborg-9zb.se",
    "xn--i8s19v917a.com",
    "xn--ida.online",
    "xn--ida.website",
    "xn--ihq702hpui.top",
    "xn--ihqa136rhf6b.xn--6qq986b3xl",
    "xn--iloveand-5z9m0a.gq",
    "xn--instgram-cza.com",
    "xn--j6h.ml",
    "xn--jkrzr252dtnal80f95bk17d.top",
    "xn--jurdicorobot-ufb.com",
    "xn--k3wn9edz8c.xn--6qq986b3xl",
    "xn--kbr860dxgb522ac8c.com",
    "xn--kksrenoveringgvle-3qb24a.se",
    "xn--kksrenoveringnorrkping-uhcr.se",
    "xn--kksrenoveringstersund-hecm.se",
    "xn--kltrkrtasiye-dlbc11f.com",
    "xn--koltukrts-57a2eb.com",
    "xn--krhemp-3ya.com",
    "xn--l1b.live",
    "xn--l3caiixzj3a4a0a4bofr.com",
    "xn--l3caiixzj3a4a0a4bovk1p.com",
    "xn--l3caiixzj3a4a7dghbv.com",
    "xn--l3caiixzj3a4a7dnbdr.com",
    "xn--l3caiixzj3a4aw7anddj0t.com",
    "xn--l3caiixzj3a4aw7angjb8s.com",
    "xn--l3caiixzj3a4awe5aoq9a9nla.com",
    "xn--l3caiixzj3a4awe5aoqf4s.com",
    "xn--l3cajg0aze3a4a0a3cjfq.com",
    "xn--l3cajg0aze3a4a0a3copf1p.com",
    "xn--l3cajg0aze3a4a0edcpq.com",
    "xn--l3cajg0aze3a4a0efopf1p.com",
    "xn--l3cajg0aze3a4a5efdfq.com",
    "xn--l3cajg0aze3a4az7anfqy7pg.com",
    "xn--l3cajg0aze3a4az7aqchj3s.com",
    "xn--l3cajg0aze3a4azb8auqy7pg.com",
    "xn--l3cao5brv2ceq.com",
    "xn--l3cao5brv6cdm.com",
    "xn--l3cao5brv9bdv.com",
    "xn--l3cao5brv9bwaf1j.com",
    "xn--l3cao5brvqbz9b6hg.com",
    "xn--l3cao5brvqyk7a9ig.com",
    "xn--l3cao5brvqyng3m.com",
    "xn--l3cao5brvqytd9l.com",
    "xn--l3cao5brvr8cf1j.com",
    "xn--l3cj5ans2bd.com",
    "xn--l3cj5ans5bd.com",
    "xn--l3cj5ans8bd.com",
    "xn--l3clf0bb4at.world",
    "xn--l8v25u.xn--6qq986b3xl",
    "xn--leccindemsica-flb3i.info",
    "xn--ledigajobbbors-xib.se",
    "xn--lgbabba2ddn0k1a86eemd79bgab.com",
    "xn--livredadepresso-xkb.com",
    "xn--lna10000krdirekt-dob.se",
    "xn--lndle-gra.dev",
    "xn--lndwirt-hwa.com",
    "xn--lttflrt-5wa0o.se",
    "xn--lyv9g077hwjg.xn--6qq986b3xl",
    "xn--m3cso0a9e4c3a.com",
    "xn--malmstronomy-7ib.se",
    "xn--marknadsfring-qmb.xyz",
    "xn--mcdonals-8bb.com",
    "xn--mes89wv6wqby9a05u.site",
    "xn--mes89wv6wqby9a05u.website",
    "xn--mgb.online",
    "xn--mgbaak8abb3osw7v.com",
    "xn--mgbabc8be3kg.xn--mgbab2bd",
    "xn--mgbad8a0b2cxa.com",
    "xn--mgbgvi3fi.com",
    "xn--mgbgz7e0zxg.com",
    "xn--mgbq7clv.com",
    "xn--mirn-xpa7a.xyz",
    "xn--mlareume-9zah.nu",
    "xn--mll-hoa.email",
    "xn--mllemail-65a.com",
    "xn--mllmail-n2a.com",
    "xn--mnq99h22t4u6c.xn--6qq986b3xl",
    "xn--mzn-elan1g.com",
    "xn--namnh-7ya4834c.net",
    "xn--ndice-ysa.com",
    "xn--nds7pu7ag41mqka.top",
    "xn--nepreminine-split-zcc.com",
    "xn--nlqp3yv9o.xn--6qq986b3xl",
    "xn--nlqr7k134a.xn--6qq986b3xl",
    "xn--norrkpingmlare-uib0y.se",
    "xn--ntex24-3ua.net",
    "xn--o39a10at55b6sdcrf.com",
    "xn--ob0br3r1td81o8tc.com",
    "xn--obyv86a.xn--6qq986b3xl",
    "xn--ok0bo94b1pav74c.com",
    "xn--ot24-px9g.biz",
    "xn--otomotivingelecei-imc.com",
    "xn--otu027d.com",
    "xn--p89anzg24betd54dkw2abqa.shop",
    "xn--pararse-as-t8a.info",
    "xn--parasepeti-q6a.com",
    "xn--parasoescondido-7ob.com",
    "xn--paypa-9tb.com",
    "xn--pddf8i.com",
    "xn--pedescalo-x3a.com",
    "xn--planteraltt-t8a.com",
    "xn--planteraltt-t8a.nu",
    "xn--planteraltt-t8a.se",
    "xn--pn1am9c0zp.xn--6qq986b3xl",
    "xn--pq1ax85b.xn--6qq986b3xl",
    "xn--princessbetgiri1-0dd.com",
    "xn--prncessbet1-0zb.com",
    "xn--q3cadn7dwbj.com",
    "xn--q3caxbff8ccp6afk4qmeqc.net",
    "xn--q5v250a.xn--6qq986b3xl",
    "xn--q5vu48cuko.xn--6qq986b3xl",
    "xn--qxam.xyz",
    "xn--r2baebyf8c2dtc.com",
    "xn--ray-bg-2h6j.net",
    "xn--razn-para-sonrer-nsb9g.info",
    "xn--realmatc-y09c.com",
    "xn--redovisningsbyrjnkping-25b32bc.nu",
    "xn--refeio-7ta5a.online",
    "xn--rgfest-vxa4c.com",
    "xn--rhqt5tmrbt30afkiqpk45b.top",
    "xn--robotjurdico-zfb.com",
    "xn--rrmokarejnkping-8sbic.nu",
    "xn--rrmokarenorrkping-zzbm.com",
    "xn--saatbahaber-4zb11d.com",
    "xn--sakerhetsdrrar-4pb.se",
    "xn--sdertrnsfjrrvrme-4nbd24ae.com",
    "xn--sdertrnsfjrrvrme-4nbd24ae.nu",
    "xn--sdertrnsfjrrvrme-4nbd24ae.se",
    "xn--seorcane-e3a.com",
    "xn--seorgol-5za.com",
    "xn--sheyd8kejer-thb.xyz",
    "xn--sk-fka.xyz",
    "xn--skerhetsvst-l8ai.se",
    "xn--skidvder-4za.nu",
    "xn--smrtforum-w2a.se",
    "xn--sngkheep-qcb2527era.com",
    "xn--snr894bgn9a.xn--6qq986b3xl",
    "xn--soclich-hya.com",
    "xn--sprq0xrsg4w0ad9q.com",
    "xn--sqrr42azne.xn--6qq986b3xl",
    "xn--stambytegvle-ocb.se",
    "xn--stambyteume-78a.se",
    "xn--sttvgsbehandlingstockholm-ffc07b.nu",
    "xn--svenskkrnkraft-cib.se",
    "xn--szsr02aej7b.xn--6qq986b3xl",
    "xn--t-tma.xyz",
    "xn--tacklggareoxelsund-ptb38a.se",
    "xn--taklggareneskilstuna-ezb.se",
    "xn--taklggarenrebro-3kb62a.se",
    "xn--taklggarenvsters-ynbhx.nu",
    "xn--taklggarestockholm-otb.nu",
    "xn--taklggareume-jcbw.nu",
    "xn--taxinykping-xfb.se",
    "xn--thepiratbay-ibb.org",
    "xn--thepratebay-rcb.org",
    "xn--thpiratebay-cbb.org",
    "xn--til-e-emocionante-01b.info",
    "xn--tiqz61cv9ct44b.asia",
    "xn--tl3br0fpo32jc0f.net",
    "xn--tn1b.com",
    "xn--tn1b.net",
    "xn--toms-2na.cat",
    "xn--tryggmklare-q8a.se",
    "xn--u1sz81f.xn--6qq986b3xl",
    "xn--ucyx6wl7n.xn--6qq986b3xl",
    "xn--undaoscuro-m8a.info",
    "xn--uxq98sdy1b.xn--6qq986b3xl",
    "xn--uzzfeed-22a.com",
    "xn--v30bm5byymr7m.org",
    "xn--v3chobrp9cc6k.com",
    "xn--vk5b29y.com",
    "xn--vo4b.com",
    "xn--vo4b.net",
    "xn--vuqutg24mksf.com",
    "xn--w4rx21m.xn--6qq986b3xl",
    "xn--w9sp0j4wg.xn--6qq986b3xl",
    "xn--wcso4nxt0ar2j.com",
    "xn--wda.net",
    "xn--wgkln-lua.org",
    "xn--wkr.cf",
    "xn--wkr.gq",
    "xn--wkzv32d4sb.xn--6qq986b3xl",
    "xn--wlr283c.xn--6qq986b3xl",
    "xn--wxwta994t.xn--ses554g",
    "xn--x2a.ltd",
    "xn--x49ap35a6odo7t.net",
    "xn--x8q24mjzay63b.top",
    "xn--xsq77xgu2c.xn--6qq986b3xl",
    "xn--xt1ao2o.xn--6qq986b3xl",
    "xn--xyz-t33er8o.xyz",
    "xn--yenialdm-zkb.com",
    "xn--yfr2t843afc006birqehc.top",
    "xn--yfrx98av8bba7543a.biz",
    "xn--yh4bv0ldmk.site",
    "xn--yivy24d73j.com",
    "xn--ynvs5nc94a.xn--6qq986b3xl",
    "xn--ynyz0b.com",
    "xn--yuniverse-l4a.net",
    "xn--yuniversity-nbb.com",
    "xn--yuuniversity-oeb.com",
    "xn--z1t717ba.xn--6qq986b3xl",
    "xn--z1tn3mqw8c.xn--6qq986b3xl",
    "xn--z1tq4lqsl.xn--6qq986b3xl",
    "xn--z1tt9kjxh.xn--6qq986b3xl",
    "xn--ztsu23a.com",
    "xnefa7dpydciob6wu9.cf",
    "xnefa7dpydciob6wu9.ga",
    "xnefa7dpydciob6wu9.gq",
    "xnefa7dpydciob6wu9.ml",
    "xnefa7dpydciob6wu9.tk",
    "xneu.com",
    "xngirls.fun",
    "xnmail.mooo.com",
    "xnnpdqjow.shop",
    "xnogl.us",
    "xnscy.xyz",
    "xnsmm.xyz",
    "xnssf.xyz",
    "xnszp.xyz",
    "xnttjtpuk.shop",
    "xntub.site",
    "xnxn.biz",
    "xnxxa.fun",
    "xnxxa.site",
    "xnxxb.site",
    "xnxxmov.site",
    "xnxxn.space",
    "xnxxs.site",
    "xnxxt.online",
    "xnxxtube.site",
    "xnxxup.site",
    "xnxxv.site",
    "xnxxv.top",
    "xnxxz.site",
    "xnxzzz.com",
    "xnycy.best",
    "xo0.buzz",
    "xo0yvn.com",
    "xoballoon.com",
    "xodu.site",
    "xoduje.info",
    "xogolden.com",
    "xography.site",
    "xohi.site",
    "xoifyjcyj.shop",
    "xoixa.com",
    "xokdgw.site",
    "xolox.xyz",
    "xoolexa.xyz",
    "xoom.com",
    "xoommail.com",
    "xormail.net",
    "xormail.org",
    "xoru.ga",
    "xoso.online",
    "xoso168.org",
    "xoso889.net",
    "xost.us",
    "xov0qq.info",
    "xowxdd4w4h.cf",
    "xowxdd4w4h.ga",
    "xowxdd4w4h.gq",
    "xowxdd4w4h.ml",
    "xowxdd4w4h.tk",
    "xoxaxoda.site",
    "xoxo1688.com",
    "xoxox.cc",
    "xoxy.net",
    "xoxy.uk",
    "xoxy.work",
    "xoyctl.com",
    "xoze0.us",
    "xp603.top",
    "xp6tq6vet4tzphy6b0n.cf",
    "xp6tq6vet4tzphy6b0n.ga",
    "xp6tq6vet4tzphy6b0n.gq",
    "xp6tq6vet4tzphy6b0n.ml",
    "xp6tq6vet4tzphy6b0n.tk",
    "xpalcomp3.xyz",
    "xpartner.site",
    "xpaw.net",
    "xpdyab.site",
    "xpectmore.com",
    "xpee.tk",
    "xperiae5.com",
    "xpert.tech",
    "xphyk.fun",
    "xpict.buzz",
    "xpict.site",
    "xpiyg.com",
    "xpj-333.com",
    "xpj100999.com",
    "xpjbct.com",
    "xpjfvmjq.shop",
    "xplannersr.com",
    "xplanningzx.com",
    "xplaytamil.pro",
    "xploit.ml",
    "xploreazadkashmir.com",
    "xplornet.com",
    "xploziya.xyz",
    "xpoker99.asia",
    "xposenet.ooo",
    "xposible.info",
    "xpouch.com",
    "xpressbattery.com",
    "xpressionisme.com",
    "xpressmail.zzn.com",
    "xprice.co",
    "xproxyhost.com",
    "xpsatnzenyljpozi.cf",
    "xpsatnzenyljpozi.ga",
    "xpsatnzenyljpozi.gq",
    "xpsatnzenyljpozi.ml",
    "xpsatnzenyljpozi.tk",
    "xpslots.com",
    "xpslotscasino.com",
    "xq-diamond.com",
    "xqcenter.com",
    "xqfhm1.site",
    "xqonu.us",
    "xqsdr.com",
    "xqur.xyz",
    "xqworks.com",
    "xqwuia.icu",
    "xqyoqwnpl.shop",
    "xqzsale.top",
    "xr232.com",
    "xrbsgv.us",
    "xreiesx.club",
    "xrerlf.us",
    "xret.com",
    "xrewspro.site",
    "xrg7vtiwfeluwk.cf",
    "xrg7vtiwfeluwk.ga",
    "xrg7vtiwfeluwk.gq",
    "xrg7vtiwfeluwk.ml",
    "xrg7vtiwfeluwk.tk",
    "xrho.com",
    "xrlackli.shop",
    "xrlihiuvt.shop",
    "xrmdvvkre.shop",
    "xroenv.us",
    "xrohan.ga",
    "xrplug.com",
    "xrpmail.com",
    "xrqsoz.us",
    "xrqwooehh.shop",
    "xrsig.us",
    "xrxrxr.host",
    "xrzgxj.icu",
    "xs188.net",
    "xs31xs.com",
    "xs31xs.info",
    "xs31xs.org",
    "xs31xs.xyz",
    "xs4all.nl",
    "xs5lfo.site",
    "xsbetter20.xyz",
    "xsbyby.com",
    "xscrape.com",
    "xsecurity.org",
    "xsellize.xyz",
    "xsgb2v.host",
    "xshoestop.info",
    "xsil43fw5fgzito.cf",
    "xsil43fw5fgzito.ga",
    "xsil43fw5fgzito.gq",
    "xsil43fw5fgzito.ml",
    "xsil43fw5fgzito.tk",
    "xsingles.online",
    "xsingles.site",
    "xsiteservice.com",
    "xsjfl.info",
    "xsjfl.org",
    "xsjfl.xyz",
    "xskt168.com",
    "xsmail.com",
    "xsnapbet2020.xyz",
    "xsnapbett.xyz",
    "xsqc54.com",
    "xsrrug.tokyo",
    "xss.science",
    "xssworm.com",
    "xstabbettsnupp2020.xyz",
    "xstabetsnup.xyz",
    "xstabilbettingsnap.xyz",
    "xstabilbettsnapp.xyz",
    "xstabilitybettingsnapp.xyz",
    "xstdshmpz.shop",
    "xstrerilize.com",
    "xswtrl.com",
    "xt6jn.us",
    "xtbanke.com",
    "xtgg8f.site",
    "xtggarshz.shop",
    "xtguj.com",
    "xthemes.xyz",
    "xtknrv.us",
    "xtm7vr.us",
    "xtnr2cd464ivdj6exro.cf",
    "xtnr2cd464ivdj6exro.ga",
    "xtnr2cd464ivdj6exro.gq",
    "xtnr2cd464ivdj6exro.ml",
    "xtnr2cd464ivdj6exro.tk",
    "xtocqw.club",
    "xtojnhpq.shop",
    "xtq6mk2swxuf0kr.cf",
    "xtq6mk2swxuf0kr.ga",
    "xtq6mk2swxuf0kr.gq",
    "xtq6mk2swxuf0kr.ml",
    "xtq6mk2swxuf0kr.tk",
    "xtra.co.nz",
    "xtram.com",
    "xtrars.ga",
    "xtrars.ml",
    "xtremenano9h.net",
    "xtremerouters.com",
    "xtremeventure.com",
    "xtrzeer.fun",
    "xtubemate.site",
    "xtuc.com",
    "xtxfdwe03zhnmrte0e.ga",
    "xtxfdwe03zhnmrte0e.ml",
    "xtxfdwe03zhnmrte0e.tk",
    "xtzverostrore.com",
    "xubawe.info",
    "xubqgqyuq98c.cf",
    "xubqgqyuq98c.ga",
    "xubqgqyuq98c.gq",
    "xubqgqyuq98c.ml",
    "xubqgqyuq98c.tk",
    "xudttnik4n.cf",
    "xudttnik4n.ga",
    "xudttnik4n.gq",
    "xudttnik4n.ml",
    "xudttnik4n.tk",
    "xueshenka.com",
    "xueziwo.com",
    "xuiahyobv.shop",
    "xuj56.us",
    "xumail.cf",
    "xumail.ga",
    "xumail.gq",
    "xumail.ml",
    "xumail.tk",
    "xumberleop.ru",
    "xumku.ru",
    "xundayule.com",
    "xunfood.com",
    "xunixiaozhan.com",
    "xunlei.ml",
    "xuno.com",
    "xuora.com",
    "xupace.info",
    "xusujyi.space",
    "xutd8o2izswc3ib.xyz",
    "xuuxmo1lvrth.cf",
    "xuuxmo1lvrth.ga",
    "xuuxmo1lvrth.gq",
    "xuuxmo1lvrth.ml",
    "xuuxmo1lvrth.tk",
    "xuwome.info",
    "xuwphq72clob.cf",
    "xuwphq72clob.ga",
    "xuwphq72clob.gq",
    "xuwphq72clob.ml",
    "xuwphq72clob.tk",
    "xuxx.gq",
    "xuyushuai.com",
    "xv9u9m.com",
    "xvcezxodtqzbvvcfw4a.cf",
    "xvcezxodtqzbvvcfw4a.ga",
    "xvcezxodtqzbvvcfw4a.gq",
    "xvcezxodtqzbvvcfw4a.ml",
    "xvcezxodtqzbvvcfw4a.tk",
    "xvpkrm.online",
    "xvpz6c.us",
    "xvx.us",
    "xwa3up.us",
    "xwaretech.com",
    "xwaretech.info",
    "xwaretech.net",
    "xwaretech.tk",
    "xwcbk1.site",
    "xwdmoe.cf",
    "xwfzlvjb.shop",
    "xwgpzgajlpw.cf",
    "xwgpzgajlpw.ga",
    "xwgpzgajlpw.gq",
    "xwgpzgajlpw.ml",
    "xwgpzgajlpw.tk",
    "xwmca1.site",
    "xwo4ua.us",
    "xwpet8imjuihrlgs.cf",
    "xwpet8imjuihrlgs.ga",
    "xwpet8imjuihrlgs.gq",
    "xwpet8imjuihrlgs.ml",
    "xwpet8imjuihrlgs.tk",
    "xww.ro",
    "xwyzperlkx.cf",
    "xwyzperlkx.ga",
    "xwyzperlkx.gq",
    "xwyzperlkx.ml",
    "xwyzperlkx.tk",
    "xwzowgfnuuwcpvm.cf",
    "xwzowgfnuuwcpvm.ga",
    "xwzowgfnuuwcpvm.gq",
    "xwzowgfnuuwcpvm.ml",
    "xwzowgfnuuwcpvm.tk",
    "xx-9.tk",
    "xx-ms98.online",
    "xx-xgirls.fun",
    "xx-xgirls.host",
    "xx11.icu",
    "xx1775.com",
    "xx18269.com",
    "xx44.xyz",
    "xx57822.com",
    "xx6699.com",
    "xx9094.com",
    "xxbb834.info",
    "xxckefu.online",
    "xxckefu.xyz",
    "xxdane5p2nj8mbi.xyz",
    "xxgirls.site",
    "xxhaili.com",
    "xxhamsterxx.ga",
    "xxhu70.com",
    "xxhu74.com",
    "xxhu76.com",
    "xxi2.com",
    "xxiyh.us",
    "xxjj068.xyz",
    "xxjj072.xyz",
    "xxjj073.xyz",
    "xxjj074.xyz",
    "xxjj075.xyz",
    "xxjj077.xyz",
    "xxjj078.xyz",
    "xxjj079.xyz",
    "xxjj080.xyz",
    "xxjj081.xyz",
    "xxjj082.xyz",
    "xxjj083.xyz",
    "xxjj084.xyz",
    "xxjj085.xyz",
    "xxjj086.xyz",
    "xxjj087.xyz",
    "xxjj089.xyz",
    "xxjj090.xyz",
    "xxjj091.xyz",
    "xxjj093.xyz",
    "xxjj094.xyz",
    "xxjj096.xyz",
    "xxjj098.xyz",
    "xxjj099.xyz",
    "xxkangli.com",
    "xxldruckerei.de",
    "xxlocanto.us",
    "xxme.me",
    "xxolocanto.us",
    "xxpm12pzxpom6p.cf",
    "xxpm12pzxpom6p.ga",
    "xxpm12pzxpom6p.gq",
    "xxpm12pzxpom6p.ml",
    "xxpm12pzxpom6p.tk",
    "xxqx3802.com",
    "xxs.buzz",
    "xxshe.info",
    "xxsxnr.tokyo",
    "xxtreamcam.com",
    "xxtxmore.online",
    "xxtxmuse.best",
    "xxtxtime.site",
    "xxvl.xyz",
    "xxw22.com",
    "xxx-chatten.online",
    "xxx-gif.com",
    "xxx-strory.ru",
    "xxx.sytes.net",
    "xxx28.ru",
    "xxx36.ru",
    "xxx65.ru",
    "xxx72.ru",
    "xxx72.space",
    "xxx73.space",
    "xxx75.space",
    "xxx76.space",
    "xxx81.space",
    "xxx83.space",
    "xxx84.space",
    "xxx9827.com",
    "xxxa.online",
    "xxxa.site",
    "xxxa.space",
    "xxxamazing.com",
    "xxxany.site",
    "xxxb.fun",
    "xxxbig.site",
    "xxxbomb.site",
    "xxxbox.site",
    "xxxc.fun",
    "xxxcam.ooo",
    "xxxclips.site",
    "xxxcock.site",
    "xxxd.fun",
    "xxxdreams.site",
    "xxxe.club",
    "xxxe.fun",
    "xxxe.online",
    "xxxe.site",
    "xxxe.top",
    "xxxe.website",
    "xxxf.fun",
    "xxxf.site",
    "xxxflashgaming.com",
    "xxxfresh.site",
    "xxxfunny.site",
    "xxxfuns.site",
    "xxxg.fun",
    "xxxg.site",
    "xxxgamesshop.com",
    "xxxgirls.online",
    "xxxh.fun",
    "xxxh.site",
    "xxxh.space",
    "xxxhdtv.top",
    "xxxhdv.site",
    "xxxhdv.top",
    "xxxhi.site",
    "xxxhot.fun",
    "xxxhot.site",
    "xxxhot.space",
    "xxxi.club",
    "xxxi.fun",
    "xxxi.site",
    "xxxi.space",
    "xxxi.website",
    "xxxin.site",
    "xxxj.fun",
    "xxxj.site",
    "xxxju.site",
    "xxxjust.com",
    "xxxk.fun",
    "xxxk.site",
    "xxxk.space",
    "xxxking.site",
    "xxxl.fun",
    "xxxlive.ooo",
    "xxxlx.site",
    "xxxm.fun",
    "xxxm.online",
    "xxxm.site",
    "xxxmature.mobi",
    "xxxmob.fun",
    "xxxmovs.fun",
    "xxxmovs.site",
    "xxxmp4.site",
    "xxxmx.site",
    "xxxn.fun",
    "xxxn.online",
    "xxxn.site",
    "xxxn.website",
    "xxxnew.site",
    "xxxnxx.fun",
    "xxxnxx.site",
    "xxxo.fun",
    "xxxo.online",
    "xxxo.site",
    "xxxo.space",
    "xxxo.website",
    "xxxok.site",
    "xxxooo.site",
    "xxxorgy.site",
    "xxxp.fun",
    "xxxp.online",
    "xxxpawme.com",
    "xxxpure.site",
    "xxxq.fun",
    "xxxq.site",
    "xxxr.fun",
    "xxxred.fun",
    "xxxred.site",
    "xxxred.xyz",
    "xxxs.buzz",
    "xxxs.online",
    "xxxs.site",
    "xxxs.website",
    "xxxshort.com",
    "xxxsn.site",
    "xxxstars.site",
    "xxxsweet.site",
    "xxxsx.site",
    "xxxt.fun",
    "xxxtext.site",
    "xxxtub.fun",
    "xxxtyt.ru",
    "xxxu.fun",
    "xxxu.site",
    "xxxv.fun",
    "xxxv.online",
    "xxxv.website",
    "xxxvids.site",
    "xxxvs.site",
    "xxxvx.site",
    "xxxw.fun",
    "xxxw.online",
    "xxxw.site",
    "xxxw.space",
    "xxxw.website",
    "xxxwap.site",
    "xxxy.space",
    "xxxy.website",
    "xxxz.online",
    "xxxz.site",
    "xxxz.space",
    "xy-78.com",
    "xy1qrgqv3a.cf",
    "xy1qrgqv3a.ga",
    "xy1qrgqv3a.gq",
    "xy1qrgqv3a.ml",
    "xy1qrgqv3a.tk",
    "xy2jg.us",
    "xy66699.com",
    "xy9ce.tk",
    "xycp5556.com",
    "xycp5557.com",
    "xycp7775.com",
    "xycp8880.com",
    "xycp8882.com",
    "xycp8883.com",
    "xycp8885.com",
    "xyguja.ru",
    "xygy.site",
    "xyhjzg.com",
    "xymailpro.com",
    "xymgzp.com",
    "xypo.site",
    "xyso.site",
    "xysthjx.com",
    "xystus.site",
    "xytexinternational.com",
    "xyussmc.xyz",
    "xyz.am",
    "xyzbnj.com",
    "xyzcasinoforum.xyz",
    "xyzcasinositeleri.xyz",
    "xyzdzw.com",
    "xyzfree.net",
    "xyzmail.men",
    "xyzmailhub.com",
    "xyzpoker.club",
    "xyzsite.space",
    "xz3.net",
    "xz8syw3ymc.cf",
    "xz8syw3ymc.ga",
    "xz8syw3ymc.gq",
    "xz8syw3ymc.ml",
    "xz8syw3ymc.tk",
    "xzapmail.com",
    "xzavier1121.club",
    "xzbags.com",
    "xzcameras.com",
    "xzcloth2.online",
    "xzcsrv41.life",
    "xzcsrv44.life",
    "xzcsrv45.life",
    "xzcsrv46.life",
    "xzcsrv51.life",
    "xzcsrv55.life",
    "xzcsrv56.life",
    "xzcsrv58.life",
    "xzcsrv61.life",
    "xzcsrv62.life",
    "xzcsrv63.life",
    "xzcsrv64.life",
    "xzcsrv65.life",
    "xzcsrv66.life",
    "xzcsrv69.life",
    "xzcsrv70.life",
    "xzcsrv72.life",
    "xzcsrv74.life",
    "xzcsrv75.life",
    "xzcsrv76.life",
    "xzcsrv79.life",
    "xzcsrv80.life",
    "xzcsrv82.life",
    "xzcsrv83.life",
    "xzcsrv84.life",
    "xzcsrv85.life",
    "xzcsrv88.life",
    "xzcsrv89.life",
    "xzcsrv90.life",
    "xzcsrv91.life",
    "xzcsrv92.life",
    "xzcsrv95.life",
    "xzcsrv98.life",
    "xzcsrv99.life",
    "xzdcn.com",
    "xzemw.us",
    "xzephzdt.shop",
    "xzhanziyuan.xyz",
    "xzifgx.icu",
    "xzjwtsohya3.cf",
    "xzjwtsohya3.ga",
    "xzjwtsohya3.gq",
    "xzjwtsohya3.ml",
    "xzjwtsohya3.tk",
    "xzljdt.com",
    "xzmic.com",
    "xzoahsuyb.shop",
    "xzqrepurlrre7.cf",
    "xzqrepurlrre7.ga",
    "xzqrepurlrre7.gq",
    "xzqrepurlrre7.ml",
    "xzqrepurlrre7.tk",
    "xzsok.com",
    "xzxmymfz.shop",
    "xzymoe.edu.pl",
    "y-3sapfirov.ru",
    "y-andekac.ru",
    "y-turist.ru",
    "y-voronezh.ru",
    "y.bcb.ro",
    "y.email.ne.jp",
    "y.lochou.fr",
    "y033w3bs1t3a99m0b113.xyz",
    "y05.xyz",
    "y06nr.info",
    "y0brainx6.com",
    "y0cocb.us",
    "y0ituhabqwjpnua.cf",
    "y0ituhabqwjpnua.ga",
    "y0ituhabqwjpnua.gq",
    "y0ituhabqwjpnua.ml",
    "y0ituhabqwjpnua.tk",
    "y0rkhm246kd0.cf",
    "y0rkhm246kd0.ga",
    "y0rkhm246kd0.gq",
    "y0rkhm246kd0.ml",
    "y0rkhm246kd0.tk",
    "y0up0rn.cf",
    "y0up0rn.ga",
    "y0up0rn.gq",
    "y0up0rn.ml",
    "y0up0rn.tk",
    "y1ajs4.us",
    "y1djbz.us",
    "y1vmis713bucmc.cf",
    "y1vmis713bucmc.ga",
    "y1vmis713bucmc.gq",
    "y1vmis713bucmc.ml",
    "y1vmis713bucmc.tk",
    "y1wl0z.us",
    "y1xhu.us",
    "y1ybl.cloud",
    "y1zwny.us",
    "y20acz.com",
    "y20pq.site",
    "y20pt.site",
    "y2b.comx.cf",
    "y2d.xyz",
    "y2emu.us",
    "y2kpz7mstrj.cf",
    "y2kpz7mstrj.ga",
    "y2kpz7mstrj.gq",
    "y2kpz7mstrj.ml",
    "y2kpz7mstrj.tk",
    "y2oleo.us",
    "y2ube.comx.cf",
    "y2zgop89uxtsk84.xyz",
    "y3dvb0bw947k.cf",
    "y3dvb0bw947k.ga",
    "y3dvb0bw947k.gq",
    "y3dvb0bw947k.ml",
    "y3dvb0bw947k.tk",
    "y3elp.com",
    "y3qryj.us",
    "y46abt.host",
    "y4s9.icu",
    "y56erx.us",
    "y5815.com",
    "y59.jp",
    "y5kbku.host",
    "y5q3pf.com",
    "y6ce.us",
    "y6npbt.us",
    "y70.net",
    "y75aff.site",
    "y7bbbbbbbbbbt8.ga",
    "y7mail.com",
    "y7sdpd.site",
    "y7ukrb.host",
    "y8c.info",
    "y8gbc.cloud",
    "y97998.com",
    "y981ppe1a07kphr.xyz",
    "y9827.com",
    "y9ewd.site",
    "ya-doctor.ru",
    "ya-gamer.ru",
    "ya-tourism.ru",
    "ya-tourist.ru",
    "ya-touristo.ru",
    "ya-tur.ru",
    "ya-turistik.ru",
    "ya-turistom.ru",
    "ya-tyt.ru",
    "ya.ru",
    "ya.yomail.info",
    "yaadgar-tullamore.com",
    "yabai-oppai.tk",
    "yabbadabbadoo.ru",
    "yabo0770.com",
    "yabo0990.com",
    "yabo7070.com",
    "yabo9090.com",
    "yabocg.com",
    "yaboda.shop",
    "yaboo.com",
    "yaburi.shop",
    "yabyoo.xyz",
    "yachassa09.com",
    "yachassa16.com",
    "yackir.store",
    "yada-yada.com",
    "yadavnaresh.com.np",
    "yadegarigift.icu",
    "yadong4.com",
    "yadongmall.shop",
    "yaelahrid.net",
    "yaelahtodkokgitu.cf",
    "yaelahtodkokgitu.ga",
    "yaelahtodkokgitu.gq",
    "yaelahtodkokgitu.ml",
    "yaelahtodkokgitu.tk",
    "yafri.se",
    "yagciogluajansmatbaa.xyz",
    "yagfiltresi.com",
    "yaha.com",
    "yahahayuk.fun",
    "yahane.shop",
    "yahantv.shop",
    "yahany.shop",
    "yahho.co.uk",
    "yahhoo.com",
    "yahmail.top",
    "yahnmtntxwhxtymrs.cf",
    "yahnmtntxwhxtymrs.ga",
    "yahnmtntxwhxtymrs.gq",
    "yahnmtntxwhxtymrs.ml",
    "yahnmtntxwhxtymrs.tk",
    "yaho.com",
    "yahomail.top",
    "yahon.com",
    "yahoo-mail.ga",
    "yahoo-team.org",
    "yahoo.ae",
    "yahoo.ar",
    "yahoo.at",
    "yahoo.be",
    "yahoo.ca",
    "yahoo.ch",
    "yahoo.cl",
    "yahoo.cm",
    "yahoo.cn",
    "yahoo.co",
    "yahoo.co.id",
    "yahoo.co.il",
    "yahoo.co.in",
    "yahoo.co.jp",
    "yahoo.co.kr",
    "yahoo.co.nz",
    "yahoo.co.th",
    "yahoo.co.uk",
    "yahoo.co.za",
    "yahoo.com",
    "yahoo.com.ar",
    "yahoo.com.asia",
    "yahoo.com.au",
    "yahoo.com.br",
    "yahoo.com.cn",
    "yahoo.com.co",
    "yahoo.com.es",
    "yahoo.com.hk",
    "yahoo.com.is",
    "yahoo.com.malaysia",
    "yahoo.com.mx",
    "yahoo.com.my",
    "yahoo.com.pe",
    "yahoo.com.ph",
    "yahoo.com.ru",
    "yahoo.com.sg",
    "yahoo.com.tr",
    "yahoo.com.tw",
    "yahoo.com.ve",
    "yahoo.com.vn",
    "yahoo.comx.cf",
    "yahoo.cz",
    "yahoo.de",
    "yahoo.dk",
    "yahoo.es",
    "yahoo.fi",
    "yahoo.fr",
    "yahoo.gr",
    "yahoo.hu",
    "yahoo.id",
    "yahoo.ie",
    "yahoo.in",
    "yahoo.it",
    "yahoo.jp",
    "yahoo.mx",
    "yahoo.my",
    "yahoo.net",
    "yahoo.netmail.tk",
    "yahoo.nl",
    "yahoo.no",
    "yahoo.om",
    "yahoo.ph",
    "yahoo.pl",
    "yahoo.pt",
    "yahoo.ro",
    "yahoo.ru",
    "yahoo.se",
    "yahoo.uk",
    "yahoo.vn",
    "yahoodashtrick.com",
    "yahoofs.com",
    "yahoomail.com",
    "yahoomails.site",
    "yahooo.com",
    "yahooo.xyz",
    "yahooproduct.com",
    "yahooproduct.net",
    "yahoosportstab.com",
    "yahooweb.co",
    "yahooxtra.co.nz",
    "yajasoo2.net",
    "yajasoo3.net",
    "yajoo.de",
    "yakgh.com",
    "yakimarealestateagents.com",
    "yakinikurestaurantejapones.com",
    "yakolhoznik.ru",
    "yalamail.com",
    "yale-lisboa.com",
    "yalelo.biz",
    "yalelo.pro",
    "yaleta.ru",
    "yalexonyegues.com",
    "yalild.tk",
    "yalla.com",
    "yalla.com.lb",
    "yalokh.site",
    "yalook.com",
    "yalovacakilliogrenciyurdu.xyz",
    "yalovaemlakevi.xyz",
    "yalovaklimaservisi.online",
    "yalovalisveris.com",
    "yalovamenar.xyz",
    "yalovamhaber.xyz",
    "yalovamuzik.com",
    "yam.com",
    "yamail.win",
    "yamalmashstroy.ru",
    "yaman3raby.com",
    "yamanaraby.com",
    "yamiyule88.com",
    "yammydog.com",
    "yamoa.shop",
    "yamory.shop",
    "yamuyade.site",
    "yan-dex.cf",
    "yan-dex.ga",
    "yan-dex.gq",
    "yan-dex.ml",
    "yan-dex.tk",
    "yana-dolgushina.ru",
    "yandecompany.ru",
    "yandere.cu.cc",
    "yandex-prosto.ru",
    "yandex-vladimir.ru",
    "yandex.by",
    "yandex.com",
    "yandex.com.tr",
    "yandex.comx.cf",
    "yandex.kz",
    "yandex.mail",
    "yandex.pl",
    "yandex.ru",
    "yandex.ua",
    "yandexdrive.pro",
    "yandexmail.cf",
    "yandexmail.ga",
    "yandexmail.gq",
    "yandextaxigp.ru",
    "yandextaxilider.ru",
    "yandx.icu",
    "yaner.icu",
    "yanet.me",
    "yannmail.win",
    "yaokpm.site",
    "yaoo.com",
    "yaoshe121.com",
    "yaoshe122.com",
    "yaoshe127.com",
    "yaoshe128.com",
    "yaoshe149.com",
    "yapbahsini112.com",
    "yapbahsini114.com",
    "yapkayyoldye.info",
    "yaple9.com",
    "yapohudeu.ru",
    "yapost.com",
    "yapped.net",
    "yaqp.com",
    "yaraon.cf",
    "yaraon.ga",
    "yaraon.gq",
    "yaraon.ml",
    "yaraon.tk",
    "yargerfamily.com",
    "yariga.org",
    "yarigasport.info",
    "yarigatv.net",
    "yarikadeh.org",
    "yarininogretmenleri.online",
    "yarininogretmenleri.xyz",
    "yarled.com",
    "yarmarka-alla.ru",
    "yarnpedia.cf",
    "yarnpedia.ga",
    "yarnpedia.gq",
    "yarnpedia.ml",
    "yarnpedia.tk",
    "yarra.click",
    "yarra.design",
    "yarra.studio",
    "yarzmail.xyz",
    "yasakvideo.net",
    "yasakvideo.org",
    "yasalbahisiddaa.info",
    "yasaljigoloajansi.info",
    "yasaltv.icu",
    "yase.xyz",
    "yaseebet90.org",
    "yasellerbot.xyz",
    "yaseminilan.com",
    "yaseutdcz.shop",
    "yasminavaniterson.info",
    "yasminbanks.buzz",
    "yasser.ru",
    "yasul.shop",
    "yasvoyurist.ru",
    "yatagandergisi.xyz",
    "yatecars.info",
    "yathaitakeaway.com",
    "yatou-rist.ru",
    "yatripath.com",
    "yatube11.com",
    "yatube13.com",
    "yatube8.com",
    "yatube9.com",
    "yaturistik.ru",
    "yaturistt.ru",
    "yaungshop.com",
    "yavdengah.ru",
    "yavinedr.digital",
    "yavolshebnik.ru",
    "yavsety.ru",
    "yawmail.com",
    "yayazhibo.com",
    "yayinakisi.info",
    "yayincilikokulu.com",
    "yayincilikokulu.net",
    "yayoo.com",
    "yazaral14.net",
    "yazilimfirmasi.com",
    "yb0hmi.us",
    "yb45tyvn8945.cf",
    "yb45tyvn8945.ga",
    "yb45tyvn8945.gq",
    "yb45tyvn8945.ml",
    "yb45tyvn8945.tk",
    "yb78oim.cf",
    "yb78oim.ga",
    "yb78oim.gq",
    "yb78oim.ml",
    "yb78oim.tk",
    "ybaznygl.shop",
    "ybb.ne.jp",
    "ybbltl.site",
    "ybdwz.com",
    "ybetsport.com",
    "ybgnzblml.shop",
    "ybmwukt.com",
    "ybozus.us",
    "ybq2.com",
    "ybq4.com",
    "ybrc8n.site",
    "ybsc1o.us",
    "ybtz1.com",
    "ybvip10.com",
    "ybw678.com",
    "ybwcf.site",
    "ybwjs.com",
    "ybwrh1.us",
    "ybyule88.com",
    "yc9obkmthnla2owe.cf",
    "yc9obkmthnla2owe.ga",
    "yc9obkmthnla2owe.gq",
    "yc9obkmthnla2owe.ml",
    "yc9obkmthnla2owe.tk",
    "yc9qv5.site",
    "ycare.de",
    "ycbfb.com",
    "yceqsd.tk",
    "ychatz.ga",
    "yckvz.com",
    "yclub.com",
    "ycn.ro",
    "ycrsnb.site",
    "yctfn.us",
    "ycwodpim.shop",
    "ycxe3h.us",
    "ycy-charm.com",
    "ycysale.top",
    "ycyuan.club",
    "ycyuan.site",
    "ycyuan.xyz",
    "yd-wf.com",
    "yd20q.site",
    "yd2444.com",
    "yd2yd.org",
    "yd3oqf.us",
    "yd7lw.us",
    "ydbdsgnn.shop",
    "ydd20.site",
    "ydeclinegv.com",
    "ydgeimrgd.shop",
    "ydhbbr.site",
    "ydhopn.us",
    "ydkscoyun.shop",
    "ydnwgkulh.shop",
    "ydouthink.com",
    "ydpggbwe.shop",
    "ydpq.site",
    "ydvrgaphk.shop",
    "ydwyw.com",
    "ydyl5.com",
    "ydzwnq.site",
    "ye.vc",
    "ye20p.site",
    "ye20q.site",
    "ye20t.site",
    "yeah.com",
    "yeah.net",
    "yeahm.cn",
    "yean.site",
    "yearbooks.xyz",
    "yearnbudge.buzz",
    "yearngra.xyz",
    "yearngras.xyz",
    "yebox.com",
    "yeckelk.tech",
    "yed20.site",
    "yedi.org",
    "yedkvgar.site",
    "yedp.site",
    "yedq.site",
    "yedt.site",
    "yedvmq.site",
    "yeeet.info",
    "yeehaa.com",
    "yeeshoes.store",
    "yeezus.ru",
    "yeezy888.com",
    "yehaa.com",
    "yeheey.xyz",
    "yehetang.info",
    "yehey.com",
    "yehha.xyz",
    "yej2lf.us",
    "yejdnp45ie1to.cf",
    "yejdnp45ie1to.ga",
    "yejdnp45ie1to.gq",
    "yejdnp45ie1to.ml",
    "yejdnp45ie1to.tk",
    "yek2pay.shop",
    "yelectronicsmost.info",
    "yelkivpos2.ru",
    "yelkons1.ru",
    "yellingjournal.com",
    "yellnbmv766.cf",
    "yellnbmv766.ga",
    "yellnbmv766.gq",
    "yellnbmv766.ml",
    "yellnbmv766.tk",
    "yellow.flu.cc",
    "yellow.hotakama.tk",
    "yellow.igg.biz",
    "yellowbearpropertymanagement.com",
    "yellowbearrealty.com",
    "yellowen.com",
    "yellowhandprint.com",
    "yelloww.ga",
    "yelloww.gq",
    "yelloww.ml",
    "yelloww.tk",
    "yelvin.info",
    "yemek46.com",
    "yemekizmit.xyz",
    "yemenmail.com",
    "yemobaswq.online",
    "yenderpern10.ru",
    "yenigulen.xyz",
    "yenilerturizm.online",
    "yenilerturizm.xyz",
    "yenilmezdijital.com",
    "yenilmezdijital.xyz",
    "yenimahalledershanesi.xyz",
    "yenimail.site",
    "yenimusteri.com",
    "yeniyasamgorukle.xyz",
    "yennzu.com",
    "yentzscholarship.xyz",
    "yeod.site",
    "yeoq.site",
    "yeot.site",
    "yep.it",
    "yepmail.app",
    "yepmail.cc",
    "yepmail.club",
    "yepmail.co",
    "yepmail.email",
    "yepmail.id",
    "yepmail.in",
    "yepmail.net",
    "yepmail.to",
    "yepmail.us",
    "yepmail.ws",
    "yeppee.net",
    "yepq.site",
    "yept.site",
    "yeqlk1.site",
    "yerberasdeluruguay.com",
    "yerliarabafiyati.xyz",
    "yermail.net",
    "yermanbetx.com",
    "yerpertod5.ru",
    "yert.ye.vc",
    "yertio.website",
    "yertwowos9.ru",
    "yertxenon.tk",
    "yertxenor.tk",
    "yes2khalistan.com",
    "yesaccounts.net",
    "yesbox.net",
    "yesdew.com",
    "yesese.xyz",
    "yesey.net",
    "yesferadyim.ga",
    "yesgotour.com",
    "yesilyurtkurye.xyz",
    "yesilyurtluyuz.com",
    "yesiyu.com",
    "yeson1608.org",
    "yespostcardyou.website",
    "yesuan17.xyz",
    "yesuan18.xyz",
    "yesuan20.xyz",
    "yeswebmaster.com",
    "yeswewill2024.com",
    "yesxnxx.site",
    "yesyes.site",
    "yetgo.site",
    "yeuniverse.net",
    "y\xeauniverse.net",
    "yeuniverse.org",
    "yeupmail.cf",
    "yeurth.com",
    "yevme.com",
    "yevvd.site",
    "yevvp.site",
    "yevvq.site",
    "yewma46eta.ml",
    "yewmail.com",
    "yf322.com",
    "yf877.com",
    "yffxs.com",
    "yfkfct.info",
    "yfn1d5.us",
    "yfqchina.com",
    "yfqyvg.com",
    "yftfc.com",
    "yfyf00000.info",
    "yfyf11111.info",
    "yfyf777.com",
    "yfyf77777.info",
    "yfyf88888.info",
    "yfyf999.com",
    "yg02sl.us",
    "ygfghhs.xyz",
    "ygifccwbzv.site",
    "ygm.com",
    "ygmin3.us",
    "ygmx.de",
    "ygnzqh2f97sv.cf",
    "ygnzqh2f97sv.ga",
    "ygnzqh2f97sv.gq",
    "ygnzqh2f97sv.ml",
    "ygnzqh2f97sv.tk",
    "ygod2020.site",
    "ygow2020.site",
    "ygquc.us",
    "ygroupvideoarchive.com",
    "ygroupvideoarchive.net",
    "ygrxw.com",
    "ygryiprodagi.ru",
    "ygva12.info",
    "ygvz2n.site",
    "yh00028.com",
    "yh00078.com",
    "yh08c6abpfm17g8cqds.cf",
    "yh08c6abpfm17g8cqds.ga",
    "yh08c6abpfm17g8cqds.gq",
    "yh08c6abpfm17g8cqds.ml",
    "yh08c6abpfm17g8cqds.tk",
    "yh3kjs-mail.xyz",
    "yh58581.com",
    "yh9837.com",
    "yhaig.com",
    "yham222.com",
    "yham666.com",
    "yham888.com",
    "yhcaturkl79jk.tk",
    "yhcaturxc69ol.ml",
    "yhccetl.com",
    "yhdichan.com",
    "yhfadceub.shop",
    "yhfryy.com",
    "yhfs78.com",
    "yhg.biz",
    "yhgj9986.com",
    "yhiy.site",
    "yhjgh65hghgfj.tk",
    "yhoo.com",
    "yhq61.space",
    "yhqbb.site",
    "yhtqks.us",
    "yhttls.us",
    "yhyseo.com",
    "yicaiwts.com",
    "yidaiyiluwang.com",
    "yidaolife.net",
    "yidongo.xyz",
    "yieldo.com",
    "yifan.net",
    "yiffy.monster",
    "yigeyidh1.xyz",
    "yigitcafe.xyz",
    "yihdc4.info",
    "yihuang.xyz",
    "yiiokb.xyz",
    "yikanabilirmaske.site",
    "yikes.online",
    "yikpg.us",
    "yildirimgurses.xyz",
    "yildirimmatbaareklam.xyz",
    "yildzentegre.com",
    "yilmazplanlama.xyz",
    "yimate.info",
    "yin-m.com",
    "yinfengyule1.com",
    "ying168.org",
    "yingcaipiao.com",
    "yingcy.xyz",
    "yingka-yule.com",
    "yingnanstone.com",
    "yintoni.com",
    "yinz.cab",
    "yipimalls.site",
    "yipple.com",
    "yirotrin15.ru",
    "yitemalls.site",
    "yitenghz.xyz",
    "yiustrange.com",
    "yiwuoutlet.site",
    "yiximalls.site",
    "yiyi678.com",
    "yiying.app",
    "yiyuncloud.services",
    "yiz126dd4oz44ye.xyz",
    "yj3nas.cf",
    "yj3nas.ga",
    "yj3nas.gq",
    "yj3nas.ml",
    "yj3nas.tk",
    "yjav14.com",
    "yjav15.com",
    "yjav17.com",
    "yjav18.com",
    "yjav19.com",
    "yjav20.com",
    "yjav22.com",
    "yjav23.com",
    "yjav25.com",
    "yjav28.com",
    "yjav31.com",
    "yjav32.com",
    "yjav34.com",
    "yjav37.com",
    "yjav39.com",
    "yjav40.com",
    "yjav44.com",
    "yjav46.com",
    "yjav49.com",
    "yjcoupone.com",
    "yjehor.site",
    "yjemjj.com",
    "yjfcncch.shop",
    "yjivq.us",
    "yjjgcbxhn.shop",
    "yjjk19.top",
    "yjjvinbnr.shop",
    "yjlnyo.space",
    "yjpel.com",
    "yjpth.us",
    "yk20.com",
    "ykblzr.site",
    "ykbmcp.fun",
    "ykc.com",
    "ykctj.com",
    "ykdmrk.fun",
    "ykdszp.us",
    "ykfmzg.fun",
    "ykfx9u-mail.xyz",
    "ykgmjf.fun",
    "ykjmpb.fun",
    "yklmgh.fun",
    "yklmyt.fun",
    "yknhcm.site",
    "yknmpx.fun",
    "ykp9.com",
    "ykrmgb.fun",
    "ykrybwiko.shop",
    "yksmmk.fun",
    "ykssyqub.pro",
    "ykwmnt.fun",
    "yl2bs4.us",
    "ylatd.com",
    "yldvgi.us",
    "ylegging.com",
    "yliora.site",
    "yliuetcxaf405.tk",
    "ylkpdp.info",
    "yllw.info",
    "yllw.life",
    "yllw.rocks",
    "yllw.us",
    "ylxnw6.com",
    "ylztst.site",
    "ym9.app",
    "ymail.com",
    "ymail.net",
    "ymail.org",
    "ymail.site",
    "ymail365.com",
    "ymail4.com",
    "ymail44.com",
    "ymail5.com",
    "ymails.biz",
    "ymakers.shop",
    "ymeil.cc",
    "ymjd9n.us",
    "ymoaymor.shop",
    "ymobil.ru",
    "ymogof.cf",
    "ymogof.ml",
    "ymqzwwdo.shop",
    "ymv168.com",
    "ymwvlgzkn.shop",
    "ymz7ur.us",
    "yn6lcg.us",
    "yn8jnfb0cwr8.cf",
    "yn8jnfb0cwr8.ga",
    "yn8jnfb0cwr8.gq",
    "yn8jnfb0cwr8.ml",
    "yn8jnfb0cwr8.tk",
    "yndrinks.com",
    "yndx.online",
    "yndx.press",
    "yndx.space",
    "yngjh.net",
    "ynlasrpza.shop",
    "ynmrealty.com",
    "ynnmail.com",
    "ynolptsmw.shop",
    "ynowmt.us",
    "ynuyqc.com",
    "ynvidixoc7.ru",
    "ynvvehnfe.shop",
    "ynvwdg.us",
    "ynwfkeji.com",
    "ynwkw.com",
    "ynzfx6.us",
    "yo20p.site",
    "yo20t.site",
    "yo35.xyz",
    "yo88.pro",
    "yoa69.space",
    "yobit.biz",
    "yobogames.com",
    "yoco.dev",
    "yoco.shop",
    "yocxiphbi.shop",
    "yodabetbonus.com",
    "yodd.site",
    "yodq.site",
    "yodt.site",
    "yodw2020.site",
    "yodx.ro",
    "yoex0s.us",
    "yofashops.site",
    "yofibeauty.com",
    "yofoto5188.com",
    "yoga-flexible.club",
    "yogainsurancequote.com",
    "yogaisaboutyou.ru",
    "yogajellies.info",
    "yogakovriki.ru",
    "yogamaven.com",
    "yogasauna.ru",
    "yogashop.live",
    "yogawithniyati.com",
    "yogida.host",
    "yoginyogik.ru",
    "yogivest.com",
    "yogiwebsite.com",
    "yogotemail.com",
    "yohana.us",
    "yohomail.ga",
    "yohomail.ml",
    "yojishinkawa.com",
    "yolbiletim.xyz",
    "yolooo.top",
    "yolosherpa.com",
    "yom6dw.com",
    "yomail.info",
    "yomura.info",
    "yomura.mobi",
    "yomura.org",
    "yomurabroadband.com",
    "yomuracarrier.com",
    "yomuracloud.com",
    "yomuraethernet.com",
    "yomuragroup.com",
    "yomuraholdings.com",
    "yomuraix.net",
    "yomurarefugee.com",
    "yomurarefugees.com",
    "yomurastatus.com",
    "yomuratransit.com",
    "yomurawifi.com",
    "yonaki.xyz",
    "yongdaqm.com",
    "yongfameiye.com",
    "yongxin3.com",
    "yonisp.site",
    "yoo.ro",
    "yood.org",
    "yoofollow.com",
    "yoojeen.design",
    "yoojeen.store",
    "yoojeen.tech",
    "yoonpapa.site",
    "yop.email",
    "yop.emersion.fr",
    "yop.fexp.io",
    "yop.itram.es",
    "yop.milter.int.eu.org",
    "yop.profmusique.com",
    "yop.xn--vqq79r59m.eu.org",
    "yop.ze.cx",
    "yopmail.biz.st",
    "yopmail.cf",
    "yopmail.com",
    "yopmail.dams.city",
    "yopmail.fr",
    "yopmail.fr.nf",
    "yopmail.gq",
    "yopmail.info",
    "yopmail.ml",
    "yopmail.net",
    "yopmail.org",
    "yopmail.pp.ua",
    "yopmail.usa.cc",
    "yopmail.xxi2.com",
    "yopmail2.tk",
    "yopolis.com",
    "yoposts.icu",
    "yopq.site",
    "yopweb.com",
    "yoqtedbre.shop",
    "yordanmail.cf",
    "yorecountryhome.com",
    "yorkbet100.com",
    "yorkbet49.com",
    "yorkbet70.com",
    "yorkieandco.com",
    "yormanwhite.ml",
    "yoru-dea.com",
    "yoshoper.ru",
    "yosketchers.ml",
    "yosuoa.com",
    "yotq.site",
    "you-spam.com",
    "you-turist.ru",
    "you.e4ward.com",
    "youandmetrip.site",
    "youareadork.com",
    "youarenotyourstigma.com",
    "youbestone.pw",
    "youbetcash.club",
    "youbid.auction",
    "youbid.network",
    "youbid.team",
    "youcankeepit.info",
    "youcaresimple.com",
    "youchat.ooo",
    "youdoloveme.me",
    "yougoodshop.com",
    "yougotgoated.com",
    "youhachongdian.net",
    "youhavegotnewmail.net",
    "youhavegototbekidding.com",
    "youhavetowatchthis.com",
    "youhouse.biz",
    "youjury.com",
    "youkiss-me.online",
    "youknow.blog",
    "youkybox.store",
    "youlike88box.com",
    "youmail.dk",
    "youmail.ga",
    "youmailr.com",
    "youmails.online",
    "youmakeincome.online",
    "youneedmore.info",
    "young-app-lexacc.com",
    "young-living.store",
    "youngadultrehabprograms.com",
    "youngandjuicy.net",
    "youngaudiences.us",
    "youngbluekennels.com",
    "youngcrew.ga",
    "youngforevers.com",
    "younghemp.com",
    "younguxqy.space",
    "youniquelycrowned.com",
    "youporn.flu.cc",
    "youporn.igg.biz",
    "youporn.usa.cc",
    "youpush1.xyz",
    "youpy.com",
    "youpymail.com",
    "youqa.ru",
    "your-airy-lashes-spb.ru",
    "your-best-profits2.com",
    "your-crossover-car-today.live",
    "your-crossover-cars-deal.live",
    "your-dating-zones.com",
    "your-dating.website",
    "your-dentalimplant-deal.rocks",
    "your-dentalimplant-offer.sale",
    "your-dentalimplantchoice.live",
    "your-dentalimplantchoice.sale",
    "your-dentalimplantdeals.rocks",
    "your-dentalimplantguide.rocks",
    "your-dentalimplantguides.live",
    "your-dentalimplantonline.live",
    "your-dentalimplantonline.sale",
    "your-dentalimplantsites.rocks",
    "your-dentalimplantspot.market",
    "your-dentalimplantzone.market",
    "your-health.store",
    "your-house.com",
    "your-iphone.com",
    "your-mail.com",
    "youradvocacystory.org",
    "youranimations.com",
    "yourannuityadvisors.com",
    "yourannuityconsultant.com",
    "yourannuityguru.com",
    "yourapartmentinmadrid.com",
    "yourbellawedding.com",
    "yourbestdate.website",
    "yourbestmua.ru",
    "yourbestwishes.ru",
    "yourbonus.win",
    "yourbranded.website",
    "yourbrandsites.com",
    "yourbreathcoach.com",
    "yourbusinessjustgoteasier.com",
    "yourcambridgemortgageshrink.com",
    "yourcelebshop.com",
    "yourchristmasplan.com",
    "yourdomain.com",
    "yourefiredday.com",
    "youremail.cf",
    "yourenotyourstigma.com",
    "yourent.us",
    "yourentuan.com",
    "yourewronghereswhy.com",
    "yourfast-prizehere9.life",
    "yourfirststeps.blog",
    "yourfreeflix.me",
    "yourfreemail.tk",
    "yourgrand-bonus-zone1.life",
    "yourhatchpedia.com",
    "yourhealthyfamily.xyz",
    "yourhomesecured.net",
    "yourhorseisfrog.online",
    "yourhotbabes.com",
    "yourhotclips.info",
    "youri-tapper.shop",
    "yourinbox.com",
    "yourinternet.icu",
    "yourinternets.world",
    "yourjobguru.online",
    "yourlifesucks.cu.cc",
    "yourlincolnparkagent.com",
    "yourlms.biz",
    "yourlover.net",
    "yourluckycompany.net",
    "yourmailtoday.com",
    "yourmommademecum.com",
    "yourname.ddns.org",
    "yourname.freeservers.com",
    "yournewstarlog.com",
    "yournightmare.com",
    "yourofficiteblueprint.com",
    "youronlyliveonce.online",
    "youropinion.ooo",
    "yourparked.app",
    "yourpilotstars.com",
    "yourpresscorner.com",
    "yourprizehere10.life",
    "yourprizeishere12.life",
    "yourprizeishere14.info",
    "yourrealpartner1.com",
    "yourresult.ru",
    "yourroscoevillageagent.com",
    "yours.com",
    "yoursafeinv.website",
    "yoursaferate.biz",
    "yoursaferate.info",
    "yoursaferate.mobi",
    "yoursaferate.name",
    "yoursaferate.net",
    "yoursaferate.org",
    "yoursaferate.us",
    "yoursoulsrainbow.com",
    "yourspace.ooo",
    "yourspamgoesto.space",
    "yourssincerely.com",
    "yoursubdomain.findhere.com",
    "yoursubdomain.zzn.com",
    "yoursuperhealth.com",
    "yoursurvivorstory.org",
    "yourteacher.net",
    "yourtempmail.com",
    "yourtinylog.com",
    "yourtube.ml",
    "yourvideos.ru",
    "yourwap.com",
    "yourweb.email",
    "yourwebsite.world",
    "yourwildheart.com",
    "youryearofsayingyes.com",
    "yousefnabulsi.com",
    "yousupers.online",
    "youtebem.site",
    "youtheatingdisordertreatment.com",
    "youtheatingdisordertreatments.com",
    "youthfeet.com",
    "youthfire.com",
    "youthfulhgh.com",
    "youthhuntingclub.com",
    "youthnetworks.info",
    "youthpost.com",
    "youthquakelive.org",
    "youthqueue.com",
    "youtube-page.com",
    "youtube.com",
    "youtube.comx.cf",
    "youtubeabonesatinal.net",
    "youtubecasino.ru",
    "youtubeconverter.tools",
    "youtubelive360.com",
    "youtuyuedu.top",
    "youvegotmail.net",
    "youveo.ch",
    "youw88.com",
    "youweb.solutions",
    "youwillenjoythis.com",
    "youwinbahis.info",
    "youwinturkiye.info",
    "youxi.moe",
    "youxi88.club",
    "youxxx.site",
    "youzend.net",
    "yovv20.site",
    "yovvd.site",
    "yovvq.site",
    "yovvt.site",
    "yowinpoker.club",
    "yoynk.net",
    "yoyo11.xyz",
    "yoyobt.online",
    "yoyobt.xyz",
    "yozaruwi.site",
    "yozgatcozumkoleji.com",
    "yozgatdogruhaber.xyz",
    "yozgatlialuminyum.com",
    "yozgatliyiz.xyz",
    "yozgatmedya.xyz",
    "yozgatyazilim.xyz",
    "yp10.info",
    "yp3sur.us",
    "ypapa.ooo",
    "ypar82.info",
    "ypcarp.us",
    "ypcomq.com",
    "ypehh.us",
    "ypeople.shop",
    "ypfkrl.site",
    "ypicall.shop",
    "ypkyl.fun",
    "ypmail.webarnak.fr.eu.org",
    "ypolk1.site",
    "ypovert.shop",
    "ypplasev.cf",
    "ypplasev.gq",
    "ypplasev.ml",
    "yppm0z5sjif.ga",
    "yppm0z5sjif.gq",
    "yppm0z5sjif.ml",
    "yppm0z5sjif.tk",
    "yprbcxde1cux.cf",
    "yprbcxde1cux.ga",
    "yprbcxde1cux.gq",
    "yprbcxde1cux.ml",
    "yprbcxde1cux.tk",
    "ypsilantiapartments.com",
    "yq2.app",
    "yq3.app",
    "yq6iki8l5xa.cf",
    "yq6iki8l5xa.ga",
    "yq6iki8l5xa.gq",
    "yq6iki8l5xa.ml",
    "yq6iki8l5xa.tk",
    "yqdongze.com",
    "yqejb1.site",
    "yqevzp.online",
    "yqjmtqpl.shop",
    "yqww14gpadey.cf",
    "yqww14gpadey.ga",
    "yqww14gpadey.ml",
    "yqww14gpadey.tk",
    "yqzzmo.info",
    "yr2tx.us",
    "yr6mhc.us",
    "yr9mek.us",
    "yraff.us",
    "yraj46a46an43.tk",
    "yrcr3.com",
    "yrcr4.com",
    "yrcr5.com",
    "yrcr9.com",
    "yreduslim.ru",
    "yreilof.xyz",
    "yrfffo.shop",
    "yritysporssi.ru",
    "yrivgdbk.shop",
    "yrmno5cxjkcp9qlen8t.cf",
    "yrmno5cxjkcp9qlen8t.ga",
    "yrmno5cxjkcp9qlen8t.gq",
    "yrmno5cxjkcp9qlen8t.ml",
    "yrmno5cxjkcp9qlen8t.tk",
    "yroid.com",
    "yrp35o.us",
    "yrra.dev",
    "yrseni.site",
    "yrt74748944.cf",
    "yrt74748944.ga",
    "yrt74748944.gq",
    "yrt74748944.ml",
    "yrt74748944.tk",
    "yrubjt.com",
    "yrzvip.com",
    "ys034.com",
    "ys054.com",
    "ys242.com",
    "ys264.com",
    "ys3hhylgw.com",
    "ys7eqe.site",
    "ysavvides.com",
    "ysbjwg.info",
    "yscape.net",
    "ysgldvux.shop",
    "yslyep.online",
    "ysmm3.us",
    "ysoundfirst.info",
    "yspend.com",
    "yspk.online",
    "yspwhc.us",
    "ystradgynlais.biz",
    "ysu.edu",
    "ysvit7.online",
    "ysyl000.com",
    "ysyl03.com",
    "ysyl10.com",
    "ysyl222.com",
    "ysyl33.com",
    "ysyl444.com",
    "yszjj.us",
    "yt-creator.com",
    "yt-dl.net",
    "yt-google.com",
    "yt6erya4646yf.gq",
    "yta1965.com",
    "ytb14a.us",
    "ytbmc.tk",
    "ytdyou.shop",
    "ytg456hjkjh.cf",
    "ytg456hjkjh.ga",
    "ytg456hjkjh.gq",
    "ytg456hjkjh.ml",
    "ytg456hjkjh.tk",
    "ytgzn.space",
    "yth242.com",
    "yth243.com",
    "yth244.com",
    "yth248.com",
    "yth249.com",
    "yth254.com",
    "yth256.com",
    "yth259.com",
    "yth261.com",
    "yth264.com",
    "yth277.com",
    "yth282.com",
    "yth289.com",
    "yth295.com",
    "yth298.com",
    "yth300.com",
    "yth303.com",
    "yth306.com",
    "yth307.com",
    "yth311.com",
    "yth312.com",
    "yth319.com",
    "yth323.com",
    "yth334.com",
    "yth335.com",
    "yth337.com",
    "yth353.com",
    "yth355.com",
    "yth357.com",
    "yth361.com",
    "yth364.com",
    "yth373.com",
    "yth379.com",
    "yth385.com",
    "yth386.com",
    "yth387.com",
    "yth390.com",
    "yth391.com",
    "yth392.com",
    "yth400.com",
    "yth500.com",
    "yth533.com",
    "yth543.com",
    "yth552.com",
    "yth577.com",
    "yth599.com",
    "yth600.com",
    "yth611.com",
    "yth660.com",
    "yth664.com",
    "yth665.com",
    "yth700.com",
    "yth755.com",
    "yth770.com",
    "yth771.com",
    "yth775.com",
    "yth779.com",
    "yth788.com",
    "yth811.com",
    "yth822.com",
    "yth881.com",
    "yth886.com",
    "yth887.com",
    "yth890.com",
    "yth933.com",
    "yth955.com",
    "yth977.com",
    "yth987.com",
    "yth992.com",
    "yth993.com",
    "ythunsha.com",
    "ythyh.net",
    "ytjh.site",
    "ytkewl.rest",
    "ytknu.space",
    "ytkqv.space",
    "ytn333.com",
    "ytpayy.com",
    "ytpza.space",
    "ytqou.space",
    "ytrko.space",
    "ytrojad.online",
    "ytvanrfut.shop",
    "ytvfu.space",
    "ytwbws.site",
    "ytwjxms.xyz",
    "ytxot.space",
    "ytyyh.com",
    "ytzsgz.com",
    "yu15.xyz",
    "yualfq.rest",
    "yubacityapartments.com",
    "yubima.com",
    "yubixiang.com",
    "yuebo.xyz",
    "yuepaopai.world",
    "yuese122.com",
    "yufu999.com",
    "yugasandrika.com",
    "yuge5189.xyz",
    "yugfbjghbvh8v67.ml",
    "yughfdjg67ff.ga",
    "yuhe.us",
    "yui.it",
    "yuirz.com",
    "yukaction.club",
    "yukemon.online",
    "yuksedekah.online",
    "yuksu.com",
    "yuku.net",
    "yula-stayhome.ru",
    "yuletideop.net",
    "yum-king.com",
    "yumavbbo.space",
    "yumlecn.com",
    "yummiescf31.com",
    "yumrecipekitchen.com",
    "yumyumcentralondon.com",
    "yunacg.com",
    "yundiktonber4.ru",
    "yungal.com",
    "yuniang.club",
    "yunshijiegj1.com",
    "yuntiangjzc.com",
    "yunusdelano.online",
    "yunusemre.kim",
    "yuoia.com",
    "yupengjy.com",
    "yups.xyz",
    "yuqiliangju.com",
    "yurtdisitatilsec.com",
    "yurtdisitursec.com",
    "yuslamail.com",
    "yusmpgroup.ru",
    "yutnaya-kuhnya.ru",
    "yuugk9.us",
    "yuuhuu.net",
    "yuurok.com",
    "yuuuyyyyyui.site",
    "yuuywil.date",
    "yuwixms.xyz",
    "yuxdeo.info",
    "yuxuan.mobi",
    "yuyoshop.site",
    "yuyu.asia",
    "yuzhen6688.com",
    "yuzwdo.us",
    "yvaw6gv9hytojpm.top",
    "yvd20.site",
    "yvdd.site",
    "yvehyrain.shop",
    "yverinostiimestnotiii.xyz",
    "yverinostiipopul.xyz",
    "yveswindow.com",
    "yvgalgu7zt.cf",
    "yvgalgu7zt.ga",
    "yvgalgu7zt.gq",
    "yvgalgu7zt.ml",
    "yvgalgu7zt.tk",
    "yvod.site",
    "yvr4u.us",
    "yvv20p.site",
    "yvv20q.site",
    "yvvd20.site",
    "yvvdp.site",
    "yvvdq.site",
    "yvvdt.site",
    "yvvpt.site",
    "yvzcmk.us",
    "yw4kz.info",
    "ywamdayton.com",
    "ywdd89.com",
    "ywhmsx.xyz",
    "ywirywil.shop",
    "ywjpfdry.xyz",
    "ywsgeli.com",
    "ywydw.com",
    "ywzs20d76pb06zy.xyz",
    "yx.dns-cloud.net",
    "yx262.com",
    "yx48bxdv.ga",
    "yxbooketo.ru",
    "yxbv0bipacuhtq4f6z.ga",
    "yxbv0bipacuhtq4f6z.gq",
    "yxbv0bipacuhtq4f6z.ml",
    "yxbv0bipacuhtq4f6z.tk",
    "yxir.cn",
    "yxpf.xyz",
    "yxsdszd.club",
    "yxtgame.com",
    "yxyoqn.shop",
    "yxzr4n.us",
    "yxzx.net",
    "yy-h2.nut.cc",
    "yy18269.com",
    "yyaahooo.com",
    "yyc.rocks",
    "yydrbxzv.shop",
    "yyemek.xyz",
    "yyhdress.com",
    "yyhmail.com",
    "yyj295r31.com",
    "yynkm.com",
    "yyolf.net",
    "yyonya.site",
    "yyt.resolution4print.info",
    "yytcza.com",
    "yytv.ddns.net",
    "yyugo.com",
    "yyuuhxjt.shop",
    "yywenxue.com",
    "yyy.lol",
    "yz-huanyu.com",
    "yz831.com",
    "yz888x.com",
    "yz888y.com",
    "yz888z.com",
    "yzgpxm.site",
    "yzhz78hvsxm3zuuod.cf",
    "yzhz78hvsxm3zuuod.ga",
    "yzhz78hvsxm3zuuod.ml",
    "yzi6co.us",
    "yzjrhnfs.pro",
    "yzjup.us",
    "yzmuht.us",
    "yznqa.us",
    "yzovun.site",
    "yzrbjc.com",
    "yzrd.org",
    "yzsdhi.us",
    "yztfgtqm.shop",
    "yzwmanbetx.com",
    "yzx12.com",
    "yzxvbp.com",
    "z-7mark.ru",
    "z-mail.cf",
    "z-mail.ga",
    "z-mail.gq",
    "z-mild.ga",
    "z-o-e-v-a.ru",
    "z-portfolio.ru",
    "z-profit.ru",
    "z00111.com",
    "z00222.com",
    "z00333.com",
    "z00555.com",
    "z00999.com",
    "z0b2h.info",
    "z0d.eu",
    "z0zkjy.us",
    "z1-fm.ru",
    "z1-mp3.ru",
    "z10888.com",
    "z11bet.org",
    "z1775.com",
    "z18wgfafghatddm.cf",
    "z18wgfafghatddm.ga",
    "z18wgfafghatddm.gq",
    "z18wgfafghatddm.ml",
    "z18wgfafghatddm.tk",
    "z1fm.site",
    "z1gb4t.us",
    "z1kycx2hlf1k7vo.xyz",
    "z1ott6.us",
    "z1p.biz",
    "z1tiixjk7juqix94.ga",
    "z1tiixjk7juqix94.ml",
    "z1tiixjk7juqix94.tk",
    "z2-payfree.site",
    "z20888.com",
    "z22123.com",
    "z27-cashsait.host",
    "z27-cashsait.site",
    "z2v.ru",
    "z3-userreferal.info",
    "z3-userreferal.site",
    "z30-megacash.host",
    "z30-megacash.site",
    "z30888.com",
    "z32-faropartner.info",
    "z33-funnymoney.host",
    "z36-megajoy.xyz",
    "z3at.us",
    "z3cq.com",
    "z3frrd.info",
    "z3pbtvrxv76flacp4f.cf",
    "z3pbtvrxv76flacp4f.ga",
    "z3pbtvrxv76flacp4f.gq",
    "z3pbtvrxv76flacp4f.ml",
    "z3pbtvrxv76flacp4f.tk",
    "z4445.com",
    "z4vkg.info",
    "z50888.com",
    "z5cpw9pg8oiiuwylva.cf",
    "z5cpw9pg8oiiuwylva.ga",
    "z5cpw9pg8oiiuwylva.gq",
    "z5cpw9pg8oiiuwylva.ml",
    "z5cpw9pg8oiiuwylva.tk",
    "z6.com",
    "z6s.net",
    "z6ylqc.us",
    "z6yr.top",
    "z70888.com",
    "z77567.com",
    "z777e.space",
    "z7az14m.com",
    "z7az14m.com.com",
    "z80888.com",
    "z85frv.host",
    "z86.ru",
    "z87.info",
    "z870wfurpwxadxrk.ga",
    "z870wfurpwxadxrk.gq",
    "z870wfurpwxadxrk.ml",
    "z870wfurpwxadxrk.tk",
    "z8h.info",
    "z8zcx3gpit2kzo.gq",
    "z8zcx3gpit2kzo.ml",
    "z8zcx3gpit2kzo.tk",
    "z90888.com",
    "z9094.com",
    "z9827.com",
    "z9btpl.us",
    "z9mail.com",
    "za-derzhavu.ru",
    "za-gay.link",
    "za-zdravie.ru",
    "za-zelenskogo.info",
    "za.com",
    "za72p.com",
    "zaab.de",
    "zaandam.info",
    "zaaskater.cf",
    "zaaskater.gq",
    "zaaskater.ml",
    "zaaskater.tk",
    "zabaikalfood.club",
    "zabolevaniya.info",
    "zaborkalitka.ru",
    "zabtec.ru",
    "zacharychan.buzz",
    "zadder.xyz",
    "zaderatsky.info",
    "zadereasder.site",
    "zadz119.com",
    "zae.monster",
    "zaelmo.com",
    "zaertlich.love",
    "zafarullah.com",
    "zafervip.online",
    "zafran5in1.com",
    "zaftneqz2xsg87.cf",
    "zaftneqz2xsg87.ga",
    "zaftneqz2xsg87.gq",
    "zaftneqz2xsg87.ml",
    "zaftneqz2xsg87.tk",
    "zaga.site",
    "zagdy1.site",
    "zageulyy.shop",
    "zagorodnyi-domik.ru",
    "zah3jk.us",
    "zahadum.com",
    "zaharin.ru",
    "zahav.net",
    "zahav.net.il",
    "zahuy.site",
    "zaim-gotov.store",
    "zaimi-na-karty.ru",
    "zaimy-srochno.ru",
    "zain.site",
    "zainhaidermusic.com",
    "zainmax.net",
    "zakazat-aviabilet.ru",
    "zakazat-okno.ru",
    "zakitri.website",
    "zakkaas.com",
    "zakonnaya-territoriya.ru",
    "zakticorp.com",
    "zaktouni.fr",
    "zakupro.ru",
    "zakvason.ru",
    "zalocasino.xyz",
    "zaltak.com",
    "zalvisual.us",
    "zamana.com",
    "zambezinationalparks.com",
    "zamena-stekla.ru",
    "zamge.com",
    "zamsahamtravel.com",
    "zamua.com",
    "zamytravel.icu",
    "zamzamtakeaway.com",
    "zanaflex.pro",
    "zanairsafety.com",
    "zanaveskin.ru",
    "zanboor.pro",
    "zanderfoxgrant.com",
    "zandicapital.com",
    "zane.pro",
    "zane.rocks",
    "zanichelli.cf",
    "zanichelli.ga",
    "zanichelli.gq",
    "zanichelli.ml",
    "zanichelli.tk",
    "zanist.xyz",
    "zanistan.xyz",
    "zanmei5.com",
    "zannuaire.com",
    "zanovosti.ru",
    "zantsuppno.gq",
    "zantsuppno.tk",
    "zanzatoys.com",
    "zaonlineclassified.com",
    "zaoshweika.ru",
    "zap2q0drhxu.cf",
    "zap2q0drhxu.ga",
    "zap2q0drhxu.gq",
    "zap2q0drhxu.ml",
    "zap2q0drhxu.tk",
    "zapbox.fr",
    "zapchasti-ford-sevastopol.ru",
    "zapl.ink",
    "zapravka19.ru",
    "zapviral.com",
    "zapzap.army",
    "zapzap.band",
    "zapzap.bar",
    "zapzap.bike",
    "zapzap.build",
    "zapzap.care",
    "zapzap.careers",
    "zapzap.catering",
    "zapzap.coach",
    "zapzap.college",
    "zapzap.construction",
    "zapzap.cricket",
    "zapzap.deals",
    "zapzap.delivery",
    "zapzap.dev",
    "zapzap.equipment",
    "zapzap.estate",
    "zapzap.events",
    "zapzap.financial",
    "zapzap.fish",
    "zapzap.florist",
    "zapzap.gallery",
    "zapzap.glass",
    "zapzap.golf",
    "zapzap.host",
    "zapzap.ink",
    "zapzap.legal",
    "zapzap.lighting",
    "zapzap.limo",
    "zapzap.navy",
    "zapzap.news",
    "zapzap.photography",
    "zapzap.plumbing",
    "zapzap.properties",
    "zapzap.racing",
    "zapzap.realty",
    "zapzap.rent",
    "zapzap.solutions",
    "zapzap.space",
    "zapzap.store",
    "zapzap.supply",
    "zapzap.support",
    "zapzap.tech",
    "zapzap.tours",
    "zapzap.toys",
    "zapzap.trade",
    "zapzap.travel",
    "zapzap.vet",
    "zapzap.video",
    "zapzap.vision",
    "zapzapchasty.ru",
    "zapzapcloud.com",
    "zar-fin.ru",
    "zarabotaibystro.ru",
    "zarabotati-sei4as.ru",
    "zarabotok-77.host",
    "zarabotok-biz.ru",
    "zarabotok-v-internet.ru",
    "zarabotokdoma11.ru",
    "zarabotokdoma12.ru",
    "zarabotokdoma7.ru",
    "zarabotokdoma8.ru",
    "zarabotokvseti.info",
    "zarafit.xyz",
    "zarbelo.ga",
    "zarbelo.tk",
    "zard.website",
    "zarinparvaz.net",
    "zarnitsa.su",
    "zarplatniy-proekt.ru",
    "zarplatnyj-proekt.ru",
    "zaruchku.ru",
    "zarurrora.online",
    "zarweek.cf",
    "zarweek.ga",
    "zarweek.tk",
    "zaryadkaofficial.ru",
    "zasderea.site",
    "zasod.com",
    "zasrance.website",
    "zasve.info",
    "zauj.us",
    "zavejy.info",
    "zavio.nl",
    "zavod-himii.ru",
    "zavodzet.ru",
    "zavtrac.ru",
    "zawzad.com",
    "zaym-mix.ru",
    "zaym-o.ru",
    "zaym-zaym.ru",
    "zaymi-online.ru",
    "zaymi-srochno.ru",
    "zayna.love",
    "zayna.style",
    "zaz-co.com",
    "zazebo.xyz",
    "zazeto.xyz",
    "zbapaly.store",
    "zbarman.com",
    "zbbk.info",
    "zbmingfa.com",
    "zbolg.xyz",
    "zbook.site",
    "zbpefn95saft.cf",
    "zbpefn95saft.ga",
    "zbpefn95saft.gq",
    "zbpefn95saft.ml",
    "zbpefn95saft.tk",
    "zbtkazgf.site",
    "zbtxx4iblkgp0qh.cf",
    "zbtxx4iblkgp0qh.ga",
    "zbtxx4iblkgp0qh.gq",
    "zbtxx4iblkgp0qh.ml",
    "zbtxx4iblkgp0qh.tk",
    "zbyadk.com",
    "zbzincs.com",
    "zc3dy5.us",
    "zc72379.top",
    "zcbkh.space",
    "zchatz.ga",
    "zchwzskc.shop",
    "zcities.com",
    "zcolor.live",
    "zcphxq.shop",
    "zcttrira.site",
    "zcut.de",
    "zcvtheiconic.com",
    "zcwx88.com",
    "zcymamrqs.shop",
    "zdbgjajg.shop",
    "zdbgroup.com",
    "zdcardtechglobal.com",
    "zdecadesgl.com",
    "zdenka.net",
    "zdferma.ru",
    "zdfpost.net",
    "zdfsmh.site",
    "zdie.us",
    "zdjv0s.us",
    "zdmxbqww.shop",
    "zdnetmail.com",
    "zdoroveem-molodeem.ru",
    "zdorovie2-0.ru",
    "zdorovja.net",
    "zdorovmay.ru",
    "zdorovpagh.ru",
    "zdorovyeblogs.ru",
    "zdpuppyiy.com",
    "zdqe.icu",
    "zdqfnk01rz.icu",
    "zdqjt.com",
    "zdr20.club",
    "zdrav-nadzor-03.site",
    "zdravmol.ru",
    "zdravnadzor07.site",
    "zdravslet.ru",
    "zdtnpkydingcw2e.xyz",
    "ze.cx",
    "ze.gally.jp",
    "ze.tc",
    "ze31.com",
    "ze4rty.pw",
    "ze87.com",
    "zeansteplnw.com",
    "zebins.com",
    "zebins.eu",
    "zebra.email",
    "zebras.network",
    "zebua.cf",
    "zebuaboy.cf",
    "zebuasadis.ml",
    "zebyic.tokyo",
    "zeca.com",
    "zecili.xyz",
    "zed.expert",
    "zedeliereo.icu",
    "zedthei.shop",
    "zeedcn.site",
    "zeeks.com",
    "zeelandnet.nl",
    "zeemails.in",
    "zeenews.app",
    "zeepaw.com",
    "zeepost.nl",
    "zeeworldproduction.com",
    "zefuqua.space",
    "zeg59.us",
    "zehnminuten.de",
    "zehnminutenmail.de",
    "zeingae.ru",
    "zeitdesschwarms.com",
    "zeko.site",
    "zeky.site",
    "zelda-planet.de",
    "zelda.monster",
    "zeldaforums.net",
    "zelia.online",
    "zemail.ga",
    "zemail.ml",
    "zematsmskorela.host",
    "zen4mom.com",
    "zen4play.net",
    "zenadop.com",
    "zenadops.com",
    "zenbe.com",
    "zeng2b.us",
    "zengolar.xyz",
    "zeniga.com",
    "zenithagedcare.sydney",
    "zenitsumail.com",
    "zenopoker.com",
    "zenopoker.net",
    "zensearch.com",
    "zensearch.net",
    "zenseo.net",
    "zentaiji.biz",
    "zentaiji.info",
    "zentaiji.name",
    "zentaiji.net",
    "zentaiji.us",
    "zentradingmagazine.online",
    "zenyth.marketing",
    "zenyth.online",
    "zep-hyr.com",
    "zepco.ru",
    "zepexo.com",
    "zepp.dk",
    "zer-0.cf",
    "zer-0.ga",
    "zer-0.gq",
    "zer-0.ml",
    "zergp.vip",
    "zerkalo-admiralx.xyz",
    "zerkalosssport.website",
    "zerkaloxc.ru",
    "zero-action-shopping.ru",
    "zero-product-stock.ru",
    "zero-sale-inform.ru",
    "zerocarboncalifornia.com",
    "zerocarboncostarica.com",
    "zerocopter.dev",
    "zerocoptermail.com",
    "zerocrime.org",
    "zerodog.icu",
    "zeroe.ml",
    "zeroegress.com",
    "zeroegress.net",
    "zeroeth-world.org",
    "zeroethworld.net",
    "zerohush.org",
    "zeroknow.ga",
    "zeromail.ga",
    "zerosupervision.art",
    "zerothccbd.us",
    "zerothworld.net",
    "zerotohero-1.com",
    "zest.me.uk",
    "zesta.cf",
    "zesta.gq",
    "zestrany.website",
    "zeta-telecom.com",
    "zetagames.club",
    "zetap.travel",
    "zetaseek.com",
    "zetgets.com",
    "zetmail.com",
    "zeus0303430.xyz",
    "zeus0310218.xyz",
    "zeus0324202.xyz",
    "zeus0454333.xyz",
    "zeus0771866.xyz",
    "zeus1252961.xyz",
    "zeus1549658.xyz",
    "zeus1817999.xyz",
    "zeus2229034.xyz",
    "zeus2502287.xyz",
    "zeus3777396.xyz",
    "zeus4588184.xyz",
    "zeus5233852.xyz",
    "zeus6397394.xyz",
    "zeus6408834.xyz",
    "zeus7843650.xyz",
    "zeus8399726.xyz",
    "zeus9447425.xyz",
    "zeus9536726.xyz",
    "zeus9550576.xyz",
    "zeus9556189.xyz",
    "zeus9563736.xyz",
    "zeus9564765.xyz",
    "zeus9577727.xyz",
    "zeus9594524.xyz",
    "zeus9603734.xyz",
    "zeus9618305.xyz",
    "zeus9665639.xyz",
    "zeus9694503.xyz",
    "zeus9695926.xyz",
    "zeus9705328.xyz",
    "zeus9723746.xyz",
    "zeus9730367.xyz",
    "zeus9736785.xyz",
    "zeus9778146.xyz",
    "zeus9779039.xyz",
    "zeus9805897.xyz",
    "zeus9821555.xyz",
    "zeus9864546.xyz",
    "zeus9892415.xyz",
    "zeus9892949.xyz",
    "zeus9895931.xyz",
    "zeus9907227.xyz",
    "zeus9917624.xyz",
    "zeus9929754.xyz",
    "zeus9936224.xyz",
    "zeus9958726.xyz",
    "zeus9959878.xyz",
    "zeus9963130.xyz",
    "zeus9993314.xyz",
    "zeuschimneyservice.com",
    "zeusndione-eyewear.com",
    "zeusonline99.biz",
    "zeusrisky07.ml",
    "zeusrisky07.tk",
    "zeusus.ru",
    "zeuwescull.ga",
    "zeuwescull.ml",
    "zeuwescull.tk",
    "zeveyuse.com",
    "zeveyuse.net",
    "zewuju.info",
    "zexeet9i5l49ocke.cf",
    "zexeet9i5l49ocke.ga",
    "zexeet9i5l49ocke.gq",
    "zexeet9i5l49ocke.ml",
    "zexeet9i5l49ocke.tk",
    "zeynepgenc.com",
    "zeytinburnudamlaspor.com",
    "zezayiez.xyz",
    "zezet.net",
    "zezis.ru",
    "zf4r34ie.com",
    "zf813.com",
    "zfbmt1.site",
    "zfijv.us",
    "zfpsale.top",
    "zfs4ug.us",
    "zfshqt.online",
    "zfvip75.com",
    "zfvip76.com",
    "zfvip78.com",
    "zfvip79.com",
    "zfvip80.com",
    "zfxchk.site",
    "zfxmanbetx.com",
    "zfyl63.com",
    "zfymail.com",
    "zg2.info",
    "zg5dl7go8ylo5im.xyz",
    "zg8.info",
    "zgbeilin.com",
    "zgdayi.com",
    "zgdsoper.space",
    "zgeotd.us",
    "zgfzazbe.shop",
    "zgg520.com",
    "zggyfzyxgs.com",
    "zgjlcbs.com",
    "zgktfj.com",
    "zglysyw.com",
    "zgm-ural.ru",
    "zgmdl.com",
    "zgsgjj.com",
    "zgsphj.us",
    "zgtjvczkp.shop",
    "zgtmanbetx.com",
    "zgu5la23tngr2molii.cf",
    "zgu5la23tngr2molii.ga",
    "zgu5la23tngr2molii.gq",
    "zgu5la23tngr2molii.ml",
    "zgu5la23tngr2molii.tk",
    "zguide.site",
    "zgupuf.site",
    "zgzbqshy.com",
    "zh.ax",
    "zh214.com",
    "zh9.info",
    "zhaixing.icu",
    "zhaocaiqipai4.com",
    "zhaohishu.com",
    "zhaowei.net",
    "zhaoyuanedu.cn",
    "zhaoyuantu.com",
    "zhaqiaocun.com",
    "zhcne.com",
    "zhcp123.com",
    "zhebucuo.com",
    "zhehot.com",
    "zhejiang.today",
    "zheleznodorognyi-beton-zavod.ru",
    "zhenchashi.com",
    "zhendesao.com",
    "zhenghaokai.xyz",
    "zhengyajun.com",
    "zhenskayaodejda.ru",
    "zhenskiy-stendap.best",
    "zhewei88.com",
    "zhibang.info",
    "zhibo69.com",
    "zhibo69.xyz",
    "zhibozhiyuan.xyz",
    "zhidkiy-gazon.ru",
    "zhitnadovkaifotivse.xyz",
    "zhkmywb.site",
    "zhkzux.shop",
    "zhnslyzkv.shop",
    "zhongbeike.com",
    "zhorachu.com",
    "zhouemail.510520.org",
    "zhuanqianco.com",
    "zhubed.us",
    "zhubobao.xyz",
    "zhuhaipools.com",
    "zhuishu.online",
    "zhurnaliki.com",
    "zhuting1993.com",
    "zhvssnrf.shop",
    "zhyl0.us",
    "zi3asz.us",
    "ziadbzo.ml",
    "zicaolu.com",
    "zicu.site",
    "ziebhagil.cf",
    "ziebhagil.ga",
    "ziebhagil.ml",
    "ziebhagil.tk",
    "zientogel.com",
    "zientogel.net",
    "ziewrwp.space",
    "zifersrl.com",
    "ziggo.nl",
    "zigybt.us",
    "zigzagmirror.ru",
    "ziholexet.ru",
    "zihuwu.info",
    "zihuxb.rest",
    "zik.dj",
    "zil4czsdz3mvauc2.cf",
    "zil4czsdz3mvauc2.ga",
    "zil4czsdz3mvauc2.gq",
    "zil4czsdz3mvauc2.ml",
    "zil4czsdz3mvauc2.tk",
    "zilbercoin.space",
    "zilmail.cf",
    "zilmail.ga",
    "zilmail.gq",
    "zilmail.ml",
    "zilmail.tk",
    "zilonggj.com",
    "zimbail.me",
    "zimerster.site",
    "zimonas.site",
    "zimu.moe",
    "zimu123.com",
    "zimufensi.cn",
    "zinabf2edderus.xyz",
    "zincc.us",
    "zindevital.com",
    "zinfighkildo.ftpserver.biz",
    "zing.vn",
    "zingar.com",
    "zingermail.co",
    "zingibzfrr.space",
    "zinmail.cf",
    "zinmail.ga",
    "zinmail.gq",
    "zinmail.ml",
    "zinmail.tk",
    "zinnober.xyz",
    "ziojp.com",
    "zionweb.org",
    "zip-institute.com",
    "zip.net",
    "zipada.com",
    "zipcad.com",
    "zipido.com",
    "ziplinehuntermountain.com",
    "ziplink.net",
    "ziplip.com",
    "zipmail.com",
    "zipmail.com.br",
    "zipmail.xyz",
    "zipmax.com",
    "zipo1.cf",
    "zipo1.ga",
    "zipo1.gq",
    "zipo1.ml",
    "zippiex.com",
    "zippymail.in",
    "zippymail.info",
    "ziprol.com",
    "zipsendtest.com",
    "zipzaprap.beerolympics.se",
    "zipzaps.de",
    "ziqo.studio",
    "zis.netmail.tk",
    "zisustand.site",
    "zitong001.com",
    "zitroproperties.com",
    "ziu3z9.com",
    "zivanto.xyz",
    "zivvwh.com",
    "zixaha.info",
    "zixnnupt.shop",
    "zixoa.com",
    "ziyap.com",
    "ziyaratarbaeen1437.com",
    "ziyungj.com",
    "ziza.ru",
    "zizobt.org",
    "zjdkoq.best",
    "zjexmail.com",
    "zjffmj.com",
    "zjflqj.us",
    "zjip.com",
    "zjkksgs.com",
    "zjlm28.com",
    "zjlrau.rest",
    "zjlzd.com",
    "zjnicety.com",
    "zjnmn.info",
    "zjnxek.us",
    "zjp.monster",
    "zjrt4.us",
    "zju.best",
    "zju83.space",
    "zjvg2x.us",
    "zjxylcar.com",
    "zk2578.com",
    "zk9sdg.online",
    "zkb.su",
    "zkcckwvt5j.cf",
    "zkcckwvt5j.ga",
    "zkcckwvt5j.gq",
    "zkcckwvt5j.ml",
    "zkcckwvt5j.tk",
    "zkcmlp.fun",
    "zkd252.com",
    "zkd252.net",
    "zkeiw.com",
    "zkfmdm.fun",
    "zkgmgm.fun",
    "zkgxvued.shop",
    "zkhmmk.fun",
    "zkhyib.ml",
    "zkjbbf.vip",
    "zkjmzj.fun",
    "zkjmzz.fun",
    "zkkefu.online",
    "zklmkr.fun",
    "zkmusic.ru",
    "zknow.org",
    "zkxr1u.us",
    "zkzjk.com",
    "zl0irltxrb2c.cf",
    "zl0irltxrb2c.ga",
    "zl0irltxrb2c.gq",
    "zl0irltxrb2c.ml",
    "zl0irltxrb2c.tk",
    "zl3ici.us",
    "zlatoj.ru",
    "zlbpvs.us",
    "zlcai168.net",
    "zlcai1688.net",
    "zlcai88.net",
    "zlcai888.net",
    "zledscsuobre9adudxm.cf",
    "zledscsuobre9adudxm.ga",
    "zledscsuobre9adudxm.gq",
    "zledscsuobre9adudxm.ml",
    "zledscsuobre9adudxm.tk",
    "zleohkaqpt5.cf",
    "zleohkaqpt5.ga",
    "zleohkaqpt5.gq",
    "zleohkaqpt5.ml",
    "zleohkaqpt5.tk",
    "zlinvo.site",
    "zlmsl0rkw0232hph.cf",
    "zlmsl0rkw0232hph.ga",
    "zlmsl0rkw0232hph.gq",
    "zlmsl0rkw0232hph.ml",
    "zlmsl0rkw0232hph.tk",
    "zlrjxmmt.shop",
    "zltcsmym9xyns1eq.cf",
    "zltcsmym9xyns1eq.tk",
    "zltiu4.us",
    "zluxretail.xyz",
    "zm-44.com",
    "zmail.info.tm",
    "zmail.pt",
    "zmail.ru",
    "zmani.biz",
    "zmara.com",
    "zmat.xyz",
    "zmemq.com",
    "zmi3cb.com",
    "zmpoker.info",
    "zmt.plus",
    "zmtdzc.com",
    "zmti6x70hdop.cf",
    "zmti6x70hdop.ga",
    "zmti6x70hdop.gq",
    "zmti6x70hdop.ml",
    "zmti6x70hdop.tk",
    "zmwgvx.site",
    "zmxrrxipv.shop",
    "zmylf33tompym.cf",
    "zmylf33tompym.ga",
    "zmylf33tompym.gq",
    "zmylf33tompym.ml",
    "zmylf33tompym.tk",
    "zn4chyguz9rz2gvjcq.cf",
    "zn4chyguz9rz2gvjcq.ga",
    "zn4chyguz9rz2gvjcq.gq",
    "zn4chyguz9rz2gvjcq.ml",
    "zn4chyguz9rz2gvjcq.tk",
    "zn7w0.us",
    "zn9a.icu",
    "znachenie-finance.ru",
    "znacheniezvezd.ru",
    "znai-gde.ru",
    "znaisvoiprava.ru",
    "znakomstva-vsem.ru",
    "znam-ya.ru",
    "znatb25xbul30ui.cf",
    "znatb25xbul30ui.ga",
    "znatb25xbul30ui.gq",
    "znatb25xbul30ui.ml",
    "znatb25xbul30ui.tk",
    "znatzhestko.xyz",
    "znbhuf.ooo",
    "znbup3e30kpupwf.xyz",
    "zncqtumbkq.cf",
    "zncqtumbkq.ga",
    "zncqtumbkq.gq",
    "zncqtumbkq.ml",
    "zncqtumbkq.tk",
    "zndqv4.site",
    "zngjfa.us",
    "zni1d2bs6fx4lp.cf",
    "zni1d2bs6fx4lp.ga",
    "zni1d2bs6fx4lp.gq",
    "zni1d2bs6fx4lp.ml",
    "zni1d2bs6fx4lp.tk",
    "znnxguest.com",
    "znq0bc.us",
    "zns1ad.com",
    "znsxchgx212jc9y.xyz",
    "znthe6ggfbh6d0mn2f.cf",
    "znthe6ggfbh6d0mn2f.ga",
    "znthe6ggfbh6d0mn2f.gq",
    "znthe6ggfbh6d0mn2f.ml",
    "znthe6ggfbh6d0mn2f.tk",
    "znull.net",
    "znxrzalb.shop",
    "znyxer.icu",
    "zoabok.ru",
    "zoanthropy.xyz",
    "zoaxe.com",
    "zobeed.com",
    "zodekb.ru",
    "zoedailythoughts.com",
    "zoelifetips.com",
    "zoelotem.ga",
    "zoelotem.ml",
    "zoelotem.tk",
    "zoemail.com",
    "zoemail.net",
    "zoemail.org",
    "zoeov.com",
    "zoepenny.com",
    "zoeportals.icu",
    "zoescolorfullegacy.org",
    "zoetomlinson.buzz",
    "zoetropes.org",
    "zoevaofficial.online",
    "zoevaofficial.ru",
    "zogavm.ru",
    "zoho.com",
    "zoidberg.ninja",
    "zoknseybm.shop",
    "zolaemporium.site",
    "zoldnwx.com",
    "zolman.org",
    "zomail.org",
    "zomantidecopics.site",
    "zombie-hive.com",
    "zombie99.com",
    "zombieapocalypserace.com",
    "zombo.flu.cc",
    "zombo.igg.biz",
    "zombo.nut.cc",
    "zomg.inf",
    "zomg.info",
    "zona-kita.com",
    "zona24.ru",
    "zona7.com",
    "zonagaming77.club",
    "zonagaming77.live",
    "zonai.com",
    "zonamail.ga",
    "zonangopi.co",
    "zondee.ru",
    "zone-telechargement-1.com",
    "zone10electric.com",
    "zone4u-prizes1.info",
    "zonecotton.com",
    "zonedefilmbarbie.com",
    "zonemail.info",
    "zoneview.net",
    "zongases.cf",
    "zongases.ga",
    "zongases.gq",
    "zongases.ml",
    "zongases.tk",
    "zongbopay1577.com",
    "zongbopay2100.com",
    "zonguldakgundem.xyz",
    "zonland.ru",
    "zonnet.nl",
    "zonsurvey.xyz",
    "zoo-chat.ru",
    "zoo-game.ru",
    "zoobutik.ru",
    "zooglemail.com",
    "zoomail.dk",
    "zoombdcmi.shop",
    "zoomfm.ru",
    "zoominternet.net",
    "zoomnation.info",
    "zoophagy.xyz",
    "zoosuits.info",
    "zoozentrum.de",
    "zoqqa.com",
    "zoqyge.info",
    "zorgkaartzeeland.com",
    "zoromarkets.site",
    "zoroter21.xyz",
    "zorropace.se",
    "zota.fun",
    "zotorganics.com",
    "zotyxsod.shop",
    "zoutlook.com",
    "zoutoutou.com",
    "zowomavixy.website",
    "zowtaguz.shop",
    "zowuto.info",
    "zozoprint.com",
    "zozugo.info",
    "zp.ua",
    "zp4.info",
    "zp5d0a.com",
    "zpapa.ooo",
    "zpayhub2.com",
    "zpcdgm.us",
    "zperczhnj.shop",
    "zph8ag47zm3zz1h.xyz",
    "zphuxm.info",
    "zpjcre.com",
    "zpjdb1.site",
    "zpjy.xyz",
    "zpkdqkozdopc3mnta.cf",
    "zpkdqkozdopc3mnta.ga",
    "zpkdqkozdopc3mnta.gq",
    "zpkdqkozdopc3mnta.ml",
    "zpkdqkozdopc3mnta.tk",
    "zpqvdc.com",
    "zprea.ru",
    "zpsrwt.icu",
    "zpvozwsri4aryzatr.cf",
    "zpvozwsri4aryzatr.ga",
    "zpvozwsri4aryzatr.gq",
    "zpvozwsri4aryzatr.ml",
    "zpvozwsri4aryzatr.tk",
    "zpxcb1.site",
    "zpye.icu",
    "zqakus.us",
    "zqdnppf.site",
    "zqe91.buzz",
    "zr8la.us",
    "zran5yxefwrcpqtcq.cf",
    "zran5yxefwrcpqtcq.ga",
    "zran5yxefwrcpqtcq.gq",
    "zran5yxefwrcpqtcq.ml",
    "zran5yxefwrcpqtcq.tk",
    "zrbmsx.top",
    "zre3i49lnsv6qt.cf",
    "zre3i49lnsv6qt.ga",
    "zre3i49lnsv6qt.gq",
    "zre3i49lnsv6qt.ml",
    "zre3i49lnsv6qt.tk",
    "zrega.com",
    "zregomen.cf",
    "zregomen.ga",
    "zregomen.ml",
    "zregomen.tk",
    "zrinyi.org",
    "zrmail.ga",
    "zrmail.ml",
    "zrqlejfyt.shop",
    "zruycop.site",
    "zrvtddfh.shop",
    "zs2019021.com",
    "zs2019023.com",
    "zs2019025.com",
    "zs2019031.com",
    "zs2019033.com",
    "zs2019064.com",
    "zs2019065.com",
    "zs2019097.com",
    "zs2019098.com",
    "zs2019099.com",
    "zs20192068.com",
    "zs20192097.com",
    "zs201939.com",
    "zs201940.com",
    "zs201942.com",
    "zsaful.com",
    "zsaleshow.site",
    "zsba31.us",
    "zsbgllzin.shop",
    "zsero.com",
    "zsgo45.com",
    "zshaiwa.com",
    "zshops.ru",
    "zsigmondy.org",
    "zsj05.com",
    "zsjrxh.com",
    "zskoqt.us",
    "zslsz.com",
    "zsyx158.com",
    "zt5wgv.us",
    "ztahoewgbo.com",
    "ztd5af7qo1drt8.cf",
    "ztd5af7qo1drt8.ga",
    "ztd5af7qo1drt8.gq",
    "ztd5af7qo1drt8.ml",
    "ztd5af7qo1drt8.tk",
    "ztdgrucjg92piejmx.cf",
    "ztdgrucjg92piejmx.ga",
    "ztdgrucjg92piejmx.gq",
    "ztdgrucjg92piejmx.ml",
    "ztdgrucjg92piejmx.tk",
    "ztjspeakmn.com",
    "ztlkky.icu",
    "ztols4.online",
    "ztrackz.tk",
    "ztsecurity.org",
    "ztssce.icu",
    "zu15jn.us",
    "zu91pml1dge6dcv.xyz",
    "zualikhakk.cf",
    "zualikhakk.ga",
    "zualikhakk.gq",
    "zualikhakk.ml",
    "zualikhakk.tk",
    "zuan4e.us",
    "zubacteriax.com",
    "zubee.com",
    "zubr-store.ru",
    "zucconi-dublin.com",
    "zudrm1dxjnikm.cf",
    "zudrm1dxjnikm.ga",
    "zudrm1dxjnikm.gq",
    "zudrm1dxjnikm.ml",
    "zudrm1dxjnikm.tk",
    "zuhaoban.com",
    "zuimap.com",
    "zuinigverwarmen.com",
    "zuiquandaohang.xyz",
    "zujdg1.site",
    "zujrn4.us",
    "zukhy4.us",
    "zukmail.cf",
    "zukmail.ga",
    "zukmail.ml",
    "zukmail.tk",
    "zulala.com",
    "zulamri.com",
    "zumbinimex.com",
    "zumpul.com",
    "zumrotin.ml",
    "zunemasters.com",
    "zunigersa.site",
    "zupload.xyz",
    "zuqame.info",
    "zuqkfp.info",
    "zurabhsan.ml",
    "zurabhsan.tk",
    "zurbdj.us",
    "zurcasinocow.ru",
    "zuribeauty.com",
    "zurotrinz.ru",
    "zurtel.cf",
    "zurtel.ga",
    "zurtel.gq",
    "zurtel.ml",
    "zurtel.tk",
    "zuvio.com",
    "zuxi.site",
    "zuzzurello.com",
    "zv-mail.ru",
    "zv-ml.ru",
    "zv-send.ru",
    "zv35.icu",
    "zv6.info",
    "zv68.com",
    "zvbt.com",
    "zvhmuytt.shop",
    "zvik-mail.ru",
    "zvik-ml.ru",
    "zvik-r.ru",
    "zvik-ras.ru",
    "zvik-rs.ru",
    "zvik-sd.ru",
    "zvik-send.ru",
    "zvikeu.xyz",
    "zvkkihlo.shop",
    "zvmail.com",
    "zvnhkcpnq.shop",
    "zvookkolonka.ru",
    "zvtv.xyz",
    "zvukofon.ru",
    "zvwjfk.us",
    "zw6provider.com",
    "zwallet.com",
    "zwcmanbetx.com",
    "zweb.in",
    "zwmkv0.us",
    "zwnrffoz.shop",
    "zwoho.com",
    "zwphmnfrs.shop",
    "zwpqjsnpkdjbtu2soc.ga",
    "zwpqjsnpkdjbtu2soc.ml",
    "zwpqjsnpkdjbtu2soc.tk",
    "zwunwvxz.shop",
    "zwwaltered.com",
    "zwwnhmmcec57ziwux.cf",
    "zwwnhmmcec57ziwux.ga",
    "zwwnhmmcec57ziwux.gq",
    "zwwnhmmcec57ziwux.ml",
    "zwwnhmmcec57ziwux.tk",
    "zx180.com",
    "zx3dl.com",
    "zx3dlzc.com",
    "zx3gw.com",
    "zx553.com",
    "zx81.ovh",
    "zxcnvgj2-privnbmgt.press",
    "zxcnvgj2-privnbmgt.xyz",
    "zxcv.com",
    "zxcvbnm.cf",
    "zxcvbnm.com",
    "zxcvbnm.tk",
    "zxcvbtyuytfcvb06nbp.monster",
    "zxcxc.com",
    "zxd9837.com",
    "zxgsd4gydfg.ga",
    "zxlzct.info",
    "zxnhu0.us",
    "zxo.us",
    "zxonkcw91bjdojkn.cf",
    "zxonkcw91bjdojkn.ga",
    "zxonkcw91bjdojkn.gq",
    "zxonkcw91bjdojkn.ml",
    "zxonkcw91bjdojkn.tk",
    "zxq1998.design",
    "zxqpgame.com",
    "zxuinf.us",
    "zxusnkn0ahscvuk0v.cf",
    "zxusnkn0ahscvuk0v.ga",
    "zxusnkn0ahscvuk0v.gq",
    "zxusnkn0ahscvuk0v.ml",
    "zxusnkn0ahscvuk0v.tk",
    "zxw114.info",
    "zxwg.site",
    "zxxxz.gq",
    "zxxz.ml",
    "zyarat40.com",
    "zyazu.xyz",
    "zybermail.com",
    "zybermail.dk",
    "zybiqe.site",
    "zydecofan.com",
    "zyegabvk.shop",
    "zyeht.info",
    "zyfdz.com",
    "zyga2d.us",
    "zygnomic.xyz",
    "zyjzdrowiej.club",
    "zylpu4cm6hrwrgrqxb.cf",
    "zylpu4cm6hrwrgrqxb.ga",
    "zylpu4cm6hrwrgrqxb.gq",
    "zylpu4cm6hrwrgrqxb.ml",
    "zylpu4cm6hrwrgrqxb.tk",
    "zymail.men",
    "zymotic.xyz",
    "zymuying.com",
    "zynana.cf",
    "zynana.ga",
    "zynga-email.com",
    "zyngabahis77.com",
    "zyngabahis80.com",
    "zyoxry.site",
    "zypu.site",
    "zyqoje.info",
    "zyte.site",
    "zyyberrys.com",
    "zyyg.net",
    "zyyu6mute9qn.cf",
    "zyyu6mute9qn.ga",
    "zyyu6mute9qn.gq",
    "zyyu6mute9qn.ml",
    "zyyu6mute9qn.tk",
    "zz-6677.com",
    "zz.mu",
    "zz1298.com",
    "zz75.net",
    "zz7665.com",
    "zz77.com",
    "zz8ty.com",
    "zz9094.com",
    "zz9827.com",
    "zza77.com",
    "zzhjqr.com",
    "zzi.us",
    "zzjbfwqi.shop",
    "zzn.com",
    "zzolboo02.com",
    "zzom.co.uk",
    "zzom.co.uk1033edge.com",
    "zzom.co.uk123.com",
    "zzom.co.ukgmail.com",
    "zzom.co.ukhitmail.com",
    "zzom.co.uksina.com",
    "zzom.co.uksina.com0-mail.com",
    "zzqaau.rest",
    "zzrgg.com",
    "zzxilie.xyz",
    "zzz-xxx.com",
    "zzz.com",
    "zzz.pl",
    "zzz813.com",
    "zzz98.xyz"
]);

});

parcelRegister("4H8De", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $36b1dfad2b61be47$var$isEmail;

var $36b1dfad2b61be47$var$_assertString = $36b1dfad2b61be47$var$_interopRequireDefault((parcelRequire("bnen1")));

var $36b1dfad2b61be47$var$_isByteLength = $36b1dfad2b61be47$var$_interopRequireDefault((parcelRequire("cPHxt")));

var $36b1dfad2b61be47$var$_isFQDN = $36b1dfad2b61be47$var$_interopRequireDefault((parcelRequire("almTI")));

var $36b1dfad2b61be47$var$_isIP = $36b1dfad2b61be47$var$_interopRequireDefault((parcelRequire("ccVky")));

var $36b1dfad2b61be47$var$_merge = $36b1dfad2b61be47$var$_interopRequireDefault((parcelRequire("69eOl")));
function $36b1dfad2b61be47$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $36b1dfad2b61be47$var$default_email_options = {
    allow_display_name: false,
    allow_underscores: false,
    require_display_name: false,
    allow_utf8_local_part: true,
    require_tld: true,
    blacklisted_chars: "",
    ignore_max_length: false,
    host_blacklist: [],
    host_whitelist: []
};
/* eslint-disable max-len */ /* eslint-disable no-control-regex */ var $36b1dfad2b61be47$var$splitNameAddress = /^([^\x00-\x1F\x7F-\x9F\cX]+)</i;
var $36b1dfad2b61be47$var$emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
var $36b1dfad2b61be47$var$gmailUserPart = /^[a-z\d]+$/;
var $36b1dfad2b61be47$var$quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
var $36b1dfad2b61be47$var$emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A1-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
var $36b1dfad2b61be47$var$quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
var $36b1dfad2b61be47$var$defaultMaxEmailLength = 254;
/* eslint-enable max-len */ /* eslint-enable no-control-regex */ /**
 * Validate display name according to the RFC2822: https://tools.ietf.org/html/rfc2822#appendix-A.1.2
 * @param {String} display_name
 */ function $36b1dfad2b61be47$var$validateDisplayName(display_name) {
    var display_name_without_quotes = display_name.replace(/^"(.+)"$/, "$1");
    // display name with only spaces is not valid
    if (!display_name_without_quotes.trim()) return false;
    // check whether display name contains illegal character
    var contains_illegal = /[\.";<>]/.test(display_name_without_quotes);
    if (contains_illegal) {
        // if contains illegal characters,
        // must to be enclosed in double-quotes, otherwise it's not a valid display name
        if (display_name_without_quotes === display_name) return false;
        // the quotes in display name must start with character symbol \
        var all_start_with_back_slash = display_name_without_quotes.split('"').length === display_name_without_quotes.split('\\"').length;
        if (!all_start_with_back_slash) return false;
    }
    return true;
}
function $36b1dfad2b61be47$var$isEmail(str, options) {
    (0, $36b1dfad2b61be47$var$_assertString.default)(str);
    options = (0, $36b1dfad2b61be47$var$_merge.default)(options, $36b1dfad2b61be47$var$default_email_options);
    if (options.require_display_name || options.allow_display_name) {
        var display_email = str.match($36b1dfad2b61be47$var$splitNameAddress);
        if (display_email) {
            var display_name = display_email[1];
            // Remove display name and angle brackets to get email address
            // Can be done in the regex but will introduce a ReDOS (See  #1597 for more info)
            str = str.replace(display_name, "").replace(/(^<|>$)/g, "");
            // sometimes need to trim the last space to get the display name
            // because there may be a space between display name and email address
            // eg. myname <address@gmail.com>
            // the display name is `myname` instead of `myname `, so need to trim the last space
            if (display_name.endsWith(" ")) display_name = display_name.slice(0, -1);
            if (!$36b1dfad2b61be47$var$validateDisplayName(display_name)) return false;
        } else if (options.require_display_name) return false;
    }
    if (!options.ignore_max_length && str.length > $36b1dfad2b61be47$var$defaultMaxEmailLength) return false;
    var parts = str.split("@");
    var domain = parts.pop();
    var lower_domain = domain.toLowerCase();
    if (options.host_blacklist.includes(lower_domain)) return false;
    if (options.host_whitelist.length > 0 && !options.host_whitelist.includes(lower_domain)) return false;
    var user = parts.join("@");
    if (options.domain_specific_validation && (lower_domain === "gmail.com" || lower_domain === "googlemail.com")) {
        /*
      Previously we removed dots for gmail addresses before validating.
      This was removed because it allows `multiple..dots@gmail.com`
      to be reported as valid, but it is not.
      Gmail only normalizes single dots, removing them from here is pointless,
      should be done in normalizeEmail
    */ user = user.toLowerCase();
        // Removing sub-address from username before gmail validation
        var username = user.split("+")[0];
        // Dots are not included in gmail length restriction
        if (!(0, $36b1dfad2b61be47$var$_isByteLength.default)(username.replace(/\./g, ""), {
            min: 6,
            max: 30
        })) return false;
        var _user_parts = username.split(".");
        for(var i = 0; i < _user_parts.length; i++){
            if (!$36b1dfad2b61be47$var$gmailUserPart.test(_user_parts[i])) return false;
        }
    }
    if (options.ignore_max_length === false && (!(0, $36b1dfad2b61be47$var$_isByteLength.default)(user, {
        max: 64
    }) || !(0, $36b1dfad2b61be47$var$_isByteLength.default)(domain, {
        max: 254
    }))) return false;
    if (!(0, $36b1dfad2b61be47$var$_isFQDN.default)(domain, {
        require_tld: options.require_tld,
        ignore_max_length: options.ignore_max_length,
        allow_underscores: options.allow_underscores
    })) {
        if (!options.allow_ip_domain) return false;
        if (!(0, $36b1dfad2b61be47$var$_isIP.default)(domain)) {
            if (!domain.startsWith("[") || !domain.endsWith("]")) return false;
            var noBracketdomain = domain.slice(1, -1);
            if (noBracketdomain.length === 0 || !(0, $36b1dfad2b61be47$var$_isIP.default)(noBracketdomain)) return false;
        }
    }
    if (user[0] === '"') {
        user = user.slice(1, user.length - 1);
        return options.allow_utf8_local_part ? $36b1dfad2b61be47$var$quotedEmailUserUtf8.test(user) : $36b1dfad2b61be47$var$quotedEmailUser.test(user);
    }
    var pattern = options.allow_utf8_local_part ? $36b1dfad2b61be47$var$emailUserUtf8Part : $36b1dfad2b61be47$var$emailUserPart;
    var user_parts = user.split(".");
    for(var _i = 0; _i < user_parts.length; _i++){
        if (!pattern.test(user_parts[_i])) return false;
    }
    if (options.blacklisted_chars) {
        if (user.search(new RegExp("[".concat(options.blacklisted_chars, "]+"), "g")) !== -1) return false;
    }
    return true;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("bnen1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $847cfd5c924f315a$var$assertString;
function $847cfd5c924f315a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $847cfd5c924f315a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $847cfd5c924f315a$var$_typeof(o);
}
function $847cfd5c924f315a$var$assertString(input) {
    var isString = typeof input === "string" || input instanceof String;
    if (!isString) {
        var invalidType = $847cfd5c924f315a$var$_typeof(input);
        if (input === null) invalidType = "null";
        else if (invalidType === "object") invalidType = input.constructor.name;
        throw new TypeError("Expected a string but received a ".concat(invalidType));
    }
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("cPHxt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $957c055fb04987f3$var$isByteLength;

var $957c055fb04987f3$var$_assertString = $957c055fb04987f3$var$_interopRequireDefault((parcelRequire("bnen1")));
function $957c055fb04987f3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $957c055fb04987f3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $957c055fb04987f3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $957c055fb04987f3$var$_typeof(o);
}
/* eslint-disable prefer-rest-params */ function $957c055fb04987f3$var$isByteLength(str, options) {
    (0, $957c055fb04987f3$var$_assertString.default)(str);
    var min;
    var max;
    if ($957c055fb04987f3$var$_typeof(options) === "object") {
        min = options.min || 0;
        max = options.max;
    } else {
        // backwards compatibility: isByteLength(str, min [, max])
        min = arguments[1];
        max = arguments[2];
    }
    var len = encodeURI(str).split(/%..|./).length - 1;
    return len >= min && (typeof max === "undefined" || len <= max);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("almTI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $787da08831688f77$var$isFQDN;

var $787da08831688f77$var$_assertString = $787da08831688f77$var$_interopRequireDefault((parcelRequire("bnen1")));

var $787da08831688f77$var$_merge = $787da08831688f77$var$_interopRequireDefault((parcelRequire("69eOl")));
function $787da08831688f77$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $787da08831688f77$var$default_fqdn_options = {
    require_tld: true,
    allow_underscores: false,
    allow_trailing_dot: false,
    allow_numeric_tld: false,
    allow_wildcard: false,
    ignore_max_length: false
};
function $787da08831688f77$var$isFQDN(str, options) {
    (0, $787da08831688f77$var$_assertString.default)(str);
    options = (0, $787da08831688f77$var$_merge.default)(options, $787da08831688f77$var$default_fqdn_options);
    /* Remove the optional trailing dot before checking validity */ if (options.allow_trailing_dot && str[str.length - 1] === ".") str = str.substring(0, str.length - 1);
    /* Remove the optional wildcard before checking validity */ if (options.allow_wildcard === true && str.indexOf("*.") === 0) str = str.substring(2);
    var parts = str.split(".");
    var tld = parts[parts.length - 1];
    if (options.require_tld) {
        // disallow fqdns without tld
        if (parts.length < 2) return false;
        if (!options.allow_numeric_tld && !/^([a-z\u00A1-\u00A8\u00AA-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) return false;
        // disallow spaces
        if (/\s/.test(tld)) return false;
    }
    // reject numeric TLDs
    if (!options.allow_numeric_tld && /^\d+$/.test(tld)) return false;
    return parts.every(function(part) {
        if (part.length > 63 && !options.ignore_max_length) return false;
        if (!/^[a-z_\u00a1-\uffff0-9-]+$/i.test(part)) return false;
        // disallow full-width chars
        if (/[\uff01-\uff5e]/.test(part)) return false;
        // disallow parts starting or ending with hyphen
        if (/^-|-$/.test(part)) return false;
        if (!options.allow_underscores && /_/.test(part)) return false;
        return true;
    });
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("69eOl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $479f127d38f4be01$var$merge;
function $479f127d38f4be01$var$merge() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var defaults = arguments.length > 1 ? arguments[1] : undefined;
    for(var key in defaults)if (typeof obj[key] === "undefined") obj[key] = defaults[key];
    return obj;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});


parcelRegister("ccVky", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8e3313afebfd4ab7$var$isIP;

var $8e3313afebfd4ab7$var$_assertString = $8e3313afebfd4ab7$var$_interopRequireDefault((parcelRequire("bnen1")));
function $8e3313afebfd4ab7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
11.3.  Examples

   The following addresses

             fe80::1234 (on the 1st link of the node)
             ff02::5678 (on the 5th link of the node)
             ff08::9abc (on the 10th organization of the node)

   would be represented as follows:

             fe80::1234%1
             ff02::5678%5
             ff08::9abc%10

   (Here we assume a natural translation from a zone index to the
   <zone_id> part, where the Nth zone of any scope is translated into
   "N".)

   If we use interface names as <zone_id>, those addresses could also be
   represented as follows:

            fe80::1234%ne0
            ff02::5678%pvc1.3
            ff08::9abc%interface10

   where the interface "ne0" belongs to the 1st link, "pvc1.3" belongs
   to the 5th link, and "interface10" belongs to the 10th organization.
 * * */ var $8e3313afebfd4ab7$var$IPv4SegmentFormat = "(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])";
var $8e3313afebfd4ab7$var$IPv4AddressFormat = "(".concat($8e3313afebfd4ab7$var$IPv4SegmentFormat, "[.]){3}").concat($8e3313afebfd4ab7$var$IPv4SegmentFormat);
var $8e3313afebfd4ab7$var$IPv4AddressRegExp = new RegExp("^".concat($8e3313afebfd4ab7$var$IPv4AddressFormat, "$"));
var $8e3313afebfd4ab7$var$IPv6SegmentFormat = "(?:[0-9a-fA-F]{1,4})";
var $8e3313afebfd4ab7$var$IPv6AddressRegExp = new RegExp("^(" + "(?:".concat($8e3313afebfd4ab7$var$IPv6SegmentFormat, ":){7}(?:").concat($8e3313afebfd4ab7$var$IPv6SegmentFormat, "|:)|") + "(?:".concat($8e3313afebfd4ab7$var$IPv6SegmentFormat, ":){6}(?:").concat($8e3313afebfd4ab7$var$IPv4AddressFormat, "|:").concat($8e3313afebfd4ab7$var$IPv6SegmentFormat, "|:)|") + "(?:".concat($8e3313afebfd4ab7$var$IPv6SegmentFormat, ":){5}(?::").concat($8e3313afebfd4ab7$var$IPv4AddressFormat, "|(:").concat($8e3313afebfd4ab7$var$IPv6SegmentFormat, "){1,2}|:)|") + "(?:".concat($8e3313afebfd4ab7$var$IPv6SegmentFormat, ":){4}(?:(:").concat($8e3313afebfd4ab7$var$IPv6SegmentFormat, "){0,1}:").concat($8e3313afebfd4ab7$var$IPv4AddressFormat, "|(:").concat($8e3313afebfd4ab7$var$IPv6SegmentFormat, "){1,3}|:)|") + "(?:".concat($8e3313afebfd4ab7$var$IPv6SegmentFormat, ":){3}(?:(:").concat($8e3313afebfd4ab7$var$IPv6SegmentFormat, "){0,2}:").concat($8e3313afebfd4ab7$var$IPv4AddressFormat, "|(:").concat($8e3313afebfd4ab7$var$IPv6SegmentFormat, "){1,4}|:)|") + "(?:".concat($8e3313afebfd4ab7$var$IPv6SegmentFormat, ":){2}(?:(:").concat($8e3313afebfd4ab7$var$IPv6SegmentFormat, "){0,3}:").concat($8e3313afebfd4ab7$var$IPv4AddressFormat, "|(:").concat($8e3313afebfd4ab7$var$IPv6SegmentFormat, "){1,5}|:)|") + "(?:".concat($8e3313afebfd4ab7$var$IPv6SegmentFormat, ":){1}(?:(:").concat($8e3313afebfd4ab7$var$IPv6SegmentFormat, "){0,4}:").concat($8e3313afebfd4ab7$var$IPv4AddressFormat, "|(:").concat($8e3313afebfd4ab7$var$IPv6SegmentFormat, "){1,6}|:)|") + "(?::((?::".concat($8e3313afebfd4ab7$var$IPv6SegmentFormat, "){0,5}:").concat($8e3313afebfd4ab7$var$IPv4AddressFormat, "|(?::").concat($8e3313afebfd4ab7$var$IPv6SegmentFormat, "){1,7}|:))") + ")(%[0-9a-zA-Z-.:]{1,})?$");
function $8e3313afebfd4ab7$var$isIP(str) {
    var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    (0, $8e3313afebfd4ab7$var$_assertString.default)(str);
    version = String(version);
    if (!version) return $8e3313afebfd4ab7$var$isIP(str, 4) || $8e3313afebfd4ab7$var$isIP(str, 6);
    if (version === "4") return $8e3313afebfd4ab7$var$IPv4AddressRegExp.test(str);
    if (version === "6") return $8e3313afebfd4ab7$var$IPv6AddressRegExp.test(str);
    return false;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});




parcelRegister("01BMe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $004d65cdd2d7e234$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $hzmaq = parcelRequire("hzmaq");

var $fTGwv = parcelRequire("fTGwv");

var $2YJBX = parcelRequire("2YJBX");

var $bksdd = parcelRequire("bksdd");

var $e57zc = parcelRequire("e57zc");

var $5XMpG = parcelRequire("5XMpG");

var $dfQH6 = parcelRequire("dfQH6");

var $dKid7 = parcelRequire("dKid7");

var $uywq3 = parcelRequire("uywq3");
var $1kvoC = parcelRequire("1kvoC");
var $bgV8F = parcelRequire("bgV8F");
var $cfwbh = parcelRequire("cfwbh");
var $kqCA7 = parcelRequire("kqCA7");
var $4nt1z = parcelRequire("4nt1z");
const $004d65cdd2d7e234$var$DomainCard = ({ domain: domain, onRemove: onRemove, processing: processing })=>{
    var _domain$verification;
    const [verifyEmail, setVerifyEmail] = (0, $jbmdS.useState)("");
    const [verifyCode, setVerifyCode] = (0, $jbmdS.useState)("");
    const [isVerifying, setIsVerifying] = (0, $jbmdS.useState)(false);
    const [verifyError, setVerifyError] = (0, $jbmdS.useState)("");
    const [verificationStep, setVerificationStep] = (0, $jbmdS.useState)("email");
    const [success, setSuccess] = (0, $jbmdS.useState)("");
    const [isUpdatingEnrollment, setIsUpdatingEnrollment] = (0, $jbmdS.useState)(false);
    const needsVerification = !domain.verification || domain.verification.status === "unverified";
    const handleEnrollmentChange = async (checked)=>{
        setIsUpdatingEnrollment(true);
        setVerifyError("");
        setSuccess("");
        try {
            // Use the correct Clerk API method
            await domain.updateEnrollmentMode({
                enrollment_mode: checked ? "automatic_invitation" : "manual_invitation"
            });
            setSuccess("Enrollment mode updated successfully.");
        } catch (err) {
            setVerifyError(err.message || "Failed to update enrollment mode");
        } finally{
            setIsUpdatingEnrollment(false);
        }
    };
    const handleVerifyEmail = async (e)=>{
        e.preventDefault();
        setIsVerifying(true);
        setVerifyError("");
        setSuccess("");
        try {
            await domain.prepareAffiliationVerification({
                affiliationEmailAddress: verifyEmail
            });
            setVerificationStep("code");
            setSuccess("Verification code sent to your email.");
        } catch (err) {
            setVerifyError(err.message || "Failed to send verification email");
        } finally{
            setIsVerifying(false);
        }
    };
    const handleVerifyCode = async (e)=>{
        e.preventDefault();
        setIsVerifying(true);
        setVerifyError("");
        setSuccess("");
        try {
            await domain.attemptAffiliationVerification({
                code: verifyCode
            });
            window.location.reload();
        } catch (err) {
            setVerifyError(err.message || "Invalid verification code");
        } finally{
            setIsVerifying(false);
        }
    };
    const renderVerificationForm = ()=>{
        if (verificationStep === "email") return /*#__PURE__*/ (0, $61Ea1.jsx)("form", {
            onSubmit: handleVerifyEmail,
            className: "space-y-4",
            children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "flex space-x-2",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "flex-grow",
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $2YJBX.Input), {
                            type: "email",
                            placeholder: `admin@${domain.name}`,
                            value: verifyEmail,
                            onChange: (e)=>setVerifyEmail(e.target.value),
                            required: true,
                            disabled: isVerifying
                        })
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fTGwv.Button), {
                        type: "submit",
                        disabled: !verifyEmail || isVerifying,
                        children: [
                            isVerifying && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bgV8F.default), {
                                className: "mr-2 h-4 w-4 animate-spin"
                            }),
                            "Send Code"
                        ]
                    })
                ]
            })
        });
        return /*#__PURE__*/ (0, $61Ea1.jsxs)("form", {
            onSubmit: handleVerifyCode,
            className: "space-y-4",
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $dfQH6.Alert), {
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $cfwbh.default), {
                            className: "h-4 w-4"
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $dfQH6.AlertDescription), {
                            children: [
                                "Enter the verification code sent to ",
                                verifyEmail
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    className: "flex space-x-2",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            className: "flex-grow",
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $2YJBX.Input), {
                                type: "text",
                                placeholder: "Enter verification code",
                                value: verifyCode,
                                onChange: (e)=>setVerifyCode(e.target.value),
                                required: true,
                                disabled: isVerifying
                            })
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fTGwv.Button), {
                            type: "submit",
                            disabled: !verifyCode || isVerifying,
                            children: [
                                isVerifying && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bgV8F.default), {
                                    className: "mr-2 h-4 w-4 animate-spin"
                                }),
                                "Verify"
                            ]
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fTGwv.Button), {
                            type: "button",
                            variant: "ghost",
                            onClick: ()=>{
                                setVerificationStep("email");
                                setVerifyCode("");
                                setVerifyError("");
                            },
                            children: "Back"
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "flex flex-col p-4 border rounded-lg space-y-4",
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "flex items-center justify-between",
                children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    className: "space-y-2 w-full",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            className: "flex items-center justify-between",
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                    className: "flex items-center space-x-2",
                                    children: [
                                        /*#__PURE__*/ (0, $61Ea1.jsx)("p", {
                                            className: "font-medium",
                                            children: domain.name
                                        }),
                                        domain.verification ? /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $dKid7.Badge), {
                                            className: domain.verification.status === "verified" ? "bg-green-200" : "bg-yellow-200",
                                            children: [
                                                domain.verification.status === "verified" ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $1kvoC.default), {
                                                    className: "w-3 h-3 mr-1"
                                                }) : /*#__PURE__*/ (0, $61Ea1.jsx)((0, $uywq3.default), {
                                                    className: "w-3 h-3 mr-1"
                                                }),
                                                domain.verification.status === "verified" ? "Verified" : "Pending"
                                            ]
                                        }) : /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $dKid7.Badge), {
                                            variant: "secondary",
                                            children: [
                                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $uywq3.default), {
                                                    className: "w-3 h-3 mr-1"
                                                }),
                                                "Unverified"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fTGwv.Button), {
                                    variant: "ghost",
                                    size: "icon",
                                    onClick: ()=>onRemove(domain),
                                    disabled: processing || isUpdatingEnrollment,
                                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $4nt1z.default), {
                                        className: "w-4 h-4"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            className: "flex items-center space-x-2 pt-2",
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $e57zc.Switch), {
                                    id: `enrollment-mode-${domain.id}`,
                                    checked: domain.enrollmentMode === "automatic_invitation",
                                    onCheckedChange: handleEnrollmentChange,
                                    disabled: isUpdatingEnrollment || isVerifying || ((_domain$verification = domain.verification) !== null && _domain$verification !== void 0 && _domain$verification.status, false)
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5XMpG.Label), {
                                    htmlFor: `enrollment-mode-${domain.id}`,
                                    className: "text-sm text-muted-foreground",
                                    children: isUpdatingEnrollment ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                        className: "flex items-center space-x-2",
                                        children: [
                                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bgV8F.default), {
                                                className: "h-3 w-3 animate-spin"
                                            }),
                                            /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                                children: "Updating..."
                                            })
                                        ]
                                    }) : "Automatic enrollment"
                                })
                            ]
                        })
                    ]
                })
            }),
            needsVerification && /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "space-y-4",
                children: [
                    verifyError && /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $dfQH6.Alert), {
                        variant: "destructive",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $uywq3.default), {
                                className: "h-4 w-4"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $dfQH6.AlertDescription), {
                                children: verifyError
                            })
                        ]
                    }),
                    success && /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $dfQH6.Alert), {
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $1kvoC.default), {
                                className: "h-4 w-4"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $dfQH6.AlertDescription), {
                                children: success
                            })
                        ]
                    }),
                    renderVerificationForm()
                ]
            })
        ]
    });
};
const $004d65cdd2d7e234$var$DomainVerification = ()=>{
    const { organization: organization } = (0, $hzmaq.useOrganization)();
    const [domains, setDomains] = (0, $jbmdS.useState)([]);
    const [loading, setLoading] = (0, $jbmdS.useState)(true);
    const [showAddForm, setShowAddForm] = (0, $jbmdS.useState)(false);
    const [newDomain, setNewDomain] = (0, $jbmdS.useState)("");
    const [enrollmentMode, setEnrollmentMode] = (0, $jbmdS.useState)("manual_invitation");
    const [verificationStep, setVerificationStep] = (0, $jbmdS.useState)("domain");
    const [verificationEmail, setVerificationEmail] = (0, $jbmdS.useState)("");
    const [verificationCode, setVerificationCode] = (0, $jbmdS.useState)("");
    const [currentDomain, setCurrentDomain] = (0, $jbmdS.useState)(null);
    const [processing, setProcessing] = (0, $jbmdS.useState)(false);
    const [error, setError] = (0, $jbmdS.useState)("");
    const [success, setSuccess] = (0, $jbmdS.useState)("");
    (0, $jbmdS.useEffect)(()=>{
        if (!(organization !== null && organization !== void 0 && organization.id)) return;
        loadDomains();
    }, [
        organization === null || organization === void 0 ? void 0 : organization.id
    ]); // Only depends on organization ID
    const loadDomains = async ()=>{
        if (!(organization !== null && organization !== void 0 && organization.id)) return;
        try {
            setLoading(true);
            const domainList = await organization.getDomains();
            setDomains(domainList.data);
            setError("");
        } catch (err) {
            setError("Failed to load domains. Please try again.");
        } finally{
            setLoading(false);
        }
    };
    const handleAddDomain = async (e)=>{
        e.preventDefault();
        setProcessing(true);
        setError("");
        setSuccess("");
        try {
            const domain = await organization.createDomain(newDomain);
            setCurrentDomain(domain);
            setVerificationStep("email");
            setNewDomain("");
            setEnrollmentMode("manual_invitation");
            await loadDomains();
            setSuccess("Domain added successfully. Please complete verification.");
        } catch (err) {
            setError(err.message || "Failed to add domain. Please try again.");
        } finally{
            setProcessing(false);
        }
    };
    const handleVerifyEmail = async (e)=>{
        e.preventDefault();
        setProcessing(true);
        setError("");
        setSuccess("");
        try {
            await currentDomain.prepareAffiliationVerification({
                affiliationEmailAddress: verificationEmail
            });
            setVerificationStep("code");
            setSuccess("Verification email sent. Please check your inbox.");
        } catch (err) {
            setError(err.message || "Failed to send verification email. Please try again.");
        } finally{
            setProcessing(false);
        }
    };
    const handleVerifyCode = async (e)=>{
        e.preventDefault();
        setProcessing(true);
        setError("");
        setSuccess("");
        try {
            await currentDomain.attemptAffiliationVerification({
                code: verificationCode
            });
            await loadDomains();
            setShowAddForm(false);
            setVerificationStep("domain");
            setVerificationEmail("");
            setVerificationCode("");
            setCurrentDomain(null);
            setSuccess("Domain verified successfully.");
        } catch (err) {
            setError(err.message || "Invalid verification code. Please try again.");
        } finally{
            setProcessing(false);
        }
    };
    const handleRemoveDomain = async (domain)=>{
        setProcessing(true);
        setError("");
        setSuccess("");
        try {
            await domain.delete();
            await loadDomains();
            setSuccess("Domain removed successfully.");
        } catch (err) {
            setError(err.message || "Failed to remove domain. Please try again.");
        } finally{
            setProcessing(false);
        }
    };
    const renderDomainList = ()=>/*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            className: "space-y-4",
            children: domains.map((domain)=>/*#__PURE__*/ (0, $61Ea1.jsx)($004d65cdd2d7e234$var$DomainCard, {
                    domain: domain,
                    onRemove: handleRemoveDomain,
                    processing: processing
                }, domain.id))
        });
    const renderAddForm = ()=>/*#__PURE__*/ (0, $61Ea1.jsxs)((0, $bksdd.Card), {
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $bksdd.CardHeader), {
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bksdd.CardTitle), {
                            children: "Add domain"
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bksdd.CardDescription), {
                            children: "Add the domain to verify. Users with email addresses at this domain can join the organization automatically or request to join."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $bksdd.CardContent), {
                    children: [
                        error && /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $dfQH6.Alert), {
                            variant: "destructive",
                            className: "mb-4",
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $uywq3.default), {
                                    className: "h-4 w-4"
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $dfQH6.AlertDescription), {
                                    children: error
                                })
                            ]
                        }),
                        success && /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $dfQH6.Alert), {
                            className: "mb-4",
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $1kvoC.default), {
                                    className: "h-4 w-4"
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $dfQH6.AlertDescription), {
                                    children: success
                                })
                            ]
                        }),
                        verificationStep === "domain" && /*#__PURE__*/ (0, $61Ea1.jsxs)("form", {
                            onSubmit: handleAddDomain,
                            className: "space-y-6",
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                    className: "space-y-2",
                                    children: [
                                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5XMpG.Label), {
                                            htmlFor: "domain",
                                            children: "Domain"
                                        }),
                                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $2YJBX.Input), {
                                            id: "domain",
                                            placeholder: "example.com",
                                            value: newDomain,
                                            onChange: (e)=>setNewDomain(e.target.value),
                                            required: true,
                                            disabled: processing
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                    className: "space-y-4",
                                    children: [
                                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5XMpG.Label), {
                                            children: "Enrollment Mode"
                                        }),
                                        /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                            className: "flex items-center space-x-2",
                                            children: [
                                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $e57zc.Switch), {
                                                    id: "enrollment-mode",
                                                    checked: enrollmentMode === "automatic_invitation",
                                                    onCheckedChange: (checked)=>setEnrollmentMode(checked ? "automatic_invitation" : "manual_invitation"),
                                                    disabled: processing
                                                }),
                                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5XMpG.Label), {
                                                    htmlFor: "enrollment-mode",
                                                    children: "Enable automatic enrollment"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                    className: "flex space-x-2",
                                    children: [
                                        /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fTGwv.Button), {
                                            type: "submit",
                                            disabled: !newDomain || processing,
                                            children: [
                                                processing && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bgV8F.default), {
                                                    className: "mr-2 h-4 w-4 animate-spin"
                                                }),
                                                "Save"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fTGwv.Button), {
                                            type: "button",
                                            variant: "ghost",
                                            onClick: ()=>{
                                                setShowAddForm(false);
                                                setError("");
                                                setSuccess("");
                                            },
                                            disabled: processing,
                                            children: "Cancel"
                                        })
                                    ]
                                })
                            ]
                        }),
                        verificationStep === "email" && /*#__PURE__*/ (0, $61Ea1.jsxs)("form", {
                            onSubmit: handleVerifyEmail,
                            className: "space-y-6",
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $dfQH6.Alert), {
                                    children: [
                                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $cfwbh.default), {
                                            className: "w-4 h-4"
                                        }),
                                        /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $dfQH6.AlertDescription), {
                                            children: [
                                                "We couldn't verify the domain automatically. Please provide an email address at",
                                                " ",
                                                currentDomain === null || currentDomain === void 0 ? void 0 : currentDomain.name,
                                                " to verify ownership."
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                    className: "space-y-2",
                                    children: [
                                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5XMpG.Label), {
                                            htmlFor: "email",
                                            children: "Email address"
                                        }),
                                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $2YJBX.Input), {
                                            id: "email",
                                            type: "email",
                                            placeholder: `admin@${currentDomain === null || currentDomain === void 0 ? void 0 : currentDomain.name}`,
                                            value: verificationEmail,
                                            onChange: (e)=>setVerificationEmail(e.target.value),
                                            required: true,
                                            disabled: processing
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                    className: "flex space-x-2",
                                    children: [
                                        /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fTGwv.Button), {
                                            type: "submit",
                                            disabled: !verificationEmail || processing,
                                            children: [
                                                processing && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bgV8F.default), {
                                                    className: "mr-2 h-4 w-4 animate-spin"
                                                }),
                                                "Send verification"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fTGwv.Button), {
                                            type: "button",
                                            variant: "ghost",
                                            onClick: ()=>{
                                                setShowAddForm(false);
                                                setError("");
                                                setSuccess("");
                                            },
                                            disabled: processing,
                                            children: "Cancel"
                                        })
                                    ]
                                })
                            ]
                        }),
                        verificationStep === "code" && /*#__PURE__*/ (0, $61Ea1.jsxs)("form", {
                            onSubmit: handleVerifyCode,
                            className: "space-y-6",
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $dfQH6.Alert), {
                                    children: [
                                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $cfwbh.default), {
                                            className: "w-4 h-4"
                                        }),
                                        /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $dfQH6.AlertDescription), {
                                            children: [
                                                "Please enter the verification code sent to",
                                                " ",
                                                verificationEmail
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                    className: "space-y-2",
                                    children: [
                                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5XMpG.Label), {
                                            htmlFor: "code",
                                            children: "Verification code"
                                        }),
                                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $2YJBX.Input), {
                                            id: "code",
                                            placeholder: "Enter code",
                                            value: verificationCode,
                                            onChange: (e)=>setVerificationCode(e.target.value),
                                            required: true,
                                            disabled: processing
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                    className: "flex space-x-2",
                                    children: [
                                        /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fTGwv.Button), {
                                            type: "submit",
                                            disabled: !verificationCode || processing,
                                            children: [
                                                processing && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bgV8F.default), {
                                                    className: "mr-2 h-4 w-4 animate-spin"
                                                }),
                                                "Verify"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fTGwv.Button), {
                                            type: "button",
                                            variant: "ghost",
                                            onClick: ()=>{
                                                setShowAddForm(false);
                                                setError("");
                                                setSuccess("");
                                            },
                                            disabled: processing,
                                            children: "Cancel"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    if (loading) return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "flex items-center justify-center p-8",
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bgV8F.default), {
            className: "h-8 w-8 animate-spin"
        })
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "space-y-6",
        children: [
            domains.length > 0 && renderDomainList(),
            !showAddForm ? /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fTGwv.Button), {
                onClick: ()=>setShowAddForm(true),
                className: "w-full",
                variant: "outline",
                disabled: processing,
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqCA7.default), {
                        className: "w-4 h-4 mr-2"
                    }),
                    "Add domain"
                ]
            }) : renderAddForm()
        ]
    });
};
var $004d65cdd2d7e234$export$2e2bcd8739ae039 = $004d65cdd2d7e234$var$DomainVerification;

});
parcelRegister("bksdd", function(module, exports) {

$parcel$export(module.exports, "Card", function () { return $043787a6c9b06170$export$60332b2344f7fe41; });
$parcel$export(module.exports, "CardHeader", function () { return $043787a6c9b06170$export$5665775b26e26c5d; });
$parcel$export(module.exports, "CardTitle", function () { return $043787a6c9b06170$export$474db65c3c394e1c; });
$parcel$export(module.exports, "CardDescription", function () { return $043787a6c9b06170$export$16e0ed4cb97c00d4; });
$parcel$export(module.exports, "CardContent", function () { return $043787a6c9b06170$export$64ef9b8c11710c47; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $Yha9m = parcelRequire("Yha9m");
const $043787a6c9b06170$export$60332b2344f7fe41 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        ref: ref,
        className: (0, $Yha9m.cn)("rounded-lg border bg-card text-card-foreground shadow-sm", className),
        ...props
    }));
$043787a6c9b06170$export$60332b2344f7fe41.displayName = "Card";
const $043787a6c9b06170$export$5665775b26e26c5d = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        ref: ref,
        className: (0, $Yha9m.cn)("flex flex-col space-y-1.5 p-6", className),
        ...props
    }));
$043787a6c9b06170$export$5665775b26e26c5d.displayName = "CardHeader";
const $043787a6c9b06170$export$474db65c3c394e1c = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)("h3", {
        ref: ref,
        className: (0, $Yha9m.cn)("text-2xl font-semibold leading-none tracking-tight", className),
        ...props
    }));
$043787a6c9b06170$export$474db65c3c394e1c.displayName = "CardTitle";
const $043787a6c9b06170$export$16e0ed4cb97c00d4 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)("p", {
        ref: ref,
        className: (0, $Yha9m.cn)("text-sm text-muted-foreground", className),
        ...props
    }));
$043787a6c9b06170$export$16e0ed4cb97c00d4.displayName = "CardDescription";
const $043787a6c9b06170$export$64ef9b8c11710c47 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        ref: ref,
        className: (0, $Yha9m.cn)("p-6 pt-0", className),
        ...props
    }));
$043787a6c9b06170$export$64ef9b8c11710c47.displayName = "CardContent";
const $043787a6c9b06170$export$e9897d434e0741ee = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        ref: ref,
        className: (0, $Yha9m.cn)("flex items-center p-6 pt-0", className),
        ...props
    }));
$043787a6c9b06170$export$e9897d434e0741ee.displayName = "CardFooter";

});

parcelRegister("e57zc", function(module, exports) {

$parcel$export(module.exports, "Switch", function () { return $bd8f4c26ec5d0286$export$b5d5cf8927ab7262; });
$parcel$export(module.exports, "SwitchWithLabel", function () { return $bd8f4c26ec5d0286$export$afdb6dae40f95261; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $7xcUw = parcelRequire("7xcUw");

var $95Evz = parcelRequire("95Evz");

var $5XMpG = parcelRequire("5XMpG");
const $bd8f4c26ec5d0286$export$b5d5cf8927ab7262 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)($7xcUw.Root, {
        className: (0, $95Evz.cn)("peer inline-flex h-[20px] w-[36px] shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-white disabled:cursor-not-allowed disabled:opacity-50 bg-indigo-200", className),
        ...props,
        ref: ref,
        children: /*#__PURE__*/ (0, $61Ea1.jsx)($7xcUw.Thumb, {
            className: (0, $95Evz.cn)("pointer-events-none block h-4 w-4 rounded-full data-[state=unchecked]:bg-white data-[state=checked]:bg-indigo-500 shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0")
        })
    }));
$bd8f4c26ec5d0286$export$b5d5cf8927ab7262.displayName = $7xcUw.Root.displayName;
const $bd8f4c26ec5d0286$export$afdb6dae40f95261 = /*#__PURE__*/ $jbmdS.forwardRef(({ label: label, containerClassName: containerClassName, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsxs)("label", {
        className: (0, $95Evz.cn)("flex items-center space-x-2", containerClassName),
        children: [
            label ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5XMpG.Label), {
                children: label
            }) : null,
            /*#__PURE__*/ (0, $61Ea1.jsx)($bd8f4c26ec5d0286$export$b5d5cf8927ab7262, {
                ...props,
                ref: ref
            })
        ]
    }));

});
parcelRegister("7xcUw", function(module, exports) {

$parcel$export(module.exports, "Root", function () { return $7cc32fcf92c75948$export$be92b6f5f03c0fe9; });
$parcel$export(module.exports, "Thumb", function () { return $7cc32fcf92c75948$export$6521433ed15a34db; });

var $jbmdS = parcelRequire("jbmdS");

var $hFcKE = parcelRequire("hFcKE");

var $9sunj = parcelRequire("9sunj");

var $f4RZG = parcelRequire("f4RZG");

var $1sq0Q = parcelRequire("1sq0Q");

var $f4s2q = parcelRequire("f4s2q");

var $am0tV = parcelRequire("am0tV");

var $cihg9 = parcelRequire("cihg9");

var $4TLFw = parcelRequire("4TLFw");
"use client";
var $7cc32fcf92c75948$var$SWITCH_NAME = "Switch";
var [$7cc32fcf92c75948$var$createSwitchContext, $7cc32fcf92c75948$export$cf7f5f17f69cbd43] = (0, $f4RZG.createContextScope)($7cc32fcf92c75948$var$SWITCH_NAME);
var [$7cc32fcf92c75948$var$SwitchProvider, $7cc32fcf92c75948$var$useSwitchContext] = $7cc32fcf92c75948$var$createSwitchContext($7cc32fcf92c75948$var$SWITCH_NAME);
var $7cc32fcf92c75948$export$b5d5cf8927ab7262 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeSwitch: __scopeSwitch, name: name, checked: checkedProp, defaultChecked: defaultChecked, required: required, disabled: disabled, value: value = "on", onCheckedChange: onCheckedChange, form: form, ...switchProps } = props;
    const [button, setButton] = $jbmdS.useState(null);
    const composedRefs = (0, $9sunj.useComposedRefs)(forwardedRef, (node)=>setButton(node));
    const hasConsumerStoppedPropagationRef = $jbmdS.useRef(false);
    const isFormControl = button ? form || !!button.closest("form") : true;
    const [checked = false, setChecked] = (0, $1sq0Q.useControllableState)({
        prop: checkedProp,
        defaultProp: defaultChecked,
        onChange: onCheckedChange
    });
    return /* @__PURE__ */ (0, $4TLFw.jsxs)($7cc32fcf92c75948$var$SwitchProvider, {
        scope: __scopeSwitch,
        checked: checked,
        disabled: disabled,
        children: [
            /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).button, {
                type: "button",
                role: "switch",
                "aria-checked": checked,
                "aria-required": required,
                "data-state": $7cc32fcf92c75948$var$getState(checked),
                "data-disabled": disabled ? "" : void 0,
                disabled: disabled,
                value: value,
                ...switchProps,
                ref: composedRefs,
                onClick: (0, $hFcKE.composeEventHandlers)(props.onClick, (event)=>{
                    setChecked((prevChecked)=>!prevChecked);
                    if (isFormControl) {
                        hasConsumerStoppedPropagationRef.current = event.isPropagationStopped();
                        if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
                    }
                })
            }),
            isFormControl && /* @__PURE__ */ (0, $4TLFw.jsx)($7cc32fcf92c75948$var$BubbleInput, {
                control: button,
                bubbles: !hasConsumerStoppedPropagationRef.current,
                name: name,
                value: value,
                checked: checked,
                required: required,
                disabled: disabled,
                form: form,
                style: {
                    transform: "translateX(-100%)"
                }
            })
        ]
    });
});
$7cc32fcf92c75948$export$b5d5cf8927ab7262.displayName = $7cc32fcf92c75948$var$SWITCH_NAME;
var $7cc32fcf92c75948$var$THUMB_NAME = "SwitchThumb";
var $7cc32fcf92c75948$export$4d07bf653ea69106 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeSwitch: __scopeSwitch, ...thumbProps } = props;
    const context = $7cc32fcf92c75948$var$useSwitchContext($7cc32fcf92c75948$var$THUMB_NAME, __scopeSwitch);
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).span, {
        "data-state": $7cc32fcf92c75948$var$getState(context.checked),
        "data-disabled": context.disabled ? "" : void 0,
        ...thumbProps,
        ref: forwardedRef
    });
});
$7cc32fcf92c75948$export$4d07bf653ea69106.displayName = $7cc32fcf92c75948$var$THUMB_NAME;
var $7cc32fcf92c75948$var$BubbleInput = (props)=>{
    const { control: control, checked: checked, bubbles: bubbles = true, ...inputProps } = props;
    const ref = $jbmdS.useRef(null);
    const prevChecked = (0, $f4s2q.usePrevious)(checked);
    const controlSize = (0, $am0tV.useSize)(control);
    $jbmdS.useEffect(()=>{
        const input = ref.current;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
        const setChecked = descriptor.set;
        if (prevChecked !== checked && setChecked) {
            const event = new Event("click", {
                bubbles: bubbles
            });
            setChecked.call(input, checked);
            input.dispatchEvent(event);
        }
    }, [
        prevChecked,
        checked,
        bubbles
    ]);
    return /* @__PURE__ */ (0, $4TLFw.jsx)("input", {
        type: "checkbox",
        "aria-hidden": true,
        defaultChecked: checked,
        ...inputProps,
        tabIndex: -1,
        ref: ref,
        style: {
            ...props.style,
            ...controlSize,
            position: "absolute",
            pointerEvents: "none",
            opacity: 0,
            margin: 0
        }
    });
};
function $7cc32fcf92c75948$var$getState(checked) {
    return checked ? "checked" : "unchecked";
}
var $7cc32fcf92c75948$export$be92b6f5f03c0fe9 = $7cc32fcf92c75948$export$b5d5cf8927ab7262;
var $7cc32fcf92c75948$export$6521433ed15a34db = $7cc32fcf92c75948$export$4d07bf653ea69106;

});


parcelRegister("dfQH6", function(module, exports) {

$parcel$export(module.exports, "Alert", function () { return $50d9b01bcc56763f$export$caec2af78bcc877f; });
$parcel$export(module.exports, "AlertDescription", function () { return $50d9b01bcc56763f$export$d4feae172fccda11; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $5kn1b = parcelRequire("5kn1b");

var $Yha9m = parcelRequire("Yha9m");
const $50d9b01bcc56763f$var$alertVariants = (0, $5kn1b.cva)("relative w-full rounded-lg border p-4 [&>svg~*]:pl-7 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground", {
    variants: {
        variant: {
            default: "bg-background text-foreground",
            destructive: "border-destructive/50 text-destructive dark:border-destructive [&>svg]:text-destructive"
        }
    },
    defaultVariants: {
        variant: "default"
    }
});
const $50d9b01bcc56763f$export$caec2af78bcc877f = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, variant: variant, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        ref: ref,
        role: "alert",
        className: (0, $Yha9m.cn)($50d9b01bcc56763f$var$alertVariants({
            variant: variant
        }), className),
        ...props
    }));
$50d9b01bcc56763f$export$caec2af78bcc877f.displayName = "Alert";
const $50d9b01bcc56763f$export$4a7253439a300753 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)("h5", {
        ref: ref,
        className: (0, $Yha9m.cn)("mb-1 font-medium leading-none tracking-tight", className),
        ...props
    }));
$50d9b01bcc56763f$export$4a7253439a300753.displayName = "AlertTitle";
const $50d9b01bcc56763f$export$d4feae172fccda11 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        ref: ref,
        className: (0, $Yha9m.cn)("text-sm [&_p]:leading-relaxed", className),
        ...props
    }));
$50d9b01bcc56763f$export$d4feae172fccda11.displayName = "AlertDescription";

});

parcelRegister("dKid7", function(module, exports) {

$parcel$export(module.exports, "Badge", function () { return $7ad752c99ac3155e$export$37acb3580601e69a; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("jbmdS");

var $5kn1b = parcelRequire("5kn1b");

var $Yha9m = parcelRequire("Yha9m");
const $7ad752c99ac3155e$export$48443d129636634d = (0, $5kn1b.cva)("inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2", {
    variants: {
        variant: {
            default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
            secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
            destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
            outline: "text-foreground"
        }
    },
    defaultVariants: {
        variant: "default"
    }
});
function $7ad752c99ac3155e$export$37acb3580601e69a({ className: className, variant: variant, ...props }) {
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: (0, $Yha9m.cn)($7ad752c99ac3155e$export$48443d129636634d({
            variant: variant
        }), className),
        ...props
    });
}

});

parcelRegister("uywq3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05bd94c901bf280e$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $05bd94c901bf280e$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("CircleAlert", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "8",
            y2: "12",
            key: "1pkeuh"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12.01",
            y1: "16",
            y2: "16",
            key: "4dfq90"
        }
    ]
]);

});

parcelRegister("bgV8F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $834d82ee5c609d5b$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $834d82ee5c609d5b$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("LoaderCircle", [
    [
        "path",
        {
            d: "M21 12a9 9 0 1 1-6.219-8.56",
            key: "13zald"
        }
    ]
]);

});

parcelRegister("cfwbh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8eafd9318364b49e$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $8eafd9318364b49e$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("Mail", [
    [
        "rect",
        {
            width: "20",
            height: "16",
            x: "2",
            y: "4",
            rx: "2",
            key: "18n3k1"
        }
    ],
    [
        "path",
        {
            d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7",
            key: "1ocrg3"
        }
    ]
]);

});

parcelRegister("kqCA7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $edf429e0288c8a08$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $edf429e0288c8a08$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("Plus", [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "M12 5v14",
            key: "s699le"
        }
    ]
]);

});

parcelRegister("4nt1z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32ffd30e89a9edab$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $32ffd30e89a9edab$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("Trash", [
    [
        "path",
        {
            d: "M3 6h18",
            key: "d0wm0j"
        }
    ],
    [
        "path",
        {
            d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6",
            key: "4alrt4"
        }
    ],
    [
        "path",
        {
            d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2",
            key: "v07s0e"
        }
    ]
]);

});



parcelRegister("kglP9", function(module, exports) {

$parcel$export(module.exports, "SettingPage", function () { return $9fdc2348d970281a$export$f725d643d9eb40bc; });

var $61Ea1 = parcelRequire("61Ea1");

var $9CBKL = parcelRequire("9CBKL");
const $9fdc2348d970281a$export$f725d643d9eb40bc = ()=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $9CBKL.SettingsPageForm), {});
};

});
parcelRegister("9CBKL", function(module, exports) {

$parcel$export(module.exports, "SettingsPageForm", function () { return $ac5c607156abbfca$export$dd6dc3404e9ac394; });

var $61Ea1 = parcelRequire("61Ea1");

var $8kZ1o = parcelRequire("8kZ1o");

var $3Gs4l = parcelRequire("3Gs4l");

var $8jD92 = parcelRequire("8jD92");

var $01BMe = parcelRequire("01BMe");

var $MYZTJ = parcelRequire("MYZTJ");
function $ac5c607156abbfca$export$dd6dc3404e9ac394() {
    const settings = (0, $MYZTJ.useSetting)();
    const { autoPopulate: autoPopulate, timeEntryAllocations: timeEntryAllocations } = settings;
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "max-w-[60em] py-[2em] px-[4px]",
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "flex items-center py-[2em]",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                        className: "inline-block",
                        children: "Sort Phases By:"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "mx-[1em] w-[12em]",
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3Gs4l.SelectWithLabel), {
                            value: settings.sortPhasesBy,
                            onValueChange: (value)=>{
                                (0, $MYZTJ.settingActions).changeSettings(value, "sortPhasesBy");
                            },
                            options: [
                                {
                                    key: "startDate",
                                    value: "startDate",
                                    label: "Start Date"
                                },
                                {
                                    key: "title",
                                    value: "title",
                                    label: "Title"
                                }
                            ],
                            // defaultValue="title"
                            placeholder: "Select..."
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8jD92.CheckboxWithLabel), {
                    checked: settings.allowNoPhase,
                    onCheckedChange: (value)=>{
                        (0, $MYZTJ.settingActions).changeSettings(value, "allowNoPhase");
                    },
                    id: "allowNoPhase",
                    label: "Allow time to be logged without a selecting a phase."
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "mt-[2em]",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8jD92.CheckboxWithLabel), {
                    checked: settings.useTasks,
                    onCheckedChange: function(value) {
                        (0, $MYZTJ.settingActions).changeSettings(value, "useTasks");
                    },
                    label: "Allow time to be logged against tasks.",
                    id: "useTasks"
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "mt-[2em]",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8jD92.CheckboxWithLabel), {
                    checked: settings.allowAfterPhaseEnd,
                    onCheckedChange: (value)=>{
                        (0, $MYZTJ.settingActions).changeSettings(value, "allowAfterPhaseEnd");
                    },
                    label: "Allow time to be logged against a phase that has ended.",
                    id: "allowAfterPhaseEnd"
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "mt-[3em]",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)("p", {
                    children: "Allow phases with the following statuses to be visible when entering time:"
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "mt-[1em] ml-[2em]",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8jD92.CheckboxWithLabel), {
                    checked: settings.timeEntryStatus.includes("active"),
                    onCheckedChange: function(value) {
                        if (value) (0, $MYZTJ.settingActions).changeSettings([
                            ...settings.timeEntryStatus,
                            "active"
                        ], "timeEntryStatus");
                        else (0, $MYZTJ.settingActions).changeSettings(settings.timeEntryStatus.filter((s)=>s !== "active"), "timeEntryStatus");
                    },
                    label: "Active",
                    id: "active"
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "ml-[2em]",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8jD92.CheckboxWithLabel), {
                    checked: settings.timeEntryStatus.includes("prospective"),
                    onCheckedChange: function(value) {
                        if (value) (0, $MYZTJ.settingActions).changeSettings([
                            ...settings.timeEntryStatus,
                            "prospective"
                        ], "timeEntryStatus");
                        else (0, $MYZTJ.settingActions).changeSettings(settings.timeEntryStatus.filter((s)=>s !== "prospective"), "timeEntryStatus");
                    },
                    label: "Prospective",
                    id: "prospective"
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    marginLeft: "2em"
                },
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8jD92.CheckboxWithLabel), {
                    checked: settings.timeEntryStatus.includes("onHold"),
                    onCheckedChange: function(value) {
                        if (value) (0, $MYZTJ.settingActions).changeSettings([
                            ...settings.timeEntryStatus,
                            "onHold"
                        ], "timeEntryStatus");
                        else (0, $MYZTJ.settingActions).changeSettings(settings.timeEntryStatus.filter((s)=>s !== "onHold"), "timeEntryStatus");
                    },
                    label: "On Hold",
                    id: "onHold"
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    marginLeft: "2em"
                },
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8jD92.CheckboxWithLabel), {
                    checked: settings.timeEntryStatus.includes("archived"),
                    onCheckedChange: function(value) {
                        if (value) (0, $MYZTJ.settingActions).changeSettings([
                            ...settings.timeEntryStatus,
                            "archived"
                        ], "timeEntryStatus");
                        else (0, $MYZTJ.settingActions).changeSettings(settings.timeEntryStatus.filter((s)=>s !== "archived"), "timeEntryStatus");
                    },
                    label: "Archived",
                    id: "archived"
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("p", {
                className: "mt-[3em]",
                children: "Allow staff to flag time entries with the following:"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "mt-[1em] ml-[2em]",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8jD92.CheckboxWithLabel), {
                    checked: settings.timeEntryFlags.includes("variation"),
                    onCheckedChange: function(value) {
                        if (value) (0, $MYZTJ.settingActions).changeSettings([
                            ...settings.timeEntryFlags,
                            "variation"
                        ], "timeEntryFlags");
                        else (0, $MYZTJ.settingActions).changeSettings(settings.timeEntryFlags.filter((s)=>s !== "variation"), "timeEntryFlags");
                    },
                    label: "Variation",
                    id: "variation"
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    marginLeft: "2em"
                },
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8jD92.CheckboxWithLabel), {
                    checked: settings.timeEntryFlags.includes("billable"),
                    onCheckedChange: function(value) {
                        if (value) (0, $MYZTJ.settingActions).changeSettings([
                            ...settings.timeEntryFlags,
                            "billable"
                        ], "timeEntryFlags");
                        else (0, $MYZTJ.settingActions).changeSettings(settings.timeEntryFlags.filter((s)=>s !== "billable"), "timeEntryFlags");
                    },
                    label: "Billable",
                    id: "billable"
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    marginLeft: "2em"
                },
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8jD92.CheckboxWithLabel), {
                    checked: settings.timeEntryFlags.includes("overtime"),
                    onCheckedChange: function(value) {
                        if (value) (0, $MYZTJ.settingActions).changeSettings([
                            ...settings.timeEntryFlags,
                            "overtime"
                        ], "timeEntryFlags");
                        else (0, $MYZTJ.settingActions).changeSettings(settings.timeEntryFlags.filter((s)=>s !== "overtime"), "timeEntryFlags");
                    },
                    label: "Overtime",
                    id: "overtime"
                })
            }),
            (0, $8kZ1o.canViewRemote)() ? /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    marginLeft: "2em"
                },
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8jD92.CheckboxWithLabel), {
                    checked: settings.timeEntryFlags.includes("remote"),
                    onCheckedChange: function(value) {
                        if (value) (0, $MYZTJ.settingActions).changeSettings([
                            ...settings.timeEntryFlags,
                            "remote"
                        ], "timeEntryFlags");
                        else (0, $MYZTJ.settingActions).changeSettings(settings.timeEntryFlags.filter((s)=>s !== "remote"), "timeEntryFlags");
                    },
                    label: "Remote",
                    id: "remote"
                })
            }) : null,
            (0, $8kZ1o.canViewFlexi)() ? /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    marginLeft: "2em"
                },
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8jD92.CheckboxWithLabel), {
                    checked: settings.timeEntryFlags.includes("flexi"),
                    onCheckedChange: function(value) {
                        if (value) (0, $MYZTJ.settingActions).changeSettings([
                            ...settings.timeEntryFlags,
                            "flexi"
                        ], "timeEntryFlags");
                        else (0, $MYZTJ.settingActions).changeSettings(settings.timeEntryFlags.filter((s)=>s !== "flexi"), "timeEntryFlags");
                    },
                    label: "Flexi",
                    id: "flexi"
                })
            }) : null,
            /*#__PURE__*/ (0, $61Ea1.jsx)("p", {
                className: "mt-[3em]",
                children: "Allow staff to enter time against phases:"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "mt-[1em] ml-[2em]",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8jD92.CheckboxWithLabel), {
                    checked: settings.timeEntryAllocations.includes("noAllocations"),
                    onCheckedChange: function(value) {
                        if (value) (0, $MYZTJ.settingActions).changeSettings([
                            ...settings.timeEntryAllocations,
                            "noAllocations"
                        ], "timeEntryAllocations");
                        else (0, $MYZTJ.settingActions).changeSettings(settings.timeEntryAllocations.filter((s)=>s !== "noAllocations"), "timeEntryAllocations");
                    },
                    label: "Without budgets or allocations for that staff member.",
                    id: "noAllocations"
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "mt-[1em] ml-[2em]",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8jD92.CheckboxWithLabel), {
                    checked: settings.timeEntryAllocations.includes("budgets"),
                    onCheckedChange: function(value) {
                        if (value) (0, $MYZTJ.settingActions).changeSettings([
                            ...settings.timeEntryAllocations,
                            "budgets"
                        ], "timeEntryAllocations");
                        else (0, $MYZTJ.settingActions).changeSettings(settings.timeEntryAllocations.filter((s)=>s !== "budgets"), "timeEntryAllocations");
                    },
                    label: "With budgets for that staff member.",
                    id: "budgets"
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "mt-[1em] ml-[2em]",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8jD92.CheckboxWithLabel), {
                    checked: settings.timeEntryAllocations.includes("allocations"),
                    onCheckedChange: function(value) {
                        if (value) (0, $MYZTJ.settingActions).changeSettings([
                            ...settings.timeEntryAllocations,
                            "allocations"
                        ], "timeEntryAllocations");
                        else (0, $MYZTJ.settingActions).changeSettings(timeEntryAllocations.filter((s)=>s !== "allocations"), "timeEntryAllocations");
                    },
                    label: "With monthly allocations for that staff member.",
                    id: "allocations"
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("p", {
                className: "mt-[3em]",
                children: "Auto-populate timesheets for phases:"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "mt-[1em] ml-[2em]",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8jD92.CheckboxWithLabel), {
                    checked: settings.autoPopulate.includes("budgets"),
                    onCheckedChange: function(value) {
                        if (value) (0, $MYZTJ.settingActions).changeSettings([
                            "budgets",
                            ...autoPopulate
                        ], "autoPopulate");
                        else (0, $MYZTJ.settingActions).changeSettings(autoPopulate.filter((s)=>s !== "budgets"), "autoPopulate");
                    },
                    label: "With time budgeted for that staff member.",
                    id: "budgets-autoPopulate"
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "mt-[1em] ml-[2em]",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8jD92.CheckboxWithLabel), {
                    checked: settings.autoPopulate.includes("allocations"),
                    onCheckedChange: function(value) {
                        if (value) (0, $MYZTJ.settingActions).changeSettings([
                            "allocations",
                            ...autoPopulate
                        ], "autoPopulate");
                        else (0, $MYZTJ.settingActions).changeSettings(autoPopulate.filter((s)=>s !== "allocations"), "autoPopulate");
                    },
                    label: "With monthly allocations assigned to that staff member.",
                    id: "allocations-autoPopulate"
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "mt-[2em]",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8jD92.CheckboxWithLabel), {
                        checked: settings.updateHoursFromRevenue,
                        onCheckedChange: function(value) {
                            (0, $MYZTJ.settingActions).changeSettings(value, "updateHoursFromRevenue");
                        },
                        label: "Automatically adjust Staff Hours when editing Revenue in Forecasts",
                        id: "updateHoursFromRevenue"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8jD92.CheckboxWithLabel), {
                        checked: settings.updateRevenueFromHours,
                        onCheckedChange: function(value) {
                            (0, $MYZTJ.settingActions).changeSettings(value, "updateRevenueFromHours");
                        },
                        label: "Automatically adjust Revenue when editing Staff Hours in Forecasts",
                        id: "updateRevenueFromHours"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "mt-[4em]",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "flex items-center mb-[0.5em]",
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3Gs4l.SelectWithLabel), {
                            value: settings.autoUpdateRevenue.action,
                            onValueChange: (value)=>{
                                (0, $MYZTJ.settingActions).changeSettings({
                                    ...settings.autoUpdateRevenue,
                                    action: value
                                }, "autoUpdateRevenue");
                            },
                            options: [
                                {
                                    key: "ask",
                                    value: "ask",
                                    label: "Ask Me to"
                                },
                                {
                                    key: "automatic",
                                    value: "automatic",
                                    label: "Always"
                                },
                                {
                                    key: "never",
                                    value: "never",
                                    label: "Never"
                                }
                            ],
                            className: "flex-row-reverse gap-2",
                            defaultValue: "ask",
                            placeholder: "Select...",
                            label: "Automatically adjust the Revenue Forecast when saving Projects and Invoices."
                        })
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8jD92.CheckboxWithLabel), {
                        checked: settings.autoUpdateRevenue.adjustOnLoad,
                        onCheckedChange: function(value) {
                            (0, $MYZTJ.settingActions).changeSettings({
                                ...settings.autoUpdateRevenue,
                                adjustOnLoad: value
                            }, "autoUpdateRevenue");
                        },
                        label: "Automatically adjust Revenue when loading the Revenue Forecast",
                        id: "adjustOnLoad",
                        className: "my-3"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "flex items-center border-t border-[#eee] p-[2em]",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                className: "inline-block",
                                children: "Distribute"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "mx-[1em] w-[12em]",
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3Gs4l.SelectWithLabel), {
                                    value: settings.autoUpdateRevenue.budget,
                                    onValueChange: (value)=>{
                                        (0, $MYZTJ.settingActions).changeSettings({
                                            ...settings.autoUpdateRevenue,
                                            budget: value
                                        }, "autoUpdateRevenue");
                                    },
                                    options: [
                                        {
                                            key: "total",
                                            value: "total",
                                            label: "Total Budget"
                                        },
                                        {
                                            key: "remaining",
                                            value: "remaining",
                                            label: "Remaining Budget"
                                        }
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                className: "inline-block",
                                children: "between"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "mx-[1em] w-[9em]",
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3Gs4l.SelectWithLabel), {
                                    value: settings.autoUpdateRevenue.start,
                                    onValueChange: (value)=>{
                                        (0, $MYZTJ.settingActions).changeSettings({
                                            ...settings.autoUpdateRevenue,
                                            start: value
                                        }, "autoUpdateRevenue");
                                    },
                                    options: [
                                        {
                                            key: "startDate",
                                            value: "startDate",
                                            label: "Start Date"
                                        },
                                        {
                                            key: "now",
                                            value: "now",
                                            label: "Current Date"
                                        },
                                        {
                                            key: "endDate",
                                            value: "endDate",
                                            label: "End Date"
                                        }
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                className: "inline-block",
                                children: "and"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "mx-[1em] w-[9em]",
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3Gs4l.SelectWithLabel), {
                                    value: settings.autoUpdateRevenue.end,
                                    onValueChange: (value)=>{
                                        (0, $MYZTJ.settingActions).changeSettings({
                                            ...settings.autoUpdateRevenue,
                                            end: value
                                        }, "autoUpdateRevenue");
                                    },
                                    options: [
                                        {
                                            key: "startDate",
                                            value: "startDate",
                                            label: "Start Date"
                                        },
                                        {
                                            key: "endDate",
                                            value: "endDate",
                                            label: "End Date"
                                        }
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "mt-[3em]",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3Gs4l.SelectWithLabel), {
                        value: settings.autoUpdateHours.action,
                        onValueChange: (value)=>{
                            (0, $MYZTJ.settingActions).changeSettings({
                                ...settings.autoUpdateHours,
                                action: value
                            }, "autoUpdateHours");
                        },
                        options: [
                            {
                                key: "ask",
                                value: "ask",
                                label: "Ask Me to"
                            },
                            {
                                key: "automatic",
                                value: "automatic",
                                label: "Always"
                            },
                            {
                                key: "never",
                                value: "never",
                                label: "Never"
                            }
                        ],
                        className: "flex-row-reverse gap-2",
                        placeholder: "Select...",
                        label: "Automatically adjust the Resource Schedule when saving Projects and Time entries "
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8jD92.CheckboxWithLabel), {
                        checked: settings.autoUpdateHours.adjustOnLoad,
                        onCheckedChange: function(value) {
                            (0, $MYZTJ.settingActions).changeSettings({
                                ...settings.autoUpdateHours,
                                adjustOnLoad: value
                            }, "autoUpdateHours");
                        },
                        className: "my-3",
                        label: "Automatically adjust Staff Hours when loading the Resource Schedule",
                        id: "adjustOnLoad"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "flex items-center border-t border-[#eee] p-[2em]",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                className: "inline-block",
                                children: "Distribute"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "mx-[1em] w-[12em]",
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3Gs4l.SelectWithLabel), {
                                    value: settings.autoUpdateHours.budget,
                                    onValueChange: (value)=>{
                                        (0, $MYZTJ.settingActions).changeSettings({
                                            ...settings.autoUpdateHours,
                                            budget: value
                                        }, "autoUpdateHours");
                                    },
                                    options: [
                                        {
                                            key: "total",
                                            value: "total",
                                            label: "Total Budget"
                                        },
                                        {
                                            key: "remaining",
                                            value: "remaining",
                                            label: "Remaining Budget"
                                        }
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                className: "inline-block",
                                children: "between"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "mx-[1em] w-[9em]",
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3Gs4l.SelectWithLabel), {
                                    value: settings.autoUpdateHours.start,
                                    onValueChange: (value)=>{
                                        (0, $MYZTJ.settingActions).changeSettings({
                                            ...settings.autoUpdateHours,
                                            start: value
                                        }, "autoUpdateHours");
                                    },
                                    options: [
                                        {
                                            key: "startDate",
                                            value: "startDate",
                                            label: "Start Date"
                                        },
                                        {
                                            key: "now",
                                            value: "now",
                                            label: "Current Date"
                                        },
                                        {
                                            key: "endDate",
                                            value: "endDate",
                                            label: "End Date"
                                        }
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                className: "inline-block",
                                children: "and"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "mx-[1em] w-[9em]",
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3Gs4l.SelectWithLabel), {
                                    value: settings.autoUpdateHours.end,
                                    onValueChange: (value)=>{
                                        (0, $MYZTJ.settingActions).changeSettings({
                                            ...settings.autoUpdateHours,
                                            end: value
                                        }, "autoUpdateHours");
                                    },
                                    options: [
                                        {
                                            key: "startDate",
                                            value: "startDate",
                                            label: "Start Date"
                                        },
                                        {
                                            key: "endDate",
                                            value: "endDate",
                                            label: "End Date"
                                        }
                                    ],
                                    defaultValue: "startDate"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            padding: "4em 0em 1em 0em"
                        },
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                className: "inline-block",
                                children: "Use Invoice Date Type in Reports:"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "mx-[1em] w-[12em]",
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3Gs4l.SelectWithLabel), {
                                    value: settings.reportInvoiceDateType,
                                    onValueChange: (value)=>{
                                        (0, $MYZTJ.settingActions).changeSettings(value, "reportInvoiceDateType");
                                    },
                                    options: [
                                        {
                                            key: "endDate",
                                            value: "endDate",
                                            label: "Work Completion"
                                        },
                                        {
                                            key: "issueDate",
                                            value: "issueDate",
                                            label: "Issue Date"
                                        },
                                        {
                                            key: "dueDate",
                                            value: "dueDate",
                                            label: "Due Date"
                                        }
                                    ],
                                    defaultValue: "endDate"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            maxWidth: "60em",
                            padding: "0em 0em 2em"
                        },
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("p", {
                                style: {
                                    marginTop: "2em"
                                },
                                children: "When saving Invoices:"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                style: {
                                    marginTop: "1em",
                                    marginLeft: "2em"
                                },
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8jD92.CheckboxWithLabel), {
                                    checked: settings.savingInvoices.includes("lockTime"),
                                    onCheckedChange: function(value) {
                                        if (value) (0, $MYZTJ.settingActions).changeSettings([
                                            ...settings.savingInvoices,
                                            "lockTime"
                                        ], "savingInvoices");
                                        else (0, $MYZTJ.settingActions).changeSettings(settings.savingInvoices.filter((s)=>s !== "lockTime"), "savingInvoices");
                                    },
                                    label: "Lock time entries.",
                                    id: "lockTime"
                                })
                            })
                        ]
                    }),
                    (0, $8kZ1o.usingNewLogin)() ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            maxWidth: "60em",
                            padding: "0em 0em 2em"
                        },
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("p", {
                                children: "Automatically create accounts for users with the following email domains:"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                style: {
                                    padding: "1em 2em"
                                },
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $01BMe.default), {})
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
}

});
parcelRegister("8jD92", function(module, exports) {

$parcel$export(module.exports, "Checkbox", function () { return $3d87cf998896938b$export$48513f6b9f8ce62d; });
$parcel$export(module.exports, "CheckboxWithLabel", function () { return $3d87cf998896938b$export$6cb1578e30bfa58d; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $iaXNY = parcelRequire("iaXNY");

var $1kvoC = parcelRequire("1kvoC");
var $qkvOH = parcelRequire("qkvOH");

var $Yha9m = parcelRequire("Yha9m");

var $5XMpG = parcelRequire("5XMpG");
const $3d87cf998896938b$export$48513f6b9f8ce62d = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)($iaXNY.Root, {
        ref: ref,
        className: (0, $Yha9m.cn)("peer h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground", className),
        ...props,
        children: /*#__PURE__*/ (0, $61Ea1.jsx)($iaXNY.Indicator, {
            className: (0, $Yha9m.cn)("flex items-center justify-center text-current"),
            children: props.checked === "indeterminate" ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $qkvOH.default), {
                className: "h-4 w-4"
            }) : /*#__PURE__*/ (0, $61Ea1.jsx)((0, $1kvoC.default), {
                className: "h-4 w-4"
            })
        })
    });
});
$3d87cf998896938b$export$48513f6b9f8ce62d.displayName = $iaXNY.Root.displayName;
const $3d87cf998896938b$export$6cb1578e30bfa58d = ({ checked: checked, onCheckedChange: onCheckedChange, label: label, id: id, className: className, disabled: disabled })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: (0, $Yha9m.cn)("flex items-center space-x-2", className),
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)($3d87cf998896938b$export$48513f6b9f8ce62d, {
                checked: checked,
                onCheckedChange: onCheckedChange,
                id: id,
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5XMpG.Label), {
                htmlFor: id,
                className: "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
                children: label
            })
        ]
    });
};

});
parcelRegister("iaXNY", function(module, exports) {

$parcel$export(module.exports, "Root", function () { return $bed5b4beb58e8a15$export$be92b6f5f03c0fe9; });
$parcel$export(module.exports, "Indicator", function () { return $bed5b4beb58e8a15$export$adb584737d712b70; });

var $jbmdS = parcelRequire("jbmdS");

var $9sunj = parcelRequire("9sunj");

var $f4RZG = parcelRequire("f4RZG");

var $hFcKE = parcelRequire("hFcKE");

var $1sq0Q = parcelRequire("1sq0Q");

var $f4s2q = parcelRequire("f4s2q");

var $am0tV = parcelRequire("am0tV");

var $joHB8 = parcelRequire("joHB8");

var $cihg9 = parcelRequire("cihg9");

var $4TLFw = parcelRequire("4TLFw");
"use client";
var $bed5b4beb58e8a15$var$CHECKBOX_NAME = "Checkbox";
var [$bed5b4beb58e8a15$var$createCheckboxContext, $bed5b4beb58e8a15$export$b566c4ff5488ea01] = (0, $f4RZG.createContextScope)($bed5b4beb58e8a15$var$CHECKBOX_NAME);
var [$bed5b4beb58e8a15$var$CheckboxProvider, $bed5b4beb58e8a15$var$useCheckboxContext] = $bed5b4beb58e8a15$var$createCheckboxContext($bed5b4beb58e8a15$var$CHECKBOX_NAME);
var $bed5b4beb58e8a15$export$48513f6b9f8ce62d = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeCheckbox: __scopeCheckbox, name: name, checked: checkedProp, defaultChecked: defaultChecked, required: required, disabled: disabled, value: value = "on", onCheckedChange: onCheckedChange, form: form, ...checkboxProps } = props;
    const [button, setButton] = $jbmdS.useState(null);
    const composedRefs = (0, $9sunj.useComposedRefs)(forwardedRef, (node)=>setButton(node));
    const hasConsumerStoppedPropagationRef = $jbmdS.useRef(false);
    const isFormControl = button ? form || !!button.closest("form") : true;
    const [checked = false, setChecked] = (0, $1sq0Q.useControllableState)({
        prop: checkedProp,
        defaultProp: defaultChecked,
        onChange: onCheckedChange
    });
    const initialCheckedStateRef = $jbmdS.useRef(checked);
    $jbmdS.useEffect(()=>{
        const form2 = button?.form;
        if (form2) {
            const reset = ()=>setChecked(initialCheckedStateRef.current);
            form2.addEventListener("reset", reset);
            return ()=>form2.removeEventListener("reset", reset);
        }
    }, [
        button,
        setChecked
    ]);
    return /* @__PURE__ */ (0, $4TLFw.jsxs)($bed5b4beb58e8a15$var$CheckboxProvider, {
        scope: __scopeCheckbox,
        state: checked,
        disabled: disabled,
        children: [
            /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).button, {
                type: "button",
                role: "checkbox",
                "aria-checked": $bed5b4beb58e8a15$var$isIndeterminate(checked) ? "mixed" : checked,
                "aria-required": required,
                "data-state": $bed5b4beb58e8a15$var$getState(checked),
                "data-disabled": disabled ? "" : void 0,
                disabled: disabled,
                value: value,
                ...checkboxProps,
                ref: composedRefs,
                onKeyDown: (0, $hFcKE.composeEventHandlers)(props.onKeyDown, (event)=>{
                    if (event.key === "Enter") event.preventDefault();
                }),
                onClick: (0, $hFcKE.composeEventHandlers)(props.onClick, (event)=>{
                    setChecked((prevChecked)=>$bed5b4beb58e8a15$var$isIndeterminate(prevChecked) ? true : !prevChecked);
                    if (isFormControl) {
                        hasConsumerStoppedPropagationRef.current = event.isPropagationStopped();
                        if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
                    }
                })
            }),
            isFormControl && /* @__PURE__ */ (0, $4TLFw.jsx)($bed5b4beb58e8a15$var$BubbleInput, {
                control: button,
                bubbles: !hasConsumerStoppedPropagationRef.current,
                name: name,
                value: value,
                checked: checked,
                required: required,
                disabled: disabled,
                form: form,
                style: {
                    transform: "translateX(-100%)"
                },
                defaultChecked: $bed5b4beb58e8a15$var$isIndeterminate(defaultChecked) ? false : defaultChecked
            })
        ]
    });
});
$bed5b4beb58e8a15$export$48513f6b9f8ce62d.displayName = $bed5b4beb58e8a15$var$CHECKBOX_NAME;
var $bed5b4beb58e8a15$var$INDICATOR_NAME = "CheckboxIndicator";
var $bed5b4beb58e8a15$export$59aad738f51d1c05 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeCheckbox: __scopeCheckbox, forceMount: forceMount, ...indicatorProps } = props;
    const context = $bed5b4beb58e8a15$var$useCheckboxContext($bed5b4beb58e8a15$var$INDICATOR_NAME, __scopeCheckbox);
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $joHB8.Presence), {
        present: forceMount || $bed5b4beb58e8a15$var$isIndeterminate(context.state) || context.state === true,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).span, {
            "data-state": $bed5b4beb58e8a15$var$getState(context.state),
            "data-disabled": context.disabled ? "" : void 0,
            ...indicatorProps,
            ref: forwardedRef,
            style: {
                pointerEvents: "none",
                ...props.style
            }
        })
    });
});
$bed5b4beb58e8a15$export$59aad738f51d1c05.displayName = $bed5b4beb58e8a15$var$INDICATOR_NAME;
var $bed5b4beb58e8a15$var$BubbleInput = (props)=>{
    const { control: control, checked: checked, bubbles: bubbles = true, defaultChecked: defaultChecked, ...inputProps } = props;
    const ref = $jbmdS.useRef(null);
    const prevChecked = (0, $f4s2q.usePrevious)(checked);
    const controlSize = (0, $am0tV.useSize)(control);
    $jbmdS.useEffect(()=>{
        const input = ref.current;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
        const setChecked = descriptor.set;
        if (prevChecked !== checked && setChecked) {
            const event = new Event("click", {
                bubbles: bubbles
            });
            input.indeterminate = $bed5b4beb58e8a15$var$isIndeterminate(checked);
            setChecked.call(input, $bed5b4beb58e8a15$var$isIndeterminate(checked) ? false : checked);
            input.dispatchEvent(event);
        }
    }, [
        prevChecked,
        checked,
        bubbles
    ]);
    const defaultCheckedRef = $jbmdS.useRef($bed5b4beb58e8a15$var$isIndeterminate(checked) ? false : checked);
    return /* @__PURE__ */ (0, $4TLFw.jsx)("input", {
        type: "checkbox",
        "aria-hidden": true,
        defaultChecked: defaultChecked ?? defaultCheckedRef.current,
        ...inputProps,
        tabIndex: -1,
        ref: ref,
        style: {
            ...props.style,
            ...controlSize,
            position: "absolute",
            pointerEvents: "none",
            opacity: 0,
            margin: 0
        }
    });
};
function $bed5b4beb58e8a15$var$isIndeterminate(checked) {
    return checked === "indeterminate";
}
function $bed5b4beb58e8a15$var$getState(checked) {
    return $bed5b4beb58e8a15$var$isIndeterminate(checked) ? "indeterminate" : checked ? "checked" : "unchecked";
}
var $bed5b4beb58e8a15$export$be92b6f5f03c0fe9 = $bed5b4beb58e8a15$export$48513f6b9f8ce62d;
var $bed5b4beb58e8a15$export$adb584737d712b70 = $bed5b4beb58e8a15$export$59aad738f51d1c05;

});

parcelRegister("qkvOH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04f2571cf4bb41d8$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $04f2571cf4bb41d8$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("Minus", [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ]
]);

});


parcelRegister("MYZTJ", function(module, exports) {

$parcel$export(module.exports, "settingsStore", function () { return $a268662e6de10d6e$export$e32e6b6089ace470; });
$parcel$export(module.exports, "settingActions", function () { return $a268662e6de10d6e$export$c160000d10ba2cf; });
$parcel$export(module.exports, "useSetting", function () { return $a268662e6de10d6e$export$12b0e20ae7d96a25; });

var $8qPhl = parcelRequire("8qPhl");

var $3h7sC = parcelRequire("3h7sC");

var $277OF = parcelRequire("277OF");

var $lJ1OS = parcelRequire("lJ1OS");

var $1BTI2 = parcelRequire("1BTI2");
const $a268662e6de10d6e$export$3e10d5d315a7be6 = (0, $8qPhl.z).object({
    action: (0, $8qPhl.z).string(),
    adjustOnLoad: (0, $8qPhl.z).boolean(),
    budget: (0, $8qPhl.z).string(),
    start: (0, $8qPhl.z).string(),
    end: (0, $8qPhl.z).string()
});
const $a268662e6de10d6e$export$a3245a650612c6b = (0, $8qPhl.z).object({
    sortPhasesBy: (0, $8qPhl.z).string(),
    allowNoPhase: (0, $8qPhl.z).boolean(),
    useTasks: (0, $8qPhl.z).boolean(),
    allowAfterPhaseEnd: (0, $8qPhl.z).boolean(),
    timeEntryAllocations: (0, $8qPhl.z).array((0, $8qPhl.z).string()),
    timeEntryStatus: (0, $8qPhl.z).array((0, $8qPhl.z).string()),
    timeEntryFlags: (0, $8qPhl.z).array((0, $8qPhl.z).string()),
    autoPopulate: (0, $8qPhl.z).array((0, $8qPhl.z).string()),
    updateHoursFromRevenue: (0, $8qPhl.z).boolean(),
    updateRevenueFromHours: (0, $8qPhl.z).boolean(),
    autoUpdateRevenue: $a268662e6de10d6e$export$3e10d5d315a7be6,
    autoUpdateHours: $a268662e6de10d6e$export$3e10d5d315a7be6,
    reportInvoiceDateType: (0, $8qPhl.z).string(),
    savingInvoices: (0, $8qPhl.z).array((0, $8qPhl.z).string())
});
const $a268662e6de10d6e$var$initialContext = {
    settings: {
        ...(0, $1BTI2.settingDefaults)
    }
};
const $a268662e6de10d6e$export$e32e6b6089ace470 = (0, $277OF.createQueryStore)({
    context: $a268662e6de10d6e$var$initialContext,
    on: {
        saveSettingData: {
            settings: (_, event)=>event.data
        },
        changeSettings: {
            settings: (context, event)=>({
                    ...context.settings,
                    [event.data.key]: event.data.value
                })
        }
    }
}, {
    queryKey: [
        "settings"
    ],
    queryFn: async ()=>{
        const result = await (0, $3h7sC.trpc).setting.getSettings.query();
        return {
            settings: result.settings
        };
    },
    mutationFn: (data)=>(0, $3h7sC.trpc).setting.saveSettings.mutate({
            settings: data.settings
        }),
    staleTime: 300000,
    // 5 minutes
    cacheTime: 1800000 // 30 minutes
}, {
    saveId: "settings-save",
    requireConfirmation: true,
    confirmationMessage: "Save changes to settings?",
    loadingMessage: "Saving settings...",
    successMessage: "Settings saved successfully",
    errorMessage: "Failed to save settings"
});
const { useStoreData: $a268662e6de10d6e$export$544efe5ac05fc17, useIsLoading: $a268662e6de10d6e$export$4dface15d86304a4, useCanUndo: $a268662e6de10d6e$export$653033ad74e314c9, useCanRedo: $a268662e6de10d6e$export$e7ea8bfdbe9392b0, useUpdatedAt: $a268662e6de10d6e$export$4d53551414e812c, undo: $a268662e6de10d6e$export$21f930c44940fd98, redo: $a268662e6de10d6e$export$1688e416fee0a49e, save: $a268662e6de10d6e$export$a1544dad697b423d, revertToLastSave: $a268662e6de10d6e$export$7e511c2293ae6e56, getState: $a268662e6de10d6e$export$50fdfeece43146fd, getHistory: $a268662e6de10d6e$export$f9582a3c130d9538, getCurrentHistoryIndex: $a268662e6de10d6e$export$3d0fb93f79a1d871, getLastSavedIndex: $a268662e6de10d6e$export$3ad3501ee738138, getSavedAt: $a268662e6de10d6e$export$f4c906ca2124fef8, getUpdatedAt: $a268662e6de10d6e$export$ff3aa069bd8fb4e4 } = $a268662e6de10d6e$export$e32e6b6089ace470;
const $a268662e6de10d6e$export$c160000d10ba2cf = {
    saveSettingData: (data)=>$a268662e6de10d6e$export$e32e6b6089ace470.store.send({
            type: "saveSettingData",
            data: data
        }),
    changeSettings: (value, key)=>{
        const data = {
            value: value,
            key: key
        };
        $a268662e6de10d6e$export$e32e6b6089ace470.store.send({
            type: "changeSettings",
            data: data
        });
    }
};
const $a268662e6de10d6e$export$12b0e20ae7d96a25 = ()=>(0, $lJ1OS.useSelector)($a268662e6de10d6e$export$e32e6b6089ace470.store, (state)=>state.context.settings);
const $a268662e6de10d6e$export$4a647155031ece = ()=>$a268662e6de10d6e$export$e32e6b6089ace470.getState().context.settings;

});
parcelRegister("8qPhl", function(module, exports) {

$parcel$export(module.exports, "z", function () { return $28a33cb307c00cce$export$2e2bcd8739ae039; });
var $28a33cb307c00cce$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($28a33cb307c00cce$export$7debb50ef11d5e0b || ($28a33cb307c00cce$export$7debb50ef11d5e0b = {}));
var $28a33cb307c00cce$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($28a33cb307c00cce$export$4aa2142c225fd5c7 || ($28a33cb307c00cce$export$4aa2142c225fd5c7 = {}));
const $28a33cb307c00cce$export$5716da67bfaa244d = $28a33cb307c00cce$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $28a33cb307c00cce$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $28a33cb307c00cce$export$5716da67bfaa244d.undefined;
        case "string":
            return $28a33cb307c00cce$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $28a33cb307c00cce$export$5716da67bfaa244d.nan : $28a33cb307c00cce$export$5716da67bfaa244d.number;
        case "boolean":
            return $28a33cb307c00cce$export$5716da67bfaa244d.boolean;
        case "function":
            return $28a33cb307c00cce$export$5716da67bfaa244d.function;
        case "bigint":
            return $28a33cb307c00cce$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $28a33cb307c00cce$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $28a33cb307c00cce$export$5716da67bfaa244d.array;
            if (data === null) return $28a33cb307c00cce$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $28a33cb307c00cce$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $28a33cb307c00cce$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $28a33cb307c00cce$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $28a33cb307c00cce$export$5716da67bfaa244d.date;
            return $28a33cb307c00cce$export$5716da67bfaa244d.object;
        default:
            return $28a33cb307c00cce$export$5716da67bfaa244d.unknown;
    }
};
const $28a33cb307c00cce$export$5ba560653e4a1035 = $28a33cb307c00cce$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $28a33cb307c00cce$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $28a33cb307c00cce$export$f98dac4b251ab333 extends Error {
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof $28a33cb307c00cce$export$f98dac4b251ab333)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $28a33cb307c00cce$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
$28a33cb307c00cce$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $28a33cb307c00cce$export$f98dac4b251ab333(issues);
    return error;
};
const $28a33cb307c00cce$export$341b0b6e0a6f5099 = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $28a33cb307c00cce$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $28a33cb307c00cce$export$5716da67bfaa244d.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $28a33cb307c00cce$export$5ba560653e4a1035.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $28a33cb307c00cce$export$7debb50ef11d5e0b.jsonStringifyReplacer)}`;
            break;
        case $28a33cb307c00cce$export$5ba560653e4a1035.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$28a33cb307c00cce$export$7debb50ef11d5e0b.joinValues(issue.keys, ", ")}`;
            break;
        case $28a33cb307c00cce$export$5ba560653e4a1035.invalid_union:
            message = `Invalid input`;
            break;
        case $28a33cb307c00cce$export$5ba560653e4a1035.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$28a33cb307c00cce$export$7debb50ef11d5e0b.joinValues(issue.options)}`;
            break;
        case $28a33cb307c00cce$export$5ba560653e4a1035.invalid_enum_value:
            message = `Invalid enum value. Expected ${$28a33cb307c00cce$export$7debb50ef11d5e0b.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $28a33cb307c00cce$export$5ba560653e4a1035.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $28a33cb307c00cce$export$5ba560653e4a1035.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $28a33cb307c00cce$export$5ba560653e4a1035.invalid_date:
            message = `Invalid date`;
            break;
        case $28a33cb307c00cce$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $28a33cb307c00cce$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $28a33cb307c00cce$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $28a33cb307c00cce$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $28a33cb307c00cce$export$5ba560653e4a1035.custom:
            message = `Invalid input`;
            break;
        case $28a33cb307c00cce$export$5ba560653e4a1035.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $28a33cb307c00cce$export$5ba560653e4a1035.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $28a33cb307c00cce$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $28a33cb307c00cce$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
let $28a33cb307c00cce$var$overrideErrorMap = $28a33cb307c00cce$export$341b0b6e0a6f5099;
function $28a33cb307c00cce$export$1097a8289cfd22d7(map) {
    $28a33cb307c00cce$var$overrideErrorMap = map;
}
function $28a33cb307c00cce$export$32f27c719778d4c4() {
    return $28a33cb307c00cce$var$overrideErrorMap;
}
const $28a33cb307c00cce$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    if (issueData.message !== undefined) return {
        ...issueData,
        path: fullPath,
        message: issueData.message
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: errorMessage
    };
};
const $28a33cb307c00cce$export$1526d2e05f74572 = [];
function $28a33cb307c00cce$export$db7caee60e5d514d(ctx, issueData) {
    const overrideMap = $28a33cb307c00cce$export$32f27c719778d4c4();
    const issue = $28a33cb307c00cce$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === $28a33cb307c00cce$export$341b0b6e0a6f5099 ? undefined : $28a33cb307c00cce$export$341b0b6e0a6f5099
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $28a33cb307c00cce$export$5b20a5c3d05c1f6f {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $28a33cb307c00cce$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key: key,
                value: value
            });
        }
        return $28a33cb307c00cce$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $28a33cb307c00cce$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $28a33cb307c00cce$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const $28a33cb307c00cce$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $28a33cb307c00cce$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $28a33cb307c00cce$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $28a33cb307c00cce$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $28a33cb307c00cce$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $28a33cb307c00cce$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $28a33cb307c00cce$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $28a33cb307c00cce$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $28a33cb307c00cce$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
typeof SuppressedError === "function" && SuppressedError;
var $28a33cb307c00cce$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($28a33cb307c00cce$var$errorUtil || ($28a33cb307c00cce$var$errorUtil = {}));
var $28a33cb307c00cce$var$_ZodEnum_cache, $28a33cb307c00cce$var$_ZodNativeEnum_cache;
class $28a33cb307c00cce$var$ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const $28a33cb307c00cce$var$handleResult = (ctx, result)=>{
    if ($28a33cb307c00cce$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $28a33cb307c00cce$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $28a33cb307c00cce$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        var _a, _b;
        const { message: message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message !== null && message !== void 0 ? message : ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: (_a = message !== null && message !== void 0 ? message : required_error) !== null && _a !== void 0 ? _a : ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: (_b = message !== null && message !== void 0 ? message : invalid_type_error) !== null && _b !== void 0 ? _b : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $28a33cb307c00cce$export$19342e026b58ebb7 {
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return $28a33cb307c00cce$export$3e9057828ebd5c7a(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: $28a33cb307c00cce$export$3e9057828ebd5c7a(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $28a33cb307c00cce$export$5b20a5c3d05c1f6f(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: $28a33cb307c00cce$export$3e9057828ebd5c7a(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ($28a33cb307c00cce$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $28a33cb307c00cce$export$3e9057828ebd5c7a(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $28a33cb307c00cce$var$handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $28a33cb307c00cce$export$3e9057828ebd5c7a(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ($28a33cb307c00cce$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $28a33cb307c00cce$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: $28a33cb307c00cce$export$5ba560653e4a1035.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $28a33cb307c00cce$export$a60af00cc0ce2582({
            schema: this,
            typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return $28a33cb307c00cce$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $28a33cb307c00cce$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $28a33cb307c00cce$export$7acfc3e64785411.create(this, this._def);
    }
    promise() {
        return $28a33cb307c00cce$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $28a33cb307c00cce$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $28a33cb307c00cce$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $28a33cb307c00cce$export$a60af00cc0ce2582({
            ...$28a33cb307c00cce$var$processCreateParams(this._def),
            schema: this,
            typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $28a33cb307c00cce$export$bb19b37874861e7e({
            ...$28a33cb307c00cce$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $28a33cb307c00cce$export$66b0c798a395271f({
            typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$28a33cb307c00cce$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $28a33cb307c00cce$export$75a44ec6249ac76b({
            ...$28a33cb307c00cce$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $28a33cb307c00cce$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $28a33cb307c00cce$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const $28a33cb307c00cce$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $28a33cb307c00cce$var$cuid2Regex = /^[0-9a-z]+$/;
const $28a33cb307c00cce$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $28a33cb307c00cce$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const $28a33cb307c00cce$var$nanoidRegex = /^[a-z0-9_-]{21}$/i;
const $28a33cb307c00cce$var$durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $28a33cb307c00cce$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $28a33cb307c00cce$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $28a33cb307c00cce$var$emojiRegex;
// faster, simpler, safer
const $28a33cb307c00cce$var$ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const $28a33cb307c00cce$var$ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const $28a33cb307c00cce$var$base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const $28a33cb307c00cce$var$dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const $28a33cb307c00cce$var$dateRegex = new RegExp(`^${$28a33cb307c00cce$var$dateRegexSource}$`);
function $28a33cb307c00cce$var$timeRegexSource(args) {
    // let regex = `\\d{2}:\\d{2}:\\d{2}`;
    let regex = `([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d`;
    if (args.precision) regex = `${regex}\\.\\d{${args.precision}}`;
    else if (args.precision == null) regex = `${regex}(\\.\\d+)?`;
    return regex;
}
function $28a33cb307c00cce$var$timeRegex(args) {
    return new RegExp(`^${$28a33cb307c00cce$var$timeRegexSource(args)}$`);
}
// Adapted from https://stackoverflow.com/a/3143231
function $28a33cb307c00cce$export$a4b563879add27a(args) {
    let regex = `${$28a33cb307c00cce$var$dateRegexSource}T${$28a33cb307c00cce$var$timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function $28a33cb307c00cce$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $28a33cb307c00cce$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $28a33cb307c00cce$var$ipv6Regex.test(ip)) return true;
    return false;
}
class $28a33cb307c00cce$export$1230eb29b8d3b502 extends $28a33cb307c00cce$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $28a33cb307c00cce$export$5716da67bfaa244d.string) {
            const ctx = this._getOrReturnCtx(input);
            $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_type,
                expected: $28a33cb307c00cce$export$5716da67bfaa244d.string,
                received: ctx.parsedType
            });
            return $28a33cb307c00cce$export$9a105a556e65c2c0;
        }
        const status = new $28a33cb307c00cce$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                        code: $28a33cb307c00cce$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                        code: $28a33cb307c00cce$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                        code: $28a33cb307c00cce$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                        code: $28a33cb307c00cce$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$28a33cb307c00cce$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                        validation: "email",
                        code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$28a33cb307c00cce$var$emojiRegex) $28a33cb307c00cce$var$emojiRegex = new RegExp($28a33cb307c00cce$var$_emojiRegex, "u");
                if (!$28a33cb307c00cce$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                        validation: "emoji",
                        code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$28a33cb307c00cce$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                        validation: "uuid",
                        code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!$28a33cb307c00cce$var$nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                        validation: "nanoid",
                        code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$28a33cb307c00cce$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                        validation: "cuid",
                        code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$28a33cb307c00cce$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                        validation: "cuid2",
                        code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$28a33cb307c00cce$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                        validation: "ulid",
                        code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                    validation: "url",
                    code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                        validation: "regex",
                        code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                        code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                        code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                        code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $28a33cb307c00cce$export$a4b563879add27a(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                        code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = $28a33cb307c00cce$var$dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                        code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = $28a33cb307c00cce$var$timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                        code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!$28a33cb307c00cce$var$durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                        validation: "duration",
                        code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$28a33cb307c00cce$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                        validation: "ip",
                        code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!$28a33cb307c00cce$var$base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                        validation: "base64",
                        code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $28a33cb307c00cce$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_string,
            ...$28a33cb307c00cce$var$errorUtil.errToObj(message)
        });
    }
    _addCheck(check) {
        return new $28a33cb307c00cce$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...$28a33cb307c00cce$var$errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...$28a33cb307c00cce$var$errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...$28a33cb307c00cce$var$errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...$28a33cb307c00cce$var$errorUtil.errToObj(message)
        });
    }
    nanoid(message) {
        return this._addCheck({
            kind: "nanoid",
            ...$28a33cb307c00cce$var$errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...$28a33cb307c00cce$var$errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...$28a33cb307c00cce$var$errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...$28a33cb307c00cce$var$errorUtil.errToObj(message)
        });
    }
    base64(message) {
        return this._addCheck({
            kind: "base64",
            ...$28a33cb307c00cce$var$errorUtil.errToObj(message)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...$28a33cb307c00cce$var$errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        var _a, _b;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            local: (_b = options === null || options === void 0 ? void 0 : options.local) !== null && _b !== void 0 ? _b : false,
            ...$28a33cb307c00cce$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message: message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck({
            kind: "time",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            ...$28a33cb307c00cce$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    duration(message) {
        return this._addCheck({
            kind: "duration",
            ...$28a33cb307c00cce$var$errorUtil.errToObj(message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...$28a33cb307c00cce$var$errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...$28a33cb307c00cce$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...$28a33cb307c00cce$var$errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...$28a33cb307c00cce$var$errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...$28a33cb307c00cce$var$errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...$28a33cb307c00cce$var$errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...$28a33cb307c00cce$var$errorUtil.errToObj(message)
        });
    }
    /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */ nonempty(message) {
        return this.min(1, $28a33cb307c00cce$var$errorUtil.errToObj(message));
    }
    trim() {
        return new $28a33cb307c00cce$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $28a33cb307c00cce$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $28a33cb307c00cce$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$28a33cb307c00cce$export$1230eb29b8d3b502.create = (params)=>{
    var _a;
    return new $28a33cb307c00cce$export$1230eb29b8d3b502({
        checks: [],
        typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$28a33cb307c00cce$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $28a33cb307c00cce$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $28a33cb307c00cce$export$5b070a55c0c43e09 extends $28a33cb307c00cce$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $28a33cb307c00cce$export$5716da67bfaa244d.number) {
            const ctx = this._getOrReturnCtx(input);
            $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_type,
                expected: $28a33cb307c00cce$export$5716da67bfaa244d.number,
                received: ctx.parsedType
            });
            return $28a33cb307c00cce$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $28a33cb307c00cce$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$28a33cb307c00cce$export$7debb50ef11d5e0b.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                        code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                        code: $28a33cb307c00cce$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                        code: $28a33cb307c00cce$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($28a33cb307c00cce$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                        code: $28a33cb307c00cce$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                        code: $28a33cb307c00cce$export$5ba560653e4a1035.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $28a33cb307c00cce$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $28a33cb307c00cce$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $28a33cb307c00cce$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $28a33cb307c00cce$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $28a33cb307c00cce$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $28a33cb307c00cce$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $28a33cb307c00cce$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $28a33cb307c00cce$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $28a33cb307c00cce$var$errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $28a33cb307c00cce$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $28a33cb307c00cce$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $28a33cb307c00cce$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $28a33cb307c00cce$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $28a33cb307c00cce$var$errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $28a33cb307c00cce$var$errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $28a33cb307c00cce$var$errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $28a33cb307c00cce$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $28a33cb307c00cce$export$7debb50ef11d5e0b.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
$28a33cb307c00cce$export$5b070a55c0c43e09.create = (params)=>{
    return new $28a33cb307c00cce$export$5b070a55c0c43e09({
        checks: [],
        typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$28a33cb307c00cce$var$processCreateParams(params)
    });
};
class $28a33cb307c00cce$export$67d741fd70ff98f4 extends $28a33cb307c00cce$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) input.data = BigInt(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $28a33cb307c00cce$export$5716da67bfaa244d.bigint) {
            const ctx = this._getOrReturnCtx(input);
            $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_type,
                expected: $28a33cb307c00cce$export$5716da67bfaa244d.bigint,
                received: ctx.parsedType
            });
            return $28a33cb307c00cce$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $28a33cb307c00cce$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                        code: $28a33cb307c00cce$export$5ba560653e4a1035.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                        code: $28a33cb307c00cce$export$5ba560653e4a1035.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                        code: $28a33cb307c00cce$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $28a33cb307c00cce$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $28a33cb307c00cce$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $28a33cb307c00cce$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $28a33cb307c00cce$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $28a33cb307c00cce$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $28a33cb307c00cce$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $28a33cb307c00cce$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $28a33cb307c00cce$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $28a33cb307c00cce$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $28a33cb307c00cce$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $28a33cb307c00cce$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $28a33cb307c00cce$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $28a33cb307c00cce$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$28a33cb307c00cce$export$67d741fd70ff98f4.create = (params)=>{
    var _a;
    return new $28a33cb307c00cce$export$67d741fd70ff98f4({
        checks: [],
        typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$28a33cb307c00cce$var$processCreateParams(params)
    });
};
class $28a33cb307c00cce$export$723d146f80596191 extends $28a33cb307c00cce$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $28a33cb307c00cce$export$5716da67bfaa244d.boolean) {
            const ctx = this._getOrReturnCtx(input);
            $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_type,
                expected: $28a33cb307c00cce$export$5716da67bfaa244d.boolean,
                received: ctx.parsedType
            });
            return $28a33cb307c00cce$export$9a105a556e65c2c0;
        }
        return $28a33cb307c00cce$export$c6813a8d51f77eaf(input.data);
    }
}
$28a33cb307c00cce$export$723d146f80596191.create = (params)=>{
    return new $28a33cb307c00cce$export$723d146f80596191({
        typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$28a33cb307c00cce$var$processCreateParams(params)
    });
};
class $28a33cb307c00cce$export$e974be33bdc55521 extends $28a33cb307c00cce$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $28a33cb307c00cce$export$5716da67bfaa244d.date) {
            const ctx = this._getOrReturnCtx(input);
            $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_type,
                expected: $28a33cb307c00cce$export$5716da67bfaa244d.date,
                received: ctx.parsedType
            });
            return $28a33cb307c00cce$export$9a105a556e65c2c0;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_date
            });
            return $28a33cb307c00cce$export$9a105a556e65c2c0;
        }
        const status = new $28a33cb307c00cce$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                        code: $28a33cb307c00cce$export$5ba560653e4a1035.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                        code: $28a33cb307c00cce$export$5ba560653e4a1035.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $28a33cb307c00cce$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $28a33cb307c00cce$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $28a33cb307c00cce$var$errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $28a33cb307c00cce$var$errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$28a33cb307c00cce$export$e974be33bdc55521.create = (params)=>{
    return new $28a33cb307c00cce$export$e974be33bdc55521({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodDate,
        ...$28a33cb307c00cce$var$processCreateParams(params)
    });
};
class $28a33cb307c00cce$export$bcc3b40f6b638044 extends $28a33cb307c00cce$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $28a33cb307c00cce$export$5716da67bfaa244d.symbol) {
            const ctx = this._getOrReturnCtx(input);
            $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_type,
                expected: $28a33cb307c00cce$export$5716da67bfaa244d.symbol,
                received: ctx.parsedType
            });
            return $28a33cb307c00cce$export$9a105a556e65c2c0;
        }
        return $28a33cb307c00cce$export$c6813a8d51f77eaf(input.data);
    }
}
$28a33cb307c00cce$export$bcc3b40f6b638044.create = (params)=>{
    return new $28a33cb307c00cce$export$bcc3b40f6b638044({
        typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodSymbol,
        ...$28a33cb307c00cce$var$processCreateParams(params)
    });
};
class $28a33cb307c00cce$export$4e780e961c30340d extends $28a33cb307c00cce$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $28a33cb307c00cce$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_type,
                expected: $28a33cb307c00cce$export$5716da67bfaa244d.undefined,
                received: ctx.parsedType
            });
            return $28a33cb307c00cce$export$9a105a556e65c2c0;
        }
        return $28a33cb307c00cce$export$c6813a8d51f77eaf(input.data);
    }
}
$28a33cb307c00cce$export$4e780e961c30340d.create = (params)=>{
    return new $28a33cb307c00cce$export$4e780e961c30340d({
        typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodUndefined,
        ...$28a33cb307c00cce$var$processCreateParams(params)
    });
};
class $28a33cb307c00cce$export$a96281f914484f2d extends $28a33cb307c00cce$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $28a33cb307c00cce$export$5716da67bfaa244d.null) {
            const ctx = this._getOrReturnCtx(input);
            $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_type,
                expected: $28a33cb307c00cce$export$5716da67bfaa244d.null,
                received: ctx.parsedType
            });
            return $28a33cb307c00cce$export$9a105a556e65c2c0;
        }
        return $28a33cb307c00cce$export$c6813a8d51f77eaf(input.data);
    }
}
$28a33cb307c00cce$export$a96281f914484f2d.create = (params)=>{
    return new $28a33cb307c00cce$export$a96281f914484f2d({
        typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodNull,
        ...$28a33cb307c00cce$var$processCreateParams(params)
    });
};
class $28a33cb307c00cce$export$b9d1edb536b4e4eb extends $28a33cb307c00cce$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return $28a33cb307c00cce$export$c6813a8d51f77eaf(input.data);
    }
}
$28a33cb307c00cce$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $28a33cb307c00cce$export$b9d1edb536b4e4eb({
        typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodAny,
        ...$28a33cb307c00cce$var$processCreateParams(params)
    });
};
class $28a33cb307c00cce$export$ef3b1bb1630977ae extends $28a33cb307c00cce$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return $28a33cb307c00cce$export$c6813a8d51f77eaf(input.data);
    }
}
$28a33cb307c00cce$export$ef3b1bb1630977ae.create = (params)=>{
    return new $28a33cb307c00cce$export$ef3b1bb1630977ae({
        typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodUnknown,
        ...$28a33cb307c00cce$var$processCreateParams(params)
    });
};
class $28a33cb307c00cce$export$1e576a20c3ce9fb5 extends $28a33cb307c00cce$export$19342e026b58ebb7 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
            code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_type,
            expected: $28a33cb307c00cce$export$5716da67bfaa244d.never,
            received: ctx.parsedType
        });
        return $28a33cb307c00cce$export$9a105a556e65c2c0;
    }
}
$28a33cb307c00cce$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $28a33cb307c00cce$export$1e576a20c3ce9fb5({
        typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodNever,
        ...$28a33cb307c00cce$var$processCreateParams(params)
    });
};
class $28a33cb307c00cce$export$7d39f5df85f21031 extends $28a33cb307c00cce$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $28a33cb307c00cce$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_type,
                expected: $28a33cb307c00cce$export$5716da67bfaa244d.void,
                received: ctx.parsedType
            });
            return $28a33cb307c00cce$export$9a105a556e65c2c0;
        }
        return $28a33cb307c00cce$export$c6813a8d51f77eaf(input.data);
    }
}
$28a33cb307c00cce$export$7d39f5df85f21031.create = (params)=>{
    return new $28a33cb307c00cce$export$7d39f5df85f21031({
        typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodVoid,
        ...$28a33cb307c00cce$var$processCreateParams(params)
    });
};
class $28a33cb307c00cce$export$7acfc3e64785411 extends $28a33cb307c00cce$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $28a33cb307c00cce$export$5716da67bfaa244d.array) {
            $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_type,
                expected: $28a33cb307c00cce$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $28a33cb307c00cce$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                    code: tooBig ? $28a33cb307c00cce$export$5ba560653e4a1035.too_big : $28a33cb307c00cce$export$5ba560653e4a1035.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                    code: $28a33cb307c00cce$export$5ba560653e4a1035.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                    code: $28a33cb307c00cce$export$5ba560653e4a1035.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $28a33cb307c00cce$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $28a33cb307c00cce$export$5b20a5c3d05c1f6f.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $28a33cb307c00cce$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $28a33cb307c00cce$export$5b20a5c3d05c1f6f.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $28a33cb307c00cce$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: $28a33cb307c00cce$var$errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $28a33cb307c00cce$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: $28a33cb307c00cce$var$errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new $28a33cb307c00cce$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: $28a33cb307c00cce$var$errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$28a33cb307c00cce$export$7acfc3e64785411.create = (schema, params)=>{
    return new $28a33cb307c00cce$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodArray,
        ...$28a33cb307c00cce$var$processCreateParams(params)
    });
};
function $28a33cb307c00cce$var$deepPartialify(schema) {
    if (schema instanceof $28a33cb307c00cce$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $28a33cb307c00cce$export$aa56fec1e9d629b8.create($28a33cb307c00cce$var$deepPartialify(fieldSchema));
        }
        return new $28a33cb307c00cce$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $28a33cb307c00cce$export$7acfc3e64785411) return new $28a33cb307c00cce$export$7acfc3e64785411({
        ...schema._def,
        type: $28a33cb307c00cce$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $28a33cb307c00cce$export$aa56fec1e9d629b8) return $28a33cb307c00cce$export$aa56fec1e9d629b8.create($28a33cb307c00cce$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $28a33cb307c00cce$export$aaac0b8b429cef5) return $28a33cb307c00cce$export$aaac0b8b429cef5.create($28a33cb307c00cce$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $28a33cb307c00cce$export$e2a18bb771d8e6a3) return $28a33cb307c00cce$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$28a33cb307c00cce$var$deepPartialify(item)));
    else return schema;
}
class $28a33cb307c00cce$export$736315c5b55efbad extends $28a33cb307c00cce$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $28a33cb307c00cce$export$7debb50ef11d5e0b.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $28a33cb307c00cce$export$5716da67bfaa244d.object) {
            const ctx = this._getOrReturnCtx(input);
            $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_type,
                expected: $28a33cb307c00cce$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $28a33cb307c00cce$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $28a33cb307c00cce$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $28a33cb307c00cce$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $28a33cb307c00cce$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                        code: $28a33cb307c00cce$export$5ba560653e4a1035.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $28a33cb307c00cce$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key: key,
                    value: value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return $28a33cb307c00cce$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
        });
        else return $28a33cb307c00cce$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $28a33cb307c00cce$var$errorUtil.errToObj;
        return new $28a33cb307c00cce$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    var _a, _b, _c, _d;
                    const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (_d = $28a33cb307c00cce$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $28a33cb307c00cce$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $28a33cb307c00cce$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $28a33cb307c00cce$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $28a33cb307c00cce$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $28a33cb307c00cce$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        $28a33cb307c00cce$export$7debb50ef11d5e0b.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $28a33cb307c00cce$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        $28a33cb307c00cce$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $28a33cb307c00cce$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $28a33cb307c00cce$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $28a33cb307c00cce$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $28a33cb307c00cce$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        $28a33cb307c00cce$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $28a33cb307c00cce$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $28a33cb307c00cce$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $28a33cb307c00cce$var$createZodEnum($28a33cb307c00cce$export$7debb50ef11d5e0b.objectKeys(this.shape));
    }
}
$28a33cb307c00cce$export$736315c5b55efbad.create = (shape, params)=>{
    return new $28a33cb307c00cce$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $28a33cb307c00cce$export$1e576a20c3ce9fb5.create(),
        typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodObject,
        ...$28a33cb307c00cce$var$processCreateParams(params)
    });
};
$28a33cb307c00cce$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $28a33cb307c00cce$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $28a33cb307c00cce$export$1e576a20c3ce9fb5.create(),
        typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodObject,
        ...$28a33cb307c00cce$var$processCreateParams(params)
    });
};
$28a33cb307c00cce$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $28a33cb307c00cce$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $28a33cb307c00cce$export$1e576a20c3ce9fb5.create(),
        typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodObject,
        ...$28a33cb307c00cce$var$processCreateParams(params)
    });
};
class $28a33cb307c00cce$export$a8b236cb5070a311 extends $28a33cb307c00cce$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $28a33cb307c00cce$export$f98dac4b251ab333(result.ctx.common.issues));
            $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $28a33cb307c00cce$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $28a33cb307c00cce$export$f98dac4b251ab333(issues));
            $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $28a33cb307c00cce$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$28a33cb307c00cce$export$a8b236cb5070a311.create = (types, params)=>{
    return new $28a33cb307c00cce$export$a8b236cb5070a311({
        options: types,
        typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodUnion,
        ...$28a33cb307c00cce$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $28a33cb307c00cce$var$getDiscriminator = (type)=>{
    if (type instanceof $28a33cb307c00cce$export$378d0cfce37406e6) return $28a33cb307c00cce$var$getDiscriminator(type.schema);
    else if (type instanceof $28a33cb307c00cce$export$a60af00cc0ce2582) return $28a33cb307c00cce$var$getDiscriminator(type.innerType());
    else if (type instanceof $28a33cb307c00cce$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $28a33cb307c00cce$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $28a33cb307c00cce$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return $28a33cb307c00cce$export$7debb50ef11d5e0b.objectValues(type.enum);
    else if (type instanceof $28a33cb307c00cce$export$bb19b37874861e7e) return $28a33cb307c00cce$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $28a33cb307c00cce$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $28a33cb307c00cce$export$a96281f914484f2d) return [
        null
    ];
    else if (type instanceof $28a33cb307c00cce$export$aa56fec1e9d629b8) return [
        undefined,
        ...$28a33cb307c00cce$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $28a33cb307c00cce$export$aaac0b8b429cef5) return [
        null,
        ...$28a33cb307c00cce$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $28a33cb307c00cce$export$66b0c798a395271f) return $28a33cb307c00cce$var$getDiscriminator(type.unwrap());
    else if (type instanceof $28a33cb307c00cce$export$5d1f7ef05c4e493a) return $28a33cb307c00cce$var$getDiscriminator(type.unwrap());
    else if (type instanceof $28a33cb307c00cce$export$75a44ec6249ac76b) return $28a33cb307c00cce$var$getDiscriminator(type._def.innerType);
    else return [];
};
class $28a33cb307c00cce$export$5ef2424805ac76a3 extends $28a33cb307c00cce$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $28a33cb307c00cce$export$5716da67bfaa244d.object) {
            $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_type,
                expected: $28a33cb307c00cce$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $28a33cb307c00cce$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $28a33cb307c00cce$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $28a33cb307c00cce$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $28a33cb307c00cce$export$5ef2424805ac76a3({
            typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$28a33cb307c00cce$var$processCreateParams(params)
        });
    }
}
function $28a33cb307c00cce$var$mergeValues(a, b) {
    const aType = $28a33cb307c00cce$export$3e9057828ebd5c7a(a);
    const bType = $28a33cb307c00cce$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $28a33cb307c00cce$export$5716da67bfaa244d.object && bType === $28a33cb307c00cce$export$5716da67bfaa244d.object) {
        const bKeys = $28a33cb307c00cce$export$7debb50ef11d5e0b.objectKeys(b);
        const sharedKeys = $28a33cb307c00cce$export$7debb50ef11d5e0b.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $28a33cb307c00cce$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $28a33cb307c00cce$export$5716da67bfaa244d.array && bType === $28a33cb307c00cce$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $28a33cb307c00cce$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $28a33cb307c00cce$export$5716da67bfaa244d.date && bType === $28a33cb307c00cce$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $28a33cb307c00cce$export$c02deaf0bb5203d4 extends $28a33cb307c00cce$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ($28a33cb307c00cce$export$afa861e3c5730743(parsedLeft) || $28a33cb307c00cce$export$afa861e3c5730743(parsedRight)) return $28a33cb307c00cce$export$9a105a556e65c2c0;
            const merged = $28a33cb307c00cce$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                    code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_intersection_types
                });
                return $28a33cb307c00cce$export$9a105a556e65c2c0;
            }
            if ($28a33cb307c00cce$export$910b6cdd390341b3(parsedLeft) || $28a33cb307c00cce$export$910b6cdd390341b3(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$28a33cb307c00cce$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $28a33cb307c00cce$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodIntersection,
        ...$28a33cb307c00cce$var$processCreateParams(params)
    });
};
class $28a33cb307c00cce$export$e2a18bb771d8e6a3 extends $28a33cb307c00cce$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $28a33cb307c00cce$export$5716da67bfaa244d.array) {
            $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_type,
                expected: $28a33cb307c00cce$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $28a33cb307c00cce$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                code: $28a33cb307c00cce$export$5ba560653e4a1035.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $28a33cb307c00cce$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                code: $28a33cb307c00cce$export$5ba560653e4a1035.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $28a33cb307c00cce$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $28a33cb307c00cce$export$5b20a5c3d05c1f6f.mergeArray(status, results);
        });
        else return $28a33cb307c00cce$export$5b20a5c3d05c1f6f.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $28a33cb307c00cce$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$28a33cb307c00cce$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $28a33cb307c00cce$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$28a33cb307c00cce$var$processCreateParams(params)
    });
};
class $28a33cb307c00cce$export$a2acc09968cb4b7f extends $28a33cb307c00cce$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $28a33cb307c00cce$export$5716da67bfaa244d.object) {
            $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_type,
                expected: $28a33cb307c00cce$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $28a33cb307c00cce$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $28a33cb307c00cce$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $28a33cb307c00cce$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return $28a33cb307c00cce$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
        else return $28a33cb307c00cce$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $28a33cb307c00cce$export$19342e026b58ebb7) return new $28a33cb307c00cce$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodRecord,
            ...$28a33cb307c00cce$var$processCreateParams(third)
        });
        return new $28a33cb307c00cce$export$a2acc09968cb4b7f({
            keyType: $28a33cb307c00cce$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodRecord,
            ...$28a33cb307c00cce$var$processCreateParams(second)
        });
    }
}
class $28a33cb307c00cce$export$163b6a2b712d9542 extends $28a33cb307c00cce$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $28a33cb307c00cce$export$5716da67bfaa244d.map) {
            $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_type,
                expected: $28a33cb307c00cce$export$5716da67bfaa244d.map,
                received: ctx.parsedType
            });
            return $28a33cb307c00cce$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $28a33cb307c00cce$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $28a33cb307c00cce$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $28a33cb307c00cce$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $28a33cb307c00cce$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$28a33cb307c00cce$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $28a33cb307c00cce$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodMap,
        ...$28a33cb307c00cce$var$processCreateParams(params)
    });
};
class $28a33cb307c00cce$export$977057706f816712 extends $28a33cb307c00cce$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $28a33cb307c00cce$export$5716da67bfaa244d.set) {
            $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_type,
                expected: $28a33cb307c00cce$export$5716da67bfaa244d.set,
                received: ctx.parsedType
            });
            return $28a33cb307c00cce$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                    code: $28a33cb307c00cce$export$5ba560653e4a1035.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                    code: $28a33cb307c00cce$export$5ba560653e4a1035.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $28a33cb307c00cce$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $28a33cb307c00cce$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $28a33cb307c00cce$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: $28a33cb307c00cce$var$errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $28a33cb307c00cce$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: $28a33cb307c00cce$var$errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$28a33cb307c00cce$export$977057706f816712.create = (valueType, params)=>{
    return new $28a33cb307c00cce$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodSet,
        ...$28a33cb307c00cce$var$processCreateParams(params)
    });
};
class $28a33cb307c00cce$export$d4602ba55673f53c extends $28a33cb307c00cce$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $28a33cb307c00cce$export$5716da67bfaa244d.function) {
            $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_type,
                expected: $28a33cb307c00cce$export$5716da67bfaa244d.function,
                received: ctx.parsedType
            });
            return $28a33cb307c00cce$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return $28a33cb307c00cce$export$244a85fde9c419ed({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $28a33cb307c00cce$export$32f27c719778d4c4(),
                    $28a33cb307c00cce$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return $28a33cb307c00cce$export$244a85fde9c419ed({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $28a33cb307c00cce$export$32f27c719778d4c4(),
                    $28a33cb307c00cce$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $28a33cb307c00cce$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $28a33cb307c00cce$export$c6813a8d51f77eaf(async function(...args) {
                const error = new $28a33cb307c00cce$export$f98dac4b251ab333([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $28a33cb307c00cce$export$c6813a8d51f77eaf(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new $28a33cb307c00cce$export$f98dac4b251ab333([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new $28a33cb307c00cce$export$f98dac4b251ab333([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $28a33cb307c00cce$export$d4602ba55673f53c({
            ...this._def,
            args: $28a33cb307c00cce$export$e2a18bb771d8e6a3.create(items).rest($28a33cb307c00cce$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $28a33cb307c00cce$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $28a33cb307c00cce$export$d4602ba55673f53c({
            args: args ? args : $28a33cb307c00cce$export$e2a18bb771d8e6a3.create([]).rest($28a33cb307c00cce$export$ef3b1bb1630977ae.create()),
            returns: returns || $28a33cb307c00cce$export$ef3b1bb1630977ae.create(),
            typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodFunction,
            ...$28a33cb307c00cce$var$processCreateParams(params)
        });
    }
}
class $28a33cb307c00cce$export$378d0cfce37406e6 extends $28a33cb307c00cce$export$19342e026b58ebb7 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$28a33cb307c00cce$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $28a33cb307c00cce$export$378d0cfce37406e6({
        getter: getter,
        typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodLazy,
        ...$28a33cb307c00cce$var$processCreateParams(params)
    });
};
class $28a33cb307c00cce$export$7e44096782a165d3 extends $28a33cb307c00cce$export$19342e026b58ebb7 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_literal,
                expected: this._def.value
            });
            return $28a33cb307c00cce$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$28a33cb307c00cce$export$7e44096782a165d3.create = (value, params)=>{
    return new $28a33cb307c00cce$export$7e44096782a165d3({
        value: value,
        typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodLiteral,
        ...$28a33cb307c00cce$var$processCreateParams(params)
    });
};
function $28a33cb307c00cce$var$createZodEnum(values, params) {
    return new $28a33cb307c00cce$export$d325d1f0e1c20179({
        values: values,
        typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodEnum,
        ...$28a33cb307c00cce$var$processCreateParams(params)
    });
}
class $28a33cb307c00cce$export$d325d1f0e1c20179 extends $28a33cb307c00cce$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        $28a33cb307c00cce$var$_ZodEnum_cache.set(this, void 0);
    }
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                expected: $28a33cb307c00cce$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_type
            });
            return $28a33cb307c00cce$export$9a105a556e65c2c0;
        }
        if (!$28a33cb307c00cce$var$__classPrivateFieldGet(this, $28a33cb307c00cce$var$_ZodEnum_cache, "f")) $28a33cb307c00cce$var$__classPrivateFieldSet(this, $28a33cb307c00cce$var$_ZodEnum_cache, new Set(this._def.values), "f");
        if (!$28a33cb307c00cce$var$__classPrivateFieldGet(this, $28a33cb307c00cce$var$_ZodEnum_cache, "f").has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $28a33cb307c00cce$export$9a105a556e65c2c0;
        }
        return $28a33cb307c00cce$export$c6813a8d51f77eaf(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return $28a33cb307c00cce$export$d325d1f0e1c20179.create(values, {
            ...this._def,
            ...newDef
        });
    }
    exclude(values, newDef = this._def) {
        return $28a33cb307c00cce$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)), {
            ...this._def,
            ...newDef
        });
    }
}
$28a33cb307c00cce$var$_ZodEnum_cache = new WeakMap();
$28a33cb307c00cce$export$d325d1f0e1c20179.create = $28a33cb307c00cce$var$createZodEnum;
class $28a33cb307c00cce$export$370b2e8d6d6f5c56 extends $28a33cb307c00cce$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        $28a33cb307c00cce$var$_ZodNativeEnum_cache.set(this, void 0);
    }
    _parse(input) {
        const nativeEnumValues = $28a33cb307c00cce$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $28a33cb307c00cce$export$5716da67bfaa244d.string && ctx.parsedType !== $28a33cb307c00cce$export$5716da67bfaa244d.number) {
            const expectedValues = $28a33cb307c00cce$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                expected: $28a33cb307c00cce$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_type
            });
            return $28a33cb307c00cce$export$9a105a556e65c2c0;
        }
        if (!$28a33cb307c00cce$var$__classPrivateFieldGet(this, $28a33cb307c00cce$var$_ZodNativeEnum_cache, "f")) $28a33cb307c00cce$var$__classPrivateFieldSet(this, $28a33cb307c00cce$var$_ZodNativeEnum_cache, new Set($28a33cb307c00cce$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values)), "f");
        if (!$28a33cb307c00cce$var$__classPrivateFieldGet(this, $28a33cb307c00cce$var$_ZodNativeEnum_cache, "f").has(input.data)) {
            const expectedValues = $28a33cb307c00cce$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $28a33cb307c00cce$export$9a105a556e65c2c0;
        }
        return $28a33cb307c00cce$export$c6813a8d51f77eaf(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
$28a33cb307c00cce$var$_ZodNativeEnum_cache = new WeakMap();
$28a33cb307c00cce$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $28a33cb307c00cce$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodNativeEnum,
        ...$28a33cb307c00cce$var$processCreateParams(params)
    });
};
class $28a33cb307c00cce$export$3f196b0127d6e50a extends $28a33cb307c00cce$export$19342e026b58ebb7 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $28a33cb307c00cce$export$5716da67bfaa244d.promise && ctx.common.async === false) {
            $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_type,
                expected: $28a33cb307c00cce$export$5716da67bfaa244d.promise,
                received: ctx.parsedType
            });
            return $28a33cb307c00cce$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === $28a33cb307c00cce$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
        return $28a33cb307c00cce$export$c6813a8d51f77eaf(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$28a33cb307c00cce$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $28a33cb307c00cce$export$3f196b0127d6e50a({
        type: schema,
        typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodPromise,
        ...$28a33cb307c00cce$var$processCreateParams(params)
    });
};
class $28a33cb307c00cce$export$a60af00cc0ce2582 extends $28a33cb307c00cce$export$19342e026b58ebb7 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $28a33cb307c00cce$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                $28a33cb307c00cce$export$db7caee60e5d514d(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return $28a33cb307c00cce$export$9a105a556e65c2c0;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $28a33cb307c00cce$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $28a33cb307c00cce$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $28a33cb307c00cce$export$325a211da9693fcf(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return $28a33cb307c00cce$export$9a105a556e65c2c0;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $28a33cb307c00cce$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $28a33cb307c00cce$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $28a33cb307c00cce$export$325a211da9693fcf(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $28a33cb307c00cce$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $28a33cb307c00cce$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!$28a33cb307c00cce$export$1ea939691cdc45b8(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!$28a33cb307c00cce$export$1ea939691cdc45b8(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $28a33cb307c00cce$export$7debb50ef11d5e0b.assertNever(effect);
    }
}
$28a33cb307c00cce$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $28a33cb307c00cce$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$28a33cb307c00cce$var$processCreateParams(params)
    });
};
$28a33cb307c00cce$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $28a33cb307c00cce$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodEffects,
        ...$28a33cb307c00cce$var$processCreateParams(params)
    });
};
class $28a33cb307c00cce$export$aa56fec1e9d629b8 extends $28a33cb307c00cce$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $28a33cb307c00cce$export$5716da67bfaa244d.undefined) return $28a33cb307c00cce$export$c6813a8d51f77eaf(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$28a33cb307c00cce$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $28a33cb307c00cce$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodOptional,
        ...$28a33cb307c00cce$var$processCreateParams(params)
    });
};
class $28a33cb307c00cce$export$aaac0b8b429cef5 extends $28a33cb307c00cce$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $28a33cb307c00cce$export$5716da67bfaa244d.null) return $28a33cb307c00cce$export$c6813a8d51f77eaf(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$28a33cb307c00cce$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $28a33cb307c00cce$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodNullable,
        ...$28a33cb307c00cce$var$processCreateParams(params)
    });
};
class $28a33cb307c00cce$export$bb19b37874861e7e extends $28a33cb307c00cce$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $28a33cb307c00cce$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$28a33cb307c00cce$export$bb19b37874861e7e.create = (type, params)=>{
    return new $28a33cb307c00cce$export$bb19b37874861e7e({
        innerType: type,
        typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$28a33cb307c00cce$var$processCreateParams(params)
    });
};
class $28a33cb307c00cce$export$75a44ec6249ac76b extends $28a33cb307c00cce$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ($28a33cb307c00cce$export$aefee5ebe1dcfd9e(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $28a33cb307c00cce$export$f98dac4b251ab333(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $28a33cb307c00cce$export$f98dac4b251ab333(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$28a33cb307c00cce$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $28a33cb307c00cce$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$28a33cb307c00cce$var$processCreateParams(params)
    });
};
class $28a33cb307c00cce$export$26ccfa0145e8511f extends $28a33cb307c00cce$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $28a33cb307c00cce$export$5716da67bfaa244d.nan) {
            const ctx = this._getOrReturnCtx(input);
            $28a33cb307c00cce$export$db7caee60e5d514d(ctx, {
                code: $28a33cb307c00cce$export$5ba560653e4a1035.invalid_type,
                expected: $28a33cb307c00cce$export$5716da67bfaa244d.nan,
                received: ctx.parsedType
            });
            return $28a33cb307c00cce$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$28a33cb307c00cce$export$26ccfa0145e8511f.create = (params)=>{
    return new $28a33cb307c00cce$export$26ccfa0145e8511f({
        typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodNaN,
        ...$28a33cb307c00cce$var$processCreateParams(params)
    });
};
const $28a33cb307c00cce$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $28a33cb307c00cce$export$66b0c798a395271f extends $28a33cb307c00cce$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $28a33cb307c00cce$export$a3c3ef8a0e95c6da extends $28a33cb307c00cce$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return $28a33cb307c00cce$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return $28a33cb307c00cce$export$325a211da9693fcf(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $28a33cb307c00cce$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $28a33cb307c00cce$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $28a33cb307c00cce$export$5d1f7ef05c4e493a extends $28a33cb307c00cce$export$19342e026b58ebb7 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if ($28a33cb307c00cce$export$1ea939691cdc45b8(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return $28a33cb307c00cce$export$aefee5ebe1dcfd9e(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$28a33cb307c00cce$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $28a33cb307c00cce$export$5d1f7ef05c4e493a({
        innerType: type,
        typeName: $28a33cb307c00cce$export$558106ce543bd011.ZodReadonly,
        ...$28a33cb307c00cce$var$processCreateParams(params)
    });
};
function $28a33cb307c00cce$export$4c00f665f0d4b443(check, params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return $28a33cb307c00cce$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        var _a, _b;
        if (!check(data)) {
            const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            const p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue({
                code: "custom",
                ...p2,
                fatal: _fatal
            });
        }
    });
    return $28a33cb307c00cce$export$b9d1edb536b4e4eb.create();
}
const $28a33cb307c00cce$export$1ee8ee30835eab8b = {
    object: $28a33cb307c00cce$export$736315c5b55efbad.lazycreate
};
var $28a33cb307c00cce$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($28a33cb307c00cce$export$558106ce543bd011 || ($28a33cb307c00cce$export$558106ce543bd011 = {}));
const $28a33cb307c00cce$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$28a33cb307c00cce$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $28a33cb307c00cce$export$22b082955e083ec3 = $28a33cb307c00cce$export$1230eb29b8d3b502.create;
const $28a33cb307c00cce$export$98e628dec113755e = $28a33cb307c00cce$export$5b070a55c0c43e09.create;
const $28a33cb307c00cce$export$9e06de0973666692 = $28a33cb307c00cce$export$26ccfa0145e8511f.create;
const $28a33cb307c00cce$export$a0f65b52274bcc00 = $28a33cb307c00cce$export$67d741fd70ff98f4.create;
const $28a33cb307c00cce$export$4a21f16c33752377 = $28a33cb307c00cce$export$723d146f80596191.create;
const $28a33cb307c00cce$export$324d90190a8b822a = $28a33cb307c00cce$export$e974be33bdc55521.create;
const $28a33cb307c00cce$export$8f701197936bc2a6 = $28a33cb307c00cce$export$bcc3b40f6b638044.create;
const $28a33cb307c00cce$export$1db45310990710a5 = $28a33cb307c00cce$export$4e780e961c30340d.create;
const $28a33cb307c00cce$export$7b1b591b262c240 = $28a33cb307c00cce$export$a96281f914484f2d.create;
const $28a33cb307c00cce$export$4154a199d7d90455 = $28a33cb307c00cce$export$b9d1edb536b4e4eb.create;
const $28a33cb307c00cce$export$19282c40b967aec6 = $28a33cb307c00cce$export$ef3b1bb1630977ae.create;
const $28a33cb307c00cce$export$b3e22bcfd64c1022 = $28a33cb307c00cce$export$1e576a20c3ce9fb5.create;
const $28a33cb307c00cce$export$490e536ee7389aeb = $28a33cb307c00cce$export$7d39f5df85f21031.create;
const $28a33cb307c00cce$export$2f23118c22fb2630 = $28a33cb307c00cce$export$7acfc3e64785411.create;
const $28a33cb307c00cce$export$be5493f9613cbbe = $28a33cb307c00cce$export$736315c5b55efbad.create;
const $28a33cb307c00cce$export$8fb0df5f40d0b477 = $28a33cb307c00cce$export$736315c5b55efbad.strictCreate;
const $28a33cb307c00cce$export$971dd5b0dfd021b6 = $28a33cb307c00cce$export$a8b236cb5070a311.create;
const $28a33cb307c00cce$export$4b888e40c4ee26dd = $28a33cb307c00cce$export$5ef2424805ac76a3.create;
const $28a33cb307c00cce$export$bc86dfbf7795668c = $28a33cb307c00cce$export$c02deaf0bb5203d4.create;
const $28a33cb307c00cce$export$65e3907585753458 = $28a33cb307c00cce$export$e2a18bb771d8e6a3.create;
const $28a33cb307c00cce$export$e5185e241753e543 = $28a33cb307c00cce$export$a2acc09968cb4b7f.create;
const $28a33cb307c00cce$export$871de8747c9eaa88 = $28a33cb307c00cce$export$163b6a2b712d9542.create;
const $28a33cb307c00cce$export$adaa4cf7ef1b65be = $28a33cb307c00cce$export$977057706f816712.create;
const $28a33cb307c00cce$export$44e51c8aac7c2deb = $28a33cb307c00cce$export$d4602ba55673f53c.create;
const $28a33cb307c00cce$export$488013bae63b21da = $28a33cb307c00cce$export$378d0cfce37406e6.create;
const $28a33cb307c00cce$export$c8ec6e1ec9fefcb0 = $28a33cb307c00cce$export$7e44096782a165d3.create;
const $28a33cb307c00cce$export$78a99c8d44d72635 = $28a33cb307c00cce$export$d325d1f0e1c20179.create;
const $28a33cb307c00cce$export$6fe7eca19ebe5199 = $28a33cb307c00cce$export$370b2e8d6d6f5c56.create;
const $28a33cb307c00cce$export$c957ef27a0ebfd4 = $28a33cb307c00cce$export$3f196b0127d6e50a.create;
const $28a33cb307c00cce$export$dc573d8a6576cdb3 = $28a33cb307c00cce$export$a60af00cc0ce2582.create;
const $28a33cb307c00cce$export$516e28dec6a4b6d4 = $28a33cb307c00cce$export$aa56fec1e9d629b8.create;
const $28a33cb307c00cce$export$133fc36489ac9add = $28a33cb307c00cce$export$aaac0b8b429cef5.create;
const $28a33cb307c00cce$export$fc37fe19dfda43ee = $28a33cb307c00cce$export$a60af00cc0ce2582.createWithPreprocess;
const $28a33cb307c00cce$export$43f28b24e1eb8181 = $28a33cb307c00cce$export$a3c3ef8a0e95c6da.create;
const $28a33cb307c00cce$export$3b3d07727c5b702c = ()=>$28a33cb307c00cce$export$22b082955e083ec3().optional();
const $28a33cb307c00cce$export$eb150471a61fced6 = ()=>$28a33cb307c00cce$export$98e628dec113755e().optional();
const $28a33cb307c00cce$export$269251733cdcbbf1 = ()=>$28a33cb307c00cce$export$4a21f16c33752377().optional();
const $28a33cb307c00cce$export$8c14e57e778d3873 = {
    string: (arg)=>$28a33cb307c00cce$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$28a33cb307c00cce$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$28a33cb307c00cce$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$28a33cb307c00cce$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$28a33cb307c00cce$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $28a33cb307c00cce$export$96c94437c95d7862 = $28a33cb307c00cce$export$9a105a556e65c2c0;
var $28a33cb307c00cce$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $28a33cb307c00cce$export$341b0b6e0a6f5099,
    setErrorMap: $28a33cb307c00cce$export$1097a8289cfd22d7,
    getErrorMap: $28a33cb307c00cce$export$32f27c719778d4c4,
    makeIssue: $28a33cb307c00cce$export$244a85fde9c419ed,
    EMPTY_PATH: $28a33cb307c00cce$export$1526d2e05f74572,
    addIssueToContext: $28a33cb307c00cce$export$db7caee60e5d514d,
    ParseStatus: $28a33cb307c00cce$export$5b20a5c3d05c1f6f,
    INVALID: $28a33cb307c00cce$export$9a105a556e65c2c0,
    DIRTY: $28a33cb307c00cce$export$325a211da9693fcf,
    OK: $28a33cb307c00cce$export$c6813a8d51f77eaf,
    isAborted: $28a33cb307c00cce$export$afa861e3c5730743,
    isDirty: $28a33cb307c00cce$export$910b6cdd390341b3,
    isValid: $28a33cb307c00cce$export$1ea939691cdc45b8,
    isAsync: $28a33cb307c00cce$export$aefee5ebe1dcfd9e,
    get util () {
        return $28a33cb307c00cce$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $28a33cb307c00cce$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $28a33cb307c00cce$export$5716da67bfaa244d,
    getParsedType: $28a33cb307c00cce$export$3e9057828ebd5c7a,
    ZodType: $28a33cb307c00cce$export$19342e026b58ebb7,
    datetimeRegex: $28a33cb307c00cce$export$a4b563879add27a,
    ZodString: $28a33cb307c00cce$export$1230eb29b8d3b502,
    ZodNumber: $28a33cb307c00cce$export$5b070a55c0c43e09,
    ZodBigInt: $28a33cb307c00cce$export$67d741fd70ff98f4,
    ZodBoolean: $28a33cb307c00cce$export$723d146f80596191,
    ZodDate: $28a33cb307c00cce$export$e974be33bdc55521,
    ZodSymbol: $28a33cb307c00cce$export$bcc3b40f6b638044,
    ZodUndefined: $28a33cb307c00cce$export$4e780e961c30340d,
    ZodNull: $28a33cb307c00cce$export$a96281f914484f2d,
    ZodAny: $28a33cb307c00cce$export$b9d1edb536b4e4eb,
    ZodUnknown: $28a33cb307c00cce$export$ef3b1bb1630977ae,
    ZodNever: $28a33cb307c00cce$export$1e576a20c3ce9fb5,
    ZodVoid: $28a33cb307c00cce$export$7d39f5df85f21031,
    ZodArray: $28a33cb307c00cce$export$7acfc3e64785411,
    ZodObject: $28a33cb307c00cce$export$736315c5b55efbad,
    ZodUnion: $28a33cb307c00cce$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $28a33cb307c00cce$export$5ef2424805ac76a3,
    ZodIntersection: $28a33cb307c00cce$export$c02deaf0bb5203d4,
    ZodTuple: $28a33cb307c00cce$export$e2a18bb771d8e6a3,
    ZodRecord: $28a33cb307c00cce$export$a2acc09968cb4b7f,
    ZodMap: $28a33cb307c00cce$export$163b6a2b712d9542,
    ZodSet: $28a33cb307c00cce$export$977057706f816712,
    ZodFunction: $28a33cb307c00cce$export$d4602ba55673f53c,
    ZodLazy: $28a33cb307c00cce$export$378d0cfce37406e6,
    ZodLiteral: $28a33cb307c00cce$export$7e44096782a165d3,
    ZodEnum: $28a33cb307c00cce$export$d325d1f0e1c20179,
    ZodNativeEnum: $28a33cb307c00cce$export$370b2e8d6d6f5c56,
    ZodPromise: $28a33cb307c00cce$export$3f196b0127d6e50a,
    ZodEffects: $28a33cb307c00cce$export$a60af00cc0ce2582,
    ZodTransformer: $28a33cb307c00cce$export$a60af00cc0ce2582,
    ZodOptional: $28a33cb307c00cce$export$aa56fec1e9d629b8,
    ZodNullable: $28a33cb307c00cce$export$aaac0b8b429cef5,
    ZodDefault: $28a33cb307c00cce$export$bb19b37874861e7e,
    ZodCatch: $28a33cb307c00cce$export$75a44ec6249ac76b,
    ZodNaN: $28a33cb307c00cce$export$26ccfa0145e8511f,
    BRAND: $28a33cb307c00cce$export$cf2deea74cde46b4,
    ZodBranded: $28a33cb307c00cce$export$66b0c798a395271f,
    ZodPipeline: $28a33cb307c00cce$export$a3c3ef8a0e95c6da,
    ZodReadonly: $28a33cb307c00cce$export$5d1f7ef05c4e493a,
    custom: $28a33cb307c00cce$export$4c00f665f0d4b443,
    Schema: $28a33cb307c00cce$export$19342e026b58ebb7,
    ZodSchema: $28a33cb307c00cce$export$19342e026b58ebb7,
    late: $28a33cb307c00cce$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $28a33cb307c00cce$export$558106ce543bd011;
    },
    coerce: $28a33cb307c00cce$export$8c14e57e778d3873,
    any: $28a33cb307c00cce$export$4154a199d7d90455,
    array: $28a33cb307c00cce$export$2f23118c22fb2630,
    bigint: $28a33cb307c00cce$export$a0f65b52274bcc00,
    boolean: $28a33cb307c00cce$export$4a21f16c33752377,
    date: $28a33cb307c00cce$export$324d90190a8b822a,
    discriminatedUnion: $28a33cb307c00cce$export$4b888e40c4ee26dd,
    effect: $28a33cb307c00cce$export$dc573d8a6576cdb3,
    "enum": $28a33cb307c00cce$export$78a99c8d44d72635,
    "function": $28a33cb307c00cce$export$44e51c8aac7c2deb,
    "instanceof": $28a33cb307c00cce$export$3d916e7c22dbd8b5,
    intersection: $28a33cb307c00cce$export$bc86dfbf7795668c,
    lazy: $28a33cb307c00cce$export$488013bae63b21da,
    literal: $28a33cb307c00cce$export$c8ec6e1ec9fefcb0,
    map: $28a33cb307c00cce$export$871de8747c9eaa88,
    nan: $28a33cb307c00cce$export$9e06de0973666692,
    nativeEnum: $28a33cb307c00cce$export$6fe7eca19ebe5199,
    never: $28a33cb307c00cce$export$b3e22bcfd64c1022,
    "null": $28a33cb307c00cce$export$7b1b591b262c240,
    nullable: $28a33cb307c00cce$export$133fc36489ac9add,
    number: $28a33cb307c00cce$export$98e628dec113755e,
    object: $28a33cb307c00cce$export$be5493f9613cbbe,
    oboolean: $28a33cb307c00cce$export$269251733cdcbbf1,
    onumber: $28a33cb307c00cce$export$eb150471a61fced6,
    optional: $28a33cb307c00cce$export$516e28dec6a4b6d4,
    ostring: $28a33cb307c00cce$export$3b3d07727c5b702c,
    pipeline: $28a33cb307c00cce$export$43f28b24e1eb8181,
    preprocess: $28a33cb307c00cce$export$fc37fe19dfda43ee,
    promise: $28a33cb307c00cce$export$c957ef27a0ebfd4,
    record: $28a33cb307c00cce$export$e5185e241753e543,
    set: $28a33cb307c00cce$export$adaa4cf7ef1b65be,
    strictObject: $28a33cb307c00cce$export$8fb0df5f40d0b477,
    string: $28a33cb307c00cce$export$22b082955e083ec3,
    symbol: $28a33cb307c00cce$export$8f701197936bc2a6,
    transformer: $28a33cb307c00cce$export$dc573d8a6576cdb3,
    tuple: $28a33cb307c00cce$export$65e3907585753458,
    "undefined": $28a33cb307c00cce$export$1db45310990710a5,
    union: $28a33cb307c00cce$export$971dd5b0dfd021b6,
    unknown: $28a33cb307c00cce$export$19282c40b967aec6,
    "void": $28a33cb307c00cce$export$490e536ee7389aeb,
    NEVER: $28a33cb307c00cce$export$96c94437c95d7862,
    ZodIssueCode: $28a33cb307c00cce$export$5ba560653e4a1035,
    quotelessJson: $28a33cb307c00cce$export$913eddeaf297cfea,
    ZodError: $28a33cb307c00cce$export$f98dac4b251ab333
});

});

parcelRegister("277OF", function(module, exports) {

$parcel$export(module.exports, "createQueryStore", function () { return $bf10bd8d1e3a71e9$export$849cdc3ce803f885; });
// query-store.ts

var $hDdVA = parcelRequire("hDdVA");

var $lJ1OS = parcelRequire("lJ1OS");

var $bAwxh = parcelRequire("bAwxh");

var $jbmdS = parcelRequire("jbmdS");

var $6Q5sp = parcelRequire("6Q5sp");
function $bf10bd8d1e3a71e9$export$849cdc3ce803f885(storeConfig, queryConfig, saveToastConfig) {
    // Add isLoading to the initial context
    const initialContext = {
        ...storeConfig.context,
        isLoading: false
    };
    // Create base store with history
    const store = (0, $hDdVA.withHistory)({
        context: initialContext,
        on: {
            ...storeConfig.on,
            setIsLoading: {
                isLoading: (_, event)=>event.isLoading
            }
        }
    });
    // Create enhanced store with query integration
    const enhancedStore = {
        ...store,
        send: (event)=>{
            store.send(event);
            if (![
                "setIsLoading",
                "initializeState"
            ].includes(event.type)) {
                // Extract only the original context fields for react-query updates
                const originalContextKeys = Object.keys(storeConfig.context);
                const contextForQuery = Object.fromEntries(Object.entries(store.getSnapshot().context).filter(([key])=>originalContextKeys.includes(key)));
                (0, $6Q5sp.queryClient).setQueryData(queryConfig.queryKey, contextForQuery);
            }
        }
    };
    // Create loader function
    const loader = async (...params)=>{
        store.send({
            type: "setIsLoading",
            isLoading: true
        });
        try {
            var _queryConfig$staleTim, _queryConfig$cacheTim;
            const result = await (0, $6Q5sp.queryClient).fetchQuery({
                queryKey: queryConfig.queryKey,
                queryFn: ()=>queryConfig.queryFn(...params),
                staleTime: (_queryConfig$staleTim = queryConfig.staleTime) !== null && _queryConfig$staleTim !== void 0 ? _queryConfig$staleTim : 300000,
                cacheTime: (_queryConfig$cacheTim = queryConfig.cacheTime) !== null && _queryConfig$cacheTim !== void 0 ? _queryConfig$cacheTim : 1800000
            });
            store.send({
                type: "initializeState",
                state: {
                    ...result,
                    isLoading: false
                }
            });
            return result;
        } catch (error) {
            console.error(`Error loading ${queryConfig.queryKey.join("/")}:`, error);
            throw error;
        } finally{
            store.send({
                type: "setIsLoading",
                isLoading: false
            });
        }
    };
    // Create custom hooks
    const useStoreData = ()=>(0, $lJ1OS.useSelector)(enhancedStore, (state)=>{
            const originalContextKeys = Object.keys(storeConfig.context);
            return Object.fromEntries(Object.entries(state.context).filter(([key])=>originalContextKeys.includes(key)));
        });
    const useIsLoading = ()=>(0, $lJ1OS.useSelector)(enhancedStore, (state)=>state.context.isLoading);
    // Create save hook that integrates with save toast
    const useSaveHandler = ()=>{
        var _useUpdatedAt;
        const { useCanUndo: useCanUndo, useCanRedo: useCanRedo, useUpdatedAt: useUpdatedAt } = (0, $hDdVA.createHistoryHooks)(enhancedStore);
        const hasUnsavedChanges = (_useUpdatedAt = useUpdatedAt()) === null || _useUpdatedAt === void 0 ? void 0 : _useUpdatedAt.getTime();
        const { save: save, revertToLastSave: revertToLastSave } = (0, $hDdVA.createHistoryActions)(enhancedStore);
        const handleSave = (0, $jbmdS.useCallback)(async ()=>{
            const currentState = enhancedStore.getSnapshot().context;
            const originalContextKeys = Object.keys(storeConfig.context);
            const stateForMutation = Object.fromEntries(Object.entries(currentState).filter(([key])=>originalContextKeys.includes(key)));
            try {
                const result = await queryConfig.mutationFn(stateForMutation);
                save();
                return result;
            } catch (error) {
                console.error("Error saving changes:", error);
                throw error;
            }
        }, []);
        const handleCancel = (0, $jbmdS.useCallback)(()=>{
            revertToLastSave();
        }, []);
        (0, $bAwxh.useSaveToast)({
            saveId: saveToastConfig.saveId,
            onSave: handleSave,
            onCancel: handleCancel,
            requireConfirmation: saveToastConfig.requireConfirmation,
            confirmationMessage: saveToastConfig.confirmationMessage,
            loadingMessage: saveToastConfig.loadingMessage,
            successMessage: saveToastConfig.successMessage,
            errorMessage: saveToastConfig.errorMessage,
            metadata: {
                type: queryConfig.queryKey.join("/"),
                timestamp: Date.now()
            },
            hasPendingChanges: hasUnsavedChanges
        });
        return {
            handleSave: handleSave,
            handleCancel: handleCancel,
            hasUnsavedChanges: hasUnsavedChanges
        };
    };
    // Return everything needed to use the store
    return {
        store: enhancedStore,
        loader: loader,
        useStoreData: useStoreData,
        useIsLoading: useIsLoading,
        useSaveHandler: useSaveHandler,
        ...(0, $hDdVA.createHistoryHooks)(enhancedStore),
        ...(0, $hDdVA.createHistoryActions)(enhancedStore),
        ...(0, $hDdVA.createHistoryGetters)(enhancedStore)
    };
}

});
parcelRegister("hDdVA", function(module, exports) {

$parcel$export(module.exports, "withHistory", function () { return $fe6779982ed13c21$export$f90a925769053fad; });
$parcel$export(module.exports, "createHistoryHooks", function () { return $fe6779982ed13c21$export$9a775569e6970cb4; });
$parcel$export(module.exports, "createHistoryActions", function () { return $fe6779982ed13c21$export$87937487b839871f; });
$parcel$export(module.exports, "createHistoryGetters", function () { return $fe6779982ed13c21$export$ca5acca7cf48fb08; });

var $hxM7m = parcelRequire("hxM7m");

var $lJ1OS = parcelRequire("lJ1OS");
function $fe6779982ed13c21$export$f90a925769053fad(config) {
    const initialHistoryContext = {
        history: [],
        currentHistoryIndex: -1,
        lastSavedIndex: -1,
        savedAt: null,
        updatedAt: null
    };
    // Merge the initial context with history context
    const initialContext = {
        ...config.context,
        ...initialHistoryContext
    };
    // Helper function to manage history
    const addToHistory = (context, newState)=>{
        const newHistory = context.history.slice(0, context.currentHistoryIndex + 1);
        return [
            ...newHistory,
            {
                state: newState,
                timestamp: new Date()
            }
        ];
    };
    // Create enhanced event handlers
    const enhancedOn = {
        initializeState: {
            ...Object.fromEntries(Object.keys(config.context).map((key)=>[
                    key,
                    (_, event)=>event.state[key]
                ])),
            history: (_, event)=>[
                    {
                        state: event.state,
                        timestamp: null
                    }
                ],
            currentHistoryIndex: ()=>0,
            lastSavedIndex: ()=>0,
            savedAt: ()=>null,
            updatedAt: ()=>null
        },
        ...config.on,
        undo: {
            ...Object.fromEntries(Object.keys(config.context).map((key)=>[
                    key,
                    (context)=>{
                        if (context.currentHistoryIndex <= 0) return context[key];
                        return context.history[context.currentHistoryIndex - 1].state[key];
                    }
                ])),
            currentHistoryIndex: (context)=>Math.max(-1, context.currentHistoryIndex - 1),
            updatedAt: (context)=>{
                if (context.currentHistoryIndex <= 0) return null;
                return context.history[context.currentHistoryIndex - 1].timestamp;
            }
        },
        redo: {
            ...Object.fromEntries(Object.keys(config.context).map((key)=>[
                    key,
                    (context)=>{
                        if (context.currentHistoryIndex >= context.history.length - 1) return context[key];
                        return context.history[context.currentHistoryIndex + 1].state[key];
                    }
                ])),
            currentHistoryIndex: (context)=>Math.min(context.history.length - 1, context.currentHistoryIndex + 1),
            updatedAt: (context)=>{
                if (context.currentHistoryIndex >= context.history.length - 1) return context.updatedAt;
                return context.history[context.currentHistoryIndex + 1].timestamp;
            }
        },
        save: {
            savedAt: ()=>new Date(),
            lastSavedIndex: (context)=>context.currentHistoryIndex
        },
        revertToLastSave: {
            ...Object.fromEntries(Object.keys(config.context).map((key)=>[
                    key,
                    (context)=>{
                        if (context.lastSavedIndex === -1) return context[key];
                        return context.history[context.lastSavedIndex].state[key];
                    }
                ])),
            currentHistoryIndex: (context)=>context.lastSavedIndex,
            updatedAt: (context)=>{
                if (context.lastSavedIndex === -1) return null;
                return context.history[context.lastSavedIndex].timestamp;
            }
        }
    };
    // Enhance existing actions with history tracking
    Object.keys(config.on).forEach((actionType)=>{
        if ([
            "undo",
            "redo",
            "save",
            "revertToLastSave",
            "initializeState",
            "setIsLoading"
        ].includes(actionType)) return;
        const originalHandler = config.on[actionType];
        enhancedOn[actionType] = {
            ...originalHandler,
            history: (context, event)=>{
                const newState = Object.keys(config.context).reduce((acc, key)=>{
                    const handler = originalHandler[key];
                    if (handler) acc[key] = handler(context, event);
                    else acc[key] = context[key];
                    return acc;
                }, {});
                return addToHistory(context, newState);
            },
            currentHistoryIndex: (context)=>context.history.length,
            updatedAt: ()=>new Date()
        };
    });
    return (0, $hxM7m.createStore)({
        context: initialContext,
        on: enhancedOn
    });
}
function $fe6779982ed13c21$export$9a775569e6970cb4(store) {
    return {
        useCanUndo: ()=>(0, $lJ1OS.useSelector)(store, (state)=>state.context.currentHistoryIndex > 0),
        useCanRedo: ()=>(0, $lJ1OS.useSelector)(store, (state)=>state.context.currentHistoryIndex < state.context.history.length - 1),
        useHasUnsavedChanges: ()=>(0, $lJ1OS.useSelector)(store, (state)=>state.context.currentHistoryIndex !== state.context.lastSavedIndex),
        useUpdatedAt: ()=>(0, $lJ1OS.useSelector)(store, (state)=>{
                var _state$context$histor;
                // Only return updatedAt if it's after the initial state timestamp
                const updatedAt = state.context.updatedAt;
                const initialTimestamp = (_state$context$histor = state.context.history[0]) === null || _state$context$histor === void 0 ? void 0 : _state$context$histor.timestamp;
                return updatedAt && (!initialTimestamp || updatedAt > initialTimestamp) ? updatedAt : null;
            }),
        useSavedAt: ()=>(0, $lJ1OS.useSelector)(store, (state)=>state.context.savedAt)
    };
}
function $fe6779982ed13c21$export$87937487b839871f(store) {
    return {
        undo: ()=>store.send({
                type: "undo"
            }),
        redo: ()=>store.send({
                type: "redo"
            }),
        save: ()=>store.send({
                type: "save"
            }),
        revertToLastSave: ()=>store.send({
                type: "revertToLastSave"
            }),
        initializeState: (state)=>store.send({
                type: "initializeState",
                state: state
            })
    };
}
function $fe6779982ed13c21$export$ca5acca7cf48fb08(store) {
    return {
        getState: ()=>store.getSnapshot().context,
        getHistory: ()=>store.getSnapshot().context.history,
        getCurrentHistoryIndex: ()=>store.getSnapshot().context.currentHistoryIndex,
        getLastSavedIndex: ()=>store.getSnapshot().context.lastSavedIndex,
        getSavedAt: ()=>store.getSnapshot().context.savedAt,
        getUpdatedAt: ()=>store.getSnapshot().context.updatedAt
    };
}

});

parcelRegister("bAwxh", function(module, exports) {

$parcel$export(module.exports, "useSaveToast", function () { return $224b011a65877c40$export$b089529cdd532383; });
$parcel$export(module.exports, "default", function () { return $224b011a65877c40$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $7zCyL = parcelRequire("7zCyL");

var $fTGwv = parcelRequire("fTGwv");

var $nhf4j = parcelRequire("nhf4j");

var $lY3j8 = parcelRequire("lY3j8");
// Constants
const $224b011a65877c40$var$SAVE_TIMEOUT_MS = 30000;
const $224b011a65877c40$var$MAX_RETRY_ATTEMPTS = 3;
const $224b011a65877c40$var$MAX_PENDING_OPERATIONS = 50;
// Add timeout handling for save operations
const $224b011a65877c40$var$withTimeout = (promise, timeoutMs)=>{
    return Promise.race([
        promise,
        new Promise((_, reject)=>setTimeout(()=>reject(new Error("Save operation timed out")), timeoutMs))
    ]);
};
const $224b011a65877c40$export$3bd2a898ef2fa88e = (requireConfirmation, onCancel)=>{
    const hasUnsavedChanges = (0, $lY3j8.useHasUnsavedChanges)();
    const { activeToasts: activeToasts } = (0, $lY3j8.getSaveState)();
    (0, $nhf4j.useBlocker)({
        shouldBlockFn: ({ current: current, next: next })=>{
            if (!hasUnsavedChanges || !requireConfirmation) return false;
            if (current.pathname === next.pathname && current.search === next.search) return false;
            const shouldProceed = window.confirm("You have unsaved changes. Are you sure you want to leave?");
            if (shouldProceed) {
                (0, $7zCyL.toast).dismiss();
                (0, $lY3j8.resetSaveStore)();
                if (onCancel) onCancel();
            }
            return !shouldProceed;
        },
        enableBeforeUnload: ()=>hasUnsavedChanges,
        withResolver: true
    });
};
const $224b011a65877c40$export$b089529cdd532383 = ({ saveId: saveId, onSave: onSave, onCancel: onCancel, requireConfirmation: requireConfirmation = false, confirmationMessage: confirmationMessage = "Save changes?", loadingMessage: loadingMessage = "Saving changes...", successMessage: successMessage = "All saved", errorMessage: errorMessage = "Changes have not been saved", showCancelButton: showCancelButton = true, onSuccess: onSuccess, onRetry: onRetry, metadata: metadata, hasPendingChanges: hasPendingChanges })=>{
    const activeToasts = (0, $lY3j8.useActiveToasts)();
    const saveTimeoutRef = (0, $jbmdS.useRef)();
    const retryCountRef = (0, $jbmdS.useRef)(0);
    $224b011a65877c40$export$3bd2a898ef2fa88e(requireConfirmation, onCancel);
    (0, $jbmdS.useEffect)(()=>{
        return ()=>{
            if (saveTimeoutRef.current) clearTimeout(saveTimeoutRef.current);
        };
    }, []);
    const executeSave = (0, $jbmdS.useCallback)(async (id, ...props)=>{
        // Start saving - moves operation from pending to saving state
        (0, $lY3j8.startSaving)(id);
        return (0, $7zCyL.toast).promise($224b011a65877c40$var$withTimeout(onSave(...props), $224b011a65877c40$var$SAVE_TIMEOUT_MS), {
            loading: loadingMessage,
            success: (data)=>{
                (0, $lY3j8.savingSucceeded)(id);
                (0, $lY3j8.removeActiveToast)(id);
                retryCountRef.current = 0;
                // Check if there's a pending operation with the same ID
                const state = (0, $lY3j8.getSaveState)();
                const pendingOperation = state.pendingOperations.find((op)=>op.id === id);
                if (pendingOperation) // If there is, show a new toast for it
                setTimeout(()=>showSaveConfirmation(), 100);
                if (onSuccess) onSuccess(data);
                return successMessage;
            },
            error: (error)=>{
                (0, $lY3j8.savingFailed)(id);
                retryCountRef.current += 1;
                const isTimeoutError = error.message.includes("timed out");
                const errorDetail = isTimeoutError ? "Operation timed out" : error.message;
                const canRetry = retryCountRef.current < $224b011a65877c40$var$MAX_RETRY_ATTEMPTS;
                return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    className: "flex items-center justify-between w-full",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                    className: "text-muted-foreground",
                                    children: errorMessage
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                    className: "text-sm text-red-500 block",
                                    children: errorDetail
                                })
                            ]
                        }),
                        canRetry && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fTGwv.Button), {
                            onClick: ()=>{
                                (0, $7zCyL.toast).dismiss();
                                if (onRetry) onRetry();
                                else showSaveConfirmation();
                            },
                            variant: "default",
                            size: "sm",
                            children: "Retry"
                        })
                    ]
                });
            }
        });
    }, [
        onSave,
        onSuccess,
        onRetry,
        metadata,
        saveId
    ]);
    const showSaveConfirmation = (0, $jbmdS.useCallback)((...props)=>{
        const id = (0, $lY3j8.generateSaveId)(saveId);
        // Check operation limits first
        const state = (0, $lY3j8.getSaveState)();
        if (state.pendingOperations.length + state.savingOperations.length >= $224b011a65877c40$var$MAX_PENDING_OPERATIONS) {
            (0, $7zCyL.toast).error("Too many pending save operations. Please try again later.");
            return;
        }
        // Check if this ID is currently saving
        const isCurrentlySaving = state.savingOperations.some((op)=>op.id === id);
        // Add/update pending operation
        (0, $lY3j8.addPendingOperation)({
            id: id,
            timestamp: Date.now(),
            metadata: metadata,
            successMessage: successMessage,
            errorMessage: errorMessage,
            loadingMessage: loadingMessage
        });
        // Only show a new toast if the operation isn't currently saving
        if (!isCurrentlySaving && !activeToasts.has(id)) {
            (0, $lY3j8.addActiveToast)(id);
            if (!requireConfirmation) return executeSave(id, ...props);
            (0, $7zCyL.toast)(/*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "flex w-full items-center",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "flex-auto",
                        children: confirmationMessage
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "flex-none flex gap-2 justify-end",
                        children: [
                            showCancelButton && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fTGwv.Button), {
                                onClick: ()=>{
                                    (0, $7zCyL.toast).dismiss();
                                    (0, $lY3j8.removeActiveToast)(id);
                                    (0, $lY3j8.clearOperation)(id);
                                    if (onCancel) onCancel();
                                },
                                variant: "outline",
                                size: "sm",
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fTGwv.Button), {
                                onClick: ()=>{
                                    (0, $7zCyL.toast).dismiss();
                                    executeSave();
                                },
                                variant: "default",
                                size: "sm",
                                children: "Save"
                            })
                        ]
                    })
                ]
            }), {
                duration: Infinity,
                dismissible: false
            });
        }
    }, [
        executeSave,
        onCancel,
        requireConfirmation,
        confirmationMessage,
        showCancelButton,
        metadata,
        successMessage,
        errorMessage,
        loadingMessage,
        activeToasts,
        saveId
    ]);
    // Handle showing the confirmation based on pending changes
    (0, $jbmdS.useEffect)(()=>{
        if (hasPendingChanges) showSaveConfirmation();
    }, [
        hasPendingChanges
    ]);
    return showSaveConfirmation;
};
var $224b011a65877c40$export$2e2bcd8739ae039 = $224b011a65877c40$export$b089529cdd532383;

});
parcelRegister("nhf4j", function(module, exports) {

$parcel$export(module.exports, "useBlocker", function () { return $045f8601d3f800cf$export$b273b3273281a049; });

var $jbmdS = parcelRequire("jbmdS");

var $1Fr27 = parcelRequire("1Fr27");
function $045f8601d3f800cf$var$_resolveBlockerOpts(opts, condition) {
    if (opts === void 0) return {
        shouldBlockFn: ()=>true,
        withResolver: false
    };
    if ("shouldBlockFn" in opts) return opts;
    if (typeof opts === "function") {
        const shouldBlock2 = Boolean(condition ?? true);
        const _customBlockerFn2 = async ()=>{
            if (shouldBlock2) return await opts();
            return false;
        };
        return {
            shouldBlockFn: _customBlockerFn2,
            enableBeforeUnload: shouldBlock2,
            withResolver: false
        };
    }
    const shouldBlock = Boolean(opts.condition ?? true);
    const fn = opts.blockerFn;
    const _customBlockerFn = async ()=>{
        if (shouldBlock && fn !== void 0) return await fn();
        return shouldBlock;
    };
    return {
        shouldBlockFn: _customBlockerFn,
        enableBeforeUnload: shouldBlock,
        withResolver: fn === void 0
    };
}
function $045f8601d3f800cf$export$b273b3273281a049(opts, condition) {
    const { shouldBlockFn: shouldBlockFn, enableBeforeUnload: enableBeforeUnload = true, disabled: disabled = false, withResolver: withResolver = false } = $045f8601d3f800cf$var$_resolveBlockerOpts(opts, condition);
    const router = (0, $1Fr27.useRouter)();
    const { history: history } = router;
    const [resolver, setResolver] = $jbmdS.useState({
        status: "idle",
        current: void 0,
        next: void 0,
        action: void 0,
        proceed: void 0,
        reset: void 0
    });
    $jbmdS.useEffect(()=>{
        const blockerFnComposed = async (blockerFnArgs)=>{
            function getLocation(location) {
                const parsedLocation = router.parseLocation(void 0, location);
                const matchedRoutes = router.getMatchedRoutes(parsedLocation);
                if (matchedRoutes.foundRoute === void 0) throw new Error(`No route found for location ${location.href}`);
                return {
                    routeId: matchedRoutes.foundRoute.id,
                    fullPath: matchedRoutes.foundRoute.fullPath,
                    pathname: parsedLocation.pathname,
                    params: matchedRoutes.routeParams,
                    search: parsedLocation.search
                };
            }
            const current = getLocation(blockerFnArgs.currentLocation);
            const next = getLocation(blockerFnArgs.nextLocation);
            const shouldBlock = await shouldBlockFn({
                action: blockerFnArgs.action,
                current: current,
                next: next
            });
            if (!withResolver) return shouldBlock;
            if (!shouldBlock) return false;
            const promise = new Promise((resolve)=>{
                setResolver({
                    status: "blocked",
                    current: current,
                    next: next,
                    action: blockerFnArgs.action,
                    proceed: ()=>resolve(false),
                    reset: ()=>resolve(true)
                });
            });
            const canNavigateAsync = await promise;
            setResolver({
                status: "idle",
                current: void 0,
                next: void 0,
                action: void 0,
                proceed: void 0,
                reset: void 0
            });
            return canNavigateAsync;
        };
        return disabled ? void 0 : history.block({
            blockerFn: blockerFnComposed,
            enableBeforeUnload: enableBeforeUnload
        });
    }, [
        shouldBlockFn,
        enableBeforeUnload,
        disabled,
        withResolver,
        history,
        router
    ]);
    return resolver;
}
const $045f8601d3f800cf$var$_resolvePromptBlockerArgs = (props)=>{
    if ("shouldBlockFn" in props) return {
        ...props
    };
    const shouldBlock = Boolean(props.condition ?? true);
    const fn = props.blockerFn;
    const _customBlockerFn = async ()=>{
        if (shouldBlock && fn !== void 0) return await fn();
        return shouldBlock;
    };
    return {
        shouldBlockFn: _customBlockerFn,
        enableBeforeUnload: shouldBlock,
        withResolver: fn === void 0
    };
};
function $045f8601d3f800cf$export$d96a8827a60d6b69(opts) {
    const { children: children, ...rest } = opts;
    const args = $045f8601d3f800cf$var$_resolvePromptBlockerArgs(rest);
    const resolver = $045f8601d3f800cf$export$b273b3273281a049(args);
    return children ? typeof children === "function" ? children(resolver) : children : null;
}

});

parcelRegister("lY3j8", function(module, exports) {

$parcel$export(module.exports, "addPendingOperation", function () { return $80584b61585a281d$export$5e82b3f1ea6bb7; });
$parcel$export(module.exports, "startSaving", function () { return $80584b61585a281d$export$fbcaffa1dbf05ba2; });
$parcel$export(module.exports, "savingSucceeded", function () { return $80584b61585a281d$export$b9a8f4d1d3b73afd; });
$parcel$export(module.exports, "savingFailed", function () { return $80584b61585a281d$export$5ab010172c2475c0; });
$parcel$export(module.exports, "addActiveToast", function () { return $80584b61585a281d$export$6ee9815116c0ed65; });
$parcel$export(module.exports, "removeActiveToast", function () { return $80584b61585a281d$export$752e4b45580b76bd; });
$parcel$export(module.exports, "clearOperation", function () { return $80584b61585a281d$export$159d300bf72e1b44; });
$parcel$export(module.exports, "resetSaveStore", function () { return $80584b61585a281d$export$6ab356d3b32eb089; });
$parcel$export(module.exports, "useActiveToasts", function () { return $80584b61585a281d$export$f4ec9524ac9dc84c; });
$parcel$export(module.exports, "useHasUnsavedChanges", function () { return $80584b61585a281d$export$d85ed874af6294e9; });
$parcel$export(module.exports, "getSaveState", function () { return $80584b61585a281d$export$d5f148e6ae9a2a68; });
$parcel$export(module.exports, "generateSaveId", function () { return $80584b61585a281d$export$f806e35bcae26f4c; });

var $hxM7m = parcelRequire("hxM7m");

var $lJ1OS = parcelRequire("lJ1OS");
// Initial state
const $80584b61585a281d$var$initialContext = {
    pendingOperations: [],
    savingOperations: [],
    activeToasts: new Set()
};
const $80584b61585a281d$export$102d1ee310cc895f = (0, $hxM7m.createStore)({
    context: $80584b61585a281d$var$initialContext,
    on: {
        addPendingOperation: {
            pendingOperations: (state, event)=>{
                // replace any existing pending operation with same ID
                const filtered = state.pendingOperations.filter((op)=>op.id !== event.operation.id);
                return [
                    ...filtered,
                    event.operation
                ];
            }
        },
        startSaving: {
            pendingOperations: (state, event)=>state.pendingOperations.filter((op)=>op.id !== event.id),
            savingOperations: (state, event)=>[
                    ...state.savingOperations,
                    state.pendingOperations.find((op)=>op.id === event.id)
                ]
        },
        savingSucceeded: {
            savingOperations: (state, event)=>{
                const newSavingOperations = state.savingOperations.filter((op)=>op.id !== event.id);
                return newSavingOperations;
            }
        },
        savingFailed: {
            savingOperations: (state, event)=>state.savingOperations.filter((op)=>op.id !== event.id),
            pendingOperations: (state, event)=>{
                const failedOperation = state.savingOperations.find((op)=>op.id === event.id);
                if (!failedOperation) return state.pendingOperations;
                // Only add back to pending if there isn't already an operation with the same id
                const hasPendingWithSameId = state.pendingOperations.some((op)=>op.id === event.id);
                if (hasPendingWithSameId) return state.pendingOperations;
                return [
                    ...state.pendingOperations,
                    failedOperation
                ];
            }
        },
        addActiveToast: {
            activeToasts: (state, event)=>new Set([
                    ...Array.from(state.activeToasts),
                    event.id
                ])
        },
        removeActiveToast: {
            activeToasts: (state, event)=>{
                const newSet = new Set(state.activeToasts);
                newSet.delete(event.id);
                return newSet;
            }
        },
        clearOperation: {
            pendingOperations: (state, event)=>state.pendingOperations.filter((op)=>op.id !== event.id),
            savingOperations: (state, event)=>state.savingOperations.filter((op)=>op.id !== event.id)
        },
        reset: {
            pendingOperations: ()=>[],
            savingOperations: ()=>[],
            activeToasts: ()=>new Set()
        }
    }
});
const $80584b61585a281d$export$5e82b3f1ea6bb7 = (operation)=>$80584b61585a281d$export$102d1ee310cc895f.send({
        type: "addPendingOperation",
        operation: operation
    });
const $80584b61585a281d$export$fbcaffa1dbf05ba2 = (id)=>$80584b61585a281d$export$102d1ee310cc895f.send({
        type: "startSaving",
        id: id
    });
const $80584b61585a281d$export$b9a8f4d1d3b73afd = (id)=>$80584b61585a281d$export$102d1ee310cc895f.send({
        type: "savingSucceeded",
        id: id
    });
const $80584b61585a281d$export$5ab010172c2475c0 = (id)=>$80584b61585a281d$export$102d1ee310cc895f.send({
        type: "savingFailed",
        id: id
    });
const $80584b61585a281d$export$6ee9815116c0ed65 = (id)=>$80584b61585a281d$export$102d1ee310cc895f.send({
        type: "addActiveToast",
        id: id
    });
const $80584b61585a281d$export$752e4b45580b76bd = (id)=>$80584b61585a281d$export$102d1ee310cc895f.send({
        type: "removeActiveToast",
        id: id
    });
const $80584b61585a281d$export$159d300bf72e1b44 = (id)=>$80584b61585a281d$export$102d1ee310cc895f.send({
        type: "clearOperation",
        id: id
    });
const $80584b61585a281d$export$6ab356d3b32eb089 = ()=>$80584b61585a281d$export$102d1ee310cc895f.send({
        type: "reset"
    });
const $80584b61585a281d$export$b4b29b787be0c5e7 = ()=>(0, $lJ1OS.useSelector)($80584b61585a281d$export$102d1ee310cc895f, (state)=>state.context.pendingOperations);
const $80584b61585a281d$export$e19f5af9f5d335a2 = ()=>(0, $lJ1OS.useSelector)($80584b61585a281d$export$102d1ee310cc895f, (state)=>state.context.savingOperations);
const $80584b61585a281d$export$f4ec9524ac9dc84c = ()=>(0, $lJ1OS.useSelector)($80584b61585a281d$export$102d1ee310cc895f, (state)=>state.context.activeToasts);
const $80584b61585a281d$export$d85ed874af6294e9 = ()=>(0, $lJ1OS.useSelector)($80584b61585a281d$export$102d1ee310cc895f, (state)=>{
        return state.context.pendingOperations.length > 0 || state.context.savingOperations.length > 0;
    });
const $80584b61585a281d$export$d5f148e6ae9a2a68 = ()=>$80584b61585a281d$export$102d1ee310cc895f.getSnapshot().context;
const $80584b61585a281d$export$10f54de470c39aa2 = (id)=>{
    const state = $80584b61585a281d$export$d5f148e6ae9a2a68();
    return state.pendingOperations.some((op)=>op.id === id) || state.savingOperations.some((op)=>op.id === id);
};
const $80584b61585a281d$export$f806e35bcae26f4c = (saveId)=>{
    return saveId || Math.random().toString(36).substring(2, 9);
};

});







parcelRegister("8MUwN", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $665ea7b2a37ede8f$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");
parcelRequire("e1rsZ");
parcelRequire("k4clm");
parcelRequire("kuPRw");
parcelRequire("bZfKS");
parcelRequire("a9PLH");

var $4iw5i = parcelRequire("4iw5i");

var $5PXcS = parcelRequire("5PXcS");

var $1BTI2 = parcelRequire("1BTI2");

var $8kZ1o = parcelRequire("8kZ1o");

var $7qobO = parcelRequire("7qobO");

var $26sX2 = parcelRequire("26sX2");

var $38AIP = parcelRequire("38AIP");

var $kqntg = parcelRequire("kqntg");

var $3RaC0 = parcelRequire("3RaC0");
parcelRequire("iuUqi");

var $27lKj = parcelRequire("27lKj");

var $4hBm1 = parcelRequire("4hBm1");

var $SRJCe = parcelRequire("SRJCe");
parcelRequire("jbmdS");

var $3h7sC = parcelRequire("3h7sC");
const $665ea7b2a37ede8f$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_private/revenue-forecast2")({
    beforeLoad: ({ params: params, search: search })=>{
        if (!(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "revenueForecast", params)) throw new Error("Permission Denied");
        const report = (0, $38AIP.getCacheItemById)("revenueForecastReports", search.report);
        (0, $26sX2.setLayoutDefaults)({
            pageTitle: (report === null || report === void 0 ? void 0 : report.name) || "Revenue Forecast",
            subMenu: "organisation"
        });
    },
    errorComponent: ({ error: error, reset: reset })=>{
        if (error.message === "Permission Denied") return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7qobO.default), {});
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    },
    component: $665ea7b2a37ede8f$var$Wrapper,
    pendingComponent: (0, $4iw5i.default),
    loader: async ({ location: location })=>await $665ea7b2a37ede8f$var$loader(location.search),
    loaderDeps: ({ search: { report: report, startDate: startDate } })=>({
            report: report,
            startDate: startDate
        })
});
const $665ea7b2a37ede8f$var$getDefaultDateRange = ()=>{
    const start = (0, $4hBm1.subMonths)((0, $4hBm1.startOfMonth)(new Date()), 3);
    const end = (0, $4hBm1.addMonths)(start, 11); // 12 months including start month
    return [
        (0, $4hBm1.format)(start, "yyyy-MM-dd"),
        (0, $4hBm1.format)(end, "yyyy-MM-dd")
    ];
};
const $665ea7b2a37ede8f$var$loader = async ({ report: report, startDate: startDate })=>{
    var _report, _SessionStore$organis;
    (_report = report) !== null && _report !== void 0 ? _report : report = (_SessionStore$organis = (0, $1BTI2.default).organisation) === null || _SessionStore$organis === void 0 ? void 0 : _SessionStore$organis.defaultRevenueForecastReportId;
    // Use provided start date or default to current month
    const dateRange = startDate ? [
        startDate,
        (0, $4hBm1.format)((0, $4hBm1.addMonths)(new Date(startDate), 11), "yyyy-MM-dd")
    ] : $665ea7b2a37ede8f$var$getDefaultDateRange();
    // First fetch the report if specified
    let filters = {};
    if (report) {
        const reportData = await (0, $3h7sC.trpc).revenueForecast.getRevenueForecastReport.query({
            id: report
        });
        (0, $27lKj.setReport)(reportData);
        filters = reportData.filters;
    }
    // Load initial data with filters from report
    await (0, $27lKj.fetchForecastData)(dateRange, filters);
    (0, $27lKj.setDateRange)(dateRange);
    // Return nothing since data is now in store
    return null;
};
const $665ea7b2a37ede8f$var$SidebarContent = ({ number: number = 1 })=>{
    const { addToSidebar: addToSidebar } = (0, $SRJCe.useSidebarStack)();
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)("h1", {
                children: [
                    "Hello ",
                    number
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                onClick: ()=>addToSidebar(/*#__PURE__*/ (0, $61Ea1.jsx)($665ea7b2a37ede8f$var$SidebarContent, {
                        number: number + 1
                    })),
                children: "Add to sidebar"
            })
        ]
    });
};
function $665ea7b2a37ede8f$var$Wrapper() {
    const { addToSidebar: addToSidebar } = (0, $SRJCe.useSidebarStack)();
    // useEffect(() => {
    //     addToSidebar(<SidebarContent />)
    // }, [])
    if ((0, $8kZ1o.migratedToV2)()) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqntg.PageBody), {
            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3RaC0.RevenueForecastPage), {})
        })
    });
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            ref: parent,
            className: "flex-auto w-full overflow-hidden flex bg-background",
            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqntg.PageBody), {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3RaC0.RevenueForecastPage), {})
            })
        })
    });
}

});
parcelRegister("e1rsZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a35676fab66ba07f$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $heNWk = parcelRequire("heNWk");

var $1k348 = parcelRequire("1k348");
parcelRequire("1BTI2");

var $36Jjh = parcelRequire("36Jjh");

var $hYUed = parcelRequire("hYUed");

var $3X7oM = parcelRequire("3X7oM");

var $ewAM3 = parcelRequire("ewAM3");
var $a35676fab66ba07f$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ label: label })=>{
    const [store, setStore] = (0, $jbmdS.useState)((0, $hYUed.default));
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $36Jjh.default), {
        heading: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: "Revenue Forecast"
            })
        }),
        extraContent: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $heNWk.default), {
            store: store,
            report: store.report,
            reportOptions: (0, $1k348.default).revenueForecastReports.filter((r)=>!r.deletedAt),
            baseUrl: "/projects"
        }),
        rightButtons: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            className: "flex gap-2 items-center",
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    className: "export-button-dropdown inline-flex items-center dont-print gap-2",
                    children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3X7oM.default), {
                                label: "Export",
                                icon: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                    className: "fa fa-table"
                                }),
                                onClick: ()=>{
                                    store.downloadCSV();
                                },
                                className: "border-r-0 rounded-tr-none rounded-br-none"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                                className: " border! border-white bg-transparent hover:bg-white/25 transition-colors rounded-[6px] rounded-tl-none rounded-bl-none",
                                style: {
                                    maxWidth: "8em",
                                    margin: 0,
                                    fontSize: "1em",
                                    background: "transparent"
                                },
                                value: store.exportGroup,
                                options: [
                                    "Projects",
                                    "Phases"
                                ],
                                optionLabel: function(group) {
                                    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        children: group
                                    });
                                },
                                onChange: (group)=>store.setExportGroup(group)
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3X7oM.default), {
                    label: "Print",
                    icon: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                        className: "fa fa-print"
                    }),
                    onClick: ()=>window.print()
                })
            ]
        })
    });
});

});
parcelRegister("heNWk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8ca7b7db3790f34$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $02LyB = parcelRequire("02LyB");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("h6zQv");

var $khJQv = parcelRequire("khJQv");

var $e8Hda = parcelRequire("e8Hda");
parcelRequire("fEtu5");
var $avIhR = parcelRequire("avIhR");
var $e4TNX = parcelRequire("e4TNX");
parcelRequire("cnmvx");
parcelRequire("ek5Pm");

var $c86dX = parcelRequire("c86dX");
parcelRequire("dtopU");

var $eRflC = parcelRequire("eRflC");

var $fM2j4 = parcelRequire("fM2j4");

var $8ppo6 = parcelRequire("8ppo6");

var $52dEm = parcelRequire("52dEm");

var $eNcHX = parcelRequire("eNcHX");

var $gJT7h = parcelRequire("gJT7h");

var $htkeB = parcelRequire("htkeB");

var $1UDCR = parcelRequire("1UDCR");

var $ewAM3 = parcelRequire("ewAM3");

var $3X7oM = parcelRequire("3X7oM");

var $6UBLf = parcelRequire("6UBLf");

var $eat5C = parcelRequire("eat5C");
var $c8ca7b7db3790f34$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ store: store, report: report, reportOptions: reportOptions = [] })=>{
    const [expandReportEditor, setExpandReportEditor] = (0, $jbmdS.useState)(false);
    const navigate = (0, $6UBLf.useNavigate)();
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "report-selector flex items-center gap-2 mt-7",
                children: [
                    "Report: ",
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                        className: "flex-0-0-auto page-header__button",
                        style: {
                            marginLeft: "1em"
                        },
                        value: report,
                        options: reportOptions,
                        searchMatcher: function(report, searchText) {
                            return (0, $e8Hda.caseInsensitiveContains)(report.name, searchText);
                        },
                        optionLabel: function(report) {
                            return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                children: report.name
                            });
                        },
                        onChange: (report)=>navigate({
                                search: (prev)=>({
                                        ...prev,
                                        report: report.id
                                    })
                            })
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3X7oM.default), {
                                label: expandReportEditor ? "Hide " : "Edit ",
                                icon: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("fa m-0", expandReportEditor ? "fa-angle-double-up" : "fa-angle-double-down")
                                }),
                                onClick: ()=>setExpandReportEditor(!expandReportEditor)
                            }),
                            expandReportEditor ? /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)($c8ca7b7db3790f34$var$ReportSaveDropdown, {
                                        report: report
                                    }),
                                    !report.systemReport ? /*#__PURE__*/ (0, $61Ea1.jsx)($c8ca7b7db3790f34$var$ReportActionsDropdown, {
                                        report: report
                                    }) : null
                                ]
                            }) : null
                        ]
                    })
                ]
            }),
            expandReportEditor ? /*#__PURE__*/ (0, $61Ea1.jsx)($c8ca7b7db3790f34$var$ReportEditor, {
                store: store,
                report: report
            }) : null
        ]
    });
});
const $c8ca7b7db3790f34$var$ReportSaveDropdown = (0, $1EEMt.observer)(({ report: report })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $avIhR.Dropdown3), {
        // isExpanded={this.props.isExpanded}
        // onToggle={this.handleToggle}
        toggleElement: /*#__PURE__*/ (0, $61Ea1.jsxs)("button", {
            className: "primary flex items-center gap-1 py-2 px-4 border border-white bg-transparent hover:bg-white/25 transition-colors rounded-[6px] text-xs",
            children: [
                "Save",
                /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                    className: "rw-i rw-i-caret-down"
                })
            ]
        }),
        contentStyle: {
            width: "14em",
            color: "#444",
            borderRadius: "0.5em"
        },
        children: [
            !report.systemReport ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $avIhR.Dropdown3ListItem), {
                style: {
                    padding: "0.5em 1em",
                    height: "2.5em"
                },
                className: "report-save-dropdown__save-option",
                onClick: ()=>(0, $fM2j4.default).saveModel(report),
                children: "Save"
            }) : null,
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $avIhR.Dropdown3ListItem), {
                style: {
                    padding: "0.5em 1em",
                    height: "2.5em"
                },
                onClick: ()=>{
                    (0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $8ppo6.default), {
                        report: report,
                        modalId: "saveAsReport"
                    }));
                },
                children: "Save As..."
            })
        ]
    });
});
const $c8ca7b7db3790f34$var$ReportActionsDropdown = (0, $1EEMt.observer)(({ report: report })=>{
    const navigate = (0, $6UBLf.useNavigate)();
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $avIhR.Dropdown3), {
        // isExpanded={this.props.isExpanded}
        // onToggle={this.handleToggle}
        toggleElement: /*#__PURE__*/ (0, $61Ea1.jsxs)("button", {
            className: "primary flex items-center gap-1 ml-2 py-2 px-4 border border-white bg-transparent hover:bg-white/25 transition-colors rounded-[6px] text-xs",
            children: [
                "Actions",
                /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                    className: "rw-i rw-i-caret-down",
                    style: {
                        marginLeft: "0.5em"
                    }
                })
            ]
        }),
        contentStyle: {
            width: "18em",
            color: "#444",
            borderRadius: "0.5em"
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $avIhR.Dropdown3ListItem), {
                style: {
                    padding: "0.5em 1em",
                    height: "2.5em"
                },
                onClick: ()=>{
                    report.makeDefault();
                    (0, $fM2j4.default).saveModel(report);
                },
                children: "Set As Default"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $avIhR.Dropdown3ListItem), {
                style: {
                    padding: "0.5em 1em",
                    height: "2.5em"
                },
                onClick: ()=>{
                    (0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $eRflC.default), {
                        report: report,
                        modalId: "renameReport"
                    }));
                },
                children: "Rename"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $avIhR.Dropdown3ListItem), {
                style: {
                    padding: "0.5em 1em",
                    height: "2.5em"
                },
                onClick: ()=>{
                    report.update({
                        deletedAt: new Date()
                    });
                    (0, $fM2j4.default).saveModel(report);
                    navigate({
                        search: (prev)=>(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).omitBy({
                                ...prev,
                                report: null
                            }, (v)=>v === null)
                    });
                },
                children: "Delete"
            })
        ]
    });
});
const $c8ca7b7db3790f34$var$ReportEditor = (0, $1EEMt.observer)(({ report: report, store: store })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "dont-print",
        style: {
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            borderRadius: "1em",
            margin: "1em 0"
        },
        children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            children: /*#__PURE__*/ (0, $61Ea1.jsx)($c8ca7b7db3790f34$var$ReportFilterList, {
                store: store,
                report: report,
                filters: report.filters
            })
        })
    });
});
const $c8ca7b7db3790f34$var$ReportFilterList = (0, $1EEMt.observer)(({ filters: filters, store: store, report: report })=>{
    var _filters$costCentres, _filters$projects, _filters$staff, _filters$projectOwner, _filters$expenses;
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "report-selector",
        style: {
            width: "100%",
            marginTop: "1em",
            display: "block",
            padding: "1em"
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "py-[1em] px-[0.5em] flex items-end flex-wrap",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            marginRight: "2em"
                        },
                        children: [
                            "Revenue Data: ",
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                                className: "flex-0-0-auto page-header__button",
                                style: {
                                    margin: "0 0.5em"
                                },
                                value: filters.revenueData,
                                onChange: (revenueData)=>store.updateFilters({
                                        revenueData: revenueData
                                    }),
                                options: [
                                    {
                                        label: "Actuals + Projected",
                                        value: "actualsProjected"
                                    },
                                    {
                                        label: "Actuals",
                                        value: "actuals"
                                    },
                                    {
                                        label: "Projected",
                                        value: "projected"
                                    },
                                    {
                                        label: "Actuals / Projected",
                                        value: "actualsVsProjected"
                                    }
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            marginRight: "2em"
                        },
                        children: [
                            "Profit %: ",
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                                className: "flex-0-0-auto page-header__button",
                                style: {
                                    margin: "0 0.5em"
                                },
                                value: filters.profitDataType,
                                onChange: (profitDataType)=>store.updateFilters({
                                        profitDataType: profitDataType
                                    }),
                                options: [
                                    {
                                        label: "Profit Margin",
                                        value: "margin"
                                    },
                                    {
                                        label: "Markup",
                                        value: "markup"
                                    }
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            marginRight: "2em"
                        },
                        children: [
                            "Invoice: ",
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                                className: "flex-0-0-auto page-header__button",
                                style: {
                                    margin: "0 0.5em"
                                },
                                value: filters.invoiceData,
                                onChange: (invoiceData)=>store.updateFilters({
                                        invoiceData: invoiceData
                                    }),
                                options: [
                                    {
                                        label: "Work Completion",
                                        value: "endDate"
                                    },
                                    {
                                        label: "Issue Date",
                                        value: "issuedOn"
                                    },
                                    {
                                        label: "Due Date",
                                        value: "dueDate"
                                    }
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            marginRight: "2em"
                        },
                        children: [
                            "Totals: ",
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                                className: "flex-0-0-auto page-header__button",
                                style: {
                                    margin: "0 0.5em"
                                },
                                value: filters.totalData,
                                onChange: (totalData)=>store.updateFilters({
                                        totalData: totalData
                                    }),
                                options: [
                                    {
                                        label: "Revenue / Total Fee",
                                        value: "revenueTotalFee"
                                    },
                                    {
                                        label: "Remaining Fee",
                                        value: "remaining"
                                    }
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            marginRight: "2em"
                        },
                        children: [
                            "Contractor Expense: ",
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                                className: "flex-0-0-auto page-header__button",
                                style: {
                                    margin: "0 0.5em"
                                },
                                value: filters.contractorExpense,
                                onChange: (contractorExpense)=>store.updateFilters({
                                        contractorExpense: contractorExpense
                                    }),
                                options: [
                                    {
                                        label: "Available Hours",
                                        value: "availableHours"
                                    },
                                    {
                                        label: "Allocated Hours",
                                        value: "allocatedHours"
                                    }
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            marginRight: "2em"
                        },
                        children: [
                            "Status Group: ",
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                                className: "flex-0-0-auto page-header__button",
                                style: {
                                    margin: "0 0.5em"
                                },
                                value: filters.statusGroup || "phase",
                                onChange: (statusGroup)=>store.updateFilters({
                                        statusGroup: statusGroup
                                    }),
                                options: [
                                    {
                                        label: "Project",
                                        value: "project"
                                    },
                                    {
                                        label: "Phase",
                                        value: "phase"
                                    }
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            marginRight: "2em"
                        },
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                                value: filters.showExpenses,
                                onChange: (showExpenses)=>store.updateFilters({
                                        showExpenses: showExpenses
                                    })
                            }),
                            " Show project expenses."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "flex",
                style: {
                    width: "100%",
                    fontSize: "0.95em"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            width: "20%",
                            padding: "0.5em"
                        },
                        children: [
                            "Cost Centres:",
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $c86dX.CostCentreMultiselect), {
                                selectedCostCentres: ((_filters$costCentres = filters.costCentres) === null || _filters$costCentres === void 0 ? void 0 : _filters$costCentres.map((cId)=>(0, $eNcHX.default).costCentresById[cId])) || [],
                                onChange: (costCentres)=>store.updateFilters({
                                        costCentres: costCentres.map((cc)=>cc.id)
                                    }),
                                onBlur: ()=>null,
                                styles: {
                                    container: (provided, state)=>({
                                            ...provided,
                                            color: "#444"
                                        }),
                                    input: (provided, state)=>({
                                            ...provided,
                                            color: "#444"
                                        }),
                                    menu: (provided, state)=>({
                                            ...provided,
                                            fontSize: "0.9em",
                                            color: "#444"
                                        })
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            width: "20%",
                            padding: "0.5em"
                        },
                        children: [
                            "Status:",
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $c86dX.StatusMultiselect), {
                                selectedStatuses: filters.projectStatus,
                                onChange: (projectStatuses)=>{
                                    return store.updateFilters({
                                        projectStatus: projectStatuses
                                    });
                                },
                                onBlur: ()=>null,
                                styles: {
                                    container: (provided, state)=>({
                                            ...provided,
                                            color: "#444"
                                        }),
                                    input: (provided, state)=>({
                                            ...provided,
                                            color: "#444"
                                        }),
                                    menu: (provided, state)=>({
                                            ...provided,
                                            fontSize: "0.9em",
                                            color: "#444"
                                        })
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            width: "20%",
                            padding: "0.5em"
                        },
                        children: [
                            "Projects:",
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $c86dX.ProjectMultiselect), {
                                selectedProjects: ((_filters$projects = filters.projects) === null || _filters$projects === void 0 ? void 0 : _filters$projects.map((cId)=>(0, $gJT7h.default).projectsById[cId])) || [],
                                onChange: (projects)=>store.updateFilters({
                                        projects: projects.map((p)=>p.id)
                                    }),
                                onBlur: ()=>null,
                                styles: {
                                    container: (provided, state)=>({
                                            ...provided,
                                            color: "#444"
                                        }),
                                    input: (provided, state)=>({
                                            ...provided,
                                            color: "#444"
                                        }),
                                    menu: (provided, state)=>({
                                            ...provided,
                                            fontSize: "0.9em",
                                            color: "#444"
                                        })
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            width: "20%",
                            padding: "0.5em"
                        },
                        children: [
                            "Staff:",
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $c86dX.StaffMultiselect), {
                                selectedStaffMembers: ((_filters$staff = filters.staff) === null || _filters$staff === void 0 ? void 0 : _filters$staff.map((cId)=>(0, $htkeB.default).staffsById[cId])) || [],
                                onChange: (staff)=>store.updateFilters({
                                        staff: staff.map((st)=>st.id)
                                    }),
                                onBlur: ()=>null,
                                styles: {
                                    container: (provided, state)=>({
                                            ...provided,
                                            color: "#444"
                                        }),
                                    input: (provided, state)=>({
                                            ...provided,
                                            color: "#444"
                                        }),
                                    menu: (provided, state)=>({
                                            ...provided,
                                            fontSize: "0.9em",
                                            color: "#444"
                                        })
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            width: "20%",
                            padding: "0.5em"
                        },
                        children: [
                            "Project Owner:",
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $c86dX.StaffMultiselect), {
                                selectedStaffMembers: ((_filters$projectOwner = filters.projectOwners) === null || _filters$projectOwner === void 0 ? void 0 : _filters$projectOwner.map((cId)=>(0, $htkeB.default).staffsById[cId])) || [],
                                onChange: (staff)=>store.updateFilters({
                                        projectOwners: staff.map((st)=>st.id)
                                    }),
                                onBlur: ()=>null,
                                styles: {
                                    container: (provided, state)=>({
                                            ...provided,
                                            color: "#444"
                                        }),
                                    input: (provided, state)=>({
                                            ...provided,
                                            color: "#444"
                                        }),
                                    menu: (provided, state)=>({
                                            ...provided,
                                            fontSize: "0.9em",
                                            color: "#444"
                                        })
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            width: "20%",
                            padding: "0.5em"
                        },
                        children: [
                            "Expenses:",
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $c86dX.OverheadMultiselect), {
                                selectedExpenses: (_filters$expenses = filters.expenses) === null || _filters$expenses === void 0 ? void 0 : _filters$expenses.map((eId)=>(0, $1UDCR.default).overheadExpensesById[eId]).filter(Boolean),
                                onChange: (expenses)=>store.updateFilters({
                                        expenses: expenses.map((e)=>e.id)
                                    }),
                                onBlur: ()=>null,
                                styles: {
                                    container: (provided, state)=>({
                                            ...provided,
                                            color: "#444"
                                        }),
                                    input: (provided, state)=>({
                                            ...provided,
                                            color: "#444"
                                        }),
                                    menu: (provided, state)=>({
                                            ...provided,
                                            fontSize: "0.9em",
                                            color: "#444"
                                        })
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
const $c8ca7b7db3790f34$export$ae9c33d24d74aaae = (0, $1EEMt.observer)(({ report: report, placeholder: placeholder })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $e4TNX.FilterTextBox), {
        style: {
            width: "19em"
        },
        value: report.searchFilter || "",
        onChange: (val)=>report.updateSearchFilter(val),
        placeholder: placeholder
    });
});

});
parcelRegister("eRflC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad11eba5c49f385a$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("gN0TC");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $fEcKX = parcelRequire("fEcKX");

var $fM2j4 = parcelRequire("fM2j4");

var $foLWS = parcelRequire("foLWS");
var $ad11eba5c49f385a$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ report: report, modalId: modalId })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fEcKX.default), {
        modalId: modalId,
        heading: "Rename Report",
        onSave: ()=>(0, $fM2j4.default).saveModel(report),
        saveLabel: "Rename Report",
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: "Please enter new name for this Report:"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $foLWS.default), {
                value: report.name,
                onChange: (v)=>report.update({
                        name: v
                    })
            })
        ]
    });
});

});

parcelRegister("8ppo6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61f45a0821ed89e1$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("gN0TC");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $fEcKX = parcelRequire("fEcKX");

var $fM2j4 = parcelRequire("fM2j4");

var $foLWS = parcelRequire("foLWS");

var $6UBLf = parcelRequire("6UBLf");
parcelRequire("eat5C");
var $61f45a0821ed89e1$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ report: report, modalId: modalId })=>{
    const [newName, setNewName] = (0, $jbmdS.useState)("New Report");
    const navigate = (0, $6UBLf.useNavigate)();
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fEcKX.default), {
        modalId: modalId,
        heading: "Save As...",
        onSave: ()=>{
            const newReport = report.clone({
                name: newName,
                systemReport: false
            }, {
                trackUpdates: true
            });
            (0, $fM2j4.default).saveModel(newReport);
            navigate({
                search: (prev)=>({
                        ...prev,
                        report: newReport.id
                    })
            });
        },
        saveLabel: "Save New Report",
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: "Please enter new name for this Report:"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $foLWS.default), {
                className: "input-base",
                value: newName,
                onChange: (v)=>setNewName(v),
                style: {
                    marginTop: "4px"
                }
            })
        ]
    });
});

});


parcelRegister("hYUed", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d173a80550e88d65$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");
parcelRequire("jbmdS");

var $eat5C = parcelRequire("eat5C");

var $4hBm1 = parcelRequire("4hBm1");

var $1k348 = parcelRequire("1k348");

var $khJQv = parcelRequire("khJQv");

var $1BTI2 = parcelRequire("1BTI2");

var $cV8g5 = parcelRequire("cV8g5");

var $6mjwz = parcelRequire("6mjwz");

var $62nmb = parcelRequire("62nmb");

var $47i9t = parcelRequire("47i9t");

var $6un1H = parcelRequire("6un1H");

var $hdshG = parcelRequire("hdshG");

var $aOFHJ = parcelRequire("aOFHJ");

var $907iH = parcelRequire("907iH");

var $6YofH = parcelRequire("6YofH");

var $Ds2V9 = parcelRequire("Ds2V9");

var $iOQGT = parcelRequire("iOQGT");
parcelRequire("6Q5sp");

var $8kZ1o = parcelRequire("8kZ1o");

var $3h7sC = parcelRequire("3h7sC");
var $d173a80550e88d65$var$_dec, $d173a80550e88d65$var$_dec2, $d173a80550e88d65$var$_dec3, $d173a80550e88d65$var$_dec4, $d173a80550e88d65$var$_dec5, $d173a80550e88d65$var$_dec6, $d173a80550e88d65$var$_dec7, $d173a80550e88d65$var$_dec8, $d173a80550e88d65$var$_dec9, $d173a80550e88d65$var$_class, $d173a80550e88d65$var$_descriptor, $d173a80550e88d65$var$_descriptor2, $d173a80550e88d65$var$_descriptor3, $d173a80550e88d65$var$_descriptor4, $d173a80550e88d65$var$_descriptor5, $d173a80550e88d65$var$_descriptor6, $d173a80550e88d65$var$_descriptor7, $d173a80550e88d65$var$_descriptor8, $d173a80550e88d65$var$_descriptor9, $d173a80550e88d65$var$_descriptor10, $d173a80550e88d65$var$_descriptor11, $d173a80550e88d65$var$_descriptor12, $d173a80550e88d65$var$_descriptor13, $d173a80550e88d65$var$_descriptor14;
function $d173a80550e88d65$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $d173a80550e88d65$var$_defineProperty(e, r, t) {
    return (r = $d173a80550e88d65$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $d173a80550e88d65$var$_toPropertyKey(t) {
    var i = $d173a80550e88d65$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $d173a80550e88d65$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $d173a80550e88d65$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $d173a80550e88d65$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $d173a80550e88d65$var$RevenueForecastStore = ($d173a80550e88d65$var$_dec = (0, $4JcCM.action).bound, $d173a80550e88d65$var$_dec2 = (0, $4JcCM.action).bound, $d173a80550e88d65$var$_dec3 = (0, $4JcCM.action).bound, $d173a80550e88d65$var$_dec4 = (0, $4JcCM.action).bound, $d173a80550e88d65$var$_dec5 = (0, $4JcCM.action).bound, $d173a80550e88d65$var$_dec6 = (0, $4JcCM.action).bound, $d173a80550e88d65$var$_dec7 = (0, $4JcCM.action).bound, $d173a80550e88d65$var$_dec8 = (0, $4JcCM.action).bound, $d173a80550e88d65$var$_dec9 = (0, $4JcCM.action).bound, $d173a80550e88d65$var$_class = class RevenueForecastStore {
    constructor(){
        $d173a80550e88d65$var$_initializerDefineProperty(this, "startDate", $d173a80550e88d65$var$_descriptor, this);
        $d173a80550e88d65$var$_initializerDefineProperty(this, "endDate", $d173a80550e88d65$var$_descriptor2, this);
        $d173a80550e88d65$var$_initializerDefineProperty(this, "selectedObject", $d173a80550e88d65$var$_descriptor3, this);
        $d173a80550e88d65$var$_initializerDefineProperty(this, "selectedMonth", $d173a80550e88d65$var$_descriptor4, this);
        $d173a80550e88d65$var$_initializerDefineProperty(this, "selectedProjectId", $d173a80550e88d65$var$_descriptor5, this);
        $d173a80550e88d65$var$_initializerDefineProperty(this, "selectedPhaseId", $d173a80550e88d65$var$_descriptor6, this);
        $d173a80550e88d65$var$_initializerDefineProperty(this, "isPrinting", $d173a80550e88d65$var$_descriptor7, this);
        $d173a80550e88d65$var$_initializerDefineProperty(this, "expandedRevenueRows", $d173a80550e88d65$var$_descriptor8, this);
        $d173a80550e88d65$var$_initializerDefineProperty(this, "queryData", $d173a80550e88d65$var$_descriptor9, this);
        $d173a80550e88d65$var$_initializerDefineProperty(this, "editedRevenue", $d173a80550e88d65$var$_descriptor10, this);
        $d173a80550e88d65$var$_initializerDefineProperty(this, "projectTableStore", $d173a80550e88d65$var$_descriptor11, this);
        $d173a80550e88d65$var$_initializerDefineProperty(this, "searchParams", $d173a80550e88d65$var$_descriptor12, this);
        $d173a80550e88d65$var$_initializerDefineProperty(this, "exportGroup", $d173a80550e88d65$var$_descriptor13, this);
        $d173a80550e88d65$var$_defineProperty(this, "getRevenueRows", (0, $Ds2V9.computedFn)((keyString = "")=>{
            const keys = keyString ? keyString.split(",").filter((v)=>v) : [];
            let rows = this.queryData || [];
            keys.forEach((k)=>{
                var _rows$find;
                rows = (((_rows$find = rows.find((r)=>(r === null || r === void 0 ? void 0 : r.key) === k)) === null || _rows$find === void 0 ? void 0 : _rows$find.children) || [
                    rows.find((r)=>(r === null || r === void 0 ? void 0 : r.key) === k)
                ]).filter((v)=>v);
            });
            rows = rows.filter((r)=>{
                return r.title !== "(No Project)";
            });
            return rows || [];
        }));
        $d173a80550e88d65$var$_defineProperty(this, "getAllLeafResourceRows", (0, $Ds2V9.computedFn)(()=>{
            let rows = this.queryData || [];
            while((_rows$ = rows[0]) !== null && _rows$ !== void 0 && _rows$.children){
                var _rows$;
                rows = rows.flatMap((r)=>r.children);
            }
            return rows;
        }));
        $d173a80550e88d65$var$_defineProperty(this, "getLeafRevenueRows", (0, $Ds2V9.computedFn)((keyString = "")=>{
            const rows = this.getAllLeafResourceRows();
            const keys = (keyString === null || keyString === void 0 ? void 0 : keyString.split(",").filter((v)=>v)) || [];
            return rows.filter((r)=>keys.every((k)=>r.fullPath.includes(k)));
        }));
        $d173a80550e88d65$var$_defineProperty(this, "getEditedRevenueData", (0, $Ds2V9.computedFn)((keyString = "")=>{
            const rows = this.getLeafRevenueRows(keyString);
            return rows.flatMap((r)=>this.editedRevenue[r.fullPath] || []);
        }));
        $d173a80550e88d65$var$_defineProperty(this, "getRowRevenueData", (0, $Ds2V9.computedFn)((keyString = "")=>{
            const rows = this.getLeafRevenueRows(keyString);
            return rows.flatMap((r)=>r.data || []);
        }));
        $d173a80550e88d65$var$_defineProperty(this, "getTotalFee", (0, $Ds2V9.computedFn)((keyString = "")=>{
            const phases = this.getLeafRevenueRows(keyString);
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(phases.map((b)=>{
                var _b$likelihood;
                const useLikelihood = [
                    "prospective",
                    "onHold"
                ].includes(b.status);
                const likelihood = useLikelihood ? (_b$likelihood = b.likelihood) !== null && _b$likelihood !== void 0 ? _b$likelihood : 1 : 1;
                return (b.fee || 0) * likelihood;
            }));
        }));
        $d173a80550e88d65$var$_defineProperty(this, "getLikelihood", (0, $Ds2V9.computedFn)((keyString = "")=>{
            const phases = this.getRowRevenueData(keyString).filter((b)=>b.type === "phase");
            if (!phases.length) return 1;
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).mean(phases.map((b)=>{
                var _b$likelihood2;
                const useLikelihood = [
                    "prospective",
                    "onHold"
                ].includes(b.status);
                return useLikelihood ? (_b$likelihood2 = b.likelihood) !== null && _b$likelihood2 !== void 0 ? _b$likelihood2 : 1 : 1;
            }));
        }));
        $d173a80550e88d65$var$_defineProperty(this, "getEditedRevenueDataInMonth", (0, $Ds2V9.computedFn)((keyString = "", month)=>{
            return this.getEditedRevenueData(keyString).filter((d)=>d.month === month);
        }));
        $d173a80550e88d65$var$_defineProperty(this, "getRevenueDataInMonth", (0, $Ds2V9.computedFn)((keyString = "", month)=>{
            return this.getRowRevenueData(keyString).filter((d)=>{
                return d.month === month;
            });
        }));
        $d173a80550e88d65$var$_defineProperty(this, "getRevenueTargetDataInMonth", (0, $Ds2V9.computedFn)((keyString = "", month)=>{
            return this.getRevenueDataInMonth(keyString, month).filter((d)=>{
                return d.type === "revenueTarget";
            });
        }));
        $d173a80550e88d65$var$_defineProperty(this, "getInvoiceDataInMonth", (0, $Ds2V9.computedFn)((keyString = "", month)=>{
            return this.getRevenueDataInMonth(keyString, month).filter((d)=>{
                return d.type === "invoice";
            });
        }));
        $d173a80550e88d65$var$_defineProperty(this, "getChangeLogDataInMonth", (0, $Ds2V9.computedFn)((keyString = "", month)=>{
            return this.getRevenueDataInMonth(keyString, month).filter((d)=>{
                return d.type === "changeLog";
            });
        }));
        $d173a80550e88d65$var$_defineProperty(this, "getExpenseDataInMonth", (0, $Ds2V9.computedFn)((keyString = "", month)=>{
            return this.getRevenueDataInMonth(keyString, month).filter((d)=>{
                return d.type === "changeLog" || d.type === "expenseAllocation";
            });
        }));
        $d173a80550e88d65$var$_defineProperty(this, "getProspectiveRevenueTargetDataInMonth", (0, $Ds2V9.computedFn)((keyString = "", month)=>{
            return [
                ...this.getRevenueTargetDataInMonth(keyString, month).filter((d)=>{
                    return d.status === "prospective";
                }),
                ...this.getEditedRevenueDataInMonth(keyString, month).filter((d)=>{
                    return d.status === "prospective";
                })
            ];
        }));
        $d173a80550e88d65$var$_defineProperty(this, "getProspectiveRevenueInMonth", (0, $Ds2V9.computedFn)((keyString = "", month)=>{
            const thisMonth = (0, $4hBm1.format)(new Date(), "yyyy-MM");
            if (month < thisMonth) return 0;
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.getProspectiveRevenueTargetDataInMonth(keyString, month).map((b)=>{
                var _b$likelihood3;
                const useLikelihood = [
                    "prospective",
                    "onHold"
                ].includes(b.status);
                const likelihood = useLikelihood ? (_b$likelihood3 = b.likelihood) !== null && _b$likelihood3 !== void 0 ? _b$likelihood3 : 1 : 1;
                return b.revenue * likelihood;
            }));
        }));
        $d173a80550e88d65$var$_defineProperty(this, "getEditedRevenueInMonth", (0, $Ds2V9.computedFn)((keyString = "", month)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.getEditedRevenueDataInMonth(keyString, month).map((b)=>{
                var _b$likelihood4;
                const useLikelihood = [
                    "prospective",
                    "onHold"
                ].includes(b.status);
                const likelihood = useLikelihood ? (_b$likelihood4 = b.likelihood) !== null && _b$likelihood4 !== void 0 ? _b$likelihood4 : 1 : 1;
                return b.revenue * likelihood;
            }));
        }));
        $d173a80550e88d65$var$_defineProperty(this, "getRevenueTargetRevenueInMonth", (0, $Ds2V9.computedFn)((keyString = "", month)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.getRevenueTargetDataInMonth(keyString, month).map((b)=>{
                var _b$likelihood5;
                const useLikelihood = [
                    "prospective",
                    "onHold"
                ].includes(b.status);
                const likelihood = useLikelihood ? (_b$likelihood5 = b.likelihood) !== null && _b$likelihood5 !== void 0 ? _b$likelihood5 : 1 : 1;
                return b.revenue * likelihood;
            }));
        }));
        $d173a80550e88d65$var$_defineProperty(this, "getInvoiceRevenueInMonth", (0, $Ds2V9.computedFn)((keyString = "", month)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.getInvoiceDataInMonth(keyString, month).map((d)=>d.revenue));
        }));
        $d173a80550e88d65$var$_defineProperty(this, "getChangeLogRevenueInMonth", (0, $Ds2V9.computedFn)((keyString = "", month)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.getChangeLogDataInMonth(keyString, month).map((d)=>d.revenue));
        }));
        $d173a80550e88d65$var$_defineProperty(this, "getExpensesInMonth", (0, $Ds2V9.computedFn)((keyString = "", month)=>{
            if (!this.report.filters.showExpenses) return 0;
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.getExpenseDataInMonth(keyString, month).map((d)=>d.expenses));
        }));
        $d173a80550e88d65$var$_defineProperty(this, "getRevenueInMonth", (0, $Ds2V9.computedFn)((keyString = "", month, revenueData)=>{
            var _revenueData;
            const phases = this.getLeafRevenueRows(keyString);
            if (phases.length > 1) return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(phases.map((p)=>this.getRevenueInMonth(p.fullPath, month, revenueData)));
            (_revenueData = revenueData) !== null && _revenueData !== void 0 ? _revenueData : revenueData = this.report.filters.revenueData;
            const thisMonth = (0, $4hBm1.format)(new Date(), "yyyy-MM");
            const isPastMonth = month < thisMonth;
            const isFutureMonth = month > thisMonth;
            const isCurrentMonth = month === thisMonth;
            if (revenueData === "projected") return this.getRevenueTargetRevenueInMonth(keyString, month) + this.getEditedRevenueInMonth(keyString, month);
            if (revenueData === "actuals") return this.getInvoiceRevenueInMonth(keyString, month) + this.getChangeLogRevenueInMonth(keyString, month) - this.getExpensesInMonth(keyString, month);
            if (isPastMonth) return this.getInvoiceRevenueInMonth(keyString, month) + this.getChangeLogRevenueInMonth(keyString, month) - this.getExpensesInMonth(keyString, month);
            if (isFutureMonth) return this.getRevenueTargetRevenueInMonth(keyString, month) + this.getEditedRevenueInMonth(keyString, month);
            if (isCurrentMonth) return Math.max(this.getRevenueTargetRevenueInMonth(keyString, month) + this.getEditedRevenueInMonth(keyString, month), this.getInvoiceRevenueInMonth(keyString, month) + this.getChangeLogRevenueInMonth(keyString, month) - this.getExpensesInMonth(keyString, month));
        }));
        $d173a80550e88d65$var$_defineProperty(this, "getRevenueToDateInMonth", (0, $Ds2V9.computedFn)((keyString = "", month)=>{
            const months = this.dataMonths.filter((m)=>m <= month);
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(months.map((m)=>this.getRevenueInMonth(keyString, m, null)));
        }));
        $d173a80550e88d65$var$_defineProperty(this, "getTotalRevenue", (0, $Ds2V9.computedFn)((keyString = "")=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.dataMonths.map((m)=>this.getRevenueInMonth(keyString, m, null)));
        }));
        $d173a80550e88d65$var$_initializerDefineProperty(this, "updateRows", $d173a80550e88d65$var$_descriptor14, this);
        (0, $4JcCM.makeObservable)(this);
        this.projectTableStore = new (0, $hdshG.default)();
        this.staffTableStore = new (0, $hdshG.default)();
        this.expenseTableStore = new (0, $hdshG.default)();
    }
    init(queryData) {
        this.queryData = queryData;
        this.reset();
    }
    reset() {
        (0, $khJQv.default).toggleSidebar(false);
        this.startDate = (0, $4hBm1.startOfMonth)((0, $4hBm1.subMonths)(new Date(), 3));
        this.endDate = (0, $4hBm1.endOfMonth)((0, $4hBm1.addMonths)(new Date(), 8));
        this.selectedObject = null;
        this.selectedMonth = null;
        this.expandedRevenueRows = new Set();
        this.editedRevenue = {};
    }
    setSearchParams(params) {
        this.searchParams = params;
    }
    expandRevenueRow(row) {
        this.expandedRevenueRows.add(row);
    }
    collapseRevenueRow(row) {
        this.expandedRevenueRows.delete(row);
    }
    setExportGroup(group) {
        this.exportGroup = group;
    }
    get report() {
        var _this$searchParams;
        return (0, $1k348.default).revenueForecastReportsById[(_this$searchParams = this.searchParams) === null || _this$searchParams === void 0 ? void 0 : _this$searchParams.report] || (0, $1BTI2.default).organisation.defaultRevenueForecastReport || {};
    }
    updateFilters(filterData) {
        this.report.updateFilters(filterData);
        this.expandedRevenueRows = new Set();
    }
    get csvLabelColumns() {
        return [
            {
                id: "csvlabel",
                label: "Title",
                type: "text",
                width: 18,
                visible: false,
                editable: (row)=>false,
                value: (row, stores)=>{
                    if (stores.row.group) return stores.row.cells[stores.row.group].formattedValue;
                    if (row.modelType === "overheadExpense") return row.name;
                    if (row.modelType === "staff") return row.fullName;
                    if (row.modelType === "phase") return `${row.project.title}: ${row.title}`;
                    if (row.modelType === "project") return row.title;
                }
            }
        ];
    }
    selectCell(selectedMonth, selectedObject, keyString = "") {
        const keys = keyString.split(",");
        //only show sidebar if it's the first cell selected in session
        if (!this.selectedMonth && !this.selectedObject && selectedMonth && selectedObject && !(0, $khJQv.default).showSidebar) (0, $khJQv.default).toggleSidebar(true);
        this.selectedMonth = selectedMonth;
        this.selectedObject = selectedObject;
        this.selectedProjectId = keys[1];
        this.selectedPhaseId = keys[2];
    }
    shiftSelectedPeriod(amount) {
        this.selectedMonth = (0, $4hBm1.addMonths)(this.selectedMonth, amount);
        if (this.selectedMonth < this.startDate || this.selectedMonth > this.endDate) this.shiftDates(amount);
    }
    shiftDates(amount) {
        this.startDate = (0, $4hBm1.addMonths)(this.startDate, amount);
        this.endDate = (0, $4hBm1.addMonths)(this.endDate, amount);
        let newDates = [];
        if (amount > 0) newDates = [
            (0, $4hBm1.startOfMonth)(this.endDate),
            (0, $4hBm1.endOfMonth)(this.endDate)
        ];
        else newDates = [
            (0, $4hBm1.startOfMonth)(this.startDate),
            (0, $4hBm1.endOfMonth)(this.startDate)
        ];
        this.updateRows();
    }
    downloadCSV() {
        const revPhaseColumns = (0, $aOFHJ.RevenueForecastReportPhaseColumns)(this);
        let revRows = this.getRevenueRows("").flatMap((r)=>r.children);
        // Deduplicate projects by their key when exporting Projects
        if (this.exportGroup === "Projects") {
            const uniqueProjects = new Map();
            revRows.forEach((project)=>{
                if (!uniqueProjects.has(project.key)) uniqueProjects.set(project.key, project);
            });
            revRows = Array.from(uniqueProjects.values());
            // Filter out (No Project) rows
            revRows = revRows.filter((project)=>project.title !== "(No Project)");
        }
        if (this.exportGroup === "Phases") revRows = revRows.flatMap((r)=>r.children.map((c)=>{
                return {
                    ...c,
                    title: `${r.title}: ${c.title}`
                };
            }));
        revRows.sort((a, b)=>{
            var _a$title, _a$title$localeCompar;
            return a === null || a === void 0 ? void 0 : (_a$title = a.title) === null || _a$title === void 0 ? void 0 : (_a$title$localeCompar = _a$title.localeCompare) === null || _a$title$localeCompar === void 0 ? void 0 : _a$title$localeCompar.call(_a$title, b.title);
        });
        const revColumns = [
            {
                id: "title",
                label: "Title",
                type: "text",
                value: (row, stores)=>{
                    return row.title;
                }
            },
            {
                id: "costCentre",
                label: "Cost Centre",
                type: "text",
                value: (row, stores)=>{
                    return (row === null || row === void 0 ? void 0 : row.costCentre) || "Projects";
                }
            },
            ...[
                ...Array(12)
            ].map((v, i)=>{
                return revPhaseColumns.csvRevenue((0, $4hBm1.addMonths)(this.startDate, i), {}, {});
            })
        ];
        const revTableStore = new (0, $hdshG.default)();
        revTableStore.update({
            columns: revColumns,
            rows: revRows
        });
        const staffColumnDefs = (0, $907iH.RevenueForecastReportStaffColumns)(this);
        const staffTableStore = new (0, $hdshG.default)();
        const staffColumns = [
            staffColumnDefs.title(),
            {
                id: "costCentre",
                label: "Cost Centre",
                type: "text",
                value: (row, stores)=>{
                    var _row$costCentre;
                    return ((_row$costCentre = row.costCentre) === null || _row$costCentre === void 0 ? void 0 : _row$costCentre.name) || "Staff";
                }
            },
            ...[
                ...Array(12)
            ].map((v, i)=>{
                return staffColumnDefs.cost((0, $4hBm1.addMonths)(this.startDate, i), this);
            })
        ];
        const staffRows = this.getStaffRows();
        staffTableStore.update({
            columns: staffColumns,
            rows: staffRows
        });
        const overheadColumnDefs = (0, $6YofH.RevenueForecastReportOverheadColumns)(this);
        const overheadTableStore = new (0, $hdshG.default)();
        const overheadColumns = [
            overheadColumnDefs.title(),
            {
                id: "costCentre",
                label: "Cost Centre",
                type: "text",
                value: (row, stores)=>{
                    var _row$costCentre2;
                    return ((_row$costCentre2 = row.costCentre) === null || _row$costCentre2 === void 0 ? void 0 : _row$costCentre2.name) || "Expenses";
                }
            },
            ...[
                ...Array(12)
            ].map((v, i)=>{
                return overheadColumnDefs.cost((0, $4hBm1.addMonths)(this.startDate, i), this);
            })
        ];
        const overheadRows = this.getOverheadRows();
        overheadTableStore.update({
            columns: overheadColumns,
            rows: overheadRows,
            groupBy: [
                "title"
            ]
        });
        const rows = [
            ...revTableStore.getCsvData()
        ];
        if ((0, $8kZ1o.canViewRevenueForecastStaffExpenses)((0, $1BTI2.default).user) && (0, $8kZ1o.canViewStaffPayRate)((0, $1BTI2.default).user)) rows.push(...staffTableStore.getCsvData({
            includeHeadings: false
        }));
        if ((0, $8kZ1o.canViewRevenueForecastOperationalExpenses)((0, $1BTI2.default).user)) rows.push(...overheadTableStore.getCsvData({
            includeHeadings: false
        }));
        (0, (/*@__PURE__*/$parcel$interopDefault($cV8g5)))((0, (/*@__PURE__*/$parcel$interopDefault($6mjwz))).unparse(rows), `${this.report.name}.csv`, "text/csv");
    }
    makeQueryKey(base) {
        return base + this.report.queryKey;
    }
    get fetchedProjectIds() {
        return this.queryData.flatMap((r)=>r.children).map((r)=>r.key);
    }
    setEditedRevenueData(keyString = "", month, revenue, afterEdit) {
        const rows = this.getLeafRevenueRows(keyString).filter((r)=>{
            return r.status != undefined && r.status !== "archived" && !r.isRootPhase && r.isRootPhase != undefined;
        });
        const existingRevenue = this.getRevenueInMonth(keyString, month, null);
        const ratio = existingRevenue && revenue / existingRevenue;
        rows.forEach((r)=>{
            var _this$editedRevenue, _r$fullPath, _this$editedRevenue$_;
            const rExistingRevenue = this.getRevenueInMonth(r.fullPath, month, null);
            const likelihood = this.getLikelihood(r.fullPath);
            let newRevenue = (ratio ? rExistingRevenue * ratio : revenue / rows.length) / likelihood;
            newRevenue = isFinite(newRevenue) ? newRevenue : 0;
            (_this$editedRevenue$_ = (_this$editedRevenue = this.editedRevenue)[_r$fullPath = r.fullPath]) !== null && _this$editedRevenue$_ !== void 0 ? _this$editedRevenue$_ : _this$editedRevenue[_r$fullPath] = [];
            this.editedRevenue[r.fullPath] = this.editedRevenue[r.fullPath].filter((h)=>h.month !== month);
            this.editedRevenue[r.fullPath].push({
                fullPath: r.fullPath,
                month: month,
                revenue: newRevenue,
                status: r.status
            });
            r.data = r.data.filter((d)=>!(d.month === month && d.type === "revenueTarget"));
            if (afterEdit && this.selectedProjectId) {
                let ids = r.fullPath.split(",");
                afterEdit(month, newRevenue, ids[1], ids[2]);
            }
        });
    }
    get dataMonths() {
        return [
            ...new Set([
                ...this.getRowRevenueData(null),
                ...this.getEditedRevenueData(null)
            ].map((d)=>d.month))
        ].filter((v)=>v);
    }
    getStaffData() {
        let id = "staff-cost";
        return (0, $6un1H.default).getResponse(this.makeQueryKey(id)) || [];
    }
    getStaffRows() {
        var _this$getStaffData, _this$getStaffData$st;
        return ((_this$getStaffData = this.getStaffData()) === null || _this$getStaffData === void 0 ? void 0 : (_this$getStaffData$st = _this$getStaffData.staff) === null || _this$getStaffData$st === void 0 ? void 0 : _this$getStaffData$st.staff) || [];
    }
    async staffRowQuery() {
        let id = "staff-cost";
        id = this.makeQueryKey(id);
        const reportFilters = this.report.filters;
        const data = await (0, $3h7sC.trpc).legacy.getStaffRowData.query({
            filters: reportFilters,
            startDate: this.startDate,
            endDate: this.endDate
        });
        return (0, $47i9t.processTRPCData)(data, id);
    }
    getOverheadRows() {
        var _FetchStore$getRespon, _FetchStore$getRespon2;
        let id = "overhead-cost";
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).uniq(((_FetchStore$getRespon = (0, $6un1H.default).getResponse(this.makeQueryKey(id))) === null || _FetchStore$getRespon === void 0 ? void 0 : (_FetchStore$getRespon2 = _FetchStore$getRespon.overheadExpenses) === null || _FetchStore$getRespon2 === void 0 ? void 0 : _FetchStore$getRespon2.overheadExpenses) || []).map((e)=>e.name);
    }
    async overheadRowQuery() {
        let id = "overhead-cost";
        id = this.makeQueryKey(id);
        const reportFilters = this.report.filters;
        const data = await (0, $3h7sC.trpc).legacy.getOverheadRowData.query({
            filters: reportFilters,
            startDate: this.startDate,
            endDate: this.endDate
        });
        return (0, $47i9t.processTRPCData)(data, id);
    }
    updateQueryData(data) {
        const queryData = this.queryData || [];
        const statusRows = data;
        statusRows.forEach((r)=>{
            let statusRow = queryData.find((q)=>q.key === r.key);
            if (!statusRow) queryData.push(r);
            r.children.forEach((c)=>{
                let childRow = statusRow === null || statusRow === void 0 ? void 0 : statusRow.children.find((q)=>q.key === c.key);
                if (!childRow) statusRow === null || statusRow === void 0 || statusRow.children.push(c);
            });
        });
        requestIdleCallback(()=>{
            this.queryData = queryData;
        });
    }
}, $d173a80550e88d65$var$_descriptor = $d173a80550e88d65$var$_applyDecoratedDescriptor($d173a80550e88d65$var$_class.prototype, "startDate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return (0, $4hBm1.startOfMonth)((0, $4hBm1.subMonths)(new Date(), 3));
    }
}), $d173a80550e88d65$var$_descriptor2 = $d173a80550e88d65$var$_applyDecoratedDescriptor($d173a80550e88d65$var$_class.prototype, "endDate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return (0, $4hBm1.endOfMonth)((0, $4hBm1.addMonths)(new Date(), 8));
    }
}), $d173a80550e88d65$var$_descriptor3 = $d173a80550e88d65$var$_applyDecoratedDescriptor($d173a80550e88d65$var$_class.prototype, "selectedObject", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d173a80550e88d65$var$_descriptor4 = $d173a80550e88d65$var$_applyDecoratedDescriptor($d173a80550e88d65$var$_class.prototype, "selectedMonth", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d173a80550e88d65$var$_descriptor5 = $d173a80550e88d65$var$_applyDecoratedDescriptor($d173a80550e88d65$var$_class.prototype, "selectedProjectId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d173a80550e88d65$var$_descriptor6 = $d173a80550e88d65$var$_applyDecoratedDescriptor($d173a80550e88d65$var$_class.prototype, "selectedPhaseId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d173a80550e88d65$var$_descriptor7 = $d173a80550e88d65$var$_applyDecoratedDescriptor($d173a80550e88d65$var$_class.prototype, "isPrinting", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $d173a80550e88d65$var$_descriptor8 = $d173a80550e88d65$var$_applyDecoratedDescriptor($d173a80550e88d65$var$_class.prototype, "expandedRevenueRows", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Set();
    }
}), $d173a80550e88d65$var$_descriptor9 = $d173a80550e88d65$var$_applyDecoratedDescriptor($d173a80550e88d65$var$_class.prototype, "queryData", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $d173a80550e88d65$var$_descriptor10 = $d173a80550e88d65$var$_applyDecoratedDescriptor($d173a80550e88d65$var$_class.prototype, "editedRevenue", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $d173a80550e88d65$var$_descriptor11 = $d173a80550e88d65$var$_applyDecoratedDescriptor($d173a80550e88d65$var$_class.prototype, "projectTableStore", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d173a80550e88d65$var$_descriptor12 = $d173a80550e88d65$var$_applyDecoratedDescriptor($d173a80550e88d65$var$_class.prototype, "searchParams", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $d173a80550e88d65$var$_descriptor13 = $d173a80550e88d65$var$_applyDecoratedDescriptor($d173a80550e88d65$var$_class.prototype, "exportGroup", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "Projects";
    }
}), $d173a80550e88d65$var$_applyDecoratedDescriptor($d173a80550e88d65$var$_class.prototype, "init", [
    $d173a80550e88d65$var$_dec
], Object.getOwnPropertyDescriptor($d173a80550e88d65$var$_class.prototype, "init"), $d173a80550e88d65$var$_class.prototype), $d173a80550e88d65$var$_applyDecoratedDescriptor($d173a80550e88d65$var$_class.prototype, "reset", [
    (0, $4JcCM.action)
], Object.getOwnPropertyDescriptor($d173a80550e88d65$var$_class.prototype, "reset"), $d173a80550e88d65$var$_class.prototype), $d173a80550e88d65$var$_applyDecoratedDescriptor($d173a80550e88d65$var$_class.prototype, "setSearchParams", [
    $d173a80550e88d65$var$_dec2
], Object.getOwnPropertyDescriptor($d173a80550e88d65$var$_class.prototype, "setSearchParams"), $d173a80550e88d65$var$_class.prototype), $d173a80550e88d65$var$_applyDecoratedDescriptor($d173a80550e88d65$var$_class.prototype, "expandRevenueRow", [
    (0, $4JcCM.action)
], Object.getOwnPropertyDescriptor($d173a80550e88d65$var$_class.prototype, "expandRevenueRow"), $d173a80550e88d65$var$_class.prototype), $d173a80550e88d65$var$_applyDecoratedDescriptor($d173a80550e88d65$var$_class.prototype, "collapseRevenueRow", [
    (0, $4JcCM.action)
], Object.getOwnPropertyDescriptor($d173a80550e88d65$var$_class.prototype, "collapseRevenueRow"), $d173a80550e88d65$var$_class.prototype), $d173a80550e88d65$var$_applyDecoratedDescriptor($d173a80550e88d65$var$_class.prototype, "setExportGroup", [
    $d173a80550e88d65$var$_dec3
], Object.getOwnPropertyDescriptor($d173a80550e88d65$var$_class.prototype, "setExportGroup"), $d173a80550e88d65$var$_class.prototype), $d173a80550e88d65$var$_applyDecoratedDescriptor($d173a80550e88d65$var$_class.prototype, "report", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($d173a80550e88d65$var$_class.prototype, "report"), $d173a80550e88d65$var$_class.prototype), $d173a80550e88d65$var$_applyDecoratedDescriptor($d173a80550e88d65$var$_class.prototype, "updateFilters", [
    $d173a80550e88d65$var$_dec4
], Object.getOwnPropertyDescriptor($d173a80550e88d65$var$_class.prototype, "updateFilters"), $d173a80550e88d65$var$_class.prototype), $d173a80550e88d65$var$_applyDecoratedDescriptor($d173a80550e88d65$var$_class.prototype, "csvLabelColumns", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($d173a80550e88d65$var$_class.prototype, "csvLabelColumns"), $d173a80550e88d65$var$_class.prototype), $d173a80550e88d65$var$_applyDecoratedDescriptor($d173a80550e88d65$var$_class.prototype, "selectCell", [
    $d173a80550e88d65$var$_dec5
], Object.getOwnPropertyDescriptor($d173a80550e88d65$var$_class.prototype, "selectCell"), $d173a80550e88d65$var$_class.prototype), $d173a80550e88d65$var$_applyDecoratedDescriptor($d173a80550e88d65$var$_class.prototype, "shiftSelectedPeriod", [
    $d173a80550e88d65$var$_dec6
], Object.getOwnPropertyDescriptor($d173a80550e88d65$var$_class.prototype, "shiftSelectedPeriod"), $d173a80550e88d65$var$_class.prototype), $d173a80550e88d65$var$_applyDecoratedDescriptor($d173a80550e88d65$var$_class.prototype, "shiftDates", [
    $d173a80550e88d65$var$_dec7
], Object.getOwnPropertyDescriptor($d173a80550e88d65$var$_class.prototype, "shiftDates"), $d173a80550e88d65$var$_class.prototype), $d173a80550e88d65$var$_applyDecoratedDescriptor($d173a80550e88d65$var$_class.prototype, "downloadCSV", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($d173a80550e88d65$var$_class.prototype, "downloadCSV"), $d173a80550e88d65$var$_class.prototype), $d173a80550e88d65$var$_applyDecoratedDescriptor($d173a80550e88d65$var$_class.prototype, "makeQueryKey", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($d173a80550e88d65$var$_class.prototype, "makeQueryKey"), $d173a80550e88d65$var$_class.prototype), $d173a80550e88d65$var$_applyDecoratedDescriptor($d173a80550e88d65$var$_class.prototype, "fetchedProjectIds", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($d173a80550e88d65$var$_class.prototype, "fetchedProjectIds"), $d173a80550e88d65$var$_class.prototype), $d173a80550e88d65$var$_applyDecoratedDescriptor($d173a80550e88d65$var$_class.prototype, "setEditedRevenueData", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($d173a80550e88d65$var$_class.prototype, "setEditedRevenueData"), $d173a80550e88d65$var$_class.prototype), $d173a80550e88d65$var$_applyDecoratedDescriptor($d173a80550e88d65$var$_class.prototype, "dataMonths", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($d173a80550e88d65$var$_class.prototype, "dataMonths"), $d173a80550e88d65$var$_class.prototype), $d173a80550e88d65$var$_applyDecoratedDescriptor($d173a80550e88d65$var$_class.prototype, "getStaffData", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($d173a80550e88d65$var$_class.prototype, "getStaffData"), $d173a80550e88d65$var$_class.prototype), $d173a80550e88d65$var$_applyDecoratedDescriptor($d173a80550e88d65$var$_class.prototype, "getStaffRows", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($d173a80550e88d65$var$_class.prototype, "getStaffRows"), $d173a80550e88d65$var$_class.prototype), $d173a80550e88d65$var$_applyDecoratedDescriptor($d173a80550e88d65$var$_class.prototype, "staffRowQuery", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($d173a80550e88d65$var$_class.prototype, "staffRowQuery"), $d173a80550e88d65$var$_class.prototype), $d173a80550e88d65$var$_applyDecoratedDescriptor($d173a80550e88d65$var$_class.prototype, "getOverheadRows", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($d173a80550e88d65$var$_class.prototype, "getOverheadRows"), $d173a80550e88d65$var$_class.prototype), $d173a80550e88d65$var$_applyDecoratedDescriptor($d173a80550e88d65$var$_class.prototype, "overheadRowQuery", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($d173a80550e88d65$var$_class.prototype, "overheadRowQuery"), $d173a80550e88d65$var$_class.prototype), $d173a80550e88d65$var$_descriptor14 = $d173a80550e88d65$var$_applyDecoratedDescriptor($d173a80550e88d65$var$_class.prototype, "updateRows", [
    $d173a80550e88d65$var$_dec8
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).debounce(()=>{
            var _SessionStore$user;
            this.staffRowQuery();
            this.overheadRowQuery();
            // fetchData(this.overheadRowQuery())
            (0, $iOQGT.makeRequest)({
                id: `revenueTable` + this.report.queryKey,
                baseURL: "https://server2.coincraft.co",
                path: `/revenue-forecast/table`,
                method: "POST",
                data: {
                    organisationId: (0, $1BTI2.default).organisationId,
                    userId: (_SessionStore$user = (0, $1BTI2.default).user) === null || _SessionStore$user === void 0 ? void 0 : _SessionStore$user.id,
                    filters: this.report.filters,
                    level: 0,
                    parentData: {},
                    dateRange: [
                        (0, $4hBm1.format)(this.startDate, "yyyy-MM-dd"),
                        (0, $4hBm1.format)(this.endDate, "yyyy-MM-dd")
                    ],
                    existingProjectIds: this.fetchedProjectIds
                }
            }).then((r)=>{
                this.updateQueryData(r.data);
            });
        }, 500);
    }
}), $d173a80550e88d65$var$_applyDecoratedDescriptor($d173a80550e88d65$var$_class.prototype, "updateQueryData", [
    $d173a80550e88d65$var$_dec9
], Object.getOwnPropertyDescriptor($d173a80550e88d65$var$_class.prototype, "updateQueryData"), $d173a80550e88d65$var$_class.prototype), $d173a80550e88d65$var$_class);
var $d173a80550e88d65$export$2e2bcd8739ae039 = new $d173a80550e88d65$var$RevenueForecastStore();

});
parcelRegister("cV8g5", function(module, exports) {
//download.js v4.2, by dandavis; 2008-2016. [MIT] see http://danml.com/download.html for tests/usage
// v1 landed a FF+Chrome compat way of downloading strings to local un-named files, upgraded to use a hidden frame and optional mime
// v2 added named files via a[download], msSaveBlob, IE (10+) support, and window.URL support for larger+faster saves than dataURLs
// v3 added dataURL and Blob Input, bind-toggle arity, and legacy dataURL fallback was improved with force-download mime and base64 support. 3.1 improved safari handling.
// v4 adds AMD/UMD, commonJS, and plain browser support
// v4.1 adds url download capability via solo URL argument (same domain/CORS only)
// v4.2 adds semantic variable names, long (over 2MB) dataURL support, and hidden by default temp anchors
// https://github.com/rndme/download
(function(root, factory) {
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([], factory);
    else // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
})(module.exports, function() {
    return function download(data, strFileName, strMimeType) {
        var self = window, defaultMime = "application/octet-stream", mimeType = strMimeType || defaultMime, payload = data, url = !strFileName && !strMimeType && payload, anchor = document.createElement("a"), toString = function(a) {
            return String(a);
        }, myBlob = self.Blob || self.MozBlob || self.WebKitBlob || toString, fileName = strFileName || "download", blob, reader;
        myBlob = myBlob.call ? myBlob.bind(self) : Blob;
        if (String(this) === "true") {
            payload = [
                payload,
                mimeType
            ];
            mimeType = payload[0];
            payload = payload[1];
        }
        if (url && url.length < 2048) {
            fileName = url.split("/").pop().split("?")[0];
            anchor.href = url; // assign href prop to temp anchor
            if (anchor.href.indexOf(url) !== -1) {
                var ajax = new XMLHttpRequest();
                ajax.open("GET", url, true);
                ajax.responseType = "blob";
                ajax.onload = function(e) {
                    download(e.target.response, fileName, defaultMime);
                };
                setTimeout(function() {
                    ajax.send();
                }, 0); // allows setting custom ajax headers using the return:
                return ajax;
            } // end if valid url?
        } // end if url?
        //go ahead and download dataURLs right away
        if (/^data:([\w+-]+\/[\w+.-]+)?[,;]/.test(payload)) {
            if (payload.length > 2096103.424 && myBlob !== toString) {
                payload = dataUrlToBlob(payload);
                mimeType = payload.type || defaultMime;
            } else return navigator.msSaveBlob ? navigator.msSaveBlob(dataUrlToBlob(payload), fileName) : saver(payload); // everyone else can save dataURLs un-processed
        } else if (/([\x80-\xff])/.test(payload)) {
            var i = 0, tempUiArr = new Uint8Array(payload.length), mx = tempUiArr.length;
            for(i; i < mx; ++i)tempUiArr[i] = payload.charCodeAt(i);
            payload = new myBlob([
                tempUiArr
            ], {
                type: mimeType
            });
        }
        blob = payload instanceof myBlob ? payload : new myBlob([
            payload
        ], {
            type: mimeType
        });
        function dataUrlToBlob(strUrl) {
            var parts = strUrl.split(/[:;,]/), type = parts[1], decoder = parts[2] == "base64" ? atob : decodeURIComponent, binData = decoder(parts.pop()), mx = binData.length, i = 0, uiArr = new Uint8Array(mx);
            for(i; i < mx; ++i)uiArr[i] = binData.charCodeAt(i);
            return new myBlob([
                uiArr
            ], {
                type: type
            });
        }
        function saver(url, winMode) {
            if ("download" in anchor) {
                anchor.href = url;
                anchor.setAttribute("download", fileName);
                anchor.className = "download-js-link";
                anchor.innerHTML = "downloading...";
                anchor.style.display = "none";
                document.body.appendChild(anchor);
                setTimeout(function() {
                    anchor.click();
                    document.body.removeChild(anchor);
                    if (winMode === true) setTimeout(function() {
                        self.URL.revokeObjectURL(anchor.href);
                    }, 250);
                }, 66);
                return true;
            }
            // handle non-a[download] safari as best we can:
            if (/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)) {
                if (/^data:/.test(url)) url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
                if (!window.open(url)) {
                    if (confirm("Displaying New Document\n\nUse Save As... to download, then click back to return to this page.")) location.href = url;
                }
                return true;
            }
            //do iframe dataURL download (old ch+FF):
            var f = document.createElement("iframe");
            document.body.appendChild(f);
            if (!winMode && /^data:/.test(url)) url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
            f.src = url;
            setTimeout(function() {
                document.body.removeChild(f);
            }, 333);
        } //end saver
        if (navigator.msSaveBlob) return navigator.msSaveBlob(blob, fileName);
        if (self.URL) saver(self.URL.createObjectURL(blob), true);
        else {
            // handle non-Blob()+non-URL browsers:
            if (typeof blob === "string" || blob.constructor === toString) try {
                return saver("data:" + mimeType + ";base64," + self.btoa(blob));
            } catch (y) {
                return saver("data:" + mimeType + "," + encodeURIComponent(blob));
            }
            // Blob but not URL support:
            reader = new FileReader();
            reader.onload = function(e) {
                saver(this.result);
            };
            reader.readAsDataURL(blob);
        }
        return true;
    }; /* end download() */ 
});

});

parcelRegister("6mjwz", function(module, exports) {
/* @license
Papa Parse
v4.6.3
https://github.com/mholt/PapaParse
License: MIT
*/ Array.isArray || (Array.isArray = function(e) {
    return "[object Array]" === Object.prototype.toString.call(e);
}), function(e, t) {
    "function" == typeof define && define.amd ? define([], t) : module.exports = t();
}(module.exports, function() {
    "use strict";
    var s, e, f = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== f ? f : {}, n = !f.document && !!f.postMessage, o = n && /(\?|&)papaworker(=|&|$)/.test(f.location.search), a = !1, h = {}, u = 0, k = {
        parse: function(e, t) {
            var r = (t = t || {}).dynamicTyping || !1;
            z(r) && (t.dynamicTypingFunction = r, r = {});
            if (t.dynamicTyping = r, t.transform = !!z(t.transform) && t.transform, t.worker && k.WORKERS_SUPPORTED) {
                var i = function() {
                    if (!k.WORKERS_SUPPORTED) return !1;
                    if (!a && null === k.SCRIPT_PATH) throw new Error("Script path cannot be determined automatically when Papa Parse is loaded asynchronously. You need to set Papa.SCRIPT_PATH manually.");
                    var e = k.SCRIPT_PATH || s;
                    e += (-1 !== e.indexOf("?") ? "&" : "?") + "papaworker";
                    var t = new f.Worker(e);
                    return t.onmessage = m, t.id = u++, h[t.id] = t;
                }();
                return i.userStep = t.step, i.userChunk = t.chunk, i.userComplete = t.complete, i.userError = t.error, t.step = z(t.step), t.chunk = z(t.chunk), t.complete = z(t.complete), t.error = z(t.error), delete t.worker, void i.postMessage({
                    input: e,
                    config: t,
                    workerId: i.id
                });
            }
            var n = null;
            k.NODE_STREAM_INPUT, "string" == typeof e ? n = t.download ? new c(t) : new _(t) : !0 === e.readable && z(e.read) && z(e.on) ? n = new g(t) : (f.File && e instanceof File || e instanceof Object) && (n = new p(t));
            return n.stream(e);
        },
        unparse: function(e, t) {
            var i = !1, g = !0, m = ",", y = "\r\n", n = '"', r = !1;
            !function() {
                if ("object" != typeof t) return;
                "string" != typeof t.delimiter || k.BAD_DELIMITERS.filter(function(e) {
                    return -1 !== t.delimiter.indexOf(e);
                }).length || (m = t.delimiter);
                ("boolean" == typeof t.quotes || Array.isArray(t.quotes)) && (i = t.quotes);
                "boolean" != typeof t.skipEmptyLines && "string" != typeof t.skipEmptyLines || (r = t.skipEmptyLines);
                "string" == typeof t.newline && (y = t.newline);
                "string" == typeof t.quoteChar && (n = t.quoteChar);
                "boolean" == typeof t.header && (g = t.header);
            }();
            var s = new RegExp(M(n), "g");
            "string" == typeof e && (e = JSON.parse(e));
            if (Array.isArray(e)) {
                if (!e.length || Array.isArray(e[0])) return o(null, e, r);
                if ("object" == typeof e[0]) return o(a(e[0]), e, r);
            } else if ("object" == typeof e) return "string" == typeof e.data && (e.data = JSON.parse(e.data)), Array.isArray(e.data) && (e.fields || (e.fields = e.meta && e.meta.fields), e.fields || (e.fields = Array.isArray(e.data[0]) ? e.fields : a(e.data[0])), Array.isArray(e.data[0]) || "object" == typeof e.data[0] || (e.data = [
                e.data
            ])), o(e.fields || [], e.data || [], r);
            throw "exception: Unable to serialize unrecognized input";
            function a(e) {
                if ("object" != typeof e) return [];
                var t = [];
                for(var r in e)t.push(r);
                return t;
            }
            function o(e, t, r) {
                var i = "";
                "string" == typeof e && (e = JSON.parse(e)), "string" == typeof t && (t = JSON.parse(t));
                var n = Array.isArray(e) && 0 < e.length, s = !Array.isArray(t[0]);
                if (n && g) {
                    for(var a = 0; a < e.length; a++)0 < a && (i += m), i += v(e[a], a);
                    0 < t.length && (i += y);
                }
                for(var o = 0; o < t.length; o++){
                    var h = n ? e.length : t[o].length, u = !1, f = n ? 0 === Object.keys(t[o]).length : 0 === t[o].length;
                    if (r && !n && (u = "greedy" === r ? "" === t[o].join("").trim() : 1 === t[o].length && 0 === t[o][0].length), "greedy" === r && n) {
                        for(var d = [], l = 0; l < h; l++){
                            var c = s ? e[l] : l;
                            d.push(t[o][c]);
                        }
                        u = "" === d.join("").trim();
                    }
                    if (!u) {
                        for(var p = 0; p < h; p++){
                            0 < p && !f && (i += m);
                            var _ = n && s ? e[p] : p;
                            i += v(t[o][_], p);
                        }
                        o < t.length - 1 && (!r || 0 < h && !f) && (i += y);
                    }
                }
                return i;
            }
            function v(e, t) {
                if (null == e) return "";
                if (e.constructor === Date) return JSON.stringify(e).slice(1, 25);
                e = e.toString().replace(s, n + n);
                var r = "boolean" == typeof i && i || Array.isArray(i) && i[t] || function(e, t) {
                    for(var r = 0; r < t.length; r++)if (-1 < e.indexOf(t[r])) return !0;
                    return !1;
                }(e, k.BAD_DELIMITERS) || -1 < e.indexOf(m) || " " === e.charAt(0) || " " === e.charAt(e.length - 1);
                return r ? n + e + n : e;
            }
        }
    };
    if (k.RECORD_SEP = String.fromCharCode(30), k.UNIT_SEP = String.fromCharCode(31), k.BYTE_ORDER_MARK = "\uFEFF", k.BAD_DELIMITERS = [
        "\r",
        "\n",
        '"',
        k.BYTE_ORDER_MARK
    ], k.WORKERS_SUPPORTED = !n && !!f.Worker, k.SCRIPT_PATH = null, k.NODE_STREAM_INPUT = 1, k.LocalChunkSize = 10485760, k.RemoteChunkSize = 5242880, k.DefaultDelimiter = ",", k.Parser = v, k.ParserHandle = r, k.NetworkStreamer = c, k.FileStreamer = p, k.StringStreamer = _, k.ReadableStreamStreamer = g, f.jQuery) {
        var d = f.jQuery;
        d.fn.parse = function(o) {
            var r = o.config || {}, h = [];
            return this.each(function(e) {
                if (!("INPUT" === d(this).prop("tagName").toUpperCase() && "file" === d(this).attr("type").toLowerCase() && f.FileReader) || !this.files || 0 === this.files.length) return !0;
                for(var t = 0; t < this.files.length; t++)h.push({
                    file: this.files[t],
                    inputElem: this,
                    instanceConfig: d.extend({}, r)
                });
            }), e(), this;
            function e() {
                if (0 !== h.length) {
                    var e, t, r, i, n = h[0];
                    if (z(o.before)) {
                        var s = o.before(n.file, n.inputElem);
                        if ("object" == typeof s) {
                            if ("abort" === s.action) return e = "AbortError", t = n.file, r = n.inputElem, i = s.reason, void (z(o.error) && o.error({
                                name: e
                            }, t, r, i));
                            if ("skip" === s.action) return void u();
                            "object" == typeof s.config && (n.instanceConfig = d.extend(n.instanceConfig, s.config));
                        } else if ("skip" === s) return void u();
                    }
                    var a = n.instanceConfig.complete;
                    n.instanceConfig.complete = function(e) {
                        z(a) && a(e, n.file, n.inputElem), u();
                    }, k.parse(n.file, n.instanceConfig);
                } else z(o.complete) && o.complete();
            }
            function u() {
                h.splice(0, 1), e();
            }
        };
    }
    function l(e) {
        this._handle = null, this._finished = !1, this._completed = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = {
            data: [],
            errors: [],
            meta: {}
        }, (function(e) {
            var t = E(e);
            t.chunkSize = parseInt(t.chunkSize), e.step || e.chunk || (t.chunkSize = null);
            this._handle = new r(t), (this._handle.streamer = this)._config = t;
        }).call(this, e), this.parseChunk = function(e, t) {
            if (this.isFirstChunk && z(this._config.beforeFirstChunk)) {
                var r = this._config.beforeFirstChunk(e);
                void 0 !== r && (e = r);
            }
            this.isFirstChunk = !1;
            var i = this._partialLine + e;
            this._partialLine = "";
            var n = this._handle.parse(i, this._baseIndex, !this._finished);
            if (!this._handle.paused() && !this._handle.aborted()) {
                var s = n.meta.cursor;
                this._finished || (this._partialLine = i.substring(s - this._baseIndex), this._baseIndex = s), n && n.data && (this._rowCount += n.data.length);
                var a = this._finished || this._config.preview && this._rowCount >= this._config.preview;
                if (o) f.postMessage({
                    results: n,
                    workerId: k.WORKER_ID,
                    finished: a
                });
                else if (z(this._config.chunk) && !t) {
                    if (this._config.chunk(n, this._handle), this._handle.paused() || this._handle.aborted()) return;
                    n = void 0, this._completeResults = void 0;
                }
                return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(n.data), this._completeResults.errors = this._completeResults.errors.concat(n.errors), this._completeResults.meta = n.meta), this._completed || !a || !z(this._config.complete) || n && n.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), a || n && n.meta.paused || this._nextChunk(), n;
            }
        }, this._sendError = function(e) {
            z(this._config.error) ? this._config.error(e) : o && this._config.error && f.postMessage({
                workerId: k.WORKER_ID,
                error: e,
                finished: !1
            });
        };
    }
    function c(e) {
        var i;
        (e = e || {}).chunkSize || (e.chunkSize = k.RemoteChunkSize), l.call(this, e), this._nextChunk = n ? function() {
            this._readChunk(), this._chunkLoaded();
        } : function() {
            this._readChunk();
        }, this.stream = function(e) {
            this._input = e, this._nextChunk();
        }, this._readChunk = function() {
            if (this._finished) this._chunkLoaded();
            else {
                if (i = new XMLHttpRequest, this._config.withCredentials && (i.withCredentials = this._config.withCredentials), n || (i.onload = w(this._chunkLoaded, this), i.onerror = w(this._chunkError, this)), i.open("GET", this._input, !n), this._config.downloadRequestHeaders) {
                    var e = this._config.downloadRequestHeaders;
                    for(var t in e)i.setRequestHeader(t, e[t]);
                }
                if (this._config.chunkSize) {
                    var r = this._start + this._config.chunkSize - 1;
                    i.setRequestHeader("Range", "bytes=" + this._start + "-" + r), i.setRequestHeader("If-None-Match", "webkit-no-cache");
                }
                try {
                    i.send();
                } catch (e) {
                    this._chunkError(e.message);
                }
                n && 0 === i.status ? this._chunkError() : this._start += this._config.chunkSize;
            }
        }, this._chunkLoaded = function() {
            4 === i.readyState && (i.status < 200 || 400 <= i.status ? this._chunkError() : (this._finished = !this._config.chunkSize || this._start > function(e) {
                var t = e.getResponseHeader("Content-Range");
                if (null === t) return -1;
                return parseInt(t.substr(t.lastIndexOf("/") + 1));
            }(i), this.parseChunk(i.responseText)));
        }, this._chunkError = function(e) {
            var t = i.statusText || e;
            this._sendError(new Error(t));
        };
    }
    function p(e) {
        var i, n;
        (e = e || {}).chunkSize || (e.chunkSize = k.LocalChunkSize), l.call(this, e);
        var s = "undefined" != typeof FileReader;
        this.stream = function(e) {
            this._input = e, n = e.slice || e.webkitSlice || e.mozSlice, s ? ((i = new FileReader).onload = w(this._chunkLoaded, this), i.onerror = w(this._chunkError, this)) : i = new FileReaderSync, this._nextChunk();
        }, this._nextChunk = function() {
            this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
        }, this._readChunk = function() {
            var e = this._input;
            if (this._config.chunkSize) {
                var t = Math.min(this._start + this._config.chunkSize, this._input.size);
                e = n.call(e, this._start, t);
            }
            var r = i.readAsText(e, this._config.encoding);
            s || this._chunkLoaded({
                target: {
                    result: r
                }
            });
        }, this._chunkLoaded = function(e) {
            this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(e.target.result);
        }, this._chunkError = function() {
            this._sendError(i.error);
        };
    }
    function _(e) {
        var r;
        l.call(this, e = e || {}), this.stream = function(e) {
            return r = e, this._nextChunk();
        }, this._nextChunk = function() {
            if (!this._finished) {
                var e = this._config.chunkSize, t = e ? r.substr(0, e) : r;
                return r = e ? r.substr(e) : "", this._finished = !r, this.parseChunk(t);
            }
        };
    }
    function g(e) {
        l.call(this, e = e || {});
        var t = [], r = !0, i = !1;
        this.pause = function() {
            l.prototype.pause.apply(this, arguments), this._input.pause();
        }, this.resume = function() {
            l.prototype.resume.apply(this, arguments), this._input.resume();
        }, this.stream = function(e) {
            this._input = e, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
        }, this._checkIsFinished = function() {
            i && 1 === t.length && (this._finished = !0);
        }, this._nextChunk = function() {
            this._checkIsFinished(), t.length ? this.parseChunk(t.shift()) : r = !0;
        }, this._streamData = w(function(e) {
            try {
                t.push("string" == typeof e ? e : e.toString(this._config.encoding)), r && (r = !1, this._checkIsFinished(), this.parseChunk(t.shift()));
            } catch (e) {
                this._streamError(e);
            }
        }, this), this._streamError = w(function(e) {
            this._streamCleanUp(), this._sendError(e);
        }, this), this._streamEnd = w(function() {
            this._streamCleanUp(), i = !0, this._streamData("");
        }, this), this._streamCleanUp = w(function() {
            this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
        }, this);
    }
    function r(g) {
        var a, o, h, i = /^\s*-?(\d*\.?\d+|\d+\.?\d*)(e[-+]?\d+)?\s*$/i, n = /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))/, t = this, r = 0, s = 0, u = !1, e = !1, f = [], d = {
            data: [],
            errors: [],
            meta: {}
        };
        if (z(g.step)) {
            var l = g.step;
            g.step = function(e) {
                if (d = e, p()) c();
                else {
                    if (c(), 0 === d.data.length) return;
                    r += e.data.length, g.preview && r > g.preview ? o.abort() : l(d, t);
                }
            };
        }
        function m(e) {
            return "greedy" === g.skipEmptyLines ? "" === e.join("").trim() : 1 === e.length && 0 === e[0].length;
        }
        function c() {
            if (d && h && (y("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + k.DefaultDelimiter + "'"), h = !1), g.skipEmptyLines) for(var e = 0; e < d.data.length; e++)m(d.data[e]) && d.data.splice(e--, 1);
            return p() && function() {
                if (!d) return;
                for(var e = 0; p() && e < d.data.length; e++)for(var t = 0; t < d.data[e].length; t++){
                    var r = d.data[e][t];
                    g.trimHeaders && (r = r.trim()), f.push(r);
                }
                d.data.splice(0, 1);
            }(), function() {
                if (!d || !g.header && !g.dynamicTyping && !g.transform) return d;
                for(var e = 0; e < d.data.length; e++){
                    var t, r = g.header ? {} : [];
                    for(t = 0; t < d.data[e].length; t++){
                        var i = t, n = d.data[e][t];
                        g.header && (i = t >= f.length ? "__parsed_extra" : f[t]), g.transform && (n = g.transform(n, i)), n = _(i, n), "__parsed_extra" === i ? (r[i] = r[i] || [], r[i].push(n)) : r[i] = n;
                    }
                    d.data[e] = r, g.header && (t > f.length ? y("FieldMismatch", "TooManyFields", "Too many fields: expected " + f.length + " fields but parsed " + t, s + e) : t < f.length && y("FieldMismatch", "TooFewFields", "Too few fields: expected " + f.length + " fields but parsed " + t, s + e));
                }
                g.header && d.meta && (d.meta.fields = f);
                return s += d.data.length, d;
            }();
        }
        function p() {
            return g.header && 0 === f.length;
        }
        function _(e, t) {
            var r;
            return r = e, g.dynamicTypingFunction && void 0 === g.dynamicTyping[r] && (g.dynamicTyping[r] = g.dynamicTypingFunction(r)), !0 === (g.dynamicTyping[r] || g.dynamicTyping) ? "true" === t || "TRUE" === t || "false" !== t && "FALSE" !== t && (i.test(t) ? parseFloat(t) : n.test(t) ? new Date(t) : "" === t ? null : t) : t;
        }
        function y(e, t, r, i) {
            d.errors.push({
                type: e,
                code: t,
                message: r,
                row: i
            });
        }
        this.parse = function(e, t, r) {
            var i = g.quoteChar || '"';
            if (g.newline || (g.newline = function(e, t) {
                e = e.substr(0, 1048576);
                var r = new RegExp(M(t) + "([^]*?)" + M(t), "gm"), i = (e = e.replace(r, "")).split("\r"), n = e.split("\n"), s = 1 < n.length && n[0].length < i[0].length;
                if (1 === i.length || s) return "\n";
                for(var a = 0, o = 0; o < i.length; o++)"\n" === i[o][0] && a++;
                return a >= i.length / 2 ? "\r\n" : "\r";
            }(e, i)), h = !1, g.delimiter) z(g.delimiter) && (g.delimiter = g.delimiter(e), d.meta.delimiter = g.delimiter);
            else {
                var n = function(e, t, r, i) {
                    for(var n, s, a, o = [
                        ",",
                        "	",
                        "|",
                        ";",
                        k.RECORD_SEP,
                        k.UNIT_SEP
                    ], h = 0; h < o.length; h++){
                        var u = o[h], f = 0, d = 0, l = 0;
                        a = void 0;
                        for(var c = new v({
                            comments: i,
                            delimiter: u,
                            newline: t,
                            preview: 10
                        }).parse(e), p = 0; p < c.data.length; p++)if (r && m(c.data[p])) l++;
                        else {
                            var _ = c.data[p].length;
                            d += _, void 0 !== a ? 1 < _ && (f += Math.abs(_ - a), a = _) : a = 0;
                        }
                        0 < c.data.length && (d /= c.data.length - l), (void 0 === s || s < f) && 1.99 < d && (s = f, n = u);
                    }
                    return {
                        successful: !!(g.delimiter = n),
                        bestDelimiter: n
                    };
                }(e, g.newline, g.skipEmptyLines, g.comments);
                n.successful ? g.delimiter = n.bestDelimiter : (h = !0, g.delimiter = k.DefaultDelimiter), d.meta.delimiter = g.delimiter;
            }
            var s = E(g);
            return g.preview && g.header && s.preview++, a = e, o = new v(s), d = o.parse(a, t, r), c(), u ? {
                meta: {
                    paused: !0
                }
            } : d || {
                meta: {
                    paused: !1
                }
            };
        }, this.paused = function() {
            return u;
        }, this.pause = function() {
            u = !0, o.abort(), a = a.substr(o.getCharIndex());
        }, this.resume = function() {
            u = !1, t.streamer.parseChunk(a, !0);
        }, this.aborted = function() {
            return e;
        }, this.abort = function() {
            e = !0, o.abort(), d.meta.aborted = !0, z(g.complete) && g.complete(d), a = "";
        };
    }
    function M(e) {
        return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
    function v(e) {
        var S, O = (e = e || {}).delimiter, x = e.newline, T = e.comments, I = e.step, A = e.preview, D = e.fastMode, L = S = void 0 === e.quoteChar ? '"' : e.quoteChar;
        if (void 0 !== e.escapeChar && (L = e.escapeChar), ("string" != typeof O || -1 < k.BAD_DELIMITERS.indexOf(O)) && (O = ","), T === O) throw "Comment character same as delimiter";
        !0 === T ? T = "#" : ("string" != typeof T || -1 < k.BAD_DELIMITERS.indexOf(T)) && (T = !1), "\n" !== x && "\r" !== x && "\r\n" !== x && (x = "\n");
        var P = 0, F = !1;
        this.parse = function(i, t, r) {
            if ("string" != typeof i) throw "Input must be a string";
            var n = i.length, e = O.length, s = x.length, a = T.length, o = z(I), h = [], u = [], f = [], d = P = 0;
            if (!i) return C();
            if (D || !1 !== D && -1 === i.indexOf(S)) {
                for(var l = i.split(x), c = 0; c < l.length; c++){
                    if (f = l[c], P += f.length, c !== l.length - 1) P += x.length;
                    else if (r) return C();
                    if (!T || f.substr(0, a) !== T) {
                        if (o) {
                            if (h = [], k(f.split(O)), R(), F) return C();
                        } else k(f.split(O));
                        if (A && A <= c) return h = h.slice(0, A), C(!0);
                    }
                }
                return C();
            }
            for(var p, _ = i.indexOf(O, P), g = i.indexOf(x, P), m = new RegExp(M(L) + M(S), "g");;)if (i[P] !== S) {
                if (T && 0 === f.length && i.substr(P, a) === T) {
                    if (-1 === g) return C();
                    P = g + s, g = i.indexOf(x, P), _ = i.indexOf(O, P);
                } else if (-1 !== _ && (_ < g || -1 === g)) f.push(i.substring(P, _)), P = _ + e, _ = i.indexOf(O, P);
                else {
                    if (-1 === g) break;
                    if (f.push(i.substring(P, g)), w(g + s), o && (R(), F)) return C();
                    if (A && h.length >= A) return C(!0);
                }
            } else for(p = P, P++;;){
                if (-1 === (p = i.indexOf(S, p + 1))) return r || u.push({
                    type: "Quotes",
                    code: "MissingQuotes",
                    message: "Quoted field unterminated",
                    row: h.length,
                    index: P
                }), E();
                if (p === n - 1) return E(i.substring(P, p).replace(m, S));
                if (S !== L || i[p + 1] !== L) {
                    if (S === L || 0 === p || i[p - 1] !== L) {
                        var y = b(-1 === g ? _ : Math.min(_, g));
                        if (i[p + 1 + y] === O) {
                            f.push(i.substring(P, p).replace(m, S)), P = p + 1 + y + e, _ = i.indexOf(O, P), g = i.indexOf(x, P);
                            break;
                        }
                        var v = b(g);
                        if (i.substr(p + 1 + v, s) === x) {
                            if (f.push(i.substring(P, p).replace(m, S)), w(p + 1 + v + s), _ = i.indexOf(O, P), o && (R(), F)) return C();
                            if (A && h.length >= A) return C(!0);
                            break;
                        }
                        u.push({
                            type: "Quotes",
                            code: "InvalidQuotes",
                            message: "Trailing quote on quoted field is malformed",
                            row: h.length,
                            index: P
                        }), p++;
                    }
                } else p++;
            }
            return E();
            function k(e) {
                h.push(e), d = P;
            }
            function b(e) {
                var t = 0;
                if (-1 !== e) {
                    var r = i.substring(p + 1, e);
                    r && "" === r.trim() && (t = r.length);
                }
                return t;
            }
            function E(e) {
                return r || (void 0 === e && (e = i.substr(P)), f.push(e), P = n, k(f), o && R()), C();
            }
            function w(e) {
                P = e, k(f), f = [], g = i.indexOf(x, P);
            }
            function C(e) {
                return {
                    data: h,
                    errors: u,
                    meta: {
                        delimiter: O,
                        linebreak: x,
                        aborted: F,
                        truncated: !!e,
                        cursor: d + (t || 0)
                    }
                };
            }
            function R() {
                I(C()), h = [], u = [];
            }
        }, this.abort = function() {
            F = !0;
        }, this.getCharIndex = function() {
            return P;
        };
    }
    function m(e) {
        var t = e.data, r = h[t.workerId], i = !1;
        if (t.error) r.userError(t.error, t.file);
        else if (t.results && t.results.data) {
            var n = {
                abort: function() {
                    i = !0, y(t.workerId, {
                        data: [],
                        errors: [],
                        meta: {
                            aborted: !0
                        }
                    });
                },
                pause: b,
                resume: b
            };
            if (z(r.userStep)) {
                for(var s = 0; s < t.results.data.length && (r.userStep({
                    data: [
                        t.results.data[s]
                    ],
                    errors: t.results.errors,
                    meta: t.results.meta
                }, n), !i); s++);
                delete t.results;
            } else z(r.userChunk) && (r.userChunk(t.results, n, t.file), delete t.results);
        }
        t.finished && !i && y(t.workerId, t.results);
    }
    function y(e, t) {
        var r = h[e];
        z(r.userComplete) && r.userComplete(t), r.terminate(), delete h[e];
    }
    function b() {
        throw "Not implemented.";
    }
    function E(e) {
        if ("object" != typeof e || null === e) return e;
        var t = Array.isArray(e) ? [] : {};
        for(var r in e)t[r] = E(e[r]);
        return t;
    }
    function w(e, t) {
        return function() {
            e.apply(t, arguments);
        };
    }
    function z(e) {
        return "function" == typeof e;
    }
    return o ? f.onmessage = function(e) {
        var t = e.data;
        void 0 === k.WORKER_ID && t && (k.WORKER_ID = t.workerId);
        if ("string" == typeof t.input) f.postMessage({
            workerId: k.WORKER_ID,
            results: k.parse(t.input, t.config),
            finished: !0
        });
        else if (f.File && t.input instanceof File || t.input instanceof Object) {
            var r = k.parse(t.input, t.config);
            r && f.postMessage({
                workerId: k.WORKER_ID,
                results: r,
                finished: !0
            });
        }
    } : k.WORKERS_SUPPORTED && (e = document.getElementsByTagName("script"), s = e.length ? e[e.length - 1].src : "", document.body ? document.addEventListener("DOMContentLoaded", function() {
        a = !0;
    }, !0) : a = !0), (c.prototype = Object.create(l.prototype)).constructor = c, (p.prototype = Object.create(l.prototype)).constructor = p, (_.prototype = Object.create(_.prototype)).constructor = _, (g.prototype = Object.create(l.prototype)).constructor = g, k;
});

});

parcelRegister("aOFHJ", function(module, exports) {

$parcel$export(module.exports, "RevenueForecastReportPhaseColumns", function () { return $7dfeec7cdc7dfa90$export$a43e082dc13e5f4; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("eat5C");

var $jbmdS = parcelRequire("jbmdS");

var $4hBm1 = parcelRequire("4hBm1");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $lEBSy = parcelRequire("lEBSy");

var $12o9H = parcelRequire("12o9H");

var $ikffN = parcelRequire("ikffN");
parcelRequire("4Ypeq");

var $alT7C = parcelRequire("alT7C");

var $49KZT = parcelRequire("49KZT");

var $liJtZ = parcelRequire("liJtZ");

var $6gkJQ = parcelRequire("6gkJQ");

var $kqlQp = parcelRequire("kqlQp");

const $7dfeec7cdc7dfa90$var$cellStyles = (row, stores, monthStart, isPastMonth)=>{
    var _stores$cell, _stores$cell2, _row$getProgressInMon;
    const inPhaseDateRange = (row === null || row === void 0 ? void 0 : row.startDate) && (row === null || row === void 0 ? void 0 : row.endDate) && monthStart >= (0, $4hBm1.startOfMonth)(new Date(row === null || row === void 0 ? void 0 : row.startDate)) && monthStart <= (0, $4hBm1.endOfMonth)(new Date(row === null || row === void 0 ? void 0 : row.endDate));
    const hasRevenue = (stores === null || stores === void 0 ? void 0 : (_stores$cell = stores.cell) === null || _stores$cell === void 0 ? void 0 : _stores$cell.value) !== 0;
    const isNegative = (stores === null || stores === void 0 ? void 0 : (_stores$cell2 = stores.cell) === null || _stores$cell2 === void 0 ? void 0 : _stores$cell2.value) < 0;
    const overBudget = (row === null || row === void 0 ? void 0 : (_row$getProgressInMon = row.getProgressInMonth) === null || _row$getProgressInMon === void 0 ? void 0 : _row$getProgressInMon.call(row, monthStart)) > 1;
    return {
        ...isPastMonth ? {
            backgroundImage: `url(${new URL((parcelRequire("3vc8e")))})`
        } : {},
        ...hasRevenue ? !(isNegative || overBudget) ? {
            borderBottom: "5px gold solid"
        } : {
            borderBottom: "5px #f15a29 solid",
            color: "#f15a29"
        } : inPhaseDateRange ? {
            borderBottom: "3px #d7d7d7 solid"
        } : {}
    };
};
const $7dfeec7cdc7dfa90$export$a43e082dc13e5f4 = (store, keyString = "")=>({
        title: (monthStartDate, groupBy = [], filters = [], { status: status, projectId: projectId } = {})=>({
                id: "title",
                label: "Title",
                type: "text",
                width: 18,
                editable: (row)=>false,
                value: (row, stores)=>{
                    // labels disappear when using title case for some reason
                    // checking it exist first works - maybe some observable thing?
                    return row.title;
                },
                component: ({ value: value, group: group, stores: stores })=>{
                    var _row$groups2;
                    const row = stores.row.rowObject;
                    if (stores.row.group === "totals") return "Total";
                    if (row.group === "project") {
                        var _row$groups;
                        return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            style: {
                                paddingLeft: `${1 * row.groupLevel}rem`,
                                display: "flex",
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                    style: {
                                        flex: 1
                                    },
                                    children: ((_row$groups = row.groups) === null || _row$groups === void 0 ? void 0 : _row$groups.length) === 1 ? (0, $ikffN.capitalCase)(value) : (0, $lEBSy.titleCase)(value)
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqlQp.Link), {
                                    to: `/projects/${row.key}`,
                                    className: "ml-2",
                                    children: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                        className: "fa fa-external-link text-gray-500",
                                        style: {
                                            cursor: "pointer"
                                        }
                                    })
                                })
                            ]
                        });
                    }
                    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        style: {
                            paddingLeft: `${1 * row.groupLevel}rem`
                        },
                        children: ((_row$groups2 = row.groups) === null || _row$groups2 === void 0 ? void 0 : _row$groups2.length) === 1 ? (0, $ikffN.capitalCase)(value) : (0, $lEBSy.titleCase)(value)
                    });
                }
            }),
        revenue: (monthStartDate, groupBy = [], filters = [], { status: status, projectId: projectId } = {})=>{
            const monthStart = (0, $4hBm1.startOfMonth)(monthStartDate);
            const monthEnd = (0, $4hBm1.endOfMonth)(monthStart);
            const currentMonthStart = (0, $4hBm1.startOfMonth)(new Date());
            const monthType = monthStart.getTime() === currentMonthStart.getTime() ? "current" : monthStart.getTime() > currentMonthStart.getTime() ? "future" : "past";
            const isPastMonth = monthType === "past";
            const isFutureMonth = monthType === "future";
            const isCurrentMonth = monthType === "current";
            const cellLabel = (0, $4hBm1.format)(monthStartDate, "yyyy-MM");
            let queryId = "revenue";
            if (status) queryId += status;
            if (projectId) queryId += projectId;
            return {
                id: cellLabel,
                label: (0, $4hBm1.format)(monthStartDate, "MMM yy"),
                type: "currency",
                width: 8,
                value: (row)=>{
                    return store.getRevenueInMonth(keyString ? `${keyString},${row.key}` : row.key, cellLabel, null);
                },
                component: (props)=>{
                    const row = props.stores.row.rowObject;
                    return $7dfeec7cdc7dfa90$var$RevenueCellComponent(props, store, (0, $4hBm1.format)(monthStartDate, "yyyy-MM"), keyString ? `${keyString},${row.key}` : row.key);
                },
                editable: ()=>{
                    return (isFutureMonth || isCurrentMonth || store.report.filters.revenueData === "projected") && (keyString === null || keyString === void 0 ? void 0 : keyString.split(",").filter((k)=>k !== "").length) >= 1 && (0, $8kZ1o.canEditRevenueTargets)((0, $1BTI2.default).user);
                },
                style: (row, stores)=>{
                    return $7dfeec7cdc7dfa90$var$cellStyles(row, stores, monthStart, isPastMonth);
                },
                format: (v)=>(0, $12o9H.FormatCurrency)(v, {
                        decimals: 0
                    }),
                aggregate: "sum",
                onClick: (row)=>()=>{
                        store.selectCell(monthStart, row, keyString ? `${keyString},${row.key}` : row.key);
                    },
                selected: (row)=>{
                    return store.selectedObject === row && (0, $4hBm1.format)(store.selectedMonth, "yyyy-MM") === (0, $4hBm1.format)(monthStart, "yyyy-MM");
                },
                onChange: (r)=>(v)=>{
                        v = v || 0;
                        store.setEditedRevenueData(keyString ? `${keyString},${r.key}` : r.key, (0, $4hBm1.format)(monthStartDate, "yyyy-MM"), v, (period, newRevenue, projectId, phaseId)=>{
                            (0, $alT7C.ProjectSidebarStore).setRevenueInPeriod((0, $4hBm1.format)(monthStartDate, "yyyy-MM"), projectId, phaseId || null, newRevenue);
                        });
                    }
            };
        },
        csvRevenue: (monthStartDate, groupBy = [], filters = [], { status: status, projectId: projectId } = {})=>{
            const monthStart = (0, $4hBm1.startOfMonth)(monthStartDate);
            const monthLabel = (0, $4hBm1.format)(monthStart, "yyyy-MM");
            return {
                id: monthLabel,
                label: (0, $4hBm1.format)(monthStartDate, "MMM yy"),
                type: "text",
                value: (row)=>{
                    const key = keyString ? `${keyString},${row.key}` : row.key;
                    let value = (0, $12o9H.FormatCurrency)(store.getRevenueInMonth(key, monthLabel, null) || 0, {
                        decimals: 0
                    });
                    if (store.report.filters.revenueData === "actualsVsProjected") {
                        const actualRevenueInMonth = store.getRevenueInMonth(key, monthLabel, "actuals");
                        const projectedRevenueInMonth = store.getRevenueInMonth(key, monthLabel, "projected");
                        value = `${(0, $12o9H.FormatCurrency)(actualRevenueInMonth, {
                            decimals: 0
                        })} / ${(0, $12o9H.FormatCurrency)(projectedRevenueInMonth, {
                            decimals: 0
                        })}`;
                    }
                    return value;
                }
            };
        },
        revenueVsFee: (monthStartDate, groupBy = [], filters = [])=>{
            const currentMonthStart = (0, $4hBm1.startOfMonth)(new Date());
            const currentMonthEnd = (0, $4hBm1.endOfMonth)(currentMonthStart);
            return {
                id: "revenueVsFee",
                label: /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                    children: [
                        "Total",
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                            style: {
                                fontSize: "1.5em",
                                float: "right"
                            },
                            onClick: (e)=>e.stopPropagation(),
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                    className: `fa fa-caret-left`,
                                    style: {
                                        cursor: "pointer"
                                    },
                                    onClick: ()=>store.shiftDates(-1)
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                    className: `fa fa-caret-right`,
                                    style: {
                                        marginRight: 0,
                                        cursor: "pointer"
                                    },
                                    onClick: ()=>store.shiftDates(1)
                                })
                            ]
                        })
                    ]
                }),
                type: "progress",
                width: 18,
                editable: (row)=>false,
                format: (v)=>(0, $12o9H.FormatCurrency)(v, {
                        decimals: 0
                    }),
                style: (row, stores)=>{
                    var _stores$cell3, _stores$cell3$value, _stores$cell4, _stores$cell4$value;
                    return {
                        ...(stores === null || stores === void 0 ? void 0 : (_stores$cell3 = stores.cell) === null || _stores$cell3 === void 0 ? void 0 : (_stores$cell3$value = _stores$cell3.value) === null || _stores$cell3$value === void 0 ? void 0 : _stores$cell3$value.numerator) / (stores === null || stores === void 0 ? void 0 : (_stores$cell4 = stores.cell) === null || _stores$cell4 === void 0 ? void 0 : (_stores$cell4$value = _stores$cell4.value) === null || _stores$cell4$value === void 0 ? void 0 : _stores$cell4$value.denominator) > 1 ? {
                            color: "#f15a29"
                        } : {}
                    };
                },
                value: (r)=>{
                    return {
                        numerator: store.getTotalRevenue(keyString ? `${keyString},${r.key}` : r.key) || 0,
                        denominator: store.getTotalFee(keyString ? `${keyString},${r.key}` : r.key) || 0
                    };
                }
            };
        }
    });
const $7dfeec7cdc7dfa90$var$RevenueCellComponent = (props, store, month, key = "")=>{
    const keys = key.split(",");
    const projectId = keys[1];
    const phaseId = keys[2];
    let value = props.formattedValue;
    if (store.report.filters.revenueData === "actualsVsProjected") {
        const actualRevenueInMonth = store.getRevenueInMonth(key, month, "actuals");
        const projectedRevenueInMonth = store.getRevenueInMonth(key, month, "projected");
        value = `${(0, $12o9H.FormatCurrency)(actualRevenueInMonth, {
            decimals: 0
        })} / ${(0, $12o9H.FormatCurrency)(projectedRevenueInMonth, {
            decimals: 0
        })}`;
    }
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)($7dfeec7cdc7dfa90$var$MilestoneCellComponent, {
                projectId: projectId,
                phaseId: phaseId,
                month: month
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                ...props,
                onChange: null,
                style: {
                    ...props.style,
                    justifyContent: "flex-end"
                },
                children: props.selected && props.editable ? (0, $49KZT.default)["currency"]({
                    ...props,
                    key: "edit"
                }) : (0, $49KZT.default)["text"]({
                    ...props,
                    key: "display",
                    style: {
                        textAlign: "right",
                        justifyContent: "flex-end"
                    },
                    value: value,
                    formattedValue: value,
                    editable: false,
                    onChange: null
                })
            })
        ]
    });
};
const $7dfeec7cdc7dfa90$var$MilestoneCellComponent = ({ projectId: projectId, phaseId: phaseId, month: month })=>{
    const [isOpen, setIsOpen] = (0, $jbmdS.useState)(false);
    if (!(0, $8kZ1o.canViewProjectMilestones)((0, $1BTI2.default).user)) return null;
    const milestones = (phaseId ? (0, $liJtZ.default).milestonesByPhaseId[phaseId] : (0, $liJtZ.default).milestonesByProjectId[projectId]) || [];
    const milestonesInMonth = milestones.filter((m)=>m.month === month);
    if (milestonesInMonth.length === 0) return null;
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $6gkJQ.Popover), {
        open: isOpen,
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6gkJQ.PopoverTrigger), {
                onMouseEnter: ()=>setIsOpen(true),
                onMouseLeave: ()=>setIsOpen(false),
                children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    className: "absolute top-0.5 right-0.5 w-2 h-2 bg-rose-600 rounded-full cursor-pointer border border-white shadow-sm"
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6gkJQ.PopoverContent), {
                onMouseEnter: ()=>setIsOpen(true),
                onMouseLeave: ()=>setIsOpen(false),
                children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    className: "p-4 text-sm",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("h4", {
                            children: "Milestones"
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)("ul", {
                            children: milestonesInMonth.map((m)=>/*#__PURE__*/ (0, $61Ea1.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                            className: "font-bold",
                                            children: (0, $4hBm1.format)(m.date, "dd/MM/yy")
                                        }),
                                        " ",
                                        "- ",
                                        m.label
                                    ]
                                }, m.id))
                        })
                    ]
                })
            })
        ]
    });
};

});
parcelRegister("lEBSy", function(module, exports) {

$parcel$export(module.exports, "titleCase", function () { return $fc3ab75f6dd0b732$export$348afa8c9ff47183; });
var $fc3ab75f6dd0b732$var$SMALL_WORDS = /\b(?:an?d?|a[st]|because|but|by|en|for|i[fn]|neither|nor|o[fnr]|only|over|per|so|some|tha[tn]|the|to|up|upon|vs?\.?|versus|via|when|with|without|yet)\b/i;
var $fc3ab75f6dd0b732$var$TOKENS = /[^\s:–—-]+|./g;
var $fc3ab75f6dd0b732$var$WHITESPACE = /\s/;
var $fc3ab75f6dd0b732$var$IS_MANUAL_CASE = /.(?=[A-Z]|\..)/;
var $fc3ab75f6dd0b732$var$ALPHANUMERIC_PATTERN = /[A-Za-z0-9\u00C0-\u00FF]/;
function $fc3ab75f6dd0b732$export$348afa8c9ff47183(input) {
    var result = "";
    var m;
    // tslint:disable-next-line
    while((m = $fc3ab75f6dd0b732$var$TOKENS.exec(input)) !== null){
        var token = m[0], index = m.index;
        if (// Ignore already capitalized words.
        !$fc3ab75f6dd0b732$var$IS_MANUAL_CASE.test(token) && // Ignore small words except at beginning or end.
        (!$fc3ab75f6dd0b732$var$SMALL_WORDS.test(token) || index === 0 || index + token.length === input.length) && // Ignore URLs.
        (input.charAt(index + token.length) !== ":" || $fc3ab75f6dd0b732$var$WHITESPACE.test(input.charAt(index + token.length + 1)))) {
            // Find and uppercase first word character, skips over *modifiers*.
            result += token.replace($fc3ab75f6dd0b732$var$ALPHANUMERIC_PATTERN, function(m) {
                return m.toUpperCase();
            });
            continue;
        }
        result += token;
    }
    return result;
}

});

parcelRegister("4Ypeq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39f0567a8610a817$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $4JcCM = parcelRequire("4JcCM");
parcelRequire("jbmdS");

var $eat5C = parcelRequire("eat5C");

var $4hBm1 = parcelRequire("4hBm1");

var $5CHqX = parcelRequire("5CHqX");

var $d4jhX = parcelRequire("d4jhX");

var $hDUkm = parcelRequire("hDUkm");

var $khJQv = parcelRequire("khJQv");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $azaaH = parcelRequire("azaaH");

var $3KSJP = parcelRequire("3KSJP");

var $bvRAk = parcelRequire("bvRAk");

var $lOQvu = parcelRequire("lOQvu");

var $gJT7h = parcelRequire("gJT7h");

var $Ds2V9 = parcelRequire("Ds2V9");

var $6fNfM = parcelRequire("6fNfM");

var $bxXv3 = parcelRequire("bxXv3");

var $htkeB = parcelRequire("htkeB");

var $iOQGT = parcelRequire("iOQGT");

var $ywyHN = parcelRequire("ywyHN");

var $XoImS = parcelRequire("XoImS");
parcelRequire("eBwNQ");

var $gN0TC = parcelRequire("gN0TC");

var $cwjKY = parcelRequire("cwjKY");

var $12o9H = parcelRequire("12o9H");
var $39f0567a8610a817$var$_dec, $39f0567a8610a817$var$_dec2, $39f0567a8610a817$var$_dec3, $39f0567a8610a817$var$_dec4, $39f0567a8610a817$var$_dec5, $39f0567a8610a817$var$_dec6, $39f0567a8610a817$var$_dec7, $39f0567a8610a817$var$_dec8, $39f0567a8610a817$var$_dec9, $39f0567a8610a817$var$_dec10, $39f0567a8610a817$var$_dec11, $39f0567a8610a817$var$_dec12, $39f0567a8610a817$var$_dec13, $39f0567a8610a817$var$_dec14, $39f0567a8610a817$var$_dec15, $39f0567a8610a817$var$_dec16, $39f0567a8610a817$var$_dec17, $39f0567a8610a817$var$_dec18, $39f0567a8610a817$var$_class, $39f0567a8610a817$var$_descriptor, $39f0567a8610a817$var$_descriptor2, $39f0567a8610a817$var$_descriptor3, $39f0567a8610a817$var$_descriptor4, $39f0567a8610a817$var$_descriptor5, $39f0567a8610a817$var$_descriptor6, $39f0567a8610a817$var$_descriptor7, $39f0567a8610a817$var$_descriptor8, $39f0567a8610a817$var$_descriptor9, $39f0567a8610a817$var$_descriptor10, $39f0567a8610a817$var$_descriptor11, $39f0567a8610a817$var$_descriptor12, $39f0567a8610a817$var$_descriptor13, $39f0567a8610a817$var$_descriptor14, $39f0567a8610a817$var$_descriptor15, $39f0567a8610a817$var$_descriptor16, $39f0567a8610a817$var$_descriptor17, $39f0567a8610a817$var$_descriptor18, $39f0567a8610a817$var$_descriptor19, $39f0567a8610a817$var$_descriptor20, $39f0567a8610a817$var$_descriptor21, $39f0567a8610a817$var$_descriptor22, $39f0567a8610a817$var$_descriptor23, $39f0567a8610a817$var$_descriptor24, $39f0567a8610a817$var$_descriptor25, $39f0567a8610a817$var$_descriptor26, $39f0567a8610a817$var$_descriptor27, $39f0567a8610a817$var$_descriptor28, $39f0567a8610a817$var$_descriptor29;
function $39f0567a8610a817$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $39f0567a8610a817$var$_defineProperty(e, r, t) {
    return (r = $39f0567a8610a817$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $39f0567a8610a817$var$_toPropertyKey(t) {
    var i = $39f0567a8610a817$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $39f0567a8610a817$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $39f0567a8610a817$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $39f0567a8610a817$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
const $39f0567a8610a817$var$spacerColumn = {
    label: "",
    width: 3,
    type: "text",
    value: (r)=>"",
    onChange: (r)=>(v)=>null
};
const $39f0567a8610a817$var$noRole = {
    id: "norole",
    title: "(No Role)",
    rates: []
};
const $39f0567a8610a817$var$noStaff = {
    id: "nostaff",
    title: "(No Staff)",
    rates: []
};
const $39f0567a8610a817$var$dateFuncs = {
    month: {
        add: (0, $4hBm1.addMonths),
        sub: (0, $4hBm1.subMonths),
        start: (0, $4hBm1.startOfMonth),
        end: (0, $4hBm1.endOfMonth),
        formatString: "yyyy-MM",
        displayFormatString: "MMM yy"
    },
    week: {
        add: (0, $4hBm1.addWeeks),
        sub: (0, $4hBm1.subWeeks),
        start: (0, $4hBm1.startOfISOWeek),
        end: (0, $4hBm1.endOfISOWeek),
        formatString: "RRRR-II",
        displayFormatString: "dd MMM yy"
    }
};





let $39f0567a8610a817$var$ProjectForecastStore = ($39f0567a8610a817$var$_dec = (0, $4JcCM.action).bound, $39f0567a8610a817$var$_dec2 = (0, $4JcCM.action).bound, $39f0567a8610a817$var$_dec3 = (0, $4JcCM.action).bound, $39f0567a8610a817$var$_dec4 = (0, $4JcCM.action).bound, $39f0567a8610a817$var$_dec5 = (0, $4JcCM.action).bound, $39f0567a8610a817$var$_dec6 = (0, $4JcCM.action).bound, $39f0567a8610a817$var$_dec7 = (0, $4JcCM.action).bound, $39f0567a8610a817$var$_dec8 = (0, $4JcCM.action).bound, $39f0567a8610a817$var$_dec9 = (0, $4JcCM.action).bound, $39f0567a8610a817$var$_dec10 = (0, $4JcCM.action).bound, $39f0567a8610a817$var$_dec11 = (0, $4JcCM.action).bound, $39f0567a8610a817$var$_dec12 = (0, $4JcCM.action).bound, $39f0567a8610a817$var$_dec13 = (0, $4JcCM.action).bound, $39f0567a8610a817$var$_dec14 = (0, $4JcCM.action).bound, $39f0567a8610a817$var$_dec15 = (0, $4JcCM.action).bound, $39f0567a8610a817$var$_dec16 = (0, $4JcCM.action).bound, $39f0567a8610a817$var$_dec17 = (0, $4JcCM.action).bound, $39f0567a8610a817$var$_dec18 = (0, $4JcCM.action).bound, $39f0567a8610a817$var$_class = class ProjectForecastStore {
    constructor(){
        $39f0567a8610a817$var$_initializerDefineProperty(this, "filterByPhase", $39f0567a8610a817$var$_descriptor, this);
        $39f0567a8610a817$var$_initializerDefineProperty(this, "graphType", $39f0567a8610a817$var$_descriptor2, this);
        $39f0567a8610a817$var$_initializerDefineProperty(this, "graphData", $39f0567a8610a817$var$_descriptor3, this);
        $39f0567a8610a817$var$_initializerDefineProperty(this, "startDate", $39f0567a8610a817$var$_descriptor4, this);
        $39f0567a8610a817$var$_initializerDefineProperty(this, "endDate", $39f0567a8610a817$var$_descriptor5, this);
        $39f0567a8610a817$var$_initializerDefineProperty(this, "selectedTable", $39f0567a8610a817$var$_descriptor6, this);
        $39f0567a8610a817$var$_initializerDefineProperty(this, "selectedObject", $39f0567a8610a817$var$_descriptor7, this);
        $39f0567a8610a817$var$_initializerDefineProperty(this, "selectedProjectOrPhase", $39f0567a8610a817$var$_descriptor8, this);
        $39f0567a8610a817$var$_initializerDefineProperty(this, "selectedPeriod", $39f0567a8610a817$var$_descriptor9, this);
        $39f0567a8610a817$var$_initializerDefineProperty(this, "updateRevenueWithExpenses", $39f0567a8610a817$var$_descriptor10, this);
        $39f0567a8610a817$var$_initializerDefineProperty(this, "updateExpensesWithRevenue", $39f0567a8610a817$var$_descriptor11, this);
        $39f0567a8610a817$var$_initializerDefineProperty(this, "queryData", $39f0567a8610a817$var$_descriptor12, this);
        $39f0567a8610a817$var$_initializerDefineProperty(this, "phaseRoleRowsByPhaseId", $39f0567a8610a817$var$_descriptor13, this);
        $39f0567a8610a817$var$_initializerDefineProperty(this, "phaseStaffRowsByPhaseRoleId", $39f0567a8610a817$var$_descriptor14, this);
        $39f0567a8610a817$var$_initializerDefineProperty(this, "editedRevenueTargets", $39f0567a8610a817$var$_descriptor15, this);
        $39f0567a8610a817$var$_initializerDefineProperty(this, "editedAllocations", $39f0567a8610a817$var$_descriptor16, this);
        $39f0567a8610a817$var$_initializerDefineProperty(this, "editedExpenses", $39f0567a8610a817$var$_descriptor17, this);
        $39f0567a8610a817$var$_initializerDefineProperty(this, "project", $39f0567a8610a817$var$_descriptor18, this);
        $39f0567a8610a817$var$_initializerDefineProperty(this, "projectStaff", $39f0567a8610a817$var$_descriptor19, this);
        $39f0567a8610a817$var$_initializerDefineProperty(this, "staffByPhase", $39f0567a8610a817$var$_descriptor20, this);
        $39f0567a8610a817$var$_initializerDefineProperty(this, "saveState", $39f0567a8610a817$var$_descriptor21, this);
        $39f0567a8610a817$var$_initializerDefineProperty(this, "uuid", $39f0567a8610a817$var$_descriptor22, this);
        $39f0567a8610a817$var$_initializerDefineProperty(this, "savingIds", $39f0567a8610a817$var$_descriptor23, this);
        $39f0567a8610a817$var$_initializerDefineProperty(this, "periodType", $39f0567a8610a817$var$_descriptor24, this);
        $39f0567a8610a817$var$_defineProperty(this, "setPeriodType", (type)=>{
            var _this$editedRevenueTa, _this$periodType, _this$editedRevenueTa2, _this$project, _this$editedAllocatio, _this$periodType2, _this$editedAllocatio2, _this$project2, _this$editedExpenses$, _this$periodType3, _this$editedExpenses$2, _this$project3;
            this.periodType = type;
            (_this$editedRevenueTa2 = (_this$editedRevenueTa = this.editedRevenueTargets[(_this$project = this.project) === null || _this$project === void 0 ? void 0 : _this$project.id])[_this$periodType = this.periodType]) !== null && _this$editedRevenueTa2 !== void 0 ? _this$editedRevenueTa2 : _this$editedRevenueTa[_this$periodType] = {};
            (_this$editedAllocatio2 = (_this$editedAllocatio = this.editedAllocations[(_this$project2 = this.project) === null || _this$project2 === void 0 ? void 0 : _this$project2.id])[_this$periodType2 = this.periodType]) !== null && _this$editedAllocatio2 !== void 0 ? _this$editedAllocatio2 : _this$editedAllocatio[_this$periodType2] = {};
            (_this$editedExpenses$2 = (_this$editedExpenses$ = this.editedExpenses[(_this$project3 = this.project) === null || _this$project3 === void 0 ? void 0 : _this$project3.id])[_this$periodType3 = this.periodType]) !== null && _this$editedExpenses$2 !== void 0 ? _this$editedExpenses$2 : _this$editedExpenses$[_this$periodType3] = {};
        });
        $39f0567a8610a817$var$_defineProperty(this, "addPeriods", (...params)=>{
            return $39f0567a8610a817$var$dateFuncs[this.periodType].add(...params);
        });
        $39f0567a8610a817$var$_defineProperty(this, "subPeriods", (...params)=>{
            return $39f0567a8610a817$var$dateFuncs[this.periodType].sub(...params);
        });
        $39f0567a8610a817$var$_defineProperty(this, "startOfPeriod", (...params)=>{
            return $39f0567a8610a817$var$dateFuncs[this.periodType].start(...params);
        });
        $39f0567a8610a817$var$_defineProperty(this, "endOfPeriod", (...params)=>{
            return $39f0567a8610a817$var$dateFuncs[this.periodType].end(...params);
        });
        $39f0567a8610a817$var$_defineProperty(this, "periodFormat", ()=>{
            return $39f0567a8610a817$var$dateFuncs[this.periodType].formatString;
        });
        $39f0567a8610a817$var$_defineProperty(this, "periodDisplayFormat", ()=>{
            return $39f0567a8610a817$var$dateFuncs[this.periodType].displayFormatString;
        });
        $39f0567a8610a817$var$_defineProperty(this, "getInvoiceRevenueInPeriod", (0, $Ds2V9.computedFn)((period, phaseId)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.queryData.invoices.filter((inv)=>(!phaseId || inv.phaseId === phaseId) && inv[this.periodType] === period).map((inv)=>inv.amount));
        }));
        $39f0567a8610a817$var$_defineProperty(this, "getChangeLogRevenueInPeriod", (0, $Ds2V9.computedFn)((period, phaseId)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.queryData.changeLog.filter((cli)=>(!phaseId || cli.phaseId === phaseId) && cli[this.periodType] === period).map((cli)=>cli.revenue));
        }));
        $39f0567a8610a817$var$_defineProperty(this, "getRevenueTargetsInPeriod", (0, $Ds2V9.computedFn)((period, phaseId)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.queryData.revenueTargets.filter((rt)=>(!phaseId || rt.phaseId === phaseId) && rt[this.periodType] === period).map((r)=>r.revenue));
        }));
        $39f0567a8610a817$var$_defineProperty(this, "getEditedRevenueInPeriod", (0, $Ds2V9.computedFn)((period, phaseId)=>{
            var _this$editedRevenueTa3, _this$project4;
            if (!phaseId) return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.queryData.projects[0].phases.map((p)=>this.getEditedRevenueInPeriod(period, p.id)));
            return (_this$editedRevenueTa3 = this.editedRevenueTargets[(_this$project4 = this.project) === null || _this$project4 === void 0 ? void 0 : _this$project4.id][this.periodType][period + phaseId]) === null || _this$editedRevenueTa3 === void 0 ? void 0 : _this$editedRevenueTa3.revenue;
        }));
        $39f0567a8610a817$var$_initializerDefineProperty(this, "setEditedRevenueInPeriod", $39f0567a8610a817$var$_descriptor25, this);
        $39f0567a8610a817$var$_initializerDefineProperty(this, "setEditedRevenueProgressInPeriod", $39f0567a8610a817$var$_descriptor26, this);
        $39f0567a8610a817$var$_defineProperty(this, "getFee", (phaseId)=>{
            var _PhaseCollection$phas;
            if (!phaseId) return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.queryData.projects[0].phases.map((p)=>this.getFee(p.id)));
            return (_PhaseCollection$phas = (0, $XoImS.default).phasesById[phaseId]) === null || _PhaseCollection$phas === void 0 ? void 0 : _PhaseCollection$phas.fee;
        });
        $39f0567a8610a817$var$_defineProperty(this, "getRevenueInPeriod", (0, $Ds2V9.computedFn)((period, phaseId)=>{
            if (!period) return 0;
            if (!phaseId) return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.queryData.projects[0].phases.map((p)=>this.getRevenueInPeriod(period, p.id)));
            const thisPeriod = (0, $4hBm1.format)(new Date(), this.periodFormat());
            const isPastPeriod = period < thisPeriod;
            const isFuturePeriod = period > thisPeriod;
            const isCurrentPeriod = period === thisPeriod;
            if (isPastPeriod) {
                const invoiceRevenue = this.getInvoiceRevenueInPeriod(period, phaseId);
                const changeLogRevenue = this.getChangeLogRevenueInPeriod(period, phaseId);
                return invoiceRevenue + changeLogRevenue;
            }
            if (isFuturePeriod) {
                const revenueTargets = this.getRevenueTargetsInPeriod(period, phaseId);
                const editedRevenue = this.getEditedRevenueInPeriod(period, phaseId);
                return editedRevenue !== null && editedRevenue !== void 0 ? editedRevenue : revenueTargets;
            }
            if (isCurrentPeriod) {
                const revenueTargets = this.getRevenueTargetsInPeriod(period, phaseId);
                const editedRevenue = this.getEditedRevenueInPeriod(period, phaseId);
                const invoiceRevenue = this.getInvoiceRevenueInPeriod(period, phaseId);
                const changeLogRevenue = this.getChangeLogRevenueInPeriod(period, phaseId);
                return Math.max(editedRevenue !== null && editedRevenue !== void 0 ? editedRevenue : revenueTargets, invoiceRevenue + changeLogRevenue);
            }
            return 0;
        }));
        $39f0567a8610a817$var$_defineProperty(this, "getRevenueToDateInPeriod", (0, $Ds2V9.computedFn)((period, phaseId)=>{
            const periodsPrior = this.periods.filter((m)=>m <= period);
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(periodsPrior.map((m)=>this.getRevenueInPeriod(m, phaseId)));
        }));
        $39f0567a8610a817$var$_defineProperty(this, "getTotalRevenue", (0, $Ds2V9.computedFn)((phaseId)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.periods.map((m)=>this.getRevenueInPeriod(m, phaseId)));
        }));
        $39f0567a8610a817$var$_defineProperty(this, "getTimeEntryCostInPeriod", (0, $Ds2V9.computedFn)((period, phaseId, roleId, staffId)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.queryData.timeEntries.filter((te)=>{
                const staff = (0, $htkeB.default).staffById[te.staffId] || $39f0567a8610a817$var$noStaff;
                const role = (staff === null || staff === void 0 ? void 0 : staff.role) || (0, $bxXv3.default).rolesById[te.roleId] || $39f0567a8610a817$var$noRole;
                return (!phaseId || te.phaseId === phaseId) && te[this.periodType] === period && (staffId === "nostaff" ? !te.staffId : !staffId || (staff === null || staff === void 0 ? void 0 : staff.id) === staffId) && (!roleId || (role === null || role === void 0 ? void 0 : role.id) === roleId);
            }).map((te)=>te.cost));
        }));
        $39f0567a8610a817$var$_defineProperty(this, "getEditedAllocationCostInPeriod", (0, $Ds2V9.computedFn)((period, phaseId, roleId, staffId)=>{
            const ids = this.getLeafPhaseIds(phaseId, roleId, staffId).filter(([p, r, s])=>{
                const staff = (0, $htkeB.default).staffById[s];
                return (staff === null || staff === void 0 ? void 0 : staff.id) || (staff === null || staff === void 0 ? void 0 : staff.isArchived) === false && isFinite((0, $ywyHN.default)({
                    project: this.project,
                    phase: (0, $XoImS.default).phasesById[p],
                    staff: staff || $39f0567a8610a817$var$noStaff,
                    role: (0, $bxXv3.default).rolesById[r] || $39f0567a8610a817$var$noRole
                }, "cost", [
                    (0, $4hBm1.parse)(period, this.periodFormat(), new Date(), {
                        weekStartsOn: 1
                    }),
                    this.endOfPeriod((0, $4hBm1.parse)(period, this.periodFormat(), new Date(), {
                        weekStartsOn: 1
                    }))
                ]));
            });
            let total = null;
            ids.forEach(([p, r, s])=>{
                var _this$editedAllocatio3, _this$editedAllocatio4, _this$project5;
                const edit = (_this$editedAllocatio3 = this.editedAllocations[(_this$project5 = this.project) === null || _this$project5 === void 0 ? void 0 : _this$project5.id]) === null || _this$editedAllocatio3 === void 0 ? void 0 : (_this$editedAllocatio4 = _this$editedAllocatio3[this.periodType]) === null || _this$editedAllocatio4 === void 0 ? void 0 : _this$editedAllocatio4[period + p + r + s];
                if (edit) {
                    var _total;
                    (_total = total) !== null && _total !== void 0 ? _total : total = 0;
                    total += edit.cost;
                }
            });
            return total;
        }));
        $39f0567a8610a817$var$_defineProperty(this, "getLeafPhaseIds", (0, $Ds2V9.computedFn)((phaseId, roleId, staffId)=>{
            const leafIds = [];
            const phaseIds = phaseId ? [
                phaseId
            ] : this.queryData.projects[0].phases.map((p)=>p === null || p === void 0 ? void 0 : p.id);
            phaseIds.forEach((phId)=>{
                const roleIds = roleId ? [
                    roleId
                ] : (this.phaseRoleRowsByPhaseId[phId] || []).map((r)=>r === null || r === void 0 ? void 0 : r.id);
                roleIds.forEach((rId)=>{
                    const staffIds = staffId ? [
                        staffId
                    ] : (this.phaseStaffRowsByPhaseRoleId[phId + rId] || []).map((s)=>s === null || s === void 0 ? void 0 : s.id);
                    staffIds.forEach((sId)=>{
                        leafIds.push([
                            phId,
                            rId,
                            sId
                        ]);
                    });
                });
            });
            return leafIds;
        }));
        $39f0567a8610a817$var$_defineProperty(this, "getLeafModels", (0, $Ds2V9.computedFn)((phaseId, roleId, staffId)=>{
            const leafModels = [];
            const phases = phaseId ? [
                (0, $XoImS.default).phasesById[phaseId]
            ] : this.queryData.projects[0].phases;
            phases.forEach((ph)=>{
                const roles = roleId ? [
                    (0, $bxXv3.default).rolesById[roleId]
                ] : this.phaseRoleRowsByPhaseId[ph.id] || [];
                roles.forEach((r)=>{
                    const staffs = staffId ? [
                        (0, $htkeB.default).staffById[staffId]
                    ] : this.phaseStaffRowsByPhaseRoleId[ph.id + r.id] || [];
                    staffs.forEach((s)=>{
                        leafModels.push({
                            project: this.project,
                            phase: ph,
                            status: ph.status,
                            role: r,
                            staff: s
                        });
                    });
                });
            });
            return leafModels;
        }));
        $39f0567a8610a817$var$_initializerDefineProperty(this, "setEditedCostInPeriod", $39f0567a8610a817$var$_descriptor27, this);
        $39f0567a8610a817$var$_defineProperty(this, "setEditedCostProgressInPeriod", (period, phaseId, roleId, staffId, percent)=>{
            const dateRange = [
                (0, $4hBm1.parse)(period, this.periodFormat(), new Date(), {
                    weekStartsOn: 1
                }),
                this.endOfPeriod((0, $4hBm1.parse)(period, this.periodFormat(), new Date(), {
                    weekStartsOn: 1
                }))
            ];
            const ids = this.getLeafPhaseIds(phaseId, roleId, staffId).filter(([p, r, s])=>{
                const staff = (0, $htkeB.default).staffById[s];
                return staffId || (staff === null || staff === void 0 ? void 0 : staff.isArchived) === false && isFinite((0, $ywyHN.default)({
                    project: this.project,
                    phase: (0, $XoImS.default).phasesById[p],
                    staff: staff || $39f0567a8610a817$var$noStaff,
                    role: (0, $bxXv3.default).rolesById[r] || $39f0567a8610a817$var$noRole
                }, "cost", dateRange));
            });
            ids.forEach(([p, r, s])=>{
                const periodBefore = (0, $4hBm1.format)(this.subPeriods((0, $4hBm1.parse)(period, this.periodFormat(), new Date(), {
                    weekStartsOn: 1
                }), 1), this.periodFormat());
                const costBeforePeriod = this.getCostToDateInPeriod(periodBefore, p, r, s);
                const budget = this.getCostBudget(p, r, s);
                const newCost = Math.max(budget * percent - costBeforePeriod, 0);
                this.setEditedCostInPeriod(period, p, r, s, newCost);
            });
            this.prepareToSave();
        });
        $39f0567a8610a817$var$_defineProperty(this, "getCostProgressInPeriod", (period, phaseId, roleId, staffId)=>{
            return this.getCostToDateInPeriod(period, phaseId, roleId, staffId) / this.getCostBudget(phaseId, roleId, staffId);
        });
        $39f0567a8610a817$var$_defineProperty(this, "getHoursProgressInPeriod", (period, phaseId, roleId, staffId)=>{
            return this.getHoursToDateInPeriod(period, phaseId, roleId, staffId) / this.getHoursBudget(phaseId, roleId, staffId);
        });
        $39f0567a8610a817$var$_defineProperty(this, "getAllocationCostInPeriod", (0, $Ds2V9.computedFn)((period, phaseId, roleId, staffId)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.queryData.allocations.filter((a)=>{
                const staff = (0, $htkeB.default).staffById[a.staffId] || $39f0567a8610a817$var$noStaff;
                const role = (staff === null || staff === void 0 ? void 0 : staff.role) || (0, $bxXv3.default).rolesById[a.roleId] || $39f0567a8610a817$var$noRole;
                return (!phaseId || a.phaseId === phaseId) && a[this.periodType] === period && (staffId === "nostaff" ? !a.staffId : !staffId || (staff === null || staff === void 0 ? void 0 : staff.id) === staffId) && (!roleId || (role === null || role === void 0 ? void 0 : role.id) === roleId);
            }).map((a)=>a.cost));
        }));
        $39f0567a8610a817$var$_defineProperty(this, "getCostInPeriod", (0, $Ds2V9.computedFn)((period, phaseId, roleId, staffId)=>{
            if (!period) return 0;
            if (!staffId || !phaseId) {
                const ids = this.getLeafPhaseIds(phaseId, roleId, staffId);
                return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(ids.map(([p, r, s])=>{
                    if (!p || !s) return 0;
                    return this.getCostInPeriod(period, p, r || null, s);
                }));
            }
            const thisPeriod = (0, $4hBm1.format)(new Date(), this.periodFormat());
            const isPastPeriod = period < thisPeriod;
            const isFuturePeriod = period > thisPeriod;
            const isCurrentPeriod = period === thisPeriod;
            if (isPastPeriod) return this.getTimeEntryCostInPeriod(period, phaseId, roleId, staffId);
            if (isFuturePeriod) {
                const edits = this.getEditedAllocationCostInPeriod(period, phaseId, roleId, staffId);
                const allocations = this.getAllocationCostInPeriod(period, phaseId, roleId, staffId);
                return edits !== null && edits !== void 0 ? edits : allocations;
            }
            if (isCurrentPeriod) {
                const edits = this.getEditedAllocationCostInPeriod(period, phaseId, roleId, staffId);
                const allocations = this.getAllocationCostInPeriod(period, phaseId, roleId, staffId);
                return Math.max(this.getTimeEntryCostInPeriod(period, phaseId, roleId, staffId), edits !== null && edits !== void 0 ? edits : allocations);
            }
            return 0;
        }));
        $39f0567a8610a817$var$_defineProperty(this, "getCostToDateInPeriod", (0, $Ds2V9.computedFn)((period, phaseId, roleId, staffId)=>{
            const periodsPrior = this.periods.filter((m)=>m <= period);
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(periodsPrior.map((m)=>this.getCostInPeriod(m, phaseId, roleId, staffId)));
        }));
        $39f0567a8610a817$var$_defineProperty(this, "getTotalCost", (0, $Ds2V9.computedFn)((phaseId, roleId, staffId)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.periods.map((m)=>this.getCostInPeriod(m, phaseId, roleId, staffId)));
        }));
        $39f0567a8610a817$var$_defineProperty(this, "getCostBudget", (0, $Ds2V9.computedFn)((phaseId, roleId, staffId)=>{
            if (!phaseId || !(roleId || staffId)) {
                const ids = this.getLeafBudgetIds(phaseId, roleId, staffId);
                return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(ids.map(([p, r, s])=>{
                    if (!p) return 0;
                    return this.getCostBudget(p, r, s);
                }));
            }
            const phase = this.queryData.projects[0].phases.find((p)=>p.id === phaseId);
            if (!phase) return 0;
            const budgets = phase.budgets.filter((b)=>{
                const bStaff = (0, $htkeB.default).staffById[b.staffId];
                const bRoleId = (bStaff === null || bStaff === void 0 ? void 0 : bStaff.roleId) || b.roleId;
                const bRole = (bStaff === null || bStaff === void 0 ? void 0 : bStaff.role) || (0, $bxXv3.default).rolesById[b.roleId];
                // If looking for a specific staff member
                if (staffId && staffId !== "nostaff") return b.staffId === staffId;
                // If looking for unassigned staff under a specific role
                if (staffId === "nostaff" && roleId) return !b.staffId && bRoleId === roleId;
                // If aggregating at role level (no staffId specified)
                if (!staffId && roleId) return bRoleId === roleId || !bRoleId && roleId === "norole";
                // Phase level aggregation
                return true;
            });
            if (!(budgets !== null && budgets !== void 0 && budgets.length)) return 0;
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(budgets.map((b)=>{
                const staff = (0, $htkeB.default).staffById[b.staffId];
                const role = (staff === null || staff === void 0 ? void 0 : staff.role) || (0, $bxXv3.default).rolesById[b.roleId];
                return b.hours * (0, $ywyHN.default)({
                    project: this.project,
                    phase: (0, $XoImS.default).phasesById[b.phaseId],
                    staff: staff,
                    role: role
                }, "cost", [
                    (0, $XoImS.default).phasesById[b.phaseId].startDate,
                    (0, $XoImS.default).phasesById[b.phaseId].endDate
                ]);
            }));
        }));
        $39f0567a8610a817$var$_defineProperty(this, "getTimeEntryHoursInPeriod", (0, $Ds2V9.computedFn)((period, phaseId, roleId, staffId)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.queryData.timeEntries.filter((te)=>{
                const staff = (0, $htkeB.default).staffById[te.staffId] || $39f0567a8610a817$var$noStaff;
                const role = (staff === null || staff === void 0 ? void 0 : staff.role) || (0, $bxXv3.default).rolesById[te.roleId] || $39f0567a8610a817$var$noRole;
                return (!phaseId || te.phaseId === phaseId) && te[this.periodType] === period && (staffId === "nostaff" ? !te.staffId : !staffId || (staff === null || staff === void 0 ? void 0 : staff.id) === staffId) && (!roleId || (role === null || role === void 0 ? void 0 : role.id) === roleId);
            }).map((te)=>te.hours));
        }));
        $39f0567a8610a817$var$_defineProperty(this, "getEditedAllocationHoursInPeriod", (0, $Ds2V9.computedFn)((period, phaseId, roleId, staffId)=>{
            const ids = this.getLeafPhaseIds(phaseId, roleId, staffId).filter(([p, r, s])=>{
                const staff = (0, $htkeB.default).staffById[s];
                return staffId || (staff === null || staff === void 0 ? void 0 : staff.isArchived) === false;
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(ids.map(([p, r, s])=>{
                var _this$editedAllocatio5, _this$editedAllocatio6, _this$editedAllocatio7, _this$project6;
                return (_this$editedAllocatio5 = this.editedAllocations[(_this$project6 = this.project) === null || _this$project6 === void 0 ? void 0 : _this$project6.id]) === null || _this$editedAllocatio5 === void 0 ? void 0 : (_this$editedAllocatio6 = _this$editedAllocatio5[this.periodType]) === null || _this$editedAllocatio6 === void 0 ? void 0 : (_this$editedAllocatio7 = _this$editedAllocatio6[period + p + r + s]) === null || _this$editedAllocatio7 === void 0 ? void 0 : _this$editedAllocatio7.hours;
            }));
        }));
        $39f0567a8610a817$var$_initializerDefineProperty(this, "setEditedHoursInPeriod", $39f0567a8610a817$var$_descriptor28, this);
        $39f0567a8610a817$var$_defineProperty(this, "setEditedHoursProgressInPeriod", (period, phaseId, roleId, staffId, percent)=>{
            const ids = this.getLeafPhaseIds(phaseId, roleId, staffId).filter(([p, r, s])=>{
                const staff = (0, $htkeB.default).staffById[s];
                return staffId || (staff === null || staff === void 0 ? void 0 : staff.isArchived) === false;
            });
            ids.forEach(([p, r, s])=>{
                const periodBefore = (0, $4hBm1.format)(this.subPeriods((0, $4hBm1.parse)(period, this.periodFormat(), new Date(), {
                    weekStartsOn: 1
                }), 1), this.periodFormat());
                const hoursBeforePeriod = this.getHoursToDateInPeriod(periodBefore, p, r, s);
                const budget = this.getHoursBudget(p, r, s);
                const newHours = Math.max(budget * percent - hoursBeforePeriod, 0);
                this.setEditedHoursInPeriod(period, p, r, s, newHours);
            });
            this.prepareToSave();
        });
        $39f0567a8610a817$var$_defineProperty(this, "getAllocationHoursInPeriod", (0, $Ds2V9.computedFn)((period, phaseId, roleId, staffId)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.queryData.allocations.filter((a)=>{
                const staff = (0, $htkeB.default).staffById[a.staffId] || $39f0567a8610a817$var$noStaff;
                const role = (staff === null || staff === void 0 ? void 0 : staff.role) || (0, $bxXv3.default).rolesById[a.roleId] || $39f0567a8610a817$var$noRole;
                return (!phaseId || a.phaseId === phaseId) && a[this.periodType] === period && (staffId === "nostaff" ? !a.staffId : !staffId || (staff === null || staff === void 0 ? void 0 : staff.id) === staffId) && (!roleId || (role === null || role === void 0 ? void 0 : role.id) === roleId);
            }).map((a)=>a.hours));
        }));
        $39f0567a8610a817$var$_defineProperty(this, "getHoursInPeriod", (0, $Ds2V9.computedFn)((period, phaseId, roleId, staffId)=>{
            if (!period) return 0;
            if (!staffId || !phaseId) {
                const ids = this.getLeafPhaseIds(phaseId, roleId, staffId);
                return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(ids.map(([p, r, s])=>{
                    if (!p || !s) return 0;
                    return this.getHoursInPeriod(period, p, r || null, s);
                }));
            }
            const thisPeriod = (0, $4hBm1.format)(new Date(), this.periodFormat());
            const isPastPeriod = period < thisPeriod;
            const isFuturePeriod = period > thisPeriod;
            const isCurrentPeriod = period === thisPeriod;
            if (isPastPeriod) return this.getTimeEntryHoursInPeriod(period, phaseId, roleId, staffId);
            if (isFuturePeriod) {
                const edits = this.getEditedAllocationHoursInPeriod(period, phaseId, roleId, staffId);
                const allocations = this.getAllocationHoursInPeriod(period, phaseId, roleId, staffId);
                return edits !== null && edits !== void 0 ? edits : allocations;
            }
            if (isCurrentPeriod) {
                const edits = this.getEditedAllocationHoursInPeriod(period, phaseId, roleId, staffId);
                const allocations = this.getAllocationHoursInPeriod(period, phaseId, roleId, staffId);
                return Math.max(this.getTimeEntryHoursInPeriod(period, phaseId, roleId, staffId), edits !== null && edits !== void 0 ? edits : allocations);
            }
            return 0;
        }));
        $39f0567a8610a817$var$_defineProperty(this, "getHoursToDateInPeriod", (0, $Ds2V9.computedFn)((period, phaseId, roleId, staffId)=>{
            const periodsPrior = this.periods.filter((m)=>m <= period);
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(periodsPrior.map((m)=>this.getHoursInPeriod(m, phaseId, roleId, staffId)));
        }));
        $39f0567a8610a817$var$_defineProperty(this, "getTotalHours", (0, $Ds2V9.computedFn)((phaseId, roleId, staffId)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.periods.map((m)=>this.getHoursInPeriod(m, phaseId, roleId, staffId)));
        }));
        $39f0567a8610a817$var$_defineProperty(this, "getHoursBudget", (0, $Ds2V9.computedFn)((phaseId, roleId, staffId)=>{
            if (!phaseId || !(roleId || staffId)) {
                const ids = this.getLeafBudgetIds(phaseId, roleId, staffId);
                return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(ids.map(([p, r, s])=>{
                    if (!p) return 0;
                    return this.getHoursBudget(p, r, s);
                }));
            }
            const phase = this.queryData.projects[0].phases.find((p)=>p.id === phaseId);
            if (!phase) return 0;
            const budgets = phase.budgets.filter((b)=>{
                const bStaff = (0, $htkeB.default).staffById[b.staffId];
                const bRoleId = (bStaff === null || bStaff === void 0 ? void 0 : bStaff.roleId) || b.roleId;
                const bRole = (bStaff === null || bStaff === void 0 ? void 0 : bStaff.role) || (0, $bxXv3.default).rolesById[b.roleId];
                // If looking for a specific staff member
                if (staffId && staffId !== "nostaff") return b.staffId === staffId;
                // If looking for unassigned staff under a specific role
                if (staffId === "nostaff" && roleId) return !b.staffId && bRoleId === roleId;
                // If aggregating at role level (no staffId specified)
                if (!staffId && roleId) return bRoleId === roleId || !bRoleId && roleId === "norole";
                // Phase level aggregation
                return true;
            });
            if (!(budgets !== null && budgets !== void 0 && budgets.length)) return 0;
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(budgets.map((b)=>b.hours));
        }));
        $39f0567a8610a817$var$_defineProperty(this, "getExpenseIds", (0, $Ds2V9.computedFn)((phaseId, expenseName, includeClis)=>{
            let ids = [];
            const phaseIds = phaseId ? [
                phaseId
            ] : this.queryData.projects[0].phases.map((p)=>p.id);
            phaseIds.forEach((p)=>{
                const phase = this.queryData.projects[0].phases.find((ph)=>ph.id === p);
                const changeLogItems = includeClis ? this.queryData.changeLog.filter((cli)=>cli.phaseId === p && cli.expenses) : [];
                const expenseNames = expenseName ? [
                    expenseName
                ] : [
                    ...new Set([
                        ...(phase === null || phase === void 0 ? void 0 : phase.expenses.map((e)=>e.name)) || [],
                        ...(changeLogItems === null || changeLogItems === void 0 ? void 0 : changeLogItems.map((c)=>c.name)) || []
                    ])
                ];
                expenseNames.forEach((e)=>{
                    ids.push([
                        p,
                        e
                    ]);
                });
            });
            return ids;
        }));
        $39f0567a8610a817$var$_defineProperty(this, "getAllocatedExpensesInPeriod", (0, $Ds2V9.computedFn)((period, phaseId, expenseName)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.queryData.expenseAllocations.filter((ea)=>{
                return (!phaseId || ea.phaseId === phaseId) && ea[this.periodType] === period && (!expenseName || (ea === null || ea === void 0 ? void 0 : ea.name) === expenseName);
            }).map((te)=>te.amount));
        }));
        $39f0567a8610a817$var$_defineProperty(this, "getChangeLogExpensesInPeriod", (0, $Ds2V9.computedFn)((period, phaseId, expenseName)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.queryData.changeLog.filter((cli)=>{
                return (!phaseId || cli.phaseId === phaseId) && cli[this.periodType] === period && (!expenseName || (cli === null || cli === void 0 ? void 0 : cli.name) === expenseName);
            }).map((te)=>te.expenses));
        }));
        $39f0567a8610a817$var$_defineProperty(this, "getEditedExpensesInPeriod", (0, $Ds2V9.computedFn)((period, phaseId, expenseName)=>{
            var _this$editedExpenses$3, _this$project7;
            return (_this$editedExpenses$3 = this.editedExpenses[(_this$project7 = this.project) === null || _this$project7 === void 0 ? void 0 : _this$project7.id][this.periodType][period + phaseId + expenseName]) === null || _this$editedExpenses$3 === void 0 ? void 0 : _this$editedExpenses$3.amount;
        }));
        $39f0567a8610a817$var$_initializerDefineProperty(this, "setEditedExpensesInPeriod", $39f0567a8610a817$var$_descriptor29, this);
        $39f0567a8610a817$var$_defineProperty(this, "setEditedExpensesProgressInPeriod", (period, phaseId, expenseName, percent)=>{
            const ids = this.getExpenseIds(phaseId, expenseName, false);
            ids.forEach(([p, e])=>{
                const periodBefore = (0, $4hBm1.format)(this.subPeriods((0, $4hBm1.parse)(period, this.periodFormat(), new Date(), {
                    weekStartsOn: 1
                }), 1), this.periodFormat());
                const expensesBeforePeriod = this.getExpensesToDateInPeriod(periodBefore, p, e);
                const budget = this.getExpensesBudget(p, e);
                const cliExpenses = this.getChangeLogExpensesInPeriod(period, p, e);
                const newExpenses = Math.max(budget * percent - expensesBeforePeriod - cliExpenses, 0);
                this.setEditedExpensesInPeriod(period, p, e, newExpenses);
            });
            this.prepareToSave();
        });
        $39f0567a8610a817$var$_defineProperty(this, "getExpensesInPeriod", (0, $Ds2V9.computedFn)((period, phaseId, expenseName)=>{
            if (!period) return 0;
            const ids = this.getExpenseIds(phaseId, expenseName, true);
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(ids.map(([p, e])=>this.getEditedExpensesInPeriod(period, p, e) || this.getAllocatedExpensesInPeriod(period, p, e) + this.getChangeLogExpensesInPeriod(period, p, e)));
        }));
        $39f0567a8610a817$var$_defineProperty(this, "getExpensesToDateInPeriod", (0, $Ds2V9.computedFn)((period, phaseId, expenseName)=>{
            const periodsPrior = this.periods.filter((m)=>m <= period);
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(periodsPrior.map((m)=>this.getExpensesInPeriod(m, phaseId, expenseName)));
        }));
        $39f0567a8610a817$var$_defineProperty(this, "getTotalExpenses", (0, $Ds2V9.computedFn)((phaseId, expenseName)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.periods.map((m)=>this.getExpensesInPeriod(m, phaseId, expenseName)));
        }));
        $39f0567a8610a817$var$_defineProperty(this, "getExpensesBudget", (0, $Ds2V9.computedFn)((phaseId, expenseName)=>{
            const ids = this.getExpenseIds(phaseId, expenseName, false);
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(ids.map(([p, e])=>{
                const phase = this.queryData.projects[0].phases.find((ph)=>ph.id === p);
                const expense = phase.expenses.find((ex)=>ex.name === e);
                return (expense === null || expense === void 0 ? void 0 : expense.cost) || 0;
            }));
        }));
        $39f0567a8610a817$var$_defineProperty(this, "staffTableColumns", (0, $Ds2V9.computedFn)((getIds = (row)=>[
                row.id,
                null,
                null
            ])=>{
            const showCost = this.cellType === "currency";
            return [
                ...this.labelColumns,
                {
                    id: "budgetUse",
                    label: /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                        children: [
                            "Total",
                            /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                                style: {
                                    fontSize: "1.5em",
                                    float: "right"
                                },
                                onClick: (e)=>e.stopPropagation(),
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                        className: `fa fa-caret-left`,
                                        style: {
                                            cursor: "pointer"
                                        },
                                        onClick: ()=>this.shiftDates(-1)
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                        className: `fa fa-caret-right`,
                                        style: {
                                            marginRight: 0,
                                            cursor: "pointer"
                                        },
                                        onClick: ()=>this.shiftDates(1)
                                    })
                                ]
                            })
                        ]
                    }),
                    type: "progress",
                    width: 18,
                    editable: (row)=>false,
                    format: (v)=>showCost ? (0, $12o9H.FormatCurrency)(v, {
                            decimals: 0
                        }) : (0, $cwjKY.FormatNumber)(v, {
                            decimals: 0
                        }),
                    value: (row, stores)=>{
                        if (row === this.project) row = null;
                        return {
                            numerator: showCost ? this.getTotalCost(...getIds(row)) : this.getTotalHours(...getIds(row)),
                            denominator: showCost ? this.getCostBudget(...getIds(row)) : this.getHoursBudget(...getIds(row))
                        };
                    },
                    style: (row)=>({
                            textAlign: "left",
                            justifyContent: "flex-start",
                            color: row && showCost && Math.round(this.getTotalCost(...getIds(row))) > Math.round(this.getCostBudget(...getIds(row))) || row && !showCost && Math.round(this.getTotalHours(...getIds(row))) > Math.round(this.getHoursBudget(...getIds(row))) ? "red" : ""
                        })
                },
                ...[
                    ...Array(12)
                ].map((v, i)=>{
                    var _this$displayedProjec;
                    const currentPeriodStart = this.startOfPeriod(new Date());
                    const periodStart = this.addPeriods(this.startDate, i);
                    const periodId = (0, $4hBm1.format)(periodStart, this.periodFormat());
                    const project = ((_this$displayedProjec = this.displayedProjectOrPhase) === null || _this$displayedProjec === void 0 ? void 0 : _this$displayedProjec.project) || this.displayedProjectOrPhase;
                    const periodType = periodStart.getTime() === currentPeriodStart.getTime() ? "current" : periodStart.getTime() > currentPeriodStart.getTime() ? "future" : "past";
                    const user = (0, $1BTI2.default).user;
                    const isPastPeriod = periodType === "past";
                    const isCurrentPeriod = periodType === "current";
                    const isFuturePeriod = periodType === "future";
                    return {
                        id: periodStart.getTime(),
                        label: (0, $4hBm1.format)(periodStart, this.periodDisplayFormat()),
                        type: this.cellType,
                        format: (v)=>showCost ? (0, $12o9H.FormatCurrency)(v, {
                                decimals: 0
                            }) : (0, $cwjKY.FormatNumber)(v, {
                                decimals: 0
                            }),
                        width: 8,
                        editable: (row, stores)=>{
                            return (isCurrentPeriod || isFuturePeriod) && (0, $8kZ1o.canEditStaffAllocations)((0, $1BTI2.default).user, project) && (!showCost || (0, $8kZ1o.canViewStaffCostRate)(user, project));
                        },
                        style: (row, stores)=>{
                            var _stores$cell;
                            const hasDatesInRange = (row === null || row === void 0 ? void 0 : row.startDate) && (row === null || row === void 0 ? void 0 : row.endDate) && periodStart >= this.startOfPeriod(row.startDate) && periodStart <= this.endOfPeriod(row.endDate);
                            return {
                                ...isPastPeriod ? {
                                    backgroundImage: `url(${new URL((parcelRequire("3vc8e")))})`
                                } : {},
                                ...(stores === null || stores === void 0 ? void 0 : (_stores$cell = stores.cell) === null || _stores$cell === void 0 ? void 0 : _stores$cell.value) > 0 ? {
                                    borderBottom: "5px gold solid"
                                } : hasDatesInRange ? {
                                    borderBottom: "3px #d7d7d7 solid"
                                } : {}
                            };
                        },
                        value: (row, stores)=>{
                            return showCost ? this.getCostInPeriod(periodId, ...getIds(row)) : this.getHoursInPeriod(periodId, ...getIds(row));
                        },
                        onChange: (row, stores)=>(v)=>{
                                showCost ? this.setEditedCostInPeriod(periodId, ...getIds(row), v) : this.setEditedHoursInPeriod(periodId, ...getIds(row), v);
                            },
                        onClick: (r, stores)=>()=>{
                                this.selectCell(periodStart, (r === null || r === void 0 ? void 0 : r.id) || this.project.id, stores.table, (0, $XoImS.default).phasesById[getIds(r)[0]] || this.project);
                            },
                        selected: (r, stores)=>{
                            return this.selectedObject === ((r === null || r === void 0 ? void 0 : r.id) || this.project.id) && (0, $4hBm1.format)(this.selectedPeriod, this.periodFormat()) === (0, $4hBm1.format)(periodStart, this.periodFormat()) && this.selectedTable === stores.table;
                        }
                    };
                }),
                {
                    id: "project",
                    label: "Project",
                    type: "project",
                    width: 25,
                    visible: false,
                    value: (row)=>this.project
                },
                {
                    id: "phase",
                    label: "Phase",
                    type: "phase",
                    width: 25,
                    visible: false,
                    value: (row)=>row.phase
                },
                {
                    id: "staff",
                    label: "Staff",
                    type: "staff",
                    width: 25,
                    visible: false,
                    value: (row)=>row.staff
                },
                {
                    id: "role",
                    label: "Role",
                    type: "role",
                    width: 25,
                    visible: false,
                    value: (row)=>row.role
                }
            ];
        }));
        $39f0567a8610a817$var$_defineProperty(this, "expensePhaseTableRows", (0, $Ds2V9.computedFn)((phaseId)=>{
            if (!this.queryData) return [];
            const phase = this.queryData.projects[0].phases.find((ph)=>ph.id === phaseId);
            const expenses = (phase === null || phase === void 0 ? void 0 : phase.expenses) || [];
            const changeLogItems = this.queryData.changeLog.filter((cli)=>(cli === null || cli === void 0 ? void 0 : cli.phaseId) === phaseId && (cli === null || cli === void 0 ? void 0 : cli.expenses));
            return [
                ...new Set([
                    ...expenses.map((e)=>e === null || e === void 0 ? void 0 : e.name),
                    ...changeLogItems.map((cli)=>cli === null || cli === void 0 ? void 0 : cli.name)
                ])
            ].filter((r)=>r);
        }));
        (0, $4JcCM.makeObservable)(this);
    }
    init(queryData, period, selectedProjectOrPhase, periodType) {
        var _this$project8, _this$editedRevenueTa4, _this$project$id, _this$editedRevenueTa5, _this$project9, _this$editedAllocatio8, _this$project$id2, _this$editedAllocatio9, _this$project10, _this$editedExpenses, _this$project$id3, _this$editedExpenses$4, _this$project11, _this$editedRevenueTa6, _this$periodType4, _this$editedRevenueTa7, _this$project12, _this$editedAllocatio10, _this$periodType5, _this$editedAllocatio11, _this$project13, _this$editedExpenses$5, _this$periodType6, _this$editedExpenses$6, _this$project14;
        this.queryData = queryData;
        const project = (0, $gJT7h.default).projectsById[queryData.projects[0].id];
        const isNewProject = ((_this$project8 = this.project) === null || _this$project8 === void 0 ? void 0 : _this$project8.id) !== project.id;
        this.project = project;
        this.graphType = (0, $8kZ1o.canViewRevenueTargets)((0, $1BTI2.default).user, project) && (0, $8kZ1o.canViewProjectExpenses)((0, $1BTI2.default).user, project) && (0, $8kZ1o.canViewProjectFees)((0, $1BTI2.default).user, project) && (0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, project) ? "revenueVsExpenses" : "hoursBudget";
        this.graphData = "actualsProjected";
        this.startDate = this.startOfPeriod(this.subPeriods(new Date(), 3));
        this.endDate = this.endOfPeriod(this.addPeriods(new Date(), 8));
        this.selectedTable = null;
        this.selectedObject = null;
        this.selectedPeriod = null;
        (_this$editedRevenueTa5 = (_this$editedRevenueTa4 = this.editedRevenueTargets)[_this$project$id = (_this$project9 = this.project) === null || _this$project9 === void 0 ? void 0 : _this$project9.id]) !== null && _this$editedRevenueTa5 !== void 0 ? _this$editedRevenueTa5 : _this$editedRevenueTa4[_this$project$id] = {};
        (_this$editedAllocatio9 = (_this$editedAllocatio8 = this.editedAllocations)[_this$project$id2 = (_this$project10 = this.project) === null || _this$project10 === void 0 ? void 0 : _this$project10.id]) !== null && _this$editedAllocatio9 !== void 0 ? _this$editedAllocatio9 : _this$editedAllocatio8[_this$project$id2] = {};
        (_this$editedExpenses$4 = (_this$editedExpenses = this.editedExpenses)[_this$project$id3 = (_this$project11 = this.project) === null || _this$project11 === void 0 ? void 0 : _this$project11.id]) !== null && _this$editedExpenses$4 !== void 0 ? _this$editedExpenses$4 : _this$editedExpenses[_this$project$id3] = {};
        this.generatePhaseStaffAndRoleRows();
        if (periodType) this.setPeriodType(periodType);
        if (period) this.selectedPeriod = period;
        if (selectedProjectOrPhase) this.selectedProjectOrPhase = selectedProjectOrPhase;
        (_this$editedRevenueTa7 = (_this$editedRevenueTa6 = this.editedRevenueTargets[(_this$project12 = this.project) === null || _this$project12 === void 0 ? void 0 : _this$project12.id])[_this$periodType4 = this.periodType]) !== null && _this$editedRevenueTa7 !== void 0 ? _this$editedRevenueTa7 : _this$editedRevenueTa6[_this$periodType4] = {};
        (_this$editedAllocatio11 = (_this$editedAllocatio10 = this.editedAllocations[(_this$project13 = this.project) === null || _this$project13 === void 0 ? void 0 : _this$project13.id])[_this$periodType5 = this.periodType]) !== null && _this$editedAllocatio11 !== void 0 ? _this$editedAllocatio11 : _this$editedAllocatio10[_this$periodType5] = {};
        (_this$editedExpenses$6 = (_this$editedExpenses$5 = this.editedExpenses[(_this$project14 = this.project) === null || _this$project14 === void 0 ? void 0 : _this$project14.id])[_this$periodType6 = this.periodType]) !== null && _this$editedExpenses$6 !== void 0 ? _this$editedExpenses$6 : _this$editedExpenses$5[_this$periodType6] = {};
        this.uuid = (0, (/*@__PURE__*/$parcel$interopDefault($gN0TC)))();
    }
    reset() {
        this.graphType = "revenueVsExpenses";
        this.graphData = "actualsProjected";
        this.startDate = this.startOfPeriod(this.subPeriods(new Date(), 3));
        this.endDate = this.endOfPeriod(this.addPeriods(new Date(), 8));
        this.selectedTable = null;
        this.selectedObject = null;
        this.selectedPeriod = null;
        this.updateRevenueWithExpenses = (0, $8kZ1o.shouldUpdateRevenueFromHours)();
        this.updateExpensesWithRevenue = (0, $8kZ1o.shouldUpdateHoursFromRevenue)();
        this.editedRevenueTargets = {};
        this.editedAllocations = {};
        this.editedExpenses = {};
    }
    setFilterByPhase(phase) {
        this.filterByPhase = phase;
    }
    setUpdateRevenueWithExpenses(value) {
        this.updateRevenueWithExpenses = value;
    }
    setUpdateExpensesWithRevenue(value) {
        this.updateExpensesWithRevenue = value;
    }
    generatePhaseStaffAndRoleRows() {
        const phaseRoleRowsByPhaseId = {};
        const phaseStaffRowsByPhaseRoleId = {};
        [
            ...this.queryData.timeEntries,
            ...this.queryData.allocations,
            ...this.queryData.projects[0].phases.flatMap((ph)=>ph.budgets)
        ].forEach((item)=>{
            var _item$phaseId, _phaseRoleRowsByPhase, _this$staffByPhase, _item$phaseId2, _this$staffByPhase$_i;
            // Don't modify the original item, work with local variables
            const itemRoleId = item.roleId || "norole";
            const itemStaffId = item.staffId || "nostaff";
            const staff = (0, $htkeB.default).staffById[item.staffId] || (item.staffId ? null : $39f0567a8610a817$var$noStaff);
            const role = (staff === null || staff === void 0 ? void 0 : staff.role) || (0, $bxXv3.default).rolesById[item.roleId] || $39f0567a8610a817$var$noRole;
            (_phaseRoleRowsByPhase = phaseRoleRowsByPhaseId[_item$phaseId = item.phaseId]) !== null && _phaseRoleRowsByPhase !== void 0 ? _phaseRoleRowsByPhase : phaseRoleRowsByPhaseId[_item$phaseId] = new Set();
            phaseRoleRowsByPhaseId[item.phaseId].add(role || "(No Role)");
            if (staff) {
                var _ref, _phaseStaffRowsByPhas;
                (_phaseStaffRowsByPhas = phaseStaffRowsByPhaseRoleId[_ref = item.phaseId + (role === null || role === void 0 ? void 0 : role.id)]) !== null && _phaseStaffRowsByPhas !== void 0 ? _phaseStaffRowsByPhas : phaseStaffRowsByPhaseRoleId[_ref] = new Set();
                phaseStaffRowsByPhaseRoleId[item.phaseId + (role === null || role === void 0 ? void 0 : role.id)].add(staff);
            }
            this.projectStaff.add(staff);
            (_this$staffByPhase$_i = (_this$staffByPhase = this.staffByPhase)[_item$phaseId2 = item.phaseId]) !== null && _this$staffByPhase$_i !== void 0 ? _this$staffByPhase$_i : _this$staffByPhase[_item$phaseId2] = new Set();
            this.staffByPhase[item.phaseId].add(staff);
        });
        this.phaseRoleRowsByPhaseId = Object.fromEntries(Object.entries(phaseRoleRowsByPhaseId).map(([k, v])=>[
                k,
                Array.from(v)
            ]));
        this.phaseStaffRowsByPhaseRoleId = Object.fromEntries(Object.entries(phaseStaffRowsByPhaseRoleId).map(([k, v])=>[
                k,
                Array.from(v)
            ]));
    }
    get periods() {
        var _this$project15, _this$project16, _this$project17;
        const periods = new Set([
            ...this.queryData.timeEntries.map((i)=>i[this.periodType]),
            ...this.queryData.invoices.map((i)=>i[this.periodType]),
            ...this.queryData.allocations.map((e)=>e[this.periodType]),
            ...this.queryData.expenseAllocations.map((e)=>e[this.periodType]),
            ...this.queryData.changeLog.map((r)=>r[this.periodType]),
            ...this.queryData.revenueTargets.map((rt)=>rt[this.periodType]),
            ...Object.values(this.editedAllocations[(_this$project15 = this.project) === null || _this$project15 === void 0 ? void 0 : _this$project15.id][this.periodType]).map((a)=>a[this.periodType]),
            ...Object.values(this.editedRevenueTargets[(_this$project16 = this.project) === null || _this$project16 === void 0 ? void 0 : _this$project16.id][this.periodType]).map((rt)=>rt[this.periodType]),
            ...Object.values(this.editedExpenses[(_this$project17 = this.project) === null || _this$project17 === void 0 ? void 0 : _this$project17.id][this.periodType]).map((rt)=>rt[this.periodType])
        ]);
        return Array.from(periods).sort();
    }
    get maxPeriod() {
        return this.periods[this.periods.length - 1];
    }
    get minPeriod() {
        return this.periods[0];
    }
    getRevenueProgressInPeriod(period, phaseId) {
        return this.getRevenueToDateInPeriod(period, phaseId) / this.getFee(phaseId);
    }
    async prepareToSave() {
        const DataStoreModule = await Promise.resolve((parcelRequire("fM2j4")));
        const DataStore = DataStoreModule.default;
        const organisationId = (0, $1BTI2.default).organisationId;
        const projectId = this.project.id;
        const periodType = this.periodType;
        const revenueTargets = Object.values(this.editedRevenueTargets[projectId][periodType]);
        const allocations = Object.values(this.editedAllocations[projectId][periodType]);
        const expenses = Object.values(this.editedExpenses[projectId][periodType]);
        DataStore.addSaveFunction(`${projectId}-forecasts`, ()=>this.saveChanges({
                id: `${projectId}-forecasts`,
                organisationId: organisationId,
                projectId: projectId,
                revenueTargets: revenueTargets,
                allocations: allocations,
                expenses: expenses,
                periodType: periodType
            }));
    }
    async saveChanges({ id: id, organisationId: organisationId, projectId: projectId, revenueTargets: revenueTargets, allocations: allocations, expenses: expenses, periodType: periodType }) {
        if (this.savingIds.has(id)) return;
        this.savingIds.add(id);
        return (0, $iOQGT.makeRequest)({
            baseURL: "https://server2.coincraft.co",
            path: "/project-forecast/save",
            method: "POST",
            data: {
                organisationId: organisationId,
                projectId: projectId,
                revenueTargets: revenueTargets,
                allocations: allocations,
                expenses: expenses,
                periodType: periodType
            }
        }).then((res)=>{
            this.savingIds.delete(id);
            return res;
        });
    }
    getLeafBudgetIds(phaseId, roleId, staffId) {
        const leafIds = [];
        const phaseIds = phaseId ? [
            phaseId
        ] : this.queryData.projects[0].phases.map((p)=>p === null || p === void 0 ? void 0 : p.id);
        phaseIds.forEach((phId)=>{
            var _this$queryData$proje;
            const budgets = ((_this$queryData$proje = this.queryData.projects[0].phases.find((p)=>p.id === phId)) === null || _this$queryData$proje === void 0 ? void 0 : _this$queryData$proje.budgets) || [];
            const filteredBudgets = budgets.filter((b)=>{
                const bStaff = (0, $htkeB.default).staffById[b.staffId];
                const bRoleId = (bStaff === null || bStaff === void 0 ? void 0 : bStaff.roleId) || b.roleId;
                // Filter by role if specified
                if (roleId && roleId !== "norole" && bRoleId !== roleId) return false;
                if (roleId === "norole" && bRoleId) return false;
                // Filter by staff if specified
                if (staffId === "nostaff") return !b.staffId;
                if (staffId && staffId !== "nostaff") return b.staffId === staffId;
                return true;
            });
            leafIds.push(...filteredBudgets.map((b)=>{
                const bStaff = (0, $htkeB.default).staffById[b.staffId];
                const bRoleId = (bStaff === null || bStaff === void 0 ? void 0 : bStaff.roleId) || b.roleId;
                return [
                    phId,
                    bRoleId || "norole",
                    b.staffId || "nostaff"
                ];
            }));
        });
        return leafIds;
    }
    setDisplayedProjectOrPhase(projectOrPhase) {
        this.displayedProjectOrPhase = projectOrPhase;
    }
    setGraphType(graphType) {
        this.graphType = graphType;
    // this.updateColumns()
    }
    setGraphData(graphData) {
        this.graphData = graphData;
    }
    get isCumulative() {
        return [
            "revenueVsExpenses",
            "expenseBudget",
            "hoursBudget"
        ].includes(this.graphType);
    }
    get labelColumns() {
        return [
            {
                id: "label",
                label: "Title",
                type: "text",
                width: 18,
                editable: (row)=>false,
                value: (row, stores)=>{
                    if (stores.row.group && stores.row.cells[stores.row.group].formattedValue) return stores.row.cells[stores.row.group].formattedValue;
                    return row.label || row.title || row.name || row.expenseName || row.fullName || String(row);
                },
                component: ({ value: value, group: group, stores: stores })=>{
                    const { row: row, table: table } = stores;
                    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            paddingLeft: `${1 * row.groupLevel}rem`
                        },
                        children: [
                            row.group !== "project" && row.childRows.length ? /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                className: `fa fa-${`caret-${row.expanded ? "down" : "right"}`} fa-fw`,
                                onClick: ()=>table.toggleRowExpand(row)
                            }) : null,
                            value
                        ]
                    });
                }
            }
        ];
    }
    get cellType() {
        return [
            "hoursBudget",
            "hoursBudgetMonthly"
        ].includes(this.graphType) ? "number" : "currency";
    }
    get budgetColumns() {
        const isExpenseRow = (row)=>row instanceof (0, $bvRAk.default);
        const isStaffPhaseRow1 = (row)=>row instanceof (0, $3KSJP.default);
        const isRevenueRow = (row)=>row instanceof (0, $lOQvu.default);
        const getNumerator = (row, table)=>{
            if (isExpenseRow(row)) return row.getTotalExpense(this.graphData);
            if (isStaffPhaseRow1(row)) return this.cellType === "currency" ? row.getTotalCost() : row.getTotalHours();
            if (isRevenueRow(row)) return row.getTotalRevenue();
            return 0;
        };
        const getDenominator = (row, table)=>{
            if (isExpenseRow(row)) return row.expenseBudget;
            if (isStaffPhaseRow1(row) && this.cellType === "currency") return row.resource ? row.costBudget : row.phase.expenseBudget;
            if (isStaffPhaseRow1(row) && this.cellType === "number") return row.resource ? row.hoursBudget : row.phase.hoursBudget;
            if (isRevenueRow(row)) return row.fee;
            return 0;
        };
        return [
            {
                id: "budgetUse",
                label: /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                    children: [
                        "Total",
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                            style: {
                                fontSize: "1.5em",
                                float: "right"
                            },
                            onClick: (e)=>e.stopPropagation(),
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                    className: `fa fa-caret-left`,
                                    style: {
                                        cursor: "pointer"
                                    },
                                    onClick: ()=>this.shiftDates(-1)
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                    className: `fa fa-caret-right`,
                                    style: {
                                        marginRight: 0,
                                        cursor: "pointer"
                                    },
                                    onClick: ()=>this.shiftDates(1)
                                })
                            ]
                        })
                    ]
                }),
                type: "progress",
                width: 18,
                editable: (row)=>false,
                format: this.cellType === "currency" ? (0, $azaaH.default).currency : (0, $azaaH.default).number,
                value: (row, stores)=>({
                        numerator: getNumerator(row, stores.table),
                        denominator: getDenominator(row, stores.table)
                    }),
                style: (row)=>({
                        textAlign: "left",
                        justifyContent: "flex-start"
                    })
            }
        ];
    }
    getExpenseCellValue({ row: row, periodStart: periodStart, periodEnd: periodEnd }) {
        if (!periodStart) return 0;
        return row.getExpensesInPeriod((0, $4hBm1.format)(periodStart, this.periodFormat()), this.graphData);
    }
    getStaffCellValue({ row: row, periodStart: periodStart, periodEnd: periodEnd }) {
        if (!periodStart) return 0;
        return row[this.cellType === "currency" ? "getCostInPeriod" : "getHoursInPeriod"]((0, $4hBm1.format)(periodStart, this.periodFormat()));
    }
    updateRevenueValue({ model: model, value: value, stores: stores, periodStart: periodStart, periodEnd: periodEnd }) {
        (0, $hDUkm.editRevenueTargetsInDateRange)([
            ...model.revenueTargets,
            ...model.invoiceLineItems,
            ...model.changeLog.filter((cli)=>cli.revenue)
        ], [
            periodStart,
            periodEnd
        ], value, this.cellType === "currency" ? "cost" : "hours");
    }
    updateStaffValue({ model: model, value: value, stores: stores, periodStart: periodStart, periodEnd: periodEnd }) {
        (0, $5CHqX.editAllocationsInDateRange)(stores.row.descendants.map((r)=>r.rowObject), [
            periodStart,
            periodEnd
        ], value, this.cellType === "currency" ? "cost" : "hours");
    }
    updateExpenseValue({ model: model, value: value, stores: stores, periodStart: periodStart, periodEnd: periodEnd }) {
        const expenses = [
            "project",
            "phase"
        ].includes(model.modelType) ? model.expenses : model.modelType === "projectExpense" ? [
            model
        ] : [];
        const totalExpense = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(expenses.map((ex)=>(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(ex.allocations.filter((exAl)=>exAl.date >= periodStart && exAl.date <= periodEnd).map((exAl)=>exAl.amount))));
        if (expenses.length && totalExpense) {
            const revenueRatio = value / totalExpense;
            expenses.forEach((ex)=>ex.allocations.filter((exAl)=>exAl.date >= periodStart && exAl.date <= periodEnd).forEach((exAl)=>exAl.update({
                        amount: exAl.amount * revenueRatio
                    })));
        } else if (expenses.length && !totalExpense) {
            const splitAmount = value / expenses.length;
            expenses.forEach((ex)=>{
                const allocations = ex.allocations.filter((exAl)=>exAl.date >= periodStart && exAl.date <= periodEnd);
                if (allocations.length) {
                    const subSplitAmount = splitAmount / allocations.length;
                    allocations.forEach((exAl)=>exAl.update({
                            amount: subSplitAmount
                        }));
                } else (0, $d4jhX.default).add({
                    projectId: ex.projectId,
                    phaseId: ex.phaseId,
                    expenseId: ex.id,
                    amount: splitAmount,
                    date: periodStart
                });
            });
        }
    }
    get periodColumns() {
        var _this$displayedProjec2;
        const project = ((_this$displayedProjec2 = this.displayedProjectOrPhase) === null || _this$displayedProjec2 === void 0 ? void 0 : _this$displayedProjec2.project) || this.displayedProjectOrPhase;
        const user = (0, $1BTI2.default).user;
        const cols = [
            ...Array(12)
        ].map((v, i)=>{
            const currentPeriodStart = this.startOfPeriod(new Date());
            const periodStart = this.addPeriods(this.startDate, i);
            const periodEnd = this.endOfPeriod(periodStart);
            const periodType = periodStart.getTime() === currentPeriodStart.getTime() ? "current" : periodStart.getTime() > currentPeriodStart.getTime() ? "future" : "past";
            const isPastPeriod = periodType === "past";
            const isCurrentPeriod = periodType === "current";
            const isFuturePeriod = periodType === "future";
            const isExpenseRow = (row)=>row instanceof (0, $bvRAk.default);
            const isRevenueRow = (tableStore)=>tableStore === this.revenueTableStore;
            const periodId = (0, $4hBm1.format)(periodStart, this.periodFormat());
            return {
                id: periodStart.getTime(),
                label: periodId,
                type: this.cellType,
                width: 8,
                editable: (row, stores)=>{
                    if (isExpenseRow(row) && (0, $8kZ1o.canEditProjectExpenses)(user, project)) return isCurrentPeriod || isFuturePeriod;
                    if (isStaffPhaseRow(row) && ([
                        "hoursBudget",
                        "hoursBudgetMonthly"
                    ].includes(this.graphType) && (0, $8kZ1o.canEditStaffAllocations) || [
                        "revenueVsExpenses",
                        "revenueVsExpensesMonthly",
                        "expenseBudget",
                        "expenseBudgetMonthly"
                    ].includes(this.graphType) && (0, $8kZ1o.canEditStaffAllocations)((0, $1BTI2.default).user, project) && (0, $8kZ1o.canViewStaffCostRate)((0, $1BTI2.default).user, project))) return isCurrentPeriod || isFuturePeriod;
                    if (isRevenueRow(row) && (0, $8kZ1o.canEditRevenueTargets)(user, project)) return isCurrentPeriod || isFuturePeriod;
                    return false;
                },
                style: (row, stores)=>{
                    var _stores$cell2;
                    const hasDatesInRange = (row === null || row === void 0 ? void 0 : row.startDate) && (row === null || row === void 0 ? void 0 : row.endDate) && periodStart >= this.startOfPeriod(row.startDate) && periodStart <= this.endOfPeriod(row.endDate);
                    return {
                        ...isPastPeriod ? {
                            backgroundImage: `url(${new URL((parcelRequire("3vc8e")))})`
                        } : {},
                        ...(stores === null || stores === void 0 ? void 0 : (_stores$cell2 = stores.cell) === null || _stores$cell2 === void 0 ? void 0 : _stores$cell2.value) > 0 ? {
                            borderBottom: "5px gold solid"
                        } : hasDatesInRange ? {
                            borderBottom: "3px #d7d7d7 solid"
                        } : {}
                    };
                },
                value: (row, stores)=>{
                    if (isExpenseRow(row)) return this.getExpenseCellValue({
                        row: row,
                        periodStart: periodStart,
                        periodEnd: periodEnd
                    });
                    if (isStaffPhaseRow(stores.table)) return this.getCostInPeriod(periodId, row.id, null, null);
                    if (isStaffPhaseRow(stores.table) && this.cellType === "number") return this.getCostInPeriod(periodId, row.id, null, null);
                    if (isRevenueRow(stores.table)) return this.getRevenueInPeriod(periodId, row.id);
                },
                onChange: (r, stores)=>(v)=>{
                        v = v || 0;
                        if (isRevenueRow(r)) r.setRevenueInPeriod((0, $4hBm1.format)(periodStart, this.periodFormat()), v);
                        if (isStaffPhaseRow(r) && this.cellType === "number") r.setHoursInPeriod((0, $4hBm1.format)(periodStart, this.periodFormat()), v);
                        if (isStaffPhaseRow(r) && this.cellType === "currency") r.setCostInPeriod((0, $4hBm1.format)(periodStart, this.periodFormat()), v);
                        if (isExpenseRow(r)) r.setExpenseInPeriod((0, $4hBm1.format)(periodStart, this.periodFormat()), v, this.graphData);
                    },
                onClick: (r, stores)=>()=>{
                        if (r instanceof (0, $bvRAk.default)) return;
                        this.selectCell(periodStart, r, stores.table);
                    },
                selected: (r, stores)=>{
                    return this.selectedObject === r && (0, $4hBm1.format)(this.selectedPeriod, this.periodFormat()) === (0, $4hBm1.format)(periodStart, this.periodFormat()) && this.selectedTable === stores.table;
                }
            };
        });
        return cols;
    }
    selectCell(selectedPeriod, selectedObject, selectedTable, selectedProjectOrPhase) {
        this.selectedPeriod = selectedPeriod;
        this.selectedObject = selectedObject;
        this.selectedTable = selectedTable;
        this.selectedProjectOrPhase = selectedProjectOrPhase;
        (0, $khJQv.default).showSidebar = !!(selectedPeriod && selectedObject);
    }
    get graphRevenue() {
        return this.periodColumns.map((c)=>{
            const periodStart = new Date(c.id);
            const periodEnd = this.endOfPeriod(periodStart);
            const periodId = (0, $4hBm1.format)(periodStart, this.periodFormat());
            if (this.graphType === "revenueVsExpenses") return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.revenueTableRows.map((r)=>this.getRevenueToDateInPeriod(periodId, r === null || r === void 0 ? void 0 : r.id)));
            if (this.graphType === "expenseBudget") return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.staffPhaseTableRows.map((r)=>this.getCostBudget(r === null || r === void 0 ? void 0 : r.id, null, null)));
            if (this.graphType === "hoursBudget") return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.staffPhaseTableRows.map((r)=>this.getHoursBudget(r === null || r === void 0 ? void 0 : r.id, null, null)));
            if (this.graphType === "revenueVsExpensesMonthly") return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.revenueTableRows.map((r)=>this.getRevenueInPeriod(periodId, r === null || r === void 0 ? void 0 : r.id)));
            if (this.graphType === "expenseBudgetMonthly") return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.staffPhaseTableRows.map((r)=>this.getCostBudget(r === null || r === void 0 ? void 0 : r.id, null, null))) - (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.staffPhaseTableRows.map((r)=>this.getCostToDateInPeriod(periodId, r === null || r === void 0 ? void 0 : r.id, null, null))) - (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.expenseTableRows.map((r)=>this.getExpensesToDateInPeriod((0, $4hBm1.format)(periodStart, this.periodFormat()), r === null || r === void 0 ? void 0 : r.id, null)));
            if (this.graphType === "hoursBudgetMonthly") return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.staffPhaseTableRows.map((r)=>this.getHoursBudget(r === null || r === void 0 ? void 0 : r.id, null, null))) - (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.staffPhaseTableRows.map((r)=>this.getHoursToDateInPeriod(periodId, r === null || r === void 0 ? void 0 : r.id, null, null)));
            return null;
        });
    }
    get graphExpenses() {
        const currentPeriodStart = this.startOfPeriod(new Date());
        const currentPeriodEnd = this.endOfPeriod(new Date());
        return this.periodColumns.map((c)=>{
            const periodStart = new Date(c.id);
            const periodEnd = this.endOfPeriod(periodStart);
            const periodId = (0, $4hBm1.format)(periodStart, this.periodFormat());
            if ([
                "revenueVsExpenses",
                "expenseBudget"
            ].includes(this.graphType)) return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.staffPhaseTableRows.map((r)=>this.getCostToDateInPeriod(periodId, r === null || r === void 0 ? void 0 : r.id, null, null))) + (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.expenseTableRows.map((r)=>this.getExpensesToDateInPeriod((0, $4hBm1.format)(periodStart, this.periodFormat()), r === null || r === void 0 ? void 0 : r.id, null)));
            if (this.graphType === "hoursBudget") return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.staffPhaseTableRows.map((r)=>this.getHoursToDateInPeriod(periodId, r === null || r === void 0 ? void 0 : r.id, null, null)));
            if ([
                "revenueVsExpensesMonthly",
                "expenseBudgetMonthly"
            ].includes(this.graphType)) return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.staffPhaseTableRows.map((r)=>this.getCostInPeriod(periodId, r === null || r === void 0 ? void 0 : r.id, null, null))) + (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.expenseTableRows.map((r)=>this.getExpensesInPeriod(periodId, r === null || r === void 0 ? void 0 : r.id, null)));
            if (this.graphType === "hoursBudgetMonthly") return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.staffPhaseTableRows.map((r)=>this.getHoursInPeriod(periodId, r === null || r === void 0 ? void 0 : r.id, null, null)));
            return null;
        });
    }
    get showRevenueTable() {
        var _this$displayedProjec3;
        return [
            "revenueVsExpenses",
            "revenueVsExpensesMonthly"
        ].includes(this.graphType) && (0, $8kZ1o.canViewRevenueTargets)((0, $1BTI2.default).user, ((_this$displayedProjec3 = this.displayedProjectOrPhase) === null || _this$displayedProjec3 === void 0 ? void 0 : _this$displayedProjec3.project) || this.displayedProjectOrPhase);
    }
    get showStaffTable() {
        var _this$displayedProjec4;
        const project = ((_this$displayedProjec4 = this.displayedProjectOrPhase) === null || _this$displayedProjec4 === void 0 ? void 0 : _this$displayedProjec4.project) || this.displayedProjectOrPhase;
        return [
            "hoursBudget",
            "hoursBudgetMonthly"
        ].includes(this.graphType) || [
            "revenueVsExpenses",
            "revenueVsExpensesMonthly",
            "expenseBudget",
            "expenseBudgetMonthly"
        ].includes(this.graphType) && (0, $8kZ1o.canViewStaffAllocations)((0, $1BTI2.default).user, project) && (0, $8kZ1o.canViewStaffCostRate)((0, $1BTI2.default).user, project);
    }
    get showExpenseTable() {
        var _this$displayedProjec5;
        return [
            "revenueVsExpenses",
            "revenueVsExpensesMonthly",
            "expenseBudget",
            "expenseBudgetMonthly"
        ].includes(this.graphType) && (0, $8kZ1o.canViewProjectExpenses)((0, $1BTI2.default).user, ((_this$displayedProjec5 = this.displayedProjectOrPhase) === null || _this$displayedProjec5 === void 0 ? void 0 : _this$displayedProjec5.project) || this.displayedProjectOrPhase);
    }
    get revenueTableColumns() {
        return [
            $39f0567a8610a817$var$spacerColumn,
            ...this.labelColumns,
            {
                id: "budgetUse",
                label: /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                    children: [
                        "Total",
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                            style: {
                                fontSize: "1.5em",
                                float: "right"
                            },
                            onClick: (e)=>e.stopPropagation(),
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                    className: `fa fa-caret-left`,
                                    style: {
                                        cursor: "pointer"
                                    },
                                    onClick: ()=>this.shiftDates(-1)
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                    className: `fa fa-caret-right`,
                                    style: {
                                        marginRight: 0,
                                        cursor: "pointer"
                                    },
                                    onClick: ()=>this.shiftDates(1)
                                })
                            ]
                        })
                    ]
                }),
                type: "progress",
                width: 18,
                editable: (row)=>false,
                format: this.cellType === "currency" ? (0, $azaaH.default).currency : (0, $azaaH.default).number,
                value: (row, stores)=>{
                    return {
                        numerator: this.getTotalRevenue(row === null || row === void 0 ? void 0 : row.id),
                        denominator: this.getFee(row === null || row === void 0 ? void 0 : row.id)
                    };
                },
                format: (v)=>(0, $12o9H.FormatCurrency)(v, {
                        decimals: 0
                    }),
                style: (row)=>({
                        textAlign: "left",
                        justifyContent: "flex-start",
                        color: row && Math.round(this.getTotalRevenue(row === null || row === void 0 ? void 0 : row.id)) > Math.round(this.getFee(row === null || row === void 0 ? void 0 : row.id)) ? "red" : ""
                    })
            },
            ...[
                ...Array(12)
            ].map((v, i)=>{
                var _this$displayedProjec6;
                const currentPeriodStart = this.startOfPeriod(new Date());
                const periodStart = this.addPeriods(this.startDate, i);
                const periodId = (0, $4hBm1.format)(periodStart, this.periodFormat());
                const project = ((_this$displayedProjec6 = this.displayedProjectOrPhase) === null || _this$displayedProjec6 === void 0 ? void 0 : _this$displayedProjec6.project) || this.displayedProjectOrPhase;
                const periodType = periodStart.getTime() === currentPeriodStart.getTime() ? "current" : periodStart.getTime() > currentPeriodStart.getTime() ? "future" : "past";
                const user = (0, $1BTI2.default).user;
                const isPastPeriod = periodType === "past";
                const isCurrentPeriod = periodType === "current";
                const isFuturePeriod = periodType === "future";
                return {
                    id: periodStart.getTime(),
                    label: (0, $4hBm1.format)(periodStart, this.periodDisplayFormat()),
                    type: this.cellType,
                    width: 8,
                    editable: (row, stores)=>{
                        return (0, $8kZ1o.canEditRevenueTargets)(user, project) && (isCurrentPeriod || isFuturePeriod);
                    },
                    style: (row, stores)=>{
                        var _stores$cell3;
                        const hasDatesInRange = (row === null || row === void 0 ? void 0 : row.startDate) && (row === null || row === void 0 ? void 0 : row.endDate) && periodStart >= this.startOfPeriod(row.startDate) && periodStart <= this.endOfPeriod(row.endDate);
                        return {
                            ...isPastPeriod ? {
                                backgroundImage: `url(${new URL((parcelRequire("3vc8e")))})`
                            } : {},
                            ...(stores === null || stores === void 0 ? void 0 : (_stores$cell3 = stores.cell) === null || _stores$cell3 === void 0 ? void 0 : _stores$cell3.value) > 0 ? {
                                borderBottom: "5px gold solid"
                            } : hasDatesInRange ? {
                                borderBottom: "3px #d7d7d7 solid"
                            } : {}
                        };
                    },
                    value: (row, stores)=>{
                        return this.getRevenueInPeriod(periodId, row.id);
                    },
                    format: (v)=>(0, $12o9H.FormatCurrency)(v, {
                            decimals: 0
                        }),
                    onChange: (r, stores)=>(v)=>{
                            this.setEditedRevenueInPeriod(periodId, r === null || r === void 0 ? void 0 : r.id, v);
                        },
                    onClick: (r, stores)=>()=>{
                            this.selectCell(periodStart, (r === null || r === void 0 ? void 0 : r.id) || this.project.id, stores.table, (0, $XoImS.default).phasesById[r === null || r === void 0 ? void 0 : r.id] || this.project);
                        },
                    selected: (r, stores)=>{
                        return this.selectedObject === ((r === null || r === void 0 ? void 0 : r.id) || this.project.id) && (0, $4hBm1.format)(this.selectedPeriod, this.periodFormat()) === (0, $4hBm1.format)(periodStart, this.periodFormat()) && this.selectedTable === stores.table;
                    }
                };
            }),
            {
                id: "project",
                label: "Project",
                type: "project",
                width: 25,
                visible: false,
                value: (row)=>this.project
            }
        ];
    }
    expenseTableColumns(getIds = (phase)=>[
            phase.id,
            null
        ]) {
        return [
            ...this.labelColumns,
            {
                id: "budgetUse",
                label: /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                    children: [
                        "Total",
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                            style: {
                                fontSize: "1.5em",
                                float: "right"
                            },
                            onClick: (e)=>e.stopPropagation(),
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                    className: `fa fa-caret-left`,
                                    style: {
                                        cursor: "pointer"
                                    },
                                    onClick: ()=>this.shiftDates(-1)
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                    className: `fa fa-caret-right`,
                                    style: {
                                        marginRight: 0,
                                        cursor: "pointer"
                                    },
                                    onClick: ()=>this.shiftDates(1)
                                })
                            ]
                        })
                    ]
                }),
                type: "progress",
                width: 18,
                editable: (row)=>false,
                format: (v)=>(0, $12o9H.FormatCurrency)(v, {
                        decimals: 0
                    }),
                value: (row, stores)=>{
                    return {
                        numerator: this.getTotalExpenses(...getIds(row)),
                        denominator: this.getExpensesBudget(...getIds(row))
                    };
                },
                style: (row)=>{
                    return {
                        textAlign: "left",
                        justifyContent: "flex-start",
                        color: row && Math.round(this.getTotalExpenses(...getIds(row))) > Math.round(this.getExpensesBudget(...getIds(row))) ? "red" : ""
                    };
                }
            },
            ...[
                ...Array(12)
            ].map((v, i)=>{
                var _this$displayedProjec7;
                const currentPeriodStart = this.startOfPeriod(new Date());
                const periodStart = this.addPeriods(this.startDate, i);
                const periodId = (0, $4hBm1.format)(periodStart, this.periodFormat());
                const project = ((_this$displayedProjec7 = this.displayedProjectOrPhase) === null || _this$displayedProjec7 === void 0 ? void 0 : _this$displayedProjec7.project) || this.displayedProjectOrPhase;
                const periodType = periodStart.getTime() === currentPeriodStart.getTime() ? "current" : periodStart.getTime() > currentPeriodStart.getTime() ? "future" : "past";
                const user = (0, $1BTI2.default).user;
                const isPastPeriod = periodType === "past";
                const isCurrentPeriod = periodType === "current";
                const isFuturePeriod = periodType === "future";
                return {
                    id: periodStart.getTime(),
                    label: (0, $4hBm1.format)(periodStart, this.periodDisplayFormat()),
                    type: this.cellType,
                    width: 8,
                    editable: (row, stores)=>{
                        return (0, $8kZ1o.canEditProjectExpenses)(user, project);
                    },
                    style: (row, stores)=>{
                        var _stores$cell4;
                        const hasDatesInRange = (row === null || row === void 0 ? void 0 : row.startDate) && (row === null || row === void 0 ? void 0 : row.endDate) && periodStart >= this.startOfPeriod(row.startDate) && periodStart <= this.endOfPeriod(row.endDate);
                        return {
                            ...isPastPeriod ? {
                                backgroundImage: `url(${new URL((parcelRequire("3vc8e")))})`
                            } : {},
                            ...(stores === null || stores === void 0 ? void 0 : (_stores$cell4 = stores.cell) === null || _stores$cell4 === void 0 ? void 0 : _stores$cell4.value) > 0 ? {
                                borderBottom: "5px gold solid"
                            } : hasDatesInRange ? {
                                borderBottom: "3px #d7d7d7 solid"
                            } : {}
                        };
                    },
                    value: (row, stores)=>{
                        return this.getExpensesInPeriod(periodId, ...getIds(row));
                    },
                    format: (v)=>(0, $12o9H.FormatCurrency)(v, {
                            decimals: 0
                        }),
                    onChange: (row, stores)=>(v)=>{
                            this.setEditedExpensesInPeriod(periodId, ...getIds(row), v);
                        },
                    onClick: (r, stores)=>()=>{
                            this.selectCell(periodStart, (r === null || r === void 0 ? void 0 : r.id) || r || this.project.id, stores.table, (0, $XoImS.default).phasesById[r === null || r === void 0 ? void 0 : r.id] || this.project);
                        },
                    selected: (r, stores)=>{
                        return this.selectedObject === ((r === null || r === void 0 ? void 0 : r.id) || r || this.project.id) && (0, $4hBm1.format)(this.selectedPeriod, this.periodFormat()) === (0, $4hBm1.format)(periodStart, this.periodFormat()) && this.selectedTable === stores.table;
                    }
                };
            }),
            {
                id: "project",
                label: "Project",
                type: "project",
                width: 25,
                visible: false,
                value: (row)=>this.project
            },
            {
                id: "phase",
                label: "Phase",
                type: "phase",
                width: 25,
                visible: false,
                value: (row)=>row
            }
        ];
    }
    get revenueTableRows() {
        if (!this.queryData) return [];
        return [
            ...this.queryData.projects[0].phases
        ].sort((0, $6fNfM.default)).filter((ph)=>!(ph !== null && ph !== void 0 && ph.isRootPhase) && (this.filterByPhase && !this.filterByPhase.isRootPhase ? ph.id === this.filterByPhase.id : true));
    }
    get staffPhaseTableRows() {
        if (!this.queryData) return [];
        return [
            ...this.queryData.projects[0].phases
        ].sort((0, $6fNfM.default)).filter((ph)=>!(ph !== null && ph !== void 0 && ph.isRootPhase) && (this.filterByPhase && !this.filterByPhase.isRootPhase ? ph.id === this.filterByPhase.id : true));
    }
    get expenseTableRows() {
        if (!this.queryData) return [];
        return [
            ...this.queryData.projects[0].phases
        ].sort((0, $6fNfM.default)).filter((ph)=>!(ph !== null && ph !== void 0 && ph.isRootPhase) && (this.filterByPhase && !this.filterByPhase.isRootPhase ? ph.id === this.filterByPhase.id : true));
    }
    shiftDates(amount) {
        this.startDate = this.addPeriods(this.startDate, amount);
        this.endDate = this.addPeriods(this.endDate, amount);
    // this.updateColumns()
    }
    shiftSelectedDates(amount) {
        this.selectedPeriod = this.startOfPeriod(this.addPeriods(this.selectedPeriod, amount));
        if (amount < 0 && this.selectedPeriod < this.startDate) this.shiftDates(amount);
        else if (amount > 0 && this.selectedPeriod > this.endDate) this.shiftDates(amount);
    }
    get totalsLabelColumn() {
        const titleLookup = {
            revenueVsExpenses: "Profit",
            expenseBudget: "Remaining Budget",
            hoursBudget: "Remaining Budget"
        };
        return {
            id: "label",
            label: "Title",
            type: "text",
            width: 18,
            editable: (row)=>false,
            value: (row, stores)=>{
                return titleLookup[this.graphType.replace("Monthly", "")];
            },
            component: ({ value: value, group: group, stores: stores })=>{
                const { row: row, table: table } = stores;
                return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    style: {
                        paddingLeft: `${1 * row.groupLevel}rem`
                    },
                    children: [
                        row.group !== "project" && row.childRows.length ? /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                            className: `fa fa-${`caret-${row.expanded ? "down" : "right"}`} fa-fw`,
                            onClick: ()=>table.toggleRowExpand(row)
                        }) : null,
                        value
                    ]
                });
            }
        };
    }
    get totalsTotalColumn() {
        const totalValueLookup = {
            revenueVsExpenses: (row, stores)=>{
                return {
                    numerator: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.revenueTableRows.map((r)=>this.getTotalRevenue(r.id))) - (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.staffPhaseTableRows.map((r)=>this.getTotalCost(r.id, null, null))) - (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.expenseTableRows.map((r)=>this.getTotalExpenses(r.id, null))),
                    denominator: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.revenueTableRows.map((r)=>this.getTotalRevenue(r.id)))
                };
            },
            expenseBudget: (row, stores)=>{
                return {
                    numerator: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.staffPhaseTableRows.map((r)=>this.getTotalCost(r.id, null, null))) + (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.expenseTableRows.map((r)=>this.getTotalExpenses(r.id, null))),
                    denominator: this.getCostBudget(null, null, null)
                };
            },
            hoursBudget: (row, stores)=>{
                return {
                    numerator: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.staffPhaseTableRows.map((r)=>r.getTotalHours(r.id, null, null))),
                    denominator: this.getHoursBudget(null, null, null)
                };
            }
        };
        const showCost = this.cellType === "currency";
        return {
            id: "total",
            label: "Total",
            type: "progress",
            format: (v)=>showCost ? (0, $12o9H.FormatCurrency)(v, {
                    decimals: 0
                }) : (0, $cwjKY.FormatNumber)(v, {
                    decimals: 0
                }),
            width: 18,
            editable: (row)=>false,
            value: totalValueLookup[this.graphType.replace("Monthly", "")]
        };
    }
    get totalsPeriodColumns() {
        const getValueLookup = {
            revenueVsExpenses: (period)=>{
                return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.revenueTableRows.map((r)=>this.getRevenueToDateInPeriod(period, r === null || r === void 0 ? void 0 : r.id))) - (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.staffPhaseTableRows.map((r)=>this.getCostToDateInPeriod(period, r === null || r === void 0 ? void 0 : r.id, null, null))) - (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.expenseTableRows.map((r)=>this.getExpensesToDateInPeriod(period, r === null || r === void 0 ? void 0 : r.id, null)));
            },
            expenseBudget: (period)=>{
                return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.staffPhaseTableRows.map((r)=>this.getCostBudget(r === null || r === void 0 ? void 0 : r.id, null, null))) - (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.staffPhaseTableRows.map((r)=>this.getCostToDateInPeriod(period, r === null || r === void 0 ? void 0 : r.id, null, null))) - (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.expenseTableRows.map((r)=>this.getExpensesToDateInPeriod(period, r === null || r === void 0 ? void 0 : r.id, null)));
            },
            hoursBudget: (period)=>{
                return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.staffPhaseTableRows.map((r)=>this.getHoursBudget(r === null || r === void 0 ? void 0 : r.id, null, null))) - (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.staffPhaseTableRows.map((r)=>this.getHoursToDateInPeriod(period, r === null || r === void 0 ? void 0 : r.id, null, null)));
            },
            revenueVsExpensesMonthly: (period)=>{
                return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.revenueTableRows.map((r)=>this.getRevenueInPeriod(period, r === null || r === void 0 ? void 0 : r.id))) - (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.staffPhaseTableRows.map((r)=>this.getCostInPeriod(period, r === null || r === void 0 ? void 0 : r.id, null, null))) - (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.expenseTableRows.map((r)=>this.getExpensesInPeriod(period, r === null || r === void 0 ? void 0 : r.id, null)));
            },
            expenseBudgetMonthly: (period)=>{
                return -(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.staffPhaseTableRows.map((r)=>this.getCostInPeriod(period, r === null || r === void 0 ? void 0 : r.id, null, null))) - (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.expenseTableRows.map((r)=>this.getExpensesInPeriod(period, r === null || r === void 0 ? void 0 : r.id, null)));
            },
            hoursBudgetMonthly: (period)=>{
                return -(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.staffPhaseTableRows.map((r)=>this.getHoursInPeriod(period, r === null || r === void 0 ? void 0 : r.id, null, null)));
            }
        };
        const showCost = this.cellType === "currency";
        return [
            ...Array(12)
        ].map((v, i)=>{
            const periodStart = this.addPeriods(this.startDate, i);
            const periodEnd = this.endOfPeriod(periodStart);
            const periodType = periodStart.getTime() === this.startOfPeriod(new Date()).getTime() ? "current" : periodStart.getTime() > this.startOfPeriod(new Date()).getTime() ? "future" : "past";
            const isPastPeriod = periodType === "past";
            const isCurrentPeriod = periodType === "current";
            const isFuturePeriod = periodType === "future";
            return {
                id: periodStart.getTime(),
                label: (0, $4hBm1.format)(periodStart, this.periodDisplayFormat()),
                type: this.cellType,
                width: 8,
                editable: (row, stores)=>{
                    return false;
                },
                value: (row, stores)=>{
                    return getValueLookup[this.graphType]((0, $4hBm1.format)(periodStart, this.periodFormat()));
                },
                format: (v)=>showCost ? (0, $12o9H.FormatCurrency)(v, {
                        decimals: 0
                    }) : (0, $cwjKY.FormatNumber)(v, {
                        decimals: 0
                    })
            };
        });
    }
    get totalsTableColumns() {
        return [
            $39f0567a8610a817$var$spacerColumn,
            this.totalsLabelColumn,
            this.totalsTotalColumn,
            ...this.totalsPeriodColumns
        ];
    }
    get profitMarginLabelColumn() {
        return {
            id: "label",
            label: "Title",
            type: "text",
            width: 18,
            editable: (row)=>false,
            value: (row, stores)=>{
                return "Profit Margin";
            },
            component: ({ value: value, group: group, stores: stores })=>{
                const { row: row, table: table } = stores;
                return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    style: {
                        paddingLeft: `${1 * row.groupLevel}rem`
                    },
                    children: [
                        row.group !== "project" && row.childRows.length ? /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                            className: `fa fa-${`caret-${row.expanded ? "down" : "right"}`} fa-fw`,
                            onClick: ()=>table.toggleRowExpand(row)
                        }) : null,
                        value
                    ]
                });
            }
        };
    }
    get profitMarginTotalColumn() {
        return {
            id: "total",
            label: "Total",
            type: "percent",
            width: 18,
            editable: (row)=>false,
            value: ()=>{
                return ((0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.revenueTableRows.map((r)=>this.getTotalRevenue(r.id))) - (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.staffPhaseTableRows.map((r)=>this.getTotalCost(r.id, null, null))) - (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.expenseTableRows.map((r)=>this.getTotalExpenses(r.id, null)))) / (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.revenueTableRows.map((r)=>this.getTotalRevenue(r.id)));
            }
        };
    }
    get profitMarginPeriodColumns() {
        return [
            ...Array(12)
        ].map((v, i)=>{
            const periodStart = this.addPeriods(this.startDate, i);
            const periodEnd = this.endOfPeriod(periodStart);
            const periodType = periodStart.getTime() === this.startOfPeriod(new Date()).getTime() ? "current" : periodStart.getTime() > this.startOfPeriod(new Date()).getTime() ? "future" : "past";
            const period = (0, $4hBm1.format)(periodStart, this.periodFormat());
            return {
                id: periodStart.getTime(),
                label: (0, $4hBm1.format)(periodStart, this.periodDisplayFormat()),
                type: "percent",
                width: 8,
                editable: (row, stores)=>{
                    return false;
                },
                value: (row, stores)=>{
                    return ((0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.revenueTableRows.map((r)=>this.getRevenueToDateInPeriod(period, r === null || r === void 0 ? void 0 : r.id))) - (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.staffPhaseTableRows.map((r)=>this.getCostToDateInPeriod(period, r === null || r === void 0 ? void 0 : r.id, null, null))) - (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.expenseTableRows.map((r)=>this.getExpensesToDateInPeriod(period, r === null || r === void 0 ? void 0 : r.id, null)))) / (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.revenueTableRows.map((r)=>this.getRevenueToDateInPeriod(period, r === null || r === void 0 ? void 0 : r.id)));
                }
            };
        });
    }
    get profitMarginTableColumns() {
        return [
            $39f0567a8610a817$var$spacerColumn,
            this.profitMarginLabelColumn,
            this.profitMarginTotalColumn,
            ...this.profitMarginPeriodColumns
        ];
    }
}, $39f0567a8610a817$var$_descriptor = $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "filterByPhase", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $39f0567a8610a817$var$_descriptor2 = $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "graphType", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "hoursBudget";
    }
}), $39f0567a8610a817$var$_descriptor3 = $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "graphData", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "actualsProjected";
    }
}), $39f0567a8610a817$var$_descriptor4 = $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "startDate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return (0, $4hBm1.startOfMonth)((0, $4hBm1.subMonths)(new Date(), 3));
    }
}), $39f0567a8610a817$var$_descriptor5 = $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "endDate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return (0, $4hBm1.endOfMonth)((0, $4hBm1.addMonths)(new Date(), 8));
    }
}), $39f0567a8610a817$var$_descriptor6 = $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "selectedTable", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $39f0567a8610a817$var$_descriptor7 = $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "selectedObject", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $39f0567a8610a817$var$_descriptor8 = $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "selectedProjectOrPhase", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $39f0567a8610a817$var$_descriptor9 = $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "selectedPeriod", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $39f0567a8610a817$var$_descriptor10 = $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "updateRevenueWithExpenses", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        var _shouldUpdateRevenueF;
        return (_shouldUpdateRevenueF = (0, $8kZ1o.shouldUpdateRevenueFromHours)()) !== null && _shouldUpdateRevenueF !== void 0 ? _shouldUpdateRevenueF : false;
    }
}), $39f0567a8610a817$var$_descriptor11 = $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "updateExpensesWithRevenue", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        var _shouldUpdateHoursFro;
        return (_shouldUpdateHoursFro = (0, $8kZ1o.shouldUpdateHoursFromRevenue)()) !== null && _shouldUpdateHoursFro !== void 0 ? _shouldUpdateHoursFro : false;
    }
}), $39f0567a8610a817$var$_descriptor12 = $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "queryData", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $39f0567a8610a817$var$_descriptor13 = $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "phaseRoleRowsByPhaseId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $39f0567a8610a817$var$_descriptor14 = $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "phaseStaffRowsByPhaseRoleId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $39f0567a8610a817$var$_descriptor15 = $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "editedRevenueTargets", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $39f0567a8610a817$var$_descriptor16 = $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "editedAllocations", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $39f0567a8610a817$var$_descriptor17 = $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "editedExpenses", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $39f0567a8610a817$var$_descriptor18 = $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "project", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $39f0567a8610a817$var$_descriptor19 = $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "projectStaff", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Set();
    }
}), $39f0567a8610a817$var$_descriptor20 = $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "staffByPhase", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $39f0567a8610a817$var$_descriptor21 = $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "saveState", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "idle";
    }
}), $39f0567a8610a817$var$_descriptor22 = $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "uuid", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($gN0TC)))();
    }
}), $39f0567a8610a817$var$_descriptor23 = $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "savingIds", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Set();
    }
}), $39f0567a8610a817$var$_descriptor24 = $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "periodType", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "month";
    }
}), $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "reset", [
    $39f0567a8610a817$var$_dec
], Object.getOwnPropertyDescriptor($39f0567a8610a817$var$_class.prototype, "reset"), $39f0567a8610a817$var$_class.prototype), $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "setFilterByPhase", [
    $39f0567a8610a817$var$_dec2
], Object.getOwnPropertyDescriptor($39f0567a8610a817$var$_class.prototype, "setFilterByPhase"), $39f0567a8610a817$var$_class.prototype), $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "setUpdateRevenueWithExpenses", [
    $39f0567a8610a817$var$_dec3
], Object.getOwnPropertyDescriptor($39f0567a8610a817$var$_class.prototype, "setUpdateRevenueWithExpenses"), $39f0567a8610a817$var$_class.prototype), $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "setUpdateExpensesWithRevenue", [
    $39f0567a8610a817$var$_dec4
], Object.getOwnPropertyDescriptor($39f0567a8610a817$var$_class.prototype, "setUpdateExpensesWithRevenue"), $39f0567a8610a817$var$_class.prototype), $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "generatePhaseStaffAndRoleRows", [
    $39f0567a8610a817$var$_dec5
], Object.getOwnPropertyDescriptor($39f0567a8610a817$var$_class.prototype, "generatePhaseStaffAndRoleRows"), $39f0567a8610a817$var$_class.prototype), $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "periods", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($39f0567a8610a817$var$_class.prototype, "periods"), $39f0567a8610a817$var$_class.prototype), $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "maxPeriod", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($39f0567a8610a817$var$_class.prototype, "maxPeriod"), $39f0567a8610a817$var$_class.prototype), $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "minPeriod", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($39f0567a8610a817$var$_class.prototype, "minPeriod"), $39f0567a8610a817$var$_class.prototype), $39f0567a8610a817$var$_descriptor25 = $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "setEditedRevenueInPeriod", [
    $39f0567a8610a817$var$_dec6
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return (period, phaseId, value, updateExpensesWithRevenue)=>{
            if (!phaseId) {
                const existingRevenue = this.getRevenueInPeriod(period, null);
                const ratio = existingRevenue && value / existingRevenue;
                this.queryData.projects[0].phases.forEach((p)=>{
                    var _this$project18;
                    const existingVal = this.getRevenueInPeriod(period, p.id);
                    const revenue = ratio ? existingVal * ratio : value / p.fee;
                    this.editedRevenueTargets[(_this$project18 = this.project) === null || _this$project18 === void 0 ? void 0 : _this$project18.id][this.periodType][period + p.id] = {
                        period: period,
                        periodType: this.periodType,
                        phaseId: p.id,
                        revenue: revenue
                    };
                });
            } else {
                var _this$project19;
                this.editedRevenueTargets[(_this$project19 = this.project) === null || _this$project19 === void 0 ? void 0 : _this$project19.id][this.periodType][period + phaseId] = {
                    periodType: this.periodType,
                    period: period,
                    phaseId: phaseId,
                    revenue: value
                };
            }
            this.prepareToSave();
        };
    }
}), $39f0567a8610a817$var$_descriptor26 = $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "setEditedRevenueProgressInPeriod", [
    $39f0567a8610a817$var$_dec7
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return (period, phaseId, percent)=>{
            var _this$project20;
            if (!phaseId) return this.queryData.projects[0].phases.forEach((p)=>{
                this.setEditedRevenueProgressInPeriod(period, p.id, percent);
            });
            const periodBefore = (0, $4hBm1.format)(this.subPeriods((0, $4hBm1.parse)(period, this.periodFormat(), new Date(), {
                weekStartsOn: 1
            }), 1), this.periodFormat());
            const revenueBeforePeriod = this.getRevenueToDateInPeriod(periodBefore, phaseId);
            const newRevenue = Math.max(percent * (0, $XoImS.default).phasesById[phaseId].fee - revenueBeforePeriod, 0);
            this.editedRevenueTargets[(_this$project20 = this.project) === null || _this$project20 === void 0 ? void 0 : _this$project20.id][this.periodType][period + phaseId] = {
                period: period,
                periodType: this.periodType,
                phaseId: phaseId,
                revenue: newRevenue
            };
            this.prepareToSave();
        };
    }
}), $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "prepareToSave", [
    $39f0567a8610a817$var$_dec8
], Object.getOwnPropertyDescriptor($39f0567a8610a817$var$_class.prototype, "prepareToSave"), $39f0567a8610a817$var$_class.prototype), $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "saveChanges", [
    $39f0567a8610a817$var$_dec9
], Object.getOwnPropertyDescriptor($39f0567a8610a817$var$_class.prototype, "saveChanges"), $39f0567a8610a817$var$_class.prototype), $39f0567a8610a817$var$_descriptor27 = $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "setEditedCostInPeriod", [
    $39f0567a8610a817$var$_dec10
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return (period, phaseId, roleId, staffId, value)=>{
            const dateRange = [
                (0, $4hBm1.parse)(period, this.periodFormat(), new Date(), {
                    weekStartsOn: 1
                }),
                this.endOfPeriod((0, $4hBm1.parse)(period, this.periodFormat(), new Date(), {
                    weekStartsOn: 1
                }))
            ];
            const ids = this.getLeafPhaseIds(phaseId, roleId, staffId).filter(([p, r, s])=>{
                const staff = (0, $htkeB.default).staffById[s];
                return (staff === null || staff === void 0 ? void 0 : staff.id) || (staff === null || staff === void 0 ? void 0 : staff.isArchived) === false && isFinite((0, $ywyHN.default)({
                    project: this.project,
                    phase: (0, $XoImS.default).phasesById[p],
                    staff: staff || $39f0567a8610a817$var$noStaff,
                    role: (0, $bxXv3.default).rolesById[r] || $39f0567a8610a817$var$noRole
                }, "cost", dateRange));
            });
            // Calculate total cost budget for weighting
            const totalCostBudget = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(ids.map(([p, r, s])=>this.getCostBudget(p, r, s) || 0));
            ids.forEach(([p, r, s])=>{
                var _this$project21;
                const models = {
                    project: this.project,
                    phase: (0, $XoImS.default).phasesById[p],
                    staff: (0, $htkeB.default).staffById[s] || $39f0567a8610a817$var$noStaff,
                    role: (0, $bxXv3.default).rolesById[r] || $39f0567a8610a817$var$noRole
                };
                // If no budgets exist, distribute evenly, otherwise weight by budget
                const costBudget = this.getCostBudget(p, r, s) || 0;
                const cost = totalCostBudget === 0 ? value / ids.length : costBudget / totalCostBudget * value;
                const hours = cost / (0, $ywyHN.default)(models, "cost", dateRange);
                const pay = hours * (0, $ywyHN.default)(models, "pay", dateRange);
                const chargeOut = hours * (0, $ywyHN.default)(models, "chargeOut", dateRange);
                this.editedAllocations[(_this$project21 = this.project) === null || _this$project21 === void 0 ? void 0 : _this$project21.id][this.periodType][period + p + r + s] = {
                    period: period,
                    periodType: this.periodType,
                    phaseId: p,
                    roleId: r,
                    staffId: s,
                    hours: hours,
                    pay: pay,
                    cost: cost,
                    chargeOut: chargeOut
                };
            });
            this.prepareToSave();
        };
    }
}), $39f0567a8610a817$var$_descriptor28 = $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "setEditedHoursInPeriod", [
    $39f0567a8610a817$var$_dec11
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return (period, phaseId, roleId, staffId, value)=>{
            const dateRange = [
                (0, $4hBm1.parse)(period, this.periodFormat(), new Date(), {
                    weekStartsOn: 1
                }),
                this.endOfPeriod((0, $4hBm1.parse)(period, this.periodFormat(), new Date(), {
                    weekStartsOn: 1
                }))
            ];
            const ids = this.getLeafPhaseIds(phaseId, roleId, staffId).filter(([p, r, s])=>{
                const staff = (0, $htkeB.default).staffById[s];
                return staffId || (staff === null || staff === void 0 ? void 0 : staff.isArchived) === false;
            });
            // Calculate total budget for weighting
            const totalBudget = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(ids.map(([p, r, s])=>this.getHoursBudget(p, r, s) || 0));
            ids.forEach(([p, r, s])=>{
                var _this$project22;
                const models = {
                    project: this.project,
                    phase: (0, $XoImS.default).phasesById[p],
                    staff: (0, $htkeB.default).staffById[s] || $39f0567a8610a817$var$noStaff,
                    role: (0, $bxXv3.default).rolesById[r] || $39f0567a8610a817$var$noRole
                };
                // If no budgets exist, distribute evenly, otherwise weight by budget
                const budget = this.getHoursBudget(p, r, s) || 0;
                const hours = totalBudget === 0 ? value / ids.length : budget / totalBudget * value;
                const cost = hours * (0, $ywyHN.default)(models, "cost", dateRange);
                const pay = hours * (0, $ywyHN.default)(models, "pay", dateRange);
                const chargeOut = hours * (0, $ywyHN.default)(models, "chargeOut", dateRange);
                this.editedAllocations[(_this$project22 = this.project) === null || _this$project22 === void 0 ? void 0 : _this$project22.id][this.periodType][period + p + r + s] = {
                    period: period,
                    periodType: this.periodType,
                    phaseId: p,
                    roleId: r,
                    staffId: s,
                    hours: hours,
                    pay: pay,
                    cost: cost,
                    chargeOut: chargeOut
                };
            });
            this.prepareToSave();
        };
    }
}), $39f0567a8610a817$var$_descriptor29 = $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "setEditedExpensesInPeriod", [
    $39f0567a8610a817$var$_dec12
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return (period, phaseId, expenseName, value)=>{
            const ids = this.getExpenseIds(phaseId, expenseName, false).filter(([p, e])=>{
                var _this$queryData$proje2;
                return (_this$queryData$proje2 = this.queryData.projects[0].phases.find((ph)=>ph.id === p)) === null || _this$queryData$proje2 === void 0 ? void 0 : _this$queryData$proje2.expenses.find((ex)=>ex.name === e);
            });
            const existingExpenses = this.getExpensesInPeriod(period, phaseId, expenseName);
            const ratio = existingExpenses && value / existingExpenses;
            ids.forEach(([p, e])=>{
                var _this$queryData$proje3, _this$project23;
                const existingVal = this.getExpensesInPeriod(period, p, e);
                const expenses = ratio ? existingVal * ratio : value / ids.length;
                const matchingExpense = (_this$queryData$proje3 = this.queryData.projects[0].phases.find((ph)=>ph.id === p)) === null || _this$queryData$proje3 === void 0 ? void 0 : _this$queryData$proje3.expenses.find((ex)=>ex.name === e);
                this.editedExpenses[(_this$project23 = this.project) === null || _this$project23 === void 0 ? void 0 : _this$project23.id][this.periodType][period + p + e] = {
                    periodType: this.periodType,
                    period: period,
                    phaseId: p,
                    expenseName: e,
                    expenseId: matchingExpense === null || matchingExpense === void 0 ? void 0 : matchingExpense.id,
                    amount: expenses
                };
            });
            this.prepareToSave();
        };
    }
}), $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "setDisplayedProjectOrPhase", [
    $39f0567a8610a817$var$_dec13
], Object.getOwnPropertyDescriptor($39f0567a8610a817$var$_class.prototype, "setDisplayedProjectOrPhase"), $39f0567a8610a817$var$_class.prototype), $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "setGraphType", [
    $39f0567a8610a817$var$_dec14
], Object.getOwnPropertyDescriptor($39f0567a8610a817$var$_class.prototype, "setGraphType"), $39f0567a8610a817$var$_class.prototype), $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "setGraphData", [
    $39f0567a8610a817$var$_dec15
], Object.getOwnPropertyDescriptor($39f0567a8610a817$var$_class.prototype, "setGraphData"), $39f0567a8610a817$var$_class.prototype), $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "isCumulative", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($39f0567a8610a817$var$_class.prototype, "isCumulative"), $39f0567a8610a817$var$_class.prototype), $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "labelColumns", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($39f0567a8610a817$var$_class.prototype, "labelColumns"), $39f0567a8610a817$var$_class.prototype), $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "cellType", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($39f0567a8610a817$var$_class.prototype, "cellType"), $39f0567a8610a817$var$_class.prototype), $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "budgetColumns", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($39f0567a8610a817$var$_class.prototype, "budgetColumns"), $39f0567a8610a817$var$_class.prototype), $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "periodColumns", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($39f0567a8610a817$var$_class.prototype, "periodColumns"), $39f0567a8610a817$var$_class.prototype), $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "selectCell", [
    $39f0567a8610a817$var$_dec16
], Object.getOwnPropertyDescriptor($39f0567a8610a817$var$_class.prototype, "selectCell"), $39f0567a8610a817$var$_class.prototype), $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "graphRevenue", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($39f0567a8610a817$var$_class.prototype, "graphRevenue"), $39f0567a8610a817$var$_class.prototype), $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "graphExpenses", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($39f0567a8610a817$var$_class.prototype, "graphExpenses"), $39f0567a8610a817$var$_class.prototype), $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "showRevenueTable", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($39f0567a8610a817$var$_class.prototype, "showRevenueTable"), $39f0567a8610a817$var$_class.prototype), $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "showStaffTable", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($39f0567a8610a817$var$_class.prototype, "showStaffTable"), $39f0567a8610a817$var$_class.prototype), $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "showExpenseTable", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($39f0567a8610a817$var$_class.prototype, "showExpenseTable"), $39f0567a8610a817$var$_class.prototype), $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "revenueTableColumns", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($39f0567a8610a817$var$_class.prototype, "revenueTableColumns"), $39f0567a8610a817$var$_class.prototype), $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "revenueTableRows", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($39f0567a8610a817$var$_class.prototype, "revenueTableRows"), $39f0567a8610a817$var$_class.prototype), $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "staffPhaseTableRows", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($39f0567a8610a817$var$_class.prototype, "staffPhaseTableRows"), $39f0567a8610a817$var$_class.prototype), $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "expenseTableRows", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($39f0567a8610a817$var$_class.prototype, "expenseTableRows"), $39f0567a8610a817$var$_class.prototype), $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "shiftDates", [
    $39f0567a8610a817$var$_dec17
], Object.getOwnPropertyDescriptor($39f0567a8610a817$var$_class.prototype, "shiftDates"), $39f0567a8610a817$var$_class.prototype), $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "shiftSelectedDates", [
    $39f0567a8610a817$var$_dec18
], Object.getOwnPropertyDescriptor($39f0567a8610a817$var$_class.prototype, "shiftSelectedDates"), $39f0567a8610a817$var$_class.prototype), $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "totalsLabelColumn", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($39f0567a8610a817$var$_class.prototype, "totalsLabelColumn"), $39f0567a8610a817$var$_class.prototype), $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "totalsTotalColumn", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($39f0567a8610a817$var$_class.prototype, "totalsTotalColumn"), $39f0567a8610a817$var$_class.prototype), $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "totalsPeriodColumns", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($39f0567a8610a817$var$_class.prototype, "totalsPeriodColumns"), $39f0567a8610a817$var$_class.prototype), $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "totalsTableColumns", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($39f0567a8610a817$var$_class.prototype, "totalsTableColumns"), $39f0567a8610a817$var$_class.prototype), $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "profitMarginLabelColumn", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($39f0567a8610a817$var$_class.prototype, "profitMarginLabelColumn"), $39f0567a8610a817$var$_class.prototype), $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "profitMarginTotalColumn", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($39f0567a8610a817$var$_class.prototype, "profitMarginTotalColumn"), $39f0567a8610a817$var$_class.prototype), $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "profitMarginPeriodColumns", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($39f0567a8610a817$var$_class.prototype, "profitMarginPeriodColumns"), $39f0567a8610a817$var$_class.prototype), $39f0567a8610a817$var$_applyDecoratedDescriptor($39f0567a8610a817$var$_class.prototype, "profitMarginTableColumns", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($39f0567a8610a817$var$_class.prototype, "profitMarginTableColumns"), $39f0567a8610a817$var$_class.prototype), $39f0567a8610a817$var$_class);
var $39f0567a8610a817$export$2e2bcd8739ae039 = new $39f0567a8610a817$var$ProjectForecastStore();

});
parcelRegister("5CHqX", function(module, exports) {

$parcel$export(module.exports, "editAllocationsInDateRange", function () { return $4182316c0f9313f8$export$a6d1e57a245edeb2; });

var $f44xu = parcelRequire("f44xu");

var $28FmA = parcelRequire("28FmA");


var $eat5C = parcelRequire("eat5C");
parcelRequire("ywyHN");

var $jg8jZ = parcelRequire("jg8jZ");
function $4182316c0f9313f8$export$a6d1e57a245edeb2(allocations, dateRange, value, valueType) {
    //get unique project, phase, staff, role
    const uniqIds = new Set();
    const matchingAllocations = [];
    allocations.forEach((al)=>{
        var _al$role;
        uniqIds.add((0, $f44xu.default)(al.projectId, al.phaseId, (_al$role = al.role) === null || _al$role === void 0 ? void 0 : _al$role.id, al.staffId));
        if (al.modelType !== "allocation" || !(0, $28FmA.isDateOnOrBetweenRange)(al.date, dateRange)) return;
        matchingAllocations.push(al);
    });
    const totalAmount = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(matchingAllocations.map((al)=>{
        return al[valueType];
    }));
    if (matchingAllocations.length && totalAmount) {
        const amountRatio = value / totalAmount;
        matchingAllocations.forEach((al)=>al.update({
                hours: al.hours * amountRatio
            }));
    } else {
        const splitValue = value / uniqIds.size;
        [
            ...uniqIds
        ].forEach((ids)=>{
            const al = (0, $jg8jZ.default).add({
                projectId: ids[0],
                phaseId: ids[1],
                roleId: ids[2],
                staffId: ids[3],
                numMinutes: splitValue * 60,
                date: dateRange[1]
            }, {
                trackUpdates: true
            });
            al.update({
                numMinutes: splitValue / (valueType !== "hours" ? al[valueType + "Rate"] : 1) * 60
            });
        });
    }
}

});
parcelRegister("28FmA", function(module, exports) {

$parcel$export(module.exports, "isDateOnOrBetweenRange", function () { return $18ec6a00b169ea1a$export$8708b89d395ce3dd; });

var $4hBm1 = parcelRequire("4hBm1");
const $18ec6a00b169ea1a$export$ac5a29372f8d1668 = {
    weeks: {
        add: (0, $4hBm1.addWeeks),
        sub: (0, $4hBm1.subWeeks),
        startOf: (0, $4hBm1.startOfWeek),
        endOf: (0, $4hBm1.endOfWeek)
    },
    months: {
        add: (0, $4hBm1.addMonths),
        sub: (0, $4hBm1.subMonths),
        startOf: (0, $4hBm1.startOfMonth),
        endOf: (0, $4hBm1.endOfMonth)
    }
};
const $18ec6a00b169ea1a$export$b05525f4ef740065 = (date, dateRange)=>{
    return (dateRange[0] ? date > dateRange[0] : true) && (dateRange[1] ? date < dateRange[1] : true);
};
const $18ec6a00b169ea1a$export$8708b89d395ce3dd = (date, dateRange)=>{
    return (dateRange[0] ? date >= dateRange[0] : true) && (dateRange[1] ? date <= dateRange[1] : true);
};
const $18ec6a00b169ea1a$export$971859f72281a885 = (dateRange1, dateRange2)=>{
    return dateRange2[0] <= dateRange1[1] && dateRange2[1] >= dateRange1[0];
};

});


parcelRegister("hDUkm", function(module, exports) {

$parcel$export(module.exports, "editRevenueTargetsInDateRange", function () { return $cd81c5a67e0e2647$export$c09fd48d61ad7731; });

var $f44xu = parcelRequire("f44xu");

var $28FmA = parcelRequire("28FmA");

var $eat5C = parcelRequire("eat5C");

var $64hVI = parcelRequire("64hVI");
function $cd81c5a67e0e2647$export$c09fd48d61ad7731(revenueTargets, dateRange, value) {
    //get unique project, phase
    const uniqIds = new Set();
    const matchingRevenueTargets = [];
    revenueTargets.forEach((rt)=>{
        uniqIds.add((0, $f44xu.default)(rt.projectId, rt.phaseId));
        if (rt.modelType !== "revenueTarget" || !(0, $28FmA.isDateOnOrBetweenRange)(rt.date, dateRange)) return;
        matchingRevenueTargets.push(rt);
    });
    const totalAmount = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(matchingRevenueTargets.map((rt)=>rt.amount));
    if (matchingRevenueTargets.length && totalAmount) {
        const amountRatio = value / totalAmount;
        matchingRevenueTargets.forEach((rt)=>rt.update({
                amount: rt.amount * amountRatio
            }));
    } else {
        const splitValue = value / uniqIds.size;
        [
            ...uniqIds
        ].forEach((ids)=>{
            const rt = (0, $64hVI.default).add({
                projectId: ids[0],
                phaseId: ids[1],
                amount: splitValue,
                date: dateRange[1]
            }, {
                trackUpdates: true
            });
        });
    }
}

});

parcelRegister("3vc8e", function(module, exports) {
module.exports = new URL("diag.e6af899a.png", import.meta.url).toString();

});


parcelRegister("alT7C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78969f96c58dae47$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "ProjectSidebarContent", function () { return $78969f96c58dae47$export$eba2edac344eb313; });
$parcel$export(module.exports, "ProjectSidebarStore", function () { return $78969f96c58dae47$export$80232d64ee2983f5; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $1EEMt = parcelRequire("1EEMt");

var $6RcUP = parcelRequire("6RcUP");

var $6eCWq = parcelRequire("6eCWq");

var $1BTI2 = parcelRequire("1BTI2");

var $XoImS = parcelRequire("XoImS");

var $gJT7h = parcelRequire("gJT7h");

var $6Q5sp = parcelRequire("6Q5sp");

var $4hBm1 = parcelRequire("4hBm1");

var $8kZ1o = parcelRequire("8kZ1o");

var $hYVSY = parcelRequire("hYVSY");

var $8oGqY = parcelRequire("8oGqY");

var $eat5C = parcelRequire("eat5C");

var $2tryL = parcelRequire("2tryL");

var $ccJUd = parcelRequire("ccJUd");

var $htkeB = parcelRequire("htkeB");

var $ywyHN = parcelRequire("ywyHN");

var $bxXv3 = parcelRequire("bxXv3");

var $jCrfK = parcelRequire("jCrfK");

var $bfcx4 = parcelRequire("bfcx4");

var $4JcCM = parcelRequire("4JcCM");

var $iOQGT = parcelRequire("iOQGT");

var $12o9H = parcelRequire("12o9H");

var $kqlQp = parcelRequire("kqlQp");

var $6fNfM = parcelRequire("6fNfM");

var $ewAM3 = parcelRequire("ewAM3");

var $3X7oM = parcelRequire("3X7oM");

var $3h7sC = parcelRequire("3h7sC");

var $47i9t = parcelRequire("47i9t");
var $78969f96c58dae47$var$_dec, $78969f96c58dae47$var$_dec2, $78969f96c58dae47$var$_dec3, $78969f96c58dae47$var$_dec4, $78969f96c58dae47$var$_dec5, $78969f96c58dae47$var$_dec6, $78969f96c58dae47$var$_class, $78969f96c58dae47$var$_descriptor, $78969f96c58dae47$var$_descriptor2, $78969f96c58dae47$var$_descriptor3, $78969f96c58dae47$var$_descriptor4, $78969f96c58dae47$var$_descriptor5, $78969f96c58dae47$var$_descriptor6, $78969f96c58dae47$var$_descriptor7, $78969f96c58dae47$var$_descriptor8;
function $78969f96c58dae47$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $78969f96c58dae47$var$_defineProperty(e, r, t) {
    return (r = $78969f96c58dae47$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $78969f96c58dae47$var$_toPropertyKey(t) {
    var i = $78969f96c58dae47$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $78969f96c58dae47$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $78969f96c58dae47$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $78969f96c58dae47$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
var $78969f96c58dae47$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(()=>{
    const [store, setStore] = (0, $jbmdS.useState)((0, $6eCWq.default));
    const period = store.selectedPeriod && store.startOfPeriod(store.selectedPeriod);
    const project = (0, $gJT7h.default).projectsById[store.selectedProjectId];
    const phase = (0, $XoImS.default).phasesById[store.selectedPhaseId];
    const periodId = (0, $4hBm1.format)(period, store.periodFormat());
    const periodType = store.periodType;
    const queryId = `sidebar${periodType}${periodId}${store.selectedProjectId}${store.selectedPhaseId}${store.selectedStaffId}${store.selectedRoleId}${store.selectedStaffIds.join(",")}`;
    if (store.selectedPeriod && store.selectedObject) {
        var _SessionStore$user;
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6RcUP.default), {
            queryIds: [
                {
                    id: queryId,
                    baseURL: "https://server2.coincraft.co",
                    path: `/project-forecast-sidebar`,
                    method: "POST",
                    staleTime: 0,
                    data: {
                        projectId: store.selectedProjectId,
                        organisationId: (0, $1BTI2.default).organisationId,
                        userId: (_SessionStore$user = (0, $1BTI2.default).user) === null || _SessionStore$user === void 0 ? void 0 : _SessionStore$user.id,
                        invoiceType: (0, $1BTI2.default).organisation.defaultRevenueForecastReport.filters.invoiceData,
                        periodType: (0, $6eCWq.default).periodType,
                        dataType: (0, $6eCWq.default).report.filters.hoursData,
                        selectedPeriod: (0, $4hBm1.format)(new Date(store.selectedPeriod), store.periodFormat()),
                        phaseId: store.selectedPhaseId,
                        staffIds: store.selectedStaffIds
                    }
                },
                {
                    id: store.selectedProjectId + "phases",
                    queryFn: async ()=>{
                        const requestData = await (0, $3h7sC.trpc).legacy.getProjectPhases.query({
                            projectId: store.selectedProjectId
                        });
                        return (0, $47i9t.processTRPCData)(requestData, `phases-${store.selectedProjectId}`);
                    }
                },
                {
                    id: `rates-${store.selectedProjectId}`,
                    queryFn: async ()=>{
                        const requestData = await (0, $3h7sC.trpc).legacy.getRates.query({
                            projectId: store.selectedProjectId
                        });
                        return (0, $47i9t.processTRPCData)(requestData, `rates-${store.selectedProjectId}`);
                    }
                }
            ],
            children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    display: "flex",
                    flexDirection: "column",
                    height: "100%"
                },
                children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jCrfK.default), {
                            title: project === null || project === void 0 ? void 0 : project.title,
                            subTitle: phase === null || phase === void 0 ? void 0 : phase.title,
                            link: `/projects/${store.selectedProjectId}`
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bfcx4.default), {
                            title: (0, $4hBm1.format)(store.selectedPeriod, store.periodDisplayFormat()),
                            onLeftClick: ()=>store.shiftSelectedPeriod(-1),
                            onRightClick: ()=>store.shiftSelectedPeriod(1)
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)($78969f96c58dae47$export$eba2edac344eb313, {
                            periodType: periodType,
                            period: period,
                            periodId: periodId,
                            projectId: store.selectedProjectId,
                            phaseId: store.selectedPhaseId,
                            staffId: store.selectedStaffId,
                            roleId: store.selectedRoleId,
                            staffIds: store.selectedStaffIds,
                            queryId: queryId,
                            onUpdateHours: (hoursData)=>{
                                const groups = (0, $6eCWq.default).report.filters.groups;
                                const hoursByRow = new Map();
                                hoursData.forEach((hd)=>{
                                    var _models$project;
                                    let row;
                                    const { period: periodFromData, hours: hours, ...models } = hd;
                                    models.owner = (_models$project = models.project) === null || _models$project === void 0 ? void 0 : _models$project.owner;
                                    groups.forEach((group, i)=>{
                                        const children = row ? row.children : (0, $6eCWq.default).queryData;
                                        const groupsBefore = groups.slice(0, i + 1);
                                        const key = groupsBefore === null || groupsBefore === void 0 ? void 0 : groupsBefore.map((g)=>{
                                            var _models$g;
                                            return ((_models$g = models[g]) === null || _models$g === void 0 ? void 0 : _models$g.id) || models[g] || "null";
                                        }).join("||");
                                        row = children.find((r)=>r.key === key);
                                    });
                                    if (row) {
                                        if (hoursByRow.has(row)) {
                                            const oldHours = hoursByRow.get(row);
                                            hoursByRow.set(row, hours + oldHours);
                                        } else hoursByRow.set(row, hours);
                                    }
                                });
                                hoursByRow.forEach((hours, row)=>{
                                    (0, $6eCWq.default).setHours(row, periodId, hours, false);
                                });
                            }
                        })
                    ]
                })
            }, `sidebar${periodType}${periodId}${store.selectedProjectId}${store.selectedPhaseId}${store.selectedStaffId}${store.selectedRoleId}${store.selectedStaffIds.join(",")}`)
        });
    }
});
let $78969f96c58dae47$var$SidebarStore = ($78969f96c58dae47$var$_dec = (0, $4JcCM.action).bound, $78969f96c58dae47$var$_dec2 = (0, $4JcCM.action).bound, $78969f96c58dae47$var$_dec3 = (0, $4JcCM.action).bound, $78969f96c58dae47$var$_dec4 = (0, $4JcCM.action).bound, $78969f96c58dae47$var$_dec5 = (0, $4JcCM.action).bound, $78969f96c58dae47$var$_dec6 = (0, $4JcCM.action).bound, $78969f96c58dae47$var$_class = class SidebarStore {
    constructor(){
        $78969f96c58dae47$var$_initializerDefineProperty(this, "sidebarId", $78969f96c58dae47$var$_descriptor, this);
        $78969f96c58dae47$var$_initializerDefineProperty(this, "period", $78969f96c58dae47$var$_descriptor2, this);
        $78969f96c58dae47$var$_initializerDefineProperty(this, "periodType", $78969f96c58dae47$var$_descriptor3, this);
        $78969f96c58dae47$var$_initializerDefineProperty(this, "projectId", $78969f96c58dae47$var$_descriptor4, this);
        $78969f96c58dae47$var$_initializerDefineProperty(this, "queryData", $78969f96c58dae47$var$_descriptor5, this);
        $78969f96c58dae47$var$_initializerDefineProperty(this, "updateRevenueWithExpenses", $78969f96c58dae47$var$_descriptor6, this);
        $78969f96c58dae47$var$_initializerDefineProperty(this, "updateExpensesWithRevenue", $78969f96c58dae47$var$_descriptor7, this);
        $78969f96c58dae47$var$_initializerDefineProperty(this, "showAllPhases", $78969f96c58dae47$var$_descriptor8, this);
        (0, $4JcCM.makeObservable)(this);
    }
    setQueryData(data, projectId, periodType, period, sidebarId) {
        var _this$updateRevenueWi, _this$updateExpensesW;
        this.queryData = data;
        this.periodType = periodType;
        this.period = period;
        this.projectId = projectId;
        this.sidebarId = sidebarId;
        (_this$updateRevenueWi = this.updateRevenueWithExpenses) !== null && _this$updateRevenueWi !== void 0 ? _this$updateRevenueWi : this.updateRevenueWithExpenses = (0, $8kZ1o.shouldUpdateRevenueFromHours)();
        (_this$updateExpensesW = this.updateExpensesWithRevenue) !== null && _this$updateExpensesW !== void 0 ? _this$updateExpensesW : this.updateExpensesWithRevenue = (0, $8kZ1o.shouldUpdateHoursFromRevenue)();
    }
    setUpdateExpensesWithRevenue(value) {
        this.updateExpensesWithRevenue = value;
    }
    setUpdateRevenueWithExpenses(value) {
        this.updateRevenueWithExpenses = value;
    }
    setShowAllPhases(value) {
        this.showAllPhases = value;
    }
    setHoursInPeriod(period, projectId, phaseId, roleId, staffId, hours, phaseIds, staffIds, periodType) {
        var _this$queryData, _this$queryData2;
        (_this$queryData = this.queryData) !== null && _this$queryData !== void 0 ? _this$queryData : this.queryData = {};
        const correctSidebar = period === this.period && projectId === this.projectId && this.queryData != null;
        const sidebarId = [
            period,
            projectId,
            phaseId,
            roleId,
            staffId
        ].join(", ");
        let filteredHoursData = correctSidebar ? $78969f96c58dae47$var$filterHoursData(((_this$queryData2 = this.queryData) === null || _this$queryData2 === void 0 ? void 0 : _this$queryData2.hoursData) || [], staffId, roleId, projectId, phaseId) : [];
        if (!filteredHoursData.length) filteredHoursData.push({
            projectId: projectId,
            phaseId: phaseId,
            roleId: roleId,
            staffId: staffId,
            hoursInPeriod: 0,
            costInPeriod: 0,
            payInPeriod: 0,
            chargeOutInPeriod: 0
        });
        $78969f96c58dae47$var$setHoursInPeriod(filteredHoursData, hours, this.showAllPhases);
        if (this.updateRevenueWithExpenses && correctSidebar) $78969f96c58dae47$var$setRevenueProgressFromCost(this.queryData.revenueData, this.queryData.hoursData, this.showAllPhases);
        this.queryData = {
            ...this.queryData
        };
        $78969f96c58dae47$var$saveChanges(sidebarId, {
            period: period,
            periodType: periodType || this.periodType,
            organisationId: (0, $1BTI2.default).organisationId,
            hoursData: filteredHoursData,
            revenueData: correctSidebar ? this.queryData.revenueData : []
        });
    }
    setRevenueInPeriod(period, projectId, phaseId, revenue) {
        var _this$queryData3, _this$queryData4, _this$queryData4$reve;
        (_this$queryData3 = this.queryData) !== null && _this$queryData3 !== void 0 ? _this$queryData3 : this.queryData = {};
        const correctSidebar = period === this.period && projectId === this.projectId && this.queryData != null;
        const sidebarId = [
            period,
            projectId,
            phaseId
        ].join(", ");
        let filteredRevenueData = correctSidebar ? ((_this$queryData4 = this.queryData) === null || _this$queryData4 === void 0 ? void 0 : (_this$queryData4$reve = _this$queryData4.revenueData) === null || _this$queryData4$reve === void 0 ? void 0 : _this$queryData4$reve.filter((d)=>!phaseId || d.phaseId === phaseId)) || [] : [];
        if (!filteredRevenueData.length) filteredRevenueData.push({
            projectId: projectId,
            phaseId: phaseId,
            revenueInPeriod: 0
        });
        $78969f96c58dae47$var$setRevenueInPeriod(filteredRevenueData, revenue, this.showAllPhases);
        if (this.updateExpensesWithRevenue && correctSidebar) $78969f96c58dae47$var$setCostProgressFromRevenue(this.queryData.revenueData, this.queryData.hoursData, this.showAllPhases);
        this.queryData = {
            ...this.queryData
        };
        $78969f96c58dae47$var$saveChanges(sidebarId, {
            period: period,
            periodType: this.periodType,
            organisationId: (0, $1BTI2.default).organisationId,
            revenueData: filteredRevenueData,
            hoursData: correctSidebar ? this.queryData.hoursData : []
        });
    }
}, $78969f96c58dae47$var$_descriptor = $78969f96c58dae47$var$_applyDecoratedDescriptor($78969f96c58dae47$var$_class.prototype, "sidebarId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $78969f96c58dae47$var$_descriptor2 = $78969f96c58dae47$var$_applyDecoratedDescriptor($78969f96c58dae47$var$_class.prototype, "period", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $78969f96c58dae47$var$_descriptor3 = $78969f96c58dae47$var$_applyDecoratedDescriptor($78969f96c58dae47$var$_class.prototype, "periodType", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "month";
    }
}), $78969f96c58dae47$var$_descriptor4 = $78969f96c58dae47$var$_applyDecoratedDescriptor($78969f96c58dae47$var$_class.prototype, "projectId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $78969f96c58dae47$var$_descriptor5 = $78969f96c58dae47$var$_applyDecoratedDescriptor($78969f96c58dae47$var$_class.prototype, "queryData", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {
            revenueData: [],
            hoursData: [],
            phases: [],
            staff: [],
            roles: []
        };
    }
}), $78969f96c58dae47$var$_descriptor6 = $78969f96c58dae47$var$_applyDecoratedDescriptor($78969f96c58dae47$var$_class.prototype, "updateRevenueWithExpenses", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $78969f96c58dae47$var$_descriptor7 = $78969f96c58dae47$var$_applyDecoratedDescriptor($78969f96c58dae47$var$_class.prototype, "updateExpensesWithRevenue", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $78969f96c58dae47$var$_descriptor8 = $78969f96c58dae47$var$_applyDecoratedDescriptor($78969f96c58dae47$var$_class.prototype, "showAllPhases", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $78969f96c58dae47$var$_applyDecoratedDescriptor($78969f96c58dae47$var$_class.prototype, "setQueryData", [
    $78969f96c58dae47$var$_dec
], Object.getOwnPropertyDescriptor($78969f96c58dae47$var$_class.prototype, "setQueryData"), $78969f96c58dae47$var$_class.prototype), $78969f96c58dae47$var$_applyDecoratedDescriptor($78969f96c58dae47$var$_class.prototype, "setUpdateExpensesWithRevenue", [
    $78969f96c58dae47$var$_dec2
], Object.getOwnPropertyDescriptor($78969f96c58dae47$var$_class.prototype, "setUpdateExpensesWithRevenue"), $78969f96c58dae47$var$_class.prototype), $78969f96c58dae47$var$_applyDecoratedDescriptor($78969f96c58dae47$var$_class.prototype, "setUpdateRevenueWithExpenses", [
    $78969f96c58dae47$var$_dec3
], Object.getOwnPropertyDescriptor($78969f96c58dae47$var$_class.prototype, "setUpdateRevenueWithExpenses"), $78969f96c58dae47$var$_class.prototype), $78969f96c58dae47$var$_applyDecoratedDescriptor($78969f96c58dae47$var$_class.prototype, "setShowAllPhases", [
    $78969f96c58dae47$var$_dec4
], Object.getOwnPropertyDescriptor($78969f96c58dae47$var$_class.prototype, "setShowAllPhases"), $78969f96c58dae47$var$_class.prototype), $78969f96c58dae47$var$_applyDecoratedDescriptor($78969f96c58dae47$var$_class.prototype, "setHoursInPeriod", [
    $78969f96c58dae47$var$_dec5
], Object.getOwnPropertyDescriptor($78969f96c58dae47$var$_class.prototype, "setHoursInPeriod"), $78969f96c58dae47$var$_class.prototype), $78969f96c58dae47$var$_applyDecoratedDescriptor($78969f96c58dae47$var$_class.prototype, "setRevenueInPeriod", [
    $78969f96c58dae47$var$_dec6
], Object.getOwnPropertyDescriptor($78969f96c58dae47$var$_class.prototype, "setRevenueInPeriod"), $78969f96c58dae47$var$_class.prototype), $78969f96c58dae47$var$_class);
const $78969f96c58dae47$export$80232d64ee2983f5 = new $78969f96c58dae47$var$SidebarStore();
const $78969f96c58dae47$export$eba2edac344eb313 = (0, $1EEMt.observer)(({ period: period, periodId: periodId, periodType: periodType, projectId: projectId, phaseId: phaseId, staffId: staffId, roleId: roleId, staffIds: staffIds = [], queryId: queryId, onUpdateHours: onUpdateHours = ()=>null, onUpdateRevenue: onUpdateRevenue = ()=>null })=>{
    var _queryClient$getQuery, _queryData$phases, _queryData$phases2, _SessionStore$user2, _SessionStore$user3;
    const sidebarId = [
        periodType,
        periodId,
        projectId,
        phaseId,
        staffId,
        roleId,
        staffIds.join(",")
    ].join(", ");
    const project = (0, $gJT7h.default).projectsById[projectId];
    const phase = (0, $XoImS.default).phasesById[phaseId];
    (0, $jbmdS.useEffect)(()=>{
        if (phase && (phase === null || phase === void 0 ? void 0 : phase.status) !== "active") $78969f96c58dae47$export$80232d64ee2983f5.setShowAllPhases(true);
    }, [
        phase
    ]);
    const periodStart = (0, $6eCWq.default).startOfPeriod(period);
    const periodEnd = (0, $6eCWq.default).endOfPeriod(period);
    const queryData = $78969f96c58dae47$export$80232d64ee2983f5.queryData;
    const setQueryData = $78969f96c58dae47$export$80232d64ee2983f5.setQueryData;
    const updateExpensesWithRevenue = $78969f96c58dae47$export$80232d64ee2983f5.updateExpensesWithRevenue;
    const updateRevenueWithExpenses = $78969f96c58dae47$export$80232d64ee2983f5.updateRevenueWithExpenses;
    const setUpdateExpensesWithRevenue = $78969f96c58dae47$export$80232d64ee2983f5.setUpdateExpensesWithRevenue;
    const setUpdateRevenueWithExpenses = $78969f96c58dae47$export$80232d64ee2983f5.setUpdateRevenueWithExpenses;
    const queriesData = (_queryClient$getQuery = (0, $6Q5sp.queryClient).getQueryData([
        queryId
    ])) === null || _queryClient$getQuery === void 0 ? void 0 : _queryClient$getQuery.data;
    const showAllPhases = $78969f96c58dae47$export$80232d64ee2983f5.showAllPhases;
    (0, $jbmdS.useEffect)(()=>{
        setQueryData(queriesData, projectId, periodType, periodId, sidebarId);
        return ()=>{
            setQueryData({
                revenueData: [],
                hoursData: [],
                phases: [],
                staff: [],
                roles: []
            });
            (0, $6Q5sp.queryClient).removeQueries([
                queryId
            ]);
        };
    }, [
        projectId,
        phaseId,
        staffId,
        roleId,
        periodType,
        periodId,
        queriesData
    ]);
    // Filtered data for contexts where staff selection is primary (Staff Budgets, Utilisation, overall expenses)
    const staffContextFilteredHoursData = $78969f96c58dae47$var$filterHoursData((queryData === null || queryData === void 0 ? void 0 : queryData.hoursData) || [], staffId, // staffId prop from global store selection
    roleId, // roleId prop from global store selection
    projectId, phaseId);
    // Filtered data specifically for RoleExpenseBudgets
    // This should not be filtered by staffId, but can be by roleId
    const roleContextFilteredHoursData = $78969f96c58dae47$var$filterHoursData((queryData === null || queryData === void 0 ? void 0 : queryData.hoursData) || [], null, // Explicitly do not filter by the globally selected staffId
    roleId, // Filter by globally selected roleId if present
    projectId, phaseId);
    const showRevenue = periodType === "month" && (0, $8kZ1o.canViewProjectFees)((0, $1BTI2.default).user, project) && (0, $8kZ1o.canViewRevenueTargets)((0, $1BTI2.default).user, project);
    const showExpenses = (0, $8kZ1o.canViewStaffAllocations)((0, $1BTI2.default).user, project) && (0, $8kZ1o.canViewStaffCostRate)((0, $1BTI2.default).user);
    if (!queryData) return null;
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        style: {
            padding: "1em"
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "text-right pb-4",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hYVSY.default), {
                    onChange: (e)=>{
                        $78969f96c58dae47$export$80232d64ee2983f5.setShowAllPhases(e.target.checked);
                    },
                    checked: $78969f96c58dae47$export$80232d64ee2983f5.showAllPhases,
                    children: "Show All Phases"
                })
            }),
            showRevenue ? /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("h4", {
                        children: [
                            "Revenue",
                            !!project && (0, $8kZ1o.canEditStaffAllocations)((0, $1BTI2.default).user, project) ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hYVSY.default), {
                                onChange: (e)=>{
                                    const { checked: checked } = e.target;
                                    setUpdateExpensesWithRevenue(checked);
                                },
                                checked: updateExpensesWithRevenue,
                                style: {
                                    width: "45%",
                                    float: "right",
                                    fontSize: "0.65em"
                                },
                                children: "Update Expenses With Revenue"
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            padding: "1em"
                        },
                        children: [
                            !phaseId ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8oGqY.default), {
                                label: project === null || project === void 0 ? void 0 : project.title,
                                editable: (0, $8kZ1o.canEditRevenueTargets)((0, $1BTI2.default).user),
                                month: period,
                                fee: $78969f96c58dae47$var$getTotalFee(queryData.revenueData),
                                previousRevenue: $78969f96c58dae47$var$getRevenueBeforePeriod(queryData.revenueData),
                                currentRevenue: $78969f96c58dae47$var$getRevenueInPeriod(queryData.revenueData),
                                onChange: (v)=>{
                                    $78969f96c58dae47$var$setRevenueInPeriod(queryData.revenueData, v, showAllPhases);
                                    queryData.revenueData.forEach((d)=>{
                                        const phase = (0, $XoImS.default).phasesById[d.phaseId];
                                        onUpdateRevenue({
                                            period: periodId,
                                            revenue: d.revenueInPeriod,
                                            project: project,
                                            phase: phase
                                        });
                                    });
                                    if (updateExpensesWithRevenue) {
                                        var _queryData$hoursData;
                                        $78969f96c58dae47$var$setCostProgressFromRevenue(queryData.revenueData, queryData.hoursData, showAllPhases);
                                        onUpdateHours((queryData === null || queryData === void 0 ? void 0 : (_queryData$hoursData = queryData.hoursData) === null || _queryData$hoursData === void 0 ? void 0 : _queryData$hoursData.map((hd)=>{
                                            const staff = (0, $htkeB.default).staffById[hd.staffId];
                                            const phase = (0, $XoImS.default).phasesById[hd.phaseId];
                                            const role = (0, $bxXv3.default).rolesById[hd.roleId] || (staff === null || staff === void 0 ? void 0 : staff.role);
                                            return {
                                                period: periodId,
                                                hours: hd.hoursInPeriod,
                                                project: project,
                                                phase: phase,
                                                staff: staff,
                                                role: role
                                            };
                                        })) || []);
                                    }
                                    setQueryData({
                                        ...queryData
                                    });
                                    $78969f96c58dae47$var$saveChanges(sidebarId, {
                                        period: periodId,
                                        periodType: periodType,
                                        organisationId: (0, $1BTI2.default).organisationId,
                                        hoursData: queryData.hoursData,
                                        revenueData: queryData.revenueData
                                    });
                                }
                            }, "rev" + periodId + projectId) : null,
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                style: {
                                    padding: "2em 0"
                                },
                                children: ((queryData === null || queryData === void 0 ? void 0 : (_queryData$phases = queryData.phases) === null || _queryData$phases === void 0 ? void 0 : _queryData$phases.filter((ph)=>showAllPhases || ph.status === "active")) || []).sort((0, $6fNfM.default)).map((ph)=>{
                                    var _queryData$revenueDat;
                                    const phase = (0, $XoImS.default).phasesById[ph === null || ph === void 0 ? void 0 : ph.id];
                                    const revData = queryData === null || queryData === void 0 ? void 0 : (_queryData$revenueDat = queryData.revenueData) === null || _queryData$revenueDat === void 0 ? void 0 : _queryData$revenueDat.filter((d)=>d.phaseId === (ph === null || ph === void 0 ? void 0 : ph.id));
                                    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8oGqY.default), {
                                        label: phase === null || phase === void 0 ? void 0 : phase.title,
                                        editable: (0, $8kZ1o.canEditRevenueTargets)((0, $1BTI2.default).user) && (showAllPhases ? phase.status !== "archived" : phase.status === "active"),
                                        month: period,
                                        fee: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(revData === null || revData === void 0 ? void 0 : revData.map((d)=>d.fee)),
                                        previousRevenue: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(revData === null || revData === void 0 ? void 0 : revData.map((d)=>d.revenueBeforePeriod)),
                                        currentRevenue: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(revData === null || revData === void 0 ? void 0 : revData.map((d)=>d.revenueInPeriod)),
                                        onChange: (v)=>{
                                            $78969f96c58dae47$var$setRevenueInPeriod(revData, v, showAllPhases);
                                            revData === null || revData === void 0 || revData.forEach((d)=>{
                                                const phase = (0, $XoImS.default).phasesById[d.phaseId];
                                                onUpdateRevenue({
                                                    period: periodId,
                                                    revenue: d.revenueInPeriod,
                                                    project: project,
                                                    phase: phase
                                                });
                                            });
                                            if (updateExpensesWithRevenue) {
                                                var _queryData$hoursData2;
                                                $78969f96c58dae47$var$setCostProgressFromRevenue(queryData.revenueData, queryData.hoursData, showAllPhases);
                                                onUpdateHours((queryData === null || queryData === void 0 ? void 0 : (_queryData$hoursData2 = queryData.hoursData) === null || _queryData$hoursData2 === void 0 ? void 0 : _queryData$hoursData2.map((hd)=>{
                                                    const staff = (0, $htkeB.default).staffById[hd.staffId];
                                                    const phase = (0, $XoImS.default).phasesById[hd.phaseId];
                                                    const role = (0, $bxXv3.default).rolesById[hd.roleId] || (staff === null || staff === void 0 ? void 0 : staff.role);
                                                    return {
                                                        period: periodId,
                                                        hours: hd.hoursInPeriod,
                                                        project: project,
                                                        phase: phase,
                                                        staff: staff,
                                                        role: role
                                                    };
                                                })) || []);
                                            }
                                            setQueryData({
                                                ...queryData
                                            });
                                            $78969f96c58dae47$var$saveChanges(sidebarId, {
                                                period: periodId,
                                                periodType: periodType,
                                                organisationId: (0, $1BTI2.default).organisationId,
                                                hoursData: queryData.hoursData,
                                                revenueData: queryData.revenueData
                                            });
                                        }
                                    }, "rev" + periodId + (ph === null || ph === void 0 ? void 0 : ph.id));
                                })
                            })
                        ]
                    })
                ]
            }) : null,
            showExpenses ? /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                children: [
                    " ",
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("h4", {
                        children: [
                            "Expenses",
                            (0, $8kZ1o.canEditRevenueTargets)((0, $1BTI2.default).user, project) && showRevenue ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hYVSY.default), {
                                onChange: (e)=>{
                                    const { checked: checked } = e.target;
                                    setUpdateRevenueWithExpenses(checked);
                                },
                                checked: updateRevenueWithExpenses,
                                style: {
                                    width: "45%",
                                    float: "right",
                                    fontSize: "0.65em"
                                },
                                children: "Update Revenue With Expenses"
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            padding: "1em"
                        },
                        children: [
                            !phaseId ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $2tryL.default), {
                                editable: !!project && (0, $8kZ1o.canEditStaffAllocations)((0, $1BTI2.default).user, project),
                                month: period,
                                onChange: (v)=>{
                                    $78969f96c58dae47$var$setCostInPeriod(staffContextFilteredHoursData, v, showAllPhases);
                                    if (updateRevenueWithExpenses && showRevenue) {
                                        $78969f96c58dae47$var$setRevenueProgressFromCost(queryData.revenueData, queryData.hoursData, showAllPhases);
                                        queryData.revenueData.forEach((d)=>{
                                            const phase = (0, $XoImS.default).phasesById[d.phaseId];
                                            onUpdateRevenue({
                                                period: periodId,
                                                revenue: d.revenueInPeriod,
                                                project: project,
                                                phase: phase
                                            });
                                        });
                                    }
                                    setQueryData({
                                        ...queryData
                                    });
                                    onUpdateHours((staffContextFilteredHoursData === null || staffContextFilteredHoursData === void 0 ? void 0 : staffContextFilteredHoursData.map((hd)=>{
                                        const staff = (0, $htkeB.default).staffById[hd.staffId];
                                        const phase = (0, $XoImS.default).phasesById[hd.phaseId];
                                        const role = (0, $bxXv3.default).rolesById[hd.roleId] || (staff === null || staff === void 0 ? void 0 : staff.role);
                                        return {
                                            period: periodId,
                                            hours: hd.hoursInPeriod,
                                            project: project,
                                            phase: phase,
                                            staff: staff,
                                            role: role
                                        };
                                    })) || []);
                                    $78969f96c58dae47$var$saveChanges(sidebarId, {
                                        period: periodId,
                                        periodType: periodType,
                                        organisationId: (0, $1BTI2.default).organisationId,
                                        hoursData: staffContextFilteredHoursData,
                                        revenueData: queryData.revenueData
                                    });
                                },
                                onTimeChange: (v)=>{
                                    $78969f96c58dae47$var$setHoursInPeriod(staffContextFilteredHoursData, v, showAllPhases);
                                    if (updateRevenueWithExpenses && showRevenue) {
                                        $78969f96c58dae47$var$setRevenueProgressFromCost(queryData.revenueData, queryData.hoursData, showAllPhases);
                                        queryData.revenueData.forEach((d)=>{
                                            const phase = (0, $XoImS.default).phasesById[d.phaseId];
                                            onUpdateRevenue({
                                                period: periodId,
                                                revenue: d.revenueInPeriod,
                                                project: project,
                                                phase: phase
                                            });
                                        });
                                    }
                                    setQueryData({
                                        ...queryData
                                    });
                                    onUpdateHours((staffContextFilteredHoursData === null || staffContextFilteredHoursData === void 0 ? void 0 : staffContextFilteredHoursData.map((hd)=>{
                                        const staff = (0, $htkeB.default).staffById[hd.staffId];
                                        const phase = (0, $XoImS.default).phasesById[hd.phaseId];
                                        const role = (0, $bxXv3.default).rolesById[hd.roleId] || (staff === null || staff === void 0 ? void 0 : staff.role);
                                        return {
                                            period: periodId,
                                            hours: hd.hoursInPeriod,
                                            project: project,
                                            phase: phase,
                                            staff: staff,
                                            role: role
                                        };
                                    })) || []);
                                    $78969f96c58dae47$var$saveChanges(sidebarId, {
                                        period: periodId,
                                        periodType: periodType,
                                        organisationId: (0, $1BTI2.default).organisationId,
                                        hoursData: staffContextFilteredHoursData,
                                        revenueData: queryData.revenueData
                                    });
                                },
                                costBudget: $78969f96c58dae47$var$getCostBudget(staffContextFilteredHoursData),
                                hoursBudget: $78969f96c58dae47$var$getHoursBudget(staffContextFilteredHoursData),
                                previousCost: $78969f96c58dae47$var$getCostBeforePeriod(staffContextFilteredHoursData),
                                previousHours: $78969f96c58dae47$var$getHoursBeforePeriod(staffContextFilteredHoursData),
                                currentCost: $78969f96c58dae47$var$getCostInPeriod(staffContextFilteredHoursData),
                                currentHours: $78969f96c58dae47$var$getHoursInPeriod(staffContextFilteredHoursData),
                                label: project === null || project === void 0 ? void 0 : project.title
                            }, "res" + periodId + projectId) : null,
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                style: {
                                    padding: "2em 0"
                                },
                                children: queryData === null || queryData === void 0 ? void 0 : (_queryData$phases2 = queryData.phases) === null || _queryData$phases2 === void 0 ? void 0 : _queryData$phases2.filter((ph)=>showAllPhases || ph.status === "active").sort((0, $6fNfM.default)).map((ph)=>{
                                    const phase = (0, $XoImS.default).phasesById[ph === null || ph === void 0 ? void 0 : ph.id];
                                    const hoursData = (staffContextFilteredHoursData === null || staffContextFilteredHoursData === void 0 ? void 0 : staffContextFilteredHoursData.filter((d)=>d.phaseId === (ph === null || ph === void 0 ? void 0 : ph.id))) || [];
                                    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $2tryL.default), {
                                        editable: !!project && (0, $8kZ1o.canEditStaffAllocations)((0, $1BTI2.default).user, project) && (showAllPhases ? phase.status !== "archived" : phase.status === "active"),
                                        month: period,
                                        onChange: (v)=>{
                                            $78969f96c58dae47$var$setCostInPeriod(hoursData, v, showAllPhases);
                                            if (updateRevenueWithExpenses && showRevenue) {
                                                $78969f96c58dae47$var$setRevenueProgressFromCost(queryData.revenueData, queryData.hoursData, showAllPhases);
                                                queryData.revenueData.forEach((d)=>{
                                                    const phase = (0, $XoImS.default).phasesById[d.phaseId];
                                                    onUpdateRevenue({
                                                        period: periodId,
                                                        revenue: d.revenueInPeriod,
                                                        project: project,
                                                        phase: phase
                                                    });
                                                });
                                            }
                                            setQueryData({
                                                ...queryData
                                            });
                                            onUpdateHours((hoursData === null || hoursData === void 0 ? void 0 : hoursData.map((hd)=>{
                                                const staff = (0, $htkeB.default).staffById[hd.staffId];
                                                const role = (0, $bxXv3.default).rolesById[hd.roleId] || (staff === null || staff === void 0 ? void 0 : staff.role);
                                                return {
                                                    period: periodId,
                                                    hours: hd.hoursInPeriod,
                                                    project: project,
                                                    phase: phase,
                                                    staff: staff,
                                                    role: role
                                                };
                                            })) || []);
                                            $78969f96c58dae47$var$saveChanges(sidebarId, {
                                                period: periodId,
                                                periodType: periodType,
                                                organisationId: (0, $1BTI2.default).organisationId,
                                                hoursData: hoursData,
                                                revenueData: queryData.revenueData
                                            });
                                        },
                                        onTimeChange: (v)=>{
                                            $78969f96c58dae47$var$setHoursInPeriod(hoursData, v, showAllPhases);
                                            if (updateRevenueWithExpenses && showRevenue) {
                                                $78969f96c58dae47$var$setRevenueProgressFromCost(queryData.revenueData, queryData.hoursData, showAllPhases);
                                                queryData.revenueData.forEach((d)=>{
                                                    const phase = (0, $XoImS.default).phasesById[d.phaseId];
                                                    onUpdateRevenue({
                                                        period: periodId,
                                                        revenue: d.revenueInPeriod,
                                                        project: project,
                                                        phase: phase
                                                    });
                                                });
                                            }
                                            setQueryData({
                                                ...queryData
                                            });
                                            onUpdateHours((hoursData === null || hoursData === void 0 ? void 0 : hoursData.map((hd)=>{
                                                const staff = (0, $htkeB.default).staffById[hd.staffId];
                                                const role = (0, $bxXv3.default).rolesById[hd.roleId] || (staff === null || staff === void 0 ? void 0 : staff.role);
                                                return {
                                                    period: periodId,
                                                    hours: hd.hoursInPeriod,
                                                    project: project,
                                                    phase: phase,
                                                    staff: staff,
                                                    role: role
                                                };
                                            })) || []);
                                            $78969f96c58dae47$var$saveChanges(sidebarId, {
                                                period: periodId,
                                                periodType: periodType,
                                                organisationId: (0, $1BTI2.default).organisationId,
                                                hoursData: hoursData,
                                                revenueData: queryData.revenueData
                                            });
                                        },
                                        costBudget: $78969f96c58dae47$var$getCostBudget(hoursData),
                                        hoursBudget: $78969f96c58dae47$var$getHoursBudget(hoursData),
                                        previousCost: $78969f96c58dae47$var$getCostBeforePeriod(hoursData),
                                        previousHours: $78969f96c58dae47$var$getHoursBeforePeriod(hoursData),
                                        currentCost: $78969f96c58dae47$var$getCostInPeriod(hoursData),
                                        currentHours: $78969f96c58dae47$var$getHoursInPeriod(hoursData),
                                        label: phase === null || phase === void 0 ? void 0 : phase.title
                                    }, "res" + periodId + (ph === null || ph === void 0 ? void 0 : ph.id));
                                })
                            })
                        ]
                    })
                ]
            }) : null,
            showExpenses ? /*#__PURE__*/ (0, $61Ea1.jsx)($78969f96c58dae47$var$RoleExpenseBudgets, {
                project: project,
                period: period,
                periodId: periodId,
                periodType: periodType,
                filteredHoursData: roleContextFilteredHoursData,
                queryData: queryData,
                sidebarId: sidebarId,
                updateRevenueWithExpenses: updateRevenueWithExpenses,
                showRevenue: showRevenue,
                setQueryData: setQueryData,
                onUpdateHours: onUpdateHours,
                onUpdateRevenue: onUpdateRevenue,
                showAllPhases: showAllPhases,
                editable: !!project && (0, $8kZ1o.canEditStaffAllocations)((0, $1BTI2.default).user, project)
            }) : null,
            showExpenses ? /*#__PURE__*/ (0, $61Ea1.jsx)($78969f96c58dae47$var$StaffExpenseBudgets, {
                project: project,
                period: period,
                periodId: periodId,
                periodType: periodType,
                filteredHoursData: staffContextFilteredHoursData,
                queryData: queryData,
                sidebarId: sidebarId,
                updateRevenueWithExpenses: updateRevenueWithExpenses,
                showRevenue: showRevenue,
                setQueryData: setQueryData,
                onUpdateHours: onUpdateHours,
                onUpdateRevenue: onUpdateRevenue,
                showAllPhases: showAllPhases,
                editable: !!project && (0, $8kZ1o.canEditStaffAllocations)((0, $1BTI2.default).user, project)
            }) : null,
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6RcUP.default), {
                queryIds: [
                    {
                        id: `staff-util-${project === null || project === void 0 ? void 0 : project.id}-${periodId}`,
                        baseURL: "https://server2.coincraft.co",
                        path: `/staff-utilisation/without-project`,
                        method: "POST",
                        data: {
                            period: periodId,
                            periodType: periodType,
                            projectId: project === null || project === void 0 ? void 0 : project.id,
                            organisationId: (0, $1BTI2.default).organisationId,
                            userId: (_SessionStore$user2 = (0, $1BTI2.default).user) === null || _SessionStore$user2 === void 0 ? void 0 : _SessionStore$user2.id
                        }
                    }
                ],
                children: /*#__PURE__*/ (0, $61Ea1.jsx)($78969f96c58dae47$var$StaffUtilisation, {
                    staffIds: staffIds,
                    project: project,
                    period: period,
                    periodId: periodId,
                    periodStart: periodStart,
                    periodEnd: periodEnd,
                    periodType: periodType,
                    filteredHoursData: staffContextFilteredHoursData,
                    queryData: queryData,
                    sidebarId: sidebarId,
                    projectId: projectId,
                    phaseId: phaseId,
                    updateRevenueWithExpenses: updateRevenueWithExpenses,
                    showRevenue: showRevenue,
                    setQueryData: setQueryData,
                    onUpdateHours: onUpdateHours,
                    onUpdateRevenue: onUpdateRevenue,
                    showAllPhases: showAllPhases
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6RcUP.default), {
                queryIds: [
                    {
                        id: `rev-source-${projectId}-${periodId}`,
                        baseURL: "https://server2.coincraft.co",
                        path: `/revenue-sources/`,
                        method: "POST",
                        data: {
                            period: periodId,
                            periodType: periodType,
                            projectId: projectId,
                            organisationId: (0, $1BTI2.default).organisationId,
                            userId: (_SessionStore$user3 = (0, $1BTI2.default).user) === null || _SessionStore$user3 === void 0 ? void 0 : _SessionStore$user3.id,
                            invoiceDateType: (0, $1BTI2.default).settings.reportInvoiceDateType
                        }
                    }
                ],
                children: /*#__PURE__*/ (0, $61Ea1.jsx)($78969f96c58dae47$var$RevenueSources, {
                    project: project,
                    period: period,
                    periodId: periodId
                })
            })
        ]
    }, sidebarId);
});
const $78969f96c58dae47$var$StaffUtilisation = (0, $1EEMt.observer)(({ staffIds: staffIds, project: project, period: period, periodId: periodId, periodStart: periodStart, periodEnd: periodEnd, periodType: periodType, filteredHoursData: filteredHoursData, queryData: queryData, sidebarId: sidebarId, projectId: projectId, phaseId: phaseId, updateRevenueWithExpenses: updateRevenueWithExpenses, showRevenue: showRevenue, setQueryData: setQueryData, onUpdateHours: onUpdateHours, onUpdateRevenue: onUpdateRevenue, showAllPhases: showAllPhases })=>{
    var _queryClient$getQuery2, _ref;
    const staffUtilData = (_queryClient$getQuery2 = (0, $6Q5sp.queryClient).getQueryData([
        `staff-util-${project === null || project === void 0 ? void 0 : project.id}-${periodId}`
    ])) === null || _queryClient$getQuery2 === void 0 ? void 0 : _queryClient$getQuery2.data;
    const uniqueStaffIds = [
        ...new Set((_ref = [
            ...staffIds,
            ...filteredHoursData === null || filteredHoursData === void 0 ? void 0 : filteredHoursData.map((d)=>d.staffId)
        ], _ref === void 0) ? void 0 : _ref.filter((stId)=>{
            const staff = (0, $htkeB.default).staffById[stId];
            const hoursData = (filteredHoursData === null || filteredHoursData === void 0 ? void 0 : filteredHoursData.filter((d)=>d.staffId === (staff === null || staff === void 0 ? void 0 : staff.id))) || [];
            const totalHours = $78969f96c58dae47$var$getHoursInPeriod(hoursData);
            return totalHours > 0 || (staff === null || staff === void 0 ? void 0 : staff.isArchived) === false;
        }))
    ];
    const [selectedStaff, setSelectedStaff] = (0, $jbmdS.useState)(null);
    const handleAddStaff = ()=>{
        var _queryData$phases3;
        if (!selectedStaff) return;
        // Get phaseId - either use provided phaseId or find first active phase
        let targetPhaseId = phaseId;
        if (!targetPhaseId && queryData !== null && queryData !== void 0 && (_queryData$phases3 = queryData.phases) !== null && _queryData$phases3 !== void 0 && _queryData$phases3.length) {
            var _queryData$phases4;
            const activePhases = queryData === null || queryData === void 0 ? void 0 : (_queryData$phases4 = queryData.phases) === null || _queryData$phases4 === void 0 ? void 0 : _queryData$phases4.filter((ph)=>ph.status === "active").sort((0, $6fNfM.default));
            if (activePhases.length) targetPhaseId = activePhases[0].id;
            else {
                var _queryData$phases5;
                // If no active phases, use first non-archived phase
                const nonArchivedPhases = queryData === null || queryData === void 0 ? void 0 : (_queryData$phases5 = queryData.phases) === null || _queryData$phases5 === void 0 ? void 0 : _queryData$phases5.filter((ph)=>ph.status !== "archived").sort((0, $6fNfM.default));
                if (nonArchivedPhases.length) targetPhaseId = nonArchivedPhases[0].id;
            }
        }
        const targetPhase = (0, $XoImS.default).phasesById[targetPhaseId];
        // Create initial hoursData entry for the new staff
        const newHoursData = {
            staffId: selectedStaff.id,
            roleId: selectedStaff.roleId,
            projectId: project.id,
            phaseId: targetPhaseId,
            hoursInPeriod: 0,
            [periodType]: periodId,
            costInPeriod: 0,
            payInPeriod: 0,
            chargeOutInPeriod: 0
        };
        // Update filteredHoursData and queryData
        setQueryData({
            ...queryData,
            hoursData: [
                ...queryData.hoursData,
                newHoursData
            ]
        });
        // Add staff using ResourceScheduleStore
        (0, $6eCWq.default).addStaffs([
            selectedStaff
        ], project, targetPhase, [
            periodStart,
            periodEnd
        ], 0, // Initial hours
        "hours", (period, newHours, projectId, phaseId, roleId, staffId)=>{
            $78969f96c58dae47$export$80232d64ee2983f5.setHoursInPeriod(period, projectId, phaseId || null, roleId || null, staffId || null, newHours, (0, $6eCWq.default).selectedPhaseIds, (0, $6eCWq.default).selectedStaffIds, (0, $6eCWq.default).periodType);
        });
        // Update the uniqueStaffIds to include the new staff
        if (!uniqueStaffIds.includes(selectedStaff.id)) staffIds.push(selectedStaff.id);
        setSelectedStaff(null);
    };
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("h4", {
                children: "Utilisation"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    padding: "1em"
                },
                children: [
                    !!project && (0, $8kZ1o.canEditStaffAllocations)((0, $1BTI2.default).user, project) && /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            display: "flex",
                            gap: "0.5em",
                            marginBottom: "1em"
                        },
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.StaffSelector), {
                                selectedStaffMember: selectedStaff,
                                onChange: setSelectedStaff,
                                staffOptions: (0, $htkeB.default).staffs.filter((s)=>!s.isArchived && !uniqueStaffIds.includes(s.id)).sort((a, b)=>a.fullName.localeCompare(b.fullName)),
                                style: {
                                    flex: 1
                                },
                                variant: "secondary"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3X7oM.default), {
                                label: "+",
                                onClick: handleAddStaff,
                                // disabled={!selectedStaff}
                                style: {
                                    flex: 0
                                },
                                variant: "secondary"
                            })
                        ]
                    }),
                    uniqueStaffIds.filter(Boolean).sort((a, b)=>{
                        const staffA = (0, $htkeB.default).staffById[a];
                        const staffB = (0, $htkeB.default).staffById[b];
                        return staffA === null || staffA === void 0 ? void 0 : staffA.fullName.localeCompare(staffB === null || staffB === void 0 ? void 0 : staffB.fullName);
                    }).map((stId)=>{
                        var _staff$getAvailableHo, _staffUtilData$staff$, _staffUtilData$staff$2;
                        const staff = (0, $htkeB.default).staffById[stId];
                        const hoursData = filteredHoursData.filter((d)=>d.staffId === (staff === null || staff === void 0 ? void 0 : staff.id));
                        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ccJUd.default), {
                            label: staff === null || staff === void 0 ? void 0 : staff.fullName,
                            editable: !!project && (0, $8kZ1o.canEditStaffAllocations)((0, $1BTI2.default).user, project),
                            month: period,
                            staff: staff,
                            availability: staff === null || staff === void 0 ? void 0 : (_staff$getAvailableHo = staff.getAvailableHoursInDateRange) === null || _staff$getAvailableHo === void 0 ? void 0 : _staff$getAvailableHo.call(staff, [
                                periodStart,
                                periodEnd
                            ]),
                            totalHours: $78969f96c58dae47$var$getHoursInPeriod(hoursData) + ((_staffUtilData$staff$ = (_staffUtilData$staff$2 = staffUtilData[staff === null || staff === void 0 ? void 0 : staff.id]) === null || _staffUtilData$staff$2 === void 0 ? void 0 : _staffUtilData$staff$2.hours) !== null && _staffUtilData$staff$ !== void 0 ? _staffUtilData$staff$ : 0),
                            selectedHours: $78969f96c58dae47$var$getHoursInPeriod(hoursData),
                            onChange: (v)=>{
                                $78969f96c58dae47$var$setHoursInPeriod(hoursData, v, showAllPhases);
                                if (updateRevenueWithExpenses && showRevenue) {
                                    $78969f96c58dae47$var$setRevenueProgressFromCost(queryData.revenueData, queryData.hoursData, showAllPhases);
                                    queryData.revenueData.forEach((d)=>{
                                        const phase = (0, $XoImS.default).phasesById[d.phaseId];
                                        onUpdateRevenue({
                                            period: periodId,
                                            revenue: d.revenueInPeriod,
                                            project: project,
                                            phase: phase
                                        });
                                    });
                                }
                                setQueryData({
                                    ...queryData
                                });
                                onUpdateHours((hoursData === null || hoursData === void 0 ? void 0 : hoursData.map((hd)=>{
                                    const staff = (0, $htkeB.default).staffById[hd.staffId];
                                    const phase = (0, $XoImS.default).phasesById[hd.phaseId];
                                    const role = (0, $bxXv3.default).rolesById[hd.roleId] || (staff === null || staff === void 0 ? void 0 : staff.role);
                                    return {
                                        period: periodId,
                                        hours: hd.hoursInPeriod,
                                        project: project,
                                        phase: phase,
                                        staff: staff,
                                        role: role
                                    };
                                })) || []);
                                $78969f96c58dae47$var$saveChanges(sidebarId, {
                                    period: periodId,
                                    periodType: periodType,
                                    organisationId: (0, $1BTI2.default).organisationId,
                                    hoursData: hoursData,
                                    revenueData: queryData.revenueData
                                });
                            }
                        }, "util" + (staff === null || staff === void 0 ? void 0 : staff.id) + projectId + periodId);
                    })
                ]
            })
        ]
    });
});
const $78969f96c58dae47$var$RevenueSources = (0, $1EEMt.observer)(({ project: project, period: period, periodId: periodId })=>{
    var _queryClient$getQuery3, _sources$invoices, _sources$changeLogs, _sources$invoices2, _sources$invoices3, _sources$changeLogs2, _sources$changeLogs3;
    const sources = (_queryClient$getQuery3 = (0, $6Q5sp.queryClient).getQueryData([
        `rev-source-${project === null || project === void 0 ? void 0 : project.id}-${periodId}`
    ])) === null || _queryClient$getQuery3 === void 0 ? void 0 : _queryClient$getQuery3.data;
    if (!(sources !== null && sources !== void 0 && (_sources$invoices = sources.invoices) !== null && _sources$invoices !== void 0 && _sources$invoices.length) && !(sources !== null && sources !== void 0 && (_sources$changeLogs = sources.changeLogs) !== null && _sources$changeLogs !== void 0 && _sources$changeLogs.length)) return null;
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        style: {
            borderTop: "1px solid #ccc",
            paddingTop: "1em",
            marginTop: "1em"
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("h4", {
                children: "Revenue Sources"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    padding: "1em"
                },
                children: [
                    sources !== null && sources !== void 0 && (_sources$invoices2 = sources.invoices) !== null && _sources$invoices2 !== void 0 && _sources$invoices2.length ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                style: {
                                    fontWeight: "bold"
                                },
                                children: "Invoices"
                            }),
                            sources === null || sources === void 0 ? void 0 : (_sources$invoices3 = sources.invoices) === null || _sources$invoices3 === void 0 ? void 0 : _sources$invoices3.map((source)=>{
                                return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        justifyContent: "space-between",
                                        padding: "0.5em 0"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $kqlQp.Link), {
                                            to: `/invoices/${source === null || source === void 0 ? void 0 : source.id}`,
                                            children: [
                                                " ",
                                                source === null || source === void 0 ? void 0 : source.ref
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                            children: (0, $12o9H.FormatCurrency)(source === null || source === void 0 ? void 0 : source.amount)
                                        })
                                    ]
                                }, source === null || source === void 0 ? void 0 : source.id);
                            })
                        ]
                    }) : null,
                    sources !== null && sources !== void 0 && (_sources$changeLogs2 = sources.changeLogs) !== null && _sources$changeLogs2 !== void 0 && _sources$changeLogs2.length ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                style: {
                                    fontWeight: "bold"
                                },
                                children: "Change Log"
                            }),
                            sources === null || sources === void 0 ? void 0 : (_sources$changeLogs3 = sources.changeLogs) === null || _sources$changeLogs3 === void 0 ? void 0 : _sources$changeLogs3.map((source)=>{
                                return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        justifyContent: "space-between",
                                        padding: "0.5em 0"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                            children: source === null || source === void 0 ? void 0 : source.title
                                        }),
                                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                            children: (0, $12o9H.FormatCurrency)((source.revenue || 0) - (source.expenses || 0))
                                        })
                                    ]
                                }, source === null || source === void 0 ? void 0 : source.id);
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
});
const $78969f96c58dae47$var$StaffExpenseBudgets = (0, $1EEMt.observer)(({ project: project, period: period, periodId: periodId, periodType: periodType, filteredHoursData: filteredHoursData, queryData: queryData, sidebarId: sidebarId, updateRevenueWithExpenses: updateRevenueWithExpenses, showRevenue: showRevenue, setQueryData: setQueryData, onUpdateHours: onUpdateHours, onUpdateRevenue: onUpdateRevenue, showAllPhases: showAllPhases, editable: editable })=>{
    var _Object$keys;
    // Group hours data by staff ID
    const hoursByStaff = {};
    filteredHoursData.forEach((data)=>{
        if (!data.staffId) return;
        if (!hoursByStaff[data.staffId]) hoursByStaff[data.staffId] = [];
        hoursByStaff[data.staffId].push(data);
    });
    // Filter out staff with no hoursBudget
    const staffWithBudget = (_Object$keys = Object.keys(hoursByStaff)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.filter((staffId)=>{
        const hoursData = hoursByStaff[staffId];
        const budget = $78969f96c58dae47$var$getHoursBudget(hoursData);
        return budget > 0;
    });
    if (staffWithBudget.length === 0) return null;
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("h4", {
                children: "Staff Expense Budgets"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    padding: "1em"
                },
                children: staffWithBudget === null || staffWithBudget === void 0 ? void 0 : staffWithBudget.map((staffId)=>{
                    const staff = (0, $htkeB.default).staffById[staffId];
                    const hoursData = hoursByStaff[staffId];
                    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $2tryL.default), {
                        label: staff === null || staff === void 0 ? void 0 : staff.fullName,
                        editable: editable && (showAllPhases ? !(staff !== null && staff !== void 0 && staff.isArchived) : !(staff !== null && staff !== void 0 && staff.isArchived)),
                        month: period,
                        onChange: (v)=>{
                            $78969f96c58dae47$var$setCostInPeriod(hoursData, v, showAllPhases);
                            if (updateRevenueWithExpenses && showRevenue) {
                                $78969f96c58dae47$var$setRevenueProgressFromCost(queryData.revenueData, queryData.hoursData, showAllPhases);
                                queryData.revenueData.forEach((d)=>{
                                    const phase = (0, $XoImS.default).phasesById[d.phaseId];
                                    onUpdateRevenue({
                                        period: periodId,
                                        revenue: d.revenueInPeriod,
                                        project: project,
                                        phase: phase
                                    });
                                });
                            }
                            setQueryData({
                                ...queryData
                            });
                            onUpdateHours((hoursData === null || hoursData === void 0 ? void 0 : hoursData.map((hd)=>{
                                const staff = (0, $htkeB.default).staffById[hd.staffId];
                                const phase = (0, $XoImS.default).phasesById[hd.phaseId];
                                const role = (0, $bxXv3.default).rolesById[hd.roleId] || (staff === null || staff === void 0 ? void 0 : staff.role);
                                return {
                                    period: periodId,
                                    hours: hd.hoursInPeriod,
                                    project: project,
                                    phase: phase,
                                    staff: staff,
                                    role: role
                                };
                            })) || []);
                            $78969f96c58dae47$var$saveChanges(sidebarId, {
                                period: periodId,
                                periodType: periodType,
                                organisationId: (0, $1BTI2.default).organisationId,
                                hoursData: hoursData,
                                revenueData: queryData.revenueData
                            });
                        },
                        onTimeChange: (v)=>{
                            $78969f96c58dae47$var$setHoursInPeriod(hoursData, v, showAllPhases);
                            if (updateRevenueWithExpenses && showRevenue) {
                                $78969f96c58dae47$var$setRevenueProgressFromCost(queryData.revenueData, queryData.hoursData, showAllPhases);
                                queryData.revenueData.forEach((d)=>{
                                    const phase = (0, $XoImS.default).phasesById[d.phaseId];
                                    onUpdateRevenue({
                                        period: periodId,
                                        revenue: d.revenueInPeriod,
                                        project: project,
                                        phase: phase
                                    });
                                });
                            }
                            setQueryData({
                                ...queryData //
                            });
                            onUpdateHours((hoursData === null || hoursData === void 0 ? void 0 : hoursData.map((hd)=>{
                                const staff = (0, $htkeB.default).staffById[hd.staffId];
                                const phase = (0, $XoImS.default).phasesById[hd.phaseId];
                                const role = (0, $bxXv3.default).rolesById[hd.roleId] || (staff === null || staff === void 0 ? void 0 : staff.role);
                                return {
                                    period: periodId,
                                    hours: hd.hoursInPeriod,
                                    project: project,
                                    phase: phase,
                                    staff: staff,
                                    role: role
                                };
                            })) || []);
                            $78969f96c58dae47$var$saveChanges(sidebarId, {
                                period: periodId,
                                periodType: periodType,
                                organisationId: (0, $1BTI2.default).organisationId,
                                hoursData: hoursData,
                                revenueData: queryData.revenueData
                            });
                        },
                        costBudget: $78969f96c58dae47$var$getCostBudget(hoursData),
                        hoursBudget: $78969f96c58dae47$var$getHoursBudget(hoursData),
                        previousCost: $78969f96c58dae47$var$getCostBeforePeriod(hoursData),
                        previousHours: $78969f96c58dae47$var$getHoursBeforePeriod(hoursData),
                        currentCost: $78969f96c58dae47$var$getCostInPeriod(hoursData),
                        currentHours: $78969f96c58dae47$var$getHoursInPeriod(hoursData)
                    }, `staff-expense-${staffId}-${periodId}`);
                })
            })
        ]
    });
});
const $78969f96c58dae47$var$RoleExpenseBudgets = (0, $1EEMt.observer)(({ project: project, period: period, periodId: periodId, periodType: periodType, filteredHoursData: filteredHoursData, queryData: queryData, sidebarId: sidebarId, updateRevenueWithExpenses: updateRevenueWithExpenses, showRevenue: showRevenue, setQueryData: setQueryData, onUpdateHours: onUpdateHours, onUpdateRevenue: onUpdateRevenue, showAllPhases: showAllPhases, editable: editable })=>{
    var _Object$keys2;
    // Group hours data by role ID
    const hoursByRole = {};
    filteredHoursData.forEach((data)=>{
        if (!data.roleId) return;
        if (!hoursByRole[data.roleId]) hoursByRole[data.roleId] = [];
        hoursByRole[data.roleId].push(data);
    });
    // Filter out roles with no hoursBudget
    const rolesWithBudget = (_Object$keys2 = Object.keys(hoursByRole)) === null || _Object$keys2 === void 0 ? void 0 : _Object$keys2.filter((roleId)=>{
        const hoursData = hoursByRole[roleId];
        const budget = $78969f96c58dae47$var$getHoursBudget(hoursData);
        return budget > 0;
    });
    if (rolesWithBudget.length === 0) return null;
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("h4", {
                children: "Role Expense Budgets"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    padding: "1em"
                },
                children: rolesWithBudget === null || rolesWithBudget === void 0 ? void 0 : rolesWithBudget.map((roleId)=>{
                    const role = (0, $bxXv3.default).rolesById[roleId];
                    const hoursData = hoursByRole[roleId];
                    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $2tryL.default), {
                        label: role === null || role === void 0 ? void 0 : role.name,
                        editable: editable && (showAllPhases ? !(role !== null && role !== void 0 && role.isArchived) : !(role !== null && role !== void 0 && role.isArchived)),
                        month: period,
                        onChange: (v)=>{
                            $78969f96c58dae47$var$setCostInPeriod(hoursData, v, showAllPhases);
                            if (updateRevenueWithExpenses && showRevenue) {
                                $78969f96c58dae47$var$setRevenueProgressFromCost(queryData.revenueData, queryData.hoursData, showAllPhases);
                                queryData.revenueData.forEach((d)=>{
                                    const phase = (0, $XoImS.default).phasesById[d.phaseId];
                                    onUpdateRevenue({
                                        period: periodId,
                                        revenue: d.revenueInPeriod,
                                        project: project,
                                        phase: phase
                                    });
                                });
                            }
                            setQueryData({
                                ...queryData
                            });
                            onUpdateHours((hoursData === null || hoursData === void 0 ? void 0 : hoursData.map((hd)=>{
                                const staff = (0, $htkeB.default).staffById[hd.staffId];
                                const phase = (0, $XoImS.default).phasesById[hd.phaseId];
                                const roleFromHD = // renamed to avoid conflict
                                (0, $bxXv3.default).rolesById[hd.roleId] || (staff === null || staff === void 0 ? void 0 : staff.role);
                                return {
                                    period: periodId,
                                    hours: hd.hoursInPeriod,
                                    project: project,
                                    phase: phase,
                                    staff: staff,
                                    role: roleFromHD
                                };
                            })) || []);
                            $78969f96c58dae47$var$saveChanges(sidebarId, {
                                period: periodId,
                                periodType: periodType,
                                organisationId: (0, $1BTI2.default).organisationId,
                                hoursData: hoursData,
                                revenueData: queryData.revenueData
                            });
                        },
                        onTimeChange: (v)=>{
                            $78969f96c58dae47$var$setHoursInPeriod(hoursData, v, showAllPhases);
                            if (updateRevenueWithExpenses && showRevenue) {
                                $78969f96c58dae47$var$setRevenueProgressFromCost(queryData.revenueData, queryData.hoursData, showAllPhases);
                                queryData.revenueData.forEach((d)=>{
                                    const phase = (0, $XoImS.default).phasesById[d.phaseId];
                                    onUpdateRevenue({
                                        period: periodId,
                                        revenue: d.revenueInPeriod,
                                        project: project,
                                        phase: phase
                                    });
                                });
                            }
                            setQueryData({
                                ...queryData //
                            });
                            onUpdateHours((hoursData === null || hoursData === void 0 ? void 0 : hoursData.map((hd)=>{
                                const staff = (0, $htkeB.default).staffById[hd.staffId];
                                const phase = (0, $XoImS.default).phasesById[hd.phaseId];
                                const roleFromHD = // renamed to avoid conflict
                                (0, $bxXv3.default).rolesById[hd.roleId] || (staff === null || staff === void 0 ? void 0 : staff.role);
                                return {
                                    period: periodId,
                                    hours: hd.hoursInPeriod,
                                    project: project,
                                    phase: phase,
                                    staff: staff,
                                    role: roleFromHD
                                };
                            })) || []);
                            $78969f96c58dae47$var$saveChanges(sidebarId, {
                                period: periodId,
                                periodType: periodType,
                                organisationId: (0, $1BTI2.default).organisationId,
                                hoursData: hoursData,
                                revenueData: queryData.revenueData
                            });
                        },
                        costBudget: $78969f96c58dae47$var$getCostBudget(hoursData),
                        hoursBudget: $78969f96c58dae47$var$getHoursBudget(hoursData),
                        previousCost: $78969f96c58dae47$var$getCostBeforePeriod(hoursData),
                        previousHours: $78969f96c58dae47$var$getHoursBeforePeriod(hoursData),
                        currentCost: $78969f96c58dae47$var$getCostInPeriod(hoursData),
                        currentHours: $78969f96c58dae47$var$getHoursInPeriod(hoursData)
                    }, `role-expense-${roleId}-${periodId}`);
                })
            })
        ]
    });
});
const $78969f96c58dae47$var$splitValueAmongstObjects = (objects, value, key)=>{
    const currentTotal = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(objects.map((o)=>o[key]));
    if (currentTotal === 0) objects.forEach((o)=>{
        o[key] = value / objects.length;
    });
    else {
        const ratio = value / currentTotal;
        objects.forEach((o)=>{
            o[key] = o[key] * ratio;
        });
    }
    return objects;
};
const $78969f96c58dae47$var$filterHoursData = (hoursData, staffId, roleId, projectId, phaseId)=>{
    return (hoursData === null || hoursData === void 0 ? void 0 : hoursData.filter((d)=>{
        return (!staffId && !roleId || staffId && staffId === d.staffId || !staffId && roleId === d.roleId) && (!phaseId || phaseId === d.phaseId) && (!projectId || projectId === d.projectId);
    })) || [];
};
const $78969f96c58dae47$var$getTotalFee = (revenueData)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum((revenueData === null || revenueData === void 0 ? void 0 : revenueData.map((d)=>d.fee || 0)) || []);
};
const $78969f96c58dae47$var$getRevenueBeforePeriod = (revenueData)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum((revenueData === null || revenueData === void 0 ? void 0 : revenueData.map((d)=>d.revenueBeforePeriod || 0)) || []);
};
const $78969f96c58dae47$var$getRevenueInPeriod = (revenueData)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum((revenueData === null || revenueData === void 0 ? void 0 : revenueData.map((d)=>d.revenueInPeriod || 0)) || []);
};
const $78969f96c58dae47$var$getCostBeforePeriod = (hoursData)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum((hoursData === null || hoursData === void 0 ? void 0 : hoursData.map((d)=>d.costBeforePeriod || 0)) || []);
};
const $78969f96c58dae47$var$getCostInPeriod = (hoursData)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum((hoursData === null || hoursData === void 0 ? void 0 : hoursData.map((d)=>d.costInPeriod || 0)) || []);
};
const $78969f96c58dae47$var$getHoursBeforePeriod = (hoursData)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum((hoursData === null || hoursData === void 0 ? void 0 : hoursData.map((d)=>d.hoursBeforePeriod || 0)) || []);
};
const $78969f96c58dae47$var$getHoursInPeriod = (hoursData)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum((hoursData === null || hoursData === void 0 ? void 0 : hoursData.map((d)=>d.hoursInPeriod || 0)) || []);
};
const $78969f96c58dae47$var$getHoursBudget = (hoursData)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum((hoursData === null || hoursData === void 0 ? void 0 : hoursData.map((d)=>d.hoursBudget || 0)) || []);
};
const $78969f96c58dae47$var$getCostBudget = (hoursData)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum((hoursData === null || hoursData === void 0 ? void 0 : hoursData.map((d)=>{
        const project = (0, $gJT7h.default).projectsById[d.projectId];
        const phase = (0, $XoImS.default).phasesById[d.phaseId];
        const staff = (0, $htkeB.default).staffById[d.staffId];
        const role = (0, $bxXv3.default).rolesById[d === null || d === void 0 ? void 0 : d.roleId] || (staff === null || staff === void 0 ? void 0 : staff.role);
        const models = {
            staff: staff,
            role: role,
            project: project,
            phase: phase
        };
        const rate = (0, $ywyHN.default)(models, "cost", [
            phase === null || phase === void 0 ? void 0 : phase.startDate,
            phase === null || phase === void 0 ? void 0 : phase.endDate
        ]);
        return d.hoursBudget * rate || 0;
    })) || []);
};
const $78969f96c58dae47$var$setRevenueInPeriod = (revenueData, value, showAllPhases)=>{
    var _revenueData;
    const filteredRevenueData = ((_revenueData = revenueData) === null || _revenueData === void 0 ? void 0 : _revenueData.filter((d)=>{
        const phase = (0, $XoImS.default).phasesById[d.phaseId];
        return phase && (showAllPhases ? phase.status !== "archived" : phase.status === "active");
    })) || [];
    revenueData = filteredRevenueData.length ? filteredRevenueData : revenueData;
    $78969f96c58dae47$var$splitValueAmongstObjects(revenueData, value, "revenueInPeriod");
};
const $78969f96c58dae47$var$setHoursInPeriod = (hoursData, value, showAllPhases)=>{
    var _hoursData, _hoursData2, _hoursData4;
    const filteredHoursData = ((_hoursData = hoursData) === null || _hoursData === void 0 ? void 0 : _hoursData.filter((d)=>{
        const phase = (0, $XoImS.default).phasesById[d.phaseId];
        const staff = (0, $htkeB.default).staffById[d.staffId];
        const role = (0, $bxXv3.default).rolesById[d === null || d === void 0 ? void 0 : d.roleId] || (staff === null || staff === void 0 ? void 0 : staff.role);
        return phase && (showAllPhases ? phase.status !== "archived" : phase.status === "active") && (!staff || !(staff !== null && staff !== void 0 && staff.isArchived)) && (!role || !(role !== null && role !== void 0 && role.isArchived));
    })) || [];
    hoursData = filteredHoursData.length ? filteredHoursData : hoursData;
    // Weight by budget instead of existing hours
    const totalBudget = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(((_hoursData2 = hoursData) === null || _hoursData2 === void 0 ? void 0 : _hoursData2.map((d)=>d.hoursBudget || 0)) || []);
    if (totalBudget === 0) // If no budget, distribute evenly
    $78969f96c58dae47$var$splitValueAmongstObjects(hoursData, value, "hoursInPeriod");
    else {
        var _hoursData3;
        // Distribute proportionally to budget
        (_hoursData3 = hoursData) === null || _hoursData3 === void 0 || _hoursData3.forEach((d)=>{
            d.hoursInPeriod = (d.hoursBudget || 0) / totalBudget * value;
        });
    }
    (_hoursData4 = hoursData) === null || _hoursData4 === void 0 || _hoursData4.forEach((d)=>{
        const project = (0, $gJT7h.default).projectsById[d.projectId];
        const phase = (0, $XoImS.default).phasesById[d.phaseId];
        const staff = (0, $htkeB.default).staffById[d.staffId];
        const role = (0, $bxXv3.default).rolesById[d === null || d === void 0 ? void 0 : d.roleId] || (staff === null || staff === void 0 ? void 0 : staff.role);
        const models = {
            staff: staff,
            role: role,
            project: project,
            phase: phase
        };
        const rate = (0, $ywyHN.default)(models, "cost", [
            phase === null || phase === void 0 ? void 0 : phase.startDate,
            phase === null || phase === void 0 ? void 0 : phase.endDate
        ]);
        d.costInPeriod = d.hoursInPeriod * rate;
        const payRate = (0, $ywyHN.default)(models, "pay", [
            phase === null || phase === void 0 ? void 0 : phase.startDate,
            phase === null || phase === void 0 ? void 0 : phase.endDate
        ]);
        const chargeOutRate = (0, $ywyHN.default)(models, "chargeOut", [
            phase === null || phase === void 0 ? void 0 : phase.startDate,
            phase === null || phase === void 0 ? void 0 : phase.endDate
        ]);
        d.payInPeriod = d.hoursInPeriod * payRate;
        d.chargeOutInPeriod = d.hoursInPeriod * chargeOutRate;
    });
};
const $78969f96c58dae47$var$setCostInPeriod = (hoursData, value, showAllPhases)=>{
    var _hoursData5;
    hoursData = ((_hoursData5 = hoursData) === null || _hoursData5 === void 0 ? void 0 : _hoursData5.filter((d)=>{
        const phase = (0, $XoImS.default).phasesById[d.phaseId];
        return phase && (showAllPhases ? phase.status !== "archived" : phase.status === "active");
    })) || [];
    // Weight by cost budget instead of existing cost
    const totalCostBudget = $78969f96c58dae47$var$getCostBudget(hoursData);
    if (totalCostBudget === 0) // If no budget, distribute evenly
    $78969f96c58dae47$var$splitValueAmongstObjects(hoursData, value, "costInPeriod");
    else // Distribute proportionally to cost budget
    hoursData.forEach((d)=>{
        const project = (0, $gJT7h.default).projectsById[d.projectId];
        const phase = (0, $XoImS.default).phasesById[d.phaseId];
        const staff = (0, $htkeB.default).staffById[d.staffId];
        const role = (0, $bxXv3.default).rolesById[d === null || d === void 0 ? void 0 : d.roleId] || (staff === null || staff === void 0 ? void 0 : staff.role);
        const models = {
            staff: staff,
            role: role,
            project: project,
            phase: phase
        };
        const rate = (0, $ywyHN.default)(models, "cost", [
            phase === null || phase === void 0 ? void 0 : phase.startDate,
            phase === null || phase === void 0 ? void 0 : phase.endDate
        ]);
        const costBudget = (d.hoursBudget || 0) * rate;
        d.costInPeriod = costBudget / totalCostBudget * value;
    });
    hoursData.forEach((d)=>{
        const project = (0, $gJT7h.default).projectsById[d.projectId];
        const phase = (0, $XoImS.default).phasesById[d.phaseId];
        const staff = (0, $htkeB.default).staffById[d.staffId];
        const role = (0, $bxXv3.default).rolesById[d === null || d === void 0 ? void 0 : d.roleId] || (staff === null || staff === void 0 ? void 0 : staff.role);
        const models = {
            staff: staff,
            role: role,
            project: project,
            phase: phase
        };
        const rate = (0, $ywyHN.default)(models, "cost", [
            phase === null || phase === void 0 ? void 0 : phase.startDate,
            phase === null || phase === void 0 ? void 0 : phase.endDate
        ]);
        d.hoursInPeriod = d.costInPeriod / rate;
        const payRate = (0, $ywyHN.default)(models, "pay", [
            phase === null || phase === void 0 ? void 0 : phase.startDate,
            phase === null || phase === void 0 ? void 0 : phase.endDate
        ]);
        const chargeOutRate = (0, $ywyHN.default)(models, "chargeOut", [
            phase === null || phase === void 0 ? void 0 : phase.startDate,
            phase === null || phase === void 0 ? void 0 : phase.endDate
        ]);
        d.payInPeriod = d.hoursInPeriod * payRate;
        d.chargeOutInPeriod = d.hoursInPeriod * chargeOutRate;
    });
};
const $78969f96c58dae47$var$getRevenueProgress = (revenueData)=>{
    return ($78969f96c58dae47$var$getRevenueBeforePeriod(revenueData) + $78969f96c58dae47$var$getRevenueInPeriod(revenueData)) / $78969f96c58dae47$var$getTotalFee(revenueData) || 0;
};
const $78969f96c58dae47$var$getCostProgress = (hoursData)=>{
    return ($78969f96c58dae47$var$getCostBeforePeriod(hoursData) + $78969f96c58dae47$var$getCostInPeriod(hoursData)) / $78969f96c58dae47$var$getCostBudget(hoursData) || 0;
};
const $78969f96c58dae47$var$setRevenueProgress = (revenueData, value, showAllPhases)=>{
    var _revenueData2;
    revenueData = ((_revenueData2 = revenueData) === null || _revenueData2 === void 0 ? void 0 : _revenueData2.filter((d)=>{
        const phase = (0, $XoImS.default).phasesById[d.phaseId];
        return phase && (showAllPhases ? phase.status !== "archived" : phase.status === "active");
    })) || [];
    if (!isFinite(value) || !$78969f96c58dae47$var$getTotalFee(revenueData)) return;
    const previousRevenue = $78969f96c58dae47$var$getRevenueBeforePeriod(revenueData);
    const totalRevenue = $78969f96c58dae47$var$getTotalFee(revenueData) * value;
    const newValue = Math.max(totalRevenue - previousRevenue, 0);
    $78969f96c58dae47$var$setRevenueInPeriod(revenueData, newValue, showAllPhases);
};
const $78969f96c58dae47$var$setCostProgress = (hoursData, value, showAllPhases)=>{
    var _hoursData6;
    hoursData = ((_hoursData6 = hoursData) === null || _hoursData6 === void 0 ? void 0 : _hoursData6.filter((d)=>{
        const phase = (0, $XoImS.default).phasesById[d.phaseId];
        return phase && (showAllPhases ? phase.status !== "archived" : phase.status === "active");
    })) || [];
    if (!isFinite(value) || !$78969f96c58dae47$var$getCostBudget(hoursData)) return;
    const previousCost = $78969f96c58dae47$var$getCostBeforePeriod(hoursData);
    const totalCost = $78969f96c58dae47$var$getCostBudget(hoursData) * value;
    const newValue = Math.max(totalCost - previousCost, 0);
    $78969f96c58dae47$var$setCostInPeriod(hoursData, newValue, showAllPhases);
};
const $78969f96c58dae47$var$setRevenueProgressFromCost = (revenueData, hoursData, showAllPhases)=>{
    var _revenueData3, _hoursData7;
    revenueData = ((_revenueData3 = revenueData) === null || _revenueData3 === void 0 ? void 0 : _revenueData3.filter((d)=>{
        const phase = (0, $XoImS.default).phasesById[d.phaseId];
        return phase && (showAllPhases ? phase.status !== "archived" : phase.status === "active");
    })) || [];
    hoursData = (_hoursData7 = hoursData) === null || _hoursData7 === void 0 ? void 0 : _hoursData7.filter((d)=>{
        const phase = (0, $XoImS.default).phasesById[d.phaseId];
        return phase && (showAllPhases ? phase.status !== "archived" : phase.status === "active");
    });
    revenueData.forEach((rd)=>{
        const filteredHoursData = $78969f96c58dae47$var$filterHoursData(hoursData, rd.staffId, rd.roleId, rd.projectId, rd.phaseId);
        const costProgress = $78969f96c58dae47$var$getCostProgress(filteredHoursData);
        if (isFinite(costProgress)) $78969f96c58dae47$var$setRevenueProgress([
            rd
        ], costProgress, showAllPhases);
    });
};
const $78969f96c58dae47$var$setCostProgressFromRevenue = (revenueData, hoursData, showAllPhases)=>{
    var _revenueData4, _hoursData8;
    revenueData = ((_revenueData4 = revenueData) === null || _revenueData4 === void 0 ? void 0 : _revenueData4.filter((d)=>{
        const phase = (0, $XoImS.default).phasesById[d.phaseId];
        return phase && phase.status && (showAllPhases ? phase.status !== "archived" : phase.status === "active");
    })) || [];
    hoursData = ((_hoursData8 = hoursData) === null || _hoursData8 === void 0 ? void 0 : _hoursData8.filter((d)=>{
        const phase = (0, $XoImS.default).phasesById[d.phaseId];
        return phase && phase.status && (showAllPhases ? phase.status !== "archived" : phase.status === "active");
    })) || [];
    hoursData.forEach((hd)=>{
        var _revenueData5;
        const filteredRevenueData = ((_revenueData5 = revenueData) === null || _revenueData5 === void 0 ? void 0 : _revenueData5.filter((rd)=>rd.phaseId === hd.phaseId)) || [];
        const revenueProgress = $78969f96c58dae47$var$getRevenueProgress(filteredRevenueData);
        if (isFinite(revenueProgress)) $78969f96c58dae47$var$setCostProgress([
            hd
        ], revenueProgress, showAllPhases);
    });
};

const $78969f96c58dae47$var$saveChanges = (id, queryData)=>{
    const DataStore = (parcelRequire("fM2j4")).default;
    DataStore.addSaveFunction(id, async ()=>{
        var _SessionStore$user4;
        await (0, $iOQGT.makeRequest)({
            baseURL: "https://server2.coincraft.co",
            path: `/project-forecast-sidebar/save`,
            method: "POST",
            data: {
                ...queryData,
                organisationId: (0, $1BTI2.default).organisationId,
                userId: (_SessionStore$user4 = (0, $1BTI2.default).user) === null || _SessionStore$user4 === void 0 ? void 0 : _SessionStore$user4.id
            }
        });
    });
};

});
parcelRegister("6eCWq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48a241d888fbd1ac$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $eat5C = parcelRequire("eat5C");

var $4hBm1 = parcelRequire("4hBm1");

var $hdshG = parcelRequire("hdshG");

var $htkeB = parcelRequire("htkeB");

var $4iwZm = parcelRequire("4iwZm");

var $khJQv = parcelRequire("khJQv");

var $1BTI2 = parcelRequire("1BTI2");

var $cV8g5 = parcelRequire("cV8g5");

var $6mjwz = parcelRequire("6mjwz");

var $62nmb = parcelRequire("62nmb");
parcelRequire("jE5CX");

var $ikffN = parcelRequire("ikffN");

var $iOQGT = parcelRequire("iOQGT");

var $cQvuY = parcelRequire("cQvuY");

var $Ds2V9 = parcelRequire("Ds2V9");

var $8XaFv = parcelRequire("8XaFv");

var $XoImS = parcelRequire("XoImS");
var $48a241d888fbd1ac$var$_dec, $48a241d888fbd1ac$var$_dec2, $48a241d888fbd1ac$var$_dec3, $48a241d888fbd1ac$var$_dec4, $48a241d888fbd1ac$var$_dec5, $48a241d888fbd1ac$var$_dec6, $48a241d888fbd1ac$var$_dec7, $48a241d888fbd1ac$var$_dec8, $48a241d888fbd1ac$var$_dec9, $48a241d888fbd1ac$var$_dec10, $48a241d888fbd1ac$var$_dec11, $48a241d888fbd1ac$var$_dec12, $48a241d888fbd1ac$var$_dec13, $48a241d888fbd1ac$var$_dec14, $48a241d888fbd1ac$var$_dec15, $48a241d888fbd1ac$var$_class, $48a241d888fbd1ac$var$_descriptor, $48a241d888fbd1ac$var$_descriptor2, $48a241d888fbd1ac$var$_descriptor3, $48a241d888fbd1ac$var$_descriptor4, $48a241d888fbd1ac$var$_descriptor5, $48a241d888fbd1ac$var$_descriptor6, $48a241d888fbd1ac$var$_descriptor7, $48a241d888fbd1ac$var$_descriptor8, $48a241d888fbd1ac$var$_descriptor9, $48a241d888fbd1ac$var$_descriptor10, $48a241d888fbd1ac$var$_descriptor11, $48a241d888fbd1ac$var$_descriptor12, $48a241d888fbd1ac$var$_descriptor13, $48a241d888fbd1ac$var$_descriptor14, $48a241d888fbd1ac$var$_descriptor15, $48a241d888fbd1ac$var$_descriptor16, $48a241d888fbd1ac$var$_descriptor17, $48a241d888fbd1ac$var$_descriptor18, $48a241d888fbd1ac$var$_descriptor19;
function $48a241d888fbd1ac$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $48a241d888fbd1ac$var$_defineProperty(e, r, t) {
    return (r = $48a241d888fbd1ac$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $48a241d888fbd1ac$var$_toPropertyKey(t) {
    var i = $48a241d888fbd1ac$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $48a241d888fbd1ac$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $48a241d888fbd1ac$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $48a241d888fbd1ac$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
const $48a241d888fbd1ac$var$undefinedRole = {
    id: null
};
const $48a241d888fbd1ac$export$6a7dce92243b5962 = {
    project: "projectId",
    phase: "phaseId",
    role: "staffRoleId",
    staff: "staffId",
    status: "status",
    owner: "ownerId"
};
const $48a241d888fbd1ac$export$f1f4ce1df2235f79 = {
    project: (row)=>row.project.title,
    phase: (row)=>row.phase.title,
    role: (row)=>(row === null || row === void 0 ? void 0 : row.name) || "(No Role)",
    staff: (row)=>row.fullName || "(No Staff)",
    status: (row)=>(0, $ikffN.capitalCase)(row)
};
const $48a241d888fbd1ac$var$dateFuncs = {
    month: {
        add: (0, $4hBm1.addMonths),
        sub: (0, $4hBm1.subMonths),
        start: (0, $4hBm1.startOfMonth),
        end: (0, $4hBm1.endOfMonth),
        formatString: "yyyy-MM",
        displayFormatString: "MMM yy"
    },
    week: {
        add: (0, $4hBm1.addWeeks),
        sub: (0, $4hBm1.subWeeks),
        start: (0, $4hBm1.startOfISOWeek),
        end: (0, $4hBm1.endOfISOWeek),
        formatString: "RRRR-II",
        displayFormatString: "dd MMM yy"
    }
};
let $48a241d888fbd1ac$var$ResourceScheduleStore = ($48a241d888fbd1ac$var$_dec = (0, $4JcCM.action).bound, $48a241d888fbd1ac$var$_dec2 = (0, $4JcCM.action).bound, $48a241d888fbd1ac$var$_dec3 = (0, $4JcCM.action).bound, $48a241d888fbd1ac$var$_dec4 = (0, $4JcCM.action).bound, $48a241d888fbd1ac$var$_dec5 = (0, $4JcCM.action).bound, $48a241d888fbd1ac$var$_dec6 = (0, $4JcCM.action).bound, $48a241d888fbd1ac$var$_dec7 = (0, $4JcCM.action).bound, $48a241d888fbd1ac$var$_dec8 = (0, $4JcCM.action).bound, $48a241d888fbd1ac$var$_dec9 = (0, $4JcCM.action).bound, $48a241d888fbd1ac$var$_dec10 = (0, $4JcCM.action).bound, $48a241d888fbd1ac$var$_dec11 = (0, $4JcCM.action).bound, $48a241d888fbd1ac$var$_dec12 = (0, $4JcCM.action).bound, $48a241d888fbd1ac$var$_dec13 = (0, $4JcCM.action).bound, $48a241d888fbd1ac$var$_dec14 = (0, $4JcCM.action).bound, $48a241d888fbd1ac$var$_dec15 = (0, $4JcCM.action).bound, $48a241d888fbd1ac$var$_class = class ResourceScheduleStore {
    constructor(){
        $48a241d888fbd1ac$var$_initializerDefineProperty(this, "startDate", $48a241d888fbd1ac$var$_descriptor, this);
        $48a241d888fbd1ac$var$_initializerDefineProperty(this, "endDate", $48a241d888fbd1ac$var$_descriptor2, this);
        $48a241d888fbd1ac$var$_initializerDefineProperty(this, "selectedObject", $48a241d888fbd1ac$var$_descriptor3, this);
        $48a241d888fbd1ac$var$_initializerDefineProperty(this, "selectedPeriod", $48a241d888fbd1ac$var$_descriptor4, this);
        $48a241d888fbd1ac$var$_initializerDefineProperty(this, "selectedProjectId", $48a241d888fbd1ac$var$_descriptor5, this);
        $48a241d888fbd1ac$var$_initializerDefineProperty(this, "selectedPhaseId", $48a241d888fbd1ac$var$_descriptor6, this);
        $48a241d888fbd1ac$var$_initializerDefineProperty(this, "selectedStaffId", $48a241d888fbd1ac$var$_descriptor7, this);
        $48a241d888fbd1ac$var$_initializerDefineProperty(this, "selectedRoleId", $48a241d888fbd1ac$var$_descriptor8, this);
        $48a241d888fbd1ac$var$_initializerDefineProperty(this, "selectedStaffIds", $48a241d888fbd1ac$var$_descriptor9, this);
        $48a241d888fbd1ac$var$_initializerDefineProperty(this, "selectedPhaseIds", $48a241d888fbd1ac$var$_descriptor10, this);
        $48a241d888fbd1ac$var$_initializerDefineProperty(this, "isPrinting", $48a241d888fbd1ac$var$_descriptor11, this);
        $48a241d888fbd1ac$var$_initializerDefineProperty(this, "expandedAllocationRows", $48a241d888fbd1ac$var$_descriptor12, this);
        $48a241d888fbd1ac$var$_initializerDefineProperty(this, "editedHours", $48a241d888fbd1ac$var$_descriptor13, this);
        $48a241d888fbd1ac$var$_initializerDefineProperty(this, "queryData", $48a241d888fbd1ac$var$_descriptor14, this);
        $48a241d888fbd1ac$var$_initializerDefineProperty(this, "_periodType", $48a241d888fbd1ac$var$_descriptor15, this);
        $48a241d888fbd1ac$var$_initializerDefineProperty(this, "searchParams", $48a241d888fbd1ac$var$_descriptor16, this);
        $48a241d888fbd1ac$var$_initializerDefineProperty(this, "expandAll", $48a241d888fbd1ac$var$_descriptor17, this);
        $48a241d888fbd1ac$var$_initializerDefineProperty(this, "exportGroup", $48a241d888fbd1ac$var$_descriptor18, this);
        $48a241d888fbd1ac$var$_defineProperty(this, "setPeriodType", (type)=>{
            this._periodType = type;
            this.report.updateFilters({
                period: type
            });
            this.reset();
        });
        $48a241d888fbd1ac$var$_defineProperty(this, "addPeriods", (...params)=>{
            return $48a241d888fbd1ac$var$dateFuncs[this.periodType].add(...params);
        });
        $48a241d888fbd1ac$var$_defineProperty(this, "subPeriods", (...params)=>{
            return $48a241d888fbd1ac$var$dateFuncs[this.periodType].sub(...params);
        });
        $48a241d888fbd1ac$var$_defineProperty(this, "startOfPeriod", (...params)=>{
            return $48a241d888fbd1ac$var$dateFuncs[this.periodType].start(...params);
        });
        $48a241d888fbd1ac$var$_defineProperty(this, "endOfPeriod", (...params)=>{
            return $48a241d888fbd1ac$var$dateFuncs[this.periodType].end(...params);
        });
        $48a241d888fbd1ac$var$_defineProperty(this, "periodFormat", ()=>{
            return $48a241d888fbd1ac$var$dateFuncs[this.periodType].formatString;
        });
        $48a241d888fbd1ac$var$_defineProperty(this, "periodDisplayFormat", ()=>{
            return $48a241d888fbd1ac$var$dateFuncs[this.periodType].displayFormatString;
        });
        $48a241d888fbd1ac$var$_defineProperty(this, "getResourceRows", (0, $Ds2V9.computedFn)((keyString = "")=>{
            const keys = keyString ? keyString.split(",").filter((v)=>v) : [];
            let rows = this.queryData;
            keys.forEach((k)=>{
                var _rows$find;
                rows = (((_rows$find = rows.find((r)=>(r === null || r === void 0 ? void 0 : r.key) === k)) === null || _rows$find === void 0 ? void 0 : _rows$find.children) || [
                    rows.find((r)=>(r === null || r === void 0 ? void 0 : r.key) === k)
                ]).filter((v)=>v);
            });
            return rows || [];
        }));
        $48a241d888fbd1ac$var$_defineProperty(this, "getAllLeafResourceRows", (0, $Ds2V9.computedFn)(()=>{
            let rows = this.queryData;
            while((_rows$ = rows[0]) !== null && _rows$ !== void 0 && (_rows$$children = _rows$.children) !== null && _rows$$children !== void 0 && _rows$$children.length){
                var _rows$, _rows$$children;
                rows = rows.flatMap((r)=>r.children);
            }
            return rows;
        }));
        $48a241d888fbd1ac$var$_defineProperty(this, "getRowStaffIds", (row)=>{
            let rows = [
                row
            ];
            while((_rows$2 = rows[0]) !== null && _rows$2 !== void 0 && (_rows$2$children = _rows$2.children) !== null && _rows$2$children !== void 0 && _rows$2$children.length){
                var _rows$2, _rows$2$children;
                rows = rows.flatMap((r)=>r.children);
            }
            return [
                ...new Set(rows.filter(Boolean).map((r)=>r.staffId))
            ];
        });
        $48a241d888fbd1ac$var$_defineProperty(this, "getRowPhaseIds", (row)=>{
            let rows = [
                row
            ];
            while((_rows$3 = rows[0]) !== null && _rows$3 !== void 0 && (_rows$3$children = _rows$3.children) !== null && _rows$3$children !== void 0 && _rows$3$children.length){
                var _rows$3, _rows$3$children;
                rows = rows.flatMap((r)=>r.children);
            }
            return [
                ...new Set(rows.filter(Boolean).map((r)=>r.phaseId))
            ];
        });
        $48a241d888fbd1ac$var$_defineProperty(this, "getLeafResourceRows", (0, $Ds2V9.computedFn)((keyString = "")=>{
            var r, k;
            return [];
        }));
        $48a241d888fbd1ac$var$_defineProperty(this, "getEditedHoursData", (0, $Ds2V9.computedFn)((keyString = "")=>{
            const rows = this.getLeafResourceRows(keyString);
            return rows.flatMap((r)=>this.editedHours[this.periodType][r.fullPath] || []);
        }));
        $48a241d888fbd1ac$var$_defineProperty(this, "getRowTimeData", (0, $Ds2V9.computedFn)((keyString = "")=>{
            const rows = this.getLeafResourceRows(keyString);
            return rows.flatMap((r)=>r.data || []);
        }));
        $48a241d888fbd1ac$var$_defineProperty(this, "getTotalBudget", (0, $Ds2V9.computedFn)((keyString = "")=>{
            const budgets = this.getRowTimeData(keyString).filter((b)=>b.type === "budget");
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(budgets.map((b)=>{
                var _b$likelihood;
                const useLikelihood = [
                    "prospective",
                    "onHold"
                ].includes(b.status);
                const likelihood = useLikelihood ? (_b$likelihood = b.likelihood) !== null && _b$likelihood !== void 0 ? _b$likelihood : 1 : 1;
                return b.hours * likelihood;
            }));
        }));
        $48a241d888fbd1ac$var$_defineProperty(this, "getLikelihood", (0, $Ds2V9.computedFn)((keyString = "")=>{
            const budgets = this.getRowTimeData(keyString).filter((b)=>b.type === "budget" || b.type === "allocation");
            if (!budgets.length) return 1;
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).mean(budgets.map((b)=>{
                var _b$likelihood2;
                const useLikelihood = [
                    "prospective",
                    "onHold"
                ].includes(b.status);
                return useLikelihood ? (_b$likelihood2 = b.likelihood) !== null && _b$likelihood2 !== void 0 ? _b$likelihood2 : 1 : 1;
            }));
        }));
        $48a241d888fbd1ac$var$_defineProperty(this, "getAvailabilityInPeriod", (0, $Ds2V9.computedFn)((keyString = "", period)=>{
            const keys = keyString.split(",");
            const staffId = keys[this.report.filters.groups.findIndex((g)=>g === "staff")];
            const roleId = keys[this.report.filters.groups.findIndex((g)=>g === "role")];
            const staffFilters = this.report.filters.staff;
            const roleFilters = this.report.filters.roles;
            const staff = (0, $htkeB.default).activeStaff.filter((st)=>{
                return (!staffId || st.id === staffId) && (!roleId || st.roleId === roleId || roleId === "null" && !st.roleId) && (!roleFilters.length || roleFilters.includes(st.roleId)) && (!staffFilters.length || staffFilters.includes(st.id));
            });
            const periodDate = this.startOfPeriod((0, $4hBm1.parse)(period, this.periodFormat(), new Date()));
            const start = this.startOfPeriod(periodDate);
            const end = this.endOfPeriod(periodDate);
            const dayAfterEnd = this.startOfPeriod(this.addPeriods(end, 1));
            const holidayDays = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum((0, $8XaFv.default).organisationHolidays.filter((h)=>h.startDate <= end && h.endDate >= start).map((h)=>{
                const startDate = Math.max(h.startDate, start);
                const endDate = (0, $4hBm1.addDays)((0, $4hBm1.startOfDay)(Math.min(h.endDate, end)), 1);
                return (0, $4hBm1.differenceInBusinessDays)(endDate, startDate);
            }));
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(staff.map((s)=>s.getAvailabilityInDateRange([
                    start,
                    end
                ]) / 60 / 5)) * ((0, $4hBm1.differenceInBusinessDays)(dayAfterEnd, start) - holidayDays);
        }));
        $48a241d888fbd1ac$var$_defineProperty(this, "getEditedHoursDataInPeriod", (0, $Ds2V9.computedFn)((keyString = "", period)=>{
            return this.getEditedHoursData(keyString).filter((d)=>d[this.periodType] === period);
        }));
        $48a241d888fbd1ac$var$_defineProperty(this, "getTimeDataInPeriod", (0, $Ds2V9.computedFn)((keyString = "", period)=>{
            return this.getRowTimeData(keyString).filter((d)=>{
                return d[this.periodType] === period;
            });
        }));
        $48a241d888fbd1ac$var$_defineProperty(this, "getAllocationTimeDataInPeriod", (0, $Ds2V9.computedFn)((keyString = "", period)=>{
            return this.getTimeDataInPeriod(keyString, period).filter((d)=>{
                return d.type === "allocation";
            });
        }));
        $48a241d888fbd1ac$var$_defineProperty(this, "getTimeEntryTimeDataInPeriod", (0, $Ds2V9.computedFn)((keyString = "", period)=>{
            return this.getTimeDataInPeriod(keyString, period).filter((d)=>{
                return d.type === "timeEntry";
            });
        }));
        $48a241d888fbd1ac$var$_defineProperty(this, "getProspectiveTimeDataInPeriod", (0, $Ds2V9.computedFn)((keyString = "", period)=>{
            return this.getAllocationTimeDataInPeriod(keyString, period).filter((d)=>{
                return d.status === "prospective";
            });
        }));
        $48a241d888fbd1ac$var$_defineProperty(this, "getProspectiveHoursInPeriod", (0, $Ds2V9.computedFn)((keyString = "", period)=>{
            const thisPeriod = (0, $4hBm1.format)(new Date(), "yyyy-MM");
            if (period < thisPeriod) return 0;
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.getProspectiveTimeDataInPeriod(keyString, period).map((b)=>{
                var _b$likelihood3;
                const useLikelihood = [
                    "prospective",
                    "onHold"
                ].includes(b.status);
                const likelihood = useLikelihood ? (_b$likelihood3 = b.likelihood) !== null && _b$likelihood3 !== void 0 ? _b$likelihood3 : 1 : 1;
                return b.hours * likelihood;
            }));
        }));
        $48a241d888fbd1ac$var$_defineProperty(this, "getEditedHoursInPeriod", (0, $Ds2V9.computedFn)((keyString = "", period)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.getEditedHoursDataInPeriod(keyString, period).map((b)=>{
                var _b$likelihood4;
                const useLikelihood = [
                    "prospective",
                    "onHold"
                ].includes(b.status);
                const likelihood = useLikelihood ? (_b$likelihood4 = b.likelihood) !== null && _b$likelihood4 !== void 0 ? _b$likelihood4 : 1 : 1;
                return b.hours * likelihood;
            }));
        }));
        $48a241d888fbd1ac$var$_defineProperty(this, "getAllocationHoursInPeriod", (0, $Ds2V9.computedFn)((keyString = "", period)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.getAllocationTimeDataInPeriod(keyString, period).map((b)=>{
                var _b$likelihood5;
                const useLikelihood = [
                    "prospective",
                    "onHold"
                ].includes(b.status);
                const likelihood = useLikelihood ? (_b$likelihood5 = b.likelihood) !== null && _b$likelihood5 !== void 0 ? _b$likelihood5 : 1 : 1;
                return b.hours * likelihood;
            }));
        }));
        $48a241d888fbd1ac$var$_defineProperty(this, "getTimeEntryHoursInPeriod", (0, $Ds2V9.computedFn)((keyString = "", period)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.getTimeEntryTimeDataInPeriod(keyString, period).map((d)=>d.hours));
        }));
        $48a241d888fbd1ac$var$_defineProperty(this, "getHoursInPeriod", (0, $Ds2V9.computedFn)((keyString = "", period)=>{
            const rows = this.getLeafResourceRows(keyString);
            if (rows.length > 1) return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(rows.map((r)=>this.getHoursInPeriod(r.fullPath, period)));
            const hoursData = this.report.filters.hoursData;
            const thisPeriod = (0, $4hBm1.format)(new Date(), this.periodFormat());
            const isPastPeriod = period < thisPeriod;
            const isFuturePeriod = period > thisPeriod;
            const isCurrentPeriod = period === thisPeriod;
            if (hoursData === "remainingProjected") return this.getAllocationHoursInPeriod(keyString, period) + this.getEditedHoursInPeriod(keyString, period) - this.getTimeEntryHoursInPeriod(keyString, period);
            if (hoursData === "remainingProjectedCapped") return Math.max(this.getAllocationHoursInPeriod(keyString, period) + this.getEditedHoursInPeriod(keyString, period) - this.getTimeEntryHoursInPeriod(keyString, period), 0);
            // if (hoursData === 'actualsVsProjected') {
            //     return {
            //         numerator: this.getTimeEntryHoursInPeriod(keyString, period),
            //         denominator:
            //             this.getAllocationHoursInPeriod(keyString, period) +
            //             this.getEditedHoursInPeriod(keyString, period),
            //     }
            // }
            if (hoursData === "projected") return this.getAllocationHoursInPeriod(keyString, period) + this.getEditedHoursInPeriod(keyString, period);
            if (hoursData === "actuals") return this.getTimeEntryHoursInPeriod(keyString, period);
            if (isPastPeriod) return this.getTimeEntryHoursInPeriod(keyString, period);
            if (isFuturePeriod) return this.getAllocationHoursInPeriod(keyString, period) + this.getEditedHoursInPeriod(keyString, period);
            if (isCurrentPeriod) return Math.max(this.getAllocationHoursInPeriod(keyString, period) + this.getEditedHoursInPeriod(keyString, period), this.getTimeEntryHoursInPeriod(keyString, period));
        }));
        $48a241d888fbd1ac$var$_defineProperty(this, "getHoursToDateInPeriod", (0, $Ds2V9.computedFn)((keyString = "", period)=>{
            const periods = this.dataPeriods.filter((m)=>m <= period);
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(periods.map((m)=>this.getHoursInPeriod(keyString, m)));
        }));
        $48a241d888fbd1ac$var$_defineProperty(this, "getTotalHours", (0, $Ds2V9.computedFn)((keyString = "")=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.dataPeriods.map((m)=>this.getHoursInPeriod(keyString, m)));
        }));
        $48a241d888fbd1ac$var$_initializerDefineProperty(this, "updateRows", $48a241d888fbd1ac$var$_descriptor19, this);
        (0, $4JcCM.makeObservable)(this);
        this.resourceTableStore = new (0, $hdshG.default)();
    }
    init(queryData) {
        this._periodType = this.report.filters.period || "month";
        this.queryData = queryData;
        this.getLeafResourceRows(null).forEach((r)=>{
            this.editedHours[this.periodType][r.fullPath] = [];
        });
        this.startDate = this.startOfPeriod(this.subPeriods(new Date(), 3));
        this.endDate = this.endOfPeriod(this.addPeriods(new Date(), 8));
        this.selectedObject = null;
        this.selectedPeriod = null;
    }
    reset() {
        (0, $khJQv.default).toggleSidebar(false);
        this.startDate = this.startOfPeriod(this.subPeriods(new Date(), 3));
        this.endDate = this.endOfPeriod(this.addPeriods(new Date(), 8));
        this.selectedObject = null;
        this.selectedPeriod = null;
        this.expandedAllocationRows = new Set();
        this.queryData = [];
    }
    setSearchParams(params) {
        this.searchParams = params;
    }
    setExportGroup(group) {
        this.exportGroup = group;
    }
    get periodType() {
        var _this$report, _this$report$filters;
        return ((_this$report = this.report) === null || _this$report === void 0 ? void 0 : (_this$report$filters = _this$report.filters) === null || _this$report$filters === void 0 ? void 0 : _this$report$filters.period) || this._periodType;
    }
    get staff() {
        const reportFilters = this.report.filters;
        return (0, $htkeB.default).staff.filter((s)=>{
            return (!reportFilters.roles.length || reportFilters.roles.includes(s.roleId)) && (!reportFilters.staff.length || reportFilters.staff.includes(s.id)) && (reportFilters.staff.length || reportFilters.roles.length || !s.deletedAt);
        });
    }
    setExpandAll(expandAll) {
        this.expandAll = expandAll;
    }
    makeQueryKey(base) {
        return base + this.report.queryKey;
    }
    get fetchedProjectIds() {
        return [
            ...new Set(this.getAllLeafResourceRows().map((r)=>r.fullPath.split(",")[this.report.filters.groups.findIndex((g)=>g === "project")]))
        ].filter((v)=>v);
    }
    setEditedHoursData(keyString = "", period, hours, afterEdit) {
        const rows = this.getLeafResourceRows(keyString);
        const existingHours = this.getHoursInPeriod(keyString, period);
        const ratio = existingHours && hours / existingHours;
        rows.forEach((r)=>{
            var _this$editedHours$thi, _r$fullPath, _this$editedHours$thi2;
            const rExistingHours = this.getHoursInPeriod(r.fullPath, period);
            const likelihood = this.getLikelihood(r.fullPath);
            const newHours = (ratio ? rExistingHours * ratio : hours / rows.length) / likelihood;
            (_this$editedHours$thi2 = (_this$editedHours$thi = this.editedHours[this.periodType])[_r$fullPath = r.fullPath]) !== null && _this$editedHours$thi2 !== void 0 ? _this$editedHours$thi2 : _this$editedHours$thi[_r$fullPath] = [];
            this.editedHours[r.fullPath] = this.editedHours[this.periodType][r.fullPath].filter((h)=>h[this.periodType] !== period);
            this.editedHours[this.periodType][r.fullPath].push({
                fullPath: r.fullPath,
                [this.periodType]: period,
                hours: newHours
            });
            r.data = r.data.filter((d)=>!(d[this.periodType] === period && d.type === "allocation"));
            if (afterEdit && this.selectedProjectId) afterEdit(period, r.fullPath.split(","), newHours, this.report.filters.groups);
        });
    }
    async saveChanges() {
        return (0, $iOQGT.makeRequest)({
            baseURL: "https://server2.coincraft.co",
            path: "/resource-schedule/save",
            method: "POST",
            data: {
                organisationId: (0, $1BTI2.default).organisationId,
                groups: this.report.filters.groups,
                editedAllocations: this.getEditedHoursData(null)
            }
        });
    }
    get dataPeriods() {
        return [
            ...this.getRowTimeData(null),
            ...this.getEditedHoursData(null)
        ].map((d)=>d[this.periodType]).filter((v)=>v);
    }
    get report() {
        var _this$searchParams, _SessionStore$organis;
        return (0, $4iwZm.default).resourceSchedulesById[(_this$searchParams = this.searchParams) === null || _this$searchParams === void 0 ? void 0 : _this$searchParams.report] || ((0, $1BTI2.default) === null || (0, $1BTI2.default) === void 0 ? void 0 : (_SessionStore$organis = (0, $1BTI2.default).organisation) === null || _SessionStore$organis === void 0 ? void 0 : _SessionStore$organis.defaultResourceScheduleReport) || {};
    }
    updateFilters(filterData) {
        this.report.updateFilters(filterData);
    }
    selectCell(selectedPeriod, keys, selectedObject) {
        this.selectedPeriod = selectedPeriod;
        this.selectedObject = selectedObject;
        this.selectedProjectId = selectedObject === null || selectedObject === void 0 ? void 0 : selectedObject.projectId;
        this.selectedPhaseId = selectedObject === null || selectedObject === void 0 ? void 0 : selectedObject.phaseId;
        this.selectedStaffId = selectedObject === null || selectedObject === void 0 ? void 0 : selectedObject.staffId;
        this.selectedRoleId = selectedObject === null || selectedObject === void 0 ? void 0 : selectedObject.staffRoleId;
        this.selectedStaffIds = this.getRowStaffIds(selectedObject);
        this.selectedPhaseIds = this.getRowPhaseIds(selectedObject);
        (0, $khJQv.default).showSidebar = !!(selectedPeriod && selectedObject);
    }
    shiftSelectedPeriod(amount) {
        this.selectedPeriod = this.addPeriods(this.selectedPeriod, amount);
        if (this.selectedPeriod < this.startDate || this.selectedPeriod > this.endDate) this.shiftDates(amount);
    }
    shiftDates(amount) {
        this.startDate = this.addPeriods(this.startDate, amount);
        this.endDate = this.addPeriods(this.endDate, amount);
        let newDates = [];
        if (amount > 0) newDates = [
            this.startOfPeriod(this.endDate),
            this.endOfPeriod(this.endDate)
        ];
        else newDates = [
            this.startOfPeriod(this.startDate),
            this.endOfPeriod(this.startDate)
        ];
        this.updateRows();
    }
    getRowAvailabilityInPeriod(row, period) {
        const staff = (row !== null && row !== void 0 && row.staffId ? [
            (0, $htkeB.default).staffById[row.staffId]
        ] : row !== null && row !== void 0 && row.roleId ? (0, $htkeB.default).staffByRoleId[row.roleId] : (0, $htkeB.default).staffs) || [];
        const periodDate = this.startOfPeriod((0, $4hBm1.parse)(period, this.periodFormat(), new Date()));
        const start = this.startOfPeriod(periodDate);
        const end = this.endOfPeriod(periodDate);
        const dayAfterEnd = this.startOfPeriod(this.addPeriods(end, 1));
        const holidayDays = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum((0, $8XaFv.default).organisationHolidays.filter((h)=>h.startDate <= end && h.endDate >= start).map((h)=>{
            const startDate = Math.max(h.startDate, start);
            const endDate = (0, $4hBm1.addDays)((0, $4hBm1.startOfDay)(Math.min(h.endDate, end)), 1);
            return (0, $4hBm1.differenceInBusinessDays)(endDate, startDate);
        }));
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(staff.filter(Boolean).map((s)=>s.getAvailabilityInDateRange([
                start,
                end
            ]) / 60 / 5)) * ((0, $4hBm1.differenceInBusinessDays)(dayAfterEnd, start) - holidayDays);
    }
    getRowBudget(row) {
        const emptyRow = !(row !== null && row !== void 0 && row.key);
        if (emptyRow) return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.queryData.map((r)=>this.getRowBudget(r)));
        return (row === null || row === void 0 ? void 0 : row.budget) || 0;
    }
    getRowTotalHours(row, hoursData = this.report.filters.hoursData) {
        const emptyRow = !(row !== null && row !== void 0 && row.key);
        if (emptyRow) return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.queryData.map((r)=>this.getRowTotalHours(r, hoursData)));
        if (hoursData == "actuals") {
            var _row$grandTotals;
            return (row === null || row === void 0 ? void 0 : (_row$grandTotals = row.grandTotals) === null || _row$grandTotals === void 0 ? void 0 : _row$grandTotals.actuals) || 0;
        } else if (hoursData == "projected") {
            var _row$grandTotals2;
            return (row === null || row === void 0 ? void 0 : (_row$grandTotals2 = row.grandTotals) === null || _row$grandTotals2 === void 0 ? void 0 : _row$grandTotals2.projected) || 0;
        } else {
            var _row$grandTotals3;
            return (row === null || row === void 0 ? void 0 : (_row$grandTotals3 = row.grandTotals) === null || _row$grandTotals3 === void 0 ? void 0 : _row$grandTotals3.actualsProjected) || 0;
        }
    }
    getRowHoursToDateInPeriod(row, period, hoursData = this.report.filters.hoursData) {
        const emptyRow = !(row !== null && row !== void 0 && row.key);
        if (emptyRow) return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.queryData.map((r)=>this.getRowHoursToDateInPeriod(r, period, hoursData)));
        if (hoursData == "actuals") {
            var _row$totalHours, _row$totalHours$actua;
            return (row === null || row === void 0 ? void 0 : (_row$totalHours = row.totalHours) === null || _row$totalHours === void 0 ? void 0 : (_row$totalHours$actua = _row$totalHours.actuals) === null || _row$totalHours$actua === void 0 ? void 0 : _row$totalHours$actua[period]) || 0;
        } else if (hoursData == "projected") {
            var _row$totalHours$proje;
            return (row === null || row === void 0 ? void 0 : (_row$totalHours$proje = row.totalHours.projected) === null || _row$totalHours$proje === void 0 ? void 0 : _row$totalHours$proje[period]) || 0;
        } else {
            var _row$totalHours2, _row$totalHours2$actu;
            return (row === null || row === void 0 ? void 0 : (_row$totalHours2 = row.totalHours) === null || _row$totalHours2 === void 0 ? void 0 : (_row$totalHours2$actu = _row$totalHours2.actualsProjected) === null || _row$totalHours2$actu === void 0 ? void 0 : _row$totalHours2$actu[period]) || 0;
        }
    }
    getRowHoursInPeriod(row, period, hoursData = this.report.filters.hoursData) {
        const emptyRow = !(row !== null && row !== void 0 && row.key);
        if (emptyRow) return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.queryData.map((r)=>this.getRowHoursInPeriod(r, period, hoursData)));
        return this.getRowActiveHoursInPeriod(row, period, hoursData) + this.getRowProspectiveHoursInPeriod(row, period, hoursData);
    }
    getRowActiveHoursInPeriod(row, period, hoursData = this.report.filters.hoursData) {
        const emptyRow = !(row !== null && row !== void 0 && row.key);
        if (emptyRow) return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.queryData.map((r)=>this.getRowActiveHoursInPeriod(r, period, hoursData)));
        const currentPeriod = (0, $4hBm1.format)(new Date(), this.periodFormat());
        if (hoursData === "actuals" || [
            "actualsProjected",
            "actualsVsProjected"
        ].includes(hoursData) && period < currentPeriod) {
            var _row$recordedHours, _row$recordedHours$ac;
            return (row === null || row === void 0 ? void 0 : (_row$recordedHours = row.recordedHours) === null || _row$recordedHours === void 0 ? void 0 : (_row$recordedHours$ac = _row$recordedHours.active) === null || _row$recordedHours$ac === void 0 ? void 0 : _row$recordedHours$ac[period]) || 0;
        } else if (hoursData === "projected" || [
            "actualsProjected",
            "actualsVsProjected"
        ].includes(hoursData) && period > currentPeriod) {
            var _row$allocatedHours, _row$allocatedHours$a;
            return (row === null || row === void 0 ? void 0 : (_row$allocatedHours = row.allocatedHours) === null || _row$allocatedHours === void 0 ? void 0 : (_row$allocatedHours$a = _row$allocatedHours.active) === null || _row$allocatedHours$a === void 0 ? void 0 : _row$allocatedHours$a[period]) || 0;
        } else if ([
            "actualsProjected",
            "actualsVsProjected"
        ].includes(hoursData)) {
            var _row$allocatedHours2, _row$allocatedHours2$;
            return Math.max((row === null || row === void 0 ? void 0 : (_row$allocatedHours2 = row.allocatedHours) === null || _row$allocatedHours2 === void 0 ? void 0 : (_row$allocatedHours2$ = _row$allocatedHours2.active) === null || _row$allocatedHours2$ === void 0 ? void 0 : _row$allocatedHours2$[period]) || 0);
        } else if (hoursData === "remainingProjected") {
            var _row$allocatedHours3, _row$allocatedHours3$, _row$recordedHours2, _row$recordedHours2$a;
            return ((row === null || row === void 0 ? void 0 : (_row$allocatedHours3 = row.allocatedHours) === null || _row$allocatedHours3 === void 0 ? void 0 : (_row$allocatedHours3$ = _row$allocatedHours3.active) === null || _row$allocatedHours3$ === void 0 ? void 0 : _row$allocatedHours3$[period]) || 0) - ((row === null || row === void 0 ? void 0 : (_row$recordedHours2 = row.recordedHours) === null || _row$recordedHours2 === void 0 ? void 0 : (_row$recordedHours2$a = _row$recordedHours2.active) === null || _row$recordedHours2$a === void 0 ? void 0 : _row$recordedHours2$a[period]) || 0);
        } else if (hoursData === "remainingProjectedCapped") {
            var _row$allocatedHours4, _row$allocatedHours4$, _row$recordedHours3, _row$recordedHours3$a;
            return Math.max(((row === null || row === void 0 ? void 0 : (_row$allocatedHours4 = row.allocatedHours) === null || _row$allocatedHours4 === void 0 ? void 0 : (_row$allocatedHours4$ = _row$allocatedHours4.active) === null || _row$allocatedHours4$ === void 0 ? void 0 : _row$allocatedHours4$[period]) || 0) - ((row === null || row === void 0 ? void 0 : (_row$recordedHours3 = row.recordedHours) === null || _row$recordedHours3 === void 0 ? void 0 : (_row$recordedHours3$a = _row$recordedHours3.active) === null || _row$recordedHours3$a === void 0 ? void 0 : _row$recordedHours3$a[period]) || 0), 0);
        } else return 0;
    }
    getRowProspectiveHoursInPeriod(row, period, hoursData = this.report.filters.hoursData) {
        const emptyRow = !(row !== null && row !== void 0 && row.key);
        if (emptyRow) return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.queryData.map((r)=>this.getRowProspectiveHoursInPeriod(r, period, hoursData)));
        const currentPeriod = (0, $4hBm1.format)(new Date(), this.periodFormat());
        if (hoursData === "actuals" || [
            "actualsProjected",
            "actualsVsProjected"
        ].includes(hoursData) && period < currentPeriod) return 0;
        else {
            var _row$allocatedHours5, _row$allocatedHours5$;
            return (row === null || row === void 0 ? void 0 : (_row$allocatedHours5 = row.allocatedHours) === null || _row$allocatedHours5 === void 0 ? void 0 : (_row$allocatedHours5$ = _row$allocatedHours5.prospective) === null || _row$allocatedHours5$ === void 0 ? void 0 : _row$allocatedHours5$[period]) || 0;
        }
    }
    setHours(row, period, value, updateProjectForecasts) {
        var _row$allocatedHours6, _row$allocatedHours6$, _row$allocatedHours7, _row$allocatedHours7$;
        const oldValue = ((row === null || row === void 0 ? void 0 : (_row$allocatedHours6 = row.allocatedHours) === null || _row$allocatedHours6 === void 0 ? void 0 : (_row$allocatedHours6$ = _row$allocatedHours6.active) === null || _row$allocatedHours6$ === void 0 ? void 0 : _row$allocatedHours6$[period]) || 0) + ((row === null || row === void 0 ? void 0 : (_row$allocatedHours7 = row.allocatedHours) === null || _row$allocatedHours7 === void 0 ? void 0 : (_row$allocatedHours7$ = _row$allocatedHours7.prospective) === null || _row$allocatedHours7$ === void 0 ? void 0 : _row$allocatedHours7$[period]) || 0);
        const ratio = value / oldValue;
        let diffActive = 0;
        let diffProspective = 0;
        const children = row.children.filter((c)=>c.statuses.length > 1 || c.statuses[0] && c.statuses[0] !== "archived");
        if (children !== null && children !== void 0 && children.length && oldValue) children.forEach((r)=>{
            var _r$allocatedHours, _r$allocatedHours$act, _r$allocatedHours2, _r$allocatedHours2$pr;
            this.setHours(r, period, ((r === null || r === void 0 ? void 0 : (_r$allocatedHours = r.allocatedHours) === null || _r$allocatedHours === void 0 ? void 0 : (_r$allocatedHours$act = _r$allocatedHours.active) === null || _r$allocatedHours$act === void 0 ? void 0 : _r$allocatedHours$act[period]) + (r === null || r === void 0 ? void 0 : (_r$allocatedHours2 = r.allocatedHours) === null || _r$allocatedHours2 === void 0 ? void 0 : (_r$allocatedHours2$pr = _r$allocatedHours2.prospective) === null || _r$allocatedHours2$pr === void 0 ? void 0 : _r$allocatedHours2$pr[period])) * ratio, updateProjectForecasts);
        });
        else if (children !== null && children !== void 0 && children.length) children.forEach((r)=>{
            this.setHours(r, period, value / children.length, updateProjectForecasts);
        });
        else if (oldValue) {
            var _row$allocatedHours8, _row$allocatedHours8$, _row$allocatedHours9, _row$allocatedHours9$, _row$allocatedHours10, _row$allocatedHours11, _row$allocatedHours12, _row$allocatedHours13, _row$allocatedHours14, _row$allocatedHours15, _row$allocatedHours16, _row$allocatedHours17;
            diffActive = (row === null || row === void 0 ? void 0 : (_row$allocatedHours8 = row.allocatedHours) === null || _row$allocatedHours8 === void 0 ? void 0 : (_row$allocatedHours8$ = _row$allocatedHours8.active) === null || _row$allocatedHours8$ === void 0 ? void 0 : _row$allocatedHours8$[period]) * ratio - (row === null || row === void 0 ? void 0 : (_row$allocatedHours9 = row.allocatedHours) === null || _row$allocatedHours9 === void 0 ? void 0 : (_row$allocatedHours9$ = _row$allocatedHours9.active) === null || _row$allocatedHours9$ === void 0 ? void 0 : _row$allocatedHours9$[period]);
            diffProspective = (row === null || row === void 0 ? void 0 : (_row$allocatedHours10 = row.allocatedHours) === null || _row$allocatedHours10 === void 0 ? void 0 : (_row$allocatedHours11 = _row$allocatedHours10.prospective) === null || _row$allocatedHours11 === void 0 ? void 0 : _row$allocatedHours11[period]) * ratio - (row === null || row === void 0 ? void 0 : (_row$allocatedHours12 = row.allocatedHours) === null || _row$allocatedHours12 === void 0 ? void 0 : (_row$allocatedHours13 = _row$allocatedHours12.prospective) === null || _row$allocatedHours13 === void 0 ? void 0 : _row$allocatedHours13[period]);
            row.allocatedHours.active[period] = (row === null || row === void 0 ? void 0 : (_row$allocatedHours14 = row.allocatedHours) === null || _row$allocatedHours14 === void 0 ? void 0 : (_row$allocatedHours15 = _row$allocatedHours14.active) === null || _row$allocatedHours15 === void 0 ? void 0 : _row$allocatedHours15[period]) * ratio;
            row.allocatedHours.prospective[period] = (row === null || row === void 0 ? void 0 : (_row$allocatedHours16 = row.allocatedHours) === null || _row$allocatedHours16 === void 0 ? void 0 : (_row$allocatedHours17 = _row$allocatedHours16.prospective) === null || _row$allocatedHours17 === void 0 ? void 0 : _row$allocatedHours17[period]) * ratio;
        } else {
            row.allocatedHours.active[period] = value;
            diffActive = value;
        }
        if (!(children !== null && children !== void 0 && children.length)) {
            var _row$phaseIds;
            Object.keys(row.totalHours.actualsProjected).forEach((k)=>{
                if (k >= period) {
                    row.totalHours.projected[k] += diffActive + diffProspective;
                    row.totalHours.actualsProjected[k] += diffActive + diffProspective;
                }
            });
            row.grandTotals.projected += diffActive + diffProspective;
            row.grandTotals.actualsProjected += diffActive + diffProspective;
            const keys = row.key.split("||");
            const parentKeys = keys.slice(0, keys.length - 1);
            const addDiff = (rows, keys, level)=>{
                const keysAtLevel = keys.slice(0, level + 1);
                const key = keysAtLevel.join("||");
                const row = rows.find((r)=>r.key === key);
                row.allocatedHours.active[period] += diffActive;
                row.allocatedHours.prospective[period] += diffProspective;
                Object.keys(row.totalHours.actualsProjected).forEach((k)=>{
                    if (k >= period) {
                        row.totalHours.projected[k] += diffActive + diffProspective;
                        row.totalHours.actualsProjected[k] += diffActive + diffProspective;
                    }
                });
                row.grandTotals.projected += diffActive + diffProspective;
                row.grandTotals.actualsProjected += diffActive + diffProspective;
                if (keys.length > level + 1) addDiff(row.children, keys, level + 1);
            };
            addDiff(this.queryData, parentKeys, 0);
            const projectId = row.projectId || (row.projectIds.length === 1 ? row.projectIds[0] : this.selectedProjectId);
            const phaseId = row.phaseId || (row === null || row === void 0 ? void 0 : (_row$phaseIds = row.phaseIds) === null || _row$phaseIds === void 0 ? void 0 : _row$phaseIds[0]) || null;
            const roleId = row.roleId || (row.roleIds.length === 1 ? row.roleIds[0] : null);
            const staffId = row.staffId || (row.staffIds.length === 1 ? row.staffIds[0] : null);
            if (updateProjectForecasts) updateProjectForecasts(period, value, projectId, phaseId, roleId, staffId);
        }
    }
    downloadCSV() {
        const table = new (0, $hdshG.default)();
        let rows = this.queryData;
        const exportLevel = this.report.filters.groups.findIndex((g)=>g === this.exportGroup);
        let rowLevel = 0;
        while(rowLevel < exportLevel){
            rows = rows.flatMap((r)=>r.children);
            rowLevel++;
        }
        const rowColumns = (0, $cQvuY.ResourceScheduleReportAllocationColumns)(this);
        const exportGroups = this.report.filters.groups.slice(0, exportLevel + 1);
        let columns = [
            ...exportGroups.map((g)=>({
                    id: g,
                    label: (0, $ikffN.capitalCase)(g),
                    type: "text",
                    value: (row)=>row[g]
                }))
        ];
        columns.push(...[
            ...Array(12)
        ].map((v, i)=>{
            return rowColumns.csvHours(this.addPeriods(this.startDate, i), 0, {});
        }));
        table.update({
            columns: columns,
            rows: rows
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($cV8g5)))((0, (/*@__PURE__*/$parcel$interopDefault($6mjwz))).unparse([
            ...table.getCsvData()
        ]), `${this.report.name}.csv`, "text/csv");
    }
    addStaffs(staffs, project, phase, dateRange, allocationValue, allocationType, updateProjectForecasts) {
        staffs.forEach((staff)=>{
            this.addStaff(staff, project, phase, dateRange, allocationValue, allocationType, updateProjectForecasts);
        });
    }
    addStaff(staff, project, phase, dateRange, allocationValue, allocationType, updateProjectForecasts) {
        var _staff$role, _project$owner;
        const groupKeys = {
            project: project === null || project === void 0 ? void 0 : project.id,
            phase: phase === null || phase === void 0 ? void 0 : phase.id,
            role: staff === null || staff === void 0 ? void 0 : staff.roleId,
            staff: staff === null || staff === void 0 ? void 0 : staff.id,
            status: phase.status,
            owner: project === null || project === void 0 ? void 0 : project.ownerId
        };
        const groupTitles = {
            project: project === null || project === void 0 ? void 0 : project.title,
            phase: phase === null || phase === void 0 ? void 0 : phase.title,
            role: (staff === null || staff === void 0 ? void 0 : (_staff$role = staff.role) === null || _staff$role === void 0 ? void 0 : _staff$role.name) || "(No Role)",
            staff: (staff === null || staff === void 0 ? void 0 : staff.fullName) || "(No Staff)",
            status: (0, $ikffN.capitalCase)(phase.status),
            owner: (project === null || project === void 0 ? void 0 : (_project$owner = project.owner) === null || _project$owner === void 0 ? void 0 : _project$owner.fullName) || "(No Owner)"
        };
        const groups = this.report.filters.groups;
        let parentRow;
        let groupRows = this.queryData;
        const createRow = (group, groupKey, parentRow, groupRows)=>{
            var _newRow$roleIds, _newRow$staffIds, _newRow$projectIds, _newRow$phaseIds, _newRow$statuses;
            const newRow = {
                ...parentRow,
                key: parentRow ? `${parentRow.key}||${groupKey}` : `${groupKey}`,
                children: [],
                allocatedHours: {
                    active: {},
                    prospective: {}
                },
                recordedHours: {
                    active: {}
                },
                totalHours: {
                    projected: {},
                    actualsProjected: {}
                },
                grandTotals: {
                    projected: 0,
                    actualsProjected: 0
                }
            };
            (_newRow$roleIds = newRow.roleIds) !== null && _newRow$roleIds !== void 0 ? _newRow$roleIds : newRow.roleIds = [
                staff.roleId
            ];
            (_newRow$staffIds = newRow.staffIds) !== null && _newRow$staffIds !== void 0 ? _newRow$staffIds : newRow.staffIds = [
                staff.id
            ];
            (_newRow$projectIds = newRow.projectIds) !== null && _newRow$projectIds !== void 0 ? _newRow$projectIds : newRow.projectIds = [
                project.id
            ];
            (_newRow$phaseIds = newRow.phaseIds) !== null && _newRow$phaseIds !== void 0 ? _newRow$phaseIds : newRow.phaseIds = [
                phase.id
            ];
            (_newRow$statuses = newRow.statuses) !== null && _newRow$statuses !== void 0 ? _newRow$statuses : newRow.statuses = [
                phase.status
            ];
            if (group === "project") {
                newRow.projectIds = [
                    groupKey
                ];
                newRow.projectId = groupKey;
                newRow.phaseIds = newRow.phaseIds.filter((p)=>{
                    var _PhaseCollection$phas;
                    return ((_PhaseCollection$phas = (0, $XoImS.default).phasesById[p]) === null || _PhaseCollection$phas === void 0 ? void 0 : _PhaseCollection$phas.projectId) === groupKey;
                });
            } else if (group === "phase") {
                newRow.phaseIds = [
                    groupKey
                ];
                newRow.phaseId = groupKey;
            } else if (group === "role") {
                newRow.roleIds = [
                    groupKey
                ];
                newRow.roleId = groupKey;
                newRow.staffIds = newRow.staffIds.filter((s)=>s === staff.id);
            } else if (group === "staff") {
                newRow.staffIds = [
                    groupKey
                ];
                newRow.staffId = groupKey;
            } else if (group === "status") {
                newRow.statuses = [
                    groupKey
                ];
                newRow.status = groupKey;
            } else if (group === "owner") {
                newRow.ownerIds = [
                    groupKey
                ];
                newRow.ownerId = groupKey;
                newRow.projectIds = newRow.projectIds.filter((p)=>{
                    var _ProjectCollection$pr;
                    return ((_ProjectCollection$pr = ProjectCollection.projectsById[p]) === null || _ProjectCollection$pr === void 0 ? void 0 : _ProjectCollection$pr.ownerId) === groupKey;
                });
                newRow.phaseIds = newRow.phaseIds.filter((p)=>{
                    var _PhaseCollection$phas2, _PhaseCollection$phas3;
                    return ((_PhaseCollection$phas2 = (0, $XoImS.default).phasesById[p]) === null || _PhaseCollection$phas2 === void 0 ? void 0 : (_PhaseCollection$phas3 = _PhaseCollection$phas2.project) === null || _PhaseCollection$phas3 === void 0 ? void 0 : _PhaseCollection$phas3.ownerId) === groupKey;
                });
            }
            return newRow;
        };
        let lastRow;
        groups.forEach((g)=>{
            let row = groupRows.find((r)=>r[$48a241d888fbd1ac$export$6a7dce92243b5962[g]] === groupKeys[g]);
            if (!row) {
                // Create a new row
                row = createRow(g, groupKeys[g], parentRow, groupRows);
                row.title = groupTitles[g];
                if (parentRow) {
                    parentRow.children.push(row);
                    //I don't know why the reference is lost here
                    row = parentRow.children[parentRow.children.length - 1];
                } else {
                    groupRows.push(row);
                    //I don't know why the reference is lost here
                    row = groupRows[groupRows.length - 1];
                }
            }
            if (!row.staffIds.includes(staff.id || "null")) row.staffIds.push(staff.id || "null");
            if (!row.projectIds.includes(project.id || "null")) row.projectIds.push(project.id || "null");
            if (!row.phaseIds.includes(phase.id || "null")) row.phaseIds.push(phase.id || "null");
            if (!row.roleIds.includes(staff.roleId || "null")) row.roleIds.push(staff.roleId || "null");
            // Update row ids
            if (g === "staff") {
                row.staffId = staff.id || "null";
                row.staff = groupTitles[g];
            }
            if (g === "project") {
                row.projectId = project.id || "null";
                row.project = groupTitles[g];
            }
            if (g === "phase") {
                row.phaseId = phase.id || "null";
                row.phase = groupTitles[g];
            }
            if (g === "role") {
                row.roleId = staff.roleId || "null";
                row.role = groupTitles[g];
            }
            parentRow = row;
            groupRows = row.children;
            lastRow = row;
        });
        // this.selectCell(this.selectedPeriod, null, this.selectedObject)
        this.addAllocationInDateRange(lastRow, staff, project, phase, dateRange, allocationValue, allocationType, updateProjectForecasts);
    // this.queryData = _.cloneDeep(this.queryData)
    }
    addAllocationInDateRange(row, staff, project, phase, dateRange, allocationValue, allocationType, updateProjectForecasts) {
        const periods = this.getPeriodsInDateRange(dateRange);
        const businessDays = this.getBusinessDaysInDateRange(dateRange);
        const value = allocationType === "hours" ? allocationValue : staff.getAvailabilityInDateRange(dateRange) / 60 / 5 * allocationValue * businessDays;
        const valuePerBusinessDay = value / businessDays;
        periods.forEach((period)=>{
            const businessDaysInPeriod = this.getBusinessDaysInDateRange([
                Math.max(this.startOfPeriod((0, $4hBm1.parse)(period, this.periodFormat(), new Date())), dateRange[0]),
                Math.min(this.endOfPeriod((0, $4hBm1.parse)(period, this.periodFormat(), new Date())), dateRange[1])
            ]);
            this.setHours(row, period, allocationType === "hours" ? value : businessDaysInPeriod * valuePerBusinessDay, updateProjectForecasts);
        });
    }
    getBusinessDaysInDateRange(dateRange) {
        const startDate = (0, $4hBm1.startOfDay)(dateRange[0]);
        const endDate = (0, $4hBm1.addDays)((0, $4hBm1.startOfDay)(dateRange[1]), 1);
        const businessDays = (0, $4hBm1.differenceInBusinessDays)(endDate, startDate);
        return businessDays;
    }
    getPeriodsInDateRange(dateRange) {
        const startDate = (0, $4hBm1.startOfDay)(dateRange[0]);
        const endDate = (0, $4hBm1.addDays)((0, $4hBm1.startOfDay)(dateRange[1]), 1);
        const periods = [];
        let currentDate = startDate;
        while(currentDate <= endDate){
            periods.push((0, $4hBm1.format)(currentDate, this.periodFormat()));
            currentDate = this.addPeriods(currentDate, 1);
        }
        return periods;
    }
    getStaffHoursInPeriod(staffId, period, hoursData = this.report.filters.hoursData) {
        // Get all leaf rows that contain this staff ID
        const rows = this.getAllLeafResourceRows().filter((row)=>row.staffId === staffId);
        // Sum up all hours for these rows in the given period
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(rows.map((row)=>this.getRowHoursInPeriod(row, period, hoursData)));
    }
    updateQueryData(data) {
        let storedRows = this.queryData;
        let newRows = data;
        // Function to insert or update rows recursively
        const insertOrUpdateRows = (storedRows, newRows)=>{
            newRows.forEach((newRow)=>{
                let existingRow = storedRows.find((storedRow)=>storedRow.key === newRow.key);
                if (!existingRow) // If the row does not exist, add it to storedRows
                storedRows.push(newRow);
                else {
                    Object.entries(newRow).forEach(([key, value])=>{
                        if (key !== "children") existingRow[key] = value;
                    });
                    // If it exists, update existing children with new ones recursively
                    if (newRow.children && newRow.children.length > 0) {
                        if (!existingRow.children) existingRow.children = []; // Initialize children array if it doesn't exist
                        insertOrUpdateRows(existingRow.children, newRow.children);
                    }
                }
            });
        };
        // Start the recursive update process from the root
        requestIdleCallback(()=>{
            insertOrUpdateRows(storedRows, newRows);
            this.queryData = storedRows;
        });
    }
}, $48a241d888fbd1ac$var$_descriptor = $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "startDate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return (0, $4hBm1.startOfMonth)((0, $4hBm1.subMonths)(new Date(), 3));
    }
}), $48a241d888fbd1ac$var$_descriptor2 = $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "endDate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return (0, $4hBm1.endOfMonth)((0, $4hBm1.addMonths)(new Date(), 8));
    }
}), $48a241d888fbd1ac$var$_descriptor3 = $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "selectedObject", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $48a241d888fbd1ac$var$_descriptor4 = $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "selectedPeriod", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $48a241d888fbd1ac$var$_descriptor5 = $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "selectedProjectId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $48a241d888fbd1ac$var$_descriptor6 = $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "selectedPhaseId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $48a241d888fbd1ac$var$_descriptor7 = $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "selectedStaffId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $48a241d888fbd1ac$var$_descriptor8 = $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "selectedRoleId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $48a241d888fbd1ac$var$_descriptor9 = $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "selectedStaffIds", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $48a241d888fbd1ac$var$_descriptor10 = $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "selectedPhaseIds", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $48a241d888fbd1ac$var$_descriptor11 = $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "isPrinting", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $48a241d888fbd1ac$var$_descriptor12 = $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "expandedAllocationRows", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Set();
    }
}), $48a241d888fbd1ac$var$_descriptor13 = $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "editedHours", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {
            month: {},
            week: {}
        };
    }
}), $48a241d888fbd1ac$var$_descriptor14 = $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "queryData", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $48a241d888fbd1ac$var$_descriptor15 = $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "_periodType", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "month";
    }
}), $48a241d888fbd1ac$var$_descriptor16 = $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "searchParams", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $48a241d888fbd1ac$var$_descriptor17 = $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "expandAll", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $48a241d888fbd1ac$var$_descriptor18 = $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "exportGroup", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "staff";
    }
}), $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "init", [
    $48a241d888fbd1ac$var$_dec
], Object.getOwnPropertyDescriptor($48a241d888fbd1ac$var$_class.prototype, "init"), $48a241d888fbd1ac$var$_class.prototype), $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "reset", [
    (0, $4JcCM.action)
], Object.getOwnPropertyDescriptor($48a241d888fbd1ac$var$_class.prototype, "reset"), $48a241d888fbd1ac$var$_class.prototype), $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "setSearchParams", [
    $48a241d888fbd1ac$var$_dec2
], Object.getOwnPropertyDescriptor($48a241d888fbd1ac$var$_class.prototype, "setSearchParams"), $48a241d888fbd1ac$var$_class.prototype), $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "setExportGroup", [
    $48a241d888fbd1ac$var$_dec3
], Object.getOwnPropertyDescriptor($48a241d888fbd1ac$var$_class.prototype, "setExportGroup"), $48a241d888fbd1ac$var$_class.prototype), $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "periodType", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($48a241d888fbd1ac$var$_class.prototype, "periodType"), $48a241d888fbd1ac$var$_class.prototype), $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "staff", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($48a241d888fbd1ac$var$_class.prototype, "staff"), $48a241d888fbd1ac$var$_class.prototype), $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "setExpandAll", [
    $48a241d888fbd1ac$var$_dec4
], Object.getOwnPropertyDescriptor($48a241d888fbd1ac$var$_class.prototype, "setExpandAll"), $48a241d888fbd1ac$var$_class.prototype), $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "makeQueryKey", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($48a241d888fbd1ac$var$_class.prototype, "makeQueryKey"), $48a241d888fbd1ac$var$_class.prototype), $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "fetchedProjectIds", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($48a241d888fbd1ac$var$_class.prototype, "fetchedProjectIds"), $48a241d888fbd1ac$var$_class.prototype), $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "setEditedHoursData", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($48a241d888fbd1ac$var$_class.prototype, "setEditedHoursData"), $48a241d888fbd1ac$var$_class.prototype), $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "saveChanges", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($48a241d888fbd1ac$var$_class.prototype, "saveChanges"), $48a241d888fbd1ac$var$_class.prototype), $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "dataPeriods", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($48a241d888fbd1ac$var$_class.prototype, "dataPeriods"), $48a241d888fbd1ac$var$_class.prototype), $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "report", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($48a241d888fbd1ac$var$_class.prototype, "report"), $48a241d888fbd1ac$var$_class.prototype), $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "updateFilters", [
    $48a241d888fbd1ac$var$_dec5
], Object.getOwnPropertyDescriptor($48a241d888fbd1ac$var$_class.prototype, "updateFilters"), $48a241d888fbd1ac$var$_class.prototype), $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "selectCell", [
    $48a241d888fbd1ac$var$_dec6
], Object.getOwnPropertyDescriptor($48a241d888fbd1ac$var$_class.prototype, "selectCell"), $48a241d888fbd1ac$var$_class.prototype), $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "shiftSelectedPeriod", [
    $48a241d888fbd1ac$var$_dec7
], Object.getOwnPropertyDescriptor($48a241d888fbd1ac$var$_class.prototype, "shiftSelectedPeriod"), $48a241d888fbd1ac$var$_class.prototype), $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "shiftDates", [
    $48a241d888fbd1ac$var$_dec8
], Object.getOwnPropertyDescriptor($48a241d888fbd1ac$var$_class.prototype, "shiftDates"), $48a241d888fbd1ac$var$_class.prototype), $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "setHours", [
    $48a241d888fbd1ac$var$_dec9
], Object.getOwnPropertyDescriptor($48a241d888fbd1ac$var$_class.prototype, "setHours"), $48a241d888fbd1ac$var$_class.prototype), $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "downloadCSV", [
    $48a241d888fbd1ac$var$_dec10
], Object.getOwnPropertyDescriptor($48a241d888fbd1ac$var$_class.prototype, "downloadCSV"), $48a241d888fbd1ac$var$_class.prototype), $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "addStaffs", [
    $48a241d888fbd1ac$var$_dec11
], Object.getOwnPropertyDescriptor($48a241d888fbd1ac$var$_class.prototype, "addStaffs"), $48a241d888fbd1ac$var$_class.prototype), $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "addStaff", [
    $48a241d888fbd1ac$var$_dec12
], Object.getOwnPropertyDescriptor($48a241d888fbd1ac$var$_class.prototype, "addStaff"), $48a241d888fbd1ac$var$_class.prototype), $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "addAllocationInDateRange", [
    $48a241d888fbd1ac$var$_dec13
], Object.getOwnPropertyDescriptor($48a241d888fbd1ac$var$_class.prototype, "addAllocationInDateRange"), $48a241d888fbd1ac$var$_class.prototype), $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "getBusinessDaysInDateRange", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($48a241d888fbd1ac$var$_class.prototype, "getBusinessDaysInDateRange"), $48a241d888fbd1ac$var$_class.prototype), $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "getPeriodsInDateRange", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($48a241d888fbd1ac$var$_class.prototype, "getPeriodsInDateRange"), $48a241d888fbd1ac$var$_class.prototype), $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "getStaffHoursInPeriod", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($48a241d888fbd1ac$var$_class.prototype, "getStaffHoursInPeriod"), $48a241d888fbd1ac$var$_class.prototype), $48a241d888fbd1ac$var$_descriptor19 = $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "updateRows", [
    $48a241d888fbd1ac$var$_dec14
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).debounce(()=>{
            var _SessionStore$user;
            (0, $iOQGT.makeRequest)({
                id: `resourceTable` + this.report.queryKey,
                baseURL: "https://server2.coincraft.co",
                path: `/resource-schedule/table`,
                method: "POST",
                data: {
                    organisationId: (0, $1BTI2.default).organisationId,
                    userId: (_SessionStore$user = (0, $1BTI2.default).user) === null || _SessionStore$user === void 0 ? void 0 : _SessionStore$user.id,
                    filters: this.report.filters,
                    level: 0,
                    parentData: {},
                    dateRange: [
                        (0, $4hBm1.format)(this.startDate, "yyyy-MM-dd"),
                        (0, $4hBm1.format)(this.endDate, "yyyy-MM-dd")
                    ],
                    periodType: this.periodType
                }
            }).then((r)=>{
                this.updateQueryData(r.data);
            });
        }, 500);
    }
}), $48a241d888fbd1ac$var$_applyDecoratedDescriptor($48a241d888fbd1ac$var$_class.prototype, "updateQueryData", [
    $48a241d888fbd1ac$var$_dec15
], Object.getOwnPropertyDescriptor($48a241d888fbd1ac$var$_class.prototype, "updateQueryData"), $48a241d888fbd1ac$var$_class.prototype), $48a241d888fbd1ac$var$_class);
var $48a241d888fbd1ac$export$2e2bcd8739ae039 = new $48a241d888fbd1ac$var$ResourceScheduleStore();

});
parcelRegister("cQvuY", function(module, exports) {

$parcel$export(module.exports, "ResourceScheduleReportAllocationColumns", function () { return $95a2c64d75bb34c2$export$b66096f6cf0a19c4; });

var $61Ea1 = parcelRequire("61Ea1");

var $eat5C = parcelRequire("eat5C");

var $jbmdS = parcelRequire("jbmdS");

var $fUWIW = parcelRequire("fUWIW");

var $4hBm1 = parcelRequire("4hBm1");

var $6eCWq = parcelRequire("6eCWq");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $49KZT = parcelRequire("49KZT");

var $gjxeM = parcelRequire("gjxeM");

var $hTXTf = parcelRequire("hTXTf");

var $cwjKY = parcelRequire("cwjKY");

var $alT7C = parcelRequire("alT7C");

var $gJT7h = parcelRequire("gJT7h");

var $liJtZ = parcelRequire("liJtZ");

var $6gkJQ = parcelRequire("6gkJQ");

const $95a2c64d75bb34c2$var$cellStyles = (row, stores, periodStart, isPastPeriod, keys)=>{
    const inPhaseDateRange = (row === null || row === void 0 ? void 0 : row.projectId) && (row === null || row === void 0 ? void 0 : row.startDate) && (row === null || row === void 0 ? void 0 : row.endDate) && periodStart >= (0, $6eCWq.default).startOfPeriod(new Date(row === null || row === void 0 ? void 0 : row.startDate)) && periodStart <= (0, $6eCWq.default).endOfPeriod(new Date(row === null || row === void 0 ? void 0 : row.endDate));
    const period = (0, $4hBm1.format)(periodStart, (0, $6eCWq.default).periodFormat());
    let progress = $95a2c64d75bb34c2$var$getProgressValue((0, $6eCWq.default), period, row);
    if ((0, $6eCWq.default).report.filters.percentData.includes("remaining")) progress = Math.max(0.1, 1 - progress);
    return {
        ...isPastPeriod ? {
            backgroundImage: `url(${new URL((parcelRequire("3vc8e")))})`
        } : {},
        ...(row !== null && row !== void 0 && row.projectId || row !== null && row !== void 0 && row.phaseId) && (row !== null && row !== void 0 && row.startDate || row !== null && row !== void 0 && row._startDate) && (row !== null && row !== void 0 && row.endDate || row !== null && row !== void 0 && row._endDate) && inPhaseDateRange ? {
            borderBottom: "3px #3dacafaa solid"
        } : {},
        ...stores !== null && stores !== void 0 && stores.row && progress ? (0, $hTXTf.getGradient)(progress || 0) : {}
    };
};
const $95a2c64d75bb34c2$export$b66096f6cf0a19c4 = (store, keys, projectForecastsStore)=>({
        title: (level, periodStartDate, groupBy = [], filters = [], { status: status, projectId: projectId } = {})=>({
                id: "title",
                label: "Title",
                type: "text",
                width: 18,
                editable: (row)=>false,
                value: (row, stores)=>{
                    return row.title;
                },
                component: ({ value: value, group: group, stores: stores })=>{
                    const { row: row, table: table } = stores;
                    if (row.group === "totals") return "Total";
                    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        style: {
                            paddingLeft: `${1 * row.groupLevel}rem`
                        },
                        children: value
                    });
                }
            }),
        project: (periodStartDate, groupBy = [], filters = [], { status: status, projectId: projectId } = {})=>({
                id: "project",
                label: "Project",
                type: "project",
                width: 18,
                value: (row)=>row.project,
                queryFilters: ({ operator: operator, value: value })=>{
                    return (0, $fUWIW.queryFilters).singleId[operator]("projectId", value);
                }
            }),
        phase: (periodStartDate, groupBy = [], filters = [], { status: status, projectId: projectId } = {})=>({
                id: "phase",
                label: "Phase",
                type: "phase",
                width: 18,
                value: (row)=>{
                    return row;
                },
                queryFilters: ({ operator: operator, value: value })=>{
                    return (0, $fUWIW.queryFilters).text[operator]("name", value);
                }
            }),
        status: (periodStartDate, groupBy = [], filters = [], { status: status, projectId: projectId } = {})=>({
                id: "status",
                label: "Status",
                type: "status",
                width: 18,
                value: (row)=>{
                    return row.status || row._status;
                },
                queryFilters: ({ operator: operator, value: value })=>{
                    return (0, $fUWIW.queryFilters).text[operator]("status", value);
                }
            }),
        hours: (periodStartDate, level, filters)=>{
            const groupsAtLevel = store.report.filters.groups.slice(0, level + 1);
            const groupsBeforeLevel = store.report.filters.groups.slice(0, level);
            const group = store.report.filters.groups[level];
            const cellLabel = (0, $4hBm1.format)(periodStartDate, (0, $6eCWq.default).periodFormat());
            const currentPeriodStart = (0, $6eCWq.default).startOfPeriod(new Date());
            const periodStart = (0, $6eCWq.default).startOfPeriod(periodStartDate);
            const periodEnd = (0, $6eCWq.default).endOfPeriod(periodStart);
            const periodType = periodStart.getTime() === currentPeriodStart.getTime() ? "current" : periodStart.getTime() > currentPeriodStart.getTime() ? "future" : "past";
            const isPastPeriod = periodType === "past";
            const isFuturePeriod = periodType === "future";
            const isCurrentPeriod = periodType === "current";
            let queryId = "hours";
            if (groupsBeforeLevel.includes("status")) queryId += String(filters.status);
            if (groupsBeforeLevel.includes("project")) queryId += String(filters.projectId);
            if (groupsBeforeLevel.includes("phase")) queryId += String(filters.phaseId);
            if (groupsBeforeLevel.includes("role")) queryId += String(filters.staffRoleId);
            if (groupsBeforeLevel.includes("staff")) queryId += String(filters.staffId);
            return {
                label: (0, $4hBm1.format)(periodStartDate, (0, $6eCWq.default).periodDisplayFormat()),
                type: "number",
                width: 8,
                format: (v)=>(0, $cwjKY.FormatNumber)(v, {
                        decimals: 1
                    }),
                value: (row)=>{
                    return (0, $6eCWq.default).getRowHoursInPeriod(row, (0, $4hBm1.format)(periodStartDate, (0, $6eCWq.default).periodFormat()));
                },
                component: (props)=>$95a2c64d75bb34c2$var$ResourceCellComponent(props, store, (0, $4hBm1.format)(periodStartDate, (0, $6eCWq.default).periodFormat()), [
                        ...keys,
                        props.stores.row.rowObject.key
                    ]),
                editable: (row)=>{
                    return (isFuturePeriod || isCurrentPeriod || store.report.filters.hoursData === "projected") && [
                        "projected",
                        "actualsProjected"
                    ].includes(store.report.filters.hoursData) && !!row.projectId && !!(0, $gJT7h.default).projectsById[row.projectId] && (0, $8kZ1o.canEditStaffAllocations)((0, $1BTI2.default).user, (0, $gJT7h.default).projectsById[row.projectId]) && groupsAtLevel.includes("project");
                },
                style: (row, stores)=>{
                    return $95a2c64d75bb34c2$var$cellStyles(row, stores, periodStart, isPastPeriod);
                },
                aggregate: "sum",
                onClick: (r)=>()=>{
                        store.selectCell(periodStart, [
                            ...keys,
                            r.key
                        ], r);
                    },
                selected: (r)=>{
                    return store.selectedObject === r && (0, $4hBm1.format)(store.selectedPeriod, (0, $6eCWq.default).periodFormat()) === (0, $4hBm1.format)(periodStart, (0, $6eCWq.default).periodFormat());
                },
                onChange: (r)=>(v)=>{
                        v = v || 0;
                        store.setHours(r, (0, $4hBm1.format)(periodStartDate, (0, $6eCWq.default).periodFormat()), v, (period, newHours, projectId, phaseId, roleId, staffId)=>{
                            (0, $alT7C.ProjectSidebarStore).setHoursInPeriod((0, $4hBm1.format)(periodStartDate, (0, $6eCWq.default).periodFormat()), projectId, phaseId || null, roleId || null, staffId || null, newHours, (0, $6eCWq.default).selectedPhaseIds, (0, $6eCWq.default).selectedStaffIds, (0, $6eCWq.default).periodType);
                        });
                    }
            };
        },
        csvHours: (periodStartDate, groupBy = [], filters = [])=>{
            return {
                id: (0, $4hBm1.format)(periodStartDate, (0, $6eCWq.default).periodFormat()),
                label: (0, $4hBm1.format)(periodStartDate, (0, $6eCWq.default).periodDisplayFormat()),
                type: "text",
                value: (row)=>{
                    const period = (0, $4hBm1.format)(periodStartDate, (0, $6eCWq.default).periodFormat());
                    let value = (0, $cwjKY.FormatNumber)(store.getRowHoursInPeriod(row, period), {
                        decimals: 0
                    });
                    if (store.report.filters.hoursData === "actualsVsProjected") {
                        const actualHoursInPeriod = store.getRowHoursInPeriod(row, period, "actuals");
                        const projectedHoursInPeriod = store.getRowHoursInPeriod(row, period, "projected");
                        value = `${(0, $cwjKY.FormatNumber)(actualHoursInPeriod, {
                            decimals: 0
                        })} / ${(0, $cwjKY.FormatNumber)(projectedHoursInPeriod, {
                            decimals: 0
                        })}`;
                    }
                    return value;
                }
            };
        },
        budgetUse: (level, filters)=>{
            const colType = {
                budgetUse: "progress",
                remainingBudget: "number",
                averageUtilisation: "percent"
            };
            const colVal = {
                budgetUse: (row)=>{
                    return {
                        numerator: store.getRowTotalHours(row) || 0,
                        denominator: store.getRowBudget(row) || 0
                    };
                },
                remainingBudget: (row)=>{
                    return (store.getRowBudget(row) || 0) - store.getRowTotalHours(row) || 0;
                },
                averageUtilisation: (row)=>{
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).mean([
                        ...Array(12)
                    ].map((v, i)=>{
                        const period = (0, $4hBm1.format)(store.addPeriods(store.startOfPeriod(store.startDate), i), store.periodFormat());
                        return store.getRowHoursInPeriod(row, period) / store.getRowAvailabilityInPeriod(row, period);
                    }));
                }
            };
            return {
                id: "budgetUse",
                label: /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                    children: [
                        "Total",
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                            style: {
                                fontSize: "1.5em",
                                float: "right"
                            },
                            onClick: (e)=>e.stopPropagation(),
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                    className: `fa fa-caret-left`,
                                    style: {
                                        cursor: "pointer"
                                    },
                                    onClick: ()=>store.shiftDates(-1)
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                    className: `fa fa-caret-right`,
                                    style: {
                                        marginRight: 0,
                                        cursor: "pointer"
                                    },
                                    onClick: ()=>store.shiftDates(1)
                                })
                            ]
                        })
                    ]
                }),
                type: colType[store.report.filters.totalData],
                width: 18,
                editable: (row)=>false,
                value: (row)=>{
                    return colVal[store.report.filters.totalData](row);
                }
            };
        }
    });
const $95a2c64d75bb34c2$var$ResourceCellComponent = (props, store, period, keys = [])=>{
    var _props$stores, _props$stores$row;
    const resourceRow = props.stores.row.rowObject;
    const isTotalRow = (props === null || props === void 0 ? void 0 : (_props$stores = props.stores) === null || _props$stores === void 0 ? void 0 : (_props$stores$row = _props$stores.row) === null || _props$stores$row === void 0 ? void 0 : _props$stores$row.id) === "totals";
    let progress = $95a2c64d75bb34c2$var$getProgressValue(store, period, resourceRow);
    let value = props.formattedValue;
    const keyString = keys.join(",");
    if ((0, $6eCWq.default).report.filters.hoursData === "actualsVsProjected") {
        const actualHoursInPeriod = store.getRowHoursInPeriod(resourceRow, period, "actuals");
        const projectedHoursInPeriod = store.getRowHoursInPeriod(resourceRow, period, "projected");
        value = `${(0, $cwjKY.FormatNumber)(actualHoursInPeriod, {
            decimals: 0
        })} / ${(0, $cwjKY.FormatNumber)(projectedHoursInPeriod, {
            decimals: 0
        })}`;
    }
    if (isFinite(progress)) value += ` (${(0, $gjxeM.FormatPercent)(progress || 0, {
        decimals: 0
    })})`;
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)($95a2c64d75bb34c2$var$MilestoneCellComponent, {
                projectId: resourceRow.projectId,
                phaseId: resourceRow.phaseId,
                periodType: store.periodType,
                period: period
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                ...props,
                onChange: null,
                children: props.selected && props.editable ? (0, $49KZT.default)["number"]({
                    ...props,
                    key: "edit"
                }) : (0, $49KZT.default)["text"]({
                    ...props,
                    key: "display",
                    style: {
                        textAlign: "right"
                    },
                    value: value,
                    formattedValue: value,
                    editable: false,
                    onChange: null
                })
            })
        ]
    });
};
const $95a2c64d75bb34c2$var$getProgressValue = (store, period, row)=>{
    var _row$key;
    let progress, allocatedHours, recordedHours, hours, budget, availability;
    switch((0, $6eCWq.default).report.filters.percentData){
        case "budgetUse":
            hours = store.getRowHoursToDateInPeriod(row, period);
            budget = store.getRowBudget(row);
            progress = budget > 0 ? hours / budget : 0;
            break;
        case "monthlyBudgetUse":
            hours = store.getRowHoursInPeriod(row, period);
            budget = store.getRowBudget(row);
            progress = budget > 0 ? hours / budget : 0;
            break;
        case "remainingMonthlyBudgetUse":
            allocatedHours = store.getRowHoursInPeriod(row, period, "projected");
            recordedHours = store.getRowHoursInPeriod(row, period, "actuals");
            progress = allocatedHours > 0 ? (allocatedHours - recordedHours) / allocatedHours : 0;
            break;
        case "remainingMonthlyBudgetUseCapped":
            allocatedHours = store.getRowHoursInPeriod(row, period, "projected");
            recordedHours = store.getRowHoursInPeriod(row, period, "actuals");
            progress = allocatedHours > 0 ? Math.max(allocatedHours - recordedHours, 0) / allocatedHours : 0;
            break;
        case "utilisation":
        default:
            hours = store.getRowHoursInPeriod(row, period);
            availability = store.getRowAvailabilityInPeriod(row, period);
            // Check if no ancestor rows have a staffId before adjusting hours
            const hasAncestorWithStaffId = row === null || row === void 0 ? void 0 : (_row$key = row.key) === null || _row$key === void 0 ? void 0 : _row$key.split("||").slice(0, -1).some((ancestorKey)=>{
                const ancestorRow = store.queryData.find((r)=>r.key === ancestorKey);
                return ancestorRow === null || ancestorRow === void 0 ? void 0 : ancestorRow.staffId;
            });
            if (row !== null && row !== void 0 && row.staffId && hours && !hasAncestorWithStaffId) hours = store.getStaffHoursInPeriod(row === null || row === void 0 ? void 0 : row.staffId, period);
            progress = availability > 0 ? hours / availability : 0;
            break;
    }
    return progress;
};
const $95a2c64d75bb34c2$var$MilestoneCellComponent = ({ projectId: projectId, phaseId: phaseId, periodType: periodType, period: period })=>{
    const [isOpen, setIsOpen] = (0, $jbmdS.useState)(false);
    if (!(0, $8kZ1o.canViewProjectMilestones)((0, $1BTI2.default).user) || !projectId || !period) return null;
    const milestones = (phaseId ? (0, $liJtZ.default).milestonesByPhaseId[phaseId] : (0, $liJtZ.default).milestonesByProjectId[projectId]) || [];
    const milestonesInPeriod = milestones.filter((m)=>m[periodType] === period);
    if (milestonesInPeriod.length === 0) return null;
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $6gkJQ.Popover), {
        open: isOpen,
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6gkJQ.PopoverTrigger), {
                onMouseEnter: ()=>setIsOpen(true),
                onMouseLeave: ()=>setIsOpen(false),
                children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    className: "absolute top-0.5 right-0.5 w-2 h-2 bg-rose-600 rounded-full cursor-pointer border border-white shadow-sm"
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6gkJQ.PopoverContent), {
                onMouseEnter: ()=>setIsOpen(true),
                onMouseLeave: ()=>setIsOpen(false),
                children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    className: "p-4 text-sm",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("h4", {
                            children: "Milestones"
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)("ul", {
                            children: milestonesInPeriod.map((m)=>/*#__PURE__*/ (0, $61Ea1.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                            className: "font-bold",
                                            children: (0, $4hBm1.format)(m.date, "dd/MM/yy")
                                        }),
                                        " ",
                                        "- ",
                                        m.label
                                    ]
                                }, m.id))
                        })
                    ]
                })
            })
        ]
    });
};

});
parcelRegister("fUWIW", function(module, exports) {

$parcel$export(module.exports, "queryFilters", function () { return $b969a34a81f514cc$export$a99de19ba7bfbeeb; });

var $cnmvx = parcelRequire("cnmvx");

var $jE5CX = parcelRequire("jE5CX");
const $b969a34a81f514cc$var$boolOrDefault = (columnId)=>`(${columnId} == null ? false : ${columnId})`;
const $b969a34a81f514cc$var$textOrDefault = (columnId)=>`(${columnId} == null ? "" : ${columnId})`;
const $b969a34a81f514cc$var$numberOrDefault = (columnId)=>`(${columnId} == null ? 0 : ${columnId})`;
const $b969a34a81f514cc$export$a99de19ba7bfbeeb = {
    boolean: {
        "=": (column, value)=>value != null ? [
                `${column} == (${value})`
            ] : null,
        "!=": (column, value)=>value != null ? [
                `${column} != (${value})`
            ] : null
    },
    text: {
        "=": (column, value)=>[
                `${$b969a34a81f514cc$var$textOrDefault(column)} == "${value || ""}"`
            ],
        "!=": (column, value)=>[
                `${$b969a34a81f514cc$var$textOrDefault(column)} != "${value || ""}"`
            ],
        contains: (column, value)=>value ? [
                `contains(${$b969a34a81f514cc$var$textOrDefault(column)}, "%${value}%")`
            ] : [],
        "!contains": (column, value)=>value ? [
                `not(contains(${$b969a34a81f514cc$var$textOrDefault(column)}, "%${value}%"))`
            ] : [],
        starts: (column, value)=>value ? [
                `contains(${$b969a34a81f514cc$var$textOrDefault(column)}, "${value}%")`
            ] : [],
        "!starts": (column, value)=>value ? [
                `not(contains(${$b969a34a81f514cc$var$textOrDefault(column)}, "${value}%"))`
            ] : [],
        ends: (column, value)=>value ? [
                `contains(${$b969a34a81f514cc$var$textOrDefault(column)}, "%${value}")`
            ] : [],
        "!ends": (column, value)=>value ? [
                `not(contains(${$b969a34a81f514cc$var$textOrDefault(column)}, "%${value}"))`
            ] : [],
        in: (column, value)=>value ? [
                `${$b969a34a81f514cc$var$textOrDefault(column)} in ${(0, $jE5CX.qf)(value)}`
            ] : [],
        "!in": (column, value)=>value ? [
                `not(${$b969a34a81f514cc$var$textOrDefault(column)} in ${(0, $jE5CX.qf)(value)})`
            ] : []
    },
    number: {
        "=": (column, value)=>[
                `${$b969a34a81f514cc$var$numberOrDefault(column)} == (${value || 0})`
            ],
        "!=": (column, value)=>[
                `${$b969a34a81f514cc$var$numberOrDefault(column)} != (${value || 0})`
            ],
        ">": (column, value)=>[
                `${$b969a34a81f514cc$var$numberOrDefault(column)} > (${value || 0})`
            ],
        ">=": (column, value)=>[
                `${$b969a34a81f514cc$var$numberOrDefault(column)} >= (${value || 0})`
            ],
        "<": (column, value)=>[
                `${$b969a34a81f514cc$var$numberOrDefault(column)} < (${value || 0})`
            ],
        "<=": (column, value)=>[
                `${$b969a34a81f514cc$var$numberOrDefault(column)} <= (${value || 0})`
            ],
        between: (column, value)=>value ? [
                `${$b969a34a81f514cc$var$numberOrDefault(column)} >= (${value[0]}) and ${$b969a34a81f514cc$var$numberOrDefault(column)} <= (${value[1]})`
            ] : [],
        "!between": (column, value)=>value ? [
                `not(${$b969a34a81f514cc$var$numberOrDefault(column)} >= (${value[0]}) and ${$b969a34a81f514cc$var$numberOrDefault(column)} <= (${value[1]}))`
            ] : [],
        in: (column, value)=>value ? [
                `${$b969a34a81f514cc$var$numberOrDefault(column)} in ${(0, $jE5CX.qf)(value)}`
            ] : [],
        "!in": (column, value)=>value ? [
                `not(${$b969a34a81f514cc$var$numberOrDefault(column)} in ${(0, $jE5CX.qf)(value)})`
            ] : []
    },
    date: {
        "=": (column, value)=>value ? [
                `${column} == ${(0, $jE5CX.qf)(value)}`
            ] : [],
        "!=": (column, value)=>value ? [
                `${column} != ${(0, $jE5CX.qf)(value)}`
            ] : [],
        ">": (column, value)=>value ? [
                `${column} > ${(0, $jE5CX.qf)(value)}`
            ] : [],
        ">=": (column, value)=>value ? [
                `${column} >= ${(0, $jE5CX.qf)(value)}`
            ] : [],
        "<": (column, value)=>value ? [
                `${column} < ${(0, $jE5CX.qf)(value)}`
            ] : [],
        "<=": (column, value)=>value ? [
                `${column} <= ${(0, $jE5CX.qf)(value)}`
            ] : [],
        between: (column, value)=>{
            var _dateStringLookup$val;
            value = ((_dateStringLookup$val = (0, $cnmvx.dateStringLookup)[value]) === null || _dateStringLookup$val === void 0 ? void 0 : _dateStringLookup$val.call((0, $cnmvx.dateStringLookup))) || value;
            return value ? [
                `${column} >= ${(0, $jE5CX.qf)(value[0])} and ${column} <= ${(0, $jE5CX.qf)(value[1])}`
            ] : [];
        },
        "!between": (column, value)=>{
            var _dateStringLookup$val2;
            value = ((_dateStringLookup$val2 = (0, $cnmvx.dateStringLookup)[value]) === null || _dateStringLookup$val2 === void 0 ? void 0 : _dateStringLookup$val2.call((0, $cnmvx.dateStringLookup))) || value;
            return value ? [
                `not(${column} >= ${(0, $jE5CX.qf)(value[0])} and ${column} <= ${(0, $jE5CX.qf)(value[1])})`
            ] : [];
        }
    },
    singleId: {
        "=": (column, value)=>[
                `${column} == ${(0, $jE5CX.qf)(value)}`
            ],
        "!=": (column, value)=>[
                `${column} != ${(0, $jE5CX.qf)(value)}`
            ],
        in: (column, value)=>value !== null && value !== void 0 && value.length ? [
                `${column} in ${(0, $jE5CX.qf)(value)}`
            ] : [],
        "!in": (column, value)=>value !== null && value !== void 0 && value.length ? [
                `not(${column} in ${(0, $jE5CX.qf)(value)})`
            ] : []
    },
    manyIds: {
        in: (column, value)=>value !== null && value !== void 0 && value.length ? [
                value.map((v)=>[
                        `${v} in ${column}`
                    ]).join(" or ")
            ] : [],
        "!in": (column, value)=>value !== null && value !== void 0 && value.length ? [
                value.map((v)=>[
                        `not(${v} in ${column}})`
                    ]).join(" and ")
            ] : []
    }
};

});

parcelRegister("hTXTf", function(module, exports) {

$parcel$export(module.exports, "getGradient", function () { return $d086079fea328a92$export$e14995d3ec1747ee; });

var $axwFe = parcelRequire("axwFe");
// note: HUSL is depricated and should be replaced with HSLuv
//copied from http://refactorman.com/2015/08/08/better-color-gradients-with-husl/
function $d086079fea328a92$var$linearTween(start, stop) {
    return function tween(i) {
        return (stop - start) * i + start;
    };
}
function $d086079fea328a92$var$degreesToRadians(d) {
    return d * Math.PI / 180;
}
function $d086079fea328a92$var$radiansToDegrees(r) {
    return r * 180 / Math.PI;
}
function $d086079fea328a92$var$circularTween(start, stop) {
    start = $d086079fea328a92$var$degreesToRadians(start);
    stop = $d086079fea328a92$var$degreesToRadians(stop);
    let delta = Math.atan2(Math.sin(stop - start), Math.cos(stop - start));
    return function tween(i) {
        return ($d086079fea328a92$var$radiansToDegrees(start + delta * i) + 360) % 360;
    };
}
let $d086079fea328a92$var$bgStartColor = $axwFe.fromHex("#fdf3d2");
let $d086079fea328a92$var$bgMidColor = $axwFe.fromHex("#ffc800");
let $d086079fea328a92$var$bgEndColor = $axwFe.fromHex("#f15a29");
let $d086079fea328a92$var$bgHue1 = $d086079fea328a92$var$circularTween($d086079fea328a92$var$bgStartColor[0], $d086079fea328a92$var$bgMidColor[0]);
let $d086079fea328a92$var$bgSaturation1 = $d086079fea328a92$var$linearTween($d086079fea328a92$var$bgStartColor[1], $d086079fea328a92$var$bgMidColor[1]);
let $d086079fea328a92$var$bgLightness1 = $d086079fea328a92$var$linearTween($d086079fea328a92$var$bgStartColor[2], $d086079fea328a92$var$bgMidColor[2]);
let $d086079fea328a92$var$bgHue2 = $d086079fea328a92$var$circularTween($d086079fea328a92$var$bgMidColor[0], $d086079fea328a92$var$bgEndColor[0]);
let $d086079fea328a92$var$bgSaturation2 = $d086079fea328a92$var$linearTween($d086079fea328a92$var$bgMidColor[1], $d086079fea328a92$var$bgEndColor[1]);
let $d086079fea328a92$var$bgLightness2 = $d086079fea328a92$var$linearTween($d086079fea328a92$var$bgMidColor[2], $d086079fea328a92$var$bgEndColor[2]);
function $d086079fea328a92$export$e14995d3ec1747ee(val) {
    /**
   * Returns styles to render a cell with value `val` (from 0 to 1) where 0 is
   * white and 1 is bright red.
   */ if (val < 0) val = 0;
    return {
        color: val > 1 ? "#ffffff" : "inherit",
        backgroundColor: val > 1 ? $axwFe.toHex($d086079fea328a92$var$bgHue2((1 - 0.8) / 0.2), $d086079fea328a92$var$bgSaturation2((1 - 0.8) / 0.2), $d086079fea328a92$var$bgLightness2((1 - 0.8) / 0.2)) + "cc" : val >= 0 ? $axwFe.toHex($d086079fea328a92$var$bgHue1(val), $d086079fea328a92$var$bgSaturation1(val), $d086079fea328a92$var$bgLightness1(val)) + "cc" : null
    };
}

});
parcelRegister("axwFe", function(module, exports) {
(function() {
    function b() {}
    function h() {}
    function n() {}
    function k() {}
    function f() {}
    function e(a) {
        return function(b, c, l) {
            return a([
                b,
                c,
                l
            ]);
        };
    }
    f.j = function(a) {
        a = a.charCodeAt(1);
        if (a == a) return a;
    };
    f.substr = function(a, b, c) {
        if (null == c) c = a.length;
        else if (0 > c) {
            if (0 == b) c = a.length + c;
            else return "";
        }
        return a.substr(b, c);
    };
    k.parseInt = function(a) {
        var b = parseInt(a, 10);
        0 != b || 120 != f.j(a) && 88 != f.j(a) || (b = parseInt(a));
        return isNaN(b) ? null : b;
    };
    n.L = function(a) {
        for(var b = ""; b = "0123456789ABCDEF".charAt(a & 15) + b, a >>>= 4, 0 < a;);
        for(; 2 > b.length;)b = "0" + b;
        return b;
    };
    h.K = function(a) {
        return Math.abs(a.v) / Math.sqrt(Math.pow(a.J, 2) + 1);
    };
    h.X = function(a, b) {
        return b.v / (Math.sin(a) - b.J * Math.cos(a));
    };
    b.m = function(a) {
        for(var d = [], c = Math.pow(a + 16, 3) / 1560896, c = c > b.l ? c : a / b.g, l = 0; 3 > l;)for(var g = l++, p = b.b[g][0], f = b.b[g][1], g = b.b[g][2], e = 0; 2 > e;){
            var h = e++, k = (632260 * g - 126452 * f) * c + 126452 * h;
            d.push({
                J: (284517 * p - 94839 * g) * c / k,
                v: ((838422 * g + 769860 * f + 731718 * p) * a * c - 769860 * h * a) / k
            });
        }
        return d;
    };
    b.B = function(a) {
        a = b.m(a);
        for(var d = 1.7976931348623157E308, c = 0; 2 > c;)d = Math.min(d, h.K(a[c++]));
        return d;
    };
    b.A = function(a, d) {
        for(var c = d / 360 * Math.PI * 2, l = b.m(a), g = 1.7976931348623157E308, f = 0; f < l.length;){
            var e = l[f];
            ++f;
            e = h.X(c, e);
            0 <= e && (g = Math.min(g, e));
        }
        return g;
    };
    b.a = function(a, b) {
        for(var c = 0, d = 0, f = a.length; d < f;)var e = d++, c = c + a[e] * b[e];
        return c;
    };
    b.f = function(a) {
        return .0031308 >= a ? 12.92 * a : 1.055 * Math.pow(a, .4166666666666667) - .055;
    };
    b.i = function(a) {
        return .04045 < a ? Math.pow((a + .055) / 1.055, 2.4) : a / 12.92;
    };
    b.ba = function(a) {
        return [
            b.f(b.a(b.b[0], a)),
            b.f(b.a(b.b[1], a)),
            b.f(b.a(b.b[2], a))
        ];
    };
    b.$ = function(a) {
        a = [
            b.i(a[0]),
            b.i(a[1]),
            b.i(a[2])
        ];
        return [
            b.a(b.h[0], a),
            b.a(b.h[1], a),
            b.a(b.h[2], a)
        ];
    };
    b.ca = function(a) {
        return a <= b.l ? a / b.c * b.g : 116 * Math.pow(a / b.c, .3333333333333333) - 16;
    };
    b.T = function(a) {
        return 8 >= a ? b.c * a / b.g : b.c * Math.pow((a + 16) / 116, 3);
    };
    b.aa = function(a) {
        var d = a[0], c = a[1];
        a = d + 15 * c + 3 * a[2];
        0 != a ? (d = 4 * d / a, a = 9 * c / a) : a = d = NaN;
        c = b.ca(c);
        return 0 == c ? [
            0,
            0,
            0
        ] : [
            c,
            13 * c * (d - b.C),
            13 * c * (a - b.D)
        ];
    };
    b.Z = function(a) {
        var d = a[0];
        if (0 == d) return [
            0,
            0,
            0
        ];
        var c = a[1] / (13 * d) + b.C;
        a = a[2] / (13 * d) + b.D;
        d = b.T(d);
        c = 0 - 9 * d * c / ((c - 4) * a - c * a);
        return [
            c,
            d,
            (9 * d - 15 * a * d - a * c) / (3 * a)
        ];
    };
    b.Y = function(a) {
        var b = a[0], c = a[1], e = a[2];
        a = Math.sqrt(c * c + e * e);
        1E-8 > a ? c = 0 : (c = 180 * Math.atan2(e, c) / 3.141592653589793, 0 > c && (c = 360 + c));
        return [
            b,
            a,
            c
        ];
    };
    b.W = function(a) {
        var b = a[1], c = a[2] / 360 * 2 * Math.PI;
        return [
            a[0],
            Math.cos(c) * b,
            Math.sin(c) * b
        ];
    };
    b.P = function(a) {
        var d = a[0], c = a[1];
        a = a[2];
        return 99.9999999 < a ? [
            100,
            0,
            d
        ] : 1E-8 > a ? [
            0,
            0,
            d
        ] : [
            a,
            b.A(a, d) / 100 * c,
            d
        ];
    };
    b.U = function(a) {
        var d = a[0], c = a[2];
        return 99.9999999 < d ? [
            c,
            0,
            100
        ] : 1E-8 > d ? [
            c,
            0,
            0
        ] : [
            c,
            a[1] / b.A(d, c) * 100,
            d
        ];
    };
    b.S = function(a) {
        var d = a[0], c = a[1];
        a = a[2];
        return 99.9999999 < a ? [
            100,
            0,
            d
        ] : 1E-8 > a ? [
            0,
            0,
            d
        ] : [
            a,
            b.B(a) / 100 * c,
            d
        ];
    };
    b.V = function(a) {
        var d = a[0], c = a[2];
        return 99.9999999 < d ? [
            c,
            0,
            100
        ] : 1E-8 > d ? [
            c,
            0,
            0
        ] : [
            c,
            a[1] / b.B(d) * 100,
            d
        ];
    };
    b.F = function(a) {
        for(var b = "#", c = 0, e = a.length; c < e;)b += n.L(Math.round(255 * a[c++])).toLowerCase();
        return b;
    };
    b.o = function(a) {
        a = a.toUpperCase();
        return [
            k.parseInt("0x" + f.substr(a, 1, 2)) / 255,
            k.parseInt("0x" + f.substr(a, 3, 2)) / 255,
            k.parseInt("0x" + f.substr(a, 5, 2)) / 255
        ];
    };
    b.w = function(a) {
        return b.ba(b.Z(b.W(a)));
    };
    b.I = function(a) {
        return b.Y(b.aa(b.$(a)));
    };
    b.s = function(a) {
        return b.w(b.P(a));
    };
    b.G = function(a) {
        return b.U(b.I(a));
    };
    b.u = function(a) {
        return b.w(b.S(a));
    };
    b.H = function(a) {
        return b.V(b.I(a));
    };
    b.O = function(a) {
        return b.F(b.s(a));
    };
    b.R = function(a) {
        return b.F(b.u(a));
    };
    b.M = function(a) {
        return b.G(b.o(a));
    };
    b.N = function(a) {
        return b.H(b.o(a));
    };
    b.b = [
        [
            3.240969941904521,
            -1.537383177570093,
            -0.498610760293
        ],
        [
            -0.96924363628087,
            1.87596750150772,
            .041555057407175
        ],
        [
            .055630079696993,
            -0.20397695888897,
            1.056971514242878
        ]
    ];
    b.h = [
        [
            .41239079926595,
            .35758433938387,
            .18048078840183
        ],
        [
            .21263900587151,
            .71516867876775,
            .072192315360733
        ],
        [
            .019330818715591,
            .11919477979462,
            .95053215224966
        ]
    ];
    b.c = 1;
    b.C = .19783000664283;
    b.D = .46831999493879;
    b.g = 903.2962962;
    b.l = .0088564516;
    var m = {
        fromRGB: e(b.G),
        fromHex: b.M,
        toRGB: e(b.s),
        toHex: e(b.O),
        p: {
            fromRGB: e(b.H),
            fromHex: b.N,
            toRGB: e(b.u),
            toHex: e(b.R)
        }
    };
    "undefined" !== typeof jQuery && (jQuery.husl = m);
    module.exports = m;
    "undefined" !== typeof define && define(m);
    "undefined" !== typeof window && (window.HUSL = m);
})();

});




parcelRegister("hYVSY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d174f126afbef039$export$2e2bcd8739ae039; });

var $6CU3E = parcelRequire("6CU3E");

var $4ClFh = parcelRequire("4ClFh");
var $d174f126afbef039$var$Checkbox = (0, $6CU3E.default);
$d174f126afbef039$var$Checkbox.Group = (0, $4ClFh.default);
$d174f126afbef039$var$Checkbox.__ANT_CHECKBOX = true;
var $d174f126afbef039$export$2e2bcd8739ae039 = $d174f126afbef039$var$Checkbox;

});
parcelRegister("6CU3E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d31c699d285c38c$export$2e2bcd8739ae039; });

var $8K2NM = parcelRequire("8K2NM");

var $7i29i = parcelRequire("7i29i");

var $02LyB = parcelRequire("02LyB");

var $h7Op5 = parcelRequire("h7Op5");

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("8uDri");
var $ewikT = parcelRequire("ewikT");

var $3ACNS = parcelRequire("3ACNS");


var $4ClFh = parcelRequire("4ClFh");

var $kgIuF = parcelRequire("kgIuF");
var $4d31c699d285c38c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $4d31c699d285c38c$var$InternalCheckbox = function InternalCheckbox(_a, ref) {
    var _b;
    var customizePrefixCls = _a.prefixCls, className = _a.className, children = _a.children, _a$indeterminate = _a.indeterminate, indeterminate = _a$indeterminate === void 0 ? false : _a$indeterminate, style = _a.style, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, _a$skipGroup = _a.skipGroup, skipGroup = _a$skipGroup === void 0 ? false : _a$skipGroup, disabled = _a.disabled, restProps = $4d31c699d285c38c$var$__rest(_a, [
        "prefixCls",
        "className",
        "children",
        "indeterminate",
        "style",
        "onMouseEnter",
        "onMouseLeave",
        "skipGroup",
        "disabled"
    ]);
    var _React$useContext = $jbmdS.useContext((0, $ewikT.ConfigContext)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var checkboxGroup = $jbmdS.useContext((0, $4ClFh.GroupContext));
    var _useContext = (0, $jbmdS.useContext)((0, $3ACNS.FormItemInputContext)), isFormItemInput = _useContext.isFormItemInput;
    var contextDisabled = (0, $jbmdS.useContext)((0, $kgIuF.default));
    var mergedDisabled = (_b = (checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.disabled) || disabled) !== null && _b !== void 0 ? _b : contextDisabled;
    var prevValue = $jbmdS.useRef(restProps.value);
    $jbmdS.useEffect(function() {
        checkboxGroup === null || checkboxGroup === void 0 || checkboxGroup.registerValue(restProps.value);
    }, []);
    $jbmdS.useEffect(function() {
        if (skipGroup) return;
        if (restProps.value !== prevValue.current) {
            checkboxGroup === null || checkboxGroup === void 0 || checkboxGroup.cancelValue(prevValue.current);
            checkboxGroup === null || checkboxGroup === void 0 || checkboxGroup.registerValue(restProps.value);
            prevValue.current = restProps.value;
        }
        return function() {
            return checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.cancelValue(restProps.value);
        };
    }, [
        restProps.value
    ]);
    var prefixCls = getPrefixCls("checkbox", customizePrefixCls);
    var checkboxProps = (0, $7i29i.default)({}, restProps);
    if (checkboxGroup && !skipGroup) {
        checkboxProps.onChange = function() {
            if (restProps.onChange) restProps.onChange.apply(restProps, arguments);
            if (checkboxGroup.toggleOption) checkboxGroup.toggleOption({
                label: children,
                value: restProps.value
            });
        };
        checkboxProps.name = checkboxGroup.name;
        checkboxProps.checked = checkboxGroup.value.includes(restProps.value);
    }
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)({}, "".concat(prefixCls, "-wrapper"), true), "".concat(prefixCls, "-rtl"), direction === "rtl"), "".concat(prefixCls, "-wrapper-checked"), checkboxProps.checked), "".concat(prefixCls, "-wrapper-disabled"), mergedDisabled), "".concat(prefixCls, "-wrapper-in-form-item"), isFormItemInput), className);
    var checkboxClass = (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))((0, $8K2NM.default)({}, "".concat(prefixCls, "-indeterminate"), indeterminate));
    var ariaChecked = indeterminate ? "mixed" : undefined;
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/label-has-associated-control
    $jbmdS.createElement("label", {
        className: classString,
        style: style,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, /*#__PURE__*/ $jbmdS.createElement((0, $h7Op5.default), (0, $7i29i.default)({
        "aria-checked": ariaChecked
    }, checkboxProps, {
        prefixCls: prefixCls,
        className: checkboxClass,
        disabled: mergedDisabled,
        ref: ref
    })), children !== undefined && /*#__PURE__*/ $jbmdS.createElement("span", null, children)));
};
var $4d31c699d285c38c$var$Checkbox = /*#__PURE__*/ $jbmdS.forwardRef($4d31c699d285c38c$var$InternalCheckbox);
var $4d31c699d285c38c$export$2e2bcd8739ae039 = $4d31c699d285c38c$var$Checkbox;

});
parcelRegister("h7Op5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c77a303ea63b6dc2$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $lv6ip = parcelRequire("lv6ip");

var $8K2NM = parcelRequire("8K2NM");

var $CZyex = parcelRequire("CZyex");

var $ccQt4 = parcelRequire("ccQt4");

var $02LyB = parcelRequire("02LyB");

var $9nYhz = parcelRequire("9nYhz");

var $jbmdS = parcelRequire("jbmdS");
var $c77a303ea63b6dc2$var$_excluded = [
    "prefixCls",
    "className",
    "style",
    "checked",
    "disabled",
    "defaultChecked",
    "type",
    "onChange"
];
var $c77a303ea63b6dc2$export$48513f6b9f8ce62d = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(props, ref) {
    var _classNames;
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-checkbox" : _props$prefixCls, className = props.className, style = props.style, checked = props.checked, disabled = props.disabled, _props$defaultChecked = props.defaultChecked, defaultChecked = _props$defaultChecked === void 0 ? false : _props$defaultChecked, _props$type = props.type, type = _props$type === void 0 ? "checkbox" : _props$type, onChange = props.onChange, inputProps = (0, $ccQt4.default)(props, $c77a303ea63b6dc2$var$_excluded);
    var inputRef = (0, $jbmdS.useRef)(null);
    var _useMergedState = (0, $9nYhz.default)(defaultChecked, {
        value: checked
    }), _useMergedState2 = (0, $CZyex.default)(_useMergedState, 2), rawValue = _useMergedState2[0], setRawValue = _useMergedState2[1];
    (0, $jbmdS.useImperativeHandle)(ref, function() {
        return {
            focus: function focus() {
                var _inputRef$current;
                (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
            },
            blur: function blur() {
                var _inputRef$current2;
                (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.blur();
            },
            input: inputRef.current
        };
    });
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(prefixCls, className, (_classNames = {}, (0, $8K2NM.default)(_classNames, "".concat(prefixCls, "-checked"), rawValue), (0, $8K2NM.default)(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames));
    var handleChange = function handleChange(e) {
        if (disabled) return;
        if (!("checked" in props)) setRawValue(e.target.checked);
        onChange === null || onChange === void 0 || onChange({
            target: (0, $lv6ip.default)((0, $lv6ip.default)({}, props), {}, {
                type: type,
                checked: e.target.checked
            }),
            stopPropagation: function stopPropagation() {
                e.stopPropagation();
            },
            preventDefault: function preventDefault() {
                e.preventDefault();
            },
            nativeEvent: e.nativeEvent
        });
    };
    return /*#__PURE__*/ $jbmdS.createElement("span", {
        className: classString,
        style: style
    }, /*#__PURE__*/ $jbmdS.createElement("input", (0, $7i29i.default)({}, inputProps, {
        className: "".concat(prefixCls, "-input"),
        ref: inputRef,
        onChange: handleChange,
        disabled: disabled,
        checked: !!rawValue,
        type: type
    })), /*#__PURE__*/ $jbmdS.createElement("span", {
        className: "".concat(prefixCls, "-inner")
    }));
});
var $c77a303ea63b6dc2$export$2e2bcd8739ae039 = $c77a303ea63b6dc2$export$48513f6b9f8ce62d;

});

parcelRegister("4ClFh", function(module, exports) {

$parcel$export(module.exports, "GroupContext", function () { return $35cb84331a98fed2$export$f9c6924e160136d1; });
$parcel$export(module.exports, "default", function () { return $35cb84331a98fed2$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $8K2NM = parcelRequire("8K2NM");

var $huwkX = parcelRequire("huwkX");

var $CZyex = parcelRequire("CZyex");

var $02LyB = parcelRequire("02LyB");

var $cXDkH = parcelRequire("cXDkH");

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("8uDri");
var $ewikT = parcelRequire("ewikT");

var $6CU3E = parcelRequire("6CU3E");
var $35cb84331a98fed2$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $35cb84331a98fed2$export$f9c6924e160136d1 = /*#__PURE__*/ $jbmdS.createContext(null);
var $35cb84331a98fed2$var$InternalCheckboxGroup = function InternalCheckboxGroup(_a, ref) {
    var defaultValue = _a.defaultValue, children = _a.children, _a$options = _a.options, options = _a$options === void 0 ? [] : _a$options, customizePrefixCls = _a.prefixCls, className = _a.className, style = _a.style, onChange = _a.onChange, restProps = $35cb84331a98fed2$var$__rest(_a, [
        "defaultValue",
        "children",
        "options",
        "prefixCls",
        "className",
        "style",
        "onChange"
    ]);
    var _React$useContext = $jbmdS.useContext((0, $ewikT.ConfigContext)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var _React$useState = $jbmdS.useState(restProps.value || defaultValue || []), _React$useState2 = (0, $CZyex.default)(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
    var _React$useState3 = $jbmdS.useState([]), _React$useState4 = (0, $CZyex.default)(_React$useState3, 2), registeredValues = _React$useState4[0], setRegisteredValues = _React$useState4[1];
    $jbmdS.useEffect(function() {
        if ("value" in restProps) setValue(restProps.value || []);
    }, [
        restProps.value
    ]);
    var getOptions = function getOptions() {
        return options.map(function(option) {
            if (typeof option === "string" || typeof option === "number") return {
                label: option,
                value: option
            };
            return option;
        });
    };
    var cancelValue = function cancelValue(val) {
        setRegisteredValues(function(prevValues) {
            return prevValues.filter(function(v) {
                return v !== val;
            });
        });
    };
    var registerValue = function registerValue(val) {
        setRegisteredValues(function(prevValues) {
            return [].concat((0, $huwkX.default)(prevValues), [
                val
            ]);
        });
    };
    var toggleOption = function toggleOption(option) {
        var optionIndex = value.indexOf(option.value);
        var newValue = (0, $huwkX.default)(value);
        if (optionIndex === -1) newValue.push(option.value);
        else newValue.splice(optionIndex, 1);
        if (!("value" in restProps)) setValue(newValue);
        var opts = getOptions();
        onChange === null || onChange === void 0 || onChange(newValue.filter(function(val) {
            return registeredValues.includes(val);
        }).sort(function(a, b) {
            var indexA = opts.findIndex(function(opt) {
                return opt.value === a;
            });
            var indexB = opts.findIndex(function(opt) {
                return opt.value === b;
            });
            return indexA - indexB;
        }));
    };
    var prefixCls = getPrefixCls("checkbox", customizePrefixCls);
    var groupPrefixCls = "".concat(prefixCls, "-group");
    var domProps = (0, $cXDkH.default)(restProps, [
        "value",
        "disabled"
    ]);
    if (options && options.length > 0) children = getOptions().map(function(option) {
        return /*#__PURE__*/ $jbmdS.createElement((0, $6CU3E.default), {
            prefixCls: prefixCls,
            key: option.value.toString(),
            disabled: "disabled" in option ? option.disabled : restProps.disabled,
            value: option.value,
            checked: value.includes(option.value),
            onChange: option.onChange,
            className: "".concat(groupPrefixCls, "-item"),
            style: option.style
        }, option.label);
    });
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    var context = {
        toggleOption: toggleOption,
        value: value,
        disabled: restProps.disabled,
        name: restProps.name,
        // https://github.com/ant-design/ant-design/issues/16376
        registerValue: registerValue,
        cancelValue: cancelValue
    };
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(groupPrefixCls, (0, $8K2NM.default)({}, "".concat(groupPrefixCls, "-rtl"), direction === "rtl"), className);
    return /*#__PURE__*/ $jbmdS.createElement("div", (0, $7i29i.default)({
        className: classString,
        style: style
    }, domProps, {
        ref: ref
    }), /*#__PURE__*/ $jbmdS.createElement($35cb84331a98fed2$export$f9c6924e160136d1.Provider, {
        value: context
    }, children));
};
var $35cb84331a98fed2$var$CheckboxGroup = /*#__PURE__*/ $jbmdS.forwardRef($35cb84331a98fed2$var$InternalCheckboxGroup);
var $35cb84331a98fed2$export$2e2bcd8739ae039 = /*#__PURE__*/ $jbmdS.memo($35cb84331a98fed2$var$CheckboxGroup);

});



parcelRegister("8oGqY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61d17b282665aa46$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("jbmdS");

var $1EEMt = parcelRequire("1EEMt");

var $4hBm1 = parcelRequire("4hBm1");
parcelRequire("eat5C");

var $dsTi9 = parcelRequire("dsTi9");
var $61d17b282665aa46$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ row: row, month: month, editable: editable, updateCost: updateCost, onChange: onChange, fee: fee, previousRevenue: previousRevenue, currentRevenue: currentRevenue, label: label, key: key })=>{
    const monthId = (0, $4hBm1.format)(month, "yyyy-MM");
    const maxFee = Math.max(fee !== null && fee !== void 0 ? fee : row === null || row === void 0 ? void 0 : row.totalFee, previousRevenue !== null && previousRevenue !== void 0 ? previousRevenue : row === null || row === void 0 ? void 0 : row.getRevenueToDateInMonth((0, $4hBm1.format)((0, $4hBm1.subMonths)(month, 1), "yyyy-MM")));
    const prevRevenue = previousRevenue !== null && previousRevenue !== void 0 ? previousRevenue : row === null || row === void 0 ? void 0 : row.getRevenueToDateInMonth((0, $4hBm1.format)((0, $4hBm1.subMonths)(month, 1), "yyyy-MM"));
    const selectedRevenue = currentRevenue !== null && currentRevenue !== void 0 ? currentRevenue : row === null || row === void 0 ? void 0 : row.getRevenueInMonth((0, $4hBm1.format)(month, "yyyy-MM"));
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        style: {
            marginTop: "0.9em"
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: label !== null && label !== void 0 ? label : row === null || row === void 0 ? void 0 : row.label
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $dsTi9.default), {
                total: fee !== null && fee !== void 0 ? fee : row === null || row === void 0 ? void 0 : row.totalFee,
                maxAmount: maxFee,
                prevAmount: prevRevenue,
                amount: selectedRevenue,
                height: 4,
                editable: editable,
                onChange: onChange !== null && onChange !== void 0 ? onChange : (v)=>{
                    var _row$setRevenueInMont;
                    const monthId = (0, $4hBm1.format)(month, "yyyy-MM");
                    row === null || row === void 0 || (_row$setRevenueInMont = row.setRevenueInMonth) === null || _row$setRevenueInMont === void 0 || _row$setRevenueInMont.call(row, monthId, v);
                }
            })
        ]
    }, key !== null && key !== void 0 ? key : monthId + (row === null || row === void 0 ? void 0 : row.id));
});

});
parcelRegister("dsTi9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9cd8c7af0e45f320$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $1EEMt = parcelRequire("1EEMt");

var $gjxeM = parcelRequire("gjxeM");

var $ek5Pm = parcelRequire("ek5Pm");

var $9tNBb = parcelRequire("9tNBb");
var $9cd8c7af0e45f320$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ total: total, maxAmount: maxAmount, prevAmount: prevAmount, amount: amount, height: height = 4, editable: editable = true, onChange: onChange })=>{
    const maxProgress = maxAmount / (total || 1);
    const prevProgress = prevAmount / (total || 1);
    const currentProgress = (prevAmount + amount) / (total || 1);
    const [value, setValue] = (0, $jbmdS.useState)(currentProgress * 100);
    let progressGradient = {
        "0%": "#108ee9"
    };
    let finalColour = "#108ee9";
    progressGradient[`${Math.round(0.5 / currentProgress * 100)}%`] = "#87d068";
    if (currentProgress > 0.4) finalColour = "#87d068";
    if (currentProgress > 0.8) {
        progressGradient[`${Math.round(0.8 / currentProgress * 100)}%`] = "#ffc200";
        finalColour = "#ffc200";
    }
    if (currentProgress > 1) {
        progressGradient[`${Math.round(1 / currentProgress * 100)}%`] = "#ff5800";
        finalColour = "#ff5800";
    }
    const [sliderFocused, setSliderFocused] = (0, $jbmdS.useState)(false);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "sidebar-slider",
        children: [
            total ? /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    textAlign: "right",
                    margin: "0.9em 0 0"
                },
                children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    style: {
                        width: "18%",
                        marginLeft: "0.5em",
                        display: "inline-block",
                        float: "right",
                        marginTop: "-1.5em"
                    },
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ek5Pm.default).percent, {
                        disabled: !editable,
                        formatter: (v)=>(0, $gjxeM.FormatPercent)(v, {
                                decimals: 0
                            }),
                        value: currentProgress,
                        onChange: (v)=>{
                            if (v * 100 === Math.round(prevProgress * 100)) return onChange(0);
                            if (v * 100 === Math.round(maxProgress * 100)) return onChange(maxAmount - prevAmount);
                            return onChange(Math.max(v, prevProgress) * total - prevAmount);
                        },
                        style: {
                            textAlign: "right",
                            borderRadius: "0.5em",
                            border: "1px solid #ddd",
                            backgroundColor: "#f8f8f8",
                            boxShadow: "none",
                            padding: "0.1em 0.35em",
                            minHeight: "0",
                            lineHeight: "0"
                        }
                    })
                })
            }) : null,
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $9tNBb.Slider), {
                value: total ? [
                    currentProgress * 100
                ] : [],
                max: total ? Math.max(maxProgress, currentProgress) * 100 : 0,
                onValueChange: (v)=>{
                    if (!sliderFocused || !total) return;
                    if (v === Math.round(prevProgress * 100)) return onChange(0);
                    if (v === Math.round(maxProgress * 100)) return onChange(maxAmount - prevAmount);
                    return onChange(Math.max(v / 100, prevProgress) * total - prevAmount);
                },
                rangeStyle: {
                    background: total ? `linear-gradient(to right, ${Object.entries(progressGradient).map(([key, value])=>`${value} ${key}`).join(", ")})` : "#f5f5f5",
                    height: `${height}px`
                },
                thumbStyle: {
                    borderColor: finalColour
                },
                marks: total ? [
                    prevProgress * 100
                ] : [],
                disabled: !editable || !total,
                onFocus: ()=>setSliderFocused(true),
                onBlur: ()=>setSliderFocused(false)
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    textAlign: "right",
                    margin: "-0.25em 0 0"
                },
                children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    style: {
                        width: "32%",
                        marginLeft: "0.5em",
                        display: "inline-block",
                        textAlign: "left"
                    },
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            style: {
                                fontSize: "0.8em",
                                fontWeight: "bold",
                                paddingLeft: "0.5em"
                            },
                            children: "Revenue"
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ek5Pm.default).currency, {
                            disabled: !editable,
                            value: amount,
                            onChange: onChange,
                            style: {
                                border: "1px solid #ddd",
                                textAlign: "right",
                                borderRadius: "0.5em",
                                backgroundColor: "#f8f8f8",
                                boxShadow: "none",
                                padding: "0.1em 0.35em",
                                minHeight: "0",
                                lineHeight: "0"
                            }
                        })
                    ]
                })
            })
        ]
    });
});

});
parcelRegister("9tNBb", function(module, exports) {

$parcel$export(module.exports, "Slider", function () { return $6ac5b37b1372b9b0$export$472062a354075cee; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $bESZf = parcelRequire("bESZf");
const $6ac5b37b1372b9b0$export$472062a354075cee = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, rootStyle: rootStyle = {}, trackStyle: trackStyle = {}, rangeStyle: rangeStyle = {}, thumbStyle: thumbStyle = {}, markStyle: markStyle = {}, marks: marks = [], ...props }, ref)=>{
    // Define your styles here using rem units
    const _rootStyle = {
        position: "relative",
        display: "flex",
        width: "100%",
        touchAction: "none",
        userSelect: "none",
        alignItems: "center"
    };
    const _trackStyle = {
        position: "relative",
        height: "0.25rem",
        // Equivalent to h-1 in Tailwind
        width: "100%",
        flexGrow: 1,
        overflow: "hidden",
        borderRadius: "9999px",
        // Equivalent to rounded-full
        background: "rgba(0, 0, 0, 0.2)" // Replace with your primary color at 20% opacity
    };
    const _rangeStyle = {
        position: "absolute",
        height: "100%",
        background: "black" // Replace with your primary color
    };
    const _thumbStyle = {
        display: "block",
        height: "0.75rem",
        // Equivalent to h-3 in Tailwind
        width: "0.75rem",
        // Equivalent to w-3 in Tailwind
        borderRadius: "9999px",
        // Equivalent to rounded-full
        border: "0.2rem solid rgba(0, 0, 0, 0.5)",
        // Replace with your primary color at 50% opacity
        background: "white",
        // Replace with your background color
        boxShadow: "0 0 0.625rem rgba(0, 0, 0, 0.1)",
        transition: "color 0.2s",
        outline: "none",
        ringWidth: "0.2rem" // Equivalent to ring-1 in Tailwind
    };
    const _markStyle = (percentage)=>({
            position: "absolute",
            left: `${percentage}%`,
            top: "50%",
            transform: "translate(-50%, -50%)",
            width: "0.375rem",
            // Size of the mark
            height: "0.375rem",
            // Size of the mark
            borderRadius: "50%",
            // Circular mark
            backgroundColor: "black" // Mark color, replace as needed
        });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)($bESZf.Root, {
        ref: ref,
        style: {
            ..._rootStyle,
            ...rootStyle
        },
        ...props,
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)($bESZf.Track, {
                style: {
                    ..._trackStyle,
                    ...trackStyle
                },
                children: /*#__PURE__*/ (0, $61Ea1.jsx)($bESZf.Range, {
                    style: {
                        ..._rangeStyle,
                        ...rangeStyle
                    }
                })
            }),
            marks && marks.filter((m)=>m).map((mark)=>/*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                    style: {
                        ..._markStyle(mark / props.max * 100),
                        ...markStyle
                    }
                }, mark)),
            /*#__PURE__*/ (0, $61Ea1.jsx)($bESZf.Thumb, {
                style: {
                    ..._thumbStyle,
                    ...thumbStyle
                }
            })
        ]
    });
});
$6ac5b37b1372b9b0$export$472062a354075cee.displayName = $bESZf.Root.displayName;

});
parcelRegister("bESZf", function(module, exports) {

$parcel$export(module.exports, "Root", function () { return $e75a0ceb7cbdbdf3$export$be92b6f5f03c0fe9; });
$parcel$export(module.exports, "Track", function () { return $e75a0ceb7cbdbdf3$export$13921ac0cc260818; });
$parcel$export(module.exports, "Range", function () { return $e75a0ceb7cbdbdf3$export$9a58ef0d7ad3278c; });
$parcel$export(module.exports, "Thumb", function () { return $e75a0ceb7cbdbdf3$export$6521433ed15a34db; });

var $jbmdS = parcelRequire("jbmdS");

var $kMiXC = parcelRequire("kMiXC");

var $hFcKE = parcelRequire("hFcKE");

var $9sunj = parcelRequire("9sunj");

var $f4RZG = parcelRequire("f4RZG");

var $1sq0Q = parcelRequire("1sq0Q");

var $9czjk = parcelRequire("9czjk");

var $f4s2q = parcelRequire("f4s2q");

var $am0tV = parcelRequire("am0tV");

var $cihg9 = parcelRequire("cihg9");

var $g2eqD = parcelRequire("g2eqD");

var $4TLFw = parcelRequire("4TLFw");
"use client";
var $e75a0ceb7cbdbdf3$var$PAGE_KEYS = [
    "PageUp",
    "PageDown"
];
var $e75a0ceb7cbdbdf3$var$ARROW_KEYS = [
    "ArrowUp",
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight"
];
var $e75a0ceb7cbdbdf3$var$BACK_KEYS = {
    "from-left": [
        "Home",
        "PageDown",
        "ArrowDown",
        "ArrowLeft"
    ],
    "from-right": [
        "Home",
        "PageDown",
        "ArrowDown",
        "ArrowRight"
    ],
    "from-bottom": [
        "Home",
        "PageDown",
        "ArrowDown",
        "ArrowLeft"
    ],
    "from-top": [
        "Home",
        "PageDown",
        "ArrowUp",
        "ArrowLeft"
    ]
};
var $e75a0ceb7cbdbdf3$var$SLIDER_NAME = "Slider";
var [$e75a0ceb7cbdbdf3$var$Collection, $e75a0ceb7cbdbdf3$var$useCollection, $e75a0ceb7cbdbdf3$var$createCollectionScope] = (0, $g2eqD.createCollection)($e75a0ceb7cbdbdf3$var$SLIDER_NAME);
var [$e75a0ceb7cbdbdf3$var$createSliderContext, $e75a0ceb7cbdbdf3$export$ef72632d7b901f97] = (0, $f4RZG.createContextScope)($e75a0ceb7cbdbdf3$var$SLIDER_NAME, [
    $e75a0ceb7cbdbdf3$var$createCollectionScope
]);
var [$e75a0ceb7cbdbdf3$var$SliderProvider, $e75a0ceb7cbdbdf3$var$useSliderContext] = $e75a0ceb7cbdbdf3$var$createSliderContext($e75a0ceb7cbdbdf3$var$SLIDER_NAME);
var $e75a0ceb7cbdbdf3$export$472062a354075cee = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { name: name, min: min = 0, max: max = 100, step: step = 1, orientation: orientation = "horizontal", disabled: disabled = false, minStepsBetweenThumbs: minStepsBetweenThumbs = 0, defaultValue: defaultValue = [
        min
    ], value: value, onValueChange: onValueChange = ()=>{}, onValueCommit: onValueCommit = ()=>{}, inverted: inverted = false, form: form, ...sliderProps } = props;
    const thumbRefs = $jbmdS.useRef(/* @__PURE__ */ new Set());
    const valueIndexToChangeRef = $jbmdS.useRef(0);
    const isHorizontal = orientation === "horizontal";
    const SliderOrientation = isHorizontal ? $e75a0ceb7cbdbdf3$var$SliderHorizontal : $e75a0ceb7cbdbdf3$var$SliderVertical;
    const [values = [], setValues] = (0, $1sq0Q.useControllableState)({
        prop: value,
        defaultProp: defaultValue,
        onChange: (value2)=>{
            const thumbs = [
                ...thumbRefs.current
            ];
            thumbs[valueIndexToChangeRef.current]?.focus();
            onValueChange(value2);
        }
    });
    const valuesBeforeSlideStartRef = $jbmdS.useRef(values);
    function handleSlideStart(value2) {
        const closestIndex = $e75a0ceb7cbdbdf3$var$getClosestValueIndex(values, value2);
        updateValues(value2, closestIndex);
    }
    function handleSlideMove(value2) {
        updateValues(value2, valueIndexToChangeRef.current);
    }
    function handleSlideEnd() {
        const prevValue = valuesBeforeSlideStartRef.current[valueIndexToChangeRef.current];
        const nextValue = values[valueIndexToChangeRef.current];
        const hasChanged = nextValue !== prevValue;
        if (hasChanged) onValueCommit(values);
    }
    function updateValues(value2, atIndex, { commit: commit } = {
        commit: false
    }) {
        const decimalCount = $e75a0ceb7cbdbdf3$var$getDecimalCount(step);
        const snapToStep = $e75a0ceb7cbdbdf3$var$roundValue(Math.round((value2 - min) / step) * step + min, decimalCount);
        const nextValue = (0, $kMiXC.clamp)(snapToStep, [
            min,
            max
        ]);
        setValues((prevValues = [])=>{
            const nextValues = $e75a0ceb7cbdbdf3$var$getNextSortedValues(prevValues, nextValue, atIndex);
            if ($e75a0ceb7cbdbdf3$var$hasMinStepsBetweenValues(nextValues, minStepsBetweenThumbs * step)) {
                valueIndexToChangeRef.current = nextValues.indexOf(nextValue);
                const hasChanged = String(nextValues) !== String(prevValues);
                if (hasChanged && commit) onValueCommit(nextValues);
                return hasChanged ? nextValues : prevValues;
            } else return prevValues;
        });
    }
    return /* @__PURE__ */ (0, $4TLFw.jsx)($e75a0ceb7cbdbdf3$var$SliderProvider, {
        scope: props.__scopeSlider,
        name: name,
        disabled: disabled,
        min: min,
        max: max,
        valueIndexToChangeRef: valueIndexToChangeRef,
        thumbs: thumbRefs.current,
        values: values,
        orientation: orientation,
        form: form,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)($e75a0ceb7cbdbdf3$var$Collection.Provider, {
            scope: props.__scopeSlider,
            children: /* @__PURE__ */ (0, $4TLFw.jsx)($e75a0ceb7cbdbdf3$var$Collection.Slot, {
                scope: props.__scopeSlider,
                children: /* @__PURE__ */ (0, $4TLFw.jsx)(SliderOrientation, {
                    "aria-disabled": disabled,
                    "data-disabled": disabled ? "" : void 0,
                    ...sliderProps,
                    ref: forwardedRef,
                    onPointerDown: (0, $hFcKE.composeEventHandlers)(sliderProps.onPointerDown, ()=>{
                        if (!disabled) valuesBeforeSlideStartRef.current = values;
                    }),
                    min: min,
                    max: max,
                    inverted: inverted,
                    onSlideStart: disabled ? void 0 : handleSlideStart,
                    onSlideMove: disabled ? void 0 : handleSlideMove,
                    onSlideEnd: disabled ? void 0 : handleSlideEnd,
                    onHomeKeyDown: ()=>!disabled && updateValues(min, 0, {
                            commit: true
                        }),
                    onEndKeyDown: ()=>!disabled && updateValues(max, values.length - 1, {
                            commit: true
                        }),
                    onStepKeyDown: ({ event: event, direction: stepDirection })=>{
                        if (!disabled) {
                            const isPageKey = $e75a0ceb7cbdbdf3$var$PAGE_KEYS.includes(event.key);
                            const isSkipKey = isPageKey || event.shiftKey && $e75a0ceb7cbdbdf3$var$ARROW_KEYS.includes(event.key);
                            const multiplier = isSkipKey ? 10 : 1;
                            const atIndex = valueIndexToChangeRef.current;
                            const value2 = values[atIndex];
                            const stepInDirection = step * multiplier * stepDirection;
                            updateValues(value2 + stepInDirection, atIndex, {
                                commit: true
                            });
                        }
                    }
                })
            })
        })
    });
});
$e75a0ceb7cbdbdf3$export$472062a354075cee.displayName = $e75a0ceb7cbdbdf3$var$SLIDER_NAME;
var [$e75a0ceb7cbdbdf3$var$SliderOrientationProvider, $e75a0ceb7cbdbdf3$var$useSliderOrientationContext] = $e75a0ceb7cbdbdf3$var$createSliderContext($e75a0ceb7cbdbdf3$var$SLIDER_NAME, {
    startEdge: "left",
    endEdge: "right",
    size: "width",
    direction: 1
});
var $e75a0ceb7cbdbdf3$var$SliderHorizontal = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { min: min, max: max, dir: dir, inverted: inverted, onSlideStart: onSlideStart, onSlideMove: onSlideMove, onSlideEnd: onSlideEnd, onStepKeyDown: onStepKeyDown, ...sliderProps } = props;
    const [slider, setSlider] = $jbmdS.useState(null);
    const composedRefs = (0, $9sunj.useComposedRefs)(forwardedRef, (node)=>setSlider(node));
    const rectRef = $jbmdS.useRef();
    const direction = (0, $9czjk.useDirection)(dir);
    const isDirectionLTR = direction === "ltr";
    const isSlidingFromLeft = isDirectionLTR && !inverted || !isDirectionLTR && inverted;
    function getValueFromPointer(pointerPosition) {
        const rect = rectRef.current || slider.getBoundingClientRect();
        const input = [
            0,
            rect.width
        ];
        const output = isSlidingFromLeft ? [
            min,
            max
        ] : [
            max,
            min
        ];
        const value = $e75a0ceb7cbdbdf3$var$linearScale(input, output);
        rectRef.current = rect;
        return value(pointerPosition - rect.left);
    }
    return /* @__PURE__ */ (0, $4TLFw.jsx)($e75a0ceb7cbdbdf3$var$SliderOrientationProvider, {
        scope: props.__scopeSlider,
        startEdge: isSlidingFromLeft ? "left" : "right",
        endEdge: isSlidingFromLeft ? "right" : "left",
        direction: isSlidingFromLeft ? 1 : -1,
        size: "width",
        children: /* @__PURE__ */ (0, $4TLFw.jsx)($e75a0ceb7cbdbdf3$var$SliderImpl, {
            dir: direction,
            "data-orientation": "horizontal",
            ...sliderProps,
            ref: composedRefs,
            style: {
                ...sliderProps.style,
                ["--radix-slider-thumb-transform"]: "translateX(-50%)"
            },
            onSlideStart: (event)=>{
                const value = getValueFromPointer(event.clientX);
                onSlideStart?.(value);
            },
            onSlideMove: (event)=>{
                const value = getValueFromPointer(event.clientX);
                onSlideMove?.(value);
            },
            onSlideEnd: ()=>{
                rectRef.current = void 0;
                onSlideEnd?.();
            },
            onStepKeyDown: (event)=>{
                const slideDirection = isSlidingFromLeft ? "from-left" : "from-right";
                const isBackKey = $e75a0ceb7cbdbdf3$var$BACK_KEYS[slideDirection].includes(event.key);
                onStepKeyDown?.({
                    event: event,
                    direction: isBackKey ? -1 : 1
                });
            }
        })
    });
});
var $e75a0ceb7cbdbdf3$var$SliderVertical = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { min: min, max: max, inverted: inverted, onSlideStart: onSlideStart, onSlideMove: onSlideMove, onSlideEnd: onSlideEnd, onStepKeyDown: onStepKeyDown, ...sliderProps } = props;
    const sliderRef = $jbmdS.useRef(null);
    const ref = (0, $9sunj.useComposedRefs)(forwardedRef, sliderRef);
    const rectRef = $jbmdS.useRef();
    const isSlidingFromBottom = !inverted;
    function getValueFromPointer(pointerPosition) {
        const rect = rectRef.current || sliderRef.current.getBoundingClientRect();
        const input = [
            0,
            rect.height
        ];
        const output = isSlidingFromBottom ? [
            max,
            min
        ] : [
            min,
            max
        ];
        const value = $e75a0ceb7cbdbdf3$var$linearScale(input, output);
        rectRef.current = rect;
        return value(pointerPosition - rect.top);
    }
    return /* @__PURE__ */ (0, $4TLFw.jsx)($e75a0ceb7cbdbdf3$var$SliderOrientationProvider, {
        scope: props.__scopeSlider,
        startEdge: isSlidingFromBottom ? "bottom" : "top",
        endEdge: isSlidingFromBottom ? "top" : "bottom",
        size: "height",
        direction: isSlidingFromBottom ? 1 : -1,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)($e75a0ceb7cbdbdf3$var$SliderImpl, {
            "data-orientation": "vertical",
            ...sliderProps,
            ref: ref,
            style: {
                ...sliderProps.style,
                ["--radix-slider-thumb-transform"]: "translateY(50%)"
            },
            onSlideStart: (event)=>{
                const value = getValueFromPointer(event.clientY);
                onSlideStart?.(value);
            },
            onSlideMove: (event)=>{
                const value = getValueFromPointer(event.clientY);
                onSlideMove?.(value);
            },
            onSlideEnd: ()=>{
                rectRef.current = void 0;
                onSlideEnd?.();
            },
            onStepKeyDown: (event)=>{
                const slideDirection = isSlidingFromBottom ? "from-bottom" : "from-top";
                const isBackKey = $e75a0ceb7cbdbdf3$var$BACK_KEYS[slideDirection].includes(event.key);
                onStepKeyDown?.({
                    event: event,
                    direction: isBackKey ? -1 : 1
                });
            }
        })
    });
});
var $e75a0ceb7cbdbdf3$var$SliderImpl = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeSlider: __scopeSlider, onSlideStart: onSlideStart, onSlideMove: onSlideMove, onSlideEnd: onSlideEnd, onHomeKeyDown: onHomeKeyDown, onEndKeyDown: onEndKeyDown, onStepKeyDown: onStepKeyDown, ...sliderProps } = props;
    const context = $e75a0ceb7cbdbdf3$var$useSliderContext($e75a0ceb7cbdbdf3$var$SLIDER_NAME, __scopeSlider);
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).span, {
        ...sliderProps,
        ref: forwardedRef,
        onKeyDown: (0, $hFcKE.composeEventHandlers)(props.onKeyDown, (event)=>{
            if (event.key === "Home") {
                onHomeKeyDown(event);
                event.preventDefault();
            } else if (event.key === "End") {
                onEndKeyDown(event);
                event.preventDefault();
            } else if ($e75a0ceb7cbdbdf3$var$PAGE_KEYS.concat($e75a0ceb7cbdbdf3$var$ARROW_KEYS).includes(event.key)) {
                onStepKeyDown(event);
                event.preventDefault();
            }
        }),
        onPointerDown: (0, $hFcKE.composeEventHandlers)(props.onPointerDown, (event)=>{
            const target = event.target;
            target.setPointerCapture(event.pointerId);
            event.preventDefault();
            if (context.thumbs.has(target)) target.focus();
            else onSlideStart(event);
        }),
        onPointerMove: (0, $hFcKE.composeEventHandlers)(props.onPointerMove, (event)=>{
            const target = event.target;
            if (target.hasPointerCapture(event.pointerId)) onSlideMove(event);
        }),
        onPointerUp: (0, $hFcKE.composeEventHandlers)(props.onPointerUp, (event)=>{
            const target = event.target;
            if (target.hasPointerCapture(event.pointerId)) {
                target.releasePointerCapture(event.pointerId);
                onSlideEnd(event);
            }
        })
    });
});
var $e75a0ceb7cbdbdf3$var$TRACK_NAME = "SliderTrack";
var $e75a0ceb7cbdbdf3$export$105594979f116971 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeSlider: __scopeSlider, ...trackProps } = props;
    const context = $e75a0ceb7cbdbdf3$var$useSliderContext($e75a0ceb7cbdbdf3$var$TRACK_NAME, __scopeSlider);
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).span, {
        "data-disabled": context.disabled ? "" : void 0,
        "data-orientation": context.orientation,
        ...trackProps,
        ref: forwardedRef
    });
});
$e75a0ceb7cbdbdf3$export$105594979f116971.displayName = $e75a0ceb7cbdbdf3$var$TRACK_NAME;
var $e75a0ceb7cbdbdf3$var$RANGE_NAME = "SliderRange";
var $e75a0ceb7cbdbdf3$export$a5cf38a7a000fe77 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeSlider: __scopeSlider, ...rangeProps } = props;
    const context = $e75a0ceb7cbdbdf3$var$useSliderContext($e75a0ceb7cbdbdf3$var$RANGE_NAME, __scopeSlider);
    const orientation = $e75a0ceb7cbdbdf3$var$useSliderOrientationContext($e75a0ceb7cbdbdf3$var$RANGE_NAME, __scopeSlider);
    const ref = $jbmdS.useRef(null);
    const composedRefs = (0, $9sunj.useComposedRefs)(forwardedRef, ref);
    const valuesCount = context.values.length;
    const percentages = context.values.map((value)=>$e75a0ceb7cbdbdf3$var$convertValueToPercentage(value, context.min, context.max));
    const offsetStart = valuesCount > 1 ? Math.min(...percentages) : 0;
    const offsetEnd = 100 - Math.max(...percentages);
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).span, {
        "data-orientation": context.orientation,
        "data-disabled": context.disabled ? "" : void 0,
        ...rangeProps,
        ref: composedRefs,
        style: {
            ...props.style,
            [orientation.startEdge]: offsetStart + "%",
            [orientation.endEdge]: offsetEnd + "%"
        }
    });
});
$e75a0ceb7cbdbdf3$export$a5cf38a7a000fe77.displayName = $e75a0ceb7cbdbdf3$var$RANGE_NAME;
var $e75a0ceb7cbdbdf3$var$THUMB_NAME = "SliderThumb";
var $e75a0ceb7cbdbdf3$export$2c1b491743890dec = $jbmdS.forwardRef((props, forwardedRef)=>{
    const getItems = $e75a0ceb7cbdbdf3$var$useCollection(props.__scopeSlider);
    const [thumb, setThumb] = $jbmdS.useState(null);
    const composedRefs = (0, $9sunj.useComposedRefs)(forwardedRef, (node)=>setThumb(node));
    const index = $jbmdS.useMemo(()=>thumb ? getItems().findIndex((item)=>item.ref.current === thumb) : -1, [
        getItems,
        thumb
    ]);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($e75a0ceb7cbdbdf3$var$SliderThumbImpl, {
        ...props,
        ref: composedRefs,
        index: index
    });
});
var $e75a0ceb7cbdbdf3$var$SliderThumbImpl = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeSlider: __scopeSlider, index: index, name: name, ...thumbProps } = props;
    const context = $e75a0ceb7cbdbdf3$var$useSliderContext($e75a0ceb7cbdbdf3$var$THUMB_NAME, __scopeSlider);
    const orientation = $e75a0ceb7cbdbdf3$var$useSliderOrientationContext($e75a0ceb7cbdbdf3$var$THUMB_NAME, __scopeSlider);
    const [thumb, setThumb] = $jbmdS.useState(null);
    const composedRefs = (0, $9sunj.useComposedRefs)(forwardedRef, (node)=>setThumb(node));
    const isFormControl = thumb ? context.form || !!thumb.closest("form") : true;
    const size = (0, $am0tV.useSize)(thumb);
    const value = context.values[index];
    const percent = value === void 0 ? 0 : $e75a0ceb7cbdbdf3$var$convertValueToPercentage(value, context.min, context.max);
    const label = $e75a0ceb7cbdbdf3$var$getLabel(index, context.values.length);
    const orientationSize = size?.[orientation.size];
    const thumbInBoundsOffset = orientationSize ? $e75a0ceb7cbdbdf3$var$getThumbInBoundsOffset(orientationSize, percent, orientation.direction) : 0;
    $jbmdS.useEffect(()=>{
        if (thumb) {
            context.thumbs.add(thumb);
            return ()=>{
                context.thumbs.delete(thumb);
            };
        }
    }, [
        thumb,
        context.thumbs
    ]);
    return /* @__PURE__ */ (0, $4TLFw.jsxs)("span", {
        style: {
            transform: "var(--radix-slider-thumb-transform)",
            position: "absolute",
            [orientation.startEdge]: `calc(${percent}% + ${thumbInBoundsOffset}px)`
        },
        children: [
            /* @__PURE__ */ (0, $4TLFw.jsx)($e75a0ceb7cbdbdf3$var$Collection.ItemSlot, {
                scope: props.__scopeSlider,
                children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).span, {
                    role: "slider",
                    "aria-label": props["aria-label"] || label,
                    "aria-valuemin": context.min,
                    "aria-valuenow": value,
                    "aria-valuemax": context.max,
                    "aria-orientation": context.orientation,
                    "data-orientation": context.orientation,
                    "data-disabled": context.disabled ? "" : void 0,
                    tabIndex: context.disabled ? void 0 : 0,
                    ...thumbProps,
                    ref: composedRefs,
                    style: value === void 0 ? {
                        display: "none"
                    } : props.style,
                    onFocus: (0, $hFcKE.composeEventHandlers)(props.onFocus, ()=>{
                        context.valueIndexToChangeRef.current = index;
                    })
                })
            }),
            isFormControl && /* @__PURE__ */ (0, $4TLFw.jsx)($e75a0ceb7cbdbdf3$var$BubbleInput, {
                name: name ?? (context.name ? context.name + (context.values.length > 1 ? "[]" : "") : void 0),
                form: context.form,
                value: value
            }, index)
        ]
    });
});
$e75a0ceb7cbdbdf3$export$2c1b491743890dec.displayName = $e75a0ceb7cbdbdf3$var$THUMB_NAME;
var $e75a0ceb7cbdbdf3$var$BubbleInput = (props)=>{
    const { value: value, ...inputProps } = props;
    const ref = $jbmdS.useRef(null);
    const prevValue = (0, $f4s2q.usePrevious)(value);
    $jbmdS.useEffect(()=>{
        const input = ref.current;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, "value");
        const setValue = descriptor.set;
        if (prevValue !== value && setValue) {
            const event = new Event("input", {
                bubbles: true
            });
            setValue.call(input, value);
            input.dispatchEvent(event);
        }
    }, [
        prevValue,
        value
    ]);
    return /* @__PURE__ */ (0, $4TLFw.jsx)("input", {
        style: {
            display: "none"
        },
        ...inputProps,
        ref: ref,
        defaultValue: value
    });
};
function $e75a0ceb7cbdbdf3$var$getNextSortedValues(prevValues = [], nextValue, atIndex) {
    const nextValues = [
        ...prevValues
    ];
    nextValues[atIndex] = nextValue;
    return nextValues.sort((a, b)=>a - b);
}
function $e75a0ceb7cbdbdf3$var$convertValueToPercentage(value, min, max) {
    const maxSteps = max - min;
    const percentPerStep = 100 / maxSteps;
    const percentage = percentPerStep * (value - min);
    return (0, $kMiXC.clamp)(percentage, [
        0,
        100
    ]);
}
function $e75a0ceb7cbdbdf3$var$getLabel(index, totalValues) {
    if (totalValues > 2) return `Value ${index + 1} of ${totalValues}`;
    else if (totalValues === 2) return [
        "Minimum",
        "Maximum"
    ][index];
    else return void 0;
}
function $e75a0ceb7cbdbdf3$var$getClosestValueIndex(values, nextValue) {
    if (values.length === 1) return 0;
    const distances = values.map((value)=>Math.abs(value - nextValue));
    const closestDistance = Math.min(...distances);
    return distances.indexOf(closestDistance);
}
function $e75a0ceb7cbdbdf3$var$getThumbInBoundsOffset(width, left, direction) {
    const halfWidth = width / 2;
    const halfPercent = 50;
    const offset = $e75a0ceb7cbdbdf3$var$linearScale([
        0,
        halfPercent
    ], [
        0,
        halfWidth
    ]);
    return (halfWidth - offset(left) * direction) * direction;
}
function $e75a0ceb7cbdbdf3$var$getStepsBetweenValues(values) {
    return values.slice(0, -1).map((value, index)=>values[index + 1] - value);
}
function $e75a0ceb7cbdbdf3$var$hasMinStepsBetweenValues(values, minStepsBetweenValues) {
    if (minStepsBetweenValues > 0) {
        const stepsBetweenValues = $e75a0ceb7cbdbdf3$var$getStepsBetweenValues(values);
        const actualMinStepsBetweenValues = Math.min(...stepsBetweenValues);
        return actualMinStepsBetweenValues >= minStepsBetweenValues;
    }
    return true;
}
function $e75a0ceb7cbdbdf3$var$linearScale(input, output) {
    return (value)=>{
        if (input[0] === input[1] || output[0] === output[1]) return output[0];
        const ratio = (output[1] - output[0]) / (input[1] - input[0]);
        return output[0] + ratio * (value - input[0]);
    };
}
function $e75a0ceb7cbdbdf3$var$getDecimalCount(value) {
    return (String(value).split(".")[1] || "").length;
}
function $e75a0ceb7cbdbdf3$var$roundValue(value, decimalCount) {
    const rounder = Math.pow(10, decimalCount);
    return Math.round(value * rounder) / rounder;
}
var $e75a0ceb7cbdbdf3$export$be92b6f5f03c0fe9 = $e75a0ceb7cbdbdf3$export$472062a354075cee;
var $e75a0ceb7cbdbdf3$export$13921ac0cc260818 = $e75a0ceb7cbdbdf3$export$105594979f116971;
var $e75a0ceb7cbdbdf3$export$9a58ef0d7ad3278c = $e75a0ceb7cbdbdf3$export$a5cf38a7a000fe77;
var $e75a0ceb7cbdbdf3$export$6521433ed15a34db = $e75a0ceb7cbdbdf3$export$2c1b491743890dec;

});




parcelRegister("2tryL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1cd3aaf6a0da1de5$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("jbmdS");

var $1EEMt = parcelRequire("1EEMt");

var $4hBm1 = parcelRequire("4hBm1");

var $6lMyi = parcelRequire("6lMyi");
parcelRequire("eat5C");
var $1cd3aaf6a0da1de5$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ row: row, month: month, editable: editable, onChange: onChange, onTimeChange: onTimeChange, costBudget: costBudget, hoursBudget: hoursBudget, previousCost: previousCost, previousHours: previousHours, currentCost: currentCost, currentHours: currentHours, key: key, label: label })=>{
    var _hoursBudget, _ref;
    const monthId = (0, $4hBm1.format)(month, "yyyy-MM");
    const project = row === null || row === void 0 ? void 0 : row.project;
    const phase = row === null || row === void 0 ? void 0 : row.phase;
    // const revenueRow = getProjectPhaseRow(matchers, RevenueRowCollection)
    const maxCostBudget = Math.max(costBudget !== null && costBudget !== void 0 ? costBudget : row === null || row === void 0 ? void 0 : row.costBudget, previousCost !== null && previousCost !== void 0 ? previousCost : row === null || row === void 0 ? void 0 : row.getCostToDateInMonth((0, $4hBm1.format)((0, $4hBm1.subMonths)(month, 1), "yyyy-MM")));
    hoursBudget = (_hoursBudget = hoursBudget) !== null && _hoursBudget !== void 0 ? _hoursBudget : row === null || row === void 0 ? void 0 : row.hoursBudget;
    const prevTime = previousHours !== null && previousHours !== void 0 ? previousHours : row === null || row === void 0 ? void 0 : row.getHoursToDateInMonth((0, $4hBm1.format)((0, $4hBm1.subMonths)(month, 1), "yyyy-MM"));
    const selectedTime = currentHours !== null && currentHours !== void 0 ? currentHours : row === null || row === void 0 ? void 0 : row.getHoursInMonth((0, $4hBm1.format)(month, "yyyy-MM"));
    const prevCost = previousCost !== null && previousCost !== void 0 ? previousCost : row === null || row === void 0 ? void 0 : row.getCostToDateInMonth((0, $4hBm1.format)((0, $4hBm1.subMonths)(month, 1), "yyyy-MM"));
    const selectedCost = currentCost !== null && currentCost !== void 0 ? currentCost : row === null || row === void 0 ? void 0 : row.getCostInMonth((0, $4hBm1.format)(month, "yyyy-MM"));
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        style: {
            marginTop: "-0.25em"
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: (_ref = label !== null && label !== void 0 ? label : phase === null || phase === void 0 ? void 0 : phase.title) !== null && _ref !== void 0 ? _ref : project === null || project === void 0 ? void 0 : project.title
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6lMyi.default), {
                total: costBudget !== null && costBudget !== void 0 ? costBudget : row === null || row === void 0 ? void 0 : row.costBudget,
                maxAmount: maxCostBudget,
                prevAmount: prevCost,
                amount: selectedCost,
                prevTime: prevTime,
                time: selectedTime,
                totalTime: hoursBudget,
                height: 4,
                editable: editable,
                onChange: onChange || ((v)=>{
                    row === null || row === void 0 || row.setCostInMonth((0, $4hBm1.format)(month, "yyyy-MM"), v);
                }),
                onTimeChange: onTimeChange || ((v)=>{
                    row === null || row === void 0 || row.setHoursInMonth((0, $4hBm1.format)(month, "yyyy-MM"), v);
                })
            })
        ]
    }, key !== null && key !== void 0 ? key : monthId + (project === null || project === void 0 ? void 0 : project.id) + ((phase === null || phase === void 0 ? void 0 : phase.id) || ""));
});

});
parcelRegister("6lMyi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49fa5db0ab6a1087$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $1EEMt = parcelRequire("1EEMt");

var $9tNBb = parcelRequire("9tNBb");

var $gjxeM = parcelRequire("gjxeM");

var $ek5Pm = parcelRequire("ek5Pm");
var $49fa5db0ab6a1087$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ total: total, maxAmount: maxAmount, prevAmount: prevAmount, amount: amount, prevTime: prevTime, time: time, totalTime: totalTime, onTimeChange: onTimeChange, height: height = 4, onChange: onChange, editable: editable = true })=>{
    const maxProgress = maxAmount / (total || 1);
    const prevProgress = prevAmount / (total || 1);
    const currentProgress = (prevAmount + amount) / (total || 1);
    let progressGradient = {
        "0%": "#108ee9"
    };
    let finalColour = "#108ee9";
    progressGradient[`${Math.round(0.5 / currentProgress * 100)}%`] = "#87d068";
    if (currentProgress > 0.4) finalColour = "#87d068";
    if (currentProgress > 0.8) {
        progressGradient[`${Math.round(0.8 / currentProgress * 100)}%`] = "#ffc200";
        finalColour = "#ffc200";
    }
    if (currentProgress > 1) {
        progressGradient[`${Math.round(1 / currentProgress * 100)}%`] = "#ff5800";
        finalColour = "#ff5800";
    }
    const [sliderFocused, setSliderFocused] = (0, $jbmdS.useState)(false);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "sidebar-slider",
        children: [
            total ? /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    textAlign: "right",
                    margin: "0.9em 0 0"
                },
                children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    style: {
                        width: "18%",
                        marginLeft: "0.5em",
                        display: "inline-block",
                        float: "right",
                        marginTop: "-1.5em"
                    },
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ek5Pm.default).percent, {
                        disabled: !editable,
                        value: currentProgress,
                        onChange: (v)=>{
                            if (v * 100 === Math.round(prevProgress * 100)) return onChange(0);
                            if (v * 100 === Math.round(maxProgress * 100)) return onChange(maxAmount - prevAmount);
                            return onChange(Math.max(v, prevProgress) * total - prevAmount);
                        },
                        style: {
                            textAlign: "right",
                            borderRadius: "0.5em",
                            border: "1px solid #ddd",
                            backgroundColor: "#f8f8f8",
                            boxShadow: "none",
                            padding: "0.1em 0.35em",
                            minHeight: "0",
                            lineHeight: "0"
                        },
                        formatter: (v)=>(0, $gjxeM.FormatPercent)(v, {
                                decimals: 0
                            })
                    })
                })
            }) : null,
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $9tNBb.Slider), {
                value: total ? [
                    currentProgress * 100
                ] : [],
                max: total ? Math.max(maxProgress, currentProgress) * 100 : 0,
                onValueChange: (v)=>{
                    if (!sliderFocused || !total) return;
                    if (v === Math.round(prevProgress * 100)) return onChange(0);
                    if (v === Math.round(maxProgress * 100)) return onChange(maxAmount - prevAmount);
                    return onChange(Math.max(v / 100, prevProgress) * total - prevAmount);
                },
                rangeStyle: {
                    background: total ? `linear-gradient(to right, ${Object.entries(progressGradient).map(([key, value])=>`${value} ${key}`).join(", ")})` : "#f5f5f5",
                    height: `${height}px`
                },
                thumbStyle: {
                    borderColor: finalColour
                },
                marks: total ? [
                    prevProgress * 100
                ] : [],
                disabled: !editable || !total,
                onFocus: ()=>setSliderFocused(true),
                onBlur: ()=>setSliderFocused(false)
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    textAlign: "right",
                    margin: "-0.25em 0 0"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            width: "22%",
                            marginLeft: "0.5em",
                            display: "inline-block",
                            textAlign: "left"
                        },
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                style: {
                                    fontSize: "0.8em",
                                    fontWeight: "bold",
                                    paddingLeft: "0.5em"
                                },
                                children: "Hours"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ek5Pm.default).number, {
                                disabled: !editable,
                                value: time,
                                onChange: (v)=>onTimeChange(v),
                                style: {
                                    textAlign: "right",
                                    borderRadius: "0.5em",
                                    border: "1px solid #ddd",
                                    backgroundColor: "#f8f8f8",
                                    boxShadow: "none",
                                    padding: "0.1em 0.35em",
                                    minHeight: "0",
                                    lineHeight: "0",
                                    opacity: editable ? 1 : 0.5
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            width: "32%",
                            marginLeft: "0.5em",
                            display: "inline-block",
                            textAlign: "left"
                        },
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                style: {
                                    fontSize: "0.8em",
                                    fontWeight: "bold",
                                    paddingLeft: "0.5em"
                                },
                                children: "Expense"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ek5Pm.default).currency, {
                                disabled: !editable,
                                value: amount,
                                onChange: (v)=>onChange(v),
                                style: {
                                    textAlign: "right",
                                    borderRadius: "0.5em",
                                    border: "1px solid #ddd",
                                    backgroundColor: "#f8f8f8",
                                    boxShadow: "none",
                                    padding: "0.1em 0.35em",
                                    minHeight: "0",
                                    lineHeight: "0",
                                    opacity: editable ? 1 : 0.5
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
});

});


parcelRegister("ccJUd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e2a36ea6c34b48f$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("jbmdS");

var $1EEMt = parcelRequire("1EEMt");

var $4hBm1 = parcelRequire("4hBm1");

var $dI8V7 = parcelRequire("dI8V7");

var $htkeB = parcelRequire("htkeB");

var $bxXv3 = parcelRequire("bxXv3");
var $8e2a36ea6c34b48f$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ staffRow: staffRow, row: row, month: month, title: title, showOtherHours: showOtherHours = true, editable: editable, updateRevenue: updateRevenue, hoursData: hoursData = "actualsProjected", label: label, onChange: onChange, staff: staff, availability: availability, totalHours: totalHours, selectedHours: selectedHours, key: key })=>{
    var _staff, _ref, _staff2, _availability, _ref2, _ref3, _selectedHours, _onChange, _ref4, _ref5;
    const monthId = (0, $4hBm1.format)(month, "yyyy-MM");
    (_staff = staff) !== null && _staff !== void 0 ? _staff : staff = (0, $htkeB.default).staffById[(_ref = staffRow || row) === null || _ref === void 0 ? void 0 : _ref.staffId];
    const role = ((_staff2 = staff) === null || _staff2 === void 0 ? void 0 : _staff2.role) || (0, $bxXv3.default).rolesById[staffRow === null || staffRow === void 0 ? void 0 : staffRow.roleId];
    (_availability = availability) !== null && _availability !== void 0 ? _availability : availability = (_ref2 = staffRow || row) === null || _ref2 === void 0 ? void 0 : _ref2.getAvailabilityInMonth(monthId);
    const timeInMonth = totalHours !== null && totalHours !== void 0 ? totalHours : (_ref3 = showOtherHours ? staffRow : row) === null || _ref3 === void 0 ? void 0 : _ref3.getHoursInMonth(monthId);
    const maxHours = Math.max(availability, timeInMonth);
    (_selectedHours = selectedHours) !== null && _selectedHours !== void 0 ? _selectedHours : selectedHours = row === null || row === void 0 ? void 0 : row.getHoursInMonth(monthId);
    const otherHours = timeInMonth - selectedHours;
    (_onChange = onChange) !== null && _onChange !== void 0 ? _onChange : onChange = (v)=>{
        const prevHours = row === null || row === void 0 ? void 0 : row.getHoursInMonth(monthId);
        const diff = v - prevHours;
        row === null || row === void 0 || row.setHoursInMonth(monthId, v);
        if (staffRow && diff !== 0) staffRow.projectedHours[monthId] = (staffRow === null || staffRow === void 0 ? void 0 : staffRow.getHoursInMonth(monthId)) + diff;
    };
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        style: {
            marginTop: "-0.25em"
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: label || (row === null || row === void 0 ? void 0 : row.label) || (staffRow === null || staffRow === void 0 ? void 0 : staffRow.label)
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $dI8V7.default), {
                editable: editable,
                total: availability,
                maxAmount: maxHours,
                prevAmount: otherHours,
                amount: selectedHours,
                onChange: (v)=>onChange(v)
            })
        ]
    }, key !== null && key !== void 0 ? key : monthId + (((_ref4 = staffRow || row) === null || _ref4 === void 0 ? void 0 : _ref4.roleId) || "") + (((_ref5 = staffRow || row) === null || _ref5 === void 0 ? void 0 : _ref5.staffId) || ""));
});

});
parcelRegister("dI8V7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fb64dcdd7c1cc9d$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $1EEMt = parcelRequire("1EEMt");

var $9tNBb = parcelRequire("9tNBb");

var $gjxeM = parcelRequire("gjxeM");

var $ek5Pm = parcelRequire("ek5Pm");
var $9fb64dcdd7c1cc9d$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ total: total, maxAmount: maxAmount, prevAmount: prevAmount, amount: amount, onChange: onChange, height: height = 4, editable: editable = true })=>{
    const maxProgress = maxAmount / (total || 1);
    const prevProgress = prevAmount / (total || 1);
    const currentProgress = (prevAmount + amount) / (total || 1);
    let progressGradient = {
        "0%": "#108ee9"
    };
    let finalColour = "#108ee9";
    progressGradient[`${Math.round(0.5 / currentProgress * 100)}%`] = "#87d068";
    if (currentProgress > 0.4) finalColour = "#87d068";
    if (currentProgress > 0.8) {
        progressGradient[`${Math.round(0.8 / currentProgress * 100)}%`] = "#ffc200";
        finalColour = "#ffc200";
    }
    if (currentProgress > 1) {
        progressGradient[`${Math.round(1 / currentProgress * 100)}%`] = "#ff5800";
        finalColour = "#ff5800";
    }
    const [sliderFocused, setSliderFocused] = (0, $jbmdS.useState)(false);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "sidebar-slider",
        children: [
            total ? /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    textAlign: "right",
                    margin: "0.9em 0 0"
                },
                children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    style: {
                        width: "18%",
                        marginLeft: "0.5em",
                        display: "inline-block",
                        float: "right",
                        marginTop: "-1.5em"
                    },
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ek5Pm.default).percent, {
                        formatter: (v)=>(0, $gjxeM.FormatPercent)(v, {
                                decimals: 0
                            }),
                        disabled: !editable,
                        value: currentProgress,
                        onChange: (v)=>{
                            if (v * 100 === Math.round(prevProgress * 100)) return onChange(0);
                            if (v * 100 === Math.round(maxProgress * 100)) return onChange(maxAmount - prevAmount);
                            return onChange(Math.max(v, prevProgress) * total - prevAmount);
                        },
                        style: {
                            textAlign: "right",
                            borderRadius: "0.5em",
                            border: "1px solid #ddd",
                            backgroundColor: "#f8f8f8",
                            boxShadow: "none",
                            padding: "0.1em 0.35em",
                            minHeight: "0",
                            lineHeight: "0"
                        }
                    })
                })
            }) : null,
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $9tNBb.Slider), {
                value: total ? [
                    currentProgress * 100
                ] : [],
                max: total ? Math.max(maxProgress, currentProgress) * 100 : 0,
                onValueChange: (v)=>{
                    if (!sliderFocused) return;
                    if (v === Math.round(prevProgress * 100)) return onChange(0);
                    if (v === Math.round(maxProgress * 100)) return onChange(maxAmount - prevAmount);
                    return onChange(Math.max(v / 100, prevProgress) * total - prevAmount);
                },
                rangeStyle: {
                    background: total ? `linear-gradient(to right, ${Object.entries(progressGradient).map(([key, value])=>`${value} ${key}`).join(", ")})` : "#f5f5f5",
                    height: `${height}px`
                },
                thumbStyle: {
                    borderColor: finalColour
                },
                marks: total ? [
                    prevProgress * 100
                ] : [],
                disabled: !editable || !total,
                onFocus: ()=>setSliderFocused(true),
                onBlur: ()=>setSliderFocused(false)
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    textAlign: "right",
                    margin: "-0.25em 0 0"
                },
                children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    style: {
                        width: "22%",
                        marginLeft: "0.5em",
                        display: "inline-block",
                        textAlign: "left"
                    },
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            style: {
                                fontSize: "0.8em",
                                fontWeight: "bold",
                                paddingLeft: "0.5em"
                            },
                            children: "Hours"
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ek5Pm.default).number, {
                            disabled: !editable,
                            value: amount,
                            onChange: onChange,
                            style: {
                                textAlign: "right",
                                borderRadius: "0.5em",
                                border: "1px solid #ddd",
                                backgroundColor: "#f8f8f8",
                                boxShadow: "none",
                                padding: "0.1em 0.35em",
                                minHeight: "0",
                                lineHeight: "0"
                            }
                        })
                    ]
                })
            })
        ]
    });
});

});


parcelRegister("jCrfK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e486b4d4ba5fb362$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("jbmdS");

var $1EEMt = parcelRequire("1EEMt");

var $kqlQp = parcelRequire("kqlQp");
var $e486b4d4ba5fb362$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ title: title, subTitle: subTitle, link: link })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        style: {
            textAlign: "center",
            padding: "1em",
            borderBottom: "1px solid #ccc",
            flex: "0 0 auto"
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    fontSize: "1.2em",
                    fontWeight: "bold",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                        className: "flex-1 text-center",
                        children: title
                    }),
                    link && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqlQp.Link), {
                        to: link,
                        className: "ml-2",
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                            className: "fa fa-external-link text-gray-500",
                            style: {
                                cursor: "pointer"
                            }
                        })
                    })
                ]
            }),
            subTitle ? /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {},
                children: subTitle
            }) : null
        ]
    });
});

});

parcelRegister("bfcx4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82fad11b098a77cb$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("jbmdS");

var $1EEMt = parcelRequire("1EEMt");
var $82fad11b098a77cb$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ title: title, onLeftClick: onLeftClick, onRightClick: onRightClick })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "flex-1 overflow-y-auto border-b border-[#ccc] p-[0.5em] mb-[1em]",
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            className: "flex items-center justify-between",
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    style: {
                        cursor: "pointer",
                        padding: "0 1em"
                    },
                    onClick: ()=>onLeftClick(),
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                        className: "fa fa-chevron-left",
                        style: {
                            margin: 0
                        }
                    })
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                    style: {
                        fontWeight: "bold"
                    },
                    children: title
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    style: {
                        cursor: "pointer",
                        padding: "0 1em"
                    },
                    onClick: ()=>onRightClick(),
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                        className: "fa fa-chevron-right",
                        style: {
                            margin: 0
                        }
                    })
                })
            ]
        })
    });
});

});



parcelRegister("907iH", function(module, exports) {

$parcel$export(module.exports, "RevenueForecastReportStaffColumns", function () { return $68d9c6ea0e095e67$export$bda095381f634cc5; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("eat5C");
parcelRequire("jbmdS");

var $4hBm1 = parcelRequire("4hBm1");
parcelRequire("jE5CX");
parcelRequire("6un1H");

var $12o9H = parcelRequire("12o9H");
parcelRequire("gSTGk");

const $68d9c6ea0e095e67$var$cellStyles = (row, stores, monthStart, isPastMonth)=>{
    return {
        ...isPastMonth ? {
            backgroundImage: `url(${new URL((parcelRequire("3vc8e")))})`
        } : {}
    };
};
const $68d9c6ea0e095e67$export$bda095381f634cc5 = (store)=>({
        title: (monthStartDate)=>({
                id: "title",
                label: "Title",
                type: "text",
                width: 18,
                editable: (row)=>false,
                value: (row, stores)=>{
                    return row.fullName;
                },
                component: ({ value: value, group: group, stores: stores })=>{
                    const { row: row, table: table } = stores;
                    if (row.group === "totals") return "Total";
                    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        style: {
                            paddingLeft: `${1 * row.groupLevel}rem`
                        },
                        children: value
                    });
                }
            }),
        cost: (monthStartDate)=>{
            const monthStart = (0, $4hBm1.startOfMonth)(monthStartDate);
            const monthEnd = (0, $4hBm1.endOfMonth)(monthStart);
            const dayAfterMonthEnd = (0, $4hBm1.startOfMonth)((0, $4hBm1.addDays)(monthEnd, 1));
            const isPastMonth = monthEnd < (0, $4hBm1.startOfMonth)(new Date());
            return {
                label: (0, $4hBm1.format)(monthStartDate, "MMM yy"),
                type: "currency",
                width: 8,
                value: (row)=>{
                    var _store$report;
                    if (!isPastMonth && ((_store$report = store.report) === null || _store$report === void 0 ? void 0 : _store$report.filters.contractorExpense) === "availableHours" || row.staffType === "employee") return row.getAvailabilityInDateRange([
                        monthStart,
                        monthEnd
                    ]) / 60 / 5 * (0, $4hBm1.differenceInBusinessDays)(dayAfterMonthEnd, monthStart) * row.getRateInDateRange("pay", [
                        monthStart,
                        monthEnd
                    ]);
                    else {
                        var _store$getStaffData$t, _store$getStaffData$t2, _store$getStaffData$m, _store$getStaffData$m2;
                        const timeEntryHours = (_store$getStaffData$t = store.getStaffData().timeEntriesByMonth) === null || _store$getStaffData$t === void 0 ? void 0 : (_store$getStaffData$t2 = _store$getStaffData$t[row.id]) === null || _store$getStaffData$t2 === void 0 ? void 0 : _store$getStaffData$t2[(0, $4hBm1.format)(monthStartDate, "yyyy-MM")];
                        const monthlyAllocationHours = (_store$getStaffData$m = store.getStaffData().monthlyAllocationsByMonth) === null || _store$getStaffData$m === void 0 ? void 0 : (_store$getStaffData$m2 = _store$getStaffData$m[row.id]) === null || _store$getStaffData$m2 === void 0 ? void 0 : _store$getStaffData$m2[(0, $4hBm1.format)(monthStartDate, "yyyy-MM")];
                        const hours = isPastMonth ? timeEntryHours : monthlyAllocationHours;
                        return (hours || 0) * row.getRateInDateRange("pay", [
                            monthStart,
                            monthEnd
                        ]);
                    }
                },
                editable: ()=>false,
                style: (row, stores)=>{
                    return $68d9c6ea0e095e67$var$cellStyles(row, stores, monthStart, isPastMonth);
                },
                format: (v)=>(0, $12o9H.FormatCurrency)(v, {
                        decimals: 0
                    }),
                aggregate: "sum"
            };
        },
        total: (monthStartDate, store)=>{
            return {
                id: "total",
                label: /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                    children: [
                        "Total",
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                            style: {
                                fontSize: "1.5em",
                                float: "right"
                            },
                            onClick: (e)=>e.stopPropagation(),
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                    className: `fa fa-caret-left`,
                                    style: {
                                        cursor: "pointer"
                                    },
                                    onClick: ()=>store.shiftDates(-1)
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                    className: `fa fa-caret-right`,
                                    style: {
                                        marginRight: 0,
                                        cursor: "pointer"
                                    },
                                    onClick: ()=>store.shiftDates(1)
                                })
                            ]
                        })
                    ]
                }),
                type: "text",
                width: 18,
                editable: (row)=>false,
                value: (row)=>{
                    return "";
                }
            };
        }
    });

});

parcelRegister("6YofH", function(module, exports) {

$parcel$export(module.exports, "RevenueForecastReportOverheadColumns", function () { return $513b28ac7bbd2bdf$export$6c2213d571ffb32e; });

var $61Ea1 = parcelRequire("61Ea1");

var $eat5C = parcelRequire("eat5C");
parcelRequire("jbmdS");

var $4hBm1 = parcelRequire("4hBm1");

var $ikffN = parcelRequire("ikffN");

var $1UDCR = parcelRequire("1UDCR");

var $12o9H = parcelRequire("12o9H");

const $513b28ac7bbd2bdf$var$cellStyles = (row, stores, monthStart, isPastMonth)=>{
    return {
        ...isPastMonth ? {
            backgroundImage: `url(${new URL((parcelRequire("3vc8e")))})`
        } : {}
    };
};
const $513b28ac7bbd2bdf$export$6c2213d571ffb32e = (store)=>({
        title: (monthStartDate)=>({
                id: "title",
                label: "Title",
                type: "text",
                width: 18,
                editable: (row)=>false,
                value: (row, stores)=>{
                    return (0, $ikffN.capitalCase)(row);
                },
                component: ({ value: value, group: group, stores: stores })=>{
                    const { row: row, table: table } = stores;
                    if (row.group === "totals") return "Total";
                    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        style: {
                            paddingLeft: `${1 * row.groupLevel}rem`
                        },
                        children: value
                    });
                }
            }),
        cost: (monthStartDate)=>{
            const monthStart = (0, $4hBm1.startOfMonth)(monthStartDate);
            const monthEnd = (0, $4hBm1.endOfMonth)(monthStart);
            const dayAfterMonthEnd = (0, $4hBm1.addDays)(monthEnd, 1);
            const isPastMonth = monthEnd < (0, $4hBm1.startOfMonth)(new Date());
            return {
                label: (0, $4hBm1.format)(monthStartDate, "MMM yy"),
                type: "currency",
                width: 8,
                value: (row)=>{
                    const overheadsWithSameName = (0, $1UDCR.default).overheadExpenses.filter((o)=>o.name === row);
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(overheadsWithSameName.map((o)=>o.valueInDateRange(monthStart, monthEnd)));
                },
                // data: (row) => {
                //     return [...revenueCell.data(row)]
                // },
                editable: ()=>false,
                style: (row, stores)=>{
                    return $513b28ac7bbd2bdf$var$cellStyles(row, stores, monthStart, isPastMonth);
                },
                aggregate: "sum",
                format: (v)=>(0, $12o9H.FormatCurrency)(v, {
                        decimals: 0
                    })
            };
        },
        total: (monthStartDate, store)=>{
            return {
                id: "total",
                label: /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                    children: [
                        "Total",
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                            style: {
                                fontSize: "1.5em",
                                float: "right"
                            },
                            onClick: (e)=>e.stopPropagation(),
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                    className: `fa fa-caret-left`,
                                    style: {
                                        cursor: "pointer"
                                    },
                                    onClick: ()=>store.shiftDates(-1)
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                    className: `fa fa-caret-right`,
                                    style: {
                                        marginRight: 0,
                                        cursor: "pointer"
                                    },
                                    onClick: ()=>store.shiftDates(1)
                                })
                            ]
                        })
                    ]
                }),
                type: "text",
                width: 18,
                editable: (row)=>false,
                value: (row)=>{
                    return "";
                }
            };
        }
    });

});



parcelRegister("k4clm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9bdc186d8e1ac0a$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $eat5C = parcelRequire("eat5C");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $goLmS = parcelRequire("goLmS");

var $38zj9 = parcelRequire("38zj9");

var $hYUed = parcelRequire("hYUed");

var $6d1V1 = parcelRequire("6d1V1");

var $d8zxI = parcelRequire("d8zxI");

var $6RcUP = parcelRequire("6RcUP");

var $4iw5i = parcelRequire("4iw5i");

var $aOFHJ = parcelRequire("aOFHJ");

var $4hBm1 = parcelRequire("4hBm1");

var $6un1H = parcelRequire("6un1H");

var $bg3Nf = parcelRequire("bg3Nf");

var $907iH = parcelRequire("907iH");

var $6YofH = parcelRequire("6YofH");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $12o9H = parcelRequire("12o9H");

var $6Q5sp = parcelRequire("6Q5sp");

var $3erXY = parcelRequire("3erXY");

var $6fNfM = parcelRequire("6fNfM");
const $e9bdc186d8e1ac0a$var$statusOrder = [
    "active",
    "prospective",
    "onHold",
    "archived"
];
const $e9bdc186d8e1ac0a$var$useSize = (target)=>{
    const [size, setSize] = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useState();
    (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useLayoutEffect(()=>{
        setSize(target.current.getBoundingClientRect());
    }, [
        target
    ]);
    // Where the magic happens
    (0, $d8zxI.default)(target, (entry)=>setSize(entry.contentRect));
    return size;
};
const $e9bdc186d8e1ac0a$var$spacerColumn = {
    label: "",
    width: 3,
    type: "text",
    value: (r)=>"",
    onChange: (r)=>(v)=>null
};
const $e9bdc186d8e1ac0a$var$ProfitTable = (0, $1EEMt.observer)(({ store: store })=>{
    if (!(0, $8kZ1o.canViewRevenueForecastStaffExpenses)((0, $1BTI2.default).user) && !(0, $8kZ1o.canViewRevenueForecastOperationalExpenses)((0, $1BTI2.default).user)) return null;
    const profitRow = store.report.filters.profitDataType === "margin" ? "profitMargin" : "markup";
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
                style: {
                    margin: "2em 0 0 0"
                },
                columns: [
                    $e9bdc186d8e1ac0a$var$spacerColumn,
                    (0, $bg3Nf.RevenueForecastReportProfitColumns)(store).title(),
                    (0, $bg3Nf.RevenueForecastReportProfitColumns)(store).total(null, store),
                    ...[
                        ...Array(12)
                    ].map((v, i)=>{
                        return (0, $bg3Nf.RevenueForecastReportProfitColumns)(store).profit((0, $4hBm1.addMonths)(store.startDate, i), store);
                    })
                ],
                rows: [
                    "profit"
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
                columns: [
                    $e9bdc186d8e1ac0a$var$spacerColumn,
                    (0, $bg3Nf.RevenueForecastReportProfitColumns)(store).title(),
                    (0, $bg3Nf.RevenueForecastReportProfitColumns)(store).total(null, store),
                    ...[
                        ...Array(12)
                    ].map((v, i)=>{
                        return (0, $bg3Nf.RevenueForecastReportProfitColumns)(store)[profitRow]((0, $4hBm1.addMonths)(store.startDate, i), store);
                    })
                ],
                style: {
                    margin: "0 0 2em 0"
                },
                showHeader: false,
                rows: [
                    profitRow
                ]
            })
        ]
    });
});
const $e9bdc186d8e1ac0a$var$RevenueTableByStatus = (0, $1EEMt.observer)(({ store: store })=>{
    const phaseColumns = (0, $aOFHJ.RevenueForecastReportPhaseColumns)(store);
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
        tableStore: store.projectTableStore,
        style: {
            margin: "2em 0"
        },
        columns: [
            {
                id: "statusPosition",
                label: "",
                width: 3,
                visible: false,
                type: "number",
                value: (row)=>{
                    return $e9bdc186d8e1ac0a$var$statusOrder.indexOf(row.title) + 1;
                }
            },
            phaseColumns.title(null, {}, {}),
            phaseColumns.revenueVsFee(null, {}, {}),
            ...[
                ...Array(12)
            ].map((v, i)=>{
                return phaseColumns.revenue((0, $4hBm1.addMonths)(store.startDate, i), {}, {});
            })
        ],
        rows: [
            ...store.getRevenueRows(null)
        ].sort((a, b)=>$e9bdc186d8e1ac0a$var$statusOrder.indexOf(a.title) - $e9bdc186d8e1ac0a$var$statusOrder.indexOf(b.title)),
        showTotals: true,
        getChildComponent: (r)=>{
            return /*#__PURE__*/ (0, $61Ea1.jsx)($e9bdc186d8e1ac0a$var$RevenueTableByProject, {
                status: r.key,
                store: store
            });
        }
    });
});
const $e9bdc186d8e1ac0a$var$RevenueTableByProject = (0, $1EEMt.observer)(({ store: store, status: status })=>{
    const level = 1;
    const bgColor = 256 - level * 5;
    const bgShadow = bgColor - 10;
    const phaseColumns = (0, $aOFHJ.RevenueForecastReportPhaseColumns)(store, status);
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
        columns: [
            phaseColumns.title(null, {}, {}, {
                status: status
            }),
            phaseColumns.revenueVsFee(null, {}, {}, {
                status: status
            }),
            ...[
                ...Array(12)
            ].map((v, i)=>{
                return phaseColumns.revenue((0, $4hBm1.addMonths)(store.startDate, i), {}, {}, {
                    status: status
                });
            })
        ],
        rows: store.getRevenueRows(status).sort((a, b)=>{
            var _a$title, _a$title$localeCompar;
            return (_a$title = a.title) === null || _a$title === void 0 ? void 0 : (_a$title$localeCompar = _a$title.localeCompare) === null || _a$title$localeCompar === void 0 ? void 0 : _a$title$localeCompar.call(_a$title, b.title);
        }),
        showHeader: false,
        getChildComponent: (r)=>{
            return /*#__PURE__*/ (0, $61Ea1.jsx)($e9bdc186d8e1ac0a$var$RevenueTableByPhase, {
                status: status,
                projectId: r.key,
                store: store
            });
        },
        style: {
            boxShadow: "none",
            background: `linear-gradient(180deg, rgb(${bgShadow},${bgShadow},${bgShadow}) 1px, rgb(${bgColor},${bgColor},${bgColor}) 8px)`,
            fontSize: "1.2rem"
        },
        // onExpand={(row) =>
        //     store.expandRevenueRow(row.status, row.projectId)
        // }
        // onCollapse={(row) =>
        //     store.expandRevenueRow(row.status, row.projectId)
        // }
        sortBy: store.projectTableStore.sortBy
    });
});
const $e9bdc186d8e1ac0a$var$RevenueTableByPhase = (0, $1EEMt.observer)(({ store: store, status: status, projectId: projectId })=>{
    const level = 2;
    const bgColor = 256 - level * 5;
    const bgShadow = bgColor - 10;
    const phaseColumns = (0, $aOFHJ.RevenueForecastReportPhaseColumns)(store, [
        status,
        projectId
    ].join(","));
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
        columns: [
            $e9bdc186d8e1ac0a$var$spacerColumn,
            phaseColumns.title(null, {}, {}, {
                status: status,
                projectId: projectId
            }),
            phaseColumns.revenueVsFee(null, {}, {}, {
                status: status,
                projectId: projectId
            }),
            ...[
                ...Array(12)
            ].map((v, i)=>{
                return phaseColumns.revenue((0, $4hBm1.addMonths)(store.startDate, i), {}, {}, {
                    status: status,
                    projectId: projectId
                });
            }),
            {
                id: "startDate",
                type: "date",
                label: "Start Date",
                value: (ph)=>ph.startDate,
                visible: false
            }
        ],
        rows: store.getRevenueRows([
            status,
            projectId
        ].join(",")).sort((0, $6fNfM.default)),
        showHeader: false,
        style: {
            boxShadow: "none",
            background: `linear-gradient(180deg, rgb(${bgShadow},${bgShadow},${bgShadow}) 1px, rgb(${bgColor},${bgColor},${bgColor}) 8px)`,
            fontSize: "1.2rem"
        },
        sortBy: store.projectTableStore.sortBy
    });
});
const $e9bdc186d8e1ac0a$var$StaffCostTable = (0, $1EEMt.observer)(({ store: store })=>{
    if (!(0, $8kZ1o.canViewRevenueForecastStaffExpenses)((0, $1BTI2.default).user) || !(0, $8kZ1o.canViewStaffPayRate)((0, $1BTI2.default).user)) return null;
    const staffColumns = (0, $907iH.RevenueForecastReportStaffColumns)(store);
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
        tableStore: store.staffTableStore,
        style: {
            margin: "2em 0 0 0"
        },
        columns: [
            $e9bdc186d8e1ac0a$var$spacerColumn,
            staffColumns.title(),
            staffColumns.total(null, store),
            ...[
                ...Array(12)
            ].map((v, i)=>{
                return staffColumns.cost((0, $4hBm1.addMonths)(store.startDate, i), store);
            })
        ],
        showTotals: true,
        rows: store.getStaffRows(),
        sortBy: [
            [
                "title",
                "asc"
            ]
        ]
    });
});
const $e9bdc186d8e1ac0a$var$OverheadCostTable = (0, $1EEMt.observer)(({ store: store })=>{
    if (!(0, $8kZ1o.canViewRevenueForecastOperationalExpenses)((0, $1BTI2.default).user)) return null;
    const overheadColumns = (0, $6YofH.RevenueForecastReportOverheadColumns)(store);
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
        tableStore: store.expenseTableStore,
        style: {
            margin: "2em 0 0 0"
        },
        columns: [
            $e9bdc186d8e1ac0a$var$spacerColumn,
            overheadColumns.title(),
            overheadColumns.total(null, store),
            ...[
                ...Array(12)
            ].map((v, i)=>{
                return overheadColumns.cost((0, $4hBm1.addMonths)(store.startDate, i), store);
            })
        ],
        groupBy: [
            "title"
        ],
        sortBy: [
            [
                "title",
                "asc"
            ]
        ],
        showTotals: true,
        rows: store.getOverheadRows()
    });
});
var $e9bdc186d8e1ac0a$export$2e2bcd8739ae039 = (0, $1EEMt.observer)((params)=>{
    (0, $jbmdS.useEffect)(()=>{
        (0, $hYUed.default).setSearchParams(params);
    }, [
        params
    ]);
    // useEffect(() => {
    //     RevenueForecastStore.reset()
    //     RevenueRowCollection.clear()
    //     ResourceRowCollection.clear()
    //     DataStore.setAutosave(true)
    //     return () => DataStore.setAutosave(false)
    // }, [])
    if (!(0, $1BTI2.default).settings.autoUpdateRevenue.adjustOnLoad) return /*#__PURE__*/ (0, $61Ea1.jsx)($e9bdc186d8e1ac0a$var$ForecastPage, {});
    else {
        var _SessionStore$organis, _SessionStore$organis2, _SessionStore$organis3, _SessionStore$organis4, _SessionStore$organis5, _SessionStore$organis6, _SessionStore$organis7, _SessionStore$organis8, _SessionStore$organis9, _SessionStore$organis10, _SessionStore$organis11, _SessionStore$organis12;
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6RcUP.default), {
            queryIds: [
                {
                    id: "auto-adjust-revenue",
                    path: "/api/v1.5/auto-adjust-revenue",
                    method: "POST",
                    data: {
                        budgetType: ((_SessionStore$organis = (0, $1BTI2.default).organisation.settings) === null || _SessionStore$organis === void 0 ? void 0 : (_SessionStore$organis2 = _SessionStore$organis.autoUpdateRevenue) === null || _SessionStore$organis2 === void 0 ? void 0 : _SessionStore$organis2.budget) || "remaining",
                        startDateType: ((_SessionStore$organis3 = (0, $1BTI2.default).organisation.settings) === null || _SessionStore$organis3 === void 0 ? void 0 : (_SessionStore$organis4 = _SessionStore$organis3.autoUpdateRevenue) === null || _SessionStore$organis4 === void 0 ? void 0 : _SessionStore$organis4.start) || "now",
                        endDateType: ((_SessionStore$organis5 = (0, $1BTI2.default).organisation.settings) === null || _SessionStore$organis5 === void 0 ? void 0 : (_SessionStore$organis6 = _SessionStore$organis5.autoUpdateRevenue) === null || _SessionStore$organis6 === void 0 ? void 0 : _SessionStore$organis6.end) || "endDate"
                    },
                    nowTs: Date.now()
                },
                {
                    id: "auto-adjust-expenses",
                    path: "/api/v1.5/auto-adjust-expenses",
                    method: "POST",
                    data: {
                        budgetType: ((_SessionStore$organis7 = (0, $1BTI2.default).organisation.settings) === null || _SessionStore$organis7 === void 0 ? void 0 : (_SessionStore$organis8 = _SessionStore$organis7.autoUpdateRevenue) === null || _SessionStore$organis8 === void 0 ? void 0 : _SessionStore$organis8.budget) || "remaining",
                        startDateType: ((_SessionStore$organis9 = (0, $1BTI2.default).organisation.settings) === null || _SessionStore$organis9 === void 0 ? void 0 : (_SessionStore$organis10 = _SessionStore$organis9.autoUpdateRevenue) === null || _SessionStore$organis10 === void 0 ? void 0 : _SessionStore$organis10.start) || "now",
                        endDateType: ((_SessionStore$organis11 = (0, $1BTI2.default).organisation.settings) === null || _SessionStore$organis11 === void 0 ? void 0 : (_SessionStore$organis12 = _SessionStore$organis11.autoUpdateRevenue) === null || _SessionStore$organis12 === void 0 ? void 0 : _SessionStore$organis12.end) || "endDate"
                    },
                    nowTs: Date.now()
                }
            ],
            loading: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $4iw5i.default), {}),
            children: /*#__PURE__*/ (0, $61Ea1.jsx)($e9bdc186d8e1ac0a$var$ForecastPage, {})
        });
    }
});

const $e9bdc186d8e1ac0a$var$ForecastPage = (0, $1EEMt.observer)(()=>{
    var _store$projectTableSt, _SessionStore$user;
    const isPrinting = (0, $6d1V1.useMediaQuery)("print");
    const DataStore = (parcelRequire("fM2j4")).default;
    (0, $jbmdS.useEffect)(()=>{
        DataStore.setAutosave(true);
        return ()=>{
            DataStore.setAutosave(false);
        };
    }, []);
    const [store, setStore] = (0, $jbmdS.useState)((0, $hYUed.default));
    const target = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useRef(null);
    const size = $e9bdc186d8e1ac0a$var$useSize(target);
    const widthRatio = (size === null || size === void 0 ? void 0 : size.width) / ((store === null || store === void 0 ? void 0 : (_store$projectTableSt = store.projectTableStore) === null || _store$projectTableSt === void 0 ? void 0 : _store$projectTableSt.width) * 15);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        style: {
            padding: "0 2em",
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                ref: target,
                style: {
                    width: "100%",
                    display: "flex"
                }
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $6RcUP.default), {
                queryIds: [
                    {
                        id: `revenueTable` + store.report.queryKey,
                        baseURL: "https://server2.coincraft.co",
                        path: `/revenue-forecast/table`,
                        method: "POST",
                        staleTime: 1000,
                        cacheTime: 1000,
                        data: {
                            organisationId: (0, $1BTI2.default).organisationId,
                            userId: (_SessionStore$user = (0, $1BTI2.default).user) === null || _SessionStore$user === void 0 ? void 0 : _SessionStore$user.id,
                            filters: store.report.filters,
                            level: 0,
                            parentData: {},
                            dateRange: [
                                (0, $4hBm1.format)(store.startDate, "yyyy-MM-dd"),
                                (0, $4hBm1.format)(store.endDate, "yyyy-MM-dd")
                            ]
                        }
                    },
                    {
                        id: "staff-cost" + store.report.queryKey,
                        queryFn: store.staffRowQuery
                    },
                    {
                        id: "overhead-cost" + store.report.queryKey,
                        queryFn: store.overheadRowQuery
                    }
                ],
                loading: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $4iw5i.default), {}),
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3erXY.default), {
                        report: store.report
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)($e9bdc186d8e1ac0a$var$RevenueForecasts, {
                        store: store,
                        widthRatio: widthRatio,
                        isPrinting: isPrinting
                    })
                ]
            })
        ]
    });
});
const $e9bdc186d8e1ac0a$var$ForecastChart = (0, $1EEMt.observer)(({ store: store, widthRatio: widthRatio, isPrinting: isPrinting })=>{
    var _FetchStore$getRespon, _FetchStore$getRespon2, _FetchStore$getRespon3, _FetchStore$getRespon4;
    const months = [
        ...Array(12)
    ].map((v, i)=>(0, $4hBm1.addMonths)(store.startDate, i));
    const staffQueryResults = (0, $8kZ1o.canViewRevenueForecastStaffExpenses)((0, $1BTI2.default).user) && ((_FetchStore$getRespon = (0, $6un1H.default).getResponse(store.makeQueryKey("staff-cost"))) === null || _FetchStore$getRespon === void 0 ? void 0 : (_FetchStore$getRespon2 = _FetchStore$getRespon.staff) === null || _FetchStore$getRespon2 === void 0 ? void 0 : _FetchStore$getRespon2.staff) || [];
    const overheadQueryResults = ((0, $8kZ1o.canViewRevenueForecastOperationalExpenses)((0, $1BTI2.default).user) && ((_FetchStore$getRespon3 = (0, $6un1H.default).getResponse(store.makeQueryKey("overhead-cost"))) === null || _FetchStore$getRespon3 === void 0 ? void 0 : (_FetchStore$getRespon4 = _FetchStore$getRespon3.overheadExpenses) === null || _FetchStore$getRespon4 === void 0 ? void 0 : _FetchStore$getRespon4.overheadExpenses) || []).map((e)=>e.name);
    const staffCells = months.map((m, i)=>(0, $907iH.RevenueForecastReportStaffColumns)(store).cost(m, store));
    const overheadCells = months.map((m, i)=>(0, $6YofH.RevenueForecastReportOverheadColumns)(store).cost(m, store));
    const revenue = months.map((m)=>{
        return store.getRevenueInMonth("", (0, $4hBm1.format)(m, "yyyy-MM"), null) || 0;
    });
    const prospectiveRevenue = months.map((m)=>{
        return store.getProspectiveRevenueInMonth("", (0, $4hBm1.format)(m, "yyyy-MM")) || 0;
    });
    const expenses = staffCells.map((sc, i)=>{
        return (!(0, $8kZ1o.canViewRevenueForecastStaffExpenses)((0, $1BTI2.default).user) || !(0, $8kZ1o.canViewStaffPayRate)((0, $1BTI2.default).user) ? 0 : (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(staffQueryResults.map((st)=>{
            return sc.value(st);
        }))) + (!(0, $8kZ1o.canViewRevenueForecastOperationalExpenses)((0, $1BTI2.default).user) ? 0 : (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum([
            ...new Set(overheadQueryResults)
        ].map((oh)=>{
            return overheadCells[i].value(oh);
        })));
    });
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $38zj9.default), {
        revenue: revenue,
        expenses: expenses,
        prospectiveRevenue: prospectiveRevenue,
        totalWidth: 1310,
        graphWidth: 880,
        height: 220,
        sizeRatio: isPrinting ? widthRatio : 1,
        formatter: (n)=>(0, $12o9H.FormatCurrency)(n, {
                decimals: 0,
                compact: true
            })
    });
});
const $e9bdc186d8e1ac0a$var$RevenueForecasts = (0, $1EEMt.observer)(({ store: store, widthRatio: widthRatio, isPrinting: isPrinting })=>{
    var _queryClient$getQuery;
    const queryData = (_queryClient$getQuery = (0, $6Q5sp.queryClient).getQueryData([
        `revenueTable` + store.report.queryKey
    ])) === null || _queryClient$getQuery === void 0 ? void 0 : _queryClient$getQuery.data;
    (0, $jbmdS.useEffect)(()=>{
        store.init(queryData);
    }, [
        store.report.queryKey,
        queryData
    ]);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)($e9bdc186d8e1ac0a$var$ForecastChart, {
                store: store,
                widthRatio: widthRatio,
                isPrinting: isPrinting
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)($e9bdc186d8e1ac0a$var$ProfitTable, {
                store: store
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)($e9bdc186d8e1ac0a$var$RevenueTableByStatus, {
                store: store
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)($e9bdc186d8e1ac0a$var$StaffCostTable, {
                store: store
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)($e9bdc186d8e1ac0a$var$OverheadCostTable, {
                store: store
            })
        ]
    });
});

});
parcelRegister("38zj9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $248d81d800379103$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $eat5C = parcelRequire("eat5C");
parcelRequire("gN0TC");

var $h1mzP = parcelRequire("h1mzP");

var $hVjuY = parcelRequire("hVjuY");

var $cwjKY = parcelRequire("cwjKY");
var $248d81d800379103$export$2e2bcd8739ae039 = ({ revenue: revenue, expenses: expenses, prospectiveRevenue: prospectiveRevenue, prospectiveExpenses: prospectiveExpenses, graphWidth: graphWidth, totalWidth: totalWidth, height: height, padding: padding = 12, sizeRatio: sizeRatio = 1, formatter: formatter = (n)=>(0, $cwjKY.FormatNumber)(n, {
        decimals: 2,
        compact: true
    }), ...props })=>{
    revenue = revenue.map((v)=>v || 0);
    expenses = expenses.map((v)=>v || 0);
    graphWidth = graphWidth * sizeRatio || 0;
    totalWidth = totalWidth * sizeRatio || 0;
    height = height * sizeRatio || 0;
    padding = padding * sizeRatio || 0;
    const widthStep = graphWidth / (revenue.length - 1) || 0;
    const graphStart = totalWidth - graphWidth || 0;
    const maxVal = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).max([
        ...revenue,
        ...expenses,
        // add revenue to expenses if revenue is negative
        ...expenses.map((v, i)=>v - revenue[i])
    ]);
    const scale = (0, $hVjuY.niceScale)([
        0,
        maxVal || 1000
    ], 5);
    const maxScale = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).max(scale) || 1000;
    const revenuePoints = revenue.map((v, i)=>({
            X: graphStart + widthStep * i || 0,
            Y: height - Math.max(v, 0) / maxScale * height + padding || 0
        }));
    const expensePoints = expenses.map((v, i)=>{
        // add revenue to expenses if revenue is negative
        v -= revenue[i] < 0 ? revenue[i] : 0;
        return {
            X: graphStart + widthStep * i || 0,
            Y: height - Math.max(v, 0) / maxScale * height + padding || 0
        };
    });
    const prospectiveRevenuePoints = prospectiveRevenue && revenue.map((v, i)=>({
            X: graphStart + widthStep * i || 0,
            Y: height - Math.max(v - prospectiveRevenue[i], 0) / maxScale * height + padding || 0
        }));
    const prospectiveExpensePoints = prospectiveExpenses && expenses.map((activeExpenseValueAtIndex, i)=>{
        const currentProspectiveExpense = prospectiveExpenses[i] || 0;
        let totalCombinedExpense = activeExpenseValueAtIndex + currentProspectiveExpense;
        // Apply the same "add revenue to expenses if revenue is negative" logic to the total combined expense
        // revenue[i] is the original revenue value for this index from the props, already mapped with || 0
        totalCombinedExpense -= revenue[i] < 0 ? revenue[i] : 0;
        return {
            X: graphStart + widthStep * i || 0,
            Y: height - Math.max(totalCombinedExpense, 0) / maxScale * height + padding || 0
        };
    });
    const revenueFillPoints = [
        {
            X: graphStart || 0,
            Y: height + padding || 0
        },
        ...revenuePoints,
        {
            X: totalWidth || 0,
            Y: height + padding || 0
        }
    ];
    const expenseFillPoints = [
        {
            X: graphStart || 0,
            Y: height + padding || 0
        },
        ...expensePoints,
        {
            X: totalWidth || 0,
            Y: height + padding || 0
        }
    ];
    const prospectiveExpenseFillPoints = prospectiveExpenses && [
        {
            X: graphStart || 0,
            Y: height + padding || 0
        },
        ...prospectiveExpensePoints,
        {
            X: totalWidth || 0,
            Y: height + padding || 0
        }
    ];
    const prospectiveRevenueFillPoints = prospectiveRevenue && [
        {
            X: graphStart || 0,
            Y: height + padding || 0
        },
        ...prospectiveRevenuePoints,
        {
            X: totalWidth || 0,
            Y: height + padding || 0
        }
    ];
    const revenueShape = new (0, (/*@__PURE__*/$parcel$interopDefault($h1mzP)))([
        revenueFillPoints
    ], true);
    const expenseShape = new (0, (/*@__PURE__*/$parcel$interopDefault($h1mzP)))([
        expenseFillPoints
    ], true);
    const prospectiveRevenueShape = prospectiveRevenue && new (0, (/*@__PURE__*/$parcel$interopDefault($h1mzP)))([
        prospectiveRevenueFillPoints
    ], true);
    const prospectiveExpenseShape = prospectiveExpenses && new (0, (/*@__PURE__*/$parcel$interopDefault($h1mzP)))([
        prospectiveExpenseFillPoints
    ], true);
    // Determine if prospective expenses are provided and valid
    const hasProspectiveExpenses = !!(prospectiveExpenses && prospectiveExpensePoints && prospectiveExpenseShape);
    // Main fills (grey, red) should be based on total expenses if available, otherwise active expenses.
    const displayTotalExpenseShape = hasProspectiveExpenses ? prospectiveExpenseShape : expenseShape;
    const grey = revenueShape.intersect(displayTotalExpenseShape);
    const gold = revenueShape.difference(displayTotalExpenseShape); // gold should also be vs total
    const red = displayTotalExpenseShape.difference(revenueShape);
    // whiteGrey is the area between total (prospectiveExpenseShape) and active (expenseShape)
    // This is only relevant if hasProspectiveExpenses is true.
    const whiteGrey = hasProspectiveExpenses ? prospectiveExpenseShape.difference(expenseShape) : null;
    const whiteGold = prospectiveRevenue && revenueShape.difference(prospectiveRevenueShape);
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        style: {
            textAlign: "right"
        },
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("svg", {
            // ref={target}
            style: {
                width: totalWidth + padding * 2,
                height: height + padding * 2,
                display: "inline-block",
                ...props.style
            },
            children: [
                scale// .filter((s) => s)
                .map((s, i)=>{
                    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).Fragment, {
                        children: [
                            s ? /*#__PURE__*/ (0, $61Ea1.jsx)("text", {
                                x: graphStart - padding * 9,
                                y: height - s / maxScale * height + 4 + padding,
                                textAnchor: "end",
                                style: {
                                    fill: "#444",
                                    opacity: 0.8,
                                    fontSize: `${sizeRatio}em`
                                },
                                children: formatter(s)
                            }) : null,
                            /*#__PURE__*/ (0, $61Ea1.jsx)("line", {
                                x1: graphStart - padding * 8,
                                x2: totalWidth + padding * 2,
                                y1: height - s / maxScale * height + padding,
                                y2: height - s / maxScale * height + padding,
                                style: {
                                    stroke: "#444",
                                    strokeWidth: 0.5,
                                    opacity: 0.6
                                }
                            })
                        ]
                    }, "y" + i);
                }),
                grey.paths.map((path, i)=>{
                    return /*#__PURE__*/ (0, $61Ea1.jsx)("polygon", {
                        points: path.map((coord)=>`${coord.X},${coord.Y}`).join(" "),
                        style: {
                            fill: "#444",
                            opacity: 0.8
                        }
                    }, "grey-path" + i);
                }),
                gold.paths.map((path, i)=>{
                    return /*#__PURE__*/ (0, $61Ea1.jsx)("polygon", {
                        points: path.map((coord)=>`${coord.X},${coord.Y}`).join(" "),
                        style: {
                            fill: "#ffca01",
                            opacity: 0.8
                        }
                    }, "gold-path" + i);
                }),
                red.paths.map((path, i)=>{
                    return /*#__PURE__*/ (0, $61Ea1.jsx)("polygon", {
                        points: path.map((coord)=>`${coord.X},${coord.Y}`).join(" "),
                        style: {
                            fill: "#f15a29",
                            opacity: 0.8
                        }
                    }, "red-path" + i);
                }),
                whiteGold ? whiteGold.paths.map((path, i)=>{
                    return /*#__PURE__*/ (0, $61Ea1.jsx)("polygon", {
                        points: path.map((coord)=>`${coord.X},${coord.Y}`).join(" "),
                        style: {
                            fill: "white",
                            opacity: 0.25
                        }
                    }, "white-gold-path" + i);
                }) : null,
                whiteGrey ? whiteGrey.paths.map((path, i)=>{
                    return /*#__PURE__*/ (0, $61Ea1.jsx)("polygon", {
                        points: path.map((coord)=>`${coord.X},${coord.Y}`).join(" "),
                        style: {
                            fill: "white",
                            opacity: 0.25
                        }
                    }, "white-grey-path" + i);
                }) : null,
                hasProspectiveExpenses && expensePoints ? /*#__PURE__*/ (0, $61Ea1.jsx)("polyline", {
                    points: expensePoints // Use active-only expense data
                    .map((coord)=>`${coord.X},${coord.Y}`).join(" "),
                    style: {
                        fill: "none",
                        stroke: "#444",
                        strokeWidth: 1 * sizeRatio,
                        opacity: 0.5
                    }
                }, "prospective-expense" // Keep key for consistency, though it now shows active
                ) : null,
                prospectiveRevenuePoints ? /*#__PURE__*/ (0, $61Ea1.jsx)("polyline", {
                    points: prospectiveRevenuePoints.map((coord)=>`${coord.X},${coord.Y}`).join(" "),
                    style: {
                        fill: "none",
                        stroke: "#ffca01",
                        strokeWidth: 1 * sizeRatio,
                        opacity: 0.5
                    }
                }, "prospective-revenue") : null,
                /*#__PURE__*/ (0, $61Ea1.jsx)("polyline", {
                    points: (hasProspectiveExpenses ? prospectiveExpensePoints : expensePoints).map((coord)=>`${coord.X},${coord.Y}`).join(" "),
                    style: {
                        fill: "none",
                        stroke: "#444",
                        strokeWidth: 2.5 * sizeRatio,
                        opacity: 1
                    }
                }, "expense"),
                /*#__PURE__*/ (0, $61Ea1.jsx)("polyline", {
                    points: revenuePoints.map((coord)=>`${coord.X},${coord.Y}`).join(" "),
                    style: {
                        fill: "none",
                        stroke: "#ffca01",
                        strokeWidth: 2.5 * sizeRatio,
                        opacity: 1
                    }
                }, "revenue"),
                hasProspectiveExpenses && expensePoints ? expensePoints.map((coord, i)=>{
                    return /*#__PURE__*/ (0, $61Ea1.jsx)("circle", {
                        cx: coord.X,
                        cy: coord.Y,
                        r: 4 * sizeRatio,
                        style: {
                            fill: "#444",
                            // Consistent fill for active-only points
                            opacity: 1
                        }
                    }, "exp-circle" + i);
                }) : null,
                prospectiveRevenuePoints ? prospectiveRevenuePoints.map((coord, i)=>{
                    return /*#__PURE__*/ (0, $61Ea1.jsx)("circle", {
                        cx: coord.X,
                        cy: coord.Y,
                        r: 3 * sizeRatio,
                        style: {
                            fill: "#ffca01",
                            opacity: 1
                        }
                    }, "rev-circle" + i);
                }) : null,
                (hasProspectiveExpenses ? prospectiveExpensePoints : expensePoints).map((coord, i)=>{
                    // Determine fill based on comparison with revenue line
                    const revenueY = revenuePoints[i] ? revenuePoints[i].Y : coord.Y + 1; // Default to not red if no revenue point
                    return /*#__PURE__*/ (0, $61Ea1.jsx)("circle", {
                        cx: coord.X,
                        cy: coord.Y,
                        r: 7 * sizeRatio,
                        style: {
                            fill: coord.Y < revenueY ? "#f15a29" : "#444",
                            stroke: "white",
                            strokeWidth: 2.5 * sizeRatio,
                            opacity: 1
                        }
                    }, "exp-p" + i);
                }),
                revenuePoints.map((coord, i)=>{
                    return /*#__PURE__*/ (0, $61Ea1.jsx)("circle", {
                        cx: coord.X,
                        cy: coord.Y,
                        r: 7 * sizeRatio,
                        style: {
                            fill: "#ffca01",
                            stroke: "white",
                            strokeWidth: 2.5 * sizeRatio,
                            opacity: 1
                        }
                    }, "rev-p" + i);
                })
            ]
        }, "cashflowchart")
    });
};

});
parcelRegister("h1mzP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setErrorCallback = undefined;
var $c6440af92f3e9df1$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $iV6qj = parcelRequire("iV6qj");
var $c6440af92f3e9df1$var$_clipper2 = $c6440af92f3e9df1$var$_interopRequireDefault($iV6qj);
function $c6440af92f3e9df1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c6440af92f3e9df1$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
function $c6440af92f3e9df1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $c6440af92f3e9df1$var$errorCallback = void 0;
var $c6440af92f3e9df1$var$setErrorCallback = module.exports.setErrorCallback = function setErrorCallback(callback) {
    $c6440af92f3e9df1$var$errorCallback = callback;
};
$c6440af92f3e9df1$var$_clipper2.default.Error = function(message) {
    if ($c6440af92f3e9df1$var$errorCallback) $c6440af92f3e9df1$var$errorCallback(message);
};
var $c6440af92f3e9df1$var$CLIPPER = new $c6440af92f3e9df1$var$_clipper2.default.Clipper();
var $c6440af92f3e9df1$var$CLIPPER_OFFSET = new $c6440af92f3e9df1$var$_clipper2.default.ClipperOffset();
var $c6440af92f3e9df1$var$Shape = function() {
    function Shape() {
        var paths = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var closed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        var capitalConversion = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var integerConversion = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        var removeDuplicates = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
        $c6440af92f3e9df1$var$_classCallCheck(this, Shape);
        this.paths = paths;
        if (capitalConversion) this.paths = this.paths.map($c6440af92f3e9df1$var$mapLowerToCapital);
        if (integerConversion) this.paths = this.paths.map($c6440af92f3e9df1$var$mapToRound);
        if (removeDuplicates) this.paths = this.paths.map($c6440af92f3e9df1$var$filterPathsDuplicates);
        this.closed = closed;
    }
    $c6440af92f3e9df1$var$_createClass(Shape, [
        {
            key: "_clip",
            value: function _clip(type) {
                var solution = new $c6440af92f3e9df1$var$_clipper2.default.PolyTree();
                $c6440af92f3e9df1$var$CLIPPER.Clear();
                $c6440af92f3e9df1$var$CLIPPER.AddPaths(this.paths, $c6440af92f3e9df1$var$_clipper2.default.PolyType.ptSubject, this.closed);
                for(var _len = arguments.length, clipShapes = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)clipShapes[_key - 1] = arguments[_key];
                for(var i = 0; i < clipShapes.length; i++){
                    var clipShape = clipShapes[i];
                    $c6440af92f3e9df1$var$CLIPPER.AddPaths(clipShape.paths, $c6440af92f3e9df1$var$_clipper2.default.PolyType.ptClip, clipShape.closed);
                }
                $c6440af92f3e9df1$var$CLIPPER.Execute(type, solution);
                var newShape = $c6440af92f3e9df1$var$_clipper2.default.Clipper.PolyTreeToPaths(solution);
                return new Shape(newShape, this.closed);
            }
        },
        {
            key: "union",
            value: function union() {
                for(var _len2 = arguments.length, clipShapes = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)clipShapes[_key2] = arguments[_key2];
                return this._clip.apply(this, [
                    $c6440af92f3e9df1$var$_clipper2.default.ClipType.ctUnion
                ].concat(clipShapes));
            }
        },
        {
            key: "difference",
            value: function difference() {
                for(var _len3 = arguments.length, clipShapes = Array(_len3), _key3 = 0; _key3 < _len3; _key3++)clipShapes[_key3] = arguments[_key3];
                return this._clip.apply(this, [
                    $c6440af92f3e9df1$var$_clipper2.default.ClipType.ctDifference
                ].concat(clipShapes));
            }
        },
        {
            key: "intersect",
            value: function intersect() {
                for(var _len4 = arguments.length, clipShapes = Array(_len4), _key4 = 0; _key4 < _len4; _key4++)clipShapes[_key4] = arguments[_key4];
                return this._clip.apply(this, [
                    $c6440af92f3e9df1$var$_clipper2.default.ClipType.ctIntersection
                ].concat(clipShapes));
            }
        },
        {
            key: "xor",
            value: function xor() {
                for(var _len5 = arguments.length, clipShapes = Array(_len5), _key5 = 0; _key5 < _len5; _key5++)clipShapes[_key5] = arguments[_key5];
                return this._clip.apply(this, [
                    $c6440af92f3e9df1$var$_clipper2.default.ClipType.ctXor
                ].concat(clipShapes));
            }
        },
        {
            key: "offset",
            value: function offset(_offset) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _options$jointType = options.jointType, jointType = _options$jointType === undefined ? "jtSquare" : _options$jointType, _options$endType = options.endType, endType = _options$endType === undefined ? "etClosedPolygon" : _options$endType, _options$miterLimit = options.miterLimit, miterLimit = _options$miterLimit === undefined ? 2.0 : _options$miterLimit, _options$roundPrecisi = options.roundPrecision, roundPrecision = _options$roundPrecisi === undefined ? 0.25 : _options$roundPrecisi;
                $c6440af92f3e9df1$var$CLIPPER_OFFSET.Clear();
                $c6440af92f3e9df1$var$CLIPPER_OFFSET.ArcTolerance = roundPrecision;
                $c6440af92f3e9df1$var$CLIPPER_OFFSET.MiterLimit = miterLimit;
                var offsetPaths = new $c6440af92f3e9df1$var$_clipper2.default.Paths();
                $c6440af92f3e9df1$var$CLIPPER_OFFSET.AddPaths(this.paths, $c6440af92f3e9df1$var$_clipper2.default.JoinType[jointType], $c6440af92f3e9df1$var$_clipper2.default.EndType[endType]);
                $c6440af92f3e9df1$var$CLIPPER_OFFSET.Execute(offsetPaths, _offset);
                return new Shape(offsetPaths, true);
            }
        },
        {
            key: "scaleUp",
            value: function scaleUp(factor) {
                $c6440af92f3e9df1$var$_clipper2.default.JS.ScaleUpPaths(this.paths, factor);
                return this;
            }
        },
        {
            key: "scaleDown",
            value: function scaleDown(factor) {
                $c6440af92f3e9df1$var$_clipper2.default.JS.ScaleDownPaths(this.paths, factor);
                return this;
            }
        },
        {
            key: "firstPoint",
            value: function firstPoint() {
                var toLower = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                if (this.paths.length === 0) return;
                var firstPath = this.paths[0];
                var firstPoint = firstPath[0];
                if (toLower) return $c6440af92f3e9df1$var$vectorToLower(firstPoint);
                else return firstPoint;
            }
        },
        {
            key: "lastPoint",
            value: function lastPoint() {
                var toLower = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                if (this.paths.length === 0) return;
                var lastPath = this.paths[this.paths.length - 1];
                var lastPoint = this.closed ? lastPath[0] : lastPath[lastPath.length - 1];
                if (toLower) return $c6440af92f3e9df1$var$vectorToLower(lastPoint);
                else return lastPoint;
            }
        },
        {
            key: "areas",
            value: function areas() {
                var _this = this;
                var areas = this.paths.map(function(path, i) {
                    return _this.area(i);
                });
                return areas;
            }
        },
        {
            key: "area",
            value: function area(index) {
                var path = this.paths[index];
                var area = $c6440af92f3e9df1$var$_clipper2.default.Clipper.Area(path);
                return area;
            }
        },
        {
            key: "totalArea",
            value: function totalArea() {
                return this.areas().reduce(function(totalArea, area) {
                    return totalArea + area;
                }, 0);
            }
        },
        {
            key: "perimeter",
            value: function perimeter(index) {
                var path = this.paths[index];
                var perimeter = $c6440af92f3e9df1$var$_clipper2.default.JS.PerimeterOfPath(path, this.closed, 1);
                return perimeter;
            }
        },
        {
            key: "perimeters",
            value: function perimeters() {
                var _this2 = this;
                return this.paths.map(function(path) {
                    return $c6440af92f3e9df1$var$_clipper2.default.JS.PerimeterOfPath(path, _this2.closed, 1);
                });
            }
        },
        {
            key: "totalPerimeter",
            value: function totalPerimeter() {
                var perimeter = $c6440af92f3e9df1$var$_clipper2.default.JS.PerimeterOfPaths(this.paths, this.closed);
                return perimeter;
            }
        },
        {
            key: "reverse",
            value: function reverse() {
                $c6440af92f3e9df1$var$_clipper2.default.Clipper.ReversePaths(this.paths);
                return this;
            }
        },
        {
            key: "thresholdArea",
            value: function thresholdArea(minArea) {
                var _arr = [].concat($c6440af92f3e9df1$var$_toConsumableArray(this.paths));
                for(var _i = 0; _i < _arr.length; _i++){
                    var path = _arr[_i];
                    var area = Math.abs($c6440af92f3e9df1$var$_clipper2.default.Clipper.Area(path));
                    if (area < minArea) {
                        var index = this.paths.indexOf(path);
                        this.paths.splice(index, 1);
                    }
                }
                return this;
            }
        },
        {
            key: "join",
            value: function join(shape) {
                var _paths;
                (_paths = this.paths).splice.apply(_paths, [
                    this.paths.length,
                    0
                ].concat($c6440af92f3e9df1$var$_toConsumableArray(shape.paths)));
                return this;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new Shape($c6440af92f3e9df1$var$_clipper2.default.JS.Clone(this.paths), this.closed);
            }
        },
        {
            key: "shapeBounds",
            value: function shapeBounds() {
                return $c6440af92f3e9df1$var$_clipper2.default.JS.BoundsOfPaths(this.paths);
            }
        },
        {
            key: "pathBounds",
            value: function pathBounds(index) {
                var path = this.paths[index];
                return $c6440af92f3e9df1$var$_clipper2.default.JS.BoundsOfPath(path);
            }
        },
        {
            key: "clean",
            value: function clean(cleanDelta) {
                return new Shape($c6440af92f3e9df1$var$_clipper2.default.Clipper.CleanPolygons(this.paths, cleanDelta), this.closed);
            }
        },
        {
            key: "orientation",
            value: function orientation(index) {
                var path = this.paths[index];
                return $c6440af92f3e9df1$var$_clipper2.default.Clipper.Orientation(path);
            }
        },
        {
            key: "pointInShape",
            value: function pointInShape(point) {
                var capitalConversion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var integerConversion = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                if (capitalConversion) point = $c6440af92f3e9df1$var$vectorToCapital(point);
                if (integerConversion) point = $c6440af92f3e9df1$var$roundVector(point);
                for(var i = 0; i < this.paths.length; i++){
                    var pointInPath = this.pointInPath(i, point);
                    var orientation = this.orientation(i);
                    if (!pointInPath && orientation || pointInPath && !orientation) return false;
                }
                return true;
            }
        },
        {
            key: "pointInPath",
            value: function pointInPath(index, point) {
                var capitalConversion = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                var integerConversion = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
                if (capitalConversion) point = $c6440af92f3e9df1$var$vectorToCapital(point);
                if (integerConversion) point = $c6440af92f3e9df1$var$roundVector(point);
                var path = this.paths[index];
                var intPoint = {
                    X: Math.round(point.X),
                    Y: Math.round(point.Y)
                };
                return $c6440af92f3e9df1$var$_clipper2.default.Clipper.PointInPolygon(intPoint, path) > 0;
            }
        },
        {
            key: "fixOrientation",
            value: function fixOrientation() {
                if (!this.closed) return this;
                if (this.totalArea() < 0) this.reverse();
                return this;
            }
        },
        {
            key: "simplify",
            value: function simplify(fillType) {
                if (this.closed) {
                    var shape = $c6440af92f3e9df1$var$_clipper2.default.Clipper.SimplifyPolygons(this.paths, $c6440af92f3e9df1$var$_clipper2.default.PolyFillType[fillType]);
                    return new Shape(shape, true);
                } else return this;
            }
        },
        {
            key: "separateShapes",
            value: function separateShapes() {
                var shapes = [];
                if (!this.closed) {
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;
                    try {
                        for(var _iterator = this.paths[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var path = _step.value;
                            shapes.push(new Shape([
                                path
                            ], false));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
                        } finally{
                            if (_didIteratorError) throw _iteratorError;
                        }
                    }
                } else {
                    var areas = new WeakMap();
                    var outlines = [];
                    var holes = [];
                    for(var i = 0; i < this.paths.length; i++){
                        var _path = this.paths[i];
                        var orientation = this.orientation(i);
                        if (orientation) {
                            var area = this.area(i);
                            areas.set(_path, area);
                            outlines.push(_path);
                        } else holes.push(_path);
                    }
                    outlines.sort(function(a, b) {
                        return areas.get(a) - areas.get(b);
                    });
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;
                    try {
                        for(var _iterator2 = outlines[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                            var outline = _step2.value;
                            var shape = [
                                outline
                            ];
                            var index = this.paths.indexOf(outline);
                            var _arr2 = [].concat(holes);
                            for(var _i2 = 0; _i2 < _arr2.length; _i2++){
                                var hole = _arr2[_i2];
                                var pointInHole = this.pointInPath(index, hole[0]);
                                if (pointInHole) {
                                    shape.push(hole);
                                    var _index = holes.indexOf(hole);
                                    holes.splice(_index, 1);
                                }
                            }
                            shapes.push(new Shape(shape, true));
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
                        } finally{
                            if (_didIteratorError2) throw _iteratorError2;
                        }
                    }
                }
                return shapes;
            }
        },
        {
            key: "round",
            value: function round() {
                return new Shape(this.paths.map($c6440af92f3e9df1$var$mapToRound), this.closed);
            }
        },
        {
            key: "removeDuplicates",
            value: function removeDuplicates() {
                return new Shape(this.paths.map($c6440af92f3e9df1$var$filterPathsDuplicates), this.closed);
            }
        },
        {
            key: "mapToLower",
            value: function mapToLower() {
                return this.paths.map($c6440af92f3e9df1$var$mapCapitalToLower);
            }
        }
    ]);
    return Shape;
}();
module.exports.default = $c6440af92f3e9df1$var$Shape;
function $c6440af92f3e9df1$var$mapCapitalToLower(path) {
    return path.map($c6440af92f3e9df1$var$vectorToLower);
}
function $c6440af92f3e9df1$var$vectorToLower(_ref) {
    var X = _ref.X, Y = _ref.Y;
    return {
        x: X,
        y: Y
    };
}
function $c6440af92f3e9df1$var$mapLowerToCapital(path) {
    return path.map($c6440af92f3e9df1$var$vectorToCapital);
}
function $c6440af92f3e9df1$var$vectorToCapital(_ref2) {
    var x = _ref2.x, y = _ref2.y;
    return {
        X: x,
        Y: y
    };
}
function $c6440af92f3e9df1$var$mapToRound(path) {
    return path.map($c6440af92f3e9df1$var$roundVector);
}
function $c6440af92f3e9df1$var$roundVector(_ref3) {
    var X = _ref3.X, Y = _ref3.Y;
    return {
        X: Math.round(X),
        Y: Math.round(Y)
    };
}
function $c6440af92f3e9df1$var$filterPathsDuplicates(path) {
    return path.filter($c6440af92f3e9df1$var$filterPathDuplicates);
}
function $c6440af92f3e9df1$var$filterPathDuplicates(point, i, array) {
    if (i === 0) return true;
    var prevPoint = array[i - 1];
    return !(point.X === prevPoint.X && point.Y === prevPoint.Y);
}

});
parcelRegister("iV6qj", function(module, exports) {
/*******************************************************************************
 *                                                                              *
 * Author    :  Angus Johnson                                                   *
 * Version   :  6.4.2                                                           *
 * Date      :  27 February 2017                                                *
 * Website   :  http://www.angusj.com                                           *
 * Copyright :  Angus Johnson 2010-2017                                         *
 *                                                                              *
 * License:                                                                     *
 * Use, modification & distribution is subject to Boost Software License Ver 1. *
 * http://www.boost.org/LICENSE_1_0.txt                                         *
 *                                                                              *
 * Attributions:                                                                *
 * The code in this library is an extension of Bala Vatti's clipping algorithm: *
 * "A generic solution to polygon clipping"                                     *
 * Communications of the ACM, Vol 35, Issue 7 (July 1992) pp 56-63.             *
 * http://portal.acm.org/citation.cfm?id=129906                                 *
 *                                                                              *
 * Computer graphics and geometric modeling: implementation and algorithms      *
 * By Max K. Agoston                                                            *
 * Springer; 1 edition (January 4, 2005)                                        *
 * http://books.google.com/books?q=vatti+clipping+agoston                       *
 *                                                                              *
 * See also:                                                                    *
 * "Polygon Offsetting by Computing Winding Numbers"                            *
 * Paper no. DETC2005-85513 pp. 565-575                                         *
 * ASME 2005 International Design Engineering Technical Conferences             *
 * and Computers and Information in Engineering Conference (IDETC/CIE2005)      *
 * September 24-28, 2005 , Long Beach, California, USA                          *
 * http://www.me.berkeley.edu/~mcmains/pubs/DAC05OffsetPolygon.pdf              *
 *                                                                              *
 *******************************************************************************/ /*******************************************************************************
 *                                                                              *
 * Author    :  Timo                                                            *
 * Version   :  6.4.2.2                                                         *
 * Date      :  8 September 2017                                                 *
 *                                                                              *
 * This is a translation of the C# Clipper library to Javascript.               *
 * Int128 struct of C# is implemented using JSBN of Tom Wu.                     *
 * Because Javascript lacks support for 64-bit integers, the space              *
 * is a little more restricted than in C# version.                              *
 *                                                                              *
 * C# version has support for coordinate space:                                 *
 * +-4611686018427387903 ( sqrt(2^127 -1)/2 )                                   *
 * while Javascript version has support for space:                              *
 * +-4503599627370495 ( sqrt(2^106 -1)/2 )                                      *
 *                                                                              *
 * Tom Wu's JSBN proved to be the fastest big integer library:                  *
 * http://jsperf.com/big-integer-library-test                                   *
 *                                                                              *
 * This class can be made simpler when (if ever) 64-bit integer support comes   *
 * or floating point Clipper is released.                                       *
 *                                                                              *
 *******************************************************************************/ /*******************************************************************************
 *                                                                              *
 * Basic JavaScript BN library - subset useful for RSA encryption.              *
 * http://www-cs-students.stanford.edu/~tjw/jsbn/                               *
 * Copyright (c) 2005  Tom Wu                                                   *
 * All Rights Reserved.                                                         *
 * See "LICENSE" for details:                                                   *
 * http://www-cs-students.stanford.edu/~tjw/jsbn/LICENSE                        *
 *                                                                              *
 *******************************************************************************/ (function() {
    "use strict";
    var ClipperLib = {};
    ClipperLib.version = "6.4.2.2";
    //UseLines: Enables open path clipping. Adds a very minor cost to performance.
    ClipperLib.use_lines = true;
    //ClipperLib.use_xyz: adds a Z member to IntPoint. Adds a minor cost to performance.
    ClipperLib.use_xyz = false;
    var isNode = false;
    if (0, module.exports) {
        module.exports = ClipperLib;
        isNode = true;
    } else if (typeof document !== "undefined") window.ClipperLib = ClipperLib;
    else self["ClipperLib"] = ClipperLib;
    var navigator_appName;
    if (!isNode) {
        var nav = navigator.userAgent.toString().toLowerCase();
        navigator_appName = navigator.appName;
    } else {
        var nav = "chrome"; // Node.js uses Chrome's V8 engine
        navigator_appName = "Netscape"; // Firefox, Chrome and Safari returns "Netscape", so Node.js should also
    }
    // Browser test to speedup performance critical functions
    var browser = {};
    if (nav.indexOf("chrome") != -1 && nav.indexOf("chromium") == -1) browser.chrome = 1;
    else browser.chrome = 0;
    if (nav.indexOf("chromium") != -1) browser.chromium = 1;
    else browser.chromium = 0;
    if (nav.indexOf("safari") != -1 && nav.indexOf("chrome") == -1 && nav.indexOf("chromium") == -1) browser.safari = 1;
    else browser.safari = 0;
    if (nav.indexOf("firefox") != -1) browser.firefox = 1;
    else browser.firefox = 0;
    if (nav.indexOf("firefox/17") != -1) browser.firefox17 = 1;
    else browser.firefox17 = 0;
    if (nav.indexOf("firefox/15") != -1) browser.firefox15 = 1;
    else browser.firefox15 = 0;
    if (nav.indexOf("firefox/3") != -1) browser.firefox3 = 1;
    else browser.firefox3 = 0;
    if (nav.indexOf("opera") != -1) browser.opera = 1;
    else browser.opera = 0;
    if (nav.indexOf("msie 10") != -1) browser.msie10 = 1;
    else browser.msie10 = 0;
    if (nav.indexOf("msie 9") != -1) browser.msie9 = 1;
    else browser.msie9 = 0;
    if (nav.indexOf("msie 8") != -1) browser.msie8 = 1;
    else browser.msie8 = 0;
    if (nav.indexOf("msie 7") != -1) browser.msie7 = 1;
    else browser.msie7 = 0;
    if (nav.indexOf("msie ") != -1) browser.msie = 1;
    else browser.msie = 0;
    ClipperLib.biginteger_used = null;
    // Copyright (c) 2005  Tom Wu
    // All Rights Reserved.
    // See "LICENSE" for details.
    // Basic JavaScript BN library - subset useful for RSA encryption.
    // Bits per digit
    var dbits;
    // JavaScript engine analysis
    var canary = 0xdeadbeefcafe;
    var j_lm = (canary & 0xffffff) == 0xefcafe;
    // (public) Constructor
    /**
	* @constructor
	*/ function BigInteger(a, b, c) {
        // This test variable can be removed,
        // but at least for performance tests it is useful piece of knowledge
        // This is the only ClipperLib related variable in BigInteger library
        ClipperLib.biginteger_used = 1;
        if (a != null) {
            if ("number" == typeof a && "undefined" == typeof b) this.fromInt(a); // faster conversion
            else if ("number" == typeof a) this.fromNumber(a, b, c);
            else if (b == null && "string" != typeof a) this.fromString(a, 256);
            else this.fromString(a, b);
        }
    }
    // return new, unset BigInteger
    function nbi() {
        return new BigInteger(null, undefined, undefined);
    }
    // am: Compute w_j += (x*this_i), propagate carries,
    // c is initial carry, returns final carry.
    // c < 3*dvalue, x < 2*dvalue, this_i < dvalue
    // We need to select the fastest one that works in this environment.
    // am1: use a single mult and divide to get the high bits,
    // max digit bits should be 26 because
    // max internal value = 2*dvalue^2-2*dvalue (< 2^53)
    function am1(i, x, w, j, c, n) {
        while(--n >= 0){
            var v = x * this[i++] + w[j] + c;
            c = Math.floor(v / 0x4000000);
            w[j++] = v & 0x3ffffff;
        }
        return c;
    }
    // am2 avoids a big mult-and-extract completely.
    // Max digit bits should be <= 30 because we do bitwise ops
    // on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
    function am2(i, x, w, j, c, n) {
        var xl = x & 0x7fff, xh = x >> 15;
        while(--n >= 0){
            var l = this[i] & 0x7fff;
            var h = this[i++] >> 15;
            var m = xh * l + h * xl;
            l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
            c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
            w[j++] = l & 0x3fffffff;
        }
        return c;
    }
    // Alternately, set max digit bits to 28 since some
    // browsers slow down when dealing with 32-bit numbers.
    function am3(i, x, w, j, c, n) {
        var xl = x & 0x3fff, xh = x >> 14;
        while(--n >= 0){
            var l = this[i] & 0x3fff;
            var h = this[i++] >> 14;
            var m = xh * l + h * xl;
            l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
            c = (l >> 28) + (m >> 14) + xh * h;
            w[j++] = l & 0xfffffff;
        }
        return c;
    }
    if (j_lm && navigator_appName == "Microsoft Internet Explorer") {
        BigInteger.prototype.am = am2;
        dbits = 30;
    } else if (j_lm && navigator_appName != "Netscape") {
        BigInteger.prototype.am = am1;
        dbits = 26;
    } else {
        BigInteger.prototype.am = am3;
        dbits = 28;
    }
    BigInteger.prototype.DB = dbits;
    BigInteger.prototype.DM = (1 << dbits) - 1;
    BigInteger.prototype.DV = 1 << dbits;
    var BI_FP = 52;
    BigInteger.prototype.FV = Math.pow(2, BI_FP);
    BigInteger.prototype.F1 = BI_FP - dbits;
    BigInteger.prototype.F2 = 2 * dbits - BI_FP;
    // Digit conversions
    var BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
    var BI_RC = new Array();
    var rr, vv;
    rr = "0".charCodeAt(0);
    for(vv = 0; vv <= 9; ++vv)BI_RC[rr++] = vv;
    rr = "a".charCodeAt(0);
    for(vv = 10; vv < 36; ++vv)BI_RC[rr++] = vv;
    rr = "A".charCodeAt(0);
    for(vv = 10; vv < 36; ++vv)BI_RC[rr++] = vv;
    function int2char(n) {
        return BI_RM.charAt(n);
    }
    function intAt(s, i) {
        var c = BI_RC[s.charCodeAt(i)];
        return c == null ? -1 : c;
    }
    // (protected) copy this to r
    function bnpCopyTo(r) {
        for(var i = this.t - 1; i >= 0; --i)r[i] = this[i];
        r.t = this.t;
        r.s = this.s;
    }
    // (protected) set from integer value x, -DV <= x < DV
    function bnpFromInt(x) {
        this.t = 1;
        this.s = x < 0 ? -1 : 0;
        if (x > 0) this[0] = x;
        else if (x < -1) this[0] = x + this.DV;
        else this.t = 0;
    }
    // return bigint initialized to value
    function nbv(i) {
        var r = nbi();
        r.fromInt(i);
        return r;
    }
    // (protected) set from string and radix
    function bnpFromString(s, b) {
        var k;
        if (b == 16) k = 4;
        else if (b == 8) k = 3;
        else if (b == 256) k = 8; // byte array
        else if (b == 2) k = 1;
        else if (b == 32) k = 5;
        else if (b == 4) k = 2;
        else {
            this.fromRadix(s, b);
            return;
        }
        this.t = 0;
        this.s = 0;
        var i = s.length, mi = false, sh = 0;
        while(--i >= 0){
            var x = k == 8 ? s[i] & 0xff : intAt(s, i);
            if (x < 0) {
                if (s.charAt(i) == "-") mi = true;
                continue;
            }
            mi = false;
            if (sh == 0) this[this.t++] = x;
            else if (sh + k > this.DB) {
                this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
                this[this.t++] = x >> this.DB - sh;
            } else this[this.t - 1] |= x << sh;
            sh += k;
            if (sh >= this.DB) sh -= this.DB;
        }
        if (k == 8 && (s[0] & 0x80) != 0) {
            this.s = -1;
            if (sh > 0) this[this.t - 1] |= (1 << this.DB - sh) - 1 << sh;
        }
        this.clamp();
        if (mi) BigInteger.ZERO.subTo(this, this);
    }
    // (protected) clamp off excess high words
    function bnpClamp() {
        var c = this.s & this.DM;
        while(this.t > 0 && this[this.t - 1] == c)--this.t;
    }
    // (public) return string representation in given radix
    function bnToString(b) {
        if (this.s < 0) return "-" + this.negate().toString(b);
        var k;
        if (b == 16) k = 4;
        else if (b == 8) k = 3;
        else if (b == 2) k = 1;
        else if (b == 32) k = 5;
        else if (b == 4) k = 2;
        else return this.toRadix(b);
        var km = (1 << k) - 1, d, m = false, r = "", i = this.t;
        var p = this.DB - i * this.DB % k;
        if (i-- > 0) {
            if (p < this.DB && (d = this[i] >> p) > 0) {
                m = true;
                r = int2char(d);
            }
            while(i >= 0){
                if (p < k) {
                    d = (this[i] & (1 << p) - 1) << k - p;
                    d |= this[--i] >> (p += this.DB - k);
                } else {
                    d = this[i] >> (p -= k) & km;
                    if (p <= 0) {
                        p += this.DB;
                        --i;
                    }
                }
                if (d > 0) m = true;
                if (m) r += int2char(d);
            }
        }
        return m ? r : "0";
    }
    // (public) -this
    function bnNegate() {
        var r = nbi();
        BigInteger.ZERO.subTo(this, r);
        return r;
    }
    // (public) |this|
    function bnAbs() {
        return this.s < 0 ? this.negate() : this;
    }
    // (public) return + if this > a, - if this < a, 0 if equal
    function bnCompareTo(a) {
        var r = this.s - a.s;
        if (r != 0) return r;
        var i = this.t;
        r = i - a.t;
        if (r != 0) return this.s < 0 ? -r : r;
        while(--i >= 0)if ((r = this[i] - a[i]) != 0) return r;
        return 0;
    }
    // returns bit length of the integer x
    function nbits(x) {
        var r = 1, t;
        if ((t = x >>> 16) != 0) {
            x = t;
            r += 16;
        }
        if ((t = x >> 8) != 0) {
            x = t;
            r += 8;
        }
        if ((t = x >> 4) != 0) {
            x = t;
            r += 4;
        }
        if ((t = x >> 2) != 0) {
            x = t;
            r += 2;
        }
        if ((t = x >> 1) != 0) {
            x = t;
            r += 1;
        }
        return r;
    }
    // (public) return the number of bits in "this"
    function bnBitLength() {
        if (this.t <= 0) return 0;
        return this.DB * (this.t - 1) + nbits(this[this.t - 1] ^ this.s & this.DM);
    }
    // (protected) r = this << n*DB
    function bnpDLShiftTo(n, r) {
        var i;
        for(i = this.t - 1; i >= 0; --i)r[i + n] = this[i];
        for(i = n - 1; i >= 0; --i)r[i] = 0;
        r.t = this.t + n;
        r.s = this.s;
    }
    // (protected) r = this >> n*DB
    function bnpDRShiftTo(n, r) {
        for(var i = n; i < this.t; ++i)r[i - n] = this[i];
        r.t = Math.max(this.t - n, 0);
        r.s = this.s;
    }
    // (protected) r = this << n
    function bnpLShiftTo(n, r) {
        var bs = n % this.DB;
        var cbs = this.DB - bs;
        var bm = (1 << cbs) - 1;
        var ds = Math.floor(n / this.DB), c = this.s << bs & this.DM, i;
        for(i = this.t - 1; i >= 0; --i){
            r[i + ds + 1] = this[i] >> cbs | c;
            c = (this[i] & bm) << bs;
        }
        for(i = ds - 1; i >= 0; --i)r[i] = 0;
        r[ds] = c;
        r.t = this.t + ds + 1;
        r.s = this.s;
        r.clamp();
    }
    // (protected) r = this >> n
    function bnpRShiftTo(n, r) {
        r.s = this.s;
        var ds = Math.floor(n / this.DB);
        if (ds >= this.t) {
            r.t = 0;
            return;
        }
        var bs = n % this.DB;
        var cbs = this.DB - bs;
        var bm = (1 << bs) - 1;
        r[0] = this[ds] >> bs;
        for(var i = ds + 1; i < this.t; ++i){
            r[i - ds - 1] |= (this[i] & bm) << cbs;
            r[i - ds] = this[i] >> bs;
        }
        if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
        r.t = this.t - ds;
        r.clamp();
    }
    // (protected) r = this - a
    function bnpSubTo(a, r) {
        var i = 0, c = 0, m = Math.min(a.t, this.t);
        while(i < m){
            c += this[i] - a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        if (a.t < this.t) {
            c -= a.s;
            while(i < this.t){
                c += this[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c += this.s;
        } else {
            c += this.s;
            while(i < a.t){
                c -= a[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c -= a.s;
        }
        r.s = c < 0 ? -1 : 0;
        if (c < -1) r[i++] = this.DV + c;
        else if (c > 0) r[i++] = c;
        r.t = i;
        r.clamp();
    }
    // (protected) r = this * a, r != this,a (HAC 14.12)
    // "this" should be the larger one if appropriate.
    function bnpMultiplyTo(a, r) {
        var x = this.abs(), y = a.abs();
        var i = x.t;
        r.t = i + y.t;
        while(--i >= 0)r[i] = 0;
        for(i = 0; i < y.t; ++i)r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
        r.s = 0;
        r.clamp();
        if (this.s != a.s) BigInteger.ZERO.subTo(r, r);
    }
    // (protected) r = this^2, r != this (HAC 14.16)
    function bnpSquareTo(r) {
        var x = this.abs();
        var i = r.t = 2 * x.t;
        while(--i >= 0)r[i] = 0;
        for(i = 0; i < x.t - 1; ++i){
            var c = x.am(i, x[i], r, 2 * i, 0, 1);
            if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
                r[i + x.t] -= x.DV;
                r[i + x.t + 1] = 1;
            }
        }
        if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
        r.s = 0;
        r.clamp();
    }
    // (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
    // r != q, this != m.  q or r may be null.
    function bnpDivRemTo(m, q, r) {
        var pm = m.abs();
        if (pm.t <= 0) return;
        var pt = this.abs();
        if (pt.t < pm.t) {
            if (q != null) q.fromInt(0);
            if (r != null) this.copyTo(r);
            return;
        }
        if (r == null) r = nbi();
        var y = nbi(), ts = this.s, ms = m.s;
        var nsh = this.DB - nbits(pm[pm.t - 1]); // normalize modulus
        if (nsh > 0) {
            pm.lShiftTo(nsh, y);
            pt.lShiftTo(nsh, r);
        } else {
            pm.copyTo(y);
            pt.copyTo(r);
        }
        var ys = y.t;
        var y0 = y[ys - 1];
        if (y0 == 0) return;
        var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
        var d1 = this.FV / yt, d2 = (1 << this.F1) / yt, e = 1 << this.F2;
        var i = r.t, j = i - ys, t = q == null ? nbi() : q;
        y.dlShiftTo(j, t);
        if (r.compareTo(t) >= 0) {
            r[r.t++] = 1;
            r.subTo(t, r);
        }
        BigInteger.ONE.dlShiftTo(ys, t);
        t.subTo(y, y); // "negative" y so we can replace sub with am later
        while(y.t < ys)y[y.t++] = 0;
        while(--j >= 0){
            // Estimate quotient digit
            var qd = r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
            if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
                y.dlShiftTo(j, t);
                r.subTo(t, r);
                while(r[i] < --qd)r.subTo(t, r);
            }
        }
        if (q != null) {
            r.drShiftTo(ys, q);
            if (ts != ms) BigInteger.ZERO.subTo(q, q);
        }
        r.t = ys;
        r.clamp();
        if (nsh > 0) r.rShiftTo(nsh, r); // Denormalize remainder
        if (ts < 0) BigInteger.ZERO.subTo(r, r);
    }
    // (public) this mod a
    function bnMod(a) {
        var r = nbi();
        this.abs().divRemTo(a, null, r);
        if (this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) a.subTo(r, r);
        return r;
    }
    // Modular reduction using "classic" algorithm
    /**
	* @constructor
	*/ function Classic(m) {
        this.m = m;
    }
    function cConvert(x) {
        if (x.s < 0 || x.compareTo(this.m) >= 0) return x.mod(this.m);
        else return x;
    }
    function cRevert(x) {
        return x;
    }
    function cReduce(x) {
        x.divRemTo(this.m, null, x);
    }
    function cMulTo(x, y, r) {
        x.multiplyTo(y, r);
        this.reduce(r);
    }
    function cSqrTo(x, r) {
        x.squareTo(r);
        this.reduce(r);
    }
    Classic.prototype.convert = cConvert;
    Classic.prototype.revert = cRevert;
    Classic.prototype.reduce = cReduce;
    Classic.prototype.mulTo = cMulTo;
    Classic.prototype.sqrTo = cSqrTo;
    // (protected) return "-1/this % 2^DB"; useful for Mont. reduction
    // justification:
    //         xy == 1 (mod m)
    //         xy =  1+km
    //   xy(2-xy) = (1+km)(1-km)
    // x[y(2-xy)] = 1-k^2m^2
    // x[y(2-xy)] == 1 (mod m^2)
    // if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
    // should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
    // JS multiply "overflows" differently from C/C++, so care is needed here.
    function bnpInvDigit() {
        if (this.t < 1) return 0;
        var x = this[0];
        if ((x & 1) == 0) return 0;
        var y = x & 3; // y == 1/x mod 2^2
        y = y * (2 - (x & 0xf) * y) & 0xf; // y == 1/x mod 2^4
        y = y * (2 - (x & 0xff) * y) & 0xff; // y == 1/x mod 2^8
        y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff; // y == 1/x mod 2^16
        // last step - calculate inverse mod DV directly;
        // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
        y = y * (2 - x * y % this.DV) % this.DV; // y == 1/x mod 2^dbits
        // we really want the negative inverse, and -DV < y < DV
        return y > 0 ? this.DV - y : -y;
    }
    // Montgomery reduction
    /**
	* @constructor
	*/ function Montgomery(m) {
        this.m = m;
        this.mp = m.invDigit();
        this.mpl = this.mp & 0x7fff;
        this.mph = this.mp >> 15;
        this.um = (1 << m.DB - 15) - 1;
        this.mt2 = 2 * m.t;
    }
    // xR mod m
    function montConvert(x) {
        var r = nbi();
        x.abs().dlShiftTo(this.m.t, r);
        r.divRemTo(this.m, null, r);
        if (x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) this.m.subTo(r, r);
        return r;
    }
    // x/R mod m
    function montRevert(x) {
        var r = nbi();
        x.copyTo(r);
        this.reduce(r);
        return r;
    }
    // x = x/R mod m (HAC 14.32)
    function montReduce(x) {
        while(x.t <= this.mt2)x[x.t++] = 0;
        for(var i = 0; i < this.m.t; ++i){
            // faster way of calculating u0 = x[i]*mp mod DV
            var j = x[i] & 0x7fff;
            var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
            // use am to combine the multiply-shift-add into one call
            j = i + this.m.t;
            x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
            // propagate carry
            while(x[j] >= x.DV){
                x[j] -= x.DV;
                x[++j]++;
            }
        }
        x.clamp();
        x.drShiftTo(this.m.t, x);
        if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
    }
    // r = "x^2/R mod m"; x != r
    function montSqrTo(x, r) {
        x.squareTo(r);
        this.reduce(r);
    }
    // r = "xy/R mod m"; x,y != r
    function montMulTo(x, y, r) {
        x.multiplyTo(y, r);
        this.reduce(r);
    }
    Montgomery.prototype.convert = montConvert;
    Montgomery.prototype.revert = montRevert;
    Montgomery.prototype.reduce = montReduce;
    Montgomery.prototype.mulTo = montMulTo;
    Montgomery.prototype.sqrTo = montSqrTo;
    // (protected) true iff this is even
    function bnpIsEven() {
        return (this.t > 0 ? this[0] & 1 : this.s) == 0;
    }
    // (protected) this^e, e < 2^32, doing sqr and mul with "r" (HAC 14.79)
    function bnpExp(e, z) {
        if (e > 0xffffffff || e < 1) return BigInteger.ONE;
        var r = nbi(), r2 = nbi(), g = z.convert(this), i = nbits(e) - 1;
        g.copyTo(r);
        while(--i >= 0){
            z.sqrTo(r, r2);
            if ((e & 1 << i) > 0) z.mulTo(r2, g, r);
            else {
                var t = r;
                r = r2;
                r2 = t;
            }
        }
        return z.revert(r);
    }
    // (public) this^e % m, 0 <= e < 2^32
    function bnModPowInt(e, m) {
        var z;
        if (e < 256 || m.isEven()) z = new Classic(m);
        else z = new Montgomery(m);
        return this.exp(e, z);
    }
    // protected
    BigInteger.prototype.copyTo = bnpCopyTo;
    BigInteger.prototype.fromInt = bnpFromInt;
    BigInteger.prototype.fromString = bnpFromString;
    BigInteger.prototype.clamp = bnpClamp;
    BigInteger.prototype.dlShiftTo = bnpDLShiftTo;
    BigInteger.prototype.drShiftTo = bnpDRShiftTo;
    BigInteger.prototype.lShiftTo = bnpLShiftTo;
    BigInteger.prototype.rShiftTo = bnpRShiftTo;
    BigInteger.prototype.subTo = bnpSubTo;
    BigInteger.prototype.multiplyTo = bnpMultiplyTo;
    BigInteger.prototype.squareTo = bnpSquareTo;
    BigInteger.prototype.divRemTo = bnpDivRemTo;
    BigInteger.prototype.invDigit = bnpInvDigit;
    BigInteger.prototype.isEven = bnpIsEven;
    BigInteger.prototype.exp = bnpExp;
    // public
    BigInteger.prototype.toString = bnToString;
    BigInteger.prototype.negate = bnNegate;
    BigInteger.prototype.abs = bnAbs;
    BigInteger.prototype.compareTo = bnCompareTo;
    BigInteger.prototype.bitLength = bnBitLength;
    BigInteger.prototype.mod = bnMod;
    BigInteger.prototype.modPowInt = bnModPowInt;
    // "constants"
    BigInteger.ZERO = nbv(0);
    BigInteger.ONE = nbv(1);
    // Copyright (c) 2005-2009  Tom Wu
    // All Rights Reserved.
    // See "LICENSE" for details.
    // Extended JavaScript BN functions, required for RSA private ops.
    // Version 1.1: new BigInteger("0", 10) returns "proper" zero
    // Version 1.2: square() API, isProbablePrime fix
    // (public)
    function bnClone() {
        var r = nbi();
        this.copyTo(r);
        return r;
    }
    // (public) return value as integer
    function bnIntValue() {
        if (this.s < 0) {
            if (this.t == 1) return this[0] - this.DV;
            else if (this.t == 0) return -1;
        } else if (this.t == 1) return this[0];
        else if (this.t == 0) return 0;
        // assumes 16 < DB < 32
        return (this[1] & (1 << 32 - this.DB) - 1) << this.DB | this[0];
    }
    // (public) return value as byte
    function bnByteValue() {
        return this.t == 0 ? this.s : this[0] << 24 >> 24;
    }
    // (public) return value as short (assumes DB>=16)
    function bnShortValue() {
        return this.t == 0 ? this.s : this[0] << 16 >> 16;
    }
    // (protected) return x s.t. r^x < DV
    function bnpChunkSize(r) {
        return Math.floor(Math.LN2 * this.DB / Math.log(r));
    }
    // (public) 0 if this == 0, 1 if this > 0
    function bnSigNum() {
        if (this.s < 0) return -1;
        else if (this.t <= 0 || this.t == 1 && this[0] <= 0) return 0;
        else return 1;
    }
    // (protected) convert to radix string
    function bnpToRadix(b) {
        if (b == null) b = 10;
        if (this.signum() == 0 || b < 2 || b > 36) return "0";
        var cs = this.chunkSize(b);
        var a = Math.pow(b, cs);
        var d = nbv(a), y = nbi(), z = nbi(), r = "";
        this.divRemTo(d, y, z);
        while(y.signum() > 0){
            r = (a + z.intValue()).toString(b).substr(1) + r;
            y.divRemTo(d, y, z);
        }
        return z.intValue().toString(b) + r;
    }
    // (protected) convert from radix string
    function bnpFromRadix(s, b) {
        this.fromInt(0);
        if (b == null) b = 10;
        var cs = this.chunkSize(b);
        var d = Math.pow(b, cs), mi = false, j = 0, w = 0;
        for(var i = 0; i < s.length; ++i){
            var x = intAt(s, i);
            if (x < 0) {
                if (s.charAt(i) == "-" && this.signum() == 0) mi = true;
                continue;
            }
            w = b * w + x;
            if (++j >= cs) {
                this.dMultiply(d);
                this.dAddOffset(w, 0);
                j = 0;
                w = 0;
            }
        }
        if (j > 0) {
            this.dMultiply(Math.pow(b, j));
            this.dAddOffset(w, 0);
        }
        if (mi) BigInteger.ZERO.subTo(this, this);
    }
    // (protected) alternate constructor
    function bnpFromNumber(a, b, c) {
        if ("number" == typeof b) {
            // new BigInteger(int,int,RNG)
            if (a < 2) this.fromInt(1);
            else {
                this.fromNumber(a, c);
                if (!this.testBit(a - 1)) this.bitwiseTo(BigInteger.ONE.shiftLeft(a - 1), op_or, this);
                if (this.isEven()) this.dAddOffset(1, 0); // force odd
                while(!this.isProbablePrime(b)){
                    this.dAddOffset(2, 0);
                    if (this.bitLength() > a) this.subTo(BigInteger.ONE.shiftLeft(a - 1), this);
                }
            }
        } else {
            // new BigInteger(int,RNG)
            var x = new Array(), t = a & 7;
            x.length = (a >> 3) + 1;
            b.nextBytes(x);
            if (t > 0) x[0] &= (1 << t) - 1;
            else x[0] = 0;
            this.fromString(x, 256);
        }
    }
    // (public) convert to bigendian byte array
    function bnToByteArray() {
        var i = this.t, r = new Array();
        r[0] = this.s;
        var p = this.DB - i * this.DB % 8, d, k = 0;
        if (i-- > 0) {
            if (p < this.DB && (d = this[i] >> p) != (this.s & this.DM) >> p) r[k++] = d | this.s << this.DB - p;
            while(i >= 0){
                if (p < 8) {
                    d = (this[i] & (1 << p) - 1) << 8 - p;
                    d |= this[--i] >> (p += this.DB - 8);
                } else {
                    d = this[i] >> (p -= 8) & 0xff;
                    if (p <= 0) {
                        p += this.DB;
                        --i;
                    }
                }
                if ((d & 0x80) != 0) d |= -256;
                if (k == 0 && (this.s & 0x80) != (d & 0x80)) ++k;
                if (k > 0 || d != this.s) r[k++] = d;
            }
        }
        return r;
    }
    function bnEquals(a) {
        return this.compareTo(a) == 0;
    }
    function bnMin(a) {
        return this.compareTo(a) < 0 ? this : a;
    }
    function bnMax(a) {
        return this.compareTo(a) > 0 ? this : a;
    }
    // (protected) r = this op a (bitwise)
    function bnpBitwiseTo(a, op, r) {
        var i, f, m = Math.min(a.t, this.t);
        for(i = 0; i < m; ++i)r[i] = op(this[i], a[i]);
        if (a.t < this.t) {
            f = a.s & this.DM;
            for(i = m; i < this.t; ++i)r[i] = op(this[i], f);
            r.t = this.t;
        } else {
            f = this.s & this.DM;
            for(i = m; i < a.t; ++i)r[i] = op(f, a[i]);
            r.t = a.t;
        }
        r.s = op(this.s, a.s);
        r.clamp();
    }
    // (public) this & a
    function op_and(x, y) {
        return x & y;
    }
    function bnAnd(a) {
        var r = nbi();
        this.bitwiseTo(a, op_and, r);
        return r;
    }
    // (public) this | a
    function op_or(x, y) {
        return x | y;
    }
    function bnOr(a) {
        var r = nbi();
        this.bitwiseTo(a, op_or, r);
        return r;
    }
    // (public) this ^ a
    function op_xor(x, y) {
        return x ^ y;
    }
    function bnXor(a) {
        var r = nbi();
        this.bitwiseTo(a, op_xor, r);
        return r;
    }
    // (public) this & ~a
    function op_andnot(x, y) {
        return x & ~y;
    }
    function bnAndNot(a) {
        var r = nbi();
        this.bitwiseTo(a, op_andnot, r);
        return r;
    }
    // (public) ~this
    function bnNot() {
        var r = nbi();
        for(var i = 0; i < this.t; ++i)r[i] = this.DM & ~this[i];
        r.t = this.t;
        r.s = ~this.s;
        return r;
    }
    // (public) this << n
    function bnShiftLeft(n) {
        var r = nbi();
        if (n < 0) this.rShiftTo(-n, r);
        else this.lShiftTo(n, r);
        return r;
    }
    // (public) this >> n
    function bnShiftRight(n) {
        var r = nbi();
        if (n < 0) this.lShiftTo(-n, r);
        else this.rShiftTo(n, r);
        return r;
    }
    // return index of lowest 1-bit in x, x < 2^31
    function lbit(x) {
        if (x == 0) return -1;
        var r = 0;
        if ((x & 0xffff) == 0) {
            x >>= 16;
            r += 16;
        }
        if ((x & 0xff) == 0) {
            x >>= 8;
            r += 8;
        }
        if ((x & 0xf) == 0) {
            x >>= 4;
            r += 4;
        }
        if ((x & 3) == 0) {
            x >>= 2;
            r += 2;
        }
        if ((x & 1) == 0) ++r;
        return r;
    }
    // (public) returns index of lowest 1-bit (or -1 if none)
    function bnGetLowestSetBit() {
        for(var i = 0; i < this.t; ++i)if (this[i] != 0) return i * this.DB + lbit(this[i]);
        if (this.s < 0) return this.t * this.DB;
        return -1;
    }
    // return number of 1 bits in x
    function cbit(x) {
        var r = 0;
        while(x != 0){
            x &= x - 1;
            ++r;
        }
        return r;
    }
    // (public) return number of set bits
    function bnBitCount() {
        var r = 0, x = this.s & this.DM;
        for(var i = 0; i < this.t; ++i)r += cbit(this[i] ^ x);
        return r;
    }
    // (public) true iff nth bit is set
    function bnTestBit(n) {
        var j = Math.floor(n / this.DB);
        if (j >= this.t) return this.s != 0;
        return (this[j] & 1 << n % this.DB) != 0;
    }
    // (protected) this op (1<<n)
    function bnpChangeBit(n, op) {
        var r = BigInteger.ONE.shiftLeft(n);
        this.bitwiseTo(r, op, r);
        return r;
    }
    // (public) this | (1<<n)
    function bnSetBit(n) {
        return this.changeBit(n, op_or);
    }
    // (public) this & ~(1<<n)
    function bnClearBit(n) {
        return this.changeBit(n, op_andnot);
    }
    // (public) this ^ (1<<n)
    function bnFlipBit(n) {
        return this.changeBit(n, op_xor);
    }
    // (protected) r = this + a
    function bnpAddTo(a, r) {
        var i = 0, c = 0, m = Math.min(a.t, this.t);
        while(i < m){
            c += this[i] + a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        if (a.t < this.t) {
            c += a.s;
            while(i < this.t){
                c += this[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c += this.s;
        } else {
            c += this.s;
            while(i < a.t){
                c += a[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c += a.s;
        }
        r.s = c < 0 ? -1 : 0;
        if (c > 0) r[i++] = c;
        else if (c < -1) r[i++] = this.DV + c;
        r.t = i;
        r.clamp();
    }
    // (public) this + a
    function bnAdd(a) {
        var r = nbi();
        this.addTo(a, r);
        return r;
    }
    // (public) this - a
    function bnSubtract(a) {
        var r = nbi();
        this.subTo(a, r);
        return r;
    }
    // (public) this * a
    function bnMultiply(a) {
        var r = nbi();
        this.multiplyTo(a, r);
        return r;
    }
    // (public) this^2
    function bnSquare() {
        var r = nbi();
        this.squareTo(r);
        return r;
    }
    // (public) this / a
    function bnDivide(a) {
        var r = nbi();
        this.divRemTo(a, r, null);
        return r;
    }
    // (public) this % a
    function bnRemainder(a) {
        var r = nbi();
        this.divRemTo(a, null, r);
        return r;
    }
    // (public) [this/a,this%a]
    function bnDivideAndRemainder(a) {
        var q = nbi(), r = nbi();
        this.divRemTo(a, q, r);
        return new Array(q, r);
    }
    // (protected) this *= n, this >= 0, 1 < n < DV
    function bnpDMultiply(n) {
        this[this.t] = this.am(0, n - 1, this, 0, 0, this.t);
        ++this.t;
        this.clamp();
    }
    // (protected) this += n << w words, this >= 0
    function bnpDAddOffset(n, w) {
        if (n == 0) return;
        while(this.t <= w)this[this.t++] = 0;
        this[w] += n;
        while(this[w] >= this.DV){
            this[w] -= this.DV;
            if (++w >= this.t) this[this.t++] = 0;
            ++this[w];
        }
    }
    // A "null" reducer
    /**
	* @constructor
	*/ function NullExp() {}
    function nNop(x) {
        return x;
    }
    function nMulTo(x, y, r) {
        x.multiplyTo(y, r);
    }
    function nSqrTo(x, r) {
        x.squareTo(r);
    }
    NullExp.prototype.convert = nNop;
    NullExp.prototype.revert = nNop;
    NullExp.prototype.mulTo = nMulTo;
    NullExp.prototype.sqrTo = nSqrTo;
    // (public) this^e
    function bnPow(e) {
        return this.exp(e, new NullExp());
    }
    // (protected) r = lower n words of "this * a", a.t <= n
    // "this" should be the larger one if appropriate.
    function bnpMultiplyLowerTo(a, n, r) {
        var i = Math.min(this.t + a.t, n);
        r.s = 0; // assumes a,this >= 0
        r.t = i;
        while(i > 0)r[--i] = 0;
        var j;
        for(j = r.t - this.t; i < j; ++i)r[i + this.t] = this.am(0, a[i], r, i, 0, this.t);
        for(j = Math.min(a.t, n); i < j; ++i)this.am(0, a[i], r, i, 0, n - i);
        r.clamp();
    }
    // (protected) r = "this * a" without lower n words, n > 0
    // "this" should be the larger one if appropriate.
    function bnpMultiplyUpperTo(a, n, r) {
        --n;
        var i = r.t = this.t + a.t - n;
        r.s = 0; // assumes a,this >= 0
        while(--i >= 0)r[i] = 0;
        for(i = Math.max(n - this.t, 0); i < a.t; ++i)r[this.t + i - n] = this.am(n - i, a[i], r, 0, 0, this.t + i - n);
        r.clamp();
        r.drShiftTo(1, r);
    }
    // Barrett modular reduction
    /**
	* @constructor
	*/ function Barrett(m) {
        // setup Barrett
        this.r2 = nbi();
        this.q3 = nbi();
        BigInteger.ONE.dlShiftTo(2 * m.t, this.r2);
        this.mu = this.r2.divide(m);
        this.m = m;
    }
    function barrettConvert(x) {
        if (x.s < 0 || x.t > 2 * this.m.t) return x.mod(this.m);
        else if (x.compareTo(this.m) < 0) return x;
        else {
            var r = nbi();
            x.copyTo(r);
            this.reduce(r);
            return r;
        }
    }
    function barrettRevert(x) {
        return x;
    }
    // x = x mod m (HAC 14.42)
    function barrettReduce(x) {
        x.drShiftTo(this.m.t - 1, this.r2);
        if (x.t > this.m.t + 1) {
            x.t = this.m.t + 1;
            x.clamp();
        }
        this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3);
        this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2);
        while(x.compareTo(this.r2) < 0)x.dAddOffset(1, this.m.t + 1);
        x.subTo(this.r2, x);
        while(x.compareTo(this.m) >= 0)x.subTo(this.m, x);
    }
    // r = x^2 mod m; x != r
    function barrettSqrTo(x, r) {
        x.squareTo(r);
        this.reduce(r);
    }
    // r = x*y mod m; x,y != r
    function barrettMulTo(x, y, r) {
        x.multiplyTo(y, r);
        this.reduce(r);
    }
    Barrett.prototype.convert = barrettConvert;
    Barrett.prototype.revert = barrettRevert;
    Barrett.prototype.reduce = barrettReduce;
    Barrett.prototype.mulTo = barrettMulTo;
    Barrett.prototype.sqrTo = barrettSqrTo;
    // (public) this^e % m (HAC 14.85)
    function bnModPow(e, m) {
        var i = e.bitLength(), k, r = nbv(1), z;
        if (i <= 0) return r;
        else if (i < 18) k = 1;
        else if (i < 48) k = 3;
        else if (i < 144) k = 4;
        else if (i < 768) k = 5;
        else k = 6;
        if (i < 8) z = new Classic(m);
        else if (m.isEven()) z = new Barrett(m);
        else z = new Montgomery(m);
        // precomputation
        var g = new Array(), n = 3, k1 = k - 1, km = (1 << k) - 1;
        g[1] = z.convert(this);
        if (k > 1) {
            var g2 = nbi();
            z.sqrTo(g[1], g2);
            while(n <= km){
                g[n] = nbi();
                z.mulTo(g2, g[n - 2], g[n]);
                n += 2;
            }
        }
        var j = e.t - 1, w, is1 = true, r2 = nbi(), t;
        i = nbits(e[j]) - 1;
        while(j >= 0){
            if (i >= k1) w = e[j] >> i - k1 & km;
            else {
                w = (e[j] & (1 << i + 1) - 1) << k1 - i;
                if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
            }
            n = k;
            while((w & 1) == 0){
                w >>= 1;
                --n;
            }
            if ((i -= n) < 0) {
                i += this.DB;
                --j;
            }
            if (is1) {
                g[w].copyTo(r);
                is1 = false;
            } else {
                while(n > 1){
                    z.sqrTo(r, r2);
                    z.sqrTo(r2, r);
                    n -= 2;
                }
                if (n > 0) z.sqrTo(r, r2);
                else {
                    t = r;
                    r = r2;
                    r2 = t;
                }
                z.mulTo(r2, g[w], r);
            }
            while(j >= 0 && (e[j] & 1 << i) == 0){
                z.sqrTo(r, r2);
                t = r;
                r = r2;
                r2 = t;
                if (--i < 0) {
                    i = this.DB - 1;
                    --j;
                }
            }
        }
        return z.revert(r);
    }
    // (public) gcd(this,a) (HAC 14.54)
    function bnGCD(a) {
        var x = this.s < 0 ? this.negate() : this.clone();
        var y = a.s < 0 ? a.negate() : a.clone();
        if (x.compareTo(y) < 0) {
            var t = x;
            x = y;
            y = t;
        }
        var i = x.getLowestSetBit(), g = y.getLowestSetBit();
        if (g < 0) return x;
        if (i < g) g = i;
        if (g > 0) {
            x.rShiftTo(g, x);
            y.rShiftTo(g, y);
        }
        while(x.signum() > 0){
            if ((i = x.getLowestSetBit()) > 0) x.rShiftTo(i, x);
            if ((i = y.getLowestSetBit()) > 0) y.rShiftTo(i, y);
            if (x.compareTo(y) >= 0) {
                x.subTo(y, x);
                x.rShiftTo(1, x);
            } else {
                y.subTo(x, y);
                y.rShiftTo(1, y);
            }
        }
        if (g > 0) y.lShiftTo(g, y);
        return y;
    }
    // (protected) this % n, n < 2^26
    function bnpModInt(n) {
        if (n <= 0) return 0;
        var d = this.DV % n, r = this.s < 0 ? n - 1 : 0;
        if (this.t > 0) {
            if (d == 0) r = this[0] % n;
            else for(var i = this.t - 1; i >= 0; --i)r = (d * r + this[i]) % n;
        }
        return r;
    }
    // (public) 1/this % m (HAC 14.61)
    function bnModInverse(m) {
        var ac = m.isEven();
        if (this.isEven() && ac || m.signum() == 0) return BigInteger.ZERO;
        var u = m.clone(), v = this.clone();
        var a = nbv(1), b = nbv(0), c = nbv(0), d = nbv(1);
        while(u.signum() != 0){
            while(u.isEven()){
                u.rShiftTo(1, u);
                if (ac) {
                    if (!a.isEven() || !b.isEven()) {
                        a.addTo(this, a);
                        b.subTo(m, b);
                    }
                    a.rShiftTo(1, a);
                } else if (!b.isEven()) b.subTo(m, b);
                b.rShiftTo(1, b);
            }
            while(v.isEven()){
                v.rShiftTo(1, v);
                if (ac) {
                    if (!c.isEven() || !d.isEven()) {
                        c.addTo(this, c);
                        d.subTo(m, d);
                    }
                    c.rShiftTo(1, c);
                } else if (!d.isEven()) d.subTo(m, d);
                d.rShiftTo(1, d);
            }
            if (u.compareTo(v) >= 0) {
                u.subTo(v, u);
                if (ac) a.subTo(c, a);
                b.subTo(d, b);
            } else {
                v.subTo(u, v);
                if (ac) c.subTo(a, c);
                d.subTo(b, d);
            }
        }
        if (v.compareTo(BigInteger.ONE) != 0) return BigInteger.ZERO;
        if (d.compareTo(m) >= 0) return d.subtract(m);
        if (d.signum() < 0) d.addTo(m, d);
        else return d;
        if (d.signum() < 0) return d.add(m);
        else return d;
    }
    var lowprimes = [
        2,
        3,
        5,
        7,
        11,
        13,
        17,
        19,
        23,
        29,
        31,
        37,
        41,
        43,
        47,
        53,
        59,
        61,
        67,
        71,
        73,
        79,
        83,
        89,
        97,
        101,
        103,
        107,
        109,
        113,
        127,
        131,
        137,
        139,
        149,
        151,
        157,
        163,
        167,
        173,
        179,
        181,
        191,
        193,
        197,
        199,
        211,
        223,
        227,
        229,
        233,
        239,
        241,
        251,
        257,
        263,
        269,
        271,
        277,
        281,
        283,
        293,
        307,
        311,
        313,
        317,
        331,
        337,
        347,
        349,
        353,
        359,
        367,
        373,
        379,
        383,
        389,
        397,
        401,
        409,
        419,
        421,
        431,
        433,
        439,
        443,
        449,
        457,
        461,
        463,
        467,
        479,
        487,
        491,
        499,
        503,
        509,
        521,
        523,
        541,
        547,
        557,
        563,
        569,
        571,
        577,
        587,
        593,
        599,
        601,
        607,
        613,
        617,
        619,
        631,
        641,
        643,
        647,
        653,
        659,
        661,
        673,
        677,
        683,
        691,
        701,
        709,
        719,
        727,
        733,
        739,
        743,
        751,
        757,
        761,
        769,
        773,
        787,
        797,
        809,
        811,
        821,
        823,
        827,
        829,
        839,
        853,
        857,
        859,
        863,
        877,
        881,
        883,
        887,
        907,
        911,
        919,
        929,
        937,
        941,
        947,
        953,
        967,
        971,
        977,
        983,
        991,
        997
    ];
    var lplim = 67108864 / lowprimes[lowprimes.length - 1];
    // (public) test primality with certainty >= 1-.5^t
    function bnIsProbablePrime(t) {
        var i, x = this.abs();
        if (x.t == 1 && x[0] <= lowprimes[lowprimes.length - 1]) {
            for(i = 0; i < lowprimes.length; ++i)if (x[0] == lowprimes[i]) return true;
            return false;
        }
        if (x.isEven()) return false;
        i = 1;
        while(i < lowprimes.length){
            var m = lowprimes[i], j = i + 1;
            while(j < lowprimes.length && m < lplim)m *= lowprimes[j++];
            m = x.modInt(m);
            while(i < j)if (m % lowprimes[i++] == 0) return false;
        }
        return x.millerRabin(t);
    }
    // (protected) true if probably prime (HAC 4.24, Miller-Rabin)
    function bnpMillerRabin(t) {
        var n1 = this.subtract(BigInteger.ONE);
        var k = n1.getLowestSetBit();
        if (k <= 0) return false;
        var r = n1.shiftRight(k);
        t = t + 1 >> 1;
        if (t > lowprimes.length) t = lowprimes.length;
        var a = nbi();
        for(var i = 0; i < t; ++i){
            //Pick bases at random, instead of starting at 2
            a.fromInt(lowprimes[Math.floor(Math.random() * lowprimes.length)]);
            var y = a.modPow(r, this);
            if (y.compareTo(BigInteger.ONE) != 0 && y.compareTo(n1) != 0) {
                var j = 1;
                while(j++ < k && y.compareTo(n1) != 0){
                    y = y.modPowInt(2, this);
                    if (y.compareTo(BigInteger.ONE) == 0) return false;
                }
                if (y.compareTo(n1) != 0) return false;
            }
        }
        return true;
    }
    // protected
    BigInteger.prototype.chunkSize = bnpChunkSize;
    BigInteger.prototype.toRadix = bnpToRadix;
    BigInteger.prototype.fromRadix = bnpFromRadix;
    BigInteger.prototype.fromNumber = bnpFromNumber;
    BigInteger.prototype.bitwiseTo = bnpBitwiseTo;
    BigInteger.prototype.changeBit = bnpChangeBit;
    BigInteger.prototype.addTo = bnpAddTo;
    BigInteger.prototype.dMultiply = bnpDMultiply;
    BigInteger.prototype.dAddOffset = bnpDAddOffset;
    BigInteger.prototype.multiplyLowerTo = bnpMultiplyLowerTo;
    BigInteger.prototype.multiplyUpperTo = bnpMultiplyUpperTo;
    BigInteger.prototype.modInt = bnpModInt;
    BigInteger.prototype.millerRabin = bnpMillerRabin;
    // public
    BigInteger.prototype.clone = bnClone;
    BigInteger.prototype.intValue = bnIntValue;
    BigInteger.prototype.byteValue = bnByteValue;
    BigInteger.prototype.shortValue = bnShortValue;
    BigInteger.prototype.signum = bnSigNum;
    BigInteger.prototype.toByteArray = bnToByteArray;
    BigInteger.prototype.equals = bnEquals;
    BigInteger.prototype.min = bnMin;
    BigInteger.prototype.max = bnMax;
    BigInteger.prototype.and = bnAnd;
    BigInteger.prototype.or = bnOr;
    BigInteger.prototype.xor = bnXor;
    BigInteger.prototype.andNot = bnAndNot;
    BigInteger.prototype.not = bnNot;
    BigInteger.prototype.shiftLeft = bnShiftLeft;
    BigInteger.prototype.shiftRight = bnShiftRight;
    BigInteger.prototype.getLowestSetBit = bnGetLowestSetBit;
    BigInteger.prototype.bitCount = bnBitCount;
    BigInteger.prototype.testBit = bnTestBit;
    BigInteger.prototype.setBit = bnSetBit;
    BigInteger.prototype.clearBit = bnClearBit;
    BigInteger.prototype.flipBit = bnFlipBit;
    BigInteger.prototype.add = bnAdd;
    BigInteger.prototype.subtract = bnSubtract;
    BigInteger.prototype.multiply = bnMultiply;
    BigInteger.prototype.divide = bnDivide;
    BigInteger.prototype.remainder = bnRemainder;
    BigInteger.prototype.divideAndRemainder = bnDivideAndRemainder;
    BigInteger.prototype.modPow = bnModPow;
    BigInteger.prototype.modInverse = bnModInverse;
    BigInteger.prototype.pow = bnPow;
    BigInteger.prototype.gcd = bnGCD;
    BigInteger.prototype.isProbablePrime = bnIsProbablePrime;
    // JSBN-specific extension
    BigInteger.prototype.square = bnSquare;
    var Int128 = BigInteger;
    // BigInteger interfaces not implemented in jsbn:
    // BigInteger(int signum, byte[] magnitude)
    // double doubleValue()
    // float floatValue()
    // int hashCode()
    // long longValue()
    // static BigInteger valueOf(long val)
    // Helper functions to make BigInteger functions callable with two parameters
    // as in original C# Clipper
    Int128.prototype.IsNegative = function() {
        if (this.compareTo(Int128.ZERO) == -1) return true;
        else return false;
    };
    Int128.op_Equality = function(val1, val2) {
        if (val1.compareTo(val2) == 0) return true;
        else return false;
    };
    Int128.op_Inequality = function(val1, val2) {
        if (val1.compareTo(val2) != 0) return true;
        else return false;
    };
    Int128.op_GreaterThan = function(val1, val2) {
        if (val1.compareTo(val2) > 0) return true;
        else return false;
    };
    Int128.op_LessThan = function(val1, val2) {
        if (val1.compareTo(val2) < 0) return true;
        else return false;
    };
    Int128.op_Addition = function(lhs, rhs) {
        return new Int128(lhs, undefined, undefined).add(new Int128(rhs, undefined, undefined));
    };
    Int128.op_Subtraction = function(lhs, rhs) {
        return new Int128(lhs, undefined, undefined).subtract(new Int128(rhs, undefined, undefined));
    };
    Int128.Int128Mul = function(lhs, rhs) {
        return new Int128(lhs, undefined, undefined).multiply(new Int128(rhs, undefined, undefined));
    };
    Int128.op_Division = function(lhs, rhs) {
        return lhs.divide(rhs);
    };
    Int128.prototype.ToDouble = function() {
        return parseFloat(this.toString()); // This could be something faster
    };
    // end of Int128 section
    /*
	// Uncomment the following two lines if you want to use Int128 outside ClipperLib
	if (typeof(document) !== "undefined") window.Int128 = Int128;
	else self.Int128 = Int128;
	*/ // ---------------------------------------------
    // Here starts the actual Clipper library:
    // Helper function to support Inheritance in Javascript
    var Inherit = function(ce, ce2) {
        var p;
        if (typeof Object.getOwnPropertyNames === "undefined") {
            for(p in ce2.prototype)if (typeof ce.prototype[p] === "undefined" || ce.prototype[p] === Object.prototype[p]) ce.prototype[p] = ce2.prototype[p];
            for(p in ce2)if (typeof ce[p] === "undefined") ce[p] = ce2[p];
            ce.$baseCtor = ce2;
        } else {
            var props = Object.getOwnPropertyNames(ce2.prototype);
            for(var i = 0; i < props.length; i++)if (typeof Object.getOwnPropertyDescriptor(ce.prototype, props[i]) === "undefined") Object.defineProperty(ce.prototype, props[i], Object.getOwnPropertyDescriptor(ce2.prototype, props[i]));
            for(p in ce2)if (typeof ce[p] === "undefined") ce[p] = ce2[p];
            ce.$baseCtor = ce2;
        }
    };
    /**
	* @constructor
	*/ ClipperLib.Path = function() {
        return [];
    };
    ClipperLib.Path.prototype.push = Array.prototype.push;
    /**
	* @constructor
	*/ ClipperLib.Paths = function() {
        return []; // Was previously [[]], but caused problems when pushed
    };
    ClipperLib.Paths.prototype.push = Array.prototype.push;
    // Preserves the calling way of original C# Clipper
    // Is essential due to compatibility, because DoublePoint is public class in original C# version
    /**
	* @constructor
	*/ ClipperLib.DoublePoint = function() {
        var a = arguments;
        this.X = 0;
        this.Y = 0;
        // public DoublePoint(DoublePoint dp)
        // public DoublePoint(IntPoint ip)
        if (a.length === 1) {
            this.X = a[0].X;
            this.Y = a[0].Y;
        } else if (a.length === 2) {
            this.X = a[0];
            this.Y = a[1];
        }
    }; // This is internal faster function when called without arguments
    /**
	* @constructor
	*/ ClipperLib.DoublePoint0 = function() {
        this.X = 0;
        this.Y = 0;
    };
    ClipperLib.DoublePoint0.prototype = ClipperLib.DoublePoint.prototype;
    // This is internal faster function when called with 1 argument (dp or ip)
    /**
	* @constructor
	*/ ClipperLib.DoublePoint1 = function(dp) {
        this.X = dp.X;
        this.Y = dp.Y;
    };
    ClipperLib.DoublePoint1.prototype = ClipperLib.DoublePoint.prototype;
    // This is internal faster function when called with 2 arguments (x and y)
    /**
	* @constructor
	*/ ClipperLib.DoublePoint2 = function(x, y) {
        this.X = x;
        this.Y = y;
    };
    ClipperLib.DoublePoint2.prototype = ClipperLib.DoublePoint.prototype;
    // PolyTree & PolyNode start
    /**
	* @suppress {missingProperties}
	*/ ClipperLib.PolyNode = function() {
        this.m_Parent = null;
        this.m_polygon = new ClipperLib.Path();
        this.m_Index = 0;
        this.m_jointype = 0;
        this.m_endtype = 0;
        this.m_Childs = [];
        this.IsOpen = false;
    };
    ClipperLib.PolyNode.prototype.IsHoleNode = function() {
        var result = true;
        var node = this.m_Parent;
        while(node !== null){
            result = !result;
            node = node.m_Parent;
        }
        return result;
    };
    ClipperLib.PolyNode.prototype.ChildCount = function() {
        return this.m_Childs.length;
    };
    ClipperLib.PolyNode.prototype.Contour = function() {
        return this.m_polygon;
    };
    ClipperLib.PolyNode.prototype.AddChild = function(Child) {
        var cnt = this.m_Childs.length;
        this.m_Childs.push(Child);
        Child.m_Parent = this;
        Child.m_Index = cnt;
    };
    ClipperLib.PolyNode.prototype.GetNext = function() {
        if (this.m_Childs.length > 0) return this.m_Childs[0];
        else return this.GetNextSiblingUp();
    };
    ClipperLib.PolyNode.prototype.GetNextSiblingUp = function() {
        if (this.m_Parent === null) return null;
        else if (this.m_Index === this.m_Parent.m_Childs.length - 1) return this.m_Parent.GetNextSiblingUp();
        else return this.m_Parent.m_Childs[this.m_Index + 1];
    };
    ClipperLib.PolyNode.prototype.Childs = function() {
        return this.m_Childs;
    };
    ClipperLib.PolyNode.prototype.Parent = function() {
        return this.m_Parent;
    };
    ClipperLib.PolyNode.prototype.IsHole = function() {
        return this.IsHoleNode();
    };
    // PolyTree : PolyNode
    /**
	 * @suppress {missingProperties}
	 * @constructor
	 */ ClipperLib.PolyTree = function() {
        this.m_AllPolys = [];
        ClipperLib.PolyNode.call(this);
    };
    ClipperLib.PolyTree.prototype.Clear = function() {
        for(var i = 0, ilen = this.m_AllPolys.length; i < ilen; i++)this.m_AllPolys[i] = null;
        this.m_AllPolys.length = 0;
        this.m_Childs.length = 0;
    };
    ClipperLib.PolyTree.prototype.GetFirst = function() {
        if (this.m_Childs.length > 0) return this.m_Childs[0];
        else return null;
    };
    ClipperLib.PolyTree.prototype.Total = function() {
        var result = this.m_AllPolys.length;
        //with negative offsets, ignore the hidden outer polygon ...
        if (result > 0 && this.m_Childs[0] !== this.m_AllPolys[0]) result--;
        return result;
    };
    Inherit(ClipperLib.PolyTree, ClipperLib.PolyNode);
    // PolyTree & PolyNode end
    ClipperLib.Math_Abs_Int64 = ClipperLib.Math_Abs_Int32 = ClipperLib.Math_Abs_Double = function(a) {
        return Math.abs(a);
    };
    ClipperLib.Math_Max_Int32_Int32 = function(a, b) {
        return Math.max(a, b);
    };
    /*
	-----------------------------------
	cast_32 speedtest: http://jsperf.com/truncate-float-to-integer/2
	-----------------------------------
	*/ if (browser.msie || browser.opera || browser.safari) ClipperLib.Cast_Int32 = function(a) {
        return a | 0;
    };
    else ClipperLib.Cast_Int32 = function(a) {
        return ~~a;
    };
    /*
	--------------------------
	cast_64 speedtests: http://jsperf.com/truncate-float-to-integer
	Chrome: bitwise_not_floor
	Firefox17: toInteger (typeof test)
	IE9: bitwise_or_floor
	IE7 and IE8: to_parseint
	Chromium: to_floor_or_ceil
	Firefox3: to_floor_or_ceil
	Firefox15: to_floor_or_ceil
	Opera: to_floor_or_ceil
	Safari: to_floor_or_ceil
	--------------------------
	*/ if (typeof Number.toInteger === "undefined") Number.toInteger = null;
    if (browser.chrome) ClipperLib.Cast_Int64 = function(a) {
        if (a < -2147483648 || a > 2147483647) return a < 0 ? Math.ceil(a) : Math.floor(a);
        else return ~~a;
    };
    else if (browser.firefox && typeof Number.toInteger === "function") ClipperLib.Cast_Int64 = function(a) {
        return Number.toInteger(a);
    };
    else if (browser.msie7 || browser.msie8) ClipperLib.Cast_Int64 = function(a) {
        return parseInt(a, 10);
    };
    else if (browser.msie) ClipperLib.Cast_Int64 = function(a) {
        if (a < -2147483648 || a > 2147483647) return a < 0 ? Math.ceil(a) : Math.floor(a);
        return a | 0;
    };
    else ClipperLib.Cast_Int64 = function(a) {
        return a < 0 ? Math.ceil(a) : Math.floor(a);
    };
    ClipperLib.Clear = function(a) {
        a.length = 0;
    };
    //ClipperLib.MaxSteps = 64; // How many steps at maximum in arc in BuildArc() function
    ClipperLib.PI = 3.141592653589793;
    ClipperLib.PI2 = 6.283185307179586;
    /**
	* @constructor
	*/ ClipperLib.IntPoint = function() {
        var a = arguments, alen = a.length;
        this.X = 0;
        this.Y = 0;
        if (ClipperLib.use_xyz) {
            this.Z = 0;
            if (alen === 3) {
                this.X = a[0];
                this.Y = a[1];
                this.Z = a[2];
            } else if (alen === 2) {
                this.X = a[0];
                this.Y = a[1];
                this.Z = 0;
            } else if (alen === 1) {
                if (a[0] instanceof ClipperLib.DoublePoint) {
                    var dp = a[0];
                    this.X = ClipperLib.Clipper.Round(dp.X);
                    this.Y = ClipperLib.Clipper.Round(dp.Y);
                    this.Z = 0;
                } else {
                    var pt = a[0];
                    if (typeof pt.Z === "undefined") pt.Z = 0;
                    this.X = pt.X;
                    this.Y = pt.Y;
                    this.Z = pt.Z;
                }
            } else {
                this.X = 0;
                this.Y = 0;
                this.Z = 0;
            }
        } else {
            if (alen === 2) {
                this.X = a[0];
                this.Y = a[1];
            } else if (alen === 1) {
                if (a[0] instanceof ClipperLib.DoublePoint) {
                    var dp = a[0];
                    this.X = ClipperLib.Clipper.Round(dp.X);
                    this.Y = ClipperLib.Clipper.Round(dp.Y);
                } else {
                    var pt = a[0];
                    this.X = pt.X;
                    this.Y = pt.Y;
                }
            } else {
                this.X = 0;
                this.Y = 0;
            }
        }
    };
    ClipperLib.IntPoint.op_Equality = function(a, b) {
        //return a == b;
        return a.X === b.X && a.Y === b.Y;
    };
    ClipperLib.IntPoint.op_Inequality = function(a, b) {
        //return a !== b;
        return a.X !== b.X || a.Y !== b.Y;
    };
    /*
  ClipperLib.IntPoint.prototype.Equals = function (obj)
  {
    if (obj === null)
        return false;
    if (obj instanceof ClipperLib.IntPoint)
    {
        var a = Cast(obj, ClipperLib.IntPoint);
        return (this.X == a.X) && (this.Y == a.Y);
    }
    else
        return false;
  };

	*/ /**
	* @constructor
	*/ ClipperLib.IntPoint0 = function() {
        this.X = 0;
        this.Y = 0;
        if (ClipperLib.use_xyz) this.Z = 0;
    };
    ClipperLib.IntPoint0.prototype = ClipperLib.IntPoint.prototype;
    /**
	* @constructor
	*/ ClipperLib.IntPoint1 = function(pt) {
        this.X = pt.X;
        this.Y = pt.Y;
        if (ClipperLib.use_xyz) {
            if (typeof pt.Z === "undefined") this.Z = 0;
            else this.Z = pt.Z;
        }
    };
    ClipperLib.IntPoint1.prototype = ClipperLib.IntPoint.prototype;
    /**
	* @constructor
	*/ ClipperLib.IntPoint1dp = function(dp) {
        this.X = ClipperLib.Clipper.Round(dp.X);
        this.Y = ClipperLib.Clipper.Round(dp.Y);
        if (ClipperLib.use_xyz) this.Z = 0;
    };
    ClipperLib.IntPoint1dp.prototype = ClipperLib.IntPoint.prototype;
    /**
	* @constructor
	*/ ClipperLib.IntPoint2 = function(x, y, z) {
        this.X = x;
        this.Y = y;
        if (ClipperLib.use_xyz) {
            if (typeof z === "undefined") this.Z = 0;
            else this.Z = z;
        }
    };
    ClipperLib.IntPoint2.prototype = ClipperLib.IntPoint.prototype;
    /**
	* @constructor
	*/ ClipperLib.IntRect = function() {
        var a = arguments, alen = a.length;
        if (alen === 4) {
            this.left = a[0];
            this.top = a[1];
            this.right = a[2];
            this.bottom = a[3];
        } else if (alen === 1) {
            var ir = a[0];
            this.left = ir.left;
            this.top = ir.top;
            this.right = ir.right;
            this.bottom = ir.bottom;
        } else {
            this.left = 0;
            this.top = 0;
            this.right = 0;
            this.bottom = 0;
        }
    };
    /**
	* @constructor
	*/ ClipperLib.IntRect0 = function() {
        this.left = 0;
        this.top = 0;
        this.right = 0;
        this.bottom = 0;
    };
    ClipperLib.IntRect0.prototype = ClipperLib.IntRect.prototype;
    /**
	* @constructor
	*/ ClipperLib.IntRect1 = function(ir) {
        this.left = ir.left;
        this.top = ir.top;
        this.right = ir.right;
        this.bottom = ir.bottom;
    };
    ClipperLib.IntRect1.prototype = ClipperLib.IntRect.prototype;
    /**
	* @constructor
	*/ ClipperLib.IntRect4 = function(l, t, r, b) {
        this.left = l;
        this.top = t;
        this.right = r;
        this.bottom = b;
    };
    ClipperLib.IntRect4.prototype = ClipperLib.IntRect.prototype;
    ClipperLib.ClipType = {
        ctIntersection: 0,
        ctUnion: 1,
        ctDifference: 2,
        ctXor: 3
    };
    ClipperLib.PolyType = {
        ptSubject: 0,
        ptClip: 1
    };
    ClipperLib.PolyFillType = {
        pftEvenOdd: 0,
        pftNonZero: 1,
        pftPositive: 2,
        pftNegative: 3
    };
    ClipperLib.JoinType = {
        jtSquare: 0,
        jtRound: 1,
        jtMiter: 2
    };
    ClipperLib.EndType = {
        etOpenSquare: 0,
        etOpenRound: 1,
        etOpenButt: 2,
        etClosedLine: 3,
        etClosedPolygon: 4
    };
    ClipperLib.EdgeSide = {
        esLeft: 0,
        esRight: 1
    };
    ClipperLib.Direction = {
        dRightToLeft: 0,
        dLeftToRight: 1
    };
    /**
	* @constructor
	*/ ClipperLib.TEdge = function() {
        this.Bot = new ClipperLib.IntPoint0();
        this.Curr = new ClipperLib.IntPoint0(); //current (updated for every new scanbeam)
        this.Top = new ClipperLib.IntPoint0();
        this.Delta = new ClipperLib.IntPoint0();
        this.Dx = 0;
        this.PolyTyp = ClipperLib.PolyType.ptSubject;
        this.Side = ClipperLib.EdgeSide.esLeft; //side only refers to current side of solution poly
        this.WindDelta = 0; //1 or -1 depending on winding direction
        this.WindCnt = 0;
        this.WindCnt2 = 0; //winding count of the opposite polytype
        this.OutIdx = 0;
        this.Next = null;
        this.Prev = null;
        this.NextInLML = null;
        this.NextInAEL = null;
        this.PrevInAEL = null;
        this.NextInSEL = null;
        this.PrevInSEL = null;
    };
    /**
	* @constructor
	*/ ClipperLib.IntersectNode = function() {
        this.Edge1 = null;
        this.Edge2 = null;
        this.Pt = new ClipperLib.IntPoint0();
    };
    ClipperLib.MyIntersectNodeSort = function() {};
    ClipperLib.MyIntersectNodeSort.Compare = function(node1, node2) {
        var i = node2.Pt.Y - node1.Pt.Y;
        if (i > 0) return 1;
        else if (i < 0) return -1;
        else return 0;
    };
    /**
	* @constructor
	*/ ClipperLib.LocalMinima = function() {
        this.Y = 0;
        this.LeftBound = null;
        this.RightBound = null;
        this.Next = null;
    };
    /**
	* @constructor
	*/ ClipperLib.Scanbeam = function() {
        this.Y = 0;
        this.Next = null;
    };
    /**
	* @constructor
	*/ ClipperLib.Maxima = function() {
        this.X = 0;
        this.Next = null;
        this.Prev = null;
    };
    //OutRec: contains a path in the clipping solution. Edges in the AEL will
    //carry a pointer to an OutRec when they are part of the clipping solution.
    /**
	* @constructor
	*/ ClipperLib.OutRec = function() {
        this.Idx = 0;
        this.IsHole = false;
        this.IsOpen = false;
        this.FirstLeft = null; //see comments in clipper.pas
        this.Pts = null;
        this.BottomPt = null;
        this.PolyNode = null;
    };
    /**
	* @constructor
	*/ ClipperLib.OutPt = function() {
        this.Idx = 0;
        this.Pt = new ClipperLib.IntPoint0();
        this.Next = null;
        this.Prev = null;
    };
    /**
	* @constructor
	*/ ClipperLib.Join = function() {
        this.OutPt1 = null;
        this.OutPt2 = null;
        this.OffPt = new ClipperLib.IntPoint0();
    };
    ClipperLib.ClipperBase = function() {
        this.m_MinimaList = null;
        this.m_CurrentLM = null;
        this.m_edges = new Array();
        this.m_UseFullRange = false;
        this.m_HasOpenPaths = false;
        this.PreserveCollinear = false;
        this.m_Scanbeam = null;
        this.m_PolyOuts = null;
        this.m_ActiveEdges = null;
    };
    // Ranges are in original C# too high for Javascript (in current state 2013 september):
    // protected const double horizontal = -3.4E+38;
    // internal const cInt loRange = 0x3FFFFFFF; // = 1073741823 = sqrt(2^63 -1)/2
    // internal const cInt hiRange = 0x3FFFFFFFFFFFFFFFL; // = 4611686018427387903 = sqrt(2^127 -1)/2
    // So had to adjust them to more suitable for Javascript.
    // If JS some day supports truly 64-bit integers, then these ranges can be as in C#
    // and biginteger library can be more simpler (as then 128bit can be represented as two 64bit numbers)
    ClipperLib.ClipperBase.horizontal = -9007199254740992; //-2^53
    ClipperLib.ClipperBase.Skip = -2;
    ClipperLib.ClipperBase.Unassigned = -1;
    ClipperLib.ClipperBase.tolerance = 1E-20;
    ClipperLib.ClipperBase.loRange = 47453132; // sqrt(2^53 -1)/2
    ClipperLib.ClipperBase.hiRange = 4503599627370495; // sqrt(2^106 -1)/2
    ClipperLib.ClipperBase.near_zero = function(val) {
        return val > -ClipperLib.ClipperBase.tolerance && val < ClipperLib.ClipperBase.tolerance;
    };
    ClipperLib.ClipperBase.IsHorizontal = function(e) {
        return e.Delta.Y === 0;
    };
    ClipperLib.ClipperBase.prototype.PointIsVertex = function(pt, pp) {
        var pp2 = pp;
        do {
            if (ClipperLib.IntPoint.op_Equality(pp2.Pt, pt)) return true;
            pp2 = pp2.Next;
        }while (pp2 !== pp);
        return false;
    };
    ClipperLib.ClipperBase.prototype.PointOnLineSegment = function(pt, linePt1, linePt2, UseFullRange) {
        if (UseFullRange) return pt.X === linePt1.X && pt.Y === linePt1.Y || pt.X === linePt2.X && pt.Y === linePt2.Y || pt.X > linePt1.X === pt.X < linePt2.X && pt.Y > linePt1.Y === pt.Y < linePt2.Y && Int128.op_Equality(Int128.Int128Mul(pt.X - linePt1.X, linePt2.Y - linePt1.Y), Int128.Int128Mul(linePt2.X - linePt1.X, pt.Y - linePt1.Y));
        else return pt.X === linePt1.X && pt.Y === linePt1.Y || pt.X === linePt2.X && pt.Y === linePt2.Y || pt.X > linePt1.X === pt.X < linePt2.X && pt.Y > linePt1.Y === pt.Y < linePt2.Y && (pt.X - linePt1.X) * (linePt2.Y - linePt1.Y) === (linePt2.X - linePt1.X) * (pt.Y - linePt1.Y);
    };
    ClipperLib.ClipperBase.prototype.PointOnPolygon = function(pt, pp, UseFullRange) {
        var pp2 = pp;
        while(true){
            if (this.PointOnLineSegment(pt, pp2.Pt, pp2.Next.Pt, UseFullRange)) return true;
            pp2 = pp2.Next;
            if (pp2 === pp) break;
        }
        return false;
    };
    ClipperLib.ClipperBase.prototype.SlopesEqual = ClipperLib.ClipperBase.SlopesEqual = function() {
        var a = arguments, alen = a.length;
        var e1, e2, pt1, pt2, pt3, pt4, UseFullRange;
        if (alen === 3) {
            e1 = a[0];
            e2 = a[1];
            UseFullRange = a[2];
            if (UseFullRange) return Int128.op_Equality(Int128.Int128Mul(e1.Delta.Y, e2.Delta.X), Int128.Int128Mul(e1.Delta.X, e2.Delta.Y));
            else return ClipperLib.Cast_Int64(e1.Delta.Y * e2.Delta.X) === ClipperLib.Cast_Int64(e1.Delta.X * e2.Delta.Y);
        } else if (alen === 4) {
            pt1 = a[0];
            pt2 = a[1];
            pt3 = a[2];
            UseFullRange = a[3];
            if (UseFullRange) return Int128.op_Equality(Int128.Int128Mul(pt1.Y - pt2.Y, pt2.X - pt3.X), Int128.Int128Mul(pt1.X - pt2.X, pt2.Y - pt3.Y));
            else return ClipperLib.Cast_Int64((pt1.Y - pt2.Y) * (pt2.X - pt3.X)) - ClipperLib.Cast_Int64((pt1.X - pt2.X) * (pt2.Y - pt3.Y)) === 0;
        } else {
            pt1 = a[0];
            pt2 = a[1];
            pt3 = a[2];
            pt4 = a[3];
            UseFullRange = a[4];
            if (UseFullRange) return Int128.op_Equality(Int128.Int128Mul(pt1.Y - pt2.Y, pt3.X - pt4.X), Int128.Int128Mul(pt1.X - pt2.X, pt3.Y - pt4.Y));
            else return ClipperLib.Cast_Int64((pt1.Y - pt2.Y) * (pt3.X - pt4.X)) - ClipperLib.Cast_Int64((pt1.X - pt2.X) * (pt3.Y - pt4.Y)) === 0;
        }
    };
    ClipperLib.ClipperBase.SlopesEqual3 = function(e1, e2, UseFullRange) {
        if (UseFullRange) return Int128.op_Equality(Int128.Int128Mul(e1.Delta.Y, e2.Delta.X), Int128.Int128Mul(e1.Delta.X, e2.Delta.Y));
        else return ClipperLib.Cast_Int64(e1.Delta.Y * e2.Delta.X) === ClipperLib.Cast_Int64(e1.Delta.X * e2.Delta.Y);
    };
    ClipperLib.ClipperBase.SlopesEqual4 = function(pt1, pt2, pt3, UseFullRange) {
        if (UseFullRange) return Int128.op_Equality(Int128.Int128Mul(pt1.Y - pt2.Y, pt2.X - pt3.X), Int128.Int128Mul(pt1.X - pt2.X, pt2.Y - pt3.Y));
        else return ClipperLib.Cast_Int64((pt1.Y - pt2.Y) * (pt2.X - pt3.X)) - ClipperLib.Cast_Int64((pt1.X - pt2.X) * (pt2.Y - pt3.Y)) === 0;
    };
    ClipperLib.ClipperBase.SlopesEqual5 = function(pt1, pt2, pt3, pt4, UseFullRange) {
        if (UseFullRange) return Int128.op_Equality(Int128.Int128Mul(pt1.Y - pt2.Y, pt3.X - pt4.X), Int128.Int128Mul(pt1.X - pt2.X, pt3.Y - pt4.Y));
        else return ClipperLib.Cast_Int64((pt1.Y - pt2.Y) * (pt3.X - pt4.X)) - ClipperLib.Cast_Int64((pt1.X - pt2.X) * (pt3.Y - pt4.Y)) === 0;
    };
    ClipperLib.ClipperBase.prototype.Clear = function() {
        this.DisposeLocalMinimaList();
        for(var i = 0, ilen = this.m_edges.length; i < ilen; ++i){
            for(var j = 0, jlen = this.m_edges[i].length; j < jlen; ++j)this.m_edges[i][j] = null;
            ClipperLib.Clear(this.m_edges[i]);
        }
        ClipperLib.Clear(this.m_edges);
        this.m_UseFullRange = false;
        this.m_HasOpenPaths = false;
    };
    ClipperLib.ClipperBase.prototype.DisposeLocalMinimaList = function() {
        while(this.m_MinimaList !== null){
            var tmpLm = this.m_MinimaList.Next;
            this.m_MinimaList = null;
            this.m_MinimaList = tmpLm;
        }
        this.m_CurrentLM = null;
    };
    ClipperLib.ClipperBase.prototype.RangeTest = function(Pt, useFullRange) {
        if (useFullRange.Value) {
            if (Pt.X > ClipperLib.ClipperBase.hiRange || Pt.Y > ClipperLib.ClipperBase.hiRange || -Pt.X > ClipperLib.ClipperBase.hiRange || -Pt.Y > ClipperLib.ClipperBase.hiRange) ClipperLib.Error("Coordinate outside allowed range in RangeTest().");
        } else if (Pt.X > ClipperLib.ClipperBase.loRange || Pt.Y > ClipperLib.ClipperBase.loRange || -Pt.X > ClipperLib.ClipperBase.loRange || -Pt.Y > ClipperLib.ClipperBase.loRange) {
            useFullRange.Value = true;
            this.RangeTest(Pt, useFullRange);
        }
    };
    ClipperLib.ClipperBase.prototype.InitEdge = function(e, eNext, ePrev, pt) {
        e.Next = eNext;
        e.Prev = ePrev;
        //e.Curr = pt;
        e.Curr.X = pt.X;
        e.Curr.Y = pt.Y;
        if (ClipperLib.use_xyz) e.Curr.Z = pt.Z;
        e.OutIdx = -1;
    };
    ClipperLib.ClipperBase.prototype.InitEdge2 = function(e, polyType) {
        if (e.Curr.Y >= e.Next.Curr.Y) {
            //e.Bot = e.Curr;
            e.Bot.X = e.Curr.X;
            e.Bot.Y = e.Curr.Y;
            if (ClipperLib.use_xyz) e.Bot.Z = e.Curr.Z;
            //e.Top = e.Next.Curr;
            e.Top.X = e.Next.Curr.X;
            e.Top.Y = e.Next.Curr.Y;
            if (ClipperLib.use_xyz) e.Top.Z = e.Next.Curr.Z;
        } else {
            //e.Top = e.Curr;
            e.Top.X = e.Curr.X;
            e.Top.Y = e.Curr.Y;
            if (ClipperLib.use_xyz) e.Top.Z = e.Curr.Z;
            //e.Bot = e.Next.Curr;
            e.Bot.X = e.Next.Curr.X;
            e.Bot.Y = e.Next.Curr.Y;
            if (ClipperLib.use_xyz) e.Bot.Z = e.Next.Curr.Z;
        }
        this.SetDx(e);
        e.PolyTyp = polyType;
    };
    ClipperLib.ClipperBase.prototype.FindNextLocMin = function(E) {
        var E2;
        for(;;){
            while(ClipperLib.IntPoint.op_Inequality(E.Bot, E.Prev.Bot) || ClipperLib.IntPoint.op_Equality(E.Curr, E.Top))E = E.Next;
            if (E.Dx !== ClipperLib.ClipperBase.horizontal && E.Prev.Dx !== ClipperLib.ClipperBase.horizontal) break;
            while(E.Prev.Dx === ClipperLib.ClipperBase.horizontal)E = E.Prev;
            E2 = E;
            while(E.Dx === ClipperLib.ClipperBase.horizontal)E = E.Next;
            if (E.Top.Y === E.Prev.Bot.Y) continue;
            //ie just an intermediate horz.
            if (E2.Prev.Bot.X < E.Bot.X) E = E2;
            break;
        }
        return E;
    };
    ClipperLib.ClipperBase.prototype.ProcessBound = function(E, LeftBoundIsForward) {
        var EStart;
        var Result = E;
        var Horz;
        if (Result.OutIdx === ClipperLib.ClipperBase.Skip) {
            //check if there are edges beyond the skip edge in the bound and if so
            //create another LocMin and calling ProcessBound once more ...
            E = Result;
            if (LeftBoundIsForward) {
                while(E.Top.Y === E.Next.Bot.Y)E = E.Next;
                while(E !== Result && E.Dx === ClipperLib.ClipperBase.horizontal)E = E.Prev;
            } else {
                while(E.Top.Y === E.Prev.Bot.Y)E = E.Prev;
                while(E !== Result && E.Dx === ClipperLib.ClipperBase.horizontal)E = E.Next;
            }
            if (E === Result) {
                if (LeftBoundIsForward) Result = E.Next;
                else Result = E.Prev;
            } else {
                //there are more edges in the bound beyond result starting with E
                if (LeftBoundIsForward) E = Result.Next;
                else E = Result.Prev;
                var locMin = new ClipperLib.LocalMinima();
                locMin.Next = null;
                locMin.Y = E.Bot.Y;
                locMin.LeftBound = null;
                locMin.RightBound = E;
                E.WindDelta = 0;
                Result = this.ProcessBound(E, LeftBoundIsForward);
                this.InsertLocalMinima(locMin);
            }
            return Result;
        }
        if (E.Dx === ClipperLib.ClipperBase.horizontal) {
            //We need to be careful with open paths because this may not be a
            //true local minima (ie E may be following a skip edge).
            //Also, consecutive horz. edges may start heading left before going right.
            if (LeftBoundIsForward) EStart = E.Prev;
            else EStart = E.Next;
            if (EStart.Dx === ClipperLib.ClipperBase.horizontal) {
                if (EStart.Bot.X !== E.Bot.X && EStart.Top.X !== E.Bot.X) this.ReverseHorizontal(E);
            } else if (EStart.Bot.X !== E.Bot.X) this.ReverseHorizontal(E);
        }
        EStart = E;
        if (LeftBoundIsForward) {
            while(Result.Top.Y === Result.Next.Bot.Y && Result.Next.OutIdx !== ClipperLib.ClipperBase.Skip)Result = Result.Next;
            if (Result.Dx === ClipperLib.ClipperBase.horizontal && Result.Next.OutIdx !== ClipperLib.ClipperBase.Skip) {
                //nb: at the top of a bound, horizontals are added to the bound
                //only when the preceding edge attaches to the horizontal's left vertex
                //unless a Skip edge is encountered when that becomes the top divide
                Horz = Result;
                while(Horz.Prev.Dx === ClipperLib.ClipperBase.horizontal)Horz = Horz.Prev;
                if (Horz.Prev.Top.X > Result.Next.Top.X) Result = Horz.Prev;
            }
            while(E !== Result){
                E.NextInLML = E.Next;
                if (E.Dx === ClipperLib.ClipperBase.horizontal && E !== EStart && E.Bot.X !== E.Prev.Top.X) this.ReverseHorizontal(E);
                E = E.Next;
            }
            if (E.Dx === ClipperLib.ClipperBase.horizontal && E !== EStart && E.Bot.X !== E.Prev.Top.X) this.ReverseHorizontal(E);
            Result = Result.Next;
        //move to the edge just beyond current bound
        } else {
            while(Result.Top.Y === Result.Prev.Bot.Y && Result.Prev.OutIdx !== ClipperLib.ClipperBase.Skip)Result = Result.Prev;
            if (Result.Dx === ClipperLib.ClipperBase.horizontal && Result.Prev.OutIdx !== ClipperLib.ClipperBase.Skip) {
                Horz = Result;
                while(Horz.Next.Dx === ClipperLib.ClipperBase.horizontal)Horz = Horz.Next;
                if (Horz.Next.Top.X === Result.Prev.Top.X || Horz.Next.Top.X > Result.Prev.Top.X) Result = Horz.Next;
            }
            while(E !== Result){
                E.NextInLML = E.Prev;
                if (E.Dx === ClipperLib.ClipperBase.horizontal && E !== EStart && E.Bot.X !== E.Next.Top.X) this.ReverseHorizontal(E);
                E = E.Prev;
            }
            if (E.Dx === ClipperLib.ClipperBase.horizontal && E !== EStart && E.Bot.X !== E.Next.Top.X) this.ReverseHorizontal(E);
            Result = Result.Prev;
        //move to the edge just beyond current bound
        }
        return Result;
    };
    ClipperLib.ClipperBase.prototype.AddPath = function(pg, polyType, Closed) {
        if (ClipperLib.use_lines) {
            if (!Closed && polyType === ClipperLib.PolyType.ptClip) ClipperLib.Error("AddPath: Open paths must be subject.");
        } else if (!Closed) ClipperLib.Error("AddPath: Open paths have been disabled.");
        var highI = pg.length - 1;
        if (Closed) while(highI > 0 && ClipperLib.IntPoint.op_Equality(pg[highI], pg[0]))--highI;
        while(highI > 0 && ClipperLib.IntPoint.op_Equality(pg[highI], pg[highI - 1]))--highI;
        if (Closed && highI < 2 || !Closed && highI < 1) return false;
        //create a new edge array ...
        var edges = new Array();
        for(var i = 0; i <= highI; i++)edges.push(new ClipperLib.TEdge());
        var IsFlat = true;
        //1. Basic (first) edge initialization ...
        //edges[1].Curr = pg[1];
        edges[1].Curr.X = pg[1].X;
        edges[1].Curr.Y = pg[1].Y;
        if (ClipperLib.use_xyz) edges[1].Curr.Z = pg[1].Z;
        var $1 = {
            Value: this.m_UseFullRange
        };
        this.RangeTest(pg[0], $1);
        this.m_UseFullRange = $1.Value;
        $1.Value = this.m_UseFullRange;
        this.RangeTest(pg[highI], $1);
        this.m_UseFullRange = $1.Value;
        this.InitEdge(edges[0], edges[1], edges[highI], pg[0]);
        this.InitEdge(edges[highI], edges[0], edges[highI - 1], pg[highI]);
        for(var i = highI - 1; i >= 1; --i){
            $1.Value = this.m_UseFullRange;
            this.RangeTest(pg[i], $1);
            this.m_UseFullRange = $1.Value;
            this.InitEdge(edges[i], edges[i + 1], edges[i - 1], pg[i]);
        }
        var eStart = edges[0];
        //2. Remove duplicate vertices, and (when closed) collinear edges ...
        var E = eStart, eLoopStop = eStart;
        for(;;){
            //console.log(E.Next, eStart);
            //nb: allows matching start and end points when not Closed ...
            if (E.Curr === E.Next.Curr && (Closed || E.Next !== eStart)) {
                if (E === E.Next) break;
                if (E === eStart) eStart = E.Next;
                E = this.RemoveEdge(E);
                eLoopStop = E;
                continue;
            }
            if (E.Prev === E.Next) break;
            else if (Closed && ClipperLib.ClipperBase.SlopesEqual4(E.Prev.Curr, E.Curr, E.Next.Curr, this.m_UseFullRange) && (!this.PreserveCollinear || !this.Pt2IsBetweenPt1AndPt3(E.Prev.Curr, E.Curr, E.Next.Curr))) {
                //Collinear edges are allowed for open paths but in closed paths
                //the default is to merge adjacent collinear edges into a single edge.
                //However, if the PreserveCollinear property is enabled, only overlapping
                //collinear edges (ie spikes) will be removed from closed paths.
                if (E === eStart) eStart = E.Next;
                E = this.RemoveEdge(E);
                E = E.Prev;
                eLoopStop = E;
                continue;
            }
            E = E.Next;
            if (E === eLoopStop || !Closed && E.Next === eStart) break;
        }
        if (!Closed && E === E.Next || Closed && E.Prev === E.Next) return false;
        if (!Closed) {
            this.m_HasOpenPaths = true;
            eStart.Prev.OutIdx = ClipperLib.ClipperBase.Skip;
        }
        //3. Do second stage of edge initialization ...
        E = eStart;
        do {
            this.InitEdge2(E, polyType);
            E = E.Next;
            if (IsFlat && E.Curr.Y !== eStart.Curr.Y) IsFlat = false;
        }while (E !== eStart);
        //4. Finally, add edge bounds to LocalMinima list ...
        //Totally flat paths must be handled differently when adding them
        //to LocalMinima list to avoid endless loops etc ...
        if (IsFlat) {
            if (Closed) return false;
            E.Prev.OutIdx = ClipperLib.ClipperBase.Skip;
            var locMin = new ClipperLib.LocalMinima();
            locMin.Next = null;
            locMin.Y = E.Bot.Y;
            locMin.LeftBound = null;
            locMin.RightBound = E;
            locMin.RightBound.Side = ClipperLib.EdgeSide.esRight;
            locMin.RightBound.WindDelta = 0;
            for(;;){
                if (E.Bot.X !== E.Prev.Top.X) this.ReverseHorizontal(E);
                if (E.Next.OutIdx === ClipperLib.ClipperBase.Skip) break;
                E.NextInLML = E.Next;
                E = E.Next;
            }
            this.InsertLocalMinima(locMin);
            this.m_edges.push(edges);
            return true;
        }
        this.m_edges.push(edges);
        var leftBoundIsForward;
        var EMin = null;
        //workaround to avoid an endless loop in the while loop below when
        //open paths have matching start and end points ...
        if (ClipperLib.IntPoint.op_Equality(E.Prev.Bot, E.Prev.Top)) E = E.Next;
        for(;;){
            E = this.FindNextLocMin(E);
            if (E === EMin) break;
            else if (EMin === null) EMin = E;
            //E and E.Prev now share a local minima (left aligned if horizontal).
            //Compare their slopes to find which starts which bound ...
            var locMin = new ClipperLib.LocalMinima();
            locMin.Next = null;
            locMin.Y = E.Bot.Y;
            if (E.Dx < E.Prev.Dx) {
                locMin.LeftBound = E.Prev;
                locMin.RightBound = E;
                leftBoundIsForward = false;
            //Q.nextInLML = Q.prev
            } else {
                locMin.LeftBound = E;
                locMin.RightBound = E.Prev;
                leftBoundIsForward = true;
            //Q.nextInLML = Q.next
            }
            locMin.LeftBound.Side = ClipperLib.EdgeSide.esLeft;
            locMin.RightBound.Side = ClipperLib.EdgeSide.esRight;
            if (!Closed) locMin.LeftBound.WindDelta = 0;
            else if (locMin.LeftBound.Next === locMin.RightBound) locMin.LeftBound.WindDelta = -1;
            else locMin.LeftBound.WindDelta = 1;
            locMin.RightBound.WindDelta = -locMin.LeftBound.WindDelta;
            E = this.ProcessBound(locMin.LeftBound, leftBoundIsForward);
            if (E.OutIdx === ClipperLib.ClipperBase.Skip) E = this.ProcessBound(E, leftBoundIsForward);
            var E2 = this.ProcessBound(locMin.RightBound, !leftBoundIsForward);
            if (E2.OutIdx === ClipperLib.ClipperBase.Skip) E2 = this.ProcessBound(E2, !leftBoundIsForward);
            if (locMin.LeftBound.OutIdx === ClipperLib.ClipperBase.Skip) locMin.LeftBound = null;
            else if (locMin.RightBound.OutIdx === ClipperLib.ClipperBase.Skip) locMin.RightBound = null;
            this.InsertLocalMinima(locMin);
            if (!leftBoundIsForward) E = E2;
        }
        return true;
    };
    ClipperLib.ClipperBase.prototype.AddPaths = function(ppg, polyType, closed) {
        //  console.log("-------------------------------------------");
        //  console.log(JSON.stringify(ppg));
        var result = false;
        for(var i = 0, ilen = ppg.length; i < ilen; ++i)if (this.AddPath(ppg[i], polyType, closed)) result = true;
        return result;
    };
    ClipperLib.ClipperBase.prototype.Pt2IsBetweenPt1AndPt3 = function(pt1, pt2, pt3) {
        if (ClipperLib.IntPoint.op_Equality(pt1, pt3) || ClipperLib.IntPoint.op_Equality(pt1, pt2) || ClipperLib.IntPoint.op_Equality(pt3, pt2)) //if ((pt1 == pt3) || (pt1 == pt2) || (pt3 == pt2))
        return false;
        else if (pt1.X !== pt3.X) return pt2.X > pt1.X === pt2.X < pt3.X;
        else return pt2.Y > pt1.Y === pt2.Y < pt3.Y;
    };
    ClipperLib.ClipperBase.prototype.RemoveEdge = function(e) {
        //removes e from double_linked_list (but without removing from memory)
        e.Prev.Next = e.Next;
        e.Next.Prev = e.Prev;
        var result = e.Next;
        e.Prev = null; //flag as removed (see ClipperBase.Clear)
        return result;
    };
    ClipperLib.ClipperBase.prototype.SetDx = function(e) {
        e.Delta.X = e.Top.X - e.Bot.X;
        e.Delta.Y = e.Top.Y - e.Bot.Y;
        if (e.Delta.Y === 0) e.Dx = ClipperLib.ClipperBase.horizontal;
        else e.Dx = e.Delta.X / e.Delta.Y;
    };
    ClipperLib.ClipperBase.prototype.InsertLocalMinima = function(newLm) {
        if (this.m_MinimaList === null) this.m_MinimaList = newLm;
        else if (newLm.Y >= this.m_MinimaList.Y) {
            newLm.Next = this.m_MinimaList;
            this.m_MinimaList = newLm;
        } else {
            var tmpLm = this.m_MinimaList;
            while(tmpLm.Next !== null && newLm.Y < tmpLm.Next.Y)tmpLm = tmpLm.Next;
            newLm.Next = tmpLm.Next;
            tmpLm.Next = newLm;
        }
    };
    ClipperLib.ClipperBase.prototype.PopLocalMinima = function(Y, current) {
        current.v = this.m_CurrentLM;
        if (this.m_CurrentLM !== null && this.m_CurrentLM.Y === Y) {
            this.m_CurrentLM = this.m_CurrentLM.Next;
            return true;
        }
        return false;
    };
    ClipperLib.ClipperBase.prototype.ReverseHorizontal = function(e) {
        //swap horizontal edges' top and bottom x's so they follow the natural
        //progression of the bounds - ie so their xbots will align with the
        //adjoining lower edge. [Helpful in the ProcessHorizontal() method.]
        var tmp = e.Top.X;
        e.Top.X = e.Bot.X;
        e.Bot.X = tmp;
        if (ClipperLib.use_xyz) {
            tmp = e.Top.Z;
            e.Top.Z = e.Bot.Z;
            e.Bot.Z = tmp;
        }
    };
    ClipperLib.ClipperBase.prototype.Reset = function() {
        this.m_CurrentLM = this.m_MinimaList;
        if (this.m_CurrentLM === null) return;
        //reset all edges ...
        this.m_Scanbeam = null;
        var lm = this.m_MinimaList;
        while(lm !== null){
            this.InsertScanbeam(lm.Y);
            var e = lm.LeftBound;
            if (e !== null) {
                //e.Curr = e.Bot;
                e.Curr.X = e.Bot.X;
                e.Curr.Y = e.Bot.Y;
                if (ClipperLib.use_xyz) e.Curr.Z = e.Bot.Z;
                e.OutIdx = ClipperLib.ClipperBase.Unassigned;
            }
            e = lm.RightBound;
            if (e !== null) {
                //e.Curr = e.Bot;
                e.Curr.X = e.Bot.X;
                e.Curr.Y = e.Bot.Y;
                if (ClipperLib.use_xyz) e.Curr.Z = e.Bot.Z;
                e.OutIdx = ClipperLib.ClipperBase.Unassigned;
            }
            lm = lm.Next;
        }
        this.m_ActiveEdges = null;
    };
    ClipperLib.ClipperBase.prototype.InsertScanbeam = function(Y) {
        //single-linked list: sorted descending, ignoring dups.
        if (this.m_Scanbeam === null) {
            this.m_Scanbeam = new ClipperLib.Scanbeam();
            this.m_Scanbeam.Next = null;
            this.m_Scanbeam.Y = Y;
        } else if (Y > this.m_Scanbeam.Y) {
            var newSb = new ClipperLib.Scanbeam();
            newSb.Y = Y;
            newSb.Next = this.m_Scanbeam;
            this.m_Scanbeam = newSb;
        } else {
            var sb2 = this.m_Scanbeam;
            while(sb2.Next !== null && Y <= sb2.Next.Y)sb2 = sb2.Next;
            if (Y === sb2.Y) return;
             //ie ignores duplicates
            var newSb1 = new ClipperLib.Scanbeam();
            newSb1.Y = Y;
            newSb1.Next = sb2.Next;
            sb2.Next = newSb1;
        }
    };
    ClipperLib.ClipperBase.prototype.PopScanbeam = function(Y) {
        if (this.m_Scanbeam === null) {
            Y.v = 0;
            return false;
        }
        Y.v = this.m_Scanbeam.Y;
        this.m_Scanbeam = this.m_Scanbeam.Next;
        return true;
    };
    ClipperLib.ClipperBase.prototype.LocalMinimaPending = function() {
        return this.m_CurrentLM !== null;
    };
    ClipperLib.ClipperBase.prototype.CreateOutRec = function() {
        var result = new ClipperLib.OutRec();
        result.Idx = ClipperLib.ClipperBase.Unassigned;
        result.IsHole = false;
        result.IsOpen = false;
        result.FirstLeft = null;
        result.Pts = null;
        result.BottomPt = null;
        result.PolyNode = null;
        this.m_PolyOuts.push(result);
        result.Idx = this.m_PolyOuts.length - 1;
        return result;
    };
    ClipperLib.ClipperBase.prototype.DisposeOutRec = function(index) {
        var outRec = this.m_PolyOuts[index];
        outRec.Pts = null;
        outRec = null;
        this.m_PolyOuts[index] = null;
    };
    ClipperLib.ClipperBase.prototype.UpdateEdgeIntoAEL = function(e) {
        if (e.NextInLML === null) ClipperLib.Error("UpdateEdgeIntoAEL: invalid call");
        var AelPrev = e.PrevInAEL;
        var AelNext = e.NextInAEL;
        e.NextInLML.OutIdx = e.OutIdx;
        if (AelPrev !== null) AelPrev.NextInAEL = e.NextInLML;
        else this.m_ActiveEdges = e.NextInLML;
        if (AelNext !== null) AelNext.PrevInAEL = e.NextInLML;
        e.NextInLML.Side = e.Side;
        e.NextInLML.WindDelta = e.WindDelta;
        e.NextInLML.WindCnt = e.WindCnt;
        e.NextInLML.WindCnt2 = e.WindCnt2;
        e = e.NextInLML;
        e.Curr.X = e.Bot.X;
        e.Curr.Y = e.Bot.Y;
        e.PrevInAEL = AelPrev;
        e.NextInAEL = AelNext;
        if (!ClipperLib.ClipperBase.IsHorizontal(e)) this.InsertScanbeam(e.Top.Y);
        return e;
    };
    ClipperLib.ClipperBase.prototype.SwapPositionsInAEL = function(edge1, edge2) {
        //check that one or other edge hasn't already been removed from AEL ...
        if (edge1.NextInAEL === edge1.PrevInAEL || edge2.NextInAEL === edge2.PrevInAEL) return;
        if (edge1.NextInAEL === edge2) {
            var next = edge2.NextInAEL;
            if (next !== null) next.PrevInAEL = edge1;
            var prev = edge1.PrevInAEL;
            if (prev !== null) prev.NextInAEL = edge2;
            edge2.PrevInAEL = prev;
            edge2.NextInAEL = edge1;
            edge1.PrevInAEL = edge2;
            edge1.NextInAEL = next;
        } else if (edge2.NextInAEL === edge1) {
            var next1 = edge1.NextInAEL;
            if (next1 !== null) next1.PrevInAEL = edge2;
            var prev1 = edge2.PrevInAEL;
            if (prev1 !== null) prev1.NextInAEL = edge1;
            edge1.PrevInAEL = prev1;
            edge1.NextInAEL = edge2;
            edge2.PrevInAEL = edge1;
            edge2.NextInAEL = next1;
        } else {
            var next2 = edge1.NextInAEL;
            var prev2 = edge1.PrevInAEL;
            edge1.NextInAEL = edge2.NextInAEL;
            if (edge1.NextInAEL !== null) edge1.NextInAEL.PrevInAEL = edge1;
            edge1.PrevInAEL = edge2.PrevInAEL;
            if (edge1.PrevInAEL !== null) edge1.PrevInAEL.NextInAEL = edge1;
            edge2.NextInAEL = next2;
            if (edge2.NextInAEL !== null) edge2.NextInAEL.PrevInAEL = edge2;
            edge2.PrevInAEL = prev2;
            if (edge2.PrevInAEL !== null) edge2.PrevInAEL.NextInAEL = edge2;
        }
        if (edge1.PrevInAEL === null) this.m_ActiveEdges = edge1;
        else if (edge2.PrevInAEL === null) this.m_ActiveEdges = edge2;
    };
    ClipperLib.ClipperBase.prototype.DeleteFromAEL = function(e) {
        var AelPrev = e.PrevInAEL;
        var AelNext = e.NextInAEL;
        if (AelPrev === null && AelNext === null && e !== this.m_ActiveEdges) return;
         //already deleted
        if (AelPrev !== null) AelPrev.NextInAEL = AelNext;
        else this.m_ActiveEdges = AelNext;
        if (AelNext !== null) AelNext.PrevInAEL = AelPrev;
        e.NextInAEL = null;
        e.PrevInAEL = null;
    };
    // public Clipper(int InitOptions = 0)
    /**
	 * @suppress {missingProperties}
	 */ ClipperLib.Clipper = function(InitOptions) {
        if (typeof InitOptions === "undefined") InitOptions = 0;
        this.m_PolyOuts = null;
        this.m_ClipType = ClipperLib.ClipType.ctIntersection;
        this.m_Scanbeam = null;
        this.m_Maxima = null;
        this.m_ActiveEdges = null;
        this.m_SortedEdges = null;
        this.m_IntersectList = null;
        this.m_IntersectNodeComparer = null;
        this.m_ExecuteLocked = false;
        this.m_ClipFillType = ClipperLib.PolyFillType.pftEvenOdd;
        this.m_SubjFillType = ClipperLib.PolyFillType.pftEvenOdd;
        this.m_Joins = null;
        this.m_GhostJoins = null;
        this.m_UsingPolyTree = false;
        this.ReverseSolution = false;
        this.StrictlySimple = false;
        ClipperLib.ClipperBase.call(this);
        this.m_Scanbeam = null;
        this.m_Maxima = null;
        this.m_ActiveEdges = null;
        this.m_SortedEdges = null;
        this.m_IntersectList = new Array();
        this.m_IntersectNodeComparer = ClipperLib.MyIntersectNodeSort.Compare;
        this.m_ExecuteLocked = false;
        this.m_UsingPolyTree = false;
        this.m_PolyOuts = new Array();
        this.m_Joins = new Array();
        this.m_GhostJoins = new Array();
        this.ReverseSolution = (1 & InitOptions) !== 0;
        this.StrictlySimple = (2 & InitOptions) !== 0;
        this.PreserveCollinear = (4 & InitOptions) !== 0;
        if (ClipperLib.use_xyz) this.ZFillFunction = null; // function (IntPoint vert1, IntPoint vert2, ref IntPoint intersectPt);
    };
    ClipperLib.Clipper.ioReverseSolution = 1;
    ClipperLib.Clipper.ioStrictlySimple = 2;
    ClipperLib.Clipper.ioPreserveCollinear = 4;
    ClipperLib.Clipper.prototype.Clear = function() {
        if (this.m_edges.length === 0) return;
        //avoids problems with ClipperBase destructor
        this.DisposeAllPolyPts();
        ClipperLib.ClipperBase.prototype.Clear.call(this);
    };
    ClipperLib.Clipper.prototype.InsertMaxima = function(X) {
        //double-linked list: sorted ascending, ignoring dups.
        var newMax = new ClipperLib.Maxima();
        newMax.X = X;
        if (this.m_Maxima === null) {
            this.m_Maxima = newMax;
            this.m_Maxima.Next = null;
            this.m_Maxima.Prev = null;
        } else if (X < this.m_Maxima.X) {
            newMax.Next = this.m_Maxima;
            newMax.Prev = null;
            this.m_Maxima = newMax;
        } else {
            var m = this.m_Maxima;
            while(m.Next !== null && X >= m.Next.X)m = m.Next;
            if (X === m.X) return;
             //ie ignores duplicates (& CG to clean up newMax)
            //insert newMax between m and m.Next ...
            newMax.Next = m.Next;
            newMax.Prev = m;
            if (m.Next !== null) m.Next.Prev = newMax;
            m.Next = newMax;
        }
    };
    // ************************************
    ClipperLib.Clipper.prototype.Execute = function() {
        var a = arguments, alen = a.length, ispolytree = a[1] instanceof ClipperLib.PolyTree;
        if (alen === 4 && !ispolytree) {
            var clipType = a[0], solution = a[1], subjFillType = a[2], clipFillType = a[3];
            if (this.m_ExecuteLocked) return false;
            if (this.m_HasOpenPaths) ClipperLib.Error("Error: PolyTree struct is needed for open path clipping.");
            this.m_ExecuteLocked = true;
            ClipperLib.Clear(solution);
            this.m_SubjFillType = subjFillType;
            this.m_ClipFillType = clipFillType;
            this.m_ClipType = clipType;
            this.m_UsingPolyTree = false;
            try {
                var succeeded = this.ExecuteInternal();
                //build the return polygons ...
                if (succeeded) this.BuildResult(solution);
            } finally{
                this.DisposeAllPolyPts();
                this.m_ExecuteLocked = false;
            }
            return succeeded;
        } else if (alen === 4 && ispolytree) {
            var clipType = a[0], polytree = a[1], subjFillType = a[2], clipFillType = a[3];
            if (this.m_ExecuteLocked) return false;
            this.m_ExecuteLocked = true;
            this.m_SubjFillType = subjFillType;
            this.m_ClipFillType = clipFillType;
            this.m_ClipType = clipType;
            this.m_UsingPolyTree = true;
            try {
                var succeeded = this.ExecuteInternal();
                //build the return polygons ...
                if (succeeded) this.BuildResult2(polytree);
            } finally{
                this.DisposeAllPolyPts();
                this.m_ExecuteLocked = false;
            }
            return succeeded;
        } else if (alen === 2 && !ispolytree) {
            var clipType = a[0], solution = a[1];
            return this.Execute(clipType, solution, ClipperLib.PolyFillType.pftEvenOdd, ClipperLib.PolyFillType.pftEvenOdd);
        } else if (alen === 2 && ispolytree) {
            var clipType = a[0], polytree = a[1];
            return this.Execute(clipType, polytree, ClipperLib.PolyFillType.pftEvenOdd, ClipperLib.PolyFillType.pftEvenOdd);
        }
    };
    ClipperLib.Clipper.prototype.FixHoleLinkage = function(outRec) {
        //skip if an outermost polygon or
        //already already points to the correct FirstLeft ...
        if (outRec.FirstLeft === null || outRec.IsHole !== outRec.FirstLeft.IsHole && outRec.FirstLeft.Pts !== null) return;
        var orfl = outRec.FirstLeft;
        while(orfl !== null && (orfl.IsHole === outRec.IsHole || orfl.Pts === null))orfl = orfl.FirstLeft;
        outRec.FirstLeft = orfl;
    };
    ClipperLib.Clipper.prototype.ExecuteInternal = function() {
        try {
            this.Reset();
            this.m_SortedEdges = null;
            this.m_Maxima = null;
            var botY = {}, topY = {};
            if (!this.PopScanbeam(botY)) return false;
            this.InsertLocalMinimaIntoAEL(botY.v);
            while(this.PopScanbeam(topY) || this.LocalMinimaPending()){
                this.ProcessHorizontals();
                this.m_GhostJoins.length = 0;
                if (!this.ProcessIntersections(topY.v)) return false;
                this.ProcessEdgesAtTopOfScanbeam(topY.v);
                botY.v = topY.v;
                this.InsertLocalMinimaIntoAEL(botY.v);
            }
            //fix orientations ...
            var outRec, i, ilen;
            //fix orientations ...
            for(i = 0, ilen = this.m_PolyOuts.length; i < ilen; i++){
                outRec = this.m_PolyOuts[i];
                if (outRec.Pts === null || outRec.IsOpen) continue;
                if ((outRec.IsHole ^ this.ReverseSolution) == this.Area$1(outRec) > 0) this.ReversePolyPtLinks(outRec.Pts);
            }
            this.JoinCommonEdges();
            for(i = 0, ilen = this.m_PolyOuts.length; i < ilen; i++){
                outRec = this.m_PolyOuts[i];
                if (outRec.Pts === null) continue;
                else if (outRec.IsOpen) this.FixupOutPolyline(outRec);
                else this.FixupOutPolygon(outRec);
            }
            if (this.StrictlySimple) this.DoSimplePolygons();
            return true;
        } finally{
            this.m_Joins.length = 0;
            this.m_GhostJoins.length = 0;
        }
    };
    ClipperLib.Clipper.prototype.DisposeAllPolyPts = function() {
        for(var i = 0, ilen = this.m_PolyOuts.length; i < ilen; ++i)this.DisposeOutRec(i);
        ClipperLib.Clear(this.m_PolyOuts);
    };
    ClipperLib.Clipper.prototype.AddJoin = function(Op1, Op2, OffPt) {
        var j = new ClipperLib.Join();
        j.OutPt1 = Op1;
        j.OutPt2 = Op2;
        //j.OffPt = OffPt;
        j.OffPt.X = OffPt.X;
        j.OffPt.Y = OffPt.Y;
        if (ClipperLib.use_xyz) j.OffPt.Z = OffPt.Z;
        this.m_Joins.push(j);
    };
    ClipperLib.Clipper.prototype.AddGhostJoin = function(Op, OffPt) {
        var j = new ClipperLib.Join();
        j.OutPt1 = Op;
        //j.OffPt = OffPt;
        j.OffPt.X = OffPt.X;
        j.OffPt.Y = OffPt.Y;
        if (ClipperLib.use_xyz) j.OffPt.Z = OffPt.Z;
        this.m_GhostJoins.push(j);
    };
    //if (ClipperLib.use_xyz)
    //{
    ClipperLib.Clipper.prototype.SetZ = function(pt, e1, e2) {
        if (this.ZFillFunction !== null) {
            if (pt.Z !== 0 || this.ZFillFunction === null) return;
            else if (ClipperLib.IntPoint.op_Equality(pt, e1.Bot)) pt.Z = e1.Bot.Z;
            else if (ClipperLib.IntPoint.op_Equality(pt, e1.Top)) pt.Z = e1.Top.Z;
            else if (ClipperLib.IntPoint.op_Equality(pt, e2.Bot)) pt.Z = e2.Bot.Z;
            else if (ClipperLib.IntPoint.op_Equality(pt, e2.Top)) pt.Z = e2.Top.Z;
            else this.ZFillFunction(e1.Bot, e1.Top, e2.Bot, e2.Top, pt);
        }
    };
    //}
    ClipperLib.Clipper.prototype.InsertLocalMinimaIntoAEL = function(botY) {
        var lm = {};
        var lb;
        var rb;
        while(this.PopLocalMinima(botY, lm)){
            lb = lm.v.LeftBound;
            rb = lm.v.RightBound;
            var Op1 = null;
            if (lb === null) {
                this.InsertEdgeIntoAEL(rb, null);
                this.SetWindingCount(rb);
                if (this.IsContributing(rb)) Op1 = this.AddOutPt(rb, rb.Bot);
            } else if (rb === null) {
                this.InsertEdgeIntoAEL(lb, null);
                this.SetWindingCount(lb);
                if (this.IsContributing(lb)) Op1 = this.AddOutPt(lb, lb.Bot);
                this.InsertScanbeam(lb.Top.Y);
            } else {
                this.InsertEdgeIntoAEL(lb, null);
                this.InsertEdgeIntoAEL(rb, lb);
                this.SetWindingCount(lb);
                rb.WindCnt = lb.WindCnt;
                rb.WindCnt2 = lb.WindCnt2;
                if (this.IsContributing(lb)) Op1 = this.AddLocalMinPoly(lb, rb, lb.Bot);
                this.InsertScanbeam(lb.Top.Y);
            }
            if (rb !== null) {
                if (ClipperLib.ClipperBase.IsHorizontal(rb)) {
                    if (rb.NextInLML !== null) this.InsertScanbeam(rb.NextInLML.Top.Y);
                    this.AddEdgeToSEL(rb);
                } else this.InsertScanbeam(rb.Top.Y);
            }
            if (lb === null || rb === null) continue;
            //if output polygons share an Edge with a horizontal rb, they'll need joining later ...
            if (Op1 !== null && ClipperLib.ClipperBase.IsHorizontal(rb) && this.m_GhostJoins.length > 0 && rb.WindDelta !== 0) for(var i = 0, ilen = this.m_GhostJoins.length; i < ilen; i++){
                //if the horizontal Rb and a 'ghost' horizontal overlap, then convert
                //the 'ghost' join to a real join ready for later ...
                var j = this.m_GhostJoins[i];
                if (this.HorzSegmentsOverlap(j.OutPt1.Pt.X, j.OffPt.X, rb.Bot.X, rb.Top.X)) this.AddJoin(j.OutPt1, Op1, j.OffPt);
            }
            if (lb.OutIdx >= 0 && lb.PrevInAEL !== null && lb.PrevInAEL.Curr.X === lb.Bot.X && lb.PrevInAEL.OutIdx >= 0 && ClipperLib.ClipperBase.SlopesEqual5(lb.PrevInAEL.Curr, lb.PrevInAEL.Top, lb.Curr, lb.Top, this.m_UseFullRange) && lb.WindDelta !== 0 && lb.PrevInAEL.WindDelta !== 0) {
                var Op2 = this.AddOutPt(lb.PrevInAEL, lb.Bot);
                this.AddJoin(Op1, Op2, lb.Top);
            }
            if (lb.NextInAEL !== rb) {
                if (rb.OutIdx >= 0 && rb.PrevInAEL.OutIdx >= 0 && ClipperLib.ClipperBase.SlopesEqual5(rb.PrevInAEL.Curr, rb.PrevInAEL.Top, rb.Curr, rb.Top, this.m_UseFullRange) && rb.WindDelta !== 0 && rb.PrevInAEL.WindDelta !== 0) {
                    var Op2 = this.AddOutPt(rb.PrevInAEL, rb.Bot);
                    this.AddJoin(Op1, Op2, rb.Top);
                }
                var e = lb.NextInAEL;
                if (e !== null) while(e !== rb){
                    //nb: For calculating winding counts etc, IntersectEdges() assumes
                    //that param1 will be to the right of param2 ABOVE the intersection ...
                    this.IntersectEdges(rb, e, lb.Curr);
                    //order important here
                    e = e.NextInAEL;
                }
            }
        }
    };
    ClipperLib.Clipper.prototype.InsertEdgeIntoAEL = function(edge, startEdge) {
        if (this.m_ActiveEdges === null) {
            edge.PrevInAEL = null;
            edge.NextInAEL = null;
            this.m_ActiveEdges = edge;
        } else if (startEdge === null && this.E2InsertsBeforeE1(this.m_ActiveEdges, edge)) {
            edge.PrevInAEL = null;
            edge.NextInAEL = this.m_ActiveEdges;
            this.m_ActiveEdges.PrevInAEL = edge;
            this.m_ActiveEdges = edge;
        } else {
            if (startEdge === null) startEdge = this.m_ActiveEdges;
            while(startEdge.NextInAEL !== null && !this.E2InsertsBeforeE1(startEdge.NextInAEL, edge))startEdge = startEdge.NextInAEL;
            edge.NextInAEL = startEdge.NextInAEL;
            if (startEdge.NextInAEL !== null) startEdge.NextInAEL.PrevInAEL = edge;
            edge.PrevInAEL = startEdge;
            startEdge.NextInAEL = edge;
        }
    };
    ClipperLib.Clipper.prototype.E2InsertsBeforeE1 = function(e1, e2) {
        if (e2.Curr.X === e1.Curr.X) {
            if (e2.Top.Y > e1.Top.Y) return e2.Top.X < ClipperLib.Clipper.TopX(e1, e2.Top.Y);
            else return e1.Top.X > ClipperLib.Clipper.TopX(e2, e1.Top.Y);
        } else return e2.Curr.X < e1.Curr.X;
    };
    ClipperLib.Clipper.prototype.IsEvenOddFillType = function(edge) {
        if (edge.PolyTyp === ClipperLib.PolyType.ptSubject) return this.m_SubjFillType === ClipperLib.PolyFillType.pftEvenOdd;
        else return this.m_ClipFillType === ClipperLib.PolyFillType.pftEvenOdd;
    };
    ClipperLib.Clipper.prototype.IsEvenOddAltFillType = function(edge) {
        if (edge.PolyTyp === ClipperLib.PolyType.ptSubject) return this.m_ClipFillType === ClipperLib.PolyFillType.pftEvenOdd;
        else return this.m_SubjFillType === ClipperLib.PolyFillType.pftEvenOdd;
    };
    ClipperLib.Clipper.prototype.IsContributing = function(edge) {
        var pft, pft2;
        if (edge.PolyTyp === ClipperLib.PolyType.ptSubject) {
            pft = this.m_SubjFillType;
            pft2 = this.m_ClipFillType;
        } else {
            pft = this.m_ClipFillType;
            pft2 = this.m_SubjFillType;
        }
        switch(pft){
            case ClipperLib.PolyFillType.pftEvenOdd:
                if (edge.WindDelta === 0 && edge.WindCnt !== 1) return false;
                break;
            case ClipperLib.PolyFillType.pftNonZero:
                if (Math.abs(edge.WindCnt) !== 1) return false;
                break;
            case ClipperLib.PolyFillType.pftPositive:
                if (edge.WindCnt !== 1) return false;
                break;
            default:
                if (edge.WindCnt !== -1) return false;
                break;
        }
        switch(this.m_ClipType){
            case ClipperLib.ClipType.ctIntersection:
                switch(pft2){
                    case ClipperLib.PolyFillType.pftEvenOdd:
                    case ClipperLib.PolyFillType.pftNonZero:
                        return edge.WindCnt2 !== 0;
                    case ClipperLib.PolyFillType.pftPositive:
                        return edge.WindCnt2 > 0;
                    default:
                        return edge.WindCnt2 < 0;
                }
            case ClipperLib.ClipType.ctUnion:
                switch(pft2){
                    case ClipperLib.PolyFillType.pftEvenOdd:
                    case ClipperLib.PolyFillType.pftNonZero:
                        return edge.WindCnt2 === 0;
                    case ClipperLib.PolyFillType.pftPositive:
                        return edge.WindCnt2 <= 0;
                    default:
                        return edge.WindCnt2 >= 0;
                }
            case ClipperLib.ClipType.ctDifference:
                if (edge.PolyTyp === ClipperLib.PolyType.ptSubject) switch(pft2){
                    case ClipperLib.PolyFillType.pftEvenOdd:
                    case ClipperLib.PolyFillType.pftNonZero:
                        return edge.WindCnt2 === 0;
                    case ClipperLib.PolyFillType.pftPositive:
                        return edge.WindCnt2 <= 0;
                    default:
                        return edge.WindCnt2 >= 0;
                }
                else switch(pft2){
                    case ClipperLib.PolyFillType.pftEvenOdd:
                    case ClipperLib.PolyFillType.pftNonZero:
                        return edge.WindCnt2 !== 0;
                    case ClipperLib.PolyFillType.pftPositive:
                        return edge.WindCnt2 > 0;
                    default:
                        return edge.WindCnt2 < 0;
                }
            case ClipperLib.ClipType.ctXor:
                if (edge.WindDelta === 0) switch(pft2){
                    case ClipperLib.PolyFillType.pftEvenOdd:
                    case ClipperLib.PolyFillType.pftNonZero:
                        return edge.WindCnt2 === 0;
                    case ClipperLib.PolyFillType.pftPositive:
                        return edge.WindCnt2 <= 0;
                    default:
                        return edge.WindCnt2 >= 0;
                }
                else return true;
        }
        return true;
    };
    ClipperLib.Clipper.prototype.SetWindingCount = function(edge) {
        var e = edge.PrevInAEL;
        //find the edge of the same polytype that immediately preceeds 'edge' in AEL
        while(e !== null && (e.PolyTyp !== edge.PolyTyp || e.WindDelta === 0))e = e.PrevInAEL;
        if (e === null) {
            var pft = edge.PolyTyp === ClipperLib.PolyType.ptSubject ? this.m_SubjFillType : this.m_ClipFillType;
            if (edge.WindDelta === 0) edge.WindCnt = pft === ClipperLib.PolyFillType.pftNegative ? -1 : 1;
            else edge.WindCnt = edge.WindDelta;
            edge.WindCnt2 = 0;
            e = this.m_ActiveEdges;
        //ie get ready to calc WindCnt2
        } else if (edge.WindDelta === 0 && this.m_ClipType !== ClipperLib.ClipType.ctUnion) {
            edge.WindCnt = 1;
            edge.WindCnt2 = e.WindCnt2;
            e = e.NextInAEL;
        //ie get ready to calc WindCnt2
        } else if (this.IsEvenOddFillType(edge)) {
            //EvenOdd filling ...
            if (edge.WindDelta === 0) {
                //are we inside a subj polygon ...
                var Inside = true;
                var e2 = e.PrevInAEL;
                while(e2 !== null){
                    if (e2.PolyTyp === e.PolyTyp && e2.WindDelta !== 0) Inside = !Inside;
                    e2 = e2.PrevInAEL;
                }
                edge.WindCnt = Inside ? 0 : 1;
            } else edge.WindCnt = edge.WindDelta;
            edge.WindCnt2 = e.WindCnt2;
            e = e.NextInAEL;
        //ie get ready to calc WindCnt2
        } else {
            //nonZero, Positive or Negative filling ...
            if (e.WindCnt * e.WindDelta < 0) {
                //prev edge is 'decreasing' WindCount (WC) toward zero
                //so we're outside the previous polygon ...
                if (Math.abs(e.WindCnt) > 1) {
                    //outside prev poly but still inside another.
                    //when reversing direction of prev poly use the same WC
                    if (e.WindDelta * edge.WindDelta < 0) edge.WindCnt = e.WindCnt;
                    else edge.WindCnt = e.WindCnt + edge.WindDelta;
                } else edge.WindCnt = edge.WindDelta === 0 ? 1 : edge.WindDelta;
            } else {
                //prev edge is 'increasing' WindCount (WC) away from zero
                //so we're inside the previous polygon ...
                if (edge.WindDelta === 0) edge.WindCnt = e.WindCnt < 0 ? e.WindCnt - 1 : e.WindCnt + 1;
                else if (e.WindDelta * edge.WindDelta < 0) edge.WindCnt = e.WindCnt;
                else edge.WindCnt = e.WindCnt + edge.WindDelta;
            }
            edge.WindCnt2 = e.WindCnt2;
            e = e.NextInAEL;
        //ie get ready to calc WindCnt2
        }
        //update WindCnt2 ...
        if (this.IsEvenOddAltFillType(edge)) //EvenOdd filling ...
        while(e !== edge){
            if (e.WindDelta !== 0) edge.WindCnt2 = edge.WindCnt2 === 0 ? 1 : 0;
            e = e.NextInAEL;
        }
        else //nonZero, Positive or Negative filling ...
        while(e !== edge){
            edge.WindCnt2 += e.WindDelta;
            e = e.NextInAEL;
        }
    };
    ClipperLib.Clipper.prototype.AddEdgeToSEL = function(edge) {
        //SEL pointers in PEdge are use to build transient lists of horizontal edges.
        //However, since we don't need to worry about processing order, all additions
        //are made to the front of the list ...
        if (this.m_SortedEdges === null) {
            this.m_SortedEdges = edge;
            edge.PrevInSEL = null;
            edge.NextInSEL = null;
        } else {
            edge.NextInSEL = this.m_SortedEdges;
            edge.PrevInSEL = null;
            this.m_SortedEdges.PrevInSEL = edge;
            this.m_SortedEdges = edge;
        }
    };
    ClipperLib.Clipper.prototype.PopEdgeFromSEL = function(e) {
        //Pop edge from front of SEL (ie SEL is a FILO list)
        e.v = this.m_SortedEdges;
        if (e.v === null) return false;
        var oldE = e.v;
        this.m_SortedEdges = e.v.NextInSEL;
        if (this.m_SortedEdges !== null) this.m_SortedEdges.PrevInSEL = null;
        oldE.NextInSEL = null;
        oldE.PrevInSEL = null;
        return true;
    };
    ClipperLib.Clipper.prototype.CopyAELToSEL = function() {
        var e = this.m_ActiveEdges;
        this.m_SortedEdges = e;
        while(e !== null){
            e.PrevInSEL = e.PrevInAEL;
            e.NextInSEL = e.NextInAEL;
            e = e.NextInAEL;
        }
    };
    ClipperLib.Clipper.prototype.SwapPositionsInSEL = function(edge1, edge2) {
        if (edge1.NextInSEL === null && edge1.PrevInSEL === null) return;
        if (edge2.NextInSEL === null && edge2.PrevInSEL === null) return;
        if (edge1.NextInSEL === edge2) {
            var next = edge2.NextInSEL;
            if (next !== null) next.PrevInSEL = edge1;
            var prev = edge1.PrevInSEL;
            if (prev !== null) prev.NextInSEL = edge2;
            edge2.PrevInSEL = prev;
            edge2.NextInSEL = edge1;
            edge1.PrevInSEL = edge2;
            edge1.NextInSEL = next;
        } else if (edge2.NextInSEL === edge1) {
            var next = edge1.NextInSEL;
            if (next !== null) next.PrevInSEL = edge2;
            var prev = edge2.PrevInSEL;
            if (prev !== null) prev.NextInSEL = edge1;
            edge1.PrevInSEL = prev;
            edge1.NextInSEL = edge2;
            edge2.PrevInSEL = edge1;
            edge2.NextInSEL = next;
        } else {
            var next = edge1.NextInSEL;
            var prev = edge1.PrevInSEL;
            edge1.NextInSEL = edge2.NextInSEL;
            if (edge1.NextInSEL !== null) edge1.NextInSEL.PrevInSEL = edge1;
            edge1.PrevInSEL = edge2.PrevInSEL;
            if (edge1.PrevInSEL !== null) edge1.PrevInSEL.NextInSEL = edge1;
            edge2.NextInSEL = next;
            if (edge2.NextInSEL !== null) edge2.NextInSEL.PrevInSEL = edge2;
            edge2.PrevInSEL = prev;
            if (edge2.PrevInSEL !== null) edge2.PrevInSEL.NextInSEL = edge2;
        }
        if (edge1.PrevInSEL === null) this.m_SortedEdges = edge1;
        else if (edge2.PrevInSEL === null) this.m_SortedEdges = edge2;
    };
    ClipperLib.Clipper.prototype.AddLocalMaxPoly = function(e1, e2, pt) {
        this.AddOutPt(e1, pt);
        if (e2.WindDelta === 0) this.AddOutPt(e2, pt);
        if (e1.OutIdx === e2.OutIdx) {
            e1.OutIdx = -1;
            e2.OutIdx = -1;
        } else if (e1.OutIdx < e2.OutIdx) this.AppendPolygon(e1, e2);
        else this.AppendPolygon(e2, e1);
    };
    ClipperLib.Clipper.prototype.AddLocalMinPoly = function(e1, e2, pt) {
        var result;
        var e, prevE;
        if (ClipperLib.ClipperBase.IsHorizontal(e2) || e1.Dx > e2.Dx) {
            result = this.AddOutPt(e1, pt);
            e2.OutIdx = e1.OutIdx;
            e1.Side = ClipperLib.EdgeSide.esLeft;
            e2.Side = ClipperLib.EdgeSide.esRight;
            e = e1;
            if (e.PrevInAEL === e2) prevE = e2.PrevInAEL;
            else prevE = e.PrevInAEL;
        } else {
            result = this.AddOutPt(e2, pt);
            e1.OutIdx = e2.OutIdx;
            e1.Side = ClipperLib.EdgeSide.esRight;
            e2.Side = ClipperLib.EdgeSide.esLeft;
            e = e2;
            if (e.PrevInAEL === e1) prevE = e1.PrevInAEL;
            else prevE = e.PrevInAEL;
        }
        if (prevE !== null && prevE.OutIdx >= 0 && prevE.Top.Y < pt.Y && e.Top.Y < pt.Y) {
            var xPrev = ClipperLib.Clipper.TopX(prevE, pt.Y);
            var xE = ClipperLib.Clipper.TopX(e, pt.Y);
            if (xPrev === xE && e.WindDelta !== 0 && prevE.WindDelta !== 0 && ClipperLib.ClipperBase.SlopesEqual5(new ClipperLib.IntPoint2(xPrev, pt.Y), prevE.Top, new ClipperLib.IntPoint2(xE, pt.Y), e.Top, this.m_UseFullRange)) {
                var outPt = this.AddOutPt(prevE, pt);
                this.AddJoin(result, outPt, e.Top);
            }
        }
        return result;
    };
    ClipperLib.Clipper.prototype.AddOutPt = function(e, pt) {
        if (e.OutIdx < 0) {
            var outRec = this.CreateOutRec();
            outRec.IsOpen = e.WindDelta === 0;
            var newOp = new ClipperLib.OutPt();
            outRec.Pts = newOp;
            newOp.Idx = outRec.Idx;
            //newOp.Pt = pt;
            newOp.Pt.X = pt.X;
            newOp.Pt.Y = pt.Y;
            if (ClipperLib.use_xyz) newOp.Pt.Z = pt.Z;
            newOp.Next = newOp;
            newOp.Prev = newOp;
            if (!outRec.IsOpen) this.SetHoleState(e, outRec);
            e.OutIdx = outRec.Idx;
            //nb: do this after SetZ !
            return newOp;
        } else {
            var outRec = this.m_PolyOuts[e.OutIdx];
            //OutRec.Pts is the 'Left-most' point & OutRec.Pts.Prev is the 'Right-most'
            var op = outRec.Pts;
            var ToFront = e.Side === ClipperLib.EdgeSide.esLeft;
            if (ToFront && ClipperLib.IntPoint.op_Equality(pt, op.Pt)) return op;
            else if (!ToFront && ClipperLib.IntPoint.op_Equality(pt, op.Prev.Pt)) return op.Prev;
            var newOp = new ClipperLib.OutPt();
            newOp.Idx = outRec.Idx;
            //newOp.Pt = pt;
            newOp.Pt.X = pt.X;
            newOp.Pt.Y = pt.Y;
            if (ClipperLib.use_xyz) newOp.Pt.Z = pt.Z;
            newOp.Next = op;
            newOp.Prev = op.Prev;
            newOp.Prev.Next = newOp;
            op.Prev = newOp;
            if (ToFront) outRec.Pts = newOp;
            return newOp;
        }
    };
    ClipperLib.Clipper.prototype.GetLastOutPt = function(e) {
        var outRec = this.m_PolyOuts[e.OutIdx];
        if (e.Side === ClipperLib.EdgeSide.esLeft) return outRec.Pts;
        else return outRec.Pts.Prev;
    };
    ClipperLib.Clipper.prototype.SwapPoints = function(pt1, pt2) {
        var tmp = new ClipperLib.IntPoint1(pt1.Value);
        //pt1.Value = pt2.Value;
        pt1.Value.X = pt2.Value.X;
        pt1.Value.Y = pt2.Value.Y;
        if (ClipperLib.use_xyz) pt1.Value.Z = pt2.Value.Z;
        //pt2.Value = tmp;
        pt2.Value.X = tmp.X;
        pt2.Value.Y = tmp.Y;
        if (ClipperLib.use_xyz) pt2.Value.Z = tmp.Z;
    };
    ClipperLib.Clipper.prototype.HorzSegmentsOverlap = function(seg1a, seg1b, seg2a, seg2b) {
        var tmp;
        if (seg1a > seg1b) {
            tmp = seg1a;
            seg1a = seg1b;
            seg1b = tmp;
        }
        if (seg2a > seg2b) {
            tmp = seg2a;
            seg2a = seg2b;
            seg2b = tmp;
        }
        return seg1a < seg2b && seg2a < seg1b;
    };
    ClipperLib.Clipper.prototype.SetHoleState = function(e, outRec) {
        var e2 = e.PrevInAEL;
        var eTmp = null;
        while(e2 !== null){
            if (e2.OutIdx >= 0 && e2.WindDelta !== 0) {
                if (eTmp === null) eTmp = e2;
                else if (eTmp.OutIdx === e2.OutIdx) eTmp = null; //paired
            }
            e2 = e2.PrevInAEL;
        }
        if (eTmp === null) {
            outRec.FirstLeft = null;
            outRec.IsHole = false;
        } else {
            outRec.FirstLeft = this.m_PolyOuts[eTmp.OutIdx];
            outRec.IsHole = !outRec.FirstLeft.IsHole;
        }
    };
    ClipperLib.Clipper.prototype.GetDx = function(pt1, pt2) {
        if (pt1.Y === pt2.Y) return ClipperLib.ClipperBase.horizontal;
        else return (pt2.X - pt1.X) / (pt2.Y - pt1.Y);
    };
    ClipperLib.Clipper.prototype.FirstIsBottomPt = function(btmPt1, btmPt2) {
        var p = btmPt1.Prev;
        while(ClipperLib.IntPoint.op_Equality(p.Pt, btmPt1.Pt) && p !== btmPt1)p = p.Prev;
        var dx1p = Math.abs(this.GetDx(btmPt1.Pt, p.Pt));
        p = btmPt1.Next;
        while(ClipperLib.IntPoint.op_Equality(p.Pt, btmPt1.Pt) && p !== btmPt1)p = p.Next;
        var dx1n = Math.abs(this.GetDx(btmPt1.Pt, p.Pt));
        p = btmPt2.Prev;
        while(ClipperLib.IntPoint.op_Equality(p.Pt, btmPt2.Pt) && p !== btmPt2)p = p.Prev;
        var dx2p = Math.abs(this.GetDx(btmPt2.Pt, p.Pt));
        p = btmPt2.Next;
        while(ClipperLib.IntPoint.op_Equality(p.Pt, btmPt2.Pt) && p !== btmPt2)p = p.Next;
        var dx2n = Math.abs(this.GetDx(btmPt2.Pt, p.Pt));
        if (Math.max(dx1p, dx1n) === Math.max(dx2p, dx2n) && Math.min(dx1p, dx1n) === Math.min(dx2p, dx2n)) return this.Area(btmPt1) > 0; //if otherwise identical use orientation
        else return dx1p >= dx2p && dx1p >= dx2n || dx1n >= dx2p && dx1n >= dx2n;
    };
    ClipperLib.Clipper.prototype.GetBottomPt = function(pp) {
        var dups = null;
        var p = pp.Next;
        while(p !== pp){
            if (p.Pt.Y > pp.Pt.Y) {
                pp = p;
                dups = null;
            } else if (p.Pt.Y === pp.Pt.Y && p.Pt.X <= pp.Pt.X) {
                if (p.Pt.X < pp.Pt.X) {
                    dups = null;
                    pp = p;
                } else if (p.Next !== pp && p.Prev !== pp) dups = p;
            }
            p = p.Next;
        }
        if (dups !== null) //there appears to be at least 2 vertices at bottomPt so ...
        while(dups !== p){
            if (!this.FirstIsBottomPt(p, dups)) pp = dups;
            dups = dups.Next;
            while(ClipperLib.IntPoint.op_Inequality(dups.Pt, pp.Pt))dups = dups.Next;
        }
        return pp;
    };
    ClipperLib.Clipper.prototype.GetLowermostRec = function(outRec1, outRec2) {
        //work out which polygon fragment has the correct hole state ...
        if (outRec1.BottomPt === null) outRec1.BottomPt = this.GetBottomPt(outRec1.Pts);
        if (outRec2.BottomPt === null) outRec2.BottomPt = this.GetBottomPt(outRec2.Pts);
        var bPt1 = outRec1.BottomPt;
        var bPt2 = outRec2.BottomPt;
        if (bPt1.Pt.Y > bPt2.Pt.Y) return outRec1;
        else if (bPt1.Pt.Y < bPt2.Pt.Y) return outRec2;
        else if (bPt1.Pt.X < bPt2.Pt.X) return outRec1;
        else if (bPt1.Pt.X > bPt2.Pt.X) return outRec2;
        else if (bPt1.Next === bPt1) return outRec2;
        else if (bPt2.Next === bPt2) return outRec1;
        else if (this.FirstIsBottomPt(bPt1, bPt2)) return outRec1;
        else return outRec2;
    };
    ClipperLib.Clipper.prototype.OutRec1RightOfOutRec2 = function(outRec1, outRec2) {
        do {
            outRec1 = outRec1.FirstLeft;
            if (outRec1 === outRec2) return true;
        }while (outRec1 !== null);
        return false;
    };
    ClipperLib.Clipper.prototype.GetOutRec = function(idx) {
        var outrec = this.m_PolyOuts[idx];
        while(outrec !== this.m_PolyOuts[outrec.Idx])outrec = this.m_PolyOuts[outrec.Idx];
        return outrec;
    };
    ClipperLib.Clipper.prototype.AppendPolygon = function(e1, e2) {
        //get the start and ends of both output polygons ...
        var outRec1 = this.m_PolyOuts[e1.OutIdx];
        var outRec2 = this.m_PolyOuts[e2.OutIdx];
        var holeStateRec;
        if (this.OutRec1RightOfOutRec2(outRec1, outRec2)) holeStateRec = outRec2;
        else if (this.OutRec1RightOfOutRec2(outRec2, outRec1)) holeStateRec = outRec1;
        else holeStateRec = this.GetLowermostRec(outRec1, outRec2);
        //get the start and ends of both output polygons and
        //join E2 poly onto E1 poly and delete pointers to E2 ...
        var p1_lft = outRec1.Pts;
        var p1_rt = p1_lft.Prev;
        var p2_lft = outRec2.Pts;
        var p2_rt = p2_lft.Prev;
        //join e2 poly onto e1 poly and delete pointers to e2 ...
        if (e1.Side === ClipperLib.EdgeSide.esLeft) {
            if (e2.Side === ClipperLib.EdgeSide.esLeft) {
                //z y x a b c
                this.ReversePolyPtLinks(p2_lft);
                p2_lft.Next = p1_lft;
                p1_lft.Prev = p2_lft;
                p1_rt.Next = p2_rt;
                p2_rt.Prev = p1_rt;
                outRec1.Pts = p2_rt;
            } else {
                //x y z a b c
                p2_rt.Next = p1_lft;
                p1_lft.Prev = p2_rt;
                p2_lft.Prev = p1_rt;
                p1_rt.Next = p2_lft;
                outRec1.Pts = p2_lft;
            }
        } else if (e2.Side === ClipperLib.EdgeSide.esRight) {
            //a b c z y x
            this.ReversePolyPtLinks(p2_lft);
            p1_rt.Next = p2_rt;
            p2_rt.Prev = p1_rt;
            p2_lft.Next = p1_lft;
            p1_lft.Prev = p2_lft;
        } else {
            //a b c x y z
            p1_rt.Next = p2_lft;
            p2_lft.Prev = p1_rt;
            p1_lft.Prev = p2_rt;
            p2_rt.Next = p1_lft;
        }
        outRec1.BottomPt = null;
        if (holeStateRec === outRec2) {
            if (outRec2.FirstLeft !== outRec1) outRec1.FirstLeft = outRec2.FirstLeft;
            outRec1.IsHole = outRec2.IsHole;
        }
        outRec2.Pts = null;
        outRec2.BottomPt = null;
        outRec2.FirstLeft = outRec1;
        var OKIdx = e1.OutIdx;
        var ObsoleteIdx = e2.OutIdx;
        e1.OutIdx = -1;
        //nb: safe because we only get here via AddLocalMaxPoly
        e2.OutIdx = -1;
        var e = this.m_ActiveEdges;
        while(e !== null){
            if (e.OutIdx === ObsoleteIdx) {
                e.OutIdx = OKIdx;
                e.Side = e1.Side;
                break;
            }
            e = e.NextInAEL;
        }
        outRec2.Idx = outRec1.Idx;
    };
    ClipperLib.Clipper.prototype.ReversePolyPtLinks = function(pp) {
        if (pp === null) return;
        var pp1;
        var pp2;
        pp1 = pp;
        do {
            pp2 = pp1.Next;
            pp1.Next = pp1.Prev;
            pp1.Prev = pp2;
            pp1 = pp2;
        }while (pp1 !== pp);
    };
    ClipperLib.Clipper.SwapSides = function(edge1, edge2) {
        var side = edge1.Side;
        edge1.Side = edge2.Side;
        edge2.Side = side;
    };
    ClipperLib.Clipper.SwapPolyIndexes = function(edge1, edge2) {
        var outIdx = edge1.OutIdx;
        edge1.OutIdx = edge2.OutIdx;
        edge2.OutIdx = outIdx;
    };
    ClipperLib.Clipper.prototype.IntersectEdges = function(e1, e2, pt) {
        //e1 will be to the left of e2 BELOW the intersection. Therefore e1 is before
        //e2 in AEL except when e1 is being inserted at the intersection point ...
        var e1Contributing = e1.OutIdx >= 0;
        var e2Contributing = e2.OutIdx >= 0;
        if (ClipperLib.use_xyz) this.SetZ(pt, e1, e2);
        if (ClipperLib.use_lines) //if either edge is on an OPEN path ...
        {
            if (e1.WindDelta === 0 || e2.WindDelta === 0) {
                //ignore subject-subject open path intersections UNLESS they
                //are both open paths, AND they are both 'contributing maximas' ...
                if (e1.WindDelta === 0 && e2.WindDelta === 0) return;
                else if (e1.PolyTyp === e2.PolyTyp && e1.WindDelta !== e2.WindDelta && this.m_ClipType === ClipperLib.ClipType.ctUnion) {
                    if (e1.WindDelta === 0) {
                        if (e2Contributing) {
                            this.AddOutPt(e1, pt);
                            if (e1Contributing) e1.OutIdx = -1;
                        }
                    } else if (e1Contributing) {
                        this.AddOutPt(e2, pt);
                        if (e2Contributing) e2.OutIdx = -1;
                    }
                } else if (e1.PolyTyp !== e2.PolyTyp) {
                    if (e1.WindDelta === 0 && Math.abs(e2.WindCnt) === 1 && (this.m_ClipType !== ClipperLib.ClipType.ctUnion || e2.WindCnt2 === 0)) {
                        this.AddOutPt(e1, pt);
                        if (e1Contributing) e1.OutIdx = -1;
                    } else if (e2.WindDelta === 0 && Math.abs(e1.WindCnt) === 1 && (this.m_ClipType !== ClipperLib.ClipType.ctUnion || e1.WindCnt2 === 0)) {
                        this.AddOutPt(e2, pt);
                        if (e2Contributing) e2.OutIdx = -1;
                    }
                }
                return;
            }
        }
        //update winding counts...
        //assumes that e1 will be to the Right of e2 ABOVE the intersection
        if (e1.PolyTyp === e2.PolyTyp) {
            if (this.IsEvenOddFillType(e1)) {
                var oldE1WindCnt = e1.WindCnt;
                e1.WindCnt = e2.WindCnt;
                e2.WindCnt = oldE1WindCnt;
            } else {
                if (e1.WindCnt + e2.WindDelta === 0) e1.WindCnt = -e1.WindCnt;
                else e1.WindCnt += e2.WindDelta;
                if (e2.WindCnt - e1.WindDelta === 0) e2.WindCnt = -e2.WindCnt;
                else e2.WindCnt -= e1.WindDelta;
            }
        } else {
            if (!this.IsEvenOddFillType(e2)) e1.WindCnt2 += e2.WindDelta;
            else e1.WindCnt2 = e1.WindCnt2 === 0 ? 1 : 0;
            if (!this.IsEvenOddFillType(e1)) e2.WindCnt2 -= e1.WindDelta;
            else e2.WindCnt2 = e2.WindCnt2 === 0 ? 1 : 0;
        }
        var e1FillType, e2FillType, e1FillType2, e2FillType2;
        if (e1.PolyTyp === ClipperLib.PolyType.ptSubject) {
            e1FillType = this.m_SubjFillType;
            e1FillType2 = this.m_ClipFillType;
        } else {
            e1FillType = this.m_ClipFillType;
            e1FillType2 = this.m_SubjFillType;
        }
        if (e2.PolyTyp === ClipperLib.PolyType.ptSubject) {
            e2FillType = this.m_SubjFillType;
            e2FillType2 = this.m_ClipFillType;
        } else {
            e2FillType = this.m_ClipFillType;
            e2FillType2 = this.m_SubjFillType;
        }
        var e1Wc, e2Wc;
        switch(e1FillType){
            case ClipperLib.PolyFillType.pftPositive:
                e1Wc = e1.WindCnt;
                break;
            case ClipperLib.PolyFillType.pftNegative:
                e1Wc = -e1.WindCnt;
                break;
            default:
                e1Wc = Math.abs(e1.WindCnt);
                break;
        }
        switch(e2FillType){
            case ClipperLib.PolyFillType.pftPositive:
                e2Wc = e2.WindCnt;
                break;
            case ClipperLib.PolyFillType.pftNegative:
                e2Wc = -e2.WindCnt;
                break;
            default:
                e2Wc = Math.abs(e2.WindCnt);
                break;
        }
        if (e1Contributing && e2Contributing) {
            if (e1Wc !== 0 && e1Wc !== 1 || e2Wc !== 0 && e2Wc !== 1 || e1.PolyTyp !== e2.PolyTyp && this.m_ClipType !== ClipperLib.ClipType.ctXor) this.AddLocalMaxPoly(e1, e2, pt);
            else {
                this.AddOutPt(e1, pt);
                this.AddOutPt(e2, pt);
                ClipperLib.Clipper.SwapSides(e1, e2);
                ClipperLib.Clipper.SwapPolyIndexes(e1, e2);
            }
        } else if (e1Contributing) {
            if (e2Wc === 0 || e2Wc === 1) {
                this.AddOutPt(e1, pt);
                ClipperLib.Clipper.SwapSides(e1, e2);
                ClipperLib.Clipper.SwapPolyIndexes(e1, e2);
            }
        } else if (e2Contributing) {
            if (e1Wc === 0 || e1Wc === 1) {
                this.AddOutPt(e2, pt);
                ClipperLib.Clipper.SwapSides(e1, e2);
                ClipperLib.Clipper.SwapPolyIndexes(e1, e2);
            }
        } else if ((e1Wc === 0 || e1Wc === 1) && (e2Wc === 0 || e2Wc === 1)) {
            //neither edge is currently contributing ...
            var e1Wc2, e2Wc2;
            switch(e1FillType2){
                case ClipperLib.PolyFillType.pftPositive:
                    e1Wc2 = e1.WindCnt2;
                    break;
                case ClipperLib.PolyFillType.pftNegative:
                    e1Wc2 = -e1.WindCnt2;
                    break;
                default:
                    e1Wc2 = Math.abs(e1.WindCnt2);
                    break;
            }
            switch(e2FillType2){
                case ClipperLib.PolyFillType.pftPositive:
                    e2Wc2 = e2.WindCnt2;
                    break;
                case ClipperLib.PolyFillType.pftNegative:
                    e2Wc2 = -e2.WindCnt2;
                    break;
                default:
                    e2Wc2 = Math.abs(e2.WindCnt2);
                    break;
            }
            if (e1.PolyTyp !== e2.PolyTyp) this.AddLocalMinPoly(e1, e2, pt);
            else if (e1Wc === 1 && e2Wc === 1) switch(this.m_ClipType){
                case ClipperLib.ClipType.ctIntersection:
                    if (e1Wc2 > 0 && e2Wc2 > 0) this.AddLocalMinPoly(e1, e2, pt);
                    break;
                case ClipperLib.ClipType.ctUnion:
                    if (e1Wc2 <= 0 && e2Wc2 <= 0) this.AddLocalMinPoly(e1, e2, pt);
                    break;
                case ClipperLib.ClipType.ctDifference:
                    if (e1.PolyTyp === ClipperLib.PolyType.ptClip && e1Wc2 > 0 && e2Wc2 > 0 || e1.PolyTyp === ClipperLib.PolyType.ptSubject && e1Wc2 <= 0 && e2Wc2 <= 0) this.AddLocalMinPoly(e1, e2, pt);
                    break;
                case ClipperLib.ClipType.ctXor:
                    this.AddLocalMinPoly(e1, e2, pt);
                    break;
            }
            else ClipperLib.Clipper.SwapSides(e1, e2);
        }
    };
    ClipperLib.Clipper.prototype.DeleteFromSEL = function(e) {
        var SelPrev = e.PrevInSEL;
        var SelNext = e.NextInSEL;
        if (SelPrev === null && SelNext === null && e !== this.m_SortedEdges) return;
        //already deleted
        if (SelPrev !== null) SelPrev.NextInSEL = SelNext;
        else this.m_SortedEdges = SelNext;
        if (SelNext !== null) SelNext.PrevInSEL = SelPrev;
        e.NextInSEL = null;
        e.PrevInSEL = null;
    };
    ClipperLib.Clipper.prototype.ProcessHorizontals = function() {
        var horzEdge = {}; //m_SortedEdges;
        while(this.PopEdgeFromSEL(horzEdge))this.ProcessHorizontal(horzEdge.v);
    };
    ClipperLib.Clipper.prototype.GetHorzDirection = function(HorzEdge, $var) {
        if (HorzEdge.Bot.X < HorzEdge.Top.X) {
            $var.Left = HorzEdge.Bot.X;
            $var.Right = HorzEdge.Top.X;
            $var.Dir = ClipperLib.Direction.dLeftToRight;
        } else {
            $var.Left = HorzEdge.Top.X;
            $var.Right = HorzEdge.Bot.X;
            $var.Dir = ClipperLib.Direction.dRightToLeft;
        }
    };
    ClipperLib.Clipper.prototype.ProcessHorizontal = function(horzEdge) {
        var $var = {
            Dir: null,
            Left: null,
            Right: null
        };
        this.GetHorzDirection(horzEdge, $var);
        var dir = $var.Dir;
        var horzLeft = $var.Left;
        var horzRight = $var.Right;
        var IsOpen = horzEdge.WindDelta === 0;
        var eLastHorz = horzEdge, eMaxPair = null;
        while(eLastHorz.NextInLML !== null && ClipperLib.ClipperBase.IsHorizontal(eLastHorz.NextInLML))eLastHorz = eLastHorz.NextInLML;
        if (eLastHorz.NextInLML === null) eMaxPair = this.GetMaximaPair(eLastHorz);
        var currMax = this.m_Maxima;
        if (currMax !== null) {
            //get the first maxima in range (X) ...
            if (dir === ClipperLib.Direction.dLeftToRight) {
                while(currMax !== null && currMax.X <= horzEdge.Bot.X)currMax = currMax.Next;
                if (currMax !== null && currMax.X >= eLastHorz.Top.X) currMax = null;
            } else {
                while(currMax.Next !== null && currMax.Next.X < horzEdge.Bot.X)currMax = currMax.Next;
                if (currMax.X <= eLastHorz.Top.X) currMax = null;
            }
        }
        var op1 = null;
        for(;;){
            var IsLastHorz = horzEdge === eLastHorz;
            var e = this.GetNextInAEL(horzEdge, dir);
            while(e !== null){
                //this code block inserts extra coords into horizontal edges (in output
                //polygons) whereever maxima touch these horizontal edges. This helps
                //'simplifying' polygons (ie if the Simplify property is set).
                if (currMax !== null) {
                    if (dir === ClipperLib.Direction.dLeftToRight) while(currMax !== null && currMax.X < e.Curr.X){
                        if (horzEdge.OutIdx >= 0 && !IsOpen) this.AddOutPt(horzEdge, new ClipperLib.IntPoint2(currMax.X, horzEdge.Bot.Y));
                        currMax = currMax.Next;
                    }
                    else while(currMax !== null && currMax.X > e.Curr.X){
                        if (horzEdge.OutIdx >= 0 && !IsOpen) this.AddOutPt(horzEdge, new ClipperLib.IntPoint2(currMax.X, horzEdge.Bot.Y));
                        currMax = currMax.Prev;
                    }
                }
                if (dir === ClipperLib.Direction.dLeftToRight && e.Curr.X > horzRight || dir === ClipperLib.Direction.dRightToLeft && e.Curr.X < horzLeft) break;
                //Also break if we've got to the end of an intermediate horizontal edge ...
                //nb: Smaller Dx's are to the right of larger Dx's ABOVE the horizontal.
                if (e.Curr.X === horzEdge.Top.X && horzEdge.NextInLML !== null && e.Dx < horzEdge.NextInLML.Dx) break;
                if (horzEdge.OutIdx >= 0 && !IsOpen) {
                    if (ClipperLib.use_xyz) {
                        if (dir === ClipperLib.Direction.dLeftToRight) this.SetZ(e.Curr, horzEdge, e);
                        else this.SetZ(e.Curr, e, horzEdge);
                    }
                    op1 = this.AddOutPt(horzEdge, e.Curr);
                    var eNextHorz = this.m_SortedEdges;
                    while(eNextHorz !== null){
                        if (eNextHorz.OutIdx >= 0 && this.HorzSegmentsOverlap(horzEdge.Bot.X, horzEdge.Top.X, eNextHorz.Bot.X, eNextHorz.Top.X)) {
                            var op2 = this.GetLastOutPt(eNextHorz);
                            this.AddJoin(op2, op1, eNextHorz.Top);
                        }
                        eNextHorz = eNextHorz.NextInSEL;
                    }
                    this.AddGhostJoin(op1, horzEdge.Bot);
                }
                //OK, so far we're still in range of the horizontal Edge  but make sure
                //we're at the last of consec. horizontals when matching with eMaxPair
                if (e === eMaxPair && IsLastHorz) {
                    if (horzEdge.OutIdx >= 0) this.AddLocalMaxPoly(horzEdge, eMaxPair, horzEdge.Top);
                    this.DeleteFromAEL(horzEdge);
                    this.DeleteFromAEL(eMaxPair);
                    return;
                }
                if (dir === ClipperLib.Direction.dLeftToRight) {
                    var Pt = new ClipperLib.IntPoint2(e.Curr.X, horzEdge.Curr.Y);
                    this.IntersectEdges(horzEdge, e, Pt);
                } else {
                    var Pt = new ClipperLib.IntPoint2(e.Curr.X, horzEdge.Curr.Y);
                    this.IntersectEdges(e, horzEdge, Pt);
                }
                var eNext = this.GetNextInAEL(e, dir);
                this.SwapPositionsInAEL(horzEdge, e);
                e = eNext;
            } //end while(e !== null)
            //Break out of loop if HorzEdge.NextInLML is not also horizontal ...
            if (horzEdge.NextInLML === null || !ClipperLib.ClipperBase.IsHorizontal(horzEdge.NextInLML)) break;
            horzEdge = this.UpdateEdgeIntoAEL(horzEdge);
            if (horzEdge.OutIdx >= 0) this.AddOutPt(horzEdge, horzEdge.Bot);
            $var = {
                Dir: dir,
                Left: horzLeft,
                Right: horzRight
            };
            this.GetHorzDirection(horzEdge, $var);
            dir = $var.Dir;
            horzLeft = $var.Left;
            horzRight = $var.Right;
        } //end for (;;)
        if (horzEdge.OutIdx >= 0 && op1 === null) {
            op1 = this.GetLastOutPt(horzEdge);
            var eNextHorz = this.m_SortedEdges;
            while(eNextHorz !== null){
                if (eNextHorz.OutIdx >= 0 && this.HorzSegmentsOverlap(horzEdge.Bot.X, horzEdge.Top.X, eNextHorz.Bot.X, eNextHorz.Top.X)) {
                    var op2 = this.GetLastOutPt(eNextHorz);
                    this.AddJoin(op2, op1, eNextHorz.Top);
                }
                eNextHorz = eNextHorz.NextInSEL;
            }
            this.AddGhostJoin(op1, horzEdge.Top);
        }
        if (horzEdge.NextInLML !== null) {
            if (horzEdge.OutIdx >= 0) {
                op1 = this.AddOutPt(horzEdge, horzEdge.Top);
                horzEdge = this.UpdateEdgeIntoAEL(horzEdge);
                if (horzEdge.WindDelta === 0) return;
                //nb: HorzEdge is no longer horizontal here
                var ePrev = horzEdge.PrevInAEL;
                var eNext = horzEdge.NextInAEL;
                if (ePrev !== null && ePrev.Curr.X === horzEdge.Bot.X && ePrev.Curr.Y === horzEdge.Bot.Y && ePrev.WindDelta === 0 && ePrev.OutIdx >= 0 && ePrev.Curr.Y > ePrev.Top.Y && ClipperLib.ClipperBase.SlopesEqual3(horzEdge, ePrev, this.m_UseFullRange)) {
                    var op2 = this.AddOutPt(ePrev, horzEdge.Bot);
                    this.AddJoin(op1, op2, horzEdge.Top);
                } else if (eNext !== null && eNext.Curr.X === horzEdge.Bot.X && eNext.Curr.Y === horzEdge.Bot.Y && eNext.WindDelta !== 0 && eNext.OutIdx >= 0 && eNext.Curr.Y > eNext.Top.Y && ClipperLib.ClipperBase.SlopesEqual3(horzEdge, eNext, this.m_UseFullRange)) {
                    var op2 = this.AddOutPt(eNext, horzEdge.Bot);
                    this.AddJoin(op1, op2, horzEdge.Top);
                }
            } else horzEdge = this.UpdateEdgeIntoAEL(horzEdge);
        } else {
            if (horzEdge.OutIdx >= 0) this.AddOutPt(horzEdge, horzEdge.Top);
            this.DeleteFromAEL(horzEdge);
        }
    };
    ClipperLib.Clipper.prototype.GetNextInAEL = function(e, Direction) {
        return Direction === ClipperLib.Direction.dLeftToRight ? e.NextInAEL : e.PrevInAEL;
    };
    ClipperLib.Clipper.prototype.IsMinima = function(e) {
        return e !== null && e.Prev.NextInLML !== e && e.Next.NextInLML !== e;
    };
    ClipperLib.Clipper.prototype.IsMaxima = function(e, Y) {
        return e !== null && e.Top.Y === Y && e.NextInLML === null;
    };
    ClipperLib.Clipper.prototype.IsIntermediate = function(e, Y) {
        return e.Top.Y === Y && e.NextInLML !== null;
    };
    ClipperLib.Clipper.prototype.GetMaximaPair = function(e) {
        if (ClipperLib.IntPoint.op_Equality(e.Next.Top, e.Top) && e.Next.NextInLML === null) return e.Next;
        else {
            if (ClipperLib.IntPoint.op_Equality(e.Prev.Top, e.Top) && e.Prev.NextInLML === null) return e.Prev;
            else return null;
        }
    };
    ClipperLib.Clipper.prototype.GetMaximaPairEx = function(e) {
        //as above but returns null if MaxPair isn't in AEL (unless it's horizontal)
        var result = this.GetMaximaPair(e);
        if (result === null || result.OutIdx === ClipperLib.ClipperBase.Skip || result.NextInAEL === result.PrevInAEL && !ClipperLib.ClipperBase.IsHorizontal(result)) return null;
        return result;
    };
    ClipperLib.Clipper.prototype.ProcessIntersections = function(topY) {
        if (this.m_ActiveEdges === null) return true;
        try {
            this.BuildIntersectList(topY);
            if (this.m_IntersectList.length === 0) return true;
            if (this.m_IntersectList.length === 1 || this.FixupIntersectionOrder()) this.ProcessIntersectList();
            else return false;
        } catch ($$e2) {
            this.m_SortedEdges = null;
            this.m_IntersectList.length = 0;
            ClipperLib.Error("ProcessIntersections error");
        }
        this.m_SortedEdges = null;
        return true;
    };
    ClipperLib.Clipper.prototype.BuildIntersectList = function(topY) {
        if (this.m_ActiveEdges === null) return;
        //prepare for sorting ...
        var e = this.m_ActiveEdges;
        //console.log(JSON.stringify(JSON.decycle( e )));
        this.m_SortedEdges = e;
        while(e !== null){
            e.PrevInSEL = e.PrevInAEL;
            e.NextInSEL = e.NextInAEL;
            e.Curr.X = ClipperLib.Clipper.TopX(e, topY);
            e = e.NextInAEL;
        }
        //bubblesort ...
        var isModified = true;
        while(isModified && this.m_SortedEdges !== null){
            isModified = false;
            e = this.m_SortedEdges;
            while(e.NextInSEL !== null){
                var eNext = e.NextInSEL;
                var pt = new ClipperLib.IntPoint0();
                //console.log("e.Curr.X: " + e.Curr.X + " eNext.Curr.X" + eNext.Curr.X);
                if (e.Curr.X > eNext.Curr.X) {
                    this.IntersectPoint(e, eNext, pt);
                    if (pt.Y < topY) pt = new ClipperLib.IntPoint2(ClipperLib.Clipper.TopX(e, topY), topY);
                    var newNode = new ClipperLib.IntersectNode();
                    newNode.Edge1 = e;
                    newNode.Edge2 = eNext;
                    //newNode.Pt = pt;
                    newNode.Pt.X = pt.X;
                    newNode.Pt.Y = pt.Y;
                    if (ClipperLib.use_xyz) newNode.Pt.Z = pt.Z;
                    this.m_IntersectList.push(newNode);
                    this.SwapPositionsInSEL(e, eNext);
                    isModified = true;
                } else e = eNext;
            }
            if (e.PrevInSEL !== null) e.PrevInSEL.NextInSEL = null;
            else break;
        }
        this.m_SortedEdges = null;
    };
    ClipperLib.Clipper.prototype.EdgesAdjacent = function(inode) {
        return inode.Edge1.NextInSEL === inode.Edge2 || inode.Edge1.PrevInSEL === inode.Edge2;
    };
    ClipperLib.Clipper.IntersectNodeSort = function(node1, node2) {
        //the following typecast is safe because the differences in Pt.Y will
        //be limited to the height of the scanbeam.
        return node2.Pt.Y - node1.Pt.Y;
    };
    ClipperLib.Clipper.prototype.FixupIntersectionOrder = function() {
        //pre-condition: intersections are sorted bottom-most first.
        //Now it's crucial that intersections are made only between adjacent edges,
        //so to ensure this the order of intersections may need adjusting ...
        this.m_IntersectList.sort(this.m_IntersectNodeComparer);
        this.CopyAELToSEL();
        var cnt = this.m_IntersectList.length;
        for(var i = 0; i < cnt; i++){
            if (!this.EdgesAdjacent(this.m_IntersectList[i])) {
                var j = i + 1;
                while(j < cnt && !this.EdgesAdjacent(this.m_IntersectList[j]))j++;
                if (j === cnt) return false;
                var tmp = this.m_IntersectList[i];
                this.m_IntersectList[i] = this.m_IntersectList[j];
                this.m_IntersectList[j] = tmp;
            }
            this.SwapPositionsInSEL(this.m_IntersectList[i].Edge1, this.m_IntersectList[i].Edge2);
        }
        return true;
    };
    ClipperLib.Clipper.prototype.ProcessIntersectList = function() {
        for(var i = 0, ilen = this.m_IntersectList.length; i < ilen; i++){
            var iNode = this.m_IntersectList[i];
            this.IntersectEdges(iNode.Edge1, iNode.Edge2, iNode.Pt);
            this.SwapPositionsInAEL(iNode.Edge1, iNode.Edge2);
        }
        this.m_IntersectList.length = 0;
    };
    /*
	--------------------------------
	Round speedtest: http://jsperf.com/fastest-round
	--------------------------------
	*/ var R1 = function(a) {
        return a < 0 ? Math.ceil(a - 0.5) : Math.round(a);
    };
    var R2 = function(a) {
        return a < 0 ? Math.ceil(a - 0.5) : Math.floor(a + 0.5);
    };
    var R3 = function(a) {
        return a < 0 ? -Math.round(Math.abs(a)) : Math.round(a);
    };
    var R4 = function(a) {
        if (a < 0) {
            a -= 0.5;
            return a < -2147483648 ? Math.ceil(a) : a | 0;
        } else {
            a += 0.5;
            return a > 2147483647 ? Math.floor(a) : a | 0;
        }
    };
    if (browser.msie) ClipperLib.Clipper.Round = R1;
    else if (browser.chromium) ClipperLib.Clipper.Round = R3;
    else if (browser.safari) ClipperLib.Clipper.Round = R4;
    else ClipperLib.Clipper.Round = R2; // eg. browser.chrome || browser.firefox || browser.opera
    ClipperLib.Clipper.TopX = function(edge, currentY) {
        //if (edge.Bot == edge.Curr) alert ("edge.Bot = edge.Curr");
        //if (edge.Bot == edge.Top) alert ("edge.Bot = edge.Top");
        if (currentY === edge.Top.Y) return edge.Top.X;
        return edge.Bot.X + ClipperLib.Clipper.Round(edge.Dx * (currentY - edge.Bot.Y));
    };
    ClipperLib.Clipper.prototype.IntersectPoint = function(edge1, edge2, ip) {
        ip.X = 0;
        ip.Y = 0;
        var b1, b2;
        //nb: with very large coordinate values, it's possible for SlopesEqual() to
        //return false but for the edge.Dx value be equal due to double precision rounding.
        if (edge1.Dx === edge2.Dx) {
            ip.Y = edge1.Curr.Y;
            ip.X = ClipperLib.Clipper.TopX(edge1, ip.Y);
            return;
        }
        if (edge1.Delta.X === 0) {
            ip.X = edge1.Bot.X;
            if (ClipperLib.ClipperBase.IsHorizontal(edge2)) ip.Y = edge2.Bot.Y;
            else {
                b2 = edge2.Bot.Y - edge2.Bot.X / edge2.Dx;
                ip.Y = ClipperLib.Clipper.Round(ip.X / edge2.Dx + b2);
            }
        } else if (edge2.Delta.X === 0) {
            ip.X = edge2.Bot.X;
            if (ClipperLib.ClipperBase.IsHorizontal(edge1)) ip.Y = edge1.Bot.Y;
            else {
                b1 = edge1.Bot.Y - edge1.Bot.X / edge1.Dx;
                ip.Y = ClipperLib.Clipper.Round(ip.X / edge1.Dx + b1);
            }
        } else {
            b1 = edge1.Bot.X - edge1.Bot.Y * edge1.Dx;
            b2 = edge2.Bot.X - edge2.Bot.Y * edge2.Dx;
            var q = (b2 - b1) / (edge1.Dx - edge2.Dx);
            ip.Y = ClipperLib.Clipper.Round(q);
            if (Math.abs(edge1.Dx) < Math.abs(edge2.Dx)) ip.X = ClipperLib.Clipper.Round(edge1.Dx * q + b1);
            else ip.X = ClipperLib.Clipper.Round(edge2.Dx * q + b2);
        }
        if (ip.Y < edge1.Top.Y || ip.Y < edge2.Top.Y) {
            if (edge1.Top.Y > edge2.Top.Y) {
                ip.Y = edge1.Top.Y;
                ip.X = ClipperLib.Clipper.TopX(edge2, edge1.Top.Y);
                return ip.X < edge1.Top.X;
            } else ip.Y = edge2.Top.Y;
            if (Math.abs(edge1.Dx) < Math.abs(edge2.Dx)) ip.X = ClipperLib.Clipper.TopX(edge1, ip.Y);
            else ip.X = ClipperLib.Clipper.TopX(edge2, ip.Y);
        }
        //finally, don't allow 'ip' to be BELOW curr.Y (ie bottom of scanbeam) ...
        if (ip.Y > edge1.Curr.Y) {
            ip.Y = edge1.Curr.Y;
            //better to use the more vertical edge to derive X ...
            if (Math.abs(edge1.Dx) > Math.abs(edge2.Dx)) ip.X = ClipperLib.Clipper.TopX(edge2, ip.Y);
            else ip.X = ClipperLib.Clipper.TopX(edge1, ip.Y);
        }
    };
    ClipperLib.Clipper.prototype.ProcessEdgesAtTopOfScanbeam = function(topY) {
        var e = this.m_ActiveEdges;
        while(e !== null){
            //1. process maxima, treating them as if they're 'bent' horizontal edges,
            //   but exclude maxima with horizontal edges. nb: e can't be a horizontal.
            var IsMaximaEdge = this.IsMaxima(e, topY);
            if (IsMaximaEdge) {
                var eMaxPair = this.GetMaximaPairEx(e);
                IsMaximaEdge = eMaxPair === null || !ClipperLib.ClipperBase.IsHorizontal(eMaxPair);
            }
            if (IsMaximaEdge) {
                if (this.StrictlySimple) this.InsertMaxima(e.Top.X);
                var ePrev = e.PrevInAEL;
                this.DoMaxima(e);
                if (ePrev === null) e = this.m_ActiveEdges;
                else e = ePrev.NextInAEL;
            } else {
                //2. promote horizontal edges, otherwise update Curr.X and Curr.Y ...
                if (this.IsIntermediate(e, topY) && ClipperLib.ClipperBase.IsHorizontal(e.NextInLML)) {
                    e = this.UpdateEdgeIntoAEL(e);
                    if (e.OutIdx >= 0) this.AddOutPt(e, e.Bot);
                    this.AddEdgeToSEL(e);
                } else {
                    e.Curr.X = ClipperLib.Clipper.TopX(e, topY);
                    e.Curr.Y = topY;
                }
                if (ClipperLib.use_xyz) {
                    if (e.Top.Y === topY) e.Curr.Z = e.Top.Z;
                    else if (e.Bot.Y === topY) e.Curr.Z = e.Bot.Z;
                    else e.Curr.Z = 0;
                }
                //When StrictlySimple and 'e' is being touched by another edge, then
                //make sure both edges have a vertex here ...
                if (this.StrictlySimple) {
                    var ePrev = e.PrevInAEL;
                    if (e.OutIdx >= 0 && e.WindDelta !== 0 && ePrev !== null && ePrev.OutIdx >= 0 && ePrev.Curr.X === e.Curr.X && ePrev.WindDelta !== 0) {
                        var ip = new ClipperLib.IntPoint1(e.Curr);
                        if (ClipperLib.use_xyz) this.SetZ(ip, ePrev, e);
                        var op = this.AddOutPt(ePrev, ip);
                        var op2 = this.AddOutPt(e, ip);
                        this.AddJoin(op, op2, ip); //StrictlySimple (type-3) join
                    }
                }
                e = e.NextInAEL;
            }
        }
        //3. Process horizontals at the Top of the scanbeam ...
        this.ProcessHorizontals();
        this.m_Maxima = null;
        //4. Promote intermediate vertices ...
        e = this.m_ActiveEdges;
        while(e !== null){
            if (this.IsIntermediate(e, topY)) {
                var op = null;
                if (e.OutIdx >= 0) op = this.AddOutPt(e, e.Top);
                e = this.UpdateEdgeIntoAEL(e);
                //if output polygons share an edge, they'll need joining later ...
                var ePrev = e.PrevInAEL;
                var eNext = e.NextInAEL;
                if (ePrev !== null && ePrev.Curr.X === e.Bot.X && ePrev.Curr.Y === e.Bot.Y && op !== null && ePrev.OutIdx >= 0 && ePrev.Curr.Y === ePrev.Top.Y && ClipperLib.ClipperBase.SlopesEqual5(e.Curr, e.Top, ePrev.Curr, ePrev.Top, this.m_UseFullRange) && e.WindDelta !== 0 && ePrev.WindDelta !== 0) {
                    var op2 = this.AddOutPt(ePrev2, e.Bot);
                    this.AddJoin(op, op2, e.Top);
                } else if (eNext !== null && eNext.Curr.X === e.Bot.X && eNext.Curr.Y === e.Bot.Y && op !== null && eNext.OutIdx >= 0 && eNext.Curr.Y === eNext.Top.Y && ClipperLib.ClipperBase.SlopesEqual5(e.Curr, e.Top, eNext.Curr, eNext.Top, this.m_UseFullRange) && e.WindDelta !== 0 && eNext.WindDelta !== 0) {
                    var op2 = this.AddOutPt(eNext, e.Bot);
                    this.AddJoin(op, op2, e.Top);
                }
            }
            e = e.NextInAEL;
        }
    };
    ClipperLib.Clipper.prototype.DoMaxima = function(e) {
        var eMaxPair = this.GetMaximaPairEx(e);
        if (eMaxPair === null) {
            if (e.OutIdx >= 0) this.AddOutPt(e, e.Top);
            this.DeleteFromAEL(e);
            return;
        }
        var eNext = e.NextInAEL;
        while(eNext !== null && eNext !== eMaxPair){
            this.IntersectEdges(e, eNext, e.Top);
            this.SwapPositionsInAEL(e, eNext);
            eNext = e.NextInAEL;
        }
        if (e.OutIdx === -1 && eMaxPair.OutIdx === -1) {
            this.DeleteFromAEL(e);
            this.DeleteFromAEL(eMaxPair);
        } else if (e.OutIdx >= 0 && eMaxPair.OutIdx >= 0) {
            if (e.OutIdx >= 0) this.AddLocalMaxPoly(e, eMaxPair, e.Top);
            this.DeleteFromAEL(e);
            this.DeleteFromAEL(eMaxPair);
        } else if (ClipperLib.use_lines && e.WindDelta === 0) {
            if (e.OutIdx >= 0) {
                this.AddOutPt(e, e.Top);
                e.OutIdx = ClipperLib.ClipperBase.Unassigned;
            }
            this.DeleteFromAEL(e);
            if (eMaxPair.OutIdx >= 0) {
                this.AddOutPt(eMaxPair, e.Top);
                eMaxPair.OutIdx = ClipperLib.ClipperBase.Unassigned;
            }
            this.DeleteFromAEL(eMaxPair);
        } else ClipperLib.Error("DoMaxima error");
    };
    ClipperLib.Clipper.ReversePaths = function(polys) {
        for(var i = 0, len = polys.length; i < len; i++)polys[i].reverse();
    };
    ClipperLib.Clipper.Orientation = function(poly) {
        return ClipperLib.Clipper.Area(poly) >= 0;
    };
    ClipperLib.Clipper.prototype.PointCount = function(pts) {
        if (pts === null) return 0;
        var result = 0;
        var p = pts;
        do {
            result++;
            p = p.Next;
        }while (p !== pts);
        return result;
    };
    ClipperLib.Clipper.prototype.BuildResult = function(polyg) {
        ClipperLib.Clear(polyg);
        for(var i = 0, ilen = this.m_PolyOuts.length; i < ilen; i++){
            var outRec = this.m_PolyOuts[i];
            if (outRec.Pts === null) continue;
            var p = outRec.Pts.Prev;
            var cnt = this.PointCount(p);
            if (cnt < 2) continue;
            var pg = new Array(cnt);
            for(var j = 0; j < cnt; j++){
                pg[j] = p.Pt;
                p = p.Prev;
            }
            polyg.push(pg);
        }
    };
    ClipperLib.Clipper.prototype.BuildResult2 = function(polytree) {
        polytree.Clear();
        //add each output polygon/contour to polytree ...
        //polytree.m_AllPolys.set_Capacity(this.m_PolyOuts.length);
        for(var i = 0, ilen = this.m_PolyOuts.length; i < ilen; i++){
            var outRec = this.m_PolyOuts[i];
            var cnt = this.PointCount(outRec.Pts);
            if (outRec.IsOpen && cnt < 2 || !outRec.IsOpen && cnt < 3) continue;
            this.FixHoleLinkage(outRec);
            var pn = new ClipperLib.PolyNode();
            polytree.m_AllPolys.push(pn);
            outRec.PolyNode = pn;
            pn.m_polygon.length = cnt;
            var op = outRec.Pts.Prev;
            for(var j = 0; j < cnt; j++){
                pn.m_polygon[j] = op.Pt;
                op = op.Prev;
            }
        }
        //fixup PolyNode links etc ...
        //polytree.m_Childs.set_Capacity(this.m_PolyOuts.length);
        for(var i = 0, ilen = this.m_PolyOuts.length; i < ilen; i++){
            var outRec = this.m_PolyOuts[i];
            if (outRec.PolyNode === null) continue;
            else if (outRec.IsOpen) {
                outRec.PolyNode.IsOpen = true;
                polytree.AddChild(outRec.PolyNode);
            } else if (outRec.FirstLeft !== null && outRec.FirstLeft.PolyNode !== null) outRec.FirstLeft.PolyNode.AddChild(outRec.PolyNode);
            else polytree.AddChild(outRec.PolyNode);
        }
    };
    ClipperLib.Clipper.prototype.FixupOutPolyline = function(outRec) {
        var pp = outRec.Pts;
        var lastPP = pp.Prev;
        while(pp !== lastPP){
            pp = pp.Next;
            if (ClipperLib.IntPoint.op_Equality(pp.Pt, pp.Prev.Pt)) {
                if (pp === lastPP) lastPP = pp.Prev;
                var tmpPP = pp.Prev;
                tmpPP.Next = pp.Next;
                pp.Next.Prev = tmpPP;
                pp = tmpPP;
            }
        }
        if (pp === pp.Prev) outRec.Pts = null;
    };
    ClipperLib.Clipper.prototype.FixupOutPolygon = function(outRec) {
        //FixupOutPolygon() - removes duplicate points and simplifies consecutive
        //parallel edges by removing the middle vertex.
        var lastOK = null;
        outRec.BottomPt = null;
        var pp = outRec.Pts;
        var preserveCol = this.PreserveCollinear || this.StrictlySimple;
        for(;;){
            if (pp.Prev === pp || pp.Prev === pp.Next) {
                outRec.Pts = null;
                return;
            }
            //test for duplicate points and collinear edges ...
            if (ClipperLib.IntPoint.op_Equality(pp.Pt, pp.Next.Pt) || ClipperLib.IntPoint.op_Equality(pp.Pt, pp.Prev.Pt) || ClipperLib.ClipperBase.SlopesEqual4(pp.Prev.Pt, pp.Pt, pp.Next.Pt, this.m_UseFullRange) && (!preserveCol || !this.Pt2IsBetweenPt1AndPt3(pp.Prev.Pt, pp.Pt, pp.Next.Pt))) {
                lastOK = null;
                pp.Prev.Next = pp.Next;
                pp.Next.Prev = pp.Prev;
                pp = pp.Prev;
            } else if (pp === lastOK) break;
            else {
                if (lastOK === null) lastOK = pp;
                pp = pp.Next;
            }
        }
        outRec.Pts = pp;
    };
    ClipperLib.Clipper.prototype.DupOutPt = function(outPt, InsertAfter) {
        var result = new ClipperLib.OutPt();
        //result.Pt = outPt.Pt;
        result.Pt.X = outPt.Pt.X;
        result.Pt.Y = outPt.Pt.Y;
        if (ClipperLib.use_xyz) result.Pt.Z = outPt.Pt.Z;
        result.Idx = outPt.Idx;
        if (InsertAfter) {
            result.Next = outPt.Next;
            result.Prev = outPt;
            outPt.Next.Prev = result;
            outPt.Next = result;
        } else {
            result.Prev = outPt.Prev;
            result.Next = outPt;
            outPt.Prev.Next = result;
            outPt.Prev = result;
        }
        return result;
    };
    ClipperLib.Clipper.prototype.GetOverlap = function(a1, a2, b1, b2, $val) {
        if (a1 < a2) {
            if (b1 < b2) {
                $val.Left = Math.max(a1, b1);
                $val.Right = Math.min(a2, b2);
            } else {
                $val.Left = Math.max(a1, b2);
                $val.Right = Math.min(a2, b1);
            }
        } else if (b1 < b2) {
            $val.Left = Math.max(a2, b1);
            $val.Right = Math.min(a1, b2);
        } else {
            $val.Left = Math.max(a2, b2);
            $val.Right = Math.min(a1, b1);
        }
        return $val.Left < $val.Right;
    };
    ClipperLib.Clipper.prototype.JoinHorz = function(op1, op1b, op2, op2b, Pt, DiscardLeft) {
        var Dir1 = op1.Pt.X > op1b.Pt.X ? ClipperLib.Direction.dRightToLeft : ClipperLib.Direction.dLeftToRight;
        var Dir2 = op2.Pt.X > op2b.Pt.X ? ClipperLib.Direction.dRightToLeft : ClipperLib.Direction.dLeftToRight;
        if (Dir1 === Dir2) return false;
        //When DiscardLeft, we want Op1b to be on the Left of Op1, otherwise we
        //want Op1b to be on the Right. (And likewise with Op2 and Op2b.)
        //So, to facilitate this while inserting Op1b and Op2b ...
        //when DiscardLeft, make sure we're AT or RIGHT of Pt before adding Op1b,
        //otherwise make sure we're AT or LEFT of Pt. (Likewise with Op2b.)
        if (Dir1 === ClipperLib.Direction.dLeftToRight) {
            while(op1.Next.Pt.X <= Pt.X && op1.Next.Pt.X >= op1.Pt.X && op1.Next.Pt.Y === Pt.Y)op1 = op1.Next;
            if (DiscardLeft && op1.Pt.X !== Pt.X) op1 = op1.Next;
            op1b = this.DupOutPt(op1, !DiscardLeft);
            if (ClipperLib.IntPoint.op_Inequality(op1b.Pt, Pt)) {
                op1 = op1b;
                //op1.Pt = Pt;
                op1.Pt.X = Pt.X;
                op1.Pt.Y = Pt.Y;
                if (ClipperLib.use_xyz) op1.Pt.Z = Pt.Z;
                op1b = this.DupOutPt(op1, !DiscardLeft);
            }
        } else {
            while(op1.Next.Pt.X >= Pt.X && op1.Next.Pt.X <= op1.Pt.X && op1.Next.Pt.Y === Pt.Y)op1 = op1.Next;
            if (!DiscardLeft && op1.Pt.X !== Pt.X) op1 = op1.Next;
            op1b = this.DupOutPt(op1, DiscardLeft);
            if (ClipperLib.IntPoint.op_Inequality(op1b.Pt, Pt)) {
                op1 = op1b;
                //op1.Pt = Pt;
                op1.Pt.X = Pt.X;
                op1.Pt.Y = Pt.Y;
                if (ClipperLib.use_xyz) op1.Pt.Z = Pt.Z;
                op1b = this.DupOutPt(op1, DiscardLeft);
            }
        }
        if (Dir2 === ClipperLib.Direction.dLeftToRight) {
            while(op2.Next.Pt.X <= Pt.X && op2.Next.Pt.X >= op2.Pt.X && op2.Next.Pt.Y === Pt.Y)op2 = op2.Next;
            if (DiscardLeft && op2.Pt.X !== Pt.X) op2 = op2.Next;
            op2b = this.DupOutPt(op2, !DiscardLeft);
            if (ClipperLib.IntPoint.op_Inequality(op2b.Pt, Pt)) {
                op2 = op2b;
                //op2.Pt = Pt;
                op2.Pt.X = Pt.X;
                op2.Pt.Y = Pt.Y;
                if (ClipperLib.use_xyz) op2.Pt.Z = Pt.Z;
                op2b = this.DupOutPt(op2, !DiscardLeft);
            }
        } else {
            while(op2.Next.Pt.X >= Pt.X && op2.Next.Pt.X <= op2.Pt.X && op2.Next.Pt.Y === Pt.Y)op2 = op2.Next;
            if (!DiscardLeft && op2.Pt.X !== Pt.X) op2 = op2.Next;
            op2b = this.DupOutPt(op2, DiscardLeft);
            if (ClipperLib.IntPoint.op_Inequality(op2b.Pt, Pt)) {
                op2 = op2b;
                //op2.Pt = Pt;
                op2.Pt.X = Pt.X;
                op2.Pt.Y = Pt.Y;
                if (ClipperLib.use_xyz) op2.Pt.Z = Pt.Z;
                op2b = this.DupOutPt(op2, DiscardLeft);
            }
        }
        if (Dir1 === ClipperLib.Direction.dLeftToRight === DiscardLeft) {
            op1.Prev = op2;
            op2.Next = op1;
            op1b.Next = op2b;
            op2b.Prev = op1b;
        } else {
            op1.Next = op2;
            op2.Prev = op1;
            op1b.Prev = op2b;
            op2b.Next = op1b;
        }
        return true;
    };
    ClipperLib.Clipper.prototype.JoinPoints = function(j, outRec1, outRec2) {
        var op1 = j.OutPt1, op1b = new ClipperLib.OutPt();
        var op2 = j.OutPt2, op2b = new ClipperLib.OutPt();
        //There are 3 kinds of joins for output polygons ...
        //1. Horizontal joins where Join.OutPt1 & Join.OutPt2 are vertices anywhere
        //along (horizontal) collinear edges (& Join.OffPt is on the same horizontal).
        //2. Non-horizontal joins where Join.OutPt1 & Join.OutPt2 are at the same
        //location at the Bottom of the overlapping segment (& Join.OffPt is above).
        //3. StrictlySimple joins where edges touch but are not collinear and where
        //Join.OutPt1, Join.OutPt2 & Join.OffPt all share the same point.
        var isHorizontal = j.OutPt1.Pt.Y === j.OffPt.Y;
        if (isHorizontal && ClipperLib.IntPoint.op_Equality(j.OffPt, j.OutPt1.Pt) && ClipperLib.IntPoint.op_Equality(j.OffPt, j.OutPt2.Pt)) {
            //Strictly Simple join ...
            if (outRec1 !== outRec2) return false;
            op1b = j.OutPt1.Next;
            while(op1b !== op1 && ClipperLib.IntPoint.op_Equality(op1b.Pt, j.OffPt))op1b = op1b.Next;
            var reverse1 = op1b.Pt.Y > j.OffPt.Y;
            op2b = j.OutPt2.Next;
            while(op2b !== op2 && ClipperLib.IntPoint.op_Equality(op2b.Pt, j.OffPt))op2b = op2b.Next;
            var reverse2 = op2b.Pt.Y > j.OffPt.Y;
            if (reverse1 === reverse2) return false;
            if (reverse1) {
                op1b = this.DupOutPt(op1, false);
                op2b = this.DupOutPt(op2, true);
                op1.Prev = op2;
                op2.Next = op1;
                op1b.Next = op2b;
                op2b.Prev = op1b;
                j.OutPt1 = op1;
                j.OutPt2 = op1b;
                return true;
            } else {
                op1b = this.DupOutPt(op1, true);
                op2b = this.DupOutPt(op2, false);
                op1.Next = op2;
                op2.Prev = op1;
                op1b.Prev = op2b;
                op2b.Next = op1b;
                j.OutPt1 = op1;
                j.OutPt2 = op1b;
                return true;
            }
        } else if (isHorizontal) {
            //treat horizontal joins differently to non-horizontal joins since with
            //them we're not yet sure where the overlapping is. OutPt1.Pt & OutPt2.Pt
            //may be anywhere along the horizontal edge.
            op1b = op1;
            while(op1.Prev.Pt.Y === op1.Pt.Y && op1.Prev !== op1b && op1.Prev !== op2)op1 = op1.Prev;
            while(op1b.Next.Pt.Y === op1b.Pt.Y && op1b.Next !== op1 && op1b.Next !== op2)op1b = op1b.Next;
            if (op1b.Next === op1 || op1b.Next === op2) return false;
            //a flat 'polygon'
            op2b = op2;
            while(op2.Prev.Pt.Y === op2.Pt.Y && op2.Prev !== op2b && op2.Prev !== op1b)op2 = op2.Prev;
            while(op2b.Next.Pt.Y === op2b.Pt.Y && op2b.Next !== op2 && op2b.Next !== op1)op2b = op2b.Next;
            if (op2b.Next === op2 || op2b.Next === op1) return false;
            //a flat 'polygon'
            //Op1 -. Op1b & Op2 -. Op2b are the extremites of the horizontal edges
            var $val = {
                Left: null,
                Right: null
            };
            if (!this.GetOverlap(op1.Pt.X, op1b.Pt.X, op2.Pt.X, op2b.Pt.X, $val)) return false;
            var Left = $val.Left;
            var Right = $val.Right;
            //DiscardLeftSide: when overlapping edges are joined, a spike will created
            //which needs to be cleaned up. However, we don't want Op1 or Op2 caught up
            //on the discard Side as either may still be needed for other joins ...
            var Pt = new ClipperLib.IntPoint0();
            var DiscardLeftSide;
            if (op1.Pt.X >= Left && op1.Pt.X <= Right) {
                //Pt = op1.Pt;
                Pt.X = op1.Pt.X;
                Pt.Y = op1.Pt.Y;
                if (ClipperLib.use_xyz) Pt.Z = op1.Pt.Z;
                DiscardLeftSide = op1.Pt.X > op1b.Pt.X;
            } else if (op2.Pt.X >= Left && op2.Pt.X <= Right) {
                //Pt = op2.Pt;
                Pt.X = op2.Pt.X;
                Pt.Y = op2.Pt.Y;
                if (ClipperLib.use_xyz) Pt.Z = op2.Pt.Z;
                DiscardLeftSide = op2.Pt.X > op2b.Pt.X;
            } else if (op1b.Pt.X >= Left && op1b.Pt.X <= Right) {
                //Pt = op1b.Pt;
                Pt.X = op1b.Pt.X;
                Pt.Y = op1b.Pt.Y;
                if (ClipperLib.use_xyz) Pt.Z = op1b.Pt.Z;
                DiscardLeftSide = op1b.Pt.X > op1.Pt.X;
            } else {
                //Pt = op2b.Pt;
                Pt.X = op2b.Pt.X;
                Pt.Y = op2b.Pt.Y;
                if (ClipperLib.use_xyz) Pt.Z = op2b.Pt.Z;
                DiscardLeftSide = op2b.Pt.X > op2.Pt.X;
            }
            j.OutPt1 = op1;
            j.OutPt2 = op2;
            return this.JoinHorz(op1, op1b, op2, op2b, Pt, DiscardLeftSide);
        } else {
            //nb: For non-horizontal joins ...
            //    1. Jr.OutPt1.Pt.Y == Jr.OutPt2.Pt.Y
            //    2. Jr.OutPt1.Pt > Jr.OffPt.Y
            //make sure the polygons are correctly oriented ...
            op1b = op1.Next;
            while(ClipperLib.IntPoint.op_Equality(op1b.Pt, op1.Pt) && op1b !== op1)op1b = op1b.Next;
            var Reverse1 = op1b.Pt.Y > op1.Pt.Y || !ClipperLib.ClipperBase.SlopesEqual4(op1.Pt, op1b.Pt, j.OffPt, this.m_UseFullRange);
            if (Reverse1) {
                op1b = op1.Prev;
                while(ClipperLib.IntPoint.op_Equality(op1b.Pt, op1.Pt) && op1b !== op1)op1b = op1b.Prev;
                if (op1b.Pt.Y > op1.Pt.Y || !ClipperLib.ClipperBase.SlopesEqual4(op1.Pt, op1b.Pt, j.OffPt, this.m_UseFullRange)) return false;
            }
            op2b = op2.Next;
            while(ClipperLib.IntPoint.op_Equality(op2b.Pt, op2.Pt) && op2b !== op2)op2b = op2b.Next;
            var Reverse2 = op2b.Pt.Y > op2.Pt.Y || !ClipperLib.ClipperBase.SlopesEqual4(op2.Pt, op2b.Pt, j.OffPt, this.m_UseFullRange);
            if (Reverse2) {
                op2b = op2.Prev;
                while(ClipperLib.IntPoint.op_Equality(op2b.Pt, op2.Pt) && op2b !== op2)op2b = op2b.Prev;
                if (op2b.Pt.Y > op2.Pt.Y || !ClipperLib.ClipperBase.SlopesEqual4(op2.Pt, op2b.Pt, j.OffPt, this.m_UseFullRange)) return false;
            }
            if (op1b === op1 || op2b === op2 || op1b === op2b || outRec1 === outRec2 && Reverse1 === Reverse2) return false;
            if (Reverse1) {
                op1b = this.DupOutPt(op1, false);
                op2b = this.DupOutPt(op2, true);
                op1.Prev = op2;
                op2.Next = op1;
                op1b.Next = op2b;
                op2b.Prev = op1b;
                j.OutPt1 = op1;
                j.OutPt2 = op1b;
                return true;
            } else {
                op1b = this.DupOutPt(op1, true);
                op2b = this.DupOutPt(op2, false);
                op1.Next = op2;
                op2.Prev = op1;
                op1b.Prev = op2b;
                op2b.Next = op1b;
                j.OutPt1 = op1;
                j.OutPt2 = op1b;
                return true;
            }
        }
    };
    ClipperLib.Clipper.GetBounds = function(paths) {
        var i = 0, cnt = paths.length;
        while(i < cnt && paths[i].length === 0)i++;
        if (i === cnt) return new ClipperLib.IntRect(0, 0, 0, 0);
        var result = new ClipperLib.IntRect();
        result.left = paths[i][0].X;
        result.right = result.left;
        result.top = paths[i][0].Y;
        result.bottom = result.top;
        for(; i < cnt; i++)for(var j = 0, jlen = paths[i].length; j < jlen; j++){
            if (paths[i][j].X < result.left) result.left = paths[i][j].X;
            else if (paths[i][j].X > result.right) result.right = paths[i][j].X;
            if (paths[i][j].Y < result.top) result.top = paths[i][j].Y;
            else if (paths[i][j].Y > result.bottom) result.bottom = paths[i][j].Y;
        }
        return result;
    };
    ClipperLib.Clipper.prototype.GetBounds2 = function(ops) {
        var opStart = ops;
        var result = new ClipperLib.IntRect();
        result.left = ops.Pt.X;
        result.right = ops.Pt.X;
        result.top = ops.Pt.Y;
        result.bottom = ops.Pt.Y;
        ops = ops.Next;
        while(ops !== opStart){
            if (ops.Pt.X < result.left) result.left = ops.Pt.X;
            if (ops.Pt.X > result.right) result.right = ops.Pt.X;
            if (ops.Pt.Y < result.top) result.top = ops.Pt.Y;
            if (ops.Pt.Y > result.bottom) result.bottom = ops.Pt.Y;
            ops = ops.Next;
        }
        return result;
    };
    ClipperLib.Clipper.PointInPolygon = function(pt, path) {
        //returns 0 if false, +1 if true, -1 if pt ON polygon boundary
        //See "The Point in Polygon Problem for Arbitrary Polygons" by Hormann & Agathos
        //http://citeseerx.ist.psu.edu/viewdoc/download?doi=10.1.1.88.5498&rep=rep1&type=pdf
        var result = 0, cnt = path.length;
        if (cnt < 3) return 0;
        var ip = path[0];
        for(var i = 1; i <= cnt; ++i){
            var ipNext = i === cnt ? path[0] : path[i];
            if (ipNext.Y === pt.Y) {
                if (ipNext.X === pt.X || ip.Y === pt.Y && ipNext.X > pt.X === ip.X < pt.X) return -1;
            }
            if (ip.Y < pt.Y !== ipNext.Y < pt.Y) {
                if (ip.X >= pt.X) {
                    if (ipNext.X > pt.X) result = 1 - result;
                    else {
                        var d = (ip.X - pt.X) * (ipNext.Y - pt.Y) - (ipNext.X - pt.X) * (ip.Y - pt.Y);
                        if (d === 0) return -1;
                        else if (d > 0 === ipNext.Y > ip.Y) result = 1 - result;
                    }
                } else if (ipNext.X > pt.X) {
                    var d = (ip.X - pt.X) * (ipNext.Y - pt.Y) - (ipNext.X - pt.X) * (ip.Y - pt.Y);
                    if (d === 0) return -1;
                    else if (d > 0 === ipNext.Y > ip.Y) result = 1 - result;
                }
            }
            ip = ipNext;
        }
        return result;
    };
    ClipperLib.Clipper.prototype.PointInPolygon = function(pt, op) {
        //returns 0 if false, +1 if true, -1 if pt ON polygon boundary
        var result = 0;
        var startOp = op;
        var ptx = pt.X, pty = pt.Y;
        var poly0x = op.Pt.X, poly0y = op.Pt.Y;
        do {
            op = op.Next;
            var poly1x = op.Pt.X, poly1y = op.Pt.Y;
            if (poly1y === pty) {
                if (poly1x === ptx || poly0y === pty && poly1x > ptx === poly0x < ptx) return -1;
            }
            if (poly0y < pty !== poly1y < pty) {
                if (poly0x >= ptx) {
                    if (poly1x > ptx) result = 1 - result;
                    else {
                        var d = (poly0x - ptx) * (poly1y - pty) - (poly1x - ptx) * (poly0y - pty);
                        if (d === 0) return -1;
                        if (d > 0 === poly1y > poly0y) result = 1 - result;
                    }
                } else if (poly1x > ptx) {
                    var d = (poly0x - ptx) * (poly1y - pty) - (poly1x - ptx) * (poly0y - pty);
                    if (d === 0) return -1;
                    if (d > 0 === poly1y > poly0y) result = 1 - result;
                }
            }
            poly0x = poly1x;
            poly0y = poly1y;
        }while (startOp !== op);
        return result;
    };
    ClipperLib.Clipper.prototype.Poly2ContainsPoly1 = function(outPt1, outPt2) {
        var op = outPt1;
        do {
            //nb: PointInPolygon returns 0 if false, +1 if true, -1 if pt on polygon
            var res = this.PointInPolygon(op.Pt, outPt2);
            if (res >= 0) return res > 0;
            op = op.Next;
        }while (op !== outPt1);
        return true;
    };
    ClipperLib.Clipper.prototype.FixupFirstLefts1 = function(OldOutRec, NewOutRec) {
        var outRec, firstLeft;
        for(var i = 0, ilen = this.m_PolyOuts.length; i < ilen; i++){
            outRec = this.m_PolyOuts[i];
            firstLeft = ClipperLib.Clipper.ParseFirstLeft(outRec.FirstLeft);
            if (outRec.Pts !== null && firstLeft === OldOutRec) {
                if (this.Poly2ContainsPoly1(outRec.Pts, NewOutRec.Pts)) outRec.FirstLeft = NewOutRec;
            }
        }
    };
    ClipperLib.Clipper.prototype.FixupFirstLefts2 = function(innerOutRec, outerOutRec) {
        //A polygon has split into two such that one is now the inner of the other.
        //It's possible that these polygons now wrap around other polygons, so check
        //every polygon that's also contained by OuterOutRec's FirstLeft container
        //(including nil) to see if they've become inner to the new inner polygon ...
        var orfl = outerOutRec.FirstLeft;
        var outRec, firstLeft;
        for(var i = 0, ilen = this.m_PolyOuts.length; i < ilen; i++){
            outRec = this.m_PolyOuts[i];
            if (outRec.Pts === null || outRec === outerOutRec || outRec === innerOutRec) continue;
            firstLeft = ClipperLib.Clipper.ParseFirstLeft(outRec.FirstLeft);
            if (firstLeft !== orfl && firstLeft !== innerOutRec && firstLeft !== outerOutRec) continue;
            if (this.Poly2ContainsPoly1(outRec.Pts, innerOutRec.Pts)) outRec.FirstLeft = innerOutRec;
            else if (this.Poly2ContainsPoly1(outRec.Pts, outerOutRec.Pts)) outRec.FirstLeft = outerOutRec;
            else if (outRec.FirstLeft === innerOutRec || outRec.FirstLeft === outerOutRec) outRec.FirstLeft = orfl;
        }
    };
    ClipperLib.Clipper.prototype.FixupFirstLefts3 = function(OldOutRec, NewOutRec) {
        //same as FixupFirstLefts1 but doesn't call Poly2ContainsPoly1()
        var outRec;
        var firstLeft;
        for(var i = 0, ilen = this.m_PolyOuts.length; i < ilen; i++){
            outRec = this.m_PolyOuts[i];
            firstLeft = ClipperLib.Clipper.ParseFirstLeft(outRec.FirstLeft);
            if (outRec.Pts !== null && firstLeft === OldOutRec) outRec.FirstLeft = NewOutRec;
        }
    };
    ClipperLib.Clipper.ParseFirstLeft = function(FirstLeft) {
        while(FirstLeft !== null && FirstLeft.Pts === null)FirstLeft = FirstLeft.FirstLeft;
        return FirstLeft;
    };
    ClipperLib.Clipper.prototype.JoinCommonEdges = function() {
        for(var i = 0, ilen = this.m_Joins.length; i < ilen; i++){
            var join = this.m_Joins[i];
            var outRec1 = this.GetOutRec(join.OutPt1.Idx);
            var outRec2 = this.GetOutRec(join.OutPt2.Idx);
            if (outRec1.Pts === null || outRec2.Pts === null) continue;
            if (outRec1.IsOpen || outRec2.IsOpen) continue;
            //get the polygon fragment with the correct hole state (FirstLeft)
            //before calling JoinPoints() ...
            var holeStateRec;
            if (outRec1 === outRec2) holeStateRec = outRec1;
            else if (this.OutRec1RightOfOutRec2(outRec1, outRec2)) holeStateRec = outRec2;
            else if (this.OutRec1RightOfOutRec2(outRec2, outRec1)) holeStateRec = outRec1;
            else holeStateRec = this.GetLowermostRec(outRec1, outRec2);
            if (!this.JoinPoints(join, outRec1, outRec2)) continue;
            if (outRec1 === outRec2) {
                //instead of joining two polygons, we've just created a new one by
                //splitting one polygon into two.
                outRec1.Pts = join.OutPt1;
                outRec1.BottomPt = null;
                outRec2 = this.CreateOutRec();
                outRec2.Pts = join.OutPt2;
                //update all OutRec2.Pts Idx's ...
                this.UpdateOutPtIdxs(outRec2);
                if (this.Poly2ContainsPoly1(outRec2.Pts, outRec1.Pts)) {
                    //outRec1 contains outRec2 ...
                    outRec2.IsHole = !outRec1.IsHole;
                    outRec2.FirstLeft = outRec1;
                    if (this.m_UsingPolyTree) this.FixupFirstLefts2(outRec2, outRec1);
                    if ((outRec2.IsHole ^ this.ReverseSolution) == this.Area$1(outRec2) > 0) this.ReversePolyPtLinks(outRec2.Pts);
                } else if (this.Poly2ContainsPoly1(outRec1.Pts, outRec2.Pts)) {
                    //outRec2 contains outRec1 ...
                    outRec2.IsHole = outRec1.IsHole;
                    outRec1.IsHole = !outRec2.IsHole;
                    outRec2.FirstLeft = outRec1.FirstLeft;
                    outRec1.FirstLeft = outRec2;
                    if (this.m_UsingPolyTree) this.FixupFirstLefts2(outRec1, outRec2);
                    if ((outRec1.IsHole ^ this.ReverseSolution) == this.Area$1(outRec1) > 0) this.ReversePolyPtLinks(outRec1.Pts);
                } else {
                    //the 2 polygons are completely separate ...
                    outRec2.IsHole = outRec1.IsHole;
                    outRec2.FirstLeft = outRec1.FirstLeft;
                    //fixup FirstLeft pointers that may need reassigning to OutRec2
                    if (this.m_UsingPolyTree) this.FixupFirstLefts1(outRec1, outRec2);
                }
            } else {
                //joined 2 polygons together ...
                outRec2.Pts = null;
                outRec2.BottomPt = null;
                outRec2.Idx = outRec1.Idx;
                outRec1.IsHole = holeStateRec.IsHole;
                if (holeStateRec === outRec2) outRec1.FirstLeft = outRec2.FirstLeft;
                outRec2.FirstLeft = outRec1;
                //fixup FirstLeft pointers that may need reassigning to OutRec1
                if (this.m_UsingPolyTree) this.FixupFirstLefts3(outRec2, outRec1);
            }
        }
    };
    ClipperLib.Clipper.prototype.UpdateOutPtIdxs = function(outrec) {
        var op = outrec.Pts;
        do {
            op.Idx = outrec.Idx;
            op = op.Prev;
        }while (op !== outrec.Pts);
    };
    ClipperLib.Clipper.prototype.DoSimplePolygons = function() {
        var i = 0;
        while(i < this.m_PolyOuts.length){
            var outrec = this.m_PolyOuts[i++];
            var op = outrec.Pts;
            if (op === null || outrec.IsOpen) continue;
            do {
                var op2 = op.Next;
                while(op2 !== outrec.Pts){
                    if (ClipperLib.IntPoint.op_Equality(op.Pt, op2.Pt) && op2.Next !== op && op2.Prev !== op) {
                        //split the polygon into two ...
                        var op3 = op.Prev;
                        var op4 = op2.Prev;
                        op.Prev = op4;
                        op4.Next = op;
                        op2.Prev = op3;
                        op3.Next = op2;
                        outrec.Pts = op;
                        var outrec2 = this.CreateOutRec();
                        outrec2.Pts = op2;
                        this.UpdateOutPtIdxs(outrec2);
                        if (this.Poly2ContainsPoly1(outrec2.Pts, outrec.Pts)) {
                            //OutRec2 is contained by OutRec1 ...
                            outrec2.IsHole = !outrec.IsHole;
                            outrec2.FirstLeft = outrec;
                            if (this.m_UsingPolyTree) this.FixupFirstLefts2(outrec2, outrec);
                        } else if (this.Poly2ContainsPoly1(outrec.Pts, outrec2.Pts)) {
                            //OutRec1 is contained by OutRec2 ...
                            outrec2.IsHole = outrec.IsHole;
                            outrec.IsHole = !outrec2.IsHole;
                            outrec2.FirstLeft = outrec.FirstLeft;
                            outrec.FirstLeft = outrec2;
                            if (this.m_UsingPolyTree) this.FixupFirstLefts2(outrec, outrec2);
                        } else {
                            //the 2 polygons are separate ...
                            outrec2.IsHole = outrec.IsHole;
                            outrec2.FirstLeft = outrec.FirstLeft;
                            if (this.m_UsingPolyTree) this.FixupFirstLefts1(outrec, outrec2);
                        }
                        op2 = op;
                    //ie get ready for the next iteration
                    }
                    op2 = op2.Next;
                }
                op = op.Next;
            }while (op !== outrec.Pts);
        }
    };
    ClipperLib.Clipper.Area = function(poly) {
        if (!Array.isArray(poly)) return 0;
        var cnt = poly.length;
        if (cnt < 3) return 0;
        var a = 0;
        for(var i = 0, j = cnt - 1; i < cnt; ++i){
            a += (poly[j].X + poly[i].X) * (poly[j].Y - poly[i].Y);
            j = i;
        }
        return -a * 0.5;
    };
    ClipperLib.Clipper.prototype.Area = function(op) {
        var opFirst = op;
        if (op === null) return 0;
        var a = 0;
        do {
            a = a + (op.Prev.Pt.X + op.Pt.X) * (op.Prev.Pt.Y - op.Pt.Y);
            op = op.Next;
        }while (op !== opFirst); // && typeof op !== 'undefined');
        return a * 0.5;
    };
    ClipperLib.Clipper.prototype.Area$1 = function(outRec) {
        return this.Area(outRec.Pts);
    };
    ClipperLib.Clipper.SimplifyPolygon = function(poly, fillType) {
        var result = new Array();
        var c = new ClipperLib.Clipper(0);
        c.StrictlySimple = true;
        c.AddPath(poly, ClipperLib.PolyType.ptSubject, true);
        c.Execute(ClipperLib.ClipType.ctUnion, result, fillType, fillType);
        return result;
    };
    ClipperLib.Clipper.SimplifyPolygons = function(polys, fillType) {
        if (typeof fillType === "undefined") fillType = ClipperLib.PolyFillType.pftEvenOdd;
        var result = new Array();
        var c = new ClipperLib.Clipper(0);
        c.StrictlySimple = true;
        c.AddPaths(polys, ClipperLib.PolyType.ptSubject, true);
        c.Execute(ClipperLib.ClipType.ctUnion, result, fillType, fillType);
        return result;
    };
    ClipperLib.Clipper.DistanceSqrd = function(pt1, pt2) {
        var dx = pt1.X - pt2.X;
        var dy = pt1.Y - pt2.Y;
        return dx * dx + dy * dy;
    };
    ClipperLib.Clipper.DistanceFromLineSqrd = function(pt, ln1, ln2) {
        //The equation of a line in general form (Ax + By + C = 0)
        //given 2 points (x¹,y¹) & (x²,y²) is ...
        //(y¹ - y²)x + (x² - x¹)y + (y² - y¹)x¹ - (x² - x¹)y¹ = 0
        //A = (y¹ - y²); B = (x² - x¹); C = (y² - y¹)x¹ - (x² - x¹)y¹
        //perpendicular distance of point (x³,y³) = (Ax³ + By³ + C)/Sqrt(A² + B²)
        //see http://en.wikipedia.org/wiki/Perpendicular_distance
        var A = ln1.Y - ln2.Y;
        var B = ln2.X - ln1.X;
        var C = A * ln1.X + B * ln1.Y;
        C = A * pt.X + B * pt.Y - C;
        return C * C / (A * A + B * B);
    };
    ClipperLib.Clipper.SlopesNearCollinear = function(pt1, pt2, pt3, distSqrd) {
        //this function is more accurate when the point that's GEOMETRICALLY
        //between the other 2 points is the one that's tested for distance.
        //nb: with 'spikes', either pt1 or pt3 is geometrically between the other pts
        if (Math.abs(pt1.X - pt2.X) > Math.abs(pt1.Y - pt2.Y)) {
            if (pt1.X > pt2.X === pt1.X < pt3.X) return ClipperLib.Clipper.DistanceFromLineSqrd(pt1, pt2, pt3) < distSqrd;
            else if (pt2.X > pt1.X === pt2.X < pt3.X) return ClipperLib.Clipper.DistanceFromLineSqrd(pt2, pt1, pt3) < distSqrd;
            else return ClipperLib.Clipper.DistanceFromLineSqrd(pt3, pt1, pt2) < distSqrd;
        } else {
            if (pt1.Y > pt2.Y === pt1.Y < pt3.Y) return ClipperLib.Clipper.DistanceFromLineSqrd(pt1, pt2, pt3) < distSqrd;
            else if (pt2.Y > pt1.Y === pt2.Y < pt3.Y) return ClipperLib.Clipper.DistanceFromLineSqrd(pt2, pt1, pt3) < distSqrd;
            else return ClipperLib.Clipper.DistanceFromLineSqrd(pt3, pt1, pt2) < distSqrd;
        }
    };
    ClipperLib.Clipper.PointsAreClose = function(pt1, pt2, distSqrd) {
        var dx = pt1.X - pt2.X;
        var dy = pt1.Y - pt2.Y;
        return dx * dx + dy * dy <= distSqrd;
    };
    ClipperLib.Clipper.ExcludeOp = function(op) {
        var result = op.Prev;
        result.Next = op.Next;
        op.Next.Prev = result;
        result.Idx = 0;
        return result;
    };
    ClipperLib.Clipper.CleanPolygon = function(path, distance) {
        if (typeof distance === "undefined") distance = 1.415;
        //distance = proximity in units/pixels below which vertices will be stripped.
        //Default ~= sqrt(2) so when adjacent vertices or semi-adjacent vertices have
        //both x & y coords within 1 unit, then the second vertex will be stripped.
        var cnt = path.length;
        if (cnt === 0) return new Array();
        var outPts = new Array(cnt);
        for(var i = 0; i < cnt; ++i)outPts[i] = new ClipperLib.OutPt();
        for(var i = 0; i < cnt; ++i){
            outPts[i].Pt = path[i];
            outPts[i].Next = outPts[(i + 1) % cnt];
            outPts[i].Next.Prev = outPts[i];
            outPts[i].Idx = 0;
        }
        var distSqrd = distance * distance;
        var op = outPts[0];
        while(op.Idx === 0 && op.Next !== op.Prev){
            if (ClipperLib.Clipper.PointsAreClose(op.Pt, op.Prev.Pt, distSqrd)) {
                op = ClipperLib.Clipper.ExcludeOp(op);
                cnt--;
            } else if (ClipperLib.Clipper.PointsAreClose(op.Prev.Pt, op.Next.Pt, distSqrd)) {
                ClipperLib.Clipper.ExcludeOp(op.Next);
                op = ClipperLib.Clipper.ExcludeOp(op);
                cnt -= 2;
            } else if (ClipperLib.Clipper.SlopesNearCollinear(op.Prev.Pt, op.Pt, op.Next.Pt, distSqrd)) {
                op = ClipperLib.Clipper.ExcludeOp(op);
                cnt--;
            } else {
                op.Idx = 1;
                op = op.Next;
            }
        }
        if (cnt < 3) cnt = 0;
        var result = new Array(cnt);
        for(var i = 0; i < cnt; ++i){
            result[i] = new ClipperLib.IntPoint1(op.Pt);
            op = op.Next;
        }
        outPts = null;
        return result;
    };
    ClipperLib.Clipper.CleanPolygons = function(polys, distance) {
        var result = new Array(polys.length);
        for(var i = 0, ilen = polys.length; i < ilen; i++)result[i] = ClipperLib.Clipper.CleanPolygon(polys[i], distance);
        return result;
    };
    ClipperLib.Clipper.Minkowski = function(pattern, path, IsSum, IsClosed) {
        var delta = IsClosed ? 1 : 0;
        var polyCnt = pattern.length;
        var pathCnt = path.length;
        var result = new Array();
        if (IsSum) for(var i = 0; i < pathCnt; i++){
            var p = new Array(polyCnt);
            for(var j = 0, jlen = pattern.length, ip = pattern[j]; j < jlen; j++, ip = pattern[j])p[j] = new ClipperLib.IntPoint2(path[i].X + ip.X, path[i].Y + ip.Y);
            result.push(p);
        }
        else for(var i = 0; i < pathCnt; i++){
            var p = new Array(polyCnt);
            for(var j = 0, jlen = pattern.length, ip = pattern[j]; j < jlen; j++, ip = pattern[j])p[j] = new ClipperLib.IntPoint2(path[i].X - ip.X, path[i].Y - ip.Y);
            result.push(p);
        }
        var quads = new Array();
        for(var i = 0; i < pathCnt - 1 + delta; i++)for(var j = 0; j < polyCnt; j++){
            var quad = new Array();
            quad.push(result[i % pathCnt][j % polyCnt]);
            quad.push(result[(i + 1) % pathCnt][j % polyCnt]);
            quad.push(result[(i + 1) % pathCnt][(j + 1) % polyCnt]);
            quad.push(result[i % pathCnt][(j + 1) % polyCnt]);
            if (!ClipperLib.Clipper.Orientation(quad)) quad.reverse();
            quads.push(quad);
        }
        return quads;
    };
    ClipperLib.Clipper.MinkowskiSum = function(pattern, path_or_paths, pathIsClosed) {
        if (!(path_or_paths[0] instanceof Array)) {
            var path = path_or_paths;
            var paths = ClipperLib.Clipper.Minkowski(pattern, path, true, pathIsClosed);
            var c = new ClipperLib.Clipper();
            c.AddPaths(paths, ClipperLib.PolyType.ptSubject, true);
            c.Execute(ClipperLib.ClipType.ctUnion, paths, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
            return paths;
        } else {
            var paths = path_or_paths;
            var solution = new ClipperLib.Paths();
            var c = new ClipperLib.Clipper();
            for(var i = 0; i < paths.length; ++i){
                var tmp = ClipperLib.Clipper.Minkowski(pattern, paths[i], true, pathIsClosed);
                c.AddPaths(tmp, ClipperLib.PolyType.ptSubject, true);
                if (pathIsClosed) {
                    var path = ClipperLib.Clipper.TranslatePath(paths[i], pattern[0]);
                    c.AddPath(path, ClipperLib.PolyType.ptClip, true);
                }
            }
            c.Execute(ClipperLib.ClipType.ctUnion, solution, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
            return solution;
        }
    };
    ClipperLib.Clipper.TranslatePath = function(path, delta) {
        var outPath = new ClipperLib.Path();
        for(var i = 0; i < path.length; i++)outPath.push(new ClipperLib.IntPoint2(path[i].X + delta.X, path[i].Y + delta.Y));
        return outPath;
    };
    ClipperLib.Clipper.MinkowskiDiff = function(poly1, poly2) {
        var paths = ClipperLib.Clipper.Minkowski(poly1, poly2, false, true);
        var c = new ClipperLib.Clipper();
        c.AddPaths(paths, ClipperLib.PolyType.ptSubject, true);
        c.Execute(ClipperLib.ClipType.ctUnion, paths, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
        return paths;
    };
    ClipperLib.Clipper.PolyTreeToPaths = function(polytree) {
        var result = new Array();
        //result.set_Capacity(polytree.get_Total());
        ClipperLib.Clipper.AddPolyNodeToPaths(polytree, ClipperLib.Clipper.NodeType.ntAny, result);
        return result;
    };
    ClipperLib.Clipper.AddPolyNodeToPaths = function(polynode, nt, paths) {
        var match = true;
        switch(nt){
            case ClipperLib.Clipper.NodeType.ntOpen:
                return;
            case ClipperLib.Clipper.NodeType.ntClosed:
                match = !polynode.IsOpen;
                break;
            default:
                break;
        }
        if (polynode.m_polygon.length > 0 && match) paths.push(polynode.m_polygon);
        for(var $i3 = 0, $t3 = polynode.Childs(), $l3 = $t3.length, pn = $t3[$i3]; $i3 < $l3; $i3++, pn = $t3[$i3])ClipperLib.Clipper.AddPolyNodeToPaths(pn, nt, paths);
    };
    ClipperLib.Clipper.OpenPathsFromPolyTree = function(polytree) {
        var result = new ClipperLib.Paths();
        //result.set_Capacity(polytree.ChildCount());
        for(var i = 0, ilen = polytree.ChildCount(); i < ilen; i++)if (polytree.Childs()[i].IsOpen) result.push(polytree.Childs()[i].m_polygon);
        return result;
    };
    ClipperLib.Clipper.ClosedPathsFromPolyTree = function(polytree) {
        var result = new ClipperLib.Paths();
        //result.set_Capacity(polytree.Total());
        ClipperLib.Clipper.AddPolyNodeToPaths(polytree, ClipperLib.Clipper.NodeType.ntClosed, result);
        return result;
    };
    Inherit(ClipperLib.Clipper, ClipperLib.ClipperBase);
    ClipperLib.Clipper.NodeType = {
        ntAny: 0,
        ntOpen: 1,
        ntClosed: 2
    };
    /**
	* @constructor
	*/ ClipperLib.ClipperOffset = function(miterLimit, arcTolerance) {
        if (typeof miterLimit === "undefined") miterLimit = 2;
        if (typeof arcTolerance === "undefined") arcTolerance = ClipperLib.ClipperOffset.def_arc_tolerance;
        this.m_destPolys = new ClipperLib.Paths();
        this.m_srcPoly = new ClipperLib.Path();
        this.m_destPoly = new ClipperLib.Path();
        this.m_normals = new Array();
        this.m_delta = 0;
        this.m_sinA = 0;
        this.m_sin = 0;
        this.m_cos = 0;
        this.m_miterLim = 0;
        this.m_StepsPerRad = 0;
        this.m_lowest = new ClipperLib.IntPoint0();
        this.m_polyNodes = new ClipperLib.PolyNode();
        this.MiterLimit = miterLimit;
        this.ArcTolerance = arcTolerance;
        this.m_lowest.X = -1;
    };
    ClipperLib.ClipperOffset.two_pi = 6.28318530717959;
    ClipperLib.ClipperOffset.def_arc_tolerance = 0.25;
    ClipperLib.ClipperOffset.prototype.Clear = function() {
        ClipperLib.Clear(this.m_polyNodes.Childs());
        this.m_lowest.X = -1;
    };
    ClipperLib.ClipperOffset.Round = ClipperLib.Clipper.Round;
    ClipperLib.ClipperOffset.prototype.AddPath = function(path, joinType, endType) {
        var highI = path.length - 1;
        if (highI < 0) return;
        var newNode = new ClipperLib.PolyNode();
        newNode.m_jointype = joinType;
        newNode.m_endtype = endType;
        //strip duplicate points from path and also get index to the lowest point ...
        if (endType === ClipperLib.EndType.etClosedLine || endType === ClipperLib.EndType.etClosedPolygon) while(highI > 0 && ClipperLib.IntPoint.op_Equality(path[0], path[highI]))highI--;
        //newNode.m_polygon.set_Capacity(highI + 1);
        newNode.m_polygon.push(path[0]);
        var j = 0, k = 0;
        for(var i = 1; i <= highI; i++)if (ClipperLib.IntPoint.op_Inequality(newNode.m_polygon[j], path[i])) {
            j++;
            newNode.m_polygon.push(path[i]);
            if (path[i].Y > newNode.m_polygon[k].Y || path[i].Y === newNode.m_polygon[k].Y && path[i].X < newNode.m_polygon[k].X) k = j;
        }
        if (endType === ClipperLib.EndType.etClosedPolygon && j < 2) return;
        this.m_polyNodes.AddChild(newNode);
        //if this path's lowest pt is lower than all the others then update m_lowest
        if (endType !== ClipperLib.EndType.etClosedPolygon) return;
        if (this.m_lowest.X < 0) this.m_lowest = new ClipperLib.IntPoint2(this.m_polyNodes.ChildCount() - 1, k);
        else {
            var ip = this.m_polyNodes.Childs()[this.m_lowest.X].m_polygon[this.m_lowest.Y];
            if (newNode.m_polygon[k].Y > ip.Y || newNode.m_polygon[k].Y === ip.Y && newNode.m_polygon[k].X < ip.X) this.m_lowest = new ClipperLib.IntPoint2(this.m_polyNodes.ChildCount() - 1, k);
        }
    };
    ClipperLib.ClipperOffset.prototype.AddPaths = function(paths, joinType, endType) {
        for(var i = 0, ilen = paths.length; i < ilen; i++)this.AddPath(paths[i], joinType, endType);
    };
    ClipperLib.ClipperOffset.prototype.FixOrientations = function() {
        //fixup orientations of all closed paths if the orientation of the
        //closed path with the lowermost vertex is wrong ...
        if (this.m_lowest.X >= 0 && !ClipperLib.Clipper.Orientation(this.m_polyNodes.Childs()[this.m_lowest.X].m_polygon)) for(var i = 0; i < this.m_polyNodes.ChildCount(); i++){
            var node = this.m_polyNodes.Childs()[i];
            if (node.m_endtype === ClipperLib.EndType.etClosedPolygon || node.m_endtype === ClipperLib.EndType.etClosedLine && ClipperLib.Clipper.Orientation(node.m_polygon)) node.m_polygon.reverse();
        }
        else for(var i = 0; i < this.m_polyNodes.ChildCount(); i++){
            var node = this.m_polyNodes.Childs()[i];
            if (node.m_endtype === ClipperLib.EndType.etClosedLine && !ClipperLib.Clipper.Orientation(node.m_polygon)) node.m_polygon.reverse();
        }
    };
    ClipperLib.ClipperOffset.GetUnitNormal = function(pt1, pt2) {
        var dx = pt2.X - pt1.X;
        var dy = pt2.Y - pt1.Y;
        if (dx === 0 && dy === 0) return new ClipperLib.DoublePoint2(0, 0);
        var f = 1 / Math.sqrt(dx * dx + dy * dy);
        dx *= f;
        dy *= f;
        return new ClipperLib.DoublePoint2(dy, -dx);
    };
    ClipperLib.ClipperOffset.prototype.DoOffset = function(delta) {
        this.m_destPolys = new Array();
        this.m_delta = delta;
        //if Zero offset, just copy any CLOSED polygons to m_p and return ...
        if (ClipperLib.ClipperBase.near_zero(delta)) {
            //this.m_destPolys.set_Capacity(this.m_polyNodes.ChildCount);
            for(var i = 0; i < this.m_polyNodes.ChildCount(); i++){
                var node = this.m_polyNodes.Childs()[i];
                if (node.m_endtype === ClipperLib.EndType.etClosedPolygon) this.m_destPolys.push(node.m_polygon);
            }
            return;
        }
        //see offset_triginometry3.svg in the documentation folder ...
        if (this.MiterLimit > 2) this.m_miterLim = 2 / (this.MiterLimit * this.MiterLimit);
        else this.m_miterLim = 0.5;
        var y;
        if (this.ArcTolerance <= 0) y = ClipperLib.ClipperOffset.def_arc_tolerance;
        else if (this.ArcTolerance > Math.abs(delta) * ClipperLib.ClipperOffset.def_arc_tolerance) y = Math.abs(delta) * ClipperLib.ClipperOffset.def_arc_tolerance;
        else y = this.ArcTolerance;
        //see offset_triginometry2.svg in the documentation folder ...
        var steps = 3.14159265358979 / Math.acos(1 - y / Math.abs(delta));
        this.m_sin = Math.sin(ClipperLib.ClipperOffset.two_pi / steps);
        this.m_cos = Math.cos(ClipperLib.ClipperOffset.two_pi / steps);
        this.m_StepsPerRad = steps / ClipperLib.ClipperOffset.two_pi;
        if (delta < 0) this.m_sin = -this.m_sin;
        //this.m_destPolys.set_Capacity(this.m_polyNodes.ChildCount * 2);
        for(var i = 0; i < this.m_polyNodes.ChildCount(); i++){
            var node = this.m_polyNodes.Childs()[i];
            this.m_srcPoly = node.m_polygon;
            var len = this.m_srcPoly.length;
            if (len === 0 || delta <= 0 && (len < 3 || node.m_endtype !== ClipperLib.EndType.etClosedPolygon)) continue;
            this.m_destPoly = new Array();
            if (len === 1) {
                if (node.m_jointype === ClipperLib.JoinType.jtRound) {
                    var X = 1, Y = 0;
                    for(var j = 1; j <= steps; j++){
                        this.m_destPoly.push(new ClipperLib.IntPoint2(ClipperLib.ClipperOffset.Round(this.m_srcPoly[0].X + X * delta), ClipperLib.ClipperOffset.Round(this.m_srcPoly[0].Y + Y * delta)));
                        var X2 = X;
                        X = X * this.m_cos - this.m_sin * Y;
                        Y = X2 * this.m_sin + Y * this.m_cos;
                    }
                } else {
                    var X = -1, Y = -1;
                    for(var j = 0; j < 4; ++j){
                        this.m_destPoly.push(new ClipperLib.IntPoint2(ClipperLib.ClipperOffset.Round(this.m_srcPoly[0].X + X * delta), ClipperLib.ClipperOffset.Round(this.m_srcPoly[0].Y + Y * delta)));
                        if (X < 0) X = 1;
                        else if (Y < 0) Y = 1;
                        else X = -1;
                    }
                }
                this.m_destPolys.push(this.m_destPoly);
                continue;
            }
            //build m_normals ...
            this.m_normals.length = 0;
            //this.m_normals.set_Capacity(len);
            for(var j = 0; j < len - 1; j++)this.m_normals.push(ClipperLib.ClipperOffset.GetUnitNormal(this.m_srcPoly[j], this.m_srcPoly[j + 1]));
            if (node.m_endtype === ClipperLib.EndType.etClosedLine || node.m_endtype === ClipperLib.EndType.etClosedPolygon) this.m_normals.push(ClipperLib.ClipperOffset.GetUnitNormal(this.m_srcPoly[len - 1], this.m_srcPoly[0]));
            else this.m_normals.push(new ClipperLib.DoublePoint1(this.m_normals[len - 2]));
            if (node.m_endtype === ClipperLib.EndType.etClosedPolygon) {
                var k = len - 1;
                for(var j = 0; j < len; j++)k = this.OffsetPoint(j, k, node.m_jointype);
                this.m_destPolys.push(this.m_destPoly);
            } else if (node.m_endtype === ClipperLib.EndType.etClosedLine) {
                var k = len - 1;
                for(var j = 0; j < len; j++)k = this.OffsetPoint(j, k, node.m_jointype);
                this.m_destPolys.push(this.m_destPoly);
                this.m_destPoly = new Array();
                //re-build m_normals ...
                var n = this.m_normals[len - 1];
                for(var j = len - 1; j > 0; j--)this.m_normals[j] = new ClipperLib.DoublePoint2(-this.m_normals[j - 1].X, -this.m_normals[j - 1].Y);
                this.m_normals[0] = new ClipperLib.DoublePoint2(-n.X, -n.Y);
                k = 0;
                for(var j = len - 1; j >= 0; j--)k = this.OffsetPoint(j, k, node.m_jointype);
                this.m_destPolys.push(this.m_destPoly);
            } else {
                var k = 0;
                for(var j = 1; j < len - 1; ++j)k = this.OffsetPoint(j, k, node.m_jointype);
                var pt1;
                if (node.m_endtype === ClipperLib.EndType.etOpenButt) {
                    var j = len - 1;
                    pt1 = new ClipperLib.IntPoint2(ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].X + this.m_normals[j].X * delta), ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].Y + this.m_normals[j].Y * delta));
                    this.m_destPoly.push(pt1);
                    pt1 = new ClipperLib.IntPoint2(ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].X - this.m_normals[j].X * delta), ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].Y - this.m_normals[j].Y * delta));
                    this.m_destPoly.push(pt1);
                } else {
                    var j = len - 1;
                    k = len - 2;
                    this.m_sinA = 0;
                    this.m_normals[j] = new ClipperLib.DoublePoint2(-this.m_normals[j].X, -this.m_normals[j].Y);
                    if (node.m_endtype === ClipperLib.EndType.etOpenSquare) this.DoSquare(j, k);
                    else this.DoRound(j, k);
                }
                //re-build m_normals ...
                for(var j = len - 1; j > 0; j--)this.m_normals[j] = new ClipperLib.DoublePoint2(-this.m_normals[j - 1].X, -this.m_normals[j - 1].Y);
                this.m_normals[0] = new ClipperLib.DoublePoint2(-this.m_normals[1].X, -this.m_normals[1].Y);
                k = len - 1;
                for(var j = k - 1; j > 0; --j)k = this.OffsetPoint(j, k, node.m_jointype);
                if (node.m_endtype === ClipperLib.EndType.etOpenButt) {
                    pt1 = new ClipperLib.IntPoint2(ClipperLib.ClipperOffset.Round(this.m_srcPoly[0].X - this.m_normals[0].X * delta), ClipperLib.ClipperOffset.Round(this.m_srcPoly[0].Y - this.m_normals[0].Y * delta));
                    this.m_destPoly.push(pt1);
                    pt1 = new ClipperLib.IntPoint2(ClipperLib.ClipperOffset.Round(this.m_srcPoly[0].X + this.m_normals[0].X * delta), ClipperLib.ClipperOffset.Round(this.m_srcPoly[0].Y + this.m_normals[0].Y * delta));
                    this.m_destPoly.push(pt1);
                } else {
                    k = 1;
                    this.m_sinA = 0;
                    if (node.m_endtype === ClipperLib.EndType.etOpenSquare) this.DoSquare(0, 1);
                    else this.DoRound(0, 1);
                }
                this.m_destPolys.push(this.m_destPoly);
            }
        }
    };
    ClipperLib.ClipperOffset.prototype.Execute = function() {
        var a = arguments, ispolytree = a[0] instanceof ClipperLib.PolyTree;
        if (!ispolytree) {
            var solution = a[0], delta = a[1];
            ClipperLib.Clear(solution);
            this.FixOrientations();
            this.DoOffset(delta);
            //now clean up 'corners' ...
            var clpr = new ClipperLib.Clipper(0);
            clpr.AddPaths(this.m_destPolys, ClipperLib.PolyType.ptSubject, true);
            if (delta > 0) clpr.Execute(ClipperLib.ClipType.ctUnion, solution, ClipperLib.PolyFillType.pftPositive, ClipperLib.PolyFillType.pftPositive);
            else {
                var r = ClipperLib.Clipper.GetBounds(this.m_destPolys);
                var outer = new ClipperLib.Path();
                outer.push(new ClipperLib.IntPoint2(r.left - 10, r.bottom + 10));
                outer.push(new ClipperLib.IntPoint2(r.right + 10, r.bottom + 10));
                outer.push(new ClipperLib.IntPoint2(r.right + 10, r.top - 10));
                outer.push(new ClipperLib.IntPoint2(r.left - 10, r.top - 10));
                clpr.AddPath(outer, ClipperLib.PolyType.ptSubject, true);
                clpr.ReverseSolution = true;
                clpr.Execute(ClipperLib.ClipType.ctUnion, solution, ClipperLib.PolyFillType.pftNegative, ClipperLib.PolyFillType.pftNegative);
                if (solution.length > 0) solution.splice(0, 1);
            }
        //console.log(JSON.stringify(solution));
        } else {
            var solution = a[0], delta = a[1];
            solution.Clear();
            this.FixOrientations();
            this.DoOffset(delta);
            //now clean up 'corners' ...
            var clpr = new ClipperLib.Clipper(0);
            clpr.AddPaths(this.m_destPolys, ClipperLib.PolyType.ptSubject, true);
            if (delta > 0) clpr.Execute(ClipperLib.ClipType.ctUnion, solution, ClipperLib.PolyFillType.pftPositive, ClipperLib.PolyFillType.pftPositive);
            else {
                var r = ClipperLib.Clipper.GetBounds(this.m_destPolys);
                var outer = new ClipperLib.Path();
                outer.push(new ClipperLib.IntPoint2(r.left - 10, r.bottom + 10));
                outer.push(new ClipperLib.IntPoint2(r.right + 10, r.bottom + 10));
                outer.push(new ClipperLib.IntPoint2(r.right + 10, r.top - 10));
                outer.push(new ClipperLib.IntPoint2(r.left - 10, r.top - 10));
                clpr.AddPath(outer, ClipperLib.PolyType.ptSubject, true);
                clpr.ReverseSolution = true;
                clpr.Execute(ClipperLib.ClipType.ctUnion, solution, ClipperLib.PolyFillType.pftNegative, ClipperLib.PolyFillType.pftNegative);
                //remove the outer PolyNode rectangle ...
                if (solution.ChildCount() === 1 && solution.Childs()[0].ChildCount() > 0) {
                    var outerNode = solution.Childs()[0];
                    //solution.Childs.set_Capacity(outerNode.ChildCount);
                    solution.Childs()[0] = outerNode.Childs()[0];
                    solution.Childs()[0].m_Parent = solution;
                    for(var i = 1; i < outerNode.ChildCount(); i++)solution.AddChild(outerNode.Childs()[i]);
                } else solution.Clear();
            }
        }
    };
    ClipperLib.ClipperOffset.prototype.OffsetPoint = function(j, k, jointype) {
        //cross product ...
        this.m_sinA = this.m_normals[k].X * this.m_normals[j].Y - this.m_normals[j].X * this.m_normals[k].Y;
        if (Math.abs(this.m_sinA * this.m_delta) < 1.0) {
            //dot product ...
            var cosA = this.m_normals[k].X * this.m_normals[j].X + this.m_normals[j].Y * this.m_normals[k].Y;
            if (cosA > 0) {
                this.m_destPoly.push(new ClipperLib.IntPoint2(ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].X + this.m_normals[k].X * this.m_delta), ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].Y + this.m_normals[k].Y * this.m_delta)));
                return k;
            }
        //else angle ==> 180 degrees
        } else if (this.m_sinA > 1) this.m_sinA = 1.0;
        else if (this.m_sinA < -1) this.m_sinA = -1;
        if (this.m_sinA * this.m_delta < 0) {
            this.m_destPoly.push(new ClipperLib.IntPoint2(ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].X + this.m_normals[k].X * this.m_delta), ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].Y + this.m_normals[k].Y * this.m_delta)));
            this.m_destPoly.push(new ClipperLib.IntPoint1(this.m_srcPoly[j]));
            this.m_destPoly.push(new ClipperLib.IntPoint2(ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].X + this.m_normals[j].X * this.m_delta), ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].Y + this.m_normals[j].Y * this.m_delta)));
        } else switch(jointype){
            case ClipperLib.JoinType.jtMiter:
                var r = 1 + (this.m_normals[j].X * this.m_normals[k].X + this.m_normals[j].Y * this.m_normals[k].Y);
                if (r >= this.m_miterLim) this.DoMiter(j, k, r);
                else this.DoSquare(j, k);
                break;
            case ClipperLib.JoinType.jtSquare:
                this.DoSquare(j, k);
                break;
            case ClipperLib.JoinType.jtRound:
                this.DoRound(j, k);
                break;
        }
        k = j;
        return k;
    };
    ClipperLib.ClipperOffset.prototype.DoSquare = function(j, k) {
        var dx = Math.tan(Math.atan2(this.m_sinA, this.m_normals[k].X * this.m_normals[j].X + this.m_normals[k].Y * this.m_normals[j].Y) / 4);
        this.m_destPoly.push(new ClipperLib.IntPoint2(ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].X + this.m_delta * (this.m_normals[k].X - this.m_normals[k].Y * dx)), ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].Y + this.m_delta * (this.m_normals[k].Y + this.m_normals[k].X * dx))));
        this.m_destPoly.push(new ClipperLib.IntPoint2(ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].X + this.m_delta * (this.m_normals[j].X + this.m_normals[j].Y * dx)), ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].Y + this.m_delta * (this.m_normals[j].Y - this.m_normals[j].X * dx))));
    };
    ClipperLib.ClipperOffset.prototype.DoMiter = function(j, k, r) {
        var q = this.m_delta / r;
        this.m_destPoly.push(new ClipperLib.IntPoint2(ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].X + (this.m_normals[k].X + this.m_normals[j].X) * q), ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].Y + (this.m_normals[k].Y + this.m_normals[j].Y) * q)));
    };
    ClipperLib.ClipperOffset.prototype.DoRound = function(j, k) {
        var a = Math.atan2(this.m_sinA, this.m_normals[k].X * this.m_normals[j].X + this.m_normals[k].Y * this.m_normals[j].Y);
        var steps = Math.max(ClipperLib.Cast_Int32(ClipperLib.ClipperOffset.Round(this.m_StepsPerRad * Math.abs(a))), 1);
        var X = this.m_normals[k].X, Y = this.m_normals[k].Y, X2;
        for(var i = 0; i < steps; ++i){
            this.m_destPoly.push(new ClipperLib.IntPoint2(ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].X + X * this.m_delta), ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].Y + Y * this.m_delta)));
            X2 = X;
            X = X * this.m_cos - this.m_sin * Y;
            Y = X2 * this.m_sin + Y * this.m_cos;
        }
        this.m_destPoly.push(new ClipperLib.IntPoint2(ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].X + this.m_normals[j].X * this.m_delta), ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].Y + this.m_normals[j].Y * this.m_delta)));
    };
    ClipperLib.Error = function(message) {
        try {
            throw new Error(message);
        } catch (err) {
            alert(err.message);
        }
    };
    // ---------------------------------------------
    // JS extension by Timo 2013
    ClipperLib.JS = {};
    ClipperLib.JS.AreaOfPolygon = function(poly, scale) {
        if (!scale) scale = 1;
        return ClipperLib.Clipper.Area(poly) / (scale * scale);
    };
    ClipperLib.JS.AreaOfPolygons = function(poly, scale) {
        if (!scale) scale = 1;
        var area = 0;
        for(var i = 0; i < poly.length; i++)area += ClipperLib.Clipper.Area(poly[i]);
        return area / (scale * scale);
    };
    ClipperLib.JS.BoundsOfPath = function(path, scale) {
        return ClipperLib.JS.BoundsOfPaths([
            path
        ], scale);
    };
    ClipperLib.JS.BoundsOfPaths = function(paths, scale) {
        if (!scale) scale = 1;
        var bounds = ClipperLib.Clipper.GetBounds(paths);
        bounds.left /= scale;
        bounds.bottom /= scale;
        bounds.right /= scale;
        bounds.top /= scale;
        return bounds;
    };
    // Clean() joins vertices that are too near each other
    // and causes distortion to offsetted polygons without cleaning
    ClipperLib.JS.Clean = function(polygon, delta) {
        if (!(polygon instanceof Array)) return [];
        var isPolygons = polygon[0] instanceof Array;
        var polygon = ClipperLib.JS.Clone(polygon);
        if (typeof delta !== "number" || delta === null) {
            ClipperLib.Error("Delta is not a number in Clean().");
            return polygon;
        }
        if (polygon.length === 0 || polygon.length === 1 && polygon[0].length === 0 || delta < 0) return polygon;
        if (!isPolygons) polygon = [
            polygon
        ];
        var k_length = polygon.length;
        var len, poly, result, d, p, j, i;
        var results = [];
        for(var k = 0; k < k_length; k++){
            poly = polygon[k];
            len = poly.length;
            if (len === 0) continue;
            else if (len < 3) {
                result = poly;
                results.push(result);
                continue;
            }
            result = poly;
            d = delta * delta;
            //d = Math.floor(c_delta * c_delta);
            p = poly[0];
            j = 1;
            for(i = 1; i < len; i++){
                if ((poly[i].X - p.X) * (poly[i].X - p.X) + (poly[i].Y - p.Y) * (poly[i].Y - p.Y) <= d) continue;
                result[j] = poly[i];
                p = poly[i];
                j++;
            }
            p = poly[j - 1];
            if ((poly[0].X - p.X) * (poly[0].X - p.X) + (poly[0].Y - p.Y) * (poly[0].Y - p.Y) <= d) j--;
            if (j < len) result.splice(j, len - j);
            if (result.length) results.push(result);
        }
        if (!isPolygons && results.length) results = results[0];
        else if (!isPolygons && results.length === 0) results = [];
        else if (isPolygons && results.length === 0) results = [
            []
        ];
        return results;
    };
    // Make deep copy of Polygons or Polygon
    // so that also IntPoint objects are cloned and not only referenced
    // This should be the fastest way
    ClipperLib.JS.Clone = function(polygon) {
        if (!(polygon instanceof Array)) return [];
        if (polygon.length === 0) return [];
        else if (polygon.length === 1 && polygon[0].length === 0) return [
            []
        ];
        var isPolygons = polygon[0] instanceof Array;
        if (!isPolygons) polygon = [
            polygon
        ];
        var len = polygon.length, plen, i, j, result;
        var results = new Array(len);
        for(i = 0; i < len; i++){
            plen = polygon[i].length;
            result = new Array(plen);
            for(j = 0; j < plen; j++)result[j] = {
                X: polygon[i][j].X,
                Y: polygon[i][j].Y
            };
            results[i] = result;
        }
        if (!isPolygons) results = results[0];
        return results;
    };
    // Removes points that doesn't affect much to the visual appearance.
    // If middle point is at or under certain distance (tolerance) of the line segment between
    // start and end point, the middle point is removed.
    ClipperLib.JS.Lighten = function(polygon, tolerance) {
        if (!(polygon instanceof Array)) return [];
        if (typeof tolerance !== "number" || tolerance === null) {
            ClipperLib.Error("Tolerance is not a number in Lighten().");
            return ClipperLib.JS.Clone(polygon);
        }
        if (polygon.length === 0 || polygon.length === 1 && polygon[0].length === 0 || tolerance < 0) return ClipperLib.JS.Clone(polygon);
        var isPolygons = polygon[0] instanceof Array;
        if (!isPolygons) polygon = [
            polygon
        ];
        var i, j, poly, k, poly2, plen, A, B, P, d, rem, addlast;
        var bxax, byay, l, ax, ay;
        var len = polygon.length;
        var toleranceSq = tolerance * tolerance;
        var results = [];
        for(i = 0; i < len; i++){
            poly = polygon[i];
            plen = poly.length;
            if (plen === 0) continue;
            for(k = 0; k < 1000000; k++){
                poly2 = [];
                plen = poly.length;
                // the first have to added to the end, if first and last are not the same
                // this way we ensure that also the actual last point can be removed if needed
                if (poly[plen - 1].X !== poly[0].X || poly[plen - 1].Y !== poly[0].Y) {
                    addlast = 1;
                    poly.push({
                        X: poly[0].X,
                        Y: poly[0].Y
                    });
                    plen = poly.length;
                } else addlast = 0;
                rem = []; // Indexes of removed points
                for(j = 0; j < plen - 2; j++){
                    A = poly[j]; // Start point of line segment
                    P = poly[j + 1]; // Middle point. This is the one to be removed.
                    B = poly[j + 2]; // End point of line segment
                    ax = A.X;
                    ay = A.Y;
                    bxax = B.X - ax;
                    byay = B.Y - ay;
                    if (bxax !== 0 || byay !== 0) {
                        l = ((P.X - ax) * bxax + (P.Y - ay) * byay) / (bxax * bxax + byay * byay);
                        if (l > 1) {
                            ax = B.X;
                            ay = B.Y;
                        } else if (l > 0) {
                            ax += bxax * l;
                            ay += byay * l;
                        }
                    }
                    bxax = P.X - ax;
                    byay = P.Y - ay;
                    d = bxax * bxax + byay * byay;
                    if (d <= toleranceSq) {
                        rem[j + 1] = 1;
                        j++; // when removed, transfer the pointer to the next one
                    }
                }
                // add all unremoved points to poly2
                poly2.push({
                    X: poly[0].X,
                    Y: poly[0].Y
                });
                for(j = 1; j < plen - 1; j++)if (!rem[j]) poly2.push({
                    X: poly[j].X,
                    Y: poly[j].Y
                });
                poly2.push({
                    X: poly[plen - 1].X,
                    Y: poly[plen - 1].Y
                });
                // if the first point was added to the end, remove it
                if (addlast) poly.pop();
                // break, if there was not anymore removed points
                if (!rem.length) break;
                else poly = poly2;
            }
            plen = poly2.length;
            // remove duplicate from end, if needed
            if (poly2[plen - 1].X === poly2[0].X && poly2[plen - 1].Y === poly2[0].Y) poly2.pop();
            if (poly2.length > 2) results.push(poly2);
        }
        if (!isPolygons) results = results[0];
        if (typeof results === "undefined") results = [];
        return results;
    };
    ClipperLib.JS.PerimeterOfPath = function(path, closed, scale) {
        if (typeof path === "undefined") return 0;
        var sqrt = Math.sqrt;
        var perimeter = 0.0;
        var p1, p2, p1x = 0.0, p1y = 0.0, p2x = 0.0, p2y = 0.0;
        var j = path.length;
        if (j < 2) return 0;
        if (closed) {
            path[j] = path[0];
            j++;
        }
        while(--j){
            p1 = path[j];
            p1x = p1.X;
            p1y = p1.Y;
            p2 = path[j - 1];
            p2x = p2.X;
            p2y = p2.Y;
            perimeter += sqrt((p1x - p2x) * (p1x - p2x) + (p1y - p2y) * (p1y - p2y));
        }
        if (closed) path.pop();
        return perimeter / scale;
    };
    ClipperLib.JS.PerimeterOfPaths = function(paths, closed, scale) {
        if (!scale) scale = 1;
        var perimeter = 0;
        for(var i = 0; i < paths.length; i++)perimeter += ClipperLib.JS.PerimeterOfPath(paths[i], closed, scale);
        return perimeter;
    };
    ClipperLib.JS.ScaleDownPath = function(path, scale) {
        var i, p;
        if (!scale) scale = 1;
        i = path.length;
        while(i--){
            p = path[i];
            p.X = p.X / scale;
            p.Y = p.Y / scale;
        }
    };
    ClipperLib.JS.ScaleDownPaths = function(paths, scale) {
        var i, j, p;
        if (!scale) scale = 1;
        i = paths.length;
        while(i--){
            j = paths[i].length;
            while(j--){
                p = paths[i][j];
                p.X = p.X / scale;
                p.Y = p.Y / scale;
            }
        }
    };
    ClipperLib.JS.ScaleUpPath = function(path, scale) {
        var i, p, round = Math.round;
        if (!scale) scale = 1;
        i = path.length;
        while(i--){
            p = path[i];
            p.X = round(p.X * scale);
            p.Y = round(p.Y * scale);
        }
    };
    ClipperLib.JS.ScaleUpPaths = function(paths, scale) {
        var i, j, p, round = Math.round;
        if (!scale) scale = 1;
        i = paths.length;
        while(i--){
            j = paths[i].length;
            while(j--){
                p = paths[i][j];
                p.X = round(p.X * scale);
                p.Y = round(p.Y * scale);
            }
        }
    };
    /**
	* @constructor
	*/ ClipperLib.ExPolygons = function() {
        return [];
    };
    /**
	* @constructor
	*/ ClipperLib.ExPolygon = function() {
        this.outer = null;
        this.holes = null;
    };
    ClipperLib.JS.AddOuterPolyNodeToExPolygons = function(polynode, expolygons) {
        var ep = new ClipperLib.ExPolygon();
        ep.outer = polynode.Contour();
        var childs = polynode.Childs();
        var ilen = childs.length;
        ep.holes = new Array(ilen);
        var node, n, i, j, childs2, jlen;
        for(i = 0; i < ilen; i++){
            node = childs[i];
            ep.holes[i] = node.Contour();
            //Add outer polygons contained by (nested within) holes ...
            for(j = 0, childs2 = node.Childs(), jlen = childs2.length; j < jlen; j++){
                n = childs2[j];
                ClipperLib.JS.AddOuterPolyNodeToExPolygons(n, expolygons);
            }
        }
        expolygons.push(ep);
    };
    ClipperLib.JS.ExPolygonsToPaths = function(expolygons) {
        var a, i, alen, ilen;
        var paths = new ClipperLib.Paths();
        for(a = 0, alen = expolygons.length; a < alen; a++){
            paths.push(expolygons[a].outer);
            for(i = 0, ilen = expolygons[a].holes.length; i < ilen; i++)paths.push(expolygons[a].holes[i]);
        }
        return paths;
    };
    ClipperLib.JS.PolyTreeToExPolygons = function(polytree) {
        var expolygons = new ClipperLib.ExPolygons();
        var node, i, childs, ilen;
        for(i = 0, childs = polytree.Childs(), ilen = childs.length; i < ilen; i++){
            node = childs[i];
            ClipperLib.JS.AddOuterPolyNodeToExPolygons(node, expolygons);
        }
        return expolygons;
    };
})();

});



parcelRegister("bg3Nf", function(module, exports) {

$parcel$export(module.exports, "RevenueForecastReportProfitColumns", function () { return $8324219de500cef2$export$78e43eef14ed28fa; });

var $61Ea1 = parcelRequire("61Ea1");

var $eat5C = parcelRequire("eat5C");
parcelRequire("jbmdS");

var $4hBm1 = parcelRequire("4hBm1");

var $ikffN = parcelRequire("ikffN");

var $aOFHJ = parcelRequire("aOFHJ");

var $907iH = parcelRequire("907iH");

var $6YofH = parcelRequire("6YofH");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $12o9H = parcelRequire("12o9H");

const $8324219de500cef2$var$cellStyles = (row, stores, monthStart, isPastMonth)=>{
    return {
        ...isPastMonth ? {
            backgroundImage: `url(${new URL((parcelRequire("3vc8e")))})`
        } : {}
    };
};
const $8324219de500cef2$export$78e43eef14ed28fa = (store)=>({
        title: (monthStartDate)=>({
                id: "title",
                label: "Title",
                type: "text",
                width: 18,
                editable: (row)=>false,
                value: (row, stores)=>{
                    return (0, $ikffN.capitalCase)(row);
                },
                component: ({ value: value, group: group, stores: stores })=>{
                    const { row: row, table: table } = stores;
                    if (row.group === "totals") return "Total";
                    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        style: {
                            paddingLeft: `${1 * row.groupLevel}rem`
                        },
                        children: value
                    });
                }
            }),
        profit: (monthStartDate)=>{
            const monthStart = (0, $4hBm1.startOfMonth)(monthStartDate);
            const monthEnd = (0, $4hBm1.endOfMonth)(monthStart);
            const monthId = (0, $4hBm1.format)(monthStart, "yyyy-MM");
            const isPastMonth = monthEnd < (0, $4hBm1.startOfMonth)(new Date());
            const revenueCell = (0, $aOFHJ.RevenueForecastReportPhaseColumns)(store).revenue(monthStartDate, [
                "status"
            ]);
            const staffCostCell = (0, $907iH.RevenueForecastReportStaffColumns)(store).cost(monthStartDate);
            const overheadCostCell = (0, $6YofH.RevenueForecastReportOverheadColumns)(store).cost(monthStartDate, store);
            return {
                label: (0, $4hBm1.format)(monthStartDate, "MMM yy"),
                type: "currency",
                width: 8,
                value: (row)=>{
                    const revenue = store.getRevenueInMonth("", monthId, null);
                    const staffCost = (0, $8kZ1o.canViewRevenueForecastStaffExpenses)((0, $1BTI2.default).user) ? (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(store.getStaffRows().map((ph)=>{
                        return staffCostCell.value(ph);
                    })) : 0;
                    const overheadCost = (0, $8kZ1o.canViewRevenueForecastOperationalExpenses)((0, $1BTI2.default).user) ? (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum([
                        ...new Set(store.getOverheadRows())
                    ].map((ph)=>{
                        return overheadCostCell.value(ph);
                    })) : 0;
                    return revenue - staffCost - overheadCost;
                },
                // data: (row) => {
                //     return [
                //         ...(revenueCell.data?.(row) || []),
                //         ...(staffCostCell.data?.(row) || []),
                //         ...(overheadCostCell.data?.(row) || []),
                //     ]
                // },
                editable: ()=>false,
                style: (row, stores)=>{
                    return $8324219de500cef2$var$cellStyles(row, stores, monthStart, isPastMonth);
                },
                format: (v)=>(0, $12o9H.FormatCurrency)(v, {
                        decimals: 0
                    }),
                aggregate: "sum"
            };
        },
        profitMargin: (monthStartDate)=>{
            const monthStart = (0, $4hBm1.startOfMonth)(monthStartDate);
            const monthEnd = (0, $4hBm1.endOfMonth)(monthStart);
            const monthId = (0, $4hBm1.format)(monthStart, "yyyy-MM");
            const isPastMonth = monthEnd < (0, $4hBm1.startOfMonth)(new Date());
            const revenueCell = (0, $aOFHJ.RevenueForecastReportPhaseColumns)(store).revenue(monthStartDate, [
                "status"
            ]);
            const staffCostCell = (0, $907iH.RevenueForecastReportStaffColumns)(store).cost(monthStartDate);
            const overheadCostCell = (0, $6YofH.RevenueForecastReportOverheadColumns)(store).cost(monthStartDate);
            return {
                label: (0, $4hBm1.format)(monthStartDate, "MMM yy"),
                type: "percent",
                width: 8,
                value: (row)=>{
                    const revenue = store.getRevenueInMonth("", monthId, null);
                    const staffCost = (0, $8kZ1o.canViewRevenueForecastStaffExpenses)((0, $1BTI2.default).user) ? (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(store.getStaffRows().map((ph)=>{
                        return staffCostCell.value(ph);
                    })) : 0;
                    const overheadCost = (0, $8kZ1o.canViewRevenueForecastOperationalExpenses)((0, $1BTI2.default).user) ? (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum([
                        ...new Set(store.getOverheadRows())
                    ].map((ph)=>{
                        return overheadCostCell.value(ph);
                    })) : 0;
                    return (revenue - staffCost - overheadCost) / revenue;
                },
                // data: (row) => {
                //     return [
                //         ...(revenueCell.data?.(row) || []),
                //         ...(staffCostCell.data?.(row) || []),
                //         ...(overheadCostCell.data?.(row) || []),
                //     ]
                // },
                editable: ()=>false,
                style: (row, stores)=>{
                    return $8324219de500cef2$var$cellStyles(row, stores, monthStart, isPastMonth);
                },
                aggregate: "sum"
            };
        },
        markup: (monthStartDate)=>{
            const monthStart = (0, $4hBm1.startOfMonth)(monthStartDate);
            const monthEnd = (0, $4hBm1.endOfMonth)(monthStart);
            const monthId = (0, $4hBm1.format)(monthStart, "yyyy-MM");
            const isPastMonth = monthEnd < (0, $4hBm1.startOfMonth)(new Date());
            const revenueCell = (0, $aOFHJ.RevenueForecastReportPhaseColumns)(store).revenue(monthStartDate, [
                "status"
            ]);
            const staffCostCell = (0, $907iH.RevenueForecastReportStaffColumns)(store).cost(monthStartDate);
            const overheadCostCell = (0, $6YofH.RevenueForecastReportOverheadColumns)(store).cost(monthStartDate);
            return {
                label: (0, $4hBm1.format)(monthStartDate, "MMM yy"),
                type: "percent",
                width: 8,
                value: (row)=>{
                    const revenue = store.getRevenueInMonth("", monthId, null);
                    const staffCost = (0, $8kZ1o.canViewRevenueForecastStaffExpenses)((0, $1BTI2.default).user) ? (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(store.getStaffRows().map((ph)=>{
                        return staffCostCell.value(ph);
                    })) : 0;
                    const overheadCost = (0, $8kZ1o.canViewRevenueForecastOperationalExpenses)((0, $1BTI2.default).user) ? (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum([
                        ...new Set(store.getOverheadRows())
                    ].map((ph)=>{
                        return overheadCostCell.value(ph);
                    })) : 0;
                    return revenue / (staffCost + overheadCost) - 1;
                },
                // data: (row) => {
                //     return [
                //         ...(revenueCell.data?.(row) || []),
                //         ...(staffCostCell.data?.(row) || []),
                //         ...(overheadCostCell.data?.(row) || []),
                //     ]
                // },
                editable: ()=>false,
                style: (row, stores)=>{
                    return $8324219de500cef2$var$cellStyles(row, stores, monthStart, isPastMonth);
                },
                aggregate: "sum"
            };
        },
        total: (monthStartDate, store)=>{
            return {
                id: "total",
                label: /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                    children: [
                        "Total",
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                            style: {
                                fontSize: "1.5em",
                                float: "right"
                            },
                            onClick: (e)=>e.stopPropagation(),
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                    className: `fa fa-caret-left`,
                                    style: {
                                        cursor: "pointer"
                                    },
                                    onClick: ()=>store.shiftDates(-1)
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                    className: `fa fa-caret-right`,
                                    style: {
                                        marginRight: 0,
                                        cursor: "pointer"
                                    },
                                    onClick: ()=>store.shiftDates(1)
                                })
                            ]
                        })
                    ]
                }),
                type: "text",
                width: 18,
                editable: (row)=>false,
                value: (row)=>{
                    return "";
                }
            };
        }
    });

});

parcelRegister("3erXY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25a85f6ac711f4d5$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("jbmdS");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("fEcKX");
var $25a85f6ac711f4d5$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ report: report })=>{
    if (!(report !== null && report !== void 0 && report.needsUpdate)) return null;
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "text-center p-8 flex justify-center items-start",
        style: {
            background: "#FFFFFFaa",
            zIndex: 900,
            width: "100vw",
            height: "100vh",
            position: "absolute",
            left: 0,
            marginTop: "-2rem",
            minHeight: "15rem"
        },
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            style: {
                backgroundColor: "white",
                width: "20rem",
                height: "13rem",
                display: "inline-flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "1rem",
                boxShadow: "0 0 2rem #00000033",
                marginTop: "2rem"
            },
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsx)("h4", {
                    children: "Apply Changes To Report"
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                    className: "btn btn-primary",
                    onClick: ()=>report.setQueryKey(),
                    style: {
                        marginTop: "2rem"
                    },
                    children: "Update Report"
                })
            ]
        })
    });
});

});


parcelRegister("a9PLH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7652e6c3fd228e90$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $1EEMt = parcelRequire("1EEMt");

var $4hBm1 = parcelRequire("4hBm1");

var $6RcUP = parcelRequire("6RcUP");

var $1BTI2 = parcelRequire("1BTI2");

var $XoImS = parcelRequire("XoImS");
parcelRequire("3nqbz");
parcelRequire("4Ypeq");

var $gJT7h = parcelRequire("gJT7h");
parcelRequire("6Q5sp");

var $hYUed = parcelRequire("hYUed");

var $jCrfK = parcelRequire("jCrfK");

var $bfcx4 = parcelRequire("bfcx4");

var $alT7C = parcelRequire("alT7C");

var $3h7sC = parcelRequire("3h7sC");

var $47i9t = parcelRequire("47i9t");
var $7652e6c3fd228e90$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(()=>{
    const [store, setStore] = (0, $jbmdS.useState)((0, $hYUed.default));
    if (store.selectedMonth && store.selectedObject && store.selectedProjectId) {
        var _SessionStore$user;
        const month = store.selectedMonth && (0, $4hBm1.startOfMonth)(store.selectedMonth);
        const project = (0, $gJT7h.default).projectsById[store.selectedProjectId];
        const phase = (0, $XoImS.default).phasesById[store.selectedPhaseId];
        const periodId = (0, $4hBm1.format)(month, "yyyy-MM");
        const periodType = "month";
        const queryId = `sidebar${periodType}${periodId}${store.selectedProjectId}${store.selectedPhaseId}`;
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6RcUP.default), {
            queryIds: [
                {
                    id: queryId,
                    baseURL: "https://server2.coincraft.co",
                    path: `/project-forecast-sidebar`,
                    method: "POST",
                    staleTime: 0,
                    data: {
                        projectId: store.selectedProjectId,
                        organisationId: (0, $1BTI2.default).organisationId,
                        userId: (_SessionStore$user = (0, $1BTI2.default).user) === null || _SessionStore$user === void 0 ? void 0 : _SessionStore$user.id,
                        invoiceType: (0, $1BTI2.default).organisation.defaultRevenueForecastReport.filters.invoiceData,
                        periodType: periodType,
                        dataType: (0, $hYUed.default).report.filters.revenueData,
                        selectedPeriod: periodId,
                        phaseId: store.selectedPhaseId
                    }
                },
                {
                    id: store.selectedProjectId + "phases",
                    queryFn: async ()=>{
                        const requestData = await (0, $3h7sC.trpc).legacy.getProjectPhases.query({
                            projectId: store.selectedProjectId
                        });
                        return (0, $47i9t.processTRPCData)(requestData, `phases-${store.selectedProjectId}`);
                    }
                },
                {
                    id: `rates-${store.selectedProjectId}`,
                    queryFn: async ()=>{
                        const requestData = await (0, $3h7sC.trpc).legacy.getRates.query({
                            projectId: store.selectedProjectId
                        });
                        return (0, $47i9t.processTRPCData)(requestData, `rates-${store.selectedProjectId}`);
                    }
                }
            ],
            children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    display: "flex",
                    flexDirection: "column",
                    height: "100%"
                },
                children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jCrfK.default), {
                            title: project === null || project === void 0 ? void 0 : project.title,
                            subTitle: phase === null || phase === void 0 ? void 0 : phase.title,
                            link: `/projects/${store.selectedProjectId}`
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bfcx4.default), {
                            title: (0, $4hBm1.format)(month, "MMM yy"),
                            onLeftClick: ()=>store.shiftSelectedPeriod(-1),
                            onRightClick: ()=>store.shiftSelectedPeriod(1)
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $alT7C.ProjectSidebarContent), {
                            periodType: periodType,
                            period: month,
                            periodId: periodId,
                            projectId: store.selectedProjectId,
                            phaseId: store.selectedPhaseId,
                            queryId: queryId,
                            onUpdateRevenue: ({ period: period, revenue: revenue, ...models })=>{
                                var _models$phase, _models$project, _models$phase2;
                                (0, $hYUed.default).setEditedRevenueData([
                                    (_models$phase = models.phase) === null || _models$phase === void 0 ? void 0 : _models$phase.status,
                                    (_models$project = models.project) === null || _models$project === void 0 ? void 0 : _models$project.id,
                                    (_models$phase2 = models.phase) === null || _models$phase2 === void 0 ? void 0 : _models$phase2.id
                                ].filter((k)=>k).join(","), period, revenue, false);
                            }
                        })
                    ]
                })
            }, queryId)
        });
    }
});

});
parcelRegister("3nqbz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2757d503c0a840ee$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $4hBm1 = parcelRequire("4hBm1");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $4Ypeq = parcelRequire("4Ypeq");

var $bfcx4 = parcelRequire("bfcx4");

var $jCrfK = parcelRequire("jCrfK");

var $hYVSY = parcelRequire("hYVSY");

var $8oGqY = parcelRequire("8oGqY");

var $2tryL = parcelRequire("2tryL");

var $ccJUd = parcelRequire("ccJUd");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $6RcUP = parcelRequire("6RcUP");

var $6Q5sp = parcelRequire("6Q5sp");

var $12o9H = parcelRequire("12o9H");

var $kqlQp = parcelRequire("kqlQp");
var $2757d503c0a840ee$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ onUpdateRevenue: onUpdateRevenue1, onUpdateResources: onUpdateResources })=>{
    const [store, setStore] = (0, $jbmdS.useState)((0, $4Ypeq.default));
    const selectedProjectOrPhase = store.selectedProjectOrPhase;
    const project = (selectedProjectOrPhase === null || selectedProjectOrPhase === void 0 ? void 0 : selectedProjectOrPhase.project) || selectedProjectOrPhase;
    const phase = (selectedProjectOrPhase === null || selectedProjectOrPhase === void 0 ? void 0 : selectedProjectOrPhase.project) && selectedProjectOrPhase;
    const period = store.selectedPeriod && store.startOfPeriod(store.selectedPeriod);
    if (selectedProjectOrPhase && period) return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "flex flex-col h-full",
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jCrfK.default), {
                    title: project === null || project === void 0 ? void 0 : project.title,
                    subTitle: phase === null || phase === void 0 ? void 0 : phase.title,
                    link: `/projects/${project === null || project === void 0 ? void 0 : project.id}`
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bfcx4.default), {
                    title: (0, $4hBm1.format)(store.selectedPeriod, store.periodDisplayFormat()),
                    onLeftClick: ()=>store.shiftSelectedDates(-1),
                    onRightClick: ()=>store.shiftSelectedDates(1)
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)($2757d503c0a840ee$var$SidebarProgress, {
                    store: store,
                    period: period,
                    selectedProjectOrPhase: selectedProjectOrPhase,
                    onUpdateResources: onUpdateResources,
                    onUpdateRevenue: onUpdateRevenue1
                })
            ]
        })
    }, (selectedProjectOrPhase === null || selectedProjectOrPhase === void 0 ? void 0 : selectedProjectOrPhase.id) + (0, $4hBm1.format)(store.selectedPeriod, store.periodFormat()));
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        style: {
            padding: "1em"
        },
        children: "Please select a revenue cell from project or phase."
    });
});
const $2757d503c0a840ee$var$SidebarProgress = (0, $1EEMt.observer)(({ store: store, period: period, selectedProjectOrPhase: selectedProjectOrPhase, onUpdateRevenue: onUpdateRevenue1 = null, onUpdateResources: onUpdateResources = null })=>{
    var _SessionStore$user, _SessionStore$user2;
    const periodId = (0, $4hBm1.format)(period, store.periodFormat());
    const prevPeriodId = (0, $4hBm1.format)(store.subPeriods(period, 1), store.periodFormat());
    const project = (selectedProjectOrPhase === null || selectedProjectOrPhase === void 0 ? void 0 : selectedProjectOrPhase.project) || selectedProjectOrPhase;
    const phase = (selectedProjectOrPhase === null || selectedProjectOrPhase === void 0 ? void 0 : selectedProjectOrPhase.project) && selectedProjectOrPhase;
    const allPhases = phase ? [
        phase
    ] : (project === null || project === void 0 ? void 0 : project.phases.filter((ph)=>!(ph !== null && ph !== void 0 && ph.isRootPhase))) || [];
    const budgetsByStaff = allPhases.reduce((acc, phase)=>{
        phase.budgets.filter((b)=>b.staffId).forEach((budget)=>{
            var _budget$staffId, _acc$_budget$staffId;
            (_acc$_budget$staffId = acc[_budget$staffId = budget.staffId]) !== null && _acc$_budget$staffId !== void 0 ? _acc$_budget$staffId : acc[_budget$staffId] = {
                staff: budget.staff,
                role: budget.role,
                cost: 0,
                hours: 0
            };
            acc[budget.staffId].cost += budget.cost;
            acc[budget.staffId].hours += budget.hours;
        });
        return acc;
    }, {});
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        style: {
            padding: "1em"
        },
        children: [
            (0, $8kZ1o.canViewProjectFees)((0, $1BTI2.default).user, project) && (0, $8kZ1o.canViewRevenueTargets)((0, $1BTI2.default).user, project) ? /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("h4", {
                        children: [
                            "Revenue",
                            (0, $8kZ1o.canEditStaffAllocations)((0, $1BTI2.default).user) ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hYVSY.default), {
                                onChange: (e)=>{
                                    const { checked: checked } = e.target;
                                    store.setUpdateExpensesWithRevenue(checked);
                                },
                                checked: store.updateExpensesWithRevenue,
                                style: {
                                    width: "45%",
                                    float: "right",
                                    fontSize: "0.65em"
                                },
                                children: "Update Expenses With Revenue"
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            padding: "1em"
                        },
                        children: [
                            !phase ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8oGqY.default), {
                                label: project.title,
                                editable: (0, $8kZ1o.canEditRevenueTargets)((0, $1BTI2.default).user),
                                month: period,
                                fee: project.fee,
                                previousRevenue: store.getRevenueToDateInPeriod(prevPeriodId, null),
                                currentRevenue: store.getRevenueInPeriod(periodId, null),
                                onChange: (v)=>{
                                    store.setEditedRevenueInPeriod(periodId, null, v);
                                    if (store.updateExpensesWithRevenue) allPhases.forEach((phase)=>{
                                        const progress = store.getRevenueProgressInPeriod(periodId, phase.id);
                                        if (isFinite(progress)) {
                                            store.setEditedCostProgressInPeriod(periodId, phase.id, null, null, progress);
                                            if (typeof onUpdateResources !== "undefined" && onUpdateResources) store.getLeafModels(phase.id, null, null).forEach(({ project: project, phase: phase, status: status, role: role, staff: staff })=>{
                                                onUpdateResources({
                                                    period: periodId,
                                                    project: project,
                                                    phase: phase,
                                                    status: status,
                                                    role: role,
                                                    staff: staff,
                                                    cost: store.getCostInPeriod(periodId, phase.id, (role === null || role === void 0 ? void 0 : role.id) || "norole", (staff === null || staff === void 0 ? void 0 : staff.id) || "nostaff"),
                                                    hours: store.getHoursInPeriod(periodId, phase.id, (role === null || role === void 0 ? void 0 : role.id) || "norole", (staff === null || staff === void 0 ? void 0 : staff.id) || "nostaff")
                                                });
                                            });
                                        }
                                    });
                                    if (typeof onUpdateRevenue1 !== "undefined" && onUpdateRevenue1) onUpdateRevenue1({
                                        project: project,
                                        period: periodId,
                                        value: v
                                    });
                                }
                            }, periodId + project.id) : null,
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                style: {
                                    padding: "2em 0"
                                },
                                children: allPhases.map((phase)=>{
                                    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8oGqY.default), {
                                        label: phase.title,
                                        editable: (0, $8kZ1o.canEditRevenueTargets)((0, $1BTI2.default).user),
                                        month: period,
                                        fee: phase.fee,
                                        previousRevenue: store.getRevenueToDateInPeriod(prevPeriodId, phase.id),
                                        currentRevenue: store.getRevenueInPeriod(periodId, phase.id),
                                        onChange: (v)=>{
                                            store.setEditedRevenueInPeriod(periodId, phase.id, v);
                                            if (store.updateExpensesWithRevenue) {
                                                const progress = store.getRevenueProgressInPeriod(periodId, phase.id);
                                                if (isFinite(progress)) {
                                                    store.setEditedCostProgressInPeriod(periodId, phase.id, null, null, progress);
                                                    if (typeof onUpdateResources !== "undefined" && onUpdateResources) store.getLeafModels(phase.id, null, null).forEach(({ project: project, phase: phase, status: status, role: role, staff: staff })=>{
                                                        onUpdateResources({
                                                            period: periodId,
                                                            project: project,
                                                            phase: phase,
                                                            status: status,
                                                            role: role,
                                                            staff: staff,
                                                            cost: store.getCostInPeriod(periodId, phase.id, (role === null || role === void 0 ? void 0 : role.id) || "norole", (staff === null || staff === void 0 ? void 0 : staff.id) || "nostaff"),
                                                            hours: store.getHoursInPeriod(periodId, phase.id, (role === null || role === void 0 ? void 0 : role.id) || "norole", (staff === null || staff === void 0 ? void 0 : staff.id) || "nostaff")
                                                        });
                                                    });
                                                }
                                            }
                                            if (typeof onUpdateRevenue1 !== "undefined" && onUpdateRevenue1) onUpdateRevenue1({
                                                project: project,
                                                phase: phase,
                                                period: periodId,
                                                value: v
                                            });
                                        }
                                    }, periodId + phase.id);
                                })
                            })
                        ]
                    })
                ]
            }) : null,
            (0, $8kZ1o.canViewStaffAllocations)((0, $1BTI2.default).user, project) && (0, $8kZ1o.canViewStaffCostRate)((0, $1BTI2.default).user) ? /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("h4", {
                        children: [
                            "Expenses",
                            (0, $8kZ1o.canEditRevenueTargets)((0, $1BTI2.default).user, project) ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hYVSY.default), {
                                onChange: (e)=>{
                                    const { checked: checked } = e.target;
                                    store.setUpdateRevenueWithExpenses(checked);
                                },
                                checked: store.updateRevenueWithExpenses,
                                style: {
                                    width: "45%",
                                    float: "right",
                                    fontSize: "0.65em"
                                },
                                children: "Update Revenue With Expenses"
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            padding: "1em"
                        },
                        children: [
                            !phase ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $2tryL.default), {
                                editable: (0, $8kZ1o.canEditStaffAllocations)((0, $1BTI2.default).user, project),
                                month: period,
                                onChange: (v)=>{
                                    store.setEditedCostInPeriod(periodId, null, null, null, v);
                                    if (store.updateRevenueWithExpenses) allPhases.forEach((phase)=>{
                                        const progress = store.getCostProgressInPeriod(periodId, phase.id, null, null);
                                        if (isFinite(progress)) {
                                            store.setEditedRevenueProgressInPeriod(periodId, phase.id, progress);
                                            if (typeof onUpdateRevenue1 !== "undefined" && onUpdateRevenue1) onUpdateRevenue1({
                                                project: project,
                                                phase: phase,
                                                period: periodId,
                                                value: store.getRevenueInPeriod(periodId, phase.id)
                                            });
                                        }
                                    });
                                    if (typeof onUpdateResources !== "undefined" && onUpdateResources) store.getLeafModels(null, null, null).forEach(({ project: project, phase: phase, status: status, role: role, staff: staff })=>{
                                        onUpdateResources({
                                            period: periodId,
                                            project: project,
                                            phase: phase,
                                            status: status,
                                            role: role,
                                            staff: staff,
                                            cost: store.getCostInPeriod(periodId, phase.id, (role === null || role === void 0 ? void 0 : role.id) || "norole", (staff === null || staff === void 0 ? void 0 : staff.id) || "nostaff"),
                                            hours: store.getHoursInPeriod(periodId, phase.id, (role === null || role === void 0 ? void 0 : role.id) || "norole", (staff === null || staff === void 0 ? void 0 : staff.id) || "nostaff")
                                        });
                                    });
                                },
                                onTimeChange: (v)=>{
                                    store.setEditedHoursInPeriod(periodId, null, null, null, v);
                                    if (store.updateRevenueWithExpenses) allPhases.forEach((phase)=>{
                                        const progress = store.getCostProgressInPeriod(periodId, phase.id, null, null);
                                        if (isFinite(progress)) {
                                            store.setEditedRevenueProgressInPeriod(periodId, phase.id, progress);
                                            if (typeof onUpdateRevenue1 !== "undefined" && onUpdateRevenue1) onUpdateRevenue1({
                                                project: project,
                                                phase: phase,
                                                period: periodId,
                                                value: store.getRevenueInPeriod(periodId, phase.id)
                                            });
                                        }
                                    });
                                    if (typeof onUpdateResources !== "undefined" && onUpdateResources) store.getLeafModels(null, null, null).forEach(({ project: project, phase: phase, status: status, role: role, staff: staff })=>{
                                        onUpdateResources({
                                            period: periodId,
                                            project: project,
                                            phase: phase,
                                            status: status,
                                            role: role,
                                            staff: staff,
                                            cost: store.getCostInPeriod(periodId, phase.id, (role === null || role === void 0 ? void 0 : role.id) || "norole", (staff === null || staff === void 0 ? void 0 : staff.id) || "nostaff"),
                                            hours: store.getHoursInPeriod(periodId, phase.id, (role === null || role === void 0 ? void 0 : role.id) || "norole", (staff === null || staff === void 0 ? void 0 : staff.id) || "nostaff")
                                        });
                                    });
                                },
                                costBudget: store.getCostBudget(null, null, null),
                                hoursBudget: store.getHoursBudget(null, null, null),
                                previousCost: store.getCostToDateInPeriod(prevPeriodId, null, null, null),
                                previousHours: store.getHoursToDateInPeriod(prevPeriodId, null, null, null),
                                currentCost: store.getCostInPeriod(periodId, null, null, null),
                                currentHours: store.getHoursInPeriod(periodId, null, null, null),
                                label: project.title
                            }, periodId + project.id) : null,
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                style: {
                                    padding: "2em 0"
                                },
                                children: allPhases.map((phase)=>{
                                    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $2tryL.default), {
                                        editable: (0, $8kZ1o.canEditStaffAllocations)((0, $1BTI2.default).user, project),
                                        month: period,
                                        onChange: (v)=>{
                                            store.setEditedCostInPeriod(periodId, phase.id, null, null, v);
                                            if (store.updateRevenueWithExpenses) {
                                                const progress = store.getCostProgressInPeriod(periodId, phase.id, null, null);
                                                if (isFinite(progress)) {
                                                    store.setEditedRevenueProgressInPeriod(periodId, phase.id, progress);
                                                    if (typeof onUpdateRevenue1 !== "undefined" && onUpdateRevenue1) onUpdateRevenue1({
                                                        project: project,
                                                        phase: phase,
                                                        period: periodId,
                                                        value: store.getRevenueInPeriod(periodId, phase.id)
                                                    });
                                                }
                                            }
                                            if (typeof onUpdateResources !== "undefined" && onUpdateResources) store.getLeafModels(phase.id, null, null).forEach(({ project: project, phase: phase, status: status, role: role, staff: staff })=>{
                                                onUpdateResources({
                                                    period: periodId,
                                                    project: project,
                                                    phase: phase,
                                                    status: status,
                                                    role: role,
                                                    staff: staff,
                                                    cost: store.getCostInPeriod(periodId, phase.id, (role === null || role === void 0 ? void 0 : role.id) || "norole", (staff === null || staff === void 0 ? void 0 : staff.id) || "nostaff"),
                                                    hours: store.getHoursInPeriod(periodId, phase.id, (role === null || role === void 0 ? void 0 : role.id) || "norole", (staff === null || staff === void 0 ? void 0 : staff.id) || "nostaff")
                                                });
                                            });
                                        },
                                        onTimeChange: (v)=>{
                                            store.setEditedHoursInPeriod(periodId, phase.id, null, null, v, store.updateRevenueWithExpenses);
                                            if (store.updateRevenueWithExpenses) {
                                                const progress = store.getCostProgressInPeriod(periodId, phase.id, null, null);
                                                if (isFinite(progress)) {
                                                    store.setEditedRevenueProgressInPeriod(periodId, phase.id, progress);
                                                    if (typeof onUpdateRevenue1 !== "undefined" && onUpdateRevenue1) onUpdateRevenue1({
                                                        project: project,
                                                        phase: phase,
                                                        period: periodId,
                                                        value: store.getRevenueInPeriod(periodId, phase.id)
                                                    });
                                                }
                                            }
                                            if (typeof onUpdateResources !== "undefined" && onUpdateResources) store.getLeafModels(phase.id, null, null).forEach(({ project: project, phase: phase, status: status, role: role, staff: staff })=>{
                                                onUpdateResources({
                                                    period: periodId,
                                                    project: project,
                                                    phase: phase,
                                                    status: status,
                                                    role: role,
                                                    staff: staff,
                                                    cost: store.getCostInPeriod(periodId, phase.id, (role === null || role === void 0 ? void 0 : role.id) || "norole", (staff === null || staff === void 0 ? void 0 : staff.id) || "nostaff"),
                                                    hours: store.getHoursInPeriod(periodId, phase.id, (role === null || role === void 0 ? void 0 : role.id) || "norole", (staff === null || staff === void 0 ? void 0 : staff.id) || "nostaff")
                                                });
                                            });
                                        },
                                        costBudget: store.getCostBudget(phase.id, null, null),
                                        hoursBudget: store.getHoursBudget(phase.id, null, null),
                                        previousCost: store.getCostToDateInPeriod(prevPeriodId, phase.id, null, null),
                                        previousHours: store.getHoursToDateInPeriod(prevPeriodId, phase.id, null, null),
                                        currentCost: store.getCostInPeriod(periodId, phase.id, null, null),
                                        currentHours: store.getHoursInPeriod(periodId, phase.id, null, null),
                                        label: phase.title
                                    }, periodId + phase.id);
                                })
                            })
                        ]
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
                children: Object.values(budgetsByStaff).length > 0 && /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    style: {
                        padding: "2em 0"
                    },
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("h4", {
                            children: "Staff Expenses"
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            style: {
                                padding: "1em"
                            },
                            children: Array.from(Object.values(budgetsByStaff)).map((budget)=>{
                                var _budget$staff, _budget$role, _budget$staff2, _budget$staff2$role, _budget$staff3;
                                const staffId = ((_budget$staff = budget.staff) === null || _budget$staff === void 0 ? void 0 : _budget$staff.id) || null;
                                const roleId = ((_budget$role = budget.role) === null || _budget$role === void 0 ? void 0 : _budget$role.id) || ((_budget$staff2 = budget.staff) === null || _budget$staff2 === void 0 ? void 0 : (_budget$staff2$role = _budget$staff2.role) === null || _budget$staff2$role === void 0 ? void 0 : _budget$staff2$role.id) || null;
                                return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $2tryL.default), {
                                    label: ((_budget$staff3 = budget.staff) === null || _budget$staff3 === void 0 ? void 0 : _budget$staff3.fullName) || "Unassigned",
                                    editable: (0, $8kZ1o.canEditStaffAllocations)((0, $1BTI2.default).user, project),
                                    month: period,
                                    onChange: (v)=>{
                                        store.setEditedCostInPeriod(periodId, phase === null || phase === void 0 ? void 0 : phase.id, roleId, staffId, v);
                                        if (store.updateRevenueWithExpenses) {
                                            const progress = store.getCostProgressInPeriod(periodId, phase === null || phase === void 0 ? void 0 : phase.id, roleId, staffId);
                                            if (isFinite(progress)) {
                                                // Update the revenue for the specific phase this staff member is in
                                                // Or potentially update the overall project revenue if no phase selected?
                                                // This assumes updating the containing phase/project revenue based on staff cost change
                                                store.setEditedRevenueProgressInPeriod(periodId, phase === null || phase === void 0 ? void 0 : phase.id, // Or null if project level? Needs clarification
                                                progress);
                                                if (typeof onUpdateRevenue1 !== "undefined" && onUpdateRevenue1) onUpdateRevenue1({
                                                    project: project,
                                                    phase: phase,
                                                    // Pass the specific phase if available
                                                    period: periodId,
                                                    value: store.getRevenueInPeriod(periodId, phase === null || phase === void 0 ? void 0 : phase.id) // Get updated revenue
                                                });
                                            }
                                        }
                                        if (typeof onUpdateResources !== "undefined" && onUpdateResources) store.getLeafModels(phase === null || phase === void 0 ? void 0 : phase.id, roleId, staffId).forEach(({ project: project, phase: leafPhase, status: status, role: role, staff: staff })=>{
                                            onUpdateResources({
                                                period: periodId,
                                                project: project,
                                                phase: leafPhase,
                                                status: status,
                                                role: role,
                                                staff: staff,
                                                cost: store.getCostInPeriod(periodId, leafPhase === null || leafPhase === void 0 ? void 0 : leafPhase.id, (role === null || role === void 0 ? void 0 : role.id) || "norole", (staff === null || staff === void 0 ? void 0 : staff.id) || "nostaff"),
                                                hours: store.getHoursInPeriod(periodId, leafPhase === null || leafPhase === void 0 ? void 0 : leafPhase.id, (role === null || role === void 0 ? void 0 : role.id) || "norole", (staff === null || staff === void 0 ? void 0 : staff.id) || "nostaff")
                                            });
                                        });
                                    },
                                    onTimeChange: (v)=>{
                                        store.setEditedHoursInPeriod(periodId, phase === null || phase === void 0 ? void 0 : phase.id, roleId, staffId, v);
                                        if (store.updateRevenueWithExpenses) {
                                            const progress = store.getCostProgressInPeriod(periodId, phase === null || phase === void 0 ? void 0 : phase.id, roleId, staffId);
                                            if (isFinite(progress)) {
                                                store.setEditedRevenueProgressInPeriod(periodId, phase === null || phase === void 0 ? void 0 : phase.id, // Or null if project level?
                                                progress);
                                                if (typeof onUpdateRevenue1 !== "undefined" && onUpdateRevenue1) onUpdateRevenue1({
                                                    project: project,
                                                    phase: phase,
                                                    // Pass the specific phase if available
                                                    period: periodId,
                                                    value: store.getRevenueInPeriod(periodId, phase === null || phase === void 0 ? void 0 : phase.id) // Get updated revenue
                                                });
                                            }
                                        }
                                        if (typeof onUpdateResources !== "undefined" && onUpdateResources) store.getLeafModels(phase === null || phase === void 0 ? void 0 : phase.id, roleId, staffId).forEach(({ project: project, phase: leafPhase, status: status, role: role, staff: staff })=>{
                                            onUpdateResources({
                                                period: periodId,
                                                project: project,
                                                phase: leafPhase,
                                                status: status,
                                                role: role,
                                                staff: staff,
                                                cost: store.getCostInPeriod(periodId, leafPhase === null || leafPhase === void 0 ? void 0 : leafPhase.id, (role === null || role === void 0 ? void 0 : role.id) || "norole", (staff === null || staff === void 0 ? void 0 : staff.id) || "nostaff"),
                                                hours: store.getHoursInPeriod(periodId, leafPhase === null || leafPhase === void 0 ? void 0 : leafPhase.id, (role === null || role === void 0 ? void 0 : role.id) || "norole", (staff === null || staff === void 0 ? void 0 : staff.id) || "nostaff")
                                            });
                                        });
                                    },
                                    costBudget: store.getCostBudget(phase === null || phase === void 0 ? void 0 : phase.id, roleId, staffId),
                                    hoursBudget: store.getHoursBudget(phase === null || phase === void 0 ? void 0 : phase.id, roleId, staffId),
                                    previousCost: store.getCostToDateInPeriod(prevPeriodId, phase === null || phase === void 0 ? void 0 : phase.id, roleId, staffId),
                                    previousHours: store.getHoursToDateInPeriod(prevPeriodId, phase === null || phase === void 0 ? void 0 : phase.id, roleId, staffId),
                                    currentCost: store.getCostInPeriod(periodId, phase === null || phase === void 0 ? void 0 : phase.id, roleId, staffId),
                                    currentHours: store.getHoursInPeriod(periodId, phase === null || phase === void 0 ? void 0 : phase.id, roleId, staffId)
                                }, periodId + (phase === null || phase === void 0 ? void 0 : phase.id) + staffId);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6RcUP.default), {
                queryIds: [
                    {
                        id: `staff-util-${project.id}-${periodId}`,
                        baseURL: "https://server2.coincraft.co",
                        path: `/staff-utilisation/without-project`,
                        method: "POST",
                        data: {
                            period: periodId,
                            periodType: store.periodType,
                            projectId: project.id,
                            organisationId: (0, $1BTI2.default).organisationId,
                            userId: (_SessionStore$user = (0, $1BTI2.default).user) === null || _SessionStore$user === void 0 ? void 0 : _SessionStore$user.id
                        }
                    }
                ],
                children: /*#__PURE__*/ (0, $61Ea1.jsx)($2757d503c0a840ee$var$StaffUtilisation, {
                    store: store,
                    project: project,
                    phase: phase,
                    period: period,
                    periodId: periodId,
                    allPhases: allPhases,
                    onUpdateResources: onUpdateResources
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6RcUP.default), {
                queryIds: [
                    {
                        id: `rev-source-${project.id}-${periodId}`,
                        baseURL: "https://server2.coincraft.co",
                        path: `/revenue-sources/`,
                        method: "POST",
                        data: {
                            period: periodId,
                            periodType: store.periodType,
                            projectId: project.id,
                            organisationId: (0, $1BTI2.default).organisationId,
                            userId: (_SessionStore$user2 = (0, $1BTI2.default).user) === null || _SessionStore$user2 === void 0 ? void 0 : _SessionStore$user2.id,
                            invoiceDateType: (0, $1BTI2.default).settings.reportInvoiceDateType
                        }
                    }
                ],
                children: /*#__PURE__*/ (0, $61Ea1.jsx)($2757d503c0a840ee$var$RevenueSources, {
                    store: store,
                    project: project,
                    phase: phase,
                    period: period,
                    periodId: periodId,
                    allPhases: allPhases
                })
            })
        ]
    }, periodId + project.id);
});
const $2757d503c0a840ee$var$StaffUtilisation = (0, $1EEMt.observer)(({ store: store, project: project, phase: phase, allPhases: allPhases, period: period, periodId: periodId, onUpdateResources: onUpdateResources })=>{
    var _queryClient$getQuery;
    const staffUtilData = (_queryClient$getQuery = (0, $6Q5sp.queryClient).getQueryData([
        `staff-util-${project.id}-${periodId}`
    ])) === null || _queryClient$getQuery === void 0 ? void 0 : _queryClient$getQuery.data;
    const staff = [
        ...(phase ? store.staffByPhase[phase.id] : store.projectStaff) || []
    ].filter((s)=>s) || [];
    const periodStart = store.startOfPeriod(period);
    const periodEnd = store.endOfPeriod(period);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("h4", {
                children: "Utilisation"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    padding: "1em"
                },
                children: staff.filter((s)=>s && s.id !== "nostaff").map((st)=>{
                    var _st$role, _staffUtilData$st$id$, _staffUtilData$st$id;
                    const selectedHours = store.getHoursInPeriod(periodId, phase === null || phase === void 0 ? void 0 : phase.id, (st === null || st === void 0 ? void 0 : (_st$role = st.role) === null || _st$role === void 0 ? void 0 : _st$role.id) || "norole", st === null || st === void 0 ? void 0 : st.id);
                    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ccJUd.default), {
                        label: st.fullName,
                        editable: (0, $8kZ1o.canEditStaffAllocations)((0, $1BTI2.default).user, project),
                        month: period,
                        staff: st,
                        availability: st.getAvailableHoursInDateRange([
                            periodStart,
                            periodEnd
                        ]),
                        totalHours: selectedHours + ((_staffUtilData$st$id$ = (_staffUtilData$st$id = staffUtilData[st.id]) === null || _staffUtilData$st$id === void 0 ? void 0 : _staffUtilData$st$id.hours) !== null && _staffUtilData$st$id$ !== void 0 ? _staffUtilData$st$id$ : 0),
                        selectedHours: selectedHours,
                        onChange: (v)=>{
                            var _st$role2, _st$role3;
                            store.setEditedHoursInPeriod(periodId, phase === null || phase === void 0 ? void 0 : phase.id, st === null || st === void 0 ? void 0 : (_st$role2 = st.role) === null || _st$role2 === void 0 ? void 0 : _st$role2.id, st === null || st === void 0 ? void 0 : st.id, v);
                            if (store.updateRevenueWithExpenses) allPhases.forEach((phase)=>{
                                const progress = store.getCostProgressInPeriod(periodId, phase.id, null, null);
                                if (isFinite(progress)) {
                                    store.setEditedRevenueProgressInPeriod(periodId, phase.id, progress);
                                    if (typeof onUpdateRevenue !== "undefined" && onUpdateRevenue) onUpdateRevenue({
                                        project: project,
                                        phase: phase,
                                        period: periodId,
                                        value: store.getRevenueInPeriod(periodId, phase.id)
                                    });
                                }
                            });
                            if (typeof onUpdateResources !== "undefined" && onUpdateResources) store.getLeafModels(phase === null || phase === void 0 ? void 0 : phase.id, st === null || st === void 0 ? void 0 : (_st$role3 = st.role) === null || _st$role3 === void 0 ? void 0 : _st$role3.id, st === null || st === void 0 ? void 0 : st.id).forEach(({ project: project, phase: phase, status: status, role: role, staff: staff })=>{
                                onUpdateResources({
                                    period: periodId,
                                    project: project,
                                    phase: phase,
                                    status: status,
                                    role: role,
                                    staff: staff,
                                    cost: store.getCostInPeriod(periodId, phase.id, (role === null || role === void 0 ? void 0 : role.id) || "norole", (staff === null || staff === void 0 ? void 0 : staff.id) || "nostaff"),
                                    hours: store.getHoursInPeriod(periodId, phase.id, (role === null || role === void 0 ? void 0 : role.id) || "norole", (staff === null || staff === void 0 ? void 0 : staff.id) || "nostaff")
                                });
                            });
                        }
                    }, st.id + project.id + (phase === null || phase === void 0 ? void 0 : phase.id) + periodId);
                })
            })
        ]
    });
});
const $2757d503c0a840ee$var$RevenueSources = (0, $1EEMt.observer)(({ store: store, project: project, phase: phase, allPhases: allPhases, period: period, periodId: periodId })=>{
    var _queryClient$getQuery2, _sources$invoices, _sources$invoices2, _sources$changeLogs, _sources$changeLogs2;
    const sources = (_queryClient$getQuery2 = (0, $6Q5sp.queryClient).getQueryData([
        `rev-source-${project.id}-${periodId}`
    ])) === null || _queryClient$getQuery2 === void 0 ? void 0 : _queryClient$getQuery2.data;
    if (!(sources !== null && sources !== void 0 && sources.invoices) && !(sources !== null && sources !== void 0 && sources.changeLogs)) return null;
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        style: {
            borderTop: "1px solid #ccc",
            paddingTop: "1em",
            marginTop: "1em"
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("h4", {
                children: "Revenue Sources"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    padding: "1em"
                },
                children: [
                    sources !== null && sources !== void 0 && (_sources$invoices = sources.invoices) !== null && _sources$invoices !== void 0 && _sources$invoices.length ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                style: {
                                    fontWeight: "bold"
                                },
                                children: "Invoices"
                            }),
                            sources === null || sources === void 0 ? void 0 : (_sources$invoices2 = sources.invoices) === null || _sources$invoices2 === void 0 ? void 0 : _sources$invoices2.map((source)=>{
                                return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        justifyContent: "space-between",
                                        padding: "0.5em 0"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqlQp.Link), {
                                            to: `/invoices/${source.id}`,
                                            children: source.ref
                                        }),
                                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                            children: (0, $12o9H.FormatCurrency)(source.amount)
                                        })
                                    ]
                                }, source.id);
                            })
                        ]
                    }) : null,
                    sources !== null && sources !== void 0 && (_sources$changeLogs = sources.changeLogs) !== null && _sources$changeLogs !== void 0 && _sources$changeLogs.length ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                style: {
                                    fontWeight: "bold"
                                },
                                children: "Change Log"
                            }),
                            sources === null || sources === void 0 ? void 0 : (_sources$changeLogs2 = sources.changeLogs) === null || _sources$changeLogs2 === void 0 ? void 0 : _sources$changeLogs2.map((source)=>{
                                return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        justifyContent: "space-between",
                                        padding: "0.5em 0"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                            children: source.title
                                        }),
                                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                            children: (0, $12o9H.FormatCurrency)((source.revenue || 0) - (source.expenses || 0))
                                        })
                                    ]
                                }, source.id);
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
});

});


parcelRegister("3RaC0", function(module, exports) {

$parcel$export(module.exports, "RevenueForecastPage", function () { return $5fab38c6aa501e4c$export$6f3204b547e2945d; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $kWKJG = parcelRequire("kWKJG");

var $8tQ2D = parcelRequire("8tQ2D");

var $eTG48 = parcelRequire("eTG48");

var $fTGwv = parcelRequire("fTGwv");

var $27lKj = parcelRequire("27lKj");
parcelRequire("iaSLm");
var $4hBm1 = parcelRequire("4hBm1");

var $kvIkY = parcelRequire("kvIkY");

var $k9RJX = parcelRequire("k9RJX");

var $3Gs4l = parcelRequire("3Gs4l");

var $38AIP = parcelRequire("38AIP");

var $6UBLf = parcelRequire("6UBLf");
var $5zaoU = parcelRequire("5zaoU");

var $1BTI2 = parcelRequire("1BTI2");

var $8kZ1o = parcelRequire("8kZ1o");
const $5fab38c6aa501e4c$export$6f3204b547e2945d = ()=>{
    const isLoading = (0, $27lKj.useIsLoading)();
    const error = (0, $27lKj.useError)();
    const dateRange = (0, $27lKj.useDateRange)();
    const revenueForecastReports = (0, $38AIP.useFilteredCacheItems)("revenueForecastReports");
    const { report: report } = (0, $5zaoU.useSearch)({
        strict: false
    });
    const navigate = (0, $6UBLf.useNavigate)();
    (0, $jbmdS.useEffect)(()=>{
        if (!dateRange[0] || !dateRange[1]) {
            const today = new Date();
            const startDate = (0, $4hBm1.startOfMonth)(today);
            const endDate = (0, $4hBm1.addMonths)(startDate, 11); // Ensure 12-month window
            (0, $27lKj.fetchForecastData)([
                (0, $4hBm1.format)(startDate, "yyyy-MM-dd"),
                (0, $4hBm1.format)(endDate, "yyyy-MM-dd")
            ]);
        }
    }, [
        dateRange
    ]);
    if (error) return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "p-4 text-red-500",
        children: [
            "Error loading forecast data: ",
            error
        ]
    });
    const canViewStaffTable = (0, $8kZ1o.canViewRevenueForecastStaffExpenses)((0, $1BTI2.default).user) && (0, $8kZ1o.canViewStaffPayRate)((0, $1BTI2.default).user);
    const canViewOverheadTable = (0, $8kZ1o.canViewRevenueForecastOperationalExpenses)((0, $1BTI2.default).user);
    const canViewProfitTable = canViewStaffTable && canViewOverheadTable;
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "sticky left-0 pt-8",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "p-8",
                        children: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $3Gs4l.Select), {
                            value: report,
                            onValueChange: (value)=>{
                                navigate({
                                    search: (prev)=>({
                                            ...prev,
                                            report: value
                                        })
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3Gs4l.SelectTrigger), {
                                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3Gs4l.SelectValue), {
                                        placeholder: "Select a report"
                                    })
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3Gs4l.SelectContent), {
                                    children: revenueForecastReports === null || revenueForecastReports === void 0 ? void 0 : revenueForecastReports.sort((a, b)=>a.name.localeCompare(b.name)).map((report)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $3Gs4l.SelectItem), {
                                            value: report.id.toString(),
                                            children: report.name
                                        }, report.id))
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kvIkY.RevenueForecastChart), {}),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "flex justify-between items-center p-4",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fTGwv.Button), {
                                onClick: ()=>(0, $27lKj.shiftMonths)("left"),
                                disabled: isLoading,
                                variant: "outline",
                                children: "\u2190 Previous Month"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "text-sm text-gray-600",
                                children: dateRange[0] && dateRange[1] ? `${(0, $4hBm1.format)(new Date(dateRange[0]), "MMM yyyy")} - ${(0, $4hBm1.format)(new Date(dateRange[1]), "MMM yyyy")}` : ""
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fTGwv.Button), {
                                onClick: ()=>(0, $27lKj.shiftMonths)("right"),
                                disabled: isLoading,
                                variant: "outline",
                                children: "Next Month \u2192"
                            })
                        ]
                    })
                ]
            }),
            isLoading ? /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "p-4",
                children: "Loading forecast data..."
            }) : /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                children: [
                    canViewProfitTable && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $k9RJX.RevenueForecastProfitTable), {}),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kWKJG.RevenueForecastProjectTable), {}),
                    canViewStaffTable && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $eTG48.RevenueForecastStaffTable), {}),
                    canViewOverheadTable && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8tQ2D.RevenueForecastOverheadTable), {})
                ]
            })
        ]
    });
};

});
parcelRegister("kWKJG", function(module, exports) {

$parcel$export(module.exports, "RevenueForecastProjectTable", function () { return $2b81a985832b1d7e$export$873563c7211b4a64; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $aYyI4 = parcelRequire("aYyI4");

var $aaosT = parcelRequire("aaosT");

var $khCHn = parcelRequire("khCHn");

var $27lKj = parcelRequire("27lKj");
parcelRequire("iaSLm");
var $4hBm1 = parcelRequire("4hBm1");

var $3h7sC = parcelRequire("3h7sC");

var $O2UPo = parcelRequire("O2UPo");

var $12o9H = parcelRequire("12o9H");

var $1BTI2 = parcelRequire("1BTI2");

var $8kZ1o = parcelRequire("8kZ1o");

var $Yha9m = parcelRequire("Yha9m");

var $eat5C = parcelRequire("eat5C");

var $7RI9h = parcelRequire("7RI9h");
const $2b81a985832b1d7e$export$873563c7211b4a64 = ()=>{
    (0, $27lKj.useSelectedRow)();
    (0, $27lKj.useSelectedMonth)();
    const addSaveOperation = (0, $7RI9h.useSaveQueueAction)();
    const showSaveToast = (row, month)=>{
        const phaseRow = row.depth === 2 ? row : null;
        const projectRow = row.depth === 1 ? row : row.depth === 2 ? row.getParentRow() : null;
        const statusRow = row.depth === 1 ? row.getParentRow() : row.depth === 2 ? row.getParentRow().getParentRow() : null;
        // Get status, project, and phase identifiers
        const status = statusRow === null || statusRow === void 0 ? void 0 : statusRow.original.status;
        const projectId = projectRow === null || projectRow === void 0 ? void 0 : projectRow.original.projectId;
        const phaseId = phaseRow === null || phaseRow === void 0 ? void 0 : phaseRow.original.phaseId;
        const saveId = status + projectId + (phaseId || "") + month;
        const storeState = (0, $27lKj.revenueForecastStore).getSnapshot().context;
        if (phaseRow) {
            // Find the corresponding data in the store
            const statusIndex = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).findIndex(storeState.data, {
                status: status
            });
            if (statusIndex === -1) return;
            const projectIndex = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).findIndex(storeState.data[statusIndex].children, {
                projectId: projectId
            });
            if (projectIndex === -1) return;
            const phaseIndex = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).findIndex(storeState.data[statusIndex].children[projectIndex].children, {
                phaseId: phaseId
            });
            if (phaseIndex === -1) return;
            // Get the latest phase data from the store
            const phaseData = storeState.data[statusIndex].children[projectIndex].children[phaseIndex];
            addSaveOperation({
                saveId: saveId,
                onSave: async ()=>{
                    // Make API call for phase update with the latest data
                    await (0, $3h7sC.trpc).revenueForecast.updateForecastData.mutate([
                        {
                            month: month,
                            status: status,
                            projectId: projectId,
                            phaseId: phaseId,
                            value: phaseData[`${month}-P`] || 0
                        }
                    ]);
                },
                loadingMessage: "Saving forecast...",
                successMessage: "Forecast saved successfully",
                errorMessage: "Failed to save forecast"
            });
        } else if (projectRow) {
            // Get status and project identifiers
            const status = statusRow === null || statusRow === void 0 ? void 0 : statusRow.original.status;
            const projectId = projectRow === null || projectRow === void 0 ? void 0 : projectRow.original.projectId;
            // Find the corresponding data in the store
            const statusIndex = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).findIndex(storeState.data, {
                status: status
            });
            if (statusIndex === -1) return;
            const projectIndex = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).findIndex(storeState.data[statusIndex].children, {
                projectId: projectId
            });
            if (projectIndex === -1) return;
            // Get the latest project data from the store
            const projectData = storeState.data[statusIndex].children[projectIndex];
            addSaveOperation({
                saveId: saveId,
                onSave: async ()=>{
                    // Make API call for project update with the latest data
                    await (0, $3h7sC.trpc).revenueForecast.updateForecastData.mutate(projectData.children.map((phase)=>({
                            month: month,
                            status: status,
                            projectId: projectId,
                            phaseId: phase.phaseId,
                            value: phase[`${month}-P`] || 0
                        })));
                },
                loadingMessage: "Saving forecast...",
                successMessage: "Forecast saved successfully",
                errorMessage: "Failed to save forecast"
            });
        }
    };
    const generateColumnDef = (0, $khCHn.createGenerateColumnDef)({
        onHideColumn: ()=>null
    });
    const storeData = (0, $27lKj.useData)();
    const dateRange = (0, $27lKj.useDateRange)();
    const months = (0, $jbmdS.useMemo)(()=>dateRange[0] && dateRange[1] ? (0, $4hBm1.eachMonthOfInterval)({
            start: (0, $4hBm1.parse)(dateRange[0], "yyyy-MM-dd", new Date()),
            end: (0, $4hBm1.parse)(dateRange[1], "yyyy-MM-dd", new Date())
        }) : [], [
        dateRange
    ]);
    const columns = (0, $jbmdS.useMemo)(()=>[
            generateColumnDef({
                key: "total",
                title: "Total",
                type: "string",
                size: 120,
                customValue: (row)=>{
                    if (!row) return "";
                    const total = row.pastActualTotal + row.futureProjectedTotal + row.currentProjectedTotal;
                    const formattedValue = `${(0, $12o9H.FormatCurrency)(total, {
                        decimals: 0
                    })} / ${(0, $12o9H.FormatCurrency)(row.fee, {
                        decimals: 0
                    })}`;
                    return formattedValue;
                },
                cellClassName: (row)=>{
                    if (!row || !row.original.fee || !row.depth) return "";
                    const total = row.original.pastActualTotal + row.original.futureProjectedTotal + row.original.currentProjectedTotal;
                    const roundedTotal = Math.round(total);
                    const roundedFee = Math.round(row.original.fee);
                    if (roundedTotal < roundedFee) return "text-blue-500";
                    if (roundedTotal > roundedFee) return "text-red-500";
                    return "";
                }
            }),
            generateColumnDef({
                key: "status",
                title: "Status",
                type: "string",
                size: 120
            }),
            generateColumnDef({
                key: "project",
                title: "Project",
                size: 120
            }),
            generateColumnDef({
                key: "phase",
                title: "Phase",
                size: 120
            }),
            ...months.map((month)=>generateColumnDef({
                    key: (0, $4hBm1.format)(month, "yyyy-MM"),
                    title: (0, $4hBm1.format)(month, "MMM yy"),
                    type: "currency",
                    aggregationFn: "sum",
                    size: 120,
                    customValue: (row)=>{
                        const monthKey = (0, $4hBm1.format)(month, "yyyy-MM");
                        const projected = row[`${monthKey}-P`] || 0;
                        const actual = row[`${monthKey}-A`] || 0;
                        const currentMonthKey = (0, $4hBm1.format)(new Date(), "yyyy-MM");
                        if (monthKey < currentMonthKey) return actual;
                        else return projected;
                        return Math.max(actual, projected);
                    },
                    editable: (row)=>row.depth > 0 && (0, $8kZ1o.canEditRevenueTargets)((0, $1BTI2.default).user) && (0, $4hBm1.format)(month, "yyyy-MM") >= (0, $4hBm1.format)(new Date(), "yyyy-MM"),
                    onChange: (row, value)=>{
                        const phaseRow = row.depth === 2 ? row : null;
                        const projectRow = row.depth === 1 ? row : row.depth === 2 ? row.getParentRow() : null;
                        const statusRow = row.depth === 1 ? row.getParentRow() : row.depth === 2 ? row.getParentRow().getParentRow() : null;
                        (0, $27lKj.setSelectedRow)({
                            status: statusRow === null || statusRow === void 0 ? void 0 : statusRow.original.status,
                            projectId: projectRow === null || projectRow === void 0 ? void 0 : projectRow.original.projectId,
                            phaseId: phaseRow === null || phaseRow === void 0 ? void 0 : phaseRow.original.phaseId
                        });
                        (0, $27lKj.updateProjectedRevenueCellValue)({
                            month: (0, $4hBm1.format)(month, "yyyy-MM"),
                            status: statusRow === null || statusRow === void 0 ? void 0 : statusRow.original.status,
                            projectId: projectRow === null || projectRow === void 0 ? void 0 : projectRow.original.projectId,
                            phaseId: phaseRow === null || phaseRow === void 0 ? void 0 : phaseRow.original.phaseId,
                            value: value
                        });
                        showSaveToast(row, (0, $4hBm1.format)(month, "yyyy-MM"));
                    },
                    onClick: (row)=>{
                        const phaseRow = row.depth === 2 ? row : null;
                        const projectRow = row.depth === 1 ? row : row.depth === 2 ? row.getParentRow() : null;
                        const statusRow = row.depth === 1 ? row.getParentRow() : row.depth === 2 ? row.getParentRow().getParentRow() : null;
                        (0, $27lKj.setSelectedRow)({
                            status: statusRow === null || statusRow === void 0 ? void 0 : statusRow.original.status,
                            projectId: projectRow === null || projectRow === void 0 ? void 0 : projectRow.original.projectId,
                            phaseId: phaseRow === null || phaseRow === void 0 ? void 0 : phaseRow.original.phaseId
                        });
                        (0, $27lKj.setSelectedMonth)((0, $4hBm1.format)(month, "yyyy-MM"));
                    },
                    onFocus: (row)=>{
                        const phaseRow = row.depth === 2 ? row : null;
                        const projectRow = row.depth === 1 ? row : row.depth === 2 ? row.getParentRow() : null;
                        const statusRow = row.depth === 1 ? row.getParentRow() : row.depth === 2 ? row.getParentRow().getParentRow() : null;
                        (0, $27lKj.setSelectedRow)({
                            status: statusRow === null || statusRow === void 0 ? void 0 : statusRow.original.status,
                            projectId: projectRow === null || projectRow === void 0 ? void 0 : projectRow.original.projectId,
                            phaseId: phaseRow === null || phaseRow === void 0 ? void 0 : phaseRow.original.phaseId
                        });
                        (0, $27lKj.setSelectedMonth)((0, $4hBm1.format)(month, "yyyy-MM"));
                    },
                    cellClassName: (row)=>{
                        const phaseRow = row.depth === 2 ? row : null;
                        const projectRow = row.depth === 1 ? row : row.depth === 2 ? row.getParentRow() : null;
                        const statusRow = row.depth === 1 ? row.getParentRow() : row.depth === 2 ? row.getParentRow().getParentRow() : null;
                        const selectedRow = (0, $27lKj.getSelectedRow)();
                        const selectedMonth = (0, $27lKj.getSelectedMonth)();
                        const selected = row.depth > 0 && (selectedRow === null || selectedRow === void 0 ? void 0 : selectedRow.status) === (statusRow === null || statusRow === void 0 ? void 0 : statusRow.original.status) && (selectedRow === null || selectedRow === void 0 ? void 0 : selectedRow.projectId) === (projectRow === null || projectRow === void 0 ? void 0 : projectRow.original.projectId) && (selectedRow === null || selectedRow === void 0 ? void 0 : selectedRow.phaseId) === (phaseRow === null || phaseRow === void 0 ? void 0 : phaseRow.original.phaseId) && selectedMonth === (0, $4hBm1.format)(month, "yyyy-MM");
                        const isPastMonth = (0, $4hBm1.format)(month, "yyyy-MM") < (0, $4hBm1.format)(new Date(), "yyyy-MM");
                        return (0, $Yha9m.cn)(selected && !isPastMonth ? "outline outline-2 outline-blue-500" : "", isPastMonth && "bg-diagonal-pattern");
                    }
                }))
        ], [
        months
    ]);
    const { table: table } = (0, $aaosT.useDataTable)({
        data: storeData,
        columns: columns,
        visibleColumns: [
            "label",
            "total",
            // 'status',
            // 'project',
            // 'phase',
            ...months.map((month)=>(0, $4hBm1.format)(month, "yyyy-MM"))
        ],
        groups: {
            enabled: true,
            columns: [
                "status",
                "project"
            ],
            leafRowLabel: "Phase"
        },
        defaultSort: [
            {
                id: "label",
                desc: false
            }
        ],
        sortingFns: {
            sortingTextFn: $O2UPo.sortingTextFn,
            sortingDateFn: $O2UPo.sortingDateFn
        }
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "mt-8",
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("h2", {
                className: "text-xl font-semibold mb-4 pl-4",
                children: "Project Revenue"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $aYyI4.DataTable), {
                table: table,
                showTotals: true,
                className: "w-full"
            })
        ]
    });
};
var $2b81a985832b1d7e$export$2e2bcd8739ae039 = $2b81a985832b1d7e$export$873563c7211b4a64;

});
parcelRegister("aYyI4", function(module, exports) {

$parcel$export(module.exports, "DataTable", function () { return $aaeb8b72be21700e$export$df30df7ec97b32b5; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $bYkcY = parcelRequire("bYkcY");

var $Yha9m = parcelRequire("Yha9m");

var $bbMvq = parcelRequire("bbMvq");

var $4iw5i = parcelRequire("4iw5i");

var $3wpAZ = parcelRequire("3wpAZ");

var $eJqVD = parcelRequire("eJqVD");

var $k6C77 = parcelRequire("k6C77");
const $aaeb8b72be21700e$var$getRowComponent = ({ dragable: dragable })=>{
    if (dragable) return 0, $bbMvq.DraggableRow;
    return 0, $bbMvq.TableRow;
};
const $aaeb8b72be21700e$var$getCellComponent = ({ dragable: dragable, isRenderDragCell: isRenderDragCell })=>{
    if (dragable && isRenderDragCell) return 0, $bbMvq.RowDragHandleCell;
    return 0, $bbMvq.TableCell;
};
function $aaeb8b72be21700e$export$df30df7ec97b32b5({ table: table, floatingBar: floatingBar = null, children: children, className: className, showTotals: showTotals = false, loadingReportData: loadingReportData = false, hideColumns: hideColumns = [], topRows: topRows, renderTopRow: renderTopRow, draggable: draggable = false, renderDragCellIndex: renderDragCellIndex = 0, onDragRowEnd: onDragRowEnd, sortableId: sortableId, ...props }) {
    const totalWidth = table.getAllColumns().filter((column)=>column.getIsVisible() && !hideColumns.includes(column.id)).reduce((acc, column)=>acc + column.getSize(), 0);
    const getAllSelectedRows = $jbmdS.useCallback((rows)=>{
        return rows.reduce((acc, row)=>{
            var _row$subRows;
            if (row.getIsSelected()) acc.push(row);
            // Check subrows regardless of parent selection state
            if ((_row$subRows = row.subRows) !== null && _row$subRows !== void 0 && _row$subRows.length) {
                const selectedSubRows = getAllSelectedRows(row.subRows);
                acc.push(...selectedSubRows);
            }
            return acc;
        }, []);
    }, []);
    // Calculate if we should show floating bar
    const showFloatingBar = $jbmdS.useMemo(()=>{
        const rows = table.getFilteredRowModel().rows;
        const selectedRows = getAllSelectedRows(rows);
        return selectedRows.length > 0;
    }, [
        table.getFilteredRowModel().rows,
        table.getState().rowSelection
    ]);
    const rows = table.getRowModel().rows;
    const RowItem = $aaeb8b72be21700e$var$getRowComponent({
        dragable: draggable
    });
    const _renderRowsContent = ()=>{
        return rows.map((row)=>{
            return /*#__PURE__*/ (0, $61Ea1.jsx)(RowItem, {
                style: {
                    "--row-base": `hsl(39, 12%, ${98 - row.depth * 2}%)`,
                    "--row-hover": `hsl(39, 12%, ${94 - row.depth * 2}%)`,
                    "--row-selected": `hsl(39, 12%, ${90 - row.depth * 2}%)`
                },
                className: "transition-colors duration-200 bg-[var(--row-base)] hover:bg-[var(--row-hover)] data-[state=selected]:bg-[var(--row-selected)] data-[state=selected]:hover:bg-[var(--row-hover)]",
                "data-state": row.getIsSelected() && "selected",
                row: row,
                sortableId: sortableId !== null && sortableId !== void 0 ? sortableId : row.id,
                children: row.getVisibleCells().filter((cell)=>!hideColumns.includes(cell.column.id)).map((cell)=>{
                    var _cell$column$columnDe;
                    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bbMvq.TableCell), {
                        className: (0, $Yha9m.cn)({
                            "pr-0": cell.column.id === "expand"
                        }, (_cell$column$columnDe = cell.column.columnDef.meta) === null || _cell$column$columnDe === void 0 ? void 0 : _cell$column$columnDe.cellClassName(cell.row)),
                        style: {
                            width: `${Math.round(cell.column.getSize() / totalWidth * 100)}%`,
                            ...cell.column.id === "label" ? {
                                justifyContent: "flex-start",
                                paddingLeft: 1 + row.depth * 1 + "rem",
                                fontWeight: 800 - row.depth * 100
                            } : {}
                        },
                        children: (0, $bYkcY.flexRender)(cell.column.columnDef.cell, cell.getContext())
                    }, cell.id);
                })
            }, row.id);
        });
    };
    const _renderRows = ()=>{
        if (draggable) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $k6C77.SortableContext), {
            items: rows.map((row)=>typeof sortableId === "function" ? sortableId(row) : sortableId !== null && sortableId !== void 0 ? sortableId : row.id),
            strategy: (0, $k6C77.verticalListSortingStrategy),
            children: _renderRowsContent()
        });
        return _renderRowsContent();
    };
    const _renderTableContent = ()=>{
        var _rows$, _table$getRowModel$ro;
        return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $bbMvq.Table), {
            className: (0, $Yha9m.cn)(`border-b border-border min-w-full print:!w-full relative table-fixed text-xs`),
            style: {
                width: `${totalWidth}px`
            },
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bbMvq.TableHeader), {
                    className: "sticky top-[-1px] bg-primary z-[1]",
                    children: table.getHeaderGroups().map((headerGroup)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $bbMvq.TableRow), {
                            children: headerGroup.headers.filter((header)=>!hideColumns.includes(header.column.id)).map((header)=>{
                                var _header$column$column;
                                return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bbMvq.TableHead), {
                                    className: (0, $Yha9m.cn)("py-2", (_header$column$column = header.column.columnDef.meta) === null || _header$column$column === void 0 ? void 0 : _header$column$column.className),
                                    style: {
                                        width: `${Math.round(header.column.getSize() / totalWidth * 100)}%`
                                    },
                                    children: header.isPlaceholder ? null : (0, $bYkcY.flexRender)(header.column.columnDef.header, header.getContext())
                                }, header.id);
                            })
                        }, headerGroup.id))
                }),
                /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $bbMvq.TableBody), {
                    children: [
                        (topRows === null || topRows === void 0 ? void 0 : topRows.length) && renderTopRow && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bbMvq.TableRow), {
                            style: {
                                ["--row-base"]: `hsl(39, 12%, 99%)`,
                                ["--row-hover"]: `hsl(39, 12%, 95%)`
                            },
                            className: "font-bold transition-colors duration-200 bg-[var(--row-base)] hover:bg-[var(--row-hover)]",
                            children: topRows.map((cell)=>{
                                return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bbMvq.TableCell), {
                                    className: (0, $Yha9m.cn)("py-4"),
                                    style: {
                                        width: cell !== null && cell !== void 0 && cell.size ? `${Math.round((cell === null || cell === void 0 ? void 0 : cell.size) / totalWidth * 100)}%` : "auto"
                                    },
                                    children: renderTopRow(cell)
                                }, "total-" + (cell === null || cell === void 0 ? void 0 : cell.id));
                            })
                        }),
                        showTotals && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bbMvq.TableRow), {
                            style: {
                                ["--row-base"]: `hsl(39, 12%, 99%)`,
                                ["--row-hover"]: `hsl(39, 12%, 95%)`
                            },
                            className: "font-bold transition-colors duration-200 bg-[var(--row-base)] hover:bg-[var(--row-hover)]",
                            children: (_rows$ = rows[0]) === null || _rows$ === void 0 ? void 0 : _rows$.getVisibleCells().filter((cell)=>!hideColumns.includes(cell.column.id)).map((cell)=>{
                                var _cell$column$columnDe2;
                                const aggregationFn = cell.column.getAggregationFn();
                                const parentRows = rows.filter((r)=>r.depth === 0);
                                const getValue = ()=>{
                                    return aggregationFn ? aggregationFn(cell.column.id, rows.filter((r)=>r.depth > 0), parentRows) : null;
                                };
                                return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bbMvq.TableCell), {
                                    className: (0, $Yha9m.cn)("py-4", (_cell$column$columnDe2 = cell.column.columnDef.meta) === null || _cell$column$columnDe2 === void 0 ? void 0 : _cell$column$columnDe2.cellClassName(cell.row)),
                                    style: {
                                        width: `${Math.round(cell.column.getSize() / totalWidth * 100)}%`
                                    },
                                    children: (0, $bYkcY.flexRender)([
                                        "expand",
                                        "select",
                                        "label"
                                    ].includes(cell.column.columnDef.id) ? null : cell.column.columnDef.cell, {
                                        ...cell.getContext(),
                                        getValue: getValue,
                                        renderValue: getValue
                                    })
                                }, "total-" + cell.column.id);
                            })
                        }),
                        (_table$getRowModel$ro = table.getRowModel().rows) !== null && _table$getRowModel$ro !== void 0 && _table$getRowModel$ro.length ? _renderRows() : /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bbMvq.TableRow), {
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bbMvq.TableCell), {
                                colSpan: table.getAllColumns().length,
                                className: "h-24 text-center",
                                children: "No results."
                            })
                        })
                    ]
                })
            ]
        });
    };
    const sensors = (0, $3wpAZ.useSensors)((0, $3wpAZ.useSensor)((0, $3wpAZ.MouseSensor), {}), (0, $3wpAZ.useSensor)((0, $3wpAZ.TouchSensor), {}), (0, $3wpAZ.useSensor)((0, $3wpAZ.KeyboardSensor), {}));
    // reorder rows after drag & drop
    function handleDragEnd(event) {
        const { active: active, over: over } = event;
        if (active && over && active.id !== over.id) onDragRowEnd === null || onDragRowEnd === void 0 || onDragRowEnd(event);
    }
    const _renderTable = ()=>{
        if (draggable) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3wpAZ.DndContext), {
            collisionDetection: (0, $3wpAZ.closestCenter),
            modifiers: [
                (0, $eJqVD.restrictToVerticalAxis)
            ],
            onDragEnd: handleDragEnd,
            sensors: sensors,
            children: _renderTableContent()
        });
        return _renderTableContent();
    };
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "sticky left-0",
                children: children
            }),
            loadingReportData ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $4iw5i.default), {}) : _renderTable(),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "flex flex-col gap-2.5 relative",
                children: showFloatingBar && floatingBar
            })
        ]
    });
}

});
parcelRegister("bYkcY", function(module, exports) {
$parcel$export(module.exports, "aggregationFns", function () { return (parcelRequire("lVpRF")).aggregationFns; });
$parcel$export(module.exports, "createTable", function () { return (parcelRequire("lVpRF")).createTable; });
$parcel$export(module.exports, "getCoreRowModel", function () { return (parcelRequire("lVpRF")).getCoreRowModel; });
$parcel$export(module.exports, "getExpandedRowModel", function () { return (parcelRequire("lVpRF")).getExpandedRowModel; });
$parcel$export(module.exports, "getFacetedRowModel", function () { return (parcelRequire("lVpRF")).getFacetedRowModel; });
$parcel$export(module.exports, "getFacetedUniqueValues", function () { return (parcelRequire("lVpRF")).getFacetedUniqueValues; });
$parcel$export(module.exports, "getFilteredRowModel", function () { return (parcelRequire("lVpRF")).getFilteredRowModel; });
$parcel$export(module.exports, "getPaginationRowModel", function () { return (parcelRequire("lVpRF")).getPaginationRowModel; });
$parcel$export(module.exports, "getSortedRowModel", function () { return (parcelRequire("lVpRF")).getSortedRowModel; });

$parcel$export(module.exports, "flexRender", function () { return $8b74f938b49e8a11$export$f2385bb6e3ac4b4f; });
$parcel$export(module.exports, "useReactTable", function () { return $8b74f938b49e8a11$export$25eaeb3743e6b31f; });
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */ 
var $jbmdS = parcelRequire("jbmdS");

var $lVpRF = parcelRequire("lVpRF");
//
/**
 * If rendering headers, cells, or footers with custom markup, use flexRender instead of `cell.getValue()` or `cell.renderValue()`.
 */ function $8b74f938b49e8a11$export$f2385bb6e3ac4b4f(Comp, props) {
    return !Comp ? null : $8b74f938b49e8a11$var$isReactComponent(Comp) ? /*#__PURE__*/ $jbmdS.createElement(Comp, props) : Comp;
}
function $8b74f938b49e8a11$var$isReactComponent(component) {
    return $8b74f938b49e8a11$var$isClassComponent(component) || typeof component === "function" || $8b74f938b49e8a11$var$isExoticComponent(component);
}
function $8b74f938b49e8a11$var$isClassComponent(component) {
    return typeof component === "function" && (()=>{
        const proto = Object.getPrototypeOf(component);
        return proto.prototype && proto.prototype.isReactComponent;
    })();
}
function $8b74f938b49e8a11$var$isExoticComponent(component) {
    return typeof component === "object" && typeof component.$$typeof === "symbol" && [
        "react.memo",
        "react.forward_ref"
    ].includes(component.$$typeof.description);
}
function $8b74f938b49e8a11$export$25eaeb3743e6b31f(options) {
    // Compose in the generic options to the user options
    const resolvedOptions = {
        state: {},
        // Dummy state
        onStateChange: ()=>{},
        // noop
        renderFallbackValue: null,
        ...options
    };
    // Create a new table and store it in state
    const [tableRef] = $jbmdS.useState(()=>({
            current: (0, $lVpRF.createTable)(resolvedOptions)
        }));
    // By default, manage table state here using the table's initial state
    const [state, setState] = $jbmdS.useState(()=>tableRef.current.initialState);
    // Compose the default state above with any user state. This will allow the user
    // to only control a subset of the state if desired.
    tableRef.current.setOptions((prev)=>({
            ...prev,
            ...options,
            state: {
                ...state,
                ...options.state
            },
            // Similarly, we'll maintain both our internal state and any user-provided
            // state.
            onStateChange: (updater)=>{
                setState(updater);
                options.onStateChange == null || options.onStateChange(updater);
            }
        }));
    return tableRef.current;
}

});
parcelRegister("lVpRF", function(module, exports) {

$parcel$export(module.exports, "aggregationFns", function () { return $ff62fbff81e95ce8$export$3aa4339120b8b25b; });
$parcel$export(module.exports, "createTable", function () { return $ff62fbff81e95ce8$export$33bbb3ec7652e187; });
$parcel$export(module.exports, "getCoreRowModel", function () { return $ff62fbff81e95ce8$export$32d0bc001e828250; });
$parcel$export(module.exports, "getExpandedRowModel", function () { return $ff62fbff81e95ce8$export$53cfec7b1b8d1fcd; });
$parcel$export(module.exports, "getFacetedRowModel", function () { return $ff62fbff81e95ce8$export$3519aa0e35dc33b4; });
$parcel$export(module.exports, "getFacetedUniqueValues", function () { return $ff62fbff81e95ce8$export$1fb5d0c1edc37de2; });
$parcel$export(module.exports, "getFilteredRowModel", function () { return $ff62fbff81e95ce8$export$26f255a2756e1638; });
$parcel$export(module.exports, "getPaginationRowModel", function () { return $ff62fbff81e95ce8$export$ddfd3662e196c265; });
$parcel$export(module.exports, "getSortedRowModel", function () { return $ff62fbff81e95ce8$export$4ca93ca80835d8c1; });
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */ // type Person = {
//   firstName: string
//   lastName: string
//   age: number
//   visits: number
//   status: string
//   progress: number
//   createdAt: Date
//   nested: {
//     foo: [
//       {
//         bar: 'bar'
//       }
//     ]
//     bar: { subBar: boolean }[]
//     baz: {
//       foo: 'foo'
//       bar: {
//         baz: 'baz'
//       }
//     }
//   }
// }
// const test: DeepKeys<Person> = 'nested.foo.0.bar'
// const test2: DeepKeys<Person> = 'nested.bar'
// const helper = createColumnHelper<Person>()
// helper.accessor('nested.foo', {
//   cell: info => info.getValue(),
// })
// helper.accessor('nested.foo.0.bar', {
//   cell: info => info.getValue(),
// })
// helper.accessor('nested.bar', {
//   cell: info => info.getValue(),
// })
function $ff62fbff81e95ce8$export$4b44a5cb9651fe5e() {
    return {
        accessor: (accessor, column)=>{
            return typeof accessor === "function" ? {
                ...column,
                accessorFn: accessor
            } : {
                ...column,
                accessorKey: accessor
            };
        },
        display: (column)=>column,
        group: (column)=>column
    };
}
// Is this type a tuple?
// If this type is a tuple, what indices are allowed?
///
function $ff62fbff81e95ce8$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $ff62fbff81e95ce8$export$8793edee2d425525() {
//
}
function $ff62fbff81e95ce8$export$2b5605d8069324bd(key, instance) {
    return (updater)=>{
        instance.setState((old)=>{
            return {
                ...old,
                [key]: $ff62fbff81e95ce8$export$7f095f455ad5af3f(updater, old[key])
            };
        });
    };
}
function $ff62fbff81e95ce8$export$f6e2535fb5126e54(d) {
    return d instanceof Function;
}
function $ff62fbff81e95ce8$export$5cd576d1827d40c8(d) {
    return Array.isArray(d) && d.every((val)=>typeof val === "number");
}
function $ff62fbff81e95ce8$export$bf4548421d1b2c8(arr, getChildren) {
    const flat = [];
    const recurse = (subArr)=>{
        subArr.forEach((item)=>{
            flat.push(item);
            const children = getChildren(item);
            if (children != null && children.length) recurse(children);
        });
    };
    recurse(arr);
    return flat;
}
function $ff62fbff81e95ce8$export$7c73462e0d25e514(getDeps, fn, opts) {
    let deps = [];
    let result;
    return (depArgs)=>{
        let depTime;
        if (opts.key && opts.debug) depTime = Date.now();
        const newDeps = getDeps(depArgs);
        const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index)=>deps[index] !== dep);
        if (!depsChanged) return result;
        deps = newDeps;
        let resultTime;
        if (opts.key && opts.debug) resultTime = Date.now();
        result = fn(...newDeps);
        opts == null || opts.onChange == null || opts.onChange(result);
        if (opts.key && opts.debug) {
            if (opts != null && opts.debug()) {
                const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
                const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
                const resultFpsPercentage = resultEndTime / 16;
                const pad = (str, num)=>{
                    str = String(str);
                    while(str.length < num)str = " " + str;
                    return str;
                };
                console.info(`%c\u{23F1} ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
            }
        }
        return result;
    };
}
function $ff62fbff81e95ce8$export$b1f82222dc43996c(tableOptions, debugLevel, key, onChange) {
    return {
        debug: ()=>{
            var _tableOptions$debugAl;
            return (_tableOptions$debugAl = tableOptions == null ? void 0 : tableOptions.debugAll) != null ? _tableOptions$debugAl : tableOptions[debugLevel];
        },
        key: false,
        onChange: onChange
    };
}
function $ff62fbff81e95ce8$export$3cb21b6b1233300e(table, row, column, columnId) {
    const getRenderValue = ()=>{
        var _cell$getValue;
        return (_cell$getValue = cell.getValue()) != null ? _cell$getValue : table.options.renderFallbackValue;
    };
    const cell = {
        id: `${row.id}_${column.id}`,
        row: row,
        column: column,
        getValue: ()=>row.getValue(columnId),
        renderValue: getRenderValue,
        getContext: $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table,
                column,
                row,
                cell
            ], (table, column, row, cell)=>({
                table: table,
                column: column,
                row: row,
                cell: cell,
                getValue: cell.getValue,
                renderValue: cell.renderValue
            }), $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, "debugCells", "cell.getContext"))
    };
    table._features.forEach((feature)=>{
        feature.createCell == null || feature.createCell(cell, column, row, table);
    }, {});
    return cell;
}
function $ff62fbff81e95ce8$export$1bfa986e9c92c0b5(table, columnDef, depth, parent) {
    var _ref, _resolvedColumnDef$id;
    const defaultColumn = table._getDefaultColumnDef();
    const resolvedColumnDef = {
        ...defaultColumn,
        ...columnDef
    };
    const accessorKey = resolvedColumnDef.accessorKey;
    let id = (_ref = (_resolvedColumnDef$id = resolvedColumnDef.id) != null ? _resolvedColumnDef$id : accessorKey ? typeof String.prototype.replaceAll === "function" ? accessorKey.replaceAll(".", "_") : accessorKey.replace(/\./g, "_") : undefined) != null ? _ref : typeof resolvedColumnDef.header === "string" ? resolvedColumnDef.header : undefined;
    let accessorFn;
    if (resolvedColumnDef.accessorFn) accessorFn = resolvedColumnDef.accessorFn;
    else if (accessorKey) {
        // Support deep accessor keys
        if (accessorKey.includes(".")) accessorFn = (originalRow)=>{
            let result = originalRow;
            for (const key of accessorKey.split(".")){
                var _result;
                result = (_result = result) == null ? void 0 : _result[key];
            }
            return result;
        };
        else accessorFn = (originalRow)=>originalRow[resolvedColumnDef.accessorKey];
    }
    if (!id) throw new Error();
    let column = {
        id: `${String(id)}`,
        accessorFn: accessorFn,
        parent: parent,
        depth: depth,
        columnDef: resolvedColumnDef,
        columns: [],
        getFlatColumns: $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                true
            ], ()=>{
            var _column$columns;
            return [
                column,
                ...(_column$columns = column.columns) == null ? void 0 : _column$columns.flatMap((d)=>d.getFlatColumns())
            ];
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, "debugColumns", "column.getFlatColumns")),
        getLeafColumns: $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table._getOrderColumnsFn()
            ], (orderColumns)=>{
            var _column$columns2;
            if ((_column$columns2 = column.columns) != null && _column$columns2.length) {
                let leafColumns = column.columns.flatMap((column)=>column.getLeafColumns());
                return orderColumns(leafColumns);
            }
            return [
                column
            ];
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, "debugColumns", "column.getLeafColumns"))
    };
    for (const feature of table._features)feature.createColumn == null || feature.createColumn(column, table);
    // Yes, we have to convert table to unknown, because we know more than the compiler here.
    return column;
}
const $ff62fbff81e95ce8$var$debug = "debugHeaders";
//
function $ff62fbff81e95ce8$var$createHeader(table, column, options) {
    var _options$id;
    const id = (_options$id = options.id) != null ? _options$id : column.id;
    let header = {
        id: id,
        column: column,
        index: options.index,
        isPlaceholder: !!options.isPlaceholder,
        placeholderId: options.placeholderId,
        depth: options.depth,
        subHeaders: [],
        colSpan: 0,
        rowSpan: 0,
        headerGroup: null,
        getLeafHeaders: ()=>{
            const leafHeaders = [];
            const recurseHeader = (h)=>{
                if (h.subHeaders && h.subHeaders.length) h.subHeaders.map(recurseHeader);
                leafHeaders.push(h);
            };
            recurseHeader(header);
            return leafHeaders;
        },
        getContext: ()=>({
                table: table,
                header: header,
                column: column
            })
    };
    table._features.forEach((feature)=>{
        feature.createHeader == null || feature.createHeader(header, table);
    });
    return header;
}
const $ff62fbff81e95ce8$export$79b704688b15c0f4 = {
    createTable: (table)=>{
        // Header Groups
        table.getHeaderGroups = $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allColumns, leafColumns, left, right)=>{
            var _left$map$filter, _right$map$filter;
            const leftColumns = (_left$map$filter = left == null ? void 0 : left.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _left$map$filter : [];
            const rightColumns = (_right$map$filter = right == null ? void 0 : right.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _right$map$filter : [];
            const centerColumns = leafColumns.filter((column)=>!(left != null && left.includes(column.id)) && !(right != null && right.includes(column.id)));
            const headerGroups = $ff62fbff81e95ce8$export$d8c3a8af36458fc3(allColumns, [
                ...leftColumns,
                ...centerColumns,
                ...rightColumns
            ], table);
            return headerGroups;
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, $ff62fbff81e95ce8$var$debug, "getHeaderGroups"));
        table.getCenterHeaderGroups = $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allColumns, leafColumns, left, right)=>{
            leafColumns = leafColumns.filter((column)=>!(left != null && left.includes(column.id)) && !(right != null && right.includes(column.id)));
            return $ff62fbff81e95ce8$export$d8c3a8af36458fc3(allColumns, leafColumns, table, "center");
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, $ff62fbff81e95ce8$var$debug, "getCenterHeaderGroups"));
        table.getLeftHeaderGroups = $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.left
            ], (allColumns, leafColumns, left)=>{
            var _left$map$filter2;
            const orderedLeafColumns = (_left$map$filter2 = left == null ? void 0 : left.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _left$map$filter2 : [];
            return $ff62fbff81e95ce8$export$d8c3a8af36458fc3(allColumns, orderedLeafColumns, table, "left");
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, $ff62fbff81e95ce8$var$debug, "getLeftHeaderGroups"));
        table.getRightHeaderGroups = $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.right
            ], (allColumns, leafColumns, right)=>{
            var _right$map$filter2;
            const orderedLeafColumns = (_right$map$filter2 = right == null ? void 0 : right.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _right$map$filter2 : [];
            return $ff62fbff81e95ce8$export$d8c3a8af36458fc3(allColumns, orderedLeafColumns, table, "right");
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, $ff62fbff81e95ce8$var$debug, "getRightHeaderGroups"));
        // Footer Groups
        table.getFooterGroups = $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table.getHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, $ff62fbff81e95ce8$var$debug, "getFooterGroups"));
        table.getLeftFooterGroups = $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table.getLeftHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, $ff62fbff81e95ce8$var$debug, "getLeftFooterGroups"));
        table.getCenterFooterGroups = $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table.getCenterHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, $ff62fbff81e95ce8$var$debug, "getCenterFooterGroups"));
        table.getRightFooterGroups = $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table.getRightHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, $ff62fbff81e95ce8$var$debug, "getRightFooterGroups"));
        // Flat Headers
        table.getFlatHeaders = $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table.getHeaderGroups()
            ], (headerGroups)=>{
            return headerGroups.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, $ff62fbff81e95ce8$var$debug, "getFlatHeaders"));
        table.getLeftFlatHeaders = $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table.getLeftHeaderGroups()
            ], (left)=>{
            return left.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, $ff62fbff81e95ce8$var$debug, "getLeftFlatHeaders"));
        table.getCenterFlatHeaders = $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table.getCenterHeaderGroups()
            ], (left)=>{
            return left.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, $ff62fbff81e95ce8$var$debug, "getCenterFlatHeaders"));
        table.getRightFlatHeaders = $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table.getRightHeaderGroups()
            ], (left)=>{
            return left.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, $ff62fbff81e95ce8$var$debug, "getRightFlatHeaders"));
        // Leaf Headers
        table.getCenterLeafHeaders = $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table.getCenterFlatHeaders()
            ], (flatHeaders)=>{
            return flatHeaders.filter((header)=>{
                var _header$subHeaders;
                return !((_header$subHeaders = header.subHeaders) != null && _header$subHeaders.length);
            });
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, $ff62fbff81e95ce8$var$debug, "getCenterLeafHeaders"));
        table.getLeftLeafHeaders = $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table.getLeftFlatHeaders()
            ], (flatHeaders)=>{
            return flatHeaders.filter((header)=>{
                var _header$subHeaders2;
                return !((_header$subHeaders2 = header.subHeaders) != null && _header$subHeaders2.length);
            });
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, $ff62fbff81e95ce8$var$debug, "getLeftLeafHeaders"));
        table.getRightLeafHeaders = $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table.getRightFlatHeaders()
            ], (flatHeaders)=>{
            return flatHeaders.filter((header)=>{
                var _header$subHeaders3;
                return !((_header$subHeaders3 = header.subHeaders) != null && _header$subHeaders3.length);
            });
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, $ff62fbff81e95ce8$var$debug, "getRightLeafHeaders"));
        table.getLeafHeaders = $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table.getLeftHeaderGroups(),
                table.getCenterHeaderGroups(),
                table.getRightHeaderGroups()
            ], (left, center, right)=>{
            var _left$0$headers, _left$, _center$0$headers, _center$, _right$0$headers, _right$;
            return [
                ...(_left$0$headers = (_left$ = left[0]) == null ? void 0 : _left$.headers) != null ? _left$0$headers : [],
                ...(_center$0$headers = (_center$ = center[0]) == null ? void 0 : _center$.headers) != null ? _center$0$headers : [],
                ...(_right$0$headers = (_right$ = right[0]) == null ? void 0 : _right$.headers) != null ? _right$0$headers : []
            ].map((header)=>{
                return header.getLeafHeaders();
            }).flat();
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, $ff62fbff81e95ce8$var$debug, "getLeafHeaders"));
    }
};
function $ff62fbff81e95ce8$export$d8c3a8af36458fc3(allColumns, columnsToGroup, table, headerFamily) {
    var _headerGroups$0$heade, _headerGroups$;
    // Find the max depth of the columns:
    // build the leaf column row
    // build each buffer row going up
    //    placeholder for non-existent level
    //    real column for existing level
    let maxDepth = 0;
    const findMaxDepth = function(columns, depth) {
        if (depth === void 0) depth = 1;
        maxDepth = Math.max(maxDepth, depth);
        columns.filter((column)=>column.getIsVisible()).forEach((column)=>{
            var _column$columns;
            if ((_column$columns = column.columns) != null && _column$columns.length) findMaxDepth(column.columns, depth + 1);
        }, 0);
    };
    findMaxDepth(allColumns);
    let headerGroups = [];
    const createHeaderGroup = (headersToGroup, depth)=>{
        // The header group we are creating
        const headerGroup = {
            depth: depth,
            id: [
                headerFamily,
                `${depth}`
            ].filter(Boolean).join("_"),
            headers: []
        };
        // The parent columns we're going to scan next
        const pendingParentHeaders = [];
        // Scan each column for parents
        headersToGroup.forEach((headerToGroup)=>{
            // What is the latest (last) parent column?
            const latestPendingParentHeader = [
                ...pendingParentHeaders
            ].reverse()[0];
            const isLeafHeader = headerToGroup.column.depth === headerGroup.depth;
            let column;
            let isPlaceholder = false;
            if (isLeafHeader && headerToGroup.column.parent) // The parent header is new
            column = headerToGroup.column.parent;
            else {
                // The parent header is repeated
                column = headerToGroup.column;
                isPlaceholder = true;
            }
            if (latestPendingParentHeader && (latestPendingParentHeader == null ? void 0 : latestPendingParentHeader.column) === column) // This column is repeated. Add it as a sub header to the next batch
            latestPendingParentHeader.subHeaders.push(headerToGroup);
            else {
                // This is a new header. Let's create it
                const header = $ff62fbff81e95ce8$var$createHeader(table, column, {
                    id: [
                        headerFamily,
                        depth,
                        column.id,
                        headerToGroup == null ? void 0 : headerToGroup.id
                    ].filter(Boolean).join("_"),
                    isPlaceholder: isPlaceholder,
                    placeholderId: isPlaceholder ? `${pendingParentHeaders.filter((d)=>d.column === column).length}` : undefined,
                    depth: depth,
                    index: pendingParentHeaders.length
                });
                // Add the headerToGroup as a subHeader of the new header
                header.subHeaders.push(headerToGroup);
                // Add the new header to the pendingParentHeaders to get grouped
                // in the next batch
                pendingParentHeaders.push(header);
            }
            headerGroup.headers.push(headerToGroup);
            headerToGroup.headerGroup = headerGroup;
        });
        headerGroups.push(headerGroup);
        if (depth > 0) createHeaderGroup(pendingParentHeaders, depth - 1);
    };
    const bottomHeaders = columnsToGroup.map((column, index)=>$ff62fbff81e95ce8$var$createHeader(table, column, {
            depth: maxDepth,
            index: index
        }));
    createHeaderGroup(bottomHeaders, maxDepth - 1);
    headerGroups.reverse();
    // headerGroups = headerGroups.filter(headerGroup => {
    //   return !headerGroup.headers.every(header => header.isPlaceholder)
    // })
    const recurseHeadersForSpans = (headers)=>{
        const filteredHeaders = headers.filter((header)=>header.column.getIsVisible());
        return filteredHeaders.map((header)=>{
            let colSpan = 0;
            let rowSpan = 0;
            let childRowSpans = [
                0
            ];
            if (header.subHeaders && header.subHeaders.length) {
                childRowSpans = [];
                recurseHeadersForSpans(header.subHeaders).forEach((_ref)=>{
                    let { colSpan: childColSpan, rowSpan: childRowSpan } = _ref;
                    colSpan += childColSpan;
                    childRowSpans.push(childRowSpan);
                });
            } else colSpan = 1;
            const minChildRowSpan = Math.min(...childRowSpans);
            rowSpan = rowSpan + minChildRowSpan;
            header.colSpan = colSpan;
            header.rowSpan = rowSpan;
            return {
                colSpan: colSpan,
                rowSpan: rowSpan
            };
        });
    };
    recurseHeadersForSpans((_headerGroups$0$heade = (_headerGroups$ = headerGroups[0]) == null ? void 0 : _headerGroups$.headers) != null ? _headerGroups$0$heade : []);
    return headerGroups;
}
const $ff62fbff81e95ce8$export$3442c5d213434705 = (table, id, original, rowIndex, depth, subRows, parentId)=>{
    let row = {
        id: id,
        index: rowIndex,
        original: original,
        depth: depth,
        parentId: parentId,
        _valuesCache: {},
        _uniqueValuesCache: {},
        getValue: (columnId)=>{
            if (row._valuesCache.hasOwnProperty(columnId)) return row._valuesCache[columnId];
            const column = table.getColumn(columnId);
            if (!(column != null && column.accessorFn)) return undefined;
            row._valuesCache[columnId] = column.accessorFn(row.original, rowIndex);
            return row._valuesCache[columnId];
        },
        getUniqueValues: (columnId)=>{
            if (row._uniqueValuesCache.hasOwnProperty(columnId)) return row._uniqueValuesCache[columnId];
            const column = table.getColumn(columnId);
            if (!(column != null && column.accessorFn)) return undefined;
            if (!column.columnDef.getUniqueValues) {
                row._uniqueValuesCache[columnId] = [
                    row.getValue(columnId)
                ];
                return row._uniqueValuesCache[columnId];
            }
            row._uniqueValuesCache[columnId] = column.columnDef.getUniqueValues(row.original, rowIndex);
            return row._uniqueValuesCache[columnId];
        },
        renderValue: (columnId)=>{
            var _row$getValue;
            return (_row$getValue = row.getValue(columnId)) != null ? _row$getValue : table.options.renderFallbackValue;
        },
        subRows: subRows != null ? subRows : [],
        getLeafRows: ()=>$ff62fbff81e95ce8$export$bf4548421d1b2c8(row.subRows, (d)=>d.subRows),
        getParentRow: ()=>row.parentId ? table.getRow(row.parentId, true) : undefined,
        getParentRows: ()=>{
            let parentRows = [];
            let currentRow = row;
            while(true){
                const parentRow = currentRow.getParentRow();
                if (!parentRow) break;
                parentRows.push(parentRow);
                currentRow = parentRow;
            }
            return parentRows.reverse();
        },
        getAllCells: $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table.getAllLeafColumns()
            ], (leafColumns)=>{
            return leafColumns.map((column)=>{
                return $ff62fbff81e95ce8$export$3cb21b6b1233300e(table, row, column, column.id);
            });
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, "debugRows", "getAllCells")),
        _getAllCellsByColumnId: $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                row.getAllCells()
            ], (allCells)=>{
            return allCells.reduce((acc, cell)=>{
                acc[cell.column.id] = cell;
                return acc;
            }, {});
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, "debugRows", "getAllCellsByColumnId"))
    };
    for(let i = 0; i < table._features.length; i++){
        const feature = table._features[i];
        feature == null || feature.createRow == null || feature.createRow(row, table);
    }
    return row;
};
//
const $ff62fbff81e95ce8$export$1f746e6a9cd841b1 = {
    createColumn: (column, table)=>{
        column._getFacetedRowModel = table.options.getFacetedRowModel && table.options.getFacetedRowModel(table, column.id);
        column.getFacetedRowModel = ()=>{
            if (!column._getFacetedRowModel) return table.getPreFilteredRowModel();
            return column._getFacetedRowModel();
        };
        column._getFacetedUniqueValues = table.options.getFacetedUniqueValues && table.options.getFacetedUniqueValues(table, column.id);
        column.getFacetedUniqueValues = ()=>{
            if (!column._getFacetedUniqueValues) return new Map();
            return column._getFacetedUniqueValues();
        };
        column._getFacetedMinMaxValues = table.options.getFacetedMinMaxValues && table.options.getFacetedMinMaxValues(table, column.id);
        column.getFacetedMinMaxValues = ()=>{
            if (!column._getFacetedMinMaxValues) return undefined;
            return column._getFacetedMinMaxValues();
        };
    }
};
const $ff62fbff81e95ce8$var$includesString = (row, columnId, filterValue)=>{
    var _filterValue$toString, _row$getValue;
    const search = filterValue == null || (_filterValue$toString = filterValue.toString()) == null ? void 0 : _filterValue$toString.toLowerCase();
    return Boolean((_row$getValue = row.getValue(columnId)) == null || (_row$getValue = _row$getValue.toString()) == null || (_row$getValue = _row$getValue.toLowerCase()) == null ? void 0 : _row$getValue.includes(search));
};
$ff62fbff81e95ce8$var$includesString.autoRemove = (val)=>$ff62fbff81e95ce8$var$testFalsey(val);
const $ff62fbff81e95ce8$var$includesStringSensitive = (row, columnId, filterValue)=>{
    var _row$getValue2;
    return Boolean((_row$getValue2 = row.getValue(columnId)) == null || (_row$getValue2 = _row$getValue2.toString()) == null ? void 0 : _row$getValue2.includes(filterValue));
};
$ff62fbff81e95ce8$var$includesStringSensitive.autoRemove = (val)=>$ff62fbff81e95ce8$var$testFalsey(val);
const $ff62fbff81e95ce8$var$equalsString = (row, columnId, filterValue)=>{
    var _row$getValue3;
    return ((_row$getValue3 = row.getValue(columnId)) == null || (_row$getValue3 = _row$getValue3.toString()) == null ? void 0 : _row$getValue3.toLowerCase()) === (filterValue == null ? void 0 : filterValue.toLowerCase());
};
$ff62fbff81e95ce8$var$equalsString.autoRemove = (val)=>$ff62fbff81e95ce8$var$testFalsey(val);
const $ff62fbff81e95ce8$var$arrIncludes = (row, columnId, filterValue)=>{
    var _row$getValue4;
    return (_row$getValue4 = row.getValue(columnId)) == null ? void 0 : _row$getValue4.includes(filterValue);
};
$ff62fbff81e95ce8$var$arrIncludes.autoRemove = (val)=>$ff62fbff81e95ce8$var$testFalsey(val) || !(val != null && val.length);
const $ff62fbff81e95ce8$var$arrIncludesAll = (row, columnId, filterValue)=>{
    return !filterValue.some((val)=>{
        var _row$getValue5;
        return !((_row$getValue5 = row.getValue(columnId)) != null && _row$getValue5.includes(val));
    });
};
$ff62fbff81e95ce8$var$arrIncludesAll.autoRemove = (val)=>$ff62fbff81e95ce8$var$testFalsey(val) || !(val != null && val.length);
const $ff62fbff81e95ce8$var$arrIncludesSome = (row, columnId, filterValue)=>{
    return filterValue.some((val)=>{
        var _row$getValue6;
        return (_row$getValue6 = row.getValue(columnId)) == null ? void 0 : _row$getValue6.includes(val);
    });
};
$ff62fbff81e95ce8$var$arrIncludesSome.autoRemove = (val)=>$ff62fbff81e95ce8$var$testFalsey(val) || !(val != null && val.length);
const $ff62fbff81e95ce8$var$equals = (row, columnId, filterValue)=>{
    return row.getValue(columnId) === filterValue;
};
$ff62fbff81e95ce8$var$equals.autoRemove = (val)=>$ff62fbff81e95ce8$var$testFalsey(val);
const $ff62fbff81e95ce8$var$weakEquals = (row, columnId, filterValue)=>{
    return row.getValue(columnId) == filterValue;
};
$ff62fbff81e95ce8$var$weakEquals.autoRemove = (val)=>$ff62fbff81e95ce8$var$testFalsey(val);
const $ff62fbff81e95ce8$var$inNumberRange = (row, columnId, filterValue)=>{
    let [min, max] = filterValue;
    const rowValue = row.getValue(columnId);
    return rowValue >= min && rowValue <= max;
};
$ff62fbff81e95ce8$var$inNumberRange.resolveFilterValue = (val)=>{
    let [unsafeMin, unsafeMax] = val;
    let parsedMin = typeof unsafeMin !== "number" ? parseFloat(unsafeMin) : unsafeMin;
    let parsedMax = typeof unsafeMax !== "number" ? parseFloat(unsafeMax) : unsafeMax;
    let min = unsafeMin === null || Number.isNaN(parsedMin) ? -Infinity : parsedMin;
    let max = unsafeMax === null || Number.isNaN(parsedMax) ? Infinity : parsedMax;
    if (min > max) {
        const temp = min;
        min = max;
        max = temp;
    }
    return [
        min,
        max
    ];
};
$ff62fbff81e95ce8$var$inNumberRange.autoRemove = (val)=>$ff62fbff81e95ce8$var$testFalsey(val) || $ff62fbff81e95ce8$var$testFalsey(val[0]) && $ff62fbff81e95ce8$var$testFalsey(val[1]);
// Export
const $ff62fbff81e95ce8$export$6ad8312e296ec316 = {
    includesString: $ff62fbff81e95ce8$var$includesString,
    includesStringSensitive: $ff62fbff81e95ce8$var$includesStringSensitive,
    equalsString: $ff62fbff81e95ce8$var$equalsString,
    arrIncludes: $ff62fbff81e95ce8$var$arrIncludes,
    arrIncludesAll: $ff62fbff81e95ce8$var$arrIncludesAll,
    arrIncludesSome: $ff62fbff81e95ce8$var$arrIncludesSome,
    equals: $ff62fbff81e95ce8$var$equals,
    weakEquals: $ff62fbff81e95ce8$var$weakEquals,
    inNumberRange: $ff62fbff81e95ce8$var$inNumberRange
};
// Utils
function $ff62fbff81e95ce8$var$testFalsey(val) {
    return val === undefined || val === null || val === "";
}
//
const $ff62fbff81e95ce8$export$f1d67534a0c5e9d3 = {
    getDefaultColumnDef: ()=>{
        return {
            filterFn: "auto"
        };
    },
    getInitialState: (state)=>{
        return {
            columnFilters: [],
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnFiltersChange: $ff62fbff81e95ce8$export$2b5605d8069324bd("columnFilters", table),
            filterFromLeafRows: false,
            maxLeafRowFilterDepth: 100
        };
    },
    createColumn: (column, table)=>{
        column.getAutoFilterFn = ()=>{
            const firstRow = table.getCoreRowModel().flatRows[0];
            const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
            if (typeof value === "string") return $ff62fbff81e95ce8$export$6ad8312e296ec316.includesString;
            if (typeof value === "number") return $ff62fbff81e95ce8$export$6ad8312e296ec316.inNumberRange;
            if (typeof value === "boolean") return $ff62fbff81e95ce8$export$6ad8312e296ec316.equals;
            if (value !== null && typeof value === "object") return $ff62fbff81e95ce8$export$6ad8312e296ec316.equals;
            if (Array.isArray(value)) return $ff62fbff81e95ce8$export$6ad8312e296ec316.arrIncludes;
            return $ff62fbff81e95ce8$export$6ad8312e296ec316.weakEquals;
        };
        column.getFilterFn = ()=>{
            var _table$options$filter, _table$options$filter2;
            return $ff62fbff81e95ce8$export$f6e2535fb5126e54(column.columnDef.filterFn) ? column.columnDef.filterFn : column.columnDef.filterFn === "auto" ? column.getAutoFilterFn() : (_table$options$filter = (_table$options$filter2 = table.options.filterFns) == null ? void 0 : _table$options$filter2[column.columnDef.filterFn]) != null ? _table$options$filter : $ff62fbff81e95ce8$export$6ad8312e296ec316[column.columnDef.filterFn];
        };
        column.getCanFilter = ()=>{
            var _column$columnDef$ena, _table$options$enable, _table$options$enable2;
            return ((_column$columnDef$ena = column.columnDef.enableColumnFilter) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableColumnFilters) != null ? _table$options$enable : true) && ((_table$options$enable2 = table.options.enableFilters) != null ? _table$options$enable2 : true) && !!column.accessorFn;
        };
        column.getIsFiltered = ()=>column.getFilterIndex() > -1;
        column.getFilterValue = ()=>{
            var _table$getState$colum;
            return (_table$getState$colum = table.getState().columnFilters) == null || (_table$getState$colum = _table$getState$colum.find((d)=>d.id === column.id)) == null ? void 0 : _table$getState$colum.value;
        };
        column.getFilterIndex = ()=>{
            var _table$getState$colum2, _table$getState$colum3;
            return (_table$getState$colum2 = (_table$getState$colum3 = table.getState().columnFilters) == null ? void 0 : _table$getState$colum3.findIndex((d)=>d.id === column.id)) != null ? _table$getState$colum2 : -1;
        };
        column.setFilterValue = (value)=>{
            table.setColumnFilters((old)=>{
                const filterFn = column.getFilterFn();
                const previousFilter = old == null ? void 0 : old.find((d)=>d.id === column.id);
                const newFilter = $ff62fbff81e95ce8$export$7f095f455ad5af3f(value, previousFilter ? previousFilter.value : undefined);
                //
                if ($ff62fbff81e95ce8$export$5b01eb94d7ce58a8(filterFn, newFilter, column)) {
                    var _old$filter;
                    return (_old$filter = old == null ? void 0 : old.filter((d)=>d.id !== column.id)) != null ? _old$filter : [];
                }
                const newFilterObj = {
                    id: column.id,
                    value: newFilter
                };
                if (previousFilter) {
                    var _old$map;
                    return (_old$map = old == null ? void 0 : old.map((d)=>{
                        if (d.id === column.id) return newFilterObj;
                        return d;
                    })) != null ? _old$map : [];
                }
                if (old != null && old.length) return [
                    ...old,
                    newFilterObj
                ];
                return [
                    newFilterObj
                ];
            });
        };
    },
    createRow: (row, _table)=>{
        row.columnFilters = {};
        row.columnFiltersMeta = {};
    },
    createTable: (table)=>{
        table.setColumnFilters = (updater)=>{
            const leafColumns = table.getAllLeafColumns();
            const updateFn = (old)=>{
                var _functionalUpdate;
                return (_functionalUpdate = $ff62fbff81e95ce8$export$7f095f455ad5af3f(updater, old)) == null ? void 0 : _functionalUpdate.filter((filter)=>{
                    const column = leafColumns.find((d)=>d.id === filter.id);
                    if (column) {
                        const filterFn = column.getFilterFn();
                        if ($ff62fbff81e95ce8$export$5b01eb94d7ce58a8(filterFn, filter.value, column)) return false;
                    }
                    return true;
                });
            };
            table.options.onColumnFiltersChange == null || table.options.onColumnFiltersChange(updateFn);
        };
        table.resetColumnFilters = (defaultState)=>{
            var _table$initialState$c, _table$initialState;
            table.setColumnFilters(defaultState ? [] : (_table$initialState$c = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.columnFilters) != null ? _table$initialState$c : []);
        };
        table.getPreFilteredRowModel = ()=>table.getCoreRowModel();
        table.getFilteredRowModel = ()=>{
            if (!table._getFilteredRowModel && table.options.getFilteredRowModel) table._getFilteredRowModel = table.options.getFilteredRowModel(table);
            if (table.options.manualFiltering || !table._getFilteredRowModel) return table.getPreFilteredRowModel();
            return table._getFilteredRowModel();
        };
    }
};
function $ff62fbff81e95ce8$export$5b01eb94d7ce58a8(filterFn, value, column) {
    return (filterFn && filterFn.autoRemove ? filterFn.autoRemove(value, column) : false) || typeof value === "undefined" || typeof value === "string" && !value;
}
const $ff62fbff81e95ce8$var$sum = (columnId, _leafRows, childRows)=>{
    // It's faster to just add the aggregations together instead of
    // process leaf nodes individually
    return childRows.reduce((sum, next)=>{
        const nextValue = next.getValue(columnId);
        return sum + (typeof nextValue === "number" ? nextValue : 0);
    }, 0);
};
const $ff62fbff81e95ce8$var$min = (columnId, _leafRows, childRows)=>{
    let min;
    childRows.forEach((row)=>{
        const value = row.getValue(columnId);
        if (value != null && (min > value || min === undefined && value >= value)) min = value;
    });
    return min;
};
const $ff62fbff81e95ce8$var$max = (columnId, _leafRows, childRows)=>{
    let max;
    childRows.forEach((row)=>{
        const value = row.getValue(columnId);
        if (value != null && (max < value || max === undefined && value >= value)) max = value;
    });
    return max;
};
const $ff62fbff81e95ce8$var$extent = (columnId, _leafRows, childRows)=>{
    let min;
    let max;
    childRows.forEach((row)=>{
        const value = row.getValue(columnId);
        if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    });
    return [
        min,
        max
    ];
};
const $ff62fbff81e95ce8$var$mean = (columnId, leafRows)=>{
    let count = 0;
    let sum = 0;
    leafRows.forEach((row)=>{
        let value = row.getValue(columnId);
        if (value != null && (value = +value) >= value) ++count, sum += value;
    });
    if (count) return sum / count;
    return;
};
const $ff62fbff81e95ce8$var$median = (columnId, leafRows)=>{
    if (!leafRows.length) return;
    const values = leafRows.map((row)=>row.getValue(columnId));
    if (!$ff62fbff81e95ce8$export$5cd576d1827d40c8(values)) return;
    if (values.length === 1) return values[0];
    const mid = Math.floor(values.length / 2);
    const nums = values.sort((a, b)=>a - b);
    return values.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
};
const $ff62fbff81e95ce8$var$unique = (columnId, leafRows)=>{
    return Array.from(new Set(leafRows.map((d)=>d.getValue(columnId))).values());
};
const $ff62fbff81e95ce8$var$uniqueCount = (columnId, leafRows)=>{
    return new Set(leafRows.map((d)=>d.getValue(columnId))).size;
};
const $ff62fbff81e95ce8$var$count = (_columnId, leafRows)=>{
    return leafRows.length;
};
const $ff62fbff81e95ce8$export$3aa4339120b8b25b = {
    sum: $ff62fbff81e95ce8$var$sum,
    min: $ff62fbff81e95ce8$var$min,
    max: $ff62fbff81e95ce8$var$max,
    extent: $ff62fbff81e95ce8$var$extent,
    mean: $ff62fbff81e95ce8$var$mean,
    median: $ff62fbff81e95ce8$var$median,
    unique: $ff62fbff81e95ce8$var$unique,
    uniqueCount: $ff62fbff81e95ce8$var$uniqueCount,
    count: $ff62fbff81e95ce8$var$count
};
//
const $ff62fbff81e95ce8$export$9c9247c655f92e74 = {
    getDefaultColumnDef: ()=>{
        return {
            aggregatedCell: (props)=>{
                var _toString, _props$getValue;
                return (_toString = (_props$getValue = props.getValue()) == null || _props$getValue.toString == null ? void 0 : _props$getValue.toString()) != null ? _toString : null;
            },
            aggregationFn: "auto"
        };
    },
    getInitialState: (state)=>{
        return {
            grouping: [],
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onGroupingChange: $ff62fbff81e95ce8$export$2b5605d8069324bd("grouping", table),
            groupedColumnMode: "reorder"
        };
    },
    createColumn: (column, table)=>{
        column.toggleGrouping = ()=>{
            table.setGrouping((old)=>{
                // Find any existing grouping for this column
                if (old != null && old.includes(column.id)) return old.filter((d)=>d !== column.id);
                return [
                    ...old != null ? old : [],
                    column.id
                ];
            });
        };
        column.getCanGroup = ()=>{
            var _column$columnDef$ena, _table$options$enable;
            return ((_column$columnDef$ena = column.columnDef.enableGrouping) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableGrouping) != null ? _table$options$enable : true) && (!!column.accessorFn || !!column.columnDef.getGroupingValue);
        };
        column.getIsGrouped = ()=>{
            var _table$getState$group;
            return (_table$getState$group = table.getState().grouping) == null ? void 0 : _table$getState$group.includes(column.id);
        };
        column.getGroupedIndex = ()=>{
            var _table$getState$group2;
            return (_table$getState$group2 = table.getState().grouping) == null ? void 0 : _table$getState$group2.indexOf(column.id);
        };
        column.getToggleGroupingHandler = ()=>{
            const canGroup = column.getCanGroup();
            return ()=>{
                if (!canGroup) return;
                column.toggleGrouping();
            };
        };
        column.getAutoAggregationFn = ()=>{
            const firstRow = table.getCoreRowModel().flatRows[0];
            const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
            if (typeof value === "number") return $ff62fbff81e95ce8$export$3aa4339120b8b25b.sum;
            if (Object.prototype.toString.call(value) === "[object Date]") return $ff62fbff81e95ce8$export$3aa4339120b8b25b.extent;
        };
        column.getAggregationFn = ()=>{
            var _table$options$aggreg, _table$options$aggreg2;
            if (!column) throw new Error();
            return $ff62fbff81e95ce8$export$f6e2535fb5126e54(column.columnDef.aggregationFn) ? column.columnDef.aggregationFn : column.columnDef.aggregationFn === "auto" ? column.getAutoAggregationFn() : (_table$options$aggreg = (_table$options$aggreg2 = table.options.aggregationFns) == null ? void 0 : _table$options$aggreg2[column.columnDef.aggregationFn]) != null ? _table$options$aggreg : $ff62fbff81e95ce8$export$3aa4339120b8b25b[column.columnDef.aggregationFn];
        };
    },
    createTable: (table)=>{
        table.setGrouping = (updater)=>table.options.onGroupingChange == null ? void 0 : table.options.onGroupingChange(updater);
        table.resetGrouping = (defaultState)=>{
            var _table$initialState$g, _table$initialState;
            table.setGrouping(defaultState ? [] : (_table$initialState$g = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.grouping) != null ? _table$initialState$g : []);
        };
        table.getPreGroupedRowModel = ()=>table.getFilteredRowModel();
        table.getGroupedRowModel = ()=>{
            if (!table._getGroupedRowModel && table.options.getGroupedRowModel) table._getGroupedRowModel = table.options.getGroupedRowModel(table);
            if (table.options.manualGrouping || !table._getGroupedRowModel) return table.getPreGroupedRowModel();
            return table._getGroupedRowModel();
        };
    },
    createRow: (row, table)=>{
        row.getIsGrouped = ()=>!!row.groupingColumnId;
        row.getGroupingValue = (columnId)=>{
            if (row._groupingValuesCache.hasOwnProperty(columnId)) return row._groupingValuesCache[columnId];
            const column = table.getColumn(columnId);
            if (!(column != null && column.columnDef.getGroupingValue)) return row.getValue(columnId);
            row._groupingValuesCache[columnId] = column.columnDef.getGroupingValue(row.original);
            return row._groupingValuesCache[columnId];
        };
        row._groupingValuesCache = {};
    },
    createCell: (cell, column, row, table)=>{
        cell.getIsGrouped = ()=>column.getIsGrouped() && column.id === row.groupingColumnId;
        cell.getIsPlaceholder = ()=>!cell.getIsGrouped() && column.getIsGrouped();
        cell.getIsAggregated = ()=>{
            var _row$subRows;
            return !cell.getIsGrouped() && !cell.getIsPlaceholder() && !!((_row$subRows = row.subRows) != null && _row$subRows.length);
        };
    }
};
function $ff62fbff81e95ce8$export$ac763d2b0470e663(leafColumns, grouping, groupedColumnMode) {
    if (!(grouping != null && grouping.length) || !groupedColumnMode) return leafColumns;
    const nonGroupingColumns = leafColumns.filter((col)=>!grouping.includes(col.id));
    if (groupedColumnMode === "remove") return nonGroupingColumns;
    const groupingColumns = grouping.map((g)=>leafColumns.find((col)=>col.id === g)).filter(Boolean);
    return [
        ...groupingColumns,
        ...nonGroupingColumns
    ];
}
//
const $ff62fbff81e95ce8$export$fec9c66cd0275c2c = {
    getInitialState: (state)=>{
        return {
            columnOrder: [],
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnOrderChange: $ff62fbff81e95ce8$export$2b5605d8069324bd("columnOrder", table)
        };
    },
    createColumn: (column, table)=>{
        column.getIndex = $ff62fbff81e95ce8$export$7c73462e0d25e514((position)=>[
                $ff62fbff81e95ce8$export$1d7c103713892a11(table, position)
            ], (columns)=>columns.findIndex((d)=>d.id === column.id), $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, "debugColumns", "getIndex"));
        column.getIsFirstColumn = (position)=>{
            var _columns$;
            const columns = $ff62fbff81e95ce8$export$1d7c103713892a11(table, position);
            return ((_columns$ = columns[0]) == null ? void 0 : _columns$.id) === column.id;
        };
        column.getIsLastColumn = (position)=>{
            var _columns;
            const columns = $ff62fbff81e95ce8$export$1d7c103713892a11(table, position);
            return ((_columns = columns[columns.length - 1]) == null ? void 0 : _columns.id) === column.id;
        };
    },
    createTable: (table)=>{
        table.setColumnOrder = (updater)=>table.options.onColumnOrderChange == null ? void 0 : table.options.onColumnOrderChange(updater);
        table.resetColumnOrder = (defaultState)=>{
            var _table$initialState$c;
            table.setColumnOrder(defaultState ? [] : (_table$initialState$c = table.initialState.columnOrder) != null ? _table$initialState$c : []);
        };
        table._getOrderColumnsFn = $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table.getState().columnOrder,
                table.getState().grouping,
                table.options.groupedColumnMode
            ], (columnOrder, grouping, groupedColumnMode)=>(columns)=>{
                // Sort grouped columns to the start of the column list
                // before the headers are built
                let orderedColumns = [];
                // If there is no order, return the normal columns
                if (!(columnOrder != null && columnOrder.length)) orderedColumns = columns;
                else {
                    const columnOrderCopy = [
                        ...columnOrder
                    ];
                    // If there is an order, make a copy of the columns
                    const columnsCopy = [
                        ...columns
                    ];
                    // And make a new ordered array of the columns
                    // Loop over the columns and place them in order into the new array
                    while(columnsCopy.length && columnOrderCopy.length){
                        const targetColumnId = columnOrderCopy.shift();
                        const foundIndex = columnsCopy.findIndex((d)=>d.id === targetColumnId);
                        if (foundIndex > -1) orderedColumns.push(columnsCopy.splice(foundIndex, 1)[0]);
                    }
                    // If there are any columns left, add them to the end
                    orderedColumns = [
                        ...orderedColumns,
                        ...columnsCopy
                    ];
                }
                return $ff62fbff81e95ce8$export$ac763d2b0470e663(orderedColumns, grouping, groupedColumnMode);
            }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, "debugTable", "_getOrderColumnsFn"));
    }
};
//
const $ff62fbff81e95ce8$var$getDefaultColumnPinningState = ()=>({
        left: [],
        right: []
    });
const $ff62fbff81e95ce8$export$3563275ce70c4813 = {
    getInitialState: (state)=>{
        return {
            columnPinning: $ff62fbff81e95ce8$var$getDefaultColumnPinningState(),
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnPinningChange: $ff62fbff81e95ce8$export$2b5605d8069324bd("columnPinning", table)
        };
    },
    createColumn: (column, table)=>{
        column.pin = (position)=>{
            const columnIds = column.getLeafColumns().map((d)=>d.id).filter(Boolean);
            table.setColumnPinning((old)=>{
                var _old$left3, _old$right3;
                if (position === "right") {
                    var _old$left, _old$right;
                    return {
                        left: ((_old$left = old == null ? void 0 : old.left) != null ? _old$left : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                        right: [
                            ...((_old$right = old == null ? void 0 : old.right) != null ? _old$right : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                            ...columnIds
                        ]
                    };
                }
                if (position === "left") {
                    var _old$left2, _old$right2;
                    return {
                        left: [
                            ...((_old$left2 = old == null ? void 0 : old.left) != null ? _old$left2 : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                            ...columnIds
                        ],
                        right: ((_old$right2 = old == null ? void 0 : old.right) != null ? _old$right2 : []).filter((d)=>!(columnIds != null && columnIds.includes(d)))
                    };
                }
                return {
                    left: ((_old$left3 = old == null ? void 0 : old.left) != null ? _old$left3 : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                    right: ((_old$right3 = old == null ? void 0 : old.right) != null ? _old$right3 : []).filter((d)=>!(columnIds != null && columnIds.includes(d)))
                };
            });
        };
        column.getCanPin = ()=>{
            const leafColumns = column.getLeafColumns();
            return leafColumns.some((d)=>{
                var _d$columnDef$enablePi, _ref, _table$options$enable;
                return ((_d$columnDef$enablePi = d.columnDef.enablePinning) != null ? _d$columnDef$enablePi : true) && ((_ref = (_table$options$enable = table.options.enableColumnPinning) != null ? _table$options$enable : table.options.enablePinning) != null ? _ref : true);
            });
        };
        column.getIsPinned = ()=>{
            const leafColumnIds = column.getLeafColumns().map((d)=>d.id);
            const { left: left, right: right } = table.getState().columnPinning;
            const isLeft = leafColumnIds.some((d)=>left == null ? void 0 : left.includes(d));
            const isRight = leafColumnIds.some((d)=>right == null ? void 0 : right.includes(d));
            return isLeft ? "left" : isRight ? "right" : false;
        };
        column.getPinnedIndex = ()=>{
            var _table$getState$colum, _table$getState$colum2;
            const position = column.getIsPinned();
            return position ? (_table$getState$colum = (_table$getState$colum2 = table.getState().columnPinning) == null || (_table$getState$colum2 = _table$getState$colum2[position]) == null ? void 0 : _table$getState$colum2.indexOf(column.id)) != null ? _table$getState$colum : -1 : 0;
        };
    },
    createRow: (row, table)=>{
        row.getCenterVisibleCells = $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                row._getAllVisibleCells(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allCells, left, right)=>{
            const leftAndRight = [
                ...left != null ? left : [],
                ...right != null ? right : []
            ];
            return allCells.filter((d)=>!leftAndRight.includes(d.column.id));
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, "debugRows", "getCenterVisibleCells"));
        row.getLeftVisibleCells = $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                row._getAllVisibleCells(),
                table.getState().columnPinning.left
            ], (allCells, left)=>{
            const cells = (left != null ? left : []).map((columnId)=>allCells.find((cell)=>cell.column.id === columnId)).filter(Boolean).map((d)=>({
                    ...d,
                    position: "left"
                }));
            return cells;
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, "debugRows", "getLeftVisibleCells"));
        row.getRightVisibleCells = $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                row._getAllVisibleCells(),
                table.getState().columnPinning.right
            ], (allCells, right)=>{
            const cells = (right != null ? right : []).map((columnId)=>allCells.find((cell)=>cell.column.id === columnId)).filter(Boolean).map((d)=>({
                    ...d,
                    position: "right"
                }));
            return cells;
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, "debugRows", "getRightVisibleCells"));
    },
    createTable: (table)=>{
        table.setColumnPinning = (updater)=>table.options.onColumnPinningChange == null ? void 0 : table.options.onColumnPinningChange(updater);
        table.resetColumnPinning = (defaultState)=>{
            var _table$initialState$c, _table$initialState;
            return table.setColumnPinning(defaultState ? $ff62fbff81e95ce8$var$getDefaultColumnPinningState() : (_table$initialState$c = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.columnPinning) != null ? _table$initialState$c : $ff62fbff81e95ce8$var$getDefaultColumnPinningState());
        };
        table.getIsSomeColumnsPinned = (position)=>{
            var _pinningState$positio;
            const pinningState = table.getState().columnPinning;
            if (!position) {
                var _pinningState$left, _pinningState$right;
                return Boolean(((_pinningState$left = pinningState.left) == null ? void 0 : _pinningState$left.length) || ((_pinningState$right = pinningState.right) == null ? void 0 : _pinningState$right.length));
            }
            return Boolean((_pinningState$positio = pinningState[position]) == null ? void 0 : _pinningState$positio.length);
        };
        table.getLeftLeafColumns = $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table.getAllLeafColumns(),
                table.getState().columnPinning.left
            ], (allColumns, left)=>{
            return (left != null ? left : []).map((columnId)=>allColumns.find((column)=>column.id === columnId)).filter(Boolean);
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, "debugColumns", "getLeftLeafColumns"));
        table.getRightLeafColumns = $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table.getAllLeafColumns(),
                table.getState().columnPinning.right
            ], (allColumns, right)=>{
            return (right != null ? right : []).map((columnId)=>allColumns.find((column)=>column.id === columnId)).filter(Boolean);
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, "debugColumns", "getRightLeafColumns"));
        table.getCenterLeafColumns = $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table.getAllLeafColumns(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allColumns, left, right)=>{
            const leftAndRight = [
                ...left != null ? left : [],
                ...right != null ? right : []
            ];
            return allColumns.filter((d)=>!leftAndRight.includes(d.id));
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, "debugColumns", "getCenterLeafColumns"));
    }
};
//
//
const $ff62fbff81e95ce8$export$2f660993f4eb1f29 = {
    size: 150,
    minSize: 20,
    maxSize: Number.MAX_SAFE_INTEGER
};
const $ff62fbff81e95ce8$var$getDefaultColumnSizingInfoState = ()=>({
        startOffset: null,
        startSize: null,
        deltaOffset: null,
        deltaPercentage: null,
        isResizingColumn: false,
        columnSizingStart: []
    });
const $ff62fbff81e95ce8$export$9916c85814812d4a = {
    getDefaultColumnDef: ()=>{
        return $ff62fbff81e95ce8$export$2f660993f4eb1f29;
    },
    getInitialState: (state)=>{
        return {
            columnSizing: {},
            columnSizingInfo: $ff62fbff81e95ce8$var$getDefaultColumnSizingInfoState(),
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            columnResizeMode: "onEnd",
            columnResizeDirection: "ltr",
            onColumnSizingChange: $ff62fbff81e95ce8$export$2b5605d8069324bd("columnSizing", table),
            onColumnSizingInfoChange: $ff62fbff81e95ce8$export$2b5605d8069324bd("columnSizingInfo", table)
        };
    },
    createColumn: (column, table)=>{
        column.getSize = ()=>{
            var _column$columnDef$min, _ref, _column$columnDef$max;
            const columnSize = table.getState().columnSizing[column.id];
            return Math.min(Math.max((_column$columnDef$min = column.columnDef.minSize) != null ? _column$columnDef$min : $ff62fbff81e95ce8$export$2f660993f4eb1f29.minSize, (_ref = columnSize != null ? columnSize : column.columnDef.size) != null ? _ref : $ff62fbff81e95ce8$export$2f660993f4eb1f29.size), (_column$columnDef$max = column.columnDef.maxSize) != null ? _column$columnDef$max : $ff62fbff81e95ce8$export$2f660993f4eb1f29.maxSize);
        };
        column.getStart = $ff62fbff81e95ce8$export$7c73462e0d25e514((position)=>[
                position,
                $ff62fbff81e95ce8$export$1d7c103713892a11(table, position),
                table.getState().columnSizing
            ], (position, columns)=>columns.slice(0, column.getIndex(position)).reduce((sum, column)=>sum + column.getSize(), 0), $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, "debugColumns", "getStart"));
        column.getAfter = $ff62fbff81e95ce8$export$7c73462e0d25e514((position)=>[
                position,
                $ff62fbff81e95ce8$export$1d7c103713892a11(table, position),
                table.getState().columnSizing
            ], (position, columns)=>columns.slice(column.getIndex(position) + 1).reduce((sum, column)=>sum + column.getSize(), 0), $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, "debugColumns", "getAfter"));
        column.resetSize = ()=>{
            table.setColumnSizing((_ref2)=>{
                let { [column.id]: _, ...rest } = _ref2;
                return rest;
            });
        };
        column.getCanResize = ()=>{
            var _column$columnDef$ena, _table$options$enable;
            return ((_column$columnDef$ena = column.columnDef.enableResizing) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableColumnResizing) != null ? _table$options$enable : true);
        };
        column.getIsResizing = ()=>{
            return table.getState().columnSizingInfo.isResizingColumn === column.id;
        };
    },
    createHeader: (header, table)=>{
        header.getSize = ()=>{
            let sum = 0;
            const recurse = (header)=>{
                if (header.subHeaders.length) header.subHeaders.forEach(recurse);
                else {
                    var _header$column$getSiz;
                    sum += (_header$column$getSiz = header.column.getSize()) != null ? _header$column$getSiz : 0;
                }
            };
            recurse(header);
            return sum;
        };
        header.getStart = ()=>{
            if (header.index > 0) {
                const prevSiblingHeader = header.headerGroup.headers[header.index - 1];
                return prevSiblingHeader.getStart() + prevSiblingHeader.getSize();
            }
            return 0;
        };
        header.getResizeHandler = (_contextDocument)=>{
            const column = table.getColumn(header.column.id);
            const canResize = column == null ? void 0 : column.getCanResize();
            return (e)=>{
                if (!column || !canResize) return;
                e.persist == null || e.persist();
                if ($ff62fbff81e95ce8$var$isTouchStartEvent(e)) {
                    // lets not respond to multiple touches (e.g. 2 or 3 fingers)
                    if (e.touches && e.touches.length > 1) return;
                }
                const startSize = header.getSize();
                const columnSizingStart = header ? header.getLeafHeaders().map((d)=>[
                        d.column.id,
                        d.column.getSize()
                    ]) : [
                    [
                        column.id,
                        column.getSize()
                    ]
                ];
                const clientX = $ff62fbff81e95ce8$var$isTouchStartEvent(e) ? Math.round(e.touches[0].clientX) : e.clientX;
                const newColumnSizing = {};
                const updateOffset = (eventType, clientXPos)=>{
                    if (typeof clientXPos !== "number") return;
                    table.setColumnSizingInfo((old)=>{
                        var _old$startOffset, _old$startSize;
                        const deltaDirection = table.options.columnResizeDirection === "rtl" ? -1 : 1;
                        const deltaOffset = (clientXPos - ((_old$startOffset = old == null ? void 0 : old.startOffset) != null ? _old$startOffset : 0)) * deltaDirection;
                        const deltaPercentage = Math.max(deltaOffset / ((_old$startSize = old == null ? void 0 : old.startSize) != null ? _old$startSize : 0), -0.999999);
                        old.columnSizingStart.forEach((_ref3)=>{
                            let [columnId, headerSize] = _ref3;
                            newColumnSizing[columnId] = Math.round(Math.max(headerSize + headerSize * deltaPercentage, 0) * 100) / 100;
                        });
                        return {
                            ...old,
                            deltaOffset: deltaOffset,
                            deltaPercentage: deltaPercentage
                        };
                    });
                    if (table.options.columnResizeMode === "onChange" || eventType === "end") table.setColumnSizing((old)=>({
                            ...old,
                            ...newColumnSizing
                        }));
                };
                const onMove = (clientXPos)=>updateOffset("move", clientXPos);
                const onEnd = (clientXPos)=>{
                    updateOffset("end", clientXPos);
                    table.setColumnSizingInfo((old)=>({
                            ...old,
                            isResizingColumn: false,
                            startOffset: null,
                            startSize: null,
                            deltaOffset: null,
                            deltaPercentage: null,
                            columnSizingStart: []
                        }));
                };
                const contextDocument = _contextDocument || typeof document !== "undefined" ? document : null;
                const mouseEvents = {
                    moveHandler: (e)=>onMove(e.clientX),
                    upHandler: (e)=>{
                        contextDocument == null || contextDocument.removeEventListener("mousemove", mouseEvents.moveHandler);
                        contextDocument == null || contextDocument.removeEventListener("mouseup", mouseEvents.upHandler);
                        onEnd(e.clientX);
                    }
                };
                const touchEvents = {
                    moveHandler: (e)=>{
                        if (e.cancelable) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                        onMove(e.touches[0].clientX);
                        return false;
                    },
                    upHandler: (e)=>{
                        var _e$touches$;
                        contextDocument == null || contextDocument.removeEventListener("touchmove", touchEvents.moveHandler);
                        contextDocument == null || contextDocument.removeEventListener("touchend", touchEvents.upHandler);
                        if (e.cancelable) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                        onEnd((_e$touches$ = e.touches[0]) == null ? void 0 : _e$touches$.clientX);
                    }
                };
                const passiveIfSupported = $ff62fbff81e95ce8$export$4927b5943c7c0b4() ? {
                    passive: false
                } : false;
                if ($ff62fbff81e95ce8$var$isTouchStartEvent(e)) {
                    contextDocument == null || contextDocument.addEventListener("touchmove", touchEvents.moveHandler, passiveIfSupported);
                    contextDocument == null || contextDocument.addEventListener("touchend", touchEvents.upHandler, passiveIfSupported);
                } else {
                    contextDocument == null || contextDocument.addEventListener("mousemove", mouseEvents.moveHandler, passiveIfSupported);
                    contextDocument == null || contextDocument.addEventListener("mouseup", mouseEvents.upHandler, passiveIfSupported);
                }
                table.setColumnSizingInfo((old)=>({
                        ...old,
                        startOffset: clientX,
                        startSize: startSize,
                        deltaOffset: 0,
                        deltaPercentage: 0,
                        columnSizingStart: columnSizingStart,
                        isResizingColumn: column.id
                    }));
            };
        };
    },
    createTable: (table)=>{
        table.setColumnSizing = (updater)=>table.options.onColumnSizingChange == null ? void 0 : table.options.onColumnSizingChange(updater);
        table.setColumnSizingInfo = (updater)=>table.options.onColumnSizingInfoChange == null ? void 0 : table.options.onColumnSizingInfoChange(updater);
        table.resetColumnSizing = (defaultState)=>{
            var _table$initialState$c;
            table.setColumnSizing(defaultState ? {} : (_table$initialState$c = table.initialState.columnSizing) != null ? _table$initialState$c : {});
        };
        table.resetHeaderSizeInfo = (defaultState)=>{
            var _table$initialState$c2;
            table.setColumnSizingInfo(defaultState ? $ff62fbff81e95ce8$var$getDefaultColumnSizingInfoState() : (_table$initialState$c2 = table.initialState.columnSizingInfo) != null ? _table$initialState$c2 : $ff62fbff81e95ce8$var$getDefaultColumnSizingInfoState());
        };
        table.getTotalSize = ()=>{
            var _table$getHeaderGroup, _table$getHeaderGroup2;
            return (_table$getHeaderGroup = (_table$getHeaderGroup2 = table.getHeaderGroups()[0]) == null ? void 0 : _table$getHeaderGroup2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getHeaderGroup : 0;
        };
        table.getLeftTotalSize = ()=>{
            var _table$getLeftHeaderG, _table$getLeftHeaderG2;
            return (_table$getLeftHeaderG = (_table$getLeftHeaderG2 = table.getLeftHeaderGroups()[0]) == null ? void 0 : _table$getLeftHeaderG2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getLeftHeaderG : 0;
        };
        table.getCenterTotalSize = ()=>{
            var _table$getCenterHeade, _table$getCenterHeade2;
            return (_table$getCenterHeade = (_table$getCenterHeade2 = table.getCenterHeaderGroups()[0]) == null ? void 0 : _table$getCenterHeade2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getCenterHeade : 0;
        };
        table.getRightTotalSize = ()=>{
            var _table$getRightHeader, _table$getRightHeader2;
            return (_table$getRightHeader = (_table$getRightHeader2 = table.getRightHeaderGroups()[0]) == null ? void 0 : _table$getRightHeader2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getRightHeader : 0;
        };
    }
};
let $ff62fbff81e95ce8$var$passiveSupported = null;
function $ff62fbff81e95ce8$export$4927b5943c7c0b4() {
    if (typeof $ff62fbff81e95ce8$var$passiveSupported === "boolean") return $ff62fbff81e95ce8$var$passiveSupported;
    let supported = false;
    try {
        const options = {
            get passive () {
                supported = true;
                return false;
            }
        };
        const noop = ()=>{};
        window.addEventListener("test", noop, options);
        window.removeEventListener("test", noop);
    } catch (err) {
        supported = false;
    }
    $ff62fbff81e95ce8$var$passiveSupported = supported;
    return $ff62fbff81e95ce8$var$passiveSupported;
}
function $ff62fbff81e95ce8$var$isTouchStartEvent(e) {
    return e.type === "touchstart";
}
//
const $ff62fbff81e95ce8$export$be5545a32e20d889 = {
    getInitialState: (state)=>{
        return {
            columnVisibility: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnVisibilityChange: $ff62fbff81e95ce8$export$2b5605d8069324bd("columnVisibility", table)
        };
    },
    createColumn: (column, table)=>{
        column.toggleVisibility = (value)=>{
            if (column.getCanHide()) table.setColumnVisibility((old)=>({
                    ...old,
                    [column.id]: value != null ? value : !column.getIsVisible()
                }));
        };
        column.getIsVisible = ()=>{
            var _ref, _table$getState$colum;
            const childColumns = column.columns;
            return (_ref = childColumns.length ? childColumns.some((c)=>c.getIsVisible()) : (_table$getState$colum = table.getState().columnVisibility) == null ? void 0 : _table$getState$colum[column.id]) != null ? _ref : true;
        };
        column.getCanHide = ()=>{
            var _column$columnDef$ena, _table$options$enable;
            return ((_column$columnDef$ena = column.columnDef.enableHiding) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableHiding) != null ? _table$options$enable : true);
        };
        column.getToggleVisibilityHandler = ()=>{
            return (e)=>{
                column.toggleVisibility == null || column.toggleVisibility(e.target.checked);
            };
        };
    },
    createRow: (row, table)=>{
        row._getAllVisibleCells = $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                row.getAllCells(),
                table.getState().columnVisibility
            ], (cells)=>{
            return cells.filter((cell)=>cell.column.getIsVisible());
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, "debugRows", "_getAllVisibleCells"));
        row.getVisibleCells = $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                row.getLeftVisibleCells(),
                row.getCenterVisibleCells(),
                row.getRightVisibleCells()
            ], (left, center, right)=>[
                ...left,
                ...center,
                ...right
            ], $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, "debugRows", "getVisibleCells"));
    },
    createTable: (table)=>{
        const makeVisibleColumnsMethod = (key, getColumns)=>{
            return $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                    getColumns(),
                    getColumns().filter((d)=>d.getIsVisible()).map((d)=>d.id).join("_")
                ], (columns)=>{
                return columns.filter((d)=>d.getIsVisible == null ? void 0 : d.getIsVisible());
            }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, "debugColumns", key));
        };
        table.getVisibleFlatColumns = makeVisibleColumnsMethod("getVisibleFlatColumns", ()=>table.getAllFlatColumns());
        table.getVisibleLeafColumns = makeVisibleColumnsMethod("getVisibleLeafColumns", ()=>table.getAllLeafColumns());
        table.getLeftVisibleLeafColumns = makeVisibleColumnsMethod("getLeftVisibleLeafColumns", ()=>table.getLeftLeafColumns());
        table.getRightVisibleLeafColumns = makeVisibleColumnsMethod("getRightVisibleLeafColumns", ()=>table.getRightLeafColumns());
        table.getCenterVisibleLeafColumns = makeVisibleColumnsMethod("getCenterVisibleLeafColumns", ()=>table.getCenterLeafColumns());
        table.setColumnVisibility = (updater)=>table.options.onColumnVisibilityChange == null ? void 0 : table.options.onColumnVisibilityChange(updater);
        table.resetColumnVisibility = (defaultState)=>{
            var _table$initialState$c;
            table.setColumnVisibility(defaultState ? {} : (_table$initialState$c = table.initialState.columnVisibility) != null ? _table$initialState$c : {});
        };
        table.toggleAllColumnsVisible = (value)=>{
            var _value;
            value = (_value = value) != null ? _value : !table.getIsAllColumnsVisible();
            table.setColumnVisibility(table.getAllLeafColumns().reduce((obj, column)=>({
                    ...obj,
                    [column.id]: !value ? !(column.getCanHide != null && column.getCanHide()) : value
                }), {}));
        };
        table.getIsAllColumnsVisible = ()=>!table.getAllLeafColumns().some((column)=>!(column.getIsVisible != null && column.getIsVisible()));
        table.getIsSomeColumnsVisible = ()=>table.getAllLeafColumns().some((column)=>column.getIsVisible == null ? void 0 : column.getIsVisible());
        table.getToggleAllColumnsVisibilityHandler = ()=>{
            return (e)=>{
                var _target;
                table.toggleAllColumnsVisible((_target = e.target) == null ? void 0 : _target.checked);
            };
        };
    }
};
function $ff62fbff81e95ce8$export$1d7c103713892a11(table, position) {
    return !position ? table.getVisibleLeafColumns() : position === "center" ? table.getCenterVisibleLeafColumns() : position === "left" ? table.getLeftVisibleLeafColumns() : table.getRightVisibleLeafColumns();
}
//
const $ff62fbff81e95ce8$export$4b37edcdc7ad2fe1 = {
    createTable: (table)=>{
        table._getGlobalFacetedRowModel = table.options.getFacetedRowModel && table.options.getFacetedRowModel(table, "__global__");
        table.getGlobalFacetedRowModel = ()=>{
            if (table.options.manualFiltering || !table._getGlobalFacetedRowModel) return table.getPreFilteredRowModel();
            return table._getGlobalFacetedRowModel();
        };
        table._getGlobalFacetedUniqueValues = table.options.getFacetedUniqueValues && table.options.getFacetedUniqueValues(table, "__global__");
        table.getGlobalFacetedUniqueValues = ()=>{
            if (!table._getGlobalFacetedUniqueValues) return new Map();
            return table._getGlobalFacetedUniqueValues();
        };
        table._getGlobalFacetedMinMaxValues = table.options.getFacetedMinMaxValues && table.options.getFacetedMinMaxValues(table, "__global__");
        table.getGlobalFacetedMinMaxValues = ()=>{
            if (!table._getGlobalFacetedMinMaxValues) return;
            return table._getGlobalFacetedMinMaxValues();
        };
    }
};
//
const $ff62fbff81e95ce8$export$61e9e0661ff79b1c = {
    getInitialState: (state)=>{
        return {
            globalFilter: undefined,
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onGlobalFilterChange: $ff62fbff81e95ce8$export$2b5605d8069324bd("globalFilter", table),
            globalFilterFn: "auto",
            getColumnCanGlobalFilter: (column)=>{
                var _table$getCoreRowMode;
                const value = (_table$getCoreRowMode = table.getCoreRowModel().flatRows[0]) == null || (_table$getCoreRowMode = _table$getCoreRowMode._getAllCellsByColumnId()[column.id]) == null ? void 0 : _table$getCoreRowMode.getValue();
                return typeof value === "string" || typeof value === "number";
            }
        };
    },
    createColumn: (column, table)=>{
        column.getCanGlobalFilter = ()=>{
            var _column$columnDef$ena, _table$options$enable, _table$options$enable2, _table$options$getCol;
            return ((_column$columnDef$ena = column.columnDef.enableGlobalFilter) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableGlobalFilter) != null ? _table$options$enable : true) && ((_table$options$enable2 = table.options.enableFilters) != null ? _table$options$enable2 : true) && ((_table$options$getCol = table.options.getColumnCanGlobalFilter == null ? void 0 : table.options.getColumnCanGlobalFilter(column)) != null ? _table$options$getCol : true) && !!column.accessorFn;
        };
    },
    createTable: (table)=>{
        table.getGlobalAutoFilterFn = ()=>{
            return $ff62fbff81e95ce8$export$6ad8312e296ec316.includesString;
        };
        table.getGlobalFilterFn = ()=>{
            var _table$options$filter, _table$options$filter2;
            const { globalFilterFn: globalFilterFn } = table.options;
            return $ff62fbff81e95ce8$export$f6e2535fb5126e54(globalFilterFn) ? globalFilterFn : globalFilterFn === "auto" ? table.getGlobalAutoFilterFn() : (_table$options$filter = (_table$options$filter2 = table.options.filterFns) == null ? void 0 : _table$options$filter2[globalFilterFn]) != null ? _table$options$filter : $ff62fbff81e95ce8$export$6ad8312e296ec316[globalFilterFn];
        };
        table.setGlobalFilter = (updater)=>{
            table.options.onGlobalFilterChange == null || table.options.onGlobalFilterChange(updater);
        };
        table.resetGlobalFilter = (defaultState)=>{
            table.setGlobalFilter(defaultState ? undefined : table.initialState.globalFilter);
        };
    }
};
//
const $ff62fbff81e95ce8$export$fed54e0d64c17fb2 = {
    getInitialState: (state)=>{
        return {
            expanded: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onExpandedChange: $ff62fbff81e95ce8$export$2b5605d8069324bd("expanded", table),
            paginateExpandedRows: true
        };
    },
    createTable: (table)=>{
        let registered = false;
        let queued = false;
        table._autoResetExpanded = ()=>{
            var _ref, _table$options$autoRe;
            if (!registered) {
                table._queue(()=>{
                    registered = true;
                });
                return;
            }
            if ((_ref = (_table$options$autoRe = table.options.autoResetAll) != null ? _table$options$autoRe : table.options.autoResetExpanded) != null ? _ref : !table.options.manualExpanding) {
                if (queued) return;
                queued = true;
                table._queue(()=>{
                    table.resetExpanded();
                    queued = false;
                });
            }
        };
        table.setExpanded = (updater)=>table.options.onExpandedChange == null ? void 0 : table.options.onExpandedChange(updater);
        table.toggleAllRowsExpanded = (expanded)=>{
            if (expanded != null ? expanded : !table.getIsAllRowsExpanded()) table.setExpanded(true);
            else table.setExpanded({});
        };
        table.resetExpanded = (defaultState)=>{
            var _table$initialState$e, _table$initialState;
            table.setExpanded(defaultState ? {} : (_table$initialState$e = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.expanded) != null ? _table$initialState$e : {});
        };
        table.getCanSomeRowsExpand = ()=>{
            return table.getPrePaginationRowModel().flatRows.some((row)=>row.getCanExpand());
        };
        table.getToggleAllRowsExpandedHandler = ()=>{
            return (e)=>{
                e.persist == null || e.persist();
                table.toggleAllRowsExpanded();
            };
        };
        table.getIsSomeRowsExpanded = ()=>{
            const expanded = table.getState().expanded;
            return expanded === true || Object.values(expanded).some(Boolean);
        };
        table.getIsAllRowsExpanded = ()=>{
            const expanded = table.getState().expanded;
            // If expanded is true, save some cycles and return true
            if (typeof expanded === "boolean") return expanded === true;
            if (!Object.keys(expanded).length) return false;
            // If any row is not expanded, return false
            if (table.getRowModel().flatRows.some((row)=>!row.getIsExpanded())) return false;
            // They must all be expanded :shrug:
            return true;
        };
        table.getExpandedDepth = ()=>{
            let maxDepth = 0;
            const rowIds = table.getState().expanded === true ? Object.keys(table.getRowModel().rowsById) : Object.keys(table.getState().expanded);
            rowIds.forEach((id)=>{
                const splitId = id.split(".");
                maxDepth = Math.max(maxDepth, splitId.length);
            });
            return maxDepth;
        };
        table.getPreExpandedRowModel = ()=>table.getSortedRowModel();
        table.getExpandedRowModel = ()=>{
            if (!table._getExpandedRowModel && table.options.getExpandedRowModel) table._getExpandedRowModel = table.options.getExpandedRowModel(table);
            if (table.options.manualExpanding || !table._getExpandedRowModel) return table.getPreExpandedRowModel();
            return table._getExpandedRowModel();
        };
    },
    createRow: (row, table)=>{
        row.toggleExpanded = (expanded)=>{
            table.setExpanded((old)=>{
                var _expanded;
                const exists = old === true ? true : !!(old != null && old[row.id]);
                let oldExpanded = {};
                if (old === true) Object.keys(table.getRowModel().rowsById).forEach((rowId)=>{
                    oldExpanded[rowId] = true;
                });
                else oldExpanded = old;
                expanded = (_expanded = expanded) != null ? _expanded : !exists;
                if (!exists && expanded) return {
                    ...oldExpanded,
                    [row.id]: true
                };
                if (exists && !expanded) {
                    const { [row.id]: _, ...rest } = oldExpanded;
                    return rest;
                }
                return old;
            });
        };
        row.getIsExpanded = ()=>{
            var _table$options$getIsR;
            const expanded = table.getState().expanded;
            return !!((_table$options$getIsR = table.options.getIsRowExpanded == null ? void 0 : table.options.getIsRowExpanded(row)) != null ? _table$options$getIsR : expanded === true || (expanded == null ? void 0 : expanded[row.id]));
        };
        row.getCanExpand = ()=>{
            var _table$options$getRow, _table$options$enable, _row$subRows;
            return (_table$options$getRow = table.options.getRowCanExpand == null ? void 0 : table.options.getRowCanExpand(row)) != null ? _table$options$getRow : ((_table$options$enable = table.options.enableExpanding) != null ? _table$options$enable : true) && !!((_row$subRows = row.subRows) != null && _row$subRows.length);
        };
        row.getIsAllParentsExpanded = ()=>{
            let isFullyExpanded = true;
            let currentRow = row;
            while(isFullyExpanded && currentRow.parentId){
                currentRow = table.getRow(currentRow.parentId, true);
                isFullyExpanded = currentRow.getIsExpanded();
            }
            return isFullyExpanded;
        };
        row.getToggleExpandedHandler = ()=>{
            const canExpand = row.getCanExpand();
            return ()=>{
                if (!canExpand) return;
                row.toggleExpanded();
            };
        };
    }
};
//
const $ff62fbff81e95ce8$var$defaultPageIndex = 0;
const $ff62fbff81e95ce8$var$defaultPageSize = 10;
const $ff62fbff81e95ce8$var$getDefaultPaginationState = ()=>({
        pageIndex: $ff62fbff81e95ce8$var$defaultPageIndex,
        pageSize: $ff62fbff81e95ce8$var$defaultPageSize
    });
const $ff62fbff81e95ce8$export$bce540641752d22b = {
    getInitialState: (state)=>{
        return {
            ...state,
            pagination: {
                ...$ff62fbff81e95ce8$var$getDefaultPaginationState(),
                ...state == null ? void 0 : state.pagination
            }
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onPaginationChange: $ff62fbff81e95ce8$export$2b5605d8069324bd("pagination", table)
        };
    },
    createTable: (table)=>{
        let registered = false;
        let queued = false;
        table._autoResetPageIndex = ()=>{
            var _ref, _table$options$autoRe;
            if (!registered) {
                table._queue(()=>{
                    registered = true;
                });
                return;
            }
            if ((_ref = (_table$options$autoRe = table.options.autoResetAll) != null ? _table$options$autoRe : table.options.autoResetPageIndex) != null ? _ref : !table.options.manualPagination) {
                if (queued) return;
                queued = true;
                table._queue(()=>{
                    table.resetPageIndex();
                    queued = false;
                });
            }
        };
        table.setPagination = (updater)=>{
            const safeUpdater = (old)=>{
                let newState = $ff62fbff81e95ce8$export$7f095f455ad5af3f(updater, old);
                return newState;
            };
            return table.options.onPaginationChange == null ? void 0 : table.options.onPaginationChange(safeUpdater);
        };
        table.resetPagination = (defaultState)=>{
            var _table$initialState$p;
            table.setPagination(defaultState ? $ff62fbff81e95ce8$var$getDefaultPaginationState() : (_table$initialState$p = table.initialState.pagination) != null ? _table$initialState$p : $ff62fbff81e95ce8$var$getDefaultPaginationState());
        };
        table.setPageIndex = (updater)=>{
            table.setPagination((old)=>{
                let pageIndex = $ff62fbff81e95ce8$export$7f095f455ad5af3f(updater, old.pageIndex);
                const maxPageIndex = typeof table.options.pageCount === "undefined" || table.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : table.options.pageCount - 1;
                pageIndex = Math.max(0, Math.min(pageIndex, maxPageIndex));
                return {
                    ...old,
                    pageIndex: pageIndex
                };
            });
        };
        table.resetPageIndex = (defaultState)=>{
            var _table$initialState$p2, _table$initialState;
            table.setPageIndex(defaultState ? $ff62fbff81e95ce8$var$defaultPageIndex : (_table$initialState$p2 = (_table$initialState = table.initialState) == null || (_table$initialState = _table$initialState.pagination) == null ? void 0 : _table$initialState.pageIndex) != null ? _table$initialState$p2 : $ff62fbff81e95ce8$var$defaultPageIndex);
        };
        table.resetPageSize = (defaultState)=>{
            var _table$initialState$p3, _table$initialState2;
            table.setPageSize(defaultState ? $ff62fbff81e95ce8$var$defaultPageSize : (_table$initialState$p3 = (_table$initialState2 = table.initialState) == null || (_table$initialState2 = _table$initialState2.pagination) == null ? void 0 : _table$initialState2.pageSize) != null ? _table$initialState$p3 : $ff62fbff81e95ce8$var$defaultPageSize);
        };
        table.setPageSize = (updater)=>{
            table.setPagination((old)=>{
                const pageSize = Math.max(1, $ff62fbff81e95ce8$export$7f095f455ad5af3f(updater, old.pageSize));
                const topRowIndex = old.pageSize * old.pageIndex;
                const pageIndex = Math.floor(topRowIndex / pageSize);
                return {
                    ...old,
                    pageIndex: pageIndex,
                    pageSize: pageSize
                };
            });
        };
        //deprecated
        table.setPageCount = (updater)=>table.setPagination((old)=>{
                var _table$options$pageCo;
                let newPageCount = $ff62fbff81e95ce8$export$7f095f455ad5af3f(updater, (_table$options$pageCo = table.options.pageCount) != null ? _table$options$pageCo : -1);
                if (typeof newPageCount === "number") newPageCount = Math.max(-1, newPageCount);
                return {
                    ...old,
                    pageCount: newPageCount
                };
            });
        table.getPageOptions = $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table.getPageCount()
            ], (pageCount)=>{
            let pageOptions = [];
            if (pageCount && pageCount > 0) pageOptions = [
                ...new Array(pageCount)
            ].fill(null).map((_, i)=>i);
            return pageOptions;
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, "debugTable", "getPageOptions"));
        table.getCanPreviousPage = ()=>table.getState().pagination.pageIndex > 0;
        table.getCanNextPage = ()=>{
            const { pageIndex: pageIndex } = table.getState().pagination;
            const pageCount = table.getPageCount();
            if (pageCount === -1) return true;
            if (pageCount === 0) return false;
            return pageIndex < pageCount - 1;
        };
        table.previousPage = ()=>{
            return table.setPageIndex((old)=>old - 1);
        };
        table.nextPage = ()=>{
            return table.setPageIndex((old)=>{
                return old + 1;
            });
        };
        table.firstPage = ()=>{
            return table.setPageIndex(0);
        };
        table.lastPage = ()=>{
            return table.setPageIndex(table.getPageCount() - 1);
        };
        table.getPrePaginationRowModel = ()=>table.getExpandedRowModel();
        table.getPaginationRowModel = ()=>{
            if (!table._getPaginationRowModel && table.options.getPaginationRowModel) table._getPaginationRowModel = table.options.getPaginationRowModel(table);
            if (table.options.manualPagination || !table._getPaginationRowModel) return table.getPrePaginationRowModel();
            return table._getPaginationRowModel();
        };
        table.getPageCount = ()=>{
            var _table$options$pageCo2;
            return (_table$options$pageCo2 = table.options.pageCount) != null ? _table$options$pageCo2 : Math.ceil(table.getRowCount() / table.getState().pagination.pageSize);
        };
        table.getRowCount = ()=>{
            var _table$options$rowCou;
            return (_table$options$rowCou = table.options.rowCount) != null ? _table$options$rowCou : table.getPrePaginationRowModel().rows.length;
        };
    }
};
//
const $ff62fbff81e95ce8$var$getDefaultRowPinningState = ()=>({
        top: [],
        bottom: []
    });
const $ff62fbff81e95ce8$export$213d72cb2ac7d440 = {
    getInitialState: (state)=>{
        return {
            rowPinning: $ff62fbff81e95ce8$var$getDefaultRowPinningState(),
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onRowPinningChange: $ff62fbff81e95ce8$export$2b5605d8069324bd("rowPinning", table)
        };
    },
    createRow: (row, table)=>{
        row.pin = (position, includeLeafRows, includeParentRows)=>{
            const leafRowIds = includeLeafRows ? row.getLeafRows().map((_ref)=>{
                let { id: id } = _ref;
                return id;
            }) : [];
            const parentRowIds = includeParentRows ? row.getParentRows().map((_ref2)=>{
                let { id: id } = _ref2;
                return id;
            }) : [];
            const rowIds = new Set([
                ...parentRowIds,
                row.id,
                ...leafRowIds
            ]);
            table.setRowPinning((old)=>{
                var _old$top3, _old$bottom3;
                if (position === "bottom") {
                    var _old$top, _old$bottom;
                    return {
                        top: ((_old$top = old == null ? void 0 : old.top) != null ? _old$top : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                        bottom: [
                            ...((_old$bottom = old == null ? void 0 : old.bottom) != null ? _old$bottom : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                            ...Array.from(rowIds)
                        ]
                    };
                }
                if (position === "top") {
                    var _old$top2, _old$bottom2;
                    return {
                        top: [
                            ...((_old$top2 = old == null ? void 0 : old.top) != null ? _old$top2 : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                            ...Array.from(rowIds)
                        ],
                        bottom: ((_old$bottom2 = old == null ? void 0 : old.bottom) != null ? _old$bottom2 : []).filter((d)=>!(rowIds != null && rowIds.has(d)))
                    };
                }
                return {
                    top: ((_old$top3 = old == null ? void 0 : old.top) != null ? _old$top3 : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                    bottom: ((_old$bottom3 = old == null ? void 0 : old.bottom) != null ? _old$bottom3 : []).filter((d)=>!(rowIds != null && rowIds.has(d)))
                };
            });
        };
        row.getCanPin = ()=>{
            var _ref3;
            const { enableRowPinning: enableRowPinning, enablePinning: enablePinning } = table.options;
            if (typeof enableRowPinning === "function") return enableRowPinning(row);
            return (_ref3 = enableRowPinning != null ? enableRowPinning : enablePinning) != null ? _ref3 : true;
        };
        row.getIsPinned = ()=>{
            const rowIds = [
                row.id
            ];
            const { top: top, bottom: bottom } = table.getState().rowPinning;
            const isTop = rowIds.some((d)=>top == null ? void 0 : top.includes(d));
            const isBottom = rowIds.some((d)=>bottom == null ? void 0 : bottom.includes(d));
            return isTop ? "top" : isBottom ? "bottom" : false;
        };
        row.getPinnedIndex = ()=>{
            var _ref4, _visiblePinnedRowIds$;
            const position = row.getIsPinned();
            if (!position) return -1;
            const visiblePinnedRowIds = (_ref4 = position === "top" ? table.getTopRows() : table.getBottomRows()) == null ? void 0 : _ref4.map((_ref5)=>{
                let { id: id } = _ref5;
                return id;
            });
            return (_visiblePinnedRowIds$ = visiblePinnedRowIds == null ? void 0 : visiblePinnedRowIds.indexOf(row.id)) != null ? _visiblePinnedRowIds$ : -1;
        };
    },
    createTable: (table)=>{
        table.setRowPinning = (updater)=>table.options.onRowPinningChange == null ? void 0 : table.options.onRowPinningChange(updater);
        table.resetRowPinning = (defaultState)=>{
            var _table$initialState$r, _table$initialState;
            return table.setRowPinning(defaultState ? $ff62fbff81e95ce8$var$getDefaultRowPinningState() : (_table$initialState$r = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.rowPinning) != null ? _table$initialState$r : $ff62fbff81e95ce8$var$getDefaultRowPinningState());
        };
        table.getIsSomeRowsPinned = (position)=>{
            var _pinningState$positio;
            const pinningState = table.getState().rowPinning;
            if (!position) {
                var _pinningState$top, _pinningState$bottom;
                return Boolean(((_pinningState$top = pinningState.top) == null ? void 0 : _pinningState$top.length) || ((_pinningState$bottom = pinningState.bottom) == null ? void 0 : _pinningState$bottom.length));
            }
            return Boolean((_pinningState$positio = pinningState[position]) == null ? void 0 : _pinningState$positio.length);
        };
        table._getPinnedRows = (visibleRows, pinnedRowIds, position)=>{
            var _table$options$keepPi;
            const rows = ((_table$options$keepPi = table.options.keepPinnedRows) != null ? _table$options$keepPi : true) ? //get all rows that are pinned even if they would not be otherwise visible
            //account for expanded parent rows, but not pagination or filtering
            (pinnedRowIds != null ? pinnedRowIds : []).map((rowId)=>{
                const row = table.getRow(rowId, true);
                return row.getIsAllParentsExpanded() ? row : null;
            }) : //else get only visible rows that are pinned
            (pinnedRowIds != null ? pinnedRowIds : []).map((rowId)=>visibleRows.find((row)=>row.id === rowId));
            return rows.filter(Boolean).map((d)=>({
                    ...d,
                    position: position
                }));
        };
        table.getTopRows = $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table.getRowModel().rows,
                table.getState().rowPinning.top
            ], (allRows, topPinnedRowIds)=>table._getPinnedRows(allRows, topPinnedRowIds, "top"), $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, "debugRows", "getTopRows"));
        table.getBottomRows = $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table.getRowModel().rows,
                table.getState().rowPinning.bottom
            ], (allRows, bottomPinnedRowIds)=>table._getPinnedRows(allRows, bottomPinnedRowIds, "bottom"), $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, "debugRows", "getBottomRows"));
        table.getCenterRows = $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table.getRowModel().rows,
                table.getState().rowPinning.top,
                table.getState().rowPinning.bottom
            ], (allRows, top, bottom)=>{
            const topAndBottom = new Set([
                ...top != null ? top : [],
                ...bottom != null ? bottom : []
            ]);
            return allRows.filter((d)=>!topAndBottom.has(d.id));
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, "debugRows", "getCenterRows"));
    }
};
//
const $ff62fbff81e95ce8$export$e8905133e7bf3121 = {
    getInitialState: (state)=>{
        return {
            rowSelection: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onRowSelectionChange: $ff62fbff81e95ce8$export$2b5605d8069324bd("rowSelection", table),
            enableRowSelection: true,
            enableMultiRowSelection: true,
            enableSubRowSelection: true
        };
    },
    createTable: (table)=>{
        table.setRowSelection = (updater)=>table.options.onRowSelectionChange == null ? void 0 : table.options.onRowSelectionChange(updater);
        table.resetRowSelection = (defaultState)=>{
            var _table$initialState$r;
            return table.setRowSelection(defaultState ? {} : (_table$initialState$r = table.initialState.rowSelection) != null ? _table$initialState$r : {});
        };
        table.toggleAllRowsSelected = (value)=>{
            table.setRowSelection((old)=>{
                value = typeof value !== "undefined" ? value : !table.getIsAllRowsSelected();
                const rowSelection = {
                    ...old
                };
                const preGroupedFlatRows = table.getPreGroupedRowModel().flatRows;
                // We don't use `mutateRowIsSelected` here for performance reasons.
                // All of the rows are flat already, so it wouldn't be worth it
                if (value) preGroupedFlatRows.forEach((row)=>{
                    if (!row.getCanSelect()) return;
                    rowSelection[row.id] = true;
                });
                else preGroupedFlatRows.forEach((row)=>{
                    delete rowSelection[row.id];
                });
                return rowSelection;
            });
        };
        table.toggleAllPageRowsSelected = (value)=>table.setRowSelection((old)=>{
                const resolvedValue = typeof value !== "undefined" ? value : !table.getIsAllPageRowsSelected();
                const rowSelection = {
                    ...old
                };
                table.getRowModel().rows.forEach((row)=>{
                    $ff62fbff81e95ce8$var$mutateRowIsSelected(rowSelection, row.id, resolvedValue, true, table);
                });
                return rowSelection;
            });
        // addRowSelectionRange: rowId => {
        //   const {
        //     rows,
        //     rowsById,
        //     options: { selectGroupingRows, selectSubRows },
        //   } = table
        //   const findSelectedRow = (rows: Row[]) => {
        //     let found
        //     rows.find(d => {
        //       if (d.getIsSelected()) {
        //         found = d
        //         return true
        //       }
        //       const subFound = findSelectedRow(d.subRows || [])
        //       if (subFound) {
        //         found = subFound
        //         return true
        //       }
        //       return false
        //     })
        //     return found
        //   }
        //   const firstRow = findSelectedRow(rows) || rows[0]
        //   const lastRow = rowsById[rowId]
        //   let include = false
        //   const selectedRowIds = {}
        //   const addRow = (row: Row) => {
        //     mutateRowIsSelected(selectedRowIds, row.id, true, {
        //       rowsById,
        //       selectGroupingRows: selectGroupingRows!,
        //       selectSubRows: selectSubRows!,
        //     })
        //   }
        //   table.rows.forEach(row => {
        //     const isFirstRow = row.id === firstRow.id
        //     const isLastRow = row.id === lastRow.id
        //     if (isFirstRow || isLastRow) {
        //       if (!include) {
        //         include = true
        //       } else if (include) {
        //         addRow(row)
        //         include = false
        //       }
        //     }
        //     if (include) {
        //       addRow(row)
        //     }
        //   })
        //   table.setRowSelection(selectedRowIds)
        // },
        table.getPreSelectedRowModel = ()=>table.getCoreRowModel();
        table.getSelectedRowModel = $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table.getState().rowSelection,
                table.getCoreRowModel()
            ], (rowSelection, rowModel)=>{
            if (!Object.keys(rowSelection).length) return {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            return $ff62fbff81e95ce8$export$f150e72530556b0b(table, rowModel);
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, "debugTable", "getSelectedRowModel"));
        table.getFilteredSelectedRowModel = $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table.getState().rowSelection,
                table.getFilteredRowModel()
            ], (rowSelection, rowModel)=>{
            if (!Object.keys(rowSelection).length) return {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            return $ff62fbff81e95ce8$export$f150e72530556b0b(table, rowModel);
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, "debugTable", "getFilteredSelectedRowModel"));
        table.getGroupedSelectedRowModel = $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table.getState().rowSelection,
                table.getSortedRowModel()
            ], (rowSelection, rowModel)=>{
            if (!Object.keys(rowSelection).length) return {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            return $ff62fbff81e95ce8$export$f150e72530556b0b(table, rowModel);
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, "debugTable", "getGroupedSelectedRowModel"));
        ///
        // getGroupingRowCanSelect: rowId => {
        //   const row = table.getRow(rowId)
        //   if (!row) {
        //     throw new Error()
        //   }
        //   if (typeof table.options.enableGroupingRowSelection === 'function') {
        //     return table.options.enableGroupingRowSelection(row)
        //   }
        //   return table.options.enableGroupingRowSelection ?? false
        // },
        table.getIsAllRowsSelected = ()=>{
            const preGroupedFlatRows = table.getFilteredRowModel().flatRows;
            const { rowSelection: rowSelection } = table.getState();
            let isAllRowsSelected = Boolean(preGroupedFlatRows.length && Object.keys(rowSelection).length);
            if (isAllRowsSelected) {
                if (preGroupedFlatRows.some((row)=>row.getCanSelect() && !rowSelection[row.id])) isAllRowsSelected = false;
            }
            return isAllRowsSelected;
        };
        table.getIsAllPageRowsSelected = ()=>{
            const paginationFlatRows = table.getPaginationRowModel().flatRows.filter((row)=>row.getCanSelect());
            const { rowSelection: rowSelection } = table.getState();
            let isAllPageRowsSelected = !!paginationFlatRows.length;
            if (isAllPageRowsSelected && paginationFlatRows.some((row)=>!rowSelection[row.id])) isAllPageRowsSelected = false;
            return isAllPageRowsSelected;
        };
        table.getIsSomeRowsSelected = ()=>{
            var _table$getState$rowSe;
            const totalSelected = Object.keys((_table$getState$rowSe = table.getState().rowSelection) != null ? _table$getState$rowSe : {}).length;
            return totalSelected > 0 && totalSelected < table.getFilteredRowModel().flatRows.length;
        };
        table.getIsSomePageRowsSelected = ()=>{
            const paginationFlatRows = table.getPaginationRowModel().flatRows;
            return table.getIsAllPageRowsSelected() ? false : paginationFlatRows.filter((row)=>row.getCanSelect()).some((d)=>d.getIsSelected() || d.getIsSomeSelected());
        };
        table.getToggleAllRowsSelectedHandler = ()=>{
            return (e)=>{
                table.toggleAllRowsSelected(e.target.checked);
            };
        };
        table.getToggleAllPageRowsSelectedHandler = ()=>{
            return (e)=>{
                table.toggleAllPageRowsSelected(e.target.checked);
            };
        };
    },
    createRow: (row, table)=>{
        row.toggleSelected = (value, opts)=>{
            const isSelected = row.getIsSelected();
            table.setRowSelection((old)=>{
                var _opts$selectChildren;
                value = typeof value !== "undefined" ? value : !isSelected;
                if (row.getCanSelect() && isSelected === value) return old;
                const selectedRowIds = {
                    ...old
                };
                $ff62fbff81e95ce8$var$mutateRowIsSelected(selectedRowIds, row.id, value, (_opts$selectChildren = opts == null ? void 0 : opts.selectChildren) != null ? _opts$selectChildren : true, table);
                return selectedRowIds;
            });
        };
        row.getIsSelected = ()=>{
            const { rowSelection: rowSelection } = table.getState();
            return $ff62fbff81e95ce8$export$710e11cf672b86c(row, rowSelection);
        };
        row.getIsSomeSelected = ()=>{
            const { rowSelection: rowSelection } = table.getState();
            return $ff62fbff81e95ce8$export$8f4c46e5d7907334(row, rowSelection) === "some";
        };
        row.getIsAllSubRowsSelected = ()=>{
            const { rowSelection: rowSelection } = table.getState();
            return $ff62fbff81e95ce8$export$8f4c46e5d7907334(row, rowSelection) === "all";
        };
        row.getCanSelect = ()=>{
            var _table$options$enable;
            if (typeof table.options.enableRowSelection === "function") return table.options.enableRowSelection(row);
            return (_table$options$enable = table.options.enableRowSelection) != null ? _table$options$enable : true;
        };
        row.getCanSelectSubRows = ()=>{
            var _table$options$enable2;
            if (typeof table.options.enableSubRowSelection === "function") return table.options.enableSubRowSelection(row);
            return (_table$options$enable2 = table.options.enableSubRowSelection) != null ? _table$options$enable2 : true;
        };
        row.getCanMultiSelect = ()=>{
            var _table$options$enable3;
            if (typeof table.options.enableMultiRowSelection === "function") return table.options.enableMultiRowSelection(row);
            return (_table$options$enable3 = table.options.enableMultiRowSelection) != null ? _table$options$enable3 : true;
        };
        row.getToggleSelectedHandler = ()=>{
            const canSelect = row.getCanSelect();
            return (e)=>{
                var _target;
                if (!canSelect) return;
                row.toggleSelected((_target = e.target) == null ? void 0 : _target.checked);
            };
        };
    }
};
const $ff62fbff81e95ce8$var$mutateRowIsSelected = (selectedRowIds, id, value, includeChildren, table)=>{
    var _row$subRows;
    const row = table.getRow(id, true);
    // const isGrouped = row.getIsGrouped()
    // if ( // TODO: enforce grouping row selection rules
    //   !isGrouped ||
    //   (isGrouped && table.options.enableGroupingRowSelection)
    // ) {
    if (value) {
        if (!row.getCanMultiSelect()) Object.keys(selectedRowIds).forEach((key)=>delete selectedRowIds[key]);
        if (row.getCanSelect()) selectedRowIds[id] = true;
    } else delete selectedRowIds[id];
    // }
    if (includeChildren && (_row$subRows = row.subRows) != null && _row$subRows.length && row.getCanSelectSubRows()) row.subRows.forEach((row)=>$ff62fbff81e95ce8$var$mutateRowIsSelected(selectedRowIds, row.id, value, includeChildren, table));
};
function $ff62fbff81e95ce8$export$f150e72530556b0b(table, rowModel) {
    const rowSelection = table.getState().rowSelection;
    const newSelectedFlatRows = [];
    const newSelectedRowsById = {};
    // Filters top level and nested rows
    const recurseRows = function(rows, depth) {
        return rows.map((row)=>{
            var _row$subRows2;
            const isSelected = $ff62fbff81e95ce8$export$710e11cf672b86c(row, rowSelection);
            if (isSelected) {
                newSelectedFlatRows.push(row);
                newSelectedRowsById[row.id] = row;
            }
            if ((_row$subRows2 = row.subRows) != null && _row$subRows2.length) row = {
                ...row,
                subRows: recurseRows(row.subRows)
            };
            if (isSelected) return row;
        }).filter(Boolean);
    };
    return {
        rows: recurseRows(rowModel.rows),
        flatRows: newSelectedFlatRows,
        rowsById: newSelectedRowsById
    };
}
function $ff62fbff81e95ce8$export$710e11cf672b86c(row, selection) {
    var _selection$row$id;
    return (_selection$row$id = selection[row.id]) != null ? _selection$row$id : false;
}
function $ff62fbff81e95ce8$export$8f4c46e5d7907334(row, selection, table) {
    var _row$subRows3;
    if (!((_row$subRows3 = row.subRows) != null && _row$subRows3.length)) return false;
    let allChildrenSelected = true;
    let someSelected = false;
    row.subRows.forEach((subRow)=>{
        // Bail out early if we know both of these
        if (someSelected && !allChildrenSelected) return;
        if (subRow.getCanSelect()) {
            if ($ff62fbff81e95ce8$export$710e11cf672b86c(subRow, selection)) someSelected = true;
            else allChildrenSelected = false;
        }
        // Check row selection of nested subrows
        if (subRow.subRows && subRow.subRows.length) {
            const subRowChildrenSelected = $ff62fbff81e95ce8$export$8f4c46e5d7907334(subRow, selection);
            if (subRowChildrenSelected === "all") someSelected = true;
            else if (subRowChildrenSelected === "some") {
                someSelected = true;
                allChildrenSelected = false;
            } else allChildrenSelected = false;
        }
    });
    return allChildrenSelected ? "all" : someSelected ? "some" : false;
}
const $ff62fbff81e95ce8$export$8758689f50bddb9f = /([0-9]+)/gm;
const $ff62fbff81e95ce8$var$alphanumeric = (rowA, rowB, columnId)=>{
    return $ff62fbff81e95ce8$var$compareAlphanumeric($ff62fbff81e95ce8$var$toString(rowA.getValue(columnId)).toLowerCase(), $ff62fbff81e95ce8$var$toString(rowB.getValue(columnId)).toLowerCase());
};
const $ff62fbff81e95ce8$var$alphanumericCaseSensitive = (rowA, rowB, columnId)=>{
    return $ff62fbff81e95ce8$var$compareAlphanumeric($ff62fbff81e95ce8$var$toString(rowA.getValue(columnId)), $ff62fbff81e95ce8$var$toString(rowB.getValue(columnId)));
};
// The text filter is more basic (less numeric support)
// but is much faster
const $ff62fbff81e95ce8$var$text = (rowA, rowB, columnId)=>{
    return $ff62fbff81e95ce8$var$compareBasic($ff62fbff81e95ce8$var$toString(rowA.getValue(columnId)).toLowerCase(), $ff62fbff81e95ce8$var$toString(rowB.getValue(columnId)).toLowerCase());
};
// The text filter is more basic (less numeric support)
// but is much faster
const $ff62fbff81e95ce8$var$textCaseSensitive = (rowA, rowB, columnId)=>{
    return $ff62fbff81e95ce8$var$compareBasic($ff62fbff81e95ce8$var$toString(rowA.getValue(columnId)), $ff62fbff81e95ce8$var$toString(rowB.getValue(columnId)));
};
const $ff62fbff81e95ce8$var$datetime = (rowA, rowB, columnId)=>{
    const a = rowA.getValue(columnId);
    const b = rowB.getValue(columnId);
    // Can handle nullish values
    // Use > and < because == (and ===) doesn't work with
    // Date objects (would require calling getTime()).
    return a > b ? 1 : a < b ? -1 : 0;
};
const $ff62fbff81e95ce8$var$basic = (rowA, rowB, columnId)=>{
    return $ff62fbff81e95ce8$var$compareBasic(rowA.getValue(columnId), rowB.getValue(columnId));
};
// Utils
function $ff62fbff81e95ce8$var$compareBasic(a, b) {
    return a === b ? 0 : a > b ? 1 : -1;
}
function $ff62fbff81e95ce8$var$toString(a) {
    if (typeof a === "number") {
        if (isNaN(a) || a === Infinity || a === -Infinity) return "";
        return String(a);
    }
    if (typeof a === "string") return a;
    return "";
}
// Mixed sorting is slow, but very inclusive of many edge cases.
// It handles numbers, mixed alphanumeric combinations, and even
// null, undefined, and Infinity
function $ff62fbff81e95ce8$var$compareAlphanumeric(aStr, bStr) {
    // Split on number groups, but keep the delimiter
    // Then remove falsey split values
    const a = aStr.split($ff62fbff81e95ce8$export$8758689f50bddb9f).filter(Boolean);
    const b = bStr.split($ff62fbff81e95ce8$export$8758689f50bddb9f).filter(Boolean);
    // While
    while(a.length && b.length){
        const aa = a.shift();
        const bb = b.shift();
        const an = parseInt(aa, 10);
        const bn = parseInt(bb, 10);
        const combo = [
            an,
            bn
        ].sort();
        // Both are string
        if (isNaN(combo[0])) {
            if (aa > bb) return 1;
            if (bb > aa) return -1;
            continue;
        }
        // One is a string, one is a number
        if (isNaN(combo[1])) return isNaN(an) ? -1 : 1;
        // Both are numbers
        if (an > bn) return 1;
        if (bn > an) return -1;
    }
    return a.length - b.length;
}
// Exports
const $ff62fbff81e95ce8$export$47423a4cd813a815 = {
    alphanumeric: $ff62fbff81e95ce8$var$alphanumeric,
    alphanumericCaseSensitive: $ff62fbff81e95ce8$var$alphanumericCaseSensitive,
    text: $ff62fbff81e95ce8$var$text,
    textCaseSensitive: $ff62fbff81e95ce8$var$textCaseSensitive,
    datetime: $ff62fbff81e95ce8$var$datetime,
    basic: $ff62fbff81e95ce8$var$basic
};
//
const $ff62fbff81e95ce8$export$c7de5ec16c5efba8 = {
    getInitialState: (state)=>{
        return {
            sorting: [],
            ...state
        };
    },
    getDefaultColumnDef: ()=>{
        return {
            sortingFn: "auto",
            sortUndefined: 1
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onSortingChange: $ff62fbff81e95ce8$export$2b5605d8069324bd("sorting", table),
            isMultiSortEvent: (e)=>{
                return e.shiftKey;
            }
        };
    },
    createColumn: (column, table)=>{
        column.getAutoSortingFn = ()=>{
            const firstRows = table.getFilteredRowModel().flatRows.slice(10);
            let isString = false;
            for (const row of firstRows){
                const value = row == null ? void 0 : row.getValue(column.id);
                if (Object.prototype.toString.call(value) === "[object Date]") return $ff62fbff81e95ce8$export$47423a4cd813a815.datetime;
                if (typeof value === "string") {
                    isString = true;
                    if (value.split($ff62fbff81e95ce8$export$8758689f50bddb9f).length > 1) return $ff62fbff81e95ce8$export$47423a4cd813a815.alphanumeric;
                }
            }
            if (isString) return $ff62fbff81e95ce8$export$47423a4cd813a815.text;
            return $ff62fbff81e95ce8$export$47423a4cd813a815.basic;
        };
        column.getAutoSortDir = ()=>{
            const firstRow = table.getFilteredRowModel().flatRows[0];
            const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
            if (typeof value === "string") return "asc";
            return "desc";
        };
        column.getSortingFn = ()=>{
            var _table$options$sortin, _table$options$sortin2;
            if (!column) throw new Error();
            return $ff62fbff81e95ce8$export$f6e2535fb5126e54(column.columnDef.sortingFn) ? column.columnDef.sortingFn : column.columnDef.sortingFn === "auto" ? column.getAutoSortingFn() : (_table$options$sortin = (_table$options$sortin2 = table.options.sortingFns) == null ? void 0 : _table$options$sortin2[column.columnDef.sortingFn]) != null ? _table$options$sortin : $ff62fbff81e95ce8$export$47423a4cd813a815[column.columnDef.sortingFn];
        };
        column.toggleSorting = (desc, multi)=>{
            // if (column.columns.length) {
            //   column.columns.forEach((c, i) => {
            //     if (c.id) {
            //       table.toggleColumnSorting(c.id, undefined, multi || !!i)
            //     }
            //   })
            //   return
            // }
            // this needs to be outside of table.setSorting to be in sync with rerender
            const nextSortingOrder = column.getNextSortingOrder();
            const hasManualValue = typeof desc !== "undefined" && desc !== null;
            table.setSorting((old)=>{
                // Find any existing sorting for this column
                const existingSorting = old == null ? void 0 : old.find((d)=>d.id === column.id);
                const existingIndex = old == null ? void 0 : old.findIndex((d)=>d.id === column.id);
                let newSorting = [];
                // What should we do with this sort action?
                let sortAction;
                let nextDesc = hasManualValue ? desc : nextSortingOrder === "desc";
                // Multi-mode
                if (old != null && old.length && column.getCanMultiSort() && multi) {
                    if (existingSorting) sortAction = "toggle";
                    else sortAction = "add";
                } else {
                    // Normal mode
                    if (old != null && old.length && existingIndex !== old.length - 1) sortAction = "replace";
                    else if (existingSorting) sortAction = "toggle";
                    else sortAction = "replace";
                }
                // Handle toggle states that will remove the sorting
                if (sortAction === "toggle") {
                    // If we are "actually" toggling (not a manual set value), should we remove the sorting?
                    if (!hasManualValue) // Is our intention to remove?
                    {
                        if (!nextSortingOrder) sortAction = "remove";
                    }
                }
                if (sortAction === "add") {
                    var _table$options$maxMul;
                    newSorting = [
                        ...old,
                        {
                            id: column.id,
                            desc: nextDesc
                        }
                    ];
                    // Take latest n columns
                    newSorting.splice(0, newSorting.length - ((_table$options$maxMul = table.options.maxMultiSortColCount) != null ? _table$options$maxMul : Number.MAX_SAFE_INTEGER));
                } else if (sortAction === "toggle") // This flips (or sets) the
                newSorting = old.map((d)=>{
                    if (d.id === column.id) return {
                        ...d,
                        desc: nextDesc
                    };
                    return d;
                });
                else if (sortAction === "remove") newSorting = old.filter((d)=>d.id !== column.id);
                else newSorting = [
                    {
                        id: column.id,
                        desc: nextDesc
                    }
                ];
                return newSorting;
            });
        };
        column.getFirstSortDir = ()=>{
            var _ref, _column$columnDef$sor;
            const sortDescFirst = (_ref = (_column$columnDef$sor = column.columnDef.sortDescFirst) != null ? _column$columnDef$sor : table.options.sortDescFirst) != null ? _ref : column.getAutoSortDir() === "desc";
            return sortDescFirst ? "desc" : "asc";
        };
        column.getNextSortingOrder = (multi)=>{
            var _table$options$enable, _table$options$enable2;
            const firstSortDirection = column.getFirstSortDir();
            const isSorted = column.getIsSorted();
            if (!isSorted) return firstSortDirection;
            if (isSorted !== firstSortDirection && ((_table$options$enable = table.options.enableSortingRemoval) != null ? _table$options$enable : true) && // If enableSortRemove, enable in general
            (multi ? (_table$options$enable2 = table.options.enableMultiRemove) != null ? _table$options$enable2 : true : true // If multi, don't allow if enableMultiRemove))
            )) return false;
            return isSorted === "desc" ? "asc" : "desc";
        };
        column.getCanSort = ()=>{
            var _column$columnDef$ena, _table$options$enable3;
            return ((_column$columnDef$ena = column.columnDef.enableSorting) != null ? _column$columnDef$ena : true) && ((_table$options$enable3 = table.options.enableSorting) != null ? _table$options$enable3 : true) && !!column.accessorFn;
        };
        column.getCanMultiSort = ()=>{
            var _ref2, _column$columnDef$ena2;
            return (_ref2 = (_column$columnDef$ena2 = column.columnDef.enableMultiSort) != null ? _column$columnDef$ena2 : table.options.enableMultiSort) != null ? _ref2 : !!column.accessorFn;
        };
        column.getIsSorted = ()=>{
            var _table$getState$sorti;
            const columnSort = (_table$getState$sorti = table.getState().sorting) == null ? void 0 : _table$getState$sorti.find((d)=>d.id === column.id);
            return !columnSort ? false : columnSort.desc ? "desc" : "asc";
        };
        column.getSortIndex = ()=>{
            var _table$getState$sorti2, _table$getState$sorti3;
            return (_table$getState$sorti2 = (_table$getState$sorti3 = table.getState().sorting) == null ? void 0 : _table$getState$sorti3.findIndex((d)=>d.id === column.id)) != null ? _table$getState$sorti2 : -1;
        };
        column.clearSorting = ()=>{
            //clear sorting for just 1 column
            table.setSorting((old)=>old != null && old.length ? old.filter((d)=>d.id !== column.id) : []);
        };
        column.getToggleSortingHandler = ()=>{
            const canSort = column.getCanSort();
            return (e)=>{
                if (!canSort) return;
                e.persist == null || e.persist();
                column.toggleSorting == null || column.toggleSorting(undefined, column.getCanMultiSort() ? table.options.isMultiSortEvent == null ? void 0 : table.options.isMultiSortEvent(e) : false);
            };
        };
    },
    createTable: (table)=>{
        table.setSorting = (updater)=>table.options.onSortingChange == null ? void 0 : table.options.onSortingChange(updater);
        table.resetSorting = (defaultState)=>{
            var _table$initialState$s, _table$initialState;
            table.setSorting(defaultState ? [] : (_table$initialState$s = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.sorting) != null ? _table$initialState$s : []);
        };
        table.getPreSortedRowModel = ()=>table.getGroupedRowModel();
        table.getSortedRowModel = ()=>{
            if (!table._getSortedRowModel && table.options.getSortedRowModel) table._getSortedRowModel = table.options.getSortedRowModel(table);
            if (table.options.manualSorting || !table._getSortedRowModel) return table.getPreSortedRowModel();
            return table._getSortedRowModel();
        };
    }
};
const $ff62fbff81e95ce8$var$builtInFeatures = [
    $ff62fbff81e95ce8$export$79b704688b15c0f4,
    $ff62fbff81e95ce8$export$be5545a32e20d889,
    $ff62fbff81e95ce8$export$fec9c66cd0275c2c,
    $ff62fbff81e95ce8$export$3563275ce70c4813,
    $ff62fbff81e95ce8$export$1f746e6a9cd841b1,
    $ff62fbff81e95ce8$export$f1d67534a0c5e9d3,
    $ff62fbff81e95ce8$export$4b37edcdc7ad2fe1,
    //depends on ColumnFaceting
    $ff62fbff81e95ce8$export$61e9e0661ff79b1c,
    //depends on ColumnFiltering
    $ff62fbff81e95ce8$export$c7de5ec16c5efba8,
    $ff62fbff81e95ce8$export$9c9247c655f92e74,
    //depends on RowSorting
    $ff62fbff81e95ce8$export$fed54e0d64c17fb2,
    $ff62fbff81e95ce8$export$bce540641752d22b,
    $ff62fbff81e95ce8$export$213d72cb2ac7d440,
    $ff62fbff81e95ce8$export$e8905133e7bf3121,
    $ff62fbff81e95ce8$export$9916c85814812d4a
];
//
function $ff62fbff81e95ce8$export$33bbb3ec7652e187(options) {
    var _options$_features, _options$initialState;
    const _features = [
        ...$ff62fbff81e95ce8$var$builtInFeatures,
        ...(_options$_features = options._features) != null ? _options$_features : []
    ];
    let table = {
        _features: _features
    };
    const defaultOptions = table._features.reduce((obj, feature)=>{
        return Object.assign(obj, feature.getDefaultOptions == null ? void 0 : feature.getDefaultOptions(table));
    }, {});
    const mergeOptions = (options)=>{
        if (table.options.mergeOptions) return table.options.mergeOptions(defaultOptions, options);
        return {
            ...defaultOptions,
            ...options
        };
    };
    const coreInitialState = {};
    let initialState = {
        ...coreInitialState,
        ...(_options$initialState = options.initialState) != null ? _options$initialState : {}
    };
    table._features.forEach((feature)=>{
        var _feature$getInitialSt;
        initialState = (_feature$getInitialSt = feature.getInitialState == null ? void 0 : feature.getInitialState(initialState)) != null ? _feature$getInitialSt : initialState;
    });
    const queued = [];
    let queuedTimeout = false;
    const coreInstance = {
        _features: _features,
        options: {
            ...defaultOptions,
            ...options
        },
        initialState: initialState,
        _queue: (cb)=>{
            queued.push(cb);
            if (!queuedTimeout) {
                queuedTimeout = true;
                // Schedule a microtask to run the queued callbacks after
                // the current call stack (render, etc) has finished.
                Promise.resolve().then(()=>{
                    while(queued.length)queued.shift()();
                    queuedTimeout = false;
                }).catch((error)=>setTimeout(()=>{
                        throw error;
                    }));
            }
        },
        reset: ()=>{
            table.setState(table.initialState);
        },
        setOptions: (updater)=>{
            const newOptions = $ff62fbff81e95ce8$export$7f095f455ad5af3f(updater, table.options);
            table.options = mergeOptions(newOptions);
        },
        getState: ()=>{
            return table.options.state;
        },
        setState: (updater)=>{
            table.options.onStateChange == null || table.options.onStateChange(updater);
        },
        _getRowId: (row, index, parent)=>{
            var _table$options$getRow;
            return (_table$options$getRow = table.options.getRowId == null ? void 0 : table.options.getRowId(row, index, parent)) != null ? _table$options$getRow : `${parent ? [
                parent.id,
                index
            ].join(".") : index}`;
        },
        getCoreRowModel: ()=>{
            if (!table._getCoreRowModel) table._getCoreRowModel = table.options.getCoreRowModel(table);
            return table._getCoreRowModel();
        },
        // The final calls start at the bottom of the model,
        // expanded rows, which then work their way up
        getRowModel: ()=>{
            return table.getPaginationRowModel();
        },
        //in next version, we should just pass in the row model as the optional 2nd arg
        getRow: (id, searchAll)=>{
            let row = (searchAll ? table.getPrePaginationRowModel() : table.getRowModel()).rowsById[id];
            if (!row) {
                row = table.getCoreRowModel().rowsById[id];
                if (!row) throw new Error();
            }
            return row;
        },
        _getDefaultColumnDef: $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table.options.defaultColumn
            ], (defaultColumn)=>{
            var _defaultColumn;
            defaultColumn = (_defaultColumn = defaultColumn) != null ? _defaultColumn : {};
            return {
                header: (props)=>{
                    const resolvedColumnDef = props.header.column.columnDef;
                    if (resolvedColumnDef.accessorKey) return resolvedColumnDef.accessorKey;
                    if (resolvedColumnDef.accessorFn) return resolvedColumnDef.id;
                    return null;
                },
                // footer: props => props.header.column.id,
                cell: (props)=>{
                    var _props$renderValue$to, _props$renderValue;
                    return (_props$renderValue$to = (_props$renderValue = props.renderValue()) == null || _props$renderValue.toString == null ? void 0 : _props$renderValue.toString()) != null ? _props$renderValue$to : null;
                },
                ...table._features.reduce((obj, feature)=>{
                    return Object.assign(obj, feature.getDefaultColumnDef == null ? void 0 : feature.getDefaultColumnDef());
                }, {}),
                ...defaultColumn
            };
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(options, "debugColumns", "_getDefaultColumnDef")),
        _getColumnDefs: ()=>table.options.columns,
        getAllColumns: $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table._getColumnDefs()
            ], (columnDefs)=>{
            const recurseColumns = function(columnDefs, parent, depth) {
                if (depth === void 0) depth = 0;
                return columnDefs.map((columnDef)=>{
                    const column = $ff62fbff81e95ce8$export$1bfa986e9c92c0b5(table, columnDef, depth, parent);
                    const groupingColumnDef = columnDef;
                    column.columns = groupingColumnDef.columns ? recurseColumns(groupingColumnDef.columns, column, depth + 1) : [];
                    return column;
                });
            };
            return recurseColumns(columnDefs);
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(options, "debugColumns", "getAllColumns")),
        getAllFlatColumns: $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table.getAllColumns()
            ], (allColumns)=>{
            return allColumns.flatMap((column)=>{
                return column.getFlatColumns();
            });
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(options, "debugColumns", "getAllFlatColumns")),
        _getAllFlatColumnsById: $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table.getAllFlatColumns()
            ], (flatColumns)=>{
            return flatColumns.reduce((acc, column)=>{
                acc[column.id] = column;
                return acc;
            }, {});
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(options, "debugColumns", "getAllFlatColumnsById")),
        getAllLeafColumns: $ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table._getOrderColumnsFn()
            ], (allColumns, orderColumns)=>{
            let leafColumns = allColumns.flatMap((column)=>column.getLeafColumns());
            return orderColumns(leafColumns);
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(options, "debugColumns", "getAllLeafColumns")),
        getColumn: (columnId)=>{
            const column = table._getAllFlatColumnsById()[columnId];
            return column;
        }
    };
    Object.assign(table, coreInstance);
    for(let index = 0; index < table._features.length; index++){
        const feature = table._features[index];
        feature == null || feature.createTable == null || feature.createTable(table);
    }
    return table;
}
function $ff62fbff81e95ce8$export$32d0bc001e828250() {
    return (table)=>$ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table.options.data
            ], (data)=>{
            const rowModel = {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            const accessRows = function(originalRows, depth, parentRow) {
                if (depth === void 0) depth = 0;
                const rows = [];
                for(let i = 0; i < originalRows.length; i++){
                    // This could be an expensive check at scale, so we should move it somewhere else, but where?
                    // if (!id) {
                    //   if (process.env.NODE_ENV !== 'production') {
                    //     throw new Error(`getRowId expected an ID, but got ${id}`)
                    //   }
                    // }
                    // Make the row
                    const row = $ff62fbff81e95ce8$export$3442c5d213434705(table, table._getRowId(originalRows[i], i, parentRow), originalRows[i], i, depth, undefined, parentRow == null ? void 0 : parentRow.id);
                    // Keep track of every row in a flat array
                    rowModel.flatRows.push(row);
                    // Also keep track of every row by its ID
                    rowModel.rowsById[row.id] = row;
                    // Push table row into parent
                    rows.push(row);
                    // Get the original subrows
                    if (table.options.getSubRows) {
                        var _row$originalSubRows;
                        row.originalSubRows = table.options.getSubRows(originalRows[i], i);
                        // Then recursively access them
                        if ((_row$originalSubRows = row.originalSubRows) != null && _row$originalSubRows.length) row.subRows = accessRows(row.originalSubRows, depth + 1, row);
                    }
                }
                return rows;
            };
            rowModel.rows = accessRows(data);
            return rowModel;
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, "debugTable", "getRowModel", ()=>table._autoResetPageIndex()));
}
function $ff62fbff81e95ce8$export$53cfec7b1b8d1fcd() {
    return (table)=>$ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table.getState().expanded,
                table.getPreExpandedRowModel(),
                table.options.paginateExpandedRows
            ], (expanded, rowModel, paginateExpandedRows)=>{
            if (!rowModel.rows.length || expanded !== true && !Object.keys(expanded != null ? expanded : {}).length) return rowModel;
            if (!paginateExpandedRows) // Only expand rows at this point if they are being paginated
            return rowModel;
            return $ff62fbff81e95ce8$export$1293f966cdb38633(rowModel);
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, "debugTable", "getExpandedRowModel"));
}
function $ff62fbff81e95ce8$export$1293f966cdb38633(rowModel) {
    const expandedRows = [];
    const handleRow = (row)=>{
        var _row$subRows;
        expandedRows.push(row);
        if ((_row$subRows = row.subRows) != null && _row$subRows.length && row.getIsExpanded()) row.subRows.forEach(handleRow);
    };
    rowModel.rows.forEach(handleRow);
    return {
        rows: expandedRows,
        flatRows: rowModel.flatRows,
        rowsById: rowModel.rowsById
    };
}
function $ff62fbff81e95ce8$export$d17dd32c9eab9fc7() {
    return (table, columnId)=>$ff62fbff81e95ce8$export$7c73462e0d25e514(()=>{
            var _table$getColumn;
            return [
                (_table$getColumn = table.getColumn(columnId)) == null ? void 0 : _table$getColumn.getFacetedRowModel()
            ];
        }, (facetedRowModel)=>{
            if (!facetedRowModel) return undefined;
            const uniqueValues = facetedRowModel.flatRows.flatMap((flatRow)=>{
                var _flatRow$getUniqueVal;
                return (_flatRow$getUniqueVal = flatRow.getUniqueValues(columnId)) != null ? _flatRow$getUniqueVal : [];
            }).map(Number).filter((value)=>!Number.isNaN(value));
            if (!uniqueValues.length) return;
            let facetedMinValue = uniqueValues[0];
            let facetedMaxValue = uniqueValues[uniqueValues.length - 1];
            for (const value of uniqueValues){
                if (value < facetedMinValue) facetedMinValue = value;
                else if (value > facetedMaxValue) facetedMaxValue = value;
            }
            return [
                facetedMinValue,
                facetedMaxValue
            ];
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, "debugTable", "getFacetedMinMaxValues"));
}
function $ff62fbff81e95ce8$var$filterRows(rows, filterRowImpl, table) {
    if (table.options.filterFromLeafRows) return $ff62fbff81e95ce8$var$filterRowModelFromLeafs(rows, filterRowImpl, table);
    return $ff62fbff81e95ce8$var$filterRowModelFromRoot(rows, filterRowImpl, table);
}
function $ff62fbff81e95ce8$var$filterRowModelFromLeafs(rowsToFilter, filterRow, table) {
    var _table$options$maxLea;
    const newFilteredFlatRows = [];
    const newFilteredRowsById = {};
    const maxDepth = (_table$options$maxLea = table.options.maxLeafRowFilterDepth) != null ? _table$options$maxLea : 100;
    const recurseFilterRows = function(rowsToFilter, depth) {
        if (depth === void 0) depth = 0;
        const rows = [];
        // Filter from children up first
        for(let i = 0; i < rowsToFilter.length; i++){
            var _row$subRows;
            let row = rowsToFilter[i];
            const newRow = $ff62fbff81e95ce8$export$3442c5d213434705(table, row.id, row.original, row.index, row.depth, undefined, row.parentId);
            newRow.columnFilters = row.columnFilters;
            if ((_row$subRows = row.subRows) != null && _row$subRows.length && depth < maxDepth) {
                newRow.subRows = recurseFilterRows(row.subRows, depth + 1);
                row = newRow;
                if (filterRow(row) && !newRow.subRows.length) {
                    rows.push(row);
                    newFilteredRowsById[row.id] = row;
                    newFilteredFlatRows.push(row);
                    continue;
                }
                if (filterRow(row) || newRow.subRows.length) {
                    rows.push(row);
                    newFilteredRowsById[row.id] = row;
                    newFilteredFlatRows.push(row);
                    continue;
                }
            } else {
                row = newRow;
                if (filterRow(row)) {
                    rows.push(row);
                    newFilteredRowsById[row.id] = row;
                    newFilteredFlatRows.push(row);
                }
            }
        }
        return rows;
    };
    return {
        rows: recurseFilterRows(rowsToFilter),
        flatRows: newFilteredFlatRows,
        rowsById: newFilteredRowsById
    };
}
function $ff62fbff81e95ce8$var$filterRowModelFromRoot(rowsToFilter, filterRow, table) {
    var _table$options$maxLea2;
    const newFilteredFlatRows = [];
    const newFilteredRowsById = {};
    const maxDepth = (_table$options$maxLea2 = table.options.maxLeafRowFilterDepth) != null ? _table$options$maxLea2 : 100;
    // Filters top level and nested rows
    const recurseFilterRows = function(rowsToFilter, depth) {
        if (depth === void 0) depth = 0;
        // Filter from parents downward first
        const rows = [];
        // Apply the filter to any subRows
        for(let i = 0; i < rowsToFilter.length; i++){
            let row = rowsToFilter[i];
            const pass = filterRow(row);
            if (pass) {
                var _row$subRows2;
                if ((_row$subRows2 = row.subRows) != null && _row$subRows2.length && depth < maxDepth) {
                    const newRow = $ff62fbff81e95ce8$export$3442c5d213434705(table, row.id, row.original, row.index, row.depth, undefined, row.parentId);
                    newRow.subRows = recurseFilterRows(row.subRows, depth + 1);
                    row = newRow;
                }
                rows.push(row);
                newFilteredFlatRows.push(row);
                newFilteredRowsById[row.id] = row;
            }
        }
        return rows;
    };
    return {
        rows: recurseFilterRows(rowsToFilter),
        flatRows: newFilteredFlatRows,
        rowsById: newFilteredRowsById
    };
}
function $ff62fbff81e95ce8$export$3519aa0e35dc33b4() {
    return (table, columnId)=>$ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table.getPreFilteredRowModel(),
                table.getState().columnFilters,
                table.getState().globalFilter,
                table.getFilteredRowModel()
            ], (preRowModel, columnFilters, globalFilter)=>{
            if (!preRowModel.rows.length || !(columnFilters != null && columnFilters.length) && !globalFilter) return preRowModel;
            const filterableIds = [
                ...columnFilters.map((d)=>d.id).filter((d)=>d !== columnId),
                globalFilter ? "__global__" : undefined
            ].filter(Boolean);
            const filterRowsImpl = (row)=>{
                // Horizontally filter rows through each column
                for(let i = 0; i < filterableIds.length; i++){
                    if (row.columnFilters[filterableIds[i]] === false) return false;
                }
                return true;
            };
            return $ff62fbff81e95ce8$var$filterRows(preRowModel.rows, filterRowsImpl, table);
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, "debugTable", "getFacetedRowModel"));
}
function $ff62fbff81e95ce8$export$1fb5d0c1edc37de2() {
    return (table, columnId)=>$ff62fbff81e95ce8$export$7c73462e0d25e514(()=>{
            var _table$getColumn;
            return [
                (_table$getColumn = table.getColumn(columnId)) == null ? void 0 : _table$getColumn.getFacetedRowModel()
            ];
        }, (facetedRowModel)=>{
            if (!facetedRowModel) return new Map();
            let facetedUniqueValues = new Map();
            for(let i = 0; i < facetedRowModel.flatRows.length; i++){
                const values = facetedRowModel.flatRows[i].getUniqueValues(columnId);
                for(let j = 0; j < values.length; j++){
                    const value = values[j];
                    if (facetedUniqueValues.has(value)) {
                        var _facetedUniqueValues$;
                        facetedUniqueValues.set(value, ((_facetedUniqueValues$ = facetedUniqueValues.get(value)) != null ? _facetedUniqueValues$ : 0) + 1);
                    } else facetedUniqueValues.set(value, 1);
                }
            }
            return facetedUniqueValues;
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, "debugTable", `getFacetedUniqueValues_${columnId}`));
}
function $ff62fbff81e95ce8$export$26f255a2756e1638() {
    return (table)=>$ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table.getPreFilteredRowModel(),
                table.getState().columnFilters,
                table.getState().globalFilter
            ], (rowModel, columnFilters, globalFilter)=>{
            if (!rowModel.rows.length || !(columnFilters != null && columnFilters.length) && !globalFilter) {
                for(let i = 0; i < rowModel.flatRows.length; i++){
                    rowModel.flatRows[i].columnFilters = {};
                    rowModel.flatRows[i].columnFiltersMeta = {};
                }
                return rowModel;
            }
            const resolvedColumnFilters = [];
            const resolvedGlobalFilters = [];
            (columnFilters != null ? columnFilters : []).forEach((d)=>{
                var _filterFn$resolveFilt;
                const column = table.getColumn(d.id);
                if (!column) return;
                const filterFn = column.getFilterFn();
                if (!filterFn) return;
                resolvedColumnFilters.push({
                    id: d.id,
                    filterFn: filterFn,
                    resolvedValue: (_filterFn$resolveFilt = filterFn.resolveFilterValue == null ? void 0 : filterFn.resolveFilterValue(d.value)) != null ? _filterFn$resolveFilt : d.value
                });
            });
            const filterableIds = (columnFilters != null ? columnFilters : []).map((d)=>d.id);
            const globalFilterFn = table.getGlobalFilterFn();
            const globallyFilterableColumns = table.getAllLeafColumns().filter((column)=>column.getCanGlobalFilter());
            if (globalFilter && globalFilterFn && globallyFilterableColumns.length) {
                filterableIds.push("__global__");
                globallyFilterableColumns.forEach((column)=>{
                    var _globalFilterFn$resol;
                    resolvedGlobalFilters.push({
                        id: column.id,
                        filterFn: globalFilterFn,
                        resolvedValue: (_globalFilterFn$resol = globalFilterFn.resolveFilterValue == null ? void 0 : globalFilterFn.resolveFilterValue(globalFilter)) != null ? _globalFilterFn$resol : globalFilter
                    });
                });
            }
            let currentColumnFilter;
            let currentGlobalFilter;
            // Flag the prefiltered row model with each filter state
            for(let j = 0; j < rowModel.flatRows.length; j++){
                const row = rowModel.flatRows[j];
                row.columnFilters = {};
                if (resolvedColumnFilters.length) for(let i = 0; i < resolvedColumnFilters.length; i++){
                    currentColumnFilter = resolvedColumnFilters[i];
                    const id = currentColumnFilter.id;
                    // Tag the row with the column filter state
                    row.columnFilters[id] = currentColumnFilter.filterFn(row, id, currentColumnFilter.resolvedValue, (filterMeta)=>{
                        row.columnFiltersMeta[id] = filterMeta;
                    });
                }
                if (resolvedGlobalFilters.length) {
                    for(let i = 0; i < resolvedGlobalFilters.length; i++){
                        currentGlobalFilter = resolvedGlobalFilters[i];
                        const id = currentGlobalFilter.id;
                        // Tag the row with the first truthy global filter state
                        if (currentGlobalFilter.filterFn(row, id, currentGlobalFilter.resolvedValue, (filterMeta)=>{
                            row.columnFiltersMeta[id] = filterMeta;
                        })) {
                            row.columnFilters.__global__ = true;
                            break;
                        }
                    }
                    if (row.columnFilters.__global__ !== true) row.columnFilters.__global__ = false;
                }
            }
            const filterRowsImpl = (row)=>{
                // Horizontally filter rows through each column
                for(let i = 0; i < filterableIds.length; i++){
                    if (row.columnFilters[filterableIds[i]] === false) return false;
                }
                return true;
            };
            // Filter final rows using all of the active filters
            return $ff62fbff81e95ce8$var$filterRows(rowModel.rows, filterRowsImpl, table);
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, "debugTable", "getFilteredRowModel", ()=>table._autoResetPageIndex()));
}
function $ff62fbff81e95ce8$export$2b7f4b57ce71b81() {
    return (table)=>$ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table.getState().grouping,
                table.getPreGroupedRowModel()
            ], (grouping, rowModel)=>{
            if (!rowModel.rows.length || !grouping.length) {
                rowModel.rows.forEach((row)=>{
                    row.depth = 0;
                    row.parentId = undefined;
                });
                return rowModel;
            }
            // Filter the grouping list down to columns that exist
            const existingGrouping = grouping.filter((columnId)=>table.getColumn(columnId));
            const groupedFlatRows = [];
            const groupedRowsById = {};
            // const onlyGroupedFlatRows: Row[] = [];
            // const onlyGroupedRowsById: Record<RowId, Row> = {};
            // const nonGroupedFlatRows: Row[] = [];
            // const nonGroupedRowsById: Record<RowId, Row> = {};
            // Recursively group the data
            const groupUpRecursively = function(rows, depth, parentId) {
                if (depth === void 0) depth = 0;
                // Grouping depth has been been met
                // Stop grouping and simply rewrite thd depth and row relationships
                if (depth >= existingGrouping.length) return rows.map((row)=>{
                    row.depth = depth;
                    groupedFlatRows.push(row);
                    groupedRowsById[row.id] = row;
                    if (row.subRows) row.subRows = groupUpRecursively(row.subRows, depth + 1, row.id);
                    return row;
                });
                const columnId = existingGrouping[depth];
                // Group the rows together for this level
                const rowGroupsMap = $ff62fbff81e95ce8$var$groupBy(rows, columnId);
                // Perform aggregations for each group
                const aggregatedGroupedRows = Array.from(rowGroupsMap.entries()).map((_ref, index)=>{
                    let [groupingValue, groupedRows] = _ref;
                    let id = `${columnId}:${groupingValue}`;
                    id = parentId ? `${parentId}>${id}` : id;
                    // First, Recurse to group sub rows before aggregation
                    const subRows = groupUpRecursively(groupedRows, depth + 1, id);
                    subRows.forEach((subRow)=>{
                        subRow.parentId = id;
                    });
                    // Flatten the leaf rows of the rows in this group
                    const leafRows = depth ? $ff62fbff81e95ce8$export$bf4548421d1b2c8(groupedRows, (row)=>row.subRows) : groupedRows;
                    const row = $ff62fbff81e95ce8$export$3442c5d213434705(table, id, leafRows[0].original, index, depth, undefined, parentId);
                    Object.assign(row, {
                        groupingColumnId: columnId,
                        groupingValue: groupingValue,
                        subRows: subRows,
                        leafRows: leafRows,
                        getValue: (columnId)=>{
                            // Don't aggregate columns that are in the grouping
                            if (existingGrouping.includes(columnId)) {
                                if (row._valuesCache.hasOwnProperty(columnId)) return row._valuesCache[columnId];
                                if (groupedRows[0]) {
                                    var _groupedRows$0$getVal;
                                    row._valuesCache[columnId] = (_groupedRows$0$getVal = groupedRows[0].getValue(columnId)) != null ? _groupedRows$0$getVal : undefined;
                                }
                                return row._valuesCache[columnId];
                            }
                            if (row._groupingValuesCache.hasOwnProperty(columnId)) return row._groupingValuesCache[columnId];
                            // Aggregate the values
                            const column = table.getColumn(columnId);
                            const aggregateFn = column == null ? void 0 : column.getAggregationFn();
                            if (aggregateFn) {
                                row._groupingValuesCache[columnId] = aggregateFn(columnId, leafRows, groupedRows);
                                return row._groupingValuesCache[columnId];
                            }
                        }
                    });
                    subRows.forEach((subRow)=>{
                        groupedFlatRows.push(subRow);
                        groupedRowsById[subRow.id] = subRow;
                    // if (subRow.getIsGrouped?.()) {
                    //   onlyGroupedFlatRows.push(subRow);
                    //   onlyGroupedRowsById[subRow.id] = subRow;
                    // } else {
                    //   nonGroupedFlatRows.push(subRow);
                    //   nonGroupedRowsById[subRow.id] = subRow;
                    // }
                    });
                    return row;
                });
                return aggregatedGroupedRows;
            };
            const groupedRows = groupUpRecursively(rowModel.rows, 0);
            groupedRows.forEach((subRow)=>{
                groupedFlatRows.push(subRow);
                groupedRowsById[subRow.id] = subRow;
            // if (subRow.getIsGrouped?.()) {
            //   onlyGroupedFlatRows.push(subRow);
            //   onlyGroupedRowsById[subRow.id] = subRow;
            // } else {
            //   nonGroupedFlatRows.push(subRow);
            //   nonGroupedRowsById[subRow.id] = subRow;
            // }
            });
            return {
                rows: groupedRows,
                flatRows: groupedFlatRows,
                rowsById: groupedRowsById
            };
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, "debugTable", "getGroupedRowModel", ()=>{
            table._queue(()=>{
                table._autoResetExpanded();
                table._autoResetPageIndex();
            });
        }));
}
function $ff62fbff81e95ce8$var$groupBy(rows, columnId) {
    const groupMap = new Map();
    return rows.reduce((map, row)=>{
        const resKey = `${row.getGroupingValue(columnId)}`;
        const previous = map.get(resKey);
        if (!previous) map.set(resKey, [
            row
        ]);
        else previous.push(row);
        return map;
    }, groupMap);
}
function $ff62fbff81e95ce8$export$ddfd3662e196c265(opts) {
    return (table)=>$ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table.getState().pagination,
                table.getPrePaginationRowModel(),
                table.options.paginateExpandedRows ? undefined : table.getState().expanded
            ], (pagination, rowModel)=>{
            if (!rowModel.rows.length) return rowModel;
            const { pageSize: pageSize, pageIndex: pageIndex } = pagination;
            let { rows: rows, flatRows: flatRows, rowsById: rowsById } = rowModel;
            const pageStart = pageSize * pageIndex;
            const pageEnd = pageStart + pageSize;
            rows = rows.slice(pageStart, pageEnd);
            let paginatedRowModel;
            if (!table.options.paginateExpandedRows) paginatedRowModel = $ff62fbff81e95ce8$export$1293f966cdb38633({
                rows: rows,
                flatRows: flatRows,
                rowsById: rowsById
            });
            else paginatedRowModel = {
                rows: rows,
                flatRows: flatRows,
                rowsById: rowsById
            };
            paginatedRowModel.flatRows = [];
            const handleRow = (row)=>{
                paginatedRowModel.flatRows.push(row);
                if (row.subRows.length) row.subRows.forEach(handleRow);
            };
            paginatedRowModel.rows.forEach(handleRow);
            return paginatedRowModel;
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, "debugTable", "getPaginationRowModel"));
}
function $ff62fbff81e95ce8$export$4ca93ca80835d8c1() {
    return (table)=>$ff62fbff81e95ce8$export$7c73462e0d25e514(()=>[
                table.getState().sorting,
                table.getPreSortedRowModel()
            ], (sorting, rowModel)=>{
            if (!rowModel.rows.length || !(sorting != null && sorting.length)) return rowModel;
            const sortingState = table.getState().sorting;
            const sortedFlatRows = [];
            // Filter out sortings that correspond to non existing columns
            const availableSorting = sortingState.filter((sort)=>{
                var _table$getColumn;
                return (_table$getColumn = table.getColumn(sort.id)) == null ? void 0 : _table$getColumn.getCanSort();
            });
            const columnInfoById = {};
            availableSorting.forEach((sortEntry)=>{
                const column = table.getColumn(sortEntry.id);
                if (!column) return;
                columnInfoById[sortEntry.id] = {
                    sortUndefined: column.columnDef.sortUndefined,
                    invertSorting: column.columnDef.invertSorting,
                    sortingFn: column.getSortingFn()
                };
            });
            const sortData = (rows)=>{
                // This will also perform a stable sorting using the row index
                // if needed.
                const sortedData = rows.map((row)=>({
                        ...row
                    }));
                sortedData.sort((rowA, rowB)=>{
                    for(let i = 0; i < availableSorting.length; i += 1){
                        var _sortEntry$desc;
                        const sortEntry = availableSorting[i];
                        const columnInfo = columnInfoById[sortEntry.id];
                        const sortUndefined = columnInfo.sortUndefined;
                        const isDesc = (_sortEntry$desc = sortEntry == null ? void 0 : sortEntry.desc) != null ? _sortEntry$desc : false;
                        let sortInt = 0;
                        // All sorting ints should always return in ascending order
                        if (sortUndefined) {
                            const aValue = rowA.getValue(sortEntry.id);
                            const bValue = rowB.getValue(sortEntry.id);
                            const aUndefined = aValue === undefined;
                            const bUndefined = bValue === undefined;
                            if (aUndefined || bUndefined) {
                                if (sortUndefined === "first") return aUndefined ? -1 : 1;
                                if (sortUndefined === "last") return aUndefined ? 1 : -1;
                                sortInt = aUndefined && bUndefined ? 0 : aUndefined ? sortUndefined : -sortUndefined;
                            }
                        }
                        if (sortInt === 0) sortInt = columnInfo.sortingFn(rowA, rowB, sortEntry.id);
                        // If sorting is non-zero, take care of desc and inversion
                        if (sortInt !== 0) {
                            if (isDesc) sortInt *= -1;
                            if (columnInfo.invertSorting) sortInt *= -1;
                            return sortInt;
                        }
                    }
                    return rowA.index - rowB.index;
                });
                // If there are sub-rows, sort them
                sortedData.forEach((row)=>{
                    var _row$subRows;
                    sortedFlatRows.push(row);
                    if ((_row$subRows = row.subRows) != null && _row$subRows.length) row.subRows = sortData(row.subRows);
                });
                return sortedData;
            };
            return {
                rows: sortData(rowModel.rows),
                flatRows: sortedFlatRows,
                rowsById: rowModel.rowsById
            };
        }, $ff62fbff81e95ce8$export$b1f82222dc43996c(table.options, "debugTable", "getSortedRowModel", ()=>table._autoResetPageIndex()));
}

});


parcelRegister("bbMvq", function(module, exports) {

$parcel$export(module.exports, "Table", function () { return $7d502ffcbe32a59b$export$54ec01a60f47d33d; });
$parcel$export(module.exports, "TableHeader", function () { return $7d502ffcbe32a59b$export$f850895b287ef28e; });
$parcel$export(module.exports, "TableBody", function () { return $7d502ffcbe32a59b$export$76ccd210b9029917; });
$parcel$export(module.exports, "TableRow", function () { return $7d502ffcbe32a59b$export$b05581f4e764e162; });
$parcel$export(module.exports, "DraggableRow", function () { return $7d502ffcbe32a59b$export$8f9583e8843556a2; });
$parcel$export(module.exports, "TableHead", function () { return $7d502ffcbe32a59b$export$2f4a7be4f0dcc2; });
$parcel$export(module.exports, "TableCell", function () { return $7d502ffcbe32a59b$export$1e4baea7053fc0e3; });
$parcel$export(module.exports, "RowDragHandleCell", function () { return $7d502ffcbe32a59b$export$a0c80e6963dcb573; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $Yha9m = parcelRequire("Yha9m");

var $k6C77 = parcelRequire("k6C77");

var $2EYIn = parcelRequire("2EYIn");
const $7d502ffcbe32a59b$export$54ec01a60f47d33d = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)("table", {
        ref: ref,
        className: (0, $Yha9m.cn)("w-full caption-bottom text-sm print:text-[0.65rem]", className),
        ...props
    }));
$7d502ffcbe32a59b$export$54ec01a60f47d33d.displayName = "Table";
const $7d502ffcbe32a59b$export$f850895b287ef28e = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)("thead", {
        ref: ref,
        className: (0, $Yha9m.cn)("[&_tr]:border-b", className),
        ...props
    }));
$7d502ffcbe32a59b$export$f850895b287ef28e.displayName = "TableHeader";
const $7d502ffcbe32a59b$export$76ccd210b9029917 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)("tbody", {
        ref: ref,
        className: (0, $Yha9m.cn)("[&_tr:last-child]:border-0", className),
        ...props
    }));
$7d502ffcbe32a59b$export$76ccd210b9029917.displayName = "TableBody";
const $7d502ffcbe32a59b$export$1f116082bba1f9a8 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)("tfoot", {
        ref: ref,
        className: (0, $Yha9m.cn)("border-t bg-muted/50 font-medium [&>tr]:last:border-b-0", className),
        ...props
    }));
$7d502ffcbe32a59b$export$1f116082bba1f9a8.displayName = "TableFooter";
const $7d502ffcbe32a59b$export$b05581f4e764e162 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)("tr", {
        ref: ref,
        className: (0, $Yha9m.cn)("border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted", className),
        ...props
    }));
$7d502ffcbe32a59b$export$b05581f4e764e162.displayName = "TableRow";
const $7d502ffcbe32a59b$export$8f9583e8843556a2 = ({ row: row, sortableId: sortableId, className: className, style: style = {}, ...props })=>{
    const { transform: transform, transition: transition, setNodeRef: setNodeRef, isDragging: isDragging } = (0, $k6C77.useSortable)({
        id: typeof sortableId === "function" ? sortableId(row) : sortableId
    });
    const _style = {
        transform: (0, $2EYIn.CSS).Transform.toString(transform),
        //let dnd-kit do its thing
        transition: transition,
        opacity: isDragging ? 0.8 : 1,
        zIndex: isDragging ? 1 : 0,
        position: "relative"
    };
    return(// connect row ref to dnd-kit, apply important styles
    /*#__PURE__*/ (0, $61Ea1.jsx)("tr", {
        ref: setNodeRef,
        className: (0, $Yha9m.cn)("border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted", className),
        ...props,
        style: {
            ...style,
            ..._style
        }
    }));
};
$7d502ffcbe32a59b$export$8f9583e8843556a2.displayName = "DraggableRow";
const $7d502ffcbe32a59b$export$2f4a7be4f0dcc2 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)("th", {
        ref: ref,
        className: (0, $Yha9m.cn)("h-12 px-4 text-left align-middle font-medium text-muted-foreground [&:has([role=checkbox])]:pr-0 overflow-hidden print:px-2", className),
        ...props
    }));
$7d502ffcbe32a59b$export$2f4a7be4f0dcc2.displayName = "TableHead";
const $7d502ffcbe32a59b$export$1e4baea7053fc0e3 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)("td", {
        ref: ref,
        className: (0, $Yha9m.cn)("p-3 align-middle [&:has([role=checkbox])]:pr-0 overflow-hidden print:p-2", className),
        ...props
    }));
$7d502ffcbe32a59b$export$1e4baea7053fc0e3.displayName = "TableCell";
// Cell Component
const $7d502ffcbe32a59b$export$a0c80e6963dcb573 = /*#__PURE__*/ $jbmdS.forwardRef(({ rowId: rowId, ...props }, ref)=>{
    const { attributes: attributes, listeners: listeners } = (0, $k6C77.useSortable)({
        id: rowId
    });
    return(// Alternatively, you could set these attributes on the rows themselves
    /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
        ref: ref,
        ...props,
        ...attributes,
        ...listeners,
        children: "\uD83D\uDFF0"
    }));
});
$7d502ffcbe32a59b$export$a0c80e6963dcb573.displayName = "RowDragHandleCell";
const $7d502ffcbe32a59b$export$35468a455d619eb3 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)("caption", {
        ref: ref,
        className: (0, $Yha9m.cn)("mt-4 text-sm text-muted-foreground", className),
        ...props
    }));
$7d502ffcbe32a59b$export$35468a455d619eb3.displayName = "TableCaption";

});
parcelRegister("k6C77", function(module, exports) {

$parcel$export(module.exports, "verticalListSortingStrategy", function () { return $ea31eed186902620$export$fe2be640df2ffb9e; });
$parcel$export(module.exports, "SortableContext", function () { return $ea31eed186902620$export$86155fde54f06e6a; });
$parcel$export(module.exports, "useSortable", function () { return $ea31eed186902620$export$4ebcb6201122185a; });

var $jbmdS = parcelRequire("jbmdS");

var $3wpAZ = parcelRequire("3wpAZ");

var $2EYIn = parcelRequire("2EYIn");
/**
 * Move an array item to a different position. Returns a new array with the item moved to the new position.
 */ function $ea31eed186902620$export$5d49d615ad5ea2b0(array, from, to) {
    const newArray = array.slice();
    newArray.splice(to < 0 ? newArray.length + to : to, 0, newArray.splice(from, 1)[0]);
    return newArray;
}
/**
 * Swap an array item to a different position. Returns a new array with the item swapped to the new position.
 */ function $ea31eed186902620$export$5d3a3e794fd2dcef(array, from, to) {
    const newArray = array.slice();
    newArray[from] = array[to];
    newArray[to] = array[from];
    return newArray;
}
function $ea31eed186902620$var$getSortedRects(items, rects) {
    return items.reduce((accumulator, id, index)=>{
        const rect = rects.get(id);
        if (rect) accumulator[index] = rect;
        return accumulator;
    }, Array(items.length));
}
function $ea31eed186902620$var$isValidIndex(index) {
    return index !== null && index >= 0;
}
function $ea31eed186902620$var$itemsEqual(a, b) {
    if (a === b) return true;
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $ea31eed186902620$var$normalizeDisabled(disabled) {
    if (typeof disabled === "boolean") return {
        draggable: disabled,
        droppable: disabled
    };
    return disabled;
}
// To-do: We should be calculating scale transformation
const $ea31eed186902620$var$defaultScale = {
    scaleX: 1,
    scaleY: 1
};
const $ea31eed186902620$export$7a687825fa98548a = (_ref)=>{
    var _rects$activeIndex;
    let { rects: rects, activeNodeRect: fallbackActiveRect, activeIndex: activeIndex, overIndex: overIndex, index: index } = _ref;
    const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
    if (!activeNodeRect) return null;
    const itemGap = $ea31eed186902620$var$getItemGap(rects, index, activeIndex);
    if (index === activeIndex) {
        const newIndexRect = rects[overIndex];
        if (!newIndexRect) return null;
        return {
            x: activeIndex < overIndex ? newIndexRect.left + newIndexRect.width - (activeNodeRect.left + activeNodeRect.width) : newIndexRect.left - activeNodeRect.left,
            y: 0,
            ...$ea31eed186902620$var$defaultScale
        };
    }
    if (index > activeIndex && index <= overIndex) return {
        x: -activeNodeRect.width - itemGap,
        y: 0,
        ...$ea31eed186902620$var$defaultScale
    };
    if (index < activeIndex && index >= overIndex) return {
        x: activeNodeRect.width + itemGap,
        y: 0,
        ...$ea31eed186902620$var$defaultScale
    };
    return {
        x: 0,
        y: 0,
        ...$ea31eed186902620$var$defaultScale
    };
};
function $ea31eed186902620$var$getItemGap(rects, index, activeIndex) {
    const currentRect = rects[index];
    const previousRect = rects[index - 1];
    const nextRect = rects[index + 1];
    if (!currentRect || !previousRect && !nextRect) return 0;
    if (activeIndex < index) return previousRect ? currentRect.left - (previousRect.left + previousRect.width) : nextRect.left - (currentRect.left + currentRect.width);
    return nextRect ? nextRect.left - (currentRect.left + currentRect.width) : currentRect.left - (previousRect.left + previousRect.width);
}
const $ea31eed186902620$export$9377a9486e3fbbe1 = (_ref)=>{
    let { rects: rects, activeIndex: activeIndex, overIndex: overIndex, index: index } = _ref;
    const newRects = $ea31eed186902620$export$5d49d615ad5ea2b0(rects, overIndex, activeIndex);
    const oldRect = rects[index];
    const newRect = newRects[index];
    if (!newRect || !oldRect) return null;
    return {
        x: newRect.left - oldRect.left,
        y: newRect.top - oldRect.top,
        scaleX: newRect.width / oldRect.width,
        scaleY: newRect.height / oldRect.height
    };
};
const $ea31eed186902620$export$8b26fb37076c162 = (_ref)=>{
    let { activeIndex: activeIndex, index: index, rects: rects, overIndex: overIndex } = _ref;
    let oldRect;
    let newRect;
    if (index === activeIndex) {
        oldRect = rects[index];
        newRect = rects[overIndex];
    }
    if (index === overIndex) {
        oldRect = rects[index];
        newRect = rects[activeIndex];
    }
    if (!newRect || !oldRect) return null;
    return {
        x: newRect.left - oldRect.left,
        y: newRect.top - oldRect.top,
        scaleX: newRect.width / oldRect.width,
        scaleY: newRect.height / oldRect.height
    };
};
// To-do: We should be calculating scale transformation
const $ea31eed186902620$var$defaultScale$1 = {
    scaleX: 1,
    scaleY: 1
};
const $ea31eed186902620$export$fe2be640df2ffb9e = (_ref)=>{
    var _rects$activeIndex;
    let { activeIndex: activeIndex, activeNodeRect: fallbackActiveRect, index: index, rects: rects, overIndex: overIndex } = _ref;
    const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
    if (!activeNodeRect) return null;
    if (index === activeIndex) {
        const overIndexRect = rects[overIndex];
        if (!overIndexRect) return null;
        return {
            x: 0,
            y: activeIndex < overIndex ? overIndexRect.top + overIndexRect.height - (activeNodeRect.top + activeNodeRect.height) : overIndexRect.top - activeNodeRect.top,
            ...$ea31eed186902620$var$defaultScale$1
        };
    }
    const itemGap = $ea31eed186902620$var$getItemGap$1(rects, index, activeIndex);
    if (index > activeIndex && index <= overIndex) return {
        x: 0,
        y: -activeNodeRect.height - itemGap,
        ...$ea31eed186902620$var$defaultScale$1
    };
    if (index < activeIndex && index >= overIndex) return {
        x: 0,
        y: activeNodeRect.height + itemGap,
        ...$ea31eed186902620$var$defaultScale$1
    };
    return {
        x: 0,
        y: 0,
        ...$ea31eed186902620$var$defaultScale$1
    };
};
function $ea31eed186902620$var$getItemGap$1(clientRects, index, activeIndex) {
    const currentRect = clientRects[index];
    const previousRect = clientRects[index - 1];
    const nextRect = clientRects[index + 1];
    if (!currentRect) return 0;
    if (activeIndex < index) return previousRect ? currentRect.top - (previousRect.top + previousRect.height) : nextRect ? nextRect.top - (currentRect.top + currentRect.height) : 0;
    return nextRect ? nextRect.top - (currentRect.top + currentRect.height) : previousRect ? currentRect.top - (previousRect.top + previousRect.height) : 0;
}
const $ea31eed186902620$var$ID_PREFIX = "Sortable";
const $ea31eed186902620$var$Context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createContext({
    activeIndex: -1,
    containerId: $ea31eed186902620$var$ID_PREFIX,
    disableTransforms: false,
    items: [],
    overIndex: -1,
    useDragOverlay: false,
    sortedRects: [],
    strategy: $ea31eed186902620$export$9377a9486e3fbbe1,
    disabled: {
        draggable: false,
        droppable: false
    }
});
function $ea31eed186902620$export$86155fde54f06e6a(_ref) {
    let { children: children, id: id, items: userDefinedItems, strategy: strategy = $ea31eed186902620$export$9377a9486e3fbbe1, disabled: disabledProp = false } = _ref;
    const { active: active, dragOverlay: dragOverlay, droppableRects: droppableRects, over: over, measureDroppableContainers: measureDroppableContainers } = (0, $3wpAZ.useDndContext)();
    const containerId = (0, $2EYIn.useUniqueId)($ea31eed186902620$var$ID_PREFIX, id);
    const useDragOverlay = Boolean(dragOverlay.rect !== null);
    const items = (0, $jbmdS.useMemo)(()=>userDefinedItems.map((item)=>typeof item === "object" && "id" in item ? item.id : item), [
        userDefinedItems
    ]);
    const isDragging = active != null;
    const activeIndex = active ? items.indexOf(active.id) : -1;
    const overIndex = over ? items.indexOf(over.id) : -1;
    const previousItemsRef = (0, $jbmdS.useRef)(items);
    const itemsHaveChanged = !$ea31eed186902620$var$itemsEqual(items, previousItemsRef.current);
    const disableTransforms = overIndex !== -1 && activeIndex === -1 || itemsHaveChanged;
    const disabled = $ea31eed186902620$var$normalizeDisabled(disabledProp);
    (0, $2EYIn.useIsomorphicLayoutEffect)(()=>{
        if (itemsHaveChanged && isDragging) measureDroppableContainers(items);
    }, [
        itemsHaveChanged,
        items,
        isDragging,
        measureDroppableContainers
    ]);
    (0, $jbmdS.useEffect)(()=>{
        previousItemsRef.current = items;
    }, [
        items
    ]);
    const contextValue = (0, $jbmdS.useMemo)(()=>({
            activeIndex: activeIndex,
            containerId: containerId,
            disabled: disabled,
            disableTransforms: disableTransforms,
            items: items,
            overIndex: overIndex,
            useDragOverlay: useDragOverlay,
            sortedRects: $ea31eed186902620$var$getSortedRects(items, droppableRects),
            strategy: strategy
        }), [
        activeIndex,
        containerId,
        disabled.draggable,
        disabled.droppable,
        disableTransforms,
        items,
        overIndex,
        droppableRects,
        useDragOverlay,
        strategy
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($ea31eed186902620$var$Context.Provider, {
        value: contextValue
    }, children);
}
const $ea31eed186902620$export$e1ca29a833a61b5e = (_ref)=>{
    let { id: id, items: items, activeIndex: activeIndex, overIndex: overIndex } = _ref;
    return $ea31eed186902620$export$5d49d615ad5ea2b0(items, activeIndex, overIndex).indexOf(id);
};
const $ea31eed186902620$export$633d85fd1dcf5e11 = (_ref2)=>{
    let { containerId: containerId, isSorting: isSorting, wasDragging: wasDragging, index: index, items: items, newIndex: newIndex, previousItems: previousItems, previousContainerId: previousContainerId, transition: transition } = _ref2;
    if (!transition || !wasDragging) return false;
    if (previousItems !== items && index === newIndex) return false;
    if (isSorting) return true;
    return newIndex !== index && containerId === previousContainerId;
};
const $ea31eed186902620$var$defaultTransition = {
    duration: 200,
    easing: "ease"
};
const $ea31eed186902620$var$transitionProperty = "transform";
const $ea31eed186902620$var$disabledTransition = /*#__PURE__*/ (0, $2EYIn.CSS).Transition.toString({
    property: $ea31eed186902620$var$transitionProperty,
    duration: 0,
    easing: "linear"
});
const $ea31eed186902620$var$defaultAttributes = {
    roleDescription: "sortable"
};
/*
 * When the index of an item changes while sorting,
 * we need to temporarily disable the transforms
 */ function $ea31eed186902620$var$useDerivedTransform(_ref) {
    let { disabled: disabled, index: index, node: node, rect: rect } = _ref;
    const [derivedTransform, setDerivedtransform] = (0, $jbmdS.useState)(null);
    const previousIndex = (0, $jbmdS.useRef)(index);
    (0, $2EYIn.useIsomorphicLayoutEffect)(()=>{
        if (!disabled && index !== previousIndex.current && node.current) {
            const initial = rect.current;
            if (initial) {
                const current = (0, $3wpAZ.getClientRect)(node.current, {
                    ignoreTransform: true
                });
                const delta = {
                    x: initial.left - current.left,
                    y: initial.top - current.top,
                    scaleX: initial.width / current.width,
                    scaleY: initial.height / current.height
                };
                if (delta.x || delta.y) setDerivedtransform(delta);
            }
        }
        if (index !== previousIndex.current) previousIndex.current = index;
    }, [
        disabled,
        index,
        node,
        rect
    ]);
    (0, $jbmdS.useEffect)(()=>{
        if (derivedTransform) setDerivedtransform(null);
    }, [
        derivedTransform
    ]);
    return derivedTransform;
}
function $ea31eed186902620$export$4ebcb6201122185a(_ref) {
    let { animateLayoutChanges: animateLayoutChanges = $ea31eed186902620$export$633d85fd1dcf5e11, attributes: userDefinedAttributes, disabled: localDisabled, data: customData, getNewIndex: getNewIndex = $ea31eed186902620$export$e1ca29a833a61b5e, id: id, strategy: localStrategy, resizeObserverConfig: resizeObserverConfig, transition: transition = $ea31eed186902620$var$defaultTransition } = _ref;
    const { items: items, containerId: containerId, activeIndex: activeIndex, disabled: globalDisabled, disableTransforms: disableTransforms, sortedRects: sortedRects, overIndex: overIndex, useDragOverlay: useDragOverlay, strategy: globalStrategy } = (0, $jbmdS.useContext)($ea31eed186902620$var$Context);
    const disabled = $ea31eed186902620$var$normalizeLocalDisabled(localDisabled, globalDisabled);
    const index = items.indexOf(id);
    const data = (0, $jbmdS.useMemo)(()=>({
            sortable: {
                containerId: containerId,
                index: index,
                items: items
            },
            ...customData
        }), [
        containerId,
        customData,
        index,
        items
    ]);
    const itemsAfterCurrentSortable = (0, $jbmdS.useMemo)(()=>items.slice(items.indexOf(id)), [
        items,
        id
    ]);
    const { rect: rect, node: node, isOver: isOver, setNodeRef: setDroppableNodeRef } = (0, $3wpAZ.useDroppable)({
        id: id,
        data: data,
        disabled: disabled.droppable,
        resizeObserverConfig: {
            updateMeasurementsFor: itemsAfterCurrentSortable,
            ...resizeObserverConfig
        }
    });
    const { active: active, activatorEvent: activatorEvent, activeNodeRect: activeNodeRect, attributes: attributes, setNodeRef: setDraggableNodeRef, listeners: listeners, isDragging: isDragging, over: over, setActivatorNodeRef: setActivatorNodeRef, transform: transform } = (0, $3wpAZ.useDraggable)({
        id: id,
        data: data,
        attributes: {
            ...$ea31eed186902620$var$defaultAttributes,
            ...userDefinedAttributes
        },
        disabled: disabled.draggable
    });
    const setNodeRef = (0, $2EYIn.useCombinedRefs)(setDroppableNodeRef, setDraggableNodeRef);
    const isSorting = Boolean(active);
    const displaceItem = isSorting && !disableTransforms && $ea31eed186902620$var$isValidIndex(activeIndex) && $ea31eed186902620$var$isValidIndex(overIndex);
    const shouldDisplaceDragSource = !useDragOverlay && isDragging;
    const dragSourceDisplacement = shouldDisplaceDragSource && displaceItem ? transform : null;
    const strategy = localStrategy != null ? localStrategy : globalStrategy;
    const finalTransform = displaceItem ? dragSourceDisplacement != null ? dragSourceDisplacement : strategy({
        rects: sortedRects,
        activeNodeRect: activeNodeRect,
        activeIndex: activeIndex,
        overIndex: overIndex,
        index: index
    }) : null;
    const newIndex = $ea31eed186902620$var$isValidIndex(activeIndex) && $ea31eed186902620$var$isValidIndex(overIndex) ? getNewIndex({
        id: id,
        items: items,
        activeIndex: activeIndex,
        overIndex: overIndex
    }) : index;
    const activeId = active == null ? void 0 : active.id;
    const previous = (0, $jbmdS.useRef)({
        activeId: activeId,
        items: items,
        newIndex: newIndex,
        containerId: containerId
    });
    const itemsHaveChanged = items !== previous.current.items;
    const shouldAnimateLayoutChanges = animateLayoutChanges({
        active: active,
        containerId: containerId,
        isDragging: isDragging,
        isSorting: isSorting,
        id: id,
        index: index,
        items: items,
        newIndex: previous.current.newIndex,
        previousItems: previous.current.items,
        previousContainerId: previous.current.containerId,
        transition: transition,
        wasDragging: previous.current.activeId != null
    });
    const derivedTransform = $ea31eed186902620$var$useDerivedTransform({
        disabled: !shouldAnimateLayoutChanges,
        index: index,
        node: node,
        rect: rect
    });
    (0, $jbmdS.useEffect)(()=>{
        if (isSorting && previous.current.newIndex !== newIndex) previous.current.newIndex = newIndex;
        if (containerId !== previous.current.containerId) previous.current.containerId = containerId;
        if (items !== previous.current.items) previous.current.items = items;
    }, [
        isSorting,
        newIndex,
        containerId,
        items
    ]);
    (0, $jbmdS.useEffect)(()=>{
        if (activeId === previous.current.activeId) return;
        if (activeId != null && previous.current.activeId == null) {
            previous.current.activeId = activeId;
            return;
        }
        const timeoutId = setTimeout(()=>{
            previous.current.activeId = activeId;
        }, 50);
        return ()=>clearTimeout(timeoutId);
    }, [
        activeId
    ]);
    return {
        active: active,
        activeIndex: activeIndex,
        attributes: attributes,
        data: data,
        rect: rect,
        index: index,
        newIndex: newIndex,
        items: items,
        isOver: isOver,
        isSorting: isSorting,
        isDragging: isDragging,
        listeners: listeners,
        node: node,
        overIndex: overIndex,
        over: over,
        setNodeRef: setNodeRef,
        setActivatorNodeRef: setActivatorNodeRef,
        setDroppableNodeRef: setDroppableNodeRef,
        setDraggableNodeRef: setDraggableNodeRef,
        transform: derivedTransform != null ? derivedTransform : finalTransform,
        transition: getTransition()
    };
    function getTransition() {
        if (derivedTransform || // Or to prevent items jumping to back to their "new" position when items change
        itemsHaveChanged && previous.current.newIndex === index) return $ea31eed186902620$var$disabledTransition;
        if (shouldDisplaceDragSource && !(0, $2EYIn.isKeyboardEvent)(activatorEvent) || !transition) return undefined;
        if (isSorting || shouldAnimateLayoutChanges) return (0, $2EYIn.CSS).Transition.toString({
            ...transition,
            property: $ea31eed186902620$var$transitionProperty
        });
        return undefined;
    }
}
function $ea31eed186902620$var$normalizeLocalDisabled(localDisabled, globalDisabled) {
    var _localDisabled$dragga, _localDisabled$droppa;
    if (typeof localDisabled === "boolean") return {
        draggable: localDisabled,
        // Backwards compatibility
        droppable: false
    };
    return {
        draggable: (_localDisabled$dragga = localDisabled == null ? void 0 : localDisabled.draggable) != null ? _localDisabled$dragga : globalDisabled.draggable,
        droppable: (_localDisabled$droppa = localDisabled == null ? void 0 : localDisabled.droppable) != null ? _localDisabled$droppa : globalDisabled.droppable
    };
}
function $ea31eed186902620$export$6424ec8a0d450b09(entry) {
    if (!entry) return false;
    const data = entry.data.current;
    if (data && "sortable" in data && typeof data.sortable === "object" && "containerId" in data.sortable && "items" in data.sortable && "index" in data.sortable) return true;
    return false;
}
const $ea31eed186902620$var$directions = [
    (0, $3wpAZ.KeyboardCode).Down,
    (0, $3wpAZ.KeyboardCode).Right,
    (0, $3wpAZ.KeyboardCode).Up,
    (0, $3wpAZ.KeyboardCode).Left
];
const $ea31eed186902620$export$a6f27ecf02eb3a67 = (event, _ref)=>{
    let { context: { active: active, collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers, over: over, scrollableAncestors: scrollableAncestors } } = _ref;
    if ($ea31eed186902620$var$directions.includes(event.code)) {
        event.preventDefault();
        if (!active || !collisionRect) return;
        const filteredContainers = [];
        droppableContainers.getEnabled().forEach((entry)=>{
            if (!entry || entry != null && entry.disabled) return;
            const rect = droppableRects.get(entry.id);
            if (!rect) return;
            switch(event.code){
                case (0, $3wpAZ.KeyboardCode).Down:
                    if (collisionRect.top < rect.top) filteredContainers.push(entry);
                    break;
                case (0, $3wpAZ.KeyboardCode).Up:
                    if (collisionRect.top > rect.top) filteredContainers.push(entry);
                    break;
                case (0, $3wpAZ.KeyboardCode).Left:
                    if (collisionRect.left > rect.left) filteredContainers.push(entry);
                    break;
                case (0, $3wpAZ.KeyboardCode).Right:
                    if (collisionRect.left < rect.left) filteredContainers.push(entry);
                    break;
            }
        });
        const collisions = (0, $3wpAZ.closestCorners)({
            active: active,
            collisionRect: collisionRect,
            droppableRects: droppableRects,
            droppableContainers: filteredContainers,
            pointerCoordinates: null
        });
        let closestId = (0, $3wpAZ.getFirstCollision)(collisions, "id");
        if (closestId === (over == null ? void 0 : over.id) && collisions.length > 1) closestId = collisions[1].id;
        if (closestId != null) {
            const activeDroppable = droppableContainers.get(active.id);
            const newDroppable = droppableContainers.get(closestId);
            const newRect = newDroppable ? droppableRects.get(newDroppable.id) : null;
            const newNode = newDroppable == null ? void 0 : newDroppable.node.current;
            if (newNode && newRect && activeDroppable && newDroppable) {
                const newScrollAncestors = (0, $3wpAZ.getScrollableAncestors)(newNode);
                const hasDifferentScrollAncestors = newScrollAncestors.some((element, index)=>scrollableAncestors[index] !== element);
                const hasSameContainer = $ea31eed186902620$var$isSameContainer(activeDroppable, newDroppable);
                const isAfterActive = $ea31eed186902620$var$isAfter(activeDroppable, newDroppable);
                const offset = hasDifferentScrollAncestors || !hasSameContainer ? {
                    x: 0,
                    y: 0
                } : {
                    x: isAfterActive ? collisionRect.width - newRect.width : 0,
                    y: isAfterActive ? collisionRect.height - newRect.height : 0
                };
                const rectCoordinates = {
                    x: newRect.left,
                    y: newRect.top
                };
                const newCoordinates = offset.x && offset.y ? rectCoordinates : (0, $2EYIn.subtract)(rectCoordinates, offset);
                return newCoordinates;
            }
        }
    }
    return undefined;
};
function $ea31eed186902620$var$isSameContainer(a, b) {
    if (!$ea31eed186902620$export$6424ec8a0d450b09(a) || !$ea31eed186902620$export$6424ec8a0d450b09(b)) return false;
    return a.data.current.sortable.containerId === b.data.current.sortable.containerId;
}
function $ea31eed186902620$var$isAfter(a, b) {
    if (!$ea31eed186902620$export$6424ec8a0d450b09(a) || !$ea31eed186902620$export$6424ec8a0d450b09(b)) return false;
    if (!$ea31eed186902620$var$isSameContainer(a, b)) return false;
    return a.data.current.sortable.index < b.data.current.sortable.index;
}

});
parcelRegister("3wpAZ", function(module, exports) {

$parcel$export(module.exports, "useSensor", function () { return $290836fe8d7e8057$export$cc72dd71f4ec69eb; });
$parcel$export(module.exports, "useSensors", function () { return $290836fe8d7e8057$export$19012f58216d597f; });
$parcel$export(module.exports, "getFirstCollision", function () { return $290836fe8d7e8057$export$ef1beab6d7287295; });
$parcel$export(module.exports, "closestCenter", function () { return $290836fe8d7e8057$export$c8e785ae6b74bab8; });
$parcel$export(module.exports, "closestCorners", function () { return $290836fe8d7e8057$export$c3a6c1c7122b31c9; });
$parcel$export(module.exports, "getClientRect", function () { return $290836fe8d7e8057$export$b6aa1f30c53d7454; });
$parcel$export(module.exports, "getScrollableAncestors", function () { return $290836fe8d7e8057$export$e4864aa91b5ed091; });
$parcel$export(module.exports, "KeyboardCode", function () { return $290836fe8d7e8057$export$a8b1916dba3ae88b; });
$parcel$export(module.exports, "KeyboardSensor", function () { return $290836fe8d7e8057$export$44d67f2a438aeba9; });
$parcel$export(module.exports, "MouseSensor", function () { return $290836fe8d7e8057$export$b28554b50bf7f273; });
$parcel$export(module.exports, "TouchSensor", function () { return $290836fe8d7e8057$export$19b41baf2e1bcdc0; });
$parcel$export(module.exports, "DndContext", function () { return $290836fe8d7e8057$export$2d5c5ceac203fc1e; });
$parcel$export(module.exports, "useDraggable", function () { return $290836fe8d7e8057$export$df30c81f5aa01ff7; });
$parcel$export(module.exports, "useDndContext", function () { return $290836fe8d7e8057$export$4930f6bf413be70e; });
$parcel$export(module.exports, "useDroppable", function () { return $290836fe8d7e8057$export$d74e5d67dc2b3176; });

var $jbmdS = parcelRequire("jbmdS");

var $jCNM0 = parcelRequire("jCNM0");

var $2EYIn = parcelRequire("2EYIn");

var $wVnus = parcelRequire("wVnus");
const $290836fe8d7e8057$var$DndMonitorContext = /*#__PURE__*/ (0, $jbmdS.createContext)(null);
function $290836fe8d7e8057$export$1182af90218a7b81(listener) {
    const registerListener = (0, $jbmdS.useContext)($290836fe8d7e8057$var$DndMonitorContext);
    (0, $jbmdS.useEffect)(()=>{
        if (!registerListener) throw new Error("useDndMonitor must be used within a children of <DndContext>");
        const unsubscribe = registerListener(listener);
        return unsubscribe;
    }, [
        listener,
        registerListener
    ]);
}
function $290836fe8d7e8057$var$useDndMonitorProvider() {
    const [listeners] = (0, $jbmdS.useState)(()=>new Set());
    const registerListener = (0, $jbmdS.useCallback)((listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    }, [
        listeners
    ]);
    const dispatch = (0, $jbmdS.useCallback)((_ref)=>{
        let { type: type, event: event } = _ref;
        listeners.forEach((listener)=>{
            var _listener$type;
            return (_listener$type = listener[type]) == null ? void 0 : _listener$type.call(listener, event);
        });
    }, [
        listeners
    ]);
    return [
        dispatch,
        registerListener
    ];
}
const $290836fe8d7e8057$export$2547556495408594 = {
    draggable: "\n    To pick up a draggable item, press the space bar.\n    While dragging, use the arrow keys to move the item.\n    Press space again to drop the item in its new position, or press escape to cancel.\n  "
};
const $290836fe8d7e8057$export$6acb64047911dd54 = {
    onDragStart (_ref) {
        let { active: active } = _ref;
        return "Picked up draggable item " + active.id + ".";
    },
    onDragOver (_ref2) {
        let { active: active, over: over } = _ref2;
        if (over) return "Draggable item " + active.id + " was moved over droppable area " + over.id + ".";
        return "Draggable item " + active.id + " is no longer over a droppable area.";
    },
    onDragEnd (_ref3) {
        let { active: active, over: over } = _ref3;
        if (over) return "Draggable item " + active.id + " was dropped over droppable area " + over.id;
        return "Draggable item " + active.id + " was dropped.";
    },
    onDragCancel (_ref4) {
        let { active: active } = _ref4;
        return "Dragging was cancelled. Draggable item " + active.id + " was dropped.";
    }
};
function $290836fe8d7e8057$var$Accessibility(_ref) {
    let { announcements: announcements = $290836fe8d7e8057$export$6acb64047911dd54, container: container, hiddenTextDescribedById: hiddenTextDescribedById, screenReaderInstructions: screenReaderInstructions = $290836fe8d7e8057$export$2547556495408594 } = _ref;
    const { announce: announce, announcement: announcement } = (0, $wVnus.useAnnouncement)();
    const liveRegionId = (0, $2EYIn.useUniqueId)("DndLiveRegion");
    const [mounted, setMounted] = (0, $jbmdS.useState)(false);
    (0, $jbmdS.useEffect)(()=>{
        setMounted(true);
    }, []);
    $290836fe8d7e8057$export$1182af90218a7b81((0, $jbmdS.useMemo)(()=>({
            onDragStart (_ref2) {
                let { active: active } = _ref2;
                announce(announcements.onDragStart({
                    active: active
                }));
            },
            onDragMove (_ref3) {
                let { active: active, over: over } = _ref3;
                if (announcements.onDragMove) announce(announcements.onDragMove({
                    active: active,
                    over: over
                }));
            },
            onDragOver (_ref4) {
                let { active: active, over: over } = _ref4;
                announce(announcements.onDragOver({
                    active: active,
                    over: over
                }));
            },
            onDragEnd (_ref5) {
                let { active: active, over: over } = _ref5;
                announce(announcements.onDragEnd({
                    active: active,
                    over: over
                }));
            },
            onDragCancel (_ref6) {
                let { active: active, over: over } = _ref6;
                announce(announcements.onDragCancel({
                    active: active,
                    over: over
                }));
            }
        }), [
        announce,
        announcements
    ]));
    if (!mounted) return null;
    const markup = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $wVnus.HiddenText), {
        id: hiddenTextDescribedById,
        value: screenReaderInstructions.draggable
    }), (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $wVnus.LiveRegion), {
        id: liveRegionId,
        announcement: announcement
    }));
    return container ? (0, $jCNM0.createPortal)(markup, container) : markup;
}
var $290836fe8d7e8057$var$Action;
(function(Action) {
    Action["DragStart"] = "dragStart";
    Action["DragMove"] = "dragMove";
    Action["DragEnd"] = "dragEnd";
    Action["DragCancel"] = "dragCancel";
    Action["DragOver"] = "dragOver";
    Action["RegisterDroppable"] = "registerDroppable";
    Action["SetDroppableDisabled"] = "setDroppableDisabled";
    Action["UnregisterDroppable"] = "unregisterDroppable";
})($290836fe8d7e8057$var$Action || ($290836fe8d7e8057$var$Action = {}));
function $290836fe8d7e8057$var$noop() {}
function $290836fe8d7e8057$export$cc72dd71f4ec69eb(sensor, options) {
    return (0, $jbmdS.useMemo)(()=>({
            sensor: sensor,
            options: options != null ? options : {}
        }), [
        sensor,
        options
    ]);
}
function $290836fe8d7e8057$export$19012f58216d597f() {
    for(var _len = arguments.length, sensors = new Array(_len), _key = 0; _key < _len; _key++)sensors[_key] = arguments[_key];
    return (0, $jbmdS.useMemo)(()=>[
            ...sensors
        ].filter((sensor)=>sensor != null), [
        ...sensors
    ]);
}
const $290836fe8d7e8057$export$597cbd7bbd10deb4 = /*#__PURE__*/ Object.freeze({
    x: 0,
    y: 0
});
/**
 * Returns the distance between two points
 */ function $290836fe8d7e8057$var$distanceBetween(p1, p2) {
    return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
}
function $290836fe8d7e8057$var$getRelativeTransformOrigin(event, rect) {
    const eventCoordinates = (0, $2EYIn.getEventCoordinates)(event);
    if (!eventCoordinates) return "0 0";
    const transformOrigin = {
        x: (eventCoordinates.x - rect.left) / rect.width * 100,
        y: (eventCoordinates.y - rect.top) / rect.height * 100
    };
    return transformOrigin.x + "% " + transformOrigin.y + "%";
}
/**
 * Sort collisions from smallest to greatest value
 */ function $290836fe8d7e8057$var$sortCollisionsAsc(_ref, _ref2) {
    let { data: { value: a } } = _ref;
    let { data: { value: b } } = _ref2;
    return a - b;
}
/**
 * Sort collisions from greatest to smallest value
 */ function $290836fe8d7e8057$var$sortCollisionsDesc(_ref3, _ref4) {
    let { data: { value: a } } = _ref3;
    let { data: { value: b } } = _ref4;
    return b - a;
}
/**
 * Returns the coordinates of the corners of a given rectangle:
 * [TopLeft {x, y}, TopRight {x, y}, BottomLeft {x, y}, BottomRight {x, y}]
 */ function $290836fe8d7e8057$var$cornersOfRectangle(_ref5) {
    let { left: left, top: top, height: height, width: width } = _ref5;
    return [
        {
            x: left,
            y: top
        },
        {
            x: left + width,
            y: top
        },
        {
            x: left,
            y: top + height
        },
        {
            x: left + width,
            y: top + height
        }
    ];
}
function $290836fe8d7e8057$export$ef1beab6d7287295(collisions, property) {
    if (!collisions || collisions.length === 0) return null;
    const [firstCollision] = collisions;
    return property ? firstCollision[property] : firstCollision;
}
/**
 * Returns the coordinates of the center of a given ClientRect
 */ function $290836fe8d7e8057$var$centerOfRectangle(rect, left, top) {
    if (left === void 0) left = rect.left;
    if (top === void 0) top = rect.top;
    return {
        x: left + rect.width * 0.5,
        y: top + rect.height * 0.5
    };
}
/**
 * Returns the closest rectangles from an array of rectangles to the center of a given
 * rectangle.
 */ const $290836fe8d7e8057$export$c8e785ae6b74bab8 = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const centerRect = $290836fe8d7e8057$var$centerOfRectangle(collisionRect, collisionRect.left, collisionRect.top);
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const distBetween = $290836fe8d7e8057$var$distanceBetween($290836fe8d7e8057$var$centerOfRectangle(rect), centerRect);
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: distBetween
                }
            });
        }
    }
    return collisions.sort($290836fe8d7e8057$var$sortCollisionsAsc);
};
/**
 * Returns the closest rectangles from an array of rectangles to the corners of
 * another rectangle.
 */ const $290836fe8d7e8057$export$c3a6c1c7122b31c9 = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const corners = $290836fe8d7e8057$var$cornersOfRectangle(collisionRect);
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const rectCorners = $290836fe8d7e8057$var$cornersOfRectangle(rect);
            const distances = corners.reduce((accumulator, corner, index)=>{
                return accumulator + $290836fe8d7e8057$var$distanceBetween(rectCorners[index], corner);
            }, 0);
            const effectiveDistance = Number((distances / 4).toFixed(4));
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: effectiveDistance
                }
            });
        }
    }
    return collisions.sort($290836fe8d7e8057$var$sortCollisionsAsc);
};
/**
 * Returns the intersecting rectangle area between two rectangles
 */ function $290836fe8d7e8057$var$getIntersectionRatio(entry, target) {
    const top = Math.max(target.top, entry.top);
    const left = Math.max(target.left, entry.left);
    const right = Math.min(target.left + target.width, entry.left + entry.width);
    const bottom = Math.min(target.top + target.height, entry.top + entry.height);
    const width = right - left;
    const height = bottom - top;
    if (left < right && top < bottom) {
        const targetArea = target.width * target.height;
        const entryArea = entry.width * entry.height;
        const intersectionArea = width * height;
        const intersectionRatio = intersectionArea / (targetArea + entryArea - intersectionArea);
        return Number(intersectionRatio.toFixed(4));
    } // Rectangles do not overlap, or overlap has an area of zero (edge/corner overlap)
    return 0;
}
/**
 * Returns the rectangles that has the greatest intersection area with a given
 * rectangle in an array of rectangles.
 */ const $290836fe8d7e8057$export$953346c40b5eb62a = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const intersectionRatio = $290836fe8d7e8057$var$getIntersectionRatio(rect, collisionRect);
            if (intersectionRatio > 0) collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: intersectionRatio
                }
            });
        }
    }
    return collisions.sort($290836fe8d7e8057$var$sortCollisionsDesc);
};
/**
 * Check if a given point is contained within a bounding rectangle
 */ function $290836fe8d7e8057$var$isPointWithinRect(point, rect) {
    const { top: top, left: left, bottom: bottom, right: right } = rect;
    return top <= point.y && point.y <= bottom && left <= point.x && point.x <= right;
}
/**
 * Returns the rectangles that the pointer is hovering over
 */ const $290836fe8d7e8057$export$cd834c0ba378cb94 = (_ref)=>{
    let { droppableContainers: droppableContainers, droppableRects: droppableRects, pointerCoordinates: pointerCoordinates } = _ref;
    if (!pointerCoordinates) return [];
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect && $290836fe8d7e8057$var$isPointWithinRect(pointerCoordinates, rect)) {
            /* There may be more than a single rectangle intersecting
       * with the pointer coordinates. In order to sort the
       * colliding rectangles, we measure the distance between
       * the pointer and the corners of the intersecting rectangle
       */ const corners = $290836fe8d7e8057$var$cornersOfRectangle(rect);
            const distances = corners.reduce((accumulator, corner)=>{
                return accumulator + $290836fe8d7e8057$var$distanceBetween(pointerCoordinates, corner);
            }, 0);
            const effectiveDistance = Number((distances / 4).toFixed(4));
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: effectiveDistance
                }
            });
        }
    }
    return collisions.sort($290836fe8d7e8057$var$sortCollisionsAsc);
};
function $290836fe8d7e8057$var$adjustScale(transform, rect1, rect2) {
    return {
        ...transform,
        scaleX: rect1 && rect2 ? rect1.width / rect2.width : 1,
        scaleY: rect1 && rect2 ? rect1.height / rect2.height : 1
    };
}
function $290836fe8d7e8057$var$getRectDelta(rect1, rect2) {
    return rect1 && rect2 ? {
        x: rect1.left - rect2.left,
        y: rect1.top - rect2.top
    } : $290836fe8d7e8057$export$597cbd7bbd10deb4;
}
function $290836fe8d7e8057$var$createRectAdjustmentFn(modifier) {
    return function adjustClientRect(rect) {
        for(var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)adjustments[_key - 1] = arguments[_key];
        return adjustments.reduce((acc, adjustment)=>({
                ...acc,
                top: acc.top + modifier * adjustment.y,
                bottom: acc.bottom + modifier * adjustment.y,
                left: acc.left + modifier * adjustment.x,
                right: acc.right + modifier * adjustment.x
            }), {
            ...rect
        });
    };
}
const $290836fe8d7e8057$var$getAdjustedRect = /*#__PURE__*/ $290836fe8d7e8057$var$createRectAdjustmentFn(1);
function $290836fe8d7e8057$var$parseTransform(transform) {
    if (transform.startsWith("matrix3d(")) {
        const transformArray = transform.slice(9, -1).split(/, /);
        return {
            x: +transformArray[12],
            y: +transformArray[13],
            scaleX: +transformArray[0],
            scaleY: +transformArray[5]
        };
    } else if (transform.startsWith("matrix(")) {
        const transformArray = transform.slice(7, -1).split(/, /);
        return {
            x: +transformArray[4],
            y: +transformArray[5],
            scaleX: +transformArray[0],
            scaleY: +transformArray[3]
        };
    }
    return null;
}
function $290836fe8d7e8057$var$inverseTransform(rect, transform, transformOrigin) {
    const parsedTransform = $290836fe8d7e8057$var$parseTransform(transform);
    if (!parsedTransform) return rect;
    const { scaleX: scaleX, scaleY: scaleY, x: translateX, y: translateY } = parsedTransform;
    const x = rect.left - translateX - (1 - scaleX) * parseFloat(transformOrigin);
    const y = rect.top - translateY - (1 - scaleY) * parseFloat(transformOrigin.slice(transformOrigin.indexOf(" ") + 1));
    const w = scaleX ? rect.width / scaleX : rect.width;
    const h = scaleY ? rect.height / scaleY : rect.height;
    return {
        width: w,
        height: h,
        top: y,
        right: x + w,
        bottom: y + h,
        left: x
    };
}
const $290836fe8d7e8057$var$defaultOptions = {
    ignoreTransform: false
};
/**
 * Returns the bounding client rect of an element relative to the viewport.
 */ function $290836fe8d7e8057$export$b6aa1f30c53d7454(element, options) {
    if (options === void 0) options = $290836fe8d7e8057$var$defaultOptions;
    let rect = element.getBoundingClientRect();
    if (options.ignoreTransform) {
        const { transform: transform, transformOrigin: transformOrigin } = (0, $2EYIn.getWindow)(element).getComputedStyle(element);
        if (transform) rect = $290836fe8d7e8057$var$inverseTransform(rect, transform, transformOrigin);
    }
    const { top: top, left: left, width: width, height: height, bottom: bottom, right: right } = rect;
    return {
        top: top,
        left: left,
        width: width,
        height: height,
        bottom: bottom,
        right: right
    };
}
/**
 * Returns the bounding client rect of an element relative to the viewport.
 *
 * @remarks
 * The ClientRect returned by this method does not take into account transforms
 * applied to the element it measures.
 *
 */ function $290836fe8d7e8057$var$getTransformAgnosticClientRect(element) {
    return $290836fe8d7e8057$export$b6aa1f30c53d7454(element, {
        ignoreTransform: true
    });
}
function $290836fe8d7e8057$var$getWindowClientRect(element) {
    const width = element.innerWidth;
    const height = element.innerHeight;
    return {
        top: 0,
        left: 0,
        right: width,
        bottom: height,
        width: width,
        height: height
    };
}
function $290836fe8d7e8057$var$isFixed(node, computedStyle) {
    if (computedStyle === void 0) computedStyle = (0, $2EYIn.getWindow)(node).getComputedStyle(node);
    return computedStyle.position === "fixed";
}
function $290836fe8d7e8057$var$isScrollable(element, computedStyle) {
    if (computedStyle === void 0) computedStyle = (0, $2EYIn.getWindow)(element).getComputedStyle(element);
    const overflowRegex = /(auto|scroll|overlay)/;
    const properties = [
        "overflow",
        "overflowX",
        "overflowY"
    ];
    return properties.some((property)=>{
        const value = computedStyle[property];
        return typeof value === "string" ? overflowRegex.test(value) : false;
    });
}
function $290836fe8d7e8057$export$e4864aa91b5ed091(element, limit) {
    const scrollParents = [];
    function findScrollableAncestors(node) {
        if (limit != null && scrollParents.length >= limit) return scrollParents;
        if (!node) return scrollParents;
        if ((0, $2EYIn.isDocument)(node) && node.scrollingElement != null && !scrollParents.includes(node.scrollingElement)) {
            scrollParents.push(node.scrollingElement);
            return scrollParents;
        }
        if (!(0, $2EYIn.isHTMLElement)(node) || (0, $2EYIn.isSVGElement)(node)) return scrollParents;
        if (scrollParents.includes(node)) return scrollParents;
        const computedStyle = (0, $2EYIn.getWindow)(element).getComputedStyle(node);
        if (node !== element) {
            if ($290836fe8d7e8057$var$isScrollable(node, computedStyle)) scrollParents.push(node);
        }
        if ($290836fe8d7e8057$var$isFixed(node, computedStyle)) return scrollParents;
        return findScrollableAncestors(node.parentNode);
    }
    if (!element) return scrollParents;
    return findScrollableAncestors(element);
}
function $290836fe8d7e8057$var$getFirstScrollableAncestor(node) {
    const [firstScrollableAncestor] = $290836fe8d7e8057$export$e4864aa91b5ed091(node, 1);
    return firstScrollableAncestor != null ? firstScrollableAncestor : null;
}
function $290836fe8d7e8057$var$getScrollableElement(element) {
    if (!(0, $2EYIn.canUseDOM) || !element) return null;
    if ((0, $2EYIn.isWindow)(element)) return element;
    if (!(0, $2EYIn.isNode)(element)) return null;
    if ((0, $2EYIn.isDocument)(element) || element === (0, $2EYIn.getOwnerDocument)(element).scrollingElement) return window;
    if ((0, $2EYIn.isHTMLElement)(element)) return element;
    return null;
}
function $290836fe8d7e8057$var$getScrollXCoordinate(element) {
    if ((0, $2EYIn.isWindow)(element)) return element.scrollX;
    return element.scrollLeft;
}
function $290836fe8d7e8057$var$getScrollYCoordinate(element) {
    if ((0, $2EYIn.isWindow)(element)) return element.scrollY;
    return element.scrollTop;
}
function $290836fe8d7e8057$var$getScrollCoordinates(element) {
    return {
        x: $290836fe8d7e8057$var$getScrollXCoordinate(element),
        y: $290836fe8d7e8057$var$getScrollYCoordinate(element)
    };
}
var $290836fe8d7e8057$var$Direction;
(function(Direction) {
    Direction[Direction["Forward"] = 1] = "Forward";
    Direction[Direction["Backward"] = -1] = "Backward";
})($290836fe8d7e8057$var$Direction || ($290836fe8d7e8057$var$Direction = {}));
function $290836fe8d7e8057$var$isDocumentScrollingElement(element) {
    if (!(0, $2EYIn.canUseDOM) || !element) return false;
    return element === document.scrollingElement;
}
function $290836fe8d7e8057$var$getScrollPosition(scrollingContainer) {
    const minScroll = {
        x: 0,
        y: 0
    };
    const dimensions = $290836fe8d7e8057$var$isDocumentScrollingElement(scrollingContainer) ? {
        height: window.innerHeight,
        width: window.innerWidth
    } : {
        height: scrollingContainer.clientHeight,
        width: scrollingContainer.clientWidth
    };
    const maxScroll = {
        x: scrollingContainer.scrollWidth - dimensions.width,
        y: scrollingContainer.scrollHeight - dimensions.height
    };
    const isTop = scrollingContainer.scrollTop <= minScroll.y;
    const isLeft = scrollingContainer.scrollLeft <= minScroll.x;
    const isBottom = scrollingContainer.scrollTop >= maxScroll.y;
    const isRight = scrollingContainer.scrollLeft >= maxScroll.x;
    return {
        isTop: isTop,
        isLeft: isLeft,
        isBottom: isBottom,
        isRight: isRight,
        maxScroll: maxScroll,
        minScroll: minScroll
    };
}
const $290836fe8d7e8057$var$defaultThreshold = {
    x: 0.2,
    y: 0.2
};
function $290836fe8d7e8057$var$getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, _ref, acceleration, thresholdPercentage) {
    let { top: top, left: left, right: right, bottom: bottom } = _ref;
    if (acceleration === void 0) acceleration = 10;
    if (thresholdPercentage === void 0) thresholdPercentage = $290836fe8d7e8057$var$defaultThreshold;
    const { isTop: isTop, isBottom: isBottom, isLeft: isLeft, isRight: isRight } = $290836fe8d7e8057$var$getScrollPosition(scrollContainer);
    const direction = {
        x: 0,
        y: 0
    };
    const speed = {
        x: 0,
        y: 0
    };
    const threshold = {
        height: scrollContainerRect.height * thresholdPercentage.y,
        width: scrollContainerRect.width * thresholdPercentage.x
    };
    if (!isTop && top <= scrollContainerRect.top + threshold.height) {
        // Scroll Up
        direction.y = $290836fe8d7e8057$var$Direction.Backward;
        speed.y = acceleration * Math.abs((scrollContainerRect.top + threshold.height - top) / threshold.height);
    } else if (!isBottom && bottom >= scrollContainerRect.bottom - threshold.height) {
        // Scroll Down
        direction.y = $290836fe8d7e8057$var$Direction.Forward;
        speed.y = acceleration * Math.abs((scrollContainerRect.bottom - threshold.height - bottom) / threshold.height);
    }
    if (!isRight && right >= scrollContainerRect.right - threshold.width) {
        // Scroll Right
        direction.x = $290836fe8d7e8057$var$Direction.Forward;
        speed.x = acceleration * Math.abs((scrollContainerRect.right - threshold.width - right) / threshold.width);
    } else if (!isLeft && left <= scrollContainerRect.left + threshold.width) {
        // Scroll Left
        direction.x = $290836fe8d7e8057$var$Direction.Backward;
        speed.x = acceleration * Math.abs((scrollContainerRect.left + threshold.width - left) / threshold.width);
    }
    return {
        direction: direction,
        speed: speed
    };
}
function $290836fe8d7e8057$var$getScrollElementRect(element) {
    if (element === document.scrollingElement) {
        const { innerWidth: innerWidth, innerHeight: innerHeight } = window;
        return {
            top: 0,
            left: 0,
            right: innerWidth,
            bottom: innerHeight,
            width: innerWidth,
            height: innerHeight
        };
    }
    const { top: top, left: left, right: right, bottom: bottom } = element.getBoundingClientRect();
    return {
        top: top,
        left: left,
        right: right,
        bottom: bottom,
        width: element.clientWidth,
        height: element.clientHeight
    };
}
function $290836fe8d7e8057$var$getScrollOffsets(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return (0, $2EYIn.add)(acc, $290836fe8d7e8057$var$getScrollCoordinates(node));
    }, $290836fe8d7e8057$export$597cbd7bbd10deb4);
}
function $290836fe8d7e8057$var$getScrollXOffset(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return acc + $290836fe8d7e8057$var$getScrollXCoordinate(node);
    }, 0);
}
function $290836fe8d7e8057$var$getScrollYOffset(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return acc + $290836fe8d7e8057$var$getScrollYCoordinate(node);
    }, 0);
}
function $290836fe8d7e8057$var$scrollIntoViewIfNeeded(element, measure) {
    if (measure === void 0) measure = $290836fe8d7e8057$export$b6aa1f30c53d7454;
    if (!element) return;
    const { top: top, left: left, bottom: bottom, right: right } = measure(element);
    const firstScrollableAncestor = $290836fe8d7e8057$var$getFirstScrollableAncestor(element);
    if (!firstScrollableAncestor) return;
    if (bottom <= 0 || right <= 0 || top >= window.innerHeight || left >= window.innerWidth) element.scrollIntoView({
        block: "center",
        inline: "center"
    });
}
const $290836fe8d7e8057$var$properties = [
    [
        "x",
        [
            "left",
            "right"
        ],
        $290836fe8d7e8057$var$getScrollXOffset
    ],
    [
        "y",
        [
            "top",
            "bottom"
        ],
        $290836fe8d7e8057$var$getScrollYOffset
    ]
];
class $290836fe8d7e8057$var$Rect {
    constructor(rect, element){
        this.rect = void 0;
        this.width = void 0;
        this.height = void 0;
        this.top = void 0;
        this.bottom = void 0;
        this.right = void 0;
        this.left = void 0;
        const scrollableAncestors = $290836fe8d7e8057$export$e4864aa91b5ed091(element);
        const scrollOffsets = $290836fe8d7e8057$var$getScrollOffsets(scrollableAncestors);
        this.rect = {
            ...rect
        };
        this.width = rect.width;
        this.height = rect.height;
        for (const [axis, keys, getScrollOffset] of $290836fe8d7e8057$var$properties)for (const key of keys)Object.defineProperty(this, key, {
            get: ()=>{
                const currentOffsets = getScrollOffset(scrollableAncestors);
                const scrollOffsetsDeltla = scrollOffsets[axis] - currentOffsets;
                return this.rect[key] + scrollOffsetsDeltla;
            },
            enumerable: true
        });
        Object.defineProperty(this, "rect", {
            enumerable: false
        });
    }
}
class $290836fe8d7e8057$var$Listeners {
    constructor(target){
        this.target = void 0;
        this.listeners = [];
        this.removeAll = ()=>{
            this.listeners.forEach((listener)=>{
                var _this$target;
                return (_this$target = this.target) == null ? void 0 : _this$target.removeEventListener(...listener);
            });
        };
        this.target = target;
    }
    add(eventName, handler, options) {
        var _this$target2;
        (_this$target2 = this.target) == null || _this$target2.addEventListener(eventName, handler, options);
        this.listeners.push([
            eventName,
            handler,
            options
        ]);
    }
}
function $290836fe8d7e8057$var$getEventListenerTarget(target) {
    // If the `event.target` element is removed from the document events will still be targeted
    // at it, and hence won't always bubble up to the window or document anymore.
    // If there is any risk of an element being removed while it is being dragged,
    // the best practice is to attach the event listeners directly to the target.
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget
    const { EventTarget: EventTarget } = (0, $2EYIn.getWindow)(target);
    return target instanceof EventTarget ? target : (0, $2EYIn.getOwnerDocument)(target);
}
function $290836fe8d7e8057$var$hasExceededDistance(delta, measurement) {
    const dx = Math.abs(delta.x);
    const dy = Math.abs(delta.y);
    if (typeof measurement === "number") return Math.sqrt(dx ** 2 + dy ** 2) > measurement;
    if ("x" in measurement && "y" in measurement) return dx > measurement.x && dy > measurement.y;
    if ("x" in measurement) return dx > measurement.x;
    if ("y" in measurement) return dy > measurement.y;
    return false;
}
var $290836fe8d7e8057$var$EventName;
(function(EventName) {
    EventName["Click"] = "click";
    EventName["DragStart"] = "dragstart";
    EventName["Keydown"] = "keydown";
    EventName["ContextMenu"] = "contextmenu";
    EventName["Resize"] = "resize";
    EventName["SelectionChange"] = "selectionchange";
    EventName["VisibilityChange"] = "visibilitychange";
})($290836fe8d7e8057$var$EventName || ($290836fe8d7e8057$var$EventName = {}));
function $290836fe8d7e8057$var$preventDefault(event) {
    event.preventDefault();
}
function $290836fe8d7e8057$var$stopPropagation(event) {
    event.stopPropagation();
}
var $290836fe8d7e8057$export$a8b1916dba3ae88b;
(function(KeyboardCode) {
    KeyboardCode["Space"] = "Space";
    KeyboardCode["Down"] = "ArrowDown";
    KeyboardCode["Right"] = "ArrowRight";
    KeyboardCode["Left"] = "ArrowLeft";
    KeyboardCode["Up"] = "ArrowUp";
    KeyboardCode["Esc"] = "Escape";
    KeyboardCode["Enter"] = "Enter";
    KeyboardCode["Tab"] = "Tab";
})($290836fe8d7e8057$export$a8b1916dba3ae88b || ($290836fe8d7e8057$export$a8b1916dba3ae88b = {}));
const $290836fe8d7e8057$var$defaultKeyboardCodes = {
    start: [
        $290836fe8d7e8057$export$a8b1916dba3ae88b.Space,
        $290836fe8d7e8057$export$a8b1916dba3ae88b.Enter
    ],
    cancel: [
        $290836fe8d7e8057$export$a8b1916dba3ae88b.Esc
    ],
    end: [
        $290836fe8d7e8057$export$a8b1916dba3ae88b.Space,
        $290836fe8d7e8057$export$a8b1916dba3ae88b.Enter,
        $290836fe8d7e8057$export$a8b1916dba3ae88b.Tab
    ]
};
const $290836fe8d7e8057$export$ae4c9a18005b0235 = (event, _ref)=>{
    let { currentCoordinates: currentCoordinates } = _ref;
    switch(event.code){
        case $290836fe8d7e8057$export$a8b1916dba3ae88b.Right:
            return {
                ...currentCoordinates,
                x: currentCoordinates.x + 25
            };
        case $290836fe8d7e8057$export$a8b1916dba3ae88b.Left:
            return {
                ...currentCoordinates,
                x: currentCoordinates.x - 25
            };
        case $290836fe8d7e8057$export$a8b1916dba3ae88b.Down:
            return {
                ...currentCoordinates,
                y: currentCoordinates.y + 25
            };
        case $290836fe8d7e8057$export$a8b1916dba3ae88b.Up:
            return {
                ...currentCoordinates,
                y: currentCoordinates.y - 25
            };
    }
    return undefined;
};
class $290836fe8d7e8057$export$44d67f2a438aeba9 {
    constructor(props){
        this.props = void 0;
        this.autoScrollEnabled = false;
        this.referenceCoordinates = void 0;
        this.listeners = void 0;
        this.windowListeners = void 0;
        this.props = props;
        const { event: { target: target } } = props;
        this.props = props;
        this.listeners = new $290836fe8d7e8057$var$Listeners((0, $2EYIn.getOwnerDocument)(target));
        this.windowListeners = new $290836fe8d7e8057$var$Listeners((0, $2EYIn.getWindow)(target));
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.attach();
    }
    attach() {
        this.handleStart();
        this.windowListeners.add($290836fe8d7e8057$var$EventName.Resize, this.handleCancel);
        this.windowListeners.add($290836fe8d7e8057$var$EventName.VisibilityChange, this.handleCancel);
        setTimeout(()=>this.listeners.add($290836fe8d7e8057$var$EventName.Keydown, this.handleKeyDown));
    }
    handleStart() {
        const { activeNode: activeNode, onStart: onStart } = this.props;
        const node = activeNode.node.current;
        if (node) $290836fe8d7e8057$var$scrollIntoViewIfNeeded(node);
        onStart($290836fe8d7e8057$export$597cbd7bbd10deb4);
    }
    handleKeyDown(event) {
        if ((0, $2EYIn.isKeyboardEvent)(event)) {
            const { active: active, context: context, options: options } = this.props;
            const { keyboardCodes: keyboardCodes = $290836fe8d7e8057$var$defaultKeyboardCodes, coordinateGetter: coordinateGetter = $290836fe8d7e8057$export$ae4c9a18005b0235, scrollBehavior: scrollBehavior = "smooth" } = options;
            const { code: code } = event;
            if (keyboardCodes.end.includes(code)) {
                this.handleEnd(event);
                return;
            }
            if (keyboardCodes.cancel.includes(code)) {
                this.handleCancel(event);
                return;
            }
            const { collisionRect: collisionRect } = context.current;
            const currentCoordinates = collisionRect ? {
                x: collisionRect.left,
                y: collisionRect.top
            } : $290836fe8d7e8057$export$597cbd7bbd10deb4;
            if (!this.referenceCoordinates) this.referenceCoordinates = currentCoordinates;
            const newCoordinates = coordinateGetter(event, {
                active: active,
                context: context.current,
                currentCoordinates: currentCoordinates
            });
            if (newCoordinates) {
                const coordinatesDelta = (0, $2EYIn.subtract)(newCoordinates, currentCoordinates);
                const scrollDelta = {
                    x: 0,
                    y: 0
                };
                const { scrollableAncestors: scrollableAncestors } = context.current;
                for (const scrollContainer of scrollableAncestors){
                    const direction = event.code;
                    const { isTop: isTop, isRight: isRight, isLeft: isLeft, isBottom: isBottom, maxScroll: maxScroll, minScroll: minScroll } = $290836fe8d7e8057$var$getScrollPosition(scrollContainer);
                    const scrollElementRect = $290836fe8d7e8057$var$getScrollElementRect(scrollContainer);
                    const clampedCoordinates = {
                        x: Math.min(direction === $290836fe8d7e8057$export$a8b1916dba3ae88b.Right ? scrollElementRect.right - scrollElementRect.width / 2 : scrollElementRect.right, Math.max(direction === $290836fe8d7e8057$export$a8b1916dba3ae88b.Right ? scrollElementRect.left : scrollElementRect.left + scrollElementRect.width / 2, newCoordinates.x)),
                        y: Math.min(direction === $290836fe8d7e8057$export$a8b1916dba3ae88b.Down ? scrollElementRect.bottom - scrollElementRect.height / 2 : scrollElementRect.bottom, Math.max(direction === $290836fe8d7e8057$export$a8b1916dba3ae88b.Down ? scrollElementRect.top : scrollElementRect.top + scrollElementRect.height / 2, newCoordinates.y))
                    };
                    const canScrollX = direction === $290836fe8d7e8057$export$a8b1916dba3ae88b.Right && !isRight || direction === $290836fe8d7e8057$export$a8b1916dba3ae88b.Left && !isLeft;
                    const canScrollY = direction === $290836fe8d7e8057$export$a8b1916dba3ae88b.Down && !isBottom || direction === $290836fe8d7e8057$export$a8b1916dba3ae88b.Up && !isTop;
                    if (canScrollX && clampedCoordinates.x !== newCoordinates.x) {
                        const newScrollCoordinates = scrollContainer.scrollLeft + coordinatesDelta.x;
                        const canScrollToNewCoordinates = direction === $290836fe8d7e8057$export$a8b1916dba3ae88b.Right && newScrollCoordinates <= maxScroll.x || direction === $290836fe8d7e8057$export$a8b1916dba3ae88b.Left && newScrollCoordinates >= minScroll.x;
                        if (canScrollToNewCoordinates && !coordinatesDelta.y) {
                            // We don't need to update coordinates, the scroll adjustment alone will trigger
                            // logic to auto-detect the new container we are over
                            scrollContainer.scrollTo({
                                left: newScrollCoordinates,
                                behavior: scrollBehavior
                            });
                            return;
                        }
                        if (canScrollToNewCoordinates) scrollDelta.x = scrollContainer.scrollLeft - newScrollCoordinates;
                        else scrollDelta.x = direction === $290836fe8d7e8057$export$a8b1916dba3ae88b.Right ? scrollContainer.scrollLeft - maxScroll.x : scrollContainer.scrollLeft - minScroll.x;
                        if (scrollDelta.x) scrollContainer.scrollBy({
                            left: -scrollDelta.x,
                            behavior: scrollBehavior
                        });
                        break;
                    } else if (canScrollY && clampedCoordinates.y !== newCoordinates.y) {
                        const newScrollCoordinates = scrollContainer.scrollTop + coordinatesDelta.y;
                        const canScrollToNewCoordinates = direction === $290836fe8d7e8057$export$a8b1916dba3ae88b.Down && newScrollCoordinates <= maxScroll.y || direction === $290836fe8d7e8057$export$a8b1916dba3ae88b.Up && newScrollCoordinates >= minScroll.y;
                        if (canScrollToNewCoordinates && !coordinatesDelta.x) {
                            // We don't need to update coordinates, the scroll adjustment alone will trigger
                            // logic to auto-detect the new container we are over
                            scrollContainer.scrollTo({
                                top: newScrollCoordinates,
                                behavior: scrollBehavior
                            });
                            return;
                        }
                        if (canScrollToNewCoordinates) scrollDelta.y = scrollContainer.scrollTop - newScrollCoordinates;
                        else scrollDelta.y = direction === $290836fe8d7e8057$export$a8b1916dba3ae88b.Down ? scrollContainer.scrollTop - maxScroll.y : scrollContainer.scrollTop - minScroll.y;
                        if (scrollDelta.y) scrollContainer.scrollBy({
                            top: -scrollDelta.y,
                            behavior: scrollBehavior
                        });
                        break;
                    }
                }
                this.handleMove(event, (0, $2EYIn.add)((0, $2EYIn.subtract)(newCoordinates, this.referenceCoordinates), scrollDelta));
            }
        }
    }
    handleMove(event, coordinates) {
        const { onMove: onMove } = this.props;
        event.preventDefault();
        onMove(coordinates);
    }
    handleEnd(event) {
        const { onEnd: onEnd } = this.props;
        event.preventDefault();
        this.detach();
        onEnd();
    }
    handleCancel(event) {
        const { onCancel: onCancel } = this.props;
        event.preventDefault();
        this.detach();
        onCancel();
    }
    detach() {
        this.listeners.removeAll();
        this.windowListeners.removeAll();
    }
}
$290836fe8d7e8057$export$44d67f2a438aeba9.activators = [
    {
        eventName: "onKeyDown",
        handler: (event, _ref, _ref2)=>{
            let { keyboardCodes: keyboardCodes = $290836fe8d7e8057$var$defaultKeyboardCodes, onActivation: onActivation } = _ref;
            let { active: active } = _ref2;
            const { code: code } = event.nativeEvent;
            if (keyboardCodes.start.includes(code)) {
                const activator = active.activatorNode.current;
                if (activator && event.target !== activator) return false;
                event.preventDefault();
                onActivation == null || onActivation({
                    event: event.nativeEvent
                });
                return true;
            }
            return false;
        }
    }
];
function $290836fe8d7e8057$var$isDistanceConstraint(constraint) {
    return Boolean(constraint && "distance" in constraint);
}
function $290836fe8d7e8057$var$isDelayConstraint(constraint) {
    return Boolean(constraint && "delay" in constraint);
}
class $290836fe8d7e8057$var$AbstractPointerSensor {
    constructor(props, events, listenerTarget){
        var _getEventCoordinates;
        if (listenerTarget === void 0) listenerTarget = $290836fe8d7e8057$var$getEventListenerTarget(props.event.target);
        this.props = void 0;
        this.events = void 0;
        this.autoScrollEnabled = true;
        this.document = void 0;
        this.activated = false;
        this.initialCoordinates = void 0;
        this.timeoutId = null;
        this.listeners = void 0;
        this.documentListeners = void 0;
        this.windowListeners = void 0;
        this.props = props;
        this.events = events;
        const { event: event } = props;
        const { target: target } = event;
        this.props = props;
        this.events = events;
        this.document = (0, $2EYIn.getOwnerDocument)(target);
        this.documentListeners = new $290836fe8d7e8057$var$Listeners(this.document);
        this.listeners = new $290836fe8d7e8057$var$Listeners(listenerTarget);
        this.windowListeners = new $290836fe8d7e8057$var$Listeners((0, $2EYIn.getWindow)(target));
        this.initialCoordinates = (_getEventCoordinates = (0, $2EYIn.getEventCoordinates)(event)) != null ? _getEventCoordinates : $290836fe8d7e8057$export$597cbd7bbd10deb4;
        this.handleStart = this.handleStart.bind(this);
        this.handleMove = this.handleMove.bind(this);
        this.handleEnd = this.handleEnd.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.removeTextSelection = this.removeTextSelection.bind(this);
        this.attach();
    }
    attach() {
        const { events: events, props: { options: { activationConstraint: activationConstraint, bypassActivationConstraint: bypassActivationConstraint } } } = this;
        this.listeners.add(events.move.name, this.handleMove, {
            passive: false
        });
        this.listeners.add(events.end.name, this.handleEnd);
        if (events.cancel) this.listeners.add(events.cancel.name, this.handleCancel);
        this.windowListeners.add($290836fe8d7e8057$var$EventName.Resize, this.handleCancel);
        this.windowListeners.add($290836fe8d7e8057$var$EventName.DragStart, $290836fe8d7e8057$var$preventDefault);
        this.windowListeners.add($290836fe8d7e8057$var$EventName.VisibilityChange, this.handleCancel);
        this.windowListeners.add($290836fe8d7e8057$var$EventName.ContextMenu, $290836fe8d7e8057$var$preventDefault);
        this.documentListeners.add($290836fe8d7e8057$var$EventName.Keydown, this.handleKeydown);
        if (activationConstraint) {
            if (bypassActivationConstraint != null && bypassActivationConstraint({
                event: this.props.event,
                activeNode: this.props.activeNode,
                options: this.props.options
            })) return this.handleStart();
            if ($290836fe8d7e8057$var$isDelayConstraint(activationConstraint)) {
                this.timeoutId = setTimeout(this.handleStart, activationConstraint.delay);
                this.handlePending(activationConstraint);
                return;
            }
            if ($290836fe8d7e8057$var$isDistanceConstraint(activationConstraint)) {
                this.handlePending(activationConstraint);
                return;
            }
        }
        this.handleStart();
    }
    detach() {
        this.listeners.removeAll();
        this.windowListeners.removeAll(); // Wait until the next event loop before removing document listeners
        // This is necessary because we listen for `click` and `selection` events on the document
        setTimeout(this.documentListeners.removeAll, 50);
        if (this.timeoutId !== null) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
    }
    handlePending(constraint, offset) {
        const { active: active, onPending: onPending } = this.props;
        onPending(active, constraint, this.initialCoordinates, offset);
    }
    handleStart() {
        const { initialCoordinates: initialCoordinates } = this;
        const { onStart: onStart } = this.props;
        if (initialCoordinates) {
            this.activated = true; // Stop propagation of click events once activation constraints are met
            this.documentListeners.add($290836fe8d7e8057$var$EventName.Click, $290836fe8d7e8057$var$stopPropagation, {
                capture: true
            }); // Remove any text selection from the document
            this.removeTextSelection(); // Prevent further text selection while dragging
            this.documentListeners.add($290836fe8d7e8057$var$EventName.SelectionChange, this.removeTextSelection);
            onStart(initialCoordinates);
        }
    }
    handleMove(event) {
        var _getEventCoordinates2;
        const { activated: activated, initialCoordinates: initialCoordinates, props: props } = this;
        const { onMove: onMove, options: { activationConstraint: activationConstraint } } = props;
        if (!initialCoordinates) return;
        const coordinates = (_getEventCoordinates2 = (0, $2EYIn.getEventCoordinates)(event)) != null ? _getEventCoordinates2 : $290836fe8d7e8057$export$597cbd7bbd10deb4;
        const delta = (0, $2EYIn.subtract)(initialCoordinates, coordinates); // Constraint validation
        if (!activated && activationConstraint) {
            if ($290836fe8d7e8057$var$isDistanceConstraint(activationConstraint)) {
                if (activationConstraint.tolerance != null && $290836fe8d7e8057$var$hasExceededDistance(delta, activationConstraint.tolerance)) return this.handleCancel();
                if ($290836fe8d7e8057$var$hasExceededDistance(delta, activationConstraint.distance)) return this.handleStart();
            }
            if ($290836fe8d7e8057$var$isDelayConstraint(activationConstraint)) {
                if ($290836fe8d7e8057$var$hasExceededDistance(delta, activationConstraint.tolerance)) return this.handleCancel();
            }
            this.handlePending(activationConstraint, delta);
            return;
        }
        if (event.cancelable) event.preventDefault();
        onMove(coordinates);
    }
    handleEnd() {
        const { onAbort: onAbort, onEnd: onEnd } = this.props;
        this.detach();
        if (!this.activated) onAbort(this.props.active);
        onEnd();
    }
    handleCancel() {
        const { onAbort: onAbort, onCancel: onCancel } = this.props;
        this.detach();
        if (!this.activated) onAbort(this.props.active);
        onCancel();
    }
    handleKeydown(event) {
        if (event.code === $290836fe8d7e8057$export$a8b1916dba3ae88b.Esc) this.handleCancel();
    }
    removeTextSelection() {
        var _this$document$getSel;
        (_this$document$getSel = this.document.getSelection()) == null || _this$document$getSel.removeAllRanges();
    }
}
const $290836fe8d7e8057$var$events = {
    cancel: {
        name: "pointercancel"
    },
    move: {
        name: "pointermove"
    },
    end: {
        name: "pointerup"
    }
};
class $290836fe8d7e8057$export$b26af955418d6638 extends $290836fe8d7e8057$var$AbstractPointerSensor {
    constructor(props){
        const { event: event } = props; // Pointer events stop firing if the target is unmounted while dragging
        // Therefore we attach listeners to the owner document instead
        const listenerTarget = (0, $2EYIn.getOwnerDocument)(event.target);
        super(props, $290836fe8d7e8057$var$events, listenerTarget);
    }
}
$290836fe8d7e8057$export$b26af955418d6638.activators = [
    {
        eventName: "onPointerDown",
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            if (!event.isPrimary || event.button !== 0) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
const $290836fe8d7e8057$var$events$1 = {
    move: {
        name: "mousemove"
    },
    end: {
        name: "mouseup"
    }
};
var $290836fe8d7e8057$var$MouseButton;
(function(MouseButton) {
    MouseButton[MouseButton["RightClick"] = 2] = "RightClick";
})($290836fe8d7e8057$var$MouseButton || ($290836fe8d7e8057$var$MouseButton = {}));
class $290836fe8d7e8057$export$b28554b50bf7f273 extends $290836fe8d7e8057$var$AbstractPointerSensor {
    constructor(props){
        super(props, $290836fe8d7e8057$var$events$1, (0, $2EYIn.getOwnerDocument)(props.event.target));
    }
}
$290836fe8d7e8057$export$b28554b50bf7f273.activators = [
    {
        eventName: "onMouseDown",
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            if (event.button === $290836fe8d7e8057$var$MouseButton.RightClick) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
const $290836fe8d7e8057$var$events$2 = {
    cancel: {
        name: "touchcancel"
    },
    move: {
        name: "touchmove"
    },
    end: {
        name: "touchend"
    }
};
class $290836fe8d7e8057$export$19b41baf2e1bcdc0 extends $290836fe8d7e8057$var$AbstractPointerSensor {
    constructor(props){
        super(props, $290836fe8d7e8057$var$events$2);
    }
    static setup() {
        // Adding a non-capture and non-passive `touchmove` listener in order
        // to force `event.preventDefault()` calls to work in dynamically added
        // touchmove event handlers. This is required for iOS Safari.
        window.addEventListener($290836fe8d7e8057$var$events$2.move.name, noop, {
            capture: false,
            passive: false
        });
        return function teardown() {
            window.removeEventListener($290836fe8d7e8057$var$events$2.move.name, noop);
        }; // We create a new handler because the teardown function of another sensor
        // could remove our event listener if we use a referentially equal listener.
        function noop() {}
    }
}
$290836fe8d7e8057$export$19b41baf2e1bcdc0.activators = [
    {
        eventName: "onTouchStart",
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            const { touches: touches } = event;
            if (touches.length > 1) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
var $290836fe8d7e8057$export$eefe60e26f04c318;
(function(AutoScrollActivator) {
    AutoScrollActivator[AutoScrollActivator["Pointer"] = 0] = "Pointer";
    AutoScrollActivator[AutoScrollActivator["DraggableRect"] = 1] = "DraggableRect";
})($290836fe8d7e8057$export$eefe60e26f04c318 || ($290836fe8d7e8057$export$eefe60e26f04c318 = {}));
var $290836fe8d7e8057$export$f93aa492a37e1b0e;
(function(TraversalOrder) {
    TraversalOrder[TraversalOrder["TreeOrder"] = 0] = "TreeOrder";
    TraversalOrder[TraversalOrder["ReversedTreeOrder"] = 1] = "ReversedTreeOrder";
})($290836fe8d7e8057$export$f93aa492a37e1b0e || ($290836fe8d7e8057$export$f93aa492a37e1b0e = {}));
function $290836fe8d7e8057$var$useAutoScroller(_ref) {
    let { acceleration: acceleration, activator: activator = $290836fe8d7e8057$export$eefe60e26f04c318.Pointer, canScroll: canScroll, draggingRect: draggingRect, enabled: enabled, interval: interval = 5, order: order = $290836fe8d7e8057$export$f93aa492a37e1b0e.TreeOrder, pointerCoordinates: pointerCoordinates, scrollableAncestors: scrollableAncestors, scrollableAncestorRects: scrollableAncestorRects, delta: delta, threshold: threshold } = _ref;
    const scrollIntent = $290836fe8d7e8057$var$useScrollIntent({
        delta: delta,
        disabled: !enabled
    });
    const [setAutoScrollInterval, clearAutoScrollInterval] = (0, $2EYIn.useInterval)();
    const scrollSpeed = (0, $jbmdS.useRef)({
        x: 0,
        y: 0
    });
    const scrollDirection = (0, $jbmdS.useRef)({
        x: 0,
        y: 0
    });
    const rect = (0, $jbmdS.useMemo)(()=>{
        switch(activator){
            case $290836fe8d7e8057$export$eefe60e26f04c318.Pointer:
                return pointerCoordinates ? {
                    top: pointerCoordinates.y,
                    bottom: pointerCoordinates.y,
                    left: pointerCoordinates.x,
                    right: pointerCoordinates.x
                } : null;
            case $290836fe8d7e8057$export$eefe60e26f04c318.DraggableRect:
                return draggingRect;
        }
    }, [
        activator,
        draggingRect,
        pointerCoordinates
    ]);
    const scrollContainerRef = (0, $jbmdS.useRef)(null);
    const autoScroll = (0, $jbmdS.useCallback)(()=>{
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;
        const scrollLeft = scrollSpeed.current.x * scrollDirection.current.x;
        const scrollTop = scrollSpeed.current.y * scrollDirection.current.y;
        scrollContainer.scrollBy(scrollLeft, scrollTop);
    }, []);
    const sortedScrollableAncestors = (0, $jbmdS.useMemo)(()=>order === $290836fe8d7e8057$export$f93aa492a37e1b0e.TreeOrder ? [
            ...scrollableAncestors
        ].reverse() : scrollableAncestors, [
        order,
        scrollableAncestors
    ]);
    (0, $jbmdS.useEffect)(()=>{
        if (!enabled || !scrollableAncestors.length || !rect) {
            clearAutoScrollInterval();
            return;
        }
        for (const scrollContainer of sortedScrollableAncestors){
            if ((canScroll == null ? void 0 : canScroll(scrollContainer)) === false) continue;
            const index = scrollableAncestors.indexOf(scrollContainer);
            const scrollContainerRect = scrollableAncestorRects[index];
            if (!scrollContainerRect) continue;
            const { direction: direction, speed: speed } = $290836fe8d7e8057$var$getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, rect, acceleration, threshold);
            for (const axis of [
                "x",
                "y"
            ])if (!scrollIntent[axis][direction[axis]]) {
                speed[axis] = 0;
                direction[axis] = 0;
            }
            if (speed.x > 0 || speed.y > 0) {
                clearAutoScrollInterval();
                scrollContainerRef.current = scrollContainer;
                setAutoScrollInterval(autoScroll, interval);
                scrollSpeed.current = speed;
                scrollDirection.current = direction;
                return;
            }
        }
        scrollSpeed.current = {
            x: 0,
            y: 0
        };
        scrollDirection.current = {
            x: 0,
            y: 0
        };
        clearAutoScrollInterval();
    }, [
        acceleration,
        autoScroll,
        canScroll,
        clearAutoScrollInterval,
        enabled,
        interval,
        JSON.stringify(rect),
        JSON.stringify(scrollIntent),
        setAutoScrollInterval,
        scrollableAncestors,
        sortedScrollableAncestors,
        scrollableAncestorRects,
        JSON.stringify(threshold)
    ]);
}
const $290836fe8d7e8057$var$defaultScrollIntent = {
    x: {
        [$290836fe8d7e8057$var$Direction.Backward]: false,
        [$290836fe8d7e8057$var$Direction.Forward]: false
    },
    y: {
        [$290836fe8d7e8057$var$Direction.Backward]: false,
        [$290836fe8d7e8057$var$Direction.Forward]: false
    }
};
function $290836fe8d7e8057$var$useScrollIntent(_ref2) {
    let { delta: delta, disabled: disabled } = _ref2;
    const previousDelta = (0, $2EYIn.usePrevious)(delta);
    return (0, $2EYIn.useLazyMemo)((previousIntent)=>{
        if (disabled || !previousDelta || !previousIntent) // Reset scroll intent tracking when auto-scrolling is disabled
        return $290836fe8d7e8057$var$defaultScrollIntent;
        const direction = {
            x: Math.sign(delta.x - previousDelta.x),
            y: Math.sign(delta.y - previousDelta.y)
        }; // Keep track of the user intent to scroll in each direction for both axis
        return {
            x: {
                [$290836fe8d7e8057$var$Direction.Backward]: previousIntent.x[$290836fe8d7e8057$var$Direction.Backward] || direction.x === -1,
                [$290836fe8d7e8057$var$Direction.Forward]: previousIntent.x[$290836fe8d7e8057$var$Direction.Forward] || direction.x === 1
            },
            y: {
                [$290836fe8d7e8057$var$Direction.Backward]: previousIntent.y[$290836fe8d7e8057$var$Direction.Backward] || direction.y === -1,
                [$290836fe8d7e8057$var$Direction.Forward]: previousIntent.y[$290836fe8d7e8057$var$Direction.Forward] || direction.y === 1
            }
        };
    }, [
        disabled,
        delta,
        previousDelta
    ]);
}
function $290836fe8d7e8057$var$useCachedNode(draggableNodes, id) {
    const draggableNode = id != null ? draggableNodes.get(id) : undefined;
    const node = draggableNode ? draggableNode.node.current : null;
    return (0, $2EYIn.useLazyMemo)((cachedNode)=>{
        var _ref;
        if (id == null) return null;
         // In some cases, the draggable node can unmount while dragging
        // This is the case for virtualized lists. In those situations,
        // we fall back to the last known value for that node.
        return (_ref = node != null ? node : cachedNode) != null ? _ref : null;
    }, [
        node,
        id
    ]);
}
function $290836fe8d7e8057$var$useCombineActivators(sensors, getSyntheticHandler) {
    return (0, $jbmdS.useMemo)(()=>sensors.reduce((accumulator, sensor)=>{
            const { sensor: Sensor } = sensor;
            const sensorActivators = Sensor.activators.map((activator)=>({
                    eventName: activator.eventName,
                    handler: getSyntheticHandler(activator.handler, sensor)
                }));
            return [
                ...accumulator,
                ...sensorActivators
            ];
        }, []), [
        sensors,
        getSyntheticHandler
    ]);
}
var $290836fe8d7e8057$export$571c10ffffe014ab;
(function(MeasuringStrategy) {
    MeasuringStrategy[MeasuringStrategy["Always"] = 0] = "Always";
    MeasuringStrategy[MeasuringStrategy["BeforeDragging"] = 1] = "BeforeDragging";
    MeasuringStrategy[MeasuringStrategy["WhileDragging"] = 2] = "WhileDragging";
})($290836fe8d7e8057$export$571c10ffffe014ab || ($290836fe8d7e8057$export$571c10ffffe014ab = {}));
var $290836fe8d7e8057$export$8e062c3160beefd5;
(function(MeasuringFrequency) {
    MeasuringFrequency["Optimized"] = "optimized";
})($290836fe8d7e8057$export$8e062c3160beefd5 || ($290836fe8d7e8057$export$8e062c3160beefd5 = {}));
const $290836fe8d7e8057$var$defaultValue = /*#__PURE__*/ new Map();
function $290836fe8d7e8057$var$useDroppableMeasuring(containers, _ref) {
    let { dragging: dragging, dependencies: dependencies, config: config } = _ref;
    const [queue, setQueue] = (0, $jbmdS.useState)(null);
    const { frequency: frequency, measure: measure, strategy: strategy } = config;
    const containersRef = (0, $jbmdS.useRef)(containers);
    const disabled = isDisabled();
    const disabledRef = (0, $2EYIn.useLatestValue)(disabled);
    const measureDroppableContainers = (0, $jbmdS.useCallback)(function(ids) {
        if (ids === void 0) ids = [];
        if (disabledRef.current) return;
        setQueue((value)=>{
            if (value === null) return ids;
            return value.concat(ids.filter((id)=>!value.includes(id)));
        });
    }, [
        disabledRef
    ]);
    const timeoutId = (0, $jbmdS.useRef)(null);
    const droppableRects = (0, $2EYIn.useLazyMemo)((previousValue)=>{
        if (disabled && !dragging) return $290836fe8d7e8057$var$defaultValue;
        if (!previousValue || previousValue === $290836fe8d7e8057$var$defaultValue || containersRef.current !== containers || queue != null) {
            const map = new Map();
            for (let container of containers){
                if (!container) continue;
                if (queue && queue.length > 0 && !queue.includes(container.id) && container.rect.current) {
                    // This container does not need to be re-measured
                    map.set(container.id, container.rect.current);
                    continue;
                }
                const node = container.node.current;
                const rect = node ? new $290836fe8d7e8057$var$Rect(measure(node), node) : null;
                container.rect.current = rect;
                if (rect) map.set(container.id, rect);
            }
            return map;
        }
        return previousValue;
    }, [
        containers,
        queue,
        dragging,
        disabled,
        measure
    ]);
    (0, $jbmdS.useEffect)(()=>{
        containersRef.current = containers;
    }, [
        containers
    ]);
    (0, $jbmdS.useEffect)(()=>{
        if (disabled) return;
        measureDroppableContainers();
    }, [
        dragging,
        disabled
    ]);
    (0, $jbmdS.useEffect)(()=>{
        if (queue && queue.length > 0) setQueue(null);
    }, [
        JSON.stringify(queue)
    ]);
    (0, $jbmdS.useEffect)(()=>{
        if (disabled || typeof frequency !== "number" || timeoutId.current !== null) return;
        timeoutId.current = setTimeout(()=>{
            measureDroppableContainers();
            timeoutId.current = null;
        }, frequency);
    }, [
        frequency,
        disabled,
        measureDroppableContainers,
        ...dependencies
    ]);
    return {
        droppableRects: droppableRects,
        measureDroppableContainers: measureDroppableContainers,
        measuringScheduled: queue != null
    };
    function isDisabled() {
        switch(strategy){
            case $290836fe8d7e8057$export$571c10ffffe014ab.Always:
                return false;
            case $290836fe8d7e8057$export$571c10ffffe014ab.BeforeDragging:
                return dragging;
            default:
                return !dragging;
        }
    }
}
function $290836fe8d7e8057$var$useInitialValue(value, computeFn) {
    return (0, $2EYIn.useLazyMemo)((previousValue)=>{
        if (!value) return null;
        if (previousValue) return previousValue;
        return typeof computeFn === "function" ? computeFn(value) : value;
    }, [
        computeFn,
        value
    ]);
}
function $290836fe8d7e8057$var$useInitialRect(node, measure) {
    return $290836fe8d7e8057$var$useInitialValue(node, measure);
}
/**
 * Returns a new MutationObserver instance.
 * If `MutationObserver` is undefined in the execution environment, returns `undefined`.
 */ function $290836fe8d7e8057$var$useMutationObserver(_ref) {
    let { callback: callback, disabled: disabled } = _ref;
    const handleMutations = (0, $2EYIn.useEvent)(callback);
    const mutationObserver = (0, $jbmdS.useMemo)(()=>{
        if (disabled || typeof window === "undefined" || typeof window.MutationObserver === "undefined") return undefined;
        const { MutationObserver: MutationObserver } = window;
        return new MutationObserver(handleMutations);
    }, [
        handleMutations,
        disabled
    ]);
    (0, $jbmdS.useEffect)(()=>{
        return ()=>mutationObserver == null ? void 0 : mutationObserver.disconnect();
    }, [
        mutationObserver
    ]);
    return mutationObserver;
}
/**
 * Returns a new ResizeObserver instance bound to the `onResize` callback.
 * If `ResizeObserver` is undefined in the execution environment, returns `undefined`.
 */ function $290836fe8d7e8057$var$useResizeObserver(_ref) {
    let { callback: callback, disabled: disabled } = _ref;
    const handleResize = (0, $2EYIn.useEvent)(callback);
    const resizeObserver = (0, $jbmdS.useMemo)(()=>{
        if (disabled || typeof window === "undefined" || typeof window.ResizeObserver === "undefined") return undefined;
        const { ResizeObserver: ResizeObserver } = window;
        return new ResizeObserver(handleResize);
    }, [
        disabled
    ]);
    (0, $jbmdS.useEffect)(()=>{
        return ()=>resizeObserver == null ? void 0 : resizeObserver.disconnect();
    }, [
        resizeObserver
    ]);
    return resizeObserver;
}
function $290836fe8d7e8057$var$defaultMeasure(element) {
    return new $290836fe8d7e8057$var$Rect($290836fe8d7e8057$export$b6aa1f30c53d7454(element), element);
}
function $290836fe8d7e8057$var$useRect(element, measure, fallbackRect) {
    if (measure === void 0) measure = $290836fe8d7e8057$var$defaultMeasure;
    const [rect, setRect] = (0, $jbmdS.useState)(null);
    function measureRect() {
        setRect((currentRect)=>{
            if (!element) return null;
            if (element.isConnected === false) {
                var _ref;
                // Fall back to last rect we measured if the element is
                // no longer connected to the DOM.
                return (_ref = currentRect != null ? currentRect : fallbackRect) != null ? _ref : null;
            }
            const newRect = measure(element);
            if (JSON.stringify(currentRect) === JSON.stringify(newRect)) return currentRect;
            return newRect;
        });
    }
    const mutationObserver = $290836fe8d7e8057$var$useMutationObserver({
        callback (records) {
            if (!element) return;
            for (const record of records){
                const { type: type, target: target } = record;
                if (type === "childList" && target instanceof HTMLElement && target.contains(element)) {
                    measureRect();
                    break;
                }
            }
        }
    });
    const resizeObserver = $290836fe8d7e8057$var$useResizeObserver({
        callback: measureRect
    });
    (0, $2EYIn.useIsomorphicLayoutEffect)(()=>{
        measureRect();
        if (element) {
            resizeObserver == null || resizeObserver.observe(element);
            mutationObserver == null || mutationObserver.observe(document.body, {
                childList: true,
                subtree: true
            });
        } else {
            resizeObserver == null || resizeObserver.disconnect();
            mutationObserver == null || mutationObserver.disconnect();
        }
    }, [
        element
    ]);
    return rect;
}
function $290836fe8d7e8057$var$useRectDelta(rect) {
    const initialRect = $290836fe8d7e8057$var$useInitialValue(rect);
    return $290836fe8d7e8057$var$getRectDelta(rect, initialRect);
}
const $290836fe8d7e8057$var$defaultValue$1 = [];
function $290836fe8d7e8057$var$useScrollableAncestors(node) {
    const previousNode = (0, $jbmdS.useRef)(node);
    const ancestors = (0, $2EYIn.useLazyMemo)((previousValue)=>{
        if (!node) return $290836fe8d7e8057$var$defaultValue$1;
        if (previousValue && previousValue !== $290836fe8d7e8057$var$defaultValue$1 && node && previousNode.current && node.parentNode === previousNode.current.parentNode) return previousValue;
        return $290836fe8d7e8057$export$e4864aa91b5ed091(node);
    }, [
        node
    ]);
    (0, $jbmdS.useEffect)(()=>{
        previousNode.current = node;
    }, [
        node
    ]);
    return ancestors;
}
function $290836fe8d7e8057$var$useScrollOffsets(elements) {
    const [scrollCoordinates, setScrollCoordinates] = (0, $jbmdS.useState)(null);
    const prevElements = (0, $jbmdS.useRef)(elements); // To-do: Throttle the handleScroll callback
    const handleScroll = (0, $jbmdS.useCallback)((event)=>{
        const scrollingElement = $290836fe8d7e8057$var$getScrollableElement(event.target);
        if (!scrollingElement) return;
        setScrollCoordinates((scrollCoordinates)=>{
            if (!scrollCoordinates) return null;
            scrollCoordinates.set(scrollingElement, $290836fe8d7e8057$var$getScrollCoordinates(scrollingElement));
            return new Map(scrollCoordinates);
        });
    }, []);
    (0, $jbmdS.useEffect)(()=>{
        const previousElements = prevElements.current;
        if (elements !== previousElements) {
            cleanup(previousElements);
            const entries = elements.map((element)=>{
                const scrollableElement = $290836fe8d7e8057$var$getScrollableElement(element);
                if (scrollableElement) {
                    scrollableElement.addEventListener("scroll", handleScroll, {
                        passive: true
                    });
                    return [
                        scrollableElement,
                        $290836fe8d7e8057$var$getScrollCoordinates(scrollableElement)
                    ];
                }
                return null;
            }).filter((entry)=>entry != null);
            setScrollCoordinates(entries.length ? new Map(entries) : null);
            prevElements.current = elements;
        }
        return ()=>{
            cleanup(elements);
            cleanup(previousElements);
        };
        function cleanup(elements) {
            elements.forEach((element)=>{
                const scrollableElement = $290836fe8d7e8057$var$getScrollableElement(element);
                scrollableElement == null || scrollableElement.removeEventListener("scroll", handleScroll);
            });
        }
    }, [
        handleScroll,
        elements
    ]);
    return (0, $jbmdS.useMemo)(()=>{
        if (elements.length) return scrollCoordinates ? Array.from(scrollCoordinates.values()).reduce((acc, coordinates)=>(0, $2EYIn.add)(acc, coordinates), $290836fe8d7e8057$export$597cbd7bbd10deb4) : $290836fe8d7e8057$var$getScrollOffsets(elements);
        return $290836fe8d7e8057$export$597cbd7bbd10deb4;
    }, [
        elements,
        scrollCoordinates
    ]);
}
function $290836fe8d7e8057$var$useScrollOffsetsDelta(scrollOffsets, dependencies) {
    if (dependencies === void 0) dependencies = [];
    const initialScrollOffsets = (0, $jbmdS.useRef)(null);
    (0, $jbmdS.useEffect)(()=>{
        initialScrollOffsets.current = null;
    }, dependencies);
    (0, $jbmdS.useEffect)(()=>{
        const hasScrollOffsets = scrollOffsets !== $290836fe8d7e8057$export$597cbd7bbd10deb4;
        if (hasScrollOffsets && !initialScrollOffsets.current) initialScrollOffsets.current = scrollOffsets;
        if (!hasScrollOffsets && initialScrollOffsets.current) initialScrollOffsets.current = null;
    }, [
        scrollOffsets
    ]);
    return initialScrollOffsets.current ? (0, $2EYIn.subtract)(scrollOffsets, initialScrollOffsets.current) : $290836fe8d7e8057$export$597cbd7bbd10deb4;
}
function $290836fe8d7e8057$var$useSensorSetup(sensors) {
    (0, $jbmdS.useEffect)(()=>{
        if (!(0, $2EYIn.canUseDOM)) return;
        const teardownFns = sensors.map((_ref)=>{
            let { sensor: sensor } = _ref;
            return sensor.setup == null ? void 0 : sensor.setup();
        });
        return ()=>{
            for (const teardown of teardownFns)teardown == null || teardown();
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    sensors.map((_ref2)=>{
        let { sensor: sensor } = _ref2;
        return sensor;
    }));
}
function $290836fe8d7e8057$var$useSyntheticListeners(listeners, id) {
    return (0, $jbmdS.useMemo)(()=>{
        return listeners.reduce((acc, _ref)=>{
            let { eventName: eventName, handler: handler } = _ref;
            acc[eventName] = (event)=>{
                handler(event, id);
            };
            return acc;
        }, {});
    }, [
        listeners,
        id
    ]);
}
function $290836fe8d7e8057$var$useWindowRect(element) {
    return (0, $jbmdS.useMemo)(()=>element ? $290836fe8d7e8057$var$getWindowClientRect(element) : null, [
        element
    ]);
}
const $290836fe8d7e8057$var$defaultValue$2 = [];
function $290836fe8d7e8057$var$useRects(elements, measure) {
    if (measure === void 0) measure = $290836fe8d7e8057$export$b6aa1f30c53d7454;
    const [firstElement] = elements;
    const windowRect = $290836fe8d7e8057$var$useWindowRect(firstElement ? (0, $2EYIn.getWindow)(firstElement) : null);
    const [rects, setRects] = (0, $jbmdS.useState)($290836fe8d7e8057$var$defaultValue$2);
    function measureRects() {
        setRects(()=>{
            if (!elements.length) return $290836fe8d7e8057$var$defaultValue$2;
            return elements.map((element)=>$290836fe8d7e8057$var$isDocumentScrollingElement(element) ? windowRect : new $290836fe8d7e8057$var$Rect(measure(element), element));
        });
    }
    const resizeObserver = $290836fe8d7e8057$var$useResizeObserver({
        callback: measureRects
    });
    (0, $2EYIn.useIsomorphicLayoutEffect)(()=>{
        resizeObserver == null || resizeObserver.disconnect();
        measureRects();
        elements.forEach((element)=>resizeObserver == null ? void 0 : resizeObserver.observe(element));
    }, [
        elements
    ]);
    return rects;
}
function $290836fe8d7e8057$var$getMeasurableNode(node) {
    if (!node) return null;
    if (node.children.length > 1) return node;
    const firstChild = node.children[0];
    return (0, $2EYIn.isHTMLElement)(firstChild) ? firstChild : node;
}
function $290836fe8d7e8057$var$useDragOverlayMeasuring(_ref) {
    let { measure: measure } = _ref;
    const [rect, setRect] = (0, $jbmdS.useState)(null);
    const handleResize = (0, $jbmdS.useCallback)((entries)=>{
        for (const { target: target } of entries)if ((0, $2EYIn.isHTMLElement)(target)) {
            setRect((rect)=>{
                const newRect = measure(target);
                return rect ? {
                    ...rect,
                    width: newRect.width,
                    height: newRect.height
                } : newRect;
            });
            break;
        }
    }, [
        measure
    ]);
    const resizeObserver = $290836fe8d7e8057$var$useResizeObserver({
        callback: handleResize
    });
    const handleNodeChange = (0, $jbmdS.useCallback)((element)=>{
        const node = $290836fe8d7e8057$var$getMeasurableNode(element);
        resizeObserver == null || resizeObserver.disconnect();
        if (node) resizeObserver == null || resizeObserver.observe(node);
        setRect(node ? measure(node) : null);
    }, [
        measure,
        resizeObserver
    ]);
    const [nodeRef, setRef] = (0, $2EYIn.useNodeRef)(handleNodeChange);
    return (0, $jbmdS.useMemo)(()=>({
            nodeRef: nodeRef,
            rect: rect,
            setRef: setRef
        }), [
        rect,
        nodeRef,
        setRef
    ]);
}
const $290836fe8d7e8057$var$defaultSensors = [
    {
        sensor: $290836fe8d7e8057$export$b26af955418d6638,
        options: {}
    },
    {
        sensor: $290836fe8d7e8057$export$44d67f2a438aeba9,
        options: {}
    }
];
const $290836fe8d7e8057$var$defaultData = {
    current: {}
};
const $290836fe8d7e8057$var$defaultMeasuringConfiguration = {
    draggable: {
        measure: $290836fe8d7e8057$var$getTransformAgnosticClientRect
    },
    droppable: {
        measure: $290836fe8d7e8057$var$getTransformAgnosticClientRect,
        strategy: $290836fe8d7e8057$export$571c10ffffe014ab.WhileDragging,
        frequency: $290836fe8d7e8057$export$8e062c3160beefd5.Optimized
    },
    dragOverlay: {
        measure: $290836fe8d7e8057$export$b6aa1f30c53d7454
    }
};
class $290836fe8d7e8057$var$DroppableContainersMap extends Map {
    get(id) {
        var _super$get;
        return id != null ? (_super$get = super.get(id)) != null ? _super$get : undefined : undefined;
    }
    toArray() {
        return Array.from(this.values());
    }
    getEnabled() {
        return this.toArray().filter((_ref)=>{
            let { disabled: disabled } = _ref;
            return !disabled;
        });
    }
    getNodeFor(id) {
        var _this$get$node$curren, _this$get;
        return (_this$get$node$curren = (_this$get = this.get(id)) == null ? void 0 : _this$get.node.current) != null ? _this$get$node$curren : undefined;
    }
}
const $290836fe8d7e8057$var$defaultPublicContext = {
    activatorEvent: null,
    active: null,
    activeNode: null,
    activeNodeRect: null,
    collisions: null,
    containerNodeRect: null,
    draggableNodes: /*#__PURE__*/ new Map(),
    droppableRects: /*#__PURE__*/ new Map(),
    droppableContainers: /*#__PURE__*/ new $290836fe8d7e8057$var$DroppableContainersMap(),
    over: null,
    dragOverlay: {
        nodeRef: {
            current: null
        },
        rect: null,
        setRef: $290836fe8d7e8057$var$noop
    },
    scrollableAncestors: [],
    scrollableAncestorRects: [],
    measuringConfiguration: $290836fe8d7e8057$var$defaultMeasuringConfiguration,
    measureDroppableContainers: $290836fe8d7e8057$var$noop,
    windowRect: null,
    measuringScheduled: false
};
const $290836fe8d7e8057$var$defaultInternalContext = {
    activatorEvent: null,
    activators: [],
    active: null,
    activeNodeRect: null,
    ariaDescribedById: {
        draggable: ""
    },
    dispatch: $290836fe8d7e8057$var$noop,
    draggableNodes: /*#__PURE__*/ new Map(),
    over: null,
    measureDroppableContainers: $290836fe8d7e8057$var$noop
};
const $290836fe8d7e8057$var$InternalContext = /*#__PURE__*/ (0, $jbmdS.createContext)($290836fe8d7e8057$var$defaultInternalContext);
const $290836fe8d7e8057$var$PublicContext = /*#__PURE__*/ (0, $jbmdS.createContext)($290836fe8d7e8057$var$defaultPublicContext);
function $290836fe8d7e8057$var$getInitialState() {
    return {
        draggable: {
            active: null,
            initialCoordinates: {
                x: 0,
                y: 0
            },
            nodes: new Map(),
            translate: {
                x: 0,
                y: 0
            }
        },
        droppable: {
            containers: new $290836fe8d7e8057$var$DroppableContainersMap()
        }
    };
}
function $290836fe8d7e8057$var$reducer(state, action) {
    switch(action.type){
        case $290836fe8d7e8057$var$Action.DragStart:
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    initialCoordinates: action.initialCoordinates,
                    active: action.active
                }
            };
        case $290836fe8d7e8057$var$Action.DragMove:
            if (state.draggable.active == null) return state;
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    translate: {
                        x: action.coordinates.x - state.draggable.initialCoordinates.x,
                        y: action.coordinates.y - state.draggable.initialCoordinates.y
                    }
                }
            };
        case $290836fe8d7e8057$var$Action.DragEnd:
        case $290836fe8d7e8057$var$Action.DragCancel:
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    active: null,
                    initialCoordinates: {
                        x: 0,
                        y: 0
                    },
                    translate: {
                        x: 0,
                        y: 0
                    }
                }
            };
        case $290836fe8d7e8057$var$Action.RegisterDroppable:
            {
                const { element: element } = action;
                const { id: id } = element;
                const containers = new $290836fe8d7e8057$var$DroppableContainersMap(state.droppable.containers);
                containers.set(id, element);
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers: containers
                    }
                };
            }
        case $290836fe8d7e8057$var$Action.SetDroppableDisabled:
            {
                const { id: id, key: key, disabled: disabled } = action;
                const element = state.droppable.containers.get(id);
                if (!element || key !== element.key) return state;
                const containers = new $290836fe8d7e8057$var$DroppableContainersMap(state.droppable.containers);
                containers.set(id, {
                    ...element,
                    disabled: disabled
                });
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers: containers
                    }
                };
            }
        case $290836fe8d7e8057$var$Action.UnregisterDroppable:
            {
                const { id: id, key: key } = action;
                const element = state.droppable.containers.get(id);
                if (!element || key !== element.key) return state;
                const containers = new $290836fe8d7e8057$var$DroppableContainersMap(state.droppable.containers);
                containers.delete(id);
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers: containers
                    }
                };
            }
        default:
            return state;
    }
}
function $290836fe8d7e8057$var$RestoreFocus(_ref) {
    let { disabled: disabled } = _ref;
    const { active: active, activatorEvent: activatorEvent, draggableNodes: draggableNodes } = (0, $jbmdS.useContext)($290836fe8d7e8057$var$InternalContext);
    const previousActivatorEvent = (0, $2EYIn.usePrevious)(activatorEvent);
    const previousActiveId = (0, $2EYIn.usePrevious)(active == null ? void 0 : active.id); // Restore keyboard focus on the activator node
    (0, $jbmdS.useEffect)(()=>{
        if (disabled) return;
        if (!activatorEvent && previousActivatorEvent && previousActiveId != null) {
            if (!(0, $2EYIn.isKeyboardEvent)(previousActivatorEvent)) return;
            if (document.activeElement === previousActivatorEvent.target) // No need to restore focus
            return;
            const draggableNode = draggableNodes.get(previousActiveId);
            if (!draggableNode) return;
            const { activatorNode: activatorNode, node: node } = draggableNode;
            if (!activatorNode.current && !node.current) return;
            requestAnimationFrame(()=>{
                for (const element of [
                    activatorNode.current,
                    node.current
                ]){
                    if (!element) continue;
                    const focusableNode = (0, $2EYIn.findFirstFocusableNode)(element);
                    if (focusableNode) {
                        focusableNode.focus();
                        break;
                    }
                }
            });
        }
    }, [
        activatorEvent,
        disabled,
        draggableNodes,
        previousActiveId,
        previousActivatorEvent
    ]);
    return null;
}
function $290836fe8d7e8057$export$f1696300e8775372(modifiers, _ref) {
    let { transform: transform, ...args } = _ref;
    return modifiers != null && modifiers.length ? modifiers.reduce((accumulator, modifier)=>{
        return modifier({
            transform: accumulator,
            ...args
        });
    }, transform) : transform;
}
function $290836fe8d7e8057$var$useMeasuringConfiguration(config) {
    return (0, $jbmdS.useMemo)(()=>({
            draggable: {
                ...$290836fe8d7e8057$var$defaultMeasuringConfiguration.draggable,
                ...config == null ? void 0 : config.draggable
            },
            droppable: {
                ...$290836fe8d7e8057$var$defaultMeasuringConfiguration.droppable,
                ...config == null ? void 0 : config.droppable
            },
            dragOverlay: {
                ...$290836fe8d7e8057$var$defaultMeasuringConfiguration.dragOverlay,
                ...config == null ? void 0 : config.dragOverlay
            }
        }), [
        config == null ? void 0 : config.draggable,
        config == null ? void 0 : config.droppable,
        config == null ? void 0 : config.dragOverlay
    ]);
}
function $290836fe8d7e8057$var$useLayoutShiftScrollCompensation(_ref) {
    let { activeNode: activeNode, measure: measure, initialRect: initialRect, config: config = true } = _ref;
    const initialized = (0, $jbmdS.useRef)(false);
    const { x: x, y: y } = typeof config === "boolean" ? {
        x: config,
        y: config
    } : config;
    (0, $2EYIn.useIsomorphicLayoutEffect)(()=>{
        const disabled = !x && !y;
        if (disabled || !activeNode) {
            initialized.current = false;
            return;
        }
        if (initialized.current || !initialRect) // Return early if layout shift scroll compensation was already attempted
        // or if there is no initialRect to compare to.
        return;
         // Get the most up to date node ref for the active draggable
        const node = activeNode == null ? void 0 : activeNode.node.current;
        if (!node || node.isConnected === false) // Return early if there is no attached node ref or if the node is
        // disconnected from the document.
        return;
        const rect = measure(node);
        const rectDelta = $290836fe8d7e8057$var$getRectDelta(rect, initialRect);
        if (!x) rectDelta.x = 0;
        if (!y) rectDelta.y = 0;
         // Only perform layout shift scroll compensation once
        initialized.current = true;
        if (Math.abs(rectDelta.x) > 0 || Math.abs(rectDelta.y) > 0) {
            const firstScrollableAncestor = $290836fe8d7e8057$var$getFirstScrollableAncestor(node);
            if (firstScrollableAncestor) firstScrollableAncestor.scrollBy({
                top: rectDelta.y,
                left: rectDelta.x
            });
        }
    }, [
        activeNode,
        x,
        y,
        initialRect,
        measure
    ]);
}
const $290836fe8d7e8057$var$ActiveDraggableContext = /*#__PURE__*/ (0, $jbmdS.createContext)({
    ...$290836fe8d7e8057$export$597cbd7bbd10deb4,
    scaleX: 1,
    scaleY: 1
});
var $290836fe8d7e8057$var$Status;
(function(Status) {
    Status[Status["Uninitialized"] = 0] = "Uninitialized";
    Status[Status["Initializing"] = 1] = "Initializing";
    Status[Status["Initialized"] = 2] = "Initialized";
})($290836fe8d7e8057$var$Status || ($290836fe8d7e8057$var$Status = {}));
const $290836fe8d7e8057$export$2d5c5ceac203fc1e = /*#__PURE__*/ (0, $jbmdS.memo)(function DndContext(_ref) {
    var _sensorContext$curren, _dragOverlay$nodeRef$, _dragOverlay$rect, _over$rect;
    let { id: id, accessibility: accessibility, autoScroll: autoScroll = true, children: children, sensors: sensors = $290836fe8d7e8057$var$defaultSensors, collisionDetection: collisionDetection = $290836fe8d7e8057$export$953346c40b5eb62a, measuring: measuring, modifiers: modifiers, ...props } = _ref;
    const store = (0, $jbmdS.useReducer)($290836fe8d7e8057$var$reducer, undefined, $290836fe8d7e8057$var$getInitialState);
    const [state, dispatch] = store;
    const [dispatchMonitorEvent, registerMonitorListener] = $290836fe8d7e8057$var$useDndMonitorProvider();
    const [status, setStatus] = (0, $jbmdS.useState)($290836fe8d7e8057$var$Status.Uninitialized);
    const isInitialized = status === $290836fe8d7e8057$var$Status.Initialized;
    const { draggable: { active: activeId, nodes: draggableNodes, translate: translate }, droppable: { containers: droppableContainers } } = state;
    const node = activeId != null ? draggableNodes.get(activeId) : null;
    const activeRects = (0, $jbmdS.useRef)({
        initial: null,
        translated: null
    });
    const active = (0, $jbmdS.useMemo)(()=>{
        var _node$data;
        return activeId != null ? {
            id: activeId,
            // It's possible for the active node to unmount while dragging
            data: (_node$data = node == null ? void 0 : node.data) != null ? _node$data : $290836fe8d7e8057$var$defaultData,
            rect: activeRects
        } : null;
    }, [
        activeId,
        node
    ]);
    const activeRef = (0, $jbmdS.useRef)(null);
    const [activeSensor, setActiveSensor] = (0, $jbmdS.useState)(null);
    const [activatorEvent, setActivatorEvent] = (0, $jbmdS.useState)(null);
    const latestProps = (0, $2EYIn.useLatestValue)(props, Object.values(props));
    const draggableDescribedById = (0, $2EYIn.useUniqueId)("DndDescribedBy", id);
    const enabledDroppableContainers = (0, $jbmdS.useMemo)(()=>droppableContainers.getEnabled(), [
        droppableContainers
    ]);
    const measuringConfiguration = $290836fe8d7e8057$var$useMeasuringConfiguration(measuring);
    const { droppableRects: droppableRects, measureDroppableContainers: measureDroppableContainers, measuringScheduled: measuringScheduled } = $290836fe8d7e8057$var$useDroppableMeasuring(enabledDroppableContainers, {
        dragging: isInitialized,
        dependencies: [
            translate.x,
            translate.y
        ],
        config: measuringConfiguration.droppable
    });
    const activeNode = $290836fe8d7e8057$var$useCachedNode(draggableNodes, activeId);
    const activationCoordinates = (0, $jbmdS.useMemo)(()=>activatorEvent ? (0, $2EYIn.getEventCoordinates)(activatorEvent) : null, [
        activatorEvent
    ]);
    const autoScrollOptions = getAutoScrollerOptions();
    const initialActiveNodeRect = $290836fe8d7e8057$var$useInitialRect(activeNode, measuringConfiguration.draggable.measure);
    $290836fe8d7e8057$var$useLayoutShiftScrollCompensation({
        activeNode: activeId != null ? draggableNodes.get(activeId) : null,
        config: autoScrollOptions.layoutShiftCompensation,
        initialRect: initialActiveNodeRect,
        measure: measuringConfiguration.draggable.measure
    });
    const activeNodeRect = $290836fe8d7e8057$var$useRect(activeNode, measuringConfiguration.draggable.measure, initialActiveNodeRect);
    const containerNodeRect = $290836fe8d7e8057$var$useRect(activeNode ? activeNode.parentElement : null);
    const sensorContext = (0, $jbmdS.useRef)({
        activatorEvent: null,
        active: null,
        activeNode: activeNode,
        collisionRect: null,
        collisions: null,
        droppableRects: droppableRects,
        draggableNodes: draggableNodes,
        draggingNode: null,
        draggingNodeRect: null,
        droppableContainers: droppableContainers,
        over: null,
        scrollableAncestors: [],
        scrollAdjustedTranslate: null
    });
    const overNode = droppableContainers.getNodeFor((_sensorContext$curren = sensorContext.current.over) == null ? void 0 : _sensorContext$curren.id);
    const dragOverlay = $290836fe8d7e8057$var$useDragOverlayMeasuring({
        measure: measuringConfiguration.dragOverlay.measure
    }); // Use the rect of the drag overlay if it is mounted
    const draggingNode = (_dragOverlay$nodeRef$ = dragOverlay.nodeRef.current) != null ? _dragOverlay$nodeRef$ : activeNode;
    const draggingNodeRect = isInitialized ? (_dragOverlay$rect = dragOverlay.rect) != null ? _dragOverlay$rect : activeNodeRect : null;
    const usesDragOverlay = Boolean(dragOverlay.nodeRef.current && dragOverlay.rect); // The delta between the previous and new position of the draggable node
    // is only relevant when there is no drag overlay
    const nodeRectDelta = $290836fe8d7e8057$var$useRectDelta(usesDragOverlay ? null : activeNodeRect); // Get the window rect of the dragging node
    const windowRect = $290836fe8d7e8057$var$useWindowRect(draggingNode ? (0, $2EYIn.getWindow)(draggingNode) : null); // Get scrollable ancestors of the dragging node
    const scrollableAncestors = $290836fe8d7e8057$var$useScrollableAncestors(isInitialized ? overNode != null ? overNode : activeNode : null);
    const scrollableAncestorRects = $290836fe8d7e8057$var$useRects(scrollableAncestors); // Apply modifiers
    const modifiedTranslate = $290836fe8d7e8057$export$f1696300e8775372(modifiers, {
        transform: {
            x: translate.x - nodeRectDelta.x,
            y: translate.y - nodeRectDelta.y,
            scaleX: 1,
            scaleY: 1
        },
        activatorEvent: activatorEvent,
        active: active,
        activeNodeRect: activeNodeRect,
        containerNodeRect: containerNodeRect,
        draggingNodeRect: draggingNodeRect,
        over: sensorContext.current.over,
        overlayNodeRect: dragOverlay.rect,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects,
        windowRect: windowRect
    });
    const pointerCoordinates = activationCoordinates ? (0, $2EYIn.add)(activationCoordinates, translate) : null;
    const scrollOffsets = $290836fe8d7e8057$var$useScrollOffsets(scrollableAncestors); // Represents the scroll delta since dragging was initiated
    const scrollAdjustment = $290836fe8d7e8057$var$useScrollOffsetsDelta(scrollOffsets); // Represents the scroll delta since the last time the active node rect was measured
    const activeNodeScrollDelta = $290836fe8d7e8057$var$useScrollOffsetsDelta(scrollOffsets, [
        activeNodeRect
    ]);
    const scrollAdjustedTranslate = (0, $2EYIn.add)(modifiedTranslate, scrollAdjustment);
    const collisionRect = draggingNodeRect ? $290836fe8d7e8057$var$getAdjustedRect(draggingNodeRect, modifiedTranslate) : null;
    const collisions = active && collisionRect ? collisionDetection({
        active: active,
        collisionRect: collisionRect,
        droppableRects: droppableRects,
        droppableContainers: enabledDroppableContainers,
        pointerCoordinates: pointerCoordinates
    }) : null;
    const overId = $290836fe8d7e8057$export$ef1beab6d7287295(collisions, "id");
    const [over, setOver] = (0, $jbmdS.useState)(null); // When there is no drag overlay used, we need to account for the
    // window scroll delta
    const appliedTranslate = usesDragOverlay ? modifiedTranslate : (0, $2EYIn.add)(modifiedTranslate, activeNodeScrollDelta);
    const transform = $290836fe8d7e8057$var$adjustScale(appliedTranslate, (_over$rect = over == null ? void 0 : over.rect) != null ? _over$rect : null, activeNodeRect);
    const activeSensorRef = (0, $jbmdS.useRef)(null);
    const instantiateSensor = (0, $jbmdS.useCallback)((event, _ref2)=>{
        let { sensor: Sensor, options: options } = _ref2;
        if (activeRef.current == null) return;
        const activeNode = draggableNodes.get(activeRef.current);
        if (!activeNode) return;
        const activatorEvent = event.nativeEvent;
        const sensorInstance = new Sensor({
            active: activeRef.current,
            activeNode: activeNode,
            event: activatorEvent,
            options: options,
            // Sensors need to be instantiated with refs for arguments that change over time
            // otherwise they are frozen in time with the stale arguments
            context: sensorContext,
            onAbort (id) {
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragAbort: onDragAbort } = latestProps.current;
                const event = {
                    id: id
                };
                onDragAbort == null || onDragAbort(event);
                dispatchMonitorEvent({
                    type: "onDragAbort",
                    event: event
                });
            },
            onPending (id, constraint, initialCoordinates, offset) {
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragPending: onDragPending } = latestProps.current;
                const event = {
                    id: id,
                    constraint: constraint,
                    initialCoordinates: initialCoordinates,
                    offset: offset
                };
                onDragPending == null || onDragPending(event);
                dispatchMonitorEvent({
                    type: "onDragPending",
                    event: event
                });
            },
            onStart (initialCoordinates) {
                const id = activeRef.current;
                if (id == null) return;
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragStart: onDragStart } = latestProps.current;
                const event = {
                    activatorEvent: activatorEvent,
                    active: {
                        id: id,
                        data: draggableNode.data,
                        rect: activeRects
                    }
                };
                (0, $jCNM0.unstable_batchedUpdates)(()=>{
                    onDragStart == null || onDragStart(event);
                    setStatus($290836fe8d7e8057$var$Status.Initializing);
                    dispatch({
                        type: $290836fe8d7e8057$var$Action.DragStart,
                        initialCoordinates: initialCoordinates,
                        active: id
                    });
                    dispatchMonitorEvent({
                        type: "onDragStart",
                        event: event
                    });
                    setActiveSensor(activeSensorRef.current);
                    setActivatorEvent(activatorEvent);
                });
            },
            onMove (coordinates) {
                dispatch({
                    type: $290836fe8d7e8057$var$Action.DragMove,
                    coordinates: coordinates
                });
            },
            onEnd: createHandler($290836fe8d7e8057$var$Action.DragEnd),
            onCancel: createHandler($290836fe8d7e8057$var$Action.DragCancel)
        });
        activeSensorRef.current = sensorInstance;
        function createHandler(type) {
            return async function handler() {
                const { active: active, collisions: collisions, over: over, scrollAdjustedTranslate: scrollAdjustedTranslate } = sensorContext.current;
                let event = null;
                if (active && scrollAdjustedTranslate) {
                    const { cancelDrop: cancelDrop } = latestProps.current;
                    event = {
                        activatorEvent: activatorEvent,
                        active: active,
                        collisions: collisions,
                        delta: scrollAdjustedTranslate,
                        over: over
                    };
                    if (type === $290836fe8d7e8057$var$Action.DragEnd && typeof cancelDrop === "function") {
                        const shouldCancel = await Promise.resolve(cancelDrop(event));
                        if (shouldCancel) type = $290836fe8d7e8057$var$Action.DragCancel;
                    }
                }
                activeRef.current = null;
                (0, $jCNM0.unstable_batchedUpdates)(()=>{
                    dispatch({
                        type: type
                    });
                    setStatus($290836fe8d7e8057$var$Status.Uninitialized);
                    setOver(null);
                    setActiveSensor(null);
                    setActivatorEvent(null);
                    activeSensorRef.current = null;
                    const eventName = type === $290836fe8d7e8057$var$Action.DragEnd ? "onDragEnd" : "onDragCancel";
                    if (event) {
                        const handler = latestProps.current[eventName];
                        handler == null || handler(event);
                        dispatchMonitorEvent({
                            type: eventName,
                            event: event
                        });
                    }
                });
            };
        }
    }, [
        draggableNodes
    ]);
    const bindActivatorToSensorInstantiator = (0, $jbmdS.useCallback)((handler, sensor)=>{
        return (event, active)=>{
            const nativeEvent = event.nativeEvent;
            const activeDraggableNode = draggableNodes.get(active);
            if (activeRef.current !== null || // No active draggable
            !activeDraggableNode || // Event has already been captured
            nativeEvent.dndKit || nativeEvent.defaultPrevented) return;
            const activationContext = {
                active: activeDraggableNode
            };
            const shouldActivate = handler(event, sensor.options, activationContext);
            if (shouldActivate === true) {
                nativeEvent.dndKit = {
                    capturedBy: sensor.sensor
                };
                activeRef.current = active;
                instantiateSensor(event, sensor);
            }
        };
    }, [
        draggableNodes,
        instantiateSensor
    ]);
    const activators = $290836fe8d7e8057$var$useCombineActivators(sensors, bindActivatorToSensorInstantiator);
    $290836fe8d7e8057$var$useSensorSetup(sensors);
    (0, $2EYIn.useIsomorphicLayoutEffect)(()=>{
        if (activeNodeRect && status === $290836fe8d7e8057$var$Status.Initializing) setStatus($290836fe8d7e8057$var$Status.Initialized);
    }, [
        activeNodeRect,
        status
    ]);
    (0, $jbmdS.useEffect)(()=>{
        const { onDragMove: onDragMove } = latestProps.current;
        const { active: active, activatorEvent: activatorEvent, collisions: collisions, over: over } = sensorContext.current;
        if (!active || !activatorEvent) return;
        const event = {
            active: active,
            activatorEvent: activatorEvent,
            collisions: collisions,
            delta: {
                x: scrollAdjustedTranslate.x,
                y: scrollAdjustedTranslate.y
            },
            over: over
        };
        (0, $jCNM0.unstable_batchedUpdates)(()=>{
            onDragMove == null || onDragMove(event);
            dispatchMonitorEvent({
                type: "onDragMove",
                event: event
            });
        });
    }, [
        scrollAdjustedTranslate.x,
        scrollAdjustedTranslate.y
    ]);
    (0, $jbmdS.useEffect)(()=>{
        const { active: active, activatorEvent: activatorEvent, collisions: collisions, droppableContainers: droppableContainers, scrollAdjustedTranslate: scrollAdjustedTranslate } = sensorContext.current;
        if (!active || activeRef.current == null || !activatorEvent || !scrollAdjustedTranslate) return;
        const { onDragOver: onDragOver } = latestProps.current;
        const overContainer = droppableContainers.get(overId);
        const over = overContainer && overContainer.rect.current ? {
            id: overContainer.id,
            rect: overContainer.rect.current,
            data: overContainer.data,
            disabled: overContainer.disabled
        } : null;
        const event = {
            active: active,
            activatorEvent: activatorEvent,
            collisions: collisions,
            delta: {
                x: scrollAdjustedTranslate.x,
                y: scrollAdjustedTranslate.y
            },
            over: over
        };
        (0, $jCNM0.unstable_batchedUpdates)(()=>{
            setOver(over);
            onDragOver == null || onDragOver(event);
            dispatchMonitorEvent({
                type: "onDragOver",
                event: event
            });
        });
    }, [
        overId
    ]);
    (0, $2EYIn.useIsomorphicLayoutEffect)(()=>{
        sensorContext.current = {
            activatorEvent: activatorEvent,
            active: active,
            activeNode: activeNode,
            collisionRect: collisionRect,
            collisions: collisions,
            droppableRects: droppableRects,
            draggableNodes: draggableNodes,
            draggingNode: draggingNode,
            draggingNodeRect: draggingNodeRect,
            droppableContainers: droppableContainers,
            over: over,
            scrollableAncestors: scrollableAncestors,
            scrollAdjustedTranslate: scrollAdjustedTranslate
        };
        activeRects.current = {
            initial: draggingNodeRect,
            translated: collisionRect
        };
    }, [
        active,
        activeNode,
        collisions,
        collisionRect,
        draggableNodes,
        draggingNode,
        draggingNodeRect,
        droppableRects,
        droppableContainers,
        over,
        scrollableAncestors,
        scrollAdjustedTranslate
    ]);
    $290836fe8d7e8057$var$useAutoScroller({
        ...autoScrollOptions,
        delta: translate,
        draggingRect: collisionRect,
        pointerCoordinates: pointerCoordinates,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects
    });
    const publicContext = (0, $jbmdS.useMemo)(()=>{
        const context = {
            active: active,
            activeNode: activeNode,
            activeNodeRect: activeNodeRect,
            activatorEvent: activatorEvent,
            collisions: collisions,
            containerNodeRect: containerNodeRect,
            dragOverlay: dragOverlay,
            draggableNodes: draggableNodes,
            droppableContainers: droppableContainers,
            droppableRects: droppableRects,
            over: over,
            measureDroppableContainers: measureDroppableContainers,
            scrollableAncestors: scrollableAncestors,
            scrollableAncestorRects: scrollableAncestorRects,
            measuringConfiguration: measuringConfiguration,
            measuringScheduled: measuringScheduled,
            windowRect: windowRect
        };
        return context;
    }, [
        active,
        activeNode,
        activeNodeRect,
        activatorEvent,
        collisions,
        containerNodeRect,
        dragOverlay,
        draggableNodes,
        droppableContainers,
        droppableRects,
        over,
        measureDroppableContainers,
        scrollableAncestors,
        scrollableAncestorRects,
        measuringConfiguration,
        measuringScheduled,
        windowRect
    ]);
    const internalContext = (0, $jbmdS.useMemo)(()=>{
        const context = {
            activatorEvent: activatorEvent,
            activators: activators,
            active: active,
            activeNodeRect: activeNodeRect,
            ariaDescribedById: {
                draggable: draggableDescribedById
            },
            dispatch: dispatch,
            draggableNodes: draggableNodes,
            over: over,
            measureDroppableContainers: measureDroppableContainers
        };
        return context;
    }, [
        activatorEvent,
        activators,
        active,
        activeNodeRect,
        dispatch,
        draggableDescribedById,
        draggableNodes,
        over,
        measureDroppableContainers
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($290836fe8d7e8057$var$DndMonitorContext.Provider, {
        value: registerMonitorListener
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($290836fe8d7e8057$var$InternalContext.Provider, {
        value: internalContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($290836fe8d7e8057$var$PublicContext.Provider, {
        value: publicContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($290836fe8d7e8057$var$ActiveDraggableContext.Provider, {
        value: transform
    }, children)), (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($290836fe8d7e8057$var$RestoreFocus, {
        disabled: (accessibility == null ? void 0 : accessibility.restoreFocus) === false
    })), (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($290836fe8d7e8057$var$Accessibility, {
        ...accessibility,
        hiddenTextDescribedById: draggableDescribedById
    }));
    function getAutoScrollerOptions() {
        const activeSensorDisablesAutoscroll = (activeSensor == null ? void 0 : activeSensor.autoScrollEnabled) === false;
        const autoScrollGloballyDisabled = typeof autoScroll === "object" ? autoScroll.enabled === false : autoScroll === false;
        const enabled = isInitialized && !activeSensorDisablesAutoscroll && !autoScrollGloballyDisabled;
        if (typeof autoScroll === "object") return {
            ...autoScroll,
            enabled: enabled
        };
        return {
            enabled: enabled
        };
    }
});
const $290836fe8d7e8057$var$NullContext = /*#__PURE__*/ (0, $jbmdS.createContext)(null);
const $290836fe8d7e8057$var$defaultRole = "button";
const $290836fe8d7e8057$var$ID_PREFIX = "Draggable";
function $290836fe8d7e8057$export$df30c81f5aa01ff7(_ref) {
    let { id: id, data: data, disabled: disabled = false, attributes: attributes } = _ref;
    const key = (0, $2EYIn.useUniqueId)($290836fe8d7e8057$var$ID_PREFIX);
    const { activators: activators, activatorEvent: activatorEvent, active: active, activeNodeRect: activeNodeRect, ariaDescribedById: ariaDescribedById, draggableNodes: draggableNodes, over: over } = (0, $jbmdS.useContext)($290836fe8d7e8057$var$InternalContext);
    const { role: role = $290836fe8d7e8057$var$defaultRole, roleDescription: roleDescription = "draggable", tabIndex: tabIndex = 0 } = attributes != null ? attributes : {};
    const isDragging = (active == null ? void 0 : active.id) === id;
    const transform = (0, $jbmdS.useContext)(isDragging ? $290836fe8d7e8057$var$ActiveDraggableContext : $290836fe8d7e8057$var$NullContext);
    const [node, setNodeRef] = (0, $2EYIn.useNodeRef)();
    const [activatorNode, setActivatorNodeRef] = (0, $2EYIn.useNodeRef)();
    const listeners = $290836fe8d7e8057$var$useSyntheticListeners(activators, id);
    const dataRef = (0, $2EYIn.useLatestValue)(data);
    (0, $2EYIn.useIsomorphicLayoutEffect)(()=>{
        draggableNodes.set(id, {
            id: id,
            key: key,
            node: node,
            activatorNode: activatorNode,
            data: dataRef
        });
        return ()=>{
            const node = draggableNodes.get(id);
            if (node && node.key === key) draggableNodes.delete(id);
        };
    }, [
        draggableNodes,
        id
    ]);
    const memoizedAttributes = (0, $jbmdS.useMemo)(()=>({
            role: role,
            tabIndex: tabIndex,
            "aria-disabled": disabled,
            "aria-pressed": isDragging && role === $290836fe8d7e8057$var$defaultRole ? true : undefined,
            "aria-roledescription": roleDescription,
            "aria-describedby": ariaDescribedById.draggable
        }), [
        disabled,
        role,
        tabIndex,
        isDragging,
        roleDescription,
        ariaDescribedById.draggable
    ]);
    return {
        active: active,
        activatorEvent: activatorEvent,
        activeNodeRect: activeNodeRect,
        attributes: memoizedAttributes,
        isDragging: isDragging,
        listeners: disabled ? undefined : listeners,
        node: node,
        over: over,
        setNodeRef: setNodeRef,
        setActivatorNodeRef: setActivatorNodeRef,
        transform: transform
    };
}
function $290836fe8d7e8057$export$4930f6bf413be70e() {
    return (0, $jbmdS.useContext)($290836fe8d7e8057$var$PublicContext);
}
const $290836fe8d7e8057$var$ID_PREFIX$1 = "Droppable";
const $290836fe8d7e8057$var$defaultResizeObserverConfig = {
    timeout: 25
};
function $290836fe8d7e8057$export$d74e5d67dc2b3176(_ref) {
    let { data: data, disabled: disabled = false, id: id, resizeObserverConfig: resizeObserverConfig } = _ref;
    const key = (0, $2EYIn.useUniqueId)($290836fe8d7e8057$var$ID_PREFIX$1);
    const { active: active, dispatch: dispatch, over: over, measureDroppableContainers: measureDroppableContainers } = (0, $jbmdS.useContext)($290836fe8d7e8057$var$InternalContext);
    const previous = (0, $jbmdS.useRef)({
        disabled: disabled
    });
    const resizeObserverConnected = (0, $jbmdS.useRef)(false);
    const rect = (0, $jbmdS.useRef)(null);
    const callbackId = (0, $jbmdS.useRef)(null);
    const { disabled: resizeObserverDisabled, updateMeasurementsFor: updateMeasurementsFor, timeout: resizeObserverTimeout } = {
        ...$290836fe8d7e8057$var$defaultResizeObserverConfig,
        ...resizeObserverConfig
    };
    const ids = (0, $2EYIn.useLatestValue)(updateMeasurementsFor != null ? updateMeasurementsFor : id);
    const handleResize = (0, $jbmdS.useCallback)(()=>{
        if (!resizeObserverConnected.current) {
            // ResizeObserver invokes the `handleResize` callback as soon as `observe` is called,
            // assuming the element is rendered and displayed.
            resizeObserverConnected.current = true;
            return;
        }
        if (callbackId.current != null) clearTimeout(callbackId.current);
        callbackId.current = setTimeout(()=>{
            measureDroppableContainers(Array.isArray(ids.current) ? ids.current : [
                ids.current
            ]);
            callbackId.current = null;
        }, resizeObserverTimeout);
    }, [
        resizeObserverTimeout
    ]);
    const resizeObserver = $290836fe8d7e8057$var$useResizeObserver({
        callback: handleResize,
        disabled: resizeObserverDisabled || !active
    });
    const handleNodeChange = (0, $jbmdS.useCallback)((newElement, previousElement)=>{
        if (!resizeObserver) return;
        if (previousElement) {
            resizeObserver.unobserve(previousElement);
            resizeObserverConnected.current = false;
        }
        if (newElement) resizeObserver.observe(newElement);
    }, [
        resizeObserver
    ]);
    const [nodeRef, setNodeRef] = (0, $2EYIn.useNodeRef)(handleNodeChange);
    const dataRef = (0, $2EYIn.useLatestValue)(data);
    (0, $jbmdS.useEffect)(()=>{
        if (!resizeObserver || !nodeRef.current) return;
        resizeObserver.disconnect();
        resizeObserverConnected.current = false;
        resizeObserver.observe(nodeRef.current);
    }, [
        nodeRef,
        resizeObserver
    ]);
    (0, $jbmdS.useEffect)(()=>{
        dispatch({
            type: $290836fe8d7e8057$var$Action.RegisterDroppable,
            element: {
                id: id,
                key: key,
                disabled: disabled,
                node: nodeRef,
                rect: rect,
                data: dataRef
            }
        });
        return ()=>dispatch({
                type: $290836fe8d7e8057$var$Action.UnregisterDroppable,
                key: key,
                id: id
            });
    }, [
        id
    ]);
    (0, $jbmdS.useEffect)(()=>{
        if (disabled !== previous.current.disabled) {
            dispatch({
                type: $290836fe8d7e8057$var$Action.SetDroppableDisabled,
                id: id,
                key: key,
                disabled: disabled
            });
            previous.current.disabled = disabled;
        }
    }, [
        id,
        key,
        disabled,
        dispatch
    ]);
    return {
        active: active,
        rect: rect,
        isOver: (over == null ? void 0 : over.id) === id,
        node: nodeRef,
        over: over,
        setNodeRef: setNodeRef
    };
}
function $290836fe8d7e8057$var$AnimationManager(_ref) {
    let { animation: animation, children: children } = _ref;
    const [clonedChildren, setClonedChildren] = (0, $jbmdS.useState)(null);
    const [element, setElement] = (0, $jbmdS.useState)(null);
    const previousChildren = (0, $2EYIn.usePrevious)(children);
    if (!children && !clonedChildren && previousChildren) setClonedChildren(previousChildren);
    (0, $2EYIn.useIsomorphicLayoutEffect)(()=>{
        if (!element) return;
        const key = clonedChildren == null ? void 0 : clonedChildren.key;
        const id = clonedChildren == null ? void 0 : clonedChildren.props.id;
        if (key == null || id == null) {
            setClonedChildren(null);
            return;
        }
        Promise.resolve(animation(id, element)).then(()=>{
            setClonedChildren(null);
        });
    }, [
        animation,
        clonedChildren,
        element
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).Fragment, null, children, clonedChildren ? (0, $jbmdS.cloneElement)(clonedChildren, {
        ref: setElement
    }) : null);
}
const $290836fe8d7e8057$var$defaultTransform = {
    x: 0,
    y: 0,
    scaleX: 1,
    scaleY: 1
};
function $290836fe8d7e8057$var$NullifiedContextProvider(_ref) {
    let { children: children } = _ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($290836fe8d7e8057$var$InternalContext.Provider, {
        value: $290836fe8d7e8057$var$defaultInternalContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($290836fe8d7e8057$var$ActiveDraggableContext.Provider, {
        value: $290836fe8d7e8057$var$defaultTransform
    }, children));
}
const $290836fe8d7e8057$var$baseStyles = {
    position: "fixed",
    touchAction: "none"
};
const $290836fe8d7e8057$var$defaultTransition = (activatorEvent)=>{
    const isKeyboardActivator = (0, $2EYIn.isKeyboardEvent)(activatorEvent);
    return isKeyboardActivator ? "transform 250ms ease" : undefined;
};
const $290836fe8d7e8057$var$PositionedOverlay = /*#__PURE__*/ (0, $jbmdS.forwardRef)((_ref, ref)=>{
    let { as: as, activatorEvent: activatorEvent, adjustScale: adjustScale, children: children, className: className, rect: rect, style: style, transform: transform, transition: transition = $290836fe8d7e8057$var$defaultTransition } = _ref;
    if (!rect) return null;
    const scaleAdjustedTransform = adjustScale ? transform : {
        ...transform,
        scaleX: 1,
        scaleY: 1
    };
    const styles = {
        ...$290836fe8d7e8057$var$baseStyles,
        width: rect.width,
        height: rect.height,
        top: rect.top,
        left: rect.left,
        transform: (0, $2EYIn.CSS).Transform.toString(scaleAdjustedTransform),
        transformOrigin: adjustScale && activatorEvent ? $290836fe8d7e8057$var$getRelativeTransformOrigin(activatorEvent, rect) : undefined,
        transition: typeof transition === "function" ? transition(activatorEvent) : transition,
        ...style
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement(as, {
        className: className,
        style: styles,
        ref: ref
    }, children);
});
const $290836fe8d7e8057$export$28c62adcaabe654c = (options)=>(_ref)=>{
        let { active: active, dragOverlay: dragOverlay } = _ref;
        const originalStyles = {};
        const { styles: styles, className: className } = options;
        if (styles != null && styles.active) for (const [key, value] of Object.entries(styles.active)){
            if (value === undefined) continue;
            originalStyles[key] = active.node.style.getPropertyValue(key);
            active.node.style.setProperty(key, value);
        }
        if (styles != null && styles.dragOverlay) for (const [key, value] of Object.entries(styles.dragOverlay)){
            if (value === undefined) continue;
            dragOverlay.node.style.setProperty(key, value);
        }
        if (className != null && className.active) active.node.classList.add(className.active);
        if (className != null && className.dragOverlay) dragOverlay.node.classList.add(className.dragOverlay);
        return function cleanup() {
            for (const [key, value] of Object.entries(originalStyles))active.node.style.setProperty(key, value);
            if (className != null && className.active) active.node.classList.remove(className.active);
        };
    };
const $290836fe8d7e8057$var$defaultKeyframeResolver = (_ref2)=>{
    let { transform: { initial: initial, final: final } } = _ref2;
    return [
        {
            transform: (0, $2EYIn.CSS).Transform.toString(initial)
        },
        {
            transform: (0, $2EYIn.CSS).Transform.toString(final)
        }
    ];
};
const $290836fe8d7e8057$export$10f7ab1c653bb60e = {
    duration: 250,
    easing: "ease",
    keyframes: $290836fe8d7e8057$var$defaultKeyframeResolver,
    sideEffects: /*#__PURE__*/ $290836fe8d7e8057$export$28c62adcaabe654c({
        styles: {
            active: {
                opacity: "0"
            }
        }
    })
};
function $290836fe8d7e8057$var$useDropAnimation(_ref3) {
    let { config: config, draggableNodes: draggableNodes, droppableContainers: droppableContainers, measuringConfiguration: measuringConfiguration } = _ref3;
    return (0, $2EYIn.useEvent)((id, node)=>{
        if (config === null) return;
        const activeDraggable = draggableNodes.get(id);
        if (!activeDraggable) return;
        const activeNode = activeDraggable.node.current;
        if (!activeNode) return;
        const measurableNode = $290836fe8d7e8057$var$getMeasurableNode(node);
        if (!measurableNode) return;
        const { transform: transform } = (0, $2EYIn.getWindow)(node).getComputedStyle(node);
        const parsedTransform = $290836fe8d7e8057$var$parseTransform(transform);
        if (!parsedTransform) return;
        const animation = typeof config === "function" ? config : $290836fe8d7e8057$var$createDefaultDropAnimation(config);
        $290836fe8d7e8057$var$scrollIntoViewIfNeeded(activeNode, measuringConfiguration.draggable.measure);
        return animation({
            active: {
                id: id,
                data: activeDraggable.data,
                node: activeNode,
                rect: measuringConfiguration.draggable.measure(activeNode)
            },
            draggableNodes: draggableNodes,
            dragOverlay: {
                node: node,
                rect: measuringConfiguration.dragOverlay.measure(measurableNode)
            },
            droppableContainers: droppableContainers,
            measuringConfiguration: measuringConfiguration,
            transform: parsedTransform
        });
    });
}
function $290836fe8d7e8057$var$createDefaultDropAnimation(options) {
    const { duration: duration, easing: easing, sideEffects: sideEffects, keyframes: keyframes } = {
        ...$290836fe8d7e8057$export$10f7ab1c653bb60e,
        ...options
    };
    return (_ref4)=>{
        let { active: active, dragOverlay: dragOverlay, transform: transform, ...rest } = _ref4;
        if (!duration) // Do not animate if animation duration is zero.
        return;
        const delta = {
            x: dragOverlay.rect.left - active.rect.left,
            y: dragOverlay.rect.top - active.rect.top
        };
        const scale = {
            scaleX: transform.scaleX !== 1 ? active.rect.width * transform.scaleX / dragOverlay.rect.width : 1,
            scaleY: transform.scaleY !== 1 ? active.rect.height * transform.scaleY / dragOverlay.rect.height : 1
        };
        const finalTransform = {
            x: transform.x - delta.x,
            y: transform.y - delta.y,
            ...scale
        };
        const animationKeyframes = keyframes({
            ...rest,
            active: active,
            dragOverlay: dragOverlay,
            transform: {
                initial: transform,
                final: finalTransform
            }
        });
        const [firstKeyframe] = animationKeyframes;
        const lastKeyframe = animationKeyframes[animationKeyframes.length - 1];
        if (JSON.stringify(firstKeyframe) === JSON.stringify(lastKeyframe)) // The start and end keyframes are the same, infer that there is no animation needed.
        return;
        const cleanup = sideEffects == null ? void 0 : sideEffects({
            active: active,
            dragOverlay: dragOverlay,
            ...rest
        });
        const animation = dragOverlay.node.animate(animationKeyframes, {
            duration: duration,
            easing: easing,
            fill: "forwards"
        });
        return new Promise((resolve)=>{
            animation.onfinish = ()=>{
                cleanup == null || cleanup();
                resolve();
            };
        });
    };
}
let $290836fe8d7e8057$var$key = 0;
function $290836fe8d7e8057$var$useKey(id) {
    return (0, $jbmdS.useMemo)(()=>{
        if (id == null) return;
        $290836fe8d7e8057$var$key++;
        return $290836fe8d7e8057$var$key;
    }, [
        id
    ]);
}
const $290836fe8d7e8057$export$aca73479aa40659d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).memo((_ref)=>{
    let { adjustScale: adjustScale = false, children: children, dropAnimation: dropAnimationConfig, style: style, transition: transition, modifiers: modifiers, wrapperElement: wrapperElement = "div", className: className, zIndex: zIndex = 999 } = _ref;
    const { activatorEvent: activatorEvent, active: active, activeNodeRect: activeNodeRect, containerNodeRect: containerNodeRect, draggableNodes: draggableNodes, droppableContainers: droppableContainers, dragOverlay: dragOverlay, over: over, measuringConfiguration: measuringConfiguration, scrollableAncestors: scrollableAncestors, scrollableAncestorRects: scrollableAncestorRects, windowRect: windowRect } = $290836fe8d7e8057$export$4930f6bf413be70e();
    const transform = (0, $jbmdS.useContext)($290836fe8d7e8057$var$ActiveDraggableContext);
    const key = $290836fe8d7e8057$var$useKey(active == null ? void 0 : active.id);
    const modifiedTransform = $290836fe8d7e8057$export$f1696300e8775372(modifiers, {
        activatorEvent: activatorEvent,
        active: active,
        activeNodeRect: activeNodeRect,
        containerNodeRect: containerNodeRect,
        draggingNodeRect: dragOverlay.rect,
        over: over,
        overlayNodeRect: dragOverlay.rect,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects,
        transform: transform,
        windowRect: windowRect
    });
    const initialRect = $290836fe8d7e8057$var$useInitialValue(activeNodeRect);
    const dropAnimation = $290836fe8d7e8057$var$useDropAnimation({
        config: dropAnimationConfig,
        draggableNodes: draggableNodes,
        droppableContainers: droppableContainers,
        measuringConfiguration: measuringConfiguration
    }); // We need to wait for the active node to be measured before connecting the drag overlay ref
    // otherwise collisions can be computed against a mispositioned drag overlay
    const ref = initialRect ? dragOverlay.setRef : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($290836fe8d7e8057$var$NullifiedContextProvider, null, (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($290836fe8d7e8057$var$AnimationManager, {
        animation: dropAnimation
    }, active && key ? (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($290836fe8d7e8057$var$PositionedOverlay, {
        key: key,
        id: active.id,
        ref: ref,
        as: wrapperElement,
        activatorEvent: activatorEvent,
        adjustScale: adjustScale,
        className: className,
        transition: transition,
        rect: initialRect,
        style: {
            zIndex: zIndex,
            ...style
        },
        transform: modifiedTransform
    }, children) : null));
});

});
parcelRegister("2EYIn", function(module, exports) {

$parcel$export(module.exports, "useCombinedRefs", function () { return $1efe69e16430819b$export$2f8294366bb2d67a; });
$parcel$export(module.exports, "canUseDOM", function () { return $1efe69e16430819b$export$71594e8a50f746f4; });
$parcel$export(module.exports, "isWindow", function () { return $1efe69e16430819b$export$5a096129d439f843; });
$parcel$export(module.exports, "isNode", function () { return $1efe69e16430819b$export$8ee0fc9ee280b4ee; });
$parcel$export(module.exports, "getWindow", function () { return $1efe69e16430819b$export$38b2d434cce3ea22; });
$parcel$export(module.exports, "isDocument", function () { return $1efe69e16430819b$export$62858bae88b53fd0; });
$parcel$export(module.exports, "isHTMLElement", function () { return $1efe69e16430819b$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isSVGElement", function () { return $1efe69e16430819b$export$17eda790a720ec57; });
$parcel$export(module.exports, "getOwnerDocument", function () { return $1efe69e16430819b$export$b204af158042fbac; });
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $1efe69e16430819b$export$700979bc83e7db82; });
$parcel$export(module.exports, "useEvent", function () { return $1efe69e16430819b$export$90fc3a17d93f704c; });
$parcel$export(module.exports, "useInterval", function () { return $1efe69e16430819b$export$f4b266cd2aae9cb1; });
$parcel$export(module.exports, "useLatestValue", function () { return $1efe69e16430819b$export$86c4283a11f23f95; });
$parcel$export(module.exports, "useLazyMemo", function () { return $1efe69e16430819b$export$b0d7b7f1fcd613d1; });
$parcel$export(module.exports, "useNodeRef", function () { return $1efe69e16430819b$export$bc23c270f170c912; });
$parcel$export(module.exports, "usePrevious", function () { return $1efe69e16430819b$export$5cae361ad82dce8b; });
$parcel$export(module.exports, "useUniqueId", function () { return $1efe69e16430819b$export$c485849f2e393253; });
$parcel$export(module.exports, "add", function () { return $1efe69e16430819b$export$e16d8520af44a096; });
$parcel$export(module.exports, "subtract", function () { return $1efe69e16430819b$export$4e2d2ead65e5f7e3; });
$parcel$export(module.exports, "isKeyboardEvent", function () { return $1efe69e16430819b$export$130b789831072f4c; });
$parcel$export(module.exports, "getEventCoordinates", function () { return $1efe69e16430819b$export$36195c8aa1517e04; });
$parcel$export(module.exports, "CSS", function () { return $1efe69e16430819b$export$c4ffa16951855e28; });
$parcel$export(module.exports, "findFirstFocusableNode", function () { return $1efe69e16430819b$export$44f71d798fd0a62b; });

var $jbmdS = parcelRequire("jbmdS");
function $1efe69e16430819b$export$2f8294366bb2d67a() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    return (0, $jbmdS.useMemo)(()=>(node)=>{
            refs.forEach((ref)=>ref(node));
        }, refs);
}
// https://github.com/facebook/react/blob/master/packages/shared/ExecutionEnvironment.js
const $1efe69e16430819b$export$71594e8a50f746f4 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $1efe69e16430819b$export$5a096129d439f843(element) {
    const elementString = Object.prototype.toString.call(element);
    return elementString === "[object Window]" || // In Electron context the Window object serializes to [object global]
    elementString === "[object global]";
}
function $1efe69e16430819b$export$8ee0fc9ee280b4ee(node) {
    return "nodeType" in node;
}
function $1efe69e16430819b$export$38b2d434cce3ea22(target) {
    var _target$ownerDocument, _target$ownerDocument2;
    if (!target) return window;
    if ($1efe69e16430819b$export$5a096129d439f843(target)) return target;
    if (!$1efe69e16430819b$export$8ee0fc9ee280b4ee(target)) return window;
    return (_target$ownerDocument = (_target$ownerDocument2 = target.ownerDocument) == null ? void 0 : _target$ownerDocument2.defaultView) != null ? _target$ownerDocument : window;
}
function $1efe69e16430819b$export$62858bae88b53fd0(node) {
    const { Document: Document } = $1efe69e16430819b$export$38b2d434cce3ea22(node);
    return node instanceof Document;
}
function $1efe69e16430819b$export$1b3bfaa9684536aa(node) {
    if ($1efe69e16430819b$export$5a096129d439f843(node)) return false;
    return node instanceof $1efe69e16430819b$export$38b2d434cce3ea22(node).HTMLElement;
}
function $1efe69e16430819b$export$17eda790a720ec57(node) {
    return node instanceof $1efe69e16430819b$export$38b2d434cce3ea22(node).SVGElement;
}
function $1efe69e16430819b$export$b204af158042fbac(target) {
    if (!target) return document;
    if ($1efe69e16430819b$export$5a096129d439f843(target)) return target.document;
    if (!$1efe69e16430819b$export$8ee0fc9ee280b4ee(target)) return document;
    if ($1efe69e16430819b$export$62858bae88b53fd0(target)) return target;
    if ($1efe69e16430819b$export$1b3bfaa9684536aa(target) || $1efe69e16430819b$export$17eda790a720ec57(target)) return target.ownerDocument;
    return document;
}
/**
 * A hook that resolves to useEffect on the server and useLayoutEffect on the client
 * @param callback {function} Callback function that is invoked when the dependencies of the hook change
 */ const $1efe69e16430819b$export$700979bc83e7db82 = $1efe69e16430819b$export$71594e8a50f746f4 ? (0, $jbmdS.useLayoutEffect) : (0, $jbmdS.useEffect);
function $1efe69e16430819b$export$90fc3a17d93f704c(handler) {
    const handlerRef = (0, $jbmdS.useRef)(handler);
    $1efe69e16430819b$export$700979bc83e7db82(()=>{
        handlerRef.current = handler;
    });
    return (0, $jbmdS.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return handlerRef.current == null ? void 0 : handlerRef.current(...args);
    }, []);
}
function $1efe69e16430819b$export$f4b266cd2aae9cb1() {
    const intervalRef = (0, $jbmdS.useRef)(null);
    const set = (0, $jbmdS.useCallback)((listener, duration)=>{
        intervalRef.current = setInterval(listener, duration);
    }, []);
    const clear = (0, $jbmdS.useCallback)(()=>{
        if (intervalRef.current !== null) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    }, []);
    return [
        set,
        clear
    ];
}
function $1efe69e16430819b$export$86c4283a11f23f95(value, dependencies) {
    if (dependencies === void 0) dependencies = [
        value
    ];
    const valueRef = (0, $jbmdS.useRef)(value);
    $1efe69e16430819b$export$700979bc83e7db82(()=>{
        if (valueRef.current !== value) valueRef.current = value;
    }, dependencies);
    return valueRef;
}
function $1efe69e16430819b$export$b0d7b7f1fcd613d1(callback, dependencies) {
    const valueRef = (0, $jbmdS.useRef)();
    return (0, $jbmdS.useMemo)(()=>{
        const newValue = callback(valueRef.current);
        valueRef.current = newValue;
        return newValue;
    }, [
        ...dependencies
    ]);
}
function $1efe69e16430819b$export$bc23c270f170c912(onChange) {
    const onChangeHandler = $1efe69e16430819b$export$90fc3a17d93f704c(onChange);
    const node = (0, $jbmdS.useRef)(null);
    const setNodeRef = (0, $jbmdS.useCallback)((element)=>{
        if (element !== node.current) onChangeHandler == null || onChangeHandler(element, node.current);
        node.current = element;
    }, []);
    return [
        node,
        setNodeRef
    ];
}
function $1efe69e16430819b$export$5cae361ad82dce8b(value) {
    const ref = (0, $jbmdS.useRef)();
    (0, $jbmdS.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
let $1efe69e16430819b$var$ids = {};
function $1efe69e16430819b$export$c485849f2e393253(prefix, value) {
    return (0, $jbmdS.useMemo)(()=>{
        if (value) return value;
        const id = $1efe69e16430819b$var$ids[prefix] == null ? 0 : $1efe69e16430819b$var$ids[prefix] + 1;
        $1efe69e16430819b$var$ids[prefix] = id;
        return prefix + "-" + id;
    }, [
        prefix,
        value
    ]);
}
function $1efe69e16430819b$var$createAdjustmentFn(modifier) {
    return function(object) {
        for(var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)adjustments[_key - 1] = arguments[_key];
        return adjustments.reduce((accumulator, adjustment)=>{
            const entries = Object.entries(adjustment);
            for (const [key, valueAdjustment] of entries){
                const value = accumulator[key];
                if (value != null) accumulator[key] = value + modifier * valueAdjustment;
            }
            return accumulator;
        }, {
            ...object
        });
    };
}
const $1efe69e16430819b$export$e16d8520af44a096 = /*#__PURE__*/ $1efe69e16430819b$var$createAdjustmentFn(1);
const $1efe69e16430819b$export$4e2d2ead65e5f7e3 = /*#__PURE__*/ $1efe69e16430819b$var$createAdjustmentFn(-1);
function $1efe69e16430819b$export$d0e71af79cd586c6(event) {
    return "clientX" in event && "clientY" in event;
}
function $1efe69e16430819b$export$130b789831072f4c(event) {
    if (!event) return false;
    const { KeyboardEvent: KeyboardEvent } = $1efe69e16430819b$export$38b2d434cce3ea22(event.target);
    return KeyboardEvent && event instanceof KeyboardEvent;
}
function $1efe69e16430819b$export$c4dfce035d43d1e0(event) {
    if (!event) return false;
    const { TouchEvent: TouchEvent } = $1efe69e16430819b$export$38b2d434cce3ea22(event.target);
    return TouchEvent && event instanceof TouchEvent;
}
/**
 * Returns the normalized x and y coordinates for mouse and touch events.
 */ function $1efe69e16430819b$export$36195c8aa1517e04(event) {
    if ($1efe69e16430819b$export$c4dfce035d43d1e0(event)) {
        if (event.touches && event.touches.length) {
            const { clientX: x, clientY: y } = event.touches[0];
            return {
                x: x,
                y: y
            };
        } else if (event.changedTouches && event.changedTouches.length) {
            const { clientX: x, clientY: y } = event.changedTouches[0];
            return {
                x: x,
                y: y
            };
        }
    }
    if ($1efe69e16430819b$export$d0e71af79cd586c6(event)) return {
        x: event.clientX,
        y: event.clientY
    };
    return null;
}
const $1efe69e16430819b$export$c4ffa16951855e28 = /*#__PURE__*/ Object.freeze({
    Translate: {
        toString (transform) {
            if (!transform) return;
            const { x: x, y: y } = transform;
            return "translate3d(" + (x ? Math.round(x) : 0) + "px, " + (y ? Math.round(y) : 0) + "px, 0)";
        }
    },
    Scale: {
        toString (transform) {
            if (!transform) return;
            const { scaleX: scaleX, scaleY: scaleY } = transform;
            return "scaleX(" + scaleX + ") scaleY(" + scaleY + ")";
        }
    },
    Transform: {
        toString (transform) {
            if (!transform) return;
            return [
                $1efe69e16430819b$export$c4ffa16951855e28.Translate.toString(transform),
                $1efe69e16430819b$export$c4ffa16951855e28.Scale.toString(transform)
            ].join(" ");
        }
    },
    Transition: {
        toString (_ref) {
            let { property: property, duration: duration, easing: easing } = _ref;
            return property + " " + duration + "ms " + easing;
        }
    }
});
const $1efe69e16430819b$var$SELECTOR = "a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]";
function $1efe69e16430819b$export$44f71d798fd0a62b(element) {
    if (element.matches($1efe69e16430819b$var$SELECTOR)) return element;
    return element.querySelector($1efe69e16430819b$var$SELECTOR);
}

});

parcelRegister("wVnus", function(module, exports) {

$parcel$export(module.exports, "HiddenText", function () { return $062f7f531c9c9053$export$1496ac55023363a5; });
$parcel$export(module.exports, "LiveRegion", function () { return $062f7f531c9c9053$export$ae99b902be98b17; });
$parcel$export(module.exports, "useAnnouncement", function () { return $062f7f531c9c9053$export$97d78af8d95ca8bd; });

var $jbmdS = parcelRequire("jbmdS");
const $062f7f531c9c9053$var$hiddenStyles = {
    display: "none"
};
function $062f7f531c9c9053$export$1496ac55023363a5(_ref) {
    let { id: id, value: value } = _ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("div", {
        id: id,
        style: $062f7f531c9c9053$var$hiddenStyles
    }, value);
}
function $062f7f531c9c9053$export$ae99b902be98b17(_ref) {
    let { id: id, announcement: announcement, ariaLiveType: ariaLiveType = "assertive" } = _ref;
    // Hide element visually but keep it readable by screen readers
    const visuallyHidden = {
        position: "fixed",
        top: 0,
        left: 0,
        width: 1,
        height: 1,
        margin: -1,
        border: 0,
        padding: 0,
        overflow: "hidden",
        clip: "rect(0 0 0 0)",
        clipPath: "inset(100%)",
        whiteSpace: "nowrap"
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("div", {
        id: id,
        style: visuallyHidden,
        role: "status",
        "aria-live": ariaLiveType,
        "aria-atomic": true
    }, announcement);
}
function $062f7f531c9c9053$export$97d78af8d95ca8bd() {
    const [announcement, setAnnouncement] = (0, $jbmdS.useState)("");
    const announce = (0, $jbmdS.useCallback)((value)=>{
        if (value != null) setAnnouncement(value);
    }, []);
    return {
        announce: announce,
        announcement: announcement
    };
}

});




parcelRegister("eJqVD", function(module, exports) {

$parcel$export(module.exports, "restrictToVerticalAxis", function () { return $ab9a281e87cbd8a4$export$1ed98a87b7c51b89; });

var $2EYIn = parcelRequire("2EYIn");
function $ab9a281e87cbd8a4$export$7f11ea1f0ba255b5(gridSize) {
    return (_ref)=>{
        let { transform: transform } = _ref;
        return {
            ...transform,
            x: Math.ceil(transform.x / gridSize) * gridSize,
            y: Math.ceil(transform.y / gridSize) * gridSize
        };
    };
}
const $ab9a281e87cbd8a4$export$29320759dd5f3702 = (_ref)=>{
    let { transform: transform } = _ref;
    return {
        ...transform,
        y: 0
    };
};
function $ab9a281e87cbd8a4$var$restrictToBoundingRect(transform, rect, boundingRect) {
    const value = {
        ...transform
    };
    if (rect.top + transform.y <= boundingRect.top) value.y = boundingRect.top - rect.top;
    else if (rect.bottom + transform.y >= boundingRect.top + boundingRect.height) value.y = boundingRect.top + boundingRect.height - rect.bottom;
    if (rect.left + transform.x <= boundingRect.left) value.x = boundingRect.left - rect.left;
    else if (rect.right + transform.x >= boundingRect.left + boundingRect.width) value.x = boundingRect.left + boundingRect.width - rect.right;
    return value;
}
const $ab9a281e87cbd8a4$export$c7685f801ed492b5 = (_ref)=>{
    let { containerNodeRect: containerNodeRect, draggingNodeRect: draggingNodeRect, transform: transform } = _ref;
    if (!draggingNodeRect || !containerNodeRect) return transform;
    return $ab9a281e87cbd8a4$var$restrictToBoundingRect(transform, draggingNodeRect, containerNodeRect);
};
const $ab9a281e87cbd8a4$export$85bf625d52c1d097 = (_ref)=>{
    let { draggingNodeRect: draggingNodeRect, transform: transform, scrollableAncestorRects: scrollableAncestorRects } = _ref;
    const firstScrollableAncestorRect = scrollableAncestorRects[0];
    if (!draggingNodeRect || !firstScrollableAncestorRect) return transform;
    return $ab9a281e87cbd8a4$var$restrictToBoundingRect(transform, draggingNodeRect, firstScrollableAncestorRect);
};
const $ab9a281e87cbd8a4$export$1ed98a87b7c51b89 = (_ref)=>{
    let { transform: transform } = _ref;
    return {
        ...transform,
        x: 0
    };
};
const $ab9a281e87cbd8a4$export$57196ad89f591aab = (_ref)=>{
    let { transform: transform, draggingNodeRect: draggingNodeRect, windowRect: windowRect } = _ref;
    if (!draggingNodeRect || !windowRect) return transform;
    return $ab9a281e87cbd8a4$var$restrictToBoundingRect(transform, draggingNodeRect, windowRect);
};
const $ab9a281e87cbd8a4$export$70a75ea36ecd3098 = (_ref)=>{
    let { activatorEvent: activatorEvent, draggingNodeRect: draggingNodeRect, transform: transform } = _ref;
    if (draggingNodeRect && activatorEvent) {
        const activatorCoordinates = (0, $2EYIn.getEventCoordinates)(activatorEvent);
        if (!activatorCoordinates) return transform;
        const offsetX = activatorCoordinates.x - draggingNodeRect.left;
        const offsetY = activatorCoordinates.y - draggingNodeRect.top;
        return {
            ...transform,
            x: transform.x + offsetX - draggingNodeRect.width / 2,
            y: transform.y + offsetY - draggingNodeRect.height / 2
        };
    }
    return transform;
};

});


parcelRegister("aaosT", function(module, exports) {

$parcel$export(module.exports, "useDataTable", function () { return $7603317fc4def885$export$25350bca48f99cd1; });

var $jbmdS = parcelRequire("jbmdS");

var $6UBLf = parcelRequire("6UBLf");
var $5zaoU = parcelRequire("5zaoU");

var $lVpRF = parcelRequire("lVpRF");
var $bYkcY = parcelRequire("bYkcY");

var $hPAFY = parcelRequire("hPAFY");

var $g1Ho2 = parcelRequire("g1Ho2");

var $1g7Kl = parcelRequire("1g7Kl");

var $1PdjB = parcelRequire("1PdjB");
function $7603317fc4def885$export$25350bca48f99cd1({ data: data, columns: columns, visibleColumns: visibleColumns, defaultSort: // pageCount,
// defaultPerPage,
defaultSort, filterFields: filterFields = [], enableAdvancedFilter: enableAdvancedFilter = false, sortingFns: sortingFns, selectable: selectable, groups: groups }) {
    const navigate = (0, $6UBLf.useNavigate)();
    const search = (0, $5zaoU.useSearch)({
        strict: false
    });
    const defaultColumnVisibility = columns.reduce((acc, column)=>{
        acc[column.accessorKey] = visibleColumns.includes(column.accessorKey);
        return acc;
    }, {});
    // Search params
    // const parsedSearch = schema.parse(search)
    // const page = parsedSearch.page
    // const perPage = parsedSearch.per_page ?? defaultPerPage
    // const [column, order] = sort?.split('.') ?? []
    // Memoize computation of searchableColumns and filterableColumns
    const { searchableColumns: searchableColumns, filterableColumns: filterableColumns } = $jbmdS.useMemo(()=>{
        return {
            searchableColumns: filterFields.filter((field)=>!field.options && field.isDefaultFilter === true),
            filterableColumns: filterFields.filter((field)=>field.options && field.isDefaultFilter === true)
        };
    }, [
        filterFields
    ]);
    // Create query string
    const createQueryString = $jbmdS.useCallback((params)=>{
        const newSearch = {
            ...search
        };
        for (const [key, value] of Object.entries(params))if (value === null) delete newSearch[key];
        else newSearch[key] = String(value);
        return newSearch;
    }, [
        search
    ]);
    // Initial column filters
    const initialColumnFilters = $jbmdS.useMemo(()=>{
        return Object.entries(search).reduce((filters, [key, value])=>{
            const filterableColumn = filterableColumns.find((column)=>column.value === key);
            const searchableColumn = searchableColumns.find((column)=>column.value === key);
            if (filterableColumn) filters.push({
                id: key,
                value: value.split(".")
            });
            else if (searchableColumn) filters.push({
                id: key,
                value: [
                    value
                ]
            });
            return filters;
        }, []);
    }, [
        filterableColumns,
        searchableColumns,
        search
    ]);
    // Table states
    const [rowSelection, setRowSelection] = $jbmdS.useState({});
    const [columnVisibility, setColumnVisibility] = $jbmdS.useState(defaultColumnVisibility);
    const [columnFilters, setColumnFilters] = $jbmdS.useState(initialColumnFilters);
    // Handle server-side pagination
    // const [{ pageIndex, pageSize }, setPagination] =
    //     React.useState<PaginationState>({
    //         pageIndex: page - 1,
    //         pageSize: perPage,
    //     })
    // const pagination = React.useMemo(
    //     () => ({
    //         pageIndex,
    //         pageSize,
    //     }),
    //     [pageIndex, pageSize]
    // )
    // Handle server-side sorting
    const [sorting, setSorting] = $jbmdS.useState(defaultSort);
    // React.useEffect(() => {
    //     navigate({
    //         search: createQueryString({
    //             page: pageIndex + 1,
    //             per_page: pageSize,
    //             sort: sorting[0]?.id
    //                 ? `${sorting[0]?.id}.${sorting[0]?.desc ? 'desc' : 'asc'}`
    //                 : null,
    //         }),
    //         replace: true,
    //     })
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [pageIndex, pageSize, sorting])
    // Handle server-side filtering
    const debouncedSearchableColumnFilters = JSON.parse((0, $hPAFY.useDebounce)(JSON.stringify(columnFilters.filter((filter)=>{
        return searchableColumns.find((column)=>column.value === filter.id);
    })), 500));
    const filterableColumnFilters = columnFilters.filter((filter)=>{
        return filterableColumns.find((column)=>column.value === filter.id);
    });
    const [mounted, setMounted] = $jbmdS.useState(false);
    $jbmdS.useEffect(()=>{
        // Opt out when advanced filter is enabled, because it contains additional params
        if (enableAdvancedFilter) return;
        // Prevent resetting the page on initial render
        if (!mounted) {
            setMounted(true);
            return;
        }
        // Initialize new params
        const newParamsObject = {};
        // Handle debounced searchable column filters
        for (const column of debouncedSearchableColumnFilters)if (typeof column.value === "string") Object.assign(newParamsObject, {
            [column.id]: typeof column.value === "string" ? column.value : null
        });
        // Handle filterable column filters
        for (const column of filterableColumnFilters)if (typeof column.value === "object" && Array.isArray(column.value)) Object.assign(newParamsObject, {
            [column.id]: column.value.join(".")
        });
        // Remove deleted values
        for(const key in search)if (searchableColumns.find((column)=>column.value === key) && !debouncedSearchableColumnFilters.find((column)=>column.id === key) || filterableColumns.find((column)=>column.value === key) && !filterableColumnFilters.find((column)=>column.id === key)) Object.assign(newParamsObject, {
            [key]: null
        });
        // After cumulating all the changes, push new params
        navigate({
            search: createQueryString(newParamsObject),
            replace: true
        });
    // table.setPageIndex(0)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(debouncedSearchableColumnFilters),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(filterableColumnFilters)
    ]);
    const customAggregationFns = {
        progressBar: (columnId, leafRows, childRows)=>{
            let numerator = 0;
            let denominator = 0;
            childRows.forEach((row)=>{
                var _value$numerator, _value$denominator;
                const value = row.getValue(columnId);
                numerator += (_value$numerator = value === null || value === void 0 ? void 0 : value.numerator) !== null && _value$numerator !== void 0 ? _value$numerator : 0;
                denominator += (_value$denominator = value === null || value === void 0 ? void 0 : value.denominator) !== null && _value$denominator !== void 0 ? _value$denominator : 0;
            });
            return {
                numerator: numerator,
                denominator: denominator
            };
        },
        titleDefault: (columnId, leafRows, childRows)=>{
            return "Total";
        },
        nullData: null
    };
    let tableColumns = [
        ...columns
    ];
    if (groups !== null && groups !== void 0 && groups.enabled) {
        // Add label column if grouping is enabled
        const labelColumn = groups.labelColumn || (0, $1PdjB.createLabelColumn)({
            groupByColumns: groups.columns,
            columns: columns
        });
        // Add expansion column for grouped data
        const expansionColumn = (0, $1g7Kl.createExpansionColumn)({
            groupByColumns: [
                ...groups.columns,
                groups.leafRowLabel
            ],
            columns: columns
        });
        tableColumns = [
            expansionColumn,
            labelColumn,
            ...tableColumns
        ];
    }
    if (selectable !== null && selectable !== void 0 && selectable.enabled) {
        const selectColumn = (0, $g1Ho2.createSelectableColumn)({
            enableMultipleSelection: selectable.enableMultipleSelection,
            enableRowSelection: selectable.enableRowSelection
        });
        tableColumns = [
            selectColumn,
            ...tableColumns
        ];
    }
    const table = (0, $bYkcY.useReactTable)({
        data: data,
        columns: tableColumns,
        // pageCount: pageCount ?? -1,
        state: {
            sorting: // pagination,
            sorting,
            columnVisibility: defaultColumnVisibility,
            rowSelection: rowSelection,
            columnFilters: columnFilters
        },
        enableRowSelection: (selectable === null || selectable === void 0 ? void 0 : selectable.enabled) && (selectable === null || selectable === void 0 ? void 0 : selectable.enableRowSelection),
        getSubRows: (row)=>row.children,
        onRowSelectionChange: setRowSelection,
        // onPaginationChange: setPagination,
        onSortingChange: setSorting,
        onColumnFiltersChange: setColumnFilters,
        onColumnVisibilityChange: setColumnVisibility,
        getCoreRowModel: (0, $lVpRF.getCoreRowModel)(),
        getFilteredRowModel: (0, $lVpRF.getFilteredRowModel)(),
        getPaginationRowModel: (0, $lVpRF.getPaginationRowModel)(),
        getSortedRowModel: (0, $lVpRF.getSortedRowModel)(),
        getFacetedRowModel: (0, $lVpRF.getFacetedRowModel)(),
        getFacetedUniqueValues: (0, $lVpRF.getFacetedUniqueValues)(),
        getExpandedRowModel: (0, $lVpRF.getExpandedRowModel)(),
        sortingFns: sortingFns,
        manualPagination: true,
        aggregationFns: {
            ...(0, $lVpRF.aggregationFns),
            // Built-in aggregation functions
            ...customAggregationFns // Your custom aggregation functions
        },
        // manualSorting: true,
        // manualFiltering: true,
        enableGlobalFilter: true
    });
    return {
        table: table
    };
}

});
parcelRegister("hPAFY", function(module, exports) {

$parcel$export(module.exports, "useDebounce", function () { return $a4d45684a03c83ef$export$21805fee57372823; });

var $jbmdS = parcelRequire("jbmdS");
function $a4d45684a03c83ef$export$21805fee57372823(value, delay) {
    const [debouncedValue, setDebouncedValue] = $jbmdS.useState(value);
    $jbmdS.useEffect(()=>{
        const timer = setTimeout(()=>setDebouncedValue(value), delay !== null && delay !== void 0 ? delay : 500);
        return ()=>{
            clearTimeout(timer);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}

});

parcelRegister("g1Ho2", function(module, exports) {

$parcel$export(module.exports, "createSelectableColumn", function () { return $72d01e929128824c$export$a3430af47f24f074; });
// columns/select-column.tsx

var $61Ea1 = parcelRequire("61Ea1");

var $8jD92 = parcelRequire("8jD92");

var $4Bqwe = parcelRequire("4Bqwe");
const $72d01e929128824c$export$a3430af47f24f074 = (options = {})=>{
    const { getSubRowSelectionState: getSubRowSelectionState, handleRowSelection: handleRowSelection } = (0, $4Bqwe.useTableSelection)(options);
    return {
        id: "select",
        accessorKey: "select",
        header: ({ table: table })=>{
            if (!options.enableMultipleSelection) return null;
            return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8jD92.Checkbox), {
                    checked: table.getIsAllRowsSelected() ? true : table.getIsSomeRowsSelected() ? "indeterminate" : false,
                    onCheckedChange: (checked)=>{
                        table.toggleAllRowsSelected(!!checked);
                    },
                    "aria-label": "Select all"
                })
            });
        },
        cell: ({ row: row, table: table })=>{
            var _options$enableRowSel;
            if (!((_options$enableRowSel = options.enableRowSelection) !== null && _options$enableRowSel !== void 0 && _options$enableRowSel.call(options, row))) return null;
            const subRowState = row.getLeafRows().length ? getSubRowSelectionState(row, table.getState().rowSelection) : "none";
            return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8jD92.Checkbox), {
                    checked: row.getIsSelected() ? true : subRowState === "some" ? "indeterminate" : false,
                    onCheckedChange: (checked)=>{
                        handleRowSelection(row, table, !!checked);
                    },
                    "aria-label": "Select row"
                })
            });
        },
        enableSorting: false,
        enableHiding: false,
        size: 40,
        minSize: 34
    };
};

});
parcelRegister("4Bqwe", function(module, exports) {

$parcel$export(module.exports, "useTableSelection", function () { return $f736e3a752cdac7e$export$9989d8b5155ba3be; });
// hooks/use-table-selection.ts
const $f736e3a752cdac7e$export$9989d8b5155ba3be = (options = {})=>{
    const { enableRowSelection: enableRowSelection = ()=>true, enableMultipleSelection: enableMultipleSelection = true } = options;
    const getSubRowSelectionState = (row, selection)=>{
        const subRows = row.getLeafRows();
        if (!subRows.length) return "none";
        const selectedCount = subRows.filter((subRow)=>selection[subRow.id]).length;
        if (selectedCount === 0) return "none";
        if (selectedCount === subRows.length) return "all";
        return "some";
    };
    const handleRowSelection = (row, table, checked)=>{
        table.setRowSelection((old)=>{
            const newSelection = {
                ...old
            };
            // Handle single selection mode
            if (!enableMultipleSelection) Object.keys(newSelection).forEach((key)=>{
                delete newSelection[key];
            });
            // Set the current row
            if (enableRowSelection(row)) newSelection[row.id] = checked;
            // Handle child rows
            row.getLeafRows().forEach((subRow)=>{
                if (enableRowSelection(subRow)) newSelection[subRow.id] = checked;
            });
            // Handle parent rows
            let currentRow = row.getParentRow();
            while(currentRow){
                const subState = getSubRowSelectionState(currentRow, newSelection);
                newSelection[currentRow.id] = subState === "all";
                currentRow = currentRow.getParentRow();
            }
            return newSelection;
        });
    };
    return {
        getSubRowSelectionState: getSubRowSelectionState,
        handleRowSelection: handleRowSelection
    };
};

});


parcelRegister("1g7Kl", function(module, exports) {

$parcel$export(module.exports, "createExpansionColumn", function () { return $2e3ae55584dc37d9$export$544851269227bdd5; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $1kvoC = parcelRequire("1kvoC");
var $ahXOC = parcelRequire("ahXOC");

var $95Evz = parcelRequire("95Evz");

var $l4nwI = parcelRequire("l4nwI");

var $fRrIT = parcelRequire("fRrIT");
const $2e3ae55584dc37d9$export$544851269227bdd5 = ({ groupByColumns: groupByColumns, columns: columns })=>{
    const [open, setOpen] = $jbmdS.useState(false);
    const [rowExpand, setRowExpand] = $jbmdS.useState("");
    const toggleRowsAtDepth = (table, targetDepth, isExpand)=>{
        const allRows = table.getFilteredRowModel().rows.flatMap((row)=>[
                row,
                ...row.getLeafRows()
            ]);
        allRows.forEach((row)=>{
            if (row.depth < targetDepth) row.toggleExpanded(isExpand);
            if (isExpand && row.depth >= targetDepth) row.toggleExpanded(!isExpand);
        });
    };
    return {
        id: "expand",
        accessorKey: "expand",
        header: ({ table: table })=>{
            // If no grouping columns or exactly one grouping column, show simple toggle
            if (!(groupByColumns !== null && groupByColumns !== void 0 && groupByColumns.length) || groupByColumns.length <= 2) return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "cursor-pointer",
                onClick: ()=>table.toggleAllRowsExpanded(),
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ahXOC.default), {
                    size: 18,
                    className: `transition-transform duration-300 ${table.getIsAllRowsExpanded() ? "rotate-90" : ""}`
                })
            });
            // For multiple grouping columns, show the dropdown menu
            return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $l4nwI.Popover), {
                open: open,
                onOpenChange: setOpen,
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $l4nwI.PopoverTrigger), {
                        asChild: true,
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ahXOC.default), {
                            size: 18,
                            className: `transition-transform duration-300 ${open ? "rotate-90" : ""} cursor-pointer`
                        })
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $l4nwI.PopoverContent), {
                        className: "w-[20rem] p-0",
                        align: "start",
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fRrIT.Command), {
                            children: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fRrIT.CommandList), {
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fRrIT.CommandGroup), {
                                        children: groupByColumns.map((columnId, index)=>{
                                            var _column$meta;
                                            const column = columns === null || columns === void 0 ? void 0 : columns.find((col)=>col.accessorKey === columnId);
                                            return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fRrIT.CommandItem), {
                                                className: "capitalize",
                                                value: columnId,
                                                onSelect: (currentValue)=>{
                                                    setRowExpand(currentValue === rowExpand ? "" : currentValue);
                                                    toggleRowsAtDepth(table, index, !(currentValue === rowExpand));
                                                    setOpen(false);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $1kvoC.default), {
                                                        className: (0, $95Evz.cn)("mr-2 h-4 w-4", rowExpand === columnId ? "opacity-100" : "opacity-0")
                                                    }),
                                                    (column === null || column === void 0 ? void 0 : (_column$meta = column.meta) === null || _column$meta === void 0 ? void 0 : _column$meta.title) || columnId
                                                ]
                                            }, columnId);
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fRrIT.CommandSeparator), {})
                                ]
                            })
                        })
                    })
                ]
            });
        },
        cell: ({ row: row })=>{
            return row.getCanExpand() ? /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "cursor-pointer",
                onClick: ()=>row.toggleExpanded(),
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ahXOC.default), {
                    size: 18,
                    className: `transition-transform duration-300 ${row.getIsExpanded() ? "rotate-90" : ""}`
                })
            }) : null;
        },
        size: 40,
        minSize: 34
    };
};

});

parcelRegister("1PdjB", function(module, exports) {

$parcel$export(module.exports, "createLabelColumn", function () { return $b380fe1e817d606b$export$479ca6840ca9d009; });

var $61Ea1 = parcelRequire("61Ea1");

var $fow7v = parcelRequire("fow7v");
const $b380fe1e817d606b$export$479ca6840ca9d009 = ({ groupByColumns: groupByColumns, columns: columns, setIsAlertChangeColumns: setIsAlertChangeColumns })=>{
    return {
        id: "label",
        accessorKey: "label",
        header: ({ column: column })=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $fow7v.DataTableColumnHeader), {
                column: column,
                setIsAlertChangeColumns: setIsAlertChangeColumns,
                title: "Label"
            }),
        enableHiding: false,
        sortingFn: "text"
    };
};

});
parcelRegister("fow7v", function(module, exports) {

$parcel$export(module.exports, "DataTableColumnHeader", function () { return $dce6beee0bb24365$export$323bca95afad2e81; });

var $61Ea1 = parcelRequire("61Ea1");

var $jSiTu = parcelRequire("jSiTu");

var $Yha9m = parcelRequire("Yha9m");

var $fTGwv = parcelRequire("fTGwv");

var $8tafh = parcelRequire("8tafh");
function $dce6beee0bb24365$export$323bca95afad2e81({ column: column, title: title, className: className, onHideColumn: onHideColumn }) {
    if (!column.getCanSort() && !column.getCanHide()) return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: (0, $Yha9m.cn)(className),
        children: title
    });
    const handleHideColumn = ()=>{
        column.toggleVisibility(false);
        onHideColumn(column.id);
    };
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: (0, $Yha9m.cn)("inline-flex items-center space-x-2", className),
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $8tafh.DropdownMenu), {
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8tafh.DropdownMenuTrigger), {
                    asChild: true,
                    children: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fTGwv.Button), {
                        "aria-label": column.getIsSorted() === "desc" ? "Sorted descending. Click to sort ascending." : column.getIsSorted() === "asc" ? "Sorted ascending. Click to sort descending." : "Not sorted. Click to sort ascending.",
                        variant: "ghost",
                        size: "sm",
                        className: "-ml-3 h-auto print:text-[0.65rem] flex max-w-full p-2 hover:bg-transparent focus:bg-transparent data-[state=open]:bg-accent",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                className: "flex-auto text-wrap text-left",
                                children: title
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                className: "flex-none",
                                children: column.getCanSort() && column.getIsSorted() === "desc" ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jSiTu.ArrowDownIcon), {
                                    className: "ml-2 size-4 print:hidden",
                                    "aria-hidden": "true"
                                }) : column.getIsSorted() === "asc" ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jSiTu.ArrowUpIcon), {
                                    className: "ml-2 size-4 print:hidden",
                                    "aria-hidden": "true"
                                }) : /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jSiTu.CaretSortIcon), {
                                    className: "ml-2 size-4 print:hidden",
                                    "aria-hidden": "true"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $8tafh.DropdownMenuContent), {
                    align: "start",
                    children: [
                        column.getCanSort() && /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $8tafh.DropdownMenuItem), {
                                    "aria-label": "Sort ascending",
                                    onClick: ()=>column.toggleSorting(false),
                                    children: [
                                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jSiTu.ArrowUpIcon), {
                                            className: "mr-2 size-3.5 text-muted-foreground/70",
                                            "aria-hidden": "true"
                                        }),
                                        "Asc"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $8tafh.DropdownMenuItem), {
                                    "aria-label": "Sort descending",
                                    onClick: ()=>column.toggleSorting(true),
                                    children: [
                                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jSiTu.ArrowDownIcon), {
                                            className: "mr-2 size-3.5 text-muted-foreground/70",
                                            "aria-hidden": "true"
                                        }),
                                        "Desc"
                                    ]
                                })
                            ]
                        }),
                        column.getCanSort() && column.getCanHide() && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8tafh.DropdownMenuSeparator), {}),
                        column.getCanHide() && /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $8tafh.DropdownMenuItem), {
                            "aria-label": "Hide column",
                            onClick: handleHideColumn,
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jSiTu.EyeNoneIcon), {
                                    className: "mr-2 size-3.5 text-muted-foreground/70",
                                    "aria-hidden": "true"
                                }),
                                "Hide"
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

});



parcelRegister("khCHn", function(module, exports) {

$parcel$export(module.exports, "generateColumnDef", function () { return $a311ea4ac34f485e$export$faa451c612de4f50; });
$parcel$export(module.exports, "createGenerateColumnDef", function () { return $a311ea4ac34f485e$export$72126e5973c3f252; });

var $61Ea1 = parcelRequire("61Ea1");

var $fow7v = parcelRequire("fow7v");

var $6Tdl2 = parcelRequire("6Tdl2");

var $5VJGc = parcelRequire("5VJGc");

var $22002 = parcelRequire("22002");
function $a311ea4ac34f485e$export$faa451c612de4f50({ key: key = "", type: type = "default", title: title = "", permissions: permissions = (row)=>true, size: size = 160, aggregationFn: aggregationFn = null, formatter: formatter = (v)=>v, cell: cell = null, filterOptions: filterOptions = null, editable: editable = false, onChange: onChange = (v)=>{}, onClick: onClick = (v)=>{}, onFocus: onFocus = (v)=>{}, onHideColumn: onHideColumn = (column)=>{}, cellClassName: cellClassName = (row)=>null, cellStyle: cellStyle = (row)=>null, customValue: customValue = null, filterType: filterType }) {
    return {
        accessorKey: key,
        ...customValue && {
            accessorFn: customValue
        },
        header: (header)=>{
            return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fow7v.DataTableColumnHeader), {
                column: header.column,
                title: title,
                onHideColumn: onHideColumn
            });
        },
        cell: ({ getValue: getValue, row: row, column: column })=>{
            const value = getValue();
            return (0, $6Tdl2.renderCell)({
                value: value,
                row: row,
                column: column,
                editable: typeof editable === "function" ? editable(row) : editable,
                onClick: onClick,
                onFocus: onFocus,
                onChange: onChange,
                cell: cell
            });
        },
        size: size,
        minSize: size * 0.8,
        maxSize: size * 1.2,
        meta: {
            title: title,
            type: type,
            permissions: permissions,
            filterOptions: filterOptions || (0, $22002.generateFilterOptions)(filterType || type),
            formatter: formatter,
            cellClassName: cellClassName,
            cellStyle: cellStyle
        },
        sortingFn: (0, $5VJGc.sortingFns)[type],
        aggregationFn: aggregationFn || "none"
    };
}
function $a311ea4ac34f485e$export$72126e5973c3f252(defaultProps) {
    return (props)=>$a311ea4ac34f485e$export$faa451c612de4f50({
            ...defaultProps,
            ...props
        });
}

});
parcelRegister("6Tdl2", function(module, exports) {

$parcel$export(module.exports, "renderCell", function () { return $4f2dc4917880bd27$export$a19f2b5bc152a233; });

var $61Ea1 = parcelRequire("61Ea1");

var $azaaH = parcelRequire("azaaH");

var $49KZT = parcelRequire("49KZT");

var $210wi = parcelRequire("210wi");

var $2YJBX = parcelRequire("2YJBX");

var $80DmM = parcelRequire("80DmM");

var $fTGwv = parcelRequire("fTGwv");

var $8jD92 = parcelRequire("8jD92");

var $k90lK = parcelRequire("k90lK");

var $5QoiI = parcelRequire("5QoiI");

var $imf6A = parcelRequire("imf6A");
function $4f2dc4917880bd27$export$a19f2b5bc152a233({ value: value, row: row, column: column, cell: cell, editable: editable = false, onClick: onClick, onChange: onChange, onFocus: onFocus, className: className, style: style }) {
    var _column$columnDef, _column$columnDef2, _column$columnDef2$me, _value, _value2, _value$name, _value3;
    const { type: type, permissions: permissions } = (_column$columnDef = column.columnDef) === null || _column$columnDef === void 0 ? void 0 : _column$columnDef.meta;
    if (permissions !== undefined && !permissions(row)) value = null;
    if (cell && type !== "button") return cell(row);
    switch(type){
        case "currency":
            return editable ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $imf6A.TableInput), {
                type: type,
                value: Math.round(value),
                onChange: (e)=>onChange === null || onChange === void 0 ? void 0 : onChange(row, e.target.value),
                onClick: ()=>onClick === null || onClick === void 0 ? void 0 : onClick(row),
                onFocus: ()=>onFocus === null || onFocus === void 0 ? void 0 : onFocus(row),
                className: className,
                style: style
            }) : /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                onClick: ()=>onClick === null || onClick === void 0 ? void 0 : onClick(row),
                onFocus: ()=>onFocus === null || onFocus === void 0 ? void 0 : onFocus(row),
                className: className,
                style: style,
                tabIndex: 0,
                children: (0, $azaaH.default).currency(value)
            });
        case "percent":
            if (editable) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $imf6A.TableInput), {
                type: type,
                value: Math.round(value),
                onChange: (e)=>onChange(row, e.target.value),
                onClick: ()=>onClick(row)
            });
            return (0, $49KZT.default).percent({
                value: value,
                formattedValue: (0, $azaaH.default).percent(value)
            });
        case "date":
            if (editable) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $80DmM.DatePicker), {
                value: new Date(value),
                onChange: (val)=>onChange(row, val)
            });
            return (0, $azaaH.default).date(value ? new Date(value) : null);
        case "number":
            if (editable) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $imf6A.TableInput), {
                type: type,
                value: Math.round(value),
                onChange: (e)=>onChange(row, e.target.value),
                onClick: ()=>onClick(row)
            });
            return (0, $49KZT.default).number({
                value: value,
                formattedValue: (0, $azaaH.default).number(value)
            });
        case "status":
            return (0, $azaaH.default).status(value);
        case "boolean":
            if (editable) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8jD92.Checkbox), {
                checked: value,
                onCheckedChange: (checked)=>onChange(row, !!checked)
            });
            return (0, $azaaH.default).boolean(value);
        case "progressBar":
            const formatter = ((_column$columnDef2 = column.columnDef) === null || _column$columnDef2 === void 0 ? void 0 : (_column$columnDef2$me = _column$columnDef2.meta) === null || _column$columnDef2$me === void 0 ? void 0 : _column$columnDef2$me.formatter) || (0, $azaaH.default).number;
            return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $210wi.default), {
                width: "100%",
                height: "1.5em",
                numerator: (_value = value) === null || _value === void 0 ? void 0 : _value.numerator,
                denominator: (_value2 = value) === null || _value2 === void 0 ? void 0 : _value2.denominator,
                formatNumber: formatter,
                radius: "4"
            });
        case "duration":
            return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $k90lK.DurationUnit), {
                value: value,
                onChange: (v)=>onChange(row, v)
            });
        case "button":
            return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fTGwv.Button), {
                onClick: ()=>onClick(row),
                disabled: !editable,
                variant: "outline",
                children: cell(row)
            });
        case "supplier":
            if (editable) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5QoiI.SupplierSelector), {
                value: value,
                onChange: (v)=>onChange(row, v)
            });
            return (_value$name = (_value3 = value) === null || _value3 === void 0 ? void 0 : _value3.name) !== null && _value$name !== void 0 ? _value$name : "No Supplier";
        case "box":
            return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
                children: cell(row)
            });
        default:
            if (editable) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $2YJBX.Input), {
                type: type,
                value: value,
                onChange: (e)=>onChange(row, e.target.value),
                onClick: ()=>onClick(row)
            });
            return value;
    }
}

});
parcelRegister("k90lK", function(module, exports) {

$parcel$export(module.exports, "DurationUnit", function () { return $26d91912322b6f99$export$5c92cf4c87d0aa6a; });

var $61Ea1 = parcelRequire("61Ea1");

var $2YJBX = parcelRequire("2YJBX");

var $Yha9m = parcelRequire("Yha9m");

var $eat5C = parcelRequire("eat5C");

var $cwjKY = parcelRequire("cwjKY");

var $3Gs4l = parcelRequire("3Gs4l");
const $26d91912322b6f99$export$5c92cf4c87d0aa6a = (props)=>{
    const { value: value, onChange: onChange, className: className } = props;
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: (0, $Yha9m.cn)("flex", className),
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "w-[40%]",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $2YJBX.Input), {
                    value: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).toNumber(value === null || value === void 0 ? void 0 : value.duration),
                    onChange: (e)=>{
                        const v = (0, $cwjKY.FormatNumber)((0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).toNumber(e.target.value), {
                            decimals: 2
                        });
                        onChange({
                            ...value,
                            duration: v
                        });
                    }
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "w-[60%]",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3Gs4l.SelectWithLabel), {
                    value: value === null || value === void 0 ? void 0 : value.durationUnit,
                    options: [
                        {
                            key: "days",
                            value: "days",
                            label: "Days"
                        },
                        {
                            key: "weeks",
                            value: "weeks",
                            label: "Weeks"
                        },
                        {
                            key: "months",
                            value: "months",
                            label: "Months"
                        }
                    ],
                    onValueChange: (v)=>onChange({
                            ...value,
                            durationUnit: v
                        })
                })
            })
        ]
    });
};

});

parcelRegister("5QoiI", function(module, exports) {

$parcel$export(module.exports, "Selector", function () { return $e4a8f065e6cf4b44$export$d15f4cd5286f9b1e; });
$parcel$export(module.exports, "ProjectSelector", function () { return $e4a8f065e6cf4b44$export$a764642e4b725728; });
$parcel$export(module.exports, "SupplierSelector", function () { return $e4a8f065e6cf4b44$export$1a0b0fec383cc555; });
$parcel$export(module.exports, "PhaseSelector", function () { return $e4a8f065e6cf4b44$export$c6fe3fcc5c7d197b; });
$parcel$export(module.exports, "TaskSelector", function () { return $e4a8f065e6cf4b44$export$b1a90c704904b8d3; });
$parcel$export(module.exports, "CostCentreSelector", function () { return $e4a8f065e6cf4b44$export$2d2573c5466d1f18; });
$parcel$export(module.exports, "PermissionsSelector", function () { return $e4a8f065e6cf4b44$export$88f0a7c4e0b5e98e; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $1kvoC = parcelRequire("1kvoC");
var $kSlHv = parcelRequire("kSlHv");
var $5FqxN = parcelRequire("5FqxN");

var $fRrIT = parcelRequire("fRrIT");

var $l4nwI = parcelRequire("l4nwI");

var $fTGwv = parcelRequire("fTGwv");

var $Yha9m = parcelRequire("Yha9m");

var $e8Hda = parcelRequire("e8Hda");

var $38AIP = parcelRequire("38AIP");

var $49KvR = parcelRequire("49KvR");

var $hJgkt = parcelRequire("hJgkt");

var $3h7sC = parcelRequire("3h7sC");
const $e4a8f065e6cf4b44$var$defaultGetLabel = (option)=>{
    var _option$toString;
    return (_option$toString = option === null || option === void 0 ? void 0 : option.toString()) !== null && _option$toString !== void 0 ? _option$toString : "";
};
const $e4a8f065e6cf4b44$var$defaultGetValue = (option)=>{
    var _option$toString2;
    return (_option$toString2 = option === null || option === void 0 ? void 0 : option.toString()) !== null && _option$toString2 !== void 0 ? _option$toString2 : "";
};
// Default sort function that uses getLabel for case-insensitive alphabetical sorting
const $e4a8f065e6cf4b44$var$defaultSort = (getLabel)=>(a, b)=>{
        return getLabel(a).toLowerCase().localeCompare(getLabel(b).toLowerCase());
    };
function $e4a8f065e6cf4b44$export$d15f4cd5286f9b1e({ value: value, options: options, onChange: onChange, getLabel: getLabel = $e4a8f065e6cf4b44$var$defaultGetLabel, getValue: getValue = $e4a8f065e6cf4b44$var$defaultGetValue, disableOption: disableOption, groupBy: groupBy, sort: sort = $e4a8f065e6cf4b44$var$defaultSort(getLabel), placeholder: placeholder = "Select...", disabled: disabled = false, className: className, clearable: clearable = true, search: search = false, itemProps: itemProps, ...props }) {
    options || (options = []);
    const [open, setOpen] = (0, $jbmdS.useState)(false);
    // Sort options if sort function is provided
    const sortedOptions = (0, $jbmdS.useMemo)(()=>{
        return [
            ...options
        ].sort(sort);
    }, [
        options,
        sort
    ]);
    // Group options if groupBy function is provided
    const groupedOptions = (0, $jbmdS.useMemo)(()=>{
        if (!groupBy) return null;
        return Object.entries(sortedOptions.reduce((acc, option)=>{
            const groupKey = groupBy(option);
            if (!acc[groupKey]) acc[groupKey] = [];
            acc[groupKey].push(option);
            return acc;
        }, {}));
    }, [
        sortedOptions,
        groupBy
    ]);
    const handleClear = (e)=>{
        e.stopPropagation();
        onChange === null || onChange === void 0 || onChange(null);
    };
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $l4nwI.Popover), {
        open: open,
        onOpenChange: disabled ? undefined : setOpen,
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $l4nwI.PopoverTrigger), {
                asChild: true,
                children: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fTGwv.Button), {
                    variant: "outline",
                    role: "combobox",
                    "aria-expanded": open,
                    className: (0, $Yha9m.cn)("w-full justify-between relative pr-8", className),
                    disabled: disabled,
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                            className: "truncate",
                            children: value ? getLabel(value) : placeholder
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            className: "flex absolute right-2 top-1/2 -translate-y-1/2",
                            children: [
                                clearable && value && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fTGwv.Button), {
                                    variant: "ghost",
                                    onClick: handleClear,
                                    className: "h-auto p-0 hover:bg-transparent",
                                    type: "button",
                                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5FqxN.default), {
                                        className: "h-4 w-4 text-muted-foreground hover:text-foreground"
                                    })
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kSlHv.default), {
                                    className: "h-4 w-4 shrink-0 opacity-50 ml-1"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $l4nwI.PopoverContent), {
                className: "w-[500px] p-0",
                onWheel: (e)=>e.stopPropagation(),
                children: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fRrIT.Command), {
                    children: [
                        search && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fRrIT.CommandInput), {
                            placeholder: `Search ${placeholder.toLowerCase()}...`
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fRrIT.CommandList), {
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fRrIT.CommandEmpty), {
                                    children: "No results found."
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                    className: "max-h-[300px] overflow-y-auto",
                                    children: groupedOptions ? groupedOptions.map(([group, items], groupIndex)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $fRrIT.CommandGroup), {
                                            heading: group,
                                            children: items.map((option)=>/*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fRrIT.CommandItem), {
                                                    value: getLabel(option),
                                                    onSelect: ()=>{
                                                        onChange === null || onChange === void 0 || onChange(option);
                                                        setOpen(false);
                                                    },
                                                    disabled: disableOption === null || disableOption === void 0 ? void 0 : disableOption(option),
                                                    onMouseEnter: ()=>{
                                                        var _itemProps$onMouseEnt;
                                                        return itemProps === null || itemProps === void 0 ? void 0 : (_itemProps$onMouseEnt = itemProps.onMouseEnter) === null || _itemProps$onMouseEnt === void 0 ? void 0 : _itemProps$onMouseEnt.call(itemProps, option);
                                                    },
                                                    onFocus: ()=>{
                                                        var _itemProps$onFocus;
                                                        return itemProps === null || itemProps === void 0 ? void 0 : (_itemProps$onFocus = itemProps.onFocus) === null || _itemProps$onFocus === void 0 ? void 0 : _itemProps$onFocus.call(itemProps, option);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $1kvoC.default), {
                                                            className: (0, $Yha9m.cn)("mr-2 h-4 w-4", value && getValue(option) === getValue(value) ? "opacity-100" : "opacity-0")
                                                        }),
                                                        getLabel(option)
                                                    ]
                                                }, getValue(option)))
                                        }, group + groupIndex)) : /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fRrIT.CommandGroup), {
                                        children: sortedOptions.map((option)=>/*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fRrIT.CommandItem), {
                                                value: getLabel(option),
                                                onSelect: ()=>{
                                                    onChange === null || onChange === void 0 || onChange(option);
                                                    setOpen(false);
                                                },
                                                disabled: disableOption === null || disableOption === void 0 ? void 0 : disableOption(option),
                                                children: [
                                                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $1kvoC.default), {
                                                        className: (0, $Yha9m.cn)("mr-2 h-4 w-4", value && getValue(option) === getValue(value) ? "opacity-100" : "opacity-0")
                                                    }),
                                                    getLabel(option)
                                                ]
                                            }, getValue(option)))
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
const $e4a8f065e6cf4b44$export$a764642e4b725728 = ({ value: value, options: providedOptions, onChange: onChange, placeholder: placeholder = "Select Project...", clearable: clearable = true, ...props })=>{
    var _options$;
    const projects = (0, $38AIP.useCacheSlice)("projects");
    const options = providedOptions || projects || [];
    return /*#__PURE__*/ (0, $61Ea1.jsx)($e4a8f065e6cf4b44$export$d15f4cd5286f9b1e, {
        value: value,
        onChange: onChange,
        options: options,
        getLabel: (project)=>project ? (0, $49KvR.getLabel).projects(project) : placeholder,
        getValue: (project)=>project === null || project === void 0 ? void 0 : project.id,
        sort: (a, b)=>{
            // First, sort by status
            const statusOrder = [
                "active",
                "prospective",
                "onHold",
                "archived"
            ];
            const statusCompare = statusOrder.indexOf(a.status || "active") - statusOrder.indexOf(b.status || "active");
            // If status is the same, sort by name case-insensitive
            if (statusCompare === 0) return (a.name || "").toLowerCase().localeCompare((b.name || "").toLowerCase());
            return statusCompare;
        },
        placeholder: placeholder,
        clearable: clearable,
        search: true,
        groupBy: (_options$ = options[0]) !== null && _options$ !== void 0 && _options$.status ? (project)=>(0, $e8Hda.camelCaseToSentence)(((project === null || project === void 0 ? void 0 : project.status) || "active") + "Projects") : undefined,
        ...props
    });
};
const $e4a8f065e6cf4b44$export$1a0b0fec383cc555 = ({ value: value, options: providedOptions, onChange: onChange, placeholder: placeholder = "Select Supplier...", clearable: clearable = true, supplierId: supplierId, ...props })=>{
    const suppliers = (0, $38AIP.useCacheSlice)("suppliers");
    const options = providedOptions || suppliers || [];
    return /*#__PURE__*/ (0, $61Ea1.jsx)($e4a8f065e6cf4b44$export$d15f4cd5286f9b1e, {
        value: value,
        onChange: onChange,
        options: options,
        getLabel: (supplier)=>supplier ? (0, $49KvR.getLabel).suppliers(supplier) : placeholder,
        getValue: (supplier)=>supplier === null || supplier === void 0 ? void 0 : supplier.id,
        sort: (a, b)=>{
            return (a.name || "").toLowerCase().localeCompare((b.name || "").toLowerCase());
        },
        placeholder: placeholder,
        clearable: clearable,
        search: true,
        ...props
    });
};
const $e4a8f065e6cf4b44$export$c6fe3fcc5c7d197b = ({ projectId: projectId, value: value, options: providedOptions, onChange: onChange, placeholder: placeholder = "Select Phase...", clearable: clearable = true, ...props })=>{
    var _options$2;
    const { data: phaseData, isLoading: isLoading } = (0, $hJgkt.useQuery)({
        queryKey: [
            "project-phases",
            projectId
        ],
        queryFn: ()=>(0, $3h7sC.trpc).global.getPhaseTasks.query({
                projectId: projectId
            }),
        enabled: !providedOptions && !!projectId,
        // Only run query when projectId is provided
        staleTime: 300000 // Cache for 5 minutes
    });
    const options = providedOptions || (phaseData === null || phaseData === void 0 ? void 0 : phaseData.phases) || [];
    return /*#__PURE__*/ (0, $61Ea1.jsx)($e4a8f065e6cf4b44$export$d15f4cd5286f9b1e, {
        value: value,
        onChange: onChange,
        options: options,
        getLabel: (phase)=>phase ? (0, $49KvR.getLabel).phases(phase) : placeholder,
        getValue: (phase)=>phase === null || phase === void 0 ? void 0 : phase.id,
        sort: (a, b)=>{
            // First, sort by status
            const statusOrder = [
                "active",
                "prospective",
                "onHold",
                "archived"
            ];
            const statusCompare = statusOrder.indexOf(a.status || "active") - statusOrder.indexOf(b.status || "active");
            // If status is the same, sort by name case-insensitive
            if (statusCompare === 0) return (a.name || "").toLowerCase().localeCompare((b.name || "").toLowerCase());
            return statusCompare;
        },
        placeholder: placeholder,
        clearable: clearable,
        search: true,
        groupBy: (_options$2 = options[0]) !== null && _options$2 !== void 0 && _options$2.status ? (phase)=>(0, $e8Hda.camelCaseToSentence)(((phase === null || phase === void 0 ? void 0 : phase.status) || "active") + "Phases") : undefined,
        ...props
    });
};
const $e4a8f065e6cf4b44$export$b1a90c704904b8d3 = ({ projectId: projectId, phaseId: phaseId, value: value, options: providedOptions, onChange: onChange, placeholder: placeholder = "Select Task...", clearable: clearable = true, ...props })=>{
    const { data: phaseData, isLoading: isLoading } = (0, $hJgkt.useQuery)({
        queryKey: [
            "project-phases",
            projectId
        ],
        queryFn: ()=>(0, $3h7sC.trpc).global.getPhaseTasks.query({
                projectId: projectId
            }),
        enabled: !providedOptions && !!projectId,
        // Only run query when projectId is provided
        staleTime: 300000 // Cache for 5 minutes
    });
    const options = providedOptions || (phaseData === null || phaseData === void 0 ? void 0 : phaseData.tasks.filter((t)=>t.phaseId === phaseId)) || [];
    return /*#__PURE__*/ (0, $61Ea1.jsx)($e4a8f065e6cf4b44$export$d15f4cd5286f9b1e, {
        value: value,
        onChange: onChange,
        options: options,
        getLabel: (task)=>task ? (0, $49KvR.getLabel).tasks(task) : placeholder,
        getValue: (task)=>task === null || task === void 0 ? void 0 : task.id,
        sort: (a, b)=>{
            return (a.name || "").toLowerCase().localeCompare((b.name || "").toLowerCase());
        },
        placeholder: placeholder,
        clearable: clearable,
        search: true,
        ...props
    });
};
const $e4a8f065e6cf4b44$export$2d2573c5466d1f18 = ({ value: value, options: providedOptions, onChange: onChange, placeholder: placeholder = "Select Cost Centre...", clearable: clearable = true, ...props })=>{
    const costCentres = (0, $38AIP.useCacheSlice)("costCentres");
    const options = providedOptions || costCentres || [];
    return /*#__PURE__*/ (0, $61Ea1.jsx)($e4a8f065e6cf4b44$export$d15f4cd5286f9b1e, {
        value: value,
        onChange: onChange,
        options: options,
        getLabel: (costCentre)=>{
            return costCentre ? (0, $49KvR.getLabel).costCentres(costCentre) : placeholder;
        },
        getValue: (costCentre)=>costCentre === null || costCentre === void 0 ? void 0 : costCentre.id,
        sort: (a, b)=>{
            return (a.name || "").toLowerCase().localeCompare((b.name || "").toLowerCase());
        },
        placeholder: placeholder,
        clearable: clearable,
        search: true,
        ...props
    });
};
const $e4a8f065e6cf4b44$export$88f0a7c4e0b5e98e = ({ value: value, options: providedOptions, onChange: onChange, placeholder: placeholder = "Select Permission...", clearable: clearable = true, ...props })=>{
    const permission = (0, $38AIP.useCacheSlice)("permissions");
    const options = providedOptions || permission || [];
    return /*#__PURE__*/ (0, $61Ea1.jsx)($e4a8f065e6cf4b44$export$d15f4cd5286f9b1e, {
        value: value,
        onChange: onChange,
        options: [
            ...options,
            {
                id: "custom",
                name: "Custom"
            }
        ],
        getLabel: (permission)=>{
            return permission ? (0, $49KvR.getLabel).permission(permission) : placeholder;
        },
        getValue: (permission)=>permission === null || permission === void 0 ? void 0 : permission.id,
        sort: (a, b)=>{
            return (a.name || "").toLowerCase().localeCompare((b.name || "").toLowerCase());
        },
        placeholder: placeholder,
        clearable: clearable,
        search: true,
        ...props
    });
};

});
parcelRegister("hJgkt", function(module, exports) {

$parcel$export(module.exports, "useQuery", function () { return $ce834e437ea306f9$export$dd0a697e1782aedd; });

var $dI9XE = parcelRequire("dI9XE");
var $432gx = parcelRequire("432gx");

var $fXcUS = parcelRequire("fXcUS");
"use client";
function $ce834e437ea306f9$export$dd0a697e1782aedd(arg1, arg2, arg3) {
    const parsedOptions = (0, $dI9XE.parseQueryArgs)(arg1, arg2, arg3);
    return (0, $fXcUS.useBaseQuery)(parsedOptions, (0, $432gx.QueryObserver));
}

});
parcelRegister("fXcUS", function(module, exports) {

$parcel$export(module.exports, "useBaseQuery", function () { return $b9d662a032611bf5$export$fff0865807e996c5; });

var $jbmdS = parcelRequire("jbmdS");

var $7jCK0 = parcelRequire("7jCK0");

var $lK3dc = parcelRequire("lK3dc");

var $hErV2 = parcelRequire("hErV2");

var $9d62S = parcelRequire("9d62S");

var $1j7JM = parcelRequire("1j7JM");

var $fKh4E = parcelRequire("fKh4E");

var $83bXR = parcelRequire("83bXR");
"use client";
function $b9d662a032611bf5$export$fff0865807e996c5(options, Observer) {
    const queryClient = (0, $9d62S.useQueryClient)({
        context: options.context
    });
    const isRestoring = (0, $1j7JM.useIsRestoring)();
    const errorResetBoundary = (0, $hErV2.useQueryErrorResetBoundary)();
    const defaultedOptions = queryClient.defaultQueryOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic"; // Include callbacks in batch renders
    if (defaultedOptions.onError) defaultedOptions.onError = (0, $7jCK0.notifyManager).batchCalls(defaultedOptions.onError);
    if (defaultedOptions.onSuccess) defaultedOptions.onSuccess = (0, $7jCK0.notifyManager).batchCalls(defaultedOptions.onSuccess);
    if (defaultedOptions.onSettled) defaultedOptions.onSettled = (0, $7jCK0.notifyManager).batchCalls(defaultedOptions.onSettled);
    (0, $83bXR.ensureStaleTime)(defaultedOptions);
    (0, $fKh4E.ensurePreventErrorBoundaryRetry)(defaultedOptions, errorResetBoundary);
    (0, $fKh4E.useClearResetErrorBoundary)(errorResetBoundary);
    const [observer] = $jbmdS.useState(()=>new Observer(queryClient, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    (0, $lK3dc.useSyncExternalStore)($jbmdS.useCallback((onStoreChange)=>{
        const unsubscribe = isRestoring ? ()=>undefined : observer.subscribe((0, $7jCK0.notifyManager).batchCalls(onStoreChange)); // Update result to make sure we did not miss any query updates
        // between creating the observer and subscribing to it.
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $jbmdS.useEffect(()=>{
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]); // Handle suspense
    if ((0, $83bXR.shouldSuspend)(defaultedOptions, result, isRestoring)) throw (0, $83bXR.fetchOptimistic)(defaultedOptions, observer, errorResetBoundary);
     // Handle error boundary
    if ((0, $fKh4E.getHasError)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        useErrorBoundary: defaultedOptions.useErrorBoundary,
        query: observer.getCurrentQuery()
    })) throw result.error;
     // Handle result property usage tracking
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}

});



parcelRegister("imf6A", function(module, exports) {

$parcel$export(module.exports, "TableInput", function () { return $7cac4d5de44ad8b7$export$9680b991b5aa924f; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $Yha9m = parcelRequire("Yha9m");
const $7cac4d5de44ad8b7$export$9680b991b5aa924f = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, type: type, suffix: suffix, prefix: prefix, onChange: onChange, debounceMs: debounceMs = 300, value: controlledValue, defaultValue: defaultValue, ...props }, ref)=>{
    var _ref;
    const [internalValue, setInternalValue] = $jbmdS.useState((_ref = controlledValue !== null && controlledValue !== void 0 ? controlledValue : defaultValue) !== null && _ref !== void 0 ? _ref : "");
    // Update internal value when controlled value changes
    $jbmdS.useEffect(()=>{
        if (controlledValue !== undefined) setInternalValue(controlledValue);
    }, [
        controlledValue
    ]);
    // Create a debounced version of onChange
    const debouncedOnChange = $jbmdS.useCallback($jbmdS.useMemo(()=>{
        let timeoutId = null;
        return (value)=>{
            if (timeoutId) clearTimeout(timeoutId);
            timeoutId = setTimeout(()=>{
                // Create a synthetic event with the current value
                const syntheticEvent = {
                    target: {
                        value: value
                    }
                };
                onChange === null || onChange === void 0 || onChange(syntheticEvent);
            }, debounceMs);
        };
    }, [
        onChange,
        debounceMs
    ]), [
        onChange,
        debounceMs
    ]);
    const handleChange = (event)=>{
        const newValue = event.target.value;
        // For number inputs, only update if the value is valid
        if ([
            "number",
            "percent",
            "currency"
        ].includes(type)) {
            // Allow empty string for clearing
            if (newValue === "") {
                setInternalValue(newValue);
                debouncedOnChange(newValue);
                return;
            }
            // Allow valid number patterns including partial inputs
            const numberPattern = /^-?\d*\.?\d*$/;
            if (numberPattern.test(newValue)) {
                setInternalValue(newValue);
                debouncedOnChange(newValue);
            }
            setInternalValue(newValue);
            return;
        }
        // For all other types, update normally
        setInternalValue(newValue);
        debouncedOnChange(newValue);
    };
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "relative flex items-center",
        children: [
            prefix && /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                className: "absolute left-0 text-xs text-muted-foreground",
                children: prefix
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
                type: type,
                className: (0, $Yha9m.cn)("z-1 flex w-full rounded-md border border-input bg-background px-1 py-1 text-xs ring-offset-background file:border-0 file:bg-transparent file:text-xs file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50", suffix && "pr-10", className),
                value: internalValue,
                onChange: handleChange,
                ref: ref,
                ...props
            }),
            suffix && /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                className: "absolute right-1 text-xs text-muted-foreground",
                children: suffix
            })
        ]
    });
});
$7cac4d5de44ad8b7$export$9680b991b5aa924f.displayName = "TableInput";

});


parcelRegister("5VJGc", function(module, exports) {

$parcel$export(module.exports, "sortingFns", function () { return $8d6b52cbe7db1c3c$export$47423a4cd813a815; });
const $8d6b52cbe7db1c3c$export$47423a4cd813a815 = {
    date: "sortingDateFn",
    text: "sortingTextFn",
    number: "sortingNumberFn",
    currency: "sortingNumberFn",
    status: "sortingStatusFn",
    staffMember: "sortingStaffMemberFn",
    progressBar: "sortingProgressFn"
};

});

parcelRegister("22002", function(module, exports) {

$parcel$export(module.exports, "generateFilterOptions", function () { return $b4beb8d4a69d79ce$export$91755dbccb711060; });

var $eat5C = parcelRequire("eat5C");

var $38AIP = parcelRequire("38AIP");
const $b4beb8d4a69d79ce$export$91755dbccb711060 = (type)=>{
    const cache = (0, $38AIP.getCache)();
    switch(type){
        case "project":
            return {
                options: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sortBy((cache.projects || []).map((project)=>{
                    return {
                        label: project.jobNumber ? `${project.jobNumber}: ${project.name}` : project.name,
                        value: project.id,
                        status: project.status
                    };
                }), (project)=>(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).toLower(project.label)),
                groupBy: (sm)=>sm.status,
                sortGroups: (a, b)=>{
                    const statusOrder = [
                        "active",
                        "prospective",
                        "onHold",
                        "archived"
                    ];
                    return statusOrder.indexOf(a.label) - statusOrder.indexOf(b.label);
                }
            };
        case "status":
            return {
                options: [
                    {
                        label: "Active",
                        value: "active"
                    },
                    {
                        label: "On Hold",
                        value: "onHold"
                    },
                    {
                        label: "Prospective",
                        value: "prospective"
                    },
                    {
                        label: "Archived",
                        value: "archived"
                    }
                ]
            };
        case "staffMember":
            return {
                options: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sortBy((cache.staff || []).map((staff)=>{
                    return {
                        label: `${staff.firstName} ${staff.lastName}`,
                        value: staff.id,
                        isArchived: staff.isArchived
                    };
                }), (staff)=>(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).toLower(staff.label)),
                groupBy: (sm)=>sm.isArchived ? "Archived" : "Active",
                sortGroups: (a, b)=>a.label === "Archived" ? 1 : -1
            };
        case "costCentre":
            return {
                options: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sortBy((cache.costCentres || []).map((costCentre)=>{
                    return {
                        label: costCentre.name,
                        value: costCentre.id
                    };
                }), (costCentre)=>(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).toLower(costCentre.label))
            };
        case "contact":
            return {
                options: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sortBy((cache.contacts || []).map((contact)=>{
                    return {
                        label: `(${contact.organisationName})`,
                        value: contact.id
                    };
                }), (contact)=>(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).toLower(contact.label))
            };
        default:
            return {};
    }
};

});


parcelRegister("27lKj", function(module, exports) {

$parcel$export(module.exports, "revenueForecastStore", function () { return $18d7227a308247c9$export$5cab8ff05643eba5; });
$parcel$export(module.exports, "useDateRange", function () { return $18d7227a308247c9$export$57e024081dbf72bf; });
$parcel$export(module.exports, "useData", function () { return $18d7227a308247c9$export$c1cf1cf4c5d51937; });
$parcel$export(module.exports, "useError", function () { return $18d7227a308247c9$export$5027865de34f9ec6; });
$parcel$export(module.exports, "useIsLoading", function () { return $18d7227a308247c9$export$4dface15d86304a4; });
$parcel$export(module.exports, "useOverheadExpenses", function () { return $18d7227a308247c9$export$964e8030253e4b81; });
$parcel$export(module.exports, "useStaffExpenses", function () { return $18d7227a308247c9$export$b4dd337a14f8b9f7; });
$parcel$export(module.exports, "useSelectedRow", function () { return $18d7227a308247c9$export$11a86b67953bcc50; });
$parcel$export(module.exports, "useSelectedMonth", function () { return $18d7227a308247c9$export$78c2e6bb19c6570a; });
$parcel$export(module.exports, "useSidebarProject", function () { return $18d7227a308247c9$export$71464175645a82b0; });
$parcel$export(module.exports, "useSidebarResourcing", function () { return $18d7227a308247c9$export$f3f5bf3aac730371; });
$parcel$export(module.exports, "setReport", function () { return $18d7227a308247c9$export$752dd95bf9e69de3; });
$parcel$export(module.exports, "setDateRange", function () { return $18d7227a308247c9$export$102acb2535380e55; });
$parcel$export(module.exports, "setSelectedRow", function () { return $18d7227a308247c9$export$f5d4b21aafee189; });
$parcel$export(module.exports, "setSelectedMonth", function () { return $18d7227a308247c9$export$9712fed88123de7a; });
$parcel$export(module.exports, "setSidebarProject", function () { return $18d7227a308247c9$export$6801407cd94f1512; });
$parcel$export(module.exports, "setSidebarResourcing", function () { return $18d7227a308247c9$export$7f9585f3aecebcaf; });
$parcel$export(module.exports, "setSidebarMonth", function () { return $18d7227a308247c9$export$6402b81e9001a2f7; });
$parcel$export(module.exports, "getSelectedRow", function () { return $18d7227a308247c9$export$6f4d2c23e76294f0; });
$parcel$export(module.exports, "getSelectedMonth", function () { return $18d7227a308247c9$export$92e57cd34a242473; });
$parcel$export(module.exports, "fetchForecastData", function () { return $18d7227a308247c9$export$13a305e81276b1dc; });
$parcel$export(module.exports, "shiftMonths", function () { return $18d7227a308247c9$export$92ecf9ccd40d17c0; });
$parcel$export(module.exports, "updateProjectedRevenueCellValue", function () { return $18d7227a308247c9$export$6ba91eb6d21577a4; });

var $hxM7m = parcelRequire("hxM7m");

var $lJ1OS = parcelRequire("lJ1OS");

var $3h7sC = parcelRequire("3h7sC");
parcelRequire("iaSLm");
var $4hBm1 = parcelRequire("4hBm1");

var $eat5C = parcelRequire("eat5C");

var $fhV44 = parcelRequire("fhV44");
// Initial state
const $18d7227a308247c9$var$initialContext = {
    report: null,
    selectedRow: null,
    selectedMonth: null,
    dateRange: [
        "",
        ""
    ],
    data: [],
    overheadExpenses: [],
    staffExpenses: [],
    error: null,
    isLoading: false,
    sidebar: {
        month: "",
        project: {
            id: "",
            title: "",
            fee: 0,
            expenseBudget: 0,
            hoursBudget: 0,
            revenue: 0,
            expense: 0,
            phases: []
        },
        resourcing: {
            allocations: [],
            staff: [],
            roles: []
        }
    }
};
const $18d7227a308247c9$export$5cab8ff05643eba5 = (0, $hxM7m.createStore)({
    context: $18d7227a308247c9$var$initialContext,
    on: {
        setReport: {
            report: (_, event)=>event.report
        },
        setDateRange: {
            dateRange: (_, event)=>event.dateRange
        },
        setData: {
            data: (_, event)=>event.data.revenue,
            overheadExpenses: (_, event)=>event.data.overheadExpenses,
            staffExpenses: (_, event)=>event.data.staffExpenses
        },
        setError: {
            error: (_, event)=>event.error
        },
        setIsLoading: {
            isLoading: (_, event)=>event.isLoading
        },
        setSelectedRow: {
            selectedRow: (_, event)=>event.selectedRow
        },
        setSelectedMonth: {
            selectedMonth: (_, event)=>event.selectedMonth
        },
        setSidebarProject: {
            sidebar: (state, event)=>({
                    ...state.sidebar,
                    project: event.project
                })
        },
        setSidebarResourcing: {
            sidebar: (state, event)=>({
                    ...state.sidebar,
                    resourcing: event.resourcing
                })
        },
        setSidebarMonth: {
            sidebar: (state, event)=>({
                    ...state.sidebar,
                    month: event.month
                })
        },
        updateProjectedRevenueCell: {
            data: (state, event)=>{
                const { path: path, value: value, month: month } = event;
                const monthKey = `${month}-P`;
                // Get the old value by traversing the path
                let current = state.data;
                let oldValue = 0;
                const tempPath = [
                    ...path
                ];
                while(tempPath.length > 0){
                    const key = tempPath.shift();
                    if (current[key] !== undefined) current = current[key];
                }
                oldValue = Number(current[monthKey]) || 0;
                const diffValue = value - oldValue;
                // Helper to determine if a month is current
                const isCurrentMonth = (month)=>{
                    return month === (0, $4hBm1.format)(new Date(), "yyyy-MM");
                };
                // Recalculate totals up the hierarchy
                const updateTotals = (data, pathToUpdate)=>{
                    if (pathToUpdate.length === 0) return;
                    let current = data;
                    for(let i = 0; i < pathToUpdate.length - 1; i++)current = current[pathToUpdate[i]];
                    const parent = current;
                    const lastKey = pathToUpdate[pathToUpdate.length - 1];
                    if (parent) {
                        // If the parent has children (it's a project or status group),
                        // recalculate its value based on the sum of its children
                        if (parent[lastKey] && parent[lastKey].children) {
                            const children = parent[lastKey].children;
                            const childrenTotal = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(children.map((child)=>Number(child[monthKey]) || 0));
                            // Update the parent's value to match the sum of its children
                            const oldParentValue = Number(parent[lastKey][monthKey]) || 0;
                            parent[lastKey][monthKey] = childrenTotal;
                            // Calculate the difference for updating totals
                            const localDiffValue = childrenTotal - oldParentValue;
                            // Update the appropriate total based on the month
                            if (isCurrentMonth(month)) parent[lastKey].currentProjectedTotal = (parent[lastKey].currentProjectedTotal || 0) + localDiffValue;
                            else {
                                const monthDate = new Date(month);
                                const today = new Date();
                                if (monthDate > today) parent[lastKey].futureProjectedTotal = (parent[lastKey].futureProjectedTotal || 0) + localDiffValue;
                            }
                        } else {
                            var _parent$lastKey, _parent$lastKey$month;
                            // If there are no children (it's a phase), use the original diffValue
                            (_parent$lastKey$month = (_parent$lastKey = parent[lastKey])[monthKey]) !== null && _parent$lastKey$month !== void 0 ? _parent$lastKey$month : _parent$lastKey[monthKey] = 0;
                            parent[lastKey][monthKey] += diffValue;
                            // Update the appropriate total based on the month
                            if (isCurrentMonth(month)) parent[lastKey].currentProjectedTotal = (parent[lastKey].currentProjectedTotal || 0) + diffValue;
                            else {
                                const monthDate = new Date(month);
                                const today = new Date();
                                if (monthDate > today) parent[lastKey].futureProjectedTotal = (parent[lastKey].futureProjectedTotal || 0) + diffValue;
                            }
                        }
                    }
                    // Continue up the hierarchy
                    updateTotals(data, pathToUpdate.slice(0, -1));
                };
                // Update appropriate total based on month and then update the hierarchy
                const updateTotalForMonth = (item, diff = diffValue, itemPath = [])=>{
                    // Update the item's totals
                    if (isCurrentMonth(month)) item.currentProjectedTotal = (item.currentProjectedTotal || 0) + diff;
                    else {
                        const monthDate = new Date(month);
                        const today = new Date();
                        if (monthDate > today) item.futureProjectedTotal = (item.futureProjectedTotal || 0) + diff;
                    }
                    // If we have a path, update the hierarchy
                    if (itemPath.length > 0) updateTotals(newData, itemPath.slice(0, -1));
                };
                // If updating a project (not a phase)
                const newData = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).cloneDeep(state.data);
                if (path.length === 3) {
                    // [statusIndex, 'children', projectIndex]
                    let current = newData;
                    for(let i = 0; i < path.length; i++)current = current[path[i]];
                    // Update project value first
                    current[monthKey] = value;
                    updateTotalForMonth(current, diffValue, path);
                    // Then distribute to phases
                    const phases = current.children;
                    const phaseTotals = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(phases.map((phase)=>phase[monthKey] || 0));
                    if (phaseTotals > 0) // Distribute proportionally based on current phase values
                    phases.forEach((phase, phaseIndex)=>{
                        var _phase$monthKey;
                        (_phase$monthKey = phase[monthKey]) !== null && _phase$monthKey !== void 0 ? _phase$monthKey : phase[monthKey] = 0;
                        const ratio = phase[monthKey] / phaseTotals;
                        const oldPhaseValue = phase[monthKey];
                        phase[monthKey] = ratio * value;
                        const phaseDiff = phase[monthKey] - oldPhaseValue;
                        const phasePath = [
                            ...path,
                            "children",
                            phaseIndex
                        ];
                        updateTotalForMonth(phase, phaseDiff, phasePath);
                    });
                    else {
                        // Distribute equally among phases
                        const equalShare = value / phases.length;
                        phases.forEach((phase, phaseIndex)=>{
                            const oldPhaseValue = phase[monthKey] || 0;
                            phase[monthKey] = equalShare;
                            const phaseDiff = equalShare - oldPhaseValue;
                            const phasePath = [
                                ...path,
                                "children",
                                phaseIndex
                            ];
                            updateTotalForMonth(phase, phaseDiff, phasePath);
                        });
                    }
                } else {
                    // Direct phase update
                    let current = newData;
                    for(let i = 0; i < path.length - 1; i++)current = current[path[i]];
                    current[path[path.length - 1]][monthKey] = value;
                    updateTotalForMonth(current[path[path.length - 1]], diffValue, path);
                }
                return newData;
            }
        },
        mergeFetchedData: {
            data: (state, event)=>{
                const { revenue: revenue } = event.data;
                const existingRevenue = state.data;
                revenue.forEach((statusGroup)=>{
                    let existingStatusGroup = existingRevenue.find((s)=>s.status === statusGroup.status);
                    if (existingStatusGroup) Object.keys(statusGroup).forEach((key)=>{
                        if (key !== "children") existingStatusGroup[key] = statusGroup[key];
                        else {
                            const newChildren = statusGroup.children.filter((p)=>!existingStatusGroup.children.map((p2)=>p2.projectId).includes(p.projectId));
                            existingStatusGroup.children = [
                                ...existingStatusGroup.children,
                                ...newChildren
                            ];
                        }
                    });
                    else {
                        existingRevenue.push(statusGroup);
                        return;
                    }
                    statusGroup.children.forEach((project)=>{
                        let existingProject = existingStatusGroup.children.find((p)=>p.projectId === project.projectId);
                        if (existingProject) Object.keys(project).forEach((key)=>{
                            if (key !== "children") existingProject[key] = project[key];
                            else existingProject.children = [
                                ...existingProject.children,
                                ...project.children.filter((p2)=>!existingProject.children.map((p3)=>p3.phaseId).includes(p2.phaseId))
                            ];
                        });
                        else {
                            existingStatusGroup.children.push(project);
                            return;
                        }
                        project.children.forEach((phase)=>{
                            let existingPhase = existingProject.children.find((p)=>p.phaseId === phase.phaseId);
                            if (existingPhase) Object.keys(phase).forEach((key)=>{
                                existingPhase[key] = phase[key];
                            });
                            else existingProject.children.push(phase);
                        });
                    });
                });
                return existingRevenue;
            },
            overheadExpenses: (state, event)=>{
                const { overheadExpenses: overheadExpenses } = event.data;
                const existingOverheadExpenses = state.overheadExpenses;
                const expenseMap = new Map(existingOverheadExpenses.map((expense)=>[
                        expense.id,
                        expense
                    ]));
                overheadExpenses.forEach((expense)=>{
                    const existingExpense = expenseMap.get(expense.id);
                    if (existingExpense) Object.assign(existingExpense, expense);
                    else existingOverheadExpenses.push(expense);
                });
                return existingOverheadExpenses;
            },
            staffExpenses: (state, event)=>{
                const { staffExpenses: staffExpenses } = event.data;
                const existingStaffExpenses = state.staffExpenses;
                const expenseMap = new Map(existingStaffExpenses.map((expense)=>[
                        expense.id,
                        expense
                    ]));
                staffExpenses.forEach((expense)=>{
                    const existingExpense = expenseMap.get(expense.id);
                    if (existingExpense) Object.assign(existingExpense, expense);
                    else existingStaffExpenses.push(expense);
                });
                return existingStaffExpenses;
            }
        }
    }
});
const $18d7227a308247c9$export$335080e14d32489b = ()=>(0, $lJ1OS.useSelector)($18d7227a308247c9$export$5cab8ff05643eba5, (state)=>state.context.report);
const $18d7227a308247c9$export$57e024081dbf72bf = ()=>(0, $lJ1OS.useSelector)($18d7227a308247c9$export$5cab8ff05643eba5, (state)=>state.context.dateRange);
const $18d7227a308247c9$export$c1cf1cf4c5d51937 = ()=>(0, $lJ1OS.useSelector)($18d7227a308247c9$export$5cab8ff05643eba5, (state)=>state.context.data);
const $18d7227a308247c9$export$5027865de34f9ec6 = ()=>(0, $lJ1OS.useSelector)($18d7227a308247c9$export$5cab8ff05643eba5, (state)=>state.context.error);
const $18d7227a308247c9$export$4dface15d86304a4 = ()=>(0, $lJ1OS.useSelector)($18d7227a308247c9$export$5cab8ff05643eba5, (state)=>state.context.isLoading);
const $18d7227a308247c9$export$964e8030253e4b81 = ()=>(0, $lJ1OS.useSelector)($18d7227a308247c9$export$5cab8ff05643eba5, (state)=>state.context.overheadExpenses);
const $18d7227a308247c9$export$b4dd337a14f8b9f7 = ()=>(0, $lJ1OS.useSelector)($18d7227a308247c9$export$5cab8ff05643eba5, (state)=>state.context.staffExpenses);
const $18d7227a308247c9$export$11a86b67953bcc50 = ()=>(0, $lJ1OS.useSelector)($18d7227a308247c9$export$5cab8ff05643eba5, (state)=>state.context.selectedRow);
const $18d7227a308247c9$export$78c2e6bb19c6570a = ()=>(0, $lJ1OS.useSelector)($18d7227a308247c9$export$5cab8ff05643eba5, (state)=>state.context.selectedMonth);
const $18d7227a308247c9$export$71464175645a82b0 = ()=>(0, $lJ1OS.useSelector)($18d7227a308247c9$export$5cab8ff05643eba5, (state)=>state.context.sidebar.project);
const $18d7227a308247c9$export$f3f5bf3aac730371 = ()=>(0, $lJ1OS.useSelector)($18d7227a308247c9$export$5cab8ff05643eba5, (state)=>state.context.sidebar.resourcing);
const $18d7227a308247c9$export$b7045fa6cd06f67a = ()=>(0, $lJ1OS.useSelector)($18d7227a308247c9$export$5cab8ff05643eba5, (state)=>state.context.sidebar.month);
const $18d7227a308247c9$export$752dd95bf9e69de3 = (report)=>$18d7227a308247c9$export$5cab8ff05643eba5.send({
        type: "setReport",
        report: report
    });
const $18d7227a308247c9$export$102acb2535380e55 = (dateRange)=>$18d7227a308247c9$export$5cab8ff05643eba5.send({
        type: "setDateRange",
        dateRange: dateRange
    });
const $18d7227a308247c9$export$3a6802af14bf5fa6 = (data)=>$18d7227a308247c9$export$5cab8ff05643eba5.send({
        type: "setData",
        data: data
    });
const $18d7227a308247c9$export$df824cb52c618ce8 = (data)=>$18d7227a308247c9$export$5cab8ff05643eba5.send({
        type: "mergeFetchedData",
        data: data
    });
const $18d7227a308247c9$export$b8d0bb2aa0adefe5 = (error)=>$18d7227a308247c9$export$5cab8ff05643eba5.send({
        type: "setError",
        error: error
    });
const $18d7227a308247c9$export$9eaa806651dd33f0 = (isLoading)=>$18d7227a308247c9$export$5cab8ff05643eba5.send({
        type: "setIsLoading",
        isLoading: isLoading
    });
const $18d7227a308247c9$export$f5d4b21aafee189 = (selectedRow)=>$18d7227a308247c9$export$5cab8ff05643eba5.send({
        type: "setSelectedRow",
        selectedRow: selectedRow
    });
const $18d7227a308247c9$export$9712fed88123de7a = (selectedMonth)=>$18d7227a308247c9$export$5cab8ff05643eba5.send({
        type: "setSelectedMonth",
        selectedMonth: selectedMonth
    });
const $18d7227a308247c9$export$6801407cd94f1512 = (project)=>$18d7227a308247c9$export$5cab8ff05643eba5.send({
        type: "setSidebarProject",
        project: project
    });
const $18d7227a308247c9$export$7f9585f3aecebcaf = (resourcing)=>$18d7227a308247c9$export$5cab8ff05643eba5.send({
        type: "setSidebarResourcing",
        resourcing: resourcing
    });
const $18d7227a308247c9$export$6402b81e9001a2f7 = (month)=>$18d7227a308247c9$export$5cab8ff05643eba5.send({
        type: "setSidebarMonth",
        month: month
    });
const $18d7227a308247c9$export$c054181989e5496 = (data, month)=>{
    return data.reduce((total, statusGroup)=>{
        return total + (statusGroup[month] || 0);
    }, 0);
};
const $18d7227a308247c9$export$6c2f5ccbee8220a6 = (statusGroup, month)=>{
    return statusGroup[month] || 0;
};
const $18d7227a308247c9$export$6754364b781f09a0 = (project, month)=>{
    return project[month] || 0;
};
const $18d7227a308247c9$export$7cd9e519f3427ff1 = (phase, month)=>{
    return phase[month] || 0;
};
const $18d7227a308247c9$export$20dacee9ff3b391d = (data)=>{
    const totals = {};
    data.forEach((statusGroup)=>{
        Object.entries(statusGroup).filter(([key])=>key.match(/^\d{4}-\d{2}-[AP]$/)).forEach(([month, revenue])=>{
            totals[month] = (totals[month] || 0) + revenue;
        });
    });
    return totals;
};
const $18d7227a308247c9$export$6f4d2c23e76294f0 = ()=>{
    const state = $18d7227a308247c9$export$5cab8ff05643eba5.getSnapshot();
    return state.context.selectedRow;
};
const $18d7227a308247c9$export$92e57cd34a242473 = ()=>{
    const state = $18d7227a308247c9$export$5cab8ff05643eba5.getSnapshot();
    return state.context.selectedMonth;
};
const $18d7227a308247c9$export$e2b90344b1245c93 = ()=>{
    const state = $18d7227a308247c9$export$5cab8ff05643eba5.getSnapshot();
    return state.context.report;
};
// Helper function to merge monthly revenues
const $18d7227a308247c9$var$mergeMonthlyRevenues = (existing, incoming)=>{
    return {
        ...existing,
        ...incoming
    };
};
// Helper function to merge phases
const $18d7227a308247c9$var$mergePhases = (existing, incoming)=>{
    const phaseMap = new Map(existing.map((phase)=>[
            phase.id,
            phase
        ]));
    incoming.forEach((phase)=>{
        const existingPhase = phaseMap.get(phase.id);
        if (existingPhase) {
            const { id: id, name: name, ...monthlyRevenue } = phase;
            const basePhase = {
                id: id,
                name: name
            };
            phaseMap.set(phase.id, {
                ...basePhase,
                ...$18d7227a308247c9$var$mergeMonthlyRevenues(existingPhase, monthlyRevenue)
            });
        } else phaseMap.set(phase.id, phase);
    });
    return Array.from(phaseMap.values());
};
// Helper function to merge projects
const $18d7227a308247c9$var$mergeProjects = (existing, incoming)=>{
    const projectMap = new Map(existing.map((project)=>[
            project.id,
            project
        ]));
    incoming.forEach((project)=>{
        const existingProject = projectMap.get(project.id);
        if (existingProject) {
            const { id: id, name: name, phases: phases, ...monthlyRevenue } = project;
            const baseProject = {
                id: id,
                name: name,
                phases: $18d7227a308247c9$var$mergePhases(existingProject.phases, phases)
            };
            projectMap.set(project.id, {
                ...baseProject,
                ...$18d7227a308247c9$var$mergeMonthlyRevenues(existingProject, monthlyRevenue)
            });
        } else projectMap.set(project.id, project);
    });
    return Array.from(projectMap.values());
};
// Helper function to merge status groups
const $18d7227a308247c9$var$mergeStatusGroups = (existing, incoming)=>{
    const statusMap = new Map(existing.map((status)=>[
            status.id,
            status
        ]));
    incoming.forEach((status)=>{
        const existingStatus = statusMap.get(status.id);
        if (existingStatus) {
            const { id: id, projects: projects, ...monthlyRevenue } = status;
            const baseStatusGroup = {
                id: id,
                projects: $18d7227a308247c9$var$mergeProjects(existingStatus.projects, projects)
            };
            statusMap.set(status.id, {
                ...baseStatusGroup,
                ...$18d7227a308247c9$var$mergeMonthlyRevenues(existingStatus, monthlyRevenue)
            });
        } else statusMap.set(status.id, status);
    });
    return Array.from(statusMap.values());
};
const $18d7227a308247c9$export$566499ecc0d835a9 = async (newDateRange)=>{
    try {
        $18d7227a308247c9$export$9eaa806651dd33f0(true);
        $18d7227a308247c9$export$b8d0bb2aa0adefe5(null);
        const response = await (0, $3h7sC.trpc).revenueForecast.getForecastData.query({
            dateRange: newDateRange
        });
        // Get existing data from store using snapshot
        const state = $18d7227a308247c9$export$5cab8ff05643eba5.getSnapshot();
        const existingData = state.context.data;
        // Merge existing and new data
        const mergedData = $18d7227a308247c9$var$mergeStatusGroups(existingData, response.revenue);
        // Update store with merged data and new date range
        $18d7227a308247c9$export$3a6802af14bf5fa6({
            revenue: mergedData,
            overheadExpenses: response.overheadExpenses,
            staffExpenses: response.staffExpenses
        });
        $18d7227a308247c9$export$102acb2535380e55(newDateRange);
    } catch (error) {
        $18d7227a308247c9$export$b8d0bb2aa0adefe5(error instanceof Error ? error.message : "An error occurred while fetching data");
    } finally{
        $18d7227a308247c9$export$9eaa806651dd33f0(false);
    }
};
const $18d7227a308247c9$export$13a305e81276b1dc = async (dateRange, filters = {})=>{
    try {
        $18d7227a308247c9$export$9eaa806651dd33f0(true);
        $18d7227a308247c9$export$b8d0bb2aa0adefe5(null);
        const response = await (0, $3h7sC.trpc).revenueForecast.getForecastData.query({
            dateRange: dateRange,
            filters: filters
        });
        $18d7227a308247c9$export$3a6802af14bf5fa6({
            revenue: response.revenue,
            overheadExpenses: response.overheadExpenses,
            staffExpenses: response.staffExpenses
        });
        $18d7227a308247c9$export$102acb2535380e55(dateRange);
    } catch (error) {
        $18d7227a308247c9$export$b8d0bb2aa0adefe5(error instanceof Error ? error.message : "An error occurred while fetching data");
    } finally{
        $18d7227a308247c9$export$9eaa806651dd33f0(false);
    }
};
const $18d7227a308247c9$export$92ecf9ccd40d17c0 = async (direction)=>{
    const state = $18d7227a308247c9$export$5cab8ff05643eba5.getSnapshot();
    const currentDateRange = state.context.dateRange;
    if (!currentDateRange[0] || !currentDateRange[1]) return;
    // setIsLoading(true) // Set loading state immediately
    const startDate = new Date(currentDateRange[0]);
    const endDate = new Date(currentDateRange[1]);
    // Calculate new date range maintaining 12-month window
    const newStartDate = (0, $fhV44.startOfMonth)(direction === "left" ? (0, $4hBm1.subMonths)(startDate, 1) : (0, $4hBm1.addMonths)(startDate, 1));
    const newEndDate = (0, $4hBm1.endOfMonth)((0, $4hBm1.addMonths)(newStartDate, 11));
    const newDateRange = [
        (0, $4hBm1.format)(newStartDate, "yyyy-MM-dd"),
        (0, $4hBm1.format)(newEndDate, "yyyy-MM-dd")
    ];
    try {
        var _getReport;
        // setIsLoading(true)
        $18d7227a308247c9$export$b8d0bb2aa0adefe5(null);
        // Fetch data for the new date range
        const response = await (0, $3h7sC.trpc).revenueForecast.getForecastData.query({
            dateRange: newDateRange,
            filters: (_getReport = $18d7227a308247c9$export$e2b90344b1245c93()) === null || _getReport === void 0 ? void 0 : _getReport.filters
        });
        $18d7227a308247c9$export$df824cb52c618ce8({
            revenue: response.revenue,
            overheadExpenses: response.overheadExpenses,
            staffExpenses: response.staffExpenses
        });
        $18d7227a308247c9$export$102acb2535380e55(newDateRange);
    } catch (error) {
        $18d7227a308247c9$export$b8d0bb2aa0adefe5(error instanceof Error ? error.message : "An error occurred while fetching data");
    } finally{
    // setIsLoading(false)
    }
};
const $18d7227a308247c9$export$6ba91eb6d21577a4 = async ({ status: status, projectId: projectId, phaseId: phaseId, month: month, value: value })=>{
    value = Number(value);
    value = isFinite(value) ? value : 0;
    const state = $18d7227a308247c9$export$5cab8ff05643eba5.getSnapshot().context;
    const statusIndex = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).findIndex(state.data, {
        status: status
    });
    if (statusIndex === -1) return;
    const projectIndex = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).findIndex(state.data[statusIndex].children, {
        projectId: projectId
    });
    if (projectIndex === -1) return;
    const previousState = state.data;
    try {
        if (phaseId) {
            const phaseIndex = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).findIndex(state.data[statusIndex].children[projectIndex].children, {
                phaseId: phaseId
            });
            if (phaseIndex === -1) return;
            $18d7227a308247c9$export$5cab8ff05643eba5.send({
                type: "updateProjectedRevenueCell",
                path: [
                    statusIndex,
                    "children",
                    projectIndex,
                    "children",
                    phaseIndex
                ],
                value: value,
                month: month
            });
        } else {
            // Update store first
            $18d7227a308247c9$export$5cab8ff05643eba5.send({
                type: "updateProjectedRevenueCell",
                path: [
                    statusIndex,
                    "children",
                    projectIndex
                ],
                value: value,
                month: month
            });
            // Get updated phases after distribution
            const updatedPhases = $18d7227a308247c9$export$5cab8ff05643eba5.getSnapshot().context.data[statusIndex].children[projectIndex].children;
            const updates = updatedPhases.map((phase)=>({
                    month: month,
                    status: status,
                    projectId: projectId,
                    phaseId: phase.phaseId,
                    value: phase[`${month}-P`] || 0
                }));
        }
    } catch (error) {
        // Revert changes in store if API call fails
        $18d7227a308247c9$export$5cab8ff05643eba5.send({
            type: "setData",
            data: {
                revenue: previousState,
                overheadExpenses: $18d7227a308247c9$export$5cab8ff05643eba5.getSnapshot().context.overheadExpenses,
                staffExpenses: $18d7227a308247c9$export$5cab8ff05643eba5.getSnapshot().context.staffExpenses
            }
        });
        $18d7227a308247c9$export$b8d0bb2aa0adefe5(error instanceof Error ? error.message : "Failed to save changes");
    }
};

});
parcelRegister("iaSLm", function(module, exports) {

var $4hBm1 = parcelRequire("4hBm1");
$parcel$exportWildcard(module.exports, $4hBm1);

});

parcelRegister("fhV44", function(module, exports) {

$parcel$export(module.exports, "startOfMonth", function () { return $721387e1232df5fe$export$a5a3b454ada2268e; });

var $l7oHg = parcelRequire("l7oHg");
function $721387e1232df5fe$export$a5a3b454ada2268e(date) {
    const _date = (0, $l7oHg.toDate)(date);
    _date.setDate(1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$721387e1232df5fe$export$2e2bcd8739ae039 = $721387e1232df5fe$export$a5a3b454ada2268e;

});
parcelRegister("l7oHg", function(module, exports) {

$parcel$export(module.exports, "toDate", function () { return $d99dbcadc37b17a3$export$e67a095c620b86fe; });
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $d99dbcadc37b17a3$export$e67a095c620b86fe(argument) {
    const argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
    else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") // TODO: Can we get rid of as?
    return new Date(argument);
    else // TODO: Can we get rid of as?
    return new Date(NaN);
}
var // Fallback for modularized imports:
$d99dbcadc37b17a3$export$2e2bcd8739ae039 = $d99dbcadc37b17a3$export$e67a095c620b86fe;

});



parcelRegister("O2UPo", function(module, exports) {

$parcel$export(module.exports, "typeFilterMap", function () { return $7f7dba40e6390bcf$export$7e3f5ace1b21b51f; });
$parcel$export(module.exports, "sortingTextFn", function () { return $7f7dba40e6390bcf$export$7dfb30b6f36bd775; });
$parcel$export(module.exports, "sortingProgressFn", function () { return $7f7dba40e6390bcf$export$e4bd3cb07036e693; });
$parcel$export(module.exports, "sortingDateFn", function () { return $7f7dba40e6390bcf$export$5cce8c16f4d64fd0; });
$parcel$export(module.exports, "csvFormatter", function () { return $7f7dba40e6390bcf$export$26f1df27a0a010c3; });

var $azaaH = parcelRequire("azaaH");

var $fJ4T4 = parcelRequire("fJ4T4");

var $i0shw = parcelRequire("i0shw");
const $7f7dba40e6390bcf$export$7e3f5ace1b21b51f = {
    text: "text",
    progressBar: "percent",
    percent: "percent",
    date: "date",
    number: "number",
    project: "select",
    costCentre: "select",
    contact: "select",
    staffMember: "select",
    status: "select",
    staffs: "select",
    role: "select",
    boolean: "boolean",
    currency: "currency",
    time: "time"
};
const $7f7dba40e6390bcf$export$7dfb30b6f36bd775 = (rowA, rowB, columnId)=>{
    const valueA = rowA.getValue(columnId);
    const valueB = rowB.getValue(columnId);
    const isNumberA = /^\d/.test(valueA);
    const isNumberB = /^\d/.test(valueB);
    if (isNumberA && !isNumberB) return -1;
    if (!isNumberA && isNumberB) return 1;
    if (!isNumberA && !isNumberB) return 0;
    return valueA.localeCompare(valueB);
};
const $7f7dba40e6390bcf$export$e4bd3cb07036e693 = (rowA, rowB, columnId)=>{
    const valueA = rowA.getValue(columnId);
    const valueB = rowB.getValue(columnId);
    const ratioA = valueA.numerator / valueA.denominator;
    const ratioB = valueB.numerator / valueB.denominator;
    const isUndefinedA = isNaN(ratioA) || valueA.denominator === 0;
    const isUndefinedB = isNaN(ratioB) || valueB.denominator === 0;
    if (isUndefinedA && !isUndefinedB) return 1;
    if (!isUndefinedA && isUndefinedB) return -1;
    if (isUndefinedA && isUndefinedB) return 0;
    return ratioA - ratioB;
};
const $7f7dba40e6390bcf$export$5cce8c16f4d64fd0 = (rowA, rowB, columnId)=>{
    const dateA = rowA.getValue(columnId);
    const dateB = rowB.getValue(columnId);
    if (!dateA) return 1;
    if (!dateB) return -1;
    const timeA = new Date(dateA).getTime();
    const timeB = new Date(dateB).getTime();
    return timeA - timeB;
};
const $7f7dba40e6390bcf$export$26f1df27a0a010c3 = (data, column)=>{
    var _column$columnDef$met, _Formatter$column$col, _column$columnDef$met2;
    const value = data.getValue(column === null || column === void 0 ? void 0 : column.id);
    switch((_column$columnDef$met = column.columnDef.meta) === null || _column$columnDef$met === void 0 ? void 0 : _column$columnDef$met.type){
        case "progress":
        case "progressBar":
            const { numerator: numerator, denominator: denominator } = value;
            if (numerator || denominator) return `${(0, $azaaH.default).progress(numerator || 0)} / ${(0, $azaaH.default).progress(denominator || 0)}`;
            else return "";
        case "date":
            return data ? (0, $fJ4T4.FormatDate)(new Date(value), {
                year: "numeric",
                month: "2-digit",
                day: "2-digit"
            }) : "";
        case "staffMember":
        case "project":
            return value;
        case "time":
            return data ? (0, $i0shw.FormatTime)(new Date(value)) : "";
        default:
            return (_Formatter$column$col = (0, $azaaH.default)[(_column$columnDef$met2 = column.columnDef.meta) === null || _column$columnDef$met2 === void 0 ? void 0 : _column$columnDef$met2.type](value)) !== null && _Formatter$column$col !== void 0 ? _Formatter$column$col : value;
    }
};

});


parcelRegister("8tQ2D", function(module, exports) {

$parcel$export(module.exports, "RevenueForecastOverheadTable", function () { return $e0a0ae8f52bb409d$export$3aeb272eadc84e63; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $aYyI4 = parcelRequire("aYyI4");

var $aaosT = parcelRequire("aaosT");

var $khCHn = parcelRequire("khCHn");

var $27lKj = parcelRequire("27lKj");
parcelRequire("iaSLm");
var $4hBm1 = parcelRequire("4hBm1");

var $O2UPo = parcelRequire("O2UPo");

var $Yha9m = parcelRequire("Yha9m");
const $e0a0ae8f52bb409d$export$3aeb272eadc84e63 = ()=>{
    const generateColumnDef = (0, $khCHn.createGenerateColumnDef)({
        onHideColumn: ()=>null
    });
    const overheadExpenses = (0, $27lKj.useOverheadExpenses)();
    const dateRange = (0, $27lKj.useDateRange)();
    const months = (0, $jbmdS.useMemo)(()=>dateRange[0] && dateRange[1] ? (0, $4hBm1.eachMonthOfInterval)({
            start: (0, $4hBm1.parse)(dateRange[0], "yyyy-MM-dd", new Date()),
            end: (0, $4hBm1.parse)(dateRange[1], "yyyy-MM-dd", new Date())
        }) : [], [
        dateRange
    ]);
    const tableData = (0, $jbmdS.useMemo)(()=>{
        if (!Array.isArray(overheadExpenses)) return [];
        return overheadExpenses.map((expense)=>({
                id: expense.id,
                name: expense.name,
                label: expense.name,
                total: Object.entries(expense).filter(([key])=>key.match(/^\d{4}-\d{2}$/)).reduce((sum, [_, value])=>{
                    const numValue = typeof value === "string" ? parseFloat(value) : value;
                    return sum + (numValue || 0);
                }, 0),
                ...months.reduce((acc, month)=>{
                    const monthKey = (0, $4hBm1.format)(month, "yyyy-MM");
                    const value = expense[monthKey];
                    acc[monthKey] = typeof value === "string" ? parseFloat(value) : value || 0;
                    return acc;
                }, {})
            }));
    }, [
        overheadExpenses,
        months
    ]);
    const columns = (0, $jbmdS.useMemo)(()=>[
            generateColumnDef({
                key: "name",
                title: "Expense Name",
                type: "text",
                size: 200
            }),
            generateColumnDef({
                key: "total",
                title: "Total",
                type: "currency",
                size: 120,
                aggregationFn: "none"
            }),
            ...months.map((month)=>generateColumnDef({
                    key: (0, $4hBm1.format)(month, "yyyy-MM"),
                    title: (0, $4hBm1.format)(month, "MMM yy"),
                    type: "currency",
                    aggregationFn: "sum",
                    size: 120,
                    cellClassName: (row)=>{
                        const isPastMonth = (0, $4hBm1.format)(month, "yyyy-MM") < (0, $4hBm1.format)(new Date(), "yyyy-MM");
                        return (0, $Yha9m.cn)(isPastMonth && "bg-diagonal-pattern");
                    }
                }))
        ], [
        months
    ]);
    const visibleColumns = (0, $jbmdS.useMemo)(()=>[
            "name",
            "total",
            ...months.map((month)=>(0, $4hBm1.format)(month, "yyyy-MM"))
        ], [
        months
    ]);
    const { table: table } = (0, $aaosT.useDataTable)({
        data: tableData,
        columns: columns,
        visibleColumns: visibleColumns,
        sortingFns: {
            sortingTextFn: $O2UPo.sortingTextFn,
            sortingDateFn: $O2UPo.sortingDateFn
        }
    });
    if (!tableData.length) return null;
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "mt-8",
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("h2", {
                className: "text-xl font-semibold mb-4 pl-4",
                children: "Overhead Expenses"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $aYyI4.DataTable), {
                table: table,
                showTotals: true,
                className: "w-full"
            })
        ]
    });
};
var $e0a0ae8f52bb409d$export$2e2bcd8739ae039 = $e0a0ae8f52bb409d$export$3aeb272eadc84e63;

});

parcelRegister("eTG48", function(module, exports) {

$parcel$export(module.exports, "RevenueForecastStaffTable", function () { return $43e621aba0b41e59$export$7abe61df7998780b; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $aYyI4 = parcelRequire("aYyI4");

var $aaosT = parcelRequire("aaosT");

var $khCHn = parcelRequire("khCHn");

var $27lKj = parcelRequire("27lKj");
parcelRequire("iaSLm");
var $4hBm1 = parcelRequire("4hBm1");

var $O2UPo = parcelRequire("O2UPo");

var $Yha9m = parcelRequire("Yha9m");
const $43e621aba0b41e59$export$7abe61df7998780b = ()=>{
    const generateColumnDef = (0, $khCHn.createGenerateColumnDef)({
        onHideColumn: ()=>null
    });
    const staffExpenses = (0, $27lKj.useStaffExpenses)();
    const dateRange = (0, $27lKj.useDateRange)();
    const months = (0, $jbmdS.useMemo)(()=>dateRange[0] && dateRange[1] ? (0, $4hBm1.eachMonthOfInterval)({
            start: (0, $4hBm1.parse)(dateRange[0], "yyyy-MM-dd", new Date()),
            end: (0, $4hBm1.parse)(dateRange[1], "yyyy-MM-dd", new Date())
        }) : [], [
        dateRange
    ]);
    const tableData = (0, $jbmdS.useMemo)(()=>{
        if (!staffExpenses || !Array.isArray(staffExpenses) || !staffExpenses.length) return [];
        return staffExpenses.map((staff)=>{
            if (!staff || !staff.id || !staff.name) return null;
            return {
                id: staff.id,
                name: staff.name,
                label: staff.name,
                total: Object.entries(staff).filter(([key])=>key.match(/^\d{4}-\d{2}$/)).reduce((sum, [_, value])=>{
                    const numValue = typeof value === "string" ? parseFloat(value) : value;
                    return sum + (numValue || 0);
                }, 0),
                ...months.reduce((acc, month)=>{
                    const monthKey = (0, $4hBm1.format)(month, "yyyy-MM");
                    const value = staff[monthKey];
                    acc[monthKey] = typeof value === "string" ? parseFloat(value) : value || 0;
                    return acc;
                }, {})
            };
        }).filter(Boolean).sort((a, b)=>a.name.localeCompare(b.name));
    }, [
        staffExpenses,
        months
    ]);
    const columns = (0, $jbmdS.useMemo)(()=>[
            generateColumnDef({
                key: "name",
                title: "Staff Member",
                type: "text",
                size: 200
            }),
            generateColumnDef({
                key: "total",
                title: "Total",
                type: "currency",
                size: 120,
                aggregationFn: "sum"
            }),
            ...months.map((month)=>generateColumnDef({
                    key: (0, $4hBm1.format)(month, "yyyy-MM"),
                    title: (0, $4hBm1.format)(month, "MMM yy"),
                    type: "currency",
                    aggregationFn: "sum",
                    size: 120,
                    cellClassName: (row)=>{
                        const isPastMonth = (0, $4hBm1.format)(month, "yyyy-MM") < (0, $4hBm1.format)(new Date(), "yyyy-MM");
                        return (0, $Yha9m.cn)(isPastMonth && "bg-diagonal-pattern");
                    }
                }))
        ], [
        months
    ]);
    const visibleColumns = (0, $jbmdS.useMemo)(()=>[
            "name",
            "total",
            ...months.map((month)=>(0, $4hBm1.format)(month, "yyyy-MM"))
        ], [
        months
    ]);
    const { table: table } = (0, $aaosT.useDataTable)({
        data: tableData,
        columns: columns,
        visibleColumns: visibleColumns,
        groups: {
            enabled: false,
            columns: [],
            leafRowLabel: "Staff Member"
        },
        sortingFns: {
            sortingTextFn: $O2UPo.sortingTextFn,
            sortingDateFn: $O2UPo.sortingDateFn
        }
    });
    if (!tableData.length) return null;
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "mt-8",
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("h2", {
                className: "text-xl font-semibold mb-4 pl-4",
                children: "Staff Expenses"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $aYyI4.DataTable), {
                table: table,
                showTotals: true,
                className: "w-full"
            })
        ]
    });
};
var $43e621aba0b41e59$export$2e2bcd8739ae039 = $43e621aba0b41e59$export$7abe61df7998780b;

});

parcelRegister("kvIkY", function(module, exports) {

$parcel$export(module.exports, "RevenueForecastChart", function () { return $d53a88f178dadb9d$export$3a73bd04a9b42981; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $aYonL = parcelRequire("aYonL");
var $6YJY0 = parcelRequire("6YJY0");
var $id8ax = parcelRequire("id8ax");
var $eGOJx = parcelRequire("eGOJx");
var $hbTlI = parcelRequire("hbTlI");

var $97vSR = parcelRequire("97vSR");

var $27lKj = parcelRequire("27lKj");
parcelRequire("iaSLm");
var $4hBm1 = parcelRequire("4hBm1");

var $12o9H = parcelRequire("12o9H");

var $Yha9m = parcelRequire("Yha9m");
const $d53a88f178dadb9d$export$3a73bd04a9b42981 = ()=>{
    const projectData = (0, $27lKj.useData)();
    const dateRange = (0, $27lKj.useDateRange)();
    const overheadExpenses = (0, $27lKj.useOverheadExpenses)();
    const staffExpenses = (0, $27lKj.useStaffExpenses)();
    const chartData = (0, $jbmdS.useMemo)(()=>{
        if (!(projectData !== null && projectData !== void 0 && projectData.length) || !dateRange[0] || !dateRange[1]) return [];
        const months = (0, $4hBm1.eachMonthOfInterval)({
            start: (0, $4hBm1.parse)(dateRange[0], "yyyy-MM-dd", new Date()),
            end: (0, $4hBm1.parse)(dateRange[1], "yyyy-MM-dd", new Date())
        });
        const thisMonthKey = (0, $4hBm1.format)(new Date(), "yyyy-MM");
        return months.map((month)=>{
            const monthKey = (0, $4hBm1.format)(month, "yyyy-MM");
            const monthLabel = (0, $4hBm1.format)(month, "MMM yy");
            const totalRevenue = projectData.reduce((total, statusGroup)=>{
                const projected = statusGroup[`${monthKey}-P`] || 0;
                const actual = statusGroup[`${monthKey}-A`] || 0;
                if (monthKey < thisMonthKey) return total + actual;
                else return total + projected;
                return total + Math.max(actual, projected);
            }, 0);
            const totalExpenses = (overheadExpenses || []).reduce((total, overheadExpense)=>{
                return total + (overheadExpense[`${monthKey}`] || 0);
            }, 0) + (staffExpenses || []).reduce((total, staffExpense)=>{
                return total + (staffExpense[`${monthKey}`] || 0);
            }, 0);
            return {
                name: monthLabel,
                revenue: totalRevenue,
                expenses: totalExpenses
            };
        });
    }, [
        projectData,
        dateRange
    ]);
    const chartConfig = {
        revenue: {
            label: "Revenue",
            color: "hsl(var(--primary))"
        },
        expenses: {
            label: "Expenses",
            color: "hsl(var(--destructive))"
        }
    };
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $97vSR.ChartContainer), {
        config: chartConfig,
        className: "h-[300px] w-full",
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $6YJY0.AreaChart), {
            data: chartData,
            margin: {
                top: 10,
                right: 30,
                left: 20,
                bottom: 20
            },
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsxs)("defs", {
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("filter", {
                            id: "dotShadow",
                            x: "-50%",
                            y: "-50%",
                            width: "200%",
                            height: "200%",
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)("feDropShadow", {
                                dx: "0",
                                dy: "1",
                                stdDeviation: "2",
                                floodOpacity: "0.3"
                            })
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("linearGradient", {
                            id: "gradientRevenue",
                            x1: "0",
                            y1: "0",
                            x2: "0",
                            y2: "1",
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("stop", {
                                    offset: "5%",
                                    stopColor: "hsl(var(--primary))",
                                    stopOpacity: 0.75
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)("stop", {
                                    offset: "95%",
                                    stopColor: "hsl(var(--primary))",
                                    stopOpacity: 0.3
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("linearGradient", {
                            id: "gradientExpenses",
                            x1: "0",
                            y1: "0",
                            x2: "0",
                            y2: "1",
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("stop", {
                                    offset: "5%",
                                    stopColor: "hsl(var(--destructive))",
                                    stopOpacity: 0.75
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)("stop", {
                                    offset: "95%",
                                    stopColor: "hsl(var(--destructive))",
                                    stopOpacity: 0.1
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $eGOJx.XAxis), {
                    dataKey: "name",
                    tickLine: false,
                    tickMargin: 20,
                    fontSize: "0.8rem",
                    axisLine: false
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hbTlI.YAxis), {
                    axisLine: false,
                    tickLine: false,
                    tickMargin: 20,
                    fontSize: "0.8rem",
                    tickFormatter: (value)=>new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            notation: "compact"
                        }).format(value)
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $id8ax.CartesianGrid), {
                    strokeOpacity: 0.25,
                    strokeWidth: 0.5,
                    stroke: "hsl(var(--card-foreground))"
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $97vSR.ChartTooltip), {
                    content: ({ payload: payload, className: className })=>{
                        var _payload$, _payload$$payload, _payload$2, _payload$2$payload, _payload$3, _payload$3$payload;
                        const revenue = ((_payload$ = payload[0]) === null || _payload$ === void 0 ? void 0 : (_payload$$payload = _payload$.payload) === null || _payload$$payload === void 0 ? void 0 : _payload$$payload.revenue) || 0;
                        const expenses = ((_payload$2 = payload[0]) === null || _payload$2 === void 0 ? void 0 : (_payload$2$payload = _payload$2.payload) === null || _payload$2$payload === void 0 ? void 0 : _payload$2$payload.expenses) || 0;
                        const profit = revenue - expenses;
                        const profitMargin = revenue > 0 ? profit / revenue * 100 : 0;
                        return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            className: (0, $Yha9m.cn)("grid min-w-[8rem] items-start gap-1.5 rounded-lg border border-border/50 bg-background px-2.5 py-1.5 text-xs shadow-xl", className),
                            children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        className: "font-medium mb-1",
                                        children: (_payload$3 = payload[0]) === null || _payload$3 === void 0 ? void 0 : (_payload$3$payload = _payload$3.payload) === null || _payload$3$payload === void 0 ? void 0 : _payload$3$payload.name
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                        className: (0, $Yha9m.cn)(profit < 0 && "text-red-500"),
                                        children: [
                                            /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                                className: "mr-2",
                                                children: "Profit:"
                                            }),
                                            /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                                                children: [
                                                    (0, $12o9H.FormatCurrency)(profit, {
                                                        decimals: 0
                                                    }),
                                                    " ",
                                                    "(",
                                                    profitMargin.toFixed(1),
                                                    "%)"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                            className: "flex items-center",
                                            children: [
                                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                    className: "h-2 w-2 shrink-0 rounded-[2px] mr-2",
                                                    style: {
                                                        backgroundColor: "hsl(var(--primary))"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                                    className: "mr-2",
                                                    children: "Revenue:"
                                                }),
                                                /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                                    children: (0, $12o9H.FormatCurrency)(revenue, {
                                                        decimals: 0
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                            className: "flex items-center",
                                            children: [
                                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                    className: "h-2 w-2 shrink-0 rounded-[2px] mr-2",
                                                    style: {
                                                        backgroundColor: "hsl(var(--destructive))"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                                    className: "mr-2",
                                                    children: "Expenses:"
                                                }),
                                                /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                                    children: (0, $12o9H.FormatCurrency)(expenses, {
                                                        decimals: 0
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        });
                    }
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $97vSR.ChartLegend), {
                    content: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $97vSR.ChartLegendContent), {})
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $aYonL.Area), {
                    type: "monotone",
                    dataKey: "revenue",
                    stroke: "hsl(var(--primary))",
                    // fill="none"
                    fill: "url(#gradientRevenue)",
                    strokeWidth: 2,
                    activeDot: {
                        stroke: "#fbfaf9",
                        strokeWidth: 1,
                        r: 4,
                        filter: "url(#dotShadow)"
                    }
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $aYonL.Area), {
                    type: "monotone",
                    dataKey: "expenses",
                    stroke: "hsl(var(--destructive))",
                    // fill="none"
                    fill: "url(#gradientExpenses)",
                    strokeWidth: 2,
                    activeDot: {
                        stroke: "#fbfaf9",
                        strokeWidth: 1,
                        r: 4,
                        filter: "url(#dotShadow)"
                    }
                })
            ]
        })
    });
};
var $d53a88f178dadb9d$export$2e2bcd8739ae039 = $d53a88f178dadb9d$export$3a73bd04a9b42981;

});
parcelRegister("aYonL", function(module, exports) {

$parcel$export(module.exports, "Area", function () { return $7fd26bcda5cbebd8$export$ea1a111407f37557; });

var $jbmdS = parcelRequire("jbmdS");

var $dWgPS = parcelRequire("dWgPS");

var $bBmgp = parcelRequire("bBmgp");

var $i99FY = parcelRequire("i99FY");

var $9HZtv = parcelRequire("9HZtv");

var $aVX0M = parcelRequire("aVX0M");

var $BWzdJ = parcelRequire("BWzdJ");

var $dzN0r = parcelRequire("dzN0r");

var $1JINr = parcelRequire("1JINr");

var $6eKmI = parcelRequire("6eKmI");

var $bIYfh = parcelRequire("bIYfh");

var $1sHYq = parcelRequire("1sHYq");

var $9wZNv = parcelRequire("9wZNv");

var $1gmrG = parcelRequire("1gmrG");

var $fiDSf = parcelRequire("fiDSf");

var $f06D9 = parcelRequire("f06D9");
var $7fd26bcda5cbebd8$var$_excluded = [
    "layout",
    "type",
    "stroke",
    "connectNulls",
    "isRange",
    "ref"
], $7fd26bcda5cbebd8$var$_excluded2 = [
    "key"
];
var $7fd26bcda5cbebd8$var$_Area;
function $7fd26bcda5cbebd8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7fd26bcda5cbebd8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7fd26bcda5cbebd8$var$_typeof(o);
}
function $7fd26bcda5cbebd8$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $7fd26bcda5cbebd8$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $7fd26bcda5cbebd8$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $7fd26bcda5cbebd8$var$_extends() {
    $7fd26bcda5cbebd8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7fd26bcda5cbebd8$var$_extends.apply(this, arguments);
}
function $7fd26bcda5cbebd8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7fd26bcda5cbebd8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7fd26bcda5cbebd8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $7fd26bcda5cbebd8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7fd26bcda5cbebd8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7fd26bcda5cbebd8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7fd26bcda5cbebd8$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $7fd26bcda5cbebd8$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $7fd26bcda5cbebd8$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7fd26bcda5cbebd8$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7fd26bcda5cbebd8$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $7fd26bcda5cbebd8$var$_callSuper(t, o, e) {
    return o = $7fd26bcda5cbebd8$var$_getPrototypeOf(o), $7fd26bcda5cbebd8$var$_possibleConstructorReturn(t, $7fd26bcda5cbebd8$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $7fd26bcda5cbebd8$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $7fd26bcda5cbebd8$var$_possibleConstructorReturn(self, call) {
    if (call && ($7fd26bcda5cbebd8$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $7fd26bcda5cbebd8$var$_assertThisInitialized(self);
}
function $7fd26bcda5cbebd8$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $7fd26bcda5cbebd8$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7fd26bcda5cbebd8$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $7fd26bcda5cbebd8$var$_getPrototypeOf(o) {
    $7fd26bcda5cbebd8$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $7fd26bcda5cbebd8$var$_getPrototypeOf(o);
}
function $7fd26bcda5cbebd8$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $7fd26bcda5cbebd8$var$_setPrototypeOf(subClass, superClass);
}
function $7fd26bcda5cbebd8$var$_setPrototypeOf(o, p) {
    $7fd26bcda5cbebd8$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7fd26bcda5cbebd8$var$_setPrototypeOf(o, p);
}
function $7fd26bcda5cbebd8$var$_defineProperty(obj, key, value) {
    key = $7fd26bcda5cbebd8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7fd26bcda5cbebd8$var$_toPropertyKey(t) {
    var i = $7fd26bcda5cbebd8$var$_toPrimitive(t, "string");
    return "symbol" == $7fd26bcda5cbebd8$var$_typeof(i) ? i : i + "";
}
function $7fd26bcda5cbebd8$var$_toPrimitive(t, r) {
    if ("object" != $7fd26bcda5cbebd8$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $7fd26bcda5cbebd8$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $7fd26bcda5cbebd8$export$ea1a111407f37557 = /*#__PURE__*/ function(_PureComponent) {
    function Area() {
        var _this;
        $7fd26bcda5cbebd8$var$_classCallCheck(this, Area);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $7fd26bcda5cbebd8$var$_callSuper(this, Area, [].concat(args));
        $7fd26bcda5cbebd8$var$_defineProperty(_this, "state", {
            isAnimationFinished: true
        });
        $7fd26bcda5cbebd8$var$_defineProperty(_this, "id", (0, $1gmrG.uniqueId)("recharts-area-"));
        $7fd26bcda5cbebd8$var$_defineProperty(_this, "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if ((0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(onAnimationEnd)) onAnimationEnd();
        });
        $7fd26bcda5cbebd8$var$_defineProperty(_this, "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if ((0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(onAnimationStart)) onAnimationStart();
        });
        return _this;
    }
    $7fd26bcda5cbebd8$var$_inherits(Area, _PureComponent);
    return $7fd26bcda5cbebd8$var$_createClass(Area, [
        {
            key: "renderDots",
            value: function renderDots(needClip, clipDot, clipPathId) {
                var isAnimationActive = this.props.isAnimationActive;
                var isAnimationFinished = this.state.isAnimationFinished;
                if (isAnimationActive && !isAnimationFinished) return null;
                var _this$props = this.props, dot = _this$props.dot, points = _this$props.points, dataKey = _this$props.dataKey;
                var areaProps = (0, $f06D9.filterProps)(this.props, false);
                var customDotProps = (0, $f06D9.filterProps)(dot, true);
                var dots = points.map(function(entry, i) {
                    var dotProps = $7fd26bcda5cbebd8$var$_objectSpread($7fd26bcda5cbebd8$var$_objectSpread($7fd26bcda5cbebd8$var$_objectSpread({
                        key: "dot-".concat(i),
                        r: 3
                    }, areaProps), customDotProps), {}, {
                        index: i,
                        cx: entry.x,
                        cy: entry.y,
                        dataKey: dataKey,
                        value: entry.value,
                        payload: entry.payload,
                        points: points
                    });
                    return Area.renderDotItem(dot, dotProps);
                });
                var dotsProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipDot ? "" : "dots-").concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $bIYfh.Layer), $7fd26bcda5cbebd8$var$_extends({
                    className: "recharts-area-dots"
                }, dotsProps), dots);
            }
        },
        {
            key: "renderHorizontalRect",
            value: function renderHorizontalRect(alpha) {
                var _this$props2 = this.props, baseLine = _this$props2.baseLine, points = _this$props2.points, strokeWidth = _this$props2.strokeWidth;
                var startX = points[0].x;
                var endX = points[points.length - 1].x;
                var width = alpha * Math.abs(startX - endX);
                var maxY = (0, (/*@__PURE__*/$parcel$interopDefault($9HZtv)))(points.map(function(entry) {
                    return entry.y || 0;
                }));
                if ((0, $1gmrG.isNumber)(baseLine) && typeof baseLine === "number") maxY = Math.max(baseLine, maxY);
                else if (baseLine && Array.isArray(baseLine) && baseLine.length) maxY = Math.max((0, (/*@__PURE__*/$parcel$interopDefault($9HZtv)))(baseLine.map(function(entry) {
                    return entry.y || 0;
                })), maxY);
                if ((0, $1gmrG.isNumber)(maxY)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("rect", {
                    x: startX < endX ? startX : startX - width,
                    y: 0,
                    width: width,
                    height: Math.floor(maxY + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1))
                });
                return null;
            }
        },
        {
            key: "renderVerticalRect",
            value: function renderVerticalRect(alpha) {
                var _this$props3 = this.props, baseLine = _this$props3.baseLine, points = _this$props3.points, strokeWidth = _this$props3.strokeWidth;
                var startY = points[0].y;
                var endY = points[points.length - 1].y;
                var height = alpha * Math.abs(startY - endY);
                var maxX = (0, (/*@__PURE__*/$parcel$interopDefault($9HZtv)))(points.map(function(entry) {
                    return entry.x || 0;
                }));
                if ((0, $1gmrG.isNumber)(baseLine) && typeof baseLine === "number") maxX = Math.max(baseLine, maxX);
                else if (baseLine && Array.isArray(baseLine) && baseLine.length) maxX = Math.max((0, (/*@__PURE__*/$parcel$interopDefault($9HZtv)))(baseLine.map(function(entry) {
                    return entry.x || 0;
                })), maxX);
                if ((0, $1gmrG.isNumber)(maxX)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("rect", {
                    x: 0,
                    y: startY < endY ? startY : startY - height,
                    width: maxX + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1),
                    height: Math.floor(height)
                });
                return null;
            }
        },
        {
            key: "renderClipRect",
            value: function renderClipRect(alpha) {
                var layout = this.props.layout;
                if (layout === "vertical") return this.renderVerticalRect(alpha);
                return this.renderHorizontalRect(alpha);
            }
        },
        {
            key: "renderAreaStatically",
            value: function renderAreaStatically(points, baseLine, needClip, clipPathId) {
                var _this$props4 = this.props, layout = _this$props4.layout, type = _this$props4.type, stroke = _this$props4.stroke, connectNulls = _this$props4.connectNulls, isRange = _this$props4.isRange, ref = _this$props4.ref, others = $7fd26bcda5cbebd8$var$_objectWithoutProperties(_this$props4, $7fd26bcda5cbebd8$var$_excluded);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $bIYfh.Layer), {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $1JINr.Curve), $7fd26bcda5cbebd8$var$_extends({}, (0, $f06D9.filterProps)(others, true), {
                    points: points,
                    connectNulls: connectNulls,
                    type: type,
                    baseLine: baseLine,
                    layout: layout,
                    stroke: "none",
                    className: "recharts-area-area"
                })), stroke !== "none" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $1JINr.Curve), $7fd26bcda5cbebd8$var$_extends({}, (0, $f06D9.filterProps)(this.props, false), {
                    className: "recharts-area-curve",
                    layout: layout,
                    type: type,
                    connectNulls: connectNulls,
                    fill: "none",
                    points: points
                })), stroke !== "none" && isRange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $1JINr.Curve), $7fd26bcda5cbebd8$var$_extends({}, (0, $f06D9.filterProps)(this.props, false), {
                    className: "recharts-area-curve",
                    layout: layout,
                    type: type,
                    connectNulls: connectNulls,
                    fill: "none",
                    points: baseLine
                })));
            }
        },
        {
            key: "renderAreaWithAnimation",
            value: function renderAreaWithAnimation(needClip, clipPathId) {
                var _this2 = this;
                var _this$props5 = this.props, points = _this$props5.points, baseLine = _this$props5.baseLine, isAnimationActive = _this$props5.isAnimationActive, animationBegin = _this$props5.animationBegin, animationDuration = _this$props5.animationDuration, animationEasing = _this$props5.animationEasing, animationId = _this$props5.animationId;
                var _this$state = this.state, prevPoints = _this$state.prevPoints, prevBaseLine = _this$state.prevBaseLine;
                // const clipPathId = isNil(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $bBmgp.default), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "area-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    if (prevPoints) {
                        var prevPointsDiffFactor = prevPoints.length / points.length;
                        // update animtaion
                        var stepPoints = points.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevPoints[prevPointIndex]) {
                                var prev = prevPoints[prevPointIndex];
                                var interpolatorX = (0, $1gmrG.interpolateNumber)(prev.x, entry.x);
                                var interpolatorY = (0, $1gmrG.interpolateNumber)(prev.y, entry.y);
                                return $7fd26bcda5cbebd8$var$_objectSpread($7fd26bcda5cbebd8$var$_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            return entry;
                        });
                        var stepBaseLine;
                        if ((0, $1gmrG.isNumber)(baseLine) && typeof baseLine === "number") {
                            var interpolator = (0, $1gmrG.interpolateNumber)(prevBaseLine, baseLine);
                            stepBaseLine = interpolator(t);
                        } else if ((0, (/*@__PURE__*/$parcel$interopDefault($aVX0M)))(baseLine) || (0, (/*@__PURE__*/$parcel$interopDefault($BWzdJ)))(baseLine)) {
                            var _interpolator = (0, $1gmrG.interpolateNumber)(prevBaseLine, 0);
                            stepBaseLine = _interpolator(t);
                        } else stepBaseLine = baseLine.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevBaseLine[prevPointIndex]) {
                                var prev = prevBaseLine[prevPointIndex];
                                var interpolatorX = (0, $1gmrG.interpolateNumber)(prev.x, entry.x);
                                var interpolatorY = (0, $1gmrG.interpolateNumber)(prev.y, entry.y);
                                return $7fd26bcda5cbebd8$var$_objectSpread($7fd26bcda5cbebd8$var$_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            return entry;
                        });
                        return _this2.renderAreaStatically(stepPoints, stepBaseLine, needClip, clipPathId);
                    }
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $bIYfh.Layer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("clipPath", {
                        id: "animationClipPath-".concat(clipPathId)
                    }, _this2.renderClipRect(t))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $bIYfh.Layer), {
                        clipPath: "url(#animationClipPath-".concat(clipPathId, ")")
                    }, _this2.renderAreaStatically(points, baseLine, needClip, clipPathId)));
                });
            }
        },
        {
            key: "renderArea",
            value: function renderArea(needClip, clipPathId) {
                var _this$props6 = this.props, points = _this$props6.points, baseLine = _this$props6.baseLine, isAnimationActive = _this$props6.isAnimationActive;
                var _this$state2 = this.state, prevPoints = _this$state2.prevPoints, prevBaseLine = _this$state2.prevBaseLine, totalLength = _this$state2.totalLength;
                if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, (/*@__PURE__*/$parcel$interopDefault($dzN0r)))(prevPoints, points) || !(0, (/*@__PURE__*/$parcel$interopDefault($dzN0r)))(prevBaseLine, baseLine))) return this.renderAreaWithAnimation(needClip, clipPathId);
                return this.renderAreaStatically(points, baseLine, needClip, clipPathId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _filterProps;
                var _this$props7 = this.props, hide = _this$props7.hide, dot = _this$props7.dot, points = _this$props7.points, className = _this$props7.className, top = _this$props7.top, left = _this$props7.left, xAxis = _this$props7.xAxis, yAxis = _this$props7.yAxis, width = _this$props7.width, height = _this$props7.height, isAnimationActive = _this$props7.isAnimationActive, id = _this$props7.id;
                if (hide || !points || !points.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var hasSinglePoint = points.length === 1;
                var layerClass = (0, $dWgPS.default)("recharts-area", className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($aVX0M)))(id) ? this.id : id;
                var _ref2 = (_filterProps = (0, $f06D9.filterProps)(dot, false)) !== null && _filterProps !== void 0 ? _filterProps : {
                    r: 3,
                    strokeWidth: 2
                }, _ref2$r = _ref2.r, r = _ref2$r === void 0 ? 3 : _ref2$r, _ref2$strokeWidth = _ref2.strokeWidth, strokeWidth = _ref2$strokeWidth === void 0 ? 2 : _ref2$strokeWidth;
                var _ref3 = (0, $f06D9.hasClipDot)(dot) ? dot : {}, _ref3$clipDot = _ref3.clipDot, clipDot = _ref3$clipDot === void 0 ? true : _ref3$clipDot;
                var dotSize = r * 2 + strokeWidth;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $bIYfh.Layer), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                })), !clipDot && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("clipPath", {
                    id: "clipPath-dots-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("rect", {
                    x: left - dotSize / 2,
                    y: top - dotSize / 2,
                    width: width + dotSize,
                    height: height + dotSize
                }))) : null, !hasSinglePoint ? this.renderArea(needClip, clipPathId) : null, (dot || hasSinglePoint) && this.renderDots(needClip, clipDot, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $1sHYq.LabelList).renderCallByParent(this.props, points));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curPoints: nextProps.points,
                    curBaseLine: nextProps.baseLine,
                    prevPoints: prevState.curPoints,
                    prevBaseLine: prevState.curBaseLine
                };
                if (nextProps.points !== prevState.curPoints || nextProps.baseLine !== prevState.curBaseLine) return {
                    curPoints: nextProps.points,
                    curBaseLine: nextProps.baseLine
                };
                return null;
            }
        }
    ]);
}((0, $jbmdS.PureComponent));
$7fd26bcda5cbebd8$var$_Area = $7fd26bcda5cbebd8$export$ea1a111407f37557;
$7fd26bcda5cbebd8$var$_defineProperty($7fd26bcda5cbebd8$export$ea1a111407f37557, "displayName", "Area");
$7fd26bcda5cbebd8$var$_defineProperty($7fd26bcda5cbebd8$export$ea1a111407f37557, "defaultProps", {
    stroke: "#3182bd",
    fill: "#3182bd",
    fillOpacity: 0.6,
    xAxisId: 0,
    yAxisId: 0,
    legendType: "line",
    connectNulls: false,
    // points of area
    points: [],
    dot: false,
    activeDot: true,
    hide: false,
    isAnimationActive: !(0, $9wZNv.Global).isSsr,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: "ease"
});
$7fd26bcda5cbebd8$var$_defineProperty($7fd26bcda5cbebd8$export$ea1a111407f37557, "getBaseValue", function(props, item, xAxis, yAxis) {
    var layout = props.layout, chartBaseValue = props.baseValue;
    var itemBaseValue = item.props.baseValue;
    // The baseValue can be defined both on the AreaChart as well as on the Area.
    // The value for the item takes precedence.
    var baseValue = itemBaseValue !== null && itemBaseValue !== void 0 ? itemBaseValue : chartBaseValue;
    if ((0, $1gmrG.isNumber)(baseValue) && typeof baseValue === "number") return baseValue;
    var numericAxis = layout === "horizontal" ? yAxis : xAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === "number") {
        var domainMax = Math.max(domain[0], domain[1]);
        var domainMin = Math.min(domain[0], domain[1]);
        if (baseValue === "dataMin") return domainMin;
        if (baseValue === "dataMax") return domainMax;
        return domainMax < 0 ? domainMax : Math.max(Math.min(domain[0], domain[1]), 0);
    }
    if (baseValue === "dataMin") return domain[0];
    if (baseValue === "dataMax") return domain[1];
    return domain[0];
});
$7fd26bcda5cbebd8$var$_defineProperty($7fd26bcda5cbebd8$export$ea1a111407f37557, "getComposedData", function(_ref4) {
    var props = _ref4.props, item = _ref4.item, xAxis = _ref4.xAxis, yAxis = _ref4.yAxis, xAxisTicks = _ref4.xAxisTicks, yAxisTicks = _ref4.yAxisTicks, bandSize = _ref4.bandSize, dataKey = _ref4.dataKey, stackedData = _ref4.stackedData, dataStartIndex = _ref4.dataStartIndex, displayedData = _ref4.displayedData, offset = _ref4.offset;
    var layout = props.layout;
    var hasStack = stackedData && stackedData.length;
    var baseValue = $7fd26bcda5cbebd8$var$_Area.getBaseValue(props, item, xAxis, yAxis);
    var isHorizontalLayout = layout === "horizontal";
    var isRange = false;
    var points = displayedData.map(function(entry, index) {
        var value;
        if (hasStack) value = stackedData[dataStartIndex + index];
        else {
            value = (0, $fiDSf.getValueByDataKey)(entry, dataKey);
            if (!Array.isArray(value)) value = [
                baseValue,
                value
            ];
            else isRange = true;
        }
        var isBreakPoint = value[1] == null || hasStack && (0, $fiDSf.getValueByDataKey)(entry, dataKey) == null;
        if (isHorizontalLayout) return {
            x: (0, $fiDSf.getCateCoordinateOfLine)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            y: isBreakPoint ? null : yAxis.scale(value[1]),
            value: value,
            payload: entry
        };
        return {
            x: isBreakPoint ? null : xAxis.scale(value[1]),
            y: (0, $fiDSf.getCateCoordinateOfLine)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            value: value,
            payload: entry
        };
    });
    var baseLine;
    if (hasStack || isRange) baseLine = points.map(function(entry) {
        var x = Array.isArray(entry.value) ? entry.value[0] : null;
        if (isHorizontalLayout) return {
            x: entry.x,
            y: x != null && entry.y != null ? yAxis.scale(x) : null
        };
        return {
            x: x != null ? xAxis.scale(x) : null,
            y: entry.y
        };
    });
    else baseLine = isHorizontalLayout ? yAxis.scale(baseValue) : xAxis.scale(baseValue);
    return $7fd26bcda5cbebd8$var$_objectSpread({
        points: points,
        baseLine: baseLine,
        layout: layout,
        isRange: isRange
    }, offset);
});
$7fd26bcda5cbebd8$var$_defineProperty($7fd26bcda5cbebd8$export$ea1a111407f37557, "renderDotItem", function(option, props) {
    var dotItem;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).isValidElement(option)) dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(option)) dotItem = option(props);
    else {
        var className = (0, $dWgPS.default)("recharts-area-dot", typeof option !== "boolean" ? option.className : "");
        var key = props.key, rest = $7fd26bcda5cbebd8$var$_objectWithoutProperties(props, $7fd26bcda5cbebd8$var$_excluded2);
        dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $6eKmI.Dot), $7fd26bcda5cbebd8$var$_extends({}, rest, {
            key: key,
            className: className
        }));
    }
    return dotItem;
});

});
parcelRegister("bBmgp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87246b7f101cee92$export$2e2bcd8739ae039; });

var $i4kTt = parcelRequire("i4kTt");


var $87246b7f101cee92$export$2e2bcd8739ae039 = (0, $i4kTt.default);

});
parcelRegister("i4kTt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d278cecbeec48ebe$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");

var $2MXkj = parcelRequire("2MXkj");

var $6RKnm = parcelRequire("6RKnm");

var $9zUCG = parcelRequire("9zUCG");

var $fXBh7 = parcelRequire("fXBh7");

var $jbtQ4 = parcelRequire("jbtQ4");

var $c1ThR = parcelRequire("c1ThR");
function $d278cecbeec48ebe$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d278cecbeec48ebe$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d278cecbeec48ebe$var$_typeof(o);
}
var $d278cecbeec48ebe$var$_excluded = [
    "children",
    "begin",
    "duration",
    "attributeName",
    "easing",
    "isActive",
    "steps",
    "from",
    "to",
    "canBegin",
    "onAnimationEnd",
    "shouldReAnimate",
    "onAnimationReStart"
];
function $d278cecbeec48ebe$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d278cecbeec48ebe$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d278cecbeec48ebe$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d278cecbeec48ebe$var$_toConsumableArray(arr) {
    return $d278cecbeec48ebe$var$_arrayWithoutHoles(arr) || $d278cecbeec48ebe$var$_iterableToArray(arr) || $d278cecbeec48ebe$var$_unsupportedIterableToArray(arr) || $d278cecbeec48ebe$var$_nonIterableSpread();
}
function $d278cecbeec48ebe$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d278cecbeec48ebe$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d278cecbeec48ebe$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d278cecbeec48ebe$var$_arrayLikeToArray(o, minLen);
}
function $d278cecbeec48ebe$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $d278cecbeec48ebe$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $d278cecbeec48ebe$var$_arrayLikeToArray(arr);
}
function $d278cecbeec48ebe$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d278cecbeec48ebe$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d278cecbeec48ebe$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d278cecbeec48ebe$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d278cecbeec48ebe$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d278cecbeec48ebe$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d278cecbeec48ebe$var$_defineProperty(obj, key, value) {
    key = $d278cecbeec48ebe$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d278cecbeec48ebe$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d278cecbeec48ebe$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $d278cecbeec48ebe$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $d278cecbeec48ebe$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d278cecbeec48ebe$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d278cecbeec48ebe$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $d278cecbeec48ebe$var$_toPropertyKey(arg) {
    var key = $d278cecbeec48ebe$var$_toPrimitive(arg, "string");
    return $d278cecbeec48ebe$var$_typeof(key) === "symbol" ? key : String(key);
}
function $d278cecbeec48ebe$var$_toPrimitive(input, hint) {
    if ($d278cecbeec48ebe$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($d278cecbeec48ebe$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $d278cecbeec48ebe$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $d278cecbeec48ebe$var$_setPrototypeOf(subClass, superClass);
}
function $d278cecbeec48ebe$var$_setPrototypeOf(o, p) {
    $d278cecbeec48ebe$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d278cecbeec48ebe$var$_setPrototypeOf(o, p);
}
function $d278cecbeec48ebe$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d278cecbeec48ebe$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $d278cecbeec48ebe$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $d278cecbeec48ebe$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $d278cecbeec48ebe$var$_possibleConstructorReturn(this, result);
    };
}
function $d278cecbeec48ebe$var$_possibleConstructorReturn(self, call) {
    if (call && ($d278cecbeec48ebe$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $d278cecbeec48ebe$var$_assertThisInitialized(self);
}
function $d278cecbeec48ebe$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $d278cecbeec48ebe$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $d278cecbeec48ebe$var$_getPrototypeOf(o) {
    $d278cecbeec48ebe$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d278cecbeec48ebe$var$_getPrototypeOf(o);
}
var $d278cecbeec48ebe$var$Animate = /*#__PURE__*/ function(_PureComponent) {
    $d278cecbeec48ebe$var$_inherits(Animate, _PureComponent);
    var _super = $d278cecbeec48ebe$var$_createSuper(Animate);
    function Animate(props, context) {
        var _this;
        $d278cecbeec48ebe$var$_classCallCheck(this, Animate);
        _this = _super.call(this, props, context);
        var _this$props = _this.props, isActive = _this$props.isActive, attributeName = _this$props.attributeName, from = _this$props.from, to = _this$props.to, steps = _this$props.steps, children = _this$props.children, duration = _this$props.duration;
        _this.handleStyleChange = _this.handleStyleChange.bind($d278cecbeec48ebe$var$_assertThisInitialized(_this));
        _this.changeStyle = _this.changeStyle.bind($d278cecbeec48ebe$var$_assertThisInitialized(_this));
        if (!isActive || duration <= 0) {
            _this.state = {
                style: {}
            };
            // if children is a function and animation is not active, set style to 'to'
            if (typeof children === "function") _this.state = {
                style: to
            };
            return $d278cecbeec48ebe$var$_possibleConstructorReturn(_this);
        }
        if (steps && steps.length) _this.state = {
            style: steps[0].style
        };
        else if (from) {
            if (typeof children === "function") {
                _this.state = {
                    style: from
                };
                return $d278cecbeec48ebe$var$_possibleConstructorReturn(_this);
            }
            _this.state = {
                style: attributeName ? $d278cecbeec48ebe$var$_defineProperty({}, attributeName, from) : from
            };
        } else _this.state = {
            style: {}
        };
        return _this;
    }
    $d278cecbeec48ebe$var$_createClass(Animate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props2 = this.props, isActive = _this$props2.isActive, canBegin = _this$props2.canBegin;
                this.mounted = true;
                if (!isActive || !canBegin) return;
                this.runAnimation(this.props);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props3 = this.props, isActive = _this$props3.isActive, canBegin = _this$props3.canBegin, attributeName = _this$props3.attributeName, shouldReAnimate = _this$props3.shouldReAnimate, to = _this$props3.to, currentFrom = _this$props3.from;
                var style = this.state.style;
                if (!canBegin) return;
                if (!isActive) {
                    var newState = {
                        style: attributeName ? $d278cecbeec48ebe$var$_defineProperty({}, attributeName, to) : to
                    };
                    if (this.state && style) {
                        if (attributeName && style[attributeName] !== to || !attributeName && style !== to) // eslint-disable-next-line react/no-did-update-set-state
                        this.setState(newState);
                    }
                    return;
                }
                if ((0, $6RKnm.deepEqual)(prevProps.to, to) && prevProps.canBegin && prevProps.isActive) return;
                var isTriggered = !prevProps.canBegin || !prevProps.isActive;
                if (this.manager) this.manager.stop();
                if (this.stopJSAnimation) this.stopJSAnimation();
                var from = isTriggered || shouldReAnimate ? currentFrom : prevProps.to;
                if (this.state && style) {
                    var _newState = {
                        style: attributeName ? $d278cecbeec48ebe$var$_defineProperty({}, attributeName, from) : from
                    };
                    if (attributeName && style[attributeName] !== from || !attributeName && style !== from) // eslint-disable-next-line react/no-did-update-set-state
                    this.setState(_newState);
                }
                this.runAnimation($d278cecbeec48ebe$var$_objectSpread($d278cecbeec48ebe$var$_objectSpread({}, this.props), {}, {
                    from: from,
                    begin: 0
                }));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mounted = false;
                var onAnimationEnd = this.props.onAnimationEnd;
                if (this.unSubscribe) this.unSubscribe();
                if (this.manager) {
                    this.manager.stop();
                    this.manager = null;
                }
                if (this.stopJSAnimation) this.stopJSAnimation();
                if (onAnimationEnd) onAnimationEnd();
            }
        },
        {
            key: "handleStyleChange",
            value: function handleStyleChange(style) {
                this.changeStyle(style);
            }
        },
        {
            key: "changeStyle",
            value: function changeStyle(style) {
                if (this.mounted) this.setState({
                    style: style
                });
            }
        },
        {
            key: "runJSAnimation",
            value: function runJSAnimation(props) {
                var _this2 = this;
                var from = props.from, to = props.to, duration = props.duration, easing = props.easing, begin = props.begin, onAnimationEnd = props.onAnimationEnd, onAnimationStart = props.onAnimationStart;
                var startAnimation = (0, $jbtQ4.default)(from, to, (0, $fXBh7.configEasing)(easing), duration, this.changeStyle);
                var finalStartAnimation = function finalStartAnimation() {
                    _this2.stopJSAnimation = startAnimation();
                };
                this.manager.start([
                    onAnimationStart,
                    begin,
                    finalStartAnimation,
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "runStepAnimation",
            value: function runStepAnimation(props) {
                var _this3 = this;
                var steps = props.steps, begin = props.begin, onAnimationStart = props.onAnimationStart;
                var _steps$ = steps[0], initialStyle = _steps$.style, _steps$$duration = _steps$.duration, initialTime = _steps$$duration === void 0 ? 0 : _steps$$duration;
                var addStyle = function addStyle(sequence, nextItem, index) {
                    if (index === 0) return sequence;
                    var duration = nextItem.duration, _nextItem$easing = nextItem.easing, easing = _nextItem$easing === void 0 ? "ease" : _nextItem$easing, style = nextItem.style, nextProperties = nextItem.properties, onAnimationEnd = nextItem.onAnimationEnd;
                    var preItem = index > 0 ? steps[index - 1] : nextItem;
                    var properties = nextProperties || Object.keys(style);
                    if (typeof easing === "function" || easing === "spring") return [].concat($d278cecbeec48ebe$var$_toConsumableArray(sequence), [
                        _this3.runJSAnimation.bind(_this3, {
                            from: preItem.style,
                            to: style,
                            duration: duration,
                            easing: easing
                        }),
                        duration
                    ]);
                    var transition = (0, $c1ThR.getTransitionVal)(properties, duration, easing);
                    var newStyle = $d278cecbeec48ebe$var$_objectSpread($d278cecbeec48ebe$var$_objectSpread($d278cecbeec48ebe$var$_objectSpread({}, preItem.style), style), {}, {
                        transition: transition
                    });
                    return [].concat($d278cecbeec48ebe$var$_toConsumableArray(sequence), [
                        newStyle,
                        duration,
                        onAnimationEnd
                    ]).filter((0, $c1ThR.identity));
                };
                return this.manager.start([
                    onAnimationStart
                ].concat($d278cecbeec48ebe$var$_toConsumableArray(steps.reduce(addStyle, [
                    initialStyle,
                    Math.max(initialTime, begin)
                ])), [
                    props.onAnimationEnd
                ]));
            }
        },
        {
            key: "runAnimation",
            value: function runAnimation(props) {
                if (!this.manager) this.manager = (0, $9zUCG.default)();
                var begin = props.begin, duration = props.duration, attributeName = props.attributeName, propsTo = props.to, easing = props.easing, onAnimationStart = props.onAnimationStart, onAnimationEnd = props.onAnimationEnd, steps = props.steps, children = props.children;
                var manager = this.manager;
                this.unSubscribe = manager.subscribe(this.handleStyleChange);
                if (typeof easing === "function" || typeof children === "function" || easing === "spring") {
                    this.runJSAnimation(props);
                    return;
                }
                if (steps.length > 1) {
                    this.runStepAnimation(props);
                    return;
                }
                var to = attributeName ? $d278cecbeec48ebe$var$_defineProperty({}, attributeName, propsTo) : propsTo;
                var transition = (0, $c1ThR.getTransitionVal)(Object.keys(to), duration, easing);
                manager.start([
                    onAnimationStart,
                    begin,
                    $d278cecbeec48ebe$var$_objectSpread($d278cecbeec48ebe$var$_objectSpread({}, to), {}, {
                        transition: transition
                    }),
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, children = _this$props4.children, begin = _this$props4.begin, duration = _this$props4.duration, attributeName = _this$props4.attributeName, easing = _this$props4.easing, isActive = _this$props4.isActive, steps = _this$props4.steps, from = _this$props4.from, to = _this$props4.to, canBegin = _this$props4.canBegin, onAnimationEnd = _this$props4.onAnimationEnd, shouldReAnimate = _this$props4.shouldReAnimate, onAnimationReStart = _this$props4.onAnimationReStart, others = $d278cecbeec48ebe$var$_objectWithoutProperties(_this$props4, $d278cecbeec48ebe$var$_excluded);
                var count = (0, $jbmdS.Children).count(children);
                // eslint-disable-next-line react/destructuring-assignment
                var stateStyle = this.state.style;
                if (typeof children === "function") return children(stateStyle);
                if (!isActive || count === 0 || duration <= 0) return children;
                var cloneContainer = function cloneContainer(container) {
                    var _container$props = container.props, _container$props$styl = _container$props.style, style = _container$props$styl === void 0 ? {} : _container$props$styl, className = _container$props.className;
                    var res = /*#__PURE__*/ (0, $jbmdS.cloneElement)(container, $d278cecbeec48ebe$var$_objectSpread($d278cecbeec48ebe$var$_objectSpread({}, others), {}, {
                        style: $d278cecbeec48ebe$var$_objectSpread($d278cecbeec48ebe$var$_objectSpread({}, style), stateStyle),
                        className: className
                    }));
                    return res;
                };
                if (count === 1) return cloneContainer((0, $jbmdS.Children).only(children));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("div", null, (0, $jbmdS.Children).map(children, function(child) {
                    return cloneContainer(child);
                }));
            }
        }
    ]);
    return Animate;
}((0, $jbmdS.PureComponent));
$d278cecbeec48ebe$var$Animate.displayName = "Animate";
$d278cecbeec48ebe$var$Animate.defaultProps = {
    begin: 0,
    duration: 1000,
    from: "",
    to: "",
    attributeName: "",
    easing: "ease",
    isActive: true,
    canBegin: true,
    steps: [],
    onAnimationEnd: function onAnimationEnd() {},
    onAnimationStart: function onAnimationStart() {}
};
$d278cecbeec48ebe$var$Animate.propTypes = {
    from: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).string
    ]),
    to: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).string
    ]),
    attributeName: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).string,
    // animation duration
    duration: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).number,
    begin: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).number,
    easing: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).func
    ]),
    steps: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).shape({
        duration: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).number.isRequired,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).object.isRequired,
        easing: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).oneOf([
                "ease",
                "ease-in",
                "ease-out",
                "ease-in-out",
                "linear"
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).func
        ]),
        // transition css properties(dash case), optional
        properties: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).arrayOf("string"),
        onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).func
    })),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).func
    ]),
    isActive: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).bool,
    canBegin: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).bool,
    onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).func,
    // decide if it should reanimate with initial from style when props change
    shouldReAnimate: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).bool,
    onAnimationStart: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).func,
    onAnimationReStart: (0, (/*@__PURE__*/$parcel$interopDefault($2MXkj))).func
};
var $d278cecbeec48ebe$export$2e2bcd8739ae039 = $d278cecbeec48ebe$var$Animate;

});
parcelRegister("6RKnm", function(module, exports) {
(function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    "use strict";
    var getOwnPropertyNames = Object.getOwnPropertyNames, getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /**
     * Combine two comparators into a single comparators.
     */ function combineComparators(comparatorA, comparatorB) {
        return function isEqual(a, b, state) {
            return comparatorA(a, b, state) && comparatorB(a, b, state);
        };
    }
    /**
     * Wrap the provided `areItemsEqual` method to manage the circular state, allowing
     * for circular references to be safely included in the comparison without creating
     * stack overflows.
     */ function createIsCircular(areItemsEqual) {
        return function isCircular(a, b, state) {
            if (!a || !b || typeof a !== "object" || typeof b !== "object") return areItemsEqual(a, b, state);
            var cache = state.cache;
            var cachedA = cache.get(a);
            var cachedB = cache.get(b);
            if (cachedA && cachedB) return cachedA === b && cachedB === a;
            cache.set(a, b);
            cache.set(b, a);
            var result = areItemsEqual(a, b, state);
            cache.delete(a);
            cache.delete(b);
            return result;
        };
    }
    /**
     * Get the properties to strictly examine, which include both own properties that are
     * not enumerable and symbol properties.
     */ function getStrictProperties(object) {
        return getOwnPropertyNames(object).concat(getOwnPropertySymbols(object));
    }
    /**
     * Whether the object contains the property passed as an own property.
     */ var hasOwn = Object.hasOwn || function(object, property) {
        return hasOwnProperty.call(object, property);
    };
    /**
     * Whether the values passed are strictly equal or both NaN.
     */ function sameValueZeroEqual(a, b) {
        return a === b || !a && !b && a !== a && b !== b;
    }
    var PREACT_VNODE = "__v";
    var PREACT_OWNER = "__o";
    var REACT_OWNER = "_owner";
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, keys = Object.keys;
    /**
     * Whether the arrays are equal in value.
     */ function areArraysEqual(a, b, state) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (!state.equals(a[index], b[index], index, index, a, b, state)) return false;
        }
        return true;
    }
    /**
     * Whether the dates passed are equal in value.
     */ function areDatesEqual(a, b) {
        return sameValueZeroEqual(a.getTime(), b.getTime());
    }
    /**
     * Whether the errors passed are equal in value.
     */ function areErrorsEqual(a, b) {
        return a.name === b.name && a.message === b.message && a.cause === b.cause && a.stack === b.stack;
    }
    /**
     * Whether the functions passed are equal in value.
     */ function areFunctionsEqual(a, b) {
        return a === b;
    }
    /**
     * Whether the `Map`s are equal in value.
     */ function areMapsEqual(a, b, state) {
        var size = a.size;
        if (size !== b.size) return false;
        if (!size) return true;
        var matchedIndices = new Array(size);
        var aIterable = a.entries();
        var aResult;
        var bResult;
        var index = 0;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.entries();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                if (matchedIndices[matchIndex]) {
                    matchIndex++;
                    continue;
                }
                var aEntry = aResult.value;
                var bEntry = bResult.value;
                if (state.equals(aEntry[0], bEntry[0], index, matchIndex, a, b, state) && state.equals(aEntry[1], bEntry[1], aEntry[0], bEntry[0], a, b, state)) {
                    hasMatch = matchedIndices[matchIndex] = true;
                    break;
                }
                matchIndex++;
            }
            if (!hasMatch) return false;
            index++;
        }
        return true;
    }
    /**
     * Whether the numbers are equal in value.
     */ var areNumbersEqual = sameValueZeroEqual;
    /**
     * Whether the objects are equal in value.
     */ function areObjectsEqual(a, b, state) {
        var properties = keys(a);
        var index = properties.length;
        if (keys(b).length !== index) return false;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            if (!isPropertyEqual(a, b, state, properties[index])) return false;
        }
        return true;
    }
    /**
     * Whether the objects are equal in value with strict property checking.
     */ function areObjectsEqualStrict(a, b, state) {
        var properties = getStrictProperties(a);
        var index = properties.length;
        if (getStrictProperties(b).length !== index) return false;
        var property;
        var descriptorA;
        var descriptorB;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            property = properties[index];
            if (!isPropertyEqual(a, b, state, property)) return false;
            descriptorA = getOwnPropertyDescriptor(a, property);
            descriptorB = getOwnPropertyDescriptor(b, property);
            if ((descriptorA || descriptorB) && (!descriptorA || !descriptorB || descriptorA.configurable !== descriptorB.configurable || descriptorA.enumerable !== descriptorB.enumerable || descriptorA.writable !== descriptorB.writable)) return false;
        }
        return true;
    }
    /**
     * Whether the primitive wrappers passed are equal in value.
     */ function arePrimitiveWrappersEqual(a, b) {
        return sameValueZeroEqual(a.valueOf(), b.valueOf());
    }
    /**
     * Whether the regexps passed are equal in value.
     */ function areRegExpsEqual(a, b) {
        return a.source === b.source && a.flags === b.flags;
    }
    /**
     * Whether the `Set`s are equal in value.
     */ function areSetsEqual(a, b, state) {
        var size = a.size;
        if (size !== b.size) return false;
        if (!size) return true;
        var matchedIndices = new Array(size);
        var aIterable = a.values();
        var aResult;
        var bResult;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.values();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                if (!matchedIndices[matchIndex] && state.equals(aResult.value, bResult.value, aResult.value, bResult.value, a, b, state)) {
                    hasMatch = matchedIndices[matchIndex] = true;
                    break;
                }
                matchIndex++;
            }
            if (!hasMatch) return false;
        }
        return true;
    }
    /**
     * Whether the TypedArray instances are equal in value.
     */ function areTypedArraysEqual(a, b) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (a[index] !== b[index]) return false;
        }
        return true;
    }
    /**
     * Whether the URL instances are equal in value.
     */ function areUrlsEqual(a, b) {
        return a.hostname === b.hostname && a.pathname === b.pathname && a.protocol === b.protocol && a.port === b.port && a.hash === b.hash && a.username === b.username && a.password === b.password;
    }
    function isPropertyEqual(a, b, state, property) {
        if ((property === REACT_OWNER || property === PREACT_OWNER || property === PREACT_VNODE) && (a.$$typeof || b.$$typeof)) return true;
        return hasOwn(b, property) && state.equals(a[property], b[property], property, property, a, b, state);
    }
    var ARGUMENTS_TAG = "[object Arguments]";
    var BOOLEAN_TAG = "[object Boolean]";
    var DATE_TAG = "[object Date]";
    var ERROR_TAG = "[object Error]";
    var MAP_TAG = "[object Map]";
    var NUMBER_TAG = "[object Number]";
    var OBJECT_TAG = "[object Object]";
    var REG_EXP_TAG = "[object RegExp]";
    var SET_TAG = "[object Set]";
    var STRING_TAG = "[object String]";
    var URL_TAG = "[object URL]";
    var isArray = Array.isArray;
    var isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView ? ArrayBuffer.isView : null;
    var assign = Object.assign;
    var getTag = Object.prototype.toString.call.bind(Object.prototype.toString);
    /**
     * Create a comparator method based on the type-specific equality comparators passed.
     */ function createEqualityComparator(_a) {
        var areArraysEqual = _a.areArraysEqual, areDatesEqual = _a.areDatesEqual, areErrorsEqual = _a.areErrorsEqual, areFunctionsEqual = _a.areFunctionsEqual, areMapsEqual = _a.areMapsEqual, areNumbersEqual = _a.areNumbersEqual, areObjectsEqual = _a.areObjectsEqual, arePrimitiveWrappersEqual = _a.arePrimitiveWrappersEqual, areRegExpsEqual = _a.areRegExpsEqual, areSetsEqual = _a.areSetsEqual, areTypedArraysEqual = _a.areTypedArraysEqual, areUrlsEqual = _a.areUrlsEqual;
        /**
         * compare the value of the two objects and return true if they are equivalent in values
         */ return function comparator(a, b, state) {
            // If the items are strictly equal, no need to do a value comparison.
            if (a === b) return true;
            // If either of the items are nullish and fail the strictly equal check
            // above, then they must be unequal.
            if (a == null || b == null) return false;
            var type = typeof a;
            if (type !== typeof b) return false;
            if (type !== "object") {
                if (type === "number") return areNumbersEqual(a, b, state);
                if (type === "function") return areFunctionsEqual(a, b, state);
                // If a primitive value that is not strictly equal, it must be unequal.
                return false;
            }
            var constructor = a.constructor;
            // Checks are listed in order of commonality of use-case:
            //   1. Common complex object types (plain object, array)
            //   2. Common data values (date, regexp)
            //   3. Less-common complex object types (map, set)
            //   4. Less-common data values (promise, primitive wrappers)
            // Inherently this is both subjective and assumptive, however
            // when reviewing comparable libraries in the wild this order
            // appears to be generally consistent.
            // Constructors should match, otherwise there is potential for false positives
            // between class and subclass or custom object and POJO.
            if (constructor !== b.constructor) return false;
            // `isPlainObject` only checks against the object's own realm. Cross-realm
            // comparisons are rare, and will be handled in the ultimate fallback, so
            // we can avoid capturing the string tag.
            if (constructor === Object) return areObjectsEqual(a, b, state);
            // `isArray()` works on subclasses and is cross-realm, so we can avoid capturing
            // the string tag or doing an `instanceof` check.
            if (isArray(a)) return areArraysEqual(a, b, state);
            // `isTypedArray()` works on all possible TypedArray classes, so we can avoid
            // capturing the string tag or comparing against all possible constructors.
            if (isTypedArray != null && isTypedArray(a)) return areTypedArraysEqual(a, b, state);
            // Try to fast-path equality checks for other complex object types in the
            // same realm to avoid capturing the string tag. Strict equality is used
            // instead of `instanceof` because it is more performant for the common
            // use-case. If someone is subclassing a native class, it will be handled
            // with the string tag comparison.
            if (constructor === Date) return areDatesEqual(a, b, state);
            if (constructor === RegExp) return areRegExpsEqual(a, b, state);
            if (constructor === Map) return areMapsEqual(a, b, state);
            if (constructor === Set) return areSetsEqual(a, b, state);
            // Since this is a custom object, capture the string tag to determing its type.
            // This is reasonably performant in modern environments like v8 and SpiderMonkey.
            var tag = getTag(a);
            if (tag === DATE_TAG) return areDatesEqual(a, b, state);
            // For RegExp, the properties are not enumerable, and therefore will give false positives if
            // tested like a standard object.
            if (tag === REG_EXP_TAG) return areRegExpsEqual(a, b, state);
            if (tag === MAP_TAG) return areMapsEqual(a, b, state);
            if (tag === SET_TAG) return areSetsEqual(a, b, state);
            if (tag === OBJECT_TAG) // The exception for value comparison is custom `Promise`-like class instances. These should
            // be treated the same as standard `Promise` objects, which means strict equality, and if
            // it reaches this point then that strict equality comparison has already failed.
            return typeof a.then !== "function" && typeof b.then !== "function" && areObjectsEqual(a, b, state);
            // If a URL tag, it should be tested explicitly. Like RegExp, the properties are not
            // enumerable, and therefore will give false positives if tested like a standard object.
            if (tag === URL_TAG) return areUrlsEqual(a, b, state);
            // If an error tag, it should be tested explicitly. Like RegExp, the properties are not
            // enumerable, and therefore will give false positives if tested like a standard object.
            if (tag === ERROR_TAG) return areErrorsEqual(a, b, state);
            // If an arguments tag, it should be treated as a standard object.
            if (tag === ARGUMENTS_TAG) return areObjectsEqual(a, b, state);
            // As the penultimate fallback, check if the values passed are primitive wrappers. This
            // is very rare in modern JS, which is why it is deprioritized compared to all other object
            // types.
            if (tag === BOOLEAN_TAG || tag === NUMBER_TAG || tag === STRING_TAG) return arePrimitiveWrappersEqual(a, b, state);
            // If not matching any tags that require a specific type of comparison, then we hard-code false because
            // the only thing remaining is strict equality, which has already been compared. This is for a few reasons:
            //   - Certain types that cannot be introspected (e.g., `WeakMap`). For these types, this is the only
            //     comparison that can be made.
            //   - For types that can be introspected, but rarely have requirements to be compared
            //     (`ArrayBuffer`, `DataView`, etc.), the cost is avoided to prioritize the common
            //     use-cases (may be included in a future release, if requested enough).
            //   - For types that can be introspected but do not have an objective definition of what
            //     equality is (`Error`, etc.), the subjective decision is to be conservative and strictly compare.
            // In all cases, these decisions should be reevaluated based on changes to the language and
            // common development practices.
            return false;
        };
    }
    /**
     * Create the configuration object used for building comparators.
     */ function createEqualityComparatorConfig(_a) {
        var circular = _a.circular, createCustomConfig = _a.createCustomConfig, strict = _a.strict;
        var config = {
            areArraysEqual: strict ? areObjectsEqualStrict : areArraysEqual,
            areDatesEqual: areDatesEqual,
            areErrorsEqual: areErrorsEqual,
            areFunctionsEqual: areFunctionsEqual,
            areMapsEqual: strict ? combineComparators(areMapsEqual, areObjectsEqualStrict) : areMapsEqual,
            areNumbersEqual: areNumbersEqual,
            areObjectsEqual: strict ? areObjectsEqualStrict : areObjectsEqual,
            arePrimitiveWrappersEqual: arePrimitiveWrappersEqual,
            areRegExpsEqual: areRegExpsEqual,
            areSetsEqual: strict ? combineComparators(areSetsEqual, areObjectsEqualStrict) : areSetsEqual,
            areTypedArraysEqual: strict ? areObjectsEqualStrict : areTypedArraysEqual,
            areUrlsEqual: areUrlsEqual
        };
        if (createCustomConfig) config = assign({}, config, createCustomConfig(config));
        if (circular) {
            var areArraysEqual$1 = createIsCircular(config.areArraysEqual);
            var areMapsEqual$1 = createIsCircular(config.areMapsEqual);
            var areObjectsEqual$1 = createIsCircular(config.areObjectsEqual);
            var areSetsEqual$1 = createIsCircular(config.areSetsEqual);
            config = assign({}, config, {
                areArraysEqual: areArraysEqual$1,
                areMapsEqual: areMapsEqual$1,
                areObjectsEqual: areObjectsEqual$1,
                areSetsEqual: areSetsEqual$1
            });
        }
        return config;
    }
    /**
     * Default equality comparator pass-through, used as the standard `isEqual` creator for
     * use inside the built comparator.
     */ function createInternalEqualityComparator(compare) {
        return function(a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, state) {
            return compare(a, b, state);
        };
    }
    /**
     * Create the `isEqual` function used by the consuming application.
     */ function createIsEqual(_a) {
        var circular = _a.circular, comparator = _a.comparator, createState = _a.createState, equals = _a.equals, strict = _a.strict;
        if (createState) return function isEqual(a, b) {
            var _a = createState(), _b = _a.cache, cache = _b === void 0 ? circular ? new WeakMap() : undefined : _b, meta = _a.meta;
            return comparator(a, b, {
                cache: cache,
                equals: equals,
                meta: meta,
                strict: strict
            });
        };
        if (circular) return function isEqual(a, b) {
            return comparator(a, b, {
                cache: new WeakMap(),
                equals: equals,
                meta: undefined,
                strict: strict
            });
        };
        var state = {
            cache: undefined,
            equals: equals,
            meta: undefined,
            strict: strict
        };
        return function isEqual(a, b) {
            return comparator(a, b, state);
        };
    }
    /**
     * Whether the items passed are deeply-equal in value.
     */ var deepEqual = createCustomEqual();
    /**
     * Whether the items passed are deeply-equal in value based on strict comparison.
     */ var strictDeepEqual = createCustomEqual({
        strict: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references.
     */ var circularDeepEqual = createCustomEqual({
        circular: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularDeepEqual = createCustomEqual({
        circular: true,
        strict: true
    });
    /**
     * Whether the items passed are shallowly-equal in value.
     */ var shallowEqual = createCustomEqual({
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value based on strict comparison
     */ var strictShallowEqual = createCustomEqual({
        strict: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references.
     */ var circularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        },
        strict: true
    });
    /**
     * Create a custom equality comparison method.
     *
     * This can be done to create very targeted comparisons in extreme hot-path scenarios
     * where the standard methods are not performant enough, but can also be used to provide
     * support for legacy environments that do not support expected features like
     * `RegExp.prototype.flags` out of the box.
     */ function createCustomEqual(options) {
        if (options === void 0) options = {};
        var _a = options.circular, circular = _a === void 0 ? false : _a, createCustomInternalComparator = options.createInternalComparator, createState = options.createState, _b = options.strict, strict = _b === void 0 ? false : _b;
        var config = createEqualityComparatorConfig(options);
        var comparator = createEqualityComparator(config);
        var equals = createCustomInternalComparator ? createCustomInternalComparator(comparator) : createInternalEqualityComparator(comparator);
        return createIsEqual({
            circular: circular,
            comparator: comparator,
            createState: createState,
            equals: equals,
            strict: strict
        });
    }
    exports1.circularDeepEqual = circularDeepEqual;
    exports1.circularShallowEqual = circularShallowEqual;
    exports1.createCustomEqual = createCustomEqual;
    exports1.deepEqual = deepEqual;
    exports1.sameValueZeroEqual = sameValueZeroEqual;
    exports1.shallowEqual = shallowEqual;
    exports1.strictCircularDeepEqual = strictCircularDeepEqual;
    exports1.strictCircularShallowEqual = strictCircularShallowEqual;
    exports1.strictDeepEqual = strictDeepEqual;
    exports1.strictShallowEqual = strictShallowEqual;
});

});

parcelRegister("9zUCG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f934e1001d79303$export$2e2bcd8739ae039; });

var $3p0tP = parcelRequire("3p0tP");
function $6f934e1001d79303$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6f934e1001d79303$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6f934e1001d79303$var$_typeof(o);
}
function $6f934e1001d79303$var$_toArray(arr) {
    return $6f934e1001d79303$var$_arrayWithHoles(arr) || $6f934e1001d79303$var$_iterableToArray(arr) || $6f934e1001d79303$var$_unsupportedIterableToArray(arr) || $6f934e1001d79303$var$_nonIterableRest();
}
function $6f934e1001d79303$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6f934e1001d79303$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6f934e1001d79303$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6f934e1001d79303$var$_arrayLikeToArray(o, minLen);
}
function $6f934e1001d79303$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6f934e1001d79303$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $6f934e1001d79303$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $6f934e1001d79303$export$2e2bcd8739ae039() {
    var currStyle = {};
    var handleChange = function handleChange() {
        return null;
    };
    var shouldStop = false;
    var setStyle = function setStyle(_style) {
        if (shouldStop) return;
        if (Array.isArray(_style)) {
            if (!_style.length) return;
            var styles = _style;
            var _styles = $6f934e1001d79303$var$_toArray(styles), curr = _styles[0], restStyles = _styles.slice(1);
            if (typeof curr === "number") {
                (0, $3p0tP.default)(setStyle.bind(null, restStyles), curr);
                return;
            }
            setStyle(curr);
            (0, $3p0tP.default)(setStyle.bind(null, restStyles));
            return;
        }
        if ($6f934e1001d79303$var$_typeof(_style) === "object") {
            currStyle = _style;
            handleChange(currStyle);
        }
        if (typeof _style === "function") _style();
    };
    return {
        stop: function stop() {
            shouldStop = true;
        },
        start: function start(style) {
            shouldStop = false;
            setStyle(style);
        },
        subscribe: function subscribe(_handleChange) {
            handleChange = _handleChange;
            return function() {
                handleChange = function handleChange() {
                    return null;
                };
            };
        }
    };
}

});
parcelRegister("3p0tP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27a4143c4762e73f$export$2e2bcd8739ae039; });
function $27a4143c4762e73f$var$safeRequestAnimationFrame(callback) {
    if (typeof requestAnimationFrame !== "undefined") requestAnimationFrame(callback);
}
function $27a4143c4762e73f$export$2e2bcd8739ae039(callback) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var currTime = -1;
    var shouldUpdate = function shouldUpdate(now) {
        if (currTime < 0) currTime = now;
        if (now - currTime > timeout) {
            callback(now);
            currTime = -1;
        } else $27a4143c4762e73f$var$safeRequestAnimationFrame(shouldUpdate);
    };
    requestAnimationFrame(shouldUpdate);
}

});


parcelRegister("fXBh7", function(module, exports) {

$parcel$export(module.exports, "configEasing", function () { return $b9e947c92d348ecc$export$e3e04925801e5434; });

var $c1ThR = parcelRequire("c1ThR");
function $b9e947c92d348ecc$var$_slicedToArray(arr, i) {
    return $b9e947c92d348ecc$var$_arrayWithHoles(arr) || $b9e947c92d348ecc$var$_iterableToArrayLimit(arr, i) || $b9e947c92d348ecc$var$_unsupportedIterableToArray(arr, i) || $b9e947c92d348ecc$var$_nonIterableRest();
}
function $b9e947c92d348ecc$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b9e947c92d348ecc$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $b9e947c92d348ecc$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $b9e947c92d348ecc$var$_toConsumableArray(arr) {
    return $b9e947c92d348ecc$var$_arrayWithoutHoles(arr) || $b9e947c92d348ecc$var$_iterableToArray(arr) || $b9e947c92d348ecc$var$_unsupportedIterableToArray(arr) || $b9e947c92d348ecc$var$_nonIterableSpread();
}
function $b9e947c92d348ecc$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b9e947c92d348ecc$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b9e947c92d348ecc$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b9e947c92d348ecc$var$_arrayLikeToArray(o, minLen);
}
function $b9e947c92d348ecc$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $b9e947c92d348ecc$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $b9e947c92d348ecc$var$_arrayLikeToArray(arr);
}
function $b9e947c92d348ecc$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $b9e947c92d348ecc$var$ACCURACY = 1e-4;
var $b9e947c92d348ecc$var$cubicBezierFactor = function cubicBezierFactor(c1, c2) {
    return [
        0,
        3 * c1,
        3 * c2 - 6 * c1,
        3 * c1 - 3 * c2 + 1
    ];
};
var $b9e947c92d348ecc$var$multyTime = function multyTime(params, t) {
    return params.map(function(param, i) {
        return param * Math.pow(t, i);
    }).reduce(function(pre, curr) {
        return pre + curr;
    });
};
var $b9e947c92d348ecc$var$cubicBezier = function cubicBezier(c1, c2) {
    return function(t) {
        var params = $b9e947c92d348ecc$var$cubicBezierFactor(c1, c2);
        return $b9e947c92d348ecc$var$multyTime(params, t);
    };
};
var $b9e947c92d348ecc$var$derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
    return function(t) {
        var params = $b9e947c92d348ecc$var$cubicBezierFactor(c1, c2);
        var newParams = [].concat($b9e947c92d348ecc$var$_toConsumableArray(params.map(function(param, i) {
            return param * i;
        }).slice(1)), [
            0
        ]);
        return $b9e947c92d348ecc$var$multyTime(newParams, t);
    };
};
var $b9e947c92d348ecc$export$56c51296f72f0592 = function configBezier() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var x1 = args[0], y1 = args[1], x2 = args[2], y2 = args[3];
    if (args.length === 1) switch(args[0]){
        case "linear":
            x1 = 0.0;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case "ease":
            x1 = 0.25;
            y1 = 0.1;
            x2 = 0.25;
            y2 = 1.0;
            break;
        case "ease-in":
            x1 = 0.42;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case "ease-out":
            x1 = 0.42;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        case "ease-in-out":
            x1 = 0.0;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        default:
            var easing = args[0].split("(");
            if (easing[0] === "cubic-bezier" && easing[1].split(")")[0].split(",").length === 4) {
                var _easing$1$split$0$spl = easing[1].split(")")[0].split(",").map(function(x) {
                    return parseFloat(x);
                });
                var _easing$1$split$0$spl2 = $b9e947c92d348ecc$var$_slicedToArray(_easing$1$split$0$spl, 4);
                x1 = _easing$1$split$0$spl2[0];
                y1 = _easing$1$split$0$spl2[1];
                x2 = _easing$1$split$0$spl2[2];
                y2 = _easing$1$split$0$spl2[3];
            } else (0, $c1ThR.warn)(false, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", args);
    }
    (0, $c1ThR.warn)([
        x1,
        x2,
        y1,
        y2
    ].every(function(num) {
        return typeof num === "number" && num >= 0 && num <= 1;
    }), "[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s", args);
    var curveX = $b9e947c92d348ecc$var$cubicBezier(x1, x2);
    var curveY = $b9e947c92d348ecc$var$cubicBezier(y1, y2);
    var derCurveX = $b9e947c92d348ecc$var$derivativeCubicBezier(x1, x2);
    var rangeValue = function rangeValue(value) {
        if (value > 1) return 1;
        if (value < 0) return 0;
        return value;
    };
    var bezier = function bezier(_t) {
        var t = _t > 1 ? 1 : _t;
        var x = t;
        for(var i = 0; i < 8; ++i){
            var evalT = curveX(x) - t;
            var derVal = derCurveX(x);
            if (Math.abs(evalT - t) < $b9e947c92d348ecc$var$ACCURACY || derVal < $b9e947c92d348ecc$var$ACCURACY) return curveY(x);
            x = rangeValue(x - evalT / derVal);
        }
        return curveY(x);
    };
    bezier.isStepper = false;
    return bezier;
};
var $b9e947c92d348ecc$export$12fc25daf62b865a = function configSpring() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _config$stiff = config.stiff, stiff = _config$stiff === void 0 ? 100 : _config$stiff, _config$damping = config.damping, damping = _config$damping === void 0 ? 8 : _config$damping, _config$dt = config.dt, dt = _config$dt === void 0 ? 17 : _config$dt;
    var stepper = function stepper(currX, destX, currV) {
        var FSpring = -(currX - destX) * stiff;
        var FDamping = currV * damping;
        var newV = currV + (FSpring - FDamping) * dt / 1000;
        var newX = currV * dt / 1000 + currX;
        if (Math.abs(newX - destX) < $b9e947c92d348ecc$var$ACCURACY && Math.abs(newV) < $b9e947c92d348ecc$var$ACCURACY) return [
            destX,
            0
        ];
        return [
            newX,
            newV
        ];
    };
    stepper.isStepper = true;
    stepper.dt = dt;
    return stepper;
};
var $b9e947c92d348ecc$export$e3e04925801e5434 = function configEasing() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    var easing = args[0];
    if (typeof easing === "string") switch(easing){
        case "ease":
        case "ease-in-out":
        case "ease-out":
        case "ease-in":
        case "linear":
            return $b9e947c92d348ecc$export$56c51296f72f0592(easing);
        case "spring":
            return $b9e947c92d348ecc$export$12fc25daf62b865a();
        default:
            if (easing.split("(")[0] === "cubic-bezier") return $b9e947c92d348ecc$export$56c51296f72f0592(easing);
            (0, $c1ThR.warn)(false, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", args);
    }
    if (typeof easing === "function") return easing;
    (0, $c1ThR.warn)(false, "[configEasing]: first argument type should be function or string, instead received %s", args);
    return null;
};

});
parcelRegister("c1ThR", function(module, exports) {

$parcel$export(module.exports, "getIntersectionKeys", function () { return $8c2076e5726574db$export$59e29973723da0b3; });
$parcel$export(module.exports, "identity", function () { return $8c2076e5726574db$export$f0954fd7d5368655; });
$parcel$export(module.exports, "mapObject", function () { return $8c2076e5726574db$export$d6051a0f7a227332; });
$parcel$export(module.exports, "getTransitionVal", function () { return $8c2076e5726574db$export$1594c78389ee3429; });
$parcel$export(module.exports, "warn", function () { return $8c2076e5726574db$export$c106dd0671a0fc2d; });
function $8c2076e5726574db$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8c2076e5726574db$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8c2076e5726574db$var$_typeof(o);
}
function $8c2076e5726574db$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8c2076e5726574db$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8c2076e5726574db$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8c2076e5726574db$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8c2076e5726574db$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8c2076e5726574db$var$_defineProperty(obj, key, value) {
    key = $8c2076e5726574db$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8c2076e5726574db$var$_toPropertyKey(arg) {
    var key = $8c2076e5726574db$var$_toPrimitive(arg, "string");
    return $8c2076e5726574db$var$_typeof(key) === "symbol" ? key : String(key);
}
function $8c2076e5726574db$var$_toPrimitive(input, hint) {
    if ($8c2076e5726574db$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($8c2076e5726574db$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $8c2076e5726574db$export$59e29973723da0b3 = function getIntersectionKeys(preObj, nextObj) {
    return [
        Object.keys(preObj),
        Object.keys(nextObj)
    ].reduce(function(a, b) {
        return a.filter(function(c) {
            return b.includes(c);
        });
    });
};
var $8c2076e5726574db$export$f0954fd7d5368655 = function identity(param) {
    return param;
};
var $8c2076e5726574db$export$51610fddbf64bc9d = function getDashCase(name) {
    return name.replace(/([A-Z])/g, function(v) {
        return "-".concat(v.toLowerCase());
    });
};
var $8c2076e5726574db$export$bef1f36f5486a6a3 = function log() {
    var _console;
    (_console = console).log.apply(_console, arguments);
};
var $8c2076e5726574db$export$1c9f709888824e05 = function debug(name) {
    return function(item) {
        $8c2076e5726574db$export$bef1f36f5486a6a3(name, item);
        return item;
    };
};
var $8c2076e5726574db$export$1dc45301cd23a8c7 = function debugf(tag, f) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var res = f.apply(void 0, args);
        var name = tag || f.name || "anonymous function";
        var argNames = "(".concat(args.map(JSON.stringify).join(", "), ")");
        $8c2076e5726574db$export$bef1f36f5486a6a3("".concat(name, ": ").concat(argNames, " => ").concat(JSON.stringify(res)));
        return res;
    };
};
var $8c2076e5726574db$export$d6051a0f7a227332 = function mapObject(fn, obj) {
    return Object.keys(obj).reduce(function(res, key) {
        return $8c2076e5726574db$var$_objectSpread($8c2076e5726574db$var$_objectSpread({}, res), {}, $8c2076e5726574db$var$_defineProperty({}, key, fn(key, obj[key])));
    }, {});
};
var $8c2076e5726574db$export$1594c78389ee3429 = function getTransitionVal(props, duration, easing) {
    return props.map(function(prop) {
        return "".concat($8c2076e5726574db$export$51610fddbf64bc9d(prop), " ").concat(duration, "ms ").concat(easing);
    }).join(",");
};
var $8c2076e5726574db$var$isDev = false;
var $8c2076e5726574db$export$c106dd0671a0fc2d = function warn(condition, format, a, b, c, d, e, f) {
    if ($8c2076e5726574db$var$isDev && typeof console !== "undefined" && console.warn) {
        if (format === undefined) console.warn("LogUtils requires an error message argument");
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var args = [
                    a,
                    b,
                    c,
                    d,
                    e,
                    f
                ];
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};

});


parcelRegister("jbtQ4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df7630cca8729f66$export$2e2bcd8739ae039; });

var $c1ThR = parcelRequire("c1ThR");
function $df7630cca8729f66$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $df7630cca8729f66$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $df7630cca8729f66$var$_typeof(o);
}
function $df7630cca8729f66$var$_toConsumableArray(arr) {
    return $df7630cca8729f66$var$_arrayWithoutHoles(arr) || $df7630cca8729f66$var$_iterableToArray(arr) || $df7630cca8729f66$var$_unsupportedIterableToArray(arr) || $df7630cca8729f66$var$_nonIterableSpread();
}
function $df7630cca8729f66$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $df7630cca8729f66$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $df7630cca8729f66$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $df7630cca8729f66$var$_arrayLikeToArray(arr);
}
function $df7630cca8729f66$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $df7630cca8729f66$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $df7630cca8729f66$var$ownKeys(Object(t), !0).forEach(function(r) {
            $df7630cca8729f66$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $df7630cca8729f66$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $df7630cca8729f66$var$_defineProperty(obj, key, value) {
    key = $df7630cca8729f66$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $df7630cca8729f66$var$_toPropertyKey(arg) {
    var key = $df7630cca8729f66$var$_toPrimitive(arg, "string");
    return $df7630cca8729f66$var$_typeof(key) === "symbol" ? key : String(key);
}
function $df7630cca8729f66$var$_toPrimitive(input, hint) {
    if ($df7630cca8729f66$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($df7630cca8729f66$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $df7630cca8729f66$var$_slicedToArray(arr, i) {
    return $df7630cca8729f66$var$_arrayWithHoles(arr) || $df7630cca8729f66$var$_iterableToArrayLimit(arr, i) || $df7630cca8729f66$var$_unsupportedIterableToArray(arr, i) || $df7630cca8729f66$var$_nonIterableRest();
}
function $df7630cca8729f66$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $df7630cca8729f66$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $df7630cca8729f66$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $df7630cca8729f66$var$_arrayLikeToArray(o, minLen);
}
function $df7630cca8729f66$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $df7630cca8729f66$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $df7630cca8729f66$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $df7630cca8729f66$var$alpha = function alpha(begin, end, k) {
    return begin + (end - begin) * k;
};
var $df7630cca8729f66$var$needContinue = function needContinue(_ref) {
    var from = _ref.from, to = _ref.to;
    return from !== to;
};
/*
 * @description: cal new from value and velocity in each stepper
 * @return: { [styleProperty]: { from, to, velocity } }
 */ var $df7630cca8729f66$var$calStepperVals = function calStepperVals(easing, preVals, steps) {
    var nextStepVals = (0, $c1ThR.mapObject)(function(key, val) {
        if ($df7630cca8729f66$var$needContinue(val)) {
            var _easing = easing(val.from, val.to, val.velocity), _easing2 = $df7630cca8729f66$var$_slicedToArray(_easing, 2), newX = _easing2[0], newV = _easing2[1];
            return $df7630cca8729f66$var$_objectSpread($df7630cca8729f66$var$_objectSpread({}, val), {}, {
                from: newX,
                velocity: newV
            });
        }
        return val;
    }, preVals);
    if (steps < 1) return (0, $c1ThR.mapObject)(function(key, val) {
        if ($df7630cca8729f66$var$needContinue(val)) return $df7630cca8729f66$var$_objectSpread($df7630cca8729f66$var$_objectSpread({}, val), {}, {
            velocity: $df7630cca8729f66$var$alpha(val.velocity, nextStepVals[key].velocity, steps),
            from: $df7630cca8729f66$var$alpha(val.from, nextStepVals[key].from, steps)
        });
        return val;
    }, preVals);
    return calStepperVals(easing, nextStepVals, steps - 1);
};
var // configure update function
$df7630cca8729f66$export$2e2bcd8739ae039 = function(from, to, easing, duration, render) {
    var interKeys = (0, $c1ThR.getIntersectionKeys)(from, to);
    var timingStyle = interKeys.reduce(function(res, key) {
        return $df7630cca8729f66$var$_objectSpread($df7630cca8729f66$var$_objectSpread({}, res), {}, $df7630cca8729f66$var$_defineProperty({}, key, [
            from[key],
            to[key]
        ]));
    }, {});
    var stepperStyle = interKeys.reduce(function(res, key) {
        return $df7630cca8729f66$var$_objectSpread($df7630cca8729f66$var$_objectSpread({}, res), {}, $df7630cca8729f66$var$_defineProperty({}, key, {
            from: from[key],
            velocity: 0,
            to: to[key]
        }));
    }, {});
    var cafId = -1;
    var preTime;
    var beginTime;
    var update = function update() {
        return null;
    };
    var getCurrStyle = function getCurrStyle() {
        return (0, $c1ThR.mapObject)(function(key, val) {
            return val.from;
        }, stepperStyle);
    };
    var shouldStopAnimation = function shouldStopAnimation() {
        return !Object.values(stepperStyle).filter($df7630cca8729f66$var$needContinue).length;
    };
    // stepper timing function like spring
    var stepperUpdate = function stepperUpdate(now) {
        if (!preTime) preTime = now;
        var deltaTime = now - preTime;
        var steps = deltaTime / easing.dt;
        stepperStyle = $df7630cca8729f66$var$calStepperVals(easing, stepperStyle, steps);
        // get union set and add compatible prefix
        render($df7630cca8729f66$var$_objectSpread($df7630cca8729f66$var$_objectSpread($df7630cca8729f66$var$_objectSpread({}, from), to), getCurrStyle(stepperStyle)));
        preTime = now;
        if (!shouldStopAnimation()) cafId = requestAnimationFrame(update);
    };
    // t => val timing function like cubic-bezier
    var timingUpdate = function timingUpdate(now) {
        if (!beginTime) beginTime = now;
        var t = (now - beginTime) / duration;
        var currStyle = (0, $c1ThR.mapObject)(function(key, val) {
            return $df7630cca8729f66$var$alpha.apply(void 0, $df7630cca8729f66$var$_toConsumableArray(val).concat([
                easing(t)
            ]));
        }, timingStyle);
        // get union set and add compatible prefix
        render($df7630cca8729f66$var$_objectSpread($df7630cca8729f66$var$_objectSpread($df7630cca8729f66$var$_objectSpread({}, from), to), currStyle));
        if (t < 1) cafId = requestAnimationFrame(update);
        else {
            var finalStyle = (0, $c1ThR.mapObject)(function(key, val) {
                return $df7630cca8729f66$var$alpha.apply(void 0, $df7630cca8729f66$var$_toConsumableArray(val).concat([
                    easing(1)
                ]));
            }, timingStyle);
            render($df7630cca8729f66$var$_objectSpread($df7630cca8729f66$var$_objectSpread($df7630cca8729f66$var$_objectSpread({}, from), to), finalStyle));
        }
    };
    update = easing.isStepper ? stepperUpdate : timingUpdate;
    // return start animation method
    return function() {
        requestAnimationFrame(update);
        // return stop animation method
        return function() {
            cancelAnimationFrame(cafId);
        };
    };
};

});



parcelRegister("i99FY", function(module, exports) {

var $d8VrW = parcelRequire("d8VrW");

var $hBKZ2 = parcelRequire("hBKZ2");
/** `Object#toString` result references. */ var $d36092b638f320eb$var$asyncTag = "[object AsyncFunction]", $d36092b638f320eb$var$funcTag = "[object Function]", $d36092b638f320eb$var$genTag = "[object GeneratorFunction]", $d36092b638f320eb$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $d36092b638f320eb$var$isFunction(value) {
    if (!$hBKZ2(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $d8VrW(value);
    return tag == $d36092b638f320eb$var$funcTag || tag == $d36092b638f320eb$var$genTag || tag == $d36092b638f320eb$var$asyncTag || tag == $d36092b638f320eb$var$proxyTag;
}
module.exports = $d36092b638f320eb$var$isFunction;

});

parcelRegister("9HZtv", function(module, exports) {

var $462cn = parcelRequire("462cn");

var $7xRTQ = parcelRequire("7xRTQ");

var $l8YZt = parcelRequire("l8YZt");
/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $7117d0dbb6fd835f$var$max(array) {
    return array && array.length ? $462cn(array, $l8YZt, $7xRTQ) : undefined;
}
module.exports = $7117d0dbb6fd835f$var$max;

});
parcelRegister("462cn", function(module, exports) {

var $5Ob3C = parcelRequire("5Ob3C");
/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $2fb96d8bfa291173$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$5Ob3C(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
module.exports = $2fb96d8bfa291173$var$baseExtremum;

});

parcelRegister("7xRTQ", function(module, exports) {
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $57e56cd329730e3b$var$baseGt(value, other) {
    return value > other;
}
module.exports = $57e56cd329730e3b$var$baseGt;

});

parcelRegister("l8YZt", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $f649a7cb0c5dc203$var$identity(value) {
    return value;
}
module.exports = $f649a7cb0c5dc203$var$identity;

});


parcelRegister("aVX0M", function(module, exports) {
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $7f5d00be15c5c2e1$var$isNil(value) {
    return value == null;
}
module.exports = $7f5d00be15c5c2e1$var$isNil;

});

parcelRegister("BWzdJ", function(module, exports) {

var $fuFGl = parcelRequire("fuFGl");
/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */ function $0720e3044d3c17ab$var$isNaN(value) {
    // An `NaN` primitive is the only value that is not equal to itself.
    // Perform the `toStringTag` check first to avoid errors with some
    // ActiveX objects in IE.
    return $fuFGl(value) && value != +value;
}
module.exports = $0720e3044d3c17ab$var$isNaN;

});
parcelRegister("fuFGl", function(module, exports) {

var $d8VrW = parcelRequire("d8VrW");

var $8JxPO = parcelRequire("8JxPO");
/** `Object#toString` result references. */ var $b479fd853ca4a5a0$var$numberTag = "[object Number]";
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $b479fd853ca4a5a0$var$isNumber(value) {
    return typeof value == "number" || $8JxPO(value) && $d8VrW(value) == $b479fd853ca4a5a0$var$numberTag;
}
module.exports = $b479fd853ca4a5a0$var$isNumber;

});


parcelRegister("dzN0r", function(module, exports) {

var $3SVoe = parcelRequire("3SVoe");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $9e248ed40d4823f9$var$isEqual(value, other) {
    return $3SVoe(value, other);
}
module.exports = $9e248ed40d4823f9$var$isEqual;

});
parcelRegister("3SVoe", function(module, exports) {

var $aH5O2 = parcelRequire("aH5O2");

var $8JxPO = parcelRequire("8JxPO");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $2d42eeaede06e455$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$8JxPO(value) && !$8JxPO(other)) return value !== value && other !== other;
    return $aH5O2(value, other, bitmask, customizer, $2d42eeaede06e455$var$baseIsEqual, stack);
}
module.exports = $2d42eeaede06e455$var$baseIsEqual;

});
parcelRegister("aH5O2", function(module, exports) {

var $asKzW = parcelRequire("asKzW");

var $3WXRO = parcelRequire("3WXRO");

var $1dhGL = parcelRequire("1dhGL");

var $5tSRI = parcelRequire("5tSRI");

var $3FJyp = parcelRequire("3FJyp");

var $687Zl = parcelRequire("687Zl");

var $dqeyy = parcelRequire("dqeyy");

var $c62dE = parcelRequire("c62dE");
/** Used to compose bitmasks for value comparisons. */ var $7c926c7b11cc8317$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $7c926c7b11cc8317$var$argsTag = "[object Arguments]", $7c926c7b11cc8317$var$arrayTag = "[object Array]", $7c926c7b11cc8317$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $7c926c7b11cc8317$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7c926c7b11cc8317$var$hasOwnProperty = $7c926c7b11cc8317$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $7c926c7b11cc8317$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $687Zl(object), othIsArr = $687Zl(other), objTag = objIsArr ? $7c926c7b11cc8317$var$arrayTag : $3FJyp(object), othTag = othIsArr ? $7c926c7b11cc8317$var$arrayTag : $3FJyp(other);
    objTag = objTag == $7c926c7b11cc8317$var$argsTag ? $7c926c7b11cc8317$var$objectTag : objTag;
    othTag = othTag == $7c926c7b11cc8317$var$argsTag ? $7c926c7b11cc8317$var$objectTag : othTag;
    var objIsObj = objTag == $7c926c7b11cc8317$var$objectTag, othIsObj = othTag == $7c926c7b11cc8317$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $dqeyy(object)) {
        if (!$dqeyy(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $asKzW);
        return objIsArr || $c62dE(object) ? $3WXRO(object, other, bitmask, customizer, equalFunc, stack) : $1dhGL(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $7c926c7b11cc8317$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $7c926c7b11cc8317$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $7c926c7b11cc8317$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $asKzW);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $asKzW);
    return $5tSRI(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $7c926c7b11cc8317$var$baseIsEqualDeep;

});
parcelRegister("asKzW", function(module, exports) {

var $ggsaP = parcelRequire("ggsaP");

var $jIkaj = parcelRequire("jIkaj");

var $aRYcM = parcelRequire("aRYcM");

var $a02p8 = parcelRequire("a02p8");

var $lrZem = parcelRequire("lrZem");

var $ggPwL = parcelRequire("ggPwL");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $79e0a671c96e7b92$var$Stack(entries) {
    var data = this.__data__ = new $ggsaP(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$79e0a671c96e7b92$var$Stack.prototype.clear = $jIkaj;
$79e0a671c96e7b92$var$Stack.prototype["delete"] = $aRYcM;
$79e0a671c96e7b92$var$Stack.prototype.get = $a02p8;
$79e0a671c96e7b92$var$Stack.prototype.has = $lrZem;
$79e0a671c96e7b92$var$Stack.prototype.set = $ggPwL;
module.exports = $79e0a671c96e7b92$var$Stack;

});
parcelRegister("ggsaP", function(module, exports) {

var $9QsNc = parcelRequire("9QsNc");

var $hNORR = parcelRequire("hNORR");

var $2VSII = parcelRequire("2VSII");

var $K3s8Y = parcelRequire("K3s8Y");

var $5dDjJ = parcelRequire("5dDjJ");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bd73fea74bbd1835$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$bd73fea74bbd1835$var$ListCache.prototype.clear = $9QsNc;
$bd73fea74bbd1835$var$ListCache.prototype["delete"] = $hNORR;
$bd73fea74bbd1835$var$ListCache.prototype.get = $2VSII;
$bd73fea74bbd1835$var$ListCache.prototype.has = $K3s8Y;
$bd73fea74bbd1835$var$ListCache.prototype.set = $5dDjJ;
module.exports = $bd73fea74bbd1835$var$ListCache;

});
parcelRegister("9QsNc", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $72af4dfa307d12ab$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $72af4dfa307d12ab$var$listCacheClear;

});

parcelRegister("hNORR", function(module, exports) {

var $fyQ9x = parcelRequire("fyQ9x");
/** Used for built-in method references. */ var $cf5e788cbc78868e$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $cf5e788cbc78868e$var$splice = $cf5e788cbc78868e$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $cf5e788cbc78868e$var$listCacheDelete(key) {
    var data = this.__data__, index = $fyQ9x(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $cf5e788cbc78868e$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $cf5e788cbc78868e$var$listCacheDelete;

});
parcelRegister("fyQ9x", function(module, exports) {

var $40ggO = parcelRequire("40ggO");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $b5427c755105c7a8$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($40ggO(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $b5427c755105c7a8$var$assocIndexOf;

});
parcelRegister("40ggO", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $2ea3c86b15bc8cec$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $2ea3c86b15bc8cec$var$eq;

});



parcelRegister("2VSII", function(module, exports) {

var $fyQ9x = parcelRequire("fyQ9x");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $222b59f67d2d6c71$var$listCacheGet(key) {
    var data = this.__data__, index = $fyQ9x(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $222b59f67d2d6c71$var$listCacheGet;

});

parcelRegister("K3s8Y", function(module, exports) {

var $fyQ9x = parcelRequire("fyQ9x");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $08a6f9ac4dc644e7$var$listCacheHas(key) {
    return $fyQ9x(this.__data__, key) > -1;
}
module.exports = $08a6f9ac4dc644e7$var$listCacheHas;

});

parcelRegister("5dDjJ", function(module, exports) {

var $fyQ9x = parcelRequire("fyQ9x");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $3cccaa38e5a43abe$var$listCacheSet(key, value) {
    var data = this.__data__, index = $fyQ9x(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $3cccaa38e5a43abe$var$listCacheSet;

});


parcelRegister("jIkaj", function(module, exports) {

var $ggsaP = parcelRequire("ggsaP");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $e5a1c4c703d9ccbb$var$stackClear() {
    this.__data__ = new $ggsaP;
    this.size = 0;
}
module.exports = $e5a1c4c703d9ccbb$var$stackClear;

});

parcelRegister("aRYcM", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $7e9d8e1fa1fef5b7$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = $7e9d8e1fa1fef5b7$var$stackDelete;

});

parcelRegister("a02p8", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $747bc4f40b320bca$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $747bc4f40b320bca$var$stackGet;

});

parcelRegister("lrZem", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $f9db9dbb2ddf42d7$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $f9db9dbb2ddf42d7$var$stackHas;

});

parcelRegister("ggPwL", function(module, exports) {

var $ggsaP = parcelRequire("ggsaP");

var $jVjMA = parcelRequire("jVjMA");

var $4NJjW = parcelRequire("4NJjW");
/** Used as the size to enable large array optimizations. */ var $bd861c410402ace1$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $bd861c410402ace1$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $ggsaP) {
        var pairs = data.__data__;
        if (!$jVjMA || pairs.length < $bd861c410402ace1$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $4NJjW(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $bd861c410402ace1$var$stackSet;

});
parcelRegister("jVjMA", function(module, exports) {

var $743br = parcelRequire("743br");

var $bHcVp = parcelRequire("bHcVp");
/* Built-in method references that are verified to be native. */ var $e812af9ca8fd1c46$var$Map = $743br($bHcVp, "Map");
module.exports = $e812af9ca8fd1c46$var$Map;

});
parcelRegister("743br", function(module, exports) {

var $CIDZO = parcelRequire("CIDZO");

var $d8C3A = parcelRequire("d8C3A");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $524b605410f2ff85$var$getNative(object, key) {
    var value = $d8C3A(object, key);
    return $CIDZO(value) ? value : undefined;
}
module.exports = $524b605410f2ff85$var$getNative;

});
parcelRegister("CIDZO", function(module, exports) {

var $i99FY = parcelRequire("i99FY");

var $6IhJP = parcelRequire("6IhJP");

var $hBKZ2 = parcelRequire("hBKZ2");

var $cHUEI = parcelRequire("cHUEI");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $07462e1cbb2a2b84$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $07462e1cbb2a2b84$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $07462e1cbb2a2b84$var$funcProto = Function.prototype, $07462e1cbb2a2b84$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $07462e1cbb2a2b84$var$funcToString = $07462e1cbb2a2b84$var$funcProto.toString;
/** Used to check objects for own properties. */ var $07462e1cbb2a2b84$var$hasOwnProperty = $07462e1cbb2a2b84$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $07462e1cbb2a2b84$var$reIsNative = RegExp("^" + $07462e1cbb2a2b84$var$funcToString.call($07462e1cbb2a2b84$var$hasOwnProperty).replace($07462e1cbb2a2b84$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $07462e1cbb2a2b84$var$baseIsNative(value) {
    if (!$hBKZ2(value) || $6IhJP(value)) return false;
    var pattern = $i99FY(value) ? $07462e1cbb2a2b84$var$reIsNative : $07462e1cbb2a2b84$var$reIsHostCtor;
    return pattern.test($cHUEI(value));
}
module.exports = $07462e1cbb2a2b84$var$baseIsNative;

});
parcelRegister("6IhJP", function(module, exports) {

var $bLK00 = parcelRequire("bLK00");
/** Used to detect methods masquerading as native. */ var $4e349c9072729e90$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($bLK00 && $bLK00.keys && $bLK00.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $4e349c9072729e90$var$isMasked(func) {
    return !!$4e349c9072729e90$var$maskSrcKey && $4e349c9072729e90$var$maskSrcKey in func;
}
module.exports = $4e349c9072729e90$var$isMasked;

});
parcelRegister("bLK00", function(module, exports) {

var $bHcVp = parcelRequire("bHcVp");
/** Used to detect overreaching core-js shims. */ var $8917c3f6ca032044$var$coreJsData = $bHcVp["__core-js_shared__"];
module.exports = $8917c3f6ca032044$var$coreJsData;

});


parcelRegister("cHUEI", function(module, exports) {
/** Used for built-in method references. */ var $940572d2e38b6f2b$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $940572d2e38b6f2b$var$funcToString = $940572d2e38b6f2b$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $940572d2e38b6f2b$var$toSource(func) {
    if (func != null) {
        try {
            return $940572d2e38b6f2b$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = $940572d2e38b6f2b$var$toSource;

});


parcelRegister("d8C3A", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $99098aff57b51c0d$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $99098aff57b51c0d$var$getValue;

});



parcelRegister("4NJjW", function(module, exports) {

var $khK3U = parcelRequire("khK3U");

var $fS4pk = parcelRequire("fS4pk");

var $6OsrJ = parcelRequire("6OsrJ");

var $8pvXV = parcelRequire("8pvXV");

var $jDuLa = parcelRequire("jDuLa");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $37eee4bd6fd919b0$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$37eee4bd6fd919b0$var$MapCache.prototype.clear = $khK3U;
$37eee4bd6fd919b0$var$MapCache.prototype["delete"] = $fS4pk;
$37eee4bd6fd919b0$var$MapCache.prototype.get = $6OsrJ;
$37eee4bd6fd919b0$var$MapCache.prototype.has = $8pvXV;
$37eee4bd6fd919b0$var$MapCache.prototype.set = $jDuLa;
module.exports = $37eee4bd6fd919b0$var$MapCache;

});
parcelRegister("khK3U", function(module, exports) {

var $lItEH = parcelRequire("lItEH");

var $ggsaP = parcelRequire("ggsaP");

var $jVjMA = parcelRequire("jVjMA");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $ec4920208c1ef12a$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $lItEH,
        "map": new ($jVjMA || $ggsaP),
        "string": new $lItEH
    };
}
module.exports = $ec4920208c1ef12a$var$mapCacheClear;

});
parcelRegister("lItEH", function(module, exports) {

var $8IcCY = parcelRequire("8IcCY");

var $jR3Jv = parcelRequire("jR3Jv");

var $dEh1q = parcelRequire("dEh1q");

var $QQtM6 = parcelRequire("QQtM6");

var $981Fe = parcelRequire("981Fe");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $fcf4b5fb804c51be$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$fcf4b5fb804c51be$var$Hash.prototype.clear = $8IcCY;
$fcf4b5fb804c51be$var$Hash.prototype["delete"] = $jR3Jv;
$fcf4b5fb804c51be$var$Hash.prototype.get = $dEh1q;
$fcf4b5fb804c51be$var$Hash.prototype.has = $QQtM6;
$fcf4b5fb804c51be$var$Hash.prototype.set = $981Fe;
module.exports = $fcf4b5fb804c51be$var$Hash;

});
parcelRegister("8IcCY", function(module, exports) {

var $2HX6F = parcelRequire("2HX6F");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $657c3a5c646fc7b4$var$hashClear() {
    this.__data__ = $2HX6F ? $2HX6F(null) : {};
    this.size = 0;
}
module.exports = $657c3a5c646fc7b4$var$hashClear;

});
parcelRegister("2HX6F", function(module, exports) {

var $743br = parcelRequire("743br");
/* Built-in method references that are verified to be native. */ var $1f8d72465d2cb4db$var$nativeCreate = $743br(Object, "create");
module.exports = $1f8d72465d2cb4db$var$nativeCreate;

});


parcelRegister("jR3Jv", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $e745dcd8dfa2ca98$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $e745dcd8dfa2ca98$var$hashDelete;

});

parcelRegister("dEh1q", function(module, exports) {

var $2HX6F = parcelRequire("2HX6F");
/** Used to stand-in for `undefined` hash values. */ var $9efc36fed74e69b9$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $9efc36fed74e69b9$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9efc36fed74e69b9$var$hasOwnProperty = $9efc36fed74e69b9$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $9efc36fed74e69b9$var$hashGet(key) {
    var data = this.__data__;
    if ($2HX6F) {
        var result = data[key];
        return result === $9efc36fed74e69b9$var$HASH_UNDEFINED ? undefined : result;
    }
    return $9efc36fed74e69b9$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $9efc36fed74e69b9$var$hashGet;

});

parcelRegister("QQtM6", function(module, exports) {

var $2HX6F = parcelRequire("2HX6F");
/** Used for built-in method references. */ var $09ed90ba20edd8eb$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $09ed90ba20edd8eb$var$hasOwnProperty = $09ed90ba20edd8eb$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $09ed90ba20edd8eb$var$hashHas(key) {
    var data = this.__data__;
    return $2HX6F ? data[key] !== undefined : $09ed90ba20edd8eb$var$hasOwnProperty.call(data, key);
}
module.exports = $09ed90ba20edd8eb$var$hashHas;

});

parcelRegister("981Fe", function(module, exports) {

var $2HX6F = parcelRequire("2HX6F");
/** Used to stand-in for `undefined` hash values. */ var $6a5626dcd0d142c6$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $6a5626dcd0d142c6$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $2HX6F && value === undefined ? $6a5626dcd0d142c6$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $6a5626dcd0d142c6$var$hashSet;

});



parcelRegister("fS4pk", function(module, exports) {

var $hVvQ1 = parcelRequire("hVvQ1");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b8df5168385b0f60$var$mapCacheDelete(key) {
    var result = $hVvQ1(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $b8df5168385b0f60$var$mapCacheDelete;

});
parcelRegister("hVvQ1", function(module, exports) {

var $6rI2Z = parcelRequire("6rI2Z");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $d0d074e932be2664$var$getMapData(map, key) {
    var data = map.__data__;
    return $6rI2Z(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = $d0d074e932be2664$var$getMapData;

});
parcelRegister("6rI2Z", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $4b176e929a80bb87$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = $4b176e929a80bb87$var$isKeyable;

});



parcelRegister("6OsrJ", function(module, exports) {

var $hVvQ1 = parcelRequire("hVvQ1");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $4f5d7a71516fc47f$var$mapCacheGet(key) {
    return $hVvQ1(this, key).get(key);
}
module.exports = $4f5d7a71516fc47f$var$mapCacheGet;

});

parcelRegister("8pvXV", function(module, exports) {

var $hVvQ1 = parcelRequire("hVvQ1");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $61f9743bb4a01e89$var$mapCacheHas(key) {
    return $hVvQ1(this, key).has(key);
}
module.exports = $61f9743bb4a01e89$var$mapCacheHas;

});

parcelRegister("jDuLa", function(module, exports) {

var $hVvQ1 = parcelRequire("hVvQ1");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $e4b98514f2f02e71$var$mapCacheSet(key, value) {
    var data = $hVvQ1(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $e4b98514f2f02e71$var$mapCacheSet;

});




parcelRegister("3WXRO", function(module, exports) {

var $iE4Sd = parcelRequire("iE4Sd");

var $gQRXj = parcelRequire("gQRXj");

var $giw2L = parcelRequire("giw2L");
/** Used to compose bitmasks for value comparisons. */ var $2e053a36d4aa2837$var$COMPARE_PARTIAL_FLAG = 1, $2e053a36d4aa2837$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $2e053a36d4aa2837$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $2e053a36d4aa2837$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $2e053a36d4aa2837$var$COMPARE_UNORDERED_FLAG ? new $iE4Sd : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$gQRXj(other, function(othValue, othIndex) {
                if (!$giw2L(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
module.exports = $2e053a36d4aa2837$var$equalArrays;

});
parcelRegister("iE4Sd", function(module, exports) {

var $4NJjW = parcelRequire("4NJjW");

var $hCYy1 = parcelRequire("hCYy1");

var $irH8e = parcelRequire("irH8e");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $d92fbe2a2e317acc$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $4NJjW;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$d92fbe2a2e317acc$var$SetCache.prototype.add = $d92fbe2a2e317acc$var$SetCache.prototype.push = $hCYy1;
$d92fbe2a2e317acc$var$SetCache.prototype.has = $irH8e;
module.exports = $d92fbe2a2e317acc$var$SetCache;

});
parcelRegister("hCYy1", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $cd54f3cbec7de1c5$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $cd54f3cbec7de1c5$var$setCacheAdd(value) {
    this.__data__.set(value, $cd54f3cbec7de1c5$var$HASH_UNDEFINED);
    return this;
}
module.exports = $cd54f3cbec7de1c5$var$setCacheAdd;

});

parcelRegister("irH8e", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $d6dc34b200960627$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $d6dc34b200960627$var$setCacheHas;

});


parcelRegister("gQRXj", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $c44b5b21b6159c0d$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $c44b5b21b6159c0d$var$arraySome;

});

parcelRegister("giw2L", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $bdd72ef6abe8e082$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $bdd72ef6abe8e082$var$cacheHas;

});


parcelRegister("1dhGL", function(module, exports) {

var $1QaHq = parcelRequire("1QaHq");

var $fhhK1 = parcelRequire("fhhK1");

var $40ggO = parcelRequire("40ggO");

var $3WXRO = parcelRequire("3WXRO");

var $hwe40 = parcelRequire("hwe40");

var $iWpJD = parcelRequire("iWpJD");
/** Used to compose bitmasks for value comparisons. */ var $0e24b9f333c92517$var$COMPARE_PARTIAL_FLAG = 1, $0e24b9f333c92517$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $0e24b9f333c92517$var$boolTag = "[object Boolean]", $0e24b9f333c92517$var$dateTag = "[object Date]", $0e24b9f333c92517$var$errorTag = "[object Error]", $0e24b9f333c92517$var$mapTag = "[object Map]", $0e24b9f333c92517$var$numberTag = "[object Number]", $0e24b9f333c92517$var$regexpTag = "[object RegExp]", $0e24b9f333c92517$var$setTag = "[object Set]", $0e24b9f333c92517$var$stringTag = "[object String]", $0e24b9f333c92517$var$symbolTag = "[object Symbol]";
var $0e24b9f333c92517$var$arrayBufferTag = "[object ArrayBuffer]", $0e24b9f333c92517$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $0e24b9f333c92517$var$symbolProto = $1QaHq ? $1QaHq.prototype : undefined, $0e24b9f333c92517$var$symbolValueOf = $0e24b9f333c92517$var$symbolProto ? $0e24b9f333c92517$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $0e24b9f333c92517$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $0e24b9f333c92517$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $0e24b9f333c92517$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $fhhK1(object), new $fhhK1(other))) return false;
            return true;
        case $0e24b9f333c92517$var$boolTag:
        case $0e24b9f333c92517$var$dateTag:
        case $0e24b9f333c92517$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $40ggO(+object, +other);
        case $0e24b9f333c92517$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $0e24b9f333c92517$var$regexpTag:
        case $0e24b9f333c92517$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $0e24b9f333c92517$var$mapTag:
            var convert = $hwe40;
        case $0e24b9f333c92517$var$setTag:
            var isPartial = bitmask & $0e24b9f333c92517$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $iWpJD);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $0e24b9f333c92517$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $3WXRO(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $0e24b9f333c92517$var$symbolTag:
            if ($0e24b9f333c92517$var$symbolValueOf) return $0e24b9f333c92517$var$symbolValueOf.call(object) == $0e24b9f333c92517$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $0e24b9f333c92517$var$equalByTag;

});
parcelRegister("fhhK1", function(module, exports) {

var $bHcVp = parcelRequire("bHcVp");
/** Built-in value references. */ var $b1f6349a3f7d4957$var$Uint8Array = $bHcVp.Uint8Array;
module.exports = $b1f6349a3f7d4957$var$Uint8Array;

});

parcelRegister("hwe40", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $cc10559248ac8396$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $cc10559248ac8396$var$mapToArray;

});

parcelRegister("iWpJD", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $dca19b3512d7a297$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $dca19b3512d7a297$var$setToArray;

});


parcelRegister("5tSRI", function(module, exports) {

var $gBvLo = parcelRequire("gBvLo");
/** Used to compose bitmasks for value comparisons. */ var $3fda384c5966efed$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $3fda384c5966efed$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3fda384c5966efed$var$hasOwnProperty = $3fda384c5966efed$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $3fda384c5966efed$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $3fda384c5966efed$var$COMPARE_PARTIAL_FLAG, objProps = $gBvLo(object), objLength = objProps.length, othProps = $gBvLo(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $3fda384c5966efed$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
module.exports = $3fda384c5966efed$var$equalObjects;

});
parcelRegister("gBvLo", function(module, exports) {

var $jsIqJ = parcelRequire("jsIqJ");

var $fS9Ov = parcelRequire("fS9Ov");

var $lVjOx = parcelRequire("lVjOx");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $c168bd92ea9a5243$var$getAllKeys(object) {
    return $jsIqJ(object, $lVjOx, $fS9Ov);
}
module.exports = $c168bd92ea9a5243$var$getAllKeys;

});
parcelRegister("jsIqJ", function(module, exports) {

var $8lg0J = parcelRequire("8lg0J");

var $687Zl = parcelRequire("687Zl");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $e2b318bd01efd6c3$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $687Zl(object) ? result : $8lg0J(result, symbolsFunc(object));
}
module.exports = $e2b318bd01efd6c3$var$baseGetAllKeys;

});
parcelRegister("8lg0J", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $612cb448d3101ced$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $612cb448d3101ced$var$arrayPush;

});


parcelRegister("fS9Ov", function(module, exports) {

var $e1iTP = parcelRequire("e1iTP");

var $dni9z = parcelRequire("dni9z");
/** Used for built-in method references. */ var $b8e382f1f8361feb$var$objectProto = Object.prototype;
/** Built-in value references. */ var $b8e382f1f8361feb$var$propertyIsEnumerable = $b8e382f1f8361feb$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b8e382f1f8361feb$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $b8e382f1f8361feb$var$getSymbols = !$b8e382f1f8361feb$var$nativeGetSymbols ? $dni9z : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $e1iTP($b8e382f1f8361feb$var$nativeGetSymbols(object), function(symbol) {
        return $b8e382f1f8361feb$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $b8e382f1f8361feb$var$getSymbols;

});
parcelRegister("e1iTP", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $a34fd1b76ed3d615$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $a34fd1b76ed3d615$var$arrayFilter;

});

parcelRegister("dni9z", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $9bcb813f22a6321d$var$stubArray() {
    return [];
}
module.exports = $9bcb813f22a6321d$var$stubArray;

});


parcelRegister("lVjOx", function(module, exports) {

var $dUw2Y = parcelRequire("dUw2Y");

var $lXP1o = parcelRequire("lXP1o");

var $5KNSm = parcelRequire("5KNSm");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $ff5e4a8adea0457c$var$keys(object) {
    return $5KNSm(object) ? $dUw2Y(object) : $lXP1o(object);
}
module.exports = $ff5e4a8adea0457c$var$keys;

});
parcelRegister("dUw2Y", function(module, exports) {

var $bsV6f = parcelRequire("bsV6f");

var $5rXka = parcelRequire("5rXka");

var $687Zl = parcelRequire("687Zl");

var $dqeyy = parcelRequire("dqeyy");

var $4DenX = parcelRequire("4DenX");

var $c62dE = parcelRequire("c62dE");
/** Used for built-in method references. */ var $a2095d2eade61cce$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a2095d2eade61cce$var$hasOwnProperty = $a2095d2eade61cce$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $a2095d2eade61cce$var$arrayLikeKeys(value, inherited) {
    var isArr = $687Zl(value), isArg = !isArr && $5rXka(value), isBuff = !isArr && !isArg && $dqeyy(value), isType = !isArr && !isArg && !isBuff && $c62dE(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $bsV6f(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $a2095d2eade61cce$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $4DenX(key, length)))) result.push(key);
    return result;
}
module.exports = $a2095d2eade61cce$var$arrayLikeKeys;

});
parcelRegister("bsV6f", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $858e9a0d32469bbe$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $858e9a0d32469bbe$var$baseTimes;

});

parcelRegister("5rXka", function(module, exports) {

var $kkuX1 = parcelRequire("kkuX1");

var $8JxPO = parcelRequire("8JxPO");
/** Used for built-in method references. */ var $3f7d7df4ad7eeb5f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3f7d7df4ad7eeb5f$var$hasOwnProperty = $3f7d7df4ad7eeb5f$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $3f7d7df4ad7eeb5f$var$propertyIsEnumerable = $3f7d7df4ad7eeb5f$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $3f7d7df4ad7eeb5f$var$isArguments = $kkuX1(function() {
    return arguments;
}()) ? $kkuX1 : function(value) {
    return $8JxPO(value) && $3f7d7df4ad7eeb5f$var$hasOwnProperty.call(value, "callee") && !$3f7d7df4ad7eeb5f$var$propertyIsEnumerable.call(value, "callee");
};
module.exports = $3f7d7df4ad7eeb5f$var$isArguments;

});
parcelRegister("kkuX1", function(module, exports) {

var $d8VrW = parcelRequire("d8VrW");

var $8JxPO = parcelRequire("8JxPO");
/** `Object#toString` result references. */ var $eccdaf1c21c8b26a$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $eccdaf1c21c8b26a$var$baseIsArguments(value) {
    return $8JxPO(value) && $d8VrW(value) == $eccdaf1c21c8b26a$var$argsTag;
}
module.exports = $eccdaf1c21c8b26a$var$baseIsArguments;

});


parcelRegister("dqeyy", function(module, exports) {

var $bHcVp = parcelRequire("bHcVp");

var $dwwRa = parcelRequire("dwwRa");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $bHcVp.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $dwwRa;
module.exports = isBuffer;

});
parcelRegister("dwwRa", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $9d87c024fa0d2995$var$stubFalse() {
    return false;
}
module.exports = $9d87c024fa0d2995$var$stubFalse;

});


parcelRegister("4DenX", function(module, exports) {
/** Used as references for various `Number` constants. */ var $35f5f69ab93443e8$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $35f5f69ab93443e8$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $35f5f69ab93443e8$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $35f5f69ab93443e8$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $35f5f69ab93443e8$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $35f5f69ab93443e8$var$isIndex;

});

parcelRegister("c62dE", function(module, exports) {

var $h5Vwd = parcelRequire("h5Vwd");

var $lGylI = parcelRequire("lGylI");

var $ecjdr = parcelRequire("ecjdr");
/* Node.js helper references. */ var $8ce7c43cbf0391b4$var$nodeIsTypedArray = $ecjdr && $ecjdr.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $8ce7c43cbf0391b4$var$isTypedArray = $8ce7c43cbf0391b4$var$nodeIsTypedArray ? $lGylI($8ce7c43cbf0391b4$var$nodeIsTypedArray) : $h5Vwd;
module.exports = $8ce7c43cbf0391b4$var$isTypedArray;

});
parcelRegister("h5Vwd", function(module, exports) {

var $d8VrW = parcelRequire("d8VrW");

var $fzuB5 = parcelRequire("fzuB5");

var $8JxPO = parcelRequire("8JxPO");
/** `Object#toString` result references. */ var $c71f855147ad6eb6$var$argsTag = "[object Arguments]", $c71f855147ad6eb6$var$arrayTag = "[object Array]", $c71f855147ad6eb6$var$boolTag = "[object Boolean]", $c71f855147ad6eb6$var$dateTag = "[object Date]", $c71f855147ad6eb6$var$errorTag = "[object Error]", $c71f855147ad6eb6$var$funcTag = "[object Function]", $c71f855147ad6eb6$var$mapTag = "[object Map]", $c71f855147ad6eb6$var$numberTag = "[object Number]", $c71f855147ad6eb6$var$objectTag = "[object Object]", $c71f855147ad6eb6$var$regexpTag = "[object RegExp]", $c71f855147ad6eb6$var$setTag = "[object Set]", $c71f855147ad6eb6$var$stringTag = "[object String]", $c71f855147ad6eb6$var$weakMapTag = "[object WeakMap]";
var $c71f855147ad6eb6$var$arrayBufferTag = "[object ArrayBuffer]", $c71f855147ad6eb6$var$dataViewTag = "[object DataView]", $c71f855147ad6eb6$var$float32Tag = "[object Float32Array]", $c71f855147ad6eb6$var$float64Tag = "[object Float64Array]", $c71f855147ad6eb6$var$int8Tag = "[object Int8Array]", $c71f855147ad6eb6$var$int16Tag = "[object Int16Array]", $c71f855147ad6eb6$var$int32Tag = "[object Int32Array]", $c71f855147ad6eb6$var$uint8Tag = "[object Uint8Array]", $c71f855147ad6eb6$var$uint8ClampedTag = "[object Uint8ClampedArray]", $c71f855147ad6eb6$var$uint16Tag = "[object Uint16Array]", $c71f855147ad6eb6$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $c71f855147ad6eb6$var$typedArrayTags = {};
$c71f855147ad6eb6$var$typedArrayTags[$c71f855147ad6eb6$var$float32Tag] = $c71f855147ad6eb6$var$typedArrayTags[$c71f855147ad6eb6$var$float64Tag] = $c71f855147ad6eb6$var$typedArrayTags[$c71f855147ad6eb6$var$int8Tag] = $c71f855147ad6eb6$var$typedArrayTags[$c71f855147ad6eb6$var$int16Tag] = $c71f855147ad6eb6$var$typedArrayTags[$c71f855147ad6eb6$var$int32Tag] = $c71f855147ad6eb6$var$typedArrayTags[$c71f855147ad6eb6$var$uint8Tag] = $c71f855147ad6eb6$var$typedArrayTags[$c71f855147ad6eb6$var$uint8ClampedTag] = $c71f855147ad6eb6$var$typedArrayTags[$c71f855147ad6eb6$var$uint16Tag] = $c71f855147ad6eb6$var$typedArrayTags[$c71f855147ad6eb6$var$uint32Tag] = true;
$c71f855147ad6eb6$var$typedArrayTags[$c71f855147ad6eb6$var$argsTag] = $c71f855147ad6eb6$var$typedArrayTags[$c71f855147ad6eb6$var$arrayTag] = $c71f855147ad6eb6$var$typedArrayTags[$c71f855147ad6eb6$var$arrayBufferTag] = $c71f855147ad6eb6$var$typedArrayTags[$c71f855147ad6eb6$var$boolTag] = $c71f855147ad6eb6$var$typedArrayTags[$c71f855147ad6eb6$var$dataViewTag] = $c71f855147ad6eb6$var$typedArrayTags[$c71f855147ad6eb6$var$dateTag] = $c71f855147ad6eb6$var$typedArrayTags[$c71f855147ad6eb6$var$errorTag] = $c71f855147ad6eb6$var$typedArrayTags[$c71f855147ad6eb6$var$funcTag] = $c71f855147ad6eb6$var$typedArrayTags[$c71f855147ad6eb6$var$mapTag] = $c71f855147ad6eb6$var$typedArrayTags[$c71f855147ad6eb6$var$numberTag] = $c71f855147ad6eb6$var$typedArrayTags[$c71f855147ad6eb6$var$objectTag] = $c71f855147ad6eb6$var$typedArrayTags[$c71f855147ad6eb6$var$regexpTag] = $c71f855147ad6eb6$var$typedArrayTags[$c71f855147ad6eb6$var$setTag] = $c71f855147ad6eb6$var$typedArrayTags[$c71f855147ad6eb6$var$stringTag] = $c71f855147ad6eb6$var$typedArrayTags[$c71f855147ad6eb6$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $c71f855147ad6eb6$var$baseIsTypedArray(value) {
    return $8JxPO(value) && $fzuB5(value.length) && !!$c71f855147ad6eb6$var$typedArrayTags[$d8VrW(value)];
}
module.exports = $c71f855147ad6eb6$var$baseIsTypedArray;

});
parcelRegister("fzuB5", function(module, exports) {
/** Used as references for various `Number` constants. */ var $b561dbda38820358$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $b561dbda38820358$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $b561dbda38820358$var$MAX_SAFE_INTEGER;
}
module.exports = $b561dbda38820358$var$isLength;

});


parcelRegister("lGylI", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $fc982a3df815fddc$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $fc982a3df815fddc$var$baseUnary;

});

parcelRegister("ecjdr", function(module, exports) {

var $lPf0h = parcelRequire("lPf0h");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $lPf0h.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("lXP1o", function(module, exports) {

var $67xKQ = parcelRequire("67xKQ");

var $8utjy = parcelRequire("8utjy");
/** Used for built-in method references. */ var $ffd6af79b25b85e7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ffd6af79b25b85e7$var$hasOwnProperty = $ffd6af79b25b85e7$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $ffd6af79b25b85e7$var$baseKeys(object) {
    if (!$67xKQ(object)) return $8utjy(object);
    var result = [];
    for(var key in Object(object))if ($ffd6af79b25b85e7$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = $ffd6af79b25b85e7$var$baseKeys;

});
parcelRegister("67xKQ", function(module, exports) {
/** Used for built-in method references. */ var $474d94763f8c2872$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $474d94763f8c2872$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $474d94763f8c2872$var$objectProto;
    return value === proto;
}
module.exports = $474d94763f8c2872$var$isPrototype;

});

parcelRegister("8utjy", function(module, exports) {

var $fDgsE = parcelRequire("fDgsE");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $62e7dd4e893b8fad$var$nativeKeys = $fDgsE(Object.keys, Object);
module.exports = $62e7dd4e893b8fad$var$nativeKeys;

});
parcelRegister("fDgsE", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $b617446227140f83$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $b617446227140f83$var$overArg;

});



parcelRegister("5KNSm", function(module, exports) {

var $i99FY = parcelRequire("i99FY");

var $fzuB5 = parcelRequire("fzuB5");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $4307efea1289b42f$var$isArrayLike(value) {
    return value != null && $fzuB5(value.length) && !$i99FY(value);
}
module.exports = $4307efea1289b42f$var$isArrayLike;

});




parcelRegister("3FJyp", function(module, exports) {

var $gCWRv = parcelRequire("gCWRv");

var $jVjMA = parcelRequire("jVjMA");

var $e6Nxa = parcelRequire("e6Nxa");

var $jnEqy = parcelRequire("jnEqy");

var $lK7l5 = parcelRequire("lK7l5");

var $d8VrW = parcelRequire("d8VrW");

var $cHUEI = parcelRequire("cHUEI");
/** `Object#toString` result references. */ var $2ac8898801514d2d$var$mapTag = "[object Map]", $2ac8898801514d2d$var$objectTag = "[object Object]", $2ac8898801514d2d$var$promiseTag = "[object Promise]", $2ac8898801514d2d$var$setTag = "[object Set]", $2ac8898801514d2d$var$weakMapTag = "[object WeakMap]";
var $2ac8898801514d2d$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $2ac8898801514d2d$var$dataViewCtorString = $cHUEI($gCWRv), $2ac8898801514d2d$var$mapCtorString = $cHUEI($jVjMA), $2ac8898801514d2d$var$promiseCtorString = $cHUEI($e6Nxa), $2ac8898801514d2d$var$setCtorString = $cHUEI($jnEqy), $2ac8898801514d2d$var$weakMapCtorString = $cHUEI($lK7l5);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $2ac8898801514d2d$var$getTag = $d8VrW;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($gCWRv && $2ac8898801514d2d$var$getTag(new $gCWRv(new ArrayBuffer(1))) != $2ac8898801514d2d$var$dataViewTag || $jVjMA && $2ac8898801514d2d$var$getTag(new $jVjMA) != $2ac8898801514d2d$var$mapTag || $e6Nxa && $2ac8898801514d2d$var$getTag($e6Nxa.resolve()) != $2ac8898801514d2d$var$promiseTag || $jnEqy && $2ac8898801514d2d$var$getTag(new $jnEqy) != $2ac8898801514d2d$var$setTag || $lK7l5 && $2ac8898801514d2d$var$getTag(new $lK7l5) != $2ac8898801514d2d$var$weakMapTag) $2ac8898801514d2d$var$getTag = function(value) {
    var result = $d8VrW(value), Ctor = result == $2ac8898801514d2d$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $cHUEI(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $2ac8898801514d2d$var$dataViewCtorString:
            return $2ac8898801514d2d$var$dataViewTag;
        case $2ac8898801514d2d$var$mapCtorString:
            return $2ac8898801514d2d$var$mapTag;
        case $2ac8898801514d2d$var$promiseCtorString:
            return $2ac8898801514d2d$var$promiseTag;
        case $2ac8898801514d2d$var$setCtorString:
            return $2ac8898801514d2d$var$setTag;
        case $2ac8898801514d2d$var$weakMapCtorString:
            return $2ac8898801514d2d$var$weakMapTag;
    }
    return result;
};
module.exports = $2ac8898801514d2d$var$getTag;

});
parcelRegister("gCWRv", function(module, exports) {

var $743br = parcelRequire("743br");

var $bHcVp = parcelRequire("bHcVp");
/* Built-in method references that are verified to be native. */ var $c1addab581c7a45f$var$DataView = $743br($bHcVp, "DataView");
module.exports = $c1addab581c7a45f$var$DataView;

});

parcelRegister("e6Nxa", function(module, exports) {

var $743br = parcelRequire("743br");

var $bHcVp = parcelRequire("bHcVp");
/* Built-in method references that are verified to be native. */ var $a4580c9ebc8dd537$var$Promise = $743br($bHcVp, "Promise");
module.exports = $a4580c9ebc8dd537$var$Promise;

});

parcelRegister("jnEqy", function(module, exports) {

var $743br = parcelRequire("743br");

var $bHcVp = parcelRequire("bHcVp");
/* Built-in method references that are verified to be native. */ var $e1bf8653b41a1710$var$Set = $743br($bHcVp, "Set");
module.exports = $e1bf8653b41a1710$var$Set;

});

parcelRegister("lK7l5", function(module, exports) {

var $743br = parcelRequire("743br");

var $bHcVp = parcelRequire("bHcVp");
/* Built-in method references that are verified to be native. */ var $fd43963dfa2e8740$var$WeakMap = $743br($bHcVp, "WeakMap");
module.exports = $fd43963dfa2e8740$var$WeakMap;

});





parcelRegister("1JINr", function(module, exports) {

$parcel$export(module.exports, "Curve", function () { return $143cbe110d01fb15$export$b0e83c3ef8d2db1; });

var $jbmdS = parcelRequire("jbmdS");

var $hNS9W = parcelRequire("hNS9W");

var $lKqbf = parcelRequire("lKqbf");

var $i99FY = parcelRequire("i99FY");

var $dWgPS = parcelRequire("dWgPS");

var $gBhCn = parcelRequire("gBhCn");

var $f06D9 = parcelRequire("f06D9");

var $1gmrG = parcelRequire("1gmrG");
function $143cbe110d01fb15$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $143cbe110d01fb15$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $143cbe110d01fb15$var$_typeof(o);
}
function $143cbe110d01fb15$var$_extends() {
    $143cbe110d01fb15$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $143cbe110d01fb15$var$_extends.apply(this, arguments);
}
function $143cbe110d01fb15$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $143cbe110d01fb15$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $143cbe110d01fb15$var$ownKeys(Object(t), !0).forEach(function(r) {
            $143cbe110d01fb15$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $143cbe110d01fb15$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $143cbe110d01fb15$var$_defineProperty(obj, key, value) {
    key = $143cbe110d01fb15$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $143cbe110d01fb15$var$_toPropertyKey(t) {
    var i = $143cbe110d01fb15$var$_toPrimitive(t, "string");
    return "symbol" == $143cbe110d01fb15$var$_typeof(i) ? i : i + "";
}
function $143cbe110d01fb15$var$_toPrimitive(t, r) {
    if ("object" != $143cbe110d01fb15$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $143cbe110d01fb15$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $143cbe110d01fb15$var$CURVE_FACTORIES = {
    curveBasisClosed: (0, $hNS9W.curveBasisClosed),
    curveBasisOpen: (0, $hNS9W.curveBasisOpen),
    curveBasis: (0, $hNS9W.curveBasis),
    curveBumpX: (0, $hNS9W.curveBumpX),
    curveBumpY: (0, $hNS9W.curveBumpY),
    curveLinearClosed: (0, $hNS9W.curveLinearClosed),
    curveLinear: (0, $hNS9W.curveLinear),
    curveMonotoneX: (0, $hNS9W.curveMonotoneX),
    curveMonotoneY: (0, $hNS9W.curveMonotoneY),
    curveNatural: (0, $hNS9W.curveNatural),
    curveStep: (0, $hNS9W.curveStep),
    curveStepAfter: (0, $hNS9W.curveStepAfter),
    curveStepBefore: (0, $hNS9W.curveStepBefore)
};
var $143cbe110d01fb15$var$defined = function defined(p) {
    return p.x === +p.x && p.y === +p.y;
};
var $143cbe110d01fb15$var$getX = function getX(p) {
    return p.x;
};
var $143cbe110d01fb15$var$getY = function getY(p) {
    return p.y;
};
var $143cbe110d01fb15$var$getCurveFactory = function getCurveFactory(type, layout) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(type)) return type;
    var name = "curve".concat((0, (/*@__PURE__*/$parcel$interopDefault($lKqbf)))(type));
    if ((name === "curveMonotone" || name === "curveBump") && layout) return $143cbe110d01fb15$var$CURVE_FACTORIES["".concat(name).concat(layout === "vertical" ? "Y" : "X")];
    return $143cbe110d01fb15$var$CURVE_FACTORIES[name] || (0, $hNS9W.curveLinear);
};
var $143cbe110d01fb15$export$2aa3fd96c49a84a8 = function getPath(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? "linear" : _ref$type, _ref$points = _ref.points, points = _ref$points === void 0 ? [] : _ref$points, baseLine = _ref.baseLine, layout = _ref.layout, _ref$connectNulls = _ref.connectNulls, connectNulls = _ref$connectNulls === void 0 ? false : _ref$connectNulls;
    var curveFactory = $143cbe110d01fb15$var$getCurveFactory(type, layout);
    var formatPoints = connectNulls ? points.filter(function(entry) {
        return $143cbe110d01fb15$var$defined(entry);
    }) : points;
    var lineFunction;
    if (Array.isArray(baseLine)) {
        var formatBaseLine = connectNulls ? baseLine.filter(function(base) {
            return $143cbe110d01fb15$var$defined(base);
        }) : baseLine;
        var areaPoints = formatPoints.map(function(entry, index) {
            return $143cbe110d01fb15$var$_objectSpread($143cbe110d01fb15$var$_objectSpread({}, entry), {}, {
                base: formatBaseLine[index]
            });
        });
        if (layout === "vertical") lineFunction = (0, $hNS9W.area)().y($143cbe110d01fb15$var$getY).x1($143cbe110d01fb15$var$getX).x0(function(d) {
            return d.base.x;
        });
        else lineFunction = (0, $hNS9W.area)().x($143cbe110d01fb15$var$getX).y1($143cbe110d01fb15$var$getY).y0(function(d) {
            return d.base.y;
        });
        lineFunction.defined($143cbe110d01fb15$var$defined).curve(curveFactory);
        return lineFunction(areaPoints);
    }
    if (layout === "vertical" && (0, $1gmrG.isNumber)(baseLine)) lineFunction = (0, $hNS9W.area)().y($143cbe110d01fb15$var$getY).x1($143cbe110d01fb15$var$getX).x0(baseLine);
    else if ((0, $1gmrG.isNumber)(baseLine)) lineFunction = (0, $hNS9W.area)().x($143cbe110d01fb15$var$getX).y1($143cbe110d01fb15$var$getY).y0(baseLine);
    else lineFunction = (0, $hNS9W.line)().x($143cbe110d01fb15$var$getX).y($143cbe110d01fb15$var$getY);
    lineFunction.defined($143cbe110d01fb15$var$defined).curve(curveFactory);
    return lineFunction(formatPoints);
};
var $143cbe110d01fb15$export$b0e83c3ef8d2db1 = function Curve(props) {
    var className = props.className, points = props.points, path = props.path, pathRef = props.pathRef;
    if ((!points || !points.length) && !path) return null;
    var realPath = points && points.length ? $143cbe110d01fb15$export$2aa3fd96c49a84a8(props) : path;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("path", $143cbe110d01fb15$var$_extends({}, (0, $f06D9.filterProps)(props, false), (0, $gBhCn.adaptEventHandlers)(props), {
        className: (0, $dWgPS.default)("recharts-curve", className),
        d: realPath,
        ref: pathRef
    }));
};

});
parcelRegister("hNS9W", function(module, exports) {
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

module.exports = (parcelRequire("iRbZX"));

});
parcelRegister("iRbZX", function(module, exports) {
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-shape`

module.exports = (parcelRequire("5thHL"));

});
parcelRegister("5thHL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "arc", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_arc.default;
    }
});
Object.defineProperty(module.exports, "area", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_area.default;
    }
});
Object.defineProperty(module.exports, "areaRadial", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "curveBasis", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "curveBasisClosed", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "curveBasisOpen", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_basisOpen.default;
    }
});
Object.defineProperty(module.exports, "curveBumpX", {
    enumerable: true,
    get: function() {
        return $4MXpk.bumpX;
    }
});
Object.defineProperty(module.exports, "curveBumpY", {
    enumerable: true,
    get: function() {
        return $4MXpk.bumpY;
    }
});
Object.defineProperty(module.exports, "curveBundle", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_bundle.default;
    }
});
Object.defineProperty(module.exports, "curveCardinal", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_cardinal.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalClosed", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_cardinalClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalOpen", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_cardinalOpen.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRom", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_catmullRom.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomClosed", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_catmullRomClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomOpen", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_catmullRomOpen.default;
    }
});
Object.defineProperty(module.exports, "curveLinear", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "curveLinearClosed", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_linearClosed.default;
    }
});
Object.defineProperty(module.exports, "curveMonotoneX", {
    enumerable: true,
    get: function() {
        return $4Jk9g.monotoneX;
    }
});
Object.defineProperty(module.exports, "curveMonotoneY", {
    enumerable: true,
    get: function() {
        return $4Jk9g.monotoneY;
    }
});
Object.defineProperty(module.exports, "curveNatural", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_natural.default;
    }
});
Object.defineProperty(module.exports, "curveStep", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_step.default;
    }
});
Object.defineProperty(module.exports, "curveStepAfter", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_step.stepAfter;
    }
});
Object.defineProperty(module.exports, "curveStepBefore", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_step.stepBefore;
    }
});
Object.defineProperty(module.exports, "line", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_line.default;
    }
});
Object.defineProperty(module.exports, "lineRadial", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "link", {
    enumerable: true,
    get: function() {
        return $cpy0u.link;
    }
});
Object.defineProperty(module.exports, "linkHorizontal", {
    enumerable: true,
    get: function() {
        return $cpy0u.linkHorizontal;
    }
});
Object.defineProperty(module.exports, "linkRadial", {
    enumerable: true,
    get: function() {
        return $cpy0u.linkRadial;
    }
});
Object.defineProperty(module.exports, "linkVertical", {
    enumerable: true,
    get: function() {
        return $cpy0u.linkVertical;
    }
});
Object.defineProperty(module.exports, "pie", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_pie.default;
    }
});
Object.defineProperty(module.exports, "pointRadial", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_pointRadial.default;
    }
});
Object.defineProperty(module.exports, "radialArea", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "radialLine", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "stack", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_stack.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetDiverging", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetExpand", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_expand.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetNone", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_none.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetSilhouette", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_silhouette.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetWiggle", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_wiggle.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAppearance", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_appearance.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAscending", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderDescending", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderInsideOut", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_insideOut.default;
    }
});
Object.defineProperty(module.exports, "stackOrderNone", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_none2.default;
    }
});
Object.defineProperty(module.exports, "stackOrderReverse", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "symbol", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_symbol.default;
    }
});
Object.defineProperty(module.exports, "symbolAsterisk", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_asterisk.default;
    }
});
Object.defineProperty(module.exports, "symbolCircle", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_circle.default;
    }
});
Object.defineProperty(module.exports, "symbolCross", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_diamond.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond2", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_diamond2.default;
    }
});
Object.defineProperty(module.exports, "symbolPlus", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_plus.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_square.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare2", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_square2.default;
    }
});
Object.defineProperty(module.exports, "symbolStar", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_star.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_triangle.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle2", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_triangle2.default;
    }
});
Object.defineProperty(module.exports, "symbolWye", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_wye.default;
    }
});
Object.defineProperty(module.exports, "symbolX", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_x.default;
    }
});
Object.defineProperty(module.exports, "symbols", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsFill", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsStroke", {
    enumerable: true,
    get: function() {
        return $3fbd65022581bbcc$var$_symbol.symbolsStroke;
    }
});

var $3fbd65022581bbcc$var$_arc = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("6b38C")));

var $3fbd65022581bbcc$var$_area = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("k2zDX")));

var $3fbd65022581bbcc$var$_line = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("9S9uN")));

var $3fbd65022581bbcc$var$_pie = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("dP6yW")));

var $3fbd65022581bbcc$var$_areaRadial = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("59odw")));

var $3fbd65022581bbcc$var$_lineRadial = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("YbvJa")));

var $3fbd65022581bbcc$var$_pointRadial = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("8OKT5")));

var $cpy0u = parcelRequire("cpy0u");

var $3fbd65022581bbcc$var$_symbol = $3fbd65022581bbcc$var$_interopRequireWildcard((parcelRequire("eeZLq")));

var $3fbd65022581bbcc$var$_asterisk = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("l5m8Z")));

var $3fbd65022581bbcc$var$_circle = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("hSzX3")));

var $3fbd65022581bbcc$var$_cross = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("jyGRv")));

var $3fbd65022581bbcc$var$_diamond = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("2ZjM9")));

var $3fbd65022581bbcc$var$_diamond2 = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("lTMyx")));

var $3fbd65022581bbcc$var$_plus = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("eerbl")));

var $3fbd65022581bbcc$var$_square = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("gjj6e")));

var $3fbd65022581bbcc$var$_square2 = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("71dU9")));

var $3fbd65022581bbcc$var$_star = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("cr0Xc")));

var $3fbd65022581bbcc$var$_triangle = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("5vNh7")));

var $3fbd65022581bbcc$var$_triangle2 = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("coYKj")));

var $3fbd65022581bbcc$var$_wye = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("hf1k2")));

var $3fbd65022581bbcc$var$_x = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("gbhSn")));

var $3fbd65022581bbcc$var$_basisClosed = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("eh8Jo")));

var $3fbd65022581bbcc$var$_basisOpen = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("2E93i")));

var $3fbd65022581bbcc$var$_basis = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("3EuEO")));

var $4MXpk = parcelRequire("4MXpk");

var $3fbd65022581bbcc$var$_bundle = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("kQY6H")));

var $3fbd65022581bbcc$var$_cardinalClosed = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("3PCrm")));

var $3fbd65022581bbcc$var$_cardinalOpen = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("5raP3")));

var $3fbd65022581bbcc$var$_cardinal = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("iwBwh")));

var $3fbd65022581bbcc$var$_catmullRomClosed = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("dEO7A")));

var $3fbd65022581bbcc$var$_catmullRomOpen = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("eiz6l")));

var $3fbd65022581bbcc$var$_catmullRom = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("iBjsd")));

var $3fbd65022581bbcc$var$_linearClosed = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("3tVed")));

var $3fbd65022581bbcc$var$_linear = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("h0Azv")));

var $4Jk9g = parcelRequire("4Jk9g");

var $3fbd65022581bbcc$var$_natural = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("83UOo")));

var $3fbd65022581bbcc$var$_step = $3fbd65022581bbcc$var$_interopRequireWildcard((parcelRequire("8Jhdf")));

var $3fbd65022581bbcc$var$_stack = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("7vkE1")));

var $3fbd65022581bbcc$var$_expand = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("67EXt")));

var $3fbd65022581bbcc$var$_diverging = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("gp8Em")));

var $3fbd65022581bbcc$var$_none = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("gOvxF")));

var $3fbd65022581bbcc$var$_silhouette = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("fxXhn")));

var $3fbd65022581bbcc$var$_wiggle = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("ePR5y")));

var $3fbd65022581bbcc$var$_appearance = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("bHp1I")));

var $3fbd65022581bbcc$var$_ascending = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("inuiw")));

var $3fbd65022581bbcc$var$_descending = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("bco5c")));

var $3fbd65022581bbcc$var$_insideOut = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("bYOrm")));

var $3fbd65022581bbcc$var$_none2 = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("3Lnbc")));

var $3fbd65022581bbcc$var$_reverse = $3fbd65022581bbcc$var$_interopRequireDefault((parcelRequire("dATyF")));
function $3fbd65022581bbcc$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($3fbd65022581bbcc$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $3fbd65022581bbcc$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $3fbd65022581bbcc$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $3fbd65022581bbcc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("6b38C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $47f6344f8493fec9$var$_default;

var $dNWUS = parcelRequire("dNWUS");

var $47f6344f8493fec9$var$_constant = $47f6344f8493fec9$var$_interopRequireDefault((parcelRequire("gDtoD")));

var $60ffJ = parcelRequire("60ffJ");
function $47f6344f8493fec9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $47f6344f8493fec9$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $47f6344f8493fec9$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $47f6344f8493fec9$var$arcStartAngle(d) {
    return d.startAngle;
}
function $47f6344f8493fec9$var$arcEndAngle(d) {
    return d.endAngle;
}
function $47f6344f8493fec9$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $47f6344f8493fec9$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < $60ffJ.epsilon) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
} // Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $47f6344f8493fec9$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $60ffJ.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $60ffJ.sqrt)((0, $60ffJ.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00; // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $47f6344f8493fec9$var$_default() {
    var innerRadius = $47f6344f8493fec9$var$arcInnerRadius, outerRadius = $47f6344f8493fec9$var$arcOuterRadius, cornerRadius = (0, $47f6344f8493fec9$var$_constant.default)(0), padRadius = null, startAngle = $47f6344f8493fec9$var$arcStartAngle, endAngle = $47f6344f8493fec9$var$arcEndAngle, padAngle = $47f6344f8493fec9$var$arcPadAngle, context = null;
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - $60ffJ.halfPi, a1 = endAngle.apply(this, arguments) - $60ffJ.halfPi, da = (0, $60ffJ.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = (0, $dNWUS.path)(); // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r; // Is it a point?
        if (!(r1 > $60ffJ.epsilon)) context.moveTo(0, 0); // Or is it a circle or annulus?
        else if (da > $60ffJ.tau - $60ffJ.epsilon) {
            context.moveTo(r1 * (0, $60ffJ.cos)(a0), r1 * (0, $60ffJ.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > $60ffJ.epsilon) {
                context.moveTo(r0 * (0, $60ffJ.cos)(a1), r0 * (0, $60ffJ.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > $60ffJ.epsilon && (padRadius ? +padRadius.apply(this, arguments) : (0, $60ffJ.sqrt)(r0 * r0 + r1 * r1)), rc = (0, $60ffJ.min)((0, $60ffJ.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1; // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > $60ffJ.epsilon) {
                var p0 = (0, $60ffJ.asin)(rp / r0 * (0, $60ffJ.sin)(ap)), p1 = (0, $60ffJ.asin)(rp / r1 * (0, $60ffJ.sin)(ap));
                if ((da0 -= p0 * 2) > $60ffJ.epsilon) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > $60ffJ.epsilon) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $60ffJ.cos)(a01), y01 = r1 * (0, $60ffJ.sin)(a01), x10 = r0 * (0, $60ffJ.cos)(a10), y10 = r0 * (0, $60ffJ.sin)(a10); // Apply rounded corners?
            if (rc > $60ffJ.epsilon) {
                var x11 = r1 * (0, $60ffJ.cos)(a11), y11 = r1 * (0, $60ffJ.sin)(a11), x00 = r0 * (0, $60ffJ.cos)(a00), y00 = r0 * (0, $60ffJ.sin)(a00), oc; // Restrict the corner radius according to the sector angle.
                if (da < $60ffJ.pi && (oc = $47f6344f8493fec9$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                    var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $60ffJ.sin)((0, $60ffJ.acos)((ax * bx + ay * by) / ((0, $60ffJ.sqrt)(ax * ax + ay * ay) * (0, $60ffJ.sqrt)(bx * bx + by * by))) / 2), lc = (0, $60ffJ.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                    rc0 = (0, $60ffJ.min)(rc, (r0 - lc) / (kc - 1));
                    rc1 = (0, $60ffJ.min)(rc, (r1 - lc) / (kc + 1));
                }
            } // Is the sector collapsed to a line?
            if (!(da1 > $60ffJ.epsilon)) context.moveTo(x01, y01); // Does the sector’s outer ring have rounded corners?
            else if (rc1 > $60ffJ.epsilon) {
                t0 = $47f6344f8493fec9$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $47f6344f8493fec9$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $60ffJ.atan2)(t0.y01, t0.x01), (0, $60ffJ.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $60ffJ.atan2)(t0.y01, t0.x01), (0, $60ffJ.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $60ffJ.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $60ffJ.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $60ffJ.atan2)(t1.y11, t1.x11), (0, $60ffJ.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw); // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > $60ffJ.epsilon) || !(da0 > $60ffJ.epsilon)) context.lineTo(x10, y10); // Does the sector’s inner ring (or point) have rounded corners?
            else if (rc0 > $60ffJ.epsilon) {
                t0 = $47f6344f8493fec9$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $47f6344f8493fec9$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $60ffJ.atan2)(t0.y01, t0.x01), (0, $60ffJ.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $60ffJ.atan2)(t0.y01, t0.x01), (0, $60ffJ.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $60ffJ.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $60ffJ.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $60ffJ.atan2)(t1.y11, t1.x11), (0, $60ffJ.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - $60ffJ.pi / 2;
        return [
            (0, $60ffJ.cos)(a) * r,
            (0, $60ffJ.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $47f6344f8493fec9$var$_constant.default)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $47f6344f8493fec9$var$_constant.default)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $47f6344f8493fec9$var$_constant.default)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $47f6344f8493fec9$var$_constant.default)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $47f6344f8493fec9$var$_constant.default)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $47f6344f8493fec9$var$_constant.default)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $47f6344f8493fec9$var$_constant.default)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

});
parcelRegister("dNWUS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "path", {
    enumerable: true,
    get: function() {
        return $a0cd8d822cb5204f$var$_path.default;
    }
});

var $a0cd8d822cb5204f$var$_path = $a0cd8d822cb5204f$var$_interopRequireDefault((parcelRequire("25qUS")));
function $a0cd8d822cb5204f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("25qUS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $1850ed69b5878ac3$var$pi = Math.PI, $1850ed69b5878ac3$var$tau = 2 * $1850ed69b5878ac3$var$pi, $1850ed69b5878ac3$var$epsilon = 1e-6, $1850ed69b5878ac3$var$tauEpsilon = $1850ed69b5878ac3$var$tau - $1850ed69b5878ac3$var$epsilon;
function $1850ed69b5878ac3$var$Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $1850ed69b5878ac3$var$path() {
    return new $1850ed69b5878ac3$var$Path();
}
$1850ed69b5878ac3$var$Path.prototype = $1850ed69b5878ac3$var$path.prototype = {
    constructor: $1850ed69b5878ac3$var$Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $1850ed69b5878ac3$var$epsilon)) ; // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $1850ed69b5878ac3$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($1850ed69b5878ac3$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21; // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $1850ed69b5878ac3$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $1850ed69b5878ac3$var$epsilon || Math.abs(this._y1 - y0) > $1850ed69b5878ac3$var$epsilon) this._ += "L" + x0 + "," + y0;
         // Is this arc empty? We’re done.
        if (!r) return; // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $1850ed69b5878ac3$var$tau + $1850ed69b5878ac3$var$tau; // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $1850ed69b5878ac3$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $1850ed69b5878ac3$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $1850ed69b5878ac3$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var $1850ed69b5878ac3$var$_default = $1850ed69b5878ac3$var$path;
module.exports.default = $1850ed69b5878ac3$var$_default;

});


parcelRegister("gDtoD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c1c7175670b3446a$var$_default;
function $c1c7175670b3446a$var$_default(x) {
    return function constant() {
        return x;
    };
}

});

parcelRegister("60ffJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.abs = void 0;
module.exports.acos = $45ee930da0d52368$var$acos;
module.exports.asin = $45ee930da0d52368$var$asin;
module.exports.tau = module.exports.sqrt = module.exports.sin = module.exports.pi = module.exports.min = module.exports.max = module.exports.halfPi = module.exports.epsilon = module.exports.cos = module.exports.atan2 = void 0;
const $45ee930da0d52368$var$abs = Math.abs;
module.exports.abs = $45ee930da0d52368$var$abs;
const $45ee930da0d52368$var$atan2 = Math.atan2;
module.exports.atan2 = $45ee930da0d52368$var$atan2;
const $45ee930da0d52368$var$cos = Math.cos;
module.exports.cos = $45ee930da0d52368$var$cos;
const $45ee930da0d52368$var$max = Math.max;
module.exports.max = $45ee930da0d52368$var$max;
const $45ee930da0d52368$var$min = Math.min;
module.exports.min = $45ee930da0d52368$var$min;
const $45ee930da0d52368$var$sin = Math.sin;
module.exports.sin = $45ee930da0d52368$var$sin;
const $45ee930da0d52368$var$sqrt = Math.sqrt;
module.exports.sqrt = $45ee930da0d52368$var$sqrt;
const $45ee930da0d52368$var$epsilon = 1e-12;
module.exports.epsilon = $45ee930da0d52368$var$epsilon;
const $45ee930da0d52368$var$pi = Math.PI;
module.exports.pi = $45ee930da0d52368$var$pi;
const $45ee930da0d52368$var$halfPi = $45ee930da0d52368$var$pi / 2;
module.exports.halfPi = $45ee930da0d52368$var$halfPi;
const $45ee930da0d52368$var$tau = 2 * $45ee930da0d52368$var$pi;
module.exports.tau = $45ee930da0d52368$var$tau;
function $45ee930da0d52368$var$acos(x) {
    return x > 1 ? 0 : x < -1 ? $45ee930da0d52368$var$pi : Math.acos(x);
}
function $45ee930da0d52368$var$asin(x) {
    return x >= 1 ? $45ee930da0d52368$var$halfPi : x <= -1 ? -$45ee930da0d52368$var$halfPi : Math.asin(x);
}

});


parcelRegister("k2zDX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e96fa49452cb8a0f$var$_default;

var $dNWUS = parcelRequire("dNWUS");

var $e96fa49452cb8a0f$var$_array = $e96fa49452cb8a0f$var$_interopRequireDefault((parcelRequire("ch2fZ")));

var $e96fa49452cb8a0f$var$_constant = $e96fa49452cb8a0f$var$_interopRequireDefault((parcelRequire("gDtoD")));

var $e96fa49452cb8a0f$var$_linear = $e96fa49452cb8a0f$var$_interopRequireDefault((parcelRequire("h0Azv")));

var $e96fa49452cb8a0f$var$_line = $e96fa49452cb8a0f$var$_interopRequireDefault((parcelRequire("9S9uN")));

var $7f7dq = parcelRequire("7f7dq");
function $e96fa49452cb8a0f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e96fa49452cb8a0f$var$_default(x0, y0, y1) {
    var x1 = null, defined = (0, $e96fa49452cb8a0f$var$_constant.default)(true), context = null, curve = $e96fa49452cb8a0f$var$_linear.default, output = null;
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? $7f7dq.x : (0, $e96fa49452cb8a0f$var$_constant.default)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, $e96fa49452cb8a0f$var$_constant.default)(0) : (0, $e96fa49452cb8a0f$var$_constant.default)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? $7f7dq.y : (0, $e96fa49452cb8a0f$var$_constant.default)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, $e96fa49452cb8a0f$var$_array.default)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = (0, $dNWUS.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $e96fa49452cb8a0f$var$_line.default)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $e96fa49452cb8a0f$var$_constant.default)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $e96fa49452cb8a0f$var$_constant.default)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $e96fa49452cb8a0f$var$_constant.default)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $e96fa49452cb8a0f$var$_constant.default)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $e96fa49452cb8a0f$var$_constant.default)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $e96fa49452cb8a0f$var$_constant.default)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $e96fa49452cb8a0f$var$_constant.default)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

});
parcelRegister("ch2fZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8ef8d2baa00c6467$var$_default;
module.exports.slice = void 0;
var $8ef8d2baa00c6467$var$slice = Array.prototype.slice;
module.exports.slice = $8ef8d2baa00c6467$var$slice;
function $8ef8d2baa00c6467$var$_default(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}

});

parcelRegister("h0Azv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c61ece1bff5a29d2$var$_default;
function $c61ece1bff5a29d2$var$Linear(context) {
    this._context = context;
}
$c61ece1bff5a29d2$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $c61ece1bff5a29d2$var$_default(context) {
    return new $c61ece1bff5a29d2$var$Linear(context);
}

});

parcelRegister("9S9uN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $730085d74ed8053a$var$_default;

var $dNWUS = parcelRequire("dNWUS");

var $730085d74ed8053a$var$_array = $730085d74ed8053a$var$_interopRequireDefault((parcelRequire("ch2fZ")));

var $730085d74ed8053a$var$_constant = $730085d74ed8053a$var$_interopRequireDefault((parcelRequire("gDtoD")));

var $730085d74ed8053a$var$_linear = $730085d74ed8053a$var$_interopRequireDefault((parcelRequire("h0Azv")));

var $7f7dq = parcelRequire("7f7dq");
function $730085d74ed8053a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $730085d74ed8053a$var$_default(x, y) {
    var defined = (0, $730085d74ed8053a$var$_constant.default)(true), context = null, curve = $730085d74ed8053a$var$_linear.default, output = null;
    x = typeof x === "function" ? x : x === undefined ? $7f7dq.x : (0, $730085d74ed8053a$var$_constant.default)(x);
    y = typeof y === "function" ? y : y === undefined ? $7f7dq.y : (0, $730085d74ed8053a$var$_constant.default)(y);
    function line(data) {
        var i, n = (data = (0, $730085d74ed8053a$var$_array.default)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = (0, $dNWUS.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $730085d74ed8053a$var$_constant.default)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $730085d74ed8053a$var$_constant.default)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $730085d74ed8053a$var$_constant.default)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}

});
parcelRegister("7f7dq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.x = $545f87f31a756df0$var$x;
module.exports.y = $545f87f31a756df0$var$y;
function $545f87f31a756df0$var$x(p) {
    return p[0];
}
function $545f87f31a756df0$var$y(p) {
    return p[1];
}

});



parcelRegister("dP6yW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a10520f904d80e34$var$_default;

var $a10520f904d80e34$var$_array = $a10520f904d80e34$var$_interopRequireDefault((parcelRequire("ch2fZ")));

var $a10520f904d80e34$var$_constant = $a10520f904d80e34$var$_interopRequireDefault((parcelRequire("gDtoD")));

var $a10520f904d80e34$var$_descending = $a10520f904d80e34$var$_interopRequireDefault((parcelRequire("2gLOI")));

var $a10520f904d80e34$var$_identity = $a10520f904d80e34$var$_interopRequireDefault((parcelRequire("iwqgr")));

var $60ffJ = parcelRequire("60ffJ");
function $a10520f904d80e34$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a10520f904d80e34$var$_default() {
    var value = $a10520f904d80e34$var$_identity.default, sortValues = $a10520f904d80e34$var$_descending.default, sort = null, startAngle = (0, $a10520f904d80e34$var$_constant.default)(0), endAngle = (0, $a10520f904d80e34$var$_constant.default)($60ffJ.tau), padAngle = (0, $a10520f904d80e34$var$_constant.default)(0);
    function pie(data) {
        var i, n = (data = (0, $a10520f904d80e34$var$_array.default)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min($60ffJ.tau, Math.max(-$60ffJ.tau, endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
         // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        }); // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $a10520f904d80e34$var$_constant.default)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $a10520f904d80e34$var$_constant.default)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $a10520f904d80e34$var$_constant.default)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $a10520f904d80e34$var$_constant.default)(+_), pie) : padAngle;
    };
    return pie;
}

});
parcelRegister("2gLOI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1a722ade60ae6178$var$_default;
function $1a722ade60ae6178$var$_default(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("iwqgr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d7bf96ae8764e844$var$_default;
function $d7bf96ae8764e844$var$_default(d) {
    return d;
}

});


parcelRegister("59odw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3c00940289d35379$var$_default;

var $3c00940289d35379$var$_radial = $3c00940289d35379$var$_interopRequireWildcard((parcelRequire("ebHr8")));

var $3c00940289d35379$var$_area = $3c00940289d35379$var$_interopRequireDefault((parcelRequire("k2zDX")));

var $YbvJa = parcelRequire("YbvJa");
function $3c00940289d35379$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3c00940289d35379$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($3c00940289d35379$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $3c00940289d35379$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $3c00940289d35379$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $3c00940289d35379$var$_default() {
    var a = (0, $3c00940289d35379$var$_area.default)().curve($3c00940289d35379$var$_radial.curveRadialLinear), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
    a.angle = a.x, delete a.x;
    a.startAngle = a.x0, delete a.x0;
    a.endAngle = a.x1, delete a.x1;
    a.radius = a.y, delete a.y;
    a.innerRadius = a.y0, delete a.y0;
    a.outerRadius = a.y1, delete a.y1;
    a.lineStartAngle = function() {
        return (0, $YbvJa.lineRadial)(x0());
    }, delete a.lineX0;
    a.lineEndAngle = function() {
        return (0, $YbvJa.lineRadial)(x1());
    }, delete a.lineX1;
    a.lineInnerRadius = function() {
        return (0, $YbvJa.lineRadial)(y0());
    }, delete a.lineY0;
    a.lineOuterRadius = function() {
        return (0, $YbvJa.lineRadial)(y1());
    }, delete a.lineY1;
    a.curve = function(_) {
        return arguments.length ? c((0, $3c00940289d35379$var$_radial.default)(_)) : c()._curve;
    };
    return a;
}

});
parcelRegister("ebHr8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.curveRadialLinear = void 0;
module.exports.default = $a543c9642e49c45e$var$curveRadial;

var $a543c9642e49c45e$var$_linear = $a543c9642e49c45e$var$_interopRequireDefault((parcelRequire("h0Azv")));
function $a543c9642e49c45e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a543c9642e49c45e$var$curveRadialLinear = $a543c9642e49c45e$var$curveRadial($a543c9642e49c45e$var$_linear.default);
module.exports.curveRadialLinear = $a543c9642e49c45e$var$curveRadialLinear;
function $a543c9642e49c45e$var$Radial(curve) {
    this._curve = curve;
}
$a543c9642e49c45e$var$Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function $a543c9642e49c45e$var$curveRadial(curve) {
    function radial(context) {
        return new $a543c9642e49c45e$var$Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

});

parcelRegister("YbvJa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0b4e8880cf379f49$var$_default;
module.exports.lineRadial = $0b4e8880cf379f49$var$lineRadial;

var $0b4e8880cf379f49$var$_radial = $0b4e8880cf379f49$var$_interopRequireWildcard((parcelRequire("ebHr8")));

var $0b4e8880cf379f49$var$_line = $0b4e8880cf379f49$var$_interopRequireDefault((parcelRequire("9S9uN")));
function $0b4e8880cf379f49$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0b4e8880cf379f49$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($0b4e8880cf379f49$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $0b4e8880cf379f49$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $0b4e8880cf379f49$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $0b4e8880cf379f49$var$lineRadial(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, $0b4e8880cf379f49$var$_radial.default)(_)) : c()._curve;
    };
    return l;
}
function $0b4e8880cf379f49$var$_default() {
    return $0b4e8880cf379f49$var$lineRadial((0, $0b4e8880cf379f49$var$_line.default)().curve($0b4e8880cf379f49$var$_radial.curveRadialLinear));
}

});


parcelRegister("8OKT5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $66b75d220ef8b5ce$var$_default;
function $66b75d220ef8b5ce$var$_default(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}

});

parcelRegister("cpy0u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.link = $909232e2faa98543$var$link;
module.exports.linkHorizontal = $909232e2faa98543$var$linkHorizontal;
module.exports.linkRadial = $909232e2faa98543$var$linkRadial;
module.exports.linkVertical = $909232e2faa98543$var$linkVertical;

var $dNWUS = parcelRequire("dNWUS");

var $ch2fZ = parcelRequire("ch2fZ");

var $909232e2faa98543$var$_constant = $909232e2faa98543$var$_interopRequireDefault((parcelRequire("gDtoD")));

var $4MXpk = parcelRequire("4MXpk");

var $7f7dq = parcelRequire("7f7dq");
function $909232e2faa98543$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $909232e2faa98543$var$linkSource(d) {
    return d.source;
}
function $909232e2faa98543$var$linkTarget(d) {
    return d.target;
}
function $909232e2faa98543$var$link(curve) {
    let source = $909232e2faa98543$var$linkSource;
    let target = $909232e2faa98543$var$linkTarget;
    let x = $7f7dq.x;
    let y = $7f7dq.y;
    let context = null;
    let output = null;
    function link() {
        let buffer;
        const argv = $ch2fZ.slice.call(arguments);
        const s = source.apply(this, argv);
        const t = target.apply(this, argv);
        if (context == null) output = curve(buffer = (0, $dNWUS.path)());
        output.lineStart();
        argv[0] = s, output.point(+x.apply(this, argv), +y.apply(this, argv));
        argv[0] = t, output.point(+x.apply(this, argv), +y.apply(this, argv));
        output.lineEnd();
        if (buffer) return output = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $909232e2faa98543$var$_constant.default)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $909232e2faa98543$var$_constant.default)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
    };
    return link;
}
function $909232e2faa98543$var$linkHorizontal() {
    return $909232e2faa98543$var$link($4MXpk.bumpX);
}
function $909232e2faa98543$var$linkVertical() {
    return $909232e2faa98543$var$link($4MXpk.bumpY);
}
function $909232e2faa98543$var$linkRadial() {
    const l = $909232e2faa98543$var$link($4MXpk.bumpRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}

});
parcelRegister("4MXpk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bumpRadial = $37c9ba3b02db65d5$var$bumpRadial;
module.exports.bumpX = $37c9ba3b02db65d5$var$bumpX;
module.exports.bumpY = $37c9ba3b02db65d5$var$bumpY;

var $37c9ba3b02db65d5$var$_pointRadial = $37c9ba3b02db65d5$var$_interopRequireDefault((parcelRequire("8OKT5")));
function $37c9ba3b02db65d5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
class $37c9ba3b02db65d5$var$Bump {
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
}
class $37c9ba3b02db65d5$var$BumpRadial {
    constructor(context){
        this._context = context;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {}
    point(x, y) {
        x = +x, y = +y;
        if (this._point++ === 0) this._x0 = x, this._y0 = y;
        else {
            const p0 = (0, $37c9ba3b02db65d5$var$_pointRadial.default)(this._x0, this._y0);
            const p1 = (0, $37c9ba3b02db65d5$var$_pointRadial.default)(this._x0, this._y0 = (this._y0 + y) / 2);
            const p2 = (0, $37c9ba3b02db65d5$var$_pointRadial.default)(x, this._y0);
            const p3 = (0, $37c9ba3b02db65d5$var$_pointRadial.default)(x, y);
            this._context.moveTo(...p0);
            this._context.bezierCurveTo(...p1, ...p2, ...p3);
        }
    }
}
function $37c9ba3b02db65d5$var$bumpX(context) {
    return new $37c9ba3b02db65d5$var$Bump(context, true);
}
function $37c9ba3b02db65d5$var$bumpY(context) {
    return new $37c9ba3b02db65d5$var$Bump(context, false);
}
function $37c9ba3b02db65d5$var$bumpRadial(context) {
    return new $37c9ba3b02db65d5$var$BumpRadial(context);
}

});


parcelRegister("eeZLq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a5e24887a19e0b66$var$Symbol;
module.exports.symbolsStroke = module.exports.symbolsFill = void 0;

var $dNWUS = parcelRequire("dNWUS");

var $a5e24887a19e0b66$var$_constant = $a5e24887a19e0b66$var$_interopRequireDefault((parcelRequire("gDtoD")));

var $a5e24887a19e0b66$var$_asterisk = $a5e24887a19e0b66$var$_interopRequireDefault((parcelRequire("l5m8Z")));

var $a5e24887a19e0b66$var$_circle = $a5e24887a19e0b66$var$_interopRequireDefault((parcelRequire("hSzX3")));

var $a5e24887a19e0b66$var$_cross = $a5e24887a19e0b66$var$_interopRequireDefault((parcelRequire("jyGRv")));

var $a5e24887a19e0b66$var$_diamond = $a5e24887a19e0b66$var$_interopRequireDefault((parcelRequire("2ZjM9")));

var $a5e24887a19e0b66$var$_diamond2 = $a5e24887a19e0b66$var$_interopRequireDefault((parcelRequire("lTMyx")));

var $a5e24887a19e0b66$var$_plus = $a5e24887a19e0b66$var$_interopRequireDefault((parcelRequire("eerbl")));

var $a5e24887a19e0b66$var$_square = $a5e24887a19e0b66$var$_interopRequireDefault((parcelRequire("gjj6e")));

var $a5e24887a19e0b66$var$_square2 = $a5e24887a19e0b66$var$_interopRequireDefault((parcelRequire("71dU9")));

var $a5e24887a19e0b66$var$_star = $a5e24887a19e0b66$var$_interopRequireDefault((parcelRequire("cr0Xc")));

var $a5e24887a19e0b66$var$_triangle = $a5e24887a19e0b66$var$_interopRequireDefault((parcelRequire("5vNh7")));

var $a5e24887a19e0b66$var$_triangle2 = $a5e24887a19e0b66$var$_interopRequireDefault((parcelRequire("coYKj")));

var $a5e24887a19e0b66$var$_wye = $a5e24887a19e0b66$var$_interopRequireDefault((parcelRequire("hf1k2")));

var $a5e24887a19e0b66$var$_x = $a5e24887a19e0b66$var$_interopRequireDefault((parcelRequire("gbhSn")));
function $a5e24887a19e0b66$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// These symbols are designed to be filled.
const $a5e24887a19e0b66$var$symbolsFill = [
    $a5e24887a19e0b66$var$_circle.default,
    $a5e24887a19e0b66$var$_cross.default,
    $a5e24887a19e0b66$var$_diamond.default,
    $a5e24887a19e0b66$var$_square.default,
    $a5e24887a19e0b66$var$_star.default,
    $a5e24887a19e0b66$var$_triangle.default,
    $a5e24887a19e0b66$var$_wye.default
]; // These symbols are designed to be stroked (with a width of 1.5px and round caps).
module.exports.symbolsFill = $a5e24887a19e0b66$var$symbolsFill;
const $a5e24887a19e0b66$var$symbolsStroke = [
    $a5e24887a19e0b66$var$_circle.default,
    $a5e24887a19e0b66$var$_plus.default,
    $a5e24887a19e0b66$var$_x.default,
    $a5e24887a19e0b66$var$_triangle2.default,
    $a5e24887a19e0b66$var$_asterisk.default,
    $a5e24887a19e0b66$var$_square2.default,
    $a5e24887a19e0b66$var$_diamond2.default
];
module.exports.symbolsStroke = $a5e24887a19e0b66$var$symbolsStroke;
function $a5e24887a19e0b66$var$Symbol(type, size) {
    let context = null;
    type = typeof type === "function" ? type : (0, $a5e24887a19e0b66$var$_constant.default)(type || $a5e24887a19e0b66$var$_circle.default);
    size = typeof size === "function" ? size : (0, $a5e24887a19e0b66$var$_constant.default)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = (0, $dNWUS.path)();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $a5e24887a19e0b66$var$_constant.default)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $a5e24887a19e0b66$var$_constant.default)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}

});
parcelRegister("l5m8Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $60ffJ = parcelRequire("60ffJ");
const $f59b3df6728f169d$var$sqrt3 = (0, $60ffJ.sqrt)(3);
var $f59b3df6728f169d$var$_default = {
    draw (context, size) {
        const r = (0, $60ffJ.sqrt)(size + (0, $60ffJ.min)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * $f59b3df6728f169d$var$sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};
module.exports.default = $f59b3df6728f169d$var$_default;

});

parcelRegister("hSzX3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $60ffJ = parcelRequire("60ffJ");
var $d0435e05903f5983$var$_default = {
    draw (context, size) {
        const r = (0, $60ffJ.sqrt)(size / $60ffJ.pi);
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, $60ffJ.tau);
    }
};
module.exports.default = $d0435e05903f5983$var$_default;

});

parcelRegister("jyGRv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $60ffJ = parcelRequire("60ffJ");
var $e3d270cf07e196d1$var$_default = {
    draw (context, size) {
        const r = (0, $60ffJ.sqrt)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};
module.exports.default = $e3d270cf07e196d1$var$_default;

});

parcelRegister("2ZjM9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $60ffJ = parcelRequire("60ffJ");
const $22d09e4bf326cdf3$var$tan30 = (0, $60ffJ.sqrt)(1 / 3);
const $22d09e4bf326cdf3$var$tan30_2 = $22d09e4bf326cdf3$var$tan30 * 2;
var $22d09e4bf326cdf3$var$_default = {
    draw (context, size) {
        const y = (0, $60ffJ.sqrt)(size / $22d09e4bf326cdf3$var$tan30_2);
        const x = y * $22d09e4bf326cdf3$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};
module.exports.default = $22d09e4bf326cdf3$var$_default;

});

parcelRegister("lTMyx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $60ffJ = parcelRequire("60ffJ");
var $ff146641de7ef1c6$var$_default = {
    draw (context, size) {
        const r = (0, $60ffJ.sqrt)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};
module.exports.default = $ff146641de7ef1c6$var$_default;

});

parcelRegister("eerbl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $60ffJ = parcelRequire("60ffJ");
var $a5c7754536077dcb$var$_default = {
    draw (context, size) {
        const r = (0, $60ffJ.sqrt)(size - (0, $60ffJ.min)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};
module.exports.default = $a5c7754536077dcb$var$_default;

});

parcelRegister("gjj6e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $60ffJ = parcelRequire("60ffJ");
var $bdfd3c78dc378e37$var$_default = {
    draw (context, size) {
        const w = (0, $60ffJ.sqrt)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};
module.exports.default = $bdfd3c78dc378e37$var$_default;

});

parcelRegister("71dU9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $60ffJ = parcelRequire("60ffJ");
var $51c369986553f93e$var$_default = {
    draw (context, size) {
        const r = (0, $60ffJ.sqrt)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};
module.exports.default = $51c369986553f93e$var$_default;

});

parcelRegister("cr0Xc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $60ffJ = parcelRequire("60ffJ");
const $90d8bf129685f219$var$ka = 0.89081309152928522810;
const $90d8bf129685f219$var$kr = (0, $60ffJ.sin)($60ffJ.pi / 10) / (0, $60ffJ.sin)(7 * $60ffJ.pi / 10);
const $90d8bf129685f219$var$kx = (0, $60ffJ.sin)($60ffJ.tau / 10) * $90d8bf129685f219$var$kr;
const $90d8bf129685f219$var$ky = -(0, $60ffJ.cos)($60ffJ.tau / 10) * $90d8bf129685f219$var$kr;
var $90d8bf129685f219$var$_default = {
    draw (context, size) {
        const r = (0, $60ffJ.sqrt)(size * $90d8bf129685f219$var$ka);
        const x = $90d8bf129685f219$var$kx * r;
        const y = $90d8bf129685f219$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = $60ffJ.tau * i / 5;
            const c = (0, $60ffJ.cos)(a);
            const s = (0, $60ffJ.sin)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};
module.exports.default = $90d8bf129685f219$var$_default;

});

parcelRegister("5vNh7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $60ffJ = parcelRequire("60ffJ");
const $40361206580dc9e5$var$sqrt3 = (0, $60ffJ.sqrt)(3);
var $40361206580dc9e5$var$_default = {
    draw (context, size) {
        const y = -(0, $60ffJ.sqrt)(size / ($40361206580dc9e5$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$40361206580dc9e5$var$sqrt3 * y, -y);
        context.lineTo($40361206580dc9e5$var$sqrt3 * y, -y);
        context.closePath();
    }
};
module.exports.default = $40361206580dc9e5$var$_default;

});

parcelRegister("coYKj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $60ffJ = parcelRequire("60ffJ");
const $9076d8d6058cd18f$var$sqrt3 = (0, $60ffJ.sqrt)(3);
var $9076d8d6058cd18f$var$_default = {
    draw (context, size) {
        const s = (0, $60ffJ.sqrt)(size) * 0.6824;
        const t = s / 2;
        const u = s * $9076d8d6058cd18f$var$sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};
module.exports.default = $9076d8d6058cd18f$var$_default;

});

parcelRegister("hf1k2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $60ffJ = parcelRequire("60ffJ");
const $c8d4dceb24448700$var$c = -0.5;
const $c8d4dceb24448700$var$s = (0, $60ffJ.sqrt)(3) / 2;
const $c8d4dceb24448700$var$k = 1 / (0, $60ffJ.sqrt)(12);
const $c8d4dceb24448700$var$a = ($c8d4dceb24448700$var$k / 2 + 1) * 3;
var $c8d4dceb24448700$var$_default = {
    draw (context, size) {
        const r = (0, $60ffJ.sqrt)(size / $c8d4dceb24448700$var$a);
        const x0 = r / 2, y0 = r * $c8d4dceb24448700$var$k;
        const x1 = x0, y1 = r * $c8d4dceb24448700$var$k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($c8d4dceb24448700$var$c * x0 - $c8d4dceb24448700$var$s * y0, $c8d4dceb24448700$var$s * x0 + $c8d4dceb24448700$var$c * y0);
        context.lineTo($c8d4dceb24448700$var$c * x1 - $c8d4dceb24448700$var$s * y1, $c8d4dceb24448700$var$s * x1 + $c8d4dceb24448700$var$c * y1);
        context.lineTo($c8d4dceb24448700$var$c * x2 - $c8d4dceb24448700$var$s * y2, $c8d4dceb24448700$var$s * x2 + $c8d4dceb24448700$var$c * y2);
        context.lineTo($c8d4dceb24448700$var$c * x0 + $c8d4dceb24448700$var$s * y0, $c8d4dceb24448700$var$c * y0 - $c8d4dceb24448700$var$s * x0);
        context.lineTo($c8d4dceb24448700$var$c * x1 + $c8d4dceb24448700$var$s * y1, $c8d4dceb24448700$var$c * y1 - $c8d4dceb24448700$var$s * x1);
        context.lineTo($c8d4dceb24448700$var$c * x2 + $c8d4dceb24448700$var$s * y2, $c8d4dceb24448700$var$c * y2 - $c8d4dceb24448700$var$s * x2);
        context.closePath();
    }
};
module.exports.default = $c8d4dceb24448700$var$_default;

});

parcelRegister("gbhSn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $60ffJ = parcelRequire("60ffJ");
var $bc7b8a394f6c732f$var$_default = {
    draw (context, size) {
        const r = (0, $60ffJ.sqrt)(size - (0, $60ffJ.min)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};
module.exports.default = $bc7b8a394f6c732f$var$_default;

});


parcelRegister("eh8Jo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a6496d0bdf20dd08$var$_default;

var $a6496d0bdf20dd08$var$_noop = $a6496d0bdf20dd08$var$_interopRequireDefault((parcelRequire("kThR3")));

var $3EuEO = parcelRequire("3EuEO");
function $a6496d0bdf20dd08$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a6496d0bdf20dd08$var$BasisClosed(context) {
    this._context = context;
}
$a6496d0bdf20dd08$var$BasisClosed.prototype = {
    areaStart: $a6496d0bdf20dd08$var$_noop.default,
    areaEnd: $a6496d0bdf20dd08$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $3EuEO.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $a6496d0bdf20dd08$var$_default(context) {
    return new $a6496d0bdf20dd08$var$BasisClosed(context);
}

});
parcelRegister("kThR3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f356cb422292a460$var$_default;
function $f356cb422292a460$var$_default() {}

});

parcelRegister("3EuEO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Basis = $2a8ce369db0db328$var$Basis;
module.exports.default = $2a8ce369db0db328$var$_default;
module.exports.point = $2a8ce369db0db328$var$point;
function $2a8ce369db0db328$var$point(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $2a8ce369db0db328$var$Basis(context) {
    this._context = context;
}
$2a8ce369db0db328$var$Basis.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $2a8ce369db0db328$var$point(this, this._x1, this._y1);
            // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
            // falls through
            default:
                $2a8ce369db0db328$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $2a8ce369db0db328$var$_default(context) {
    return new $2a8ce369db0db328$var$Basis(context);
}

});


parcelRegister("2E93i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1ed656c5962b24da$var$_default;

var $3EuEO = parcelRequire("3EuEO");
function $1ed656c5962b24da$var$BasisOpen(context) {
    this._context = context;
}
$1ed656c5962b24da$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $3EuEO.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $1ed656c5962b24da$var$_default(context) {
    return new $1ed656c5962b24da$var$BasisOpen(context);
}

});

parcelRegister("kQY6H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3EuEO = parcelRequire("3EuEO");
function $f2e749ff81bb9c45$var$Bundle(context, beta) {
    this._basis = new $3EuEO.Basis(context);
    this._beta = beta;
}
$f2e749ff81bb9c45$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $f2e749ff81bb9c45$var$_default = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new $3EuEO.Basis(context) : new $f2e749ff81bb9c45$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);
module.exports.default = $f2e749ff81bb9c45$var$_default;

});

parcelRegister("3PCrm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalClosed = $2ca3f3f96e46424f$var$CardinalClosed;
module.exports.default = void 0;

var $2ca3f3f96e46424f$var$_noop = $2ca3f3f96e46424f$var$_interopRequireDefault((parcelRequire("kThR3")));

var $iwBwh = parcelRequire("iwBwh");
function $2ca3f3f96e46424f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2ca3f3f96e46424f$var$CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$2ca3f3f96e46424f$var$CardinalClosed.prototype = {
    areaStart: $2ca3f3f96e46424f$var$_noop.default,
    areaEnd: $2ca3f3f96e46424f$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $iwBwh.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $2ca3f3f96e46424f$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $2ca3f3f96e46424f$var$CardinalClosed(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $2ca3f3f96e46424f$var$_default;

});
parcelRegister("iwBwh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cardinal = $d7c851c85b1d7e90$var$Cardinal;
module.exports.default = void 0;
module.exports.point = $d7c851c85b1d7e90$var$point;
function $d7c851c85b1d7e90$var$point(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $d7c851c85b1d7e90$var$Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$d7c851c85b1d7e90$var$Cardinal.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $d7c851c85b1d7e90$var$point(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                $d7c851c85b1d7e90$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $d7c851c85b1d7e90$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $d7c851c85b1d7e90$var$Cardinal(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $d7c851c85b1d7e90$var$_default;

});


parcelRegister("5raP3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalOpen = $3f57de7dbd1a5b6d$var$CardinalOpen;
module.exports.default = void 0;

var $iwBwh = parcelRequire("iwBwh");
function $3f57de7dbd1a5b6d$var$CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$3f57de7dbd1a5b6d$var$CardinalOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $iwBwh.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $3f57de7dbd1a5b6d$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $3f57de7dbd1a5b6d$var$CardinalOpen(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $3f57de7dbd1a5b6d$var$_default;

});

parcelRegister("dEO7A", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3PCrm = parcelRequire("3PCrm");

var $9f15e3d4ddd94fe6$var$_noop = $9f15e3d4ddd94fe6$var$_interopRequireDefault((parcelRequire("kThR3")));

var $iBjsd = parcelRequire("iBjsd");
function $9f15e3d4ddd94fe6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9f15e3d4ddd94fe6$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$9f15e3d4ddd94fe6$var$CatmullRomClosed.prototype = {
    areaStart: $9f15e3d4ddd94fe6$var$_noop.default,
    areaEnd: $9f15e3d4ddd94fe6$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $iBjsd.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $9f15e3d4ddd94fe6$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $9f15e3d4ddd94fe6$var$CatmullRomClosed(context, alpha) : new $3PCrm.CardinalClosed(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $9f15e3d4ddd94fe6$var$_default;

});
parcelRegister("iBjsd", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.point = point;

var $60ffJ = parcelRequire("60ffJ");

var $iwBwh = parcelRequire("iwBwh");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > $60ffJ.epsilon) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > $60ffJ.epsilon) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new $iwBwh.Cardinal(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
exports.default = _default;

});


parcelRegister("eiz6l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5raP3 = parcelRequire("5raP3");

var $iBjsd = parcelRequire("iBjsd");
function $a68df9824d9a05e9$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$a68df9824d9a05e9$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $iBjsd.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $a68df9824d9a05e9$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $a68df9824d9a05e9$var$CatmullRomOpen(context, alpha) : new $5raP3.CardinalOpen(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $a68df9824d9a05e9$var$_default;

});

parcelRegister("3tVed", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $289078dce2f15efc$var$_default;

var $289078dce2f15efc$var$_noop = $289078dce2f15efc$var$_interopRequireDefault((parcelRequire("kThR3")));
function $289078dce2f15efc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $289078dce2f15efc$var$LinearClosed(context) {
    this._context = context;
}
$289078dce2f15efc$var$LinearClosed.prototype = {
    areaStart: $289078dce2f15efc$var$_noop.default,
    areaEnd: $289078dce2f15efc$var$_noop.default,
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $289078dce2f15efc$var$_default(context) {
    return new $289078dce2f15efc$var$LinearClosed(context);
}

});

parcelRegister("4Jk9g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.monotoneX = $371afe745ae47316$var$monotoneX;
module.exports.monotoneY = $371afe745ae47316$var$monotoneY;
function $371afe745ae47316$var$sign(x) {
    return x < 0 ? -1 : 1;
} // Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $371afe745ae47316$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($371afe745ae47316$var$sign(s0) + $371afe745ae47316$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
} // Calculate a one-sided slope.
function $371afe745ae47316$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
} // According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $371afe745ae47316$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $371afe745ae47316$var$MonotoneX(context) {
    this._context = context;
}
$371afe745ae47316$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $371afe745ae47316$var$point(this, this._t0, $371afe745ae47316$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $371afe745ae47316$var$point(this, $371afe745ae47316$var$slope2(this, t1 = $371afe745ae47316$var$slope3(this, x, y)), t1);
                break;
            default:
                $371afe745ae47316$var$point(this, this._t0, t1 = $371afe745ae47316$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $371afe745ae47316$var$MonotoneY(context) {
    this._context = new $371afe745ae47316$var$ReflectContext(context);
}
($371afe745ae47316$var$MonotoneY.prototype = Object.create($371afe745ae47316$var$MonotoneX.prototype)).point = function(x, y) {
    $371afe745ae47316$var$MonotoneX.prototype.point.call(this, y, x);
};
function $371afe745ae47316$var$ReflectContext(context) {
    this._context = context;
}
$371afe745ae47316$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $371afe745ae47316$var$monotoneX(context) {
    return new $371afe745ae47316$var$MonotoneX(context);
}
function $371afe745ae47316$var$monotoneY(context) {
    return new $371afe745ae47316$var$MonotoneY(context);
}

});

parcelRegister("83UOo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5deaac2c3cfce2b4$var$_default;
function $5deaac2c3cfce2b4$var$Natural(context) {
    this._context = context;
}
$5deaac2c3cfce2b4$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $5deaac2c3cfce2b4$var$controlPoints(x), py = $5deaac2c3cfce2b4$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
}; // See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $5deaac2c3cfce2b4$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $5deaac2c3cfce2b4$var$_default(context) {
    return new $5deaac2c3cfce2b4$var$Natural(context);
}

});

parcelRegister("8Jhdf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $65afe0c3c0feaf16$var$_default;
module.exports.stepAfter = $65afe0c3c0feaf16$var$stepAfter;
module.exports.stepBefore = $65afe0c3c0feaf16$var$stepBefore;
function $65afe0c3c0feaf16$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$65afe0c3c0feaf16$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $65afe0c3c0feaf16$var$_default(context) {
    return new $65afe0c3c0feaf16$var$Step(context, 0.5);
}
function $65afe0c3c0feaf16$var$stepBefore(context) {
    return new $65afe0c3c0feaf16$var$Step(context, 0);
}
function $65afe0c3c0feaf16$var$stepAfter(context) {
    return new $65afe0c3c0feaf16$var$Step(context, 1);
}

});

parcelRegister("7vkE1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $576b713df25eeb8f$var$_default;

var $576b713df25eeb8f$var$_array = $576b713df25eeb8f$var$_interopRequireDefault((parcelRequire("ch2fZ")));

var $576b713df25eeb8f$var$_constant = $576b713df25eeb8f$var$_interopRequireDefault((parcelRequire("gDtoD")));

var $576b713df25eeb8f$var$_none = $576b713df25eeb8f$var$_interopRequireDefault((parcelRequire("gOvxF")));

var $576b713df25eeb8f$var$_none2 = $576b713df25eeb8f$var$_interopRequireDefault((parcelRequire("3Lnbc")));
function $576b713df25eeb8f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $576b713df25eeb8f$var$stackValue(d, key) {
    return d[key];
}
function $576b713df25eeb8f$var$stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function $576b713df25eeb8f$var$_default() {
    var keys = (0, $576b713df25eeb8f$var$_constant.default)([]), order = $576b713df25eeb8f$var$_none2.default, offset = $576b713df25eeb8f$var$_none.default, value = $576b713df25eeb8f$var$stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), $576b713df25eeb8f$var$stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, $576b713df25eeb8f$var$_array.default)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $576b713df25eeb8f$var$_constant.default)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $576b713df25eeb8f$var$_constant.default)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? $576b713df25eeb8f$var$_none2.default : typeof _ === "function" ? _ : (0, $576b713df25eeb8f$var$_constant.default)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? $576b713df25eeb8f$var$_none.default : _, stack) : offset;
    };
    return stack;
}

});
parcelRegister("gOvxF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c3d9c86bb07ea953$var$_default;
function $c3d9c86bb07ea953$var$_default(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}

});

parcelRegister("3Lnbc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2bd7bddde5100763$var$_default;
function $2bd7bddde5100763$var$_default(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}

});


parcelRegister("67EXt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $47532afc4286de81$var$_default;

var $47532afc4286de81$var$_none = $47532afc4286de81$var$_interopRequireDefault((parcelRequire("gOvxF")));
function $47532afc4286de81$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $47532afc4286de81$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $47532afc4286de81$var$_none.default)(series, order);
}

});

parcelRegister("gp8Em", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bf15b0dcfec18459$var$_default;
function $bf15b0dcfec18459$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}

});

parcelRegister("fxXhn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b517ebb8b8866b3f$var$_default;

var $b517ebb8b8866b3f$var$_none = $b517ebb8b8866b3f$var$_interopRequireDefault((parcelRequire("gOvxF")));
function $b517ebb8b8866b3f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b517ebb8b8866b3f$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $b517ebb8b8866b3f$var$_none.default)(series, order);
}

});

parcelRegister("ePR5y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $accf026186bdea7c$var$_default;

var $accf026186bdea7c$var$_none = $accf026186bdea7c$var$_interopRequireDefault((parcelRequire("gOvxF")));
function $accf026186bdea7c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $accf026186bdea7c$var$_default(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $accf026186bdea7c$var$_none.default)(series, order);
}

});

parcelRegister("bHp1I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $88471fa3433f53c0$var$_default;

var $88471fa3433f53c0$var$_none = $88471fa3433f53c0$var$_interopRequireDefault((parcelRequire("3Lnbc")));
function $88471fa3433f53c0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $88471fa3433f53c0$var$_default(series) {
    var peaks = series.map($88471fa3433f53c0$var$peak);
    return (0, $88471fa3433f53c0$var$_none.default)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function $88471fa3433f53c0$var$peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

});

parcelRegister("inuiw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d611e079cd3171df$var$_default;
module.exports.sum = $d611e079cd3171df$var$sum;

var $d611e079cd3171df$var$_none = $d611e079cd3171df$var$_interopRequireDefault((parcelRequire("3Lnbc")));
function $d611e079cd3171df$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d611e079cd3171df$var$_default(series) {
    var sums = series.map($d611e079cd3171df$var$sum);
    return (0, $d611e079cd3171df$var$_none.default)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $d611e079cd3171df$var$sum(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

});

parcelRegister("bco5c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $82737f0bf7a01f75$var$_default;

var $82737f0bf7a01f75$var$_ascending = $82737f0bf7a01f75$var$_interopRequireDefault((parcelRequire("inuiw")));
function $82737f0bf7a01f75$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $82737f0bf7a01f75$var$_default(series) {
    return (0, $82737f0bf7a01f75$var$_ascending.default)(series).reverse();
}

});

parcelRegister("bYOrm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8b8c6cb6db5f4895$var$_default;

var $8b8c6cb6db5f4895$var$_appearance = $8b8c6cb6db5f4895$var$_interopRequireDefault((parcelRequire("bHp1I")));

var $inuiw = parcelRequire("inuiw");
function $8b8c6cb6db5f4895$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8b8c6cb6db5f4895$var$_default(series) {
    var n = series.length, i, j, sums = series.map($inuiw.sum), order = (0, $8b8c6cb6db5f4895$var$_appearance.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}

});

parcelRegister("dATyF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9e59bbd38dd921d5$var$_default;

var $9e59bbd38dd921d5$var$_none = $9e59bbd38dd921d5$var$_interopRequireDefault((parcelRequire("3Lnbc")));
function $9e59bbd38dd921d5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9e59bbd38dd921d5$var$_default(series) {
    return (0, $9e59bbd38dd921d5$var$_none.default)(series).reverse();
}

});




parcelRegister("gBhCn", function(module, exports) {

$parcel$export(module.exports, "SVGElementPropKeys", function () { return $c15dc49a8fce810e$export$190f430946f96110; });
$parcel$export(module.exports, "FilteredElementKeyMap", function () { return $c15dc49a8fce810e$export$2b22758266a6fa48; });
$parcel$export(module.exports, "EventKeys", function () { return $c15dc49a8fce810e$export$f30789245f2c4d11; });
$parcel$export(module.exports, "adaptEventHandlers", function () { return $c15dc49a8fce810e$export$7c4c290a4a9c1b1e; });
$parcel$export(module.exports, "adaptEventsOfChild", function () { return $c15dc49a8fce810e$export$ca62be0d67a3158c; });

var $jbmdS = parcelRequire("jbmdS");

var $hBKZ2 = parcelRequire("hBKZ2");
function $c15dc49a8fce810e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c15dc49a8fce810e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c15dc49a8fce810e$var$_typeof(o);
}
/**
 * Determines how values are stacked:
 *
 * - `none` is the default, it adds values on top of each other. No smarts. Negative values will overlap.
 * - `expand` make it so that the values always add up to 1 - so the chart will look like a rectangle.
 * - `wiggle` and `silhouette` tries to keep the chart centered.
 * - `sign` stacks positive values above zero and negative values below zero. Similar to `none` but handles negatives.
 * - `positive` ignores all negative values, and then behaves like \`none\`.
 *
 * Also see https://d3js.org/d3-shape/stack#stack-offsets
 * (note that the `diverging` offset in d3 is named `sign` in recharts)
 */ //
// Event Handler Types -- Copied from @types/react/index.d.ts and adapted for Props.
//
var $c15dc49a8fce810e$var$SVGContainerPropKeys = [
    "viewBox",
    "children"
];
var $c15dc49a8fce810e$export$190f430946f96110 = [
    "aria-activedescendant",
    "aria-atomic",
    "aria-autocomplete",
    "aria-busy",
    "aria-checked",
    "aria-colcount",
    "aria-colindex",
    "aria-colspan",
    "aria-controls",
    "aria-current",
    "aria-describedby",
    "aria-details",
    "aria-disabled",
    "aria-errormessage",
    "aria-expanded",
    "aria-flowto",
    "aria-haspopup",
    "aria-hidden",
    "aria-invalid",
    "aria-keyshortcuts",
    "aria-label",
    "aria-labelledby",
    "aria-level",
    "aria-live",
    "aria-modal",
    "aria-multiline",
    "aria-multiselectable",
    "aria-orientation",
    "aria-owns",
    "aria-placeholder",
    "aria-posinset",
    "aria-pressed",
    "aria-readonly",
    "aria-relevant",
    "aria-required",
    "aria-roledescription",
    "aria-rowcount",
    "aria-rowindex",
    "aria-rowspan",
    "aria-selected",
    "aria-setsize",
    "aria-sort",
    "aria-valuemax",
    "aria-valuemin",
    "aria-valuenow",
    "aria-valuetext",
    "className",
    "color",
    "height",
    "id",
    "lang",
    "max",
    "media",
    "method",
    "min",
    "name",
    "style",
    /*
 * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
 * that can use it and it conflicts with the recharts prop 'type'
 * https://github.com/recharts/recharts/pull/3327
 * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
 */ // 'type',
    "target",
    "width",
    "role",
    "tabIndex",
    "accentHeight",
    "accumulate",
    "additive",
    "alignmentBaseline",
    "allowReorder",
    "alphabetic",
    "amplitude",
    "arabicForm",
    "ascent",
    "attributeName",
    "attributeType",
    "autoReverse",
    "azimuth",
    "baseFrequency",
    "baselineShift",
    "baseProfile",
    "bbox",
    "begin",
    "bias",
    "by",
    "calcMode",
    "capHeight",
    "clip",
    "clipPath",
    "clipPathUnits",
    "clipRule",
    "colorInterpolation",
    "colorInterpolationFilters",
    "colorProfile",
    "colorRendering",
    "contentScriptType",
    "contentStyleType",
    "cursor",
    "cx",
    "cy",
    "d",
    "decelerate",
    "descent",
    "diffuseConstant",
    "direction",
    "display",
    "divisor",
    "dominantBaseline",
    "dur",
    "dx",
    "dy",
    "edgeMode",
    "elevation",
    "enableBackground",
    "end",
    "exponent",
    "externalResourcesRequired",
    "fill",
    "fillOpacity",
    "fillRule",
    "filter",
    "filterRes",
    "filterUnits",
    "floodColor",
    "floodOpacity",
    "focusable",
    "fontFamily",
    "fontSize",
    "fontSizeAdjust",
    "fontStretch",
    "fontStyle",
    "fontVariant",
    "fontWeight",
    "format",
    "from",
    "fx",
    "fy",
    "g1",
    "g2",
    "glyphName",
    "glyphOrientationHorizontal",
    "glyphOrientationVertical",
    "glyphRef",
    "gradientTransform",
    "gradientUnits",
    "hanging",
    "horizAdvX",
    "horizOriginX",
    "href",
    "ideographic",
    "imageRendering",
    "in2",
    "in",
    "intercept",
    "k1",
    "k2",
    "k3",
    "k4",
    "k",
    "kernelMatrix",
    "kernelUnitLength",
    "kerning",
    "keyPoints",
    "keySplines",
    "keyTimes",
    "lengthAdjust",
    "letterSpacing",
    "lightingColor",
    "limitingConeAngle",
    "local",
    "markerEnd",
    "markerHeight",
    "markerMid",
    "markerStart",
    "markerUnits",
    "markerWidth",
    "mask",
    "maskContentUnits",
    "maskUnits",
    "mathematical",
    "mode",
    "numOctaves",
    "offset",
    "opacity",
    "operator",
    "order",
    "orient",
    "orientation",
    "origin",
    "overflow",
    "overlinePosition",
    "overlineThickness",
    "paintOrder",
    "panose1",
    "pathLength",
    "patternContentUnits",
    "patternTransform",
    "patternUnits",
    "pointerEvents",
    "pointsAtX",
    "pointsAtY",
    "pointsAtZ",
    "preserveAlpha",
    "preserveAspectRatio",
    "primitiveUnits",
    "r",
    "radius",
    "refX",
    "refY",
    "renderingIntent",
    "repeatCount",
    "repeatDur",
    "requiredExtensions",
    "requiredFeatures",
    "restart",
    "result",
    "rotate",
    "rx",
    "ry",
    "seed",
    "shapeRendering",
    "slope",
    "spacing",
    "specularConstant",
    "specularExponent",
    "speed",
    "spreadMethod",
    "startOffset",
    "stdDeviation",
    "stemh",
    "stemv",
    "stitchTiles",
    "stopColor",
    "stopOpacity",
    "strikethroughPosition",
    "strikethroughThickness",
    "string",
    "stroke",
    "strokeDasharray",
    "strokeDashoffset",
    "strokeLinecap",
    "strokeLinejoin",
    "strokeMiterlimit",
    "strokeOpacity",
    "strokeWidth",
    "surfaceScale",
    "systemLanguage",
    "tableValues",
    "targetX",
    "targetY",
    "textAnchor",
    "textDecoration",
    "textLength",
    "textRendering",
    "to",
    "transform",
    "u1",
    "u2",
    "underlinePosition",
    "underlineThickness",
    "unicode",
    "unicodeBidi",
    "unicodeRange",
    "unitsPerEm",
    "vAlphabetic",
    "values",
    "vectorEffect",
    "version",
    "vertAdvY",
    "vertOriginX",
    "vertOriginY",
    "vHanging",
    "vIdeographic",
    "viewTarget",
    "visibility",
    "vMathematical",
    "widths",
    "wordSpacing",
    "writingMode",
    "x1",
    "x2",
    "x",
    "xChannelSelector",
    "xHeight",
    "xlinkActuate",
    "xlinkArcrole",
    "xlinkHref",
    "xlinkRole",
    "xlinkShow",
    "xlinkTitle",
    "xlinkType",
    "xmlBase",
    "xmlLang",
    "xmlns",
    "xmlnsXlink",
    "xmlSpace",
    "y1",
    "y2",
    "y",
    "yChannelSelector",
    "z",
    "zoomAndPan",
    "ref",
    "key",
    "angle"
];
var $c15dc49a8fce810e$var$PolyElementKeys = [
    "points",
    "pathLength"
];
var $c15dc49a8fce810e$export$2b22758266a6fa48 = {
    svg: $c15dc49a8fce810e$var$SVGContainerPropKeys,
    polygon: $c15dc49a8fce810e$var$PolyElementKeys,
    polyline: $c15dc49a8fce810e$var$PolyElementKeys
};
var $c15dc49a8fce810e$export$f30789245f2c4d11 = [
    "dangerouslySetInnerHTML",
    "onCopy",
    "onCopyCapture",
    "onCut",
    "onCutCapture",
    "onPaste",
    "onPasteCapture",
    "onCompositionEnd",
    "onCompositionEndCapture",
    "onCompositionStart",
    "onCompositionStartCapture",
    "onCompositionUpdate",
    "onCompositionUpdateCapture",
    "onFocus",
    "onFocusCapture",
    "onBlur",
    "onBlurCapture",
    "onChange",
    "onChangeCapture",
    "onBeforeInput",
    "onBeforeInputCapture",
    "onInput",
    "onInputCapture",
    "onReset",
    "onResetCapture",
    "onSubmit",
    "onSubmitCapture",
    "onInvalid",
    "onInvalidCapture",
    "onLoad",
    "onLoadCapture",
    "onError",
    "onErrorCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyPress",
    "onKeyPressCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onAbort",
    "onAbortCapture",
    "onCanPlay",
    "onCanPlayCapture",
    "onCanPlayThrough",
    "onCanPlayThroughCapture",
    "onDurationChange",
    "onDurationChangeCapture",
    "onEmptied",
    "onEmptiedCapture",
    "onEncrypted",
    "onEncryptedCapture",
    "onEnded",
    "onEndedCapture",
    "onLoadedData",
    "onLoadedDataCapture",
    "onLoadedMetadata",
    "onLoadedMetadataCapture",
    "onLoadStart",
    "onLoadStartCapture",
    "onPause",
    "onPauseCapture",
    "onPlay",
    "onPlayCapture",
    "onPlaying",
    "onPlayingCapture",
    "onProgress",
    "onProgressCapture",
    "onRateChange",
    "onRateChangeCapture",
    "onSeeked",
    "onSeekedCapture",
    "onSeeking",
    "onSeekingCapture",
    "onStalled",
    "onStalledCapture",
    "onSuspend",
    "onSuspendCapture",
    "onTimeUpdate",
    "onTimeUpdateCapture",
    "onVolumeChange",
    "onVolumeChangeCapture",
    "onWaiting",
    "onWaitingCapture",
    "onAuxClick",
    "onAuxClickCapture",
    "onClick",
    "onClickCapture",
    "onContextMenu",
    "onContextMenuCapture",
    "onDoubleClick",
    "onDoubleClickCapture",
    "onDrag",
    "onDragCapture",
    "onDragEnd",
    "onDragEndCapture",
    "onDragEnter",
    "onDragEnterCapture",
    "onDragExit",
    "onDragExitCapture",
    "onDragLeave",
    "onDragLeaveCapture",
    "onDragOver",
    "onDragOverCapture",
    "onDragStart",
    "onDragStartCapture",
    "onDrop",
    "onDropCapture",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseMove",
    "onMouseMoveCapture",
    "onMouseOut",
    "onMouseOutCapture",
    "onMouseOver",
    "onMouseOverCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onSelect",
    "onSelectCapture",
    "onTouchCancel",
    "onTouchCancelCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onTouchMove",
    "onTouchMoveCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerMove",
    "onPointerMoveCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onPointerCancel",
    "onPointerCancelCapture",
    "onPointerEnter",
    "onPointerEnterCapture",
    "onPointerLeave",
    "onPointerLeaveCapture",
    "onPointerOver",
    "onPointerOverCapture",
    "onPointerOut",
    "onPointerOutCapture",
    "onGotPointerCapture",
    "onGotPointerCaptureCapture",
    "onLostPointerCapture",
    "onLostPointerCaptureCapture",
    "onScroll",
    "onScrollCapture",
    "onWheel",
    "onWheelCapture",
    "onAnimationStart",
    "onAnimationStartCapture",
    "onAnimationEnd",
    "onAnimationEndCapture",
    "onAnimationIteration",
    "onAnimationIterationCapture",
    "onTransitionEnd",
    "onTransitionEndCapture"
];
var $c15dc49a8fce810e$export$7c4c290a4a9c1b1e = function adaptEventHandlers(props, newHandler) {
    if (!props || typeof props === "function" || typeof props === "boolean") return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $jbmdS.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hBKZ2)))(inputProps)) return null;
    var out = {};
    Object.keys(inputProps).forEach(function(key) {
        if ($c15dc49a8fce810e$export$f30789245f2c4d11.includes(key)) out[key] = newHandler || function(e) {
            return inputProps[key](inputProps, e);
        };
    });
    return out;
};
var $c15dc49a8fce810e$var$getEventHandlerOfChild = function getEventHandlerOfChild(originalHandler, data, index) {
    return function(e) {
        originalHandler(data, index, e);
        return null;
    };
};
var $c15dc49a8fce810e$export$ca62be0d67a3158c = function adaptEventsOfChild(props, data, index) {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hBKZ2)))(props) || $c15dc49a8fce810e$var$_typeof(props) !== "object") return null;
    var out = null;
    Object.keys(props).forEach(function(key) {
        var item = props[key];
        if ($c15dc49a8fce810e$export$f30789245f2c4d11.includes(key) && typeof item === "function") {
            if (!out) out = {};
            out[key] = $c15dc49a8fce810e$var$getEventHandlerOfChild(item, data, index);
        }
    });
    return out;
};

});

parcelRegister("f06D9", function(module, exports) {

$parcel$export(module.exports, "getDisplayName", function () { return $aebbffcbd3512418$export$be63e0664592e141; });
$parcel$export(module.exports, "findAllByType", function () { return $aebbffcbd3512418$export$fdd5e64c0e8495bb; });
$parcel$export(module.exports, "findChildByType", function () { return $aebbffcbd3512418$export$64c61536a2b72e0f; });
$parcel$export(module.exports, "validateWidthHeight", function () { return $aebbffcbd3512418$export$5301de6bfd3cfa2a; });
$parcel$export(module.exports, "hasClipDot", function () { return $aebbffcbd3512418$export$392f6c9701718a4e; });
$parcel$export(module.exports, "filterProps", function () { return $aebbffcbd3512418$export$d697c39a2985a4c; });
$parcel$export(module.exports, "isChildrenEqual", function () { return $aebbffcbd3512418$export$acdc716e08572f94; });
$parcel$export(module.exports, "renderByOrder", function () { return $aebbffcbd3512418$export$a98d6da55570cb82; });
$parcel$export(module.exports, "getReactEventByType", function () { return $aebbffcbd3512418$export$afb3591bc51a0b70; });
$parcel$export(module.exports, "parseChildIndex", function () { return $aebbffcbd3512418$export$857ca101f741953; });

var $lNQsK = parcelRequire("lNQsK");

var $aVX0M = parcelRequire("aVX0M");

var $aVvo3 = parcelRequire("aVvo3");

var $i99FY = parcelRequire("i99FY");

var $hBKZ2 = parcelRequire("hBKZ2");

var $jbmdS = parcelRequire("jbmdS");

var $6thKp = parcelRequire("6thKp");

var $1gmrG = parcelRequire("1gmrG");

var $cxCWI = parcelRequire("cxCWI");

var $gBhCn = parcelRequire("gBhCn");
var $aebbffcbd3512418$var$_excluded = [
    "children"
], $aebbffcbd3512418$var$_excluded2 = [
    "children"
];
function $aebbffcbd3512418$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $aebbffcbd3512418$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $aebbffcbd3512418$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $aebbffcbd3512418$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $aebbffcbd3512418$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $aebbffcbd3512418$var$_typeof(o);
}
var $aebbffcbd3512418$var$REACT_BROWSER_EVENT_MAP = {
    click: "onClick",
    mousedown: "onMouseDown",
    mouseup: "onMouseUp",
    mouseover: "onMouseOver",
    mousemove: "onMouseMove",
    mouseout: "onMouseOut",
    mouseenter: "onMouseEnter",
    mouseleave: "onMouseLeave",
    touchcancel: "onTouchCancel",
    touchend: "onTouchEnd",
    touchmove: "onTouchMove",
    touchstart: "onTouchStart",
    contextmenu: "onContextMenu",
    dblclick: "onDoubleClick"
};
var $aebbffcbd3512418$export$e65e0ff8d3882b46 = [
    "auto",
    "linear",
    "pow",
    "sqrt",
    "log",
    "identity",
    "time",
    "band",
    "point",
    "ordinal",
    "quantile",
    "quantize",
    "utc",
    "sequential",
    "threshold"
];
var $aebbffcbd3512418$export$84dbd3b52ff06578 = [
    "plainline",
    "line",
    "square",
    "rect",
    "circle",
    "cross",
    "diamond",
    "star",
    "triangle",
    "wye",
    "none"
];
var $aebbffcbd3512418$export$59a4d7d024cf1025 = [
    "none"
];
var $aebbffcbd3512418$export$be63e0664592e141 = function getDisplayName(Comp) {
    if (typeof Comp === "string") return Comp;
    if (!Comp) return "";
    return Comp.displayName || Comp.name || "Component";
};
// `toArray` gets called multiple times during the render
// so we can memoize last invocation (since reference to `children` is the same)
var $aebbffcbd3512418$var$lastChildren = null;
var $aebbffcbd3512418$var$lastResult = null;
var $aebbffcbd3512418$export$45b10814cc054894 = function toArray(children) {
    if (children === $aebbffcbd3512418$var$lastChildren && Array.isArray($aebbffcbd3512418$var$lastResult)) return $aebbffcbd3512418$var$lastResult;
    var result = [];
    (0, $jbmdS.Children).forEach(children, function(child) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($aVX0M)))(child)) return;
        if ((0, $6thKp.isFragment)(child)) result = result.concat(toArray(child.props.children));
        else // @ts-expect-error this could still be Iterable<ReactNode> and TS does not like that
        result.push(child);
    });
    $aebbffcbd3512418$var$lastResult = result;
    $aebbffcbd3512418$var$lastChildren = children;
    return result;
};
function $aebbffcbd3512418$export$fdd5e64c0e8495bb(children, type) {
    var result = [];
    var types = [];
    if (Array.isArray(type)) types = type.map(function(t) {
        return $aebbffcbd3512418$export$be63e0664592e141(t);
    });
    else types = [
        $aebbffcbd3512418$export$be63e0664592e141(type)
    ];
    $aebbffcbd3512418$export$45b10814cc054894(children).forEach(function(child) {
        var childType = (0, (/*@__PURE__*/$parcel$interopDefault($lNQsK)))(child, "type.displayName") || (0, (/*@__PURE__*/$parcel$interopDefault($lNQsK)))(child, "type.name");
        if (types.indexOf(childType) !== -1) result.push(child);
    });
    return result;
}
function $aebbffcbd3512418$export$64c61536a2b72e0f(children, type) {
    var result = $aebbffcbd3512418$export$fdd5e64c0e8495bb(children, type);
    return result && result[0];
}
var $aebbffcbd3512418$export$d0b46a9571fa5ebf = function withoutType(children, type) {
    var newChildren = [];
    var types;
    if (Array.isArray(type)) types = type.map(function(t) {
        return $aebbffcbd3512418$export$be63e0664592e141(t);
    });
    else types = [
        $aebbffcbd3512418$export$be63e0664592e141(type)
    ];
    $aebbffcbd3512418$export$45b10814cc054894(children).forEach(function(child) {
        var displayName = (0, (/*@__PURE__*/$parcel$interopDefault($lNQsK)))(child, "type.displayName");
        if (displayName && types.indexOf(displayName) !== -1) return;
        newChildren.push(child);
    });
    return newChildren;
};
var $aebbffcbd3512418$export$5301de6bfd3cfa2a = function validateWidthHeight(el) {
    if (!el || !el.props) return false;
    var _el$props = el.props, width = _el$props.width, height = _el$props.height;
    if (!(0, $1gmrG.isNumber)(width) || width <= 0 || !(0, $1gmrG.isNumber)(height) || height <= 0) return false;
    return true;
};
var $aebbffcbd3512418$var$SVG_TAGS = [
    "a",
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animate",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "circle",
    "clipPath",
    "color-profile",
    "cursor",
    "defs",
    "desc",
    "ellipse",
    "feBlend",
    "feColormatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "filter",
    "font",
    "font-face",
    "font-face-format",
    "font-face-name",
    "font-face-url",
    "foreignObject",
    "g",
    "glyph",
    "glyphRef",
    "hkern",
    "image",
    "line",
    "lineGradient",
    "marker",
    "mask",
    "metadata",
    "missing-glyph",
    "mpath",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "script",
    "set",
    "stop",
    "style",
    "svg",
    "switch",
    "symbol",
    "text",
    "textPath",
    "title",
    "tref",
    "tspan",
    "use",
    "view",
    "vkern"
];
var $aebbffcbd3512418$var$isSvgElement = function isSvgElement(child) {
    return child && child.type && (0, (/*@__PURE__*/$parcel$interopDefault($aVvo3)))(child.type) && $aebbffcbd3512418$var$SVG_TAGS.indexOf(child.type) >= 0;
};
var $aebbffcbd3512418$export$392f6c9701718a4e = function hasClipDot(dot) {
    return dot && $aebbffcbd3512418$var$_typeof(dot) === "object" && "clipDot" in dot;
};
var $aebbffcbd3512418$export$be767fcc756dddf6 = function isValidSpreadableProp(property, key, includeEvents, svgElementType) {
    var _FilteredElementKeyMa;
    /**
   * If the svg element type is explicitly included, check against the filtered element key map
   * to determine if there are attributes that should only exist on that element type.
   * @todo Add an internal cjs version of https://github.com/wooorm/svg-element-attributes for full coverage.
   */ var matchingElementTypeKeys = (_FilteredElementKeyMa = (0, $gBhCn.FilteredElementKeyMap) === null || (0, $gBhCn.FilteredElementKeyMap) === void 0 ? void 0 : (0, $gBhCn.FilteredElementKeyMap)[svgElementType]) !== null && _FilteredElementKeyMa !== void 0 ? _FilteredElementKeyMa : [];
    return !(0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(property) && (svgElementType && matchingElementTypeKeys.includes(key) || (0, $gBhCn.SVGElementPropKeys).includes(key)) || includeEvents && (0, $gBhCn.EventKeys).includes(key);
};
var $aebbffcbd3512418$export$ef6f3b46dcb37b3f = function filterSvgElements(children) {
    var svgElements = [];
    $aebbffcbd3512418$export$45b10814cc054894(children).forEach(function(entry) {
        if ($aebbffcbd3512418$var$isSvgElement(entry)) svgElements.push(entry);
    });
    return svgElements;
};
var $aebbffcbd3512418$export$d697c39a2985a4c = function filterProps(props, includeEvents, svgElementType) {
    if (!props || typeof props === "function" || typeof props === "boolean") return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $jbmdS.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hBKZ2)))(inputProps)) return null;
    var out = {};
    /**
   * Props are blindly spread onto SVG elements. This loop filters out properties that we don't want to spread.
   * Items filtered out are as follows:
   *   - functions in properties that are SVG attributes (functions are included when includeEvents is true)
   *   - props that are SVG attributes but don't matched the passed svgElementType
   *   - any prop that is not in SVGElementPropKeys (or in EventKeys if includeEvents is true)
   */ Object.keys(inputProps).forEach(function(key) {
        var _inputProps;
        if ($aebbffcbd3512418$export$be767fcc756dddf6((_inputProps = inputProps) === null || _inputProps === void 0 ? void 0 : _inputProps[key], key, includeEvents, svgElementType)) out[key] = inputProps[key];
    });
    return out;
};
var $aebbffcbd3512418$export$acdc716e08572f94 = function isChildrenEqual(nextChildren, prevChildren) {
    if (nextChildren === prevChildren) return true;
    var count = (0, $jbmdS.Children).count(nextChildren);
    if (count !== (0, $jbmdS.Children).count(prevChildren)) return false;
    if (count === 0) return true;
    if (count === 1) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $aebbffcbd3512418$export$96bceecf65400492(Array.isArray(nextChildren) ? nextChildren[0] : nextChildren, Array.isArray(prevChildren) ? prevChildren[0] : prevChildren);
    for(var i = 0; i < count; i++){
        var nextChild = nextChildren[i];
        var prevChild = prevChildren[i];
        if (Array.isArray(nextChild) || Array.isArray(prevChild)) {
            if (!isChildrenEqual(nextChild, prevChild)) return false;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        } else if (!$aebbffcbd3512418$export$96bceecf65400492(nextChild, prevChild)) return false;
    }
    return true;
};
var $aebbffcbd3512418$export$96bceecf65400492 = function isSingleChildEqual(nextChild, prevChild) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($aVX0M)))(nextChild) && (0, (/*@__PURE__*/$parcel$interopDefault($aVX0M)))(prevChild)) return true;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($aVX0M)))(nextChild) && !(0, (/*@__PURE__*/$parcel$interopDefault($aVX0M)))(prevChild)) {
        var _ref = nextChild.props || {}, nextChildren = _ref.children, nextProps = $aebbffcbd3512418$var$_objectWithoutProperties(_ref, $aebbffcbd3512418$var$_excluded);
        var _ref2 = prevChild.props || {}, prevChildren = _ref2.children, prevProps = $aebbffcbd3512418$var$_objectWithoutProperties(_ref2, $aebbffcbd3512418$var$_excluded2);
        if (nextChildren && prevChildren) return (0, $cxCWI.shallowEqual)(nextProps, prevProps) && $aebbffcbd3512418$export$acdc716e08572f94(nextChildren, prevChildren);
        if (!nextChildren && !prevChildren) return (0, $cxCWI.shallowEqual)(nextProps, prevProps);
        return false;
    }
    return false;
};
var $aebbffcbd3512418$export$a98d6da55570cb82 = function renderByOrder(children, renderMap) {
    var elements = [];
    var record = {};
    $aebbffcbd3512418$export$45b10814cc054894(children).forEach(function(child, index) {
        if ($aebbffcbd3512418$var$isSvgElement(child)) elements.push(child);
        else if (child) {
            var displayName = $aebbffcbd3512418$export$be63e0664592e141(child.type);
            var _ref3 = renderMap[displayName] || {}, handler = _ref3.handler, once = _ref3.once;
            if (handler && (!once || !record[displayName])) {
                var results = handler(child, displayName, index);
                elements.push(results);
                record[displayName] = true;
            }
        }
    });
    return elements;
};
var $aebbffcbd3512418$export$afb3591bc51a0b70 = function getReactEventByType(e) {
    var type = e && e.type;
    if (type && $aebbffcbd3512418$var$REACT_BROWSER_EVENT_MAP[type]) return $aebbffcbd3512418$var$REACT_BROWSER_EVENT_MAP[type];
    return null;
};
var $aebbffcbd3512418$export$857ca101f741953 = function parseChildIndex(child, children) {
    return $aebbffcbd3512418$export$45b10814cc054894(children).indexOf(child);
};

});
parcelRegister("lNQsK", function(module, exports) {

var $2HLB2 = parcelRequire("2HLB2");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $fdf6de97b4bb1d9e$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $2HLB2(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $fdf6de97b4bb1d9e$var$get;

});
parcelRegister("2HLB2", function(module, exports) {

var $egGZR = parcelRequire("egGZR");

var $hZ9oa = parcelRequire("hZ9oa");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $1f848490d41ca365$var$baseGet(object, path) {
    path = $egGZR(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$hZ9oa(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $1f848490d41ca365$var$baseGet;

});
parcelRegister("egGZR", function(module, exports) {

var $687Zl = parcelRequire("687Zl");

var $kgsO2 = parcelRequire("kgsO2");

var $1Mnqk = parcelRequire("1Mnqk");

var $ebkZ0 = parcelRequire("ebkZ0");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $a633e99470d55f3e$var$castPath(value, object) {
    if ($687Zl(value)) return value;
    return $kgsO2(value, object) ? [
        value
    ] : $1Mnqk($ebkZ0(value));
}
module.exports = $a633e99470d55f3e$var$castPath;

});
parcelRegister("kgsO2", function(module, exports) {

var $687Zl = parcelRequire("687Zl");

var $5Ob3C = parcelRequire("5Ob3C");
/** Used to match property names within property paths. */ var $ec0ba58f3d42c823$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $ec0ba58f3d42c823$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $ec0ba58f3d42c823$var$isKey(value, object) {
    if ($687Zl(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $5Ob3C(value)) return true;
    return $ec0ba58f3d42c823$var$reIsPlainProp.test(value) || !$ec0ba58f3d42c823$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $ec0ba58f3d42c823$var$isKey;

});

parcelRegister("1Mnqk", function(module, exports) {

var $5KFVK = parcelRequire("5KFVK");
/** Used to match property names within property paths. */ var $14bc7193bbd4c022$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $14bc7193bbd4c022$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $14bc7193bbd4c022$var$stringToPath = $5KFVK(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($14bc7193bbd4c022$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($14bc7193bbd4c022$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
module.exports = $14bc7193bbd4c022$var$stringToPath;

});
parcelRegister("5KFVK", function(module, exports) {

var $eBB0l = parcelRequire("eBB0l");
/** Used as the maximum memoize cache size. */ var $4301c6268f6beace$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $4301c6268f6beace$var$memoizeCapped(func) {
    var result = $eBB0l(func, function(key) {
        if (cache.size === $4301c6268f6beace$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $4301c6268f6beace$var$memoizeCapped;

});
parcelRegister("eBB0l", function(module, exports) {

var $4NJjW = parcelRequire("4NJjW");
/** Error message constants. */ var $aa2139bdc7a817c0$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $aa2139bdc7a817c0$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($aa2139bdc7a817c0$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($aa2139bdc7a817c0$var$memoize.Cache || $4NJjW);
    return memoized;
}
// Expose `MapCache`.
$aa2139bdc7a817c0$var$memoize.Cache = $4NJjW;
module.exports = $aa2139bdc7a817c0$var$memoize;

});




parcelRegister("hZ9oa", function(module, exports) {

var $5Ob3C = parcelRequire("5Ob3C");
/** Used as references for various `Number` constants. */ var $d17f6a963614f3ad$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $d17f6a963614f3ad$var$toKey(value) {
    if (typeof value == "string" || $5Ob3C(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$d17f6a963614f3ad$var$INFINITY ? "-0" : result;
}
module.exports = $d17f6a963614f3ad$var$toKey;

});



parcelRegister("aVvo3", function(module, exports) {

var $d8VrW = parcelRequire("d8VrW");

var $687Zl = parcelRequire("687Zl");

var $8JxPO = parcelRequire("8JxPO");
/** `Object#toString` result references. */ var $7f47931008c28d5e$var$stringTag = "[object String]";
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $7f47931008c28d5e$var$isString(value) {
    return typeof value == "string" || !$687Zl(value) && $8JxPO(value) && $d8VrW(value) == $7f47931008c28d5e$var$stringTag;
}
module.exports = $7f47931008c28d5e$var$isString;

});

parcelRegister("6thKp", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gkf1i"));

});
parcelRegister("gkf1i", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $be2a2a37bab7c304$export$a7c73072b1a182ae; }, function (v) { return $be2a2a37bab7c304$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $be2a2a37bab7c304$export$9f27bc3417b4524d; }, function (v) { return $be2a2a37bab7c304$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $be2a2a37bab7c304$export$db77ccec0bb4ccac; }, function (v) { return $be2a2a37bab7c304$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $be2a2a37bab7c304$export$8392c0c9d3dcbd35; }, function (v) { return $be2a2a37bab7c304$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $be2a2a37bab7c304$export$ffb0004e005737fa; }, function (v) { return $be2a2a37bab7c304$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $be2a2a37bab7c304$export$b624eff549462981; }, function (v) { return $be2a2a37bab7c304$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $be2a2a37bab7c304$export$7897aa7841a5380c; }, function (v) { return $be2a2a37bab7c304$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $be2a2a37bab7c304$export$602eac185826482c; }, function (v) { return $be2a2a37bab7c304$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $be2a2a37bab7c304$export$e2c29f18771995cb; }, function (v) { return $be2a2a37bab7c304$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $be2a2a37bab7c304$export$5f8d39834fd61797; }, function (v) { return $be2a2a37bab7c304$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $be2a2a37bab7c304$export$74bf444e3cd11ea5; }, function (v) { return $be2a2a37bab7c304$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $be2a2a37bab7c304$export$998bcd577473dd93; }, function (v) { return $be2a2a37bab7c304$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $be2a2a37bab7c304$export$92387174baf9b227; }, function (v) { return $be2a2a37bab7c304$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $be2a2a37bab7c304$export$ec112efeb987d9c6; }, function (v) { return $be2a2a37bab7c304$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $be2a2a37bab7c304$export$b706b080d889d2c9; }, function (v) { return $be2a2a37bab7c304$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $be2a2a37bab7c304$export$5be5a87408f70ddc; }, function (v) { return $be2a2a37bab7c304$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $be2a2a37bab7c304$export$45a5e7f76e0caa8d; }, function (v) { return $be2a2a37bab7c304$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $be2a2a37bab7c304$export$455c2e768291efa6; }, function (v) { return $be2a2a37bab7c304$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $be2a2a37bab7c304$export$9522e17588c12572; }, function (v) { return $be2a2a37bab7c304$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $be2a2a37bab7c304$export$2110ac352bb060b9; }, function (v) { return $be2a2a37bab7c304$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $be2a2a37bab7c304$export$56885ab8b9c456ab; }, function (v) { return $be2a2a37bab7c304$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $be2a2a37bab7c304$export$d927fcb6adf8f9de; }, function (v) { return $be2a2a37bab7c304$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $be2a2a37bab7c304$export$b82d16f27459e05a; }, function (v) { return $be2a2a37bab7c304$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $be2a2a37bab7c304$export$522c17b4f5e123e8; }, function (v) { return $be2a2a37bab7c304$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $be2a2a37bab7c304$export$1aabd8a0274ecfd6; }, function (v) { return $be2a2a37bab7c304$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $be2a2a37bab7c304$export$3d6c20d97e46b957; }, function (v) { return $be2a2a37bab7c304$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $be2a2a37bab7c304$export$9b621391a187a31a; }, function (v) { return $be2a2a37bab7c304$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $be2a2a37bab7c304$export$f5bbd400c2f4426f; }, function (v) { return $be2a2a37bab7c304$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $be2a2a37bab7c304$export$a7c73072b1a182ae;
var $be2a2a37bab7c304$export$9f27bc3417b4524d;
var $be2a2a37bab7c304$export$db77ccec0bb4ccac;
var $be2a2a37bab7c304$export$8392c0c9d3dcbd35;
var $be2a2a37bab7c304$export$ffb0004e005737fa;
var $be2a2a37bab7c304$export$b624eff549462981;
var $be2a2a37bab7c304$export$7897aa7841a5380c;
var $be2a2a37bab7c304$export$602eac185826482c;
var $be2a2a37bab7c304$export$e2c29f18771995cb;
var $be2a2a37bab7c304$export$5f8d39834fd61797;
var $be2a2a37bab7c304$export$74bf444e3cd11ea5;
var $be2a2a37bab7c304$export$998bcd577473dd93;
var $be2a2a37bab7c304$export$92387174baf9b227;
var $be2a2a37bab7c304$export$ec112efeb987d9c6;
var $be2a2a37bab7c304$export$b706b080d889d2c9;
var $be2a2a37bab7c304$export$5be5a87408f70ddc;
var $be2a2a37bab7c304$export$45a5e7f76e0caa8d;
var $be2a2a37bab7c304$export$455c2e768291efa6;
var $be2a2a37bab7c304$export$9522e17588c12572;
var $be2a2a37bab7c304$export$2110ac352bb060b9;
var $be2a2a37bab7c304$export$56885ab8b9c456ab;
var $be2a2a37bab7c304$export$d927fcb6adf8f9de;
var $be2a2a37bab7c304$export$b82d16f27459e05a;
var $be2a2a37bab7c304$export$522c17b4f5e123e8;
var $be2a2a37bab7c304$export$1aabd8a0274ecfd6;
var $be2a2a37bab7c304$export$3d6c20d97e46b957;
var $be2a2a37bab7c304$export$9b621391a187a31a;
var $be2a2a37bab7c304$export$f5bbd400c2f4426f;
"use strict";
var $be2a2a37bab7c304$var$b = Symbol.for("react.element"), $be2a2a37bab7c304$var$c = Symbol.for("react.portal"), $be2a2a37bab7c304$var$d = Symbol.for("react.fragment"), $be2a2a37bab7c304$var$e = Symbol.for("react.strict_mode"), $be2a2a37bab7c304$var$f = Symbol.for("react.profiler"), $be2a2a37bab7c304$var$g = Symbol.for("react.provider"), $be2a2a37bab7c304$var$h = Symbol.for("react.context"), $be2a2a37bab7c304$var$k = Symbol.for("react.server_context"), $be2a2a37bab7c304$var$l = Symbol.for("react.forward_ref"), $be2a2a37bab7c304$var$m = Symbol.for("react.suspense"), $be2a2a37bab7c304$var$n = Symbol.for("react.suspense_list"), $be2a2a37bab7c304$var$p = Symbol.for("react.memo"), $be2a2a37bab7c304$var$q = Symbol.for("react.lazy"), $be2a2a37bab7c304$var$t = Symbol.for("react.offscreen"), $be2a2a37bab7c304$var$u;
$be2a2a37bab7c304$var$u = Symbol.for("react.module.reference");
function $be2a2a37bab7c304$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $be2a2a37bab7c304$var$b:
                switch(a = a.type, a){
                    case $be2a2a37bab7c304$var$d:
                    case $be2a2a37bab7c304$var$f:
                    case $be2a2a37bab7c304$var$e:
                    case $be2a2a37bab7c304$var$m:
                    case $be2a2a37bab7c304$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $be2a2a37bab7c304$var$k:
                            case $be2a2a37bab7c304$var$h:
                            case $be2a2a37bab7c304$var$l:
                            case $be2a2a37bab7c304$var$q:
                            case $be2a2a37bab7c304$var$p:
                            case $be2a2a37bab7c304$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $be2a2a37bab7c304$var$c:
                return r;
        }
    }
}
$be2a2a37bab7c304$export$a7c73072b1a182ae = $be2a2a37bab7c304$var$h;
$be2a2a37bab7c304$export$9f27bc3417b4524d = $be2a2a37bab7c304$var$g;
$be2a2a37bab7c304$export$db77ccec0bb4ccac = $be2a2a37bab7c304$var$b;
$be2a2a37bab7c304$export$8392c0c9d3dcbd35 = $be2a2a37bab7c304$var$l;
$be2a2a37bab7c304$export$ffb0004e005737fa = $be2a2a37bab7c304$var$d;
$be2a2a37bab7c304$export$b624eff549462981 = $be2a2a37bab7c304$var$q;
$be2a2a37bab7c304$export$7897aa7841a5380c = $be2a2a37bab7c304$var$p;
$be2a2a37bab7c304$export$602eac185826482c = $be2a2a37bab7c304$var$c;
$be2a2a37bab7c304$export$e2c29f18771995cb = $be2a2a37bab7c304$var$f;
$be2a2a37bab7c304$export$5f8d39834fd61797 = $be2a2a37bab7c304$var$e;
$be2a2a37bab7c304$export$74bf444e3cd11ea5 = $be2a2a37bab7c304$var$m;
$be2a2a37bab7c304$export$998bcd577473dd93 = $be2a2a37bab7c304$var$n;
$be2a2a37bab7c304$export$92387174baf9b227 = function() {
    return !1;
};
$be2a2a37bab7c304$export$ec112efeb987d9c6 = function() {
    return !1;
};
$be2a2a37bab7c304$export$b706b080d889d2c9 = function(a) {
    return $be2a2a37bab7c304$var$v(a) === $be2a2a37bab7c304$var$h;
};
$be2a2a37bab7c304$export$5be5a87408f70ddc = function(a) {
    return $be2a2a37bab7c304$var$v(a) === $be2a2a37bab7c304$var$g;
};
$be2a2a37bab7c304$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $be2a2a37bab7c304$var$b;
};
$be2a2a37bab7c304$export$455c2e768291efa6 = function(a) {
    return $be2a2a37bab7c304$var$v(a) === $be2a2a37bab7c304$var$l;
};
$be2a2a37bab7c304$export$9522e17588c12572 = function(a) {
    return $be2a2a37bab7c304$var$v(a) === $be2a2a37bab7c304$var$d;
};
$be2a2a37bab7c304$export$2110ac352bb060b9 = function(a) {
    return $be2a2a37bab7c304$var$v(a) === $be2a2a37bab7c304$var$q;
};
$be2a2a37bab7c304$export$56885ab8b9c456ab = function(a) {
    return $be2a2a37bab7c304$var$v(a) === $be2a2a37bab7c304$var$p;
};
$be2a2a37bab7c304$export$d927fcb6adf8f9de = function(a) {
    return $be2a2a37bab7c304$var$v(a) === $be2a2a37bab7c304$var$c;
};
$be2a2a37bab7c304$export$b82d16f27459e05a = function(a) {
    return $be2a2a37bab7c304$var$v(a) === $be2a2a37bab7c304$var$f;
};
$be2a2a37bab7c304$export$522c17b4f5e123e8 = function(a) {
    return $be2a2a37bab7c304$var$v(a) === $be2a2a37bab7c304$var$e;
};
$be2a2a37bab7c304$export$1aabd8a0274ecfd6 = function(a) {
    return $be2a2a37bab7c304$var$v(a) === $be2a2a37bab7c304$var$m;
};
$be2a2a37bab7c304$export$3d6c20d97e46b957 = function(a) {
    return $be2a2a37bab7c304$var$v(a) === $be2a2a37bab7c304$var$n;
};
$be2a2a37bab7c304$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $be2a2a37bab7c304$var$d || a === $be2a2a37bab7c304$var$f || a === $be2a2a37bab7c304$var$e || a === $be2a2a37bab7c304$var$m || a === $be2a2a37bab7c304$var$n || a === $be2a2a37bab7c304$var$t || "object" === typeof a && null !== a && (a.$$typeof === $be2a2a37bab7c304$var$q || a.$$typeof === $be2a2a37bab7c304$var$p || a.$$typeof === $be2a2a37bab7c304$var$g || a.$$typeof === $be2a2a37bab7c304$var$h || a.$$typeof === $be2a2a37bab7c304$var$l || a.$$typeof === $be2a2a37bab7c304$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$be2a2a37bab7c304$export$f5bbd400c2f4426f = $be2a2a37bab7c304$var$v;

});


parcelRegister("1gmrG", function(module, exports) {

$parcel$export(module.exports, "mathSign", function () { return $0eb8b24a09366e7e$export$9d334328eb75e624; });
$parcel$export(module.exports, "isPercent", function () { return $0eb8b24a09366e7e$export$e50269385c77c348; });
$parcel$export(module.exports, "isNumber", function () { return $0eb8b24a09366e7e$export$7e4aa119212bc614; });
$parcel$export(module.exports, "isNumOrStr", function () { return $0eb8b24a09366e7e$export$402a499e1ea44294; });
$parcel$export(module.exports, "uniqueId", function () { return $0eb8b24a09366e7e$export$8b15d37bc3f197d4; });
$parcel$export(module.exports, "getPercentValue", function () { return $0eb8b24a09366e7e$export$476354dbf49bdff6; });
$parcel$export(module.exports, "getAnyElementOfObject", function () { return $0eb8b24a09366e7e$export$b88993f0aa0bf776; });
$parcel$export(module.exports, "hasDuplicate", function () { return $0eb8b24a09366e7e$export$732baf6a98f122; });
$parcel$export(module.exports, "interpolateNumber", function () { return $0eb8b24a09366e7e$export$d871d53bd7eeb390; });
$parcel$export(module.exports, "findEntryInArray", function () { return $0eb8b24a09366e7e$export$66950d3869f5cc67; });

var $aVvo3 = parcelRequire("aVvo3");

var $BWzdJ = parcelRequire("BWzdJ");

var $lNQsK = parcelRequire("lNQsK");

var $fuFGl = parcelRequire("fuFGl");
var $0eb8b24a09366e7e$export$9d334328eb75e624 = function mathSign(value) {
    if (value === 0) return 0;
    if (value > 0) return 1;
    return -1;
};
var $0eb8b24a09366e7e$export$e50269385c77c348 = function isPercent(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($aVvo3)))(value) && value.indexOf("%") === value.length - 1;
};
var $0eb8b24a09366e7e$export$7e4aa119212bc614 = function isNumber(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($fuFGl)))(value) && !(0, (/*@__PURE__*/$parcel$interopDefault($BWzdJ)))(value);
};
var $0eb8b24a09366e7e$export$402a499e1ea44294 = function isNumOrStr(value) {
    return $0eb8b24a09366e7e$export$7e4aa119212bc614(value) || (0, (/*@__PURE__*/$parcel$interopDefault($aVvo3)))(value);
};
var $0eb8b24a09366e7e$var$idCounter = 0;
var $0eb8b24a09366e7e$export$8b15d37bc3f197d4 = function uniqueId(prefix) {
    var id = ++$0eb8b24a09366e7e$var$idCounter;
    return "".concat(prefix || "").concat(id);
};
var $0eb8b24a09366e7e$export$476354dbf49bdff6 = function getPercentValue(percent, totalValue) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (!$0eb8b24a09366e7e$export$7e4aa119212bc614(percent) && !(0, (/*@__PURE__*/$parcel$interopDefault($aVvo3)))(percent)) return defaultValue;
    var value;
    if ($0eb8b24a09366e7e$export$e50269385c77c348(percent)) {
        var index = percent.indexOf("%");
        value = totalValue * parseFloat(percent.slice(0, index)) / 100;
    } else value = +percent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($BWzdJ)))(value)) value = defaultValue;
    if (validate && value > totalValue) value = totalValue;
    return value;
};
var $0eb8b24a09366e7e$export$b88993f0aa0bf776 = function getAnyElementOfObject(obj) {
    if (!obj) return null;
    var keys = Object.keys(obj);
    if (keys && keys.length) return obj[keys[0]];
    return null;
};
var $0eb8b24a09366e7e$export$732baf6a98f122 = function hasDuplicate(ary) {
    if (!Array.isArray(ary)) return false;
    var len = ary.length;
    var cache = {};
    for(var i = 0; i < len; i++){
        if (!cache[ary[i]]) cache[ary[i]] = true;
        else return true;
    }
    return false;
};
var $0eb8b24a09366e7e$export$d871d53bd7eeb390 = function interpolateNumber(numberA, numberB) {
    if ($0eb8b24a09366e7e$export$7e4aa119212bc614(numberA) && $0eb8b24a09366e7e$export$7e4aa119212bc614(numberB)) return function(t) {
        return numberA + t * (numberB - numberA);
    };
    return function() {
        return numberB;
    };
};
function $0eb8b24a09366e7e$export$66950d3869f5cc67(ary, specifiedKey, specifiedValue) {
    if (!ary || !ary.length) return null;
    return ary.find(function(entry) {
        return entry && (typeof specifiedKey === "function" ? specifiedKey(entry) : (0, (/*@__PURE__*/$parcel$interopDefault($lNQsK)))(entry, specifiedKey)) === specifiedValue;
    });
}
var $0eb8b24a09366e7e$export$484982720961754e = function getLinearRegression(data) {
    if (!data || !data.length) return null;
    var len = data.length;
    var xsum = 0;
    var ysum = 0;
    var xysum = 0;
    var xxsum = 0;
    var xmin = Infinity;
    var xmax = -Infinity;
    var xcurrent = 0;
    var ycurrent = 0;
    for(var i = 0; i < len; i++){
        xcurrent = data[i].cx || 0;
        ycurrent = data[i].cy || 0;
        xsum += xcurrent;
        ysum += ycurrent;
        xysum += xcurrent * ycurrent;
        xxsum += xcurrent * xcurrent;
        xmin = Math.min(xmin, xcurrent);
        xmax = Math.max(xmax, xcurrent);
    }
    var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
    return {
        xmin: xmin,
        xmax: xmax,
        a: a,
        b: (ysum - a * xsum) / len
    };
};

});

parcelRegister("cxCWI", function(module, exports) {

$parcel$export(module.exports, "shallowEqual", function () { return $9216c6fb86c606ac$export$d36bdfa510afb180; });
function $9216c6fb86c606ac$export$d36bdfa510afb180(a, b) {
    /* eslint-disable no-restricted-syntax */ for(var key in a){
        if (({}).hasOwnProperty.call(a, key) && (!({}).hasOwnProperty.call(b, key) || a[key] !== b[key])) return false;
    }
    for(var _key in b){
        if (({}).hasOwnProperty.call(b, _key) && !({}).hasOwnProperty.call(a, _key)) return false;
    }
    return true;
}

});



parcelRegister("6eKmI", function(module, exports) {

$parcel$export(module.exports, "Dot", function () { return $48a804113136b094$export$d046b3c4a416f60d; });

var $jbmdS = parcelRequire("jbmdS");

var $dWgPS = parcelRequire("dWgPS");

var $gBhCn = parcelRequire("gBhCn");

var $f06D9 = parcelRequire("f06D9");
function $48a804113136b094$var$_extends() {
    $48a804113136b094$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $48a804113136b094$var$_extends.apply(this, arguments);
}
var $48a804113136b094$export$d046b3c4a416f60d = function Dot(props) {
    var cx = props.cx, cy = props.cy, r = props.r, className = props.className;
    var layerClass = (0, $dWgPS.default)("recharts-dot", className);
    if (cx === +cx && cy === +cy && r === +r) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("circle", $48a804113136b094$var$_extends({}, (0, $f06D9.filterProps)(props, false), (0, $gBhCn.adaptEventHandlers)(props), {
        className: layerClass,
        cx: cx,
        cy: cy,
        r: r
    }));
    return null;
};

});

parcelRegister("bIYfh", function(module, exports) {

$parcel$export(module.exports, "Layer", function () { return $8892894993c9bce0$export$936d0764594b6eb3; });

var $jbmdS = parcelRequire("jbmdS");

var $dWgPS = parcelRequire("dWgPS");

var $f06D9 = parcelRequire("f06D9");
var $8892894993c9bce0$var$_excluded = [
    "children",
    "className"
];
function $8892894993c9bce0$var$_extends() {
    $8892894993c9bce0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8892894993c9bce0$var$_extends.apply(this, arguments);
}
function $8892894993c9bce0$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8892894993c9bce0$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $8892894993c9bce0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $8892894993c9bce0$export$936d0764594b6eb3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).forwardRef(function(props, ref) {
    var children = props.children, className = props.className, others = $8892894993c9bce0$var$_objectWithoutProperties(props, $8892894993c9bce0$var$_excluded);
    var layerClass = (0, $dWgPS.default)("recharts-layer", className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("g", $8892894993c9bce0$var$_extends({
        className: layerClass
    }, (0, $f06D9.filterProps)(others, true), {
        ref: ref
    }), children);
});

});

parcelRegister("1sHYq", function(module, exports) {

$parcel$export(module.exports, "LabelList", function () { return $110a8439d6f657ff$export$835fcf23ab7bf88; });

var $jbmdS = parcelRequire("jbmdS");

var $aVX0M = parcelRequire("aVX0M");

var $hBKZ2 = parcelRequire("hBKZ2");

var $i99FY = parcelRequire("i99FY");

var $4Z5bA = parcelRequire("4Z5bA");

var $eGPJt = parcelRequire("eGPJt");

var $bIYfh = parcelRequire("bIYfh");

var $f06D9 = parcelRequire("f06D9");

var $fiDSf = parcelRequire("fiDSf");
function $110a8439d6f657ff$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $110a8439d6f657ff$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $110a8439d6f657ff$var$_typeof(o);
}
var $110a8439d6f657ff$var$_excluded = [
    "valueAccessor"
], $110a8439d6f657ff$var$_excluded2 = [
    "data",
    "dataKey",
    "clockWise",
    "id",
    "textBreakAll"
];
function $110a8439d6f657ff$var$_toConsumableArray(arr) {
    return $110a8439d6f657ff$var$_arrayWithoutHoles(arr) || $110a8439d6f657ff$var$_iterableToArray(arr) || $110a8439d6f657ff$var$_unsupportedIterableToArray(arr) || $110a8439d6f657ff$var$_nonIterableSpread();
}
function $110a8439d6f657ff$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $110a8439d6f657ff$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $110a8439d6f657ff$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $110a8439d6f657ff$var$_arrayLikeToArray(o, minLen);
}
function $110a8439d6f657ff$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $110a8439d6f657ff$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $110a8439d6f657ff$var$_arrayLikeToArray(arr);
}
function $110a8439d6f657ff$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $110a8439d6f657ff$var$_extends() {
    $110a8439d6f657ff$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $110a8439d6f657ff$var$_extends.apply(this, arguments);
}
function $110a8439d6f657ff$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $110a8439d6f657ff$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $110a8439d6f657ff$var$ownKeys(Object(t), !0).forEach(function(r) {
            $110a8439d6f657ff$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $110a8439d6f657ff$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $110a8439d6f657ff$var$_defineProperty(obj, key, value) {
    key = $110a8439d6f657ff$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $110a8439d6f657ff$var$_toPropertyKey(t) {
    var i = $110a8439d6f657ff$var$_toPrimitive(t, "string");
    return "symbol" == $110a8439d6f657ff$var$_typeof(i) ? i : i + "";
}
function $110a8439d6f657ff$var$_toPrimitive(t, r) {
    if ("object" != $110a8439d6f657ff$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $110a8439d6f657ff$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $110a8439d6f657ff$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $110a8439d6f657ff$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $110a8439d6f657ff$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $110a8439d6f657ff$var$defaultAccessor = function defaultAccessor(entry) {
    return Array.isArray(entry.value) ? (0, (/*@__PURE__*/$parcel$interopDefault($4Z5bA)))(entry.value) : entry.value;
};
function $110a8439d6f657ff$export$835fcf23ab7bf88(_ref) {
    var _ref$valueAccessor = _ref.valueAccessor, valueAccessor = _ref$valueAccessor === void 0 ? $110a8439d6f657ff$var$defaultAccessor : _ref$valueAccessor, restProps = $110a8439d6f657ff$var$_objectWithoutProperties(_ref, $110a8439d6f657ff$var$_excluded);
    var data = restProps.data, dataKey = restProps.dataKey, clockWise = restProps.clockWise, id = restProps.id, textBreakAll = restProps.textBreakAll, others = $110a8439d6f657ff$var$_objectWithoutProperties(restProps, $110a8439d6f657ff$var$_excluded2);
    if (!data || !data.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $bIYfh.Layer), {
        className: "recharts-label-list"
    }, data.map(function(entry, index) {
        var value = (0, (/*@__PURE__*/$parcel$interopDefault($aVX0M)))(dataKey) ? valueAccessor(entry, index) : (0, $fiDSf.getValueByDataKey)(entry && entry.payload, dataKey);
        var idProps = (0, (/*@__PURE__*/$parcel$interopDefault($aVX0M)))(id) ? {} : {
            id: "".concat(id, "-").concat(index)
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $eGPJt.Label), $110a8439d6f657ff$var$_extends({}, (0, $f06D9.filterProps)(entry, true), others, idProps, {
            parentViewBox: entry.parentViewBox,
            value: value,
            textBreakAll: textBreakAll,
            viewBox: (0, $eGPJt.Label).parseViewBox((0, (/*@__PURE__*/$parcel$interopDefault($aVX0M)))(clockWise) ? entry : $110a8439d6f657ff$var$_objectSpread($110a8439d6f657ff$var$_objectSpread({}, entry), {}, {
                clockWise: clockWise
            })),
            key: "label-".concat(index) // eslint-disable-line react/no-array-index-key
            ,
            index: index
        }));
    }));
}
$110a8439d6f657ff$export$835fcf23ab7bf88.displayName = "LabelList";
function $110a8439d6f657ff$var$parseLabelList(label, data) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($110a8439d6f657ff$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data
    });
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).isValidElement(label) || (0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($110a8439d6f657ff$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data,
        content: label
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hBKZ2)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($110a8439d6f657ff$export$835fcf23ab7bf88, $110a8439d6f657ff$var$_extends({
        data: data
    }, label, {
        key: "labelList-implicit"
    }));
    return null;
}
function $110a8439d6f657ff$var$renderCallByParent(parentProps, data) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var explicitChildren = (0, $f06D9.findAllByType)(children, $110a8439d6f657ff$export$835fcf23ab7bf88).map(function(child, index) {
        return /*#__PURE__*/ (0, $jbmdS.cloneElement)(child, {
            data: data,
            // eslint-disable-next-line react/no-array-index-key
            key: "labelList-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabelList = $110a8439d6f657ff$var$parseLabelList(parentProps.label, data);
    return [
        implicitLabelList
    ].concat($110a8439d6f657ff$var$_toConsumableArray(explicitChildren));
}
$110a8439d6f657ff$export$835fcf23ab7bf88.renderCallByParent = $110a8439d6f657ff$var$renderCallByParent;

});
parcelRegister("4Z5bA", function(module, exports) {
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $3a10e1c0a39c7b78$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
module.exports = $3a10e1c0a39c7b78$var$last;

});

parcelRegister("eGPJt", function(module, exports) {

$parcel$export(module.exports, "Label", function () { return $ab1d1de844b7f000$export$b04be29aa201d4f5; });

var $jbmdS = parcelRequire("jbmdS");

var $aVX0M = parcelRequire("aVX0M");

var $i99FY = parcelRequire("i99FY");

var $hBKZ2 = parcelRequire("hBKZ2");

var $dWgPS = parcelRequire("dWgPS");

var $hyGHv = parcelRequire("hyGHv");

var $f06D9 = parcelRequire("f06D9");

var $1gmrG = parcelRequire("1gmrG");

var $h7eoY = parcelRequire("h7eoY");
function $ab1d1de844b7f000$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ab1d1de844b7f000$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ab1d1de844b7f000$var$_typeof(o);
}
var $ab1d1de844b7f000$var$_excluded = [
    "offset"
];
function $ab1d1de844b7f000$var$_toConsumableArray(arr) {
    return $ab1d1de844b7f000$var$_arrayWithoutHoles(arr) || $ab1d1de844b7f000$var$_iterableToArray(arr) || $ab1d1de844b7f000$var$_unsupportedIterableToArray(arr) || $ab1d1de844b7f000$var$_nonIterableSpread();
}
function $ab1d1de844b7f000$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ab1d1de844b7f000$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ab1d1de844b7f000$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ab1d1de844b7f000$var$_arrayLikeToArray(o, minLen);
}
function $ab1d1de844b7f000$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $ab1d1de844b7f000$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $ab1d1de844b7f000$var$_arrayLikeToArray(arr);
}
function $ab1d1de844b7f000$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ab1d1de844b7f000$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ab1d1de844b7f000$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ab1d1de844b7f000$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ab1d1de844b7f000$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ab1d1de844b7f000$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ab1d1de844b7f000$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ab1d1de844b7f000$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ab1d1de844b7f000$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ab1d1de844b7f000$var$_defineProperty(obj, key, value) {
    key = $ab1d1de844b7f000$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ab1d1de844b7f000$var$_toPropertyKey(t) {
    var i = $ab1d1de844b7f000$var$_toPrimitive(t, "string");
    return "symbol" == $ab1d1de844b7f000$var$_typeof(i) ? i : i + "";
}
function $ab1d1de844b7f000$var$_toPrimitive(t, r) {
    if ("object" != $ab1d1de844b7f000$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ab1d1de844b7f000$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $ab1d1de844b7f000$var$_extends() {
    $ab1d1de844b7f000$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ab1d1de844b7f000$var$_extends.apply(this, arguments);
}
var $ab1d1de844b7f000$var$getLabel = function getLabel(props) {
    var value = props.value, formatter = props.formatter;
    var label = (0, (/*@__PURE__*/$parcel$interopDefault($aVX0M)))(props.children) ? value : props.children;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(formatter)) return formatter(label);
    return label;
};
var $ab1d1de844b7f000$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $1gmrG.mathSign)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
};
var $ab1d1de844b7f000$var$renderRadialLabel = function renderRadialLabel(labelProps, label, attrs) {
    var position = labelProps.position, viewBox = labelProps.viewBox, offset = labelProps.offset, className = labelProps.className;
    var _ref = viewBox, cx = _ref.cx, cy = _ref.cy, innerRadius = _ref.innerRadius, outerRadius = _ref.outerRadius, startAngle = _ref.startAngle, endAngle = _ref.endAngle, clockWise = _ref.clockWise;
    var radius = (innerRadius + outerRadius) / 2;
    var deltaAngle = $ab1d1de844b7f000$var$getDeltaAngle(startAngle, endAngle);
    var sign = deltaAngle >= 0 ? 1 : -1;
    var labelAngle, direction;
    if (position === "insideStart") {
        labelAngle = startAngle + sign * offset;
        direction = clockWise;
    } else if (position === "insideEnd") {
        labelAngle = endAngle - sign * offset;
        direction = !clockWise;
    } else if (position === "end") {
        labelAngle = endAngle + sign * offset;
        direction = clockWise;
    }
    direction = deltaAngle <= 0 ? direction : !direction;
    var startPoint = (0, $h7eoY.polarToCartesian)(cx, cy, radius, labelAngle);
    var endPoint = (0, $h7eoY.polarToCartesian)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
    var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
    var id = (0, (/*@__PURE__*/$parcel$interopDefault($aVX0M)))(labelProps.id) ? (0, $1gmrG.uniqueId)("recharts-radial-line-") : labelProps.id;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("text", $ab1d1de844b7f000$var$_extends({}, attrs, {
        dominantBaseline: "central",
        className: (0, $dWgPS.default)("recharts-radial-bar-label", className)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("path", {
        id: id,
        d: path
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("textPath", {
        xlinkHref: "#".concat(id)
    }, label));
};
var $ab1d1de844b7f000$var$getAttrsOfPolarLabel = function getAttrsOfPolarLabel(props) {
    var viewBox = props.viewBox, offset = props.offset, position = props.position;
    var _ref2 = viewBox, cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var midAngle = (startAngle + endAngle) / 2;
    if (position === "outside") {
        var _polarToCartesian = (0, $h7eoY.polarToCartesian)(cx, cy, outerRadius + offset, midAngle), _x = _polarToCartesian.x, _y = _polarToCartesian.y;
        return {
            x: _x,
            y: _y,
            textAnchor: _x >= cx ? "start" : "end",
            verticalAnchor: "middle"
        };
    }
    if (position === "center") return {
        x: cx,
        y: cy,
        textAnchor: "middle",
        verticalAnchor: "middle"
    };
    if (position === "centerTop") return {
        x: cx,
        y: cy,
        textAnchor: "middle",
        verticalAnchor: "start"
    };
    if (position === "centerBottom") return {
        x: cx,
        y: cy,
        textAnchor: "middle",
        verticalAnchor: "end"
    };
    var r = (innerRadius + outerRadius) / 2;
    var _polarToCartesian2 = (0, $h7eoY.polarToCartesian)(cx, cy, r, midAngle), x = _polarToCartesian2.x, y = _polarToCartesian2.y;
    return {
        x: x,
        y: y,
        textAnchor: "middle",
        verticalAnchor: "middle"
    };
};
var $ab1d1de844b7f000$var$getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel(props) {
    var viewBox = props.viewBox, parentViewBox = props.parentViewBox, offset = props.offset, position = props.position;
    var _ref3 = viewBox, x = _ref3.x, y = _ref3.y, width = _ref3.width, height = _ref3.height;
    // Define vertical offsets and position inverts based on the value being positive or negative
    var verticalSign = height >= 0 ? 1 : -1;
    var verticalOffset = verticalSign * offset;
    var verticalEnd = verticalSign > 0 ? "end" : "start";
    var verticalStart = verticalSign > 0 ? "start" : "end";
    // Define horizontal offsets and position inverts based on the value being positive or negative
    var horizontalSign = width >= 0 ? 1 : -1;
    var horizontalOffset = horizontalSign * offset;
    var horizontalEnd = horizontalSign > 0 ? "end" : "start";
    var horizontalStart = horizontalSign > 0 ? "start" : "end";
    if (position === "top") {
        var attrs = {
            x: x + width / 2,
            y: y - verticalSign * offset,
            textAnchor: "middle",
            verticalAnchor: verticalEnd
        };
        return $ab1d1de844b7f000$var$_objectSpread($ab1d1de844b7f000$var$_objectSpread({}, attrs), parentViewBox ? {
            height: Math.max(y - parentViewBox.y, 0),
            width: width
        } : {});
    }
    if (position === "bottom") {
        var _attrs = {
            x: x + width / 2,
            y: y + height + verticalOffset,
            textAnchor: "middle",
            verticalAnchor: verticalStart
        };
        return $ab1d1de844b7f000$var$_objectSpread($ab1d1de844b7f000$var$_objectSpread({}, _attrs), parentViewBox ? {
            height: Math.max(parentViewBox.y + parentViewBox.height - (y + height), 0),
            width: width
        } : {});
    }
    if (position === "left") {
        var _attrs2 = {
            x: x - horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalEnd,
            verticalAnchor: "middle"
        };
        return $ab1d1de844b7f000$var$_objectSpread($ab1d1de844b7f000$var$_objectSpread({}, _attrs2), parentViewBox ? {
            width: Math.max(_attrs2.x - parentViewBox.x, 0),
            height: height
        } : {});
    }
    if (position === "right") {
        var _attrs3 = {
            x: x + width + horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalStart,
            verticalAnchor: "middle"
        };
        return $ab1d1de844b7f000$var$_objectSpread($ab1d1de844b7f000$var$_objectSpread({}, _attrs3), parentViewBox ? {
            width: Math.max(parentViewBox.x + parentViewBox.width - _attrs3.x, 0),
            height: height
        } : {});
    }
    var sizeAttrs = parentViewBox ? {
        width: width,
        height: height
    } : {};
    if (position === "insideLeft") return $ab1d1de844b7f000$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalStart,
        verticalAnchor: "middle"
    }, sizeAttrs);
    if (position === "insideRight") return $ab1d1de844b7f000$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalEnd,
        verticalAnchor: "middle"
    }, sizeAttrs);
    if (position === "insideTop") return $ab1d1de844b7f000$var$_objectSpread({
        x: x + width / 2,
        y: y + verticalOffset,
        textAnchor: "middle",
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === "insideBottom") return $ab1d1de844b7f000$var$_objectSpread({
        x: x + width / 2,
        y: y + height - verticalOffset,
        textAnchor: "middle",
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === "insideTopLeft") return $ab1d1de844b7f000$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === "insideTopRight") return $ab1d1de844b7f000$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === "insideBottomLeft") return $ab1d1de844b7f000$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === "insideBottomRight") return $ab1d1de844b7f000$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hBKZ2)))(position) && ((0, $1gmrG.isNumber)(position.x) || (0, $1gmrG.isPercent)(position.x)) && ((0, $1gmrG.isNumber)(position.y) || (0, $1gmrG.isPercent)(position.y))) return $ab1d1de844b7f000$var$_objectSpread({
        x: x + (0, $1gmrG.getPercentValue)(position.x, width),
        y: y + (0, $1gmrG.getPercentValue)(position.y, height),
        textAnchor: "end",
        verticalAnchor: "end"
    }, sizeAttrs);
    return $ab1d1de844b7f000$var$_objectSpread({
        x: x + width / 2,
        y: y + height / 2,
        textAnchor: "middle",
        verticalAnchor: "middle"
    }, sizeAttrs);
};
var $ab1d1de844b7f000$var$isPolar = function isPolar(viewBox) {
    return "cx" in viewBox && (0, $1gmrG.isNumber)(viewBox.cx);
};
function $ab1d1de844b7f000$export$b04be29aa201d4f5(_ref4) {
    var _ref4$offset = _ref4.offset, offset = _ref4$offset === void 0 ? 5 : _ref4$offset, restProps = $ab1d1de844b7f000$var$_objectWithoutProperties(_ref4, $ab1d1de844b7f000$var$_excluded);
    var props = $ab1d1de844b7f000$var$_objectSpread({
        offset: offset
    }, restProps);
    var viewBox = props.viewBox, position = props.position, value = props.value, children = props.children, content = props.content, _props$className = props.className, className = _props$className === void 0 ? "" : _props$className, textBreakAll = props.textBreakAll;
    if (!viewBox || (0, (/*@__PURE__*/$parcel$interopDefault($aVX0M)))(value) && (0, (/*@__PURE__*/$parcel$interopDefault($aVX0M)))(children) && !/*#__PURE__*/ (0, $jbmdS.isValidElement)(content) && !(0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(content)) return null;
    if (/*#__PURE__*/ (0, $jbmdS.isValidElement)(content)) return /*#__PURE__*/ (0, $jbmdS.cloneElement)(content, props);
    var label;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(content)) {
        label = /*#__PURE__*/ (0, $jbmdS.createElement)(content, props);
        if (/*#__PURE__*/ (0, $jbmdS.isValidElement)(label)) return label;
    } else label = $ab1d1de844b7f000$var$getLabel(props);
    var isPolarLabel = $ab1d1de844b7f000$var$isPolar(viewBox);
    var attrs = (0, $f06D9.filterProps)(props, true);
    if (isPolarLabel && (position === "insideStart" || position === "insideEnd" || position === "end")) return $ab1d1de844b7f000$var$renderRadialLabel(props, label, attrs);
    var positionAttrs = isPolarLabel ? $ab1d1de844b7f000$var$getAttrsOfPolarLabel(props) : $ab1d1de844b7f000$var$getAttrsOfCartesianLabel(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $hyGHv.Text), $ab1d1de844b7f000$var$_extends({
        className: (0, $dWgPS.default)("recharts-label", className)
    }, attrs, positionAttrs, {
        breakAll: textBreakAll
    }), label);
}
$ab1d1de844b7f000$export$b04be29aa201d4f5.displayName = "Label";
var $ab1d1de844b7f000$var$parseViewBox = function parseViewBox(props) {
    var cx = props.cx, cy = props.cy, angle = props.angle, startAngle = props.startAngle, endAngle = props.endAngle, r = props.r, radius = props.radius, innerRadius = props.innerRadius, outerRadius = props.outerRadius, x = props.x, y = props.y, top = props.top, left = props.left, width = props.width, height = props.height, clockWise = props.clockWise, labelViewBox = props.labelViewBox;
    if (labelViewBox) return labelViewBox;
    if ((0, $1gmrG.isNumber)(width) && (0, $1gmrG.isNumber)(height)) {
        if ((0, $1gmrG.isNumber)(x) && (0, $1gmrG.isNumber)(y)) return {
            x: x,
            y: y,
            width: width,
            height: height
        };
        if ((0, $1gmrG.isNumber)(top) && (0, $1gmrG.isNumber)(left)) return {
            x: top,
            y: left,
            width: width,
            height: height
        };
    }
    if ((0, $1gmrG.isNumber)(x) && (0, $1gmrG.isNumber)(y)) return {
        x: x,
        y: y,
        width: 0,
        height: 0
    };
    if ((0, $1gmrG.isNumber)(cx) && (0, $1gmrG.isNumber)(cy)) return {
        cx: cx,
        cy: cy,
        startAngle: startAngle || angle || 0,
        endAngle: endAngle || angle || 0,
        innerRadius: innerRadius || 0,
        outerRadius: outerRadius || radius || r || 0,
        clockWise: clockWise
    };
    if (props.viewBox) return props.viewBox;
    return {};
};
var $ab1d1de844b7f000$var$parseLabel = function parseLabel(label, viewBox) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($ab1d1de844b7f000$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox
    });
    if ((0, $1gmrG.isNumOrStr)(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($ab1d1de844b7f000$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox,
        value: label
    });
    if (/*#__PURE__*/ (0, $jbmdS.isValidElement)(label)) {
        if (label.type === $ab1d1de844b7f000$export$b04be29aa201d4f5) return /*#__PURE__*/ (0, $jbmdS.cloneElement)(label, {
            key: "label-implicit",
            viewBox: viewBox
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($ab1d1de844b7f000$export$b04be29aa201d4f5, {
            key: "label-implicit",
            content: label,
            viewBox: viewBox
        });
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($ab1d1de844b7f000$export$b04be29aa201d4f5, {
        key: "label-implicit",
        content: label,
        viewBox: viewBox
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hBKZ2)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($ab1d1de844b7f000$export$b04be29aa201d4f5, $ab1d1de844b7f000$var$_extends({
        viewBox: viewBox
    }, label, {
        key: "label-implicit"
    }));
    return null;
};
var $ab1d1de844b7f000$var$renderCallByParent = function renderCallByParent(parentProps, viewBox) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var parentViewBox = $ab1d1de844b7f000$var$parseViewBox(parentProps);
    var explicitChildren = (0, $f06D9.findAllByType)(children, $ab1d1de844b7f000$export$b04be29aa201d4f5).map(function(child, index) {
        return /*#__PURE__*/ (0, $jbmdS.cloneElement)(child, {
            viewBox: viewBox || parentViewBox,
            // eslint-disable-next-line react/no-array-index-key
            key: "label-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabel = $ab1d1de844b7f000$var$parseLabel(parentProps.label, viewBox || parentViewBox);
    return [
        implicitLabel
    ].concat($ab1d1de844b7f000$var$_toConsumableArray(explicitChildren));
};
$ab1d1de844b7f000$export$b04be29aa201d4f5.parseViewBox = $ab1d1de844b7f000$var$parseViewBox;
$ab1d1de844b7f000$export$b04be29aa201d4f5.renderCallByParent = $ab1d1de844b7f000$var$renderCallByParent;

});
parcelRegister("hyGHv", function(module, exports) {

$parcel$export(module.exports, "Text", function () { return $cc86bc21be8338ee$export$5f1af8db9871e1d6; });

var $jbmdS = parcelRequire("jbmdS");

var $aVX0M = parcelRequire("aVX0M");

var $dWgPS = parcelRequire("dWgPS");

var $1gmrG = parcelRequire("1gmrG");

var $9wZNv = parcelRequire("9wZNv");

var $f06D9 = parcelRequire("f06D9");

var $kPfcu = parcelRequire("kPfcu");

var $B8IAX = parcelRequire("B8IAX");
var $cc86bc21be8338ee$var$_excluded = [
    "x",
    "y",
    "lineHeight",
    "capHeight",
    "scaleToFit",
    "textAnchor",
    "verticalAnchor",
    "fill"
], $cc86bc21be8338ee$var$_excluded2 = [
    "dx",
    "dy",
    "angle",
    "className",
    "breakAll"
];
function $cc86bc21be8338ee$var$_extends() {
    $cc86bc21be8338ee$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cc86bc21be8338ee$var$_extends.apply(this, arguments);
}
function $cc86bc21be8338ee$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $cc86bc21be8338ee$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $cc86bc21be8338ee$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $cc86bc21be8338ee$var$_slicedToArray(arr, i) {
    return $cc86bc21be8338ee$var$_arrayWithHoles(arr) || $cc86bc21be8338ee$var$_iterableToArrayLimit(arr, i) || $cc86bc21be8338ee$var$_unsupportedIterableToArray(arr, i) || $cc86bc21be8338ee$var$_nonIterableRest();
}
function $cc86bc21be8338ee$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $cc86bc21be8338ee$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $cc86bc21be8338ee$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $cc86bc21be8338ee$var$_arrayLikeToArray(o, minLen);
}
function $cc86bc21be8338ee$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $cc86bc21be8338ee$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $cc86bc21be8338ee$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $cc86bc21be8338ee$var$BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
var $cc86bc21be8338ee$var$calculateWordWidths = function calculateWordWidths(_ref) {
    var children = _ref.children, breakAll = _ref.breakAll, style = _ref.style;
    try {
        var words = [];
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($aVX0M)))(children)) {
            if (breakAll) words = children.toString().split("");
            else words = children.toString().split($cc86bc21be8338ee$var$BREAKING_SPACES);
        }
        var wordsWithComputedWidth = words.map(function(word) {
            return {
                word: word,
                width: (0, $kPfcu.getStringSize)(word, style).width
            };
        });
        var spaceWidth = breakAll ? 0 : (0, $kPfcu.getStringSize)("\xa0", style).width;
        return {
            wordsWithComputedWidth: wordsWithComputedWidth,
            spaceWidth: spaceWidth
        };
    } catch (e) {
        return null;
    }
};
var $cc86bc21be8338ee$var$calculateWordsByLines = function calculateWordsByLines(_ref2, initialWordsWithComputedWith, spaceWidth, lineWidth, scaleToFit) {
    var maxLines = _ref2.maxLines, children = _ref2.children, style = _ref2.style, breakAll = _ref2.breakAll;
    var shouldLimitLines = (0, $1gmrG.isNumber)(maxLines);
    var text = children;
    var calculate = function calculate() {
        var words = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return words.reduce(function(result, _ref3) {
            var word = _ref3.word, width = _ref3.width;
            var currentLine = result[result.length - 1];
            if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < Number(lineWidth))) {
                // Word can be added to an existing line
                currentLine.words.push(word);
                currentLine.width += width + spaceWidth;
            } else {
                // Add first word to line or word is too long to scaleToFit on existing line
                var newLine = {
                    words: [
                        word
                    ],
                    width: width
                };
                result.push(newLine);
            }
            return result;
        }, []);
    };
    var originalResult = calculate(initialWordsWithComputedWith);
    var findLongestLine = function findLongestLine(words) {
        return words.reduce(function(a, b) {
            return a.width > b.width ? a : b;
        });
    };
    if (!shouldLimitLines) return originalResult;
    var suffix = "\u2026";
    var checkOverflow = function checkOverflow(index) {
        var tempText = text.slice(0, index);
        var words = $cc86bc21be8338ee$var$calculateWordWidths({
            breakAll: breakAll,
            style: style,
            children: tempText + suffix
        }).wordsWithComputedWidth;
        var result = calculate(words);
        var doesOverflow = result.length > maxLines || findLongestLine(result).width > Number(lineWidth);
        return [
            doesOverflow,
            result
        ];
    };
    var start = 0;
    var end = text.length - 1;
    var iterations = 0;
    var trimmedResult;
    while(start <= end && iterations <= text.length - 1){
        var middle = Math.floor((start + end) / 2);
        var prev = middle - 1;
        var _checkOverflow = checkOverflow(prev), _checkOverflow2 = $cc86bc21be8338ee$var$_slicedToArray(_checkOverflow, 2), doesPrevOverflow = _checkOverflow2[0], result = _checkOverflow2[1];
        var _checkOverflow3 = checkOverflow(middle), _checkOverflow4 = $cc86bc21be8338ee$var$_slicedToArray(_checkOverflow3, 1), doesMiddleOverflow = _checkOverflow4[0];
        if (!doesPrevOverflow && !doesMiddleOverflow) start = middle + 1;
        if (doesPrevOverflow && doesMiddleOverflow) end = middle - 1;
        if (!doesPrevOverflow && doesMiddleOverflow) {
            trimmedResult = result;
            break;
        }
        iterations++;
    }
    // Fallback to originalResult (result without trimming) if we cannot find the
    // where to trim.  This should not happen :tm:
    return trimmedResult || originalResult;
};
var $cc86bc21be8338ee$var$getWordsWithoutCalculate = function getWordsWithoutCalculate(children) {
    var words = !(0, (/*@__PURE__*/$parcel$interopDefault($aVX0M)))(children) ? children.toString().split($cc86bc21be8338ee$var$BREAKING_SPACES) : [];
    return [
        {
            words: words
        }
    ];
};
var $cc86bc21be8338ee$var$getWordsByLines = function getWordsByLines(_ref4) {
    var width = _ref4.width, scaleToFit = _ref4.scaleToFit, children = _ref4.children, style = _ref4.style, breakAll = _ref4.breakAll, maxLines = _ref4.maxLines;
    // Only perform calculations if using features that require them (multiline, scaleToFit)
    if ((width || scaleToFit) && !(0, $9wZNv.Global).isSsr) {
        var wordsWithComputedWidth, spaceWidth;
        var wordWidths = $cc86bc21be8338ee$var$calculateWordWidths({
            breakAll: breakAll,
            children: children,
            style: style
        });
        if (wordWidths) {
            var wcw = wordWidths.wordsWithComputedWidth, sw = wordWidths.spaceWidth;
            wordsWithComputedWidth = wcw;
            spaceWidth = sw;
        } else return $cc86bc21be8338ee$var$getWordsWithoutCalculate(children);
        return $cc86bc21be8338ee$var$calculateWordsByLines({
            breakAll: breakAll,
            children: children,
            maxLines: maxLines,
            style: style
        }, wordsWithComputedWidth, spaceWidth, width, scaleToFit);
    }
    return $cc86bc21be8338ee$var$getWordsWithoutCalculate(children);
};
var $cc86bc21be8338ee$var$DEFAULT_FILL = "#808080";
var $cc86bc21be8338ee$export$5f1af8db9871e1d6 = function Text(_ref5) {
    var _ref5$x = _ref5.x, propsX = _ref5$x === void 0 ? 0 : _ref5$x, _ref5$y = _ref5.y, propsY = _ref5$y === void 0 ? 0 : _ref5$y, _ref5$lineHeight = _ref5.lineHeight, lineHeight = _ref5$lineHeight === void 0 ? "1em" : _ref5$lineHeight, _ref5$capHeight = _ref5.capHeight, capHeight = _ref5$capHeight === void 0 ? "0.71em" : _ref5$capHeight, _ref5$scaleToFit = _ref5.scaleToFit, scaleToFit = _ref5$scaleToFit === void 0 ? false : _ref5$scaleToFit, _ref5$textAnchor = _ref5.textAnchor, textAnchor = _ref5$textAnchor === void 0 ? "start" : _ref5$textAnchor, _ref5$verticalAnchor = _ref5.verticalAnchor, verticalAnchor = _ref5$verticalAnchor === void 0 ? "end" : _ref5$verticalAnchor, _ref5$fill = _ref5.fill, fill = _ref5$fill === void 0 ? $cc86bc21be8338ee$var$DEFAULT_FILL : _ref5$fill, props = $cc86bc21be8338ee$var$_objectWithoutProperties(_ref5, $cc86bc21be8338ee$var$_excluded);
    var wordsByLines = (0, $jbmdS.useMemo)(function() {
        return $cc86bc21be8338ee$var$getWordsByLines({
            breakAll: props.breakAll,
            children: props.children,
            maxLines: props.maxLines,
            scaleToFit: scaleToFit,
            style: props.style,
            width: props.width
        });
    }, [
        props.breakAll,
        props.children,
        props.maxLines,
        scaleToFit,
        props.style,
        props.width
    ]);
    var dx = props.dx, dy = props.dy, angle = props.angle, className = props.className, breakAll = props.breakAll, textProps = $cc86bc21be8338ee$var$_objectWithoutProperties(props, $cc86bc21be8338ee$var$_excluded2);
    if (!(0, $1gmrG.isNumOrStr)(propsX) || !(0, $1gmrG.isNumOrStr)(propsY)) return null;
    var x = propsX + ((0, $1gmrG.isNumber)(dx) ? dx : 0);
    var y = propsY + ((0, $1gmrG.isNumber)(dy) ? dy : 0);
    var startDy;
    switch(verticalAnchor){
        case "start":
            startDy = (0, $B8IAX.reduceCSSCalc)("calc(".concat(capHeight, ")"));
            break;
        case "middle":
            startDy = (0, $B8IAX.reduceCSSCalc)("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
            break;
        default:
            startDy = (0, $B8IAX.reduceCSSCalc)("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
            break;
    }
    var transforms = [];
    if (scaleToFit) {
        var lineWidth = wordsByLines[0].width;
        var width = props.width;
        transforms.push("scale(".concat(((0, $1gmrG.isNumber)(width) ? width / lineWidth : 1) / lineWidth, ")"));
    }
    if (angle) transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
    if (transforms.length) textProps.transform = transforms.join(" ");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("text", $cc86bc21be8338ee$var$_extends({}, (0, $f06D9.filterProps)(textProps, true), {
        x: x,
        y: y,
        className: (0, $dWgPS.default)("recharts-text", className),
        textAnchor: textAnchor,
        fill: fill.includes("url") ? $cc86bc21be8338ee$var$DEFAULT_FILL : fill
    }), wordsByLines.map(function(line, index) {
        var words = line.words.join(breakAll ? "" : " ");
        return(/*#__PURE__*/ // duplicate words will cause duplicate keys
        // eslint-disable-next-line react/no-array-index-key
        (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("tspan", {
            x: x,
            dy: index === 0 ? startDy : lineHeight,
            key: "".concat(words, "-").concat(index)
        }, words));
    }));
};

});
parcelRegister("9wZNv", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $6f0709eac31bf5f6$export$98f03c5d19621d70; });
var $6f0709eac31bf5f6$var$parseIsSsrByDefault = function parseIsSsrByDefault() {
    return !(typeof window !== "undefined" && window.document && window.document.createElement && window.setTimeout);
};
var $6f0709eac31bf5f6$export$98f03c5d19621d70 = {
    isSsr: $6f0709eac31bf5f6$var$parseIsSsrByDefault(),
    get: function get(key) {
        return $6f0709eac31bf5f6$export$98f03c5d19621d70[key];
    },
    set: function set(key, value) {
        if (typeof key === "string") $6f0709eac31bf5f6$export$98f03c5d19621d70[key] = value;
        else {
            var keys = Object.keys(key);
            if (keys && keys.length) keys.forEach(function(k) {
                $6f0709eac31bf5f6$export$98f03c5d19621d70[k] = key[k];
            });
        }
    }
};

});

parcelRegister("kPfcu", function(module, exports) {

$parcel$export(module.exports, "getStringSize", function () { return $f2945c8fe0cead82$export$e5560531f057ad5d; });
$parcel$export(module.exports, "getOffset", function () { return $f2945c8fe0cead82$export$622cea445a1c5b7d; });

var $9wZNv = parcelRequire("9wZNv");
function $f2945c8fe0cead82$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f2945c8fe0cead82$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f2945c8fe0cead82$var$_typeof(o);
}
function $f2945c8fe0cead82$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f2945c8fe0cead82$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f2945c8fe0cead82$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f2945c8fe0cead82$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f2945c8fe0cead82$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f2945c8fe0cead82$var$_defineProperty(obj, key, value) {
    key = $f2945c8fe0cead82$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f2945c8fe0cead82$var$_toPropertyKey(t) {
    var i = $f2945c8fe0cead82$var$_toPrimitive(t, "string");
    return "symbol" == $f2945c8fe0cead82$var$_typeof(i) ? i : i + "";
}
function $f2945c8fe0cead82$var$_toPrimitive(t, r) {
    if ("object" != $f2945c8fe0cead82$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f2945c8fe0cead82$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $f2945c8fe0cead82$var$_toConsumableArray(arr) {
    return $f2945c8fe0cead82$var$_arrayWithoutHoles(arr) || $f2945c8fe0cead82$var$_iterableToArray(arr) || $f2945c8fe0cead82$var$_unsupportedIterableToArray(arr) || $f2945c8fe0cead82$var$_nonIterableSpread();
}
function $f2945c8fe0cead82$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f2945c8fe0cead82$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f2945c8fe0cead82$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f2945c8fe0cead82$var$_arrayLikeToArray(o, minLen);
}
function $f2945c8fe0cead82$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $f2945c8fe0cead82$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $f2945c8fe0cead82$var$_arrayLikeToArray(arr);
}
function $f2945c8fe0cead82$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $f2945c8fe0cead82$var$stringCache = {
    widthCache: {},
    cacheCount: 0
};
var $f2945c8fe0cead82$var$MAX_CACHE_NUM = 2000;
var $f2945c8fe0cead82$var$SPAN_STYLE = {
    position: "absolute",
    top: "-20000px",
    left: 0,
    padding: 0,
    margin: 0,
    border: "none",
    whiteSpace: "pre"
};
var $f2945c8fe0cead82$var$STYLE_LIST = [
    "minWidth",
    "maxWidth",
    "width",
    "minHeight",
    "maxHeight",
    "height",
    "top",
    "left",
    "fontSize",
    "lineHeight",
    "padding",
    "margin",
    "paddingLeft",
    "paddingRight",
    "paddingTop",
    "paddingBottom",
    "marginLeft",
    "marginRight",
    "marginTop",
    "marginBottom"
];
var $f2945c8fe0cead82$var$MEASUREMENT_SPAN_ID = "recharts_measurement_span";
function $f2945c8fe0cead82$var$autoCompleteStyle(name, value) {
    if ($f2945c8fe0cead82$var$STYLE_LIST.indexOf(name) >= 0 && value === +value) return "".concat(value, "px");
    return value;
}
function $f2945c8fe0cead82$var$camelToMiddleLine(text) {
    var strs = text.split("");
    var formatStrs = strs.reduce(function(result, entry) {
        if (entry === entry.toUpperCase()) return [].concat($f2945c8fe0cead82$var$_toConsumableArray(result), [
            "-",
            entry.toLowerCase()
        ]);
        return [].concat($f2945c8fe0cead82$var$_toConsumableArray(result), [
            entry
        ]);
    }, []);
    return formatStrs.join("");
}
var $f2945c8fe0cead82$export$9a2c38fb88d8e30 = function getStyleString(style) {
    return Object.keys(style).reduce(function(result, s) {
        return "".concat(result).concat($f2945c8fe0cead82$var$camelToMiddleLine(s), ":").concat($f2945c8fe0cead82$var$autoCompleteStyle(s, style[s]), ";");
    }, "");
};
function $f2945c8fe0cead82$var$removeInvalidKeys(obj) {
    var copyObj = $f2945c8fe0cead82$var$_objectSpread({}, obj);
    Object.keys(copyObj).forEach(function(key) {
        if (!copyObj[key]) delete copyObj[key];
    });
    return copyObj;
}
var $f2945c8fe0cead82$export$e5560531f057ad5d = function getStringSize(text) {
    var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (text === undefined || text === null || (0, $9wZNv.Global).isSsr) return {
        width: 0,
        height: 0
    };
    var copyStyle = $f2945c8fe0cead82$var$removeInvalidKeys(style);
    var cacheKey = JSON.stringify({
        text: text,
        copyStyle: copyStyle
    });
    if ($f2945c8fe0cead82$var$stringCache.widthCache[cacheKey]) return $f2945c8fe0cead82$var$stringCache.widthCache[cacheKey];
    try {
        var measurementSpan = document.getElementById($f2945c8fe0cead82$var$MEASUREMENT_SPAN_ID);
        if (!measurementSpan) {
            measurementSpan = document.createElement("span");
            measurementSpan.setAttribute("id", $f2945c8fe0cead82$var$MEASUREMENT_SPAN_ID);
            measurementSpan.setAttribute("aria-hidden", "true");
            document.body.appendChild(measurementSpan);
        }
        // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
        // https://en.wikipedia.org/wiki/Content_Security_Policy
        var measurementSpanStyle = $f2945c8fe0cead82$var$_objectSpread($f2945c8fe0cead82$var$_objectSpread({}, $f2945c8fe0cead82$var$SPAN_STYLE), copyStyle);
        Object.assign(measurementSpan.style, measurementSpanStyle);
        measurementSpan.textContent = "".concat(text);
        var rect = measurementSpan.getBoundingClientRect();
        var result = {
            width: rect.width,
            height: rect.height
        };
        $f2945c8fe0cead82$var$stringCache.widthCache[cacheKey] = result;
        if (++$f2945c8fe0cead82$var$stringCache.cacheCount > $f2945c8fe0cead82$var$MAX_CACHE_NUM) {
            $f2945c8fe0cead82$var$stringCache.cacheCount = 0;
            $f2945c8fe0cead82$var$stringCache.widthCache = {};
        }
        return result;
    } catch (e) {
        return {
            width: 0,
            height: 0
        };
    }
};
var $f2945c8fe0cead82$export$622cea445a1c5b7d = function getOffset(rect) {
    return {
        top: rect.top + window.scrollY - document.documentElement.clientTop,
        left: rect.left + window.scrollX - document.documentElement.clientLeft
    };
};

});

parcelRegister("B8IAX", function(module, exports) {

$parcel$export(module.exports, "reduceCSSCalc", function () { return $06fa38157780d3a2$export$254eac204f89fd7d; });
function $06fa38157780d3a2$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $06fa38157780d3a2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $06fa38157780d3a2$var$_typeof(o);
}
function $06fa38157780d3a2$var$_slicedToArray(arr, i) {
    return $06fa38157780d3a2$var$_arrayWithHoles(arr) || $06fa38157780d3a2$var$_iterableToArrayLimit(arr, i) || $06fa38157780d3a2$var$_unsupportedIterableToArray(arr, i) || $06fa38157780d3a2$var$_nonIterableRest();
}
function $06fa38157780d3a2$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $06fa38157780d3a2$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $06fa38157780d3a2$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $06fa38157780d3a2$var$_arrayLikeToArray(o, minLen);
}
function $06fa38157780d3a2$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $06fa38157780d3a2$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $06fa38157780d3a2$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $06fa38157780d3a2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $06fa38157780d3a2$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $06fa38157780d3a2$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $06fa38157780d3a2$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $06fa38157780d3a2$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $06fa38157780d3a2$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $06fa38157780d3a2$var$_toPropertyKey(t) {
    var i = $06fa38157780d3a2$var$_toPrimitive(t, "string");
    return "symbol" == $06fa38157780d3a2$var$_typeof(i) ? i : i + "";
}
function $06fa38157780d3a2$var$_toPrimitive(t, r) {
    if ("object" != $06fa38157780d3a2$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $06fa38157780d3a2$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $06fa38157780d3a2$var$MULTIPLY_OR_DIVIDE_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $06fa38157780d3a2$var$ADD_OR_SUBTRACT_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $06fa38157780d3a2$var$CSS_LENGTH_UNIT_REGEX = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/;
var $06fa38157780d3a2$var$NUM_SPLIT_REGEX = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/;
var $06fa38157780d3a2$var$CONVERSION_RATES = {
    cm: 96 / 2.54,
    mm: 96 / 25.4,
    pt: 96 / 72,
    pc: 16,
    "in": 96,
    Q: 96 / 101.6,
    px: 1
};
var $06fa38157780d3a2$var$FIXED_CSS_LENGTH_UNITS = Object.keys($06fa38157780d3a2$var$CONVERSION_RATES);
var $06fa38157780d3a2$var$STR_NAN = "NaN";
function $06fa38157780d3a2$var$convertToPx(value, unit) {
    return value * $06fa38157780d3a2$var$CONVERSION_RATES[unit];
}
var $06fa38157780d3a2$var$DecimalCSS = /*#__PURE__*/ function() {
    function DecimalCSS(num, unit) {
        $06fa38157780d3a2$var$_classCallCheck(this, DecimalCSS);
        this.num = num;
        this.unit = unit;
        this.num = num;
        this.unit = unit;
        if (Number.isNaN(num)) this.unit = "";
        if (unit !== "" && !$06fa38157780d3a2$var$CSS_LENGTH_UNIT_REGEX.test(unit)) {
            this.num = NaN;
            this.unit = "";
        }
        if ($06fa38157780d3a2$var$FIXED_CSS_LENGTH_UNITS.includes(unit)) {
            this.num = $06fa38157780d3a2$var$convertToPx(num, unit);
            this.unit = "px";
        }
    }
    return $06fa38157780d3a2$var$_createClass(DecimalCSS, [
        {
            key: "add",
            value: function add(other) {
                if (this.unit !== other.unit) return new DecimalCSS(NaN, "");
                return new DecimalCSS(this.num + other.num, this.unit);
            }
        },
        {
            key: "subtract",
            value: function subtract(other) {
                if (this.unit !== other.unit) return new DecimalCSS(NaN, "");
                return new DecimalCSS(this.num - other.num, this.unit);
            }
        },
        {
            key: "multiply",
            value: function multiply(other) {
                if (this.unit !== "" && other.unit !== "" && this.unit !== other.unit) return new DecimalCSS(NaN, "");
                return new DecimalCSS(this.num * other.num, this.unit || other.unit);
            }
        },
        {
            key: "divide",
            value: function divide(other) {
                if (this.unit !== "" && other.unit !== "" && this.unit !== other.unit) return new DecimalCSS(NaN, "");
                return new DecimalCSS(this.num / other.num, this.unit || other.unit);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.num).concat(this.unit);
            }
        },
        {
            key: "isNaN",
            value: function isNaN() {
                return Number.isNaN(this.num);
            }
        }
    ], [
        {
            key: "parse",
            value: function parse(str) {
                var _NUM_SPLIT_REGEX$exec;
                var _ref = (_NUM_SPLIT_REGEX$exec = $06fa38157780d3a2$var$NUM_SPLIT_REGEX.exec(str)) !== null && _NUM_SPLIT_REGEX$exec !== void 0 ? _NUM_SPLIT_REGEX$exec : [], _ref2 = $06fa38157780d3a2$var$_slicedToArray(_ref, 3), numStr = _ref2[1], unit = _ref2[2];
                return new DecimalCSS(parseFloat(numStr), unit !== null && unit !== void 0 ? unit : "");
            }
        }
    ]);
}();
function $06fa38157780d3a2$var$calculateArithmetic(expr) {
    if (expr.includes($06fa38157780d3a2$var$STR_NAN)) return $06fa38157780d3a2$var$STR_NAN;
    var newExpr = expr;
    while(newExpr.includes("*") || newExpr.includes("/")){
        var _MULTIPLY_OR_DIVIDE_R;
        var _ref3 = (_MULTIPLY_OR_DIVIDE_R = $06fa38157780d3a2$var$MULTIPLY_OR_DIVIDE_REGEX.exec(newExpr)) !== null && _MULTIPLY_OR_DIVIDE_R !== void 0 ? _MULTIPLY_OR_DIVIDE_R : [], _ref4 = $06fa38157780d3a2$var$_slicedToArray(_ref3, 4), leftOperand = _ref4[1], operator = _ref4[2], rightOperand = _ref4[3];
        var lTs = $06fa38157780d3a2$var$DecimalCSS.parse(leftOperand !== null && leftOperand !== void 0 ? leftOperand : "");
        var rTs = $06fa38157780d3a2$var$DecimalCSS.parse(rightOperand !== null && rightOperand !== void 0 ? rightOperand : "");
        var result = operator === "*" ? lTs.multiply(rTs) : lTs.divide(rTs);
        if (result.isNaN()) return $06fa38157780d3a2$var$STR_NAN;
        newExpr = newExpr.replace($06fa38157780d3a2$var$MULTIPLY_OR_DIVIDE_REGEX, result.toString());
    }
    while(newExpr.includes("+") || /.-\d+(?:\.\d+)?/.test(newExpr)){
        var _ADD_OR_SUBTRACT_REGE;
        var _ref5 = (_ADD_OR_SUBTRACT_REGE = $06fa38157780d3a2$var$ADD_OR_SUBTRACT_REGEX.exec(newExpr)) !== null && _ADD_OR_SUBTRACT_REGE !== void 0 ? _ADD_OR_SUBTRACT_REGE : [], _ref6 = $06fa38157780d3a2$var$_slicedToArray(_ref5, 4), _leftOperand = _ref6[1], _operator = _ref6[2], _rightOperand = _ref6[3];
        var _lTs = $06fa38157780d3a2$var$DecimalCSS.parse(_leftOperand !== null && _leftOperand !== void 0 ? _leftOperand : "");
        var _rTs = $06fa38157780d3a2$var$DecimalCSS.parse(_rightOperand !== null && _rightOperand !== void 0 ? _rightOperand : "");
        var _result = _operator === "+" ? _lTs.add(_rTs) : _lTs.subtract(_rTs);
        if (_result.isNaN()) return $06fa38157780d3a2$var$STR_NAN;
        newExpr = newExpr.replace($06fa38157780d3a2$var$ADD_OR_SUBTRACT_REGEX, _result.toString());
    }
    return newExpr;
}
var $06fa38157780d3a2$var$PARENTHESES_REGEX = /\(([^()]*)\)/;
function $06fa38157780d3a2$var$calculateParentheses(expr) {
    var newExpr = expr;
    while(newExpr.includes("(")){
        var _PARENTHESES_REGEX$ex = $06fa38157780d3a2$var$PARENTHESES_REGEX.exec(newExpr), _PARENTHESES_REGEX$ex2 = $06fa38157780d3a2$var$_slicedToArray(_PARENTHESES_REGEX$ex, 2), parentheticalExpression = _PARENTHESES_REGEX$ex2[1];
        newExpr = newExpr.replace($06fa38157780d3a2$var$PARENTHESES_REGEX, $06fa38157780d3a2$var$calculateArithmetic(parentheticalExpression));
    }
    return newExpr;
}
function $06fa38157780d3a2$var$evaluateExpression(expression) {
    var newExpr = expression.replace(/\s+/g, "");
    newExpr = $06fa38157780d3a2$var$calculateParentheses(newExpr);
    newExpr = $06fa38157780d3a2$var$calculateArithmetic(newExpr);
    return newExpr;
}
function $06fa38157780d3a2$export$c891f73c9c6d00c9(expression) {
    try {
        return $06fa38157780d3a2$var$evaluateExpression(expression);
    } catch (e) {
        /* istanbul ignore next */ return $06fa38157780d3a2$var$STR_NAN;
    }
}
function $06fa38157780d3a2$export$254eac204f89fd7d(expression) {
    var result = $06fa38157780d3a2$export$c891f73c9c6d00c9(expression.slice(5, -1));
    if (result === $06fa38157780d3a2$var$STR_NAN) // notify the user
    return "";
    return result;
}

});


parcelRegister("h7eoY", function(module, exports) {

$parcel$export(module.exports, "RADIAN", function () { return $c75e4309458cdbe1$export$d74e8f7e9cc3fed3; });
$parcel$export(module.exports, "polarToCartesian", function () { return $c75e4309458cdbe1$export$5c9a959bb3fc7749; });
$parcel$export(module.exports, "inRangeOfSector", function () { return $c75e4309458cdbe1$export$e85a2bf8cd31c504; });

var $aVX0M = parcelRequire("aVX0M");

var $jbmdS = parcelRequire("jbmdS");

var $i99FY = parcelRequire("i99FY");

var $1gmrG = parcelRequire("1gmrG");

var $fiDSf = parcelRequire("fiDSf");
function $c75e4309458cdbe1$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c75e4309458cdbe1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c75e4309458cdbe1$var$_typeof(o);
}
function $c75e4309458cdbe1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c75e4309458cdbe1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c75e4309458cdbe1$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c75e4309458cdbe1$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c75e4309458cdbe1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c75e4309458cdbe1$var$_defineProperty(obj, key, value) {
    key = $c75e4309458cdbe1$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c75e4309458cdbe1$var$_toPropertyKey(t) {
    var i = $c75e4309458cdbe1$var$_toPrimitive(t, "string");
    return "symbol" == $c75e4309458cdbe1$var$_typeof(i) ? i : i + "";
}
function $c75e4309458cdbe1$var$_toPrimitive(t, r) {
    if ("object" != $c75e4309458cdbe1$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $c75e4309458cdbe1$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $c75e4309458cdbe1$var$_slicedToArray(arr, i) {
    return $c75e4309458cdbe1$var$_arrayWithHoles(arr) || $c75e4309458cdbe1$var$_iterableToArrayLimit(arr, i) || $c75e4309458cdbe1$var$_unsupportedIterableToArray(arr, i) || $c75e4309458cdbe1$var$_nonIterableRest();
}
function $c75e4309458cdbe1$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c75e4309458cdbe1$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c75e4309458cdbe1$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c75e4309458cdbe1$var$_arrayLikeToArray(o, minLen);
}
function $c75e4309458cdbe1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c75e4309458cdbe1$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $c75e4309458cdbe1$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $c75e4309458cdbe1$export$d74e8f7e9cc3fed3 = Math.PI / 180;
var $c75e4309458cdbe1$export$4f2c4f194778dcbb = function degreeToRadian(angle) {
    return angle * Math.PI / 180;
};
var $c75e4309458cdbe1$export$1c20e104e3e29a0a = function radianToDegree(angleInRadian) {
    return angleInRadian * 180 / Math.PI;
};
var $c75e4309458cdbe1$export$5c9a959bb3fc7749 = function polarToCartesian(cx, cy, radius, angle) {
    return {
        x: cx + Math.cos(-$c75e4309458cdbe1$export$d74e8f7e9cc3fed3 * angle) * radius,
        y: cy + Math.sin(-$c75e4309458cdbe1$export$d74e8f7e9cc3fed3 * angle) * radius
    };
};
var $c75e4309458cdbe1$export$ad5c48602371adfa = function getMaxRadius(width, height) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
    return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
};
var $c75e4309458cdbe1$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height;
    var startAngle = props.startAngle, endAngle = props.endAngle;
    var cx = (0, $1gmrG.getPercentValue)(props.cx, width, width / 2);
    var cy = (0, $1gmrG.getPercentValue)(props.cy, height, height / 2);
    var maxRadius = $c75e4309458cdbe1$export$ad5c48602371adfa(width, height, offset);
    var innerRadius = (0, $1gmrG.getPercentValue)(props.innerRadius, maxRadius, 0);
    var outerRadius = (0, $1gmrG.getPercentValue)(props.outerRadius, maxRadius, maxRadius * 0.8);
    var ids = Object.keys(axisMap);
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var domain = axis.domain, reversed = axis.reversed;
        var range;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($aVX0M)))(axis.range)) {
            if (axisType === "angleAxis") range = [
                startAngle,
                endAngle
            ];
            else if (axisType === "radiusAxis") range = [
                innerRadius,
                outerRadius
            ];
            if (reversed) range = [
                range[1],
                range[0]
            ];
        } else {
            range = axis.range;
            var _range = range;
            var _range2 = $c75e4309458cdbe1$var$_slicedToArray(_range, 2);
            startAngle = _range2[0];
            endAngle = _range2[1];
        }
        var _parseScale = (0, $fiDSf.parseScale)(axis, chartName), realScaleType = _parseScale.realScaleType, scale = _parseScale.scale;
        scale.domain(domain).range(range);
        (0, $fiDSf.checkDomainOfScale)(scale);
        var ticks = (0, $fiDSf.getTicksOfScale)(scale, $c75e4309458cdbe1$var$_objectSpread($c75e4309458cdbe1$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        var finalAxis = $c75e4309458cdbe1$var$_objectSpread($c75e4309458cdbe1$var$_objectSpread($c75e4309458cdbe1$var$_objectSpread({}, axis), ticks), {}, {
            range: range,
            radius: outerRadius,
            realScaleType: realScaleType,
            scale: scale,
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
        return $c75e4309458cdbe1$var$_objectSpread($c75e4309458cdbe1$var$_objectSpread({}, result), {}, $c75e4309458cdbe1$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $c75e4309458cdbe1$export$b59117efbc9c7af = function distanceBetweenPoints(point, anotherPoint) {
    var x1 = point.x, y1 = point.y;
    var x2 = anotherPoint.x, y2 = anotherPoint.y;
    return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
};
var $c75e4309458cdbe1$export$bc42f851bd05a2ae = function getAngleOfPoint(_ref, _ref2) {
    var x = _ref.x, y = _ref.y;
    var cx = _ref2.cx, cy = _ref2.cy;
    var radius = $c75e4309458cdbe1$export$b59117efbc9c7af({
        x: x,
        y: y
    }, {
        x: cx,
        y: cy
    });
    if (radius <= 0) return {
        radius: radius
    };
    var cos = (x - cx) / radius;
    var angleInRadian = Math.acos(cos);
    if (y > cy) angleInRadian = 2 * Math.PI - angleInRadian;
    return {
        radius: radius,
        angle: $c75e4309458cdbe1$export$1c20e104e3e29a0a(angleInRadian),
        angleInRadian: angleInRadian
    };
};
var $c75e4309458cdbe1$export$c8ca70209d427b81 = function formatAngleOfSector(_ref3) {
    var startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return {
        startAngle: startAngle - min * 360,
        endAngle: endAngle - min * 360
    };
};
var $c75e4309458cdbe1$var$reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor(angle, _ref4) {
    var startAngle = _ref4.startAngle, endAngle = _ref4.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return angle + min * 360;
};
var $c75e4309458cdbe1$export$e85a2bf8cd31c504 = function inRangeOfSector(_ref5, sector) {
    var x = _ref5.x, y = _ref5.y;
    var _getAngleOfPoint = $c75e4309458cdbe1$export$bc42f851bd05a2ae({
        x: x,
        y: y
    }, sector), radius = _getAngleOfPoint.radius, angle = _getAngleOfPoint.angle;
    var innerRadius = sector.innerRadius, outerRadius = sector.outerRadius;
    if (radius < innerRadius || radius > outerRadius) return false;
    if (radius === 0) return true;
    var _formatAngleOfSector = $c75e4309458cdbe1$export$c8ca70209d427b81(sector), startAngle = _formatAngleOfSector.startAngle, endAngle = _formatAngleOfSector.endAngle;
    var formatAngle = angle;
    var inRange;
    if (startAngle <= endAngle) {
        while(formatAngle > endAngle)formatAngle -= 360;
        while(formatAngle < startAngle)formatAngle += 360;
        inRange = formatAngle >= startAngle && formatAngle <= endAngle;
    } else {
        while(formatAngle > startAngle)formatAngle -= 360;
        while(formatAngle < endAngle)formatAngle += 360;
        inRange = formatAngle >= endAngle && formatAngle <= startAngle;
    }
    if (inRange) return $c75e4309458cdbe1$var$_objectSpread($c75e4309458cdbe1$var$_objectSpread({}, sector), {}, {
        radius: radius,
        angle: $c75e4309458cdbe1$var$reverseFormatAngleOfSetor(formatAngle, sector)
    });
    return null;
};
var $c75e4309458cdbe1$export$88d525dabc04abcd = function getTickClassName(tick) {
    return !/*#__PURE__*/ (0, $jbmdS.isValidElement)(tick) && !(0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(tick) && typeof tick !== "boolean" ? tick.className : "";
};

});
parcelRegister("fiDSf", function(module, exports) {

$parcel$export(module.exports, "getValueByDataKey", function () { return $b237779b1a44002c$export$f97fc4a450f29a; });
$parcel$export(module.exports, "getDomainOfDataByKey", function () { return $b237779b1a44002c$export$6a1e7873444c95a7; });
$parcel$export(module.exports, "calculateActiveTickIndex", function () { return $b237779b1a44002c$export$3071d39cc844078e; });
$parcel$export(module.exports, "getMainColorOfGraphicItem", function () { return $b237779b1a44002c$export$ec6cab5a7a3b93bf; });
$parcel$export(module.exports, "getBarSizeList", function () { return $b237779b1a44002c$export$570d306bee26c748; });
$parcel$export(module.exports, "getBarPosition", function () { return $b237779b1a44002c$export$d36834ecd87f906b; });
$parcel$export(module.exports, "appendOffsetOfLegend", function () { return $b237779b1a44002c$export$3a657a8c9f789617; });
$parcel$export(module.exports, "parseErrorBarsOfAxis", function () { return $b237779b1a44002c$export$2266342e22c737e8; });
$parcel$export(module.exports, "getDomainOfItemsWithSameAxis", function () { return $b237779b1a44002c$export$c92c4f4286b1390d; });
$parcel$export(module.exports, "isCategoricalAxis", function () { return $b237779b1a44002c$export$9fc1baaa6c6368b; });
$parcel$export(module.exports, "getCoordinatesOfGrid", function () { return $b237779b1a44002c$export$846dc5ac5fecff74; });
$parcel$export(module.exports, "getTicksOfAxis", function () { return $b237779b1a44002c$export$c829ee42daf7f66d; });
$parcel$export(module.exports, "combineEventHandlers", function () { return $b237779b1a44002c$export$760ec406ba47bace; });
$parcel$export(module.exports, "parseScale", function () { return $b237779b1a44002c$export$534b094a708572c1; });
$parcel$export(module.exports, "checkDomainOfScale", function () { return $b237779b1a44002c$export$9d80152e23bae434; });
$parcel$export(module.exports, "findPositionOfBar", function () { return $b237779b1a44002c$export$778e70011fdf4625; });
$parcel$export(module.exports, "truncateByDomain", function () { return $b237779b1a44002c$export$c7ec0fa96d0c462e; });
$parcel$export(module.exports, "getStackGroupsByAxisId", function () { return $b237779b1a44002c$export$9af3ba56474b9601; });
$parcel$export(module.exports, "getTicksOfScale", function () { return $b237779b1a44002c$export$ac086aaa4358d590; });
$parcel$export(module.exports, "getCateCoordinateOfLine", function () { return $b237779b1a44002c$export$6e87f3defb83c3f; });
$parcel$export(module.exports, "getCateCoordinateOfBar", function () { return $b237779b1a44002c$export$8abb9e87422f3a0c; });
$parcel$export(module.exports, "getBaseValueOfBar", function () { return $b237779b1a44002c$export$54f3200dd4a8a235; });
$parcel$export(module.exports, "getStackedDataOfItem", function () { return $b237779b1a44002c$export$a17bf3d98457878c; });
$parcel$export(module.exports, "getDomainOfStackGroups", function () { return $b237779b1a44002c$export$26522b779eb5497c; });
$parcel$export(module.exports, "parseSpecifiedDomain", function () { return $b237779b1a44002c$export$a0bc8660980558a0; });
$parcel$export(module.exports, "getBandSizeOfAxis", function () { return $b237779b1a44002c$export$212ec45c42fe68a7; });
$parcel$export(module.exports, "parseDomainOfCategoryAxis", function () { return $b237779b1a44002c$export$c9a5230f0dda41bf; });
$parcel$export(module.exports, "getTooltipItem", function () { return $b237779b1a44002c$export$a4ea3faa19bc2d90; });
$parcel$export(module.exports, "getLegendProps", function () { return (parcelRequire("jTbSW")).getLegendProps; });

var $b0sdz = parcelRequire("b0sdz");

var $hNS9W = parcelRequire("hNS9W");

var $9HZtv = parcelRequire("9HZtv");

var $2vCNF = parcelRequire("2vCNF");

var $aVX0M = parcelRequire("aVX0M");

var $i99FY = parcelRequire("i99FY");

var $aVvo3 = parcelRequire("aVvo3");

var $lNQsK = parcelRequire("lNQsK");

var $cCcFB = parcelRequire("cCcFB");

var $BWzdJ = parcelRequire("BWzdJ");

var $lKqbf = parcelRequire("lKqbf");

var $dzN0r = parcelRequire("dzN0r");

var $lfx6l = parcelRequire("lfx6l");
parcelRequire("9o1s2");
var $1TRCo = parcelRequire("1TRCo");

var $3Efgj = parcelRequire("3Efgj");

var $1gmrG = parcelRequire("1gmrG");

var $f06D9 = parcelRequire("f06D9");

var $jTbSW = parcelRequire("jTbSW");
function $b237779b1a44002c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b237779b1a44002c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b237779b1a44002c$var$_typeof(o);
}
function $b237779b1a44002c$var$_toConsumableArray(arr) {
    return $b237779b1a44002c$var$_arrayWithoutHoles(arr) || $b237779b1a44002c$var$_iterableToArray(arr) || $b237779b1a44002c$var$_unsupportedIterableToArray(arr) || $b237779b1a44002c$var$_nonIterableSpread();
}
function $b237779b1a44002c$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b237779b1a44002c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b237779b1a44002c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b237779b1a44002c$var$_arrayLikeToArray(o, minLen);
}
function $b237779b1a44002c$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $b237779b1a44002c$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $b237779b1a44002c$var$_arrayLikeToArray(arr);
}
function $b237779b1a44002c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b237779b1a44002c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b237779b1a44002c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b237779b1a44002c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b237779b1a44002c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b237779b1a44002c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b237779b1a44002c$var$_defineProperty(obj, key, value) {
    key = $b237779b1a44002c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b237779b1a44002c$var$_toPropertyKey(t) {
    var i = $b237779b1a44002c$var$_toPrimitive(t, "string");
    return "symbol" == $b237779b1a44002c$var$_typeof(i) ? i : i + "";
}
function $b237779b1a44002c$var$_toPrimitive(t, r) {
    if ("object" != $b237779b1a44002c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b237779b1a44002c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $b237779b1a44002c$export$f97fc4a450f29a(obj, dataKey, defaultValue) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($aVX0M)))(obj) || (0, (/*@__PURE__*/$parcel$interopDefault($aVX0M)))(dataKey)) return defaultValue;
    if ((0, $1gmrG.isNumOrStr)(dataKey)) return (0, (/*@__PURE__*/$parcel$interopDefault($lNQsK)))(obj, dataKey, defaultValue);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(dataKey)) return dataKey(obj);
    return defaultValue;
}
function $b237779b1a44002c$export$6a1e7873444c95a7(data, key, type, filterNil) {
    var flattenData = (0, (/*@__PURE__*/$parcel$interopDefault($cCcFB)))(data, function(entry) {
        return $b237779b1a44002c$export$f97fc4a450f29a(entry, key);
    });
    if (type === "number") {
        // @ts-expect-error parseFloat type only accepts strings
        var domain = flattenData.filter(function(entry) {
            return (0, $1gmrG.isNumber)(entry) || parseFloat(entry);
        });
        return domain.length ? [
            (0, (/*@__PURE__*/$parcel$interopDefault($2vCNF)))(domain),
            (0, (/*@__PURE__*/$parcel$interopDefault($9HZtv)))(domain)
        ] : [
            Infinity,
            -Infinity
        ];
    }
    var validateData = filterNil ? flattenData.filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($aVX0M)))(entry);
    }) : flattenData;
    // Supports x-axis of Date type
    return validateData.map(function(entry) {
        return (0, $1gmrG.isNumOrStr)(entry) || entry instanceof Date ? entry : "";
    });
}
var $b237779b1a44002c$export$3071d39cc844078e = function calculateActiveTickIndex(coordinate) {
    var _ticks$length;
    var ticks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var unsortedTicks = arguments.length > 2 ? arguments[2] : undefined;
    var axis = arguments.length > 3 ? arguments[3] : undefined;
    var index = -1;
    var len = (_ticks$length = ticks === null || ticks === void 0 ? void 0 : ticks.length) !== null && _ticks$length !== void 0 ? _ticks$length : 0;
    // if there are 1 or less ticks ticks then the active tick is at index 0
    if (len <= 1) return 0;
    if (axis && axis.axisType === "angleAxis" && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
        var range = axis.range;
        // ticks are distributed in a circle
        for(var i = 0; i < len; i++){
            var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
            var cur = unsortedTicks[i].coordinate;
            var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
            var sameDirectionCoord = void 0;
            if ((0, $1gmrG.mathSign)(cur - before) !== (0, $1gmrG.mathSign)(after - cur)) {
                var diffInterval = [];
                if ((0, $1gmrG.mathSign)(after - cur) === (0, $1gmrG.mathSign)(range[1] - range[0])) {
                    sameDirectionCoord = after;
                    var curInRange = cur + range[1] - range[0];
                    diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
                    diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
                } else {
                    sameDirectionCoord = before;
                    var afterInRange = after + range[1] - range[0];
                    diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
                    diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
                }
                var sameInterval = [
                    Math.min(cur, (sameDirectionCoord + cur) / 2),
                    Math.max(cur, (sameDirectionCoord + cur) / 2)
                ];
                if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
                    index = unsortedTicks[i].index;
                    break;
                }
            } else {
                var minValue = Math.min(before, after);
                var maxValue = Math.max(before, after);
                if (coordinate > (minValue + cur) / 2 && coordinate <= (maxValue + cur) / 2) {
                    index = unsortedTicks[i].index;
                    break;
                }
            }
        }
    } else {
        // ticks are distributed in a single direction
        for(var _i = 0; _i < len; _i++)if (_i === 0 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2) {
            index = ticks[_i].index;
            break;
        }
    }
    return index;
};
var $b237779b1a44002c$export$ec6cab5a7a3b93bf = function getMainColorOfGraphicItem(item) {
    var _item$type;
    var _ref = item, displayName = _ref.type.displayName; // TODO: check if displayName is valid.
    var defaultedProps = (_item$type = item.type) !== null && _item$type !== void 0 && _item$type.defaultProps ? $b237779b1a44002c$var$_objectSpread($b237779b1a44002c$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
    var stroke = defaultedProps.stroke, fill = defaultedProps.fill;
    var result;
    switch(displayName){
        case "Line":
            result = stroke;
            break;
        case "Area":
        case "Radar":
            result = stroke && stroke !== "none" ? stroke : fill;
            break;
        default:
            result = fill;
            break;
    }
    return result;
};
var $b237779b1a44002c$export$570d306bee26c748 = function getBarSizeList(_ref2) {
    var globalSize = _ref2.barSize, totalSize = _ref2.totalSize, _ref2$stackGroups = _ref2.stackGroups, stackGroups = _ref2$stackGroups === void 0 ? {} : _ref2$stackGroups;
    if (!stackGroups) return {};
    var result = {};
    var numericAxisIds = Object.keys(stackGroups);
    for(var i = 0, len = numericAxisIds.length; i < len; i++){
        var sgs = stackGroups[numericAxisIds[i]].stackGroups;
        var stackIds = Object.keys(sgs);
        for(var j = 0, sLen = stackIds.length; j < sLen; j++){
            var _sgs$stackIds$j = sgs[stackIds[j]], items = _sgs$stackIds$j.items, cateAxisId = _sgs$stackIds$j.cateAxisId;
            var barItems = items.filter(function(item) {
                return (0, $f06D9.getDisplayName)(item.type).indexOf("Bar") >= 0;
            });
            if (barItems && barItems.length) {
                var barItemDefaultProps = barItems[0].type.defaultProps;
                var barItemProps = barItemDefaultProps !== undefined ? $b237779b1a44002c$var$_objectSpread($b237779b1a44002c$var$_objectSpread({}, barItemDefaultProps), barItems[0].props) : barItems[0].props;
                var selfSize = barItemProps.barSize;
                var cateId = barItemProps[cateAxisId];
                if (!result[cateId]) result[cateId] = [];
                var barSize = (0, (/*@__PURE__*/$parcel$interopDefault($aVX0M)))(selfSize) ? globalSize : selfSize;
                result[cateId].push({
                    item: barItems[0],
                    stackList: barItems.slice(1),
                    barSize: (0, (/*@__PURE__*/$parcel$interopDefault($aVX0M)))(barSize) ? undefined : (0, $1gmrG.getPercentValue)(barSize, totalSize, 0)
                });
            }
        }
    }
    return result;
};
var $b237779b1a44002c$export$d36834ecd87f906b = function getBarPosition(_ref3) {
    var barGap = _ref3.barGap, barCategoryGap = _ref3.barCategoryGap, bandSize = _ref3.bandSize, _ref3$sizeList = _ref3.sizeList, sizeList = _ref3$sizeList === void 0 ? [] : _ref3$sizeList, maxBarSize = _ref3.maxBarSize;
    var len = sizeList.length;
    if (len < 1) return null;
    var realBarGap = (0, $1gmrG.getPercentValue)(barGap, bandSize, 0, true);
    var result;
    var initialValue = [];
    // whether or not is barSize setted by user
    if (sizeList[0].barSize === +sizeList[0].barSize) {
        var useFull = false;
        var fullBarSize = bandSize / len;
        // @ts-expect-error the type check above does not check for type number explicitly
        var sum = sizeList.reduce(function(res, entry) {
            return res + entry.barSize || 0;
        }, 0);
        sum += (len - 1) * realBarGap;
        if (sum >= bandSize) {
            sum -= (len - 1) * realBarGap;
            realBarGap = 0;
        }
        if (sum >= bandSize && fullBarSize > 0) {
            useFull = true;
            fullBarSize *= 0.9;
            sum = len * fullBarSize;
        }
        var offset = (bandSize - sum) / 2 >> 0;
        var prev = {
            offset: offset - realBarGap,
            size: 0
        };
        result = sizeList.reduce(function(res, entry) {
            var newPosition = {
                item: entry.item,
                position: {
                    offset: prev.offset + prev.size + realBarGap,
                    // @ts-expect-error the type check above does not check for type number explicitly
                    size: useFull ? fullBarSize : entry.barSize
                }
            };
            var newRes = [].concat($b237779b1a44002c$var$_toConsumableArray(res), [
                newPosition
            ]);
            prev = newRes[newRes.length - 1].position;
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: prev
                });
            });
            return newRes;
        }, initialValue);
    } else {
        var _offset = (0, $1gmrG.getPercentValue)(barCategoryGap, bandSize, 0, true);
        if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) realBarGap = 0;
        var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
        if (originalSize > 1) originalSize >>= 0;
        var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
        result = sizeList.reduce(function(res, entry, i) {
            var newRes = [].concat($b237779b1a44002c$var$_toConsumableArray(res), [
                {
                    item: entry.item,
                    position: {
                        offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
                        size: size
                    }
                }
            ]);
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: newRes[newRes.length - 1].position
                });
            });
            return newRes;
        }, initialValue);
    }
    return result;
};
var $b237779b1a44002c$export$3a657a8c9f789617 = function appendOffsetOfLegend(offset, _unused, props, legendBox) {
    var children = props.children, width = props.width, margin = props.margin;
    var legendWidth = width - (margin.left || 0) - (margin.right || 0);
    var legendProps = (0, $jTbSW.getLegendProps)({
        children: children,
        legendWidth: legendWidth
    });
    if (legendProps) {
        var _ref4 = legendBox || {}, boxWidth = _ref4.width, boxHeight = _ref4.height;
        var align = legendProps.align, verticalAlign = legendProps.verticalAlign, layout = legendProps.layout;
        if ((layout === "vertical" || layout === "horizontal" && verticalAlign === "middle") && align !== "center" && (0, $1gmrG.isNumber)(offset[align])) return $b237779b1a44002c$var$_objectSpread($b237779b1a44002c$var$_objectSpread({}, offset), {}, $b237779b1a44002c$var$_defineProperty({}, align, offset[align] + (boxWidth || 0)));
        if ((layout === "horizontal" || layout === "vertical" && align === "center") && verticalAlign !== "middle" && (0, $1gmrG.isNumber)(offset[verticalAlign])) return $b237779b1a44002c$var$_objectSpread($b237779b1a44002c$var$_objectSpread({}, offset), {}, $b237779b1a44002c$var$_defineProperty({}, verticalAlign, offset[verticalAlign] + (boxHeight || 0)));
    }
    return offset;
};
var $b237779b1a44002c$var$isErrorBarRelevantForAxis = function isErrorBarRelevantForAxis(layout, axisType, direction) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($aVX0M)))(axisType)) return true;
    if (layout === "horizontal") return axisType === "yAxis";
    if (layout === "vertical") return axisType === "xAxis";
    if (direction === "x") return axisType === "xAxis";
    if (direction === "y") return axisType === "yAxis";
    return true;
};
var $b237779b1a44002c$export$8a46d1a2b0f8e61a = function getDomainOfErrorBars(data, item, dataKey, layout, axisType) {
    var children = item.props.children;
    var errorBars = (0, $f06D9.findAllByType)(children, (0, $3Efgj.ErrorBar)).filter(function(errorBarChild) {
        return $b237779b1a44002c$var$isErrorBarRelevantForAxis(layout, axisType, errorBarChild.props.direction);
    });
    if (errorBars && errorBars.length) {
        var keys = errorBars.map(function(errorBarChild) {
            return errorBarChild.props.dataKey;
        });
        return data.reduce(function(result, entry) {
            var entryValue = $b237779b1a44002c$export$f97fc4a450f29a(entry, dataKey);
            if ((0, (/*@__PURE__*/$parcel$interopDefault($aVX0M)))(entryValue)) return result;
            var mainValue = Array.isArray(entryValue) ? [
                (0, (/*@__PURE__*/$parcel$interopDefault($2vCNF)))(entryValue),
                (0, (/*@__PURE__*/$parcel$interopDefault($9HZtv)))(entryValue)
            ] : [
                entryValue,
                entryValue
            ];
            var errorDomain = keys.reduce(function(prevErrorArr, k) {
                var errorValue = $b237779b1a44002c$export$f97fc4a450f29a(entry, k, 0);
                var lowerValue = mainValue[0] - Math.abs(Array.isArray(errorValue) ? errorValue[0] : errorValue);
                var upperValue = mainValue[1] + Math.abs(Array.isArray(errorValue) ? errorValue[1] : errorValue);
                return [
                    Math.min(lowerValue, prevErrorArr[0]),
                    Math.max(upperValue, prevErrorArr[1])
                ];
            }, [
                Infinity,
                -Infinity
            ]);
            return [
                Math.min(errorDomain[0], result[0]),
                Math.max(errorDomain[1], result[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
    }
    return null;
};
var $b237779b1a44002c$export$2266342e22c737e8 = function parseErrorBarsOfAxis(data, items, dataKey, axisType, layout) {
    var domains = items.map(function(item) {
        return $b237779b1a44002c$export$8a46d1a2b0f8e61a(data, item, dataKey, layout, axisType);
    }).filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($aVX0M)))(entry);
    });
    if (domains && domains.length) return domains.reduce(function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    return null;
};
var $b237779b1a44002c$export$c92c4f4286b1390d = function getDomainOfItemsWithSameAxis(data, items, type, layout, filterNil) {
    var domains = items.map(function(item) {
        var dataKey = item.props.dataKey;
        if (type === "number" && dataKey) return $b237779b1a44002c$export$8a46d1a2b0f8e61a(data, item, dataKey, layout) || $b237779b1a44002c$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
        return $b237779b1a44002c$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
    });
    if (type === "number") // Calculate the domain of number axis
    return domains.reduce(// @ts-expect-error if (type === number) means that the domain is numerical type
    // - but this link is missing in the type definition
    function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    var tag = {};
    // Get the union set of category axis
    return domains.reduce(function(result, entry) {
        for(var i = 0, len = entry.length; i < len; i++)// @ts-expect-error Date cannot index an object
        if (!tag[entry[i]]) {
            // @ts-expect-error Date cannot index an object
            tag[entry[i]] = true;
            // @ts-expect-error Date cannot index an object
            result.push(entry[i]);
        }
        return result;
    }, []);
};
var $b237779b1a44002c$export$9fc1baaa6c6368b = function isCategoricalAxis(layout, axisType) {
    return layout === "horizontal" && axisType === "xAxis" || layout === "vertical" && axisType === "yAxis" || layout === "centric" && axisType === "angleAxis" || layout === "radial" && axisType === "radiusAxis";
};
var $b237779b1a44002c$export$846dc5ac5fecff74 = function getCoordinatesOfGrid(ticks, minValue, maxValue, syncWithTicks) {
    if (syncWithTicks) return ticks.map(function(entry) {
        return entry.coordinate;
    });
    var hasMin, hasMax;
    var values = ticks.map(function(entry) {
        if (entry.coordinate === minValue) hasMin = true;
        if (entry.coordinate === maxValue) hasMax = true;
        return entry.coordinate;
    });
    if (!hasMin) values.push(minValue);
    if (!hasMax) values.push(maxValue);
    return values;
};
var $b237779b1a44002c$export$c829ee42daf7f66d = function getTicksOfAxis(axis, isGrid, isAll) {
    if (!axis) return null;
    var scale = axis.scale;
    var duplicateDomain = axis.duplicateDomain, type = axis.type, range = axis.range;
    var offsetForBand = axis.realScaleType === "scaleBand" ? scale.bandwidth() / 2 : 2;
    var offset = (isGrid || isAll) && type === "category" && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axis.axisType === "angleAxis" && (range === null || range === void 0 ? void 0 : range.length) >= 2 ? (0, $1gmrG.mathSign)(range[0] - range[1]) * 2 * offset : offset;
    // The ticks set by user should only affect the ticks adjacent to axis line
    if (isGrid && (axis.ticks || axis.niceTicks)) {
        var result = (axis.ticks || axis.niceTicks).map(function(entry) {
            var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
            return {
                // If the scaleContent is not a number, the coordinate will be NaN.
                // That could be the case for example with a PointScale and a string as domain.
                coordinate: scale(scaleContent) + offset,
                value: entry,
                offset: offset
            };
        });
        return result.filter(function(row) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($BWzdJ)))(row.coordinate);
        });
    }
    // When axis is a categorial axis, but the type of axis is number or the scale of axis is not "auto"
    if (axis.isCategorical && axis.categoricalDomain) return axis.categoricalDomain.map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            index: index,
            offset: offset
        };
    });
    if (scale.ticks && !isAll) return scale.ticks(axis.tickCount).map(function(entry) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            offset: offset
        };
    });
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        };
    });
};
/**
 * combine the handlers
 * @param  {Function} defaultHandler Internal private handler
 * @param  {Function} childHandler Handler function specified in child component
 * @return {Function}                The combined handler
 */ var $b237779b1a44002c$var$handlerWeakMap = new WeakMap();
var $b237779b1a44002c$export$760ec406ba47bace = function combineEventHandlers(defaultHandler, childHandler) {
    if (typeof childHandler !== "function") return defaultHandler;
    if (!$b237779b1a44002c$var$handlerWeakMap.has(defaultHandler)) $b237779b1a44002c$var$handlerWeakMap.set(defaultHandler, new WeakMap());
    var childWeakMap = $b237779b1a44002c$var$handlerWeakMap.get(defaultHandler);
    if (childWeakMap.has(childHandler)) return childWeakMap.get(childHandler);
    var combineHandler = function combineHandler() {
        defaultHandler.apply(void 0, arguments);
        childHandler.apply(void 0, arguments);
    };
    childWeakMap.set(childHandler, combineHandler);
    return combineHandler;
};
var $b237779b1a44002c$export$534b094a708572c1 = function parseScale(axis, chartType, hasBar) {
    var scale = axis.scale, type = axis.type, layout = axis.layout, axisType = axis.axisType;
    if (scale === "auto") {
        if (layout === "radial" && axisType === "radiusAxis") return {
            scale: $b0sdz.scaleBand(),
            realScaleType: "band"
        };
        if (layout === "radial" && axisType === "angleAxis") return {
            scale: $b0sdz.scaleLinear(),
            realScaleType: "linear"
        };
        if (type === "category" && chartType && (chartType.indexOf("LineChart") >= 0 || chartType.indexOf("AreaChart") >= 0 || chartType.indexOf("ComposedChart") >= 0 && !hasBar)) return {
            scale: $b0sdz.scalePoint(),
            realScaleType: "point"
        };
        if (type === "category") return {
            scale: $b0sdz.scaleBand(),
            realScaleType: "band"
        };
        return {
            scale: $b0sdz.scaleLinear(),
            realScaleType: "linear"
        };
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($aVvo3)))(scale)) {
        var name = "scale".concat((0, (/*@__PURE__*/$parcel$interopDefault($lKqbf)))(scale));
        return {
            scale: ($b0sdz[name] || $b0sdz.scalePoint)(),
            realScaleType: $b0sdz[name] ? name : "point"
        };
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(scale) ? {
        scale: scale
    } : {
        scale: $b0sdz.scalePoint(),
        realScaleType: "point"
    };
};
var $b237779b1a44002c$var$EPS = 1e-4;
var $b237779b1a44002c$export$9d80152e23bae434 = function checkDomainOfScale(scale) {
    var domain = scale.domain();
    if (!domain || domain.length <= 2) return;
    var len = domain.length;
    var range = scale.range();
    var minValue = Math.min(range[0], range[1]) - $b237779b1a44002c$var$EPS;
    var maxValue = Math.max(range[0], range[1]) + $b237779b1a44002c$var$EPS;
    var first = scale(domain[0]);
    var last = scale(domain[len - 1]);
    if (first < minValue || first > maxValue || last < minValue || last > maxValue) scale.domain([
        domain[0],
        domain[len - 1]
    ]);
};
var $b237779b1a44002c$export$778e70011fdf4625 = function findPositionOfBar(barPosition, child) {
    if (!barPosition) return null;
    for(var i = 0, len = barPosition.length; i < len; i++){
        if (barPosition[i].item === child) return barPosition[i].position;
    }
    return null;
};
var $b237779b1a44002c$export$c7ec0fa96d0c462e = function truncateByDomain(value, domain) {
    if (!domain || domain.length !== 2 || !(0, $1gmrG.isNumber)(domain[0]) || !(0, $1gmrG.isNumber)(domain[1])) return value;
    var minValue = Math.min(domain[0], domain[1]);
    var maxValue = Math.max(domain[0], domain[1]);
    var result = [
        value[0],
        value[1]
    ];
    if (!(0, $1gmrG.isNumber)(value[0]) || value[0] < minValue) result[0] = minValue;
    if (!(0, $1gmrG.isNumber)(value[1]) || value[1] > maxValue) result[1] = maxValue;
    if (result[0] > maxValue) result[0] = maxValue;
    if (result[1] < minValue) result[1] = minValue;
    return result;
};
var $b237779b1a44002c$export$3104c513558164c1 = function offsetSign(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        var negative = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($BWzdJ)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = negative;
                series[i][j][1] = negative + value;
                negative = series[i][j][1];
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
var $b237779b1a44002c$export$9f2c6ead70935022 = function offsetPositive(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($BWzdJ)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = 0;
                series[i][j][1] = 0;
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
/**
 * Function type to compute offset for stacked data.
 *
 * d3-shape has something fishy going on with its types.
 * In @definitelytyped/d3-shape, this function (the offset accessor) is typed as Series<> => void.
 * However! When I actually open the storybook I can see that the offset accessor actually receives Array<Series<>>.
 * The same I can see in the source code itself:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 * That one unfortunately has no types but we can tell it passes three-dimensional array.
 *
 * Which leads me to believe that definitelytyped is wrong on this one.
 * There's open discussion on this topic without much attention:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 */ var $b237779b1a44002c$var$STACK_OFFSET_MAP = {
    sign: $b237779b1a44002c$export$3104c513558164c1,
    // @ts-expect-error definitelytyped types are incorrect
    expand: (0, $hNS9W.stackOffsetExpand),
    // @ts-expect-error definitelytyped types are incorrect
    none: (0, $hNS9W.stackOffsetNone),
    // @ts-expect-error definitelytyped types are incorrect
    silhouette: (0, $hNS9W.stackOffsetSilhouette),
    // @ts-expect-error definitelytyped types are incorrect
    wiggle: (0, $hNS9W.stackOffsetWiggle),
    positive: $b237779b1a44002c$export$9f2c6ead70935022
};
var $b237779b1a44002c$export$c2170542cfc0177c = function getStackedData(data, stackItems, offsetType) {
    var dataKeys = stackItems.map(function(item) {
        return item.props.dataKey;
    });
    var offsetAccessor = $b237779b1a44002c$var$STACK_OFFSET_MAP[offsetType];
    var stack = (0, $hNS9W.stack)()// @ts-expect-error stack.keys type wants an array of strings, but we provide array of DataKeys
    .keys(dataKeys).value(function(d, key) {
        return +$b237779b1a44002c$export$f97fc4a450f29a(d, key, 0);
    }).order((0, $hNS9W.stackOrderNone))// @ts-expect-error definitelytyped types are incorrect
    .offset(offsetAccessor);
    return stack(data);
};
var $b237779b1a44002c$export$9af3ba56474b9601 = function getStackGroupsByAxisId(data, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
    if (!data) return null;
    // reversing items to affect render order (for layering)
    var items = reverseStackOrder ? _items.reverse() : _items;
    var parentStackGroupsInitialValue = {};
    var stackGroups = items.reduce(function(result, item) {
        var _item$type2;
        var defaultedProps = (_item$type2 = item.type) !== null && _item$type2 !== void 0 && _item$type2.defaultProps ? $b237779b1a44002c$var$_objectSpread($b237779b1a44002c$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
        var stackId = defaultedProps.stackId, hide = defaultedProps.hide;
        if (hide) return result;
        var axisId = defaultedProps[numericAxisId];
        var parentGroup = result[axisId] || {
            hasStack: false,
            stackGroups: {}
        };
        if ((0, $1gmrG.isNumOrStr)(stackId)) {
            var childGroup = parentGroup.stackGroups[stackId] || {
                numericAxisId: numericAxisId,
                cateAxisId: cateAxisId,
                items: []
            };
            childGroup.items.push(item);
            parentGroup.hasStack = true;
            parentGroup.stackGroups[stackId] = childGroup;
        } else parentGroup.stackGroups[(0, $1gmrG.uniqueId)("_stackId_")] = {
            numericAxisId: numericAxisId,
            cateAxisId: cateAxisId,
            items: [
                item
            ]
        };
        return $b237779b1a44002c$var$_objectSpread($b237779b1a44002c$var$_objectSpread({}, result), {}, $b237779b1a44002c$var$_defineProperty({}, axisId, parentGroup));
    }, parentStackGroupsInitialValue);
    var axisStackGroupsInitialValue = {};
    return Object.keys(stackGroups).reduce(function(result, axisId) {
        var group = stackGroups[axisId];
        if (group.hasStack) {
            var stackGroupsInitialValue = {};
            group.stackGroups = Object.keys(group.stackGroups).reduce(function(res, stackId) {
                var g = group.stackGroups[stackId];
                return $b237779b1a44002c$var$_objectSpread($b237779b1a44002c$var$_objectSpread({}, res), {}, $b237779b1a44002c$var$_defineProperty({}, stackId, {
                    numericAxisId: numericAxisId,
                    cateAxisId: cateAxisId,
                    items: g.items,
                    stackedData: $b237779b1a44002c$export$c2170542cfc0177c(data, g.items, offsetType)
                }));
            }, stackGroupsInitialValue);
        }
        return $b237779b1a44002c$var$_objectSpread($b237779b1a44002c$var$_objectSpread({}, result), {}, $b237779b1a44002c$var$_defineProperty({}, axisId, group));
    }, axisStackGroupsInitialValue);
};
var $b237779b1a44002c$export$ac086aaa4358d590 = function getTicksOfScale(scale, opts) {
    var realScaleType = opts.realScaleType, type = opts.type, tickCount = opts.tickCount, originalDomain = opts.originalDomain, allowDecimals = opts.allowDecimals;
    var scaleType = realScaleType || opts.scale;
    if (scaleType !== "auto" && scaleType !== "linear") return null;
    if (tickCount && type === "number" && originalDomain && (originalDomain[0] === "auto" || originalDomain[1] === "auto")) {
        // Calculate the ticks by the number of grid when the axis is a number axis
        var domain = scale.domain();
        if (!domain.length) return null;
        var tickValues = (0, $1TRCo.getNiceTickValues)(domain, tickCount, allowDecimals);
        scale.domain([
            (0, (/*@__PURE__*/$parcel$interopDefault($2vCNF)))(tickValues),
            (0, (/*@__PURE__*/$parcel$interopDefault($9HZtv)))(tickValues)
        ]);
        return {
            niceTicks: tickValues
        };
    }
    if (tickCount && type === "number") {
        var _domain = scale.domain();
        var _tickValues = (0, $1TRCo.getTickValuesFixedDomain)(_domain, tickCount, allowDecimals);
        return {
            niceTicks: _tickValues
        };
    }
    return null;
};
function $b237779b1a44002c$export$6e87f3defb83c3f(_ref5) {
    var axis = _ref5.axis, ticks = _ref5.ticks, bandSize = _ref5.bandSize, entry = _ref5.entry, index = _ref5.index, dataKey = _ref5.dataKey;
    if (axis.type === "category") {
        // find coordinate of category axis by the value of category
        // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
        if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, (/*@__PURE__*/$parcel$interopDefault($aVX0M)))(entry[axis.dataKey])) {
            // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
            var matchedTick = (0, $1gmrG.findEntryInArray)(ticks, "value", entry[axis.dataKey]);
            if (matchedTick) return matchedTick.coordinate + bandSize / 2;
        }
        return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
    }
    var value = $b237779b1a44002c$export$f97fc4a450f29a(entry, !(0, (/*@__PURE__*/$parcel$interopDefault($aVX0M)))(dataKey) ? dataKey : axis.dataKey);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($aVX0M)))(value) ? axis.scale(value) : null;
}
var $b237779b1a44002c$export$8abb9e87422f3a0c = function getCateCoordinateOfBar(_ref6) {
    var axis = _ref6.axis, ticks = _ref6.ticks, offset = _ref6.offset, bandSize = _ref6.bandSize, entry = _ref6.entry, index = _ref6.index;
    if (axis.type === "category") return ticks[index] ? ticks[index].coordinate + offset : null;
    var value = $b237779b1a44002c$export$f97fc4a450f29a(entry, axis.dataKey, axis.domain[index]);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($aVX0M)))(value) ? axis.scale(value) - bandSize / 2 + offset : null;
};
var $b237779b1a44002c$export$54f3200dd4a8a235 = function getBaseValueOfBar(_ref7) {
    var numericAxis = _ref7.numericAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === "number") {
        var minValue = Math.min(domain[0], domain[1]);
        var maxValue = Math.max(domain[0], domain[1]);
        if (minValue <= 0 && maxValue >= 0) return 0;
        if (maxValue < 0) return maxValue;
        return minValue;
    }
    return domain[0];
};
var $b237779b1a44002c$export$a17bf3d98457878c = function getStackedDataOfItem(item, stackGroups) {
    var _item$type3;
    var defaultedProps = (_item$type3 = item.type) !== null && _item$type3 !== void 0 && _item$type3.defaultProps ? $b237779b1a44002c$var$_objectSpread($b237779b1a44002c$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
    var stackId = defaultedProps.stackId;
    if ((0, $1gmrG.isNumOrStr)(stackId)) {
        var group = stackGroups[stackId];
        if (group) {
            var itemIndex = group.items.indexOf(item);
            return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
        }
    }
    return null;
};
var $b237779b1a44002c$var$getDomainOfSingle = function getDomainOfSingle(data) {
    return data.reduce(function(result, entry) {
        return [
            (0, (/*@__PURE__*/$parcel$interopDefault($2vCNF)))(entry.concat([
                result[0]
            ]).filter((0, $1gmrG.isNumber))),
            (0, (/*@__PURE__*/$parcel$interopDefault($9HZtv)))(entry.concat([
                result[1]
            ]).filter((0, $1gmrG.isNumber)))
        ];
    }, [
        Infinity,
        -Infinity
    ]);
};
var $b237779b1a44002c$export$26522b779eb5497c = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
    return Object.keys(stackGroups).reduce(function(result, stackId) {
        var group = stackGroups[stackId];
        var stackedData = group.stackedData;
        var domain = stackedData.reduce(function(res, entry) {
            var s = $b237779b1a44002c$var$getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
            return [
                Math.min(res[0], s[0]),
                Math.max(res[1], s[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
        return [
            Math.min(domain[0], result[0]),
            Math.max(domain[1], result[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]).map(function(result) {
        return result === Infinity || result === -Infinity ? 0 : result;
    });
};
var $b237779b1a44002c$export$75a7b23ff266dfa1 = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $b237779b1a44002c$export$19c111ec8ad6c644 = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $b237779b1a44002c$export$a0bc8660980558a0 = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(specifiedDomain)) return specifiedDomain(dataDomain, allowDataOverflow);
    if (!Array.isArray(specifiedDomain)) return dataDomain;
    var domain = [];
    /* eslint-disable prefer-destructuring */ if ((0, $1gmrG.isNumber)(specifiedDomain[0])) domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
    else if ($b237779b1a44002c$export$75a7b23ff266dfa1.test(specifiedDomain[0])) {
        var value = +$b237779b1a44002c$export$75a7b23ff266dfa1.exec(specifiedDomain[0])[1];
        domain[0] = dataDomain[0] - value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(specifiedDomain[0])) domain[0] = specifiedDomain[0](dataDomain[0]);
    else domain[0] = dataDomain[0];
    if ((0, $1gmrG.isNumber)(specifiedDomain[1])) domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
    else if ($b237779b1a44002c$export$19c111ec8ad6c644.test(specifiedDomain[1])) {
        var _value = +$b237779b1a44002c$export$19c111ec8ad6c644.exec(specifiedDomain[1])[1];
        domain[1] = dataDomain[1] + _value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(specifiedDomain[1])) domain[1] = specifiedDomain[1](dataDomain[1]);
    else domain[1] = dataDomain[1];
    /* eslint-enable prefer-destructuring */ return domain;
};
var $b237779b1a44002c$export$212ec45c42fe68a7 = function getBandSizeOfAxis(axis, ticks, isBar) {
    // @ts-expect-error we need to rethink scale type
    if (axis && axis.scale && axis.scale.bandwidth) {
        // @ts-expect-error we need to rethink scale type
        var bandWidth = axis.scale.bandwidth();
        if (!isBar || bandWidth > 0) return bandWidth;
    }
    if (axis && ticks && ticks.length >= 2) {
        var orderedTicks = (0, (/*@__PURE__*/$parcel$interopDefault($lfx6l)))(ticks, function(o) {
            return o.coordinate;
        });
        var bandSize = Infinity;
        for(var i = 1, len = orderedTicks.length; i < len; i++){
            var cur = orderedTicks[i];
            var prev = orderedTicks[i - 1];
            bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
        }
        return bandSize === Infinity ? 0 : bandSize;
    }
    return isBar ? undefined : 0;
};
var $b237779b1a44002c$export$c9a5230f0dda41bf = function parseDomainOfCategoryAxis(specifiedDomain, calculatedDomain, axisChild) {
    if (!specifiedDomain || !specifiedDomain.length) return calculatedDomain;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($dzN0r)))(specifiedDomain, (0, (/*@__PURE__*/$parcel$interopDefault($lNQsK)))(axisChild, "type.defaultProps.domain"))) return calculatedDomain;
    return specifiedDomain;
};
var $b237779b1a44002c$export$a4ea3faa19bc2d90 = function getTooltipItem(graphicalItem, payload) {
    var defaultedProps = graphicalItem.type.defaultProps ? $b237779b1a44002c$var$_objectSpread($b237779b1a44002c$var$_objectSpread({}, graphicalItem.type.defaultProps), graphicalItem.props) : graphicalItem.props;
    var dataKey = defaultedProps.dataKey, name = defaultedProps.name, unit = defaultedProps.unit, formatter = defaultedProps.formatter, tooltipType = defaultedProps.tooltipType, chartType = defaultedProps.chartType, hide = defaultedProps.hide;
    return $b237779b1a44002c$var$_objectSpread($b237779b1a44002c$var$_objectSpread({}, (0, $f06D9.filterProps)(graphicalItem, false)), {}, {
        dataKey: dataKey,
        unit: unit,
        formatter: formatter,
        name: name || dataKey,
        color: $b237779b1a44002c$export$ec6cab5a7a3b93bf(graphicalItem),
        value: $b237779b1a44002c$export$f97fc4a450f29a(payload, dataKey),
        type: tooltipType,
        payload: payload,
        chartType: chartType,
        hide: hide
    });
};

});
parcelRegister("b0sdz", function(module, exports) {
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

module.exports = (parcelRequire("hoTQa"));

});
parcelRegister("hoTQa", function(module, exports) {
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-scale`

module.exports = (parcelRequire("bHW9h"));

});
parcelRegister("bHW9h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "scaleBand", {
    enumerable: true,
    get: function() {
        return $02331c250a25f7cd$var$_band.default;
    }
});
Object.defineProperty(module.exports, "scaleDiverging", {
    enumerable: true,
    get: function() {
        return $02331c250a25f7cd$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "scaleDivergingLog", {
    enumerable: true,
    get: function() {
        return $02331c250a25f7cd$var$_diverging.divergingLog;
    }
});
Object.defineProperty(module.exports, "scaleDivergingPow", {
    enumerable: true,
    get: function() {
        return $02331c250a25f7cd$var$_diverging.divergingPow;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSqrt", {
    enumerable: true,
    get: function() {
        return $02331c250a25f7cd$var$_diverging.divergingSqrt;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSymlog", {
    enumerable: true,
    get: function() {
        return $02331c250a25f7cd$var$_diverging.divergingSymlog;
    }
});
Object.defineProperty(module.exports, "scaleIdentity", {
    enumerable: true,
    get: function() {
        return $02331c250a25f7cd$var$_identity.default;
    }
});
Object.defineProperty(module.exports, "scaleImplicit", {
    enumerable: true,
    get: function() {
        return $02331c250a25f7cd$var$_ordinal.implicit;
    }
});
Object.defineProperty(module.exports, "scaleLinear", {
    enumerable: true,
    get: function() {
        return $02331c250a25f7cd$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "scaleLog", {
    enumerable: true,
    get: function() {
        return $02331c250a25f7cd$var$_log.default;
    }
});
Object.defineProperty(module.exports, "scaleOrdinal", {
    enumerable: true,
    get: function() {
        return $02331c250a25f7cd$var$_ordinal.default;
    }
});
Object.defineProperty(module.exports, "scalePoint", {
    enumerable: true,
    get: function() {
        return $02331c250a25f7cd$var$_band.point;
    }
});
Object.defineProperty(module.exports, "scalePow", {
    enumerable: true,
    get: function() {
        return $02331c250a25f7cd$var$_pow.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantile", {
    enumerable: true,
    get: function() {
        return $02331c250a25f7cd$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantize", {
    enumerable: true,
    get: function() {
        return $02331c250a25f7cd$var$_quantize.default;
    }
});
Object.defineProperty(module.exports, "scaleRadial", {
    enumerable: true,
    get: function() {
        return $02331c250a25f7cd$var$_radial.default;
    }
});
Object.defineProperty(module.exports, "scaleSequential", {
    enumerable: true,
    get: function() {
        return $02331c250a25f7cd$var$_sequential.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialLog", {
    enumerable: true,
    get: function() {
        return $02331c250a25f7cd$var$_sequential.sequentialLog;
    }
});
Object.defineProperty(module.exports, "scaleSequentialPow", {
    enumerable: true,
    get: function() {
        return $02331c250a25f7cd$var$_sequential.sequentialPow;
    }
});
Object.defineProperty(module.exports, "scaleSequentialQuantile", {
    enumerable: true,
    get: function() {
        return $02331c250a25f7cd$var$_sequentialQuantile.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSqrt", {
    enumerable: true,
    get: function() {
        return $02331c250a25f7cd$var$_sequential.sequentialSqrt;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSymlog", {
    enumerable: true,
    get: function() {
        return $02331c250a25f7cd$var$_sequential.sequentialSymlog;
    }
});
Object.defineProperty(module.exports, "scaleSqrt", {
    enumerable: true,
    get: function() {
        return $02331c250a25f7cd$var$_pow.sqrt;
    }
});
Object.defineProperty(module.exports, "scaleSymlog", {
    enumerable: true,
    get: function() {
        return $02331c250a25f7cd$var$_symlog.default;
    }
});
Object.defineProperty(module.exports, "scaleThreshold", {
    enumerable: true,
    get: function() {
        return $02331c250a25f7cd$var$_threshold.default;
    }
});
Object.defineProperty(module.exports, "scaleTime", {
    enumerable: true,
    get: function() {
        return $02331c250a25f7cd$var$_time.default;
    }
});
Object.defineProperty(module.exports, "scaleUtc", {
    enumerable: true,
    get: function() {
        return $02331c250a25f7cd$var$_utcTime.default;
    }
});
Object.defineProperty(module.exports, "tickFormat", {
    enumerable: true,
    get: function() {
        return $02331c250a25f7cd$var$_tickFormat.default;
    }
});

var $02331c250a25f7cd$var$_band = $02331c250a25f7cd$var$_interopRequireWildcard((parcelRequire("7YBwQ")));

var $02331c250a25f7cd$var$_identity = $02331c250a25f7cd$var$_interopRequireDefault((parcelRequire("jfp0U")));

var $02331c250a25f7cd$var$_linear = $02331c250a25f7cd$var$_interopRequireDefault((parcelRequire("5bYdw")));

var $02331c250a25f7cd$var$_log = $02331c250a25f7cd$var$_interopRequireDefault((parcelRequire("acYkY")));

var $02331c250a25f7cd$var$_symlog = $02331c250a25f7cd$var$_interopRequireDefault((parcelRequire("e8pBQ")));

var $02331c250a25f7cd$var$_ordinal = $02331c250a25f7cd$var$_interopRequireWildcard((parcelRequire("kAUuD")));

var $02331c250a25f7cd$var$_pow = $02331c250a25f7cd$var$_interopRequireWildcard((parcelRequire("aQ2CU")));

var $02331c250a25f7cd$var$_radial = $02331c250a25f7cd$var$_interopRequireDefault((parcelRequire("h9Z5b")));

var $02331c250a25f7cd$var$_quantile = $02331c250a25f7cd$var$_interopRequireDefault((parcelRequire("gMQyC")));

var $02331c250a25f7cd$var$_quantize = $02331c250a25f7cd$var$_interopRequireDefault((parcelRequire("alarn")));

var $02331c250a25f7cd$var$_threshold = $02331c250a25f7cd$var$_interopRequireDefault((parcelRequire("g0t6E")));

var $02331c250a25f7cd$var$_time = $02331c250a25f7cd$var$_interopRequireDefault((parcelRequire("kLoNf")));

var $02331c250a25f7cd$var$_utcTime = $02331c250a25f7cd$var$_interopRequireDefault((parcelRequire("7OWIf")));

var $02331c250a25f7cd$var$_sequential = $02331c250a25f7cd$var$_interopRequireWildcard((parcelRequire("eybci")));

var $02331c250a25f7cd$var$_sequentialQuantile = $02331c250a25f7cd$var$_interopRequireDefault((parcelRequire("ihnVV")));

var $02331c250a25f7cd$var$_diverging = $02331c250a25f7cd$var$_interopRequireWildcard((parcelRequire("i4lEL")));

var $02331c250a25f7cd$var$_tickFormat = $02331c250a25f7cd$var$_interopRequireDefault((parcelRequire("cNYhO")));
function $02331c250a25f7cd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $02331c250a25f7cd$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($02331c250a25f7cd$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $02331c250a25f7cd$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $02331c250a25f7cd$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("7YBwQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5ceb3f6a2a3118d9$var$band;
module.exports.point = $5ceb3f6a2a3118d9$var$point;

var $2bySc = parcelRequire("2bySc");

var $8vtGb = parcelRequire("8vtGb");

var $5ceb3f6a2a3118d9$var$_ordinal = $5ceb3f6a2a3118d9$var$_interopRequireDefault((parcelRequire("kAUuD")));
function $5ceb3f6a2a3118d9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5ceb3f6a2a3118d9$var$band() {
    var scale = (0, $5ceb3f6a2a3118d9$var$_ordinal.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $2bySc.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $5ceb3f6a2a3118d9$var$band(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return $8vtGb.initRange.apply(rescale(), arguments);
}
function $5ceb3f6a2a3118d9$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $5ceb3f6a2a3118d9$var$pointish(copy());
    };
    return scale;
}
function $5ceb3f6a2a3118d9$var$point() {
    return $5ceb3f6a2a3118d9$var$pointish($5ceb3f6a2a3118d9$var$band.apply(null, arguments).paddingInner(1));
}

});
parcelRegister("2bySc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Adder", {
    enumerable: true,
    get: function() {
        return $e1l2N.Adder;
    }
});
Object.defineProperty(module.exports, "InternMap", {
    enumerable: true,
    get: function() {
        return $QUjlf.InternMap;
    }
});
Object.defineProperty(module.exports, "InternSet", {
    enumerable: true,
    get: function() {
        return $QUjlf.InternSet;
    }
});
Object.defineProperty(module.exports, "ascending", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "bin", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "bisect", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_bisect.default;
    }
});
Object.defineProperty(module.exports, "bisectCenter", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_bisect.bisectCenter;
    }
});
Object.defineProperty(module.exports, "bisectLeft", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_bisect.bisectLeft;
    }
});
Object.defineProperty(module.exports, "bisectRight", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_bisect.bisectRight;
    }
});
Object.defineProperty(module.exports, "bisector", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_bisector.default;
    }
});
Object.defineProperty(module.exports, "count", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_count.default;
    }
});
Object.defineProperty(module.exports, "cross", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "cumsum", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_cumsum.default;
    }
});
Object.defineProperty(module.exports, "descending", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "deviation", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_deviation.default;
    }
});
Object.defineProperty(module.exports, "difference", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_difference.default;
    }
});
Object.defineProperty(module.exports, "disjoint", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_disjoint.default;
    }
});
Object.defineProperty(module.exports, "every", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_every.default;
    }
});
Object.defineProperty(module.exports, "extent", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_extent.default;
    }
});
Object.defineProperty(module.exports, "fcumsum", {
    enumerable: true,
    get: function() {
        return $e1l2N.fcumsum;
    }
});
Object.defineProperty(module.exports, "filter", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_filter.default;
    }
});
Object.defineProperty(module.exports, "flatGroup", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_group.flatGroup;
    }
});
Object.defineProperty(module.exports, "flatRollup", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_group.flatRollup;
    }
});
Object.defineProperty(module.exports, "fsum", {
    enumerable: true,
    get: function() {
        return $e1l2N.fsum;
    }
});
Object.defineProperty(module.exports, "greatest", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_greatest.default;
    }
});
Object.defineProperty(module.exports, "greatestIndex", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_greatestIndex.default;
    }
});
Object.defineProperty(module.exports, "group", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_group.default;
    }
});
Object.defineProperty(module.exports, "groupSort", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_groupSort.default;
    }
});
Object.defineProperty(module.exports, "groups", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_group.groups;
    }
});
Object.defineProperty(module.exports, "histogram", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "index", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_group.index;
    }
});
Object.defineProperty(module.exports, "indexes", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_group.indexes;
    }
});
Object.defineProperty(module.exports, "intersection", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_intersection.default;
    }
});
Object.defineProperty(module.exports, "least", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_least.default;
    }
});
Object.defineProperty(module.exports, "leastIndex", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_leastIndex.default;
    }
});
Object.defineProperty(module.exports, "map", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_map.default;
    }
});
Object.defineProperty(module.exports, "max", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_max.default;
    }
});
Object.defineProperty(module.exports, "maxIndex", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_maxIndex.default;
    }
});
Object.defineProperty(module.exports, "mean", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_mean.default;
    }
});
Object.defineProperty(module.exports, "median", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_median.default;
    }
});
Object.defineProperty(module.exports, "merge", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_merge.default;
    }
});
Object.defineProperty(module.exports, "min", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_min.default;
    }
});
Object.defineProperty(module.exports, "minIndex", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_minIndex.default;
    }
});
Object.defineProperty(module.exports, "mode", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_mode.default;
    }
});
Object.defineProperty(module.exports, "nice", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_nice.default;
    }
});
Object.defineProperty(module.exports, "pairs", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_pairs.default;
    }
});
Object.defineProperty(module.exports, "permute", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_permute.default;
    }
});
Object.defineProperty(module.exports, "quantile", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "quantileSorted", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_quantile.quantileSorted;
    }
});
Object.defineProperty(module.exports, "quickselect", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_quickselect.default;
    }
});
Object.defineProperty(module.exports, "range", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_range.default;
    }
});
Object.defineProperty(module.exports, "rank", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_rank.default;
    }
});
Object.defineProperty(module.exports, "reduce", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_reduce.default;
    }
});
Object.defineProperty(module.exports, "reverse", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "rollup", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_group.rollup;
    }
});
Object.defineProperty(module.exports, "rollups", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_group.rollups;
    }
});
Object.defineProperty(module.exports, "scan", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_scan.default;
    }
});
Object.defineProperty(module.exports, "shuffle", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_shuffle.default;
    }
});
Object.defineProperty(module.exports, "shuffler", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_shuffle.shuffler;
    }
});
Object.defineProperty(module.exports, "some", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_some.default;
    }
});
Object.defineProperty(module.exports, "sort", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_sort.default;
    }
});
Object.defineProperty(module.exports, "subset", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_subset.default;
    }
});
Object.defineProperty(module.exports, "sum", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_sum.default;
    }
});
Object.defineProperty(module.exports, "superset", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_superset.default;
    }
});
Object.defineProperty(module.exports, "thresholdFreedmanDiaconis", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_freedmanDiaconis.default;
    }
});
Object.defineProperty(module.exports, "thresholdScott", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_scott.default;
    }
});
Object.defineProperty(module.exports, "thresholdSturges", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_sturges.default;
    }
});
Object.defineProperty(module.exports, "tickIncrement", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_ticks.tickIncrement;
    }
});
Object.defineProperty(module.exports, "tickStep", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_ticks.tickStep;
    }
});
Object.defineProperty(module.exports, "ticks", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_ticks.default;
    }
});
Object.defineProperty(module.exports, "transpose", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_transpose.default;
    }
});
Object.defineProperty(module.exports, "union", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_union.default;
    }
});
Object.defineProperty(module.exports, "variance", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_variance.default;
    }
});
Object.defineProperty(module.exports, "zip", {
    enumerable: true,
    get: function() {
        return $1977a8f67d9e1a26$var$_zip.default;
    }
});

var $1977a8f67d9e1a26$var$_bisect = $1977a8f67d9e1a26$var$_interopRequireWildcard((parcelRequire("7AfxL")));

var $1977a8f67d9e1a26$var$_ascending = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("e3onA")));

var $1977a8f67d9e1a26$var$_bisector = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("4uNAQ")));

var $1977a8f67d9e1a26$var$_count = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("5UTDi")));

var $1977a8f67d9e1a26$var$_cross = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("6vCd2")));

var $1977a8f67d9e1a26$var$_cumsum = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("ipdfE")));

var $1977a8f67d9e1a26$var$_descending = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("f4Z7a")));

var $1977a8f67d9e1a26$var$_deviation = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("dyvZc")));

var $1977a8f67d9e1a26$var$_extent = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("fObW4")));

var $e1l2N = parcelRequire("e1l2N");

var $1977a8f67d9e1a26$var$_group = $1977a8f67d9e1a26$var$_interopRequireWildcard((parcelRequire("bdwXa")));

var $1977a8f67d9e1a26$var$_groupSort = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("3RmtT")));

var $1977a8f67d9e1a26$var$_bin = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("8ZDzk")));

var $1977a8f67d9e1a26$var$_freedmanDiaconis = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("6lbaw")));

var $1977a8f67d9e1a26$var$_scott = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("4NG26")));

var $1977a8f67d9e1a26$var$_sturges = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("8vvB8")));

var $1977a8f67d9e1a26$var$_max = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("7guTq")));

var $1977a8f67d9e1a26$var$_maxIndex = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("6IeI9")));

var $1977a8f67d9e1a26$var$_mean = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("e3bit")));

var $1977a8f67d9e1a26$var$_median = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("1jVc3")));

var $1977a8f67d9e1a26$var$_merge = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("3ChYQ")));

var $1977a8f67d9e1a26$var$_min = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("Ojec1")));

var $1977a8f67d9e1a26$var$_minIndex = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("lATcB")));

var $1977a8f67d9e1a26$var$_mode = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("1esF3")));

var $1977a8f67d9e1a26$var$_nice = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("5X3wh")));

var $1977a8f67d9e1a26$var$_pairs = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("j18Jm")));

var $1977a8f67d9e1a26$var$_permute = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("kfU9X")));

var $1977a8f67d9e1a26$var$_quantile = $1977a8f67d9e1a26$var$_interopRequireWildcard((parcelRequire("lpC3c")));

var $1977a8f67d9e1a26$var$_quickselect = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("9rYw5")));

var $1977a8f67d9e1a26$var$_range = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("dGOEk")));

var $1977a8f67d9e1a26$var$_rank = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("4cf4B")));

var $1977a8f67d9e1a26$var$_least = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("ioACH")));

var $1977a8f67d9e1a26$var$_leastIndex = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("kvmYL")));

var $1977a8f67d9e1a26$var$_greatest = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("6FrDQ")));

var $1977a8f67d9e1a26$var$_greatestIndex = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("lmzh6")));

var $1977a8f67d9e1a26$var$_scan = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("jvPzw")));

var $1977a8f67d9e1a26$var$_shuffle = $1977a8f67d9e1a26$var$_interopRequireWildcard((parcelRequire("5z8Bo")));

var $1977a8f67d9e1a26$var$_sum = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("gQmRZ")));

var $1977a8f67d9e1a26$var$_ticks = $1977a8f67d9e1a26$var$_interopRequireWildcard((parcelRequire("i1Kbe")));

var $1977a8f67d9e1a26$var$_transpose = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("bumB5")));

var $1977a8f67d9e1a26$var$_variance = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("05cBN")));

var $1977a8f67d9e1a26$var$_zip = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("lUZKZ")));

var $1977a8f67d9e1a26$var$_every = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("jhUFn")));

var $1977a8f67d9e1a26$var$_some = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("d04yi")));

var $1977a8f67d9e1a26$var$_filter = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("2ehPK")));

var $1977a8f67d9e1a26$var$_map = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("8JivZ")));

var $1977a8f67d9e1a26$var$_reduce = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("eCJY6")));

var $1977a8f67d9e1a26$var$_reverse = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("9qCvR")));

var $1977a8f67d9e1a26$var$_sort = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("beWVB")));

var $1977a8f67d9e1a26$var$_difference = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("fqTXF")));

var $1977a8f67d9e1a26$var$_disjoint = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("9s7cT")));

var $1977a8f67d9e1a26$var$_intersection = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("k4QyO")));

var $1977a8f67d9e1a26$var$_subset = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("49DZS")));

var $1977a8f67d9e1a26$var$_superset = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("3ol0T")));

var $1977a8f67d9e1a26$var$_union = $1977a8f67d9e1a26$var$_interopRequireDefault((parcelRequire("eJ7de")));

var $QUjlf = parcelRequire("QUjlf");
function $1977a8f67d9e1a26$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1977a8f67d9e1a26$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($1977a8f67d9e1a26$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $1977a8f67d9e1a26$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $1977a8f67d9e1a26$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("7AfxL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.bisectRight = module.exports.bisectLeft = module.exports.bisectCenter = void 0;

var $5857f3d6def3a478$var$_ascending = $5857f3d6def3a478$var$_interopRequireDefault((parcelRequire("e3onA")));

var $5857f3d6def3a478$var$_bisector = $5857f3d6def3a478$var$_interopRequireDefault((parcelRequire("4uNAQ")));

var $5857f3d6def3a478$var$_number = $5857f3d6def3a478$var$_interopRequireDefault((parcelRequire("1SKnD")));
function $5857f3d6def3a478$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $5857f3d6def3a478$var$ascendingBisect = (0, $5857f3d6def3a478$var$_bisector.default)($5857f3d6def3a478$var$_ascending.default);
const $5857f3d6def3a478$var$bisectRight = $5857f3d6def3a478$var$ascendingBisect.right;
module.exports.bisectRight = $5857f3d6def3a478$var$bisectRight;
const $5857f3d6def3a478$var$bisectLeft = $5857f3d6def3a478$var$ascendingBisect.left;
module.exports.bisectLeft = $5857f3d6def3a478$var$bisectLeft;
const $5857f3d6def3a478$var$bisectCenter = (0, $5857f3d6def3a478$var$_bisector.default)($5857f3d6def3a478$var$_number.default).center;
module.exports.bisectCenter = $5857f3d6def3a478$var$bisectCenter;
var $5857f3d6def3a478$var$_default = $5857f3d6def3a478$var$bisectRight;
module.exports.default = $5857f3d6def3a478$var$_default;

});
parcelRegister("e3onA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a3b441c2d21d7e8c$var$ascending;
function $a3b441c2d21d7e8c$var$ascending(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("4uNAQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $34606ef9446c7093$var$bisector;

var $34606ef9446c7093$var$_ascending = $34606ef9446c7093$var$_interopRequireDefault((parcelRequire("e3onA")));

var $34606ef9446c7093$var$_descending = $34606ef9446c7093$var$_interopRequireDefault((parcelRequire("f4Z7a")));
function $34606ef9446c7093$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $34606ef9446c7093$var$bisector(f) {
    let compare1, compare2, delta; // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = $34606ef9446c7093$var$_ascending.default;
        compare2 = (d, x)=>(0, $34606ef9446c7093$var$_ascending.default)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === $34606ef9446c7093$var$_ascending.default || f === $34606ef9446c7093$var$_descending.default ? f : $34606ef9446c7093$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $34606ef9446c7093$var$zero() {
    return 0;
}

});
parcelRegister("f4Z7a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $afa6a2cc487c1d83$var$descending;
function $afa6a2cc487c1d83$var$descending(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});


parcelRegister("1SKnD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $15eecfb90f311aae$var$number;
module.exports.numbers = $15eecfb90f311aae$var$numbers;
function $15eecfb90f311aae$var$number(x) {
    return x === null ? NaN : +x;
}
function* $15eecfb90f311aae$var$numbers(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

});


parcelRegister("5UTDi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $44ed563823e6b7c1$var$count;
function $44ed563823e6b7c1$var$count(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}

});

parcelRegister("6vCd2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4bd346e8fc2e1d1f$var$cross;
function $4bd346e8fc2e1d1f$var$length(array) {
    return array.length | 0;
}
function $4bd346e8fc2e1d1f$var$empty(length) {
    return !(length > 0);
}
function $4bd346e8fc2e1d1f$var$arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function $4bd346e8fc2e1d1f$var$reducer(reduce) {
    return (values)=>reduce(...values);
}
function $4bd346e8fc2e1d1f$var$cross(...values) {
    const reduce = typeof values[values.length - 1] === "function" && $4bd346e8fc2e1d1f$var$reducer(values.pop());
    values = values.map($4bd346e8fc2e1d1f$var$arrayify);
    const lengths = values.map($4bd346e8fc2e1d1f$var$length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some($4bd346e8fc2e1d1f$var$empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}

});

parcelRegister("ipdfE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d664d73ae1275948$var$cumsum;
function $d664d73ae1275948$var$cumsum(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
}

});

parcelRegister("dyvZc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9de7431f7d3ce55a$var$deviation;

var $9de7431f7d3ce55a$var$_variance = $9de7431f7d3ce55a$var$_interopRequireDefault((parcelRequire("05cBN")));
function $9de7431f7d3ce55a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9de7431f7d3ce55a$var$deviation(values, valueof) {
    const v = (0, $9de7431f7d3ce55a$var$_variance.default)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

});
parcelRegister("05cBN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $00fa3f94750ecba8$var$variance;
function $00fa3f94750ecba8$var$variance(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}

});


parcelRegister("fObW4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b824c8b50e669e05$var$extent;
function $b824c8b50e669e05$var$extent(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

});

parcelRegister("e1l2N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Adder = void 0;
module.exports.fcumsum = $a3517b9a6f440948$var$fcumsum;
module.exports.fsum = $a3517b9a6f440948$var$fsum;
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class $a3517b9a6f440948$var$Adder {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
module.exports.Adder = $a3517b9a6f440948$var$Adder;
function $a3517b9a6f440948$var$fsum(values, valueof) {
    const adder = new $a3517b9a6f440948$var$Adder();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function $a3517b9a6f440948$var$fcumsum(values, valueof) {
    const adder = new $a3517b9a6f440948$var$Adder();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}

});

parcelRegister("bdwXa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $82aa786cca7ea9fd$var$group;
module.exports.flatGroup = $82aa786cca7ea9fd$var$flatGroup;
module.exports.flatRollup = $82aa786cca7ea9fd$var$flatRollup;
module.exports.groups = $82aa786cca7ea9fd$var$groups;
module.exports.index = $82aa786cca7ea9fd$var$index;
module.exports.indexes = $82aa786cca7ea9fd$var$indexes;
module.exports.rollup = $82aa786cca7ea9fd$var$rollup;
module.exports.rollups = $82aa786cca7ea9fd$var$rollups;

var $QUjlf = parcelRequire("QUjlf");

var $82aa786cca7ea9fd$var$_identity = $82aa786cca7ea9fd$var$_interopRequireDefault((parcelRequire("dySvk")));
function $82aa786cca7ea9fd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $82aa786cca7ea9fd$var$group(values, ...keys) {
    return $82aa786cca7ea9fd$var$nest(values, $82aa786cca7ea9fd$var$_identity.default, $82aa786cca7ea9fd$var$_identity.default, keys);
}
function $82aa786cca7ea9fd$var$groups(values, ...keys) {
    return $82aa786cca7ea9fd$var$nest(values, Array.from, $82aa786cca7ea9fd$var$_identity.default, keys);
}
function $82aa786cca7ea9fd$var$flatten(groups, keys) {
    for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                ...g,
                key,
                value
            ]));
    return groups;
}
function $82aa786cca7ea9fd$var$flatGroup(values, ...keys) {
    return $82aa786cca7ea9fd$var$flatten($82aa786cca7ea9fd$var$groups(values, ...keys), keys);
}
function $82aa786cca7ea9fd$var$flatRollup(values, reduce, ...keys) {
    return $82aa786cca7ea9fd$var$flatten($82aa786cca7ea9fd$var$rollups(values, reduce, ...keys), keys);
}
function $82aa786cca7ea9fd$var$rollup(values, reduce, ...keys) {
    return $82aa786cca7ea9fd$var$nest(values, $82aa786cca7ea9fd$var$_identity.default, reduce, keys);
}
function $82aa786cca7ea9fd$var$rollups(values, reduce, ...keys) {
    return $82aa786cca7ea9fd$var$nest(values, Array.from, reduce, keys);
}
function $82aa786cca7ea9fd$var$index(values, ...keys) {
    return $82aa786cca7ea9fd$var$nest(values, $82aa786cca7ea9fd$var$_identity.default, $82aa786cca7ea9fd$var$unique, keys);
}
function $82aa786cca7ea9fd$var$indexes(values, ...keys) {
    return $82aa786cca7ea9fd$var$nest(values, Array.from, $82aa786cca7ea9fd$var$unique, keys);
}
function $82aa786cca7ea9fd$var$unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function $82aa786cca7ea9fd$var$nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new $QUjlf.InternMap();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}

});
parcelRegister("QUjlf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InternSet = module.exports.InternMap = void 0;
class $09f089a0a171acc7$var$InternMap extends Map {
    constructor(entries, key = $09f089a0a171acc7$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($09f089a0a171acc7$var$intern_get(this, key));
    }
    has(key) {
        return super.has($09f089a0a171acc7$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($09f089a0a171acc7$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($09f089a0a171acc7$var$intern_delete(this, key));
    }
}
module.exports.InternMap = $09f089a0a171acc7$var$InternMap;
class $09f089a0a171acc7$var$InternSet extends Set {
    constructor(values, key = $09f089a0a171acc7$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($09f089a0a171acc7$var$intern_get(this, value));
    }
    add(value) {
        return super.add($09f089a0a171acc7$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($09f089a0a171acc7$var$intern_delete(this, value));
    }
}
module.exports.InternSet = $09f089a0a171acc7$var$InternSet;
function $09f089a0a171acc7$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $09f089a0a171acc7$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $09f089a0a171acc7$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $09f089a0a171acc7$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});

parcelRegister("dySvk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9df8babf7c3dd890$var$identity;
function $9df8babf7c3dd890$var$identity(x) {
    return x;
}

});


parcelRegister("3RmtT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2cf7c29bd0b14df1$var$groupSort;

var $2cf7c29bd0b14df1$var$_ascending = $2cf7c29bd0b14df1$var$_interopRequireDefault((parcelRequire("e3onA")));

var $2cf7c29bd0b14df1$var$_group = $2cf7c29bd0b14df1$var$_interopRequireWildcard((parcelRequire("bdwXa")));

var $2cf7c29bd0b14df1$var$_sort = $2cf7c29bd0b14df1$var$_interopRequireDefault((parcelRequire("beWVB")));
function $2cf7c29bd0b14df1$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($2cf7c29bd0b14df1$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $2cf7c29bd0b14df1$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $2cf7c29bd0b14df1$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $2cf7c29bd0b14df1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2cf7c29bd0b14df1$var$groupSort(values, reduce, key) {
    return (reduce.length !== 2 ? (0, $2cf7c29bd0b14df1$var$_sort.default)((0, $2cf7c29bd0b14df1$var$_group.rollup)(values, reduce, key), ([ak, av], [bk, bv])=>(0, $2cf7c29bd0b14df1$var$_ascending.default)(av, bv) || (0, $2cf7c29bd0b14df1$var$_ascending.default)(ak, bk)) : (0, $2cf7c29bd0b14df1$var$_sort.default)((0, $2cf7c29bd0b14df1$var$_group.default)(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || (0, $2cf7c29bd0b14df1$var$_ascending.default)(ak, bk))).map(([key])=>key);
}

});
parcelRegister("beWVB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ascendingDefined = $82eeb66280f43a4b$var$ascendingDefined;
module.exports.compareDefined = $82eeb66280f43a4b$var$compareDefined;
module.exports.default = $82eeb66280f43a4b$var$sort;

var $82eeb66280f43a4b$var$_ascending = $82eeb66280f43a4b$var$_interopRequireDefault((parcelRequire("e3onA")));

var $82eeb66280f43a4b$var$_permute = $82eeb66280f43a4b$var$_interopRequireDefault((parcelRequire("kfU9X")));
function $82eeb66280f43a4b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $82eeb66280f43a4b$var$sort(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = $82eeb66280f43a4b$var$ascendingDefined(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>$82eeb66280f43a4b$var$ascendingDefined(f[i], f[j]));
        }
        return (0, $82eeb66280f43a4b$var$_permute.default)(values, index);
    }
    return values.sort($82eeb66280f43a4b$var$compareDefined(f));
}
function $82eeb66280f43a4b$var$compareDefined(compare = $82eeb66280f43a4b$var$_ascending.default) {
    if (compare === $82eeb66280f43a4b$var$_ascending.default) return $82eeb66280f43a4b$var$ascendingDefined;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function $82eeb66280f43a4b$var$ascendingDefined(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

});
parcelRegister("kfU9X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ebf0c579fcfca0de$var$permute;
function $ebf0c579fcfca0de$var$permute(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}

});



parcelRegister("8ZDzk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $68c2b6c94037a017$var$bin;

var $kZant = parcelRequire("kZant");

var $68c2b6c94037a017$var$_bisect = $68c2b6c94037a017$var$_interopRequireDefault((parcelRequire("7AfxL")));

var $68c2b6c94037a017$var$_constant = $68c2b6c94037a017$var$_interopRequireDefault((parcelRequire("bsMUk")));

var $68c2b6c94037a017$var$_extent = $68c2b6c94037a017$var$_interopRequireDefault((parcelRequire("fObW4")));

var $68c2b6c94037a017$var$_identity = $68c2b6c94037a017$var$_interopRequireDefault((parcelRequire("dySvk")));

var $68c2b6c94037a017$var$_nice = $68c2b6c94037a017$var$_interopRequireDefault((parcelRequire("5X3wh")));

var $68c2b6c94037a017$var$_ticks = $68c2b6c94037a017$var$_interopRequireWildcard((parcelRequire("i1Kbe")));

var $68c2b6c94037a017$var$_sturges = $68c2b6c94037a017$var$_interopRequireDefault((parcelRequire("8vvB8")));
function $68c2b6c94037a017$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($68c2b6c94037a017$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $68c2b6c94037a017$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $68c2b6c94037a017$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $68c2b6c94037a017$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $68c2b6c94037a017$var$bin() {
    var value = $68c2b6c94037a017$var$_identity.default, domain = $68c2b6c94037a017$var$_extent.default, threshold = $68c2b6c94037a017$var$_sturges.default;
    function histogram(data) {
        if (!Array.isArray(data)) data = Array.from(data);
        var i, n = data.length, x, step, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1); // Convert number of thresholds into uniform thresholds, and nice the
        // default domain accordingly.
        if (!Array.isArray(tz)) {
            const max = x1, tn = +tz;
            if (domain === $68c2b6c94037a017$var$_extent.default) [x0, x1] = (0, $68c2b6c94037a017$var$_nice.default)(x0, x1, tn);
            tz = (0, $68c2b6c94037a017$var$_ticks.default)(x0, x1, tn); // If the domain is aligned with the first tick (which it will by
            // default), then we can use quantization rather than bisection to bin
            // values, which is substantially faster.
            if (tz[0] <= x0) step = (0, $68c2b6c94037a017$var$_ticks.tickIncrement)(x0, x1, tn); // If the last threshold is coincident with the domain’s upper bound, the
            // last bin will be zero-width. If the default domain is used, and this
            // last threshold is coincident with the maximum input value, we can
            // extend the niced upper bound by one tick to ensure uniform bin widths;
            // otherwise, we simply remove the last threshold. Note that we don’t
            // coerce values or the domain to numbers, and thus must be careful to
            // compare order (>=) rather than strict equality (===)!
            if (tz[tz.length - 1] >= x1) {
                if (max >= x1 && domain === $68c2b6c94037a017$var$_extent.default) {
                    const step = (0, $68c2b6c94037a017$var$_ticks.tickIncrement)(x0, x1, tn);
                    if (isFinite(step)) {
                        if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                        else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                    }
                } else tz.pop();
            }
        } // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin; // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        } // Assign data to bins by value, ignoring any outside the domain.
        if (isFinite(step)) {
            if (step > 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
            } else if (step < 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                    const j = Math.floor((x0 - x) * step);
                    bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
                }
            }
        } else {
            for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[(0, $68c2b6c94037a017$var$_bisect.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $68c2b6c94037a017$var$_constant.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $68c2b6c94037a017$var$_constant.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $68c2b6c94037a017$var$_constant.default)($kZant.slice.call(_)) : (0, $68c2b6c94037a017$var$_constant.default)(_), histogram) : threshold;
    };
    return histogram;
}

});
parcelRegister("kZant", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.slice = module.exports.map = void 0;
var $f4718de9c7a47780$var$array = Array.prototype;
var $f4718de9c7a47780$var$slice = $f4718de9c7a47780$var$array.slice;
module.exports.slice = $f4718de9c7a47780$var$slice;
var $f4718de9c7a47780$var$map = $f4718de9c7a47780$var$array.map;
module.exports.map = $f4718de9c7a47780$var$map;

});

parcelRegister("bsMUk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $85883f3b2b38013a$var$constant;
function $85883f3b2b38013a$var$constant(x) {
    return ()=>x;
}

});

parcelRegister("5X3wh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $45553159353b04b5$var$nice;

var $i1Kbe = parcelRequire("i1Kbe");
function $45553159353b04b5$var$nice(start, stop, count) {
    let prestep;
    while(true){
        const step = (0, $i1Kbe.tickIncrement)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}

});
parcelRegister("i1Kbe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d1fc2464d475d011$var$ticks;
module.exports.tickIncrement = $d1fc2464d475d011$var$tickIncrement;
module.exports.tickStep = $d1fc2464d475d011$var$tickStep;
var $d1fc2464d475d011$var$e10 = Math.sqrt(50), $d1fc2464d475d011$var$e5 = Math.sqrt(10), $d1fc2464d475d011$var$e2 = Math.sqrt(2);
function $d1fc2464d475d011$var$ticks(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $d1fc2464d475d011$var$tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        let r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        let r0 = Math.round(start * step), r1 = Math.round(stop * step);
        if (r0 / step < start) ++r0;
        if (r1 / step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $d1fc2464d475d011$var$tickIncrement(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $d1fc2464d475d011$var$e10 ? 10 : error >= $d1fc2464d475d011$var$e5 ? 5 : error >= $d1fc2464d475d011$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $d1fc2464d475d011$var$e10 ? 10 : error >= $d1fc2464d475d011$var$e5 ? 5 : error >= $d1fc2464d475d011$var$e2 ? 2 : 1);
}
function $d1fc2464d475d011$var$tickStep(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $d1fc2464d475d011$var$e10) step1 *= 10;
    else if (error >= $d1fc2464d475d011$var$e5) step1 *= 5;
    else if (error >= $d1fc2464d475d011$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});


parcelRegister("8vvB8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6319baa74d7abba6$var$thresholdSturges;

var $6319baa74d7abba6$var$_count = $6319baa74d7abba6$var$_interopRequireDefault((parcelRequire("5UTDi")));
function $6319baa74d7abba6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6319baa74d7abba6$var$thresholdSturges(values) {
    return Math.ceil(Math.log((0, $6319baa74d7abba6$var$_count.default)(values)) / Math.LN2) + 1;
}

});


parcelRegister("6lbaw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $49dd5e1811babd51$var$thresholdFreedmanDiaconis;

var $49dd5e1811babd51$var$_count = $49dd5e1811babd51$var$_interopRequireDefault((parcelRequire("5UTDi")));

var $49dd5e1811babd51$var$_quantile = $49dd5e1811babd51$var$_interopRequireDefault((parcelRequire("lpC3c")));
function $49dd5e1811babd51$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $49dd5e1811babd51$var$thresholdFreedmanDiaconis(values, min, max) {
    return Math.ceil((max - min) / (2 * ((0, $49dd5e1811babd51$var$_quantile.default)(values, 0.75) - (0, $49dd5e1811babd51$var$_quantile.default)(values, 0.25)) * Math.pow((0, $49dd5e1811babd51$var$_count.default)(values), -1 / 3)));
}

});
parcelRegister("lpC3c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f96972d924da2bc0$var$quantile;
module.exports.quantileSorted = $f96972d924da2bc0$var$quantileSorted;

var $f96972d924da2bc0$var$_max = $f96972d924da2bc0$var$_interopRequireDefault((parcelRequire("7guTq")));

var $f96972d924da2bc0$var$_min = $f96972d924da2bc0$var$_interopRequireDefault((parcelRequire("Ojec1")));

var $f96972d924da2bc0$var$_quickselect = $f96972d924da2bc0$var$_interopRequireDefault((parcelRequire("9rYw5")));

var $f96972d924da2bc0$var$_number = $f96972d924da2bc0$var$_interopRequireWildcard((parcelRequire("1SKnD")));
function $f96972d924da2bc0$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($f96972d924da2bc0$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $f96972d924da2bc0$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $f96972d924da2bc0$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $f96972d924da2bc0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f96972d924da2bc0$var$quantile(values, p, valueof) {
    values = Float64Array.from((0, $f96972d924da2bc0$var$_number.numbers)(values, valueof));
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return (0, $f96972d924da2bc0$var$_min.default)(values);
    if (p >= 1) return (0, $f96972d924da2bc0$var$_max.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, $f96972d924da2bc0$var$_max.default)((0, $f96972d924da2bc0$var$_quickselect.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, $f96972d924da2bc0$var$_min.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function $f96972d924da2bc0$var$quantileSorted(values, p, valueof = $f96972d924da2bc0$var$_number.default) {
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

});
parcelRegister("7guTq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $54a1fdbe5fbde9e3$var$max;
function $54a1fdbe5fbde9e3$var$max(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

});

parcelRegister("Ojec1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $097395e3d95d28ad$var$min;
function $097395e3d95d28ad$var$min(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

});

parcelRegister("9rYw5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6e15940108e81e0d$var$quickselect;

var $beWVB = parcelRequire("beWVB");
// Based on https://github.com/mourner/quickselect
// ISC license, Copyright 2018 Vladimir Agafonkin.
function $6e15940108e81e0d$var$quickselect(array, k, left = 0, right = array.length - 1, compare) {
    compare = compare === undefined ? $beWVB.ascendingDefined : (0, $beWVB.compareDefined)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $6e15940108e81e0d$var$quickselect(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        $6e15940108e81e0d$var$swap(array, left, k);
        if (compare(array[right], t) > 0) $6e15940108e81e0d$var$swap(array, left, right);
        while(i < j){
            $6e15940108e81e0d$var$swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) $6e15940108e81e0d$var$swap(array, left, j);
        else ++j, $6e15940108e81e0d$var$swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function $6e15940108e81e0d$var$swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}

});



parcelRegister("4NG26", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $37ec57dd31897534$var$thresholdScott;

var $37ec57dd31897534$var$_count = $37ec57dd31897534$var$_interopRequireDefault((parcelRequire("5UTDi")));

var $37ec57dd31897534$var$_deviation = $37ec57dd31897534$var$_interopRequireDefault((parcelRequire("dyvZc")));
function $37ec57dd31897534$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $37ec57dd31897534$var$thresholdScott(values, min, max) {
    return Math.ceil((max - min) * Math.cbrt((0, $37ec57dd31897534$var$_count.default)(values)) / (3.49 * (0, $37ec57dd31897534$var$_deviation.default)(values)));
}

});

parcelRegister("6IeI9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4e32437013fac5c8$var$maxIndex;
function $4e32437013fac5c8$var$maxIndex(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}

});

parcelRegister("e3bit", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a3aa1bdc5bec480e$var$mean;
function $a3aa1bdc5bec480e$var$mean(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}

});

parcelRegister("1jVc3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0f63ee38e9a58291$var$median;

var $0f63ee38e9a58291$var$_quantile = $0f63ee38e9a58291$var$_interopRequireDefault((parcelRequire("lpC3c")));
function $0f63ee38e9a58291$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0f63ee38e9a58291$var$median(values, valueof) {
    return (0, $0f63ee38e9a58291$var$_quantile.default)(values, 0.5, valueof);
}

});

parcelRegister("3ChYQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2a22de385d2860d3$var$merge;
function* $2a22de385d2860d3$var$flatten(arrays) {
    for (const array of arrays)yield* array;
}
function $2a22de385d2860d3$var$merge(arrays) {
    return Array.from($2a22de385d2860d3$var$flatten(arrays));
}

});

parcelRegister("lATcB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fb87c7cf7d29f2f4$var$minIndex;
function $fb87c7cf7d29f2f4$var$minIndex(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}

});

parcelRegister("1esF3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0e5d54bc986803d3$var$mode;

var $QUjlf = parcelRequire("QUjlf");
function $0e5d54bc986803d3$var$mode(values, valueof) {
    const counts = new $QUjlf.InternMap();
    if (valueof === undefined) {
        for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    }
    let modeValue;
    let modeCount = 0;
    for (const [value, count] of counts)if (count > modeCount) {
        modeCount = count;
        modeValue = value;
    }
    return modeValue;
}

});

parcelRegister("j18Jm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dd84e206b2456c49$var$pairs;
module.exports.pair = $dd84e206b2456c49$var$pair;
function $dd84e206b2456c49$var$pairs(values, pairof = $dd84e206b2456c49$var$pair) {
    const pairs = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs;
}
function $dd84e206b2456c49$var$pair(a, b) {
    return [
        a,
        b
    ];
}

});

parcelRegister("dGOEk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9f767c8cbd657d85$var$range;
function $9f767c8cbd657d85$var$range(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRegister("4cf4B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $30e3f9a00fe23136$var$rank;

var $30e3f9a00fe23136$var$_ascending = $30e3f9a00fe23136$var$_interopRequireDefault((parcelRequire("e3onA")));

var $beWVB = parcelRequire("beWVB");
function $30e3f9a00fe23136$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $30e3f9a00fe23136$var$rank(values, valueof = $30e3f9a00fe23136$var$_ascending.default) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    let V = Array.from(values);
    const R = new Float64Array(V.length);
    if (valueof.length !== 2) V = V.map(valueof), valueof = $30e3f9a00fe23136$var$_ascending.default;
    const compareIndex = (i, j)=>valueof(V[i], V[j]);
    let k, r;
    Uint32Array.from(V, (_, i)=>i).sort(valueof === $30e3f9a00fe23136$var$_ascending.default ? (i, j)=>(0, $beWVB.ascendingDefined)(V[i], V[j]) : (0, $beWVB.compareDefined)(compareIndex)).forEach((j, i)=>{
        const c = compareIndex(j, k === undefined ? j : k);
        if (c >= 0) {
            if (k === undefined || c > 0) k = j, r = i;
            R[j] = r;
        } else R[j] = NaN;
    });
    return R;
}

});

parcelRegister("ioACH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d646e07f208574a4$var$least;

var $d646e07f208574a4$var$_ascending = $d646e07f208574a4$var$_interopRequireDefault((parcelRequire("e3onA")));
function $d646e07f208574a4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d646e07f208574a4$var$least(values, compare = $d646e07f208574a4$var$_ascending.default) {
    let min;
    let defined = false;
    if (compare.length === 1) {
        let minValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $d646e07f208574a4$var$_ascending.default)(value, minValue) < 0 : (0, $d646e07f208574a4$var$_ascending.default)(value, value) === 0) {
                min = element;
                minValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
            min = value;
            defined = true;
        }
    }
    return min;
}

});

parcelRegister("kvmYL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $eed8870b852ef27d$var$leastIndex;

var $eed8870b852ef27d$var$_ascending = $eed8870b852ef27d$var$_interopRequireDefault((parcelRequire("e3onA")));

var $eed8870b852ef27d$var$_minIndex = $eed8870b852ef27d$var$_interopRequireDefault((parcelRequire("lATcB")));
function $eed8870b852ef27d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $eed8870b852ef27d$var$leastIndex(values, compare = $eed8870b852ef27d$var$_ascending.default) {
    if (compare.length === 1) return (0, $eed8870b852ef27d$var$_minIndex.default)(values, compare);
    let minValue;
    let min = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
            minValue = value;
            min = index;
        }
    }
    return min;
}

});

parcelRegister("6FrDQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4dac03719d2704b7$var$greatest;

var $4dac03719d2704b7$var$_ascending = $4dac03719d2704b7$var$_interopRequireDefault((parcelRequire("e3onA")));
function $4dac03719d2704b7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4dac03719d2704b7$var$greatest(values, compare = $4dac03719d2704b7$var$_ascending.default) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $4dac03719d2704b7$var$_ascending.default)(value, maxValue) > 0 : (0, $4dac03719d2704b7$var$_ascending.default)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}

});

parcelRegister("lmzh6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f8d703e683392dc9$var$greatestIndex;

var $f8d703e683392dc9$var$_ascending = $f8d703e683392dc9$var$_interopRequireDefault((parcelRequire("e3onA")));

var $f8d703e683392dc9$var$_maxIndex = $f8d703e683392dc9$var$_interopRequireDefault((parcelRequire("6IeI9")));
function $f8d703e683392dc9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f8d703e683392dc9$var$greatestIndex(values, compare = $f8d703e683392dc9$var$_ascending.default) {
    if (compare.length === 1) return (0, $f8d703e683392dc9$var$_maxIndex.default)(values, compare);
    let maxValue;
    let max = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
            maxValue = value;
            max = index;
        }
    }
    return max;
}

});

parcelRegister("jvPzw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e348eab0e04fd3f0$var$scan;

var $e348eab0e04fd3f0$var$_leastIndex = $e348eab0e04fd3f0$var$_interopRequireDefault((parcelRequire("kvmYL")));
function $e348eab0e04fd3f0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e348eab0e04fd3f0$var$scan(values, compare) {
    const index = (0, $e348eab0e04fd3f0$var$_leastIndex.default)(values, compare);
    return index < 0 ? undefined : index;
}

});

parcelRegister("5z8Bo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.shuffler = $40d6e4d3b84a4fc1$var$shuffler;
var $40d6e4d3b84a4fc1$var$_default = $40d6e4d3b84a4fc1$var$shuffler(Math.random);
module.exports.default = $40d6e4d3b84a4fc1$var$_default;
function $40d6e4d3b84a4fc1$var$shuffler(random) {
    return function shuffle(array, i0 = 0, i1 = array.length) {
        let m = i1 - (i0 = +i0);
        while(m){
            const i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}

});

parcelRegister("gQmRZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c4333e274130e91f$var$sum;
function $c4333e274130e91f$var$sum(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}

});

parcelRegister("bumB5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $85d406651d5d4cd6$var$transpose;

var $85d406651d5d4cd6$var$_min = $85d406651d5d4cd6$var$_interopRequireDefault((parcelRequire("Ojec1")));
function $85d406651d5d4cd6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $85d406651d5d4cd6$var$transpose(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $85d406651d5d4cd6$var$_min.default)(matrix, $85d406651d5d4cd6$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $85d406651d5d4cd6$var$length(d) {
    return d.length;
}

});

parcelRegister("lUZKZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ff4ebb8c8fd7f43f$var$zip;

var $ff4ebb8c8fd7f43f$var$_transpose = $ff4ebb8c8fd7f43f$var$_interopRequireDefault((parcelRequire("bumB5")));
function $ff4ebb8c8fd7f43f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ff4ebb8c8fd7f43f$var$zip() {
    return (0, $ff4ebb8c8fd7f43f$var$_transpose.default)(arguments);
}

});

parcelRegister("jhUFn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e0ab8f97aec8fb3a$var$every;
function $e0ab8f97aec8fb3a$var$every(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (!test(value, ++index, values)) return false;
    }
    return true;
}

});

parcelRegister("d04yi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $976ece6b36734d0d$var$some;
function $976ece6b36734d0d$var$some(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (test(value, ++index, values)) return true;
    }
    return false;
}

});

parcelRegister("2ehPK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $19fab8fdec7770c3$var$filter;
function $19fab8fdec7770c3$var$filter(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    const array = [];
    let index = -1;
    for (const value of values)if (test(value, ++index, values)) array.push(value);
    return array;
}

});

parcelRegister("8JivZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $65b0e36420df9fca$var$map;
function $65b0e36420df9fca$var$map(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, (value, index)=>mapper(value, index, values));
}

});

parcelRegister("eCJY6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $aa5845aa42179abf$var$reduce;
function $aa5845aa42179abf$var$reduce(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    const iterator = values[Symbol.iterator]();
    let done, next, index = -1;
    if (arguments.length < 3) {
        ({ done: done, value: value } = iterator.next());
        if (done) return;
        ++index;
    }
    while({ done: done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
    return value;
}

});

parcelRegister("9qCvR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6dd46a9aeae63a89$var$reverse;
function $6dd46a9aeae63a89$var$reverse(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

});

parcelRegister("fqTXF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b3c4b17eae703a62$var$difference;

var $QUjlf = parcelRequire("QUjlf");
function $b3c4b17eae703a62$var$difference(values, ...others) {
    values = new $QUjlf.InternSet(values);
    for (const other of others)for (const value of other)values.delete(value);
    return values;
}

});

parcelRegister("9s7cT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6e1c51bafc7b1d3f$var$disjoint;

var $QUjlf = parcelRequire("QUjlf");
function $6e1c51bafc7b1d3f$var$disjoint(values, other) {
    const iterator = other[Symbol.iterator](), set = new $QUjlf.InternSet();
    for (const v of values){
        if (set.has(v)) return false;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) break;
            if (Object.is(v, value)) return false;
            set.add(value);
        }
    }
    return true;
}

});

parcelRegister("k4QyO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e9dcf3c364836d52$var$intersection;

var $QUjlf = parcelRequire("QUjlf");
function $e9dcf3c364836d52$var$intersection(values, ...others) {
    values = new $QUjlf.InternSet(values);
    others = others.map($e9dcf3c364836d52$var$set);
    out: for (const value of values){
        for (const other of others)if (!other.has(value)) {
            values.delete(value);
            continue out;
        }
    }
    return values;
}
function $e9dcf3c364836d52$var$set(values) {
    return values instanceof $QUjlf.InternSet ? values : new $QUjlf.InternSet(values);
}

});

parcelRegister("49DZS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $30670743640fd91a$var$subset;

var $30670743640fd91a$var$_superset = $30670743640fd91a$var$_interopRequireDefault((parcelRequire("3ol0T")));
function $30670743640fd91a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $30670743640fd91a$var$subset(values, other) {
    return (0, $30670743640fd91a$var$_superset.default)(other, values);
}

});
parcelRegister("3ol0T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2783e9d0cdcfed31$var$superset;
function $2783e9d0cdcfed31$var$superset(values, other) {
    const iterator = values[Symbol.iterator](), set = new Set();
    for (const o of other){
        const io = $2783e9d0cdcfed31$var$intern(o);
        if (set.has(io)) continue;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) return false;
            const ivalue = $2783e9d0cdcfed31$var$intern(value);
            set.add(ivalue);
            if (Object.is(io, ivalue)) break;
        }
    }
    return true;
}
function $2783e9d0cdcfed31$var$intern(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});


parcelRegister("eJ7de", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ab8adcde6a83f944$var$union;

var $QUjlf = parcelRequire("QUjlf");
function $ab8adcde6a83f944$var$union(...others) {
    const set = new $QUjlf.InternSet();
    for (const other of others)for (const o of other)set.add(o);
    return set;
}

});


parcelRegister("8vtGb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.initInterpolator = $63183dabb7465785$var$initInterpolator;
module.exports.initRange = $63183dabb7465785$var$initRange;
function $63183dabb7465785$var$initRange(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $63183dabb7465785$var$initInterpolator(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

});

parcelRegister("kAUuD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $efe2fdcaf259ebea$var$ordinal;
module.exports.implicit = void 0;

var $2bySc = parcelRequire("2bySc");

var $8vtGb = parcelRequire("8vtGb");
const $efe2fdcaf259ebea$var$implicit = Symbol("implicit");
module.exports.implicit = $efe2fdcaf259ebea$var$implicit;
function $efe2fdcaf259ebea$var$ordinal() {
    var index = new $2bySc.InternMap(), domain = [], range = [], unknown = $efe2fdcaf259ebea$var$implicit;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $efe2fdcaf259ebea$var$implicit) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new $2bySc.InternMap();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $efe2fdcaf259ebea$var$ordinal(domain, range).unknown(unknown);
    };
    $8vtGb.initRange.apply(scale, arguments);
    return scale;
}

});


parcelRegister("jfp0U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e032d238ff84bef3$var$identity;

var $5bYdw = parcelRequire("5bYdw");

var $e032d238ff84bef3$var$_number = $e032d238ff84bef3$var$_interopRequireDefault((parcelRequire("23xQd")));
function $e032d238ff84bef3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e032d238ff84bef3$var$identity(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, $e032d238ff84bef3$var$_number.default), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $e032d238ff84bef3$var$identity(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, $e032d238ff84bef3$var$_number.default) : [
        0,
        1
    ];
    return (0, $5bYdw.linearish)(scale);
}

});
parcelRegister("5bYdw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3c7cb0b74724e434$var$linear;
module.exports.linearish = $3c7cb0b74724e434$var$linearish;

var $2bySc = parcelRequire("2bySc");

var $3c7cb0b74724e434$var$_continuous = $3c7cb0b74724e434$var$_interopRequireWildcard((parcelRequire("4ofCy")));

var $8vtGb = parcelRequire("8vtGb");

var $3c7cb0b74724e434$var$_tickFormat = $3c7cb0b74724e434$var$_interopRequireDefault((parcelRequire("cNYhO")));
function $3c7cb0b74724e434$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3c7cb0b74724e434$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($3c7cb0b74724e434$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $3c7cb0b74724e434$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $3c7cb0b74724e434$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $3c7cb0b74724e434$var$linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $2bySc.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $3c7cb0b74724e434$var$_tickFormat.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $2bySc.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $3c7cb0b74724e434$var$linear() {
    var scale = (0, $3c7cb0b74724e434$var$_continuous.default)();
    scale.copy = function() {
        return (0, $3c7cb0b74724e434$var$_continuous.copy)(scale, $3c7cb0b74724e434$var$linear());
    };
    $8vtGb.initRange.apply(scale, arguments);
    return $3c7cb0b74724e434$var$linearish(scale);
}

});
parcelRegister("4ofCy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $3325854a933cb0e6$var$copy;
module.exports.default = $3325854a933cb0e6$var$continuous;
module.exports.identity = $3325854a933cb0e6$var$identity;
module.exports.transformer = $3325854a933cb0e6$var$transformer;

var $2bySc = parcelRequire("2bySc");

var $8NXT9 = parcelRequire("8NXT9");

var $3325854a933cb0e6$var$_constant = $3325854a933cb0e6$var$_interopRequireDefault((parcelRequire("kR5Yc")));

var $3325854a933cb0e6$var$_number = $3325854a933cb0e6$var$_interopRequireDefault((parcelRequire("23xQd")));
function $3325854a933cb0e6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $3325854a933cb0e6$var$unit = [
    0,
    1
];
function $3325854a933cb0e6$var$identity(x) {
    return x;
}
function $3325854a933cb0e6$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $3325854a933cb0e6$var$_constant.default)(isNaN(b) ? NaN : 0.5);
}
function $3325854a933cb0e6$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
} // normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $3325854a933cb0e6$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $3325854a933cb0e6$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $3325854a933cb0e6$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $3325854a933cb0e6$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1; // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $3325854a933cb0e6$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $2bySc.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $3325854a933cb0e6$var$copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $3325854a933cb0e6$var$transformer() {
    var domain = $3325854a933cb0e6$var$unit, range = $3325854a933cb0e6$var$unit, interpolate = $8NXT9.interpolate, transform, untransform, unknown, clamp = $3325854a933cb0e6$var$identity, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $3325854a933cb0e6$var$identity) clamp = $3325854a933cb0e6$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $3325854a933cb0e6$var$polymap : $3325854a933cb0e6$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), $8NXT9.interpolateNumber)))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, $3325854a933cb0e6$var$_number.default), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = $8NXT9.interpolateRound, rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $3325854a933cb0e6$var$identity, rescale()) : clamp !== $3325854a933cb0e6$var$identity;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $3325854a933cb0e6$var$continuous() {
    return $3325854a933cb0e6$var$transformer()($3325854a933cb0e6$var$identity, $3325854a933cb0e6$var$identity);
}

});
parcelRegister("8NXT9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "interpolate", {
    enumerable: true,
    get: function() {
        return $66915af88a0d090f$var$_value.default;
    }
});
Object.defineProperty(module.exports, "interpolateArray", {
    enumerable: true,
    get: function() {
        return $66915af88a0d090f$var$_array.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasis", {
    enumerable: true,
    get: function() {
        return $66915af88a0d090f$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasisClosed", {
    enumerable: true,
    get: function() {
        return $66915af88a0d090f$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelix", {
    enumerable: true,
    get: function() {
        return $66915af88a0d090f$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelixLong", {
    enumerable: true,
    get: function() {
        return $66915af88a0d090f$var$_cubehelix.cubehelixLong;
    }
});
Object.defineProperty(module.exports, "interpolateDate", {
    enumerable: true,
    get: function() {
        return $66915af88a0d090f$var$_date.default;
    }
});
Object.defineProperty(module.exports, "interpolateDiscrete", {
    enumerable: true,
    get: function() {
        return $66915af88a0d090f$var$_discrete.default;
    }
});
Object.defineProperty(module.exports, "interpolateHcl", {
    enumerable: true,
    get: function() {
        return $66915af88a0d090f$var$_hcl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHclLong", {
    enumerable: true,
    get: function() {
        return $66915af88a0d090f$var$_hcl.hclLong;
    }
});
Object.defineProperty(module.exports, "interpolateHsl", {
    enumerable: true,
    get: function() {
        return $66915af88a0d090f$var$_hsl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHslLong", {
    enumerable: true,
    get: function() {
        return $66915af88a0d090f$var$_hsl.hslLong;
    }
});
Object.defineProperty(module.exports, "interpolateHue", {
    enumerable: true,
    get: function() {
        return $66915af88a0d090f$var$_hue.default;
    }
});
Object.defineProperty(module.exports, "interpolateLab", {
    enumerable: true,
    get: function() {
        return $66915af88a0d090f$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumber", {
    enumerable: true,
    get: function() {
        return $66915af88a0d090f$var$_number.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumberArray", {
    enumerable: true,
    get: function() {
        return $66915af88a0d090f$var$_numberArray.default;
    }
});
Object.defineProperty(module.exports, "interpolateObject", {
    enumerable: true,
    get: function() {
        return $66915af88a0d090f$var$_object.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgb", {
    enumerable: true,
    get: function() {
        return $66915af88a0d090f$var$_rgb.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasis", {
    enumerable: true,
    get: function() {
        return $66915af88a0d090f$var$_rgb.rgbBasis;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasisClosed", {
    enumerable: true,
    get: function() {
        return $66915af88a0d090f$var$_rgb.rgbBasisClosed;
    }
});
Object.defineProperty(module.exports, "interpolateRound", {
    enumerable: true,
    get: function() {
        return $66915af88a0d090f$var$_round.default;
    }
});
Object.defineProperty(module.exports, "interpolateString", {
    enumerable: true,
    get: function() {
        return $66915af88a0d090f$var$_string.default;
    }
});
Object.defineProperty(module.exports, "interpolateTransformCss", {
    enumerable: true,
    get: function() {
        return $hQjiP.interpolateTransformCss;
    }
});
Object.defineProperty(module.exports, "interpolateTransformSvg", {
    enumerable: true,
    get: function() {
        return $hQjiP.interpolateTransformSvg;
    }
});
Object.defineProperty(module.exports, "interpolateZoom", {
    enumerable: true,
    get: function() {
        return $66915af88a0d090f$var$_zoom.default;
    }
});
Object.defineProperty(module.exports, "piecewise", {
    enumerable: true,
    get: function() {
        return $66915af88a0d090f$var$_piecewise.default;
    }
});
Object.defineProperty(module.exports, "quantize", {
    enumerable: true,
    get: function() {
        return $66915af88a0d090f$var$_quantize.default;
    }
});

var $66915af88a0d090f$var$_value = $66915af88a0d090f$var$_interopRequireDefault((parcelRequire("9W099")));

var $66915af88a0d090f$var$_array = $66915af88a0d090f$var$_interopRequireDefault((parcelRequire("iHsbP")));

var $66915af88a0d090f$var$_basis = $66915af88a0d090f$var$_interopRequireDefault((parcelRequire("b1bOb")));

var $66915af88a0d090f$var$_basisClosed = $66915af88a0d090f$var$_interopRequireDefault((parcelRequire("jceqk")));

var $66915af88a0d090f$var$_date = $66915af88a0d090f$var$_interopRequireDefault((parcelRequire("8OgE0")));

var $66915af88a0d090f$var$_discrete = $66915af88a0d090f$var$_interopRequireDefault((parcelRequire("9NMDm")));

var $66915af88a0d090f$var$_hue = $66915af88a0d090f$var$_interopRequireDefault((parcelRequire("2qMsl")));

var $66915af88a0d090f$var$_number = $66915af88a0d090f$var$_interopRequireDefault((parcelRequire("gOyNP")));

var $66915af88a0d090f$var$_numberArray = $66915af88a0d090f$var$_interopRequireDefault((parcelRequire("6luBV")));

var $66915af88a0d090f$var$_object = $66915af88a0d090f$var$_interopRequireDefault((parcelRequire("11AEI")));

var $66915af88a0d090f$var$_round = $66915af88a0d090f$var$_interopRequireDefault((parcelRequire("gANCJ")));

var $66915af88a0d090f$var$_string = $66915af88a0d090f$var$_interopRequireDefault((parcelRequire("b6ieu")));

var $hQjiP = parcelRequire("hQjiP");

var $66915af88a0d090f$var$_zoom = $66915af88a0d090f$var$_interopRequireDefault((parcelRequire("k0cFD")));

var $66915af88a0d090f$var$_rgb = $66915af88a0d090f$var$_interopRequireWildcard((parcelRequire("5dNnf")));

var $66915af88a0d090f$var$_hsl = $66915af88a0d090f$var$_interopRequireWildcard((parcelRequire("c9JZg")));

var $66915af88a0d090f$var$_lab = $66915af88a0d090f$var$_interopRequireDefault((parcelRequire("g5xj4")));

var $66915af88a0d090f$var$_hcl = $66915af88a0d090f$var$_interopRequireWildcard((parcelRequire("lvACH")));

var $66915af88a0d090f$var$_cubehelix = $66915af88a0d090f$var$_interopRequireWildcard((parcelRequire("1B6XZ")));

var $66915af88a0d090f$var$_piecewise = $66915af88a0d090f$var$_interopRequireDefault((parcelRequire("lGL4X")));

var $66915af88a0d090f$var$_quantize = $66915af88a0d090f$var$_interopRequireDefault((parcelRequire("87M3t")));
function $66915af88a0d090f$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($66915af88a0d090f$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $66915af88a0d090f$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $66915af88a0d090f$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $66915af88a0d090f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("9W099", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $73b9a4f3845aeb0d$var$_default;

var $LtbBW = parcelRequire("LtbBW");

var $73b9a4f3845aeb0d$var$_rgb = $73b9a4f3845aeb0d$var$_interopRequireDefault((parcelRequire("5dNnf")));

var $iHsbP = parcelRequire("iHsbP");

var $73b9a4f3845aeb0d$var$_date = $73b9a4f3845aeb0d$var$_interopRequireDefault((parcelRequire("8OgE0")));

var $73b9a4f3845aeb0d$var$_number = $73b9a4f3845aeb0d$var$_interopRequireDefault((parcelRequire("gOyNP")));

var $73b9a4f3845aeb0d$var$_object = $73b9a4f3845aeb0d$var$_interopRequireDefault((parcelRequire("11AEI")));

var $73b9a4f3845aeb0d$var$_string = $73b9a4f3845aeb0d$var$_interopRequireDefault((parcelRequire("b6ieu")));

var $73b9a4f3845aeb0d$var$_constant = $73b9a4f3845aeb0d$var$_interopRequireDefault((parcelRequire("lM4SR")));

var $73b9a4f3845aeb0d$var$_numberArray = $73b9a4f3845aeb0d$var$_interopRequireWildcard((parcelRequire("6luBV")));
function $73b9a4f3845aeb0d$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($73b9a4f3845aeb0d$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $73b9a4f3845aeb0d$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $73b9a4f3845aeb0d$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $73b9a4f3845aeb0d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $73b9a4f3845aeb0d$var$_default(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $73b9a4f3845aeb0d$var$_constant.default)(b) : (t === "number" ? $73b9a4f3845aeb0d$var$_number.default : t === "string" ? (c = (0, $LtbBW.color)(b)) ? (b = c, $73b9a4f3845aeb0d$var$_rgb.default) : $73b9a4f3845aeb0d$var$_string.default : b instanceof $LtbBW.color ? $73b9a4f3845aeb0d$var$_rgb.default : b instanceof Date ? $73b9a4f3845aeb0d$var$_date.default : (0, $73b9a4f3845aeb0d$var$_numberArray.isNumberArray)(b) ? $73b9a4f3845aeb0d$var$_numberArray.default : Array.isArray(b) ? $iHsbP.genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? $73b9a4f3845aeb0d$var$_object.default : $73b9a4f3845aeb0d$var$_number.default)(a, b);
}

});
parcelRegister("LtbBW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "color", {
    enumerable: true,
    get: function() {
        return $08eb07afe0e07f8b$var$_color.default;
    }
});
Object.defineProperty(module.exports, "cubehelix", {
    enumerable: true,
    get: function() {
        return $08eb07afe0e07f8b$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "gray", {
    enumerable: true,
    get: function() {
        return $08eb07afe0e07f8b$var$_lab.gray;
    }
});
Object.defineProperty(module.exports, "hcl", {
    enumerable: true,
    get: function() {
        return $08eb07afe0e07f8b$var$_lab.hcl;
    }
});
Object.defineProperty(module.exports, "hsl", {
    enumerable: true,
    get: function() {
        return $08eb07afe0e07f8b$var$_color.hsl;
    }
});
Object.defineProperty(module.exports, "lab", {
    enumerable: true,
    get: function() {
        return $08eb07afe0e07f8b$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "lch", {
    enumerable: true,
    get: function() {
        return $08eb07afe0e07f8b$var$_lab.lch;
    }
});
Object.defineProperty(module.exports, "rgb", {
    enumerable: true,
    get: function() {
        return $08eb07afe0e07f8b$var$_color.rgb;
    }
});

var $08eb07afe0e07f8b$var$_color = $08eb07afe0e07f8b$var$_interopRequireWildcard((parcelRequire("gXeFn")));

var $08eb07afe0e07f8b$var$_lab = $08eb07afe0e07f8b$var$_interopRequireWildcard((parcelRequire("9EMxD")));

var $08eb07afe0e07f8b$var$_cubehelix = $08eb07afe0e07f8b$var$_interopRequireDefault((parcelRequire("caugz")));
function $08eb07afe0e07f8b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $08eb07afe0e07f8b$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($08eb07afe0e07f8b$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $08eb07afe0e07f8b$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $08eb07afe0e07f8b$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("gXeFn", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Color = Color;
exports.Rgb = Rgb;
exports.darker = exports.brighter = void 0;
exports.default = color;
exports.hsl = hsl;
exports.hslConvert = hslConvert;
exports.rgb = rgb;
exports.rgbConvert = rgbConvert;

var _define = _interopRequireWildcard((parcelRequire("8iQLH")));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function Color() {}
var darker = 0.7;
exports.darker = darker;
var brighter = 1 / darker;
exports.brighter = brighter;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _define.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor(), this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb();
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _define.default)(Rgb, rgb, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl();
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _define.default)(Hsl, hsl, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("8iQLH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $60b8efde9d2bf50b$var$_default;
module.exports.extend = $60b8efde9d2bf50b$var$extend;
function $60b8efde9d2bf50b$var$_default(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $60b8efde9d2bf50b$var$extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("9EMxD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hcl = $707d80d5e0f6f01d$var$Hcl;
module.exports.Lab = $707d80d5e0f6f01d$var$Lab;
module.exports.default = $707d80d5e0f6f01d$var$lab;
module.exports.gray = $707d80d5e0f6f01d$var$gray;
module.exports.hcl = $707d80d5e0f6f01d$var$hcl;
module.exports.lch = $707d80d5e0f6f01d$var$lch;

var $707d80d5e0f6f01d$var$_define = $707d80d5e0f6f01d$var$_interopRequireWildcard((parcelRequire("8iQLH")));

var $gXeFn = parcelRequire("gXeFn");

var $ltRKN = parcelRequire("ltRKN");
function $707d80d5e0f6f01d$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($707d80d5e0f6f01d$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $707d80d5e0f6f01d$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $707d80d5e0f6f01d$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
// https://observablehq.com/@mbostock/lab-and-rgb
const $707d80d5e0f6f01d$var$K = 18, $707d80d5e0f6f01d$var$Xn = 0.96422, $707d80d5e0f6f01d$var$Yn = 1, $707d80d5e0f6f01d$var$Zn = 0.82521, $707d80d5e0f6f01d$var$t0 = 4 / 29, $707d80d5e0f6f01d$var$t1 = 6 / 29, $707d80d5e0f6f01d$var$t2 = 3 * $707d80d5e0f6f01d$var$t1 * $707d80d5e0f6f01d$var$t1, $707d80d5e0f6f01d$var$t3 = $707d80d5e0f6f01d$var$t1 * $707d80d5e0f6f01d$var$t1 * $707d80d5e0f6f01d$var$t1;
function $707d80d5e0f6f01d$var$labConvert(o) {
    if (o instanceof $707d80d5e0f6f01d$var$Lab) return new $707d80d5e0f6f01d$var$Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof $707d80d5e0f6f01d$var$Hcl) return $707d80d5e0f6f01d$var$hcl2lab(o);
    if (!(o instanceof $gXeFn.Rgb)) o = (0, $gXeFn.rgbConvert)(o);
    var r = $707d80d5e0f6f01d$var$rgb2lrgb(o.r), g = $707d80d5e0f6f01d$var$rgb2lrgb(o.g), b = $707d80d5e0f6f01d$var$rgb2lrgb(o.b), y = $707d80d5e0f6f01d$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $707d80d5e0f6f01d$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $707d80d5e0f6f01d$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $707d80d5e0f6f01d$var$Xn);
        z = $707d80d5e0f6f01d$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $707d80d5e0f6f01d$var$Zn);
    }
    return new $707d80d5e0f6f01d$var$Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $707d80d5e0f6f01d$var$gray(l, opacity) {
    return new $707d80d5e0f6f01d$var$Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function $707d80d5e0f6f01d$var$lab(l, a, b, opacity) {
    return arguments.length === 1 ? $707d80d5e0f6f01d$var$labConvert(l) : new $707d80d5e0f6f01d$var$Lab(l, a, b, opacity == null ? 1 : opacity);
}
function $707d80d5e0f6f01d$var$Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $707d80d5e0f6f01d$var$_define.default)($707d80d5e0f6f01d$var$Lab, $707d80d5e0f6f01d$var$lab, (0, $707d80d5e0f6f01d$var$_define.extend)($gXeFn.Color, {
    brighter (k) {
        return new $707d80d5e0f6f01d$var$Lab(this.l + $707d80d5e0f6f01d$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new $707d80d5e0f6f01d$var$Lab(this.l - $707d80d5e0f6f01d$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $707d80d5e0f6f01d$var$Xn * $707d80d5e0f6f01d$var$lab2xyz(x);
        y = $707d80d5e0f6f01d$var$Yn * $707d80d5e0f6f01d$var$lab2xyz(y);
        z = $707d80d5e0f6f01d$var$Zn * $707d80d5e0f6f01d$var$lab2xyz(z);
        return new $gXeFn.Rgb($707d80d5e0f6f01d$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $707d80d5e0f6f01d$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $707d80d5e0f6f01d$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $707d80d5e0f6f01d$var$xyz2lab(t) {
    return t > $707d80d5e0f6f01d$var$t3 ? Math.pow(t, 1 / 3) : t / $707d80d5e0f6f01d$var$t2 + $707d80d5e0f6f01d$var$t0;
}
function $707d80d5e0f6f01d$var$lab2xyz(t) {
    return t > $707d80d5e0f6f01d$var$t1 ? t * t * t : $707d80d5e0f6f01d$var$t2 * (t - $707d80d5e0f6f01d$var$t0);
}
function $707d80d5e0f6f01d$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $707d80d5e0f6f01d$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $707d80d5e0f6f01d$var$hclConvert(o) {
    if (o instanceof $707d80d5e0f6f01d$var$Hcl) return new $707d80d5e0f6f01d$var$Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $707d80d5e0f6f01d$var$Lab)) o = $707d80d5e0f6f01d$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $707d80d5e0f6f01d$var$Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * $ltRKN.degrees;
    return new $707d80d5e0f6f01d$var$Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $707d80d5e0f6f01d$var$lch(l, c, h, opacity) {
    return arguments.length === 1 ? $707d80d5e0f6f01d$var$hclConvert(l) : new $707d80d5e0f6f01d$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $707d80d5e0f6f01d$var$hcl(h, c, l, opacity) {
    return arguments.length === 1 ? $707d80d5e0f6f01d$var$hclConvert(h) : new $707d80d5e0f6f01d$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $707d80d5e0f6f01d$var$Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $707d80d5e0f6f01d$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $707d80d5e0f6f01d$var$Lab(o.l, 0, 0, o.opacity);
    var h = o.h * $ltRKN.radians;
    return new $707d80d5e0f6f01d$var$Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $707d80d5e0f6f01d$var$_define.default)($707d80d5e0f6f01d$var$Hcl, $707d80d5e0f6f01d$var$hcl, (0, $707d80d5e0f6f01d$var$_define.extend)($gXeFn.Color, {
    brighter (k) {
        return new $707d80d5e0f6f01d$var$Hcl(this.h, this.c, this.l + $707d80d5e0f6f01d$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new $707d80d5e0f6f01d$var$Hcl(this.h, this.c, this.l - $707d80d5e0f6f01d$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return $707d80d5e0f6f01d$var$hcl2lab(this).rgb();
    }
}));

});
parcelRegister("ltRKN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.radians = module.exports.degrees = void 0;
const $fa3600c76930e9b9$var$radians = Math.PI / 180;
module.exports.radians = $fa3600c76930e9b9$var$radians;
const $fa3600c76930e9b9$var$degrees = 180 / Math.PI;
module.exports.degrees = $fa3600c76930e9b9$var$degrees;

});


parcelRegister("caugz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cubehelix = $8dbde578767a9101$var$Cubehelix;
module.exports.default = $8dbde578767a9101$var$cubehelix;

var $8dbde578767a9101$var$_define = $8dbde578767a9101$var$_interopRequireWildcard((parcelRequire("8iQLH")));

var $gXeFn = parcelRequire("gXeFn");

var $ltRKN = parcelRequire("ltRKN");
function $8dbde578767a9101$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($8dbde578767a9101$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $8dbde578767a9101$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $8dbde578767a9101$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $8dbde578767a9101$var$A = -0.14861, $8dbde578767a9101$var$B = 1.78277, $8dbde578767a9101$var$C = -0.29227, $8dbde578767a9101$var$D = -0.90649, $8dbde578767a9101$var$E = 1.97294, $8dbde578767a9101$var$ED = $8dbde578767a9101$var$E * $8dbde578767a9101$var$D, $8dbde578767a9101$var$EB = $8dbde578767a9101$var$E * $8dbde578767a9101$var$B, $8dbde578767a9101$var$BC_DA = $8dbde578767a9101$var$B * $8dbde578767a9101$var$C - $8dbde578767a9101$var$D * $8dbde578767a9101$var$A;
function $8dbde578767a9101$var$cubehelixConvert(o) {
    if (o instanceof $8dbde578767a9101$var$Cubehelix) return new $8dbde578767a9101$var$Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof $gXeFn.Rgb)) o = (0, $gXeFn.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($8dbde578767a9101$var$BC_DA * b + $8dbde578767a9101$var$ED * r - $8dbde578767a9101$var$EB * g) / ($8dbde578767a9101$var$BC_DA + $8dbde578767a9101$var$ED - $8dbde578767a9101$var$EB), bl = b - l, k = ($8dbde578767a9101$var$E * (g - l) - $8dbde578767a9101$var$C * bl) / $8dbde578767a9101$var$D, s = Math.sqrt(k * k + bl * bl) / ($8dbde578767a9101$var$E * l * (1 - l)), // NaN if l=0 or l=1
    h = s ? Math.atan2(k, bl) * $ltRKN.degrees - 120 : NaN;
    return new $8dbde578767a9101$var$Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $8dbde578767a9101$var$cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? $8dbde578767a9101$var$cubehelixConvert(h) : new $8dbde578767a9101$var$Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function $8dbde578767a9101$var$Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $8dbde578767a9101$var$_define.default)($8dbde578767a9101$var$Cubehelix, $8dbde578767a9101$var$cubehelix, (0, $8dbde578767a9101$var$_define.extend)($gXeFn.Color, {
    brighter (k) {
        k = k == null ? $gXeFn.brighter : Math.pow($gXeFn.brighter, k);
        return new $8dbde578767a9101$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? $gXeFn.darker : Math.pow($gXeFn.darker, k);
        return new $8dbde578767a9101$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * $ltRKN.radians, l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new $gXeFn.Rgb(255 * (l + a * ($8dbde578767a9101$var$A * cosh + $8dbde578767a9101$var$B * sinh)), 255 * (l + a * ($8dbde578767a9101$var$C * cosh + $8dbde578767a9101$var$D * sinh)), 255 * (l + a * ($8dbde578767a9101$var$E * cosh)), this.opacity);
    }
}));

});


parcelRegister("5dNnf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rgbBasisClosed = module.exports.rgbBasis = module.exports.default = void 0;

var $LtbBW = parcelRequire("LtbBW");

var $3cd4774b411c97fd$var$_basis = $3cd4774b411c97fd$var$_interopRequireDefault((parcelRequire("b1bOb")));

var $3cd4774b411c97fd$var$_basisClosed = $3cd4774b411c97fd$var$_interopRequireDefault((parcelRequire("jceqk")));

var $3cd4774b411c97fd$var$_color = $3cd4774b411c97fd$var$_interopRequireWildcard((parcelRequire("dz00K")));
function $3cd4774b411c97fd$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($3cd4774b411c97fd$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $3cd4774b411c97fd$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $3cd4774b411c97fd$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $3cd4774b411c97fd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $3cd4774b411c97fd$var$_default = function rgbGamma(y) {
    var color = (0, $3cd4774b411c97fd$var$_color.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $LtbBW.rgb)(start)).r, (end = (0, $LtbBW.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $3cd4774b411c97fd$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
module.exports.default = $3cd4774b411c97fd$var$_default;
function $3cd4774b411c97fd$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $LtbBW.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $3cd4774b411c97fd$var$rgbBasis = $3cd4774b411c97fd$var$rgbSpline($3cd4774b411c97fd$var$_basis.default);
module.exports.rgbBasis = $3cd4774b411c97fd$var$rgbBasis;
var $3cd4774b411c97fd$var$rgbBasisClosed = $3cd4774b411c97fd$var$rgbSpline($3cd4774b411c97fd$var$_basisClosed.default);
module.exports.rgbBasisClosed = $3cd4774b411c97fd$var$rgbBasisClosed;

});
parcelRegister("b1bOb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.basis = $8058f2a201e37af8$var$basis;
module.exports.default = $8058f2a201e37af8$var$_default;
function $8058f2a201e37af8$var$basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $8058f2a201e37af8$var$_default(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $8058f2a201e37af8$var$basis((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("jceqk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $df9a53928b0cae97$var$_default;

var $b1bOb = parcelRequire("b1bOb");
function $df9a53928b0cae97$var$_default(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $b1bOb.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("dz00K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9dfe8d6db1ed4cad$var$nogamma;
module.exports.gamma = $9dfe8d6db1ed4cad$var$gamma;
module.exports.hue = $9dfe8d6db1ed4cad$var$hue;

var $9dfe8d6db1ed4cad$var$_constant = $9dfe8d6db1ed4cad$var$_interopRequireDefault((parcelRequire("lM4SR")));
function $9dfe8d6db1ed4cad$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9dfe8d6db1ed4cad$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $9dfe8d6db1ed4cad$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $9dfe8d6db1ed4cad$var$hue(a, b) {
    var d = b - a;
    return d ? $9dfe8d6db1ed4cad$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $9dfe8d6db1ed4cad$var$_constant.default)(isNaN(a) ? b : a);
}
function $9dfe8d6db1ed4cad$var$gamma(y) {
    return (y = +y) === 1 ? $9dfe8d6db1ed4cad$var$nogamma : function(a, b) {
        return b - a ? $9dfe8d6db1ed4cad$var$exponential(a, b, y) : (0, $9dfe8d6db1ed4cad$var$_constant.default)(isNaN(a) ? b : a);
    };
}
function $9dfe8d6db1ed4cad$var$nogamma(a, b) {
    var d = b - a;
    return d ? $9dfe8d6db1ed4cad$var$linear(a, d) : (0, $9dfe8d6db1ed4cad$var$_constant.default)(isNaN(a) ? b : a);
}

});
parcelRegister("lM4SR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $fda1de822123f4ac$var$_default = (x)=>()=>x;
module.exports.default = $fda1de822123f4ac$var$_default;

});



parcelRegister("iHsbP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0383638c90e21aaa$var$_default;
module.exports.genericArray = $0383638c90e21aaa$var$genericArray;

var $0383638c90e21aaa$var$_value = $0383638c90e21aaa$var$_interopRequireDefault((parcelRequire("9W099")));

var $0383638c90e21aaa$var$_numberArray = $0383638c90e21aaa$var$_interopRequireWildcard((parcelRequire("6luBV")));
function $0383638c90e21aaa$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($0383638c90e21aaa$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $0383638c90e21aaa$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $0383638c90e21aaa$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $0383638c90e21aaa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0383638c90e21aaa$var$_default(a, b) {
    return ((0, $0383638c90e21aaa$var$_numberArray.isNumberArray)(b) ? $0383638c90e21aaa$var$_numberArray.default : $0383638c90e21aaa$var$genericArray)(a, b);
}
function $0383638c90e21aaa$var$genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $0383638c90e21aaa$var$_value.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRegister("6luBV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $49ec72de6b48ff07$var$_default;
module.exports.isNumberArray = $49ec72de6b48ff07$var$isNumberArray;
function $49ec72de6b48ff07$var$_default(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $49ec72de6b48ff07$var$isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRegister("8OgE0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $669fe7733d5b631c$var$_default;
function $669fe7733d5b631c$var$_default(a, b) {
    var d = new Date();
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRegister("gOyNP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c3dc4ff24071c629$var$_default;
function $c3dc4ff24071c629$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("11AEI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0bf2517fdda207c5$var$_default;

var $0bf2517fdda207c5$var$_value = $0bf2517fdda207c5$var$_interopRequireDefault((parcelRequire("9W099")));
function $0bf2517fdda207c5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0bf2517fdda207c5$var$_default(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $0bf2517fdda207c5$var$_value.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRegister("b6ieu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $814e65e81e88c53e$var$_default;

var $814e65e81e88c53e$var$_number = $814e65e81e88c53e$var$_interopRequireDefault((parcelRequire("gOyNP")));
function $814e65e81e88c53e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $814e65e81e88c53e$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $814e65e81e88c53e$var$reB = new RegExp($814e65e81e88c53e$var$reA.source, "g");
function $814e65e81e88c53e$var$zero(b) {
    return function() {
        return b;
    };
}
function $814e65e81e88c53e$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $814e65e81e88c53e$var$_default(a, b) {
    var bi = $814e65e81e88c53e$var$reA.lastIndex = $814e65e81e88c53e$var$reB.lastIndex = 0, // scan index for next number in b
    am, // current match in a
    bm, // current match in b
    bs, // string preceding current number in b, if any
    i = -1, // index in s
    s = [], // string constants and placeholders
    q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + ""; // Interpolate pairs of numbers in a & b.
    while((am = $814e65e81e88c53e$var$reA.exec(a)) && (bm = $814e65e81e88c53e$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            // a string precedes the next number in b
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            // numbers in a & b match
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            // interpolate non-matching numbers
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $814e65e81e88c53e$var$_number.default)(am, bm)
            });
        }
        bi = $814e65e81e88c53e$var$reB.lastIndex;
    } // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    } // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $814e65e81e88c53e$var$one(q[0].x) : $814e65e81e88c53e$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRegister("9NMDm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $722e6a597b20e739$var$_default;
function $722e6a597b20e739$var$_default(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}

});

parcelRegister("2qMsl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1c5398d9cfbbd086$var$_default;

var $dz00K = parcelRequire("dz00K");
function $1c5398d9cfbbd086$var$_default(a, b) {
    var i = (0, $dz00K.hue)(+a, +b);
    return function(t) {
        var x = i(t);
        return x - 360 * Math.floor(x / 360);
    };
}

});

parcelRegister("gANCJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c146806158ddf119$var$_default;
function $c146806158ddf119$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

});

parcelRegister("hQjiP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTransformSvg = module.exports.interpolateTransformCss = void 0;

var $cfd644211cb234b7$var$_number = $cfd644211cb234b7$var$_interopRequireDefault((parcelRequire("gOyNP")));

var $jXCuP = parcelRequire("jXCuP");
function $cfd644211cb234b7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cfd644211cb234b7$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $cfd644211cb234b7$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $cfd644211cb234b7$var$_number.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $cfd644211cb234b7$var$_number.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $cfd644211cb234b7$var$_number.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $cfd644211cb234b7$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $cfd644211cb234b7$var$_number.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], // string constants and placeholders
        q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $cfd644211cb234b7$var$interpolateTransformCss = $cfd644211cb234b7$var$interpolateTransform($jXCuP.parseCss, "px, ", "px)", "deg)");
module.exports.interpolateTransformCss = $cfd644211cb234b7$var$interpolateTransformCss;
var $cfd644211cb234b7$var$interpolateTransformSvg = $cfd644211cb234b7$var$interpolateTransform($jXCuP.parseSvg, ", ", ")", ")");
module.exports.interpolateTransformSvg = $cfd644211cb234b7$var$interpolateTransformSvg;

});
parcelRegister("jXCuP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseCss = $e8816395b54c879e$var$parseCss;
module.exports.parseSvg = $e8816395b54c879e$var$parseSvg;

var $e8816395b54c879e$var$_decompose = $e8816395b54c879e$var$_interopRequireWildcard((parcelRequire("lrpMv")));
function $e8816395b54c879e$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($e8816395b54c879e$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $e8816395b54c879e$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $e8816395b54c879e$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $e8816395b54c879e$var$svgNode;
/* eslint-disable no-undef */ function $e8816395b54c879e$var$parseCss(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? $e8816395b54c879e$var$_decompose.identity : (0, $e8816395b54c879e$var$_decompose.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $e8816395b54c879e$var$parseSvg(value) {
    if (value == null) return $e8816395b54c879e$var$_decompose.identity;
    if (!$e8816395b54c879e$var$svgNode) $e8816395b54c879e$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $e8816395b54c879e$var$svgNode.setAttribute("transform", value);
    if (!(value = $e8816395b54c879e$var$svgNode.transform.baseVal.consolidate())) return $e8816395b54c879e$var$_decompose.identity;
    value = value.matrix;
    return (0, $e8816395b54c879e$var$_decompose.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

});
parcelRegister("lrpMv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f9c01e3c249d5b81$var$_default;
module.exports.identity = void 0;
var $f9c01e3c249d5b81$var$degrees = 180 / Math.PI;
var $f9c01e3c249d5b81$var$identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
module.exports.identity = $f9c01e3c249d5b81$var$identity;
function $f9c01e3c249d5b81$var$_default(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $f9c01e3c249d5b81$var$degrees,
        skewX: Math.atan(skewX) * $f9c01e3c249d5b81$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

});



parcelRegister("k0cFD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $e8fda2da37dcdaca$var$epsilon2 = 1e-12;
function $e8fda2da37dcdaca$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $e8fda2da37dcdaca$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $e8fda2da37dcdaca$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $e8fda2da37dcdaca$var$_default = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S; // Special case for u0 ≅ u1.
        if (d2 < $e8fda2da37dcdaca$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $e8fda2da37dcdaca$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $e8fda2da37dcdaca$var$tanh(rho * s + r0) - $e8fda2da37dcdaca$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $e8fda2da37dcdaca$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);
module.exports.default = $e8fda2da37dcdaca$var$_default;

});

parcelRegister("c9JZg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hslLong = module.exports.default = void 0;

var $LtbBW = parcelRequire("LtbBW");

var $8d99ff678d92e189$var$_color = $8d99ff678d92e189$var$_interopRequireWildcard((parcelRequire("dz00K")));
function $8d99ff678d92e189$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($8d99ff678d92e189$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $8d99ff678d92e189$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $8d99ff678d92e189$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $8d99ff678d92e189$var$hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $LtbBW.hsl)(start)).h, (end = (0, $LtbBW.hsl)(end)).h), s = (0, $8d99ff678d92e189$var$_color.default)(start.s, end.s), l = (0, $8d99ff678d92e189$var$_color.default)(start.l, end.l), opacity = (0, $8d99ff678d92e189$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $8d99ff678d92e189$var$_default = $8d99ff678d92e189$var$hsl($8d99ff678d92e189$var$_color.hue);
module.exports.default = $8d99ff678d92e189$var$_default;
var $8d99ff678d92e189$var$hslLong = $8d99ff678d92e189$var$hsl($8d99ff678d92e189$var$_color.default);
module.exports.hslLong = $8d99ff678d92e189$var$hslLong;

});

parcelRegister("g5xj4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bb66f2fb1dc862b3$var$lab;

var $LtbBW = parcelRequire("LtbBW");

var $bb66f2fb1dc862b3$var$_color = $bb66f2fb1dc862b3$var$_interopRequireDefault((parcelRequire("dz00K")));
function $bb66f2fb1dc862b3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bb66f2fb1dc862b3$var$lab(start, end) {
    var l = (0, $bb66f2fb1dc862b3$var$_color.default)((start = (0, $LtbBW.lab)(start)).l, (end = (0, $LtbBW.lab)(end)).l), a = (0, $bb66f2fb1dc862b3$var$_color.default)(start.a, end.a), b = (0, $bb66f2fb1dc862b3$var$_color.default)(start.b, end.b), opacity = (0, $bb66f2fb1dc862b3$var$_color.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

});

parcelRegister("lvACH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hclLong = module.exports.default = void 0;

var $LtbBW = parcelRequire("LtbBW");

var $fa88e6d7517f899f$var$_color = $fa88e6d7517f899f$var$_interopRequireWildcard((parcelRequire("dz00K")));
function $fa88e6d7517f899f$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($fa88e6d7517f899f$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $fa88e6d7517f899f$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $fa88e6d7517f899f$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $fa88e6d7517f899f$var$hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $LtbBW.hcl)(start)).h, (end = (0, $LtbBW.hcl)(end)).h), c = (0, $fa88e6d7517f899f$var$_color.default)(start.c, end.c), l = (0, $fa88e6d7517f899f$var$_color.default)(start.l, end.l), opacity = (0, $fa88e6d7517f899f$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $fa88e6d7517f899f$var$_default = $fa88e6d7517f899f$var$hcl($fa88e6d7517f899f$var$_color.hue);
module.exports.default = $fa88e6d7517f899f$var$_default;
var $fa88e6d7517f899f$var$hclLong = $fa88e6d7517f899f$var$hcl($fa88e6d7517f899f$var$_color.default);
module.exports.hclLong = $fa88e6d7517f899f$var$hclLong;

});

parcelRegister("1B6XZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.cubehelixLong = void 0;

var $LtbBW = parcelRequire("LtbBW");

var $129ea68e97fc7a06$var$_color = $129ea68e97fc7a06$var$_interopRequireWildcard((parcelRequire("dz00K")));
function $129ea68e97fc7a06$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($129ea68e97fc7a06$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $129ea68e97fc7a06$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $129ea68e97fc7a06$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $129ea68e97fc7a06$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $LtbBW.cubehelix)(start)).h, (end = (0, $LtbBW.cubehelix)(end)).h), s = (0, $129ea68e97fc7a06$var$_color.default)(start.s, end.s), l = (0, $129ea68e97fc7a06$var$_color.default)(start.l, end.l), opacity = (0, $129ea68e97fc7a06$var$_color.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $129ea68e97fc7a06$var$_default = $129ea68e97fc7a06$var$cubehelix($129ea68e97fc7a06$var$_color.hue);
module.exports.default = $129ea68e97fc7a06$var$_default;
var $129ea68e97fc7a06$var$cubehelixLong = $129ea68e97fc7a06$var$cubehelix($129ea68e97fc7a06$var$_color.default);
module.exports.cubehelixLong = $129ea68e97fc7a06$var$cubehelixLong;

});

parcelRegister("lGL4X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fca20a1a7e96d91d$var$piecewise;

var $fca20a1a7e96d91d$var$_value = $fca20a1a7e96d91d$var$_interopRequireDefault((parcelRequire("9W099")));
function $fca20a1a7e96d91d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fca20a1a7e96d91d$var$piecewise(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = $fca20a1a7e96d91d$var$_value.default;
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

});

parcelRegister("87M3t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5ea440ecdf6b4b9d$var$_default;
function $5ea440ecdf6b4b9d$var$_default(interpolator, n) {
    var samples = new Array(n);
    for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
    return samples;
}

});


parcelRegister("kR5Yc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f2ed63653ea38fa4$var$constants;
function $f2ed63653ea38fa4$var$constants(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("23xQd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $17f61cbad9db3ee0$var$number;
function $17f61cbad9db3ee0$var$number(x) {
    return +x;
}

});


parcelRegister("cNYhO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9528d33e138bd002$var$tickFormat;

var $2bySc = parcelRequire("2bySc");

var $7i2IB = parcelRequire("7i2IB");
function $9528d33e138bd002$var$tickFormat(start, stop, count, specifier) {
    var step = (0, $2bySc.tickStep)(start, stop, count), precision;
    specifier = (0, $7i2IB.formatSpecifier)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $7i2IB.precisionPrefix)(step, value))) specifier.precision = precision;
            return (0, $7i2IB.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $7i2IB.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $7i2IB.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $7i2IB.format)(specifier);
}

});
parcelRegister("7i2IB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "FormatSpecifier", {
    enumerable: true,
    get: function() {
        return $54ec52adb849a69b$var$_formatSpecifier.FormatSpecifier;
    }
});
Object.defineProperty(module.exports, "format", {
    enumerable: true,
    get: function() {
        return $54ec52adb849a69b$var$_defaultLocale.format;
    }
});
Object.defineProperty(module.exports, "formatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $54ec52adb849a69b$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "formatLocale", {
    enumerable: true,
    get: function() {
        return $54ec52adb849a69b$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "formatPrefix", {
    enumerable: true,
    get: function() {
        return $54ec52adb849a69b$var$_defaultLocale.formatPrefix;
    }
});
Object.defineProperty(module.exports, "formatSpecifier", {
    enumerable: true,
    get: function() {
        return $54ec52adb849a69b$var$_formatSpecifier.default;
    }
});
Object.defineProperty(module.exports, "precisionFixed", {
    enumerable: true,
    get: function() {
        return $54ec52adb849a69b$var$_precisionFixed.default;
    }
});
Object.defineProperty(module.exports, "precisionPrefix", {
    enumerable: true,
    get: function() {
        return $54ec52adb849a69b$var$_precisionPrefix.default;
    }
});
Object.defineProperty(module.exports, "precisionRound", {
    enumerable: true,
    get: function() {
        return $54ec52adb849a69b$var$_precisionRound.default;
    }
});

var $54ec52adb849a69b$var$_defaultLocale = $54ec52adb849a69b$var$_interopRequireWildcard((parcelRequire("2e4Jt")));

var $54ec52adb849a69b$var$_locale = $54ec52adb849a69b$var$_interopRequireDefault((parcelRequire("bTcAc")));

var $54ec52adb849a69b$var$_formatSpecifier = $54ec52adb849a69b$var$_interopRequireWildcard((parcelRequire("b35dI")));

var $54ec52adb849a69b$var$_precisionFixed = $54ec52adb849a69b$var$_interopRequireDefault((parcelRequire("4g4ZM")));

var $54ec52adb849a69b$var$_precisionPrefix = $54ec52adb849a69b$var$_interopRequireDefault((parcelRequire("8EuuR")));

var $54ec52adb849a69b$var$_precisionRound = $54ec52adb849a69b$var$_interopRequireDefault((parcelRequire("il7ir")));
function $54ec52adb849a69b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $54ec52adb849a69b$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($54ec52adb849a69b$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $54ec52adb849a69b$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $54ec52adb849a69b$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("2e4Jt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $19f08f515dabb601$var$defaultLocale;
module.exports.formatPrefix = module.exports.format = void 0;

var $19f08f515dabb601$var$_locale = $19f08f515dabb601$var$_interopRequireDefault((parcelRequire("bTcAc")));
function $19f08f515dabb601$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $19f08f515dabb601$var$locale;
var $19f08f515dabb601$var$format;
module.exports.format = $19f08f515dabb601$var$format;
var $19f08f515dabb601$var$formatPrefix;
module.exports.formatPrefix = $19f08f515dabb601$var$formatPrefix;
$19f08f515dabb601$var$defaultLocale({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $19f08f515dabb601$var$defaultLocale(definition) {
    $19f08f515dabb601$var$locale = (0, $19f08f515dabb601$var$_locale.default)(definition);
    module.exports.format = $19f08f515dabb601$var$format = $19f08f515dabb601$var$locale.format;
    module.exports.formatPrefix = $19f08f515dabb601$var$formatPrefix = $19f08f515dabb601$var$locale.formatPrefix;
    return $19f08f515dabb601$var$locale;
}

});
parcelRegister("bTcAc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8a7e97794c9bce2e$var$_default;

var $8a7e97794c9bce2e$var$_exponent = $8a7e97794c9bce2e$var$_interopRequireDefault((parcelRequire("fcmkF")));

var $8a7e97794c9bce2e$var$_formatGroup = $8a7e97794c9bce2e$var$_interopRequireDefault((parcelRequire("2FIsG")));

var $8a7e97794c9bce2e$var$_formatNumerals = $8a7e97794c9bce2e$var$_interopRequireDefault((parcelRequire("7haPm")));

var $8a7e97794c9bce2e$var$_formatSpecifier = $8a7e97794c9bce2e$var$_interopRequireDefault((parcelRequire("b35dI")));

var $8a7e97794c9bce2e$var$_formatTrim = $8a7e97794c9bce2e$var$_interopRequireDefault((parcelRequire("8rssl")));

var $8a7e97794c9bce2e$var$_formatTypes = $8a7e97794c9bce2e$var$_interopRequireDefault((parcelRequire("B15qf")));

var $aXy4P = parcelRequire("aXy4P");

var $8a7e97794c9bce2e$var$_identity = $8a7e97794c9bce2e$var$_interopRequireDefault((parcelRequire("5lHVc")));
function $8a7e97794c9bce2e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8a7e97794c9bce2e$var$map = Array.prototype.map, $8a7e97794c9bce2e$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $8a7e97794c9bce2e$var$_default(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? $8a7e97794c9bce2e$var$_identity.default : (0, $8a7e97794c9bce2e$var$_formatGroup.default)($8a7e97794c9bce2e$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? $8a7e97794c9bce2e$var$_identity.default : (0, $8a7e97794c9bce2e$var$_formatNumerals.default)($8a7e97794c9bce2e$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $8a7e97794c9bce2e$var$_formatSpecifier.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type; // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g"; // The "" type, and any invalid type, is an alias for ".12~g".
        else if (!$8a7e97794c9bce2e$var$_formatTypes.default[type]) precision === undefined && (precision = 12), trim = true, type = "g"; // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "="; // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : ""; // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = $8a7e97794c9bce2e$var$_formatTypes.default[type], maybeSuffix = /[defgprs%]/.test(type); // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value; // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0; // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision); // Trim insignificant zeros.
                if (trim) value = (0, $8a7e97794c9bce2e$var$_formatTrim.default)(value); // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false; // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $8a7e97794c9bce2e$var$prefixes[8 + $aXy4P.prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : ""); // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            } // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity); // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : ""; // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = ""; // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $8a7e97794c9bce2e$var$_formatSpecifier.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $8a7e97794c9bce2e$var$_exponent.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $8a7e97794c9bce2e$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRegister("fcmkF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b1094cc3fc9d55f5$var$_default;

var $eTo0C = parcelRequire("eTo0C");
function $b1094cc3fc9d55f5$var$_default(x) {
    return x = (0, $eTo0C.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRegister("eTo0C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ad78d37212f91d09$var$_default;
module.exports.formatDecimalParts = $ad78d37212f91d09$var$formatDecimalParts;
function $ad78d37212f91d09$var$_default(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
} // Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function $ad78d37212f91d09$var$formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i); // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRegister("2FIsG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1f21e648a7e842cb$var$_default;
function $1f21e648a7e842cb$var$_default(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRegister("7haPm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $54c2850320f1ab4d$var$_default;
function $54c2850320f1ab4d$var$_default(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRegister("b35dI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatSpecifier = $80b40629d8789157$var$FormatSpecifier;
module.exports.default = $80b40629d8789157$var$formatSpecifier;
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $80b40629d8789157$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $80b40629d8789157$var$formatSpecifier(specifier) {
    if (!(match = $80b40629d8789157$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $80b40629d8789157$var$FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$80b40629d8789157$var$formatSpecifier.prototype = $80b40629d8789157$var$FormatSpecifier.prototype; // instanceof
function $80b40629d8789157$var$FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$80b40629d8789157$var$FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRegister("8rssl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6256eb29f01667b0$var$_default;
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $6256eb29f01667b0$var$_default(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRegister("B15qf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $06f44c90471e2e48$var$_formatDecimal = $06f44c90471e2e48$var$_interopRequireDefault((parcelRequire("eTo0C")));

var $06f44c90471e2e48$var$_formatPrefixAuto = $06f44c90471e2e48$var$_interopRequireDefault((parcelRequire("aXy4P")));

var $06f44c90471e2e48$var$_formatRounded = $06f44c90471e2e48$var$_interopRequireDefault((parcelRequire("aIshH")));
function $06f44c90471e2e48$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $06f44c90471e2e48$var$_default = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": $06f44c90471e2e48$var$_formatDecimal.default,
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $06f44c90471e2e48$var$_formatRounded.default)(x * 100, p),
    "r": $06f44c90471e2e48$var$_formatRounded.default,
    "s": $06f44c90471e2e48$var$_formatPrefixAuto.default,
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};
module.exports.default = $06f44c90471e2e48$var$_default;

});
parcelRegister("aXy4P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7fa9d90820ad2899$var$_default;
module.exports.prefixExponent = void 0;

var $eTo0C = parcelRequire("eTo0C");
var $7fa9d90820ad2899$var$prefixExponent;
module.exports.prefixExponent = $7fa9d90820ad2899$var$prefixExponent;
function $7fa9d90820ad2899$var$_default(x, p) {
    var d = (0, $eTo0C.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - (module.exports.prefixExponent = $7fa9d90820ad2899$var$prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $eTo0C.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRegister("aIshH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7cd3f426a565db31$var$_default;

var $eTo0C = parcelRequire("eTo0C");
function $7cd3f426a565db31$var$_default(x, p) {
    var d = (0, $eTo0C.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRegister("5lHVc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3e50fbd51f221a4b$var$_default;
function $3e50fbd51f221a4b$var$_default(x) {
    return x;
}

});



parcelRegister("4g4ZM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $319c880aea6d6d22$var$_default;

var $319c880aea6d6d22$var$_exponent = $319c880aea6d6d22$var$_interopRequireDefault((parcelRequire("fcmkF")));
function $319c880aea6d6d22$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $319c880aea6d6d22$var$_default(step) {
    return Math.max(0, -(0, $319c880aea6d6d22$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("8EuuR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $64c9b72d94f44a6b$var$_default;

var $64c9b72d94f44a6b$var$_exponent = $64c9b72d94f44a6b$var$_interopRequireDefault((parcelRequire("fcmkF")));
function $64c9b72d94f44a6b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $64c9b72d94f44a6b$var$_default(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $64c9b72d94f44a6b$var$_exponent.default)(value) / 3))) * 3 - (0, $64c9b72d94f44a6b$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("il7ir", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d59fd915c1c28d8b$var$_default;

var $d59fd915c1c28d8b$var$_exponent = $d59fd915c1c28d8b$var$_interopRequireDefault((parcelRequire("fcmkF")));
function $d59fd915c1c28d8b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d59fd915c1c28d8b$var$_default(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $d59fd915c1c28d8b$var$_exponent.default)(max) - (0, $d59fd915c1c28d8b$var$_exponent.default)(step)) + 1;
}

});





parcelRegister("acYkY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $76e9d41e0f154636$var$log;
module.exports.loggish = $76e9d41e0f154636$var$loggish;

var $2bySc = parcelRequire("2bySc");

var $7i2IB = parcelRequire("7i2IB");

var $76e9d41e0f154636$var$_nice = $76e9d41e0f154636$var$_interopRequireDefault((parcelRequire("asWO4")));

var $4ofCy = parcelRequire("4ofCy");

var $8vtGb = parcelRequire("8vtGb");
function $76e9d41e0f154636$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $76e9d41e0f154636$var$transformLog(x) {
    return Math.log(x);
}
function $76e9d41e0f154636$var$transformExp(x) {
    return Math.exp(x);
}
function $76e9d41e0f154636$var$transformLogn(x) {
    return -Math.log(-x);
}
function $76e9d41e0f154636$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $76e9d41e0f154636$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $76e9d41e0f154636$var$powp(base) {
    return base === 10 ? $76e9d41e0f154636$var$pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function $76e9d41e0f154636$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function $76e9d41e0f154636$var$reflect(f) {
    return (x, k)=>-f(-x, k);
}
function $76e9d41e0f154636$var$loggish(transform) {
    const scale = transform($76e9d41e0f154636$var$transformLog, $76e9d41e0f154636$var$transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = $76e9d41e0f154636$var$logp(base), pows = $76e9d41e0f154636$var$powp(base);
        if (domain()[0] < 0) {
            logs = $76e9d41e0f154636$var$reflect(logs), pows = $76e9d41e0f154636$var$reflect(pows);
            transform($76e9d41e0f154636$var$transformLogn, $76e9d41e0f154636$var$transformExpn);
        } else transform($76e9d41e0f154636$var$transformLog, $76e9d41e0f154636$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $2bySc.ticks)(u, v, n);
        } else z = (0, $2bySc.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $7i2IB.formatSpecifier)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $7i2IB.format)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, $76e9d41e0f154636$var$_nice.default)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function $76e9d41e0f154636$var$log() {
    const scale = $76e9d41e0f154636$var$loggish((0, $4ofCy.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, $4ofCy.copy)(scale, $76e9d41e0f154636$var$log()).base(scale.base());
    $8vtGb.initRange.apply(scale, arguments);
    return scale;
}

});
parcelRegister("asWO4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $79ea22b1c9f0b57b$var$nice;
function $79ea22b1c9f0b57b$var$nice(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

});


parcelRegister("e8pBQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a4a5ad87cbce17be$var$symlog;
module.exports.symlogish = $a4a5ad87cbce17be$var$symlogish;

var $5bYdw = parcelRequire("5bYdw");

var $4ofCy = parcelRequire("4ofCy");

var $8vtGb = parcelRequire("8vtGb");
function $a4a5ad87cbce17be$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $a4a5ad87cbce17be$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $a4a5ad87cbce17be$var$symlogish(transform) {
    var c = 1, scale = transform($a4a5ad87cbce17be$var$transformSymlog(c), $a4a5ad87cbce17be$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($a4a5ad87cbce17be$var$transformSymlog(c = +_), $a4a5ad87cbce17be$var$transformSymexp(c)) : c;
    };
    return (0, $5bYdw.linearish)(scale);
}
function $a4a5ad87cbce17be$var$symlog() {
    var scale = $a4a5ad87cbce17be$var$symlogish((0, $4ofCy.transformer)());
    scale.copy = function() {
        return (0, $4ofCy.copy)(scale, $a4a5ad87cbce17be$var$symlog()).constant(scale.constant());
    };
    return $8vtGb.initRange.apply(scale, arguments);
}

});

parcelRegister("aQ2CU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7e40cc51564842ce$var$pow;
module.exports.powish = $7e40cc51564842ce$var$powish;
module.exports.sqrt = $7e40cc51564842ce$var$sqrt;

var $5bYdw = parcelRequire("5bYdw");

var $4ofCy = parcelRequire("4ofCy");

var $8vtGb = parcelRequire("8vtGb");
function $7e40cc51564842ce$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $7e40cc51564842ce$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $7e40cc51564842ce$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $7e40cc51564842ce$var$powish(transform) {
    var scale = transform($4ofCy.identity, $4ofCy.identity), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform($4ofCy.identity, $4ofCy.identity) : exponent === 0.5 ? transform($7e40cc51564842ce$var$transformSqrt, $7e40cc51564842ce$var$transformSquare) : transform($7e40cc51564842ce$var$transformPow(exponent), $7e40cc51564842ce$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $5bYdw.linearish)(scale);
}
function $7e40cc51564842ce$var$pow() {
    var scale = $7e40cc51564842ce$var$powish((0, $4ofCy.transformer)());
    scale.copy = function() {
        return (0, $4ofCy.copy)(scale, $7e40cc51564842ce$var$pow()).exponent(scale.exponent());
    };
    $8vtGb.initRange.apply(scale, arguments);
    return scale;
}
function $7e40cc51564842ce$var$sqrt() {
    return $7e40cc51564842ce$var$pow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("h9Z5b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c7e2a8a4d9e4307b$var$radial;

var $c7e2a8a4d9e4307b$var$_continuous = $c7e2a8a4d9e4307b$var$_interopRequireDefault((parcelRequire("4ofCy")));

var $8vtGb = parcelRequire("8vtGb");

var $5bYdw = parcelRequire("5bYdw");

var $c7e2a8a4d9e4307b$var$_number = $c7e2a8a4d9e4307b$var$_interopRequireDefault((parcelRequire("23xQd")));
function $c7e2a8a4d9e4307b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c7e2a8a4d9e4307b$var$square(x) {
    return Math.sign(x) * x * x;
}
function $c7e2a8a4d9e4307b$var$unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function $c7e2a8a4d9e4307b$var$radial() {
    var squared = (0, $c7e2a8a4d9e4307b$var$_continuous.default)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = $c7e2a8a4d9e4307b$var$unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert($c7e2a8a4d9e4307b$var$square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, $c7e2a8a4d9e4307b$var$_number.default)).map($c7e2a8a4d9e4307b$var$square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $c7e2a8a4d9e4307b$var$radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    $8vtGb.initRange.apply(scale, arguments);
    return (0, $5bYdw.linearish)(scale);
}

});

parcelRegister("gMQyC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c389e5cffb2449ba$var$quantile;

var $2bySc = parcelRequire("2bySc");

var $8vtGb = parcelRequire("8vtGb");
function $c389e5cffb2449ba$var$quantile() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $2bySc.quantileSorted)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, $2bySc.bisect)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($2bySc.ascending);
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $c389e5cffb2449ba$var$quantile().domain(domain).range(range).unknown(unknown);
    };
    return $8vtGb.initRange.apply(scale, arguments);
}

});

parcelRegister("alarn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7873f6d660509cc5$var$quantize;

var $2bySc = parcelRequire("2bySc");

var $5bYdw = parcelRequire("5bYdw");

var $8vtGb = parcelRequire("8vtGb");
function $7873f6d660509cc5$var$quantize() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, $2bySc.bisect)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $7873f6d660509cc5$var$quantize().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return $8vtGb.initRange.apply((0, $5bYdw.linearish)(scale), arguments);
}

});

parcelRegister("g0t6E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ba733953aae6cdc7$var$threshold;

var $2bySc = parcelRequire("2bySc");

var $8vtGb = parcelRequire("8vtGb");
function $ba733953aae6cdc7$var$threshold() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, $2bySc.bisect)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $ba733953aae6cdc7$var$threshold().domain(domain).range(range).unknown(unknown);
    };
    return $8vtGb.initRange.apply(scale, arguments);
}

});

parcelRegister("kLoNf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calendar = $f1db6de19b052edc$var$calendar;
module.exports.default = $f1db6de19b052edc$var$time;

var $1Bm3R = parcelRequire("1Bm3R");

var $9mFI8 = parcelRequire("9mFI8");

var $f1db6de19b052edc$var$_continuous = $f1db6de19b052edc$var$_interopRequireWildcard((parcelRequire("4ofCy")));

var $8vtGb = parcelRequire("8vtGb");

var $f1db6de19b052edc$var$_nice = $f1db6de19b052edc$var$_interopRequireDefault((parcelRequire("asWO4")));
function $f1db6de19b052edc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f1db6de19b052edc$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($f1db6de19b052edc$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $f1db6de19b052edc$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $f1db6de19b052edc$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $f1db6de19b052edc$var$date(t) {
    return new Date(t);
}
function $f1db6de19b052edc$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $f1db6de19b052edc$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $f1db6de19b052edc$var$_continuous.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $f1db6de19b052edc$var$number)) : domain().map($f1db6de19b052edc$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $f1db6de19b052edc$var$_nice.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $f1db6de19b052edc$var$_continuous.copy)(scale, $f1db6de19b052edc$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $f1db6de19b052edc$var$time() {
    return $8vtGb.initRange.apply($f1db6de19b052edc$var$calendar($1Bm3R.timeTicks, $1Bm3R.timeTickInterval, $1Bm3R.timeYear, $1Bm3R.timeMonth, $1Bm3R.timeWeek, $1Bm3R.timeDay, $1Bm3R.timeHour, $1Bm3R.timeMinute, $1Bm3R.timeSecond, $9mFI8.timeFormat).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

});
parcelRegister("1Bm3R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "timeDay", {
    enumerable: true,
    get: function() {
        return $12aa5c131fbd13bc$var$_day.default;
    }
});
Object.defineProperty(module.exports, "timeDays", {
    enumerable: true,
    get: function() {
        return $12aa5c131fbd13bc$var$_day.days;
    }
});
Object.defineProperty(module.exports, "timeFriday", {
    enumerable: true,
    get: function() {
        return $3wN2f.friday;
    }
});
Object.defineProperty(module.exports, "timeFridays", {
    enumerable: true,
    get: function() {
        return $3wN2f.fridays;
    }
});
Object.defineProperty(module.exports, "timeHour", {
    enumerable: true,
    get: function() {
        return $12aa5c131fbd13bc$var$_hour.default;
    }
});
Object.defineProperty(module.exports, "timeHours", {
    enumerable: true,
    get: function() {
        return $12aa5c131fbd13bc$var$_hour.hours;
    }
});
Object.defineProperty(module.exports, "timeInterval", {
    enumerable: true,
    get: function() {
        return $12aa5c131fbd13bc$var$_interval.default;
    }
});
Object.defineProperty(module.exports, "timeMillisecond", {
    enumerable: true,
    get: function() {
        return $12aa5c131fbd13bc$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "timeMilliseconds", {
    enumerable: true,
    get: function() {
        return $12aa5c131fbd13bc$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "timeMinute", {
    enumerable: true,
    get: function() {
        return $12aa5c131fbd13bc$var$_minute.default;
    }
});
Object.defineProperty(module.exports, "timeMinutes", {
    enumerable: true,
    get: function() {
        return $12aa5c131fbd13bc$var$_minute.minutes;
    }
});
Object.defineProperty(module.exports, "timeMonday", {
    enumerable: true,
    get: function() {
        return $3wN2f.monday;
    }
});
Object.defineProperty(module.exports, "timeMondays", {
    enumerable: true,
    get: function() {
        return $3wN2f.mondays;
    }
});
Object.defineProperty(module.exports, "timeMonth", {
    enumerable: true,
    get: function() {
        return $12aa5c131fbd13bc$var$_month.default;
    }
});
Object.defineProperty(module.exports, "timeMonths", {
    enumerable: true,
    get: function() {
        return $12aa5c131fbd13bc$var$_month.months;
    }
});
Object.defineProperty(module.exports, "timeSaturday", {
    enumerable: true,
    get: function() {
        return $3wN2f.saturday;
    }
});
Object.defineProperty(module.exports, "timeSaturdays", {
    enumerable: true,
    get: function() {
        return $3wN2f.saturdays;
    }
});
Object.defineProperty(module.exports, "timeSecond", {
    enumerable: true,
    get: function() {
        return $12aa5c131fbd13bc$var$_second.default;
    }
});
Object.defineProperty(module.exports, "timeSeconds", {
    enumerable: true,
    get: function() {
        return $12aa5c131fbd13bc$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "timeSunday", {
    enumerable: true,
    get: function() {
        return $3wN2f.sunday;
    }
});
Object.defineProperty(module.exports, "timeSundays", {
    enumerable: true,
    get: function() {
        return $3wN2f.sundays;
    }
});
Object.defineProperty(module.exports, "timeThursday", {
    enumerable: true,
    get: function() {
        return $3wN2f.thursday;
    }
});
Object.defineProperty(module.exports, "timeThursdays", {
    enumerable: true,
    get: function() {
        return $3wN2f.thursdays;
    }
});
Object.defineProperty(module.exports, "timeTickInterval", {
    enumerable: true,
    get: function() {
        return $aI4Av.timeTickInterval;
    }
});
Object.defineProperty(module.exports, "timeTicks", {
    enumerable: true,
    get: function() {
        return $aI4Av.timeTicks;
    }
});
Object.defineProperty(module.exports, "timeTuesday", {
    enumerable: true,
    get: function() {
        return $3wN2f.tuesday;
    }
});
Object.defineProperty(module.exports, "timeTuesdays", {
    enumerable: true,
    get: function() {
        return $3wN2f.tuesdays;
    }
});
Object.defineProperty(module.exports, "timeWednesday", {
    enumerable: true,
    get: function() {
        return $3wN2f.wednesday;
    }
});
Object.defineProperty(module.exports, "timeWednesdays", {
    enumerable: true,
    get: function() {
        return $3wN2f.wednesdays;
    }
});
Object.defineProperty(module.exports, "timeWeek", {
    enumerable: true,
    get: function() {
        return $3wN2f.sunday;
    }
});
Object.defineProperty(module.exports, "timeWeeks", {
    enumerable: true,
    get: function() {
        return $3wN2f.sundays;
    }
});
Object.defineProperty(module.exports, "timeYear", {
    enumerable: true,
    get: function() {
        return $12aa5c131fbd13bc$var$_year.default;
    }
});
Object.defineProperty(module.exports, "timeYears", {
    enumerable: true,
    get: function() {
        return $12aa5c131fbd13bc$var$_year.years;
    }
});
Object.defineProperty(module.exports, "utcDay", {
    enumerable: true,
    get: function() {
        return $12aa5c131fbd13bc$var$_utcDay.default;
    }
});
Object.defineProperty(module.exports, "utcDays", {
    enumerable: true,
    get: function() {
        return $12aa5c131fbd13bc$var$_utcDay.utcDays;
    }
});
Object.defineProperty(module.exports, "utcFriday", {
    enumerable: true,
    get: function() {
        return $jFQin.utcFriday;
    }
});
Object.defineProperty(module.exports, "utcFridays", {
    enumerable: true,
    get: function() {
        return $jFQin.utcFridays;
    }
});
Object.defineProperty(module.exports, "utcHour", {
    enumerable: true,
    get: function() {
        return $12aa5c131fbd13bc$var$_utcHour.default;
    }
});
Object.defineProperty(module.exports, "utcHours", {
    enumerable: true,
    get: function() {
        return $12aa5c131fbd13bc$var$_utcHour.utcHours;
    }
});
Object.defineProperty(module.exports, "utcMillisecond", {
    enumerable: true,
    get: function() {
        return $12aa5c131fbd13bc$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "utcMilliseconds", {
    enumerable: true,
    get: function() {
        return $12aa5c131fbd13bc$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "utcMinute", {
    enumerable: true,
    get: function() {
        return $12aa5c131fbd13bc$var$_utcMinute.default;
    }
});
Object.defineProperty(module.exports, "utcMinutes", {
    enumerable: true,
    get: function() {
        return $12aa5c131fbd13bc$var$_utcMinute.utcMinutes;
    }
});
Object.defineProperty(module.exports, "utcMonday", {
    enumerable: true,
    get: function() {
        return $jFQin.utcMonday;
    }
});
Object.defineProperty(module.exports, "utcMondays", {
    enumerable: true,
    get: function() {
        return $jFQin.utcMondays;
    }
});
Object.defineProperty(module.exports, "utcMonth", {
    enumerable: true,
    get: function() {
        return $12aa5c131fbd13bc$var$_utcMonth.default;
    }
});
Object.defineProperty(module.exports, "utcMonths", {
    enumerable: true,
    get: function() {
        return $12aa5c131fbd13bc$var$_utcMonth.utcMonths;
    }
});
Object.defineProperty(module.exports, "utcSaturday", {
    enumerable: true,
    get: function() {
        return $jFQin.utcSaturday;
    }
});
Object.defineProperty(module.exports, "utcSaturdays", {
    enumerable: true,
    get: function() {
        return $jFQin.utcSaturdays;
    }
});
Object.defineProperty(module.exports, "utcSecond", {
    enumerable: true,
    get: function() {
        return $12aa5c131fbd13bc$var$_second.default;
    }
});
Object.defineProperty(module.exports, "utcSeconds", {
    enumerable: true,
    get: function() {
        return $12aa5c131fbd13bc$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "utcSunday", {
    enumerable: true,
    get: function() {
        return $jFQin.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcSundays", {
    enumerable: true,
    get: function() {
        return $jFQin.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcThursday", {
    enumerable: true,
    get: function() {
        return $jFQin.utcThursday;
    }
});
Object.defineProperty(module.exports, "utcThursdays", {
    enumerable: true,
    get: function() {
        return $jFQin.utcThursdays;
    }
});
Object.defineProperty(module.exports, "utcTickInterval", {
    enumerable: true,
    get: function() {
        return $aI4Av.utcTickInterval;
    }
});
Object.defineProperty(module.exports, "utcTicks", {
    enumerable: true,
    get: function() {
        return $aI4Av.utcTicks;
    }
});
Object.defineProperty(module.exports, "utcTuesday", {
    enumerable: true,
    get: function() {
        return $jFQin.utcTuesday;
    }
});
Object.defineProperty(module.exports, "utcTuesdays", {
    enumerable: true,
    get: function() {
        return $jFQin.utcTuesdays;
    }
});
Object.defineProperty(module.exports, "utcWednesday", {
    enumerable: true,
    get: function() {
        return $jFQin.utcWednesday;
    }
});
Object.defineProperty(module.exports, "utcWednesdays", {
    enumerable: true,
    get: function() {
        return $jFQin.utcWednesdays;
    }
});
Object.defineProperty(module.exports, "utcWeek", {
    enumerable: true,
    get: function() {
        return $jFQin.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcWeeks", {
    enumerable: true,
    get: function() {
        return $jFQin.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcYear", {
    enumerable: true,
    get: function() {
        return $12aa5c131fbd13bc$var$_utcYear.default;
    }
});
Object.defineProperty(module.exports, "utcYears", {
    enumerable: true,
    get: function() {
        return $12aa5c131fbd13bc$var$_utcYear.utcYears;
    }
});

var $12aa5c131fbd13bc$var$_interval = $12aa5c131fbd13bc$var$_interopRequireDefault((parcelRequire("dNNtY")));

var $12aa5c131fbd13bc$var$_millisecond = $12aa5c131fbd13bc$var$_interopRequireWildcard((parcelRequire("8X4DO")));

var $12aa5c131fbd13bc$var$_second = $12aa5c131fbd13bc$var$_interopRequireWildcard((parcelRequire("5NI8V")));

var $12aa5c131fbd13bc$var$_minute = $12aa5c131fbd13bc$var$_interopRequireWildcard((parcelRequire("bAD7U")));

var $12aa5c131fbd13bc$var$_hour = $12aa5c131fbd13bc$var$_interopRequireWildcard((parcelRequire("1MiSH")));

var $12aa5c131fbd13bc$var$_day = $12aa5c131fbd13bc$var$_interopRequireWildcard((parcelRequire("9mQ3m")));

var $3wN2f = parcelRequire("3wN2f");

var $12aa5c131fbd13bc$var$_month = $12aa5c131fbd13bc$var$_interopRequireWildcard((parcelRequire("623T2")));

var $12aa5c131fbd13bc$var$_year = $12aa5c131fbd13bc$var$_interopRequireWildcard((parcelRequire("kW5jr")));

var $12aa5c131fbd13bc$var$_utcMinute = $12aa5c131fbd13bc$var$_interopRequireWildcard((parcelRequire("94PXF")));

var $12aa5c131fbd13bc$var$_utcHour = $12aa5c131fbd13bc$var$_interopRequireWildcard((parcelRequire("8L3wd")));

var $12aa5c131fbd13bc$var$_utcDay = $12aa5c131fbd13bc$var$_interopRequireWildcard((parcelRequire("awAoj")));

var $jFQin = parcelRequire("jFQin");

var $12aa5c131fbd13bc$var$_utcMonth = $12aa5c131fbd13bc$var$_interopRequireWildcard((parcelRequire("bbGbo")));

var $12aa5c131fbd13bc$var$_utcYear = $12aa5c131fbd13bc$var$_interopRequireWildcard((parcelRequire("1TEgN")));

var $aI4Av = parcelRequire("aI4Av");
function $12aa5c131fbd13bc$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($12aa5c131fbd13bc$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $12aa5c131fbd13bc$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $12aa5c131fbd13bc$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $12aa5c131fbd13bc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("dNNtY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a0c63c256e5e9b40$var$newInterval;
var $a0c63c256e5e9b40$var$t0 = new Date(), $a0c63c256e5e9b40$var$t1 = new Date();
function $a0c63c256e5e9b40$var$newInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date() : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $a0c63c256e5e9b40$var$newInterval(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $a0c63c256e5e9b40$var$t0.setTime(+start), $a0c63c256e5e9b40$var$t1.setTime(+end);
            floori($a0c63c256e5e9b40$var$t0), floori($a0c63c256e5e9b40$var$t1);
            return Math.floor(count($a0c63c256e5e9b40$var$t0, $a0c63c256e5e9b40$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

});

parcelRegister("8X4DO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.milliseconds = module.exports.default = void 0;

var $68476f127e988038$var$_interval = $68476f127e988038$var$_interopRequireDefault((parcelRequire("dNNtY")));
function $68476f127e988038$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $68476f127e988038$var$millisecond = (0, $68476f127e988038$var$_interval.default)(function() {}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
}); // An optimized implementation for this simple case.
$68476f127e988038$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $68476f127e988038$var$millisecond;
    return (0, $68476f127e988038$var$_interval.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $68476f127e988038$var$_default = $68476f127e988038$var$millisecond;
module.exports.default = $68476f127e988038$var$_default;
var $68476f127e988038$var$milliseconds = $68476f127e988038$var$millisecond.range;
module.exports.milliseconds = $68476f127e988038$var$milliseconds;

});

parcelRegister("5NI8V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.seconds = module.exports.default = void 0;

var $4393c539ff32eb02$var$_interval = $4393c539ff32eb02$var$_interopRequireDefault((parcelRequire("dNNtY")));

var $e9CHQ = parcelRequire("e9CHQ");
function $4393c539ff32eb02$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $4393c539ff32eb02$var$second = (0, $4393c539ff32eb02$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * $e9CHQ.durationSecond);
}, function(start, end) {
    return (end - start) / $e9CHQ.durationSecond;
}, function(date) {
    return date.getUTCSeconds();
});
var $4393c539ff32eb02$var$_default = $4393c539ff32eb02$var$second;
module.exports.default = $4393c539ff32eb02$var$_default;
var $4393c539ff32eb02$var$seconds = $4393c539ff32eb02$var$second.range;
module.exports.seconds = $4393c539ff32eb02$var$seconds;

});
parcelRegister("e9CHQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.durationYear = module.exports.durationWeek = module.exports.durationSecond = module.exports.durationMonth = module.exports.durationMinute = module.exports.durationHour = module.exports.durationDay = void 0;
const $a4dfee37366396e9$var$durationSecond = 1000;
module.exports.durationSecond = $a4dfee37366396e9$var$durationSecond;
const $a4dfee37366396e9$var$durationMinute = $a4dfee37366396e9$var$durationSecond * 60;
module.exports.durationMinute = $a4dfee37366396e9$var$durationMinute;
const $a4dfee37366396e9$var$durationHour = $a4dfee37366396e9$var$durationMinute * 60;
module.exports.durationHour = $a4dfee37366396e9$var$durationHour;
const $a4dfee37366396e9$var$durationDay = $a4dfee37366396e9$var$durationHour * 24;
module.exports.durationDay = $a4dfee37366396e9$var$durationDay;
const $a4dfee37366396e9$var$durationWeek = $a4dfee37366396e9$var$durationDay * 7;
module.exports.durationWeek = $a4dfee37366396e9$var$durationWeek;
const $a4dfee37366396e9$var$durationMonth = $a4dfee37366396e9$var$durationDay * 30;
module.exports.durationMonth = $a4dfee37366396e9$var$durationMonth;
const $a4dfee37366396e9$var$durationYear = $a4dfee37366396e9$var$durationDay * 365;
module.exports.durationYear = $a4dfee37366396e9$var$durationYear;

});


parcelRegister("bAD7U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.minutes = module.exports.default = void 0;

var $870168373b2638f1$var$_interval = $870168373b2638f1$var$_interopRequireDefault((parcelRequire("dNNtY")));

var $e9CHQ = parcelRequire("e9CHQ");
function $870168373b2638f1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $870168373b2638f1$var$minute = (0, $870168373b2638f1$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $e9CHQ.durationSecond);
}, function(date, step) {
    date.setTime(+date + step * $e9CHQ.durationMinute);
}, function(start, end) {
    return (end - start) / $e9CHQ.durationMinute;
}, function(date) {
    return date.getMinutes();
});
var $870168373b2638f1$var$_default = $870168373b2638f1$var$minute;
module.exports.default = $870168373b2638f1$var$_default;
var $870168373b2638f1$var$minutes = $870168373b2638f1$var$minute.range;
module.exports.minutes = $870168373b2638f1$var$minutes;

});

parcelRegister("1MiSH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hours = module.exports.default = void 0;

var $14b8eb8ed0e6a2f2$var$_interval = $14b8eb8ed0e6a2f2$var$_interopRequireDefault((parcelRequire("dNNtY")));

var $e9CHQ = parcelRequire("e9CHQ");
function $14b8eb8ed0e6a2f2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $14b8eb8ed0e6a2f2$var$hour = (0, $14b8eb8ed0e6a2f2$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $e9CHQ.durationSecond - date.getMinutes() * $e9CHQ.durationMinute);
}, function(date, step) {
    date.setTime(+date + step * $e9CHQ.durationHour);
}, function(start, end) {
    return (end - start) / $e9CHQ.durationHour;
}, function(date) {
    return date.getHours();
});
var $14b8eb8ed0e6a2f2$var$_default = $14b8eb8ed0e6a2f2$var$hour;
module.exports.default = $14b8eb8ed0e6a2f2$var$_default;
var $14b8eb8ed0e6a2f2$var$hours = $14b8eb8ed0e6a2f2$var$hour.range;
module.exports.hours = $14b8eb8ed0e6a2f2$var$hours;

});

parcelRegister("9mQ3m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.days = void 0;

var $6d1e8bcd3b7652f3$var$_interval = $6d1e8bcd3b7652f3$var$_interopRequireDefault((parcelRequire("dNNtY")));

var $e9CHQ = parcelRequire("e9CHQ");
function $6d1e8bcd3b7652f3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6d1e8bcd3b7652f3$var$day = (0, $6d1e8bcd3b7652f3$var$_interval.default)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $e9CHQ.durationMinute) / $e9CHQ.durationDay, (date)=>date.getDate() - 1);
var $6d1e8bcd3b7652f3$var$_default = $6d1e8bcd3b7652f3$var$day;
module.exports.default = $6d1e8bcd3b7652f3$var$_default;
var $6d1e8bcd3b7652f3$var$days = $6d1e8bcd3b7652f3$var$day.range;
module.exports.days = $6d1e8bcd3b7652f3$var$days;

});

parcelRegister("3wN2f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.wednesdays = module.exports.wednesday = module.exports.tuesdays = module.exports.tuesday = module.exports.thursdays = module.exports.thursday = module.exports.sundays = module.exports.sunday = module.exports.saturdays = module.exports.saturday = module.exports.mondays = module.exports.monday = module.exports.fridays = module.exports.friday = void 0;

var $291a65a4747a5218$var$_interval = $291a65a4747a5218$var$_interopRequireDefault((parcelRequire("dNNtY")));

var $e9CHQ = parcelRequire("e9CHQ");
function $291a65a4747a5218$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $291a65a4747a5218$var$weekday(i) {
    return (0, $291a65a4747a5218$var$_interval.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $e9CHQ.durationMinute) / $e9CHQ.durationWeek;
    });
}
var $291a65a4747a5218$var$sunday = $291a65a4747a5218$var$weekday(0);
module.exports.sunday = $291a65a4747a5218$var$sunday;
var $291a65a4747a5218$var$monday = $291a65a4747a5218$var$weekday(1);
module.exports.monday = $291a65a4747a5218$var$monday;
var $291a65a4747a5218$var$tuesday = $291a65a4747a5218$var$weekday(2);
module.exports.tuesday = $291a65a4747a5218$var$tuesday;
var $291a65a4747a5218$var$wednesday = $291a65a4747a5218$var$weekday(3);
module.exports.wednesday = $291a65a4747a5218$var$wednesday;
var $291a65a4747a5218$var$thursday = $291a65a4747a5218$var$weekday(4);
module.exports.thursday = $291a65a4747a5218$var$thursday;
var $291a65a4747a5218$var$friday = $291a65a4747a5218$var$weekday(5);
module.exports.friday = $291a65a4747a5218$var$friday;
var $291a65a4747a5218$var$saturday = $291a65a4747a5218$var$weekday(6);
module.exports.saturday = $291a65a4747a5218$var$saturday;
var $291a65a4747a5218$var$sundays = $291a65a4747a5218$var$sunday.range;
module.exports.sundays = $291a65a4747a5218$var$sundays;
var $291a65a4747a5218$var$mondays = $291a65a4747a5218$var$monday.range;
module.exports.mondays = $291a65a4747a5218$var$mondays;
var $291a65a4747a5218$var$tuesdays = $291a65a4747a5218$var$tuesday.range;
module.exports.tuesdays = $291a65a4747a5218$var$tuesdays;
var $291a65a4747a5218$var$wednesdays = $291a65a4747a5218$var$wednesday.range;
module.exports.wednesdays = $291a65a4747a5218$var$wednesdays;
var $291a65a4747a5218$var$thursdays = $291a65a4747a5218$var$thursday.range;
module.exports.thursdays = $291a65a4747a5218$var$thursdays;
var $291a65a4747a5218$var$fridays = $291a65a4747a5218$var$friday.range;
module.exports.fridays = $291a65a4747a5218$var$fridays;
var $291a65a4747a5218$var$saturdays = $291a65a4747a5218$var$saturday.range;
module.exports.saturdays = $291a65a4747a5218$var$saturdays;

});

parcelRegister("623T2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.months = module.exports.default = void 0;

var $4645f1ca5de0ca12$var$_interval = $4645f1ca5de0ca12$var$_interopRequireDefault((parcelRequire("dNNtY")));
function $4645f1ca5de0ca12$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $4645f1ca5de0ca12$var$month = (0, $4645f1ca5de0ca12$var$_interval.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $4645f1ca5de0ca12$var$_default = $4645f1ca5de0ca12$var$month;
module.exports.default = $4645f1ca5de0ca12$var$_default;
var $4645f1ca5de0ca12$var$months = $4645f1ca5de0ca12$var$month.range;
module.exports.months = $4645f1ca5de0ca12$var$months;

});

parcelRegister("kW5jr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.years = module.exports.default = void 0;

var $f3dd586ae504f83c$var$_interval = $f3dd586ae504f83c$var$_interopRequireDefault((parcelRequire("dNNtY")));
function $f3dd586ae504f83c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $f3dd586ae504f83c$var$year = (0, $f3dd586ae504f83c$var$_interval.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
}); // An optimized implementation for this simple case.
$f3dd586ae504f83c$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $f3dd586ae504f83c$var$_interval.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $f3dd586ae504f83c$var$_default = $f3dd586ae504f83c$var$year;
module.exports.default = $f3dd586ae504f83c$var$_default;
var $f3dd586ae504f83c$var$years = $f3dd586ae504f83c$var$year.range;
module.exports.years = $f3dd586ae504f83c$var$years;

});

parcelRegister("94PXF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMinutes = module.exports.default = void 0;

var $69bccb3b27921e17$var$_interval = $69bccb3b27921e17$var$_interopRequireDefault((parcelRequire("dNNtY")));

var $e9CHQ = parcelRequire("e9CHQ");
function $69bccb3b27921e17$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $69bccb3b27921e17$var$utcMinute = (0, $69bccb3b27921e17$var$_interval.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * $e9CHQ.durationMinute);
}, function(start, end) {
    return (end - start) / $e9CHQ.durationMinute;
}, function(date) {
    return date.getUTCMinutes();
});
var $69bccb3b27921e17$var$_default = $69bccb3b27921e17$var$utcMinute;
module.exports.default = $69bccb3b27921e17$var$_default;
var $69bccb3b27921e17$var$utcMinutes = $69bccb3b27921e17$var$utcMinute.range;
module.exports.utcMinutes = $69bccb3b27921e17$var$utcMinutes;

});

parcelRegister("8L3wd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcHours = module.exports.default = void 0;

var $6605713acc89e6c3$var$_interval = $6605713acc89e6c3$var$_interopRequireDefault((parcelRequire("dNNtY")));

var $e9CHQ = parcelRequire("e9CHQ");
function $6605713acc89e6c3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6605713acc89e6c3$var$utcHour = (0, $6605713acc89e6c3$var$_interval.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * $e9CHQ.durationHour);
}, function(start, end) {
    return (end - start) / $e9CHQ.durationHour;
}, function(date) {
    return date.getUTCHours();
});
var $6605713acc89e6c3$var$_default = $6605713acc89e6c3$var$utcHour;
module.exports.default = $6605713acc89e6c3$var$_default;
var $6605713acc89e6c3$var$utcHours = $6605713acc89e6c3$var$utcHour.range;
module.exports.utcHours = $6605713acc89e6c3$var$utcHours;

});

parcelRegister("awAoj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcDays = module.exports.default = void 0;

var $7a991f0bd4ecf517$var$_interval = $7a991f0bd4ecf517$var$_interopRequireDefault((parcelRequire("dNNtY")));

var $e9CHQ = parcelRequire("e9CHQ");
function $7a991f0bd4ecf517$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $7a991f0bd4ecf517$var$utcDay = (0, $7a991f0bd4ecf517$var$_interval.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / $e9CHQ.durationDay;
}, function(date) {
    return date.getUTCDate() - 1;
});
var $7a991f0bd4ecf517$var$_default = $7a991f0bd4ecf517$var$utcDay;
module.exports.default = $7a991f0bd4ecf517$var$_default;
var $7a991f0bd4ecf517$var$utcDays = $7a991f0bd4ecf517$var$utcDay.range;
module.exports.utcDays = $7a991f0bd4ecf517$var$utcDays;

});

parcelRegister("jFQin", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcWednesdays = module.exports.utcWednesday = module.exports.utcTuesdays = module.exports.utcTuesday = module.exports.utcThursdays = module.exports.utcThursday = module.exports.utcSundays = module.exports.utcSunday = module.exports.utcSaturdays = module.exports.utcSaturday = module.exports.utcMondays = module.exports.utcMonday = module.exports.utcFridays = module.exports.utcFriday = void 0;

var $e52a696dfd98f1d3$var$_interval = $e52a696dfd98f1d3$var$_interopRequireDefault((parcelRequire("dNNtY")));

var $e9CHQ = parcelRequire("e9CHQ");
function $e52a696dfd98f1d3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e52a696dfd98f1d3$var$utcWeekday(i) {
    return (0, $e52a696dfd98f1d3$var$_interval.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / $e9CHQ.durationWeek;
    });
}
var $e52a696dfd98f1d3$var$utcSunday = $e52a696dfd98f1d3$var$utcWeekday(0);
module.exports.utcSunday = $e52a696dfd98f1d3$var$utcSunday;
var $e52a696dfd98f1d3$var$utcMonday = $e52a696dfd98f1d3$var$utcWeekday(1);
module.exports.utcMonday = $e52a696dfd98f1d3$var$utcMonday;
var $e52a696dfd98f1d3$var$utcTuesday = $e52a696dfd98f1d3$var$utcWeekday(2);
module.exports.utcTuesday = $e52a696dfd98f1d3$var$utcTuesday;
var $e52a696dfd98f1d3$var$utcWednesday = $e52a696dfd98f1d3$var$utcWeekday(3);
module.exports.utcWednesday = $e52a696dfd98f1d3$var$utcWednesday;
var $e52a696dfd98f1d3$var$utcThursday = $e52a696dfd98f1d3$var$utcWeekday(4);
module.exports.utcThursday = $e52a696dfd98f1d3$var$utcThursday;
var $e52a696dfd98f1d3$var$utcFriday = $e52a696dfd98f1d3$var$utcWeekday(5);
module.exports.utcFriday = $e52a696dfd98f1d3$var$utcFriday;
var $e52a696dfd98f1d3$var$utcSaturday = $e52a696dfd98f1d3$var$utcWeekday(6);
module.exports.utcSaturday = $e52a696dfd98f1d3$var$utcSaturday;
var $e52a696dfd98f1d3$var$utcSundays = $e52a696dfd98f1d3$var$utcSunday.range;
module.exports.utcSundays = $e52a696dfd98f1d3$var$utcSundays;
var $e52a696dfd98f1d3$var$utcMondays = $e52a696dfd98f1d3$var$utcMonday.range;
module.exports.utcMondays = $e52a696dfd98f1d3$var$utcMondays;
var $e52a696dfd98f1d3$var$utcTuesdays = $e52a696dfd98f1d3$var$utcTuesday.range;
module.exports.utcTuesdays = $e52a696dfd98f1d3$var$utcTuesdays;
var $e52a696dfd98f1d3$var$utcWednesdays = $e52a696dfd98f1d3$var$utcWednesday.range;
module.exports.utcWednesdays = $e52a696dfd98f1d3$var$utcWednesdays;
var $e52a696dfd98f1d3$var$utcThursdays = $e52a696dfd98f1d3$var$utcThursday.range;
module.exports.utcThursdays = $e52a696dfd98f1d3$var$utcThursdays;
var $e52a696dfd98f1d3$var$utcFridays = $e52a696dfd98f1d3$var$utcFriday.range;
module.exports.utcFridays = $e52a696dfd98f1d3$var$utcFridays;
var $e52a696dfd98f1d3$var$utcSaturdays = $e52a696dfd98f1d3$var$utcSaturday.range;
module.exports.utcSaturdays = $e52a696dfd98f1d3$var$utcSaturdays;

});

parcelRegister("bbGbo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMonths = module.exports.default = void 0;

var $8251716d0dadebbe$var$_interval = $8251716d0dadebbe$var$_interopRequireDefault((parcelRequire("dNNtY")));
function $8251716d0dadebbe$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8251716d0dadebbe$var$utcMonth = (0, $8251716d0dadebbe$var$_interval.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $8251716d0dadebbe$var$_default = $8251716d0dadebbe$var$utcMonth;
module.exports.default = $8251716d0dadebbe$var$_default;
var $8251716d0dadebbe$var$utcMonths = $8251716d0dadebbe$var$utcMonth.range;
module.exports.utcMonths = $8251716d0dadebbe$var$utcMonths;

});

parcelRegister("1TEgN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcYears = module.exports.default = void 0;

var $161a2a47617328af$var$_interval = $161a2a47617328af$var$_interopRequireDefault((parcelRequire("dNNtY")));
function $161a2a47617328af$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $161a2a47617328af$var$utcYear = (0, $161a2a47617328af$var$_interval.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
}); // An optimized implementation for this simple case.
$161a2a47617328af$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $161a2a47617328af$var$_interval.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $161a2a47617328af$var$_default = $161a2a47617328af$var$utcYear;
module.exports.default = $161a2a47617328af$var$_default;
var $161a2a47617328af$var$utcYears = $161a2a47617328af$var$utcYear.range;
module.exports.utcYears = $161a2a47617328af$var$utcYears;

});

parcelRegister("aI4Av", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcTicks = module.exports.utcTickInterval = module.exports.timeTicks = module.exports.timeTickInterval = void 0;

var $2bySc = parcelRequire("2bySc");

var $e9CHQ = parcelRequire("e9CHQ");

var $7cc19276c5ab35c4$var$_millisecond = $7cc19276c5ab35c4$var$_interopRequireDefault((parcelRequire("8X4DO")));

var $7cc19276c5ab35c4$var$_second = $7cc19276c5ab35c4$var$_interopRequireDefault((parcelRequire("5NI8V")));

var $7cc19276c5ab35c4$var$_minute = $7cc19276c5ab35c4$var$_interopRequireDefault((parcelRequire("bAD7U")));

var $7cc19276c5ab35c4$var$_hour = $7cc19276c5ab35c4$var$_interopRequireDefault((parcelRequire("1MiSH")));

var $7cc19276c5ab35c4$var$_day = $7cc19276c5ab35c4$var$_interopRequireDefault((parcelRequire("9mQ3m")));

var $3wN2f = parcelRequire("3wN2f");

var $7cc19276c5ab35c4$var$_month = $7cc19276c5ab35c4$var$_interopRequireDefault((parcelRequire("623T2")));

var $7cc19276c5ab35c4$var$_year = $7cc19276c5ab35c4$var$_interopRequireDefault((parcelRequire("kW5jr")));

var $7cc19276c5ab35c4$var$_utcMinute = $7cc19276c5ab35c4$var$_interopRequireDefault((parcelRequire("94PXF")));

var $7cc19276c5ab35c4$var$_utcHour = $7cc19276c5ab35c4$var$_interopRequireDefault((parcelRequire("8L3wd")));

var $7cc19276c5ab35c4$var$_utcDay = $7cc19276c5ab35c4$var$_interopRequireDefault((parcelRequire("awAoj")));

var $jFQin = parcelRequire("jFQin");

var $7cc19276c5ab35c4$var$_utcMonth = $7cc19276c5ab35c4$var$_interopRequireDefault((parcelRequire("bbGbo")));

var $7cc19276c5ab35c4$var$_utcYear = $7cc19276c5ab35c4$var$_interopRequireDefault((parcelRequire("1TEgN")));
function $7cc19276c5ab35c4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7cc19276c5ab35c4$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            $7cc19276c5ab35c4$var$_second.default,
            1,
            $e9CHQ.durationSecond
        ],
        [
            $7cc19276c5ab35c4$var$_second.default,
            5,
            5 * $e9CHQ.durationSecond
        ],
        [
            $7cc19276c5ab35c4$var$_second.default,
            15,
            15 * $e9CHQ.durationSecond
        ],
        [
            $7cc19276c5ab35c4$var$_second.default,
            30,
            30 * $e9CHQ.durationSecond
        ],
        [
            minute,
            1,
            $e9CHQ.durationMinute
        ],
        [
            minute,
            5,
            5 * $e9CHQ.durationMinute
        ],
        [
            minute,
            15,
            15 * $e9CHQ.durationMinute
        ],
        [
            minute,
            30,
            30 * $e9CHQ.durationMinute
        ],
        [
            hour,
            1,
            $e9CHQ.durationHour
        ],
        [
            hour,
            3,
            3 * $e9CHQ.durationHour
        ],
        [
            hour,
            6,
            6 * $e9CHQ.durationHour
        ],
        [
            hour,
            12,
            12 * $e9CHQ.durationHour
        ],
        [
            day,
            1,
            $e9CHQ.durationDay
        ],
        [
            day,
            2,
            2 * $e9CHQ.durationDay
        ],
        [
            week,
            1,
            $e9CHQ.durationWeek
        ],
        [
            month,
            1,
            $e9CHQ.durationMonth
        ],
        [
            month,
            3,
            3 * $e9CHQ.durationMonth
        ],
        [
            year,
            1,
            $e9CHQ.durationYear
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $2bySc.bisector)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $2bySc.tickStep)(start / $e9CHQ.durationYear, stop / $e9CHQ.durationYear, count));
        if (i === 0) return $7cc19276c5ab35c4$var$_millisecond.default.every(Math.max((0, $2bySc.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$7cc19276c5ab35c4$var$utcTicks, $7cc19276c5ab35c4$var$utcTickInterval] = $7cc19276c5ab35c4$var$ticker($7cc19276c5ab35c4$var$_utcYear.default, $7cc19276c5ab35c4$var$_utcMonth.default, $jFQin.utcSunday, $7cc19276c5ab35c4$var$_utcDay.default, $7cc19276c5ab35c4$var$_utcHour.default, $7cc19276c5ab35c4$var$_utcMinute.default);
module.exports.utcTickInterval = $7cc19276c5ab35c4$var$utcTickInterval;
module.exports.utcTicks = $7cc19276c5ab35c4$var$utcTicks;
const [$7cc19276c5ab35c4$var$timeTicks, $7cc19276c5ab35c4$var$timeTickInterval] = $7cc19276c5ab35c4$var$ticker($7cc19276c5ab35c4$var$_year.default, $7cc19276c5ab35c4$var$_month.default, $3wN2f.sunday, $7cc19276c5ab35c4$var$_day.default, $7cc19276c5ab35c4$var$_hour.default, $7cc19276c5ab35c4$var$_minute.default);
module.exports.timeTickInterval = $7cc19276c5ab35c4$var$timeTickInterval;
module.exports.timeTicks = $7cc19276c5ab35c4$var$timeTicks;

});


parcelRegister("9mFI8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "isoFormat", {
    enumerable: true,
    get: function() {
        return $6d16860be4714172$var$_isoFormat.default;
    }
});
Object.defineProperty(module.exports, "isoParse", {
    enumerable: true,
    get: function() {
        return $6d16860be4714172$var$_isoParse.default;
    }
});
Object.defineProperty(module.exports, "timeFormat", {
    enumerable: true,
    get: function() {
        return $6d16860be4714172$var$_defaultLocale.timeFormat;
    }
});
Object.defineProperty(module.exports, "timeFormatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $6d16860be4714172$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "timeFormatLocale", {
    enumerable: true,
    get: function() {
        return $6d16860be4714172$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "timeParse", {
    enumerable: true,
    get: function() {
        return $6d16860be4714172$var$_defaultLocale.timeParse;
    }
});
Object.defineProperty(module.exports, "utcFormat", {
    enumerable: true,
    get: function() {
        return $6d16860be4714172$var$_defaultLocale.utcFormat;
    }
});
Object.defineProperty(module.exports, "utcParse", {
    enumerable: true,
    get: function() {
        return $6d16860be4714172$var$_defaultLocale.utcParse;
    }
});

var $6d16860be4714172$var$_defaultLocale = $6d16860be4714172$var$_interopRequireWildcard((parcelRequire("7cv0q")));

var $6d16860be4714172$var$_locale = $6d16860be4714172$var$_interopRequireDefault((parcelRequire("38TwJ")));

var $6d16860be4714172$var$_isoFormat = $6d16860be4714172$var$_interopRequireDefault((parcelRequire("37ALe")));

var $6d16860be4714172$var$_isoParse = $6d16860be4714172$var$_interopRequireDefault((parcelRequire("aLNmJ")));
function $6d16860be4714172$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6d16860be4714172$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($6d16860be4714172$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $6d16860be4714172$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $6d16860be4714172$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("7cv0q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $53e1b47d0f90a45a$var$defaultLocale;
module.exports.utcParse = module.exports.utcFormat = module.exports.timeParse = module.exports.timeFormat = void 0;

var $53e1b47d0f90a45a$var$_locale = $53e1b47d0f90a45a$var$_interopRequireDefault((parcelRequire("38TwJ")));
function $53e1b47d0f90a45a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $53e1b47d0f90a45a$var$locale;
var $53e1b47d0f90a45a$var$timeFormat;
module.exports.timeFormat = $53e1b47d0f90a45a$var$timeFormat;
var $53e1b47d0f90a45a$var$timeParse;
module.exports.timeParse = $53e1b47d0f90a45a$var$timeParse;
var $53e1b47d0f90a45a$var$utcFormat;
module.exports.utcFormat = $53e1b47d0f90a45a$var$utcFormat;
var $53e1b47d0f90a45a$var$utcParse;
module.exports.utcParse = $53e1b47d0f90a45a$var$utcParse;
$53e1b47d0f90a45a$var$defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $53e1b47d0f90a45a$var$defaultLocale(definition) {
    $53e1b47d0f90a45a$var$locale = (0, $53e1b47d0f90a45a$var$_locale.default)(definition);
    module.exports.timeFormat = $53e1b47d0f90a45a$var$timeFormat = $53e1b47d0f90a45a$var$locale.format;
    module.exports.timeParse = $53e1b47d0f90a45a$var$timeParse = $53e1b47d0f90a45a$var$locale.parse;
    module.exports.utcFormat = $53e1b47d0f90a45a$var$utcFormat = $53e1b47d0f90a45a$var$locale.utcFormat;
    module.exports.utcParse = $53e1b47d0f90a45a$var$utcParse = $53e1b47d0f90a45a$var$locale.utcParse;
    return $53e1b47d0f90a45a$var$locale;
}

});
parcelRegister("38TwJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $249d30f8161379fa$var$formatLocale;

var $1Bm3R = parcelRequire("1Bm3R");
function $249d30f8161379fa$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $249d30f8161379fa$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $249d30f8161379fa$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $249d30f8161379fa$var$formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $249d30f8161379fa$var$formatRe(locale_periods), periodLookup = $249d30f8161379fa$var$formatLookup(locale_periods), weekdayRe = $249d30f8161379fa$var$formatRe(locale_weekdays), weekdayLookup = $249d30f8161379fa$var$formatLookup(locale_weekdays), shortWeekdayRe = $249d30f8161379fa$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $249d30f8161379fa$var$formatLookup(locale_shortWeekdays), monthRe = $249d30f8161379fa$var$formatRe(locale_months), monthLookup = $249d30f8161379fa$var$formatLookup(locale_months), shortMonthRe = $249d30f8161379fa$var$formatRe(locale_shortMonths), shortMonthLookup = $249d30f8161379fa$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $249d30f8161379fa$var$formatDayOfMonth,
        "e": $249d30f8161379fa$var$formatDayOfMonth,
        "f": $249d30f8161379fa$var$formatMicroseconds,
        "g": $249d30f8161379fa$var$formatYearISO,
        "G": $249d30f8161379fa$var$formatFullYearISO,
        "H": $249d30f8161379fa$var$formatHour24,
        "I": $249d30f8161379fa$var$formatHour12,
        "j": $249d30f8161379fa$var$formatDayOfYear,
        "L": $249d30f8161379fa$var$formatMilliseconds,
        "m": $249d30f8161379fa$var$formatMonthNumber,
        "M": $249d30f8161379fa$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $249d30f8161379fa$var$formatUnixTimestamp,
        "s": $249d30f8161379fa$var$formatUnixTimestampSeconds,
        "S": $249d30f8161379fa$var$formatSeconds,
        "u": $249d30f8161379fa$var$formatWeekdayNumberMonday,
        "U": $249d30f8161379fa$var$formatWeekNumberSunday,
        "V": $249d30f8161379fa$var$formatWeekNumberISO,
        "w": $249d30f8161379fa$var$formatWeekdayNumberSunday,
        "W": $249d30f8161379fa$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $249d30f8161379fa$var$formatYear,
        "Y": $249d30f8161379fa$var$formatFullYear,
        "Z": $249d30f8161379fa$var$formatZone,
        "%": $249d30f8161379fa$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $249d30f8161379fa$var$formatUTCDayOfMonth,
        "e": $249d30f8161379fa$var$formatUTCDayOfMonth,
        "f": $249d30f8161379fa$var$formatUTCMicroseconds,
        "g": $249d30f8161379fa$var$formatUTCYearISO,
        "G": $249d30f8161379fa$var$formatUTCFullYearISO,
        "H": $249d30f8161379fa$var$formatUTCHour24,
        "I": $249d30f8161379fa$var$formatUTCHour12,
        "j": $249d30f8161379fa$var$formatUTCDayOfYear,
        "L": $249d30f8161379fa$var$formatUTCMilliseconds,
        "m": $249d30f8161379fa$var$formatUTCMonthNumber,
        "M": $249d30f8161379fa$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $249d30f8161379fa$var$formatUnixTimestamp,
        "s": $249d30f8161379fa$var$formatUnixTimestampSeconds,
        "S": $249d30f8161379fa$var$formatUTCSeconds,
        "u": $249d30f8161379fa$var$formatUTCWeekdayNumberMonday,
        "U": $249d30f8161379fa$var$formatUTCWeekNumberSunday,
        "V": $249d30f8161379fa$var$formatUTCWeekNumberISO,
        "w": $249d30f8161379fa$var$formatUTCWeekdayNumberSunday,
        "W": $249d30f8161379fa$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $249d30f8161379fa$var$formatUTCYear,
        "Y": $249d30f8161379fa$var$formatUTCFullYear,
        "Z": $249d30f8161379fa$var$formatUTCZone,
        "%": $249d30f8161379fa$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $249d30f8161379fa$var$parseDayOfMonth,
        "e": $249d30f8161379fa$var$parseDayOfMonth,
        "f": $249d30f8161379fa$var$parseMicroseconds,
        "g": $249d30f8161379fa$var$parseYear,
        "G": $249d30f8161379fa$var$parseFullYear,
        "H": $249d30f8161379fa$var$parseHour24,
        "I": $249d30f8161379fa$var$parseHour24,
        "j": $249d30f8161379fa$var$parseDayOfYear,
        "L": $249d30f8161379fa$var$parseMilliseconds,
        "m": $249d30f8161379fa$var$parseMonthNumber,
        "M": $249d30f8161379fa$var$parseMinutes,
        "p": parsePeriod,
        "q": $249d30f8161379fa$var$parseQuarter,
        "Q": $249d30f8161379fa$var$parseUnixTimestamp,
        "s": $249d30f8161379fa$var$parseUnixTimestampSeconds,
        "S": $249d30f8161379fa$var$parseSeconds,
        "u": $249d30f8161379fa$var$parseWeekdayNumberMonday,
        "U": $249d30f8161379fa$var$parseWeekNumberSunday,
        "V": $249d30f8161379fa$var$parseWeekNumberISO,
        "w": $249d30f8161379fa$var$parseWeekdayNumberSunday,
        "W": $249d30f8161379fa$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $249d30f8161379fa$var$parseYear,
        "Y": $249d30f8161379fa$var$parseFullYear,
        "Z": $249d30f8161379fa$var$parseZone,
        "%": $249d30f8161379fa$var$parseLiteralPercent
    }; // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $249d30f8161379fa$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $249d30f8161379fa$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null; // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0)); // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0; // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12; // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0; // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $249d30f8161379fa$var$utcDate($249d30f8161379fa$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? $1Bm3R.utcMonday.ceil(week) : (0, $1Bm3R.utcMonday)(week);
                    week = $1Bm3R.utcDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $249d30f8161379fa$var$localDate($249d30f8161379fa$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? $1Bm3R.timeMonday.ceil(week) : (0, $1Bm3R.timeMonday)(week);
                    week = $1Bm3R.timeDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $249d30f8161379fa$var$utcDate($249d30f8161379fa$var$newDate(d.y, 0, 1)).getUTCDay() : $249d30f8161379fa$var$localDate($249d30f8161379fa$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            } // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $249d30f8161379fa$var$utcDate(d);
            } // Otherwise, all fields are in local time.
            return $249d30f8161379fa$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $249d30f8161379fa$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $249d30f8161379fa$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $249d30f8161379fa$var$numberRe = /^\s*\d+/, // note: ignores next directive
$249d30f8161379fa$var$percentRe = /^%/, $249d30f8161379fa$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $249d30f8161379fa$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $249d30f8161379fa$var$requote(s) {
    return s.replace($249d30f8161379fa$var$requoteRe, "\\$&");
}
function $249d30f8161379fa$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($249d30f8161379fa$var$requote).join("|") + ")", "i");
}
function $249d30f8161379fa$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $249d30f8161379fa$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $249d30f8161379fa$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $249d30f8161379fa$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $249d30f8161379fa$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $249d30f8161379fa$var$parseWeekNumberSunday(d, string, i) {
    var n = $249d30f8161379fa$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $249d30f8161379fa$var$parseWeekNumberISO(d, string, i) {
    var n = $249d30f8161379fa$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $249d30f8161379fa$var$parseWeekNumberMonday(d, string, i) {
    var n = $249d30f8161379fa$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $249d30f8161379fa$var$parseFullYear(d, string, i) {
    var n = $249d30f8161379fa$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $249d30f8161379fa$var$parseYear(d, string, i) {
    var n = $249d30f8161379fa$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $249d30f8161379fa$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $249d30f8161379fa$var$parseQuarter(d, string, i) {
    var n = $249d30f8161379fa$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $249d30f8161379fa$var$parseMonthNumber(d, string, i) {
    var n = $249d30f8161379fa$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $249d30f8161379fa$var$parseDayOfMonth(d, string, i) {
    var n = $249d30f8161379fa$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $249d30f8161379fa$var$parseDayOfYear(d, string, i) {
    var n = $249d30f8161379fa$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $249d30f8161379fa$var$parseHour24(d, string, i) {
    var n = $249d30f8161379fa$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $249d30f8161379fa$var$parseMinutes(d, string, i) {
    var n = $249d30f8161379fa$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $249d30f8161379fa$var$parseSeconds(d, string, i) {
    var n = $249d30f8161379fa$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $249d30f8161379fa$var$parseMilliseconds(d, string, i) {
    var n = $249d30f8161379fa$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $249d30f8161379fa$var$parseMicroseconds(d, string, i) {
    var n = $249d30f8161379fa$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $249d30f8161379fa$var$parseLiteralPercent(d, string, i) {
    var n = $249d30f8161379fa$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $249d30f8161379fa$var$parseUnixTimestamp(d, string, i) {
    var n = $249d30f8161379fa$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $249d30f8161379fa$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $249d30f8161379fa$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $249d30f8161379fa$var$formatDayOfMonth(d, p) {
    return $249d30f8161379fa$var$pad(d.getDate(), p, 2);
}
function $249d30f8161379fa$var$formatHour24(d, p) {
    return $249d30f8161379fa$var$pad(d.getHours(), p, 2);
}
function $249d30f8161379fa$var$formatHour12(d, p) {
    return $249d30f8161379fa$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $249d30f8161379fa$var$formatDayOfYear(d, p) {
    return $249d30f8161379fa$var$pad(1 + $1Bm3R.timeDay.count((0, $1Bm3R.timeYear)(d), d), p, 3);
}
function $249d30f8161379fa$var$formatMilliseconds(d, p) {
    return $249d30f8161379fa$var$pad(d.getMilliseconds(), p, 3);
}
function $249d30f8161379fa$var$formatMicroseconds(d, p) {
    return $249d30f8161379fa$var$formatMilliseconds(d, p) + "000";
}
function $249d30f8161379fa$var$formatMonthNumber(d, p) {
    return $249d30f8161379fa$var$pad(d.getMonth() + 1, p, 2);
}
function $249d30f8161379fa$var$formatMinutes(d, p) {
    return $249d30f8161379fa$var$pad(d.getMinutes(), p, 2);
}
function $249d30f8161379fa$var$formatSeconds(d, p) {
    return $249d30f8161379fa$var$pad(d.getSeconds(), p, 2);
}
function $249d30f8161379fa$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $249d30f8161379fa$var$formatWeekNumberSunday(d, p) {
    return $249d30f8161379fa$var$pad($1Bm3R.timeSunday.count((0, $1Bm3R.timeYear)(d) - 1, d), p, 2);
}
function $249d30f8161379fa$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $1Bm3R.timeThursday)(d) : $1Bm3R.timeThursday.ceil(d);
}
function $249d30f8161379fa$var$formatWeekNumberISO(d, p) {
    d = $249d30f8161379fa$var$dISO(d);
    return $249d30f8161379fa$var$pad($1Bm3R.timeThursday.count((0, $1Bm3R.timeYear)(d), d) + ((0, $1Bm3R.timeYear)(d).getDay() === 4), p, 2);
}
function $249d30f8161379fa$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $249d30f8161379fa$var$formatWeekNumberMonday(d, p) {
    return $249d30f8161379fa$var$pad($1Bm3R.timeMonday.count((0, $1Bm3R.timeYear)(d) - 1, d), p, 2);
}
function $249d30f8161379fa$var$formatYear(d, p) {
    return $249d30f8161379fa$var$pad(d.getFullYear() % 100, p, 2);
}
function $249d30f8161379fa$var$formatYearISO(d, p) {
    d = $249d30f8161379fa$var$dISO(d);
    return $249d30f8161379fa$var$pad(d.getFullYear() % 100, p, 2);
}
function $249d30f8161379fa$var$formatFullYear(d, p) {
    return $249d30f8161379fa$var$pad(d.getFullYear() % 10000, p, 4);
}
function $249d30f8161379fa$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $1Bm3R.timeThursday)(d) : $1Bm3R.timeThursday.ceil(d);
    return $249d30f8161379fa$var$pad(d.getFullYear() % 10000, p, 4);
}
function $249d30f8161379fa$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $249d30f8161379fa$var$pad(z / 60 | 0, "0", 2) + $249d30f8161379fa$var$pad(z % 60, "0", 2);
}
function $249d30f8161379fa$var$formatUTCDayOfMonth(d, p) {
    return $249d30f8161379fa$var$pad(d.getUTCDate(), p, 2);
}
function $249d30f8161379fa$var$formatUTCHour24(d, p) {
    return $249d30f8161379fa$var$pad(d.getUTCHours(), p, 2);
}
function $249d30f8161379fa$var$formatUTCHour12(d, p) {
    return $249d30f8161379fa$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $249d30f8161379fa$var$formatUTCDayOfYear(d, p) {
    return $249d30f8161379fa$var$pad(1 + $1Bm3R.utcDay.count((0, $1Bm3R.utcYear)(d), d), p, 3);
}
function $249d30f8161379fa$var$formatUTCMilliseconds(d, p) {
    return $249d30f8161379fa$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $249d30f8161379fa$var$formatUTCMicroseconds(d, p) {
    return $249d30f8161379fa$var$formatUTCMilliseconds(d, p) + "000";
}
function $249d30f8161379fa$var$formatUTCMonthNumber(d, p) {
    return $249d30f8161379fa$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $249d30f8161379fa$var$formatUTCMinutes(d, p) {
    return $249d30f8161379fa$var$pad(d.getUTCMinutes(), p, 2);
}
function $249d30f8161379fa$var$formatUTCSeconds(d, p) {
    return $249d30f8161379fa$var$pad(d.getUTCSeconds(), p, 2);
}
function $249d30f8161379fa$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $249d30f8161379fa$var$formatUTCWeekNumberSunday(d, p) {
    return $249d30f8161379fa$var$pad($1Bm3R.utcSunday.count((0, $1Bm3R.utcYear)(d) - 1, d), p, 2);
}
function $249d30f8161379fa$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $1Bm3R.utcThursday)(d) : $1Bm3R.utcThursday.ceil(d);
}
function $249d30f8161379fa$var$formatUTCWeekNumberISO(d, p) {
    d = $249d30f8161379fa$var$UTCdISO(d);
    return $249d30f8161379fa$var$pad($1Bm3R.utcThursday.count((0, $1Bm3R.utcYear)(d), d) + ((0, $1Bm3R.utcYear)(d).getUTCDay() === 4), p, 2);
}
function $249d30f8161379fa$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $249d30f8161379fa$var$formatUTCWeekNumberMonday(d, p) {
    return $249d30f8161379fa$var$pad($1Bm3R.utcMonday.count((0, $1Bm3R.utcYear)(d) - 1, d), p, 2);
}
function $249d30f8161379fa$var$formatUTCYear(d, p) {
    return $249d30f8161379fa$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $249d30f8161379fa$var$formatUTCYearISO(d, p) {
    d = $249d30f8161379fa$var$UTCdISO(d);
    return $249d30f8161379fa$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $249d30f8161379fa$var$formatUTCFullYear(d, p) {
    return $249d30f8161379fa$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $249d30f8161379fa$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $1Bm3R.utcThursday)(d) : $1Bm3R.utcThursday.ceil(d);
    return $249d30f8161379fa$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $249d30f8161379fa$var$formatUTCZone() {
    return "+0000";
}
function $249d30f8161379fa$var$formatLiteralPercent() {
    return "%";
}
function $249d30f8161379fa$var$formatUnixTimestamp(d) {
    return +d;
}
function $249d30f8161379fa$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

});


parcelRegister("37ALe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isoSpecifier = module.exports.default = void 0;

var $7cv0q = parcelRequire("7cv0q");
var $245e8a7a70e383ef$var$isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
module.exports.isoSpecifier = $245e8a7a70e383ef$var$isoSpecifier;
function $245e8a7a70e383ef$var$formatIsoNative(date) {
    return date.toISOString();
}
var $245e8a7a70e383ef$var$formatIso = Date.prototype.toISOString ? $245e8a7a70e383ef$var$formatIsoNative : (0, $7cv0q.utcFormat)($245e8a7a70e383ef$var$isoSpecifier);
var $245e8a7a70e383ef$var$_default = $245e8a7a70e383ef$var$formatIso;
module.exports.default = $245e8a7a70e383ef$var$_default;

});

parcelRegister("aLNmJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $37ALe = parcelRequire("37ALe");

var $7cv0q = parcelRequire("7cv0q");
function $7d74962e0e66e091$var$parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var $7d74962e0e66e091$var$parseIso = +new Date("2000-01-01T00:00:00.000Z") ? $7d74962e0e66e091$var$parseIsoNative : (0, $7cv0q.utcParse)($37ALe.isoSpecifier);
var $7d74962e0e66e091$var$_default = $7d74962e0e66e091$var$parseIso;
module.exports.default = $7d74962e0e66e091$var$_default;

});



parcelRegister("7OWIf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5b1abf0d77841f88$var$utcTime;

var $1Bm3R = parcelRequire("1Bm3R");

var $9mFI8 = parcelRequire("9mFI8");

var $kLoNf = parcelRequire("kLoNf");

var $8vtGb = parcelRequire("8vtGb");
function $5b1abf0d77841f88$var$utcTime() {
    return $8vtGb.initRange.apply((0, $kLoNf.calendar)($1Bm3R.utcTicks, $1Bm3R.utcTickInterval, $1Bm3R.utcYear, $1Bm3R.utcMonth, $1Bm3R.utcWeek, $1Bm3R.utcDay, $1Bm3R.utcHour, $1Bm3R.utcMinute, $1Bm3R.utcSecond, $9mFI8.utcFormat).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

});

parcelRegister("eybci", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $a97ced354d37f021$var$copy;
module.exports.default = $a97ced354d37f021$var$sequential;
module.exports.sequentialLog = $a97ced354d37f021$var$sequentialLog;
module.exports.sequentialPow = $a97ced354d37f021$var$sequentialPow;
module.exports.sequentialSqrt = $a97ced354d37f021$var$sequentialSqrt;
module.exports.sequentialSymlog = $a97ced354d37f021$var$sequentialSymlog;

var $8NXT9 = parcelRequire("8NXT9");

var $4ofCy = parcelRequire("4ofCy");

var $8vtGb = parcelRequire("8vtGb");

var $5bYdw = parcelRequire("5bYdw");

var $acYkY = parcelRequire("acYkY");

var $e8pBQ = parcelRequire("e8pBQ");

var $aQ2CU = parcelRequire("aQ2CU");
function $a97ced354d37f021$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = $4ofCy.identity, clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range($8NXT9.interpolate);
    scale.rangeRound = range($8NXT9.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $a97ced354d37f021$var$copy(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $a97ced354d37f021$var$sequential() {
    var scale = (0, $5bYdw.linearish)($a97ced354d37f021$var$transformer()($4ofCy.identity));
    scale.copy = function() {
        return $a97ced354d37f021$var$copy(scale, $a97ced354d37f021$var$sequential());
    };
    return $8vtGb.initInterpolator.apply(scale, arguments);
}
function $a97ced354d37f021$var$sequentialLog() {
    var scale = (0, $acYkY.loggish)($a97ced354d37f021$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $a97ced354d37f021$var$copy(scale, $a97ced354d37f021$var$sequentialLog()).base(scale.base());
    };
    return $8vtGb.initInterpolator.apply(scale, arguments);
}
function $a97ced354d37f021$var$sequentialSymlog() {
    var scale = (0, $e8pBQ.symlogish)($a97ced354d37f021$var$transformer());
    scale.copy = function() {
        return $a97ced354d37f021$var$copy(scale, $a97ced354d37f021$var$sequentialSymlog()).constant(scale.constant());
    };
    return $8vtGb.initInterpolator.apply(scale, arguments);
}
function $a97ced354d37f021$var$sequentialPow() {
    var scale = (0, $aQ2CU.powish)($a97ced354d37f021$var$transformer());
    scale.copy = function() {
        return $a97ced354d37f021$var$copy(scale, $a97ced354d37f021$var$sequentialPow()).exponent(scale.exponent());
    };
    return $8vtGb.initInterpolator.apply(scale, arguments);
}
function $a97ced354d37f021$var$sequentialSqrt() {
    return $a97ced354d37f021$var$sequentialPow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("ihnVV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d4ec6127886b5234$var$sequentialQuantile;

var $2bySc = parcelRequire("2bySc");

var $4ofCy = parcelRequire("4ofCy");

var $8vtGb = parcelRequire("8vtGb");
function $d4ec6127886b5234$var$sequentialQuantile() {
    var domain = [], interpolator = $4ofCy.identity;
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, $2bySc.bisect)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($2bySc.ascending);
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, $2bySc.quantile)(domain, i / n));
    };
    scale.copy = function() {
        return $d4ec6127886b5234$var$sequentialQuantile(interpolator).domain(domain);
    };
    return $8vtGb.initInterpolator.apply(scale, arguments);
}

});

parcelRegister("i4lEL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d2796642404debf4$var$diverging;
module.exports.divergingLog = $d2796642404debf4$var$divergingLog;
module.exports.divergingPow = $d2796642404debf4$var$divergingPow;
module.exports.divergingSqrt = $d2796642404debf4$var$divergingSqrt;
module.exports.divergingSymlog = $d2796642404debf4$var$divergingSymlog;

var $8NXT9 = parcelRequire("8NXT9");

var $4ofCy = parcelRequire("4ofCy");

var $8vtGb = parcelRequire("8vtGb");

var $5bYdw = parcelRequire("5bYdw");

var $acYkY = parcelRequire("acYkY");

var $eybci = parcelRequire("eybci");

var $e8pBQ = parcelRequire("e8pBQ");

var $aQ2CU = parcelRequire("aQ2CU");
function $d2796642404debf4$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = $4ofCy.identity, transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, $8NXT9.piecewise)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range($8NXT9.interpolate);
    scale.rangeRound = range($8NXT9.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $d2796642404debf4$var$diverging() {
    var scale = (0, $5bYdw.linearish)($d2796642404debf4$var$transformer()($4ofCy.identity));
    scale.copy = function() {
        return (0, $eybci.copy)(scale, $d2796642404debf4$var$diverging());
    };
    return $8vtGb.initInterpolator.apply(scale, arguments);
}
function $d2796642404debf4$var$divergingLog() {
    var scale = (0, $acYkY.loggish)($d2796642404debf4$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $eybci.copy)(scale, $d2796642404debf4$var$divergingLog()).base(scale.base());
    };
    return $8vtGb.initInterpolator.apply(scale, arguments);
}
function $d2796642404debf4$var$divergingSymlog() {
    var scale = (0, $e8pBQ.symlogish)($d2796642404debf4$var$transformer());
    scale.copy = function() {
        return (0, $eybci.copy)(scale, $d2796642404debf4$var$divergingSymlog()).constant(scale.constant());
    };
    return $8vtGb.initInterpolator.apply(scale, arguments);
}
function $d2796642404debf4$var$divergingPow() {
    var scale = (0, $aQ2CU.powish)($d2796642404debf4$var$transformer());
    scale.copy = function() {
        return (0, $eybci.copy)(scale, $d2796642404debf4$var$divergingPow()).exponent(scale.exponent());
    };
    return $8vtGb.initInterpolator.apply(scale, arguments);
}
function $d2796642404debf4$var$divergingSqrt() {
    return $d2796642404debf4$var$divergingPow.apply(null, arguments).exponent(0.5);
}

});




parcelRegister("2vCNF", function(module, exports) {

var $462cn = parcelRequire("462cn");

var $60fox = parcelRequire("60fox");

var $l8YZt = parcelRequire("l8YZt");
/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */ function $1d3c92ea9859372b$var$min(array) {
    return array && array.length ? $462cn(array, $l8YZt, $60fox) : undefined;
}
module.exports = $1d3c92ea9859372b$var$min;

});
parcelRegister("60fox", function(module, exports) {
/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */ function $45eeaf404d984aa4$var$baseLt(value, other) {
    return value < other;
}
module.exports = $45eeaf404d984aa4$var$baseLt;

});


parcelRegister("cCcFB", function(module, exports) {

var $avh5F = parcelRequire("avh5F");

var $7HijS = parcelRequire("7HijS");
/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $92f2dca39ce38614$var$flatMap(collection, iteratee) {
    return $avh5F($7HijS(collection, iteratee), 1);
}
module.exports = $92f2dca39ce38614$var$flatMap;

});
parcelRegister("avh5F", function(module, exports) {

var $8lg0J = parcelRequire("8lg0J");

var $b7fQn = parcelRequire("b7fQn");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $7a5a0e70e30a1adb$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $b7fQn);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $7a5a0e70e30a1adb$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $8lg0J(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $7a5a0e70e30a1adb$var$baseFlatten;

});
parcelRegister("b7fQn", function(module, exports) {

var $1QaHq = parcelRequire("1QaHq");

var $5rXka = parcelRequire("5rXka");

var $687Zl = parcelRequire("687Zl");
/** Built-in value references. */ var $817ca3633bf76154$var$spreadableSymbol = $1QaHq ? $1QaHq.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $817ca3633bf76154$var$isFlattenable(value) {
    return $687Zl(value) || $5rXka(value) || !!($817ca3633bf76154$var$spreadableSymbol && value && value[$817ca3633bf76154$var$spreadableSymbol]);
}
module.exports = $817ca3633bf76154$var$isFlattenable;

});


parcelRegister("7HijS", function(module, exports) {

var $f63qI = parcelRequire("f63qI");

var $15GS2 = parcelRequire("15GS2");

var $fl2Ga = parcelRequire("fl2Ga");

var $687Zl = parcelRequire("687Zl");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $01723cf1528165c0$var$map(collection, iteratee) {
    var func = $687Zl(collection) ? $f63qI : $fl2Ga;
    return func(collection, $15GS2(iteratee, 3));
}
module.exports = $01723cf1528165c0$var$map;

});
parcelRegister("15GS2", function(module, exports) {

var $jCV6W = parcelRequire("jCV6W");

var $aRFbX = parcelRequire("aRFbX");

var $l8YZt = parcelRequire("l8YZt");

var $687Zl = parcelRequire("687Zl");

var $5IrGZ = parcelRequire("5IrGZ");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $0cb783472cda9de9$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $l8YZt;
    if (typeof value == "object") return $687Zl(value) ? $aRFbX(value[0], value[1]) : $jCV6W(value);
    return $5IrGZ(value);
}
module.exports = $0cb783472cda9de9$var$baseIteratee;

});
parcelRegister("jCV6W", function(module, exports) {

var $5QVh0 = parcelRequire("5QVh0");

var $44fe6 = parcelRequire("44fe6");

var $iqPy9 = parcelRequire("iqPy9");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $03aff7318e4404cc$var$baseMatches(source) {
    var matchData = $44fe6(source);
    if (matchData.length == 1 && matchData[0][2]) return $iqPy9(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $5QVh0(object, source, matchData);
    };
}
module.exports = $03aff7318e4404cc$var$baseMatches;

});
parcelRegister("5QVh0", function(module, exports) {

var $asKzW = parcelRequire("asKzW");

var $3SVoe = parcelRequire("3SVoe");
/** Used to compose bitmasks for value comparisons. */ var $0119851a417f3d34$var$COMPARE_PARTIAL_FLAG = 1, $0119851a417f3d34$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $0119851a417f3d34$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $asKzW;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $3SVoe(srcValue, objValue, $0119851a417f3d34$var$COMPARE_PARTIAL_FLAG | $0119851a417f3d34$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $0119851a417f3d34$var$baseIsMatch;

});

parcelRegister("44fe6", function(module, exports) {

var $53Nzk = parcelRequire("53Nzk");

var $lVjOx = parcelRequire("lVjOx");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $2f6358ca06ba1751$var$getMatchData(object) {
    var result = $lVjOx(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $53Nzk(value)
        ];
    }
    return result;
}
module.exports = $2f6358ca06ba1751$var$getMatchData;

});
parcelRegister("53Nzk", function(module, exports) {

var $hBKZ2 = parcelRequire("hBKZ2");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $3af3aeec03b7fff3$var$isStrictComparable(value) {
    return value === value && !$hBKZ2(value);
}
module.exports = $3af3aeec03b7fff3$var$isStrictComparable;

});


parcelRegister("iqPy9", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $d6b2a472b674bb7e$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $d6b2a472b674bb7e$var$matchesStrictComparable;

});


parcelRegister("aRFbX", function(module, exports) {

var $3SVoe = parcelRequire("3SVoe");

var $lNQsK = parcelRequire("lNQsK");

var $3psUZ = parcelRequire("3psUZ");

var $kgsO2 = parcelRequire("kgsO2");

var $53Nzk = parcelRequire("53Nzk");

var $iqPy9 = parcelRequire("iqPy9");

var $hZ9oa = parcelRequire("hZ9oa");
/** Used to compose bitmasks for value comparisons. */ var $7e8ece77e94343d1$var$COMPARE_PARTIAL_FLAG = 1, $7e8ece77e94343d1$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $7e8ece77e94343d1$var$baseMatchesProperty(path, srcValue) {
    if ($kgsO2(path) && $53Nzk(srcValue)) return $iqPy9($hZ9oa(path), srcValue);
    return function(object) {
        var objValue = $lNQsK(object, path);
        return objValue === undefined && objValue === srcValue ? $3psUZ(object, path) : $3SVoe(srcValue, objValue, $7e8ece77e94343d1$var$COMPARE_PARTIAL_FLAG | $7e8ece77e94343d1$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $7e8ece77e94343d1$var$baseMatchesProperty;

});
parcelRegister("3psUZ", function(module, exports) {

var $eQ7VH = parcelRequire("eQ7VH");

var $3uNAr = parcelRequire("3uNAr");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $27ba2378f41ea68f$var$hasIn(object, path) {
    return object != null && $3uNAr(object, path, $eQ7VH);
}
module.exports = $27ba2378f41ea68f$var$hasIn;

});
parcelRegister("eQ7VH", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $acdc12b29cb1d926$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $acdc12b29cb1d926$var$baseHasIn;

});

parcelRegister("3uNAr", function(module, exports) {

var $egGZR = parcelRequire("egGZR");

var $5rXka = parcelRequire("5rXka");

var $687Zl = parcelRequire("687Zl");

var $4DenX = parcelRequire("4DenX");

var $fzuB5 = parcelRequire("fzuB5");

var $hZ9oa = parcelRequire("hZ9oa");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $28baa350a2a93758$var$hasPath(object, path, hasFunc) {
    path = $egGZR(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $hZ9oa(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $fzuB5(length) && $4DenX(key, length) && ($687Zl(object) || $5rXka(object));
}
module.exports = $28baa350a2a93758$var$hasPath;

});



parcelRegister("5IrGZ", function(module, exports) {

var $hAcfn = parcelRequire("hAcfn");

var $kotE2 = parcelRequire("kotE2");

var $kgsO2 = parcelRequire("kgsO2");

var $hZ9oa = parcelRequire("hZ9oa");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $42968aedef058eec$var$property(path) {
    return $kgsO2(path) ? $hAcfn($hZ9oa(path)) : $kotE2(path);
}
module.exports = $42968aedef058eec$var$property;

});
parcelRegister("hAcfn", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $cccf4c7937806a0c$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $cccf4c7937806a0c$var$baseProperty;

});

parcelRegister("kotE2", function(module, exports) {

var $2HLB2 = parcelRequire("2HLB2");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $ed8d0b5de44bf271$var$basePropertyDeep(path) {
    return function(object) {
        return $2HLB2(object, path);
    };
}
module.exports = $ed8d0b5de44bf271$var$basePropertyDeep;

});



parcelRegister("fl2Ga", function(module, exports) {

var $hQ9aw = parcelRequire("hQ9aw");

var $5KNSm = parcelRequire("5KNSm");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $b2aae535568f671b$var$baseMap(collection, iteratee) {
    var index = -1, result = $5KNSm(collection) ? Array(collection.length) : [];
    $hQ9aw(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = $b2aae535568f671b$var$baseMap;

});
parcelRegister("hQ9aw", function(module, exports) {

var $kBC6R = parcelRequire("kBC6R");

var $fMmE1 = parcelRequire("fMmE1");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $cfce67b38830cfdb$var$baseEach = $fMmE1($kBC6R);
module.exports = $cfce67b38830cfdb$var$baseEach;

});
parcelRegister("kBC6R", function(module, exports) {

var $k6cy6 = parcelRequire("k6cy6");

var $lVjOx = parcelRequire("lVjOx");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $f004d31d9311ca88$var$baseForOwn(object, iteratee) {
    return object && $k6cy6(object, iteratee, $lVjOx);
}
module.exports = $f004d31d9311ca88$var$baseForOwn;

});
parcelRegister("k6cy6", function(module, exports) {

var $5zxR5 = parcelRequire("5zxR5");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $ea1e1a24eae58896$var$baseFor = $5zxR5();
module.exports = $ea1e1a24eae58896$var$baseFor;

});
parcelRegister("5zxR5", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $40ea7b903bbc8372$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $40ea7b903bbc8372$var$createBaseFor;

});



parcelRegister("fMmE1", function(module, exports) {

var $5KNSm = parcelRequire("5KNSm");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $b7cce7738117d66a$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$5KNSm(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $b7cce7738117d66a$var$createBaseEach;

});





parcelRegister("lfx6l", function(module, exports) {

var $avh5F = parcelRequire("avh5F");

var $kLpOm = parcelRequire("kLpOm");

var $hJtVH = parcelRequire("hJtVH");

var $6PImS = parcelRequire("6PImS");
/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $f784acf2e305b2ef$var$sortBy = $hJtVH(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $6PImS(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $6PImS(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $kLpOm(collection, $avh5F(iteratees, 1), []);
});
module.exports = $f784acf2e305b2ef$var$sortBy;

});
parcelRegister("kLpOm", function(module, exports) {

var $f63qI = parcelRequire("f63qI");

var $2HLB2 = parcelRequire("2HLB2");

var $15GS2 = parcelRequire("15GS2");

var $fl2Ga = parcelRequire("fl2Ga");

var $dTpFr = parcelRequire("dTpFr");

var $lGylI = parcelRequire("lGylI");

var $H8Twd = parcelRequire("H8Twd");

var $l8YZt = parcelRequire("l8YZt");

var $687Zl = parcelRequire("687Zl");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $f1dc3801205b8cff$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $f63qI(iteratees, function(iteratee) {
        if ($687Zl(iteratee)) return function(value) {
            return $2HLB2(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $l8YZt
    ];
    var index = -1;
    iteratees = $f63qI(iteratees, $lGylI($15GS2));
    var result = $fl2Ga(collection, function(value, key, collection) {
        var criteria = $f63qI(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            "criteria": criteria,
            "index": ++index,
            "value": value
        };
    });
    return $dTpFr(result, function(object, other) {
        return $H8Twd(object, other, orders);
    });
}
module.exports = $f1dc3801205b8cff$var$baseOrderBy;

});
parcelRegister("dTpFr", function(module, exports) {
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $a1d4526c3324c5b7$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
module.exports = $a1d4526c3324c5b7$var$baseSortBy;

});

parcelRegister("H8Twd", function(module, exports) {

var $5syL9 = parcelRequire("5syL9");
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $081aea85960fabe9$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $5syL9(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == "desc" ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
module.exports = $081aea85960fabe9$var$compareMultiple;

});
parcelRegister("5syL9", function(module, exports) {

var $5Ob3C = parcelRequire("5Ob3C");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $3f9a87c6ce11bb09$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $5Ob3C(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $5Ob3C(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
module.exports = $3f9a87c6ce11bb09$var$compareAscending;

});



parcelRegister("hJtVH", function(module, exports) {

var $l8YZt = parcelRequire("l8YZt");

var $ci3r8 = parcelRequire("ci3r8");

var $hrmyo = parcelRequire("hrmyo");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $ce8ddb0941089020$var$baseRest(func, start) {
    return $hrmyo($ci3r8(func, start, $l8YZt), func + "");
}
module.exports = $ce8ddb0941089020$var$baseRest;

});
parcelRegister("ci3r8", function(module, exports) {

var $eTERZ = parcelRequire("eTERZ");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $8f29d4ea4bdbca42$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $8f29d4ea4bdbca42$var$overRest(func, start, transform) {
    start = $8f29d4ea4bdbca42$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $8f29d4ea4bdbca42$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $eTERZ(func, this, otherArgs);
    };
}
module.exports = $8f29d4ea4bdbca42$var$overRest;

});
parcelRegister("eTERZ", function(module, exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $ad85e79e69e60377$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = $ad85e79e69e60377$var$apply;

});


parcelRegister("hrmyo", function(module, exports) {

var $eg6N1 = parcelRequire("eg6N1");

var $bkbse = parcelRequire("bkbse");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $cb267400d2c80884$var$setToString = $bkbse($eg6N1);
module.exports = $cb267400d2c80884$var$setToString;

});
parcelRegister("eg6N1", function(module, exports) {

var $kAbzE = parcelRequire("kAbzE");

var $a91q9 = parcelRequire("a91q9");

var $l8YZt = parcelRequire("l8YZt");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $a617d39af0689048$var$baseSetToString = !$a91q9 ? $l8YZt : function(func, string) {
    return $a91q9(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": $kAbzE(string),
        "writable": true
    });
};
module.exports = $a617d39af0689048$var$baseSetToString;

});
parcelRegister("kAbzE", function(module, exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $efc025d1e299068f$var$constant(value) {
    return function() {
        return value;
    };
}
module.exports = $efc025d1e299068f$var$constant;

});

parcelRegister("a91q9", function(module, exports) {

var $743br = parcelRequire("743br");
var $762bd8c36978310c$var$defineProperty = function() {
    try {
        var func = $743br(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
module.exports = $762bd8c36978310c$var$defineProperty;

});


parcelRegister("bkbse", function(module, exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $83ea729133a3a63f$var$HOT_COUNT = 800, $83ea729133a3a63f$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $83ea729133a3a63f$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $83ea729133a3a63f$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $83ea729133a3a63f$var$nativeNow(), remaining = $83ea729133a3a63f$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $83ea729133a3a63f$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = $83ea729133a3a63f$var$shortOut;

});



parcelRegister("6PImS", function(module, exports) {

var $40ggO = parcelRequire("40ggO");

var $5KNSm = parcelRequire("5KNSm");

var $4DenX = parcelRequire("4DenX");

var $hBKZ2 = parcelRequire("hBKZ2");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $4f99ec0753ff1899$var$isIterateeCall(value, index, object) {
    if (!$hBKZ2(object)) return false;
    var type = typeof index;
    if (type == "number" ? $5KNSm(object) && $4DenX(index, object.length) : type == "string" && index in object) return $40ggO(object[index], value);
    return false;
}
module.exports = $4f99ec0753ff1899$var$isIterateeCall;

});


parcelRegister("9o1s2", function(module, exports) {

$parcel$export(module.exports, "getNiceTickValues", function () { return (parcelRequire("1TRCo")).getNiceTickValues; });
$parcel$export(module.exports, "getTickValuesFixedDomain", function () { return (parcelRequire("1TRCo")).getTickValuesFixedDomain; });

var $1TRCo = parcelRequire("1TRCo");

});
parcelRegister("1TRCo", function(module, exports) {

$parcel$export(module.exports, "getNiceTickValues", function () { return $162484f5f27a837c$export$b84e75ccbfe6a612; });
$parcel$export(module.exports, "getTickValuesFixedDomain", function () { return $162484f5f27a837c$export$e9d28da780436e98; });

var $i8MOS = parcelRequire("i8MOS");

var $kvNm7 = parcelRequire("kvNm7");

var $chSQq = parcelRequire("chSQq");
function $162484f5f27a837c$var$_toConsumableArray(arr) {
    return $162484f5f27a837c$var$_arrayWithoutHoles(arr) || $162484f5f27a837c$var$_iterableToArray(arr) || $162484f5f27a837c$var$_unsupportedIterableToArray(arr) || $162484f5f27a837c$var$_nonIterableSpread();
}
function $162484f5f27a837c$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $162484f5f27a837c$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $162484f5f27a837c$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $162484f5f27a837c$var$_arrayLikeToArray(arr);
}
function $162484f5f27a837c$var$_slicedToArray(arr, i) {
    return $162484f5f27a837c$var$_arrayWithHoles(arr) || $162484f5f27a837c$var$_iterableToArrayLimit(arr, i) || $162484f5f27a837c$var$_unsupportedIterableToArray(arr, i) || $162484f5f27a837c$var$_nonIterableRest();
}
function $162484f5f27a837c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $162484f5f27a837c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $162484f5f27a837c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $162484f5f27a837c$var$_arrayLikeToArray(o, minLen);
}
function $162484f5f27a837c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $162484f5f27a837c$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $162484f5f27a837c$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
/**
 * Calculate a interval of a minimum value and a maximum value
 *
 * @param  {Number} min       The minimum value
 * @param  {Number} max       The maximum value
 * @return {Array} An interval
 */ function $162484f5f27a837c$var$getValidInterval(_ref) {
    var _ref2 = $162484f5f27a837c$var$_slicedToArray(_ref, 2), min = _ref2[0], max = _ref2[1];
    var validMin = min, validMax = max; // exchange
    if (min > max) {
        validMin = max;
        validMax = min;
    }
    return [
        validMin,
        validMax
    ];
}
/**
 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
 *
 * @param  {Decimal} roughStep        The rough step calculated by deviding the
 * difference by the tickCount
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Integer} correctionFactor A correction factor
 * @return {Decimal} The step which is easy to understand between two ticks
 */ function $162484f5f27a837c$var$getFormatStep(roughStep, allowDecimals, correctionFactor) {
    if (roughStep.lte(0)) return new (0, (/*@__PURE__*/$parcel$interopDefault($i8MOS)))(0);
    var digitCount = (0, $chSQq.default).getDigitCount(roughStep.toNumber()); // The ratio between the rough step and the smallest number which has a bigger
    // order of magnitudes than the rough step
    var digitCountValue = new (0, (/*@__PURE__*/$parcel$interopDefault($i8MOS)))(10).pow(digitCount);
    var stepRatio = roughStep.div(digitCountValue); // When an integer and a float multiplied, the accuracy of result may be wrong
    var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
    var amendStepRatio = new (0, (/*@__PURE__*/$parcel$interopDefault($i8MOS)))(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
    var formatStep = amendStepRatio.mul(digitCountValue);
    return allowDecimals ? formatStep : new (0, (/*@__PURE__*/$parcel$interopDefault($i8MOS)))(Math.ceil(formatStep));
}
/**
 * calculate the ticks when the minimum value equals to the maximum value
 *
 * @param  {Number}  value         The minimum valuue which is also the maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}                 ticks
 */ function $162484f5f27a837c$var$getTickOfSingleValue(value, tickCount, allowDecimals) {
    var step = 1; // calculate the middle value of ticks
    var middle = new (0, (/*@__PURE__*/$parcel$interopDefault($i8MOS)))(value);
    if (!middle.isint() && allowDecimals) {
        var absVal = Math.abs(value);
        if (absVal < 1) {
            // The step should be a float number when the difference is smaller than 1
            step = new (0, (/*@__PURE__*/$parcel$interopDefault($i8MOS)))(10).pow((0, $chSQq.default).getDigitCount(value) - 1);
            middle = new (0, (/*@__PURE__*/$parcel$interopDefault($i8MOS)))(Math.floor(middle.div(step).toNumber())).mul(step);
        } else if (absVal > 1) // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($i8MOS)))(Math.floor(value));
    } else if (value === 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($i8MOS)))(Math.floor((tickCount - 1) / 2));
    else if (!allowDecimals) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($i8MOS)))(Math.floor(value));
    var middleIndex = Math.floor((tickCount - 1) / 2);
    var fn = (0, $kvNm7.compose)((0, $kvNm7.map)(function(n) {
        return middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($i8MOS)))(n - middleIndex).mul(step)).toNumber();
    }), (0, $kvNm7.range));
    return fn(0, tickCount);
}
/**
 * Calculate the step
 *
 * @param  {Number}  min              The minimum value of an interval
 * @param  {Number}  max              The maximum value of an interval
 * @param  {Integer} tickCount        The count of ticks
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Number}  correctionFactor A correction factor
 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
 */ function $162484f5f27a837c$var$calculateStep(min, max, tickCount, allowDecimals) {
    var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    // dirty hack (for recharts' test)
    if (!Number.isFinite((max - min) / (tickCount - 1))) return {
        step: new (0, (/*@__PURE__*/$parcel$interopDefault($i8MOS)))(0),
        tickMin: new (0, (/*@__PURE__*/$parcel$interopDefault($i8MOS)))(0),
        tickMax: new (0, (/*@__PURE__*/$parcel$interopDefault($i8MOS)))(0)
    };
     // The step which is easy to understand between two ticks
    var step = $162484f5f27a837c$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($i8MOS)))(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor); // A medial value of ticks
    var middle; // When 0 is inside the interval, 0 should be a tick
    if (min <= 0 && max >= 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($i8MOS)))(0);
    else {
        // calculate the middle value
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($i8MOS)))(min).add(max).div(2); // minus modulo value
        middle = middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($i8MOS)))(middle).mod(step));
    }
    var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
    var upCount = Math.ceil(new (0, (/*@__PURE__*/$parcel$interopDefault($i8MOS)))(max).sub(middle).div(step).toNumber());
    var scaleCount = belowCount + upCount + 1;
    if (scaleCount > tickCount) // When more ticks need to cover the interval, step should be bigger.
    return $162484f5f27a837c$var$calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
    if (scaleCount < tickCount) {
        // When less ticks can cover the interval, we should add some additional ticks
        upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
        belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
    }
    return {
        step: step,
        tickMin: middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($i8MOS)))(belowCount).mul(step)),
        tickMax: middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($i8MOS)))(upCount).mul(step))
    };
}
/**
 * Calculate the ticks of an interval, the count of ticks will be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $162484f5f27a837c$var$getNiceTickValuesFn(_ref3) {
    var _ref4 = $162484f5f27a837c$var$_slicedToArray(_ref3, 2), min = _ref4[0], max = _ref4[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval = $162484f5f27a837c$var$getValidInterval([
        min,
        max
    ]), _getValidInterval2 = $162484f5f27a837c$var$_slicedToArray(_getValidInterval, 2), cormin = _getValidInterval2[0], cormax = _getValidInterval2[1];
    if (cormin === -Infinity || cormax === Infinity) {
        var _values = cormax === Infinity ? [
            cormin
        ].concat($162484f5f27a837c$var$_toConsumableArray((0, $kvNm7.range)(0, tickCount - 1).map(function() {
            return Infinity;
        }))) : [].concat($162484f5f27a837c$var$_toConsumableArray((0, $kvNm7.range)(0, tickCount - 1).map(function() {
            return -Infinity;
        })), [
            cormax
        ]);
        return min > max ? (0, $kvNm7.reverse)(_values) : _values;
    }
    if (cormin === cormax) return $162484f5f27a837c$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
     // Get the step between two ticks
    var _calculateStep = $162484f5f27a837c$var$calculateStep(cormin, cormax, count, allowDecimals), step = _calculateStep.step, tickMin = _calculateStep.tickMin, tickMax = _calculateStep.tickMax;
    var values = (0, $chSQq.default).rangeStep(tickMin, tickMax.add(new (0, (/*@__PURE__*/$parcel$interopDefault($i8MOS)))(0.1).mul(step)), step);
    return min > max ? (0, $kvNm7.reverse)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $162484f5f27a837c$var$getTickValuesFn(_ref5) {
    var _ref6 = $162484f5f27a837c$var$_slicedToArray(_ref5, 2), min = _ref6[0], max = _ref6[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval3 = $162484f5f27a837c$var$getValidInterval([
        min,
        max
    ]), _getValidInterval4 = $162484f5f27a837c$var$_slicedToArray(_getValidInterval3, 2), cormin = _getValidInterval4[0], cormax = _getValidInterval4[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return $162484f5f27a837c$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
    var step = $162484f5f27a837c$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($i8MOS)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var fn = (0, $kvNm7.compose)((0, $kvNm7.map)(function(n) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($i8MOS)))(cormin).add(new (0, (/*@__PURE__*/$parcel$interopDefault($i8MOS)))(n).mul(step)).toNumber();
    }), (0, $kvNm7.range));
    var values = fn(0, count).filter(function(entry) {
        return entry >= cormin && entry <= cormax;
    });
    return min > max ? (0, $kvNm7.reverse)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed,
 * but the domain will be guaranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $162484f5f27a837c$var$getTickValuesFixedDomainFn(_ref7, tickCount) {
    var _ref8 = $162484f5f27a837c$var$_slicedToArray(_ref7, 2), min = _ref8[0], max = _ref8[1];
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var _getValidInterval5 = $162484f5f27a837c$var$getValidInterval([
        min,
        max
    ]), _getValidInterval6 = $162484f5f27a837c$var$_slicedToArray(_getValidInterval5, 2), cormin = _getValidInterval6[0], cormax = _getValidInterval6[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return [
        cormin
    ];
    var count = Math.max(tickCount, 2);
    var step = $162484f5f27a837c$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($i8MOS)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var values = [].concat($162484f5f27a837c$var$_toConsumableArray((0, $chSQq.default).rangeStep(new (0, (/*@__PURE__*/$parcel$interopDefault($i8MOS)))(cormin), new (0, (/*@__PURE__*/$parcel$interopDefault($i8MOS)))(cormax).sub(new (0, (/*@__PURE__*/$parcel$interopDefault($i8MOS)))(0.99).mul(step)), step)), [
        cormax
    ]);
    return min > max ? (0, $kvNm7.reverse)(values) : values;
}
var $162484f5f27a837c$export$b84e75ccbfe6a612 = (0, $kvNm7.memoize)($162484f5f27a837c$var$getNiceTickValuesFn);
var $162484f5f27a837c$export$4cc7a216492b1f53 = (0, $kvNm7.memoize)($162484f5f27a837c$var$getTickValuesFn);
var $162484f5f27a837c$export$e9d28da780436e98 = (0, $kvNm7.memoize)($162484f5f27a837c$var$getTickValuesFixedDomainFn);

});
parcelRegister("i8MOS", function(module, exports) {
(function(globalScope) {
    "use strict";
    /*
   *  decimal.js-light v2.5.1
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js-light
   *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Expat Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    var MAX_DIGITS = 1e9, // The initial configuration properties of the Decimal constructor.
    Decimal = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed during run-time using `Decimal.config`.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
        // `toFixed`, `toPrecision` and `toSignificantDigits`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The natural logarithm of 10.
        // 115 digits
        LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    external = true, decimalError = "[DecimalError] ", invalidArgument = decimalError + "Invalid argument: ", exponentOutOfRange = decimalError + "Exponent out of range: ", mathfloor = Math.floor, mathpow = Math.pow, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ONE, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE), // Decimal.prototype object
    P = {};
    // Decimal prototype methods
    /*
   *  absoluteValue                       abs
   *  comparedTo                          cmp
   *  decimalPlaces                       dp
   *  dividedBy                           div
   *  dividedToIntegerBy                  idiv
   *  equals                              eq
   *  exponent
   *  greaterThan                         gt
   *  greaterThanOrEqualTo                gte
   *  isInteger                           isint
   *  isNegative                          isneg
   *  isPositive                          ispos
   *  isZero
   *  lessThan                            lt
   *  lessThanOrEqualTo                   lte
   *  logarithm                           log
   *  minus                               sub
   *  modulo                              mod
   *  naturalExponential                  exp
   *  naturalLogarithm                    ln
   *  negated                             neg
   *  plus                                add
   *  precision                           sd
   *  squareRoot                          sqrt
   *  times                               mul
   *  toDecimalPlaces                     todp
   *  toExponential
   *  toFixed
   *  toInteger                           toint
   *  toNumber
   *  toPower                             pow
   *  toPrecision
   *  toSignificantDigits                 tosd
   *  toString
   *  valueOf                             val
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s) x.s = 1;
        return x;
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this;
        y = new x.constructor(y);
        // Signs differ?
        if (x.s !== y.s) return x.s || -y.s;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;
        xdL = x.d.length;
        ydL = y.d.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var x = this, w = x.d.length - 1, dp = (w - x.e) * LOG_BASE;
        // Subtract the number of trailing zeros of the last word.
        w = x.d[w];
        if (w) for(; w % 10 == 0; w /= 10)dp--;
        return dp < 0 ? 0 : dp;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
   * `precision` significant digits.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, truncated to `precision` significant digits.
   *
   */ P.dividedToIntegerBy = P.idiv = function(y) {
        var x = this, Ctor = x.constructor;
        return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return !this.cmp(y);
    };
    /*
   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
   *
   */ P.exponent = function() {
        return getBase10Exponent(this);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        return this.cmp(y) >= 0;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isint = function() {
        return this.e > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isneg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.ispos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0, otherwise return false.
   *
   */ P.isZero = function() {
        return this.s === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, truncated to
   * `precision` significant digits.
   *
   * If no base is specified, return log[10](x).
   *
   * log[base](x) = ln(x) / ln(base)
   *
   * The maximum error of the result is 1 ulp (unit in the last place).
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var r, x = this, Ctor = x.constructor, pr = Ctor.precision, wpr = pr + 5;
        // Default base is 10.
        if (base === void 0) base = new Ctor(10);
        else {
            base = new Ctor(base);
            // log[-b](x) = NaN
            // log[0](x)  = NaN
            // log[1](x)  = NaN
            if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + "NaN");
        }
        // log[b](-x) = NaN
        // log[b](0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? "NaN" : "-Infinity"));
        // log[b](1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        external = false;
        r = divide(ln(x, wpr), ln(base, wpr), wpr);
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.minus = P.sub = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
   * `precision` significant digits.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor, pr = Ctor.precision;
        y = new Ctor(y);
        // x % 0 = NaN
        if (!y.s) throw Error(decimalError + "NaN");
        // Return x if x is 0.
        if (!x.s) return round(new Ctor(x), pr);
        // Prevent rounding of intermediate calculations.
        external = false;
        q = divide(x, y, 0, 1).times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.naturalExponential = P.exp = function() {
        return exp(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * truncated to `precision` significant digits.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return ln(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s || 0;
        return x;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.plus = P.add = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var e, sd, w, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        e = getBase10Exponent(x) + 1;
        w = x.d.length - 1;
        sd = w * LOG_BASE + 1;
        w = x.d[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)sd--;
            // Add the number of digits of the first word.
            for(w = x.d[0]; w >= 10; w /= 10)sd++;
        }
        return z && e > sd ? e : sd;
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.squareRoot = P.sqrt = function() {
        var e, n, pr, r, s, t, wpr, x = this, Ctor = x.constructor;
        // Negative or zero?
        if (x.s < 1) {
            if (!x.s) return new Ctor(0);
            // sqrt(-x) = NaN
            throw Error(decimalError + "NaN");
        }
        e = getBase10Exponent(x);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(x.d);
            if ((n.length + e) % 2 == 0) n += "0";
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = "5e" + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf("e") + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        pr = Ctor.precision;
        s = wpr = pr + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, wpr + 2)).times(0.5);
            if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
                n = n.slice(wpr - 3, wpr + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (s == wpr && n == "4999") {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    round(t, pr + 1, 0);
                    if (t.times(t).eq(x)) {
                        r = t;
                        break;
                    }
                } else if (n != "9999") break;
                wpr += 4;
            }
        }
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
   * `precision` significant digits.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        // Return 0 if either is 0.
        if (!x.s || !y.s) return new Ctor(0);
        y.s *= x.s;
        e = x.e + y.e;
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = e;
        return external ? round(y, Ctor.precision) : y;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.todp = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return round(x, dp + getBase10Exponent(x) + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = toString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), dp + 1, rm);
            str = toString(x, true, dp + 1);
        }
        return str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) return toString(x);
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
        str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isneg() && !x.isZero() ? "-" + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.toInteger = P.toint = function() {
        var x = this, Ctor = x.constructor;
        return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
   * truncated to `precision` significant digits.
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * The maximum error is 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, sign, yIsInt, x = this, Ctor = x.constructor, guard = 12, yn = +(y = new Ctor(y));
        // pow(x, 0) = 1
        if (!y.s) return new Ctor(ONE);
        x = new Ctor(x);
        // pow(0, y > 0) = 0
        // pow(0, y < 0) = Infinity
        if (!x.s) {
            if (y.s < 1) throw Error(decimalError + "Infinity");
            return x;
        }
        // pow(1, y) = 1
        if (x.eq(ONE)) return x;
        pr = Ctor.precision;
        // pow(x, 1) = x
        if (y.eq(ONE)) return round(x, pr);
        e = y.e;
        k = y.d.length - 1;
        yIsInt = e >= k;
        sign = x.s;
        if (!yIsInt) {
            // pow(x < 0, y non-integer) = NaN
            if (sign < 0) throw Error(decimalError + "NaN");
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = new Ctor(ONE);
            // Max k of 9007199254740991 takes 53 loop iterations.
            // Maximum digits array length; leaves [28, 34] guard digits.
            e = Math.ceil(pr / LOG_BASE + 4);
            external = false;
            for(;;){
                if (k % 2) {
                    r = r.times(x);
                    truncate(r.d, e);
                }
                k = mathfloor(k / 2);
                if (k === 0) break;
                x = x.times(x);
                truncate(x.d, e);
            }
            external = true;
            return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
        }
        // Result is negative if x is negative and the last digit of integer y is odd.
        sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;
        x.s = 1;
        external = false;
        r = y.times(ln(x, pr + guard));
        external = true;
        r = exp(r);
        r.s = sign;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var e, str, x = this, Ctor = x.constructor;
        if (sd === void 0) {
            e = getBase10Exponent(x);
            str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), sd, rm);
            e = getBase10Exponent(x);
            str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
        }
        return str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toSignificantDigits = P.tosd = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return round(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = P.valueOf = P.val = P.toJSON = function() {
        var x = this, e = getBase10Exponent(x), Ctor = x.constructor;
        return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  add                 P.minus, P.plus
   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
   *  exp                 P.exp, P.pow
   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
   *                      P.toString, divide, round, toString, exp, ln
   *  getLn10             P.log, ln
   *  getZeroString       digitsToString, toString
   *  ln                  P.log, P.ln, P.pow, exp
   *  parseDecimal        Decimal
   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
   *                      divide, getLn10, exp, ln
   *  subtract            P.minus, P.plus
   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
   *  truncate            P.pow
   *
   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
   *                      getLn10, exp, ln, parseDecimal, Decimal, config
   */ function add(x, y) {
        var carry, d, e, i, k, len, xd, yd, Ctor = x.constructor, pr = Ctor.precision;
        // If either is zero...
        if (!x.s || !y.s) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!y.s) y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are finite, non-zero numbers with the same sign.
        k = x.e;
        e = y.e;
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = e;
        return external ? round(y, pr) : y;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = "", w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + "";
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + "";
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return "0";
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % BASE | 0;
                carry = temp / BASE | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * BASE + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, dp) {
            var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either 0?
            if (!x.s) return new Ctor(x);
            if (!y.s) throw Error(decimalError + "Division by zero");
            e = x.e - y.e;
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            for(i = 0; yd[i] == (xd[i] || 0);)++i;
            if (yd[i] > (xd[i] || 0)) --e;
            if (pr == null) sd = pr = Ctor.precision;
            else if (dp) sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
            else sd = pr;
            if (sd < 0) return new Ctor(0);
            // Convert precision in number of base 10 digits to base 1e7 digits.
            sd = sd / LOG_BASE + 2 | 0;
            i = 0;
            // divisor < 1e7
            if (yL == 1) {
                k = 0;
                yd = yd[0];
                sd++;
                // k is the carry.
                for(; (i < xL || k) && sd--; i++){
                    t = k * BASE + (xd[i] || 0);
                    qd[i] = t / yd | 0;
                    k = t % yd | 0;
                }
            // divisor >= 1e7
            } else {
                // Normalise xd and yd so highest order digit of yd is >= BASE/2
                k = BASE / (yd[0] + 1) | 0;
                if (k > 1) {
                    yd = multiplyInteger(yd, k);
                    xd = multiplyInteger(xd, k);
                    yL = yd.length;
                    xL = xd.length;
                }
                xi = yL;
                rem = xd.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL;)rem[remL++] = 0;
                yz = yd.slice();
                yz.unshift(0);
                yd0 = yd[0];
                if (yd[1] >= BASE / 2) ++yd0;
                do {
                    k = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yd, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, k.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);
                        // k will be how many times the divisor goes into the current remainder.
                        k = rem0 / yd0 | 0;
                        //  Algorithm:
                        //  1. product = divisor * trial digit (k)
                        //  2. if product > remainder: product -= divisor, k--
                        //  3. remainder -= product
                        //  4. if product was < remainder at 2:
                        //    5. compare new remainder and divisor
                        //    6. If remainder > divisor: remainder -= divisor, k++
                        if (k > 1) {
                            if (k >= BASE) k = BASE - 1;
                            // product = divisor * trial digit.
                            prod = multiplyInteger(yd, k);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            cmp = compare(prod, rem, prodL, remL);
                            // product > remainder.
                            if (cmp == 1) {
                                k--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yd, prodL);
                            }
                        } else {
                            // cmp is -1.
                            // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                            // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                            if (k == 0) cmp = k = 1;
                            prod = yd.slice();
                        }
                        prodL = prod.length;
                        if (prodL < remL) prod.unshift(0);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL);
                        // If product was < previous remainder.
                        if (cmp == -1) {
                            remL = rem.length;
                            // Compare divisor and new remainder.
                            cmp = compare(yd, rem, yL, remL);
                            // If divisor < new remainder, subtract divisor from remainder.
                            if (cmp < 1) {
                                k++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yd, remL);
                            }
                        }
                        remL = rem.length;
                    } else if (cmp === 0) {
                        k++;
                        rem = [
                            0
                        ];
                    } // if cmp === 1, k will be 0
                    // Add the next digit, k, to the result array.
                    qd[i++] = k;
                    // Update the remainder.
                    if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                    else {
                        rem = [
                            xd[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] !== void 0) && sd--);
            }
            // Leading zero?
            if (!qd[0]) qd.shift();
            q.e = e;
            return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
        };
    }();
    /*
   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
   * significant digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   */ function exp(x, sd) {
        var denominator, guard, pow, sum, t, wpr, i = 0, k = 0, Ctor = x.constructor, pr = Ctor.precision;
        if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));
        // exp(0) = 1
        if (!x.s) return new Ctor(ONE);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        while(x.abs().gte(0.1)){
            x = x.times(t); // x = x / 2^5
            k += 5;
        }
        // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(ONE);
        Ctor.precision = wpr;
        for(;;){
            pow = round(pow.times(x), wpr);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                while(k--)sum = round(sum.times(sum), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
        }
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(x) {
        var e = x.e * LOG_BASE, w = x.d[0];
        // Add the number of digits of the first word of the digits array.
        for(; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > Ctor.LN10.sd()) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(decimalError + "LN10 precision limit exceeded");
        }
        return round(new Ctor(Ctor.LN10), sd);
    }
    function getZeroString(k) {
        var zs = "";
        for(; k--;)zs += "0";
        return zs;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
   * digits.
   *
   *  ln(n) is non-terminating (n != 1)
   *
   */ function ln(y, sd) {
        var c, c0, denominator, e, numerator, sum, t, wpr, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, pr = Ctor.precision;
        // ln(-x) = NaN
        // ln(0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? "NaN" : "-Infinity"));
        // ln(1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        if (x.eq(10)) {
            if (sd == null) external = true;
            return getLn10(Ctor, wpr);
        }
        wpr += guard;
        Ctor.precision = wpr;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        e = getBase10Exponent(x);
        if (Math.abs(e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = getBase10Exponent(x);
            if (c0 > 1) {
                x = new Ctor("0." + c);
                e++;
            } else x = new Ctor(c0 + "." + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + "");
            x = ln(new Ctor(c0 + "." + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? (external = true, round(x, pr)) : x;
        }
        // x is reduced to a value near 1.
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
        x2 = round(x.times(x), wpr);
        denominator = 3;
        for(;;){
            numerator = round(numerator.times(x2), wpr);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ""));
                sum = divide(sum, new Ctor(n), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
            denominator += 2;
        }
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // Decimal point?
        if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48;)++i;
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48;)--len;
        str = str.slice(i, len);
        if (str) {
            len -= i;
            e = e - i - 1;
            x.e = mathfloor(e / LOG_BASE);
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += "0";
            x.d.push(+str);
            if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
        } else {
            // Zero.
            x.s = 0;
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
   */ function round(x, sd, rm) {
        var i, j, k, n, rd, doRound, w, xdi, xd = x.d;
        // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
        // w: the word of xd which contains the rounding digit, a base 1e7 number.
        // xdi: the index of w within xd.
        // n: the number of digits of w.
        // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
        // they had leading zeros)
        // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
        // Get the length of the first word of the digits array xd.
        for(n = 1, k = xd[0]; k >= 10; k /= 10)n++;
        i = sd - n;
        // Is the rounding digit in the first word of xd?
        if (i < 0) {
            i += LOG_BASE;
            j = sd;
            w = xd[xdi = 0];
        } else {
            xdi = Math.ceil((i + 1) / LOG_BASE);
            k = xd.length;
            if (xdi >= k) return x;
            w = k = xd[xdi];
            // Get the number of digits of w.
            for(n = 1; k >= 10; k /= 10)n++;
            // Get the index of rd within w.
            i %= LOG_BASE;
            // Get the index of rd within w, adjusted for leading zeros.
            // The number of leading zeros of w is given by LOG_BASE - n.
            j = i - LOG_BASE + n;
        }
        if (rm !== void 0) {
            k = mathpow(10, n - j - 1);
            // Get the rounding digit at index j of w.
            rd = w / k % 10 | 0;
            // Are there any non-zero digits after the rounding digit?
            doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;
            // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
            // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
            // 714.
            doRound = rm < 4 ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
        }
        if (sd < 1 || !xd[0]) {
            if (doRound) {
                k = getBase10Exponent(x);
                xd.length = 1;
                // Convert sd to decimal places.
                sd = sd - k - 1;
                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                x.e = mathfloor(-sd / LOG_BASE) || 0;
            } else {
                xd.length = 1;
                // Zero.
                xd[0] = x.e = x.s = 0;
            }
            return x;
        }
        // Remove excess digits.
        if (i == 0) {
            xd.length = xdi;
            k = 1;
            xdi--;
        } else {
            xd.length = xdi + 1;
            k = mathpow(10, LOG_BASE - i);
            // E.g. 56700 becomes 56000 if 7 is the rounding digit.
            // j > 0 means i > number of leading zeros of w.
            xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
        }
        if (doRound) {
            for(;;)// Is the digit to be rounded up in the first word of xd?
            if (xdi == 0) {
                if ((xd[0] += k) == BASE) {
                    xd[0] = 1;
                    ++x.e;
                }
                break;
            } else {
                xd[xdi] += k;
                if (xd[xdi] != BASE) break;
                xd[xdi--] = 0;
                k = 1;
            }
        }
        // Remove trailing zeros.
        for(i = xd.length; xd[--i] === 0;)xd.pop();
        if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + getBase10Exponent(x));
        return x;
    }
    function subtract(x, y) {
        var d, e, i, j, k, len, xd, xe, xLTy, yd, Ctor = x.constructor, pr = Ctor.precision;
        // Return y negated if x is zero.
        // Return x if y is zero and x is non-zero.
        if (!x.s || !y.s) {
            if (y.s) y.s = -y.s;
            else y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are non-zero numbers with the same sign.
        e = y.e;
        xe = x.e;
        xd = xd.slice();
        k = xe - e;
        // If exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of zeros
            // needing to be prepended, but this can be avoided while still ensuring correct rounding by
            // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to xd if shorter.
        // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(0);
        y.d = xd;
        y.e = e;
        //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
        return external ? round(y, pr) : y;
    }
    function toString(x, isExp, sd) {
        var k, e = getBase10Exponent(x), str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + "." + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + "." + str.slice(1);
            str = str + (e < 0 ? "e" : "e+") + e;
        } else if (e < 0) {
            str = "0." + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + "." + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + "." + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += ".";
                str += getZeroString(k);
            }
        }
        return x.s < 0 ? "-" + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  clone
   *  config/set
   */ /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * value {number|string|Decimal} A numeric value.
     *
     */ function Decimal(value) {
            var x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(value);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            // Duplicate.
            if (value instanceof Decimal) {
                x.s = value.s;
                x.e = value.e;
                x.d = (value = value.d) ? value.slice() : value;
                return;
            }
            if (typeof value === "number") {
                // Reject Infinity/NaN.
                if (value * 0 !== 0) throw Error(invalidArgument + value);
                if (value > 0) x.s = 1;
                else if (value < 0) {
                    value = -value;
                    x.s = -1;
                } else {
                    x.s = 0;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                // Fast path for small integers.
                if (value === ~~value && value < 1e7) {
                    x.e = 0;
                    x.d = [
                        value
                    ];
                    return;
                }
                return parseDecimal(x, value.toString());
            } else if (typeof value !== "string") throw Error(invalidArgument + value);
            // Minus sign?
            if (value.charCodeAt(0) === 45) {
                value = value.slice(1);
                x.s = -1;
            } else x.s = 1;
            if (isDecimal.test(value)) parseDecimal(x, value);
            else throw Error(invalidArgument + value);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.clone = clone;
        Decimal.config = Decimal.set = config;
        if (obj === void 0) obj = {};
        if (obj) {
            ps = [
                "precision",
                "rounding",
                "toExpNeg",
                "toExpPos",
                "LN10"
            ];
            for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== "object") throw Error(decimalError + "Object expected");
        var i, p, v, ps = [
            "precision",
            1,
            MAX_DIGITS,
            "rounding",
            0,
            8,
            "toExpNeg",
            -1 / 0,
            0,
            "toExpPos",
            0,
            1 / 0
        ];
        for(i = 0; i < ps.length; i += 3)if ((v = obj[p = ps[i]]) !== void 0) {
            if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
            else throw Error(invalidArgument + p + ": " + v);
        }
        if ((v = obj[p = "LN10"]) !== void 0) {
            if (v == Math.LN10) this[p] = new this(v);
            else throw Error(invalidArgument + p + ": " + v);
        }
        return this;
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(Decimal);
    Decimal["default"] = Decimal.Decimal = Decimal;
    // Internal constant.
    ONE = new Decimal(1);
    // Export.
    // AMD.
    if (typeof define == "function" && define.amd) define(function() {
        return Decimal;
    });
    else if (0, module.exports) module.exports = Decimal;
    else {
        if (!globalScope) globalScope = typeof self != "undefined" && self && self.self == self ? self : Function("return this")();
        globalScope.Decimal = Decimal;
    }
})(module.exports);

});

parcelRegister("kvNm7", function(module, exports) {

$parcel$export(module.exports, "curry", function () { return $eeecfce89d8c5304$export$c3095a23b368d1f2; });
$parcel$export(module.exports, "range", function () { return $eeecfce89d8c5304$export$d02631cccf789723; });
$parcel$export(module.exports, "map", function () { return $eeecfce89d8c5304$export$871de8747c9eaa88; });
$parcel$export(module.exports, "compose", function () { return $eeecfce89d8c5304$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "reverse", function () { return $eeecfce89d8c5304$export$66c1ae025e96b4bc; });
$parcel$export(module.exports, "memoize", function () { return $eeecfce89d8c5304$export$fc10aeed3a532e2a; });
function $eeecfce89d8c5304$var$_toConsumableArray(arr) {
    return $eeecfce89d8c5304$var$_arrayWithoutHoles(arr) || $eeecfce89d8c5304$var$_iterableToArray(arr) || $eeecfce89d8c5304$var$_unsupportedIterableToArray(arr) || $eeecfce89d8c5304$var$_nonIterableSpread();
}
function $eeecfce89d8c5304$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $eeecfce89d8c5304$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $eeecfce89d8c5304$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $eeecfce89d8c5304$var$_arrayLikeToArray(o, minLen);
}
function $eeecfce89d8c5304$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $eeecfce89d8c5304$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $eeecfce89d8c5304$var$_arrayLikeToArray(arr);
}
function $eeecfce89d8c5304$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $eeecfce89d8c5304$var$identity = function identity(i) {
    return i;
};
var $eeecfce89d8c5304$export$ca73b6d700d0505 = {
    "@@functional/placeholder": true
};
var $eeecfce89d8c5304$var$isPlaceHolder = function isPlaceHolder(val) {
    return val === $eeecfce89d8c5304$export$ca73b6d700d0505;
};
var $eeecfce89d8c5304$var$curry0 = function curry0(fn) {
    return function _curried() {
        if (arguments.length === 0 || arguments.length === 1 && $eeecfce89d8c5304$var$isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) return _curried;
        return fn.apply(void 0, arguments);
    };
};
var $eeecfce89d8c5304$var$curryN = function curryN(n, fn) {
    if (n === 1) return fn;
    return $eeecfce89d8c5304$var$curry0(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var argsLength = args.filter(function(arg) {
            return arg !== $eeecfce89d8c5304$export$ca73b6d700d0505;
        }).length;
        if (argsLength >= n) return fn.apply(void 0, args);
        return curryN(n - argsLength, $eeecfce89d8c5304$var$curry0(function() {
            for(var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)restArgs[_key2] = arguments[_key2];
            var newArgs = args.map(function(arg) {
                return $eeecfce89d8c5304$var$isPlaceHolder(arg) ? restArgs.shift() : arg;
            });
            return fn.apply(void 0, $eeecfce89d8c5304$var$_toConsumableArray(newArgs).concat(restArgs));
        }));
    });
};
var $eeecfce89d8c5304$export$c3095a23b368d1f2 = function curry(fn) {
    return $eeecfce89d8c5304$var$curryN(fn.length, fn);
};
var $eeecfce89d8c5304$export$d02631cccf789723 = function range(begin, end) {
    var arr = [];
    for(var i = begin; i < end; ++i)arr[i - begin] = i;
    return arr;
};
var $eeecfce89d8c5304$export$871de8747c9eaa88 = $eeecfce89d8c5304$export$c3095a23b368d1f2(function(fn, arr) {
    if (Array.isArray(arr)) return arr.map(fn);
    return Object.keys(arr).map(function(key) {
        return arr[key];
    }).map(fn);
});
var $eeecfce89d8c5304$export$f672e0b6f7222cd7 = function compose() {
    for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
    if (!args.length) return $eeecfce89d8c5304$var$identity;
    var fns = args.reverse(); // first function can receive multiply arguments
    var firstFn = fns[0];
    var tailsFn = fns.slice(1);
    return function() {
        return tailsFn.reduce(function(res, fn) {
            return fn(res);
        }, firstFn.apply(void 0, arguments));
    };
};
var $eeecfce89d8c5304$export$66c1ae025e96b4bc = function reverse(arr) {
    if (Array.isArray(arr)) return arr.reverse();
     // can be string
    return arr.split("").reverse.join("");
};
var $eeecfce89d8c5304$export$fc10aeed3a532e2a = function memoize(fn) {
    var lastArgs = null;
    var lastResult = null;
    return function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        if (lastArgs && args.every(function(val, i) {
            return val === lastArgs[i];
        })) return lastResult;
        lastArgs = args;
        lastResult = fn.apply(void 0, args);
        return lastResult;
    };
};

});

parcelRegister("chSQq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f219d933cc64e06$export$2e2bcd8739ae039; });
/**
 * @fileOverview 一些公用的运算方法
 * @author xile611
 * @date 2015-09-17
 */ 
var $i8MOS = parcelRequire("i8MOS");

var $kvNm7 = parcelRequire("kvNm7");
/**
 * 获取数值的位数
 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
 *
 * @param  {Number} value 数值
 * @return {Integer} 位数
 */ function $8f219d933cc64e06$var$getDigitCount(value) {
    var result;
    if (value === 0) result = 1;
    else result = Math.floor(new (0, (/*@__PURE__*/$parcel$interopDefault($i8MOS)))(value).abs().log(10).toNumber()) + 1;
    return result;
}
/**
 * 按照固定的步长获取[start, end)这个区间的数据
 * 并且需要处理js计算精度的问题
 *
 * @param  {Decimal} start 起点
 * @param  {Decimal} end   终点，不包含该值
 * @param  {Decimal} step  步长
 * @return {Array}         若干数值
 */ function $8f219d933cc64e06$var$rangeStep(start, end, step) {
    var num = new (0, (/*@__PURE__*/$parcel$interopDefault($i8MOS)))(start);
    var i = 0;
    var result = []; // magic number to prevent infinite loop
    while(num.lt(end) && i < 100000){
        result.push(num.toNumber());
        num = num.add(step);
        i++;
    }
    return result;
}
/**
 * 对数值进行线性插值
 *
 * @param  {Number} a  定义域的极点
 * @param  {Number} b  定义域的极点
 * @param  {Number} t  [0, 1]内的某个值
 * @return {Number}    定义域内的某个值
 */ var $8f219d933cc64e06$var$interpolateNumber = (0, $kvNm7.curry)(function(a, b, t) {
    var newA = +a;
    var newB = +b;
    return newA + t * (newB - newA);
});
/**
 * 线性插值的逆运算
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
 */ var $8f219d933cc64e06$var$uninterpolateNumber = (0, $kvNm7.curry)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return (x - a) / diff;
});
/**
 * 线性插值的逆运算，并且有截断的操作
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
 */ var $8f219d933cc64e06$var$uninterpolateTruncation = (0, $kvNm7.curry)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return Math.max(0, Math.min(1, (x - a) / diff));
});
var $8f219d933cc64e06$export$2e2bcd8739ae039 = {
    rangeStep: $8f219d933cc64e06$var$rangeStep,
    getDigitCount: $8f219d933cc64e06$var$getDigitCount,
    interpolateNumber: $8f219d933cc64e06$var$interpolateNumber,
    uninterpolateNumber: $8f219d933cc64e06$var$uninterpolateNumber,
    uninterpolateTruncation: $8f219d933cc64e06$var$uninterpolateTruncation
};

});



parcelRegister("3Efgj", function(module, exports) {

$parcel$export(module.exports, "ErrorBar", function () { return $2a80f24794d3ea74$export$4f4d7676bdf949e5; });

var $jbmdS = parcelRequire("jbmdS");

var $9GFyS = parcelRequire("9GFyS");

var $bIYfh = parcelRequire("bIYfh");

var $f06D9 = parcelRequire("f06D9");
var $2a80f24794d3ea74$var$_excluded = [
    "offset",
    "layout",
    "width",
    "dataKey",
    "data",
    "dataPointFormatter",
    "xAxis",
    "yAxis"
];
function $2a80f24794d3ea74$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2a80f24794d3ea74$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2a80f24794d3ea74$var$_typeof(o);
}
function $2a80f24794d3ea74$var$_extends() {
    $2a80f24794d3ea74$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2a80f24794d3ea74$var$_extends.apply(this, arguments);
}
function $2a80f24794d3ea74$var$_slicedToArray(arr, i) {
    return $2a80f24794d3ea74$var$_arrayWithHoles(arr) || $2a80f24794d3ea74$var$_iterableToArrayLimit(arr, i) || $2a80f24794d3ea74$var$_unsupportedIterableToArray(arr, i) || $2a80f24794d3ea74$var$_nonIterableRest();
}
function $2a80f24794d3ea74$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2a80f24794d3ea74$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2a80f24794d3ea74$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2a80f24794d3ea74$var$_arrayLikeToArray(o, minLen);
}
function $2a80f24794d3ea74$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2a80f24794d3ea74$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $2a80f24794d3ea74$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $2a80f24794d3ea74$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $2a80f24794d3ea74$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $2a80f24794d3ea74$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $2a80f24794d3ea74$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2a80f24794d3ea74$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $2a80f24794d3ea74$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $2a80f24794d3ea74$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2a80f24794d3ea74$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2a80f24794d3ea74$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $2a80f24794d3ea74$var$_callSuper(t, o, e) {
    return o = $2a80f24794d3ea74$var$_getPrototypeOf(o), $2a80f24794d3ea74$var$_possibleConstructorReturn(t, $2a80f24794d3ea74$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $2a80f24794d3ea74$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $2a80f24794d3ea74$var$_possibleConstructorReturn(self, call) {
    if (call && ($2a80f24794d3ea74$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $2a80f24794d3ea74$var$_assertThisInitialized(self);
}
function $2a80f24794d3ea74$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $2a80f24794d3ea74$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($2a80f24794d3ea74$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $2a80f24794d3ea74$var$_getPrototypeOf(o) {
    $2a80f24794d3ea74$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $2a80f24794d3ea74$var$_getPrototypeOf(o);
}
function $2a80f24794d3ea74$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $2a80f24794d3ea74$var$_setPrototypeOf(subClass, superClass);
}
function $2a80f24794d3ea74$var$_setPrototypeOf(o, p) {
    $2a80f24794d3ea74$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $2a80f24794d3ea74$var$_setPrototypeOf(o, p);
}
function $2a80f24794d3ea74$var$_defineProperty(obj, key, value) {
    key = $2a80f24794d3ea74$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2a80f24794d3ea74$var$_toPropertyKey(t) {
    var i = $2a80f24794d3ea74$var$_toPrimitive(t, "string");
    return "symbol" == $2a80f24794d3ea74$var$_typeof(i) ? i : i + "";
}
function $2a80f24794d3ea74$var$_toPrimitive(t, r) {
    if ("object" != $2a80f24794d3ea74$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $2a80f24794d3ea74$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $2a80f24794d3ea74$export$4f4d7676bdf949e5 = /*#__PURE__*/ function(_React$Component) {
    function ErrorBar() {
        $2a80f24794d3ea74$var$_classCallCheck(this, ErrorBar);
        return $2a80f24794d3ea74$var$_callSuper(this, ErrorBar, arguments);
    }
    $2a80f24794d3ea74$var$_inherits(ErrorBar, _React$Component);
    return $2a80f24794d3ea74$var$_createClass(ErrorBar, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, offset = _this$props.offset, layout = _this$props.layout, width = _this$props.width, dataKey = _this$props.dataKey, data = _this$props.data, dataPointFormatter = _this$props.dataPointFormatter, xAxis = _this$props.xAxis, yAxis = _this$props.yAxis, others = $2a80f24794d3ea74$var$_objectWithoutProperties(_this$props, $2a80f24794d3ea74$var$_excluded);
                var svgProps = (0, $f06D9.filterProps)(others, false);
                !!(this.props.direction === "x" && xAxis.type !== "number") && (0, $9GFyS.default)(false);
                var errorBars = data.map(function(entry) {
                    var _dataPointFormatter = dataPointFormatter(entry, dataKey), x = _dataPointFormatter.x, y = _dataPointFormatter.y, value = _dataPointFormatter.value, errorVal = _dataPointFormatter.errorVal;
                    if (!errorVal) return null;
                    var lineCoordinates = [];
                    var lowBound, highBound;
                    if (Array.isArray(errorVal)) {
                        var _errorVal = $2a80f24794d3ea74$var$_slicedToArray(errorVal, 2);
                        lowBound = _errorVal[0];
                        highBound = _errorVal[1];
                    } else lowBound = highBound = errorVal;
                    if (layout === "vertical") {
                        // error bar for horizontal charts, the y is fixed, x is a range value
                        var scale = xAxis.scale;
                        var yMid = y + offset;
                        var yMin = yMid + width;
                        var yMax = yMid - width;
                        var xMin = scale(value - lowBound);
                        var xMax = scale(value + highBound);
                        // the right line of |--|
                        lineCoordinates.push({
                            x1: xMax,
                            y1: yMin,
                            x2: xMax,
                            y2: yMax
                        });
                        // the middle line of |--|
                        lineCoordinates.push({
                            x1: xMin,
                            y1: yMid,
                            x2: xMax,
                            y2: yMid
                        });
                        // the left line of |--|
                        lineCoordinates.push({
                            x1: xMin,
                            y1: yMin,
                            x2: xMin,
                            y2: yMax
                        });
                    } else if (layout === "horizontal") {
                        // error bar for horizontal charts, the x is fixed, y is a range value
                        var _scale = yAxis.scale;
                        var xMid = x + offset;
                        var _xMin = xMid - width;
                        var _xMax = xMid + width;
                        var _yMin = _scale(value - lowBound);
                        var _yMax = _scale(value + highBound);
                        // the top line
                        lineCoordinates.push({
                            x1: _xMin,
                            y1: _yMax,
                            x2: _xMax,
                            y2: _yMax
                        });
                        // the middle line
                        lineCoordinates.push({
                            x1: xMid,
                            y1: _yMin,
                            x2: xMid,
                            y2: _yMax
                        });
                        // the bottom line
                        lineCoordinates.push({
                            x1: _xMin,
                            y1: _yMin,
                            x2: _xMax,
                            y2: _yMin
                        });
                    }
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $bIYfh.Layer), $2a80f24794d3ea74$var$_extends({
                        className: "recharts-errorBar",
                        key: "bar-".concat(lineCoordinates.map(function(c) {
                            return "".concat(c.x1, "-").concat(c.x2, "-").concat(c.y1, "-").concat(c.y2);
                        }))
                    }, svgProps), lineCoordinates.map(function(coordinates) {
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("line", $2a80f24794d3ea74$var$_extends({}, coordinates, {
                            key: "line-".concat(coordinates.x1, "-").concat(coordinates.x2, "-").concat(coordinates.y1, "-").concat(coordinates.y2)
                        }));
                    }));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $bIYfh.Layer), {
                    className: "recharts-errorBars"
                }, errorBars);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).Component);
$2a80f24794d3ea74$var$_defineProperty($2a80f24794d3ea74$export$4f4d7676bdf949e5, "defaultProps", {
    stroke: "black",
    strokeWidth: 1.5,
    width: 5,
    offset: 0,
    layout: "horizontal"
});
$2a80f24794d3ea74$var$_defineProperty($2a80f24794d3ea74$export$4f4d7676bdf949e5, "displayName", "ErrorBar");

});

parcelRegister("jTbSW", function(module, exports) {

$parcel$export(module.exports, "getLegendProps", function () { return $e7ac5f848e606eeb$export$8f9424d123c36aa; });

var $8QGC8 = parcelRequire("8QGC8");

var $fiDSf = parcelRequire("fiDSf");

var $f06D9 = parcelRequire("f06D9");
function $e7ac5f848e606eeb$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e7ac5f848e606eeb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e7ac5f848e606eeb$var$_typeof(o);
}
function $e7ac5f848e606eeb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e7ac5f848e606eeb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e7ac5f848e606eeb$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e7ac5f848e606eeb$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e7ac5f848e606eeb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e7ac5f848e606eeb$var$_defineProperty(obj, key, value) {
    key = $e7ac5f848e606eeb$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e7ac5f848e606eeb$var$_toPropertyKey(t) {
    var i = $e7ac5f848e606eeb$var$_toPrimitive(t, "string");
    return "symbol" == $e7ac5f848e606eeb$var$_typeof(i) ? i : i + "";
}
function $e7ac5f848e606eeb$var$_toPrimitive(t, r) {
    if ("object" != $e7ac5f848e606eeb$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $e7ac5f848e606eeb$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $e7ac5f848e606eeb$export$8f9424d123c36aa = function getLegendProps(_ref) {
    var children = _ref.children, formattedGraphicalItems = _ref.formattedGraphicalItems, legendWidth = _ref.legendWidth, legendContent = _ref.legendContent;
    var legendItem = (0, $f06D9.findChildByType)(children, (0, $8QGC8.Legend));
    if (!legendItem) return null;
    var legendDefaultProps = (0, $8QGC8.Legend).defaultProps;
    var legendProps = legendDefaultProps !== undefined ? $e7ac5f848e606eeb$var$_objectSpread($e7ac5f848e606eeb$var$_objectSpread({}, legendDefaultProps), legendItem.props) : {};
    var legendData;
    if (legendItem.props && legendItem.props.payload) legendData = legendItem.props && legendItem.props.payload;
    else if (legendContent === "children") legendData = (formattedGraphicalItems || []).reduce(function(result, _ref2) {
        var item = _ref2.item, props = _ref2.props;
        var data = props.sectors || props.data || [];
        return result.concat(data.map(function(entry) {
            return {
                type: legendItem.props.iconType || item.props.legendType,
                value: entry.name,
                color: entry.fill,
                payload: entry
            };
        }));
    }, []);
    else legendData = (formattedGraphicalItems || []).map(function(_ref3) {
        var item = _ref3.item;
        var itemDefaultProps = item.type.defaultProps;
        var itemProps = itemDefaultProps !== undefined ? $e7ac5f848e606eeb$var$_objectSpread($e7ac5f848e606eeb$var$_objectSpread({}, itemDefaultProps), item.props) : {};
        var dataKey = itemProps.dataKey, name = itemProps.name, legendType = itemProps.legendType, hide = itemProps.hide;
        return {
            inactive: hide,
            dataKey: dataKey,
            type: legendProps.iconType || legendType || "square",
            color: (0, $fiDSf.getMainColorOfGraphicItem)(item),
            value: name || dataKey,
            // @ts-expect-error property strokeDasharray is required in Payload but optional in props
            payload: itemProps
        };
    });
    return $e7ac5f848e606eeb$var$_objectSpread($e7ac5f848e606eeb$var$_objectSpread($e7ac5f848e606eeb$var$_objectSpread({}, legendProps), (0, $8QGC8.Legend).getWithHeight(legendItem, legendWidth)), {}, {
        payload: legendData,
        item: legendItem
    });
};

});
parcelRegister("8QGC8", function(module, exports) {

$parcel$export(module.exports, "Legend", function () { return $67143c4dbb07e1dc$export$ed247974535929c7; });

var $jbmdS = parcelRequire("jbmdS");

var $lQ3kN = parcelRequire("lQ3kN");

var $1gmrG = parcelRequire("1gmrG");

var $lNaU3 = parcelRequire("lNaU3");
function $67143c4dbb07e1dc$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $67143c4dbb07e1dc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $67143c4dbb07e1dc$var$_typeof(o);
}
var $67143c4dbb07e1dc$var$_excluded = [
    "ref"
];
function $67143c4dbb07e1dc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $67143c4dbb07e1dc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $67143c4dbb07e1dc$var$ownKeys(Object(t), !0).forEach(function(r) {
            $67143c4dbb07e1dc$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $67143c4dbb07e1dc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $67143c4dbb07e1dc$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $67143c4dbb07e1dc$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $67143c4dbb07e1dc$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $67143c4dbb07e1dc$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $67143c4dbb07e1dc$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $67143c4dbb07e1dc$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $67143c4dbb07e1dc$var$_callSuper(t, o, e) {
    return o = $67143c4dbb07e1dc$var$_getPrototypeOf(o), $67143c4dbb07e1dc$var$_possibleConstructorReturn(t, $67143c4dbb07e1dc$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $67143c4dbb07e1dc$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $67143c4dbb07e1dc$var$_possibleConstructorReturn(self, call) {
    if (call && ($67143c4dbb07e1dc$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $67143c4dbb07e1dc$var$_assertThisInitialized(self);
}
function $67143c4dbb07e1dc$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $67143c4dbb07e1dc$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($67143c4dbb07e1dc$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $67143c4dbb07e1dc$var$_getPrototypeOf(o) {
    $67143c4dbb07e1dc$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $67143c4dbb07e1dc$var$_getPrototypeOf(o);
}
function $67143c4dbb07e1dc$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $67143c4dbb07e1dc$var$_setPrototypeOf(subClass, superClass);
}
function $67143c4dbb07e1dc$var$_setPrototypeOf(o, p) {
    $67143c4dbb07e1dc$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $67143c4dbb07e1dc$var$_setPrototypeOf(o, p);
}
function $67143c4dbb07e1dc$var$_defineProperty(obj, key, value) {
    key = $67143c4dbb07e1dc$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $67143c4dbb07e1dc$var$_toPropertyKey(t) {
    var i = $67143c4dbb07e1dc$var$_toPrimitive(t, "string");
    return "symbol" == $67143c4dbb07e1dc$var$_typeof(i) ? i : i + "";
}
function $67143c4dbb07e1dc$var$_toPrimitive(t, r) {
    if ("object" != $67143c4dbb07e1dc$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $67143c4dbb07e1dc$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $67143c4dbb07e1dc$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $67143c4dbb07e1dc$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $67143c4dbb07e1dc$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $67143c4dbb07e1dc$var$defaultUniqBy(entry) {
    return entry.value;
}
function $67143c4dbb07e1dc$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).cloneElement(content, props);
    if (typeof content === "function") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement(content, props);
    var ref = props.ref, otherProps = $67143c4dbb07e1dc$var$_objectWithoutProperties(props, $67143c4dbb07e1dc$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $lQ3kN.DefaultLegendContent), otherProps);
}
var $67143c4dbb07e1dc$var$EPS = 1;
var $67143c4dbb07e1dc$export$ed247974535929c7 = /*#__PURE__*/ function(_PureComponent) {
    function Legend() {
        var _this;
        $67143c4dbb07e1dc$var$_classCallCheck(this, Legend);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $67143c4dbb07e1dc$var$_callSuper(this, Legend, [].concat(args));
        $67143c4dbb07e1dc$var$_defineProperty(_this, "lastBoundingBox", {
            width: -1,
            height: -1
        });
        return _this;
    }
    $67143c4dbb07e1dc$var$_inherits(Legend, _PureComponent);
    return $67143c4dbb07e1dc$var$_createClass(Legend, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.updateBBox();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.updateBBox();
            }
        },
        {
            key: "getBBox",
            value: function getBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var box = this.wrapperNode.getBoundingClientRect();
                    box.height = this.wrapperNode.offsetHeight;
                    box.width = this.wrapperNode.offsetWidth;
                    return box;
                }
                return null;
            }
        },
        {
            key: "updateBBox",
            value: function updateBBox() {
                var onBBoxUpdate = this.props.onBBoxUpdate;
                var box = this.getBBox();
                if (box) {
                    if (Math.abs(box.width - this.lastBoundingBox.width) > $67143c4dbb07e1dc$var$EPS || Math.abs(box.height - this.lastBoundingBox.height) > $67143c4dbb07e1dc$var$EPS) {
                        this.lastBoundingBox.width = box.width;
                        this.lastBoundingBox.height = box.height;
                        if (onBBoxUpdate) onBBoxUpdate(box);
                    }
                } else if (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) {
                    this.lastBoundingBox.width = -1;
                    this.lastBoundingBox.height = -1;
                    if (onBBoxUpdate) onBBoxUpdate(null);
                }
            }
        },
        {
            key: "getBBoxSnapshot",
            value: function getBBoxSnapshot() {
                if (this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0) return $67143c4dbb07e1dc$var$_objectSpread({}, this.lastBoundingBox);
                return {
                    width: 0,
                    height: 0
                };
            }
        },
        {
            key: "getDefaultPosition",
            value: function getDefaultPosition(style) {
                var _this$props = this.props, layout = _this$props.layout, align = _this$props.align, verticalAlign = _this$props.verticalAlign, margin = _this$props.margin, chartWidth = _this$props.chartWidth, chartHeight = _this$props.chartHeight;
                var hPos, vPos;
                if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
                    if (align === "center" && layout === "vertical") {
                        var box = this.getBBoxSnapshot();
                        hPos = {
                            left: ((chartWidth || 0) - box.width) / 2
                        };
                    } else hPos = align === "right" ? {
                        right: margin && margin.right || 0
                    } : {
                        left: margin && margin.left || 0
                    };
                }
                if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
                    if (verticalAlign === "middle") {
                        var _box = this.getBBoxSnapshot();
                        vPos = {
                            top: ((chartHeight || 0) - _box.height) / 2
                        };
                    } else vPos = verticalAlign === "bottom" ? {
                        bottom: margin && margin.bottom || 0
                    } : {
                        top: margin && margin.top || 0
                    };
                }
                return $67143c4dbb07e1dc$var$_objectSpread($67143c4dbb07e1dc$var$_objectSpread({}, hPos), vPos);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, content = _this$props2.content, width = _this$props2.width, height = _this$props2.height, wrapperStyle = _this$props2.wrapperStyle, payloadUniqBy = _this$props2.payloadUniqBy, payload = _this$props2.payload;
                var outerStyle = $67143c4dbb07e1dc$var$_objectSpread($67143c4dbb07e1dc$var$_objectSpread({
                    position: "absolute",
                    width: width || "auto",
                    height: height || "auto"
                }, this.getDefaultPosition(wrapperStyle)), wrapperStyle);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("div", {
                    className: "recharts-legend-wrapper",
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, $67143c4dbb07e1dc$var$renderContent(content, $67143c4dbb07e1dc$var$_objectSpread($67143c4dbb07e1dc$var$_objectSpread({}, this.props), {}, {
                    payload: (0, $lNaU3.getUniqPayload)(payload, payloadUniqBy, $67143c4dbb07e1dc$var$defaultUniqBy)
                })));
            }
        }
    ], [
        {
            key: "getWithHeight",
            value: function getWithHeight(item, chartWidth) {
                var _this$defaultProps$it = $67143c4dbb07e1dc$var$_objectSpread($67143c4dbb07e1dc$var$_objectSpread({}, this.defaultProps), item.props), layout = _this$defaultProps$it.layout;
                if (layout === "vertical" && (0, $1gmrG.isNumber)(item.props.height)) return {
                    height: item.props.height
                };
                if (layout === "horizontal") return {
                    width: item.props.width || chartWidth
                };
                return null;
            }
        }
    ]);
}((0, $jbmdS.PureComponent));
$67143c4dbb07e1dc$var$_defineProperty($67143c4dbb07e1dc$export$ed247974535929c7, "displayName", "Legend");
$67143c4dbb07e1dc$var$_defineProperty($67143c4dbb07e1dc$export$ed247974535929c7, "defaultProps", {
    iconSize: 14,
    layout: "horizontal",
    align: "center",
    verticalAlign: "bottom"
});

});
parcelRegister("lQ3kN", function(module, exports) {

$parcel$export(module.exports, "DefaultLegendContent", function () { return $fe610a756bfa9c80$export$99f8d96ed0cededa; });

var $jbmdS = parcelRequire("jbmdS");

var $i99FY = parcelRequire("i99FY");

var $dWgPS = parcelRequire("dWgPS");

var $aOmiF = parcelRequire("aOmiF");

var $3h6cG = parcelRequire("3h6cG");

var $5q3tP = parcelRequire("5q3tP");

var $gBhCn = parcelRequire("gBhCn");
function $fe610a756bfa9c80$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $fe610a756bfa9c80$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $fe610a756bfa9c80$var$_typeof(o);
}
function $fe610a756bfa9c80$var$_extends() {
    $fe610a756bfa9c80$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fe610a756bfa9c80$var$_extends.apply(this, arguments);
}
function $fe610a756bfa9c80$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fe610a756bfa9c80$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fe610a756bfa9c80$var$ownKeys(Object(t), !0).forEach(function(r) {
            $fe610a756bfa9c80$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fe610a756bfa9c80$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $fe610a756bfa9c80$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $fe610a756bfa9c80$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $fe610a756bfa9c80$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $fe610a756bfa9c80$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $fe610a756bfa9c80$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fe610a756bfa9c80$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $fe610a756bfa9c80$var$_callSuper(t, o, e) {
    return o = $fe610a756bfa9c80$var$_getPrototypeOf(o), $fe610a756bfa9c80$var$_possibleConstructorReturn(t, $fe610a756bfa9c80$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $fe610a756bfa9c80$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $fe610a756bfa9c80$var$_possibleConstructorReturn(self, call) {
    if (call && ($fe610a756bfa9c80$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $fe610a756bfa9c80$var$_assertThisInitialized(self);
}
function $fe610a756bfa9c80$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $fe610a756bfa9c80$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($fe610a756bfa9c80$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $fe610a756bfa9c80$var$_getPrototypeOf(o) {
    $fe610a756bfa9c80$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $fe610a756bfa9c80$var$_getPrototypeOf(o);
}
function $fe610a756bfa9c80$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $fe610a756bfa9c80$var$_setPrototypeOf(subClass, superClass);
}
function $fe610a756bfa9c80$var$_setPrototypeOf(o, p) {
    $fe610a756bfa9c80$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $fe610a756bfa9c80$var$_setPrototypeOf(o, p);
}
function $fe610a756bfa9c80$var$_defineProperty(obj, key, value) {
    key = $fe610a756bfa9c80$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $fe610a756bfa9c80$var$_toPropertyKey(t) {
    var i = $fe610a756bfa9c80$var$_toPrimitive(t, "string");
    return "symbol" == $fe610a756bfa9c80$var$_typeof(i) ? i : i + "";
}
function $fe610a756bfa9c80$var$_toPrimitive(t, r) {
    if ("object" != $fe610a756bfa9c80$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $fe610a756bfa9c80$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $fe610a756bfa9c80$var$SIZE = 32;
var $fe610a756bfa9c80$export$99f8d96ed0cededa = /*#__PURE__*/ function(_PureComponent) {
    function DefaultLegendContent() {
        $fe610a756bfa9c80$var$_classCallCheck(this, DefaultLegendContent);
        return $fe610a756bfa9c80$var$_callSuper(this, DefaultLegendContent, arguments);
    }
    $fe610a756bfa9c80$var$_inherits(DefaultLegendContent, _PureComponent);
    return $fe610a756bfa9c80$var$_createClass(DefaultLegendContent, [
        {
            key: "renderIcon",
            value: /**
     * Render the path of icon
     * @param {Object} data Data of each legend item
     * @return {String} Path element
     */ function renderIcon(data) {
                var inactiveColor = this.props.inactiveColor;
                var halfSize = $fe610a756bfa9c80$var$SIZE / 2;
                var sixthSize = $fe610a756bfa9c80$var$SIZE / 6;
                var thirdSize = $fe610a756bfa9c80$var$SIZE / 3;
                var color = data.inactive ? inactiveColor : data.color;
                if (data.type === "plainline") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("line", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    strokeDasharray: data.payload.strokeDasharray,
                    x1: 0,
                    y1: halfSize,
                    x2: $fe610a756bfa9c80$var$SIZE,
                    y2: halfSize,
                    className: "recharts-legend-icon"
                });
                if (data.type === "line") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("path", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat($fe610a756bfa9c80$var$SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
                    className: "recharts-legend-icon"
                });
                if (data.type === "rect") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("path", {
                    stroke: "none",
                    fill: color,
                    d: "M0,".concat($fe610a756bfa9c80$var$SIZE / 8, "h").concat($fe610a756bfa9c80$var$SIZE, "v").concat($fe610a756bfa9c80$var$SIZE * 3 / 4, "h").concat(-$fe610a756bfa9c80$var$SIZE, "z"),
                    className: "recharts-legend-icon"
                });
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).isValidElement(data.legendIcon)) {
                    var iconProps = $fe610a756bfa9c80$var$_objectSpread({}, data);
                    delete iconProps.legendIcon;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).cloneElement(data.legendIcon, iconProps);
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $5q3tP.Symbols), {
                    fill: color,
                    cx: halfSize,
                    cy: halfSize,
                    size: $fe610a756bfa9c80$var$SIZE,
                    sizeType: "diameter",
                    type: data.type
                });
            }
        },
        {
            key: "renderItems",
            value: function renderItems() {
                var _this = this;
                var _this$props = this.props, payload = _this$props.payload, iconSize = _this$props.iconSize, layout = _this$props.layout, formatter = _this$props.formatter, inactiveColor = _this$props.inactiveColor;
                var viewBox = {
                    x: 0,
                    y: 0,
                    width: $fe610a756bfa9c80$var$SIZE,
                    height: $fe610a756bfa9c80$var$SIZE
                };
                var itemStyle = {
                    display: layout === "horizontal" ? "inline-block" : "block",
                    marginRight: 10
                };
                var svgStyle = {
                    display: "inline-block",
                    verticalAlign: "middle",
                    marginRight: 4
                };
                return payload.map(function(entry, i) {
                    var finalFormatter = entry.formatter || formatter;
                    var className = (0, $dWgPS.default)($fe610a756bfa9c80$var$_defineProperty($fe610a756bfa9c80$var$_defineProperty({
                        "recharts-legend-item": true
                    }, "legend-item-".concat(i), true), "inactive", entry.inactive));
                    if (entry.type === "none") return null;
                    // Do not render entry.value as functions. Always require static string properties.
                    var entryValue = !(0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(entry.value) ? entry.value : null;
                    (0, $aOmiF.warn)(!(0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(entry.value), 'The name property is also required when using a function for the dataKey of a chart\'s cartesian components. Ex: <Bar name="Name of my Data"/>' // eslint-disable-line max-len
                    );
                    var color = entry.inactive ? inactiveColor : entry.color;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("li", $fe610a756bfa9c80$var$_extends({
                        className: className,
                        style: itemStyle,
                        key: "legend-item-".concat(i)
                    }, (0, $gBhCn.adaptEventsOfChild)(_this.props, entry, i)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $3h6cG.Surface), {
                        width: iconSize,
                        height: iconSize,
                        viewBox: viewBox,
                        style: svgStyle
                    }, _this.renderIcon(entry)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("span", {
                        className: "recharts-legend-item-text",
                        style: {
                            color: color
                        }
                    }, finalFormatter ? finalFormatter(entryValue, entry, i) : entryValue));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, payload = _this$props2.payload, layout = _this$props2.layout, align = _this$props2.align;
                if (!payload || !payload.length) return null;
                var finalStyle = {
                    padding: 0,
                    margin: 0,
                    textAlign: layout === "horizontal" ? align : "left"
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("ul", {
                    className: "recharts-default-legend",
                    style: finalStyle
                }, this.renderItems());
            }
        }
    ]);
}((0, $jbmdS.PureComponent));
$fe610a756bfa9c80$var$_defineProperty($fe610a756bfa9c80$export$99f8d96ed0cededa, "displayName", "Legend");
$fe610a756bfa9c80$var$_defineProperty($fe610a756bfa9c80$export$99f8d96ed0cededa, "defaultProps", {
    iconSize: 14,
    layout: "horizontal",
    align: "center",
    verticalAlign: "middle",
    inactiveColor: "#ccc"
});

});
parcelRegister("aOmiF", function(module, exports) {

$parcel$export(module.exports, "warn", function () { return $7defdf403c68e550$export$c106dd0671a0fc2d; });
/* eslint no-console: 0 */ var $7defdf403c68e550$var$isDev = false;
var $7defdf403c68e550$export$c106dd0671a0fc2d = function warn(condition, format) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    if ($7defdf403c68e550$var$isDev && typeof console !== "undefined" && console.warn) {
        if (format === undefined) console.warn("LogUtils requires an error message argument");
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};

});

parcelRegister("3h6cG", function(module, exports) {

$parcel$export(module.exports, "Surface", function () { return $2627c58495e86a75$export$7b92b459e668cb21; });

var $jbmdS = parcelRequire("jbmdS");

var $dWgPS = parcelRequire("dWgPS");

var $f06D9 = parcelRequire("f06D9");
var $2627c58495e86a75$var$_excluded = [
    "children",
    "width",
    "height",
    "viewBox",
    "className",
    "style",
    "title",
    "desc"
];
function $2627c58495e86a75$var$_extends() {
    $2627c58495e86a75$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2627c58495e86a75$var$_extends.apply(this, arguments);
}
function $2627c58495e86a75$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $2627c58495e86a75$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $2627c58495e86a75$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $2627c58495e86a75$export$7b92b459e668cb21(props) {
    var children = props.children, width = props.width, height = props.height, viewBox = props.viewBox, className = props.className, style = props.style, title = props.title, desc = props.desc, others = $2627c58495e86a75$var$_objectWithoutProperties(props, $2627c58495e86a75$var$_excluded);
    var svgView = viewBox || {
        width: width,
        height: height,
        x: 0,
        y: 0
    };
    var layerClass = (0, $dWgPS.default)("recharts-surface", className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("svg", $2627c58495e86a75$var$_extends({}, (0, $f06D9.filterProps)(others, true, "svg"), {
        className: layerClass,
        width: width,
        height: height,
        style: style,
        viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("desc", null, desc), children);
}

});

parcelRegister("5q3tP", function(module, exports) {

$parcel$export(module.exports, "Symbols", function () { return $3f221487ff917682$export$fa456266707bf4e4; });

var $jbmdS = parcelRequire("jbmdS");

var $lKqbf = parcelRequire("lKqbf");

var $hNS9W = parcelRequire("hNS9W");

var $dWgPS = parcelRequire("dWgPS");

var $f06D9 = parcelRequire("f06D9");
function $3f221487ff917682$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3f221487ff917682$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3f221487ff917682$var$_typeof(o);
}
var $3f221487ff917682$var$_excluded = [
    "type",
    "size",
    "sizeType"
];
function $3f221487ff917682$var$_extends() {
    $3f221487ff917682$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3f221487ff917682$var$_extends.apply(this, arguments);
}
function $3f221487ff917682$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3f221487ff917682$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3f221487ff917682$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3f221487ff917682$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3f221487ff917682$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3f221487ff917682$var$_defineProperty(obj, key, value) {
    key = $3f221487ff917682$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3f221487ff917682$var$_toPropertyKey(t) {
    var i = $3f221487ff917682$var$_toPrimitive(t, "string");
    return "symbol" == $3f221487ff917682$var$_typeof(i) ? i : i + "";
}
function $3f221487ff917682$var$_toPrimitive(t, r) {
    if ("object" != $3f221487ff917682$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $3f221487ff917682$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $3f221487ff917682$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3f221487ff917682$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3f221487ff917682$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $3f221487ff917682$var$symbolFactories = {
    symbolCircle: (0, $hNS9W.symbolCircle),
    symbolCross: (0, $hNS9W.symbolCross),
    symbolDiamond: (0, $hNS9W.symbolDiamond),
    symbolSquare: (0, $hNS9W.symbolSquare),
    symbolStar: (0, $hNS9W.symbolStar),
    symbolTriangle: (0, $hNS9W.symbolTriangle),
    symbolWye: (0, $hNS9W.symbolWye)
};
var $3f221487ff917682$var$RADIAN = Math.PI / 180;
var $3f221487ff917682$var$getSymbolFactory = function getSymbolFactory(type) {
    var name = "symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($lKqbf)))(type));
    return $3f221487ff917682$var$symbolFactories[name] || (0, $hNS9W.symbolCircle);
};
var $3f221487ff917682$var$calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
    if (sizeType === "area") return size;
    switch(type){
        case "cross":
            return 5 * size * size / 9;
        case "diamond":
            return 0.5 * size * size / Math.sqrt(3);
        case "square":
            return size * size;
        case "star":
            var angle = 18 * $3f221487ff917682$var$RADIAN;
            return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
        case "triangle":
            return Math.sqrt(3) * size * size / 4;
        case "wye":
            return (21 - 10 * Math.sqrt(3)) * size * size / 8;
        default:
            return Math.PI * size * size / 4;
    }
};
var $3f221487ff917682$var$registerSymbol = function registerSymbol(key, factory) {
    $3f221487ff917682$var$symbolFactories["symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($lKqbf)))(key))] = factory;
};
var $3f221487ff917682$export$fa456266707bf4e4 = function Symbols(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? "circle" : _ref$type, _ref$size = _ref.size, size = _ref$size === void 0 ? 64 : _ref$size, _ref$sizeType = _ref.sizeType, sizeType = _ref$sizeType === void 0 ? "area" : _ref$sizeType, rest = $3f221487ff917682$var$_objectWithoutProperties(_ref, $3f221487ff917682$var$_excluded);
    var props = $3f221487ff917682$var$_objectSpread($3f221487ff917682$var$_objectSpread({}, rest), {}, {
        type: type,
        size: size,
        sizeType: sizeType
    });
    /**
   * Calculate the path of curve
   * @return {String} path
   */ var getPath = function getPath() {
        var symbolFactory = $3f221487ff917682$var$getSymbolFactory(type);
        var symbol = (0, $hNS9W.symbol)().type(symbolFactory).size($3f221487ff917682$var$calculateAreaSize(size, sizeType, type));
        return symbol();
    };
    var className = props.className, cx = props.cx, cy = props.cy;
    var filteredProps = (0, $f06D9.filterProps)(props, true);
    if (cx === +cx && cy === +cy && size === +size) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("path", $3f221487ff917682$var$_extends({}, filteredProps, {
        className: (0, $dWgPS.default)("recharts-symbols", className),
        transform: "translate(".concat(cx, ", ").concat(cy, ")"),
        d: getPath()
    }));
    return null;
};
$3f221487ff917682$export$fa456266707bf4e4.registerSymbol = $3f221487ff917682$var$registerSymbol;

});


parcelRegister("lNaU3", function(module, exports) {

$parcel$export(module.exports, "getUniqPayload", function () { return $fdd6a1b4294e73ba$export$b67e33c2fb1535fa; });

var $kxLVy = parcelRequire("kxLVy");

var $i99FY = parcelRequire("i99FY");
function $fdd6a1b4294e73ba$export$b67e33c2fb1535fa(payload, option, defaultUniqBy) {
    if (option === true) return (0, (/*@__PURE__*/$parcel$interopDefault($kxLVy)))(payload, defaultUniqBy);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(option)) return (0, (/*@__PURE__*/$parcel$interopDefault($kxLVy)))(payload, option);
    return payload;
}

});
parcelRegister("kxLVy", function(module, exports) {

var $15GS2 = parcelRequire("15GS2");

var $8z85l = parcelRequire("8z85l");
/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $ef4c11111c4310c4$var$uniqBy(array, iteratee) {
    return array && array.length ? $8z85l(array, $15GS2(iteratee, 2)) : [];
}
module.exports = $ef4c11111c4310c4$var$uniqBy;

});
parcelRegister("8z85l", function(module, exports) {

var $iE4Sd = parcelRequire("iE4Sd");

var $9oenn = parcelRequire("9oenn");

var $6tJO2 = parcelRequire("6tJO2");

var $giw2L = parcelRequire("giw2L");

var $8mVjv = parcelRequire("8mVjv");

var $iWpJD = parcelRequire("iWpJD");
/** Used as the size to enable large array optimizations. */ var $63c7dd270bde1726$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $63c7dd270bde1726$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $9oenn, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $6tJO2;
    } else if (length >= $63c7dd270bde1726$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $8mVjv(array);
        if (set) return $iWpJD(set);
        isCommon = false;
        includes = $giw2L;
        seen = new $iE4Sd;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $63c7dd270bde1726$var$baseUniq;

});
parcelRegister("9oenn", function(module, exports) {

var $4sCVM = parcelRequire("4sCVM");
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $6d6181b5ded3e307$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $4sCVM(array, value, 0) > -1;
}
module.exports = $6d6181b5ded3e307$var$arrayIncludes;

});
parcelRegister("4sCVM", function(module, exports) {

var $7vcAM = parcelRequire("7vcAM");

var $2ub8Q = parcelRequire("2ub8Q");

var $h62WL = parcelRequire("h62WL");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $33f7f9d918a21b6b$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $h62WL(array, value, fromIndex) : $7vcAM(array, $2ub8Q, fromIndex);
}
module.exports = $33f7f9d918a21b6b$var$baseIndexOf;

});
parcelRegister("7vcAM", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $57653238e78bc4ed$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $57653238e78bc4ed$var$baseFindIndex;

});

parcelRegister("2ub8Q", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $1cf706a092f1b6a0$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $1cf706a092f1b6a0$var$baseIsNaN;

});

parcelRegister("h62WL", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $c725485d160303a0$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $c725485d160303a0$var$strictIndexOf;

});



parcelRegister("6tJO2", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $4b78fba24c4107ef$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $4b78fba24c4107ef$var$arrayIncludesWith;

});

parcelRegister("8mVjv", function(module, exports) {

var $jnEqy = parcelRequire("jnEqy");

var $jKjLS = parcelRequire("jKjLS");

var $iWpJD = parcelRequire("iWpJD");
/** Used as references for various `Number` constants. */ var $617cd615dcc39bfd$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $617cd615dcc39bfd$var$createSet = !($jnEqy && 1 / $iWpJD(new $jnEqy([
    ,
    -0
]))[1] == $617cd615dcc39bfd$var$INFINITY) ? $jKjLS : function(values) {
    return new $jnEqy(values);
};
module.exports = $617cd615dcc39bfd$var$createSet;

});
parcelRegister("jKjLS", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $e601a657adeda0d0$var$noop() {
// No operation performed.
}
module.exports = $e601a657adeda0d0$var$noop;

});












parcelRegister("6YJY0", function(module, exports) {

$parcel$export(module.exports, "AreaChart", function () { return $514c00b7261e05d6$export$f510429275d6f1a8; });
/**
 * @fileOverview Area Chart
 */ 
var $ddYc2 = parcelRequire("ddYc2");

var $aYonL = parcelRequire("aYonL");

var $eGOJx = parcelRequire("eGOJx");

var $hbTlI = parcelRequire("hbTlI");

var $eZuTD = parcelRequire("eZuTD");
var $514c00b7261e05d6$export$f510429275d6f1a8 = (0, $ddYc2.generateCategoricalChart)({
    chartName: "AreaChart",
    GraphicalChild: (0, $aYonL.Area),
    axisComponents: [
        {
            axisType: "xAxis",
            AxisComp: (0, $eGOJx.XAxis)
        },
        {
            axisType: "yAxis",
            AxisComp: (0, $hbTlI.YAxis)
        }
    ],
    formatAxisMap: (0, $eZuTD.formatAxisMap)
});

});
parcelRegister("ddYc2", function(module, exports) {

$parcel$export(module.exports, "generateCategoricalChart", function () { return $9a0b2e5a798197f9$export$77871aede60e6838; });

var $jbmdS = parcelRequire("jbmdS");

var $aVX0M = parcelRequire("aVX0M");

var $i99FY = parcelRequire("i99FY");

var $hb7df = parcelRequire("hb7df");

var $lNQsK = parcelRequire("lNQsK");

var $lfx6l = parcelRequire("lfx6l");

var $8blM9 = parcelRequire("8blM9");

var $dWgPS = parcelRequire("dWgPS");

var $9GFyS = parcelRequire("9GFyS");

var $3h6cG = parcelRequire("3h6cG");

var $bIYfh = parcelRequire("bIYfh");

var $6SvzI = parcelRequire("6SvzI");

var $8QGC8 = parcelRequire("8QGC8");

var $6eKmI = parcelRequire("6eKmI");

var $DN6Qj = parcelRequire("DN6Qj");

var $f06D9 = parcelRequire("f06D9");

var $9DdPg = parcelRequire("9DdPg");

var $kPfcu = parcelRequire("kPfcu");

var $1gmrG = parcelRequire("1gmrG");

var $fiDSf = parcelRequire("fiDSf");
var $jTbSW = parcelRequire("jTbSW");

var $eMtk2 = parcelRequire("eMtk2");

var $h7eoY = parcelRequire("h7eoY");

var $cxCWI = parcelRequire("cxCWI");

var $j2HEf = parcelRequire("j2HEf");

var $gBhCn = parcelRequire("gBhCn");

var $gL1qG = parcelRequire("gL1qG");

var $aGXRe = parcelRequire("aGXRe");

var $cFsdf = parcelRequire("cFsdf");

var $1Co4M = parcelRequire("1Co4M");

var $jgA03 = parcelRequire("jgA03");
var $9a0b2e5a798197f9$var$_excluded = [
    "item"
], $9a0b2e5a798197f9$var$_excluded2 = [
    "children",
    "className",
    "width",
    "height",
    "style",
    "compact",
    "title",
    "desc"
];
function $9a0b2e5a798197f9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9a0b2e5a798197f9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9a0b2e5a798197f9$var$_typeof(o);
}
function $9a0b2e5a798197f9$var$_extends() {
    $9a0b2e5a798197f9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9a0b2e5a798197f9$var$_extends.apply(this, arguments);
}
function $9a0b2e5a798197f9$var$_slicedToArray(arr, i) {
    return $9a0b2e5a798197f9$var$_arrayWithHoles(arr) || $9a0b2e5a798197f9$var$_iterableToArrayLimit(arr, i) || $9a0b2e5a798197f9$var$_unsupportedIterableToArray(arr, i) || $9a0b2e5a798197f9$var$_nonIterableRest();
}
function $9a0b2e5a798197f9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9a0b2e5a798197f9$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $9a0b2e5a798197f9$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $9a0b2e5a798197f9$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $9a0b2e5a798197f9$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $9a0b2e5a798197f9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $9a0b2e5a798197f9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9a0b2e5a798197f9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $9a0b2e5a798197f9$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $9a0b2e5a798197f9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $9a0b2e5a798197f9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9a0b2e5a798197f9$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $9a0b2e5a798197f9$var$_callSuper(t, o, e) {
    return o = $9a0b2e5a798197f9$var$_getPrototypeOf(o), $9a0b2e5a798197f9$var$_possibleConstructorReturn(t, $9a0b2e5a798197f9$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $9a0b2e5a798197f9$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $9a0b2e5a798197f9$var$_possibleConstructorReturn(self, call) {
    if (call && ($9a0b2e5a798197f9$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $9a0b2e5a798197f9$var$_assertThisInitialized(self);
}
function $9a0b2e5a798197f9$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $9a0b2e5a798197f9$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($9a0b2e5a798197f9$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $9a0b2e5a798197f9$var$_getPrototypeOf(o) {
    $9a0b2e5a798197f9$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $9a0b2e5a798197f9$var$_getPrototypeOf(o);
}
function $9a0b2e5a798197f9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $9a0b2e5a798197f9$var$_setPrototypeOf(subClass, superClass);
}
function $9a0b2e5a798197f9$var$_setPrototypeOf(o, p) {
    $9a0b2e5a798197f9$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $9a0b2e5a798197f9$var$_setPrototypeOf(o, p);
}
function $9a0b2e5a798197f9$var$_toConsumableArray(arr) {
    return $9a0b2e5a798197f9$var$_arrayWithoutHoles(arr) || $9a0b2e5a798197f9$var$_iterableToArray(arr) || $9a0b2e5a798197f9$var$_unsupportedIterableToArray(arr) || $9a0b2e5a798197f9$var$_nonIterableSpread();
}
function $9a0b2e5a798197f9$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9a0b2e5a798197f9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9a0b2e5a798197f9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9a0b2e5a798197f9$var$_arrayLikeToArray(o, minLen);
}
function $9a0b2e5a798197f9$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $9a0b2e5a798197f9$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $9a0b2e5a798197f9$var$_arrayLikeToArray(arr);
}
function $9a0b2e5a798197f9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9a0b2e5a798197f9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9a0b2e5a798197f9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9a0b2e5a798197f9$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9a0b2e5a798197f9$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9a0b2e5a798197f9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9a0b2e5a798197f9$var$_defineProperty(obj, key, value) {
    key = $9a0b2e5a798197f9$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9a0b2e5a798197f9$var$_toPropertyKey(t) {
    var i = $9a0b2e5a798197f9$var$_toPrimitive(t, "string");
    return "symbol" == $9a0b2e5a798197f9$var$_typeof(i) ? i : i + "";
}
function $9a0b2e5a798197f9$var$_toPrimitive(t, r) {
    if ("object" != $9a0b2e5a798197f9$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $9a0b2e5a798197f9$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $9a0b2e5a798197f9$var$ORIENT_MAP = {
    xAxis: [
        "bottom",
        "top"
    ],
    yAxis: [
        "left",
        "right"
    ]
};
var $9a0b2e5a798197f9$var$FULL_WIDTH_AND_HEIGHT = {
    width: "100%",
    height: "100%"
};
var $9a0b2e5a798197f9$var$originCoordinate = {
    x: 0,
    y: 0
};
/**
 * This function exists as a temporary workaround.
 *
 * Why? generateCategoricalChart does not render `{children}` directly;
 * instead it passes them through `renderByOrder` function which reads their handlers.
 *
 * So, this is a handler that does nothing.
 * Once we get rid of `renderByOrder` and switch to JSX only, we can get rid of this handler too.
 *
 * @param {JSX} element as is in JSX
 * @returns {JSX} the same element
 */ function $9a0b2e5a798197f9$var$renderAsIs(element) {
    return element;
}
var $9a0b2e5a798197f9$var$calculateTooltipPos = function calculateTooltipPos(rangeObj, layout) {
    if (layout === "horizontal") return rangeObj.x;
    if (layout === "vertical") return rangeObj.y;
    if (layout === "centric") return rangeObj.angle;
    return rangeObj.radius;
};
var $9a0b2e5a798197f9$var$getActiveCoordinate = function getActiveCoordinate(layout, tooltipTicks, activeIndex, rangeObj) {
    var entry = tooltipTicks.find(function(tick) {
        return tick && tick.index === activeIndex;
    });
    if (entry) {
        if (layout === "horizontal") return {
            x: entry.coordinate,
            y: rangeObj.y
        };
        if (layout === "vertical") return {
            x: rangeObj.x,
            y: entry.coordinate
        };
        if (layout === "centric") {
            var _angle = entry.coordinate;
            var _radius = rangeObj.radius;
            return $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, rangeObj), (0, $h7eoY.polarToCartesian)(rangeObj.cx, rangeObj.cy, _radius, _angle)), {}, {
                angle: _angle,
                radius: _radius
            });
        }
        var radius = entry.coordinate;
        var angle = rangeObj.angle;
        return $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, rangeObj), (0, $h7eoY.polarToCartesian)(rangeObj.cx, rangeObj.cy, radius, angle)), {}, {
            angle: angle,
            radius: radius
        });
    }
    return $9a0b2e5a798197f9$var$originCoordinate;
};
var $9a0b2e5a798197f9$var$getDisplayedData = function getDisplayedData(data, _ref) {
    var graphicalItems = _ref.graphicalItems, dataStartIndex = _ref.dataStartIndex, dataEndIndex = _ref.dataEndIndex;
    var itemsData = (graphicalItems !== null && graphicalItems !== void 0 ? graphicalItems : []).reduce(function(result, child) {
        var itemData = child.props.data;
        if (itemData && itemData.length) return [].concat($9a0b2e5a798197f9$var$_toConsumableArray(result), $9a0b2e5a798197f9$var$_toConsumableArray(itemData));
        return result;
    }, []);
    if (itemsData.length > 0) return itemsData;
    if (data && data.length && (0, $1gmrG.isNumber)(dataStartIndex) && (0, $1gmrG.isNumber)(dataEndIndex)) return data.slice(dataStartIndex, dataEndIndex + 1);
    return [];
};
function $9a0b2e5a798197f9$var$getDefaultDomainByAxisType(axisType) {
    return axisType === "number" ? [
        0,
        "auto"
    ] : undefined;
}
/**
 * Get the content to be displayed in the tooltip
 * @param  {Object} state          Current state
 * @param  {Array}  chartData      The data defined in chart
 * @param  {Number} activeIndex    Active index of data
 * @param  {String} activeLabel    Active label of data
 * @return {Array}                 The content of tooltip
 */ var $9a0b2e5a798197f9$var$getTooltipContent = function getTooltipContent(state, chartData, activeIndex, activeLabel) {
    var graphicalItems = state.graphicalItems, tooltipAxis = state.tooltipAxis;
    var displayedData = $9a0b2e5a798197f9$var$getDisplayedData(chartData, state);
    if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) return null;
    // get data by activeIndex when the axis don't allow duplicated category
    return graphicalItems.reduce(function(result, child) {
        var _child$props$data;
        /**
     * Fixes: https://github.com/recharts/recharts/issues/3669
     * Defaulting to chartData below to fix an edge case where the tooltip does not include data from all charts
     * when a separate dataset is passed to chart prop data and specified on Line/Area/etc prop data
     */ var data = (_child$props$data = child.props.data) !== null && _child$props$data !== void 0 ? _child$props$data : chartData;
        if (data && state.dataStartIndex + state.dataEndIndex !== 0 && // https://github.com/recharts/recharts/issues/4717
        // The data is sliced only when the active index is within the start/end index range.
        state.dataEndIndex - state.dataStartIndex >= activeIndex) data = data.slice(state.dataStartIndex, state.dataEndIndex + 1);
        var payload;
        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
            // graphic child has data props
            var entries = data === undefined ? displayedData : data;
            payload = (0, $1gmrG.findEntryInArray)(entries, tooltipAxis.dataKey, activeLabel);
        } else payload = data && data[activeIndex] || displayedData[activeIndex];
        if (!payload) return result;
        return [].concat($9a0b2e5a798197f9$var$_toConsumableArray(result), [
            (0, $fiDSf.getTooltipItem)(child, payload)
        ]);
    }, []);
};
/**
 * Returns tooltip data based on a mouse position (as a parameter or in state)
 * @param  {Object} state     current state
 * @param  {Array}  chartData the data defined in chart
 * @param  {String} layout     The layout type of chart
 * @param  {Object} rangeObj  { x, y } coordinates
 * @return {Object}           Tooltip data data
 */ var $9a0b2e5a798197f9$var$getTooltipData = function getTooltipData(state, chartData, layout, rangeObj) {
    var rangeData = rangeObj || {
        x: state.chartX,
        y: state.chartY
    };
    var pos = $9a0b2e5a798197f9$var$calculateTooltipPos(rangeData, layout);
    var ticks = state.orderedTooltipTicks, axis = state.tooltipAxis, tooltipTicks = state.tooltipTicks;
    var activeIndex = (0, $fiDSf.calculateActiveTickIndex)(pos, ticks, tooltipTicks, axis);
    if (activeIndex >= 0 && tooltipTicks) {
        var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
        var activePayload = $9a0b2e5a798197f9$var$getTooltipContent(state, chartData, activeIndex, activeLabel);
        var activeCoordinate = $9a0b2e5a798197f9$var$getActiveCoordinate(layout, ticks, activeIndex, rangeData);
        return {
            activeTooltipIndex: activeIndex,
            activeLabel: activeLabel,
            activePayload: activePayload,
            activeCoordinate: activeCoordinate
        };
    }
    return null;
};
var $9a0b2e5a798197f9$export$7a36da8ad5d1965e = function getAxisMapByAxes(props, _ref2) {
    var axes = _ref2.axes, graphicalItems = _ref2.graphicalItems, axisType = _ref2.axisType, axisIdKey = _ref2.axisIdKey, stackGroups = _ref2.stackGroups, dataStartIndex = _ref2.dataStartIndex, dataEndIndex = _ref2.dataEndIndex;
    var layout = props.layout, children = props.children, stackOffset = props.stackOffset;
    var isCategorical = (0, $fiDSf.isCategoricalAxis)(layout, axisType);
    // Eliminate duplicated axes
    return axes.reduce(function(result, child) {
        var _childProps$domain2;
        var childProps = child.type.defaultProps !== undefined ? $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, child.type.defaultProps), child.props) : child.props;
        var type = childProps.type, dataKey = childProps.dataKey, allowDataOverflow = childProps.allowDataOverflow, allowDuplicatedCategory = childProps.allowDuplicatedCategory, scale = childProps.scale, ticks = childProps.ticks, includeHidden = childProps.includeHidden;
        var axisId = childProps[axisIdKey];
        if (result[axisId]) return result;
        var displayedData = $9a0b2e5a798197f9$var$getDisplayedData(props.data, {
            graphicalItems: graphicalItems.filter(function(item) {
                var _defaultProps;
                var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps = item.type.defaultProps) === null || _defaultProps === void 0 ? void 0 : _defaultProps[axisIdKey];
                return itemAxisId === axisId;
            }),
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
        });
        var len = displayedData.length;
        var domain, duplicateDomain, categoricalDomain;
        /*
     * This is a hack to short-circuit the domain creation here to enhance performance.
     * Usually, the data is used to determine the domain, but when the user specifies
     * a domain upfront (via props), there is no need to calculate the domain start and end,
     * which is very expensive for a larger amount of data.
     * The only thing that would prohibit short-circuiting is when the user doesn't allow data overflow,
     * because the axis is supposed to ignore the specified domain that way.
     */ if ((0, $aGXRe.isDomainSpecifiedByUser)(childProps.domain, allowDataOverflow, type)) {
            domain = (0, $fiDSf.parseSpecifiedDomain)(childProps.domain, null, allowDataOverflow);
            /* The chart can be categorical and have the domain specified in numbers
       * we still need to calculate the categorical domain
       * TODO: refactor this more
       */ if (isCategorical && (type === "number" || scale !== "auto")) categoricalDomain = (0, $fiDSf.getDomainOfDataByKey)(displayedData, dataKey, "category");
        }
        // if the domain is defaulted we need this for `originalDomain` as well
        var defaultDomain = $9a0b2e5a798197f9$var$getDefaultDomainByAxisType(type);
        // we didn't create the domain from user's props above, so we need to calculate it
        if (!domain || domain.length === 0) {
            var _childProps$domain;
            var childDomain = (_childProps$domain = childProps.domain) !== null && _childProps$domain !== void 0 ? _childProps$domain : defaultDomain;
            if (dataKey) {
                // has dataKey in <Axis />
                domain = (0, $fiDSf.getDomainOfDataByKey)(displayedData, dataKey, type);
                if (type === "category" && isCategorical) {
                    // the field type is category data and this axis is categorical axis
                    var duplicate = (0, $1gmrG.hasDuplicate)(domain);
                    if (allowDuplicatedCategory && duplicate) {
                        duplicateDomain = domain;
                        // When category axis has duplicated text, serial numbers are used to generate scale
                        domain = (0, (/*@__PURE__*/$parcel$interopDefault($hb7df)))(0, len);
                    } else if (!allowDuplicatedCategory) // remove duplicated category
                    domain = (0, $fiDSf.parseDomainOfCategoryAxis)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 ? finalDomain : [].concat($9a0b2e5a798197f9$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                } else if (type === "category") {
                    // the field type is category data and this axis is numerical axis
                    if (!allowDuplicatedCategory) domain = (0, $fiDSf.parseDomainOfCategoryAxis)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 || entry === "" || (0, (/*@__PURE__*/$parcel$interopDefault($aVX0M)))(entry) ? finalDomain : [].concat($9a0b2e5a798197f9$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                    else // eliminate undefined or null or empty string
                    domain = domain.filter(function(entry) {
                        return entry !== "" && !(0, (/*@__PURE__*/$parcel$interopDefault($aVX0M)))(entry);
                    });
                } else if (type === "number") {
                    // the field type is numerical
                    var errorBarsDomain = (0, $fiDSf.parseErrorBarsOfAxis)(displayedData, graphicalItems.filter(function(item) {
                        var _defaultProps2, _defaultProps3;
                        var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps2 = item.type.defaultProps) === null || _defaultProps2 === void 0 ? void 0 : _defaultProps2[axisIdKey];
                        var itemHide = "hide" in item.props ? item.props.hide : (_defaultProps3 = item.type.defaultProps) === null || _defaultProps3 === void 0 ? void 0 : _defaultProps3.hide;
                        return itemAxisId === axisId && (includeHidden || !itemHide);
                    }), dataKey, axisType, layout);
                    if (errorBarsDomain) domain = errorBarsDomain;
                }
                if (isCategorical && (type === "number" || scale !== "auto")) categoricalDomain = (0, $fiDSf.getDomainOfDataByKey)(displayedData, dataKey, "category");
            } else if (isCategorical) // the axis is a categorical axis
            domain = (0, (/*@__PURE__*/$parcel$interopDefault($hb7df)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === "number") // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
            domain = stackOffset === "expand" ? [
                0,
                1
            ] : (0, $fiDSf.getDomainOfStackGroups)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
            else domain = (0, $fiDSf.getDomainOfItemsWithSameAxis)(displayedData, graphicalItems.filter(function(item) {
                var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : item.type.defaultProps[axisIdKey];
                var itemHide = "hide" in item.props ? item.props.hide : item.type.defaultProps.hide;
                return itemAxisId === axisId && (includeHidden || !itemHide);
            }), type, layout, true);
            if (type === "number") {
                // To detect wether there is any reference lines whose props alwaysShow is true
                domain = (0, $eMtk2.detectReferenceElementsDomain)(children, domain, axisId, axisType, ticks);
                if (childDomain) domain = (0, $fiDSf.parseSpecifiedDomain)(childDomain, domain, allowDataOverflow);
            } else if (type === "category" && childDomain) {
                var axisDomain = childDomain;
                var isDomainValid = domain.every(function(entry) {
                    return axisDomain.indexOf(entry) >= 0;
                });
                if (isDomainValid) domain = axisDomain;
            }
        }
        return $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, result), {}, $9a0b2e5a798197f9$var$_defineProperty({}, axisId, $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, childProps), {}, {
            axisType: axisType,
            domain: domain,
            categoricalDomain: categoricalDomain,
            duplicateDomain: duplicateDomain,
            originalDomain: (_childProps$domain2 = childProps.domain) !== null && _childProps$domain2 !== void 0 ? _childProps$domain2 : defaultDomain,
            isCategorical: isCategorical,
            layout: layout
        })));
    }, {});
};
/**
 * Get the configuration of axis by the options of item,
 * this kind of axis does not display in chart
 * @param  {Object} props         Latest props
 * @param  {Array} graphicalItems The instances of item
 * @param  {ReactElement} Axis    Axis Component
 * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
 * @param  {String} axisIdKey     The unique id of an axis
 * @param  {Object} stackGroups   The items grouped by axisId and stackId
 * @param {Number} dataStartIndex The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
 * @return {Object}               Configuration
 */ var $9a0b2e5a798197f9$var$getAxisMapByItems = function getAxisMapByItems(props, _ref3) {
    var graphicalItems = _ref3.graphicalItems, Axis = _ref3.Axis, axisType = _ref3.axisType, axisIdKey = _ref3.axisIdKey, stackGroups = _ref3.stackGroups, dataStartIndex = _ref3.dataStartIndex, dataEndIndex = _ref3.dataEndIndex;
    var layout = props.layout, children = props.children;
    var displayedData = $9a0b2e5a798197f9$var$getDisplayedData(props.data, {
        graphicalItems: graphicalItems,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    var len = displayedData.length;
    var isCategorical = (0, $fiDSf.isCategoricalAxis)(layout, axisType);
    var index = -1;
    // The default type of x-axis is category axis,
    // The default contents of x-axis is the serial numbers of data
    // The default type of y-axis is number axis
    // The default contents of y-axis is the domain of data
    return graphicalItems.reduce(function(result, child) {
        var childProps = child.type.defaultProps !== undefined ? $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, child.type.defaultProps), child.props) : child.props;
        var axisId = childProps[axisIdKey];
        var originalDomain = $9a0b2e5a798197f9$var$getDefaultDomainByAxisType("number");
        if (!result[axisId]) {
            index++;
            var domain;
            if (isCategorical) domain = (0, (/*@__PURE__*/$parcel$interopDefault($hb7df)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
                domain = (0, $fiDSf.getDomainOfStackGroups)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
                domain = (0, $eMtk2.detectReferenceElementsDomain)(children, domain, axisId, axisType);
            } else {
                domain = (0, $fiDSf.parseSpecifiedDomain)(originalDomain, (0, $fiDSf.getDomainOfItemsWithSameAxis)(displayedData, graphicalItems.filter(function(item) {
                    var _defaultProps4, _defaultProps5;
                    var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps4 = item.type.defaultProps) === null || _defaultProps4 === void 0 ? void 0 : _defaultProps4[axisIdKey];
                    var itemHide = "hide" in item.props ? item.props.hide : (_defaultProps5 = item.type.defaultProps) === null || _defaultProps5 === void 0 ? void 0 : _defaultProps5.hide;
                    return itemAxisId === axisId && !itemHide;
                }), "number", layout), Axis.defaultProps.allowDataOverflow);
                domain = (0, $eMtk2.detectReferenceElementsDomain)(children, domain, axisId, axisType);
            }
            return $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, result), {}, $9a0b2e5a798197f9$var$_defineProperty({}, axisId, $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({
                axisType: axisType
            }, Axis.defaultProps), {}, {
                hide: true,
                orientation: (0, (/*@__PURE__*/$parcel$interopDefault($lNQsK)))($9a0b2e5a798197f9$var$ORIENT_MAP, "".concat(axisType, ".").concat(index % 2), null),
                domain: domain,
                originalDomain: originalDomain,
                isCategorical: isCategorical,
                layout: layout
            })));
        }
        return result;
    }, {});
};
/**
 * Get the configuration of all x-axis or y-axis
 * @param  {Object} props          Latest props
 * @param  {String} axisType       The type of axis
 * @param  {React.ComponentType}  [AxisComp]      Axis Component
 * @param  {Array}  graphicalItems The instances of item
 * @param  {Object} stackGroups    The items grouped by axisId and stackId
 * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
 * @return {Object}          Configuration
 */ var $9a0b2e5a798197f9$var$getAxisMap = function getAxisMap(props, _ref4) {
    var _ref4$axisType = _ref4.axisType, axisType = _ref4$axisType === void 0 ? "xAxis" : _ref4$axisType, AxisComp = _ref4.AxisComp, graphicalItems = _ref4.graphicalItems, stackGroups = _ref4.stackGroups, dataStartIndex = _ref4.dataStartIndex, dataEndIndex = _ref4.dataEndIndex;
    var children = props.children;
    var axisIdKey = "".concat(axisType, "Id");
    // Get all the instance of Axis
    var axes = (0, $f06D9.findAllByType)(children, AxisComp);
    var axisMap = {};
    if (axes && axes.length) axisMap = $9a0b2e5a798197f9$export$7a36da8ad5d1965e(props, {
        axes: axes,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    else if (graphicalItems && graphicalItems.length) axisMap = $9a0b2e5a798197f9$var$getAxisMapByItems(props, {
        Axis: AxisComp,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    return axisMap;
};
var $9a0b2e5a798197f9$var$tooltipTicksGenerator = function tooltipTicksGenerator(axisMap) {
    var axis = (0, $1gmrG.getAnyElementOfObject)(axisMap);
    var tooltipTicks = (0, $fiDSf.getTicksOfAxis)(axis, false, true);
    return {
        tooltipTicks: tooltipTicks,
        orderedTooltipTicks: (0, (/*@__PURE__*/$parcel$interopDefault($lfx6l)))(tooltipTicks, function(o) {
            return o.coordinate;
        }),
        tooltipAxis: axis,
        tooltipAxisBandSize: (0, $fiDSf.getBandSizeOfAxis)(axis, tooltipTicks)
    };
};
var $9a0b2e5a798197f9$export$e5182fb58612e577 = function createDefaultState(props) {
    var children = props.children, defaultShowTooltip = props.defaultShowTooltip;
    var brushItem = (0, $f06D9.findChildByType)(children, (0, $9DdPg.Brush));
    var startIndex = 0;
    var endIndex = 0;
    if (props.data && props.data.length !== 0) endIndex = props.data.length - 1;
    if (brushItem && brushItem.props) {
        if (brushItem.props.startIndex >= 0) startIndex = brushItem.props.startIndex;
        if (brushItem.props.endIndex >= 0) endIndex = brushItem.props.endIndex;
    }
    return {
        chartX: 0,
        chartY: 0,
        dataStartIndex: startIndex,
        dataEndIndex: endIndex,
        activeTooltipIndex: -1,
        isTooltipActive: Boolean(defaultShowTooltip)
    };
};
var $9a0b2e5a798197f9$var$hasGraphicalBarItem = function hasGraphicalBarItem(graphicalItems) {
    if (!graphicalItems || !graphicalItems.length) return false;
    return graphicalItems.some(function(item) {
        var name = (0, $f06D9.getDisplayName)(item && item.type);
        return name && name.indexOf("Bar") >= 0;
    });
};
var $9a0b2e5a798197f9$var$getAxisNameByLayout = function getAxisNameByLayout(layout) {
    if (layout === "horizontal") return {
        numericAxisName: "yAxis",
        cateAxisName: "xAxis"
    };
    if (layout === "vertical") return {
        numericAxisName: "xAxis",
        cateAxisName: "yAxis"
    };
    if (layout === "centric") return {
        numericAxisName: "radiusAxis",
        cateAxisName: "angleAxis"
    };
    return {
        numericAxisName: "angleAxis",
        cateAxisName: "radiusAxis"
    };
};
/**
 * Calculate the offset of main part in the svg element
 * @param  {Object} params.props          Latest props
 * @param  {Array}  params.graphicalItems The instances of item
 * @param  {Object} params.xAxisMap       The configuration of x-axis
 * @param  {Object} params.yAxisMap       The configuration of y-axis
 * @param  {Object} prevLegendBBox        The boundary box of legend
 * @return {Object} The offset of main part in the svg element
 */ var $9a0b2e5a798197f9$var$calculateOffset = function calculateOffset(_ref5, prevLegendBBox) {
    var props = _ref5.props, graphicalItems = _ref5.graphicalItems, _ref5$xAxisMap = _ref5.xAxisMap, xAxisMap = _ref5$xAxisMap === void 0 ? {} : _ref5$xAxisMap, _ref5$yAxisMap = _ref5.yAxisMap, yAxisMap = _ref5$yAxisMap === void 0 ? {} : _ref5$yAxisMap;
    var width = props.width, height = props.height, children = props.children;
    var margin = props.margin || {};
    var brushItem = (0, $f06D9.findChildByType)(children, (0, $9DdPg.Brush));
    var legendItem = (0, $f06D9.findChildByType)(children, (0, $8QGC8.Legend));
    var offsetH = Object.keys(yAxisMap).reduce(function(result, id) {
        var entry = yAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, result), {}, $9a0b2e5a798197f9$var$_defineProperty({}, orientation, result[orientation] + entry.width));
        return result;
    }, {
        left: margin.left || 0,
        right: margin.right || 0
    });
    var offsetV = Object.keys(xAxisMap).reduce(function(result, id) {
        var entry = xAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, result), {}, $9a0b2e5a798197f9$var$_defineProperty({}, orientation, (0, (/*@__PURE__*/$parcel$interopDefault($lNQsK)))(result, "".concat(orientation)) + entry.height));
        return result;
    }, {
        top: margin.top || 0,
        bottom: margin.bottom || 0
    });
    var offset = $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, offsetV), offsetH);
    var brushBottom = offset.bottom;
    if (brushItem) offset.bottom += brushItem.props.height || (0, $9DdPg.Brush).defaultProps.height;
    if (legendItem && prevLegendBBox) // @ts-expect-error margin is optional in props but required in appendOffsetOfLegend
    offset = (0, $fiDSf.appendOffsetOfLegend)(offset, graphicalItems, props, prevLegendBBox);
    var offsetWidth = width - offset.left - offset.right;
    var offsetHeight = height - offset.top - offset.bottom;
    return $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({
        brushBottom: brushBottom
    }, offset), {}, {
        // never return negative values for height and width
        width: Math.max(offsetWidth, 0),
        height: Math.max(offsetHeight, 0)
    });
};
// Determine the size of the axis, used for calculation of relative bar sizes
var $9a0b2e5a798197f9$var$getCartesianAxisSize = function getCartesianAxisSize(axisObj, axisName) {
    if (axisName === "xAxis") return axisObj[axisName].width;
    if (axisName === "yAxis") return axisObj[axisName].height;
    // This is only supported for Bar charts (i.e. charts with cartesian axes), so we should never get here
    return undefined;
};
var $9a0b2e5a798197f9$export$77871aede60e6838 = function generateCategoricalChart(_ref6) {
    var chartName = _ref6.chartName, GraphicalChild = _ref6.GraphicalChild, _ref6$defaultTooltipE = _ref6.defaultTooltipEventType, defaultTooltipEventType = _ref6$defaultTooltipE === void 0 ? "axis" : _ref6$defaultTooltipE, _ref6$validateTooltip = _ref6.validateTooltipEventTypes, validateTooltipEventTypes = _ref6$validateTooltip === void 0 ? [
        "axis"
    ] : _ref6$validateTooltip, axisComponents = _ref6.axisComponents, legendContent = _ref6.legendContent, formatAxisMap = _ref6.formatAxisMap, defaultProps = _ref6.defaultProps;
    var getFormatItems = function getFormatItems(props, currentState) {
        var graphicalItems = currentState.graphicalItems, stackGroups = currentState.stackGroups, offset = currentState.offset, updateId = currentState.updateId, dataStartIndex = currentState.dataStartIndex, dataEndIndex = currentState.dataEndIndex;
        var barSize = props.barSize, layout = props.layout, barGap = props.barGap, barCategoryGap = props.barCategoryGap, globalMaxBarSize = props.maxBarSize;
        var _getAxisNameByLayout = $9a0b2e5a798197f9$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout.numericAxisName, cateAxisName = _getAxisNameByLayout.cateAxisName;
        var hasBar = $9a0b2e5a798197f9$var$hasGraphicalBarItem(graphicalItems);
        var formattedItems = [];
        graphicalItems.forEach(function(item, index) {
            var displayedData = $9a0b2e5a798197f9$var$getDisplayedData(props.data, {
                graphicalItems: [
                    item
                ],
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            });
            var itemProps = item.type.defaultProps !== undefined ? $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
            var dataKey = itemProps.dataKey, childMaxBarSize = itemProps.maxBarSize;
            // axisId of the numerical axis
            var numericAxisId = itemProps["".concat(numericAxisName, "Id")];
            // axisId of the categorical axis
            var cateAxisId = itemProps["".concat(cateAxisName, "Id")];
            var axisObjInitialValue = {};
            var axisObj = axisComponents.reduce(function(result, entry) {
                var _item$type$displayNam, _item$type;
                // map of axisId to axis for a specific axis type
                var axisMap = currentState["".concat(entry.axisType, "Map")];
                // axisId of axis we are currently computing
                var id = itemProps["".concat(entry.axisType, "Id")];
                /**
         * tell the user in dev mode that their configuration is incorrect if we cannot find a match between
         * axisId on the chart and axisId on the axis. zAxis does not get passed in the map for ComposedChart,
         * leave it out of the check for now.
         */ !(axisMap && axisMap[id] || entry.axisType === "zAxis") && (0, $9GFyS.default)(false);
                // the axis we are currently formatting
                var axis = axisMap[id];
                return $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, result), {}, $9a0b2e5a798197f9$var$_defineProperty($9a0b2e5a798197f9$var$_defineProperty({}, entry.axisType, axis), "".concat(entry.axisType, "Ticks"), (0, $fiDSf.getTicksOfAxis)(axis)));
            }, axisObjInitialValue);
            var cateAxis = axisObj[cateAxisName];
            var cateTicks = axisObj["".concat(cateAxisName, "Ticks")];
            var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && (0, $fiDSf.getStackedDataOfItem)(item, stackGroups[numericAxisId].stackGroups);
            var itemIsBar = (0, $f06D9.getDisplayName)(item.type).indexOf("Bar") >= 0;
            var bandSize = (0, $fiDSf.getBandSizeOfAxis)(cateAxis, cateTicks);
            var barPosition = [];
            var sizeList = hasBar && (0, $fiDSf.getBarSizeList)({
                barSize: barSize,
                stackGroups: stackGroups,
                totalSize: $9a0b2e5a798197f9$var$getCartesianAxisSize(axisObj, cateAxisName)
            });
            if (itemIsBar) {
                var _ref7, _getBandSizeOfAxis;
                // If it is bar, calculate the position of bar
                var maxBarSize = (0, (/*@__PURE__*/$parcel$interopDefault($aVX0M)))(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
                var barBandSize = (_ref7 = (_getBandSizeOfAxis = (0, $fiDSf.getBandSizeOfAxis)(cateAxis, cateTicks, true)) !== null && _getBandSizeOfAxis !== void 0 ? _getBandSizeOfAxis : maxBarSize) !== null && _ref7 !== void 0 ? _ref7 : 0;
                barPosition = (0, $fiDSf.getBarPosition)({
                    barGap: barGap,
                    barCategoryGap: barCategoryGap,
                    bandSize: barBandSize !== bandSize ? barBandSize : bandSize,
                    sizeList: sizeList[cateAxisId],
                    maxBarSize: maxBarSize
                });
                if (barBandSize !== bandSize) barPosition = barPosition.map(function(pos) {
                    return $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, pos), {}, {
                        position: $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, pos.position), {}, {
                            offset: pos.position.offset - barBandSize / 2
                        })
                    });
                });
            }
            // @ts-expect-error we should stop reading data from ReactElements
            var composedFn = item && item.type && item.type.getComposedData;
            if (composedFn) formattedItems.push({
                props: $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, composedFn($9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, axisObj), {}, {
                    displayedData: displayedData,
                    props: props,
                    dataKey: dataKey,
                    item: item,
                    bandSize: bandSize,
                    barPosition: barPosition,
                    offset: offset,
                    stackedData: stackedData,
                    layout: layout,
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex
                }))), {}, $9a0b2e5a798197f9$var$_defineProperty($9a0b2e5a798197f9$var$_defineProperty($9a0b2e5a798197f9$var$_defineProperty({
                    key: item.key || "item-".concat(index)
                }, numericAxisName, axisObj[numericAxisName]), cateAxisName, axisObj[cateAxisName]), "animationId", updateId)),
                childIndex: (0, $f06D9.parseChildIndex)(item, props.children),
                item: item
            });
        });
        return formattedItems;
    };
    /**
   * The AxisMaps are expensive to render on large data sets
   * so provide the ability to store them in state and only update them when necessary
   * they are dependent upon the start and end index of
   * the brush so it's important that this method is called _after_
   * the state is updated with any new start/end indices
   *
   * @param {Object} props          The props object to be used for updating the axismaps
   * dataStartIndex: The start index of the data series when a brush is applied
   * dataEndIndex: The end index of the data series when a brush is applied
   * updateId: The update id
   * @param {Object} prevState      Prev state
   * @return {Object} state New state to set
   */ var updateStateOfAxisMapsOffsetAndStackGroups = function updateStateOfAxisMapsOffsetAndStackGroups(_ref8, prevState) {
        var props = _ref8.props, dataStartIndex = _ref8.dataStartIndex, dataEndIndex = _ref8.dataEndIndex, updateId = _ref8.updateId;
        if (!(0, $f06D9.validateWidthHeight)({
            props: props
        })) return null;
        var children = props.children, layout = props.layout, stackOffset = props.stackOffset, data = props.data, reverseStackOrder = props.reverseStackOrder;
        var _getAxisNameByLayout2 = $9a0b2e5a798197f9$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout2.numericAxisName, cateAxisName = _getAxisNameByLayout2.cateAxisName;
        var graphicalItems = (0, $f06D9.findAllByType)(children, GraphicalChild);
        var stackGroups = (0, $fiDSf.getStackGroupsByAxisId)(data, graphicalItems, "".concat(numericAxisName, "Id"), "".concat(cateAxisName, "Id"), stackOffset, reverseStackOrder);
        var axisObj = axisComponents.reduce(function(result, entry) {
            var name = "".concat(entry.axisType, "Map");
            return $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, result), {}, $9a0b2e5a798197f9$var$_defineProperty({}, name, $9a0b2e5a798197f9$var$getAxisMap(props, $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, entry), {}, {
                graphicalItems: graphicalItems,
                stackGroups: entry.axisType === numericAxisName && stackGroups,
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            }))));
        }, {});
        var offset = $9a0b2e5a798197f9$var$calculateOffset($9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, axisObj), {}, {
            props: props,
            graphicalItems: graphicalItems
        }), prevState === null || prevState === void 0 ? void 0 : prevState.legendBBox);
        Object.keys(axisObj).forEach(function(key) {
            axisObj[key] = formatAxisMap(props, axisObj[key], offset, key.replace("Map", ""), chartName);
        });
        var cateAxisMap = axisObj["".concat(cateAxisName, "Map")];
        var ticksObj = $9a0b2e5a798197f9$var$tooltipTicksGenerator(cateAxisMap);
        var formattedGraphicalItems = getFormatItems(props, $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, axisObj), {}, {
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex,
            updateId: updateId,
            graphicalItems: graphicalItems,
            stackGroups: stackGroups,
            offset: offset
        }));
        return $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({
            formattedGraphicalItems: formattedGraphicalItems,
            graphicalItems: graphicalItems,
            offset: offset,
            stackGroups: stackGroups
        }, ticksObj), axisObj);
    };
    var CategoricalChartWrapper = /*#__PURE__*/ function(_Component) {
        function CategoricalChartWrapper(_props) {
            var _props$id, _props$throttleDelay;
            var _this;
            $9a0b2e5a798197f9$var$_classCallCheck(this, CategoricalChartWrapper);
            _this = $9a0b2e5a798197f9$var$_callSuper(this, CategoricalChartWrapper, [
                _props
            ]);
            $9a0b2e5a798197f9$var$_defineProperty(_this, "eventEmitterSymbol", Symbol("rechartsEventEmitter"));
            $9a0b2e5a798197f9$var$_defineProperty(_this, "accessibilityManager", new (0, $gL1qG.AccessibilityManager)());
            $9a0b2e5a798197f9$var$_defineProperty(_this, "handleLegendBBoxUpdate", function(box) {
                if (box) {
                    var _this$state = _this.state, dataStartIndex = _this$state.dataStartIndex, dataEndIndex = _this$state.dataEndIndex, updateId = _this$state.updateId;
                    _this.setState($9a0b2e5a798197f9$var$_objectSpread({
                        legendBBox: box
                    }, updateStateOfAxisMapsOffsetAndStackGroups({
                        props: _this.props,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex,
                        updateId: updateId
                    }, $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, _this.state), {}, {
                        legendBBox: box
                    }))));
                }
            });
            $9a0b2e5a798197f9$var$_defineProperty(_this, "handleReceiveSyncEvent", function(cId, data, emitter) {
                if (_this.props.syncId === cId) {
                    if (emitter === _this.eventEmitterSymbol && typeof _this.props.syncMethod !== "function") return;
                    _this.applySyncEvent(data);
                }
            });
            $9a0b2e5a798197f9$var$_defineProperty(_this, "handleBrushChange", function(_ref9) {
                var startIndex = _ref9.startIndex, endIndex = _ref9.endIndex;
                // Only trigger changes if the extents of the brush have actually changed
                if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
                    var updateId = _this.state.updateId;
                    _this.setState(function() {
                        return $9a0b2e5a798197f9$var$_objectSpread({
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex
                        }, updateStateOfAxisMapsOffsetAndStackGroups({
                            props: _this.props,
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex,
                            updateId: updateId
                        }, _this.state));
                    });
                    _this.triggerSyncEvent({
                        dataStartIndex: startIndex,
                        dataEndIndex: endIndex
                    });
                }
            });
            /**
       * The handler of mouse entering chart
       * @param  {Object} e              Event object
       * @return {Null}                  null
       */ $9a0b2e5a798197f9$var$_defineProperty(_this, "handleMouseEnter", function(e) {
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState = $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState);
                    _this.triggerSyncEvent(_nextState);
                    var onMouseEnter = _this.props.onMouseEnter;
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(onMouseEnter)) onMouseEnter(_nextState, e);
                }
            });
            $9a0b2e5a798197f9$var$_defineProperty(_this, "triggeredAfterMouseMove", function(e) {
                var mouse = _this.getMouseInfo(e);
                var nextState = mouse ? $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, mouse), {}, {
                    isTooltipActive: true
                }) : {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                var onMouseMove = _this.props.onMouseMove;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(onMouseMove)) onMouseMove(nextState, e);
            });
            /**
       * The handler of mouse entering a scatter
       * @param {Object} el The active scatter
       * @return {Object} no return
       */ $9a0b2e5a798197f9$var$_defineProperty(_this, "handleItemMouseEnter", function(el) {
                _this.setState(function() {
                    return {
                        isTooltipActive: true,
                        activeItem: el,
                        activePayload: el.tooltipPayload,
                        activeCoordinate: el.tooltipPosition || {
                            x: el.cx,
                            y: el.cy
                        }
                    };
                });
            });
            /**
       * The handler of mouse leaving a scatter
       * @return {Object} no return
       */ $9a0b2e5a798197f9$var$_defineProperty(_this, "handleItemMouseLeave", function() {
                _this.setState(function() {
                    return {
                        isTooltipActive: false
                    };
                });
            });
            /**
       * The handler of mouse moving in chart
       * @param  {React.MouseEvent} e        Event object
       * @return {void} no return
       */ $9a0b2e5a798197f9$var$_defineProperty(_this, "handleMouseMove", function(e) {
                e.persist();
                _this.throttleTriggeredAfterMouseMove(e);
            });
            /**
       * The handler if mouse leaving chart
       * @param {Object} e Event object
       * @return {Null} no return
       */ $9a0b2e5a798197f9$var$_defineProperty(_this, "handleMouseLeave", function(e) {
                _this.throttleTriggeredAfterMouseMove.cancel();
                var nextState = {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                var onMouseLeave = _this.props.onMouseLeave;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(onMouseLeave)) onMouseLeave(nextState, e);
            });
            $9a0b2e5a798197f9$var$_defineProperty(_this, "handleOuterEvent", function(e) {
                var eventName = (0, $f06D9.getReactEventByType)(e);
                var event = (0, (/*@__PURE__*/$parcel$interopDefault($lNQsK)))(_this.props, "".concat(eventName));
                if (eventName && (0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(event)) {
                    var _mouse;
                    var mouse;
                    if (/.*touch.*/i.test(eventName)) mouse = _this.getMouseInfo(e.changedTouches[0]);
                    else mouse = _this.getMouseInfo(e);
                    event((_mouse = mouse) !== null && _mouse !== void 0 ? _mouse : {}, e);
                }
            });
            $9a0b2e5a798197f9$var$_defineProperty(_this, "handleClick", function(e) {
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState2 = $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState2);
                    _this.triggerSyncEvent(_nextState2);
                    var onClick = _this.props.onClick;
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(onClick)) onClick(_nextState2, e);
                }
            });
            $9a0b2e5a798197f9$var$_defineProperty(_this, "handleMouseDown", function(e) {
                var onMouseDown = _this.props.onMouseDown;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(onMouseDown)) {
                    var _nextState3 = _this.getMouseInfo(e);
                    onMouseDown(_nextState3, e);
                }
            });
            $9a0b2e5a798197f9$var$_defineProperty(_this, "handleMouseUp", function(e) {
                var onMouseUp = _this.props.onMouseUp;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(onMouseUp)) {
                    var _nextState4 = _this.getMouseInfo(e);
                    onMouseUp(_nextState4, e);
                }
            });
            $9a0b2e5a798197f9$var$_defineProperty(_this, "handleTouchMove", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.throttleTriggeredAfterMouseMove(e.changedTouches[0]);
            });
            $9a0b2e5a798197f9$var$_defineProperty(_this, "handleTouchStart", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseDown(e.changedTouches[0]);
            });
            $9a0b2e5a798197f9$var$_defineProperty(_this, "handleTouchEnd", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseUp(e.changedTouches[0]);
            });
            $9a0b2e5a798197f9$var$_defineProperty(_this, "handleDoubleClick", function(e) {
                var onDoubleClick = _this.props.onDoubleClick;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(onDoubleClick)) {
                    var _nextState5 = _this.getMouseInfo(e);
                    onDoubleClick(_nextState5, e);
                }
            });
            $9a0b2e5a798197f9$var$_defineProperty(_this, "handleContextMenu", function(e) {
                var onContextMenu = _this.props.onContextMenu;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(onContextMenu)) {
                    var _nextState6 = _this.getMouseInfo(e);
                    onContextMenu(_nextState6, e);
                }
            });
            $9a0b2e5a798197f9$var$_defineProperty(_this, "triggerSyncEvent", function(data) {
                if (_this.props.syncId !== undefined) (0, $j2HEf.eventCenter).emit((0, $j2HEf.SYNC_EVENT), _this.props.syncId, data, _this.eventEmitterSymbol);
            });
            $9a0b2e5a798197f9$var$_defineProperty(_this, "applySyncEvent", function(data) {
                var _this$props = _this.props, layout = _this$props.layout, syncMethod = _this$props.syncMethod;
                var updateId = _this.state.updateId;
                var dataStartIndex = data.dataStartIndex, dataEndIndex = data.dataEndIndex;
                if (data.dataStartIndex !== undefined || data.dataEndIndex !== undefined) _this.setState($9a0b2e5a798197f9$var$_objectSpread({
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex
                }, updateStateOfAxisMapsOffsetAndStackGroups({
                    props: _this.props,
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex,
                    updateId: updateId
                }, _this.state)));
                else if (data.activeTooltipIndex !== undefined) {
                    var chartX = data.chartX, chartY = data.chartY;
                    var activeTooltipIndex = data.activeTooltipIndex;
                    var _this$state2 = _this.state, offset = _this$state2.offset, tooltipTicks = _this$state2.tooltipTicks;
                    if (!offset) return;
                    if (typeof syncMethod === "function") // Call a callback function. If there is an application specific algorithm
                    activeTooltipIndex = syncMethod(tooltipTicks, data);
                    else if (syncMethod === "value") {
                        // Set activeTooltipIndex to the index with the same value as data.activeLabel
                        // For loop instead of findIndex because the latter is very slow in some browsers
                        activeTooltipIndex = -1; // in case we cannot find the element
                        for(var i = 0; i < tooltipTicks.length; i++)if (tooltipTicks[i].value === data.activeLabel) {
                            activeTooltipIndex = i;
                            break;
                        }
                    }
                    var viewBox = $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    });
                    // When a categorical chart is combined with another chart, the value of chartX
                    // and chartY may beyond the boundaries.
                    var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
                    var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
                    var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
                    var activePayload = $9a0b2e5a798197f9$var$getTooltipContent(_this.state, _this.props.data, activeTooltipIndex);
                    var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
                        x: layout === "horizontal" ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
                        y: layout === "horizontal" ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
                    } : $9a0b2e5a798197f9$var$originCoordinate;
                    _this.setState($9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, data), {}, {
                        activeLabel: activeLabel,
                        activeCoordinate: activeCoordinate,
                        activePayload: activePayload,
                        activeTooltipIndex: activeTooltipIndex
                    }));
                } else _this.setState(data);
            });
            $9a0b2e5a798197f9$var$_defineProperty(_this, "renderCursor", function(element) {
                var _element$props$active;
                var _this$state3 = _this.state, isTooltipActive = _this$state3.isTooltipActive, activeCoordinate = _this$state3.activeCoordinate, activePayload = _this$state3.activePayload, offset = _this$state3.offset, activeTooltipIndex = _this$state3.activeTooltipIndex, tooltipAxisBandSize = _this$state3.tooltipAxisBandSize;
                var tooltipEventType = _this.getTooltipEventType();
                // The cursor is a part of the Tooltip, and it should be shown (by default) when the Tooltip is active.
                var isActive = (_element$props$active = element.props.active) !== null && _element$props$active !== void 0 ? _element$props$active : isTooltipActive;
                var layout = _this.props.layout;
                var key = element.key || "_recharts-cursor";
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $1Co4M.Cursor), {
                    key: key,
                    activeCoordinate: activeCoordinate,
                    activePayload: activePayload,
                    activeTooltipIndex: activeTooltipIndex,
                    chartName: chartName,
                    element: element,
                    isActive: isActive,
                    layout: layout,
                    offset: offset,
                    tooltipAxisBandSize: tooltipAxisBandSize,
                    tooltipEventType: tooltipEventType
                });
            });
            $9a0b2e5a798197f9$var$_defineProperty(_this, "renderPolarAxis", function(element, displayName, index) {
                var axisType = (0, (/*@__PURE__*/$parcel$interopDefault($lNQsK)))(element, "type.axisType");
                var axisMap = (0, (/*@__PURE__*/$parcel$interopDefault($lNQsK)))(_this.state, "".concat(axisType, "Map"));
                var elementDefaultProps = element.type.defaultProps;
                var elementProps = elementDefaultProps !== undefined ? $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, elementDefaultProps), element.props) : element.props;
                var axisOption = axisMap && axisMap[elementProps["".concat(axisType, "Id")]];
                return /*#__PURE__*/ (0, $jbmdS.cloneElement)(element, $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, axisOption), {}, {
                    className: (0, $dWgPS.default)(axisType, axisOption.className),
                    key: element.key || "".concat(displayName, "-").concat(index),
                    ticks: (0, $fiDSf.getTicksOfAxis)(axisOption, true)
                }));
            });
            $9a0b2e5a798197f9$var$_defineProperty(_this, "renderPolarGrid", function(element) {
                var _element$props = element.props, radialLines = _element$props.radialLines, polarAngles = _element$props.polarAngles, polarRadius = _element$props.polarRadius;
                var _this$state4 = _this.state, radiusAxisMap = _this$state4.radiusAxisMap, angleAxisMap = _this$state4.angleAxisMap;
                var radiusAxis = (0, $1gmrG.getAnyElementOfObject)(radiusAxisMap);
                var angleAxis = (0, $1gmrG.getAnyElementOfObject)(angleAxisMap);
                var cx = angleAxis.cx, cy = angleAxis.cy, innerRadius = angleAxis.innerRadius, outerRadius = angleAxis.outerRadius;
                return /*#__PURE__*/ (0, $jbmdS.cloneElement)(element, {
                    polarAngles: Array.isArray(polarAngles) ? polarAngles : (0, $fiDSf.getTicksOfAxis)(angleAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    polarRadius: Array.isArray(polarRadius) ? polarRadius : (0, $fiDSf.getTicksOfAxis)(radiusAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    cx: cx,
                    cy: cy,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius,
                    key: element.key || "polar-grid",
                    radialLines: radialLines
                });
            });
            /**
       * Draw legend
       * @return {ReactElement}            The instance of Legend
       */ $9a0b2e5a798197f9$var$_defineProperty(_this, "renderLegend", function() {
                var formattedGraphicalItems = _this.state.formattedGraphicalItems;
                var _this$props2 = _this.props, children = _this$props2.children, width = _this$props2.width, height = _this$props2.height;
                var margin = _this.props.margin || {};
                var legendWidth = width - (margin.left || 0) - (margin.right || 0);
                var props = (0, $jTbSW.getLegendProps)({
                    children: children,
                    formattedGraphicalItems: formattedGraphicalItems,
                    legendWidth: legendWidth,
                    legendContent: legendContent
                });
                if (!props) return null;
                var item = props.item, otherProps = $9a0b2e5a798197f9$var$_objectWithoutProperties(props, $9a0b2e5a798197f9$var$_excluded);
                return /*#__PURE__*/ (0, $jbmdS.cloneElement)(item, $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, otherProps), {}, {
                    chartWidth: width,
                    chartHeight: height,
                    margin: margin,
                    onBBoxUpdate: _this.handleLegendBBoxUpdate
                }));
            });
            /**
       * Draw Tooltip
       * @return {ReactElement}  The instance of Tooltip
       */ $9a0b2e5a798197f9$var$_defineProperty(_this, "renderTooltip", function() {
                var _tooltipItem$props$ac;
                var _this$props3 = _this.props, children = _this$props3.children, accessibilityLayer = _this$props3.accessibilityLayer;
                var tooltipItem = (0, $f06D9.findChildByType)(children, (0, $6SvzI.Tooltip));
                if (!tooltipItem) return null;
                var _this$state5 = _this.state, isTooltipActive = _this$state5.isTooltipActive, activeCoordinate = _this$state5.activeCoordinate, activePayload = _this$state5.activePayload, activeLabel = _this$state5.activeLabel, offset = _this$state5.offset;
                // The user can set isActive on the Tooltip,
                // and we respect the user to enable customisation.
                // The Tooltip is active if the user has set isActive, or if the tooltip is active due to a mouse event.
                var isActive = (_tooltipItem$props$ac = tooltipItem.props.active) !== null && _tooltipItem$props$ac !== void 0 ? _tooltipItem$props$ac : isTooltipActive;
                return /*#__PURE__*/ (0, $jbmdS.cloneElement)(tooltipItem, {
                    viewBox: $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    }),
                    active: isActive,
                    label: activeLabel,
                    payload: isActive ? activePayload : [],
                    coordinate: activeCoordinate,
                    accessibilityLayer: accessibilityLayer
                });
            });
            $9a0b2e5a798197f9$var$_defineProperty(_this, "renderBrush", function(element) {
                var _this$props4 = _this.props, margin = _this$props4.margin, data = _this$props4.data;
                var _this$state6 = _this.state, offset = _this$state6.offset, dataStartIndex = _this$state6.dataStartIndex, dataEndIndex = _this$state6.dataEndIndex, updateId = _this$state6.updateId;
                // TODO: update brush when children update
                return /*#__PURE__*/ (0, $jbmdS.cloneElement)(element, {
                    key: element.key || "_recharts-brush",
                    onChange: (0, $fiDSf.combineEventHandlers)(_this.handleBrushChange, element.props.onChange),
                    data: data,
                    x: (0, $1gmrG.isNumber)(element.props.x) ? element.props.x : offset.left,
                    y: (0, $1gmrG.isNumber)(element.props.y) ? element.props.y : offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
                    width: (0, $1gmrG.isNumber)(element.props.width) ? element.props.width : offset.width,
                    startIndex: dataStartIndex,
                    endIndex: dataEndIndex,
                    updateId: "brush-".concat(updateId)
                });
            });
            $9a0b2e5a798197f9$var$_defineProperty(_this, "renderReferenceElement", function(element, displayName, index) {
                if (!element) return null;
                var _this2 = _this, clipPathId = _this2.clipPathId;
                var _this$state7 = _this.state, xAxisMap = _this$state7.xAxisMap, yAxisMap = _this$state7.yAxisMap, offset = _this$state7.offset;
                var elementDefaultProps = element.type.defaultProps || {};
                var _element$props2 = element.props, _element$props2$xAxis = _element$props2.xAxisId, xAxisId = _element$props2$xAxis === void 0 ? elementDefaultProps.xAxisId : _element$props2$xAxis, _element$props2$yAxis = _element$props2.yAxisId, yAxisId = _element$props2$yAxis === void 0 ? elementDefaultProps.yAxisId : _element$props2$yAxis;
                return /*#__PURE__*/ (0, $jbmdS.cloneElement)(element, {
                    key: element.key || "".concat(displayName, "-").concat(index),
                    xAxis: xAxisMap[xAxisId],
                    yAxis: yAxisMap[yAxisId],
                    viewBox: {
                        x: offset.left,
                        y: offset.top,
                        width: offset.width,
                        height: offset.height
                    },
                    clipPathId: clipPathId
                });
            });
            $9a0b2e5a798197f9$var$_defineProperty(_this, "renderActivePoints", function(_ref10) {
                var item = _ref10.item, activePoint = _ref10.activePoint, basePoint = _ref10.basePoint, childIndex = _ref10.childIndex, isRange = _ref10.isRange;
                var result = [];
                // item is not a React Element so we don't need to resolve defaultProps.
                var key = item.props.key;
                var itemItemProps = item.item.type.defaultProps !== undefined ? $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, item.item.type.defaultProps), item.item.props) : item.item.props;
                var activeDot = itemItemProps.activeDot, dataKey = itemItemProps.dataKey;
                var dotProps = $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({
                    index: childIndex,
                    dataKey: dataKey,
                    cx: activePoint.x,
                    cy: activePoint.y,
                    r: 4,
                    fill: (0, $fiDSf.getMainColorOfGraphicItem)(item.item),
                    strokeWidth: 2,
                    stroke: "#fff",
                    payload: activePoint.payload,
                    value: activePoint.value
                }, (0, $f06D9.filterProps)(activeDot, false)), (0, $gBhCn.adaptEventHandlers)(activeDot));
                result.push(CategoricalChartWrapper.renderActiveDot(activeDot, dotProps, "".concat(key, "-activePoint-").concat(childIndex)));
                if (basePoint) result.push(CategoricalChartWrapper.renderActiveDot(activeDot, $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, dotProps), {}, {
                    cx: basePoint.x,
                    cy: basePoint.y
                }), "".concat(key, "-basePoint-").concat(childIndex)));
                else if (isRange) result.push(null);
                return result;
            });
            $9a0b2e5a798197f9$var$_defineProperty(_this, "renderGraphicChild", function(element, displayName, index) {
                var item = _this.filterFormatItem(element, displayName, index);
                if (!item) return null;
                var tooltipEventType = _this.getTooltipEventType();
                var _this$state8 = _this.state, isTooltipActive = _this$state8.isTooltipActive, tooltipAxis = _this$state8.tooltipAxis, activeTooltipIndex = _this$state8.activeTooltipIndex, activeLabel = _this$state8.activeLabel;
                var children = _this.props.children;
                var tooltipItem = (0, $f06D9.findChildByType)(children, (0, $6SvzI.Tooltip));
                // item is not a React Element so we don't need to resolve defaultProps
                var _item$props = item.props, points = _item$props.points, isRange = _item$props.isRange, baseLine = _item$props.baseLine;
                var itemItemProps = item.item.type.defaultProps !== undefined ? $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, item.item.type.defaultProps), item.item.props) : item.item.props;
                var activeDot = itemItemProps.activeDot, hide = itemItemProps.hide, activeBar = itemItemProps.activeBar, activeShape = itemItemProps.activeShape;
                var hasActive = Boolean(!hide && isTooltipActive && tooltipItem && (activeDot || activeBar || activeShape));
                var itemEvents = {};
                if (tooltipEventType !== "axis" && tooltipItem && tooltipItem.props.trigger === "click") itemEvents = {
                    onClick: (0, $fiDSf.combineEventHandlers)(_this.handleItemMouseEnter, element.props.onClick)
                };
                else if (tooltipEventType !== "axis") itemEvents = {
                    onMouseLeave: (0, $fiDSf.combineEventHandlers)(_this.handleItemMouseLeave, element.props.onMouseLeave),
                    onMouseEnter: (0, $fiDSf.combineEventHandlers)(_this.handleItemMouseEnter, element.props.onMouseEnter)
                };
                var graphicalItem = /*#__PURE__*/ (0, $jbmdS.cloneElement)(element, $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, item.props), itemEvents));
                function findWithPayload(entry) {
                    // TODO needs to verify dataKey is Function
                    return typeof tooltipAxis.dataKey === "function" ? tooltipAxis.dataKey(entry.payload) : null;
                }
                if (hasActive) {
                    if (activeTooltipIndex >= 0) {
                        var activePoint, basePoint;
                        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
                            // number transform to string
                            var specifiedKey = typeof tooltipAxis.dataKey === "function" ? findWithPayload : "payload.".concat(tooltipAxis.dataKey.toString());
                            activePoint = (0, $1gmrG.findEntryInArray)(points, specifiedKey, activeLabel);
                            basePoint = isRange && baseLine && (0, $1gmrG.findEntryInArray)(baseLine, specifiedKey, activeLabel);
                        } else {
                            activePoint = points === null || points === void 0 ? void 0 : points[activeTooltipIndex];
                            basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
                        }
                        if (activeShape || activeBar) {
                            var activeIndex = element.props.activeIndex !== undefined ? element.props.activeIndex : activeTooltipIndex;
                            return [
                                /*#__PURE__*/ (0, $jbmdS.cloneElement)(element, $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, item.props), itemEvents), {}, {
                                    activeIndex: activeIndex
                                })),
                                null,
                                null
                            ];
                        }
                        if (!(0, (/*@__PURE__*/$parcel$interopDefault($aVX0M)))(activePoint)) return [
                            graphicalItem
                        ].concat($9a0b2e5a798197f9$var$_toConsumableArray(_this.renderActivePoints({
                            item: item,
                            activePoint: activePoint,
                            basePoint: basePoint,
                            childIndex: activeTooltipIndex,
                            isRange: isRange
                        })));
                    } else {
                        var _this$getItemByXY;
                        /**
             * We hit this block if consumer uses a Tooltip without XAxis and/or YAxis.
             * In which case, this.state.activeTooltipIndex never gets set
             * because the mouse events that trigger that value getting set never get trigged without the axis components.
             *
             * An example usage case is a FunnelChart
             */ var _ref11 = (_this$getItemByXY = _this.getItemByXY(_this.state.activeCoordinate)) !== null && _this$getItemByXY !== void 0 ? _this$getItemByXY : {
                            graphicalItem: graphicalItem
                        }, _ref11$graphicalItem = _ref11.graphicalItem, _ref11$graphicalItem$ = _ref11$graphicalItem.item, xyItem = _ref11$graphicalItem$ === void 0 ? element : _ref11$graphicalItem$, childIndex = _ref11$graphicalItem.childIndex;
                        var elementProps = $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, item.props), itemEvents), {}, {
                            activeIndex: childIndex
                        });
                        return [
                            /*#__PURE__*/ (0, $jbmdS.cloneElement)(xyItem, elementProps),
                            null,
                            null
                        ];
                    }
                }
                if (isRange) return [
                    graphicalItem,
                    null,
                    null
                ];
                return [
                    graphicalItem,
                    null
                ];
            });
            $9a0b2e5a798197f9$var$_defineProperty(_this, "renderCustomized", function(element, displayName, index) {
                return /*#__PURE__*/ (0, $jbmdS.cloneElement)(element, $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({
                    key: "recharts-customized-".concat(index)
                }, _this.props), _this.state));
            });
            $9a0b2e5a798197f9$var$_defineProperty(_this, "renderMap", {
                CartesianGrid: {
                    handler: $9a0b2e5a798197f9$var$renderAsIs,
                    once: true
                },
                ReferenceArea: {
                    handler: _this.renderReferenceElement
                },
                ReferenceLine: {
                    handler: $9a0b2e5a798197f9$var$renderAsIs
                },
                ReferenceDot: {
                    handler: _this.renderReferenceElement
                },
                XAxis: {
                    handler: $9a0b2e5a798197f9$var$renderAsIs
                },
                YAxis: {
                    handler: $9a0b2e5a798197f9$var$renderAsIs
                },
                Brush: {
                    handler: _this.renderBrush,
                    once: true
                },
                Bar: {
                    handler: _this.renderGraphicChild
                },
                Line: {
                    handler: _this.renderGraphicChild
                },
                Area: {
                    handler: _this.renderGraphicChild
                },
                Radar: {
                    handler: _this.renderGraphicChild
                },
                RadialBar: {
                    handler: _this.renderGraphicChild
                },
                Scatter: {
                    handler: _this.renderGraphicChild
                },
                Pie: {
                    handler: _this.renderGraphicChild
                },
                Funnel: {
                    handler: _this.renderGraphicChild
                },
                Tooltip: {
                    handler: _this.renderCursor,
                    once: true
                },
                PolarGrid: {
                    handler: _this.renderPolarGrid,
                    once: true
                },
                PolarAngleAxis: {
                    handler: _this.renderPolarAxis
                },
                PolarRadiusAxis: {
                    handler: _this.renderPolarAxis
                },
                Customized: {
                    handler: _this.renderCustomized
                }
            });
            _this.clipPathId = "".concat((_props$id = _props.id) !== null && _props$id !== void 0 ? _props$id : (0, $1gmrG.uniqueId)("recharts"), "-clip");
            // trigger 60fps
            _this.throttleTriggeredAfterMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($8blM9)))(_this.triggeredAfterMouseMove, (_props$throttleDelay = _props.throttleDelay) !== null && _props$throttleDelay !== void 0 ? _props$throttleDelay : 1000 / 60);
            _this.state = {};
            return _this;
        }
        $9a0b2e5a798197f9$var$_inherits(CategoricalChartWrapper, _Component);
        return $9a0b2e5a798197f9$var$_createClass(CategoricalChartWrapper, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _this$props$margin$le, _this$props$margin$to;
                    this.addListener();
                    this.accessibilityManager.setDetails({
                        container: this.container,
                        offset: {
                            left: (_this$props$margin$le = this.props.margin.left) !== null && _this$props$margin$le !== void 0 ? _this$props$margin$le : 0,
                            top: (_this$props$margin$to = this.props.margin.top) !== null && _this$props$margin$to !== void 0 ? _this$props$margin$to : 0
                        },
                        coordinateList: this.state.tooltipTicks,
                        mouseHandlerCallback: this.triggeredAfterMouseMove,
                        layout: this.props.layout
                    });
                    this.displayDefaultTooltip();
                }
            },
            {
                key: "displayDefaultTooltip",
                value: function displayDefaultTooltip() {
                    var _this$props5 = this.props, children = _this$props5.children, data = _this$props5.data, height = _this$props5.height, layout = _this$props5.layout;
                    var tooltipElem = (0, $f06D9.findChildByType)(children, (0, $6SvzI.Tooltip));
                    // If the chart doesn't include a <Tooltip /> element, there's no tooltip to display
                    if (!tooltipElem) return;
                    var defaultIndex = tooltipElem.props.defaultIndex;
                    // Protect against runtime errors
                    if (typeof defaultIndex !== "number" || defaultIndex < 0 || defaultIndex > this.state.tooltipTicks.length - 1) return;
                    var activeLabel = this.state.tooltipTicks[defaultIndex] && this.state.tooltipTicks[defaultIndex].value;
                    var activePayload = $9a0b2e5a798197f9$var$getTooltipContent(this.state, data, defaultIndex, activeLabel);
                    var independentAxisCoord = this.state.tooltipTicks[defaultIndex].coordinate;
                    var dependentAxisCoord = (this.state.offset.top + height) / 2;
                    var isHorizontal = layout === "horizontal";
                    var activeCoordinate = isHorizontal ? {
                        x: independentAxisCoord,
                        y: dependentAxisCoord
                    } : {
                        y: independentAxisCoord,
                        x: dependentAxisCoord
                    };
                    // Unlike other chart types, scatter plot's tooltip positions rely on both X and Y coordinates. Only the scatter plot
                    // element knows its own Y coordinates.
                    // If there's a scatter plot, we'll want to grab that element for an interrogation.
                    var scatterPlotElement = this.state.formattedGraphicalItems.find(function(_ref12) {
                        var item = _ref12.item;
                        return item.type.name === "Scatter";
                    });
                    if (scatterPlotElement) {
                        activeCoordinate = $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, activeCoordinate), scatterPlotElement.props.points[defaultIndex].tooltipPosition);
                        activePayload = scatterPlotElement.props.points[defaultIndex].tooltipPayload;
                    }
                    var nextState = {
                        activeTooltipIndex: defaultIndex,
                        isTooltipActive: true,
                        activeLabel: activeLabel,
                        activePayload: activePayload,
                        activeCoordinate: activeCoordinate
                    };
                    this.setState(nextState);
                    this.renderCursor(tooltipElem);
                    // Make sure that anyone who keyboard-only users who tab to the chart will start their
                    // cursors at defaultIndex
                    this.accessibilityManager.setIndex(defaultIndex);
                }
            },
            {
                key: "getSnapshotBeforeUpdate",
                value: function getSnapshotBeforeUpdate(prevProps, prevState) {
                    if (!this.props.accessibilityLayer) return null;
                    if (this.state.tooltipTicks !== prevState.tooltipTicks) this.accessibilityManager.setDetails({
                        coordinateList: this.state.tooltipTicks
                    });
                    if (this.props.layout !== prevProps.layout) this.accessibilityManager.setDetails({
                        layout: this.props.layout
                    });
                    if (this.props.margin !== prevProps.margin) {
                        var _this$props$margin$le2, _this$props$margin$to2;
                        this.accessibilityManager.setDetails({
                            offset: {
                                left: (_this$props$margin$le2 = this.props.margin.left) !== null && _this$props$margin$le2 !== void 0 ? _this$props$margin$le2 : 0,
                                top: (_this$props$margin$to2 = this.props.margin.top) !== null && _this$props$margin$to2 !== void 0 ? _this$props$margin$to2 : 0
                            }
                        });
                    }
                    // Something has to be returned for getSnapshotBeforeUpdate
                    return null;
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    // Check to see if the Tooltip updated. If so, re-check default tooltip position
                    if (!(0, $f06D9.isChildrenEqual)([
                        (0, $f06D9.findChildByType)(prevProps.children, (0, $6SvzI.Tooltip))
                    ], [
                        (0, $f06D9.findChildByType)(this.props.children, (0, $6SvzI.Tooltip))
                    ])) this.displayDefaultTooltip();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.removeListener();
                    this.throttleTriggeredAfterMouseMove.cancel();
                }
            },
            {
                key: "getTooltipEventType",
                value: function getTooltipEventType() {
                    var tooltipItem = (0, $f06D9.findChildByType)(this.props.children, (0, $6SvzI.Tooltip));
                    if (tooltipItem && typeof tooltipItem.props.shared === "boolean") {
                        var eventType = tooltipItem.props.shared ? "axis" : "item";
                        return validateTooltipEventTypes.indexOf(eventType) >= 0 ? eventType : defaultTooltipEventType;
                    }
                    return defaultTooltipEventType;
                }
            },
            {
                key: "getMouseInfo",
                value: function getMouseInfo(event) {
                    if (!this.container) return null;
                    var element = this.container;
                    var boundingRect = element.getBoundingClientRect();
                    var containerOffset = (0, $kPfcu.getOffset)(boundingRect);
                    var e = {
                        chartX: Math.round(event.pageX - containerOffset.left),
                        chartY: Math.round(event.pageY - containerOffset.top)
                    };
                    var scale = boundingRect.width / element.offsetWidth || 1;
                    var rangeObj = this.inRange(e.chartX, e.chartY, scale);
                    if (!rangeObj) return null;
                    var _this$state9 = this.state, xAxisMap = _this$state9.xAxisMap, yAxisMap = _this$state9.yAxisMap;
                    var tooltipEventType = this.getTooltipEventType();
                    if (tooltipEventType !== "axis" && xAxisMap && yAxisMap) {
                        var xScale = (0, $1gmrG.getAnyElementOfObject)(xAxisMap).scale;
                        var yScale = (0, $1gmrG.getAnyElementOfObject)(yAxisMap).scale;
                        var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
                        var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;
                        return $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, e), {}, {
                            xValue: xValue,
                            yValue: yValue
                        });
                    }
                    var toolTipData = $9a0b2e5a798197f9$var$getTooltipData(this.state, this.props.data, this.props.layout, rangeObj);
                    if (toolTipData) return $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, e), toolTipData);
                    return null;
                }
            },
            {
                key: "inRange",
                value: function inRange(x, y) {
                    var scale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
                    var layout = this.props.layout;
                    var scaledX = x / scale, scaledY = y / scale;
                    if (layout === "horizontal" || layout === "vertical") {
                        var offset = this.state.offset;
                        var isInRange = scaledX >= offset.left && scaledX <= offset.left + offset.width && scaledY >= offset.top && scaledY <= offset.top + offset.height;
                        return isInRange ? {
                            x: scaledX,
                            y: scaledY
                        } : null;
                    }
                    var _this$state10 = this.state, angleAxisMap = _this$state10.angleAxisMap, radiusAxisMap = _this$state10.radiusAxisMap;
                    if (angleAxisMap && radiusAxisMap) {
                        var angleAxis = (0, $1gmrG.getAnyElementOfObject)(angleAxisMap);
                        return (0, $h7eoY.inRangeOfSector)({
                            x: scaledX,
                            y: scaledY
                        }, angleAxis);
                    }
                    return null;
                }
            },
            {
                key: "parseEventsOfWrapper",
                value: function parseEventsOfWrapper() {
                    var children = this.props.children;
                    var tooltipEventType = this.getTooltipEventType();
                    var tooltipItem = (0, $f06D9.findChildByType)(children, (0, $6SvzI.Tooltip));
                    var tooltipEvents = {};
                    if (tooltipItem && tooltipEventType === "axis") {
                        if (tooltipItem.props.trigger === "click") tooltipEvents = {
                            onClick: this.handleClick
                        };
                        else tooltipEvents = {
                            onMouseEnter: this.handleMouseEnter,
                            onDoubleClick: this.handleDoubleClick,
                            onMouseMove: this.handleMouseMove,
                            onMouseLeave: this.handleMouseLeave,
                            onTouchMove: this.handleTouchMove,
                            onTouchStart: this.handleTouchStart,
                            onTouchEnd: this.handleTouchEnd,
                            onContextMenu: this.handleContextMenu
                        };
                    }
                    // @ts-expect-error adaptEventHandlers expects DOM Event but generateCategoricalChart works with React UIEvents
                    var outerEvents = (0, $gBhCn.adaptEventHandlers)(this.props, this.handleOuterEvent);
                    return $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, outerEvents), tooltipEvents);
                }
            },
            {
                key: "addListener",
                value: function addListener() {
                    (0, $j2HEf.eventCenter).on((0, $j2HEf.SYNC_EVENT), this.handleReceiveSyncEvent);
                }
            },
            {
                key: "removeListener",
                value: function removeListener() {
                    (0, $j2HEf.eventCenter).removeListener((0, $j2HEf.SYNC_EVENT), this.handleReceiveSyncEvent);
                }
            },
            {
                key: "filterFormatItem",
                value: function filterFormatItem(item, displayName, childIndex) {
                    var formattedGraphicalItems = this.state.formattedGraphicalItems;
                    for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var entry = formattedGraphicalItems[i];
                        if (entry.item === item || entry.props.key === item.key || displayName === (0, $f06D9.getDisplayName)(entry.item.type) && childIndex === entry.childIndex) return entry;
                    }
                    return null;
                }
            },
            {
                key: "renderClipPath",
                value: function renderClipPath() {
                    var clipPathId = this.clipPathId;
                    var _this$state$offset = this.state.offset, left = _this$state$offset.left, top = _this$state$offset.top, height = _this$state$offset.height, width = _this$state$offset.width;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("clipPath", {
                        id: clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("rect", {
                        x: left,
                        y: top,
                        height: height,
                        width: width
                    })));
                }
            },
            {
                key: "getXScales",
                value: function getXScales() {
                    var xAxisMap = this.state.xAxisMap;
                    return xAxisMap ? Object.entries(xAxisMap).reduce(function(res, _ref13) {
                        var _ref14 = $9a0b2e5a798197f9$var$_slicedToArray(_ref13, 2), axisId = _ref14[0], axisProps = _ref14[1];
                        return $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, res), {}, $9a0b2e5a798197f9$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getYScales",
                value: function getYScales() {
                    var yAxisMap = this.state.yAxisMap;
                    return yAxisMap ? Object.entries(yAxisMap).reduce(function(res, _ref15) {
                        var _ref16 = $9a0b2e5a798197f9$var$_slicedToArray(_ref15, 2), axisId = _ref16[0], axisProps = _ref16[1];
                        return $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, res), {}, $9a0b2e5a798197f9$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getXScaleByAxisId",
                value: function getXScaleByAxisId(axisId) {
                    var _this$state$xAxisMap;
                    return (_this$state$xAxisMap = this.state.xAxisMap) === null || _this$state$xAxisMap === void 0 || (_this$state$xAxisMap = _this$state$xAxisMap[axisId]) === null || _this$state$xAxisMap === void 0 ? void 0 : _this$state$xAxisMap.scale;
                }
            },
            {
                key: "getYScaleByAxisId",
                value: function getYScaleByAxisId(axisId) {
                    var _this$state$yAxisMap;
                    return (_this$state$yAxisMap = this.state.yAxisMap) === null || _this$state$yAxisMap === void 0 || (_this$state$yAxisMap = _this$state$yAxisMap[axisId]) === null || _this$state$yAxisMap === void 0 ? void 0 : _this$state$yAxisMap.scale;
                }
            },
            {
                key: "getItemByXY",
                value: function getItemByXY(chartXY) {
                    var _this$state11 = this.state, formattedGraphicalItems = _this$state11.formattedGraphicalItems, activeItem = _this$state11.activeItem;
                    if (formattedGraphicalItems && formattedGraphicalItems.length) for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var graphicalItem = formattedGraphicalItems[i];
                        // graphicalItem is not a React Element so we don't need to resolve defaultProps
                        var props = graphicalItem.props, item = graphicalItem.item;
                        var itemProps = item.type.defaultProps !== undefined ? $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
                        var itemDisplayName = (0, $f06D9.getDisplayName)(item.type);
                        if (itemDisplayName === "Bar") {
                            var activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $DN6Qj.isInRectangle)(chartXY, entry);
                            });
                            if (activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: activeBarItem
                            };
                        } else if (itemDisplayName === "RadialBar") {
                            var _activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $h7eoY.inRangeOfSector)(chartXY, entry);
                            });
                            if (_activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: _activeBarItem
                            };
                        } else if ((0, $cFsdf.isFunnel)(graphicalItem, activeItem) || (0, $cFsdf.isPie)(graphicalItem, activeItem) || (0, $cFsdf.isScatter)(graphicalItem, activeItem)) {
                            var activeIndex = (0, $cFsdf.getActiveShapeIndexForTooltip)({
                                graphicalItem: graphicalItem,
                                activeTooltipItem: activeItem,
                                itemData: itemProps.data
                            });
                            var childIndex = itemProps.activeIndex === undefined ? activeIndex : itemProps.activeIndex;
                            return {
                                graphicalItem: $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, graphicalItem), {}, {
                                    childIndex: childIndex
                                }),
                                payload: (0, $cFsdf.isScatter)(graphicalItem, activeItem) ? itemProps.data[activeIndex] : graphicalItem.props.data[activeIndex]
                            };
                        }
                    }
                    return null;
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this3 = this;
                    if (!(0, $f06D9.validateWidthHeight)(this)) return null;
                    var _this$props6 = this.props, children = _this$props6.children, className = _this$props6.className, width = _this$props6.width, height = _this$props6.height, style = _this$props6.style, compact = _this$props6.compact, title = _this$props6.title, desc = _this$props6.desc, others = $9a0b2e5a798197f9$var$_objectWithoutProperties(_this$props6, $9a0b2e5a798197f9$var$_excluded2);
                    var attrs = (0, $f06D9.filterProps)(others, false);
                    // The "compact" mode is mainly used as the panorama within Brush
                    if (compact) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $jgA03.ChartLayoutContextProvider), {
                        state: this.state,
                        width: this.props.width,
                        height: this.props.height,
                        clipPathId: this.clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $3h6cG.Surface), $9a0b2e5a798197f9$var$_extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc
                    }), this.renderClipPath(), (0, $f06D9.renderByOrder)(children, this.renderMap)));
                    if (this.props.accessibilityLayer) {
                        var _this$props$tabIndex, _this$props$role;
                        // Set tabIndex to 0 by default (can be overwritten)
                        attrs.tabIndex = (_this$props$tabIndex = this.props.tabIndex) !== null && _this$props$tabIndex !== void 0 ? _this$props$tabIndex : 0;
                        // Set role to img by default (can be overwritten)
                        attrs.role = (_this$props$role = this.props.role) !== null && _this$props$role !== void 0 ? _this$props$role : "application";
                        attrs.onKeyDown = function(e) {
                            _this3.accessibilityManager.keyboardEvent(e);
                        // 'onKeyDown' is not currently a supported prop that can be passed through
                        // if it's added, this should be added: this.props.onKeyDown(e);
                        };
                        attrs.onFocus = function() {
                            _this3.accessibilityManager.focus();
                        // 'onFocus' is not currently a supported prop that can be passed through
                        // if it's added, the focus event should be forwarded to the prop
                        };
                    }
                    var events = this.parseEventsOfWrapper();
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $jgA03.ChartLayoutContextProvider), {
                        state: this.state,
                        width: this.props.width,
                        height: this.props.height,
                        clipPathId: this.clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("div", $9a0b2e5a798197f9$var$_extends({
                        className: (0, $dWgPS.default)("recharts-wrapper", className),
                        style: $9a0b2e5a798197f9$var$_objectSpread({
                            position: "relative",
                            cursor: "default",
                            width: width,
                            height: height
                        }, style)
                    }, events, {
                        ref: function ref(node) {
                            _this3.container = node;
                        }
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $3h6cG.Surface), $9a0b2e5a798197f9$var$_extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc,
                        style: $9a0b2e5a798197f9$var$FULL_WIDTH_AND_HEIGHT
                    }), this.renderClipPath(), (0, $f06D9.renderByOrder)(children, this.renderMap)), this.renderLegend(), this.renderTooltip()));
                }
            }
        ]);
    }((0, $jbmdS.Component));
    $9a0b2e5a798197f9$var$_defineProperty(CategoricalChartWrapper, "displayName", chartName);
    // todo join specific chart propTypes
    $9a0b2e5a798197f9$var$_defineProperty(CategoricalChartWrapper, "defaultProps", $9a0b2e5a798197f9$var$_objectSpread({
        layout: "horizontal",
        stackOffset: "none",
        barCategoryGap: "10%",
        barGap: 4,
        margin: {
            top: 5,
            right: 5,
            bottom: 5,
            left: 5
        },
        reverseStackOrder: false,
        syncMethod: "index"
    }, defaultProps));
    $9a0b2e5a798197f9$var$_defineProperty(CategoricalChartWrapper, "getDerivedStateFromProps", function(nextProps, prevState) {
        var dataKey = nextProps.dataKey, data = nextProps.data, children = nextProps.children, width = nextProps.width, height = nextProps.height, layout = nextProps.layout, stackOffset = nextProps.stackOffset, margin = nextProps.margin;
        var dataStartIndex = prevState.dataStartIndex, dataEndIndex = prevState.dataEndIndex;
        if (prevState.updateId === undefined) {
            var defaultState = $9a0b2e5a798197f9$export$e5182fb58612e577(nextProps);
            return $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, defaultState), {}, {
                updateId: 0
            }, updateStateOfAxisMapsOffsetAndStackGroups($9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({
                props: nextProps
            }, defaultState), {}, {
                updateId: 0
            }), prevState)), {}, {
                prevDataKey: dataKey,
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (dataKey !== prevState.prevDataKey || data !== prevState.prevData || width !== prevState.prevWidth || height !== prevState.prevHeight || layout !== prevState.prevLayout || stackOffset !== prevState.prevStackOffset || !(0, $cxCWI.shallowEqual)(margin, prevState.prevMargin)) {
            var _defaultState = $9a0b2e5a798197f9$export$e5182fb58612e577(nextProps);
            // Fixes https://github.com/recharts/recharts/issues/2143
            var keepFromPrevState = {
                // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
                // any flickering
                chartX: prevState.chartX,
                chartY: prevState.chartY,
                // The tooltip should stay active when it was active in the previous render. If this is not
                // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
                isTooltipActive: prevState.isTooltipActive
            };
            var updatesToState = $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, $9a0b2e5a798197f9$var$getTooltipData(prevState, data, layout)), {}, {
                updateId: prevState.updateId + 1
            });
            var newState = $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, _defaultState), keepFromPrevState), updatesToState);
            return $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({}, newState), updateStateOfAxisMapsOffsetAndStackGroups($9a0b2e5a798197f9$var$_objectSpread({
                props: nextProps
            }, newState), prevState)), {}, {
                prevDataKey: dataKey,
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (!(0, $f06D9.isChildrenEqual)(children, prevState.prevChildren)) {
            var _brush$props$startInd, _brush$props, _brush$props$endIndex, _brush$props2;
            // specifically check for Brush - if it exists and the start and end indexes are different, re-render with the new ones
            var brush = (0, $f06D9.findChildByType)(children, (0, $9DdPg.Brush));
            var startIndex = brush ? (_brush$props$startInd = (_brush$props = brush.props) === null || _brush$props === void 0 ? void 0 : _brush$props.startIndex) !== null && _brush$props$startInd !== void 0 ? _brush$props$startInd : dataStartIndex : dataStartIndex;
            var endIndex = brush ? (_brush$props$endIndex = (_brush$props2 = brush.props) === null || _brush$props2 === void 0 ? void 0 : _brush$props2.endIndex) !== null && _brush$props$endIndex !== void 0 ? _brush$props$endIndex : dataEndIndex : dataEndIndex;
            var hasDifferentStartOrEndIndex = startIndex !== dataStartIndex || endIndex !== dataEndIndex;
            // update configuration in children
            var hasGlobalData = !(0, (/*@__PURE__*/$parcel$interopDefault($aVX0M)))(data);
            var newUpdateId = hasGlobalData && !hasDifferentStartOrEndIndex ? prevState.updateId : prevState.updateId + 1;
            return $9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({
                updateId: newUpdateId
            }, updateStateOfAxisMapsOffsetAndStackGroups($9a0b2e5a798197f9$var$_objectSpread($9a0b2e5a798197f9$var$_objectSpread({
                props: nextProps
            }, prevState), {}, {
                updateId: newUpdateId,
                dataStartIndex: startIndex,
                dataEndIndex: endIndex
            }), prevState)), {}, {
                prevChildren: children,
                dataStartIndex: startIndex,
                dataEndIndex: endIndex
            });
        }
        return null;
    });
    $9a0b2e5a798197f9$var$_defineProperty(CategoricalChartWrapper, "renderActiveDot", function(option, props, key) {
        var dot;
        if (/*#__PURE__*/ (0, $jbmdS.isValidElement)(option)) dot = /*#__PURE__*/ (0, $jbmdS.cloneElement)(option, props);
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(option)) dot = option(props);
        else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $6eKmI.Dot), props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $bIYfh.Layer), {
            className: "recharts-active-dot",
            key: key
        }, dot);
    });
    var CategoricalChart = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function CategoricalChart(props, ref) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement(CategoricalChartWrapper, $9a0b2e5a798197f9$var$_extends({}, props, {
            ref: ref
        }));
    });
    CategoricalChart.displayName = CategoricalChartWrapper.displayName;
    return CategoricalChart;
};

});
parcelRegister("hb7df", function(module, exports) {

var $403Ax = parcelRequire("403Ax");
/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $c8190f08c351176b$var$range = $403Ax();
module.exports = $c8190f08c351176b$var$range;

});
parcelRegister("403Ax", function(module, exports) {

var $hyJ5A = parcelRequire("hyJ5A");

var $6PImS = parcelRequire("6PImS");

var $4NqFj = parcelRequire("4NqFj");
/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $2e99f21253a6c698$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != "number" && $6PImS(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $4NqFj(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $4NqFj(end);
        step = step === undefined ? start < end ? 1 : -1 : $4NqFj(step);
        return $hyJ5A(start, end, step, fromRight);
    };
}
module.exports = $2e99f21253a6c698$var$createRange;

});
parcelRegister("hyJ5A", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $cc88966d2ec23575$var$nativeCeil = Math.ceil, $cc88966d2ec23575$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $cc88966d2ec23575$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $cc88966d2ec23575$var$nativeMax($cc88966d2ec23575$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
module.exports = $cc88966d2ec23575$var$baseRange;

});

parcelRegister("4NqFj", function(module, exports) {

var $799qX = parcelRequire("799qX");
/** Used as references for various `Number` constants. */ var $37e06c33b601cbfc$var$INFINITY = 1 / 0, $37e06c33b601cbfc$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $37e06c33b601cbfc$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $799qX(value);
    if (value === $37e06c33b601cbfc$var$INFINITY || value === -$37e06c33b601cbfc$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $37e06c33b601cbfc$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
module.exports = $37e06c33b601cbfc$var$toFinite;

});



parcelRegister("8blM9", function(module, exports) {

var $ixbie = parcelRequire("ixbie");

var $hBKZ2 = parcelRequire("hBKZ2");
/** Error message constants. */ var $5f503df9db1e1316$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $5f503df9db1e1316$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($5f503df9db1e1316$var$FUNC_ERROR_TEXT);
    if ($hBKZ2(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $ixbie(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
module.exports = $5f503df9db1e1316$var$throttle;

});

parcelRegister("6SvzI", function(module, exports) {

$parcel$export(module.exports, "Tooltip", function () { return $5020475a02d6fb2f$export$28c660c63b792dea; });

var $jbmdS = parcelRequire("jbmdS");

var $apHIM = parcelRequire("apHIM");

var $bPbee = parcelRequire("bPbee");

var $9wZNv = parcelRequire("9wZNv");

var $lNaU3 = parcelRequire("lNaU3");
function $5020475a02d6fb2f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5020475a02d6fb2f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5020475a02d6fb2f$var$_typeof(o);
}
function $5020475a02d6fb2f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5020475a02d6fb2f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5020475a02d6fb2f$var$ownKeys(Object(t), !0).forEach(function(r) {
            $5020475a02d6fb2f$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5020475a02d6fb2f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5020475a02d6fb2f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5020475a02d6fb2f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $5020475a02d6fb2f$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $5020475a02d6fb2f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5020475a02d6fb2f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5020475a02d6fb2f$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $5020475a02d6fb2f$var$_callSuper(t, o, e) {
    return o = $5020475a02d6fb2f$var$_getPrototypeOf(o), $5020475a02d6fb2f$var$_possibleConstructorReturn(t, $5020475a02d6fb2f$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $5020475a02d6fb2f$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $5020475a02d6fb2f$var$_possibleConstructorReturn(self, call) {
    if (call && ($5020475a02d6fb2f$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $5020475a02d6fb2f$var$_assertThisInitialized(self);
}
function $5020475a02d6fb2f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $5020475a02d6fb2f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5020475a02d6fb2f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $5020475a02d6fb2f$var$_getPrototypeOf(o) {
    $5020475a02d6fb2f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $5020475a02d6fb2f$var$_getPrototypeOf(o);
}
function $5020475a02d6fb2f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $5020475a02d6fb2f$var$_setPrototypeOf(subClass, superClass);
}
function $5020475a02d6fb2f$var$_setPrototypeOf(o, p) {
    $5020475a02d6fb2f$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $5020475a02d6fb2f$var$_setPrototypeOf(o, p);
}
function $5020475a02d6fb2f$var$_defineProperty(obj, key, value) {
    key = $5020475a02d6fb2f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5020475a02d6fb2f$var$_toPropertyKey(t) {
    var i = $5020475a02d6fb2f$var$_toPrimitive(t, "string");
    return "symbol" == $5020475a02d6fb2f$var$_typeof(i) ? i : i + "";
}
function $5020475a02d6fb2f$var$_toPrimitive(t, r) {
    if ("object" != $5020475a02d6fb2f$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $5020475a02d6fb2f$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $5020475a02d6fb2f$var$defaultUniqBy(entry) {
    return entry.dataKey;
}
function $5020475a02d6fb2f$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).cloneElement(content, props);
    if (typeof content === "function") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement(content, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $apHIM.DefaultTooltipContent), props);
}
var $5020475a02d6fb2f$export$28c660c63b792dea = /*#__PURE__*/ function(_PureComponent) {
    function Tooltip() {
        $5020475a02d6fb2f$var$_classCallCheck(this, Tooltip);
        return $5020475a02d6fb2f$var$_callSuper(this, Tooltip, arguments);
    }
    $5020475a02d6fb2f$var$_inherits(Tooltip, _PureComponent);
    return $5020475a02d6fb2f$var$_createClass(Tooltip, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, content = _this$props.content, coordinate = _this$props.coordinate, filterNull = _this$props.filterNull, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, payload = _this$props.payload, payloadUniqBy = _this$props.payloadUniqBy, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
                var finalPayload = payload !== null && payload !== void 0 ? payload : [];
                if (filterNull && finalPayload.length) finalPayload = (0, $lNaU3.getUniqPayload)(payload.filter(function(entry) {
                    return entry.value != null && (entry.hide !== true || _this.props.includeHidden);
                }), payloadUniqBy, $5020475a02d6fb2f$var$defaultUniqBy);
                var hasPayload = finalPayload.length > 0;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $bPbee.TooltipBoundingBox), {
                    allowEscapeViewBox: allowEscapeViewBox,
                    animationDuration: animationDuration,
                    animationEasing: animationEasing,
                    isAnimationActive: isAnimationActive,
                    active: active,
                    coordinate: coordinate,
                    hasPayload: hasPayload,
                    offset: offset,
                    position: position,
                    reverseDirection: reverseDirection,
                    useTranslate3d: useTranslate3d,
                    viewBox: viewBox,
                    wrapperStyle: wrapperStyle
                }, $5020475a02d6fb2f$var$renderContent(content, $5020475a02d6fb2f$var$_objectSpread($5020475a02d6fb2f$var$_objectSpread({}, this.props), {}, {
                    payload: finalPayload
                })));
            }
        }
    ]);
}((0, $jbmdS.PureComponent));
$5020475a02d6fb2f$var$_defineProperty($5020475a02d6fb2f$export$28c660c63b792dea, "displayName", "Tooltip");
$5020475a02d6fb2f$var$_defineProperty($5020475a02d6fb2f$export$28c660c63b792dea, "defaultProps", {
    accessibilityLayer: false,
    allowEscapeViewBox: {
        x: false,
        y: false
    },
    animationDuration: 400,
    animationEasing: "ease",
    contentStyle: {},
    coordinate: {
        x: 0,
        y: 0
    },
    cursor: true,
    cursorStyle: {},
    filterNull: true,
    isAnimationActive: !(0, $9wZNv.Global).isSsr,
    itemStyle: {},
    labelStyle: {},
    offset: 10,
    reverseDirection: {
        x: false,
        y: false
    },
    separator: " : ",
    trigger: "hover",
    useTranslate3d: false,
    viewBox: {
        x: 0,
        y: 0,
        height: 0,
        width: 0
    },
    wrapperStyle: {}
});

});
parcelRegister("apHIM", function(module, exports) {

$parcel$export(module.exports, "DefaultTooltipContent", function () { return $794e274b0c56daad$export$6fe33945eebf9ac8; });

var $jbmdS = parcelRequire("jbmdS");

var $lfx6l = parcelRequire("lfx6l");

var $aVX0M = parcelRequire("aVX0M");

var $dWgPS = parcelRequire("dWgPS");

var $1gmrG = parcelRequire("1gmrG");
function $794e274b0c56daad$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $794e274b0c56daad$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $794e274b0c56daad$var$_typeof(o);
}
function $794e274b0c56daad$var$_extends() {
    $794e274b0c56daad$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $794e274b0c56daad$var$_extends.apply(this, arguments);
}
function $794e274b0c56daad$var$_slicedToArray(arr, i) {
    return $794e274b0c56daad$var$_arrayWithHoles(arr) || $794e274b0c56daad$var$_iterableToArrayLimit(arr, i) || $794e274b0c56daad$var$_unsupportedIterableToArray(arr, i) || $794e274b0c56daad$var$_nonIterableRest();
}
function $794e274b0c56daad$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $794e274b0c56daad$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $794e274b0c56daad$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $794e274b0c56daad$var$_arrayLikeToArray(o, minLen);
}
function $794e274b0c56daad$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $794e274b0c56daad$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $794e274b0c56daad$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $794e274b0c56daad$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $794e274b0c56daad$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $794e274b0c56daad$var$ownKeys(Object(t), !0).forEach(function(r) {
            $794e274b0c56daad$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $794e274b0c56daad$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $794e274b0c56daad$var$_defineProperty(obj, key, value) {
    key = $794e274b0c56daad$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $794e274b0c56daad$var$_toPropertyKey(t) {
    var i = $794e274b0c56daad$var$_toPrimitive(t, "string");
    return "symbol" == $794e274b0c56daad$var$_typeof(i) ? i : i + "";
}
function $794e274b0c56daad$var$_toPrimitive(t, r) {
    if ("object" != $794e274b0c56daad$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $794e274b0c56daad$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $794e274b0c56daad$var$defaultFormatter(value) {
    return Array.isArray(value) && (0, $1gmrG.isNumOrStr)(value[0]) && (0, $1gmrG.isNumOrStr)(value[1]) ? value.join(" ~ ") : value;
}
var $794e274b0c56daad$export$6fe33945eebf9ac8 = function DefaultTooltipContent(props) {
    var _props$separator = props.separator, separator = _props$separator === void 0 ? " : " : _props$separator, _props$contentStyle = props.contentStyle, contentStyle = _props$contentStyle === void 0 ? {} : _props$contentStyle, _props$itemStyle = props.itemStyle, itemStyle = _props$itemStyle === void 0 ? {} : _props$itemStyle, _props$labelStyle = props.labelStyle, labelStyle = _props$labelStyle === void 0 ? {} : _props$labelStyle, payload = props.payload, formatter = props.formatter, itemSorter = props.itemSorter, wrapperClassName = props.wrapperClassName, labelClassName = props.labelClassName, label = props.label, labelFormatter = props.labelFormatter, _props$accessibilityL = props.accessibilityLayer, accessibilityLayer = _props$accessibilityL === void 0 ? false : _props$accessibilityL;
    var renderContent = function renderContent() {
        if (payload && payload.length) {
            var listStyle = {
                padding: 0,
                margin: 0
            };
            var items = (itemSorter ? (0, (/*@__PURE__*/$parcel$interopDefault($lfx6l)))(payload, itemSorter) : payload).map(function(entry, i) {
                if (entry.type === "none") return null;
                var finalItemStyle = $794e274b0c56daad$var$_objectSpread({
                    display: "block",
                    paddingTop: 4,
                    paddingBottom: 4,
                    color: entry.color || "#000"
                }, itemStyle);
                var finalFormatter = entry.formatter || formatter || $794e274b0c56daad$var$defaultFormatter;
                var value = entry.value, name = entry.name;
                var finalValue = value;
                var finalName = name;
                if (finalFormatter && finalValue != null && finalName != null) {
                    var formatted = finalFormatter(value, name, entry, i, payload);
                    if (Array.isArray(formatted)) {
                        var _formatted = $794e274b0c56daad$var$_slicedToArray(formatted, 2);
                        finalValue = _formatted[0];
                        finalName = _formatted[1];
                    } else finalValue = formatted;
                }
                return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
                (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("li", {
                    className: "recharts-tooltip-item",
                    key: "tooltip-item-".concat(i),
                    style: finalItemStyle
                }, (0, $1gmrG.isNumOrStr)(finalName) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("span", {
                    className: "recharts-tooltip-item-name"
                }, finalName) : null, (0, $1gmrG.isNumOrStr)(finalName) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("span", {
                    className: "recharts-tooltip-item-separator"
                }, separator) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("span", {
                    className: "recharts-tooltip-item-value"
                }, finalValue), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("span", {
                    className: "recharts-tooltip-item-unit"
                }, entry.unit || "")));
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("ul", {
                className: "recharts-tooltip-item-list",
                style: listStyle
            }, items);
        }
        return null;
    };
    var finalStyle = $794e274b0c56daad$var$_objectSpread({
        margin: 0,
        padding: 10,
        backgroundColor: "#fff",
        border: "1px solid #ccc",
        whiteSpace: "nowrap"
    }, contentStyle);
    var finalLabelStyle = $794e274b0c56daad$var$_objectSpread({
        margin: 0
    }, labelStyle);
    var hasLabel = !(0, (/*@__PURE__*/$parcel$interopDefault($aVX0M)))(label);
    var finalLabel = hasLabel ? label : "";
    var wrapperCN = (0, $dWgPS.default)("recharts-default-tooltip", wrapperClassName);
    var labelCN = (0, $dWgPS.default)("recharts-tooltip-label", labelClassName);
    if (hasLabel && labelFormatter && payload !== undefined && payload !== null) finalLabel = labelFormatter(label, payload);
    var accessibilityAttributes = accessibilityLayer ? {
        role: "status",
        "aria-live": "assertive"
    } : {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("div", $794e274b0c56daad$var$_extends({
        className: wrapperCN,
        style: finalStyle
    }, accessibilityAttributes), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("p", {
        className: labelCN,
        style: finalLabelStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).isValidElement(finalLabel) ? finalLabel : "".concat(finalLabel)), renderContent());
};

});

parcelRegister("bPbee", function(module, exports) {

$parcel$export(module.exports, "TooltipBoundingBox", function () { return $89bd2ae88f86bf80$export$9e6cee7b86551b9c; });

var $jbmdS = parcelRequire("jbmdS");

var $2zJVr = parcelRequire("2zJVr");
function $89bd2ae88f86bf80$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $89bd2ae88f86bf80$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $89bd2ae88f86bf80$var$_typeof(o);
}
function $89bd2ae88f86bf80$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $89bd2ae88f86bf80$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $89bd2ae88f86bf80$var$ownKeys(Object(t), !0).forEach(function(r) {
            $89bd2ae88f86bf80$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $89bd2ae88f86bf80$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $89bd2ae88f86bf80$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $89bd2ae88f86bf80$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $89bd2ae88f86bf80$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $89bd2ae88f86bf80$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $89bd2ae88f86bf80$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $89bd2ae88f86bf80$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $89bd2ae88f86bf80$var$_callSuper(t, o, e) {
    return o = $89bd2ae88f86bf80$var$_getPrototypeOf(o), $89bd2ae88f86bf80$var$_possibleConstructorReturn(t, $89bd2ae88f86bf80$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $89bd2ae88f86bf80$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $89bd2ae88f86bf80$var$_possibleConstructorReturn(self, call) {
    if (call && ($89bd2ae88f86bf80$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $89bd2ae88f86bf80$var$_assertThisInitialized(self);
}
function $89bd2ae88f86bf80$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $89bd2ae88f86bf80$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($89bd2ae88f86bf80$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $89bd2ae88f86bf80$var$_getPrototypeOf(o) {
    $89bd2ae88f86bf80$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $89bd2ae88f86bf80$var$_getPrototypeOf(o);
}
function $89bd2ae88f86bf80$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $89bd2ae88f86bf80$var$_setPrototypeOf(subClass, superClass);
}
function $89bd2ae88f86bf80$var$_setPrototypeOf(o, p) {
    $89bd2ae88f86bf80$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $89bd2ae88f86bf80$var$_setPrototypeOf(o, p);
}
function $89bd2ae88f86bf80$var$_defineProperty(obj, key, value) {
    key = $89bd2ae88f86bf80$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $89bd2ae88f86bf80$var$_toPropertyKey(t) {
    var i = $89bd2ae88f86bf80$var$_toPrimitive(t, "string");
    return "symbol" == $89bd2ae88f86bf80$var$_typeof(i) ? i : i + "";
}
function $89bd2ae88f86bf80$var$_toPrimitive(t, r) {
    if ("object" != $89bd2ae88f86bf80$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $89bd2ae88f86bf80$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $89bd2ae88f86bf80$var$EPSILON = 1;
var $89bd2ae88f86bf80$export$9e6cee7b86551b9c = /*#__PURE__*/ function(_PureComponent) {
    function TooltipBoundingBox() {
        var _this;
        $89bd2ae88f86bf80$var$_classCallCheck(this, TooltipBoundingBox);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $89bd2ae88f86bf80$var$_callSuper(this, TooltipBoundingBox, [].concat(args));
        $89bd2ae88f86bf80$var$_defineProperty(_this, "state", {
            dismissed: false,
            dismissedAtCoordinate: {
                x: 0,
                y: 0
            },
            lastBoundingBox: {
                width: -1,
                height: -1
            }
        });
        $89bd2ae88f86bf80$var$_defineProperty(_this, "handleKeyDown", function(event) {
            if (event.key === "Escape") {
                var _this$props$coordinat, _this$props$coordinat2, _this$props$coordinat3, _this$props$coordinat4;
                _this.setState({
                    dismissed: true,
                    dismissedAtCoordinate: {
                        x: (_this$props$coordinat = (_this$props$coordinat2 = _this.props.coordinate) === null || _this$props$coordinat2 === void 0 ? void 0 : _this$props$coordinat2.x) !== null && _this$props$coordinat !== void 0 ? _this$props$coordinat : 0,
                        y: (_this$props$coordinat3 = (_this$props$coordinat4 = _this.props.coordinate) === null || _this$props$coordinat4 === void 0 ? void 0 : _this$props$coordinat4.y) !== null && _this$props$coordinat3 !== void 0 ? _this$props$coordinat3 : 0
                    }
                });
            }
        });
        return _this;
    }
    $89bd2ae88f86bf80$var$_inherits(TooltipBoundingBox, _PureComponent);
    return $89bd2ae88f86bf80$var$_createClass(TooltipBoundingBox, [
        {
            key: "updateBBox",
            value: function updateBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var box = this.wrapperNode.getBoundingClientRect();
                    if (Math.abs(box.width - this.state.lastBoundingBox.width) > $89bd2ae88f86bf80$var$EPSILON || Math.abs(box.height - this.state.lastBoundingBox.height) > $89bd2ae88f86bf80$var$EPSILON) this.setState({
                        lastBoundingBox: {
                            width: box.width,
                            height: box.height
                        }
                    });
                } else if (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) this.setState({
                    lastBoundingBox: {
                        width: -1,
                        height: -1
                    }
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                document.addEventListener("keydown", this.handleKeyDown);
                this.updateBBox();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.removeEventListener("keydown", this.handleKeyDown);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var _this$props$coordinat5, _this$props$coordinat6;
                if (this.props.active) this.updateBBox();
                if (!this.state.dismissed) return;
                if (((_this$props$coordinat5 = this.props.coordinate) === null || _this$props$coordinat5 === void 0 ? void 0 : _this$props$coordinat5.x) !== this.state.dismissedAtCoordinate.x || ((_this$props$coordinat6 = this.props.coordinate) === null || _this$props$coordinat6 === void 0 ? void 0 : _this$props$coordinat6.y) !== this.state.dismissedAtCoordinate.y) this.state.dismissed = false;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, children = _this$props.children, coordinate = _this$props.coordinate, hasPayload = _this$props.hasPayload, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
                var _getTooltipTranslate = (0, $2zJVr.getTooltipTranslate)({
                    allowEscapeViewBox: allowEscapeViewBox,
                    coordinate: coordinate,
                    offsetTopLeft: offset,
                    position: position,
                    reverseDirection: reverseDirection,
                    tooltipBox: this.state.lastBoundingBox,
                    useTranslate3d: useTranslate3d,
                    viewBox: viewBox
                }), cssClasses = _getTooltipTranslate.cssClasses, cssProperties = _getTooltipTranslate.cssProperties;
                var outerStyle = $89bd2ae88f86bf80$var$_objectSpread($89bd2ae88f86bf80$var$_objectSpread({
                    transition: isAnimationActive && active ? "transform ".concat(animationDuration, "ms ").concat(animationEasing) : undefined
                }, cssProperties), {}, {
                    pointerEvents: "none",
                    visibility: !this.state.dismissed && active && hasPayload ? "visible" : "hidden",
                    position: "absolute",
                    top: 0,
                    left: 0
                }, wrapperStyle);
                return(/*#__PURE__*/ // This element allow listening to the `Escape` key.
                // See https://github.com/recharts/recharts/pull/2925
                (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("div", {
                    tabIndex: -1,
                    className: cssClasses,
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, children));
            }
        }
    ]);
}((0, $jbmdS.PureComponent));

});
parcelRegister("2zJVr", function(module, exports) {

$parcel$export(module.exports, "getTooltipTranslate", function () { return $1e02797c2ca624f8$export$25e3b0ae21503056; });

var $dWgPS = parcelRequire("dWgPS");

var $1gmrG = parcelRequire("1gmrG");
function $1e02797c2ca624f8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1e02797c2ca624f8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1e02797c2ca624f8$var$_typeof(o);
}
function $1e02797c2ca624f8$var$_defineProperty(obj, key, value) {
    key = $1e02797c2ca624f8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1e02797c2ca624f8$var$_toPropertyKey(t) {
    var i = $1e02797c2ca624f8$var$_toPrimitive(t, "string");
    return "symbol" == $1e02797c2ca624f8$var$_typeof(i) ? i : i + "";
}
function $1e02797c2ca624f8$var$_toPrimitive(t, r) {
    if ("object" != $1e02797c2ca624f8$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $1e02797c2ca624f8$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $1e02797c2ca624f8$var$CSS_CLASS_PREFIX = "recharts-tooltip-wrapper";
var $1e02797c2ca624f8$var$TOOLTIP_HIDDEN = {
    visibility: "hidden"
};
function $1e02797c2ca624f8$export$46aee7ef09f78756(_ref) {
    var coordinate = _ref.coordinate, translateX = _ref.translateX, translateY = _ref.translateY;
    return (0, $dWgPS.default)($1e02797c2ca624f8$var$CSS_CLASS_PREFIX, $1e02797c2ca624f8$var$_defineProperty($1e02797c2ca624f8$var$_defineProperty($1e02797c2ca624f8$var$_defineProperty($1e02797c2ca624f8$var$_defineProperty({}, "".concat($1e02797c2ca624f8$var$CSS_CLASS_PREFIX, "-right"), (0, $1gmrG.isNumber)(translateX) && coordinate && (0, $1gmrG.isNumber)(coordinate.x) && translateX >= coordinate.x), "".concat($1e02797c2ca624f8$var$CSS_CLASS_PREFIX, "-left"), (0, $1gmrG.isNumber)(translateX) && coordinate && (0, $1gmrG.isNumber)(coordinate.x) && translateX < coordinate.x), "".concat($1e02797c2ca624f8$var$CSS_CLASS_PREFIX, "-bottom"), (0, $1gmrG.isNumber)(translateY) && coordinate && (0, $1gmrG.isNumber)(coordinate.y) && translateY >= coordinate.y), "".concat($1e02797c2ca624f8$var$CSS_CLASS_PREFIX, "-top"), (0, $1gmrG.isNumber)(translateY) && coordinate && (0, $1gmrG.isNumber)(coordinate.y) && translateY < coordinate.y));
}
function $1e02797c2ca624f8$export$4cccba03fe0eccc6(_ref2) {
    var allowEscapeViewBox = _ref2.allowEscapeViewBox, coordinate = _ref2.coordinate, key = _ref2.key, offsetTopLeft = _ref2.offsetTopLeft, position = _ref2.position, reverseDirection = _ref2.reverseDirection, tooltipDimension = _ref2.tooltipDimension, viewBox = _ref2.viewBox, viewBoxDimension = _ref2.viewBoxDimension;
    if (position && (0, $1gmrG.isNumber)(position[key])) return position[key];
    var negative = coordinate[key] - tooltipDimension - offsetTopLeft;
    var positive = coordinate[key] + offsetTopLeft;
    if (allowEscapeViewBox[key]) return reverseDirection[key] ? negative : positive;
    if (reverseDirection[key]) {
        var _tooltipBoundary = negative;
        var _viewBoxBoundary = viewBox[key];
        if (_tooltipBoundary < _viewBoxBoundary) return Math.max(positive, viewBox[key]);
        return Math.max(negative, viewBox[key]);
    }
    var tooltipBoundary = positive + tooltipDimension;
    var viewBoxBoundary = viewBox[key] + viewBoxDimension;
    if (tooltipBoundary > viewBoxBoundary) return Math.max(negative, viewBox[key]);
    return Math.max(positive, viewBox[key]);
}
function $1e02797c2ca624f8$export$4fe0982879780f9b(_ref3) {
    var translateX = _ref3.translateX, translateY = _ref3.translateY, useTranslate3d = _ref3.useTranslate3d;
    return {
        transform: useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
    };
}
function $1e02797c2ca624f8$export$25e3b0ae21503056(_ref4) {
    var allowEscapeViewBox = _ref4.allowEscapeViewBox, coordinate = _ref4.coordinate, offsetTopLeft = _ref4.offsetTopLeft, position = _ref4.position, reverseDirection = _ref4.reverseDirection, tooltipBox = _ref4.tooltipBox, useTranslate3d = _ref4.useTranslate3d, viewBox = _ref4.viewBox;
    var cssProperties, translateX, translateY;
    if (tooltipBox.height > 0 && tooltipBox.width > 0 && coordinate) {
        translateX = $1e02797c2ca624f8$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: "x",
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.width,
            viewBox: viewBox,
            viewBoxDimension: viewBox.width
        });
        translateY = $1e02797c2ca624f8$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: "y",
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.height,
            viewBox: viewBox,
            viewBoxDimension: viewBox.height
        });
        cssProperties = $1e02797c2ca624f8$export$4fe0982879780f9b({
            translateX: translateX,
            translateY: translateY,
            useTranslate3d: useTranslate3d
        });
    } else cssProperties = $1e02797c2ca624f8$var$TOOLTIP_HIDDEN;
    return {
        cssProperties: cssProperties,
        cssClasses: $1e02797c2ca624f8$export$46aee7ef09f78756({
            translateX: translateX,
            translateY: translateY,
            coordinate: coordinate
        })
    };
}

});



parcelRegister("DN6Qj", function(module, exports) {

$parcel$export(module.exports, "isInRectangle", function () { return $0779bcbb096672ea$export$f783d19325be51d5; });
$parcel$export(module.exports, "Rectangle", function () { return $0779bcbb096672ea$export$4617fb02663045ef; });

var $jbmdS = parcelRequire("jbmdS");

var $dWgPS = parcelRequire("dWgPS");

var $bBmgp = parcelRequire("bBmgp");

var $f06D9 = parcelRequire("f06D9");
function $0779bcbb096672ea$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0779bcbb096672ea$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0779bcbb096672ea$var$_typeof(o);
}
function $0779bcbb096672ea$var$_extends() {
    $0779bcbb096672ea$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0779bcbb096672ea$var$_extends.apply(this, arguments);
}
function $0779bcbb096672ea$var$_slicedToArray(arr, i) {
    return $0779bcbb096672ea$var$_arrayWithHoles(arr) || $0779bcbb096672ea$var$_iterableToArrayLimit(arr, i) || $0779bcbb096672ea$var$_unsupportedIterableToArray(arr, i) || $0779bcbb096672ea$var$_nonIterableRest();
}
function $0779bcbb096672ea$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0779bcbb096672ea$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0779bcbb096672ea$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0779bcbb096672ea$var$_arrayLikeToArray(o, minLen);
}
function $0779bcbb096672ea$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0779bcbb096672ea$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $0779bcbb096672ea$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $0779bcbb096672ea$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0779bcbb096672ea$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0779bcbb096672ea$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0779bcbb096672ea$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0779bcbb096672ea$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0779bcbb096672ea$var$_defineProperty(obj, key, value) {
    key = $0779bcbb096672ea$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0779bcbb096672ea$var$_toPropertyKey(t) {
    var i = $0779bcbb096672ea$var$_toPrimitive(t, "string");
    return "symbol" == $0779bcbb096672ea$var$_typeof(i) ? i : i + "";
}
function $0779bcbb096672ea$var$_toPrimitive(t, r) {
    if ("object" != $0779bcbb096672ea$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $0779bcbb096672ea$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $0779bcbb096672ea$var$getRectanglePath = function getRectanglePath(x, y, width, height, radius) {
    var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
    var ySign = height >= 0 ? 1 : -1;
    var xSign = width >= 0 ? 1 : -1;
    var clockWise = height >= 0 && width >= 0 || height < 0 && width < 0 ? 1 : 0;
    var path;
    if (maxRadius > 0 && radius instanceof Array) {
        var newRadius = [
            0,
            0,
            0,
            0
        ];
        for(var i = 0, len = 4; i < len; i++)newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
        path = "M".concat(x, ",").concat(y + ySign * newRadius[0]);
        if (newRadius[0] > 0) path += "A ".concat(newRadius[0], ",").concat(newRadius[0], ",0,0,").concat(clockWise, ",").concat(x + xSign * newRadius[0], ",").concat(y);
        path += "L ".concat(x + width - xSign * newRadius[1], ",").concat(y);
        if (newRadius[1] > 0) path += "A ".concat(newRadius[1], ",").concat(newRadius[1], ",0,0,").concat(clockWise, ",\n        ").concat(x + width, ",").concat(y + ySign * newRadius[1]);
        path += "L ".concat(x + width, ",").concat(y + height - ySign * newRadius[2]);
        if (newRadius[2] > 0) path += "A ".concat(newRadius[2], ",").concat(newRadius[2], ",0,0,").concat(clockWise, ",\n        ").concat(x + width - xSign * newRadius[2], ",").concat(y + height);
        path += "L ".concat(x + xSign * newRadius[3], ",").concat(y + height);
        if (newRadius[3] > 0) path += "A ".concat(newRadius[3], ",").concat(newRadius[3], ",0,0,").concat(clockWise, ",\n        ").concat(x, ",").concat(y + height - ySign * newRadius[3]);
        path += "Z";
    } else if (maxRadius > 0 && radius === +radius && radius > 0) {
        var _newRadius = Math.min(maxRadius, radius);
        path = "M ".concat(x, ",").concat(y + ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + xSign * _newRadius, ",").concat(y, "\n            L ").concat(x + width - xSign * _newRadius, ",").concat(y, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width, ",").concat(y + ySign * _newRadius, "\n            L ").concat(x + width, ",").concat(y + height - ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width - xSign * _newRadius, ",").concat(y + height, "\n            L ").concat(x + xSign * _newRadius, ",").concat(y + height, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x, ",").concat(y + height - ySign * _newRadius, " Z");
    } else path = "M ".concat(x, ",").concat(y, " h ").concat(width, " v ").concat(height, " h ").concat(-width, " Z");
    return path;
};
var $0779bcbb096672ea$export$f783d19325be51d5 = function isInRectangle(point, rect) {
    if (!point || !rect) return false;
    var px = point.x, py = point.y;
    var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
    if (Math.abs(width) > 0 && Math.abs(height) > 0) {
        var minX = Math.min(x, x + width);
        var maxX = Math.max(x, x + width);
        var minY = Math.min(y, y + height);
        var maxY = Math.max(y, y + height);
        return px >= minX && px <= maxX && py >= minY && py <= maxY;
    }
    return false;
};
var $0779bcbb096672ea$var$defaultProps = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    // The radius of border
    // The radius of four corners when radius is a number
    // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
    radius: 0,
    isAnimationActive: false,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: "ease"
};
var $0779bcbb096672ea$export$4617fb02663045ef = function Rectangle(rectangleProps) {
    var props = $0779bcbb096672ea$var$_objectSpread($0779bcbb096672ea$var$_objectSpread({}, $0779bcbb096672ea$var$defaultProps), rectangleProps);
    var pathRef = (0, $jbmdS.useRef)();
    var _useState = (0, $jbmdS.useState)(-1), _useState2 = $0779bcbb096672ea$var$_slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, $jbmdS.useEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = props.x, y = props.y, width = props.width, height = props.height, radius = props.radius, className = props.className;
    var animationEasing = props.animationEasing, animationDuration = props.animationDuration, animationBegin = props.animationBegin, isAnimationActive = props.isAnimationActive, isUpdateAnimationActive = props.isUpdateAnimationActive;
    if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) return null;
    var layerClass = (0, $dWgPS.default)("recharts-rectangle", className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("path", $0779bcbb096672ea$var$_extends({}, (0, $f06D9.filterProps)(props, true), {
        className: layerClass,
        d: $0779bcbb096672ea$var$getRectanglePath(x, y, width, height, radius)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $bBmgp.default), {
        canBegin: totalLength > 0,
        from: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        to: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currWidth = _ref.width, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $bBmgp.default), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            isActive: isAnimationActive,
            easing: animationEasing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("path", $0779bcbb096672ea$var$_extends({}, (0, $f06D9.filterProps)(props, true), {
            className: layerClass,
            d: $0779bcbb096672ea$var$getRectanglePath(currX, currY, currWidth, currHeight, radius),
            ref: pathRef
        })));
    });
};

});

parcelRegister("9DdPg", function(module, exports) {

$parcel$export(module.exports, "Brush", function () { return $70327b17d3f66229$export$59bc2e3533b384a0; });

var $jbmdS = parcelRequire("jbmdS");

var $dWgPS = parcelRequire("dWgPS");

var $b0sdz = parcelRequire("b0sdz");

var $i99FY = parcelRequire("i99FY");

var $hb7df = parcelRequire("hb7df");

var $bIYfh = parcelRequire("bIYfh");

var $hyGHv = parcelRequire("hyGHv");

var $fiDSf = parcelRequire("fiDSf");

var $1gmrG = parcelRequire("1gmrG");

var $CLihH = parcelRequire("CLihH");

var $f06D9 = parcelRequire("f06D9");
function $70327b17d3f66229$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $70327b17d3f66229$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $70327b17d3f66229$var$_typeof(o);
}
function $70327b17d3f66229$var$_extends() {
    $70327b17d3f66229$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $70327b17d3f66229$var$_extends.apply(this, arguments);
}
function $70327b17d3f66229$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $70327b17d3f66229$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $70327b17d3f66229$var$ownKeys(Object(t), !0).forEach(function(r) {
            $70327b17d3f66229$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $70327b17d3f66229$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $70327b17d3f66229$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $70327b17d3f66229$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $70327b17d3f66229$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $70327b17d3f66229$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $70327b17d3f66229$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $70327b17d3f66229$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $70327b17d3f66229$var$_callSuper(t, o, e) {
    return o = $70327b17d3f66229$var$_getPrototypeOf(o), $70327b17d3f66229$var$_possibleConstructorReturn(t, $70327b17d3f66229$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $70327b17d3f66229$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $70327b17d3f66229$var$_possibleConstructorReturn(self, call) {
    if (call && ($70327b17d3f66229$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $70327b17d3f66229$var$_assertThisInitialized(self);
}
function $70327b17d3f66229$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $70327b17d3f66229$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($70327b17d3f66229$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $70327b17d3f66229$var$_getPrototypeOf(o) {
    $70327b17d3f66229$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $70327b17d3f66229$var$_getPrototypeOf(o);
}
function $70327b17d3f66229$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $70327b17d3f66229$var$_setPrototypeOf(subClass, superClass);
}
function $70327b17d3f66229$var$_setPrototypeOf(o, p) {
    $70327b17d3f66229$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $70327b17d3f66229$var$_setPrototypeOf(o, p);
}
function $70327b17d3f66229$var$_defineProperty(obj, key, value) {
    key = $70327b17d3f66229$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $70327b17d3f66229$var$_toPropertyKey(t) {
    var i = $70327b17d3f66229$var$_toPrimitive(t, "string");
    return "symbol" == $70327b17d3f66229$var$_typeof(i) ? i : i + "";
}
function $70327b17d3f66229$var$_toPrimitive(t, r) {
    if ("object" != $70327b17d3f66229$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $70327b17d3f66229$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $70327b17d3f66229$var$createScale = function createScale(_ref) {
    var data = _ref.data, startIndex = _ref.startIndex, endIndex = _ref.endIndex, x = _ref.x, width = _ref.width, travellerWidth = _ref.travellerWidth;
    if (!data || !data.length) return {};
    var len = data.length;
    var scale = (0, $b0sdz.scalePoint)().domain((0, (/*@__PURE__*/$parcel$interopDefault($hb7df)))(0, len)).range([
        x,
        x + width - travellerWidth
    ]);
    var scaleValues = scale.domain().map(function(entry) {
        return scale(entry);
    });
    return {
        isTextActive: false,
        isSlideMoving: false,
        isTravellerMoving: false,
        isTravellerFocused: false,
        startX: scale(startIndex),
        endX: scale(endIndex),
        scale: scale,
        scaleValues: scaleValues
    };
};
var $70327b17d3f66229$var$isTouch = function isTouch(e) {
    return e.changedTouches && !!e.changedTouches.length;
};
var $70327b17d3f66229$export$59bc2e3533b384a0 = /*#__PURE__*/ function(_PureComponent) {
    function Brush(props) {
        var _this;
        $70327b17d3f66229$var$_classCallCheck(this, Brush);
        _this = $70327b17d3f66229$var$_callSuper(this, Brush, [
            props
        ]);
        $70327b17d3f66229$var$_defineProperty(_this, "handleDrag", function(e) {
            if (_this.leaveTimer) {
                clearTimeout(_this.leaveTimer);
                _this.leaveTimer = null;
            }
            if (_this.state.isTravellerMoving) _this.handleTravellerMove(e);
            else if (_this.state.isSlideMoving) _this.handleSlideDrag(e);
        });
        $70327b17d3f66229$var$_defineProperty(_this, "handleTouchMove", function(e) {
            if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleDrag(e.changedTouches[0]);
        });
        $70327b17d3f66229$var$_defineProperty(_this, "handleDragEnd", function() {
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: false
            }, function() {
                var _this$props = _this.props, endIndex = _this$props.endIndex, onDragEnd = _this$props.onDragEnd, startIndex = _this$props.startIndex;
                onDragEnd === null || onDragEnd === void 0 || onDragEnd({
                    endIndex: endIndex,
                    startIndex: startIndex
                });
            });
            _this.detachDragEndListener();
        });
        $70327b17d3f66229$var$_defineProperty(_this, "handleLeaveWrapper", function() {
            if (_this.state.isTravellerMoving || _this.state.isSlideMoving) _this.leaveTimer = window.setTimeout(_this.handleDragEnd, _this.props.leaveTimeOut);
        });
        $70327b17d3f66229$var$_defineProperty(_this, "handleEnterSlideOrTraveller", function() {
            _this.setState({
                isTextActive: true
            });
        });
        $70327b17d3f66229$var$_defineProperty(_this, "handleLeaveSlideOrTraveller", function() {
            _this.setState({
                isTextActive: false
            });
        });
        $70327b17d3f66229$var$_defineProperty(_this, "handleSlideDragStart", function(e) {
            var event = $70327b17d3f66229$var$isTouch(e) ? e.changedTouches[0] : e;
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: true,
                slideMoveStartX: event.pageX
            });
            _this.attachDragEndListener();
        });
        _this.travellerDragStartHandlers = {
            startX: _this.handleTravellerDragStart.bind(_this, "startX"),
            endX: _this.handleTravellerDragStart.bind(_this, "endX")
        };
        _this.state = {};
        return _this;
    }
    $70327b17d3f66229$var$_inherits(Brush, _PureComponent);
    return $70327b17d3f66229$var$_createClass(Brush, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.leaveTimer) {
                    clearTimeout(this.leaveTimer);
                    this.leaveTimer = null;
                }
                this.detachDragEndListener();
            }
        },
        {
            key: "getIndex",
            value: function getIndex(_ref2) {
                var startX = _ref2.startX, endX = _ref2.endX;
                var scaleValues = this.state.scaleValues;
                var _this$props2 = this.props, gap = _this$props2.gap, data = _this$props2.data;
                var lastIndex = data.length - 1;
                var min = Math.min(startX, endX);
                var max = Math.max(startX, endX);
                var minIndex = Brush.getIndexInRange(scaleValues, min);
                var maxIndex = Brush.getIndexInRange(scaleValues, max);
                return {
                    startIndex: minIndex - minIndex % gap,
                    endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - maxIndex % gap
                };
            }
        },
        {
            key: "getTextOfTick",
            value: function getTextOfTick(index) {
                var _this$props3 = this.props, data = _this$props3.data, tickFormatter = _this$props3.tickFormatter, dataKey = _this$props3.dataKey;
                var text = (0, $fiDSf.getValueByDataKey)(data[index], dataKey, index);
                return (0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(tickFormatter) ? tickFormatter(text, index) : text;
            }
        },
        {
            key: "attachDragEndListener",
            value: function attachDragEndListener() {
                window.addEventListener("mouseup", this.handleDragEnd, true);
                window.addEventListener("touchend", this.handleDragEnd, true);
                window.addEventListener("mousemove", this.handleDrag, true);
            }
        },
        {
            key: "detachDragEndListener",
            value: function detachDragEndListener() {
                window.removeEventListener("mouseup", this.handleDragEnd, true);
                window.removeEventListener("touchend", this.handleDragEnd, true);
                window.removeEventListener("mousemove", this.handleDrag, true);
            }
        },
        {
            key: "handleSlideDrag",
            value: function handleSlideDrag(e) {
                var _this$state = this.state, slideMoveStartX = _this$state.slideMoveStartX, startX = _this$state.startX, endX = _this$state.endX;
                var _this$props4 = this.props, x = _this$props4.x, width = _this$props4.width, travellerWidth = _this$props4.travellerWidth, startIndex = _this$props4.startIndex, endIndex = _this$props4.endIndex, onChange = _this$props4.onChange;
                var delta = e.pageX - slideMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
                else if (delta < 0) delta = Math.max(delta, x - startX, x - endX);
                var newIndex = this.getIndex({
                    startX: startX + delta,
                    endX: endX + delta
                });
                if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) onChange(newIndex);
                this.setState({
                    startX: startX + delta,
                    endX: endX + delta,
                    slideMoveStartX: e.pageX
                });
            }
        },
        {
            key: "handleTravellerDragStart",
            value: function handleTravellerDragStart(id, e) {
                var event = $70327b17d3f66229$var$isTouch(e) ? e.changedTouches[0] : e;
                this.setState({
                    isSlideMoving: false,
                    isTravellerMoving: true,
                    movingTravellerId: id,
                    brushMoveStartX: event.pageX
                });
                this.attachDragEndListener();
            }
        },
        {
            key: "handleTravellerMove",
            value: function handleTravellerMove(e) {
                var _this$state2 = this.state, brushMoveStartX = _this$state2.brushMoveStartX, movingTravellerId = _this$state2.movingTravellerId, endX = _this$state2.endX, startX = _this$state2.startX;
                var prevValue = this.state[movingTravellerId];
                var _this$props5 = this.props, x = _this$props5.x, width = _this$props5.width, travellerWidth = _this$props5.travellerWidth, onChange = _this$props5.onChange, gap = _this$props5.gap, data = _this$props5.data;
                var params = {
                    startX: this.state.startX,
                    endX: this.state.endX
                };
                var delta = e.pageX - brushMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - prevValue);
                else if (delta < 0) delta = Math.max(delta, x - prevValue);
                params[movingTravellerId] = prevValue + delta;
                var newIndex = this.getIndex(params);
                var startIndex = newIndex.startIndex, endIndex = newIndex.endIndex;
                var isFullGap = function isFullGap() {
                    var lastIndex = data.length - 1;
                    if (movingTravellerId === "startX" && (endX > startX ? startIndex % gap === 0 : endIndex % gap === 0) || endX < startX && endIndex === lastIndex || movingTravellerId === "endX" && (endX > startX ? endIndex % gap === 0 : startIndex % gap === 0) || endX > startX && endIndex === lastIndex) return true;
                    return false;
                };
                this.setState($70327b17d3f66229$var$_defineProperty($70327b17d3f66229$var$_defineProperty({}, movingTravellerId, prevValue + delta), "brushMoveStartX", e.pageX), function() {
                    if (onChange) {
                        if (isFullGap()) onChange(newIndex);
                    }
                });
            }
        },
        {
            key: "handleTravellerMoveKeyboard",
            value: function handleTravellerMoveKeyboard(direction, id) {
                var _this2 = this;
                // scaleValues are a list of coordinates. For example: [65, 250, 435, 620, 805, 990].
                var _this$state3 = this.state, scaleValues = _this$state3.scaleValues, startX = _this$state3.startX, endX = _this$state3.endX;
                // currentScaleValue refers to which coordinate the current traveller should be placed at.
                var currentScaleValue = this.state[id];
                var currentIndex = scaleValues.indexOf(currentScaleValue);
                if (currentIndex === -1) return;
                var newIndex = currentIndex + direction;
                if (newIndex === -1 || newIndex >= scaleValues.length) return;
                var newScaleValue = scaleValues[newIndex];
                // Prevent travellers from being on top of each other or overlapping
                if (id === "startX" && newScaleValue >= endX || id === "endX" && newScaleValue <= startX) return;
                this.setState($70327b17d3f66229$var$_defineProperty({}, id, newScaleValue), function() {
                    _this2.props.onChange(_this2.getIndex({
                        startX: _this2.state.startX,
                        endX: _this2.state.endX
                    }));
                });
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this$props6 = this.props, x = _this$props6.x, y = _this$props6.y, width = _this$props6.width, height = _this$props6.height, fill = _this$props6.fill, stroke = _this$props6.stroke;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("rect", {
                    stroke: stroke,
                    fill: fill,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderPanorama",
            value: function renderPanorama() {
                var _this$props7 = this.props, x = _this$props7.x, y = _this$props7.y, width = _this$props7.width, height = _this$props7.height, data = _this$props7.data, children = _this$props7.children, padding = _this$props7.padding;
                var chartElement = (0, $jbmdS.Children).only(children);
                if (!chartElement) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).cloneElement(chartElement, {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    margin: padding,
                    compact: true,
                    data: data
                });
            }
        },
        {
            key: "renderTravellerLayer",
            value: function renderTravellerLayer(travellerX, id) {
                var _data$startIndex, _data$endIndex, _this3 = this;
                var _this$props8 = this.props, y = _this$props8.y, travellerWidth = _this$props8.travellerWidth, height = _this$props8.height, traveller = _this$props8.traveller, ariaLabel = _this$props8.ariaLabel, data = _this$props8.data, startIndex = _this$props8.startIndex, endIndex = _this$props8.endIndex;
                var x = Math.max(travellerX, this.props.x);
                var travellerProps = $70327b17d3f66229$var$_objectSpread($70327b17d3f66229$var$_objectSpread({}, (0, $f06D9.filterProps)(this.props, false)), {}, {
                    x: x,
                    y: y,
                    width: travellerWidth,
                    height: height
                });
                var ariaLabelBrush = ariaLabel || "Min value: ".concat((_data$startIndex = data[startIndex]) === null || _data$startIndex === void 0 ? void 0 : _data$startIndex.name, ", Max value: ").concat((_data$endIndex = data[endIndex]) === null || _data$endIndex === void 0 ? void 0 : _data$endIndex.name);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $bIYfh.Layer), {
                    tabIndex: 0,
                    role: "slider",
                    "aria-label": ariaLabelBrush,
                    "aria-valuenow": travellerX,
                    className: "recharts-brush-traveller",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.travellerDragStartHandlers[id],
                    onTouchStart: this.travellerDragStartHandlers[id],
                    onKeyDown: function onKeyDown(e) {
                        if (![
                            "ArrowLeft",
                            "ArrowRight"
                        ].includes(e.key)) return;
                        e.preventDefault();
                        e.stopPropagation();
                        _this3.handleTravellerMoveKeyboard(e.key === "ArrowRight" ? 1 : -1, id);
                    },
                    onFocus: function onFocus() {
                        _this3.setState({
                            isTravellerFocused: true
                        });
                    },
                    onBlur: function onBlur() {
                        _this3.setState({
                            isTravellerFocused: false
                        });
                    },
                    style: {
                        cursor: "col-resize"
                    }
                }, Brush.renderTraveller(traveller, travellerProps));
            }
        },
        {
            key: "renderSlide",
            value: function renderSlide(startX, endX) {
                var _this$props9 = this.props, y = _this$props9.y, height = _this$props9.height, stroke = _this$props9.stroke, travellerWidth = _this$props9.travellerWidth;
                var x = Math.min(startX, endX) + travellerWidth;
                var width = Math.max(Math.abs(endX - startX) - travellerWidth, 0);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("rect", {
                    className: "recharts-brush-slide",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.handleSlideDragStart,
                    onTouchStart: this.handleSlideDragStart,
                    style: {
                        cursor: "move"
                    },
                    stroke: "none",
                    fill: stroke,
                    fillOpacity: 0.2,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderText",
            value: function renderText() {
                var _this$props10 = this.props, startIndex = _this$props10.startIndex, endIndex = _this$props10.endIndex, y = _this$props10.y, height = _this$props10.height, travellerWidth = _this$props10.travellerWidth, stroke = _this$props10.stroke;
                var _this$state4 = this.state, startX = _this$state4.startX, endX = _this$state4.endX;
                var offset = 5;
                var attrs = {
                    pointerEvents: "none",
                    fill: stroke
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $bIYfh.Layer), {
                    className: "recharts-brush-texts"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $hyGHv.Text), $70327b17d3f66229$var$_extends({
                    textAnchor: "end",
                    verticalAnchor: "middle",
                    x: Math.min(startX, endX) - offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(startIndex)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $hyGHv.Text), $70327b17d3f66229$var$_extends({
                    textAnchor: "start",
                    verticalAnchor: "middle",
                    x: Math.max(startX, endX) + travellerWidth + offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(endIndex)));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props11 = this.props, data = _this$props11.data, className = _this$props11.className, children = _this$props11.children, x = _this$props11.x, y = _this$props11.y, width = _this$props11.width, height = _this$props11.height, alwaysShowText = _this$props11.alwaysShowText;
                var _this$state5 = this.state, startX = _this$state5.startX, endX = _this$state5.endX, isTextActive = _this$state5.isTextActive, isSlideMoving = _this$state5.isSlideMoving, isTravellerMoving = _this$state5.isTravellerMoving, isTravellerFocused = _this$state5.isTravellerFocused;
                if (!data || !data.length || !(0, $1gmrG.isNumber)(x) || !(0, $1gmrG.isNumber)(y) || !(0, $1gmrG.isNumber)(width) || !(0, $1gmrG.isNumber)(height) || width <= 0 || height <= 0) return null;
                var layerClass = (0, $dWgPS.default)("recharts-brush", className);
                var isPanoramic = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).Children.count(children) === 1;
                var style = (0, $CLihH.generatePrefixStyle)("userSelect", "none");
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $bIYfh.Layer), {
                    className: layerClass,
                    onMouseLeave: this.handleLeaveWrapper,
                    onTouchMove: this.handleTouchMove,
                    style: style
                }, this.renderBackground(), isPanoramic && this.renderPanorama(), this.renderSlide(startX, endX), this.renderTravellerLayer(startX, "startX"), this.renderTravellerLayer(endX, "endX"), (isTextActive || isSlideMoving || isTravellerMoving || isTravellerFocused || alwaysShowText) && this.renderText());
            }
        }
    ], [
        {
            key: "renderDefaultTraveller",
            value: function renderDefaultTraveller(props) {
                var x = props.x, y = props.y, width = props.width, height = props.height, stroke = props.stroke;
                var lineY = Math.floor(y + height / 2) - 1;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("rect", {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    fill: stroke,
                    stroke: "none"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("line", {
                    x1: x + 1,
                    y1: lineY,
                    x2: x + width - 1,
                    y2: lineY,
                    fill: "none",
                    stroke: "#fff"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("line", {
                    x1: x + 1,
                    y1: lineY + 2,
                    x2: x + width - 1,
                    y2: lineY + 2,
                    fill: "none",
                    stroke: "#fff"
                }));
            }
        },
        {
            key: "renderTraveller",
            value: function renderTraveller(option, props) {
                var rectangle;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).isValidElement(option)) rectangle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(option)) rectangle = option(props);
                else rectangle = Brush.renderDefaultTraveller(props);
                return rectangle;
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var data = nextProps.data, width = nextProps.width, x = nextProps.x, travellerWidth = nextProps.travellerWidth, updateId = nextProps.updateId, startIndex = nextProps.startIndex, endIndex = nextProps.endIndex;
                if (data !== prevState.prevData || updateId !== prevState.prevUpdateId) return $70327b17d3f66229$var$_objectSpread({
                    prevData: data,
                    prevTravellerWidth: travellerWidth,
                    prevUpdateId: updateId,
                    prevX: x,
                    prevWidth: width
                }, data && data.length ? $70327b17d3f66229$var$createScale({
                    data: data,
                    width: width,
                    x: x,
                    travellerWidth: travellerWidth,
                    startIndex: startIndex,
                    endIndex: endIndex
                }) : {
                    scale: null,
                    scaleValues: null
                });
                if (prevState.scale && (width !== prevState.prevWidth || x !== prevState.prevX || travellerWidth !== prevState.prevTravellerWidth)) {
                    prevState.scale.range([
                        x,
                        x + width - travellerWidth
                    ]);
                    var scaleValues = prevState.scale.domain().map(function(entry) {
                        return prevState.scale(entry);
                    });
                    return {
                        prevData: data,
                        prevTravellerWidth: travellerWidth,
                        prevUpdateId: updateId,
                        prevX: x,
                        prevWidth: width,
                        startX: prevState.scale(nextProps.startIndex),
                        endX: prevState.scale(nextProps.endIndex),
                        scaleValues: scaleValues
                    };
                }
                return null;
            }
        },
        {
            key: "getIndexInRange",
            value: function getIndexInRange(valueRange, x) {
                var len = valueRange.length;
                var start = 0;
                var end = len - 1;
                while(end - start > 1){
                    var middle = Math.floor((start + end) / 2);
                    if (valueRange[middle] > x) end = middle;
                    else start = middle;
                }
                return x >= valueRange[end] ? end : start;
            }
        }
    ]);
}((0, $jbmdS.PureComponent));
$70327b17d3f66229$var$_defineProperty($70327b17d3f66229$export$59bc2e3533b384a0, "displayName", "Brush");
$70327b17d3f66229$var$_defineProperty($70327b17d3f66229$export$59bc2e3533b384a0, "defaultProps", {
    height: 40,
    travellerWidth: 5,
    gap: 1,
    fill: "#fff",
    stroke: "#666",
    padding: {
        top: 1,
        right: 1,
        bottom: 1,
        left: 1
    },
    leaveTimeOut: 1000,
    alwaysShowText: false
});

});
parcelRegister("CLihH", function(module, exports) {

$parcel$export(module.exports, "generatePrefixStyle", function () { return $07483c4f55915ac8$export$4a9169b65825efee; });
function $07483c4f55915ac8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $07483c4f55915ac8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $07483c4f55915ac8$var$_typeof(o);
}
function $07483c4f55915ac8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $07483c4f55915ac8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $07483c4f55915ac8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $07483c4f55915ac8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $07483c4f55915ac8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $07483c4f55915ac8$var$_defineProperty(obj, key, value) {
    key = $07483c4f55915ac8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $07483c4f55915ac8$var$_toPropertyKey(t) {
    var i = $07483c4f55915ac8$var$_toPrimitive(t, "string");
    return "symbol" == $07483c4f55915ac8$var$_typeof(i) ? i : i + "";
}
function $07483c4f55915ac8$var$_toPrimitive(t, r) {
    if ("object" != $07483c4f55915ac8$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $07483c4f55915ac8$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $07483c4f55915ac8$var$PREFIX_LIST = [
    "Webkit",
    "Moz",
    "O",
    "ms"
];
var $07483c4f55915ac8$export$4a9169b65825efee = function generatePrefixStyle(name, value) {
    if (!name) return null;
    var camelName = name.replace(/(\w)/, function(v) {
        return v.toUpperCase();
    });
    var result = $07483c4f55915ac8$var$PREFIX_LIST.reduce(function(res, entry) {
        return $07483c4f55915ac8$var$_objectSpread($07483c4f55915ac8$var$_objectSpread({}, res), {}, $07483c4f55915ac8$var$_defineProperty({}, entry + camelName, value));
    }, {});
    result[name] = value;
    return result;
};

});


parcelRegister("eMtk2", function(module, exports) {

$parcel$export(module.exports, "detectReferenceElementsDomain", function () { return $ac2c4b2cc3b8778b$export$62ecf5c04b491381; });

var $gWsUf = parcelRequire("gWsUf");

var $8tls9 = parcelRequire("8tls9");

var $eYU3i = parcelRequire("eYU3i");

var $a7iOf = parcelRequire("a7iOf");

var $f06D9 = parcelRequire("f06D9");

var $1gmrG = parcelRequire("1gmrG");
function $ac2c4b2cc3b8778b$var$_toConsumableArray(arr) {
    return $ac2c4b2cc3b8778b$var$_arrayWithoutHoles(arr) || $ac2c4b2cc3b8778b$var$_iterableToArray(arr) || $ac2c4b2cc3b8778b$var$_unsupportedIterableToArray(arr) || $ac2c4b2cc3b8778b$var$_nonIterableSpread();
}
function $ac2c4b2cc3b8778b$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ac2c4b2cc3b8778b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ac2c4b2cc3b8778b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ac2c4b2cc3b8778b$var$_arrayLikeToArray(o, minLen);
}
function $ac2c4b2cc3b8778b$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $ac2c4b2cc3b8778b$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $ac2c4b2cc3b8778b$var$_arrayLikeToArray(arr);
}
function $ac2c4b2cc3b8778b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $ac2c4b2cc3b8778b$export$62ecf5c04b491381 = function detectReferenceElementsDomain(children, domain, axisId, axisType, specifiedTicks) {
    var lines = (0, $f06D9.findAllByType)(children, (0, $8tls9.ReferenceLine));
    var dots = (0, $f06D9.findAllByType)(children, (0, $gWsUf.ReferenceDot));
    var elements = [].concat($ac2c4b2cc3b8778b$var$_toConsumableArray(lines), $ac2c4b2cc3b8778b$var$_toConsumableArray(dots));
    var areas = (0, $f06D9.findAllByType)(children, (0, $eYU3i.ReferenceArea));
    var idKey = "".concat(axisType, "Id");
    var valueKey = axisType[0];
    var finalDomain = domain;
    if (elements.length) finalDomain = elements.reduce(function(result, el) {
        if (el.props[idKey] === axisId && (0, $a7iOf.ifOverflowMatches)(el.props, "extendDomain") && (0, $1gmrG.isNumber)(el.props[valueKey])) {
            var value = el.props[valueKey];
            return [
                Math.min(result[0], value),
                Math.max(result[1], value)
            ];
        }
        return result;
    }, finalDomain);
    if (areas.length) {
        var key1 = "".concat(valueKey, "1");
        var key2 = "".concat(valueKey, "2");
        finalDomain = areas.reduce(function(result, el) {
            if (el.props[idKey] === axisId && (0, $a7iOf.ifOverflowMatches)(el.props, "extendDomain") && (0, $1gmrG.isNumber)(el.props[key1]) && (0, $1gmrG.isNumber)(el.props[key2])) {
                var value1 = el.props[key1];
                var value2 = el.props[key2];
                return [
                    Math.min(result[0], value1, value2),
                    Math.max(result[1], value1, value2)
                ];
            }
            return result;
        }, finalDomain);
    }
    if (specifiedTicks && specifiedTicks.length) finalDomain = specifiedTicks.reduce(function(result, tick) {
        if ((0, $1gmrG.isNumber)(tick)) return [
            Math.min(result[0], tick),
            Math.max(result[1], tick)
        ];
        return result;
    }, finalDomain);
    return finalDomain;
};

});
parcelRegister("gWsUf", function(module, exports) {

$parcel$export(module.exports, "ReferenceDot", function () { return $c5587c47d1a1dd8c$export$aa7f0b0106bff39; });

var $jbmdS = parcelRequire("jbmdS");

var $i99FY = parcelRequire("i99FY");

var $dWgPS = parcelRequire("dWgPS");

var $bIYfh = parcelRequire("bIYfh");

var $6eKmI = parcelRequire("6eKmI");

var $eGPJt = parcelRequire("eGPJt");

var $1gmrG = parcelRequire("1gmrG");

var $a7iOf = parcelRequire("a7iOf");

var $eZuTD = parcelRequire("eZuTD");

var $aOmiF = parcelRequire("aOmiF");

var $f06D9 = parcelRequire("f06D9");
function $c5587c47d1a1dd8c$var$_extends() {
    $c5587c47d1a1dd8c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c5587c47d1a1dd8c$var$_extends.apply(this, arguments);
}
function $c5587c47d1a1dd8c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c5587c47d1a1dd8c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c5587c47d1a1dd8c$var$_typeof(o);
}
function $c5587c47d1a1dd8c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c5587c47d1a1dd8c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c5587c47d1a1dd8c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c5587c47d1a1dd8c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c5587c47d1a1dd8c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c5587c47d1a1dd8c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c5587c47d1a1dd8c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c5587c47d1a1dd8c$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c5587c47d1a1dd8c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c5587c47d1a1dd8c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c5587c47d1a1dd8c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c5587c47d1a1dd8c$var$_callSuper(t, o, e) {
    return o = $c5587c47d1a1dd8c$var$_getPrototypeOf(o), $c5587c47d1a1dd8c$var$_possibleConstructorReturn(t, $c5587c47d1a1dd8c$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $c5587c47d1a1dd8c$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $c5587c47d1a1dd8c$var$_possibleConstructorReturn(self, call) {
    if (call && ($c5587c47d1a1dd8c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $c5587c47d1a1dd8c$var$_assertThisInitialized(self);
}
function $c5587c47d1a1dd8c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c5587c47d1a1dd8c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c5587c47d1a1dd8c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $c5587c47d1a1dd8c$var$_getPrototypeOf(o) {
    $c5587c47d1a1dd8c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c5587c47d1a1dd8c$var$_getPrototypeOf(o);
}
function $c5587c47d1a1dd8c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $c5587c47d1a1dd8c$var$_setPrototypeOf(subClass, superClass);
}
function $c5587c47d1a1dd8c$var$_setPrototypeOf(o, p) {
    $c5587c47d1a1dd8c$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c5587c47d1a1dd8c$var$_setPrototypeOf(o, p);
}
function $c5587c47d1a1dd8c$var$_defineProperty(obj, key, value) {
    key = $c5587c47d1a1dd8c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c5587c47d1a1dd8c$var$_toPropertyKey(t) {
    var i = $c5587c47d1a1dd8c$var$_toPrimitive(t, "string");
    return "symbol" == $c5587c47d1a1dd8c$var$_typeof(i) ? i : i + "";
}
function $c5587c47d1a1dd8c$var$_toPrimitive(t, r) {
    if ("object" != $c5587c47d1a1dd8c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $c5587c47d1a1dd8c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $c5587c47d1a1dd8c$var$getCoordinate = function getCoordinate(props) {
    var x = props.x, y = props.y, xAxis = props.xAxis, yAxis = props.yAxis;
    var scales = (0, $eZuTD.createLabeledScales)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var result = scales.apply({
        x: x,
        y: y
    }, {
        bandAware: true
    });
    if ((0, $a7iOf.ifOverflowMatches)(props, "discard") && !scales.isInRange(result)) return null;
    return result;
};
var $c5587c47d1a1dd8c$export$aa7f0b0106bff39 = /*#__PURE__*/ function(_React$Component) {
    function ReferenceDot() {
        $c5587c47d1a1dd8c$var$_classCallCheck(this, ReferenceDot);
        return $c5587c47d1a1dd8c$var$_callSuper(this, ReferenceDot, arguments);
    }
    $c5587c47d1a1dd8c$var$_inherits(ReferenceDot, _React$Component);
    return $c5587c47d1a1dd8c$var$_createClass(ReferenceDot, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, x = _this$props.x, y = _this$props.y, r = _this$props.r, alwaysShow = _this$props.alwaysShow, clipPathId = _this$props.clipPathId;
                var isX = (0, $1gmrG.isNumOrStr)(x);
                var isY = (0, $1gmrG.isNumOrStr)(y);
                (0, $aOmiF.warn)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
                if (!isX || !isY) return null;
                var coordinate = $c5587c47d1a1dd8c$var$getCoordinate(this.props);
                if (!coordinate) return null;
                var cx = coordinate.x, cy = coordinate.y;
                var _this$props2 = this.props, shape = _this$props2.shape, className = _this$props2.className;
                var clipPath = (0, $a7iOf.ifOverflowMatches)(this.props, "hidden") ? "url(#".concat(clipPathId, ")") : undefined;
                var dotProps = $c5587c47d1a1dd8c$var$_objectSpread($c5587c47d1a1dd8c$var$_objectSpread({
                    clipPath: clipPath
                }, (0, $f06D9.filterProps)(this.props, true)), {}, {
                    cx: cx,
                    cy: cy
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $bIYfh.Layer), {
                    className: (0, $dWgPS.default)("recharts-reference-dot", className)
                }, ReferenceDot.renderDot(shape, dotProps), (0, $eGPJt.Label).renderCallByParent(this.props, {
                    x: cx - r,
                    y: cy - r,
                    width: 2 * r,
                    height: 2 * r
                }));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).Component);
$c5587c47d1a1dd8c$var$_defineProperty($c5587c47d1a1dd8c$export$aa7f0b0106bff39, "displayName", "ReferenceDot");
$c5587c47d1a1dd8c$var$_defineProperty($c5587c47d1a1dd8c$export$aa7f0b0106bff39, "defaultProps", {
    isFront: false,
    ifOverflow: "discard",
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: "#fff",
    stroke: "#ccc",
    fillOpacity: 1,
    strokeWidth: 1
});
$c5587c47d1a1dd8c$var$_defineProperty($c5587c47d1a1dd8c$export$aa7f0b0106bff39, "renderDot", function(option, props) {
    var dot;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).isValidElement(option)) dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(option)) dot = option(props);
    else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $6eKmI.Dot), $c5587c47d1a1dd8c$var$_extends({}, props, {
        cx: props.cx,
        cy: props.cy,
        className: "recharts-reference-dot-dot"
    }));
    return dot;
});

});
parcelRegister("a7iOf", function(module, exports) {

$parcel$export(module.exports, "ifOverflowMatches", function () { return $75d925f808baab0a$export$3fb112445eb31879; });
var $75d925f808baab0a$export$3fb112445eb31879 = function ifOverflowMatches(props, value) {
    var alwaysShow = props.alwaysShow;
    var ifOverflow = props.ifOverflow;
    if (alwaysShow) ifOverflow = "extendDomain";
    return ifOverflow === value;
};

});

parcelRegister("eZuTD", function(module, exports) {

$parcel$export(module.exports, "formatAxisMap", function () { return $ae9eba8c62140ea0$export$ece7de1383db5ac; });
$parcel$export(module.exports, "rectWithPoints", function () { return $ae9eba8c62140ea0$export$c7964a5b9439ae62; });
$parcel$export(module.exports, "rectWithCoords", function () { return $ae9eba8c62140ea0$export$6df2062b9e15eec0; });
$parcel$export(module.exports, "createLabeledScales", function () { return $ae9eba8c62140ea0$export$db77ae668c18269f; });
$parcel$export(module.exports, "getAngledRectangleWidth", function () { return $ae9eba8c62140ea0$export$3ee78d51cffc2b68; });

var $guwjw = parcelRequire("guwjw");

var $6O6hA = parcelRequire("6O6hA");

var $fiDSf = parcelRequire("fiDSf");

var $f06D9 = parcelRequire("f06D9");

var $1gmrG = parcelRequire("1gmrG");

var $jq8pz = parcelRequire("jq8pz");
function $ae9eba8c62140ea0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ae9eba8c62140ea0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ae9eba8c62140ea0$var$_typeof(o);
}
function $ae9eba8c62140ea0$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ae9eba8c62140ea0$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $ae9eba8c62140ea0$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $ae9eba8c62140ea0$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ae9eba8c62140ea0$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ae9eba8c62140ea0$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $ae9eba8c62140ea0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ae9eba8c62140ea0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ae9eba8c62140ea0$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ae9eba8c62140ea0$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ae9eba8c62140ea0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ae9eba8c62140ea0$var$_defineProperty(obj, key, value) {
    key = $ae9eba8c62140ea0$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ae9eba8c62140ea0$var$_toPropertyKey(t) {
    var i = $ae9eba8c62140ea0$var$_toPrimitive(t, "string");
    return "symbol" == $ae9eba8c62140ea0$var$_typeof(i) ? i : i + "";
}
function $ae9eba8c62140ea0$var$_toPrimitive(t, r) {
    if ("object" != $ae9eba8c62140ea0$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ae9eba8c62140ea0$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $ae9eba8c62140ea0$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height, layout = props.layout, children = props.children;
    var ids = Object.keys(axisMap);
    var steps = {
        left: offset.left,
        leftMirror: offset.left,
        right: width - offset.right,
        rightMirror: width - offset.right,
        top: offset.top,
        topMirror: offset.top,
        bottom: height - offset.bottom,
        bottomMirror: height - offset.bottom
    };
    var hasBar = !!(0, $f06D9.findChildByType)(children, (0, $jq8pz.Bar));
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var orientation = axis.orientation, domain = axis.domain, _axis$padding = axis.padding, padding = _axis$padding === void 0 ? {} : _axis$padding, mirror = axis.mirror, reversed = axis.reversed;
        var offsetKey = "".concat(orientation).concat(mirror ? "Mirror" : "");
        var calculatedPadding, range, x, y, needSpace;
        if (axis.type === "number" && (axis.padding === "gap" || axis.padding === "no-gap")) {
            var diff = domain[1] - domain[0];
            var smallestDistanceBetweenValues = Infinity;
            var sortedValues = axis.categoricalDomain.sort();
            sortedValues.forEach(function(value, index) {
                if (index > 0) smallestDistanceBetweenValues = Math.min((value || 0) - (sortedValues[index - 1] || 0), smallestDistanceBetweenValues);
            });
            if (Number.isFinite(smallestDistanceBetweenValues)) {
                var smallestDistanceInPercent = smallestDistanceBetweenValues / diff;
                var rangeWidth = axis.layout === "vertical" ? offset.height : offset.width;
                if (axis.padding === "gap") calculatedPadding = smallestDistanceInPercent * rangeWidth / 2;
                if (axis.padding === "no-gap") {
                    var gap = (0, $1gmrG.getPercentValue)(props.barCategoryGap, smallestDistanceInPercent * rangeWidth);
                    var halfBand = smallestDistanceInPercent * rangeWidth / 2;
                    calculatedPadding = halfBand - gap - (halfBand - gap) / rangeWidth * gap;
                }
            }
        }
        if (axisType === "xAxis") range = [
            offset.left + (padding.left || 0) + (calculatedPadding || 0),
            offset.left + offset.width - (padding.right || 0) - (calculatedPadding || 0)
        ];
        else if (axisType === "yAxis") range = layout === "horizontal" ? [
            offset.top + offset.height - (padding.bottom || 0),
            offset.top + (padding.top || 0)
        ] : [
            offset.top + (padding.top || 0) + (calculatedPadding || 0),
            offset.top + offset.height - (padding.bottom || 0) - (calculatedPadding || 0)
        ];
        else range = axis.range;
        if (reversed) range = [
            range[1],
            range[0]
        ];
        var _parseScale = (0, $fiDSf.parseScale)(axis, chartName, hasBar), scale = _parseScale.scale, realScaleType = _parseScale.realScaleType;
        scale.domain(domain).range(range);
        (0, $fiDSf.checkDomainOfScale)(scale);
        var ticks = (0, $fiDSf.getTicksOfScale)(scale, $ae9eba8c62140ea0$var$_objectSpread($ae9eba8c62140ea0$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        if (axisType === "xAxis") {
            needSpace = orientation === "top" && !mirror || orientation === "bottom" && mirror;
            x = offset.left;
            y = steps[offsetKey] - needSpace * axis.height;
        } else if (axisType === "yAxis") {
            needSpace = orientation === "left" && !mirror || orientation === "right" && mirror;
            x = steps[offsetKey] - needSpace * axis.width;
            y = offset.top;
        }
        var finalAxis = $ae9eba8c62140ea0$var$_objectSpread($ae9eba8c62140ea0$var$_objectSpread($ae9eba8c62140ea0$var$_objectSpread({}, axis), ticks), {}, {
            realScaleType: realScaleType,
            x: x,
            y: y,
            scale: scale,
            width: axisType === "xAxis" ? offset.width : axis.width,
            height: axisType === "yAxis" ? offset.height : axis.height
        });
        finalAxis.bandSize = (0, $fiDSf.getBandSizeOfAxis)(finalAxis, ticks);
        if (!axis.hide && axisType === "xAxis") steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
        else if (!axis.hide) steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
        return $ae9eba8c62140ea0$var$_objectSpread($ae9eba8c62140ea0$var$_objectSpread({}, result), {}, $ae9eba8c62140ea0$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $ae9eba8c62140ea0$export$c7964a5b9439ae62 = function rectWithPoints(_ref, _ref2) {
    var x1 = _ref.x, y1 = _ref.y;
    var x2 = _ref2.x, y2 = _ref2.y;
    return {
        x: Math.min(x1, x2),
        y: Math.min(y1, y2),
        width: Math.abs(x2 - x1),
        height: Math.abs(y2 - y1)
    };
};
var $ae9eba8c62140ea0$export$6df2062b9e15eec0 = function rectWithCoords(_ref3) {
    var x1 = _ref3.x1, y1 = _ref3.y1, x2 = _ref3.x2, y2 = _ref3.y2;
    return $ae9eba8c62140ea0$export$c7964a5b9439ae62({
        x: x1,
        y: y1
    }, {
        x: x2,
        y: y2
    });
};
var $ae9eba8c62140ea0$export$dae1ac4449a69ee8 = /*#__PURE__*/ function() {
    function ScaleHelper(scale) {
        $ae9eba8c62140ea0$var$_classCallCheck(this, ScaleHelper);
        this.scale = scale;
    }
    return $ae9eba8c62140ea0$var$_createClass(ScaleHelper, [
        {
            key: "domain",
            get: function get() {
                return this.scale.domain;
            }
        },
        {
            key: "range",
            get: function get() {
                return this.scale.range;
            }
        },
        {
            key: "rangeMin",
            get: function get() {
                return this.range()[0];
            }
        },
        {
            key: "rangeMax",
            get: function get() {
                return this.range()[1];
            }
        },
        {
            key: "bandwidth",
            get: function get() {
                return this.scale.bandwidth;
            }
        },
        {
            key: "apply",
            value: function apply(value) {
                var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref4.bandAware, position = _ref4.position;
                if (value === undefined) return undefined;
                if (position) switch(position){
                    case "start":
                        return this.scale(value);
                    case "middle":
                        var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
                        return this.scale(value) + offset;
                    case "end":
                        var _offset = this.bandwidth ? this.bandwidth() : 0;
                        return this.scale(value) + _offset;
                    default:
                        return this.scale(value);
                }
                if (bandAware) {
                    var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;
                    return this.scale(value) + _offset2;
                }
                return this.scale(value);
            }
        },
        {
            key: "isInRange",
            value: function isInRange(value) {
                var range = this.range();
                var first = range[0];
                var last = range[range.length - 1];
                return first <= last ? value >= first && value <= last : value >= last && value <= first;
            }
        }
    ], [
        {
            key: "create",
            value: function create(obj) {
                return new ScaleHelper(obj);
            }
        }
    ]);
}();
$ae9eba8c62140ea0$var$_defineProperty($ae9eba8c62140ea0$export$dae1ac4449a69ee8, "EPS", 1e-4);
var $ae9eba8c62140ea0$export$db77ae668c18269f = function createLabeledScales(options) {
    var scales = Object.keys(options).reduce(function(res, key) {
        return $ae9eba8c62140ea0$var$_objectSpread($ae9eba8c62140ea0$var$_objectSpread({}, res), {}, $ae9eba8c62140ea0$var$_defineProperty({}, key, $ae9eba8c62140ea0$export$dae1ac4449a69ee8.create(options[key])));
    }, {});
    return $ae9eba8c62140ea0$var$_objectSpread($ae9eba8c62140ea0$var$_objectSpread({}, scales), {}, {
        apply: function apply(coord) {
            var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref5.bandAware, position = _ref5.position;
            return (0, (/*@__PURE__*/$parcel$interopDefault($guwjw)))(coord, function(value, label) {
                return scales[label].apply(value, {
                    bandAware: bandAware,
                    position: position
                });
            });
        },
        isInRange: function isInRange(coord) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($6O6hA)))(coord, function(value, label) {
                return scales[label].isInRange(value);
            });
        }
    });
};
function $ae9eba8c62140ea0$export$e3df76cf4464bc81(angle) {
    return (angle % 180 + 180) % 180;
}
var $ae9eba8c62140ea0$export$3ee78d51cffc2b68 = function getAngledRectangleWidth(_ref6) {
    var width = _ref6.width, height = _ref6.height;
    var angle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Ensure angle is >= 0 && < 180
    var normalizedAngle = $ae9eba8c62140ea0$export$e3df76cf4464bc81(angle);
    var angleRadians = normalizedAngle * Math.PI / 180;
    /* Depending on the height and width of the rectangle, we may need to use different formulas to calculate the angled
   * width. This threshold defines when each formula should kick in. */ var angleThreshold = Math.atan(height / width);
    var angledWidth = angleRadians > angleThreshold && angleRadians < Math.PI - angleThreshold ? height / Math.sin(angleRadians) : width / Math.cos(angleRadians);
    return Math.abs(angledWidth);
};

});
parcelRegister("guwjw", function(module, exports) {

var $gO7Nd = parcelRequire("gO7Nd");

var $kBC6R = parcelRequire("kBC6R");

var $15GS2 = parcelRequire("15GS2");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $c0188391783b678d$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $15GS2(iteratee, 3);
    $kBC6R(object, function(value, key, object) {
        $gO7Nd(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $c0188391783b678d$var$mapValues;

});
parcelRegister("gO7Nd", function(module, exports) {

var $a91q9 = parcelRequire("a91q9");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $c3c75c538a044a19$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $a91q9) $a91q9(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
module.exports = $c3c75c538a044a19$var$baseAssignValue;

});


parcelRegister("6O6hA", function(module, exports) {

var $di61z = parcelRequire("di61z");

var $63PtV = parcelRequire("63PtV");

var $15GS2 = parcelRequire("15GS2");

var $687Zl = parcelRequire("687Zl");

var $6PImS = parcelRequire("6PImS");
/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */ function $4f4c492e64c7e1eb$var$every(collection, predicate, guard) {
    var func = $687Zl(collection) ? $di61z : $63PtV;
    if (guard && $6PImS(collection, predicate, guard)) predicate = undefined;
    return func(collection, $15GS2(predicate, 3));
}
module.exports = $4f4c492e64c7e1eb$var$every;

});
parcelRegister("di61z", function(module, exports) {
/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */ function $9ad1a11d91fc7811$var$arrayEvery(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (!predicate(array[index], index, array)) return false;
    }
    return true;
}
module.exports = $9ad1a11d91fc7811$var$arrayEvery;

});

parcelRegister("63PtV", function(module, exports) {

var $hQ9aw = parcelRequire("hQ9aw");
/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */ function $469af51445d9b378$var$baseEvery(collection, predicate) {
    var result = true;
    $hQ9aw(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
    });
    return result;
}
module.exports = $469af51445d9b378$var$baseEvery;

});


parcelRegister("jq8pz", function(module, exports) {

$parcel$export(module.exports, "Bar", function () { return $e236f85aaa697515$export$bbc6c6369b38e3d1; });

var $jbmdS = parcelRequire("jbmdS");

var $dWgPS = parcelRequire("dWgPS");

var $bBmgp = parcelRequire("bBmgp");

var $dzN0r = parcelRequire("dzN0r");

var $aVX0M = parcelRequire("aVX0M");

var $bIYfh = parcelRequire("bIYfh");

var $3Efgj = parcelRequire("3Efgj");

var $6aOPF = parcelRequire("6aOPF");

var $1sHYq = parcelRequire("1sHYq");

var $1gmrG = parcelRequire("1gmrG");

var $f06D9 = parcelRequire("f06D9");

var $9wZNv = parcelRequire("9wZNv");

var $fiDSf = parcelRequire("fiDSf");

var $gBhCn = parcelRequire("gBhCn");

var $aUFpJ = parcelRequire("aUFpJ");
var $e236f85aaa697515$var$_excluded = [
    "value",
    "background"
];
var $e236f85aaa697515$var$_Bar;
function $e236f85aaa697515$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e236f85aaa697515$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e236f85aaa697515$var$_typeof(o);
}
function $e236f85aaa697515$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e236f85aaa697515$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e236f85aaa697515$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $e236f85aaa697515$var$_extends() {
    $e236f85aaa697515$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e236f85aaa697515$var$_extends.apply(this, arguments);
}
function $e236f85aaa697515$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e236f85aaa697515$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e236f85aaa697515$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e236f85aaa697515$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e236f85aaa697515$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e236f85aaa697515$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e236f85aaa697515$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $e236f85aaa697515$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $e236f85aaa697515$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e236f85aaa697515$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e236f85aaa697515$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $e236f85aaa697515$var$_callSuper(t, o, e) {
    return o = $e236f85aaa697515$var$_getPrototypeOf(o), $e236f85aaa697515$var$_possibleConstructorReturn(t, $e236f85aaa697515$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $e236f85aaa697515$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $e236f85aaa697515$var$_possibleConstructorReturn(self, call) {
    if (call && ($e236f85aaa697515$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $e236f85aaa697515$var$_assertThisInitialized(self);
}
function $e236f85aaa697515$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $e236f85aaa697515$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($e236f85aaa697515$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $e236f85aaa697515$var$_getPrototypeOf(o) {
    $e236f85aaa697515$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e236f85aaa697515$var$_getPrototypeOf(o);
}
function $e236f85aaa697515$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $e236f85aaa697515$var$_setPrototypeOf(subClass, superClass);
}
function $e236f85aaa697515$var$_setPrototypeOf(o, p) {
    $e236f85aaa697515$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e236f85aaa697515$var$_setPrototypeOf(o, p);
}
function $e236f85aaa697515$var$_defineProperty(obj, key, value) {
    key = $e236f85aaa697515$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e236f85aaa697515$var$_toPropertyKey(t) {
    var i = $e236f85aaa697515$var$_toPrimitive(t, "string");
    return "symbol" == $e236f85aaa697515$var$_typeof(i) ? i : i + "";
}
function $e236f85aaa697515$var$_toPrimitive(t, r) {
    if ("object" != $e236f85aaa697515$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $e236f85aaa697515$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $e236f85aaa697515$export$bbc6c6369b38e3d1 = /*#__PURE__*/ function(_PureComponent) {
    function Bar() {
        var _this;
        $e236f85aaa697515$var$_classCallCheck(this, Bar);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $e236f85aaa697515$var$_callSuper(this, Bar, [].concat(args));
        $e236f85aaa697515$var$_defineProperty(_this, "state", {
            isAnimationFinished: false
        });
        $e236f85aaa697515$var$_defineProperty(_this, "id", (0, $1gmrG.uniqueId)("recharts-bar-"));
        $e236f85aaa697515$var$_defineProperty(_this, "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if (onAnimationEnd) onAnimationEnd();
        });
        $e236f85aaa697515$var$_defineProperty(_this, "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if (onAnimationStart) onAnimationStart();
        });
        return _this;
    }
    $e236f85aaa697515$var$_inherits(Bar, _PureComponent);
    return $e236f85aaa697515$var$_createClass(Bar, [
        {
            key: "renderRectanglesStatically",
            value: function renderRectanglesStatically(data) {
                var _this2 = this;
                var _this$props = this.props, shape = _this$props.shape, dataKey = _this$props.dataKey, activeIndex = _this$props.activeIndex, activeBar = _this$props.activeBar;
                var baseProps = (0, $f06D9.filterProps)(this.props, false);
                return data && data.map(function(entry, i) {
                    var isActive = i === activeIndex;
                    var option = isActive ? activeBar : shape;
                    var props = $e236f85aaa697515$var$_objectSpread($e236f85aaa697515$var$_objectSpread($e236f85aaa697515$var$_objectSpread({}, baseProps), entry), {}, {
                        isActive: isActive,
                        option: option,
                        index: i,
                        dataKey: dataKey,
                        onAnimationStart: _this2.handleAnimationStart,
                        onAnimationEnd: _this2.handleAnimationEnd
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $bIYfh.Layer), $e236f85aaa697515$var$_extends({
                        className: "recharts-bar-rectangle"
                    }, (0, $gBhCn.adaptEventsOfChild)(_this2.props, entry, i), {
                        key: "rectangle-".concat(entry === null || entry === void 0 ? void 0 : entry.x, "-").concat(entry === null || entry === void 0 ? void 0 : entry.y, "-").concat(entry === null || entry === void 0 ? void 0 : entry.value)
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $aUFpJ.BarRectangle), props));
                });
            }
        },
        {
            key: "renderRectanglesWithAnimation",
            value: function renderRectanglesWithAnimation() {
                var _this3 = this;
                var _this$props2 = this.props, data = _this$props2.data, layout = _this$props2.layout, isAnimationActive = _this$props2.isAnimationActive, animationBegin = _this$props2.animationBegin, animationDuration = _this$props2.animationDuration, animationEasing = _this$props2.animationEasing, animationId = _this$props2.animationId;
                var prevData = this.state.prevData;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $bBmgp.default), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "bar-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    var stepData = data.map(function(entry, index) {
                        var prev = prevData && prevData[index];
                        if (prev) {
                            var interpolatorX = (0, $1gmrG.interpolateNumber)(prev.x, entry.x);
                            var interpolatorY = (0, $1gmrG.interpolateNumber)(prev.y, entry.y);
                            var interpolatorWidth = (0, $1gmrG.interpolateNumber)(prev.width, entry.width);
                            var interpolatorHeight = (0, $1gmrG.interpolateNumber)(prev.height, entry.height);
                            return $e236f85aaa697515$var$_objectSpread($e236f85aaa697515$var$_objectSpread({}, entry), {}, {
                                x: interpolatorX(t),
                                y: interpolatorY(t),
                                width: interpolatorWidth(t),
                                height: interpolatorHeight(t)
                            });
                        }
                        if (layout === "horizontal") {
                            var _interpolatorHeight = (0, $1gmrG.interpolateNumber)(0, entry.height);
                            var h = _interpolatorHeight(t);
                            return $e236f85aaa697515$var$_objectSpread($e236f85aaa697515$var$_objectSpread({}, entry), {}, {
                                y: entry.y + entry.height - h,
                                height: h
                            });
                        }
                        var interpolator = (0, $1gmrG.interpolateNumber)(0, entry.width);
                        var w = interpolator(t);
                        return $e236f85aaa697515$var$_objectSpread($e236f85aaa697515$var$_objectSpread({}, entry), {}, {
                            width: w
                        });
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $bIYfh.Layer), null, _this3.renderRectanglesStatically(stepData));
                });
            }
        },
        {
            key: "renderRectangles",
            value: function renderRectangles() {
                var _this$props3 = this.props, data = _this$props3.data, isAnimationActive = _this$props3.isAnimationActive;
                var prevData = this.state.prevData;
                if (isAnimationActive && data && data.length && (!prevData || !(0, (/*@__PURE__*/$parcel$interopDefault($dzN0r)))(prevData, data))) return this.renderRectanglesWithAnimation();
                return this.renderRectanglesStatically(data);
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this4 = this;
                var _this$props4 = this.props, data = _this$props4.data, dataKey = _this$props4.dataKey, activeIndex = _this$props4.activeIndex;
                var backgroundProps = (0, $f06D9.filterProps)(this.props.background, false);
                return data.map(function(entry, i) {
                    var value = entry.value, background = entry.background, rest = $e236f85aaa697515$var$_objectWithoutProperties(entry, $e236f85aaa697515$var$_excluded);
                    if (!background) return null;
                    var props = $e236f85aaa697515$var$_objectSpread($e236f85aaa697515$var$_objectSpread($e236f85aaa697515$var$_objectSpread($e236f85aaa697515$var$_objectSpread($e236f85aaa697515$var$_objectSpread({}, rest), {}, {
                        fill: "#eee"
                    }, background), backgroundProps), (0, $gBhCn.adaptEventsOfChild)(_this4.props, entry, i)), {}, {
                        onAnimationStart: _this4.handleAnimationStart,
                        onAnimationEnd: _this4.handleAnimationEnd,
                        dataKey: dataKey,
                        index: i,
                        className: "recharts-bar-background-rectangle"
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $aUFpJ.BarRectangle), $e236f85aaa697515$var$_extends({
                        key: "background-bar-".concat(i),
                        option: _this4.props.background,
                        isActive: i === activeIndex
                    }, props));
                });
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar(needClip, clipPathId) {
                if (this.props.isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props5 = this.props, data = _this$props5.data, xAxis = _this$props5.xAxis, yAxis = _this$props5.yAxis, layout = _this$props5.layout, children = _this$props5.children;
                var errorBarItems = (0, $f06D9.findAllByType)(children, (0, $3Efgj.ErrorBar));
                if (!errorBarItems) return null;
                var offset = layout === "vertical" ? data[0].height / 2 : data[0].width / 2;
                var dataPointFormatter = function dataPointFormatter(dataPoint, dataKey) {
                    /**
         * if the value coming from `getComposedData` is an array then this is a stacked bar chart.
         * arr[1] represents end value of the bar since the data is in the form of [startValue, endValue].
         * */ var value = Array.isArray(dataPoint.value) ? dataPoint.value[1] : dataPoint.value;
                    return {
                        x: dataPoint.x,
                        y: dataPoint.y,
                        value: value,
                        errorVal: (0, $fiDSf.getValueByDataKey)(dataPoint, dataKey)
                    };
                };
                var errorBarProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $bIYfh.Layer), errorBarProps, errorBarItems.map(function(item) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).cloneElement(item, {
                        key: "error-bar-".concat(clipPathId, "-").concat(item.props.dataKey),
                        data: data,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: layout,
                        offset: offset,
                        dataPointFormatter: dataPointFormatter
                    });
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, hide = _this$props6.hide, data = _this$props6.data, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, left = _this$props6.left, top = _this$props6.top, width = _this$props6.width, height = _this$props6.height, isAnimationActive = _this$props6.isAnimationActive, background = _this$props6.background, id = _this$props6.id;
                if (hide || !data || !data.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var layerClass = (0, $dWgPS.default)("recharts-bar", className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($aVX0M)))(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $bIYfh.Layer), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                }))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $bIYfh.Layer), {
                    className: "recharts-bar-rectangles",
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, background ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $1sHYq.LabelList).renderCallByParent(this.props, data));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curData: nextProps.data,
                    prevData: prevState.curData
                };
                if (nextProps.data !== prevState.curData) return {
                    curData: nextProps.data
                };
                return null;
            }
        }
    ]);
}((0, $jbmdS.PureComponent));
$e236f85aaa697515$var$_Bar = $e236f85aaa697515$export$bbc6c6369b38e3d1;
$e236f85aaa697515$var$_defineProperty($e236f85aaa697515$export$bbc6c6369b38e3d1, "displayName", "Bar");
$e236f85aaa697515$var$_defineProperty($e236f85aaa697515$export$bbc6c6369b38e3d1, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    legendType: "rect",
    minPointSize: 0,
    hide: false,
    data: [],
    layout: "vertical",
    activeBar: false,
    isAnimationActive: !(0, $9wZNv.Global).isSsr,
    animationBegin: 0,
    animationDuration: 400,
    animationEasing: "ease"
});
/**
 * Compose the data of each group
 * @param {Object} props Props for the component
 * @param {Object} item        An instance of Bar
 * @param {Array} barPosition  The offset and size of each bar
 * @param {Object} xAxis       The configuration of x-axis
 * @param {Object} yAxis       The configuration of y-axis
 * @param {Array} stackedData  The stacked data of a bar item
 * @return{Array} Composed data
 */ $e236f85aaa697515$var$_defineProperty($e236f85aaa697515$export$bbc6c6369b38e3d1, "getComposedData", function(_ref2) {
    var props = _ref2.props, item = _ref2.item, barPosition = _ref2.barPosition, bandSize = _ref2.bandSize, xAxis = _ref2.xAxis, yAxis = _ref2.yAxis, xAxisTicks = _ref2.xAxisTicks, yAxisTicks = _ref2.yAxisTicks, stackedData = _ref2.stackedData, dataStartIndex = _ref2.dataStartIndex, displayedData = _ref2.displayedData, offset = _ref2.offset;
    var pos = (0, $fiDSf.findPositionOfBar)(barPosition, item);
    if (!pos) return null;
    var layout = props.layout;
    var itemDefaultProps = item.type.defaultProps;
    var itemProps = itemDefaultProps !== undefined ? $e236f85aaa697515$var$_objectSpread($e236f85aaa697515$var$_objectSpread({}, itemDefaultProps), item.props) : item.props;
    var dataKey = itemProps.dataKey, children = itemProps.children, minPointSizeProp = itemProps.minPointSize;
    var numericAxis = layout === "horizontal" ? yAxis : xAxis;
    var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
    var baseValue = (0, $fiDSf.getBaseValueOfBar)({
        numericAxis: numericAxis
    });
    var cells = (0, $f06D9.findAllByType)(children, (0, $6aOPF.Cell));
    var rects = displayedData.map(function(entry, index) {
        var value, x, y, width, height, background;
        if (stackedData) value = (0, $fiDSf.truncateByDomain)(stackedData[dataStartIndex + index], stackedDomain);
        else {
            value = (0, $fiDSf.getValueByDataKey)(entry, dataKey);
            if (!Array.isArray(value)) value = [
                baseValue,
                value
            ];
        }
        var minPointSize = (0, $aUFpJ.minPointSizeCallback)(minPointSizeProp, $e236f85aaa697515$var$_Bar.defaultProps.minPointSize)(value[1], index);
        if (layout === "horizontal") {
            var _ref4;
            var _ref3 = [
                yAxis.scale(value[0]),
                yAxis.scale(value[1])
            ], baseValueScale = _ref3[0], currentValueScale = _ref3[1];
            x = (0, $fiDSf.getCateCoordinateOfBar)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            y = (_ref4 = currentValueScale !== null && currentValueScale !== void 0 ? currentValueScale : baseValueScale) !== null && _ref4 !== void 0 ? _ref4 : undefined;
            width = pos.size;
            var computedHeight = baseValueScale - currentValueScale;
            height = Number.isNaN(computedHeight) ? 0 : computedHeight;
            background = {
                x: x,
                y: yAxis.y,
                width: width,
                height: yAxis.height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
                var delta = (0, $1gmrG.mathSign)(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
                y -= delta;
                height += delta;
            }
        } else {
            var _ref5 = [
                xAxis.scale(value[0]),
                xAxis.scale(value[1])
            ], _baseValueScale = _ref5[0], _currentValueScale = _ref5[1];
            x = _baseValueScale;
            y = (0, $fiDSf.getCateCoordinateOfBar)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            width = _currentValueScale - _baseValueScale;
            height = pos.size;
            background = {
                x: xAxis.x,
                y: y,
                width: xAxis.width,
                height: height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
                var _delta = (0, $1gmrG.mathSign)(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
                width += _delta;
            }
        }
        return $e236f85aaa697515$var$_objectSpread($e236f85aaa697515$var$_objectSpread($e236f85aaa697515$var$_objectSpread({}, entry), {}, {
            x: x,
            y: y,
            width: width,
            height: height,
            value: stackedData ? value : value[1],
            payload: entry,
            background: background
        }, cells && cells[index] && cells[index].props), {}, {
            tooltipPayload: [
                (0, $fiDSf.getTooltipItem)(item, entry)
            ],
            tooltipPosition: {
                x: x + width / 2,
                y: y + height / 2
            }
        });
    });
    return $e236f85aaa697515$var$_objectSpread({
        data: rects,
        layout: layout
    }, offset);
});

});
parcelRegister("6aOPF", function(module, exports) {

$parcel$export(module.exports, "Cell", function () { return $47eb1b81db54f321$export$f6f0c3fe4ec306ea; });
/**
 * @fileOverview Cross
 */ var $47eb1b81db54f321$export$f6f0c3fe4ec306ea = function Cell(_props) {
    return null;
};
$47eb1b81db54f321$export$f6f0c3fe4ec306ea.displayName = "Cell";

});

parcelRegister("aUFpJ", function(module, exports) {

$parcel$export(module.exports, "BarRectangle", function () { return $7f1f424dab79fce0$export$f19074a6842f9217; });
$parcel$export(module.exports, "minPointSizeCallback", function () { return $7f1f424dab79fce0$export$c20d73790de171f0; });

var $jbmdS = parcelRequire("jbmdS");

var $9GFyS = parcelRequire("9GFyS");

var $cFsdf = parcelRequire("cFsdf");
var $7f1f424dab79fce0$var$_excluded = [
    "x",
    "y"
];
function $7f1f424dab79fce0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7f1f424dab79fce0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7f1f424dab79fce0$var$_typeof(o);
}
function $7f1f424dab79fce0$var$_extends() {
    $7f1f424dab79fce0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7f1f424dab79fce0$var$_extends.apply(this, arguments);
}
function $7f1f424dab79fce0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7f1f424dab79fce0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7f1f424dab79fce0$var$ownKeys(Object(t), !0).forEach(function(r) {
            $7f1f424dab79fce0$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7f1f424dab79fce0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7f1f424dab79fce0$var$_defineProperty(obj, key, value) {
    key = $7f1f424dab79fce0$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7f1f424dab79fce0$var$_toPropertyKey(t) {
    var i = $7f1f424dab79fce0$var$_toPrimitive(t, "string");
    return "symbol" == $7f1f424dab79fce0$var$_typeof(i) ? i : i + "";
}
function $7f1f424dab79fce0$var$_toPrimitive(t, r) {
    if ("object" != $7f1f424dab79fce0$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $7f1f424dab79fce0$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $7f1f424dab79fce0$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $7f1f424dab79fce0$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $7f1f424dab79fce0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// Rectangle props is expecting x, y, height, width as numbers, name as a string, and radius as a custom type
// When props are being spread in from a user defined component in Bar,
// the prop types of an SVGElement have these typed as something else.
// This function will return the passed in props
// along with x, y, height as numbers, name as a string, and radius as number | [number, number, number, number]
function $7f1f424dab79fce0$var$typeguardBarRectangleProps(_ref, props) {
    var xProp = _ref.x, yProp = _ref.y, option = $7f1f424dab79fce0$var$_objectWithoutProperties(_ref, $7f1f424dab79fce0$var$_excluded);
    var xValue = "".concat(xProp);
    var x = parseInt(xValue, 10);
    var yValue = "".concat(yProp);
    var y = parseInt(yValue, 10);
    var heightValue = "".concat(props.height || option.height);
    var height = parseInt(heightValue, 10);
    var widthValue = "".concat(props.width || option.width);
    var width = parseInt(widthValue, 10);
    return $7f1f424dab79fce0$var$_objectSpread($7f1f424dab79fce0$var$_objectSpread($7f1f424dab79fce0$var$_objectSpread($7f1f424dab79fce0$var$_objectSpread($7f1f424dab79fce0$var$_objectSpread({}, props), option), x ? {
        x: x
    } : {}), y ? {
        y: y
    } : {}), {}, {
        height: height,
        width: width,
        name: props.name,
        radius: props.radius
    });
}
function $7f1f424dab79fce0$export$f19074a6842f9217(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $cFsdf.Shape), $7f1f424dab79fce0$var$_extends({
        shapeType: "rectangle",
        propTransformer: $7f1f424dab79fce0$var$typeguardBarRectangleProps,
        activeClassName: "recharts-active-bar"
    }, props));
}
var $7f1f424dab79fce0$export$c20d73790de171f0 = function minPointSizeCallback(minPointSize) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return function(value, index) {
        if (typeof minPointSize === "number") return minPointSize;
        var isValueNumber = typeof value === "number";
        if (isValueNumber) return minPointSize(value, index);
        !isValueNumber && (0, $9GFyS.default)(false);
        return defaultValue;
    };
};

});
parcelRegister("cFsdf", function(module, exports) {

$parcel$export(module.exports, "Shape", function () { return $938f32d597279df2$export$6428a7f2611ef1fa; });
$parcel$export(module.exports, "isFunnel", function () { return $938f32d597279df2$export$4b83e8415af38a18; });
$parcel$export(module.exports, "isPie", function () { return $938f32d597279df2$export$f722d7e63cc07b; });
$parcel$export(module.exports, "isScatter", function () { return $938f32d597279df2$export$f62b21bcfd1a733e; });
$parcel$export(module.exports, "getActiveShapeIndexForTooltip", function () { return $938f32d597279df2$export$bd5d63c57ca4468; });

var $jbmdS = parcelRequire("jbmdS");

var $i99FY = parcelRequire("i99FY");

var $gHnuO = parcelRequire("gHnuO");

var $lhaYx = parcelRequire("lhaYx");

var $dzN0r = parcelRequire("dzN0r");

var $DN6Qj = parcelRequire("DN6Qj");

var $c238b = parcelRequire("c238b");

var $4naQZ = parcelRequire("4naQZ");

var $bIYfh = parcelRequire("bIYfh");

var $5q3tP = parcelRequire("5q3tP");
var $938f32d597279df2$var$_excluded = [
    "option",
    "shapeType",
    "propTransformer",
    "activeClassName",
    "isActive"
];
function $938f32d597279df2$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $938f32d597279df2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $938f32d597279df2$var$_typeof(o);
}
function $938f32d597279df2$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $938f32d597279df2$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $938f32d597279df2$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $938f32d597279df2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $938f32d597279df2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $938f32d597279df2$var$ownKeys(Object(t), !0).forEach(function(r) {
            $938f32d597279df2$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $938f32d597279df2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $938f32d597279df2$var$_defineProperty(obj, key, value) {
    key = $938f32d597279df2$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $938f32d597279df2$var$_toPropertyKey(t) {
    var i = $938f32d597279df2$var$_toPrimitive(t, "string");
    return "symbol" == $938f32d597279df2$var$_typeof(i) ? i : i + "";
}
function $938f32d597279df2$var$_toPrimitive(t, r) {
    if ("object" != $938f32d597279df2$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $938f32d597279df2$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * This is an abstraction for rendering a user defined prop for a customized shape in several forms.
 *
 * <Shape /> is the root and will handle taking in:
 *  - an object of svg properties
 *  - a boolean
 *  - a render prop(inline function that returns jsx)
 *  - a react element
 *
 * <ShapeSelector /> is a subcomponent of <Shape /> and used to match a component
 * to the value of props.shapeType that is passed to the root.
 *
 */ function $938f32d597279df2$var$defaultPropTransformer(option, props) {
    return $938f32d597279df2$var$_objectSpread($938f32d597279df2$var$_objectSpread({}, props), option);
}
function $938f32d597279df2$var$isSymbolsProps(shapeType, _elementProps) {
    return shapeType === "symbols";
}
function $938f32d597279df2$var$ShapeSelector(_ref) {
    var shapeType = _ref.shapeType, elementProps = _ref.elementProps;
    switch(shapeType){
        case "rectangle":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $DN6Qj.Rectangle), elementProps);
        case "trapezoid":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $c238b.Trapezoid), elementProps);
        case "sector":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $4naQZ.Sector), elementProps);
        case "symbols":
            if ($938f32d597279df2$var$isSymbolsProps(shapeType, elementProps)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $5q3tP.Symbols), elementProps);
            break;
        default:
            return null;
    }
}
function $938f32d597279df2$export$33c4f706a443da24(option) {
    if (/*#__PURE__*/ (0, $jbmdS.isValidElement)(option)) return option.props;
    return option;
}
function $938f32d597279df2$export$6428a7f2611ef1fa(_ref2) {
    var option = _ref2.option, shapeType = _ref2.shapeType, _ref2$propTransformer = _ref2.propTransformer, propTransformer = _ref2$propTransformer === void 0 ? $938f32d597279df2$var$defaultPropTransformer : _ref2$propTransformer, _ref2$activeClassName = _ref2.activeClassName, activeClassName = _ref2$activeClassName === void 0 ? "recharts-active-shape" : _ref2$activeClassName, isActive = _ref2.isActive, props = $938f32d597279df2$var$_objectWithoutProperties(_ref2, $938f32d597279df2$var$_excluded);
    var shape;
    if (/*#__PURE__*/ (0, $jbmdS.isValidElement)(option)) shape = /*#__PURE__*/ (0, $jbmdS.cloneElement)(option, $938f32d597279df2$var$_objectSpread($938f32d597279df2$var$_objectSpread({}, props), $938f32d597279df2$export$33c4f706a443da24(option)));
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(option)) shape = option(props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($gHnuO)))(option) && !(0, (/*@__PURE__*/$parcel$interopDefault($lhaYx)))(option)) {
        var nextProps = propTransformer(option, props);
        shape = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($938f32d597279df2$var$ShapeSelector, {
            shapeType: shapeType,
            elementProps: nextProps
        });
    } else {
        var elementProps = props;
        shape = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($938f32d597279df2$var$ShapeSelector, {
            shapeType: shapeType,
            elementProps: elementProps
        });
    }
    if (isActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $bIYfh.Layer), {
        className: activeClassName
    }, shape);
    return shape;
}
function $938f32d597279df2$export$4b83e8415af38a18(graphicalItem, _item) {
    return _item != null && "trapezoids" in graphicalItem.props;
}
function $938f32d597279df2$export$f722d7e63cc07b(graphicalItem, _item) {
    return _item != null && "sectors" in graphicalItem.props;
}
function $938f32d597279df2$export$f62b21bcfd1a733e(graphicalItem, _item) {
    return _item != null && "points" in graphicalItem.props;
}
function $938f32d597279df2$export$7c9a98b3f068686f(shapeData, activeTooltipItem) {
    var _activeTooltipItem$la, _activeTooltipItem$la2;
    var xMatches = shapeData.x === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la === void 0 ? void 0 : _activeTooltipItem$la.x) || shapeData.x === activeTooltipItem.x;
    var yMatches = shapeData.y === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la2 = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la2 === void 0 ? void 0 : _activeTooltipItem$la2.y) || shapeData.y === activeTooltipItem.y;
    return xMatches && yMatches;
}
function $938f32d597279df2$export$b356b51e8337a02f(shapeData, activeTooltipItem) {
    var startAngleMatches = shapeData.endAngle === activeTooltipItem.endAngle;
    var endAngleMatches = shapeData.startAngle === activeTooltipItem.startAngle;
    return startAngleMatches && endAngleMatches;
}
function $938f32d597279df2$export$559c3a78b4889350(shapeData, activeTooltipItem) {
    var xMatches = shapeData.x === activeTooltipItem.x;
    var yMatches = shapeData.y === activeTooltipItem.y;
    var zMatches = shapeData.z === activeTooltipItem.z;
    return xMatches && yMatches && zMatches;
}
function $938f32d597279df2$var$getComparisonFn(graphicalItem, activeItem) {
    var comparison;
    if ($938f32d597279df2$export$4b83e8415af38a18(graphicalItem, activeItem)) comparison = $938f32d597279df2$export$7c9a98b3f068686f;
    else if ($938f32d597279df2$export$f722d7e63cc07b(graphicalItem, activeItem)) comparison = $938f32d597279df2$export$b356b51e8337a02f;
    else if ($938f32d597279df2$export$f62b21bcfd1a733e(graphicalItem, activeItem)) comparison = $938f32d597279df2$export$559c3a78b4889350;
    return comparison;
}
function $938f32d597279df2$var$getShapeDataKey(graphicalItem, activeItem) {
    var shapeKey;
    if ($938f32d597279df2$export$4b83e8415af38a18(graphicalItem, activeItem)) shapeKey = "trapezoids";
    else if ($938f32d597279df2$export$f722d7e63cc07b(graphicalItem, activeItem)) shapeKey = "sectors";
    else if ($938f32d597279df2$export$f62b21bcfd1a733e(graphicalItem, activeItem)) shapeKey = "points";
    return shapeKey;
}
function $938f32d597279df2$var$getActiveShapeTooltipPayload(graphicalItem, activeItem) {
    if ($938f32d597279df2$export$4b83e8415af38a18(graphicalItem, activeItem)) {
        var _activeItem$tooltipPa;
        return (_activeItem$tooltipPa = activeItem.tooltipPayload) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa[0]) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa.payload) === null || _activeItem$tooltipPa === void 0 ? void 0 : _activeItem$tooltipPa.payload;
    }
    if ($938f32d597279df2$export$f722d7e63cc07b(graphicalItem, activeItem)) {
        var _activeItem$tooltipPa2;
        return (_activeItem$tooltipPa2 = activeItem.tooltipPayload) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2[0]) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2.payload) === null || _activeItem$tooltipPa2 === void 0 ? void 0 : _activeItem$tooltipPa2.payload;
    }
    if ($938f32d597279df2$export$f62b21bcfd1a733e(graphicalItem, activeItem)) return activeItem.payload;
    return {};
}
function $938f32d597279df2$export$bd5d63c57ca4468(_ref3) {
    var activeTooltipItem = _ref3.activeTooltipItem, graphicalItem = _ref3.graphicalItem, itemData = _ref3.itemData;
    var shapeKey = $938f32d597279df2$var$getShapeDataKey(graphicalItem, activeTooltipItem);
    var tooltipPayload = $938f32d597279df2$var$getActiveShapeTooltipPayload(graphicalItem, activeTooltipItem);
    var activeItemMatches = itemData.filter(function(datum, dataIndex) {
        var valuesMatch = (0, (/*@__PURE__*/$parcel$interopDefault($dzN0r)))(tooltipPayload, datum);
        var mouseCoordinateMatches = graphicalItem.props[shapeKey].filter(function(shapeData) {
            var comparison = $938f32d597279df2$var$getComparisonFn(graphicalItem, activeTooltipItem);
            return comparison(shapeData, activeTooltipItem);
        });
        // get the last index in case of multiple matches
        var indexOfMouseCoordinates = graphicalItem.props[shapeKey].indexOf(mouseCoordinateMatches[mouseCoordinateMatches.length - 1]);
        var coordinatesMatch = dataIndex === indexOfMouseCoordinates;
        return valuesMatch && coordinatesMatch;
    });
    // get the last index in case of multiple matches
    var activeIndex = itemData.indexOf(activeItemMatches[activeItemMatches.length - 1]);
    return activeIndex;
}

});
parcelRegister("gHnuO", function(module, exports) {

var $d8VrW = parcelRequire("d8VrW");

var $iCet7 = parcelRequire("iCet7");

var $8JxPO = parcelRequire("8JxPO");
/** `Object#toString` result references. */ var $c282e350f574df36$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $c282e350f574df36$var$funcProto = Function.prototype, $c282e350f574df36$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $c282e350f574df36$var$funcToString = $c282e350f574df36$var$funcProto.toString;
/** Used to check objects for own properties. */ var $c282e350f574df36$var$hasOwnProperty = $c282e350f574df36$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $c282e350f574df36$var$objectCtorString = $c282e350f574df36$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $c282e350f574df36$var$isPlainObject(value) {
    if (!$8JxPO(value) || $d8VrW(value) != $c282e350f574df36$var$objectTag) return false;
    var proto = $iCet7(value);
    if (proto === null) return true;
    var Ctor = $c282e350f574df36$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $c282e350f574df36$var$funcToString.call(Ctor) == $c282e350f574df36$var$objectCtorString;
}
module.exports = $c282e350f574df36$var$isPlainObject;

});
parcelRegister("iCet7", function(module, exports) {

var $fDgsE = parcelRequire("fDgsE");
/** Built-in value references. */ var $037f56b4d9fc6759$var$getPrototype = $fDgsE(Object.getPrototypeOf, Object);
module.exports = $037f56b4d9fc6759$var$getPrototype;

});


parcelRegister("lhaYx", function(module, exports) {

var $d8VrW = parcelRequire("d8VrW");

var $8JxPO = parcelRequire("8JxPO");
/** `Object#toString` result references. */ var $f7d3b2fd9cfcc4f5$var$boolTag = "[object Boolean]";
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $f7d3b2fd9cfcc4f5$var$isBoolean(value) {
    return value === true || value === false || $8JxPO(value) && $d8VrW(value) == $f7d3b2fd9cfcc4f5$var$boolTag;
}
module.exports = $f7d3b2fd9cfcc4f5$var$isBoolean;

});

parcelRegister("c238b", function(module, exports) {

$parcel$export(module.exports, "Trapezoid", function () { return $8c2819ac9e1e63fd$export$d1ed33dc592f5337; });

var $jbmdS = parcelRequire("jbmdS");

var $dWgPS = parcelRequire("dWgPS");

var $bBmgp = parcelRequire("bBmgp");

var $f06D9 = parcelRequire("f06D9");
function $8c2819ac9e1e63fd$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8c2819ac9e1e63fd$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8c2819ac9e1e63fd$var$_typeof(o);
}
function $8c2819ac9e1e63fd$var$_extends() {
    $8c2819ac9e1e63fd$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8c2819ac9e1e63fd$var$_extends.apply(this, arguments);
}
function $8c2819ac9e1e63fd$var$_slicedToArray(arr, i) {
    return $8c2819ac9e1e63fd$var$_arrayWithHoles(arr) || $8c2819ac9e1e63fd$var$_iterableToArrayLimit(arr, i) || $8c2819ac9e1e63fd$var$_unsupportedIterableToArray(arr, i) || $8c2819ac9e1e63fd$var$_nonIterableRest();
}
function $8c2819ac9e1e63fd$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8c2819ac9e1e63fd$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8c2819ac9e1e63fd$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8c2819ac9e1e63fd$var$_arrayLikeToArray(o, minLen);
}
function $8c2819ac9e1e63fd$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8c2819ac9e1e63fd$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $8c2819ac9e1e63fd$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $8c2819ac9e1e63fd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8c2819ac9e1e63fd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8c2819ac9e1e63fd$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8c2819ac9e1e63fd$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8c2819ac9e1e63fd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8c2819ac9e1e63fd$var$_defineProperty(obj, key, value) {
    key = $8c2819ac9e1e63fd$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8c2819ac9e1e63fd$var$_toPropertyKey(t) {
    var i = $8c2819ac9e1e63fd$var$_toPrimitive(t, "string");
    return "symbol" == $8c2819ac9e1e63fd$var$_typeof(i) ? i : i + "";
}
function $8c2819ac9e1e63fd$var$_toPrimitive(t, r) {
    if ("object" != $8c2819ac9e1e63fd$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $8c2819ac9e1e63fd$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $8c2819ac9e1e63fd$var$getTrapezoidPath = function getTrapezoidPath(x, y, upperWidth, lowerWidth, height) {
    var widthGap = upperWidth - lowerWidth;
    var path;
    path = "M ".concat(x, ",").concat(y);
    path += "L ".concat(x + upperWidth, ",").concat(y);
    path += "L ".concat(x + upperWidth - widthGap / 2, ",").concat(y + height);
    path += "L ".concat(x + upperWidth - widthGap / 2 - lowerWidth, ",").concat(y + height);
    path += "L ".concat(x, ",").concat(y, " Z");
    return path;
};
var $8c2819ac9e1e63fd$var$defaultProps = {
    x: 0,
    y: 0,
    upperWidth: 0,
    lowerWidth: 0,
    height: 0,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: "ease"
};
var $8c2819ac9e1e63fd$export$d1ed33dc592f5337 = function Trapezoid(props) {
    var trapezoidProps = $8c2819ac9e1e63fd$var$_objectSpread($8c2819ac9e1e63fd$var$_objectSpread({}, $8c2819ac9e1e63fd$var$defaultProps), props);
    var pathRef = (0, $jbmdS.useRef)();
    var _useState = (0, $jbmdS.useState)(-1), _useState2 = $8c2819ac9e1e63fd$var$_slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, $jbmdS.useEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = trapezoidProps.x, y = trapezoidProps.y, upperWidth = trapezoidProps.upperWidth, lowerWidth = trapezoidProps.lowerWidth, height = trapezoidProps.height, className = trapezoidProps.className;
    var animationEasing = trapezoidProps.animationEasing, animationDuration = trapezoidProps.animationDuration, animationBegin = trapezoidProps.animationBegin, isUpdateAnimationActive = trapezoidProps.isUpdateAnimationActive;
    if (x !== +x || y !== +y || upperWidth !== +upperWidth || lowerWidth !== +lowerWidth || height !== +height || upperWidth === 0 && lowerWidth === 0 || height === 0) return null;
    var layerClass = (0, $dWgPS.default)("recharts-trapezoid", className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("path", $8c2819ac9e1e63fd$var$_extends({}, (0, $f06D9.filterProps)(trapezoidProps, true), {
        className: layerClass,
        d: $8c2819ac9e1e63fd$var$getTrapezoidPath(x, y, upperWidth, lowerWidth, height)
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $bBmgp.default), {
        canBegin: totalLength > 0,
        from: {
            upperWidth: 0,
            lowerWidth: 0,
            height: height,
            x: x,
            y: y
        },
        to: {
            upperWidth: upperWidth,
            lowerWidth: lowerWidth,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currUpperWidth = _ref.upperWidth, currLowerWidth = _ref.lowerWidth, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $bBmgp.default), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            easing: animationEasing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("path", $8c2819ac9e1e63fd$var$_extends({}, (0, $f06D9.filterProps)(trapezoidProps, true), {
            className: layerClass,
            d: $8c2819ac9e1e63fd$var$getTrapezoidPath(currX, currY, currUpperWidth, currLowerWidth, currHeight),
            ref: pathRef
        })));
    });
};

});

parcelRegister("4naQZ", function(module, exports) {

$parcel$export(module.exports, "Sector", function () { return $32f1babb4d6198d0$export$e98c2c7eb2b14f45; });

var $jbmdS = parcelRequire("jbmdS");

var $dWgPS = parcelRequire("dWgPS");

var $f06D9 = parcelRequire("f06D9");

var $h7eoY = parcelRequire("h7eoY");

var $1gmrG = parcelRequire("1gmrG");
function $32f1babb4d6198d0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $32f1babb4d6198d0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $32f1babb4d6198d0$var$_typeof(o);
}
function $32f1babb4d6198d0$var$_extends() {
    $32f1babb4d6198d0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $32f1babb4d6198d0$var$_extends.apply(this, arguments);
}
function $32f1babb4d6198d0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $32f1babb4d6198d0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $32f1babb4d6198d0$var$ownKeys(Object(t), !0).forEach(function(r) {
            $32f1babb4d6198d0$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $32f1babb4d6198d0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $32f1babb4d6198d0$var$_defineProperty(obj, key, value) {
    key = $32f1babb4d6198d0$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $32f1babb4d6198d0$var$_toPropertyKey(t) {
    var i = $32f1babb4d6198d0$var$_toPrimitive(t, "string");
    return "symbol" == $32f1babb4d6198d0$var$_typeof(i) ? i : i + "";
}
function $32f1babb4d6198d0$var$_toPrimitive(t, r) {
    if ("object" != $32f1babb4d6198d0$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $32f1babb4d6198d0$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $32f1babb4d6198d0$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $1gmrG.mathSign)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
    return sign * deltaAngle;
};
var $32f1babb4d6198d0$var$getTangentCircle = function getTangentCircle(_ref) {
    var cx = _ref.cx, cy = _ref.cy, radius = _ref.radius, angle = _ref.angle, sign = _ref.sign, isExternal = _ref.isExternal, cornerRadius = _ref.cornerRadius, cornerIsExternal = _ref.cornerIsExternal;
    var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
    var theta = Math.asin(cornerRadius / centerRadius) / (0, $h7eoY.RADIAN);
    var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
    var center = (0, $h7eoY.polarToCartesian)(cx, cy, centerRadius, centerAngle);
    // The coordinate of point which is tangent to the circle
    var circleTangency = (0, $h7eoY.polarToCartesian)(cx, cy, radius, centerAngle);
    // The coordinate of point which is tangent to the radius line
    var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
    var lineTangency = (0, $h7eoY.polarToCartesian)(cx, cy, centerRadius * Math.cos(theta * (0, $h7eoY.RADIAN)), lineTangencyAngle);
    return {
        center: center,
        circleTangency: circleTangency,
        lineTangency: lineTangency,
        theta: theta
    };
};
var $32f1babb4d6198d0$var$getSectorPath = function getSectorPath(_ref2) {
    var cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var angle = $32f1babb4d6198d0$var$getDeltaAngle(startAngle, endAngle);
    // When the angle of sector equals to 360, star point and end point coincide
    var tempEndAngle = startAngle + angle;
    var outerStartPoint = (0, $h7eoY.polarToCartesian)(cx, cy, outerRadius, startAngle);
    var outerEndPoint = (0, $h7eoY.polarToCartesian)(cx, cy, outerRadius, tempEndAngle);
    var path = "M ".concat(outerStartPoint.x, ",").concat(outerStartPoint.y, "\n    A ").concat(outerRadius, ",").concat(outerRadius, ",0,\n    ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle > tempEndAngle), ",\n    ").concat(outerEndPoint.x, ",").concat(outerEndPoint.y, "\n  ");
    if (innerRadius > 0) {
        var innerStartPoint = (0, $h7eoY.polarToCartesian)(cx, cy, innerRadius, startAngle);
        var innerEndPoint = (0, $h7eoY.polarToCartesian)(cx, cy, innerRadius, tempEndAngle);
        path += "L ".concat(innerEndPoint.x, ",").concat(innerEndPoint.y, "\n            A ").concat(innerRadius, ",").concat(innerRadius, ",0,\n            ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle <= tempEndAngle), ",\n            ").concat(innerStartPoint.x, ",").concat(innerStartPoint.y, " Z");
    } else path += "L ".concat(cx, ",").concat(cy, " Z");
    return path;
};
var $32f1babb4d6198d0$var$getSectorWithCorner = function getSectorWithCorner(_ref3) {
    var cx = _ref3.cx, cy = _ref3.cy, innerRadius = _ref3.innerRadius, outerRadius = _ref3.outerRadius, cornerRadius = _ref3.cornerRadius, forceCornerRadius = _ref3.forceCornerRadius, cornerIsExternal = _ref3.cornerIsExternal, startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var sign = (0, $1gmrG.mathSign)(endAngle - startAngle);
    var _getTangentCircle = $32f1babb4d6198d0$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: startAngle,
        sign: sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), soct = _getTangentCircle.circleTangency, solt = _getTangentCircle.lineTangency, sot = _getTangentCircle.theta;
    var _getTangentCircle2 = $32f1babb4d6198d0$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: endAngle,
        sign: -sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), eoct = _getTangentCircle2.circleTangency, eolt = _getTangentCircle2.lineTangency, eot = _getTangentCircle2.theta;
    var outerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sot - eot;
    if (outerArcAngle < 0) {
        if (forceCornerRadius) return "M ".concat(solt.x, ",").concat(solt.y, "\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(cornerRadius * 2, ",0\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(-cornerRadius * 2, ",0\n      ");
        return $32f1babb4d6198d0$var$getSectorPath({
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
    }
    var path = "M ".concat(solt.x, ",").concat(solt.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(soct.x, ",").concat(soct.y, "\n    A").concat(outerRadius, ",").concat(outerRadius, ",0,").concat(+(outerArcAngle > 180), ",").concat(+(sign < 0), ",").concat(eoct.x, ",").concat(eoct.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eolt.x, ",").concat(eolt.y, "\n  ");
    if (innerRadius > 0) {
        var _getTangentCircle3 = $32f1babb4d6198d0$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: startAngle,
            sign: sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), sict = _getTangentCircle3.circleTangency, silt = _getTangentCircle3.lineTangency, sit = _getTangentCircle3.theta;
        var _getTangentCircle4 = $32f1babb4d6198d0$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: endAngle,
            sign: -sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), eict = _getTangentCircle4.circleTangency, eilt = _getTangentCircle4.lineTangency, eit = _getTangentCircle4.theta;
        var innerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sit - eit;
        if (innerArcAngle < 0 && cornerRadius === 0) return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
        path += "L".concat(eilt.x, ",").concat(eilt.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eict.x, ",").concat(eict.y, "\n      A").concat(innerRadius, ",").concat(innerRadius, ",0,").concat(+(innerArcAngle > 180), ",").concat(+(sign > 0), ",").concat(sict.x, ",").concat(sict.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(silt.x, ",").concat(silt.y, "Z");
    } else path += "L".concat(cx, ",").concat(cy, "Z");
    return path;
};
var $32f1babb4d6198d0$var$defaultProps = {
    cx: 0,
    cy: 0,
    innerRadius: 0,
    outerRadius: 0,
    startAngle: 0,
    endAngle: 0,
    cornerRadius: 0,
    forceCornerRadius: false,
    cornerIsExternal: false
};
var $32f1babb4d6198d0$export$e98c2c7eb2b14f45 = function Sector(sectorProps) {
    var props = $32f1babb4d6198d0$var$_objectSpread($32f1babb4d6198d0$var$_objectSpread({}, $32f1babb4d6198d0$var$defaultProps), sectorProps);
    var cx = props.cx, cy = props.cy, innerRadius = props.innerRadius, outerRadius = props.outerRadius, cornerRadius = props.cornerRadius, forceCornerRadius = props.forceCornerRadius, cornerIsExternal = props.cornerIsExternal, startAngle = props.startAngle, endAngle = props.endAngle, className = props.className;
    if (outerRadius < innerRadius || startAngle === endAngle) return null;
    var layerClass = (0, $dWgPS.default)("recharts-sector", className);
    var deltaRadius = outerRadius - innerRadius;
    var cr = (0, $1gmrG.getPercentValue)(cornerRadius, deltaRadius, 0, true);
    var path;
    if (cr > 0 && Math.abs(startAngle - endAngle) < 360) path = $32f1babb4d6198d0$var$getSectorWithCorner({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        cornerRadius: Math.min(cr, deltaRadius / 2),
        forceCornerRadius: forceCornerRadius,
        cornerIsExternal: cornerIsExternal,
        startAngle: startAngle,
        endAngle: endAngle
    });
    else path = $32f1babb4d6198d0$var$getSectorPath({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        startAngle: startAngle,
        endAngle: endAngle
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("path", $32f1babb4d6198d0$var$_extends({}, (0, $f06D9.filterProps)(props, true), {
        className: layerClass,
        d: path,
        role: "img"
    }));
};

});






parcelRegister("8tls9", function(module, exports) {

$parcel$export(module.exports, "ReferenceLine", function () { return $62b1ac4b9fec944b$export$b2f28e248e7838eb; });

var $jbmdS = parcelRequire("jbmdS");

var $i99FY = parcelRequire("i99FY");

var $7yCQ1 = parcelRequire("7yCQ1");

var $dWgPS = parcelRequire("dWgPS");

var $bIYfh = parcelRequire("bIYfh");

var $eGPJt = parcelRequire("eGPJt");

var $a7iOf = parcelRequire("a7iOf");

var $1gmrG = parcelRequire("1gmrG");

var $eZuTD = parcelRequire("eZuTD");

var $aOmiF = parcelRequire("aOmiF");

var $f06D9 = parcelRequire("f06D9");

var $jgA03 = parcelRequire("jgA03");
function $62b1ac4b9fec944b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $62b1ac4b9fec944b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $62b1ac4b9fec944b$var$_typeof(o);
}
function $62b1ac4b9fec944b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $62b1ac4b9fec944b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $62b1ac4b9fec944b$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $62b1ac4b9fec944b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $62b1ac4b9fec944b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $62b1ac4b9fec944b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $62b1ac4b9fec944b$var$_callSuper(t, o, e) {
    return o = $62b1ac4b9fec944b$var$_getPrototypeOf(o), $62b1ac4b9fec944b$var$_possibleConstructorReturn(t, $62b1ac4b9fec944b$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $62b1ac4b9fec944b$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $62b1ac4b9fec944b$var$_possibleConstructorReturn(self, call) {
    if (call && ($62b1ac4b9fec944b$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $62b1ac4b9fec944b$var$_assertThisInitialized(self);
}
function $62b1ac4b9fec944b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $62b1ac4b9fec944b$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($62b1ac4b9fec944b$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $62b1ac4b9fec944b$var$_getPrototypeOf(o) {
    $62b1ac4b9fec944b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $62b1ac4b9fec944b$var$_getPrototypeOf(o);
}
function $62b1ac4b9fec944b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $62b1ac4b9fec944b$var$_setPrototypeOf(subClass, superClass);
}
function $62b1ac4b9fec944b$var$_setPrototypeOf(o, p) {
    $62b1ac4b9fec944b$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $62b1ac4b9fec944b$var$_setPrototypeOf(o, p);
}
function $62b1ac4b9fec944b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $62b1ac4b9fec944b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $62b1ac4b9fec944b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $62b1ac4b9fec944b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $62b1ac4b9fec944b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $62b1ac4b9fec944b$var$_defineProperty(obj, key, value) {
    key = $62b1ac4b9fec944b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $62b1ac4b9fec944b$var$_toPropertyKey(t) {
    var i = $62b1ac4b9fec944b$var$_toPrimitive(t, "string");
    return "symbol" == $62b1ac4b9fec944b$var$_typeof(i) ? i : i + "";
}
function $62b1ac4b9fec944b$var$_toPrimitive(t, r) {
    if ("object" != $62b1ac4b9fec944b$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $62b1ac4b9fec944b$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $62b1ac4b9fec944b$var$_slicedToArray(arr, i) {
    return $62b1ac4b9fec944b$var$_arrayWithHoles(arr) || $62b1ac4b9fec944b$var$_iterableToArrayLimit(arr, i) || $62b1ac4b9fec944b$var$_unsupportedIterableToArray(arr, i) || $62b1ac4b9fec944b$var$_nonIterableRest();
}
function $62b1ac4b9fec944b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $62b1ac4b9fec944b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $62b1ac4b9fec944b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $62b1ac4b9fec944b$var$_arrayLikeToArray(o, minLen);
}
function $62b1ac4b9fec944b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $62b1ac4b9fec944b$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $62b1ac4b9fec944b$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $62b1ac4b9fec944b$var$_extends() {
    $62b1ac4b9fec944b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $62b1ac4b9fec944b$var$_extends.apply(this, arguments);
}
/**
 * This excludes `viewBox` prop from svg for two reasons:
 * 1. The components wants viewBox of object type, and svg wants string
 *    - so there's a conflict, and the component will throw if it gets string
 * 2. Internally the component calls `filterProps` which filters the viewBox away anyway
 */ var $62b1ac4b9fec944b$var$renderLine = function renderLine(option, props) {
    var line;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).isValidElement(option)) line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(option)) line = option(props);
    else line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("line", $62b1ac4b9fec944b$var$_extends({}, props, {
        className: "recharts-reference-line-line"
    }));
    return line;
};
var $62b1ac4b9fec944b$export$f273d496b213b6da = function getEndPoints(scales, isFixedX, isFixedY, isSegment, viewBox, position, xAxisOrientation, yAxisOrientation, props) {
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    if (isFixedY) {
        var yCoord = props.y;
        var coord = scales.y.apply(yCoord, {
            position: position
        });
        if ((0, $a7iOf.ifOverflowMatches)(props, "discard") && !scales.y.isInRange(coord)) return null;
        var points = [
            {
                x: x + width,
                y: coord
            },
            {
                x: x,
                y: coord
            }
        ];
        return yAxisOrientation === "left" ? points.reverse() : points;
    }
    if (isFixedX) {
        var xCoord = props.x;
        var _coord = scales.x.apply(xCoord, {
            position: position
        });
        if ((0, $a7iOf.ifOverflowMatches)(props, "discard") && !scales.x.isInRange(_coord)) return null;
        var _points = [
            {
                x: _coord,
                y: y + height
            },
            {
                x: _coord,
                y: y
            }
        ];
        return xAxisOrientation === "top" ? _points.reverse() : _points;
    }
    if (isSegment) {
        var segment = props.segment;
        var _points2 = segment.map(function(p) {
            return scales.apply(p, {
                position: position
            });
        });
        if ((0, $a7iOf.ifOverflowMatches)(props, "discard") && (0, (/*@__PURE__*/$parcel$interopDefault($7yCQ1)))(_points2, function(p) {
            return !scales.isInRange(p);
        })) return null;
        return _points2;
    }
    return null;
};
function $62b1ac4b9fec944b$var$ReferenceLineImpl(props) {
    var fixedX = props.x, fixedY = props.y, segment = props.segment, xAxisId = props.xAxisId, yAxisId = props.yAxisId, shape = props.shape, className = props.className, alwaysShow = props.alwaysShow;
    var clipPathId = (0, $jgA03.useClipPathId)();
    var xAxis = (0, $jgA03.useXAxisOrThrow)(xAxisId);
    var yAxis = (0, $jgA03.useYAxisOrThrow)(yAxisId);
    var viewBox = (0, $jgA03.useViewBox)();
    if (!clipPathId || !viewBox) return null;
    (0, $aOmiF.warn)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var scales = (0, $eZuTD.createLabeledScales)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var isX = (0, $1gmrG.isNumOrStr)(fixedX);
    var isY = (0, $1gmrG.isNumOrStr)(fixedY);
    var isSegment = segment && segment.length === 2;
    var endPoints = $62b1ac4b9fec944b$export$f273d496b213b6da(scales, isX, isY, isSegment, viewBox, props.position, xAxis.orientation, yAxis.orientation, props);
    if (!endPoints) return null;
    var _endPoints = $62b1ac4b9fec944b$var$_slicedToArray(endPoints, 2), _endPoints$ = _endPoints[0], x1 = _endPoints$.x, y1 = _endPoints$.y, _endPoints$2 = _endPoints[1], x2 = _endPoints$2.x, y2 = _endPoints$2.y;
    var clipPath = (0, $a7iOf.ifOverflowMatches)(props, "hidden") ? "url(#".concat(clipPathId, ")") : undefined;
    var lineProps = $62b1ac4b9fec944b$var$_objectSpread($62b1ac4b9fec944b$var$_objectSpread({
        clipPath: clipPath
    }, (0, $f06D9.filterProps)(props, true)), {}, {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $bIYfh.Layer), {
        className: (0, $dWgPS.default)("recharts-reference-line", className)
    }, $62b1ac4b9fec944b$var$renderLine(shape, lineProps), (0, $eGPJt.Label).renderCallByParent(props, (0, $eZuTD.rectWithCoords)({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    })));
}
var $62b1ac4b9fec944b$export$b2f28e248e7838eb = /*#__PURE__*/ function(_React$Component) {
    function ReferenceLine() {
        $62b1ac4b9fec944b$var$_classCallCheck(this, ReferenceLine);
        return $62b1ac4b9fec944b$var$_callSuper(this, ReferenceLine, arguments);
    }
    $62b1ac4b9fec944b$var$_inherits(ReferenceLine, _React$Component);
    return $62b1ac4b9fec944b$var$_createClass(ReferenceLine, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($62b1ac4b9fec944b$var$ReferenceLineImpl, this.props);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).Component);
$62b1ac4b9fec944b$var$_defineProperty($62b1ac4b9fec944b$export$b2f28e248e7838eb, "displayName", "ReferenceLine");
$62b1ac4b9fec944b$var$_defineProperty($62b1ac4b9fec944b$export$b2f28e248e7838eb, "defaultProps", {
    isFront: false,
    ifOverflow: "discard",
    xAxisId: 0,
    yAxisId: 0,
    fill: "none",
    stroke: "#ccc",
    fillOpacity: 1,
    strokeWidth: 1,
    position: "middle"
});

});
parcelRegister("7yCQ1", function(module, exports) {

var $gQRXj = parcelRequire("gQRXj");

var $15GS2 = parcelRequire("15GS2");

var $T4dHz = parcelRequire("T4dHz");

var $687Zl = parcelRequire("687Zl");

var $6PImS = parcelRequire("6PImS");
/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $5809d5cdf0e57cb1$var$some(collection, predicate, guard) {
    var func = $687Zl(collection) ? $gQRXj : $T4dHz;
    if (guard && $6PImS(collection, predicate, guard)) predicate = undefined;
    return func(collection, $15GS2(predicate, 3));
}
module.exports = $5809d5cdf0e57cb1$var$some;

});
parcelRegister("T4dHz", function(module, exports) {

var $hQ9aw = parcelRequire("hQ9aw");
/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $0a58692c03f16245$var$baseSome(collection, predicate) {
    var result;
    $hQ9aw(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
module.exports = $0a58692c03f16245$var$baseSome;

});


parcelRegister("jgA03", function(module, exports) {

$parcel$export(module.exports, "ChartLayoutContextProvider", function () { return $e06b6fc8040b7549$export$e22c0f72c980af5a; });
$parcel$export(module.exports, "useClipPathId", function () { return $e06b6fc8040b7549$export$71e825c43eae6ca6; });
$parcel$export(module.exports, "useXAxisOrThrow", function () { return $e06b6fc8040b7549$export$54f54805c81085c5; });
$parcel$export(module.exports, "useArbitraryXAxis", function () { return $e06b6fc8040b7549$export$1d855c2865750a72; });
$parcel$export(module.exports, "useYAxisWithFiniteDomainOrRandom", function () { return $e06b6fc8040b7549$export$631ee617f1052e16; });
$parcel$export(module.exports, "useYAxisOrThrow", function () { return $e06b6fc8040b7549$export$6f8958021ad81c20; });
$parcel$export(module.exports, "useViewBox", function () { return $e06b6fc8040b7549$export$76b29bb074e0c45a; });
$parcel$export(module.exports, "useOffset", function () { return $e06b6fc8040b7549$export$99e5207fa7e69f17; });
$parcel$export(module.exports, "useChartWidth", function () { return $e06b6fc8040b7549$export$8854f7ece606854b; });
$parcel$export(module.exports, "useChartHeight", function () { return $e06b6fc8040b7549$export$369ae257969c6f9f; });

var $jbmdS = parcelRequire("jbmdS");

var $9GFyS = parcelRequire("9GFyS");

var $k4Uqj = parcelRequire("k4Uqj");

var $6O6hA = parcelRequire("6O6hA");

var $3mfYw = parcelRequire("3mfYw");

var $1gmrG = parcelRequire("1gmrG");
function $e06b6fc8040b7549$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e06b6fc8040b7549$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e06b6fc8040b7549$var$_typeof(o);
}
var $e06b6fc8040b7549$export$92c2a2c8239475bf = /*#__PURE__*/ (0, $jbmdS.createContext)(undefined);
var $e06b6fc8040b7549$export$40ceabe61e17c4dc = /*#__PURE__*/ (0, $jbmdS.createContext)(undefined);
var $e06b6fc8040b7549$export$29b7735f8b5653b2 = /*#__PURE__*/ (0, $jbmdS.createContext)(undefined);
var $e06b6fc8040b7549$export$482c85f2026f212e = /*#__PURE__*/ (0, $jbmdS.createContext)({});
var $e06b6fc8040b7549$export$e42cfe3f3988c70f = /*#__PURE__*/ (0, $jbmdS.createContext)(undefined);
var $e06b6fc8040b7549$export$b18854f928720bc8 = /*#__PURE__*/ (0, $jbmdS.createContext)(0);
var $e06b6fc8040b7549$export$3c3f0c9338cf7530 = /*#__PURE__*/ (0, $jbmdS.createContext)(0);
var $e06b6fc8040b7549$export$e22c0f72c980af5a = function ChartLayoutContextProvider(props) {
    var _props$state = props.state, xAxisMap = _props$state.xAxisMap, yAxisMap = _props$state.yAxisMap, offset = _props$state.offset, clipPathId = props.clipPathId, children = props.children, width = props.width, height = props.height;
    /**
   * Perhaps we should compute this property when reading? Let's see what is more often used
   */ var viewBox = (0, $3mfYw.calculateViewBox)(offset);
    /*
   * This pretends to be a single context but actually is split into multiple smaller ones.
   * Why?
   * Because one React Context only allows to set one value.
   * But we need to set multiple values.
   * If we do that with one context, then we force re-render on components that might not even be interested
   * in the part of the state that has changed.
   *
   * By splitting into smaller contexts, we allow each components to be optimized and only re-render when its dependencies change.
   *
   * To actually achieve the optimal re-render, it is necessary to use React.memo().
   * See the test file for details.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($e06b6fc8040b7549$export$92c2a2c8239475bf.Provider, {
        value: xAxisMap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($e06b6fc8040b7549$export$40ceabe61e17c4dc.Provider, {
        value: yAxisMap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($e06b6fc8040b7549$export$482c85f2026f212e.Provider, {
        value: offset
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($e06b6fc8040b7549$export$29b7735f8b5653b2.Provider, {
        value: viewBox
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($e06b6fc8040b7549$export$e42cfe3f3988c70f.Provider, {
        value: clipPathId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($e06b6fc8040b7549$export$b18854f928720bc8.Provider, {
        value: height
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($e06b6fc8040b7549$export$3c3f0c9338cf7530.Provider, {
        value: width
    }, children)))))));
};
var $e06b6fc8040b7549$export$71e825c43eae6ca6 = function useClipPathId() {
    return (0, $jbmdS.useContext)($e06b6fc8040b7549$export$e42cfe3f3988c70f);
};
function $e06b6fc8040b7549$var$getKeysForDebug(object) {
    var keys = Object.keys(object);
    if (keys.length === 0) return "There are no available ids.";
    return "Available ids are: ".concat(keys, ".");
}
var $e06b6fc8040b7549$export$54f54805c81085c5 = function useXAxisOrThrow(xAxisId) {
    var xAxisMap = (0, $jbmdS.useContext)($e06b6fc8040b7549$export$92c2a2c8239475bf);
    !(xAxisMap != null) && (0, $9GFyS.default)(false);
    var xAxis = xAxisMap[xAxisId];
    !(xAxis != null) && (0, $9GFyS.default)(false);
    return xAxis;
};
var $e06b6fc8040b7549$export$1d855c2865750a72 = function useArbitraryXAxis() {
    var xAxisMap = (0, $jbmdS.useContext)($e06b6fc8040b7549$export$92c2a2c8239475bf);
    return (0, $1gmrG.getAnyElementOfObject)(xAxisMap);
};
var $e06b6fc8040b7549$export$a691147b33d52613 = function useArbitraryYAxis() {
    var yAxisMap = (0, $jbmdS.useContext)($e06b6fc8040b7549$export$40ceabe61e17c4dc);
    return (0, $1gmrG.getAnyElementOfObject)(yAxisMap);
};
var $e06b6fc8040b7549$export$631ee617f1052e16 = function useYAxisWithFiniteDomainOrRandom() {
    var yAxisMap = (0, $jbmdS.useContext)($e06b6fc8040b7549$export$40ceabe61e17c4dc);
    var yAxisWithFiniteDomain = (0, (/*@__PURE__*/$parcel$interopDefault($k4Uqj)))(yAxisMap, function(axis) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($6O6hA)))(axis.domain, Number.isFinite);
    });
    return yAxisWithFiniteDomain || (0, $1gmrG.getAnyElementOfObject)(yAxisMap);
};
var $e06b6fc8040b7549$export$6f8958021ad81c20 = function useYAxisOrThrow(yAxisId) {
    var yAxisMap = (0, $jbmdS.useContext)($e06b6fc8040b7549$export$40ceabe61e17c4dc);
    !(yAxisMap != null) && (0, $9GFyS.default)(false);
    var yAxis = yAxisMap[yAxisId];
    !(yAxis != null) && (0, $9GFyS.default)(false);
    return yAxis;
};
var $e06b6fc8040b7549$export$76b29bb074e0c45a = function useViewBox() {
    var viewBox = (0, $jbmdS.useContext)($e06b6fc8040b7549$export$29b7735f8b5653b2);
    return viewBox;
};
var $e06b6fc8040b7549$export$99e5207fa7e69f17 = function useOffset() {
    return (0, $jbmdS.useContext)($e06b6fc8040b7549$export$482c85f2026f212e);
};
var $e06b6fc8040b7549$export$8854f7ece606854b = function useChartWidth() {
    return (0, $jbmdS.useContext)($e06b6fc8040b7549$export$3c3f0c9338cf7530);
};
var $e06b6fc8040b7549$export$369ae257969c6f9f = function useChartHeight() {
    return (0, $jbmdS.useContext)($e06b6fc8040b7549$export$b18854f928720bc8);
};

});
parcelRegister("k4Uqj", function(module, exports) {

var $luuJe = parcelRequire("luuJe");

var $c1HeC = parcelRequire("c1HeC");
/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $e9dff2e1f48a3ee3$var$find = $luuJe($c1HeC);
module.exports = $e9dff2e1f48a3ee3$var$find;

});
parcelRegister("luuJe", function(module, exports) {

var $15GS2 = parcelRequire("15GS2");

var $5KNSm = parcelRequire("5KNSm");

var $lVjOx = parcelRequire("lVjOx");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $fa543c58614096f2$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$5KNSm(collection)) {
            var iteratee = $15GS2(predicate, 3);
            collection = $lVjOx(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $fa543c58614096f2$var$createFind;

});

parcelRegister("c1HeC", function(module, exports) {

var $7vcAM = parcelRequire("7vcAM");

var $15GS2 = parcelRequire("15GS2");

var $aVXn7 = parcelRequire("aVXn7");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $8c171d8f3dba2066$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $8c171d8f3dba2066$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $aVXn7(fromIndex);
    if (index < 0) index = $8c171d8f3dba2066$var$nativeMax(length + index, 0);
    return $7vcAM(array, $15GS2(predicate, 3), index);
}
module.exports = $8c171d8f3dba2066$var$findIndex;

});
parcelRegister("aVXn7", function(module, exports) {

var $4NqFj = parcelRequire("4NqFj");
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $7f5d4846f8f2ce90$var$toInteger(value) {
    var result = $4NqFj(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
module.exports = $7f5d4846f8f2ce90$var$toInteger;

});



parcelRegister("3mfYw", function(module, exports) {

$parcel$export(module.exports, "calculateViewBox", function () { return $271fd18134569508$export$7e29f973febe72ad; });

var $eBB0l = parcelRequire("eBB0l");
var $271fd18134569508$export$7e29f973febe72ad = (0, (/*@__PURE__*/$parcel$interopDefault($eBB0l)))(function(offset) {
    return {
        x: offset.left,
        y: offset.top,
        width: offset.width,
        height: offset.height
    };
}, function(offset) {
    return [
        "l",
        offset.left,
        "t",
        offset.top,
        "w",
        offset.width,
        "h",
        offset.height
    ].join("");
});

});



parcelRegister("eYU3i", function(module, exports) {

$parcel$export(module.exports, "ReferenceArea", function () { return $ae822610cb519eb6$export$b4ec4f050ce240b9; });

var $jbmdS = parcelRequire("jbmdS");

var $i99FY = parcelRequire("i99FY");

var $dWgPS = parcelRequire("dWgPS");

var $bIYfh = parcelRequire("bIYfh");

var $eGPJt = parcelRequire("eGPJt");

var $eZuTD = parcelRequire("eZuTD");

var $a7iOf = parcelRequire("a7iOf");

var $1gmrG = parcelRequire("1gmrG");

var $aOmiF = parcelRequire("aOmiF");

var $DN6Qj = parcelRequire("DN6Qj");

var $f06D9 = parcelRequire("f06D9");
function $ae822610cb519eb6$var$_extends() {
    $ae822610cb519eb6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ae822610cb519eb6$var$_extends.apply(this, arguments);
}
function $ae822610cb519eb6$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ae822610cb519eb6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ae822610cb519eb6$var$_typeof(o);
}
function $ae822610cb519eb6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ae822610cb519eb6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ae822610cb519eb6$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ae822610cb519eb6$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ae822610cb519eb6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ae822610cb519eb6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ae822610cb519eb6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $ae822610cb519eb6$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $ae822610cb519eb6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ae822610cb519eb6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ae822610cb519eb6$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $ae822610cb519eb6$var$_callSuper(t, o, e) {
    return o = $ae822610cb519eb6$var$_getPrototypeOf(o), $ae822610cb519eb6$var$_possibleConstructorReturn(t, $ae822610cb519eb6$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $ae822610cb519eb6$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $ae822610cb519eb6$var$_possibleConstructorReturn(self, call) {
    if (call && ($ae822610cb519eb6$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $ae822610cb519eb6$var$_assertThisInitialized(self);
}
function $ae822610cb519eb6$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $ae822610cb519eb6$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ae822610cb519eb6$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $ae822610cb519eb6$var$_getPrototypeOf(o) {
    $ae822610cb519eb6$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ae822610cb519eb6$var$_getPrototypeOf(o);
}
function $ae822610cb519eb6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $ae822610cb519eb6$var$_setPrototypeOf(subClass, superClass);
}
function $ae822610cb519eb6$var$_setPrototypeOf(o, p) {
    $ae822610cb519eb6$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ae822610cb519eb6$var$_setPrototypeOf(o, p);
}
function $ae822610cb519eb6$var$_defineProperty(obj, key, value) {
    key = $ae822610cb519eb6$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ae822610cb519eb6$var$_toPropertyKey(t) {
    var i = $ae822610cb519eb6$var$_toPrimitive(t, "string");
    return "symbol" == $ae822610cb519eb6$var$_typeof(i) ? i : i + "";
}
function $ae822610cb519eb6$var$_toPrimitive(t, r) {
    if ("object" != $ae822610cb519eb6$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ae822610cb519eb6$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $ae822610cb519eb6$var$getRect = function getRect(hasX1, hasX2, hasY1, hasY2, props) {
    var xValue1 = props.x1, xValue2 = props.x2, yValue1 = props.y1, yValue2 = props.y2, xAxis = props.xAxis, yAxis = props.yAxis;
    if (!xAxis || !yAxis) return null;
    var scales = (0, $eZuTD.createLabeledScales)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var p1 = {
        x: hasX1 ? scales.x.apply(xValue1, {
            position: "start"
        }) : scales.x.rangeMin,
        y: hasY1 ? scales.y.apply(yValue1, {
            position: "start"
        }) : scales.y.rangeMin
    };
    var p2 = {
        x: hasX2 ? scales.x.apply(xValue2, {
            position: "end"
        }) : scales.x.rangeMax,
        y: hasY2 ? scales.y.apply(yValue2, {
            position: "end"
        }) : scales.y.rangeMax
    };
    if ((0, $a7iOf.ifOverflowMatches)(props, "discard") && (!scales.isInRange(p1) || !scales.isInRange(p2))) return null;
    return (0, $eZuTD.rectWithPoints)(p1, p2);
};
var $ae822610cb519eb6$export$b4ec4f050ce240b9 = /*#__PURE__*/ function(_React$Component) {
    function ReferenceArea() {
        $ae822610cb519eb6$var$_classCallCheck(this, ReferenceArea);
        return $ae822610cb519eb6$var$_callSuper(this, ReferenceArea, arguments);
    }
    $ae822610cb519eb6$var$_inherits(ReferenceArea, _React$Component);
    return $ae822610cb519eb6$var$_createClass(ReferenceArea, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, x1 = _this$props.x1, x2 = _this$props.x2, y1 = _this$props.y1, y2 = _this$props.y2, className = _this$props.className, alwaysShow = _this$props.alwaysShow, clipPathId = _this$props.clipPathId;
                (0, $aOmiF.warn)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
                var hasX1 = (0, $1gmrG.isNumOrStr)(x1);
                var hasX2 = (0, $1gmrG.isNumOrStr)(x2);
                var hasY1 = (0, $1gmrG.isNumOrStr)(y1);
                var hasY2 = (0, $1gmrG.isNumOrStr)(y2);
                var shape = this.props.shape;
                if (!hasX1 && !hasX2 && !hasY1 && !hasY2 && !shape) return null;
                var rect = $ae822610cb519eb6$var$getRect(hasX1, hasX2, hasY1, hasY2, this.props);
                if (!rect && !shape) return null;
                var clipPath = (0, $a7iOf.ifOverflowMatches)(this.props, "hidden") ? "url(#".concat(clipPathId, ")") : undefined;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $bIYfh.Layer), {
                    className: (0, $dWgPS.default)("recharts-reference-area", className)
                }, ReferenceArea.renderRect(shape, $ae822610cb519eb6$var$_objectSpread($ae822610cb519eb6$var$_objectSpread({
                    clipPath: clipPath
                }, (0, $f06D9.filterProps)(this.props, true)), rect)), (0, $eGPJt.Label).renderCallByParent(this.props, rect));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).Component);
$ae822610cb519eb6$var$_defineProperty($ae822610cb519eb6$export$b4ec4f050ce240b9, "displayName", "ReferenceArea");
$ae822610cb519eb6$var$_defineProperty($ae822610cb519eb6$export$b4ec4f050ce240b9, "defaultProps", {
    isFront: false,
    ifOverflow: "discard",
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: "#ccc",
    fillOpacity: 0.5,
    stroke: "none",
    strokeWidth: 1
});
$ae822610cb519eb6$var$_defineProperty($ae822610cb519eb6$export$b4ec4f050ce240b9, "renderRect", function(option, props) {
    var rect;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).isValidElement(option)) rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(option)) rect = option(props);
    else rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $DN6Qj.Rectangle), $ae822610cb519eb6$var$_extends({}, props, {
        className: "recharts-reference-area-rect"
    }));
    return rect;
});

});


parcelRegister("j2HEf", function(module, exports) {

$parcel$export(module.exports, "eventCenter", function () { return $ddd00fd55be676db$export$9bcdfe5f29bb33; });
$parcel$export(module.exports, "SYNC_EVENT", function () { return $ddd00fd55be676db$export$ff9a08f6d0c38b8f; });

var $1DflU = parcelRequire("1DflU");
var $ddd00fd55be676db$export$9bcdfe5f29bb33 = new (0, (/*@__PURE__*/$parcel$interopDefault($1DflU)))();
var $ddd00fd55be676db$export$ff9a08f6d0c38b8f = "recharts.syncMouseEvents";

});
parcelRegister("1DflU", function(module, exports) {
"use strict";
var $130557a60aa3642b$var$has = Object.prototype.hasOwnProperty, $130557a60aa3642b$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $130557a60aa3642b$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $130557a60aa3642b$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $130557a60aa3642b$var$Events().__proto__) $130557a60aa3642b$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $130557a60aa3642b$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $130557a60aa3642b$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $130557a60aa3642b$var$EE(fn, context || emitter, once), evt = $130557a60aa3642b$var$prefix ? $130557a60aa3642b$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $130557a60aa3642b$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $130557a60aa3642b$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $130557a60aa3642b$var$EventEmitter() {
    this._events = new $130557a60aa3642b$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $130557a60aa3642b$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($130557a60aa3642b$var$has.call(events, name)) names.push($130557a60aa3642b$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $130557a60aa3642b$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $130557a60aa3642b$var$prefix ? $130557a60aa3642b$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $130557a60aa3642b$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $130557a60aa3642b$var$prefix ? $130557a60aa3642b$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $130557a60aa3642b$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $130557a60aa3642b$var$prefix ? $130557a60aa3642b$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $130557a60aa3642b$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $130557a60aa3642b$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $130557a60aa3642b$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $130557a60aa3642b$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $130557a60aa3642b$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $130557a60aa3642b$var$prefix ? $130557a60aa3642b$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $130557a60aa3642b$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $130557a60aa3642b$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $130557a60aa3642b$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $130557a60aa3642b$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $130557a60aa3642b$var$prefix ? $130557a60aa3642b$var$prefix + event : event;
        if (this._events[evt]) $130557a60aa3642b$var$clearEvent(this, evt);
    } else {
        this._events = new $130557a60aa3642b$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$130557a60aa3642b$var$EventEmitter.prototype.off = $130557a60aa3642b$var$EventEmitter.prototype.removeListener;
$130557a60aa3642b$var$EventEmitter.prototype.addListener = $130557a60aa3642b$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$130557a60aa3642b$var$EventEmitter.prefixed = $130557a60aa3642b$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$130557a60aa3642b$var$EventEmitter.EventEmitter = $130557a60aa3642b$var$EventEmitter;
module.exports = $130557a60aa3642b$var$EventEmitter;

});


parcelRegister("gL1qG", function(module, exports) {

$parcel$export(module.exports, "AccessibilityManager", function () { return $c33224f30cca628a$export$a2c2de1efa8671eb; });
function $c33224f30cca628a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c33224f30cca628a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c33224f30cca628a$var$_typeof(o);
}
function $c33224f30cca628a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c33224f30cca628a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c33224f30cca628a$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c33224f30cca628a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c33224f30cca628a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c33224f30cca628a$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c33224f30cca628a$var$_defineProperty(obj, key, value) {
    key = $c33224f30cca628a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c33224f30cca628a$var$_toPropertyKey(t) {
    var i = $c33224f30cca628a$var$_toPrimitive(t, "string");
    return "symbol" == $c33224f30cca628a$var$_typeof(i) ? i : i + "";
}
function $c33224f30cca628a$var$_toPrimitive(t, r) {
    if ("object" != $c33224f30cca628a$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $c33224f30cca628a$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $c33224f30cca628a$export$a2c2de1efa8671eb = /*#__PURE__*/ function() {
    function AccessibilityManager() {
        $c33224f30cca628a$var$_classCallCheck(this, AccessibilityManager);
        $c33224f30cca628a$var$_defineProperty(this, "activeIndex", 0);
        $c33224f30cca628a$var$_defineProperty(this, "coordinateList", []);
        $c33224f30cca628a$var$_defineProperty(this, "layout", "horizontal");
    }
    return $c33224f30cca628a$var$_createClass(AccessibilityManager, [
        {
            key: "setDetails",
            value: function setDetails(_ref) {
                var _ref2;
                var _ref$coordinateList = _ref.coordinateList, coordinateList = _ref$coordinateList === void 0 ? null : _ref$coordinateList, _ref$container = _ref.container, container = _ref$container === void 0 ? null : _ref$container, _ref$layout = _ref.layout, layout = _ref$layout === void 0 ? null : _ref$layout, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? null : _ref$offset, _ref$mouseHandlerCall = _ref.mouseHandlerCallback, mouseHandlerCallback = _ref$mouseHandlerCall === void 0 ? null : _ref$mouseHandlerCall;
                this.coordinateList = (_ref2 = coordinateList !== null && coordinateList !== void 0 ? coordinateList : this.coordinateList) !== null && _ref2 !== void 0 ? _ref2 : [];
                this.container = container !== null && container !== void 0 ? container : this.container;
                this.layout = layout !== null && layout !== void 0 ? layout : this.layout;
                this.offset = offset !== null && offset !== void 0 ? offset : this.offset;
                this.mouseHandlerCallback = mouseHandlerCallback !== null && mouseHandlerCallback !== void 0 ? mouseHandlerCallback : this.mouseHandlerCallback;
                // Keep activeIndex in the bounds between 0 and the last coordinate index
                this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.spoofMouse();
            }
        },
        {
            key: "keyboardEvent",
            value: function keyboardEvent(e) {
                // The AccessibilityManager relies on the Tooltip component. When tooltips suddenly stop existing,
                // it can cause errors. We use this function to check. We don't want arrow keys to be processed
                // if there are no tooltips, since that will cause unexpected behavior of users.
                if (this.coordinateList.length === 0) return;
                switch(e.key){
                    case "ArrowRight":
                        if (this.layout !== "horizontal") return;
                        this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1);
                        this.spoofMouse();
                        break;
                    case "ArrowLeft":
                        if (this.layout !== "horizontal") return;
                        this.activeIndex = Math.max(this.activeIndex - 1, 0);
                        this.spoofMouse();
                        break;
                    default:
                        break;
                }
            }
        },
        {
            key: "setIndex",
            value: function setIndex(newIndex) {
                this.activeIndex = newIndex;
            }
        },
        {
            key: "spoofMouse",
            value: function spoofMouse() {
                var _window, _window2;
                if (this.layout !== "horizontal") return;
                // This can happen when the tooltips suddenly stop existing as children of the component
                // That update doesn't otherwise fire events, so we have to double check here.
                if (this.coordinateList.length === 0) return;
                var _this$container$getBo = this.container.getBoundingClientRect(), x = _this$container$getBo.x, y = _this$container$getBo.y, height = _this$container$getBo.height;
                var coordinate = this.coordinateList[this.activeIndex].coordinate;
                var scrollOffsetX = ((_window = window) === null || _window === void 0 ? void 0 : _window.scrollX) || 0;
                var scrollOffsetY = ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.scrollY) || 0;
                var pageX = x + coordinate + scrollOffsetX;
                var pageY = y + this.offset.top + height / 2 + scrollOffsetY;
                this.mouseHandlerCallback({
                    pageX: pageX,
                    pageY: pageY
                });
            }
        }
    ]);
}();

});

parcelRegister("aGXRe", function(module, exports) {

$parcel$export(module.exports, "isDomainSpecifiedByUser", function () { return $7c8c4218b3490819$export$33279f645a5831b7; });

var $1gmrG = parcelRequire("1gmrG");
function $7c8c4218b3490819$export$33279f645a5831b7(domain, allowDataOverflow, axisType) {
    if (axisType === "number" && allowDataOverflow === true && Array.isArray(domain)) {
        var domainStart = domain === null || domain === void 0 ? void 0 : domain[0];
        var domainEnd = domain === null || domain === void 0 ? void 0 : domain[1];
        /*
     * The `isNumber` check is needed because the user could also provide strings like "dataMin" via the domain props.
     * In such case, we have to compute the domain from the data.
     */ if (!!domainStart && !!domainEnd && (0, $1gmrG.isNumber)(domainStart) && (0, $1gmrG.isNumber)(domainEnd)) return true;
    }
    return false;
}

});

parcelRegister("1Co4M", function(module, exports) {

$parcel$export(module.exports, "Cursor", function () { return $12dc041033145dce$export$b6a79797ad180576; });

var $jbmdS = parcelRequire("jbmdS");

var $dWgPS = parcelRequire("dWgPS");

var $1JINr = parcelRequire("1JINr");

var $4IwdC = parcelRequire("4IwdC");

var $87DYb = parcelRequire("87DYb");

var $DN6Qj = parcelRequire("DN6Qj");

var $b0gSF = parcelRequire("b0gSF");

var $4naQZ = parcelRequire("4naQZ");

var $g9hWG = parcelRequire("g9hWG");

var $f06D9 = parcelRequire("f06D9");
function $12dc041033145dce$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $12dc041033145dce$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $12dc041033145dce$var$_typeof(o);
}
function $12dc041033145dce$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $12dc041033145dce$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $12dc041033145dce$var$ownKeys(Object(t), !0).forEach(function(r) {
            $12dc041033145dce$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $12dc041033145dce$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $12dc041033145dce$var$_defineProperty(obj, key, value) {
    key = $12dc041033145dce$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $12dc041033145dce$var$_toPropertyKey(t) {
    var i = $12dc041033145dce$var$_toPrimitive(t, "string");
    return "symbol" == $12dc041033145dce$var$_typeof(i) ? i : i + "";
}
function $12dc041033145dce$var$_toPrimitive(t, r) {
    if ("object" != $12dc041033145dce$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $12dc041033145dce$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $12dc041033145dce$export$b6a79797ad180576(props) {
    var _element$props$cursor, _defaultProps;
    var element = props.element, tooltipEventType = props.tooltipEventType, isActive = props.isActive, activeCoordinate = props.activeCoordinate, activePayload = props.activePayload, offset = props.offset, activeTooltipIndex = props.activeTooltipIndex, tooltipAxisBandSize = props.tooltipAxisBandSize, layout = props.layout, chartName = props.chartName;
    var elementPropsCursor = (_element$props$cursor = element.props.cursor) !== null && _element$props$cursor !== void 0 ? _element$props$cursor : (_defaultProps = element.type.defaultProps) === null || _defaultProps === void 0 ? void 0 : _defaultProps.cursor;
    if (!element || !elementPropsCursor || !isActive || !activeCoordinate || chartName !== "ScatterChart" && tooltipEventType !== "axis") return null;
    var restProps;
    var cursorComp = (0, $1JINr.Curve);
    if (chartName === "ScatterChart") {
        restProps = activeCoordinate;
        cursorComp = (0, $4IwdC.Cross);
    } else if (chartName === "BarChart") {
        restProps = (0, $87DYb.getCursorRectangle)(layout, activeCoordinate, offset, tooltipAxisBandSize);
        cursorComp = (0, $DN6Qj.Rectangle);
    } else if (layout === "radial") {
        var _getRadialCursorPoint = (0, $b0gSF.getRadialCursorPoints)(activeCoordinate), cx = _getRadialCursorPoint.cx, cy = _getRadialCursorPoint.cy, radius = _getRadialCursorPoint.radius, startAngle = _getRadialCursorPoint.startAngle, endAngle = _getRadialCursorPoint.endAngle;
        restProps = {
            cx: cx,
            cy: cy,
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: radius,
            outerRadius: radius
        };
        cursorComp = (0, $4naQZ.Sector);
    } else {
        restProps = {
            points: (0, $g9hWG.getCursorPoints)(layout, activeCoordinate, offset)
        };
        cursorComp = (0, $1JINr.Curve);
    }
    var cursorProps = $12dc041033145dce$var$_objectSpread($12dc041033145dce$var$_objectSpread($12dc041033145dce$var$_objectSpread($12dc041033145dce$var$_objectSpread({
        stroke: "#ccc",
        pointerEvents: "none"
    }, offset), restProps), (0, $f06D9.filterProps)(elementPropsCursor, false)), {}, {
        payload: activePayload,
        payloadIndex: activeTooltipIndex,
        className: (0, $dWgPS.default)("recharts-tooltip-cursor", elementPropsCursor.className)
    });
    return /*#__PURE__*/ (0, $jbmdS.isValidElement)(elementPropsCursor) ? /*#__PURE__*/ (0, $jbmdS.cloneElement)(elementPropsCursor, cursorProps) : /*#__PURE__*/ (0, $jbmdS.createElement)(cursorComp, cursorProps);
}

});
parcelRegister("4IwdC", function(module, exports) {

$parcel$export(module.exports, "Cross", function () { return $36f4436a92e58cef$export$3c877bb842c36952; });

var $jbmdS = parcelRequire("jbmdS");

var $dWgPS = parcelRequire("dWgPS");

var $1gmrG = parcelRequire("1gmrG");

var $f06D9 = parcelRequire("f06D9");
function $36f4436a92e58cef$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $36f4436a92e58cef$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $36f4436a92e58cef$var$_typeof(o);
}
var $36f4436a92e58cef$var$_excluded = [
    "x",
    "y",
    "top",
    "left",
    "width",
    "height",
    "className"
];
function $36f4436a92e58cef$var$_extends() {
    $36f4436a92e58cef$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $36f4436a92e58cef$var$_extends.apply(this, arguments);
}
function $36f4436a92e58cef$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $36f4436a92e58cef$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $36f4436a92e58cef$var$ownKeys(Object(t), !0).forEach(function(r) {
            $36f4436a92e58cef$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $36f4436a92e58cef$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $36f4436a92e58cef$var$_defineProperty(obj, key, value) {
    key = $36f4436a92e58cef$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $36f4436a92e58cef$var$_toPropertyKey(t) {
    var i = $36f4436a92e58cef$var$_toPrimitive(t, "string");
    return "symbol" == $36f4436a92e58cef$var$_typeof(i) ? i : i + "";
}
function $36f4436a92e58cef$var$_toPrimitive(t, r) {
    if ("object" != $36f4436a92e58cef$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $36f4436a92e58cef$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $36f4436a92e58cef$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $36f4436a92e58cef$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $36f4436a92e58cef$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $36f4436a92e58cef$var$getPath = function getPath(x, y, width, height, top, left) {
    return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
};
var $36f4436a92e58cef$export$3c877bb842c36952 = function Cross(_ref) {
    var _ref$x = _ref.x, x = _ref$x === void 0 ? 0 : _ref$x, _ref$y = _ref.y, y = _ref$y === void 0 ? 0 : _ref$y, _ref$top = _ref.top, top = _ref$top === void 0 ? 0 : _ref$top, _ref$left = _ref.left, left = _ref$left === void 0 ? 0 : _ref$left, _ref$width = _ref.width, width = _ref$width === void 0 ? 0 : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? 0 : _ref$height, className = _ref.className, rest = $36f4436a92e58cef$var$_objectWithoutProperties(_ref, $36f4436a92e58cef$var$_excluded);
    var props = $36f4436a92e58cef$var$_objectSpread({
        x: x,
        y: y,
        top: top,
        left: left,
        width: width,
        height: height
    }, rest);
    if (!(0, $1gmrG.isNumber)(x) || !(0, $1gmrG.isNumber)(y) || !(0, $1gmrG.isNumber)(width) || !(0, $1gmrG.isNumber)(height) || !(0, $1gmrG.isNumber)(top) || !(0, $1gmrG.isNumber)(left)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("path", $36f4436a92e58cef$var$_extends({}, (0, $f06D9.filterProps)(props, true), {
        className: (0, $dWgPS.default)("recharts-cross", className),
        d: $36f4436a92e58cef$var$getPath(x, y, width, height, top, left)
    }));
};

});

parcelRegister("87DYb", function(module, exports) {

$parcel$export(module.exports, "getCursorRectangle", function () { return $5e9dfb4e95767f4e$export$f84ec1ecc69a13c9; });
function $5e9dfb4e95767f4e$export$f84ec1ecc69a13c9(layout, activeCoordinate, offset, tooltipAxisBandSize) {
    var halfSize = tooltipAxisBandSize / 2;
    return {
        stroke: "none",
        fill: "#ccc",
        x: layout === "horizontal" ? activeCoordinate.x - halfSize : offset.left + 0.5,
        y: layout === "horizontal" ? offset.top + 0.5 : activeCoordinate.y - halfSize,
        width: layout === "horizontal" ? tooltipAxisBandSize : offset.width - 1,
        height: layout === "horizontal" ? offset.height - 1 : tooltipAxisBandSize
    };
}

});

parcelRegister("b0gSF", function(module, exports) {

$parcel$export(module.exports, "getRadialCursorPoints", function () { return $802cc9ef338ad674$export$ad661ef85a042a4f; });

var $h7eoY = parcelRequire("h7eoY");
function $802cc9ef338ad674$export$ad661ef85a042a4f(activeCoordinate) {
    var cx = activeCoordinate.cx, cy = activeCoordinate.cy, radius = activeCoordinate.radius, startAngle = activeCoordinate.startAngle, endAngle = activeCoordinate.endAngle;
    var startPoint = (0, $h7eoY.polarToCartesian)(cx, cy, radius, startAngle);
    var endPoint = (0, $h7eoY.polarToCartesian)(cx, cy, radius, endAngle);
    return {
        points: [
            startPoint,
            endPoint
        ],
        cx: cx,
        cy: cy,
        radius: radius,
        startAngle: startAngle,
        endAngle: endAngle
    };
}

});

parcelRegister("g9hWG", function(module, exports) {

$parcel$export(module.exports, "getCursorPoints", function () { return $bc1b683bfd58d912$export$56e1305620ce5745; });

var $h7eoY = parcelRequire("h7eoY");

var $b0gSF = parcelRequire("b0gSF");
function $bc1b683bfd58d912$export$56e1305620ce5745(layout, activeCoordinate, offset) {
    var x1, y1, x2, y2;
    if (layout === "horizontal") {
        x1 = activeCoordinate.x;
        x2 = x1;
        y1 = offset.top;
        y2 = offset.top + offset.height;
    } else if (layout === "vertical") {
        y1 = activeCoordinate.y;
        y2 = y1;
        x1 = offset.left;
        x2 = offset.left + offset.width;
    } else if (activeCoordinate.cx != null && activeCoordinate.cy != null) {
        if (layout === "centric") {
            var cx = activeCoordinate.cx, cy = activeCoordinate.cy, innerRadius = activeCoordinate.innerRadius, outerRadius = activeCoordinate.outerRadius, angle = activeCoordinate.angle;
            var innerPoint = (0, $h7eoY.polarToCartesian)(cx, cy, innerRadius, angle);
            var outerPoint = (0, $h7eoY.polarToCartesian)(cx, cy, outerRadius, angle);
            x1 = innerPoint.x;
            y1 = innerPoint.y;
            x2 = outerPoint.x;
            y2 = outerPoint.y;
        } else return (0, $b0gSF.getRadialCursorPoints)(activeCoordinate);
    }
    return [
        {
            x: x1,
            y: y1
        },
        {
            x: x2,
            y: y2
        }
    ];
}

});



parcelRegister("eGOJx", function(module, exports) {

$parcel$export(module.exports, "XAxis", function () { return $ab1c578b76d0b1e2$export$ea77231de273b52d; });

var $jbmdS = parcelRequire("jbmdS");

var $dWgPS = parcelRequire("dWgPS");

var $jgA03 = parcelRequire("jgA03");

var $kJrrq = parcelRequire("kJrrq");

var $fiDSf = parcelRequire("fiDSf");
function $ab1c578b76d0b1e2$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ab1c578b76d0b1e2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ab1c578b76d0b1e2$var$_typeof(o);
}
function $ab1c578b76d0b1e2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ab1c578b76d0b1e2$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $ab1c578b76d0b1e2$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $ab1c578b76d0b1e2$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ab1c578b76d0b1e2$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ab1c578b76d0b1e2$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $ab1c578b76d0b1e2$var$_callSuper(t, o, e) {
    return o = $ab1c578b76d0b1e2$var$_getPrototypeOf(o), $ab1c578b76d0b1e2$var$_possibleConstructorReturn(t, $ab1c578b76d0b1e2$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $ab1c578b76d0b1e2$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $ab1c578b76d0b1e2$var$_possibleConstructorReturn(self, call) {
    if (call && ($ab1c578b76d0b1e2$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $ab1c578b76d0b1e2$var$_assertThisInitialized(self);
}
function $ab1c578b76d0b1e2$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $ab1c578b76d0b1e2$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ab1c578b76d0b1e2$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $ab1c578b76d0b1e2$var$_getPrototypeOf(o) {
    $ab1c578b76d0b1e2$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ab1c578b76d0b1e2$var$_getPrototypeOf(o);
}
function $ab1c578b76d0b1e2$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $ab1c578b76d0b1e2$var$_setPrototypeOf(subClass, superClass);
}
function $ab1c578b76d0b1e2$var$_setPrototypeOf(o, p) {
    $ab1c578b76d0b1e2$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ab1c578b76d0b1e2$var$_setPrototypeOf(o, p);
}
function $ab1c578b76d0b1e2$var$_defineProperty(obj, key, value) {
    key = $ab1c578b76d0b1e2$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ab1c578b76d0b1e2$var$_toPropertyKey(t) {
    var i = $ab1c578b76d0b1e2$var$_toPrimitive(t, "string");
    return "symbol" == $ab1c578b76d0b1e2$var$_typeof(i) ? i : i + "";
}
function $ab1c578b76d0b1e2$var$_toPrimitive(t, r) {
    if ("object" != $ab1c578b76d0b1e2$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ab1c578b76d0b1e2$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $ab1c578b76d0b1e2$var$_extends() {
    $ab1c578b76d0b1e2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ab1c578b76d0b1e2$var$_extends.apply(this, arguments);
}
/** Define of XAxis props */ function $ab1c578b76d0b1e2$var$XAxisImpl(_ref) {
    var xAxisId = _ref.xAxisId;
    var width = (0, $jgA03.useChartWidth)();
    var height = (0, $jgA03.useChartHeight)();
    var axisOptions = (0, $jgA03.useXAxisOrThrow)(xAxisId);
    if (axisOptions == null) return null;
    return(/*#__PURE__*/ // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $kJrrq.CartesianAxis), $ab1c578b76d0b1e2$var$_extends({}, axisOptions, {
        className: (0, $dWgPS.default)("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        },
        ticksGenerator: function ticksGenerator(axis) {
            return (0, $fiDSf.getTicksOfAxis)(axis, true);
        }
    })));
}
var $ab1c578b76d0b1e2$export$ea77231de273b52d = /*#__PURE__*/ function(_React$Component) {
    function XAxis() {
        $ab1c578b76d0b1e2$var$_classCallCheck(this, XAxis);
        return $ab1c578b76d0b1e2$var$_callSuper(this, XAxis, arguments);
    }
    $ab1c578b76d0b1e2$var$_inherits(XAxis, _React$Component);
    return $ab1c578b76d0b1e2$var$_createClass(XAxis, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($ab1c578b76d0b1e2$var$XAxisImpl, this.props);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).Component);
$ab1c578b76d0b1e2$var$_defineProperty($ab1c578b76d0b1e2$export$ea77231de273b52d, "displayName", "XAxis");
$ab1c578b76d0b1e2$var$_defineProperty($ab1c578b76d0b1e2$export$ea77231de273b52d, "defaultProps", {
    allowDecimals: true,
    hide: false,
    orientation: "bottom",
    width: 0,
    height: 30,
    mirror: false,
    xAxisId: 0,
    tickCount: 5,
    type: "category",
    padding: {
        left: 0,
        right: 0
    },
    allowDataOverflow: false,
    scale: "auto",
    reversed: false,
    allowDuplicatedCategory: true
});

});
parcelRegister("kJrrq", function(module, exports) {

$parcel$export(module.exports, "CartesianAxis", function () { return $f17d4be94fea16bb$export$bdd99f2cdf352bae; });

var $jbmdS = parcelRequire("jbmdS");

var $i99FY = parcelRequire("i99FY");

var $lNQsK = parcelRequire("lNQsK");

var $dWgPS = parcelRequire("dWgPS");

var $cxCWI = parcelRequire("cxCWI");

var $bIYfh = parcelRequire("bIYfh");

var $hyGHv = parcelRequire("hyGHv");

var $eGPJt = parcelRequire("eGPJt");

var $1gmrG = parcelRequire("1gmrG");

var $gBhCn = parcelRequire("gBhCn");

var $f06D9 = parcelRequire("f06D9");

var $48csW = parcelRequire("48csW");
var $f17d4be94fea16bb$var$_excluded = [
    "viewBox"
], $f17d4be94fea16bb$var$_excluded2 = [
    "viewBox"
], $f17d4be94fea16bb$var$_excluded3 = [
    "ticks"
];
function $f17d4be94fea16bb$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f17d4be94fea16bb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f17d4be94fea16bb$var$_typeof(o);
}
function $f17d4be94fea16bb$var$_extends() {
    $f17d4be94fea16bb$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f17d4be94fea16bb$var$_extends.apply(this, arguments);
}
function $f17d4be94fea16bb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f17d4be94fea16bb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f17d4be94fea16bb$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f17d4be94fea16bb$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f17d4be94fea16bb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f17d4be94fea16bb$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $f17d4be94fea16bb$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $f17d4be94fea16bb$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $f17d4be94fea16bb$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f17d4be94fea16bb$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $f17d4be94fea16bb$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $f17d4be94fea16bb$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f17d4be94fea16bb$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f17d4be94fea16bb$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $f17d4be94fea16bb$var$_callSuper(t, o, e) {
    return o = $f17d4be94fea16bb$var$_getPrototypeOf(o), $f17d4be94fea16bb$var$_possibleConstructorReturn(t, $f17d4be94fea16bb$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $f17d4be94fea16bb$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $f17d4be94fea16bb$var$_possibleConstructorReturn(self, call) {
    if (call && ($f17d4be94fea16bb$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $f17d4be94fea16bb$var$_assertThisInitialized(self);
}
function $f17d4be94fea16bb$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $f17d4be94fea16bb$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f17d4be94fea16bb$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $f17d4be94fea16bb$var$_getPrototypeOf(o) {
    $f17d4be94fea16bb$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f17d4be94fea16bb$var$_getPrototypeOf(o);
}
function $f17d4be94fea16bb$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $f17d4be94fea16bb$var$_setPrototypeOf(subClass, superClass);
}
function $f17d4be94fea16bb$var$_setPrototypeOf(o, p) {
    $f17d4be94fea16bb$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f17d4be94fea16bb$var$_setPrototypeOf(o, p);
}
function $f17d4be94fea16bb$var$_defineProperty(obj, key, value) {
    key = $f17d4be94fea16bb$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f17d4be94fea16bb$var$_toPropertyKey(t) {
    var i = $f17d4be94fea16bb$var$_toPrimitive(t, "string");
    return "symbol" == $f17d4be94fea16bb$var$_typeof(i) ? i : i + "";
}
function $f17d4be94fea16bb$var$_toPrimitive(t, r) {
    if ("object" != $f17d4be94fea16bb$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f17d4be94fea16bb$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $f17d4be94fea16bb$export$bdd99f2cdf352bae = /*#__PURE__*/ function(_Component) {
    function CartesianAxis(props) {
        var _this;
        $f17d4be94fea16bb$var$_classCallCheck(this, CartesianAxis);
        _this = $f17d4be94fea16bb$var$_callSuper(this, CartesianAxis, [
            props
        ]);
        _this.state = {
            fontSize: "",
            letterSpacing: ""
        };
        return _this;
    }
    $f17d4be94fea16bb$var$_inherits(CartesianAxis, _Component);
    return $f17d4be94fea16bb$var$_createClass(CartesianAxis, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(_ref, nextState) {
                var viewBox = _ref.viewBox, restProps = $f17d4be94fea16bb$var$_objectWithoutProperties(_ref, $f17d4be94fea16bb$var$_excluded);
                // props.viewBox is sometimes generated every time -
                // check that specially as object equality is likely to fail
                var _this$props = this.props, viewBoxOld = _this$props.viewBox, restPropsOld = $f17d4be94fea16bb$var$_objectWithoutProperties(_this$props, $f17d4be94fea16bb$var$_excluded2);
                return !(0, $cxCWI.shallowEqual)(viewBox, viewBoxOld) || !(0, $cxCWI.shallowEqual)(restProps, restPropsOld) || !(0, $cxCWI.shallowEqual)(nextState, this.state);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var htmlLayer = this.layerReference;
                if (!htmlLayer) return;
                var tick = htmlLayer.getElementsByClassName("recharts-cartesian-axis-tick-value")[0];
                if (tick) this.setState({
                    fontSize: window.getComputedStyle(tick).fontSize,
                    letterSpacing: window.getComputedStyle(tick).letterSpacing
                });
            }
        },
        {
            key: "getTickLineCoord",
            value: function getTickLineCoord(data) {
                var _this$props2 = this.props, x = _this$props2.x, y = _this$props2.y, width = _this$props2.width, height = _this$props2.height, orientation = _this$props2.orientation, tickSize = _this$props2.tickSize, mirror = _this$props2.mirror, tickMargin = _this$props2.tickMargin;
                var x1, x2, y1, y2, tx, ty;
                var sign = mirror ? -1 : 1;
                var finalTickSize = data.tickSize || tickSize;
                var tickCoord = (0, $1gmrG.isNumber)(data.tickCoord) ? data.tickCoord : data.coordinate;
                switch(orientation){
                    case "top":
                        x1 = x2 = data.coordinate;
                        y2 = y + +!mirror * height;
                        y1 = y2 - sign * finalTickSize;
                        ty = y1 - sign * tickMargin;
                        tx = tickCoord;
                        break;
                    case "left":
                        y1 = y2 = data.coordinate;
                        x2 = x + +!mirror * width;
                        x1 = x2 - sign * finalTickSize;
                        tx = x1 - sign * tickMargin;
                        ty = tickCoord;
                        break;
                    case "right":
                        y1 = y2 = data.coordinate;
                        x2 = x + +mirror * width;
                        x1 = x2 + sign * finalTickSize;
                        tx = x1 + sign * tickMargin;
                        ty = tickCoord;
                        break;
                    default:
                        x1 = x2 = data.coordinate;
                        y2 = y + +mirror * height;
                        y1 = y2 + sign * finalTickSize;
                        ty = y1 + sign * tickMargin;
                        tx = tickCoord;
                        break;
                }
                return {
                    line: {
                        x1: x1,
                        y1: y1,
                        x2: x2,
                        y2: y2
                    },
                    tick: {
                        x: tx,
                        y: ty
                    }
                };
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor() {
                var _this$props3 = this.props, orientation = _this$props3.orientation, mirror = _this$props3.mirror;
                var textAnchor;
                switch(orientation){
                    case "left":
                        textAnchor = mirror ? "start" : "end";
                        break;
                    case "right":
                        textAnchor = mirror ? "end" : "start";
                        break;
                    default:
                        textAnchor = "middle";
                        break;
                }
                return textAnchor;
            }
        },
        {
            key: "getTickVerticalAnchor",
            value: function getTickVerticalAnchor() {
                var _this$props4 = this.props, orientation = _this$props4.orientation, mirror = _this$props4.mirror;
                var verticalAnchor = "end";
                switch(orientation){
                    case "left":
                    case "right":
                        verticalAnchor = "middle";
                        break;
                    case "top":
                        verticalAnchor = mirror ? "start" : "end";
                        break;
                    default:
                        verticalAnchor = mirror ? "end" : "start";
                        break;
                }
                return verticalAnchor;
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props5 = this.props, x = _this$props5.x, y = _this$props5.y, width = _this$props5.width, height = _this$props5.height, orientation = _this$props5.orientation, mirror = _this$props5.mirror, axisLine = _this$props5.axisLine;
                var props = $f17d4be94fea16bb$var$_objectSpread($f17d4be94fea16bb$var$_objectSpread($f17d4be94fea16bb$var$_objectSpread({}, (0, $f06D9.filterProps)(this.props, false)), (0, $f06D9.filterProps)(axisLine, false)), {}, {
                    fill: "none"
                });
                if (orientation === "top" || orientation === "bottom") {
                    var needHeight = +(orientation === "top" && !mirror || orientation === "bottom" && mirror);
                    props = $f17d4be94fea16bb$var$_objectSpread($f17d4be94fea16bb$var$_objectSpread({}, props), {}, {
                        x1: x,
                        y1: y + needHeight * height,
                        x2: x + width,
                        y2: y + needHeight * height
                    });
                } else {
                    var needWidth = +(orientation === "left" && !mirror || orientation === "right" && mirror);
                    props = $f17d4be94fea16bb$var$_objectSpread($f17d4be94fea16bb$var$_objectSpread({}, props), {}, {
                        x1: x + needWidth * width,
                        y1: y,
                        x2: x + needWidth * width,
                        y2: y + height
                    });
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("line", $f17d4be94fea16bb$var$_extends({}, props, {
                    className: (0, $dWgPS.default)("recharts-cartesian-axis-line", (0, (/*@__PURE__*/$parcel$interopDefault($lNQsK)))(axisLine, "className"))
                }));
            }
        },
        {
            key: "renderTicks",
            value: /**
     * render the ticks
     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
     * @param {string} fontSize Fontsize to consider for tick spacing
     * @param {string} letterSpacing Letterspacing to consider for tick spacing
     * @return {ReactComponent} renderedTicks
     */ function renderTicks(ticks, fontSize, letterSpacing) {
                var _this2 = this;
                var _this$props6 = this.props, tickLine = _this$props6.tickLine, stroke = _this$props6.stroke, tick = _this$props6.tick, tickFormatter = _this$props6.tickFormatter, unit = _this$props6.unit;
                var finalTicks = (0, $48csW.getTicks)($f17d4be94fea16bb$var$_objectSpread($f17d4be94fea16bb$var$_objectSpread({}, this.props), {}, {
                    ticks: ticks
                }), fontSize, letterSpacing);
                var textAnchor = this.getTickTextAnchor();
                var verticalAnchor = this.getTickVerticalAnchor();
                var axisProps = (0, $f06D9.filterProps)(this.props, false);
                var customTickProps = (0, $f06D9.filterProps)(tick, false);
                var tickLineProps = $f17d4be94fea16bb$var$_objectSpread($f17d4be94fea16bb$var$_objectSpread({}, axisProps), {}, {
                    fill: "none"
                }, (0, $f06D9.filterProps)(tickLine, false));
                var items = finalTicks.map(function(entry, i) {
                    var _this2$getTickLineCoo = _this2.getTickLineCoord(entry), lineCoord = _this2$getTickLineCoo.line, tickCoord = _this2$getTickLineCoo.tick;
                    var tickProps = $f17d4be94fea16bb$var$_objectSpread($f17d4be94fea16bb$var$_objectSpread($f17d4be94fea16bb$var$_objectSpread($f17d4be94fea16bb$var$_objectSpread({
                        textAnchor: textAnchor,
                        verticalAnchor: verticalAnchor
                    }, axisProps), {}, {
                        stroke: "none",
                        fill: stroke
                    }, customTickProps), tickCoord), {}, {
                        index: i,
                        payload: entry,
                        visibleTicksCount: finalTicks.length,
                        tickFormatter: tickFormatter
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $bIYfh.Layer), $f17d4be94fea16bb$var$_extends({
                        className: "recharts-cartesian-axis-tick",
                        key: "tick-".concat(entry.value, "-").concat(entry.coordinate, "-").concat(entry.tickCoord)
                    }, (0, $gBhCn.adaptEventsOfChild)(_this2.props, entry, i)), tickLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("line", $f17d4be94fea16bb$var$_extends({}, tickLineProps, lineCoord, {
                        className: (0, $dWgPS.default)("recharts-cartesian-axis-tick-line", (0, (/*@__PURE__*/$parcel$interopDefault($lNQsK)))(tickLine, "className"))
                    })), tick && CartesianAxis.renderTickItem(tick, tickProps, "".concat((0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(tickFormatter) ? tickFormatter(entry.value, i) : entry.value).concat(unit || "")));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("g", {
                    className: "recharts-cartesian-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props7 = this.props, axisLine = _this$props7.axisLine, width = _this$props7.width, height = _this$props7.height, ticksGenerator = _this$props7.ticksGenerator, className = _this$props7.className, hide = _this$props7.hide;
                if (hide) return null;
                var _this$props8 = this.props, ticks = _this$props8.ticks, noTicksProps = $f17d4be94fea16bb$var$_objectWithoutProperties(_this$props8, $f17d4be94fea16bb$var$_excluded3);
                var finalTicks = ticks;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(ticksGenerator)) finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
                if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $bIYfh.Layer), {
                    className: (0, $dWgPS.default)("recharts-cartesian-axis", className),
                    ref: function ref(_ref2) {
                        _this3.layerReference = _ref2;
                    }
                }, axisLine && this.renderAxisLine(), this.renderTicks(finalTicks, this.state.fontSize, this.state.letterSpacing), (0, $eGPJt.Label).renderCallByParent(this.props));
            }
        }
    ], [
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).isValidElement(option)) tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(option)) tickItem = option(props);
                else tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $hyGHv.Text), $f17d4be94fea16bb$var$_extends({}, props, {
                    className: "recharts-cartesian-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
}((0, $jbmdS.Component));
$f17d4be94fea16bb$var$_defineProperty($f17d4be94fea16bb$export$bdd99f2cdf352bae, "displayName", "CartesianAxis");
$f17d4be94fea16bb$var$_defineProperty($f17d4be94fea16bb$export$bdd99f2cdf352bae, "defaultProps", {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    viewBox: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    // The orientation of axis
    orientation: "bottom",
    // The ticks
    ticks: [],
    stroke: "#666",
    tickLine: true,
    axisLine: true,
    tick: true,
    mirror: false,
    minTickGap: 5,
    // The width or height of tick
    tickSize: 6,
    tickMargin: 2,
    interval: "preserveEnd"
});

});
parcelRegister("48csW", function(module, exports) {

$parcel$export(module.exports, "getTicks", function () { return $302194371e097e67$export$3d27d42b1034de5c; });

var $i99FY = parcelRequire("i99FY");

var $1gmrG = parcelRequire("1gmrG");

var $kPfcu = parcelRequire("kPfcu");

var $9wZNv = parcelRequire("9wZNv");

var $iLMAq = parcelRequire("iLMAq");

var $bgyXV = parcelRequire("bgyXV");
function $302194371e097e67$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $302194371e097e67$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $302194371e097e67$var$_typeof(o);
}
function $302194371e097e67$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $302194371e097e67$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $302194371e097e67$var$ownKeys(Object(t), !0).forEach(function(r) {
            $302194371e097e67$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $302194371e097e67$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $302194371e097e67$var$_defineProperty(obj, key, value) {
    key = $302194371e097e67$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $302194371e097e67$var$_toPropertyKey(t) {
    var i = $302194371e097e67$var$_toPrimitive(t, "string");
    return "symbol" == $302194371e097e67$var$_typeof(i) ? i : i + "";
}
function $302194371e097e67$var$_toPrimitive(t, r) {
    if ("object" != $302194371e097e67$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $302194371e097e67$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $302194371e097e67$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start;
    var end = boundaries.end;
    var _loop = function _loop(i) {
        var entry = result[i];
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === len - 1) {
            var gap = sign * (entry.coordinate + sign * getSize() / 2 - end);
            result[i] = entry = $302194371e097e67$var$_objectSpread($302194371e097e67$var$_objectSpread({}, entry), {}, {
                tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $302194371e097e67$var$_objectSpread($302194371e097e67$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = (0, $iLMAq.isVisible)(sign, entry.tickCoord, getSize, start, end);
        if (isShow) {
            end = entry.tickCoord - sign * (getSize() / 2 + minTickGap);
            result[i] = $302194371e097e67$var$_objectSpread($302194371e097e67$var$_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    };
    for(var i = len - 1; i >= 0; i--)_loop(i);
    return result;
}
function $302194371e097e67$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, preserveEnd) {
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start, end = boundaries.end;
    if (preserveEnd) {
        // Try to guarantee the tail to be displayed
        var tail = ticks[len - 1];
        var tailSize = getTickSize(tail, len - 1);
        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
        result[len - 1] = tail = $302194371e097e67$var$_objectSpread($302194371e097e67$var$_objectSpread({}, tail), {}, {
            tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
        });
        var isTailShow = (0, $iLMAq.isVisible)(sign, tail.tickCoord, function() {
            return tailSize;
        }, start, end);
        if (isTailShow) {
            end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
            result[len - 1] = $302194371e097e67$var$_objectSpread($302194371e097e67$var$_objectSpread({}, tail), {}, {
                isShow: true
            });
        }
    }
    var count = preserveEnd ? len - 1 : len;
    var _loop2 = function _loop2(i) {
        var entry = result[i];
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === 0) {
            var gap = sign * (entry.coordinate - sign * getSize() / 2 - start);
            result[i] = entry = $302194371e097e67$var$_objectSpread($302194371e097e67$var$_objectSpread({}, entry), {}, {
                tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $302194371e097e67$var$_objectSpread($302194371e097e67$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = (0, $iLMAq.isVisible)(sign, entry.tickCoord, getSize, start, end);
        if (isShow) {
            start = entry.tickCoord + sign * (getSize() / 2 + minTickGap);
            result[i] = $302194371e097e67$var$_objectSpread($302194371e097e67$var$_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    };
    for(var i = 0; i < count; i++)_loop2(i);
    return result;
}
function $302194371e097e67$export$3d27d42b1034de5c(props, fontSize, letterSpacing) {
    var tick = props.tick, ticks = props.ticks, viewBox = props.viewBox, minTickGap = props.minTickGap, orientation = props.orientation, interval = props.interval, tickFormatter = props.tickFormatter, unit = props.unit, angle = props.angle;
    if (!ticks || !ticks.length || !tick) return [];
    if ((0, $1gmrG.isNumber)(interval) || (0, $9wZNv.Global).isSsr) return (0, $iLMAq.getNumberIntervalTicks)(ticks, typeof interval === "number" && (0, $1gmrG.isNumber)(interval) ? interval : 0);
    var candidates = [];
    var sizeKey = orientation === "top" || orientation === "bottom" ? "width" : "height";
    var unitSize = unit && sizeKey === "width" ? (0, $kPfcu.getStringSize)(unit, {
        fontSize: fontSize,
        letterSpacing: letterSpacing
    }) : {
        width: 0,
        height: 0
    };
    var getTickSize = function getTickSize(content, index) {
        var value = (0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(tickFormatter) ? tickFormatter(content.value, index) : content.value;
        // Recharts only supports angles when sizeKey === 'width'
        return sizeKey === "width" ? (0, $iLMAq.getAngledTickWidth)((0, $kPfcu.getStringSize)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        }), unitSize, angle) : (0, $kPfcu.getStringSize)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        })[sizeKey];
    };
    var sign = ticks.length >= 2 ? (0, $1gmrG.mathSign)(ticks[1].coordinate - ticks[0].coordinate) : 1;
    var boundaries = (0, $iLMAq.getTickBoundaries)(viewBox, sign, sizeKey);
    if (interval === "equidistantPreserveStart") return (0, $bgyXV.getEquidistantTicks)(sign, boundaries, getTickSize, ticks, minTickGap);
    if (interval === "preserveStart" || interval === "preserveStartEnd") candidates = $302194371e097e67$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, interval === "preserveStartEnd");
    else candidates = $302194371e097e67$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap);
    return candidates.filter(function(entry) {
        return entry.isShow;
    });
}

});
parcelRegister("iLMAq", function(module, exports) {

$parcel$export(module.exports, "getAngledTickWidth", function () { return $daa24e114d0c8ba8$export$a1966f4ad955c82b; });
$parcel$export(module.exports, "getTickBoundaries", function () { return $daa24e114d0c8ba8$export$a257eb8806d5033d; });
$parcel$export(module.exports, "isVisible", function () { return $daa24e114d0c8ba8$export$795910f5f15a9633; });
$parcel$export(module.exports, "getNumberIntervalTicks", function () { return $daa24e114d0c8ba8$export$beeebbe3ff1b306b; });

var $eZuTD = parcelRequire("eZuTD");

var $8H36Q = parcelRequire("8H36Q");
function $daa24e114d0c8ba8$export$a1966f4ad955c82b(contentSize, unitSize, angle) {
    var size = {
        width: contentSize.width + unitSize.width,
        height: contentSize.height + unitSize.height
    };
    return (0, $eZuTD.getAngledRectangleWidth)(size, angle);
}
function $daa24e114d0c8ba8$export$a257eb8806d5033d(viewBox, sign, sizeKey) {
    var isWidth = sizeKey === "width";
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    if (sign === 1) return {
        start: isWidth ? x : y,
        end: isWidth ? x + width : y + height
    };
    return {
        start: isWidth ? x + width : y + height,
        end: isWidth ? x : y
    };
}
function $daa24e114d0c8ba8$export$795910f5f15a9633(sign, tickPosition, getSize, start, end) {
    /* Since getSize() is expensive (it reads the ticks' size from the DOM), we do this check first to avoid calculating
   * the tick's size. */ if (sign * tickPosition < sign * start || sign * tickPosition > sign * end) return false;
    var size = getSize();
    return sign * (tickPosition - sign * size / 2 - start) >= 0 && sign * (tickPosition + sign * size / 2 - end) <= 0;
}
function $daa24e114d0c8ba8$export$beeebbe3ff1b306b(ticks, interval) {
    return (0, $8H36Q.getEveryNthWithCondition)(ticks, interval + 1);
}

});
parcelRegister("8H36Q", function(module, exports) {

$parcel$export(module.exports, "getEveryNthWithCondition", function () { return $6544c05a052db342$export$41514b9f058a6886; });
/**
 * Given an array and a number N, return a new array which contains every nTh
 * element of the input array. For n below 1, an empty array is returned.
 * If isValid is provided, all candidates must suffice the condition, else undefined is returned.
 * @param {T[]} array An input array.
 * @param {integer} n A number
 * @param {Function} isValid A function to evaluate a candidate form the array
 * @returns {T[]} The result array of the same type as the input array.
 */ function $6544c05a052db342$export$41514b9f058a6886(array, n, isValid) {
    if (n < 1) return [];
    if (n === 1 && isValid === undefined) return array;
    var result = [];
    for(var i = 0; i < array.length; i += n){
        if (isValid === undefined || isValid(array[i]) === true) result.push(array[i]);
        else return undefined;
    }
    return result;
}

});


parcelRegister("bgyXV", function(module, exports) {

$parcel$export(module.exports, "getEquidistantTicks", function () { return $833c4fc30967cc64$export$77bf2ab5711b7f99; });

var $iLMAq = parcelRequire("iLMAq");

var $8H36Q = parcelRequire("8H36Q");
function $833c4fc30967cc64$export$77bf2ab5711b7f99(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var initialStart = boundaries.start, end = boundaries.end;
    var index = 0;
    // Premature optimisation idea 1: Estimate a lower bound, and start from there.
    // For now, start from every tick
    var stepsize = 1;
    var start = initialStart;
    var _loop = function _loop() {
        // Given stepsize, evaluate whether every stepsize-th tick can be shown.
        // If it can not, then increase the stepsize by 1, and try again.
        var entry = ticks === null || ticks === void 0 ? void 0 : ticks[index];
        // Break condition - If we have evaluate all the ticks, then we are done.
        if (entry === undefined) return {
            v: (0, $8H36Q.getEveryNthWithCondition)(ticks, stepsize)
        };
        // Check if the element collides with the next element
        var i = index;
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        var tickCoord = entry.coordinate;
        // We will always show the first tick.
        var isShow = index === 0 || (0, $iLMAq.isVisible)(sign, tickCoord, getSize, start, end);
        if (!isShow) {
            // Start all over with a larger stepsize
            index = 0;
            start = initialStart;
            stepsize += 1;
        }
        if (isShow) {
            // If it can be shown, update the start
            start = tickCoord + sign * (getSize() / 2 + minTickGap);
            index += stepsize;
        }
    }, _ret;
    while(stepsize <= result.length){
        _ret = _loop();
        if (_ret) return _ret.v;
    }
    return [];
}

});




parcelRegister("hbTlI", function(module, exports) {

$parcel$export(module.exports, "YAxis", function () { return $c83e65fb54b326c3$export$f96c4024c52de8f4; });

var $jbmdS = parcelRequire("jbmdS");

var $dWgPS = parcelRequire("dWgPS");

var $jgA03 = parcelRequire("jgA03");

var $kJrrq = parcelRequire("kJrrq");

var $fiDSf = parcelRequire("fiDSf");
function $c83e65fb54b326c3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c83e65fb54b326c3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c83e65fb54b326c3$var$_typeof(o);
}
function $c83e65fb54b326c3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c83e65fb54b326c3$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c83e65fb54b326c3$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c83e65fb54b326c3$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c83e65fb54b326c3$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c83e65fb54b326c3$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c83e65fb54b326c3$var$_callSuper(t, o, e) {
    return o = $c83e65fb54b326c3$var$_getPrototypeOf(o), $c83e65fb54b326c3$var$_possibleConstructorReturn(t, $c83e65fb54b326c3$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $c83e65fb54b326c3$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $c83e65fb54b326c3$var$_possibleConstructorReturn(self, call) {
    if (call && ($c83e65fb54b326c3$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $c83e65fb54b326c3$var$_assertThisInitialized(self);
}
function $c83e65fb54b326c3$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c83e65fb54b326c3$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c83e65fb54b326c3$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $c83e65fb54b326c3$var$_getPrototypeOf(o) {
    $c83e65fb54b326c3$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c83e65fb54b326c3$var$_getPrototypeOf(o);
}
function $c83e65fb54b326c3$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $c83e65fb54b326c3$var$_setPrototypeOf(subClass, superClass);
}
function $c83e65fb54b326c3$var$_setPrototypeOf(o, p) {
    $c83e65fb54b326c3$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c83e65fb54b326c3$var$_setPrototypeOf(o, p);
}
function $c83e65fb54b326c3$var$_defineProperty(obj, key, value) {
    key = $c83e65fb54b326c3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c83e65fb54b326c3$var$_toPropertyKey(t) {
    var i = $c83e65fb54b326c3$var$_toPrimitive(t, "string");
    return "symbol" == $c83e65fb54b326c3$var$_typeof(i) ? i : i + "";
}
function $c83e65fb54b326c3$var$_toPrimitive(t, r) {
    if ("object" != $c83e65fb54b326c3$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $c83e65fb54b326c3$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $c83e65fb54b326c3$var$_extends() {
    $c83e65fb54b326c3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c83e65fb54b326c3$var$_extends.apply(this, arguments);
}
var $c83e65fb54b326c3$var$YAxisImpl = function YAxisImpl(_ref) {
    var yAxisId = _ref.yAxisId;
    var width = (0, $jgA03.useChartWidth)();
    var height = (0, $jgA03.useChartHeight)();
    var axisOptions = (0, $jgA03.useYAxisOrThrow)(yAxisId);
    if (axisOptions == null) return null;
    return(/*#__PURE__*/ // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement((0, $kJrrq.CartesianAxis), $c83e65fb54b326c3$var$_extends({}, axisOptions, {
        className: (0, $dWgPS.default)("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        },
        ticksGenerator: function ticksGenerator(axis) {
            return (0, $fiDSf.getTicksOfAxis)(axis, true);
        }
    })));
};
var $c83e65fb54b326c3$export$f96c4024c52de8f4 = /*#__PURE__*/ function(_React$Component) {
    function YAxis() {
        $c83e65fb54b326c3$var$_classCallCheck(this, YAxis);
        return $c83e65fb54b326c3$var$_callSuper(this, YAxis, arguments);
    }
    $c83e65fb54b326c3$var$_inherits(YAxis, _React$Component);
    return $c83e65fb54b326c3$var$_createClass(YAxis, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($c83e65fb54b326c3$var$YAxisImpl, this.props);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).Component);
$c83e65fb54b326c3$var$_defineProperty($c83e65fb54b326c3$export$f96c4024c52de8f4, "displayName", "YAxis");
$c83e65fb54b326c3$var$_defineProperty($c83e65fb54b326c3$export$f96c4024c52de8f4, "defaultProps", {
    allowDuplicatedCategory: true,
    allowDecimals: true,
    hide: false,
    orientation: "left",
    width: 60,
    height: 0,
    mirror: false,
    yAxisId: 0,
    tickCount: 5,
    type: "number",
    padding: {
        top: 0,
        bottom: 0
    },
    allowDataOverflow: false,
    scale: "auto",
    reversed: false
});

});


parcelRegister("id8ax", function(module, exports) {

$parcel$export(module.exports, "CartesianGrid", function () { return $d41fc71850902515$export$6440e27b9f186856; });

var $jbmdS = parcelRequire("jbmdS");

var $i99FY = parcelRequire("i99FY");

var $aOmiF = parcelRequire("aOmiF");

var $1gmrG = parcelRequire("1gmrG");

var $f06D9 = parcelRequire("f06D9");

var $fiDSf = parcelRequire("fiDSf");

var $48csW = parcelRequire("48csW");

var $kJrrq = parcelRequire("kJrrq");

var $jgA03 = parcelRequire("jgA03");
var $d41fc71850902515$var$_excluded = [
    "x1",
    "y1",
    "x2",
    "y2",
    "key"
], $d41fc71850902515$var$_excluded2 = [
    "offset"
];
function $d41fc71850902515$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d41fc71850902515$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d41fc71850902515$var$_typeof(o);
}
function $d41fc71850902515$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d41fc71850902515$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d41fc71850902515$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d41fc71850902515$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d41fc71850902515$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d41fc71850902515$var$_defineProperty(obj, key, value) {
    key = $d41fc71850902515$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d41fc71850902515$var$_toPropertyKey(t) {
    var i = $d41fc71850902515$var$_toPrimitive(t, "string");
    return "symbol" == $d41fc71850902515$var$_typeof(i) ? i : i + "";
}
function $d41fc71850902515$var$_toPrimitive(t, r) {
    if ("object" != $d41fc71850902515$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $d41fc71850902515$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $d41fc71850902515$var$_extends() {
    $d41fc71850902515$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d41fc71850902515$var$_extends.apply(this, arguments);
}
function $d41fc71850902515$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d41fc71850902515$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d41fc71850902515$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * The <CartesianGrid horizontal
 */ var $d41fc71850902515$var$Background = function Background(props) {
    var fill = props.fill;
    if (!fill || fill === "none") return null;
    var fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, ry = props.ry;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("rect", {
        x: x,
        y: y,
        ry: ry,
        width: width,
        height: height,
        stroke: "none",
        fill: fill,
        fillOpacity: fillOpacity,
        className: "recharts-cartesian-grid-bg"
    });
};
function $d41fc71850902515$var$renderLineItem(option, props) {
    var lineItem;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).isValidElement(option)) // @ts-expect-error typescript does not see the props type when cloning an element
    lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(option)) lineItem = option(props);
    else {
        var x1 = props.x1, y1 = props.y1, x2 = props.x2, y2 = props.y2, key = props.key, others = $d41fc71850902515$var$_objectWithoutProperties(props, $d41fc71850902515$var$_excluded);
        var _filterProps = (0, $f06D9.filterProps)(others, false), __ = _filterProps.offset, restOfFilteredProps = $d41fc71850902515$var$_objectWithoutProperties(_filterProps, $d41fc71850902515$var$_excluded2);
        lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("line", $d41fc71850902515$var$_extends({}, restOfFilteredProps, {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            fill: "none",
            key: key
        }));
    }
    return lineItem;
}
function $d41fc71850902515$var$HorizontalGridLines(props) {
    var x = props.x, width = props.width, _props$horizontal = props.horizontal, horizontal = _props$horizontal === void 0 ? true : _props$horizontal, horizontalPoints = props.horizontalPoints;
    if (!horizontal || !horizontalPoints || !horizontalPoints.length) return null;
    var items = horizontalPoints.map(function(entry, i) {
        var lineItemProps = $d41fc71850902515$var$_objectSpread($d41fc71850902515$var$_objectSpread({}, props), {}, {
            x1: x,
            y1: entry,
            x2: x + width,
            y2: entry,
            key: "line-".concat(i),
            index: i
        });
        return $d41fc71850902515$var$renderLineItem(horizontal, lineItemProps);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("g", {
        className: "recharts-cartesian-grid-horizontal"
    }, items);
}
function $d41fc71850902515$var$VerticalGridLines(props) {
    var y = props.y, height = props.height, _props$vertical = props.vertical, vertical = _props$vertical === void 0 ? true : _props$vertical, verticalPoints = props.verticalPoints;
    if (!vertical || !verticalPoints || !verticalPoints.length) return null;
    var items = verticalPoints.map(function(entry, i) {
        var lineItemProps = $d41fc71850902515$var$_objectSpread($d41fc71850902515$var$_objectSpread({}, props), {}, {
            x1: entry,
            y1: y,
            x2: entry,
            y2: y + height,
            key: "line-".concat(i),
            index: i
        });
        return $d41fc71850902515$var$renderLineItem(vertical, lineItemProps);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("g", {
        className: "recharts-cartesian-grid-vertical"
    }, items);
}
function $d41fc71850902515$var$HorizontalStripes(props) {
    var horizontalFill = props.horizontalFill, fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, horizontalPoints = props.horizontalPoints, _props$horizontal2 = props.horizontal, horizontal = _props$horizontal2 === void 0 ? true : _props$horizontal2;
    if (!horizontal || !horizontalFill || !horizontalFill.length) return null;
    // Why =y -y? I was trying to find any difference that this makes, with floating point numbers and edge cases but ... nothing.
    var roundedSortedHorizontalPoints = horizontalPoints.map(function(e) {
        return Math.round(e + y - y);
    }).sort(function(a, b) {
        return a - b;
    });
    // Why is this condition `!==` instead of `<=` ?
    if (y !== roundedSortedHorizontalPoints[0]) roundedSortedHorizontalPoints.unshift(0);
    var items = roundedSortedHorizontalPoints.map(function(entry, i) {
        // Why do we strip only the last stripe if it is invisible, and not all invisible stripes?
        var lastStripe = !roundedSortedHorizontalPoints[i + 1];
        var lineHeight = lastStripe ? y + height - entry : roundedSortedHorizontalPoints[i + 1] - entry;
        if (lineHeight <= 0) return null;
        var colorIndex = i % horizontalFill.length;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("rect", {
            key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
            ,
            y: entry,
            x: x,
            height: lineHeight,
            width: width,
            stroke: "none",
            fill: horizontalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("g", {
        className: "recharts-cartesian-gridstripes-horizontal"
    }, items);
}
function $d41fc71850902515$var$VerticalStripes(props) {
    var _props$vertical2 = props.vertical, vertical = _props$vertical2 === void 0 ? true : _props$vertical2, verticalFill = props.verticalFill, fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, verticalPoints = props.verticalPoints;
    if (!vertical || !verticalFill || !verticalFill.length) return null;
    var roundedSortedVerticalPoints = verticalPoints.map(function(e) {
        return Math.round(e + x - x);
    }).sort(function(a, b) {
        return a - b;
    });
    if (x !== roundedSortedVerticalPoints[0]) roundedSortedVerticalPoints.unshift(0);
    var items = roundedSortedVerticalPoints.map(function(entry, i) {
        var lastStripe = !roundedSortedVerticalPoints[i + 1];
        var lineWidth = lastStripe ? x + width - entry : roundedSortedVerticalPoints[i + 1] - entry;
        if (lineWidth <= 0) return null;
        var colorIndex = i % verticalFill.length;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("rect", {
            key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
            ,
            x: entry,
            y: y,
            width: lineWidth,
            height: height,
            stroke: "none",
            fill: verticalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("g", {
        className: "recharts-cartesian-gridstripes-vertical"
    }, items);
}
var $d41fc71850902515$var$defaultVerticalCoordinatesGenerator = function defaultVerticalCoordinatesGenerator(_ref, syncWithTicks) {
    var xAxis = _ref.xAxis, width = _ref.width, height = _ref.height, offset = _ref.offset;
    return (0, $fiDSf.getCoordinatesOfGrid)((0, $48csW.getTicks)($d41fc71850902515$var$_objectSpread($d41fc71850902515$var$_objectSpread($d41fc71850902515$var$_objectSpread({}, (0, $kJrrq.CartesianAxis).defaultProps), xAxis), {}, {
        ticks: (0, $fiDSf.getTicksOfAxis)(xAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.left, offset.left + offset.width, syncWithTicks);
};
var $d41fc71850902515$var$defaultHorizontalCoordinatesGenerator = function defaultHorizontalCoordinatesGenerator(_ref2, syncWithTicks) {
    var yAxis = _ref2.yAxis, width = _ref2.width, height = _ref2.height, offset = _ref2.offset;
    return (0, $fiDSf.getCoordinatesOfGrid)((0, $48csW.getTicks)($d41fc71850902515$var$_objectSpread($d41fc71850902515$var$_objectSpread($d41fc71850902515$var$_objectSpread({}, (0, $kJrrq.CartesianAxis).defaultProps), yAxis), {}, {
        ticks: (0, $fiDSf.getTicksOfAxis)(yAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.top, offset.top + offset.height, syncWithTicks);
};
var $d41fc71850902515$var$defaultProps = {
    horizontal: true,
    vertical: true,
    // The ordinates of horizontal grid lines
    horizontalPoints: [],
    // The abscissas of vertical grid lines
    verticalPoints: [],
    stroke: "#ccc",
    fill: "none",
    // The fill of colors of grid lines
    verticalFill: [],
    horizontalFill: []
};
function $d41fc71850902515$export$6440e27b9f186856(props) {
    var _props$stroke, _props$fill, _props$horizontal3, _props$horizontalFill, _props$vertical3, _props$verticalFill;
    var chartWidth = (0, $jgA03.useChartWidth)();
    var chartHeight = (0, $jgA03.useChartHeight)();
    var offset = (0, $jgA03.useOffset)();
    var propsIncludingDefaults = $d41fc71850902515$var$_objectSpread($d41fc71850902515$var$_objectSpread({}, props), {}, {
        stroke: (_props$stroke = props.stroke) !== null && _props$stroke !== void 0 ? _props$stroke : $d41fc71850902515$var$defaultProps.stroke,
        fill: (_props$fill = props.fill) !== null && _props$fill !== void 0 ? _props$fill : $d41fc71850902515$var$defaultProps.fill,
        horizontal: (_props$horizontal3 = props.horizontal) !== null && _props$horizontal3 !== void 0 ? _props$horizontal3 : $d41fc71850902515$var$defaultProps.horizontal,
        horizontalFill: (_props$horizontalFill = props.horizontalFill) !== null && _props$horizontalFill !== void 0 ? _props$horizontalFill : $d41fc71850902515$var$defaultProps.horizontalFill,
        vertical: (_props$vertical3 = props.vertical) !== null && _props$vertical3 !== void 0 ? _props$vertical3 : $d41fc71850902515$var$defaultProps.vertical,
        verticalFill: (_props$verticalFill = props.verticalFill) !== null && _props$verticalFill !== void 0 ? _props$verticalFill : $d41fc71850902515$var$defaultProps.verticalFill,
        x: (0, $1gmrG.isNumber)(props.x) ? props.x : offset.left,
        y: (0, $1gmrG.isNumber)(props.y) ? props.y : offset.top,
        width: (0, $1gmrG.isNumber)(props.width) ? props.width : offset.width,
        height: (0, $1gmrG.isNumber)(props.height) ? props.height : offset.height
    });
    var x = propsIncludingDefaults.x, y = propsIncludingDefaults.y, width = propsIncludingDefaults.width, height = propsIncludingDefaults.height, syncWithTicks = propsIncludingDefaults.syncWithTicks, horizontalValues = propsIncludingDefaults.horizontalValues, verticalValues = propsIncludingDefaults.verticalValues;
    // @ts-expect-error the scale prop is mixed up - we need to untagle this at some point
    var xAxis = (0, $jgA03.useArbitraryXAxis)();
    // @ts-expect-error the scale prop is mixed up - we need to untagle this at some point
    var yAxis = (0, $jgA03.useYAxisWithFiniteDomainOrRandom)();
    if (!(0, $1gmrG.isNumber)(width) || width <= 0 || !(0, $1gmrG.isNumber)(height) || height <= 0 || !(0, $1gmrG.isNumber)(x) || x !== +x || !(0, $1gmrG.isNumber)(y) || y !== +y) return null;
    /*
   * verticalCoordinatesGenerator and horizontalCoordinatesGenerator are defined
   * outside of the propsIncludingDefaults because they were never part of the original props
   * and they were never passed as a prop down to horizontal/vertical custom elements.
   * If we add these two to propsIncludingDefaults then we are changing public API.
   * Not a bad thing per se but also not necessary.
   */ var verticalCoordinatesGenerator = propsIncludingDefaults.verticalCoordinatesGenerator || $d41fc71850902515$var$defaultVerticalCoordinatesGenerator;
    var horizontalCoordinatesGenerator = propsIncludingDefaults.horizontalCoordinatesGenerator || $d41fc71850902515$var$defaultHorizontalCoordinatesGenerator;
    var horizontalPoints = propsIncludingDefaults.horizontalPoints, verticalPoints = propsIncludingDefaults.verticalPoints;
    // No horizontal points are specified
    if ((!horizontalPoints || !horizontalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(horizontalCoordinatesGenerator)) {
        var isHorizontalValues = horizontalValues && horizontalValues.length;
        var generatorResult = horizontalCoordinatesGenerator({
            yAxis: yAxis ? $d41fc71850902515$var$_objectSpread($d41fc71850902515$var$_objectSpread({}, yAxis), {}, {
                ticks: isHorizontalValues ? horizontalValues : yAxis.ticks
            }) : undefined,
            width: chartWidth,
            height: chartHeight,
            offset: offset
        }, isHorizontalValues ? true : syncWithTicks);
        (0, $aOmiF.warn)(Array.isArray(generatorResult), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat($d41fc71850902515$var$_typeof(generatorResult), "]"));
        if (Array.isArray(generatorResult)) horizontalPoints = generatorResult;
    }
    // No vertical points are specified
    if ((!verticalPoints || !verticalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($i99FY)))(verticalCoordinatesGenerator)) {
        var isVerticalValues = verticalValues && verticalValues.length;
        var _generatorResult = verticalCoordinatesGenerator({
            xAxis: xAxis ? $d41fc71850902515$var$_objectSpread($d41fc71850902515$var$_objectSpread({}, xAxis), {}, {
                ticks: isVerticalValues ? verticalValues : xAxis.ticks
            }) : undefined,
            width: chartWidth,
            height: chartHeight,
            offset: offset
        }, isVerticalValues ? true : syncWithTicks);
        (0, $aOmiF.warn)(Array.isArray(_generatorResult), "verticalCoordinatesGenerator should return Array but instead it returned [".concat($d41fc71850902515$var$_typeof(_generatorResult), "]"));
        if (Array.isArray(_generatorResult)) verticalPoints = _generatorResult;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("g", {
        className: "recharts-cartesian-grid"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($d41fc71850902515$var$Background, {
        fill: propsIncludingDefaults.fill,
        fillOpacity: propsIncludingDefaults.fillOpacity,
        x: propsIncludingDefaults.x,
        y: propsIncludingDefaults.y,
        width: propsIncludingDefaults.width,
        height: propsIncludingDefaults.height,
        ry: propsIncludingDefaults.ry
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($d41fc71850902515$var$HorizontalGridLines, $d41fc71850902515$var$_extends({}, propsIncludingDefaults, {
        offset: offset,
        horizontalPoints: horizontalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($d41fc71850902515$var$VerticalGridLines, $d41fc71850902515$var$_extends({}, propsIncludingDefaults, {
        offset: offset,
        verticalPoints: verticalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($d41fc71850902515$var$HorizontalStripes, $d41fc71850902515$var$_extends({}, propsIncludingDefaults, {
        horizontalPoints: horizontalPoints
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement($d41fc71850902515$var$VerticalStripes, $d41fc71850902515$var$_extends({}, propsIncludingDefaults, {
        verticalPoints: verticalPoints
    })));
}
$d41fc71850902515$export$6440e27b9f186856.displayName = "CartesianGrid";

});

parcelRegister("97vSR", function(module, exports) {

$parcel$export(module.exports, "ChartContainer", function () { return $53388349dd251323$export$57a8e701bcb0acd5; });
$parcel$export(module.exports, "ChartTooltip", function () { return $53388349dd251323$export$1190a21963505760; });
$parcel$export(module.exports, "ChartLegend", function () { return $53388349dd251323$export$420ac06db41dd9da; });
$parcel$export(module.exports, "ChartLegendContent", function () { return $53388349dd251323$export$4d67e64145d42c58; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $8QGC8 = parcelRequire("8QGC8");
var $bMUfV = parcelRequire("bMUfV");
var $6SvzI = parcelRequire("6SvzI");

var $95Evz = parcelRequire("95Evz");
"use client";
// Format: { THEME_NAME: CSS_SELECTOR }
const $53388349dd251323$var$THEMES = {
    light: "",
    dark: ".dark"
};
const $53388349dd251323$var$ChartContext = /*#__PURE__*/ $jbmdS.createContext(null);
function $53388349dd251323$var$useChart() {
    const context = $jbmdS.useContext($53388349dd251323$var$ChartContext);
    if (!context) throw new Error("useChart must be used within a <ChartContainer />");
    return context;
}
const $53388349dd251323$export$57a8e701bcb0acd5 = /*#__PURE__*/ $jbmdS.forwardRef(({ id: id, className: className, children: children, config: config, ...props }, ref)=>{
    const uniqueId = $jbmdS.useId();
    const chartId = `chart-${id || uniqueId.replace(/:/g, "")}`;
    return /*#__PURE__*/ (0, $61Ea1.jsx)($53388349dd251323$var$ChartContext.Provider, {
        value: {
            config: config
        },
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            "data-chart": chartId,
            ref: ref,
            className: (0, $95Evz.cn)("flex aspect-video justify-center text-xs [&_.recharts-cartesian-axis-tick_text]:fill-muted-foreground [&_.recharts-cartesian-grid_line[stroke='#ccc']]:stroke-border/50 [&_.recharts-curve.recharts-tooltip-cursor]:stroke-border [&_.recharts-dot[stroke='#fff']]:stroke-transparent [&_.recharts-layer]:outline-none [&_.recharts-polar-grid_[stroke='#ccc']]:stroke-border [&_.recharts-radial-bar-background-sector]:fill-muted [&_.recharts-rectangle.recharts-tooltip-cursor]:fill-muted [&_.recharts-reference-line_[stroke='#ccc']]:stroke-border [&_.recharts-sector[stroke='#fff']]:stroke-transparent [&_.recharts-sector]:outline-none [&_.recharts-surface]:outline-none", className),
            ...props,
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsx)($53388349dd251323$export$efafd270352f3199, {
                    id: chartId,
                    config: config
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)($bMUfV.ResponsiveContainer, {
                    children: children
                })
            ]
        })
    });
});
$53388349dd251323$export$57a8e701bcb0acd5.displayName = "Chart";
const $53388349dd251323$export$efafd270352f3199 = ({ id: id, config: config })=>{
    const colorConfig = Object.entries(config).filter(([, config])=>config.theme || config.color);
    if (!colorConfig.length) return null;
    return /*#__PURE__*/ (0, $61Ea1.jsx)("style", {
        dangerouslySetInnerHTML: {
            __html: Object.entries($53388349dd251323$var$THEMES).map(([theme, prefix])=>`
${prefix} [data-chart=${id}] {
${colorConfig.map(([key, itemConfig])=>{
                    var _itemConfig$theme;
                    const color = ((_itemConfig$theme = itemConfig.theme) === null || _itemConfig$theme === void 0 ? void 0 : _itemConfig$theme[theme]) || itemConfig.color;
                    return color ? `  --color-${key}: ${color};` : null;
                }).join("\n")}
}
`).join("\n")
        }
    });
};
const $53388349dd251323$export$1190a21963505760 = $6SvzI.Tooltip;
const $53388349dd251323$export$3f14918d8c32fc4d = /*#__PURE__*/ $jbmdS.forwardRef(({ active: active, payload: payload, className: className, indicator: indicator = "dot", hideLabel: hideLabel = false, hideIndicator: hideIndicator = false, label: label, labelFormatter: labelFormatter, labelClassName: labelClassName, formatter: formatter, color: color, nameKey: nameKey, labelKey: labelKey }, ref)=>{
    const { config: config } = $53388349dd251323$var$useChart();
    const tooltipLabel = $jbmdS.useMemo(()=>{
        var _config;
        if (hideLabel || !(payload !== null && payload !== void 0 && payload.length)) return null;
        const [item] = payload;
        const key = `${labelKey || item.dataKey || item.name || "value"}`;
        const itemConfig = $53388349dd251323$var$getPayloadConfigFromPayload(config, item, key);
        const value = !labelKey && typeof label === "string" ? ((_config = config[label]) === null || _config === void 0 ? void 0 : _config.label) || label : itemConfig === null || itemConfig === void 0 ? void 0 : itemConfig.label;
        if (labelFormatter) return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            className: (0, $95Evz.cn)("font-medium", labelClassName),
            children: labelFormatter(value, payload)
        });
        if (!value) return null;
        return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            className: (0, $95Evz.cn)("font-medium", labelClassName),
            children: value
        });
    }, [
        label,
        labelFormatter,
        payload,
        hideLabel,
        labelClassName,
        config,
        labelKey
    ]);
    if (!active || !(payload !== null && payload !== void 0 && payload.length)) return null;
    const nestLabel = payload.length === 1 && indicator !== "dot";
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        ref: ref,
        className: (0, $95Evz.cn)("grid min-w-[8rem] items-start gap-1.5 rounded-lg border border-border/50 bg-background px-2.5 py-1.5 text-xs shadow-xl", className),
        children: [
            !nestLabel ? tooltipLabel : null,
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "grid gap-1.5",
                children: payload.map((item, index)=>{
                    const key = `${nameKey || item.name || item.dataKey || "value"}`;
                    const itemConfig = $53388349dd251323$var$getPayloadConfigFromPayload(config, item, key);
                    const indicatorColor = color || item.payload.fill || item.color;
                    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: (0, $95Evz.cn)("flex w-full flex-wrap items-stretch gap-2 [&>svg]:h-2.5 [&>svg]:w-2.5 [&>svg]:text-muted-foreground", indicator === "dot" && "items-center"),
                        children: formatter && (item === null || item === void 0 ? void 0 : item.value) !== undefined && item.name ? formatter(item.value, item.name, item, index, item.payload) : /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                            children: [
                                itemConfig !== null && itemConfig !== void 0 && itemConfig.icon ? /*#__PURE__*/ (0, $61Ea1.jsx)(itemConfig.icon, {}) : !hideIndicator && /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                    className: (0, $95Evz.cn)("shrink-0 rounded-[2px] border-[--color-border] bg-[--color-bg]", {
                                        "h-2.5 w-2.5": indicator === "dot",
                                        "w-1": indicator === "line",
                                        "w-0 border-[1.5px] border-dashed bg-transparent": indicator === "dashed",
                                        "my-0.5": nestLabel && indicator === "dashed"
                                    }),
                                    style: {
                                        "--color-bg": indicatorColor,
                                        "--color-border": indicatorColor
                                    }
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                    className: (0, $95Evz.cn)("flex flex-1 justify-between leading-none", nestLabel ? "items-end" : "items-center"),
                                    children: [
                                        /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                            className: "grid gap-1.5",
                                            children: [
                                                nestLabel ? tooltipLabel : null,
                                                /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                                    className: "text-muted-foreground",
                                                    children: (itemConfig === null || itemConfig === void 0 ? void 0 : itemConfig.label) || item.name
                                                })
                                            ]
                                        }),
                                        item.value && /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                            className: "font-mono font-medium tabular-nums text-foreground",
                                            children: item.value.toLocaleString()
                                        })
                                    ]
                                })
                            ]
                        })
                    }, item.dataKey);
                })
            })
        ]
    });
});
$53388349dd251323$export$3f14918d8c32fc4d.displayName = "ChartTooltip";
const $53388349dd251323$export$420ac06db41dd9da = $8QGC8.Legend;
const $53388349dd251323$export$4d67e64145d42c58 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, hideIcon: hideIcon = false, payload: payload, verticalAlign: verticalAlign = "bottom", nameKey: nameKey }, ref)=>{
    const { config: config } = $53388349dd251323$var$useChart();
    if (!(payload !== null && payload !== void 0 && payload.length)) return null;
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        ref: ref,
        className: (0, $95Evz.cn)("flex items-center justify-center gap-4", verticalAlign === "top" ? "pb-3" : "pt-3", className),
        children: payload.map((item)=>{
            const key = `${nameKey || item.dataKey || "value"}`;
            const itemConfig = $53388349dd251323$var$getPayloadConfigFromPayload(config, item, key);
            return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: (0, $95Evz.cn)("flex items-center gap-1.5 [&>svg]:h-3 [&>svg]:w-3 [&>svg]:text-muted-foreground"),
                children: [
                    itemConfig !== null && itemConfig !== void 0 && itemConfig.icon && !hideIcon ? /*#__PURE__*/ (0, $61Ea1.jsx)(itemConfig.icon, {}) : /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "h-2 w-2 shrink-0 rounded-[2px]",
                        style: {
                            backgroundColor: item.color
                        }
                    }),
                    itemConfig === null || itemConfig === void 0 ? void 0 : itemConfig.label
                ]
            }, item.value);
        })
    });
});
$53388349dd251323$export$4d67e64145d42c58.displayName = "ChartLegend";
// Helper to extract item config from a payload.
function $53388349dd251323$var$getPayloadConfigFromPayload(config, payload, key) {
    if (typeof payload !== "object" || payload === null) return undefined;
    const payloadPayload = "payload" in payload && typeof payload.payload === "object" && payload.payload !== null ? payload.payload : undefined;
    let configLabelKey = key;
    if (key in payload && typeof payload[key] === "string") configLabelKey = payload[key];
    else if (payloadPayload && key in payloadPayload && typeof payloadPayload[key] === "string") configLabelKey = payloadPayload[key];
    return configLabelKey in config ? config[configLabelKey] : config[key];
}

});
parcelRegister("bMUfV", function(module, exports) {

$parcel$export(module.exports, "ResponsiveContainer", function () { return $894fd0a6d4949f28$export$e60a4704009a0009; });

var $dWgPS = parcelRequire("dWgPS");

var $jbmdS = parcelRequire("jbmdS");

var $8blM9 = parcelRequire("8blM9");

var $1gmrG = parcelRequire("1gmrG");

var $aOmiF = parcelRequire("aOmiF");

var $f06D9 = parcelRequire("f06D9");
function $894fd0a6d4949f28$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $894fd0a6d4949f28$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $894fd0a6d4949f28$var$_typeof(o);
}
function $894fd0a6d4949f28$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $894fd0a6d4949f28$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $894fd0a6d4949f28$var$ownKeys(Object(t), !0).forEach(function(r) {
            $894fd0a6d4949f28$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $894fd0a6d4949f28$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $894fd0a6d4949f28$var$_defineProperty(obj, key, value) {
    key = $894fd0a6d4949f28$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $894fd0a6d4949f28$var$_toPropertyKey(t) {
    var i = $894fd0a6d4949f28$var$_toPrimitive(t, "string");
    return "symbol" == $894fd0a6d4949f28$var$_typeof(i) ? i : i + "";
}
function $894fd0a6d4949f28$var$_toPrimitive(t, r) {
    if ("object" != $894fd0a6d4949f28$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $894fd0a6d4949f28$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $894fd0a6d4949f28$var$_slicedToArray(arr, i) {
    return $894fd0a6d4949f28$var$_arrayWithHoles(arr) || $894fd0a6d4949f28$var$_iterableToArrayLimit(arr, i) || $894fd0a6d4949f28$var$_unsupportedIterableToArray(arr, i) || $894fd0a6d4949f28$var$_nonIterableRest();
}
function $894fd0a6d4949f28$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $894fd0a6d4949f28$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $894fd0a6d4949f28$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $894fd0a6d4949f28$var$_arrayLikeToArray(o, minLen);
}
function $894fd0a6d4949f28$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $894fd0a6d4949f28$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $894fd0a6d4949f28$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $894fd0a6d4949f28$export$e60a4704009a0009 = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(_ref, ref) {
    var aspect = _ref.aspect, _ref$initialDimension = _ref.initialDimension, initialDimension = _ref$initialDimension === void 0 ? {
        width: -1,
        height: -1
    } : _ref$initialDimension, _ref$width = _ref.width, width = _ref$width === void 0 ? "100%" : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? "100%" : _ref$height, _ref$minWidth = _ref.minWidth, minWidth = _ref$minWidth === void 0 ? 0 : _ref$minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, children = _ref.children, _ref$debounce = _ref.debounce, debounce = _ref$debounce === void 0 ? 0 : _ref$debounce, id = _ref.id, className = _ref.className, onResize = _ref.onResize, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style;
    var containerRef = (0, $jbmdS.useRef)(null);
    var onResizeRef = (0, $jbmdS.useRef)();
    onResizeRef.current = onResize;
    (0, $jbmdS.useImperativeHandle)(ref, function() {
        return Object.defineProperty(containerRef.current, "current", {
            get: function get() {
                // eslint-disable-next-line no-console
                console.warn("The usage of ref.current.current is deprecated and will no longer be supported.");
                return containerRef.current;
            },
            configurable: true
        });
    });
    var _useState = (0, $jbmdS.useState)({
        containerWidth: initialDimension.width,
        containerHeight: initialDimension.height
    }), _useState2 = $894fd0a6d4949f28$var$_slicedToArray(_useState, 2), sizes = _useState2[0], setSizes = _useState2[1];
    var setContainerSize = (0, $jbmdS.useCallback)(function(newWidth, newHeight) {
        setSizes(function(prevState) {
            var roundedWidth = Math.round(newWidth);
            var roundedHeight = Math.round(newHeight);
            if (prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight) return prevState;
            return {
                containerWidth: roundedWidth,
                containerHeight: roundedHeight
            };
        });
    }, []);
    (0, $jbmdS.useEffect)(function() {
        var callback = function callback(entries) {
            var _onResizeRef$current;
            var _entries$0$contentRec = entries[0].contentRect, containerWidth = _entries$0$contentRec.width, containerHeight = _entries$0$contentRec.height;
            setContainerSize(containerWidth, containerHeight);
            (_onResizeRef$current = onResizeRef.current) === null || _onResizeRef$current === void 0 || _onResizeRef$current.call(onResizeRef, containerWidth, containerHeight);
        };
        if (debounce > 0) callback = (0, (/*@__PURE__*/$parcel$interopDefault($8blM9)))(callback, debounce, {
            trailing: true,
            leading: false
        });
        var observer = new ResizeObserver(callback);
        var _containerRef$current = containerRef.current.getBoundingClientRect(), containerWidth = _containerRef$current.width, containerHeight = _containerRef$current.height;
        setContainerSize(containerWidth, containerHeight);
        observer.observe(containerRef.current);
        return function() {
            observer.disconnect();
        };
    }, [
        setContainerSize,
        debounce
    ]);
    var chartContent = (0, $jbmdS.useMemo)(function() {
        var containerWidth = sizes.containerWidth, containerHeight = sizes.containerHeight;
        if (containerWidth < 0 || containerHeight < 0) return null;
        (0, $aOmiF.warn)((0, $1gmrG.isPercent)(width) || (0, $1gmrG.isPercent)(height), "The width(%s) and height(%s) are both fixed numbers,\n       maybe you don't need to use a ResponsiveContainer.", width, height);
        (0, $aOmiF.warn)(!aspect || aspect > 0, "The aspect(%s) must be greater than zero.", aspect);
        var calculatedWidth = (0, $1gmrG.isPercent)(width) ? containerWidth : width;
        var calculatedHeight = (0, $1gmrG.isPercent)(height) ? containerHeight : height;
        if (aspect && aspect > 0) {
            // Preserve the desired aspect ratio
            if (calculatedWidth) // Will default to using width for aspect ratio
            calculatedHeight = calculatedWidth / aspect;
            else if (calculatedHeight) // But we should also take height into consideration
            calculatedWidth = calculatedHeight * aspect;
            // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
            if (maxHeight && calculatedHeight > maxHeight) calculatedHeight = maxHeight;
        }
        (0, $aOmiF.warn)(calculatedWidth > 0 || calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
        var isCharts = !Array.isArray(children) && (0, $f06D9.getDisplayName)(children.type).endsWith("Chart");
        return (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).Children.map(children, function(child) {
            if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).isValidElement(child)) return /*#__PURE__*/ (0, $jbmdS.cloneElement)(child, $894fd0a6d4949f28$var$_objectSpread({
                width: calculatedWidth,
                height: calculatedHeight
            }, isCharts ? {
                style: $894fd0a6d4949f28$var$_objectSpread({
                    height: "100%",
                    width: "100%",
                    maxHeight: calculatedHeight,
                    maxWidth: calculatedWidth
                }, child.props.style)
            } : {}));
            return child;
        });
    }, [
        aspect,
        children,
        height,
        maxHeight,
        minHeight,
        minWidth,
        sizes,
        width
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createElement("div", {
        id: id ? "".concat(id) : undefined,
        className: (0, $dWgPS.default)("recharts-responsive-container", className),
        style: $894fd0a6d4949f28$var$_objectSpread($894fd0a6d4949f28$var$_objectSpread({}, style), {}, {
            width: width,
            height: height,
            minWidth: minWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        }),
        ref: containerRef
    }, chartContent);
});

});



parcelRegister("k9RJX", function(module, exports) {

$parcel$export(module.exports, "RevenueForecastProfitTable", function () { return $bb98232b996f08ee$export$481ac2841fe1ab40; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $aYyI4 = parcelRequire("aYyI4");

var $aaosT = parcelRequire("aaosT");

var $khCHn = parcelRequire("khCHn");

var $27lKj = parcelRequire("27lKj");
parcelRequire("iaSLm");
var $4hBm1 = parcelRequire("4hBm1");

var $12o9H = parcelRequire("12o9H");

var $O2UPo = parcelRequire("O2UPo");

var $Yha9m = parcelRequire("Yha9m");
const $bb98232b996f08ee$export$481ac2841fe1ab40 = ()=>{
    const generateColumnDef = (0, $khCHn.createGenerateColumnDef)({
        onHideColumn: ()=>null
    });
    const storeData = (0, $27lKj.useData)();
    const dateRange = (0, $27lKj.useDateRange)();
    const overheadExpenses = (0, $27lKj.useOverheadExpenses)();
    const staffExpenses = (0, $27lKj.useStaffExpenses)();
    const months = (0, $jbmdS.useMemo)(()=>dateRange[0] && dateRange[1] ? (0, $4hBm1.eachMonthOfInterval)({
            start: (0, $4hBm1.parse)(dateRange[0], "yyyy-MM-dd", new Date()),
            end: (0, $4hBm1.parse)(dateRange[1], "yyyy-MM-dd", new Date())
        }) : [], [
        dateRange
    ]);
    const calculateMonthlyRevenue = (month)=>{
        const monthKey = (0, $4hBm1.format)(month, "yyyy-MM");
        let total = 0;
        storeData.forEach((statusGroup)=>{
            const projected = statusGroup[`${monthKey}-P`] || 0;
            const actual = statusGroup[`${monthKey}-A`] || 0;
            const currentMonthKey = (0, $4hBm1.format)(new Date(), "yyyy-MM");
            if (monthKey < currentMonthKey) total += actual;
            else total += projected;
        });
        return total;
    };
    const calculateMonthlyExpenses = (month)=>{
        const monthKey = (0, $4hBm1.format)(month, "yyyy-MM");
        let overhead = 0;
        let staff = 0;
        if (Array.isArray(overheadExpenses)) overhead = overheadExpenses.reduce((sum, expense)=>{
            const value = expense[monthKey];
            const numValue = typeof value === "string" ? parseFloat(value) : value;
            return sum + (numValue || 0);
        }, 0);
        if (Array.isArray(staffExpenses)) staff = staffExpenses.reduce((sum, expense)=>{
            const value = expense[monthKey];
            const numValue = typeof value === "string" ? parseFloat(value) : value;
            return sum + (numValue || 0);
        }, 0);
        return overhead + staff;
    };
    const data = (0, $jbmdS.useMemo)(()=>{
        const rows = [
            {
                label: "Profit",
                total: 0
            },
            {
                label: "Profit Margin",
                total: 0
            }
        ];
        let totalRevenue = 0;
        let totalExpenses = 0;
        months.forEach((month)=>{
            const monthKey = (0, $4hBm1.format)(month, "yyyy-MM");
            const revenue = calculateMonthlyRevenue(month);
            const expenses = calculateMonthlyExpenses(month);
            const profit = revenue - expenses;
            const profitMargin = revenue > 0 ? profit / revenue * 100 : 0;
            totalRevenue += revenue;
            totalExpenses += expenses;
            rows[0][monthKey] = profit;
            rows[1][monthKey] = profitMargin;
        });
        const totalProfit = totalRevenue - totalExpenses;
        const totalProfitMargin = totalRevenue > 0 ? totalProfit / totalRevenue * 100 : 0;
        rows[0].total = totalProfit;
        rows[1].total = totalProfitMargin;
        return rows;
    }, [
        months,
        storeData,
        overheadExpenses,
        staffExpenses
    ]);
    const columns = (0, $jbmdS.useMemo)(()=>[
            generateColumnDef({
                key: "label",
                title: "",
                type: "string",
                size: 190
            }),
            generateColumnDef({
                key: "total",
                title: "Total",
                type: "string",
                size: 120,
                customValue: (row)=>{
                    if (row.label === "Profit") return (0, $12o9H.FormatCurrency)(row.total, {
                        decimals: 0
                    });
                    return `${row.total.toFixed(1)}%`;
                },
                cellClassName: (row)=>{
                    if (!row || !row.original.total) return "";
                    const total = row.original.total;
                    if (total < 0) return "text-red-500";
                    return "";
                }
            }),
            ...months.map((month)=>generateColumnDef({
                    key: (0, $4hBm1.format)(month, "yyyy-MM"),
                    title: (0, $4hBm1.format)(month, "MMM yy"),
                    type: "string",
                    size: 120,
                    customValue: (row)=>{
                        const monthKey = (0, $4hBm1.format)(month, "yyyy-MM");
                        const monthValue = row[monthKey];
                        if (row.label === "Profit") return (0, $12o9H.FormatCurrency)(monthValue, {
                            decimals: 0
                        });
                        return `${monthValue.toFixed(1)}%`;
                    },
                    cellClassName: (row)=>{
                        var _row$original;
                        const monthKey = (0, $4hBm1.format)(month, "yyyy-MM");
                        if (!row || !((_row$original = row.original) !== null && _row$original !== void 0 && _row$original[monthKey])) return "";
                        const value = row.original[monthKey];
                        const isPastMonth = (0, $4hBm1.format)(month, "yyyy-MM") < (0, $4hBm1.format)(new Date(), "yyyy-MM");
                        return (0, $Yha9m.cn)(isPastMonth && "bg-diagonal-pattern", value < 0 && "text-red-500");
                    }
                }))
        ], [
        months,
        generateColumnDef
    ]);
    const visibleColumns = (0, $jbmdS.useMemo)(()=>columns.map((col)=>col.accessorKey || col.id), [
        columns
    ]);
    const { table: table } = (0, $aaosT.useDataTable)({
        data: data,
        columns: columns,
        visibleColumns: visibleColumns,
        sortingFns: {
            sortingTextFn: $O2UPo.sortingTextFn,
            sortingDateFn: $O2UPo.sortingDateFn
        }
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "mt-8",
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("h2", {
                className: "text-xl font-semibold mb-4 pl-4",
                children: "Profit"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $aYyI4.DataTable), {
                table: table,
                showTotals: false,
                className: "w-full"
            })
        ]
    });
};

});


parcelRegister("iuUqi", function(module, exports) {

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $6Q5sp = parcelRequire("6Q5sp");

var $3h7sC = parcelRequire("3h7sC");

var $27lKj = parcelRequire("27lKj");

var $AwhfW = parcelRequire("AwhfW");
const $b676af7a2fedad14$export$7b46c169ebba380b = ()=>{
    var _sidebarProject$fee, _sidebarProject$expen, _sidebarProject$reven, _sidebarProject$expen2;
    const selectedRow = (0, $27lKj.useSelectedRow)();
    const selectedMonth = (0, $27lKj.useSelectedMonth)();
    const sidebarProject = (0, $27lKj.useSidebarProject)();
    const sidebarResourcing = (0, $27lKj.useSidebarResourcing)();
    (0, $jbmdS.useEffect)(()=>{
        if (selectedMonth) (0, $27lKj.setSidebarMonth)(selectedMonth);
    }, [
        selectedMonth
    ]);
    (0, $jbmdS.useEffect)(()=>{
        async function fetchData() {
            if (!selectedMonth || !(selectedRow !== null && selectedRow !== void 0 && selectedRow.projectId)) {
                console.log("Missing required data:", {
                    selectedMonth: selectedMonth,
                    selectedRow: selectedRow
                });
                return;
            }
            console.log("Fetching data for:", {
                selectedMonth: selectedMonth,
                selectedRow: selectedRow
            });
            try {
                const projectData = await (0, $6Q5sp.queryClient).fetchQuery([
                    "revenueForecast.getProjectDetails",
                    {
                        month: selectedMonth,
                        projectId: selectedRow.projectId
                    }
                ], async ()=>{
                    console.log("Making project details request");
                    const result = await (0, $3h7sC.trpc).revenueForecast.getProjectDetails.query({
                        month: selectedMonth,
                        projectId: selectedRow.projectId
                    });
                    console.log("Project details response:", result);
                    return result;
                });
                (0, $27lKj.setSidebarProject)(projectData);
                const resourcingData = await (0, $6Q5sp.queryClient).fetchQuery([
                    "revenueForecast.getResourcingData",
                    {
                        month: selectedMonth
                    }
                ], async ()=>{
                    console.log("Making resourcing data request");
                    const result = await (0, $3h7sC.trpc).revenueForecast.getResourcingData.query({
                        month: selectedMonth
                    });
                    console.log("Resourcing data response:", result);
                    return result;
                });
                (0, $27lKj.setSidebarResourcing)(resourcingData);
            } catch (error) {
                console.error("Error fetching sidebar data:", error);
            }
        }
        fetchData();
    }, [
        selectedMonth,
        selectedRow
    ]);
    if (!selectedMonth || !(selectedRow !== null && selectedRow !== void 0 && selectedRow.projectId)) return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "p-4",
        children: /*#__PURE__*/ (0, $61Ea1.jsx)("p", {
            className: "text-gray-500",
            children: "Select a row and month to view details"
        })
    });
    const [amount, setAmount] = (0, $jbmdS.useState)(500);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "p-4 space-y-6",
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $AwhfW.GradientSlider), {
                total: 750,
                prevAmount: 0,
                amount: amount,
                onChange: setAmount,
                height: 4,
                editable: true
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("h3", {
                        className: "text-lg font-semibold mb-2",
                        children: "Project Details"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "space-y-2",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                        className: "font-medium",
                                        children: "Title:"
                                    }),
                                    " ",
                                    sidebarProject.title
                                ]
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                        className: "font-medium",
                                        children: "Fee:"
                                    }),
                                    " $",
                                    (_sidebarProject$fee = sidebarProject.fee) === null || _sidebarProject$fee === void 0 ? void 0 : _sidebarProject$fee.toLocaleString()
                                ]
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                        className: "font-medium",
                                        children: "Budget:"
                                    }),
                                    " $",
                                    (_sidebarProject$expen = sidebarProject.expenseBudget) === null || _sidebarProject$expen === void 0 ? void 0 : _sidebarProject$expen.toLocaleString()
                                ]
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                        className: "font-medium",
                                        children: "Hours:"
                                    }),
                                    " ",
                                    sidebarProject.hoursBudget
                                ]
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                        className: "font-medium",
                                        children: "Revenue:"
                                    }),
                                    " $",
                                    (_sidebarProject$reven = sidebarProject.revenue) === null || _sidebarProject$reven === void 0 ? void 0 : _sidebarProject$reven.toLocaleString()
                                ]
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                        className: "font-medium",
                                        children: "Expenses:"
                                    }),
                                    " $",
                                    (_sidebarProject$expen2 = sidebarProject.expense) === null || _sidebarProject$expen2 === void 0 ? void 0 : _sidebarProject$expen2.toLocaleString()
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("h3", {
                        className: "text-lg font-semibold mb-2",
                        children: "Phases"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "space-y-4",
                        children: sidebarProject.phases.map((phase)=>{
                            var _phase$fee, _phase$expenseBudget;
                            return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                className: "border-l-2 border-gray-200 pl-3",
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("p", {
                                        className: "font-medium",
                                        children: phase.title
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsxs)("p", {
                                        children: [
                                            "Fee: $",
                                            (_phase$fee = phase.fee) === null || _phase$fee === void 0 ? void 0 : _phase$fee.toLocaleString()
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsxs)("p", {
                                        children: [
                                            "Budget: $",
                                            (_phase$expenseBudget = phase.expenseBudget) === null || _phase$expenseBudget === void 0 ? void 0 : _phase$expenseBudget.toLocaleString()
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsxs)("p", {
                                        children: [
                                            "Hours: ",
                                            phase.hoursBudget
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsxs)("p", {
                                        children: [
                                            "Status: ",
                                            phase.status
                                        ]
                                    })
                                ]
                            }, phase.id);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("h3", {
                        className: "text-lg font-semibold mb-2",
                        children: "Resourcing"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "space-y-4",
                        children: sidebarResourcing.staff.map((member)=>{
                            const allocations = sidebarResourcing.allocations.filter((a)=>a.staffId === member.id);
                            const role = sidebarResourcing.roles.find((r)=>r.id === member.roleId);
                            return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                className: "border-l-2 border-gray-200 pl-3",
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("p", {
                                        className: "font-medium",
                                        children: member.name
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsxs)("p", {
                                        children: [
                                            "Role: ",
                                            (role === null || role === void 0 ? void 0 : role.name) || "No Role"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsxs)("p", {
                                        children: [
                                            "Availability: ",
                                            member.availability,
                                            "h"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsxs)("p", {
                                        children: [
                                            "Cost Rate: $",
                                            member.costRate,
                                            "/h"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsxs)("p", {
                                        children: [
                                            "Allocated:",
                                            " ",
                                            allocations.reduce((sum, a)=>sum + a.hours, 0),
                                            "h"
                                        ]
                                    })
                                ]
                            }, member.id);
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("AwhfW", function(module, exports) {

$parcel$export(module.exports, "GradientSlider", function () { return $8897d84e72bddc2c$export$187ae9d96d32548; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $bESZf = parcelRequire("bESZf");

var $95Evz = parcelRequire("95Evz");
"use client";
const $8897d84e72bddc2c$export$472062a354075cee = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, rootClassName: rootClassName, trackClassName: trackClassName, rangeClassName: rangeClassName, thumbClassName: thumbClassName, markClassName: markClassName, marks: marks = [], style: style, ...props }, ref)=>{
    console.log("style", style);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)($bESZf.Root, {
        ref: ref,
        className: (0, $95Evz.cn)("relative flex w-full touch-none select-none items-center", rootClassName, className),
        ...props,
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)($bESZf.Track, {
                className: (0, $95Evz.cn)("relative h-2 w-full grow overflow-hidden rounded-full bg-secondary", trackClassName),
                children: /*#__PURE__*/ (0, $61Ea1.jsx)($bESZf.Range, {
                    className: (0, $95Evz.cn)("absolute h-full bg-primary slider-range", rangeClassName),
                    style: style
                })
            }),
            marks.length > 0 && marks.map((mark)=>/*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                    className: (0, $95Evz.cn)("absolute top-1/2 -translate-x-1/2 -translate-y-1/2 w-1.5 h-1.5 rounded-full bg-primary", markClassName),
                    style: {
                        left: `${mark / (props.max || 100) * 100}%`
                    }
                }, mark)),
            /*#__PURE__*/ (0, $61Ea1.jsx)($bESZf.Thumb, {
                className: (0, $95Evz.cn)("block h-5 w-5 rounded-full border-2 border-primary bg-background ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50", thumbClassName)
            })
        ]
    });
});
$8897d84e72bddc2c$export$472062a354075cee.displayName = $bESZf.Root.displayName;
const $8897d84e72bddc2c$var$calculateProgressValues = (total, prevAmount, amount)=>{
    const maxAmount = Math.max(prevAmount + amount, total);
    const maxProgress = maxAmount / (total || 1);
    const prevProgress = prevAmount / (total || 1);
    const currentProgress = (prevAmount + amount) / (total || 1);
    return {
        maxAmount: maxAmount,
        maxProgress: maxProgress,
        prevProgress: prevProgress,
        currentProgress: currentProgress
    };
};
const $8897d84e72bddc2c$var$getGradientColors = (currentProgress)=>{
    let progressGradient = {
        "0%": "#108ee9"
    };
    let finalColour = "#108ee9";
    progressGradient[`${Math.round(0.5 / currentProgress * 100)}%`] = "#87d068";
    if (currentProgress > 0.4) finalColour = "#87d068";
    if (currentProgress > 0.8) {
        progressGradient[`${Math.round(0.8 / currentProgress * 100)}%`] = "#ffc200";
        finalColour = "#ffc200";
    }
    if (currentProgress > 1) {
        progressGradient[`${Math.round(1 / currentProgress * 100)}%`] = "#ff5800";
        finalColour = "#ff5800";
    }
    return {
        progressGradient: progressGradient,
        finalColour: finalColour
    };
};
const $8897d84e72bddc2c$var$getRangeStyle = (progressGradient, total, height)=>({
        background: total ? `linear-gradient(to right, ${Object.entries(progressGradient).map(([key, value])=>`${value} ${key}`).join(", ")})` : "#f5f5f5",
        height: `${height}px`
    });
const $8897d84e72bddc2c$export$187ae9d96d32548 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, total: total, prevAmount: prevAmount, amount: amount, height: height = 4, editable: editable = true, onChange: onChange, ...props }, ref)=>{
    const [sliderFocused, setSliderFocused] = $jbmdS.useState(false);
    const { maxAmount: maxAmount, maxProgress: maxProgress, prevProgress: prevProgress, currentProgress: currentProgress } = $8897d84e72bddc2c$var$calculateProgressValues(total, prevAmount, amount);
    const { progressGradient: progressGradient, finalColour: finalColour } = $8897d84e72bddc2c$var$getGradientColors(currentProgress);
    const handleValueChange = (v)=>{
        if (!sliderFocused || !total || !onChange) return;
        const value = v[0];
        if (value === Math.round(prevProgress * 100)) return onChange(0);
        if (value === Math.round(maxProgress * 100)) return onChange(maxAmount - prevAmount);
        return onChange(Math.max(value / 100, prevProgress) * total - prevAmount);
    };
    return /*#__PURE__*/ (0, $61Ea1.jsx)($8897d84e72bddc2c$export$472062a354075cee, {
        ref: ref,
        className: className,
        value: total ? [
            currentProgress * 100
        ] : [],
        max: total ? Math.max(maxProgress, currentProgress) * 100 : 0,
        onValueChange: handleValueChange,
        rangeClassName: (0, $95Evz.cn)("absolute h-full", total ? "" : "bg-[#f5f5f5]"),
        style: {
            background: $8897d84e72bddc2c$var$getRangeStyle(progressGradient, total, height).background
        },
        thumbClassName: (0, $95Evz.cn)("block h-5 w-5 rounded-full border-2 bg-background", `border-[${finalColour}]`),
        marks: total ? [
            prevProgress * 100
        ] : [],
        disabled: !editable || !total,
        onFocus: ()=>setSliderFocused(true),
        onBlur: ()=>setSliderFocused(false),
        ...props
    });
});
$8897d84e72bddc2c$export$187ae9d96d32548.displayName = "GradientSlider";

});



parcelRegister("lGluJ", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $fc8e319ed40a57f9$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");

var $e1rsZ = parcelRequire("e1rsZ");

var $k4clm = parcelRequire("k4clm");

var $kuPRw = parcelRequire("kuPRw");

var $bZfKS = parcelRequire("bZfKS");

var $a9PLH = parcelRequire("a9PLH");

var $4iw5i = parcelRequire("4iw5i");

var $5PXcS = parcelRequire("5PXcS");

var $1BTI2 = parcelRequire("1BTI2");

var $47i9t = parcelRequire("47i9t");

var $8kZ1o = parcelRequire("8kZ1o");

var $7qobO = parcelRequire("7qobO");

var $26sX2 = parcelRequire("26sX2");

var $38AIP = parcelRequire("38AIP");

var $kqntg = parcelRequire("kqntg");

var $3RaC0 = parcelRequire("3RaC0");

var $27lKj = parcelRequire("27lKj");

var $4hBm1 = parcelRequire("4hBm1");
parcelRequire("SRJCe");
parcelRequire("jbmdS");

var $3h7sC = parcelRequire("3h7sC");
const $fc8e319ed40a57f9$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_private/revenue-forecast")({
    beforeLoad: ({ params: params, search: search })=>{
        if (!(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "revenueForecast", params)) throw new Error("Permission Denied");
        const report = (0, $38AIP.getCacheItemById)("revenueForecastReports", search.report);
        (0, $26sX2.setLayoutDefaults)({
            pageTitle: (report === null || report === void 0 ? void 0 : report.name) || "Revenue Forecast",
            subMenu: "organisation",
            showSidebar: true,
            sidebarExpanded: false
        });
    },
    errorComponent: ({ error: error, reset: reset })=>{
        if (error.message === "Permission Denied") return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7qobO.default), {});
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    },
    component: $fc8e319ed40a57f9$var$Wrapper,
    pendingComponent: (0, $4iw5i.default),
    loader: async ({ location: location })=>await $fc8e319ed40a57f9$var$loader(location.search),
    loaderDeps: ({ search: { report: report, startDate: startDate } })=>({
            report: report,
            startDate: startDate
        })
});
const $fc8e319ed40a57f9$var$getDefaultDateRange = ()=>{
    const start = (0, $4hBm1.subMonths)((0, $4hBm1.startOfMonth)(new Date()), 3);
    const end = (0, $4hBm1.addMonths)(start, 11); // 12 months including start month
    return [
        (0, $4hBm1.format)(start, "yyyy-MM-dd"),
        (0, $4hBm1.format)(end, "yyyy-MM-dd")
    ];
};
const $fc8e319ed40a57f9$var$loader = async ({ report: report, startDate: startDate })=>{
    var _SessionStore$organis;
    const reportId = report || ((_SessionStore$organis = (0, $1BTI2.default).organisation) === null || _SessionStore$organis === void 0 ? void 0 : _SessionStore$organis.defaultRevenueForecastReportId);
    if ((0, $8kZ1o.migratedToV2)()) {
        const dateRange = startDate ? [
            startDate,
            (0, $4hBm1.format)((0, $4hBm1.addMonths)(new Date(startDate), 11), "yyyy-MM-dd")
        ] : $fc8e319ed40a57f9$var$getDefaultDateRange();
        // First fetch the report if specified
        let filters = {};
        if (report) {
            const reportData = await (0, $3h7sC.trpc).revenueForecast.getRevenueForecastReport.query({
                id: report
            });
            (0, $27lKj.setReport)(reportData);
            filters = reportData.filters;
        }
        // Load initial data with filters from report
        await (0, $27lKj.fetchForecastData)(dateRange, filters);
        (0, $27lKj.setDateRange)(dateRange);
    }
    const data = await (0, $3h7sC.trpc).legacy.getRevenueForecastPageData.query({
        reportId: reportId
    });
    return (0, $47i9t.processTRPCData)(data);
};
function $fc8e319ed40a57f9$var$Wrapper() {
    if ((0, $8kZ1o.migratedToV2)()) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqntg.PageBody), {
            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3RaC0.RevenueForecastPage), {})
        })
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $e1rsZ.default), {
                ...$fc8e319ed40a57f9$export$e7b0ac011bb776c6.useParams(),
                ...$fc8e319ed40a57f9$export$e7b0ac011bb776c6.useSearch()
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kuPRw.default), {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $k4clm.default), {
                    ...$fc8e319ed40a57f9$export$e7b0ac011bb776c6.useParams(),
                    ...$fc8e319ed40a57f9$export$e7b0ac011bb776c6.useSearch()
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bZfKS.default), {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $a9PLH.default), {
                    ...$fc8e319ed40a57f9$export$e7b0ac011bb776c6.useParams(),
                    ...$fc8e319ed40a57f9$export$e7b0ac011bb776c6.useSearch()
                })
            })
        ]
    });
}

});

parcelRegister("gvozO", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $c0429af8d9a3c500$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");

var $bDZDc = parcelRequire("bDZDc");

var $f3YEy = parcelRequire("f3YEy");

var $kuPRw = parcelRequire("kuPRw");

var $bZfKS = parcelRequire("bZfKS");

var $4DICt = parcelRequire("4DICt");
parcelRequire("jE5CX");

var $1BTI2 = parcelRequire("1BTI2");

var $8kZ1o = parcelRequire("8kZ1o");

var $47i9t = parcelRequire("47i9t");

var $4iw5i = parcelRequire("4iw5i");

var $5PXcS = parcelRequire("5PXcS");

var $7qobO = parcelRequire("7qobO");

var $26sX2 = parcelRequire("26sX2");

var $38AIP = parcelRequire("38AIP");

var $kqntg = parcelRequire("kqntg");

var $SRJCe = parcelRequire("SRJCe");

var $jbmdS = parcelRequire("jbmdS");

var $3h7sC = parcelRequire("3h7sC");
const $c0429af8d9a3c500$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_private/resource-schedule")({
    beforeLoad: ({ params: params, search: search })=>{
        if (!(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "resourceSchedule", params)) throw new Error("Permission Denied");
        const report = (0, $38AIP.getCacheItemById)("resourceScheduleReports", search.report);
        (0, $26sX2.setLayoutDefaults)({
            pageTitle: (report === null || report === void 0 ? void 0 : report.name) || "Resource Schedule",
            subMenu: "organisation"
        });
    },
    errorComponent: ({ error: error, reset: reset })=>{
        if (error.message === "Permission Denied") return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7qobO.default), {});
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    },
    component: $c0429af8d9a3c500$var$Wrapper,
    pendingComponent: (0, $4iw5i.default),
    loader: async ({ location: location })=>await $c0429af8d9a3c500$var$loader(location.search),
    loaderDeps: ({ search: { report: report } })=>({
            report: report
        })
});
const $c0429af8d9a3c500$var$loader = async ({ report: report })=>{
    var _SessionStore$organis;
    const reportId = report || ((_SessionStore$organis = (0, $1BTI2.default).organisation) === null || _SessionStore$organis === void 0 ? void 0 : _SessionStore$organis.defaultResourceScheduleReportId);
    const data = await (0, $3h7sC.trpc).legacy.getResourceSchedulePageData.query({});
    return (0, $47i9t.processTRPCData)(data);
};
function $c0429af8d9a3c500$var$Wrapper() {
    const { addToSidebar: addToSidebar } = (0, $SRJCe.useSidebarStack)();
    (0, $jbmdS.useEffect)(()=>{
        addToSidebar(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $4DICt.default), {}));
    }, []);
    if ((0, $8kZ1o.migratedToV2)()) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqntg.CenterPadPageBody), {
            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $f3YEy.default), {
                ...$c0429af8d9a3c500$export$e7b0ac011bb776c6.useParams(),
                ...$c0429af8d9a3c500$export$e7b0ac011bb776c6.useSearch()
            })
        })
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bDZDc.default), {
                ...$c0429af8d9a3c500$export$e7b0ac011bb776c6.useParams(),
                ...$c0429af8d9a3c500$export$e7b0ac011bb776c6.useSearch()
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kuPRw.default), {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $f3YEy.default), {
                    ...$c0429af8d9a3c500$export$e7b0ac011bb776c6.useParams(),
                    ...$c0429af8d9a3c500$export$e7b0ac011bb776c6.useSearch()
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bZfKS.default), {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $4DICt.default), {
                    ...$c0429af8d9a3c500$export$e7b0ac011bb776c6.useParams(),
                    ...$c0429af8d9a3c500$export$e7b0ac011bb776c6.useSearch()
                })
            })
        ]
    });
}

});
parcelRegister("bDZDc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87a324e64d42ec28$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $1EEMt = parcelRequire("1EEMt");

var $cHSsl = parcelRequire("cHSsl");

var $4iwZm = parcelRequire("4iwZm");
parcelRequire("1BTI2");

var $36Jjh = parcelRequire("36Jjh");

var $6eCWq = parcelRequire("6eCWq");
parcelRequire("fM2j4");

var $3X7oM = parcelRequire("3X7oM");

var $ewAM3 = parcelRequire("ewAM3");
var $87a324e64d42ec28$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(()=>{
    const [store, setStore] = (0, $jbmdS.useState)((0, $6eCWq.default));
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $36Jjh.default), {
        heading: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: "Resource Schedule"
            })
        }),
        extraContent: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $cHSsl.default), {
            store: store,
            report: store.report,
            reportOptions: (0, $4iwZm.default).resourceSchedules.filter((r)=>!r.deletedAt),
            baseUrl: "/projects"
        }),
        rightButtons: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            className: "flex items-center gap-2",
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3X7oM.default), {
                    label: store.expandAll ? "Collapse All" : "Expand All",
                    className: "export-button page-header__button",
                    onClick: ()=>store.setExpandAll(!store.expandAll),
                    icon: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                        className: `fa fa-${store.expandAll ? "minus" : "plus"}`
                    })
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    className: "export-button-dropdown inline-flex items-center dont-print gap-2",
                    children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3X7oM.default), {
                                label: "Export",
                                icon: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                    className: "fa fa-table"
                                }),
                                onClick: ()=>{
                                    store.downloadCSV();
                                },
                                className: "border-r-0 rounded-tr-none rounded-br-none"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                                className: " border! border-white bg-transparent hover:bg-white/25 transition-colors rounded-[6px] rounded-tl-none rounded-bl-none",
                                style: {
                                    maxWidth: "8em",
                                    margin: 0,
                                    fontSize: "1em",
                                    background: "transparent"
                                },
                                value: store.exportGroup,
                                options: store.report.filters.groups,
                                optionLabel: function(group) {
                                    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        className: "capitalize",
                                        children: group
                                    });
                                },
                                onChange: (group)=>store.setExportGroup(group)
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3X7oM.default), {
                    label: "Print",
                    icon: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                        className: "fa fa-print"
                    }),
                    onClick: ()=>window.print()
                })
            ]
        })
    });
});

});
parcelRegister("cHSsl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9403be097794d811$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $02LyB = parcelRequire("02LyB");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("h6zQv");

var $khJQv = parcelRequire("khJQv");

var $e8Hda = parcelRequire("e8Hda");
parcelRequire("fEtu5");
var $avIhR = parcelRequire("avIhR");
var $e4TNX = parcelRequire("e4TNX");
parcelRequire("cnmvx");
parcelRequire("ek5Pm");

var $c86dX = parcelRequire("c86dX");
parcelRequire("dtopU");

var $eRflC = parcelRequire("eRflC");

var $fM2j4 = parcelRequire("fM2j4");

var $8ppo6 = parcelRequire("8ppo6");
parcelRequire("6OUQ7");

var $52dEm = parcelRequire("52dEm");

var $ikffN = parcelRequire("ikffN");

var $eNcHX = parcelRequire("eNcHX");

var $gJT7h = parcelRequire("gJT7h");

var $htkeB = parcelRequire("htkeB");

var $bxXv3 = parcelRequire("bxXv3");

var $ewAM3 = parcelRequire("ewAM3");

var $ahtQ4 = parcelRequire("ahtQ4");

var $3X7oM = parcelRequire("3X7oM");

var $6UBLf = parcelRequire("6UBLf");

var $eat5C = parcelRequire("eat5C");
var $9403be097794d811$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ store: store, report: report, reportOptions: reportOptions = [] })=>{
    const [expandReportEditor, setExpandReportEditor] = (0, $jbmdS.useState)(false);
    const navigate = (0, $6UBLf.useNavigate)();
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "report-selector flex items-center gap-2 mt-7",
                children: [
                    "Report: ",
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                        className: "flex-0-0-auto page-header__button",
                        style: {
                            marginLeft: "1em"
                        },
                        value: report,
                        options: reportOptions,
                        searchMatcher: function(report, searchText) {
                            return (0, $e8Hda.caseInsensitiveContains)(report.name, searchText);
                        },
                        optionLabel: function(report) {
                            return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                children: report.name
                            });
                        },
                        onChange: (report)=>navigate({
                                search: (prev)=>({
                                        ...prev,
                                        report: report.id
                                    })
                            })
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                className: "flex",
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("py-2 px-4 border border-white text-xs", store.periodType === "month" ? "bg-white text-black" : "text-white bg-transparent"),
                                        style: {
                                            margin: 0,
                                            borderRadius: "0.5rem 0 0 0.5rem"
                                        },
                                        onClick: ()=>store.setPeriodType("month"),
                                        children: "Monthly"
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("py-2 px-4 border border-white text-xs", store.periodType === "week" ? "bg-white text-black" : "text-white bg-transparent"),
                                        style: {
                                            margin: 0,
                                            borderRadius: "0 0.5rem 0.5rem 0"
                                        },
                                        onClick: ()=>store.setPeriodType("week"),
                                        children: "Weekly"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3X7oM.default), {
                                label: expandReportEditor ? "Hide " : "Edit ",
                                icon: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("fa m-0", expandReportEditor ? "fa-angle-double-up" : "fa-angle-double-down")
                                }),
                                onClick: ()=>setExpandReportEditor(!expandReportEditor)
                            }),
                            expandReportEditor ? /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)($9403be097794d811$var$ReportSaveDropdown, {
                                        report: report
                                    }),
                                    !report.systemReport ? /*#__PURE__*/ (0, $61Ea1.jsx)($9403be097794d811$var$ReportActionsDropdown, {
                                        report: report
                                    }) : null
                                ]
                            }) : null,
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3X7oM.default), {
                                label: "+ Add Resource",
                                onClick: ()=>{
                                    (0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $ahtQ4.default), {
                                        modalId: "add-staff-to-resources",
                                        report: report
                                    }));
                                }
                            })
                        ]
                    })
                ]
            }),
            expandReportEditor ? /*#__PURE__*/ (0, $61Ea1.jsx)($9403be097794d811$var$ReportEditor, {
                report: report,
                store: store
            }) : null
        ]
    });
});
const $9403be097794d811$var$ReportSaveDropdown = (0, $1EEMt.observer)(({ report: report })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $avIhR.Dropdown3), {
        // isExpanded={this.props.isExpanded}
        // onToggle={this.handleToggle}
        toggleElement: /*#__PURE__*/ (0, $61Ea1.jsxs)("button", {
            className: "primary flex items-center gap-1 py-2 px-4 border border-white bg-transparent hover:bg-white/25 transition-colors rounded-[6px] text-xs",
            children: [
                "Save",
                /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                    className: "rw-i rw-i-caret-down"
                })
            ]
        }),
        contentStyle: {
            width: "14em",
            color: "#444",
            borderRadius: "0.5em"
        },
        children: [
            !report.systemReport ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $avIhR.Dropdown3ListItem), {
                style: {
                    padding: "0.5em 1em",
                    height: "2.5em"
                },
                className: "report-save-dropdown__save-option",
                onClick: ()=>(0, $fM2j4.default).saveModel(report),
                children: "Save"
            }) : null,
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $avIhR.Dropdown3ListItem), {
                style: {
                    padding: "0.5em 1em",
                    height: "2.5em"
                },
                onClick: ()=>{
                    (0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $8ppo6.default), {
                        report: report,
                        modalId: "saveAsReport"
                    }));
                },
                children: "Save As..."
            })
        ]
    });
});
const $9403be097794d811$var$ReportActionsDropdown = (0, $1EEMt.observer)(({ report: report })=>{
    const navigate = (0, $6UBLf.useNavigate)();
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $avIhR.Dropdown3), {
        // isExpanded={this.props.isExpanded}
        // onToggle={this.handleToggle}
        toggleElement: /*#__PURE__*/ (0, $61Ea1.jsxs)("button", {
            className: "primary flex items-center gap-1 ml-2 py-2 px-4 border border-white bg-transparent hover:bg-white/25 transition-colors rounded-[6px] text-xs",
            children: [
                "Actions",
                /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                    className: "rw-i rw-i-caret-down",
                    style: {
                        marginLeft: "0.5em"
                    }
                })
            ]
        }),
        contentStyle: {
            width: "18em",
            color: "#444",
            borderRadius: "0.5em"
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $avIhR.Dropdown3ListItem), {
                style: {
                    padding: "0.5em 1em",
                    height: "2.5em"
                },
                onClick: ()=>{
                    report.makeDefault();
                    (0, $fM2j4.default).saveModel(report);
                },
                children: "Set As Default"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $avIhR.Dropdown3ListItem), {
                style: {
                    padding: "0.5em 1em",
                    height: "2.5em"
                },
                onClick: ()=>{
                    (0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $eRflC.default), {
                        report: report,
                        modalId: "renameReport"
                    }));
                },
                children: "Rename"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $avIhR.Dropdown3ListItem), {
                style: {
                    padding: "0.5em 1em",
                    height: "2.5em"
                },
                onClick: ()=>{
                    report.update({
                        deletedAt: new Date()
                    });
                    (0, $fM2j4.default).saveModel(report);
                    navigate({
                        search: (prev)=>(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).omitBy({
                                ...prev,
                                report: null
                            }, (v)=>v === null)
                    });
                },
                children: "Delete"
            })
        ]
    });
});
const $9403be097794d811$var$ReportEditor = (0, $1EEMt.observer)(({ report: report, store: store })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "dont-print py-6 border-t border-[#666]",
        children: /*#__PURE__*/ (0, $61Ea1.jsx)($9403be097794d811$var$ReportFilterList, {
            store: store,
            report: report,
            filters: report.filters
        })
    });
});
const $9403be097794d811$var$ReportFilterList = (0, $1EEMt.observer)(({ columns: columns, filters: filters, store: store, report: report })=>{
    var _filters$groups, _filters$projects, _filters$roles, _filters$staff, _filters$projectOwner;
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "report-selector w-full bg-white/10 rounded-[6px] py-2",
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    padding: "1em 0.5em"
                },
                children: [
                    "Groups:",
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $c86dX.MultiSelect), {
                        selectedOptions: (_filters$groups = filters.groups) === null || _filters$groups === void 0 ? void 0 : _filters$groups.map((g)=>({
                                value: g,
                                label: (0, $ikffN.capitalCase)(g)
                            })),
                        options: [
                            {
                                value: "status",
                                label: "Status"
                            },
                            {
                                value: "owner",
                                label: "Owner"
                            },
                            {
                                value: "role",
                                label: "Role"
                            },
                            {
                                value: "staff",
                                label: "Staff"
                            },
                            {
                                value: "project",
                                label: "Project"
                            },
                            {
                                value: "phase",
                                label: "Phase"
                            }
                        ],
                        style: {
                            width: "50em"
                        },
                        onChange: (groups)=>{
                            return store.updateFilters({
                                groups: groups.map((g)=>g.value)
                            });
                        },
                        onBlur: ()=>null,
                        filter: function(item, searchText) {
                            return String(item).toLowerCase().match(searchText.toLowerCase());
                        },
                        styles: {
                            container: (provided, state)=>({
                                    ...provided,
                                    color: "#444",
                                    width: "50em"
                                }),
                            input: (provided, state)=>({
                                    ...provided,
                                    color: "#444"
                                }),
                            menu: (provided, state)=>({
                                    ...provided,
                                    fontSize: "0.9em",
                                    color: "#444"
                                })
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: '"py-[1em] px-[0.5em] flex items-end flex-wrap"',
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            marginRight: "2em"
                        },
                        children: [
                            "Hours Data: ",
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                                className: "flex-0-0-auto page-header__button",
                                style: {
                                    margin: "0 1.5em 0 0.5em",
                                    maxWidth: "15em"
                                },
                                value: filters.hoursData,
                                onChange: (hoursData)=>store.updateFilters({
                                        hoursData: hoursData
                                    }),
                                options: [
                                    {
                                        label: "Actuals + Projected",
                                        value: "actualsProjected"
                                    },
                                    {
                                        label: "Actuals",
                                        value: "actuals"
                                    },
                                    {
                                        label: "Projected",
                                        value: "projected"
                                    },
                                    {
                                        label: "Actuals / Projected",
                                        value: "actualsVsProjected"
                                    },
                                    {
                                        label: "Remaining Projected Monthly",
                                        value: "remainingProjected"
                                    },
                                    {
                                        label: "Remaining Projected Monthly (Capped)",
                                        value: "remainingProjectedCapped"
                                    }
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            marginRight: "2em"
                        },
                        children: [
                            "Totals: ",
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                                className: "flex-0-0-auto page-header__button",
                                style: {
                                    margin: "0 1.5em 0 0.5em"
                                },
                                value: filters.totalData,
                                onChange: (totalData)=>store.updateFilters({
                                        totalData: totalData
                                    }),
                                options: [
                                    {
                                        label: "Budget Use",
                                        value: "budgetUse"
                                    },
                                    {
                                        label: "Remaining Budget",
                                        value: "remainingBudget"
                                    },
                                    {
                                        label: "Average Utilisation",
                                        value: "averageUtilisation"
                                    }
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            marginRight: "2em"
                        },
                        children: [
                            "Percent: ",
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                                className: "flex-0-0-auto page-header__button",
                                style: {
                                    margin: "0 1.5em 0 0.5em"
                                },
                                value: filters.percentData,
                                onChange: (percentData)=>store.updateFilters({
                                        percentData: percentData
                                    }),
                                options: [
                                    {
                                        label: "Utilisation",
                                        value: "utilisation"
                                    },
                                    {
                                        label: "Budget Use",
                                        value: "budgetUse"
                                    },
                                    {
                                        label: "Monthly Budget Use",
                                        value: "monthlyBudgetUse"
                                    },
                                    {
                                        label: "Remaining Monthly Budget Use",
                                        value: "remainingMonthlyBudgetUse"
                                    },
                                    {
                                        label: "Remaining Monthly Budget Use (Capped)",
                                        value: "remainingMonthlyBudgetUseCapped"
                                    }
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            marginRight: "2em"
                        },
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                                value: filters.futureRows,
                                onChange: (futureRows)=>store.updateFilters({
                                        futureRows: futureRows
                                    })
                            }),
                            " Only show Projects with future work allocated."
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            marginRight: "2em"
                        },
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                                value: filters.activePhases,
                                onChange: (activePhases)=>store.updateFilters({
                                        activePhases: activePhases
                                    })
                            }),
                            " Include All Active Phases."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "flex",
                style: {
                    width: "100%",
                    fontSize: "0.95em"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            width: "20%",
                            padding: "0.5em"
                        },
                        children: [
                            "Cost Centres:",
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $c86dX.CostCentreMultiselect), {
                                selectedCostCentres: filters === null || filters === void 0 ? void 0 : filters.costCentres.map((cId)=>(0, $eNcHX.default).costCentresById[cId]),
                                onChange: (costCentres)=>store.updateFilters({
                                        costCentres: costCentres.map((cc)=>cc.id)
                                    }),
                                onBlur: ()=>null,
                                styles: {
                                    container: (provided, state)=>({
                                            ...provided,
                                            color: "#444"
                                        }),
                                    input: (provided, state)=>({
                                            ...provided,
                                            color: "#444"
                                        }),
                                    menu: (provided, state)=>({
                                            ...provided,
                                            fontSize: "0.9em",
                                            color: "#444"
                                        })
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            width: "20%",
                            padding: "0.5em"
                        },
                        children: [
                            "Status:",
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $c86dX.StatusMultiselect), {
                                selectedStatuses: filters.projectStatus,
                                onChange: (projectStatuses)=>{
                                    return store.updateFilters({
                                        projectStatus: projectStatuses
                                    });
                                },
                                onBlur: ()=>null,
                                styles: {
                                    container: (provided, state)=>({
                                            ...provided,
                                            color: "#444"
                                        }),
                                    input: (provided, state)=>({
                                            ...provided,
                                            color: "#444"
                                        }),
                                    menu: (provided, state)=>({
                                            ...provided,
                                            fontSize: "0.9em",
                                            color: "#444"
                                        })
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            width: "20%",
                            padding: "0.5em"
                        },
                        children: [
                            "Projects:",
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $c86dX.ProjectMultiselect), {
                                selectedProjects: (_filters$projects = filters.projects) === null || _filters$projects === void 0 ? void 0 : _filters$projects.map((cId)=>(0, $gJT7h.default).projectsById[cId]),
                                onChange: (projects)=>store.updateFilters({
                                        projects: projects.map((p)=>p.id)
                                    }),
                                onBlur: ()=>null,
                                styles: {
                                    container: (provided, state)=>({
                                            ...provided,
                                            color: "#444"
                                        }),
                                    input: (provided, state)=>({
                                            ...provided,
                                            color: "#444"
                                        }),
                                    menu: (provided, state)=>({
                                            ...provided,
                                            fontSize: "0.9em",
                                            color: "#444"
                                        })
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            width: "20%",
                            padding: "0.5em"
                        },
                        children: [
                            "Roles:",
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $c86dX.RoleMultiselect), {
                                selectedRoles: (_filters$roles = filters.roles) === null || _filters$roles === void 0 ? void 0 : _filters$roles.map((cId)=>(0, $bxXv3.default).rolesById[cId]),
                                onChange: (roles)=>{
                                    return store.updateFilters({
                                        roles: roles.map((r)=>r.id)
                                    });
                                },
                                onBlur: ()=>null,
                                styles: {
                                    container: (provided, state)=>({
                                            ...provided,
                                            color: "#444"
                                        }),
                                    input: (provided, state)=>({
                                            ...provided,
                                            color: "#444"
                                        }),
                                    menu: (provided, state)=>({
                                            ...provided,
                                            fontSize: "0.9em",
                                            color: "#444"
                                        })
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            width: "20%",
                            padding: "0.5em"
                        },
                        children: [
                            "Staff:",
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $c86dX.StaffMultiselect), {
                                selectedStaffMembers: (_filters$staff = filters.staff) === null || _filters$staff === void 0 ? void 0 : _filters$staff.map((cId)=>(0, $htkeB.default).staffsById[cId]),
                                onChange: (staff)=>store.updateFilters({
                                        staff: staff.map((st)=>st.id)
                                    }),
                                onBlur: ()=>null,
                                styles: {
                                    container: (provided, state)=>({
                                            ...provided,
                                            color: "#444"
                                        }),
                                    input: (provided, state)=>({
                                            ...provided,
                                            color: "#444"
                                        }),
                                    menu: (provided, state)=>({
                                            ...provided,
                                            fontSize: "0.9em",
                                            color: "#444"
                                        })
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            width: "20%",
                            padding: "0.5em"
                        },
                        children: [
                            "Project Owner:",
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $c86dX.StaffMultiselect), {
                                selectedStaffMembers: (_filters$projectOwner = filters.projectOwners) === null || _filters$projectOwner === void 0 ? void 0 : _filters$projectOwner.map((cId)=>(0, $htkeB.default).staffsById[cId]),
                                onChange: (staff)=>store.updateFilters({
                                        projectOwners: staff.map((st)=>st.id)
                                    }),
                                onBlur: ()=>null,
                                styles: {
                                    container: (provided, state)=>({
                                            ...provided,
                                            color: "#444"
                                        }),
                                    input: (provided, state)=>({
                                            ...provided,
                                            color: "#444"
                                        }),
                                    menu: (provided, state)=>({
                                            ...provided,
                                            fontSize: "0.9em",
                                            color: "#444"
                                        })
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
const $9403be097794d811$export$ae9c33d24d74aaae = (0, $1EEMt.observer)(({ report: report, placeholder: placeholder })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $e4TNX.FilterTextBox), {
        style: {
            width: "19em"
        },
        value: report.searchFilter || "",
        onChange: (val)=>report.updateSearchFilter(val),
        placeholder: placeholder
    });
});

});
parcelRegister("ahtQ4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77c2a34798281ed0$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $fEcKX = parcelRequire("fEcKX");

var $ewAM3 = parcelRequire("ewAM3");

var $6RcUP = parcelRequire("6RcUP");

var $6eCWq = parcelRequire("6eCWq");

var $c86dX = parcelRequire("c86dX");

var $3X7oM = parcelRequire("3X7oM");

var $htkeB = parcelRequire("htkeB");

var $gJT7h = parcelRequire("gJT7h");

var $7GQic = parcelRequire("7GQic");

var $ek5Pm = parcelRequire("ek5Pm");

var $alT7C = parcelRequire("alT7C");


var $3h7sC = parcelRequire("3h7sC");

var $47i9t = parcelRequire("47i9t");
var $77c2a34798281ed0$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ report: report, modalId: modalId })=>{
    const [staffs, setStaffs] = (0, $jbmdS.useState)([]);
    const [dateRange, setDateRange] = (0, $jbmdS.useState)([
        new Date(),
        new Date()
    ]);
    const [allocationValue, setAllocationValue] = (0, $jbmdS.useState)(0);
    const [allocationType, setAllocationType] = (0, $jbmdS.useState)("hours");
    const projects = (0, $jbmdS.useMemo)(()=>{
        return (0, $gJT7h.default).projects.filter((p)=>{
            const projectFilters = report.filters.projects || [];
            const projectStatusFilters = report.filters.projectStatus || [];
            const projectOwnerFilters = report.filters.projectOwners || [];
            const costCentreFilters = report.filters.costCentres || [];
            return (!projectFilters.length || projectFilters.includes(p.id)) && (!projectStatusFilters.length || projectStatusFilters.includes(p.status)) && (!projectOwnerFilters.length || projectOwnerFilters.includes(p.ownerId)) && (!costCentreFilters.length || costCentreFilters.includes(p.costCentreId));
        });
    }, [
        report.filters
    ]);
    const [project, setProject] = (0, $jbmdS.useState)(projects[0]);
    const [phase, setPhase] = (0, $jbmdS.useState)(null);
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fEcKX.default), {
        modalId: modalId,
        heading: "Add Resource Allocations",
        onSave: ()=>{
            (0, $6eCWq.default).addStaffs(staffs, project, phase, dateRange, allocationValue, allocationType, (period, newHours, projectId, phaseId, roleId, staffId)=>{
                (0, $alT7C.ProjectSidebarStore).setHoursInPeriod(period, projectId, phaseId || null, roleId || null, staffId || null, newHours, (0, $6eCWq.default).selectedPhaseIds, (0, $6eCWq.default).selectedStaffIds, (0, $6eCWq.default).periodType);
            });
        },
        saveLabel: "Add Allocations",
        canSave: ()=>!!staffs.length && !!project && !!phase,
        style: {
            minHeight: "44em"
        },
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            style: {
                position: "absolute",
                width: "44em"
            },
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    className: "flex items-center gap-2 mb-4",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $c86dX.StaffMultiselect), {
                            className: "flex-auto",
                            staffOptions: (0, $htkeB.default).staffs.filter((s)=>{
                                var _ResourceScheduleStor, _ResourceScheduleStor2;
                                return !s.isArchived && ((_ResourceScheduleStor = (0, $6eCWq.default).report.filters.staff) !== null && _ResourceScheduleStor !== void 0 && _ResourceScheduleStor.length ? (0, $6eCWq.default).report.filters.staff.includes(s.id) : true) && ((_ResourceScheduleStor2 = (0, $6eCWq.default).report.filters.roles) !== null && _ResourceScheduleStor2 !== void 0 && _ResourceScheduleStor2.length ? (0, $6eCWq.default).report.filters.roles.includes(s.roleId) : true);
                            }),
                            selectedStaffMembers: staffs,
                            onChange: (s)=>setStaffs(s)
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3X7oM.default), {
                            label: "+ Add All Active Staff",
                            variant: "secondary",
                            className: "flex-none w-44",
                            onClick: ()=>{
                                setStaffs((0, $htkeB.default).activeStaff.filter((s)=>{
                                    var _ResourceScheduleStor3, _ResourceScheduleStor4;
                                    return ((_ResourceScheduleStor3 = (0, $6eCWq.default).report.filters.staff) !== null && _ResourceScheduleStor3 !== void 0 && _ResourceScheduleStor3.length ? (0, $6eCWq.default).report.filters.staff.includes(s.id) : true) && ((_ResourceScheduleStor4 = (0, $6eCWq.default).report.filters.roles) !== null && _ResourceScheduleStor4 !== void 0 && _ResourceScheduleStor4.length ? (0, $6eCWq.default).report.filters.roles.includes(s.roleId) : true);
                                }));
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.ProjectSelector), {
                    className: "mb-4",
                    selectedProject: project,
                    projectOptions: projects,
                    onChange: (pr)=>setProject(pr),
                    variant: "secondary"
                }),
                project && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6RcUP.default), {
                    queryIds: [
                        project ? {
                            id: `phases-${project.id}`,
                            queryFn: async ()=>{
                                const requestData = await (0, $3h7sC.trpc).legacy.getProjectPhases.query({
                                    projectId: project.id
                                });
                                return (0, $47i9t.processTRPCData)(requestData, `phases-${project.id}`);
                            }
                        } : null
                    ],
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)($77c2a34798281ed0$var$PhaseSelection, {
                        project: project,
                        phase: phase,
                        setPhase: setPhase
                    })
                }),
                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    className: "flex items-center gap-2 mb-4",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            children: [
                                "From:",
                                " ",
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7GQic.default), {
                                    value: dateRange[0],
                                    onChange: (d)=>setDateRange([
                                            d,
                                            dateRange[1]
                                        ])
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            children: [
                                "To:",
                                " ",
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7GQic.default), {
                                    value: dateRange[1],
                                    onChange: (d)=>setDateRange([
                                            dateRange[0],
                                            d
                                        ])
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    className: "flex items-center gap-2 mb-4",
                    children: [
                        allocationType === "hours" ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ek5Pm.default).number, {
                            className: "input-base",
                            value: allocationValue,
                            onChange: setAllocationValue,
                            variant: "secondary"
                        }) : /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ek5Pm.default).percent, {
                            className: "input-base",
                            value: allocationValue,
                            onChange: setAllocationValue,
                            variant: "secondary"
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                            selectedOption: allocationType,
                            onChange: setAllocationType,
                            options: [
                                {
                                    label: "Hours per Period",
                                    value: "hours"
                                },
                                {
                                    label: "Utilisation",
                                    value: "utilisation"
                                }
                            ],
                            optionLabel: (o)=>o.label,
                            variant: "secondary",
                            className: "w-40"
                        })
                    ]
                })
            ]
        })
    });
});
const $77c2a34798281ed0$var$PhaseSelection = ({ project: project, phase: phase, setPhase: setPhase })=>{
    (0, $jbmdS.useEffect)(()=>{
        setPhase(project.phases.filter((p)=>p.isRootPhase)[0] || project.phases.filter((p)=>p.status === "active")[0]);
    }, [
        project
    ]);
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.PhaseSelector), {
        className: "mb-4",
        selectedPhase: phase,
        phaseOptions: project.phases.filter((p)=>p.status !== "archived"),
        onChange: setPhase,
        variant: "secondary"
    });
};

});



parcelRegister("f3YEy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af762f463a357450$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $eat5C = parcelRequire("eat5C");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $goLmS = parcelRequire("goLmS");

var $38zj9 = parcelRequire("38zj9");

var $6eCWq = parcelRequire("6eCWq");

var $6d1V1 = parcelRequire("6d1V1");

var $d8zxI = parcelRequire("d8zxI");

var $6RcUP = parcelRequire("6RcUP");

var $4iw5i = parcelRequire("4iw5i");

var $cQvuY = parcelRequire("cQvuY");

var $4hBm1 = parcelRequire("4hBm1");

var $1BTI2 = parcelRequire("1BTI2");

var $6Q5sp = parcelRequire("6Q5sp");

var $3erXY = parcelRequire("3erXY");

var $4Ypeq = parcelRequire("4Ypeq");

var $6fNfM = parcelRequire("6fNfM");
const $af762f463a357450$var$useSize = (target)=>{
    const [size, setSize] = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useState();
    (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useLayoutEffect(()=>{
        setSize(target.current.getBoundingClientRect());
    }, [
        target
    ]);
    // Where the magic happens
    (0, $d8zxI.default)(target, (entry)=>setSize(entry.contentRect));
    return size;
};
const $af762f463a357450$var$spacerColumn = {
    label: "",
    width: 3,
    type: "text",
    value: (r)=>"",
    onChange: (r)=>(v)=>null
};
var $af762f463a357450$export$2e2bcd8739ae039 = (0, $1EEMt.observer)((params)=>{
    (0, $jbmdS.useEffect)(()=>{
        (0, $6eCWq.default).setSearchParams(params);
    }, [
        params
    ]);
    if (!(0, $1BTI2.default).settings.autoUpdateHours.adjustOnLoad) return /*#__PURE__*/ (0, $61Ea1.jsx)($af762f463a357450$var$SchedulePage, {});
    else {
        var _SessionStore$user, _SessionStore$organis, _SessionStore$organis2, _SessionStore$organis3, _SessionStore$organis4, _SessionStore$organis5, _SessionStore$organis6;
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6RcUP.default), {
            queryIds: [
                {
                    id: "auto-adjust-hours",
                    path: "https://server2.coincraft.co/auto-adjust/resources",
                    method: "POST",
                    data: {
                        organisationId: (0, $1BTI2.default).organisation.id,
                        userId: (_SessionStore$user = (0, $1BTI2.default).user) === null || _SessionStore$user === void 0 ? void 0 : _SessionStore$user.id,
                        budgetType: ((_SessionStore$organis = (0, $1BTI2.default).organisation.settings) === null || _SessionStore$organis === void 0 ? void 0 : (_SessionStore$organis2 = _SessionStore$organis.autoUpdateHours) === null || _SessionStore$organis2 === void 0 ? void 0 : _SessionStore$organis2.budget) || "remaining",
                        startDateType: ((_SessionStore$organis3 = (0, $1BTI2.default).organisation.settings) === null || _SessionStore$organis3 === void 0 ? void 0 : (_SessionStore$organis4 = _SessionStore$organis3.autoUpdateHours) === null || _SessionStore$organis4 === void 0 ? void 0 : _SessionStore$organis4.start) || "now",
                        endDateType: ((_SessionStore$organis5 = (0, $1BTI2.default).organisation.settings) === null || _SessionStore$organis5 === void 0 ? void 0 : (_SessionStore$organis6 = _SessionStore$organis5.autoUpdateHours) === null || _SessionStore$organis6 === void 0 ? void 0 : _SessionStore$organis6.end) || "endDate",
                        nowTs: Date.now()
                    }
                }
            ],
            loading: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $4iw5i.default), {}),
            children: /*#__PURE__*/ (0, $61Ea1.jsx)($af762f463a357450$var$SchedulePage, {})
        });
    }
});

const $af762f463a357450$var$SchedulePage = (0, $1EEMt.observer)(()=>{
    var _store$resourceTableS, _SessionStore$user2;
    const DataStore = (parcelRequire("fM2j4")).default;
    (0, $jbmdS.useEffect)(()=>{
        DataStore.setAutosave(true);
        return ()=>{
            DataStore.setAutosave(false);
        };
    }, []);
    const isPrinting = (0, $6d1V1.useMediaQuery)("print");
    const [store, setStore] = (0, $jbmdS.useState)((0, $6eCWq.default));
    const target = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useRef(null);
    const size = $af762f463a357450$var$useSize(target);
    const widthRatio = (size === null || size === void 0 ? void 0 : size.width) / ((store === null || store === void 0 ? void 0 : (_store$resourceTableS = store.resourceTableStore) === null || _store$resourceTableS === void 0 ? void 0 : _store$resourceTableS.width) * 15);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        style: {
            padding: "0 2em",
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                ref: target,
                style: {
                    width: "100%",
                    display: "flex"
                }
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $6RcUP.default), {
                loading: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $4iw5i.default), {}),
                queryIds: [
                    {
                        id: `resourceTable` + store.report.queryKey + store.periodType,
                        baseURL: "https://server2.coincraft.co",
                        path: `/resource-schedule/table`,
                        method: "POST",
                        staleTime: 1000,
                        cacheTime: 1000,
                        data: {
                            organisationId: (0, $1BTI2.default).organisationId,
                            userId: (_SessionStore$user2 = (0, $1BTI2.default).user) === null || _SessionStore$user2 === void 0 ? void 0 : _SessionStore$user2.id,
                            filters: store.report.filters,
                            level: 0,
                            parentData: {},
                            dateRange: [
                                (0, $4hBm1.format)(store.startDate, "yyyy-MM-dd"),
                                (0, $4hBm1.format)(store.endDate, "yyyy-MM-dd")
                            ],
                            periodType: store.periodType
                        }
                    }
                ],
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3erXY.default), {
                        report: store.report
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)($af762f463a357450$var$ResourceSchedule, {
                        store: store,
                        widthRatio: widthRatio,
                        isPrinting: isPrinting
                    })
                ]
            })
        ]
    });
});
const $af762f463a357450$var$ResourceSchedule = (0, $1EEMt.observer)(({ store: store, widthRatio: widthRatio, isPrinting: isPrinting })=>{
    var _queryClient$getQuery;
    const queryData = (_queryClient$getQuery = (0, $6Q5sp.queryClient).getQueryData([
        `resourceTable` + store.report.queryKey + store.periodType
    ])) === null || _queryClient$getQuery === void 0 ? void 0 : _queryClient$getQuery.data;
    (0, $jbmdS.useEffect)(()=>{
        store.init(queryData);
    }, [
        store.report.queryKey,
        store.periodType,
        queryData
    ]);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)($af762f463a357450$var$ResourceChart, {
                store: store,
                widthRatio: widthRatio,
                isPrinting: isPrinting
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)($af762f463a357450$var$ResourceTable, {
                store: store
            })
        ]
    });
});
const $af762f463a357450$var$ResourceChart = (0, $1EEMt.observer)(({ store: store, widthRatio: widthRatio, isPrinting: isPrinting })=>{
    const periods = [
        ...Array(12)
    ].map((v, i)=>store.addPeriods(store.startDate, i));
    const periodAvailability = periods.map((m)=>store.getAvailabilityInPeriod("", (0, $4hBm1.format)(m, store.periodFormat())));
    const activePeriodAllocations = periods.map((m)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(store.queryData.map((r)=>store.getRowActiveHoursInPeriod(r, (0, $4hBm1.format)(m, store.periodFormat()))));
    });
    const prospectivePeriodAllocations = periods.map((m)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(store.queryData.map((r)=>store.getRowProspectiveHoursInPeriod(r, (0, $4hBm1.format)(m, store.periodFormat()))));
    });
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $38zj9.default), {
            revenue: periodAvailability.map((v)=>v || 0),
            expenses: activePeriodAllocations.map((v)=>v || 0),
            prospectiveExpenses: prospectivePeriodAllocations.map((v)=>v || 0),
            totalWidth: 1280,
            graphWidth: 880,
            height: 220,
            sizeRatio: isPrinting ? widthRatio : 1
        })
    });
});
const $af762f463a357450$var$ResourceTable = (0, $1EEMt.observer)(({ store: store, keys: keys = [], rows: rows } = {})=>{
    var _parent;
    const level = keys.length;
    const groups = store.report.filters.groups;
    const isLastLevel = level === groups.length - 1;
    const rowColumns = (0, $cQvuY.ResourceScheduleReportAllocationColumns)(store, keys, (0, $4Ypeq.default));
    const bgColor = 256 - level * 5;
    const bgShadow = bgColor - 10;
    const group = groups[level];
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
        tableStore: !level ? store.resourceTableStore : null,
        expandAll: store.expandAll,
        style: !level ? {
            margin: "2em 0"
        } : {
            boxShadow: "none",
            background: `linear-gradient(180deg, rgb(${bgShadow},${bgShadow},${bgShadow}) 1px, rgb(${bgColor},${bgColor},${bgColor}) 8px)`,
            fontSize: "1.2rem"
        },
        columns: [
            isLastLevel ? $af762f463a357450$var$spacerColumn : null,
            rowColumns.title(level, {}),
            rowColumns.budgetUse(level, {}),
            ...[
                ...Array(12)
            ].map((v, i)=>{
                return rowColumns.hours(store.addPeriods(store.startDate, i), level, {});
            })
        ].filter((c)=>c),
        rows: [
            ...rows || store.queryData
        ].sort(group === "phase" ? (0, $6fNfM.default) : (a, b)=>(a.title || "").localeCompare(b.title || "")),
        // onExpand={(row) => {
        //     store.expandAllocationRow(filters)
        // }}
        // onCollapse={(row) => {
        //     store.collapseAllocationRow(filters)
        // }}
        getChildComponent: !isLastLevel ? (r)=>{
            return /*#__PURE__*/ (0, $61Ea1.jsx)($af762f463a357450$var$ResourceTable, {
                keys: [
                    ...keys,
                    r.key
                ],
                store: store,
                rows: r.children
            });
        } : null,
        showHeader: !level,
        showTotals: !level
    }, "ttt" + store.report.queryKey + level + ((_parent = parent) === null || _parent === void 0 ? void 0 : _parent.id));
});

});

parcelRegister("4DICt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $360d6a7916011f2b$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");


var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $6eCWq = parcelRequire("6eCWq");
parcelRequire("jCrfK");
parcelRequire("bfcx4");
parcelRequire("XoImS");
parcelRequire("jE5CX");

parcelRequire("6RcUP");

var $alT7C = parcelRequire("alT7C");
parcelRequire("gJT7h");
parcelRequire("bxXv3");
parcelRequire("htkeB");
parcelRequire("kC7c9");
parcelRequire("hYUed");
var $360d6a7916011f2b$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(()=>{
    const [store, setStore] = (0, $jbmdS.useState)((0, $6eCWq.default));
    const row = store.selectedObject;
    const groups = (row === null || row === void 0 ? void 0 : row.groups) || [];
    const period = store.selectedPeriod;
    const project = row === null || row === void 0 ? void 0 : row.project;
    const phase = row === null || row === void 0 ? void 0 : row.phase;
    const role = row === null || row === void 0 ? void 0 : row.role;
    const staff = row === null || row === void 0 ? void 0 : row.staff;
    if (!period || !store.selectedProjectId) return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        style: {
            padding: "1em"
        },
        children: "Please select a cell containing at least a project or phase."
    });
    let RenderedProgress = /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        children: "Something went wrong."
    });
    // if (
    //     (groups.includes('staff') || groups.includes('role')) &&
    //     !groups.includes('project') &&
    //     !groups.includes('phase')
    // ) {
    //     RenderedProgress = (
    //         <ResourceScheduleStaffSidebar
    //             store={store}
    //             month={store.selectedMonth}
    //             row={row}
    //         />
    //     )
    // } else if (store.selectedProjectId) {
    RenderedProgress = /*#__PURE__*/ (0, $61Ea1.jsx)((0, $alT7C.default), {});
    // }
    return RenderedProgress;
});

});
parcelRegister("kC7c9", function(module, exports) {

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $1EEMt = parcelRequire("1EEMt");

var $ccJUd = parcelRequire("ccJUd");

var $4hBm1 = parcelRequire("4hBm1");

var $6RcUP = parcelRequire("6RcUP");

var $hYVSY = parcelRequire("hYVSY");

var $htkeB = parcelRequire("htkeB");

var $eat5C = parcelRequire("eat5C");
parcelRequire("gJT7h");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $9eute = parcelRequire("9eute");
var $f01cf008b3895f77$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ store: store, month: month, row: row })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)($f01cf008b3895f77$var$FetchWrapper, {
        store: store,
        month: month,
        row: row,
        children: /*#__PURE__*/ (0, $61Ea1.jsx)($f01cf008b3895f77$var$SidebarContent, {
            store: store,
            month: month,
            row: row
        })
    });
});
const $f01cf008b3895f77$var$FetchWrapper = ({ row: row, store: store, month: month, children: children })=>{
    const includeStaff = "staffId" in (row === null || row === void 0 ? void 0 : row.matchers);
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6RcUP.default), {
        queryIds: [
            store.resourceRowQuery({
                level: 1,
                groups: [
                    "staff",
                    "project"
                ],
                dateRange: [
                    (0, $4hBm1.startOfMonth)(month),
                    (0, $4hBm1.endOfMonth)(month)
                ],
                staffRoleId: row === null || row === void 0 ? void 0 : row.roleId,
                ...includeStaff ? {
                    staffId: row === null || row === void 0 ? void 0 : row.staffId
                } : {}
            })
        ],
        children: children
    });
};
const $f01cf008b3895f77$var$SidebarContent = ({ store: store, month: month, row: row })=>{
    var _roleRow$role;
    const includeStaff = "staffId" in (row === null || row === void 0 ? void 0 : row.matchers);
    const [updateRevenueWithExpenses, setUpdateRevenueWithExpenses] = (0, $jbmdS.useState)((0, $8kZ1o.shouldUpdateRevenueFromHours)());
    const role = row === null || row === void 0 ? void 0 : row.role;
    const staff = row === null || row === void 0 ? void 0 : row.staff;
    const allStaff = staff ? [
        staff
    ] : role ? role.staff.filter((s)=>!s.isArchived) : (0, $htkeB.default).staffByRoleId[null].filter((s)=>!s.isArchived);
    const roleRow = includeStaff ? null : row;
    const staffRows = includeStaff ? [
        row
    ] : allStaff.map((s)=>{
        const staffRowId = "staffResourceSidebar" + s.id;
        const staffRow = (0, $9eute.default).rowsById[staffRowId] || (0, $9eute.default).add({
            id: staffRowId,
            roleId: row === null || row === void 0 ? void 0 : row.roleId,
            staffId: s.id,
            level: 0,
            groups: [
                ...row.groups,
                "staff"
            ],
            dateRange: [
                (0, $4hBm1.startOfMonth)(month),
                (0, $4hBm1.endOfMonth)(month)
            ]
        });
        return staffRow;
    });
    if (roleRow) {
        roleRow.setChildren(staffRows);
        staffRows.forEach((s)=>{
            s.setParent(roleRow);
        });
    }
    const staffProjectRows = store.getResourceRows({
        level: 1,
        groups: [
            "staff",
            "project"
        ],
        dateRange: [
            (0, $4hBm1.startOfMonth)(month),
            (0, $4hBm1.endOfMonth)(month)
        ],
        staffRoleId: row === null || row === void 0 ? void 0 : row.roleId,
        ...includeStaff ? {
            staffId: row === null || row === void 0 ? void 0 : row.staffId
        } : {}
    });
    staffRows.forEach((s)=>{
        const childResourceRows = staffProjectRows.filter((r)=>r.staffId === s.staffId);
        s.setChildren(childResourceRows);
        childResourceRows.forEach((r)=>{
            r.setParent(s);
        });
    });
    const roleProjectRows = [];
    if (roleRow) {
        const rowsByProjectId = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).groupBy(staffProjectRows, "projectId");
        Object.keys(rowsByProjectId).forEach((projectId)=>{
            const projectRows = rowsByProjectId[projectId];
            const roleProjectRowId = "projectResourceSidebar" + projectId + roleRow.roleId;
            const roleProjectRow = (0, $9eute.default).rowsById[roleProjectRowId] || (0, $9eute.default).add({
                id: roleProjectRowId,
                roleId: roleRow.roleId,
                projectId: projectId,
                groups: [
                    "role",
                    "project"
                ]
            });
            roleProjectRow.setChildren(projectRows);
            roleProjectRow.setParent(roleRow);
            roleProjectRows.push(roleProjectRow);
        });
    }
    if (!(0, $8kZ1o.canViewStaffAllocations)((0, $1BTI2.default).user)) return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        style: {
            padding: "1em"
        },
        children: "You do not have permission to view staff allocations."
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        children: [
            (0, $8kZ1o.canEditRevenueTargets)((0, $1BTI2.default).user) ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hYVSY.default), {
                onChange: (e)=>{
                    const { checked: checked } = e.target;
                    setUpdateRevenueWithExpenses(checked);
                },
                checked: updateRevenueWithExpenses,
                style: {
                    width: "45%",
                    float: "right",
                    fontSize: "0.65em"
                },
                children: "Update Revenue With Hours"
            }) : null,
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    padding: "2em"
                },
                children: roleRow ? /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("h4", {
                            children: "Role"
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ccJUd.default), {
                            updateRevenue: updateRevenueWithExpenses,
                            editable: (0, $8kZ1o.canEditStaffAllocations)((0, $1BTI2.default).user),
                            month: month,
                            height: 6,
                            row: roleRow,
                            staffRow: roleRow,
                            label: (_roleRow$role = roleRow.role) === null || _roleRow$role === void 0 ? void 0 : _roleRow$role.name
                        }, role === null || role === void 0 ? void 0 : role.id)
                    ]
                }) : null
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    padding: "2em"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("h4", {
                        children: "Staff"
                    }),
                    staffRows.map((s)=>{
                        var _s$staff;
                        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ccJUd.default), {
                            updateRevenue: updateRevenueWithExpenses,
                            editable: (0, $8kZ1o.canEditStaffAllocations)((0, $1BTI2.default).user),
                            row: s,
                            staffRow: s,
                            month: month,
                            label: (_s$staff = s.staff) === null || _s$staff === void 0 ? void 0 : _s$staff.fullName
                        }, s.id);
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    padding: "2em"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("h4", {
                        children: "Projects"
                    }),
                    (roleRow ? roleProjectRows : staffProjectRows).filter((projRow)=>(0, $8kZ1o.canViewStaffAllocations)((0, $1BTI2.default).user, projRow.project)).sort((a, b)=>{
                        var _a$project$title, _a$project$title$loca;
                        return (_a$project$title = a.project.title) === null || _a$project$title === void 0 ? void 0 : (_a$project$title$loca = _a$project$title.localeCompare) === null || _a$project$title$loca === void 0 ? void 0 : _a$project$title$loca.call(_a$project$title, b.project.title);
                    }).map((projRow, i)=>{
                        var _projRow$project;
                        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ccJUd.default), {
                            updateRevenue: updateRevenueWithExpenses,
                            editable: (0, $8kZ1o.canEditStaffAllocations)((0, $1BTI2.default).user),
                            row: projRow,
                            staffRow: projRow.parent,
                            month: month,
                            label: (_projRow$project = projRow.project) === null || _projRow$project === void 0 ? void 0 : _projRow$project.title,
                            showOtherHours: false
                        }, projRow.id);
                    })
                ]
            })
        ]
    }, row.id);
};

});



parcelRegister("h5272", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $c6f48ad0d9e6a4d9$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $26sX2 = parcelRequire("26sX2");

var $6XFpi = parcelRequire("6XFpi");
parcelRequire("jbmdS");

var $5PXcS = parcelRequire("5PXcS");

var $4iw5i = parcelRequire("4iw5i");

var $kuPRw = parcelRequire("kuPRw");

var $gkBId = parcelRequire("gkBId");

var $3gVBF = parcelRequire("3gVBF");

var $7qobO = parcelRequire("7qobO");

var $47i9t = parcelRequire("47i9t");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $iuKE4 = parcelRequire("iuKE4");

var $lD3Bq = parcelRequire("lD3Bq");

var $kqntg = parcelRequire("kqntg");

var $3h7sC = parcelRequire("3h7sC");
const $c6f48ad0d9e6a4d9$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_private/overhead-expenses")({
    beforeLoad: ({ params: params })=>{
        if (!(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "overheadExpenses", params)) throw new Error("Permission Denied");
        (0, $26sX2.setLayoutDefaults)({
            pageTitle: "Operational Expenses",
            subMenu: "organisation"
        });
    },
    errorComponent: ({ error: error, reset: reset })=>{
        if (error.message === "Permission Denied") return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7qobO.default), {});
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    },
    loader: async ()=>await $c6f48ad0d9e6a4d9$var$loader(),
    pendingComponent: (0, $4iw5i.default),
    component: $c6f48ad0d9e6a4d9$var$Wrapper
});
const $c6f48ad0d9e6a4d9$var$loader = async ()=>{
    if ((0, $8kZ1o.migratedToV2)()) {
        setIsLoading(true);
        try {
            const result = await (0, $3h7sC.trpc).operationalExpense.getOperationalExpenses.query();
            if (result.operationalExpenses) {
                // Parse dates from the API response
                const parsedOperationalExpenses = result.operationalExpenses.map((operationalExpense)=>({
                        ...operationalExpense,
                        value: operationalExpense.value ? Number(operationalExpense.value) : null,
                        startDate: operationalExpense.startDate ? new Date(operationalExpense.startDate) : null,
                        endDate: operationalExpense.endDate ? new Date(operationalExpense.endDate) : null
                    }));
                setOperationalExpenses(parsedOperationalExpenses);
                setPendingChanges(false);
            }
            return result;
        } catch (error) {
            console.error("Error loading overhead expense:", error);
            throw error;
        } finally{
            setIsLoading(false);
        }
    }
    const data = await (0, $3h7sC.trpc).legacy.getOverheadExpensesPageData.query();
    return (0, $47i9t.processTRPCData)(data);
};
function $c6f48ad0d9e6a4d9$var$Wrapper() {
    // The store now handles all the save toast logic internally
    (0, $iuKE4.operationalExpensesStore).useSaveHandler();
    if ((0, $8kZ1o.migratedToV2)()) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqntg.PageBody), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $lD3Bq.OverHeadExpensePage), {})
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3gVBF.default), {}),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kuPRw.default), {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $gkBId.default), {})
            })
        ]
    });
}

});
parcelRegister("gkBId", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be3bc478e0068fa2$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $ikffN = parcelRequire("ikffN");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $ewAM3 = parcelRequire("ewAM3");

var $goLmS = parcelRequire("goLmS");

var $1UDCR = parcelRequire("1UDCR");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");
const $be3bc478e0068fa2$var$columns = [
    {
        id: "name",
        label: "Name",
        type: "text",
        width: 20,
        editable: (row)=>(0, $8kZ1o.canEditOverheadExpenses)((0, $1BTI2.default).user),
        value: (row)=>{
            return row.name;
        },
        onChange: (row)=>(val)=>row.update({
                    name: val
                })
    },
    {
        id: "costCentre",
        label: "Cost Centre",
        type: "costCentre",
        width: 20,
        editable: (row)=>(0, $8kZ1o.canEditOverheadExpenses)((0, $1BTI2.default).user),
        value: (row)=>{
            return row.costCentre;
        },
        onChange: (row)=>(val)=>row.update({
                    costCentreId: val.id
                })
    },
    {
        id: "value",
        label: "Cost",
        type: "currency",
        width: 10,
        editable: (row)=>(0, $8kZ1o.canEditOverheadExpenses)((0, $1BTI2.default).user),
        value: (row)=>{
            return row.value;
        },
        onChange: (row)=>(val)=>row.update({
                    value: val
                })
    },
    {
        id: "startDate",
        label: "Start Date",
        type: "date",
        width: 15,
        editable: (row)=>(0, $8kZ1o.canEditOverheadExpenses)((0, $1BTI2.default).user),
        value: (row)=>{
            return row.startDate;
        },
        onChange: (row)=>(val)=>row.update({
                    startDate: val
                })
    },
    {
        id: "endDate",
        label: "End Date",
        type: "date",
        width: 15,
        editable: (row)=>(0, $8kZ1o.canEditOverheadExpenses)((0, $1BTI2.default).user),
        value: (row)=>{
            return row.endDate;
        },
        onChange: (row)=>(val)=>row.update({
                    endDate: val
                })
    },
    {
        id: "hasRepeat",
        label: "Repeats",
        type: "checkbox",
        width: 8,
        editable: (row)=>(0, $8kZ1o.canEditOverheadExpenses)((0, $1BTI2.default).user),
        value: (row)=>{
            return row.hasRepeat;
        },
        onChange: (row)=>(val)=>row.update({
                    hasRepeat: val
                })
    },
    {
        id: "repeatQuantity",
        label: "Every",
        type: "number",
        width: 8,
        editable: (row)=>row.hasRepeat && (0, $8kZ1o.canEditOverheadExpenses)((0, $1BTI2.default).user),
        value: (row)=>{
            return row.hasRepeat ? row.repeatQuantity : "-";
        },
        onChange: (row)=>(val)=>row.update({
                    repeatQuantity: val
                })
    },
    {
        id: "repeatUnit",
        label: "Period",
        width: 15,
        type: "dropdown",
        editable: (r)=>r.hasRepeat && (0, $8kZ1o.canEditOverheadExpenses)((0, $1BTI2.default).user),
        value: (r)=>r.repeatUnit,
        onChange: (r)=>(v)=>r.update({
                    repeatUnit: v
                }),
        component: ({ value: value, editable: editable, onChange: onChange, stores: stores })=>{
            var _stores$row$rowObject;
            if (!editable) return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: (0, $ikffN.capitalCase)((_stores$row$rowObject = stores.row.rowObject) !== null && _stores$row$rowObject !== void 0 && _stores$row$rowObject.hasRepeat && value ? value : "")
            });
            return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                selectedOption: value,
                options: [
                    "days",
                    "weeks",
                    "months",
                    "years"
                ],
                optionLabel: (opt)=>(0, $ikffN.capitalCase)(opt || ""),
                onChange: onChange,
                editable: editable,
                variant: "secondary"
            });
        }
    },
    {
        label: "",
        width: 4,
        type: "button",
        permissions: (r)=>(0, $8kZ1o.canEditOverheadExpenses)((0, $1BTI2.default).user),
        editable: (r)=>(0, $8kZ1o.canEditOverheadExpenses)((0, $1BTI2.default).user),
        value: (p)=>/*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                className: "fa fa-times",
                style: {
                    marginRight: 0
                }
            }),
        onClick: (r)=>()=>{
                r.update({
                    deletedAt: new Date()
                });
            }
    }
];
var $be3bc478e0068fa2$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(()=>{
    const [rows, setRows] = (0, $jbmdS.useState)((0, $1UDCR.default).activeOverheads.sort((a, b)=>{
        var _b$startDate, _a$startDate;
        return (b === null || b === void 0 ? void 0 : (_b$startDate = b.startDate) === null || _b$startDate === void 0 ? void 0 : _b$startDate.getTime()) - (a === null || a === void 0 ? void 0 : (_a$startDate = a.startDate) === null || _a$startDate === void 0 ? void 0 : _a$startDate.getTime());
    }));
    (0, $jbmdS.useEffect)(()=>{
        setRows((0, $1UDCR.default).activeOverheads.sort((a, b)=>{
            var _b$startDate2, _a$startDate2;
            return (b === null || b === void 0 ? void 0 : (_b$startDate2 = b.startDate) === null || _b$startDate2 === void 0 ? void 0 : _b$startDate2.getTime()) - (a === null || a === void 0 ? void 0 : (_a$startDate2 = a.startDate) === null || _a$startDate2 === void 0 ? void 0 : _a$startDate2.getTime());
        }));
    }, [
        (0, $1UDCR.default).activeOverheads.length
    ]);
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
            columns: $be3bc478e0068fa2$var$columns,
            rows: rows.filter((r)=>!r.deletedAt),
            newRowDirection: "asc"
        })
    });
});

});

parcelRegister("3gVBF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $261f8d30dd56ee9f$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $1UDCR = parcelRequire("1UDCR");

var $6mjwz = parcelRequire("6mjwz");

var $cV8g5 = parcelRequire("cV8g5");

var $36Jjh = parcelRequire("36Jjh");

var $3X7oM = parcelRequire("3X7oM");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");
const $261f8d30dd56ee9f$var$overheadExpenseColumns = [
    {
        id: "name",
        label: "Name",
        value: (expense)=>expense.name || ""
    },
    {
        id: "value",
        label: "Cost",
        value: (expense)=>expense.value || ""
    },
    {
        id: "costCentre",
        label: "Cost Centre",
        value: (expense)=>{
            var _expense$costCentre;
            return ((_expense$costCentre = expense.costCentre) === null || _expense$costCentre === void 0 ? void 0 : _expense$costCentre.name) || "";
        }
    },
    {
        id: "startDate",
        label: "Start Date",
        value: (expense)=>expense.startDate ? new Date(expense.startDate).toLocaleDateString() : ""
    },
    {
        id: "endDate",
        label: "End Date",
        value: (expense)=>expense.endDate ? new Date(expense.endDate).toLocaleDateString() : ""
    },
    {
        id: "hasRepeat",
        label: "Repeats",
        value: (expense)=>expense.hasRepeat ? "Yes" : "No"
    },
    {
        id: "repeatQuantity",
        label: "Repeat Quantity",
        value: (expense)=>expense.repeatQuantity || ""
    },
    {
        id: "repeatUnit",
        label: "Repeat Unit",
        value: (expense)=>expense.repeatUnit || ""
    }
];
const $261f8d30dd56ee9f$var$downloadCSV = ()=>{
    const rows = [
        $261f8d30dd56ee9f$var$overheadExpenseColumns.map((col)=>col.label)
    ];
    (0, $1UDCR.default).activeOverheads.forEach((expense)=>{
        rows.push($261f8d30dd56ee9f$var$overheadExpenseColumns.map((col)=>col.value(expense)));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($cV8g5)))((0, (/*@__PURE__*/$parcel$interopDefault($6mjwz))).unparse(rows), "overhead-expenses.csv", "text/csv");
};
var $261f8d30dd56ee9f$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ extraContent: extraContent })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $36Jjh.default), {
        heading: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: "Overhead Expenses"
            })
        }),
        extraContent: (0, $8kZ1o.canEditOverheadExpenses)((0, $1BTI2.default).user) ? /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
            className: "page-header__button--primary add-org-hol-button plus-btn",
            onClick: ()=>{
                const ph = (0, $1UDCR.default).add({
                    repeatQuantity: 1,
                    repeatUnit: "months"
                }, {
                    trackUpdates: true
                });
                ph.isNew = true;
            },
            style: {
                marginTop: "2em"
            },
            children: "+ Add Overhead Expense"
        }) : null,
        rightButtons: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            className: "flex items-center gap-2",
            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3X7oM.default), {
                label: "Export",
                onClick: ()=>$261f8d30dd56ee9f$var$downloadCSV(),
                icon: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                    className: "fa fa-table"
                })
            })
        })
    });
});

});

parcelRegister("iuKE4", function(module, exports) {

$parcel$export(module.exports, "operationalExpensesStore", function () { return $0d3fe6c0208be7e6$export$3010735393aa8a0d; });
$parcel$export(module.exports, "addOperationalExpenses", function () { return $0d3fe6c0208be7e6$export$368fff0c350af660; });
$parcel$export(module.exports, "updateOperationalExpenses", function () { return $0d3fe6c0208be7e6$export$4956b559f927f021; });
$parcel$export(module.exports, "deleteOperationalExpenses", function () { return $0d3fe6c0208be7e6$export$f383c4421aa584d5; });
$parcel$export(module.exports, "useActiveOperationalExpenses", function () { return $0d3fe6c0208be7e6$export$e7e38f1b6c82c284; });

var $8qPhl = parcelRequire("8qPhl");

var $3h7sC = parcelRequire("3h7sC");

var $277OF = parcelRequire("277OF");

var $lJ1OS = parcelRequire("lJ1OS");

var $jbmdS = parcelRequire("jbmdS");
const $0d3fe6c0208be7e6$export$582bb0bb954de73a = (0, $8qPhl.z).object({
    id: (0, $8qPhl.z).string(),
    name: (0, $8qPhl.z).string(),
    value: (0, $8qPhl.z).number(),
    startDate: (0, $8qPhl.z).date(),
    endDate: (0, $8qPhl.z).date(),
    hasRepeat: (0, $8qPhl.z).boolean(),
    repeatQuantity: (0, $8qPhl.z).number(),
    repeatUnit: (0, $8qPhl.z).string(),
    costCentreId: (0, $8qPhl.z).string().nullable().optional(),
    deletedAt: (0, $8qPhl.z).date().nullable().optional()
});
const $0d3fe6c0208be7e6$var$initialContext = {
    operationalExpenses: []
};
const $0d3fe6c0208be7e6$export$3010735393aa8a0d = (0, $277OF.createQueryStore)({
    context: $0d3fe6c0208be7e6$var$initialContext,
    on: {
        setOperationalExpenses: {
            operationalExpenses: (_, event)=>event.operationalExpenses
        },
        addOperationalExpenses: {
            operationalExpenses: (context, event)=>[
                    ...context.operationalExpenses,
                    event.operationalExpense
                ]
        },
        updateOperationalExpenses: {
            operationalExpenses: (context, event)=>{
                const index = context.operationalExpenses.findIndex((e)=>e.id === event.id);
                if (index === -1) return context.operationalExpenses;
                const updatedExpenses = [
                    ...context.operationalExpenses
                ];
                updatedExpenses[index] = {
                    ...updatedExpenses[index],
                    ...event.operationalExpense
                };
                return updatedExpenses;
            }
        },
        deleteOperationalExpenses: {
            operationalExpenses: (context, event)=>{
                const index = context.operationalExpenses.findIndex((e)=>e.id === event.id);
                if (index === -1) return context.operationalExpenses;
                const updatedExpenses = [
                    ...context.operationalExpenses
                ];
                updatedExpenses[index] = {
                    ...updatedExpenses[index],
                    deletedAt: new Date()
                };
                return updatedExpenses;
            }
        }
    }
}, {
    queryKey: [
        "operational-expenses"
    ],
    queryFn: async ()=>{
        const result = await (0, $3h7sC.trpc).operationalExpense.getOperationalExpenses.query();
        return {
            operationalExpenses: result.operationalExpenses.map((expense)=>({
                    ...expense,
                    value: Number(expense.value),
                    startDate: new Date(expense.startDate),
                    endDate: new Date(expense.endDate)
                }))
        };
    },
    mutationFn: (data)=>(0, $3h7sC.trpc).operationalExpense.saveOperationalExpenses.mutate({
            operationalExpenses: data.operationalExpenses
        }),
    staleTime: 300000,
    // 5 minutes
    cacheTime: 1800000 // 30 minutes
}, {
    saveId: "operational-expenses-save",
    requireConfirmation: true,
    confirmationMessage: "Save changes to operational expenses?",
    loadingMessage: "Saving operational expenses...",
    successMessage: "Operational expenses saved successfully",
    errorMessage: "Failed to save operational expenses"
});
const { useStoreData: $0d3fe6c0208be7e6$export$544efe5ac05fc17, useIsLoading: $0d3fe6c0208be7e6$export$4dface15d86304a4, useCanUndo: $0d3fe6c0208be7e6$export$653033ad74e314c9, useCanRedo: $0d3fe6c0208be7e6$export$e7ea8bfdbe9392b0, useUpdatedAt: $0d3fe6c0208be7e6$export$4d53551414e812c, undo: $0d3fe6c0208be7e6$export$21f930c44940fd98, redo: $0d3fe6c0208be7e6$export$1688e416fee0a49e, save: $0d3fe6c0208be7e6$export$a1544dad697b423d, revertToLastSave: $0d3fe6c0208be7e6$export$7e511c2293ae6e56, getState: $0d3fe6c0208be7e6$export$50fdfeece43146fd, getHistory: $0d3fe6c0208be7e6$export$f9582a3c130d9538, getCurrentHistoryIndex: $0d3fe6c0208be7e6$export$3d0fb93f79a1d871, getLastSavedIndex: $0d3fe6c0208be7e6$export$3ad3501ee738138, getSavedAt: $0d3fe6c0208be7e6$export$f4c906ca2124fef8, getUpdatedAt: $0d3fe6c0208be7e6$export$ff3aa069bd8fb4e4 } = $0d3fe6c0208be7e6$export$3010735393aa8a0d;
const $0d3fe6c0208be7e6$export$3baf43b90dcedd41 = (operationalExpenses)=>$0d3fe6c0208be7e6$export$3010735393aa8a0d.store.send({
        type: "setOperationalExpenses",
        operationalExpenses: operationalExpenses
    });
const $0d3fe6c0208be7e6$export$368fff0c350af660 = (operationalExpense)=>$0d3fe6c0208be7e6$export$3010735393aa8a0d.store.send({
        type: "addOperationalExpenses",
        operationalExpense: operationalExpense
    });
const $0d3fe6c0208be7e6$export$4956b559f927f021 = (id, operationalExpense)=>$0d3fe6c0208be7e6$export$3010735393aa8a0d.store.send({
        type: "updateOperationalExpenses",
        id: id,
        operationalExpense: operationalExpense
    });
const $0d3fe6c0208be7e6$export$f383c4421aa584d5 = (id)=>$0d3fe6c0208be7e6$export$3010735393aa8a0d.store.send({
        type: "deleteOperationalExpenses",
        id: id
    });
const $0d3fe6c0208be7e6$export$8fb176f2747b677d = ()=>(0, $lJ1OS.useSelector)($0d3fe6c0208be7e6$export$3010735393aa8a0d.store, (state)=>state.context.operationalExpenses);
const $0d3fe6c0208be7e6$export$e7e38f1b6c82c284 = ()=>{
    const expenses = $0d3fe6c0208be7e6$export$8fb176f2747b677d();
    return (0, $jbmdS.useMemo)(()=>expenses.filter((e)=>!(e !== null && e !== void 0 && e.deletedAt)), [
        expenses
    ]);
};

});

parcelRegister("lD3Bq", function(module, exports) {

$parcel$export(module.exports, "OverHeadExpensePage", function () { return $70cc8969cce34033$export$54478f862728c45c; });

var $61Ea1 = parcelRequire("61Ea1");

var $fTGwv = parcelRequire("fTGwv");

var $gQREm = parcelRequire("gQREm");

var $iuKE4 = parcelRequire("iuKE4");

var $9Pt1Z = parcelRequire("9Pt1Z");
const $70cc8969cce34033$export$54478f862728c45c = ()=>{
    const handleAddOverheadExpense = ()=>{
        (0, $iuKE4.addOperationalExpenses)({
            id: (0, (/*@__PURE__*/$parcel$interopDefault($9Pt1Z)))(),
            name: "",
            startDate: new Date(),
            endDate: new Date(),
            costCentreId: null,
            value: null,
            hasRepeat: false,
            repeatQuantity: null,
            repeatUnit: null
        });
    };
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "p-8",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fTGwv.Button), {
                    variant: "outline",
                    onClick: handleAddOverheadExpense,
                    children: "+ Add Overhead Expense"
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $gQREm.OverheadExpenseTable), {})
        ]
    });
};

});
parcelRegister("gQREm", function(module, exports) {

$parcel$export(module.exports, "OverheadExpenseTable", function () { return $0e875004b09c80c6$export$50fc88fda6435440; });

var $61Ea1 = parcelRequire("61Ea1");

var $O2UPo = parcelRequire("O2UPo");

var $aYyI4 = parcelRequire("aYyI4");

var $aaosT = parcelRequire("aaosT");

var $ezxNg = parcelRequire("ezxNg");

var $iuKE4 = parcelRequire("iuKE4");

var $jbmdS = parcelRequire("jbmdS");
function $0e875004b09c80c6$export$50fc88fda6435440() {
    const operationalExpenses = (0, $iuKE4.useActiveOperationalExpenses)();
    const columns = (0, $jbmdS.useMemo)(()=>(0, $ezxNg.getColumns)((column)=>{}, (0, $iuKE4.updateOperationalExpenses), (0, $iuKE4.deleteOperationalExpenses)), []);
    const defaultSort = [
        {
            id: "name",
            desc: false
        }
    ];
    const { table: table } = (0, $aaosT.useDataTable)({
        data: operationalExpenses,
        defaultSort: defaultSort,
        columns: columns,
        visibleColumns: columns.map((column)=>column === null || column === void 0 ? void 0 : column.accessorKey),
        sortingFns: {
            sortingTextFn: $O2UPo.sortingTextFn,
            sortingDateFn: $O2UPo.sortingDateFn
        }
    });
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $aYyI4.DataTable), {
        table: table
    });
}

});
parcelRegister("ezxNg", function(module, exports) {

$parcel$export(module.exports, "getColumns", function () { return $42e2967d6717e869$export$978e30a0fb8610d8; });

var $61Ea1 = parcelRequire("61Ea1");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $38AIP = parcelRequire("38AIP");

var $khCHn = parcelRequire("khCHn");

var $5QoiI = parcelRequire("5QoiI");

var $ikffN = parcelRequire("ikffN");
function $42e2967d6717e869$export$978e30a0fb8610d8(onHideColumn, updateOperationalExpenses, deleteOperationalExpenses) {
    const generateColumnDef = (0, $khCHn.createGenerateColumnDef)({
        onHideColumn: onHideColumn
    });
    const wideSize = 100;
    return [
        generateColumnDef({
            key: "name",
            type: "text",
            title: "Name",
            size: wideSize,
            editable: (0, $8kZ1o.canEditOverheadExpenses)((0, $1BTI2.default).user),
            onChange: (row, val)=>updateOperationalExpenses(row.original.id, {
                    name: val
                })
        }),
        generateColumnDef({
            key: "costCentreId",
            type: "costCentre",
            title: "Cost Centre",
            size: wideSize,
            editable: true,
            cell: (row)=>{
                return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5QoiI.CostCentreSelector), {
                    value: (0, $38AIP.getCacheItemById)("costCentres", row.getValue("costCentreId")),
                    onChange: (costCentre)=>updateOperationalExpenses(row.original.id, {
                            costCentreId: costCentre.id
                        }),
                    clearable: false
                });
            }
        }),
        generateColumnDef({
            key: "value",
            type: "currency",
            title: "Cost",
            size: wideSize,
            editable: (0, $8kZ1o.canEditOverheadExpenses)((0, $1BTI2.default).user),
            onChange: (row, val)=>updateOperationalExpenses(row.original.id, {
                    value: val ? Number(val) : null
                })
        }),
        generateColumnDef({
            key: "startDate",
            type: "date",
            title: "Start date",
            size: wideSize,
            editable: (0, $8kZ1o.canEditOverheadExpenses)((0, $1BTI2.default).user),
            onChange: (row, val)=>updateOperationalExpenses(row.original.id, {
                    startDate: val
                })
        }),
        generateColumnDef({
            key: "endDate",
            type: "date",
            title: "End date",
            size: wideSize,
            editable: (0, $8kZ1o.canEditOverheadExpenses)((0, $1BTI2.default).user),
            onChange: (row, val)=>updateOperationalExpenses(row.original.id, {
                    endDate: val
                })
        }),
        generateColumnDef({
            key: "hasRepeat",
            type: "boolean",
            title: "Repeats",
            size: wideSize,
            editable: (0, $8kZ1o.canEditOverheadExpenses)((0, $1BTI2.default).user),
            onChange: (row, val)=>updateOperationalExpenses(row.original.id, {
                    hasRepeat: val
                })
        }),
        generateColumnDef({
            key: "repeatQuantity",
            type: "number",
            title: "Every",
            size: wideSize,
            editable: (0, $8kZ1o.canEditOverheadExpenses)((0, $1BTI2.default).user),
            onChange: (row, val)=>updateOperationalExpenses(row.original.id, {
                    repeatQuantity: val ? Number(val) : null
                })
        }),
        generateColumnDef({
            key: "repeatUnit",
            type: "text",
            title: "Period",
            size: wideSize,
            editable: (0, $8kZ1o.canEditOverheadExpenses)((0, $1BTI2.default).user),
            onChange: (row, val)=>updateOperationalExpenses(row.original.id, {
                    repeatQuantity: val
                }),
            cell: (row)=>{
                if (!(0, $8kZ1o.canEditOverheadExpenses)((0, $1BTI2.default).user)) return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    children: (0, $ikffN.capitalCase)(row.getValue("hasRepeat") && row.getValue("repeatUnit") ? row.getValue("repeatUnit") : "")
                });
                return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5QoiI.Selector), {
                    value: row.getValue("repeatUnit"),
                    onChange: (opt)=>updateOperationalExpenses(row.original.id, {
                            repeatUnit: opt
                        }),
                    options: [
                        "days",
                        "weeks",
                        "months",
                        "years"
                    ],
                    getLabel: (opt)=>(0, $ikffN.capitalCase)(opt || ""),
                    clearable: false
                });
            }
        }),
        generateColumnDef({
            key: "deleteButton",
            title: "Action",
            type: "button",
            size: wideSize,
            editable: (0, $8kZ1o.canEditOverheadExpenses)((0, $1BTI2.default).user),
            cell: (row)=>{
                return /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                    className: "fa fa-times"
                });
            },
            onClick: (row)=>deleteOperationalExpenses(row.original.id)
        })
    ];
}

});


parcelRegister("9Pt1Z", function(module, exports) {

var $Mc9GY = parcelRequire("Mc9GY");

var $hwYgj = parcelRequire("hwYgj");
var $727f6574be12ba28$var$uuid = $hwYgj;
$727f6574be12ba28$var$uuid.v1 = $Mc9GY;
$727f6574be12ba28$var$uuid.v4 = $hwYgj;
module.exports = $727f6574be12ba28$var$uuid;

});
parcelRegister("Mc9GY", function(module, exports) {

var $7sLEn = parcelRequire("7sLEn");

var $3SnB1 = parcelRequire("3SnB1");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $090de99a8bfdab12$var$_nodeId;
var $090de99a8bfdab12$var$_clockseq;
// Previous uuid creation time
var $090de99a8bfdab12$var$_lastMSecs = 0;
var $090de99a8bfdab12$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $090de99a8bfdab12$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $090de99a8bfdab12$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $090de99a8bfdab12$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $7sLEn();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $090de99a8bfdab12$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $090de99a8bfdab12$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $090de99a8bfdab12$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $090de99a8bfdab12$var$_lastMSecs + (nsecs - $090de99a8bfdab12$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $090de99a8bfdab12$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    $090de99a8bfdab12$var$_lastMSecs = msecs;
    $090de99a8bfdab12$var$_lastNSecs = nsecs;
    $090de99a8bfdab12$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $3SnB1(b);
}
module.exports = $090de99a8bfdab12$var$v1;

});
parcelRegister("7sLEn", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $56f01c43882aff4e$var$getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if ($56f01c43882aff4e$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $56f01c43882aff4e$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $56f01c43882aff4e$var$getRandomValues($56f01c43882aff4e$var$rnds8);
        return $56f01c43882aff4e$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $56f01c43882aff4e$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $56f01c43882aff4e$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $56f01c43882aff4e$var$rnds;
    };
}

});

parcelRegister("3SnB1", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $2d28b7f647259e2b$var$byteToHex = [];
for(var $2d28b7f647259e2b$var$i = 0; $2d28b7f647259e2b$var$i < 256; ++$2d28b7f647259e2b$var$i)$2d28b7f647259e2b$var$byteToHex[$2d28b7f647259e2b$var$i] = ($2d28b7f647259e2b$var$i + 0x100).toString(16).substr(1);
function $2d28b7f647259e2b$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $2d28b7f647259e2b$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
module.exports = $2d28b7f647259e2b$var$bytesToUuid;

});


parcelRegister("hwYgj", function(module, exports) {

var $7sLEn = parcelRequire("7sLEn");

var $3SnB1 = parcelRequire("3SnB1");
function $cc342b9e1d4d2d66$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $7sLEn)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $3SnB1(rnds);
}
module.exports = $cc342b9e1d4d2d66$var$v4;

});




parcelRegister("faU8f", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $b0c354d8f53519e4$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");

var $69htt = parcelRequire("69htt");

var $a79qC = parcelRequire("a79qC");

var $kuPRw = parcelRequire("kuPRw");

var $47i9t = parcelRequire("47i9t");

var $4iw5i = parcelRequire("4iw5i");

var $5PXcS = parcelRequire("5PXcS");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $7qobO = parcelRequire("7qobO");

var $kqntg = parcelRequire("kqntg");

var $26sX2 = parcelRequire("26sX2");

var $lxyPU = parcelRequire("lxyPU");

var $3h7sC = parcelRequire("3h7sC");

var $iDy0J = parcelRequire("iDy0J");
const $b0c354d8f53519e4$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_private/organisation-holidays")({
    beforeLoad: ({ params: params })=>{
        if (!(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "organisationHolidays", params)) throw new Error("Permission Denied");
        (0, $26sX2.setLayoutDefaults)({
            pageTitle: "Organisation Holidays",
            subMenu: "organisation"
        });
    },
    errorComponent: ({ error: error, reset: reset })=>{
        if (error.message === "Permission Denied") return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7qobO.default), {});
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    },
    loader: async ()=>{
        const data = await (0, $3h7sC.trpc).legacy.getOrganisationHolidaysPageData.query();
        return (0, $47i9t.processTRPCData)(data);
    },
    pendingComponent: (0, $4iw5i.default),
    component: $b0c354d8f53519e4$var$Wrapper
});
function $b0c354d8f53519e4$var$Wrapper() {
    // The store now handles all the save toast logic internally
    (0, $lxyPU.holidayStore).useSaveHandler();
    if ((0, $8kZ1o.migratedToV2)()) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqntg.PageBody), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $iDy0J.OrganisationHolidaysPage), {})
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $69htt.default), {}),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kuPRw.default), {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $a79qC.default), {})
            })
        ]
    });
}

});
parcelRegister("69htt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47a12362d5943d90$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $8XaFv = parcelRequire("8XaFv");

var $36Jjh = parcelRequire("36Jjh");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");
var $47a12362d5943d90$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ extraContent: extraContent })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $36Jjh.default), {
        heading: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: "Organisation Holidays"
            })
        }),
        extraContent: (0, $8kZ1o.canEditHolidays)((0, $1BTI2.default).user) ? /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
            className: "btn btn-default add-timesheet-entry-button plus-btn mt-6",
            onClick: ()=>{
                const ph = (0, $8XaFv.default).add({}, {
                    trackUpdates: true
                });
                ph.isNew = true;
            },
            children: "+ Add Holiday"
        }) : null
    });
});

});

parcelRegister("a79qC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75d1df1afe95118b$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $goLmS = parcelRequire("goLmS");

var $8XaFv = parcelRequire("8XaFv");

var $1BTI2 = parcelRequire("1BTI2");

var $8kZ1o = parcelRequire("8kZ1o");
const $75d1df1afe95118b$var$columns = [
    {
        id: "name",
        label: "Name",
        type: "text",
        width: 25,
        editable: (row)=>(0, $8kZ1o.canEditHolidays)((0, $1BTI2.default).user),
        value: (row)=>{
            return row.name;
        },
        onChange: (row)=>(val)=>row.update({
                    name: val
                })
    },
    {
        id: "startDate",
        label: "Start Date",
        type: "date",
        width: 25,
        editable: (row)=>(0, $8kZ1o.canEditHolidays)((0, $1BTI2.default).user),
        value: (row)=>{
            return row.startDate;
        },
        onChange: (row)=>(val)=>row.update({
                    startDate: val
                })
    },
    {
        id: "endDate",
        label: "End Date",
        type: "date",
        width: 25,
        editable: (row)=>(0, $8kZ1o.canEditHolidays)((0, $1BTI2.default).user),
        value: (row)=>{
            return row.endDate;
        },
        onChange: (row)=>(val)=>row.update({
                    endDate: val
                })
    },
    {
        label: "",
        width: 4,
        type: "button",
        permissions: (r)=>(0, $8kZ1o.canEditHolidays)((0, $1BTI2.default).user),
        editable: (r)=>(0, $8kZ1o.canEditHolidays)((0, $1BTI2.default).user),
        value: (p)=>/*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                className: "fa fa-times",
                style: {
                    marginRight: 0
                }
            }),
        onClick: (r)=>()=>{
                r.update({
                    deletedAt: new Date()
                });
            }
    }
];
var $75d1df1afe95118b$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(()=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
            columns: $75d1df1afe95118b$var$columns,
            rows: (0, $8XaFv.default).activeHolidays,
            sortBy: [
                [
                    "startDate",
                    "desc"
                ]
            ],
            newRowDirection: "asc"
        })
    });
});

});

parcelRegister("lxyPU", function(module, exports) {

$parcel$export(module.exports, "holidayStore", function () { return $c1042ddb9eae760f$export$793a199bb9546120; });
$parcel$export(module.exports, "addHoliday", function () { return $c1042ddb9eae760f$export$edd92c840f518b17; });
$parcel$export(module.exports, "updateHoliday", function () { return $c1042ddb9eae760f$export$77ff310f3102af5b; });
$parcel$export(module.exports, "deleteHoliday", function () { return $c1042ddb9eae760f$export$1d5cfbf6a6865970; });
$parcel$export(module.exports, "useActiveHolidays", function () { return $c1042ddb9eae760f$export$8a4d2dbd56f69852; });

var $8qPhl = parcelRequire("8qPhl");

var $3h7sC = parcelRequire("3h7sC");

var $277OF = parcelRequire("277OF");

var $lJ1OS = parcelRequire("lJ1OS");

var $jbmdS = parcelRequire("jbmdS");
const $c1042ddb9eae760f$export$44976c085277a6c9 = (0, $8qPhl.z).object({
    id: (0, $8qPhl.z).string(),
    name: (0, $8qPhl.z).string().max(200),
    startDate: (0, $8qPhl.z).date(),
    endDate: (0, $8qPhl.z).date(),
    deletedAt: (0, $8qPhl.z).date().nullable().optional()
});
const $c1042ddb9eae760f$var$initialContext = {
    holidays: []
};
const $c1042ddb9eae760f$export$793a199bb9546120 = (0, $277OF.createQueryStore)({
    context: $c1042ddb9eae760f$var$initialContext,
    on: {
        setHolidays: {
            holidays: (_, event)=>event.holidays
        },
        addHoliday: {
            holidays: (context, event)=>[
                    ...context.holidays,
                    event.holiday
                ]
        },
        updateHoliday: {
            holidays: (context, event)=>{
                const index = context.holidays.findIndex((h)=>h.id === event.id);
                if (index === -1) return context.holidays;
                const updatedHolidays = [
                    ...context.holidays
                ];
                updatedHolidays[index] = {
                    ...updatedHolidays[index],
                    ...event.holiday
                };
                return updatedHolidays;
            }
        },
        deleteHoliday: {
            holidays: (context, event)=>{
                const index = context.holidays.findIndex((h)=>h.id === event.id);
                if (index === -1) return context.holidays;
                const updatedHolidays = [
                    ...context.holidays
                ];
                updatedHolidays[index] = {
                    ...updatedHolidays[index],
                    deletedAt: new Date()
                };
                return updatedHolidays;
            }
        }
    }
}, {
    queryKey: [
        "organisation-holidays"
    ],
    queryFn: async ()=>{
        const result = await (0, $3h7sC.trpc).organisationHolidays.getOrganisationHolidays.query();
        return {
            holidays: result.organisationHolidays.map((holiday)=>({
                    ...holiday,
                    startDate: new Date(holiday.startDate),
                    endDate: new Date(holiday.endDate)
                }))
        };
    },
    mutationFn: (data)=>(0, $3h7sC.trpc).organisationHolidays.saveOrganisationHolidays.mutate({
            organisationHolidays: data.holidays
        }),
    staleTime: 300000,
    // 5 minutes
    cacheTime: 1800000 // 30 minutes
}, {
    saveId: "organisation-holidays-save",
    requireConfirmation: true,
    confirmationMessage: "Save changes to organisation holidays?",
    loadingMessage: "Saving holidays...",
    successMessage: "Holidays saved successfully",
    errorMessage: "Failed to save holidays"
});
const { useStoreData: $c1042ddb9eae760f$export$544efe5ac05fc17, useIsLoading: $c1042ddb9eae760f$export$4dface15d86304a4, useCanUndo: $c1042ddb9eae760f$export$653033ad74e314c9, useCanRedo: $c1042ddb9eae760f$export$e7ea8bfdbe9392b0, useUpdatedAt: $c1042ddb9eae760f$export$4d53551414e812c, undo: $c1042ddb9eae760f$export$21f930c44940fd98, redo: $c1042ddb9eae760f$export$1688e416fee0a49e, save: $c1042ddb9eae760f$export$a1544dad697b423d, revertToLastSave: $c1042ddb9eae760f$export$7e511c2293ae6e56, getState: $c1042ddb9eae760f$export$50fdfeece43146fd, getHistory: $c1042ddb9eae760f$export$f9582a3c130d9538, getCurrentHistoryIndex: $c1042ddb9eae760f$export$3d0fb93f79a1d871, getLastSavedIndex: $c1042ddb9eae760f$export$3ad3501ee738138, getSavedAt: $c1042ddb9eae760f$export$f4c906ca2124fef8, getUpdatedAt: $c1042ddb9eae760f$export$ff3aa069bd8fb4e4 } = $c1042ddb9eae760f$export$793a199bb9546120;
const $c1042ddb9eae760f$export$ad481c62cdb657a6 = (holidays)=>$c1042ddb9eae760f$export$793a199bb9546120.store.send({
        type: "setHolidays",
        holidays: holidays
    });
const $c1042ddb9eae760f$export$edd92c840f518b17 = (holiday)=>$c1042ddb9eae760f$export$793a199bb9546120.store.send({
        type: "addHoliday",
        holiday: holiday
    });
const $c1042ddb9eae760f$export$77ff310f3102af5b = (id, holiday)=>$c1042ddb9eae760f$export$793a199bb9546120.store.send({
        type: "updateHoliday",
        id: id,
        holiday: holiday
    });
const $c1042ddb9eae760f$export$1d5cfbf6a6865970 = (id)=>$c1042ddb9eae760f$export$793a199bb9546120.store.send({
        type: "deleteHoliday",
        id: id
    });
const $c1042ddb9eae760f$export$8f6e46176e60ae19 = ()=>(0, $lJ1OS.useSelector)($c1042ddb9eae760f$export$793a199bb9546120.store, (state)=>state.context.holidays);
const $c1042ddb9eae760f$export$8a4d2dbd56f69852 = ()=>{
    const holidays = $c1042ddb9eae760f$export$8f6e46176e60ae19();
    return (0, $jbmdS.useMemo)(()=>holidays.filter((h)=>!(h !== null && h !== void 0 && h.deletedAt)), [
        holidays
    ]);
};

});

parcelRegister("iDy0J", function(module, exports) {

$parcel$export(module.exports, "OrganisationHolidaysPage", function () { return $3231b79fee5a4812$export$6a783f4dfa2c8d90; });

var $61Ea1 = parcelRequire("61Ea1");

var $fTGwv = parcelRequire("fTGwv");

var $9Pt1Z = parcelRequire("9Pt1Z");

var $lxyPU = parcelRequire("lxyPU");

var $d7z2v = parcelRequire("d7z2v");
const $3231b79fee5a4812$export$6a783f4dfa2c8d90 = ()=>{
    const handleAddHoliday = ()=>{
        (0, $lxyPU.addHoliday)({
            id: (0, (/*@__PURE__*/$parcel$interopDefault($9Pt1Z)))(),
            name: "",
            startDate: new Date(),
            endDate: new Date()
        });
    };
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "p-8",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fTGwv.Button), {
                    variant: "outline",
                    onClick: handleAddHoliday,
                    children: "+ Add Holiday"
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $d7z2v.OrganisationHolidaysTable), {})
        ]
    });
};

});
parcelRegister("d7z2v", function(module, exports) {

$parcel$export(module.exports, "OrganisationHolidaysTable", function () { return $fa5d5db81bd65fe1$export$321b8750bb55ed8; });

var $61Ea1 = parcelRequire("61Ea1");

var $O2UPo = parcelRequire("O2UPo");

var $aYyI4 = parcelRequire("aYyI4");

var $aaosT = parcelRequire("aaosT");

var $70loh = parcelRequire("70loh");

var $lxyPU = parcelRequire("lxyPU");

var $jbmdS = parcelRequire("jbmdS");
function $fa5d5db81bd65fe1$export$321b8750bb55ed8() {
    const holidays = (0, $lxyPU.useActiveHolidays)();
    const columns = (0, $jbmdS.useMemo)(()=>(0, $70loh.getColumns)((column)=>{}, (0, $lxyPU.updateHoliday), (0, $lxyPU.deleteHoliday)), []);
    const defaultSort = [
        {
            id: "name",
            desc: false
        }
    ];
    const { table: table } = (0, $aaosT.useDataTable)({
        data: holidays,
        defaultSort: defaultSort,
        columns: columns,
        visibleColumns: columns.map((column)=>column === null || column === void 0 ? void 0 : column.accessorKey),
        sortingFns: {
            sortingTextFn: $O2UPo.sortingTextFn,
            sortingDateFn: $O2UPo.sortingDateFn
        }
    });
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $aYyI4.DataTable), {
        table: table
    });
}

});
parcelRegister("70loh", function(module, exports) {

$parcel$export(module.exports, "getColumns", function () { return $6339cc0f96cf22ef$export$978e30a0fb8610d8; });

var $61Ea1 = parcelRequire("61Ea1");

var $khCHn = parcelRequire("khCHn");

var $1BTI2 = parcelRequire("1BTI2");

var $8kZ1o = parcelRequire("8kZ1o");
function $6339cc0f96cf22ef$export$978e30a0fb8610d8(onHideColumn, updateHoliday, deleteHoliday) {
    const generateColumnDef = (0, $khCHn.createGenerateColumnDef)({
        onHideColumn: onHideColumn
    });
    const wideSize = 100;
    return [
        generateColumnDef({
            key: "name",
            type: "text",
            title: "Name",
            size: wideSize,
            editable: (0, $8kZ1o.canEditHolidays)((0, $1BTI2.default).user),
            onChange: (row, val)=>updateHoliday(row.original.id, {
                    name: val
                })
        }),
        generateColumnDef({
            key: "startDate",
            type: "date",
            title: "Start date",
            size: wideSize,
            editable: (0, $8kZ1o.canEditHolidays)((0, $1BTI2.default).user),
            onChange: (row, val)=>updateHoliday(row.original.id, {
                    startDate: val
                })
        }),
        generateColumnDef({
            key: "endDate",
            type: "date",
            title: "End date",
            size: wideSize,
            editable: (0, $8kZ1o.canEditHolidays)((0, $1BTI2.default).user),
            onChange: (row, val)=>updateHoliday(row.original.id, {
                    endDate: val
                })
        }),
        generateColumnDef({
            key: "deleteButton",
            title: "Action",
            type: "button",
            editable: (0, $8kZ1o.canEditHolidays)((0, $1BTI2.default).user),
            permissions: ()=>(0, $8kZ1o.canEditHolidays)((0, $1BTI2.default).user),
            cell: (row)=>{
                return /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                    className: "fa fa-times"
                });
            },
            onClick: (row)=>deleteHoliday(row.original.id)
        })
    ];
}

});




parcelRegister("3OLHb", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $2c7b09eae0be9c3f$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");

var $3djN9 = parcelRequire("3djN9");

var $kuPRw = parcelRequire("kuPRw");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $7qobO = parcelRequire("7qobO");

var $4iw5i = parcelRequire("4iw5i");

var $5PXcS = parcelRequire("5PXcS");
const $2c7b09eae0be9c3f$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_private/feedback-auth")({
    beforeLoad: ({ params: params })=>{
        if (!(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "feedbackAuth", params)) throw new Error("Permission Denied");
    },
    errorComponent: ({ error: error, reset: reset })=>{
        if (error.message === "Permission Denied") return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7qobO.default), {});
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    },
    component: $2c7b09eae0be9c3f$var$Wrapper,
    pendingComponent: (0, $4iw5i.default)
});
function $2c7b09eae0be9c3f$var$Wrapper() {
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kuPRw.default), {
            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3djN9.default), {
                ...$2c7b09eae0be9c3f$export$e7b0ac011bb776c6.useParams(),
                ...$2c7b09eae0be9c3f$export$e7b0ac011bb776c6.useSearch()
            })
        })
    });
}

});
parcelRegister("3djN9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2571f037b0ead0e8$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("02LyB");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $iOQGT = parcelRequire("iOQGT");
var $2571f037b0ead0e8$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ redirect: redirect })=>{
    (0, $jbmdS.useEffect)(()=>{
        (0, $iOQGT.makeRequest)({
            path: "/feedback-auth",
            method: "GET"
        }).then((res)=>{
            const token = res.data.token;
            window.location.href = `${redirect}?ssoToken=${token}`;
        });
    }, []);
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "flex flex-align-items-center flex-justify-content-center",
        style: {
            textAlign: "center",
            alignSelf: "center"
        },
        children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            children: "Authenticating..."
        })
    });
});

});


parcelRegister("d5UIc", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $9887bbd09449d37d$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");

var $6tBpF = parcelRequire("6tBpF");

var $2kIid = parcelRequire("2kIid");

var $kuPRw = parcelRequire("kuPRw");
parcelRequire("jE5CX");

var $1BTI2 = parcelRequire("1BTI2");

var $fiZI4 = parcelRequire("fiZI4");

var $47i9t = parcelRequire("47i9t");

var $4iw5i = parcelRequire("4iw5i");

var $5PXcS = parcelRequire("5PXcS");

var $8kZ1o = parcelRequire("8kZ1o");

var $7qobO = parcelRequire("7qobO");

var $26sX2 = parcelRequire("26sX2");

var $38AIP = parcelRequire("38AIP");

var $kqntg = parcelRequire("kqntg");

var $3h7sC = parcelRequire("3h7sC");
const $9887bbd09449d37d$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_private/expense-reports")({
    beforeLoad: ({ params: params, search: search })=>{
        if (!(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "expenseReports", params)) throw new Error("Permission Denied");
        const report = (0, $38AIP.getCacheItemById)("organisationReports", search.report);
        (0, $26sX2.setLayoutDefaults)({
            pageTitle: (report === null || report === void 0 ? void 0 : report.name) || "Expense Report",
            subMenu: "expenses"
        });
    },
    errorComponent: ({ error: error, reset: reset })=>{
        if (error.message === "Permission Denied") return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7qobO.default), {});
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    },
    loader: async ({ location: location })=>await $9887bbd09449d37d$var$loader(location.search),
    loaderDeps: ({ search: { report: report } })=>({
            report: report
        }),
    pendingComponent: (0, $4iw5i.default),
    component: $9887bbd09449d37d$var$Wrapper
});
const $9887bbd09449d37d$var$loader = async ({ report: report })=>{
    var _SessionStore$organis;
    const reportId = report || ((_SessionStore$organis = (0, $1BTI2.default).organisation) === null || _SessionStore$organis === void 0 ? void 0 : _SessionStore$organis.defaultExpenseReportId);
    if (report) (0, $fiZI4.default).setReportId(reportId);
    const data = await (0, $3h7sC.trpc).legacy.getExpenseReportsPageData.query({
        reportId: reportId
    });
    return (0, $47i9t.processTRPCData)(data);
};
function $9887bbd09449d37d$var$Wrapper() {
    if ((0, $8kZ1o.migratedToV2)()) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqntg.CenterPadPageBody), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $2kIid.default), {})
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6tBpF.default), {}),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kuPRw.default), {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $2kIid.default), {})
            })
        ]
    });
}

});
parcelRegister("6tBpF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b7278f45aafc483$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $36Jjh = parcelRequire("36Jjh");

var $h6zQv = parcelRequire("h6zQv");

var $jr4Q7 = parcelRequire("jr4Q7");

var $fiZI4 = parcelRequire("fiZI4");

var $ewAM3 = parcelRequire("ewAM3");

var $4hBm1 = parcelRequire("4hBm1");

var $3X7oM = parcelRequire("3X7oM");
function $4b7278f45aafc483$var$getConsistentValue(arr, key) {
    const uniqueValues = new Set(arr.map((obj)=>obj[key]));
    return uniqueValues.size === 1 ? [
        ...uniqueValues
    ][0] || null : null;
}
var $4b7278f45aafc483$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(()=>{
    const report = (0, $fiZI4.default).report;
    const selectedRows = [
        ...(0, $fiZI4.default).selectedRows
    ];
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $36Jjh.default), {
        heading: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    children: "Expense Reports"
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    className: "text-sm font-normal px-2.5 py-1.5",
                    children: isFinite(report.dateRange[0]) ? `(${(0, $4hBm1.format)(report.dateRange[0], "dd MMMM yyyy")} - ${(0, $4hBm1.format)(report.dateRange[1], "dd MMMM yyyy")})` : `(All expense prior to: ${(0, $4hBm1.format)(new Date(), "dd MMMM yyyy")})`
                })
            ]
        }),
        rightButtons: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            className: "flex gap-2 items-center",
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    className: "export-button-dropdown inline-flex items-center dont-print gap-2",
                    children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3X7oM.default), {
                                label: "Export",
                                icon: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                    className: "fa fa-table"
                                }),
                                onClick: ()=>{
                                    (0, $fiZI4.default).downloadCSV();
                                },
                                className: "border-r-0 rounded-tr-none rounded-br-none"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                                className: "px-4 border! border-white bg-transparent hover:bg-white/25 transition-colors rounded-[6px] text-xs rounded-tl-none rounded-bl-none",
                                style: {
                                    maxWidth: "9em",
                                    margin: 0,
                                    fontSize: "1em"
                                },
                                value: (0, $fiZI4.default).groupBy[(0, $fiZI4.default).exportLevel] || "expense",
                                options: [
                                    ...(0, $fiZI4.default).groupBy,
                                    "expense"
                                ],
                                optionLabel: function(group) {
                                    var _report$columnOptions;
                                    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        children: ((_report$columnOptions = report.columnOptionsById[group]) === null || _report$columnOptions === void 0 ? void 0 : _report$columnOptions.label) || "Expense"
                                    });
                                },
                                onChange: (group)=>{
                                    const index = (0, $fiZI4.default).groupBy.indexOf(group);
                                    (0, $fiZI4.default).setExportLevel(index >= 0 > 0 ? index : (0, $fiZI4.default).groupBy.length);
                                }
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3X7oM.default), {
                    label: "Print",
                    icon: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                        className: "fa fa-print"
                    }),
                    onClick: ()=>window.print()
                })
            ]
        }),
        extraContent: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            className: "flex items-center justify-between",
            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jr4Q7.default), {
                report: report,
                reportOptions: (0, $h6zQv.default).reportsByType["expense"],
                expandLabel: (0, $fiZI4.default).expandAll ? "+ Expanding to..." : "+ Expand All to",
                expandClick: ()=>{
                    (0, $fiZI4.default).toggleExpandAll();
                },
                selector: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                    className: "px-4 border! border-white bg-transparent hover:bg-white/25 transition-colors rounded-[6px] text-xs",
                    style: {
                        maxWidth: "8em"
                    },
                    value: (0, $fiZI4.default).groupBy[(0, $fiZI4.default).expandToLevel] || "expense",
                    options: [
                        ...(0, $fiZI4.default).groupBy,
                        "expense"
                    ],
                    optionLabel: function(group) {
                        var _report$columnOptions2;
                        return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            children: ((_report$columnOptions2 = report.columnOptionsById[group]) === null || _report$columnOptions2 === void 0 ? void 0 : _report$columnOptions2.label) || "Expense"
                        });
                    },
                    onChange: (group)=>{
                        const index = (0, $fiZI4.default).groupBy.indexOf(group);
                        (0, $fiZI4.default).setExpandToLevel(index >= 0 > 0 ? index : (0, $fiZI4.default).groupBy.length);
                    }
                })
            })
        })
    });
});

});
parcelRegister("jr4Q7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2644af869b55313$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "ReportSearch", function () { return $e2644af869b55313$export$ae9c33d24d74aaae; });

var $61Ea1 = parcelRequire("61Ea1");

var $02LyB = parcelRequire("02LyB");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("h6zQv");

var $khJQv = parcelRequire("khJQv");

var $e8Hda = parcelRequire("e8Hda");
parcelRequire("fEtu5");
var $avIhR = parcelRequire("avIhR");
var $e4TNX = parcelRequire("e4TNX");

var $cnmvx = parcelRequire("cnmvx");

var $ek5Pm = parcelRequire("ek5Pm");
parcelRequire("c86dX");

var $ewAM3 = parcelRequire("ewAM3");

var $dtopU = parcelRequire("dtopU");

var $eRflC = parcelRequire("eRflC");

var $fM2j4 = parcelRequire("fM2j4");

var $8ppo6 = parcelRequire("8ppo6");

var $6OUQ7 = parcelRequire("6OUQ7");

var $7Vift = parcelRequire("7Vift");

var $3X7oM = parcelRequire("3X7oM");

var $6UBLf = parcelRequire("6UBLf");

var $eat5C = parcelRequire("eat5C");
var $e2644af869b55313$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ report: report, filterOptions: filterOptions = ()=>null, reportOptions: reportOptions = [], expandClick: expandClick, expandLabel: expandLabel, selector: selector })=>{
    var _report$groupBy;
    const [expandReportEditor, setExpandReportEditor] = (0, $jbmdS.useState)(false);
    const navigate = (0, $6UBLf.useNavigate)();
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "flex flex-col mt-8 w-full print:hidden",
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "report-selector flex items-center gap-2",
                        children: [
                            "Report: ",
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                                className: "flex-0-0-auto page-header__button",
                                style: {
                                    marginLeft: "1em",
                                    maxWidth: "15em"
                                },
                                value: report,
                                options: reportOptions.filter((r)=>!r.deletedAt).sort((a, b)=>a.name.localeCompare(b.name)),
                                searchMatcher: function(report, searchText) {
                                    return (0, $e8Hda.caseInsensitiveContains)(report.name, searchText);
                                },
                                optionLabel: function(report) {
                                    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        children: report.name
                                    });
                                },
                                onChange: (report)=>{
                                    navigate({
                                        search: (prev)=>({
                                                ...prev,
                                                report: report.id
                                            })
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                className: "flex gap-2 items-center",
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3X7oM.default), {
                                        onClick: ()=>setExpandReportEditor(!expandReportEditor),
                                        label: expandReportEditor ? "Hide " : "Edit ",
                                        rightIcon: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("fa", expandReportEditor ? "fa-angle-double-up" : "fa-angle-double-down", "m-0")
                                        }),
                                        style: {
                                            paddingLeft: "16px",
                                            paddingRight: "16px"
                                        }
                                    }),
                                    expandReportEditor ? /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                                        className: "flex items-center gap-1",
                                        children: [
                                            /*#__PURE__*/ (0, $61Ea1.jsx)($e2644af869b55313$var$ReportSaveDropdown, {
                                                report: report
                                            }),
                                            /*#__PURE__*/ (0, $61Ea1.jsx)($e2644af869b55313$var$ReportActionsDropdown, {
                                                report: report
                                            })
                                        ]
                                    }) : null
                                ]
                            })
                        ]
                    }, report.queryKey + "reportheader"),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "flex items-center gap-2 dont-print",
                        children: [
                            expandLabel && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3X7oM.default), {
                                onClick: expandClick,
                                label: expandLabel
                            }),
                            selector && selector
                        ]
                    })
                ]
            }),
            expandReportEditor ? /*#__PURE__*/ (0, $61Ea1.jsx)($e2644af869b55313$var$ReportEditor, {
                report: report,
                dateRange: report.options.dateRange,
                groupBy: (_report$groupBy = report.groupBy) === null || _report$groupBy === void 0 ? void 0 : _report$groupBy.map((prc)=>report.columnOptionsById[prc]),
                groupByOptions: Object.values(report.columnOptionsById),
                filterOptions: filterOptions
            }) : null
        ]
    });
});
const $e2644af869b55313$var$ReportSaveDropdown = (0, $1EEMt.observer)(({ report: report })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $avIhR.Dropdown3), {
        // isExpanded={this.props.isExpanded}
        // onToggle={this.handleToggle}
        toggleElement: /*#__PURE__*/ (0, $61Ea1.jsxs)("button", {
            className: "primary flex items-center gap-1 py-2 px-4 border border-white bg-transparent hover:bg-white/25 transition-colors rounded-[6px] text-xs",
            children: [
                "Save",
                /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                    className: "rw-i rw-i-caret-down"
                })
            ]
        }),
        contentStyle: {
            width: "14em",
            color: "#444",
            borderRadius: "0.5em"
        },
        children: [
            !report.systemReport ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $avIhR.Dropdown3ListItem), {
                style: {
                    padding: "0.5em 1em",
                    height: "2.5em"
                },
                className: "report-save-dropdown__save-option",
                onClick: ()=>(0, $fM2j4.default).saveModel(report),
                children: "Save"
            }) : null,
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $avIhR.Dropdown3ListItem), {
                style: {
                    padding: "0.5em 1em",
                    height: "2.5em"
                },
                onClick: ()=>{
                    (0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $8ppo6.default), {
                        report: report,
                        modalId: "saveAsReport"
                    }));
                },
                children: "Save As..."
            })
        ]
    });
});
const $e2644af869b55313$var$ReportActionsDropdown = (0, $1EEMt.observer)(({ report: report })=>{
    const navigate = (0, $6UBLf.useNavigate)();
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $avIhR.Dropdown3), {
        // isExpanded={this.props.isExpanded}
        // onToggle={this.handleToggle}
        toggleElement: /*#__PURE__*/ (0, $61Ea1.jsxs)("button", {
            className: "primary flex items-center gap-1 py-2 px-4 border border-white bg-transparent hover:bg-white/25 transition-colors rounded-[6px] text-xs",
            children: [
                "Actions",
                /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                    className: "rw-i rw-i-caret-down",
                    style: {
                        marginLeft: "0.5em"
                    }
                })
            ]
        }),
        contentStyle: {
            width: "18em",
            color: "#444",
            borderRadius: "0.5em"
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $avIhR.Dropdown3ListItem), {
                style: {
                    padding: "0.5em 1em",
                    height: "2.5em"
                },
                onClick: ()=>report.makeDefault(),
                children: "Set As Default"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $avIhR.Dropdown3ListItem), {
                style: {
                    padding: "0.5em 1em",
                    height: "2.5em"
                },
                onClick: ()=>{
                    (0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $eRflC.default), {
                        report: report,
                        modalId: "renameReport"
                    }));
                },
                children: "Rename"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $avIhR.Dropdown3ListItem), {
                style: {
                    padding: "0.5em 1em",
                    height: "2.5em"
                },
                onClick: ()=>{
                    report.update({
                        deletedAt: new Date()
                    });
                    (0, $fM2j4.default).saveModel(report);
                    report.removeDefault();
                    navigate({
                        search: (prev)=>(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).omitBy({
                                ...prev,
                                report: null
                            }, (v)=>v === null)
                    });
                // ReportCollection.delete(report.id)
                },
                children: "Delete"
            })
        ]
    });
});
const $e2644af869b55313$var$ReportEditor = (0, $1EEMt.observer)(({ report: report, dateRange: dateRange, groupBy: groupBy, groupByOptions: groupByOptions, filterOptions: filterOptions })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "dont-print",
        style: {
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            borderRadius: "1em",
            margin: "1em 0 0 0"
        },
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    style: {
                        borderBottom: "solid 1px #ccc",
                        padding: "1em"
                    },
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            children: dateRange ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                className: "inline-flex flex-align-items-center report-widget__use-data-from",
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("label", {
                                        className: "mx-1 text-white",
                                        children: "Use data from:"
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.RelativeDateSelector), {
                                        className: "mx-1 text-white",
                                        style: {
                                            marginLeft: "0.5em",
                                            marginRight: "0.5em"
                                        },
                                        selectedDateRange: dateRange,
                                        onChange: (dateRange)=>report.updateOptions("dateRange", dateRange),
                                        fortnightType: report.options.fortnightType,
                                        onChangeFortnightType: (fortnightType)=>report.updateOptions("fortnightType", fortnightType)
                                    })
                                ]
                            }) : null
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            className: "flex flex-align-items-center",
                            style: {
                                marginTop: "1em"
                            },
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("label", {
                                    className: "mx-1 text-white",
                                    children: "Columns:"
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6OUQ7.default), {
                                    className: "!text-sm !text-[#333]",
                                    selectedOptions: report.columns.map((c)=>report.columnOptionsById[c]).filter((c)=>!c.permissions || c.permissions()),
                                    options: Object.values(report.columnOptionsById).filter((c)=>!c.permissions || c.permissions()),
                                    styles: {
                                        container: (provided, state)=>({
                                                ...provided,
                                                color: "#444",
                                                width: "50em"
                                            }),
                                        input: (provided, state)=>({
                                                ...provided,
                                                color: "#444"
                                            }),
                                        menu: (provided, state)=>({
                                                ...provided,
                                                fontSize: "0.9em",
                                                color: "#444"
                                            })
                                    },
                                    onChange: (columns)=>report.updateColumns(columns.map((c)=>c.id)),
                                    filter: function(item, searchText) {
                                        return item.label.toLowerCase().match(searchText.toLowerCase());
                                    }
                                })
                            ]
                        }),
                        report.type === "timesheet" ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            className: "flex flex-align-items-center",
                            style: {
                                marginTop: "1em"
                            },
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("label", {
                                    className: "mx-1 text-white",
                                    children: "Group by:"
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6OUQ7.default), {
                                    className: "!text-sm !text-[#333]",
                                    selectedOptions: groupBy,
                                    options: groupByOptions,
                                    styles: {
                                        container: (provided, state)=>({
                                                ...provided,
                                                color: "#444",
                                                width: "50em"
                                            }),
                                        input: (provided, state)=>({
                                                ...provided,
                                                color: "#444"
                                            }),
                                        menu: (provided, state)=>({
                                                ...provided,
                                                fontSize: "0.9em",
                                                color: "#444"
                                            })
                                    },
                                    onChange: (groups)=>report.update({
                                            groupBy: groups.map((g)=>g.id)
                                        }, {}, true),
                                    filter: function(item, searchText) {
                                        return item.label.toLowerCase().match(searchText.toLowerCase());
                                    }
                                })
                            ]
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)($e2644af869b55313$var$ReportFilterList, {
                    report: report,
                    columns: Object.values(report.columnOptionsById),
                    filters: report.filters,
                    filterOptions: filterOptions
                }, report.queryKey + "filters")
            ]
        }, report.queryKey + "reporteditor")
    });
});
const $e2644af869b55313$var$ReportFilterList = (0, $1EEMt.observer)(({ columns: columns, filters: filters, filterOptions: filterOptions, report: report })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        style: {
            padding: "1em 1.5em"
        },
        children: [
            filters.map(function(filter, filterIndex) {
                return /*#__PURE__*/ (0, $61Ea1.jsx)($e2644af869b55313$var$DefaultFilterRow, {
                    filter: filter,
                    columns: columns,
                    report: report,
                    filterOptions: filterOptions
                }, filter.column + filterIndex);
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "mt-4",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                    className: "btn btn-default add-filter-button plus-btn",
                    onClick: ()=>report.addFilter(),
                    children: "+ Add filter"
                })
            })
        ]
    });
});
const $e2644af869b55313$export$ae9c33d24d74aaae = (0, $1EEMt.observer)(({ report: report, placeholder: placeholder })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $e4TNX.FilterTextBox), {
        style: {
            width: "19em"
        },
        value: report.searchFilter || "",
        onChange: (val)=>report.updateSearchFilter(val),
        placeholder: placeholder
    });
});
const $e2644af869b55313$var$DefaultFilterRow = (0, $1EEMt.observer)(({ filter: filter, filterOptions: filterOptions, columns: columns, report: report })=>{
    const column = report.columnOptionsById[filter.column];
    return /*#__PURE__*/ (0, $61Ea1.jsx)($e2644af869b55313$var$FilterRow, {
        filter: filter,
        columns: columns,
        report: report,
        filterValueInput: /*#__PURE__*/ (0, $61Ea1.jsx)($e2644af869b55313$var$FilterInput, {
            filter: filter,
            column: column,
            report: report
        }),
        filterOptions: filterOptions({
            filter: filter,
            columns: columns,
            report: report
        })
    });
});
const $e2644af869b55313$var$FilterInput = (0, $1EEMt.observer)(({ filter: filter, column: column, report: report })=>{
    var _filter$value;
    const columnType = column.type;
    const isRangeValue = filter.operator.includes("between");
    let value = (_filter$value = filter.value) !== null && _filter$value !== void 0 ? _filter$value : isRangeValue ? (0, $cnmvx.rangeValueDefaults)[columnType] : (0, $cnmvx.singleValueDefaults)[columnType];
    if (!isRangeValue) return ((0, $ek5Pm.default)[(0, (/*@__PURE__*/$parcel$interopDefault($dtopU)))(column.type, 2)] || (0, $ek5Pm.default)[column.type])({
        value: value instanceof Array && (0, $7Vift.CollectionLookup)[(0, (/*@__PURE__*/$parcel$interopDefault($dtopU)))(column.type, 2)] ? value.map((v)=>(0, $7Vift.CollectionLookup)[(0, (/*@__PURE__*/$parcel$interopDefault($dtopU)))(column.type, 2)].modelsById[v]) : value,
        editable: true,
        onChange: (val)=>{
            var _val$;
            report.updateFilter(filter, "value", val instanceof Array && (_val$ = val[0]) !== null && _val$ !== void 0 && _val$.id ? val.map((v)=>v.id) : val);
        },
        className: "w-full rounded !min-h-9"
    });
    if (columnType === "date") return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.RelativeDateSelector), {
            className: "mx-1 !w-1/2 [&_span]:text-black",
            style: {
                marginLeft: "0.5em",
                marginRight: "0.5em"
            },
            selectedDateRange: value,
            onChange: (dateRange)=>report.updateFilter(filter, "value", dateRange),
            variant: "secondary"
        })
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "flex items-center",
        children: [
            ((0, $ek5Pm.default)[(0, (/*@__PURE__*/$parcel$interopDefault($dtopU)))(column.type, 2)] || (0, $ek5Pm.default)[column.type])({
                value: value === null || value === void 0 ? void 0 : value[0],
                editable: true,
                onChange: (val)=>report.updateFilter(filter, "value", [
                        val,
                        value === null || value === void 0 ? void 0 : value[1]
                    ]),
                className: "w-full rounded !min-h-9 p-2"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "text-white",
                style: {
                    margin: "0 0.5em"
                },
                children: "to"
            }),
            ((0, $ek5Pm.default)[(0, (/*@__PURE__*/$parcel$interopDefault($dtopU)))(column.type, 2)] || (0, $ek5Pm.default)[column.type])({
                value: value === null || value === void 0 ? void 0 : value[1],
                editable: true,
                onChange: (val)=>report.updateFilter(filter, "value", [
                        value === null || value === void 0 ? void 0 : value[0],
                        val
                    ]),
                className: "w-full rounded !min-h-9 p-2"
            })
        ]
    });
});
const $e2644af869b55313$var$FilterRow = (0, $1EEMt.observer)(({ filter: filter, columns: columns, report: report, filterValueInput: filterValueInput, filterOptions: filterOptions })=>{
    const column = report.columnOptionsById[filter.column];
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "filter-row py-[0.5em] border-b border-[#ccc] flex items-center",
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "inline-block align-top mr-[0.5em] mt-[0.3em] flex-grow-0",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                    className: "filter-row__column-select",
                    value: column,
                    options: columns.filter((c)=>!c.permissions || c.permissions()).map((c)=>({
                            value: c,
                            label: c.label || "-- Select a column --"
                        })),
                    onChange: (col)=>{
                        return report.updateFilter(filter, "column", col.id);
                    },
                    searchMatcher: (col, searchTerm)=>col != null && (0, $e8Hda.caseInsensitiveContains)(col.label, searchTerm),
                    style: {
                        minWidth: "15em"
                    }
                })
            }),
            column != null ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "flex items-center w-full",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "flex items-center w-2/3",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                style: {
                                    display: "inline-block",
                                    verticalAlign: "top",
                                    marginRight: "0.5em"
                                },
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                                    className: "filter-row__operator-select",
                                    value: filter.operator || (0, $cnmvx.operatorDefaults)[column.type],
                                    options: Object.keys((0, $cnmvx.operatorLabels)[column.type]),
                                    onChange: (col)=>{
                                        report.updateFilter(filter, "operator", col);
                                        report.updateFilter(filter, "value", null);
                                    },
                                    optionLabel: (c)=>(0, $cnmvx.operatorLabels)[column.type][c],
                                    style: {
                                        minWidth: "12em"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "!text-sm !text-444 inline-block align-top w-full rounded-[6px]",
                                children: filterValueInput
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "whitespace-nowrap ml-4",
                        style: {
                            display: "inline-block",
                            verticalAlign: "top",
                            marginRight: "0.5em",
                            marginTop: "0.3em"
                        },
                        children: filterOptions
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    display: "inline-block",
                    verticalAlign: "top",
                    marginRight: "0.5em",
                    flexGrow: 0
                },
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $avIhR.SmallDeleteButton), {
                    onClick: ()=>report.removeFilter(filter)
                })
            })
        ]
    });
});

});

parcelRegister("fiZI4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02e022b4a2ebecf9$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");
parcelRequire("jbmdS");
parcelRequire("eat5C");

var $h6zQv = parcelRequire("h6zQv");

var $1BTI2 = parcelRequire("1BTI2");

var $gIG4O = parcelRequire("gIG4O");
parcelRequire("jE5CX");

var $cv7Es = parcelRequire("cv7Es");

var $6Q5sp = parcelRequire("6Q5sp");

var $Ds2V9 = parcelRequire("Ds2V9");

var $hdshG = parcelRequire("hdshG");

var $cV8g5 = parcelRequire("cV8g5");

var $6mjwz = parcelRequire("6mjwz");
var $02e022b4a2ebecf9$var$_dec, $02e022b4a2ebecf9$var$_dec2, $02e022b4a2ebecf9$var$_dec3, $02e022b4a2ebecf9$var$_dec4, $02e022b4a2ebecf9$var$_dec5, $02e022b4a2ebecf9$var$_dec6, $02e022b4a2ebecf9$var$_dec7, $02e022b4a2ebecf9$var$_dec8, $02e022b4a2ebecf9$var$_dec9, $02e022b4a2ebecf9$var$_dec10, $02e022b4a2ebecf9$var$_class, $02e022b4a2ebecf9$var$_descriptor, $02e022b4a2ebecf9$var$_descriptor2, $02e022b4a2ebecf9$var$_descriptor3, $02e022b4a2ebecf9$var$_descriptor4, $02e022b4a2ebecf9$var$_descriptor5, $02e022b4a2ebecf9$var$_descriptor6, $02e022b4a2ebecf9$var$_descriptor7;
function $02e022b4a2ebecf9$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $02e022b4a2ebecf9$var$_defineProperty(e, r, t) {
    return (r = $02e022b4a2ebecf9$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $02e022b4a2ebecf9$var$_toPropertyKey(t) {
    var i = $02e022b4a2ebecf9$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $02e022b4a2ebecf9$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $02e022b4a2ebecf9$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $02e022b4a2ebecf9$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
const $02e022b4a2ebecf9$var$supportedAggregates = [
    "sum",
    "avg",
    "min",
    "max",
    "count"
];
const $02e022b4a2ebecf9$var$columnsToFilterFields = {
    project: "projectId",
    projectPhase: "phaseTitle",
    staffMember: "staffId",
    task: "taskName",
    date: "date",
    numMinutes: "numMinutes",
    notes: "notes",
    costCentre: "projectCostCentreId",
    staffCostCentre: "staffCostCentreId",
    projectOwner: "projectOwnerId",
    projectContact: "projectContactId",
    projectInvoiceContact: "projectInvoiceContact",
    projectCode: "projectCode",
    projectPhaseCode: "projectPhaseCode",
    staffMemberFirstName: "staffMemberFirstName",
    staffMemberLastName: "staffMemberLastName",
    staffRole: "staffRoleId",
    monthIndex: "month",
    isBillable: "isBillable",
    isVariation: "isVariation",
    beenInvoiced: "beenInvoiced",
    isOverexpense: "isOverexpense",
    isLocked: "isLocked",
    flexi: "flexi",
    remote: "remote",
    fee: "projectFee",
    remainingFee: "projectRemainingFee",
    budget: "projectExpenseBudget",
    hoursBudget: "projectHoursBudget",
    startMinutes: "startMinutes",
    endMinutes: "startMinutes",
    labourExpense: "pay",
    cost: "cost",
    chargeOut: "chargeOut",
    chargeOutRate: "chargeOutRate",
    hasNotes: "hasNotes"
};
const $02e022b4a2ebecf9$var$columnsToGroupFields = {
    ...$02e022b4a2ebecf9$var$columnsToFilterFields
};
const $02e022b4a2ebecf9$var$groupsToModelProps = {
    project: "project",
    projectPhase: "phaseTitle",
    staffMember: "staff",
    staffRole: "role",
    task: "task"
};
let $02e022b4a2ebecf9$var$ExpenseReportStore = ($02e022b4a2ebecf9$var$_dec = (0, $4JcCM.action).bound, $02e022b4a2ebecf9$var$_dec2 = (0, $4JcCM.action).bound, $02e022b4a2ebecf9$var$_dec3 = (0, $4JcCM.action).bound, $02e022b4a2ebecf9$var$_dec4 = (0, $4JcCM.action).bound, $02e022b4a2ebecf9$var$_dec5 = (0, $4JcCM.action).bound, $02e022b4a2ebecf9$var$_dec6 = (0, $4JcCM.action).bound, $02e022b4a2ebecf9$var$_dec7 = (0, $4JcCM.action).bound, $02e022b4a2ebecf9$var$_dec8 = (0, $4JcCM.action).bound, $02e022b4a2ebecf9$var$_dec9 = (0, $4JcCM.action).bound, $02e022b4a2ebecf9$var$_dec10 = (0, $4JcCM.action).bound, $02e022b4a2ebecf9$var$_class = class ExpenseReportStore {
    constructor(){
        $02e022b4a2ebecf9$var$_defineProperty(this, "rowsLookup", {});
        $02e022b4a2ebecf9$var$_defineProperty(this, "rowsById", {});
        $02e022b4a2ebecf9$var$_initializerDefineProperty(this, "selectedRows", $02e022b4a2ebecf9$var$_descriptor, this);
        $02e022b4a2ebecf9$var$_defineProperty(this, "queryIds", new Set());
        $02e022b4a2ebecf9$var$_initializerDefineProperty(this, "batchSaving", $02e022b4a2ebecf9$var$_descriptor2, this);
        $02e022b4a2ebecf9$var$_initializerDefineProperty(this, "expandAll", $02e022b4a2ebecf9$var$_descriptor3, this);
        $02e022b4a2ebecf9$var$_initializerDefineProperty(this, "expandToLevel", $02e022b4a2ebecf9$var$_descriptor4, this);
        $02e022b4a2ebecf9$var$_initializerDefineProperty(this, "exportLevel", $02e022b4a2ebecf9$var$_descriptor5, this);
        $02e022b4a2ebecf9$var$_initializerDefineProperty(this, "tableStoresById", $02e022b4a2ebecf9$var$_descriptor6, this);
        $02e022b4a2ebecf9$var$_initializerDefineProperty(this, "queryData", $02e022b4a2ebecf9$var$_descriptor7, this);
        $02e022b4a2ebecf9$var$_defineProperty(this, "reportId", null);
        $02e022b4a2ebecf9$var$_defineProperty(this, "tableStore", new (0, $hdshG.default)());
        $02e022b4a2ebecf9$var$_defineProperty(this, "getRowsAtLevel", (0, $Ds2V9.computedFn)((level)=>{
            const getRows = (data, currentLevel)=>{
                if (currentLevel === level) return data;
                if (!data) return [];
                return data.flatMap((d)=>getRows((d === null || d === void 0 ? void 0 : d.children) || [], currentLevel + 1));
            };
            return getRows(this.queryData, 0);
        }));
        $02e022b4a2ebecf9$var$_defineProperty(this, "getLeafRows", (0, $Ds2V9.computedFn)((row)=>{
            var _row$children;
            if (!((_row$children = row.children) !== null && _row$children !== void 0 && _row$children.length)) return [
                row
            ];
            return row.children.flatMap((c)=>this.getLeafRows(c));
        }));
        $02e022b4a2ebecf9$var$_defineProperty(this, "isRowSelected", (0, $Ds2V9.computedFn)((row)=>{
            return this.getLeafRows(row).every((r)=>this.selectedRows.has(r));
        }));
        (0, $4JcCM.makeObservable)(this);
    }
    init(queryData) {
        this.queryData = queryData;
        this.tableStore = new (0, $hdshG.default)();
        this.selectedRows = new Set();
        this.exportLevel = this.report.groupBy.length;
    }
    reset() {
        this.rowsLookup = {};
        this.rowsById = {};
        this.selectedRows = new Set();
        this.queryIds = new Set();
        this.batchSaving = false;
        this.expandAll = false;
        this.expandToLevel = 1;
        this.exportLevel = this.report.groupBy.length;
        this.tableStore = new (0, $hdshG.default)();
        this.reportId = null;
    }
    toggleExpandAll() {
        this.expandAll = !this.expandAll;
    }
    setExpandToLevel(expandToLevel) {
        this.expandToLevel = expandToLevel;
    }
    setExportLevel(exportLevel) {
        this.exportLevel = exportLevel;
    }
    get report() {
        var _SessionStore$organis;
        return (0, $h6zQv.default).reportsById[this.reportId] || ((_SessionStore$organis = (0, $1BTI2.default).organisation) === null || _SessionStore$organis === void 0 ? void 0 : _SessionStore$organis.defaultExpenseReport);
    }
    get groupBy() {
        var _this$report, _this$report$groupBy;
        return (_this$report = this.report) !== null && _this$report !== void 0 && (_this$report$groupBy = _this$report.groupBy) !== null && _this$report$groupBy !== void 0 && _this$report$groupBy.length ? this.report.groupBy : (0, $gIG4O.default).groupBy;
    }
    get sortBy() {
        var _this$report2, _this$report2$sortBy;
        return (_this$report2 = this.report) !== null && _this$report2 !== void 0 && (_this$report2$sortBy = _this$report2.sortBy) !== null && _this$report2$sortBy !== void 0 && _this$report2$sortBy.length ? this.report.sortBy : (0, $gIG4O.default).sortBy;
    }
    selectRow(row) {
        this.getLeafRows(row).forEach((r)=>{
            this.selectedRows.add(r);
        });
    }
    deselectRow(row) {
        this.getLeafRows(row).forEach((r)=>{
            this.selectedRows.delete(r);
        });
    }
    selectAllRows() {
        this.queryData.forEach((row)=>this.selectRow(row));
    }
    deselectAllRows() {
        this.selectedRows.clear();
    }
    batchSaveSelectedRows(data) {
        this.batchSaving = true;
        const selectedExpenseIds = [
            ...this.selectedRows
        ].map((r)=>r.expenseId);
        (0, $cv7Es.default).addData({
            collection: "expenses",
            ids: selectedExpenseIds,
            data: data
        });
        (0, $cv7Es.default).startSave(()=>{
            const queryIds = [
                ...this.queryIds
            ];
            (0, $6Q5sp.queryClient).invalidateQueries([
                this.report.queryKey
            ]);
            this.batchSaving = false;
        });
        this.selectedRows.clear();
        this.rowsLookup = {};
    }
    async downloadCSV() {
        const rows = this.getRowsAtLevel(this.exportLevel);
        const tableStore = new (0, $hdshG.default)();
        tableStore.update({
            columns: this.report.tableColumns,
            rows: rows
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($cV8g5)))((0, (/*@__PURE__*/$parcel$interopDefault($6mjwz))).unparse(tableStore.getCsvData()), `${this.report.name}.csv`, "text/csv");
    }
    setReportId(id) {
        this.reportId = id;
    }
}, $02e022b4a2ebecf9$var$_descriptor = $02e022b4a2ebecf9$var$_applyDecoratedDescriptor($02e022b4a2ebecf9$var$_class.prototype, "selectedRows", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Set();
    }
}), $02e022b4a2ebecf9$var$_descriptor2 = $02e022b4a2ebecf9$var$_applyDecoratedDescriptor($02e022b4a2ebecf9$var$_class.prototype, "batchSaving", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $02e022b4a2ebecf9$var$_descriptor3 = $02e022b4a2ebecf9$var$_applyDecoratedDescriptor($02e022b4a2ebecf9$var$_class.prototype, "expandAll", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $02e022b4a2ebecf9$var$_descriptor4 = $02e022b4a2ebecf9$var$_applyDecoratedDescriptor($02e022b4a2ebecf9$var$_class.prototype, "expandToLevel", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 1;
    }
}), $02e022b4a2ebecf9$var$_descriptor5 = $02e022b4a2ebecf9$var$_applyDecoratedDescriptor($02e022b4a2ebecf9$var$_class.prototype, "exportLevel", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 10;
    }
}), $02e022b4a2ebecf9$var$_descriptor6 = $02e022b4a2ebecf9$var$_applyDecoratedDescriptor($02e022b4a2ebecf9$var$_class.prototype, "tableStoresById", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $02e022b4a2ebecf9$var$_descriptor7 = $02e022b4a2ebecf9$var$_applyDecoratedDescriptor($02e022b4a2ebecf9$var$_class.prototype, "queryData", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $02e022b4a2ebecf9$var$_applyDecoratedDescriptor($02e022b4a2ebecf9$var$_class.prototype, "init", [
    $02e022b4a2ebecf9$var$_dec
], Object.getOwnPropertyDescriptor($02e022b4a2ebecf9$var$_class.prototype, "init"), $02e022b4a2ebecf9$var$_class.prototype), $02e022b4a2ebecf9$var$_applyDecoratedDescriptor($02e022b4a2ebecf9$var$_class.prototype, "reset", [
    $02e022b4a2ebecf9$var$_dec2
], Object.getOwnPropertyDescriptor($02e022b4a2ebecf9$var$_class.prototype, "reset"), $02e022b4a2ebecf9$var$_class.prototype), $02e022b4a2ebecf9$var$_applyDecoratedDescriptor($02e022b4a2ebecf9$var$_class.prototype, "toggleExpandAll", [
    $02e022b4a2ebecf9$var$_dec3
], Object.getOwnPropertyDescriptor($02e022b4a2ebecf9$var$_class.prototype, "toggleExpandAll"), $02e022b4a2ebecf9$var$_class.prototype), $02e022b4a2ebecf9$var$_applyDecoratedDescriptor($02e022b4a2ebecf9$var$_class.prototype, "setExpandToLevel", [
    $02e022b4a2ebecf9$var$_dec4
], Object.getOwnPropertyDescriptor($02e022b4a2ebecf9$var$_class.prototype, "setExpandToLevel"), $02e022b4a2ebecf9$var$_class.prototype), $02e022b4a2ebecf9$var$_applyDecoratedDescriptor($02e022b4a2ebecf9$var$_class.prototype, "setExportLevel", [
    $02e022b4a2ebecf9$var$_dec5
], Object.getOwnPropertyDescriptor($02e022b4a2ebecf9$var$_class.prototype, "setExportLevel"), $02e022b4a2ebecf9$var$_class.prototype), $02e022b4a2ebecf9$var$_applyDecoratedDescriptor($02e022b4a2ebecf9$var$_class.prototype, "report", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($02e022b4a2ebecf9$var$_class.prototype, "report"), $02e022b4a2ebecf9$var$_class.prototype), $02e022b4a2ebecf9$var$_applyDecoratedDescriptor($02e022b4a2ebecf9$var$_class.prototype, "groupBy", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($02e022b4a2ebecf9$var$_class.prototype, "groupBy"), $02e022b4a2ebecf9$var$_class.prototype), $02e022b4a2ebecf9$var$_applyDecoratedDescriptor($02e022b4a2ebecf9$var$_class.prototype, "sortBy", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($02e022b4a2ebecf9$var$_class.prototype, "sortBy"), $02e022b4a2ebecf9$var$_class.prototype), $02e022b4a2ebecf9$var$_applyDecoratedDescriptor($02e022b4a2ebecf9$var$_class.prototype, "selectRow", [
    $02e022b4a2ebecf9$var$_dec6
], Object.getOwnPropertyDescriptor($02e022b4a2ebecf9$var$_class.prototype, "selectRow"), $02e022b4a2ebecf9$var$_class.prototype), $02e022b4a2ebecf9$var$_applyDecoratedDescriptor($02e022b4a2ebecf9$var$_class.prototype, "deselectRow", [
    $02e022b4a2ebecf9$var$_dec7
], Object.getOwnPropertyDescriptor($02e022b4a2ebecf9$var$_class.prototype, "deselectRow"), $02e022b4a2ebecf9$var$_class.prototype), $02e022b4a2ebecf9$var$_applyDecoratedDescriptor($02e022b4a2ebecf9$var$_class.prototype, "selectAllRows", [
    $02e022b4a2ebecf9$var$_dec8
], Object.getOwnPropertyDescriptor($02e022b4a2ebecf9$var$_class.prototype, "selectAllRows"), $02e022b4a2ebecf9$var$_class.prototype), $02e022b4a2ebecf9$var$_applyDecoratedDescriptor($02e022b4a2ebecf9$var$_class.prototype, "deselectAllRows", [
    $02e022b4a2ebecf9$var$_dec9
], Object.getOwnPropertyDescriptor($02e022b4a2ebecf9$var$_class.prototype, "deselectAllRows"), $02e022b4a2ebecf9$var$_class.prototype), $02e022b4a2ebecf9$var$_applyDecoratedDescriptor($02e022b4a2ebecf9$var$_class.prototype, "batchSaveSelectedRows", [
    $02e022b4a2ebecf9$var$_dec10
], Object.getOwnPropertyDescriptor($02e022b4a2ebecf9$var$_class.prototype, "batchSaveSelectedRows"), $02e022b4a2ebecf9$var$_class.prototype), $02e022b4a2ebecf9$var$_class);
var $02e022b4a2ebecf9$export$2e2bcd8739ae039 = new $02e022b4a2ebecf9$var$ExpenseReportStore();

});


parcelRegister("2kIid", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b2fcea348ec4aa7$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $goLmS = parcelRequire("goLmS");

var $1BTI2 = parcelRequire("1BTI2");

var $6RcUP = parcelRequire("6RcUP");

var $fiZI4 = parcelRequire("fiZI4");

var $4iw5i = parcelRequire("4iw5i");

var $eat5C = parcelRequire("eat5C");

var $6Q5sp = parcelRequire("6Q5sp");

var $3erXY = parcelRequire("3erXY");

var $4hBm1 = parcelRequire("4hBm1");

var $6d1V1 = parcelRequire("6d1V1");
let $1b2fcea348ec4aa7$var$renders = 0;
var $1b2fcea348ec4aa7$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(()=>{
    var _SessionStore$user;
    const report = (0, $fiZI4.default).report;
    if (!report) return null;
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6RcUP.default), {
        queryIds: [
            {
                id: report.queryKey,
                path: "https://server2.coincraft.co/expense-report",
                staleTime: 0,
                cacheTime: 0,
                method: "POST",
                data: {
                    organisationId: (0, $1BTI2.default).organisationId,
                    userId: (_SessionStore$user = (0, $1BTI2.default).user) === null || _SessionStore$user === void 0 ? void 0 : _SessionStore$user.id,
                    columns: report.columns.filter((c)=>{
                        var _report$columnOptions;
                        return !((_report$columnOptions = report.columnOptionsById[c]) !== null && _report$columnOptions !== void 0 && _report$columnOptions.permissions) || report.columnOptionsById[c].permissions();
                    }),
                    filters: report.filters.filter(Boolean),
                    groupBy: report.groupBy,
                    sortBy: report.sortBy,
                    dateRange: report.dateRange.map((d)=>isFinite(d) ? (0, $4hBm1.format)(d, "yyyy-MM-dd") : null)
                }
            }
        ],
        loading: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $4iw5i.default), {}),
        children: /*#__PURE__*/ (0, $61Ea1.jsx)($1b2fcea348ec4aa7$var$ExpenseTable, {}, report.queryKey)
    });
});
const $1b2fcea348ec4aa7$var$ExpenseTable = (0, $1EEMt.observer)(({ level: level = 0, parent: parent = null })=>{
    var _queryClient$getQuery;
    const store = (0, $fiZI4.default);
    const report = store.report;
    const queryData = (_queryClient$getQuery = (0, $6Q5sp.queryClient).getQueryData([
        report.queryKey
    ])) === null || _queryClient$getQuery === void 0 ? void 0 : _queryClient$getQuery.data;
    (0, $jbmdS.useEffect)(()=>{
        store.init(queryData);
    }, [
        report.queryKey,
        queryData
    ]);
    if (store.batchSaving) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $4iw5i.default), {});
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            !level ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3erXY.default), {
                report: report
            }) : null,
            /*#__PURE__*/ (0, $61Ea1.jsx)($1b2fcea348ec4aa7$var$ExpenseTableTable, {
                level: level,
                parent: parent
            }, report.queryKey)
        ]
    });
});
const $1b2fcea348ec4aa7$var$ExpenseTableTable = (0, $1EEMt.observer)(({ level: level = 0, parent: parent = null })=>{
    const isPrinting = (0, $6d1V1.useMediaQuery)("print");
    const store = (0, $fiZI4.default);
    const { report: report, groupBy: groupBy, sortBy: sortBy } = store;
    const bgColor = 256 - level * 5;
    const bgShadow = bgColor - 10;
    const tableColumns = (0, $jbmdS.useMemo)(()=>report === null || report === void 0 ? void 0 : report.tableColumns.filter((c)=>!store.groupBy.includes(c.id)), [
        report,
        store.groupBy
    ]);
    const getChildComponent = (0, $jbmdS.useCallback)((r)=>/*#__PURE__*/ (0, $61Ea1.jsx)($1b2fcea348ec4aa7$var$ExpenseTableTable, {
            parent: r,
            level: level + 1
        }, `${report.queryKey}-${level}-${r.key}`), [
        level,
        store.groupBy,
        report
    ]);
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
        expandAll: store.expandAll && store.expandToLevel > level,
        tableStore: !level ? store.tableStore : null,
        columns: [
            {
                value: (row)=>{
                    return store.isRowSelected(row);
                },
                type: "boolean",
                width: 3,
                id: "checked",
                label: "",
                editable: (r)=>true,
                print: false,
                onChange: (r, stores)=>(v)=>{
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).isEmpty(r)) {
                            if (v) store.selectAllRows();
                            else store.deselectAllRows();
                            return;
                        } else if (v) store.selectRow(r);
                        else store.deselectRow(r);
                    }
            },
            {
                value: (row)=>row.label,
                ...report === null || report === void 0 ? void 0 : report.columnOptionsById[groupBy[level]],
                width: level < groupBy.length && !isPrinting ? 30 : 33,
                id: "label",
                label: "Label",
                style: ()=>({
                        textAlign: "left",
                        justifyContent: "flex-start",
                        paddingLeft: 1 + level * 1 + "rem",
                        fontWeight: 800 - level * 100
                    })
            },
            ...tableColumns
        ],
        rows: (parent === null || parent === void 0 ? void 0 : parent.children) || store.queryData || [],
        sortBy: !level ? [
            ...sortBy,
            [
                "date",
                "desc"
            ]
        ] : store.tableStore.sortBy,
        showTotals: !level,
        showHeader: !level,
        getChildComponent: level < store.groupBy.length ? getChildComponent : null,
        style: level ? {
            // borderBottom: 'none',
            boxShadow: "none",
            background: `linear-gradient(180deg, rgb(${bgShadow},${bgShadow},${bgShadow}) 1px, rgb(${bgColor},${bgColor},${bgColor}) 8px)`,
            fontSize: "1.2rem"
        } : null
    }, `${report.queryKey}-${level}-${parent === null || parent === void 0 ? void 0 : parent.key}`);
});

});


parcelRegister("iJYn9", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $da4b42abc2675b59$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");

var $6SaSn = parcelRequire("6SaSn");

var $kuPRw = parcelRequire("kuPRw");

var $4xjoq = parcelRequire("4xjoq");

var $47i9t = parcelRequire("47i9t");

var $4iw5i = parcelRequire("4iw5i");

var $5PXcS = parcelRequire("5PXcS");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $7qobO = parcelRequire("7qobO");

var $kqntg = parcelRequire("kqntg");

var $26sX2 = parcelRequire("26sX2");

var $3h7sC = parcelRequire("3h7sC");

var $gUgf9 = parcelRequire("gUgf9");

var $jbmdS = parcelRequire("jbmdS");

var $iKbxs = parcelRequire("iKbxs");

var $3H03w = parcelRequire("3H03w");
const $da4b42abc2675b59$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_private/billing")({
    beforeLoad: ({ params: params })=>{
        if (!(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "billing", params)) throw new Error("Permission Denied");
        (0, $26sX2.setLayoutDefaults)({
            pageTitle: "Billing"
        });
    },
    errorComponent: ({ error: error, reset: reset })=>{
        if (error.message === "Permission Denied") return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7qobO.default), {});
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    },
    loader: async ()=>$da4b42abc2675b59$var$loader(),
    pendingComponent: (0, $4iw5i.default),
    component: $da4b42abc2675b59$var$Wrapper
});
const $da4b42abc2675b59$var$loader = async ()=>{
    const billingData = await (0, $3h7sC.trpc).legacy.getBillingData.query();
    (0, $gUgf9.default).setBillingData(billingData);
    // Ensure SessionStore.subscription has the latest billing period from Stripe
    if (billingData.organisationSubscriptions && billingData.organisationSubscriptions.length > 0) {
        const updatedSubscription = billingData.organisationSubscriptions[0];
        if (updatedSubscription.subscriptionPeriod && (0, $1BTI2.default).subscription) {
            (0, $1BTI2.default).subscription.subscriptionPeriod = updatedSubscription.subscriptionPeriod;
            // Also update next payment date if available
            if (updatedSubscription.nextPaymentDate) (0, $1BTI2.default).subscription.nextPaymentDate = updatedSubscription.nextPaymentDate;
        }
    }
    const processedModels = (0, $47i9t.processTRPCData)(billingData);
    return processedModels;
};
function $da4b42abc2675b59$var$Wrapper() {
    // Handle checkout session completion when returning from Stripe
    (0, $jbmdS.useEffect)(()=>{
        const handleCheckoutReturn = async ()=>{
            const urlParams = new URLSearchParams(window.location.search);
            const sessionId = urlParams.get("session_id");
            const success = urlParams.get("success");
            const cancelled = urlParams.get("cancelled");
            const type = urlParams.get("type");
            if (sessionId && success === "true") try {
                var _SessionStore$organis;
                // Track checkout session success
                const sessionTypeForTracking = type === "subscription_update" ? "subscription_update" : type || "subscription";
                (0, $3H03w.default).capture("checkout_session_success", {
                    sessionId: sessionId,
                    type: sessionTypeForTracking,
                    organisationId: (_SessionStore$organis = (0, $1BTI2.default).organisation) === null || _SessionStore$organis === void 0 ? void 0 : _SessionStore$organis.id
                });
                // Call our completion handler
                const completionResult = await (0, $3h7sC.trpc).legacy.handleCheckoutCompletion.mutate({
                    sessionId: sessionId
                });
                // Clean up URL parameters
                const newUrl = new URL(window.location);
                newUrl.searchParams.delete("session_id");
                newUrl.searchParams.delete("success");
                newUrl.searchParams.delete("type");
                window.history.replaceState({}, "", newUrl.toString());
                // Reload the page to refresh data
                window.location.reload();
            } catch (error) {
                var _SessionStore$organis2, _SessionStore$organis3;
                console.error("Error completing checkout session:", error);
                // Enhanced error categorization for checkout completion failures
                const errorMessage = error.message || "Unknown error occurred during checkout completion";
                const isCouponError = errorMessage.toLowerCase().includes("coupon") || errorMessage.toLowerCase().includes("validation") || errorMessage.toLowerCase().includes("discount");
                const isValidationError = errorMessage.toLowerCase().includes("validation") || errorMessage.toLowerCase().includes("transaction validation");
                // Track checkout session completion failure with error categorization
                (0, $3H03w.default).capture("checkout_session_completion_failed", {
                    sessionId: sessionId,
                    error: errorMessage,
                    errorType: isCouponError ? "coupon_validation" : isValidationError ? "transaction_validation" : "general",
                    organisationId: (_SessionStore$organis2 = (0, $1BTI2.default).organisation) === null || _SessionStore$organis2 === void 0 ? void 0 : _SessionStore$organis2.id
                });
                // Enhanced error monitoring with context
                $iKbxs.captureException(error, {
                    tags: {
                        operation: "handleCheckoutSessionCompletion",
                        sessionId: sessionId,
                        errorType: isCouponError ? "coupon_validation" : isValidationError ? "transaction_validation" : "general"
                    },
                    extra: {
                        sessionType: type || "subscription",
                        organisationId: (_SessionStore$organis3 = (0, $1BTI2.default).organisation) === null || _SessionStore$organis3 === void 0 ? void 0 : _SessionStore$organis3.id
                    }
                });
                (0, $3H03w.default).captureException(error);
                // Provide specific error messaging based on error type
                let userMessage = "Checkout completed but there was an issue updating your subscription. Please contact support if this issue persists.";
                if (isCouponError) userMessage = "Checkout completed but there was an issue with discount validation. Your payment was processed - please contact support to resolve the discount application.";
                else if (isValidationError) userMessage = "Checkout completed but transaction validation failed. Your payment may have been processed - please contact support to verify your subscription status.";
                // Show enhanced user-friendly error message
                alert(userMessage);
            }
            else if (cancelled === "true") {
                var _SessionStore$organis4;
                // Track checkout session cancellation
                (0, $3H03w.default).capture("checkout_session_cancelled", {
                    organisationId: (_SessionStore$organis4 = (0, $1BTI2.default).organisation) === null || _SessionStore$organis4 === void 0 ? void 0 : _SessionStore$organis4.id
                });
                // Clean up URL parameters
                const newUrl = new URL(window.location);
                newUrl.searchParams.delete("cancelled");
                window.history.replaceState({}, "", newUrl.toString());
            }
        };
        handleCheckoutReturn();
    }, []);
    if ((0, $8kZ1o.migratedToV2)()) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqntg.CenterPadPageBody), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $4xjoq.default), {})
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6SaSn.default), {
                label: "Billing"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kuPRw.default), {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $4xjoq.default), {})
            })
        ]
    });
}

});
parcelRegister("6SaSn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $501038f796178072$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $36Jjh = parcelRequire("36Jjh");

var $gUgf9 = parcelRequire("gUgf9");

var $1BTI2 = parcelRequire("1BTI2");

var $12o9H = parcelRequire("12o9H");
parcelRequire("iOQGT");

var $fJ4T4 = parcelRequire("fJ4T4");

var $iKbxs = parcelRequire("iKbxs");

var $3H03w = parcelRequire("3H03w");

var $3h7sC = parcelRequire("3h7sC");
var $501038f796178072$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ label: label })=>{
    const subscription = (0, $1BTI2.default).subscription;
    const period = (0, $gUgf9.default).billingPeriod || subscription.subscriptionPeriod || "yearly";
    const [isCreatingCheckoutSession, setIsCreatingCheckoutSession] = (0, $jbmdS.useState)(false);
    if (!subscription) return null;
    const handlePeriodChange = (newPeriod)=>{
        (0, $gUgf9.default).setBillingPeriod(newPeriod);
        // Trigger preview calculation when period changes
        (0, $gUgf9.default).calculatePreview();
    };
    const handleSubscribeClick = async ()=>{
        try {
            var _SessionStore$organis;
            setIsCreatingCheckoutSession(true);
            (0, $gUgf9.default).setIsSubscribing(true);
            // Track checkout session creation attempt
            (0, $3H03w.default).capture("checkout_session_creation_started", {
                period: period,
                organisationId: (_SessionStore$organis = (0, $1BTI2.default).organisation) === null || _SessionStore$organis === void 0 ? void 0 : _SessionStore$organis.id
            });
            // Create checkout session using tRPC
            const result = await (0, $3h7sC.trpc).legacy.createCheckoutSession.mutate({
                period: period
            });
            if (result.success && result.sessionUrl) {
                var _SessionStore$organis2;
                // Track successful session creation
                (0, $3H03w.default).capture("checkout_session_created", {
                    sessionId: result.sessionId,
                    period: period,
                    organisationId: (_SessionStore$organis2 = (0, $1BTI2.default).organisation) === null || _SessionStore$organis2 === void 0 ? void 0 : _SessionStore$organis2.id
                });
                // Redirect to Stripe Checkout
                window.location.href = result.sessionUrl;
            } else throw new Error("Failed to create checkout session");
        } catch (error) {
            var _SessionStore$organis3;
            // Track checkout session creation failure
            (0, $3H03w.default).capture("checkout_session_creation_failed", {
                error: error.message,
                period: period,
                organisationId: (_SessionStore$organis3 = (0, $1BTI2.default).organisation) === null || _SessionStore$organis3 === void 0 ? void 0 : _SessionStore$organis3.id
            });
            $iKbxs.captureException(error);
            (0, $3H03w.default).captureException(error);
            // Show user-friendly error message
            alert("Failed to create checkout session. Please try again.");
            setIsCreatingCheckoutSession(false);
            (0, $gUgf9.default).setIsSubscribing(false);
        }
    };
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $36Jjh.default), {
        heading: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: label
            })
        }),
        leftButtons: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                style: {
                    marginRight: "1em"
                },
                className: "btn btn-default edit-controls__delete-button bg-white/90 m-[0.5em] ml-0 text-[#444] py-2 px-4 text-sm rounded-[6px] border [&:not(:disabled):border-white cursor-pointer[&:not(:disabled):hover]:bg-white/70 disabled:opacity-50 disabled:cursor-not-allowed",
                disabled: period === "yearly" || (0, $gUgf9.default).isUpdatingSubscription || (0, $gUgf9.default).isFetchingPreview || isCreatingCheckoutSession,
                onClick: ()=>handlePeriodChange("yearly"),
                children: "Yearly (15% discount)"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                style: {
                    marginRight: "1em"
                },
                className: "btn btn-default edit-controls__delete-button bg-white/90 m-[0.5em] ml-0 text-[#444] py-2 px-4 text-sm rounded-[6px] border [&:not(:disabled):border-white cursor-pointer[&:not(:disabled):hover]:bg-white/70 disabled:opacity-50 disabled:cursor-not-allowed",
                disabled: period === "monthly" || (0, $gUgf9.default).isUpdatingSubscription || (0, $gUgf9.default).isFetchingPreview || isCreatingCheckoutSession,
                onClick: ()=>handlePeriodChange("monthly"),
                children: "Monthly"
            }),
            !subscription.hasSubscription ? /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                className: "btn btn-primary edit-controls__delete-button",
                disabled: isCreatingCheckoutSession || (0, $gUgf9.default).isSubscribing,
                onClick: handleSubscribeClick,
                children: isCreatingCheckoutSession || (0, $gUgf9.default).isSubscribing ? "Creating checkout..." : "Subscribe!"
            }) : null
        ],
        extraContent: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            style: {
                marginTop: "1em",
                fontSize: "1.5em",
                fontWeight: "300"
            },
            children: [
                `Next Payment: ${(0, $12o9H.FormatCurrency)((0, $gUgf9.default).grandTotal, {
                    decimals: 2
                })}`,
                (0, $1BTI2.default).subscription.nextPaymentDate ? ` - ${(0, $fJ4T4.FormatDate)((0, $1BTI2.default).subscription.nextPaymentDate)}` : ""
            ]
        })
    });
});

});
parcelRegister("gUgf9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4ee79e7effa8c33$export$2e2bcd8739ae039; });

var $1BTI2 = parcelRequire("1BTI2");

var $htkeB = parcelRequire("htkeB");

var $4JcCM = parcelRequire("4JcCM");

var $k3urn = parcelRequire("k3urn");
var $c4ee79e7effa8c33$var$_dec, $c4ee79e7effa8c33$var$_dec2, $c4ee79e7effa8c33$var$_dec3, $c4ee79e7effa8c33$var$_dec4, $c4ee79e7effa8c33$var$_dec5, $c4ee79e7effa8c33$var$_dec6, $c4ee79e7effa8c33$var$_dec7, $c4ee79e7effa8c33$var$_dec8, $c4ee79e7effa8c33$var$_dec9, $c4ee79e7effa8c33$var$_dec10, $c4ee79e7effa8c33$var$_dec11, $c4ee79e7effa8c33$var$_dec12, $c4ee79e7effa8c33$var$_dec13, $c4ee79e7effa8c33$var$_dec14, $c4ee79e7effa8c33$var$_dec15, $c4ee79e7effa8c33$var$_dec16, $c4ee79e7effa8c33$var$_dec17, $c4ee79e7effa8c33$var$_dec18, $c4ee79e7effa8c33$var$_dec19, $c4ee79e7effa8c33$var$_dec20, $c4ee79e7effa8c33$var$_dec21, $c4ee79e7effa8c33$var$_dec22, $c4ee79e7effa8c33$var$_dec23, $c4ee79e7effa8c33$var$_dec24, $c4ee79e7effa8c33$var$_dec25, $c4ee79e7effa8c33$var$_class, $c4ee79e7effa8c33$var$_descriptor, $c4ee79e7effa8c33$var$_descriptor2, $c4ee79e7effa8c33$var$_descriptor3, $c4ee79e7effa8c33$var$_descriptor4, $c4ee79e7effa8c33$var$_descriptor5, $c4ee79e7effa8c33$var$_descriptor6, $c4ee79e7effa8c33$var$_descriptor7, $c4ee79e7effa8c33$var$_descriptor8, $c4ee79e7effa8c33$var$_descriptor9, $c4ee79e7effa8c33$var$_descriptor10, $c4ee79e7effa8c33$var$_descriptor11, $c4ee79e7effa8c33$var$_descriptor12, $c4ee79e7effa8c33$var$_descriptor13, $c4ee79e7effa8c33$var$_descriptor14, $c4ee79e7effa8c33$var$_descriptor15, $c4ee79e7effa8c33$var$_descriptor16, $c4ee79e7effa8c33$var$_descriptor17, $c4ee79e7effa8c33$var$_descriptor18, $c4ee79e7effa8c33$var$_descriptor19, $c4ee79e7effa8c33$var$_descriptor20, $c4ee79e7effa8c33$var$_descriptor21, $c4ee79e7effa8c33$var$_descriptor22, $c4ee79e7effa8c33$var$_descriptor23, $c4ee79e7effa8c33$var$_descriptor24, $c4ee79e7effa8c33$var$_descriptor25, $c4ee79e7effa8c33$var$_descriptor26, $c4ee79e7effa8c33$var$_descriptor27, $c4ee79e7effa8c33$var$_descriptor28, $c4ee79e7effa8c33$var$_descriptor29;
function $c4ee79e7effa8c33$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $c4ee79e7effa8c33$var$_defineProperty(e, r, t) {
    return (r = $c4ee79e7effa8c33$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $c4ee79e7effa8c33$var$_toPropertyKey(t) {
    var i = $c4ee79e7effa8c33$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $c4ee79e7effa8c33$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $c4ee79e7effa8c33$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $c4ee79e7effa8c33$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}




let $c4ee79e7effa8c33$var$BillingPageStore = ($c4ee79e7effa8c33$var$_dec = (0, $4JcCM.action).bound, $c4ee79e7effa8c33$var$_dec2 = (0, $4JcCM.action).bound, $c4ee79e7effa8c33$var$_dec3 = (0, $4JcCM.action).bound, $c4ee79e7effa8c33$var$_dec4 = (0, $4JcCM.action).bound, $c4ee79e7effa8c33$var$_dec5 = (0, $4JcCM.action).bound, $c4ee79e7effa8c33$var$_dec6 = (0, $4JcCM.action).bound, $c4ee79e7effa8c33$var$_dec7 = (0, $4JcCM.action).bound, $c4ee79e7effa8c33$var$_dec8 = (0, $4JcCM.action).bound, $c4ee79e7effa8c33$var$_dec9 = (0, $4JcCM.action).bound, $c4ee79e7effa8c33$var$_dec10 = (0, $4JcCM.action).bound, $c4ee79e7effa8c33$var$_dec11 = (0, $4JcCM.action).bound, $c4ee79e7effa8c33$var$_dec12 = (0, $4JcCM.action).bound, $c4ee79e7effa8c33$var$_dec13 = (0, $4JcCM.action).bound, $c4ee79e7effa8c33$var$_dec14 = (0, $4JcCM.action).bound, $c4ee79e7effa8c33$var$_dec15 = (0, $4JcCM.action).bound, $c4ee79e7effa8c33$var$_dec16 = (0, $4JcCM.action).bound, $c4ee79e7effa8c33$var$_dec17 = (0, $4JcCM.action).bound, $c4ee79e7effa8c33$var$_dec18 = (0, $4JcCM.action).bound, $c4ee79e7effa8c33$var$_dec19 = (0, $4JcCM.action).bound, $c4ee79e7effa8c33$var$_dec20 = (0, $4JcCM.action).bound, $c4ee79e7effa8c33$var$_dec21 = (0, $4JcCM.action).bound, $c4ee79e7effa8c33$var$_dec22 = (0, $4JcCM.action).bound, $c4ee79e7effa8c33$var$_dec23 = (0, $4JcCM.action).bound, $c4ee79e7effa8c33$var$_dec24 = (0, $4JcCM.action).bound, $c4ee79e7effa8c33$var$_dec25 = (0, $4JcCM.action).bound, $c4ee79e7effa8c33$var$_class = class BillingPageStore {
    constructor(){
        $c4ee79e7effa8c33$var$_initializerDefineProperty(this, "isSubscribing", $c4ee79e7effa8c33$var$_descriptor, this);
        $c4ee79e7effa8c33$var$_initializerDefineProperty(this, "isUpdatingSubscription", $c4ee79e7effa8c33$var$_descriptor2, this);
        $c4ee79e7effa8c33$var$_initializerDefineProperty(this, "billingPeriod", $c4ee79e7effa8c33$var$_descriptor3, this);
        $c4ee79e7effa8c33$var$_initializerDefineProperty(this, "isFetchingPreview", $c4ee79e7effa8c33$var$_descriptor4, this);
        $c4ee79e7effa8c33$var$_initializerDefineProperty(this, "subscriptionPreview", $c4ee79e7effa8c33$var$_descriptor5, this);
        // Enhanced preview state management
        $c4ee79e7effa8c33$var$_initializerDefineProperty(this, "previewError", $c4ee79e7effa8c33$var$_descriptor6, this);
        $c4ee79e7effa8c33$var$_initializerDefineProperty(this, "isCalculatingPreview", $c4ee79e7effa8c33$var$_descriptor7, this);
        $c4ee79e7effa8c33$var$_initializerDefineProperty(this, "showPreview", $c4ee79e7effa8c33$var$_descriptor8, this);
        $c4ee79e7effa8c33$var$_initializerDefineProperty(this, "previewType", $c4ee79e7effa8c33$var$_descriptor9, this);
        // 'new-subscription', 'period-change', or null
        // Plan lookup data for client-side calculations
        $c4ee79e7effa8c33$var$_initializerDefineProperty(this, "planLookup", $c4ee79e7effa8c33$var$_descriptor10, this);
        $c4ee79e7effa8c33$var$_initializerDefineProperty(this, "couponLookup", $c4ee79e7effa8c33$var$_descriptor11, this);
        $c4ee79e7effa8c33$var$_initializerDefineProperty(this, "taxLookup", $c4ee79e7effa8c33$var$_descriptor12, this);
        // Enhanced lookup key resolution data from backend
        $c4ee79e7effa8c33$var$_initializerDefineProperty(this, "resolvedPrices", $c4ee79e7effa8c33$var$_descriptor13, this);
        // Lookup key -> Stripe price ID mapping
        $c4ee79e7effa8c33$var$_initializerDefineProperty(this, "priceResolutionStatus", $c4ee79e7effa8c33$var$_descriptor14, this);
        // 'idle', 'resolving', 'resolved', 'failed'
        $c4ee79e7effa8c33$var$_initializerDefineProperty(this, "priceResolutionError", $c4ee79e7effa8c33$var$_descriptor15, this);
        // Observables for upcoming invoice data (current subscription)
        $c4ee79e7effa8c33$var$_initializerDefineProperty(this, "nextPaymentDate", $c4ee79e7effa8c33$var$_descriptor16, this);
        $c4ee79e7effa8c33$var$_initializerDefineProperty(this, "amountDue", $c4ee79e7effa8c33$var$_descriptor17, this);
        $c4ee79e7effa8c33$var$_initializerDefineProperty(this, "discount", $c4ee79e7effa8c33$var$_descriptor18, this);
        $c4ee79e7effa8c33$var$_initializerDefineProperty(this, "tax", $c4ee79e7effa8c33$var$_descriptor19, this);
        $c4ee79e7effa8c33$var$_initializerDefineProperty(this, "credit", $c4ee79e7effa8c33$var$_descriptor20, this);
        $c4ee79e7effa8c33$var$_initializerDefineProperty(this, "adjustments", $c4ee79e7effa8c33$var$_descriptor21, this);
        $c4ee79e7effa8c33$var$_initializerDefineProperty(this, "grandTotal", $c4ee79e7effa8c33$var$_descriptor22, this);
        $c4ee79e7effa8c33$var$_initializerDefineProperty(this, "remainingCredit", $c4ee79e7effa8c33$var$_descriptor23, this);
        /** @type {any[]} */ $c4ee79e7effa8c33$var$_initializerDefineProperty(this, "staffBreakdown", $c4ee79e7effa8c33$var$_descriptor24, this);
        // Payment details from Stripe (merged from getFreshPaymentDetails)
        $c4ee79e7effa8c33$var$_initializerDefineProperty(this, "paymentMethods", $c4ee79e7effa8c33$var$_descriptor25, this);
        $c4ee79e7effa8c33$var$_initializerDefineProperty(this, "receiptEmail", $c4ee79e7effa8c33$var$_descriptor26, this);
        $c4ee79e7effa8c33$var$_initializerDefineProperty(this, "creditBalance", $c4ee79e7effa8c33$var$_descriptor27, this);
        $c4ee79e7effa8c33$var$_initializerDefineProperty(this, "currency", $c4ee79e7effa8c33$var$_descriptor28, this);
        $c4ee79e7effa8c33$var$_initializerDefineProperty(this, "stripeCustomerId", $c4ee79e7effa8c33$var$_descriptor29, this);
        (0, $4JcCM.makeObservable)(this);
    }
    /**
   * @param {any} data
   */ setBillingData(data) {
        if (!data) return;
        // Handle new nested data structure from getBillingData endpoint
        const paymentData = data.currentPayment || data; // Support both old and new formats
        // Extract payment data from nested structure or fallback to root level
        this.nextPaymentDate = paymentData.nextPaymentDate ? new Date(paymentData.nextPaymentDate) : null;
        this.amountDue = paymentData.amountDue || 0;
        this.discount = paymentData.discount || 0;
        this.tax = paymentData.tax || 0;
        this.credit = paymentData.credit || 0;
        this.adjustments = paymentData.adjustments || 0;
        this.grandTotal = paymentData.grandTotal || 0;
        this.remainingCredit = data.remainingCredit || paymentData.remainingCredit || 0;
        this.staffBreakdown = paymentData.staffBreakdown || [];
        // Clear any preview state to show current subscription data
        this.clearPreview();
        // Update SessionStore subscription data if provided
        if (data.subscription && (0, $1BTI2.default).subscription) {
            // Update the subscription period in SessionStore to match server data
            // Use currentPeriod from server response, fallback to subscription.subscriptionPeriod
            const correctPeriod = data.currentPeriod || data.subscription.subscriptionPeriod;
            if (correctPeriod && correctPeriod !== (0, $1BTI2.default).subscription.subscriptionPeriod) (0, $1BTI2.default).subscription.subscriptionPeriod = correctPeriod;
        }
        // Set lookup data for client-side calculations if available
        if (data.planLookup) {
            this.planLookup = data.planLookup;
            // Check if we should show initial preview for new users
            this.checkInitialPreviewDisplay();
        }
        if (data.couponLookup) this.couponLookup = data.couponLookup;
        if (data.taxLookup) this.taxLookup = data.taxLookup;
        // Handle new lookup key-resolved pricing data from backend
        if (data.resolvedPrices) {
            this.resolvedPrices = data.resolvedPrices;
            this.priceResolutionStatus = "resolved";
            this.priceResolutionError = null;
        }
        // Handle price resolution status from backend
        if (data.priceResolutionStatus) this.priceResolutionStatus = data.priceResolutionStatus;
        if (data.priceResolutionError) this.priceResolutionError = data.priceResolutionError;
        // Set payment details (merged from getFreshPaymentDetails)
        if (data.paymentMethods) this.paymentMethods = data.paymentMethods;
        if (data.contactEmail !== undefined) this.receiptEmail = data.contactEmail;
        else if (data.receiptEmail !== undefined) this.receiptEmail = data.receiptEmail;
        if (data.creditBalance !== undefined) this.creditBalance = data.creditBalance;
        if (data.currency) this.currency = data.currency;
        if (data.stripeCustomerId !== undefined) this.stripeCustomerId = data.stripeCustomerId;
    }
    // Computed Properties (Task 5.4, 5.5, 5.6)
    /**
   * Available billing periods based on current subscription
   */ get availableBillingPeriods() {
        const subscription = (0, $1BTI2.default).subscription;
        if (!subscription) return [
            "monthly",
            "yearly"
        ];
        const hasYearlyPlans = subscription.yearlyAdminPlanId || subscription.yearlyStandardPlanId;
        const hasMonthlyPlans = subscription.monthlyAdminPlanId || subscription.monthlyStandardPlanId;
        if (hasYearlyPlans && hasMonthlyPlans) return [
            "monthly",
            "yearly"
        ];
        else if (hasYearlyPlans) return [
            "yearly"
        ];
        else if (hasMonthlyPlans) return [
            "monthly"
        ];
        return [
            "monthly",
            "yearly"
        ]; // Default fallback
    }
    /**
   * Current subscription period from session
   */ get currentSubscriptionPeriod() {
        var _SessionStore$subscri;
        return ((_SessionStore$subscri = (0, $1BTI2.default).subscription) === null || _SessionStore$subscri === void 0 ? void 0 : _SessionStore$subscri.subscriptionPeriod) || "monthly";
    }
    /**
   * Whether the user has an active subscription
   */ get hasActiveSubscription() {
        var _SessionStore$subscri2;
        return ((_SessionStore$subscri2 = (0, $1BTI2.default).subscription) === null || _SessionStore$subscri2 === void 0 ? void 0 : _SessionStore$subscri2.hasSubscription) || false;
    }
    /**
   * Whether preview should be shown
   */ get shouldShowPreview() {
        return this.showPreview && (this.subscriptionPreview || this.isCalculatingPreview);
    }
    /**
   * Whether billing period has changed from current subscription
   */ get hasBillingPeriodChanged() {
        if (!this.billingPeriod || !this.hasActiveSubscription) return false;
        return this.billingPeriod !== this.currentSubscriptionPeriod;
    }
    /**
   * Preview type based on current state
   */ get currentPreviewType() {
        if (!this.billingPeriod) return null;
        if (!this.hasActiveSubscription) return "new-subscription";
        else if (this.hasBillingPeriodChanged) return "period-change";
        return null;
    }
    /**
   * Whether we have pricing data available (either legacy planLookup or new resolvedPrices)
   */ get hasPricingData() {
        const hasLegacyPricing = this.planLookup && Object.keys(this.planLookup).length > 0;
        const hasResolvedPricing = this.resolvedPrices && Object.keys(this.resolvedPrices).length > 0;
        return hasLegacyPricing || hasResolvedPricing;
    }
    /**
   * Whether price resolution is in progress or failed
   */ get isPriceResolutionPending() {
        return this.priceResolutionStatus === "resolving" || this.priceResolutionStatus === "idle";
    }
    /**
   * Whether price resolution has failed
   */ get hasPriceResolutionFailed() {
        return this.priceResolutionStatus === "failed";
    }
    /**
   * Staff breakdown with calculated fees - prefers server data when available
   */ get computedStaffBreakdown() {
        // Always prefer server data when available and current billing period matches subscription period
        // Server data comes from getBillingData and uses proper plan pricing
        const hasServerData = this.staffBreakdown && this.staffBreakdown.length > 0;
        const isCurrentPeriod = !this.billingPeriod || this.billingPeriod === this.currentSubscriptionPeriod;
        if (hasServerData && isCurrentPeriod) return this.staffBreakdown;
        // For preview scenarios (different billing period), use client-side calculation
        if (!(0, $htkeB.default).staff || !this.planLookup || Object.keys(this.planLookup).length === 0) return this.staffBreakdown || [];
        // Use client-side calculation for preview scenarios only
        try {
            const previewData = (0, $k3urn.calculateBillingPreview)((0, $htkeB.default).staff, this.billingPeriod || this.currentSubscriptionPeriod, (0, $1BTI2.default).subscription, this.planLookup, this.couponLookup, this.taxLookup);
            return previewData.staffBreakdown;
        } catch (error) {
            return this.staffBreakdown || [];
        }
    }
    /**
   * Savings amount when switching to yearly
   */ get yearlySavings() {
        if (!this.subscriptionPreview || this.billingPeriod !== "yearly") return 0;
        try {
            // Calculate monthly equivalent
            const monthlyData = (0, $k3urn.calculateBillingPreview)((0, $htkeB.default).staff || [], "monthly", (0, $1BTI2.default).subscription, this.planLookup, this.couponLookup, this.taxLookup);
            const yearlyTotal = this.subscriptionPreview.grandTotal;
            const monthlyEquivalent = monthlyData.grandTotal * 12;
            return Math.max(0, monthlyEquivalent - yearlyTotal);
        } catch (error) {
            console.warn("Failed to calculate yearly savings:", error);
            return 0;
        }
    }
    /**
   * Computed grand total that follows standardized Total vs Credit Applied rules
   * Matches the PRD format: Date → Amount Due → Discounts → Adjustments → Tax → Credit → Total/Credit Applied
   */ get computedGrandTotal() {
        // Follow standardized calculation order from PRD
        const amountDue = this.amountDue || 0;
        const discount = this.discount || 0;
        const adjustments = this.adjustments || 0;
        const tax = this.tax || 0;
        const credit = Math.abs(this.credit || 0); // Credit should be positive for calculation
        // Calculate subtotal before credit application
        const subtotal = amountDue - discount + adjustments + tax;
        // Apply PRD credit rules: if credit covers entire amount, return 0 (shows "Credit Applied")
        const result = subtotal - credit;
        return result;
    }
    /**
   * Computed credit that shows remaining credit after applying to current bill
   */ get computedRemainingCredit() {
        const subtotal = this.amountDue + this.tax + (this.adjustments || 0) - (this.discount || 0);
        const availableCredit = Math.abs(this.credit || 0); // Credit is usually negative
        if (availableCredit >= subtotal && subtotal > 0) // Credit covers the entire amount, return remaining credit
        return -(availableCredit - subtotal); // Keep as negative to match expected format
        else // Credit partially applied or no credit remaining
        return this.credit;
    }
    /**
   * Computed grand total for preview that follows standardized Total vs Credit Applied rules
   * This matches the backend generateStandardizedBillingPreview() implementation
   */ get previewComputedGrandTotal() {
        if (!this.subscriptionPreview) return 0;
        const preview = this.subscriptionPreview;
        // Use the standardized grandTotal calculation from the preview
        // This already follows the PRD rules: when credit covers entire amount, grandTotal = 0
        if (preview.grandTotal !== undefined) return preview.grandTotal;
        // Fallback calculation following standardized format:
        // Date → Amount Due → Discounts → Adjustments → Tax → Credit → Total/Credit Applied
        const amountDue = preview.amountDue || 0;
        const discount = preview.discount || 0;
        const adjustments = preview.adjustments || 0;
        const tax = preview.tax || 0;
        const credit = Math.abs(preview.credit || 0); // Credit should be positive for calculation
        // Calculate subtotal before credit application
        const subtotal = amountDue - discount + adjustments + tax;
        // Apply PRD credit rules: if credit covers entire amount, return 0 (shows "Credit Applied")
        const result = subtotal <= credit && subtotal > 0 ? 0 : Math.max(0, subtotal - credit);
        return result;
    }
    /**
   * @param {boolean} isSubscribing
   */ setIsSubscribing(isSubscribing) {
        this.isSubscribing = isSubscribing;
    }
    setIsUpdatingSubscription(isUpdatingSubscription) {
        this.isUpdatingSubscription = isUpdatingSubscription;
    }
    setIsFetchingPreview(isFetchingPreview) {
        this.isFetchingPreview = isFetchingPreview;
    }
    setSubscriptionPreview(subscriptionPreview) {
        this.subscriptionPreview = subscriptionPreview;
    }
    /**
   * @param {'monthly' | 'yearly'} billingPeriod
   */ setBillingPeriod(billingPeriod) {
        // If the billing period matches current subscription, clear preview to show default view
        if (this.hasActiveSubscription && billingPeriod === this.currentSubscriptionPeriod) {
            this.clearPreview();
            return;
        }
        this.billingPeriod = billingPeriod;
        // Update preview type and trigger calculation if needed
        this.previewType = this.currentPreviewType;
        if (billingPeriod && this.planLookup && Object.keys(this.planLookup).length > 0) this.calculatePreview();
    }
    // Enhanced Actions (Task 5.7)
    setPreviewError(error) {
        this.previewError = error;
    }
    setIsCalculatingPreview(isCalculating) {
        this.isCalculatingPreview = isCalculating;
    }
    setShowPreview(show) {
        this.showPreview = show;
    }
    setPreviewType(type) {
        this.previewType = type;
    }
    setPlanLookup(planLookup) {
        this.planLookup = planLookup;
    }
    setCouponLookup(couponLookup) {
        this.couponLookup = couponLookup;
    }
    setTaxLookup(taxLookup) {
        this.taxLookup = taxLookup;
    }
    setResolvedPrices(resolvedPrices) {
        this.resolvedPrices = resolvedPrices;
        this.priceResolutionStatus = "resolved";
        this.priceResolutionError = null;
    }
    setPriceResolutionStatus(status) {
        this.priceResolutionStatus = status;
    }
    setPriceResolutionError(error) {
        this.priceResolutionError = error;
        this.priceResolutionStatus = "failed";
    }
    /**
   * Calculate billing preview using client-side calculator
   */ async calculatePreview() {
        if (!this.billingPeriod || !(0, $htkeB.default).staff) return;
        // Set calculating state
        (0, $4JcCM.runInAction)(()=>{
            this.isCalculatingPreview = true;
            this.isFetchingPreview = true;
            this.previewError = null;
            this.showPreview = true;
        });
        try {
            // Check for price resolution issues first
            if (this.hasPriceResolutionFailed) throw new Error(this.priceResolutionError || "Price resolution failed. Please try refreshing the page.");
            // Always prioritize server preview for accurate data (includes stored plan preferences and prorations)
            if (this.hasActiveSubscription && this.hasBillingPeriodChanged) await this.fetchServerPreview();
            else if (!this.hasActiveSubscription) await this.fetchNewSubscriptionPreview();
            else if (this.hasPricingData) {
                // Use standardized client-side calculation only for current period view
                const previewData = (0, $k3urn.calculateBillingPreview)((0, $htkeB.default).staff, this.billingPeriod, (0, $1BTI2.default).subscription, this.planLookup, this.couponLookup, this.taxLookup);
                (0, $4JcCM.runInAction)(()=>{
                    this.subscriptionPreview = previewData;
                    this.previewType = this.currentPreviewType;
                });
            } else if (this.isPriceResolutionPending) // Still waiting for price resolution
            throw new Error("Loading pricing data... Please wait.");
            else throw new Error("No pricing data available. Please contact support.");
        } catch (error) {
            // Enhanced error categorization for billing preview failures
            const errorMessage = error.message || "Failed to calculate preview";
            const isCouponError = errorMessage.toLowerCase().includes("coupon") || errorMessage.toLowerCase().includes("validation") || errorMessage.toLowerCase().includes("discount");
            const isCalculationError = errorMessage.toLowerCase().includes("calculation") || errorMessage.toLowerCase().includes("standardized");
            // Enhanced error logging for monitoring
            if (window.Sentry) window.Sentry.captureException(error, {
                tags: {
                    operation: "calculatePreview",
                    errorType: isCouponError ? "coupon_validation" : isCalculationError ? "calculation_error" : "general",
                    billingPeriod: this.billingPeriod,
                    previewType: this.previewType,
                    hasPricingData: this.hasPricingData
                }
            });
            if (window.posthog) {
                var _SessionStore$organis;
                window.posthog.captureException(error);
                window.posthog.capture("billing_preview_calculation_failed", {
                    error: errorMessage,
                    errorType: isCouponError ? "coupon_validation" : isCalculationError ? "calculation_error" : "general",
                    billingPeriod: this.billingPeriod,
                    organisationId: (_SessionStore$organis = (0, $1BTI2.default).organisation) === null || _SessionStore$organis === void 0 ? void 0 : _SessionStore$organis.id
                });
            }
            (0, $4JcCM.runInAction)(()=>{
                // Provide specific error messaging based on error type
                if (isCouponError) this.previewError = `Preview unavailable: ${errorMessage}. Please contact support for assistance.`;
                else if (isCalculationError) this.previewError = `Unable to calculate billing preview. Please try again or contact support.`;
                else this.previewError = errorMessage;
                this.subscriptionPreview = null;
            });
        } finally{
            (0, $4JcCM.runInAction)(()=>{
                this.isCalculatingPreview = false;
                this.isFetchingPreview = false;
            });
        }
    }
    /**
   * Check if we should display initial preview for new users
   */ checkInitialPreviewDisplay() {
        var _StaffCollection$staf;
        // For new users (no active subscription), show monthly preview by default
        if (!this.hasActiveSubscription && !this.billingPeriod) this.billingPeriod = "monthly";
        // Trigger preview calculation if we have all required data
        if (this.billingPeriod && ((_StaffCollection$staf = (0, $htkeB.default).staff) === null || _StaffCollection$staf === void 0 ? void 0 : _StaffCollection$staf.length) > 0 && this.hasPricingData) // Use setTimeout to ensure MobX observable updates are processed
        setTimeout(()=>{
            this.calculatePreview();
        }, 0);
    }
    /**
   * Call this when staff data becomes available to check for initial preview
   */ onStaffDataAvailable() {
        // Check if we should show initial preview now that staff data is available
        this.checkInitialPreviewDisplay();
    }
    /**
   * Fetch preview from server for new subscriptions (uses stored plan preferences)
   */ async fetchNewSubscriptionPreview() {
        try {
            const { trpc: trpc } = await Promise.resolve((parcelRequire("3h7sC")));
            // Call tRPC endpoint for server-side preview calculation with stored plan preferences
            const serverPreview = await trpc.legacy.previewBillingChange.query({
                targetPeriod: this.billingPeriod
            });
            // Extract the preview data from the nested response structure
            const previewData = {
                ...serverPreview.preview,
                // Add additional properties from the response
                currentPeriod: serverPreview.currentPeriod,
                targetPeriod: serverPreview.targetPeriod,
                warnings: serverPreview.warnings,
                breakdown: serverPreview.breakdown
            };
            // Update preview with server calculation (includes stored plan preferences)
            (0, $4JcCM.runInAction)(()=>{
                this.subscriptionPreview = previewData;
                this.previewType = this.currentPreviewType;
            });
        } catch (error) {
            // For new subscriptions, server preview is important for stored plan preferences
            // Fallback to client calculation as a last resort
            if (this.hasPricingData) {
                const previewData = (0, $k3urn.calculateBillingPreview)((0, $htkeB.default).staff, this.billingPeriod, (0, $1BTI2.default).subscription, this.planLookup, this.couponLookup, this.taxLookup);
                (0, $4JcCM.runInAction)(()=>{
                    this.subscriptionPreview = previewData;
                    this.previewType = this.currentPreviewType;
                });
            } else throw error;
        }
    }
    /**
   * Fetch preview from server for billing period changes
   */ async fetchServerPreview() {
        if (!this.hasBillingPeriodChanged) return;
        try {
            const { trpc: trpc } = await Promise.resolve((parcelRequire("3h7sC")));
            // Call tRPC endpoint for server-side preview calculation with prorations
            const serverPreview = await trpc.legacy.previewBillingChange.query({
                targetPeriod: this.billingPeriod
            });
            // Extract the preview data from the nested response structure
            const previewData = {
                ...serverPreview.preview,
                // Add additional properties from the response
                currentPeriod: serverPreview.currentPeriod,
                targetPeriod: serverPreview.targetPeriod,
                warnings: serverPreview.warnings,
                breakdown: serverPreview.breakdown
            };
            // Update preview with server calculation (includes accurate prorations)
            (0, $4JcCM.runInAction)(()=>{
                this.subscriptionPreview = previewData;
                this.previewType = this.currentPreviewType;
            });
        } catch (error) {
            // For billing period changes, server preview is critical (contains prorations)
            // Don't fallback to client calculation as it lacks proration data
            throw new Error(`Unable to calculate billing period change preview: ${error.message || "Server error"}. Prorations and adjustments require server calculation.`);
        }
    }
    /**
   * Clear preview state
   */ clearPreview() {
        this.subscriptionPreview = null;
        this.showPreview = false;
        this.previewError = null;
        this.isCalculatingPreview = false;
        this.isFetchingPreview = false;
        this.previewType = null;
        // Reset billing period to undefined to return to default state
        this.billingPeriod = undefined;
    }
    /**
   * Reset billing period to current subscription period
   */ resetBillingPeriod() {
        this.billingPeriod = this.currentSubscriptionPeriod;
        this.clearPreview();
    }
    /**
   * Start new subscription process using checkout sessions
   */ async startNewSubscription() {
        if (!this.billingPeriod || !this.subscriptionPreview) throw new Error("No billing period or preview data available");
        try {
            (0, $4JcCM.runInAction)(()=>{
                this.isSubscribing = true;
                this.previewError = null;
            });
            // Track checkout session creation attempt
            if (window.posthog) {
                var _SessionStore$organis2;
                window.posthog.capture("checkout_session_creation_started", {
                    period: this.billingPeriod,
                    organisationId: (_SessionStore$organis2 = (0, $1BTI2.default).organisation) === null || _SessionStore$organis2 === void 0 ? void 0 : _SessionStore$organis2.id,
                    source: "billing_page_toggle"
                });
            }
            // Import trpc dynamically
            const { trpc: trpc } = await Promise.resolve((parcelRequire("3h7sC")));
            // Create checkout session using tRPC
            const result = await trpc.legacy.createCheckoutSession.mutate({
                period: this.billingPeriod
            });
            if (result.success && result.sessionUrl) {
                // Track successful session creation
                if (window.posthog) {
                    var _SessionStore$organis3;
                    window.posthog.capture("checkout_session_created", {
                        sessionId: result.sessionId,
                        period: this.billingPeriod,
                        organisationId: (_SessionStore$organis3 = (0, $1BTI2.default).organisation) === null || _SessionStore$organis3 === void 0 ? void 0 : _SessionStore$organis3.id,
                        source: "billing_page_toggle"
                    });
                }
                // Clear preview state before redirecting
                this.clearPreview();
                // Redirect to Stripe Checkout
                window.location.href = result.sessionUrl;
            } else throw new Error(result.message || "Failed to create checkout session");
        } catch (error) {
            // Enhanced error categorization for better user feedback
            const errorMessage = error.message || "Failed to start subscription process";
            const isCouponError = errorMessage.toLowerCase().includes("coupon") || errorMessage.toLowerCase().includes("validation") || errorMessage.toLowerCase().includes("discount");
            // Track checkout session creation failure with error categorization
            if (window.posthog) {
                var _SessionStore$organis4;
                window.posthog.capture("checkout_session_creation_failed", {
                    error: errorMessage,
                    errorType: isCouponError ? "coupon_validation" : "general",
                    period: this.billingPeriod,
                    organisationId: (_SessionStore$organis4 = (0, $1BTI2.default).organisation) === null || _SessionStore$organis4 === void 0 ? void 0 : _SessionStore$organis4.id,
                    source: "billing_page_toggle"
                });
            }
            // Capture error for monitoring with additional context
            if (window.Sentry) window.Sentry.captureException(error, {
                tags: {
                    operation: "startNewSubscription",
                    errorType: isCouponError ? "coupon_validation" : "general",
                    billingPeriod: this.billingPeriod
                }
            });
            if (window.posthog) window.posthog.captureException(error);
            (0, $4JcCM.runInAction)(()=>{
                // Provide more specific error messaging for coupon issues
                this.previewError = isCouponError ? `Billing setup issue: ${errorMessage}. Please contact support for assistance.` : errorMessage;
                this.isSubscribing = false;
            });
        }
    }
    /**
   * Confirm billing period change for existing subscription using updateSubscription
   */ async confirmBillingPeriodChange() {
        if (!this.hasBillingPeriodChanged || !this.subscriptionPreview) throw new Error("No billing period change to confirm");
        try {
            (0, $4JcCM.runInAction)(()=>{
                this.isUpdatingSubscription = true;
                this.previewError = null;
            });
            // Track subscription update attempt
            if (window.posthog) {
                var _SessionStore$organis5;
                window.posthog.capture("subscription_update_started", {
                    newPeriod: this.billingPeriod,
                    organisationId: (_SessionStore$organis5 = (0, $1BTI2.default).organisation) === null || _SessionStore$organis5 === void 0 ? void 0 : _SessionStore$organis5.id,
                    source: "billing_page_toggle"
                });
            }
            // Import trpc dynamically
            const { trpc: trpc } = await Promise.resolve((parcelRequire("3h7sC")));
            // Update subscription directly using tRPC
            const result = await trpc.legacy.updateSubscription.mutate({
                newPeriod: this.billingPeriod
            });
            if (result.success) {
                // Track successful subscription update
                if (window.posthog) {
                    var _SessionStore$organis6;
                    window.posthog.capture("subscription_updated", {
                        subscriptionId: result.subscriptionId,
                        newPeriod: this.billingPeriod,
                        organisationId: (_SessionStore$organis6 = (0, $1BTI2.default).organisation) === null || _SessionStore$organis6 === void 0 ? void 0 : _SessionStore$organis6.id,
                        source: "billing_page_toggle"
                    });
                }
                // Clear preview state after successful update
                this.clearPreview();
                // Refresh billing data to show updated subscription
                const billingData = await trpc.legacy.getBillingData.query();
                this.setBillingData(billingData);
                // Also ensure SessionStore subscription period is updated
                if ((0, $1BTI2.default).subscription && billingData.currentPeriod) (0, $1BTI2.default).subscription.subscriptionPeriod = billingData.currentPeriod;
                // Optional: Show a toast notification or update UI to indicate success
                if (window.Sentry) window.Sentry.addBreadcrumb({
                    message: "Subscription period updated successfully",
                    category: "billing",
                    level: "info",
                    data: {
                        newPeriod: this.billingPeriod,
                        subscriptionId: result.subscriptionId
                    }
                });
            } else throw new Error(result.message || "Failed to update subscription");
        } catch (error) {
            // Enhanced error categorization for better user feedback
            const errorMessage = error.message || "Failed to update subscription";
            const isCouponError = errorMessage.toLowerCase().includes("coupon") || errorMessage.toLowerCase().includes("validation") || errorMessage.toLowerCase().includes("discount");
            // Track subscription update failure with error categorization
            if (window.posthog) {
                var _SessionStore$organis7;
                window.posthog.capture("subscription_update_failed", {
                    error: errorMessage,
                    errorType: isCouponError ? "coupon_validation" : "general",
                    newPeriod: this.billingPeriod,
                    organisationId: (_SessionStore$organis7 = (0, $1BTI2.default).organisation) === null || _SessionStore$organis7 === void 0 ? void 0 : _SessionStore$organis7.id,
                    source: "billing_page_toggle"
                });
            }
            // Capture error for monitoring with additional context
            if (window.Sentry) window.Sentry.captureException(error, {
                tags: {
                    operation: "confirmBillingPeriodChange",
                    errorType: isCouponError ? "coupon_validation" : "general",
                    billingPeriod: this.billingPeriod
                }
            });
            if (window.posthog) window.posthog.captureException(error);
            (0, $4JcCM.runInAction)(()=>{
                // Provide more specific error messaging for coupon issues
                this.previewError = isCouponError ? `Billing update issue: ${errorMessage}. Please contact support for assistance.` : errorMessage;
                this.isUpdatingSubscription = false;
            });
        } finally{
            (0, $4JcCM.runInAction)(()=>{
                this.isUpdatingSubscription = false;
            });
        }
    }
}, $c4ee79e7effa8c33$var$_descriptor = $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "isSubscribing", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $c4ee79e7effa8c33$var$_descriptor2 = $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "isUpdatingSubscription", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $c4ee79e7effa8c33$var$_descriptor3 = $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "billingPeriod", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return undefined;
    }
}), $c4ee79e7effa8c33$var$_descriptor4 = $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "isFetchingPreview", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $c4ee79e7effa8c33$var$_descriptor5 = $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "subscriptionPreview", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c4ee79e7effa8c33$var$_descriptor6 = $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "previewError", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c4ee79e7effa8c33$var$_descriptor7 = $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "isCalculatingPreview", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $c4ee79e7effa8c33$var$_descriptor8 = $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "showPreview", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $c4ee79e7effa8c33$var$_descriptor9 = $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "previewType", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c4ee79e7effa8c33$var$_descriptor10 = $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "planLookup", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $c4ee79e7effa8c33$var$_descriptor11 = $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "couponLookup", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $c4ee79e7effa8c33$var$_descriptor12 = $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "taxLookup", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $c4ee79e7effa8c33$var$_descriptor13 = $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "resolvedPrices", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $c4ee79e7effa8c33$var$_descriptor14 = $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "priceResolutionStatus", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "idle";
    }
}), $c4ee79e7effa8c33$var$_descriptor15 = $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "priceResolutionError", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c4ee79e7effa8c33$var$_descriptor16 = $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "nextPaymentDate", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c4ee79e7effa8c33$var$_descriptor17 = $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "amountDue", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $c4ee79e7effa8c33$var$_descriptor18 = $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "discount", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $c4ee79e7effa8c33$var$_descriptor19 = $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "tax", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $c4ee79e7effa8c33$var$_descriptor20 = $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "credit", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $c4ee79e7effa8c33$var$_descriptor21 = $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "adjustments", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $c4ee79e7effa8c33$var$_descriptor22 = $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "grandTotal", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $c4ee79e7effa8c33$var$_descriptor23 = $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "remainingCredit", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $c4ee79e7effa8c33$var$_descriptor24 = $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "staffBreakdown", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $c4ee79e7effa8c33$var$_descriptor25 = $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "paymentMethods", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $c4ee79e7effa8c33$var$_descriptor26 = $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "receiptEmail", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c4ee79e7effa8c33$var$_descriptor27 = $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "creditBalance", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $c4ee79e7effa8c33$var$_descriptor28 = $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "currency", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "usd";
    }
}), $c4ee79e7effa8c33$var$_descriptor29 = $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "stripeCustomerId", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "setBillingData", [
    $c4ee79e7effa8c33$var$_dec
], Object.getOwnPropertyDescriptor($c4ee79e7effa8c33$var$_class.prototype, "setBillingData"), $c4ee79e7effa8c33$var$_class.prototype), $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "availableBillingPeriods", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c4ee79e7effa8c33$var$_class.prototype, "availableBillingPeriods"), $c4ee79e7effa8c33$var$_class.prototype), $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "currentSubscriptionPeriod", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c4ee79e7effa8c33$var$_class.prototype, "currentSubscriptionPeriod"), $c4ee79e7effa8c33$var$_class.prototype), $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "hasActiveSubscription", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c4ee79e7effa8c33$var$_class.prototype, "hasActiveSubscription"), $c4ee79e7effa8c33$var$_class.prototype), $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "shouldShowPreview", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c4ee79e7effa8c33$var$_class.prototype, "shouldShowPreview"), $c4ee79e7effa8c33$var$_class.prototype), $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "hasBillingPeriodChanged", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c4ee79e7effa8c33$var$_class.prototype, "hasBillingPeriodChanged"), $c4ee79e7effa8c33$var$_class.prototype), $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "currentPreviewType", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c4ee79e7effa8c33$var$_class.prototype, "currentPreviewType"), $c4ee79e7effa8c33$var$_class.prototype), $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "hasPricingData", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c4ee79e7effa8c33$var$_class.prototype, "hasPricingData"), $c4ee79e7effa8c33$var$_class.prototype), $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "isPriceResolutionPending", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c4ee79e7effa8c33$var$_class.prototype, "isPriceResolutionPending"), $c4ee79e7effa8c33$var$_class.prototype), $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "hasPriceResolutionFailed", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c4ee79e7effa8c33$var$_class.prototype, "hasPriceResolutionFailed"), $c4ee79e7effa8c33$var$_class.prototype), $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "computedStaffBreakdown", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c4ee79e7effa8c33$var$_class.prototype, "computedStaffBreakdown"), $c4ee79e7effa8c33$var$_class.prototype), $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "yearlySavings", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c4ee79e7effa8c33$var$_class.prototype, "yearlySavings"), $c4ee79e7effa8c33$var$_class.prototype), $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "computedGrandTotal", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c4ee79e7effa8c33$var$_class.prototype, "computedGrandTotal"), $c4ee79e7effa8c33$var$_class.prototype), $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "computedRemainingCredit", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c4ee79e7effa8c33$var$_class.prototype, "computedRemainingCredit"), $c4ee79e7effa8c33$var$_class.prototype), $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "previewComputedGrandTotal", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c4ee79e7effa8c33$var$_class.prototype, "previewComputedGrandTotal"), $c4ee79e7effa8c33$var$_class.prototype), $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "setIsSubscribing", [
    $c4ee79e7effa8c33$var$_dec2
], Object.getOwnPropertyDescriptor($c4ee79e7effa8c33$var$_class.prototype, "setIsSubscribing"), $c4ee79e7effa8c33$var$_class.prototype), $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "setIsUpdatingSubscription", [
    $c4ee79e7effa8c33$var$_dec3
], Object.getOwnPropertyDescriptor($c4ee79e7effa8c33$var$_class.prototype, "setIsUpdatingSubscription"), $c4ee79e7effa8c33$var$_class.prototype), $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "setIsFetchingPreview", [
    $c4ee79e7effa8c33$var$_dec4
], Object.getOwnPropertyDescriptor($c4ee79e7effa8c33$var$_class.prototype, "setIsFetchingPreview"), $c4ee79e7effa8c33$var$_class.prototype), $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "setSubscriptionPreview", [
    $c4ee79e7effa8c33$var$_dec5
], Object.getOwnPropertyDescriptor($c4ee79e7effa8c33$var$_class.prototype, "setSubscriptionPreview"), $c4ee79e7effa8c33$var$_class.prototype), $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "setBillingPeriod", [
    $c4ee79e7effa8c33$var$_dec6
], Object.getOwnPropertyDescriptor($c4ee79e7effa8c33$var$_class.prototype, "setBillingPeriod"), $c4ee79e7effa8c33$var$_class.prototype), $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "setPreviewError", [
    $c4ee79e7effa8c33$var$_dec7
], Object.getOwnPropertyDescriptor($c4ee79e7effa8c33$var$_class.prototype, "setPreviewError"), $c4ee79e7effa8c33$var$_class.prototype), $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "setIsCalculatingPreview", [
    $c4ee79e7effa8c33$var$_dec8
], Object.getOwnPropertyDescriptor($c4ee79e7effa8c33$var$_class.prototype, "setIsCalculatingPreview"), $c4ee79e7effa8c33$var$_class.prototype), $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "setShowPreview", [
    $c4ee79e7effa8c33$var$_dec9
], Object.getOwnPropertyDescriptor($c4ee79e7effa8c33$var$_class.prototype, "setShowPreview"), $c4ee79e7effa8c33$var$_class.prototype), $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "setPreviewType", [
    $c4ee79e7effa8c33$var$_dec10
], Object.getOwnPropertyDescriptor($c4ee79e7effa8c33$var$_class.prototype, "setPreviewType"), $c4ee79e7effa8c33$var$_class.prototype), $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "setPlanLookup", [
    $c4ee79e7effa8c33$var$_dec11
], Object.getOwnPropertyDescriptor($c4ee79e7effa8c33$var$_class.prototype, "setPlanLookup"), $c4ee79e7effa8c33$var$_class.prototype), $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "setCouponLookup", [
    $c4ee79e7effa8c33$var$_dec12
], Object.getOwnPropertyDescriptor($c4ee79e7effa8c33$var$_class.prototype, "setCouponLookup"), $c4ee79e7effa8c33$var$_class.prototype), $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "setTaxLookup", [
    $c4ee79e7effa8c33$var$_dec13
], Object.getOwnPropertyDescriptor($c4ee79e7effa8c33$var$_class.prototype, "setTaxLookup"), $c4ee79e7effa8c33$var$_class.prototype), $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "setResolvedPrices", [
    $c4ee79e7effa8c33$var$_dec14
], Object.getOwnPropertyDescriptor($c4ee79e7effa8c33$var$_class.prototype, "setResolvedPrices"), $c4ee79e7effa8c33$var$_class.prototype), $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "setPriceResolutionStatus", [
    $c4ee79e7effa8c33$var$_dec15
], Object.getOwnPropertyDescriptor($c4ee79e7effa8c33$var$_class.prototype, "setPriceResolutionStatus"), $c4ee79e7effa8c33$var$_class.prototype), $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "setPriceResolutionError", [
    $c4ee79e7effa8c33$var$_dec16
], Object.getOwnPropertyDescriptor($c4ee79e7effa8c33$var$_class.prototype, "setPriceResolutionError"), $c4ee79e7effa8c33$var$_class.prototype), $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "calculatePreview", [
    $c4ee79e7effa8c33$var$_dec17
], Object.getOwnPropertyDescriptor($c4ee79e7effa8c33$var$_class.prototype, "calculatePreview"), $c4ee79e7effa8c33$var$_class.prototype), $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "checkInitialPreviewDisplay", [
    $c4ee79e7effa8c33$var$_dec18
], Object.getOwnPropertyDescriptor($c4ee79e7effa8c33$var$_class.prototype, "checkInitialPreviewDisplay"), $c4ee79e7effa8c33$var$_class.prototype), $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "onStaffDataAvailable", [
    $c4ee79e7effa8c33$var$_dec19
], Object.getOwnPropertyDescriptor($c4ee79e7effa8c33$var$_class.prototype, "onStaffDataAvailable"), $c4ee79e7effa8c33$var$_class.prototype), $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "fetchNewSubscriptionPreview", [
    $c4ee79e7effa8c33$var$_dec20
], Object.getOwnPropertyDescriptor($c4ee79e7effa8c33$var$_class.prototype, "fetchNewSubscriptionPreview"), $c4ee79e7effa8c33$var$_class.prototype), $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "fetchServerPreview", [
    $c4ee79e7effa8c33$var$_dec21
], Object.getOwnPropertyDescriptor($c4ee79e7effa8c33$var$_class.prototype, "fetchServerPreview"), $c4ee79e7effa8c33$var$_class.prototype), $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "clearPreview", [
    $c4ee79e7effa8c33$var$_dec22
], Object.getOwnPropertyDescriptor($c4ee79e7effa8c33$var$_class.prototype, "clearPreview"), $c4ee79e7effa8c33$var$_class.prototype), $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "resetBillingPeriod", [
    $c4ee79e7effa8c33$var$_dec23
], Object.getOwnPropertyDescriptor($c4ee79e7effa8c33$var$_class.prototype, "resetBillingPeriod"), $c4ee79e7effa8c33$var$_class.prototype), $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "startNewSubscription", [
    $c4ee79e7effa8c33$var$_dec24
], Object.getOwnPropertyDescriptor($c4ee79e7effa8c33$var$_class.prototype, "startNewSubscription"), $c4ee79e7effa8c33$var$_class.prototype), $c4ee79e7effa8c33$var$_applyDecoratedDescriptor($c4ee79e7effa8c33$var$_class.prototype, "confirmBillingPeriodChange", [
    $c4ee79e7effa8c33$var$_dec25
], Object.getOwnPropertyDescriptor($c4ee79e7effa8c33$var$_class.prototype, "confirmBillingPeriodChange"), $c4ee79e7effa8c33$var$_class.prototype), $c4ee79e7effa8c33$var$_class);
var $c4ee79e7effa8c33$export$2e2bcd8739ae039 = new $c4ee79e7effa8c33$var$BillingPageStore();

});
parcelRegister("k3urn", function(module, exports) {

$parcel$export(module.exports, "calculateBillingPreview", function () { return $e99bb35521ab37b1$export$6ce3d58c8e774b83; });

var $1BTI2 = parcelRequire("1BTI2");
/**
 * STANDARDIZED BILLING CALCULATION UTILITIES
 * Following PRD rules implemented in server_node/src/utils/stripe.ts
 *
 * PRD Rules:
 * - Monthly: Flat per-user fee, no default discounts, remove coupons when switching from yearly
 * - Yearly: Flat per-user fee + 15% discount, preserve better existing coupons
 * - Payment format: Date → Amount Due → Discounts → Adjustments → Tax → Credit → Total/Credit Applied
 */ // Import plan and coupon lookup data (matching OrganisationSubscriptionModel.js)
const $e99bb35521ab37b1$export$9c27cc0af806390c = {
    "1_Month_Aus_Admin": {
        id: "1_Month_Aus_Admin",
        interval: "month",
        intervalCount: 1,
        amount: 4500,
        currency: "aud"
    },
    "1_Month_Aus_Standard": {
        id: "1",
        interval: "month",
        intervalCount: 1,
        amount: 2000,
        currency: "aud"
    },
    "12_Month_Aus_Admin": {
        id: "12_Month_Aus_Admin",
        interval: "year",
        intervalCount: 1,
        amount: 54000,
        currency: "aud"
    },
    "12_Month_Aus_Standard": {
        id: "12_Month_Aus_Standard",
        interval: "year",
        intervalCount: 1,
        amount: 24000,
        currency: "aud"
    },
    "6_Month_Aus_Admin": {
        id: "6_Month_Aus_Admin",
        interval: "month",
        intervalCount: 6,
        amount: 27000,
        currency: "aud"
    },
    "6_Month_Aus_Standard": {
        id: "6_Month_Aus_Standard",
        interval: "month",
        intervalCount: 6,
        amount: 12000,
        currency: "aud"
    },
    "1_Month_Aus_Standard_$15": {
        id: "15AUD_User",
        interval: "month",
        intervalCount: 1,
        amount: 1500,
        currency: "aud"
    },
    "12_Month_Aus_Standard_$15": {
        id: "12_Month_15AUD",
        interval: "year",
        intervalCount: 1,
        amount: 18000,
        currency: "aud"
    },
    "12_Month_Aus_Standard_BS": {
        id: "12_Month_Timesheet_BS",
        interval: "year",
        intervalCount: 1,
        amount: 18000,
        currency: "aud"
    },
    "1_Month_US_Admin": {
        id: "1month_admin_usd",
        interval: "month",
        intervalCount: 1,
        amount: 3500,
        currency: "usd"
    },
    "1_Month_US_Standard": {
        id: "1month_timesheet_usd",
        interval: "month",
        intervalCount: 1,
        amount: 1500,
        currency: "usd"
    },
    "12_Month_US_Admin": {
        id: "12month_admin_usd",
        interval: "year",
        intervalCount: 1,
        amount: 42000,
        currency: "usd"
    },
    "12_Month_US_Standard": {
        id: "12month_timesheet_usd",
        interval: "year",
        intervalCount: 1,
        amount: 18000,
        currency: "usd"
    },
    "1_Month_US_Any_$23": {
        id: "1_monthly_plan",
        interval: "month",
        intervalCount: 1,
        amount: 2300,
        currency: "usd"
    },
    "12_Month_US_Admin_$30": {
        id: "12month_admin_30usd",
        interval: "year",
        intervalCount: 1,
        amount: 36000,
        currency: "usd"
    },
    "1_Month_Aus_29": {
        id: "price_1MnYUZC5Z2UupQFYupQNBHo6",
        interval: "month",
        intervalCount: 1,
        amount: 2900,
        currency: "aud"
    },
    "12_Month_Aus_29": {
        id: "price_1MnYV3C5Z2UupQFYEBt85US1",
        interval: "year",
        intervalCount: 1,
        amount: 34800,
        currency: "aud"
    },
    "1_Month_US_19": {
        id: "price_1MnYW7C5Z2UupQFYHpzWaEih",
        interval: "month",
        intervalCount: 1,
        amount: 1900,
        currency: "usd"
    },
    "12_Month_US_19": {
        id: "price_1MnYWeC5Z2UupQFYmgDbRJqy",
        interval: "year",
        intervalCount: 1,
        amount: 22800,
        currency: "usd"
    },
    "1_Month_Aus_35": {
        id: "price_1Q8B6xC5Z2UupQFYHil12VMM",
        interval: "month",
        intervalCount: 1,
        amount: 3500,
        currency: "aud"
    },
    "12_Month_Aus_35": {
        id: "price_1Q8B7tC5Z2UupQFY5PjrScn4",
        interval: "year",
        intervalCount: 1,
        amount: 42000,
        currency: "aud"
    },
    "1_Month_US_25": {
        id: "price_1Q8B8tC5Z2UupQFYLobMM9KB",
        interval: "month",
        intervalCount: 1,
        amount: 2500,
        currency: "usd"
    },
    "12_Month_US_25": {
        id: "price_1Q8B9RC5Z2UupQFYCVOeNrd7",
        interval: "year",
        intervalCount: 1,
        amount: 30000,
        currency: "usd"
    }
};
const $e99bb35521ab37b1$export$27369182f53508d5 = {
    "10_percent_forever": {
        id: "10_percent_forever",
        percentDiscount: 10
    },
    "15_percent_forever": {
        id: "15_percent_forever",
        percentDiscount: 15
    },
    "20_percent_forever": {
        id: "20_percent_forever",
        percentDiscount: 20
    },
    "25_percent_forever": {
        id: "25_percent_forever",
        percentDiscount: 25
    },
    "35_percent_forever": {
        id: "35_percent_forever",
        percentDiscount: 35
    },
    "50_percent_forever": {
        id: "50_percent_forever",
        percentDiscount: 50
    },
    FREE: {
        id: "FREE",
        percentDiscount: 100
    },
    "20_percent_1_year": {
        id: "20_percent_1_year",
        percentDiscount: 20
    },
    "25_percent_1_year": {
        id: "25_percent_1_year",
        percentDiscount: 25
    },
    "50_percent_12months": {
        id: "50_percent_12months",
        percentDiscount: 50
    },
    "35_percent_off_6_months": {
        id: "35_percent_off_6_months",
        percentDiscount: 35
    },
    "5_percent_discount_once": {
        id: "5_percent_discount_once",
        percentDiscount: 5
    },
    "10_percent_discount_once": {
        id: "10_percent_discount_once",
        percentDiscount: 10
    },
    "20_percent_discount_once": {
        id: "20_percent_discount_once",
        percentDiscount: 20
    },
    "25_percent_discount_once": {
        id: "25_percent_discount_once",
        percentDiscount: 25
    },
    "35_percent_discount_once": {
        id: "35_percent_discount_once",
        percentDiscount: 35
    },
    "50_percent_discount_once": {
        id: "50_percent_discount_once",
        percentDiscount: 50
    }
};
const $e99bb35521ab37b1$export$371c02f644726eaa = {
    au: {
        name: "GST",
        taxPercent: 10
    }
};
const $e99bb35521ab37b1$export$28d6f94fed1fe181 = (currentPeriod, existingMonthlyCouponId, existingYearlyCouponId, couponLookupToUse = $e99bb35521ab37b1$export$27369182f53508d5)=>{
    // Rule: When switching from yearly to monthly, remove all existing coupons
    if (currentPeriod === "yearly") return {
        id: "",
        percentDiscount: 0,
        shouldApply: false,
        reason: "PRD Rule: Remove all coupons when switching from yearly to monthly"
    };
    // Rule: For monthly billing, only preserve existing monthly coupons (no default discounts)
    if (existingMonthlyCouponId && couponLookupToUse[existingMonthlyCouponId]) {
        const couponInfo = couponLookupToUse[existingMonthlyCouponId];
        return {
            id: existingMonthlyCouponId,
            percentDiscount: couponInfo.percentDiscount,
            shouldApply: true,
            reason: "PRD Rule: Preserve existing monthly coupon"
        };
    }
    // Rule: No default discounts for monthly billing
    return {
        id: "",
        percentDiscount: 0,
        shouldApply: false,
        reason: "PRD Rule: No default discounts for monthly billing"
    };
};
const $e99bb35521ab37b1$export$7a4e5a648fcf59f9 = (currentPeriod, existingMonthlyCouponId, existingYearlyCouponId, couponLookupToUse = $e99bb35521ab37b1$export$27369182f53508d5)=>{
    // Rule: When switching from monthly to yearly, compare existing monthly coupon with 15% yearly discount
    if (currentPeriod === "monthly" && existingMonthlyCouponId && couponLookupToUse[existingMonthlyCouponId]) {
        const existingCouponInfo = couponLookupToUse[existingMonthlyCouponId];
        if (existingCouponInfo.percentDiscount > 15) return {
            id: existingMonthlyCouponId,
            percentDiscount: existingCouponInfo.percentDiscount,
            shouldApply: true,
            reason: "PRD Rule: Preserve existing monthly coupon that's better than 15% yearly discount"
        };
    }
    // Rule: For yearly billing, apply 15% discount by default (or preserve existing yearly coupon if better)
    if (existingYearlyCouponId && couponLookupToUse[existingYearlyCouponId]) {
        const existingCouponInfo = couponLookupToUse[existingYearlyCouponId];
        if (existingCouponInfo.percentDiscount >= 15) return {
            id: existingYearlyCouponId,
            percentDiscount: existingCouponInfo.percentDiscount,
            shouldApply: true,
            reason: "PRD Rule: Preserve existing yearly coupon that meets minimum 15%"
        };
    }
    // Rule: Apply default 15% yearly discount
    return {
        id: "15_percent_forever",
        percentDiscount: 15,
        shouldApply: true,
        reason: "PRD Rule: Apply default 15% yearly discount"
    };
};
const $e99bb35521ab37b1$export$142554828fa8de34 = (organisationCountry, period, subscribedAt, staffList, planLookupToUse = $e99bb35521ab37b1$export$9c27cc0af806390c)=>{
    // Determine if this is a legacy subscription
    const subscribedDate = subscribedAt ? new Date(subscribedAt) : null;
    const isLegacy = subscribedDate && subscribedDate < new Date("2023-03-20");
    const isAuNz = [
        "au",
        "nz"
    ].includes(organisationCountry);
    // Get staff totals
    let numAdminUsers = 0;
    let numStandardUsers = 0;
    staffList.forEach((staffMember)=>{
        const billingLevel = $e99bb35521ab37b1$export$6d3bc4175e871ecc(staffMember);
        if (billingLevel === "admin") numAdminUsers++;
        else if (billingLevel === "standard") numStandardUsers++;
    });
    const totalUsers = numAdminUsers + numStandardUsers;
    const currency = isAuNz ? "aud" : "usd";
    if (isLegacy) {
        var _planLookupToUse$admi, _planLookupToUse$stan;
        // Legacy subscriptions maintain separate admin/standard pricing
        const adminPriceKey = period === "yearly" ? isAuNz ? "12_Month_Aus_Admin" : "12_Month_US_Admin" : isAuNz ? "1_Month_Aus_Admin" : "1_Month_US_Admin";
        const standardPriceKey = period === "yearly" ? isAuNz ? "12_Month_Aus_Standard" : "12_Month_US_Standard" : isAuNz ? "1_Month_Aus_Standard" : "1_Month_US_Standard";
        const adminPrice = ((_planLookupToUse$admi = planLookupToUse[adminPriceKey]) === null || _planLookupToUse$admi === void 0 ? void 0 : _planLookupToUse$admi.amount) || 0;
        const standardPrice = ((_planLookupToUse$stan = planLookupToUse[standardPriceKey]) === null || _planLookupToUse$stan === void 0 ? void 0 : _planLookupToUse$stan.amount) || 0;
        const amountDue = (numAdminUsers * adminPrice + numStandardUsers * standardPrice) / 100;
        const avgPricePerUser = totalUsers > 0 ? amountDue / totalUsers : 0;
        return {
            amountDue: amountDue,
            userCount: totalUsers,
            pricePerUser: avgPricePerUser,
            currency: currency
        };
    } else {
        var _planLookupToUse$flat;
        // Modern subscriptions use flat per-user pricing
        const flatPriceKey = period === "yearly" ? isAuNz ? "12_Month_Aus_35" : "12_Month_US_25" : isAuNz ? "1_Month_Aus_35" : "1_Month_US_25";
        const flatPrice = ((_planLookupToUse$flat = planLookupToUse[flatPriceKey]) === null || _planLookupToUse$flat === void 0 ? void 0 : _planLookupToUse$flat.amount) || 0;
        const amountDue = totalUsers * flatPrice / 100;
        const pricePerUser = flatPrice / 100;
        return {
            amountDue: amountDue,
            userCount: totalUsers,
            pricePerUser: pricePerUser,
            currency: currency
        };
    }
};
const $e99bb35521ab37b1$export$41e3fa8441c88bf2 = (amountDue, couponInfo, adjustments = 0, credit = 0, organisationCountry = "au", nextPaymentDate = null, currency = "usd", taxLookupToUse = $e99bb35521ab37b1$export$371c02f644726eaa)=>{
    var _taxLookupToUse$organ, _taxLookupToUse$organ2;
    // Calculate discount (always subtract from amount due)
    const discount = couponInfo.shouldApply ? amountDue * couponInfo.percentDiscount / 100 : 0;
    // Calculate tax (applied after discounts and adjustments)
    const taxPercent = ((_taxLookupToUse$organ = taxLookupToUse[organisationCountry]) === null || _taxLookupToUse$organ === void 0 ? void 0 : _taxLookupToUse$organ.taxPercent) || 0;
    const taxName = ((_taxLookupToUse$organ2 = taxLookupToUse[organisationCountry]) === null || _taxLookupToUse$organ2 === void 0 ? void 0 : _taxLookupToUse$organ2.name) || "Tax";
    const taxableAmount = amountDue - discount + adjustments;
    const tax = Math.max(0, taxableAmount * (taxPercent / 100));
    // Calculate subtotal (before credit application)
    const subtotal = amountDue - discount + adjustments + tax;
    // Calculate final amounts according to PRD rules
    let grandTotal = 0;
    let creditApplied = 0;
    if (subtotal <= credit) {
        // Credit covers entire amount - show "Credit Applied" instead of total
        grandTotal = 0;
        creditApplied = subtotal;
    } else {
        // Credit partially covers or doesn't cover - show remaining total
        grandTotal = subtotal - credit;
        creditApplied = 0;
    }
    const breakdown = {
        nextPaymentDate: nextPaymentDate,
        amountDue: amountDue,
        discount: discount,
        adjustments: adjustments,
        tax: tax,
        credit: credit,
        grandTotal: grandTotal,
        creditApplied: creditApplied,
        taxName: taxName,
        currency: currency.toUpperCase()
    };
    return breakdown;
};
const $e99bb35521ab37b1$export$7fa6bddebd9117a3 = (period, subscribedAt, organisationCountry)=>{
    const subscribedDate = subscribedAt ? new Date(subscribedAt) : null;
    const isLegacy = subscribedDate && subscribedDate < new Date("2023-03-20");
    const isAuNz = [
        "au",
        "nz"
    ].includes(organisationCountry);
    if (period === "monthly") {
        if (isLegacy) return {
            adminPlanId: isAuNz ? "1_Month_Aus_Admin" : "1_Month_US_Admin",
            standardPlanId: isAuNz ? "1_Month_Aus_Standard" : "1_Month_US_Standard"
        };
        return {
            adminPlanId: isAuNz ? "1_Month_Aus_35" : "1_Month_US_25",
            standardPlanId: isAuNz ? "1_Month_Aus_35" : "1_Month_US_25"
        };
    } else {
        // yearly
        if (isLegacy) return {
            adminPlanId: isAuNz ? "12_Month_Aus_Admin" : "12_Month_US_Admin",
            standardPlanId: isAuNz ? "12_Month_Aus_Standard" : "12_Month_US_Standard"
        };
        return {
            adminPlanId: isAuNz ? "12_Month_Aus_35" : "12_Month_US_25",
            standardPlanId: isAuNz ? "12_Month_Aus_35" : "12_Month_US_25"
        };
    }
};
const $e99bb35521ab37b1$export$aff2ff647941510 = (billingLevel, period, isLegacySubscription, organisationCountry, subscribedAt, organisationSubscription, planLookupToUse = $e99bb35521ab37b1$export$9c27cc0af806390c)=>{
    // For non-billable staff
    if (billingLevel === "none") return 0;
    if (isLegacySubscription) {
        var _planLookupToUse$plan;
        // Legacy subscriptions have separate admin/standard pricing
        const planType = billingLevel === "admin" ? "admin" : "standard";
        const planKey = period === "yearly" ? (organisationSubscription === null || organisationSubscription === void 0 ? void 0 : organisationSubscription[`yearly${planType === "admin" ? "Admin" : "Standard"}PlanId`]) || $e99bb35521ab37b1$export$7fa6bddebd9117a3(period, subscribedAt, organisationCountry)[`${planType}PlanId`] : (organisationSubscription === null || organisationSubscription === void 0 ? void 0 : organisationSubscription[`monthly${planType === "admin" ? "Admin" : "Standard"}PlanId`]) || $e99bb35521ab37b1$export$7fa6bddebd9117a3(period, subscribedAt, organisationCountry)[`${planType}PlanId`];
        const planPrice = ((_planLookupToUse$plan = planLookupToUse[planKey]) === null || _planLookupToUse$plan === void 0 ? void 0 : _planLookupToUse$plan.amount) || 0;
        return planPrice / 100; // Convert cents to dollars
    } else {
        var _planLookupToUse$flat2;
        // Modern subscriptions use flat per-user pricing
        const isAuNz = [
            "au",
            "nz"
        ].includes(organisationCountry);
        const flatPriceKey = period === "yearly" ? isAuNz ? "12_Month_Aus_35" : "12_Month_US_25" : isAuNz ? "1_Month_Aus_35" : "1_Month_US_25";
        const flatPrice = ((_planLookupToUse$flat2 = planLookupToUse[flatPriceKey]) === null || _planLookupToUse$flat2 === void 0 ? void 0 : _planLookupToUse$flat2.amount) || 0;
        return flatPrice / 100; // Convert cents to dollars
    }
};
const $e99bb35521ab37b1$export$6d3bc4175e871ecc = (staffMember)=>{
    if (staffMember.billingLevelOverride) return staffMember.billingLevelOverride;
    if (!staffMember.hasLogin || !staffMember.email || staffMember.isArchived) return "none";
    if (staffMember.permissions) {
        let permissions = {};
        if (typeof staffMember.permissions === "string") try {
            permissions = JSON.parse(staffMember.permissions);
        } catch  {
            return "standard";
        }
        else permissions = staffMember.permissions || {};
        // Determine admin status using consistent logic (matches server-side isAdmin function)
        // Admin criteria: can see salaries OR operational expenses OR billing OR settings
        const canSeeSalaries = (permissions.staffPermissions === "view" || permissions.staffPermissions === "edit" || permissions.staffPermissions === "admin") && (permissions.payRate === "view" || permissions.payRate === "edit" || permissions.payRate === "admin" || permissions.overtimeRate === "view" || permissions.overtimeRate === "edit" || permissions.overtimeRate === "admin");
        const canSeeOperationalExpenses = permissions.operationalExpenses === "view" || permissions.operationalExpenses === "edit" || permissions.operationalExpenses === "admin";
        const canViewBilling = permissions.billing === "edit";
        const canViewSettings = permissions.organisationSettings === "view" || permissions.organisationSettings === "edit" || permissions.organisationSettings === "admin";
        const hasAdminPermission = canSeeSalaries || canSeeOperationalExpenses || canViewBilling || canViewSettings;
        return hasAdminPermission ? "admin" : "standard";
    }
    return "standard";
};
const $e99bb35521ab37b1$export$9b71d46b0a887dae = ({ currentBillingData: currentBillingData, newSubtotal: newSubtotal, subscriptionPeriod: subscriptionPeriod, organisationSubscription: organisationSubscription })=>{
    if (!currentBillingData || !currentBillingData.nextPaymentDate) return 0;
    const currentPeriod = organisationSubscription === null || organisationSubscription === void 0 ? void 0 : organisationSubscription.subscriptionPeriod;
    const nextPaymentDate = new Date(currentBillingData.nextPaymentDate);
    const today = new Date();
    // Calculate days remaining in current billing cycle
    const daysRemaining = Math.max(0, Math.floor((nextPaymentDate - today) / 86400000));
    // Get current period length in days
    const currentPeriodDays = currentPeriod === "yearly" ? 365 : 30;
    // Calculate proration factor (how much of current period is unused)
    const prorationFactor = daysRemaining / currentPeriodDays;
    // Calculate current period cost that would be credited
    const currentAmountDue = currentBillingData.amountDue || 0;
    const currentCredit = currentAmountDue * prorationFactor;
    // Calculate immediate charge for new period
    let immediateCharge = 0;
    if (subscriptionPeriod === "yearly" && currentPeriod === "monthly") {
        // Switching from monthly to yearly - charge for remaining days at new rate
        const yearlyDailyRate = newSubtotal / 365;
        immediateCharge = yearlyDailyRate * daysRemaining;
    } else if (subscriptionPeriod === "monthly" && currentPeriod === "yearly") {
        // Switching from yearly to monthly - charge for remaining days at new rate
        const monthlyDailyRate = newSubtotal / 30;
        immediateCharge = monthlyDailyRate * Math.min(daysRemaining, 30);
    }
    // Net adjustment is immediate charge minus credit from unused current period
    const netAdjustment = immediateCharge - currentCredit;
    return Math.round(netAdjustment * 100) / 100; // Round to 2 decimal places
};
function $e99bb35521ab37b1$export$6ce3d58c8e774b83(staffList, billingPeriod, subscription, planLookupData, couponLookupData, taxLookupData) {
    var _SessionStore$organis, _subscription$organis, _SessionStore$user;
    // Validate inputs
    if (!staffList || !billingPeriod) throw new Error("Missing required parameters for billing preview calculation");
    // Use server-provided lookup data if available, fallback to local data
    const activePlanLookup = planLookupData && Object.keys(planLookupData).length > 0 ? planLookupData : $e99bb35521ab37b1$export$9c27cc0af806390c;
    const activeCouponLookup = couponLookupData && Object.keys(couponLookupData).length > 0 ? couponLookupData : $e99bb35521ab37b1$export$27369182f53508d5;
    const activeTaxLookup = taxLookupData && Object.keys(taxLookupData).length > 0 ? taxLookupData : $e99bb35521ab37b1$export$371c02f644726eaa;
    // Get organisation country from session or subscription
    const organisationCountry = ((_SessionStore$organis = (0, $1BTI2.default).organisation) === null || _SessionStore$organis === void 0 ? void 0 : _SessionStore$organis.country) || (subscription === null || subscription === void 0 ? void 0 : (_subscription$organis = subscription.organisation) === null || _subscription$organis === void 0 ? void 0 : _subscription$organis.country) || ((_SessionStore$user = (0, $1BTI2.default).user) === null || _SessionStore$user === void 0 ? void 0 : _SessionStore$user.country) || "au"; // Default fallback
    return $e99bb35521ab37b1$export$b9c1fc58b8ddd9ac({
        staffList: staffList,
        subscriptionPeriod: billingPeriod,
        organisationSubscription: subscription,
        organisationCountry: organisationCountry,
        isNewSubscription: !(subscription !== null && subscription !== void 0 && subscription.hasSubscription),
        currentBillingData: null,
        planLookup: activePlanLookup,
        couponLookup: activeCouponLookup,
        taxLookup: activeTaxLookup
    });
}
const $e99bb35521ab37b1$export$b9c1fc58b8ddd9ac = ({ staffList: staffList, subscriptionPeriod: subscriptionPeriod, organisationSubscription: organisationSubscription, organisationCountry: organisationCountry, isNewSubscription: isNewSubscription = false, currentBillingData: currentBillingData = null, planLookup: planLookupToUse = $e99bb35521ab37b1$export$9c27cc0af806390c, couponLookup: couponLookupToUse = $e99bb35521ab37b1$export$27369182f53508d5, taxLookup: taxLookupToUse = $e99bb35521ab37b1$export$371c02f644726eaa })=>{
    // Calculate standardized fees using the new standardized logic
    const feeData = $e99bb35521ab37b1$export$142554828fa8de34(organisationCountry, subscriptionPeriod, organisationSubscription === null || organisationSubscription === void 0 ? void 0 : organisationSubscription.subscribedAt, staffList, planLookupToUse);
    // Apply standardized coupon logic
    const currentPeriod = isNewSubscription ? undefined : organisationSubscription === null || organisationSubscription === void 0 ? void 0 : organisationSubscription.subscriptionPeriod;
    let couponInfo;
    if (subscriptionPeriod === "monthly") couponInfo = $e99bb35521ab37b1$export$28d6f94fed1fe181(currentPeriod, organisationSubscription === null || organisationSubscription === void 0 ? void 0 : organisationSubscription.monthlyCouponId, organisationSubscription === null || organisationSubscription === void 0 ? void 0 : organisationSubscription.yearlyCouponId, couponLookupToUse);
    else couponInfo = $e99bb35521ab37b1$export$7a4e5a648fcf59f9(currentPeriod, organisationSubscription === null || organisationSubscription === void 0 ? void 0 : organisationSubscription.monthlyCouponId, organisationSubscription === null || organisationSubscription === void 0 ? void 0 : organisationSubscription.yearlyCouponId, couponLookupToUse);
    // Get current credit balance
    const credit = isNewSubscription ? 0 : (currentBillingData === null || currentBillingData === void 0 ? void 0 : currentBillingData.credit) || 0;
    // Calculate adjustments (for period changes, this would include prorations)
    let adjustments = 0;
    if (!isNewSubscription && currentBillingData) adjustments = $e99bb35521ab37b1$export$9b71d46b0a887dae({
        currentBillingData: currentBillingData,
        newSubtotal: feeData.amountDue,
        subscriptionPeriod: subscriptionPeriod,
        organisationSubscription: organisationSubscription
    });
    // Create standardized payment breakdown
    const nextPaymentDate = isNewSubscription ? new Date() : (currentBillingData === null || currentBillingData === void 0 ? void 0 : currentBillingData.nextPaymentDate) || new Date();
    const breakdown = $e99bb35521ab37b1$export$41e3fa8441c88bf2(feeData.amountDue, couponInfo, adjustments, credit, organisationCountry, nextPaymentDate, feeData.currency, taxLookupToUse);
    // Get staff breakdown for display - using standardized fee calculation
    const subscribedDate = organisationSubscription !== null && organisationSubscription !== void 0 && organisationSubscription.subscribedAt ? new Date(organisationSubscription.subscribedAt) : null;
    const isLegacy = subscribedDate && subscribedDate < new Date("2023-03-20");
    const staffBreakdown = staffList.map((staff, index)=>{
        const billingLevel = $e99bb35521ab37b1$export$6d3bc4175e871ecc(staff);
        const isBillable = billingLevel !== "none";
        return {
            index: index + 1,
            name: `${staff.firstName || ""} ${staff.lastName || ""}`.trim(),
            billingLevel: billingLevel,
            fee: $e99bb35521ab37b1$export$aff2ff647941510(billingLevel, subscriptionPeriod, isLegacy, organisationCountry, subscribedDate, organisationSubscription, planLookupToUse),
            isBillable: isBillable,
            staff: staff
        };
    });
    const result = {
        ...breakdown,
        staffBreakdown: staffBreakdown,
        couponInfo: couponInfo,
        userCount: feeData.userCount,
        pricePerUser: feeData.pricePerUser,
        // Additional breakdown info for backward compatibility
        subtotal: feeData.amountDue,
        numAdminUsers: staffBreakdown.filter((s)=>s.billingLevel === "admin" && s.isBillable).length,
        numStandardUsers: staffBreakdown.filter((s)=>s.billingLevel === "standard" && s.isBillable).length
    };
    // Validate result follows standardized rules
    const validation = $e99bb35521ab37b1$export$1affc1dc8228eff2(result, subscriptionPeriod);
    if (!validation.isValid) throw new Error(`Billing calculation validation failed: ${validation.errors.join(", ")}`);
    return result;
};
const $e99bb35521ab37b1$export$44e2197fcd23c186 = ({ staffList: staffList, newPeriod: newPeriod, organisationSubscription: organisationSubscription, organisationCountry: organisationCountry, currentBillingData: currentBillingData })=>{
    return $e99bb35521ab37b1$export$6ce3d58c8e774b83({
        staffList: staffList,
        subscriptionPeriod: newPeriod,
        organisationSubscription: organisationSubscription,
        organisationCountry: organisationCountry,
        isNewSubscription: false,
        currentBillingData: currentBillingData
    });
};
const $e99bb35521ab37b1$export$3d386fef38568a60 = ({ staffList: staffList, subscriptionPeriod: subscriptionPeriod, organisationCountry: organisationCountry, organisationSubscription: organisationSubscription = null })=>{
    return $e99bb35521ab37b1$export$6ce3d58c8e774b83({
        staffList: staffList,
        subscriptionPeriod: subscriptionPeriod,
        organisationSubscription: organisationSubscription,
        organisationCountry: organisationCountry,
        isNewSubscription: true
    });
};
function $e99bb35521ab37b1$export$1affc1dc8228eff2(result, period) {
    const errors = [];
    const warnings = [];
    // Validate payment display format order
    const requiredFields = [
        "amountDue",
        "discount",
        "tax",
        "credit",
        "grandTotal"
    ];
    for (const field of requiredFields)if (result[field] === undefined || result[field] === null) errors.push(`Missing required field: ${field}`);
    // Validate coupon logic according to PRD rules
    if (period === "monthly") // Monthly should not have default discounts unless specifically preserved
    {
        if (result.discount > 0 && result.couponInfo && result.couponInfo.reason && !result.couponInfo.reason.includes("preserved")) warnings.push(`Monthly billing has discount but may not follow PRD rules: ${result.couponInfo.reason}`);
    } else if (period === "yearly") // Yearly should have 15% discount unless a better coupon is preserved
    {
        if (result.discount === 0 && (!result.couponInfo || !result.couponInfo.reason.includes("better"))) warnings.push("Yearly billing missing expected 15% discount");
    }
    // Validate Total vs Credit Applied logic
    const shouldApplyCredit = result.credit > 0 && result.credit >= result.amountDue + result.tax + (result.adjustments || 0) - result.discount;
    const hasZeroTotal = result.grandTotal === 0;
    if (shouldApplyCredit && !hasZeroTotal) errors.push("Credit should cover entire amount but grandTotal is not zero");
    if (!shouldApplyCredit && hasZeroTotal && result.credit > 0) warnings.push("GrandTotal is zero but credit does not cover full amount");
    // Validate tax calculation percentage
    const subtotalAfterDiscounts = result.amountDue + (result.adjustments || 0) - result.discount;
    if (subtotalAfterDiscounts > 0 && result.tax > 0) {
        const taxPercentage = result.tax / subtotalAfterDiscounts * 100;
        if (taxPercentage < 0 || taxPercentage > 25) warnings.push(`Tax percentage (${taxPercentage.toFixed(1)}%) seems unusual`);
    }
    return {
        isValid: errors.length === 0,
        errors: errors,
        warnings: warnings
    };
}

});



parcelRegister("4xjoq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34d9498a992c166a$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("khJQv");

var $goLmS = parcelRequire("goLmS");

var $gUgf9 = parcelRequire("gUgf9");

var $1BTI2 = parcelRequire("1BTI2");

var $12o9H = parcelRequire("12o9H");

var $gjxeM = parcelRequire("gjxeM");

var $fJ4T4 = parcelRequire("fJ4T4");
parcelRequire("iOQGT");
parcelRequire("jRZYN");

var $htkeB = parcelRequire("htkeB");

var $iKbxs = parcelRequire("iKbxs");

var $4iw5i = parcelRequire("4iw5i");

var $kJfnW = parcelRequire("kJfnW");

var $3H03w = parcelRequire("3H03w");

var $3h7sC = parcelRequire("3h7sC");

var $hLTCx = parcelRequire("hLTCx");

var $kqlQp = parcelRequire("kqlQp");
const $34d9498a992c166a$var$unpaidInvoiceColumns = [
    {
        id: "label",
        label: "Unpaid Invoices",
        type: "text",
        width: 20,
        value: (row)=>{
            return row.name;
        }
    },
    {
        id: "date",
        label: "",
        type: "date",
        width: 15,
        value: (row)=>{
            return new Date(row.date);
        }
    },
    {
        id: "amount",
        label: "",
        type: "currency",
        width: 25,
        value: (row)=>{
            return row.amount;
        }
    },
    {
        id: "payButton",
        label: "",
        type: "text",
        width: 10,
        value: (row)=>{
            return "pay...";
        }
    }
];
const $34d9498a992c166a$var$paymentDetailColumns = [
    {
        id: "label",
        label: "Payment Details",
        type: "text",
        width: 20,
        value: (row)=>{
            return row.label;
        }
    },
    {
        id: "value",
        label: "",
        type: "text",
        width: 50,
        value: (row)=>{
            return row.value;
        },
        component: ({ value: value, stores: stores })=>{
            return value;
        }
    }
];
const $34d9498a992c166a$var$nextPaymentColumns = [
    {
        id: "label",
        label: "Next Payment",
        type: "text",
        width: 20,
        style: (row)=>({
                fontWeight: (row === null || row === void 0 ? void 0 : row.label) === "Total" ? "bold" : "normal"
            }),
        value: (row)=>{
            return row.label;
        }
    },
    {
        id: "percent",
        label: "",
        type: "text",
        width: 25,
        style: (row)=>({
                fontWeight: (row === null || row === void 0 ? void 0 : row.label) === "Total" ? "bold" : "normal"
            }),
        value: (row)=>{
            return row.percent;
        },
        component: ({ value: value, stores: stores })=>{
            const row = stores.row.rowObject;
            // Show "Remaining Credit" for total row when grand total is negative
            if (row.isTotal && row.amount && row.amount < 0) return /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                style: {
                    textAlign: "right",
                    fontStyle: "italic",
                    fontWeight: 400,
                    width: "100%"
                },
                children: "Remaining Credit"
            });
            return value || "";
        }
    },
    {
        id: "amount",
        label: "",
        type: "currency",
        format: (v)=>(0, $12o9H.FormatCurrency)(v),
        width: 25,
        style: (row)=>({
                fontWeight: (row === null || row === void 0 ? void 0 : row.label) === "Total" ? "bold" : "normal"
            }),
        value: (row)=>{
            return row.amount;
        },
        component: ({ value: value, formattedValue: formattedValue, stores: stores })=>{
            return value !== null ? formattedValue : "";
        }
    }
];
const $34d9498a992c166a$var$createStaffColumns = ()=>[
        {
            id: "label",
            label: "Staff Breakdown",
            type: "text",
            width: 20,
            style: (row)=>({
                    opacity: (row === null || row === void 0 ? void 0 : row.isBillable) === false ? 0.45 : 1,
                    color: (row === null || row === void 0 ? void 0 : row.isBillable) === false ? "#adb5bd" : "inherit"
                }),
            value: (row)=>{
                return `${row.index}. ${row.name}`;
            }
        },
        {
            id: "level",
            label: "",
            type: "text",
            width: 40,
            style: (row)=>({
                    opacity: (row === null || row === void 0 ? void 0 : row.isBillable) === false ? 0.45 : 1,
                    color: (row === null || row === void 0 ? void 0 : row.isBillable) === false ? "#adb5bd" : "inherit"
                }),
            value: (row)=>{
                return row.permissionLevel;
            },
            component: ({ value: value, stores: stores })=>{
                const row = stores.row.rowObject;
                const staffId = $34d9498a992c166a$var$findStaffIdByName(row.name);
                return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    style: {
                        display: "flex",
                        width: "100%",
                        textAlign: "right",
                        opacity: (row === null || row === void 0 ? void 0 : row.isBillable) === false ? 0.45 : 1
                    },
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            style: {
                                flex: "1 1 auto",
                                padding: "0 1em",
                                color: (row === null || row === void 0 ? void 0 : row.isBillable) === false ? "#adb5bd" : "inherit"
                            },
                            children: value
                        }),
                        staffId ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqlQp.Link), {
                            to: "/staff/$id",
                            params: {
                                id: staffId
                            },
                            search: {
                                tab: "permissions"
                            },
                            style: {
                                borderLeft: "solid 1px #eee",
                                padding: "0 1em",
                                flex: "0 0 auto",
                                textDecoration: "none",
                                color: (row === null || row === void 0 ? void 0 : row.isBillable) === false ? "#adb5bd" : "inherit"
                            },
                            children: "edit..."
                        }) : /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            style: {
                                borderLeft: "solid 1px #eee",
                                padding: "0 1em",
                                flex: "0 0 auto",
                                color: "#ccc",
                                cursor: "not-allowed"
                            },
                            children: "edit..."
                        })
                    ]
                });
            }
        },
        {
            id: "fee",
            label: "",
            type: "currency",
            width: 10,
            format: (v)=>(0, $12o9H.FormatCurrency)(v),
            style: (row)=>({
                    opacity: (row === null || row === void 0 ? void 0 : row.isBillable) === false ? 0.45 : 1,
                    color: (row === null || row === void 0 ? void 0 : row.isBillable) === false ? "#adb5bd" : "inherit"
                }),
            value: (row)=>{
                return row.fee;
            },
            component: ({ value: value, formattedValue: formattedValue, stores: stores })=>{
                return value !== null ? formattedValue : "";
            }
        }
    ];
// Mobile responsive utilities
const $34d9498a992c166a$var$isMobile = ()=>window.innerWidth <= 768;
const $34d9498a992c166a$var$useResponsiveStyles = ()=>{
    const [isMobileView, setIsMobileView] = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useState($34d9498a992c166a$var$isMobile());
    (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useEffect(()=>{
        const handleResize = ()=>setIsMobileView($34d9498a992c166a$var$isMobile());
        window.addEventListener("resize", handleResize);
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    return isMobileView;
};
// Helper function to find staff ID by name
const $34d9498a992c166a$var$findStaffIdByName = (staffName)=>{
    if (!staffName || !(0, $htkeB.default).staff) return null;
    // Find staff member by matching the name
    const staff = (0, $htkeB.default).staff.find((s)=>{
        const fullName = `${s.firstName || ""} ${s.lastName || ""}`.trim();
        return fullName === staffName.trim();
    });
    return (staff === null || staff === void 0 ? void 0 : staff.id) || null;
};
// Helper function to find full staff object by name
const $34d9498a992c166a$var$findStaffByName = (staffName)=>{
    if (!staffName || !(0, $htkeB.default).staff) return null;
    // Find staff member by matching the name
    const staff = (0, $htkeB.default).staff.find((s)=>{
        const fullName = `${s.firstName || ""} ${s.lastName || ""}`.trim();
        return fullName === staffName.trim();
    });
    return staff || null;
};
// Billing Period Toggle Component
const $34d9498a992c166a$var$BillingPeriodToggle = (0, $1EEMt.observer)(()=>{
    var _SessionStore$subscri, _SessionStore$subscri2;
    const currentPeriod = (0, $gUgf9.default).billingPeriod || ((_SessionStore$subscri = (0, $1BTI2.default).subscription) === null || _SessionStore$subscri === void 0 ? void 0 : _SessionStore$subscri.subscriptionPeriod) || "monthly";
    const hasSubscription = (_SessionStore$subscri2 = (0, $1BTI2.default).subscription) === null || _SessionStore$subscri2 === void 0 ? void 0 : _SessionStore$subscri2.hasSubscription;
    const isMobileView = $34d9498a992c166a$var$useResponsiveStyles();
    const handlePeriodChange = (newPeriod)=>{
        (0, $gUgf9.default).setBillingPeriod(newPeriod);
        // Trigger preview calculation when period changes
        (0, $gUgf9.default).calculatePreview();
    };
    const getPreviewMessage = ()=>{
        if (!(0, $gUgf9.default).billingPeriod) return null;
        if (!hasSubscription) {
            // New subscription scenario
            const savings = (0, $gUgf9.default).billingPeriod === "yearly" ? " (Save 15%)" : "";
            let totalText = "";
            if ((0, $gUgf9.default).subscriptionPreview) {
                const grandTotal = (0, $gUgf9.default).previewComputedGrandTotal;
                const preview = (0, $gUgf9.default).subscriptionPreview;
                if (grandTotal === 0 && preview.credit && Math.abs(preview.credit) > 0) {
                    // Credit covers the entire amount - show remaining credit to match table total
                    const remainingCredit = preview.remainingCredit || 0;
                    if (remainingCredit > 0) totalText = ` - Remaining Credit: ${(0, $12o9H.FormatCurrency)(remainingCredit)}`;
                    else totalText = ` - Credit Applied: ${(0, $12o9H.FormatCurrency)(Math.abs(preview.credit))}`;
                } else totalText = ` - Total: ${(0, $12o9H.FormatCurrency)(grandTotal)}`;
            }
            return {
                icon: "\uD83D\uDCB0",
                text: `${(0, $gUgf9.default).billingPeriod} subscription preview${savings}${totalText}`,
                type: "info",
                buttonText: "Subscribe Now"
            };
        } else if ((0, $gUgf9.default).billingPeriod !== (0, $1BTI2.default).subscription.subscriptionPeriod) {
            // Billing period change scenario
            const fromPeriod = (0, $1BTI2.default).subscription.subscriptionPeriod;
            const toPeriod = (0, $gUgf9.default).billingPeriod;
            const isUpgrade = toPeriod === "yearly";
            let totalText = "";
            if ((0, $gUgf9.default).subscriptionPreview) {
                const grandTotal = (0, $gUgf9.default).previewComputedGrandTotal;
                const preview = (0, $gUgf9.default).subscriptionPreview;
                if (grandTotal === 0 && preview.credit && Math.abs(preview.credit) > 0) {
                    // Credit covers the entire amount - show remaining credit to match table total
                    const remainingCredit = preview.remainingCredit || 0;
                    if (remainingCredit > 0) totalText = ` - Remaining Credit: ${(0, $12o9H.FormatCurrency)(remainingCredit)}`;
                    else totalText = ` - Credit Applied: ${(0, $12o9H.FormatCurrency)(Math.abs(preview.credit))}`;
                } else totalText = ` - New total: ${(0, $12o9H.FormatCurrency)(grandTotal)}`;
            }
            return {
                icon: isUpgrade ? "\uD83D\uDCC8" : "\uD83D\uDCC9",
                text: `Switch from ${fromPeriod} to ${toPeriod} billing${totalText}`,
                type: isUpgrade ? "upgrade" : "downgrade",
                buttonText: "Confirm Change",
                subtitle: isUpgrade ? "You'll be charged a prorated amount and save on future payments" : "You'll receive credit for unused time on your current plan"
            };
        }
        return null;
    };
    const previewMessage = getPreviewMessage();
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        style: {
            margin: "2em 0",
            padding: isMobileView ? "1em" : "1.5em",
            backgroundColor: "#f8f9fa",
            borderRadius: "8px",
            border: "1px solid #e9ecef"
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    display: "flex",
                    alignItems: isMobileView ? "flex-start" : "center",
                    justifyContent: "space-between",
                    flexDirection: isMobileView ? "column" : "row",
                    marginBottom: hasSubscription ? "1em" : "0.5em",
                    gap: isMobileView ? "1em" : "0"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            width: isMobileView ? "100%" : "auto"
                        },
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("h3", {
                                style: {
                                    margin: 0,
                                    fontSize: isMobileView ? "1em" : "1.1em",
                                    fontWeight: "600"
                                },
                                children: hasSubscription ? "Change Billing Period" : "Choose Billing Period"
                            }),
                            !hasSubscription && /*#__PURE__*/ (0, $61Ea1.jsx)("p", {
                                style: {
                                    margin: "0.5em 0 0 0",
                                    fontSize: isMobileView ? "0.8em" : "0.85em",
                                    color: "#6c757d",
                                    fontStyle: "italic"
                                },
                                children: "Select your preferred billing cycle and see the cost breakdown"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            display: "flex",
                            backgroundColor: "white",
                            border: "1px solid #dee2e6",
                            borderRadius: "6px",
                            overflow: "hidden",
                            width: isMobileView ? "100%" : "auto"
                        },
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                                style: {
                                    padding: isMobileView ? "0.75em 1em" : "0.5em 1em",
                                    border: "none",
                                    backgroundColor: currentPeriod === "monthly" ? "#007bff" : "white",
                                    color: currentPeriod === "monthly" ? "white" : "#495057",
                                    cursor: (0, $gUgf9.default).isFetchingPreview ? "not-allowed" : "pointer",
                                    fontSize: isMobileView ? "0.9em" : "0.9em",
                                    transition: "all 0.2s ease",
                                    opacity: (0, $gUgf9.default).isFetchingPreview ? 0.6 : 1,
                                    flex: isMobileView ? "1" : "none",
                                    whiteSpace: "nowrap"
                                },
                                onClick: ()=>handlePeriodChange("monthly"),
                                "aria-pressed": currentPeriod === "monthly",
                                disabled: (0, $gUgf9.default).isFetchingPreview,
                                children: (0, $gUgf9.default).isFetchingPreview && (0, $gUgf9.default).billingPeriod === "monthly" ? /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                                    style: {
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kJfnW.default), {}),
                                        /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                            style: {
                                                marginLeft: "0.5em"
                                            },
                                            children: isMobileView ? "Monthly" : "Monthly"
                                        })
                                    ]
                                }) : "Monthly"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                                style: {
                                    padding: isMobileView ? "0.75em 1em" : "0.5em 1em",
                                    border: "none",
                                    borderLeft: "1px solid #dee2e6",
                                    backgroundColor: currentPeriod === "yearly" ? "#007bff" : "white",
                                    color: currentPeriod === "yearly" ? "white" : "#495057",
                                    cursor: (0, $gUgf9.default).isFetchingPreview ? "not-allowed" : "pointer",
                                    fontSize: isMobileView ? "0.9em" : "0.9em",
                                    transition: "all 0.2s ease",
                                    opacity: (0, $gUgf9.default).isFetchingPreview ? 0.6 : 1,
                                    flex: isMobileView ? "1" : "none",
                                    whiteSpace: "nowrap"
                                },
                                onClick: ()=>handlePeriodChange("yearly"),
                                "aria-pressed": currentPeriod === "yearly",
                                disabled: (0, $gUgf9.default).isFetchingPreview,
                                children: (0, $gUgf9.default).isFetchingPreview && (0, $gUgf9.default).billingPeriod === "yearly" ? /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                                    style: {
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kJfnW.default), {}),
                                        /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                            style: {
                                                marginLeft: "0.5em"
                                            },
                                            children: isMobileView ? "Yearly" : "Yearly (Save 15%)"
                                        })
                                    ]
                                }) : isMobileView ? "Yearly (15%)" : "Yearly (Save 15%)"
                            })
                        ]
                    })
                ]
            }),
            (0, $gUgf9.default).isFetchingPreview && /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: isMobileView ? "0.75em" : "1em",
                    backgroundColor: "#e3f2fd",
                    border: "1px solid #bbdefb",
                    borderRadius: "4px",
                    fontSize: isMobileView ? "0.85em" : "0.9em",
                    color: "#1976d2"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kJfnW.default), {}),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                        style: {
                            marginLeft: "0.5em"
                        },
                        children: isMobileView ? "Calculating..." : "Calculating preview..."
                    })
                ]
            }),
            (0, $gUgf9.default).previewError && !(0, $gUgf9.default).isFetchingPreview && /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: isMobileView ? "0.75em" : "1em",
                    backgroundColor: "#ffebee",
                    border: "1px solid #ffcdd2",
                    borderRadius: "4px",
                    fontSize: isMobileView ? "0.85em" : "0.9em",
                    color: "#c62828"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                        style: {
                            marginRight: "0.5em"
                        },
                        children: "\u26A0\uFE0F"
                    }),
                    (0, $gUgf9.default).previewError
                ]
            }),
            previewMessage && !(0, $gUgf9.default).isFetchingPreview && /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    padding: isMobileView ? "0.75em" : "0.75em",
                    backgroundColor: previewMessage.type === "upgrade" ? "#e8f5e8" : previewMessage.type === "downgrade" ? "#fff3cd" : "#e3f2fd",
                    border: `1px solid ${previewMessage.type === "upgrade" ? "#c3e6c3" : previewMessage.type === "downgrade" ? "#ffeaa7" : "#bbdefb"}`,
                    borderRadius: "4px",
                    fontSize: isMobileView ? "0.85em" : "0.9em"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            display: "flex",
                            alignItems: isMobileView ? "flex-start" : "center",
                            justifyContent: "space-between",
                            flexDirection: isMobileView ? "column" : "row",
                            marginBottom: previewMessage.subtitle ? "0.5em" : "0",
                            gap: isMobileView ? "0.75em" : "0"
                        },
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                                style: {
                                    wordBreak: isMobileView ? "break-word" : "normal",
                                    lineHeight: "1.4"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                        style: {
                                            marginRight: "0.5em"
                                        },
                                        children: previewMessage.icon
                                    }),
                                    previewMessage.text
                                ]
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                                style: {
                                    padding: isMobileView ? "0.6em 1em" : "0.4em 0.8em",
                                    backgroundColor: previewMessage.type === "upgrade" ? "#28a745" : "#007bff",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "4px",
                                    cursor: (0, $gUgf9.default).isUpdatingSubscription ? "not-allowed" : "pointer",
                                    fontSize: isMobileView ? "0.9em" : "0.85em",
                                    fontWeight: "500",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    opacity: (0, $gUgf9.default).isUpdatingSubscription ? 0.7 : 1,
                                    width: isMobileView ? "100%" : "auto",
                                    minWidth: isMobileView ? "auto" : "120px"
                                },
                                onClick: ()=>hasSubscription ? (0, $gUgf9.default).confirmBillingPeriodChange() : (0, $gUgf9.default).startNewSubscription(),
                                disabled: (0, $gUgf9.default).isUpdatingSubscription,
                                children: (0, $gUgf9.default).isUpdatingSubscription ? /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kJfnW.default), {}),
                                        /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                            style: {
                                                marginLeft: "0.4em"
                                            },
                                            children: hasSubscription ? "Updating..." : "Processing..."
                                        })
                                    ]
                                }) : previewMessage.buttonText
                            })
                        ]
                    }),
                    previewMessage.subtitle && /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        style: {
                            fontSize: isMobileView ? "0.75em" : "0.8em",
                            color: "#6c757d",
                            fontStyle: "italic",
                            marginTop: "0.5em",
                            lineHeight: "1.3"
                        },
                        children: previewMessage.subtitle
                    })
                ]
            })
        ]
    });
});
// Preview Payment Table Columns (reusing existing styling)
const $34d9498a992c166a$var$previewPaymentColumns = [
    {
        id: "label",
        label: "Preview - Next Payment",
        type: "text",
        width: 20,
        style: (row)=>({
                fontWeight: (row === null || row === void 0 ? void 0 : row.label) === "Total" ? "bold" : "normal",
                fontStyle: "italic",
                color: "#6c757d"
            }),
        value: (row)=>{
            return row.label;
        }
    },
    {
        id: "percent",
        label: "",
        type: "text",
        width: 25,
        style: (row)=>({
                fontWeight: (row === null || row === void 0 ? void 0 : row.label) === "Total" ? "bold" : "normal",
                fontStyle: "italic",
                color: "#6c757d"
            }),
        value: (row)=>{
            return row.percent;
        },
        component: ({ value: value, stores: stores })=>{
            const row = stores.row.rowObject;
            // Show "Remaining Credit" for total row when grand total is negative
            if (row.isTotal && row.amount && row.amount < 0) return /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                style: {
                    textAlign: "right",
                    fontStyle: "italic",
                    fontWeight: 400,
                    width: "100%"
                },
                children: "Remaining Credit"
            });
            return value || "";
        }
    },
    {
        id: "amount",
        label: "",
        type: "currency",
        format: (v)=>(0, $12o9H.FormatCurrency)(v),
        width: 25,
        style: (row)=>({
                fontWeight: (row === null || row === void 0 ? void 0 : row.label) === "Total" ? "bold" : "normal",
                fontStyle: "italic",
                color: "#6c757d"
            }),
        value: (row)=>{
            return row.amount;
        },
        component: ({ value: value, formattedValue: formattedValue, stores: stores })=>{
            return value !== null ? formattedValue : "";
        }
    }
];
// Preview Staff Breakdown Columns (reusing existing styling)
const $34d9498a992c166a$var$createPreviewStaffColumns = ()=>[
        {
            id: "label",
            label: "Preview - Staff Breakdown",
            type: "text",
            width: 20,
            style: (row)=>({
                    opacity: (row === null || row === void 0 ? void 0 : row.isBillable) === false ? 0.45 : 1,
                    fontStyle: "italic",
                    color: (row === null || row === void 0 ? void 0 : row.isBillable) === false ? "#adb5bd" : "#6c757d"
                }),
            value: (row)=>{
                return `${row.index}. ${row.name}`;
            }
        },
        {
            id: "level",
            label: "",
            type: "text",
            width: 40,
            style: (row)=>({
                    opacity: (row === null || row === void 0 ? void 0 : row.isBillable) === false ? 0.45 : 1,
                    fontStyle: "italic",
                    color: (row === null || row === void 0 ? void 0 : row.isBillable) === false ? "#adb5bd" : "#6c757d"
                }),
            value: (row)=>{
                return row.billingLevel;
            },
            component: ({ value: value, stores: stores })=>{
                const row = stores.row.rowObject;
                const staffId = $34d9498a992c166a$var$findStaffIdByName(row.name);
                return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    style: {
                        display: "flex",
                        width: "100%",
                        textAlign: "right",
                        opacity: (row === null || row === void 0 ? void 0 : row.isBillable) === false ? 0.45 : 1
                    },
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            style: {
                                flex: "1 1 auto",
                                padding: "0 1em",
                                color: (row === null || row === void 0 ? void 0 : row.isBillable) === false ? "#adb5bd" : "#6c757d",
                                fontStyle: "italic"
                            },
                            children: value
                        }),
                        staffId ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqlQp.Link), {
                            to: "/staff/$id",
                            params: {
                                id: staffId
                            },
                            search: {
                                tab: "permissions"
                            },
                            style: {
                                borderLeft: "solid 1px #eee",
                                padding: "0 1em",
                                flex: "0 0 auto",
                                textDecoration: "none",
                                color: (row === null || row === void 0 ? void 0 : row.isBillable) === false ? "#adb5bd" : "#6c757d",
                                fontStyle: "italic"
                            },
                            children: "edit..."
                        }) : /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            style: {
                                borderLeft: "solid 1px #eee",
                                padding: "0 1em",
                                flex: "0 0 auto",
                                color: "#ccc",
                                cursor: "not-allowed",
                                fontStyle: "italic"
                            },
                            children: "edit..."
                        })
                    ]
                });
            }
        },
        {
            id: "fee",
            label: "",
            type: "currency",
            width: 10,
            format: (v)=>(0, $12o9H.FormatCurrency)(v),
            style: (row)=>({
                    opacity: (row === null || row === void 0 ? void 0 : row.isBillable) === false ? 0.45 : 1,
                    fontStyle: "italic",
                    color: (row === null || row === void 0 ? void 0 : row.isBillable) === false ? "#adb5bd" : "#6c757d"
                }),
            value: (row)=>{
                return row.fee;
            },
            component: ({ value: value, formattedValue: formattedValue, stores: stores })=>{
                return value !== null ? formattedValue : "";
            }
        }
    ];
// Preview Table Component
const $34d9498a992c166a$var$BillingPreviewTable = (0, $1EEMt.observer)(()=>{
    var _SessionStore$subscri3;
    const previewData = (0, $gUgf9.default).subscriptionPreview;
    const hasSubscription = (_SessionStore$subscri3 = (0, $1BTI2.default).subscription) === null || _SessionStore$subscri3 === void 0 ? void 0 : _SessionStore$subscri3.hasSubscription;
    const isMobileView = $34d9498a992c166a$var$useResponsiveStyles();
    if (!previewData || !(0, $gUgf9.default).showPreview) return null;
    // Show loading state if preview is being fetched
    if ((0, $gUgf9.default).isFetchingPreview) return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        style: {
            border: "2px dashed #007bff",
            borderRadius: "8px",
            padding: isMobileView ? "1.5em" : "2em",
            margin: isMobileView ? "1em 0" : "2em 0",
            backgroundColor: "#f8f9fa",
            textAlign: "center"
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kJfnW.default), {}),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    color: "#6c757d",
                    fontStyle: "italic",
                    fontSize: isMobileView ? "0.85em" : "1em",
                    marginTop: "0.5em"
                },
                children: isMobileView ? "Calculating..." : "Calculating billing preview..."
            })
        ]
    });
    const previewPaymentRows = [
        {
            label: "Date",
            percent: previewData.nextPaymentDate ? (0, $fJ4T4.FormatDate)(new Date(previewData.nextPaymentDate)) : null,
            amount: null
        },
        {
            label: "Amount Due",
            percent: "",
            amount: previewData.amountDue
        },
        previewData.discount ? {
            label: "Discount",
            percent: previewData.amountDue > 0 ? (0, $gjxeM.FormatPercent)(previewData.discount / previewData.amountDue) : "",
            amount: previewData.discount * -1
        } : null,
        previewData.adjustments && Math.abs(previewData.adjustments) > 0.01 ? {
            label: "Adjustments",
            percent: "",
            amount: previewData.adjustments
        } : null,
        previewData.tax && previewData.tax !== 0 ? {
            label: "Tax",
            percent: (0, $gUgf9.default).previewComputedGrandTotal !== 0 && previewData.amountDue + (previewData.adjustments || 0) - (previewData.discount || 0) !== 0 ? (0, $gjxeM.FormatPercent)(previewData.tax / (previewData.amountDue + (previewData.adjustments || 0) - (previewData.discount || 0))) : "",
            amount: previewData.tax
        } : null,
        // Show credit if available (from preview data which includes actual customer credit balance)
        previewData.credit && previewData.credit !== 0 ? {
            label: "Credit",
            percent: "",
            amount: -Math.abs(previewData.credit)
        } : null,
        {
            label: "Total",
            percent: "",
            amount: (0, $gUgf9.default).previewComputedGrandTotal,
            // Special handling for credit scenarios
            isTotal: true,
            creditApplied: previewData.credit && (0, $gUgf9.default).previewComputedGrandTotal <= 0 ? (()=>{
                // Calculate how much credit is actually being applied
                const subtotal = previewData.amountDue + (previewData.tax || 0) + (previewData.adjustments || 0) - (previewData.discount || 0);
                const availableCredit = Math.abs(previewData.credit);
                return Math.min(availableCredit, subtotal);
            })() : null,
            remainingCredit: previewData.remainingCredit || 0
        }
    ].filter((r)=>r);
    const previewStaffRows = (previewData.staffBreakdown || []).slice().sort((a, b)=>{
        // Sort by billing level first (admin, standard, none)
        const levelOrder = {
            admin: 0,
            standard: 1,
            none: 2
        };
        const levelDiff = levelOrder[a.billingLevel] - levelOrder[b.billingLevel];
        if (levelDiff !== 0) return levelDiff;
        // Then sort alphabetically by name within each level
        return a.name.localeCompare(b.name);
    }).map((s, i)=>({
            ...s,
            index: i + 1,
            // Ensure staff property is available for edit button
            staff: s.staff || $34d9498a992c166a$var$findStaffByName(s.name)
        }));
    // Generate appropriate title based on scenario
    const getPreviewTitle = ()=>{
        const basePeriod = (0, $gUgf9.default).billingPeriod || "monthly";
        if (!hasSubscription) return isMobileView ? `\u{1F4B0} ${basePeriod} preview` : `\u{1F4B0} Preview: ${basePeriod} subscription`;
        else {
            const currentPeriod = (0, $1BTI2.default).subscription.subscriptionPeriod;
            const newPeriod = (0, $gUgf9.default).billingPeriod;
            if (newPeriod === currentPeriod) return isMobileView ? `\u{1F441}\u{FE0F} Current billing` : `\u{1F441}\u{FE0F} Current: ${currentPeriod} billing`;
            else {
                const isUpgrade = newPeriod === "yearly";
                return isMobileView ? `${isUpgrade ? "\uD83D\uDCC8" : "\uD83D\uDCC9"} Switch to ${newPeriod}` : `${isUpgrade ? "\uD83D\uDCC8" : "\uD83D\uDCC9"} Preview: switching to ${newPeriod} billing`;
            }
        }
    };
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        style: {
            opacity: 0.85,
            border: "2px dashed #007bff",
            borderRadius: "8px",
            padding: isMobileView ? "0.75em" : "1em",
            margin: isMobileView ? "1em 0" : "2em 0",
            backgroundColor: "#f8f9fa",
            overflow: "hidden"
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "1em",
                    color: "#007bff",
                    fontWeight: "600",
                    fontSize: isMobileView ? "0.9em" : "1em"
                },
                children: getPreviewTitle()
            }),
            !hasSubscription && /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    fontSize: isMobileView ? "0.8em" : "0.85em",
                    color: "#6c757d",
                    fontStyle: "italic",
                    marginBottom: "1em",
                    padding: isMobileView ? "0.5em" : "0.5em",
                    backgroundColor: "#ffffff",
                    borderRadius: "4px",
                    border: "1px solid #e9ecef",
                    lineHeight: "1.4"
                },
                children: [
                    "\uD83D\uDCA1",
                    " ",
                    isMobileView ? "What you'll pay when subscribing" : "This shows what you'll be charged when you subscribe.",
                    (0, $gUgf9.default).billingPeriod === "yearly" && (isMobileView ? " 15% savings!" : " Save 15% with yearly billing!")
                ]
            }),
            hasSubscription && (0, $gUgf9.default).billingPeriod !== (0, $1BTI2.default).subscription.subscriptionPeriod && /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    style: {
                        fontSize: isMobileView ? "0.8em" : "0.85em",
                        color: "#6c757d",
                        fontStyle: "italic",
                        marginBottom: "1em",
                        padding: isMobileView ? "0.5em" : "0.5em",
                        backgroundColor: "#ffffff",
                        borderRadius: "4px",
                        border: "1px solid #e9ecef",
                        lineHeight: "1.4"
                    },
                    children: [
                        "\u26A1",
                        " ",
                        isMobileView ? "Includes prorations from current cycle" : "This preview includes prorations and adjustments from your current billing cycle."
                    ]
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    overflowX: isMobileView ? "auto" : "visible",
                    marginLeft: isMobileView ? "-0.75em" : "0",
                    marginRight: isMobileView ? "-0.75em" : "0",
                    paddingLeft: isMobileView ? "0.75em" : "0",
                    paddingRight: isMobileView ? "0.75em" : "0"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
                        style: {
                            margin: "1em 0",
                            minWidth: isMobileView ? "300px" : "auto",
                            fontSize: isMobileView ? "0.85em" : "1em"
                        },
                        columns: $34d9498a992c166a$var$previewPaymentColumns,
                        rows: previewPaymentRows
                    }),
                    previewStaffRows.length > 0 && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
                        style: {
                            margin: "1em 0",
                            minWidth: isMobileView ? "300px" : "auto",
                            fontSize: isMobileView ? "0.85em" : "1em"
                        },
                        columns: $34d9498a992c166a$var$createPreviewStaffColumns(),
                        rows: previewStaffRows
                    })
                ]
            })
        ]
    });
});
// Fresh Receipt Email Component
const $34d9498a992c166a$var$FreshReceiptEmail = (0, $1EEMt.observer)(()=>{
    const receiptEmail = (0, $gUgf9.default).receiptEmail;
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        children: receiptEmail || /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
            style: {
                color: "#6c757d",
                fontStyle: "italic"
            },
            children: "No receipt email set"
        })
    });
});
// Fresh Credit Balance Component
const $34d9498a992c166a$var$FreshCreditBalance = (0, $1EEMt.observer)(()=>{
    const creditBalance = (0, $gUgf9.default).creditBalance;
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        children: (0, $12o9H.FormatCurrency)(creditBalance || 0, {
            decimals: 2
        })
    });
});
// Payment Method Row Component with fresh Stripe data
const $34d9498a992c166a$var$PaymentMethodRow = (0, $1EEMt.observer)(()=>{
    const paymentMethods = (0, $gUgf9.default).paymentMethods;
    const formatPaymentMethod = (method)=>{
        const methodType = method.type.replace(/_/g, " ").toUpperCase();
        if (method.type === "card") {
            var _method$cardBrand;
            return {
                type: ((_method$cardBrand = method.cardBrand) === null || _method$cardBrand === void 0 ? void 0 : _method$cardBrand.toUpperCase()) || "CARD",
                last4: method.cardLast4,
                expiry: method.cardExpMonth && method.cardExpYear ? `${method.cardExpMonth.toString().padStart(2, "0")}/${method.cardExpYear}` : null
            };
        } else if (method.type === "au_becs_debit") return {
            type: "BECS DEBIT",
            last4: method.becsLast4,
            expiry: null
        };
        else if (method.type === "us_bank_account") {
            var _method$bankAccountTy;
            return {
                type: `${((_method$bankAccountTy = method.bankAccountType) === null || _method$bankAccountTy === void 0 ? void 0 : _method$bankAccountTy.toUpperCase()) || "BANK"} ACCOUNT`,
                last4: method.bankLast4,
                expiry: method.bankRoutingNumber ? `Routing: ...${method.bankRoutingNumber.slice(-4)}` : null
            };
        } else return {
            type: methodType,
            last4: null,
            expiry: null
        };
    };
    if (!(paymentMethods !== null && paymentMethods !== void 0 && paymentMethods.length)) return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        style: {
            color: "#6c757d",
            fontStyle: "italic"
        },
        children: "No payment methods found"
    });
    // Find the default payment method
    const defaultMethod = paymentMethods.find((pm)=>pm.isDefault) || paymentMethods[0];
    const formatted = formatPaymentMethod(defaultMethod);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        style: {
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center"
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    fontWeight: "500"
                },
                children: formatted.type
            }),
            formatted.last4 && /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    borderLeft: "solid 1px #eee",
                    padding: "0 1em"
                },
                children: [
                    "...",
                    formatted.last4
                ]
            }),
            formatted.expiry && /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    borderLeft: "solid 1px #eee",
                    padding: "0 1em"
                },
                children: formatted.expiry
            }),
            paymentMethods.length > 1 && /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    borderLeft: "solid 1px #eee",
                    padding: "0 1em",
                    fontSize: "0.85em",
                    color: "#6c757d"
                },
                children: [
                    "+",
                    paymentMethods.length - 1,
                    " more"
                ]
            })
        ]
    });
});
// Billing Portal Button Component
const $34d9498a992c166a$var$BillingPortalButton = (0, $1EEMt.observer)(()=>{
    const [isCreatingPortalSession, setIsCreatingPortalSession] = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useState(false);
    const isMobileView = $34d9498a992c166a$var$useResponsiveStyles();
    const handleBillingPortalClick = async ()=>{
        try {
            var _SessionStore$organis;
            setIsCreatingPortalSession(true);
            // Track billing portal session creation attempt
            (0, $3H03w.default).capture("billing_portal_session_creation_started", {
                organisationId: (_SessionStore$organis = (0, $1BTI2.default).organisation) === null || _SessionStore$organis === void 0 ? void 0 : _SessionStore$organis.id
            });
            // Create billing portal session using tRPC
            const result = await (0, $3h7sC.trpc).legacy.createBillingPortalSession.mutate({});
            if (result.success && result.sessionUrl) {
                var _SessionStore$organis2;
                // Track successful session creation
                (0, $3H03w.default).capture("billing_portal_session_created", {
                    sessionId: result.sessionId,
                    organisationId: (_SessionStore$organis2 = (0, $1BTI2.default).organisation) === null || _SessionStore$organis2 === void 0 ? void 0 : _SessionStore$organis2.id
                });
                // Redirect to Stripe Billing Portal
                window.location.href = result.sessionUrl;
            } else throw new Error("Failed to create billing portal session");
        } catch (error) {
            var _SessionStore$organis3;
            console.error("Error creating billing portal session:", error);
            // Track billing portal session creation failure
            (0, $3H03w.default).capture("billing_portal_session_creation_failed", {
                error: error.message,
                organisationId: (_SessionStore$organis3 = (0, $1BTI2.default).organisation) === null || _SessionStore$organis3 === void 0 ? void 0 : _SessionStore$organis3.id
            });
            $iKbxs.captureException(error);
            (0, $3H03w.default).captureException(error);
            // Show user-friendly error message
            alert("Failed to open billing portal. Please try again.");
            setIsCreatingPortalSession(false);
        }
    };
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        style: {
            margin: isMobileView ? "1.5em 0" : "2em 0",
            padding: isMobileView ? "1em" : "1.5em",
            backgroundColor: "#f8f9fa",
            border: "1px solid #e9ecef",
            borderRadius: "8px",
            textAlign: "center"
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    marginBottom: "1em",
                    fontSize: isMobileView ? "0.9em" : "1em",
                    color: "#6c757d"
                },
                children: "Need to manage your billing details, view invoices, or update payment methods?"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                style: {
                    padding: isMobileView ? "0.75em 1.5em" : "0.8em 2em",
                    backgroundColor: "#007bff",
                    color: "white",
                    border: "none",
                    borderRadius: "6px",
                    cursor: isCreatingPortalSession ? "not-allowed" : "pointer",
                    fontSize: isMobileView ? "0.9em" : "1em",
                    fontWeight: "500",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    opacity: isCreatingPortalSession ? 0.7 : 1,
                    margin: "0 auto",
                    minWidth: isMobileView ? "200px" : "220px",
                    transition: "all 0.2s ease"
                },
                onClick: handleBillingPortalClick,
                disabled: isCreatingPortalSession,
                onMouseOver: (e)=>{
                    if (!isCreatingPortalSession) e.target.style.backgroundColor = "#0056b3";
                },
                onMouseOut: (e)=>{
                    if (!isCreatingPortalSession) e.target.style.backgroundColor = "#007bff";
                },
                children: isCreatingPortalSession ? /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kJfnW.default), {}),
                        /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                            style: {
                                marginLeft: "0.5em"
                            },
                            children: "Opening Portal..."
                        })
                    ]
                }) : /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hLTCx.default), {
                            size: 18,
                            style: {
                                marginRight: "0.5em"
                            }
                        }),
                        "Open Billing Portal"
                    ]
                })
            })
        ]
    });
});
var $34d9498a992c166a$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(()=>{
    var _SessionStore$subscri4;
    if (!(0, $1BTI2.default).subscription) return null;
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "mx-auto",
        children: [
            (0, $gUgf9.default).isSubscribing ? /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    height: "100%",
                    position: "fixed",
                    left: 0,
                    width: "100%",
                    background: "#FFFFFFaa",
                    textAlign: "center",
                    zIndex: 1050
                },
                children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    style: {
                        backgroundColor: "white",
                        width: "30rem",
                        height: "20rem",
                        display: "inline-flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "1rem",
                        boxShadow: "0 0 2rem #00000033"
                    },
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $4iw5i.default), {}),
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            style: {
                                fontWeight: "bold",
                                marginTop: "-1em",
                                zIndex: 100
                            },
                            children: "Processing Subscription"
                        })
                    ]
                })
            }) : null,
            (0, $1BTI2.default).subscription.hasSubscription && /*#__PURE__*/ (0, $61Ea1.jsx)($34d9498a992c166a$var$BillingPortalButton, {}),
            /*#__PURE__*/ (0, $61Ea1.jsx)($34d9498a992c166a$var$BillingPeriodToggle, {}),
            /*#__PURE__*/ (0, $61Ea1.jsx)($34d9498a992c166a$var$BillingPreviewTable, {}),
            (0, $1BTI2.default).subscription.hasSubscription ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
                style: {
                    margin: "3em 0"
                },
                columns: $34d9498a992c166a$var$paymentDetailColumns,
                rows: [
                    {
                        label: "Organisation",
                        value: (0, $1BTI2.default).organisation.name
                    },
                    {
                        label: "Card",
                        value: /*#__PURE__*/ (0, $61Ea1.jsx)($34d9498a992c166a$var$PaymentMethodRow, {})
                    },
                    {
                        label: "Receipt Email",
                        value: /*#__PURE__*/ (0, $61Ea1.jsx)($34d9498a992c166a$var$FreshReceiptEmail, {})
                    },
                    {
                        label: "Credit",
                        value: /*#__PURE__*/ (0, $61Ea1.jsx)($34d9498a992c166a$var$FreshCreditBalance, {})
                    }
                ]
            }) : null,
            (_SessionStore$subscri4 = (0, $1BTI2.default).subscription.unpaidInvoices) !== null && _SessionStore$subscri4 !== void 0 && _SessionStore$subscri4.length ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
                style: {
                    margin: "3em 0"
                },
                columns: $34d9498a992c166a$var$unpaidInvoiceColumns,
                rows: (0, $1BTI2.default).subscription.unpaidInvoices
            }) : null,
            !(0, $gUgf9.default).shouldShowPreview && /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
                        style: {
                            margin: "3em 0"
                        },
                        columns: $34d9498a992c166a$var$nextPaymentColumns,
                        rows: [
                            {
                                label: "Date",
                                percent: (0, $gUgf9.default).nextPaymentDate ? (0, $fJ4T4.FormatDate)(new Date((0, $gUgf9.default).nextPaymentDate)) : null,
                                amount: null
                            },
                            {
                                label: "Amount Due",
                                percent: "",
                                amount: (0, $gUgf9.default).amountDue
                            },
                            (0, $gUgf9.default).discount ? {
                                label: "Discount",
                                percent: (0, $gUgf9.default).amountDue > 0 ? (0, $gjxeM.FormatPercent)((0, $gUgf9.default).discount / (0, $gUgf9.default).amountDue) : "",
                                amount: (0, $gUgf9.default).discount * -1
                            } : null,
                            (0, $gUgf9.default).adjustments && Math.abs((0, $gUgf9.default).adjustments) > 0.01 ? {
                                label: "Adjustments",
                                percent: "",
                                amount: (0, $gUgf9.default).adjustments
                            } : null,
                            (0, $gUgf9.default).tax && (0, $gUgf9.default).tax !== 0 ? {
                                label: "Tax",
                                percent: (0, $gUgf9.default).computedGrandTotal !== 0 && (0, $gUgf9.default).amountDue + ((0, $gUgf9.default).adjustments || 0) - ((0, $gUgf9.default).discount || 0) !== 0 ? (0, $gjxeM.FormatPercent)((0, $gUgf9.default).tax / ((0, $gUgf9.default).amountDue + ((0, $gUgf9.default).adjustments || 0) - ((0, $gUgf9.default).discount || 0))) : "",
                                amount: (0, $gUgf9.default).tax
                            } : null,
                            (0, $gUgf9.default).credit && (0, $gUgf9.default).credit !== 0 ? {
                                label: "Credit",
                                percent: "",
                                amount: -Math.abs((0, $gUgf9.default).credit)
                            } : null,
                            {
                                label: "Total",
                                percent: "",
                                amount: (0, $gUgf9.default).computedGrandTotal,
                                // Special handling for credit scenarios
                                isTotal: true,
                                creditApplied: (0, $gUgf9.default).credit && (0, $gUgf9.default).computedGrandTotal === 0 ? (()=>{
                                    // Calculate how much credit is actually being applied
                                    const subtotal = (0, $gUgf9.default).amountDue + ((0, $gUgf9.default).tax || 0) + ((0, $gUgf9.default).adjustments || 0) - ((0, $gUgf9.default).discount || 0);
                                    const availableCredit = Math.abs((0, $gUgf9.default).credit);
                                    return Math.min(availableCredit, subtotal);
                                })() : null,
                                // Use server-provided remainingCredit value
                                remainingCredit: (0, $gUgf9.default).remainingCredit || 0
                            }
                        ].filter((r)=>r)
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
                        style: {
                            margin: "3em 0"
                        },
                        columns: $34d9498a992c166a$var$createStaffColumns(),
                        rows: (0, $gUgf9.default).computedStaffBreakdown.slice().sort((a, b)=>{
                            // Sort by billing level first (admin, standard, none)
                            const levelOrder = {
                                admin: 0,
                                standard: 1,
                                none: 2
                            };
                            const levelDiff = levelOrder[a.billingLevel] - levelOrder[b.billingLevel];
                            if (levelDiff !== 0) return levelDiff;
                            // Then sort alphabetically by name within each level
                            return a.name.localeCompare(b.name);
                        }).map((s, i)=>({
                                ...s,
                                index: i + 1,
                                fullName: s.name,
                                permissionLevel: s.billingLevel,
                                // Add staff object for edit functionality
                                staff: $34d9498a992c166a$var$findStaffByName(s.name)
                            }))
                    })
                ]
            })
        ]
    });
});

});
parcelRegister("jRZYN", function(module, exports) {

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("eat5C");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $fEcKX = parcelRequire("fEcKX");

var $1BTI2 = parcelRequire("1BTI2");

var $fM2j4 = parcelRequire("fM2j4");

var $foLWS = parcelRequire("foLWS");
var $e7730b68a72af6a5$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ modalId: modalId })=>{
    const [email, setEmail] = (0, $jbmdS.useState)((0, $1BTI2.default).subscription.receiptEmail);
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fEcKX.default), {
        modalId: modalId,
        heading: "Update Billing Email",
        saveLabel: "Save Email",
        style: {
            minHeight: "5em"
        },
        onSave: ()=>{
            (0, $1BTI2.default).subscription.update({
                receiptEmail: email
            });
            (0, $fM2j4.default).saveModel((0, $1BTI2.default).subscription);
        },
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $foLWS.default), {
            style: {
                width: "100%"
            },
            value: email,
            onChange: (v)=>setEmail(v)
        })
    });
});

});

parcelRegister("hLTCx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf01f88767187446$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $cf01f88767187446$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("CreditCard", [
    [
        "rect",
        {
            width: "20",
            height: "14",
            x: "2",
            y: "5",
            rx: "2",
            key: "ynyp8z"
        }
    ],
    [
        "line",
        {
            x1: "2",
            x2: "22",
            y1: "10",
            y2: "10",
            key: "1b3vmo"
        }
    ]
]);

});



parcelRegister("613DC", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $4615a87f5ced7de7$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");

var $kuPRw = parcelRequire("kuPRw");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $7qobO = parcelRequire("7qobO");

var $4pujq = parcelRequire("4pujq");

var $lqn89 = parcelRequire("lqn89");

var $rddxB = parcelRequire("rddxB");

var $4iw5i = parcelRequire("4iw5i");

var $5PXcS = parcelRequire("5PXcS");

var $26sX2 = parcelRequire("26sX2");

var $kqntg = parcelRequire("kqntg");
const $4615a87f5ced7de7$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_private/timesheets/")({
    beforeLoad: ({ params: params, search: search })=>{
        var _tabs$find;
        const activeTabId = (search === null || search === void 0 ? void 0 : search.tab) || "weekly";
        if (!(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "timesheets", params) || !(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, `timesheets-${activeTabId}`, params)) throw new Error("Permission Denied");
        const tabs = [
            {
                label: "Weekly",
                id: "weekly"
            },
            {
                label: "Daily",
                id: "daily"
            }
        ];
        const activeTabLabel = (_tabs$find = tabs.find((tab)=>tab.id === activeTabId)) === null || _tabs$find === void 0 ? void 0 : _tabs$find.label;
        (0, $26sX2.setLayoutDefaults)({
            pageTitle: `${activeTabLabel} Timesheets`,
            subMenu: "time",
            tabs: tabs
        });
    },
    loaderDeps: ({ search: { tab: tab, date: date, staffId: staffId } })=>({
            tab: tab,
            date: date,
            staffId: staffId
        }),
    errorComponent: ({ error: error, reset: reset })=>{
        if (error.message === "Permission Denied") return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7qobO.default), {});
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    },
    component: $4615a87f5ced7de7$var$Wrapper,
    pendingComponent: (0, $4iw5i.default)
});
function $4615a87f5ced7de7$var$Wrapper() {
    const { tab: tab, date: date, staffId: staffId } = $4615a87f5ced7de7$export$e7b0ac011bb776c6.useSearch();
    const params = $4615a87f5ced7de7$export$e7b0ac011bb776c6.useParams();
    const activeTab = tab || "weekly";
    const tabs = {
        daily: {
            label: "Daily",
            id: "daily",
            page: ({ date: date, staffId: staffId })=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $4pujq.default), {
                    date: date,
                    staffId: staffId
                }),
            permissions: ()=>(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, `timesheets-daily`, params)
        },
        weekly: {
            label: "Weekly",
            id: "weekly",
            page: ({ date: date, staffId: staffId })=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $rddxB.default), {
                    date: date,
                    staffId: staffId
                }),
            permissions: ()=>(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, `timesheets-weekly`, params)
        }
    };
    if ((0, $8kZ1o.migratedToV2)()) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqntg.CenterPadPageBody), {
        className: "pt-0",
        children: tabs[activeTab].page(params)
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $lqn89.default), {
                tabs: Object.values(tabs).filter((tab)=>tab.permissions()),
                selectedTab: activeTab,
                date: date,
                staffId: staffId
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kuPRw.default), {
                style: {
                    paddingTop: 0
                },
                children: tabs[activeTab].page({
                    date: date,
                    staffId: staffId
                })
            })
        ]
    });
}

});
parcelRegister("4pujq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3361029cf99b7f87$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $02LyB = parcelRequire("02LyB");

var $4hBm1 = parcelRequire("4hBm1");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("eNcHX");

var $QiMYe = parcelRequire("QiMYe");

var $1BTI2 = parcelRequire("1BTI2");
parcelRequire("fEtu5");
var $y5iig = parcelRequire("y5iig");

var $hP0jf = parcelRequire("hP0jf");

var $e8Hda = parcelRequire("e8Hda");

var $eat5C = parcelRequire("eat5C");

var $khJQv = parcelRequire("khJQv");

var $aRbBG = parcelRequire("aRbBG");
parcelRequire("jsc4w");

var $fM2j4 = parcelRequire("fM2j4");

var $eZxCg = parcelRequire("eZxCg");
parcelRequire("hfd05");

var $iuzpK = parcelRequire("iuzpK");
parcelRequire("hkQhK");

var $ax8Km = parcelRequire("ax8Km");

var $6RcUP = parcelRequire("6RcUP");

var $4iw5i = parcelRequire("4iw5i");
parcelRequire("jE5CX");

var $8kZ1o = parcelRequire("8kZ1o");
parcelRequire("1vY7H");

var $XoImS = parcelRequire("XoImS");

var $f44xu = parcelRequire("f44xu");
parcelRequire("jYjJH");
parcelRequire("6Q5sp");

var $6UBLf = parcelRequire("6UBLf");

var $3h7sC = parcelRequire("3h7sC");

var $47i9t = parcelRequire("47i9t");
var $3361029cf99b7f87$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ date: date, staffId: staffId })=>{
    var _date;
    (_date = date) !== null && _date !== void 0 ? _date : date = (0, $4hBm1.format)(new Date(), "yyyy-MM-dd");
    const [store, setStore] = (0, $jbmdS.useState)((0, $hP0jf.default));
    (0, $jbmdS.useEffect)(()=>{
        store.setSearchParams({
            date: date,
            staffId: staffId
        });
    }, [
        date,
        staffId
    ]);
    (0, $jbmdS.useEffect)(()=>{
        (0, $fM2j4.default).setAutosave(true);
        // TimeEntryCollection.clear()
        // TimeEntryAggregateCollection.clear()
        // store.reset()
        return ()=>(0, $fM2j4.default).setAutosave(false);
    }, []);
    const startDate = (0, $4hBm1.format)((0, $4hBm1.startOfWeek)(new Date(date), {
        weekStartsOn: 1
    }), "yyyy-MM-dd");
    const endDate = (0, $4hBm1.format)((0, $4hBm1.endOfWeek)(new Date(date), {
        weekStartsOn: 1
    }), "yyyy-MM-dd");
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "max-w-[1040px] mx-auto mb-auto w-[1040px]",
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)($3361029cf99b7f87$var$TimesheetNav, {
                monday: store.startOfWeek,
                dayTotals: store.dailyTotals,
                selectedDate: store.date,
                store: store
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6RcUP.default), {
                queryIds: [
                    {
                        queryKey: [
                            "timesheets-weekly",
                            startDate,
                            staffId
                        ],
                        queryFn: async ()=>{
                            const result = await (0, $3h7sC.trpc).legacy.getTimesheetData.query({
                                startDate: startDate,
                                endDate: endDate,
                                staffId: store.staffId,
                                autoPopulate: (0, $8kZ1o.shouldAutoPopulatePhasesInTimesheets)()
                            });
                            return (0, $47i9t.processTRPCData)(result);
                        },
                        cacheTime: 0,
                        staleTime: 0
                    }
                ],
                loading: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    style: {
                        padding: "8em"
                    },
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $4iw5i.default), {})
                }),
                children: /*#__PURE__*/ (0, $61Ea1.jsx)($3361029cf99b7f87$var$TimesheetRows, {
                    store: store
                })
            })
        ]
    });
});
const $3361029cf99b7f87$var$TimesheetRows = (0, $1EEMt.observer)(({ store: store })=>{
    (0, $jbmdS.useEffect)(()=>{
        if (!(0, $8kZ1o.shouldAutoPopulatePhasesInTimesheets)()) return;
        store.timeEntries.forEach((te)=>{
            if ((0, $8kZ1o.canEnterTimeAgainstPhase)(store.staff || (0, $1BTI2.default).user, te.phase)) te.update({
                isLocked: false
            }, {
                trackUpdates: false
            });
        });
        const existingPhases = new Set(Object.keys(store.rowsByPhaseId));
        const phasesToAdd = new Set();
        (0, $XoImS.default).phases.forEach((ph)=>{
            if (existingPhases.has(String((0, $f44xu.default)(ph === null || ph === void 0 ? void 0 : ph.projectId, ph === null || ph === void 0 ? void 0 : ph.id)))) return;
            if ((0, $8kZ1o.autoPopulatePhaseInTimesheets)(store.staff || (0, $1BTI2.default).user, ph) && (0, $8kZ1o.canEnterTimeAgainstPhase)(store.staff || (0, $1BTI2.default).user, ph)) phasesToAdd.add(ph);
        });
        store.addExtraTime([
            ...phasesToAdd
        ].map((ph)=>{
            var _ph$project, _ph$defaultTask, _ph$defaultTask2, _ph$defaultTask3;
            return (0, $QiMYe.default).add({
                costCentreId: (_ph$project = ph.project) === null || _ph$project === void 0 ? void 0 : _ph$project.costCentreId,
                projectId: ph.projectId,
                phaseId: ph === null || ph === void 0 ? void 0 : ph.id,
                staffId: (store === null || store === void 0 ? void 0 : store.staffId) || (0, $1BTI2.default).userId,
                taskId: (_ph$defaultTask = ph.defaultTask) === null || _ph$defaultTask === void 0 ? void 0 : _ph$defaultTask.id,
                isBillable: (_ph$defaultTask2 = ph.defaultTask) === null || _ph$defaultTask2 === void 0 ? void 0 : _ph$defaultTask2.isBillable,
                isVariation: (_ph$defaultTask3 = ph.defaultTask) === null || _ph$defaultTask3 === void 0 ? void 0 : _ph$defaultTask3.isVariation,
                date: store.date,
                numMinutes: 0
            }, {
                trackUpdates: true
            });
        }));
    }, [
        store
    ]);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "mt-8",
        children: [
            store.costCentres.sort((a, b)=>{
                var _a$name, _a$name$localeCompare;
                return a === null || a === void 0 ? void 0 : (_a$name = a.name) === null || _a$name === void 0 ? void 0 : (_a$name$localeCompare = _a$name.localeCompare) === null || _a$name$localeCompare === void 0 ? void 0 : _a$name$localeCompare.call(_a$name, b === null || b === void 0 ? void 0 : b.name);
            }).map((cc)=>{
                return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)($3361029cf99b7f87$var$TimesheetCostCentre, {
                            costCentre: cc
                        }),
                        (store.projectsByCostCentreId[cc === null || cc === void 0 ? void 0 : cc.id] || []).sort((a, b)=>{
                            const aName = a.title || "";
                            const bName = b.title || "";
                            return aName.localeCompare(bName);
                        }).map((pr)=>{
                            return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)($3361029cf99b7f87$var$TimesheetProject, {
                                        project: pr
                                    }),
                                    (store.phasesByProjectId[pr === null || pr === void 0 ? void 0 : pr.id] || []).sort((a, b)=>{
                                        const aName = a.title || "";
                                        const bName = b.title || "";
                                        return aName.localeCompare(bName);
                                    }).map((ph)=>{
                                        return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                            className: "phase-block timesheet-widget__row",
                                            children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                                className: "timesheet-widget__phase-block timesheet-widget__row__inner",
                                                children: [
                                                    /*#__PURE__*/ (0, $61Ea1.jsx)($3361029cf99b7f87$var$TimesheetPhase, {
                                                        project: pr,
                                                        phase: ph,
                                                        store: store
                                                    }),
                                                    (store.rowsByPhaseId[(0, $f44xu.default)(pr === null || pr === void 0 ? void 0 : pr.id, ph === null || ph === void 0 ? void 0 : ph.id)] || []).sort((a, b)=>{
                                                        var _a$task, _b$task;
                                                        const aName = ((_a$task = a.task) === null || _a$task === void 0 ? void 0 : _a$task.name) || "";
                                                        const bName = ((_b$task = b.task) === null || _b$task === void 0 ? void 0 : _b$task.name) || "";
                                                        return aName.localeCompare(bName);
                                                    }).map((row)=>{
                                                        return /*#__PURE__*/ (0, $61Ea1.jsx)($3361029cf99b7f87$var$TaskRow, {
                                                            store: store,
                                                            row: row
                                                        });
                                                    })
                                                ]
                                            })
                                        });
                                    })
                                ]
                            });
                        })
                    ]
                });
            }),
            !store.costCentres.length && /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            className: "text-[#666666] text-3xl pb-5",
                            children: "No Time Entries"
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            className: "text-[#666666] leading-[2em]",
                            children: [
                                "There are no time entries for this day.",
                                /*#__PURE__*/ (0, $61Ea1.jsx)("br", {}),
                                "Please add an entry by clicking the button below."
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                className: "btn btn-lg btn-default add-timesheet-entry-button plus-btn border-[#ccc]",
                onClick: ()=>(0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $aRbBG.default), {
                        modalId: "addEntry",
                        dates: [
                            store.date
                        ],
                        staff: store.staff,
                        store: store
                    })),
                children: "+ Add time entry"
            }),
            !store.costCentres.length ? /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                className: "btn btn-lg btn-primary timesheet-widget__copy-previous-button ml-4 bg-[#428bca] m-[0.5em] text-white py-2 px-4 text-sm rounded-[6px] border border-[#357ebd] cursor-pointer hover:bg-[#428bca]/70 disabled:opacity-50 disabled:cursor-not-allowed",
                onClick: async ()=>{
                    var _store$staff;
                    const uniqueRows = await (0, $eZxCg.getPreviousDayTime)((_store$staff = store.staff) === null || _store$staff === void 0 ? void 0 : _store$staff.id, store.date);
                    store.addExtraTime(uniqueRows.map((r)=>{
                        return (0, $QiMYe.default).add({
                            numMinutes: 0,
                            ...r,
                            date: store.date,
                            staffId: store.staffId || (0, $1BTI2.default).userId,
                            date: store.daysOfWeek[0]
                        }, {
                            trackUpdates: true
                        });
                    }));
                },
                children: "Copy previous"
            }) : null
        ]
    });
});
const $3361029cf99b7f87$var$TimesheetCostCentre = (0, $1EEMt.observer)(({ costCentre: costCentre })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "text-[1.7em] py-[0.5em] text-left border-b border-[#aaa] mb-[0.8em]",
        children: costCentre === null || costCentre === void 0 ? void 0 : costCentre.name
    });
});
const $3361029cf99b7f87$var$TimesheetProject = (0, $1EEMt.observer)(({ project: project })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "project-title",
        style: {
            fontSize: "1.4em",
            margin: "1.2em 0 0.2em 0.6em",
            fontWeight: 600,
            width: "50%"
        },
        children: project.title
    });
});
const $3361029cf99b7f87$var$TimesheetPhase = (0, $1EEMt.observer)(({ project: project, phase: phase, store: store })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "timesheet-widget__phase-row flex flex-col",
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "timesheet-widget__phase-title w-full",
                children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    className: "inline-flex w-full pb-[0.1em] items-end",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                            className: "btn btn-default timesheet-widget__add-task flex-0-0-auto",
                            onClick: ()=>{
                                var _phase$defaultTask, _phase$defaultTask2;
                                return (0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $aRbBG.default), {
                                    modalId: "addEntry",
                                    dates: [
                                        store.date
                                    ],
                                    staff: store.staff,
                                    store: store,
                                    defaults: {
                                        costCentre: project.costCentre,
                                        project: project,
                                        phase: phase,
                                        isBillable: (phase === null || phase === void 0 ? void 0 : (_phase$defaultTask = phase.defaultTask) === null || _phase$defaultTask === void 0 ? void 0 : _phase$defaultTask.isBillable) || true,
                                        isVariation: (phase === null || phase === void 0 ? void 0 : (_phase$defaultTask2 = phase.defaultTask) === null || _phase$defaultTask2 === void 0 ? void 0 : _phase$defaultTask2.isVariation) || false,
                                        isOvertime: false,
                                        isRemote: false,
                                        isFlexi: false
                                    }
                                }));
                            },
                            style: {
                                padding: "0.1em 0.4em",
                                margin: "0em 1em 0 0.5em",
                                fontSize: "0.6em"
                            },
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                className: "fa fa-plus",
                                style: {
                                    margin: 0
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            className: "phase-block__title flex-1-1-auto",
                            style: {
                                minWidth: 0,
                                flex: "0 0 auto",
                                width: "24%"
                            },
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "text-base",
                                children: (phase === null || phase === void 0 ? void 0 : phase.title) || "No Phase"
                            })
                        }),
                        !(0, $8kZ1o.hideBudgetProgress)() ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ax8Km.default), {
                            dropdownClassName: "!text-xs",
                            projects: store.projects,
                            project: project,
                            phase: phase,
                            role: store.staff.role,
                            staff: store.staff,
                            startDate: (0, $4hBm1.startOfDay)(store.date),
                            endDate: (0, $4hBm1.endOfDay)(store.date),
                            containerStyles: {
                                margin: "0 2em",
                                position: "relative",
                                width: "70%"
                            },
                            textStyles: {
                                marginLeft: "5em"
                            },
                            dropdownStyles: {
                                right: "1em",
                                bottom: "0.75rem",
                                height: "1.5rem",
                                maxWidth: "max-content",
                                position: "absolute"
                            },
                            dropdownAbove: true,
                            extraHours: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(store.timeEntries.filter((te)=>{
                                var _store$staff2;
                                return te.phaseId === (phase === null || phase === void 0 ? void 0 : phase.id) && te.staffId == ((_store$staff2 = store.staff) === null || _store$staff2 === void 0 ? void 0 : _store$staff2.id);
                            }).map((te)=>te.hours))
                        }) : null
                    ]
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "timesheet-widget__progress-bar timesheet-widget__middle-section",
                style: {
                    verticalAlign: "bottom"
                }
            })
        ]
    });
});
const $3361029cf99b7f87$var$TaskRow = (0, $1EEMt.observer)(({ store: store, row: row, mode: mode })=>{
    var _row$task;
    const isHighlighted = false;
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("timesheet-widget__task-row", {
            "timesheet-widget__task-row--highlighted": isHighlighted
        }),
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "timesheet-widget__task-title timesheet-widget__left-section",
                children: [
                    !row.isLocked ? /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                        className: "timesheet-widget__task-delete delete-button",
                        onClick: ()=>{
                            row.update({
                                deletedAt: new Date()
                            });
                        },
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                            className: "fa fa-times fa-fw"
                        })
                    }) : null,
                    !row.isLocked ? /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                        className: "timesheet-widget__task-edit edit-button",
                        onClick: ()=>{
                            (0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $aRbBG.default), {
                                modalId: "editEntry",
                                timeEntries: [
                                    row
                                ],
                                staff: store.staff,
                                store: store
                            }));
                        },
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                            className: "fa fa-pencil-square-o fa-fw"
                        })
                    }) : null,
                    (0, $8kZ1o.canEditStaffTime)((0, $1BTI2.default).user) && !row.isLocked ? /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                        className: "timesheet-widget__task-lock lock-button",
                        onClick: ()=>{
                            row.update({
                                isLocked: true
                            });
                        },
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                            className: "fa fa-lock fa-fw"
                        })
                    }) : (0, $8kZ1o.canEditStaffTime)((0, $1BTI2.default).user) && row.isLocked ? /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                        className: "timesheet-widget__task-lock lock-button",
                        onClick: ()=>{
                            row.update({
                                isLocked: false
                            });
                        },
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                            className: "fa fa-unlock fa-fw"
                        })
                    }) : null,
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "text-[0.85em]",
                        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                            style: {
                                marginLeft: "0.5em"
                            },
                            children: [
                                !row.isBillable ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                    style: {
                                        display: "inline-block"
                                    },
                                    className: "time-entry__time-options timesheet-widget__task-row__is-not-billable",
                                    children: [
                                        /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                                            className: "fa-stack",
                                            style: {
                                                fontSize: "0.7em",
                                                marginRight: "0.4em"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                                    className: "fa fa-usd fa-stack-1x"
                                                }),
                                                /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                                    className: "fa fa-ban fa-stack-2x"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                            className: "time-entry__time-options-hover",
                                            children: "Non-Billable Time"
                                        })
                                    ]
                                }) : null,
                                row.isOvertime ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                    style: {
                                        display: "inline-block"
                                    },
                                    className: "time-entry__time-options timesheet-widget__task-row__is-overtime",
                                    children: [
                                        /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                            className: "fa fa-clock-o",
                                            style: {
                                                fontSize: "1.3em",
                                                position: "relative",
                                                top: "0.15em"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                            className: "time-entry__time-options-hover",
                                            children: "Overtime"
                                        })
                                    ]
                                }) : null,
                                row.isVariation ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                    style: {
                                        display: "inline-block"
                                    },
                                    className: "time-entry__time-options timesheet-widget__task-row__is-variation",
                                    children: [
                                        /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                            className: "fa fa-code-fork",
                                            style: {
                                                fontSize: "1.3em",
                                                position: "relative",
                                                top: "0.15em"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                            className: "time-entry__time-options-hover",
                                            children: "Variation"
                                        })
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                    style: {
                                        marginLeft: "0.5em"
                                    },
                                    children: (row === null || row === void 0 ? void 0 : row.task) != null ? (_row$task = row.task) === null || _row$task === void 0 ? void 0 : _row$task.name : "(No task)"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "timesheet-widget__task-entries timesheet-widget__middle-section",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)($3361029cf99b7f87$var$DailyTimeEntry, {
                    timeEntry: row,
                    store: store
                })
            })
        ]
    });
});
const $3361029cf99b7f87$var$DailyTimeEntry = (0, $1EEMt.observer)(({ timeEntry: timeEntry, store: store })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "time-entry time-entry--daily py-1",
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $y5iig.HoursInput), {
                value: timeEntry.numMinutes,
                onChange: (numMinutes)=>{
                    timeEntry.update({
                        numMinutes: numMinutes
                    });
                    timeEntry.attach();
                },
                className: "time-entry__input",
                isEditable: !timeEntry.isLocked
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "time-entry--daily__note",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $iuzpK.TextArea), {
                    value: timeEntry.notes || "",
                    onChange: (e)=>{
                        timeEntry.update({
                            notes: e.target.value
                        });
                        timeEntry.attach();
                    },
                    className: "time-entry__note-input !my-0 inline-flex items-center justify-center !text-sm bg-white",
                    placeholder: "(No Notes)",
                    disabled: timeEntry.isLocked
                })
            })
        ]
    });
});
const $3361029cf99b7f87$var$TimesheetNav = (0, $1EEMt.observer)(({ mode: mode, monday: monday, dayTotals: dayTotals, selectedDate: selectedDate, store: store })=>{
    const navigate = (0, $6UBLf.useNavigate)();
    const formatTotal = (n, type)=>{
        return (0, $e8Hda.isNumber)(n) ? (0, $e8Hda.formatMinutes)(n) : n === "loading" ? /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
            className: "fa fa-spinner fa-spin",
            style: {
                margin: 0
            }
        }) : /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
            className: "fa fa-exclamation-triangle error-highlight-color",
            style: {
                margin: 0
            },
            title: `Some entries for this ${type} have errors.`
        });
    };
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "max-w-[1040px] bg-[#fafafa] z-[1000] pt-8 w-[1040px] sticky top-0",
        children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            className: "border-b border-[#aaa]",
            children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    className: "timesheet-widget__row min-w-[36em] mb-2.5 text-center",
                    style: {
                        fontSize: "1em"
                    },
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "timesheet-widget__row__inner min-[1310px]:w-[92%] w-full mx-auto",
                        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            className: "flex items-start",
                            // to align buttons
                            style: {
                            },
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                    className: "timesheet-widget__left-section min-[1381px]:w-[30%] w-1/4",
                                    children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                        className: "timesheets__navigation flex items-center",
                                        style: {
                                            flex: "0 0 auto"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                className: "flex w-full text-center",
                                                children: /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                                                    onClick: store.shiftThisWeek,
                                                    className: "btn btn-default w-full py-1.5 px-3 text-sm text-[#333] bg-white border border-[#ccc] text-center whitespace-nowrap rounded hover:bg-[#e0e0e0]",
                                                    children: "Today"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                className: "",
                                                style: {
                                                    flex: "0 0 auto"
                                                },
                                                children: /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                                                    onClick: store.shiftPrevWeek,
                                                    className: "btn btn-default previous-week-button ml-3 py-1.5 px-3 text-[#333] bg-white border border-[#ccc] text-sm rounded",
                                                    title: "Previous week",
                                                    children: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                                        className: "fa fa-chevron-left m-0"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                    className: "timesheet-widget__middle-section min-[1381px]:w-[65%] w-3/4",
                                    children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        className: "timesheets__day-nav flex justify-around w-full",
                                        children: dayTotals.map(function(dayTotal, dayIndex) {
                                            var _d1$getTime, _selectedDate$getTime;
                                            let d1 = (0, $4hBm1.addDays)(monday, dayIndex);
                                            let inner = /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                                className: "timesheet__nav__day__date",
                                                children: [
                                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                        className: "text-[10px] leading-[14px]",
                                                        children: (0, $4hBm1.format)(d1, "EEE")
                                                    }),
                                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                        className: "text-xl",
                                                        children: (0, $4hBm1.format)(d1, "dd")
                                                    })
                                                ]
                                            });
                                            return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                                className: "flex-0-0-auto timesheet__nav__day text-center",
                                                "data-date": (0, $4hBm1.format)(d1, "yyyy-MM-dd"),
                                                children: [
                                                    /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("btn btn-default timesheets__day-nav-button border hover:m-0 hover:border-2 hover:border-gold text-sm text-[#333] bg-white rounded py-1.5 px-3 whitespace-nowrap", (d1 === null || d1 === void 0 ? void 0 : (_d1$getTime = d1.getTime) === null || _d1$getTime === void 0 ? void 0 : _d1$getTime.call(d1)) === (selectedDate === null || selectedDate === void 0 ? void 0 : (_selectedDate$getTime = selectedDate.getTime) === null || _selectedDate$getTime === void 0 ? void 0 : _selectedDate$getTime.call(selectedDate)) ? "border-2 border-gold m-0" : "border-[#ccc] m-px"),
                                                        style: {
                                                            fontSize: "1.1em",
                                                            textAlign: "center"
                                                        },
                                                        onClick: ()=>{
                                                            navigate({
                                                                search: (prev)=>({
                                                                        ...prev,
                                                                        date: (0, $4hBm1.format)(d1, "yyyy-MM-dd")
                                                                    })
                                                            });
                                                        },
                                                        children: inner
                                                    }),
                                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                        className: "timesheet-widget__hours-cell timesheet__nav__total text-xs text-[#666666] font-semibold mt-[2px]",
                                                        children: formatTotal(dayTotal, "day")
                                                    })
                                                ]
                                            }, dayIndex);
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                    className: "timesheet-widget__right-section",
                                    style: {
                                        flex: "0 0 auto"
                                    },
                                    children: /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                                        onClick: store.shiftNextWeek,
                                        className: "btn btn-default next-week-button py-1.5 px-3 text-[#333] bg-white border border-[#ccc] text-sm rounded",
                                        title: "Next week",
                                        children: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                            className: "fa fa-chevron-right m-0"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
});

});
parcelRegister("hP0jf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf977085645ff47f$export$2e2bcd8739ae039; });

var $eat5C = parcelRequire("eat5C");

var $4JcCM = parcelRequire("4JcCM");

var $QiMYe = parcelRequire("QiMYe");

var $4hBm1 = parcelRequire("4hBm1");

var $1BTI2 = parcelRequire("1BTI2");

var $f44xu = parcelRequire("f44xu");

var $htkeB = parcelRequire("htkeB");
parcelRequire("aISc8");

var $8kZ1o = parcelRequire("8kZ1o");

var $6Q5sp = parcelRequire("6Q5sp");
var $cf977085645ff47f$var$_dec, $cf977085645ff47f$var$_dec2, $cf977085645ff47f$var$_dec3, $cf977085645ff47f$var$_dec4, $cf977085645ff47f$var$_dec5, $cf977085645ff47f$var$_dec6, $cf977085645ff47f$var$_dec7, $cf977085645ff47f$var$_class, $cf977085645ff47f$var$_descriptor, $cf977085645ff47f$var$_descriptor2;
function $cf977085645ff47f$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $cf977085645ff47f$var$_defineProperty(e, r, t) {
    return (r = $cf977085645ff47f$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $cf977085645ff47f$var$_toPropertyKey(t) {
    var i = $cf977085645ff47f$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $cf977085645ff47f$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $cf977085645ff47f$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $cf977085645ff47f$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $cf977085645ff47f$var$TimesheetsDailyStore = ($cf977085645ff47f$var$_dec = (0, $4JcCM.action).bound, $cf977085645ff47f$var$_dec2 = (0, $4JcCM.action).bound, $cf977085645ff47f$var$_dec3 = (0, $4JcCM.action).bound, $cf977085645ff47f$var$_dec4 = (0, $4JcCM.action).bound, $cf977085645ff47f$var$_dec5 = (0, $4JcCM.action).bound, $cf977085645ff47f$var$_dec6 = (0, $4JcCM.action).bound, $cf977085645ff47f$var$_dec7 = (0, $4JcCM.action).bound, $cf977085645ff47f$var$_class = class TimesheetsDailyStore {
    constructor(){
        $cf977085645ff47f$var$_initializerDefineProperty(this, "extraTime", $cf977085645ff47f$var$_descriptor, this);
        $cf977085645ff47f$var$_initializerDefineProperty(this, "searchParams", $cf977085645ff47f$var$_descriptor2, this);
        (0, $4JcCM.makeObservable)(this);
    }
    reset() {
        this.extraTime = [];
    }
    setSearchParams(params) {
        this.searchParams = params;
    }
    get staffId() {
        var _this$searchParams;
        return (0, $8kZ1o.canEditStaffTime)((0, $1BTI2.default).user) ? ((_this$searchParams = this.searchParams) === null || _this$searchParams === void 0 ? void 0 : _this$searchParams.staffId) || (0, $1BTI2.default).userId : (0, $1BTI2.default).userId;
    }
    get date() {
        var _this$searchParams2, _this$searchParams3;
        return (_this$searchParams2 = this.searchParams) !== null && _this$searchParams2 !== void 0 && _this$searchParams2.date ? (0, $4hBm1.parse)((_this$searchParams3 = this.searchParams) === null || _this$searchParams3 === void 0 ? void 0 : _this$searchParams3.date, "yyyy-MM-dd", new Date()) : (0, $4hBm1.startOfDay)(new Date());
    }
    addExtraTime(timeEntries) {
        this.extraTime.push(...timeEntries);
    }
    get timeEntries() {
        return [
            ...new Set([
                ...(0, $QiMYe.default).timeEntries.filter((t)=>t.staffId === this.staffId && (0, $4hBm1.isSameDay)(t.date, this.date) && !t.deletedAt),
                ...this.extraTime.filter((t)=>t.staffId === this.staffId && (0, $4hBm1.isSameDay)(t.date, this.date) && !t.deletedAt)
            ])
        ];
    }
    clearBlankTimeEntries() {
        this.timeEntries.filter((te)=>!te.numMinutes && !te.notes).forEach((te)=>te.update({
                deletedAt: new Date()
            }));
    }
    get costCentres() {
        return [
            ...new Set(this.timeEntries.map((t)=>{
                var _t$project;
                return ((_t$project = t.project) === null || _t$project === void 0 ? void 0 : _t$project.costCentre) || {
                    id: t.costCentreId,
                    name: "Missing Cost Centre"
                };
            }))
        ];
    }
    get projects() {
        return [
            ...new Set(this.timeEntries.map((t)=>t.project))
        ];
    }
    get projectsByCostCentreId() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).groupBy([
            ...new Set(this.timeEntries.map((t)=>t.project))
        ], (pr)=>pr === null || pr === void 0 ? void 0 : pr.costCentreId);
    }
    get phasesByProjectId() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).mapValues((0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).groupBy(this.timeEntries, (ph)=>ph === null || ph === void 0 ? void 0 : ph.projectId), (tes)=>[
                ...new Set(tes.map((te)=>{
                    var _te$project;
                    return te.phase || ((_te$project = te.project) === null || _te$project === void 0 ? void 0 : _te$project.rootPhase);
                }))
            ]);
    }
    get rowsByPhaseId() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).groupBy(this.timeEntries.filter((te)=>{
            return te.numMinutes || te.notes !== "" && te.notes !== null || new Date() - (te.createdAt || te.updatedAt) < 43200000 || !this.timeEntries.find((t)=>t.id !== te.id && t.date.getTime() === te.date.getTime() && t.taskId === te.taskId && t.isBillable === te.isBillable && t.isVariation === te.isVariation && t.isOvertime === te.isOvertime && t.isLocked === te.isLocked && (t.numMinutes || t.notes !== "" && t.notes !== null)) && this.timeEntries.find((t)=>t.date.getTime() === te.date.getTime() && t.taskId === te.taskId && t.isBillable === te.isBillable && t.isVariation === te.isVariation && t.isOvertime === te.isOvertime && t.isLocked === te.isLocked).id === te.id;
        }), (te)=>{
            var _te$project2, _te$project2$rootPhas;
            return (0, $f44xu.default)(te.projectId, te.phase ? te.phaseId : (_te$project2 = te.project) === null || _te$project2 === void 0 ? void 0 : (_te$project2$rootPhas = _te$project2.rootPhase) === null || _te$project2$rootPhas === void 0 ? void 0 : _te$project2$rootPhas.id);
        });
    }
    get staff() {
        return (0, $htkeB.default).staffsById[this.staffId] || (0, $1BTI2.default).user;
    }
    get startOfWeek() {
        return (0, $4hBm1.startOfWeek)(this.date, {
            weekStartsOn: 1
        });
    }
    get daysOfWeek() {
        return [
            ...Array(7)
        ].map((v, i)=>(0, $4hBm1.addDays)(this.startOfWeek, i));
    }
    get dailyTotals() {
        const totals = this.daysOfWeek.map((day)=>(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(((0, $QiMYe.default).timeEntriesByStaffIdDate[(0, $f44xu.default)(this.staffId, day.getTime())] || []).map((te)=>te.numMinutes)));
        return totals;
    }
    get currentDayTotal() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(((0, $QiMYe.default).timeEntriesByStaffIdDate[(0, $f44xu.default)(this.staffId, this.date.getTime())] || []).map((te)=>te.numMinutes));
    }
    shiftPrevWeek() {
        (0, $6Q5sp.router).navigate({
            search: (prev)=>({
                    ...prev,
                    date: (0, $4hBm1.format)((0, $4hBm1.subWeeks)(this.date, 1), "yyyy-MM-dd")
                })
        });
    }
    shiftNextWeek() {
        (0, $6Q5sp.router).navigate({
            search: (prev)=>({
                    ...prev,
                    date: (0, $4hBm1.format)((0, $4hBm1.addWeeks)(this.date, 1), "yyyy-MM-dd")
                })
        });
    }
    shiftThisWeek() {
        (0, $6Q5sp.router).navigate({
            search: (prev)=>(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).omitBy({
                    ...prev,
                    date: null
                }, (v)=>v === null)
        });
    }
}, $cf977085645ff47f$var$_descriptor = $cf977085645ff47f$var$_applyDecoratedDescriptor($cf977085645ff47f$var$_class.prototype, "extraTime", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $cf977085645ff47f$var$_descriptor2 = $cf977085645ff47f$var$_applyDecoratedDescriptor($cf977085645ff47f$var$_class.prototype, "searchParams", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $cf977085645ff47f$var$_applyDecoratedDescriptor($cf977085645ff47f$var$_class.prototype, "reset", [
    $cf977085645ff47f$var$_dec
], Object.getOwnPropertyDescriptor($cf977085645ff47f$var$_class.prototype, "reset"), $cf977085645ff47f$var$_class.prototype), $cf977085645ff47f$var$_applyDecoratedDescriptor($cf977085645ff47f$var$_class.prototype, "setSearchParams", [
    $cf977085645ff47f$var$_dec2
], Object.getOwnPropertyDescriptor($cf977085645ff47f$var$_class.prototype, "setSearchParams"), $cf977085645ff47f$var$_class.prototype), $cf977085645ff47f$var$_applyDecoratedDescriptor($cf977085645ff47f$var$_class.prototype, "staffId", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($cf977085645ff47f$var$_class.prototype, "staffId"), $cf977085645ff47f$var$_class.prototype), $cf977085645ff47f$var$_applyDecoratedDescriptor($cf977085645ff47f$var$_class.prototype, "date", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($cf977085645ff47f$var$_class.prototype, "date"), $cf977085645ff47f$var$_class.prototype), $cf977085645ff47f$var$_applyDecoratedDescriptor($cf977085645ff47f$var$_class.prototype, "addExtraTime", [
    $cf977085645ff47f$var$_dec3
], Object.getOwnPropertyDescriptor($cf977085645ff47f$var$_class.prototype, "addExtraTime"), $cf977085645ff47f$var$_class.prototype), $cf977085645ff47f$var$_applyDecoratedDescriptor($cf977085645ff47f$var$_class.prototype, "timeEntries", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($cf977085645ff47f$var$_class.prototype, "timeEntries"), $cf977085645ff47f$var$_class.prototype), $cf977085645ff47f$var$_applyDecoratedDescriptor($cf977085645ff47f$var$_class.prototype, "clearBlankTimeEntries", [
    $cf977085645ff47f$var$_dec4
], Object.getOwnPropertyDescriptor($cf977085645ff47f$var$_class.prototype, "clearBlankTimeEntries"), $cf977085645ff47f$var$_class.prototype), $cf977085645ff47f$var$_applyDecoratedDescriptor($cf977085645ff47f$var$_class.prototype, "costCentres", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($cf977085645ff47f$var$_class.prototype, "costCentres"), $cf977085645ff47f$var$_class.prototype), $cf977085645ff47f$var$_applyDecoratedDescriptor($cf977085645ff47f$var$_class.prototype, "projects", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($cf977085645ff47f$var$_class.prototype, "projects"), $cf977085645ff47f$var$_class.prototype), $cf977085645ff47f$var$_applyDecoratedDescriptor($cf977085645ff47f$var$_class.prototype, "projectsByCostCentreId", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($cf977085645ff47f$var$_class.prototype, "projectsByCostCentreId"), $cf977085645ff47f$var$_class.prototype), $cf977085645ff47f$var$_applyDecoratedDescriptor($cf977085645ff47f$var$_class.prototype, "phasesByProjectId", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($cf977085645ff47f$var$_class.prototype, "phasesByProjectId"), $cf977085645ff47f$var$_class.prototype), $cf977085645ff47f$var$_applyDecoratedDescriptor($cf977085645ff47f$var$_class.prototype, "rowsByPhaseId", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($cf977085645ff47f$var$_class.prototype, "rowsByPhaseId"), $cf977085645ff47f$var$_class.prototype), $cf977085645ff47f$var$_applyDecoratedDescriptor($cf977085645ff47f$var$_class.prototype, "staff", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($cf977085645ff47f$var$_class.prototype, "staff"), $cf977085645ff47f$var$_class.prototype), $cf977085645ff47f$var$_applyDecoratedDescriptor($cf977085645ff47f$var$_class.prototype, "startOfWeek", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($cf977085645ff47f$var$_class.prototype, "startOfWeek"), $cf977085645ff47f$var$_class.prototype), $cf977085645ff47f$var$_applyDecoratedDescriptor($cf977085645ff47f$var$_class.prototype, "daysOfWeek", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($cf977085645ff47f$var$_class.prototype, "daysOfWeek"), $cf977085645ff47f$var$_class.prototype), $cf977085645ff47f$var$_applyDecoratedDescriptor($cf977085645ff47f$var$_class.prototype, "dailyTotals", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($cf977085645ff47f$var$_class.prototype, "dailyTotals"), $cf977085645ff47f$var$_class.prototype), $cf977085645ff47f$var$_applyDecoratedDescriptor($cf977085645ff47f$var$_class.prototype, "currentDayTotal", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($cf977085645ff47f$var$_class.prototype, "currentDayTotal"), $cf977085645ff47f$var$_class.prototype), $cf977085645ff47f$var$_applyDecoratedDescriptor($cf977085645ff47f$var$_class.prototype, "shiftPrevWeek", [
    $cf977085645ff47f$var$_dec5
], Object.getOwnPropertyDescriptor($cf977085645ff47f$var$_class.prototype, "shiftPrevWeek"), $cf977085645ff47f$var$_class.prototype), $cf977085645ff47f$var$_applyDecoratedDescriptor($cf977085645ff47f$var$_class.prototype, "shiftNextWeek", [
    $cf977085645ff47f$var$_dec6
], Object.getOwnPropertyDescriptor($cf977085645ff47f$var$_class.prototype, "shiftNextWeek"), $cf977085645ff47f$var$_class.prototype), $cf977085645ff47f$var$_applyDecoratedDescriptor($cf977085645ff47f$var$_class.prototype, "shiftThisWeek", [
    $cf977085645ff47f$var$_dec7
], Object.getOwnPropertyDescriptor($cf977085645ff47f$var$_class.prototype, "shiftThisWeek"), $cf977085645ff47f$var$_class.prototype), $cf977085645ff47f$var$_class);
var $cf977085645ff47f$export$2e2bcd8739ae039 = new $cf977085645ff47f$var$TimesheetsDailyStore();

});

parcelRegister("aRbBG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e77db7a4d8e86e8$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $1EEMt = parcelRequire("1EEMt");

var $fEcKX = parcelRequire("fEcKX");

var $ewAM3 = parcelRequire("ewAM3");

var $6RcUP = parcelRequire("6RcUP");

var $1BTI2 = parcelRequire("1BTI2");

var $52dEm = parcelRequire("52dEm");

var $8kZ1o = parcelRequire("8kZ1o");

var $gJT7h = parcelRequire("gJT7h");

var $6Q5sp = parcelRequire("6Q5sp");

var $QiMYe = parcelRequire("QiMYe");

var $XoImS = parcelRequire("XoImS");

var $keGWP = parcelRequire("keGWP");

var $3h7sC = parcelRequire("3h7sC");

var $47i9t = parcelRequire("47i9t");
var $7e77db7a4d8e86e8$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ modalId: modalId, timeEntries: timeEntries, dates: dates, staff: staff, store: store, heading: heading, onSave: onSave, showAllFlags: showAllFlags, placeholders: placeholders, selectDefaults: selectDefaults = true, defaults: defaults })=>{
    var _timeEntries$, _timeEntries$2, _timeEntries$3, _ref, _ref2, _timeEntries$0$isBill, _timeEntries$4, _timeEntries$5, _timeEntries$5$task, _timeEntries$6, _timeEntries$6$projec, _timeEntries$6$projec2, _ref3, _timeEntries$0$isVari, _timeEntries$7, _timeEntries$8, _timeEntries$8$task, _timeEntries$0$isOver, _timeEntries$9, _timeEntries$0$isRemo, _timeEntries$10, _timeEntries$0$isFlex, _timeEntries$11, _timeEntries$0$beenIn, _timeEntries$12, _timeEntries$0$isLock, _timeEntries$13, _project$phases, _project$phases2, _project$phases3, _phase$tasks, _PhaseCollection$phas;
    const [project, setProject] = (0, $jbmdS.useState)(defaults ? defaults.project : timeEntries === null || timeEntries === void 0 ? void 0 : (_timeEntries$ = timeEntries[0]) === null || _timeEntries$ === void 0 ? void 0 : _timeEntries$.project);
    const [phase, setPhase] = (0, $jbmdS.useState)(defaults ? defaults.phase : timeEntries === null || timeEntries === void 0 ? void 0 : (_timeEntries$2 = timeEntries[0]) === null || _timeEntries$2 === void 0 ? void 0 : _timeEntries$2.phase);
    const [task, setTask] = (0, $jbmdS.useState)(defaults ? defaults.task : timeEntries === null || timeEntries === void 0 ? void 0 : (_timeEntries$3 = timeEntries[0]) === null || _timeEntries$3 === void 0 ? void 0 : _timeEntries$3.task);
    const [isBillable, setIsBillable] = (0, $jbmdS.useState)(defaults ? defaults.isBillable : (_ref = (_ref2 = (_timeEntries$0$isBill = timeEntries === null || timeEntries === void 0 ? void 0 : (_timeEntries$4 = timeEntries[0]) === null || _timeEntries$4 === void 0 ? void 0 : _timeEntries$4.isBillable) !== null && _timeEntries$0$isBill !== void 0 ? _timeEntries$0$isBill : timeEntries === null || timeEntries === void 0 ? void 0 : (_timeEntries$5 = timeEntries[0]) === null || _timeEntries$5 === void 0 ? void 0 : (_timeEntries$5$task = _timeEntries$5.task) === null || _timeEntries$5$task === void 0 ? void 0 : _timeEntries$5$task.isBillable) !== null && _ref2 !== void 0 ? _ref2 : timeEntries === null || timeEntries === void 0 ? void 0 : (_timeEntries$6 = timeEntries[0]) === null || _timeEntries$6 === void 0 ? void 0 : (_timeEntries$6$projec = _timeEntries$6.project) === null || _timeEntries$6$projec === void 0 ? void 0 : (_timeEntries$6$projec2 = _timeEntries$6$projec.costCentre) === null || _timeEntries$6$projec2 === void 0 ? void 0 : _timeEntries$6$projec2.isBillable) !== null && _ref !== void 0 ? _ref : true);
    const [isVariation, setIsVariation] = (0, $jbmdS.useState)(defaults ? defaults.isVariation : (_ref3 = (_timeEntries$0$isVari = timeEntries === null || timeEntries === void 0 ? void 0 : (_timeEntries$7 = timeEntries[0]) === null || _timeEntries$7 === void 0 ? void 0 : _timeEntries$7.isVariation) !== null && _timeEntries$0$isVari !== void 0 ? _timeEntries$0$isVari : timeEntries === null || timeEntries === void 0 ? void 0 : (_timeEntries$8 = timeEntries[0]) === null || _timeEntries$8 === void 0 ? void 0 : (_timeEntries$8$task = _timeEntries$8.task) === null || _timeEntries$8$task === void 0 ? void 0 : _timeEntries$8$task.isVariation) !== null && _ref3 !== void 0 ? _ref3 : false);
    const [isOvertime, setIsOvertime] = (0, $jbmdS.useState)(defaults ? defaults.isOvertime : (_timeEntries$0$isOver = timeEntries === null || timeEntries === void 0 ? void 0 : (_timeEntries$9 = timeEntries[0]) === null || _timeEntries$9 === void 0 ? void 0 : _timeEntries$9.isOvertime) !== null && _timeEntries$0$isOver !== void 0 ? _timeEntries$0$isOver : false);
    const [isRemote, setIsRemote] = (0, $jbmdS.useState)(defaults ? defaults.isRemote : (_timeEntries$0$isRemo = timeEntries === null || timeEntries === void 0 ? void 0 : (_timeEntries$10 = timeEntries[0]) === null || _timeEntries$10 === void 0 ? void 0 : _timeEntries$10.isRemote) !== null && _timeEntries$0$isRemo !== void 0 ? _timeEntries$0$isRemo : false);
    const [isFlexi, setIsFlexi] = (0, $jbmdS.useState)(defaults ? defaults.isFlexi : (_timeEntries$0$isFlex = timeEntries === null || timeEntries === void 0 ? void 0 : (_timeEntries$11 = timeEntries[0]) === null || _timeEntries$11 === void 0 ? void 0 : _timeEntries$11.isFlexi) !== null && _timeEntries$0$isFlex !== void 0 ? _timeEntries$0$isFlex : false);
    const [beenInvoiced, setBeenInvoiced] = (0, $jbmdS.useState)(defaults ? defaults.beenInvoiced : (_timeEntries$0$beenIn = timeEntries === null || timeEntries === void 0 ? void 0 : (_timeEntries$12 = timeEntries[0]) === null || _timeEntries$12 === void 0 ? void 0 : _timeEntries$12.beenInvoiced) !== null && _timeEntries$0$beenIn !== void 0 ? _timeEntries$0$beenIn : false);
    const [isLocked, setIsLocked] = (0, $jbmdS.useState)(defaults ? defaults.isLocked : (_timeEntries$0$isLock = timeEntries === null || timeEntries === void 0 ? void 0 : (_timeEntries$13 = timeEntries[0]) === null || _timeEntries$13 === void 0 ? void 0 : _timeEntries$13.isLocked) !== null && _timeEntries$0$isLock !== void 0 ? _timeEntries$0$isLock : false);
    const getSelectedData = ()=>{
        return Object.fromEntries([
            project ? [
                "costCentreId",
                project.costCentreId
            ] : null,
            project ? [
                "projectId",
                project.id
            ] : null,
            phase ? [
                "phaseId",
                phase.id
            ] : null,
            task ? [
                "taskId",
                task.id
            ] : null,
            isBillable != null ? [
                "isBillable",
                isBillable
            ] : null,
            isVariation != null ? [
                "isVariation",
                isVariation
            ] : null,
            isOvertime != null ? [
                "isOvertime",
                isOvertime
            ] : null,
            isRemote != null ? [
                "isRemote",
                isRemote
            ] : null,
            isFlexi != null ? [
                "isFlexi",
                isFlexi
            ] : null,
            beenInvoiced != null ? [
                "beenInvoiced",
                beenInvoiced
            ] : null,
            isLocked != null ? [
                "isLocked",
                isLocked
            ] : null
        ].filter((v)=>v));
    };
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fEcKX.default), {
        modalId: modalId,
        width: "45em",
        heading: heading || (timeEntries ? "Edit Timesheet Entries" : "New Timesheet Entry"),
        onSave: ()=>{
            if (onSave) return onSave(getSelectedData());
            if (timeEntries) timeEntries.forEach((te)=>{
                te.update(getSelectedData());
            });
            else {
                const timeEntries = dates.map((d)=>(0, $QiMYe.default).add({
                        date: d,
                        staffId: staff.id,
                        numMinutes: 0,
                        ...getSelectedData()
                    }, {
                        trackUpdates: true
                    }));
                store.addExtraTime(timeEntries);
            }
        },
        saveLabel: timeEntries ? "Edit Time Entries" : "Add Time Entries",
        canSave: ()=>showAllFlags || project && ((0, $8kZ1o.canLogTimeAgainstNoPhase)() || phase),
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "p-[1em] grid gap-[0.5em] ",
                style: {
                    gridTemplateColumns: "1fr 4fr"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "text-sm text-[#444]",
                        children: "Project: "
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "max-w-max",
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.ProjectSelector), {
                            selectedProject: project,
                            placeholderLabel: placeholders === null || placeholders === void 0 ? void 0 : placeholders.project,
                            projectOptions: (0, $gJT7h.default).projects.filter((p)=>(0, $8kZ1o.canEnterTimeAgainstProject)((0, $1BTI2.default).user, p, timeEntries ? true : false)),
                            onChange: (pr)=>{
                                (0, $6Q5sp.queryClient).invalidateQueries([
                                    `phases-${pr.id}`
                                ]);
                                setProject(pr);
                                setPhase(null);
                                setTask(null);
                                if (selectDefaults) {
                                    var _pr$costCentre;
                                    setIsBillable(pr === null || pr === void 0 ? void 0 : (_pr$costCentre = pr.costCentre) === null || _pr$costCentre === void 0 ? void 0 : _pr$costCentre.isBillable);
                                    setIsVariation(false);
                                    setIsOvertime(false);
                                }
                            },
                            variant: "secondary"
                        })
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "text-sm text-[#444]",
                        children: "Phase: "
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "max-w-max",
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6RcUP.default), {
                            queryIds: [
                                project ? {
                                    id: `phases-${project.id}`,
                                    queryFn: async ()=>{
                                        const requestData = await (0, $3h7sC.trpc).legacy.getProjectPhases.query({
                                            projectId: project.id
                                        });
                                        return (0, $47i9t.processTRPCData)(requestData, `phases-${project.id}`);
                                    }
                                } : null,
                                project ? {
                                    id: `tasks-${project.id}`,
                                    queryFn: async ()=>{
                                        const requestData = await (0, $3h7sC.trpc).legacy.getTasks.query({
                                            projectId: project.id
                                        });
                                        return (0, $47i9t.processTRPCData)(requestData, `tasks-${project.id}`);
                                    }
                                } : null
                            ].filter((v)=>v),
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.PhaseSelector), {
                                placeholderLabel: placeholders === null || placeholders === void 0 ? void 0 : placeholders.phase,
                                selectedPhase: (0, $XoImS.default).phasesById[phase === null || phase === void 0 ? void 0 : phase.id] || phase,
                                onChange: (ph)=>{
                                    setPhase(ph);
                                    const task = ph.defaultTask || ph.tasks[0] || null;
                                    if (task) {
                                        setTask(task);
                                        if (selectDefaults) {
                                            setIsBillable(task === null || task === void 0 ? void 0 : task.isBillable);
                                            setIsVariation(task === null || task === void 0 ? void 0 : task.isVariation);
                                            setIsOvertime(false);
                                        }
                                    }
                                },
                                phaseOptions: (project === null || project === void 0 ? void 0 : (_project$phases2 = project.phases) === null || _project$phases2 === void 0 ? void 0 : _project$phases2.filter((ph)=>(0, $8kZ1o.canEnterTimeAgainstPhase)((0, $1BTI2.default).user, ph))) || (phase ? [
                                    phase
                                ] : []),
                                variant: "secondary"
                            }, `phase-selector-${project !== null && project !== void 0 && (_project$phases = project.phases) !== null && _project$phases !== void 0 && _project$phases.length ? project === null || project === void 0 ? void 0 : project.id : "null"}`)
                        })
                    }),
                    (0, $8kZ1o.canLogTimeAgainstTasks)() ? /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "text-sm text-[#444]",
                                children: "Task: "
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "max-w-max",
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6RcUP.default), {
                                    queryIds: [
                                        project ? {
                                            id: `tasks-${project.id}`,
                                            queryFn: async ()=>{
                                                const requestData = await (0, $3h7sC.trpc).legacy.getTasks.query({
                                                    projectId: project.id
                                                });
                                                return (0, $47i9t.processTRPCData)(requestData, `tasks-${project.id}`);
                                            }
                                        } : null
                                    ].filter((v)=>v),
                                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.TaskSelector), {
                                        selectedTask: (0, $keGWP.default).tasksById[task === null || task === void 0 ? void 0 : task.id] || task,
                                        placeholderLabel: placeholders === null || placeholders === void 0 ? void 0 : placeholders.task,
                                        onChange: (task)=>{
                                            setTask(task);
                                            if (selectDefaults) {
                                                setIsBillable(task === null || task === void 0 ? void 0 : task.isBillable);
                                                setIsVariation(task === null || task === void 0 ? void 0 : task.isVariation);
                                                setIsOvertime(false);
                                            }
                                        },
                                        taskOptions: ((_PhaseCollection$phas = (0, $XoImS.default).phasesById[phase === null || phase === void 0 ? void 0 : phase.id]) === null || _PhaseCollection$phas === void 0 ? void 0 : _PhaseCollection$phas.tasks) || [],
                                        variant: "secondary"
                                    }, `task-selector-${project !== null && project !== void 0 && (_project$phases3 = project.phases) !== null && _project$phases3 !== void 0 && _project$phases3.length ? project === null || project === void 0 ? void 0 : project.id : "null"}-${phase !== null && phase !== void 0 && (_phase$tasks = phase.tasks) !== null && _phase$tasks !== void 0 && _phase$tasks.length ? phase === null || phase === void 0 ? void 0 : phase.id : "null"}`)
                                })
                            })
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "flex justify-around mt-[1em] pt-[1em] border-t border-t-[#d9d9d9]",
                children: [
                    showAllFlags || (0, $8kZ1o.canUseTimeEntryFlag)("billable") ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                        label: "Billable",
                        className: "is-billable-checkbox",
                        indeterminate: isBillable === null,
                        value: isBillable == null ? "indeterminate" : isBillable,
                        onChange: setIsBillable,
                        variant: "secondary"
                    }) : null,
                    showAllFlags || (0, $8kZ1o.canUseTimeEntryFlag)("variation") ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                        label: "Variation",
                        className: "is-variation-checkbox",
                        indeterminate: isVariation === null,
                        value: isVariation == null ? "indeterminate" : isVariation,
                        onChange: setIsVariation,
                        variant: "secondary"
                    }) : null,
                    showAllFlags || (0, $8kZ1o.canUseTimeEntryFlag)("overtime") ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                        label: "Overtime",
                        className: "is-overtime-checkbox",
                        indeterminate: isOvertime === null,
                        value: isOvertime == null ? "indeterminate" : isOvertime,
                        onChange: setIsOvertime,
                        variant: "secondary"
                    }) : null,
                    (0, $8kZ1o.canUseTimeEntryFlag)("remote") ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                        label: "Remote",
                        className: "is-overtime-checkbox",
                        indeterminate: isRemote === null,
                        value: isRemote == null ? "indeterminate" : isRemote,
                        onChange: setIsRemote,
                        variant: "secondary"
                    }) : null,
                    (0, $8kZ1o.canUseTimeEntryFlag)("flex") ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                        label: "Flexi",
                        className: "is-overtime-checkbox",
                        indeterminate: isFlexi === null,
                        value: isFlexi == null ? "indeterminate" : isFlexi,
                        onChange: setIsFlexi,
                        variant: "secondary"
                    }) : null,
                    showAllFlags && (0, $8kZ1o.canEditStaffTime)((0, $1BTI2.default).user) ? /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                                label: "Invoiced",
                                className: "is-invoiced-checkbox",
                                indeterminate: beenInvoiced === null,
                                value: beenInvoiced == null ? "indeterminate" : beenInvoiced,
                                onChange: setBeenInvoiced,
                                variant: "secondary"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                                label: "Locked",
                                className: "is-locked-checkbox",
                                indeterminate: isLocked === null,
                                value: isLocked == null ? "indeterminate" : isLocked,
                                onChange: setIsLocked,
                                variant: "secondary"
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
});

});

parcelRegister("jsc4w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e299ff0e3a77fa70$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $1EEMt = parcelRequire("1EEMt");

var $fEcKX = parcelRequire("fEcKX");

var $iuzpK = parcelRequire("iuzpK");
var $e299ff0e3a77fa70$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ modalId: modalId, timeEntry: timeEntry, store: store })=>{
    const [notes, setNotes] = (0, $jbmdS.useState)(timeEntry.notes);
    const textareaRef = (0, $jbmdS.useRef)(null);
    (0, $jbmdS.useEffect)(()=>{
        // Focus on the textarea when the component mounts
        if (textareaRef.current) textareaRef.current.focus();
    }, []);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fEcKX.default), {
        modalId: modalId,
        heading: "Time Entry Notes",
        onSave: ()=>{
            timeEntry.update({
                notes: notes
            });
            timeEntry.attach();
        },
        saveLabel: "Save Notes",
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: "Note:"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $iuzpK.TextArea), {
                ref: textareaRef,
                value: notes,
                onChange: (e)=>setNotes(e.target.value),
                style: {
                    width: "100%",
                    minHeight: "10em"
                }
            })
        ]
    });
});

});
parcelRegister("iuzpK", function(module, exports) {

$parcel$export(module.exports, "TextArea", function () { return $a587b180ab7adfed$export$f5c9f3c2c4054eec; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $Yha9m = parcelRequire("Yha9m");
const $a587b180ab7adfed$export$f5c9f3c2c4054eec = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>{
    const textareaRef = $jbmdS.useRef(null);
    // Combine the forwarded ref with our local ref
    $jbmdS.useImperativeHandle(ref, ()=>textareaRef.current);
    // Function to adjust the height of the textarea
    const adjustHeight = $jbmdS.useCallback(()=>{
        const textarea = textareaRef.current;
        if (!textarea) return;
        // Reset height to auto to get the correct scrollHeight
        textarea.style.height = "auto";
        // Set the height based on content
        if (textarea.value.trim() === "") // Set to 1 line height when empty
        textarea.style.height = "2rem"; // approximately 1 line of text
        else // Set the height to match the content
        textarea.style.height = `${textarea.scrollHeight}px`;
    }, []);
    // Adjust height when content changes
    $jbmdS.useEffect(()=>{
        const textarea = textareaRef.current;
        if (!textarea) return;
        // Initial height adjustment
        adjustHeight();
        // Add event listeners
        textarea.addEventListener("input", adjustHeight);
        return ()=>{
            textarea.removeEventListener("input", adjustHeight);
        };
    }, [
        adjustHeight
    ]);
    return /*#__PURE__*/ (0, $61Ea1.jsx)("textarea", {
        className: (0, $Yha9m.cn)("flex w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm overflow-hidden resize-none", className),
        ref: textareaRef,
        ...props
    });
});
$a587b180ab7adfed$export$f5c9f3c2c4054eec.displayName = "Textarea";

});


parcelRegister("eZxCg", function(module, exports) {

$parcel$export(module.exports, "getPreviousWeekTime", function () { return $aea0d6a92a524aad$export$9c9299b602d594d6; });
$parcel$export(module.exports, "getPreviousDayTime", function () { return $aea0d6a92a524aad$export$2a4397dd354dfdea; });

var $4hBm1 = parcelRequire("4hBm1");

var $1BTI2 = parcelRequire("1BTI2");

var $iOQGT = parcelRequire("iOQGT");

var $XoImS = parcelRequire("XoImS");

var $8kZ1o = parcelRequire("8kZ1o");

var $gJT7h = parcelRequire("gJT7h");

var $keGWP = parcelRequire("keGWP");
const $aea0d6a92a524aad$export$9c9299b602d594d6 = async (staffId, beforeDate = new Date())=>{
    var _r$data, _r$data2, _r$data3;
    let r = await (0, $iOQGT.makeRequest)({
        path: `api/v1.5/previous-time/weekly`,
        method: "post",
        data: {
            staffId: staffId,
            beforeDate: (0, $4hBm1.format)(beforeDate, "yyyy-MM-dd")
        }
    });
    const phases = ((_r$data = r.data) === null || _r$data === void 0 ? void 0 : _r$data.phases) || [];
    (0, $XoImS.default).addMany(phases, {
        trackUpdates: false
    });
    const tasks = ((_r$data2 = r.data) === null || _r$data2 === void 0 ? void 0 : _r$data2.tasks) || [];
    (0, $keGWP.default).addMany(tasks, {
        trackUpdates: false
    });
    return (((_r$data3 = r.data) === null || _r$data3 === void 0 ? void 0 : _r$data3.timeEntries) || []).filter((te)=>{
        const phase = (0, $XoImS.default).phasesById[te.phaseId];
        const project = (0, $gJT7h.default).projectsById[te.projectId];
        if (!project) return false;
        return (0, $8kZ1o.canEnterTimeAgainstPhase)((0, $1BTI2.default).user, phase || project);
    });
};
const $aea0d6a92a524aad$export$2a4397dd354dfdea = async (staffId, beforeDate = new Date())=>{
    var _r$data4, _r$data5, _r$data6;
    let r = await (0, $iOQGT.makeRequest)({
        path: `api/v1.5/previous-time/daily`,
        method: "post",
        data: {
            staffId: staffId,
            beforeDate: (0, $4hBm1.format)(beforeDate, "yyyy-MM-dd")
        }
    });
    const phases = ((_r$data4 = r.data) === null || _r$data4 === void 0 ? void 0 : _r$data4.phases) || [];
    (0, $XoImS.default).addMany(phases, {
        trackUpdates: false
    });
    const tasks = ((_r$data5 = r.data) === null || _r$data5 === void 0 ? void 0 : _r$data5.tasks) || [];
    (0, $keGWP.default).addMany(tasks, {
        trackUpdates: false
    });
    return (((_r$data6 = r.data) === null || _r$data6 === void 0 ? void 0 : _r$data6.timeEntries) || []).filter((te)=>{
        const phase = (0, $XoImS.default).phasesById[te.phaseId];
        const project = (0, $gJT7h.default).projectsById[te.projectId];
        if (!project) return false;
        return (0, $8kZ1o.canEnterTimeAgainstPhase)((0, $1BTI2.default).user, phase || project);
    });
};

});

parcelRegister("hkQhK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9ecdcafcd9dae03$export$2e2bcd8739ae039; });

var $eat5C = parcelRequire("eat5C");

var $4JcCM = parcelRequire("4JcCM");

var $QiMYe = parcelRequire("QiMYe");

var $4hBm1 = parcelRequire("4hBm1");

var $1BTI2 = parcelRequire("1BTI2");

var $f44xu = parcelRequire("f44xu");

var $hfd05 = parcelRequire("hfd05");

var $htkeB = parcelRequire("htkeB");

var $8kZ1o = parcelRequire("8kZ1o");

var $6Q5sp = parcelRequire("6Q5sp");
var $c9ecdcafcd9dae03$var$_dec, $c9ecdcafcd9dae03$var$_dec2, $c9ecdcafcd9dae03$var$_dec3, $c9ecdcafcd9dae03$var$_dec4, $c9ecdcafcd9dae03$var$_dec5, $c9ecdcafcd9dae03$var$_dec6, $c9ecdcafcd9dae03$var$_dec7, $c9ecdcafcd9dae03$var$_class, $c9ecdcafcd9dae03$var$_descriptor, $c9ecdcafcd9dae03$var$_descriptor2;
function $c9ecdcafcd9dae03$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $c9ecdcafcd9dae03$var$_defineProperty(e, r, t) {
    return (r = $c9ecdcafcd9dae03$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $c9ecdcafcd9dae03$var$_toPropertyKey(t) {
    var i = $c9ecdcafcd9dae03$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $c9ecdcafcd9dae03$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $c9ecdcafcd9dae03$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $c9ecdcafcd9dae03$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $c9ecdcafcd9dae03$var$TimesheetsWeeklyStore = ($c9ecdcafcd9dae03$var$_dec = (0, $4JcCM.action).bound, $c9ecdcafcd9dae03$var$_dec2 = (0, $4JcCM.action).bound, $c9ecdcafcd9dae03$var$_dec3 = (0, $4JcCM.action).bound, $c9ecdcafcd9dae03$var$_dec4 = (0, $4JcCM.action).bound, $c9ecdcafcd9dae03$var$_dec5 = (0, $4JcCM.action).bound, $c9ecdcafcd9dae03$var$_dec6 = (0, $4JcCM.action).bound, $c9ecdcafcd9dae03$var$_dec7 = (0, $4JcCM.action).bound, $c9ecdcafcd9dae03$var$_class = class TimesheetsWeeklyStore {
    constructor(){
        $c9ecdcafcd9dae03$var$_initializerDefineProperty(this, "extraTime", $c9ecdcafcd9dae03$var$_descriptor, this);
        $c9ecdcafcd9dae03$var$_initializerDefineProperty(this, "searchParams", $c9ecdcafcd9dae03$var$_descriptor2, this);
        (0, $4JcCM.makeObservable)(this);
    }
    reset() {
        this.extraTime = [];
    }
    setSearchParams(params) {
        this.searchParams = params;
    }
    get staffId() {
        var _this$searchParams;
        return (0, $8kZ1o.canEditStaffTime)((0, $1BTI2.default).user) ? ((_this$searchParams = this.searchParams) === null || _this$searchParams === void 0 ? void 0 : _this$searchParams.staffId) || (0, $1BTI2.default).userId : (0, $1BTI2.default).userId;
    }
    get date() {
        var _this$searchParams2, _this$searchParams3;
        return (_this$searchParams2 = this.searchParams) !== null && _this$searchParams2 !== void 0 && _this$searchParams2.date ? (0, $4hBm1.parse)((_this$searchParams3 = this.searchParams) === null || _this$searchParams3 === void 0 ? void 0 : _this$searchParams3.date, "yyyy-MM-dd", new Date()) : (0, $4hBm1.startOfDay)(new Date());
    }
    addExtraTime(timeEntries) {
        this.extraTime.push(...timeEntries);
    }
    get timeEntries() {
        return [
            ...new Set([
                ...(0, $QiMYe.default).timeEntries.filter((t)=>{
                    return t.staffId === this.staffId && t.week === (0, $4hBm1.getWeek)(this.date, {
                        weekStartsOn: 1
                    }) && !t.deletedAt;
                }),
                ...this.extraTime.filter((t)=>t.staffId === this.staffId && t.week === (0, $4hBm1.getWeek)(this.date, {
                        weekStartsOn: 1
                    }) && !t.deletedAt)
            ])
        ];
    }
    clearBlankTimeEntries() {
        this.timeEntries.filter((te)=>!te.numMinutes && !te.notes).forEach((te)=>te.update({
                deletedAt: new Date()
            }));
    }
    get costCentres() {
        return [
            ...new Set(this.timeEntries.map((t)=>{
                var _t$project;
                return ((_t$project = t.project) === null || _t$project === void 0 ? void 0 : _t$project.costCentre) || {
                    id: t.costCentreId,
                    name: "Missing Cost Centre"
                };
            }))
        ];
    }
    get projects() {
        return [
            ...new Set(this.timeEntries.map((t)=>t.project))
        ];
    }
    get projectsByCostCentreId() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).groupBy([
            ...new Set(this.timeEntries.map((t)=>t.project))
        ], (pr)=>pr === null || pr === void 0 ? void 0 : pr.costCentreId);
    }
    get phasesByProjectId() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).mapValues((0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).groupBy(this.timeEntries, (ph)=>ph === null || ph === void 0 ? void 0 : ph.projectId), (tes)=>[
                ...new Set(tes.map((te)=>{
                    var _te$project;
                    return te.phase || ((_te$project = te.project) === null || _te$project === void 0 ? void 0 : _te$project.rootPhase);
                }))
            ]);
    }
    get rowsByPhaseId() {
        const timeEntriesByPhaseId = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).groupBy(this.timeEntries, (te)=>{
            var _te$project2, _te$project2$rootPhas;
            return (0, $f44xu.default)(te.projectId, te.phase ? te.phaseId : (_te$project2 = te.project) === null || _te$project2 === void 0 ? void 0 : (_te$project2$rootPhas = _te$project2.rootPhase) === null || _te$project2$rootPhas === void 0 ? void 0 : _te$project2$rootPhas.id);
        });
        let rowsByPhaseId = {};
        for (const [projectPhaseId, timeEntries] of Object.entries(timeEntriesByPhaseId)){
            const filteredTimeEntries = timeEntries.filter((te)=>{
                return te.numMinutes || te.notes !== "" && te.notes !== null || new Date() - (te.createdAt || te.updatedAt) < 43200000 || !timeEntries.find((t)=>t.id !== te.id && t.date.getTime() === te.date.getTime() && t.taskId === te.taskId && t.isBillable === te.isBillable && t.isVariation === te.isVariation && t.isOvertime === te.isOvertime && t.isLocked === te.isLocked && (t.numMinutes || t.notes !== "" && t.notes !== null)) && timeEntries.find((t)=>t.date.getTime() === te.date.getTime() && t.taskId === te.taskId && t.isBillable === te.isBillable && t.isVariation === te.isVariation && t.isOvertime === te.isOvertime && t.isLocked === te.isLocked).id === te.id;
            });
            const possibleRows = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).groupBy(filteredTimeEntries, (te)=>(0, $f44xu.default)(te.taskId, te.isBillable, te.isVariation, te.isOvertime, te.isLocked));
            rowsByPhaseId[projectPhaseId] = [];
            for (const [key, timeEntries] of Object.entries(possibleRows)){
                let entriesToAdd = [
                    ...timeEntries
                ];
                while(entriesToAdd.length > 0){
                    var _rowsByPhaseId$projec2, _rowIndex, _rowsByPhaseId$projec3;
                    const entry = entriesToAdd.shift();
                    let rowIndex = 0;
                    while((_rowsByPhaseId$projec = rowsByPhaseId[projectPhaseId][rowIndex]) !== null && _rowsByPhaseId$projec !== void 0 && _rowsByPhaseId$projec[entry.date.getTime()]){
                        var _rowsByPhaseId$projec;
                        rowIndex++;
                    }
                    (_rowsByPhaseId$projec3 = (_rowsByPhaseId$projec2 = rowsByPhaseId[projectPhaseId])[_rowIndex = rowIndex]) !== null && _rowsByPhaseId$projec3 !== void 0 ? _rowsByPhaseId$projec3 : _rowsByPhaseId$projec2[_rowIndex] = {
                        entries: [],
                        costCentreId: entry.costCentreId,
                        projectId: entry.projectId,
                        phaseId: entry.phaseId,
                        taskId: entry.taskId,
                        isBillable: entry.isBillable,
                        isVariation: entry.isVariation,
                        isOvertime: entry.isOvertime,
                        isLocked: entry.isLocked
                    };
                    rowsByPhaseId[projectPhaseId][rowIndex].entries.push(entry);
                    rowsByPhaseId[projectPhaseId][rowIndex][entry.date.getTime()] = entry;
                }
                rowsByPhaseId[projectPhaseId].forEach((row)=>{
                    this.daysOfWeek.forEach((day)=>{
                        var _day$getTime, _row$_day$getTime;
                        (_row$_day$getTime = row[_day$getTime = day.getTime()]) !== null && _row$_day$getTime !== void 0 ? _row$_day$getTime : row[_day$getTime] = new (0, $hfd05.default)({
                            date: day,
                            costCentreId: row.costCentreId,
                            projectId: row.projectId,
                            phaseId: row.phaseId,
                            taskId: row.taskId,
                            isBillable: row.isBillable,
                            isVariation: row.isVariation,
                            isOvertime: row.isOvertime,
                            isLocked: row.isLocked,
                            staffId: this.staffId || (0, $1BTI2.default).userId,
                            numMinutes: 0
                        }, {
                            trackUpdates: true,
                            detached: true
                        });
                    });
                });
            }
        }
        return rowsByPhaseId;
    }
    get staff() {
        return (0, $htkeB.default).staffsById[this.staffId] || (0, $1BTI2.default).user;
    }
    get startOfWeek() {
        return (0, $4hBm1.startOfWeek)(this.date, {
            weekStartsOn: 1
        });
    }
    get daysOfWeek() {
        return [
            ...Array(7)
        ].map((v, i)=>(0, $4hBm1.addDays)(this.startOfWeek, i));
    }
    get dailyTotals() {
        const totals = this.daysOfWeek.map((day)=>(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(((0, $QiMYe.default).timeEntriesByStaffIdDate[(0, $f44xu.default)(this.staffId, day.getTime())] || []).map((te)=>te.numMinutes)));
        return totals;
    }
    shiftPrevWeek() {
        (0, $6Q5sp.router).navigate({
            search: (prev)=>({
                    ...prev,
                    date: (0, $4hBm1.format)((0, $4hBm1.subWeeks)(this.date, 1), "yyyy-MM-dd")
                })
        });
    }
    shiftNextWeek() {
        (0, $6Q5sp.router).navigate({
            search: (prev)=>({
                    ...prev,
                    date: (0, $4hBm1.format)((0, $4hBm1.addWeeks)(this.date, 1), "yyyy-MM-dd")
                })
        });
    }
    shiftThisWeek() {
        (0, $6Q5sp.router).navigate({
            search: (prev)=>(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).omitBy({
                    ...prev,
                    date: null
                }, (v)=>v === null)
        });
    }
}, $c9ecdcafcd9dae03$var$_descriptor = $c9ecdcafcd9dae03$var$_applyDecoratedDescriptor($c9ecdcafcd9dae03$var$_class.prototype, "extraTime", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $c9ecdcafcd9dae03$var$_descriptor2 = $c9ecdcafcd9dae03$var$_applyDecoratedDescriptor($c9ecdcafcd9dae03$var$_class.prototype, "searchParams", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $c9ecdcafcd9dae03$var$_applyDecoratedDescriptor($c9ecdcafcd9dae03$var$_class.prototype, "reset", [
    $c9ecdcafcd9dae03$var$_dec
], Object.getOwnPropertyDescriptor($c9ecdcafcd9dae03$var$_class.prototype, "reset"), $c9ecdcafcd9dae03$var$_class.prototype), $c9ecdcafcd9dae03$var$_applyDecoratedDescriptor($c9ecdcafcd9dae03$var$_class.prototype, "setSearchParams", [
    $c9ecdcafcd9dae03$var$_dec2
], Object.getOwnPropertyDescriptor($c9ecdcafcd9dae03$var$_class.prototype, "setSearchParams"), $c9ecdcafcd9dae03$var$_class.prototype), $c9ecdcafcd9dae03$var$_applyDecoratedDescriptor($c9ecdcafcd9dae03$var$_class.prototype, "addExtraTime", [
    $c9ecdcafcd9dae03$var$_dec3
], Object.getOwnPropertyDescriptor($c9ecdcafcd9dae03$var$_class.prototype, "addExtraTime"), $c9ecdcafcd9dae03$var$_class.prototype), $c9ecdcafcd9dae03$var$_applyDecoratedDescriptor($c9ecdcafcd9dae03$var$_class.prototype, "clearBlankTimeEntries", [
    $c9ecdcafcd9dae03$var$_dec4
], Object.getOwnPropertyDescriptor($c9ecdcafcd9dae03$var$_class.prototype, "clearBlankTimeEntries"), $c9ecdcafcd9dae03$var$_class.prototype), $c9ecdcafcd9dae03$var$_applyDecoratedDescriptor($c9ecdcafcd9dae03$var$_class.prototype, "costCentres", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c9ecdcafcd9dae03$var$_class.prototype, "costCentres"), $c9ecdcafcd9dae03$var$_class.prototype), $c9ecdcafcd9dae03$var$_applyDecoratedDescriptor($c9ecdcafcd9dae03$var$_class.prototype, "projects", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c9ecdcafcd9dae03$var$_class.prototype, "projects"), $c9ecdcafcd9dae03$var$_class.prototype), $c9ecdcafcd9dae03$var$_applyDecoratedDescriptor($c9ecdcafcd9dae03$var$_class.prototype, "projectsByCostCentreId", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c9ecdcafcd9dae03$var$_class.prototype, "projectsByCostCentreId"), $c9ecdcafcd9dae03$var$_class.prototype), $c9ecdcafcd9dae03$var$_applyDecoratedDescriptor($c9ecdcafcd9dae03$var$_class.prototype, "phasesByProjectId", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c9ecdcafcd9dae03$var$_class.prototype, "phasesByProjectId"), $c9ecdcafcd9dae03$var$_class.prototype), $c9ecdcafcd9dae03$var$_applyDecoratedDescriptor($c9ecdcafcd9dae03$var$_class.prototype, "rowsByPhaseId", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c9ecdcafcd9dae03$var$_class.prototype, "rowsByPhaseId"), $c9ecdcafcd9dae03$var$_class.prototype), $c9ecdcafcd9dae03$var$_applyDecoratedDescriptor($c9ecdcafcd9dae03$var$_class.prototype, "staff", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c9ecdcafcd9dae03$var$_class.prototype, "staff"), $c9ecdcafcd9dae03$var$_class.prototype), $c9ecdcafcd9dae03$var$_applyDecoratedDescriptor($c9ecdcafcd9dae03$var$_class.prototype, "startOfWeek", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c9ecdcafcd9dae03$var$_class.prototype, "startOfWeek"), $c9ecdcafcd9dae03$var$_class.prototype), $c9ecdcafcd9dae03$var$_applyDecoratedDescriptor($c9ecdcafcd9dae03$var$_class.prototype, "daysOfWeek", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c9ecdcafcd9dae03$var$_class.prototype, "daysOfWeek"), $c9ecdcafcd9dae03$var$_class.prototype), $c9ecdcafcd9dae03$var$_applyDecoratedDescriptor($c9ecdcafcd9dae03$var$_class.prototype, "dailyTotals", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($c9ecdcafcd9dae03$var$_class.prototype, "dailyTotals"), $c9ecdcafcd9dae03$var$_class.prototype), $c9ecdcafcd9dae03$var$_applyDecoratedDescriptor($c9ecdcafcd9dae03$var$_class.prototype, "shiftPrevWeek", [
    $c9ecdcafcd9dae03$var$_dec5
], Object.getOwnPropertyDescriptor($c9ecdcafcd9dae03$var$_class.prototype, "shiftPrevWeek"), $c9ecdcafcd9dae03$var$_class.prototype), $c9ecdcafcd9dae03$var$_applyDecoratedDescriptor($c9ecdcafcd9dae03$var$_class.prototype, "shiftNextWeek", [
    $c9ecdcafcd9dae03$var$_dec6
], Object.getOwnPropertyDescriptor($c9ecdcafcd9dae03$var$_class.prototype, "shiftNextWeek"), $c9ecdcafcd9dae03$var$_class.prototype), $c9ecdcafcd9dae03$var$_applyDecoratedDescriptor($c9ecdcafcd9dae03$var$_class.prototype, "shiftThisWeek", [
    $c9ecdcafcd9dae03$var$_dec7
], Object.getOwnPropertyDescriptor($c9ecdcafcd9dae03$var$_class.prototype, "shiftThisWeek"), $c9ecdcafcd9dae03$var$_class.prototype), $c9ecdcafcd9dae03$var$_class);
var $c9ecdcafcd9dae03$export$2e2bcd8739ae039 = new $c9ecdcafcd9dae03$var$TimesheetsWeeklyStore();

});


parcelRegister("lqn89", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f98df7e3feb7019d$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $4hBm1 = parcelRequire("4hBm1");
parcelRequire("f44xu");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $ewAM3 = parcelRequire("ewAM3");

var $80DmM = parcelRequire("80DmM");
parcelRequire("htkeB");
parcelRequire("QiMYe");

var $khJQv = parcelRequire("khJQv");

var $1BTI2 = parcelRequire("1BTI2");

var $36Jjh = parcelRequire("36Jjh");

var $aRbBG = parcelRequire("aRbBG");

var $hP0jf = parcelRequire("hP0jf");

var $hkQhK = parcelRequire("hkQhK");

var $8kZ1o = parcelRequire("8kZ1o");

var $6UBLf = parcelRequire("6UBLf");
parcelRequire("eat5C");
var $f98df7e3feb7019d$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ date: date, tab: tab, staffId: staffId, tabs: tabs, selectedTab: selectedTab })=>{
    const [store, setStore] = (0, $jbmdS.useState)(selectedTab === "daily" ? (0, $hP0jf.default) : (0, $hkQhK.default));
    (0, $jbmdS.useEffect)(()=>{
        store.setSearchParams({
            date: date,
            staffId: staffId
        });
    }, [
        date,
        staffId,
        tab
    ]);
    const startDate = (0, $4hBm1.startOfWeek)(store.date, {
        weekStartsOn: 1
    });
    const endDate = (0, $4hBm1.endOfWeek)(store.date, {
        weekStartsOn: 1
    });
    const navigate = (0, $6UBLf.useNavigate)();
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $36Jjh.default), {
        heading: selectedTab === "daily" ? `Timesheets: ${(0, $4hBm1.format)(store.date, "dd MMM yyyy")}` : `Timesheets: ${(0, $4hBm1.format)(startDate, "dd MMM yyyy")} - ${(0, $4hBm1.format)(endDate, "dd MMM yyyy")}`,
        rightButtons: /*#__PURE__*/ (0, $61Ea1.jsxs)("button", {
            className: "btn btn-danger py-1.5 px-3 border bg-danger border-danger text-white rounded text-sm",
            onClick: ()=>store.clearBlankTimeEntries(),
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                    className: "fa fa-times mr-2.5"
                }),
                "Clear Blank Time Entries"
            ]
        }),
        extraContent: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    className: "text-white",
                    children: [
                        "Try our mobile timesheet app at ",
                        /*#__PURE__*/ (0, $61Ea1.jsx)("a", {
                            href: "https://mobile.coincraft.co",
                            target: "_blank",
                            className: "!text-gold",
                            children: "mobile.coincraft.co"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    className: "flex gap-2 items-center mt-4 overflow-visible",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                            className: "btn btn-default add-timesheet-entry-button plus-btn",
                            onClick: ()=>(0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $aRbBG.default), {
                                    modalId: "addEntry",
                                    dates: store.daysOfWeek,
                                    staff: store.staff,
                                    store: store
                                })),
                            children: "+ Add time entry"
                        }),
                        (0, $8kZ1o.canEditStaffTime)((0, $1BTI2.default).user) ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.StaffSelector), {
                            className: "timesheet__staff-selector",
                            selectedStaffMember: store.staff,
                            allowNull: false,
                            onChange: (staff)=>{
                                navigate({
                                    search: (prev)=>({
                                            ...prev,
                                            staffId: staff.id
                                        })
                                });
                            }
                        }) : null,
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            className: "w-[200px]",
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $80DmM.DatePicker), {
                                className: "w-[200px] text-black",
                                popoverClassName: "!z-[9999999999]",
                                value: store.date,
                                onChange: (date)=>{
                                    navigate({
                                        search: (prev)=>({
                                                ...prev,
                                                date: (0, $4hBm1.format)(date, "yyyy-MM-dd")
                                            })
                                    });
                                }
                            })
                        })
                    ]
                })
            ]
        }),
        tabs: tabs,
        selectedTab: selectedTab
    });
});

});

parcelRegister("rddxB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $051cc66e8e810ac8$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $02LyB = parcelRequire("02LyB");

var $4hBm1 = parcelRequire("4hBm1");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("eNcHX");

var $QiMYe = parcelRequire("QiMYe");

var $1BTI2 = parcelRequire("1BTI2");

var $y5iig = parcelRequire("y5iig");

var $hkQhK = parcelRequire("hkQhK");

var $e8Hda = parcelRequire("e8Hda");

var $eat5C = parcelRequire("eat5C");

var $khJQv = parcelRequire("khJQv");

var $aRbBG = parcelRequire("aRbBG");

var $jsc4w = parcelRequire("jsc4w");

var $fM2j4 = parcelRequire("fM2j4");

var $eZxCg = parcelRequire("eZxCg");
parcelRequire("hfd05");

var $f44xu = parcelRequire("f44xu");

var $ax8Km = parcelRequire("ax8Km");

var $6RcUP = parcelRequire("6RcUP");

var $4iw5i = parcelRequire("4iw5i");
parcelRequire("jE5CX");

var $8kZ1o = parcelRequire("8kZ1o");

var $XoImS = parcelRequire("XoImS");
parcelRequire("6Q5sp");
parcelRequire("jYjJH");
parcelRequire("gJT7h");

var $3h7sC = parcelRequire("3h7sC");

var $47i9t = parcelRequire("47i9t");
var $051cc66e8e810ac8$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ date: date, staffId: staffId })=>{
    var _date;
    (_date = date) !== null && _date !== void 0 ? _date : date = (0, $4hBm1.format)(new Date(), "yyyy-MM-dd");
    const [store, setStore] = (0, $jbmdS.useState)((0, $hkQhK.default));
    (0, $jbmdS.useEffect)(()=>{
        store.setSearchParams({
            date: date,
            staffId: staffId
        });
    }, [
        date,
        staffId
    ]);
    (0, $jbmdS.useEffect)(()=>{
        (0, $fM2j4.default).setAutosave(true);
        // TimeEntryCollection.clear()
        // TimeEntryAggregateCollection.clear()
        // store.reset()
        return ()=>(0, $fM2j4.default).setAutosave(false);
    }, []);
    const startDate = (0, $4hBm1.format)((0, $4hBm1.startOfWeek)(new Date(date), {
        weekStartsOn: 1
    }), "yyyy-MM-dd");
    const endDate = (0, $4hBm1.format)((0, $4hBm1.endOfWeek)(new Date(date), {
        weekStartsOn: 1
    }), "yyyy-MM-dd");
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "max-w-[1040px] mx-auto mb-auto w-[1040px]",
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)($051cc66e8e810ac8$var$TimesheetNav, {
                monday: store.startOfWeek,
                dayTotals: store.dailyTotals,
                store: store
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6RcUP.default), {
                queryIds: [
                    {
                        queryKey: [
                            "timesheets-weekly",
                            startDate,
                            staffId
                        ],
                        queryFn: async ()=>{
                            const result = await (0, $3h7sC.trpc).legacy.getTimesheetData.query({
                                startDate: startDate,
                                endDate: endDate,
                                staffId: store.staffId,
                                autoPopulate: (0, $8kZ1o.shouldAutoPopulatePhasesInTimesheets)()
                            });
                            return (0, $47i9t.processTRPCData)(result);
                        },
                        cacheTime: 0,
                        staleTime: 0
                    }
                ],
                loading: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    style: {
                        padding: "8em"
                    },
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $4iw5i.default), {})
                }),
                children: /*#__PURE__*/ (0, $61Ea1.jsx)($051cc66e8e810ac8$var$TimesheetRows, {
                    store: store
                })
            })
        ]
    });
});
const $051cc66e8e810ac8$var$TimesheetRows = (0, $1EEMt.observer)(({ store: store })=>{
    (0, $jbmdS.useEffect)(()=>{
        if (!(0, $8kZ1o.shouldAutoPopulatePhasesInTimesheets)()) return;
        store.timeEntries.forEach((te)=>{
            if ((0, $8kZ1o.canEnterTimeAgainstPhase)(store.staff || (0, $1BTI2.default).user, te.phase)) te.update({
                isLocked: false
            }, {
                trackUpdates: false
            });
        });
        const existingPhases = new Set(Object.keys(store.rowsByPhaseId));
        const phasesToAdd = new Set();
        (0, $XoImS.default).phases.forEach((ph)=>{
            if (existingPhases.has(String((0, $f44xu.default)(ph === null || ph === void 0 ? void 0 : ph.projectId, ph === null || ph === void 0 ? void 0 : ph.id)))) return;
            if ((0, $8kZ1o.autoPopulatePhaseInTimesheets)(store.staff || (0, $1BTI2.default).user, ph) && (0, $8kZ1o.canEnterTimeAgainstPhase)(store.staff || (0, $1BTI2.default).user, ph)) phasesToAdd.add(ph);
        });
        store.addExtraTime([
            ...phasesToAdd
        ].map((ph)=>{
            var _ph$defaultTask, _ph$defaultTask2, _ph$defaultTask3;
            return (0, $QiMYe.default).add({
                costCentreId: ph === null || ph === void 0 ? void 0 : ph.project.costCentreId,
                projectId: ph === null || ph === void 0 ? void 0 : ph.projectId,
                phaseId: ph === null || ph === void 0 ? void 0 : ph.id,
                staffId: store.staffId || (0, $1BTI2.default).userId,
                taskId: (_ph$defaultTask = ph.defaultTask) === null || _ph$defaultTask === void 0 ? void 0 : _ph$defaultTask.id,
                isBillable: (_ph$defaultTask2 = ph.defaultTask) === null || _ph$defaultTask2 === void 0 ? void 0 : _ph$defaultTask2.isBillable,
                isVariation: (_ph$defaultTask3 = ph.defaultTask) === null || _ph$defaultTask3 === void 0 ? void 0 : _ph$defaultTask3.isVariation,
                date: store.daysOfWeek[0],
                numMinutes: 0
            }, {
                trackUpdates: true
            });
        }));
    }, [
        store
    ]);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "mt-8",
        children: [
            (store.costCentres || []).sort((a, b)=>{
                var _a$name, _a$name$localeCompare;
                return a === null || a === void 0 ? void 0 : (_a$name = a.name) === null || _a$name === void 0 ? void 0 : (_a$name$localeCompare = _a$name.localeCompare) === null || _a$name$localeCompare === void 0 ? void 0 : _a$name$localeCompare.call(_a$name, b === null || b === void 0 ? void 0 : b.name);
            }).map((cc)=>{
                return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)($051cc66e8e810ac8$var$TimesheetCostCentre, {
                            costCentre: cc
                        }),
                        (store.projectsByCostCentreId[cc === null || cc === void 0 ? void 0 : cc.id] || []).sort((a, b)=>{
                            const aName = a.title || "";
                            const bName = b.title || "";
                            return aName.localeCompare(bName);
                        }).map((pr)=>{
                            return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)($051cc66e8e810ac8$var$TimesheetProject, {
                                        project: pr
                                    }),
                                    (store.phasesByProjectId[pr === null || pr === void 0 ? void 0 : pr.id] || []).sort((a, b)=>{
                                        const aName = a.title || "";
                                        const bName = b.title || "";
                                        return aName.localeCompare(bName);
                                    }).map((ph)=>{
                                        return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                            className: "phase-block timesheet-widget__row",
                                            children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                                className: "timesheet-widget__phase-block timesheet-widget__row__inner w-full",
                                                children: [
                                                    /*#__PURE__*/ (0, $61Ea1.jsx)($051cc66e8e810ac8$var$TimesheetPhase, {
                                                        project: pr,
                                                        phase: ph,
                                                        store: store
                                                    }),
                                                    (store.rowsByPhaseId[(0, $f44xu.default)(pr === null || pr === void 0 ? void 0 : pr.id, ph === null || ph === void 0 ? void 0 : ph.id)] || []).sort((a, b)=>{
                                                        var _a$task, _b$task;
                                                        const aName = ((_a$task = a.task) === null || _a$task === void 0 ? void 0 : _a$task.name) || "";
                                                        const bName = ((_b$task = b.task) === null || _b$task === void 0 ? void 0 : _b$task.name) || "";
                                                        return aName.localeCompare(bName);
                                                    }).map((row)=>{
                                                        return /*#__PURE__*/ (0, $61Ea1.jsx)($051cc66e8e810ac8$var$TaskRow, {
                                                            store: store,
                                                            row: row
                                                        });
                                                    })
                                                ]
                                            })
                                        });
                                    })
                                ]
                            });
                        })
                    ]
                });
            }),
            !store.costCentres.length && /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            className: "text-[#666666] text-3xl pb-5",
                            children: "No Time Entries"
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            className: "text-[#666666] leading-[2em]",
                            children: [
                                "There are no time entries for this week.",
                                /*#__PURE__*/ (0, $61Ea1.jsx)("br", {}),
                                "Please add an entry by clicking the button below."
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                className: "btn btn-lg btn-default add-timesheet-entry-button plus-btn border-[#ccc]",
                onClick: ()=>(0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $aRbBG.default), {
                        modalId: "addEntry",
                        dates: store.daysOfWeek,
                        staff: store.staff,
                        store: store
                    })),
                children: "+ Add time entry"
            }),
            !store.costCentres.length ? /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                className: "btn btn-lg btn-primary timesheet-widget__copy-previous-button ml-4 bg-[#428bca] m-[0.5em] text-white py-2 px-4 text-sm rounded-[6px] border border-[#357ebd] cursor-pointer hover:bg-[#428bca]/70 disabled:opacity-50 disabled:cursor-not-allowed",
                onClick: async ()=>{
                    var _store$staff;
                    const uniqueRows = await (0, $eZxCg.getPreviousWeekTime)((_store$staff = store.staff) === null || _store$staff === void 0 ? void 0 : _store$staff.id, store.date);
                    store.addExtraTime(uniqueRows.map((r)=>{
                        return (0, $QiMYe.default).add({
                            numMinutes: 0,
                            ...r,
                            staffId: store.staffId || (0, $1BTI2.default).userId,
                            date: store.daysOfWeek[0]
                        }, {
                            trackUpdates: true
                        });
                    }));
                },
                style: {
                    marginLeft: "1em"
                },
                children: "Copy previous"
            }) : null
        ]
    });
});
const $051cc66e8e810ac8$var$TimesheetCostCentre = (0, $1EEMt.observer)(({ costCentre: costCentre })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "text-[1.7em] py-[0.5em] text-left border-b border-[#aaa] mb-[0.8em]",
        children: costCentre === null || costCentre === void 0 ? void 0 : costCentre.name
    });
});
const $051cc66e8e810ac8$var$TimesheetProject = (0, $1EEMt.observer)(({ project: project })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "project-title text-[1.4em] ml-2.5 mt-5 mb-1 font-semibold w-1/2",
        children: project.title
    });
});
const $051cc66e8e810ac8$var$TimesheetPhase = (0, $1EEMt.observer)(({ project: project, phase: phase, store: store })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "timesheet-widget__phase-row flex flex-col min-[1381px]:w-[92%] mx-auto w-full",
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "timesheet-widget__phase-title w-full",
                children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    className: "inline-flex w-full pb-[0.1em] items-end",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                            className: "btn btn-default timesheet-widget__add-task flex-0-0-auto",
                            onClick: ()=>{
                                var _phase$defaultTask, _phase$defaultTask2;
                                return (0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $aRbBG.default), {
                                    modalId: "addEntry",
                                    dates: store.daysOfWeek,
                                    staff: store.staff,
                                    store: store,
                                    defaults: {
                                        costCentre: project.costCentre,
                                        project: project,
                                        phase: phase,
                                        isBillable: (phase === null || phase === void 0 ? void 0 : (_phase$defaultTask = phase.defaultTask) === null || _phase$defaultTask === void 0 ? void 0 : _phase$defaultTask.isBillable) || true,
                                        isVariation: (phase === null || phase === void 0 ? void 0 : (_phase$defaultTask2 = phase.defaultTask) === null || _phase$defaultTask2 === void 0 ? void 0 : _phase$defaultTask2.isVariation) || false,
                                        isOvertime: false,
                                        isRemote: false,
                                        isFlexi: false
                                    }
                                }));
                            },
                            style: {
                                padding: "0.1em 0.4em",
                                margin: "0em 1em 0 0.5em",
                                fontSize: "0.6em"
                            },
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                className: "fa fa-plus",
                                style: {
                                    margin: 0
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            className: "phase-block__title flex-1-1-auto min-w-0 w-[24%]",
                            style: {
                                flex: "0 0 auto"
                            },
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "text-base",
                                children: (phase === null || phase === void 0 ? void 0 : phase.title) || "No Phase"
                            })
                        }),
                        !(0, $8kZ1o.hideBudgetProgress)() ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ax8Km.default), {
                            dropdownClassName: "!text-xs",
                            projects: store.projects,
                            project: project,
                            phase: phase,
                            role: store.staff.role,
                            staff: store.staff,
                            startDate: (0, $4hBm1.startOfWeek)(store.date, {
                                weekStartsOn: 1
                            }),
                            endDate: (0, $4hBm1.endOfWeek)(store.date, {
                                weekStartsOn: 1
                            }),
                            containerStyles: {
                                margin: "0 2em",
                                position: "relative",
                                width: "70%"
                            },
                            textStyles: {
                                marginLeft: "5em"
                            },
                            dropdownStyles: {
                                right: "1em",
                                bottom: "0.75rem",
                                height: "1.5rem",
                                maxWidth: "max-content",
                                position: "absolute"
                            },
                            dropdownAbove: true,
                            extraHours: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(store.timeEntries.filter((te)=>{
                                var _store$staff2;
                                return te.phaseId === (phase === null || phase === void 0 ? void 0 : phase.id) && te.staffId == ((_store$staff2 = store.staff) === null || _store$staff2 === void 0 ? void 0 : _store$staff2.id);
                            }).map((te)=>te.hours))
                        }) : null
                    ]
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "timesheet-widget__progress-bar timesheet-widget__middle-section",
                style: {
                    verticalAlign: "bottom"
                }
            })
        ]
    });
});
const $051cc66e8e810ac8$var$TaskRow = (0, $1EEMt.observer)(({ store: store, row: row, mode: mode })=>{
    var _row$entries$, _row$entries$$task;
    const isHighlighted = false;
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("timesheet-widget__task-row", {
            "timesheet-widget__task-row--highlighted": isHighlighted
        }),
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            className: "min-[1381px]:w-[92%] w-full mx-auto",
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    className: "timesheet-widget__task-title timesheet-widget__left-section min-[1381px]:w-[30%] w-1/4",
                    children: [
                        !row.isLocked ? /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                            className: "timesheet-widget__task-delete delete-button",
                            onClick: ()=>{
                                row.entries.forEach((te)=>te.update({
                                        deletedAt: new Date()
                                    }));
                            },
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                className: "fa fa-times fa-fw"
                            })
                        }) : null,
                        !row.isLocked ? /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                            className: "timesheet-widget__task-edit edit-button",
                            onClick: ()=>{
                                (0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $aRbBG.default), {
                                    modalId: "editEntry",
                                    timeEntries: row.entries,
                                    staff: store.staff,
                                    store: store
                                }));
                            },
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                className: "fa fa-pencil-square-o fa-fw"
                            })
                        }) : null,
                        (0, $8kZ1o.canEditStaffTime)((0, $1BTI2.default).user) && !row.isLocked ? /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                            className: "timesheet-widget__task-lock lock-button",
                            onClick: ()=>{
                                row.entries.forEach((te)=>te.update({
                                        isLocked: true
                                    }));
                            },
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                className: "fa fa-lock fa-fw"
                            })
                        }) : (0, $8kZ1o.canEditStaffTime)((0, $1BTI2.default).user) && row.isLocked ? /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                            className: "timesheet-widget__task-lock lock-button",
                            onClick: ()=>{
                                row.entries.forEach((te)=>te.update({
                                        isLocked: false
                                    }));
                            },
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                className: "fa fa-unlock fa-fw"
                            })
                        }) : null,
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            className: "text-[0.85em]",
                            children: /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                                style: {
                                    marginLeft: "0.5em"
                                },
                                children: [
                                    !row.isBillable ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                        style: {
                                            display: "inline-block"
                                        },
                                        className: "time-entry__time-options timesheet-widget__task-row__is-not-billable relative",
                                        children: [
                                            /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                                                className: "fa-stack",
                                                style: {
                                                    fontSize: "0.7em",
                                                    marginRight: "0.4em"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                                        className: "fa fa-usd fa-stack-1x"
                                                    }),
                                                    /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                                        className: "fa fa-ban fa-stack-2x"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                className: "time-entry__time-options-hover",
                                                children: "Non-Billable Time"
                                            })
                                        ]
                                    }) : null,
                                    row.isOvertime ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                        style: {
                                            display: "inline-block"
                                        },
                                        className: "time-entry__time-options timesheet-widget__task-row__is-overtime",
                                        children: [
                                            /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                                className: "fa fa-clock-o",
                                                style: {
                                                    fontSize: "1.3em",
                                                    position: "relative",
                                                    top: "0.15em"
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                className: "time-entry__time-options-hover",
                                                children: "Overtime"
                                            })
                                        ]
                                    }) : null,
                                    row.isVariation ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                        style: {
                                            display: "inline-block"
                                        },
                                        className: "time-entry__time-options timesheet-widget__task-row__is-variation",
                                        children: [
                                            /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                                className: "fa fa-code-fork",
                                                style: {
                                                    fontSize: "1.3em",
                                                    position: "relative",
                                                    top: "0.15em"
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                className: "time-entry__time-options-hover",
                                                children: "Variation"
                                            })
                                        ]
                                    }) : null,
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                        style: {
                                            marginLeft: "0.5em"
                                        },
                                        children: row.entries[0].task != null ? (_row$entries$ = row.entries[0]) === null || _row$entries$ === void 0 ? void 0 : (_row$entries$$task = _row$entries$.task) === null || _row$entries$$task === void 0 ? void 0 : _row$entries$$task.name : "(No task)"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    className: "timesheet-widget__task-entries timesheet-widget__middle-section",
                    children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "flex justify-around flex-1",
                                children: store.daysOfWeek.map((day)=>{
                                    const entry = row[day.getTime()];
                                    return entry ? /*#__PURE__*/ (0, $61Ea1.jsx)($051cc66e8e810ac8$var$WeeklyTimeEntry, {
                                        timeEntry: entry,
                                        store: store
                                    }) : null;
                                })
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "w-12 h-auto opacity-0",
                                children: "placeholder"
                            })
                        ]
                    })
                })
            ]
        })
    });
});
const $051cc66e8e810ac8$var$WeeklyTimeEntry = (0, $1EEMt.observer)(({ timeEntry: timeEntry, store: store })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("time-entry flex items-center", (0, $4hBm1.isWeekend)(timeEntry.date) ? "weekend" : null, timeEntry.isLocked ? "locked" : null),
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $y5iig.HoursInput), {
                value: timeEntry.numMinutes,
                onChange: (numMinutes)=>{
                    timeEntry.update({
                        numMinutes: numMinutes
                    });
                    timeEntry.attach();
                },
                className: "time-entry__input",
                isEditable: !timeEntry.isLocked
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                className: "btn btn-default time-entry__note h-[22px] inline-flex items-center justify-center",
                onClick: ()=>(0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $jsc4w.default), {
                        modalId: true,
                        timeEntry: timeEntry,
                        store: store
                    })),
                title: timeEntry.notes ? "Edit the note for this entry" : "Add a note for this entry",
                disabled: timeEntry.isLocked,
                children: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("fa", timeEntry.notes ? "fa-commenting" : "fa-comment")
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "time-entry__date-hover",
                children: (0, $4hBm1.format)(timeEntry.date, "eee dd")
            })
        ]
    });
});
const $051cc66e8e810ac8$var$TimesheetNav = (0, $1EEMt.observer)(({ mode: mode, monday: monday, dayTotals: dayTotals, selectedDate: selectedDate, store: store })=>{
    const formatTotal = (n, type)=>{
        return (0, $e8Hda.isNumber)(n) ? (0, $e8Hda.formatMinutes)(n) : n === "loading" ? /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
            className: "fa fa-spinner fa-spin",
            style: {
                margin: 0
            }
        }) : /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
            className: "fa fa-exclamation-triangle error-highlight-color",
            style: {
                margin: 0
            },
            title: `Some entries for this ${type} have errors.`
        });
    };
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "max-w-[1040px] bg-[#fafafa] z-[1000] pt-8 w-[1040px] sticky top-0",
        children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            className: "border-b border-[#aaa]",
            children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    className: "timesheet-widget__row min-w-[36em] mb-2.5 text-center",
                    style: {
                        fontSize: "1em"
                    },
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "timesheet-widget__row__inner min-[1310px]:w-[92%] w-full mx-auto",
                        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            className: "flex items-start",
                            // to align buttons
                            style: {
                            },
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                    className: "timesheet-widget__left-section min-[1381px]:w-[30%] w-1/4",
                                    children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                        className: "timesheets__navigation flex items-start",
                                        style: {
                                            flex: "0 0 auto"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                                className: "flex flex-col w-full text-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                                                        onClick: ()=>store.shiftThisWeek(),
                                                        className: "btn btn-default w-full py-1.5 px-3 text-sm text-[#333] bg-white border border-[#ccc] text-center whitespace-nowrap rounded hover:bg-[#e0e0e0]",
                                                        children: "This Week"
                                                    }),
                                                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                                        className: "font-semibold mt-1.5 text-sm text-[#666666]",
                                                        children: [
                                                            "Weekly Total:",
                                                            " ",
                                                            formatTotal((0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(dayTotals), "week")
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                className: "flex-0-0-auto",
                                                children: /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                                                    onClick: store.shiftPrevWeek,
                                                    className: "btn btn-default previous-week-button ml-3 py-1.5 px-3 text-[#333] bg-white border border-[#ccc] text-sm rounded",
                                                    style: {
                                                        marginLeft: "1em"
                                                    },
                                                    title: "Previous week",
                                                    children: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                                        className: "fa fa-chevron-left m-0"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                    className: "timesheet-widget__middle-section min-[1381px]:w-[65%] w-3/4",
                                    children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        className: "timesheets__day-nav flex justify-around w-full",
                                        children: dayTotals.map(function(dayTotal, dayIndex) {
                                            let d1 = (0, $4hBm1.addDays)(monday, dayIndex);
                                            let inner = /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                                className: "timesheet__nav__day__date",
                                                children: [
                                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                        className: "text-[10px] leading-[14px]",
                                                        children: (0, $4hBm1.format)(d1, "EEE")
                                                    }),
                                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                        className: "text-xl",
                                                        children: (0, $4hBm1.format)(d1, "dd")
                                                    })
                                                ]
                                            });
                                            return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                className: "flex-0-0-auto timesheet__nav__day text-center",
                                                "data-date": (0, $4hBm1.format)(d1, "yyyy-MM-dd"),
                                                style: {
                                                    fontSize: "1.1em",
                                                    textAlign: "center"
                                                },
                                                children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                                    className: "timesheet-widget__hours-cell timesheet__nav__total text-xs text-[#666666] font-semibold mt-[2px]",
                                                    style: {
                                                        fontSize: "1.1em",
                                                        textAlign: "center"
                                                    },
                                                    children: [
                                                        inner,
                                                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                            className: "timesheet-widget__hours-cell timesheet__nav__total",
                                                            style: {
                                                                fontSize: "0.9em",
                                                                fontWeight: 600,
                                                                marginTop: "0.2em"
                                                            },
                                                            children: formatTotal(dayTotal, "day")
                                                        })
                                                    ]
                                                })
                                            }, dayIndex);
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                    className: "timesheet-widget__right-section",
                                    style: {
                                        flex: "0 0 auto"
                                    },
                                    children: /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                                        onClick: store.shiftNextWeek,
                                        className: "btn btn-default next-week-button py-1.5 px-3 text-[#333] bg-white border border-[#ccc] text-sm rounded",
                                        title: "Next week",
                                        children: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                            className: "fa fa-chevron-right m-0"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
});

});


parcelRegister("gtJL8", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $bff2d997e5a8923f$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");

var $947hb = parcelRequire("947hb");

var $3UKGk = parcelRequire("3UKGk");

var $kuPRw = parcelRequire("kuPRw");

var $1BTI2 = parcelRequire("1BTI2");
parcelRequire("jE5CX");

var $4iw5i = parcelRequire("4iw5i");

var $5PXcS = parcelRequire("5PXcS");

var $8kZ1o = parcelRequire("8kZ1o");

var $7qobO = parcelRequire("7qobO");

var $26sX2 = parcelRequire("26sX2");

var $38AIP = parcelRequire("38AIP");

var $3bggp = parcelRequire("3bggp");

var $3h7sC = parcelRequire("3h7sC");

var $495xp = parcelRequire("495xp");

var $1k4cq = parcelRequire("1k4cq");

var $cnmvx = parcelRequire("cnmvx");

var $6Q5sp = parcelRequire("6Q5sp");

var $kqntg = parcelRequire("kqntg");

var $47i9t = parcelRequire("47i9t");
const $bff2d997e5a8923f$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_private/staff/")({
    beforeLoad: ({ search: search })=>{
        if (!(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "staffList", search)) throw new Error("Permission Denied");
        const report = (0, $38AIP.getCacheItemById)("organisationReports", search.report);
        (0, $26sX2.setLayoutDefaults)({
            pageTitle: (report === null || report === void 0 ? void 0 : report.name) || "Staff Report",
            subMenu: "resources"
        });
    },
    errorComponent: ({ error: error, reset: reset })=>{
        if (error.message === "Permission Denied") return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7qobO.default), {});
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    },
    pendingComponent: (0, $4iw5i.default),
    loader: async ({ location: location })=>await $bff2d997e5a8923f$var$loader(location.search),
    loaderDeps: ({ search: { report: report } })=>({
            report: report
        }),
    component: $bff2d997e5a8923f$var$Wrapper
});
const $bff2d997e5a8923f$var$loader = async ({ report: report })=>{
    var _SessionStore$organis;
    const reportId = report || ((_SessionStore$organis = (0, $1BTI2.default).organisation) === null || _SessionStore$organis === void 0 ? void 0 : _SessionStore$organis.defaultStaffReportId);
    if ((0, $8kZ1o.migratedToV2)()) {
        var _organisationReport$o;
        const res = reportId ? await (0, $3h7sC.trpc).staffReport.getOrganisationReport.query({
            reportId: reportId
        }) : null;
        const organisationReport = res || (0, $1BTI2.default).organisation.defaultStaffReport;
        let dateRange = [
            null,
            null
        ];
        if ((_organisationReport$o = organisationReport.options) !== null && _organisationReport$o !== void 0 && _organisationReport$o.dateRange) {
            var _dateStringLookup$org, _organisationReport$o2, _organisationReport$o3, _organisationReport$o4;
            dateRange = ((_dateStringLookup$org = (0, $cnmvx.dateStringLookup)[(_organisationReport$o2 = organisationReport.options) === null || _organisationReport$o2 === void 0 ? void 0 : _organisationReport$o2.dateRange]) === null || _dateStringLookup$org === void 0 ? void 0 : _dateStringLookup$org.call((0, $cnmvx.dateStringLookup), (_organisationReport$o3 = organisationReport.options) === null || _organisationReport$o3 === void 0 ? void 0 : _organisationReport$o3.fortnightType)) || ((_organisationReport$o4 = organisationReport.options) === null || _organisationReport$o4 === void 0 ? void 0 : _organisationReport$o4.dateRange);
        }
        const { columns: columns, filters: filters, groupBy: groupBy, sortBy: sortBy, options: options, name: name } = organisationReport;
        (0, $1k4cq.setOrganisationReport)({
            columns: columns,
            filters: filters,
            groupBy: groupBy,
            organisationId: (0, $1BTI2.default).organisationId,
            sortBy: sortBy,
            dateRange: dateRange,
            invoiceDateType: (0, $1BTI2.default).settings.reportInvoiceDateType,
            id: reportId,
            options: options,
            name: name
        }, {
            needsRefetch: false
        });
        const cacheData = await (0, $6Q5sp.queryClient).fetchQuery({
            queryKey: [
                "staffReportCache",
                reportId
            ],
            queryFn: ()=>{
                var _SessionStore$user;
                return (0, $3h7sC.trpc).staffReport.getReportsData.query({
                    organisationId: (0, $1BTI2.default).organisationId,
                    userId: (_SessionStore$user = (0, $1BTI2.default).user) === null || _SessionStore$user === void 0 ? void 0 : _SessionStore$user.id,
                    columns: organisationReport === null || organisationReport === void 0 ? void 0 : organisationReport.columns.filter((c)=>{
                        var _StaffReportColumns$c;
                        return !((_StaffReportColumns$c = (0, $495xp.StaffReportColumns)(reportId)[c]) !== null && _StaffReportColumns$c !== void 0 && _StaffReportColumns$c.permissions) || (0, $495xp.StaffReportColumns)(reportId)[c].permissions();
                    }),
                    filters: organisationReport === null || organisationReport === void 0 ? void 0 : organisationReport.filters.map((f)=>{
                        var _StaffReportColumns$f, _StaffReportColumns$f2;
                        if (((_StaffReportColumns$f = (0, $495xp.StaffReportColumns)(reportId)[f.column]) === null || _StaffReportColumns$f === void 0 ? void 0 : _StaffReportColumns$f.type) === "date") {
                            var _dateStringLookup$f$v;
                            let value = ((_dateStringLookup$f$v = (0, $cnmvx.dateStringLookup)[f.value]) === null || _dateStringLookup$f$v === void 0 ? void 0 : _dateStringLookup$f$v.call((0, $cnmvx.dateStringLookup))) || f.value;
                            if (Array.isArray(value)) value = value.map((d)=>d ? format(d, "yyyy-MM-dd") : null);
                            else value = value ? format(value, "yyyy-MM-dd") : null;
                            return {
                                ...f,
                                value: value
                            };
                        } else if (((_StaffReportColumns$f2 = (0, $495xp.StaffReportColumns)(reportId)[f.column]) === null || _StaffReportColumns$f2 === void 0 ? void 0 : _StaffReportColumns$f2.type) === "staff") {
                            let value = f.value;
                            if (Array.isArray(value)) value = value.map((d)=>{
                                d = new Date(d);
                                return d && d.getTime() ? format(d, "yyyy-MM-dd HH:mm") : null;
                            });
                            else {
                                value = new Date(value);
                                value = value && value.getTime() ? format(value, "yyyy-MM-dd HH:mm") : null;
                            }
                            return {
                                ...f,
                                value: value
                            };
                        } else return f;
                    }),
                    sortBy: (organisationReport === null || organisationReport === void 0 ? void 0 : organisationReport.sortBy) || [],
                    groupBy: (organisationReport === null || organisationReport === void 0 ? void 0 : organisationReport.groupBy) || [],
                    dateRange: dateRange,
                    invoiceDateType: (0, $1BTI2.default).settings.reportInvoiceDateType
                });
            },
            staleTime: 300000
        });
        (0, $1k4cq.setReportData)(cacheData);
    }
    const data = await (0, $3h7sC.trpc).legacy.getStaffListPageData.query({
        reportId: reportId
    });
    return (0, $47i9t.processTRPCData)(data);
};
function $bff2d997e5a8923f$var$Wrapper() {
    const { report: report } = $bff2d997e5a8923f$export$e7b0ac011bb776c6.useSearch();
    if ((0, $8kZ1o.migratedToV2)()) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqntg.PageBody), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3bggp.StaffReportPage), {})
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3UKGk.default), {
                id: report
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kuPRw.default), {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $947hb.default), {
                    id: report
                })
            })
        ]
    });
}

});
parcelRegister("947hb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $699a21ada289027d$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $goLmS = parcelRequire("goLmS");

var $h6zQv = parcelRequire("h6zQv");
parcelRequire("htkeB");

var $1BTI2 = parcelRequire("1BTI2");

var $4iw5i = parcelRequire("4iw5i");

var $6RcUP = parcelRequire("6RcUP");

var $6un1H = parcelRequire("6un1H");

var $3erXY = parcelRequire("3erXY");

var $cnmvx = parcelRequire("cnmvx");

var $3h7sC = parcelRequire("3h7sC");

var $4hBm1 = parcelRequire("4hBm1");

var $47i9t = parcelRequire("47i9t");
var $699a21ada289027d$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ id: id })=>{
    var _FetchStore$getRespon, _FetchStore$getRespon2;
    const report = (0, $h6zQv.default).reportsById[id] || (0, $1BTI2.default).organisation.defaultStaffReport;
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $6RcUP.default), {
        loading: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $4iw5i.default), {}),
        queryIds: [
            {
                id: "staffReport" + report.queryKey,
                cacheTime: 0,
                staleTime: 0,
                queryFn: async ()=>{
                    const data = await (0, $3h7sC.trpc).staffReport.getReportsData.query({
                        columns: report.columns.filter((c)=>{
                            var _report$columnOptions;
                            return !((_report$columnOptions = report.columnOptionsById[c]) !== null && _report$columnOptions !== void 0 && _report$columnOptions.permissions) || report.columnOptionsById[c].permissions();
                        }),
                        filters: report.filters.map((f)=>{
                            var _report$columnOptions2;
                            if (((_report$columnOptions2 = report.columnOptionsById[f.column]) === null || _report$columnOptions2 === void 0 ? void 0 : _report$columnOptions2.type) === "date") {
                                var _dateStringLookup$f$v;
                                let value = ((_dateStringLookup$f$v = (0, $cnmvx.dateStringLookup)[f.value]) === null || _dateStringLookup$f$v === void 0 ? void 0 : _dateStringLookup$f$v.call((0, $cnmvx.dateStringLookup))) || f.value;
                                if (Array.isArray(value)) value = value.map((d)=>d ? (0, $4hBm1.format)(d, "yyyy-MM-dd") : null);
                                else value = value ? (0, $4hBm1.format)(value, "yyyy-MM-dd") : null;
                                return {
                                    ...f,
                                    value: value
                                };
                            } else return f;
                        }),
                        groupBy: [],
                        sortBy: report.sortBy || [],
                        dateRange: report.dateRange.map((d)=>isFinite(d) ? (0, $4hBm1.format)(d, "yyyy-MM-dd") : null),
                        invoiceDateType: (0, $1BTI2.default).settings.reportInvoiceDateType
                    });
                    return (0, $47i9t.processTRPCData)(data, "staffReport" + report.queryKey);
                }
            }
        ],
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3erXY.default), {
                report: report
            }),
            !(report !== null && report !== void 0 && report.needsUpdate) ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
                tableStore: report.tableStore,
                columns: report.tableColumns,
                rows: (_FetchStore$getRespon = (0, $6un1H.default).getResponse("staffReport" + report.queryKey)) === null || _FetchStore$getRespon === void 0 ? void 0 : (_FetchStore$getRespon2 = _FetchStore$getRespon.map((staff)=>{
                    delete staff.id;
                    return staff;
                })) === null || _FetchStore$getRespon2 === void 0 ? void 0 : _FetchStore$getRespon2.filter((staff)=>staff.name.toLowerCase().includes(report.searchFilter.toLowerCase())),
                sortBy: report.sortBy,
                showTotals: true
            }) : null
        ]
    }, "staff-table" + report.queryKey);
});

});

parcelRegister("3UKGk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d9ad018d125ce6d$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $36Jjh = parcelRequire("36Jjh");

var $h6zQv = parcelRequire("h6zQv");

var $1BTI2 = parcelRequire("1BTI2");

var $jr4Q7 = parcelRequire("jr4Q7");

var $htkeB = parcelRequire("htkeB");

var $8kZ1o = parcelRequire("8kZ1o");

var $4hBm1 = parcelRequire("4hBm1");

var $3X7oM = parcelRequire("3X7oM");

var $6UBLf = parcelRequire("6UBLf");
var $2d9ad018d125ce6d$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ id: id })=>{
    const navigate = (0, $6UBLf.useNavigate)();
    const report = (0, $h6zQv.default).reportsById[id] || (0, $1BTI2.default).organisation.defaultStaffReport;
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $36Jjh.default), {
        heading: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    children: "Staff"
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    className: "text-sm font-normal px-2.5 py-1.5",
                    children: isFinite(report.dateRange[0]) ? `(${(0, $4hBm1.format)(report.dateRange[0], "dd MMMM yyyy")} - ${(0, $4hBm1.format)(report.dateRange[1], "dd MMMM yyyy")})` : `(All time prior to: ${(0, $4hBm1.format)(new Date(), "dd MMMM yyyy")})`
                })
            ]
        }),
        leftButtons: [
            (0, $8kZ1o.canCreateStaff)((0, $1BTI2.default).user) ? /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                className: "project-list__add-new-project-button page-header__button--primary plus-btn",
                onClick: ()=>{
                    const staff = (0, $htkeB.default).createStaff();
                    navigate({
                        to: "/staff/" + staff.id
                    });
                },
                children: "+ New Staff Member"
            }, 0) : null
        ],
        rightButtons: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            className: "flex items-center gap-2",
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3X7oM.default), {
                    label: "Export",
                    icon: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                        className: "fa fa-table"
                    }),
                    onClick: ()=>{
                        report.downloadCSV();
                    }
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3X7oM.default), {
                    label: "Print",
                    icon: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                        className: "fa fa-print"
                    }),
                    onClick: ()=>window.print()
                })
            ]
        }),
        filter: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jr4Q7.ReportSearch), {
            report: report,
            placeholder: "Filter by staff name"
        }),
        extraContent: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jr4Q7.default), {
            report: report,
            reportOptions: (0, $h6zQv.default).reportsByType["staffMember"],
            baseUrl: "/staff"
        })
    });
});

});

parcelRegister("3bggp", function(module, exports) {

$parcel$export(module.exports, "StaffReportPage", function () { return $15f643b983e47b04$export$f0686c8fc289f470; });

var $61Ea1 = parcelRequire("61Ea1");

var $3XA9Y = parcelRequire("3XA9Y");
const $15f643b983e47b04$export$f0686c8fc289f470 = ()=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3XA9Y.StaffReportTable), {});
};

});
parcelRegister("3XA9Y", function(module, exports) {

$parcel$export(module.exports, "StaffReportTable", function () { return $0232ce88b398c8b9$export$5aed3367e85fd5c1; });

var $61Ea1 = parcelRequire("61Ea1");

var $3h7sC = parcelRequire("3h7sC");

var $O2UPo = parcelRequire("O2UPo");

var $gcfa1 = parcelRequire("gcfa1");

var $aYyI4 = parcelRequire("aYyI4");

var $aaosT = parcelRequire("aaosT");

var $kKJbF = parcelRequire("kKJbF");

var $8d9Bx = parcelRequire("8d9Bx");

var $1k4cq = parcelRequire("1k4cq");

var $3pwHC = parcelRequire("3pwHC");

var $jbmdS = parcelRequire("jbmdS");
function $0232ce88b398c8b9$export$5aed3367e85fd5c1() {
    var _organisationReport$f;
    const organisationReport = (0, $1k4cq.useOrganisationReport)();
    const reportData = (0, $1k4cq.useReportData)();
    const isLoadingReportData = (0, $1k4cq.useIsLoadingReportData)();
    const pendingChanges = (0, $1k4cq.usePendingChanges)();
    const handleStateChange = (newState, options)=>{
        (0, $1k4cq.setOrganisationReport)({
            ...organisationReport,
            ...newState
        }, options);
    };
    const handleColumnsChange = (columns, options)=>{
        (0, $1k4cq.setColumns)(columns, options);
    };
    const handleApplyChanges = async ()=>{
        (0, $1k4cq.setIsLoadingReportData)(true);
        try {
            const data = await fetchReportData({
                ...organisationReport,
                groupBy: organisationReport.groupBy || [],
                sortBy: organisationReport.sortBy || []
            });
            (0, $1k4cq.setReportData)(data);
        } finally{
            (0, $1k4cq.setIsLoadingReportData)(false);
            (0, $1k4cq.setPendingChanges)(false);
        }
    };
    const columns = (0, $jbmdS.useMemo)(()=>(0, $kKJbF.orderColumnDefs)((0, $8d9Bx.getColumns)((column)=>{
            (0, $1k4cq.setColumns)(organisationReport.columns.filter((c)=>c !== column), {
                needsRefetch: false
            });
        }), organisationReport.columns, [], []), [
        organisationReport.columns
    ]);
    const filterFields = columns.map((column)=>{
        var _column$meta, _column$meta2, _column$meta3;
        return {
            label: column === null || column === void 0 ? void 0 : (_column$meta = column.meta) === null || _column$meta === void 0 ? void 0 : _column$meta.title,
            value: column.accessorKey,
            typeFilter: (0, $O2UPo.typeFilterMap)[column === null || column === void 0 ? void 0 : (_column$meta2 = column.meta) === null || _column$meta2 === void 0 ? void 0 : _column$meta2.type],
            ...column === null || column === void 0 ? void 0 : (_column$meta3 = column.meta) === null || _column$meta3 === void 0 ? void 0 : _column$meta3.filterOptions
        };
    });
    const defaultSort = [
        {
            id: "name",
            desc: false
        }
    ];
    const { table: table } = (0, $aaosT.useDataTable)({
        data: reportData,
        defaultSort: defaultSort,
        columns: columns,
        visibleColumns: organisationReport.columns,
        filterFields: filterFields,
        enableAdvancedFilter: true,
        sortingFns: {
            sortingTextFn: $O2UPo.sortingTextFn,
            sortingProgressFn: $O2UPo.sortingProgressFn,
            sortingDateFn: $O2UPo.sortingDateFn
        }
    });
    const fetchReportData = async (data)=>{
        return await (0, $3h7sC.trpc).staffReport.getReportsData.query(data);
    };
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $aYyI4.DataTable), {
        table: table,
        showTotals: true,
        loadingReportData: isLoadingReportData,
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $gcfa1.DataTableAdvancedToolbar), {
            table: table,
            filterFields: filterFields,
            searchableFields: [
                "name",
                "firstName",
                "lastName"
            ],
            tableState: {
                columns: organisationReport.columns,
                filters: (_organisationReport$f = organisationReport.filters) !== null && _organisationReport$f !== void 0 ? _organisationReport$f : [],
                dateRange: organisationReport.dateRange,
                sortBy: organisationReport.sortBy,
                groupBy: organisationReport.groupBy
            },
            pendingChanges: pendingChanges,
            onStateChange: handleStateChange,
            onColumnsChange: handleColumnsChange,
            onApplyChanges: handleApplyChanges,
            isLoading: isLoadingReportData,
            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3pwHC.StaffReportActions), {
                table: table
            })
        })
    });
}

});
parcelRegister("gcfa1", function(module, exports) {

$parcel$export(module.exports, "DataTableAdvancedToolbar", function () { return $f0b2aa2172a841a7$export$6abb1c1d83798fa0; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $jSiTu = parcelRequire("jSiTu");

var $Yha9m = parcelRequire("Yha9m");

var $fTGwv = parcelRequire("fTGwv");

var $2YJBX = parcelRequire("2YJBX");

var $eL2bj = parcelRequire("eL2bj");

var $dafh3 = parcelRequire("dafh3");

var $6nxaR = parcelRequire("6nxaR");

var $3QWaF = parcelRequire("3QWaF");

var $65wBC = parcelRequire("65wBC");
function $f0b2aa2172a841a7$export$6abb1c1d83798fa0({ table: table, filterFields: filterFields = [], tableState: tableState, onStateChange: onStateChange, onApplyChanges: onApplyChanges, onColumnsChange: onColumnsChange, isLoading: isLoading = false, children: children, className: className, groupByColumns: groupByColumns = [], fixedColumns: fixedColumns = [], showSearchFieldHeader: showSearchFieldHeader = true, showApplyToPhase: showApplyToPhase = true, isHaveGroup: isHaveGroup = false, pendingChanges: pendingChanges = false, searchableFields: searchableFields = [], ...props }) {
    const [globalFilter, setGlobalFilter] = $jbmdS.useState("");
    const [error, setError] = $jbmdS.useState(null);
    // Convert dates for display
    const displayDates = tableState !== null && tableState !== void 0 && tableState.dateRange ? tableState.dateRange.map((date)=>{
        if (typeof date === "number" && date === -Infinity) return (0, $65wBC.subYears)(new Date(), 50);
        if (typeof date === "number" && date === Infinity) return new Date();
        return date ? new Date(date) : new Date();
    }) : [
        new Date(),
        new Date()
    ];
    const handleApplyChanges = async ()=>{
        try {
            setError(null);
            await onApplyChanges();
        } catch (err) {
            setError("Failed to update report. Please try again.");
            console.error(err);
        }
    };
    const handleSearch = (value)=>{
        setGlobalFilter(value);
        table.setGlobalFilter(value);
    };
    // Custom global filter function
    const globalFilterFn = $jbmdS.useCallback((row, columnId, filterValue)=>{
        const searchValue = String(filterValue).toLowerCase();
        return searchableFields.some((field)=>{
            const value = row.getValue(field);
            return value && String(value).toLowerCase().includes(searchValue);
        });
    }, [
        searchableFields
    ]);
    $jbmdS.useEffect(()=>{
        if (table) table.options.globalFilterFn = globalFilterFn;
    }, [
        table,
        globalFilterFn
    ]);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: (0, $Yha9m.cn)("flex w-full flex-col space-y-2.5 overflow-auto p-8 print:hidden", className),
        ...props,
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "flex items-center justify-between gap-2",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "min-w-[300px]",
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $eL2bj.DateRangePicker), {
                            onUpdate: ({ range: range })=>{
                                onStateChange({
                                    dateRange: [
                                        range.from,
                                        range.to
                                    ].map((date)=>date.toISOString())
                                });
                            },
                            initialDateFrom: displayDates[0],
                            initialDateTo: displayDates[1],
                            align: "start",
                            locale: "en-GB",
                            showCompare: false
                        })
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            showSearchFieldHeader && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $2YJBX.Input), {
                                placeholder: "Filter by name",
                                value: globalFilter !== null && globalFilter !== void 0 ? globalFilter : "",
                                onChange: (event)=>handleSearch(event.target.value),
                                className: "h-8 w-40 lg:w-64"
                            }),
                            isHaveGroup && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6nxaR.DataTableGroupOptions), {
                                table: table,
                                onStateChange: onStateChange,
                                tableState: tableState
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6nxaR.DataTableViewOptions), {
                                table: table,
                                onColumnsChange: onColumnsChange,
                                fixedColumns: fixedColumns,
                                tableState: tableState
                            }),
                            children
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "flex items-center gap-2 flex-wrap",
                children: [
                    $f0b2aa2172a841a7$var$convertFiltersToOptions(tableState === null || tableState === void 0 ? void 0 : tableState.filters, filterFields)// .filter((option) => !option.isMulti)
                    .map((option)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $3QWaF.DataTableFilterItem), {
                            table: table,
                            selectedOption: option,
                            selectedOptions: $f0b2aa2172a841a7$var$convertFiltersToOptions(tableState === null || tableState === void 0 ? void 0 : tableState.filters, filterFields),
                            onFilterChange: (newOptions)=>{
                                onStateChange({
                                    filters: $f0b2aa2172a841a7$var$convertOptionsToFilters(newOptions)
                                });
                            },
                            showApplyToPhase: showApplyToPhase
                        }, String(option.value))),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $dafh3.DataTableFilterCombobox), {
                        options: filterFields,
                        selectedOptions: $f0b2aa2172a841a7$var$convertFiltersToOptions(tableState === null || tableState === void 0 ? void 0 : tableState.filters, filterFields),
                        onFilterChange: (newOptions)=>{
                            onStateChange({
                                filters: $f0b2aa2172a841a7$var$convertOptionsToFilters(newOptions)
                            });
                        },
                        children: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fTGwv.Button), {
                            variant: "outline",
                            size: "sm",
                            className: "h-7 rounded-full print:hidden",
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jSiTu.PlusIcon), {
                                    className: "mr-2 size-4 opacity-50"
                                }),
                                "Add filter"
                            ]
                        })
                    })
                ]
            }),
            (pendingChanges || error) && /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: (0, $Yha9m.cn)("flex items-center justify-between rounded-md px-4 py-2 border", error ? "border-red-500" : "border-gray-300"),
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jSiTu.InfoCircledIcon), {
                                className: "mr-2 size-4"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                children: error || "Changes pending"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fTGwv.Button), {
                        onClick: handleApplyChanges,
                        className: (0, $Yha9m.cn)("bg-[#facc15] rounded-md px-4 py-1"),
                        disabled: isLoading,
                        children: isLoading ? "Loading..." : error ? "Try again" : "Apply changes"
                    })
                ]
            })
        ]
    });
}
// Helper functions
function $f0b2aa2172a841a7$var$convertFiltersToOptions(filters, filterFields) {
    if (!filters) return [];
    return filters.map((filter)=>{
        var _filterFields$find$la, _filterFields$find, _filterFields$find$op, _filterFields$find2, _filterFields$find3;
        return {
            id: crypto.randomUUID(),
            label: (_filterFields$find$la = (_filterFields$find = filterFields.find((f)=>f.value === filter.column)) === null || _filterFields$find === void 0 ? void 0 : _filterFields$find.label) !== null && _filterFields$find$la !== void 0 ? _filterFields$find$la : String(filter.column),
            value: filter.column,
            options: (_filterFields$find$op = (_filterFields$find2 = filterFields.find((f)=>f.value === filter.column)) === null || _filterFields$find2 === void 0 ? void 0 : _filterFields$find2.options) !== null && _filterFields$find$op !== void 0 ? _filterFields$find$op : [],
            filterValues: filter.value,
            filterOperator: filter.operator,
            typeFilter: (_filterFields$find3 = filterFields.find((f)=>f.value === filter.column)) === null || _filterFields$find3 === void 0 ? void 0 : _filterFields$find3.typeFilter,
            isApplyToPhases: filter.group === "phase"
        };
    });
}
function $f0b2aa2172a841a7$var$convertOptionsToFilters(options) {
    if (!options) return [];
    return options.map((option)=>{
        var _option$filterOperato;
        return {
            column: String(option.value),
            operator: (_option$filterOperato = option.filterOperator) !== null && _option$filterOperato !== void 0 ? _option$filterOperato : option.typeFilter === "select" ? "in" : "=",
            value: option.filterValues,
            group: option.isApplyToPhases ? "phase" : "project"
        };
    });
}

});
parcelRegister("eL2bj", function(module, exports) {

$parcel$export(module.exports, "DateRangePicker", function () { return $303c9abd932e9f35$export$17334619f3ac2224; });

var $61Ea1 = parcelRequire("61Ea1");

var $fTGwv = parcelRequire("fTGwv");

var $l4nwI = parcelRequire("l4nwI");

var $8orVP = parcelRequire("8orVP");

var $jrx7l = parcelRequire("jrx7l");

var $5XMpG = parcelRequire("5XMpG");

var $3Gs4l = parcelRequire("3Gs4l");

var $e57zc = parcelRequire("e57zc");

var $jSiTu = parcelRequire("jSiTu");

var $95Evz = parcelRequire("95Evz");

var $jbmdS = parcelRequire("jbmdS");

var $6s7Y3 = parcelRequire("6s7Y3");
var $jsW5A = parcelRequire("jsW5A");
var $fLhu5 = parcelRequire("fLhu5");
var $hqDR9 = parcelRequire("hqDR9");
var $7ZALI = parcelRequire("7ZALI");
var $AX9kz = parcelRequire("AX9kz");
var $2D7Jq = parcelRequire("2D7Jq");
var $1rDNO = parcelRequire("1rDNO");
var $g9Sp7 = parcelRequire("g9Sp7");
var $fhV44 = parcelRequire("fhV44");
var $irq5s = parcelRequire("irq5s");
var $6mnS4 = parcelRequire("6mnS4");
var $8WGRA = parcelRequire("8WGRA");
var $3qWnK = parcelRequire("3qWnK");
const $303c9abd932e9f35$var$formatDate = (date, locale = "en-us")=>{
    return date.toLocaleDateString(locale, {
        month: "short",
        day: "numeric",
        year: "numeric"
    });
};
const $303c9abd932e9f35$var$getDateAdjustedForTimezone = (dateInput)=>{
    if (typeof dateInput === "string") {
        // Split the date string to get year, month, and day parts
        const parts = dateInput.split("-").map((part)=>parseInt(part, 10));
        // Create a new Date object using the local timezone
        // Note: Month is 0-indexed, so subtract 1 from the month part
        const date = new Date(parts[0], parts[1] - 1, parts[2]);
        return date;
    } else // If dateInput is already a Date object, return it directly
    return dateInput;
};
// Define presets
const $303c9abd932e9f35$var$PRESETS = [
    {
        name: "allTime",
        label: "All Time"
    },
    {
        name: "today",
        label: "Today"
    },
    {
        name: "yesterday",
        label: "Yesterday"
    },
    {
        name: "thisWeek",
        label: "This Week"
    },
    {
        name: "thisFortnightA",
        label: "This Fortnight A"
    },
    {
        name: "thisFortnightB",
        label: "This Fortnight B"
    },
    {
        name: "thisMonth",
        label: "This Month"
    },
    {
        name: "thisQuarter",
        label: "This Quarter"
    },
    {
        name: "thisYear",
        label: "This Year"
    },
    {
        name: "lastWeek",
        label: "Last Week"
    },
    {
        name: "lastFortnightA",
        label: "Last Fortnight A"
    },
    {
        name: "lastFortnightB",
        label: "Last Fortnight B"
    },
    {
        name: "lastMonth",
        label: "Last Month"
    },
    {
        name: "lastQuarter",
        label: "Last Quarter"
    },
    {
        name: "lastYear",
        label: "Last Year"
    },
    {
        name: "tomorrow",
        label: "Tomorrow"
    },
    {
        name: "inLastWeek",
        label: "Last 7 Days"
    },
    {
        name: "inLastFortnight",
        label: "Last 14 Days"
    },
    {
        name: "inLastMonth",
        label: "Last 30 Days"
    },
    {
        name: "inLastQuarter",
        label: "Last 90 Days"
    },
    {
        name: "inLastYear",
        label: "Last 365 Days"
    },
    {
        name: "nextWeek",
        label: "Next Week"
    },
    {
        name: "nextFortnightA",
        label: "Next Fortnight A"
    },
    {
        name: "nextFortnightB",
        label: "Next Fortnight B"
    },
    {
        name: "nextMonth",
        label: "Next Month"
    },
    {
        name: "nextQuarter",
        label: "Next Quarter"
    },
    {
        name: "nextYear",
        label: "Next Year"
    },
    {
        name: "inNextWeek",
        label: "Next 7 Days"
    },
    {
        name: "inNextFortnight",
        label: "Next 14 Days"
    },
    {
        name: "inNextMonth",
        label: "Next 30 Days"
    },
    {
        name: "inNextQuarter",
        label: "Next 90 Days"
    },
    {
        name: "inNextYear",
        label: "Next 365 Days"
    }
];
const $303c9abd932e9f35$export$17334619f3ac2224 = ({ initialDateFrom: initialDateFrom = (0, $g9Sp7.startOfDay)(new Date()), initialDateTo: initialDateTo = (0, $jsW5A.endOfDay)(new Date()), initialCompareFrom: initialCompareFrom, initialCompareTo: initialCompareTo, onUpdate: onUpdate, align: align = "end", locale: locale = "en-US", showCompare: showCompare = true })=>{
    var _PRESETS$find;
    const [isOpen, setIsOpen] = (0, $jbmdS.useState)(false);
    const [range, setRange] = (0, $jbmdS.useState)({
        from: $303c9abd932e9f35$var$getDateAdjustedForTimezone(initialDateFrom),
        to: initialDateTo ? $303c9abd932e9f35$var$getDateAdjustedForTimezone(initialDateTo) : $303c9abd932e9f35$var$getDateAdjustedForTimezone(initialDateFrom)
    });
    const [rangeCompare, setRangeCompare] = (0, $jbmdS.useState)(initialCompareFrom ? {
        from: new Date(new Date(initialCompareFrom).setHours(0, 0, 0, 0)),
        to: initialCompareTo ? new Date(new Date(initialCompareTo).setHours(0, 0, 0, 0)) : new Date(new Date(initialCompareFrom).setHours(0, 0, 0, 0))
    } : undefined);
    // Refs to store the values of range and rangeCompare when the date picker is opened
    const openedRangeRef = (0, $jbmdS.useRef)();
    const openedRangeCompareRef = (0, $jbmdS.useRef)();
    const [selectedPreset, setSelectedPreset] = (0, $jbmdS.useState)(undefined);
    const [isSmallScreen, setIsSmallScreen] = (0, $jbmdS.useState)(typeof window !== "undefined" ? window.innerWidth < 960 : false);
    (0, $jbmdS.useEffect)(()=>{
        const handleResize = ()=>{
            setIsSmallScreen(window.innerWidth < 960);
        };
        window.addEventListener("resize", handleResize);
        // Clean up event listener on unmount
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    const getPresetRange = (presetName)=>{
        const preset = $303c9abd932e9f35$var$PRESETS.find(({ name: name })=>name === presetName);
        if (!preset) throw new Error(`Unknown date range preset: ${presetName}`);
        const now = new Date();
        let from = new Date();
        let to = new Date();
        switch(preset.name){
            case "allTime":
                [from, to] = [
                    (0, $3qWnK.sub)(now, {
                        years: 50
                    }),
                    // add(now, { years: 50 }),
                    now
                ].map((d)=>new Date(d));
                break;
            case "today":
                [from, to] = [
                    (0, $g9Sp7.startOfDay)(now),
                    (0, $jsW5A.endOfDay)(now)
                ];
                break;
            case "yesterday":
                [from, to] = [
                    (0, $g9Sp7.startOfDay)((0, $3qWnK.sub)(now, {
                        days: 1
                    })),
                    (0, $jsW5A.endOfDay)((0, $3qWnK.sub)(now, {
                        days: 1
                    }))
                ];
                break;
            case "thisWeek":
                [from, to] = [
                    (0, $6mnS4.startOfWeek)(now, {
                        weekStartsOn: 1
                    }),
                    (0, $7ZALI.endOfWeek)(now, {
                        weekStartsOn: 1
                    })
                ];
                break;
            case "inLastFortnight":
                [from, to] = [
                    (0, $3qWnK.sub)(now, {
                        days: 13
                    }),
                    now
                ];
                break;
            case "thisFortnightA":
            case "thisFortnightB":
                const currentWeek = (0, $2D7Jq.getWeek)(now);
                const isEvenWeek = currentWeek % 2 === 0;
                const fortnightType = preset.name === "thisFortnightA" ? "a" : "b";
                if (fortnightType === "a" && isEvenWeek || fortnightType === "b" && !isEvenWeek) [from, to] = [
                    (0, $6mnS4.startOfWeek)(now, {
                        weekStartsOn: 1
                    }),
                    (0, $7ZALI.endOfWeek)((0, $6s7Y3.add)(now, {
                        weeks: 1
                    }), {
                        weekStartsOn: 1
                    })
                ];
                else [from, to] = [
                    (0, $6mnS4.startOfWeek)((0, $3qWnK.sub)(now, {
                        weeks: 1
                    }), {
                        weekStartsOn: 1
                    }),
                    (0, $7ZALI.endOfWeek)(now, {
                        weekStartsOn: 1
                    })
                ];
                break;
            case "thisMonth":
                [from, to] = [
                    (0, $fhV44.startOfMonth)(now),
                    (0, $fLhu5.endOfMonth)(now)
                ];
                break;
            case "thisQuarter":
                [from, to] = [
                    (0, $irq5s.startOfQuarter)(now),
                    (0, $hqDR9.endOfQuarter)(now)
                ];
                break;
            case "thisYear":
                [from, to] = [
                    (0, $8WGRA.startOfYear)(now),
                    (0, $AX9kz.endOfYear)(now)
                ];
                break;
            case "lastWeek":
                [from, to] = [
                    (0, $6mnS4.startOfWeek)((0, $3qWnK.sub)(now, {
                        weeks: 1
                    }), {
                        weekStartsOn: 1
                    }),
                    (0, $7ZALI.endOfWeek)((0, $3qWnK.sub)(now, {
                        weeks: 1
                    }), {
                        weekStartsOn: 1
                    })
                ];
                break;
            case "lastFortnightA":
            case "lastFortnightB":
                const fortnightTypeLastFortnight = preset.name === "lastFortnightA" ? "a" : "b";
                if ((0, $2D7Jq.getWeek)((0, $3qWnK.sub)(now, {
                    weeks: 2
                })) % (fortnightTypeLastFortnight === "a" ? 2 : 1)) [from, to] = [
                    (0, $6mnS4.startOfWeek)((0, $3qWnK.sub)(now, {
                        weeks: 3
                    }), {
                        weekStartsOn: 1
                    }),
                    (0, $7ZALI.endOfWeek)((0, $3qWnK.sub)(now, {
                        weeks: 2
                    }), {
                        weekStartsOn: 1
                    })
                ];
                else [from, to] = [
                    (0, $6mnS4.startOfWeek)((0, $3qWnK.sub)(now, {
                        weeks: 2
                    }), {
                        weekStartsOn: 1
                    }),
                    (0, $7ZALI.endOfWeek)((0, $3qWnK.sub)(now, {
                        weeks: 1
                    }), {
                        weekStartsOn: 1
                    })
                ];
                break;
            case "lastMonth":
                [from, to] = [
                    (0, $fhV44.startOfMonth)((0, $3qWnK.sub)(now, {
                        months: 1
                    })),
                    (0, $fLhu5.endOfMonth)((0, $3qWnK.sub)(now, {
                        months: 1
                    }))
                ];
                break;
            case "lastQuarter":
                [from, to] = [
                    (0, $irq5s.startOfQuarter)((0, $3qWnK.sub)(now, {
                        months: 3
                    })),
                    (0, $hqDR9.endOfQuarter)((0, $3qWnK.sub)(now, {
                        months: 3
                    }))
                ];
                break;
            case "lastYear":
                [from, to] = [
                    (0, $8WGRA.startOfYear)((0, $3qWnK.sub)(now, {
                        years: 1
                    })),
                    (0, $AX9kz.endOfYear)((0, $3qWnK.sub)(now, {
                        years: 1
                    }))
                ];
                break;
            case "tomorrow":
                [from, to] = [
                    (0, $g9Sp7.startOfDay)((0, $6s7Y3.add)(now, {
                        days: 1
                    })),
                    (0, $jsW5A.endOfDay)((0, $6s7Y3.add)(now, {
                        days: 1
                    }))
                ];
                break;
            case "inLastWeek":
                [from, to] = [
                    (0, $3qWnK.sub)(now, {
                        weeks: 1
                    }),
                    now
                ];
                break;
            case "inLastMonth":
                [from, to] = [
                    (0, $3qWnK.sub)(now, {
                        months: 1
                    }),
                    now
                ];
                break;
            case "inLastQuarter":
                [from, to] = [
                    (0, $3qWnK.sub)(now, {
                        months: 3
                    }),
                    now
                ];
                break;
            case "inLastYear":
                [from, to] = [
                    (0, $3qWnK.sub)(now, {
                        years: 1
                    }),
                    now
                ];
                break;
            case "nextWeek":
                [from, to] = [
                    (0, $6mnS4.startOfWeek)((0, $6s7Y3.add)(now, {
                        weeks: 1
                    }), {
                        weekStartsOn: 1
                    }),
                    (0, $7ZALI.endOfWeek)((0, $6s7Y3.add)(now, {
                        weeks: 1
                    }), {
                        weekStartsOn: 1
                    })
                ];
                break;
            case "nextFortnightA":
            case "nextFortnightB":
                const fortnightTypeNextFortnight = preset.name === "nextFortnightA" ? "a" : "b";
                if ((0, $2D7Jq.getWeek)((0, $6s7Y3.add)(now, {
                    weeks: 2
                })) % (fortnightTypeNextFortnight === "a" ? 2 : 1)) [from, to] = [
                    (0, $6mnS4.startOfWeek)((0, $6s7Y3.add)(now, {
                        weeks: 1
                    }), {
                        weekStartsOn: 1
                    }),
                    (0, $7ZALI.endOfWeek)((0, $6s7Y3.add)(now, {
                        weeks: 2
                    }), {
                        weekStartsOn: 1
                    })
                ];
                else [from, to] = [
                    (0, $6mnS4.startOfWeek)((0, $6s7Y3.add)(now, {
                        weeks: 2
                    }), {
                        weekStartsOn: 1
                    }),
                    (0, $7ZALI.endOfWeek)((0, $6s7Y3.add)(now, {
                        weeks: 3
                    }), {
                        weekStartsOn: 1
                    })
                ];
                break;
            case "nextMonth":
                [from, to] = [
                    (0, $fhV44.startOfMonth)((0, $6s7Y3.add)(now, {
                        months: 1
                    })),
                    (0, $fLhu5.endOfMonth)((0, $6s7Y3.add)(now, {
                        months: 1
                    }))
                ];
                break;
            case "nextQuarter":
                [from, to] = [
                    (0, $irq5s.startOfQuarter)((0, $6s7Y3.add)(now, {
                        months: 3
                    })),
                    (0, $hqDR9.endOfQuarter)((0, $6s7Y3.add)(now, {
                        months: 3
                    }))
                ];
                break;
            case "nextYear":
                [from, to] = [
                    (0, $8WGRA.startOfYear)((0, $6s7Y3.add)(now, {
                        years: 1
                    })),
                    (0, $AX9kz.endOfYear)((0, $6s7Y3.add)(now, {
                        years: 1
                    }))
                ];
                break;
            case "inNextWeek":
                [from, to] = [
                    now,
                    (0, $6s7Y3.add)(now, {
                        weeks: 1
                    })
                ];
                break;
            case "inNextFortnight":
                break;
            case "inNextMonth":
                [from, to] = [
                    now,
                    (0, $6s7Y3.add)(now, {
                        months: 1
                    })
                ];
                break;
            case "inNextQuarter":
                [from, to] = [
                    now,
                    (0, $6s7Y3.add)(now, {
                        months: 3
                    })
                ];
                break;
            case "inNextYear":
                [from, to] = [
                    now,
                    (0, $6s7Y3.add)(now, {
                        years: 1
                    })
                ];
                break;
        }
        return {
            from: from,
            to: to
        };
    };
    const setPreset = (preset)=>{
        const range = getPresetRange(preset);
        setRange(range);
        if (rangeCompare) {
            const rangeCompare = {
                from: new Date(range.from.getFullYear() - 1, range.from.getMonth(), range.from.getDate()),
                to: range.to ? new Date(range.to.getFullYear() - 1, range.to.getMonth(), range.to.getDate()) : undefined
            };
            setRangeCompare(rangeCompare);
        }
    };
    const checkPreset = ()=>{
        for (const preset of $303c9abd932e9f35$var$PRESETS){
            var _range$to, _presetRange$to$setHo, _presetRange$to;
            const presetRange = getPresetRange(preset.name);
            const normalizedRangeFrom = new Date(range.from);
            normalizedRangeFrom.setHours(0, 0, 0, 0);
            const normalizedPresetFrom = new Date(presetRange.from.setHours(0, 0, 0, 0));
            const normalizedRangeTo = new Date((_range$to = range.to) !== null && _range$to !== void 0 ? _range$to : 0);
            normalizedRangeTo.setHours(0, 0, 0, 0);
            const normalizedPresetTo = new Date((_presetRange$to$setHo = (_presetRange$to = presetRange.to) === null || _presetRange$to === void 0 ? void 0 : _presetRange$to.setHours(0, 0, 0, 0)) !== null && _presetRange$to$setHo !== void 0 ? _presetRange$to$setHo : 0);
            if (normalizedRangeFrom.getTime() === normalizedPresetFrom.getTime() && normalizedRangeTo.getTime() === normalizedPresetTo.getTime()) {
                setSelectedPreset(preset.name);
                return;
            }
        }
        setSelectedPreset(undefined);
    };
    const resetValues = ()=>{
        setRange({
            from: typeof initialDateFrom === "string" ? $303c9abd932e9f35$var$getDateAdjustedForTimezone(initialDateFrom) : initialDateFrom,
            to: initialDateTo ? typeof initialDateTo === "string" ? $303c9abd932e9f35$var$getDateAdjustedForTimezone(initialDateTo) : initialDateTo : typeof initialDateFrom === "string" ? $303c9abd932e9f35$var$getDateAdjustedForTimezone(initialDateFrom) : initialDateFrom
        });
        setRangeCompare(initialCompareFrom ? {
            from: typeof initialCompareFrom === "string" ? $303c9abd932e9f35$var$getDateAdjustedForTimezone(initialCompareFrom) : initialCompareFrom,
            to: initialCompareTo ? typeof initialCompareTo === "string" ? $303c9abd932e9f35$var$getDateAdjustedForTimezone(initialCompareTo) : initialCompareTo : typeof initialCompareFrom === "string" ? $303c9abd932e9f35$var$getDateAdjustedForTimezone(initialCompareFrom) : initialCompareFrom
        } : undefined);
    };
    (0, $jbmdS.useEffect)(()=>{
        checkPreset();
    }, [
        range
    ]);
    const PresetButton = ({ preset: preset, label: label, isSelected: isSelected })=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $fTGwv.Button), {
            className: (0, $95Evz.cn)(isSelected && "pointer-events-none"),
            variant: "ghost",
            onClick: ()=>{
                setPreset(preset);
            },
            children: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                        className: (0, $95Evz.cn)("pr-2 opacity-0", isSelected && "opacity-70"),
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jSiTu.CheckIcon), {
                            width: 18,
                            height: 18
                        })
                    }),
                    label
                ]
            })
        });
    // Helper function to check if two date ranges are equal
    const areRangesEqual = (a, b)=>{
        if (!a || !b) return a === b; // If either is undefined, return true if both are undefined
        return a.from.getTime() === b.from.getTime() && (!a.to || !b.to || a.to.getTime() === b.to.getTime());
    };
    (0, $jbmdS.useEffect)(()=>{
        if (isOpen) {
            openedRangeRef.current = range;
            openedRangeCompareRef.current = rangeCompare;
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $l4nwI.Popover), {
        modal: true,
        open: isOpen,
        onOpenChange: (open)=>{
            if (!open) resetValues();
            setIsOpen(open);
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $l4nwI.PopoverTrigger), {
                asChild: true,
                children: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fTGwv.Button), {
                    size: "sm",
                    variant: "outline",
                    className: "w-full justify-between",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            className: "text-right",
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                    className: "py-1",
                                    children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                        children: [
                                            selectedPreset ? `${(_PRESETS$find = $303c9abd932e9f35$var$PRESETS.find((p)=>p.name === selectedPreset)) === null || _PRESETS$find === void 0 ? void 0 : _PRESETS$find.label}: ` : "",
                                            `${$303c9abd932e9f35$var$formatDate(range.from, locale)}${range.to != null && !(0, $1rDNO.isSameDay)(range.from, range.to) ? " - " + $303c9abd932e9f35$var$formatDate(range.to, locale) : ""}`
                                        ]
                                    })
                                }),
                                rangeCompare != null && /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                    className: "opacity-60 text-xs -mt-1",
                                    children: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                                        children: [
                                            "vs. ",
                                            $303c9abd932e9f35$var$formatDate(rangeCompare.from, locale),
                                            rangeCompare.to != null ? ` - ${$303c9abd932e9f35$var$formatDate(rangeCompare.to, locale)}` : ""
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            className: "pl-1 opacity-60 -mr-2 scale-125",
                            children: isOpen ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jSiTu.ChevronUpIcon), {
                                width: 24
                            }) : /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jSiTu.ChevronDownIcon), {
                                width: 24
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $l4nwI.PopoverContent), {
                align: align,
                className: "w-auto",
                children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    className: "flex py-2",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            className: "flex",
                            children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                className: "flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                        className: "flex flex-col lg:flex-row gap-2 px-3 justify-end items-center lg:items-start pb-4 lg:pb-0",
                                        children: [
                                            showCompare && /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                                className: "flex items-center space-x-2 pr-4 py-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $e57zc.Switch), {
                                                        defaultChecked: Boolean(rangeCompare),
                                                        onCheckedChange: (checked)=>{
                                                            if (checked) {
                                                                if (!range.to) setRange({
                                                                    from: range.from,
                                                                    to: range.from
                                                                });
                                                                setRangeCompare({
                                                                    from: new Date(range.from.getFullYear(), range.from.getMonth(), range.from.getDate() - 365),
                                                                    to: range.to ? new Date(range.to.getFullYear() - 1, range.to.getMonth(), range.to.getDate()) : new Date(range.from.getFullYear() - 1, range.from.getMonth(), range.from.getDate())
                                                                });
                                                            } else setRangeCompare(undefined);
                                                        },
                                                        id: "compare-mode"
                                                    }),
                                                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5XMpG.Label), {
                                                        htmlFor: "compare-mode",
                                                        children: "Compare"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                                className: "flex flex-col gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                                        className: "flex gap-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jrx7l.DateInput), {
                                                                value: range.from,
                                                                onChange: (date)=>{
                                                                    const toDate = range.to == null || date > range.to ? date : range.to;
                                                                    setRange((prevRange)=>({
                                                                            ...prevRange,
                                                                            from: date,
                                                                            to: toDate
                                                                        }));
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                                className: "py-1",
                                                                children: "-"
                                                            }),
                                                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jrx7l.DateInput), {
                                                                value: range.to,
                                                                onChange: (date)=>{
                                                                    const fromDate = date < range.from ? date : range.from;
                                                                    setRange((prevRange)=>({
                                                                            ...prevRange,
                                                                            from: fromDate,
                                                                            to: date
                                                                        }));
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    rangeCompare != null && /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                                        className: "flex gap-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jrx7l.DateInput), {
                                                                value: rangeCompare === null || rangeCompare === void 0 ? void 0 : rangeCompare.from,
                                                                onChange: (date)=>{
                                                                    if (rangeCompare) {
                                                                        const compareToDate = rangeCompare.to == null || date > rangeCompare.to ? date : rangeCompare.to;
                                                                        setRangeCompare((prevRangeCompare)=>({
                                                                                ...prevRangeCompare,
                                                                                from: date,
                                                                                to: compareToDate
                                                                            }));
                                                                    } else setRangeCompare({
                                                                        from: date,
                                                                        to: new Date()
                                                                    });
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                                className: "py-1",
                                                                children: "-"
                                                            }),
                                                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jrx7l.DateInput), {
                                                                value: rangeCompare === null || rangeCompare === void 0 ? void 0 : rangeCompare.to,
                                                                onChange: (date)=>{
                                                                    if (rangeCompare && rangeCompare.from) {
                                                                        const compareFromDate = date < rangeCompare.from ? date : rangeCompare.from;
                                                                        setRangeCompare({
                                                                            ...rangeCompare,
                                                                            from: compareFromDate,
                                                                            to: date
                                                                        });
                                                                    }
                                                                }
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    isSmallScreen && /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $3Gs4l.Select), {
                                        defaultValue: selectedPreset,
                                        onValueChange: (value)=>{
                                            setPreset(value);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3Gs4l.SelectTrigger), {
                                                className: "w-[180px] mx-auto mb-2",
                                                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3Gs4l.SelectValue), {
                                                    placeholder: "Select..."
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3Gs4l.SelectContent), {
                                                children: $303c9abd932e9f35$var$PRESETS.map((preset)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $3Gs4l.SelectItem), {
                                                        value: preset.name,
                                                        children: preset.label
                                                    }, preset.name))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8orVP.Calendar), {
                                            mode: "range",
                                            onSelect: (value)=>{
                                                if ((value === null || value === void 0 ? void 0 : value.from) != null) setRange({
                                                    from: value.from,
                                                    to: value === null || value === void 0 ? void 0 : value.to
                                                });
                                            },
                                            selected: range,
                                            numberOfMonths: isSmallScreen ? 1 : 2,
                                            defaultMonth: new Date(new Date().setMonth(new Date().getMonth() - (isSmallScreen ? 0 : 1)))
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                        className: "flex justify-end gap-2 py-2 pr-4",
                                        children: [
                                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fTGwv.Button), {
                                                onClick: ()=>{
                                                    setIsOpen(false);
                                                    resetValues();
                                                },
                                                variant: "ghost",
                                                children: "Cancel"
                                            }),
                                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fTGwv.Button), {
                                                onClick: ()=>{
                                                    setIsOpen(false);
                                                    if (!areRangesEqual(range, openedRangeRef.current) || !areRangesEqual(rangeCompare, openedRangeCompareRef.current)) onUpdate === null || onUpdate === void 0 || onUpdate({
                                                        range: range,
                                                        rangeCompare: rangeCompare
                                                    });
                                                },
                                                children: "Update"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        !isSmallScreen && /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            className: "h-96 overflow-y-auto",
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "flex flex-col items-end gap-1 pr-2 pl-6 pb-6",
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                    className: "flex w-full flex-col items-end gap-1 pr-2 pl-6 pb-6",
                                    children: $303c9abd932e9f35$var$PRESETS.map((preset)=>/*#__PURE__*/ (0, $61Ea1.jsx)(PresetButton, {
                                            preset: preset.name,
                                            label: preset.label,
                                            isSelected: selectedPreset === preset.name
                                        }, preset.name))
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};

});
parcelRegister("jrx7l", function(module, exports) {

$parcel$export(module.exports, "DateInput", function () { return $2edc1789af4bea8b$export$7edc06cf1783b30f; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");
const $2edc1789af4bea8b$export$7edc06cf1783b30f = ({ value: value, onChange: onChange })=>{
    const [date, setDate] = (0, $jbmdS.useState)(()=>{
        const d = value ? new Date(value) : new Date();
        return {
            day: d.getDate(),
            month: d.getMonth() + 1,
            // JavaScript months are 0-indexed
            year: d.getFullYear()
        };
    });
    const monthRef = (0, $jbmdS.useRef)(null);
    const dayRef = (0, $jbmdS.useRef)(null);
    const yearRef = (0, $jbmdS.useRef)(null);
    (0, $jbmdS.useEffect)(()=>{
        const d = value ? new Date(value) : new Date();
        setDate({
            day: d.getDate(),
            month: d.getMonth() + 1,
            year: d.getFullYear()
        });
    }, [
        value
    ]);
    const validateDate = (field, value)=>{
        if (field === "day" && (value < 1 || value > 31) || field === "month" && (value < 1 || value > 12) || field === "year" && (value < 1000 || value > 9999)) return false;
        // Validate the day of the month
        const newDate = {
            ...date,
            [field]: value
        };
        const d = new Date(newDate.year, newDate.month - 1, newDate.day);
        return d.getFullYear() === newDate.year && d.getMonth() + 1 === newDate.month && d.getDate() === newDate.day;
    };
    const handleInputChange = (field)=>(e)=>{
            const newValue = e.target.value ? Number(e.target.value) : "";
            const isValid = typeof newValue === "number" && validateDate(field, newValue);
            // If the new value is valid, update the date
            const newDate = {
                ...date,
                [field]: newValue
            };
            setDate(newDate);
            // only call onChange when the entry is valid
            if (isValid) onChange(new Date(newDate.year, newDate.month - 1, newDate.day));
        };
    const initialDate = (0, $jbmdS.useRef)(date);
    const handleBlur = (field)=>(e)=>{
            if (!e.target.value) {
                setDate(initialDate.current);
                return;
            }
            const newValue = Number(e.target.value);
            const isValid = validateDate(field, newValue);
            if (!isValid) setDate(initialDate.current);
            else // If the new value is valid, update the initial value
            initialDate.current = {
                ...date,
                [field]: newValue
            };
        };
    const handleKeyDown = (field)=>(e)=>{
            // Allow command (or control) combinations
            if (e.metaKey || e.ctrlKey) return;
            // Prevent non-numeric characters, excluding allowed keys
            if (!/^[0-9]$/.test(e.key) && ![
                "ArrowUp",
                "ArrowDown",
                "ArrowLeft",
                "ArrowRight",
                "Delete",
                "Tab",
                "Backspace",
                "Enter"
            ].includes(e.key)) {
                e.preventDefault();
                return;
            }
            if (e.key === "ArrowUp") {
                e.preventDefault();
                let newDate = {
                    ...date
                };
                if (field === "day") {
                    if (date[field] === new Date(date.year, date.month, 0).getDate()) {
                        newDate = {
                            ...newDate,
                            day: 1,
                            month: date.month % 12 + 1
                        };
                        if (newDate.month === 1) newDate.year += 1;
                    } else newDate.day += 1;
                }
                if (field === "month") {
                    if (date[field] === 12) newDate = {
                        ...newDate,
                        month: 1,
                        year: date.year + 1
                    };
                    else newDate.month += 1;
                }
                if (field === "year") newDate.year += 1;
                setDate(newDate);
                onChange(new Date(newDate.year, newDate.month - 1, newDate.day));
            } else if (e.key === "ArrowDown") {
                e.preventDefault();
                let newDate = {
                    ...date
                };
                if (field === "day") {
                    if (date[field] === 1) {
                        newDate.month -= 1;
                        if (newDate.month === 0) {
                            newDate.month = 12;
                            newDate.year -= 1;
                        }
                        newDate.day = new Date(newDate.year, newDate.month, 0).getDate();
                    } else newDate.day -= 1;
                }
                if (field === "month") {
                    if (date[field] === 1) newDate = {
                        ...newDate,
                        month: 12,
                        year: date.year - 1
                    };
                    else newDate.month -= 1;
                }
                if (field === "year") newDate.year -= 1;
                setDate(newDate);
                onChange(new Date(newDate.year, newDate.month - 1, newDate.day));
            }
            if (e.key === "ArrowRight") {
                if (e.currentTarget.selectionStart === e.currentTarget.value.length || e.currentTarget.selectionStart === 0 && e.currentTarget.selectionEnd === e.currentTarget.value.length) {
                    var _dayRef$current, _yearRef$current;
                    e.preventDefault();
                    if (field === "month") (_dayRef$current = dayRef.current) === null || _dayRef$current === void 0 || _dayRef$current.focus();
                    if (field === "day") (_yearRef$current = yearRef.current) === null || _yearRef$current === void 0 || _yearRef$current.focus();
                }
            } else if (e.key === "ArrowLeft") {
                if (e.currentTarget.selectionStart === 0 || e.currentTarget.selectionStart === 0 && e.currentTarget.selectionEnd === e.currentTarget.value.length) {
                    var _monthRef$current, _dayRef$current2;
                    e.preventDefault();
                    if (field === "day") (_monthRef$current = monthRef.current) === null || _monthRef$current === void 0 || _monthRef$current.focus();
                    if (field === "year") (_dayRef$current2 = dayRef.current) === null || _dayRef$current2 === void 0 || _dayRef$current2.focus();
                }
            }
        };
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "flex border rounded-lg items-center text-sm px-1 bg-white",
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
                type: "text",
                ref: monthRef,
                max: 12,
                maxLength: 2,
                value: date.month.toString(),
                onChange: handleInputChange("month"),
                onKeyDown: handleKeyDown("month"),
                onFocus: (e)=>{
                    if (window.innerWidth > 1024) e.target.select();
                },
                onBlur: handleBlur("month"),
                className: "p-0 outline-none w-6 border-none text-center",
                placeholder: "M"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                className: "opacity-20 -mx-px",
                children: "/"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
                type: "text",
                ref: dayRef,
                max: 31,
                maxLength: 2,
                value: date.day.toString(),
                onChange: handleInputChange("day"),
                onKeyDown: handleKeyDown("day"),
                onFocus: (e)=>{
                    if (window.innerWidth > 1024) e.target.select();
                },
                onBlur: handleBlur("day"),
                className: "p-0 outline-none w-7 border-none text-center",
                placeholder: "D"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                className: "opacity-20 -mx-px",
                children: "/"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
                type: "text",
                ref: yearRef,
                max: 9999,
                maxLength: 4,
                value: date.year.toString(),
                onChange: handleInputChange("year"),
                onKeyDown: handleKeyDown("year"),
                onFocus: (e)=>{
                    if (window.innerWidth > 1024) e.target.select();
                },
                onBlur: handleBlur("year"),
                className: "p-0 outline-none w-12 border-none text-center",
                placeholder: "YYYY"
            })
        ]
    });
};
$2edc1789af4bea8b$export$7edc06cf1783b30f.displayName = "DateInput";

});

parcelRegister("6s7Y3", function(module, exports) {

$parcel$export(module.exports, "add", function () { return $f1c26acffc741f32$export$e16d8520af44a096; });

var $2gXaN = parcelRequire("2gXaN");

var $6lxwW = parcelRequire("6lxwW");

var $iNCNo = parcelRequire("iNCNo");

var $l7oHg = parcelRequire("l7oHg");
function $f1c26acffc741f32$export$e16d8520af44a096(date, duration) {
    const { years: years = 0, months: months = 0, weeks: weeks = 0, days: days = 0, hours: hours = 0, minutes: minutes = 0, seconds: seconds = 0 } = duration;
    // Add years and months
    const _date = (0, $l7oHg.toDate)(date);
    const dateWithMonths = months || years ? (0, $6lxwW.addMonths)(_date, months + years * 12) : _date;
    // Add weeks and days
    const dateWithDays = days || weeks ? (0, $2gXaN.addDays)(dateWithMonths, days + weeks * 7) : dateWithMonths;
    // Add days, hours, minutes and seconds
    const minutesToAdd = minutes + hours * 60;
    const secondsToAdd = seconds + minutesToAdd * 60;
    const msToAdd = secondsToAdd * 1000;
    const finalDate = (0, $iNCNo.constructFrom)(date, dateWithDays.getTime() + msToAdd);
    return finalDate;
}
var // Fallback for modularized imports:
$f1c26acffc741f32$export$2e2bcd8739ae039 = $f1c26acffc741f32$export$e16d8520af44a096;

});
parcelRegister("2gXaN", function(module, exports) {

$parcel$export(module.exports, "addDays", function () { return $def97d9da84deea7$export$dd412b56f1e4d8aa; });

var $l7oHg = parcelRequire("l7oHg");

var $iNCNo = parcelRequire("iNCNo");
function $def97d9da84deea7$export$dd412b56f1e4d8aa(date, amount) {
    const _date = (0, $l7oHg.toDate)(date);
    if (isNaN(amount)) return (0, $iNCNo.constructFrom)(date, NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}
var // Fallback for modularized imports:
$def97d9da84deea7$export$2e2bcd8739ae039 = $def97d9da84deea7$export$dd412b56f1e4d8aa;

});
parcelRegister("iNCNo", function(module, exports) {

$parcel$export(module.exports, "constructFrom", function () { return $3a810041fd0b3c2b$export$ead8a1812b171991; });
/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from 'date-fns'
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use contrustor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   )
 * }
 */ function $3a810041fd0b3c2b$export$ead8a1812b171991(date, value) {
    if (date instanceof Date) return new date.constructor(value);
    else return new Date(value);
}
var // Fallback for modularized imports:
$3a810041fd0b3c2b$export$2e2bcd8739ae039 = $3a810041fd0b3c2b$export$ead8a1812b171991;

});


parcelRegister("6lxwW", function(module, exports) {

$parcel$export(module.exports, "addMonths", function () { return $7372d9d98aceb0c6$export$17c93e242b2d3a22; });

var $l7oHg = parcelRequire("l7oHg");

var $iNCNo = parcelRequire("iNCNo");
function $7372d9d98aceb0c6$export$17c93e242b2d3a22(date, amount) {
    const _date = (0, $l7oHg.toDate)(date);
    if (isNaN(amount)) return (0, $iNCNo.constructFrom)(date, NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
    const dayOfMonth = _date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    const endOfDesiredMonth = (0, $iNCNo.constructFrom)(date, _date.getTime());
    endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
    const daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        _date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return _date;
    }
}
var // Fallback for modularized imports:
$7372d9d98aceb0c6$export$2e2bcd8739ae039 = $7372d9d98aceb0c6$export$17c93e242b2d3a22;

});


parcelRegister("jsW5A", function(module, exports) {

$parcel$export(module.exports, "endOfDay", function () { return $8ac79753debda46e$export$eb9a03f0e9aa6cea; });

var $l7oHg = parcelRequire("l7oHg");
function $8ac79753debda46e$export$eb9a03f0e9aa6cea(date) {
    const _date = (0, $l7oHg.toDate)(date);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$8ac79753debda46e$export$2e2bcd8739ae039 = $8ac79753debda46e$export$eb9a03f0e9aa6cea;

});

parcelRegister("fLhu5", function(module, exports) {

$parcel$export(module.exports, "endOfMonth", function () { return $8b535ee111341685$export$a2258d9c4118825c; });

var $l7oHg = parcelRequire("l7oHg");
function $8b535ee111341685$export$a2258d9c4118825c(date) {
    const _date = (0, $l7oHg.toDate)(date);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$8b535ee111341685$export$2e2bcd8739ae039 = $8b535ee111341685$export$a2258d9c4118825c;

});

parcelRegister("hqDR9", function(module, exports) {

$parcel$export(module.exports, "endOfQuarter", function () { return $e1ef052224804e0c$export$5f53493861eef879; });

var $l7oHg = parcelRequire("l7oHg");
function $e1ef052224804e0c$export$5f53493861eef879(date) {
    const _date = (0, $l7oHg.toDate)(date);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3 + 3;
    _date.setMonth(month, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$e1ef052224804e0c$export$2e2bcd8739ae039 = $e1ef052224804e0c$export$5f53493861eef879;

});

parcelRegister("7ZALI", function(module, exports) {

$parcel$export(module.exports, "endOfWeek", function () { return $d558cd54234e2883$export$ef8b6d9133084f4e; });

var $l7oHg = parcelRequire("l7oHg");

var $8gw7j = parcelRequire("8gw7j");
function $d558cd54234e2883$export$ef8b6d9133084f4e(date, options) {
    const defaultOptions = (0, $8gw7j.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $l7oHg.toDate)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setDate(_date.getDate() + diff);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$d558cd54234e2883$export$2e2bcd8739ae039 = $d558cd54234e2883$export$ef8b6d9133084f4e;

});
parcelRegister("8gw7j", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", function () { return $063fd2ddb7d3712b$export$430a3269e24b912e; });
let $063fd2ddb7d3712b$var$defaultOptions = {};
function $063fd2ddb7d3712b$export$430a3269e24b912e() {
    return $063fd2ddb7d3712b$var$defaultOptions;
}
function $063fd2ddb7d3712b$export$95365be1b0704abc(newOptions) {
    $063fd2ddb7d3712b$var$defaultOptions = newOptions;
}

});


parcelRegister("AX9kz", function(module, exports) {

$parcel$export(module.exports, "endOfYear", function () { return $7547978c3f9ec8c8$export$8b7aa55c66d5569e; });

var $l7oHg = parcelRequire("l7oHg");
function $7547978c3f9ec8c8$export$8b7aa55c66d5569e(date) {
    const _date = (0, $l7oHg.toDate)(date);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$7547978c3f9ec8c8$export$2e2bcd8739ae039 = $7547978c3f9ec8c8$export$8b7aa55c66d5569e;

});

parcelRegister("2D7Jq", function(module, exports) {

$parcel$export(module.exports, "getWeek", function () { return $f93e1847b0fc548c$export$efe19b760242b2fc; });

var $oijbG = parcelRequire("oijbG");

var $6mnS4 = parcelRequire("6mnS4");

var $kf61z = parcelRequire("kf61z");

var $l7oHg = parcelRequire("l7oHg");
function $f93e1847b0fc548c$export$efe19b760242b2fc(date, options) {
    const _date = (0, $l7oHg.toDate)(date);
    const diff = +(0, $6mnS4.startOfWeek)(_date, options) - +(0, $kf61z.startOfWeekYear)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $oijbG.millisecondsInWeek)) + 1;
}
var // Fallback for modularized imports:
$f93e1847b0fc548c$export$2e2bcd8739ae039 = $f93e1847b0fc548c$export$efe19b760242b2fc;

});
parcelRegister("oijbG", function(module, exports) {

$parcel$export(module.exports, "millisecondsInWeek", function () { return $f8c54312f5a9ca53$export$4fad13613e88edc8; });
$parcel$export(module.exports, "millisecondsInMinute", function () { return $f8c54312f5a9ca53$export$91246f0b9bd9beff; });
$parcel$export(module.exports, "millisecondsInHour", function () { return $f8c54312f5a9ca53$export$7f72910d6dfd237a; });
$parcel$export(module.exports, "millisecondsInSecond", function () { return $f8c54312f5a9ca53$export$397c2d5776aa9055; });
/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $f8c54312f5a9ca53$export$dfd9b671c89acc8e = 7;
const $f8c54312f5a9ca53$export$3913210603d8e9ae = 365.2425;
const $f8c54312f5a9ca53$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
const $f8c54312f5a9ca53$export$4dec998e48f9c246 = -$f8c54312f5a9ca53$export$81caae6e1cc7a622;
const $f8c54312f5a9ca53$export$4fad13613e88edc8 = 604800000;
const $f8c54312f5a9ca53$export$b76b1809a2898f9a = 86400000;
const $f8c54312f5a9ca53$export$91246f0b9bd9beff = 60000;
const $f8c54312f5a9ca53$export$7f72910d6dfd237a = 3600000;
const $f8c54312f5a9ca53$export$397c2d5776aa9055 = 1000;
const $f8c54312f5a9ca53$export$3633035e63cee86a = 525600;
const $f8c54312f5a9ca53$export$ab7da2ccd1075c38 = 43200;
const $f8c54312f5a9ca53$export$2423174df8cd3cd2 = 1440;
const $f8c54312f5a9ca53$export$f2f5ae5a8e2d8f9f = 60;
const $f8c54312f5a9ca53$export$3c58128db900d44e = 3;
const $f8c54312f5a9ca53$export$80d7e435f744f319 = 12;
const $f8c54312f5a9ca53$export$4db7641526e3241f = 4;
const $f8c54312f5a9ca53$export$698aec755e92c695 = 3600;
const $f8c54312f5a9ca53$export$a77c1a7ebebe2a5a = 60;
const $f8c54312f5a9ca53$export$815a9362476d2fe3 = $f8c54312f5a9ca53$export$698aec755e92c695 * 24;
const $f8c54312f5a9ca53$export$34804a017b31e2fe = $f8c54312f5a9ca53$export$815a9362476d2fe3 * 7;
const $f8c54312f5a9ca53$export$7271e9e3478110d1 = $f8c54312f5a9ca53$export$815a9362476d2fe3 * $f8c54312f5a9ca53$export$3913210603d8e9ae;
const $f8c54312f5a9ca53$export$8e6600bbdee7dabb = $f8c54312f5a9ca53$export$7271e9e3478110d1 / 12;
const $f8c54312f5a9ca53$export$be1dccf2de902d31 = $f8c54312f5a9ca53$export$8e6600bbdee7dabb * 3;

});

parcelRegister("6mnS4", function(module, exports) {

$parcel$export(module.exports, "startOfWeek", function () { return $aafe02b5ea4bdafe$export$42c81a444fbfb5d4; });

var $l7oHg = parcelRequire("l7oHg");

var $8gw7j = parcelRequire("8gw7j");
function $aafe02b5ea4bdafe$export$42c81a444fbfb5d4(date, options) {
    const defaultOptions = (0, $8gw7j.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $l7oHg.toDate)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$aafe02b5ea4bdafe$export$2e2bcd8739ae039 = $aafe02b5ea4bdafe$export$42c81a444fbfb5d4;

});

parcelRegister("kf61z", function(module, exports) {

$parcel$export(module.exports, "startOfWeekYear", function () { return $566e20587b6103da$export$bb7b45bb8e74da0f; });

var $iNCNo = parcelRequire("iNCNo");

var $gn4gH = parcelRequire("gn4gH");

var $6mnS4 = parcelRequire("6mnS4");

var $8gw7j = parcelRequire("8gw7j");
function $566e20587b6103da$export$bb7b45bb8e74da0f(date, options) {
    const defaultOptions = (0, $8gw7j.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $gn4gH.getWeekYear)(date, options);
    const firstWeek = (0, $iNCNo.constructFrom)(date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $6mnS4.startOfWeek)(firstWeek, options);
    return _date;
}
var // Fallback for modularized imports:
$566e20587b6103da$export$2e2bcd8739ae039 = $566e20587b6103da$export$bb7b45bb8e74da0f;

});
parcelRegister("gn4gH", function(module, exports) {

$parcel$export(module.exports, "getWeekYear", function () { return $5efd5ddaa4943936$export$12d572480ceb6e58; });

var $iNCNo = parcelRequire("iNCNo");

var $6mnS4 = parcelRequire("6mnS4");

var $l7oHg = parcelRequire("l7oHg");

var $8gw7j = parcelRequire("8gw7j");
function $5efd5ddaa4943936$export$12d572480ceb6e58(date, options) {
    const _date = (0, $l7oHg.toDate)(date);
    const year = _date.getFullYear();
    const defaultOptions = (0, $8gw7j.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $iNCNo.constructFrom)(date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $6mnS4.startOfWeek)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $iNCNo.constructFrom)(date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $6mnS4.startOfWeek)(firstWeekOfThisYear, options);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$5efd5ddaa4943936$export$2e2bcd8739ae039 = $5efd5ddaa4943936$export$12d572480ceb6e58;

});



parcelRegister("1rDNO", function(module, exports) {

$parcel$export(module.exports, "isSameDay", function () { return $9f9bf15136c5fd76$export$ea39ec197993aef0; });

var $g9Sp7 = parcelRequire("g9Sp7");
function $9f9bf15136c5fd76$export$ea39ec197993aef0(dateLeft, dateRight) {
    const dateLeftStartOfDay = (0, $g9Sp7.startOfDay)(dateLeft);
    const dateRightStartOfDay = (0, $g9Sp7.startOfDay)(dateRight);
    return +dateLeftStartOfDay === +dateRightStartOfDay;
}
var // Fallback for modularized imports:
$9f9bf15136c5fd76$export$2e2bcd8739ae039 = $9f9bf15136c5fd76$export$ea39ec197993aef0;

});
parcelRegister("g9Sp7", function(module, exports) {

$parcel$export(module.exports, "startOfDay", function () { return $af0525343c1a9b0f$export$63fa379ae8a9ba2; });

var $l7oHg = parcelRequire("l7oHg");
function $af0525343c1a9b0f$export$63fa379ae8a9ba2(date) {
    const _date = (0, $l7oHg.toDate)(date);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$af0525343c1a9b0f$export$2e2bcd8739ae039 = $af0525343c1a9b0f$export$63fa379ae8a9ba2;

});


parcelRegister("irq5s", function(module, exports) {

$parcel$export(module.exports, "startOfQuarter", function () { return $04101a8b134d1184$export$69be7267a042ecb3; });

var $l7oHg = parcelRequire("l7oHg");
function $04101a8b134d1184$export$69be7267a042ecb3(date) {
    const _date = (0, $l7oHg.toDate)(date);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3;
    _date.setMonth(month, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$04101a8b134d1184$export$2e2bcd8739ae039 = $04101a8b134d1184$export$69be7267a042ecb3;

});

parcelRegister("8WGRA", function(module, exports) {

$parcel$export(module.exports, "startOfYear", function () { return $af6e640337d15d2a$export$f91e89d3d0406102; });

var $l7oHg = parcelRequire("l7oHg");

var $iNCNo = parcelRequire("iNCNo");
function $af6e640337d15d2a$export$f91e89d3d0406102(date) {
    const cleanDate = (0, $l7oHg.toDate)(date);
    const _date = (0, $iNCNo.constructFrom)(date, 0);
    _date.setFullYear(cleanDate.getFullYear(), 0, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$af6e640337d15d2a$export$2e2bcd8739ae039 = $af6e640337d15d2a$export$f91e89d3d0406102;

});

parcelRegister("3qWnK", function(module, exports) {

$parcel$export(module.exports, "sub", function () { return $9fa27d2afcf17b23$export$f93b5905241a7cca; });

var $dzAlt = parcelRequire("dzAlt");

var $8Xlr4 = parcelRequire("8Xlr4");

var $iNCNo = parcelRequire("iNCNo");
function $9fa27d2afcf17b23$export$f93b5905241a7cca(date, duration) {
    const { years: years = 0, months: months = 0, weeks: weeks = 0, days: days = 0, hours: hours = 0, minutes: minutes = 0, seconds: seconds = 0 } = duration;
    // Subtract years and months
    const dateWithoutMonths = (0, $8Xlr4.subMonths)(date, months + years * 12);
    // Subtract weeks and days
    const dateWithoutDays = (0, $dzAlt.subDays)(dateWithoutMonths, days + weeks * 7);
    // Subtract hours, minutes and seconds
    const minutestoSub = minutes + hours * 60;
    const secondstoSub = seconds + minutestoSub * 60;
    const mstoSub = secondstoSub * 1000;
    const finalDate = (0, $iNCNo.constructFrom)(date, dateWithoutDays.getTime() - mstoSub);
    return finalDate;
}
var // Fallback for modularized imports:
$9fa27d2afcf17b23$export$2e2bcd8739ae039 = $9fa27d2afcf17b23$export$f93b5905241a7cca;

});
parcelRegister("dzAlt", function(module, exports) {

$parcel$export(module.exports, "subDays", function () { return $861d094237854a18$export$70823084e2deb1ea; });

var $2gXaN = parcelRequire("2gXaN");
function $861d094237854a18$export$70823084e2deb1ea(date, amount) {
    return (0, $2gXaN.addDays)(date, -amount);
}
var // Fallback for modularized imports:
$861d094237854a18$export$2e2bcd8739ae039 = $861d094237854a18$export$70823084e2deb1ea;

});

parcelRegister("8Xlr4", function(module, exports) {

$parcel$export(module.exports, "subMonths", function () { return $2e232aeac2a8f6f4$export$73d1c15a21f9fae5; });

var $6lxwW = parcelRequire("6lxwW");
function $2e232aeac2a8f6f4$export$73d1c15a21f9fae5(date, amount) {
    return (0, $6lxwW.addMonths)(date, -amount);
}
var // Fallback for modularized imports:
$2e232aeac2a8f6f4$export$2e2bcd8739ae039 = $2e232aeac2a8f6f4$export$73d1c15a21f9fae5;

});



parcelRegister("dafh3", function(module, exports) {

$parcel$export(module.exports, "DataTableFilterCombobox", function () { return $b65d247670aabd4d$export$f1715abe4806eefb; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $jSiTu = parcelRequire("jSiTu");

var $fTGwv = parcelRequire("fTGwv");

var $fRrIT = parcelRequire("fRrIT");

var $l4nwI = parcelRequire("l4nwI");
function $b65d247670aabd4d$export$f1715abe4806eefb({ options: options, selectedOptions: selectedOptions, onFilterChange: onFilterChange, children: children }) {
    var _options$;
    const [value, setValue] = $jbmdS.useState("");
    const [open, setOpen] = $jbmdS.useState(false);
    const [selectedOption, setSelectedOption] = $jbmdS.useState((_options$ = options[0]) !== null && _options$ !== void 0 ? _options$ : {});
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $l4nwI.Popover), {
        open: open,
        onOpenChange: setOpen,
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $l4nwI.PopoverTrigger), {
                asChild: true,
                children: children !== null && children !== void 0 ? children : /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fTGwv.Button), {
                    variant: "outline",
                    size: "sm",
                    role: "combobox",
                    className: "capitalize",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jSiTu.CaretSortIcon), {
                            className: "mr-2 size-4 shrink-0",
                            "aria-hidden": "true"
                        }),
                        "Filter"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $l4nwI.PopoverContent), {
                className: "w-[20rem] p-0",
                align: "end",
                children: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fRrIT.Command), {
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fRrIT.CommandInput), {
                            placeholder: "Filter by..."
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fRrIT.CommandList), {
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fRrIT.CommandEmpty), {
                                    children: "No item found."
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fRrIT.CommandGroup), {
                                    children: options.filter((option)=>!selectedOptions.some((selectedOption)=>selectedOption.value === option.value)).map((option)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $fRrIT.CommandItem), {
                                            className: "capitalize",
                                            value: String(option.value),
                                            onSelect: (currentValue)=>{
                                                setValue(currentValue === value ? "" : currentValue);
                                                setOpen(false);
                                                setSelectedOption(option);
                                                const currentOptions = selectedOptions;
                                                const newOptions = [
                                                    ...currentOptions,
                                                    {
                                                        ...option
                                                    }
                                                ];
                                                onFilterChange(newOptions);
                                            },
                                            children: option.label
                                        }, String(option.value)))
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fRrIT.CommandSeparator), {})
                            ]
                        })
                    ]
                })
            })
        ]
    });
}

});

parcelRegister("6nxaR", function(module, exports) {

$parcel$export(module.exports, "DataTableViewOptions", function () { return $f429e6c69a24e66f$export$24a06ad4874e38da; });
$parcel$export(module.exports, "DataTableGroupOptions", function () { return $f429e6c69a24e66f$export$cb07a15045e4f8a5; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $jSiTu = parcelRequire("jSiTu");

var $4Jl8d = parcelRequire("4Jl8d");

var $fTGwv = parcelRequire("fTGwv");

var $l4nwI = parcelRequire("l4nwI");

var $2YJBX = parcelRequire("2YJBX");

var $95Evz = parcelRequire("95Evz");
const $f429e6c69a24e66f$export$24a06ad4874e38da = /*#__PURE__*/ $jbmdS.forwardRef(function DataTableViewOptions({ table: table, onColumnsChange: onColumnsChange, tableState: tableState, fixedColumns: fixedColumns = [] }) {
    const [searchQuery, setSearchQuery] = $jbmdS.useState("");
    const [open, setOpen] = $jbmdS.useState(false);
    const columns = table.getAllColumns().filter((column)=>{
        var _column$columnDef, _column$columnDef$met;
        return typeof column.accessorFn !== "undefined" && column.getCanHide() && ((_column$columnDef = column.columnDef) === null || _column$columnDef === void 0 ? void 0 : (_column$columnDef$met = _column$columnDef.meta) === null || _column$columnDef$met === void 0 ? void 0 : _column$columnDef$met.title.toLowerCase().includes(searchQuery.toLowerCase()));
    });
    const sortedColumns = [
        ...columns
    ].sort((a, b)=>{
        if (a.getIsVisible() === b.getIsVisible()) return 0;
        return a.getIsVisible() ? -1 : 1;
    });
    const filteredColumns = sortedColumns.filter((column)=>{
        var _column$columnDef2, _column$columnDef2$me;
        return (_column$columnDef2 = column.columnDef) === null || _column$columnDef2 === void 0 ? void 0 : (_column$columnDef2$me = _column$columnDef2.meta) === null || _column$columnDef2$me === void 0 ? void 0 : _column$columnDef2$me.title.toLowerCase().includes(searchQuery.toLowerCase());
    });
    const onDragEnd = (result)=>{
        if (!result.destination) return;
        const newColumns = Array.from(filteredColumns);
        const [reorderedItem] = newColumns.splice(result.source.index, 1);
        newColumns.splice(result.destination.index, 0, reorderedItem);
        onColumnsChange(newColumns.filter((col)=>col.getIsVisible()).map((col)=>col.id), {
            needsRefetch: false
        });
    };
    const renderClone = (provided, snapshot, rubric)=>{
        var _filteredColumns$rubr;
        return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            ref: provided.innerRef,
            ...provided.draggableProps,
            ...provided.dragHandleProps,
            children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: (0, $95Evz.cn)("flex items-center relative py-1.5", snapshot.isDragging && "bg-accent"),
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jSiTu.CheckIcon), {
                        className: (0, $95Evz.cn)("mr-2")
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                        className: "truncate",
                        children: ((_filteredColumns$rubr = filteredColumns[rubric.source.index].columnDef) === null || _filteredColumns$rubr === void 0 ? void 0 : _filteredColumns$rubr.meta).title
                    })
                ]
            })
        });
    };
    const ColumnItem = /*#__PURE__*/ $jbmdS.memo(({ column: column, index: index, isLastVisible: isLastVisible })=>{
        const selected = tableState.columns.includes(column.id);
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $4Jl8d.Draggable), {
            draggableId: column.id,
            index: index,
            isDragDisabled: !column.getIsVisible(),
            children: (provided)=>{
                var _column$columnDef3, _column$columnDef3$me;
                return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    ref: provided.innerRef,
                    ...provided.draggableProps,
                    ...provided.dragHandleProps,
                    children: /*#__PURE__*/ (0, $61Ea1.jsxs)("li", {
                        onClick: ()=>{
                            column.toggleVisibility(!selected);
                            if (!selected) onColumnsChange([
                                ...tableState.columns,
                                column.id
                            ]);
                            else onColumnsChange(tableState.columns.filter((id)=>id !== column.id));
                        },
                        className: (0, $95Evz.cn)("flex items-center relative cursor-pointer py-1.5", selected && isLastVisible && "border-b border-border mb-2"),
                        children: [
                            selected && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jSiTu.CheckIcon), {
                                className: (0, $95Evz.cn)("mr-2")
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                className: (0, $95Evz.cn)("truncate", selected ? "" : "ml-7"),
                                children: (_column$columnDef3 = column.columnDef) === null || _column$columnDef3 === void 0 ? void 0 : (_column$columnDef3$me = _column$columnDef3.meta) === null || _column$columnDef3$me === void 0 ? void 0 : _column$columnDef3$me.title
                            })
                        ]
                    }, column.id)
                });
            }
        });
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $l4nwI.Popover), {
        open: open,
        onOpenChange: setOpen,
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $l4nwI.PopoverTrigger), {
                asChild: true,
                children: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fTGwv.Button), {
                    "aria-label": "Toggle columns",
                    variant: "outline",
                    size: "sm",
                    className: "ml-auto hidden h-8 lg:flex",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jSiTu.MixerHorizontalIcon), {
                            className: "mr-2 size-4"
                        }),
                        "Select columns"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $l4nwI.PopoverContent), {
                className: "w-[20rem] p-0",
                align: "end",
                children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    className: "pl-2",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $2YJBX.Input), {
                            placeholder: "Search columns...",
                            value: searchQuery,
                            className: "bg-transparent focus-visible:outline-none focus-visible:ring-0 border-none pl-6 pr-2 py-1 h-8",
                            onChange: (e)=>setSearchQuery(e.target.value),
                            prefix: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jSiTu.MagnifyingGlassIcon), {})
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)("ul", {
                            className: "max-h-[400px] overflow-y-auto overflow-x-hidden",
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $4Jl8d.DragDropContext), {
                                onDragEnd: onDragEnd,
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $4Jl8d.Droppable), {
                                    droppableId: "column-list",
                                    renderClone: renderClone,
                                    children: (provided, snapshot)=>/*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                            ...provided.droppableProps,
                                            ref: provided.innerRef,
                                            className: snapshot.isDraggingOver ? "pointer-events-none" : "",
                                            children: [
                                                filteredColumns.map((column, index)=>/*#__PURE__*/ (0, $61Ea1.jsx)(ColumnItem, {
                                                        column: column,
                                                        index: index,
                                                        isLastVisible: index === filteredColumns.findIndex((col)=>!col.getIsVisible()) - 1
                                                    }, `${column.id}-${column.getIsVisible()}-${index}`)),
                                                provided.placeholder
                                            ]
                                        })
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
});
const $f429e6c69a24e66f$export$cb07a15045e4f8a5 = /*#__PURE__*/ $jbmdS.forwardRef(function DataTableGroupOptions({ table: table, onStateChange: onStateChange, tableState: tableState }) {
    // Check logic again
    const [searchQuery, setSearchQuery] = $jbmdS.useState("");
    const [open, setOpen] = $jbmdS.useState(false);
    const listGroups = tableState.groupBy;
    const columns = table.getAllColumns().filter((column)=>{
        var _column$columnDef4, _column$columnDef4$me;
        return typeof column.accessorFn !== "undefined" && column.getCanHide() && ((_column$columnDef4 = column.columnDef) === null || _column$columnDef4 === void 0 ? void 0 : (_column$columnDef4$me = _column$columnDef4.meta) === null || _column$columnDef4$me === void 0 ? void 0 : _column$columnDef4$me.title.toLowerCase().includes(searchQuery.toLowerCase()));
    });
    const sortedColumns = $jbmdS.useMemo(()=>{
        return [
            ...columns
        ].sort((a, b)=>{
            const aIndex = listGroups.indexOf(a.id);
            const bIndex = listGroups.indexOf(b.id);
            if (aIndex === -1 && bIndex === -1) return 0;
            if (aIndex === -1) return 1;
            if (bIndex === -1) return -1;
            return aIndex - bIndex;
        });
    }, [
        tableState.groupBy
    ]);
    const filteredColumns = $jbmdS.useMemo(()=>{
        return sortedColumns.filter((column)=>{
            var _column$columnDef5, _column$columnDef5$me;
            return (_column$columnDef5 = column.columnDef) === null || _column$columnDef5 === void 0 ? void 0 : (_column$columnDef5$me = _column$columnDef5.meta) === null || _column$columnDef5$me === void 0 ? void 0 : _column$columnDef5$me.title.toLowerCase().includes(searchQuery.toLowerCase());
        });
    }, [
        sortedColumns,
        searchQuery
    ]);
    const onDragEnd = (result)=>{
        if (!result.destination) return;
        const newColumns = Array.from(filteredColumns);
        const [reorderedItem] = newColumns.splice(result.source.index, 1);
        newColumns.splice(result.destination.index, 0, reorderedItem);
        const groupColumns = newColumns.filter((columnId)=>listGroups.includes(columnId.id)).map((item)=>item.id);
        onStateChange({
            groupBy: groupColumns
        });
    };
    const renderClone = (provided, snapshot, rubric)=>{
        var _filteredColumns$rubr2;
        return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            ref: provided.innerRef,
            ...provided.draggableProps,
            ...provided.dragHandleProps,
            children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: (0, $95Evz.cn)("flex items-center relative py-1.5", snapshot.isDragging && "bg-accent"),
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jSiTu.CheckIcon), {
                        className: (0, $95Evz.cn)("mr-2")
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                        className: "truncate",
                        children: ((_filteredColumns$rubr2 = filteredColumns[rubric.source.index].columnDef) === null || _filteredColumns$rubr2 === void 0 ? void 0 : _filteredColumns$rubr2.meta).title
                    })
                ]
            })
        });
    };
    const ColumnItem = /*#__PURE__*/ $jbmdS.memo(({ column: column, index: index, isLastGroupItem: isLastGroupItem })=>{
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $4Jl8d.Draggable), {
            draggableId: column.id,
            index: index,
            isDragDisabled: !listGroups.includes(column.id),
            children: (provided)=>{
                var _column$columnDef6, _column$columnDef6$me;
                return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    ref: provided.innerRef,
                    ...provided.draggableProps,
                    ...provided.dragHandleProps,
                    children: /*#__PURE__*/ (0, $61Ea1.jsxs)("li", {
                        onClick: ()=>{
                            const newListGroups = listGroups.includes(column.id) ? listGroups.filter((id)=>id !== column.id) : [
                                ...listGroups,
                                column.id
                            ];
                            onStateChange({
                                groupBy: newListGroups
                            });
                        },
                        className: (0, $95Evz.cn)("flex items-center relative cursor-pointer py-1.5", listGroups.includes(column.id) && isLastGroupItem && "border-b border-border mb-2"),
                        children: [
                            listGroups.includes(column.id) && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jSiTu.CheckIcon), {
                                className: (0, $95Evz.cn)("mr-2")
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                className: (0, $95Evz.cn)("truncate", listGroups.includes(column.id) ? "" : "ml-7"),
                                children: (_column$columnDef6 = column.columnDef) === null || _column$columnDef6 === void 0 ? void 0 : (_column$columnDef6$me = _column$columnDef6.meta) === null || _column$columnDef6$me === void 0 ? void 0 : _column$columnDef6$me.title
                            })
                        ]
                    }, column.id)
                });
            }
        });
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $l4nwI.Popover), {
        open: open,
        onOpenChange: setOpen,
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $l4nwI.PopoverTrigger), {
                asChild: true,
                children: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fTGwv.Button), {
                    "aria-label": "Toggle columns",
                    variant: "outline",
                    size: "sm",
                    className: "ml-auto hidden h-8 lg:flex",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jSiTu.MixerHorizontalIcon), {
                            className: "mr-2 size-4"
                        }),
                        "Select groups"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $l4nwI.PopoverContent), {
                className: "w-[20rem] p-0",
                align: "end",
                children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    className: "pl-2",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $2YJBX.Input), {
                            placeholder: "Search columns...",
                            value: searchQuery,
                            className: "bg-transparent focus-visible:outline-none focus-visible:ring-0 border-none pl-6 pr-2 py-1 h-8",
                            onChange: (e)=>setSearchQuery(e.target.value),
                            prefix: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jSiTu.MagnifyingGlassIcon), {})
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)("ul", {
                            className: "max-h-[400px] overflow-y-auto overflow-x-hidden",
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $4Jl8d.DragDropContext), {
                                onDragEnd: onDragEnd,
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $4Jl8d.Droppable), {
                                    droppableId: "column-list",
                                    renderClone: renderClone,
                                    children: (provided, snapshot)=>/*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                            ...provided.droppableProps,
                                            ref: provided.innerRef,
                                            className: snapshot.isDraggingOver ? "pointer-events-none" : "",
                                            children: [
                                                filteredColumns.map((column, index)=>/*#__PURE__*/ (0, $61Ea1.jsx)(ColumnItem, {
                                                        column: column,
                                                        index: index,
                                                        isLastGroupItem: index === filteredColumns.findIndex((col)=>!listGroups.includes(col.id)) - 1
                                                    }, `${column.id}-${listGroups.includes(column.id)}-${index}`)),
                                                provided.placeholder
                                            ]
                                        })
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
});

});

parcelRegister("3QWaF", function(module, exports) {

$parcel$export(module.exports, "DataTableFilterItem", function () { return $0a8ee611b90f97f0$export$efeb702103d1ae3a; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $6UBLf = parcelRequire("6UBLf");
var $5zaoU = parcelRequire("5zaoU");

var $jSiTu = parcelRequire("jSiTu");

var $7sgU6 = parcelRequire("7sgU6");

var $Yha9m = parcelRequire("Yha9m");

var $hPAFY = parcelRequire("hPAFY");

var $fTGwv = parcelRequire("fTGwv");

var $2YJBX = parcelRequire("2YJBX");

var $8jD92 = parcelRequire("8jD92");

var $l4nwI = parcelRequire("l4nwI");

var $3Gs4l = parcelRequire("3Gs4l");

var $80DmM = parcelRequire("80DmM");

var $7DTxc = parcelRequire("7DTxc");

var $eL2bj = parcelRequire("eL2bj");

var $lkZM6 = parcelRequire("lkZM6");

var $eriOD = parcelRequire("eriOD");

var $i0shw = parcelRequire("i0shw");
function $0a8ee611b90f97f0$export$efeb702103d1ae3a({ table: table, selectedOption: selectedOption, selectedOptions: selectedOptions, onFilterChange: onFilterChange, defaultOpen: defaultOpen, showApplyToPhase: showApplyToPhase }) {
    var _selectedOptions$find, _filterValues$, _filterValues$2, _operators$find;
    const navigate = (0, $6UBLf.useNavigate)();
    const search = (0, $5zaoU.useSearch)({
        strict: false
    });
    const column = table.getColumn(selectedOption.value ? String(selectedOption.value) : "");
    const columnSelected = selectedOptions.find((item)=>item.value === (column === null || column === void 0 ? void 0 : column.id));
    const filterValues = Array.isArray(columnSelected === null || columnSelected === void 0 ? void 0 : columnSelected.filterValues) ? columnSelected === null || columnSelected === void 0 ? void 0 : columnSelected.filterValues : [
        columnSelected === null || columnSelected === void 0 ? void 0 : columnSelected.filterValues
    ];
    const selectedValues = new Set(filterValues);
    const filterOperator = (_selectedOptions$find = selectedOptions.find((item)=>item.value === (column === null || column === void 0 ? void 0 : column.id))) === null || _selectedOptions$find === void 0 ? void 0 : _selectedOptions$find.filterOperator;
    const operatorMap = {
        text: (0, $7sgU6.dataTableConfig).textComparisonOperators,
        number: (0, $7sgU6.dataTableConfig).numberComparisonOperators,
        percent: (0, $7sgU6.dataTableConfig).numberComparisonOperators,
        currency: (0, $7sgU6.dataTableConfig).numberComparisonOperators,
        date: (0, $7sgU6.dataTableConfig).dateComparisonOperators,
        time: (0, $7sgU6.dataTableConfig).dateComparisonOperators
    };
    const operators = operatorMap[selectedOption.typeFilter] || (0, $7sgU6.dataTableConfig).selectableOperators;
    const [value, setValue] = $jbmdS.useState((_filterValues$ = filterValues[0]) !== null && _filterValues$ !== void 0 ? _filterValues$ : "");
    const [secondValue, setSecondValue] = $jbmdS.useState((_filterValues$2 = filterValues[1]) !== null && _filterValues$2 !== void 0 ? _filterValues$2 : "");
    const [singleDate, setSingleDate] = $jbmdS.useState(filterValues[0] ? new Date(filterValues[0]) : new Date());
    const [startDate, setStartDate] = $jbmdS.useState(filterValues[0] ? new Date(filterValues[0]) : new Date());
    const [endDate, setEndDate] = $jbmdS.useState(filterValues[1] ? new Date(filterValues[1]) : new Date());
    const debounceValue = (0, $hPAFY.useDebounce)(value, 500);
    const [open, setOpen] = $jbmdS.useState(defaultOpen);
    const [selectedOperator, setSelectedOperator] = $jbmdS.useState((_operators$find = operators.find((c)=>c.value === filterOperator)) !== null && _operators$find !== void 0 ? _operators$find : operators[0]);
    const [applyToPhases, setApplyToPhases] = $jbmdS.useState(columnSelected.isApplyToPhases);
    // Create query string
    const createQueryString = $jbmdS.useCallback((params)=>{
        const newSearch = {
            ...search
        };
        for (const [key, value] of Object.entries(params))if (value === null) delete newSearch[key];
        else newSearch[key] = String(value);
        return newSearch;
    }, [
        search
    ]);
    // Update query string
    // React.useEffect(() => {
    //     if (selectedOption.options.length > 0) {
    //         // key=value1.value2.value3~operator
    //         const newSearch = createQueryString({
    //             [String(selectedOption.value)]:
    //                 filterValues.length > 0
    //                     ? `${filterValues.join('.')}~${selectedOperator?.value}`
    //                     : null,
    //         })
    //         navigate({ search: newSearch })
    //     } else {
    //         const newSearch = createQueryString({
    //             [String(selectedOption.value)]:
    //                 debounceValue.length > 0
    //                     ? `${debounceValue}~${selectedOperator?.value}`
    //                     : null,
    //         })
    //         navigate({ search: newSearch })
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [selectedOption, debounceValue, selectedOperator])
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $l4nwI.Popover), {
        open: open,
        onOpenChange: setOpen,
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $l4nwI.PopoverTrigger), {
                asChild: true,
                children: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fTGwv.Button), {
                    variant: "outline",
                    size: "sm",
                    className: (0, $Yha9m.cn)("h-7 gap-0 truncate rounded-full", (selectedValues.size > 0 || value.toString().length > 0) && "bg-muted/50"),
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                            className: "font-medium capitalize",
                            children: selectedOption.label
                        }),
                        selectedOption.typeFilter === "select" ? selectedValues.size > 0 && /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                            className: "text-muted-foreground",
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                    className: "text-foreground",
                                    children: ": "
                                }),
                                selectedValues.size > 2 ? `${selectedValues.size} selected` : selectedOption.options.filter((item)=>selectedValues.has(item.value)).map((item)=>item.label).join(", ")
                            ]
                        }) : selectedOption.typeFilter === "date" ? /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                            className: "text-muted-foreground",
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                    className: "text-foreground",
                                    children: ": "
                                }),
                                selectedOperator.value === "between" || selectedOperator.value === "!between" ? /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                                    children: [
                                        startDate && startDate.toLocaleDateString(),
                                        endDate && ` - ${endDate.toLocaleDateString()}`
                                    ]
                                }) : /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
                                    children: singleDate && singleDate.toLocaleDateString()
                                })
                            ]
                        }) : selectedOption.typeFilter === "time" ? /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                            className: "text-muted-foreground",
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                    className: "text-foreground",
                                    children: ": "
                                }),
                                selectedOperator.value === "between" || selectedOperator.value === "!between" ? /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                                    children: [
                                        startDate && (0, $i0shw.FormatTime)(startDate),
                                        endDate && ` - ${(0, $i0shw.FormatTime)(endDate)}`
                                    ]
                                }) : /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
                                    children: singleDate && (0, $i0shw.FormatTime)(singleDate)
                                })
                            ]
                        }) : (value.toString().length > 0 || secondValue.toString().length > 0) && /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                            className: "text-muted-foreground",
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                    className: "text-foreground",
                                    children: ": "
                                }),
                                value,
                                (secondValue.toString().length > 0 && selectedOperator.value === "between" || selectedOperator.value === "!between") && ` - ${secondValue}`,
                                selectedOption.typeFilter === "percent" && "%",
                                selectedOption.typeFilter === "currency" && "$"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $l4nwI.PopoverContent), {
                className: "w-80 space-y-1.5 p-2",
                align: "start",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "flex items-center space-x-1 pl-1 pr-0.5 mb-2",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                className: "flex flex-1 items-center space-x-1",
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        className: "text-xs capitalize text-muted-foreground",
                                        children: selectedOption.label
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $3Gs4l.Select), {
                                        value: selectedOperator === null || selectedOperator === void 0 ? void 0 : selectedOperator.value,
                                        onValueChange: (value)=>{
                                            setSelectedOperator(operators.find((c)=>c.value === value));
                                            const currentOptions = selectedOptions;
                                            const newOptions = currentOptions.map((option)=>option.value === selectedOption.value ? {
                                                    ...option,
                                                    filterOperator: value
                                                } : option);
                                            onFilterChange(newOptions);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3Gs4l.SelectTrigger), {
                                                className: "h-auto w-fit truncate border-none px-2 py-0.5 text-xs hover:bg-muted/50",
                                                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3Gs4l.SelectValue), {
                                                    placeholder: selectedOperator === null || selectedOperator === void 0 ? void 0 : selectedOperator.label
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3Gs4l.SelectContent), {
                                                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3Gs4l.SelectGroup), {
                                                    children: operators.map((item)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $3Gs4l.SelectItem), {
                                                            value: item.value,
                                                            className: "py-1",
                                                            children: item.label
                                                        }, item.value))
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fTGwv.Button), {
                                "aria-label": "Remove filter",
                                variant: "ghost",
                                size: "icon",
                                className: "size-7 text-muted-foreground",
                                onClick: ()=>{
                                    const currentOptions = selectedOptions;
                                    const newOptions = currentOptions.filter((item)=>item.value !== selectedOption.value);
                                    onFilterChange(newOptions);
                                },
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jSiTu.TrashIcon), {
                                    className: "size-4",
                                    "aria-hidden": "true"
                                })
                            })
                        ]
                    }),
                    selectedOption.typeFilter === "date" ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
                        children: selectedOperator.value === "between" || selectedOperator.value === "!between" ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $eL2bj.DateRangePicker), {
                            initialDateFrom: startDate,
                            initialDateTo: endDate,
                            onUpdate: ({ range: range })=>{
                                setStartDate(range.from);
                                setEndDate(range.to);
                                const currentOptions = selectedOptions;
                                const newOptions = currentOptions.map((option)=>{
                                    if (option.value === selectedOption.value) return {
                                        ...option,
                                        filterValues: [
                                            (0, $lkZM6.formatDateISOString)(range.from),
                                            (0, $lkZM6.formatDateISOString)(range.to)
                                        ]
                                    };
                                    return option;
                                });
                                onFilterChange(newOptions);
                            },
                            align: "start",
                            showCompare: false
                        }) : /*#__PURE__*/ (0, $61Ea1.jsx)((0, $80DmM.DatePicker), {
                            value: singleDate,
                            onChange: (date)=>{
                                setSingleDate(date);
                                const currentOptions = selectedOptions;
                                const newOptions = currentOptions.map((option)=>option.value === selectedOption.value ? {
                                        ...option,
                                        filterValues: (0, $lkZM6.formatDateISOString)(date)
                                    } : option);
                                onFilterChange(newOptions);
                            }
                        })
                    }) : selectedOption.typeFilter === "time" ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
                        children: selectedOperator.value === "between" || selectedOperator.value === "!between" ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $eriOD.TimePicker), {
                                    value: startDate,
                                    onChange: (date)=>{
                                        setStartDate(date);
                                        const currentOptions = selectedOptions;
                                        const newOptions = currentOptions.map((option)=>{
                                            if (option.value === selectedOption.value) return {
                                                ...option,
                                                filterValues: [
                                                    (0, $lkZM6.formatTimeISOString)(date),
                                                    (0, $lkZM6.formatTimeISOString)(endDate)
                                                ]
                                            };
                                            return option;
                                        });
                                        onFilterChange(newOptions);
                                    }
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $eriOD.TimePicker), {
                                    value: endDate,
                                    onChange: (date)=>{
                                        setEndDate(date);
                                        const currentOptions = selectedOptions;
                                        const newOptions = currentOptions.map((option)=>{
                                            if (option.value === selectedOption.value) return {
                                                ...option,
                                                filterValues: [
                                                    (0, $lkZM6.formatTimeISOString)(startDate),
                                                    (0, $lkZM6.formatTimeISOString)(date)
                                                ]
                                            };
                                            return option;
                                        });
                                        onFilterChange(newOptions);
                                    }
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $61Ea1.jsx)((0, $eriOD.TimePicker), {
                            value: singleDate,
                            onChange: (date)=>{
                                setSingleDate(date);
                                const currentOptions = selectedOptions;
                                const newOptions = currentOptions.map((option)=>{
                                    if (option.value === selectedOption.value) return {
                                        ...option,
                                        filterValues: (0, $lkZM6.formatTimeISOString)(date)
                                    };
                                    return option;
                                });
                                onFilterChange(newOptions);
                            }
                        })
                    }) : selectedOption.typeFilter === "select" ? column && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7DTxc.DataTableAdvancedFacetedFilter), {
                        column: column,
                        title: selectedOption.label,
                        options: selectedOption.options,
                        groupBy: selectedOption.groupBy,
                        sortGroups: selectedOption.sortGroups,
                        selectedValues: selectedValues,
                        selectedOptions: selectedOptions,
                        onFilterChange: onFilterChange
                    }, String(selectedOption.value)) : /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
                        children: selectedOperator.value === "between" || selectedOperator.value === "!between" ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            className: "flex space-x-2",
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $2YJBX.Input), {
                                    suffix: selectedOption.typeFilter === "percent" ? "%" : selectedOption.typeFilter === "currency" ? "$" : "",
                                    placeholder: "From",
                                    className: "h-8",
                                    value: value,
                                    onChange: (e)=>{
                                        setValue(e.target.value);
                                        const currentOptions = selectedOptions;
                                        const newOptions = currentOptions.map((option)=>{
                                            if (option.value === selectedOption.value) return {
                                                ...option,
                                                filterValues: [
                                                    e.target.value !== "" ? Number(e.target.value) : "",
                                                    secondValue
                                                ]
                                            };
                                            return option;
                                        });
                                        onFilterChange(newOptions);
                                    },
                                    autoFocus: true
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $2YJBX.Input), {
                                    suffix: selectedOption.typeFilter === "percent" ? "%" : selectedOption.typeFilter === "currency" ? "$" : "",
                                    placeholder: "To",
                                    className: "h-8",
                                    value: secondValue,
                                    onChange: (e)=>{
                                        setSecondValue(e.target.value);
                                        const currentOptions = selectedOptions;
                                        const newOptions = currentOptions.map((option)=>{
                                            if (option.value === selectedOption.value) return {
                                                ...option,
                                                filterValues: [
                                                    value,
                                                    e.target.value !== "" ? Number(e.target.value) : ""
                                                ]
                                            };
                                            return option;
                                        });
                                        onFilterChange(newOptions);
                                    }
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $61Ea1.jsx)((0, $2YJBX.Input), {
                            suffix: selectedOption.typeFilter === "percent" ? "%" : selectedOption.typeFilter === "currency" ? "$" : "",
                            className: "h-8",
                            value: value,
                            onChange: (e)=>{
                                setValue(e.target.value);
                                const currentOptions = selectedOptions;
                                const newOptions = currentOptions.map((option)=>{
                                    if (option.value === selectedOption.value) return {
                                        ...option,
                                        filterValues: e.target.value
                                    };
                                    return option;
                                });
                                onFilterChange(newOptions);
                            },
                            autoFocus: true
                        })
                    }),
                    showApplyToPhase && /*#__PURE__*/ (0, $61Ea1.jsxs)("label", {
                        className: "!mt-4 flex items-center gap-x-2",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8jD92.Checkbox), {
                                checked: applyToPhases,
                                onCheckedChange: (checked)=>{
                                    setApplyToPhases(checked === true);
                                    const currentOptions = selectedOptions;
                                    const newOptions = currentOptions.map((option)=>{
                                        if (option.value === selectedOption.value) return {
                                            ...option,
                                            isApplyToPhases: checked
                                        };
                                        return option;
                                    });
                                    onFilterChange(newOptions);
                                }
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                children: "Apply to phases"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

});
parcelRegister("7sgU6", function(module, exports) {

$parcel$export(module.exports, "dataTableConfig", function () { return $e437d1e798775caf$export$7ac3753ee4f78186; });

var $jSiTu = parcelRequire("jSiTu");
const $e437d1e798775caf$export$7ac3753ee4f78186 = {
    textComparisonOperators: [
        {
            label: "is equal to",
            value: "="
        },
        {
            label: "isn't equal to",
            value: "!="
        },
        {
            label: "contains",
            value: "contains"
        },
        {
            label: "doesn't contain",
            value: "!contains"
        },
        {
            label: "starts with",
            value: "starts"
        },
        {
            label: "doesn't start with",
            value: "!starts"
        },
        {
            label: "ends with",
            value: "ends"
        },
        {
            label: "doesn't end with",
            value: "!ends"
        }
    ],
    numberComparisonOperators: [
        {
            label: "is equal to",
            value: "="
        },
        {
            label: "isn't equal to",
            value: "!="
        },
        {
            label: "is greater than",
            value: ">"
        },
        {
            label: "is less than",
            value: "<"
        },
        {
            label: "is between",
            value: "between"
        },
        {
            label: "is not between",
            value: "!between"
        }
    ],
    dateComparisonOperators: [
        {
            label: "occurs on",
            value: "="
        },
        {
            label: "didn't occur on",
            value: "!="
        },
        {
            label: "occurs after",
            value: ">"
        },
        {
            label: "occurs before",
            value: "<"
        },
        {
            label: "occurs during",
            value: "between"
        },
        {
            label: "didn't occur during",
            value: "!between"
        }
    ],
    selectableOperators: [
        {
            label: "is any of",
            value: "in"
        },
        {
            label: "isn't any of",
            value: "!in"
        }
    ],
    logicalOperators: [
        {
            label: "And",
            value: "and",
            description: "All conditions must be met"
        },
        {
            label: "Or",
            value: "or",
            description: "At least one condition must be met"
        }
    ],
    featureFlags: [
        {
            label: "Advanced filter",
            value: "advancedFilter",
            icon: (0, $jSiTu.MixIcon),
            tooltipTitle: "Toggle advanced filter",
            tooltipDescription: "A notion like query builder to filter rows."
        }
    ]
};

});

parcelRegister("7DTxc", function(module, exports) {

$parcel$export(module.exports, "DataTableAdvancedFacetedFilter", function () { return $58bf4c1ccc7f4e1e$export$bfad6f317a2e3192; });

var $61Ea1 = parcelRequire("61Ea1");

var $jSiTu = parcelRequire("jSiTu");

var $Yha9m = parcelRequire("Yha9m");

var $fRrIT = parcelRequire("fRrIT");
function $58bf4c1ccc7f4e1e$export$bfad6f317a2e3192({ column: column, title: title, options: options, selectedValues: selectedValues, selectedOptions: selectedOptions, onFilterChange: onFilterChange, groupBy: groupBy, sortGroups: sortGroups }) {
    const groupedOptions = groupBy ? Object.entries(options.reduce((groups, option)=>{
        const groupKey = groupBy(option);
        groups[groupKey] = groups[groupKey] || [];
        groups[groupKey].push(option);
        return groups;
    }, {})).map(([groupLabel, groupOptions])=>({
            label: groupLabel,
            options: groupOptions
        })) : [
        {
            label: "",
            options: options
        }
    ];
    const listOptions = sortGroups ? groupedOptions.sort(sortGroups) : groupedOptions;
    const filteredListOptions = listOptions.map((group)=>({
            ...group,
            options: group.options.filter((option)=>!selectedValues.has(option.value))
        }));
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fRrIT.Command), {
        className: "p-1",
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm [&_[cmdk-input-wrapper]]:border-0 [&_[cmdk-input-wrapper]]:px-0",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fRrIT.CommandInput), {
                    placeholder: title,
                    className: "h-full border-0 pl-0 ring-0",
                    autoFocus: true
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fRrIT.CommandList), {
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fRrIT.CommandEmpty), {
                        children: "No results found."
                    }),
                    Array.from(selectedValues).map((value)=>{
                        const selectedItem = options.find((option)=>option.value === value);
                        if (!selectedItem) return null;
                        return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fRrIT.CommandItem), {
                            onSelect: ()=>{
                                selectedValues.delete(selectedItem.value);
                                const filterValues = Array.from(selectedValues);
                                const currentOptions = selectedOptions;
                                const newOptions = currentOptions.map((item)=>item.value === (column === null || column === void 0 ? void 0 : column.id) ? {
                                        ...item,
                                        filterValues: filterValues
                                    } : item);
                                onFilterChange(newOptions);
                            },
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                    className: (0, $Yha9m.cn)("mr-2 flex size-4 items-center justify-center rounded-sm border border-primary bg-primary text-primary-foreground"),
                                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jSiTu.CheckIcon), {
                                        className: "size-4",
                                        "aria-hidden": "true"
                                    })
                                }),
                                selectedItem.label
                            ]
                        }, selectedItem.value);
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fRrIT.CommandSeparator), {}),
                    filteredListOptions.map((listOption)=>{
                        const { label: label, options: options } = listOption;
                        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fRrIT.CommandGroup), {
                            className: "px-0",
                            heading: label && label.charAt(0).toUpperCase() + label.slice(1).toLowerCase(),
                            children: options.map((option)=>{
                                var _column$getFacetedUni;
                                const isSelected = selectedValues.has(option.value);
                                return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fRrIT.CommandItem), {
                                    onSelect: ()=>{
                                        if (isSelected) selectedValues.delete(option.value);
                                        else selectedValues.add(option.value);
                                        const filterValues = Array.from(selectedValues);
                                        const currentOptions = selectedOptions;
                                        const newOptions = currentOptions.map((item)=>item.value === (column === null || column === void 0 ? void 0 : column.id) ? {
                                                ...item,
                                                filterValues: filterValues
                                            } : item);
                                        onFilterChange(newOptions);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                            className: (0, $Yha9m.cn)("mr-2 flex size-4 items-center justify-center rounded-sm border border-primary", isSelected ? "bg-primary text-primary-foreground" : "opacity-50 [&_svg]:invisible"),
                                            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jSiTu.CheckIcon), {
                                                className: "size-4",
                                                "aria-hidden": "true"
                                            })
                                        }),
                                        option.icon && /*#__PURE__*/ (0, $61Ea1.jsx)(option.icon, {
                                            className: "mr-2 size-4 text-muted-foreground",
                                            "aria-hidden": "true"
                                        }),
                                        /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                            children: option.label
                                        }),
                                        option.withCount && (column === null || column === void 0 ? void 0 : (_column$getFacetedUni = column.getFacetedUniqueValues()) === null || _column$getFacetedUni === void 0 ? void 0 : _column$getFacetedUni.get(option.value)) && /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                            className: "ml-auto flex size-4 items-center justify-center font-mono text-xs",
                                            children: column === null || column === void 0 ? void 0 : column.getFacetedUniqueValues().get(option.value)
                                        })
                                    ]
                                }, option.value);
                            })
                        }, label);
                    }),
                    selectedValues.size > 0 && /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fRrIT.CommandSeparator), {}),
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fRrIT.CommandGroup), {
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fRrIT.CommandItem), {
                                    onSelect: ()=>{
                                        column === null || column === void 0 || column.setFilterValue(undefined);
                                        const currentOptions = selectedOptions;
                                        const newOptions = currentOptions.map((item)=>item.value === (column === null || column === void 0 ? void 0 : column.id) ? {
                                                ...item,
                                                filterValues: []
                                            } : item);
                                        onFilterChange(newOptions);
                                    },
                                    className: "justify-center text-center",
                                    children: "Clear filters"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

});

parcelRegister("lkZM6", function(module, exports) {

$parcel$export(module.exports, "formatDateISOString", function () { return $622efb410007724a$export$c824ddedb9627766; });
$parcel$export(module.exports, "formatTimeISOString", function () { return $622efb410007724a$export$6388d6e2935aaba3; });
const $622efb410007724a$export$c824ddedb9627766 = (date)=>{
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
};
const $622efb410007724a$export$6388d6e2935aaba3 = (date)=>{
    return new Date(date).toISOString();
};
const $622efb410007724a$export$f8976cf3c4813fa3 = (value, options)=>{
    if (value === undefined) return options === null || options === void 0 ? void 0 : options.default;
    if (typeof value === "number") return value;
    const parsed = parseFloat(value);
    return isNaN(parsed) ? options === null || options === void 0 ? void 0 : options.default : parsed;
};
const $622efb410007724a$export$daa9e1205fe3f904 = (value)=>{
    if (value === undefined) return undefined;
    if (value instanceof Date) return value;
    if (typeof value === "string") return value; // Keep string dates as-is
    const parsed = new Date(value);
    return isNaN(parsed.getTime()) ? undefined : parsed;
};

});


parcelRegister("65wBC", function(module, exports) {

$parcel$export(module.exports, "subYears", function () { return $fb70ed368c7fbf75$export$14867687ff6c92e2; });

var $6yjV5 = parcelRequire("6yjV5");
function $fb70ed368c7fbf75$export$14867687ff6c92e2(date, amount) {
    return (0, $6yjV5.addYears)(date, -amount);
}
var // Fallback for modularized imports:
$fb70ed368c7fbf75$export$2e2bcd8739ae039 = $fb70ed368c7fbf75$export$14867687ff6c92e2;

});
parcelRegister("6yjV5", function(module, exports) {

$parcel$export(module.exports, "addYears", function () { return $43ce644ad0aeae45$export$3d83eec43f4ea476; });

var $6lxwW = parcelRequire("6lxwW");
function $43ce644ad0aeae45$export$3d83eec43f4ea476(date, amount) {
    return (0, $6lxwW.addMonths)(date, amount * 12);
}
var // Fallback for modularized imports:
$43ce644ad0aeae45$export$2e2bcd8739ae039 = $43ce644ad0aeae45$export$3d83eec43f4ea476;

});



parcelRegister("kKJbF", function(module, exports) {

$parcel$export(module.exports, "orderColumnDefs", function () { return $d016161c2cad39d4$export$bc023b242e994da8; });
function $d016161c2cad39d4$export$bc023b242e994da8(columns, selectedColumnIds, groupedColumnIds, fixedColumnIds) {
    return columns.sort((a, b)=>{
        // Get priority for each column (lower number = higher priority)
        const getPriority = (columnId)=>{
            if (fixedColumnIds.includes(columnId)) return 1;
            if (groupedColumnIds.includes(columnId)) return 2;
            if (selectedColumnIds.includes(columnId)) return 3;
            return 4;
        };
        // Get index within its category array (-1 if not found)
        const getOrderIndex = (columnId)=>{
            if (fixedColumnIds.includes(columnId)) return fixedColumnIds.indexOf(columnId);
            if (groupedColumnIds.includes(columnId)) return groupedColumnIds.indexOf(columnId);
            if (selectedColumnIds.includes(columnId)) return selectedColumnIds.indexOf(columnId);
            return -1;
        };
        const priorityA = getPriority(a.accessorKey || a.id);
        const priorityB = getPriority(b.accessorKey || b.id);
        // If priorities are different, sort by priority
        if (priorityA !== priorityB) return priorityA - priorityB;
        // If same priority, sort by order within their category
        const orderA = getOrderIndex(a.accessorKey || a.id);
        const orderB = getOrderIndex(b.accessorKey || b.id);
        // Only compare order indices if both columns are in the same category array
        if (orderA !== -1 && orderB !== -1) return orderA - orderB;
        // Keep original order for columns not in any category array
        return 0;
    });
}

});

parcelRegister("8d9Bx", function(module, exports) {

$parcel$export(module.exports, "getColumns", function () { return $37d4b73b59bc8dc1$export$978e30a0fb8610d8; });

var $61Ea1 = parcelRequire("61Ea1");

var $kqlQp = parcelRequire("kqlQp");

var $1BTI2 = parcelRequire("1BTI2");

var $8kZ1o = parcelRequire("8kZ1o");

var $khCHn = parcelRequire("khCHn");
function $37d4b73b59bc8dc1$export$978e30a0fb8610d8(onHideColumn) {
    const generateColumnDef = (0, $khCHn.createGenerateColumnDef)({
        onHideColumn: onHideColumn
    });
    const wideSize = 200;
    return [
        generateColumnDef({
            key: "name",
            type: "text",
            title: "Name",
            size: wideSize,
            cell: (row)=>{
                const value = row.getValue("name");
                return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqlQp.Link), {
                        to: `/staff/${row.original.id}`,
                        children: value
                    })
                });
            }
        }),
        generateColumnDef({
            key: "staff",
            type: "staff",
            title: "Staff",
            size: wideSize
        }),
        generateColumnDef({
            key: "lastName",
            type: "text",
            title: "Last Name",
            size: wideSize
        }),
        generateColumnDef({
            key: "firstName",
            type: "text",
            title: "First Name",
            size: wideSize
        }),
        generateColumnDef({
            key: "email",
            type: "text",
            title: "Email",
            size: wideSize
        }),
        generateColumnDef({
            key: "role",
            type: "role",
            title: "Role",
            size: wideSize,
            permissions: ()=>(0, $8kZ1o.canViewRoles)((0, $1BTI2.default).user)
        }),
        generateColumnDef({
            key: "costCentre",
            type: "costCentre",
            title: "Cost Centre",
            size: wideSize,
            permissions: ()=>(0, $8kZ1o.canViewCostCentres)((0, $1BTI2.default).user)
        }),
        generateColumnDef({
            key: "permissionName",
            type: "text",
            title: "Permission Name",
            size: wideSize,
            permissions: ()=>(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "staff-permissions")
        }),
        generateColumnDef({
            key: "isArchived",
            type: "boolean",
            title: "Is Archived",
            size: wideSize
        }),
        generateColumnDef({
            key: "isActive",
            type: "boolean",
            title: "Is Active",
            size: wideSize
        }),
        generateColumnDef({
            key: "payRate",
            type: "number",
            title: "Pay Rate",
            size: wideSize,
            aggregationFn: "sum",
            permissions: ()=>(0, $8kZ1o.canViewStaffPayRate)((0, $1BTI2.default).user)
        }),
        generateColumnDef({
            key: "overtimeRate",
            type: "number",
            title: "Overtime Rate",
            size: wideSize,
            aggregationFn: "sum",
            permissions: ()=>(0, $8kZ1o.canViewStaffOvertimeRate)((0, $1BTI2.default).user)
        }),
        generateColumnDef({
            key: "costRate",
            type: "number",
            title: "Cost Rate",
            size: wideSize,
            aggregationFn: "sum",
            permissions: ()=>(0, $8kZ1o.canViewStaffCostRate)((0, $1BTI2.default).user)
        }),
        generateColumnDef({
            key: "chargeOutRate",
            type: "number",
            title: "Charge Out Rate",
            size: wideSize,
            aggregationFn: "sum",
            permissions: ()=>(0, $8kZ1o.canViewStaffChargeOutRate)((0, $1BTI2.default).user)
        }),
        generateColumnDef({
            key: "weeklyAvailability",
            type: "number",
            title: "Weekly Availability",
            size: wideSize,
            aggregationFn: "sum"
        }),
        generateColumnDef({
            key: "allocatedHours",
            type: "number",
            title: "Allocated Hours",
            size: wideSize,
            aggregationFn: "sum",
            permissions: ()=>(0, $8kZ1o.canViewStaffAllocations)((0, $1BTI2.default).user)
        }),
        generateColumnDef({
            key: "availableHours",
            type: "number",
            title: "Available Hours",
            size: wideSize,
            aggregationFn: "sum"
        }),
        generateColumnDef({
            key: "recordedHours",
            type: "number",
            title: "Recorded Hours",
            size: wideSize,
            aggregationFn: "sum"
        }),
        generateColumnDef({
            key: "billableHours",
            type: "number",
            title: "Billable Hours",
            size: wideSize,
            aggregationFn: "sum"
        }),
        generateColumnDef({
            key: "nonBillableHours",
            type: "number",
            title: "Non Billable Hours",
            size: wideSize,
            aggregationFn: "sum"
        }),
        generateColumnDef({
            key: "percentBillableHours",
            type: "percent",
            title: "Percent Billable Hours",
            size: wideSize,
            aggregationFn: "sum"
        }),
        generateColumnDef({
            key: "overtimeHours",
            type: "number",
            title: "Overtime Hours",
            size: wideSize,
            aggregationFn: "sum"
        }),
        generateColumnDef({
            key: "invoicedHours",
            type: "number",
            title: "Invoiced Hours",
            size: wideSize,
            aggregationFn: "sum"
        }),
        generateColumnDef({
            key: "pay",
            type: "currency",
            title: "Pay",
            size: wideSize,
            aggregationFn: "sum",
            permissions: ()=>(0, $8kZ1o.canViewStaffPayRate)((0, $1BTI2.default).user)
        }),
        generateColumnDef({
            key: "cost",
            type: "currency",
            title: "Cost",
            size: wideSize,
            aggregationFn: "sum",
            permissions: ()=>(0, $8kZ1o.canViewStaffCostRate)((0, $1BTI2.default).user)
        }),
        generateColumnDef({
            key: "chargeOut",
            type: "currency",
            title: "Charge Out",
            size: wideSize,
            aggregationFn: "sum",
            permissions: ()=>(0, $8kZ1o.canViewStaffChargeOutRate)((0, $1BTI2.default).user)
        }),
        generateColumnDef({
            key: "revenueEarned",
            type: "currency",
            title: "Revenue Earned",
            size: wideSize,
            aggregationFn: "sum",
            permissions: ()=>(0, $8kZ1o.canViewStaffChargeOutRate)((0, $1BTI2.default).user) && (0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user)
        }),
        generateColumnDef({
            key: "revenueEarnedPerHour",
            type: "currency",
            title: "Revenue Earned Per Hour",
            size: wideSize,
            aggregationFn: "sum",
            permissions: ()=>(0, $8kZ1o.canViewStaffChargeOutRate)((0, $1BTI2.default).user) && (0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user)
        }),
        generateColumnDef({
            key: "projects",
            type: "project",
            title: "Projects",
            size: wideSize
        })
    ];
}

});

parcelRegister("1k4cq", function(module, exports) {

$parcel$export(module.exports, "setOrganisationReport", function () { return $8a92b72e2dcb15f0$export$447d9eb2f4688ef2; });
$parcel$export(module.exports, "setReportData", function () { return $8a92b72e2dcb15f0$export$b4af916732271762; });
$parcel$export(module.exports, "setIsLoadingReportData", function () { return $8a92b72e2dcb15f0$export$73b176e19d58db01; });
$parcel$export(module.exports, "setColumns", function () { return $8a92b72e2dcb15f0$export$cfc099c0be5cff67; });
$parcel$export(module.exports, "setPendingChanges", function () { return $8a92b72e2dcb15f0$export$17dcaa9d506ee1de; });
$parcel$export(module.exports, "useReportData", function () { return $8a92b72e2dcb15f0$export$5937a5b9379177ff; });
$parcel$export(module.exports, "useOrganisationReport", function () { return $8a92b72e2dcb15f0$export$30415e21906d195c; });
$parcel$export(module.exports, "useIsLoadingReportData", function () { return $8a92b72e2dcb15f0$export$2ea3c65c90de2aa8; });
$parcel$export(module.exports, "usePendingChanges", function () { return $8a92b72e2dcb15f0$export$b69a3814d0f14d43; });

var $hxM7m = parcelRequire("hxM7m");

var $lJ1OS = parcelRequire("lJ1OS");

var $jbmdS = parcelRequire("jbmdS");
// Initial state
const $8a92b72e2dcb15f0$var$initialContext = {
    reportData: null,
    organisationReport: null,
    isLoadingReportData: false,
    columns: null,
    pendingChanges: false
};
const $8a92b72e2dcb15f0$export$618add13d2992046 = (0, $hxM7m.createStore)({
    context: $8a92b72e2dcb15f0$var$initialContext,
    on: {
        setOrganisationReport: {
            organisationReport: (_, event)=>event.report,
            pendingChanges: (_, event)=>{
                var _event$options$needsR, _event$options;
                return (_event$options$needsR = (_event$options = event.options) === null || _event$options === void 0 ? void 0 : _event$options.needsRefetch) !== null && _event$options$needsR !== void 0 ? _event$options$needsR : true;
            }
        },
        setReportData: {
            reportData: (_, event)=>event.data
        },
        setIsLoadingReportData: {
            isLoadingReportData: (_, event)=>event.isLoading
        },
        setColumns: {
            organisationReport: (context, event)=>context.organisationReport ? {
                    ...context.organisationReport,
                    columns: event.columns
                } : null,
            pendingChanges: (_, event)=>{
                var _event$options$needsR2, _event$options2;
                return (_event$options$needsR2 = (_event$options2 = event.options) === null || _event$options2 === void 0 ? void 0 : _event$options2.needsRefetch) !== null && _event$options$needsR2 !== void 0 ? _event$options$needsR2 : true;
            }
        },
        setPendingChanges: {
            pendingChanges: (_, event)=>event.pending
        }
    }
});
const $8a92b72e2dcb15f0$export$447d9eb2f4688ef2 = (report, options = {
    needsRefetch: true
})=>$8a92b72e2dcb15f0$export$618add13d2992046.send({
        type: "setOrganisationReport",
        report: report,
        options: options
    });
const $8a92b72e2dcb15f0$export$b4af916732271762 = (data)=>$8a92b72e2dcb15f0$export$618add13d2992046.send({
        type: "setReportData",
        data: data
    });
const $8a92b72e2dcb15f0$export$73b176e19d58db01 = (isLoading)=>$8a92b72e2dcb15f0$export$618add13d2992046.send({
        type: "setIsLoadingReportData",
        isLoading: isLoading
    });
const $8a92b72e2dcb15f0$export$cfc099c0be5cff67 = (columns, options = {
    needsRefetch: true
})=>$8a92b72e2dcb15f0$export$618add13d2992046.send({
        type: "setColumns",
        columns: columns,
        options: options
    });
const $8a92b72e2dcb15f0$export$17dcaa9d506ee1de = (pending)=>$8a92b72e2dcb15f0$export$618add13d2992046.send({
        type: "setPendingChanges",
        pending: pending
    });
const $8a92b72e2dcb15f0$export$5937a5b9379177ff = ()=>(0, $lJ1OS.useSelector)($8a92b72e2dcb15f0$export$618add13d2992046, (state)=>state.context.reportData);
const $8a92b72e2dcb15f0$export$30415e21906d195c = ()=>(0, $lJ1OS.useSelector)($8a92b72e2dcb15f0$export$618add13d2992046, (state)=>state.context.organisationReport);
const $8a92b72e2dcb15f0$export$2ea3c65c90de2aa8 = ()=>(0, $lJ1OS.useSelector)($8a92b72e2dcb15f0$export$618add13d2992046, (state)=>state.context.isLoadingReportData);
const $8a92b72e2dcb15f0$export$c97dded465ef56fb = ()=>{
    const report = $8a92b72e2dcb15f0$export$30415e21906d195c();
    return (0, $jbmdS.useMemo)(()=>{
        var _report$columns;
        return (_report$columns = report === null || report === void 0 ? void 0 : report.columns) !== null && _report$columns !== void 0 ? _report$columns : null;
    }, [
        report
    ]);
};
const $8a92b72e2dcb15f0$export$b69a3814d0f14d43 = ()=>(0, $lJ1OS.useSelector)($8a92b72e2dcb15f0$export$618add13d2992046, (state)=>state.context.pendingChanges);
const $8a92b72e2dcb15f0$export$876946ab947f18cc = ()=>$8a92b72e2dcb15f0$export$618add13d2992046.getSnapshot().context;

});

parcelRegister("3pwHC", function(module, exports) {

$parcel$export(module.exports, "StaffReportActions", function () { return $cd8b95115f374ee5$export$6dec3d74f3603680; });

var $61Ea1 = parcelRequire("61Ea1");

var $azaaH = parcelRequire("azaaH");

var $1BTI2 = parcelRequire("1BTI2");

var $3h7sC = parcelRequire("3h7sC");

var $fJ4T4 = parcelRequire("fJ4T4");

var $38AIP = parcelRequire("38AIP");

var $dHs32 = parcelRequire("dHs32");

var $bAwxh = parcelRequire("bAwxh");

var $26sX2 = parcelRequire("26sX2");

var $6UBLf = parcelRequire("6UBLf");

var $gN0TC = parcelRequire("gN0TC");

var $cV8g5 = parcelRequire("cV8g5");

var $6mjwz = parcelRequire("6mjwz");

var $jbmdS = parcelRequire("jbmdS");

var $1k4cq = parcelRequire("1k4cq");
function $cd8b95115f374ee5$export$6dec3d74f3603680({ table: table, exportColumns: exportColumns = [] }) {
    var _SessionStore$organis;
    const navigate = (0, $6UBLf.useNavigate)();
    const [dialogContent, setDialogContent] = (0, $jbmdS.useState)(null);
    const [nameReport, setNameReport] = (0, $jbmdS.useState)(null);
    const organisationReport = (0, $1k4cq.useOrganisationReport)();
    const checkDisableButton = !(organisationReport !== null && organisationReport !== void 0 && organisationReport.id) && !((_SessionStore$organis = (0, $1BTI2.default).organisation) !== null && _SessionStore$organis !== void 0 && _SessionStore$organis.defaultStaffReportId);
    const showSaveAsToast = (0, $bAwxh.default)({
        saveId: "staff-report-save-as",
        onSave: async ()=>{
            const newId = $gN0TC();
            const result = await (0, $3h7sC.trpc).staffReport.saveReport.mutate({
                id: newId,
                name: nameReport,
                filters: organisationReport.filters,
                type: "staffMember",
                columns: organisationReport.columns,
                options: organisationReport.options
            });
            (0, $38AIP.addCacheItem)("organisationReports", {
                id: newId,
                name: nameReport,
                type: "staffMember"
            });
            setNameReport(null);
            setDialogContent(null);
            (0, $1k4cq.setOrganisationReport)({
                ...organisationReport,
                ...result
            });
            navigate({
                search: {
                    report: newId
                }
            });
        },
        loadingMessage: "Saving new report...",
        successMessage: "New report saved successfully",
        errorMessage: "Failed to save new report"
    });
    // Save existing report
    const showSaveToast = (0, $bAwxh.default)({
        saveId: "staff-report-save",
        onSave: async ()=>{
            const result = await (0, $3h7sC.trpc).staffReport.saveReport.mutate({
                id: organisationReport.id,
                organisationId: organisationReport.organisationId,
                filters: organisationReport.filters,
                columns: organisationReport.columns,
                options: organisationReport.options
            });
            setDialogContent(null);
            (0, $1k4cq.setOrganisationReport)({
                ...organisationReport,
                ...result
            });
            return result;
        },
        loadingMessage: "Saving report...",
        successMessage: "Report saved successfully",
        errorMessage: "Failed to save report"
    });
    // Rename operation
    const showRenameToast = (0, $bAwxh.default)({
        saveId: "staff-report-rename",
        onSave: async ()=>{
            if (!nameReport || nameReport === organisationReport.name) return;
            const result = await (0, $3h7sC.trpc).staffReport.saveReport.mutate({
                id: organisationReport.id,
                organisationId: organisationReport.organisationId,
                name: nameReport
            });
            (0, $38AIP.updateCacheItem)("organisationReports", organisationReport.id, {
                name: nameReport,
                type: "staffMember"
            });
            (0, $26sX2.setPageTitle)(nameReport);
            setNameReport(null);
            setDialogContent(null);
            (0, $1k4cq.setOrganisationReport)({
                ...organisationReport,
                ...result
            });
            return result;
        },
        loadingMessage: "Renaming report...",
        successMessage: "Report renamed successfully",
        errorMessage: "Failed to rename report"
    });
    // Delete operation
    const showDeleteToast = (0, $bAwxh.default)({
        saveId: "staff-report-delete",
        onSave: async ()=>{
            const result = await (0, $3h7sC.trpc).staffReport.saveReport.mutate({
                id: organisationReport.id,
                organisationId: organisationReport.organisationId,
                deletedAt: new Date()
            });
            (0, $38AIP.deleteCacheItem)("organisationReports", organisationReport.id);
            setDialogContent(null);
            navigate({
                search: {}
            });
            return result;
        },
        loadingMessage: "Deleting report...",
        successMessage: "Report deleted successfully",
        errorMessage: "Failed to delete report"
    });
    // Set Default operation
    const showSaveDefaultToast = (0, $bAwxh.default)({
        saveId: "staff-report-set-default",
        onSave: async ()=>{
            return await (0, $3h7sC.trpc).staffReport.setDefaultReport.mutate({
                id: organisationReport.id
            });
        },
        loadingMessage: "Setting as default...",
        successMessage: "Set as default report",
        errorMessage: "Failed to set as default"
    });
    const handleOpenDialog = (content)=>{
        setNameReport(null);
        setDialogContent(content);
    };
    const csvFormatter = (data, column)=>{
        var _column$columnDef$met;
        const value = data.getValue(column === null || column === void 0 ? void 0 : column.id);
        switch((_column$columnDef$met = column.columnDef.meta) === null || _column$columnDef$met === void 0 ? void 0 : _column$columnDef$met.type){
            case "progress":
            case "progressBar":
                const { numerator: numerator, denominator: denominator } = value;
                if (numerator || denominator) return `${(0, $azaaH.default).progress(numerator || 0)} / ${(0, $azaaH.default).progress(denominator || 0)}`;
                else return "";
            case "date":
                return data ? (0, $fJ4T4.FormatDate)(new Date(value), {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit"
                }) : "";
            default:
                return value;
        }
    };
    const handleExportToCSV = ()=>{
        const results = [];
        const headers = table.getAllColumns().filter((item)=>{
            var _organisationReport$c;
            return organisationReport === null || organisationReport === void 0 ? void 0 : (_organisationReport$c = organisationReport.columns) === null || _organisationReport$c === void 0 ? void 0 : _organisationReport$c.includes(item.id);
        });
        const firstRow = [];
        headers.forEach((header)=>{
            var _header$columnDef$met;
            return firstRow.push((_header$columnDef$met = header.columnDef.meta) === null || _header$columnDef$met === void 0 ? void 0 : _header$columnDef$met.title);
        });
        results.push(firstRow);
        // Add data
        table.getRowModel().rows.forEach((item)=>{
            const row = [];
            headers.forEach((header)=>{
                row.push(csvFormatter(item, header));
            });
            results.push(row);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($cV8g5)))((0, (/*@__PURE__*/$parcel$interopDefault($6mjwz))).unparse(results), `staff.csv`, "text/csv");
    };
    const handleSetDefault = async ()=>{
        showSaveDefaultToast();
    };
    const handleDialogSubmit = async (dialogContent)=>{
        switch(dialogContent){
            case "Save as":
                showSaveAsToast();
                break;
            case "Save":
                showSaveToast();
                break;
            case "Rename Report":
                showRenameToast();
                break;
            case "Delete Report":
                showDeleteToast();
                break;
            default:
                break;
        }
        setDialogContent(null);
    };
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $dHs32.DataTableActions), {
            handleExportToCSV: handleExportToCSV,
            handleDialogSubmit: handleDialogSubmit,
            handleOpenDialog: handleOpenDialog,
            handleSetDefault: handleSetDefault,
            dialogContent: dialogContent,
            setDialogContent: setDialogContent,
            setNameReport: setNameReport,
            nameReport: nameReport,
            organisationReport: organisationReport,
            checkDisableButton: checkDisableButton,
            exportColumns: exportColumns
        })
    });
}

});
parcelRegister("dHs32", function(module, exports) {

$parcel$export(module.exports, "DataTableActions", function () { return $b9b283607f37f7b4$export$8c784915b79e165a; });

var $61Ea1 = parcelRequire("61Ea1");

var $fTGwv = parcelRequire("fTGwv");

var $8tafh = parcelRequire("8tafh");

var $cKXEy = parcelRequire("cKXEy");

var $2YJBX = parcelRequire("2YJBX");
function $b9b283607f37f7b4$export$8c784915b79e165a({ handleExportToCSV: handleExportToCSV, handleDialogSubmit: handleDialogSubmit, handleOpenDialog: handleOpenDialog, handleSetDefault: handleSetDefault, dialogContent: dialogContent, setDialogContent: setDialogContent, setNameReport: setNameReport, nameReport: nameReport, organisationReport: organisationReport, checkDisableButton: checkDisableButton, exportColumns: exportColumns }) {
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $8tafh.DropdownMenu), {
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8tafh.DropdownMenuTrigger), {
                        asChild: true,
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fTGwv.Button), {
                            "aria-label": "Toggle columns",
                            variant: "outline",
                            size: "sm",
                            children: "Actions"
                        })
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $8tafh.DropdownMenuContent), {
                        align: "end",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8tafh.DropdownMenuSub), {
                                children: exportColumns.length > 0 ? /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8tafh.DropdownMenuSubTrigger), {
                                            children: "Export"
                                        }),
                                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8tafh.DropdownMenuSubContent), {
                                            sideOffset: 4,
                                            children: exportColumns.map(({ value: value, label: label })=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $8tafh.DropdownMenuItem), {
                                                    onClick: ()=>handleExportToCSV(value),
                                                    className: "cursor-pointer",
                                                    children: label
                                                }, value))
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8tafh.DropdownMenuItem), {
                                    className: "cursor-pointer",
                                    onClick: ()=>handleExportToCSV(),
                                    children: "Export"
                                })
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8tafh.DropdownMenuItem), {
                                className: "cursor-pointer",
                                onClick: ()=>window.print(),
                                children: "Print"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8tafh.DropdownMenuSeparator), {}),
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8tafh.DropdownMenuItem), {
                                className: "cursor-pointer",
                                onClick: ()=>handleDialogSubmit("Save"),
                                children: "Update report"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8tafh.DropdownMenuItem), {
                                className: "cursor-pointer",
                                onClick: ()=>handleOpenDialog("Save as"),
                                children: "Save as"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8tafh.DropdownMenuItem), {
                                disabled: !(organisationReport !== null && organisationReport !== void 0 && organisationReport.id),
                                className: "cursor-pointer",
                                onClick: handleSetDefault,
                                children: "Set as default"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8tafh.DropdownMenuItem), {
                                disabled: checkDisableButton,
                                className: "cursor-pointer",
                                onClick: ()=>handleOpenDialog("Rename Report"),
                                children: "Rename"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8tafh.DropdownMenuItem), {
                                disabled: checkDisableButton,
                                className: "cursor-pointer",
                                onClick: ()=>handleOpenDialog("Delete Report"),
                                children: "Delete"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $cKXEy.Dialog), {
                open: !!dialogContent,
                onOpenChange: ()=>setDialogContent(null),
                children: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $cKXEy.DialogContent), {
                    className: "sm:max-w-[425px]",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $cKXEy.DialogHeader), {
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $cKXEy.DialogTitle), {
                                    children: dialogContent
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $cKXEy.DialogDescription), {
                                    children: [
                                        dialogContent === "Update report" && "Make changes to your report here. Click save when you are done.",
                                        dialogContent === "Save as" && "Please enter new name for this report.",
                                        dialogContent === "Set as default" && "Set this report as the default for future use.",
                                        dialogContent === "Rename Report" && "Please enter new name for this report.",
                                        dialogContent === "Delete Report" && "Are you sure you want to delete this report?"
                                    ]
                                })
                            ]
                        }),
                        dialogContent && /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            children: (dialogContent === "Rename Report" || dialogContent === "Save as") && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $2YJBX.Input), {
                                required: true,
                                type: "text",
                                placeholder: "Enter new name",
                                className: "w-full",
                                autoFocus: true,
                                defaultValue: dialogContent === "Save as" ? "" : organisationReport.name,
                                value: nameReport,
                                onChange: (e)=>setNameReport(e.target.value)
                            })
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $cKXEy.DialogFooter), {
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $cKXEy.DialogClose), {
                                    asChild: true,
                                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fTGwv.Button), {
                                        type: "button",
                                        variant: "secondary",
                                        children: "Close"
                                    })
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fTGwv.Button), {
                                    disabled: dialogContent !== "Delete Report" && !nameReport,
                                    onClick: ()=>handleDialogSubmit(dialogContent),
                                    children: dialogContent === "Delete Report" ? "Delete" : "Save changes"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}

});




parcelRegister("495xp", function(module, exports) {

$parcel$export(module.exports, "StaffReportColumns", function () { return $304c4c6801003a4b$export$b55d6bbeaf19c082; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("eat5C");
parcelRequire("jbmdS");


var $1BTI2 = parcelRequire("1BTI2");

var $8kZ1o = parcelRequire("8kZ1o");

var $kqlQp = parcelRequire("kqlQp");

var $5JL5P = parcelRequire("5JL5P");
const $304c4c6801003a4b$export$b55d6bbeaf19c082 = (report)=>({
        name: {
            id: "name",
            label: "Name",
            type: "text",
            width: 25,
            value: (row)=>row.fullName,
            component: ({ value: value, stores: stores })=>{
                const { row: row } = stores;
                return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqlQp.Link), {
                        to: `/staff/${row.rowObject.staffId || row.rowObject.id}`,
                        children: value
                    })
                });
            }
        },
        staff: {
            id: "staff",
            label: "Staff",
            type: "staffMember",
            width: 25,
            visible: false,
            value: (row)=>row.staff,
            format: (staff)=>staff,
            component: ({ value: value, stores: stores })=>{
                const { row: row } = stores;
                return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqlQp.Link), {
                        to: `/staff/${row.rowObject.staffId || row.rowObject.id}`,
                        children: value
                    })
                });
            }
        },
        lastName: {
            id: "lastName",
            label: "Last name",
            type: "text",
            width: 15,
            value: (row)=>row.lastName,
            component: ({ value: value, stores: stores })=>{
                const { row: row } = stores;
                return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqlQp.Link), {
                        to: `/staff/${row.rowObject.staffId || row.rowObject.id}`,
                        children: value
                    })
                });
            }
        },
        firstName: {
            id: "firstName",
            label: "First name",
            type: "text",
            width: 15,
            value: (row)=>row.firstName,
            component: ({ value: value, stores: stores })=>{
                const { row: row } = stores;
                return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqlQp.Link), {
                        to: `/staff/${row.rowObject.staffId || row.rowObject.id}`,
                        children: value
                    })
                });
            }
        },
        email: {
            id: "email",
            label: "Email",
            type: "text",
            width: 25,
            value: (row)=>row.email,
            component: ({ value: value, stores: stores })=>{
                const { row: row } = stores;
                return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqlQp.Link), {
                        to: `/staff/${row.rowObject.staffId || row.rowObject.id}`,
                        children: value
                    })
                });
            }
        },
        role: {
            id: "role",
            label: "Role",
            type: "role",
            width: 15,
            value: (row)=>row.role,
            format: (role)=>role,
            permissions: (row)=>(0, $8kZ1o.canViewRoles)((0, $1BTI2.default).user)
        },
        costCentre: {
            id: "costCentre",
            label: "Cost Centre",
            type: "costCentre",
            width: 15,
            value: (row)=>row.costCentre,
            format: (costCentre)=>costCentre,
            permissions: (row)=>(0, $8kZ1o.canViewCostCentres)((0, $1BTI2.default).user)
        },
        permissionName: {
            id: "permissionName",
            label: "Permission Name",
            type: "text",
            width: 20,
            value: (row)=>{
                return (0, $5JL5P.default).permissionsById[row.permissionsId].name;
            },
            permissions: (row)=>(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, `staff-permissions`)
        },
        hasLogin: {
            id: "hasLogin",
            label: "Has Login",
            type: "boolean",
            width: 15,
            value: (row)=>row.hasLogin
        },
        isArchived: {
            id: "isArchived",
            label: "Is Archived",
            type: "boolean",
            width: 15,
            value: (row)=>row.isArchived
        },
        isActive: {
            id: "isActive",
            label: "Is Active",
            type: "boolean",
            width: 15,
            value: (row)=>!row.isArchived
        },
        payRate: {
            id: "payRate",
            label: "Pay Rate",
            type: "number",
            width: 15,
            value: (row)=>row.payRate,
            permissions: (row)=>(0, $8kZ1o.canViewStaffPayRate)((0, $1BTI2.default).user)
        },
        overtimeRate: {
            id: "overtimeRate",
            label: "Overtime Rate",
            type: "number",
            width: 15,
            value: (row)=>row.overtimeRate,
            permissions: (row)=>(0, $8kZ1o.canViewStaffOvertimeRate)((0, $1BTI2.default).user)
        },
        costRate: {
            id: "costRate",
            label: "Cost Rate",
            type: "number",
            width: 15,
            value: (row)=>row.costRate,
            permissions: (row)=>(0, $8kZ1o.canViewStaffCostRate)((0, $1BTI2.default).user)
        },
        chargeOutRate: {
            id: "chargeOutRate",
            label: "Charge Out Rate",
            type: "number",
            width: 15,
            value: (row)=>row.chargeOutRate,
            permissions: (row)=>(0, $8kZ1o.canViewStaffChargeOutRate)((0, $1BTI2.default).user)
        },
        weeklyAvailability: {
            id: "weeklyAvailability",
            label: "Weekly Availability",
            type: "number",
            width: 15,
            value: (row)=>row.availability / 60
        },
        allocatedHours: {
            id: "allocatedHours",
            label: "Allocated hours",
            type: "number",
            width: 15,
            value: (row)=>row.allocatedHours,
            permissions: (row)=>(0, $8kZ1o.canViewStaffAllocations)((0, $1BTI2.default).user)
        },
        availableHours: {
            id: "availableHours",
            label: "Available hours",
            type: "number",
            width: 15,
            value: (row)=>row.availableHours
        },
        remainingHours: {
            id: "remainingHours",
            label: "Remaining hours",
            type: "number",
            width: 15,
            value: (row)=>row.remainingHours
        },
        allocatedChargeOut: {
            id: "allocatedChargeOut",
            label: "Allocated charge out",
            type: "currency",
            width: 15,
            value: (row)=>row.allocatedChargeOut,
            permissions: (row)=>(0, $8kZ1o.canViewStaffAllocations)((0, $1BTI2.default).user)
        },
        availableChargeOut: {
            id: "availableChargeOut",
            label: "Available charge out",
            type: "currency",
            width: 15,
            value: (row)=>row.availableChargeOut
        },
        remainingChargeOut: {
            id: "remainingChargeOut",
            label: "Remaining charge out",
            type: "currency",
            width: 15,
            value: (row)=>row.remainingChargeOut
        },
        recordedHours: {
            id: "recordedHours",
            label: "Recorded hours",
            type: "number",
            width: 15,
            value: (row)=>row.recordedHours
        },
        billableHours: {
            id: "billableHours",
            label: "Billable Hours",
            type: "number",
            width: 15,
            value: (row)=>row.billableHours
        },
        nonBillableHours: {
            id: "nonBillableHours",
            label: "Non Billable Hours",
            type: "number",
            width: 15,
            value: (row)=>row.nonBillableHours
        },
        percentBillableHours: {
            id: "percentBillableHours",
            label: "Percent Billable Hours",
            type: "percent",
            width: 15,
            value: (row)=>row.percentBillableHours
        },
        overtimeHours: {
            id: "overtimeHours",
            label: "Overtime hours",
            type: "number",
            width: 15,
            value: (row)=>row.overtimeHours
        },
        invoicedHours: {
            id: "invoicedHours",
            label: "Invoiced Hours",
            type: "number",
            width: 15,
            value: (row)=>row.invoicedHours
        },
        pay: {
            id: "pay",
            label: "Pay",
            type: "currency",
            width: 15,
            value: (row)=>row.pay,
            permissions: (row)=>(0, $8kZ1o.canViewStaffPayRate)((0, $1BTI2.default).user)
        },
        cost: {
            id: "cost",
            label: "Cost",
            type: "currency",
            width: 15,
            value: (row)=>row.cost,
            permissions: (row)=>(0, $8kZ1o.canViewStaffCostRate)((0, $1BTI2.default).user)
        },
        chargeOut: {
            id: "chargeOut",
            label: "Charge Out",
            type: "currency",
            width: 15,
            value: (row)=>row.chargeOut,
            permissions: (row)=>(0, $8kZ1o.canViewStaffChargeOutRate)((0, $1BTI2.default).user)
        },
        revenueEarned: {
            id: "revenueEarned",
            label: "Revenue Earned",
            type: "currency",
            width: 15,
            value: (row)=>row.revenueEarned,
            permissions: (row)=>(0, $8kZ1o.canViewStaffChargeOutRate)((0, $1BTI2.default).user) && (0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user)
        },
        revenueEarnedPerHour: {
            id: "revenueEarnedPerHour",
            label: "Revenue Earned Per Hour",
            type: "currency",
            width: 15,
            value: (row)=>row.revenueEarnedPerHour,
            permissions: (row)=>(0, $8kZ1o.canViewStaffChargeOutRate)((0, $1BTI2.default).user) && (0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user)
        },
        projects: {
            id: "projects",
            label: "Projects",
            type: "project",
            width: 15,
            value: (row)=>row.projects,
            format: (projects)=>projects
        }
    });

});


parcelRegister("9xWjB", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $6f346e4c742a4a07$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");

var $d2DzM = parcelRequire("d2DzM");

var $bPwCJ = parcelRequire("bPwCJ");

var $kuPRw = parcelRequire("kuPRw");

var $4iw5i = parcelRequire("4iw5i");

var $5PXcS = parcelRequire("5PXcS");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $7qobO = parcelRequire("7qobO");

var $kqntg = parcelRequire("kqntg");
const $6f346e4c742a4a07$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_private/staff-roles/")({
    beforeLoad: ({ params: params })=>{
        if (!(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "staffRoleList", params)) throw new Error("Permission Denied");
    },
    errorComponent: ({ error: error, reset: reset })=>{
        if (error.message === "Permission Denied") return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7qobO.default), {});
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    },
    pendingComponent: (0, $4iw5i.default),
    loader: async ()=>await $6f346e4c742a4a07$var$loader(),
    component: $6f346e4c742a4a07$var$Wrapper
});
const $6f346e4c742a4a07$var$loader = async ()=>{};
function $6f346e4c742a4a07$var$Wrapper() {
    if ((0, $8kZ1o.migratedToV2)()) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqntg.CenterPadPageBody), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bPwCJ.default), {})
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $d2DzM.default), {}),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kuPRw.default), {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bPwCJ.default), {})
            })
        ]
    });
}

});
parcelRegister("d2DzM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97ea293b176da877$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $36Jjh = parcelRequire("36Jjh");
parcelRequire("htkeB");

var $bxXv3 = parcelRequire("bxXv3");

var $52dEm = parcelRequire("52dEm");

var $jLAVl = parcelRequire("jLAVl");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $6UBLf = parcelRequire("6UBLf");
var $97ea293b176da877$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ extraContent: extraContent })=>{
    const navigate = (0, $6UBLf.useNavigate)();
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $36Jjh.default), {
        heading: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: "Staff Roles"
            })
        }),
        extraContent: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            style: {
                marginTop: "1em"
            },
            children: [
                (0, $8kZ1o.canCreateRoles)((0, $1BTI2.default).user) ? /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                    className: "project-list__add-new-project-button page-header__button--primary plus-btn",
                    onClick: ()=>{
                        const role = (0, $bxXv3.default).createRole();
                        navigate({
                            to: "/staff-roles/" + role.id
                        });
                    },
                    children: "+ New Staff Role"
                }, 0) : null,
                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                    style: {
                        marginLeft: "1.5em"
                    },
                    label: "Show Archived Roles",
                    onChange: (0, $jLAVl.default).toggleShowArchived
                })
            ]
        })
    });
});

});
parcelRegister("jLAVl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e63f0c6f0ac81e62$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");
var $e63f0c6f0ac81e62$var$_dec, $e63f0c6f0ac81e62$var$_class, $e63f0c6f0ac81e62$var$_descriptor;
function $e63f0c6f0ac81e62$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $e63f0c6f0ac81e62$var$_defineProperty(e, r, t) {
    return (r = $e63f0c6f0ac81e62$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $e63f0c6f0ac81e62$var$_toPropertyKey(t) {
    var i = $e63f0c6f0ac81e62$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $e63f0c6f0ac81e62$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $e63f0c6f0ac81e62$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $e63f0c6f0ac81e62$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $e63f0c6f0ac81e62$var$StaffRoleListStore = ($e63f0c6f0ac81e62$var$_dec = (0, $4JcCM.action).bound, $e63f0c6f0ac81e62$var$_class = class StaffRoleListStore {
    constructor(){
        $e63f0c6f0ac81e62$var$_initializerDefineProperty(this, "showArchived", $e63f0c6f0ac81e62$var$_descriptor, this);
        (0, $4JcCM.makeObservable)(this);
    }
    toggleShowArchived() {
        this.showArchived = !this.showArchived;
    }
}, $e63f0c6f0ac81e62$var$_descriptor = $e63f0c6f0ac81e62$var$_applyDecoratedDescriptor($e63f0c6f0ac81e62$var$_class.prototype, "showArchived", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $e63f0c6f0ac81e62$var$_applyDecoratedDescriptor($e63f0c6f0ac81e62$var$_class.prototype, "toggleShowArchived", [
    $e63f0c6f0ac81e62$var$_dec
], Object.getOwnPropertyDescriptor($e63f0c6f0ac81e62$var$_class.prototype, "toggleShowArchived"), $e63f0c6f0ac81e62$var$_class.prototype), $e63f0c6f0ac81e62$var$_class);
var $e63f0c6f0ac81e62$export$2e2bcd8739ae039 = new $e63f0c6f0ac81e62$var$StaffRoleListStore();

});


parcelRegister("bPwCJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89cdc37e3edbbf3d$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $goLmS = parcelRequire("goLmS");

var $bxXv3 = parcelRequire("bxXv3");

var $jLAVl = parcelRequire("jLAVl");

var $kqlQp = parcelRequire("kqlQp");
const $89cdc37e3edbbf3d$var$columns = [
    {
        id: "name",
        label: "Name",
        type: "text",
        width: 25,
        value: (row)=>{
            return row.name;
        },
        component: ({ value: value, stores: stores })=>{
            const { row: row } = stores;
            return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqlQp.Link), {
                    to: `/staff-roles/${row.rowObject.id}`,
                    children: value
                })
            });
        }
    }
];
var $89cdc37e3edbbf3d$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(()=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
            columns: $89cdc37e3edbbf3d$var$columns,
            rows: (0, $bxXv3.default).roles.filter((r)=>((0, $jLAVl.default).showArchived || !r.isArchived) && !r.deletedAt)
        }, "role-table")
    });
});

});


parcelRegister("72qTN", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $51fd95e44f9db9f9$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");

var $bkuoP = parcelRequire("bkuoP");

var $kS4Z4 = parcelRequire("kS4Z4");

var $kuPRw = parcelRequire("kuPRw");

var $1BTI2 = parcelRequire("1BTI2");

var $8kZ1o = parcelRequire("8kZ1o");

var $7qobO = parcelRequire("7qobO");

var $4iw5i = parcelRequire("4iw5i");

var $5PXcS = parcelRequire("5PXcS");

var $3h7sC = parcelRequire("3h7sC");

var $7hoGv = parcelRequire("7hoGv");

var $60uKl = parcelRequire("60uKl");

var $9Gpjo = parcelRequire("9Gpjo");

var $cnmvx = parcelRequire("cnmvx");

var $4hBm1 = parcelRequire("4hBm1");

var $26sX2 = parcelRequire("26sX2");

var $38AIP = parcelRequire("38AIP");

var $6Q5sp = parcelRequire("6Q5sp");

var $kqntg = parcelRequire("kqntg");

var $47i9t = parcelRequire("47i9t");
const $51fd95e44f9db9f9$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_private/projects/")({
    beforeLoad: async ({ params: params, search: search })=>{
        if (!(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "projectList", params)) throw new Error("Permission Denied");
        const report = (0, $38AIP.getCacheItemById)("organisationReports", search.report);
        (0, $26sX2.setLayoutDefaults)({
            pageTitle: (report === null || report === void 0 ? void 0 : report.name) || "Project Report",
            subMenu: "projects"
        });
    },
    errorComponent: ({ error: error, reset: reset })=>{
        if (error.message === "Permission Denied") return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7qobO.default), {});
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    },
    loader: async ({ location: location })=>await $51fd95e44f9db9f9$var$loader(location.search),
    loaderDeps: ({ search: { report: report } })=>({
            report: report
        }),
    pendingComponent: (0, $4iw5i.default),
    component: $51fd95e44f9db9f9$var$Wrapper
});
const $51fd95e44f9db9f9$var$loader = async ({ report: report })=>{
    var _SessionStore$organis;
    const reportId = report || ((_SessionStore$organis = (0, $1BTI2.default).organisation) === null || _SessionStore$organis === void 0 ? void 0 : _SessionStore$organis.defaultProjectReportId);
    if ((0, $8kZ1o.migratedToV2)()) {
        var _organisationReport$o;
        const res = reportId ? await (0, $3h7sC.trpc).projectReport.getOrganisationReport.query({
            reportId: reportId
        }) : null;
        const organisationReport = res || (0, $1BTI2.default).organisation.defaultProjectReport;
        let dateRange = [
            null,
            null
        ];
        if ((_organisationReport$o = organisationReport.options) !== null && _organisationReport$o !== void 0 && _organisationReport$o.dateRange) {
            var _dateStringLookup$org, _organisationReport$o2, _organisationReport$o3, _organisationReport$o4;
            dateRange = ((_dateStringLookup$org = (0, $cnmvx.dateStringLookup)[(_organisationReport$o2 = organisationReport.options) === null || _organisationReport$o2 === void 0 ? void 0 : _organisationReport$o2.dateRange]) === null || _dateStringLookup$org === void 0 ? void 0 : _dateStringLookup$org.call((0, $cnmvx.dateStringLookup), (_organisationReport$o3 = organisationReport.options) === null || _organisationReport$o3 === void 0 ? void 0 : _organisationReport$o3.fortnightType)) || ((_organisationReport$o4 = organisationReport.options) === null || _organisationReport$o4 === void 0 ? void 0 : _organisationReport$o4.dateRange);
        }
        const { columns: columns, filters: filters, groupBy: groupBy, sortBy: sortBy, options: options, name: name } = organisationReport;
        (0, $60uKl.setOrganisationReport)({
            columns: columns,
            filters: filters,
            groupBy: groupBy,
            organisationId: (0, $1BTI2.default).organisationId,
            sortBy: sortBy,
            dateRange: dateRange,
            invoiceDateType: (0, $1BTI2.default).settings.reportInvoiceDateType,
            id: reportId,
            options: options,
            name: name
        }, {
            needsRefetch: false
        });
        const cacheData = await (0, $6Q5sp.queryClient).fetchQuery({
            queryKey: [
                "projectReportCache",
                reportId
            ],
            queryFn: ()=>(0, $3h7sC.trpc).projectReport.getReportsData.query({
                    columns: organisationReport === null || organisationReport === void 0 ? void 0 : organisationReport.columns.filter((c)=>{
                        var _ProjectReportColumns;
                        return !((_ProjectReportColumns = (0, $9Gpjo.ProjectReportColumns)(reportId)[c]) !== null && _ProjectReportColumns !== void 0 && _ProjectReportColumns.permissions) || (0, $9Gpjo.ProjectReportColumns)(reportId)[c].permissions();
                    }),
                    filters: organisationReport === null || organisationReport === void 0 ? void 0 : organisationReport.filters.map((f)=>{
                        var _ProjectReportColumns2, _ProjectReportColumns3;
                        if (((_ProjectReportColumns2 = (0, $9Gpjo.ProjectReportColumns)(reportId)[f.column]) === null || _ProjectReportColumns2 === void 0 ? void 0 : _ProjectReportColumns2.type) === "date") {
                            var _dateStringLookup$f$v;
                            let value = ((_dateStringLookup$f$v = (0, $cnmvx.dateStringLookup)[f.value]) === null || _dateStringLookup$f$v === void 0 ? void 0 : _dateStringLookup$f$v.call((0, $cnmvx.dateStringLookup))) || f.value;
                            if (Array.isArray(value)) value = value.map((d)=>d ? (0, $4hBm1.format)(d, "yyyy-MM-dd") : null);
                            else value = value ? (0, $4hBm1.format)(value, "yyyy-MM-dd") : null;
                            return {
                                ...f,
                                value: value
                            };
                        } else if (((_ProjectReportColumns3 = (0, $9Gpjo.ProjectReportColumns)(reportId)[f.column]) === null || _ProjectReportColumns3 === void 0 ? void 0 : _ProjectReportColumns3.type) === "time") {
                            let value = f.value;
                            if (Array.isArray(value)) value = value.map((d)=>{
                                d = new Date(d);
                                return d && d.getTime() ? (0, $4hBm1.format)(d, "yyyy-MM-dd HH:mm") : null;
                            });
                            else {
                                value = new Date(value);
                                value = value && value.getTime() ? (0, $4hBm1.format)(value, "yyyy-MM-dd HH:mm") : null;
                            }
                            return {
                                ...f,
                                value: value
                            };
                        } else return f;
                    }),
                    groupBy: [
                        "projectId"
                    ],
                    sortBy: (organisationReport === null || organisationReport === void 0 ? void 0 : organisationReport.sortBy) || [],
                    dateRange: dateRange,
                    invoiceDateType: (0, $1BTI2.default).settings.reportInvoiceDateType
                }),
            staleTime: 300000
        });
        (0, $60uKl.setReportData)(cacheData);
    }
    const data = await (0, $3h7sC.trpc).legacy.getProjectListPageData.query({
        reportId: reportId
    });
    return (0, $47i9t.processTRPCData)(data);
};
function $51fd95e44f9db9f9$var$Wrapper() {
    if ((0, $8kZ1o.migratedToV2)()) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqntg.PageBody), {
            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7hoGv.ProjectReportPage), {})
        })
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kS4Z4.default), {
                ...$51fd95e44f9db9f9$export$e7b0ac011bb776c6.useParams(),
                ...$51fd95e44f9db9f9$export$e7b0ac011bb776c6.useSearch()
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kuPRw.default), {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bkuoP.default), {
                    ...$51fd95e44f9db9f9$export$e7b0ac011bb776c6.useParams(),
                    ...$51fd95e44f9db9f9$export$e7b0ac011bb776c6.useSearch()
                })
            })
        ]
    });
}

});
parcelRegister("bkuoP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83f924ae2cd0c694$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $4iw5i = parcelRequire("4iw5i");

var $goLmS = parcelRequire("goLmS");

var $hn9pE = parcelRequire("hn9pE");

var $h6zQv = parcelRequire("h6zQv");

var $1BTI2 = parcelRequire("1BTI2");

var $6RcUP = parcelRequire("6RcUP");

var $eat5C = parcelRequire("eat5C");

var $4hBm1 = parcelRequire("4hBm1");

var $lAjTL = parcelRequire("lAjTL");

var $3erXY = parcelRequire("3erXY");
parcelRequire("6Q5sp");

var $cnmvx = parcelRequire("cnmvx");

var $6fNfM = parcelRequire("6fNfM");

var $hJgkt = parcelRequire("hJgkt");
var $83f924ae2cd0c694$export$2e2bcd8739ae039 = (0, $1EEMt.observer)((props)=>{
    var _SessionStore$user;
    (0, $jbmdS.useEffect)(()=>{
        (0, $lAjTL.default).setSearchParams(props);
    }, [
        props.report
    ]);
    const report = (0, $h6zQv.default).reportsById[props.report] || (0, $1BTI2.default).organisation.defaultProjectReport;
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $6RcUP.default), {
        loading: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $4iw5i.default), {}),
        queryIds: [
            {
                id: report.queryKey,
                path: "https://server2.coincraft.co/project-report",
                method: "POST",
                staleTime: 0,
                cacheTime: 0,
                data: {
                    organisationId: (0, $1BTI2.default).organisationId,
                    userId: (_SessionStore$user = (0, $1BTI2.default).user) === null || _SessionStore$user === void 0 ? void 0 : _SessionStore$user.id,
                    columns: report.columns.filter((c)=>{
                        var _report$columnOptions;
                        return !((_report$columnOptions = report.columnOptionsById[c]) !== null && _report$columnOptions !== void 0 && _report$columnOptions.permissions) || report.columnOptionsById[c].permissions();
                    }),
                    filters: report.filters.map((f)=>{
                        var _report$columnOptions2;
                        if (((_report$columnOptions2 = report.columnOptionsById[f.column]) === null || _report$columnOptions2 === void 0 ? void 0 : _report$columnOptions2.type) === "date") {
                            var _dateStringLookup$f$v;
                            let value = ((_dateStringLookup$f$v = (0, $cnmvx.dateStringLookup)[f.value]) === null || _dateStringLookup$f$v === void 0 ? void 0 : _dateStringLookup$f$v.call((0, $cnmvx.dateStringLookup))) || f.value;
                            if (Array.isArray(value)) value = value.map((d)=>d ? (0, $4hBm1.format)(d, "yyyy-MM-dd") : null);
                            else value = value ? (0, $4hBm1.format)(value, "yyyy-MM-dd") : null;
                            return {
                                ...f,
                                value: value
                            };
                        } else return f;
                    }),
                    groupBy: [
                        "projectId"
                    ],
                    sortBy: report.sortBy,
                    dateRange: report.dateRange.map((d)=>isFinite(d) ? (0, $4hBm1.format)(d, "yyyy-MM-dd") : null),
                    invoiceDateType: (0, $1BTI2.default).settings.reportInvoiceDateType
                }
            }
        ],
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3erXY.default), {
                report: report
            }),
            !(report !== null && report !== void 0 && report.needsUpdate) ? /*#__PURE__*/ (0, $61Ea1.jsx)($83f924ae2cd0c694$var$ProjectTable, {
                id: props.report
            }, "project-table" + report.queryKey) : null
        ]
    }, "project-table" + report.queryKey);
});
const $83f924ae2cd0c694$var$ProjectTable = (0, $1EEMt.observer)(({ id: id })=>{
    var _report$sortBy;
    const store = (0, $lAjTL.default);
    const report = (0, $h6zQv.default).reportsById[id] || (0, $1BTI2.default).organisation.defaultProjectReport;
    const sortBy = (_report$sortBy = report.sortBy) !== null && _report$sortBy !== void 0 && _report$sortBy.length ? report.sortBy : (0, $hn9pE.default).sortBy;
    const expandAll = (0, $lAjTL.default).expandAll;
    const query = (0, $hJgkt.useQuery)([
        report.queryKey
    ]);
    const queryData = query.data.data;
    (0, $jbmdS.useEffect)(()=>{
        store.init(queryData);
    }, [
        queryData,
        store
    ]);
    const rows = (0, $jbmdS.useMemo)(()=>{
        return [
            ...queryData || []
        ].filter((r)=>{
            var _r$name, _r$name$toLowerCase, _r$name$toLowerCase$i;
            return ((_r$name = r.name) === null || _r$name === void 0 ? void 0 : (_r$name$toLowerCase = _r$name.toLowerCase()) === null || _r$name$toLowerCase === void 0 ? void 0 : (_r$name$toLowerCase$i = _r$name$toLowerCase.includes) === null || _r$name$toLowerCase$i === void 0 ? void 0 : _r$name$toLowerCase$i.call(_r$name$toLowerCase, report.searchFilter.toLowerCase())) && !r.deletedAt;
        }).map((r)=>{
            delete r.id;
            return r;
        }).sort((a, b)=>{
            var _a$name, _a$name$localeCompare;
            return (_a$name = a.name) === null || _a$name === void 0 ? void 0 : (_a$name$localeCompare = _a$name.localeCompare) === null || _a$name$localeCompare === void 0 ? void 0 : _a$name$localeCompare.call(_a$name, b.name);
        });
    }, [
        queryData,
        report.searchFilter
    ]);
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
            tableStore: report.tableStore,
            columns: [
                {
                    value: (row)=>{
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).isEmpty(row)) {
                            const totalProjects = store.queryData.length;
                            const totalPhases = store.queryData.reduce((acc, p)=>acc + store.getAllPhaseIdsForProject(p).length, 0);
                            return store.queryData && totalProjects > 0 && store.selectedProjectIds.size === totalProjects && store.selectedPhaseIds.size === totalPhases;
                        }
                        return store.isRowSelected(row);
                    },
                    type: "boolean",
                    width: 3,
                    id: "checked",
                    label: "",
                    editable: (r)=>true,
                    print: false,
                    onChange: (r)=>(v)=>{
                            console.log("onChange", r, v);
                            if ((0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).isEmpty(r)) {
                                if (v) store.selectAllRows();
                                else store.deselectAllRows();
                            } else if (v) store.selectRow(r);
                            else store.deselectRow(r);
                        }
                },
                ...report.tableColumns
            ],
            rows: rows,
            showTotals: true,
            getChildComponent: (r)=>{
                return /*#__PURE__*/ (0, $61Ea1.jsx)($83f924ae2cd0c694$var$PhaseSubTable, {
                    project: r,
                    report: report,
                    rows: r.children
                });
            },
            expandAll: expandAll
        }, "project-table" + report.queryKey)
    });
});
const $83f924ae2cd0c694$var$PhaseSubTable = (0, $1EEMt.observer)(({ project: project, report: report, sortBy: sortBy, rows: rows })=>{
    const expandAll = (0, $lAjTL.default).expandAll;
    const tableRows = (0, $jbmdS.useMemo)(()=>{
        return [
            ...rows
        ].map((r)=>{
            delete r.id;
            return r;
        }).sort((0, $6fNfM.default));
    }, [
        project.id,
        rows
    ]);
    const store = (0, $lAjTL.default);
    const columns = (0, $jbmdS.useMemo)(()=>[
            {
                label: "",
                width: 3,
                type: "text",
                value: (r)=>"",
                onChange: (r)=>(v)=>null
            },
            {
                value: (row)=>store.isRowSelected(row),
                type: "boolean",
                width: 3,
                id: "checked",
                label: "",
                editable: (r)=>true,
                print: false,
                onChange: (r)=>(v)=>{
                        if (v) store.selectRow(r);
                        else store.deselectRow(r);
                    }
            },
            ...report.tableColumns,
            ...!report.tableColumns.find((c)=>c.id === "startDate") ? [
                {
                    id: "startDate",
                    label: "Start Date",
                    visible: false,
                    type: "date",
                    value: (r)=>r ? r.startDate : (0, $4hBm1.addYears)(new Date(), 100),
                    onChange: (r)=>(v)=>null
                }
            ] : []
        ], [
        report.tableColumns,
        store
    ]);
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
        columns: columns,
        rows: tableRows,
        sortBy: report.tableStore.sortBy,
        showHeader: false,
        style: {
            boxShadow: "none",
            background: `linear-gradient(180deg, rgb(230,230,230) 1px, rgb(247,247,247) 8px)`,
            fontSize: "1.2rem"
        }
    }, "project-table" + (!expandAll ? project.id : "all") + report.queryKey);
});

});
parcelRegister("lAjTL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb6c65339df8b5b6$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");

var $h6zQv = parcelRequire("h6zQv");

var $1BTI2 = parcelRequire("1BTI2");

var $hdshG = parcelRequire("hdshG");

var $cV8g5 = parcelRequire("cV8g5");

var $6mjwz = parcelRequire("6mjwz");

var $62nmb = parcelRequire("62nmb");

var $6fNfM = parcelRequire("6fNfM");

var $gJT7h = parcelRequire("gJT7h");

var $cv7Es = parcelRequire("cv7Es");
parcelRequire("jE5CX");

var $Ds2V9 = parcelRequire("Ds2V9");

var $6Q5sp = parcelRequire("6Q5sp");
var $fb6c65339df8b5b6$var$_dec, $fb6c65339df8b5b6$var$_dec2, $fb6c65339df8b5b6$var$_dec3, $fb6c65339df8b5b6$var$_dec4, $fb6c65339df8b5b6$var$_dec5, $fb6c65339df8b5b6$var$_dec6, $fb6c65339df8b5b6$var$_dec7, $fb6c65339df8b5b6$var$_dec8, $fb6c65339df8b5b6$var$_dec9, $fb6c65339df8b5b6$var$_dec10, $fb6c65339df8b5b6$var$_class, $fb6c65339df8b5b6$var$_descriptor, $fb6c65339df8b5b6$var$_descriptor2, $fb6c65339df8b5b6$var$_descriptor3, $fb6c65339df8b5b6$var$_descriptor4, $fb6c65339df8b5b6$var$_descriptor5, $fb6c65339df8b5b6$var$_descriptor6, $fb6c65339df8b5b6$var$_descriptor7;
function $fb6c65339df8b5b6$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $fb6c65339df8b5b6$var$_defineProperty(e, r, t) {
    return (r = $fb6c65339df8b5b6$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fb6c65339df8b5b6$var$_toPropertyKey(t) {
    var i = $fb6c65339df8b5b6$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $fb6c65339df8b5b6$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $fb6c65339df8b5b6$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $fb6c65339df8b5b6$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $fb6c65339df8b5b6$var$ProjectListStore = ($fb6c65339df8b5b6$var$_dec = (0, $4JcCM.action).bound, $fb6c65339df8b5b6$var$_dec2 = (0, $4JcCM.action).bound, $fb6c65339df8b5b6$var$_dec3 = (0, $4JcCM.action).bound, $fb6c65339df8b5b6$var$_dec4 = (0, $4JcCM.action).bound, $fb6c65339df8b5b6$var$_dec5 = (0, $4JcCM.action).bound, $fb6c65339df8b5b6$var$_dec6 = (0, $4JcCM.action).bound, $fb6c65339df8b5b6$var$_dec7 = (0, $4JcCM.action).bound, $fb6c65339df8b5b6$var$_dec8 = (0, $4JcCM.action).bound, $fb6c65339df8b5b6$var$_dec9 = (0, $4JcCM.action).bound, $fb6c65339df8b5b6$var$_dec10 = (0, $4JcCM.action).bound, $fb6c65339df8b5b6$var$_class = class ProjectListStore {
    constructor(){
        $fb6c65339df8b5b6$var$_initializerDefineProperty(this, "queryData", $fb6c65339df8b5b6$var$_descriptor, this);
        $fb6c65339df8b5b6$var$_initializerDefineProperty(this, "expandAll", $fb6c65339df8b5b6$var$_descriptor2, this);
        $fb6c65339df8b5b6$var$_initializerDefineProperty(this, "exportGroup", $fb6c65339df8b5b6$var$_descriptor3, this);
        $fb6c65339df8b5b6$var$_initializerDefineProperty(this, "searchParams", $fb6c65339df8b5b6$var$_descriptor4, this);
        $fb6c65339df8b5b6$var$_initializerDefineProperty(this, "selectedProjectIds", $fb6c65339df8b5b6$var$_descriptor5, this);
        $fb6c65339df8b5b6$var$_initializerDefineProperty(this, "selectedPhaseIds", $fb6c65339df8b5b6$var$_descriptor6, this);
        $fb6c65339df8b5b6$var$_initializerDefineProperty(this, "batchSaving", $fb6c65339df8b5b6$var$_descriptor7, this);
        // --- Selection Logic Start ---
        $fb6c65339df8b5b6$var$_defineProperty(this, "getLeafRows", (0, $Ds2V9.computedFn)((row)=>{
            return [
                row
            ];
        }));
        $fb6c65339df8b5b6$var$_defineProperty(this, "isRowSelected", (0, $Ds2V9.computedFn)((row)=>{
            if (row !== null && row !== void 0 && row.projectId && !(row !== null && row !== void 0 && row.phaseId)) return this.selectedProjectIds.has(row.projectId);
            else if (row !== null && row !== void 0 && row.phaseId) return this.selectedPhaseIds.has(row.phaseId);
            return false;
        }));
        $fb6c65339df8b5b6$var$_defineProperty(this, "isProjectPartiallySelected", (0, $Ds2V9.computedFn)((projectRow)=>{
            if (!(projectRow !== null && projectRow !== void 0 && projectRow.projectId)) return false;
            const phaseIds = this.getAllPhaseIdsForProject(projectRow);
            const selectedPhaseIdsInSet = phaseIds.filter((id)=>this.selectedPhaseIds.has(id));
            return selectedPhaseIdsInSet.length > 0 && selectedPhaseIdsInSet.length < phaseIds.length;
        }));
        (0, $4JcCM.makeObservable)(this);
    }
    init(queryData) {
        this.queryData = queryData;
        this.expandAll = false;
        this.selectedProjectIds.clear();
        this.selectedPhaseIds.clear();
        this.batchSaving = false;
    }
    reset() {
        this.queryData = [];
        this.expandAll = false;
        this.exportGroup = "Projects";
        this.searchParams = {};
        this.selectedProjectIds.clear();
        this.selectedPhaseIds.clear();
        this.batchSaving = false;
    }
    setSearchParams(params) {
        this.searchParams = params;
    }
    get report() {
        var _this$searchParams;
        return (0, $h6zQv.default).reportsById[(_this$searchParams = this.searchParams) === null || _this$searchParams === void 0 ? void 0 : _this$searchParams.report] || (0, $1BTI2.default).organisation.defaultProjectReport;
    }
    toggleExpandAll() {
        this.expandAll = !this.expandAll;
    }
    setExportGroup(group) {
        this.exportGroup = group;
    }
    getAllPhaseIdsForProject(projectRow) {
        var _projectRow$children;
        return (projectRow === null || projectRow === void 0 ? void 0 : (_projectRow$children = projectRow.children) === null || _projectRow$children === void 0 ? void 0 : _projectRow$children.map((phase)=>phase.phaseId).filter(Boolean)) || [];
    }
    getParentProjectForRow(phaseRow) {
        return this.queryData.find((project)=>{
            var _project$children;
            return (_project$children = project.children) === null || _project$children === void 0 ? void 0 : _project$children.some((phase)=>phase.phaseId === (phaseRow === null || phaseRow === void 0 ? void 0 : phaseRow.phaseId));
        });
    }
    selectRow(row) {
        if (row !== null && row !== void 0 && row.projectId && !(row !== null && row !== void 0 && row.phaseId)) {
            this.selectedProjectIds.add(row.projectId);
            this.getAllPhaseIdsForProject(row).forEach((id)=>this.selectedPhaseIds.add(id));
        } else if (row !== null && row !== void 0 && row.phaseId) {
            this.selectedPhaseIds.add(row.phaseId);
            const parentProject = this.getParentProjectForRow(row);
            if (parentProject) {
                const allPhaseIds = this.getAllPhaseIdsForProject(parentProject);
                if (allPhaseIds.every((id)=>this.selectedPhaseIds.has(id))) this.selectedProjectIds.add(parentProject.projectId);
            }
        }
    }
    deselectRow(row) {
        if (row !== null && row !== void 0 && row.projectId && !(row !== null && row !== void 0 && row.phaseId)) {
            this.selectedProjectIds.delete(row.projectId);
            this.getAllPhaseIdsForProject(row).forEach((id)=>this.selectedPhaseIds.delete(id));
        } else if (row !== null && row !== void 0 && row.phaseId) {
            this.selectedPhaseIds.delete(row.phaseId);
            const parentProject = this.getParentProjectForRow(row);
            if (parentProject !== null && parentProject !== void 0 && parentProject.projectId) this.selectedProjectIds.delete(parentProject.projectId);
        }
    }
    selectAllRows() {
        this.selectedProjectIds.clear();
        this.selectedPhaseIds.clear();
        this.queryData.forEach((projectRow)=>{
            if (projectRow !== null && projectRow !== void 0 && projectRow.projectId) {
                this.selectedProjectIds.add(projectRow.projectId);
                this.getAllPhaseIdsForProject(projectRow).forEach((id)=>this.selectedPhaseIds.add(id));
            }
        });
    }
    deselectAllRows() {
        this.selectedProjectIds.clear();
        this.selectedPhaseIds.clear();
    }
    batchSaveSelectedRows(updates) {
        this.batchSaving = true;
        const projectIdsToUpdate = [
            ...this.selectedProjectIds
        ];
        // const phaseIdsToUpdate = [...this.selectedPhaseIds] // Not directly used for batch update filter, but part of data
        if (!projectIdsToUpdate.length) {
            // Updated check: only proceed if project IDs are selected
            console.warn("Batch save called for projects, but no project IDs were selected.");
            this.batchSaving = false;
            return;
        }
        (0, $cv7Es.default).addData({
            collection: "projects",
            // filters: projectIdsToFilterBy.length // Old way
            //     ? [[`id in (${qf(projectIdsToFilterBy)})`]]
            //     : [],
            ids: projectIdsToUpdate,
            // New way
            data: {
                ...updates,
                // The Python `batch_save` took `data` and applied it.
                // The original client code added selectedProjectIds and selectedPhaseIds to this data.
                // If this is still desired, keep them. Otherwise, review if they are needed for the actual update operation.
                selectedProjectIds: projectIdsToUpdate,
                selectedPhaseIds: [
                    ...this.selectedPhaseIds
                ]
            }
        });
        (0, $cv7Es.default).startSave(()=>{
            (0, $6Q5sp.queryClient).invalidateQueries([
                this.report.queryKey
            ]);
            this.batchSaving = false;
            this.selectedProjectIds.clear();
            this.selectedPhaseIds.clear();
        });
    }
    // --- Selection Logic End ---
    async downloadCSV() {
        const group = this.exportGroup;
        if (group === "Projects") this.report.downloadCSV();
        else {
            const tableStore = new (0, $hdshG.default)();
            const csvData = this.report.tableStore.rows.flatMap((row, i)=>{
                const phases = row.rowObject.children.sort((0, $6fNfM.default));
                const columns = this.report.tableColumns;
                if (!columns.map((c)=>c.id).includes("projectName")) columns.unshift({
                    id: "projectName",
                    label: "Project",
                    type: "text",
                    width: 26,
                    value: (row)=>{
                        return (0, $gJT7h.default).projectsById[row.projectId].title;
                    }
                });
                tableStore.update({
                    rows: phases,
                    columns: columns
                });
                return tableStore.getCsvData({
                    includeHeadings: i === 0
                });
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($cV8g5)))((0, (/*@__PURE__*/$parcel$interopDefault($6mjwz))).unparse(csvData), `${this.report.name}.csv`, "text/csv");
        }
    }
}, $fb6c65339df8b5b6$var$_descriptor = $fb6c65339df8b5b6$var$_applyDecoratedDescriptor($fb6c65339df8b5b6$var$_class.prototype, "queryData", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $fb6c65339df8b5b6$var$_descriptor2 = $fb6c65339df8b5b6$var$_applyDecoratedDescriptor($fb6c65339df8b5b6$var$_class.prototype, "expandAll", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $fb6c65339df8b5b6$var$_descriptor3 = $fb6c65339df8b5b6$var$_applyDecoratedDescriptor($fb6c65339df8b5b6$var$_class.prototype, "exportGroup", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "Projects";
    }
}), $fb6c65339df8b5b6$var$_descriptor4 = $fb6c65339df8b5b6$var$_applyDecoratedDescriptor($fb6c65339df8b5b6$var$_class.prototype, "searchParams", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $fb6c65339df8b5b6$var$_descriptor5 = $fb6c65339df8b5b6$var$_applyDecoratedDescriptor($fb6c65339df8b5b6$var$_class.prototype, "selectedProjectIds", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Set();
    }
}), $fb6c65339df8b5b6$var$_descriptor6 = $fb6c65339df8b5b6$var$_applyDecoratedDescriptor($fb6c65339df8b5b6$var$_class.prototype, "selectedPhaseIds", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Set();
    }
}), $fb6c65339df8b5b6$var$_descriptor7 = $fb6c65339df8b5b6$var$_applyDecoratedDescriptor($fb6c65339df8b5b6$var$_class.prototype, "batchSaving", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $fb6c65339df8b5b6$var$_applyDecoratedDescriptor($fb6c65339df8b5b6$var$_class.prototype, "init", [
    $fb6c65339df8b5b6$var$_dec
], Object.getOwnPropertyDescriptor($fb6c65339df8b5b6$var$_class.prototype, "init"), $fb6c65339df8b5b6$var$_class.prototype), $fb6c65339df8b5b6$var$_applyDecoratedDescriptor($fb6c65339df8b5b6$var$_class.prototype, "reset", [
    $fb6c65339df8b5b6$var$_dec2
], Object.getOwnPropertyDescriptor($fb6c65339df8b5b6$var$_class.prototype, "reset"), $fb6c65339df8b5b6$var$_class.prototype), $fb6c65339df8b5b6$var$_applyDecoratedDescriptor($fb6c65339df8b5b6$var$_class.prototype, "setSearchParams", [
    $fb6c65339df8b5b6$var$_dec3
], Object.getOwnPropertyDescriptor($fb6c65339df8b5b6$var$_class.prototype, "setSearchParams"), $fb6c65339df8b5b6$var$_class.prototype), $fb6c65339df8b5b6$var$_applyDecoratedDescriptor($fb6c65339df8b5b6$var$_class.prototype, "report", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($fb6c65339df8b5b6$var$_class.prototype, "report"), $fb6c65339df8b5b6$var$_class.prototype), $fb6c65339df8b5b6$var$_applyDecoratedDescriptor($fb6c65339df8b5b6$var$_class.prototype, "toggleExpandAll", [
    $fb6c65339df8b5b6$var$_dec4
], Object.getOwnPropertyDescriptor($fb6c65339df8b5b6$var$_class.prototype, "toggleExpandAll"), $fb6c65339df8b5b6$var$_class.prototype), $fb6c65339df8b5b6$var$_applyDecoratedDescriptor($fb6c65339df8b5b6$var$_class.prototype, "setExportGroup", [
    $fb6c65339df8b5b6$var$_dec5
], Object.getOwnPropertyDescriptor($fb6c65339df8b5b6$var$_class.prototype, "setExportGroup"), $fb6c65339df8b5b6$var$_class.prototype), $fb6c65339df8b5b6$var$_applyDecoratedDescriptor($fb6c65339df8b5b6$var$_class.prototype, "selectRow", [
    $fb6c65339df8b5b6$var$_dec6
], Object.getOwnPropertyDescriptor($fb6c65339df8b5b6$var$_class.prototype, "selectRow"), $fb6c65339df8b5b6$var$_class.prototype), $fb6c65339df8b5b6$var$_applyDecoratedDescriptor($fb6c65339df8b5b6$var$_class.prototype, "deselectRow", [
    $fb6c65339df8b5b6$var$_dec7
], Object.getOwnPropertyDescriptor($fb6c65339df8b5b6$var$_class.prototype, "deselectRow"), $fb6c65339df8b5b6$var$_class.prototype), $fb6c65339df8b5b6$var$_applyDecoratedDescriptor($fb6c65339df8b5b6$var$_class.prototype, "selectAllRows", [
    $fb6c65339df8b5b6$var$_dec8
], Object.getOwnPropertyDescriptor($fb6c65339df8b5b6$var$_class.prototype, "selectAllRows"), $fb6c65339df8b5b6$var$_class.prototype), $fb6c65339df8b5b6$var$_applyDecoratedDescriptor($fb6c65339df8b5b6$var$_class.prototype, "deselectAllRows", [
    $fb6c65339df8b5b6$var$_dec9
], Object.getOwnPropertyDescriptor($fb6c65339df8b5b6$var$_class.prototype, "deselectAllRows"), $fb6c65339df8b5b6$var$_class.prototype), $fb6c65339df8b5b6$var$_applyDecoratedDescriptor($fb6c65339df8b5b6$var$_class.prototype, "batchSaveSelectedRows", [
    $fb6c65339df8b5b6$var$_dec10
], Object.getOwnPropertyDescriptor($fb6c65339df8b5b6$var$_class.prototype, "batchSaveSelectedRows"), $fb6c65339df8b5b6$var$_class.prototype), $fb6c65339df8b5b6$var$_applyDecoratedDescriptor($fb6c65339df8b5b6$var$_class.prototype, "downloadCSV", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($fb6c65339df8b5b6$var$_class.prototype, "downloadCSV"), $fb6c65339df8b5b6$var$_class.prototype), $fb6c65339df8b5b6$var$_class);
var $fb6c65339df8b5b6$export$2e2bcd8739ae039 = new $fb6c65339df8b5b6$var$ProjectListStore();

});


parcelRegister("kS4Z4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f31cb78083fe01a6$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $36Jjh = parcelRequire("36Jjh");

var $h6zQv = parcelRequire("h6zQv");

var $1BTI2 = parcelRequire("1BTI2");

var $jr4Q7 = parcelRequire("jr4Q7");

var $gJT7h = parcelRequire("gJT7h");
parcelRequire("eNcHX");
parcelRequire("XoImS");

var $52dEm = parcelRequire("52dEm");

var $8kZ1o = parcelRequire("8kZ1o");

var $lAjTL = parcelRequire("lAjTL");

var $ewAM3 = parcelRequire("ewAM3");

var $4hBm1 = parcelRequire("4hBm1");

var $3X7oM = parcelRequire("3X7oM");

var $6UBLf = parcelRequire("6UBLf");

var $khJQv = parcelRequire("khJQv");

var $7DOJZ = parcelRequire("7DOJZ");
var $f31cb78083fe01a6$export$2e2bcd8739ae039 = (0, $1EEMt.observer)((props)=>{
    const navigate = (0, $6UBLf.useNavigate)();
    const report = (0, $h6zQv.default).reportsById[props.report] || (0, $1BTI2.default).organisation.defaultProjectReport;
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $36Jjh.default), {
        heading: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    children: "Projects"
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    className: "text-sm font-normal px-2.5 py-1.5",
                    children: isFinite(report.dateRange[0]) ? `(${(0, $4hBm1.format)(report.dateRange[0], "dd MMMM yyyy")} - ${(0, $4hBm1.format)(report.dateRange[1], "dd MMMM yyyy")})` : `(All time prior to: ${(0, $4hBm1.format)(new Date(), "dd MMMM yyyy")})`
                })
            ]
        }),
        leftButtons: (0, $8kZ1o.canCreateProjects)((0, $1BTI2.default).user) ? [
            /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                className: "project-list__add-new-project-button page-header__button--primary plus-btn",
                onClick: ()=>{
                    const project = (0, $gJT7h.default).createProject();
                    navigate({
                        to: `/projects/${project.id}`
                    });
                },
                children: "+ New Project"
            }, 0)
        ] : null,
        rightButtons: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            className: "flex gap-2 items-center",
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3X7oM.default), {
                    disabled: !(0, $lAjTL.default).selectedProjectIds.size && !(0, $lAjTL.default).selectedPhaseIds.size,
                    onClick: ()=>{
                        (0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $7DOJZ.default), {
                            modalId: "batchEditProject",
                            selectedProjectIds: [
                                ...(0, $lAjTL.default).selectedProjectIds
                            ],
                            selectedPhaseIds: [
                                ...(0, $lAjTL.default).selectedPhaseIds
                            ]
                        }));
                    },
                    label: "Batch Edit Selected",
                    icon: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                        className: "fa fa-pencil"
                    })
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    className: "export-button-dropdown inline-flex items-center dont-print gap-2",
                    children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3X7oM.default), {
                                label: "Export",
                                icon: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                    className: "fa fa-table"
                                }),
                                onClick: ()=>{
                                    (0, $lAjTL.default).downloadCSV();
                                },
                                className: "border-r-0 rounded-tr-none rounded-br-none"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                                className: " border! border-white bg-transparent hover:bg-white/25 transition-colors rounded-[6px] rounded-tl-none rounded-bl-none",
                                style: {
                                    maxWidth: "8em",
                                    margin: 0,
                                    fontSize: "1em",
                                    background: "transparent"
                                },
                                value: (0, $lAjTL.default).exportGroup,
                                options: [
                                    "Projects",
                                    "Phases"
                                ],
                                optionLabel: function(group) {
                                    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        children: group
                                    });
                                },
                                onChange: (group)=>(0, $lAjTL.default).setExportGroup(group)
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3X7oM.default), {
                    label: "Print",
                    icon: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                        className: "fa fa-print"
                    }),
                    onClick: ()=>window.print()
                })
            ]
        }),
        filter: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jr4Q7.ReportSearch), {
            report: report,
            placeholder: "Filter by project name or job code"
        }),
        extraContent: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jr4Q7.default), {
            report: report,
            reportOptions: (0, $h6zQv.default).reportsByType["project"],
            baseUrl: "/projects",
            filterOptions: ({ filter: filter, columns: columns, report: report })=>{
                return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                    label: "Apply to Phases",
                    className: "is-variation-checkbox",
                    value: filter.group === "phase",
                    onChange: (v)=>v ? report.updateFilter(filter, "group", "phase") : report.updateFilter(filter, "group", "project")
                });
            },
            expandClick: ()=>(0, $lAjTL.default).toggleExpandAll(),
            expandLabel: (0, $lAjTL.default).expandAll ? "- Collapse All" : "+ Expand All"
        })
    });
});

});
parcelRegister("7DOJZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59038901613bcd49$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("fuFv1");
var $aPVKl = parcelRequire("aPVKl");

var $fEcKX = parcelRequire("fEcKX");

var $ewAM3 = parcelRequire("ewAM3");

var $eat5C = parcelRequire("eat5C");

var $htkeB = parcelRequire("htkeB");

var $3h7sC = parcelRequire("3h7sC");

var $eNcHX = parcelRequire("eNcHX");
parcelRequire("gJT7h");
parcelRequire("XoImS");

var $lAjTL = parcelRequire("lAjTL");
const $59038901613bcd49$var$BatchEditProjectModal = (0, $aPVKl.observer)(({ modalId: modalId, selectedProjectIds: selectedProjectIds = [], selectedPhaseIds: selectedPhaseIds = [] })=>{
    const [status, setStatus] = (0, $jbmdS.useState)(""); // Use empty string to represent "no change"
    const [ownerId, setOwnerId] = (0, $jbmdS.useState)(""); // Use empty string for "no change"
    const [costCentreId, setCostCentreId] = (0, $jbmdS.useState)(""); // Use empty string for "no change"
    const [isLoading, setIsLoading] = (0, $jbmdS.useState)(false); // Add loading state
    (0, $jbmdS.useEffect)(()=>{
        // Set default values based on selected projects and phases from ProjectListStore
        if (selectedProjectIds.length > 0) {
            // Get selected project rows from queryData
            const selectedProjects = (0, $lAjTL.default).queryData.filter((project)=>selectedProjectIds.includes(project.projectId));
            if (selectedProjects.length > 0) {
                // Check if all projects have the same costCentreId
                const uniqueCostCentres = [
                    ...new Set(selectedProjects.map((p)=>p.costCentreId))
                ];
                if (uniqueCostCentres.length === 1 && uniqueCostCentres[0]) setCostCentreId(uniqueCostCentres[0]);
                // Check if all projects have the same ownerId
                const uniqueOwners = [
                    ...new Set(selectedProjects.map((p)=>p.ownerId))
                ];
                if (uniqueOwners.length === 1 && uniqueOwners[0]) setOwnerId(uniqueOwners[0]);
            }
        }
        if (selectedPhaseIds.length > 0) {
            // Get all phases from selected projects' children
            const selectedPhases = (0, $lAjTL.default).queryData.flatMap((project)=>project.children || []).filter((phase)=>selectedPhaseIds.includes(phase.phaseId));
            if (selectedPhases.length > 0) {
                // Check if all phases have the same status
                const uniqueStatuses = [
                    ...new Set(selectedPhases.map((p)=>p.status))
                ];
                if (uniqueStatuses.length === 1 && uniqueStatuses[0]) setStatus(uniqueStatuses[0]);
            }
        }
    }, [
        selectedProjectIds,
        selectedPhaseIds
    ]);
    const handleSave = async ()=>{
        const updates = {};
        if (status) updates.status = status;
        if (ownerId) {
            updates.ownerId = ownerId;
            // Add owner display name
            const staff = (0, $htkeB.default).staffById[ownerId];
            if (staff) updates.owner = staff.fullName;
        }
        if (costCentreId) {
            updates.costCentreId = costCentreId;
            // Add cost centre display name
            const costCentre = (0, $eNcHX.default).costCentresById[costCentreId];
            if (costCentre) updates.costCentre = costCentre.name;
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).isEmpty(updates)) {
            setIsLoading(true);
            try {
                const result = await (0, $3h7sC.trpc).batchEditProjects.batchUpdate.mutate({
                    projectIds: selectedProjectIds,
                    phaseIds: selectedPhaseIds.length ? selectedPhaseIds : undefined,
                    updates: updates
                });
                // Update the rows in ProjectListStore.queryData
                (0, $lAjTL.default).queryData = (0, $lAjTL.default).queryData.map((project)=>{
                    var _project$children2;
                    // If this project is selected, update its fields
                    if (selectedProjectIds.includes(project.projectId)) {
                        var _project$children;
                        return {
                            ...project,
                            ...updates,
                            children: (_project$children = project.children) === null || _project$children === void 0 ? void 0 : _project$children.map((phase)=>{
                                // If status is being updated and this phase is selected, update its status
                                if (updates.status && selectedPhaseIds.includes(phase.phaseId)) return {
                                    ...phase,
                                    status: updates.status
                                };
                                return phase;
                            })
                        };
                    } else if ((_project$children2 = project.children) !== null && _project$children2 !== void 0 && _project$children2.some((phase)=>selectedPhaseIds.includes(phase.phaseId))) return {
                        ...project,
                        children: project.children.map((phase)=>{
                            if (updates.status && selectedPhaseIds.includes(phase.phaseId)) return {
                                ...phase,
                                status: updates.status
                            };
                            return phase;
                        })
                    };
                    return project;
                });
                // Clear selections after successful update
                (0, $lAjTL.default).selectedProjectIds.clear();
                (0, $lAjTL.default).selectedPhaseIds.clear();
            } catch (error) {
                console.error("Failed to batch update projects:", error);
            } finally{
                setIsLoading(false);
            }
        }
    };
    const title = selectedProjectIds.length > 0 ? `Batch Edit ${selectedProjectIds.length} Project(s)` : `Batch Edit ${selectedPhaseIds.length} Phase(s)`;
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fEcKX.default), {
        modalId: modalId,
        heading: title,
        onSave: handleSave,
        saveLabel: "Save Changes",
        isSaving: isLoading,
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            className: "p-[1em] grid gap-[0.5em]",
            style: {
                gridTemplateColumns: selectedProjectIds.length > 0 ? "1fr 1fr 1fr" : "1fr"
            },
            children: [
                selectedProjectIds.length > 0 && /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("label", {
                                    htmlFor: "project-cost-centre",
                                    className: "text-sm text-[#444] font-bold",
                                    children: "Cost Centre:"
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                    className: "max-w-max",
                                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.CostCentreSelector), {
                                        id: "project-cost-centre",
                                        selectedCostCentre: (0, $eNcHX.default).costCentresById[costCentreId],
                                        onChange: (costCentre)=>setCostCentreId((costCentre === null || costCentre === void 0 ? void 0 : costCentre.id) || ""),
                                        placeholderLabel: "-- No Change --",
                                        className: "w-full",
                                        nullable: true,
                                        variant: "secondary"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("label", {
                                    htmlFor: "project-owner",
                                    className: "text-sm text-[#444] font-bold",
                                    children: "Project Owner:"
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                    className: "max-w-max",
                                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.StaffSelector), {
                                        id: "project-owner",
                                        selectedStaffMember: (0, $htkeB.default).staffById[ownerId],
                                        onChange: (staff)=>setOwnerId((staff === null || staff === void 0 ? void 0 : staff.id) || ""),
                                        placeholderLabel: "-- No Change --",
                                        className: "w-full",
                                        nullable: true,
                                        variant: "secondary"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("label", {
                            htmlFor: "project-status",
                            className: "text-sm text-[#444] font-bold",
                            children: "Status:"
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            className: "max-w-max",
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.StatusSelector), {
                                id: "project-status",
                                selectedStatus: status,
                                onChange: setStatus,
                                placeholder: "-- No Change --",
                                className: "w-full",
                                variant: "secondary"
                            })
                        })
                    ]
                })
            ]
        })
    });
});
var $59038901613bcd49$export$2e2bcd8739ae039 = $59038901613bcd49$var$BatchEditProjectModal;

});


parcelRegister("7hoGv", function(module, exports) {

$parcel$export(module.exports, "ProjectReportPage", function () { return $85b41b6fc407ecea$export$fd68bfa0192b33da; });

var $61Ea1 = parcelRequire("61Ea1");

var $c739t = parcelRequire("c739t");
const $85b41b6fc407ecea$export$fd68bfa0192b33da = ()=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $c739t.ProjectReportTable), {});
};

});
parcelRegister("c739t", function(module, exports) {

$parcel$export(module.exports, "ProjectReportTable", function () { return $741f4ae2fe8df6c8$export$682e871232c113e9; });

var $61Ea1 = parcelRequire("61Ea1");

var $gcfa1 = parcelRequire("gcfa1");

var $aYyI4 = parcelRequire("aYyI4");

var $aaosT = parcelRequire("aaosT");

var $3h7sC = parcelRequire("3h7sC");

var $khCHn = parcelRequire("khCHn");

var $kKJbF = parcelRequire("kKJbF");

var $O2UPo = parcelRequire("O2UPo");

var $kqlQp = parcelRequire("kqlQp");

var $i5M8X = parcelRequire("i5M8X");

var $lrcql = parcelRequire("lrcql");

var $60uKl = parcelRequire("60uKl");

var $jbmdS = parcelRequire("jbmdS");
function $741f4ae2fe8df6c8$export$682e871232c113e9() {
    var _organisationReport$f;
    const organisationReport = (0, $60uKl.useOrganisationReport)();
    const reportData = (0, $60uKl.useReportData)();
    const isLoadingReportData = (0, $60uKl.useIsLoadingReportData)();
    const pendingChanges = (0, $60uKl.usePendingChanges)();
    const handleStateChange = (newState, options)=>{
        (0, $60uKl.setOrganisationReport)({
            ...organisationReport,
            ...newState
        }, options);
    };
    const handleColumnsChange = (columns, options)=>{
        (0, $60uKl.setColumns)(columns, options);
    };
    const handleApplyChanges = async ()=>{
        (0, $60uKl.setIsLoadingReportData)(true);
        try {
            const data = await fetchReportData({
                ...organisationReport,
                groupBy: organisationReport.groupBy || [
                    "projectId"
                ],
                sortBy: organisationReport.sortBy || []
            });
            (0, $60uKl.setReportData)(data);
        } finally{
            (0, $60uKl.setIsLoadingReportData)(false);
            (0, $60uKl.setPendingChanges)(false);
        }
    };
    const columns = (0, $jbmdS.useMemo)(()=>(0, $kKJbF.orderColumnDefs)((0, $lrcql.getColumns)((column)=>{
            (0, $60uKl.setColumns)(organisationReport.columns.filter((c)=>c !== column), {
                needsRefetch: false
            });
        }), organisationReport.columns, [], []), [
        organisationReport.columns
    ]);
    const filterFields = columns.map((column)=>{
        var _column$meta, _column$meta2, _column$meta3;
        return {
            label: column === null || column === void 0 ? void 0 : (_column$meta = column.meta) === null || _column$meta === void 0 ? void 0 : _column$meta.title,
            value: column.accessorKey,
            typeFilter: (0, $O2UPo.typeFilterMap)[column === null || column === void 0 ? void 0 : (_column$meta2 = column.meta) === null || _column$meta2 === void 0 ? void 0 : _column$meta2.type],
            ...column === null || column === void 0 ? void 0 : (_column$meta3 = column.meta) === null || _column$meta3 === void 0 ? void 0 : _column$meta3.filterOptions
        };
    });
    const { table: table } = (0, $aaosT.useDataTable)({
        data: reportData,
        columns: columns,
        visibleColumns: organisationReport.columns,
        filterFields: filterFields,
        enableAdvancedFilter: true,
        sortingFns: {
            sortingTextFn: $O2UPo.sortingTextFn,
            sortingProgressFn: $O2UPo.sortingProgressFn,
            sortingDateFn: $O2UPo.sortingDateFn
        },
        groups: {
            enabled: true,
            columns: [
                "projectId"
            ],
            leafRowLabel: "Phase",
            labelColumn: (0, $khCHn.generateColumnDef)({
                key: "name",
                type: "text",
                title: "Name",
                size: 260,
                cell: (row)=>{
                    var _row$original$childre;
                    const value = row.getValue("name");
                    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        style: {
                            paddingLeft: `${1 * row.original.groupLevel}rem`,
                            width: "100%"
                        },
                        children: (_row$original$childre = row.original.children) !== null && _row$original$childre !== void 0 && _row$original$childre.length ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqlQp.Link), {
                            to: `/projects/${row.original.projectId}`,
                            children: value
                        }) : value
                    });
                }
            })
        }
    });
    const fetchReportData = async (data)=>{
        return await (0, $3h7sC.trpc).projectReport.getReportsData.query(data);
    };
    const exportColumns = [
        {
            label: "Project",
            value: "project"
        },
        {
            label: "Phase",
            value: "phase"
        }
    ];
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $aYyI4.DataTable), {
        table: table,
        showTotals: true,
        loadingReportData: isLoadingReportData,
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $gcfa1.DataTableAdvancedToolbar), {
            table: table,
            filterFields: filterFields,
            searchableFields: [
                "project"
            ],
            tableState: {
                columns: organisationReport.columns,
                filters: (_organisationReport$f = organisationReport.filters) !== null && _organisationReport$f !== void 0 ? _organisationReport$f : [],
                dateRange: organisationReport.dateRange,
                sortBy: organisationReport.sortBy,
                groupBy: organisationReport.groupBy
            },
            pendingChanges: pendingChanges,
            onStateChange: handleStateChange,
            onColumnsChange: handleColumnsChange,
            onApplyChanges: handleApplyChanges,
            isLoading: isLoadingReportData,
            groupByColumns: [
                "projectId"
            ],
            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $i5M8X.ProjectReportActions), {
                table: table,
                exportColumns: exportColumns
            })
        })
    });
}

});
parcelRegister("i5M8X", function(module, exports) {

$parcel$export(module.exports, "ProjectReportActions", function () { return $e608d8302a7d9d53$export$111037c79fc3e80; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $gN0TC = parcelRequire("gN0TC");

var $60uKl = parcelRequire("60uKl");

var $fJ4T4 = parcelRequire("fJ4T4");

var $cV8g5 = parcelRequire("cV8g5");

var $6mjwz = parcelRequire("6mjwz");

var $azaaH = parcelRequire("azaaH");

var $3h7sC = parcelRequire("3h7sC");

var $1BTI2 = parcelRequire("1BTI2");

var $6UBLf = parcelRequire("6UBLf");

var $dHs32 = parcelRequire("dHs32");

var $38AIP = parcelRequire("38AIP");

var $26sX2 = parcelRequire("26sX2");

var $bAwxh = parcelRequire("bAwxh");
function $e608d8302a7d9d53$export$111037c79fc3e80({ table: table, exportColumns: exportColumns }) {
    var _SessionStore$organis;
    const navigate = (0, $6UBLf.useNavigate)();
    const [dialogContent, setDialogContent] = (0, $jbmdS.useState)(null);
    const [nameReport, setNameReport] = (0, $jbmdS.useState)(null);
    const [savePayload, setSavePayload] = (0, $jbmdS.useState)(null);
    const organisationReport = (0, $60uKl.useOrganisationReport)();
    const checkDisableButton = !(organisationReport !== null && organisationReport !== void 0 && organisationReport.id) && !((_SessionStore$organis = (0, $1BTI2.default).organisation) !== null && _SessionStore$organis !== void 0 && _SessionStore$organis.defaultProjectReportId);
    const showSaveAsToast = (0, $bAwxh.useSaveToast)({
        saveId: "project-report-save-as",
        onSave: async ()=>{
            const newId = $gN0TC();
            const result = await (0, $3h7sC.trpc).projectReport.saveReport.mutate({
                id: newId,
                name: nameReport,
                organisationId: organisationReport.organisationId,
                filters: organisationReport.filters,
                type: "project",
                columns: organisationReport.columns,
                options: organisationReport.options
            });
            (0, $38AIP.addCacheItem)("organisationReports", {
                id: newId,
                name: nameReport,
                type: "project"
            });
            setNameReport(null);
            setDialogContent(null);
            (0, $60uKl.setOrganisationReport)({
                ...organisationReport,
                ...result
            });
            navigate({
                search: {
                    report: newId
                }
            });
        },
        loadingMessage: "Saving new report...",
        successMessage: "New report saved successfully",
        errorMessage: "Failed to save new report"
    });
    // Save existing report
    const showSaveToast = (0, $bAwxh.useSaveToast)({
        saveId: "project-report-save",
        onSave: async ()=>{
            const result = await (0, $3h7sC.trpc).projectReport.saveReport.mutate({
                id: organisationReport.id,
                organisationId: organisationReport.organisationId,
                filters: organisationReport.filters,
                columns: organisationReport.columns,
                options: organisationReport.options
            });
            setDialogContent(null);
            (0, $60uKl.setOrganisationReport)({
                ...organisationReport,
                ...result
            });
            return result;
        },
        loadingMessage: "Saving report...",
        successMessage: "Report saved successfully",
        errorMessage: "Failed to save report"
    });
    // Rename operation
    const showRenameToast = (0, $bAwxh.useSaveToast)({
        saveId: "project-report-rename",
        onSave: async ()=>{
            if (!nameReport || nameReport === organisationReport.name) return;
            const result = await (0, $3h7sC.trpc).projectReport.saveReport.mutate({
                id: organisationReport.id,
                organisationId: organisationReport.organisationId,
                name: nameReport
            });
            (0, $38AIP.updateCacheItem)("organisationReports", organisationReport.id, {
                name: nameReport,
                type: "project"
            });
            (0, $26sX2.setPageTitle)(nameReport);
            setNameReport(null);
            setDialogContent(null);
            (0, $60uKl.setOrganisationReport)({
                ...organisationReport,
                ...result
            });
            return result;
        },
        loadingMessage: "Renaming report...",
        successMessage: "Report renamed successfully",
        errorMessage: "Failed to rename report"
    });
    // Delete operation
    const showDeleteToast = (0, $bAwxh.useSaveToast)({
        saveId: "project-report-delete",
        onSave: async ()=>{
            const result = await (0, $3h7sC.trpc).projectReport.saveReport.mutate({
                id: organisationReport.id,
                organisationId: organisationReport.organisationId,
                deletedAt: new Date()
            });
            (0, $38AIP.deleteCacheItem)("organisationReports", organisationReport.id);
            setDialogContent(null);
            navigate({
                search: {}
            });
            return result;
        },
        loadingMessage: "Deleting report...",
        successMessage: "Report deleted successfully",
        errorMessage: "Failed to delete report"
    });
    // Set Default operation
    const showSaveDefaultToast = (0, $bAwxh.useSaveToast)({
        saveId: "project-report-set-default",
        onSave: async ()=>{
            return await (0, $3h7sC.trpc).projectReport.setDefaultReport.mutate({
                id: organisationReport.id
            });
        },
        loadingMessage: "Setting as default...",
        successMessage: "Set as default report",
        errorMessage: "Failed to set as default"
    });
    const handleOpenDialog = (content)=>{
        setNameReport(null);
        setDialogContent(content);
    };
    const csvFormatter = (data, column)=>{
        var _column$columnDef$met;
        const value = data.getValue(column === null || column === void 0 ? void 0 : column.id);
        switch((_column$columnDef$met = column.columnDef.meta) === null || _column$columnDef$met === void 0 ? void 0 : _column$columnDef$met.type){
            case "progress":
            case "progressBar":
                const { numerator: numerator, denominator: denominator } = value;
                if (numerator || denominator) return `${(0, $azaaH.default).progress(numerator || 0)} / ${(0, $azaaH.default).progress(denominator || 0)}`;
                else return "";
            case "date":
                return data ? (0, $fJ4T4.FormatDate)(new Date(value), {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit"
                }) : "";
            default:
                return value;
        }
    };
    const columns = organisationReport === null || organisationReport === void 0 ? void 0 : organisationReport.columns;
    const handleExportToCSV = (type)=>{
        const results = [];
        // Add headers
        const headers = table.getAllColumns().filter((item)=>columns === null || columns === void 0 ? void 0 : columns.includes(item.id));
        const firstRow = [];
        if (type !== "project") firstRow.push("Project");
        headers.forEach((header)=>{
            var _header$columnDef$met;
            return firstRow.push((_header$columnDef$met = header.columnDef.meta) === null || _header$columnDef$met === void 0 ? void 0 : _header$columnDef$met.title);
        });
        results.push(firstRow);
        // Add data
        table.getRowModel().rows.forEach((item)=>{
            if (type == "project") {
                const row = [];
                headers.forEach((header)=>{
                    row.push(csvFormatter(item, header));
                });
                results.push(row);
            } else {
                const phases = item === null || item === void 0 ? void 0 : item.subRows;
                if (phases.length) phases.forEach((phase)=>{
                    const dataPhase = [
                        item.getValue("name").toString()
                    ];
                    headers.forEach((header)=>{
                        dataPhase.push(csvFormatter(phase, header));
                    });
                    results.push(dataPhase);
                });
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($cV8g5)))((0, (/*@__PURE__*/$parcel$interopDefault($6mjwz))).unparse(results), `project.csv`, "text/csv");
    };
    const handleSetDefault = async ()=>{
        await showSaveDefaultToast();
    };
    const handleDialogSubmit = async (dialogContent)=>{
        switch(dialogContent){
            case "Save as":
                await showSaveAsToast();
                break;
            case "Save":
                await showSaveToast();
                break;
            case "Rename Report":
                await showRenameToast();
                break;
            case "Delete Report":
                await showDeleteToast();
                break;
            default:
                break;
        }
        setDialogContent(null);
    };
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $dHs32.DataTableActions), {
            handleExportToCSV: handleExportToCSV,
            handleDialogSubmit: handleDialogSubmit,
            handleOpenDialog: handleOpenDialog,
            handleSetDefault: handleSetDefault,
            dialogContent: dialogContent,
            setDialogContent: setDialogContent,
            setNameReport: setNameReport,
            nameReport: nameReport,
            organisationReport: organisationReport,
            checkDisableButton: checkDisableButton,
            exportColumns: exportColumns
        })
    });
}

});
parcelRegister("60uKl", function(module, exports) {

$parcel$export(module.exports, "useReportData", function () { return $8de288a98087a926$export$5937a5b9379177ff; });
$parcel$export(module.exports, "useOrganisationReport", function () { return $8de288a98087a926$export$30415e21906d195c; });
$parcel$export(module.exports, "useIsLoadingReportData", function () { return $8de288a98087a926$export$2ea3c65c90de2aa8; });
$parcel$export(module.exports, "usePendingChanges", function () { return $8de288a98087a926$export$b69a3814d0f14d43; });
$parcel$export(module.exports, "setOrganisationReport", function () { return $8de288a98087a926$export$447d9eb2f4688ef2; });
$parcel$export(module.exports, "setReportData", function () { return $8de288a98087a926$export$b4af916732271762; });
$parcel$export(module.exports, "setIsLoadingReportData", function () { return $8de288a98087a926$export$73b176e19d58db01; });
$parcel$export(module.exports, "setColumns", function () { return $8de288a98087a926$export$cfc099c0be5cff67; });
$parcel$export(module.exports, "setPendingChanges", function () { return $8de288a98087a926$export$17dcaa9d506ee1de; });

var $hxM7m = parcelRequire("hxM7m");

var $lJ1OS = parcelRequire("lJ1OS");

var $jbmdS = parcelRequire("jbmdS");
// Initial state
const $8de288a98087a926$var$initialContext = {
    reportData: [],
    organisationReport: null,
    isLoadingReportData: false,
    columns: [],
    pendingChanges: false
};
const $8de288a98087a926$export$8f4685d42ad615c0 = (0, $hxM7m.createStore)({
    context: $8de288a98087a926$var$initialContext,
    on: {
        setOrganisationReport: {
            organisationReport: (_, event)=>event.report,
            pendingChanges: (_, event)=>{
                var _event$options$needsR, _event$options;
                return (_event$options$needsR = (_event$options = event.options) === null || _event$options === void 0 ? void 0 : _event$options.needsRefetch) !== null && _event$options$needsR !== void 0 ? _event$options$needsR : true;
            }
        },
        setReportData: {
            reportData: (_, event)=>event.data
        },
        setIsLoadingReportData: {
            isLoadingReportData: (_, event)=>event.isLoading
        },
        setColumns: {
            organisationReport: (context, event)=>{
                if (!context.organisationReport) return null;
                return {
                    ...context.organisationReport,
                    columns: event.columns
                };
            },
            pendingChanges: (_, event)=>{
                var _event$options$needsR2, _event$options2;
                return (_event$options$needsR2 = (_event$options2 = event.options) === null || _event$options2 === void 0 ? void 0 : _event$options2.needsRefetch) !== null && _event$options$needsR2 !== void 0 ? _event$options$needsR2 : true;
            }
        },
        setPendingChanges: {
            pendingChanges: (_, event)=>event.pending
        }
    }
});
const $8de288a98087a926$export$5937a5b9379177ff = ()=>(0, $lJ1OS.useSelector)($8de288a98087a926$export$8f4685d42ad615c0, (state)=>state.context.reportData);
const $8de288a98087a926$export$30415e21906d195c = ()=>(0, $lJ1OS.useSelector)($8de288a98087a926$export$8f4685d42ad615c0, (state)=>state.context.organisationReport);
const $8de288a98087a926$export$2ea3c65c90de2aa8 = ()=>(0, $lJ1OS.useSelector)($8de288a98087a926$export$8f4685d42ad615c0, (state)=>state.context.isLoadingReportData);
const $8de288a98087a926$export$c97dded465ef56fb = ()=>{
    const report = $8de288a98087a926$export$30415e21906d195c();
    return (0, $jbmdS.useMemo)(()=>{
        var _report$columns;
        return (_report$columns = report === null || report === void 0 ? void 0 : report.columns) !== null && _report$columns !== void 0 ? _report$columns : [];
    }, [
        report
    ]);
};
const $8de288a98087a926$export$b69a3814d0f14d43 = ()=>(0, $lJ1OS.useSelector)($8de288a98087a926$export$8f4685d42ad615c0, (state)=>state.context.pendingChanges);
const $8de288a98087a926$export$447d9eb2f4688ef2 = (report, options)=>$8de288a98087a926$export$8f4685d42ad615c0.send({
        type: "setOrganisationReport",
        report: report,
        options: options
    });
const $8de288a98087a926$export$b4af916732271762 = (data)=>$8de288a98087a926$export$8f4685d42ad615c0.send({
        type: "setReportData",
        data: data
    });
const $8de288a98087a926$export$73b176e19d58db01 = (isLoading)=>$8de288a98087a926$export$8f4685d42ad615c0.send({
        type: "setIsLoadingReportData",
        isLoading: isLoading
    });
const $8de288a98087a926$export$cfc099c0be5cff67 = (columns, options)=>$8de288a98087a926$export$8f4685d42ad615c0.send({
        type: "setColumns",
        columns: columns,
        options: options
    });
const $8de288a98087a926$export$17dcaa9d506ee1de = (pending)=>$8de288a98087a926$export$8f4685d42ad615c0.send({
        type: "setPendingChanges",
        pending: pending
    });

});


parcelRegister("lrcql", function(module, exports) {

$parcel$export(module.exports, "getColumns", function () { return $048a4b07852ccf0f$export$978e30a0fb8610d8; });

var $azaaH = parcelRequire("azaaH");

var $1BTI2 = parcelRequire("1BTI2");

var $8kZ1o = parcelRequire("8kZ1o");

var $38AIP = parcelRequire("38AIP");

var $khCHn = parcelRequire("khCHn");
function $048a4b07852ccf0f$export$978e30a0fb8610d8(onHideColumn) {
    const generateColumnDef = (0, $khCHn.createGenerateColumnDef)({
        onHideColumn: onHideColumn
    });
    const standardSize = 100;
    const wideSize = 240;
    return [
        generateColumnDef({
            key: "actualVsBudgetedHours",
            type: "progressBar",
            title: "Actual / Budgeted Hours",
            size: wideSize,
            aggregationFn: "progressBar"
        }),
        generateColumnDef({
            key: "actualVsBudgetedExpenses",
            type: "progressBar",
            title: "Actual (Cost) / Budgeted Expenses",
            size: wideSize,
            aggregationFn: "progressBar",
            permissions: (row)=>(0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectExpenseBudgets)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "revenueVsFee",
            type: "progressBar",
            title: "Revenue / Fee",
            size: wideSize,
            aggregationFn: "progressBar",
            formatter: (v)=>(0, $azaaH.default).currency(v, {
                    decimals: 0
                }),
            permissions: (row)=>(0, $8kZ1o.canViewProjectFees)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "profit",
            type: "currency",
            title: "Profit (cost + project expenses)",
            permissions: (row)=>(0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectExpenses)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "profitMargin",
            type: "percent",
            title: "Profit margin (cost + project expenses)",
            aggregationFn: "mean",
            permissions: (row)=>(0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectExpenses)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "project",
            type: "project",
            title: "Project"
        }),
        generateColumnDef({
            key: "startDate",
            type: "date",
            title: "Start Date",
            aggregationFn: "min"
        }),
        generateColumnDef({
            key: "endDate",
            type: "date",
            title: "End Date",
            aggregationFn: "max"
        }),
        generateColumnDef({
            key: "fee",
            type: "currency",
            title: "Fee",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewProjectFees)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "expenseBudget",
            type: "currency",
            title: "Expense Budget",
            permissions: (row)=>(0, $8kZ1o.canViewProjectExpenseBudgets)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "costCentre",
            type: "costCentre",
            title: "Cost centre",
            permissions: (row)=>(0, $8kZ1o.canViewCostCentres)((0, $1BTI2.default).user)
        }),
        generateColumnDef({
            key: "contact",
            type: "contact",
            title: "Contact",
            permissions: (row)=>(0, $8kZ1o.canViewContacts)((0, $1BTI2.default).user)
        }),
        generateColumnDef({
            key: "invoiceContact",
            type: "contact",
            title: "Primary Contact",
            permissions: (row)=>(0, $8kZ1o.canViewContacts)((0, $1BTI2.default).user) && (0, $8kZ1o.canViewPrimaryContact)()
        }),
        generateColumnDef({
            key: "owner",
            type: "staffMember",
            title: "Project Owner"
        }),
        generateColumnDef({
            key: "status",
            type: "status",
            title: "Status"
        }),
        generateColumnDef({
            key: "remainingFee",
            type: "currency",
            title: "Remaining fee",
            permissions: (row)=>(0, $8kZ1o.canViewProjectFees)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "remainingExpenseProjectBudget",
            type: "currency",
            title: "Remaining Expense Budget",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewProjectExpenseBudgets)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectExpenses)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "latestEvent",
            type: "date",
            title: "Latest Event",
            size: standardSize
        }),
        generateColumnDef({
            key: "latestNote",
            type: "text",
            title: "Latest Note",
            size: 350,
            permissions: (row)=>(0, $8kZ1o.canViewProjectNotes)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "currentPhases",
            type: "text",
            title: "Current Phases",
            size: standardSize
        }),
        generateColumnDef({
            key: "activePhases",
            type: "text",
            title: "Active Phases",
            size: standardSize
        }),
        generateColumnDef({
            key: "prospectivePhases",
            type: "text",
            title: "Prospective Phases",
            size: standardSize
        }),
        generateColumnDef({
            key: "staffMembers",
            type: "staffs",
            title: "Staff members assigned",
            size: standardSize
        }),
        generateColumnDef({
            key: "progress",
            type: "percent",
            title: "Progress",
            size: standardSize,
            aggregationFn: "mean",
            permissions: (row)=>(0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectFees)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "revenue",
            type: "currency",
            title: "Revenue",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "revenueWithVariations",
            type: "currency",
            title: "Revenue (Variations)",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "revenueWithVariationsReimbursements",
            type: "currency",
            title: "Revenue (Variations + Reimbursements)",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "recordedHours",
            type: "number",
            title: "Recorded Hours",
            size: standardSize
        }),
        generateColumnDef({
            key: "recordedHoursVariation",
            type: "number",
            title: "Recorded Hours (Variation)",
            size: standardSize
        }),
        generateColumnDef({
            key: "hoursBudgeted",
            type: "number",
            title: "Hours budgeted",
            size: standardSize
        }),
        generateColumnDef({
            key: "hoursAllocated",
            type: "number",
            title: "Hours allocated",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewStaffAllocations)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "expenses",
            type: "currency",
            title: "Expenses (cost)",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "projectExpenses",
            type: "currency",
            title: "Project Expenses",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewProjectExpenses)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "billableProjectExpenses",
            type: "currency",
            title: "Billable Project Expenses",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewProjectExpenses)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "allProjectExpenses",
            type: "currency",
            title: "All Project Expenses",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewProjectExpenses)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "expensesVariation",
            type: "currency",
            title: "Expenses (cost) + Variation Cost",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "expensesVariationProject",
            type: "currency",
            title: "Expenses (cost) + Variation Cost + Project Expenses",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectExpenses)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "expensesProject",
            type: "currency",
            title: "Expenses (cost) + Project Expenses",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectExpenses)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "labourExpense",
            type: "currency",
            title: "Labour expense",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewProjectStaffPay)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "chargeOut",
            type: "currency",
            title: "Charge-out",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewProjectStaffChargeOut)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "chargeOutVariation",
            type: "currency",
            title: "Charge-out (Variations)",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewProjectStaffChargeOut)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "actualVsBudgetedHoursVariation",
            type: "progressBar",
            title: "Actual (Variation) / Budgeted Hours",
            size: wideSize,
            aggregationFn: "progressBar"
        }),
        generateColumnDef({
            key: "actualProjectVsBudgetedExpenses",
            type: "progressBar",
            title: "Actual (Cost + Project) / Budgeted Expenses",
            size: wideSize,
            aggregationFn: "progressBar",
            permissions: (row)=>(0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectExpenses)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectExpenseBudgets)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "actualVariationVsBudgetedExpenses",
            type: "progressBar",
            title: "Actual (Cost) / Budgeted Expenses",
            size: wideSize,
            aggregationFn: "progressBar",
            permissions: (row)=>(0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectExpenseBudgets)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "actualVariationProjectVsBudgetedExpenses",
            type: "progressBar",
            title: "Actual (Cost + Variation + Project) / Budgeted Expenses",
            size: wideSize,
            aggregationFn: "progressBar",
            permissions: (row)=>(0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectExpenses)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectExpenseBudgets)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "revenueVsChargeOut",
            type: "progressBar",
            title: "Revenue / Charge Out",
            size: wideSize,
            aggregationFn: "progressBar",
            permissions: (row)=>(0, $8kZ1o.canViewProjectFees)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectStaffChargeOut)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "percentRevenueVsFee",
            type: "percent",
            title: "Percent Revenue / Fee",
            size: standardSize,
            aggregationFn: "mean",
            permissions: (row)=>(0, $8kZ1o.canViewProjectFees)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "costProjectVsFee",
            type: "progressBar",
            title: "Expenses (Cost + Project) / Fee",
            size: wideSize,
            aggregationFn: "progressBar",
            permissions: (row)=>(0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectExpenses)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectFees)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "costVsFee",
            type: "progressBar",
            title: "Expense (cost) / Fee",
            size: wideSize,
            aggregationFn: "progressBar",
            permissions: (row)=>(0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectFees)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "payVsFee",
            type: "progressBar",
            title: "Expense (labour) / Fee",
            size: wideSize,
            aggregationFn: "progressBar",
            permissions: (row)=>(0, $8kZ1o.canViewProjectStaffPay)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectFees)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "chargeOutVsFee",
            type: "progressBar",
            title: "Charge Out / Fee",
            size: wideSize,
            aggregationFn: "progressBar",
            permissions: (row)=>(0, $8kZ1o.canViewProjectStaffChargeOut)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectFees)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "chargeOutVariationVsFee",
            type: "progressBar",
            title: "Charge Out (Variations) / Fee",
            size: wideSize,
            aggregationFn: "progressBar",
            permissions: (row)=>(0, $8kZ1o.canViewProjectStaffChargeOut)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectFees)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "percentOfTotalHours",
            type: "percent",
            title: "Percentage of total hours",
            size: standardSize
        }),
        generateColumnDef({
            key: "percentOfTotalRevenue",
            type: "percent",
            title: "Percentage of total revenue",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "percentOfTotalExpenses",
            type: "percent",
            title: "Percentage of total expenses (cost)",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectExpenses)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "percentOfTotalExpensesLabour",
            type: "percent",
            title: "Percentage of total expenses (labour)",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewProjectStaffPay)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "profitCost",
            type: "currency",
            title: "Profit (cost)",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "profitLabour",
            type: "currency",
            title: "Profit (labour)",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectStaffPay)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "profitFee",
            type: "currency",
            title: "Profit (fee)",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewProjectFees)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectExpenses)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "profitFeeVariation",
            type: "currency",
            title: "Profit (fee, variation & project expenses)",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewProjectFees)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectExpenses)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "profitCostVariationProject",
            type: "currency",
            title: "Profit (cost, variation & project expenses)",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectExpenses)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "profitMarginCost",
            type: "percent",
            title: "Profit margin (cost)",
            size: standardSize,
            aggregationFn: "mean",
            permissions: (row)=>(0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "profitMarginLabour",
            type: "percent",
            title: "Profit margin (labour)",
            size: standardSize,
            aggregationFn: "mean",
            permissions: (row)=>(0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectStaffPay)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "profitMarginFee",
            type: "percent",
            title: "Profit margin (fee)",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewProjectFees)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectExpenses)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "profitMarginFeeVariation",
            type: "percent",
            title: "Profit margin (fee, variation & project expenses)",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewProjectFees)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectExpenses)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "netMultiplier",
            type: "number",
            title: "Net Multiplier",
            size: standardSize,
            aggregationFn: "mean",
            permissions: (row)=>(0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectExpenses)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "markup",
            type: "percent",
            title: "Markup (cost + project expenses)",
            size: standardSize,
            aggregationFn: "mean",
            permissions: (row)=>(0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectExpenses)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "markupCost",
            type: "percent",
            title: "Markup (cost)",
            size: standardSize,
            aggregationFn: "mean",
            permissions: (row)=>(0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "markupLabour",
            type: "percent",
            title: "Markup (labour)",
            size: standardSize,
            aggregationFn: "mean",
            permissions: (row)=>(0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectStaffPay)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "revenuePerHour",
            type: "currency",
            title: "Revenue per hour",
            size: standardSize,
            aggregationFn: "mean",
            permissions: (row)=>(0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "revenueVariationPerHour",
            type: "currency",
            title: "Revenue per hour (variations)",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "revenueVariationReimbursementPerHour",
            type: "currency",
            title: "Revenue per hour (variations + reimbursements)",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "completionDate",
            type: "date",
            title: "Completion date",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewProjectFees)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "latestInvoicedPhases",
            type: "text",
            title: "Latest Invoiced Phases",
            size: 150,
            permissions: (row)=>(0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, row)
        }),
        generateColumnDef({
            key: "latestRevenueDate",
            type: "date",
            title: "Latest Revenue Date",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, row)
        }),
        generateColumnDef({
            key: "latestTimeEntryDate",
            type: "date",
            title: "Latest Time Entry Date",
            size: standardSize
        }),
        generateColumnDef({
            key: "latestTimeEntryDateInRange",
            type: "date",
            title: "Latest Time Entry Date In Range",
            size: standardSize
        }),
        generateColumnDef({
            key: "projectedHours",
            type: "number",
            title: "Projected Hours",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewStaffAllocations)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "futureHours",
            type: "number",
            title: "Future Hours",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewStaffAllocations)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "futureLabour",
            type: "currency",
            title: "Future Labour Expense",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewStaffAllocations)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectStaffPay)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "futureCost",
            type: "currency",
            title: "Future Expense",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewStaffAllocations)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "futureChargeOut",
            type: "currency",
            title: "Future Charge Out",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewStaffAllocations)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectStaffChargeOut)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "futureRevenue",
            type: "currency",
            title: "Future Revenue",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewRevenueTargets)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "projectedRevenue",
            type: "currency",
            title: "Projected Revenue",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewRevenueTargets)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "projectedExpense",
            type: "currency",
            title: "Projected Expense (Cost)",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewStaffAllocations)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "projectedLabourExpense",
            type: "currency",
            title: "Projected Labour Expense",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewStaffAllocations)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectStaffPay)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "projectedChargeOut",
            type: "currency",
            title: "Projected Charge Out",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewStaffAllocations)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectStaffChargeOut)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "projectedProfit",
            type: "currency",
            title: "Projected Profit",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewRevenueTargets)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewStaffAllocations)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "projectedProfitMargin",
            type: "percent",
            title: "Projected Profit Margin",
            size: standardSize,
            aggregationFn: "mean",
            permissions: (row)=>(0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewRevenueTargets)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewStaffAllocations)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "profitVariationProject",
            type: "currency",
            title: "Profit (Cost + Variation + Project)",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectExpenses)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "profitMarginVariationProject",
            type: "percent",
            title: "Profit Margin (Cost + Variation + Project)",
            size: standardSize,
            aggregationFn: "mean",
            permissions: (row)=>(0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectExpenses)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "markupVariationProject",
            type: "percent",
            title: "Markup (Cost + Variation + Project)",
            size: standardSize,
            aggregationFn: "mean",
            permissions: (row)=>(0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectExpenses)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "expenseVsRevenueVariationProject",
            type: "progressBar",
            title: "Expenses / Revenue (Cost + Variation + Project)",
            size: wideSize,
            aggregationFn: "progressBar",
            formatter: (v)=>(0, $azaaH.default).currency(v, {
                    decimals: 0
                }),
            permissions: (row)=>(0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectExpenses)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "revenueVsExpenseVariationProject",
            type: "progressBar",
            title: "Revenue / Expenses (Cost + Variation + Project)",
            size: wideSize,
            aggregationFn: "progressBar",
            formatter: (v)=>(0, $azaaH.default).currency(v, {
                    decimals: 0
                }),
            permissions: (row)=>(0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectExpenses)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "profitVsRevenueVariationProject",
            type: "progressBar",
            title: "Profit / Revenue (Cost + Variation + Project)",
            size: wideSize,
            aggregationFn: "progressBar",
            formatter: (v)=>(0, $azaaH.default).currency(v, {
                    decimals: 0
                }),
            permissions: (row)=>(0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectExpenses)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "profitVsExpenseVariationProject",
            type: "progressBar",
            title: "Profit / Expenses (Cost + Variation + Project)",
            size: wideSize,
            aggregationFn: "progressBar",
            formatter: (v)=>(0, $azaaH.default).currency(v, {
                    decimals: 0
                }),
            permissions: (row)=>(0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectExpenses)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "serviceFee",
            type: "currency",
            title: "Service Fee",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewProjectFees)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectExpenses)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "serviceProfit",
            type: "currency",
            title: "Service Profit",
            size: standardSize,
            permissions: (row)=>(0, $8kZ1o.canViewProjectFees)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectExpenses)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        }),
        generateColumnDef({
            key: "serviceProfitMargin",
            type: "percent",
            title: "Service Profit Margin",
            size: standardSize,
            aggregationFn: "mean",
            permissions: (row)=>(0, $8kZ1o.canViewProjectFees)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row) && (0, $8kZ1o.canViewProjectExpenses)((0, $1BTI2.default).user, (0, $38AIP.getCacheItemById)("projects", row === null || row === void 0 ? void 0 : row.projectId) || row)
        })
    ];
}

});




parcelRegister("eAAaV", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $a9f07d1d2cd7f509$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");

var $8mqHH = parcelRequire("8mqHH");

var $ePViA = parcelRequire("ePViA");

var $kuPRw = parcelRequire("kuPRw");

var $47i9t = parcelRequire("47i9t");

var $4iw5i = parcelRequire("4iw5i");

var $5PXcS = parcelRequire("5PXcS");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $7qobO = parcelRequire("7qobO");

var $kqntg = parcelRequire("kqntg");

var $26sX2 = parcelRequire("26sX2");

var $3h7sC = parcelRequire("3h7sC");
const $a9f07d1d2cd7f509$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_private/permissions/")({
    beforeLoad: ({ params: params })=>{
        if (!(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "staff-permissions", params)) throw new Error("Permission Denied");
        (0, $26sX2.setLayoutDefaults)({
            pageTitle: "Permissions",
            subMenu: "resources"
        });
    },
    errorComponent: ({ error: error, reset: reset })=>{
        if (error.message === "Permission Denied") return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7qobO.default), {});
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    },
    loader: async ()=>await $a9f07d1d2cd7f509$var$loader(),
    pendingComponent: (0, $4iw5i.default),
    component: $a9f07d1d2cd7f509$var$Wrapper
});
const $a9f07d1d2cd7f509$var$loader = async ()=>{
    const data = await (0, $3h7sC.trpc).legacy.getPermissionsListPageData.query();
    return (0, $47i9t.processTRPCData)(data);
};
function $a9f07d1d2cd7f509$var$Wrapper() {
    if ((0, $8kZ1o.migratedToV2)()) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqntg.CenterPadPageBody), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ePViA.default), {})
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8mqHH.default), {}),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kuPRw.default), {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ePViA.default), {})
            })
        ]
    });
}

});
parcelRegister("8mqHH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6165179a56eca1f4$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $5JL5P = parcelRequire("5JL5P");

var $36Jjh = parcelRequire("36Jjh");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $6UBLf = parcelRequire("6UBLf");
var $6165179a56eca1f4$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(()=>{
    const navigate = (0, $6UBLf.useNavigate)();
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $36Jjh.default), {
        heading: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: "Permissions"
            })
        }),
        extraContent: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            className: "mt-6",
            children: (0, $8kZ1o.canEditStaff)((0, $1BTI2.default).user) ? [
                /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                    className: "project-list__add-new-project-button page-header__button--primary plus-btn",
                    onClick: ()=>{
                        const permission = (0, $5JL5P.default).createPermission();
                        navigate({
                            to: "/permissions/$id",
                            params: {
                                id: permission.id
                            }
                        });
                    },
                    children: "+ New Permission"
                }, 0)
            ] : null
        })
    });
});

});

parcelRegister("ePViA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $acd24673305aae4e$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $goLmS = parcelRequire("goLmS");

var $kqlQp = parcelRequire("kqlQp");

var $5JL5P = parcelRequire("5JL5P");

var $1BTI2 = parcelRequire("1BTI2");
const $acd24673305aae4e$var$columns = [
    {
        id: "label",
        label: "Label",
        type: "text",
        width: 25,
        value: (row)=>{
            return row.name;
        },
        component: ({ value: value, stores: stores })=>{
            const { row: row } = stores;
            return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqlQp.Link), {
                        to: `/permissions/${row.rowObject.id}`,
                        children: value
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                        children: row.rowObject.id === (0, $1BTI2.default).organisation.defaultPermissionsId ? " (Default)" : null
                    })
                ]
            });
        }
    }
];
var $acd24673305aae4e$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(()=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
            columns: $acd24673305aae4e$var$columns,
            rows: (0, $5JL5P.default).permissions,
            sortBy: [
                [
                    "label",
                    "asc"
                ]
            ]
        })
    });
});

});


parcelRegister("lB9TH", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $fb94bb169f21ce65$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");

var $8lsou = parcelRequire("8lsou");

var $7kpOS = parcelRequire("7kpOS");

var $kuPRw = parcelRequire("kuPRw");

var $1BTI2 = parcelRequire("1BTI2");

var $4iw5i = parcelRequire("4iw5i");

var $5PXcS = parcelRequire("5PXcS");

var $8kZ1o = parcelRequire("8kZ1o");

var $7qobO = parcelRequire("7qobO");

var $26sX2 = parcelRequire("26sX2");

var $38AIP = parcelRequire("38AIP");

var $bskH6 = parcelRequire("bskH6");

var $3h7sC = parcelRequire("3h7sC");

var $lvlQM = parcelRequire("lvlQM");

var $dQmGn = parcelRequire("dQmGn");

var $cnmvx = parcelRequire("cnmvx");

var $6Q5sp = parcelRequire("6Q5sp");

var $4hBm1 = parcelRequire("4hBm1");

var $kqntg = parcelRequire("kqntg");

var $47i9t = parcelRequire("47i9t");
const $fb94bb169f21ce65$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_private/invoices/")({
    beforeLoad: ({ params: params, search: search })=>{
        if (!(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "invoiceList", params)) throw new Error("Permission Denied");
        const report = (0, $38AIP.getCacheItemById)("organisationReports", search.report);
        (0, $26sX2.setLayoutDefaults)({
            pageTitle: (report === null || report === void 0 ? void 0 : report.name) || "Invoice Report",
            subMenu: "invoices"
        });
    },
    errorComponent: ({ error: error, reset: reset })=>{
        if (error.message === "Permission Denied") return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7qobO.default), {});
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    },
    loader: async ({ location: location })=>await $fb94bb169f21ce65$var$loader(location.search),
    loaderDeps: ({ search: { report: report } })=>({
            report: report
        }),
    pendingComponent: (0, $4iw5i.default),
    component: $fb94bb169f21ce65$var$Wrapper
});
const $fb94bb169f21ce65$var$loader = async ({ report: report })=>{
    var _SessionStore$organis;
    const reportId = report || ((_SessionStore$organis = (0, $1BTI2.default).organisation) === null || _SessionStore$organis === void 0 ? void 0 : _SessionStore$organis.defaultInvoiceReportId);
    if ((0, $8kZ1o.migratedToV2)()) {
        var _organisationReport$o;
        const res = reportId ? await (0, $3h7sC.trpc).invoiceReport.getOrganisationReport.query({
            reportId: reportId
        }) : null;
        const organisationReport = res || (0, $1BTI2.default).organisation.defaultInvoiceReport;
        let dateRange = [
            null,
            null
        ];
        if ((_organisationReport$o = organisationReport.options) !== null && _organisationReport$o !== void 0 && _organisationReport$o.dateRange) {
            var _dateStringLookup$org, _organisationReport$o2, _organisationReport$o3, _organisationReport$o4;
            dateRange = ((_dateStringLookup$org = (0, $cnmvx.dateStringLookup)[(_organisationReport$o2 = organisationReport.options) === null || _organisationReport$o2 === void 0 ? void 0 : _organisationReport$o2.dateRange]) === null || _dateStringLookup$org === void 0 ? void 0 : _dateStringLookup$org.call((0, $cnmvx.dateStringLookup), (_organisationReport$o3 = organisationReport.options) === null || _organisationReport$o3 === void 0 ? void 0 : _organisationReport$o3.fortnightType)) || ((_organisationReport$o4 = organisationReport.options) === null || _organisationReport$o4 === void 0 ? void 0 : _organisationReport$o4.dateRange);
        }
        const { columns: columns, filters: filters, groupBy: groupBy, sortBy: sortBy, options: options, name: name } = organisationReport;
        (0, $bskH6.setOrganisationReport)({
            columns: columns,
            filters: filters,
            groupBy: groupBy,
            organisationId: (0, $1BTI2.default).organisationId,
            sortBy: sortBy,
            dateRange: dateRange,
            invoiceDateType: (0, $1BTI2.default).settings.reportInvoiceDateType,
            id: reportId,
            options: options,
            name: name
        }, {
            needsRefetch: false
        });
        const cacheData = await (0, $6Q5sp.queryClient).fetchQuery({
            queryKey: [
                "invoiceReportCache",
                reportId
            ],
            queryFn: ()=>{
                var _SessionStore$user;
                return (0, $3h7sC.trpc).invoiceReport.getReportsData.query({
                    organisationId: (0, $1BTI2.default).organisationId,
                    userId: (_SessionStore$user = (0, $1BTI2.default).user) === null || _SessionStore$user === void 0 ? void 0 : _SessionStore$user.id,
                    columns: organisationReport === null || organisationReport === void 0 ? void 0 : organisationReport.columns.filter((c)=>{
                        var _InvoiceReportColumns;
                        return !((_InvoiceReportColumns = (0, $lvlQM.InvoiceReportColumns)(reportId)[c]) !== null && _InvoiceReportColumns !== void 0 && _InvoiceReportColumns.permissions) || (0, $lvlQM.InvoiceReportColumns)(reportId)[c].permissions();
                    }),
                    filters: organisationReport === null || organisationReport === void 0 ? void 0 : organisationReport.filters.map((f)=>{
                        var _InvoiceReportColumns2, _InvoiceReportColumns3;
                        if (((_InvoiceReportColumns2 = (0, $lvlQM.InvoiceReportColumns)(reportId)[f.column]) === null || _InvoiceReportColumns2 === void 0 ? void 0 : _InvoiceReportColumns2.type) === "date") {
                            var _dateStringLookup$f$v;
                            let value = ((_dateStringLookup$f$v = (0, $cnmvx.dateStringLookup)[f.value]) === null || _dateStringLookup$f$v === void 0 ? void 0 : _dateStringLookup$f$v.call((0, $cnmvx.dateStringLookup))) || f.value;
                            if (Array.isArray(value)) value = value.map((d)=>d ? (0, $4hBm1.format)(d, "yyyy-MM-dd") : null);
                            else value = value ? (0, $4hBm1.format)(value, "yyyy-MM-dd") : null;
                            return {
                                ...f,
                                value: value
                            };
                        } else if (((_InvoiceReportColumns3 = (0, $lvlQM.InvoiceReportColumns)(reportId)[f.column]) === null || _InvoiceReportColumns3 === void 0 ? void 0 : _InvoiceReportColumns3.type) === "invoice") {
                            let value = f.value;
                            if (Array.isArray(value)) value = value.map((d)=>{
                                d = new Date(d);
                                return d && d.getTime() ? (0, $4hBm1.format)(d, "yyyy-MM-dd HH:mm") : null;
                            });
                            else {
                                value = new Date(value);
                                value = value && value.getTime() ? (0, $4hBm1.format)(value, "yyyy-MM-dd HH:mm") : null;
                            }
                            return {
                                ...f,
                                value: value
                            };
                        } else return f;
                    }),
                    sortBy: (organisationReport === null || organisationReport === void 0 ? void 0 : organisationReport.sortBy) || [],
                    groupBy: (organisationReport === null || organisationReport === void 0 ? void 0 : organisationReport.groupBy) || [],
                    dateRange: dateRange,
                    invoiceDateType: (0, $1BTI2.default).settings.reportInvoiceDateType
                });
            },
            staleTime: 300000
        });
        (0, $bskH6.setReportData)(cacheData);
    }
    const data = await (0, $3h7sC.trpc).legacy.getInvoiceListPageData.query({
        reportId: reportId
    });
    return (0, $47i9t.processTRPCData)(data);
};
function $fb94bb169f21ce65$var$Wrapper() {
    const { report: report } = $fb94bb169f21ce65$export$e7b0ac011bb776c6.useSearch();
    if ((0, $8kZ1o.migratedToV2)()) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqntg.PageBody), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $dQmGn.InvoiceReportsPageV2), {})
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8lsou.default), {
                id: report
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kuPRw.default), {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7kpOS.default), {
                    id: report
                })
            })
        ]
    });
}

});
parcelRegister("8lsou", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61364f5ec81cc9e1$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $36Jjh = parcelRequire("36Jjh");

var $h6zQv = parcelRequire("h6zQv");

var $1BTI2 = parcelRequire("1BTI2");

var $khJQv = parcelRequire("khJQv");

var $jr4Q7 = parcelRequire("jr4Q7");

var $afeg2 = parcelRequire("afeg2");

var $8kZ1o = parcelRequire("8kZ1o");

var $4hBm1 = parcelRequire("4hBm1");

var $3X7oM = parcelRequire("3X7oM");
var $61364f5ec81cc9e1$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ id: id })=>{
    const report = (0, $h6zQv.default).reportsById[id] || (0, $1BTI2.default).organisation.defaultInvoiceReport;
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $36Jjh.default), {
        heading: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    children: "Invoices"
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    className: "text-sm font-normal px-2.5 py-1.5",
                    children: isFinite(report.dateRange[0]) ? `(${(0, $4hBm1.format)(report.dateRange[0], "dd MMMM yyyy")} - ${(0, $4hBm1.format)(report.dateRange[1], "dd MMMM yyyy")})` : `(All time prior to: ${(0, $4hBm1.format)(new Date(), "dd MMMM yyyy")})`
                })
            ]
        }),
        leftButtons: [
            (0, $8kZ1o.canCreateInvoices)((0, $1BTI2.default).user) ? /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                className: "project-list__add-new-project-button page-header__button--primary plus-btn",
                onClick: ()=>{
                    (0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $afeg2.default), {
                        modalId: "new-invoice"
                    }));
                },
                children: "+ New Invoice"
            }, 0) : null
        ],
        rightButtons: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            className: "flex items-center gap-2",
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3X7oM.default), {
                    label: "Export",
                    onClick: ()=>report.downloadCSV(),
                    icon: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                        className: "fa fa-table"
                    })
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3X7oM.default), {
                    label: "Print",
                    onClick: ()=>window.print(),
                    icon: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                        className: "fa fa-print"
                    })
                })
            ]
        }),
        filter: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jr4Q7.ReportSearch), {
            report: report,
            placeholder: "Filter by Invoice / Project"
        }),
        extraContent: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jr4Q7.default), {
            report: report,
            reportOptions: (0, $h6zQv.default).reportsByType["invoice"],
            baseUrl: "/invoice"
        })
    });
});

});

parcelRegister("7kpOS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $555e6de8567d25f5$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $4iw5i = parcelRequire("4iw5i");

var $goLmS = parcelRequire("goLmS");

var $h6zQv = parcelRequire("h6zQv");

var $1BTI2 = parcelRequire("1BTI2");

var $6RcUP = parcelRequire("6RcUP");

var $3erXY = parcelRequire("3erXY");

var $3h7sC = parcelRequire("3h7sC");

var $47i9t = parcelRequire("47i9t");

var $4hBm1 = parcelRequire("4hBm1");

var $cnmvx = parcelRequire("cnmvx");
var $555e6de8567d25f5$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ id: id })=>{
    const report = (0, $h6zQv.default).reportsById[id] || (0, $1BTI2.default).organisation.defaultInvoiceReport;
    const [queryData, setQueryData] = (0, $jbmdS.useState)([]);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $6RcUP.default), {
        loading: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $4iw5i.default), {}),
        queryIds: [
            {
                id: "invoiceReport" + report.queryKey,
                cacheTime: 5000,
                staleTime: 5000,
                queryFn: async ()=>{
                    const data = await (0, $3h7sC.trpc).invoiceReport.getReportsData.query({
                        columns: report.columns.filter((c)=>{
                            var _report$columnOptions;
                            return !((_report$columnOptions = report.columnOptionsById[c]) !== null && _report$columnOptions !== void 0 && _report$columnOptions.permissions) || report.columnOptionsById[c].permissions();
                        }),
                        filters: report.filters.map((f)=>{
                            var _report$columnOptions2;
                            if (((_report$columnOptions2 = report.columnOptionsById[f.column]) === null || _report$columnOptions2 === void 0 ? void 0 : _report$columnOptions2.type) === "date") {
                                var _dateStringLookup$f$v;
                                let value = ((_dateStringLookup$f$v = (0, $cnmvx.dateStringLookup)[f.value]) === null || _dateStringLookup$f$v === void 0 ? void 0 : _dateStringLookup$f$v.call((0, $cnmvx.dateStringLookup))) || f.value;
                                if (Array.isArray(value)) value = value.map((d)=>d ? (0, $4hBm1.format)(d, "yyyy-MM-dd") : null);
                                else value = value ? (0, $4hBm1.format)(value, "yyyy-MM-dd") : null;
                                return {
                                    ...f,
                                    value: value
                                };
                            } else return f;
                        }),
                        groupBy: [],
                        sortBy: report.sortBy || [],
                        dateRange: report.dateRange.map((d)=>isFinite(d) ? (0, $4hBm1.format)(d, "yyyy-MM-dd") : null),
                        invoiceDateType: (0, $1BTI2.default).settings.reportInvoiceDateType
                    });
                    setQueryData((0, $47i9t.processTRPCData)(data));
                    return queryData;
                }
            }
        ],
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3erXY.default), {
                report: report
            }),
            !(report !== null && report !== void 0 && report.needsUpdate) ? /*#__PURE__*/ (0, $61Ea1.jsx)($555e6de8567d25f5$var$InvoiceListTable, {
                report: report,
                queryData: queryData
            }) : null
        ]
    }, report.queryKey);
});
const $555e6de8567d25f5$var$InvoiceListTable = (0, $1EEMt.observer)(({ report: report, queryData: queryData })=>{
    const rows = (0, $jbmdS.useMemo)(()=>{
        const rowData = [];
        queryData === null || queryData === void 0 || queryData.forEach((invoice)=>{
            delete invoice.id;
            if (invoice.ref && invoice.ref.toLowerCase().includes(report.searchFilter.toLowerCase()) || invoice.project && invoice.project.toLowerCase().includes(report.searchFilter.toLowerCase())) rowData.push(invoice);
        });
        return rowData;
    }, [
        queryData,
        report.searchFilter
    ]);
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
        tableStore: report.tableStore,
        columns: report.tableColumns,
        rows: rows,
        sortBy: [
            [
                "issuedOn",
                "desc"
            ],
            [
                "description",
                "desc"
            ]
        ],
        showTotals: true
    }, report.queryKey);
});

});

parcelRegister("bskH6", function(module, exports) {

$parcel$export(module.exports, "setOrganisationReport", function () { return $1491b7459a24eb05$export$447d9eb2f4688ef2; });
$parcel$export(module.exports, "setReportData", function () { return $1491b7459a24eb05$export$b4af916732271762; });
$parcel$export(module.exports, "setIsLoadingReportData", function () { return $1491b7459a24eb05$export$73b176e19d58db01; });
$parcel$export(module.exports, "setColumns", function () { return $1491b7459a24eb05$export$cfc099c0be5cff67; });
$parcel$export(module.exports, "setPendingChanges", function () { return $1491b7459a24eb05$export$17dcaa9d506ee1de; });
$parcel$export(module.exports, "useReportData", function () { return $1491b7459a24eb05$export$5937a5b9379177ff; });
$parcel$export(module.exports, "useOrganisationReport", function () { return $1491b7459a24eb05$export$30415e21906d195c; });
$parcel$export(module.exports, "useIsLoadingReportData", function () { return $1491b7459a24eb05$export$2ea3c65c90de2aa8; });
$parcel$export(module.exports, "usePendingChanges", function () { return $1491b7459a24eb05$export$b69a3814d0f14d43; });

var $hxM7m = parcelRequire("hxM7m");

var $lJ1OS = parcelRequire("lJ1OS");

var $jbmdS = parcelRequire("jbmdS");
// Initial state
const $1491b7459a24eb05$var$initialContext = {
    reportData: null,
    organisationReport: null,
    isLoadingReportData: false,
    columns: null,
    pendingChanges: false
};
const $1491b7459a24eb05$export$253bb29e6019dab7 = (0, $hxM7m.createStore)({
    context: $1491b7459a24eb05$var$initialContext,
    on: {
        setOrganisationReport: {
            organisationReport: (_, event)=>event.report,
            pendingChanges: (_, event)=>{
                var _event$options$needsR, _event$options;
                return (_event$options$needsR = (_event$options = event.options) === null || _event$options === void 0 ? void 0 : _event$options.needsRefetch) !== null && _event$options$needsR !== void 0 ? _event$options$needsR : true;
            }
        },
        setReportData: {
            reportData: (_, event)=>event.data
        },
        setIsLoadingReportData: {
            isLoadingReportData: (_, event)=>event.isLoading
        },
        setColumns: {
            organisationReport: (context, event)=>context.organisationReport ? {
                    ...context.organisationReport,
                    columns: event.columns
                } : null,
            pendingChanges: (_, event)=>{
                var _event$options$needsR2, _event$options2;
                return (_event$options$needsR2 = (_event$options2 = event.options) === null || _event$options2 === void 0 ? void 0 : _event$options2.needsRefetch) !== null && _event$options$needsR2 !== void 0 ? _event$options$needsR2 : true;
            }
        },
        setPendingChanges: {
            pendingChanges: (_, event)=>event.pending
        }
    }
});
const $1491b7459a24eb05$export$447d9eb2f4688ef2 = (report, options = {
    needsRefetch: true
})=>$1491b7459a24eb05$export$253bb29e6019dab7.send({
        type: "setOrganisationReport",
        report: report,
        options: options
    });
const $1491b7459a24eb05$export$b4af916732271762 = (data)=>$1491b7459a24eb05$export$253bb29e6019dab7.send({
        type: "setReportData",
        data: data
    });
const $1491b7459a24eb05$export$73b176e19d58db01 = (isLoading)=>$1491b7459a24eb05$export$253bb29e6019dab7.send({
        type: "setIsLoadingReportData",
        isLoading: isLoading
    });
const $1491b7459a24eb05$export$cfc099c0be5cff67 = (columns, options = {
    needsRefetch: true
})=>$1491b7459a24eb05$export$253bb29e6019dab7.send({
        type: "setColumns",
        columns: columns,
        options: options
    });
const $1491b7459a24eb05$export$17dcaa9d506ee1de = (pending)=>$1491b7459a24eb05$export$253bb29e6019dab7.send({
        type: "setPendingChanges",
        pending: pending
    });
const $1491b7459a24eb05$export$5937a5b9379177ff = ()=>(0, $lJ1OS.useSelector)($1491b7459a24eb05$export$253bb29e6019dab7, (state)=>state.context.reportData);
const $1491b7459a24eb05$export$30415e21906d195c = ()=>(0, $lJ1OS.useSelector)($1491b7459a24eb05$export$253bb29e6019dab7, (state)=>state.context.organisationReport);
const $1491b7459a24eb05$export$2ea3c65c90de2aa8 = ()=>(0, $lJ1OS.useSelector)($1491b7459a24eb05$export$253bb29e6019dab7, (state)=>state.context.isLoadingReportData);
const $1491b7459a24eb05$export$c97dded465ef56fb = ()=>{
    const organisationReport = $1491b7459a24eb05$export$30415e21906d195c();
    return (0, $jbmdS.useMemo)(()=>{
        var _organisationReport$c;
        return (_organisationReport$c = organisationReport === null || organisationReport === void 0 ? void 0 : organisationReport.columns) !== null && _organisationReport$c !== void 0 ? _organisationReport$c : null;
    }, [
        organisationReport
    ]);
};
const $1491b7459a24eb05$export$b69a3814d0f14d43 = ()=>(0, $lJ1OS.useSelector)($1491b7459a24eb05$export$253bb29e6019dab7, (state)=>state.context.pendingChanges);
const $1491b7459a24eb05$export$fb18f5a89a479f8e = ()=>$1491b7459a24eb05$export$253bb29e6019dab7.getSnapshot().context.reportData;
const $1491b7459a24eb05$export$6fcab24359f687f6 = ()=>$1491b7459a24eb05$export$253bb29e6019dab7.getSnapshot().context.organisationReport;
const $1491b7459a24eb05$export$978e30a0fb8610d8 = ()=>{
    var _invoiceReportStore$g, _invoiceReportStore$g2;
    return (_invoiceReportStore$g = (_invoiceReportStore$g2 = $1491b7459a24eb05$export$253bb29e6019dab7.getSnapshot().context.organisationReport) === null || _invoiceReportStore$g2 === void 0 ? void 0 : _invoiceReportStore$g2.columns) !== null && _invoiceReportStore$g !== void 0 ? _invoiceReportStore$g : null;
};

});

parcelRegister("lvlQM", function(module, exports) {

$parcel$export(module.exports, "InvoiceReportColumns", function () { return $040a48051cc76634$export$6a18a24ce908699c; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("eat5C");
parcelRequire("jbmdS");

var $8kZ1o = parcelRequire("8kZ1o");

var $kqlQp = parcelRequire("kqlQp");
const $040a48051cc76634$export$6a18a24ce908699c = (report)=>({
        description: {
            id: "description",
            label: "Invoice #",
            type: "text",
            width: 15,
            value: (row)=>row.ref,
            component: ({ value: value, stores: stores })=>{
                const { row: row } = stores;
                return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    children: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $kqlQp.Link), {
                        to: `/invoices/${row.rowObject.invoiceId || row.rowObject.id}`,
                        children: [
                            " ",
                            value
                        ]
                    })
                });
            }
        },
        issuedOn: {
            id: "issuedOn",
            label: "Issue Date",
            type: "date",
            width: 10,
            value: (row)=>row.issuedOn ? new Date(row.issuedOn) : null
        },
        dueDate: {
            id: "dueDate",
            label: "Due Date",
            type: "date",
            width: 10,
            value: (row)=>row.dueDate ? new Date(row.dueDate) : null
        },
        startDate: {
            id: "startDate",
            label: "Work Start Date",
            type: "date",
            width: 10,
            value: (row)=>row.startDate ? new Date(row.startDate) : null
        },
        endDate: {
            id: "endDate",
            label: "Work End Date",
            type: "date",
            width: 10,
            value: (row)=>row.endDate ? new Date(row.endDate) : null
        },
        createdAt: {
            id: "createdAt",
            label: "Creation Date",
            type: "date",
            width: 10,
            value: (row)=>row.createdAt ? new Date(row.createdAt) : null
        },
        project: {
            id: "project",
            label: "Project",
            type: "project",
            width: 20,
            value: (row)=>row.project,
            format: (project)=>{
                return project;
            }
        },
        projectTitle: {
            id: "projectTitle",
            label: "Project Title",
            type: "text",
            width: 20,
            visible: false,
            value: (row)=>row.project
        },
        contact: {
            id: "contact",
            label: "Client",
            type: "contact",
            width: 20,
            value: (row)=>row.contact,
            format: (contact)=>contact
        },
        projectContact: {
            id: "projectContact",
            label: "Project Client",
            type: "contact",
            width: 20,
            value: (row)=>row.contact,
            format: (contact)=>contact
        },
        projectOwner: {
            id: "projectOwner",
            label: "Project Owner",
            type: "staffMember",
            width: 20,
            value: (row)=>row.projectOwner,
            format: (staff)=>staff
        },
        projectPrimaryContact: {
            id: "projectPrimaryContact",
            label: "Project Primary Contact",
            type: "contact",
            width: 20,
            value: (row)=>row.projectPrimaryContact,
            format: (contact)=>contact,
            permissions: (row)=>(0, $8kZ1o.canViewPrimaryContact)()
        },
        costCentre: {
            id: "costCentre",
            label: "Cost Centre",
            type: "costCentre",
            width: 15,
            value: (row)=>row.costCentre,
            format: (costCentre)=>costCentre
        },
        amountExTax: {
            id: "amountExTax",
            label: "Amount exc. Tax",
            type: "currency",
            width: 10,
            value: (row)=>row.amountExTax
        },
        amountIncTax: {
            id: "amountIncTax",
            label: "Amount inc. Tax",
            type: "currency",
            width: 10,
            value: (row)=>row.amountIncTax
        },
        amountTax: {
            id: "amountTax",
            label: "Tax Amount",
            type: "currency",
            width: 10,
            value: (row)=>row.amountTax
        },
        agreedFeeExTax: {
            id: "agreedFeeExTax",
            label: "Agreed Fee Amount exc. Tax",
            type: "currency",
            width: 10,
            value: (row)=>row.agreedFeeExTax
        },
        variationExTax: {
            id: "variationExTax",
            label: "Variation Amount exc. Tax",
            type: "currency",
            width: 10,
            value: (row)=>row.variationExTax
        },
        agreedFeeVariationExTax: {
            id: "agreedFeeVariationExTax",
            label: "Agreed Fee + Variation Amount exc. Tax",
            type: "currency",
            width: 10,
            value: (row)=>row.agreedFeeVariationExTax
        },
        reimbursementExTax: {
            id: "reimbursementExTax",
            label: "Reimbursement Amount exc. Tax",
            type: "currency",
            width: 10,
            value: (row)=>row.reimbursementExTax
        },
        agreedFeeTax: {
            id: "agreedFeeTax",
            label: "Agreed Fee Tax",
            type: "currency",
            width: 10,
            value: (row)=>row.agreedFeeTax
        },
        variationTax: {
            id: "variationTax",
            label: "Variation Tax",
            type: "currency",
            width: 10,
            value: (row)=>row.variationTax
        },
        agreedFeeVariationTax: {
            id: "agreedFeeVariationTax",
            label: "Agreed Fee + Variation Tax",
            type: "currency",
            width: 10,
            value: (row)=>row.agreedFeeVariationTax
        },
        reimbursementTax: {
            id: "reimbursementTax",
            label: "Reimbursement Tax",
            type: "currency",
            width: 10,
            value: (row)=>row.reimbursementTax
        },
        agreedFeeIncTax: {
            id: "agreedFeeIncTax",
            label: "Agreed Fee Amount inc. Tax",
            type: "currency",
            width: 10,
            value: (row)=>row.agreedFeeIncTax
        },
        variationIncTax: {
            id: "variationIncTax",
            label: "Variation Amount inc. Tax",
            type: "currency",
            width: 10,
            value: (row)=>row.variationIncTax
        },
        agreedFeeVariationIncTax: {
            id: "agreedFeeVariationIncTax",
            label: "Agreed Fee + Variation Amount inc. Tax",
            type: "currency",
            width: 10,
            value: (row)=>row.agreedFeeVariationIncTax
        },
        reimbursementIncTax: {
            id: "reimbursementIncTax",
            label: "Reimbursement Amount inc. Tax",
            type: "currency",
            width: 10,
            value: (row)=>row.reimbursementIncTax
        },
        synced: {
            id: "synced",
            label: "Synced",
            type: "boolean",
            width: 10,
            value: (row)=>row.synced
        },
        projectStatus: {
            id: "projectStatus",
            label: "Project Status",
            type: "status",
            width: 10,
            value: (row)=>row.projectStatus || "archived"
        }
    });

});

parcelRegister("dQmGn", function(module, exports) {

$parcel$export(module.exports, "InvoiceReportsPageV2", function () { return $dda4bcc88b68a12f$export$c65ad6b0ea3aaec5; });

var $61Ea1 = parcelRequire("61Ea1");

var $lvVuT = parcelRequire("lvVuT");
const $dda4bcc88b68a12f$export$c65ad6b0ea3aaec5 = ()=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $lvVuT.InvoiceReportTable), {});
};

});
parcelRegister("lvVuT", function(module, exports) {

$parcel$export(module.exports, "InvoiceReportTable", function () { return $f1ed6723f27b4aa7$export$20493edfd6660386; });

var $61Ea1 = parcelRequire("61Ea1");

var $aaosT = parcelRequire("aaosT");

var $gcfa1 = parcelRequire("gcfa1");

var $aYyI4 = parcelRequire("aYyI4");

var $jbmdS = parcelRequire("jbmdS");

var $3h7sC = parcelRequire("3h7sC");

var $O2UPo = parcelRequire("O2UPo");

var $bskH6 = parcelRequire("bskH6");

var $hgWPl = parcelRequire("hgWPl");

var $638iS = parcelRequire("638iS");

var $kKJbF = parcelRequire("kKJbF");
function $f1ed6723f27b4aa7$export$20493edfd6660386() {
    var _organisationReport$f;
    const reportData = (0, $bskH6.useReportData)();
    const organisationReport = (0, $bskH6.useOrganisationReport)();
    const isLoadingReportData = (0, $bskH6.useIsLoadingReportData)();
    const pendingChanges = (0, $bskH6.usePendingChanges)();
    const handleStateChange = (newState, options)=>{
        (0, $bskH6.setOrganisationReport)({
            ...organisationReport,
            ...newState
        }, options);
    };
    const handleColumnsChange = (columns, options)=>{
        (0, $bskH6.setColumns)(columns, options);
    };
    const handleApplyChanges = async ()=>{
        (0, $bskH6.setIsLoadingReportData)(true);
        try {
            const data = await fetchReportData({
                ...organisationReport,
                groupBy: organisationReport.groupBy || [],
                sortBy: organisationReport.sortBy || []
            });
            (0, $bskH6.setReportData)(data);
        } finally{
            (0, $bskH6.setIsLoadingReportData)(false);
            (0, $bskH6.setPendingChanges)(false);
        }
    };
    const columns = (0, $jbmdS.useMemo)(()=>(0, $kKJbF.orderColumnDefs)((0, $hgWPl.getColumns)((column)=>{
            (0, $bskH6.setColumns)(organisationReport.columns.filter((c)=>c !== column), {
                needsRefetch: false
            });
        }), organisationReport.columns, [], []), [
        organisationReport.columns
    ]);
    const filterFields = columns.map((column)=>{
        var _column$meta, _column$meta2, _column$meta3;
        return {
            label: column === null || column === void 0 ? void 0 : (_column$meta = column.meta) === null || _column$meta === void 0 ? void 0 : _column$meta.title,
            value: column.accessorKey,
            typeFilter: (0, $O2UPo.typeFilterMap)[column === null || column === void 0 ? void 0 : (_column$meta2 = column.meta) === null || _column$meta2 === void 0 ? void 0 : _column$meta2.type],
            ...column === null || column === void 0 ? void 0 : (_column$meta3 = column.meta) === null || _column$meta3 === void 0 ? void 0 : _column$meta3.filterOptions
        };
    });
    const defaultSort = [
        {
            id: "description",
            desc: false
        }
    ];
    const { table: table } = (0, $aaosT.useDataTable)({
        data: reportData,
        defaultSort: defaultSort,
        columns: columns,
        visibleColumns: organisationReport.columns,
        filterFields: filterFields,
        enableAdvancedFilter: true,
        sortingFns: {
            sortingTextFn: $O2UPo.sortingTextFn,
            sortingProgressFn: $O2UPo.sortingProgressFn,
            sortingDateFn: $O2UPo.sortingDateFn
        }
    });
    const fetchReportData = async (data)=>{
        return await (0, $3h7sC.trpc).invoiceReport.getReportsData.query(data);
    };
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $aYyI4.DataTable), {
        table: table,
        showTotals: true,
        loadingReportData: isLoadingReportData,
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $gcfa1.DataTableAdvancedToolbar), {
            table: table,
            filterFields: filterFields,
            searchableFields: [
                "description",
                "project"
            ],
            tableState: {
                columns: organisationReport.columns,
                filters: (_organisationReport$f = organisationReport.filters) !== null && _organisationReport$f !== void 0 ? _organisationReport$f : [],
                dateRange: organisationReport.dateRange,
                sortBy: organisationReport.sortBy,
                groupBy: organisationReport.groupBy
            },
            pendingChanges: pendingChanges,
            onStateChange: handleStateChange,
            onColumnsChange: handleColumnsChange,
            onApplyChanges: handleApplyChanges,
            isLoading: isLoadingReportData,
            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $638iS.InvoiceReportActions), {
                table: table
            })
        })
    });
}

});
parcelRegister("hgWPl", function(module, exports) {

$parcel$export(module.exports, "getColumns", function () { return $2d0b6a5ef776241a$export$978e30a0fb8610d8; });

var $61Ea1 = parcelRequire("61Ea1");

var $kqlQp = parcelRequire("kqlQp");

var $1BTI2 = parcelRequire("1BTI2");

var $8kZ1o = parcelRequire("8kZ1o");

var $khCHn = parcelRequire("khCHn");
function $2d0b6a5ef776241a$export$978e30a0fb8610d8(onHideColumn) {
    const generateColumnDef = (0, $khCHn.createGenerateColumnDef)({
        onHideColumn: onHideColumn
    });
    const standardSize = 160;
    const wideSize = 200;
    return [
        generateColumnDef({
            key: "description",
            type: "text",
            title: "Invoice #",
            size: 150,
            cell: (row)=>{
                const value = row.getValue("description");
                return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqlQp.Link), {
                        to: `/invoices/${row.original.id}`,
                        children: value
                    })
                });
            }
        }),
        generateColumnDef({
            key: "issuedOn",
            type: "date",
            title: "Issue Date",
            aggregationFn: "min"
        }),
        generateColumnDef({
            key: "dueDate",
            type: "date",
            title: "Due Date",
            aggregationFn: "min"
        }),
        generateColumnDef({
            key: "startDate",
            type: "date",
            title: "Work Start Date",
            aggregationFn: "min"
        }),
        generateColumnDef({
            key: "endDate",
            type: "date",
            title: "Work End Date",
            aggregationFn: "max"
        }),
        generateColumnDef({
            key: "createdAt",
            type: "date",
            title: "Creation Date",
            aggregationFn: "min"
        }),
        generateColumnDef({
            key: "project",
            type: "project",
            title: "Project",
            size: wideSize
        }),
        generateColumnDef({
            key: "projectTitle",
            type: "text",
            title: "Project Title",
            size: wideSize
        }),
        generateColumnDef({
            key: "contact",
            type: "contact",
            title: "Client",
            size: wideSize
        }),
        generateColumnDef({
            key: "projectContact",
            type: "contact",
            title: "Project Client",
            size: wideSize
        }),
        generateColumnDef({
            key: "projectOwner",
            type: "staffMember",
            title: "Project Owner",
            size: wideSize
        }),
        generateColumnDef({
            key: "projectPrimaryContact",
            type: "contact",
            title: "Project Primary Contact",
            size: wideSize,
            permissions: ()=>(0, $8kZ1o.canViewPrimaryContact)()
        }),
        generateColumnDef({
            key: "costCentre",
            type: "costCentre",
            title: "Cost Centre",
            size: 150,
            permissions: (row)=>(0, $8kZ1o.canViewCostCentres)((0, $1BTI2.default).user)
        }),
        ...[
            "amountExTax",
            "amountIncTax",
            "amountTax",
            "agreedFeeExTax",
            "variationExTax",
            "agreedFeeVariationExTax",
            "reimbursementExTax",
            "agreedFeeTax",
            "variationTax",
            "agreedFeeVariationTax",
            "reimbursementTax",
            "agreedFeeIncTax",
            "variationIncTax",
            "agreedFeeVariationIncTax",
            "reimbursementIncTax"
        ].map((key)=>generateColumnDef({
                key: key,
                type: "currency",
                title: key.replace(/([A-Z])/g, " $1").replace(/^./, (str)=>str.toUpperCase()),
                aggregationFn: "sum"
            })),
        generateColumnDef({
            key: "synced",
            type: "boolean",
            title: "Synced",
            filterOptions: {
                options: [
                    {
                        label: "Yes",
                        value: true
                    },
                    {
                        label: "No",
                        value: false
                    }
                ]
            }
        }),
        generateColumnDef({
            key: "projectStatus",
            type: "status",
            title: "Project Status",
            filterOptions: {
                options: [
                    {
                        label: "Active",
                        value: "active"
                    },
                    {
                        label: "On Hold",
                        value: "onHold"
                    },
                    {
                        label: "Prospective",
                        value: "prospective"
                    },
                    {
                        label: "Archived",
                        value: "archived"
                    }
                ]
            }
        })
    ];
}

});

parcelRegister("638iS", function(module, exports) {

$parcel$export(module.exports, "InvoiceReportActions", function () { return $eeab46284bcaf9d3$export$ff377a85ea3e8cee; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $gN0TC = parcelRequire("gN0TC");

var $fJ4T4 = parcelRequire("fJ4T4");

var $cV8g5 = parcelRequire("cV8g5");

var $6mjwz = parcelRequire("6mjwz");

var $azaaH = parcelRequire("azaaH");

var $3h7sC = parcelRequire("3h7sC");

var $1BTI2 = parcelRequire("1BTI2");

var $6UBLf = parcelRequire("6UBLf");

var $dHs32 = parcelRequire("dHs32");

var $38AIP = parcelRequire("38AIP");

var $26sX2 = parcelRequire("26sX2");

var $bskH6 = parcelRequire("bskH6");

var $bAwxh = parcelRequire("bAwxh");
function $eeab46284bcaf9d3$export$ff377a85ea3e8cee({ table: table, exportColumns: exportColumns = [] }) {
    var _SessionStore$organis;
    const navigate = (0, $6UBLf.useNavigate)();
    const [dialogContent, setDialogContent] = (0, $jbmdS.useState)(null);
    const [nameReport, setNameReport] = (0, $jbmdS.useState)(null);
    const organisationReport = (0, $bskH6.useOrganisationReport)();
    const checkDisableButton = !(organisationReport !== null && organisationReport !== void 0 && organisationReport.id) && !((_SessionStore$organis = (0, $1BTI2.default).organisation) !== null && _SessionStore$organis !== void 0 && _SessionStore$organis.defaultInvoiceReportId);
    const handleOpenDialog = (content)=>{
        setNameReport(null);
        setDialogContent(content);
    };
    const showSaveAsToast = (0, $bAwxh.useSaveToast)({
        saveId: "invoice-report-save-as",
        onSave: async ()=>{
            const newId = $gN0TC();
            const result = await (0, $3h7sC.trpc).invoiceReport.saveReport.mutate({
                id: newId,
                name: nameReport,
                organisationId: organisationReport.organisationId,
                filters: organisationReport.filters,
                type: "invoice",
                columns: organisationReport.columns,
                options: organisationReport.options
            });
            (0, $38AIP.addCacheItem)("organisationReports", {
                id: newId,
                name: nameReport,
                type: "invoice"
            });
            setNameReport(null);
            setDialogContent(null);
            (0, $bskH6.setOrganisationReport)({
                ...organisationReport,
                ...result
            });
            navigate({
                search: {
                    report: newId
                }
            });
        },
        loadingMessage: "Saving new report...",
        successMessage: "New report saved successfully",
        errorMessage: "Failed to save new report"
    });
    // Save existing report
    const showSaveToast = (0, $bAwxh.useSaveToast)({
        saveId: "invoice-report-save",
        onSave: async ()=>{
            const result = await (0, $3h7sC.trpc).invoiceReport.saveReport.mutate({
                id: organisationReport.id,
                organisationId: organisationReport.organisationId,
                filters: organisationReport.filters,
                columns: organisationReport.columns,
                options: organisationReport.options
            });
            setDialogContent(null);
            (0, $bskH6.setOrganisationReport)({
                ...organisationReport,
                ...result
            });
            return result;
        },
        loadingMessage: "Saving report...",
        successMessage: "Report saved successfully",
        errorMessage: "Failed to save report"
    });
    // Rename operation
    const showRenameToast = (0, $bAwxh.useSaveToast)({
        saveId: "invoice-report-rename",
        onSave: async ()=>{
            if (!nameReport || nameReport === organisationReport.name) return;
            const result = await (0, $3h7sC.trpc).invoiceReport.saveReport.mutate({
                id: organisationReport.id,
                organisationId: organisationReport.organisationId,
                name: nameReport
            });
            (0, $38AIP.updateCacheItem)("organisationReports", organisationReport.id, {
                name: nameReport,
                type: "invoice"
            });
            (0, $26sX2.setPageTitle)(nameReport);
            setNameReport(null);
            setDialogContent(null);
            (0, $bskH6.setOrganisationReport)({
                ...organisationReport,
                ...result
            });
            return result;
        },
        loadingMessage: "Renaming report...",
        successMessage: "Report renamed successfully",
        errorMessage: "Failed to rename report"
    });
    // Delete operation
    const showDeleteToast = (0, $bAwxh.useSaveToast)({
        saveId: "invoice-report-delete",
        onSave: async ()=>{
            const result = await (0, $3h7sC.trpc).invoiceReport.saveReport.mutate({
                id: organisationReport.id,
                organisationId: organisationReport.organisationId,
                deletedAt: new Date()
            });
            (0, $38AIP.deleteCacheItem)("organisationReports", organisationReport.id);
            setDialogContent(null);
            navigate({
                search: {}
            });
            return result;
        },
        loadingMessage: "Deleting report...",
        successMessage: "Report deleted successfully",
        errorMessage: "Failed to delete report"
    });
    // Set Default operation
    const showSaveDefaultToast = (0, $bAwxh.useSaveToast)({
        saveId: "invoice-report-set-default",
        onSave: async ()=>{
            return await (0, $3h7sC.trpc).invoiceReport.setDefaultReport.mutate({
                id: organisationReport.id
            });
        },
        loadingMessage: "Setting as default...",
        successMessage: "Set as default report",
        errorMessage: "Failed to set as default"
    });
    const handleSetDefault = ()=>{
        showSaveDefaultToast();
    };
    const handleDialogSubmit = (dialogContent)=>{
        setDialogContent(null);
        switch(dialogContent){
            case "Save":
                showSaveToast();
                break;
            case "Save as":
                showSaveAsToast();
                break;
            case "Rename Report":
                showRenameToast();
                break;
            case "Delete Report":
                showDeleteToast();
                break;
        }
    };
    const csvFormatter = (data, column)=>{
        var _column$columnDef$met;
        const value = data.getValue(column === null || column === void 0 ? void 0 : column.id);
        switch((_column$columnDef$met = column.columnDef.meta) === null || _column$columnDef$met === void 0 ? void 0 : _column$columnDef$met.type){
            case "progress":
            case "progressBar":
                const { numerator: numerator, denominator: denominator } = value;
                if (numerator || denominator) return `${(0, $azaaH.default).progress(numerator || 0)} / ${(0, $azaaH.default).progress(denominator || 0)}`;
                else return "";
            case "date":
                return data ? (0, $fJ4T4.FormatDate)(new Date(value), {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit"
                }) : "";
            default:
                return value;
        }
    };
    const handleExportToCSV = ()=>{
        const results = [];
        const headers = table.getAllColumns().filter((item)=>{
            var _organisationReport$c;
            return organisationReport === null || organisationReport === void 0 ? void 0 : (_organisationReport$c = organisationReport.columns) === null || _organisationReport$c === void 0 ? void 0 : _organisationReport$c.includes(item.id);
        });
        const firstRow = [];
        headers.forEach((header)=>{
            var _header$columnDef$met;
            return firstRow.push((_header$columnDef$met = header.columnDef.meta) === null || _header$columnDef$met === void 0 ? void 0 : _header$columnDef$met.title);
        });
        results.push(firstRow);
        // Add data
        table.getRowModel().rows.forEach((item)=>{
            const row = [];
            headers.forEach((header)=>{
                row.push(csvFormatter(item, header));
            });
            results.push(row);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($cV8g5)))((0, (/*@__PURE__*/$parcel$interopDefault($6mjwz))).unparse(results), `invoice.csv`, "text/csv");
    };
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $dHs32.DataTableActions), {
            handleExportToCSV: handleExportToCSV,
            handleDialogSubmit: handleDialogSubmit,
            handleOpenDialog: handleOpenDialog,
            handleSetDefault: handleSetDefault,
            dialogContent: dialogContent,
            setDialogContent: setDialogContent,
            setNameReport: setNameReport,
            nameReport: nameReport,
            organisationReport: organisationReport,
            checkDisableButton: checkDisableButton,
            exportColumns: exportColumns
        })
    });
}

});




parcelRegister("cLkcu", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $94a98b2f98023c67$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("bAwxh");

var $26sX2 = parcelRequire("26sX2");

var $6XFpi = parcelRequire("6XFpi");
parcelRequire("jbmdS");

var $5PXcS = parcelRequire("5PXcS");

var $4iw5i = parcelRequire("4iw5i");

var $3MqUA = parcelRequire("3MqUA");

var $jts39 = parcelRequire("jts39");

var $kuPRw = parcelRequire("kuPRw");

var $47i9t = parcelRequire("47i9t");

var $7qobO = parcelRequire("7qobO");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $3h7sC = parcelRequire("3h7sC");

var $d21o8 = parcelRequire("d21o8");

var $88oVC = parcelRequire("88oVC");

var $kqntg = parcelRequire("kqntg");
const $94a98b2f98023c67$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_private/cost-centres/")({
    beforeLoad: ({ params: params })=>{
        if (!(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "costCentres", params)) throw new Error("Permission Denied");
        (0, $26sX2.setLayoutDefaults)({
            pageTitle: "Cost Centres",
            subMenu: "organisation"
        });
    },
    errorComponent: ({ error: error, reset: reset })=>{
        if (error.message === "Permission Denied") return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7qobO.default), {});
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    },
    loader: async ()=>{
        const data = await (0, $3h7sC.trpc).legacy.getCostCentresListPageData.query();
        return (0, $47i9t.processTRPCData)(data);
    },
    pendingComponent: (0, $4iw5i.default),
    component: $94a98b2f98023c67$var$Wrapper
});
function $94a98b2f98023c67$var$Wrapper() {
    // The store now handles all the save toast logic internally
    (0, $d21o8.costCentreStore).useSaveHandler();
    if ((0, $8kZ1o.migratedToV2)()) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqntg.PageBody), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $88oVC.CostCentrePage), {})
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jts39.default), {}),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kuPRw.default), {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3MqUA.default), {})
            })
        ]
    });
}

});
parcelRegister("3MqUA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c0abae6ff8f788d$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $goLmS = parcelRequire("goLmS");

var $eNcHX = parcelRequire("eNcHX");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");
const $2c0abae6ff8f788d$var$columns = [
    {
        id: "name",
        label: "Name",
        type: "text",
        width: 25,
        editable: (row)=>(0, $8kZ1o.canEditCostCentres)((0, $1BTI2.default).user),
        value: (row)=>{
            return row.name;
        },
        onChange: (row)=>(val)=>row.update({
                    name: val
                })
    },
    {
        id: "isBillable",
        label: "Billable",
        type: "checkbox",
        width: 25,
        editable: (row)=>(0, $8kZ1o.canEditCostCentres)((0, $1BTI2.default).user),
        value: (row)=>{
            return row.isBillable;
        },
        onChange: (row)=>(val)=>row.update({
                    isBillable: val
                })
    },
    {
        label: "",
        width: 4,
        type: "button",
        permissions: (r)=>(0, $8kZ1o.canEditCostCentres)((0, $1BTI2.default).user),
        editable: (r)=>(0, $8kZ1o.canEditCostCentres)((0, $1BTI2.default).user),
        value: (p)=>/*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                className: "fa fa-times",
                style: {
                    marginRight: 0
                }
            }),
        onClick: (r)=>()=>{
                r.update({
                    deletedAt: new Date()
                });
            }
    }
];
var $2c0abae6ff8f788d$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(()=>{
    var _CostCentreCollection, _CostCentreCollection3;
    const [costCentres, setCostCentres] = (0, $jbmdS.useState)([
        ...((0, $eNcHX.default) === null || (0, $eNcHX.default) === void 0 ? void 0 : (_CostCentreCollection = (0, $eNcHX.default).activeCostCentres) === null || _CostCentreCollection === void 0 ? void 0 : _CostCentreCollection.sort((a, b)=>{
            var _a$name, _a$name$localeCompare;
            return (_a$name = a.name) === null || _a$name === void 0 ? void 0 : (_a$name$localeCompare = _a$name.localeCompare) === null || _a$name$localeCompare === void 0 ? void 0 : _a$name$localeCompare.call(_a$name, b.name);
        })) || []
    ]);
    (0, $jbmdS.useEffect)(()=>{
        var _CostCentreCollection2;
        setCostCentres([
            ...((0, $eNcHX.default) === null || (0, $eNcHX.default) === void 0 ? void 0 : (_CostCentreCollection2 = (0, $eNcHX.default).activeCostCentres) === null || _CostCentreCollection2 === void 0 ? void 0 : _CostCentreCollection2.sort((a, b)=>{
                var _a$name2, _a$name2$localeCompar;
                return (_a$name2 = a.name) === null || _a$name2 === void 0 ? void 0 : (_a$name2$localeCompar = _a$name2.localeCompare) === null || _a$name2$localeCompar === void 0 ? void 0 : _a$name2$localeCompar.call(_a$name2, b.name);
            })) || []
        ]);
    }, [
        (0, $eNcHX.default) === null || (0, $eNcHX.default) === void 0 ? void 0 : (_CostCentreCollection3 = (0, $eNcHX.default).activeCostCentres) === null || _CostCentreCollection3 === void 0 ? void 0 : _CostCentreCollection3.length
    ]);
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
            columns: $2c0abae6ff8f788d$var$columns,
            rows: costCentres,
            newRowDirection: "asc"
        })
    });
});

});

parcelRegister("jts39", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2d67bdd67babcca$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $eNcHX = parcelRequire("eNcHX");

var $36Jjh = parcelRequire("36Jjh");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");
var $e2d67bdd67babcca$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ extraContent: extraContent })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $36Jjh.default), {
        heading: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: "Cost Centres"
            })
        }),
        extraContent: (0, $8kZ1o.canEditCostCentres)((0, $1BTI2.default).user) ? /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
            className: "btn btn-default add-timesheet-entry-button plus-btn mt-6",
            onClick: ()=>{
                const ph = (0, $eNcHX.default).add({
                    isBillable: true
                }, {
                    trackUpdates: true
                });
                ph.isNew = true;
            },
            children: "+ Add Cost Centre"
        }) : null
    });
});

});

parcelRegister("d21o8", function(module, exports) {

$parcel$export(module.exports, "costCentreStore", function () { return $8d7b1def88e4ad23$export$3225d108f9b819d7; });
$parcel$export(module.exports, "addCostCentre", function () { return $8d7b1def88e4ad23$export$d50bbad60fa48248; });
$parcel$export(module.exports, "updateCostCentre", function () { return $8d7b1def88e4ad23$export$4549187633fd33ef; });
$parcel$export(module.exports, "deleteCostCentre", function () { return $8d7b1def88e4ad23$export$e60acc67c1085276; });
$parcel$export(module.exports, "useCostCentres", function () { return $8d7b1def88e4ad23$export$faa16ea999e502b4; });

var $8qPhl = parcelRequire("8qPhl");

var $3h7sC = parcelRequire("3h7sC");

var $277OF = parcelRequire("277OF");

var $lJ1OS = parcelRequire("lJ1OS");
const $8d7b1def88e4ad23$export$89f46cf7e62c0e9a = (0, $8qPhl.z).object({
    id: (0, $8qPhl.z).string(),
    name: (0, $8qPhl.z).string().max(100),
    isBillable: (0, $8qPhl.z).boolean(),
    deletedAt: (0, $8qPhl.z).date().nullable().optional()
});
const $8d7b1def88e4ad23$var$initialContext = {
    costCentres: []
};
const $8d7b1def88e4ad23$export$3225d108f9b819d7 = (0, $277OF.createQueryStore)({
    context: $8d7b1def88e4ad23$var$initialContext,
    on: {
        setCostCentres: {
            costCentres: (_, event)=>event.costCentres
        },
        addCostCentre: {
            costCentres: (context, event)=>[
                    ...context.costCentres,
                    event.costCentre
                ]
        },
        updateCostCentre: {
            costCentres: (context, event)=>{
                const index = context.costCentres.findIndex((c)=>c.id === event.id);
                if (index === -1) return context.costCentres;
                const updatedCostCentres = [
                    ...context.costCentres
                ];
                updatedCostCentres[index] = {
                    ...updatedCostCentres[index],
                    ...event.costCentre
                };
                return updatedCostCentres;
            }
        },
        deleteCostCentre: {
            costCentres: (context, event)=>{
                const index = context.costCentres.findIndex((c)=>c.id === event.id);
                if (index === -1) return context.costCentres;
                const updatedCostCentres = [
                    ...context.costCentres
                ];
                updatedCostCentres[index] = {
                    ...updatedCostCentres[index],
                    deletedAt: new Date()
                };
                return updatedCostCentres;
            }
        }
    }
}, {
    queryKey: [
        "cost-centres"
    ],
    queryFn: ()=>(0, $3h7sC.trpc).costCentre.getCostCentres.query(),
    mutationFn: (data)=>(0, $3h7sC.trpc).costCentre.saveCostCentres.mutate(data),
    staleTime: 300000,
    // 5 minutes
    cacheTime: 1800000 // 30 minutes
}, {
    saveId: "cost-centres-save",
    requireConfirmation: true,
    confirmationMessage: "Save changes to cost centres?",
    loadingMessage: "Saving cost centres...",
    successMessage: "Cost centres saved successfully",
    errorMessage: "Failed to save cost centres"
});
const { useStoreData: $8d7b1def88e4ad23$export$544efe5ac05fc17, useIsLoading: $8d7b1def88e4ad23$export$4dface15d86304a4, useCanUndo: $8d7b1def88e4ad23$export$653033ad74e314c9, useCanRedo: $8d7b1def88e4ad23$export$e7ea8bfdbe9392b0, useUpdatedAt: $8d7b1def88e4ad23$export$4d53551414e812c, undo: $8d7b1def88e4ad23$export$21f930c44940fd98, redo: $8d7b1def88e4ad23$export$1688e416fee0a49e, save: $8d7b1def88e4ad23$export$a1544dad697b423d, revertToLastSave: $8d7b1def88e4ad23$export$7e511c2293ae6e56, getState: $8d7b1def88e4ad23$export$50fdfeece43146fd, getHistory: $8d7b1def88e4ad23$export$f9582a3c130d9538, getCurrentHistoryIndex: $8d7b1def88e4ad23$export$3d0fb93f79a1d871, getLastSavedIndex: $8d7b1def88e4ad23$export$3ad3501ee738138, getSavedAt: $8d7b1def88e4ad23$export$f4c906ca2124fef8, getUpdatedAt: $8d7b1def88e4ad23$export$ff3aa069bd8fb4e4 } = $8d7b1def88e4ad23$export$3225d108f9b819d7;
const $8d7b1def88e4ad23$export$813db5b9f7337645 = (costCentres)=>$8d7b1def88e4ad23$export$3225d108f9b819d7.store.send({
        type: "setCostCentres",
        costCentres: costCentres
    });
const $8d7b1def88e4ad23$export$d50bbad60fa48248 = (costCentre)=>$8d7b1def88e4ad23$export$3225d108f9b819d7.store.send({
        type: "addCostCentre",
        costCentre: costCentre
    });
const $8d7b1def88e4ad23$export$4549187633fd33ef = (id, costCentre)=>$8d7b1def88e4ad23$export$3225d108f9b819d7.store.send({
        type: "updateCostCentre",
        id: id,
        costCentre: costCentre
    });
const $8d7b1def88e4ad23$export$e60acc67c1085276 = (id)=>$8d7b1def88e4ad23$export$3225d108f9b819d7.store.send({
        type: "deleteCostCentre",
        id: id
    });
const $8d7b1def88e4ad23$export$faa16ea999e502b4 = ()=>(0, $lJ1OS.useSelector)($8d7b1def88e4ad23$export$3225d108f9b819d7.store, (state)=>state.context.costCentres);

});

parcelRegister("88oVC", function(module, exports) {

$parcel$export(module.exports, "CostCentrePage", function () { return $79c009604eedd4c9$export$30d37d9fd840b8e3; });

var $61Ea1 = parcelRequire("61Ea1");

var $fTGwv = parcelRequire("fTGwv");

var $9Pt1Z = parcelRequire("9Pt1Z");

var $d21o8 = parcelRequire("d21o8");

var $kKEim = parcelRequire("kKEim");
const $79c009604eedd4c9$export$30d37d9fd840b8e3 = ()=>{
    const handleAddCostCentre = ()=>{
        (0, $d21o8.addCostCentre)({
            id: (0, (/*@__PURE__*/$parcel$interopDefault($9Pt1Z)))(),
            name: "",
            isBillable: false
        });
    };
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "p-8",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fTGwv.Button), {
                    variant: "outline",
                    onClick: handleAddCostCentre,
                    children: "+ Add Cost Centre"
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kKEim.CostCentreTable), {})
        ]
    });
};

});
parcelRegister("kKEim", function(module, exports) {

$parcel$export(module.exports, "CostCentreTable", function () { return $3f5b33214cc6eda5$export$8d95000fac49c1b; });

var $61Ea1 = parcelRequire("61Ea1");

var $O2UPo = parcelRequire("O2UPo");

var $aYyI4 = parcelRequire("aYyI4");

var $aaosT = parcelRequire("aaosT");

var $d21o8 = parcelRequire("d21o8");

var $1HY3H = parcelRequire("1HY3H");

var $jbmdS = parcelRequire("jbmdS");
function $3f5b33214cc6eda5$export$8d95000fac49c1b() {
    const costCentres = (0, $d21o8.useCostCentres)();
    const columns = (0, $jbmdS.useMemo)(()=>(0, $1HY3H.getColumns)((column)=>{}, (0, $d21o8.updateCostCentre), (0, $d21o8.deleteCostCentre)), [
        (0, $d21o8.updateCostCentre),
        (0, $d21o8.deleteCostCentre)
    ]);
    const defaultSort = [
        {
            id: "name",
            desc: false
        }
    ];
    const { table: table } = (0, $aaosT.useDataTable)({
        data: costCentres,
        defaultSort: defaultSort,
        columns: columns,
        visibleColumns: columns.map((column)=>column === null || column === void 0 ? void 0 : column.accessorKey),
        sortingFns: {
            sortingTextFn: $O2UPo.sortingTextFn,
            sortingDateFn: $O2UPo.sortingDateFn
        }
    });
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $aYyI4.DataTable), {
        table: table
    });
}

});
parcelRegister("1HY3H", function(module, exports) {

$parcel$export(module.exports, "getColumns", function () { return $d139fa474a91fffa$export$978e30a0fb8610d8; });

var $61Ea1 = parcelRequire("61Ea1");

var $khCHn = parcelRequire("khCHn");
function $d139fa474a91fffa$export$978e30a0fb8610d8(onHideColumn, updateCostCentre, deleteCostCentre) {
    const generateColumnDef = (0, $khCHn.createGenerateColumnDef)({
        onHideColumn: onHideColumn
    });
    const wideSize = 100;
    return [
        generateColumnDef({
            key: "name",
            type: "text",
            title: "Name",
            size: wideSize,
            editable: true,
            onChange: (row, val)=>updateCostCentre(row.original.id, {
                    name: val
                })
        }),
        generateColumnDef({
            key: "isBillable",
            title: "Billable",
            type: "boolean",
            size: wideSize,
            editable: true,
            onChange: (row, val)=>updateCostCentre(row.original.id, {
                    isBillable: val
                })
        }),
        generateColumnDef({
            key: "deleteButton",
            title: "Action",
            type: "button",
            size: wideSize,
            editable: true,
            cell: (row)=>{
                return /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                    className: "fa fa-times"
                });
            },
            onClick: (row)=>deleteCostCentre(row.original.id)
        })
    ];
}

});




parcelRegister("e9SYy", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $a4ec8cf6c931f9f4$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");

var $26fcM = parcelRequire("26fcM");

var $c0pNQ = parcelRequire("c0pNQ");

var $kuPRw = parcelRequire("kuPRw");

var $47i9t = parcelRequire("47i9t");

var $4iw5i = parcelRequire("4iw5i");

var $5PXcS = parcelRequire("5PXcS");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $7qobO = parcelRequire("7qobO");

var $26sX2 = parcelRequire("26sX2");

var $kqntg = parcelRequire("kqntg");

var $3h7sC = parcelRequire("3h7sC");
const $a4ec8cf6c931f9f4$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_private/contacts/")({
    beforeLoad: ({ params: params })=>{
        if (!(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "contacts", params)) throw new Error("Permission Denied");
        (0, $26sX2.setLayoutDefaults)({
            pageTitle: "Clients",
            subMenu: "clients"
        });
    },
    errorComponent: ({ error: error, reset: reset })=>{
        if (error.message === "Permission Denied") return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7qobO.default), {});
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    },
    loader: async ()=>await $a4ec8cf6c931f9f4$var$loader(),
    pendingComponent: (0, $4iw5i.default),
    component: $a4ec8cf6c931f9f4$var$Wrapper
});
const $a4ec8cf6c931f9f4$var$loader = async ()=>{
    const data = await (0, $3h7sC.trpc).legacy.getContactsListPageData.query();
    return (0, $47i9t.processTRPCData)(data);
};
function $a4ec8cf6c931f9f4$var$Wrapper() {
    if ((0, $8kZ1o.migratedToV2)()) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqntg.CenterPadPageBody), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $c0pNQ.default), {})
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $26fcM.default), {}),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kuPRw.default), {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $c0pNQ.default), {})
            })
        ]
    });
}

});
parcelRegister("26fcM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1877efb7ac89ba1b$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $bhvQG = parcelRequire("bhvQG");

var $khJQv = parcelRequire("khJQv");

var $36Jjh = parcelRequire("36Jjh");

var $8Os6U = parcelRequire("8Os6U");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");
parcelRequire("fEtu5");
var $e4TNX = parcelRequire("e4TNX");

var $5PNwq = parcelRequire("5PNwq");

var $3X7oM = parcelRequire("3X7oM");

var $6UBLf = parcelRequire("6UBLf");

var $k37O2 = parcelRequire("k37O2");

var $cV8g5 = parcelRequire("cV8g5");

var $6mjwz = parcelRequire("6mjwz");
const $1877efb7ac89ba1b$var$downloadCSV = ()=>{
    const rows = [
        (0, $k37O2.contactColumns).map((c)=>c.label)
    ];
    (0, $bhvQG.default).contacts.forEach((contact)=>{
        rows.push((0, $k37O2.contactColumns).map((c)=>c.value(contact)));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($cV8g5)))((0, (/*@__PURE__*/$parcel$interopDefault($6mjwz))).unparse(rows), "contacts.csv", "text/csv");
};
var $1877efb7ac89ba1b$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(()=>{
    const navigate = (0, $6UBLf.useNavigate)();
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $36Jjh.default), {
        heading: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: "Contacts"
            })
        }),
        filter: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $e4TNX.FilterTextBox), {
            style: {
                width: "19em"
            },
            value: (0, $5PNwq.default).searchFilter || "",
            onChange: (val)=>(0, $5PNwq.default).updateSearchFilter(val),
            placeholder: "Find Contact..."
        }),
        extraContent: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            className: "mt-6",
            children: (0, $8kZ1o.canEditContacts)((0, $1BTI2.default).user) ? [
                /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                    className: "project-list__add-new-project-button page-header__button--primary plus-btn",
                    onClick: ()=>{
                        const contact = (0, $bhvQG.default).createContact();
                        navigate({
                            to: "/contacts/$id",
                            params: {
                                id: contact.id
                            }
                        });
                    },
                    children: "+ New Contact"
                }, 0),
                /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                    className: "project-list__add-new-project-button page-header__button--primary plus-btn ml-4",
                    onClick: ()=>{
                        (0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $8Os6U.default), {
                            modalId: "import-contacts"
                        }));
                    },
                    children: "+ Import From Accounting System"
                }, 0)
            ] : null
        }),
        rightButtons: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            className: "flex items-center gap-2",
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3X7oM.default), {
                    label: "Export",
                    onClick: ()=>$1877efb7ac89ba1b$var$downloadCSV(),
                    icon: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                        className: "fa fa-table"
                    })
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3X7oM.default), {
                    label: "Print",
                    onClick: ()=>window.print(),
                    icon: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                        className: "fa fa-print"
                    })
                })
            ]
        })
    });
});

});
parcelRegister("5PNwq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43f821381cdb4115$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");
var $43f821381cdb4115$var$_dec, $43f821381cdb4115$var$_class, $43f821381cdb4115$var$_descriptor;
function $43f821381cdb4115$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $43f821381cdb4115$var$_defineProperty(e, r, t) {
    return (r = $43f821381cdb4115$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $43f821381cdb4115$var$_toPropertyKey(t) {
    var i = $43f821381cdb4115$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $43f821381cdb4115$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $43f821381cdb4115$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $43f821381cdb4115$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $43f821381cdb4115$var$ContactStore = ($43f821381cdb4115$var$_dec = (0, $4JcCM.action).bound, $43f821381cdb4115$var$_class = class ContactStore {
    constructor(){
        $43f821381cdb4115$var$_initializerDefineProperty(this, "searchFilter", $43f821381cdb4115$var$_descriptor, this);
        (0, $4JcCM.makeObservable)(this);
    }
    updateSearchFilter(val) {
        this.searchFilter = val;
    }
}, $43f821381cdb4115$var$_descriptor = $43f821381cdb4115$var$_applyDecoratedDescriptor($43f821381cdb4115$var$_class.prototype, "searchFilter", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "";
    }
}), $43f821381cdb4115$var$_applyDecoratedDescriptor($43f821381cdb4115$var$_class.prototype, "updateSearchFilter", [
    $43f821381cdb4115$var$_dec
], Object.getOwnPropertyDescriptor($43f821381cdb4115$var$_class.prototype, "updateSearchFilter"), $43f821381cdb4115$var$_class.prototype), $43f821381cdb4115$var$_class);
var $43f821381cdb4115$export$2e2bcd8739ae039 = new $43f821381cdb4115$var$ContactStore();

});

parcelRegister("k37O2", function(module, exports) {

$parcel$export(module.exports, "contactColumns", function () { return $e98a2495988fd041$export$949e1a30f07709bc; });

var $61Ea1 = parcelRequire("61Ea1");

var $kqlQp = parcelRequire("kqlQp");
const $e98a2495988fd041$export$949e1a30f07709bc = [
    {
        id: "label",
        label: "Label",
        type: "text",
        width: 25,
        value: (row)=>{
            return row.label;
        },
        component: ({ value: value, stores: stores })=>{
            const { row: row } = stores;
            return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqlQp.Link), {
                    to: `/contacts/${row.rowObject.id}`,
                    children: value
                })
            });
        }
    },
    {
        id: "email",
        label: "Email",
        type: "text",
        width: 25,
        value: (row)=>{
            return row.email;
        }
    },
    {
        id: "phone",
        label: "Phone",
        type: "text",
        width: 25,
        value: (row)=>{
            return row.phone;
        }
    },
    {
        id: "address",
        label: "Address",
        type: "text",
        width: 25,
        value: (row)=>{
            return row.address;
        }
    }
];

});


parcelRegister("c0pNQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8bd9800a1063b270$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $goLmS = parcelRequire("goLmS");

var $bhvQG = parcelRequire("bhvQG");

var $5PNwq = parcelRequire("5PNwq");

var $k37O2 = parcelRequire("k37O2");
var $8bd9800a1063b270$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(()=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
            columns: (0, $k37O2.contactColumns),
            rows: (0, $bhvQG.default).contacts.filter((c)=>{
                var _ContactStore$searchF;
                return (((_ContactStore$searchF = (0, $5PNwq.default).searchFilter) === null || _ContactStore$searchF === void 0 ? void 0 : _ContactStore$searchF.length) > 0 ? c.label.toLowerCase().includes((0, $5PNwq.default).searchFilter.toLowerCase()) : true) && !c.deletedAt;
            })
        })
    });
});

});


parcelRegister("kTc56", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $f35250cc0833e2e6$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");

var $l7sMN = parcelRequire("l7sMN");

var $bb7GK = parcelRequire("bb7GK");

var $kuPRw = parcelRequire("kuPRw");

var $4iw5i = parcelRequire("4iw5i");

var $5PXcS = parcelRequire("5PXcS");

var $47i9t = parcelRequire("47i9t");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $7qobO = parcelRequire("7qobO");
parcelRequire("jE5CX");

var $1RuDH = parcelRequire("1RuDH");

var $1AaEu = parcelRequire("1AaEu");

var $5M65g = parcelRequire("5M65g");

var $3h7sC = parcelRequire("3h7sC");

var $cnmvx = parcelRequire("cnmvx");

var $6Q5sp = parcelRequire("6Q5sp");

var $26sX2 = parcelRequire("26sX2");

var $38AIP = parcelRequire("38AIP");

var $4hBm1 = parcelRequire("4hBm1");

var $kqntg = parcelRequire("kqntg");
const $f35250cc0833e2e6$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_private/timesheets/report")({
    beforeLoad: ({ params: params, search: search })=>{
        if (!(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "timesheetReports", params)) throw new Error("Permission Denied");
        const report = (0, $38AIP.getCacheItemById)("organisationReports", search.report);
        (0, $26sX2.setLayoutDefaults)({
            pageTitle: (report === null || report === void 0 ? void 0 : report.name) || "Timesheet Report",
            subMenu: "time"
        });
    },
    errorComponent: ({ error: error, reset: reset })=>{
        if (error.message === "Permission Denied") return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7qobO.default), {});
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    },
    pendingComponent: (0, $4iw5i.default),
    loader: async ({ location: location })=>await $f35250cc0833e2e6$var$loader(location.search),
    loaderDeps: ({ search: { report: report } })=>({
            report: report
        }),
    component: $f35250cc0833e2e6$var$Wrapper
});
const $f35250cc0833e2e6$var$loader = async ({ report: report })=>{
    var _SessionStore$organis;
    const reportId = report || ((0, $1BTI2.default) === null || (0, $1BTI2.default) === void 0 ? void 0 : (_SessionStore$organis = (0, $1BTI2.default).organisation) === null || _SessionStore$organis === void 0 ? void 0 : _SessionStore$organis.defaultTimeReportId);
    if ((0, $8kZ1o.migratedToV2)()) {
        var _organisationReport$o;
        const res = reportId ? await (0, $3h7sC.trpc).timeReport.getOrganisationReport.query({
            reportId: reportId
        }) : null;
        const organisationReport = res || (0, $1BTI2.default).organisation.defaultTimeReport;
        let dateRange = [
            null,
            null
        ];
        if ((_organisationReport$o = organisationReport.options) !== null && _organisationReport$o !== void 0 && _organisationReport$o.dateRange) {
            var _dateStringLookup$org, _organisationReport$o2, _organisationReport$o3, _organisationReport$o4;
            dateRange = ((_dateStringLookup$org = (0, $cnmvx.dateStringLookup)[(_organisationReport$o2 = organisationReport.options) === null || _organisationReport$o2 === void 0 ? void 0 : _organisationReport$o2.dateRange]) === null || _dateStringLookup$org === void 0 ? void 0 : _dateStringLookup$org.call((0, $cnmvx.dateStringLookup), (_organisationReport$o3 = organisationReport.options) === null || _organisationReport$o3 === void 0 ? void 0 : _organisationReport$o3.fortnightType)) || ((_organisationReport$o4 = organisationReport.options) === null || _organisationReport$o4 === void 0 ? void 0 : _organisationReport$o4.dateRange);
        }
        const { columns: columns, filters: filters, groupBy: groupBy, sortBy: sortBy, options: options, name: name } = organisationReport;
        (0, $1AaEu.setOrganisationReport)({
            columns: columns,
            filters: filters,
            groupBy: groupBy,
            organisationId: (0, $1BTI2.default).organisationId,
            sortBy: sortBy,
            dateRange: dateRange,
            invoiceDateType: (0, $1BTI2.default).settings.reportInvoiceDateType,
            id: reportId,
            options: options,
            name: name
        }, {
            needsRefetch: false
        });
        const cacheData = await (0, $6Q5sp.queryClient).fetchQuery({
            queryKey: [
                "timeReportCache",
                reportId
            ],
            queryFn: ()=>{
                var _SessionStore$user;
                return (0, $3h7sC.trpc).timeReport.getReportsData.query({
                    organisationId: (0, $1BTI2.default).organisationId,
                    userId: (_SessionStore$user = (0, $1BTI2.default).user) === null || _SessionStore$user === void 0 ? void 0 : _SessionStore$user.id,
                    columns: organisationReport === null || organisationReport === void 0 ? void 0 : organisationReport.columns.filter((c)=>{
                        var _TimeReportColumns$c;
                        return !((_TimeReportColumns$c = (0, $5M65g.TimeReportColumns)(reportId)[c]) !== null && _TimeReportColumns$c !== void 0 && _TimeReportColumns$c.permissions) || (0, $5M65g.TimeReportColumns)(reportId)[c].permissions();
                    }),
                    filters: organisationReport === null || organisationReport === void 0 ? void 0 : organisationReport.filters.map((f)=>{
                        var _TimeReportColumns$f$, _TimeReportColumns$f$2;
                        if (((_TimeReportColumns$f$ = (0, $5M65g.TimeReportColumns)(reportId)[f.column]) === null || _TimeReportColumns$f$ === void 0 ? void 0 : _TimeReportColumns$f$.type) === "date") {
                            var _dateStringLookup$f$v;
                            let value = ((_dateStringLookup$f$v = (0, $cnmvx.dateStringLookup)[f.value]) === null || _dateStringLookup$f$v === void 0 ? void 0 : _dateStringLookup$f$v.call((0, $cnmvx.dateStringLookup))) || f.value;
                            if (Array.isArray(value)) value = value.map((d)=>d ? (0, $4hBm1.format)(d, "yyyy-MM-dd") : null);
                            else value = value ? (0, $4hBm1.format)(value, "yyyy-MM-dd") : null;
                            return {
                                ...f,
                                value: value
                            };
                        } else if (((_TimeReportColumns$f$2 = (0, $5M65g.TimeReportColumns)(reportId)[f.column]) === null || _TimeReportColumns$f$2 === void 0 ? void 0 : _TimeReportColumns$f$2.type) === "time") {
                            let value = f.value;
                            if (Array.isArray(value)) value = value.map((d)=>{
                                d = new Date(d);
                                return d && d.getTime() ? (0, $4hBm1.format)(d, "yyyy-MM-dd HH:mm") : null;
                            });
                            else {
                                value = new Date(value);
                                value = value && value.getTime() ? (0, $4hBm1.format)(value, "yyyy-MM-dd HH:mm") : null;
                            }
                            return {
                                ...f,
                                value: value
                            };
                        } else return f;
                    }),
                    sortBy: (organisationReport === null || organisationReport === void 0 ? void 0 : organisationReport.sortBy) || [],
                    groupBy: (organisationReport === null || organisationReport === void 0 ? void 0 : organisationReport.groupBy) || [],
                    dateRange: dateRange,
                    invoiceDateType: (0, $1BTI2.default).settings.reportInvoiceDateType
                });
            },
            staleTime: 300000
        });
        (0, $1AaEu.setReportData)(cacheData);
    }
    const data = await (0, $3h7sC.trpc).legacy.getTimesheetReportPageData.query({
        reportId: reportId
    });
    return (0, $47i9t.processTRPCData)(data);
};
function $f35250cc0833e2e6$var$Wrapper() {
    if ((0, $8kZ1o.migratedToV2)()) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqntg.PageBody), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $1RuDH.TimesheetReportsPageV2), {})
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $l7sMN.default), {
                ...$f35250cc0833e2e6$export$e7b0ac011bb776c6.useParams(),
                ...$f35250cc0833e2e6$export$e7b0ac011bb776c6.useSearch()
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kuPRw.default), {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bb7GK.default), {
                    ...$f35250cc0833e2e6$export$e7b0ac011bb776c6.useParams(),
                    ...$f35250cc0833e2e6$export$e7b0ac011bb776c6.useSearch()
                })
            })
        ]
    });
}

});
parcelRegister("l7sMN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f60094be4e1c21d5$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $36Jjh = parcelRequire("36Jjh");

var $h6zQv = parcelRequire("h6zQv");
parcelRequire("1BTI2");

var $khJQv = parcelRequire("khJQv");

var $jr4Q7 = parcelRequire("jr4Q7");

var $kmACq = parcelRequire("kmACq");

var $aRbBG = parcelRequire("aRbBG");

var $ewAM3 = parcelRequire("ewAM3");

var $gJT7h = parcelRequire("gJT7h");

var $XoImS = parcelRequire("XoImS");

var $keGWP = parcelRequire("keGWP");

var $4hBm1 = parcelRequire("4hBm1");

var $3X7oM = parcelRequire("3X7oM");

var $6Q5sp = parcelRequire("6Q5sp");
function $f60094be4e1c21d5$var$getConsistentValue(arr, key) {
    const uniqueValues = new Set(arr.map((obj)=>obj[key]));
    return uniqueValues.size === 1 ? [
        ...uniqueValues
    ][0] || null : null;
}
var $f60094be4e1c21d5$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(()=>{
    const report = (0, $kmACq.default).report;
    const selectedRows = [
        ...(0, $kmACq.default).selectedRows
    ];
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $36Jjh.default), {
        heading: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    children: "Timesheet Reports"
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    className: "text-sm font-normal px-2.5 py-1.5",
                    children: isFinite(report.dateRange[0]) ? `(${(0, $4hBm1.format)(report.dateRange[0], "dd MMMM yyyy")} - ${(0, $4hBm1.format)(report.dateRange[1], "dd MMMM yyyy")})` : `(All time prior to: ${(0, $4hBm1.format)(new Date(), "dd MMMM yyyy")})`
                })
            ]
        }),
        rightButtons: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            className: "flex items-center gap-2",
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3X7oM.default), {
                    disabled: !(0, $kmACq.default).selectedRows.size,
                    onClick: ()=>{
                        (0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $aRbBG.default), {
                            modalId: "editEntry",
                            timeEntries: selectedRows,
                            onSave: (data)=>{
                                (0, $kmACq.default).batchSaveSelectedRows(data);
                                (0, $6Q5sp.queryClient).setQueryData([
                                    (0, $kmACq.default).report.queryKey
                                ], (oldData)=>({
                                        ...oldData,
                                        data: (0, $kmACq.default).queryData
                                    }));
                            },
                            showAllFlags: true,
                            placeholders: {
                                project: "Leave Project Unchanged",
                                phase: "Leave Phase Unchanged",
                                task: "Leave Task Unchanged"
                            },
                            selectDefaults: false,
                            defaults: {
                                project: (0, $gJT7h.default).projectsById[$f60094be4e1c21d5$var$getConsistentValue(selectedRows, "projectId")],
                                phase: $f60094be4e1c21d5$var$getConsistentValue(selectedRows, "phaseId") ? (0, $XoImS.default).phasesById[$f60094be4e1c21d5$var$getConsistentValue(selectedRows, "phaseId")] || {
                                    id: $f60094be4e1c21d5$var$getConsistentValue(selectedRows, "phaseId"),
                                    name: $f60094be4e1c21d5$var$getConsistentValue(selectedRows, "projectPhase")
                                } : null,
                                task: (0, $keGWP.default).tasksById[$f60094be4e1c21d5$var$getConsistentValue(selectedRows, "taskId")] ? (0, $keGWP.default).tasksById[$f60094be4e1c21d5$var$getConsistentValue(selectedRows, "taskId")] || {
                                    id: $f60094be4e1c21d5$var$getConsistentValue(selectedRows, "taskId"),
                                    name: $f60094be4e1c21d5$var$getConsistentValue(selectedRows, "task")
                                } : null,
                                isBillable: $f60094be4e1c21d5$var$getConsistentValue(selectedRows, "isBillable"),
                                isVariation: $f60094be4e1c21d5$var$getConsistentValue(selectedRows, "isVariation"),
                                isOvertime: $f60094be4e1c21d5$var$getConsistentValue(selectedRows, "isOvertime"),
                                beenInvoiced: $f60094be4e1c21d5$var$getConsistentValue(selectedRows, "beenInvoiced"),
                                isLocked: $f60094be4e1c21d5$var$getConsistentValue(selectedRows, "isLocked")
                            }
                        }));
                    },
                    label: "Edit Selected Time",
                    icon: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                        className: "fa fa-table"
                    })
                }),
                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    className: "export-button-dropdown flex items-center",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3X7oM.default), {
                            label: "Export",
                            icon: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                className: "fa fa-table"
                            }),
                            onClick: ()=>{
                                (0, $kmACq.default).downloadCSV();
                            },
                            className: "border-r-0 rounded-tr-none rounded-br-none"
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                            className: "border! border-white bg-transparent hover:bg-white/25 transition-colors rounded-[6px] rounded-tl-none rounded-bl-none",
                            style: {
                                maxWidth: "9em",
                                margin: 0
                            },
                            value: (0, $kmACq.default).groupBy[(0, $kmACq.default).exportLevel] || "time",
                            options: [
                                ...(0, $kmACq.default).groupBy,
                                "time"
                            ],
                            optionLabel: function(group) {
                                var _report$columnOptions;
                                return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                    children: ((_report$columnOptions = report.columnOptionsById[group]) === null || _report$columnOptions === void 0 ? void 0 : _report$columnOptions.label) || "Time Entry"
                                });
                            },
                            onChange: (group)=>{
                                const index = (0, $kmACq.default).groupBy.indexOf(group);
                                (0, $kmACq.default).setExportLevel(index >= 0 > 0 ? index : (0, $kmACq.default).groupBy.length);
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3X7oM.default), {
                    label: "Print",
                    icon: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                        className: "fa fa-print"
                    }),
                    onClick: ()=>window.print()
                })
            ]
        }),
        extraContent: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jr4Q7.default), {
                report: report,
                reportOptions: (0, $h6zQv.default).reportsByType["timesheet"],
                expandClick: ()=>(0, $kmACq.default).toggleExpandAll(),
                expandLabel: (0, $kmACq.default).expandAll ? "- Collapse All" : "+ Expand All",
                selector: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                    className: "py-2 px-4 border! border-white bg-transparent hover:bg-white/25 transition-colors rounded-[6px] text-xs",
                    style: {
                        maxWidth: "8em"
                    },
                    value: (0, $kmACq.default).groupBy[(0, $kmACq.default).expandToLevel] || "time",
                    options: [
                        ...(0, $kmACq.default).groupBy,
                        "time"
                    ],
                    optionLabel: function(group) {
                        var _report$columnOptions2;
                        return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            children: ((_report$columnOptions2 = report.columnOptionsById[group]) === null || _report$columnOptions2 === void 0 ? void 0 : _report$columnOptions2.label) || "Time Entry"
                        });
                    },
                    onChange: (group)=>{
                        const index = (0, $kmACq.default).groupBy.indexOf(group);
                        (0, $kmACq.default).setExpandToLevel(index >= 0 > 0 ? index : (0, $kmACq.default).groupBy.length);
                    }
                })
            })
        })
    });
});

});
parcelRegister("kmACq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed32447260eee1aa$export$2e2bcd8739ae039; });

var $4JcCM = parcelRequire("4JcCM");
parcelRequire("jbmdS");
parcelRequire("eat5C");

var $h6zQv = parcelRequire("h6zQv");

var $1BTI2 = parcelRequire("1BTI2");

var $lUJ9H = parcelRequire("lUJ9H");
parcelRequire("jE5CX");

var $cv7Es = parcelRequire("cv7Es");
parcelRequire("6Q5sp");

var $Ds2V9 = parcelRequire("Ds2V9");

var $hdshG = parcelRequire("hdshG");

var $cV8g5 = parcelRequire("cV8g5");

var $6mjwz = parcelRequire("6mjwz");

var $XoImS = parcelRequire("XoImS");

var $gJT7h = parcelRequire("gJT7h");

var $keGWP = parcelRequire("keGWP");
var $ed32447260eee1aa$var$_dec, $ed32447260eee1aa$var$_dec2, $ed32447260eee1aa$var$_dec3, $ed32447260eee1aa$var$_dec4, $ed32447260eee1aa$var$_dec5, $ed32447260eee1aa$var$_dec6, $ed32447260eee1aa$var$_dec7, $ed32447260eee1aa$var$_dec8, $ed32447260eee1aa$var$_dec9, $ed32447260eee1aa$var$_dec10, $ed32447260eee1aa$var$_dec11, $ed32447260eee1aa$var$_dec12, $ed32447260eee1aa$var$_class, $ed32447260eee1aa$var$_descriptor, $ed32447260eee1aa$var$_descriptor2, $ed32447260eee1aa$var$_descriptor3, $ed32447260eee1aa$var$_descriptor4, $ed32447260eee1aa$var$_descriptor5, $ed32447260eee1aa$var$_descriptor6, $ed32447260eee1aa$var$_descriptor7, $ed32447260eee1aa$var$_descriptor8;
function $ed32447260eee1aa$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $ed32447260eee1aa$var$_defineProperty(e, r, t) {
    return (r = $ed32447260eee1aa$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ed32447260eee1aa$var$_toPropertyKey(t) {
    var i = $ed32447260eee1aa$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $ed32447260eee1aa$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $ed32447260eee1aa$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $ed32447260eee1aa$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
const $ed32447260eee1aa$var$supportedAggregates = [
    "sum",
    "avg",
    "min",
    "max",
    "count"
];
const $ed32447260eee1aa$var$columnsToFilterFields = {
    project: "projectId",
    projectPhase: "phaseTitle",
    staffMember: "staffId",
    task: "taskName",
    date: "date",
    numMinutes: "numMinutes",
    notes: "notes",
    costCentre: "projectCostCentreId",
    staffCostCentre: "staffCostCentreId",
    projectOwner: "projectOwnerId",
    projectContact: "projectContactId",
    projectInvoiceContact: "projectInvoiceContact",
    projectCode: "projectCode",
    projectPhaseCode: "projectPhaseCode",
    staffMemberFirstName: "staffMemberFirstName",
    staffMemberLastName: "staffMemberLastName",
    staffRole: "staffRoleId",
    monthIndex: "month",
    isBillable: "isBillable",
    isVariation: "isVariation",
    beenInvoiced: "beenInvoiced",
    isOvertime: "isOvertime",
    isLocked: "isLocked",
    flexi: "flexi",
    remote: "remote",
    fee: "projectFee",
    remainingFee: "projectRemainingFee",
    budget: "projectExpenseBudget",
    hoursBudget: "projectHoursBudget",
    startMinutes: "startMinutes",
    endMinutes: "startMinutes",
    labourExpense: "pay",
    cost: "cost",
    chargeOut: "chargeOut",
    chargeOutRate: "chargeOutRate",
    hasNotes: "hasNotes"
};
const $ed32447260eee1aa$var$columnsToGroupFields = {
    ...$ed32447260eee1aa$var$columnsToFilterFields
};
const $ed32447260eee1aa$var$groupsToModelProps = {
    project: "project",
    projectPhase: "phaseTitle",
    staffMember: "staff",
    staffRole: "role",
    task: "task"
};
let $ed32447260eee1aa$var$TimesheetReportStore = ($ed32447260eee1aa$var$_dec = (0, $4JcCM.action).bound, $ed32447260eee1aa$var$_dec2 = (0, $4JcCM.action).bound, $ed32447260eee1aa$var$_dec3 = (0, $4JcCM.action).bound, $ed32447260eee1aa$var$_dec4 = (0, $4JcCM.action).bound, $ed32447260eee1aa$var$_dec5 = (0, $4JcCM.action).bound, $ed32447260eee1aa$var$_dec6 = (0, $4JcCM.action).bound, $ed32447260eee1aa$var$_dec7 = (0, $4JcCM.action).bound, $ed32447260eee1aa$var$_dec8 = (0, $4JcCM.action).bound, $ed32447260eee1aa$var$_dec9 = (0, $4JcCM.action).bound, $ed32447260eee1aa$var$_dec10 = (0, $4JcCM.action).bound, $ed32447260eee1aa$var$_dec11 = (0, $4JcCM.action).bound, $ed32447260eee1aa$var$_dec12 = (0, $4JcCM.action).bound, $ed32447260eee1aa$var$_class = class TimesheetReportStore {
    constructor(){
        $ed32447260eee1aa$var$_defineProperty(this, "rowsLookup", {});
        $ed32447260eee1aa$var$_defineProperty(this, "rowsById", {});
        $ed32447260eee1aa$var$_initializerDefineProperty(this, "selectedRows", $ed32447260eee1aa$var$_descriptor, this);
        $ed32447260eee1aa$var$_defineProperty(this, "queryIds", new Set());
        $ed32447260eee1aa$var$_initializerDefineProperty(this, "batchSaving", $ed32447260eee1aa$var$_descriptor2, this);
        $ed32447260eee1aa$var$_initializerDefineProperty(this, "expandAll", $ed32447260eee1aa$var$_descriptor3, this);
        $ed32447260eee1aa$var$_initializerDefineProperty(this, "expandToLevel", $ed32447260eee1aa$var$_descriptor4, this);
        $ed32447260eee1aa$var$_initializerDefineProperty(this, "exportLevel", $ed32447260eee1aa$var$_descriptor5, this);
        $ed32447260eee1aa$var$_initializerDefineProperty(this, "tableStoresById", $ed32447260eee1aa$var$_descriptor6, this);
        $ed32447260eee1aa$var$_initializerDefineProperty(this, "queryData", $ed32447260eee1aa$var$_descriptor7, this);
        $ed32447260eee1aa$var$_defineProperty(this, "tableStore", new (0, $hdshG.default)());
        $ed32447260eee1aa$var$_initializerDefineProperty(this, "searchParams", $ed32447260eee1aa$var$_descriptor8, this);
        $ed32447260eee1aa$var$_defineProperty(this, "getRowsAtLevel", (0, $Ds2V9.computedFn)((level)=>{
            const getRows = (data, currentLevel)=>{
                if (currentLevel === level) return data;
                if (!data) return [];
                return data.flatMap((d)=>getRows((d === null || d === void 0 ? void 0 : d.children) || [], currentLevel + 1));
            };
            return getRows(this.queryData, 0);
        }));
        $ed32447260eee1aa$var$_defineProperty(this, "getLeafRows", (0, $Ds2V9.computedFn)((row)=>{
            var _row$children;
            if (!((_row$children = row.children) !== null && _row$children !== void 0 && _row$children.length)) return [
                row
            ];
            return row.children.flatMap((c)=>this.getLeafRows(c));
        }));
        $ed32447260eee1aa$var$_defineProperty(this, "isRowSelected", (0, $Ds2V9.computedFn)((row)=>{
            return this.getLeafRows(row).every((r)=>this.selectedRows.has(r));
        }));
        (0, $4JcCM.makeObservable)(this);
    }
    init(queryData) {
        this.queryData = queryData;
        this.tableStore = new (0, $hdshG.default)();
        this.selectedRows = new Set();
        this.exportLevel = this.report.groupBy.length;
    }
    reset() {
        this.rowsLookup = {};
        this.rowsById = {};
        this.selectedRows = new Set();
        this.queryIds = new Set();
        this.batchSaving = false;
        this.expandAll = false;
        this.expandToLevel = 1;
        this.exportLevel = this.report.groupBy.length;
        this.tableStore = new (0, $hdshG.default)();
    }
    setSearchParams(params) {
        this.searchParams = params;
    }
    toggleExpandAll() {
        this.expandAll = !this.expandAll;
    }
    setExpandToLevel(expandToLevel) {
        this.expandToLevel = expandToLevel;
    }
    setExportLevel(exportLevel) {
        this.exportLevel = exportLevel;
    }
    get report() {
        var _this$searchParams, _SessionStore$organis;
        return (0, $h6zQv.default).reportsById[(_this$searchParams = this.searchParams) === null || _this$searchParams === void 0 ? void 0 : _this$searchParams.report] || ((_SessionStore$organis = (0, $1BTI2.default).organisation) === null || _SessionStore$organis === void 0 ? void 0 : _SessionStore$organis.defaultTimeReport);
    }
    get groupBy() {
        var _this$report, _this$report$groupBy;
        return (_this$report = this.report) !== null && _this$report !== void 0 && (_this$report$groupBy = _this$report.groupBy) !== null && _this$report$groupBy !== void 0 && _this$report$groupBy.length ? this.report.groupBy : (0, $lUJ9H.default).groupBy;
    }
    get sortBy() {
        var _this$report2, _this$report2$sortBy;
        return (_this$report2 = this.report) !== null && _this$report2 !== void 0 && (_this$report2$sortBy = _this$report2.sortBy) !== null && _this$report2$sortBy !== void 0 && _this$report2$sortBy.length ? this.report.sortBy : (0, $lUJ9H.default).sortBy;
    }
    selectRow(row) {
        this.getLeafRows(row).forEach((r)=>{
            this.selectedRows.add(r);
        });
    }
    deselectRow(row) {
        this.getLeafRows(row).forEach((r)=>{
            this.selectedRows.delete(r);
        });
    }
    selectAllRows() {
        this.queryData.forEach((row)=>this.selectRow(row));
    }
    deselectAllRows() {
        this.selectedRows.clear();
    }
    batchSaveSelectedRows(data) {
        this.batchSaving = true;
        const selectedRowIds = [
            ...this.selectedRows
        ].map((r)=>r.timeEntryId);
        (0, $cv7Es.default).addData({
            collection: "timeEntries",
            ids: selectedRowIds,
            data: data
        });
        (0, $cv7Es.default).startSave(()=>{
            // queryClient.invalidateQueries([this.report.queryKey])
            this.editSelectedRowAndAncestors(selectedRowIds, data);
            this.batchSaving = false;
        });
        this.selectedRows.clear();
        this.rowsLookup = {};
    }
    editSelectedRowAndAncestors(selectedRows, data) {
        const selectedRowIds = new Set(selectedRows);
        const editRow = (row)=>{
            var _row$children2;
            let newRow;
            const leafRows = this.getLeafRows(row);
            const shouldEdit = leafRows.every((r)=>selectedRowIds.has(r.timeEntryId));
            const checkChildren = shouldEdit || leafRows.some((r)=>selectedRowIds.has(r.timeEntryId));
            if (shouldEdit) {
                if (data.projectId) {
                    const project = (0, $gJT7h.default).projectsById[data.projectId];
                    data.project = project.title;
                    if (row.label === row.project) data.label = project.title;
                }
                if (data.phaseId) {
                    const phase = (0, $XoImS.default).phasesById[data.phaseId];
                    data.projectPhase = phase.title;
                    if (row.label === row.projectPhase) data.label = phase.title;
                }
                if (data.taskId) {
                    const task = (0, $keGWP.default).tasksById[data.taskId];
                    data.task = task.name;
                    if (row.label === row.task) data.label = task.name;
                }
                newRow = {
                    ...row,
                    ...data
                };
            } else newRow = row;
            if (checkChildren && (_row$children2 = row.children) !== null && _row$children2 !== void 0 && _row$children2.length) newRow.children = row.children.map((c)=>editRow(c));
            return newRow;
        };
        this.queryData = this.queryData.map((row)=>editRow(row));
    }
    async downloadCSV() {
        const rows = this.getRowsAtLevel(this.exportLevel);
        const tableStore = new (0, $hdshG.default)();
        tableStore.update({
            columns: this.report.tableColumns,
            rows: rows
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($cV8g5)))((0, (/*@__PURE__*/$parcel$interopDefault($6mjwz))).unparse(tableStore.getCsvData()), `${this.report.name}.csv`, "text/csv");
    }
}, $ed32447260eee1aa$var$_descriptor = $ed32447260eee1aa$var$_applyDecoratedDescriptor($ed32447260eee1aa$var$_class.prototype, "selectedRows", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Set();
    }
}), $ed32447260eee1aa$var$_descriptor2 = $ed32447260eee1aa$var$_applyDecoratedDescriptor($ed32447260eee1aa$var$_class.prototype, "batchSaving", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $ed32447260eee1aa$var$_descriptor3 = $ed32447260eee1aa$var$_applyDecoratedDescriptor($ed32447260eee1aa$var$_class.prototype, "expandAll", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $ed32447260eee1aa$var$_descriptor4 = $ed32447260eee1aa$var$_applyDecoratedDescriptor($ed32447260eee1aa$var$_class.prototype, "expandToLevel", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 1;
    }
}), $ed32447260eee1aa$var$_descriptor5 = $ed32447260eee1aa$var$_applyDecoratedDescriptor($ed32447260eee1aa$var$_class.prototype, "exportLevel", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 10;
    }
}), $ed32447260eee1aa$var$_descriptor6 = $ed32447260eee1aa$var$_applyDecoratedDescriptor($ed32447260eee1aa$var$_class.prototype, "tableStoresById", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $ed32447260eee1aa$var$_descriptor7 = $ed32447260eee1aa$var$_applyDecoratedDescriptor($ed32447260eee1aa$var$_class.prototype, "queryData", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $ed32447260eee1aa$var$_descriptor8 = $ed32447260eee1aa$var$_applyDecoratedDescriptor($ed32447260eee1aa$var$_class.prototype, "searchParams", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $ed32447260eee1aa$var$_applyDecoratedDescriptor($ed32447260eee1aa$var$_class.prototype, "init", [
    $ed32447260eee1aa$var$_dec
], Object.getOwnPropertyDescriptor($ed32447260eee1aa$var$_class.prototype, "init"), $ed32447260eee1aa$var$_class.prototype), $ed32447260eee1aa$var$_applyDecoratedDescriptor($ed32447260eee1aa$var$_class.prototype, "reset", [
    $ed32447260eee1aa$var$_dec2
], Object.getOwnPropertyDescriptor($ed32447260eee1aa$var$_class.prototype, "reset"), $ed32447260eee1aa$var$_class.prototype), $ed32447260eee1aa$var$_applyDecoratedDescriptor($ed32447260eee1aa$var$_class.prototype, "setSearchParams", [
    $ed32447260eee1aa$var$_dec3
], Object.getOwnPropertyDescriptor($ed32447260eee1aa$var$_class.prototype, "setSearchParams"), $ed32447260eee1aa$var$_class.prototype), $ed32447260eee1aa$var$_applyDecoratedDescriptor($ed32447260eee1aa$var$_class.prototype, "toggleExpandAll", [
    $ed32447260eee1aa$var$_dec4
], Object.getOwnPropertyDescriptor($ed32447260eee1aa$var$_class.prototype, "toggleExpandAll"), $ed32447260eee1aa$var$_class.prototype), $ed32447260eee1aa$var$_applyDecoratedDescriptor($ed32447260eee1aa$var$_class.prototype, "setExpandToLevel", [
    $ed32447260eee1aa$var$_dec5
], Object.getOwnPropertyDescriptor($ed32447260eee1aa$var$_class.prototype, "setExpandToLevel"), $ed32447260eee1aa$var$_class.prototype), $ed32447260eee1aa$var$_applyDecoratedDescriptor($ed32447260eee1aa$var$_class.prototype, "setExportLevel", [
    $ed32447260eee1aa$var$_dec6
], Object.getOwnPropertyDescriptor($ed32447260eee1aa$var$_class.prototype, "setExportLevel"), $ed32447260eee1aa$var$_class.prototype), $ed32447260eee1aa$var$_applyDecoratedDescriptor($ed32447260eee1aa$var$_class.prototype, "report", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($ed32447260eee1aa$var$_class.prototype, "report"), $ed32447260eee1aa$var$_class.prototype), $ed32447260eee1aa$var$_applyDecoratedDescriptor($ed32447260eee1aa$var$_class.prototype, "groupBy", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($ed32447260eee1aa$var$_class.prototype, "groupBy"), $ed32447260eee1aa$var$_class.prototype), $ed32447260eee1aa$var$_applyDecoratedDescriptor($ed32447260eee1aa$var$_class.prototype, "sortBy", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($ed32447260eee1aa$var$_class.prototype, "sortBy"), $ed32447260eee1aa$var$_class.prototype), $ed32447260eee1aa$var$_applyDecoratedDescriptor($ed32447260eee1aa$var$_class.prototype, "selectRow", [
    $ed32447260eee1aa$var$_dec7
], Object.getOwnPropertyDescriptor($ed32447260eee1aa$var$_class.prototype, "selectRow"), $ed32447260eee1aa$var$_class.prototype), $ed32447260eee1aa$var$_applyDecoratedDescriptor($ed32447260eee1aa$var$_class.prototype, "deselectRow", [
    $ed32447260eee1aa$var$_dec8
], Object.getOwnPropertyDescriptor($ed32447260eee1aa$var$_class.prototype, "deselectRow"), $ed32447260eee1aa$var$_class.prototype), $ed32447260eee1aa$var$_applyDecoratedDescriptor($ed32447260eee1aa$var$_class.prototype, "selectAllRows", [
    $ed32447260eee1aa$var$_dec9
], Object.getOwnPropertyDescriptor($ed32447260eee1aa$var$_class.prototype, "selectAllRows"), $ed32447260eee1aa$var$_class.prototype), $ed32447260eee1aa$var$_applyDecoratedDescriptor($ed32447260eee1aa$var$_class.prototype, "deselectAllRows", [
    $ed32447260eee1aa$var$_dec10
], Object.getOwnPropertyDescriptor($ed32447260eee1aa$var$_class.prototype, "deselectAllRows"), $ed32447260eee1aa$var$_class.prototype), $ed32447260eee1aa$var$_applyDecoratedDescriptor($ed32447260eee1aa$var$_class.prototype, "batchSaveSelectedRows", [
    $ed32447260eee1aa$var$_dec11
], Object.getOwnPropertyDescriptor($ed32447260eee1aa$var$_class.prototype, "batchSaveSelectedRows"), $ed32447260eee1aa$var$_class.prototype), $ed32447260eee1aa$var$_applyDecoratedDescriptor($ed32447260eee1aa$var$_class.prototype, "editSelectedRowAndAncestors", [
    $ed32447260eee1aa$var$_dec12
], Object.getOwnPropertyDescriptor($ed32447260eee1aa$var$_class.prototype, "editSelectedRowAndAncestors"), $ed32447260eee1aa$var$_class.prototype), $ed32447260eee1aa$var$_class);
var $ed32447260eee1aa$export$2e2bcd8739ae039 = new $ed32447260eee1aa$var$TimesheetReportStore();

});


parcelRegister("bb7GK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8236af895b7b2ea4$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $goLmS = parcelRequire("goLmS");

var $1BTI2 = parcelRequire("1BTI2");

var $6RcUP = parcelRequire("6RcUP");

var $kmACq = parcelRequire("kmACq");

var $4iw5i = parcelRequire("4iw5i");

var $eat5C = parcelRequire("eat5C");
parcelRequire("6Q5sp");

var $3erXY = parcelRequire("3erXY");

var $4hBm1 = parcelRequire("4hBm1");

var $6d1V1 = parcelRequire("6d1V1");

var $8kZ1o = parcelRequire("8kZ1o");

var $cnmvx = parcelRequire("cnmvx");

var $hJgkt = parcelRequire("hJgkt");
let $8236af895b7b2ea4$var$renders = 0;
var $8236af895b7b2ea4$export$2e2bcd8739ae039 = (0, $1EEMt.observer)((props)=>{
    var _SessionStore$user2;
    (0, $jbmdS.useEffect)(()=>{
        (0, $kmACq.default).setSearchParams({
            ...props
        });
    }, [
        props.report
    ]);
    const report = (0, $kmACq.default).report;
    if (!report) return null;
    const permissionFilters = [];
    if (!(0, $8kZ1o.canViewProjectStaffBudgets)((0, $1BTI2.default).user)) {
        var _SessionStore$user;
        permissionFilters.push({
            column: "staffMember",
            operator: "in",
            value: [
                (_SessionStore$user = (0, $1BTI2.default).user) === null || _SessionStore$user === void 0 ? void 0 : _SessionStore$user.id
            ]
        });
    }
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $6RcUP.default), {
        queryIds: [
            {
                id: report.queryKey,
                path: "https://server2.coincraft.co/time-report",
                method: "POST",
                staleTime: 0,
                cacheTime: 0,
                data: {
                    organisationId: (0, $1BTI2.default).organisationId,
                    userId: (_SessionStore$user2 = (0, $1BTI2.default).user) === null || _SessionStore$user2 === void 0 ? void 0 : _SessionStore$user2.id,
                    columns: report.columns.filter((c)=>{
                        var _report$columnOptions;
                        return !((_report$columnOptions = report.columnOptionsById[c]) !== null && _report$columnOptions !== void 0 && _report$columnOptions.permissions) || report.columnOptionsById[c].permissions();
                    }),
                    filters: report.filters.filter(Boolean).map((f)=>{
                        var _report$columnOptions2, _report$columnOptions3;
                        if (((_report$columnOptions2 = report.columnOptionsById[f.column]) === null || _report$columnOptions2 === void 0 ? void 0 : _report$columnOptions2.type) === "date") {
                            var _dateStringLookup$f$v;
                            let value = ((_dateStringLookup$f$v = (0, $cnmvx.dateStringLookup)[f.value]) === null || _dateStringLookup$f$v === void 0 ? void 0 : _dateStringLookup$f$v.call((0, $cnmvx.dateStringLookup))) || f.value;
                            if (Array.isArray(value)) value = value.map((d)=>d && d.getTime() ? (0, $4hBm1.format)(d, "yyyy-MM-dd") : null);
                            else value = value && value.getTime() ? (0, $4hBm1.format)(value, "yyyy-MM-dd") : null;
                            return {
                                ...f,
                                value: value
                            };
                        } else if (((_report$columnOptions3 = report.columnOptionsById[f.column]) === null || _report$columnOptions3 === void 0 ? void 0 : _report$columnOptions3.type) === "time") {
                            let value = f.value;
                            if (Array.isArray(value)) value = value.map((d)=>{
                                d = new Date(d);
                                return d && d.getTime() ? (0, $4hBm1.format)(d, "yyyy-MM-dd HH:mm") : null;
                            });
                            else {
                                value = new Date(value);
                                value = value && value.getTime() ? (0, $4hBm1.format)(value, "yyyy-MM-dd HH:mm") : null;
                            }
                            return {
                                ...f,
                                value: value
                            };
                        } else return f;
                    }),
                    groupBy: report.groupBy,
                    sortBy: report.sortBy,
                    dateRange: report.dateRange.map((d)=>isFinite(d) ? (0, $4hBm1.format)(d, "yyyy-MM-dd") : null)
                }
            }
        ],
        loading: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $4iw5i.default), {}),
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3erXY.default), {
                report: report
            }),
            " :",
            !(report !== null && report !== void 0 && report.needsUpdate) ? /*#__PURE__*/ (0, $61Ea1.jsx)($8236af895b7b2ea4$var$TimeTable, {}, report.queryKey) : null
        ]
    });
});
const $8236af895b7b2ea4$var$TimeTable = (0, $1EEMt.observer)(({ level: level = 0, parent: parent = null })=>{
    const store = (0, $kmACq.default);
    const report = store.report;
    const query = (0, $hJgkt.useQuery)([
        report.queryKey
    ]);
    const queryData = query.data.data;
    (0, $jbmdS.useEffect)(()=>{
        store.init(queryData);
    }, [
        report.queryKey,
        queryData
    ]);
    if (store.batchSaving) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $4iw5i.default), {});
    return /*#__PURE__*/ (0, $61Ea1.jsx)($8236af895b7b2ea4$var$TimeTableTable, {
        level: level,
        parent: parent
    }, report.queryKey);
});
const $8236af895b7b2ea4$var$TimeTableTable = (0, $1EEMt.observer)(({ level: level = 0, parent: parent = null })=>{
    const store = (0, $kmACq.default);
    const { report: report, groupBy: groupBy, sortBy: sortBy } = store;
    const isPrinting = (0, $6d1V1.useMediaQuery)("print");
    const bgColor = 256 - level * 5;
    const bgShadow = bgColor - 10;
    const tableColumns = (0, $jbmdS.useMemo)(()=>report === null || report === void 0 ? void 0 : report.tableColumns.filter((c)=>!store.groupBy.includes(c.id)), [
        report,
        store.groupBy
    ]);
    const getChildComponent = (0, $jbmdS.useCallback)((r)=>/*#__PURE__*/ (0, $61Ea1.jsx)($8236af895b7b2ea4$var$TimeTableTable, {
            parent: r,
            level: level + 1
        }, `${report.queryKey}-${level}-${r.key}`), [
        level,
        store.groupBy,
        report
    ]);
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
        expandAll: store.expandAll && store.expandToLevel > level,
        tableStore: !level ? store.tableStore : null,
        columns: [
            {
                value: (row)=>{
                    return store.isRowSelected(row);
                },
                type: "boolean",
                width: 3,
                id: "checked",
                label: "",
                editable: (r)=>true,
                print: false,
                onChange: (r, stores)=>(v)=>{
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).isEmpty(r)) {
                            if (v) store.selectAllRows();
                            else store.deselectAllRows();
                            return;
                        } else if (v) store.selectRow(r);
                        else store.deselectRow(r);
                    }
            },
            {
                value: (row)=>row.label,
                ...report === null || report === void 0 ? void 0 : report.columnOptionsById[groupBy[level]],
                width: level < groupBy.length && !isPrinting ? 30 : 33,
                id: "label",
                label: "Label",
                style: ()=>({
                        textAlign: "left",
                        justifyContent: "flex-start",
                        paddingLeft: 1 + level * 1 + "rem",
                        fontWeight: 800 - level * 100
                    })
            },
            ...tableColumns
        ],
        rows: (parent === null || parent === void 0 ? void 0 : parent.children) || store.queryData || [],
        sortBy: !level ? [
            ...sortBy,
            [
                "date",
                "desc"
            ]
        ] : store.tableStore.sortBy,
        showTotals: !level,
        showHeader: !level,
        getChildComponent: level < store.groupBy.length ? getChildComponent : null,
        style: level ? {
            // borderBottom: 'none',
            boxShadow: "none",
            background: `linear-gradient(180deg, rgb(${bgShadow},${bgShadow},${bgShadow}) 1px, rgb(${bgColor},${bgColor},${bgColor}) 8px)`,
            fontSize: "1.2rem"
        } : null
    }, `${report.queryKey}-${level}-${parent === null || parent === void 0 ? void 0 : parent.key}`);
});

});

parcelRegister("1RuDH", function(module, exports) {

$parcel$export(module.exports, "TimesheetReportsPageV2", function () { return $9eb2fb8d3efa0972$export$86c406b163190e93; });

var $61Ea1 = parcelRequire("61Ea1");

var $jSXn8 = parcelRequire("jSXn8");
const $9eb2fb8d3efa0972$export$86c406b163190e93 = ()=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jSXn8.TimesheetReportTable), {});
};

});
parcelRegister("jSXn8", function(module, exports) {

$parcel$export(module.exports, "TimesheetReportTable", function () { return $d4414ba54a491735$export$ba7c3539c2a832e1; });

var $61Ea1 = parcelRequire("61Ea1");

var $aaosT = parcelRequire("aaosT");

var $gcfa1 = parcelRequire("gcfa1");

var $aYyI4 = parcelRequire("aYyI4");

var $jbmdS = parcelRequire("jbmdS");

var $lDRj0 = parcelRequire("lDRj0");

var $1AaEu = parcelRequire("1AaEu");

var $3h7sC = parcelRequire("3h7sC");

var $O2UPo = parcelRequire("O2UPo");

var $l9mxF = parcelRequire("l9mxF");

var $iqFxy = parcelRequire("iqFxy");

var $kKJbF = parcelRequire("kKJbF");
function $d4414ba54a491735$export$ba7c3539c2a832e1() {
    var _organisationReport$f;
    const reportData = (0, $1AaEu.useReportData)();
    const organisationReport = (0, $1AaEu.useOrganisationReport)();
    const isLoadingReportData = (0, $1AaEu.useIsLoadingReportData)();
    const pendingChanges = (0, $1AaEu.usePendingChanges)();
    const handleStateChange = (newState, options)=>{
        (0, $1AaEu.setOrganisationReport)({
            ...organisationReport,
            ...newState
        }, options);
    };
    const handleColumnsChange = (columns, options)=>{
        (0, $1AaEu.setColumns)(columns, options);
    };
    const handleApplyChanges = async ()=>{
        (0, $1AaEu.setIsLoadingReportData)(true);
        try {
            const data = await fetchReportData({
                ...organisationReport,
                groupBy: organisationReport.groupBy || [
                    "projectId"
                ],
                sortBy: organisationReport.sortBy || []
            });
            (0, $1AaEu.setReportData)(data);
        } finally{
            (0, $1AaEu.setIsLoadingReportData)(false);
            (0, $1AaEu.setPendingChanges)(false);
        }
    };
    const columns = (0, $jbmdS.useMemo)(()=>(0, $kKJbF.orderColumnDefs)((0, $lDRj0.getColumns)((column)=>{
            (0, $1AaEu.setColumns)(organisationReport.columns.filter((c)=>c !== column), {
                needsRefetch: false
            });
        }), organisationReport.columns, [], []), [
        organisationReport.columns
    ]);
    const filterFields = columns.map((column)=>{
        var _column$meta, _column$meta2, _column$meta3;
        return {
            label: column === null || column === void 0 ? void 0 : (_column$meta = column.meta) === null || _column$meta === void 0 ? void 0 : _column$meta.title,
            value: column.accessorKey,
            typeFilter: (0, $O2UPo.typeFilterMap)[column === null || column === void 0 ? void 0 : (_column$meta2 = column.meta) === null || _column$meta2 === void 0 ? void 0 : _column$meta2.type],
            ...column === null || column === void 0 ? void 0 : (_column$meta3 = column.meta) === null || _column$meta3 === void 0 ? void 0 : _column$meta3.filterOptions
        };
    });
    const exportColumns = [
        ...organisationReport.groupBy.map((groupByColumn)=>{
            var _columns$find, _columns$find$meta;
            return {
                value: groupByColumn,
                label: (_columns$find = columns.find((column)=>column.accessorKey === groupByColumn)) === null || _columns$find === void 0 ? void 0 : (_columns$find$meta = _columns$find.meta) === null || _columns$find$meta === void 0 ? void 0 : _columns$find$meta.title
            };
        }),
        {
            value: "timeEntry",
            label: "Time Entry"
        }
    ];
    const defaultSort = [
        {
            id: "label",
            desc: false
        }
    ];
    const { table: table } = (0, $aaosT.useDataTable)({
        data: reportData,
        defaultSort: defaultSort,
        selectable: {
            enabled: true,
            enableMultipleSelection: true,
            enableRowSelection: (row)=>!row.original.isLocked
        },
        groups: {
            enabled: true,
            columns: organisationReport.groupBy,
            leafRowLabel: "Time Entry"
        },
        columns: columns,
        visibleColumns: [
            "label",
            ...organisationReport.columns
        ],
        filterFields: filterFields,
        enableAdvancedFilter: true,
        sortingFns: {
            sortingTextFn: $O2UPo.sortingTextFn,
            sortingProgressFn: $O2UPo.sortingProgressFn,
            sortingDateFn: $O2UPo.sortingDateFn
        }
    });
    const fetchReportData = async (data)=>{
        return await (0, $3h7sC.trpc).timeReport.getReportsData.query(data);
    };
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $aYyI4.DataTable), {
        table: table,
        showTotals: true,
        floatingBar: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $iqFxy.TimeReportTableFloatingBar), {
            table: table
        }),
        loadingReportData: isLoadingReportData,
        hideColumns: organisationReport.groupBy,
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $gcfa1.DataTableAdvancedToolbar), {
            table: table,
            filterFields: filterFields,
            tableState: {
                columns: organisationReport.columns,
                filters: (_organisationReport$f = organisationReport.filters) !== null && _organisationReport$f !== void 0 ? _organisationReport$f : [],
                dateRange: organisationReport.dateRange,
                sortBy: organisationReport.sortBy,
                groupBy: organisationReport.groupBy
            },
            pendingChanges: pendingChanges,
            onStateChange: handleStateChange,
            onColumnsChange: handleColumnsChange,
            onApplyChanges: handleApplyChanges,
            isHaveGroup: true,
            fixedColumns: [
                "select",
                "label"
            ],
            showSearchFieldHeader: false,
            showApplyToPhase: false,
            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $l9mxF.TimeReportActions), {
                table: table,
                exportColumns: exportColumns
            })
        })
    });
}

});
parcelRegister("lDRj0", function(module, exports) {

$parcel$export(module.exports, "getColumns", function () { return $edb7a98a310b974e$export$978e30a0fb8610d8; });

var $azaaH = parcelRequire("azaaH");

var $1BTI2 = parcelRequire("1BTI2");

var $8kZ1o = parcelRequire("8kZ1o");

var $akjxW = parcelRequire("akjxW");

var $khCHn = parcelRequire("khCHn");

var $6Tdl2 = parcelRequire("6Tdl2");
function $edb7a98a310b974e$export$978e30a0fb8610d8(onHideColumn) {
    const generateColumnDef = (0, $khCHn.createGenerateColumnDef)({
        onHideColumn: onHideColumn
    });
    return [
        generateColumnDef({
            key: "project",
            type: "project",
            title: "Project"
        }),
        generateColumnDef({
            key: "projectPhase",
            type: "text",
            title: "Phase"
        }),
        generateColumnDef({
            key: "projectStatus",
            type: "status",
            title: "Project Status"
        }),
        generateColumnDef({
            key: "phaseStatus",
            type: "status",
            title: "Phase Status"
        }),
        generateColumnDef({
            key: "staffMember",
            type: "staffMember",
            title: "Staff"
        }),
        generateColumnDef({
            key: "task",
            type: "text",
            title: "Task"
        }),
        generateColumnDef({
            key: "date",
            type: "date",
            title: "Date"
        }),
        generateColumnDef({
            key: "numMinutes",
            type: "number",
            title: "Hours",
            aggregationFn: "sum"
        }),
        generateColumnDef({
            key: "billableHours",
            type: "number",
            title: "Billable Hours",
            aggregationFn: "sum"
        }),
        generateColumnDef({
            key: "nonBillableHours",
            type: "number",
            title: "Non-Billable Hours",
            aggregationFn: "sum"
        }),
        generateColumnDef({
            key: "percentBillable",
            type: "percent",
            title: "Percent Billable",
            aggregationFn: "mean"
        }),
        generateColumnDef({
            key: "notes",
            type: "text",
            title: "Notes",
            size: 240
        }),
        generateColumnDef({
            key: "costCentre",
            type: "costCentre",
            title: "Cost Centre",
            size: 120
        }),
        generateColumnDef({
            key: "staffCostCentre",
            type: "costCentre",
            title: "Staff Cost Centre",
            size: 120
        }),
        generateColumnDef({
            key: "projectOwner",
            type: "staffMember",
            title: "Project Owner"
        }),
        generateColumnDef({
            key: "projectContact",
            type: "contact",
            title: "Project Client"
        }),
        generateColumnDef({
            key: "projectInvoiceContact",
            type: "contact",
            title: "Project Primary Contact",
            permissions: (row)=>(0, $8kZ1o.canViewPrimaryContact)()
        }),
        generateColumnDef({
            key: "projectCode",
            type: "text",
            title: "Project Code"
        }),
        generateColumnDef({
            key: "projectPhaseCode",
            type: "text",
            title: "Phase Code"
        }),
        generateColumnDef({
            key: "staffMemberFirstName",
            type: "text",
            title: "Staff First Name"
        }),
        generateColumnDef({
            key: "staffMemberLastName",
            type: "text",
            title: "Staff Last Name"
        }),
        generateColumnDef({
            key: "staffRole",
            type: "role",
            title: "Staff Role"
        }),
        generateColumnDef({
            key: "monthIndex",
            type: "text",
            title: "Month",
            cell: ({ getValue: getValue, row: row, column: column })=>{
                const month = getValue();
                const formattedMonth = month && (0, $azaaH.default).month((0, $akjxW.parse)(month, "yyyy-MM", new Date()));
                return (0, $6Tdl2.renderCell)({
                    value: formattedMonth,
                    row: row,
                    column: column
                });
            }
        }),
        generateColumnDef({
            key: "isBillable",
            type: "boolean",
            title: "Is Billable"
        }),
        generateColumnDef({
            key: "isVariation",
            type: "boolean",
            title: "Is Variation"
        }),
        generateColumnDef({
            key: "isOvertime",
            type: "boolean",
            title: "Is Overtime"
        }),
        generateColumnDef({
            key: "isLocked",
            type: "boolean",
            title: "Is Locked"
        }),
        generateColumnDef({
            key: "beenInvoiced",
            type: "boolean",
            title: "Has Been Invoiced"
        }),
        generateColumnDef({
            key: "flexi",
            type: "boolean",
            title: "Flexi",
            permissions: (row)=>(0, $8kZ1o.canViewFlexi)()
        }),
        generateColumnDef({
            key: "fee",
            type: "currency",
            title: "Fee",
            permissions: (r)=>(0, $8kZ1o.canViewProjectFees)((0, $1BTI2.default).user, r === null || r === void 0 ? void 0 : r.project),
            aggregationFn: "sum"
        }),
        generateColumnDef({
            key: "remote",
            type: "boolean",
            title: "Remote",
            permissions: (r)=>(0, $8kZ1o.canViewRemote)((0, $1BTI2.default).user, r === null || r === void 0 ? void 0 : r.project),
            aggregationFn: "sum"
        }),
        generateColumnDef({
            key: "revenue",
            type: "currency",
            title: "Revenue",
            permissions: (r)=>(0, $8kZ1o.canViewProjectFees)((0, $1BTI2.default).user, r === null || r === void 0 ? void 0 : r.project) && (0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, r === null || r === void 0 ? void 0 : r.project),
            aggregationFn: "sum"
        }),
        generateColumnDef({
            key: "remainingFee",
            type: "currency",
            title: "Remaining Fee",
            permissions: (r)=>(0, $8kZ1o.canViewProjectFees)((0, $1BTI2.default).user, r === null || r === void 0 ? void 0 : r.project) && (0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, r === null || r === void 0 ? void 0 : r.project),
            aggregationFn: "sum"
        }),
        generateColumnDef({
            key: "budget",
            type: "currency",
            title: "Expense Budget",
            permissions: (r)=>(0, $8kZ1o.canViewProjectExpenseBudgets)((0, $1BTI2.default).user, r === null || r === void 0 ? void 0 : r.project),
            aggregationFn: "sum"
        }),
        generateColumnDef({
            key: "hoursBudget",
            type: "number",
            title: "Hours Budget",
            aggregationFn: "sum"
        }),
        generateColumnDef({
            key: "staffHoursBudget",
            type: "number",
            title: "Staff Hours Budget",
            aggregationFn: "sum"
        }),
        generateColumnDef({
            key: "actualVsStaffHoursBudget",
            type: "progressBar",
            title: "Actual vs Staff Hours Budget",
            aggregationFn: "sum"
        }),
        generateColumnDef({
            key: "startMinutes",
            type: "time",
            title: "Start Time"
        }),
        generateColumnDef({
            key: "endMinutes",
            type: "time",
            title: "End Time"
        }),
        generateColumnDef({
            key: "labourExpense",
            type: "currency",
            title: "Labour Expense",
            permissions: (r)=>(0, $8kZ1o.canViewStaffPayRate)((0, $1BTI2.default).user),
            aggregationFn: "sum"
        }),
        generateColumnDef({
            key: "cost",
            type: "currency",
            title: "Expense (cost)",
            permissions: (r)=>(0, $8kZ1o.canViewStaffCostRate)((0, $1BTI2.default).user),
            aggregationFn: "sum"
        }),
        generateColumnDef({
            key: "chargeOut",
            type: "currency",
            title: "Charge Out",
            permissions: (r)=>(0, $8kZ1o.canViewStaffChargeOutRate)((0, $1BTI2.default).user),
            aggregationFn: "sum"
        }),
        generateColumnDef({
            key: "chargeOutRate",
            type: "currency",
            title: "Charge Out Rate",
            permissions: (r)=>(0, $8kZ1o.canViewStaffChargeOutRate)((0, $1BTI2.default).user),
            aggregationFn: "sum"
        }),
        generateColumnDef({
            key: "hasNotes",
            type: "boolean",
            title: "Has Notes"
        })
    ];
}

});
parcelRegister("akjxW", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $e9f61f4973bd5edd$export$98e6a39c04603d36; });

var $iNCNo = parcelRequire("iNCNo");

var $f7iR2 = parcelRequire("f7iR2");

var $6FE41 = parcelRequire("6FE41");

var $l7oHg = parcelRequire("l7oHg");

var $itnWu = parcelRequire("itnWu");

var $kovBB = parcelRequire("kovBB");

var $iGw94 = parcelRequire("iGw94");

var $kUCxz = parcelRequire("kUCxz");
/**
 * The {@link parse} function options.
 */ // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $e9f61f4973bd5edd$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $e9f61f4973bd5edd$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $e9f61f4973bd5edd$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $e9f61f4973bd5edd$var$doubleQuoteRegExp = /''/g;
const $e9f61f4973bd5edd$var$notWhitespaceRegExp = /\S/;
const $e9f61f4973bd5edd$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $e9f61f4973bd5edd$export$98e6a39c04603d36(dateStr, formatStr, referenceDate, options) {
    const defaultOptions = (0, $f7iR2.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $6FE41.enUS);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    if (formatStr === "") {
        if (dateStr === "") return (0, $l7oHg.toDate)(referenceDate);
        else return (0, $iNCNo.constructFrom)(referenceDate, NaN);
    }
    const subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    const setters = [
        new (0, $kUCxz.DateToSystemTimezoneSetter)()
    ];
    const tokens = formatStr.match($e9f61f4973bd5edd$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter in (0, $itnWu.longFormatters)) {
            const longFormatter = (0, $itnWu.longFormatters)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($e9f61f4973bd5edd$var$formattingTokensRegExp);
    const usedTokens = [];
    for (let token of tokens){
        if (!options?.useAdditionalWeekYearTokens && (0, $kovBB.isProtectedWeekYearToken)(token)) (0, $kovBB.warnOrThrowProtectedError)(token, formatStr, dateStr);
        if (!options?.useAdditionalDayOfYearTokens && (0, $kovBB.isProtectedDayOfYearToken)(token)) (0, $kovBB.warnOrThrowProtectedError)(token, formatStr, dateStr);
        const firstCharacter = token[0];
        const parser = (0, $iGw94.parsers)[firstCharacter];
        if (parser) {
            const { incompatibleTokens: incompatibleTokens } = parser;
            if (Array.isArray(incompatibleTokens)) {
                const incompatibleToken = usedTokens.find((usedToken)=>incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter);
                if (incompatibleToken) throw new RangeError(`The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token}\` at the same time`);
            } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError(`The format string mustn't contain \`${token}\` and any other token at the same time`);
            usedTokens.push({
                token: firstCharacter,
                fullToken: token
            });
            const parseResult = parser.run(dateStr, token, locale.match, subFnOptions);
            if (!parseResult) return (0, $iNCNo.constructFrom)(referenceDate, NaN);
            setters.push(parseResult.setter);
            dateStr = parseResult.rest;
        } else {
            if (firstCharacter.match($e9f61f4973bd5edd$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
            // Replace two single quote characters with one single quote character
            if (token === "''") token = "'";
            else if (firstCharacter === "'") token = $e9f61f4973bd5edd$var$cleanEscapedString(token);
            // Cut token from string, or, if string doesn't match the token, return Invalid Date
            if (dateStr.indexOf(token) === 0) dateStr = dateStr.slice(token.length);
            else return (0, $iNCNo.constructFrom)(referenceDate, NaN);
        }
    }
    // Check if the remaining input contains something other than whitespace
    if (dateStr.length > 0 && $e9f61f4973bd5edd$var$notWhitespaceRegExp.test(dateStr)) return (0, $iNCNo.constructFrom)(referenceDate, NaN);
    const uniquePrioritySetters = setters.map((setter)=>setter.priority).sort((a, b)=>b - a).filter((priority, index, array)=>array.indexOf(priority) === index).map((priority)=>setters.filter((setter)=>setter.priority === priority).sort((a, b)=>b.subPriority - a.subPriority)).map((setterArray)=>setterArray[0]);
    let date = (0, $l7oHg.toDate)(referenceDate);
    if (isNaN(date.getTime())) return (0, $iNCNo.constructFrom)(referenceDate, NaN);
    const flags = {};
    for (const setter of uniquePrioritySetters){
        if (!setter.validate(date, subFnOptions)) return (0, $iNCNo.constructFrom)(referenceDate, NaN);
        const result = setter.set(date, flags, subFnOptions);
        // Result is tuple (date, flags)
        if (Array.isArray(result)) {
            date = result[0];
            Object.assign(flags, result[1]);
        // Result is date
        } else date = result;
    }
    return (0, $iNCNo.constructFrom)(referenceDate, date);
}
function $e9f61f4973bd5edd$var$cleanEscapedString(input) {
    return input.match($e9f61f4973bd5edd$var$escapedStringRegExp)[1].replace($e9f61f4973bd5edd$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$e9f61f4973bd5edd$export$2e2bcd8739ae039 = $e9f61f4973bd5edd$export$98e6a39c04603d36;

});
parcelRegister("f7iR2", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", function () { return $90c86c0944de3c01$export$430a3269e24b912e; });

var $8gw7j = parcelRequire("8gw7j");
function $90c86c0944de3c01$export$430a3269e24b912e() {
    return Object.assign({}, (0, $8gw7j.getDefaultOptions)());
}
var // Fallback for modularized imports:
$90c86c0944de3c01$export$2e2bcd8739ae039 = $90c86c0944de3c01$export$430a3269e24b912e;

});

parcelRegister("6FE41", function(module, exports) {

$parcel$export(module.exports, "enUS", function () { return $0c0ddae9fdeeeb35$export$137380d9ce54f7f; });

var $2WWgd = parcelRequire("2WWgd");

var $76EfX = parcelRequire("76EfX");

var $jFoJj = parcelRequire("jFoJj");

var $dgzg7 = parcelRequire("dgzg7");

var $lB7Pq = parcelRequire("lB7Pq");
const $0c0ddae9fdeeeb35$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: (0, $2WWgd.formatDistance),
    formatLong: (0, $76EfX.formatLong),
    formatRelative: (0, $jFoJj.formatRelative),
    localize: (0, $dgzg7.localize),
    match: (0, $lB7Pq.match),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$0c0ddae9fdeeeb35$export$2e2bcd8739ae039 = $0c0ddae9fdeeeb35$export$137380d9ce54f7f;

});
parcelRegister("2WWgd", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $50c7d43097472a5e$export$2c14ff85d6318973; });
const $50c7d43097472a5e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $50c7d43097472a5e$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $50c7d43097472a5e$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};

});

parcelRegister("76EfX", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $3bfab60fda2a45d7$export$cbf60ecb96cbb82f; });

var $kNnqq = parcelRequire("kNnqq");
const $3bfab60fda2a45d7$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $3bfab60fda2a45d7$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $3bfab60fda2a45d7$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $3bfab60fda2a45d7$export$cbf60ecb96cbb82f = {
    date: (0, $kNnqq.buildFormatLongFn)({
        formats: $3bfab60fda2a45d7$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $kNnqq.buildFormatLongFn)({
        formats: $3bfab60fda2a45d7$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $kNnqq.buildFormatLongFn)({
        formats: $3bfab60fda2a45d7$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});
parcelRegister("kNnqq", function(module, exports) {

$parcel$export(module.exports, "buildFormatLongFn", function () { return $dcbb533baf4e9942$export$38e44e97ce4dbb7d; });
function $dcbb533baf4e9942$export$38e44e97ce4dbb7d(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("jFoJj", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $0788af055b4d044f$export$8fbbfd65594f46a0; });
const $0788af055b4d044f$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $0788af055b4d044f$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$0788af055b4d044f$var$formatRelativeLocale[token];

});

parcelRegister("dgzg7", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $718bb3c46c34950b$export$b3bd0bc58e36cd63; });

var $gYiD3 = parcelRequire("gYiD3");
const $718bb3c46c34950b$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $718bb3c46c34950b$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $718bb3c46c34950b$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $718bb3c46c34950b$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $718bb3c46c34950b$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $718bb3c46c34950b$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $718bb3c46c34950b$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $718bb3c46c34950b$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $718bb3c46c34950b$var$ordinalNumber,
    era: (0, $gYiD3.buildLocalizeFn)({
        values: $718bb3c46c34950b$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $gYiD3.buildLocalizeFn)({
        values: $718bb3c46c34950b$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $gYiD3.buildLocalizeFn)({
        values: $718bb3c46c34950b$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $gYiD3.buildLocalizeFn)({
        values: $718bb3c46c34950b$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $gYiD3.buildLocalizeFn)({
        values: $718bb3c46c34950b$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $718bb3c46c34950b$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});
parcelRegister("gYiD3", function(module, exports) {

$parcel$export(module.exports, "buildLocalizeFn", function () { return $eb8273f5d9c19b2e$export$63596d6ee8878b25; });
/* eslint-disable no-unused-vars */ /**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $eb8273f5d9c19b2e$export$63596d6ee8878b25(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("lB7Pq", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $db60526bd7ecdf05$export$4659b591c19bdf3d; });

var $jHHwi = parcelRequire("jHHwi");

var $dQTOw = parcelRequire("dQTOw");
const $db60526bd7ecdf05$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $db60526bd7ecdf05$var$parseOrdinalNumberPattern = /\d+/i;
const $db60526bd7ecdf05$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $db60526bd7ecdf05$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $db60526bd7ecdf05$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $db60526bd7ecdf05$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $db60526bd7ecdf05$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $db60526bd7ecdf05$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $db60526bd7ecdf05$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $db60526bd7ecdf05$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $db60526bd7ecdf05$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $db60526bd7ecdf05$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $db60526bd7ecdf05$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $dQTOw.buildMatchPatternFn)({
        matchPattern: $db60526bd7ecdf05$var$matchOrdinalNumberPattern,
        parsePattern: $db60526bd7ecdf05$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $jHHwi.buildMatchFn)({
        matchPatterns: $db60526bd7ecdf05$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $db60526bd7ecdf05$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $jHHwi.buildMatchFn)({
        matchPatterns: $db60526bd7ecdf05$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $db60526bd7ecdf05$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $jHHwi.buildMatchFn)({
        matchPatterns: $db60526bd7ecdf05$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $db60526bd7ecdf05$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $jHHwi.buildMatchFn)({
        matchPatterns: $db60526bd7ecdf05$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $db60526bd7ecdf05$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $jHHwi.buildMatchFn)({
        matchPatterns: $db60526bd7ecdf05$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $db60526bd7ecdf05$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});
parcelRegister("jHHwi", function(module, exports) {

$parcel$export(module.exports, "buildMatchFn", function () { return $f791de5f62560a1c$export$1430a0f35710914d; });
function $f791de5f62560a1c$export$1430a0f35710914d(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $f791de5f62560a1c$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $f791de5f62560a1c$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $f791de5f62560a1c$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $f791de5f62560a1c$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("dQTOw", function(module, exports) {

$parcel$export(module.exports, "buildMatchPatternFn", function () { return $5664a9bfaf5a8dbb$export$fdaf2fd6d7edde95; });
function $5664a9bfaf5a8dbb$export$fdaf2fd6d7edde95(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});



parcelRegister("itnWu", function(module, exports) {

$parcel$export(module.exports, "longFormatters", function () { return $e97651126ec4fc2a$export$70cc8fd02856fd58; });
const $e97651126ec4fc2a$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $e97651126ec4fc2a$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $e97651126ec4fc2a$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $e97651126ec4fc2a$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $e97651126ec4fc2a$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $e97651126ec4fc2a$var$timeLongFormatter(timePattern, formatLong));
};
const $e97651126ec4fc2a$export$70cc8fd02856fd58 = {
    p: $e97651126ec4fc2a$var$timeLongFormatter,
    P: $e97651126ec4fc2a$var$dateTimeLongFormatter
};

});

parcelRegister("kovBB", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", function () { return $941c25b07feb241f$export$c6cc36aa33304772; });
$parcel$export(module.exports, "isProtectedWeekYearToken", function () { return $941c25b07feb241f$export$c6b49d6dceb604a1; });
$parcel$export(module.exports, "warnOrThrowProtectedError", function () { return $941c25b07feb241f$export$f5f38f90ecaaf879; });
const $941c25b07feb241f$var$dayOfYearTokenRE = /^D+$/;
const $941c25b07feb241f$var$weekYearTokenRE = /^Y+$/;
const $941c25b07feb241f$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $941c25b07feb241f$export$c6cc36aa33304772(token) {
    return $941c25b07feb241f$var$dayOfYearTokenRE.test(token);
}
function $941c25b07feb241f$export$c6b49d6dceb604a1(token) {
    return $941c25b07feb241f$var$weekYearTokenRE.test(token);
}
function $941c25b07feb241f$export$f5f38f90ecaaf879(token, format, input) {
    const _message = $941c25b07feb241f$var$message(token, format, input);
    console.warn(_message);
    if ($941c25b07feb241f$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $941c25b07feb241f$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}

});

parcelRegister("iGw94", function(module, exports) {

$parcel$export(module.exports, "parsers", function () { return $9ff17db5fd47e875$export$19131010e7fd8373; });

var $zwHtt = parcelRequire("zwHtt");

var $jjQgY = parcelRequire("jjQgY");

var $dhcKB = parcelRequire("dhcKB");

var $1Db4Z = parcelRequire("1Db4Z");

var $60rJV = parcelRequire("60rJV");

var $g92mM = parcelRequire("g92mM");

var $7pW1D = parcelRequire("7pW1D");

var $4MkDY = parcelRequire("4MkDY");

var $laVqT = parcelRequire("laVqT");

var $gmrjT = parcelRequire("gmrjT");

var $gMyg2 = parcelRequire("gMyg2");

var $e52Ud = parcelRequire("e52Ud");

var $8ulEM = parcelRequire("8ulEM");

var $lSL5N = parcelRequire("lSL5N");

var $bB4fF = parcelRequire("bB4fF");

var $56tpI = parcelRequire("56tpI");

var $40szr = parcelRequire("40szr");

var $f0KWL = parcelRequire("f0KWL");

var $9pLTk = parcelRequire("9pLTk");

var $e5ZC1 = parcelRequire("e5ZC1");

var $a1aKY = parcelRequire("a1aKY");

var $k4YB1 = parcelRequire("k4YB1");

var $5Cc5l = parcelRequire("5Cc5l");

var $gy8py = parcelRequire("gy8py");

var $2mkFW = parcelRequire("2mkFW");

var $jMDHK = parcelRequire("jMDHK");

var $fumye = parcelRequire("fumye");

var $cY9V1 = parcelRequire("cY9V1");

var $5YhxX = parcelRequire("5YhxX");

var $47WRO = parcelRequire("47WRO");

var $bL7da = parcelRequire("bL7da");
const $9ff17db5fd47e875$export$19131010e7fd8373 = {
    G: new (0, $zwHtt.EraParser)(),
    y: new (0, $jjQgY.YearParser)(),
    Y: new (0, $dhcKB.LocalWeekYearParser)(),
    R: new (0, $1Db4Z.ISOWeekYearParser)(),
    u: new (0, $60rJV.ExtendedYearParser)(),
    Q: new (0, $g92mM.QuarterParser)(),
    q: new (0, $7pW1D.StandAloneQuarterParser)(),
    M: new (0, $4MkDY.MonthParser)(),
    L: new (0, $laVqT.StandAloneMonthParser)(),
    w: new (0, $gmrjT.LocalWeekParser)(),
    I: new (0, $gMyg2.ISOWeekParser)(),
    d: new (0, $e52Ud.DateParser)(),
    D: new (0, $8ulEM.DayOfYearParser)(),
    E: new (0, $lSL5N.DayParser)(),
    e: new (0, $bB4fF.LocalDayParser)(),
    c: new (0, $56tpI.StandAloneLocalDayParser)(),
    i: new (0, $40szr.ISODayParser)(),
    a: new (0, $f0KWL.AMPMParser)(),
    b: new (0, $9pLTk.AMPMMidnightParser)(),
    B: new (0, $e5ZC1.DayPeriodParser)(),
    h: new (0, $a1aKY.Hour1to12Parser)(),
    H: new (0, $k4YB1.Hour0to23Parser)(),
    K: new (0, $5Cc5l.Hour0To11Parser)(),
    k: new (0, $gy8py.Hour1To24Parser)(),
    m: new (0, $2mkFW.MinuteParser)(),
    s: new (0, $jMDHK.SecondParser)(),
    S: new (0, $fumye.FractionOfSecondParser)(),
    X: new (0, $cY9V1.ISOTimezoneWithZParser)(),
    x: new (0, $5YhxX.ISOTimezoneParser)(),
    t: new (0, $47WRO.TimestampSecondsParser)(),
    T: new (0, $bL7da.TimestampMillisecondsParser)()
};

});
parcelRegister("zwHtt", function(module, exports) {

$parcel$export(module.exports, "EraParser", function () { return $8aa6f43ab8731ad2$export$8e5a1d3f85a9688; });

var $jNSTi = parcelRequire("jNSTi");
class $8aa6f43ab8731ad2$export$8e5a1d3f85a9688 extends (0, $jNSTi.Parser) {
    priority = 140;
    parse(dateString, token, match) {
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
            // A, B
            case "GGGGG":
                return match.era(dateString, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return match.era(dateString, {
                    width: "wide"
                }) || match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
        }
    }
    set(date, flags, value) {
        flags.era = value;
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "R",
        "u",
        "t",
        "T"
    ];
}

});
parcelRegister("jNSTi", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $54ea7ace70f6c66c$export$7acfa6ed01010e37; });

var $kUCxz = parcelRequire("kUCxz");
class $54ea7ace70f6c66c$export$7acfa6ed01010e37 {
    run(dateString, token, match, options) {
        const result = this.parse(dateString, token, match, options);
        if (!result) return null;
        return {
            setter: new (0, $kUCxz.ValueSetter)(result.value, this.validate, this.set, this.priority, this.subPriority),
            rest: result.rest
        };
    }
    validate(_utcDate, _value, _options) {
        return true;
    }
}

});
parcelRegister("kUCxz", function(module, exports) {

$parcel$export(module.exports, "ValueSetter", function () { return $d23e04e630e6b9ec$export$9a09e32dd4990fd5; });
$parcel$export(module.exports, "DateToSystemTimezoneSetter", function () { return $d23e04e630e6b9ec$export$5aaf7ff7f09ea4ee; });

var $gQMoi = parcelRequire("gQMoi");

var $iNCNo = parcelRequire("iNCNo");
const $d23e04e630e6b9ec$var$TIMEZONE_UNIT_PRIORITY = 10;
class $d23e04e630e6b9ec$export$81d53e3678089a6 {
    subPriority = 0;
    validate(_utcDate, _options) {
        return true;
    }
}
class $d23e04e630e6b9ec$export$9a09e32dd4990fd5 extends $d23e04e630e6b9ec$export$81d53e3678089a6 {
    constructor(value, validateValue, setValue, priority, subPriority){
        super();
        this.value = value;
        this.validateValue = validateValue;
        this.setValue = setValue;
        this.priority = priority;
        if (subPriority) this.subPriority = subPriority;
    }
    validate(date, options) {
        return this.validateValue(date, this.value, options);
    }
    set(date, flags, options) {
        return this.setValue(date, flags, this.value, options);
    }
}
class $d23e04e630e6b9ec$export$5aaf7ff7f09ea4ee extends $d23e04e630e6b9ec$export$81d53e3678089a6 {
    priority = $d23e04e630e6b9ec$var$TIMEZONE_UNIT_PRIORITY;
    subPriority = -1;
    set(date, flags) {
        if (flags.timestampIsSet) return date;
        return (0, $iNCNo.constructFrom)(date, (0, $gQMoi.transpose)(date, Date));
    }
}

});
parcelRegister("gQMoi", function(module, exports) {

$parcel$export(module.exports, "transpose", function () { return $3f6d75242ee5ce9e$export$9cb09a71b7d66923; });

var $iNCNo = parcelRequire("iNCNo");
function $3f6d75242ee5ce9e$export$9cb09a71b7d66923(fromDate, constructor) {
    const date = constructor instanceof Date ? (0, $iNCNo.constructFrom)(constructor, 0) : new constructor(0);
    date.setFullYear(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
    date.setHours(fromDate.getHours(), fromDate.getMinutes(), fromDate.getSeconds(), fromDate.getMilliseconds());
    return date;
}
var // Fallback for modularized imports:
$3f6d75242ee5ce9e$export$2e2bcd8739ae039 = $3f6d75242ee5ce9e$export$9cb09a71b7d66923;

});




parcelRegister("jjQgY", function(module, exports) {

$parcel$export(module.exports, "YearParser", function () { return $f2f794738d41baa9$export$48d352de7cd4a988; });

var $jNSTi = parcelRequire("jNSTi");

var $8niB6 = parcelRequire("8niB6");
class $f2f794738d41baa9$export$48d352de7cd4a988 extends (0, $jNSTi.Parser) {
    priority = 130;
    incompatibleTokens = [
        "Y",
        "R",
        "u",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "yy"
            });
        switch(token){
            case "y":
                return (0, $8niB6.mapValue)((0, $8niB6.parseNDigits)(4, dateString), valueCallback);
            case "yo":
                return (0, $8niB6.mapValue)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $8niB6.mapValue)((0, $8niB6.parseNDigits)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value) {
        const currentYear = date.getFullYear();
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $8niB6.normalizeTwoDigitYear)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, 1);
            date.setHours(0, 0, 0, 0);
            return date;
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}

});
parcelRegister("8niB6", function(module, exports) {

$parcel$export(module.exports, "mapValue", function () { return $757049c89f8fba6a$export$4f84e3a82c7b538; });
$parcel$export(module.exports, "parseNumericPattern", function () { return $757049c89f8fba6a$export$cc7cc9e2a3ff9388; });
$parcel$export(module.exports, "parseTimezonePattern", function () { return $757049c89f8fba6a$export$6497f4c0ecdfba8e; });
$parcel$export(module.exports, "parseAnyDigitsSigned", function () { return $757049c89f8fba6a$export$d931c43c4608a164; });
$parcel$export(module.exports, "parseNDigits", function () { return $757049c89f8fba6a$export$513bb01536146ab6; });
$parcel$export(module.exports, "parseNDigitsSigned", function () { return $757049c89f8fba6a$export$2c9307b2e29c533c; });
$parcel$export(module.exports, "dayPeriodEnumToHours", function () { return $757049c89f8fba6a$export$fb506d2676e7f207; });
$parcel$export(module.exports, "normalizeTwoDigitYear", function () { return $757049c89f8fba6a$export$29126f735cbf69f7; });
$parcel$export(module.exports, "isLeapYearIndex", function () { return $757049c89f8fba6a$export$3d50627710b84d75; });

var $oijbG = parcelRequire("oijbG");

var $9cImL = parcelRequire("9cImL");
function $757049c89f8fba6a$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $757049c89f8fba6a$export$cc7cc9e2a3ff9388(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $757049c89f8fba6a$export$6497f4c0ecdfba8e(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    const sign = matchResult[1] === "+" ? 1 : -1;
    const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $oijbG.millisecondsInHour) + minutes * (0, $oijbG.millisecondsInMinute) + seconds * (0, $oijbG.millisecondsInSecond)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $757049c89f8fba6a$export$d931c43c4608a164(dateString) {
    return $757049c89f8fba6a$export$cc7cc9e2a3ff9388((0, $9cImL.numericPatterns).anyDigitsSigned, dateString);
}
function $757049c89f8fba6a$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $757049c89f8fba6a$export$cc7cc9e2a3ff9388((0, $9cImL.numericPatterns).singleDigit, dateString);
        case 2:
            return $757049c89f8fba6a$export$cc7cc9e2a3ff9388((0, $9cImL.numericPatterns).twoDigits, dateString);
        case 3:
            return $757049c89f8fba6a$export$cc7cc9e2a3ff9388((0, $9cImL.numericPatterns).threeDigits, dateString);
        case 4:
            return $757049c89f8fba6a$export$cc7cc9e2a3ff9388((0, $9cImL.numericPatterns).fourDigits, dateString);
        default:
            return $757049c89f8fba6a$export$cc7cc9e2a3ff9388(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $757049c89f8fba6a$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $757049c89f8fba6a$export$cc7cc9e2a3ff9388((0, $9cImL.numericPatterns).singleDigitSigned, dateString);
        case 2:
            return $757049c89f8fba6a$export$cc7cc9e2a3ff9388((0, $9cImL.numericPatterns).twoDigitsSigned, dateString);
        case 3:
            return $757049c89f8fba6a$export$cc7cc9e2a3ff9388((0, $9cImL.numericPatterns).threeDigitsSigned, dateString);
        case 4:
            return $757049c89f8fba6a$export$cc7cc9e2a3ff9388((0, $9cImL.numericPatterns).fourDigitsSigned, dateString);
        default:
            return $757049c89f8fba6a$export$cc7cc9e2a3ff9388(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $757049c89f8fba6a$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $757049c89f8fba6a$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    const isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    let result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        const rangeEnd = absCurrentYear + 50;
        const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
        const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $757049c89f8fba6a$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

});
parcelRegister("9cImL", function(module, exports) {

$parcel$export(module.exports, "numericPatterns", function () { return $afa3a2278a5cd428$export$c123ee06d9da8480; });
$parcel$export(module.exports, "timezonePatterns", function () { return $afa3a2278a5cd428$export$a7ee192b982af9c1; });
const $afa3a2278a5cd428$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    date: /^(3[0-1]|[0-2]?\d)/,
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    week: /^(5[0-3]|[0-4]?\d)/,
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    hour11h: /^(1[0-1]|0?\d)/,
    hour12h: /^(1[0-2]|0?\d)/,
    minute: /^[0-5]?\d/,
    second: /^[0-5]?\d/,
    singleDigit: /^\d/,
    twoDigits: /^\d{1,2}/,
    threeDigits: /^\d{1,3}/,
    fourDigits: /^\d{1,4}/,
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    twoDigitsSigned: /^-?\d{1,2}/,
    threeDigitsSigned: /^-?\d{1,3}/,
    fourDigitsSigned: /^-?\d{1,4}/
};
const $afa3a2278a5cd428$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

});



parcelRegister("dhcKB", function(module, exports) {

$parcel$export(module.exports, "LocalWeekYearParser", function () { return $8be054722f1605b7$export$b8ef38dfcf05d5db; });

var $gn4gH = parcelRequire("gn4gH");

var $6mnS4 = parcelRequire("6mnS4");

var $jNSTi = parcelRequire("jNSTi");

var $8niB6 = parcelRequire("8niB6");
class $8be054722f1605b7$export$b8ef38dfcf05d5db extends (0, $jNSTi.Parser) {
    priority = 130;
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "YY"
            });
        switch(token){
            case "Y":
                return (0, $8niB6.mapValue)((0, $8niB6.parseNDigits)(4, dateString), valueCallback);
            case "Yo":
                return (0, $8niB6.mapValue)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $8niB6.mapValue)((0, $8niB6.parseNDigits)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value, options) {
        const currentYear = (0, $gn4gH.getWeekYear)(date, options);
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $8niB6.normalizeTwoDigitYear)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
            date.setHours(0, 0, 0, 0);
            return (0, $6mnS4.startOfWeek)(date, options);
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, options.firstWeekContainsDate);
        date.setHours(0, 0, 0, 0);
        return (0, $6mnS4.startOfWeek)(date, options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}

});

parcelRegister("1Db4Z", function(module, exports) {

$parcel$export(module.exports, "ISOWeekYearParser", function () { return $a21e5322efa3c174$export$951d1df011fde06f; });

var $gGKcv = parcelRequire("gGKcv");

var $iNCNo = parcelRequire("iNCNo");

var $jNSTi = parcelRequire("jNSTi");

var $8niB6 = parcelRequire("8niB6");
class $a21e5322efa3c174$export$951d1df011fde06f extends (0, $jNSTi.Parser) {
    priority = 130;
    parse(dateString, token) {
        if (token === "R") return (0, $8niB6.parseNDigitsSigned)(4, dateString);
        return (0, $8niB6.parseNDigitsSigned)(token.length, dateString);
    }
    set(date, _flags, value) {
        const firstWeekOfYear = (0, $iNCNo.constructFrom)(date, 0);
        firstWeekOfYear.setFullYear(value, 0, 4);
        firstWeekOfYear.setHours(0, 0, 0, 0);
        return (0, $gGKcv.startOfISOWeek)(firstWeekOfYear);
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}

});
parcelRegister("gGKcv", function(module, exports) {

$parcel$export(module.exports, "startOfISOWeek", function () { return $ed2641348173c67a$export$6173213f95a4431e; });

var $6mnS4 = parcelRequire("6mnS4");
function $ed2641348173c67a$export$6173213f95a4431e(date) {
    return (0, $6mnS4.startOfWeek)(date, {
        weekStartsOn: 1
    });
}
var // Fallback for modularized imports:
$ed2641348173c67a$export$2e2bcd8739ae039 = $ed2641348173c67a$export$6173213f95a4431e;

});


parcelRegister("60rJV", function(module, exports) {

$parcel$export(module.exports, "ExtendedYearParser", function () { return $17248234b962a55b$export$bad9d2ea38e8f1a; });

var $jNSTi = parcelRequire("jNSTi");

var $8niB6 = parcelRequire("8niB6");
class $17248234b962a55b$export$bad9d2ea38e8f1a extends (0, $jNSTi.Parser) {
    priority = 130;
    parse(dateString, token) {
        if (token === "u") return (0, $8niB6.parseNDigitsSigned)(4, dateString);
        return (0, $8niB6.parseNDigitsSigned)(token.length, dateString);
    }
    set(date, _flags, value) {
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "R",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}

});

parcelRegister("g92mM", function(module, exports) {

$parcel$export(module.exports, "QuarterParser", function () { return $d0314afc878832f1$export$5cb0f701186dde1d; });

var $jNSTi = parcelRequire("jNSTi");

var $8niB6 = parcelRequire("8niB6");
class $d0314afc878832f1$export$5cb0f701186dde1d extends (0, $jNSTi.Parser) {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "Q":
            case "QQ":
                return (0, $8niB6.parseNDigits)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}

});

parcelRegister("7pW1D", function(module, exports) {

$parcel$export(module.exports, "StandAloneQuarterParser", function () { return $f9673933db70159c$export$300c0c2990e20e6d; });

var $jNSTi = parcelRequire("jNSTi");

var $8niB6 = parcelRequire("8niB6");
class $f9673933db70159c$export$300c0c2990e20e6d extends (0, $jNSTi.Parser) {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "q":
            case "qq":
                return (0, $8niB6.parseNDigits)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}

});

parcelRegister("4MkDY", function(module, exports) {

$parcel$export(module.exports, "MonthParser", function () { return $5642f4a624b73b5f$export$400dd8b40ef138a3; });

var $9cImL = parcelRequire("9cImL");

var $jNSTi = parcelRequire("jNSTi");

var $8niB6 = parcelRequire("8niB6");
class $5642f4a624b73b5f$export$400dd8b40ef138a3 extends (0, $jNSTi.Parser) {
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "L",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "M":
                return (0, $8niB6.mapValue)((0, $8niB6.parseNumericPattern)((0, $9cImL.numericPatterns).month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "MM":
                return (0, $8niB6.mapValue)((0, $8niB6.parseNDigits)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return (0, $8niB6.mapValue)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "MMM":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}

});

parcelRegister("laVqT", function(module, exports) {

$parcel$export(module.exports, "StandAloneMonthParser", function () { return $3d0b518f8ab93c96$export$1d7eaa53eaa5deba; });

var $9cImL = parcelRequire("9cImL");

var $jNSTi = parcelRequire("jNSTi");

var $8niB6 = parcelRequire("8niB6");
class $3d0b518f8ab93c96$export$1d7eaa53eaa5deba extends (0, $jNSTi.Parser) {
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return (0, $8niB6.mapValue)((0, $8niB6.parseNumericPattern)((0, $9cImL.numericPatterns).month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "LL":
                return (0, $8niB6.mapValue)((0, $8niB6.parseNDigits)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return (0, $8niB6.mapValue)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "LLL":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}

});

parcelRegister("gmrjT", function(module, exports) {

$parcel$export(module.exports, "LocalWeekParser", function () { return $a69403f81dd65985$export$c4005ffc174e07c0; });

var $3FMYh = parcelRequire("3FMYh");

var $6mnS4 = parcelRequire("6mnS4");

var $9cImL = parcelRequire("9cImL");

var $jNSTi = parcelRequire("jNSTi");

var $8niB6 = parcelRequire("8niB6");
class $a69403f81dd65985$export$c4005ffc174e07c0 extends (0, $jNSTi.Parser) {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "w":
                return (0, $8niB6.parseNumericPattern)((0, $9cImL.numericPatterns).week, dateString);
            case "wo":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $8niB6.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value, options) {
        return (0, $6mnS4.startOfWeek)((0, $3FMYh.setWeek)(date, value, options), options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}

});
parcelRegister("3FMYh", function(module, exports) {

$parcel$export(module.exports, "setWeek", function () { return $27fe515e67e331c1$export$4b3066ce4afafd88; });

var $2D7Jq = parcelRequire("2D7Jq");

var $l7oHg = parcelRequire("l7oHg");
function $27fe515e67e331c1$export$4b3066ce4afafd88(date, week, options) {
    const _date = (0, $l7oHg.toDate)(date);
    const diff = (0, $2D7Jq.getWeek)(_date, options) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}
var // Fallback for modularized imports:
$27fe515e67e331c1$export$2e2bcd8739ae039 = $27fe515e67e331c1$export$4b3066ce4afafd88;

});


parcelRegister("gMyg2", function(module, exports) {

$parcel$export(module.exports, "ISOWeekParser", function () { return $51a0c82e311cfe9a$export$6fc8dbedd560a6af; });

var $h7opP = parcelRequire("h7opP");

var $gGKcv = parcelRequire("gGKcv");

var $9cImL = parcelRequire("9cImL");

var $jNSTi = parcelRequire("jNSTi");

var $8niB6 = parcelRequire("8niB6");
class $51a0c82e311cfe9a$export$6fc8dbedd560a6af extends (0, $jNSTi.Parser) {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "I":
                return (0, $8niB6.parseNumericPattern)((0, $9cImL.numericPatterns).week, dateString);
            case "Io":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $8niB6.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value) {
        return (0, $gGKcv.startOfISOWeek)((0, $h7opP.setISOWeek)(date, value));
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}

});
parcelRegister("h7opP", function(module, exports) {

$parcel$export(module.exports, "setISOWeek", function () { return $49ccf7ecb6fdc2ec$export$6542bebf6be94082; });

var $8tYRe = parcelRequire("8tYRe");

var $l7oHg = parcelRequire("l7oHg");
function $49ccf7ecb6fdc2ec$export$6542bebf6be94082(date, week) {
    const _date = (0, $l7oHg.toDate)(date);
    const diff = (0, $8tYRe.getISOWeek)(_date) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}
var // Fallback for modularized imports:
$49ccf7ecb6fdc2ec$export$2e2bcd8739ae039 = $49ccf7ecb6fdc2ec$export$6542bebf6be94082;

});
parcelRegister("8tYRe", function(module, exports) {

$parcel$export(module.exports, "getISOWeek", function () { return $d450a171e31cb9de$export$7cabdc5698b63e2f; });

var $oijbG = parcelRequire("oijbG");

var $gGKcv = parcelRequire("gGKcv");

var $gLiCa = parcelRequire("gLiCa");

var $l7oHg = parcelRequire("l7oHg");
function $d450a171e31cb9de$export$7cabdc5698b63e2f(date) {
    const _date = (0, $l7oHg.toDate)(date);
    const diff = +(0, $gGKcv.startOfISOWeek)(_date) - +(0, $gLiCa.startOfISOWeekYear)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $oijbG.millisecondsInWeek)) + 1;
}
var // Fallback for modularized imports:
$d450a171e31cb9de$export$2e2bcd8739ae039 = $d450a171e31cb9de$export$7cabdc5698b63e2f;

});
parcelRegister("gLiCa", function(module, exports) {

$parcel$export(module.exports, "startOfISOWeekYear", function () { return $4bb54297e9bd8d6e$export$236bdfa374eb69a9; });

var $6vgQk = parcelRequire("6vgQk");

var $gGKcv = parcelRequire("gGKcv");

var $iNCNo = parcelRequire("iNCNo");
function $4bb54297e9bd8d6e$export$236bdfa374eb69a9(date) {
    const year = (0, $6vgQk.getISOWeekYear)(date);
    const fourthOfJanuary = (0, $iNCNo.constructFrom)(date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $gGKcv.startOfISOWeek)(fourthOfJanuary);
}
var // Fallback for modularized imports:
$4bb54297e9bd8d6e$export$2e2bcd8739ae039 = $4bb54297e9bd8d6e$export$236bdfa374eb69a9;

});
parcelRegister("6vgQk", function(module, exports) {

$parcel$export(module.exports, "getISOWeekYear", function () { return $8d92fe960afe960c$export$3dbc52535f6f8fcc; });

var $iNCNo = parcelRequire("iNCNo");

var $gGKcv = parcelRequire("gGKcv");

var $l7oHg = parcelRequire("l7oHg");
function $8d92fe960afe960c$export$3dbc52535f6f8fcc(date) {
    const _date = (0, $l7oHg.toDate)(date);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $iNCNo.constructFrom)(date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $gGKcv.startOfISOWeek)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $iNCNo.constructFrom)(date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $gGKcv.startOfISOWeek)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$8d92fe960afe960c$export$2e2bcd8739ae039 = $8d92fe960afe960c$export$3dbc52535f6f8fcc;

});





parcelRegister("e52Ud", function(module, exports) {

$parcel$export(module.exports, "DateParser", function () { return $bc8dbf9637bcd218$export$e8d4b28a20981dd2; });

var $9cImL = parcelRequire("9cImL");

var $jNSTi = parcelRequire("jNSTi");

var $8niB6 = parcelRequire("8niB6");
const $bc8dbf9637bcd218$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $bc8dbf9637bcd218$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
class $bc8dbf9637bcd218$export$e8d4b28a20981dd2 extends (0, $jNSTi.Parser) {
    priority = 90;
    subPriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "d":
                return (0, $8niB6.parseNumericPattern)((0, $9cImL.numericPatterns).date, dateString);
            case "do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $8niB6.parseNDigits)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $8niB6.isLeapYearIndex)(year);
        const month = date.getMonth();
        if (isLeapYear) return value >= 1 && value <= $bc8dbf9637bcd218$var$DAYS_IN_MONTH_LEAP_YEAR[month];
        else return value >= 1 && value <= $bc8dbf9637bcd218$var$DAYS_IN_MONTH[month];
    }
    set(date, _flags, value) {
        date.setDate(value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}

});

parcelRegister("8ulEM", function(module, exports) {

$parcel$export(module.exports, "DayOfYearParser", function () { return $50b3786bfd19f8c3$export$6cfe0d613455f615; });

var $9cImL = parcelRequire("9cImL");

var $jNSTi = parcelRequire("jNSTi");

var $8niB6 = parcelRequire("8niB6");
class $50b3786bfd19f8c3$export$6cfe0d613455f615 extends (0, $jNSTi.Parser) {
    priority = 90;
    subpriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "D":
            case "DD":
                return (0, $8niB6.parseNumericPattern)((0, $9cImL.numericPatterns).dayOfYear, dateString);
            case "Do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $8niB6.parseNDigits)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $8niB6.isLeapYearIndex)(year);
        if (isLeapYear) return value >= 1 && value <= 366;
        else return value >= 1 && value <= 365;
    }
    set(date, _flags, value) {
        date.setMonth(0, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "E",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}

});

parcelRegister("lSL5N", function(module, exports) {

$parcel$export(module.exports, "DayParser", function () { return $164f64e45aef957d$export$1b03c8b76262f7bd; });

var $efh1K = parcelRequire("efh1K");

var $jNSTi = parcelRequire("jNSTi");
class $164f64e45aef957d$export$1b03c8b76262f7bd extends (0, $jNSTi.Parser) {
    priority = 90;
    parse(dateString, token, match) {
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $efh1K.setDay)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}

});
parcelRegister("efh1K", function(module, exports) {

$parcel$export(module.exports, "setDay", function () { return $c1e585b27ab56868$export$b04fdcda82decc6c; });

var $2gXaN = parcelRequire("2gXaN");

var $l7oHg = parcelRequire("l7oHg");

var $8gw7j = parcelRequire("8gw7j");
function $c1e585b27ab56868$export$b04fdcda82decc6c(date, day, options) {
    const defaultOptions = (0, $8gw7j.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $l7oHg.toDate)(date);
    const currentDay = _date.getDay();
    const remainder = day % 7;
    const dayIndex = (remainder + 7) % 7;
    const delta = 7 - weekStartsOn;
    const diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
    return (0, $2gXaN.addDays)(_date, diff);
}
var // Fallback for modularized imports:
$c1e585b27ab56868$export$2e2bcd8739ae039 = $c1e585b27ab56868$export$b04fdcda82decc6c;

});


parcelRegister("bB4fF", function(module, exports) {

$parcel$export(module.exports, "LocalDayParser", function () { return $303c1b9ca89193d7$export$44d1c127ab42c480; });

var $efh1K = parcelRequire("efh1K");

var $jNSTi = parcelRequire("jNSTi");

var $8niB6 = parcelRequire("8niB6");
class $303c1b9ca89193d7$export$44d1c127ab42c480 extends (0, $jNSTi.Parser) {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "e":
            case "ee":
                return (0, $8niB6.mapValue)((0, $8niB6.parseNDigits)(token.length, dateString), valueCallback);
            // 3rd
            case "eo":
                return (0, $8niB6.mapValue)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "eee":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $efh1K.setDay)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "c",
        "t",
        "T"
    ];
}

});

parcelRegister("56tpI", function(module, exports) {

$parcel$export(module.exports, "StandAloneLocalDayParser", function () { return $1cb7c3f0e615fdf7$export$e447a647caaaec1d; });

var $efh1K = parcelRequire("efh1K");

var $jNSTi = parcelRequire("jNSTi");

var $8niB6 = parcelRequire("8niB6");
class $1cb7c3f0e615fdf7$export$e447a647caaaec1d extends (0, $jNSTi.Parser) {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "c":
            case "cc":
                return (0, $8niB6.mapValue)((0, $8niB6.parseNDigits)(token.length, dateString), valueCallback);
            // 3rd
            case "co":
                return (0, $8niB6.mapValue)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "ccc":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $efh1K.setDay)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "e",
        "t",
        "T"
    ];
}

});

parcelRegister("40szr", function(module, exports) {

$parcel$export(module.exports, "ISODayParser", function () { return $84b71e16eeb5a426$export$693fb1e525095b2a; });

var $JHiOK = parcelRequire("JHiOK");

var $jNSTi = parcelRequire("jNSTi");

var $8niB6 = parcelRequire("8niB6");
class $84b71e16eeb5a426$export$693fb1e525095b2a extends (0, $jNSTi.Parser) {
    priority = 90;
    parse(dateString, token, match) {
        const valueCallback = (value)=>{
            if (value === 0) return 7;
            return value;
        };
        switch(token){
            // 2
            case "i":
            case "ii":
                return (0, $8niB6.parseNDigits)(token.length, dateString);
            // 2nd
            case "io":
                return match.ordinalNumber(dateString, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return (0, $8niB6.mapValue)(match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // T
            case "iiiii":
                return (0, $8niB6.mapValue)(match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tu
            case "iiiiii":
                return (0, $8niB6.mapValue)(match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tuesday
            case "iiii":
            default:
                return (0, $8niB6.mapValue)(match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 7;
    }
    set(date, _flags, value) {
        date = (0, $JHiOK.setISODay)(date, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "E",
        "e",
        "c",
        "t",
        "T"
    ];
}

});
parcelRegister("JHiOK", function(module, exports) {

$parcel$export(module.exports, "setISODay", function () { return $cf19223aee530102$export$1fd9df65adb0d1aa; });

var $2gXaN = parcelRequire("2gXaN");

var $aMKiO = parcelRequire("aMKiO");

var $l7oHg = parcelRequire("l7oHg");
function $cf19223aee530102$export$1fd9df65adb0d1aa(date, day) {
    const _date = (0, $l7oHg.toDate)(date);
    const currentDay = (0, $aMKiO.getISODay)(_date);
    const diff = day - currentDay;
    return (0, $2gXaN.addDays)(_date, diff);
}
var // Fallback for modularized imports:
$cf19223aee530102$export$2e2bcd8739ae039 = $cf19223aee530102$export$1fd9df65adb0d1aa;

});
parcelRegister("aMKiO", function(module, exports) {

$parcel$export(module.exports, "getISODay", function () { return $c81a27a2afa709e6$export$c514f4c1a8ed5e9e; });

var $l7oHg = parcelRequire("l7oHg");
function $c81a27a2afa709e6$export$c514f4c1a8ed5e9e(date) {
    const _date = (0, $l7oHg.toDate)(date);
    let day = _date.getDay();
    if (day === 0) day = 7;
    return day;
}
var // Fallback for modularized imports:
$c81a27a2afa709e6$export$2e2bcd8739ae039 = $c81a27a2afa709e6$export$c514f4c1a8ed5e9e;

});



parcelRegister("f0KWL", function(module, exports) {

$parcel$export(module.exports, "AMPMParser", function () { return $8361223347215179$export$8d1e08492351df91; });

var $jNSTi = parcelRequire("jNSTi");

var $8niB6 = parcelRequire("8niB6");
class $8361223347215179$export$8d1e08492351df91 extends (0, $jNSTi.Parser) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "a":
            case "aa":
            case "aaa":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaaa":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $8niB6.dayPeriodEnumToHours)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "b",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}

});

parcelRegister("9pLTk", function(module, exports) {

$parcel$export(module.exports, "AMPMMidnightParser", function () { return $4a3851ed0169315d$export$73ca2bd0a17d273; });

var $jNSTi = parcelRequire("jNSTi");

var $8niB6 = parcelRequire("8niB6");
class $4a3851ed0169315d$export$73ca2bd0a17d273 extends (0, $jNSTi.Parser) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "b":
            case "bb":
            case "bbb":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbbb":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $8niB6.dayPeriodEnumToHours)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}

});

parcelRegister("e5ZC1", function(module, exports) {

$parcel$export(module.exports, "DayPeriodParser", function () { return $1b227c0bf2b970b8$export$bb9212adf05373db; });

var $jNSTi = parcelRequire("jNSTi");

var $8niB6 = parcelRequire("8niB6");
class $1b227c0bf2b970b8$export$bb9212adf05373db extends (0, $jNSTi.Parser) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBBB":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $8niB6.dayPeriodEnumToHours)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "t",
        "T"
    ];
}

});

parcelRegister("a1aKY", function(module, exports) {

$parcel$export(module.exports, "Hour1to12Parser", function () { return $43d5b433ab403294$export$8a04050a727a1756; });

var $9cImL = parcelRequire("9cImL");

var $jNSTi = parcelRequire("jNSTi");

var $8niB6 = parcelRequire("8niB6");
class $43d5b433ab403294$export$8a04050a727a1756 extends (0, $jNSTi.Parser) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "h":
                return (0, $8niB6.parseNumericPattern)((0, $9cImL.numericPatterns).hour12h, dateString);
            case "ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $8niB6.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 12;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else if (!isPM && value === 12) date.setHours(0, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "H",
        "K",
        "k",
        "t",
        "T"
    ];
}

});

parcelRegister("k4YB1", function(module, exports) {

$parcel$export(module.exports, "Hour0to23Parser", function () { return $c5d1fb069db200b6$export$e56f4dea2c3e56dd; });

var $9cImL = parcelRequire("9cImL");

var $jNSTi = parcelRequire("jNSTi");

var $8niB6 = parcelRequire("8niB6");
class $c5d1fb069db200b6$export$e56f4dea2c3e56dd extends (0, $jNSTi.Parser) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "H":
                return (0, $8niB6.parseNumericPattern)((0, $9cImL.numericPatterns).hour23h, dateString);
            case "Ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $8niB6.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 23;
    }
    set(date, _flags, value) {
        date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "K",
        "k",
        "t",
        "T"
    ];
}

});

parcelRegister("5Cc5l", function(module, exports) {

$parcel$export(module.exports, "Hour0To11Parser", function () { return $b8685a8a1e7e4755$export$cbbe855312f87d77; });

var $9cImL = parcelRequire("9cImL");

var $jNSTi = parcelRequire("jNSTi");

var $8niB6 = parcelRequire("8niB6");
class $b8685a8a1e7e4755$export$cbbe855312f87d77 extends (0, $jNSTi.Parser) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "K":
                return (0, $8niB6.parseNumericPattern)((0, $9cImL.numericPatterns).hour11h, dateString);
            case "Ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $8niB6.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "h",
        "H",
        "k",
        "t",
        "T"
    ];
}

});

parcelRegister("gy8py", function(module, exports) {

$parcel$export(module.exports, "Hour1To24Parser", function () { return $d7168295d2ad0d59$export$6008046d2b34b6a5; });

var $9cImL = parcelRequire("9cImL");

var $jNSTi = parcelRequire("jNSTi");

var $8niB6 = parcelRequire("8niB6");
class $d7168295d2ad0d59$export$6008046d2b34b6a5 extends (0, $jNSTi.Parser) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "k":
                return (0, $8niB6.parseNumericPattern)((0, $9cImL.numericPatterns).hour24h, dateString);
            case "ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $8niB6.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 24;
    }
    set(date, _flags, value) {
        const hours = value <= 24 ? value % 24 : value;
        date.setHours(hours, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "H",
        "K",
        "t",
        "T"
    ];
}

});

parcelRegister("2mkFW", function(module, exports) {

$parcel$export(module.exports, "MinuteParser", function () { return $ec95ad8231419d45$export$2b52670d9e2be53; });

var $9cImL = parcelRequire("9cImL");

var $jNSTi = parcelRequire("jNSTi");

var $8niB6 = parcelRequire("8niB6");
class $ec95ad8231419d45$export$2b52670d9e2be53 extends (0, $jNSTi.Parser) {
    priority = 60;
    parse(dateString, token, match) {
        switch(token){
            case "m":
                return (0, $8niB6.parseNumericPattern)((0, $9cImL.numericPatterns).minute, dateString);
            case "mo":
                return match.ordinalNumber(dateString, {
                    unit: "minute"
                });
            default:
                return (0, $8niB6.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setMinutes(value, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}

});

parcelRegister("jMDHK", function(module, exports) {

$parcel$export(module.exports, "SecondParser", function () { return $7968d6401aca9035$export$94d46d540cf1366a; });

var $9cImL = parcelRequire("9cImL");

var $jNSTi = parcelRequire("jNSTi");

var $8niB6 = parcelRequire("8niB6");
class $7968d6401aca9035$export$94d46d540cf1366a extends (0, $jNSTi.Parser) {
    priority = 50;
    parse(dateString, token, match) {
        switch(token){
            case "s":
                return (0, $8niB6.parseNumericPattern)((0, $9cImL.numericPatterns).second, dateString);
            case "so":
                return match.ordinalNumber(dateString, {
                    unit: "second"
                });
            default:
                return (0, $8niB6.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setSeconds(value, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}

});

parcelRegister("fumye", function(module, exports) {

$parcel$export(module.exports, "FractionOfSecondParser", function () { return $e2d3b68ea0daaa7e$export$b8e6f8b2d70893b1; });

var $jNSTi = parcelRequire("jNSTi");

var $8niB6 = parcelRequire("8niB6");
class $e2d3b68ea0daaa7e$export$b8e6f8b2d70893b1 extends (0, $jNSTi.Parser) {
    priority = 30;
    parse(dateString, token) {
        const valueCallback = (value)=>Math.trunc(value * Math.pow(10, -token.length + 3));
        return (0, $8niB6.mapValue)((0, $8niB6.parseNDigits)(token.length, dateString), valueCallback);
    }
    set(date, _flags, value) {
        date.setMilliseconds(value);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}

});

parcelRegister("cY9V1", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneWithZParser", function () { return $292ab9167b744457$export$104d901d49fea29b; });

var $iNCNo = parcelRequire("iNCNo");

var $afwzU = parcelRequire("afwzU");

var $9cImL = parcelRequire("9cImL");

var $jNSTi = parcelRequire("jNSTi");

var $8niB6 = parcelRequire("8niB6");
class $292ab9167b744457$export$104d901d49fea29b extends (0, $jNSTi.Parser) {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "X":
                return (0, $8niB6.parseTimezonePattern)((0, $9cImL.timezonePatterns).basicOptionalMinutes, dateString);
            case "XX":
                return (0, $8niB6.parseTimezonePattern)((0, $9cImL.timezonePatterns).basic, dateString);
            case "XXXX":
                return (0, $8niB6.parseTimezonePattern)((0, $9cImL.timezonePatterns).basicOptionalSeconds, dateString);
            case "XXXXX":
                return (0, $8niB6.parseTimezonePattern)((0, $9cImL.timezonePatterns).extendedOptionalSeconds, dateString);
            case "XXX":
            default:
                return (0, $8niB6.parseTimezonePattern)((0, $9cImL.timezonePatterns).extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $iNCNo.constructFrom)(date, date.getTime() - (0, $afwzU.getTimezoneOffsetInMilliseconds)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "x"
    ];
}

});
parcelRegister("afwzU", function(module, exports) {

$parcel$export(module.exports, "getTimezoneOffsetInMilliseconds", function () { return $b13d59a8d4ddc496$export$113002b5eff6e430; });

var $l7oHg = parcelRequire("l7oHg");
function $b13d59a8d4ddc496$export$113002b5eff6e430(date) {
    const _date = (0, $l7oHg.toDate)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}

});


parcelRegister("5YhxX", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneParser", function () { return $5d966ed18042cf2f$export$12910e5204b52b9; });

var $iNCNo = parcelRequire("iNCNo");

var $afwzU = parcelRequire("afwzU");

var $9cImL = parcelRequire("9cImL");

var $jNSTi = parcelRequire("jNSTi");

var $8niB6 = parcelRequire("8niB6");
class $5d966ed18042cf2f$export$12910e5204b52b9 extends (0, $jNSTi.Parser) {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "x":
                return (0, $8niB6.parseTimezonePattern)((0, $9cImL.timezonePatterns).basicOptionalMinutes, dateString);
            case "xx":
                return (0, $8niB6.parseTimezonePattern)((0, $9cImL.timezonePatterns).basic, dateString);
            case "xxxx":
                return (0, $8niB6.parseTimezonePattern)((0, $9cImL.timezonePatterns).basicOptionalSeconds, dateString);
            case "xxxxx":
                return (0, $8niB6.parseTimezonePattern)((0, $9cImL.timezonePatterns).extendedOptionalSeconds, dateString);
            case "xxx":
            default:
                return (0, $8niB6.parseTimezonePattern)((0, $9cImL.timezonePatterns).extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $iNCNo.constructFrom)(date, date.getTime() - (0, $afwzU.getTimezoneOffsetInMilliseconds)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "X"
    ];
}

});

parcelRegister("47WRO", function(module, exports) {

$parcel$export(module.exports, "TimestampSecondsParser", function () { return $0c0fc0dfb4d0a639$export$2cd8bf877a05e96; });

var $iNCNo = parcelRequire("iNCNo");

var $jNSTi = parcelRequire("jNSTi");

var $8niB6 = parcelRequire("8niB6");
class $0c0fc0dfb4d0a639$export$2cd8bf877a05e96 extends (0, $jNSTi.Parser) {
    priority = 40;
    parse(dateString) {
        return (0, $8niB6.parseAnyDigitsSigned)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $iNCNo.constructFrom)(date, value * 1000),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}

});

parcelRegister("bL7da", function(module, exports) {

$parcel$export(module.exports, "TimestampMillisecondsParser", function () { return $e90336eb212bdbd1$export$6d8f69c6906d6368; });

var $iNCNo = parcelRequire("iNCNo");

var $jNSTi = parcelRequire("jNSTi");

var $8niB6 = parcelRequire("8niB6");
class $e90336eb212bdbd1$export$6d8f69c6906d6368 extends (0, $jNSTi.Parser) {
    priority = 20;
    parse(dateString) {
        return (0, $8niB6.parseAnyDigitsSigned)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $iNCNo.constructFrom)(date, value),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}

});




parcelRegister("1AaEu", function(module, exports) {

$parcel$export(module.exports, "setOrganisationReport", function () { return $20b25e9678236c8d$export$447d9eb2f4688ef2; });
$parcel$export(module.exports, "setReportData", function () { return $20b25e9678236c8d$export$b4af916732271762; });
$parcel$export(module.exports, "setIsLoadingReportData", function () { return $20b25e9678236c8d$export$73b176e19d58db01; });
$parcel$export(module.exports, "setColumns", function () { return $20b25e9678236c8d$export$cfc099c0be5cff67; });
$parcel$export(module.exports, "setPendingChanges", function () { return $20b25e9678236c8d$export$17dcaa9d506ee1de; });
$parcel$export(module.exports, "useReportData", function () { return $20b25e9678236c8d$export$5937a5b9379177ff; });
$parcel$export(module.exports, "useOrganisationReport", function () { return $20b25e9678236c8d$export$30415e21906d195c; });
$parcel$export(module.exports, "useIsLoadingReportData", function () { return $20b25e9678236c8d$export$2ea3c65c90de2aa8; });
$parcel$export(module.exports, "usePendingChanges", function () { return $20b25e9678236c8d$export$b69a3814d0f14d43; });

var $hxM7m = parcelRequire("hxM7m");

var $lJ1OS = parcelRequire("lJ1OS");
// Initial state
const $20b25e9678236c8d$var$initialContext = {
    reportData: null,
    organisationReport: null,
    isLoadingReportData: false,
    columns: null,
    listProjects: [],
    listPhases: [],
    listTasks: [],
    pendingChanges: false
};
const $20b25e9678236c8d$export$44a231413b5659f9 = (0, $hxM7m.createStore)({
    context: $20b25e9678236c8d$var$initialContext,
    on: {
        setOrganisationReport: {
            organisationReport: (_, event)=>event.report,
            pendingChanges: (_, event)=>{
                var _event$options$needsR, _event$options;
                return (_event$options$needsR = (_event$options = event.options) === null || _event$options === void 0 ? void 0 : _event$options.needsRefetch) !== null && _event$options$needsR !== void 0 ? _event$options$needsR : true;
            }
        },
        setReportData: {
            reportData: (_, event)=>event.data
        },
        setIsLoadingReportData: {
            isLoadingReportData: (_, event)=>event.isLoading
        },
        setColumns: {
            organisationReport: (context, event)=>{
                if (!context.organisationReport) return null;
                return {
                    ...context.organisationReport,
                    columns: event.columns
                };
            },
            pendingChanges: (_, event)=>{
                var _event$options$needsR2, _event$options2;
                return (_event$options$needsR2 = (_event$options2 = event.options) === null || _event$options2 === void 0 ? void 0 : _event$options2.needsRefetch) !== null && _event$options$needsR2 !== void 0 ? _event$options$needsR2 : true;
            }
        },
        setPendingChanges: {
            pendingChanges: (_, event)=>event.pending
        }
    }
});
const $20b25e9678236c8d$export$447d9eb2f4688ef2 = (report, options)=>$20b25e9678236c8d$export$44a231413b5659f9.send({
        type: "setOrganisationReport",
        report: report,
        options: options
    });
const $20b25e9678236c8d$export$b4af916732271762 = (data)=>$20b25e9678236c8d$export$44a231413b5659f9.send({
        type: "setReportData",
        data: data
    });
const $20b25e9678236c8d$export$73b176e19d58db01 = (isLoading)=>$20b25e9678236c8d$export$44a231413b5659f9.send({
        type: "setIsLoadingReportData",
        isLoading: isLoading
    });
const $20b25e9678236c8d$export$cfc099c0be5cff67 = (columns, options)=>$20b25e9678236c8d$export$44a231413b5659f9.send({
        type: "setColumns",
        columns: columns,
        options: options
    });
const $20b25e9678236c8d$export$17dcaa9d506ee1de = (pending)=>$20b25e9678236c8d$export$44a231413b5659f9.send({
        type: "setPendingChanges",
        pending: pending
    });
const $20b25e9678236c8d$export$5937a5b9379177ff = ()=>(0, $lJ1OS.useSelector)($20b25e9678236c8d$export$44a231413b5659f9, (state)=>state.context.reportData);
const $20b25e9678236c8d$export$30415e21906d195c = ()=>(0, $lJ1OS.useSelector)($20b25e9678236c8d$export$44a231413b5659f9, (state)=>state.context.organisationReport);
const $20b25e9678236c8d$export$2ea3c65c90de2aa8 = ()=>(0, $lJ1OS.useSelector)($20b25e9678236c8d$export$44a231413b5659f9, (state)=>state.context.isLoadingReportData);
const $20b25e9678236c8d$export$c97dded465ef56fb = ()=>(0, $lJ1OS.useSelector)($20b25e9678236c8d$export$44a231413b5659f9, (state)=>{
        var _state$context$organi;
        return (_state$context$organi = state.context.organisationReport) === null || _state$context$organi === void 0 ? void 0 : _state$context$organi.columns;
    });
const $20b25e9678236c8d$export$b69a3814d0f14d43 = ()=>(0, $lJ1OS.useSelector)($20b25e9678236c8d$export$44a231413b5659f9, (state)=>state.context.pendingChanges);
const $20b25e9678236c8d$export$fb18f5a89a479f8e = ()=>$20b25e9678236c8d$export$44a231413b5659f9.getSnapshot().context.reportData;
const $20b25e9678236c8d$export$6fcab24359f687f6 = ()=>$20b25e9678236c8d$export$44a231413b5659f9.getSnapshot().context.organisationReport;

});

parcelRegister("l9mxF", function(module, exports) {

$parcel$export(module.exports, "TimeReportActions", function () { return $1b4cbe866e26d0c0$export$51576af0ec3be3df; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $gN0TC = parcelRequire("gN0TC");

var $cV8g5 = parcelRequire("cV8g5");

var $6mjwz = parcelRequire("6mjwz");

var $3h7sC = parcelRequire("3h7sC");

var $1BTI2 = parcelRequire("1BTI2");

var $6UBLf = parcelRequire("6UBLf");

var $O2UPo = parcelRequire("O2UPo");

var $dHs32 = parcelRequire("dHs32");

var $1AaEu = parcelRequire("1AaEu");

var $38AIP = parcelRequire("38AIP");

var $26sX2 = parcelRequire("26sX2");

var $kKJbF = parcelRequire("kKJbF");

var $bAwxh = parcelRequire("bAwxh");
function $1b4cbe866e26d0c0$export$51576af0ec3be3df({ table: table, exportColumns: exportColumns = [] }) {
    var _SessionStore$organis;
    const [dialogContent, setDialogContent] = (0, $jbmdS.useState)(null);
    const [nameReport, setNameReport] = (0, $jbmdS.useState)(null);
    const organisationReport = (0, $1AaEu.useOrganisationReport)();
    const navigate = (0, $6UBLf.useNavigate)();
    const checkDisableButton = !(organisationReport !== null && organisationReport !== void 0 && organisationReport.id) && !((_SessionStore$organis = (0, $1BTI2.default).organisation) !== null && _SessionStore$organis !== void 0 && _SessionStore$organis.defaultTimeReportId);
    const handleOpenDialog = (content)=>{
        setNameReport(null);
        setDialogContent(content);
    };
    const showSaveAsToast = (0, $bAwxh.useSaveToast)({
        saveId: "timesheet-report-save-as",
        onSave: async ()=>{
            const newId = $gN0TC();
            const result = await (0, $3h7sC.trpc).timeReport.saveReport.mutate({
                id: newId,
                name: nameReport,
                filters: organisationReport.filters,
                type: "timesheet",
                groupBy: organisationReport.groupBy,
                columns: organisationReport.columns,
                options: organisationReport.options
            });
            (0, $38AIP.addCacheItem)("organisationReports", {
                id: newId,
                name: nameReport,
                type: "timesheet"
            });
            setNameReport(null);
            setDialogContent(null);
            (0, $1AaEu.setOrganisationReport)({
                ...organisationReport,
                ...result
            });
            navigate({
                search: {
                    report: newId
                }
            });
        },
        loadingMessage: "Saving new report...",
        successMessage: "New report saved successfully",
        errorMessage: "Failed to save new report"
    });
    // Save existing report
    const showSaveToast = (0, $bAwxh.useSaveToast)({
        saveId: "timesheet-report-save",
        onSave: async ()=>{
            const result = await (0, $3h7sC.trpc).timeReport.saveReport.mutate({
                id: organisationReport.id,
                organisationId: organisationReport.organisationId,
                groupBy: organisationReport.groupBy,
                filters: organisationReport.filters,
                columns: organisationReport.columns,
                options: organisationReport.options
            });
            setDialogContent(null);
            (0, $1AaEu.setOrganisationReport)({
                ...organisationReport,
                ...result
            });
            return result;
        },
        loadingMessage: "Saving report...",
        successMessage: "Report saved successfully",
        errorMessage: "Failed to save report"
    });
    // Rename operation
    const showRenameToast = (0, $bAwxh.useSaveToast)({
        saveId: "timesheet-report-rename",
        onSave: async ()=>{
            if (!nameReport || nameReport === organisationReport.name) return;
            const result = await (0, $3h7sC.trpc).timeReport.saveReport.mutate({
                id: organisationReport.id,
                organisationId: organisationReport.organisationId,
                name: nameReport
            });
            (0, $38AIP.updateCacheItem)("organisationReports", organisationReport.id, {
                name: nameReport,
                type: "timesheet"
            });
            (0, $26sX2.setPageTitle)(nameReport);
            setNameReport(null);
            setDialogContent(null);
            (0, $1AaEu.setOrganisationReport)({
                ...organisationReport,
                ...result
            });
            return result;
        },
        loadingMessage: "Renaming report...",
        successMessage: "Report renamed successfully",
        errorMessage: "Failed to rename report"
    });
    // Delete operation
    const showDeleteToast = (0, $bAwxh.useSaveToast)({
        saveId: "timesheet-report-delete",
        onSave: async ()=>{
            const result = await (0, $3h7sC.trpc).timeReport.saveReport.mutate({
                id: organisationReport.id,
                organisationId: organisationReport.organisationId,
                deletedAt: new Date()
            });
            (0, $38AIP.deleteCacheItem)("organisationReports", organisationReport.id);
            setDialogContent(null);
            navigate({
                search: {}
            });
            return result;
        },
        loadingMessage: "Deleting report...",
        successMessage: "Report deleted successfully",
        errorMessage: "Failed to delete report"
    });
    // Set Default operation
    const showSaveDefaultToast = (0, $bAwxh.useSaveToast)({
        saveId: "timesheet-report-set-default",
        onSave: async ()=>{
            return await (0, $3h7sC.trpc).timeReport.setDefaultReport.mutate({
                id: organisationReport.id
            });
        },
        loadingMessage: "Setting as default...",
        successMessage: "Set as default report",
        errorMessage: "Failed to set as default"
    });
    const handleSetDefault = async ()=>{
        showSaveDefaultToast();
    };
    const handleDialogSubmit = async (dialogContent)=>{
        switch(dialogContent){
            case "Save as":
                showSaveAsToast();
                break;
            case "Save":
                showSaveToast();
                break;
            case "Rename Report":
                showRenameToast();
                break;
            case "Delete Report":
                showDeleteToast();
                break;
            default:
                break;
        }
        setDialogContent(null);
    };
    const handleExportToCSV = (type)=>{
        const level = organisationReport.groupBy.indexOf(type);
        const data = table.getExpandedRowModel().flatRows.filter((row)=>level >= 0 ? row.depth == level : row.depth == organisationReport.groupBy.length);
        const listColumnsExport = [];
        listColumnsExport.push(...organisationReport.groupBy, ...organisationReport.columns.filter((column)=>!organisationReport.groupBy.includes(column)));
        const columnsCSV = (0, $kKJbF.orderColumnDefs)(table.getAllColumns().filter((c)=>![
                "expand",
                "select",
                "label"
            ].includes(c.id) && listColumnsExport.includes(c.id)), organisationReport.columns, organisationReport.groupBy, []);
        const csv = [];
        csv.push(columnsCSV.map((c)=>{
            var _c$columnDef, _c$columnDef$meta;
            return c === null || c === void 0 ? void 0 : (_c$columnDef = c.columnDef) === null || _c$columnDef === void 0 ? void 0 : (_c$columnDef$meta = _c$columnDef.meta) === null || _c$columnDef$meta === void 0 ? void 0 : _c$columnDef$meta.title;
        }));
        csv.push(...data.map((r)=>columnsCSV.map((c)=>{
                return (0, $O2UPo.csvFormatter)(r, c);
            })));
        (0, (/*@__PURE__*/$parcel$interopDefault($cV8g5)))((0, (/*@__PURE__*/$parcel$interopDefault($6mjwz))).unparse(csv), `Default timesheet.csv`, "text/csv");
    };
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $dHs32.DataTableActions), {
            handleExportToCSV: handleExportToCSV,
            handleDialogSubmit: handleDialogSubmit,
            handleOpenDialog: handleOpenDialog,
            handleSetDefault: handleSetDefault,
            dialogContent: dialogContent,
            setDialogContent: setDialogContent,
            setNameReport: setNameReport,
            nameReport: nameReport,
            organisationReport: organisationReport,
            checkDisableButton: checkDisableButton,
            exportColumns: exportColumns
        })
    });
}

});

parcelRegister("iqFxy", function(module, exports) {

$parcel$export(module.exports, "TimeReportTableFloatingBar", function () { return $c304405b93dc13cf$export$62e010ba955dec4d; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $jSiTu = parcelRequire("jSiTu");

var $9yFzD = parcelRequire("9yFzD");

var $84Chd = parcelRequire("84Chd");

var $7sV27 = parcelRequire("7sV27");

var $fTGwv = parcelRequire("fTGwv");

var $cOk0s = parcelRequire("cOk0s");

var $38AIP = parcelRequire("38AIP");

var $3h7sC = parcelRequire("3h7sC");

var $9d62S = parcelRequire("9d62S");

var $1AaEu = parcelRequire("1AaEu");
const $c304405b93dc13cf$var$getConsistentValue = (arr, key)=>{
    const uniqueValues = new Set(arr.map((obj)=>obj.original[key]));
    return uniqueValues.size === 1 ? [
        ...uniqueValues
    ][0] || null : null;
};
function $c304405b93dc13cf$export$62e010ba955dec4d({ table: table }) {
    const queryClient = (0, $9d62S.useQueryClient)();
    const rows = $jbmdS.useMemo(()=>{
        const rows = table.getFilteredRowModel().rows;
        const selectedRows = [];
        const getSelectedLeafRows = (row)=>{
            // If this is a leaf row and it's selected, add it
            if (!row.subRows.length && row.getIsSelected()) {
                selectedRows.push(row);
                return;
            }
            // If this is a parent row, check its subrows
            row.subRows.forEach((subRow)=>{
                getSelectedLeafRows(subRow);
            });
        };
        // Process all root rows
        rows.forEach((row)=>{
            // If root row is selected with no children, add it
            if (row.getIsSelected() && !row.subRows.length) selectedRows.push(row);
            else if (row.subRows.length) getSelectedLeafRows(row);
        });
        return selectedRows;
    }, [
        table.getFilteredRowModel().rows,
        table.getState().rowSelection
    ]);
    const getAllSelectedRows = (row)=>{
        var _row$subRows;
        if (!((_row$subRows = row.subRows) !== null && _row$subRows !== void 0 && _row$subRows.length)) return [
            row
        ];
        return row.subRows.flatMap((c)=>getAllSelectedRows(c));
    };
    const selectedRows = $jbmdS.useMemo(()=>{
        return rows.flatMap((row)=>{
            return getAllSelectedRows(row);
        });
    }, [
        rows
    ]);
    // Clear selection on Escape key press
    $jbmdS.useEffect(()=>{
        function handleKeyDown(event) {
            if (event.key === "Escape") table.toggleAllRowsSelected(false);
        }
        window.addEventListener("keydown", handleKeyDown);
        return ()=>window.removeEventListener("keydown", handleKeyDown);
    }, [
        table
    ]);
    const [isOpenDialog, setIsOpenDialog] = $jbmdS.useState(false);
    const [isEditingReport, setIsEditingReport] = $jbmdS.useState(false);
    const [updateError, setUpdateError] = $jbmdS.useState(false);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $84Chd.Portal), {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7sV27.TooltipProvider), {
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "absolute inset-x-0 bottom-6 z-50 mx-auto w-fit px-2.5",
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            className: "w-full overflow-x-auto",
                            children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                className: "mx-auto flex w-fit items-center gap-2 rounded-md border bg-background p-2 text-foreground shadow",
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                        className: "flex h-7 items-center rounded-md border border-dashed pl-2.5 pr-1",
                                        children: [
                                            /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                                                className: "whitespace-nowrap text-xs",
                                                children: [
                                                    rows.length,
                                                    " selected"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $9yFzD.Separator), {
                                                orientation: "vertical",
                                                className: "ml-2 mr-1"
                                            }),
                                            /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $7sV27.Tooltip), {
                                                children: [
                                                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7sV27.TooltipTrigger), {
                                                        asChild: true,
                                                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fTGwv.Button), {
                                                            variant: "ghost",
                                                            size: "icon",
                                                            className: "size-5 hover:border",
                                                            onClick: ()=>table.toggleAllRowsSelected(false),
                                                            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jSiTu.Cross2Icon), {
                                                                className: "size-3.5 shrink-0",
                                                                "aria-hidden": "true"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7sV27.TooltipContent), {
                                                        className: "flex items-center border bg-accent px-2 py-1 font-semibold text-foreground dark:bg-zinc-900",
                                                        children: /*#__PURE__*/ (0, $61Ea1.jsx)("p", {
                                                            className: "mr-2",
                                                            children: "Clear selection"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $9yFzD.Separator), {
                                        orientation: "vertical",
                                        className: "hidden h-5 sm:block"
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7sV27.Tooltip), {
                                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7sV27.TooltipTrigger), {
                                            asChild: true,
                                            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fTGwv.Button), {
                                                "aria-label": "Toggle columns",
                                                className: "flex h-7 items-center border",
                                                variant: "secondary",
                                                size: "sm",
                                                onClick: ()=>{
                                                    setIsOpenDialog(true);
                                                },
                                                children: /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                                    className: "whitespace-nowrap text-xs",
                                                    children: "Edit"
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $cOk0s.EditTimeEntryModal), {
                table: table,
                isOpenDialog: isOpenDialog,
                setIsOpenDialog: setIsOpenDialog,
                timeEntries: selectedRows,
                onSave: async (data)=>{
                    try {
                        setIsEditingReport(true);
                        await (0, $3h7sC.trpc).timeReport.updateTimeEntry.mutate(data);
                        setIsOpenDialog(false);
                        table.resetRowSelection(false);
                        await queryClient.invalidateQueries({
                            queryKey: [
                                "timeReportCache"
                            ]
                        });
                        await queryClient.refetchQueries({
                            queryKey: [
                                "timeReportCache"
                            ]
                        });
                        const queryData = await queryClient.fetchQuery({
                            queryKey: [
                                "timeReportCache"
                            ]
                        });
                        (0, $1AaEu.setReportData)(queryData);
                    } catch (err) {
                        setIsEditingReport(false);
                        setUpdateError(true);
                    }
                },
                isEditingReport: isEditingReport,
                updateError: updateError,
                showAllFlags: true,
                placeholders: {
                    project: "Leave Project Unchanged",
                    phase: "Leave Phase Unchanged",
                    task: "Leave Task Unchanged"
                },
                selectDefaults: false,
                defaults: {
                    project: (0, $38AIP.getCacheItemById)("projects", $c304405b93dc13cf$var$getConsistentValue(selectedRows, "projectId")),
                    phase: (0, $38AIP.getCacheItemById)("phases", $c304405b93dc13cf$var$getConsistentValue(selectedRows, "phaseId")),
                    task: (0, $38AIP.getCacheItemById)("tasks", $c304405b93dc13cf$var$getConsistentValue(selectedRows, "taskId")),
                    isBillable: $c304405b93dc13cf$var$getConsistentValue(selectedRows, "isBillable"),
                    isVariation: $c304405b93dc13cf$var$getConsistentValue(selectedRows, "isVariation"),
                    isOvertime: $c304405b93dc13cf$var$getConsistentValue(selectedRows, "isOvertime"),
                    beenInvoiced: $c304405b93dc13cf$var$getConsistentValue(selectedRows, "beenInvoiced"),
                    isLocked: $c304405b93dc13cf$var$getConsistentValue(selectedRows, "isLocked")
                }
            })
        ]
    });
}

});
parcelRegister("9yFzD", function(module, exports) {

$parcel$export(module.exports, "Separator", function () { return $1228b880ffb32bd8$export$1ff3c3f08ae963c0; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $hYTDA = parcelRequire("hYTDA");

var $Yha9m = parcelRequire("Yha9m");
const $1228b880ffb32bd8$export$1ff3c3f08ae963c0 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, orientation: orientation = "horizontal", decorative: decorative = true, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)($hYTDA.Root, {
        ref: ref,
        decorative: decorative,
        orientation: orientation,
        className: (0, $Yha9m.cn)("shrink-0 bg-border", orientation === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]", className),
        ...props
    }));
$1228b880ffb32bd8$export$1ff3c3f08ae963c0.displayName = $hYTDA.Root.displayName;

});
parcelRegister("hYTDA", function(module, exports) {

$parcel$export(module.exports, "Root", function () { return $8aabfae5d145160a$export$be92b6f5f03c0fe9; });
// packages/react/separator/src/Separator.tsx

var $jbmdS = parcelRequire("jbmdS");

var $cihg9 = parcelRequire("cihg9");

var $4TLFw = parcelRequire("4TLFw");
var $8aabfae5d145160a$var$NAME = "Separator";
var $8aabfae5d145160a$var$DEFAULT_ORIENTATION = "horizontal";
var $8aabfae5d145160a$var$ORIENTATIONS = [
    "horizontal",
    "vertical"
];
var $8aabfae5d145160a$export$1ff3c3f08ae963c0 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { decorative: decorative, orientation: orientationProp = $8aabfae5d145160a$var$DEFAULT_ORIENTATION, ...domProps } = props;
    const orientation = $8aabfae5d145160a$var$isValidOrientation(orientationProp) ? orientationProp : $8aabfae5d145160a$var$DEFAULT_ORIENTATION;
    const ariaOrientation = orientation === "vertical" ? orientation : void 0;
    const semanticProps = decorative ? {
        role: "none"
    } : {
        "aria-orientation": ariaOrientation,
        role: "separator"
    };
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).div, {
        "data-orientation": orientation,
        ...semanticProps,
        ...domProps,
        ref: forwardedRef
    });
});
$8aabfae5d145160a$export$1ff3c3f08ae963c0.displayName = $8aabfae5d145160a$var$NAME;
function $8aabfae5d145160a$var$isValidOrientation(orientation) {
    return $8aabfae5d145160a$var$ORIENTATIONS.includes(orientation);
}
var $8aabfae5d145160a$export$be92b6f5f03c0fe9 = $8aabfae5d145160a$export$1ff3c3f08ae963c0;

});


parcelRegister("84Chd", function(module, exports) {

$parcel$export(module.exports, "Portal", function () { return $57286b04f2b93e42$export$602eac185826482c; });

var $fKp8B = parcelRequire("fKp8B");
"use client";
const $57286b04f2b93e42$export$602eac185826482c = $fKp8B.Root;

});

parcelRegister("cOk0s", function(module, exports) {

$parcel$export(module.exports, "EditTimeEntryModal", function () { return $700ea8e8a6ffbc36$export$e3f84c8c8400c248; });

var $61Ea1 = parcelRequire("61Ea1");

var $8jD92 = parcelRequire("8jD92");

var $jbmdS = parcelRequire("jbmdS");

var $5QoiI = parcelRequire("5QoiI");

var $38AIP = parcelRequire("38AIP");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $15gHp = parcelRequire("15gHp");

var $6Q5sp = parcelRequire("6Q5sp");

var $3h7sC = parcelRequire("3h7sC");
function $700ea8e8a6ffbc36$export$e3f84c8c8400c248({ table: table, isOpenDialog: isOpenDialog, setIsOpenDialog: setIsOpenDialog, timeEntries: timeEntries, dates: dates, staff: staff, store: store, heading: heading, onSave: onSave, showAllFlags: showAllFlags, placeholders: placeholders, selectDefaults: selectDefaults = true, defaults: defaults, isEditingReport: isEditingReport, updateError: updateError }) {
    var _timeEntries$, _timeEntries$$origina, _timeEntries$2, _timeEntries$2$origin, _timeEntries$3, _timeEntries$3$origin, _ref, _ref2, _timeEntries$0$origin, _timeEntries$4, _timeEntries$4$origin, _timeEntries$5, _timeEntries$5$origin, _timeEntries$5$origin2, _timeEntries$6, _timeEntries$6$origin, _timeEntries$6$origin2, _timeEntries$6$origin3, _ref3, _timeEntries$0$origin2, _timeEntries$7, _timeEntries$7$origin, _timeEntries$8, _timeEntries$8$origin, _timeEntries$8$origin2, _timeEntries$0$origin3, _timeEntries$9, _timeEntries$9$origin, _timeEntries$0$origin4, _timeEntries$10, _timeEntries$10$origi, _timeEntries$0$origin5, _timeEntries$11, _timeEntries$11$origi, _timeEntries$0$origin6, _timeEntries$12, _timeEntries$12$origi, _timeEntries$0$origin7, _timeEntries$13, _timeEntries$13$origi;
    const prefetchPhases = (projectId)=>{
        (0, $6Q5sp.queryClient).prefetchQuery({
            queryKey: [
                "project-phases",
                projectId
            ],
            queryFn: ()=>(0, $3h7sC.trpc).global.getPhaseTasks.query({
                    projectId: projectId
                }),
            staleTime: 300000
        });
    };
    const cache = (0, $38AIP.useCache)();
    const [project, setProject] = (0, $jbmdS.useState)(defaults ? defaults.project : (_timeEntries$ = timeEntries[0]) === null || _timeEntries$ === void 0 ? void 0 : (_timeEntries$$origina = _timeEntries$.original) === null || _timeEntries$$origina === void 0 ? void 0 : _timeEntries$$origina.project);
    const [phase, setPhase] = (0, $jbmdS.useState)(defaults ? defaults.phase : timeEntries === null || timeEntries === void 0 ? void 0 : (_timeEntries$2 = timeEntries[0]) === null || _timeEntries$2 === void 0 ? void 0 : (_timeEntries$2$origin = _timeEntries$2.original) === null || _timeEntries$2$origin === void 0 ? void 0 : _timeEntries$2$origin.phase);
    const [task, setTask] = (0, $jbmdS.useState)(defaults ? defaults.task : timeEntries === null || timeEntries === void 0 ? void 0 : (_timeEntries$3 = timeEntries[0]) === null || _timeEntries$3 === void 0 ? void 0 : (_timeEntries$3$origin = _timeEntries$3.original) === null || _timeEntries$3$origin === void 0 ? void 0 : _timeEntries$3$origin.task);
    const [phaseOptions, setPhaseOptions] = (0, $jbmdS.useState)(defaults.project ? (0, $38AIP.getFilteredCacheItems)("phases", (item)=>item.projectId === defaults.project.id) : []);
    const [taskOptions, setTaskOptions] = (0, $jbmdS.useState)(defaults.phase ? (0, $38AIP.getFilteredCacheItems)("tasks", (item)=>item.phaseId === defaults.phase.id) : []);
    const [isBillable, setIsBillable] = (0, $jbmdS.useState)(defaults ? defaults.isBillable : (_ref = (_ref2 = (_timeEntries$0$origin = timeEntries === null || timeEntries === void 0 ? void 0 : (_timeEntries$4 = timeEntries[0]) === null || _timeEntries$4 === void 0 ? void 0 : (_timeEntries$4$origin = _timeEntries$4.original) === null || _timeEntries$4$origin === void 0 ? void 0 : _timeEntries$4$origin.isBillable) !== null && _timeEntries$0$origin !== void 0 ? _timeEntries$0$origin : timeEntries === null || timeEntries === void 0 ? void 0 : (_timeEntries$5 = timeEntries[0]) === null || _timeEntries$5 === void 0 ? void 0 : (_timeEntries$5$origin = _timeEntries$5.original) === null || _timeEntries$5$origin === void 0 ? void 0 : (_timeEntries$5$origin2 = _timeEntries$5$origin.task) === null || _timeEntries$5$origin2 === void 0 ? void 0 : _timeEntries$5$origin2.isBillable) !== null && _ref2 !== void 0 ? _ref2 : timeEntries === null || timeEntries === void 0 ? void 0 : (_timeEntries$6 = timeEntries[0]) === null || _timeEntries$6 === void 0 ? void 0 : (_timeEntries$6$origin = _timeEntries$6.original) === null || _timeEntries$6$origin === void 0 ? void 0 : (_timeEntries$6$origin2 = _timeEntries$6$origin.project) === null || _timeEntries$6$origin2 === void 0 ? void 0 : (_timeEntries$6$origin3 = _timeEntries$6$origin2.costCentre) === null || _timeEntries$6$origin3 === void 0 ? void 0 : _timeEntries$6$origin3.isBillable) !== null && _ref !== void 0 ? _ref : true);
    const [isVariation, setIsVariation] = (0, $jbmdS.useState)(defaults ? defaults.isVariation : (_ref3 = (_timeEntries$0$origin2 = timeEntries === null || timeEntries === void 0 ? void 0 : (_timeEntries$7 = timeEntries[0]) === null || _timeEntries$7 === void 0 ? void 0 : (_timeEntries$7$origin = _timeEntries$7.original) === null || _timeEntries$7$origin === void 0 ? void 0 : _timeEntries$7$origin.isVariation) !== null && _timeEntries$0$origin2 !== void 0 ? _timeEntries$0$origin2 : timeEntries === null || timeEntries === void 0 ? void 0 : (_timeEntries$8 = timeEntries[0]) === null || _timeEntries$8 === void 0 ? void 0 : (_timeEntries$8$origin = _timeEntries$8.original) === null || _timeEntries$8$origin === void 0 ? void 0 : (_timeEntries$8$origin2 = _timeEntries$8$origin.task) === null || _timeEntries$8$origin2 === void 0 ? void 0 : _timeEntries$8$origin2.isVariation) !== null && _ref3 !== void 0 ? _ref3 : false);
    const [isOvertime, setIsOvertime] = (0, $jbmdS.useState)(defaults ? defaults.isOvertime : (_timeEntries$0$origin3 = timeEntries === null || timeEntries === void 0 ? void 0 : (_timeEntries$9 = timeEntries[0]) === null || _timeEntries$9 === void 0 ? void 0 : (_timeEntries$9$origin = _timeEntries$9.original) === null || _timeEntries$9$origin === void 0 ? void 0 : _timeEntries$9$origin.isOvertime) !== null && _timeEntries$0$origin3 !== void 0 ? _timeEntries$0$origin3 : false);
    const [isRemote, setIsRemote] = (0, $jbmdS.useState)(defaults ? defaults.isRemote : (_timeEntries$0$origin4 = timeEntries === null || timeEntries === void 0 ? void 0 : (_timeEntries$10 = timeEntries[0]) === null || _timeEntries$10 === void 0 ? void 0 : (_timeEntries$10$origi = _timeEntries$10.original) === null || _timeEntries$10$origi === void 0 ? void 0 : _timeEntries$10$origi.isRemote) !== null && _timeEntries$0$origin4 !== void 0 ? _timeEntries$0$origin4 : false);
    const [isFlexi, setIsFlexi] = (0, $jbmdS.useState)(defaults ? defaults.isFlexi : (_timeEntries$0$origin5 = timeEntries === null || timeEntries === void 0 ? void 0 : (_timeEntries$11 = timeEntries[0]) === null || _timeEntries$11 === void 0 ? void 0 : (_timeEntries$11$origi = _timeEntries$11.original) === null || _timeEntries$11$origi === void 0 ? void 0 : _timeEntries$11$origi.isFlexi) !== null && _timeEntries$0$origin5 !== void 0 ? _timeEntries$0$origin5 : false);
    const [beenInvoiced, setBeenInvoiced] = (0, $jbmdS.useState)(defaults ? defaults.beenInvoiced : (_timeEntries$0$origin6 = timeEntries === null || timeEntries === void 0 ? void 0 : (_timeEntries$12 = timeEntries[0]) === null || _timeEntries$12 === void 0 ? void 0 : (_timeEntries$12$origi = _timeEntries$12.original) === null || _timeEntries$12$origi === void 0 ? void 0 : _timeEntries$12$origi.beenInvoiced) !== null && _timeEntries$0$origin6 !== void 0 ? _timeEntries$0$origin6 : false);
    const [isLocked, setIsLocked] = (0, $jbmdS.useState)(defaults ? defaults.isLocked : (_timeEntries$0$origin7 = timeEntries === null || timeEntries === void 0 ? void 0 : (_timeEntries$13 = timeEntries[0]) === null || _timeEntries$13 === void 0 ? void 0 : (_timeEntries$13$origi = _timeEntries$13.original) === null || _timeEntries$13$origi === void 0 ? void 0 : _timeEntries$13$origi.isLocked) !== null && _timeEntries$0$origin7 !== void 0 ? _timeEntries$0$origin7 : false);
    const getSelectedData = ()=>{
        return {
            data: Object.fromEntries([
                project ? [
                    "costCentreId",
                    project.costCentreId
                ] : null,
                project ? [
                    "projectId",
                    project.id
                ] : null,
                phase ? [
                    "phaseId",
                    phase.id
                ] : null,
                task ? [
                    "taskId",
                    task.id
                ] : null,
                isBillable != null ? [
                    "isBillable",
                    isBillable
                ] : null,
                isVariation != null ? [
                    "isVariation",
                    isVariation
                ] : null,
                isOvertime != null ? [
                    "isOvertime",
                    isOvertime
                ] : null,
                isRemote != null ? [
                    "isRemote",
                    isRemote
                ] : null,
                isFlexi != null ? [
                    "isFlexi",
                    isFlexi
                ] : null,
                beenInvoiced != null ? [
                    "beenInvoiced",
                    beenInvoiced
                ] : null,
                isLocked != null ? [
                    "isLocked",
                    isLocked
                ] : null
            ].filter((v)=>v)),
            ids: timeEntries.map((timeEntry)=>{
                var _timeEntry$original;
                return timeEntry === null || timeEntry === void 0 ? void 0 : (_timeEntry$original = timeEntry.original) === null || _timeEntry$original === void 0 ? void 0 : _timeEntry$original.timeEntryId;
            }).filter((v)=>v)
        };
    };
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $15gHp.Modal), {
            isOpenDialog: isOpenDialog,
            setIsOpenDialog: setIsOpenDialog,
            heading: heading || (timeEntries ? "Edit Timesheet Entries" : "New Timesheet Entry"),
            onSave: ()=>{
                if (onSave) return onSave(getSelectedData());
                timeEntries;
            },
            styleSaveButton: {
                border: updateError ? "1px #ef4444 solid" : ""
            },
            saveLabel: isEditingReport ? "Loading..." : updateError ? "Try again" : timeEntries ? "Edit Time Entries" : "Add Time Entries",
            canSave: ()=>showAllFlags || project && ((0, $8kZ1o.canLogTimeAgainstNoPhase)() || phase),
            isLoading: isEditingReport,
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    className: "pb-2",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            className: "flex items-center justify-between mb-2",
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("label", {
                                    className: "font-medium mr-4",
                                    children: "Project"
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5QoiI.ProjectSelector), {
                                    value: project,
                                    options: cache.projects.filter((p)=>(0, $8kZ1o.canEnterTimeAgainstProject)((0, $1BTI2.default).user, p)),
                                    onChange: (pr)=>{
                                        var _phaseData$phases, _phaseData$tasks;
                                        const phaseData = (0, $6Q5sp.queryClient).getQueryData([
                                            "project-phases",
                                            pr === null || pr === void 0 ? void 0 : pr.id
                                        ]);
                                        const phase = (phaseData === null || phaseData === void 0 ? void 0 : (_phaseData$phases = phaseData.phases) === null || _phaseData$phases === void 0 ? void 0 : _phaseData$phases[0]) || null;
                                        const task = (phaseData === null || phaseData === void 0 ? void 0 : (_phaseData$tasks = phaseData.tasks) === null || _phaseData$tasks === void 0 ? void 0 : _phaseData$tasks.find((t)=>t.phaseId === (phase === null || phase === void 0 ? void 0 : phase.id) && t.isDefault)) || null;
                                        setProject(pr);
                                        setPhase(phase);
                                        setTask(task);
                                        if (selectDefaults) {
                                            var _pr$costCentre;
                                            setIsBillable(pr === null || pr === void 0 ? void 0 : (_pr$costCentre = pr.costCentre) === null || _pr$costCentre === void 0 ? void 0 : _pr$costCentre.isBillable);
                                            setIsVariation(false);
                                            setIsOvertime(false);
                                        }
                                    },
                                    placeholder: "Leave Project Unchanged",
                                    clearable: true,
                                    itemProps: {
                                        onMouseEnter: (pr)=>prefetchPhases(pr.id),
                                        onFocus: (pr)=>prefetchPhases(pr.id)
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            className: "flex flex-row items-center justify-between mb-2",
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("label", {
                                    className: "font-medium mr-4",
                                    children: "Phase"
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5QoiI.PhaseSelector), {
                                    projectId: project === null || project === void 0 ? void 0 : project.id,
                                    value: phase,
                                    onChange: (ph)=>{
                                        var _phaseData$phases2, _phaseData$tasks2, _phaseData$tasks3;
                                        const phaseData = (0, $6Q5sp.queryClient).getQueryData([
                                            "project-phases",
                                            project === null || project === void 0 ? void 0 : project.id
                                        ]);
                                        const phase = (phaseData === null || phaseData === void 0 ? void 0 : (_phaseData$phases2 = phaseData.phases) === null || _phaseData$phases2 === void 0 ? void 0 : _phaseData$phases2.find((p)=>p.id === (ph === null || ph === void 0 ? void 0 : ph.id))) || null;
                                        const task = (phaseData === null || phaseData === void 0 ? void 0 : (_phaseData$tasks2 = phaseData.tasks) === null || _phaseData$tasks2 === void 0 ? void 0 : _phaseData$tasks2.find((t)=>t.phaseId === (phase === null || phase === void 0 ? void 0 : phase.id) && t.isDefault)) || (phaseData === null || phaseData === void 0 ? void 0 : (_phaseData$tasks3 = phaseData.tasks) === null || _phaseData$tasks3 === void 0 ? void 0 : _phaseData$tasks3.find((t)=>t.phaseId === (phase === null || phase === void 0 ? void 0 : phase.id))) || null;
                                        setPhase(phase);
                                        if (task) {
                                            setTask(task);
                                            if (selectDefaults) {
                                                setIsBillable(task === null || task === void 0 ? void 0 : task.isBillable);
                                                setIsVariation(task === null || task === void 0 ? void 0 : task.isVariation);
                                                setIsOvertime(false);
                                            }
                                        }
                                    },
                                    placeholder: "Leave Phase Unchanged",
                                    clearable: true
                                })
                            ]
                        }),
                        (0, $8kZ1o.canLogTimeAgainstTasks)() ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            className: "flex flex-row items-center justify-between mb-2",
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("label", {
                                    className: "font-medium mr-4",
                                    children: "Task"
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5QoiI.TaskSelector), {
                                    value: task,
                                    projectId: project === null || project === void 0 ? void 0 : project.id,
                                    phaseId: phase === null || phase === void 0 ? void 0 : phase.id,
                                    onChange: (task)=>{
                                        setTask(task);
                                        if (selectDefaults) {
                                            setIsBillable(task === null || task === void 0 ? void 0 : task.isBillable);
                                            setIsVariation(task === null || task === void 0 ? void 0 : task.isVariation);
                                            setIsOvertime(false);
                                        }
                                    },
                                    placeholder: "Leave Task Unchanged",
                                    clearable: true
                                })
                            ]
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    className: "border-b border-b-[#ccc] border-t border-t-[#ccc] pb-2 pt-2 flex justify-around",
                    children: [
                        showAllFlags || (0, $8kZ1o.canUseTimeEntryFlag)("billable") ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8jD92.Checkbox), {
                                    style: {
                                        borderColor: "#000",
                                        marginRight: 5
                                    },
                                    id: "billable-checkbox",
                                    onClick: ()=>setIsBillable((prevState)=>!prevState),
                                    checked: isBillable === null ? "indeterminate" : isBillable,
                                    value: isBillable == null ? "indeterminate" : isBillable
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)("label", {
                                    htmlFor: "billable-checkbox",
                                    className: "font-medium cursor-pointer",
                                    children: "Billable"
                                })
                            ]
                        }) : null,
                        showAllFlags || (0, $8kZ1o.canUseTimeEntryFlag)("variation") ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8jD92.Checkbox), {
                                    style: {
                                        borderColor: "#000",
                                        marginRight: 5
                                    },
                                    id: "variation-checkbox",
                                    onClick: ()=>setIsVariation((prevState)=>!prevState),
                                    checked: isVariation === null ? "indeterminate" : isVariation,
                                    value: isVariation == null ? "indeterminate" : isVariation
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)("label", {
                                    htmlFor: "variation-checkbox",
                                    className: "font-medium cursor-pointer",
                                    children: "Variation"
                                })
                            ]
                        }) : null,
                        showAllFlags || (0, $8kZ1o.canUseTimeEntryFlag)("overtime") ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8jD92.Checkbox), {
                                    style: {
                                        borderColor: "#000",
                                        marginRight: 5
                                    },
                                    id: "overtime-checkbox",
                                    onClick: ()=>setIsOvertime((prevState)=>!prevState),
                                    checked: isOvertime === null ? "indeterminate" : isOvertime,
                                    value: isOvertime == null ? "indeterminate" : isOvertime
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)("label", {
                                    htmlFor: "overtime-checkbox",
                                    className: "font-medium cursor-pointer",
                                    children: "Overtime"
                                })
                            ]
                        }) : null,
                        (0, $8kZ1o.canUseTimeEntryFlag)("remote") ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8jD92.Checkbox), {
                                    style: {
                                        borderColor: "#000",
                                        marginRight: 5
                                    },
                                    id: "remote-checkbox",
                                    className: "remote-checkbox",
                                    checked: isRemote === null ? "indeterminate" : isRemote,
                                    value: isRemote == null ? "indeterminate" : isRemote,
                                    onClick: ()=>setIsRemote((prevState)=>!prevState)
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)("label", {
                                    htmlFor: "remote-checkbox",
                                    className: "font-medium cursor-pointer",
                                    children: "Remote"
                                })
                            ]
                        }) : null,
                        (0, $8kZ1o.canUseTimeEntryFlag)("flex") ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8jD92.Checkbox), {
                                    style: {
                                        borderColor: "#000",
                                        marginRight: 5
                                    },
                                    id: "is-flexi-checkbox",
                                    className: "is-flexi-checkbox",
                                    checked: isFlexi === null ? "indeterminate" : isFlexi,
                                    value: isFlexi == null ? "indeterminate" : isFlexi,
                                    onClick: ()=>setIsFlexi((prevState)=>!prevState)
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)("label", {
                                    htmlFor: "is-flexi-checkbox",
                                    className: "font-medium cursor-pointer",
                                    children: "Flexi"
                                })
                            ]
                        }) : null,
                        showAllFlags && (0, $8kZ1o.canEditStaffTime)((0, $1BTI2.default).user) ? /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                    className: "flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8jD92.Checkbox), {
                                            "aria-label": "Select all",
                                            style: {
                                                borderColor: "#000",
                                                marginRight: 5
                                            },
                                            id: "invoiced-checkbox",
                                            onClick: ()=>setBeenInvoiced((prevState)=>!prevState),
                                            checked: beenInvoiced === null ? "indeterminate" : beenInvoiced,
                                            value: beenInvoiced == null ? "indeterminate" : beenInvoiced
                                        }),
                                        /*#__PURE__*/ (0, $61Ea1.jsx)("label", {
                                            htmlFor: "invoiced-checkbox",
                                            className: "font-medium cursor-pointer",
                                            children: "Invoiced"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                    className: "flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8jD92.Checkbox), {
                                            "aria-label": "Select all",
                                            style: {
                                                borderColor: "#000",
                                                marginRight: 5
                                            },
                                            id: "locked-checkbox",
                                            onClick: ()=>setIsLocked((prevState)=>!prevState),
                                            checked: isLocked === null ? "indeterminate" : isLocked,
                                            value: isLocked == null ? "indeterminate" : isLocked
                                        }),
                                        /*#__PURE__*/ (0, $61Ea1.jsx)("label", {
                                            htmlFor: "locked-checkbox",
                                            className: "font-medium cursor-pointer",
                                            children: "Locked"
                                        })
                                    ]
                                })
                            ]
                        }) : null
                    ]
                })
            ]
        })
    });
}

});
parcelRegister("15gHp", function(module, exports) {

$parcel$export(module.exports, "Modal", function () { return $30c740eba4308f32$export$2b77a92f1a5ad772; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $cKXEy = parcelRequire("cKXEy");

var $fTGwv = parcelRequire("fTGwv");

var $5QoiI = parcelRequire("5QoiI");
const $30c740eba4308f32$export$2b77a92f1a5ad772 = ({ isOpenDialog: isOpenDialog, setIsOpenDialog: setIsOpenDialog, style: style, bodyStyle: bodyStyle, children: children, onSave: onSave, saveLabel: saveLabel, saveOptions: saveOptions, saveButtons: saveButtons, styleSaveButton: styleSaveButton, defaultSaveOption: defaultSaveOption, heading: heading, isLoading: isLoading, canSave: canSave = ()=>true, ...props })=>{
    const [selectedSaveOption, setSelectedSaveOption] = (0, $jbmdS.useState)(saveOptions !== null && saveOptions !== void 0 && saveOptions.length ? saveOptions.find((o)=>o.id === defaultSaveOption) || saveOptions[0] : null);
    console.log(styleSaveButton);
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $cKXEy.Dialog), {
            open: isOpenDialog,
            onOpenChange: ()=>setIsOpenDialog(false),
            children: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $cKXEy.DialogContent), {
                className: "sm:max-w-[630px]",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $cKXEy.DialogHeader), {
                        className: "border-b border-b-[#ccc]",
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $cKXEy.DialogTitle), {
                            children: heading
                        })
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        style: bodyStyle,
                        children: children
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $cKXEy.DialogFooter), {
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $cKXEy.DialogClose), {
                                asChild: true,
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fTGwv.Button), {
                                    type: "button",
                                    variant: "secondary",
                                    children: "Close"
                                })
                            }),
                            saveButtons && saveButtons.map(({ label: label, onClick: onClick })=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $fTGwv.Button), {
                                    className: "btn btn-success",
                                    style: {
                                        marginLeft: "1em"
                                    },
                                    onClick: ()=>{
                                        onClick();
                                        setIsOpenDialog(false);
                                    },
                                    children: label
                                }, label)),
                            !!onSave && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fTGwv.Button), {
                                style: styleSaveButton,
                                disabled: !canSave() || isLoading,
                                onClick: onSave,
                                children: saveLabel
                            }),
                            saveOptions !== null && saveOptions !== void 0 && saveOptions.length ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5QoiI.Selector), {
                                disableOption: ()=>!canSave(),
                                options: saveOptions,
                                getLabel: (o)=>o.label,
                                onChange: setSelectedSaveOption,
                                className: "max-w-max"
                            }) : null
                        ]
                    })
                ]
            })
        })
    });
};

});





parcelRegister("5M65g", function(module, exports) {

$parcel$export(module.exports, "TimeReportColumns", function () { return $43462794a5744bb6$export$b09dcabc134e2643; });
parcelRequire("eat5C");

var $fUWIW = parcelRequire("fUWIW");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $4hBm1 = parcelRequire("4hBm1");
const $43462794a5744bb6$export$b09dcabc134e2643 = (report)=>({
        project: {
            id: "project",
            label: "Project",
            type: "project",
            width: 20,
            value: (row)=>row.project,
            format: (project)=>{
                return project;
            }
        },
        projectPhase: {
            id: "projectPhase",
            label: "Phase",
            type: "text",
            width: 20,
            value: (row)=>{
                return row.projectPhase;
            }
        },
        projectStatus: {
            id: "projectStatus",
            label: "Project Status",
            type: "status",
            width: 20,
            value: (row)=>{
                return row.projectStatus;
            }
        },
        phaseStatus: {
            id: "phaseStatus",
            label: "Phase Status",
            type: "status",
            width: 20,
            value: (row)=>{
                return row.phaseStatus;
            }
        },
        staffMember: {
            id: "staffMember",
            label: "Staff",
            type: "staffMember",
            width: 20,
            value: (row)=>{
                return row.staffMember;
            },
            format: (staff)=>staff
        },
        task: {
            id: "task",
            label: "Task",
            type: "text",
            width: 20,
            value: (row)=>{
                return row.task;
            }
        },
        date: {
            id: "date",
            label: "Date",
            type: "date",
            width: 10,
            aggregate: "same",
            value: (row)=>{
                return row.date ? new Date(row.date) : null;
            }
        },
        createdAt: {
            id: "createdAt",
            label: "Created At",
            type: "date",
            width: 10,
            aggregate: "same",
            value: (row)=>{
                return row.createdAt ? new Date(row.createdAt) : null;
            }
        },
        updatedAt: {
            id: "updatedAt",
            label: "Updated At",
            type: "date",
            width: 10,
            aggregate: "same",
            value: (row)=>{
                return row.updatedAt ? new Date(row.updatedAt) : null;
            }
        },
        numMinutes: {
            id: "numMinutes",
            label: "Hours",
            type: "number",
            width: 10,
            aggregate: "sum",
            value: (row)=>{
                return row.numMinutes;
            }
        },
        billableHours: {
            id: "billableHours",
            label: "Billable Hours",
            type: "number",
            width: 10,
            aggregate: "sum",
            value: (row)=>{
                return row.billableHours;
            }
        },
        nonBillableHours: {
            id: "nonBillableHours",
            label: "Non-Billable Hours",
            type: "number",
            width: 10,
            aggregate: "sum",
            value: (row)=>{
                return row.nonBillableHours;
            }
        },
        percentBillable: {
            id: "percentBillable",
            label: "Percent Billable",
            type: "percent",
            width: 10,
            aggregate: "avg",
            value: (row)=>{
                return row.percentBillable;
            }
        },
        notes: {
            id: "notes",
            label: "Notes",
            type: "text",
            width: 30,
            value: (row)=>{
                return row.notes;
            }
        },
        costCentre: {
            id: "costCentre",
            label: "Cost Centre",
            type: "costCentre",
            width: 15,
            value: (row)=>{
                return row.costCentre;
            },
            format: (costCentre)=>costCentre
        },
        staffCostCentre: {
            id: "staffCostCentre",
            label: "Staff Cost Centre",
            type: "costCentre",
            width: 15,
            value: (row)=>{
                return row.staffCostCentre;
            },
            format: (costCentre)=>costCentre
        },
        projectOwner: {
            id: "projectOwner",
            label: "Project Owner",
            type: "staffMember",
            width: 20,
            value: (row)=>{
                return row.projectOwner;
            },
            format: (staff)=>staff
        },
        projectContact: {
            id: "projectContact",
            label: "Project Client",
            type: "contact",
            width: 20,
            value: (row)=>{
                return row.projectContact;
            },
            format: (contact)=>contact
        },
        projectInvoiceContact: {
            id: "projectInvoiceContact",
            label: "Project Primary Contact",
            type: "contact",
            width: 20,
            value: (row)=>{
                return row.projectInvoiceContact;
            },
            format: (contact)=>contact,
            permissions: (row)=>(0, $8kZ1o.canViewPrimaryContact)()
        },
        projectCode: {
            id: "projectCode",
            label: "Project Code",
            type: "text",
            width: 20,
            value: (row)=>{
                return row.projectCode;
            }
        },
        projectPhaseCode: {
            id: "projectPhaseCode",
            label: "Phase Code",
            type: "text",
            width: 20,
            value: (row)=>{
                return row.projectPhaseCode;
            }
        },
        staffMemberFirstName: {
            id: "staffMemberFirstName",
            label: "Staff First Name",
            type: "text",
            width: 20,
            value: (row)=>{
                return row.staffMemberFirstName;
            }
        },
        staffMemberLastName: {
            id: "staffMemberLastName",
            label: "Staff Last Name",
            type: "text",
            width: 20,
            value: (row)=>{
                return row.staffMemberLastName;
            }
        },
        staffRole: {
            id: "staffRole",
            label: "Staff Role",
            type: "role",
            width: 20,
            value: (row)=>{
                return row.staffRole;
            },
            format: (v)=>v
        },
        monthIndex: {
            id: "monthIndex",
            label: "Month",
            type: "text",
            width: 20,
            format: (month)=>month && (0, $4hBm1.format)((0, $4hBm1.parse)(month, "yyyy-MM", new Date()), "MMM yyyy"),
            value: (row)=>{
                return row === null || row === void 0 ? void 0 : row.monthIndex;
            }
        },
        isBillable: {
            id: "isBillable",
            label: "Is Billable",
            type: "boolean",
            width: 20,
            value: (row)=>{
                return row.isBillable;
            }
        },
        isVariation: {
            id: "isVariation",
            label: "Is Variation",
            type: "boolean",
            width: 20,
            value: (row)=>{
                return row.isVariation;
            }
        },
        isOvertime: {
            id: "isOvertime",
            label: "Is Overtime",
            type: "boolean",
            width: 20,
            value: (row)=>{
                return row.isOvertime;
            }
        },
        isLocked: {
            id: "isLocked",
            label: "Is Locked",
            type: "boolean",
            width: 20,
            value: (row)=>{
                return row.isLocked;
            }
        },
        beenInvoiced: {
            id: "beenInvoiced",
            label: "Has Been Invoiced",
            type: "boolean",
            width: 20,
            value: (row)=>{
                return row.beenInvoiced;
            }
        },
        flexi: {
            id: "flexi",
            label: "Flexi",
            type: "boolean",
            width: 20,
            value: (row)=>{
                return row.flexi;
            },
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $fUWIW.queryFilters).boolean[operator]("flexi", value);
            },
            permissions: (row)=>(0, $8kZ1o.canViewFlexi)()
        },
        remote: {
            id: "remote",
            label: "Remote",
            type: "boolean",
            width: 20,
            value: (row)=>{
                return row.remote;
            },
            permissions: (row)=>(0, $8kZ1o.canViewRemote)()
        },
        fee: {
            id: "fee",
            label: "Fee",
            type: "currency",
            width: 20,
            aggregate: "sum",
            value: (row)=>{
                return row.fee;
            },
            permissions: (r)=>(0, $8kZ1o.canViewProjectFees)((0, $1BTI2.default).user, r === null || r === void 0 ? void 0 : r.project)
        },
        revenue: {
            id: "revenue",
            label: "Revenue",
            type: "currency",
            width: 20,
            aggregate: "sum",
            value: (row)=>{
                return row.revenue;
            },
            permissions: (r)=>(0, $8kZ1o.canViewProjectFees)((0, $1BTI2.default).user, r === null || r === void 0 ? void 0 : r.project) && (0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, r === null || r === void 0 ? void 0 : r.project)
        },
        remainingFee: {
            id: "remainingFee",
            label: "Remaining Fee",
            type: "currency",
            width: 20,
            aggregate: "sum",
            value: (row)=>{
                return row.remainingFee;
            },
            permissions: (r)=>(0, $8kZ1o.canViewProjectFees)((0, $1BTI2.default).user, r === null || r === void 0 ? void 0 : r.project) && (0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, r === null || r === void 0 ? void 0 : r.project)
        },
        budget: {
            id: "budget",
            label: "Expense Budget",
            type: "currency",
            width: 20,
            aggregate: "sum",
            value: (row)=>{
                return row.budget;
            },
            permissions: (r)=>(0, $8kZ1o.canViewProjectExpenseBudgets)((0, $1BTI2.default).user, r === null || r === void 0 ? void 0 : r.project)
        },
        hoursBudget: {
            id: "hoursBudget",
            label: "Hours Budget",
            type: "number",
            width: 20,
            aggregate: "sum",
            value: (row)=>{
                return row.hoursBudget;
            }
        },
        staffHoursBudget: {
            id: "staffHoursBudget",
            label: "Staff Hours Budget",
            type: "number",
            width: 20,
            aggregate: "sum",
            value: (row)=>{
                return row.staffHoursBudget;
            }
        },
        actualVsStaffHoursBudget: {
            id: "actualVsStaffHoursBudget",
            label: "Actual vs Staff Hours Budget",
            type: "progressBar",
            width: 20,
            aggregate: "sum",
            value: (row)=>{
                return row.actualVsStaffHoursBudget;
            }
        },
        startMinutes: {
            id: "startMinutes",
            label: "Start Time",
            type: "time",
            width: 20,
            aggregate: "same",
            value: (row)=>{
                return row.startMinutes ? new Date(row.startMinutes) : null;
            }
        },
        endMinutes: {
            id: "endMinutes",
            label: "End Time",
            type: "time",
            width: 20,
            aggregate: "same",
            value: (row)=>{
                return row.endMinutes ? new Date(row.endMinutes) : null;
            }
        },
        labourExpense: {
            id: "labourExpense",
            label: "Labour Expense",
            type: "currency",
            width: 10,
            aggregate: "sum",
            value: (row)=>{
                return row.pay;
            },
            permissions: (r)=>(0, $8kZ1o.canViewStaffPayRate)((0, $1BTI2.default).user)
        },
        cost: {
            id: "cost",
            label: "Expense (cost)",
            type: "currency",
            width: 10,
            aggregate: "sum",
            value: (row)=>{
                return row.cost;
            },
            permissions: (r)=>(0, $8kZ1o.canViewStaffCostRate)((0, $1BTI2.default).user)
        },
        chargeOut: {
            id: "chargeOut",
            label: "Charge Out",
            type: "currency",
            width: 10,
            aggregate: "sum",
            value: (row)=>{
                return row.chargeOut;
            },
            permissions: (r)=>(0, $8kZ1o.canViewStaffChargeOutRate)((0, $1BTI2.default).user)
        },
        chargeOutRate: {
            id: "chargeOutRate",
            label: "Charge Out Rate",
            type: "currency",
            width: 20,
            aggregate: "sum",
            value: (row)=>{
                return row.chargeOut / row.hours;
            },
            permissions: (r)=>(0, $8kZ1o.canViewStaffChargeOutRate)((0, $1BTI2.default).user)
        },
        hasNotes: {
            id: "hasNotes",
            label: "Has Notes",
            type: "boolean",
            width: 10,
            value: (row)=>{
                return row.hasNotes;
            }
        }
    });

});


parcelRegister("1b01r", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $0db6d5ee5998ec83$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");

var $ejTkS = parcelRequire("ejTkS");

var $b9nYY = parcelRequire("b9nYY");

var $kuPRw = parcelRequire("kuPRw");

var $bZfKS = parcelRequire("bZfKS");

var $4iw5i = parcelRequire("4iw5i");

var $5PXcS = parcelRequire("5PXcS");
parcelRequire("jE5CX");

var $4hBm1 = parcelRequire("4hBm1");

var $47i9t = parcelRequire("47i9t");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $7qobO = parcelRequire("7qobO");

var $26sX2 = parcelRequire("26sX2");

var $SRJCe = parcelRequire("SRJCe");

var $kqntg = parcelRequire("kqntg");

var $jbmdS = parcelRequire("jbmdS");

var $3h7sC = parcelRequire("3h7sC");
const $0db6d5ee5998ec83$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_private/timesheets/calendar")({
    beforeLoad: ({ params: params })=>{
        if (!(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "timesheetCalendar", params)) throw new Error("Permission Denied");
        (0, $26sX2.setLayoutDefaults)({
            pageTitle: "Timesheet Calendar",
            subMenu: "time"
        });
    },
    errorComponent: ({ error: error, reset: reset })=>{
        if (error.message === "Permission Denied") return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7qobO.default), {});
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    },
    pendingComponent: (0, $4iw5i.default),
    loader: async ({ location: location })=>await $0db6d5ee5998ec83$var$loader(location.search),
    loaderDeps: ({ search: { date: date, staffId: staffId } })=>({
            date: date,
            staffId: staffId
        }),
    component: $0db6d5ee5998ec83$var$Wrapper
});
const $0db6d5ee5998ec83$var$loader = async ({ date: date, staffId: staffId } = {})=>{
    var _date;
    // Use nullish coalescing to set default date as today's date formatted
    date = (_date = date) !== null && _date !== void 0 ? _date : (0, $4hBm1.format)(new Date(), "yyyy-MM-dd");
    const startDate = (0, $4hBm1.format)((0, $4hBm1.startOfWeek)(new Date(date), {
        weekStartsOn: 1
    }), "yyyy-MM-dd");
    const endDate = (0, $4hBm1.format)((0, $4hBm1.endOfWeek)(new Date(date), {
        weekStartsOn: 1
    }), "yyyy-MM-dd");
    const data = await (0, $3h7sC.trpc).legacy.getTimesheetData.query({
        startDate: startDate,
        endDate: endDate,
        staffId: staffId
    });
    return (0, $47i9t.processTRPCData)(data);
};
function $0db6d5ee5998ec83$var$Wrapper() {
    let { date: date, staffId: staffId } = $0db6d5ee5998ec83$export$e7b0ac011bb776c6.useSearch();
    // Parse the date string or use current date if no date provided
    date = date ? (0, $4hBm1.parse)(date, "yyyy-MM-dd", new Date()) : new Date();
    const { addToSidebar: addToSidebar } = (0, $SRJCe.useSidebarStack)();
    (0, $jbmdS.useEffect)(()=>{
        addToSidebar(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $b9nYY.CalendarSidebar), {}), {
            hideClose: true
        });
    }, []);
    if ((0, $8kZ1o.migratedToV2)()) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqntg.CenterPadPageBody), {
            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ejTkS.default), {
                date: date,
                staffId: staffId
            })
        })
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kuPRw.default), {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ejTkS.default), {
                    date: date,
                    staffId: staffId
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bZfKS.default), {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $b9nYY.CalendarSidebar), {})
            })
        ]
    });
}

});
parcelRegister("ejTkS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6cdc38f7d8f7d3a$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $fgZVx = parcelRequire("fgZVx");
var $a6cdc38f7d8f7d3a$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ date: date, staffId: staffId })=>/*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        style: {
            width: "80em"
        },
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fgZVx.Calendar), {
            mode: "time",
            date: date,
            staffId: staffId
        })
    }));

});


parcelRegister("emBvU", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $a750382caa082459$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");
var $64Yjc = parcelRequire("64Yjc");

var $5PXcS = parcelRequire("5PXcS");

var $gtOF4 = parcelRequire("gtOF4");

var $8uygn = parcelRequire("8uygn");

var $kuPRw = parcelRequire("kuPRw");

var $4iw5i = parcelRequire("4iw5i");

var $7qobO = parcelRequire("7qobO");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");
parcelRequire("jE5CX");

var $lWpUl = parcelRequire("lWpUl");

var $fLiAF = parcelRequire("fLiAF");
parcelRequire("fM2j4");

var $6Q5sp = parcelRequire("6Q5sp");

var $htkeB = parcelRequire("htkeB");

var $26sX2 = parcelRequire("26sX2");

var $38AIP = parcelRequire("38AIP");

var $kqntg = parcelRequire("kqntg");
parcelRequire("hMN0G");
parcelRequire("1LepB");
parcelRequire("b0kDs");
parcelRequire("7UGfB");

var $3h7sC = parcelRequire("3h7sC");

var $47i9t = parcelRequire("47i9t");

var $6l5Kr = parcelRequire("6l5Kr");
const $a750382caa082459$export$39f5674517ec0000 = {
    details: {
        label: "Details",
        id: "details",
        page: (props)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $8uygn.default), {
                ...props
            }),
        collections: (id)=>{
            return [];
        },
        permissions: (params)=>(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, `staff-details`, params)
    },
    rates: {
        label: "Rates",
        id: "rates",
        page: (props)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $fLiAF.default), {
                ...props
            }),
        permissions: (params)=>(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, `staff-rates`, params)
    },
    permissions: {
        label: "Permissions",
        id: "permissions",
        page: (props)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $lWpUl.default), {
                ...props
            }),
        collections: ()=>{
            return [];
        },
        permissions: (params)=>(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, `staff-permissions`, params)
    }
};
const $a750382caa082459$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_private/staff/$id")({
    beforeLoad: ({ params: params, search: search })=>{
        const activeTab = (search === null || search === void 0 ? void 0 : search.tab) || "details";
        if (!(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "staff", params) || !(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, `staff-${activeTab}`, params)) throw new Error("Permission Denied");
        const staff = (0, $38AIP.getCacheItemById)("staff", params.id);
        (0, $26sX2.setLayoutDefaults)({
            pageTitle: `${staff === null || staff === void 0 ? void 0 : staff.firstName} ${staff === null || staff === void 0 ? void 0 : staff.lastName}` || "Staff",
            subMenu: "resources",
            tabs: [
                {
                    label: "Details",
                    id: "details"
                },
                {
                    label: "Rates",
                    id: "rates"
                },
                {
                    label: "Permissions",
                    id: "permissions"
                }
            ]
        });
    },
    errorComponent: ({ error: error, reset: reset })=>{
        if (error.message === "Permission Denied") return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7qobO.default), {});
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    },
    loaderDeps: ({ search: { tab: tab } })=>({
            tab: tab
        }),
    loader: async ({ params: params, location: location })=>await $a750382caa082459$var$loader(params.id, location.search),
    pendingComponent: (0, $4iw5i.default),
    component: $a750382caa082459$var$Wrapper,
    onLeave: (match)=>{
        const { id: id } = match.params;
        const staff = (0, $htkeB.default).staffById[id];
        if (staff && !staff.createdAt && match.pathname !== (0, $6Q5sp.router).latestLocation.pathname) (0, $6l5Kr.cleanupNewEntity)(staff, "staff");
    }
});
const $a750382caa082459$var$loader = async (id, search)=>{
    const { tab: tab } = search;
    const activeTab = tab || "details";
    const data = await (0, $3h7sC.trpc).legacy.getStaffPageData.query({
        id: id
    });
    const processedModels = (0, $47i9t.processTRPCData)(data);
    const staff = (0, $htkeB.default).staffById[id];
    if (!staff) throw (0, $64Yjc.notFound)();
    return processedModels;
};
function $a750382caa082459$var$Wrapper() {
    const { tab: tab } = $a750382caa082459$export$e7b0ac011bb776c6.useSearch();
    const params = $a750382caa082459$export$e7b0ac011bb776c6.useParams();
    const activeTab = tab || "details";
    if ((0, $8kZ1o.migratedToV2)()) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqntg.CenterPadPageBody), {
        children: $a750382caa082459$export$39f5674517ec0000[activeTab].page(params)
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $gtOF4.default), {
                tabs: Object.values($a750382caa082459$export$39f5674517ec0000).filter((t)=>t.permissions(params)),
                selectedTab: activeTab,
                ...params
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kuPRw.default), {
                children: $a750382caa082459$export$39f5674517ec0000[activeTab].page(params)
            })
        ]
    });
}

});
parcelRegister("gtOF4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bff6a71a4af4ae58$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("lCpBr");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $36Jjh = parcelRequire("36Jjh");
parcelRequire("gJT7h");

var $khJQv = parcelRequire("khJQv");

var $htkeB = parcelRequire("htkeB");

var $3iPaT = parcelRequire("3iPaT");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $3X7oM = parcelRequire("3X7oM");
var $bff6a71a4af4ae58$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ extraContent: extraContent, id: id, tabs: tabs, selectedTab: selectedTab })=>{
    const staff = (0, $htkeB.default).staffsById[id];
    if (!staff) return null;
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $36Jjh.default), {
        heading: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: (staff === null || staff === void 0 ? void 0 : staff.fullName) || "New Staff Member"
            })
        }),
        rightButtons: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
            children: (0, $8kZ1o.canDeleteStaff)((0, $1BTI2.default).user) ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3X7oM.default), {
                label: "Delete",
                onClick: ()=>(0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $3iPaT.default), {
                        staff: staff,
                        modalId: "deleteStaff"
                    })),
                icon: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                    className: "fa fa-trash"
                })
            }) : null
        }),
        extraContent: extraContent,
        tabs: tabs,
        selectedTab: selectedTab
    });
});

});
parcelRegister("3iPaT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $267abfbe71cdc4b0$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("eat5C");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $fEcKX = parcelRequire("fEcKX");

var $fM2j4 = parcelRequire("fM2j4");

var $6UBLf = parcelRequire("6UBLf");

var $6l5Kr = parcelRequire("6l5Kr");
var $267abfbe71cdc4b0$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ staff: staff, modalId: modalId })=>{
    const navigate = (0, $6UBLf.useNavigate)();
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fEcKX.default), {
        modalId: modalId,
        heading: "Delete Staff Member",
        saveButtons: [
            {
                label: "Archive Staff",
                onClick: ()=>{
                    if (!staff.createdAt) (0, $6l5Kr.handleEntityDelete)(staff, "staff", navigate);
                    else {
                        staff.update({
                            isArchived: true
                        });
                        (0, $fM2j4.default).saveModel(staff);
                        navigate({
                            to: "/staff/"
                        });
                    }
                }
            },
            {
                label: "Delete Staff",
                onClick: ()=>(0, $6l5Kr.handleEntityDelete)(staff, "staff", navigate)
            }
        ],
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)("p", {
                style: {
                    margin: "1em"
                },
                children: [
                    "Are you sure you wish to delete ",
                    /*#__PURE__*/ (0, $61Ea1.jsx)("em", {
                        children: staff.fullName
                    }),
                    "?"
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("p", {
                style: {
                    margin: "1em"
                },
                children: 'We recommend you "Archive" staff to retain historical timesheet information. You will not be charged for any archived staff.'
            })
        ]
    });
});

});
parcelRegister("6l5Kr", function(module, exports) {

$parcel$export(module.exports, "cleanupNewEntity", function () { return $49d929b0f2de321b$export$6e6bc4377b66bf8f; });
$parcel$export(module.exports, "handleEntityDelete", function () { return $49d929b0f2de321b$export$8811dcb5de88ce7d; });

var $fM2j4 = parcelRequire("fM2j4");

var $1BTI2 = parcelRequire("1BTI2");

var $3PAB5 = parcelRequire("3PAB5");
const $49d929b0f2de321b$export$6e6bc4377b66bf8f = (entity, entityType, additionalCleanup)=>{
    if (!entity || entity.createdAt) return false;
    switch(entityType){
        case "invoice":
            if (entity.projectId) {
                (0, $1BTI2.default).organisation.decrementInvoiceNumber(entity.projectId);
                (0, $3PAB5.default).update((0, $1BTI2.default).organisation.id, {}, {
                    trackUpdates: false,
                    savedAt: Date.now()
                });
            }
            (0, $fM2j4.default).destroyNewItems("invoiceId", entity.id);
            (0, $fM2j4.default).startSave();
            break;
        case "contact":
            (0, $fM2j4.default).destroyNewItems("contactId", entity.id);
            break;
        case "project":
            (0, $fM2j4.default).destroyNewItems("projectId", entity.id);
            break;
        case "staff":
            (0, $fM2j4.default).destroyNewItems("staffId", entity.id);
            break;
        case "role":
            (0, $fM2j4.default).destroyNewItems("roleId", entity.id);
            break;
    }
    if (additionalCleanup) additionalCleanup();
    return true;
};
const $49d929b0f2de321b$export$8811dcb5de88ce7d = (entity, entityType, navigate, additionalCleanup)=>{
    const isNewEntity = !entity.createdAt;
    if (isNewEntity) {
        $49d929b0f2de321b$export$6e6bc4377b66bf8f(entity, entityType, additionalCleanup);
        const routeMap = {
            invoice: "/invoices",
            contact: "/contacts",
            project: "/projects",
            staff: "/staff",
            role: "/staff-roles"
        };
        navigate({
            to: routeMap[entityType] || `/${entityType}s`
        });
    } else {
        entity.update({
            deletedAt: new Date()
        });
        if (entityType === "invoice" && entity.lineItems) entity.lineItems.forEach((li)=>{
            li.timeEntries.forEach((te)=>{
                te.update({
                    beenInvoiced: false
                });
            });
            li.expenseItems.forEach((ei)=>{
                ei.update({
                    beenInvoiced: false
                });
            });
            li.update({
                deletedAt: new Date()
            });
        });
        if (additionalCleanup) additionalCleanup();
        (0, $fM2j4.default).startSave();
        const routeMap = {
            invoice: "/invoices",
            contact: "/contacts",
            project: "/projects",
            staff: "/staff",
            role: "/staff-roles"
        };
        navigate({
            to: routeMap[entityType] || `/${entityType}s`
        });
    }
};

});



parcelRegister("8uygn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62ebb3feb9183d36$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $ewAM3 = parcelRequire("ewAM3");

var $52dEm = parcelRequire("52dEm");

var $gdEjf = parcelRequire("gdEjf");
parcelRequire("gJT7h");

var $htkeB = parcelRequire("htkeB");

var $khJQv = parcelRequire("khJQv");
parcelRequire("e8Hda");
parcelRequire("fEtu5");

var $gTY7P = parcelRequire("gTY7P");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $764qO = parcelRequire("764qO");

var $en4Hs = parcelRequire("en4Hs");

var $bbD51 = parcelRequire("bbD51");

var $fM2j4 = parcelRequire("fM2j4");
var $62ebb3feb9183d36$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ id: id })=>{
    const isEditable = (0, $8kZ1o.canEditStaff)((0, $1BTI2.default).user);
    const labelWidth = "10em";
    const staff = (0, $htkeB.default).staffsById[id];
    if (!staff) return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        children: "Staff Member not found."
    });
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            className: "form-horizontal",
            children: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $gdEjf.FormSection), {
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $gdEjf.FormRow), {
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $gdEjf.FormLabel), {
                                style: {
                                    width: labelWidth
                                },
                                children: "First name:"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
                                className: "staff-member-component__first-name-input input-base ml-[5em]",
                                type: "text",
                                value: staff.firstName || "",
                                disabled: !isEditable,
                                onChange: (e)=>staff.update({
                                        firstName: e.target.value
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $gdEjf.FormRow), {
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $gdEjf.FormLabel), {
                                style: {
                                    width: labelWidth
                                },
                                children: "Last name:"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
                                className: "staff-member-component__last-name-input input-base ml-[5em]",
                                type: "text",
                                value: staff.lastName || "",
                                disabled: !isEditable,
                                onChange: (e)=>staff.update({
                                        lastName: e.target.value
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $gdEjf.FormRow), {
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $gdEjf.FormLabel), {
                                style: {
                                    width: labelWidth
                                }
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                                className: "staff-member-component__has-login-input",
                                value: staff.hasLogin,
                                label: "Provide Staff Member with Login?",
                                disabled: !isEditable,
                                onChange: (v)=>staff.update({
                                        hasLogin: v
                                    }),
                                variant: "secondary"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $gdEjf.FormRow), {
                        style: {
                            opacity: staff.hasLogin ? 1 : 0.5
                        },
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $gdEjf.FormLabel), {
                                style: {
                                    width: labelWidth
                                },
                                children: "Email:"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
                                className: "staff-member-component__email-input input-base ml-[7.2em]",
                                type: "email",
                                value: staff.email || "",
                                disabled: !isEditable || !staff.hasLogin,
                                onChange: (e)=>staff.update({
                                        email: e.target.value
                                    })
                            }),
                            isEditable && staff.hasLogin && staff.email && !staff.isArchived ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
                                children: (0, $8kZ1o.usingNewLogin)() ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bbD51.default), {
                                    staff: staff
                                }) : /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                                    className: "btn btn-sm btn-default",
                                    style: {
                                        marginLeft: "1em"
                                    },
                                    onClick: async ()=>{
                                        await (0, $fM2j4.default).startSave();
                                        (0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $gTY7P.default), {
                                            modalId: "invite-staff",
                                            staff: staff
                                        }));
                                    },
                                    children: "Get invite..."
                                })
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $gdEjf.FormRow), {
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $gdEjf.FormLabel), {
                                style: {
                                    width: labelWidth
                                },
                                children: "Staff type:"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $en4Hs.RadioGroup), {
                                className: "text-base flex gap-8 ml-6",
                                defaultValue: "employee",
                                onValueChange: (v)=>staff.update({
                                        staffType: v
                                    }),
                                value: staff.staffType,
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                        className: "flex items-center space-x-2",
                                        children: [
                                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $en4Hs.RadioGroupItem), {
                                                value: "employee",
                                                id: "employee"
                                            }),
                                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $764qO.Label), {
                                                htmlFor: "employee",
                                                children: "Employee"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                        className: "flex items-center space-x-2",
                                        children: [
                                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $en4Hs.RadioGroupItem), {
                                                value: "contractor",
                                                id: "contractor"
                                            }),
                                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $764qO.Label), {
                                                htmlFor: "contractor",
                                                children: "Contractor"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $8kZ1o.canViewRoles)((0, $1BTI2.default).user) ? /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $gdEjf.FormRow), {
                        style: {
                            maxWidth: "max-content"
                        },
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $gdEjf.FormLabel), {
                                style: {
                                    width: labelWidth
                                },
                                children: "Staff Role:"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.RoleSelector), {
                                selectedRole: staff.role,
                                isEditable: isEditable,
                                onChange: (role)=>staff.update({
                                        roleId: role.id
                                    }),
                                variant: "secondary"
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $gdEjf.FormRow), {
                        style: {
                            maxWidth: "max-content"
                        },
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $gdEjf.FormLabel), {
                                style: {
                                    width: labelWidth
                                },
                                children: "Status:"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                                options: [
                                    false,
                                    true
                                ],
                                optionLabel: (v)=>v ? "Archived" : "Active",
                                isEditable: isEditable,
                                value: staff.isArchived,
                                onChange: (v)=>staff.update({
                                        isArchived: v
                                    }),
                                variant: "secondary"
                            })
                        ]
                    }),
                    (0, $8kZ1o.canViewCostCentres)((0, $1BTI2.default).user) ? /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $gdEjf.FormRow), {
                        style: {
                            maxWidth: "max-content"
                        },
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $gdEjf.FormLabel), {
                                style: {
                                    width: labelWidth
                                },
                                children: "Cost Centre:"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.CostCentreSelector), {
                                selectedCostCentre: staff.costCentre,
                                isEditable: isEditable,
                                onChange: (v)=>staff.update({
                                        costCentreId: v.id
                                    }),
                                variant: "secondary"
                            })
                        ]
                    }) : null
                ]
            })
        })
    });
});

});
parcelRegister("gdEjf", function(module, exports) {

$parcel$export(module.exports, "FormRow", function () { return $bced20d5445cda67$export$b534bc812df080fd; });
$parcel$export(module.exports, "FormSection", function () { return $bced20d5445cda67$export$b5ff61ac8b0a660f; });
$parcel$export(module.exports, "FormLabel", function () { return $bced20d5445cda67$export$842aba50ed0ce9d7; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("jbmdS");

var $e64Mn = parcelRequire("e64Mn");

var $e8Hda = parcelRequire("e8Hda");
var $bced20d5445cda67$export$b534bc812df080fd = (0, (/*@__PURE__*/$parcel$interopDefault($e64Mn)))({
    render: function() {
        let props = (0, $e8Hda.mergeProps)({
            style: {
                padding: "0.5em"
            }
        }, this.props);
        return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            ...props,
            children: this.props.children
        });
    }
});
var $bced20d5445cda67$export$b5ff61ac8b0a660f = (0, (/*@__PURE__*/$parcel$interopDefault($e64Mn)))({
    render: function() {
        let props = (0, $e8Hda.mergeProps)({
            style: {
                margin: "1em 0",
                color: "#333"
            }
        }, this.props);
        return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            ...props,
            children: this.props.children
        });
    }
});
var $bced20d5445cda67$export$842aba50ed0ce9d7 = (0, (/*@__PURE__*/$parcel$interopDefault($e64Mn)))({
    render: function() {
        let props = (0, $e8Hda.mergeProps)({
            style: {
                fontWeight: "normal",
                verticalAlign: "top"
            }
        }, this.props);
        return /*#__PURE__*/ (0, $61Ea1.jsx)("label", {
            ...props,
            children: this.props.children
        });
    }
});
var $bced20d5445cda67$export$d8d9470002e487dd = (0, (/*@__PURE__*/$parcel$interopDefault($e64Mn)))({
    render: function() {
        let props = (0, $e8Hda.mergeProps)({
            style: {
                display: "inline-block",
                fontWeight: "normal",
                verticalAlign: "top"
            }
        }, this.props);
        return /*#__PURE__*/ (0, $61Ea1.jsx)("label", {
            ...props,
            children: this.props.children
        });
    }
});
var $bced20d5445cda67$export$97ee2cbf37e5ebfe = (0, (/*@__PURE__*/$parcel$interopDefault($e64Mn)))({
    render: function() {
        let props = (0, $e8Hda.mergeProps)({
            style: {
                borderBottom: "solid 1px #eee",
                padding: ".5em 1em",
                fontSize: "1.7em"
            }
        }, this.props);
        return /*#__PURE__*/ (0, $61Ea1.jsx)("h3", {
            ...props,
            children: this.props.children
        });
    }
});

});

parcelRegister("gTY7P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4e06bffb0fd89b0$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $fEcKX = parcelRequire("fEcKX");

var $iKbxs = parcelRequire("iKbxs");

var $iOQGT = parcelRequire("iOQGT");

var $3H03w = parcelRequire("3H03w");
var $c4e06bffb0fd89b0$export$2e2bcd8739ae039 = ({ modalId: modalId, staff: staff })=>{
    const [inviteCode, setInviteCode] = (0, $jbmdS.useState)(null);
    (0, $jbmdS.useEffect)(()=>{
        (0, $iOQGT.makeRequest)({
            path: "https://api.coincraft.co/api/v1.5/user/get-token",
            method: "post",
            data: {
                id: staff.id
            }
        }).then((response)=>{
            setInviteCode(response.data.token);
        }).catch((error)=>{
            $iKbxs.captureException(error);
            (0, $3H03w.default).captureException(error);
            setInviteCode(false);
        });
    }, []);
    const inviteURL = `${"https://launch.coincraft.co"}/invite?token=${inviteCode}`;
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fEcKX.default), {
        modalId: modalId,
        heading: "Invite Staff",
        saveLabel: "Email Invite Code to Staff Member",
        onSave: ()=>{
            (0, $iOQGT.makeRequest)({
                path: "https://api.coincraft.co/api/v1.5/user/send-invite",
                method: "post",
                data: {
                    email: staff.email,
                    token: inviteCode
                }
            });
        },
        children: inviteCode ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            children: [
                "Please send the following link to your staff member to activate their account.",
                " ",
                /*#__PURE__*/ (0, $61Ea1.jsx)("a", {
                    href: inviteURL,
                    style: {
                        color: "#1890ff"
                    },
                    children: inviteURL
                })
            ]
        }) : inviteCode === null ? /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            children: "Fetching activation link..."
        }) : /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            children: "There was an error retrieving an activation link for your staff member. Please contact us to resolve the issue."
        })
    });
};

});

parcelRegister("764qO", function(module, exports) {

$parcel$export(module.exports, "Label", function () { return $b80a9dbadb1e8ff9$export$b04be29aa201d4f5; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $hZz05 = parcelRequire("hZz05");

var $5kn1b = parcelRequire("5kn1b");

var $95Evz = parcelRequire("95Evz");
const $b80a9dbadb1e8ff9$var$labelVariants = (0, $5kn1b.cva)("text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70");
const $b80a9dbadb1e8ff9$export$b04be29aa201d4f5 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $61Ea1.jsx)($hZz05.Root, {
        ref: ref,
        className: (0, $95Evz.cn)($b80a9dbadb1e8ff9$var$labelVariants(), className),
        ...props
    }));
$b80a9dbadb1e8ff9$export$b04be29aa201d4f5.displayName = $hZz05.Root.displayName;

});

parcelRegister("en4Hs", function(module, exports) {

$parcel$export(module.exports, "RadioGroup", function () { return $915c35214252f5d0$export$a98f0dcb43a68a25; });
$parcel$export(module.exports, "RadioGroupItem", function () { return $915c35214252f5d0$export$9f866c100ef519e4; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $jSiTu = parcelRequire("jSiTu");

var $jlUAZ = parcelRequire("jlUAZ");

var $95Evz = parcelRequire("95Evz");
const $915c35214252f5d0$export$a98f0dcb43a68a25 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)($jlUAZ.Root, {
        className: (0, $95Evz.cn)("grid gap-2", className),
        ...props,
        ref: ref
    });
});
$915c35214252f5d0$export$a98f0dcb43a68a25.displayName = $jlUAZ.Root.displayName;
const $915c35214252f5d0$export$9f866c100ef519e4 = /*#__PURE__*/ $jbmdS.forwardRef(({ className: className, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)($jlUAZ.Item, {
        ref: ref,
        className: (0, $95Evz.cn)("aspect-square h-4 w-4 rounded-full border border-default text-default shadow focus:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50", className),
        ...props,
        children: /*#__PURE__*/ (0, $61Ea1.jsx)($jlUAZ.Indicator, {
            className: "flex items-center justify-center",
            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $jSiTu.CheckIcon), {
                className: "h-4 w-4 fill-default"
            })
        })
    });
});
$915c35214252f5d0$export$9f866c100ef519e4.displayName = $jlUAZ.Item.displayName;

});
parcelRegister("jlUAZ", function(module, exports) {

$parcel$export(module.exports, "Root", function () { return $c832040a27b46315$export$be92b6f5f03c0fe9; });
$parcel$export(module.exports, "Item", function () { return $c832040a27b46315$export$6d08773d2e66f8f2; });
$parcel$export(module.exports, "Indicator", function () { return $c832040a27b46315$export$adb584737d712b70; });

var $jbmdS = parcelRequire("jbmdS");

var $hFcKE = parcelRequire("hFcKE");

var $9sunj = parcelRequire("9sunj");

var $f4RZG = parcelRequire("f4RZG");

var $cihg9 = parcelRequire("cihg9");

var $cmy02 = parcelRequire("cmy02");

var $1sq0Q = parcelRequire("1sq0Q");

var $9czjk = parcelRequire("9czjk");

var $am0tV = parcelRequire("am0tV");

var $f4s2q = parcelRequire("f4s2q");

var $joHB8 = parcelRequire("joHB8");

var $4TLFw = parcelRequire("4TLFw");
"use client";
var $c832040a27b46315$var$RADIO_NAME = "Radio";
var [$c832040a27b46315$var$createRadioContext, $c832040a27b46315$var$createRadioScope] = (0, $f4RZG.createContextScope)($c832040a27b46315$var$RADIO_NAME);
var [$c832040a27b46315$var$RadioProvider, $c832040a27b46315$var$useRadioContext] = $c832040a27b46315$var$createRadioContext($c832040a27b46315$var$RADIO_NAME);
var $c832040a27b46315$var$Radio = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeRadio: __scopeRadio, name: name, checked: checked = false, required: required, disabled: disabled, value: value = "on", onCheck: onCheck, form: form, ...radioProps } = props;
    const [button, setButton] = $jbmdS.useState(null);
    const composedRefs = (0, $9sunj.useComposedRefs)(forwardedRef, (node)=>setButton(node));
    const hasConsumerStoppedPropagationRef = $jbmdS.useRef(false);
    const isFormControl = button ? form || !!button.closest("form") : true;
    return /* @__PURE__ */ (0, $4TLFw.jsxs)($c832040a27b46315$var$RadioProvider, {
        scope: __scopeRadio,
        checked: checked,
        disabled: disabled,
        children: [
            /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).button, {
                type: "button",
                role: "radio",
                "aria-checked": checked,
                "data-state": $c832040a27b46315$var$getState(checked),
                "data-disabled": disabled ? "" : void 0,
                disabled: disabled,
                value: value,
                ...radioProps,
                ref: composedRefs,
                onClick: (0, $hFcKE.composeEventHandlers)(props.onClick, (event)=>{
                    if (!checked) onCheck?.();
                    if (isFormControl) {
                        hasConsumerStoppedPropagationRef.current = event.isPropagationStopped();
                        if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
                    }
                })
            }),
            isFormControl && /* @__PURE__ */ (0, $4TLFw.jsx)($c832040a27b46315$var$BubbleInput, {
                control: button,
                bubbles: !hasConsumerStoppedPropagationRef.current,
                name: name,
                value: value,
                checked: checked,
                required: required,
                disabled: disabled,
                form: form,
                style: {
                    transform: "translateX(-100%)"
                }
            })
        ]
    });
});
$c832040a27b46315$var$Radio.displayName = $c832040a27b46315$var$RADIO_NAME;
var $c832040a27b46315$var$INDICATOR_NAME = "RadioIndicator";
var $c832040a27b46315$var$RadioIndicator = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeRadio: __scopeRadio, forceMount: forceMount, ...indicatorProps } = props;
    const context = $c832040a27b46315$var$useRadioContext($c832040a27b46315$var$INDICATOR_NAME, __scopeRadio);
    return /* @__PURE__ */ (0, $4TLFw.jsx)((0, $joHB8.Presence), {
        present: forceMount || context.checked,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).span, {
            "data-state": $c832040a27b46315$var$getState(context.checked),
            "data-disabled": context.disabled ? "" : void 0,
            ...indicatorProps,
            ref: forwardedRef
        })
    });
});
$c832040a27b46315$var$RadioIndicator.displayName = $c832040a27b46315$var$INDICATOR_NAME;
var $c832040a27b46315$var$BubbleInput = (props)=>{
    const { control: control, checked: checked, bubbles: bubbles = true, ...inputProps } = props;
    const ref = $jbmdS.useRef(null);
    const prevChecked = (0, $f4s2q.usePrevious)(checked);
    const controlSize = (0, $am0tV.useSize)(control);
    $jbmdS.useEffect(()=>{
        const input = ref.current;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
        const setChecked = descriptor.set;
        if (prevChecked !== checked && setChecked) {
            const event = new Event("click", {
                bubbles: bubbles
            });
            setChecked.call(input, checked);
            input.dispatchEvent(event);
        }
    }, [
        prevChecked,
        checked,
        bubbles
    ]);
    return /* @__PURE__ */ (0, $4TLFw.jsx)("input", {
        type: "radio",
        "aria-hidden": true,
        defaultChecked: checked,
        ...inputProps,
        tabIndex: -1,
        ref: ref,
        style: {
            ...props.style,
            ...controlSize,
            position: "absolute",
            pointerEvents: "none",
            opacity: 0,
            margin: 0
        }
    });
};
function $c832040a27b46315$var$getState(checked) {
    return checked ? "checked" : "unchecked";
}
var $c832040a27b46315$var$ARROW_KEYS = [
    "ArrowUp",
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight"
];
var $c832040a27b46315$var$RADIO_GROUP_NAME = "RadioGroup";
var [$c832040a27b46315$var$createRadioGroupContext, $c832040a27b46315$export$c547093f11b76da2] = (0, $f4RZG.createContextScope)($c832040a27b46315$var$RADIO_GROUP_NAME, [
    (0, $cmy02.createRovingFocusGroupScope),
    $c832040a27b46315$var$createRadioScope
]);
var $c832040a27b46315$var$useRovingFocusGroupScope = (0, $cmy02.createRovingFocusGroupScope)();
var $c832040a27b46315$var$useRadioScope = $c832040a27b46315$var$createRadioScope();
var [$c832040a27b46315$var$RadioGroupProvider, $c832040a27b46315$var$useRadioGroupContext] = $c832040a27b46315$var$createRadioGroupContext($c832040a27b46315$var$RADIO_GROUP_NAME);
var $c832040a27b46315$export$a98f0dcb43a68a25 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeRadioGroup: __scopeRadioGroup, name: name, defaultValue: defaultValue, value: valueProp, required: required = false, disabled: disabled = false, orientation: orientation, dir: dir, loop: loop = true, onValueChange: onValueChange, ...groupProps } = props;
    const rovingFocusGroupScope = $c832040a27b46315$var$useRovingFocusGroupScope(__scopeRadioGroup);
    const direction = (0, $9czjk.useDirection)(dir);
    const [value, setValue] = (0, $1sq0Q.useControllableState)({
        prop: valueProp,
        defaultProp: defaultValue,
        onChange: onValueChange
    });
    return /* @__PURE__ */ (0, $4TLFw.jsx)($c832040a27b46315$var$RadioGroupProvider, {
        scope: __scopeRadioGroup,
        name: name,
        required: required,
        disabled: disabled,
        value: value,
        onValueChange: setValue,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)($cmy02.Root, {
            asChild: true,
            ...rovingFocusGroupScope,
            orientation: orientation,
            dir: direction,
            loop: loop,
            children: /* @__PURE__ */ (0, $4TLFw.jsx)((0, $cihg9.Primitive).div, {
                role: "radiogroup",
                "aria-required": required,
                "aria-orientation": orientation,
                "data-disabled": disabled ? "" : void 0,
                dir: direction,
                ...groupProps,
                ref: forwardedRef
            })
        })
    });
});
$c832040a27b46315$export$a98f0dcb43a68a25.displayName = $c832040a27b46315$var$RADIO_GROUP_NAME;
var $c832040a27b46315$var$ITEM_NAME = "RadioGroupItem";
var $c832040a27b46315$export$9f866c100ef519e4 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeRadioGroup: __scopeRadioGroup, disabled: disabled, ...itemProps } = props;
    const context = $c832040a27b46315$var$useRadioGroupContext($c832040a27b46315$var$ITEM_NAME, __scopeRadioGroup);
    const isDisabled = context.disabled || disabled;
    const rovingFocusGroupScope = $c832040a27b46315$var$useRovingFocusGroupScope(__scopeRadioGroup);
    const radioScope = $c832040a27b46315$var$useRadioScope(__scopeRadioGroup);
    const ref = $jbmdS.useRef(null);
    const composedRefs = (0, $9sunj.useComposedRefs)(forwardedRef, ref);
    const checked = context.value === itemProps.value;
    const isArrowKeyPressedRef = $jbmdS.useRef(false);
    $jbmdS.useEffect(()=>{
        const handleKeyDown = (event)=>{
            if ($c832040a27b46315$var$ARROW_KEYS.includes(event.key)) isArrowKeyPressedRef.current = true;
        };
        const handleKeyUp = ()=>isArrowKeyPressedRef.current = false;
        document.addEventListener("keydown", handleKeyDown);
        document.addEventListener("keyup", handleKeyUp);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("keyup", handleKeyUp);
        };
    }, []);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($cmy02.Item, {
        asChild: true,
        ...rovingFocusGroupScope,
        focusable: !isDisabled,
        active: checked,
        children: /* @__PURE__ */ (0, $4TLFw.jsx)($c832040a27b46315$var$Radio, {
            disabled: isDisabled,
            required: context.required,
            checked: checked,
            ...radioScope,
            ...itemProps,
            name: context.name,
            ref: composedRefs,
            onCheck: ()=>context.onValueChange(itemProps.value),
            onKeyDown: (0, $hFcKE.composeEventHandlers)((event)=>{
                if (event.key === "Enter") event.preventDefault();
            }),
            onFocus: (0, $hFcKE.composeEventHandlers)(itemProps.onFocus, ()=>{
                if (isArrowKeyPressedRef.current) ref.current?.click();
            })
        })
    });
});
$c832040a27b46315$export$9f866c100ef519e4.displayName = $c832040a27b46315$var$ITEM_NAME;
var $c832040a27b46315$var$INDICATOR_NAME2 = "RadioGroupIndicator";
var $c832040a27b46315$export$5fb54c671a65c88 = $jbmdS.forwardRef((props, forwardedRef)=>{
    const { __scopeRadioGroup: __scopeRadioGroup, ...indicatorProps } = props;
    const radioScope = $c832040a27b46315$var$useRadioScope(__scopeRadioGroup);
    return /* @__PURE__ */ (0, $4TLFw.jsx)($c832040a27b46315$var$RadioIndicator, {
        ...radioScope,
        ...indicatorProps,
        ref: forwardedRef
    });
});
$c832040a27b46315$export$5fb54c671a65c88.displayName = $c832040a27b46315$var$INDICATOR_NAME2;
var $c832040a27b46315$export$be92b6f5f03c0fe9 = $c832040a27b46315$export$a98f0dcb43a68a25;
var $c832040a27b46315$export$6d08773d2e66f8f2 = $c832040a27b46315$export$9f866c100ef519e4;
var $c832040a27b46315$export$adb584737d712b70 = $c832040a27b46315$export$5fb54c671a65c88;

});


parcelRegister("bbD51", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $824f0947b5970b89$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $6Q5sp = parcelRequire("6Q5sp");

var $fM2j4 = parcelRequire("fM2j4");
var $824f0947b5970b89$export$2e2bcd8739ae039 = ({ staff: staff })=>{
    const [inviteStatus, setInviteStatus] = (0, $jbmdS.useState)("loading");
    const [errorMessage, setErrorMessage] = (0, $jbmdS.useState)("");
    (0, $jbmdS.useEffect)(()=>{
        const fetchInviteStatus = async ()=>{
            try {
                const invitations = await (0, $6Q5sp.clerk).organization.getInvitations();
                console.log("\uD83D\uDE80 ~ fetchInviteStatus ~ invitations:", invitations);
                const staffInvitation = invitations.data.find((invite)=>invite.emailAddress === staff.email);
                if (staffInvitation) setInviteStatus(staffInvitation.status);
                else setInviteStatus("not_invited");
                setErrorMessage("");
            } catch (error) {
                console.error("Error fetching invite status:", error);
                setInviteStatus("error");
                setErrorMessage(error.message || "An error occurred while fetching invite status");
            }
        };
        fetchInviteStatus();
    }, [
        staff.email
    ]);
    const sendInvitation = async ()=>{
        await (0, $fM2j4.default).startSave();
        setInviteStatus("sending");
        setErrorMessage("");
        try {
            console.log("Sending invitation to", staff.email);
            console.log((0, $6Q5sp.clerk).organization);
            await (0, $6Q5sp.clerk).organization.inviteMember({
                emailAddress: staff.email,
                role: "org:member"
            }).then((res)=>{
                console.log(res);
                setInviteStatus("pending"); // or you could use res.status if available
            }).catch((error)=>{
                console.log("An error occurred:", error.errors);
                throw error; // Re-throw to be caught by the outer catch block
            });
        } catch (error) {
            var _error$errors, _error$errors$;
            console.error("Error sending invite:", error);
            setInviteStatus("error");
            setErrorMessage(((_error$errors = error.errors) === null || _error$errors === void 0 ? void 0 : (_error$errors$ = _error$errors[0]) === null || _error$errors$ === void 0 ? void 0 : _error$errors$.message) || "An error occurred while sending the invite");
        }
    };
    if (inviteStatus === "loading") return /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
        className: "btn btn-sm cursor-default bg-[#eee] hover:bg-[#eee] hover:border-[inherit]",
        style: {
            marginLeft: "1em"
        },
        disabled: true,
        children: "Loading..."
    });
    if (inviteStatus === "sending") return /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
        className: "btn btn-sm cursor-default bg-[#eee] hover:bg-[#eee] hover:border-[inherit]",
        style: {
            marginLeft: "1em"
        },
        disabled: true,
        children: "Sending..."
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "inline-block relative",
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                className: "btn btn-sm btn-default",
                style: {
                    marginLeft: "1em"
                },
                onClick: sendInvitation,
                children: inviteStatus === "not_invited" ? "Invite Staff Member" : "Resend Invitation"
            }),
            ![
                "loading",
                "sending",
                "error",
                "not_invited"
            ].includes(inviteStatus) ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "text-xs absolute text-center w-full text-[grey]",
                style: {
                    marginLeft: "1em"
                },
                children: [
                    "status: ",
                    inviteStatus
                ]
            }) : null,
            errorMessage ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "text-xs absolute text-center w-full text-red-500",
                children: [
                    "Error: ",
                    errorMessage
                ]
            }) : null
        ]
    });
};

});


parcelRegister("lWpUl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff931c7aa77e56ec$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "PermissionGroup", function () { return $ff931c7aa77e56ec$export$6310b070ee0bdfd1; });
$parcel$export(module.exports, "ProjectPermissionGroup", function () { return $ff931c7aa77e56ec$export$3fd908b74b43d5a; });

var $61Ea1 = parcelRequire("61Ea1");


var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $htkeB = parcelRequire("htkeB");

var $e4oIi = parcelRequire("e4oIi");
var $bv4Rr = parcelRequire("bv4Rr");
var $4qR9D = parcelRequire("4qR9D");
var $hRCNE = parcelRequire("hRCNE");

var $ikffN = parcelRequire("ikffN");

var $c86dX = parcelRequire("c86dX");

var $gJT7h = parcelRequire("gJT7h");

var $eNcHX = parcelRequire("eNcHX");

var $gAnn6 = parcelRequire("gAnn6");
parcelRequire("4WSZl");

var $8kZ1o = parcelRequire("8kZ1o");

var $5JL5P = parcelRequire("5JL5P");

var $kqlQp = parcelRequire("kqlQp");
var $6UBLf = parcelRequire("6UBLf");
function $ff931c7aa77e56ec$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const { Option: $ff931c7aa77e56ec$var$Option, OptGroup: $ff931c7aa77e56ec$var$OptGroup } = (0, $4qR9D.default);
var $ff931c7aa77e56ec$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ id: id })=>{
    const navigate = (0, $6UBLf.useNavigate)();
    const staff = (0, $htkeB.default).staffsById[id];
    if (!staff) return null;
    const [presetOption, setPresetOption] = (0, $jbmdS.useState)(staff.permissionsId || "custom");
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        style: {
            width: "58em"
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    marginBottom: "5em"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("h2", {
                        className: "border-b border-[#aaa]",
                        children: "Presets"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsxs)($ff931c7aa77e56ec$export$78cadc47e966a49, {
                                label: "Permission Presets",
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $4qR9D.default), {
                                        showSearch: true,
                                        optionFilterProp: "children",
                                        value: presetOption,
                                        bordered: true,
                                        onChange: (optionId)=>{
                                            setPresetOption(optionId);
                                            if ((0, $5JL5P.default).permissionsById[optionId]) staff.update({
                                                permissionsId: optionId,
                                                permissions: (0, $5JL5P.default).permissionsById[optionId].settings
                                            });
                                            else staff.update({
                                                permissionsId: null
                                            });
                                        },
                                        style: {
                                            fontSize: "0.9em",
                                            width: "20em"
                                        },
                                        children: [
                                            ...[
                                                ...(0, $5JL5P.default).permissions
                                            ].sort((a, b)=>a.name.localeCompare(b.name)).map((p)=>({
                                                    label: `${p.name}`,
                                                    value: p.id
                                                })),
                                            {
                                                label: "Custom",
                                                value: "custom"
                                            }
                                        ].filter((c)=>c).map((option)=>/*#__PURE__*/ (0, $61Ea1.jsx)($ff931c7aa77e56ec$var$Option, {
                                                style: {
                                                    fontSize: "12px"
                                                },
                                                value: option.value,
                                                children: option.label
                                            }))
                                    }),
                                    presetOption !== "custom" ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqlQp.Link), {
                                        to: `/permissions/${presetOption}`,
                                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $e4oIi.default), {
                                            className: "ml-2",
                                            children: "Edit..."
                                        })
                                    }) : /*#__PURE__*/ (0, $61Ea1.jsx)((0, $e4oIi.default), {
                                        className: "ml-2",
                                        onClick: ()=>{
                                            const permission = (0, $5JL5P.default).createPermissionFromStaff(staff);
                                            navigate({
                                                to: `/permissions/${permission.id}`
                                            });
                                        },
                                        children: "Create Preset..."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)($ff931c7aa77e56ec$export$78cadc47e966a49, {
                                label: "Financial Presets",
                                children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hRCNE.default), {
                                            disabled: staff.permissionsId,
                                            checked: (0, $8kZ1o.canSeeFeesAndRevenue)(staff),
                                            size: "small",
                                            onChange: (v)=>{
                                                var _staff$permissions;
                                                (0, $8kZ1o.updateStaffPermission)(staff, {
                                                    canViewRevenueForecast: v,
                                                    chargeOutRate: v ? "view" : "hidden",
                                                    projects: ((staff === null || staff === void 0 ? void 0 : (_staff$permissions = staff.permissions) === null || _staff$permissions === void 0 ? void 0 : _staff$permissions.projects) || []).map((p)=>({
                                                            ...p,
                                                            permissions: {
                                                                ...p.permissions,
                                                                projectFees: v ? "view" : "hidden",
                                                                projectForecastedRevenue: v ? "view" : "hidden",
                                                                projectInvoices: v ? "view" : "hidden"
                                                            }
                                                        }))
                                                });
                                            },
                                            checkedChildren: "Project Fees & Revenue",
                                            unCheckedChildren: "Project Fees & Revenue"
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $61Ea1.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hRCNE.default), {
                                            disabled: staff.permissionsId,
                                            checked: (0, $8kZ1o.canSeeExpenses)(staff),
                                            size: "small",
                                            onChange: (v)=>{
                                                var _staff$permissions2;
                                                (0, $8kZ1o.updateStaffPermission)(staff, {
                                                    costRate: v ? "view" : "hidden",
                                                    projects: ((staff === null || staff === void 0 ? void 0 : (_staff$permissions2 = staff.permissions) === null || _staff$permissions2 === void 0 ? void 0 : _staff$permissions2.projects) || []).map((p)=>({
                                                            ...p,
                                                            permissions: {
                                                                ...p.permissions,
                                                                projectExpenses: v ? "view" : "hidden",
                                                                projectExpenseBudgets: v ? "view" : "hidden"
                                                            }
                                                        }))
                                                });
                                            },
                                            checkedChildren: "Staff Cost & Project Expenses",
                                            unCheckedChildren: "Staff Cost & Project Expenses"
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $61Ea1.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hRCNE.default), {
                                            disabled: staff.permissionsId,
                                            checked: (0, $8kZ1o.canSeeSalaries)(staff),
                                            size: "small",
                                            onChange: (v)=>{
                                                (0, $8kZ1o.updateStaffPermission)(staff, {
                                                    payRate: v ? "view" : "hidden",
                                                    overtimeRate: v ? "view" : "hidden"
                                                });
                                            },
                                            checkedChildren: "Staff Salaries",
                                            unCheckedChildren: "Staff Salaries"
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $61Ea1.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hRCNE.default), {
                                            disabled: staff.permissionsId,
                                            checked: (0, $8kZ1o.canSeeOperationalExpenses)(staff),
                                            size: "small",
                                            onChange: (v)=>{
                                                (0, $8kZ1o.updateStaffPermission)(staff, {
                                                    operationalExpenses: v ? "view" : "hidden"
                                                });
                                            },
                                            checkedChildren: "Operational Expenses",
                                            unCheckedChildren: "Operational Expenses"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)($ff931c7aa77e56ec$export$b970cab02aaf8452, {
                staff: staff,
                disabled: staff.permissionsId
            })
        ]
    });
});
const $ff931c7aa77e56ec$export$b970cab02aaf8452 = ({ staff: staff, disabled: disabled })=>{
    const handleUpdatePermissions = (key, value)=>{
        (0, $8kZ1o.updateStaffPermission)(staff, {
            [key]: value
        });
    };
    const handleUpdateProjectPermissions = (staff, id, key, value)=>{
        (0, $8kZ1o.updateProjectPermission)(staff, id, {
            [key]: value
        });
    };
    const handleUpdateFilterPermissions = (staff, id, filter)=>{
        (0, $8kZ1o.updateProjectPermissionFilter)(staff, id, filter);
    };
    return (0, $gAnn6.permissionStructure).map((group)=>{
        var _staff$permissions3;
        return group.label !== "Projects" ? /*#__PURE__*/ (0, $61Ea1.jsx)($ff931c7aa77e56ec$export$6310b070ee0bdfd1, {
            title: group.label,
            permissions: group.permissions,
            staffPermissions: (staff === null || staff === void 0 ? void 0 : staff.permissions) || [],
            onChange: handleUpdatePermissions,
            disabled: disabled
        }) : /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            children: [
                ((staff === null || staff === void 0 ? void 0 : (_staff$permissions3 = staff.permissions) === null || _staff$permissions3 === void 0 ? void 0 : _staff$permissions3.projects) || []).map((projectPermissions)=>/*#__PURE__*/ (0, $61Ea1.jsx)($ff931c7aa77e56ec$export$3fd908b74b43d5a, {
                        staffPermissions: staff === null || staff === void 0 ? void 0 : staff.permissions,
                        permissions: group.permissions,
                        projectPermissions: projectPermissions,
                        onChange: (key, value)=>handleUpdateProjectPermissions(staff, projectPermissions.id, key, value),
                        onFilterChange: (value)=>handleUpdateFilterPermissions(staff, projectPermissions.id, value),
                        onDelete: ()=>(0, $8kZ1o.deleteProjectPermission)(staff, projectPermissions.id),
                        disabled: disabled
                    })),
                !disabled ? /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                    className: "plus-btn border-[#d9d9d9] mb-10",
                    onClick: ()=>(0, $8kZ1o.addProjectPermission)(staff),
                    children: "+ Add Project Permissions"
                }) : null
            ]
        });
    });
};
const $ff931c7aa77e56ec$export$3fd908b74b43d5a = ({ permissions: permissions, projectPermissions: projectPermissions, staffPermissions: staffPermissions, onChange: onChange, onFilterChange: onFilterChange, onDelete: onDelete, disabled: disabled })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        style: {
            marginBottom: "4em"
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    borderBottom: "1px solid #ccc",
                    display: "flex",
                    alignItems: "center",
                    zIndex: 10,
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("h3", {
                        style: {
                            margin: 0
                        },
                        children: "Projects"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)($ff931c7aa77e56ec$var$ProjectPermissionFilter, {
                        staffPermissions: staffPermissions,
                        filter: projectPermissions.filter,
                        onChange: onFilterChange,
                        disabled: disabled
                    }),
                    !disabled ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $e4oIi.default), {
                        danger: true,
                        size: "small",
                        onClick: ()=>onDelete(),
                        children: "Delete"
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)($ff931c7aa77e56ec$export$6310b070ee0bdfd1, {
                permissions: permissions,
                staffPermissions: projectPermissions.permissions,
                onChange: onChange,
                disabled: disabled
            })
        ]
    });
};
const $ff931c7aa77e56ec$var$ProjectPermissionFilter = ({ filter: filter, onChange: onChange, staffPermissions: staffPermissions, disabled: disabled })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "flex-auto flex w-full",
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    flex: filter.type === "all" ? "1 1 auto" : "0 0 auto",
                    marginLeft: "1em",
                    marginBottom: "0.25em",
                    position: "relative",
                    zIndex: 10
                },
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $4qR9D.default), {
                    disabled: disabled,
                    showSearch: true,
                    optionFilterProp: "children",
                    value: filter.type,
                    bordered: true,
                    onChange: (filterType)=>onChange({
                            type: filterType,
                            values: []
                        }),
                    style: {
                        fontSize: "0.9em"
                    },
                    children: [
                        !(0, $8kZ1o.hasPermissionsForAllProjects)(staffPermissions) || filter.type === "all" ? {
                            label: "All Projects",
                            value: "all"
                        } : null,
                        {
                            label: "Owned Projects",
                            value: "owner"
                        },
                        {
                            label: "Projects with Cost Centre",
                            value: "costCentre"
                        },
                        {
                            label: "Specific Projects",
                            value: "project"
                        }
                    ].filter((c)=>c).map((option)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $bv4Rr.default).Button, {
                            style: {
                                fontSize: "12px"
                            },
                            value: option.value,
                            children: option.label
                        }))
                })
            }),
            filter.type === "project" ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $c86dX.ProjectMultiselect), {
                disabled: disabled,
                className: "flex-auto",
                menuPosition: "fixed",
                projectOptions: (0, $gJT7h.default).projects.filter((p)=>!(0, $8kZ1o.getAllPermissionProjectIds)(staffPermissions).includes(p.id)),
                value: filter.values.map((prId)=>(0, $gJT7h.default).projectsById[prId]),
                onChange: (values)=>onChange({
                        ...filter,
                        values: values.map((pr)=>pr.id)
                    }),
                styles: {
                    container: (provided, state)=>({
                            flex: "1 1 auto",
                            marginLeft: "1em",
                            marginRight: "1em",
                            fontSize: "0.9em",
                            // zIndex: 10,
                            marginBottom: "0.25em"
                        }),
                    input: (provided, state)=>({
                            ...provided,
                            padding: "0"
                        })
                }
            }) : filter.type === "costCentre" ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $c86dX.CostCentreMultiselect), {
                disabled: disabled,
                className: "flex-auto",
                menuPosition: "fixed",
                costCentreOptions: (0, $eNcHX.default).costCentres.filter((cc)=>!(0, $8kZ1o.getAllPermissionCostCentreIds)(staffPermissions).includes(cc.id)),
                value: filter.values.map((ccId)=>(0, $eNcHX.default).costCentresById[ccId]),
                onChange: (values)=>onChange({
                        ...filter,
                        values: values.map((cc)=>cc.id)
                    }),
                styles: {
                    container: (provided, state)=>({
                            flex: "1 1 auto",
                            marginLeft: "1em",
                            marginRight: "1em",
                            fontSize: "0.9em",
                            // zIndex: 10,
                            marginBottom: "0.25em"
                        }),
                    input: (provided, state)=>({
                            ...provided,
                            padding: "0"
                        })
                }
            }) : null
        ]
    });
};
const $ff931c7aa77e56ec$export$6310b070ee0bdfd1 = ({ title: title, permissions: permissions, staffPermissions: staffPermissions, onChange: onChange, disabled: disabled })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        style: {
            marginBottom: title ? "4em" : 0
        },
        children: [
            title ? /*#__PURE__*/ (0, $61Ea1.jsx)("h3", {
                style: {
                    borderBottom: "1px solid #ccc"
                },
                children: title
            }) : null,
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: permissions.map(({ label: label, key: key, type: type, options: options, display: display = ()=>true })=>{
                    if (!display(staffPermissions)) return null;
                    const value = staffPermissions === null || staffPermissions === void 0 ? void 0 : staffPermissions[key];
                    const localOnChange = (value)=>onChange(key, value);
                    return type === "switch" ? /*#__PURE__*/ (0, $61Ea1.jsx)($ff931c7aa77e56ec$var$PermissionSwitch, {
                        label: label,
                        value: value,
                        onChange: localOnChange,
                        disabled: disabled
                    }) : /*#__PURE__*/ (0, $61Ea1.jsx)($ff931c7aa77e56ec$var$PermissionRadio, {
                        label: label,
                        value: value,
                        onChange: localOnChange,
                        options: options,
                        disabled: disabled
                    });
                })
            })
        ]
    });
};
const $ff931c7aa77e56ec$var$PermissionSwitch = ({ label: label, value: value = false, onChange: onChange, disabled: disabled })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)($ff931c7aa77e56ec$export$78cadc47e966a49, {
        label: label,
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hRCNE.default), {
            disabled: disabled,
            checked: value,
            size: "small",
            onChange: (v)=>onChange(v)
        })
    });
};
const $ff931c7aa77e56ec$var$PermissionRadio = ({ label: label, value: value = "hidden", onChange: onChange, options: options = [
    "hidden",
    "view",
    "edit",
    "admin"
], disabled: disabled })=>{
    const styleOverrides = {
        hidden: {},
        view: {},
        edit: {},
        admin: {}
    };
    if (value === "hidden") styleOverrides.hidden = {
        backgroundColor: "#aaa",
        borderColor: "#aaa"
    };
    return /*#__PURE__*/ (0, $61Ea1.jsx)($ff931c7aa77e56ec$export$78cadc47e966a49, {
        label: label,
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bv4Rr.default).Group, {
            disabled: disabled,
            buttonStyle: "solid",
            value: value,
            size: "small",
            onChange: (e)=>onChange(e.target.value),
            children: options.map((option)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $bv4Rr.default).Button, {
                    style: {
                        fontSize: "12px",
                        ...styleOverrides[option]
                    },
                    value: option,
                    children: option === "admin" ? "Edit, Create, & Delete" : (0, $ikffN.capitalCase)(option)
                }))
        })
    });
};
var $ff931c7aa77e56ec$var$_ref = {
    name: "1dei7nh",
    styles: "display:grid;grid-template-columns:1fr 2fr;column-gap:5em;row-gap:0.5em;border-bottom:1px solid #e9e9e9;align-items:center;padding:0.5em 0;:hover{background-color:#f2f2f2;}z-index:1;position:relative"
};
const $ff931c7aa77e56ec$export$78cadc47e966a49 = ({ label: label, children: children, className: className })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: className,
        css: $ff931c7aa77e56ec$var$_ref,
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    fontWeight: "bold",
                    textAlign: "right"
                },
                children: label
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: children
            })
        ]
    });
};

});
parcelRegister("bv4Rr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85f65c380ec99ad9$export$2e2bcd8739ae039; });

var $gU86F = parcelRequire("gU86F");

var $72sRP = parcelRequire("72sRP");

var $3YsGq = parcelRequire("3YsGq");
var $85f65c380ec99ad9$var$Radio = (0, $72sRP.default);
$85f65c380ec99ad9$var$Radio.Button = (0, $3YsGq.default);
$85f65c380ec99ad9$var$Radio.Group = (0, $gU86F.default);
$85f65c380ec99ad9$var$Radio.__ANT_RADIO = true;
var $85f65c380ec99ad9$export$2e2bcd8739ae039 = $85f65c380ec99ad9$var$Radio;

});
parcelRegister("gU86F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4e82a1e72ae8977$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $8K2NM = parcelRequire("8K2NM");

var $CZyex = parcelRequire("CZyex");

var $02LyB = parcelRequire("02LyB");

var $9nYhz = parcelRequire("9nYhz");

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("8uDri");
var $ewikT = parcelRequire("ewikT");

var $7VQDG = parcelRequire("7VQDG");

var $cSHvN = parcelRequire("cSHvN");

var $fJHn9 = parcelRequire("fJHn9");

var $72sRP = parcelRequire("72sRP");
var $c4e82a1e72ae8977$var$RadioGroup = /*#__PURE__*/ $jbmdS.forwardRef(function(props, ref) {
    var _React$useContext = $jbmdS.useContext((0, $ewikT.ConfigContext)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var size = $jbmdS.useContext((0, $7VQDG.default));
    var _useMergedState = (0, $9nYhz.default)(props.defaultValue, {
        value: props.value
    }), _useMergedState2 = (0, $CZyex.default)(_useMergedState, 2), value = _useMergedState2[0], setValue = _useMergedState2[1];
    var onRadioChange = function onRadioChange(ev) {
        var lastValue = value;
        var val = ev.target.value;
        if (!("value" in props)) setValue(val);
        var onChange = props.onChange;
        if (onChange && val !== lastValue) onChange(ev);
    };
    var customizePrefixCls = props.prefixCls, _props$className = props.className, className = _props$className === void 0 ? "" : _props$className, options = props.options, _props$buttonStyle = props.buttonStyle, buttonStyle = _props$buttonStyle === void 0 ? "outline" : _props$buttonStyle, disabled = props.disabled, children = props.children, customizeSize = props.size, style = props.style, id = props.id, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onFocus = props.onFocus, onBlur = props.onBlur;
    var prefixCls = getPrefixCls("radio", customizePrefixCls);
    var groupPrefixCls = "".concat(prefixCls, "-group");
    var childrenToRender = children;
    // 如果存在 options, 优先使用
    if (options && options.length > 0) childrenToRender = options.map(function(option) {
        if (typeof option === "string" || typeof option === "number") // 此处类型自动推导为 string
        return /*#__PURE__*/ $jbmdS.createElement((0, $72sRP.default), {
            key: option.toString(),
            prefixCls: prefixCls,
            disabled: disabled,
            value: option,
            checked: value === option
        }, option);
        // 此处类型自动推导为 { label: string value: string }
        return /*#__PURE__*/ $jbmdS.createElement((0, $72sRP.default), {
            key: "radio-group-value-options-".concat(option.value),
            prefixCls: prefixCls,
            disabled: option.disabled || disabled,
            value: option.value,
            checked: value === option.value,
            style: option.style
        }, option.label);
    });
    var mergedSize = customizeSize || size;
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(groupPrefixCls, "".concat(groupPrefixCls, "-").concat(buttonStyle), (0, $8K2NM.default)((0, $8K2NM.default)({}, "".concat(groupPrefixCls, "-").concat(mergedSize), mergedSize), "".concat(groupPrefixCls, "-rtl"), direction === "rtl"), className);
    return /*#__PURE__*/ $jbmdS.createElement("div", (0, $7i29i.default)({}, (0, $cSHvN.default)(props), {
        className: classString,
        style: style,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onFocus: onFocus,
        onBlur: onBlur,
        id: id,
        ref: ref
    }), /*#__PURE__*/ $jbmdS.createElement((0, $fJHn9.RadioGroupContextProvider), {
        value: {
            onChange: onRadioChange,
            value: value,
            disabled: props.disabled,
            name: props.name,
            optionType: props.optionType
        }
    }, childrenToRender));
});
var $c4e82a1e72ae8977$export$2e2bcd8739ae039 = /*#__PURE__*/ $jbmdS.memo($c4e82a1e72ae8977$var$RadioGroup);

});
parcelRegister("fJHn9", function(module, exports) {

$parcel$export(module.exports, "RadioGroupContextProvider", function () { return $b74cb3d4d84b730e$export$67d4730aee04efd2; });
$parcel$export(module.exports, "default", function () { return $b74cb3d4d84b730e$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "RadioOptionTypeContext", function () { return $b74cb3d4d84b730e$export$4fbd9581b41e971f; });
$parcel$export(module.exports, "RadioOptionTypeContextProvider", function () { return $b74cb3d4d84b730e$export$1b5d1f64a577990e; });

var $jbmdS = parcelRequire("jbmdS");
var $b74cb3d4d84b730e$var$RadioGroupContext = /*#__PURE__*/ $jbmdS.createContext(null);
var $b74cb3d4d84b730e$export$67d4730aee04efd2 = $b74cb3d4d84b730e$var$RadioGroupContext.Provider;
var $b74cb3d4d84b730e$export$2e2bcd8739ae039 = $b74cb3d4d84b730e$var$RadioGroupContext;
var $b74cb3d4d84b730e$export$4fbd9581b41e971f = /*#__PURE__*/ $jbmdS.createContext(null);
var $b74cb3d4d84b730e$export$1b5d1f64a577990e = $b74cb3d4d84b730e$export$4fbd9581b41e971f.Provider;

});

parcelRegister("72sRP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51ff1cbdbe735080$export$2e2bcd8739ae039; });

var $8K2NM = parcelRequire("8K2NM");

var $7i29i = parcelRequire("7i29i");

var $02LyB = parcelRequire("02LyB");

var $h7Op5 = parcelRequire("h7Op5");

var $aKVEK = parcelRequire("aKVEK");

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("8uDri");
var $ewikT = parcelRequire("ewikT");

var $kgIuF = parcelRequire("kgIuF");

var $3ACNS = parcelRequire("3ACNS");


var $fJHn9 = parcelRequire("fJHn9");
var $51ff1cbdbe735080$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $51ff1cbdbe735080$var$InternalRadio = function InternalRadio(props, ref) {
    var _a, _b;
    var groupContext = $jbmdS.useContext((0, $fJHn9.default));
    var radioOptionTypeContext = $jbmdS.useContext((0, $fJHn9.RadioOptionTypeContext));
    var _React$useContext = $jbmdS.useContext((0, $ewikT.ConfigContext)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var innerRef = $jbmdS.useRef();
    var mergedRef = (0, $aKVEK.composeRef)(ref, innerRef);
    var _useContext = (0, $jbmdS.useContext)((0, $3ACNS.FormItemInputContext)), isFormItemInput = _useContext.isFormItemInput;
    var onChange = function onChange(e) {
        var _a, _b;
        (_a = props.onChange) === null || _a === void 0 || _a.call(props, e);
        (_b = groupContext === null || groupContext === void 0 ? void 0 : groupContext.onChange) === null || _b === void 0 || _b.call(groupContext, e);
    };
    var customizePrefixCls = props.prefixCls, className = props.className, children = props.children, style = props.style, restProps = $51ff1cbdbe735080$var$__rest(props, [
        "prefixCls",
        "className",
        "children",
        "style"
    ]);
    var radioPrefixCls = getPrefixCls("radio", customizePrefixCls);
    var prefixCls = ((groupContext === null || groupContext === void 0 ? void 0 : groupContext.optionType) || radioOptionTypeContext) === "button" ? "".concat(radioPrefixCls, "-button") : radioPrefixCls;
    var radioProps = (0, $7i29i.default)({}, restProps);
    // ===================== Disabled =====================
    var disabled = $jbmdS.useContext((0, $kgIuF.default));
    if (groupContext) {
        radioProps.name = groupContext.name;
        radioProps.onChange = onChange;
        radioProps.checked = props.value === groupContext.value;
        radioProps.disabled = (_a = radioProps.disabled) !== null && _a !== void 0 ? _a : groupContext.disabled;
    }
    radioProps.disabled = (_b = radioProps.disabled) !== null && _b !== void 0 ? _b : disabled;
    var wrapperClassString = (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("".concat(prefixCls, "-wrapper"), (0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)({}, "".concat(prefixCls, "-wrapper-checked"), radioProps.checked), "".concat(prefixCls, "-wrapper-disabled"), radioProps.disabled), "".concat(prefixCls, "-wrapper-rtl"), direction === "rtl"), "".concat(prefixCls, "-wrapper-in-form-item"), isFormItemInput), className);
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/label-has-associated-control
    $jbmdS.createElement("label", {
        className: wrapperClassString,
        style: style,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave
    }, /*#__PURE__*/ $jbmdS.createElement((0, $h7Op5.default), (0, $7i29i.default)({}, radioProps, {
        type: "radio",
        prefixCls: prefixCls,
        ref: mergedRef
    })), children !== undefined ? /*#__PURE__*/ $jbmdS.createElement("span", null, children) : null));
};
var $51ff1cbdbe735080$var$Radio = /*#__PURE__*/ $jbmdS.forwardRef($51ff1cbdbe735080$var$InternalRadio);
var $51ff1cbdbe735080$export$2e2bcd8739ae039 = $51ff1cbdbe735080$var$Radio;

});


parcelRegister("3YsGq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e4d39991bd7e87f$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("8uDri");
var $ewikT = parcelRequire("ewikT");

var $fJHn9 = parcelRequire("fJHn9");

var $72sRP = parcelRequire("72sRP");
var $2e4d39991bd7e87f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $2e4d39991bd7e87f$var$RadioButton = function RadioButton(props, ref) {
    var _React$useContext = $jbmdS.useContext((0, $ewikT.ConfigContext)), getPrefixCls = _React$useContext.getPrefixCls;
    var customizePrefixCls = props.prefixCls, radioProps = $2e4d39991bd7e87f$var$__rest(props, [
        "prefixCls"
    ]);
    var prefixCls = getPrefixCls("radio", customizePrefixCls);
    return /*#__PURE__*/ $jbmdS.createElement((0, $fJHn9.RadioOptionTypeContextProvider), {
        value: "button"
    }, /*#__PURE__*/ $jbmdS.createElement((0, $72sRP.default), (0, $7i29i.default)({
        prefixCls: prefixCls
    }, radioProps, {
        type: "radio",
        ref: ref
    })));
};
var $2e4d39991bd7e87f$export$2e2bcd8739ae039 = /*#__PURE__*/ $jbmdS.forwardRef($2e4d39991bd7e87f$var$RadioButton);

});


parcelRegister("4qR9D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33a2d279f5944348$export$2e2bcd8739ae039; });

var $8K2NM = parcelRequire("8K2NM");

var $7i29i = parcelRequire("7i29i");

var $02LyB = parcelRequire("02LyB");

var $e7LyC = parcelRequire("e7LyC");
var $kJcbr = parcelRequire("kJcbr");
var $QDKu0 = parcelRequire("QDKu0");

var $cXDkH = parcelRequire("cXDkH");

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("8uDri");
var $ewikT = parcelRequire("ewikT");

var $9cRrz = parcelRequire("9cRrz");

var $kgIuF = parcelRequire("kgIuF");

var $7VQDG = parcelRequire("7VQDG");

var $3ACNS = parcelRequire("3ACNS");

var $5Tk2v = parcelRequire("5Tk2v");

var $j4i2o = parcelRequire("j4i2o");

var $9ULK8 = parcelRequire("9ULK8");


var $9RKXl = parcelRequire("9RKXl");
// TODO: 4.0 - codemod should help to change `filterOption` to support node props.
var $33a2d279f5944348$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $33a2d279f5944348$var$SECRET_COMBOBOX_MODE_DO_NOT_USE = "SECRET_COMBOBOX_MODE_DO_NOT_USE";
var $33a2d279f5944348$var$InternalSelect = function InternalSelect(_a, ref) {
    var customizePrefixCls = _a.prefixCls, _a$bordered = _a.bordered, bordered = _a$bordered === void 0 ? true : _a$bordered, className = _a.className, getPopupContainer = _a.getPopupContainer, dropdownClassName = _a.dropdownClassName, popupClassName = _a.popupClassName, _a$listHeight = _a.listHeight, listHeight = _a$listHeight === void 0 ? 256 : _a$listHeight, placement = _a.placement, _a$listItemHeight = _a.listItemHeight, listItemHeight = _a$listItemHeight === void 0 ? 32 : _a$listItemHeight, customizeSize = _a.size, customDisabled = _a.disabled, notFoundContent = _a.notFoundContent, customStatus = _a.status, showArrow = _a.showArrow, props = $33a2d279f5944348$var$__rest(_a, [
        "prefixCls",
        "bordered",
        "className",
        "getPopupContainer",
        "dropdownClassName",
        "popupClassName",
        "listHeight",
        "placement",
        "listItemHeight",
        "size",
        "disabled",
        "notFoundContent",
        "status",
        "showArrow"
    ]);
    var _React$useContext = $jbmdS.useContext((0, $ewikT.ConfigContext)), getContextPopupContainer = _React$useContext.getPopupContainer, getPrefixCls = _React$useContext.getPrefixCls, renderEmpty = _React$useContext.renderEmpty, direction = _React$useContext.direction, virtual = _React$useContext.virtual, dropdownMatchSelectWidth = _React$useContext.dropdownMatchSelectWidth;
    var size = $jbmdS.useContext((0, $7VQDG.default));
    var prefixCls = getPrefixCls("select", customizePrefixCls);
    var rootPrefixCls = getPrefixCls();
    var _useCompactItemContex = (0, $9RKXl.useCompactItemContext)(prefixCls, direction), compactSize = _useCompactItemContex.compactSize, compactItemClassnames = _useCompactItemContex.compactItemClassnames;
    var mode = $jbmdS.useMemo(function() {
        var m = props.mode;
        if (m === "combobox") return undefined;
        if (m === $33a2d279f5944348$var$SECRET_COMBOBOX_MODE_DO_NOT_USE) return "combobox";
        return m;
    }, [
        props.mode
    ]);
    var isMultiple = mode === "multiple" || mode === "tags";
    var mergedShowArrow = showArrow !== undefined ? showArrow : props.loading || !(isMultiple || mode === "combobox");
    // ===================== Form Status =====================
    var _useContext = (0, $jbmdS.useContext)((0, $3ACNS.FormItemInputContext)), contextStatus = _useContext.status, hasFeedback = _useContext.hasFeedback, isFormItemInput = _useContext.isFormItemInput, feedbackIcon = _useContext.feedbackIcon;
    var mergedStatus = (0, $j4i2o.getMergedStatus)(contextStatus, customStatus);
    // ===================== Empty =====================
    var mergedNotFound;
    if (notFoundContent !== undefined) mergedNotFound = notFoundContent;
    else if (mode === "combobox") mergedNotFound = null;
    else mergedNotFound = (renderEmpty || (0, $9cRrz.default))("Select");
    // ===================== Icons =====================
    var _getIcons = (0, $9ULK8.default)((0, $7i29i.default)((0, $7i29i.default)({}, props), {
        multiple: isMultiple,
        hasFeedback: hasFeedback,
        feedbackIcon: feedbackIcon,
        showArrow: mergedShowArrow,
        prefixCls: prefixCls
    })), suffixIcon = _getIcons.suffixIcon, itemIcon = _getIcons.itemIcon, removeIcon = _getIcons.removeIcon, clearIcon = _getIcons.clearIcon;
    var selectProps = (0, $cXDkH.default)(props, [
        "suffixIcon",
        "itemIcon"
    ]);
    var rcSelectRtlDropdownClassName = (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(popupClassName || dropdownClassName, (0, $8K2NM.default)({}, "".concat(prefixCls, "-dropdown-").concat(direction), direction === "rtl"));
    var mergedSize = compactSize || customizeSize || size;
    // ===================== Disabled =====================
    var disabled = $jbmdS.useContext((0, $kgIuF.default));
    var mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)({}, "".concat(prefixCls, "-lg"), mergedSize === "large"), "".concat(prefixCls, "-sm"), mergedSize === "small"), "".concat(prefixCls, "-rtl"), direction === "rtl"), "".concat(prefixCls, "-borderless"), !bordered), "".concat(prefixCls, "-in-form-item"), isFormItemInput), (0, $j4i2o.getStatusClassNames)(prefixCls, mergedStatus, hasFeedback), compactItemClassnames, className);
    // ===================== Placement =====================
    var getPlacement = function getPlacement() {
        if (placement !== undefined) return placement;
        return direction === "rtl" ? "bottomRight" : "bottomLeft";
    };
    return /*#__PURE__*/ $jbmdS.createElement((0, $e7LyC.default), (0, $7i29i.default)({
        ref: ref,
        virtual: virtual,
        dropdownMatchSelectWidth: dropdownMatchSelectWidth
    }, selectProps, {
        transitionName: (0, $5Tk2v.getTransitionName)(rootPrefixCls, (0, $5Tk2v.getTransitionDirection)(placement), props.transitionName),
        listHeight: listHeight,
        listItemHeight: listItemHeight,
        mode: mode,
        prefixCls: prefixCls,
        placement: getPlacement(),
        direction: direction,
        inputIcon: suffixIcon,
        menuItemSelectedIcon: itemIcon,
        removeIcon: removeIcon,
        clearIcon: clearIcon,
        notFoundContent: mergedNotFound,
        className: mergedClassName,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        dropdownClassName: rcSelectRtlDropdownClassName,
        showArrow: hasFeedback || showArrow,
        disabled: mergedDisabled
    }));
};
var $33a2d279f5944348$var$Select = /*#__PURE__*/ $jbmdS.forwardRef($33a2d279f5944348$var$InternalSelect);
$33a2d279f5944348$var$Select.SECRET_COMBOBOX_MODE_DO_NOT_USE = $33a2d279f5944348$var$SECRET_COMBOBOX_MODE_DO_NOT_USE;
$33a2d279f5944348$var$Select.Option = (0, $QDKu0.default);
$33a2d279f5944348$var$Select.OptGroup = (0, $kJcbr.default);
var $33a2d279f5944348$export$2e2bcd8739ae039 = $33a2d279f5944348$var$Select;

});
parcelRegister("e7LyC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4869c104d0e89f4$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Option", function () { return (parcelRequire("QDKu0")).default; });
$parcel$export(module.exports, "OptGroup", function () { return (parcelRequire("kJcbr")).default; });

var $d3chi = parcelRequire("d3chi");

var $QDKu0 = parcelRequire("QDKu0");

var $kJcbr = parcelRequire("kJcbr");

var $awmch = parcelRequire("awmch");

var $2eOmx = parcelRequire("2eOmx");
var $a4869c104d0e89f4$export$2e2bcd8739ae039 = (0, $d3chi.default);

});
parcelRegister("d3chi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9805145685f49c7d$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $huwkX = parcelRequire("huwkX");

var $8K2NM = parcelRequire("8K2NM");

var $lv6ip = parcelRequire("lv6ip");

var $CZyex = parcelRequire("CZyex");

var $ccQt4 = parcelRequire("ccQt4");

var $jncUt = parcelRequire("jncUt");

var $9nYhz = parcelRequire("9nYhz");
parcelRequire("8tMCd");

var $jbmdS = parcelRequire("jbmdS");

var $awmch = parcelRequire("awmch");

var $c1ozx = parcelRequire("c1ozx");

var $atbOI = parcelRequire("atbOI");

var $ayI6j = parcelRequire("ayI6j");

var $jhHhr = parcelRequire("jhHhr");

var $14qFa = parcelRequire("14qFa");

var $kJcbr = parcelRequire("kJcbr");

var $QDKu0 = parcelRequire("QDKu0");

var $4QI5P = parcelRequire("4QI5P");

var $1TF7a = parcelRequire("1TF7a");

var $gDBzp = parcelRequire("gDBzp");

var $6FrK4 = parcelRequire("6FrK4");
parcelRequire("9HQOu");
var $9805145685f49c7d$var$_excluded = [
    "id",
    "mode",
    "prefixCls",
    "backfill",
    "fieldNames",
    "inputValue",
    "searchValue",
    "onSearch",
    "autoClearSearchValue",
    "onSelect",
    "onDeselect",
    "dropdownMatchSelectWidth",
    "filterOption",
    "filterSort",
    "optionFilterProp",
    "optionLabelProp",
    "options",
    "children",
    "defaultActiveFirstOption",
    "menuItemSelectedIcon",
    "virtual",
    "listHeight",
    "listItemHeight",
    "value",
    "defaultValue",
    "labelInValue",
    "onChange"
];
var $9805145685f49c7d$var$OMIT_DOM_PROPS = [
    "inputValue"
];
function $9805145685f49c7d$var$isRawValue(value) {
    return !value || (0, $jncUt.default)(value) !== "object";
}
var $9805145685f49c7d$var$Select = /*#__PURE__*/ $jbmdS.forwardRef(function(props, ref) {
    var id = props.id, mode = props.mode, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-select" : _props$prefixCls, backfill = props.backfill, fieldNames = props.fieldNames, inputValue = props.inputValue, searchValue = props.searchValue, onSearch = props.onSearch, _props$autoClearSearc = props.autoClearSearchValue, autoClearSearchValue = _props$autoClearSearc === void 0 ? true : _props$autoClearSearc, onSelect = props.onSelect, onDeselect = props.onDeselect, _props$dropdownMatchS = props.dropdownMatchSelectWidth, dropdownMatchSelectWidth = _props$dropdownMatchS === void 0 ? true : _props$dropdownMatchS, filterOption = props.filterOption, filterSort = props.filterSort, optionFilterProp = props.optionFilterProp, optionLabelProp = props.optionLabelProp, options = props.options, children = props.children, defaultActiveFirstOption = props.defaultActiveFirstOption, menuItemSelectedIcon = props.menuItemSelectedIcon, virtual = props.virtual, _props$listHeight = props.listHeight, listHeight = _props$listHeight === void 0 ? 200 : _props$listHeight, _props$listItemHeight = props.listItemHeight, listItemHeight = _props$listItemHeight === void 0 ? 20 : _props$listItemHeight, value = props.value, defaultValue = props.defaultValue, labelInValue = props.labelInValue, onChange = props.onChange, restProps = (0, $ccQt4.default)(props, $9805145685f49c7d$var$_excluded);
    var mergedId = (0, $ayI6j.default)(id);
    var multiple = (0, $awmch.isMultiple)(mode);
    var childrenAsData = !!(!options && children);
    var mergedFilterOption = $jbmdS.useMemo(function() {
        if (filterOption === undefined && mode === "combobox") return false;
        return filterOption;
    }, [
        filterOption,
        mode
    ]);
    // ========================= FieldNames =========================
    var mergedFieldNames = $jbmdS.useMemo(function() {
        return (0, $6FrK4.fillFieldNames)(fieldNames, childrenAsData);
    }, /* eslint-disable react-hooks/exhaustive-deps */ [
        // We stringify fieldNames to avoid unnecessary re-renders.
        JSON.stringify(fieldNames),
        childrenAsData
    ]);
    // =========================== Search ===========================
    var _useMergedState = (0, $9nYhz.default)("", {
        value: searchValue !== undefined ? searchValue : inputValue,
        postState: function postState(search) {
            return search || "";
        }
    }), _useMergedState2 = (0, $CZyex.default)(_useMergedState, 2), mergedSearchValue = _useMergedState2[0], setSearchValue = _useMergedState2[1];
    // =========================== Option ===========================
    var parsedOptions = (0, $jhHhr.default)(options, children, mergedFieldNames, optionFilterProp, optionLabelProp);
    var valueOptions = parsedOptions.valueOptions, labelOptions = parsedOptions.labelOptions, mergedOptions = parsedOptions.options;
    // ========================= Wrap Value =========================
    var convert2LabelValues = $jbmdS.useCallback(function(draftValues) {
        // Convert to array
        var valueList = (0, $gDBzp.toArray)(draftValues);
        // Convert to labelInValue type
        return valueList.map(function(val) {
            var rawValue;
            var rawLabel;
            var rawKey;
            var rawDisabled;
            var rawTitle;
            // Fill label & value
            if ($9805145685f49c7d$var$isRawValue(val)) rawValue = val;
            else {
                var _val$value;
                rawKey = val.key;
                rawLabel = val.label;
                rawValue = (_val$value = val.value) !== null && _val$value !== void 0 ? _val$value : rawKey;
            }
            var option = valueOptions.get(rawValue);
            if (option) {
                var _option$key;
                // Fill missing props
                if (rawLabel === undefined) rawLabel = option === null || option === void 0 ? void 0 : option[optionLabelProp || mergedFieldNames.label];
                if (rawKey === undefined) rawKey = (_option$key = option === null || option === void 0 ? void 0 : option.key) !== null && _option$key !== void 0 ? _option$key : rawValue;
                rawDisabled = option === null || option === void 0 ? void 0 : option.disabled;
                rawTitle = option === null || option === void 0 ? void 0 : option.title;
                var optionLabel;
            }
            return {
                label: rawLabel,
                value: rawValue,
                key: rawKey,
                disabled: rawDisabled,
                title: rawTitle
            };
        });
    }, [
        mergedFieldNames,
        optionLabelProp,
        valueOptions
    ]);
    // =========================== Values ===========================
    var _useMergedState3 = (0, $9nYhz.default)(defaultValue, {
        value: value
    }), _useMergedState4 = (0, $CZyex.default)(_useMergedState3, 2), internalValue = _useMergedState4[0], setInternalValue = _useMergedState4[1];
    // Merged value with LabelValueType
    var rawLabeledValues = $jbmdS.useMemo(function() {
        var _values$;
        var values = convert2LabelValues(internalValue);
        // combobox no need save value when it's no value
        if (mode === "combobox" && !((_values$ = values[0]) !== null && _values$ !== void 0 && _values$.value)) return [];
        return values;
    }, [
        internalValue,
        convert2LabelValues,
        mode
    ]);
    // Fill label with cache to avoid option remove
    var _useCache = (0, $c1ozx.default)(rawLabeledValues, valueOptions), _useCache2 = (0, $CZyex.default)(_useCache, 2), mergedValues = _useCache2[0], getMixedOption = _useCache2[1];
    var displayValues = $jbmdS.useMemo(function() {
        // `null` need show as placeholder instead
        // https://github.com/ant-design/ant-design/issues/25057
        if (!mode && mergedValues.length === 1) {
            var firstValue = mergedValues[0];
            if (firstValue.value === null && (firstValue.label === null || firstValue.label === undefined)) return [];
        }
        return mergedValues.map(function(item) {
            var _item$label;
            return (0, $lv6ip.default)((0, $lv6ip.default)({}, item), {}, {
                label: (_item$label = item.label) !== null && _item$label !== void 0 ? _item$label : item.value
            });
        });
    }, [
        mode,
        mergedValues
    ]);
    /** Convert `displayValues` to raw value type set */ var rawValues = $jbmdS.useMemo(function() {
        return new Set(mergedValues.map(function(val) {
            return val.value;
        }));
    }, [
        mergedValues
    ]);
    $jbmdS.useEffect(function() {
        if (mode === "combobox") {
            var _mergedValues$;
            var strValue = (_mergedValues$ = mergedValues[0]) === null || _mergedValues$ === void 0 ? void 0 : _mergedValues$.value;
            setSearchValue((0, $gDBzp.hasValue)(strValue) ? String(strValue) : "");
        }
    }, [
        mergedValues
    ]);
    // ======================= Display Option =======================
    // Create a placeholder item if not exist in `options`
    var createTagOption = (0, $14qFa.default)(function(val, label) {
        var _ref;
        var mergedLabel = label !== null && label !== void 0 ? label : val;
        return _ref = {}, (0, $8K2NM.default)(_ref, mergedFieldNames.value, val), (0, $8K2NM.default)(_ref, mergedFieldNames.label, mergedLabel), _ref;
    });
    // Fill tag as option if mode is `tags`
    var filledTagOptions = $jbmdS.useMemo(function() {
        if (mode !== "tags") return mergedOptions;
        // >>> Tag mode
        var cloneOptions = (0, $huwkX.default)(mergedOptions);
        // Check if value exist in options (include new patch item)
        var existOptions = function existOptions(val) {
            return valueOptions.has(val);
        };
        // Fill current value as option
        (0, $huwkX.default)(mergedValues).sort(function(a, b) {
            return a.value < b.value ? -1 : 1;
        }).forEach(function(item) {
            var val = item.value;
            if (!existOptions(val)) cloneOptions.push(createTagOption(val, item.label));
        });
        return cloneOptions;
    }, [
        createTagOption,
        mergedOptions,
        valueOptions,
        mergedValues,
        mode
    ]);
    var filteredOptions = (0, $atbOI.default)(filledTagOptions, mergedFieldNames, mergedSearchValue, mergedFilterOption, optionFilterProp);
    // Fill options with search value if needed
    var filledSearchOptions = $jbmdS.useMemo(function() {
        if (mode !== "tags" || !mergedSearchValue || filteredOptions.some(function(item) {
            return item[optionFilterProp || "value"] === mergedSearchValue;
        })) return filteredOptions;
        // Fill search value as option
        return [
            createTagOption(mergedSearchValue)
        ].concat((0, $huwkX.default)(filteredOptions));
    }, [
        createTagOption,
        optionFilterProp,
        mode,
        filteredOptions,
        mergedSearchValue
    ]);
    var orderedFilteredOptions = $jbmdS.useMemo(function() {
        if (!filterSort) return filledSearchOptions;
        return (0, $huwkX.default)(filledSearchOptions).sort(function(a, b) {
            return filterSort(a, b);
        });
    }, [
        filledSearchOptions,
        filterSort
    ]);
    var displayOptions = $jbmdS.useMemo(function() {
        return (0, $6FrK4.flattenOptions)(orderedFilteredOptions, {
            fieldNames: mergedFieldNames,
            childrenAsData: childrenAsData
        });
    }, [
        orderedFilteredOptions,
        mergedFieldNames,
        childrenAsData
    ]);
    // =========================== Change ===========================
    var triggerChange = function triggerChange(values) {
        var labeledValues = convert2LabelValues(values);
        setInternalValue(labeledValues);
        if (onChange && // Trigger event only when value changed
        (labeledValues.length !== mergedValues.length || labeledValues.some(function(newVal, index) {
            var _mergedValues$index;
            return ((_mergedValues$index = mergedValues[index]) === null || _mergedValues$index === void 0 ? void 0 : _mergedValues$index.value) !== (newVal === null || newVal === void 0 ? void 0 : newVal.value);
        }))) {
            var returnValues = labelInValue ? labeledValues : labeledValues.map(function(v) {
                return v.value;
            });
            var returnOptions = labeledValues.map(function(v) {
                return (0, $6FrK4.injectPropsWithOption)(getMixedOption(v.value));
            });
            onChange(// Value
            multiple ? returnValues : returnValues[0], // Option
            multiple ? returnOptions : returnOptions[0]);
        }
    };
    // ======================= Accessibility ========================
    var _React$useState = $jbmdS.useState(null), _React$useState2 = (0, $CZyex.default)(_React$useState, 2), activeValue = _React$useState2[0], setActiveValue = _React$useState2[1];
    var _React$useState3 = $jbmdS.useState(0), _React$useState4 = (0, $CZyex.default)(_React$useState3, 2), accessibilityIndex = _React$useState4[0], setAccessibilityIndex = _React$useState4[1];
    var mergedDefaultActiveFirstOption = defaultActiveFirstOption !== undefined ? defaultActiveFirstOption : mode !== "combobox";
    var onActiveValue = $jbmdS.useCallback(function(active, index) {
        var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, _ref2$source = _ref2.source, source = _ref2$source === void 0 ? "keyboard" : _ref2$source;
        setAccessibilityIndex(index);
        if (backfill && mode === "combobox" && active !== null && source === "keyboard") setActiveValue(String(active));
    }, [
        backfill,
        mode
    ]);
    // ========================= OptionList =========================
    var triggerSelect = function triggerSelect(val, selected, type) {
        var getSelectEnt = function getSelectEnt() {
            var _option$key2;
            var option = getMixedOption(val);
            return [
                labelInValue ? {
                    label: option === null || option === void 0 ? void 0 : option[mergedFieldNames.label],
                    value: val,
                    key: (_option$key2 = option === null || option === void 0 ? void 0 : option.key) !== null && _option$key2 !== void 0 ? _option$key2 : val
                } : val,
                (0, $6FrK4.injectPropsWithOption)(option)
            ];
        };
        if (selected && onSelect) {
            var _getSelectEnt = getSelectEnt(), _getSelectEnt2 = (0, $CZyex.default)(_getSelectEnt, 2), wrappedValue = _getSelectEnt2[0], _option = _getSelectEnt2[1];
            onSelect(wrappedValue, _option);
        } else if (!selected && onDeselect && type !== "clear") {
            var _getSelectEnt3 = getSelectEnt(), _getSelectEnt4 = (0, $CZyex.default)(_getSelectEnt3, 2), _wrappedValue = _getSelectEnt4[0], _option2 = _getSelectEnt4[1];
            onDeselect(_wrappedValue, _option2);
        }
    };
    // Used for OptionList selection
    var onInternalSelect = (0, $14qFa.default)(function(val, info) {
        var cloneValues;
        // Single mode always trigger select only with option list
        var mergedSelect = multiple ? info.selected : true;
        if (mergedSelect) cloneValues = multiple ? [].concat((0, $huwkX.default)(mergedValues), [
            val
        ]) : [
            val
        ];
        else cloneValues = mergedValues.filter(function(v) {
            return v.value !== val;
        });
        triggerChange(cloneValues);
        triggerSelect(val, mergedSelect);
        // Clean search value if single or configured
        if (mode === "combobox") // setSearchValue(String(val));
        setActiveValue("");
        else if (!(0, $awmch.isMultiple) || autoClearSearchValue) {
            setSearchValue("");
            setActiveValue("");
        }
    });
    // ======================= Display Change =======================
    // BaseSelect display values change
    var onDisplayValuesChange = function onDisplayValuesChange(nextValues, info) {
        triggerChange(nextValues);
        var type = info.type, values = info.values;
        if (type === "remove" || type === "clear") values.forEach(function(item) {
            triggerSelect(item.value, false, type);
        });
    };
    // =========================== Search ===========================
    var onInternalSearch = function onInternalSearch(searchText, info) {
        setSearchValue(searchText);
        setActiveValue(null);
        // [Submit] Tag mode should flush input
        if (info.source === "submit") {
            var formatted = (searchText || "").trim();
            // prevent empty tags from appearing when you click the Enter button
            if (formatted) {
                var newRawValues = Array.from(new Set([].concat((0, $huwkX.default)(rawValues), [
                    formatted
                ])));
                triggerChange(newRawValues);
                triggerSelect(formatted, true);
                setSearchValue("");
            }
            return;
        }
        if (info.source !== "blur") {
            if (mode === "combobox") triggerChange(searchText);
            onSearch === null || onSearch === void 0 || onSearch(searchText);
        }
    };
    var onInternalSearchSplit = function onInternalSearchSplit(words) {
        var patchValues = words;
        if (mode !== "tags") patchValues = words.map(function(word) {
            var opt = labelOptions.get(word);
            return opt === null || opt === void 0 ? void 0 : opt.value;
        }).filter(function(val) {
            return val !== undefined;
        });
        var newRawValues = Array.from(new Set([].concat((0, $huwkX.default)(rawValues), (0, $huwkX.default)(patchValues))));
        triggerChange(newRawValues);
        newRawValues.forEach(function(newRawValue) {
            triggerSelect(newRawValue, true);
        });
    };
    // ========================== Context ===========================
    var selectContext = $jbmdS.useMemo(function() {
        var realVirtual = virtual !== false && dropdownMatchSelectWidth !== false;
        return (0, $lv6ip.default)((0, $lv6ip.default)({}, parsedOptions), {}, {
            flattenOptions: displayOptions,
            onActiveValue: onActiveValue,
            defaultActiveFirstOption: mergedDefaultActiveFirstOption,
            onSelect: onInternalSelect,
            menuItemSelectedIcon: menuItemSelectedIcon,
            rawValues: rawValues,
            fieldNames: mergedFieldNames,
            virtual: realVirtual,
            listHeight: listHeight,
            listItemHeight: listItemHeight,
            childrenAsData: childrenAsData
        });
    }, [
        parsedOptions,
        displayOptions,
        onActiveValue,
        mergedDefaultActiveFirstOption,
        onInternalSelect,
        menuItemSelectedIcon,
        rawValues,
        mergedFieldNames,
        virtual,
        dropdownMatchSelectWidth,
        listHeight,
        listItemHeight,
        childrenAsData
    ]);
    // ==============================================================
    // ==                          Render                          ==
    // ==============================================================
    return /*#__PURE__*/ $jbmdS.createElement((0, $1TF7a.default).Provider, {
        value: selectContext
    }, /*#__PURE__*/ $jbmdS.createElement((0, $awmch.default), (0, $7i29i.default)({}, restProps, {
        // >>> MISC
        id: mergedId,
        prefixCls: prefixCls,
        ref: ref,
        omitDomProps: $9805145685f49c7d$var$OMIT_DOM_PROPS,
        mode: mode,
        displayValues: displayValues,
        onDisplayValuesChange: onDisplayValuesChange,
        searchValue: mergedSearchValue,
        onSearch: onInternalSearch,
        autoClearSearchValue: autoClearSearchValue,
        onSearchSplit: onInternalSearchSplit,
        dropdownMatchSelectWidth: dropdownMatchSelectWidth,
        OptionList: (0, $4QI5P.default),
        emptyOptions: !displayOptions.length,
        activeValue: activeValue,
        activeDescendantId: "".concat(mergedId, "_list_").concat(accessibilityIndex)
    })));
});
var $9805145685f49c7d$var$TypedSelect = $9805145685f49c7d$var$Select;
$9805145685f49c7d$var$TypedSelect.Option = (0, $QDKu0.default);
$9805145685f49c7d$var$TypedSelect.OptGroup = (0, $kJcbr.default);
var $9805145685f49c7d$export$2e2bcd8739ae039 = $9805145685f49c7d$var$TypedSelect;

});
parcelRegister("awmch", function(module, exports) {

$parcel$export(module.exports, "isMultiple", function () { return $7a8e1c6b8b8a9bfe$export$7f654ad2a77ad2ac; });
$parcel$export(module.exports, "default", function () { return $7a8e1c6b8b8a9bfe$export$2e2bcd8739ae039; });

var $jncUt = parcelRequire("jncUt");

var $7i29i = parcelRequire("7i29i");

var $8K2NM = parcelRequire("8K2NM");

var $huwkX = parcelRequire("huwkX");

var $CZyex = parcelRequire("CZyex");

var $lv6ip = parcelRequire("lv6ip");

var $ccQt4 = parcelRequire("ccQt4");

var $02LyB = parcelRequire("02LyB");

var $iDOLX = parcelRequire("iDOLX");

var $9nYhz = parcelRequire("9nYhz");

var $FYXRo = parcelRequire("FYXRo");

var $5yi5E = parcelRequire("5yi5E");

var $aKVEK = parcelRequire("aKVEK");

var $jbmdS = parcelRequire("jbmdS");

var $2eOmx = parcelRequire("2eOmx");

var $4gmip = parcelRequire("4gmip");

var $10VKB = parcelRequire("10VKB");

var $bqqhg = parcelRequire("bqqhg");

var $eo7tB = parcelRequire("eo7tB");

var $70fqL = parcelRequire("70fqL");

var $1hjik = parcelRequire("1hjik");

var $6FrK4 = parcelRequire("6FrK4");
var $7a8e1c6b8b8a9bfe$var$_excluded = [
    "id",
    "prefixCls",
    "className",
    "showSearch",
    "tagRender",
    "direction",
    "omitDomProps",
    "displayValues",
    "onDisplayValuesChange",
    "emptyOptions",
    "notFoundContent",
    "onClear",
    "mode",
    "disabled",
    "loading",
    "getInputElement",
    "getRawInputElement",
    "open",
    "defaultOpen",
    "onDropdownVisibleChange",
    "activeValue",
    "onActiveValueChange",
    "activeDescendantId",
    "searchValue",
    "autoClearSearchValue",
    "onSearch",
    "onSearchSplit",
    "tokenSeparators",
    "allowClear",
    "showArrow",
    "inputIcon",
    "clearIcon",
    "OptionList",
    "animation",
    "transitionName",
    "dropdownStyle",
    "dropdownClassName",
    "dropdownMatchSelectWidth",
    "dropdownRender",
    "dropdownAlign",
    "placement",
    "getPopupContainer",
    "showAction",
    "onFocus",
    "onBlur",
    "onKeyUp",
    "onKeyDown",
    "onMouseDown"
];
var $7a8e1c6b8b8a9bfe$var$DEFAULT_OMIT_PROPS = [
    "value",
    "onChange",
    "removeIcon",
    "placeholder",
    "autoFocus",
    "maxTagCount",
    "maxTagTextLength",
    "maxTagPlaceholder",
    "choiceTransitionName",
    "onInputKeyDown",
    "onPopupScroll",
    "tabIndex"
];
function $7a8e1c6b8b8a9bfe$export$7f654ad2a77ad2ac(mode) {
    return mode === "tags" || mode === "multiple";
}
var $7a8e1c6b8b8a9bfe$var$BaseSelect = /*#__PURE__*/ $jbmdS.forwardRef(function(props, ref) {
    var _customizeRawInputEle, _classNames2;
    var id = props.id, prefixCls = props.prefixCls, className = props.className, showSearch = props.showSearch, tagRender = props.tagRender, direction = props.direction, omitDomProps = props.omitDomProps, displayValues = props.displayValues, onDisplayValuesChange = props.onDisplayValuesChange, emptyOptions = props.emptyOptions, _props$notFoundConten = props.notFoundContent, notFoundContent = _props$notFoundConten === void 0 ? "Not Found" : _props$notFoundConten, onClear = props.onClear, mode = props.mode, disabled = props.disabled, loading = props.loading, getInputElement = props.getInputElement, getRawInputElement = props.getRawInputElement, open = props.open, defaultOpen = props.defaultOpen, onDropdownVisibleChange = props.onDropdownVisibleChange, activeValue = props.activeValue, onActiveValueChange = props.onActiveValueChange, activeDescendantId = props.activeDescendantId, searchValue = props.searchValue, autoClearSearchValue = props.autoClearSearchValue, onSearch = props.onSearch, onSearchSplit = props.onSearchSplit, tokenSeparators = props.tokenSeparators, allowClear = props.allowClear, showArrow = props.showArrow, inputIcon = props.inputIcon, clearIcon = props.clearIcon, OptionList = props.OptionList, animation = props.animation, transitionName = props.transitionName, dropdownStyle = props.dropdownStyle, dropdownClassName = props.dropdownClassName, dropdownMatchSelectWidth = props.dropdownMatchSelectWidth, dropdownRender = props.dropdownRender, dropdownAlign = props.dropdownAlign, placement = props.placement, getPopupContainer = props.getPopupContainer, _props$showAction = props.showAction, showAction = _props$showAction === void 0 ? [] : _props$showAction, onFocus = props.onFocus, onBlur = props.onBlur, onKeyUp = props.onKeyUp, onKeyDown = props.onKeyDown, onMouseDown = props.onMouseDown, restProps = (0, $ccQt4.default)(props, $7a8e1c6b8b8a9bfe$var$_excluded);
    // ============================== MISC ==============================
    var multiple = $7a8e1c6b8b8a9bfe$export$7f654ad2a77ad2ac(mode);
    var mergedShowSearch = (showSearch !== undefined ? showSearch : multiple) || mode === "combobox";
    var domProps = (0, $lv6ip.default)({}, restProps);
    $7a8e1c6b8b8a9bfe$var$DEFAULT_OMIT_PROPS.forEach(function(propName) {
        delete domProps[propName];
    });
    omitDomProps === null || omitDomProps === void 0 || omitDomProps.forEach(function(propName) {
        delete domProps[propName];
    });
    // ============================= Mobile =============================
    var _React$useState = $jbmdS.useState(false), _React$useState2 = (0, $CZyex.default)(_React$useState, 2), mobile = _React$useState2[0], setMobile = _React$useState2[1];
    $jbmdS.useEffect(function() {
        // Only update on the client side
        setMobile((0, $FYXRo.default)());
    }, []);
    // ============================== Refs ==============================
    var containerRef = $jbmdS.useRef(null);
    var selectorDomRef = $jbmdS.useRef(null);
    var triggerRef = $jbmdS.useRef(null);
    var selectorRef = $jbmdS.useRef(null);
    var listRef = $jbmdS.useRef(null);
    /** Used for component focused management */ var _useDelayReset = (0, $4gmip.default)(), _useDelayReset2 = (0, $CZyex.default)(_useDelayReset, 3), mockFocused = _useDelayReset2[0], setMockFocused = _useDelayReset2[1], cancelSetMockFocused = _useDelayReset2[2];
    // =========================== Imperative ===========================
    $jbmdS.useImperativeHandle(ref, function() {
        var _selectorRef$current, _selectorRef$current2;
        return {
            focus: (_selectorRef$current = selectorRef.current) === null || _selectorRef$current === void 0 ? void 0 : _selectorRef$current.focus,
            blur: (_selectorRef$current2 = selectorRef.current) === null || _selectorRef$current2 === void 0 ? void 0 : _selectorRef$current2.blur,
            scrollTo: function scrollTo(arg) {
                var _listRef$current;
                return (_listRef$current = listRef.current) === null || _listRef$current === void 0 ? void 0 : _listRef$current.scrollTo(arg);
            }
        };
    });
    // ========================== Search Value ==========================
    var mergedSearchValue = $jbmdS.useMemo(function() {
        var _displayValues$;
        if (mode !== "combobox") return searchValue;
        var val = (_displayValues$ = displayValues[0]) === null || _displayValues$ === void 0 ? void 0 : _displayValues$.value;
        return typeof val === "string" || typeof val === "number" ? String(val) : "";
    }, [
        searchValue,
        mode,
        displayValues
    ]);
    // ========================== Custom Input ==========================
    // Only works in `combobox`
    var customizeInputElement = mode === "combobox" && typeof getInputElement === "function" && getInputElement() || null;
    // Used for customize replacement for `rc-cascader`
    var customizeRawInputElement = typeof getRawInputElement === "function" && getRawInputElement();
    var customizeRawInputRef = (0, $aKVEK.useComposeRef)(selectorDomRef, customizeRawInputElement === null || customizeRawInputElement === void 0 ? void 0 : (_customizeRawInputEle = customizeRawInputElement.props) === null || _customizeRawInputEle === void 0 ? void 0 : _customizeRawInputEle.ref);
    // ============================== Open ==============================
    var _useMergedState = (0, $9nYhz.default)(undefined, {
        defaultValue: defaultOpen,
        value: open
    }), _useMergedState2 = (0, $CZyex.default)(_useMergedState, 2), innerOpen = _useMergedState2[0], setInnerOpen = _useMergedState2[1];
    var mergedOpen = innerOpen;
    // Not trigger `open` in `combobox` when `notFoundContent` is empty
    var emptyListContent = !notFoundContent && emptyOptions;
    if (disabled || emptyListContent && mergedOpen && mode === "combobox") mergedOpen = false;
    var triggerOpen = emptyListContent ? false : mergedOpen;
    var onToggleOpen = $jbmdS.useCallback(function(newOpen) {
        var nextOpen = newOpen !== undefined ? newOpen : !mergedOpen;
        if (!disabled) {
            setInnerOpen(nextOpen);
            if (mergedOpen !== nextOpen) onDropdownVisibleChange === null || onDropdownVisibleChange === void 0 || onDropdownVisibleChange(nextOpen);
        }
    }, [
        disabled,
        mergedOpen,
        setInnerOpen,
        onDropdownVisibleChange
    ]);
    // ============================= Search =============================
    var tokenWithEnter = $jbmdS.useMemo(function() {
        return (tokenSeparators || []).some(function(tokenSeparator) {
            return [
                "\n",
                "\r\n"
            ].includes(tokenSeparator);
        });
    }, [
        tokenSeparators
    ]);
    var onInternalSearch = function onInternalSearch(searchText, fromTyping, isCompositing) {
        var ret = true;
        var newSearchText = searchText;
        onActiveValueChange === null || onActiveValueChange === void 0 || onActiveValueChange(null);
        // Check if match the `tokenSeparators`
        var patchLabels = isCompositing ? null : (0, $6FrK4.getSeparatedContent)(searchText, tokenSeparators);
        // Ignore combobox since it's not split-able
        if (mode !== "combobox" && patchLabels) {
            newSearchText = "";
            onSearchSplit === null || onSearchSplit === void 0 || onSearchSplit(patchLabels);
            // Should close when paste finish
            onToggleOpen(false);
            // Tell Selector that break next actions
            ret = false;
        }
        if (onSearch && mergedSearchValue !== newSearchText) onSearch(newSearchText, {
            source: fromTyping ? "typing" : "effect"
        });
        return ret;
    };
    // Only triggered when menu is closed & mode is tags
    // If menu is open, OptionList will take charge
    // If mode isn't tags, press enter is not meaningful when you can't see any option
    var onInternalSearchSubmit = function onInternalSearchSubmit(searchText) {
        // prevent empty tags from appearing when you click the Enter button
        if (!searchText || !searchText.trim()) return;
        onSearch(searchText, {
            source: "submit"
        });
    };
    // Close will clean up single mode search text
    $jbmdS.useEffect(function() {
        if (!mergedOpen && !multiple && mode !== "combobox") onInternalSearch("", false, false);
    }, [
        mergedOpen
    ]);
    // ============================ Disabled ============================
    // Close dropdown & remove focus state when disabled change
    $jbmdS.useEffect(function() {
        if (innerOpen && disabled) setInnerOpen(false);
        if (disabled) setMockFocused(false);
    }, [
        disabled
    ]);
    // ============================ Keyboard ============================
    /**
   * We record input value here to check if can press to clean up by backspace
   * - null: Key is not down, this is reset by key up
   * - true: Search text is empty when first time backspace down
   * - false: Search text is not empty when first time backspace down
   */ var _useLock = (0, $10VKB.default)(), _useLock2 = (0, $CZyex.default)(_useLock, 2), getClearLock = _useLock2[0], setClearLock = _useLock2[1];
    // KeyDown
    var onInternalKeyDown = function onInternalKeyDown(event) {
        var clearLock = getClearLock();
        var which = event.which;
        if (which === (0, $5yi5E.default).ENTER) {
            // Do not submit form when type in the input
            if (mode !== "combobox") event.preventDefault();
            // We only manage open state here, close logic should handle by list component
            if (!mergedOpen) onToggleOpen(true);
        }
        setClearLock(!!mergedSearchValue);
        // Remove value by `backspace`
        if (which === (0, $5yi5E.default).BACKSPACE && !clearLock && multiple && !mergedSearchValue && displayValues.length) {
            var cloneDisplayValues = (0, $huwkX.default)(displayValues);
            var removedDisplayValue = null;
            for(var i = cloneDisplayValues.length - 1; i >= 0; i -= 1){
                var current = cloneDisplayValues[i];
                if (!current.disabled) {
                    cloneDisplayValues.splice(i, 1);
                    removedDisplayValue = current;
                    break;
                }
            }
            if (removedDisplayValue) onDisplayValuesChange(cloneDisplayValues, {
                type: "remove",
                values: [
                    removedDisplayValue
                ]
            });
        }
        for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
        if (mergedOpen && listRef.current) {
            var _listRef$current2;
            (_listRef$current2 = listRef.current).onKeyDown.apply(_listRef$current2, [
                event
            ].concat(rest));
        }
        onKeyDown === null || onKeyDown === void 0 || onKeyDown.apply(void 0, [
            event
        ].concat(rest));
    };
    // KeyUp
    var onInternalKeyUp = function onInternalKeyUp(event) {
        for(var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)rest[_key2 - 1] = arguments[_key2];
        if (mergedOpen && listRef.current) {
            var _listRef$current3;
            (_listRef$current3 = listRef.current).onKeyUp.apply(_listRef$current3, [
                event
            ].concat(rest));
        }
        onKeyUp === null || onKeyUp === void 0 || onKeyUp.apply(void 0, [
            event
        ].concat(rest));
    };
    // ============================ Selector ============================
    var onSelectorRemove = function onSelectorRemove(val) {
        var newValues = displayValues.filter(function(i) {
            return i !== val;
        });
        onDisplayValuesChange(newValues, {
            type: "remove",
            values: [
                val
            ]
        });
    };
    // ========================== Focus / Blur ==========================
    /** Record real focus status */ var focusRef = $jbmdS.useRef(false);
    var onContainerFocus = function onContainerFocus() {
        setMockFocused(true);
        if (!disabled) {
            if (onFocus && !focusRef.current) onFocus.apply(void 0, arguments);
            // `showAction` should handle `focus` if set
            if (showAction.includes("focus")) onToggleOpen(true);
        }
        focusRef.current = true;
    };
    var onContainerBlur = function onContainerBlur() {
        setMockFocused(false, function() {
            focusRef.current = false;
            onToggleOpen(false);
        });
        if (disabled) return;
        if (mergedSearchValue) {
            // `tags` mode should move `searchValue` into values
            if (mode === "tags") onSearch(mergedSearchValue, {
                source: "submit"
            });
            else if (mode === "multiple") // `multiple` mode only clean the search value but not trigger event
            onSearch("", {
                source: "blur"
            });
        }
        if (onBlur) onBlur.apply(void 0, arguments);
    };
    // Give focus back of Select
    var activeTimeoutIds = [];
    $jbmdS.useEffect(function() {
        return function() {
            activeTimeoutIds.forEach(function(timeoutId) {
                return clearTimeout(timeoutId);
            });
            activeTimeoutIds.splice(0, activeTimeoutIds.length);
        };
    }, []);
    var onInternalMouseDown = function onInternalMouseDown(event) {
        var _triggerRef$current;
        var target = event.target;
        var popupElement = (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 ? void 0 : _triggerRef$current.getPopupElement();
        // We should give focus back to selector if clicked item is not focusable
        if (popupElement && popupElement.contains(target)) {
            var timeoutId = setTimeout(function() {
                var index = activeTimeoutIds.indexOf(timeoutId);
                if (index !== -1) activeTimeoutIds.splice(index, 1);
                cancelSetMockFocused();
                if (!mobile && !popupElement.contains(document.activeElement)) {
                    var _selectorRef$current3;
                    (_selectorRef$current3 = selectorRef.current) === null || _selectorRef$current3 === void 0 || _selectorRef$current3.focus();
                }
            });
            activeTimeoutIds.push(timeoutId);
        }
        for(var _len3 = arguments.length, restArgs = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)restArgs[_key3 - 1] = arguments[_key3];
        onMouseDown === null || onMouseDown === void 0 || onMouseDown.apply(void 0, [
            event
        ].concat(restArgs));
    };
    // ============================ Dropdown ============================
    var _React$useState3 = $jbmdS.useState(null), _React$useState4 = (0, $CZyex.default)(_React$useState3, 2), containerWidth = _React$useState4[0], setContainerWidth = _React$useState4[1];
    var _React$useState5 = $jbmdS.useState({}), _React$useState6 = (0, $CZyex.default)(_React$useState5, 2), forceUpdate = _React$useState6[1];
    // We need force update here since popup dom is render async
    function onPopupMouseEnter() {
        forceUpdate({});
    }
    (0, $iDOLX.default)(function() {
        if (triggerOpen) {
            var _containerRef$current;
            var newWidth = Math.ceil((_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.offsetWidth);
            if (containerWidth !== newWidth && !Number.isNaN(newWidth)) setContainerWidth(newWidth);
        }
    }, [
        triggerOpen
    ]);
    // Used for raw custom input trigger
    var onTriggerVisibleChange;
    if (customizeRawInputElement) onTriggerVisibleChange = function onTriggerVisibleChange(newOpen) {
        onToggleOpen(newOpen);
    };
    // Close when click on non-select element
    (0, $bqqhg.default)(function() {
        var _triggerRef$current2;
        return [
            containerRef.current,
            (_triggerRef$current2 = triggerRef.current) === null || _triggerRef$current2 === void 0 ? void 0 : _triggerRef$current2.getPopupElement()
        ];
    }, triggerOpen, onToggleOpen, !!customizeRawInputElement);
    // ============================ Context =============================
    var baseSelectContext = $jbmdS.useMemo(function() {
        return (0, $lv6ip.default)((0, $lv6ip.default)({}, props), {}, {
            notFoundContent: notFoundContent,
            open: mergedOpen,
            triggerOpen: triggerOpen,
            id: id,
            showSearch: mergedShowSearch,
            multiple: multiple,
            toggleOpen: onToggleOpen
        });
    }, [
        props,
        notFoundContent,
        triggerOpen,
        mergedOpen,
        id,
        mergedShowSearch,
        multiple,
        onToggleOpen
    ]);
    // ==================================================================
    // ==                            Render                            ==
    // ==================================================================
    // ============================= Arrow ==============================
    var mergedShowArrow = showArrow !== undefined ? showArrow : loading || !multiple && mode !== "combobox";
    var arrowNode;
    if (mergedShowArrow) arrowNode = /*#__PURE__*/ $jbmdS.createElement((0, $1hjik.default), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("".concat(prefixCls, "-arrow"), (0, $8K2NM.default)({}, "".concat(prefixCls, "-arrow-loading"), loading)),
        customizeIcon: inputIcon,
        customizeIconProps: {
            loading: loading,
            searchValue: mergedSearchValue,
            open: mergedOpen,
            focused: mockFocused,
            showSearch: mergedShowSearch
        }
    });
    // ============================= Clear ==============================
    var clearNode;
    var onClearMouseDown = function onClearMouseDown() {
        var _selectorRef$current4;
        onClear === null || onClear === void 0 || onClear();
        (_selectorRef$current4 = selectorRef.current) === null || _selectorRef$current4 === void 0 || _selectorRef$current4.focus();
        onDisplayValuesChange([], {
            type: "clear",
            values: displayValues
        });
        onInternalSearch("", false, false);
    };
    if (!disabled && allowClear && (displayValues.length || mergedSearchValue) && !(mode === "combobox" && mergedSearchValue === "")) clearNode = /*#__PURE__*/ $jbmdS.createElement((0, $1hjik.default), {
        className: "".concat(prefixCls, "-clear"),
        onMouseDown: onClearMouseDown,
        customizeIcon: clearIcon
    }, "\xd7");
    // =========================== OptionList ===========================
    var optionList = /*#__PURE__*/ $jbmdS.createElement(OptionList, {
        ref: listRef
    });
    // ============================= Select =============================
    var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(prefixCls, className, (_classNames2 = {}, (0, $8K2NM.default)(_classNames2, "".concat(prefixCls, "-focused"), mockFocused), (0, $8K2NM.default)(_classNames2, "".concat(prefixCls, "-multiple"), multiple), (0, $8K2NM.default)(_classNames2, "".concat(prefixCls, "-single"), !multiple), (0, $8K2NM.default)(_classNames2, "".concat(prefixCls, "-allow-clear"), allowClear), (0, $8K2NM.default)(_classNames2, "".concat(prefixCls, "-show-arrow"), mergedShowArrow), (0, $8K2NM.default)(_classNames2, "".concat(prefixCls, "-disabled"), disabled), (0, $8K2NM.default)(_classNames2, "".concat(prefixCls, "-loading"), loading), (0, $8K2NM.default)(_classNames2, "".concat(prefixCls, "-open"), mergedOpen), (0, $8K2NM.default)(_classNames2, "".concat(prefixCls, "-customize-input"), customizeInputElement), (0, $8K2NM.default)(_classNames2, "".concat(prefixCls, "-show-search"), mergedShowSearch), _classNames2));
    // >>> Selector
    var selectorNode = /*#__PURE__*/ $jbmdS.createElement((0, $70fqL.default), {
        ref: triggerRef,
        disabled: disabled,
        prefixCls: prefixCls,
        visible: triggerOpen,
        popupElement: optionList,
        containerWidth: containerWidth,
        animation: animation,
        transitionName: transitionName,
        dropdownStyle: dropdownStyle,
        dropdownClassName: dropdownClassName,
        direction: direction,
        dropdownMatchSelectWidth: dropdownMatchSelectWidth,
        dropdownRender: dropdownRender,
        dropdownAlign: dropdownAlign,
        placement: placement,
        getPopupContainer: getPopupContainer,
        empty: emptyOptions,
        getTriggerDOMNode: function getTriggerDOMNode() {
            return selectorDomRef.current;
        },
        onPopupVisibleChange: onTriggerVisibleChange,
        onPopupMouseEnter: onPopupMouseEnter
    }, customizeRawInputElement ? /*#__PURE__*/ $jbmdS.cloneElement(customizeRawInputElement, {
        ref: customizeRawInputRef
    }) : /*#__PURE__*/ $jbmdS.createElement((0, $eo7tB.default), (0, $7i29i.default)({}, props, {
        domRef: selectorDomRef,
        prefixCls: prefixCls,
        inputElement: customizeInputElement,
        ref: selectorRef,
        id: id,
        showSearch: mergedShowSearch,
        autoClearSearchValue: autoClearSearchValue,
        mode: mode,
        activeDescendantId: activeDescendantId,
        tagRender: tagRender,
        values: displayValues,
        open: mergedOpen,
        onToggleOpen: onToggleOpen,
        activeValue: activeValue,
        searchValue: mergedSearchValue,
        onSearch: onInternalSearch,
        onSearchSubmit: onInternalSearchSubmit,
        onRemove: onSelectorRemove,
        tokenWithEnter: tokenWithEnter
    })));
    // >>> Render
    var renderNode;
    // Render raw
    if (customizeRawInputElement) renderNode = selectorNode;
    else renderNode = /*#__PURE__*/ $jbmdS.createElement("div", (0, $7i29i.default)({
        className: mergedClassName
    }, domProps, {
        ref: containerRef,
        onMouseDown: onInternalMouseDown,
        onKeyDown: onInternalKeyDown,
        onKeyUp: onInternalKeyUp,
        onFocus: onContainerFocus,
        onBlur: onContainerBlur
    }), mockFocused && !mergedOpen && /*#__PURE__*/ $jbmdS.createElement("span", {
        style: {
            width: 0,
            height: 0,
            position: "absolute",
            overflow: "hidden",
            opacity: 0
        },
        "aria-live": "polite"
    }, "".concat(displayValues.map(function(_ref) {
        var label = _ref.label, value = _ref.value;
        return [
            "number",
            "string"
        ].includes((0, $jncUt.default)(label)) ? label : value;
    }).join(", "))), selectorNode, arrowNode, clearNode);
    return /*#__PURE__*/ $jbmdS.createElement((0, $2eOmx.BaseSelectContext).Provider, {
        value: baseSelectContext
    }, renderNode);
});
var $7a8e1c6b8b8a9bfe$export$2e2bcd8739ae039 = $7a8e1c6b8b8a9bfe$var$BaseSelect;

});
parcelRegister("FYXRo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07e31eba395aeaa1$export$2e2bcd8739ae039; });
var $07e31eba395aeaa1$export$2e2bcd8739ae039 = function() {
    if (typeof navigator === "undefined" || typeof window === "undefined") return false;
    var agent = navigator.userAgent || navigator.vendor || window.opera;
    return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(agent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(agent === null || agent === void 0 ? void 0 : agent.substr(0, 4));
};

});

parcelRegister("2eOmx", function(module, exports) {

$parcel$export(module.exports, "BaseSelectContext", function () { return $1a13f488457daf12$export$8234047c0aea33cf; });
$parcel$export(module.exports, "default", function () { return $1a13f488457daf12$export$2e2bcd8739ae039; });
/**
 * BaseSelect provide some parsed data into context.
 * You can use this hooks to get them.
 */ 
var $jbmdS = parcelRequire("jbmdS");
var $1a13f488457daf12$export$8234047c0aea33cf = /*#__PURE__*/ $jbmdS.createContext(null);
function $1a13f488457daf12$export$2e2bcd8739ae039() {
    return $jbmdS.useContext($1a13f488457daf12$export$8234047c0aea33cf);
}

});

parcelRegister("4gmip", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31a9f392d70aabcd$export$2e2bcd8739ae039; });

var $CZyex = parcelRequire("CZyex");

var $jbmdS = parcelRequire("jbmdS");
function $31a9f392d70aabcd$export$2e2bcd8739ae039() {
    var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
    var _React$useState = $jbmdS.useState(false), _React$useState2 = (0, $CZyex.default)(_React$useState, 2), bool = _React$useState2[0], setBool = _React$useState2[1];
    var delayRef = $jbmdS.useRef(null);
    var cancelLatest = function cancelLatest() {
        window.clearTimeout(delayRef.current);
    };
    $jbmdS.useEffect(function() {
        return cancelLatest;
    }, []);
    var delaySetBool = function delaySetBool(value, callback) {
        cancelLatest();
        delayRef.current = window.setTimeout(function() {
            setBool(value);
            if (callback) callback();
        }, timeout);
    };
    return [
        bool,
        delaySetBool,
        cancelLatest
    ];
}

});

parcelRegister("10VKB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0bd2969c596b239e$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");
function $0bd2969c596b239e$export$2e2bcd8739ae039() {
    var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 250;
    var lockRef = $jbmdS.useRef(null);
    var timeoutRef = $jbmdS.useRef(null);
    // Clean up
    $jbmdS.useEffect(function() {
        return function() {
            window.clearTimeout(timeoutRef.current);
        };
    }, []);
    function doLock(locked) {
        if (locked || lockRef.current === null) lockRef.current = locked;
        window.clearTimeout(timeoutRef.current);
        timeoutRef.current = window.setTimeout(function() {
            lockRef.current = null;
        }, duration);
    }
    return [
        function() {
            return lockRef.current;
        },
        doLock
    ];
}

});

parcelRegister("bqqhg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8516819228c54293$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");
function $8516819228c54293$export$2e2bcd8739ae039(elements, open, triggerOpen, customizedTrigger) {
    var propsRef = $jbmdS.useRef(null);
    propsRef.current = {
        open: open,
        triggerOpen: triggerOpen,
        customizedTrigger: customizedTrigger
    };
    $jbmdS.useEffect(function() {
        function onGlobalMouseDown(event) {
            var _propsRef$current;
            // If trigger is customized, Trigger will take control of popupVisible
            if ((_propsRef$current = propsRef.current) !== null && _propsRef$current !== void 0 && _propsRef$current.customizedTrigger) return;
            var target = event.target;
            if (target.shadowRoot && event.composed) target = event.composedPath()[0] || target;
            if (propsRef.current.open && elements().filter(function(element) {
                return element;
            }).every(function(element) {
                return !element.contains(target) && element !== target;
            })) // Should trigger close
            propsRef.current.triggerOpen(false);
        }
        window.addEventListener("mousedown", onGlobalMouseDown);
        return function() {
            return window.removeEventListener("mousedown", onGlobalMouseDown);
        };
    }, []);
}

});

parcelRegister("eo7tB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7991b3ec8235e0e$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $CZyex = parcelRequire("CZyex");

var $jbmdS = parcelRequire("jbmdS");

var $5yi5E = parcelRequire("5yi5E");

var $5pKkI = parcelRequire("5pKkI");

var $hngxy = parcelRequire("hngxy");

var $10VKB = parcelRequire("10VKB");

var $4v110 = parcelRequire("4v110");
var $a7991b3ec8235e0e$var$Selector = function Selector(props, ref) {
    var inputRef = (0, $jbmdS.useRef)(null);
    var compositionStatusRef = (0, $jbmdS.useRef)(false);
    var prefixCls = props.prefixCls, open = props.open, mode = props.mode, showSearch = props.showSearch, tokenWithEnter = props.tokenWithEnter, autoClearSearchValue = props.autoClearSearchValue, onSearch = props.onSearch, onSearchSubmit = props.onSearchSubmit, onToggleOpen = props.onToggleOpen, onInputKeyDown = props.onInputKeyDown, domRef = props.domRef;
    // ======================= Ref =======================
    $jbmdS.useImperativeHandle(ref, function() {
        return {
            focus: function focus() {
                inputRef.current.focus();
            },
            blur: function blur() {
                inputRef.current.blur();
            }
        };
    });
    // ====================== Input ======================
    var _useLock = (0, $10VKB.default)(0), _useLock2 = (0, $CZyex.default)(_useLock, 2), getInputMouseDown = _useLock2[0], setInputMouseDown = _useLock2[1];
    var onInternalInputKeyDown = function onInternalInputKeyDown(event) {
        var which = event.which;
        if (which === (0, $5yi5E.default).UP || which === (0, $5yi5E.default).DOWN) event.preventDefault();
        if (onInputKeyDown) onInputKeyDown(event);
        if (which === (0, $5yi5E.default).ENTER && mode === "tags" && !compositionStatusRef.current && !open) // When menu isn't open, OptionList won't trigger a value change
        // So when enter is pressed, the tag's input value should be emitted here to let selector know
        onSearchSubmit === null || onSearchSubmit === void 0 || onSearchSubmit(event.target.value);
        if ((0, $4v110.isValidateOpenKey)(which)) onToggleOpen(true);
    };
    /**
   * We can not use `findDOMNode` sine it will get warning,
   * have to use timer to check if is input element.
   */ var onInternalInputMouseDown = function onInternalInputMouseDown() {
        setInputMouseDown(true);
    };
    // When paste come, ignore next onChange
    var pastedTextRef = (0, $jbmdS.useRef)(null);
    var triggerOnSearch = function triggerOnSearch(value) {
        if (onSearch(value, true, compositionStatusRef.current) !== false) onToggleOpen(true);
    };
    var onInputCompositionStart = function onInputCompositionStart() {
        compositionStatusRef.current = true;
    };
    var onInputCompositionEnd = function onInputCompositionEnd(e) {
        compositionStatusRef.current = false;
        // Trigger search again to support `tokenSeparators` with typewriting
        if (mode !== "combobox") triggerOnSearch(e.target.value);
    };
    var onInputChange = function onInputChange(event) {
        var value = event.target.value;
        // Pasted text should replace back to origin content
        if (tokenWithEnter && pastedTextRef.current && /[\r\n]/.test(pastedTextRef.current)) {
            // CRLF will be treated as a single space for input element
            var replacedText = pastedTextRef.current.replace(/[\r\n]+$/, "").replace(/\r\n/g, " ").replace(/[\r\n]/g, " ");
            value = value.replace(replacedText, pastedTextRef.current);
        }
        pastedTextRef.current = null;
        triggerOnSearch(value);
    };
    var onInputPaste = function onInputPaste(e) {
        var clipboardData = e.clipboardData;
        var value = clipboardData.getData("text");
        pastedTextRef.current = value;
    };
    var onClick = function onClick(_ref) {
        var target = _ref.target;
        if (target !== inputRef.current) {
            // Should focus input if click the selector
            var isIE = document.body.style.msTouchAction !== undefined;
            if (isIE) setTimeout(function() {
                inputRef.current.focus();
            });
            else inputRef.current.focus();
        }
    };
    var onMouseDown = function onMouseDown(event) {
        var inputMouseDown = getInputMouseDown();
        // when mode is combobox, don't prevent default behavior
        // https://github.com/ant-design/ant-design/issues/37320
        if (event.target !== inputRef.current && !inputMouseDown && mode !== "combobox") event.preventDefault();
        if (mode !== "combobox" && (!showSearch || !inputMouseDown) || !open) {
            if (open && autoClearSearchValue !== false) onSearch("", true, false);
            onToggleOpen();
        }
    };
    // ================= Inner Selector ==================
    var sharedProps = {
        inputRef: inputRef,
        onInputKeyDown: onInternalInputKeyDown,
        onInputMouseDown: onInternalInputMouseDown,
        onInputChange: onInputChange,
        onInputPaste: onInputPaste,
        onInputCompositionStart: onInputCompositionStart,
        onInputCompositionEnd: onInputCompositionEnd
    };
    var selectNode = mode === "multiple" || mode === "tags" ? /*#__PURE__*/ $jbmdS.createElement((0, $5pKkI.default), (0, $7i29i.default)({}, props, sharedProps)) : /*#__PURE__*/ $jbmdS.createElement((0, $hngxy.default), (0, $7i29i.default)({}, props, sharedProps));
    return /*#__PURE__*/ $jbmdS.createElement("div", {
        ref: domRef,
        className: "".concat(prefixCls, "-selector"),
        onClick: onClick,
        onMouseDown: onMouseDown
    }, selectNode);
};
var $a7991b3ec8235e0e$var$ForwardSelector = /*#__PURE__*/ $jbmdS.forwardRef($a7991b3ec8235e0e$var$Selector);
$a7991b3ec8235e0e$var$ForwardSelector.displayName = "Selector";
var $a7991b3ec8235e0e$export$2e2bcd8739ae039 = $a7991b3ec8235e0e$var$ForwardSelector;

});
parcelRegister("5pKkI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f133a524a96eab9$export$2e2bcd8739ae039; });

var $8K2NM = parcelRequire("8K2NM");

var $CZyex = parcelRequire("CZyex");

var $jbmdS = parcelRequire("jbmdS");

var $02LyB = parcelRequire("02LyB");

var $dSkKg = parcelRequire("dSkKg");

var $5jf7A = parcelRequire("5jf7A");

var $1hjik = parcelRequire("1hjik");

var $2MsI2 = parcelRequire("2MsI2");

var $3JWIW = parcelRequire("3JWIW");

var $gDBzp = parcelRequire("gDBzp");
function $3f133a524a96eab9$var$itemKey(value) {
    var _value$key;
    return (_value$key = value.key) !== null && _value$key !== void 0 ? _value$key : value.value;
}
var $3f133a524a96eab9$var$onPreventMouseDown = function onPreventMouseDown(event) {
    event.preventDefault();
    event.stopPropagation();
};
var $3f133a524a96eab9$var$SelectSelector = function SelectSelector(props) {
    var id = props.id, prefixCls = props.prefixCls, values = props.values, open = props.open, searchValue = props.searchValue, autoClearSearchValue = props.autoClearSearchValue, inputRef = props.inputRef, placeholder = props.placeholder, disabled = props.disabled, mode = props.mode, showSearch = props.showSearch, autoFocus = props.autoFocus, autoComplete = props.autoComplete, activeDescendantId = props.activeDescendantId, tabIndex = props.tabIndex, removeIcon = props.removeIcon, maxTagCount = props.maxTagCount, maxTagTextLength = props.maxTagTextLength, _props$maxTagPlacehol = props.maxTagPlaceholder, maxTagPlaceholder = _props$maxTagPlacehol === void 0 ? function(omittedValues) {
        return "+ ".concat(omittedValues.length, " ...");
    } : _props$maxTagPlacehol, tagRender = props.tagRender, onToggleOpen = props.onToggleOpen, onRemove = props.onRemove, onInputChange = props.onInputChange, onInputPaste = props.onInputPaste, onInputKeyDown = props.onInputKeyDown, onInputMouseDown = props.onInputMouseDown, onInputCompositionStart = props.onInputCompositionStart, onInputCompositionEnd = props.onInputCompositionEnd;
    var measureRef = $jbmdS.useRef(null);
    var _useState = (0, $jbmdS.useState)(0), _useState2 = (0, $CZyex.default)(_useState, 2), inputWidth = _useState2[0], setInputWidth = _useState2[1];
    var _useState3 = (0, $jbmdS.useState)(false), _useState4 = (0, $CZyex.default)(_useState3, 2), focused = _useState4[0], setFocused = _useState4[1];
    var selectionPrefixCls = "".concat(prefixCls, "-selection");
    // ===================== Search ======================
    var inputValue = open || mode === "multiple" && autoClearSearchValue === false || mode === "tags" ? searchValue : "";
    var inputEditable = mode === "tags" || mode === "multiple" && autoClearSearchValue === false || showSearch && (open || focused);
    // We measure width and set to the input immediately
    (0, $3JWIW.default)(function() {
        setInputWidth(measureRef.current.scrollWidth);
    }, [
        inputValue
    ]);
    // ===================== Render ======================
    // >>> Render Selector Node. Includes Item & Rest
    function defaultRenderSelector(item, content, itemDisabled, closable, onClose) {
        return /*#__PURE__*/ $jbmdS.createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("".concat(selectionPrefixCls, "-item"), (0, $8K2NM.default)({}, "".concat(selectionPrefixCls, "-item-disabled"), itemDisabled)),
            title: (0, $gDBzp.getTitle)(item)
        }, /*#__PURE__*/ $jbmdS.createElement("span", {
            className: "".concat(selectionPrefixCls, "-item-content")
        }, content), closable && /*#__PURE__*/ $jbmdS.createElement((0, $1hjik.default), {
            className: "".concat(selectionPrefixCls, "-item-remove"),
            onMouseDown: $3f133a524a96eab9$var$onPreventMouseDown,
            onClick: onClose,
            customizeIcon: removeIcon
        }, "\xd7"));
    }
    function customizeRenderSelector(value, content, itemDisabled, closable, onClose) {
        var onMouseDown = function onMouseDown(e) {
            $3f133a524a96eab9$var$onPreventMouseDown(e);
            onToggleOpen(!open);
        };
        return /*#__PURE__*/ $jbmdS.createElement("span", {
            onMouseDown: onMouseDown
        }, tagRender({
            label: content,
            value: value,
            disabled: itemDisabled,
            closable: closable,
            onClose: onClose
        }));
    }
    function renderItem(valueItem) {
        var itemDisabled = valueItem.disabled, label = valueItem.label, value = valueItem.value;
        var closable = !disabled && !itemDisabled;
        var displayLabel = label;
        if (typeof maxTagTextLength === "number") {
            if (typeof label === "string" || typeof label === "number") {
                var strLabel = String(displayLabel);
                if (strLabel.length > maxTagTextLength) displayLabel = "".concat(strLabel.slice(0, maxTagTextLength), "...");
            }
        }
        var onClose = function onClose(event) {
            if (event) event.stopPropagation();
            onRemove(valueItem);
        };
        return typeof tagRender === "function" ? customizeRenderSelector(value, displayLabel, itemDisabled, closable, onClose) : defaultRenderSelector(valueItem, displayLabel, itemDisabled, closable, onClose);
    }
    function renderRest(omittedValues) {
        var content = typeof maxTagPlaceholder === "function" ? maxTagPlaceholder(omittedValues) : maxTagPlaceholder;
        return defaultRenderSelector({
            title: content
        }, content, false);
    }
    // >>> Input Node
    var inputNode = /*#__PURE__*/ $jbmdS.createElement("div", {
        className: "".concat(selectionPrefixCls, "-search"),
        style: {
            width: inputWidth
        },
        onFocus: function onFocus() {
            setFocused(true);
        },
        onBlur: function onBlur() {
            setFocused(false);
        }
    }, /*#__PURE__*/ $jbmdS.createElement((0, $2MsI2.default), {
        ref: inputRef,
        open: open,
        prefixCls: prefixCls,
        id: id,
        inputElement: null,
        disabled: disabled,
        autoFocus: autoFocus,
        autoComplete: autoComplete,
        editable: inputEditable,
        activeDescendantId: activeDescendantId,
        value: inputValue,
        onKeyDown: onInputKeyDown,
        onMouseDown: onInputMouseDown,
        onChange: onInputChange,
        onPaste: onInputPaste,
        onCompositionStart: onInputCompositionStart,
        onCompositionEnd: onInputCompositionEnd,
        tabIndex: tabIndex,
        attrs: (0, $dSkKg.default)(props, true)
    }), /*#__PURE__*/ $jbmdS.createElement("span", {
        ref: measureRef,
        className: "".concat(selectionPrefixCls, "-search-mirror"),
        "aria-hidden": true
    }, inputValue, "\xa0"));
    // >>> Selections
    var selectionNode = /*#__PURE__*/ $jbmdS.createElement((0, $5jf7A.default), {
        prefixCls: "".concat(selectionPrefixCls, "-overflow"),
        data: values,
        renderItem: renderItem,
        renderRest: renderRest,
        suffix: inputNode,
        itemKey: $3f133a524a96eab9$var$itemKey,
        maxCount: maxTagCount
    });
    return /*#__PURE__*/ $jbmdS.createElement($jbmdS.Fragment, null, selectionNode, !values.length && !inputValue && /*#__PURE__*/ $jbmdS.createElement("span", {
        className: "".concat(selectionPrefixCls, "-placeholder")
    }, placeholder));
};
var $3f133a524a96eab9$export$2e2bcd8739ae039 = $3f133a524a96eab9$var$SelectSelector;

});
parcelRegister("dSkKg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1a069122309fda4$export$2e2bcd8739ae039; });

var $lv6ip = parcelRequire("lv6ip");
var $a1a069122309fda4$var$attributes = "accept acceptCharset accessKey action allowFullScreen allowTransparency\n    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge\n    charSet checked classID className colSpan cols content contentEditable contextMenu\n    controls coords crossOrigin data dateTime default defer dir disabled download draggable\n    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder\n    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity\n    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media\n    mediaGroup method min minLength multiple muted name noValidate nonce open\n    optimum pattern placeholder poster preload radioGroup readOnly rel required\n    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected\n    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style\n    summary tabIndex target title type useMap value width wmode wrap";
var $a1a069122309fda4$var$eventsName = "onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown\n    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick\n    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown\n    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel\n    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough\n    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata\n    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError";
var $a1a069122309fda4$var$propList = "".concat($a1a069122309fda4$var$attributes, " ").concat($a1a069122309fda4$var$eventsName).split(/[\s\n]+/);
/* eslint-enable max-len */ var $a1a069122309fda4$var$ariaPrefix = "aria-";
var $a1a069122309fda4$var$dataPrefix = "data-";
function $a1a069122309fda4$var$match(key, prefix) {
    return key.indexOf(prefix) === 0;
}
function $a1a069122309fda4$export$2e2bcd8739ae039(props) {
    var ariaOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var mergedConfig;
    if (ariaOnly === false) mergedConfig = {
        aria: true,
        data: true,
        attr: true
    };
    else if (ariaOnly === true) mergedConfig = {
        aria: true
    };
    else mergedConfig = (0, $lv6ip.default)({}, ariaOnly);
    var attrs = {};
    Object.keys(props).forEach(function(key) {
        if (// Aria
        mergedConfig.aria && (key === "role" || $a1a069122309fda4$var$match(key, $a1a069122309fda4$var$ariaPrefix)) || // Data
        mergedConfig.data && $a1a069122309fda4$var$match(key, $a1a069122309fda4$var$dataPrefix) || // Attr
        mergedConfig.attr && $a1a069122309fda4$var$propList.includes(key)) attrs[key] = props[key];
    });
    return attrs;
}

});

parcelRegister("5jf7A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3dda74e7627c3fb0$export$2e2bcd8739ae039; });

var $7kPme = parcelRequire("7kPme");
var $3dda74e7627c3fb0$export$2e2bcd8739ae039 = (0, $7kPme.default);

});
parcelRegister("7kPme", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55723d32e655eb53$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $lv6ip = parcelRequire("lv6ip");

var $CZyex = parcelRequire("CZyex");

var $ccQt4 = parcelRequire("ccQt4");

var $jbmdS = parcelRequire("jbmdS");

var $02LyB = parcelRequire("02LyB");

var $fvfrs = parcelRequire("fvfrs");

var $iDOLX = parcelRequire("iDOLX");

var $35AD8 = parcelRequire("35AD8");

var $gv1O1 = parcelRequire("gv1O1");

var $66Vds = parcelRequire("66Vds");

var $etjiC = parcelRequire("etjiC");
var $55723d32e655eb53$var$_excluded = [
    "prefixCls",
    "data",
    "renderItem",
    "renderRawItem",
    "itemKey",
    "itemWidth",
    "ssr",
    "style",
    "className",
    "maxCount",
    "renderRest",
    "renderRawRest",
    "suffix",
    "component",
    "itemComponent",
    "onVisibleChange"
];
var $55723d32e655eb53$var$RESPONSIVE = "responsive";
var $55723d32e655eb53$var$INVALIDATE = "invalidate";
function $55723d32e655eb53$var$defaultRenderRest(omittedItems) {
    return "+ ".concat(omittedItems.length, " ...");
}
function $55723d32e655eb53$var$Overflow(props, ref) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-overflow" : _props$prefixCls, _props$data = props.data, data = _props$data === void 0 ? [] : _props$data, renderItem = props.renderItem, renderRawItem = props.renderRawItem, itemKey = props.itemKey, _props$itemWidth = props.itemWidth, itemWidth = _props$itemWidth === void 0 ? 10 : _props$itemWidth, ssr = props.ssr, style = props.style, className = props.className, maxCount = props.maxCount, renderRest = props.renderRest, renderRawRest = props.renderRawRest, suffix = props.suffix, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, itemComponent = props.itemComponent, onVisibleChange = props.onVisibleChange, restProps = (0, $ccQt4.default)(props, $55723d32e655eb53$var$_excluded);
    var fullySSR = ssr === "full";
    var notifyEffectUpdate = (0, $gv1O1.useBatcher)();
    var _useEffectState = (0, $gv1O1.default)(notifyEffectUpdate, null), _useEffectState2 = (0, $CZyex.default)(_useEffectState, 2), containerWidth = _useEffectState2[0], setContainerWidth = _useEffectState2[1];
    var mergedContainerWidth = containerWidth || 0;
    var _useEffectState3 = (0, $gv1O1.default)(notifyEffectUpdate, new Map()), _useEffectState4 = (0, $CZyex.default)(_useEffectState3, 2), itemWidths = _useEffectState4[0], setItemWidths = _useEffectState4[1];
    var _useEffectState5 = (0, $gv1O1.default)(notifyEffectUpdate, 0), _useEffectState6 = (0, $CZyex.default)(_useEffectState5, 2), prevRestWidth = _useEffectState6[0], setPrevRestWidth = _useEffectState6[1];
    var _useEffectState7 = (0, $gv1O1.default)(notifyEffectUpdate, 0), _useEffectState8 = (0, $CZyex.default)(_useEffectState7, 2), restWidth = _useEffectState8[0], setRestWidth = _useEffectState8[1];
    var _useEffectState9 = (0, $gv1O1.default)(notifyEffectUpdate, 0), _useEffectState10 = (0, $CZyex.default)(_useEffectState9, 2), suffixWidth = _useEffectState10[0], setSuffixWidth = _useEffectState10[1];
    var _useState = (0, $jbmdS.useState)(null), _useState2 = (0, $CZyex.default)(_useState, 2), suffixFixedStart = _useState2[0], setSuffixFixedStart = _useState2[1];
    var _useState3 = (0, $jbmdS.useState)(null), _useState4 = (0, $CZyex.default)(_useState3, 2), displayCount = _useState4[0], setDisplayCount = _useState4[1];
    var mergedDisplayCount = $jbmdS.useMemo(function() {
        if (displayCount === null && fullySSR) return Number.MAX_SAFE_INTEGER;
        return displayCount || 0;
    }, [
        displayCount,
        containerWidth
    ]);
    var _useState5 = (0, $jbmdS.useState)(false), _useState6 = (0, $CZyex.default)(_useState5, 2), restReady = _useState6[0], setRestReady = _useState6[1];
    var itemPrefixCls = "".concat(prefixCls, "-item");
    // Always use the max width to avoid blink
    var mergedRestWidth = Math.max(prevRestWidth, restWidth);
    // ================================= Data =================================
    var isResponsive = maxCount === $55723d32e655eb53$var$RESPONSIVE;
    var shouldResponsive = data.length && isResponsive;
    var invalidate = maxCount === $55723d32e655eb53$var$INVALIDATE;
    /**
   * When is `responsive`, we will always render rest node to get the real width of it for calculation
   */ var showRest = shouldResponsive || typeof maxCount === "number" && data.length > maxCount;
    var mergedData = (0, $jbmdS.useMemo)(function() {
        var items = data;
        if (shouldResponsive) {
            if (containerWidth === null && fullySSR) items = data;
            else items = data.slice(0, Math.min(data.length, mergedContainerWidth / itemWidth));
        } else if (typeof maxCount === "number") items = data.slice(0, maxCount);
        return items;
    }, [
        data,
        itemWidth,
        containerWidth,
        maxCount,
        shouldResponsive
    ]);
    var omittedItems = (0, $jbmdS.useMemo)(function() {
        if (shouldResponsive) return data.slice(mergedDisplayCount + 1);
        return data.slice(mergedData.length);
    }, [
        data,
        mergedData,
        shouldResponsive,
        mergedDisplayCount
    ]);
    // ================================= Item =================================
    var getKey = (0, $jbmdS.useCallback)(function(item, index) {
        var _ref;
        if (typeof itemKey === "function") return itemKey(item);
        return (_ref = itemKey && (item === null || item === void 0 ? void 0 : item[itemKey])) !== null && _ref !== void 0 ? _ref : index;
    }, [
        itemKey
    ]);
    var mergedRenderItem = (0, $jbmdS.useCallback)(renderItem || function(item) {
        return item;
    }, [
        renderItem
    ]);
    function updateDisplayCount(count, suffixFixedStartVal, notReady) {
        // React 18 will sync render even when the value is same in some case.
        // We take `mergedData` as deps which may cause dead loop if it's dynamic generate.
        // ref: https://github.com/ant-design/ant-design/issues/36559
        if (displayCount === count && (suffixFixedStartVal === undefined || suffixFixedStartVal === suffixFixedStart)) return;
        setDisplayCount(count);
        if (!notReady) {
            setRestReady(count < data.length - 1);
            onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(count);
        }
        if (suffixFixedStartVal !== undefined) setSuffixFixedStart(suffixFixedStartVal);
    }
    // ================================= Size =================================
    function onOverflowResize(_, element) {
        setContainerWidth(element.clientWidth);
    }
    function registerSize(key, width) {
        setItemWidths(function(origin) {
            var clone = new Map(origin);
            if (width === null) clone.delete(key);
            else clone.set(key, width);
            return clone;
        });
    }
    function registerOverflowSize(_, width) {
        setRestWidth(width);
        setPrevRestWidth(restWidth);
    }
    function registerSuffixSize(_, width) {
        setSuffixWidth(width);
    }
    // ================================ Effect ================================
    function getItemWidth(index) {
        return itemWidths.get(getKey(mergedData[index], index));
    }
    (0, $iDOLX.default)(function() {
        if (mergedContainerWidth && typeof mergedRestWidth === "number" && mergedData) {
            var totalWidth = suffixWidth;
            var len = mergedData.length;
            var lastIndex = len - 1;
            // When data count change to 0, reset this since not loop will reach
            if (!len) {
                updateDisplayCount(0, null);
                return;
            }
            for(var i = 0; i < len; i += 1){
                var currentItemWidth = getItemWidth(i);
                // Fully will always render
                if (fullySSR) currentItemWidth = currentItemWidth || 0;
                // Break since data not ready
                if (currentItemWidth === undefined) {
                    updateDisplayCount(i - 1, undefined, true);
                    break;
                }
                // Find best match
                totalWidth += currentItemWidth;
                if (// Only one means `totalWidth` is the final width
                lastIndex === 0 && totalWidth <= mergedContainerWidth || // Last two width will be the final width
                i === lastIndex - 1 && totalWidth + getItemWidth(lastIndex) <= mergedContainerWidth) {
                    // Additional check if match the end
                    updateDisplayCount(lastIndex, null);
                    break;
                } else if (totalWidth + mergedRestWidth > mergedContainerWidth) {
                    // Can not hold all the content to show rest
                    updateDisplayCount(i - 1, totalWidth - currentItemWidth - suffixWidth + restWidth);
                    break;
                }
            }
            if (suffix && getItemWidth(0) + suffixWidth > mergedContainerWidth) setSuffixFixedStart(null);
        }
    }, [
        mergedContainerWidth,
        itemWidths,
        restWidth,
        suffixWidth,
        getKey,
        mergedData
    ]);
    // ================================ Render ================================
    var displayRest = restReady && !!omittedItems.length;
    var suffixStyle = {};
    if (suffixFixedStart !== null && shouldResponsive) suffixStyle = {
        position: "absolute",
        left: suffixFixedStart,
        top: 0
    };
    var itemSharedProps = {
        prefixCls: itemPrefixCls,
        responsive: shouldResponsive,
        component: itemComponent,
        invalidate: invalidate
    };
    // >>>>> Choice render fun by `renderRawItem`
    var internalRenderItemNode = renderRawItem ? function(item, index) {
        var key = getKey(item, index);
        return /*#__PURE__*/ $jbmdS.createElement((0, $etjiC.OverflowContext).Provider, {
            key: key,
            value: (0, $lv6ip.default)((0, $lv6ip.default)({}, itemSharedProps), {}, {
                order: index,
                item: item,
                itemKey: key,
                registerSize: registerSize,
                display: index <= mergedDisplayCount
            })
        }, renderRawItem(item, index));
    } : function(item, index) {
        var key = getKey(item, index);
        return /*#__PURE__*/ $jbmdS.createElement((0, $35AD8.default), (0, $7i29i.default)({}, itemSharedProps, {
            order: index,
            key: key,
            item: item,
            renderItem: mergedRenderItem,
            itemKey: key,
            registerSize: registerSize,
            display: index <= mergedDisplayCount
        }));
    };
    // >>>>> Rest node
    var restNode;
    var restContextProps = {
        order: displayRest ? mergedDisplayCount : Number.MAX_SAFE_INTEGER,
        className: "".concat(itemPrefixCls, "-rest"),
        registerSize: registerOverflowSize,
        display: displayRest
    };
    if (!renderRawRest) {
        var mergedRenderRest = renderRest || $55723d32e655eb53$var$defaultRenderRest;
        restNode = /*#__PURE__*/ $jbmdS.createElement((0, $35AD8.default), (0, $7i29i.default)({}, itemSharedProps, restContextProps), typeof mergedRenderRest === "function" ? mergedRenderRest(omittedItems) : mergedRenderRest);
    } else if (renderRawRest) restNode = /*#__PURE__*/ $jbmdS.createElement((0, $etjiC.OverflowContext).Provider, {
        value: (0, $lv6ip.default)((0, $lv6ip.default)({}, itemSharedProps), restContextProps)
    }, renderRawRest(omittedItems));
    var overflowNode = /*#__PURE__*/ $jbmdS.createElement(Component, (0, $7i29i.default)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(!invalidate && prefixCls, className),
        style: style,
        ref: ref
    }, restProps), mergedData.map(internalRenderItemNode), showRest ? restNode : null, suffix && /*#__PURE__*/ $jbmdS.createElement((0, $35AD8.default), (0, $7i29i.default)({}, itemSharedProps, {
        responsive: isResponsive,
        responsiveDisabled: !shouldResponsive,
        order: mergedDisplayCount,
        className: "".concat(itemPrefixCls, "-suffix"),
        registerSize: registerSuffixSize,
        display: true,
        style: suffixStyle
    }), suffix));
    if (isResponsive) overflowNode = /*#__PURE__*/ $jbmdS.createElement((0, $fvfrs.default), {
        onResize: onOverflowResize,
        disabled: !shouldResponsive
    }, overflowNode);
    return overflowNode;
}
var $55723d32e655eb53$var$ForwardOverflow = /*#__PURE__*/ $jbmdS.forwardRef($55723d32e655eb53$var$Overflow);
$55723d32e655eb53$var$ForwardOverflow.displayName = "Overflow";
$55723d32e655eb53$var$ForwardOverflow.Item = (0, $66Vds.default);
$55723d32e655eb53$var$ForwardOverflow.RESPONSIVE = $55723d32e655eb53$var$RESPONSIVE;
$55723d32e655eb53$var$ForwardOverflow.INVALIDATE = $55723d32e655eb53$var$INVALIDATE;
var // Convert to generic type
$55723d32e655eb53$export$2e2bcd8739ae039 = $55723d32e655eb53$var$ForwardOverflow;

});
parcelRegister("35AD8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23fe40b8d7880377$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $lv6ip = parcelRequire("lv6ip");

var $ccQt4 = parcelRequire("ccQt4");

var $jbmdS = parcelRequire("jbmdS");

var $02LyB = parcelRequire("02LyB");

var $fvfrs = parcelRequire("fvfrs");
var $23fe40b8d7880377$var$_excluded = [
    "prefixCls",
    "invalidate",
    "item",
    "renderItem",
    "responsive",
    "responsiveDisabled",
    "registerSize",
    "itemKey",
    "className",
    "style",
    "children",
    "display",
    "order",
    "component"
];
// Use shared variable to save bundle size
var $23fe40b8d7880377$var$UNDEFINED = undefined;
function $23fe40b8d7880377$var$InternalItem(props, ref) {
    var prefixCls = props.prefixCls, invalidate = props.invalidate, item = props.item, renderItem = props.renderItem, responsive = props.responsive, responsiveDisabled = props.responsiveDisabled, registerSize = props.registerSize, itemKey = props.itemKey, className = props.className, style = props.style, children = props.children, display = props.display, order = props.order, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, restProps = (0, $ccQt4.default)(props, $23fe40b8d7880377$var$_excluded);
    var mergedHidden = responsive && !display;
    // ================================ Effect ================================
    function internalRegisterSize(width) {
        registerSize(itemKey, width);
    }
    $jbmdS.useEffect(function() {
        return function() {
            internalRegisterSize(null);
        };
    }, []);
    // ================================ Render ================================
    var childNode = renderItem && item !== $23fe40b8d7880377$var$UNDEFINED ? renderItem(item) : children;
    var overflowStyle;
    if (!invalidate) overflowStyle = {
        opacity: mergedHidden ? 0 : 1,
        height: mergedHidden ? 0 : $23fe40b8d7880377$var$UNDEFINED,
        overflowY: mergedHidden ? "hidden" : $23fe40b8d7880377$var$UNDEFINED,
        order: responsive ? order : $23fe40b8d7880377$var$UNDEFINED,
        pointerEvents: mergedHidden ? "none" : $23fe40b8d7880377$var$UNDEFINED,
        position: mergedHidden ? "absolute" : $23fe40b8d7880377$var$UNDEFINED
    };
    var overflowProps = {};
    if (mergedHidden) overflowProps["aria-hidden"] = true;
    var itemNode = /*#__PURE__*/ $jbmdS.createElement(Component, (0, $7i29i.default)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(!invalidate && prefixCls, className),
        style: (0, $lv6ip.default)((0, $lv6ip.default)({}, overflowStyle), style)
    }, overflowProps, restProps, {
        ref: ref
    }), childNode);
    if (responsive) itemNode = /*#__PURE__*/ $jbmdS.createElement((0, $fvfrs.default), {
        onResize: function onResize(_ref) {
            var offsetWidth = _ref.offsetWidth;
            internalRegisterSize(offsetWidth);
        },
        disabled: responsiveDisabled
    }, itemNode);
    return itemNode;
}
var $23fe40b8d7880377$var$Item = /*#__PURE__*/ $jbmdS.forwardRef($23fe40b8d7880377$var$InternalItem);
$23fe40b8d7880377$var$Item.displayName = "Item";
var $23fe40b8d7880377$export$2e2bcd8739ae039 = $23fe40b8d7880377$var$Item;

});

parcelRegister("gv1O1", function(module, exports) {

$parcel$export(module.exports, "useBatcher", function () { return $c030f12fe40340d7$export$eedf51fe9d751c7a; });
$parcel$export(module.exports, "default", function () { return $c030f12fe40340d7$export$2e2bcd8739ae039; });

var $CZyex = parcelRequire("CZyex");

var $gZPGe = parcelRequire("gZPGe");

var $jbmdS = parcelRequire("jbmdS");

var $jCNM0 = parcelRequire("jCNM0");

var $7b92z = parcelRequire("7b92z");
function $c030f12fe40340d7$export$eedf51fe9d751c7a() {
    // Updater Trigger
    var updateFuncRef = $jbmdS.useRef(null);
    // Notify update
    var notifyEffectUpdate = function notifyEffectUpdate(callback) {
        if (!updateFuncRef.current) {
            updateFuncRef.current = [];
            (0, $7b92z.default)(function() {
                (0, $jCNM0.unstable_batchedUpdates)(function() {
                    updateFuncRef.current.forEach(function(fn) {
                        fn();
                    });
                    updateFuncRef.current = null;
                });
            });
        }
        updateFuncRef.current.push(callback);
    };
    return notifyEffectUpdate;
}
function $c030f12fe40340d7$export$2e2bcd8739ae039(notifyEffectUpdate, defaultValue) {
    // Value
    var _React$useState = $jbmdS.useState(defaultValue), _React$useState2 = (0, $CZyex.default)(_React$useState, 2), stateValue = _React$useState2[0], setStateValue = _React$useState2[1];
    // Set State
    var setEffectVal = (0, $gZPGe.default)(function(nextValue) {
        notifyEffectUpdate(function() {
            setStateValue(nextValue);
        });
    });
    return [
        stateValue,
        setEffectVal
    ];
}

});
parcelRegister("7b92z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53a092bcd1c9ecbf$export$2e2bcd8739ae039; });

var $2iJQe = parcelRequire("2iJQe");
function $53a092bcd1c9ecbf$export$2e2bcd8739ae039(callback) {
    if (typeof MessageChannel === "undefined") (0, $2iJQe.default)(callback);
    else {
        var channel = new MessageChannel();
        channel.port1.onmessage = function() {
            return callback();
        };
        channel.port2.postMessage(undefined);
    }
}

});


parcelRegister("66Vds", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $472faf88724d48ca$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $ccQt4 = parcelRequire("ccQt4");

var $jbmdS = parcelRequire("jbmdS");

var $02LyB = parcelRequire("02LyB");

var $35AD8 = parcelRequire("35AD8");

var $etjiC = parcelRequire("etjiC");
var $472faf88724d48ca$var$_excluded = [
    "component"
], $472faf88724d48ca$var$_excluded2 = [
    "className"
], $472faf88724d48ca$var$_excluded3 = [
    "className"
];
var $472faf88724d48ca$var$InternalRawItem = function InternalRawItem(props, ref) {
    var context = $jbmdS.useContext((0, $etjiC.OverflowContext));
    // Render directly when context not provided
    if (!context) {
        var _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _restProps = (0, $ccQt4.default)(props, $472faf88724d48ca$var$_excluded);
        return /*#__PURE__*/ $jbmdS.createElement(Component, (0, $7i29i.default)({}, _restProps, {
            ref: ref
        }));
    }
    var contextClassName = context.className, restContext = (0, $ccQt4.default)(context, $472faf88724d48ca$var$_excluded2);
    var className = props.className, restProps = (0, $ccQt4.default)(props, $472faf88724d48ca$var$_excluded3);
    // Do not pass context to sub item to avoid multiple measure
    return /*#__PURE__*/ $jbmdS.createElement((0, $etjiC.OverflowContext).Provider, {
        value: null
    }, /*#__PURE__*/ $jbmdS.createElement((0, $35AD8.default), (0, $7i29i.default)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(contextClassName, className)
    }, restContext, restProps)));
};
var $472faf88724d48ca$var$RawItem = /*#__PURE__*/ $jbmdS.forwardRef($472faf88724d48ca$var$InternalRawItem);
$472faf88724d48ca$var$RawItem.displayName = "RawItem";
var $472faf88724d48ca$export$2e2bcd8739ae039 = $472faf88724d48ca$var$RawItem;

});
parcelRegister("etjiC", function(module, exports) {

$parcel$export(module.exports, "OverflowContext", function () { return $a892be93a45810f2$export$79f16dd643143c25; });

var $jbmdS = parcelRequire("jbmdS");
var $a892be93a45810f2$export$79f16dd643143c25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).createContext(null);

});




parcelRegister("1hjik", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ee658828698824a$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");

var $02LyB = parcelRequire("02LyB");
var $0ee658828698824a$var$TransBtn = function TransBtn(_ref) {
    var className = _ref.className, customizeIcon = _ref.customizeIcon, customizeIconProps = _ref.customizeIconProps, _onMouseDown = _ref.onMouseDown, onClick = _ref.onClick, children = _ref.children;
    var icon;
    if (typeof customizeIcon === "function") icon = customizeIcon(customizeIconProps);
    else icon = customizeIcon;
    return /*#__PURE__*/ $jbmdS.createElement("span", {
        className: className,
        onMouseDown: function onMouseDown(event) {
            event.preventDefault();
            if (_onMouseDown) _onMouseDown(event);
        },
        style: {
            userSelect: "none",
            WebkitUserSelect: "none"
        },
        unselectable: "on",
        onClick: onClick,
        "aria-hidden": true
    }, icon !== undefined ? icon : /*#__PURE__*/ $jbmdS.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(className.split(/\s+/).map(function(cls) {
            return "".concat(cls, "-icon");
        }))
    }, children));
};
var $0ee658828698824a$export$2e2bcd8739ae039 = $0ee658828698824a$var$TransBtn;

});

parcelRegister("2MsI2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $206655881ad6c64f$export$2e2bcd8739ae039; });

var $lv6ip = parcelRequire("lv6ip");

var $jbmdS = parcelRequire("jbmdS");

var $02LyB = parcelRequire("02LyB");

var $aKVEK = parcelRequire("aKVEK");

var $8tMCd = parcelRequire("8tMCd");
var $206655881ad6c64f$var$Input = function Input(_ref, ref) {
    var _inputNode2, _inputNode2$props;
    var prefixCls = _ref.prefixCls, id = _ref.id, inputElement = _ref.inputElement, disabled = _ref.disabled, tabIndex = _ref.tabIndex, autoFocus = _ref.autoFocus, autoComplete = _ref.autoComplete, editable = _ref.editable, activeDescendantId = _ref.activeDescendantId, value = _ref.value, maxLength = _ref.maxLength, _onKeyDown = _ref.onKeyDown, _onMouseDown = _ref.onMouseDown, _onChange = _ref.onChange, onPaste = _ref.onPaste, _onCompositionStart = _ref.onCompositionStart, _onCompositionEnd = _ref.onCompositionEnd, open = _ref.open, attrs = _ref.attrs;
    var inputNode = inputElement || /*#__PURE__*/ $jbmdS.createElement("input", null);
    var _inputNode = inputNode, originRef = _inputNode.ref, originProps = _inputNode.props;
    var onOriginKeyDown = originProps.onKeyDown, onOriginChange = originProps.onChange, onOriginMouseDown = originProps.onMouseDown, onOriginCompositionStart = originProps.onCompositionStart, onOriginCompositionEnd = originProps.onCompositionEnd, style = originProps.style;
    (0, $8tMCd.warning)(!("maxLength" in inputNode.props), "Passing 'maxLength' to input element directly may not work because input in BaseSelect is controlled.");
    inputNode = /*#__PURE__*/ $jbmdS.cloneElement(inputNode, (0, $lv6ip.default)((0, $lv6ip.default)((0, $lv6ip.default)({
        type: "search"
    }, originProps), {}, {
        // Override over origin props
        id: id,
        ref: (0, $aKVEK.composeRef)(ref, originRef),
        disabled: disabled,
        tabIndex: tabIndex,
        autoComplete: autoComplete || "off",
        autoFocus: autoFocus,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("".concat(prefixCls, "-selection-search-input"), (_inputNode2 = inputNode) === null || _inputNode2 === void 0 ? void 0 : (_inputNode2$props = _inputNode2.props) === null || _inputNode2$props === void 0 ? void 0 : _inputNode2$props.className),
        role: "combobox",
        "aria-expanded": open,
        "aria-haspopup": "listbox",
        "aria-owns": "".concat(id, "_list"),
        "aria-autocomplete": "list",
        "aria-controls": "".concat(id, "_list"),
        "aria-activedescendant": activeDescendantId
    }, attrs), {}, {
        value: editable ? value : "",
        maxLength: maxLength,
        readOnly: !editable,
        unselectable: !editable ? "on" : null,
        style: (0, $lv6ip.default)((0, $lv6ip.default)({}, style), {}, {
            opacity: editable ? null : 0
        }),
        onKeyDown: function onKeyDown(event) {
            _onKeyDown(event);
            if (onOriginKeyDown) onOriginKeyDown(event);
        },
        onMouseDown: function onMouseDown(event) {
            _onMouseDown(event);
            if (onOriginMouseDown) onOriginMouseDown(event);
        },
        onChange: function onChange(event) {
            _onChange(event);
            if (onOriginChange) onOriginChange(event);
        },
        onCompositionStart: function onCompositionStart(event) {
            _onCompositionStart(event);
            if (onOriginCompositionStart) onOriginCompositionStart(event);
        },
        onCompositionEnd: function onCompositionEnd(event) {
            _onCompositionEnd(event);
            if (onOriginCompositionEnd) onOriginCompositionEnd(event);
        },
        onPaste: onPaste
    }));
    return inputNode;
};
var $206655881ad6c64f$var$RefInput = /*#__PURE__*/ $jbmdS.forwardRef($206655881ad6c64f$var$Input);
$206655881ad6c64f$var$RefInput.displayName = "Input";
var $206655881ad6c64f$export$2e2bcd8739ae039 = $206655881ad6c64f$var$RefInput;

});

parcelRegister("3JWIW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b932068893cf625$export$2e2bcd8739ae039; });
/* eslint-disable react-hooks/rules-of-hooks */ 
var $jbmdS = parcelRequire("jbmdS");

var $gDBzp = parcelRequire("gDBzp");
function $2b932068893cf625$export$2e2bcd8739ae039(effect, deps) {
    // Never happen in test env
    if (0, $gDBzp.isBrowserClient) /* istanbul ignore next */ $jbmdS.useLayoutEffect(effect, deps);
    else $jbmdS.useEffect(effect, deps);
} /* eslint-enable */ 

});
parcelRegister("gDBzp", function(module, exports) {

$parcel$export(module.exports, "toArray", function () { return $c1cd6e8573fdec44$export$45b10814cc054894; });
$parcel$export(module.exports, "isBrowserClient", function () { return $c1cd6e8573fdec44$export$df7146797a248522; });
$parcel$export(module.exports, "hasValue", function () { return $c1cd6e8573fdec44$export$96bdbc84526f3739; });
$parcel$export(module.exports, "getTitle", function () { return $c1cd6e8573fdec44$export$70d1bf7729efff40; });

var $jncUt = parcelRequire("jncUt");
function $c1cd6e8573fdec44$export$45b10814cc054894(value) {
    if (Array.isArray(value)) return value;
    return value !== undefined ? [
        value
    ] : [];
}
var $c1cd6e8573fdec44$export$7383f122bf48ec30 = typeof window !== "undefined" && window.document && window.document.documentElement;
var $c1cd6e8573fdec44$export$df7146797a248522 = $c1cd6e8573fdec44$export$7383f122bf48ec30;
function $c1cd6e8573fdec44$export$96bdbc84526f3739(value) {
    return value !== undefined && value !== null;
}
function $c1cd6e8573fdec44$var$isTitleType(title) {
    return [
        "string",
        "number"
    ].includes((0, $jncUt.default)(title));
}
function $c1cd6e8573fdec44$export$70d1bf7729efff40(item) {
    var title = undefined;
    if (item) {
        if ($c1cd6e8573fdec44$var$isTitleType(item.title)) title = item.title.toString();
        else if ($c1cd6e8573fdec44$var$isTitleType(item.label)) title = item.label.toString();
    }
    return title;
}

});



parcelRegister("hngxy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca616a3593c3d5a5$export$2e2bcd8739ae039; });

var $CZyex = parcelRequire("CZyex");

var $jbmdS = parcelRequire("jbmdS");

var $dSkKg = parcelRequire("dSkKg");

var $2MsI2 = parcelRequire("2MsI2");

var $gDBzp = parcelRequire("gDBzp");
var $ca616a3593c3d5a5$var$SingleSelector = function SingleSelector(props) {
    var inputElement = props.inputElement, prefixCls = props.prefixCls, id = props.id, inputRef = props.inputRef, disabled = props.disabled, autoFocus = props.autoFocus, autoComplete = props.autoComplete, activeDescendantId = props.activeDescendantId, mode = props.mode, open = props.open, values = props.values, placeholder = props.placeholder, tabIndex = props.tabIndex, showSearch = props.showSearch, searchValue = props.searchValue, activeValue = props.activeValue, maxLength = props.maxLength, onInputKeyDown = props.onInputKeyDown, onInputMouseDown = props.onInputMouseDown, onInputChange = props.onInputChange, onInputPaste = props.onInputPaste, onInputCompositionStart = props.onInputCompositionStart, onInputCompositionEnd = props.onInputCompositionEnd;
    var _React$useState = $jbmdS.useState(false), _React$useState2 = (0, $CZyex.default)(_React$useState, 2), inputChanged = _React$useState2[0], setInputChanged = _React$useState2[1];
    var combobox = mode === "combobox";
    var inputEditable = combobox || showSearch;
    var item = values[0];
    var inputValue = searchValue || "";
    if (combobox && activeValue && !inputChanged) inputValue = activeValue;
    $jbmdS.useEffect(function() {
        if (combobox) setInputChanged(false);
    }, [
        combobox,
        activeValue
    ]);
    // Not show text when closed expect combobox mode
    var hasTextInput = mode !== "combobox" && !open && !showSearch ? false : !!inputValue;
    // Get title
    var title = (0, $gDBzp.getTitle)(item);
    var renderPlaceholder = function renderPlaceholder() {
        if (item) return null;
        var hiddenStyle = hasTextInput ? {
            visibility: "hidden"
        } : undefined;
        return /*#__PURE__*/ $jbmdS.createElement("span", {
            className: "".concat(prefixCls, "-selection-placeholder"),
            style: hiddenStyle
        }, placeholder);
    };
    return /*#__PURE__*/ $jbmdS.createElement($jbmdS.Fragment, null, /*#__PURE__*/ $jbmdS.createElement("span", {
        className: "".concat(prefixCls, "-selection-search")
    }, /*#__PURE__*/ $jbmdS.createElement((0, $2MsI2.default), {
        ref: inputRef,
        prefixCls: prefixCls,
        id: id,
        open: open,
        inputElement: inputElement,
        disabled: disabled,
        autoFocus: autoFocus,
        autoComplete: autoComplete,
        editable: inputEditable,
        activeDescendantId: activeDescendantId,
        value: inputValue,
        onKeyDown: onInputKeyDown,
        onMouseDown: onInputMouseDown,
        onChange: function onChange(e) {
            setInputChanged(true);
            onInputChange(e);
        },
        onPaste: onInputPaste,
        onCompositionStart: onInputCompositionStart,
        onCompositionEnd: onInputCompositionEnd,
        tabIndex: tabIndex,
        attrs: (0, $dSkKg.default)(props, true),
        maxLength: combobox ? maxLength : undefined
    })), !combobox && item ? /*#__PURE__*/ $jbmdS.createElement("span", {
        className: "".concat(prefixCls, "-selection-item"),
        title: title,
        style: hasTextInput ? {
            visibility: "hidden"
        } : undefined
    }, item.label) : null, renderPlaceholder());
};
var $ca616a3593c3d5a5$export$2e2bcd8739ae039 = $ca616a3593c3d5a5$var$SingleSelector;

});

parcelRegister("4v110", function(module, exports) {

$parcel$export(module.exports, "isValidateOpenKey", function () { return $346ad845f734d3cf$export$48ac81d4a07c29c; });

var $5yi5E = parcelRequire("5yi5E");
function $346ad845f734d3cf$export$48ac81d4a07c29c(currentKeyCode) {
    return ![
        // System function button
        (0, $5yi5E.default).ESC,
        (0, $5yi5E.default).SHIFT,
        (0, $5yi5E.default).BACKSPACE,
        (0, $5yi5E.default).TAB,
        (0, $5yi5E.default).WIN_KEY,
        (0, $5yi5E.default).ALT,
        (0, $5yi5E.default).META,
        (0, $5yi5E.default).WIN_KEY_RIGHT,
        (0, $5yi5E.default).CTRL,
        (0, $5yi5E.default).SEMICOLON,
        (0, $5yi5E.default).EQUALS,
        (0, $5yi5E.default).CAPS_LOCK,
        (0, $5yi5E.default).CONTEXT_MENU,
        // F1-F12
        (0, $5yi5E.default).F1,
        (0, $5yi5E.default).F2,
        (0, $5yi5E.default).F3,
        (0, $5yi5E.default).F4,
        (0, $5yi5E.default).F5,
        (0, $5yi5E.default).F6,
        (0, $5yi5E.default).F7,
        (0, $5yi5E.default).F8,
        (0, $5yi5E.default).F9,
        (0, $5yi5E.default).F10,
        (0, $5yi5E.default).F11,
        (0, $5yi5E.default).F12
    ].includes(currentKeyCode);
}

});


parcelRegister("70fqL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $519480ae0482b1d5$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $8K2NM = parcelRequire("8K2NM");

var $lv6ip = parcelRequire("lv6ip");

var $ccQt4 = parcelRequire("ccQt4");

var $jbmdS = parcelRequire("jbmdS");

var $lpI8F = parcelRequire("lpI8F");

var $02LyB = parcelRequire("02LyB");
var $519480ae0482b1d5$var$_excluded = [
    "prefixCls",
    "disabled",
    "visible",
    "children",
    "popupElement",
    "containerWidth",
    "animation",
    "transitionName",
    "dropdownStyle",
    "dropdownClassName",
    "direction",
    "placement",
    "dropdownMatchSelectWidth",
    "dropdownRender",
    "dropdownAlign",
    "getPopupContainer",
    "empty",
    "getTriggerDOMNode",
    "onPopupVisibleChange",
    "onPopupMouseEnter"
];
var $519480ae0482b1d5$var$getBuiltInPlacements = function getBuiltInPlacements(dropdownMatchSelectWidth) {
    // Enable horizontal overflow auto-adjustment when a custom dropdown width is provided
    var adjustX = dropdownMatchSelectWidth === true ? 0 : 1;
    return {
        bottomLeft: {
            points: [
                "tl",
                "bl"
            ],
            offset: [
                0,
                4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            }
        },
        bottomRight: {
            points: [
                "tr",
                "br"
            ],
            offset: [
                0,
                4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            }
        },
        topLeft: {
            points: [
                "bl",
                "tl"
            ],
            offset: [
                0,
                -4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            }
        },
        topRight: {
            points: [
                "br",
                "tr"
            ],
            offset: [
                0,
                -4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            }
        }
    };
};
var $519480ae0482b1d5$var$SelectTrigger = function SelectTrigger(props, ref) {
    var prefixCls = props.prefixCls, disabled = props.disabled, visible = props.visible, children = props.children, popupElement = props.popupElement, containerWidth = props.containerWidth, animation = props.animation, transitionName = props.transitionName, dropdownStyle = props.dropdownStyle, dropdownClassName = props.dropdownClassName, _props$direction = props.direction, direction = _props$direction === void 0 ? "ltr" : _props$direction, placement = props.placement, dropdownMatchSelectWidth = props.dropdownMatchSelectWidth, dropdownRender = props.dropdownRender, dropdownAlign = props.dropdownAlign, getPopupContainer = props.getPopupContainer, empty = props.empty, getTriggerDOMNode = props.getTriggerDOMNode, onPopupVisibleChange = props.onPopupVisibleChange, onPopupMouseEnter = props.onPopupMouseEnter, restProps = (0, $ccQt4.default)(props, $519480ae0482b1d5$var$_excluded);
    var dropdownPrefixCls = "".concat(prefixCls, "-dropdown");
    var popupNode = popupElement;
    if (dropdownRender) popupNode = dropdownRender(popupElement);
    var builtInPlacements = $jbmdS.useMemo(function() {
        return $519480ae0482b1d5$var$getBuiltInPlacements(dropdownMatchSelectWidth);
    }, [
        dropdownMatchSelectWidth
    ]);
    // ===================== Motion ======================
    var mergedTransitionName = animation ? "".concat(dropdownPrefixCls, "-").concat(animation) : transitionName;
    // ======================= Ref =======================
    var popupRef = $jbmdS.useRef(null);
    $jbmdS.useImperativeHandle(ref, function() {
        return {
            getPopupElement: function getPopupElement() {
                return popupRef.current;
            }
        };
    });
    var popupStyle = (0, $lv6ip.default)({
        minWidth: containerWidth
    }, dropdownStyle);
    if (typeof dropdownMatchSelectWidth === "number") popupStyle.width = dropdownMatchSelectWidth;
    else if (dropdownMatchSelectWidth) popupStyle.width = containerWidth;
    return /*#__PURE__*/ $jbmdS.createElement((0, $lpI8F.default), (0, $7i29i.default)({}, restProps, {
        showAction: onPopupVisibleChange ? [
            "click"
        ] : [],
        hideAction: onPopupVisibleChange ? [
            "click"
        ] : [],
        popupPlacement: placement || (direction === "rtl" ? "bottomRight" : "bottomLeft"),
        builtinPlacements: builtInPlacements,
        prefixCls: dropdownPrefixCls,
        popupTransitionName: mergedTransitionName,
        popup: /*#__PURE__*/ $jbmdS.createElement("div", {
            ref: popupRef,
            onMouseEnter: onPopupMouseEnter
        }, popupNode),
        popupAlign: dropdownAlign,
        popupVisible: visible,
        getPopupContainer: getPopupContainer,
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(dropdownClassName, (0, $8K2NM.default)({}, "".concat(dropdownPrefixCls, "-empty"), empty)),
        popupStyle: popupStyle,
        getTriggerDOMNode: getTriggerDOMNode,
        onPopupVisibleChange: onPopupVisibleChange
    }), children);
};
var $519480ae0482b1d5$var$RefSelectTrigger = /*#__PURE__*/ $jbmdS.forwardRef($519480ae0482b1d5$var$SelectTrigger);
$519480ae0482b1d5$var$RefSelectTrigger.displayName = "SelectTrigger";
var $519480ae0482b1d5$export$2e2bcd8739ae039 = $519480ae0482b1d5$var$RefSelectTrigger;

});
parcelRegister("lpI8F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f96e2bcd8e7be132$export$2e2bcd8739ae039; });

var $lv6ip = parcelRequire("lv6ip");

var $7i29i = parcelRequire("7i29i");

var $3GVdq = parcelRequire("3GVdq");

var $jj5jQ = parcelRequire("jj5jQ");

var $br3Qu = parcelRequire("br3Qu");

var $1N4zm = parcelRequire("1N4zm");

var $gRFRo = parcelRequire("gRFRo");

var $8K2NM = parcelRequire("8K2NM");

var $jbmdS = parcelRequire("jbmdS");

var $jCNM0 = parcelRequire("jCNM0");

var $2iJQe = parcelRequire("2iJQe");

var $1sys4 = parcelRequire("1sys4");

var $1RfjE = parcelRequire("1RfjE");

var $aKVEK = parcelRequire("aKVEK");

var $j12Lu = parcelRequire("j12Lu");

var $eXDiI = parcelRequire("eXDiI");

var $02LyB = parcelRequire("02LyB");

var $fNr89 = parcelRequire("fNr89");

var $3DHrI = parcelRequire("3DHrI");

var $i5q9E = parcelRequire("i5q9E");
function $f96e2bcd8e7be132$var$noop() {}
function $f96e2bcd8e7be132$var$returnEmptyString() {
    return "";
}
function $f96e2bcd8e7be132$var$returnDocument(element) {
    if (element) return element.ownerDocument;
    return window.document;
}
var $f96e2bcd8e7be132$var$ALL_HANDLERS = [
    "onClick",
    "onMouseDown",
    "onTouchStart",
    "onMouseEnter",
    "onMouseLeave",
    "onFocus",
    "onBlur",
    "onContextMenu"
];
function $f96e2bcd8e7be132$export$55e99723d7f71b47(PortalComponent) {
    var Trigger = /*#__PURE__*/ function(_React$Component) {
        (0, $1N4zm.default)(Trigger, _React$Component);
        var _super = (0, $gRFRo.default)(Trigger);
        // ensure `getContainer` will be called only once
        function Trigger(props) {
            var _this;
            (0, $3GVdq.default)(this, Trigger);
            _this = _super.call(this, props);
            (0, $8K2NM.default)((0, $br3Qu.default)(_this), "popupRef", /*#__PURE__*/ $jbmdS.createRef());
            (0, $8K2NM.default)((0, $br3Qu.default)(_this), "triggerRef", /*#__PURE__*/ $jbmdS.createRef());
            (0, $8K2NM.default)((0, $br3Qu.default)(_this), "portalContainer", void 0);
            (0, $8K2NM.default)((0, $br3Qu.default)(_this), "attachId", void 0);
            (0, $8K2NM.default)((0, $br3Qu.default)(_this), "clickOutsideHandler", void 0);
            (0, $8K2NM.default)((0, $br3Qu.default)(_this), "touchOutsideHandler", void 0);
            (0, $8K2NM.default)((0, $br3Qu.default)(_this), "contextMenuOutsideHandler1", void 0);
            (0, $8K2NM.default)((0, $br3Qu.default)(_this), "contextMenuOutsideHandler2", void 0);
            (0, $8K2NM.default)((0, $br3Qu.default)(_this), "mouseDownTimeout", void 0);
            (0, $8K2NM.default)((0, $br3Qu.default)(_this), "focusTime", void 0);
            (0, $8K2NM.default)((0, $br3Qu.default)(_this), "preClickTime", void 0);
            (0, $8K2NM.default)((0, $br3Qu.default)(_this), "preTouchTime", void 0);
            (0, $8K2NM.default)((0, $br3Qu.default)(_this), "delayTimer", void 0);
            (0, $8K2NM.default)((0, $br3Qu.default)(_this), "hasPopupMouseDown", void 0);
            (0, $8K2NM.default)((0, $br3Qu.default)(_this), "onMouseEnter", function(e) {
                var mouseEnterDelay = _this.props.mouseEnterDelay;
                _this.fireEvents("onMouseEnter", e);
                _this.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
            });
            (0, $8K2NM.default)((0, $br3Qu.default)(_this), "onMouseMove", function(e) {
                _this.fireEvents("onMouseMove", e);
                _this.setPoint(e);
            });
            (0, $8K2NM.default)((0, $br3Qu.default)(_this), "onMouseLeave", function(e) {
                _this.fireEvents("onMouseLeave", e);
                _this.delaySetPopupVisible(false, _this.props.mouseLeaveDelay);
            });
            (0, $8K2NM.default)((0, $br3Qu.default)(_this), "onPopupMouseEnter", function() {
                _this.clearDelayTimer();
            });
            (0, $8K2NM.default)((0, $br3Qu.default)(_this), "onPopupMouseLeave", function(e) {
                var _this$popupRef$curren;
                // https://github.com/react-component/trigger/pull/13
                // react bug?
                if (e.relatedTarget && !e.relatedTarget.setTimeout && (0, $1sys4.default)((_this$popupRef$curren = _this.popupRef.current) === null || _this$popupRef$curren === void 0 ? void 0 : _this$popupRef$curren.getElement(), e.relatedTarget)) return;
                _this.delaySetPopupVisible(false, _this.props.mouseLeaveDelay);
            });
            (0, $8K2NM.default)((0, $br3Qu.default)(_this), "onFocus", function(e) {
                _this.fireEvents("onFocus", e); // incase focusin and focusout
                _this.clearDelayTimer();
                if (_this.isFocusToShow()) {
                    _this.focusTime = Date.now();
                    _this.delaySetPopupVisible(true, _this.props.focusDelay);
                }
            });
            (0, $8K2NM.default)((0, $br3Qu.default)(_this), "onMouseDown", function(e) {
                _this.fireEvents("onMouseDown", e);
                _this.preClickTime = Date.now();
            });
            (0, $8K2NM.default)((0, $br3Qu.default)(_this), "onTouchStart", function(e) {
                _this.fireEvents("onTouchStart", e);
                _this.preTouchTime = Date.now();
            });
            (0, $8K2NM.default)((0, $br3Qu.default)(_this), "onBlur", function(e) {
                _this.fireEvents("onBlur", e);
                _this.clearDelayTimer();
                if (_this.isBlurToHide()) _this.delaySetPopupVisible(false, _this.props.blurDelay);
            });
            (0, $8K2NM.default)((0, $br3Qu.default)(_this), "onContextMenu", function(e) {
                e.preventDefault();
                _this.fireEvents("onContextMenu", e);
                _this.setPopupVisible(true, e);
            });
            (0, $8K2NM.default)((0, $br3Qu.default)(_this), "onContextMenuClose", function() {
                if (_this.isContextMenuToShow()) _this.close();
            });
            (0, $8K2NM.default)((0, $br3Qu.default)(_this), "onClick", function(event) {
                _this.fireEvents("onClick", event); // focus will trigger click
                if (_this.focusTime) {
                    var preTime;
                    if (_this.preClickTime && _this.preTouchTime) preTime = Math.min(_this.preClickTime, _this.preTouchTime);
                    else if (_this.preClickTime) preTime = _this.preClickTime;
                    else if (_this.preTouchTime) preTime = _this.preTouchTime;
                    if (Math.abs(preTime - _this.focusTime) < 20) return;
                    _this.focusTime = 0;
                }
                _this.preClickTime = 0;
                _this.preTouchTime = 0; // Only prevent default when all the action is click.
                // https://github.com/ant-design/ant-design/issues/17043
                // https://github.com/ant-design/ant-design/issues/17291
                if (_this.isClickToShow() && (_this.isClickToHide() || _this.isBlurToHide()) && event && event.preventDefault) event.preventDefault();
                var nextVisible = !_this.state.popupVisible;
                if (_this.isClickToHide() && !nextVisible || nextVisible && _this.isClickToShow()) _this.setPopupVisible(!_this.state.popupVisible, event);
            });
            (0, $8K2NM.default)((0, $br3Qu.default)(_this), "onPopupMouseDown", function() {
                _this.hasPopupMouseDown = true;
                clearTimeout(_this.mouseDownTimeout);
                _this.mouseDownTimeout = window.setTimeout(function() {
                    _this.hasPopupMouseDown = false;
                }, 0);
                if (_this.context) {
                    var _this$context;
                    (_this$context = _this.context).onPopupMouseDown.apply(_this$context, arguments);
                }
            });
            (0, $8K2NM.default)((0, $br3Qu.default)(_this), "onDocumentClick", function(event) {
                if (_this.props.mask && !_this.props.maskClosable) return;
                var target = event.target;
                var root = _this.getRootDomNode();
                var popupNode = _this.getPopupDomNode();
                if (// https://github.com/ant-design/ant-design/issues/29853
                (!(0, $1sys4.default)(root, target) || _this.isContextMenuOnly()) && !(0, $1sys4.default)(popupNode, target) && !_this.hasPopupMouseDown) _this.close();
            });
            (0, $8K2NM.default)((0, $br3Qu.default)(_this), "getRootDomNode", function() {
                var getTriggerDOMNode = _this.props.getTriggerDOMNode;
                if (getTriggerDOMNode) return getTriggerDOMNode(_this.triggerRef.current);
                try {
                    var domNode = (0, $1RfjE.default)(_this.triggerRef.current);
                    if (domNode) return domNode;
                } catch (err) {}
                return (0, (/*@__PURE__*/$parcel$interopDefault($jCNM0))).findDOMNode((0, $br3Qu.default)(_this));
            });
            (0, $8K2NM.default)((0, $br3Qu.default)(_this), "getPopupClassNameFromAlign", function(align) {
                var className = [];
                var _this$props = _this.props, popupPlacement = _this$props.popupPlacement, builtinPlacements = _this$props.builtinPlacements, prefixCls = _this$props.prefixCls, alignPoint = _this$props.alignPoint, getPopupClassNameFromAlign = _this$props.getPopupClassNameFromAlign;
                if (popupPlacement && builtinPlacements) className.push((0, $fNr89.getAlignPopupClassName)(builtinPlacements, prefixCls, align, alignPoint));
                if (getPopupClassNameFromAlign) className.push(getPopupClassNameFromAlign(align));
                return className.join(" ");
            });
            (0, $8K2NM.default)((0, $br3Qu.default)(_this), "getComponent", function() {
                var _this$props2 = _this.props, prefixCls = _this$props2.prefixCls, destroyPopupOnHide = _this$props2.destroyPopupOnHide, popupClassName = _this$props2.popupClassName, onPopupAlign = _this$props2.onPopupAlign, popupMotion = _this$props2.popupMotion, popupAnimation = _this$props2.popupAnimation, popupTransitionName = _this$props2.popupTransitionName, popupStyle = _this$props2.popupStyle, mask = _this$props2.mask, maskAnimation = _this$props2.maskAnimation, maskTransitionName = _this$props2.maskTransitionName, maskMotion = _this$props2.maskMotion, zIndex = _this$props2.zIndex, popup = _this$props2.popup, stretch = _this$props2.stretch, alignPoint = _this$props2.alignPoint, mobile = _this$props2.mobile, forceRender = _this$props2.forceRender, onPopupClick = _this$props2.onPopupClick;
                var _this$state = _this.state, popupVisible = _this$state.popupVisible, point = _this$state.point;
                var align = _this.getPopupAlign();
                var mouseProps = {};
                if (_this.isMouseEnterToShow()) mouseProps.onMouseEnter = _this.onPopupMouseEnter;
                if (_this.isMouseLeaveToHide()) mouseProps.onMouseLeave = _this.onPopupMouseLeave;
                mouseProps.onMouseDown = _this.onPopupMouseDown;
                mouseProps.onTouchStart = _this.onPopupMouseDown;
                return /*#__PURE__*/ $jbmdS.createElement((0, $3DHrI.default), (0, $7i29i.default)({
                    prefixCls: prefixCls,
                    destroyPopupOnHide: destroyPopupOnHide,
                    visible: popupVisible,
                    point: alignPoint && point,
                    className: popupClassName,
                    align: align,
                    onAlign: onPopupAlign,
                    animation: popupAnimation,
                    getClassNameFromAlign: _this.getPopupClassNameFromAlign
                }, mouseProps, {
                    stretch: stretch,
                    getRootDomNode: _this.getRootDomNode,
                    style: popupStyle,
                    mask: mask,
                    zIndex: zIndex,
                    transitionName: popupTransitionName,
                    maskAnimation: maskAnimation,
                    maskTransitionName: maskTransitionName,
                    maskMotion: maskMotion,
                    ref: _this.popupRef,
                    motion: popupMotion,
                    mobile: mobile,
                    forceRender: forceRender,
                    onClick: onPopupClick
                }), typeof popup === "function" ? popup() : popup);
            });
            (0, $8K2NM.default)((0, $br3Qu.default)(_this), "attachParent", function(popupContainer) {
                (0, $2iJQe.default).cancel(_this.attachId);
                var _this$props3 = _this.props, getPopupContainer = _this$props3.getPopupContainer, getDocument = _this$props3.getDocument;
                var domNode = _this.getRootDomNode();
                var mountNode;
                if (!getPopupContainer) mountNode = getDocument(_this.getRootDomNode()).body;
                else if (domNode || getPopupContainer.length === 0) // Compatible for legacy getPopupContainer with domNode argument.
                // If no need `domNode` argument, will call directly.
                // https://codesandbox.io/s/eloquent-mclean-ss93m?file=/src/App.js
                mountNode = getPopupContainer(domNode);
                if (mountNode) mountNode.appendChild(popupContainer);
                else // Retry after frame render in case parent not ready
                _this.attachId = (0, $2iJQe.default)(function() {
                    _this.attachParent(popupContainer);
                });
            });
            (0, $8K2NM.default)((0, $br3Qu.default)(_this), "getContainer", function() {
                if (!_this.portalContainer) {
                    // In React.StrictMode component will call render multiple time in first mount.
                    // When you want to refactor with FC, useRef will also init multiple time and
                    // point to different useRef instance which will create multiple element
                    // (This multiple render will not trigger effect so you can not clean up this
                    // in effect). But this is safe with class component since it always point to same class instance.
                    var getDocument = _this.props.getDocument;
                    var popupContainer = getDocument(_this.getRootDomNode()).createElement("div"); // Make sure default popup container will never cause scrollbar appearing
                    // https://github.com/react-component/trigger/issues/41
                    popupContainer.style.position = "absolute";
                    popupContainer.style.top = "0";
                    popupContainer.style.left = "0";
                    popupContainer.style.width = "100%";
                    _this.portalContainer = popupContainer;
                }
                _this.attachParent(_this.portalContainer);
                return _this.portalContainer;
            });
            (0, $8K2NM.default)((0, $br3Qu.default)(_this), "setPoint", function(point) {
                var alignPoint = _this.props.alignPoint;
                if (!alignPoint || !point) return;
                _this.setState({
                    point: {
                        pageX: point.pageX,
                        pageY: point.pageY
                    }
                });
            });
            (0, $8K2NM.default)((0, $br3Qu.default)(_this), "handlePortalUpdate", function() {
                if (_this.state.prevPopupVisible !== _this.state.popupVisible) _this.props.afterPopupVisibleChange(_this.state.popupVisible);
            });
            (0, $8K2NM.default)((0, $br3Qu.default)(_this), "triggerContextValue", {
                onPopupMouseDown: _this.onPopupMouseDown
            });
            var _popupVisible;
            if ("popupVisible" in props) _popupVisible = !!props.popupVisible;
            else _popupVisible = !!props.defaultPopupVisible;
            _this.state = {
                prevPopupVisible: _popupVisible,
                popupVisible: _popupVisible
            };
            $f96e2bcd8e7be132$var$ALL_HANDLERS.forEach(function(h) {
                _this["fire".concat(h)] = function(e) {
                    _this.fireEvents(h, e);
                };
            });
            return _this;
        }
        (0, $jj5jQ.default)(Trigger, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.componentDidUpdate();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate() {
                    var props = this.props;
                    var state = this.state; // We must listen to `mousedown` or `touchstart`, edge case:
                    // https://github.com/ant-design/ant-design/issues/5804
                    // https://github.com/react-component/calendar/issues/250
                    // https://github.com/react-component/trigger/issues/50
                    if (state.popupVisible) {
                        var currentDocument;
                        if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
                            currentDocument = props.getDocument(this.getRootDomNode());
                            this.clickOutsideHandler = (0, $j12Lu.default)(currentDocument, "mousedown", this.onDocumentClick);
                        } // always hide on mobile
                        if (!this.touchOutsideHandler) {
                            currentDocument = currentDocument || props.getDocument(this.getRootDomNode());
                            this.touchOutsideHandler = (0, $j12Lu.default)(currentDocument, "touchstart", this.onDocumentClick);
                        } // close popup when trigger type contains 'onContextMenu' and document is scrolling.
                        if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
                            currentDocument = currentDocument || props.getDocument(this.getRootDomNode());
                            this.contextMenuOutsideHandler1 = (0, $j12Lu.default)(currentDocument, "scroll", this.onContextMenuClose);
                        } // close popup when trigger type contains 'onContextMenu' and window is blur.
                        if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) this.contextMenuOutsideHandler2 = (0, $j12Lu.default)(window, "blur", this.onContextMenuClose);
                        return;
                    }
                    this.clearOutsideHandler();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.clearDelayTimer();
                    this.clearOutsideHandler();
                    clearTimeout(this.mouseDownTimeout);
                    (0, $2iJQe.default).cancel(this.attachId);
                }
            },
            {
                key: "getPopupDomNode",
                value: function getPopupDomNode() {
                    var _this$popupRef$curren2;
                    // for test
                    return ((_this$popupRef$curren2 = this.popupRef.current) === null || _this$popupRef$curren2 === void 0 ? void 0 : _this$popupRef$curren2.getElement()) || null;
                }
            },
            {
                key: "getPopupAlign",
                value: function getPopupAlign() {
                    var props = this.props;
                    var popupPlacement = props.popupPlacement, popupAlign = props.popupAlign, builtinPlacements = props.builtinPlacements;
                    if (popupPlacement && builtinPlacements) return (0, $fNr89.getAlignFromPlacement)(builtinPlacements, popupPlacement, popupAlign);
                    return popupAlign;
                }
            },
            {
                key: "setPopupVisible",
                value: /**
       * @param popupVisible    Show or not the popup element
       * @param event           SyntheticEvent, used for `pointAlign`
       */ function setPopupVisible(popupVisible, event) {
                    var alignPoint = this.props.alignPoint;
                    var prevPopupVisible = this.state.popupVisible;
                    this.clearDelayTimer();
                    if (prevPopupVisible !== popupVisible) {
                        if (!("popupVisible" in this.props)) this.setState({
                            popupVisible: popupVisible,
                            prevPopupVisible: prevPopupVisible
                        });
                        this.props.onPopupVisibleChange(popupVisible);
                    } // Always record the point position since mouseEnterDelay will delay the show
                    if (alignPoint && event && popupVisible) this.setPoint(event);
                }
            },
            {
                key: "delaySetPopupVisible",
                value: function delaySetPopupVisible(visible, delayS, event) {
                    var _this2 = this;
                    var delay = delayS * 1000;
                    this.clearDelayTimer();
                    if (delay) {
                        var point = event ? {
                            pageX: event.pageX,
                            pageY: event.pageY
                        } : null;
                        this.delayTimer = window.setTimeout(function() {
                            _this2.setPopupVisible(visible, point);
                            _this2.clearDelayTimer();
                        }, delay);
                    } else this.setPopupVisible(visible, event);
                }
            },
            {
                key: "clearDelayTimer",
                value: function clearDelayTimer() {
                    if (this.delayTimer) {
                        clearTimeout(this.delayTimer);
                        this.delayTimer = null;
                    }
                }
            },
            {
                key: "clearOutsideHandler",
                value: function clearOutsideHandler() {
                    if (this.clickOutsideHandler) {
                        this.clickOutsideHandler.remove();
                        this.clickOutsideHandler = null;
                    }
                    if (this.contextMenuOutsideHandler1) {
                        this.contextMenuOutsideHandler1.remove();
                        this.contextMenuOutsideHandler1 = null;
                    }
                    if (this.contextMenuOutsideHandler2) {
                        this.contextMenuOutsideHandler2.remove();
                        this.contextMenuOutsideHandler2 = null;
                    }
                    if (this.touchOutsideHandler) {
                        this.touchOutsideHandler.remove();
                        this.touchOutsideHandler = null;
                    }
                }
            },
            {
                key: "createTwoChains",
                value: function createTwoChains(event) {
                    var childPros = this.props.children.props;
                    var props = this.props;
                    if (childPros[event] && props[event]) return this["fire".concat(event)];
                    return childPros[event] || props[event];
                }
            },
            {
                key: "isClickToShow",
                value: function isClickToShow() {
                    var _this$props4 = this.props, action = _this$props4.action, showAction = _this$props4.showAction;
                    return action.indexOf("click") !== -1 || showAction.indexOf("click") !== -1;
                }
            },
            {
                key: "isContextMenuOnly",
                value: function isContextMenuOnly() {
                    var action = this.props.action;
                    return action === "contextMenu" || action.length === 1 && action[0] === "contextMenu";
                }
            },
            {
                key: "isContextMenuToShow",
                value: function isContextMenuToShow() {
                    var _this$props5 = this.props, action = _this$props5.action, showAction = _this$props5.showAction;
                    return action.indexOf("contextMenu") !== -1 || showAction.indexOf("contextMenu") !== -1;
                }
            },
            {
                key: "isClickToHide",
                value: function isClickToHide() {
                    var _this$props6 = this.props, action = _this$props6.action, hideAction = _this$props6.hideAction;
                    return action.indexOf("click") !== -1 || hideAction.indexOf("click") !== -1;
                }
            },
            {
                key: "isMouseEnterToShow",
                value: function isMouseEnterToShow() {
                    var _this$props7 = this.props, action = _this$props7.action, showAction = _this$props7.showAction;
                    return action.indexOf("hover") !== -1 || showAction.indexOf("mouseEnter") !== -1;
                }
            },
            {
                key: "isMouseLeaveToHide",
                value: function isMouseLeaveToHide() {
                    var _this$props8 = this.props, action = _this$props8.action, hideAction = _this$props8.hideAction;
                    return action.indexOf("hover") !== -1 || hideAction.indexOf("mouseLeave") !== -1;
                }
            },
            {
                key: "isFocusToShow",
                value: function isFocusToShow() {
                    var _this$props9 = this.props, action = _this$props9.action, showAction = _this$props9.showAction;
                    return action.indexOf("focus") !== -1 || showAction.indexOf("focus") !== -1;
                }
            },
            {
                key: "isBlurToHide",
                value: function isBlurToHide() {
                    var _this$props10 = this.props, action = _this$props10.action, hideAction = _this$props10.hideAction;
                    return action.indexOf("focus") !== -1 || hideAction.indexOf("blur") !== -1;
                }
            },
            {
                key: "forcePopupAlign",
                value: function forcePopupAlign() {
                    if (this.state.popupVisible) {
                        var _this$popupRef$curren3;
                        (_this$popupRef$curren3 = this.popupRef.current) === null || _this$popupRef$curren3 === void 0 || _this$popupRef$curren3.forceAlign();
                    }
                }
            },
            {
                key: "fireEvents",
                value: function fireEvents(type, e) {
                    var childCallback = this.props.children.props[type];
                    if (childCallback) childCallback(e);
                    var callback = this.props[type];
                    if (callback) callback(e);
                }
            },
            {
                key: "close",
                value: function close() {
                    this.setPopupVisible(false);
                }
            },
            {
                key: "render",
                value: function render() {
                    var popupVisible = this.state.popupVisible;
                    var _this$props11 = this.props, children = _this$props11.children, forceRender = _this$props11.forceRender, alignPoint = _this$props11.alignPoint, className = _this$props11.className, autoDestroy = _this$props11.autoDestroy;
                    var child = $jbmdS.Children.only(children);
                    var newChildProps = {
                        key: "trigger"
                    }; // ============================== Visible Handlers ==============================
                    // >>> ContextMenu
                    if (this.isContextMenuToShow()) newChildProps.onContextMenu = this.onContextMenu;
                    else newChildProps.onContextMenu = this.createTwoChains("onContextMenu");
                     // >>> Click
                    if (this.isClickToHide() || this.isClickToShow()) {
                        newChildProps.onClick = this.onClick;
                        newChildProps.onMouseDown = this.onMouseDown;
                        newChildProps.onTouchStart = this.onTouchStart;
                    } else {
                        newChildProps.onClick = this.createTwoChains("onClick");
                        newChildProps.onMouseDown = this.createTwoChains("onMouseDown");
                        newChildProps.onTouchStart = this.createTwoChains("onTouchStart");
                    } // >>> Hover(enter)
                    if (this.isMouseEnterToShow()) {
                        newChildProps.onMouseEnter = this.onMouseEnter; // Point align
                        if (alignPoint) newChildProps.onMouseMove = this.onMouseMove;
                    } else newChildProps.onMouseEnter = this.createTwoChains("onMouseEnter");
                     // >>> Hover(leave)
                    if (this.isMouseLeaveToHide()) newChildProps.onMouseLeave = this.onMouseLeave;
                    else newChildProps.onMouseLeave = this.createTwoChains("onMouseLeave");
                     // >>> Focus
                    if (this.isFocusToShow() || this.isBlurToHide()) {
                        newChildProps.onFocus = this.onFocus;
                        newChildProps.onBlur = this.onBlur;
                    } else {
                        newChildProps.onFocus = this.createTwoChains("onFocus");
                        newChildProps.onBlur = this.createTwoChains("onBlur");
                    } // =================================== Render ===================================
                    var childrenClassName = (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(child && child.props && child.props.className, className);
                    if (childrenClassName) newChildProps.className = childrenClassName;
                    var cloneProps = (0, $lv6ip.default)({}, newChildProps);
                    if ((0, $aKVEK.supportRef)(child)) cloneProps.ref = (0, $aKVEK.composeRef)(this.triggerRef, child.ref);
                    var trigger = /*#__PURE__*/ $jbmdS.cloneElement(child, cloneProps);
                    var portal; // prevent unmounting after it's rendered
                    if (popupVisible || this.popupRef.current || forceRender) portal = /*#__PURE__*/ $jbmdS.createElement(PortalComponent, {
                        key: "portal",
                        getContainer: this.getContainer,
                        didUpdate: this.handlePortalUpdate
                    }, this.getComponent());
                    if (!popupVisible && autoDestroy) portal = null;
                    return /*#__PURE__*/ $jbmdS.createElement((0, $i5q9E.default).Provider, {
                        value: this.triggerContextValue
                    }, trigger, portal);
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(_ref, prevState) {
                    var popupVisible = _ref.popupVisible;
                    var newState = {};
                    if (popupVisible !== undefined && prevState.popupVisible !== popupVisible) {
                        newState.popupVisible = popupVisible;
                        newState.prevPopupVisible = prevState.popupVisible;
                    }
                    return newState;
                }
            }
        ]);
        return Trigger;
    }($jbmdS.Component);
    (0, $8K2NM.default)(Trigger, "contextType", (0, $i5q9E.default));
    (0, $8K2NM.default)(Trigger, "defaultProps", {
        prefixCls: "rc-trigger-popup",
        getPopupClassNameFromAlign: $f96e2bcd8e7be132$var$returnEmptyString,
        getDocument: $f96e2bcd8e7be132$var$returnDocument,
        onPopupVisibleChange: $f96e2bcd8e7be132$var$noop,
        afterPopupVisibleChange: $f96e2bcd8e7be132$var$noop,
        onPopupAlign: $f96e2bcd8e7be132$var$noop,
        popupClassName: "",
        mouseEnterDelay: 0,
        mouseLeaveDelay: 0.1,
        focusDelay: 0,
        blurDelay: 0.15,
        popupStyle: {},
        destroyPopupOnHide: false,
        popupAlign: {},
        defaultPopupVisible: false,
        mask: false,
        maskClosable: true,
        action: [],
        showAction: [],
        hideAction: [],
        autoDestroy: false
    });
    return Trigger;
}
var $f96e2bcd8e7be132$export$2e2bcd8739ae039 = $f96e2bcd8e7be132$export$55e99723d7f71b47((0, $eXDiI.default));

});
parcelRegister("j12Lu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd80415d81e06bcb$export$2e2bcd8739ae039; });

var $jCNM0 = parcelRequire("jCNM0");
function $dd80415d81e06bcb$export$2e2bcd8739ae039(target, eventType, cb, option) {
    /* eslint camelcase: 2 */ var callback = (0, (/*@__PURE__*/$parcel$interopDefault($jCNM0))).unstable_batchedUpdates ? function run(e) {
        (0, (/*@__PURE__*/$parcel$interopDefault($jCNM0))).unstable_batchedUpdates(cb, e);
    } : cb;
    if (target !== null && target !== void 0 && target.addEventListener) target.addEventListener(eventType, callback, option);
    return {
        remove: function remove() {
            if (target !== null && target !== void 0 && target.removeEventListener) target.removeEventListener(eventType, callback, option);
        }
    };
}

});

parcelRegister("eXDiI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae450fb9450f84a2$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");

var $jCNM0 = parcelRequire("jCNM0");

var $gnP4S = parcelRequire("gnP4S");
var $ae450fb9450f84a2$var$Portal = /*#__PURE__*/ (0, $jbmdS.forwardRef)(function(props, ref) {
    var didUpdate = props.didUpdate, getContainer = props.getContainer, children = props.children;
    var parentRef = (0, $jbmdS.useRef)();
    var containerRef = (0, $jbmdS.useRef)();
    // Ref return nothing, only for wrapper check exist
    (0, $jbmdS.useImperativeHandle)(ref, function() {
        return {};
    });
    // Create container in client side with sync to avoid useEffect not get ref
    var initRef = (0, $jbmdS.useRef)(false);
    if (!initRef.current && (0, $gnP4S.default)()) {
        containerRef.current = getContainer();
        parentRef.current = containerRef.current.parentNode;
        initRef.current = true;
    }
    // [Legacy] Used by `rc-trigger`
    (0, $jbmdS.useEffect)(function() {
        didUpdate === null || didUpdate === void 0 || didUpdate(props);
    });
    (0, $jbmdS.useEffect)(function() {
        // Restore container to original place
        // React 18 StrictMode will unmount first and mount back for effect test:
        // https://reactjs.org/blog/2022/03/29/react-v18.html#new-strict-mode-behaviors
        if (containerRef.current.parentNode === null && parentRef.current !== null) parentRef.current.appendChild(containerRef.current);
        return function() {
            var _containerRef$current;
            // [Legacy] This should not be handle by Portal but parent PortalWrapper instead.
            // Since some component use `Portal` directly, we have to keep the logic here.
            (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 || (_containerRef$current = _containerRef$current.parentNode) === null || _containerRef$current === void 0 || _containerRef$current.removeChild(containerRef.current);
        };
    }, []);
    return containerRef.current ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jCNM0))).createPortal(children, containerRef.current) : null;
});
var $ae450fb9450f84a2$export$2e2bcd8739ae039 = $ae450fb9450f84a2$var$Portal;

});

parcelRegister("fNr89", function(module, exports) {

$parcel$export(module.exports, "getAlignFromPlacement", function () { return $b8007a2f819a4de8$export$44605b74f7c5d944; });
$parcel$export(module.exports, "getAlignPopupClassName", function () { return $b8007a2f819a4de8$export$faa0aa8ed2fe6432; });

var $lv6ip = parcelRequire("lv6ip");
function $b8007a2f819a4de8$var$isPointsEq(a1, a2, isAlignPoint) {
    if (isAlignPoint) return a1[0] === a2[0];
    return a1[0] === a2[0] && a1[1] === a2[1];
}
function $b8007a2f819a4de8$export$44605b74f7c5d944(builtinPlacements, placementStr, align) {
    var baseAlign = builtinPlacements[placementStr] || {};
    return (0, $lv6ip.default)((0, $lv6ip.default)({}, baseAlign), align);
}
function $b8007a2f819a4de8$export$faa0aa8ed2fe6432(builtinPlacements, prefixCls, align, isAlignPoint) {
    var points = align.points;
    var placements = Object.keys(builtinPlacements);
    for(var i = 0; i < placements.length; i += 1){
        var placement = placements[i];
        if ($b8007a2f819a4de8$var$isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) return "".concat(prefixCls, "-placement-").concat(placement);
    }
    return "";
}

});

parcelRegister("3DHrI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a66b719424b0269$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $lv6ip = parcelRequire("lv6ip");

var $CZyex = parcelRequire("CZyex");

var $ccQt4 = parcelRequire("ccQt4");

var $jbmdS = parcelRequire("jbmdS");

var $FYXRo = parcelRequire("FYXRo");

var $feNlh = parcelRequire("feNlh");

var $6zLMh = parcelRequire("6zLMh");

var $6xHzX = parcelRequire("6xHzX");
var $2a66b719424b0269$var$_excluded = [
    "visible",
    "mobile"
];
var $2a66b719424b0269$var$Popup = /*#__PURE__*/ $jbmdS.forwardRef(function(_ref, ref) {
    var visible = _ref.visible, mobile = _ref.mobile, props = (0, $ccQt4.default)(_ref, $2a66b719424b0269$var$_excluded);
    var _useState = (0, $jbmdS.useState)(visible), _useState2 = (0, $CZyex.default)(_useState, 2), innerVisible = _useState2[0], serInnerVisible = _useState2[1];
    var _useState3 = (0, $jbmdS.useState)(false), _useState4 = (0, $CZyex.default)(_useState3, 2), inMobile = _useState4[0], setInMobile = _useState4[1];
    var cloneProps = (0, $lv6ip.default)((0, $lv6ip.default)({}, props), {}, {
        visible: innerVisible
    }); // We check mobile in visible changed here.
    // And this also delay set `innerVisible` to avoid popup component render flash
    (0, $jbmdS.useEffect)(function() {
        serInnerVisible(visible);
        if (visible && mobile) setInMobile((0, $FYXRo.default)());
    }, [
        visible,
        mobile
    ]);
    var popupNode = inMobile ? /*#__PURE__*/ $jbmdS.createElement((0, $6xHzX.default), (0, $7i29i.default)({}, cloneProps, {
        mobile: mobile,
        ref: ref
    })) : /*#__PURE__*/ $jbmdS.createElement((0, $6zLMh.default), (0, $7i29i.default)({}, cloneProps, {
        ref: ref
    })); // We can use fragment directly but this may failed some selector usage. Keep as origin logic
    return /*#__PURE__*/ $jbmdS.createElement("div", null, /*#__PURE__*/ $jbmdS.createElement((0, $feNlh.default), cloneProps), popupNode);
});
$2a66b719424b0269$var$Popup.displayName = "Popup";
var $2a66b719424b0269$export$2e2bcd8739ae039 = $2a66b719424b0269$var$Popup;

});
parcelRegister("feNlh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b17e7022ae2b398e$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $lv6ip = parcelRequire("lv6ip");

var $jbmdS = parcelRequire("jbmdS");

var $02LyB = parcelRequire("02LyB");

var $jGjXd = parcelRequire("jGjXd");

var $cdxIF = parcelRequire("cdxIF");
function $b17e7022ae2b398e$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, visible = props.visible, zIndex = props.zIndex, mask = props.mask, maskMotion = props.maskMotion, maskAnimation = props.maskAnimation, maskTransitionName = props.maskTransitionName;
    if (!mask) return null;
    var motion = {};
    if (maskMotion || maskTransitionName || maskAnimation) motion = (0, $lv6ip.default)({
        motionAppear: true
    }, (0, $cdxIF.getMotion)({
        motion: maskMotion,
        prefixCls: prefixCls,
        transitionName: maskTransitionName,
        animation: maskAnimation
    }));
    return /*#__PURE__*/ $jbmdS.createElement((0, $jGjXd.default), (0, $7i29i.default)({}, motion, {
        visible: visible,
        removeOnLeave: true
    }), function(_ref) {
        var className = _ref.className;
        return /*#__PURE__*/ $jbmdS.createElement("div", {
            style: {
                zIndex: zIndex
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("".concat(prefixCls, "-mask"), className)
        });
    });
}

});
parcelRegister("cdxIF", function(module, exports) {

$parcel$export(module.exports, "getMotion", function () { return $8e50daea3fb30b50$export$7b8936ddc277a29a; });
function $8e50daea3fb30b50$export$7b8936ddc277a29a(_ref) {
    var prefixCls = _ref.prefixCls, motion = _ref.motion, animation = _ref.animation, transitionName = _ref.transitionName;
    if (motion) return motion;
    if (animation) return {
        motionName: "".concat(prefixCls, "-").concat(animation)
    };
    if (transitionName) return {
        motionName: transitionName
    };
    return null;
}

});


parcelRegister("6zLMh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c9b129dcb3959af$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $lv6ip = parcelRequire("lv6ip");

var $CZyex = parcelRequire("CZyex");

var $jbmdS = parcelRequire("jbmdS");

var $gBqJM = parcelRequire("gBqJM");

var $iDOLX = parcelRequire("iDOLX");

var $jGjXd = parcelRequire("jGjXd");

var $02LyB = parcelRequire("02LyB");

var $3XKrl = parcelRequire("3XKrl");

var $cdxIF = parcelRequire("cdxIF");

var $7pBGC = parcelRequire("7pBGC");
var $4c9b129dcb3959af$var$PopupInner = /*#__PURE__*/ $jbmdS.forwardRef(function(props, ref) {
    var visible = props.visible, prefixCls = props.prefixCls, className = props.className, style = props.style, children = props.children, zIndex = props.zIndex, stretch = props.stretch, destroyPopupOnHide = props.destroyPopupOnHide, forceRender = props.forceRender, align = props.align, point = props.point, getRootDomNode = props.getRootDomNode, getClassNameFromAlign = props.getClassNameFromAlign, onAlign = props.onAlign, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onMouseDown = props.onMouseDown, onTouchStart = props.onTouchStart, onClick = props.onClick;
    var alignRef = (0, $jbmdS.useRef)();
    var elementRef = (0, $jbmdS.useRef)();
    var _useState = (0, $jbmdS.useState)(), _useState2 = (0, $CZyex.default)(_useState, 2), alignedClassName = _useState2[0], setAlignedClassName = _useState2[1]; // ======================= Measure ========================
    var _useStretchStyle = (0, $7pBGC.default)(stretch), _useStretchStyle2 = (0, $CZyex.default)(_useStretchStyle, 2), stretchStyle = _useStretchStyle2[0], measureStretchStyle = _useStretchStyle2[1];
    function doMeasure() {
        if (stretch) measureStretchStyle(getRootDomNode());
    } // ======================== Status ========================
    var _useVisibleStatus = (0, $3XKrl.default)(visible, doMeasure), _useVisibleStatus2 = (0, $CZyex.default)(_useVisibleStatus, 2), status = _useVisibleStatus2[0], goNextStatus = _useVisibleStatus2[1]; // ======================== Aligns ========================
    /**
   * `alignedClassName` may modify `source` size,
   * which means one time align may not move to the correct position at once.
   *
   * We will reset `alignTimes` for each status switch to `alignPre`
   * and let `rc-align` to align for multiple times to ensure get final stable place.
   * Currently we mark `alignTimes < 2` repeat align, it will increase if user report for align issue.
   * 
   * Update:
   * In React 18. `rc-align` effect of align may faster than ref called trigger `forceAlign`.
   * We adjust this to `alignTimes < 2`.
   * We need refactor `rc-align` to support mark of `forceAlign` call if this still happen.
   */ var _useState3 = (0, $jbmdS.useState)(0), _useState4 = (0, $CZyex.default)(_useState3, 2), alignTimes = _useState4[0], setAlignTimes = _useState4[1];
    var prepareResolveRef = (0, $jbmdS.useRef)();
    (0, $iDOLX.default)(function() {
        if (status === "alignPre") setAlignTimes(0);
    }, [
        status
    ]); // `target` on `rc-align` can accept as a function to get the bind element or a point.
    // ref: https://www.npmjs.com/package/rc-align
    function getAlignTarget() {
        if (point) return point;
        return getRootDomNode;
    }
    function forceAlign() {
        var _alignRef$current;
        (_alignRef$current = alignRef.current) === null || _alignRef$current === void 0 || _alignRef$current.forceAlign();
    }
    function onInternalAlign(popupDomNode, matchAlign) {
        var nextAlignedClassName = getClassNameFromAlign(matchAlign);
        if (alignedClassName !== nextAlignedClassName) setAlignedClassName(nextAlignedClassName);
         // We will retry multi times to make sure that the element has been align in the right position.
        setAlignTimes(function(val) {
            return val + 1;
        });
        if (status === "align") onAlign === null || onAlign === void 0 || onAlign(popupDomNode, matchAlign);
    } // Delay to go to next status
    (0, $iDOLX.default)(function() {
        if (status === "align") {
            // Repeat until not more align needed
            if (alignTimes < 3) forceAlign();
            else goNextStatus(function() {
                var _prepareResolveRef$cu;
                (_prepareResolveRef$cu = prepareResolveRef.current) === null || _prepareResolveRef$cu === void 0 || _prepareResolveRef$cu.call(prepareResolveRef);
            });
        }
    }, [
        alignTimes
    ]); // ======================== Motion ========================
    var motion = (0, $lv6ip.default)({}, (0, $cdxIF.getMotion)(props));
    [
        "onAppearEnd",
        "onEnterEnd",
        "onLeaveEnd"
    ].forEach(function(eventName) {
        var originHandler = motion[eventName];
        motion[eventName] = function(element, event) {
            goNextStatus();
            return originHandler === null || originHandler === void 0 ? void 0 : originHandler(element, event);
        };
    });
    function onShowPrepare() {
        return new Promise(function(resolve) {
            prepareResolveRef.current = resolve;
        });
    } // Go to stable directly when motion not provided
    $jbmdS.useEffect(function() {
        if (!motion.motionName && status === "motion") goNextStatus();
    }, [
        motion.motionName,
        status
    ]); // ========================= Refs =========================
    $jbmdS.useImperativeHandle(ref, function() {
        return {
            forceAlign: forceAlign,
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    }); // ======================== Render ========================
    var mergedStyle = (0, $lv6ip.default)((0, $lv6ip.default)({}, stretchStyle), {}, {
        zIndex: zIndex,
        opacity: status === "motion" || status === "stable" || !visible ? undefined : 0,
        // Cannot interact with disappearing elements
        // https://github.com/ant-design/ant-design/issues/35051#issuecomment-1101340714
        pointerEvents: !visible && status !== "stable" ? "none" : undefined
    }, style); // Align status
    var alignDisabled = true;
    if (align !== null && align !== void 0 && align.points && (status === "align" || status === "stable")) alignDisabled = false;
    var childNode = children; // Wrapper when multiple children
    if ($jbmdS.Children.count(children) > 1) childNode = /*#__PURE__*/ $jbmdS.createElement("div", {
        className: "".concat(prefixCls, "-content")
    }, children);
    return /*#__PURE__*/ $jbmdS.createElement((0, $jGjXd.default), (0, $7i29i.default)({
        visible: visible,
        ref: elementRef,
        leavedClassName: "".concat(prefixCls, "-hidden")
    }, motion, {
        onAppearPrepare: onShowPrepare,
        onEnterPrepare: onShowPrepare,
        removeOnLeave: destroyPopupOnHide,
        forceRender: forceRender
    }), function(_ref, motionRef) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(prefixCls, className, alignedClassName, motionClassName);
        return /*#__PURE__*/ $jbmdS.createElement((0, $gBqJM.default), {
            target: getAlignTarget(),
            key: "popup",
            ref: alignRef,
            monitorWindowResize: true,
            disabled: alignDisabled,
            align: align,
            onAlign: onInternalAlign
        }, /*#__PURE__*/ $jbmdS.createElement("div", {
            ref: motionRef,
            className: mergedClassName,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onMouseDownCapture: onMouseDown,
            onTouchStartCapture: onTouchStart,
            onClick: onClick,
            style: (0, $lv6ip.default)((0, $lv6ip.default)({}, motionStyle), mergedStyle)
        }, childNode));
    });
});
$4c9b129dcb3959af$var$PopupInner.displayName = "PopupInner";
var $4c9b129dcb3959af$export$2e2bcd8739ae039 = $4c9b129dcb3959af$var$PopupInner;

});
parcelRegister("gBqJM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c164d7830e4eb5d9$export$2e2bcd8739ae039; });
// export this package's api

var $7JfIv = parcelRequire("7JfIv");
var $c164d7830e4eb5d9$export$2e2bcd8739ae039 = (0, $7JfIv.default);

});
parcelRegister("7JfIv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a08ed6a350982c9$export$2e2bcd8739ae039; });

var $CZyex = parcelRequire("CZyex");

var $jncUt = parcelRequire("jncUt");

var $2txzn = parcelRequire("2txzn");

var $2BNx7 = parcelRequire("2BNx7");

var $j12Lu = parcelRequire("j12Lu");

var $4vIiM = parcelRequire("4vIiM");

var $iDOLX = parcelRequire("iDOLX");

var $aKVEK = parcelRequire("aKVEK");

var $jbmdS = parcelRequire("jbmdS");

var $6lf6I = parcelRequire("6lf6I");

var $jbSiP = parcelRequire("jbSiP");
function $5a08ed6a350982c9$var$getElement(func) {
    if (typeof func !== "function") return null;
    return func();
}
function $5a08ed6a350982c9$var$getPoint(point) {
    if ((0, $jncUt.default)(point) !== "object" || !point) return null;
    return point;
}
var $5a08ed6a350982c9$var$Align = function Align(_ref, ref) {
    var children = _ref.children, disabled = _ref.disabled, target = _ref.target, align = _ref.align, onAlign = _ref.onAlign, monitorWindowResize = _ref.monitorWindowResize, _ref$monitorBufferTim = _ref.monitorBufferTime, monitorBufferTime = _ref$monitorBufferTim === void 0 ? 0 : _ref$monitorBufferTim;
    var cacheRef = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useRef({});
    /** Popup node ref */ var nodeRef = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useRef();
    var childNode = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).Children.only(children); // ===================== Align ======================
    // We save the props here to avoid closure makes props ood
    var forceAlignPropsRef = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useRef({});
    forceAlignPropsRef.current.disabled = disabled;
    forceAlignPropsRef.current.target = target;
    forceAlignPropsRef.current.align = align;
    forceAlignPropsRef.current.onAlign = onAlign;
    var _useBuffer = (0, $6lf6I.default)(function() {
        var _forceAlignPropsRef$c = forceAlignPropsRef.current, latestDisabled = _forceAlignPropsRef$c.disabled, latestTarget = _forceAlignPropsRef$c.target, latestAlign = _forceAlignPropsRef$c.align, latestOnAlign = _forceAlignPropsRef$c.onAlign;
        var source = nodeRef.current;
        if (!latestDisabled && latestTarget && source) {
            var _result;
            var _element = $5a08ed6a350982c9$var$getElement(latestTarget);
            var _point = $5a08ed6a350982c9$var$getPoint(latestTarget);
            cacheRef.current.element = _element;
            cacheRef.current.point = _point;
            cacheRef.current.align = latestAlign; // IE lose focus after element realign
            // We should record activeElement and restore later
            var _document = document, activeElement = _document.activeElement; // We only align when element is visible
            if (_element && (0, $4vIiM.default)(_element)) _result = (0, $2txzn.alignElement)(source, _element, latestAlign);
            else if (_point) _result = (0, $2txzn.alignPoint)(source, _point, latestAlign);
            (0, $jbSiP.restoreFocus)(activeElement, source);
            if (latestOnAlign && _result) latestOnAlign(source, _result);
            return true;
        }
        return false;
    }, monitorBufferTime), _useBuffer2 = (0, $CZyex.default)(_useBuffer, 2), _forceAlign = _useBuffer2[0], cancelForceAlign = _useBuffer2[1]; // ===================== Effect =====================
    // Handle props change
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useState(), _React$useState2 = (0, $CZyex.default)(_React$useState, 2), element = _React$useState2[0], setElement = _React$useState2[1];
    var _React$useState3 = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useState(), _React$useState4 = (0, $CZyex.default)(_React$useState3, 2), point = _React$useState4[0], setPoint = _React$useState4[1];
    (0, $iDOLX.default)(function() {
        setElement($5a08ed6a350982c9$var$getElement(target));
        setPoint($5a08ed6a350982c9$var$getPoint(target));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useEffect(function() {
        if (cacheRef.current.element !== element || !(0, $jbSiP.isSamePoint)(cacheRef.current.point, point) || !(0, $2BNx7.default)(cacheRef.current.align, align)) _forceAlign();
    }); // Watch popup element resize
    (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useEffect(function() {
        var cancelFn = (0, $jbSiP.monitorResize)(nodeRef.current, _forceAlign);
        return cancelFn;
    }, [
        nodeRef.current
    ]); // Watch target element resize
    (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useEffect(function() {
        var cancelFn = (0, $jbSiP.monitorResize)(element, _forceAlign);
        return cancelFn;
    }, [
        element
    ]); // Listen for disabled change
    (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useEffect(function() {
        if (!disabled) _forceAlign();
        else cancelForceAlign();
    }, [
        disabled
    ]); // Listen for window resize
    (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useEffect(function() {
        if (monitorWindowResize) {
            var cancelFn = (0, $j12Lu.default)(window, "resize", _forceAlign);
            return cancelFn.remove;
        }
    }, [
        monitorWindowResize
    ]); // Clear all if unmount
    (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useEffect(function() {
        return function() {
            cancelForceAlign();
        };
    }, []); // ====================== Ref =======================
    (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useImperativeHandle(ref, function() {
        return {
            forceAlign: function forceAlign() {
                return _forceAlign(true);
            }
        };
    }); // ===================== Render =====================
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).isValidElement(childNode)) childNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).cloneElement(childNode, {
        ref: (0, $aKVEK.composeRef)(childNode.ref, nodeRef)
    });
    return childNode;
};
var $5a08ed6a350982c9$var$RcAlign = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).forwardRef($5a08ed6a350982c9$var$Align);
$5a08ed6a350982c9$var$RcAlign.displayName = "Align";
var $5a08ed6a350982c9$export$2e2bcd8739ae039 = $5a08ed6a350982c9$var$RcAlign;

});
parcelRegister("2txzn", function(module, exports) {

$parcel$export(module.exports, "alignElement", function () { return $1cd85473031aaa94$export$ec21431d5ee6c534; });
$parcel$export(module.exports, "alignPoint", function () { return $1cd85473031aaa94$export$38f0e12f0aa28098; });
function $1cd85473031aaa94$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1cd85473031aaa94$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $1cd85473031aaa94$var$ownKeys(Object(source), !0).forEach(function(key) {
            $1cd85473031aaa94$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $1cd85473031aaa94$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1cd85473031aaa94$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $1cd85473031aaa94$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $1cd85473031aaa94$var$_typeof(obj);
}
function $1cd85473031aaa94$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $1cd85473031aaa94$var$vendorPrefix;
var $1cd85473031aaa94$var$jsCssMap = {
    Webkit: "-webkit-",
    Moz: "-moz-",
    // IE did it wrong again ...
    ms: "-ms-",
    O: "-o-"
};
function $1cd85473031aaa94$var$getVendorPrefix() {
    if ($1cd85473031aaa94$var$vendorPrefix !== undefined) return $1cd85473031aaa94$var$vendorPrefix;
    $1cd85473031aaa94$var$vendorPrefix = "";
    var style = document.createElement("p").style;
    var testProp = "Transform";
    for(var key in $1cd85473031aaa94$var$jsCssMap)if (key + testProp in style) $1cd85473031aaa94$var$vendorPrefix = key;
    return $1cd85473031aaa94$var$vendorPrefix;
}
function $1cd85473031aaa94$var$getTransitionName() {
    return $1cd85473031aaa94$var$getVendorPrefix() ? "".concat($1cd85473031aaa94$var$getVendorPrefix(), "TransitionProperty") : "transitionProperty";
}
function $1cd85473031aaa94$var$getTransformName() {
    return $1cd85473031aaa94$var$getVendorPrefix() ? "".concat($1cd85473031aaa94$var$getVendorPrefix(), "Transform") : "transform";
}
function $1cd85473031aaa94$var$setTransitionProperty(node, value) {
    var name = $1cd85473031aaa94$var$getTransitionName();
    if (name) {
        node.style[name] = value;
        if (name !== "transitionProperty") node.style.transitionProperty = value;
    }
}
function $1cd85473031aaa94$var$setTransform(node, value) {
    var name = $1cd85473031aaa94$var$getTransformName();
    if (name) {
        node.style[name] = value;
        if (name !== "transform") node.style.transform = value;
    }
}
function $1cd85473031aaa94$var$getTransitionProperty(node) {
    return node.style.transitionProperty || node.style[$1cd85473031aaa94$var$getTransitionName()];
}
function $1cd85473031aaa94$var$getTransformXY(node) {
    var style = window.getComputedStyle(node, null);
    var transform = style.getPropertyValue("transform") || style.getPropertyValue($1cd85473031aaa94$var$getTransformName());
    if (transform && transform !== "none") {
        var matrix = transform.replace(/[^0-9\-.,]/g, "").split(",");
        return {
            x: parseFloat(matrix[12] || matrix[4], 0),
            y: parseFloat(matrix[13] || matrix[5], 0)
        };
    }
    return {
        x: 0,
        y: 0
    };
}
var $1cd85473031aaa94$var$matrix2d = /matrix\((.*)\)/;
var $1cd85473031aaa94$var$matrix3d = /matrix3d\((.*)\)/;
function $1cd85473031aaa94$var$setTransformXY(node, xy) {
    var style = window.getComputedStyle(node, null);
    var transform = style.getPropertyValue("transform") || style.getPropertyValue($1cd85473031aaa94$var$getTransformName());
    if (transform && transform !== "none") {
        var arr;
        var match2d = transform.match($1cd85473031aaa94$var$matrix2d);
        if (match2d) {
            match2d = match2d[1];
            arr = match2d.split(",").map(function(item) {
                return parseFloat(item, 10);
            });
            arr[4] = xy.x;
            arr[5] = xy.y;
            $1cd85473031aaa94$var$setTransform(node, "matrix(".concat(arr.join(","), ")"));
        } else {
            var match3d = transform.match($1cd85473031aaa94$var$matrix3d)[1];
            arr = match3d.split(",").map(function(item) {
                return parseFloat(item, 10);
            });
            arr[12] = xy.x;
            arr[13] = xy.y;
            $1cd85473031aaa94$var$setTransform(node, "matrix3d(".concat(arr.join(","), ")"));
        }
    } else $1cd85473031aaa94$var$setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
}
var $1cd85473031aaa94$var$RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
var $1cd85473031aaa94$var$getComputedStyleX;
// https://stackoverflow.com/a/3485654/3040605
function $1cd85473031aaa94$var$forceRelayout(elem) {
    var originalStyle = elem.style.display;
    elem.style.display = "none";
    elem.offsetHeight; // eslint-disable-line
    elem.style.display = originalStyle;
}
function $1cd85473031aaa94$var$css(el, name, v) {
    var value = v;
    if ($1cd85473031aaa94$var$_typeof(name) === "object") {
        for(var i in name)if (name.hasOwnProperty(i)) $1cd85473031aaa94$var$css(el, i, name[i]);
        return undefined;
    }
    if (typeof value !== "undefined") {
        if (typeof value === "number") value = "".concat(value, "px");
        el.style[name] = value;
        return undefined;
    }
    return $1cd85473031aaa94$var$getComputedStyleX(el, name);
}
function $1cd85473031aaa94$var$getClientPosition(elem) {
    var box;
    var x;
    var y;
    var doc = elem.ownerDocument;
    var body = doc.body;
    var docElem = doc && doc.documentElement;
    // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
    box = elem.getBoundingClientRect();
    // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
    // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
    // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin
    x = Math.floor(box.left);
    y = Math.floor(box.top);
    // In IE, most of the time, 2 extra pixels are added to the top and left
    // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
    // IE6 standards mode, this border can be overridden by setting the
    // document element's border to zero -- thus, we cannot rely on the
    // offset always being 2 pixels.
    // In quirks mode, the offset can be determined by querying the body's
    // clientLeft/clientTop, but in standards mode, it is found by querying
    // the document element's clientLeft/clientTop.  Since we already called
    // getClientBoundingRect we have already forced a reflow, so it is not
    // too expensive just to query them all.
    // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
    // 窗口边框标准是设 documentElement ,quirks 时设置 body
    // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
    // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
    // 标准 ie 下 docElem.clientTop 就是 border-top
    // ie7 html 即窗口边框改变不了。永远为 2
    // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0
    x -= docElem.clientLeft || body.clientLeft || 0;
    y -= docElem.clientTop || body.clientTop || 0;
    return {
        left: x,
        top: y
    };
}
function $1cd85473031aaa94$var$getScroll(w, top) {
    var ret = w["page".concat(top ? "Y" : "X", "Offset")];
    var method = "scroll".concat(top ? "Top" : "Left");
    if (typeof ret !== "number") {
        var d = w.document;
        // ie6,7,8 standard mode
        ret = d.documentElement[method];
        if (typeof ret !== "number") // quirks mode
        ret = d.body[method];
    }
    return ret;
}
function $1cd85473031aaa94$var$getScrollLeft(w) {
    return $1cd85473031aaa94$var$getScroll(w);
}
function $1cd85473031aaa94$var$getScrollTop(w) {
    return $1cd85473031aaa94$var$getScroll(w, true);
}
function $1cd85473031aaa94$var$getOffset(el) {
    var pos = $1cd85473031aaa94$var$getClientPosition(el);
    var doc = el.ownerDocument;
    var w = doc.defaultView || doc.parentWindow;
    pos.left += $1cd85473031aaa94$var$getScrollLeft(w);
    pos.top += $1cd85473031aaa94$var$getScrollTop(w);
    return pos;
}
/**
 * A crude way of determining if an object is a window
 * @member util
 */ function $1cd85473031aaa94$var$isWindow(obj) {
    // must use == for ie8
    /* eslint eqeqeq:0 */ return obj !== null && obj !== undefined && obj == obj.window;
}
function $1cd85473031aaa94$var$getDocument(node) {
    if ($1cd85473031aaa94$var$isWindow(node)) return node.document;
    if (node.nodeType === 9) return node;
    return node.ownerDocument;
}
function $1cd85473031aaa94$var$_getComputedStyle(elem, name, cs) {
    var computedStyle = cs;
    var val = "";
    var d = $1cd85473031aaa94$var$getDocument(elem);
    computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);
    // https://github.com/kissyteam/kissy/issues/61
    if (computedStyle) val = computedStyle.getPropertyValue(name) || computedStyle[name];
    return val;
}
var $1cd85473031aaa94$var$_RE_NUM_NO_PX = new RegExp("^(".concat($1cd85473031aaa94$var$RE_NUM, ")(?!px)[a-z%]+$"), "i");
var $1cd85473031aaa94$var$RE_POS = /^(top|right|bottom|left)$/;
var $1cd85473031aaa94$var$CURRENT_STYLE = "currentStyle";
var $1cd85473031aaa94$var$RUNTIME_STYLE = "runtimeStyle";
var $1cd85473031aaa94$var$LEFT = "left";
var $1cd85473031aaa94$var$PX = "px";
function $1cd85473031aaa94$var$_getComputedStyleIE(elem, name) {
    // currentStyle maybe null
    // http://msdn.microsoft.com/en-us/library/ms535231.aspx
    var ret = elem[$1cd85473031aaa94$var$CURRENT_STYLE] && elem[$1cd85473031aaa94$var$CURRENT_STYLE][name];
    // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
    // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
    // 在 ie 下不对，需要直接用 offset 方式
    // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
    // From the awesome hack by Dean Edwards
    // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
    // If we're not dealing with a regular pixel number
    // but a number that has a weird ending, we need to convert it to pixels
    // exclude left right for relativity
    if ($1cd85473031aaa94$var$_RE_NUM_NO_PX.test(ret) && !$1cd85473031aaa94$var$RE_POS.test(name)) {
        // Remember the original values
        var style = elem.style;
        var left = style[$1cd85473031aaa94$var$LEFT];
        var rsLeft = elem[$1cd85473031aaa94$var$RUNTIME_STYLE][$1cd85473031aaa94$var$LEFT];
        // prevent flashing of content
        elem[$1cd85473031aaa94$var$RUNTIME_STYLE][$1cd85473031aaa94$var$LEFT] = elem[$1cd85473031aaa94$var$CURRENT_STYLE][$1cd85473031aaa94$var$LEFT];
        // Put in the new values to get a computed value out
        style[$1cd85473031aaa94$var$LEFT] = name === "fontSize" ? "1em" : ret || 0;
        ret = style.pixelLeft + $1cd85473031aaa94$var$PX;
        // Revert the changed values
        style[$1cd85473031aaa94$var$LEFT] = left;
        elem[$1cd85473031aaa94$var$RUNTIME_STYLE][$1cd85473031aaa94$var$LEFT] = rsLeft;
    }
    return ret === "" ? "auto" : ret;
}
if (typeof window !== "undefined") $1cd85473031aaa94$var$getComputedStyleX = window.getComputedStyle ? $1cd85473031aaa94$var$_getComputedStyle : $1cd85473031aaa94$var$_getComputedStyleIE;
function $1cd85473031aaa94$var$getOffsetDirection(dir, option) {
    if (dir === "left") return option.useCssRight ? "right" : dir;
    return option.useCssBottom ? "bottom" : dir;
}
function $1cd85473031aaa94$var$oppositeOffsetDirection(dir) {
    if (dir === "left") return "right";
    else if (dir === "right") return "left";
    else if (dir === "top") return "bottom";
    else if (dir === "bottom") return "top";
}
// 设置 elem 相对 elem.ownerDocument 的坐标
function $1cd85473031aaa94$var$setLeftTop(elem, offset, option) {
    // set position first, in-case top/left are set even on static elem
    if ($1cd85473031aaa94$var$css(elem, "position") === "static") elem.style.position = "relative";
    var presetH = -999;
    var presetV = -999;
    var horizontalProperty = $1cd85473031aaa94$var$getOffsetDirection("left", option);
    var verticalProperty = $1cd85473031aaa94$var$getOffsetDirection("top", option);
    var oppositeHorizontalProperty = $1cd85473031aaa94$var$oppositeOffsetDirection(horizontalProperty);
    var oppositeVerticalProperty = $1cd85473031aaa94$var$oppositeOffsetDirection(verticalProperty);
    if (horizontalProperty !== "left") presetH = 999;
    if (verticalProperty !== "top") presetV = 999;
    var originalTransition = "";
    var originalOffset = $1cd85473031aaa94$var$getOffset(elem);
    if ("left" in offset || "top" in offset) {
        originalTransition = $1cd85473031aaa94$var$getTransitionProperty(elem) || "";
        $1cd85473031aaa94$var$setTransitionProperty(elem, "none");
    }
    if ("left" in offset) {
        elem.style[oppositeHorizontalProperty] = "";
        elem.style[horizontalProperty] = "".concat(presetH, "px");
    }
    if ("top" in offset) {
        elem.style[oppositeVerticalProperty] = "";
        elem.style[verticalProperty] = "".concat(presetV, "px");
    }
    // force relayout
    $1cd85473031aaa94$var$forceRelayout(elem);
    var old = $1cd85473031aaa94$var$getOffset(elem);
    var originalStyle = {};
    for(var key in offset)if (offset.hasOwnProperty(key)) {
        var dir = $1cd85473031aaa94$var$getOffsetDirection(key, option);
        var preset = key === "left" ? presetH : presetV;
        var off = originalOffset[key] - old[key];
        if (dir === key) originalStyle[dir] = preset + off;
        else originalStyle[dir] = preset - off;
    }
    $1cd85473031aaa94$var$css(elem, originalStyle);
    // force relayout
    $1cd85473031aaa94$var$forceRelayout(elem);
    if ("left" in offset || "top" in offset) $1cd85473031aaa94$var$setTransitionProperty(elem, originalTransition);
    var ret = {};
    for(var _key in offset)if (offset.hasOwnProperty(_key)) {
        var _dir = $1cd85473031aaa94$var$getOffsetDirection(_key, option);
        var _off = offset[_key] - originalOffset[_key];
        if (_key === _dir) ret[_dir] = originalStyle[_dir] + _off;
        else ret[_dir] = originalStyle[_dir] - _off;
    }
    $1cd85473031aaa94$var$css(elem, ret);
}
function $1cd85473031aaa94$var$setTransform$1(elem, offset) {
    var originalOffset = $1cd85473031aaa94$var$getOffset(elem);
    var originalXY = $1cd85473031aaa94$var$getTransformXY(elem);
    var resultXY = {
        x: originalXY.x,
        y: originalXY.y
    };
    if ("left" in offset) resultXY.x = originalXY.x + offset.left - originalOffset.left;
    if ("top" in offset) resultXY.y = originalXY.y + offset.top - originalOffset.top;
    $1cd85473031aaa94$var$setTransformXY(elem, resultXY);
}
function $1cd85473031aaa94$var$setOffset(elem, offset, option) {
    if (option.ignoreShake) {
        var oriOffset = $1cd85473031aaa94$var$getOffset(elem);
        var oLeft = oriOffset.left.toFixed(0);
        var oTop = oriOffset.top.toFixed(0);
        var tLeft = offset.left.toFixed(0);
        var tTop = offset.top.toFixed(0);
        if (oLeft === tLeft && oTop === tTop) return;
    }
    if (option.useCssRight || option.useCssBottom) $1cd85473031aaa94$var$setLeftTop(elem, offset, option);
    else if (option.useCssTransform && $1cd85473031aaa94$var$getTransformName() in document.body.style) $1cd85473031aaa94$var$setTransform$1(elem, offset);
    else $1cd85473031aaa94$var$setLeftTop(elem, offset, option);
}
function $1cd85473031aaa94$var$each(arr, fn) {
    for(var i = 0; i < arr.length; i++)fn(arr[i]);
}
function $1cd85473031aaa94$var$isBorderBoxFn(elem) {
    return $1cd85473031aaa94$var$getComputedStyleX(elem, "boxSizing") === "border-box";
}
var $1cd85473031aaa94$var$BOX_MODELS = [
    "margin",
    "border",
    "padding"
];
var $1cd85473031aaa94$var$CONTENT_INDEX = -1;
var $1cd85473031aaa94$var$PADDING_INDEX = 2;
var $1cd85473031aaa94$var$BORDER_INDEX = 1;
var $1cd85473031aaa94$var$MARGIN_INDEX = 0;
function $1cd85473031aaa94$var$swap(elem, options, callback) {
    var old = {};
    var style = elem.style;
    var name;
    // Remember the old values, and insert the new ones
    for(name in options)if (options.hasOwnProperty(name)) {
        old[name] = style[name];
        style[name] = options[name];
    }
    callback.call(elem);
    // Revert the old values
    for(name in options)if (options.hasOwnProperty(name)) style[name] = old[name];
}
function $1cd85473031aaa94$var$getPBMWidth(elem, props, which) {
    var value = 0;
    var prop;
    var j;
    var i;
    for(j = 0; j < props.length; j++){
        prop = props[j];
        if (prop) for(i = 0; i < which.length; i++){
            var cssProp = void 0;
            if (prop === "border") cssProp = "".concat(prop).concat(which[i], "Width");
            else cssProp = prop + which[i];
            value += parseFloat($1cd85473031aaa94$var$getComputedStyleX(elem, cssProp)) || 0;
        }
    }
    return value;
}
var $1cd85473031aaa94$var$domUtils = {
    getParent: function getParent(element) {
        var parent = element;
        do if (parent.nodeType === 11 && parent.host) parent = parent.host;
        else parent = parent.parentNode;
        while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);
        return parent;
    }
};
$1cd85473031aaa94$var$each([
    "Width",
    "Height"
], function(name) {
    $1cd85473031aaa94$var$domUtils["doc".concat(name)] = function(refWin) {
        var d = refWin.document;
        return Math.max(// firefox chrome documentElement.scrollHeight< body.scrollHeight
        // ie standard mode : documentElement.scrollHeight> body.scrollHeight
        d.documentElement["scroll".concat(name)], // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
        d.body["scroll".concat(name)], $1cd85473031aaa94$var$domUtils["viewport".concat(name)](d));
    };
    $1cd85473031aaa94$var$domUtils["viewport".concat(name)] = function(win) {
        // pc browser includes scrollbar in window.innerWidth
        var prop = "client".concat(name);
        var doc = win.document;
        var body = doc.body;
        var documentElement = doc.documentElement;
        var documentElementProp = documentElement[prop];
        // 标准模式取 documentElement
        // backcompat 取 body
        return doc.compatMode === "CSS1Compat" && documentElementProp || body && body[prop] || documentElementProp;
    };
});
/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */ function $1cd85473031aaa94$var$getWH(elem, name, ex) {
    var extra = ex;
    if ($1cd85473031aaa94$var$isWindow(elem)) return name === "width" ? $1cd85473031aaa94$var$domUtils.viewportWidth(elem) : $1cd85473031aaa94$var$domUtils.viewportHeight(elem);
    else if (elem.nodeType === 9) return name === "width" ? $1cd85473031aaa94$var$domUtils.docWidth(elem) : $1cd85473031aaa94$var$domUtils.docHeight(elem);
    var which = name === "width" ? [
        "Left",
        "Right"
    ] : [
        "Top",
        "Bottom"
    ];
    var borderBoxValue = name === "width" ? Math.floor(elem.getBoundingClientRect().width) : Math.floor(elem.getBoundingClientRect().height);
    var isBorderBox = $1cd85473031aaa94$var$isBorderBoxFn(elem);
    var cssBoxValue = 0;
    if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
        borderBoxValue = undefined;
        // Fall back to computed then un computed css if necessary
        cssBoxValue = $1cd85473031aaa94$var$getComputedStyleX(elem, name);
        if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) cssBoxValue = elem.style[name] || 0;
        // Normalize '', auto, and prepare for extra
        cssBoxValue = Math.floor(parseFloat(cssBoxValue)) || 0;
    }
    if (extra === undefined) extra = isBorderBox ? $1cd85473031aaa94$var$BORDER_INDEX : $1cd85473031aaa94$var$CONTENT_INDEX;
    var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
    var val = borderBoxValue || cssBoxValue;
    if (extra === $1cd85473031aaa94$var$CONTENT_INDEX) {
        if (borderBoxValueOrIsBorderBox) return val - $1cd85473031aaa94$var$getPBMWidth(elem, [
            "border",
            "padding"
        ], which);
        return cssBoxValue;
    } else if (borderBoxValueOrIsBorderBox) {
        if (extra === $1cd85473031aaa94$var$BORDER_INDEX) return val;
        return val + (extra === $1cd85473031aaa94$var$PADDING_INDEX ? -$1cd85473031aaa94$var$getPBMWidth(elem, [
            "border"
        ], which) : $1cd85473031aaa94$var$getPBMWidth(elem, [
            "margin"
        ], which));
    }
    return cssBoxValue + $1cd85473031aaa94$var$getPBMWidth(elem, $1cd85473031aaa94$var$BOX_MODELS.slice(extra), which);
}
var $1cd85473031aaa94$var$cssShow = {
    position: "absolute",
    visibility: "hidden",
    display: "block"
};
// fix #119 : https://github.com/kissyteam/kissy/issues/119
function $1cd85473031aaa94$var$getWHIgnoreDisplay() {
    for(var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++)args[_key2] = arguments[_key2];
    var val;
    var elem = args[0];
    // in case elem is window
    // elem.offsetWidth === undefined
    if (elem.offsetWidth !== 0) val = $1cd85473031aaa94$var$getWH.apply(undefined, args);
    else $1cd85473031aaa94$var$swap(elem, $1cd85473031aaa94$var$cssShow, function() {
        val = $1cd85473031aaa94$var$getWH.apply(undefined, args);
    });
    return val;
}
$1cd85473031aaa94$var$each([
    "width",
    "height"
], function(name) {
    var first = name.charAt(0).toUpperCase() + name.slice(1);
    $1cd85473031aaa94$var$domUtils["outer".concat(first)] = function(el, includeMargin) {
        return el && $1cd85473031aaa94$var$getWHIgnoreDisplay(el, name, includeMargin ? $1cd85473031aaa94$var$MARGIN_INDEX : $1cd85473031aaa94$var$BORDER_INDEX);
    };
    var which = name === "width" ? [
        "Left",
        "Right"
    ] : [
        "Top",
        "Bottom"
    ];
    $1cd85473031aaa94$var$domUtils[name] = function(elem, v) {
        var val = v;
        if (val !== undefined) {
            if (elem) {
                var isBorderBox = $1cd85473031aaa94$var$isBorderBoxFn(elem);
                if (isBorderBox) val += $1cd85473031aaa94$var$getPBMWidth(elem, [
                    "padding",
                    "border"
                ], which);
                return $1cd85473031aaa94$var$css(elem, name, val);
            }
            return undefined;
        }
        return elem && $1cd85473031aaa94$var$getWHIgnoreDisplay(elem, name, $1cd85473031aaa94$var$CONTENT_INDEX);
    };
});
function $1cd85473031aaa94$var$mix(to, from) {
    for(var i in from)if (from.hasOwnProperty(i)) to[i] = from[i];
    return to;
}
var $1cd85473031aaa94$var$utils = {
    getWindow: function getWindow(node) {
        if (node && node.document && node.setTimeout) return node;
        var doc = node.ownerDocument || node;
        return doc.defaultView || doc.parentWindow;
    },
    getDocument: $1cd85473031aaa94$var$getDocument,
    offset: function offset(el, value, option) {
        if (typeof value !== "undefined") $1cd85473031aaa94$var$setOffset(el, value, option || {});
        else return $1cd85473031aaa94$var$getOffset(el);
    },
    isWindow: $1cd85473031aaa94$var$isWindow,
    each: $1cd85473031aaa94$var$each,
    css: $1cd85473031aaa94$var$css,
    clone: function clone(obj) {
        var i;
        var ret = {};
        for(i in obj)if (obj.hasOwnProperty(i)) ret[i] = obj[i];
        var overflow = obj.overflow;
        if (overflow) {
            for(i in obj)if (obj.hasOwnProperty(i)) ret.overflow[i] = obj.overflow[i];
        }
        return ret;
    },
    mix: $1cd85473031aaa94$var$mix,
    getWindowScrollLeft: function getWindowScrollLeft(w) {
        return $1cd85473031aaa94$var$getScrollLeft(w);
    },
    getWindowScrollTop: function getWindowScrollTop(w) {
        return $1cd85473031aaa94$var$getScrollTop(w);
    },
    merge: function merge() {
        var ret = {};
        for(var i = 0; i < arguments.length; i++)$1cd85473031aaa94$var$utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
        return ret;
    },
    viewportWidth: 0,
    viewportHeight: 0
};
$1cd85473031aaa94$var$mix($1cd85473031aaa94$var$utils, $1cd85473031aaa94$var$domUtils);
/**
 * 得到会导致元素显示不全的祖先元素
 */ var $1cd85473031aaa94$var$getParent = $1cd85473031aaa94$var$utils.getParent;
function $1cd85473031aaa94$var$getOffsetParent(element) {
    if ($1cd85473031aaa94$var$utils.isWindow(element) || element.nodeType === 9) return null;
    // ie 这个也不是完全可行
    /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */ // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
    //  In other browsers it only includes elements with position absolute, relative or
    // fixed, not elements with overflow set to auto or scroll.
    //        if (UA.ie && ieMode < 8) {
    //            return element.offsetParent;
    //        }
    // 统一的 offsetParent 方法
    var doc = $1cd85473031aaa94$var$utils.getDocument(element);
    var body = doc.body;
    var parent;
    var positionStyle = $1cd85473031aaa94$var$utils.css(element, "position");
    var skipStatic = positionStyle === "fixed" || positionStyle === "absolute";
    if (!skipStatic) return element.nodeName.toLowerCase() === "html" ? null : $1cd85473031aaa94$var$getParent(element);
    for(parent = $1cd85473031aaa94$var$getParent(element); parent && parent !== body && parent.nodeType !== 9; parent = $1cd85473031aaa94$var$getParent(parent)){
        positionStyle = $1cd85473031aaa94$var$utils.css(parent, "position");
        if (positionStyle !== "static") return parent;
    }
    return null;
}
var $1cd85473031aaa94$var$getParent$1 = $1cd85473031aaa94$var$utils.getParent;
function $1cd85473031aaa94$var$isAncestorFixed(element) {
    if ($1cd85473031aaa94$var$utils.isWindow(element) || element.nodeType === 9) return false;
    var doc = $1cd85473031aaa94$var$utils.getDocument(element);
    var body = doc.body;
    var parent = null;
    for(parent = $1cd85473031aaa94$var$getParent$1(element); // 修复元素位于 document.documentElement 下导致崩溃问题
    parent && parent !== body && parent !== doc; parent = $1cd85473031aaa94$var$getParent$1(parent)){
        var positionStyle = $1cd85473031aaa94$var$utils.css(parent, "position");
        if (positionStyle === "fixed") return true;
    }
    return false;
}
/**
 * 获得元素的显示部分的区域
 */ function $1cd85473031aaa94$var$getVisibleRectForElement(element, alwaysByViewport) {
    var visibleRect = {
        left: 0,
        right: Infinity,
        top: 0,
        bottom: Infinity
    };
    var el = $1cd85473031aaa94$var$getOffsetParent(element);
    var doc = $1cd85473031aaa94$var$utils.getDocument(element);
    var win = doc.defaultView || doc.parentWindow;
    var body = doc.body;
    var documentElement = doc.documentElement;
    // Determine the size of the visible rect by climbing the dom accounting for
    // all scrollable containers.
    while(el){
        // clientWidth is zero for inline block elements in ie.
        if ((navigator.userAgent.indexOf("MSIE") === -1 || el.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
        // viewport. In some browsers, el.offsetParent may be
        // document.documentElement, so check for that too.
        el !== body && el !== documentElement && $1cd85473031aaa94$var$utils.css(el, "overflow") !== "visible") {
            var pos = $1cd85473031aaa94$var$utils.offset(el);
            // add border
            pos.left += el.clientLeft;
            pos.top += el.clientTop;
            visibleRect.top = Math.max(visibleRect.top, pos.top);
            visibleRect.right = Math.min(visibleRect.right, // consider area without scrollBar
            pos.left + el.clientWidth);
            visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
            visibleRect.left = Math.max(visibleRect.left, pos.left);
        } else if (el === body || el === documentElement) break;
        el = $1cd85473031aaa94$var$getOffsetParent(el);
    }
    // Set element position to fixed
    // make sure absolute element itself don't affect it's visible area
    // https://github.com/ant-design/ant-design/issues/7601
    var originalPosition = null;
    if (!$1cd85473031aaa94$var$utils.isWindow(element) && element.nodeType !== 9) {
        originalPosition = element.style.position;
        var position = $1cd85473031aaa94$var$utils.css(element, "position");
        if (position === "absolute") element.style.position = "fixed";
    }
    var scrollX = $1cd85473031aaa94$var$utils.getWindowScrollLeft(win);
    var scrollY = $1cd85473031aaa94$var$utils.getWindowScrollTop(win);
    var viewportWidth = $1cd85473031aaa94$var$utils.viewportWidth(win);
    var viewportHeight = $1cd85473031aaa94$var$utils.viewportHeight(win);
    var documentWidth = documentElement.scrollWidth;
    var documentHeight = documentElement.scrollHeight;
    // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
    // We should cut this ourself.
    var bodyStyle = window.getComputedStyle(body);
    if (bodyStyle.overflowX === "hidden") documentWidth = win.innerWidth;
    if (bodyStyle.overflowY === "hidden") documentHeight = win.innerHeight;
    // Reset element position after calculate the visible area
    if (element.style) element.style.position = originalPosition;
    if (alwaysByViewport || $1cd85473031aaa94$var$isAncestorFixed(element)) {
        // Clip by viewport's size.
        visibleRect.left = Math.max(visibleRect.left, scrollX);
        visibleRect.top = Math.max(visibleRect.top, scrollY);
        visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
        visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
    } else {
        // Clip by document's size.
        var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
        visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
        var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
        visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
    }
    return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}
function $1cd85473031aaa94$var$adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
    var pos = $1cd85473031aaa94$var$utils.clone(elFuturePos);
    var size = {
        width: elRegion.width,
        height: elRegion.height
    };
    if (overflow.adjustX && pos.left < visibleRect.left) pos.left = visibleRect.left;
    // Left edge inside and right edge outside viewport, try to resize it.
    if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) size.width -= pos.left + size.width - visibleRect.right;
    // Right edge outside viewport, try to move it.
    if (overflow.adjustX && pos.left + size.width > visibleRect.right) // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
    // Top edge outside viewport, try to move it.
    if (overflow.adjustY && pos.top < visibleRect.top) pos.top = visibleRect.top;
    // Top edge inside and bottom edge outside viewport, try to resize it.
    if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) size.height -= pos.top + size.height - visibleRect.bottom;
    // Bottom edge outside viewport, try to move it.
    if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
    return $1cd85473031aaa94$var$utils.mix(pos, size);
}
function $1cd85473031aaa94$var$getRegion(node) {
    var offset;
    var w;
    var h;
    if (!$1cd85473031aaa94$var$utils.isWindow(node) && node.nodeType !== 9) {
        offset = $1cd85473031aaa94$var$utils.offset(node);
        w = $1cd85473031aaa94$var$utils.outerWidth(node);
        h = $1cd85473031aaa94$var$utils.outerHeight(node);
    } else {
        var win = $1cd85473031aaa94$var$utils.getWindow(node);
        offset = {
            left: $1cd85473031aaa94$var$utils.getWindowScrollLeft(win),
            top: $1cd85473031aaa94$var$utils.getWindowScrollTop(win)
        };
        w = $1cd85473031aaa94$var$utils.viewportWidth(win);
        h = $1cd85473031aaa94$var$utils.viewportHeight(win);
    }
    offset.width = w;
    offset.height = h;
    return offset;
}
/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */ function $1cd85473031aaa94$var$getAlignOffset(region, align) {
    var V = align.charAt(0);
    var H = align.charAt(1);
    var w = region.width;
    var h = region.height;
    var x = region.left;
    var y = region.top;
    if (V === "c") y += h / 2;
    else if (V === "b") y += h;
    if (H === "c") x += w / 2;
    else if (H === "r") x += w;
    return {
        left: x,
        top: y
    };
}
function $1cd85473031aaa94$var$getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
    var p1 = $1cd85473031aaa94$var$getAlignOffset(refNodeRegion, points[1]);
    var p2 = $1cd85473031aaa94$var$getAlignOffset(elRegion, points[0]);
    var diff = [
        p2.left - p1.left,
        p2.top - p1.top
    ];
    return {
        left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
        top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
    };
}
/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */ // http://yiminghe.iteye.com/blog/1124720
function $1cd85473031aaa94$var$isFailX(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}
function $1cd85473031aaa94$var$isFailY(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}
function $1cd85473031aaa94$var$isCompleteFailX(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}
function $1cd85473031aaa94$var$isCompleteFailY(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}
function $1cd85473031aaa94$var$flip(points, reg, map) {
    var ret = [];
    $1cd85473031aaa94$var$utils.each(points, function(p) {
        ret.push(p.replace(reg, function(m) {
            return map[m];
        }));
    });
    return ret;
}
function $1cd85473031aaa94$var$flipOffset(offset, index) {
    offset[index] = -offset[index];
    return offset;
}
function $1cd85473031aaa94$var$convertOffset(str, offsetLen) {
    var n;
    if (/%$/.test(str)) n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
    else n = parseInt(str, 10);
    return n || 0;
}
function $1cd85473031aaa94$var$normalizeOffset(offset, el) {
    offset[0] = $1cd85473031aaa94$var$convertOffset(offset[0], el.width);
    offset[1] = $1cd85473031aaa94$var$convertOffset(offset[1], el.height);
}
/**
 * @param el
 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
 * @param align
 */ function $1cd85473031aaa94$var$doAlign(el, tgtRegion, align, isTgtRegionVisible) {
    var points = align.points;
    var offset = align.offset || [
        0,
        0
    ];
    var targetOffset = align.targetOffset || [
        0,
        0
    ];
    var overflow = align.overflow;
    var source = align.source || el;
    offset = [].concat(offset);
    targetOffset = [].concat(targetOffset);
    overflow = overflow || {};
    var newOverflowCfg = {};
    var fail = 0;
    var alwaysByViewport = !!(overflow && overflow.alwaysByViewport);
    // 当前节点可以被放置的显示区域
    var visibleRect = $1cd85473031aaa94$var$getVisibleRectForElement(source, alwaysByViewport);
    // 当前节点所占的区域, left/top/width/height
    var elRegion = $1cd85473031aaa94$var$getRegion(source);
    // 将 offset 转换成数值，支持百分比
    $1cd85473031aaa94$var$normalizeOffset(offset, elRegion);
    $1cd85473031aaa94$var$normalizeOffset(targetOffset, tgtRegion);
    // 当前节点将要被放置的位置
    var elFuturePos = $1cd85473031aaa94$var$getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
    // 当前节点将要所处的区域
    var newElRegion = $1cd85473031aaa94$var$utils.merge(elRegion, elFuturePos);
    // 如果可视区域不能完全放置当前节点时允许调整
    if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
        if (overflow.adjustX) // 如果横向不能放下
        {
            if ($1cd85473031aaa94$var$isFailX(elFuturePos, elRegion, visibleRect)) {
                // 对齐位置反下
                var newPoints = $1cd85473031aaa94$var$flip(points, /[lr]/gi, {
                    l: "r",
                    r: "l"
                });
                // 偏移量也反下
                var newOffset = $1cd85473031aaa94$var$flipOffset(offset, 0);
                var newTargetOffset = $1cd85473031aaa94$var$flipOffset(targetOffset, 0);
                var newElFuturePos = $1cd85473031aaa94$var$getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);
                if (!$1cd85473031aaa94$var$isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
                    fail = 1;
                    points = newPoints;
                    offset = newOffset;
                    targetOffset = newTargetOffset;
                }
            }
        }
        if (overflow.adjustY) // 如果纵向不能放下
        {
            if ($1cd85473031aaa94$var$isFailY(elFuturePos, elRegion, visibleRect)) {
                // 对齐位置反下
                var _newPoints = $1cd85473031aaa94$var$flip(points, /[tb]/gi, {
                    t: "b",
                    b: "t"
                });
                // 偏移量也反下
                var _newOffset = $1cd85473031aaa94$var$flipOffset(offset, 1);
                var _newTargetOffset = $1cd85473031aaa94$var$flipOffset(targetOffset, 1);
                var _newElFuturePos = $1cd85473031aaa94$var$getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);
                if (!$1cd85473031aaa94$var$isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
                    fail = 1;
                    points = _newPoints;
                    offset = _newOffset;
                    targetOffset = _newTargetOffset;
                }
            }
        }
        // 如果失败，重新计算当前节点将要被放置的位置
        if (fail) {
            elFuturePos = $1cd85473031aaa94$var$getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
            $1cd85473031aaa94$var$utils.mix(newElRegion, elFuturePos);
        }
        var isStillFailX = $1cd85473031aaa94$var$isFailX(elFuturePos, elRegion, visibleRect);
        var isStillFailY = $1cd85473031aaa94$var$isFailY(elFuturePos, elRegion, visibleRect);
        // 检查反下后的位置是否可以放下了，如果仍然放不下：
        // 1. 复原修改过的定位参数
        if (isStillFailX || isStillFailY) {
            var _newPoints2 = points;
            // 重置对应部分的翻转逻辑
            if (isStillFailX) _newPoints2 = $1cd85473031aaa94$var$flip(points, /[lr]/gi, {
                l: "r",
                r: "l"
            });
            if (isStillFailY) _newPoints2 = $1cd85473031aaa94$var$flip(points, /[tb]/gi, {
                t: "b",
                b: "t"
            });
            points = _newPoints2;
            offset = align.offset || [
                0,
                0
            ];
            targetOffset = align.targetOffset || [
                0,
                0
            ];
        }
        // 2. 只有指定了可以调整当前方向才调整
        newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
        newOverflowCfg.adjustY = overflow.adjustY && isStillFailY;
        // 确实要调整，甚至可能会调整高度宽度
        if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) newElRegion = $1cd85473031aaa94$var$adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
    // need judge to in case set fixed with in css on height auto element
    if (newElRegion.width !== elRegion.width) $1cd85473031aaa94$var$utils.css(source, "width", $1cd85473031aaa94$var$utils.width(source) + newElRegion.width - elRegion.width);
    if (newElRegion.height !== elRegion.height) $1cd85473031aaa94$var$utils.css(source, "height", $1cd85473031aaa94$var$utils.height(source) + newElRegion.height - elRegion.height);
    // https://github.com/kissyteam/kissy/issues/190
    // 相对于屏幕位置没变，而 left/top 变了
    // 例如 <div 'relative'><el absolute></div>
    $1cd85473031aaa94$var$utils.offset(source, {
        left: newElRegion.left,
        top: newElRegion.top
    }, {
        useCssRight: align.useCssRight,
        useCssBottom: align.useCssBottom,
        useCssTransform: align.useCssTransform,
        ignoreShake: align.ignoreShake
    });
    return {
        points: points,
        offset: offset,
        targetOffset: targetOffset,
        overflow: newOverflowCfg
    };
}
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/ function $1cd85473031aaa94$var$isOutOfVisibleRect(target, alwaysByViewport) {
    var visibleRect = $1cd85473031aaa94$var$getVisibleRectForElement(target, alwaysByViewport);
    var targetRegion = $1cd85473031aaa94$var$getRegion(target);
    return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}
function $1cd85473031aaa94$export$ec21431d5ee6c534(el, refNode, align) {
    var target = align.target || refNode;
    var refNodeRegion = $1cd85473031aaa94$var$getRegion(target);
    var isTargetNotOutOfVisible = !$1cd85473031aaa94$var$isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
    return $1cd85473031aaa94$var$doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
}
$1cd85473031aaa94$export$ec21431d5ee6c534.__getOffsetParent = $1cd85473031aaa94$var$getOffsetParent;
$1cd85473031aaa94$export$ec21431d5ee6c534.__getVisibleRectForElement = $1cd85473031aaa94$var$getVisibleRectForElement;
/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */ function $1cd85473031aaa94$export$38f0e12f0aa28098(el, tgtPoint, align) {
    var pageX;
    var pageY;
    var doc = $1cd85473031aaa94$var$utils.getDocument(el);
    var win = doc.defaultView || doc.parentWindow;
    var scrollX = $1cd85473031aaa94$var$utils.getWindowScrollLeft(win);
    var scrollY = $1cd85473031aaa94$var$utils.getWindowScrollTop(win);
    var viewportWidth = $1cd85473031aaa94$var$utils.viewportWidth(win);
    var viewportHeight = $1cd85473031aaa94$var$utils.viewportHeight(win);
    if ("pageX" in tgtPoint) pageX = tgtPoint.pageX;
    else pageX = scrollX + tgtPoint.clientX;
    if ("pageY" in tgtPoint) pageY = tgtPoint.pageY;
    else pageY = scrollY + tgtPoint.clientY;
    var tgtRegion = {
        left: pageX,
        top: pageY,
        width: 0,
        height: 0
    };
    var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight;
    // Provide default target point
    var points = [
        align.points[0],
        "cc"
    ];
    return $1cd85473031aaa94$var$doAlign(el, tgtRegion, $1cd85473031aaa94$var$_objectSpread2($1cd85473031aaa94$var$_objectSpread2({}, align), {}, {
        points: points
    }), pointInView);
}
var $1cd85473031aaa94$export$2e2bcd8739ae039 = $1cd85473031aaa94$export$ec21431d5ee6c534;

});

parcelRegister("4vIiM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $348c6c1b491bfdcc$export$2e2bcd8739ae039; });
var $348c6c1b491bfdcc$export$2e2bcd8739ae039 = function(element) {
    if (!element) return false;
    if (element instanceof Element) {
        if (element.offsetParent) return true;
        if (element.getBBox) {
            var _getBBox = element.getBBox(), width = _getBBox.width, height = _getBBox.height;
            if (width || height) return true;
        }
        if (element.getBoundingClientRect) {
            var _element$getBoundingC = element.getBoundingClientRect(), _width = _element$getBoundingC.width, _height = _element$getBoundingC.height;
            if (_width || _height) return true;
        }
    }
    return false;
};

});

parcelRegister("6lf6I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49e06c3c547826c1$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");
var $49e06c3c547826c1$export$2e2bcd8739ae039 = function(callback, buffer) {
    var calledRef = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useRef(false);
    var timeoutRef = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useRef(null);
    function cancelTrigger() {
        window.clearTimeout(timeoutRef.current);
    }
    function trigger(force) {
        cancelTrigger();
        if (!calledRef.current || force === true) {
            if (callback(force) === false) // Not delay since callback cancelled self
            return;
            calledRef.current = true;
            timeoutRef.current = window.setTimeout(function() {
                calledRef.current = false;
            }, buffer);
        } else timeoutRef.current = window.setTimeout(function() {
            calledRef.current = false;
            trigger();
        }, buffer);
    }
    return [
        trigger,
        function() {
            calledRef.current = false;
            cancelTrigger();
        }
    ];
};

});

parcelRegister("jbSiP", function(module, exports) {

$parcel$export(module.exports, "isSamePoint", function () { return $df892acad98c6690$export$792a4d7b8e9efb33; });
$parcel$export(module.exports, "restoreFocus", function () { return $df892acad98c6690$export$2284e449d64b22d5; });
$parcel$export(module.exports, "monitorResize", function () { return $df892acad98c6690$export$f56787db9e74dfe; });

var $CZyex = parcelRequire("CZyex");

var $22BIt = parcelRequire("22BIt");

var $1sys4 = parcelRequire("1sys4");
function $df892acad98c6690$export$792a4d7b8e9efb33(prev, next) {
    if (prev === next) return true;
    if (!prev || !next) return false;
    if ("pageX" in next && "pageY" in next) return prev.pageX === next.pageX && prev.pageY === next.pageY;
    if ("clientX" in next && "clientY" in next) return prev.clientX === next.clientX && prev.clientY === next.clientY;
    return false;
}
function $df892acad98c6690$export$2284e449d64b22d5(activeElement, container) {
    // Focus back if is in the container
    if (activeElement !== document.activeElement && (0, $1sys4.default)(container, activeElement) && typeof activeElement.focus === "function") activeElement.focus();
}
function $df892acad98c6690$export$f56787db9e74dfe(element, callback) {
    var prevWidth = null;
    var prevHeight = null;
    function onResize(_ref) {
        var _ref2 = (0, $CZyex.default)(_ref, 1), target = _ref2[0].target;
        if (!document.documentElement.contains(target)) return;
        var _target$getBoundingCl = target.getBoundingClientRect(), width = _target$getBoundingCl.width, height = _target$getBoundingCl.height;
        var fixedWidth = Math.floor(width);
        var fixedHeight = Math.floor(height);
        if (prevWidth !== fixedWidth || prevHeight !== fixedHeight) // https://webkit.org/blog/9997/resizeobserver-in-webkit/
        Promise.resolve().then(function() {
            callback({
                width: fixedWidth,
                height: fixedHeight
            });
        });
        prevWidth = fixedWidth;
        prevHeight = fixedHeight;
    }
    var resizeObserver = new (0, $22BIt.default)(onResize);
    if (element) resizeObserver.observe(element);
    return function() {
        resizeObserver.disconnect();
    };
}

});



parcelRegister("3XKrl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e2ae7cac84df59f$export$2e2bcd8739ae039; });

var $9TNqp = parcelRequire("9TNqp");

var $raxj3 = parcelRequire("raxj3");

var $CZyex = parcelRequire("CZyex");

var $jbmdS = parcelRequire("jbmdS");

var $2iJQe = parcelRequire("2iJQe");

var $eRdwh = parcelRequire("eRdwh");
/**
 * Popup should follow the steps for each component work correctly:
 * measure - check for the current stretch size
 * align - let component align the position
 * aligned - re-align again in case additional className changed the size
 * afterAlign - choice next step is trigger motion or finished
 * beforeMotion - should reset motion to invisible so that CSSMotion can do normal motion
 * motion - play the motion
 * stable - everything is done
 */ var $2e2ae7cac84df59f$var$StatusQueue = [
    "measure",
    "alignPre",
    "align",
    null,
    "motion"
];
var $2e2ae7cac84df59f$export$2e2bcd8739ae039 = function(visible, doMeasure) {
    var _useState = (0, $eRdwh.default)(null), _useState2 = (0, $CZyex.default)(_useState, 2), status = _useState2[0], setInternalStatus = _useState2[1];
    var rafRef = (0, $jbmdS.useRef)();
    function setStatus(nextStatus) {
        setInternalStatus(nextStatus, true);
    }
    function cancelRaf() {
        (0, $2iJQe.default).cancel(rafRef.current);
    }
    function goNextStatus(callback) {
        cancelRaf();
        rafRef.current = (0, $2iJQe.default)(function() {
            // Only align should be manually trigger
            setStatus(function(prev) {
                switch(status){
                    case "align":
                        return "motion";
                    case "motion":
                        return "stable";
                    default:
                }
                return prev;
            });
            callback === null || callback === void 0 || callback();
        });
    } // Init status
    (0, $jbmdS.useEffect)(function() {
        setStatus("measure");
    }, [
        visible
    ]); // Go next status
    (0, $jbmdS.useEffect)(function() {
        switch(status){
            case "measure":
                doMeasure();
                break;
            default:
        }
        if (status) rafRef.current = (0, $2iJQe.default)(/*#__PURE__*/ (0, $raxj3.default)(/*#__PURE__*/ (0, $9TNqp.default)().mark(function _callee() {
            var index, nextStatus;
            return (0, $9TNqp.default)().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        index = $2e2ae7cac84df59f$var$StatusQueue.indexOf(status);
                        nextStatus = $2e2ae7cac84df59f$var$StatusQueue[index + 1];
                        if (nextStatus && index !== -1) setStatus(nextStatus);
                    case 3:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        })));
    }, [
        status
    ]);
    (0, $jbmdS.useEffect)(function() {
        return function() {
            cancelRaf();
        };
    }, []);
    return [
        status,
        goNextStatus
    ];
};

});

parcelRegister("7pBGC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $565819eda1c33884$export$2e2bcd8739ae039; });

var $CZyex = parcelRequire("CZyex");

var $jbmdS = parcelRequire("jbmdS");
var $565819eda1c33884$export$2e2bcd8739ae039 = function(stretch) {
    var _React$useState = $jbmdS.useState({
        width: 0,
        height: 0
    }), _React$useState2 = (0, $CZyex.default)(_React$useState, 2), targetSize = _React$useState2[0], setTargetSize = _React$useState2[1];
    function measureStretch(element) {
        var tgtWidth = element.offsetWidth, tgtHeight = element.offsetHeight;
        var _element$getBoundingC = element.getBoundingClientRect(), width = _element$getBoundingC.width, height = _element$getBoundingC.height; // Rect is more accurate than offset, use if near
        if (Math.abs(tgtWidth - width) < 1 && Math.abs(tgtHeight - height) < 1) {
            tgtWidth = width;
            tgtHeight = height;
        }
        setTargetSize({
            width: tgtWidth,
            height: tgtHeight
        });
    } // Merge stretch style
    var style = $jbmdS.useMemo(function() {
        var sizeStyle = {};
        if (stretch) {
            var width = targetSize.width, height = targetSize.height; // Stretch with target
            if (stretch.indexOf("height") !== -1 && height) sizeStyle.height = height;
            else if (stretch.indexOf("minHeight") !== -1 && height) sizeStyle.minHeight = height;
            if (stretch.indexOf("width") !== -1 && width) sizeStyle.width = width;
            else if (stretch.indexOf("minWidth") !== -1 && width) sizeStyle.minWidth = width;
        }
        return sizeStyle;
    }, [
        stretch,
        targetSize
    ]);
    return [
        style,
        measureStretch
    ];
};

});


parcelRegister("6xHzX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c37a104b6d2078b$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $lv6ip = parcelRequire("lv6ip");

var $jbmdS = parcelRequire("jbmdS");

var $jGjXd = parcelRequire("jGjXd");

var $02LyB = parcelRequire("02LyB");
var $4c37a104b6d2078b$var$MobilePopupInner = /*#__PURE__*/ $jbmdS.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, visible = props.visible, zIndex = props.zIndex, children = props.children, _props$mobile = props.mobile;
    _props$mobile = _props$mobile === void 0 ? {} : _props$mobile;
    var popupClassName = _props$mobile.popupClassName, popupStyle = _props$mobile.popupStyle, _props$mobile$popupMo = _props$mobile.popupMotion, popupMotion = _props$mobile$popupMo === void 0 ? {} : _props$mobile$popupMo, popupRender = _props$mobile.popupRender, onClick = props.onClick;
    var elementRef = $jbmdS.useRef(); // ========================= Refs =========================
    $jbmdS.useImperativeHandle(ref, function() {
        return {
            forceAlign: function forceAlign() {},
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    }); // ======================== Render ========================
    var mergedStyle = (0, $lv6ip.default)({
        zIndex: zIndex
    }, popupStyle);
    var childNode = children; // Wrapper when multiple children
    if ($jbmdS.Children.count(children) > 1) childNode = /*#__PURE__*/ $jbmdS.createElement("div", {
        className: "".concat(prefixCls, "-content")
    }, children);
     // Mobile support additional render
    if (popupRender) childNode = popupRender(childNode);
    return /*#__PURE__*/ $jbmdS.createElement((0, $jGjXd.default), (0, $7i29i.default)({
        visible: visible,
        ref: elementRef,
        removeOnLeave: true
    }, popupMotion), function(_ref, motionRef) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(prefixCls, popupClassName, motionClassName);
        return /*#__PURE__*/ $jbmdS.createElement("div", {
            ref: motionRef,
            className: mergedClassName,
            onClick: onClick,
            style: (0, $lv6ip.default)((0, $lv6ip.default)({}, motionStyle), mergedStyle)
        }, childNode);
    });
});
$4c37a104b6d2078b$var$MobilePopupInner.displayName = "MobilePopupInner";
var $4c37a104b6d2078b$export$2e2bcd8739ae039 = $4c37a104b6d2078b$var$MobilePopupInner;

});


parcelRegister("i5q9E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2acfb661d24f98e$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");
var $d2acfb661d24f98e$var$TriggerContext = /*#__PURE__*/ $jbmdS.createContext(null);
var $d2acfb661d24f98e$export$2e2bcd8739ae039 = $d2acfb661d24f98e$var$TriggerContext;

});



parcelRegister("6FrK4", function(module, exports) {

$parcel$export(module.exports, "fillFieldNames", function () { return $4dac176b29a09d5e$export$6c519d302dced239; });
$parcel$export(module.exports, "flattenOptions", function () { return $4dac176b29a09d5e$export$7baa7c13b358b002; });
$parcel$export(module.exports, "injectPropsWithOption", function () { return $4dac176b29a09d5e$export$d0b21b213c8c013c; });
$parcel$export(module.exports, "getSeparatedContent", function () { return $4dac176b29a09d5e$export$a09ca2a89e052b14; });

var $huwkX = parcelRequire("huwkX");

var $fdUcS = parcelRequire("fdUcS");

var $lv6ip = parcelRequire("lv6ip");

var $8tMCd = parcelRequire("8tMCd");
function $4dac176b29a09d5e$var$getKey(data, index) {
    var key = data.key;
    var value;
    if ("value" in data) value = data.value;
    if (key !== null && key !== undefined) return key;
    if (value !== undefined) return value;
    return "rc-index-key-".concat(index);
}
function $4dac176b29a09d5e$export$6c519d302dced239(fieldNames, childrenAsData) {
    var _ref = fieldNames || {}, label = _ref.label, value = _ref.value, options = _ref.options;
    return {
        label: label || (childrenAsData ? "children" : "label"),
        value: value || "value",
        options: options || "options"
    };
}
function $4dac176b29a09d5e$export$7baa7c13b358b002(options) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, fieldNames = _ref2.fieldNames, childrenAsData = _ref2.childrenAsData;
    var flattenList = [];
    var _fillFieldNames = $4dac176b29a09d5e$export$6c519d302dced239(fieldNames, false), fieldLabel = _fillFieldNames.label, fieldValue = _fillFieldNames.value, fieldOptions = _fillFieldNames.options;
    function dig(list, isGroupOption) {
        list.forEach(function(data) {
            var label = data[fieldLabel];
            if (isGroupOption || !(fieldOptions in data)) {
                var value = data[fieldValue];
                // Option
                flattenList.push({
                    key: $4dac176b29a09d5e$var$getKey(data, flattenList.length),
                    groupOption: isGroupOption,
                    data: data,
                    label: label,
                    value: value
                });
            } else {
                var grpLabel = label;
                if (grpLabel === undefined && childrenAsData) grpLabel = data.label;
                // Option Group
                flattenList.push({
                    key: $4dac176b29a09d5e$var$getKey(data, flattenList.length),
                    group: true,
                    data: data,
                    label: grpLabel
                });
                dig(data[fieldOptions], true);
            }
        });
    }
    dig(options, false);
    return flattenList;
}
function $4dac176b29a09d5e$export$d0b21b213c8c013c(option) {
    var newOption = (0, $lv6ip.default)({}, option);
    if (!("props" in newOption)) Object.defineProperty(newOption, "props", {
        get: function get() {
            (0, $8tMCd.default)(false, "Return type is option instead of Option instance. Please read value directly instead of reading from `props`.");
            return newOption;
        }
    });
    return newOption;
}
function $4dac176b29a09d5e$export$a09ca2a89e052b14(text, tokens) {
    if (!tokens || !tokens.length) return null;
    var match = false;
    function separate(str, _ref3) {
        var _ref4 = (0, $fdUcS.default)(_ref3), token = _ref4[0], restTokens = _ref4.slice(1);
        if (!token) return [
            str
        ];
        var list = str.split(token);
        match = match || list.length > 1;
        return list.reduce(function(prevList, unitStr) {
            return [].concat((0, $huwkX.default)(prevList), (0, $huwkX.default)(separate(unitStr, restTokens)));
        }, []).filter(function(unit) {
            return unit;
        });
    }
    var list = separate(text, tokens);
    return match ? list : null;
}

});


parcelRegister("c1ozx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c08a38bd9a2aeb4$export$2e2bcd8739ae039; });

var $lv6ip = parcelRequire("lv6ip");

var $jbmdS = parcelRequire("jbmdS");
var /**
 * Cache `value` related LabeledValue & options.
 */ $8c08a38bd9a2aeb4$export$2e2bcd8739ae039 = function(labeledValues, valueOptions) {
    var cacheRef = $jbmdS.useRef({
        values: new Map(),
        options: new Map()
    });
    var filledLabeledValues = $jbmdS.useMemo(function() {
        var _cacheRef$current = cacheRef.current, prevValueCache = _cacheRef$current.values, prevOptionCache = _cacheRef$current.options;
        // Fill label by cache
        var patchedValues = labeledValues.map(function(item) {
            if (item.label === undefined) {
                var _prevValueCache$get;
                return (0, $lv6ip.default)((0, $lv6ip.default)({}, item), {}, {
                    label: (_prevValueCache$get = prevValueCache.get(item.value)) === null || _prevValueCache$get === void 0 ? void 0 : _prevValueCache$get.label
                });
            }
            return item;
        });
        // Refresh cache
        var valueCache = new Map();
        var optionCache = new Map();
        patchedValues.forEach(function(item) {
            valueCache.set(item.value, item);
            optionCache.set(item.value, valueOptions.get(item.value) || prevOptionCache.get(item.value));
        });
        cacheRef.current.values = valueCache;
        cacheRef.current.options = optionCache;
        return patchedValues;
    }, [
        labeledValues,
        valueOptions
    ]);
    var getOption = $jbmdS.useCallback(function(val) {
        return valueOptions.get(val) || cacheRef.current.options.get(val);
    }, [
        valueOptions
    ]);
    return [
        filledLabeledValues,
        getOption
    ];
};

});

parcelRegister("atbOI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79f5c769fa051000$export$2e2bcd8739ae039; });

var $8K2NM = parcelRequire("8K2NM");

var $lv6ip = parcelRequire("lv6ip");

var $jbmdS = parcelRequire("jbmdS");

var $gDBzp = parcelRequire("gDBzp");

var $6FrK4 = parcelRequire("6FrK4");
function $79f5c769fa051000$var$includes(test, search) {
    return (0, $gDBzp.toArray)(test).join("").toUpperCase().includes(search);
}
var $79f5c769fa051000$export$2e2bcd8739ae039 = function(options, fieldNames, searchValue, filterOption, optionFilterProp) {
    return $jbmdS.useMemo(function() {
        if (!searchValue || filterOption === false) return options;
        var fieldOptions = fieldNames.options, fieldLabel = fieldNames.label, fieldValue = fieldNames.value;
        var filteredOptions = [];
        var customizeFilter = typeof filterOption === "function";
        var upperSearch = searchValue.toUpperCase();
        var filterFunc = customizeFilter ? filterOption : function(_, option) {
            // Use provided `optionFilterProp`
            if (optionFilterProp) return $79f5c769fa051000$var$includes(option[optionFilterProp], upperSearch);
            // Auto select `label` or `value` by option type
            if (option[fieldOptions]) // hack `fieldLabel` since `OptionGroup` children is not `label`
            return $79f5c769fa051000$var$includes(option[fieldLabel !== "children" ? fieldLabel : "label"], upperSearch);
            return $79f5c769fa051000$var$includes(option[fieldValue], upperSearch);
        };
        var wrapOption = customizeFilter ? function(opt) {
            return (0, $6FrK4.injectPropsWithOption)(opt);
        } : function(opt) {
            return opt;
        };
        options.forEach(function(item) {
            // Group should check child options
            if (item[fieldOptions]) {
                // Check group first
                var matchGroup = filterFunc(searchValue, wrapOption(item));
                if (matchGroup) filteredOptions.push(item);
                else {
                    // Check option
                    var subOptions = item[fieldOptions].filter(function(subItem) {
                        return filterFunc(searchValue, wrapOption(subItem));
                    });
                    if (subOptions.length) filteredOptions.push((0, $lv6ip.default)((0, $lv6ip.default)({}, item), {}, (0, $8K2NM.default)({}, fieldOptions, subOptions)));
                }
                return;
            }
            if (filterFunc(searchValue, wrapOption(item))) filteredOptions.push(item);
        });
        return filteredOptions;
    }, [
        options,
        filterOption,
        optionFilterProp,
        searchValue,
        fieldNames
    ]);
};

});

parcelRegister("ayI6j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7aff49d9c5cd222f$export$2e2bcd8739ae039; });

var $CZyex = parcelRequire("CZyex");

var $jbmdS = parcelRequire("jbmdS");

var $gnP4S = parcelRequire("gnP4S");
var $7aff49d9c5cd222f$var$uuid = 0;
var $7aff49d9c5cd222f$export$df7146797a248522 = (0, $gnP4S.default)();
function $7aff49d9c5cd222f$export$36ec425867d538d7() {
    var retId;
    // Test never reach
    /* istanbul ignore if */ if ($7aff49d9c5cd222f$export$df7146797a248522) {
        retId = $7aff49d9c5cd222f$var$uuid;
        $7aff49d9c5cd222f$var$uuid += 1;
    } else retId = "TEST_OR_SSR";
    return retId;
}
function $7aff49d9c5cd222f$export$2e2bcd8739ae039(id) {
    // Inner id for accessibility usage. Only work in client side
    var _React$useState = $jbmdS.useState(), _React$useState2 = (0, $CZyex.default)(_React$useState, 2), innerId = _React$useState2[0], setInnerId = _React$useState2[1];
    $jbmdS.useEffect(function() {
        setInnerId("rc_select_".concat($7aff49d9c5cd222f$export$36ec425867d538d7()));
    }, []);
    return id || innerId;
}

});

parcelRegister("jhHhr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0a12d6b106a2f0d$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");

var $gH1E8 = parcelRequire("gH1E8");
function $e0a12d6b106a2f0d$export$2e2bcd8739ae039(options, children, fieldNames, optionFilterProp, optionLabelProp) {
    return $jbmdS.useMemo(function() {
        var mergedOptions = options;
        var childrenAsData = !options;
        if (childrenAsData) mergedOptions = (0, $gH1E8.convertChildrenToData)(children);
        var valueOptions = new Map();
        var labelOptions = new Map();
        var setLabelOptions = function setLabelOptions(labelOptionsMap, option, key) {
            if (key && typeof key === "string") labelOptionsMap.set(option[key], option);
        };
        function dig(optionList) {
            var isChildren = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            // for loop to speed up collection speed
            for(var i = 0; i < optionList.length; i += 1){
                var option = optionList[i];
                if (!option[fieldNames.options] || isChildren) {
                    valueOptions.set(option[fieldNames.value], option);
                    setLabelOptions(labelOptions, option, fieldNames.label);
                    // https://github.com/ant-design/ant-design/issues/35304
                    setLabelOptions(labelOptions, option, optionFilterProp);
                    setLabelOptions(labelOptions, option, optionLabelProp);
                } else dig(option[fieldNames.options], true);
            }
        }
        dig(mergedOptions);
        return {
            options: mergedOptions,
            valueOptions: valueOptions,
            labelOptions: labelOptions
        };
    }, [
        options,
        children,
        fieldNames,
        optionFilterProp,
        optionLabelProp
    ]);
}

});
parcelRegister("gH1E8", function(module, exports) {

$parcel$export(module.exports, "convertChildrenToData", function () { return $c271f06cdf328e96$export$3beca35db74c3985; });

var $lv6ip = parcelRequire("lv6ip");

var $ccQt4 = parcelRequire("ccQt4");

var $jbmdS = parcelRequire("jbmdS");

var $5AfDn = parcelRequire("5AfDn");
var $c271f06cdf328e96$var$_excluded = [
    "children",
    "value"
], $c271f06cdf328e96$var$_excluded2 = [
    "children"
];
function $c271f06cdf328e96$var$convertNodeToOption(node) {
    var _ref = node, key = _ref.key, _ref$props = _ref.props, children = _ref$props.children, value = _ref$props.value, restProps = (0, $ccQt4.default)(_ref$props, $c271f06cdf328e96$var$_excluded);
    return (0, $lv6ip.default)({
        key: key,
        value: value !== undefined ? value : key,
        children: children
    }, restProps);
}
function $c271f06cdf328e96$export$3beca35db74c3985(nodes) {
    var optionOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return (0, $5AfDn.default)(nodes).map(function(node, index) {
        if (!/*#__PURE__*/ $jbmdS.isValidElement(node) || !node.type) return null;
        var _ref2 = node, isSelectOptGroup = _ref2.type.isSelectOptGroup, key = _ref2.key, _ref2$props = _ref2.props, children = _ref2$props.children, restProps = (0, $ccQt4.default)(_ref2$props, $c271f06cdf328e96$var$_excluded2);
        if (optionOnly || !isSelectOptGroup) return $c271f06cdf328e96$var$convertNodeToOption(node);
        return (0, $lv6ip.default)((0, $lv6ip.default)({
            key: "__RC_SELECT_GRP__".concat(key === null ? index : key, "__"),
            label: key
        }, restProps), {}, {
            options: $c271f06cdf328e96$export$3beca35db74c3985(children)
        });
    }).filter(function(data) {
        return data;
    });
}

});


parcelRegister("14qFa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c7ad8ddef6489bd$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");
function $0c7ad8ddef6489bd$export$2e2bcd8739ae039(callback) {
    var funcRef = $jbmdS.useRef();
    funcRef.current = callback;
    var cacheFn = $jbmdS.useCallback(function() {
        return funcRef.current.apply(funcRef, arguments);
    }, []);
    return cacheFn;
}

});

parcelRegister("kJcbr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f171760654cbe956$export$2e2bcd8739ae039; });
/* istanbul ignore file */ /** This is a placeholder, not real render in dom */ var $f171760654cbe956$var$OptGroup = function OptGroup() {
    return null;
};
$f171760654cbe956$var$OptGroup.isSelectOptGroup = true;
var $f171760654cbe956$export$2e2bcd8739ae039 = $f171760654cbe956$var$OptGroup;

});

parcelRegister("QDKu0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09e3b0b66aa40747$export$2e2bcd8739ae039; });
/* istanbul ignore file */ /** This is a placeholder, not real render in dom */ var $09e3b0b66aa40747$var$Option = function Option() {
    return null;
};
$09e3b0b66aa40747$var$Option.isSelectOption = true;
var $09e3b0b66aa40747$export$2e2bcd8739ae039 = $09e3b0b66aa40747$var$Option;

});

parcelRegister("4QI5P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $387e38b7b1a1adbc$export$2e2bcd8739ae039; });

var $8K2NM = parcelRequire("8K2NM");

var $ccQt4 = parcelRequire("ccQt4");

var $7i29i = parcelRequire("7i29i");

var $huwkX = parcelRequire("huwkX");

var $CZyex = parcelRequire("CZyex");

var $jbmdS = parcelRequire("jbmdS");

var $5yi5E = parcelRequire("5yi5E");

var $cXDkH = parcelRequire("cXDkH");

var $dSkKg = parcelRequire("dSkKg");

var $gwVpW = parcelRequire("gwVpW");

var $02LyB = parcelRequire("02LyB");

var $g0xPu = parcelRequire("g0xPu");

var $1hjik = parcelRequire("1hjik");

var $cVAnL = parcelRequire("cVAnL");

var $2eOmx = parcelRequire("2eOmx");

var $1TF7a = parcelRequire("1TF7a");
var $387e38b7b1a1adbc$var$_excluded = [
    "disabled",
    "title",
    "children",
    "style",
    "className"
];
// export interface OptionListProps<OptionsType extends object[]> {
function $387e38b7b1a1adbc$var$isTitleType(content) {
    return typeof content === "string" || typeof content === "number";
}
/**
 * Using virtual list of option display.
 * Will fallback to dom if use customize render.
 */ var $387e38b7b1a1adbc$var$OptionList = function OptionList(_, ref) {
    var _useBaseProps = (0, $2eOmx.default)(), prefixCls = _useBaseProps.prefixCls, id = _useBaseProps.id, open = _useBaseProps.open, multiple = _useBaseProps.multiple, mode = _useBaseProps.mode, searchValue = _useBaseProps.searchValue, toggleOpen = _useBaseProps.toggleOpen, notFoundContent = _useBaseProps.notFoundContent, onPopupScroll = _useBaseProps.onPopupScroll;
    var _React$useContext = $jbmdS.useContext((0, $1TF7a.default)), flattenOptions = _React$useContext.flattenOptions, onActiveValue = _React$useContext.onActiveValue, defaultActiveFirstOption = _React$useContext.defaultActiveFirstOption, onSelect = _React$useContext.onSelect, menuItemSelectedIcon = _React$useContext.menuItemSelectedIcon, rawValues = _React$useContext.rawValues, fieldNames = _React$useContext.fieldNames, virtual = _React$useContext.virtual, listHeight = _React$useContext.listHeight, listItemHeight = _React$useContext.listItemHeight;
    var itemPrefixCls = "".concat(prefixCls, "-item");
    var memoFlattenOptions = (0, $gwVpW.default)(function() {
        return flattenOptions;
    }, [
        open,
        flattenOptions
    ], function(prev, next) {
        return next[0] && prev[1] !== next[1];
    });
    // =========================== List ===========================
    var listRef = $jbmdS.useRef(null);
    var onListMouseDown = function onListMouseDown(event) {
        event.preventDefault();
    };
    var scrollIntoView = function scrollIntoView(args) {
        if (listRef.current) listRef.current.scrollTo(typeof args === "number" ? {
            index: args
        } : args);
    };
    // ========================== Active ==========================
    var getEnabledActiveIndex = function getEnabledActiveIndex(index) {
        var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        var len = memoFlattenOptions.length;
        for(var i = 0; i < len; i += 1){
            var current = (index + i * offset + len) % len;
            var _memoFlattenOptions$c = memoFlattenOptions[current], group = _memoFlattenOptions$c.group, data = _memoFlattenOptions$c.data;
            if (!group && !data.disabled) return current;
        }
        return -1;
    };
    var _React$useState = $jbmdS.useState(function() {
        return getEnabledActiveIndex(0);
    }), _React$useState2 = (0, $CZyex.default)(_React$useState, 2), activeIndex = _React$useState2[0], setActiveIndex = _React$useState2[1];
    var setActive = function setActive(index) {
        var fromKeyboard = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        setActiveIndex(index);
        var info = {
            source: fromKeyboard ? "keyboard" : "mouse"
        };
        // Trigger active event
        var flattenItem = memoFlattenOptions[index];
        if (!flattenItem) {
            onActiveValue(null, -1, info);
            return;
        }
        onActiveValue(flattenItem.value, index, info);
    };
    // Auto active first item when list length or searchValue changed
    (0, $jbmdS.useEffect)(function() {
        setActive(defaultActiveFirstOption !== false ? getEnabledActiveIndex(0) : -1);
    }, [
        memoFlattenOptions.length,
        searchValue
    ]);
    // https://github.com/ant-design/ant-design/issues/34975
    var isSelected = $jbmdS.useCallback(function(value) {
        return rawValues.has(value) && mode !== "combobox";
    }, [
        mode,
        (0, $huwkX.default)(rawValues).toString(),
        rawValues.size
    ]);
    // Auto scroll to item position in single mode
    (0, $jbmdS.useEffect)(function() {
        /**
     * React will skip `onChange` when component update.
     * `setActive` function will call root accessibility state update which makes re-render.
     * So we need to delay to let Input component trigger onChange first.
     */ var timeoutId = setTimeout(function() {
            if (!multiple && open && rawValues.size === 1) {
                var value = Array.from(rawValues)[0];
                var index = memoFlattenOptions.findIndex(function(_ref) {
                    var data = _ref.data;
                    return data.value === value;
                });
                if (index !== -1) {
                    setActive(index);
                    scrollIntoView(index);
                }
            }
        });
        // Force trigger scrollbar visible when open
        if (open) {
            var _listRef$current;
            (_listRef$current = listRef.current) === null || _listRef$current === void 0 || _listRef$current.scrollTo(undefined);
        }
        return function() {
            return clearTimeout(timeoutId);
        };
    }, [
        open,
        searchValue
    ]);
    // ========================== Values ==========================
    var onSelectValue = function onSelectValue(value) {
        if (value !== undefined) onSelect(value, {
            selected: !rawValues.has(value)
        });
        // Single mode should always close by select
        if (!multiple) toggleOpen(false);
    };
    // ========================= Keyboard =========================
    $jbmdS.useImperativeHandle(ref, function() {
        return {
            onKeyDown: function onKeyDown(event) {
                var which = event.which, ctrlKey = event.ctrlKey;
                switch(which){
                    // >>> Arrow keys & ctrl + n/p on Mac
                    case (0, $5yi5E.default).N:
                    case (0, $5yi5E.default).P:
                    case (0, $5yi5E.default).UP:
                    case (0, $5yi5E.default).DOWN:
                        var offset = 0;
                        if (which === (0, $5yi5E.default).UP) offset = -1;
                        else if (which === (0, $5yi5E.default).DOWN) offset = 1;
                        else if ((0, $cVAnL.isPlatformMac)() && ctrlKey) {
                            if (which === (0, $5yi5E.default).N) offset = 1;
                            else if (which === (0, $5yi5E.default).P) offset = -1;
                        }
                        if (offset !== 0) {
                            var nextActiveIndex = getEnabledActiveIndex(activeIndex + offset, offset);
                            scrollIntoView(nextActiveIndex);
                            setActive(nextActiveIndex, true);
                        }
                        break;
                    // >>> Select
                    case (0, $5yi5E.default).ENTER:
                        // value
                        var item = memoFlattenOptions[activeIndex];
                        if (item && !item.data.disabled) onSelectValue(item.value);
                        else onSelectValue(undefined);
                        if (open) event.preventDefault();
                        break;
                    // >>> Close
                    case (0, $5yi5E.default).ESC:
                        toggleOpen(false);
                        if (open) event.stopPropagation();
                }
            },
            onKeyUp: function onKeyUp() {},
            scrollTo: function scrollTo(index) {
                scrollIntoView(index);
            }
        };
    });
    // ========================== Render ==========================
    if (memoFlattenOptions.length === 0) return /*#__PURE__*/ $jbmdS.createElement("div", {
        role: "listbox",
        id: "".concat(id, "_list"),
        className: "".concat(itemPrefixCls, "-empty"),
        onMouseDown: onListMouseDown
    }, notFoundContent);
    var omitFieldNameList = Object.keys(fieldNames).map(function(key) {
        return fieldNames[key];
    });
    var getLabel = function getLabel(item) {
        return item.label;
    };
    var renderItem = function renderItem(index) {
        var item = memoFlattenOptions[index];
        if (!item) return null;
        var itemData = item.data || {};
        var value = itemData.value;
        var group = item.group;
        var attrs = (0, $dSkKg.default)(itemData, true);
        var mergedLabel = getLabel(item);
        return item ? /*#__PURE__*/ $jbmdS.createElement("div", (0, $7i29i.default)({
            "aria-label": typeof mergedLabel === "string" && !group ? mergedLabel : null
        }, attrs, {
            key: index,
            role: group ? "presentation" : "option",
            id: "".concat(id, "_list_").concat(index),
            "aria-selected": isSelected(value)
        }), value) : null;
    };
    return /*#__PURE__*/ $jbmdS.createElement($jbmdS.Fragment, null, /*#__PURE__*/ $jbmdS.createElement("div", {
        role: "listbox",
        id: "".concat(id, "_list"),
        style: {
            height: 0,
            width: 0,
            overflow: "hidden"
        }
    }, renderItem(activeIndex - 1), renderItem(activeIndex), renderItem(activeIndex + 1)), /*#__PURE__*/ $jbmdS.createElement((0, $g0xPu.default), {
        itemKey: "key",
        ref: listRef,
        data: memoFlattenOptions,
        height: listHeight,
        itemHeight: listItemHeight,
        fullHeight: false,
        onMouseDown: onListMouseDown,
        onScroll: onPopupScroll,
        virtual: virtual
    }, function(item, itemIndex) {
        var _classNames;
        var group = item.group, groupOption = item.groupOption, data = item.data, label = item.label, value = item.value;
        var key = data.key;
        // Group
        if (group) {
            var _data$title;
            var groupTitle = (_data$title = data.title) !== null && _data$title !== void 0 ? _data$title : $387e38b7b1a1adbc$var$isTitleType(label) ? label.toString() : undefined;
            return /*#__PURE__*/ $jbmdS.createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(itemPrefixCls, "".concat(itemPrefixCls, "-group")),
                title: groupTitle
            }, label !== undefined ? label : key);
        }
        var disabled = data.disabled, title = data.title, children = data.children, style = data.style, className = data.className, otherProps = (0, $ccQt4.default)(data, $387e38b7b1a1adbc$var$_excluded);
        var passedProps = (0, $cXDkH.default)(otherProps, omitFieldNameList);
        // Option
        var selected = isSelected(value);
        var optionPrefixCls = "".concat(itemPrefixCls, "-option");
        var optionClassName = (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(itemPrefixCls, optionPrefixCls, className, (_classNames = {}, (0, $8K2NM.default)(_classNames, "".concat(optionPrefixCls, "-grouped"), groupOption), (0, $8K2NM.default)(_classNames, "".concat(optionPrefixCls, "-active"), activeIndex === itemIndex && !disabled), (0, $8K2NM.default)(_classNames, "".concat(optionPrefixCls, "-disabled"), disabled), (0, $8K2NM.default)(_classNames, "".concat(optionPrefixCls, "-selected"), selected), _classNames));
        var mergedLabel = getLabel(item);
        var iconVisible = !menuItemSelectedIcon || typeof menuItemSelectedIcon === "function" || selected;
        // https://github.com/ant-design/ant-design/issues/34145
        var content = typeof mergedLabel === "number" ? mergedLabel : mergedLabel || value;
        // https://github.com/ant-design/ant-design/issues/26717
        var optionTitle = $387e38b7b1a1adbc$var$isTitleType(content) ? content.toString() : undefined;
        if (title !== undefined) optionTitle = title;
        return /*#__PURE__*/ $jbmdS.createElement("div", (0, $7i29i.default)({}, (0, $dSkKg.default)(passedProps), {
            "aria-selected": selected,
            className: optionClassName,
            title: optionTitle,
            onMouseMove: function onMouseMove() {
                if (activeIndex === itemIndex || disabled) return;
                setActive(itemIndex);
            },
            onClick: function onClick() {
                if (!disabled) onSelectValue(value);
            },
            style: style
        }), /*#__PURE__*/ $jbmdS.createElement("div", {
            className: "".concat(optionPrefixCls, "-content")
        }, content), /*#__PURE__*/ $jbmdS.isValidElement(menuItemSelectedIcon) || selected, iconVisible && /*#__PURE__*/ $jbmdS.createElement((0, $1hjik.default), {
            className: "".concat(itemPrefixCls, "-option-state"),
            customizeIcon: menuItemSelectedIcon,
            customizeIconProps: {
                isSelected: selected
            }
        }, selected ? "\u2713" : null));
    }));
};
var $387e38b7b1a1adbc$var$RefOptionList = /*#__PURE__*/ $jbmdS.forwardRef($387e38b7b1a1adbc$var$OptionList);
$387e38b7b1a1adbc$var$RefOptionList.displayName = "OptionList";
var $387e38b7b1a1adbc$export$2e2bcd8739ae039 = $387e38b7b1a1adbc$var$RefOptionList;

});
parcelRegister("g0xPu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba76e33cf4276f80$export$2e2bcd8739ae039; });

var $alS6N = parcelRequire("alS6N");
var $ba76e33cf4276f80$export$2e2bcd8739ae039 = (0, $alS6N.default);

});
parcelRegister("alS6N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7895d66a284f9cc2$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $jncUt = parcelRequire("jncUt");

var $lv6ip = parcelRequire("lv6ip");

var $8K2NM = parcelRequire("8K2NM");

var $CZyex = parcelRequire("CZyex");

var $ccQt4 = parcelRequire("ccQt4");

var $02LyB = parcelRequire("02LyB");

var $fvfrs = parcelRequire("fvfrs");
parcelRequire("7AQNp");
var $gZPGe = parcelRequire("gZPGe");

var $iDOLX = parcelRequire("iDOLX");

var $jbmdS = parcelRequire("jbmdS");

var $jCNM0 = parcelRequire("jCNM0");

var $iQRuM = parcelRequire("iQRuM");

var $g2jSS = parcelRequire("g2jSS");

var $dK7tv = parcelRequire("dK7tv");

var $f6uC4 = parcelRequire("f6uC4");

var $e7Ot6 = parcelRequire("e7Ot6");

var $9hLwY = parcelRequire("9hLwY");

var $bh0bX = parcelRequire("bh0bX");

var $aaUmB = parcelRequire("aaUmB");

var $cfqZO = parcelRequire("cfqZO");

var $5JMUu = parcelRequire("5JMUu");

var $gd3PK = parcelRequire("gd3PK");
var $7895d66a284f9cc2$var$_excluded = [
    "prefixCls",
    "className",
    "height",
    "itemHeight",
    "fullHeight",
    "style",
    "data",
    "children",
    "itemKey",
    "virtual",
    "direction",
    "scrollWidth",
    "component",
    "onScroll",
    "onVirtualScroll",
    "onVisibleChange",
    "innerProps",
    "extraRender",
    "styles"
];
var $7895d66a284f9cc2$var$EMPTY_DATA = [];
var $7895d66a284f9cc2$var$ScrollStyle = {
    overflowY: "auto",
    overflowAnchor: "none"
};
function $7895d66a284f9cc2$export$cc3be4e46e8486ed(props, ref) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-virtual-list" : _props$prefixCls, className = props.className, height = props.height, itemHeight = props.itemHeight, _props$fullHeight = props.fullHeight, fullHeight = _props$fullHeight === void 0 ? true : _props$fullHeight, style = props.style, data = props.data, children = props.children, itemKey = props.itemKey, virtual = props.virtual, direction = props.direction, scrollWidth = props.scrollWidth, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, onScroll = props.onScroll, onVirtualScroll = props.onVirtualScroll, onVisibleChange = props.onVisibleChange, innerProps = props.innerProps, extraRender = props.extraRender, styles = props.styles, restProps = (0, $ccQt4.default)(props, $7895d66a284f9cc2$var$_excluded);
    // =============================== Item Key ===============================
    var getKey = $jbmdS.useCallback(function(item) {
        if (typeof itemKey === "function") return itemKey(item);
        return item === null || item === void 0 ? void 0 : item[itemKey];
    }, [
        itemKey
    ]);
    // ================================ Height ================================
    var _useHeights = (0, $9hLwY.default)(getKey, null, null), _useHeights2 = (0, $CZyex.default)(_useHeights, 4), setInstanceRef = _useHeights2[0], collectHeight = _useHeights2[1], heights = _useHeights2[2], heightUpdatedMark = _useHeights2[3];
    // ================================= MISC =================================
    var useVirtual = !!(virtual !== false && height && itemHeight);
    var containerHeight = $jbmdS.useMemo(function() {
        return Object.values(heights.maps).reduce(function(total, curr) {
            return total + curr;
        }, 0);
    }, [
        heights.id,
        heights.maps
    ]);
    var inVirtual = useVirtual && data && (Math.max(itemHeight * data.length, containerHeight) > height || !!scrollWidth);
    var isRTL = direction === "rtl";
    var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(prefixCls, (0, $8K2NM.default)({}, "".concat(prefixCls, "-rtl"), isRTL), className);
    var mergedData = data || $7895d66a284f9cc2$var$EMPTY_DATA;
    var componentRef = (0, $jbmdS.useRef)();
    var fillerInnerRef = (0, $jbmdS.useRef)();
    var containerRef = (0, $jbmdS.useRef)();
    // =============================== Item Key ===============================
    var _useState = (0, $jbmdS.useState)(0), _useState2 = (0, $CZyex.default)(_useState, 2), offsetTop = _useState2[0], setOffsetTop = _useState2[1];
    var _useState3 = (0, $jbmdS.useState)(0), _useState4 = (0, $CZyex.default)(_useState3, 2), offsetLeft = _useState4[0], setOffsetLeft = _useState4[1];
    var _useState5 = (0, $jbmdS.useState)(false), _useState6 = (0, $CZyex.default)(_useState5, 2), scrollMoving = _useState6[0], setScrollMoving = _useState6[1];
    var onScrollbarStartMove = function onScrollbarStartMove() {
        setScrollMoving(true);
    };
    var onScrollbarStopMove = function onScrollbarStopMove() {
        setScrollMoving(false);
    };
    var sharedConfig = {
        getKey: getKey
    };
    // ================================ Scroll ================================
    function syncScrollTop(newTop) {
        setOffsetTop(function(origin) {
            var value;
            if (typeof newTop === "function") value = newTop(origin);
            else value = newTop;
            var alignedTop = keepInRange(value);
            componentRef.current.scrollTop = alignedTop;
            return alignedTop;
        });
    }
    // ================================ Legacy ================================
    // Put ref here since the range is generate by follow
    var rangeRef = (0, $jbmdS.useRef)({
        start: 0,
        end: mergedData.length
    });
    var diffItemRef = (0, $jbmdS.useRef)();
    var _useDiffItem = (0, $dK7tv.default)(mergedData, getKey), _useDiffItem2 = (0, $CZyex.default)(_useDiffItem, 1), diffItem = _useDiffItem2[0];
    diffItemRef.current = diffItem;
    // ========================== Visible Calculation =========================
    var _React$useMemo = $jbmdS.useMemo(function() {
        if (!useVirtual) return {
            scrollHeight: undefined,
            start: 0,
            end: mergedData.length - 1,
            offset: undefined
        };
        // Always use virtual scroll bar in avoid shaking
        if (!inVirtual) {
            var _fillerInnerRef$curre;
            return {
                scrollHeight: ((_fillerInnerRef$curre = fillerInnerRef.current) === null || _fillerInnerRef$curre === void 0 ? void 0 : _fillerInnerRef$curre.offsetHeight) || 0,
                start: 0,
                end: mergedData.length - 1,
                offset: undefined
            };
        }
        var itemTop = 0;
        var startIndex;
        var startOffset;
        var endIndex;
        var dataLen = mergedData.length;
        for(var i = 0; i < dataLen; i += 1){
            var _item = mergedData[i];
            var key = getKey(_item);
            var cacheHeight = heights.get(key);
            var currentItemBottom = itemTop + (cacheHeight === undefined ? itemHeight : cacheHeight);
            // Check item top in the range
            if (currentItemBottom >= offsetTop && startIndex === undefined) {
                startIndex = i;
                startOffset = itemTop;
            }
            // Check item bottom in the range. We will render additional one item for motion usage
            if (currentItemBottom > offsetTop + height && endIndex === undefined) endIndex = i;
            itemTop = currentItemBottom;
        }
        // When scrollTop at the end but data cut to small count will reach this
        if (startIndex === undefined) {
            startIndex = 0;
            startOffset = 0;
            endIndex = Math.ceil(height / itemHeight);
        }
        if (endIndex === undefined) endIndex = mergedData.length - 1;
        // Give cache to improve scroll experience
        endIndex = Math.min(endIndex + 1, mergedData.length - 1);
        return {
            scrollHeight: itemTop,
            start: startIndex,
            end: endIndex,
            offset: startOffset
        };
    }, [
        inVirtual,
        useVirtual,
        offsetTop,
        mergedData,
        heightUpdatedMark,
        height
    ]), scrollHeight = _React$useMemo.scrollHeight, start = _React$useMemo.start, end = _React$useMemo.end, fillerOffset = _React$useMemo.offset;
    rangeRef.current.start = start;
    rangeRef.current.end = end;
    // ================================= Size =================================
    var _React$useState = $jbmdS.useState({
        width: 0,
        height: height
    }), _React$useState2 = (0, $CZyex.default)(_React$useState, 2), size = _React$useState2[0], setSize = _React$useState2[1];
    var onHolderResize = function onHolderResize(sizeInfo) {
        setSize({
            width: sizeInfo.offsetWidth,
            height: sizeInfo.offsetHeight
        });
    };
    // Hack on scrollbar to enable flash call
    var verticalScrollBarRef = (0, $jbmdS.useRef)();
    var horizontalScrollBarRef = (0, $jbmdS.useRef)();
    var horizontalScrollBarSpinSize = $jbmdS.useMemo(function() {
        return (0, $gd3PK.getSpinSize)(size.width, scrollWidth);
    }, [
        size.width,
        scrollWidth
    ]);
    var verticalScrollBarSpinSize = $jbmdS.useMemo(function() {
        return (0, $gd3PK.getSpinSize)(size.height, scrollHeight);
    }, [
        size.height,
        scrollHeight
    ]);
    // =============================== In Range ===============================
    var maxScrollHeight = scrollHeight - height;
    var maxScrollHeightRef = (0, $jbmdS.useRef)(maxScrollHeight);
    maxScrollHeightRef.current = maxScrollHeight;
    function keepInRange(newScrollTop) {
        var newTop = newScrollTop;
        if (!Number.isNaN(maxScrollHeightRef.current)) newTop = Math.min(newTop, maxScrollHeightRef.current);
        newTop = Math.max(newTop, 0);
        return newTop;
    }
    var isScrollAtTop = offsetTop <= 0;
    var isScrollAtBottom = offsetTop >= maxScrollHeight;
    var isScrollAtLeft = offsetLeft <= 0;
    var isScrollAtRight = offsetLeft >= scrollWidth;
    var originScroll = (0, $aaUmB.default)(isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight);
    // ================================ Scroll ================================
    var getVirtualScrollInfo = function getVirtualScrollInfo() {
        return {
            x: isRTL ? -offsetLeft : offsetLeft,
            y: offsetTop
        };
    };
    var lastVirtualScrollInfoRef = (0, $jbmdS.useRef)(getVirtualScrollInfo());
    var triggerScroll = (0, $gZPGe.default)(function(params) {
        if (onVirtualScroll) {
            var nextInfo = (0, $lv6ip.default)((0, $lv6ip.default)({}, getVirtualScrollInfo()), params);
            // Trigger when offset changed
            if (lastVirtualScrollInfoRef.current.x !== nextInfo.x || lastVirtualScrollInfoRef.current.y !== nextInfo.y) {
                onVirtualScroll(nextInfo);
                lastVirtualScrollInfoRef.current = nextInfo;
            }
        }
    });
    function onScrollBar(newScrollOffset, horizontal) {
        var newOffset = newScrollOffset;
        if (horizontal) {
            (0, $jCNM0.flushSync)(function() {
                setOffsetLeft(newOffset);
            });
            triggerScroll();
        } else syncScrollTop(newOffset);
    }
    // When data size reduce. It may trigger native scroll event back to fit scroll position
    function onFallbackScroll(e) {
        var newScrollTop = e.currentTarget.scrollTop;
        if (newScrollTop !== offsetTop) syncScrollTop(newScrollTop);
        // Trigger origin onScroll
        onScroll === null || onScroll === void 0 || onScroll(e);
        triggerScroll();
    }
    var keepInHorizontalRange = function keepInHorizontalRange(nextOffsetLeft) {
        var tmpOffsetLeft = nextOffsetLeft;
        var max = !!scrollWidth ? scrollWidth - size.width : 0;
        tmpOffsetLeft = Math.max(tmpOffsetLeft, 0);
        tmpOffsetLeft = Math.min(tmpOffsetLeft, max);
        return tmpOffsetLeft;
    };
    var onWheelDelta = (0, $gZPGe.default)(function(offsetXY, fromHorizontal) {
        if (fromHorizontal) {
            (0, $jCNM0.flushSync)(function() {
                setOffsetLeft(function(left) {
                    var nextOffsetLeft = left + (isRTL ? -offsetXY : offsetXY);
                    return keepInHorizontalRange(nextOffsetLeft);
                });
            });
            triggerScroll();
        } else syncScrollTop(function(top) {
            var newTop = top + offsetXY;
            return newTop;
        });
    });
    // Since this added in global,should use ref to keep update
    var _useFrameWheel = (0, $f6uC4.default)(useVirtual, isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight, !!scrollWidth, onWheelDelta), _useFrameWheel2 = (0, $CZyex.default)(_useFrameWheel, 2), onRawWheel = _useFrameWheel2[0], onFireFoxScroll = _useFrameWheel2[1];
    // Mobile touch move
    (0, $bh0bX.default)(useVirtual, componentRef, function(isHorizontal, delta, smoothOffset, e) {
        var event = e;
        if (originScroll(isHorizontal, delta, smoothOffset)) return false;
        // Fix nest List trigger TouchMove event
        if (!event || !event._virtualHandled) {
            if (event) event._virtualHandled = true;
            onRawWheel({
                preventDefault: function preventDefault() {},
                deltaX: isHorizontal ? delta : 0,
                deltaY: isHorizontal ? 0 : delta
            });
            return true;
        }
        return false;
    });
    (0, $iDOLX.default)(function() {
        // Firefox only
        function onMozMousePixelScroll(e) {
            // scrolling at top/bottom limit
            var scrollingUpAtTop = isScrollAtTop && e.detail < 0;
            var scrollingDownAtBottom = isScrollAtBottom && e.detail > 0;
            if (useVirtual && !scrollingUpAtTop && !scrollingDownAtBottom) e.preventDefault();
        }
        var componentEle = componentRef.current;
        componentEle.addEventListener("wheel", onRawWheel, {
            passive: false
        });
        componentEle.addEventListener("DOMMouseScroll", onFireFoxScroll, {
            passive: true
        });
        componentEle.addEventListener("MozMousePixelScroll", onMozMousePixelScroll, {
            passive: false
        });
        return function() {
            componentEle.removeEventListener("wheel", onRawWheel);
            componentEle.removeEventListener("DOMMouseScroll", onFireFoxScroll);
            componentEle.removeEventListener("MozMousePixelScroll", onMozMousePixelScroll);
        };
    }, [
        useVirtual,
        isScrollAtTop,
        isScrollAtBottom
    ]);
    // Sync scroll left
    (0, $iDOLX.default)(function() {
        if (scrollWidth) {
            var newOffsetLeft = keepInHorizontalRange(offsetLeft);
            setOffsetLeft(newOffsetLeft);
            triggerScroll({
                x: newOffsetLeft
            });
        }
    }, [
        size.width,
        scrollWidth
    ]);
    // ================================= Ref ==================================
    var delayHideScrollBar = function delayHideScrollBar() {
        var _verticalScrollBarRef, _horizontalScrollBarR;
        (_verticalScrollBarRef = verticalScrollBarRef.current) === null || _verticalScrollBarRef === void 0 || _verticalScrollBarRef.delayHidden();
        (_horizontalScrollBarR = horizontalScrollBarRef.current) === null || _horizontalScrollBarR === void 0 || _horizontalScrollBarR.delayHidden();
    };
    var _scrollTo = (0, $cfqZO.default)(componentRef, mergedData, heights, itemHeight, getKey, function() {
        return collectHeight(true);
    }, syncScrollTop, delayHideScrollBar);
    $jbmdS.useImperativeHandle(ref, function() {
        return {
            nativeElement: containerRef.current,
            getScrollInfo: getVirtualScrollInfo,
            scrollTo: function scrollTo(config) {
                function isPosScroll(arg) {
                    return arg && (0, $jncUt.default)(arg) === "object" && ("left" in arg || "top" in arg);
                }
                if (isPosScroll(config)) {
                    // Scroll X
                    if (config.left !== undefined) setOffsetLeft(keepInHorizontalRange(config.left));
                    // Scroll Y
                    _scrollTo(config.top);
                } else _scrollTo(config);
            }
        };
    });
    // ================================ Effect ================================
    /** We need told outside that some list not rendered */ (0, $iDOLX.default)(function() {
        if (onVisibleChange) {
            var renderList = mergedData.slice(start, end + 1);
            onVisibleChange(renderList, mergedData);
        }
    }, [
        start,
        end,
        mergedData
    ]);
    // ================================ Extra =================================
    var getSize = (0, $e7Ot6.useGetSize)(mergedData, getKey, heights, itemHeight);
    var extraContent = extraRender === null || extraRender === void 0 ? void 0 : extraRender({
        start: start,
        end: end,
        virtual: inVirtual,
        offsetX: offsetLeft,
        offsetY: fillerOffset,
        rtl: isRTL,
        getSize: getSize
    });
    // ================================ Render ================================
    var listChildren = (0, $g2jSS.default)(mergedData, start, end, scrollWidth, offsetLeft, setInstanceRef, children, sharedConfig);
    var componentStyle = null;
    if (height) {
        componentStyle = (0, $lv6ip.default)((0, $8K2NM.default)({}, fullHeight ? "height" : "maxHeight", height), $7895d66a284f9cc2$var$ScrollStyle);
        if (useVirtual) {
            componentStyle.overflowY = "hidden";
            if (scrollWidth) componentStyle.overflowX = "hidden";
            if (scrollMoving) componentStyle.pointerEvents = "none";
        }
    }
    var containerProps = {};
    if (isRTL) containerProps.dir = "rtl";
    return /*#__PURE__*/ $jbmdS.createElement("div", (0, $7i29i.default)({
        ref: containerRef,
        style: (0, $lv6ip.default)((0, $lv6ip.default)({}, style), {}, {
            position: "relative"
        }),
        className: mergedClassName
    }, containerProps, restProps), /*#__PURE__*/ $jbmdS.createElement((0, $fvfrs.default), {
        onResize: onHolderResize
    }, /*#__PURE__*/ $jbmdS.createElement(Component, {
        className: "".concat(prefixCls, "-holder"),
        style: componentStyle,
        ref: componentRef,
        onScroll: onFallbackScroll,
        onMouseEnter: delayHideScrollBar
    }, /*#__PURE__*/ $jbmdS.createElement((0, $iQRuM.default), {
        prefixCls: prefixCls,
        height: scrollHeight,
        offsetX: offsetLeft,
        offsetY: fillerOffset,
        scrollWidth: scrollWidth,
        onInnerResize: collectHeight,
        ref: fillerInnerRef,
        innerProps: innerProps,
        rtl: isRTL,
        extra: extraContent
    }, listChildren))), inVirtual && scrollHeight > height && /*#__PURE__*/ $jbmdS.createElement((0, $5JMUu.default), {
        ref: verticalScrollBarRef,
        prefixCls: prefixCls,
        scrollOffset: offsetTop,
        scrollRange: scrollHeight,
        rtl: isRTL,
        onScroll: onScrollBar,
        onStartMove: onScrollbarStartMove,
        onStopMove: onScrollbarStopMove,
        spinSize: verticalScrollBarSpinSize,
        containerSize: size.height,
        style: styles === null || styles === void 0 ? void 0 : styles.verticalScrollBar,
        thumbStyle: styles === null || styles === void 0 ? void 0 : styles.verticalScrollBarThumb
    }), inVirtual && scrollWidth > size.width && /*#__PURE__*/ $jbmdS.createElement((0, $5JMUu.default), {
        ref: horizontalScrollBarRef,
        prefixCls: prefixCls,
        scrollOffset: offsetLeft,
        scrollRange: scrollWidth,
        rtl: isRTL,
        onScroll: onScrollBar,
        onStartMove: onScrollbarStartMove,
        onStopMove: onScrollbarStopMove,
        spinSize: horizontalScrollBarSpinSize,
        containerSize: size.width,
        horizontal: true,
        style: styles === null || styles === void 0 ? void 0 : styles.horizontalScrollBar,
        thumbStyle: styles === null || styles === void 0 ? void 0 : styles.horizontalScrollBarThumb
    }));
}
var $7895d66a284f9cc2$var$List = /*#__PURE__*/ $jbmdS.forwardRef($7895d66a284f9cc2$export$cc3be4e46e8486ed);
$7895d66a284f9cc2$var$List.displayName = "List";
var $7895d66a284f9cc2$export$2e2bcd8739ae039 = $7895d66a284f9cc2$var$List;

});
parcelRegister("iQRuM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db96946354a10183$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $8K2NM = parcelRequire("8K2NM");

var $lv6ip = parcelRequire("lv6ip");

var $jbmdS = parcelRequire("jbmdS");

var $fvfrs = parcelRequire("fvfrs");

var $02LyB = parcelRequire("02LyB");
/**
 * Fill component to provided the scroll content real height.
 */ var $db96946354a10183$var$Filler = /*#__PURE__*/ $jbmdS.forwardRef(function(_ref, ref) {
    var height = _ref.height, offsetY = _ref.offsetY, offsetX = _ref.offsetX, children = _ref.children, prefixCls = _ref.prefixCls, onInnerResize = _ref.onInnerResize, innerProps = _ref.innerProps, rtl = _ref.rtl, extra = _ref.extra;
    var outerStyle = {};
    var innerStyle = {
        display: "flex",
        flexDirection: "column"
    };
    if (offsetY !== undefined) {
        // Not set `width` since this will break `sticky: right`
        outerStyle = {
            height: height,
            position: "relative",
            overflow: "hidden"
        };
        innerStyle = (0, $lv6ip.default)((0, $lv6ip.default)({}, innerStyle), {}, (0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)({
            transform: "translateY(".concat(offsetY, "px)")
        }, rtl ? "marginRight" : "marginLeft", -offsetX), "position", "absolute"), "left", 0), "right", 0), "top", 0));
    }
    return /*#__PURE__*/ $jbmdS.createElement("div", {
        style: outerStyle
    }, /*#__PURE__*/ $jbmdS.createElement((0, $fvfrs.default), {
        onResize: function onResize(_ref2) {
            var offsetHeight = _ref2.offsetHeight;
            if (offsetHeight && onInnerResize) onInnerResize();
        }
    }, /*#__PURE__*/ $jbmdS.createElement("div", (0, $7i29i.default)({
        style: innerStyle,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))((0, $8K2NM.default)({}, "".concat(prefixCls, "-holder-inner"), prefixCls)),
        ref: ref
    }, innerProps), children, extra)));
});
$db96946354a10183$var$Filler.displayName = "Filler";
var $db96946354a10183$export$2e2bcd8739ae039 = $db96946354a10183$var$Filler;

});

parcelRegister("g2jSS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bacc41caaadb8e88$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");

var $iWpsr = parcelRequire("iWpsr");
function $bacc41caaadb8e88$export$2e2bcd8739ae039(list, startIndex, endIndex, scrollWidth, offsetX, setNodeRef, renderFunc, _ref) {
    var getKey = _ref.getKey;
    return list.slice(startIndex, endIndex + 1).map(function(item, index) {
        var eleIndex = startIndex + index;
        var node = renderFunc(item, eleIndex, {
            style: {
                width: scrollWidth
            },
            offsetX: offsetX
        });
        var key = getKey(item);
        return /*#__PURE__*/ $jbmdS.createElement((0, $iWpsr.Item), {
            key: key,
            setRef: function setRef(ele) {
                return setNodeRef(item, ele);
            }
        }, node);
    });
}

});
parcelRegister("iWpsr", function(module, exports) {

$parcel$export(module.exports, "Item", function () { return $dca16423bc9f994a$export$6d08773d2e66f8f2; });

var $jbmdS = parcelRequire("jbmdS");
function $dca16423bc9f994a$export$6d08773d2e66f8f2(_ref) {
    var children = _ref.children, setRef = _ref.setRef;
    var refFunc = $jbmdS.useCallback(function(node) {
        setRef(node);
    }, []);
    return /*#__PURE__*/ $jbmdS.cloneElement(children, {
        ref: refFunc
    });
}

});


parcelRegister("dK7tv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0155e937f55467b$export$2e2bcd8739ae039; });

var $CZyex = parcelRequire("CZyex");

var $jbmdS = parcelRequire("jbmdS");

var $3QY4P = parcelRequire("3QY4P");
function $a0155e937f55467b$export$2e2bcd8739ae039(data, getKey, onDiff) {
    var _React$useState = $jbmdS.useState(data), _React$useState2 = (0, $CZyex.default)(_React$useState, 2), prevData = _React$useState2[0], setPrevData = _React$useState2[1];
    var _React$useState3 = $jbmdS.useState(null), _React$useState4 = (0, $CZyex.default)(_React$useState3, 2), diffItem = _React$useState4[0], setDiffItem = _React$useState4[1];
    $jbmdS.useEffect(function() {
        var diff = (0, $3QY4P.findListDiffIndex)(prevData || [], data || [], getKey);
        if ((diff === null || diff === void 0 ? void 0 : diff.index) !== undefined) {
            onDiff === null || onDiff === void 0 || onDiff(diff.index);
            setDiffItem(data[diff.index]);
        }
        setPrevData(data);
    }, [
        data
    ]);
    return [
        diffItem
    ];
}

});
parcelRegister("3QY4P", function(module, exports) {

$parcel$export(module.exports, "findListDiffIndex", function () { return $2ce4d472743d2d52$export$418b8d8b03eefdf5; });
/**
 * Get index with specific start index one by one. e.g.
 * min: 3, max: 9, start: 6
 *
 * Return index is:
 * [0]: 6
 * [1]: 7
 * [2]: 5
 * [3]: 8
 * [4]: 4
 * [5]: 9
 * [6]: 3
 */ function $2ce4d472743d2d52$export$38f9023d45dd4a23(min, max, start, index) {
    var beforeCount = start - min;
    var afterCount = max - start;
    var balanceCount = Math.min(beforeCount, afterCount) * 2;
    // Balance
    if (index <= balanceCount) {
        var stepIndex = Math.floor(index / 2);
        if (index % 2) return start + stepIndex + 1;
        return start - stepIndex;
    }
    // One is out of range
    if (beforeCount > afterCount) return start - (index - afterCount);
    return start + (index - beforeCount);
}
function $2ce4d472743d2d52$export$418b8d8b03eefdf5(originList, targetList, getKey) {
    var originLen = originList.length;
    var targetLen = targetList.length;
    var shortList;
    var longList;
    if (originLen === 0 && targetLen === 0) return null;
    if (originLen < targetLen) {
        shortList = originList;
        longList = targetList;
    } else {
        shortList = targetList;
        longList = originList;
    }
    var notExistKey = {
        __EMPTY_ITEM__: true
    };
    function getItemKey(item) {
        if (item !== undefined) return getKey(item);
        return notExistKey;
    }
    // Loop to find diff one
    var diffIndex = null;
    var multiple = Math.abs(originLen - targetLen) !== 1;
    for(var i = 0; i < longList.length; i += 1){
        var shortKey = getItemKey(shortList[i]);
        var longKey = getItemKey(longList[i]);
        if (shortKey !== longKey) {
            diffIndex = i;
            multiple = multiple || shortKey !== getItemKey(longList[i + 1]);
            break;
        }
    }
    return diffIndex === null ? null : {
        index: diffIndex,
        multiple: multiple
    };
}

});


parcelRegister("f6uC4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afef29adf0a77492$export$2e2bcd8739ae039; });

var $2iJQe = parcelRequire("2iJQe");

var $jbmdS = parcelRequire("jbmdS");

var $av9Qz = parcelRequire("av9Qz");

var $aaUmB = parcelRequire("aaUmB");
function $afef29adf0a77492$export$2e2bcd8739ae039(inVirtual, isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight, horizontalScroll, /***
 * Return `true` when you need to prevent default event
 */ onWheelDelta) {
    var offsetRef = (0, $jbmdS.useRef)(0);
    var nextFrameRef = (0, $jbmdS.useRef)(null);
    // Firefox patch
    var wheelValueRef = (0, $jbmdS.useRef)(null);
    var isMouseScrollRef = (0, $jbmdS.useRef)(false);
    // Scroll status sync
    var originScroll = (0, $aaUmB.default)(isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight);
    function onWheelY(e, deltaY) {
        (0, $2iJQe.default).cancel(nextFrameRef.current);
        // Do nothing when scroll at the edge, Skip check when is in scroll
        if (originScroll(false, deltaY)) return;
        // Skip if nest List has handled this event
        var event = e;
        if (!event._virtualHandled) event._virtualHandled = true;
        else return;
        offsetRef.current += deltaY;
        wheelValueRef.current = deltaY;
        // Proxy of scroll events
        if (!(0, $av9Qz.default)) event.preventDefault();
        nextFrameRef.current = (0, $2iJQe.default)(function() {
            // Patch a multiple for Firefox to fix wheel number too small
            // ref: https://github.com/ant-design/ant-design/issues/26372#issuecomment-679460266
            var patchMultiple = isMouseScrollRef.current ? 10 : 1;
            onWheelDelta(offsetRef.current * patchMultiple, false);
            offsetRef.current = 0;
        });
    }
    function onWheelX(event, deltaX) {
        onWheelDelta(deltaX, true);
        if (!(0, $av9Qz.default)) event.preventDefault();
    }
    // Check for which direction does wheel do. `sx` means `shift + wheel`
    var wheelDirectionRef = (0, $jbmdS.useRef)(null);
    var wheelDirectionCleanRef = (0, $jbmdS.useRef)(null);
    function onWheel(event) {
        if (!inVirtual) return;
        // Wait for 2 frame to clean direction
        (0, $2iJQe.default).cancel(wheelDirectionCleanRef.current);
        wheelDirectionCleanRef.current = (0, $2iJQe.default)(function() {
            wheelDirectionRef.current = null;
        }, 2);
        var deltaX = event.deltaX, deltaY = event.deltaY, shiftKey = event.shiftKey;
        var mergedDeltaX = deltaX;
        var mergedDeltaY = deltaY;
        if (wheelDirectionRef.current === "sx" || !wheelDirectionRef.current && (shiftKey || false) && deltaY && !deltaX) {
            mergedDeltaX = deltaY;
            mergedDeltaY = 0;
            wheelDirectionRef.current = "sx";
        }
        var absX = Math.abs(mergedDeltaX);
        var absY = Math.abs(mergedDeltaY);
        if (wheelDirectionRef.current === null) wheelDirectionRef.current = horizontalScroll && absX > absY ? "x" : "y";
        if (wheelDirectionRef.current === "y") onWheelY(event, mergedDeltaY);
        else onWheelX(event, mergedDeltaX);
    }
    // A patch for firefox
    function onFireFoxScroll(event) {
        if (!inVirtual) return;
        isMouseScrollRef.current = event.detail === wheelValueRef.current;
    }
    return [
        onWheel,
        onFireFoxScroll
    ];
}

});
parcelRegister("av9Qz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a54700a00032b9b$export$2e2bcd8739ae039; });

var $jncUt = parcelRequire("jncUt");
var $7a54700a00032b9b$var$isFF = (typeof navigator === "undefined" ? "undefined" : (0, $jncUt.default)(navigator)) === "object" && /Firefox/i.test(navigator.userAgent);
var $7a54700a00032b9b$export$2e2bcd8739ae039 = $7a54700a00032b9b$var$isFF;

});

parcelRegister("aaUmB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76868f300e958058$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");
var $76868f300e958058$export$2e2bcd8739ae039 = function(isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight) {
    // Do lock for a wheel when scrolling
    var lockRef = (0, $jbmdS.useRef)(false);
    var lockTimeoutRef = (0, $jbmdS.useRef)(null);
    function lockScroll() {
        clearTimeout(lockTimeoutRef.current);
        lockRef.current = true;
        lockTimeoutRef.current = setTimeout(function() {
            lockRef.current = false;
        }, 50);
    }
    // Pass to ref since global add is in closure
    var scrollPingRef = (0, $jbmdS.useRef)({
        top: isScrollAtTop,
        bottom: isScrollAtBottom,
        left: isScrollAtLeft,
        right: isScrollAtRight
    });
    scrollPingRef.current.top = isScrollAtTop;
    scrollPingRef.current.bottom = isScrollAtBottom;
    scrollPingRef.current.left = isScrollAtLeft;
    scrollPingRef.current.right = isScrollAtRight;
    return function(isHorizontal, delta) {
        var smoothOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var originScroll = isHorizontal ? // Pass origin wheel when on the left
        delta < 0 && scrollPingRef.current.left || // Pass origin wheel when on the right
        delta > 0 && scrollPingRef.current.right // Pass origin wheel when on the top
         : delta < 0 && scrollPingRef.current.top || // Pass origin wheel when on the bottom
        delta > 0 && scrollPingRef.current.bottom;
        if (smoothOffset && originScroll) {
            // No need lock anymore when it's smooth offset from touchMove interval
            clearTimeout(lockTimeoutRef.current);
            lockRef.current = false;
        } else if (!originScroll || lockRef.current) lockScroll();
        return !lockRef.current && originScroll;
    };
};

});


parcelRegister("e7Ot6", function(module, exports) {

$parcel$export(module.exports, "useGetSize", function () { return $a488de17c34f3f9d$export$a1d82723752af087; });

var $CZyex = parcelRequire("CZyex");

var $jbmdS = parcelRequire("jbmdS");
function $a488de17c34f3f9d$export$a1d82723752af087(mergedData, getKey, heights, itemHeight) {
    var _React$useMemo = $jbmdS.useMemo(function() {
        return [
            new Map(),
            []
        ];
    }, [
        mergedData,
        heights.id,
        itemHeight
    ]), _React$useMemo2 = (0, $CZyex.default)(_React$useMemo, 2), key2Index = _React$useMemo2[0], bottomList = _React$useMemo2[1];
    var getSize = function getSize(startKey) {
        var endKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : startKey;
        // Get from cache first
        var startIndex = key2Index.get(startKey);
        var endIndex = key2Index.get(endKey);
        // Loop to fill the cache
        if (startIndex === undefined || endIndex === undefined) {
            var dataLen = mergedData.length;
            for(var i = bottomList.length; i < dataLen; i += 1){
                var _heights$get;
                var item = mergedData[i];
                var key = getKey(item);
                key2Index.set(key, i);
                var cacheHeight = (_heights$get = heights.get(key)) !== null && _heights$get !== void 0 ? _heights$get : itemHeight;
                bottomList[i] = (bottomList[i - 1] || 0) + cacheHeight;
                if (key === startKey) startIndex = i;
                if (key === endKey) endIndex = i;
                if (startIndex !== undefined && endIndex !== undefined) break;
            }
        }
        return {
            top: bottomList[startIndex - 1] || 0,
            bottom: bottomList[endIndex]
        };
    };
    return getSize;
}

});

parcelRegister("9hLwY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c2a9234c6937a53$export$2e2bcd8739ae039; });

var $CZyex = parcelRequire("CZyex");

var $jbmdS = parcelRequire("jbmdS");

var $1RfjE = parcelRequire("1RfjE");

var $2iJQe = parcelRequire("2iJQe");

var $6idwi = parcelRequire("6idwi");
function $6c2a9234c6937a53$export$2e2bcd8739ae039(getKey, onItemAdd, onItemRemove) {
    var _React$useState = $jbmdS.useState(0), _React$useState2 = (0, $CZyex.default)(_React$useState, 2), updatedMark = _React$useState2[0], setUpdatedMark = _React$useState2[1];
    var instanceRef = (0, $jbmdS.useRef)(new Map());
    var heightsRef = (0, $jbmdS.useRef)(new (0, $6idwi.default)());
    var collectRafRef = (0, $jbmdS.useRef)();
    function cancelRaf() {
        (0, $2iJQe.default).cancel(collectRafRef.current);
    }
    function collectHeight() {
        var sync = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        cancelRaf();
        var doCollect = function doCollect() {
            instanceRef.current.forEach(function(element, key) {
                if (element && element.offsetParent) {
                    var htmlElement = (0, $1RfjE.default)(element);
                    var offsetHeight = htmlElement.offsetHeight;
                    if (heightsRef.current.get(key) !== offsetHeight) heightsRef.current.set(key, htmlElement.offsetHeight);
                }
            });
            // Always trigger update mark to tell parent that should re-calculate heights when resized
            setUpdatedMark(function(c) {
                return c + 1;
            });
        };
        if (sync) doCollect();
        else collectRafRef.current = (0, $2iJQe.default)(doCollect);
    }
    function setInstanceRef(item, instance) {
        var key = getKey(item);
        var origin = instanceRef.current.get(key);
        if (instance) {
            instanceRef.current.set(key, instance);
            collectHeight();
        } else instanceRef.current.delete(key);
        // Instance changed
        if (!origin !== !instance) {
            if (instance) onItemAdd === null || onItemAdd === void 0 || onItemAdd(item);
            else onItemRemove === null || onItemRemove === void 0 || onItemRemove(item);
        }
    }
    (0, $jbmdS.useEffect)(function() {
        return cancelRaf;
    }, []);
    return [
        setInstanceRef,
        collectHeight,
        heightsRef.current,
        updatedMark
    ];
}

});
parcelRegister("6idwi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $494ee949afb9d72d$export$2e2bcd8739ae039; });

var $3GVdq = parcelRequire("3GVdq");

var $jj5jQ = parcelRequire("jj5jQ");

var $8K2NM = parcelRequire("8K2NM");
// Firefox has low performance of map.
var $494ee949afb9d72d$var$CacheMap = /*#__PURE__*/ function() {
    function CacheMap() {
        (0, $3GVdq.default)(this, CacheMap);
        (0, $8K2NM.default)(this, "maps", void 0);
        // Used for cache key
        // `useMemo` no need to update if `id` not change
        (0, $8K2NM.default)(this, "id", 0);
        this.maps = Object.create(null);
    }
    (0, $jj5jQ.default)(CacheMap, [
        {
            key: "set",
            value: function set(key, value) {
                this.maps[key] = value;
                this.id += 1;
            }
        },
        {
            key: "get",
            value: function get(key) {
                return this.maps[key];
            }
        }
    ]);
    return CacheMap;
}();
var $494ee949afb9d72d$export$2e2bcd8739ae039 = $494ee949afb9d72d$var$CacheMap;

});


parcelRegister("bh0bX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83516e5ae749ec3f$export$2e2bcd8739ae039; });

var $iDOLX = parcelRequire("iDOLX");

var $jbmdS = parcelRequire("jbmdS");
var $83516e5ae749ec3f$var$SMOOTH_PTG = 14 / 15;
function $83516e5ae749ec3f$export$2e2bcd8739ae039(inVirtual, listRef, callback) {
    var touchedRef = (0, $jbmdS.useRef)(false);
    var touchXRef = (0, $jbmdS.useRef)(0);
    var touchYRef = (0, $jbmdS.useRef)(0);
    var elementRef = (0, $jbmdS.useRef)(null);
    // Smooth scroll
    var intervalRef = (0, $jbmdS.useRef)(null);
    /* eslint-disable prefer-const */ var cleanUpEvents;
    var onTouchMove = function onTouchMove(e) {
        if (touchedRef.current) {
            var currentX = Math.ceil(e.touches[0].pageX);
            var currentY = Math.ceil(e.touches[0].pageY);
            var offsetX = touchXRef.current - currentX;
            var offsetY = touchYRef.current - currentY;
            var _isHorizontal = Math.abs(offsetX) > Math.abs(offsetY);
            if (_isHorizontal) touchXRef.current = currentX;
            else touchYRef.current = currentY;
            var scrollHandled = callback(_isHorizontal, _isHorizontal ? offsetX : offsetY, false, e);
            if (scrollHandled) e.preventDefault();
            // Smooth interval
            clearInterval(intervalRef.current);
            if (scrollHandled) intervalRef.current = setInterval(function() {
                if (_isHorizontal) offsetX *= $83516e5ae749ec3f$var$SMOOTH_PTG;
                else offsetY *= $83516e5ae749ec3f$var$SMOOTH_PTG;
                var offset = Math.floor(_isHorizontal ? offsetX : offsetY);
                if (!callback(_isHorizontal, offset, true) || Math.abs(offset) <= 0.1) clearInterval(intervalRef.current);
            }, 16);
        }
    };
    var onTouchEnd = function onTouchEnd() {
        touchedRef.current = false;
        cleanUpEvents();
    };
    var onTouchStart = function onTouchStart(e) {
        cleanUpEvents();
        if (e.touches.length === 1 && !touchedRef.current) {
            touchedRef.current = true;
            touchXRef.current = Math.ceil(e.touches[0].pageX);
            touchYRef.current = Math.ceil(e.touches[0].pageY);
            elementRef.current = e.target;
            elementRef.current.addEventListener("touchmove", onTouchMove, {
                passive: false
            });
            elementRef.current.addEventListener("touchend", onTouchEnd, {
                passive: true
            });
        }
    };
    cleanUpEvents = function cleanUpEvents() {
        if (elementRef.current) {
            elementRef.current.removeEventListener("touchmove", onTouchMove);
            elementRef.current.removeEventListener("touchend", onTouchEnd);
        }
    };
    (0, $iDOLX.default)(function() {
        if (inVirtual) listRef.current.addEventListener("touchstart", onTouchStart, {
            passive: true
        });
        return function() {
            var _listRef$current;
            (_listRef$current = listRef.current) === null || _listRef$current === void 0 || _listRef$current.removeEventListener("touchstart", onTouchStart);
            cleanUpEvents();
            clearInterval(intervalRef.current);
        };
    }, [
        inVirtual
    ]);
}

});

parcelRegister("cfqZO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8eabd399bb33ccdb$export$2e2bcd8739ae039; });

var $jncUt = parcelRequire("jncUt");

var $lv6ip = parcelRequire("lv6ip");

var $CZyex = parcelRequire("CZyex");

var $jbmdS = parcelRequire("jbmdS");

var $2iJQe = parcelRequire("2iJQe");

var $iDOLX = parcelRequire("iDOLX");
parcelRequire("7AQNp");
var $8eabd399bb33ccdb$var$MAX_TIMES = 10;
function $8eabd399bb33ccdb$export$2e2bcd8739ae039(containerRef, data, heights, itemHeight, getKey, collectHeight, syncScrollTop, triggerFlash) {
    var scrollRef = $jbmdS.useRef();
    var _React$useState = $jbmdS.useState(null), _React$useState2 = (0, $CZyex.default)(_React$useState, 2), syncState = _React$useState2[0], setSyncState = _React$useState2[1];
    // ========================== Sync Scroll ==========================
    (0, $iDOLX.default)(function() {
        if (syncState && syncState.times < $8eabd399bb33ccdb$var$MAX_TIMES) {
            // Never reach
            if (!containerRef.current) {
                setSyncState(function(ori) {
                    return (0, $lv6ip.default)({}, ori);
                });
                return;
            }
            collectHeight();
            var targetAlign = syncState.targetAlign, originAlign = syncState.originAlign, index = syncState.index, offset = syncState.offset;
            var height = containerRef.current.clientHeight;
            var needCollectHeight = false;
            var newTargetAlign = targetAlign;
            var targetTop = null;
            // Go to next frame if height not exist
            if (height) {
                var mergedAlign = targetAlign || originAlign;
                // Get top & bottom
                var stackTop = 0;
                var itemTop = 0;
                var itemBottom = 0;
                var maxLen = Math.min(data.length - 1, index);
                for(var i = 0; i <= maxLen; i += 1){
                    var key = getKey(data[i]);
                    itemTop = stackTop;
                    var cacheHeight = heights.get(key);
                    itemBottom = itemTop + (cacheHeight === undefined ? itemHeight : cacheHeight);
                    stackTop = itemBottom;
                }
                // Check if need sync height (visible range has item not record height)
                var leftHeight = mergedAlign === "top" ? offset : height - offset;
                for(var _i = maxLen; _i >= 0; _i -= 1){
                    var _key = getKey(data[_i]);
                    var _cacheHeight = heights.get(_key);
                    if (_cacheHeight === undefined) {
                        needCollectHeight = true;
                        break;
                    }
                    leftHeight -= _cacheHeight;
                    if (leftHeight <= 0) break;
                }
                // Scroll to
                switch(mergedAlign){
                    case "top":
                        targetTop = itemTop - offset;
                        break;
                    case "bottom":
                        targetTop = itemBottom - height + offset;
                        break;
                    default:
                        var scrollTop = containerRef.current.scrollTop;
                        var scrollBottom = scrollTop + height;
                        if (itemTop < scrollTop) newTargetAlign = "top";
                        else if (itemBottom > scrollBottom) newTargetAlign = "bottom";
                }
                if (targetTop !== null) syncScrollTop(targetTop);
                // One more time for sync
                if (targetTop !== syncState.lastTop) needCollectHeight = true;
            }
            // Trigger next effect
            if (needCollectHeight) setSyncState((0, $lv6ip.default)((0, $lv6ip.default)({}, syncState), {}, {
                times: syncState.times + 1,
                targetAlign: newTargetAlign,
                lastTop: targetTop
            }));
        }
    }, [
        syncState,
        containerRef.current
    ]);
    // =========================== Scroll To ===========================
    return function(arg) {
        // When not argument provided, we think dev may want to show the scrollbar
        if (arg === null || arg === undefined) {
            triggerFlash();
            return;
        }
        // Normal scroll logic
        (0, $2iJQe.default).cancel(scrollRef.current);
        if (typeof arg === "number") syncScrollTop(arg);
        else if (arg && (0, $jncUt.default)(arg) === "object") {
            var index;
            var align = arg.align;
            if ("index" in arg) index = arg.index;
            else index = data.findIndex(function(item) {
                return getKey(item) === arg.key;
            });
            var _arg$offset = arg.offset, offset = _arg$offset === void 0 ? 0 : _arg$offset;
            setSyncState({
                times: 0,
                index: index,
                offset: offset,
                originAlign: align
            });
        }
    };
}

});

parcelRegister("5JMUu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42d71844761ec82e$export$2e2bcd8739ae039; });

var $lv6ip = parcelRequire("lv6ip");

var $8K2NM = parcelRequire("8K2NM");

var $CZyex = parcelRequire("CZyex");

var $02LyB = parcelRequire("02LyB");

var $2iJQe = parcelRequire("2iJQe");

var $jbmdS = parcelRequire("jbmdS");
function $42d71844761ec82e$var$getPageXY(e, horizontal) {
    var obj = "touches" in e ? e.touches[0] : e;
    return obj[horizontal ? "pageX" : "pageY"];
}
var $42d71844761ec82e$var$ScrollBar = /*#__PURE__*/ $jbmdS.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, rtl = props.rtl, scrollOffset = props.scrollOffset, scrollRange = props.scrollRange, onStartMove = props.onStartMove, onStopMove = props.onStopMove, onScroll = props.onScroll, horizontal = props.horizontal, spinSize = props.spinSize, containerSize = props.containerSize, style = props.style, propsThumbStyle = props.thumbStyle;
    var _React$useState = $jbmdS.useState(false), _React$useState2 = (0, $CZyex.default)(_React$useState, 2), dragging = _React$useState2[0], setDragging = _React$useState2[1];
    var _React$useState3 = $jbmdS.useState(null), _React$useState4 = (0, $CZyex.default)(_React$useState3, 2), pageXY = _React$useState4[0], setPageXY = _React$useState4[1];
    var _React$useState5 = $jbmdS.useState(null), _React$useState6 = (0, $CZyex.default)(_React$useState5, 2), startTop = _React$useState6[0], setStartTop = _React$useState6[1];
    var isLTR = !rtl;
    // ========================= Refs =========================
    var scrollbarRef = $jbmdS.useRef();
    var thumbRef = $jbmdS.useRef();
    // ======================= Visible ========================
    var _React$useState7 = $jbmdS.useState(false), _React$useState8 = (0, $CZyex.default)(_React$useState7, 2), visible = _React$useState8[0], setVisible = _React$useState8[1];
    var visibleTimeoutRef = $jbmdS.useRef();
    var delayHidden = function delayHidden() {
        clearTimeout(visibleTimeoutRef.current);
        setVisible(true);
        visibleTimeoutRef.current = setTimeout(function() {
            setVisible(false);
        }, 3000);
    };
    // ======================== Range =========================
    var enableScrollRange = scrollRange - containerSize || 0;
    var enableOffsetRange = containerSize - spinSize || 0;
    // ========================= Top ==========================
    var top = $jbmdS.useMemo(function() {
        if (scrollOffset === 0 || enableScrollRange === 0) return 0;
        var ptg = scrollOffset / enableScrollRange;
        return ptg * enableOffsetRange;
    }, [
        scrollOffset,
        enableScrollRange,
        enableOffsetRange
    ]);
    // ====================== Container =======================
    var onContainerMouseDown = function onContainerMouseDown(e) {
        e.stopPropagation();
        e.preventDefault();
    };
    // ======================== Thumb =========================
    var stateRef = $jbmdS.useRef({
        top: top,
        dragging: dragging,
        pageY: pageXY,
        startTop: startTop
    });
    stateRef.current = {
        top: top,
        dragging: dragging,
        pageY: pageXY,
        startTop: startTop
    };
    var onThumbMouseDown = function onThumbMouseDown(e) {
        setDragging(true);
        setPageXY($42d71844761ec82e$var$getPageXY(e, horizontal));
        setStartTop(stateRef.current.top);
        onStartMove();
        e.stopPropagation();
        e.preventDefault();
    };
    // ======================== Effect ========================
    // React make event as passive, but we need to preventDefault
    // Add event on dom directly instead.
    // ref: https://github.com/facebook/react/issues/9809
    $jbmdS.useEffect(function() {
        var onScrollbarTouchStart = function onScrollbarTouchStart(e) {
            e.preventDefault();
        };
        var scrollbarEle = scrollbarRef.current;
        var thumbEle = thumbRef.current;
        scrollbarEle.addEventListener("touchstart", onScrollbarTouchStart, {
            passive: false
        });
        thumbEle.addEventListener("touchstart", onThumbMouseDown, {
            passive: false
        });
        return function() {
            scrollbarEle.removeEventListener("touchstart", onScrollbarTouchStart);
            thumbEle.removeEventListener("touchstart", onThumbMouseDown);
        };
    }, []);
    // Pass to effect
    var enableScrollRangeRef = $jbmdS.useRef();
    enableScrollRangeRef.current = enableScrollRange;
    var enableOffsetRangeRef = $jbmdS.useRef();
    enableOffsetRangeRef.current = enableOffsetRange;
    $jbmdS.useEffect(function() {
        if (dragging) {
            var moveRafId;
            var onMouseMove = function onMouseMove(e) {
                var _stateRef$current = stateRef.current, stateDragging = _stateRef$current.dragging, statePageY = _stateRef$current.pageY, stateStartTop = _stateRef$current.startTop;
                (0, $2iJQe.default).cancel(moveRafId);
                var rect = scrollbarRef.current.getBoundingClientRect();
                var scale = containerSize / (horizontal ? rect.width : rect.height);
                if (stateDragging) {
                    var offset = ($42d71844761ec82e$var$getPageXY(e, horizontal) - statePageY) * scale;
                    var newTop = stateStartTop;
                    if (!isLTR && horizontal) newTop -= offset;
                    else newTop += offset;
                    var tmpEnableScrollRange = enableScrollRangeRef.current;
                    var tmpEnableOffsetRange = enableOffsetRangeRef.current;
                    var ptg = tmpEnableOffsetRange ? newTop / tmpEnableOffsetRange : 0;
                    var newScrollTop = Math.ceil(ptg * tmpEnableScrollRange);
                    newScrollTop = Math.max(newScrollTop, 0);
                    newScrollTop = Math.min(newScrollTop, tmpEnableScrollRange);
                    moveRafId = (0, $2iJQe.default)(function() {
                        onScroll(newScrollTop, horizontal);
                    });
                }
            };
            var onMouseUp = function onMouseUp() {
                setDragging(false);
                onStopMove();
            };
            window.addEventListener("mousemove", onMouseMove, {
                passive: true
            });
            window.addEventListener("touchmove", onMouseMove, {
                passive: true
            });
            window.addEventListener("mouseup", onMouseUp, {
                passive: true
            });
            window.addEventListener("touchend", onMouseUp, {
                passive: true
            });
            return function() {
                window.removeEventListener("mousemove", onMouseMove);
                window.removeEventListener("touchmove", onMouseMove);
                window.removeEventListener("mouseup", onMouseUp);
                window.removeEventListener("touchend", onMouseUp);
                (0, $2iJQe.default).cancel(moveRafId);
            };
        }
    }, [
        dragging
    ]);
    $jbmdS.useEffect(function() {
        delayHidden();
        return function() {
            clearTimeout(visibleTimeoutRef.current);
        };
    }, [
        scrollOffset
    ]);
    // ====================== Imperative ======================
    $jbmdS.useImperativeHandle(ref, function() {
        return {
            delayHidden: delayHidden
        };
    });
    // ======================== Render ========================
    var scrollbarPrefixCls = "".concat(prefixCls, "-scrollbar");
    var containerStyle = {
        position: "absolute",
        visibility: visible ? null : "hidden"
    };
    var thumbStyle = {
        position: "absolute",
        background: "rgba(0, 0, 0, 0.5)",
        borderRadius: 99,
        cursor: "pointer",
        userSelect: "none"
    };
    if (horizontal) {
        // Container
        containerStyle.height = 8;
        containerStyle.left = 0;
        containerStyle.right = 0;
        containerStyle.bottom = 0;
        // Thumb
        thumbStyle.height = "100%";
        thumbStyle.width = spinSize;
        if (isLTR) thumbStyle.left = top;
        else thumbStyle.right = top;
    } else {
        // Container
        containerStyle.width = 8;
        containerStyle.top = 0;
        containerStyle.bottom = 0;
        if (isLTR) containerStyle.right = 0;
        else containerStyle.left = 0;
        // Thumb
        thumbStyle.width = "100%";
        thumbStyle.height = spinSize;
        thumbStyle.top = top;
    }
    return /*#__PURE__*/ $jbmdS.createElement("div", {
        ref: scrollbarRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(scrollbarPrefixCls, (0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)({}, "".concat(scrollbarPrefixCls, "-horizontal"), horizontal), "".concat(scrollbarPrefixCls, "-vertical"), !horizontal), "".concat(scrollbarPrefixCls, "-visible"), visible)),
        style: (0, $lv6ip.default)((0, $lv6ip.default)({}, containerStyle), style),
        onMouseDown: onContainerMouseDown,
        onMouseMove: delayHidden
    }, /*#__PURE__*/ $jbmdS.createElement("div", {
        ref: thumbRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("".concat(scrollbarPrefixCls, "-thumb"), (0, $8K2NM.default)({}, "".concat(scrollbarPrefixCls, "-thumb-moving"), dragging)),
        style: (0, $lv6ip.default)((0, $lv6ip.default)({}, thumbStyle), propsThumbStyle),
        onMouseDown: onThumbMouseDown
    }));
});
var $42d71844761ec82e$export$2e2bcd8739ae039 = $42d71844761ec82e$var$ScrollBar;

});

parcelRegister("gd3PK", function(module, exports) {

$parcel$export(module.exports, "getSpinSize", function () { return $bcd0d587d0037f88$export$f2ca68955ab35ace; });
var $bcd0d587d0037f88$var$MIN_SIZE = 20;
function $bcd0d587d0037f88$export$f2ca68955ab35ace() {
    var containerSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var scrollRange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var baseSize = containerSize / scrollRange * containerSize;
    if (isNaN(baseSize)) baseSize = 0;
    baseSize = Math.max(baseSize, $bcd0d587d0037f88$var$MIN_SIZE);
    return Math.floor(baseSize);
}

});



parcelRegister("cVAnL", function(module, exports) {

$parcel$export(module.exports, "isPlatformMac", function () { return $969707ae4194d5b3$export$3bbcfec016973a77; });
/* istanbul ignore file */ function $969707ae4194d5b3$export$3bbcfec016973a77() {
    return /(mac\sos|macintosh)/i.test(navigator.appVersion);
}

});

parcelRegister("1TF7a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $161ad20415a960e2$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");
// Use any here since we do not get the type during compilation
var $161ad20415a960e2$var$SelectContext = /*#__PURE__*/ $jbmdS.createContext(null);
var $161ad20415a960e2$export$2e2bcd8739ae039 = $161ad20415a960e2$var$SelectContext;

});


parcelRegister("9HQOu", function(module, exports) {

var $jncUt = parcelRequire("jncUt");

var $5AfDn = parcelRequire("5AfDn");

var $8tMCd = parcelRequire("8tMCd");

var $jbmdS = parcelRequire("jbmdS");

var $awmch = parcelRequire("awmch");

var $gDBzp = parcelRequire("gDBzp");

var $gH1E8 = parcelRequire("gH1E8");
function $711118d5a7274c04$var$warningProps(props) {
    var mode = props.mode, options = props.options, children = props.children, backfill = props.backfill, allowClear = props.allowClear, placeholder = props.placeholder, getInputElement = props.getInputElement, showSearch = props.showSearch, onSearch = props.onSearch, defaultOpen = props.defaultOpen, autoFocus = props.autoFocus, labelInValue = props.labelInValue, value = props.value, inputValue = props.inputValue, optionLabelProp = props.optionLabelProp;
    var multiple = (0, $awmch.isMultiple)(mode);
    var mergedShowSearch = showSearch !== undefined ? showSearch : multiple || mode === "combobox";
    var mergedOptions = options || (0, $gH1E8.convertChildrenToData)(children);
    // `tags` should not set option as disabled
    (0, $8tMCd.default)(mode !== "tags" || mergedOptions.every(function(opt) {
        return !opt.disabled;
    }), "Please avoid setting option to disabled in tags mode since user can always type text as tag.");
    // `combobox` & `tags` should option be `string` type
    if (mode === "tags" || mode === "combobox") {
        var hasNumberValue = mergedOptions.some(function(item) {
            if (item.options) return item.options.some(function(opt) {
                return typeof ("value" in opt ? opt.value : opt.key) === "number";
            });
            return typeof ("value" in item ? item.value : item.key) === "number";
        });
        (0, $8tMCd.default)(!hasNumberValue, "`value` of Option should not use number type when `mode` is `tags` or `combobox`.");
    }
    // `combobox` should not use `optionLabelProp`
    (0, $8tMCd.default)(mode !== "combobox" || !optionLabelProp, "`combobox` mode not support `optionLabelProp`. Please set `value` on Option directly.");
    // Only `combobox` support `backfill`
    (0, $8tMCd.default)(mode === "combobox" || !backfill, "`backfill` only works with `combobox` mode.");
    // Only `combobox` support `getInputElement`
    (0, $8tMCd.default)(mode === "combobox" || !getInputElement, "`getInputElement` only work with `combobox` mode.");
    // Customize `getInputElement` should not use `allowClear` & `placeholder`
    (0, $8tMCd.noteOnce)(mode !== "combobox" || !getInputElement || !allowClear || !placeholder, "Customize `getInputElement` should customize clear and placeholder logic instead of configuring `allowClear` and `placeholder`.");
    // `onSearch` should use in `combobox` or `showSearch`
    if (onSearch && !mergedShowSearch && mode !== "combobox" && mode !== "tags") (0, $8tMCd.default)(false, "`onSearch` should work with `showSearch` instead of use alone.");
    (0, $8tMCd.noteOnce)(!defaultOpen || autoFocus, "`defaultOpen` makes Select open without focus which means it will not close by click outside. You can set `autoFocus` if needed.");
    if (value !== undefined && value !== null) {
        var values = (0, $gDBzp.toArray)(value);
        (0, $8tMCd.default)(!labelInValue || values.every(function(val) {
            return (0, $jncUt.default)(val) === "object" && ("key" in val || "value" in val);
        }), "`value` should in shape of `{ value: string | number, label?: ReactNode }` when you set `labelInValue` to `true`");
        (0, $8tMCd.default)(!multiple || Array.isArray(value), "`value` should be array when `mode` is `multiple` or `tags`");
    }
    // Syntactic sugar should use correct children type
    if (children) {
        var invalidateChildType = null;
        (0, $5AfDn.default)(children).some(function(node) {
            if (!/*#__PURE__*/ $jbmdS.isValidElement(node) || !node.type) return false;
            var _ref = node, type = _ref.type;
            if (type.isSelectOption) return false;
            if (type.isSelectOptGroup) {
                var allChildrenValid = (0, $5AfDn.default)(node.props.children).every(function(subNode) {
                    if (!/*#__PURE__*/ $jbmdS.isValidElement(subNode) || !node.type || subNode.type.isSelectOption) return true;
                    invalidateChildType = subNode.type;
                    return false;
                });
                if (allChildrenValid) return false;
                return true;
            }
            invalidateChildType = type;
            return true;
        });
        if (invalidateChildType) (0, $8tMCd.default)(false, "`children` should be `Select.Option` or `Select.OptGroup` instead of `".concat(invalidateChildType.displayName || invalidateChildType.name || invalidateChildType, "`."));
        (0, $8tMCd.default)(inputValue === undefined, "`inputValue` is deprecated, please use `searchValue` instead.");
    }
}
function $711118d5a7274c04$export$c33a1be4de1ec2c(options, fieldNames) {
    if (options) {
        var recursiveOptions = function recursiveOptions(optionsList) {
            var inGroup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            for(var i = 0; i < optionsList.length; i++){
                var option = optionsList[i];
                if (option[fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.value] === null) {
                    (0, $8tMCd.default)(false, "`value` in Select options should not be `null`.");
                    return true;
                }
                if (!inGroup && Array.isArray(option[fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.options]) && recursiveOptions(option[fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.options], true)) break;
            }
        };
        recursiveOptions(options);
    }
}
var $711118d5a7274c04$export$2e2bcd8739ae039 = $711118d5a7274c04$var$warningProps;

});



parcelRegister("9cRrz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b3eb0db2d05fd22$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("8uDri");
var $ewikT = parcelRequire("ewikT");

var $4GJJu = parcelRequire("4GJJu");
var $6b3eb0db2d05fd22$var$defaultRenderEmpty = function defaultRenderEmpty(componentName) {
    return /*#__PURE__*/ $jbmdS.createElement((0, $ewikT.ConfigConsumer), null, function(_ref) {
        var getPrefixCls = _ref.getPrefixCls;
        var prefix = getPrefixCls("empty");
        switch(componentName){
            case "Table":
            case "List":
                return /*#__PURE__*/ $jbmdS.createElement((0, $4GJJu.default), {
                    image: (0, $4GJJu.default).PRESENTED_IMAGE_SIMPLE
                });
            case "Select":
            case "TreeSelect":
            case "Cascader":
            case "Transfer":
            case "Mentions":
                return /*#__PURE__*/ $jbmdS.createElement((0, $4GJJu.default), {
                    image: (0, $4GJJu.default).PRESENTED_IMAGE_SIMPLE,
                    className: "".concat(prefix, "-small")
                });
            /* istanbul ignore next */ default:
                // Should never hit if we take all the component into consider.
                return /*#__PURE__*/ $jbmdS.createElement((0, $4GJJu.default), null);
        }
    });
};
var $6b3eb0db2d05fd22$export$2e2bcd8739ae039 = $6b3eb0db2d05fd22$var$defaultRenderEmpty;

});
parcelRegister("4GJJu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $369e8f35c68f105a$export$2e2bcd8739ae039; });

var $8K2NM = parcelRequire("8K2NM");

var $7i29i = parcelRequire("7i29i");

var $02LyB = parcelRequire("02LyB");

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("8uDri");
var $ewikT = parcelRequire("ewikT");

var $bGRjq = parcelRequire("bGRjq");

var $30h5p = parcelRequire("30h5p");

var $dhfVi = parcelRequire("dhfVi");
var $369e8f35c68f105a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $369e8f35c68f105a$var$defaultEmptyImg = /*#__PURE__*/ $jbmdS.createElement((0, $30h5p.default), null);
var $369e8f35c68f105a$var$simpleEmptyImg = /*#__PURE__*/ $jbmdS.createElement((0, $dhfVi.default), null);
var $369e8f35c68f105a$var$Empty = function Empty(_a) {
    var className = _a.className, customizePrefixCls = _a.prefixCls, _a$image = _a.image, image = _a$image === void 0 ? $369e8f35c68f105a$var$defaultEmptyImg : _a$image, description = _a.description, children = _a.children, imageStyle = _a.imageStyle, restProps = $369e8f35c68f105a$var$__rest(_a, [
        "className",
        "prefixCls",
        "image",
        "description",
        "children",
        "imageStyle"
    ]);
    var _React$useContext = $jbmdS.useContext((0, $ewikT.ConfigContext)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    return /*#__PURE__*/ $jbmdS.createElement((0, $bGRjq.default), {
        componentName: "Empty"
    }, function(contextLocale) {
        var prefixCls = getPrefixCls("empty", customizePrefixCls);
        var des = typeof description !== "undefined" ? description : contextLocale.description;
        var alt = typeof des === "string" ? des : "empty";
        var imageNode = null;
        if (typeof image === "string") imageNode = /*#__PURE__*/ $jbmdS.createElement("img", {
            alt: alt,
            src: image
        });
        else imageNode = image;
        return /*#__PURE__*/ $jbmdS.createElement("div", (0, $7i29i.default)({
            className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(prefixCls, (0, $8K2NM.default)((0, $8K2NM.default)({}, "".concat(prefixCls, "-normal"), image === $369e8f35c68f105a$var$simpleEmptyImg), "".concat(prefixCls, "-rtl"), direction === "rtl"), className)
        }, restProps), /*#__PURE__*/ $jbmdS.createElement("div", {
            className: "".concat(prefixCls, "-image"),
            style: imageStyle
        }, imageNode), des && /*#__PURE__*/ $jbmdS.createElement("div", {
            className: "".concat(prefixCls, "-description")
        }, des), children && /*#__PURE__*/ $jbmdS.createElement("div", {
            className: "".concat(prefixCls, "-footer")
        }, children));
    });
};
$369e8f35c68f105a$var$Empty.PRESENTED_IMAGE_DEFAULT = $369e8f35c68f105a$var$defaultEmptyImg;
$369e8f35c68f105a$var$Empty.PRESENTED_IMAGE_SIMPLE = $369e8f35c68f105a$var$simpleEmptyImg;
var $369e8f35c68f105a$export$2e2bcd8739ae039 = $369e8f35c68f105a$var$Empty;

});
parcelRegister("30h5p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22fea02b1b91ae27$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("8uDri");
var $ewikT = parcelRequire("ewikT");
var $22fea02b1b91ae27$var$Empty = function Empty() {
    var _React$useContext = $jbmdS.useContext((0, $ewikT.ConfigContext)), getPrefixCls = _React$useContext.getPrefixCls;
    var prefixCls = getPrefixCls("empty-img-default");
    return /*#__PURE__*/ $jbmdS.createElement("svg", {
        className: prefixCls,
        width: "184",
        height: "152",
        viewBox: "0 0 184 152",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $jbmdS.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $jbmdS.createElement("g", {
        transform: "translate(24 31.67)"
    }, /*#__PURE__*/ $jbmdS.createElement("ellipse", {
        className: "".concat(prefixCls, "-ellipse"),
        cx: "67.797",
        cy: "106.89",
        rx: "67.797",
        ry: "12.668"
    }), /*#__PURE__*/ $jbmdS.createElement("path", {
        className: "".concat(prefixCls, "-path-1"),
        d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
    }), /*#__PURE__*/ $jbmdS.createElement("path", {
        className: "".concat(prefixCls, "-path-2"),
        d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
        transform: "translate(13.56)"
    }), /*#__PURE__*/ $jbmdS.createElement("path", {
        className: "".concat(prefixCls, "-path-3"),
        d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
    }), /*#__PURE__*/ $jbmdS.createElement("path", {
        className: "".concat(prefixCls, "-path-4"),
        d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
    })), /*#__PURE__*/ $jbmdS.createElement("path", {
        className: "".concat(prefixCls, "-path-5"),
        d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
    }), /*#__PURE__*/ $jbmdS.createElement("g", {
        className: "".concat(prefixCls, "-g"),
        transform: "translate(149.65 15.383)"
    }, /*#__PURE__*/ $jbmdS.createElement("ellipse", {
        cx: "20.654",
        cy: "3.167",
        rx: "2.849",
        ry: "2.815"
    }), /*#__PURE__*/ $jbmdS.createElement("path", {
        d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
    }))));
};
var $22fea02b1b91ae27$export$2e2bcd8739ae039 = $22fea02b1b91ae27$var$Empty;

});

parcelRegister("dhfVi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9aa936e5f1a9a512$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("8uDri");
var $ewikT = parcelRequire("ewikT");
var $9aa936e5f1a9a512$var$Simple = function Simple() {
    var _React$useContext = $jbmdS.useContext((0, $ewikT.ConfigContext)), getPrefixCls = _React$useContext.getPrefixCls;
    var prefixCls = getPrefixCls("empty-img-simple");
    return /*#__PURE__*/ $jbmdS.createElement("svg", {
        className: prefixCls,
        width: "64",
        height: "41",
        viewBox: "0 0 64 41",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $jbmdS.createElement("g", {
        transform: "translate(0 1)",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $jbmdS.createElement("ellipse", {
        className: "".concat(prefixCls, "-ellipse"),
        cx: "32",
        cy: "33",
        rx: "32",
        ry: "7"
    }), /*#__PURE__*/ $jbmdS.createElement("g", {
        className: "".concat(prefixCls, "-g"),
        fillRule: "nonzero"
    }, /*#__PURE__*/ $jbmdS.createElement("path", {
        d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
    }), /*#__PURE__*/ $jbmdS.createElement("path", {
        d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
        className: "".concat(prefixCls, "-path")
    }))));
};
var $9aa936e5f1a9a512$export$2e2bcd8739ae039 = $9aa936e5f1a9a512$var$Simple;

});



parcelRegister("5Tk2v", function(module, exports) {

$parcel$export(module.exports, "getTransitionDirection", function () { return $44a1a235d9a79a73$export$b2382d4a41c58fef; });
$parcel$export(module.exports, "getTransitionName", function () { return $44a1a235d9a79a73$export$27c72201b1d09951; });

var $3IdWL = parcelRequire("3IdWL");
// ================== Collapse Motion ==================
var $44a1a235d9a79a73$var$getCollapsedHeight = function getCollapsedHeight() {
    return {
        height: 0,
        opacity: 0
    };
};
var $44a1a235d9a79a73$var$getRealHeight = function getRealHeight(node) {
    var scrollHeight = node.scrollHeight;
    return {
        height: scrollHeight,
        opacity: 1
    };
};
var $44a1a235d9a79a73$var$getCurrentHeight = function getCurrentHeight(node) {
    return {
        height: node ? node.offsetHeight : 0
    };
};
var $44a1a235d9a79a73$var$skipOpacityTransition = function skipOpacityTransition(_, event) {
    return (event === null || event === void 0 ? void 0 : event.deadline) === true || event.propertyName === "height";
};
var $44a1a235d9a79a73$var$collapseMotion = {
    motionName: "ant-motion-collapse",
    onAppearStart: $44a1a235d9a79a73$var$getCollapsedHeight,
    onEnterStart: $44a1a235d9a79a73$var$getCollapsedHeight,
    onAppearActive: $44a1a235d9a79a73$var$getRealHeight,
    onEnterActive: $44a1a235d9a79a73$var$getRealHeight,
    onLeaveStart: $44a1a235d9a79a73$var$getCurrentHeight,
    onLeaveActive: $44a1a235d9a79a73$var$getCollapsedHeight,
    onAppearEnd: $44a1a235d9a79a73$var$skipOpacityTransition,
    onEnterEnd: $44a1a235d9a79a73$var$skipOpacityTransition,
    onLeaveEnd: $44a1a235d9a79a73$var$skipOpacityTransition,
    motionDeadline: 500
};
var $44a1a235d9a79a73$var$SelectPlacements = (0, $3IdWL.tuple)("bottomLeft", "bottomRight", "topLeft", "topRight");
var $44a1a235d9a79a73$export$b2382d4a41c58fef = function getTransitionDirection(placement) {
    if (placement !== undefined && (placement === "topLeft" || placement === "topRight")) return "slide-down";
    return "slide-up";
};
var $44a1a235d9a79a73$export$27c72201b1d09951 = function getTransitionName(rootPrefixCls, motion, transitionName) {
    if (transitionName !== undefined) return transitionName;
    return "".concat(rootPrefixCls, "-").concat(motion);
};
var $44a1a235d9a79a73$export$2e2bcd8739ae039 = $44a1a235d9a79a73$var$collapseMotion;

});

parcelRegister("9ULK8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $737e60d1e4740a17$export$2e2bcd8739ae039; });

var $cOGaE = parcelRequire("cOGaE");

var $kPBAG = parcelRequire("kPBAG");

var $8u58w = parcelRequire("8u58w");

var $4AJEj = parcelRequire("4AJEj");

var $97QHC = parcelRequire("97QHC");

var $lCuWO = parcelRequire("lCuWO");

var $jbmdS = parcelRequire("jbmdS");
function $737e60d1e4740a17$export$2e2bcd8739ae039(_ref) {
    var suffixIcon = _ref.suffixIcon, clearIcon = _ref.clearIcon, menuItemSelectedIcon = _ref.menuItemSelectedIcon, removeIcon = _ref.removeIcon, loading = _ref.loading, multiple = _ref.multiple, hasFeedback = _ref.hasFeedback, prefixCls = _ref.prefixCls, showArrow = _ref.showArrow, feedbackIcon = _ref.feedbackIcon;
    // Clear Icon
    var mergedClearIcon = clearIcon !== null && clearIcon !== void 0 ? clearIcon : /*#__PURE__*/ $jbmdS.createElement((0, $kPBAG.default), null);
    // Validation Feedback Icon
    var getSuffixIconNode = function getSuffixIconNode(arrowIcon) {
        return /*#__PURE__*/ $jbmdS.createElement($jbmdS.Fragment, null, showArrow !== false && arrowIcon, hasFeedback && feedbackIcon);
    };
    // Arrow item icon
    var mergedSuffixIcon = null;
    if (suffixIcon !== undefined) mergedSuffixIcon = getSuffixIconNode(suffixIcon);
    else if (loading) mergedSuffixIcon = getSuffixIconNode(/*#__PURE__*/ $jbmdS.createElement((0, $97QHC.default), {
        spin: true
    }));
    else {
        var iconCls = "".concat(prefixCls, "-suffix");
        mergedSuffixIcon = function mergedSuffixIcon(_ref2) {
            var open = _ref2.open, showSearch = _ref2.showSearch;
            if (open && showSearch) return getSuffixIconNode(/*#__PURE__*/ $jbmdS.createElement((0, $lCuWO.default), {
                className: iconCls
            }));
            return getSuffixIconNode(/*#__PURE__*/ $jbmdS.createElement((0, $4AJEj.default), {
                className: iconCls
            }));
        };
    }
    // Checked item icon
    var mergedItemIcon = null;
    if (menuItemSelectedIcon !== undefined) mergedItemIcon = menuItemSelectedIcon;
    else if (multiple) mergedItemIcon = /*#__PURE__*/ $jbmdS.createElement((0, $cOGaE.default), null);
    else mergedItemIcon = null;
    var mergedRemoveIcon = null;
    if (removeIcon !== undefined) mergedRemoveIcon = removeIcon;
    else mergedRemoveIcon = /*#__PURE__*/ $jbmdS.createElement((0, $8u58w.default), null);
    return {
        clearIcon: mergedClearIcon,
        suffixIcon: mergedSuffixIcon,
        itemIcon: mergedItemIcon,
        removeIcon: mergedRemoveIcon
    };
}

});
parcelRegister("cOGaE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $954addcf6b1cc09e$export$2e2bcd8739ae039; });

var $lv6ip = parcelRequire("lv6ip");

var $jbmdS = parcelRequire("jbmdS");

var $gf8mH = parcelRequire("gf8mH");

var $4hKc4 = parcelRequire("4hKc4");
var $954addcf6b1cc09e$var$CheckOutlined = function CheckOutlined(props, ref) {
    return /*#__PURE__*/ $jbmdS.createElement((0, $4hKc4.default), (0, $lv6ip.default)((0, $lv6ip.default)({}, props), {}, {
        ref: ref,
        icon: (0, $gf8mH.default)
    }));
};
var $954addcf6b1cc09e$var$RefIcon = /*#__PURE__*/ $jbmdS.forwardRef($954addcf6b1cc09e$var$CheckOutlined);
var $954addcf6b1cc09e$export$2e2bcd8739ae039 = $954addcf6b1cc09e$var$RefIcon;

});
parcelRegister("gf8mH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd34892bbf62224a$export$2e2bcd8739ae039; });
// This icon file is generated automatically.
var $bd34892bbf62224a$var$CheckOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"
                }
            }
        ]
    },
    "name": "check",
    "theme": "outlined"
};
var $bd34892bbf62224a$export$2e2bcd8739ae039 = $bd34892bbf62224a$var$CheckOutlined;

});


parcelRegister("4AJEj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $357def3302718650$export$2e2bcd8739ae039; });

var $lv6ip = parcelRequire("lv6ip");

var $jbmdS = parcelRequire("jbmdS");

var $eiXEa = parcelRequire("eiXEa");

var $4hKc4 = parcelRequire("4hKc4");
var $357def3302718650$var$DownOutlined = function DownOutlined(props, ref) {
    return /*#__PURE__*/ $jbmdS.createElement((0, $4hKc4.default), (0, $lv6ip.default)((0, $lv6ip.default)({}, props), {}, {
        ref: ref,
        icon: (0, $eiXEa.default)
    }));
};
var $357def3302718650$var$RefIcon = /*#__PURE__*/ $jbmdS.forwardRef($357def3302718650$var$DownOutlined);
var $357def3302718650$export$2e2bcd8739ae039 = $357def3302718650$var$RefIcon;

});
parcelRegister("eiXEa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6a103c366028242$export$2e2bcd8739ae039; });
// This icon file is generated automatically.
var $a6a103c366028242$var$DownOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"
                }
            }
        ]
    },
    "name": "down",
    "theme": "outlined"
};
var $a6a103c366028242$export$2e2bcd8739ae039 = $a6a103c366028242$var$DownOutlined;

});





parcelRegister("fLiAF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b799aa79f0983aef$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $goLmS = parcelRequire("goLmS");

var $htkeB = parcelRequire("htkeB");

var $kb7bz = parcelRequire("kb7bz");

var $52dEm = parcelRequire("52dEm");

var $49KZT = parcelRequire("49KZT");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");
const $b799aa79f0983aef$var$rateColumns = (staff)=>[
        {
            id: "date",
            label: "Starting From",
            width: 20,
            type: "date",
            editable: (r)=>r.modelType === "staffRate" && (0, $8kZ1o.canEditStaff)((0, $1BTI2.default).user),
            value: (r)=>r.date,
            onChange: (r)=>(v)=>r.update({
                        date: v
                    })
        },
        {
            label: "Pay Rate",
            width: 20,
            type: "currency",
            permissions: (r)=>(0, $8kZ1o.canViewStaffPayRate)((0, $1BTI2.default).user),
            editable: (r)=>r.modelType === "staffRate" && !staff.inheritPayRate && (0, $8kZ1o.canEditStaffPayRate)((0, $1BTI2.default).user),
            value: (p)=>(p.modelType === "staffRate" && !staff.inheritPayRate || p.modelType === "roleRate" && staff.inheritPayRate) && p.payRate,
            component: (props)=>{
                const r = props.stores.row.rowObject;
                if (r.modelType === "staffRate" && staff.inheritPayRate) return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {});
                if (r.modelType === "roleRate" && !staff.inheritPayRate) return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {});
                if (isFinite(props.value)) return (0, $49KZT.default)["currency"](props);
            },
            onChange: (r)=>(v)=>r.update({
                        payRate: v
                    })
        },
        {
            label: "Overtime Rate",
            width: 20,
            type: "currency",
            permissions: (r)=>(0, $8kZ1o.canViewStaffOvertimeRate)((0, $1BTI2.default).user),
            editable: (r)=>r.modelType === "staffRate" && !staff.inheritOvertimeRate && (0, $8kZ1o.canEditStaffOvertimeRate)((0, $1BTI2.default).user),
            value: (p)=>(p.modelType === "staffRate" && !staff.inheritOvertimeRate || p.modelType === "roleRate" && staff.inheritOvertimeRate) && p.overtimeRate,
            component: (props)=>{
                const r = props.stores.row.rowObject;
                if (r.modelType === "staffRate" && staff.inheritOvertimeRate) return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {});
                if (r.modelType === "roleRate" && !staff.inheritOvertimeRate) return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {});
                if (isFinite(props.value)) return (0, $49KZT.default)["currency"](props);
            },
            onChange: (r)=>(v)=>r.update({
                        overtimeRate: v
                    })
        },
        {
            label: "Cost Rate",
            width: 20,
            type: "currency",
            permissions: (r)=>(0, $8kZ1o.canViewStaffCostRate)((0, $1BTI2.default).user),
            editable: (r)=>r.modelType === "staffRate" && !staff.inheritCostRate && (0, $8kZ1o.canEditStaffCostRate)((0, $1BTI2.default).user),
            value: (p)=>(p.modelType === "staffRate" && !staff.inheritCostRate || p.modelType === "roleRate" && staff.inheritCostRate) && p.costRate,
            component: (props)=>{
                const r = props.stores.row.rowObject;
                if (r.modelType === "staffRate" && staff.inheritCostRate) return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {});
                if (r.modelType === "roleRate" && !staff.inheritCostRate) return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {});
                if (isFinite(props.value)) return (0, $49KZT.default)["currency"](props);
            },
            onChange: (r)=>(v)=>r.update({
                        costRate: v
                    })
        },
        {
            label: "Charge Out Rate",
            width: 20,
            type: "currency",
            permissions: (r)=>(0, $8kZ1o.canViewStaffChargeOutRate)((0, $1BTI2.default).user),
            editable: (r)=>r.modelType === "staffRate" && !staff.inheritChargeOutRate && (0, $8kZ1o.canEditStaffChargeOutRate)((0, $1BTI2.default).user),
            value: (p)=>(p.modelType === "staffRate" && !staff.inheritChargeOutRate || p.modelType === "roleRate" && staff.inheritChargeOutRate) && p.chargeOutRate,
            component: (props)=>{
                const r = props.stores.row.rowObject;
                if (r.modelType === "staffRate" && staff.inheritChargeOutRate) return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {});
                if (r.modelType === "roleRate" && !staff.inheritChargeOutRate) return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {});
                if (isFinite(props.value)) return (0, $49KZT.default)["currency"](props);
            },
            onChange: (r)=>(v)=>r.update({
                        chargeOutRate: v
                    })
        },
        {
            label: "Weekly Availability",
            width: 20,
            type: "durationMinutes",
            editable: (r)=>r.modelType === "staffRate" && (0, $8kZ1o.canEditStaff)((0, $1BTI2.default).user),
            value: (p)=>p.modelType === "staffRate" && p.weeklyAvailability || 0,
            component: (props)=>{
                const r = props.stores.row.rowObject;
                if (r.modelType === "roleRate") return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {});
                if (isFinite(props.value)) return (0, $49KZT.default)["durationMinutes"](props);
            },
            onChange: (r)=>(v)=>r.update({
                        weeklyAvailability: v
                    })
        },
        {
            label: "",
            width: 4,
            type: "button",
            permissions: (r)=>(0, $8kZ1o.canEditStaff)((0, $1BTI2.default).user),
            editable: (r)=>r.modelType === "staffRate" && (0, $8kZ1o.canEditStaff)((0, $1BTI2.default).user),
            value: (p)=>p.modelType === "staffRate" && /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                    className: "fa fa-times",
                    style: {
                        marginRight: 0
                    }
                }),
            onClick: (r)=>()=>{
                    r.update({
                        deletedAt: new Date()
                    });
                }
        }
    ];
const $b799aa79f0983aef$var$inheritRateColumns = [
    {
        width: 20,
        type: "text",
        value: ()=>"",
        style: ()=>({
                textAlign: "right",
                justifyContent: "flex-end"
            })
    },
    {
        label: "Pay Rate",
        width: 20,
        type: "boolean",
        value: (r)=>r.inheritPayRate,
        onChange: (r)=>(v)=>r.update({
                    inheritPayRate: v
                }),
        permissions: (r)=>(0, $8kZ1o.canViewStaffPayRate)((0, $1BTI2.default).user),
        editable: (r)=>{
            var _r$role;
            return r.roleId != null && !((_r$role = r.role) !== null && _r$role !== void 0 && _r$role.avgPayRate) && (0, $8kZ1o.canEditStaffPayRate)((0, $1BTI2.default).user);
        },
        component: (props)=>{
            return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    display: "flex"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        style: {
                            opacity: props.editable ? 1 : 0.75,
                            flex: "1 1 auto"
                        },
                        children: "Inherit From Role"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                        disabled: !props.editable,
                        ...props,
                        style: {
                            ...props.style,
                            flex: "0 0 auto",
                            width: "1em",
                            marginLeft: "0.5em"
                        }
                    })
                ]
            });
        },
        style: ()=>({
                textAlign: "right",
                justifyContent: "flex-end"
            })
    },
    {
        label: "Overtime Rate",
        width: 20,
        type: "boolean",
        value: (r)=>r.inheritOvertimeRate,
        onChange: (r)=>(v)=>r.update({
                    inheritOvertimeRate: v
                }),
        permissions: (r)=>(0, $8kZ1o.canViewStaffOvertimeRate)((0, $1BTI2.default).user),
        editable: (r)=>{
            var _r$role2;
            return r.roleId != null && !((_r$role2 = r.role) !== null && _r$role2 !== void 0 && _r$role2.avgOvertimeRate) && (0, $8kZ1o.canEditStaffOvertimeRate)((0, $1BTI2.default).user);
        },
        component: (props)=>{
            return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    display: "flex"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        style: {
                            opacity: props.editable ? 1 : 0.75,
                            flex: "1 1 auto"
                        },
                        children: "Inherit From Role"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                        disabled: !props.editable,
                        ...props,
                        style: {
                            ...props.style,
                            flex: "0 0 auto",
                            width: "1em",
                            marginLeft: "0.5em"
                        }
                    })
                ]
            });
        },
        style: ()=>({
                textAlign: "right",
                justifyContent: "flex-end"
            })
    },
    {
        label: "Cost Rate",
        width: 20,
        type: "boolean",
        value: (r)=>r.inheritCostRate,
        onChange: (r)=>(v)=>r.update({
                    inheritCostRate: v
                }),
        permissions: (r)=>(0, $8kZ1o.canViewStaffCostRate)((0, $1BTI2.default).user),
        editable: (r)=>{
            var _r$role3;
            return r.roleId != null && !((_r$role3 = r.role) !== null && _r$role3 !== void 0 && _r$role3.avgCostRate) && (0, $8kZ1o.canEditStaffCostRate)((0, $1BTI2.default).user);
        },
        component: (props)=>{
            return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    display: "flex"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        style: {
                            opacity: props.editable ? 1 : 0.75,
                            flex: "1 1 auto"
                        },
                        children: "Inherit From Role"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                        disabled: !props.editable,
                        ...props,
                        style: {
                            ...props.style,
                            flex: "0 0 auto",
                            width: "1em",
                            marginLeft: "0.5em"
                        }
                    })
                ]
            });
        },
        style: ()=>({
                textAlign: "right",
                justifyContent: "flex-end"
            })
    },
    {
        label: "Charge Out Rate",
        width: 20,
        type: "boolean",
        value: (r)=>r.inheritChargeOutRate,
        onChange: (r)=>(v)=>r.update({
                    inheritChargeOutRate: v
                }),
        permissions: (r)=>(0, $8kZ1o.canViewStaffChargeOutRate)((0, $1BTI2.default).user),
        editable: (r)=>{
            var _r$role4;
            return r.roleId != null && !((_r$role4 = r.role) !== null && _r$role4 !== void 0 && _r$role4.avgChargeOutRate) && (0, $8kZ1o.canEditStaffChargeOutRate)((0, $1BTI2.default).user);
        },
        component: (props)=>{
            return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    display: "flex"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        style: {
                            opacity: props.editable ? 1 : 0.75,
                            flex: "1 1 auto"
                        },
                        children: "Inherit From Role"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                        disabled: !props.editable,
                        ...props,
                        style: {
                            ...props.style,
                            flex: "0 0 auto",
                            width: "1em",
                            marginLeft: "0.5em"
                        }
                    })
                ]
            });
        },
        style: ()=>({
                textAlign: "right",
                justifyContent: "flex-end"
            })
    },
    {
        label: "Weekly Availability",
        width: 20,
        type: "text",
        value: ()=>"",
        style: ()=>({
                textAlign: "right",
                justifyContent: "flex-end"
            })
    },
    {
        permissions: (r)=>(0, $8kZ1o.canEditStaff)((0, $1BTI2.default).user),
        width: 4,
        type: "text",
        value: ()=>""
    }
];
var $b799aa79f0983aef$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ id: id })=>{
    const staff = (0, $htkeB.default).staffsById[id];
    if (!staff) return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        children: "Staff Member not found."
    });
    const includeRoleRates = staff.inheritPayRate || staff.inheritOvertimeRate || staff.inheritCostRate || staff.inheritChargeOutRate;
    const memoizedColumns = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useMemo(()=>{
        return $b799aa79f0983aef$var$rateColumns(staff).filter((c)=>!c.permissions || c.permissions());
    }, [
        staff
    ]);
    const [rows, setRows] = (0, $jbmdS.useState)((includeRoleRates ? staff.staffAndRoleRates : staff.rates).sort((a, b)=>{
        var _a$date, _b$date;
        return (a === null || a === void 0 ? void 0 : (_a$date = a.date) === null || _a$date === void 0 ? void 0 : _a$date.getTime()) - (b === null || b === void 0 ? void 0 : (_b$date = b.date) === null || _b$date === void 0 ? void 0 : _b$date.getTime());
    }));
    (0, $jbmdS.useEffect)(()=>{
        setRows((includeRoleRates ? staff.staffAndRoleRates : staff.rates).sort((a, b)=>{
            var _a$date2, _b$date2;
            return (a === null || a === void 0 ? void 0 : (_a$date2 = a.date) === null || _a$date2 === void 0 ? void 0 : _a$date2.getTime()) - (b === null || b === void 0 ? void 0 : (_b$date2 = b.date) === null || _b$date2 === void 0 ? void 0 : _b$date2.getTime());
        }));
    }, [
        includeRoleRates,
        staff.id
    ]);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
                columns: memoizedColumns,
                rows: rows.filter((r)=>!r.deletedAt),
                topRow: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
                    columns: $b799aa79f0983aef$var$inheritRateColumns.filter((c)=>!c.permissions || c.permissions()),
                    rows: [
                        staff
                    ],
                    showHeader: false
                })
            }),
            (0, $8kZ1o.canEditStaff)((0, $1BTI2.default).user) ? /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                className: "btn btn-default plus-btn border-[#ccc]",
                style: {
                    marginTop: "2em"
                },
                onClick: ()=>{
                    const sr = (0, $kb7bz.default).add({
                        staffId: staff.id,
                        date: new Date()
                    }, {
                        trackUpdates: true
                    });
                    setRows([
                        ...rows,
                        sr
                    ]);
                },
                children: "+ Add Rate"
            }) : null
        ]
    });
});

});

parcelRegister("hMN0G", function(module, exports) {

var $61Ea1 = parcelRequire("61Ea1");

var $gdEjf = parcelRequire("gdEjf");

var $8kZ1o = parcelRequire("8kZ1o");

var $764qO = parcelRequire("764qO");

var $en4Hs = parcelRequire("en4Hs");

var $7UGfB = parcelRequire("7UGfB");

var $1BTI2 = parcelRequire("1BTI2");

var $2YJBX = parcelRequire("2YJBX");

var $8jD92 = parcelRequire("8jD92");

var $bbD51 = parcelRequire("bbD51");

var $3Gs4l = parcelRequire("3Gs4l");

var $9I5Xg = parcelRequire("9I5Xg");

var $5QoiI = parcelRequire("5QoiI");
function $88d8cc0ae4f5c7d1$export$23db7943fa6e6a90() {
    const labelWidth = "10em";
    const staffMember = (0, $7UGfB.useStaffMember)();
    const roles = (0, $7UGfB.useStaffRoles)();
    const isEditable = (0, $8kZ1o.canEditStaff)((0, $1BTI2.default).user);
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "form-horizontal",
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $gdEjf.FormSection), {
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $gdEjf.FormRow), {
                    className: "flex",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $gdEjf.FormLabel), {
                            style: {
                                width: labelWidth
                            },
                            children: "First name:"
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $2YJBX.Input), {
                            className: "staff-member-component__first-name-input input-base ml-[5em]",
                            type: "text",
                            value: (staffMember === null || staffMember === void 0 ? void 0 : staffMember.firstName) || "",
                            disabled: !isEditable,
                            onChange: (e)=>(0, $7UGfB.staffActions).changeStaffData("firstName", e.target.value)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $gdEjf.FormRow), {
                    className: "flex",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $gdEjf.FormLabel), {
                            style: {
                                width: labelWidth
                            },
                            children: "Last name:"
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $2YJBX.Input), {
                            className: "staff-member-component__last-name-input input-base ml-[5em]",
                            type: "text",
                            value: staffMember.lastName || "",
                            disabled: !isEditable,
                            onChange: (e)=>(0, $7UGfB.staffActions).changeStaffData("lastName", e.target.value)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $gdEjf.FormRow), {
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8jD92.CheckboxWithLabel), {
                        className: "staff-member-component__has-login-input",
                        checked: staffMember.hasLogin,
                        label: "Provide Staff Member with Login?",
                        disabled: !isEditable,
                        onCheckedChange: (v)=>(0, $7UGfB.staffActions).changeStaffData("hasLogin", v),
                        id: "has-login"
                    })
                }),
                /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $gdEjf.FormRow), {
                    style: {
                        opacity: staffMember.hasLogin ? 1 : 0.5
                    },
                    className: "flex items-center",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $gdEjf.FormLabel), {
                            style: {
                                width: labelWidth
                            },
                            children: "Email:"
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $2YJBX.Input), {
                            className: "staff-member-component__email-input input-base ml-[5em]",
                            type: "email",
                            value: staffMember.email || "",
                            disabled: !isEditable || !staffMember.hasLogin,
                            onChange: (e)=>(0, $7UGfB.staffActions).changeStaffData("email", e.target.value)
                        }),
                        isEditable && staffMember.hasLogin && staffMember.email && !staffMember.isArchived ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bbD51.default), {
                                staff: staffMember
                            })
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $gdEjf.FormRow), {
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $gdEjf.FormLabel), {
                            style: {
                                width: labelWidth
                            },
                            children: "Staff type:"
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $en4Hs.RadioGroup), {
                            className: "text-base flex gap-8 ml-6",
                            defaultValue: "employee",
                            onValueChange: (v)=>(0, $7UGfB.staffActions).changeStaffData("staffType", v),
                            value: staffMember.staffType,
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                    className: "flex items-center space-x-2",
                                    children: [
                                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $en4Hs.RadioGroupItem), {
                                            value: "employee",
                                            id: "employee"
                                        }),
                                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $764qO.Label), {
                                            htmlFor: "employee",
                                            children: "Employee"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                    className: "flex items-center space-x-2",
                                    children: [
                                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $en4Hs.RadioGroupItem), {
                                            value: "contractor",
                                            id: "contractor"
                                        }),
                                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $764qO.Label), {
                                            htmlFor: "contractor",
                                            children: "contractor"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                (0, $8kZ1o.canViewRoles)((0, $1BTI2.default).user) ? /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $gdEjf.FormSection), {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $gdEjf.FormLabel), {
                            style: {
                                width: labelWidth
                            },
                            children: "Staff Role:"
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $9I5Xg.default), {
                            options: roles.map((role)=>({
                                    ...role,
                                    value: role.id,
                                    label: role.name
                                })),
                            value: staffMember.roleId,
                            editable: isEditable,
                            placeholder: "Select role...",
                            onChange: (value)=>(0, $7UGfB.staffActions).changeStaffData("roleId", value)
                        })
                    ]
                }) : null,
                /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $gdEjf.FormRow), {
                    style: {
                        maxWidth: "max-content"
                    },
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $gdEjf.FormLabel), {
                            style: {
                                width: labelWidth
                            },
                            children: "Status:"
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3Gs4l.SelectWithLabel), {
                            options: [
                                {
                                    value: "false",
                                    label: "Active",
                                    key: "active"
                                },
                                {
                                    value: "true",
                                    label: "Archived",
                                    key: "archived"
                                }
                            ],
                            editable: isEditable,
                            value: staffMember !== null && staffMember !== void 0 && staffMember.isArchived ? "true" : "false",
                            onValueChange: (v)=>{
                                (0, $7UGfB.staffActions).changeStaffData("isArchived", v === "true");
                            }
                        })
                    ]
                }),
                (0, $8kZ1o.canViewCostCentres)((0, $1BTI2.default).user) ? /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $gdEjf.FormRow), {
                    style: {
                        maxWidth: "max-content"
                    },
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $gdEjf.FormLabel), {
                            style: {
                                width: labelWidth
                            },
                            children: "Cost Centre:"
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5QoiI.CostCentreSelector), {
                            value: staffMember.costCentreId,
                            onChange: (value)=>(0, $7UGfB.staffActions).changeStaffData("costCentreId", value),
                            disabled: !isEditable
                        })
                    ]
                }) : null
            ]
        })
    });
}

});
parcelRegister("7UGfB", function(module, exports) {

$parcel$export(module.exports, "useStaffMember", function () { return $ef0dc96f9fb10d4b$export$edde6aad5c49920e; });
$parcel$export(module.exports, "useStaffRoles", function () { return $ef0dc96f9fb10d4b$export$b7d59641f9f6dcc0; });
$parcel$export(module.exports, "useStaffRates", function () { return $ef0dc96f9fb10d4b$export$49c7abec96e0c3f; });
$parcel$export(module.exports, "useStaffPermissions", function () { return $ef0dc96f9fb10d4b$export$31d9e2d7d0e8461e; });
$parcel$export(module.exports, "useStaffRole", function () { return $ef0dc96f9fb10d4b$export$64c2794f1d5a9975; });
$parcel$export(module.exports, "staffActions", function () { return $ef0dc96f9fb10d4b$export$2bbc89487bffe7bd; });

var $8qPhl = parcelRequire("8qPhl");

var $3h7sC = parcelRequire("3h7sC");

var $277OF = parcelRequire("277OF");

var $lJ1OS = parcelRequire("lJ1OS");

var $9Pt1Z = parcelRequire("9Pt1Z");
// Utility functions for parsing
const $ef0dc96f9fb10d4b$var$parseNumberOrUndefined = (value)=>{
    if (value === undefined) return undefined;
    if (typeof value === "number") return value;
    const parsed = parseFloat(value);
    return isNaN(parsed) ? undefined : parsed;
};
const $ef0dc96f9fb10d4b$var$parseDateOrUndefined = (value)=>{
    if (value === undefined) return undefined;
    if (value instanceof Date) return value;
    if (typeof value === "string") return value; // Keep string dates as-is
    const parsed = new Date(value);
    return isNaN(parsed.getTime()) ? undefined : parsed;
};
const $ef0dc96f9fb10d4b$export$5901abff932729af = (0, $8qPhl.z).object({
    id: (0, $8qPhl.z).string(),
    organisationId: (0, $8qPhl.z).string().optional(),
    staffId: (0, $8qPhl.z).string().optional(),
    date: (0, $8qPhl.z).union([
        (0, $8qPhl.z).coerce.date(),
        (0, $8qPhl.z).string(),
        (0, $8qPhl.z).undefined()
    ]).transform($ef0dc96f9fb10d4b$var$parseDateOrUndefined),
    payRate: (0, $8qPhl.z).union([
        (0, $8qPhl.z).number(),
        (0, $8qPhl.z).string(),
        (0, $8qPhl.z).undefined()
    ]).transform($ef0dc96f9fb10d4b$var$parseNumberOrUndefined),
    overtimeRate: (0, $8qPhl.z).union([
        (0, $8qPhl.z).number(),
        (0, $8qPhl.z).string(),
        (0, $8qPhl.z).undefined()
    ]).transform($ef0dc96f9fb10d4b$var$parseNumberOrUndefined),
    costRate: (0, $8qPhl.z).union([
        (0, $8qPhl.z).number(),
        (0, $8qPhl.z).string(),
        (0, $8qPhl.z).undefined()
    ]).transform($ef0dc96f9fb10d4b$var$parseNumberOrUndefined),
    chargeOutRate: (0, $8qPhl.z).union([
        (0, $8qPhl.z).number(),
        (0, $8qPhl.z).string(),
        (0, $8qPhl.z).undefined()
    ]).transform($ef0dc96f9fb10d4b$var$parseNumberOrUndefined),
    weeklyAvailability: (0, $8qPhl.z).union([
        (0, $8qPhl.z).number(),
        (0, $8qPhl.z).string(),
        (0, $8qPhl.z).undefined()
    ]).transform($ef0dc96f9fb10d4b$var$parseNumberOrUndefined),
    deletedAt: (0, $8qPhl.z).union([
        (0, $8qPhl.z).coerce.date(),
        (0, $8qPhl.z).string(),
        (0, $8qPhl.z).undefined()
    ]).transform($ef0dc96f9fb10d4b$var$parseDateOrUndefined)
});
const $ef0dc96f9fb10d4b$export$9b94be200cc55751 = (0, $8qPhl.z).object({
    id: (0, $8qPhl.z).string(),
    organisationId: (0, $8qPhl.z).string().optional(),
    roleId: (0, $8qPhl.z).string().optional(),
    date: (0, $8qPhl.z).union([
        (0, $8qPhl.z).date(),
        (0, $8qPhl.z).string(),
        (0, $8qPhl.z).undefined()
    ]).transform($ef0dc96f9fb10d4b$var$parseDateOrUndefined),
    payRate: (0, $8qPhl.z).union([
        (0, $8qPhl.z).number(),
        (0, $8qPhl.z).string(),
        (0, $8qPhl.z).undefined()
    ]).transform($ef0dc96f9fb10d4b$var$parseNumberOrUndefined),
    overtimeRate: (0, $8qPhl.z).union([
        (0, $8qPhl.z).number(),
        (0, $8qPhl.z).string(),
        (0, $8qPhl.z).undefined()
    ]).transform($ef0dc96f9fb10d4b$var$parseNumberOrUndefined),
    costRate: (0, $8qPhl.z).union([
        (0, $8qPhl.z).number(),
        (0, $8qPhl.z).string(),
        (0, $8qPhl.z).undefined()
    ]).transform($ef0dc96f9fb10d4b$var$parseNumberOrUndefined),
    chargeOutRate: (0, $8qPhl.z).union([
        (0, $8qPhl.z).number(),
        (0, $8qPhl.z).string(),
        (0, $8qPhl.z).undefined()
    ]).transform($ef0dc96f9fb10d4b$var$parseNumberOrUndefined)
});
const $ef0dc96f9fb10d4b$export$361c590f91455862 = (0, $8qPhl.z).object({
    id: (0, $8qPhl.z).string(),
    organisationId: (0, $8qPhl.z).string().optional(),
    name: (0, $8qPhl.z).string(),
    isArchived: (0, $8qPhl.z).boolean().optional(),
    rates: (0, $8qPhl.z).array($ef0dc96f9fb10d4b$export$9b94be200cc55751).optional(),
    avgPayRate: (0, $8qPhl.z).boolean().optional().default(false),
    avgOvertimeRate: (0, $8qPhl.z).boolean().optional().default(false),
    avgCostRate: (0, $8qPhl.z).boolean().optional().default(false),
    avgChargeOutRate: (0, $8qPhl.z).boolean().optional().default(false)
});
const $ef0dc96f9fb10d4b$export$a719e7303d439224 = (0, $8qPhl.z).object({
    id: (0, $8qPhl.z).string(),
    organisationId: (0, $8qPhl.z).string().optional(),
    firstName: (0, $8qPhl.z).string().optional(),
    lastName: (0, $8qPhl.z).string().optional(),
    email: (0, $8qPhl.z).string().optional(),
    staffType: (0, $8qPhl.z).string().optional(),
    hasLogin: (0, $8qPhl.z).boolean().optional(),
    isArchived: (0, $8qPhl.z).boolean().optional(),
    costCentreId: (0, $8qPhl.z).string().optional(),
    roleId: (0, $8qPhl.z).string().optional().nullable(),
    billingLevelOverride: (0, $8qPhl.z).string().optional().nullable(),
    permissionsId: (0, $8qPhl.z).string().optional().nullable(),
    permissions: (0, $8qPhl.z).any().optional().nullable(),
    inheritPayRate: (0, $8qPhl.z).boolean().optional(),
    inheritOvertimeRate: (0, $8qPhl.z).boolean().optional(),
    inheritCostRate: (0, $8qPhl.z).boolean().optional(),
    inheritChargeOutRate: (0, $8qPhl.z).boolean().optional(),
    rates: (0, $8qPhl.z).array($ef0dc96f9fb10d4b$export$5901abff932729af).optional(),
    role: $ef0dc96f9fb10d4b$export$361c590f91455862.optional(),
    clerkId: (0, $8qPhl.z).string().optional().nullable(),
    clerkOrgId: (0, $8qPhl.z).string().optional().nullable()
});
const $ef0dc96f9fb10d4b$export$b2daff94af8e519e = (0, $8qPhl.z).object({
    projectPermissions: (0, $8qPhl.z).string().optional(),
    projectFees: (0, $8qPhl.z).string().optional(),
    projectExpenseBudgets: (0, $8qPhl.z).string().optional(),
    projectHoursBudgets: (0, $8qPhl.z).string().optional(),
    projectStaffBudgets: (0, $8qPhl.z).string().optional(),
    projectDates: (0, $8qPhl.z).string().optional(),
    projectPhasesTasks: (0, $8qPhl.z).string().optional(),
    projectExpenses: (0, $8qPhl.z).string().optional(),
    projectForecastedRevenue: (0, $8qPhl.z).string().optional(),
    projectForecastedHours: (0, $8qPhl.z).string().optional(),
    projectInvoices: (0, $8qPhl.z).string().optional(),
    projectRates: (0, $8qPhl.z).string().optional(),
    projectNotes: (0, $8qPhl.z).string().optional(),
    projectTimesheets: (0, $8qPhl.z).boolean().optional()
}).optional();
const $ef0dc96f9fb10d4b$export$737439c5aa443626 = (0, $8qPhl.z).object({
    type: (0, $8qPhl.z).string().optional(),
    values: (0, $8qPhl.z).array((0, $8qPhl.z).string()).optional()
}).optional();
const $ef0dc96f9fb10d4b$export$5dbe7eae4180916c = (0, $8qPhl.z).object({
    filter: $ef0dc96f9fb10d4b$export$737439c5aa443626.optional(),
    permissions: $ef0dc96f9fb10d4b$export$b2daff94af8e519e.optional(),
    id: (0, $8qPhl.z).string().optional()
}).optional();
const $ef0dc96f9fb10d4b$export$99d89aaca0160ff7 = (0, $8qPhl.z).object({
    canViewRevenueForecast: (0, $8qPhl.z).boolean().optional(),
    canViewStaffExpenses: (0, $8qPhl.z).boolean().optional(),
    canViewOperationalExpenses: (0, $8qPhl.z).boolean().optional(),
    canViewResourceSchedule: (0, $8qPhl.z).boolean().optional(),
    canViewWeeklyPlanner: (0, $8qPhl.z).boolean().optional(),
    projects: (0, $8qPhl.z).array($ef0dc96f9fb10d4b$export$5dbe7eae4180916c).optional(),
    staffPermissions: (0, $8qPhl.z).string().optional(),
    rolePermissions: (0, $8qPhl.z).string().optional(),
    editStaffTime: (0, $8qPhl.z).boolean().optional(),
    payRate: (0, $8qPhl.z).string().optional(),
    overtimeRate: (0, $8qPhl.z).string().optional(),
    costRate: (0, $8qPhl.z).string().optional(),
    chargeOutRate: (0, $8qPhl.z).string().optional(),
    contacts: (0, $8qPhl.z).string().optional(),
    costCentres: (0, $8qPhl.z).string().optional(),
    operationalExpenses: (0, $8qPhl.z).string().optional(),
    holidays: (0, $8qPhl.z).string().optional(),
    invoiceSettings: (0, $8qPhl.z).string().optional(),
    organisationSettings: (0, $8qPhl.z).string().optional(),
    billing: (0, $8qPhl.z).string().optional()
}).optional().nullable();
const $ef0dc96f9fb10d4b$var$DEFAULT_RATE = {
    date: new Date(),
    payRate: 0,
    overtimeRate: 0,
    costRate: 0,
    chargeOutRate: 0
};
const $ef0dc96f9fb10d4b$export$b8030685c123f4d8 = (0, $277OF.createQueryStore)({
    context: {
        staffMember: null,
        roles: [],
        staffRates: [],
        permissions: null
    },
    on: {
        setData: {
            staffMember: (_, { data: data })=>data.staffMember,
            roles: (_, { data: data })=>data.roles,
            staffRates: (_, { data: data })=>data.staffRates,
            permissions: (_, { data: data })=>data.permissions
        },
        changeStaffData: {
            staffMember: (context, { key: key, value: value })=>context.staffMember ? {
                    ...context.staffMember,
                    [key]: value
                } : null
        },
        addNewRates: {
            staffRates: (context, { initial: initial })=>{
                var _context$staffMember, _context$staffMember2, _context$staffMember3;
                return [
                    ...context.staffRates,
                    {
                        ...$ef0dc96f9fb10d4b$var$DEFAULT_RATE,
                        id: (0, $9Pt1Z.v4)(),
                        organisationId: (_context$staffMember = context.staffMember) === null || _context$staffMember === void 0 ? void 0 : _context$staffMember.organisationId,
                        staffId: (_context$staffMember2 = context.staffMember) === null || _context$staffMember2 === void 0 ? void 0 : _context$staffMember2.id,
                        roleId: (_context$staffMember3 = context.staffMember) === null || _context$staffMember3 === void 0 ? void 0 : _context$staffMember3.roleId,
                        ...initial
                    }
                ];
            }
        },
        changeRateData: {
            staffRates: (context, { id: id, key: key, value: value })=>context.staffRates.map((rate)=>rate.id === id ? {
                        ...rate,
                        [key]: value
                    } : rate)
        },
        changePermissions: {
            permissions: (_, { permissions: permissions })=>permissions
        },
        deleteRate: {
            staffRates: (context, { id: id })=>{
                const index = context.staffRates.findIndex((rate)=>rate.id === id);
                if (index === -1) return context.staffRates;
                const updatedRates = [
                    ...context.staffRates
                ];
                updatedRates[index] = {
                    ...updatedRates[index],
                    deletedAt: new Date()
                };
                return updatedRates;
            }
        }
    }
}, {
    queryKey: [
        "staff-member"
    ],
    queryFn: async ({ id: id })=>{
        const result = await (0, $3h7sC.trpc).staff.getStaffMember.query({
            id: id
        });
        return {
            staffMember: result.staffMember ? $ef0dc96f9fb10d4b$export$a719e7303d439224.parse(result.staffMember) : null,
            roles: result.roles.map((role)=>$ef0dc96f9fb10d4b$export$361c590f91455862.parse(role)),
            staffRates: result.staffRates.map((rate)=>$ef0dc96f9fb10d4b$export$5901abff932729af.parse(rate)),
            permissions: result.permission ? $ef0dc96f9fb10d4b$export$99d89aaca0160ff7.parse(result.permission) : null
        };
    },
    mutationFn: async (data)=>{
        const result = await (0, $3h7sC.trpc).staff.updateStaffMember.mutate({
            ...data.staffMember,
            rates: data.staffRates,
            permissions: data.staffMember.permissionsId ? data.staffMember.permissions : data.permissions
        });
        return result;
    },
    staleTime: 300000,
    // 5 minutes
    cacheTime: 1800000 // 30 minutes
}, {
    saveId: "staff-save",
    requireConfirmation: true,
    confirmationMessage: "Save changes to staff member?",
    loadingMessage: "Saving staff member...",
    successMessage: "Staff member saved successfully",
    errorMessage: "Failed to save staff member"
});
const $ef0dc96f9fb10d4b$export$edde6aad5c49920e = ()=>(0, $lJ1OS.useSelector)($ef0dc96f9fb10d4b$export$b8030685c123f4d8.store, (state)=>state.context.staffMember);
const $ef0dc96f9fb10d4b$export$b7d59641f9f6dcc0 = ()=>(0, $lJ1OS.useSelector)($ef0dc96f9fb10d4b$export$b8030685c123f4d8.store, (state)=>state.context.roles);
const $ef0dc96f9fb10d4b$export$49c7abec96e0c3f = ()=>(0, $lJ1OS.useSelector)($ef0dc96f9fb10d4b$export$b8030685c123f4d8.store, (state)=>state.context.staffRates);
const $ef0dc96f9fb10d4b$export$31d9e2d7d0e8461e = ()=>(0, $lJ1OS.useSelector)($ef0dc96f9fb10d4b$export$b8030685c123f4d8.store, (state)=>state.context.permissions);
const $ef0dc96f9fb10d4b$export$64c2794f1d5a9975 = ()=>(0, $lJ1OS.useSelector)($ef0dc96f9fb10d4b$export$b8030685c123f4d8.store, (state)=>{
        const { roles: roles, staffMember: staffMember } = state.context;
        return roles.find((role)=>role.id === (staffMember === null || staffMember === void 0 ? void 0 : staffMember.roleId));
    });
const $ef0dc96f9fb10d4b$export$2bbc89487bffe7bd = {
    setData: (data)=>$ef0dc96f9fb10d4b$export$b8030685c123f4d8.store.send({
            type: "setData",
            data: data
        }),
    changeStaffData: (key, value)=>$ef0dc96f9fb10d4b$export$b8030685c123f4d8.store.send({
            type: "changeStaffData",
            key: key,
            value: value
        }),
    addNewRates: (initial)=>$ef0dc96f9fb10d4b$export$b8030685c123f4d8.store.send({
            type: "addNewRates",
            initial: initial
        }),
    changeRateData: (id, key, value)=>$ef0dc96f9fb10d4b$export$b8030685c123f4d8.store.send({
            type: "changeRateData",
            id: id,
            key: key,
            value: value
        }),
    deleteRate: (id)=>$ef0dc96f9fb10d4b$export$b8030685c123f4d8.store.send({
            type: "deleteRate",
            id: id
        }),
    changePermissions: (permissions)=>$ef0dc96f9fb10d4b$export$b8030685c123f4d8.store.send({
            type: "changePermissions",
            permissions: permissions
        })
};
const $ef0dc96f9fb10d4b$export$d785da335e8eee0e = ()=>$ef0dc96f9fb10d4b$export$b8030685c123f4d8.store.getSnapshot().context.staffMember;
const $ef0dc96f9fb10d4b$export$e3674b232bf88fed = ()=>$ef0dc96f9fb10d4b$export$b8030685c123f4d8.store.getSnapshot().context.roles;
const $ef0dc96f9fb10d4b$export$cc793f20ba19211a = ()=>$ef0dc96f9fb10d4b$export$b8030685c123f4d8.store.getSnapshot().context.staffRates;
const $ef0dc96f9fb10d4b$export$47f2e942160dae4e = ()=>$ef0dc96f9fb10d4b$export$b8030685c123f4d8.store.getSnapshot().context.permissions;
const { useStoreData: $ef0dc96f9fb10d4b$export$544efe5ac05fc17, useIsLoading: $ef0dc96f9fb10d4b$export$4dface15d86304a4, useCanUndo: $ef0dc96f9fb10d4b$export$653033ad74e314c9, useCanRedo: $ef0dc96f9fb10d4b$export$e7ea8bfdbe9392b0, useUpdatedAt: $ef0dc96f9fb10d4b$export$4d53551414e812c, undo: $ef0dc96f9fb10d4b$export$21f930c44940fd98, redo: $ef0dc96f9fb10d4b$export$1688e416fee0a49e, save: $ef0dc96f9fb10d4b$export$a1544dad697b423d, revertToLastSave: $ef0dc96f9fb10d4b$export$7e511c2293ae6e56, getState: $ef0dc96f9fb10d4b$export$50fdfeece43146fd, getHistory: $ef0dc96f9fb10d4b$export$f9582a3c130d9538, getCurrentHistoryIndex: $ef0dc96f9fb10d4b$export$3d0fb93f79a1d871, getLastSavedIndex: $ef0dc96f9fb10d4b$export$3ad3501ee738138, getSavedAt: $ef0dc96f9fb10d4b$export$f4c906ca2124fef8, getUpdatedAt: $ef0dc96f9fb10d4b$export$ff3aa069bd8fb4e4 } = $ef0dc96f9fb10d4b$export$b8030685c123f4d8;

});

parcelRegister("9I5Xg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c10555a17731868$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $1kvoC = parcelRequire("1kvoC");
var $kSlHv = parcelRequire("kSlHv");

var $Yha9m = parcelRequire("Yha9m");

var $fTGwv = parcelRequire("fTGwv");

var $fRrIT = parcelRequire("fRrIT");

var $l4nwI = parcelRequire("l4nwI");
function $6c10555a17731868$export$2706b4da0e5c8f8b(props) {
    var _options$find;
    const { options: options, placeholder: placeholder = "Select an option...", emptyMessage: emptyMessage = "No option found.", searchPlaceholder: searchPlaceholder = "Search...", className: className = "", onChange: onChange, value: valueFromProps, initialValue: initialValue, editable: editable } = props;
    const [open, setOpen] = (0, $jbmdS.useState)(false);
    const [value, setValue] = (0, $jbmdS.useState)(initialValue);
    const innerValue = props.hasOwnProperty("value") ? valueFromProps : value;
    const handleSelect = (currentValue, option)=>{
        setValue(currentValue === value ? "" : currentValue);
        setOpen(false);
        if (onChange) onChange(currentValue === value ? "" : currentValue, option);
    };
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $l4nwI.Popover), {
        open: open,
        onOpenChange: setOpen,
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $l4nwI.PopoverTrigger), {
                asChild: true,
                children: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fTGwv.Button), {
                    variant: "outline",
                    role: "combobox",
                    "aria-expanded": open,
                    disabled: !editable,
                    className: `w-[200px] justify-between ${className}`,
                    children: [
                        innerValue ? (_options$find = options.find((option)=>option.value === innerValue)) === null || _options$find === void 0 ? void 0 : _options$find.label : placeholder,
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kSlHv.default), {
                            className: "ml-2 h-4 w-4 shrink-0 opacity-50"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $l4nwI.PopoverContent), {
                className: "w-[200px] p-0",
                children: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fRrIT.Command), {
                    value: innerValue,
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fRrIT.CommandInput), {
                            placeholder: searchPlaceholder
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fRrIT.CommandList), {
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fRrIT.CommandEmpty), {
                                    children: emptyMessage
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fRrIT.CommandGroup), {
                                    children: options.map((option)=>/*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fRrIT.CommandItem), {
                                            value: option.value,
                                            onSelect: (current)=>handleSelect(current, option),
                                            disabled: !editable,
                                            children: [
                                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $1kvoC.default), {
                                                    className: (0, $Yha9m.cn)("mr-2 h-4 w-4", value === option.value ? "opacity-100" : "opacity-0")
                                                }),
                                                option.label
                                            ]
                                        }, option.value))
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
var $6c10555a17731868$export$2e2bcd8739ae039 = $6c10555a17731868$export$2706b4da0e5c8f8b;

});


parcelRegister("1LepB", function(module, exports) {

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $7UGfB = parcelRequire("7UGfB");

var $46C2K = parcelRequire("46C2K");

var $8jD92 = parcelRequire("8jD92");

var $aaosT = parcelRequire("aaosT");

var $aYyI4 = parcelRequire("aYyI4");

var $fTGwv = parcelRequire("fTGwv");
const $cc0b7bb35878ee16$export$dfcf5c338b95381d = ()=>{
    const staff = (0, $7UGfB.useStaffMember)();
    const staffRole = (0, $7UGfB.useStaffRole)();
    const staffRates = (0, $7UGfB.useStaffRates)();
    if (!staff) return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        children: "Staff Member not found."
    });
    const columns = (0, $jbmdS.useMemo)(()=>{
        return (0, $46C2K.getColumns)((column)=>{}, staff);
    }, [
        staff
    ]);
    const topRow = (0, $jbmdS.useMemo)(()=>[
            {
                id: "role",
                size: 120
            },
            {
                id: "avgPayRate",
                value: staff === null || staff === void 0 ? void 0 : staff.inheritPayRate,
                size: 120,
                label: "Inherit From Role",
                onChange: (value)=>{
                    (0, $7UGfB.staffActions).changeStaffData("inheritPayRate", value);
                },
                permissions: (0, $8kZ1o.canViewStaffPayRate)((0, $1BTI2.default).user),
                editable: (staff === null || staff === void 0 ? void 0 : staff.roleId) != null && !(staffRole !== null && staffRole !== void 0 && staffRole.avgPayRate) && (0, $8kZ1o.canEditStaffPayRate)((0, $1BTI2.default).user)
            },
            {
                id: "avgOvertimeRate",
                value: staff === null || staff === void 0 ? void 0 : staff.inheritOvertimeRate,
                size: 120,
                label: "Inherit From Role",
                onChange: (value)=>{
                    (0, $7UGfB.staffActions).changeStaffData("inheritOvertimeRate", value);
                },
                permissions: (0, $8kZ1o.canViewStaffOvertimeRate)((0, $1BTI2.default).user),
                editable: staff.roleId != null && !(staffRole !== null && staffRole !== void 0 && staffRole.avgOvertimeRate) && (0, $8kZ1o.canEditStaffOvertimeRate)((0, $1BTI2.default).user)
            },
            {
                id: "avgCostRate",
                value: staff === null || staff === void 0 ? void 0 : staff.inheritCostRate,
                size: 120,
                label: "Inherit From Role",
                onChange: (value)=>{
                    (0, $7UGfB.staffActions).changeStaffData("inheritCostRate", value);
                },
                permissions: (0, $8kZ1o.canViewStaffCostRate)((0, $1BTI2.default).user),
                editable: staff.roleId != null && !(staffRole !== null && staffRole !== void 0 && staffRole.avgCostRate) && (0, $8kZ1o.canEditStaffCostRate)((0, $1BTI2.default).user)
            },
            {
                id: "avgChargeOutRate",
                value: staff === null || staff === void 0 ? void 0 : staff.inheritChargeOutRate,
                size: 120,
                label: "Inherit From Role",
                onChange: (value)=>{
                    (0, $7UGfB.staffActions).changeStaffData("inheritChargeOutRate", value);
                },
                permissions: (0, $8kZ1o.canViewStaffChargeOutRate)((0, $1BTI2.default).user),
                editable: staff.roleId != null && !(staffRole !== null && staffRole !== void 0 && staffRole.avgChargeOutRate) && (0, $8kZ1o.canEditStaffChargeOutRate)((0, $1BTI2.default).user)
            },
            {
                id: "availability",
                size: 120
            },
            {
                id: "button"
            }
        ], [
        staffRole,
        staff
    ]);
    const renderTopRow = (row)=>{
        if (row.id === "button" || row.id === "role" || row.id === "availability") return null;
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8jD92.CheckboxWithLabel), {
            label: row.label,
            checked: row.value,
            id: row.id,
            onCheckedChange: row.onChange,
            disabled: !row.editable
        });
    };
    const includeRoleRates = staff.inheritPayRate || staff.inheritOvertimeRate || staff.inheritCostRate || staff.inheritChargeOutRate;
    const rowData = (0, $jbmdS.useMemo)(()=>{
        const rates = [];
        if (includeRoleRates) {
            var _staffRole$rates;
            rates.push(...(_staffRole$rates = staffRole.rates) !== null && _staffRole$rates !== void 0 ? _staffRole$rates : []);
        }
        rates.push(...staffRates !== null && staffRates !== void 0 ? staffRates : []);
        return rates.filter((rate)=>!rate.deletedAt).sort((a, b)=>{
            return new Date(a.date).getTime() - new Date(b.date).getTime();
        });
    }, [
        staff,
        staffRole,
        staffRates
    ]);
    const { table: table } = (0, $aaosT.useDataTable)({
        data: rowData,
        columns: columns,
        visibleColumns: columns.map((column)=>column === null || column === void 0 ? void 0 : column.accessorKey)
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fTGwv.Button), {
                variant: "outline",
                onClick: ()=>{
                    (0, $7UGfB.staffActions).addNewRates();
                },
                className: "mb-4",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                        className: "fa fa-plus mr-1"
                    }),
                    "Add Rate"
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $aYyI4.DataTable), {
                table: table,
                topRows: topRow,
                renderTopRow: renderTopRow
            })
        ]
    });
};

});
parcelRegister("46C2K", function(module, exports) {

$parcel$export(module.exports, "getColumns", function () { return $bf97bc3f96075cbd$export$978e30a0fb8610d8; });

var $61Ea1 = parcelRequire("61Ea1");

var $khCHn = parcelRequire("khCHn");

var $1BTI2 = parcelRequire("1BTI2");

var $8kZ1o = parcelRequire("8kZ1o");

var $7UGfB = parcelRequire("7UGfB");

var $fTGwv = parcelRequire("fTGwv");

var $eat5C = parcelRequire("eat5C");
function $bf97bc3f96075cbd$export$978e30a0fb8610d8(onHideColumn, staff) {
    const generateColumnDef = (0, $khCHn.createGenerateColumnDef)({
        onHideColumn: onHideColumn
    });
    const wideSize = 120;
    return [
        generateColumnDef({
            key: "date",
            type: "date",
            title: "Starting From",
            size: wideSize,
            editable: (r)=>{
                return !r.original.roleId && (0, $8kZ1o.canEditStaff)((0, $1BTI2.default).user);
            },
            onChange: (row, val)=>{
                (0, $7UGfB.staffActions).changeRateData(row.original.id, "date", val);
            }
        }),
        generateColumnDef({
            key: "payRate",
            type: "currency",
            title: "Pay Rate",
            size: wideSize,
            permissions: (r)=>(0, $8kZ1o.canViewStaffPayRate)((0, $1BTI2.default).user),
            editable: (r)=>!r.original.roleId && !(staff !== null && staff !== void 0 && staff.inheritPayRate) && (0, $8kZ1o.canEditStaffPayRate)((0, $1BTI2.default).user),
            customValue: (r)=>!r.roleId && !(staff !== null && staff !== void 0 && staff.inheritPayRate) || r.roleId && staff !== null && staff !== void 0 && staff.inheritPayRate ? r.payRate : null,
            onChange: (row, val)=>{
                (0, $7UGfB.staffActions).changeRateData(row.original.id, "payRate", (0, $eat5C.toNumber)(val));
            }
        }),
        generateColumnDef({
            key: "overtimeRate",
            type: "currency",
            title: "Overtime Rate",
            size: wideSize,
            permissions: (r)=>(0, $8kZ1o.canViewStaffOvertimeRate)((0, $1BTI2.default).user),
            editable: (r)=>!r.original.roleId && !(staff !== null && staff !== void 0 && staff.inheritOvertimeRate) && (0, $8kZ1o.canEditStaffOvertimeRate)((0, $1BTI2.default).user),
            customValue: (r)=>!r.roleId && !(staff !== null && staff !== void 0 && staff.inheritOvertimeRate) || r.roleId && staff !== null && staff !== void 0 && staff.inheritOvertimeRate ? r.overtimeRate : null,
            onChange: (row, val)=>{
                (0, $7UGfB.staffActions).changeRateData(row.original.id, "overtimeRate", (0, $eat5C.toNumber)(val));
            }
        }),
        generateColumnDef({
            key: "costRate",
            type: "currency",
            title: "Cost Rate",
            size: wideSize,
            permissions: (r)=>(0, $8kZ1o.canViewStaffCostRate)((0, $1BTI2.default).user),
            editable: (r)=>!(staff !== null && staff !== void 0 && staff.inheritCostRate) && !r.original.roleId && (0, $8kZ1o.canEditStaffCostRate)((0, $1BTI2.default).user),
            customValue: (r)=>!r.roleId && !(staff !== null && staff !== void 0 && staff.inheritCostRate) || r.roleId && staff !== null && staff !== void 0 && staff.inheritCostRate ? r.costRate : null,
            onChange: (row, val)=>{
                (0, $7UGfB.staffActions).changeRateData(row.original.id, "costRate", (0, $eat5C.toNumber)(val));
            }
        }),
        generateColumnDef({
            key: "chargeOutRate",
            type: "currency",
            title: "Charge Out Rate",
            size: wideSize,
            permissions: (r)=>(0, $8kZ1o.canViewStaffChargeOutRate)((0, $1BTI2.default).user),
            editable: (r)=>!(staff !== null && staff !== void 0 && staff.inheritChargeOutRate) && !r.original.roleId && (0, $8kZ1o.canEditStaffChargeOutRate)((0, $1BTI2.default).user),
            customValue: (r)=>!r.roleId && !(staff !== null && staff !== void 0 && staff.inheritChargeOutRate) || r.roleId && staff !== null && staff !== void 0 && staff.inheritChargeOutRate ? r.chargeOutRate : null,
            onChange: (row, val)=>{
                (0, $7UGfB.staffActions).changeRateData(row.original.id, "chargeOutRate", (0, $eat5C.toNumber)(val));
            }
        }),
        generateColumnDef({
            key: "weeklyAvailability",
            type: "number",
            title: "Weekly Availability",
            size: wideSize,
            editable: (r)=>!r.original.roleId && (0, $8kZ1o.canEditStaff)((0, $1BTI2.default).user),
            customValue: (r)=>!r.roleId ? r.weeklyAvailability : null,
            onChange: (row, val)=>{
                (0, $7UGfB.staffActions).changeRateData(row.original.id, "weeklyAvailability", (0, $eat5C.toNumber)(val));
            }
        }),
        generateColumnDef({
            key: "deleteButton",
            title: "Action",
            editable: (r)=>!r.original.roleId && (0, $8kZ1o.canEditStaff)((0, $1BTI2.default).user),
            permissions: ()=>(0, $8kZ1o.canEditStaff)((0, $1BTI2.default).user),
            cell: (c)=>{
                return !c.original.roleId ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fTGwv.Button), {
                    onClick: ()=>{
                        console.log(c.original.id);
                        (0, $7UGfB.staffActions).deleteRate({
                            id: c.original.id
                        });
                    },
                    disabled: !!c.original.roleId || !(0, $8kZ1o.canEditStaff)((0, $1BTI2.default).user),
                    variant: "outline",
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                        className: "fa fa-times"
                    })
                }) : null;
            }
        })
    ];
}

});


parcelRegister("b0kDs", function(module, exports) {

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $4qR9D = parcelRequire("4qR9D");

var $ikffN = parcelRequire("ikffN");

var $gAnn6 = parcelRequire("gAnn6");

var $8kZ1o = parcelRequire("8kZ1o");

var $kqlQp = parcelRequire("kqlQp");
var $6UBLf = parcelRequire("6UBLf");

var $7UGfB = parcelRequire("7UGfB");

var $fTGwv = parcelRequire("fTGwv");

var $5QoiI = parcelRequire("5QoiI");

var $MyPiE = parcelRequire("MyPiE");

var $38AIP = parcelRequire("38AIP");

var $4WSZl = parcelRequire("4WSZl");

var $gN0TC = parcelRequire("gN0TC");

var $e57zc = parcelRequire("e57zc");

var $bYl0g = parcelRequire("bYl0g");
function $d6bbcfbdfd9845ba$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const { Option: $d6bbcfbdfd9845ba$var$Option, OptGroup: $d6bbcfbdfd9845ba$var$OptGroup } = (0, $4qR9D.default);
const $d6bbcfbdfd9845ba$export$b0fab73a58417b3f = ({ id: id })=>{
    var _useCacheSlice, _listPermissions$find;
    const navigate = (0, $6UBLf.useNavigate)();
    const staff = (0, $7UGfB.useStaffMember)();
    const permission = (0, $7UGfB.useStaffPermissions)();
    const listPermissions = (_useCacheSlice = (0, $38AIP.useCacheSlice)("permissions")) !== null && _useCacheSlice !== void 0 ? _useCacheSlice : [];
    const defaultPreset = (_listPermissions$find = listPermissions.find((p)=>p.id.toString() === staff.permissionsId)) !== null && _listPermissions$find !== void 0 ? _listPermissions$find : {
        id: "custom",
        name: "Custom"
    };
    const [presetOption, setPresetOption] = (0, $jbmdS.useState)(defaultPreset);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        style: {
            width: "58em"
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    marginBottom: "5em"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("h2", {
                        className: "border-b border-[#aaa]",
                        children: "Presets"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsxs)($d6bbcfbdfd9845ba$export$78cadc47e966a49, {
                                childClassName: "flex",
                                label: "Permission Presets",
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5QoiI.PermissionsSelector), {
                                        value: presetOption,
                                        onChange: (value)=>{
                                            setPresetOption(value);
                                            const permissionSelected = listPermissions.find((p)=>p.id === value.id);
                                            console.log("value", value, permissionSelected);
                                            if (permissionSelected) {
                                                (0, $7UGfB.staffActions).changeStaffData("permissionsId", value.id);
                                                (0, $7UGfB.staffActions).changePermissions(permissionSelected.settings);
                                            } else {
                                                (0, $7UGfB.staffActions).changeStaffData("permissionsId", null);
                                                (0, $7UGfB.staffActions).changePermissions(staff.permissions);
                                            }
                                        }
                                    }),
                                    presetOption.id !== "custom" ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqlQp.Link), {
                                        to: `/permissions/${presetOption}`,
                                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fTGwv.Button), {
                                            className: "ml-2",
                                            children: "Edit..."
                                        })
                                    }) : /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fTGwv.Button), {
                                        className: "ml-2",
                                        onClick: ()=>{
                                        // const permission =
                                        //     PermissionCollection.createPermissionFromStaff(
                                        //         staff
                                        //     )
                                        // navigate({
                                        //     to: `/permissions/${permission.id}`,
                                        // })
                                        },
                                        children: "Create Preset..."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)($d6bbcfbdfd9845ba$export$78cadc47e966a49, {
                                label: "Financial Presets",
                                children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $e57zc.SwitchWithLabel), {
                                            label: "Project Fees & Revenue",
                                            disabled: !!staff.permissionsId,
                                            checked: (0, $8kZ1o.canSeeFeesAndRevenue)({
                                                ...staff,
                                                permissions: permission
                                            }),
                                            onCheckedChange: (v)=>{
                                                (0, $7UGfB.staffActions).changePermissions({
                                                    ...permission,
                                                    canViewRevenueForecast: v,
                                                    chargeOutRate: v ? "view" : "hidden",
                                                    projects: ((permission === null || permission === void 0 ? void 0 : permission.projects) || []).map((p)=>({
                                                            ...p,
                                                            permissions: {
                                                                ...p.permissions,
                                                                projectFees: v ? "view" : "hidden",
                                                                projectForecastedRevenue: v ? "view" : "hidden",
                                                                projectInvoices: v ? "view" : "hidden"
                                                            }
                                                        }))
                                                });
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $e57zc.SwitchWithLabel), {
                                            label: "Staff Cost & Project Expenses",
                                            disabled: !!staff.permissionsId,
                                            checked: (0, $8kZ1o.canSeeExpenses)({
                                                ...staff,
                                                permissions: permission
                                            }),
                                            onCheckedChange: (v)=>{
                                                (0, $7UGfB.staffActions).changePermissions({
                                                    ...permission,
                                                    costRate: v ? "view" : "hidden",
                                                    projects: (permission.projects || []).map((p)=>({
                                                            ...p,
                                                            permissions: {
                                                                ...p.permissions,
                                                                projectExpenses: v ? "view" : "hidden",
                                                                projectExpenseBudgets: v ? "view" : "hidden"
                                                            }
                                                        }))
                                                });
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $e57zc.SwitchWithLabel), {
                                            label: "Staff Salaries",
                                            disabled: !!staff.permissionsId,
                                            checked: (0, $8kZ1o.canSeeSalaries)({
                                                ...staff,
                                                permissions: permission
                                            }),
                                            onCheckedChange: (v)=>{
                                                (0, $7UGfB.staffActions).changePermissions({
                                                    ...permission,
                                                    payRate: v ? "view" : "hidden",
                                                    overtimeRate: v ? "view" : "hidden"
                                                });
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $e57zc.SwitchWithLabel), {
                                            label: "Operational Expenses",
                                            disabled: !!staff.permissionsId,
                                            checked: (0, $8kZ1o.canSeeOperationalExpenses)({
                                                ...staff,
                                                permissions: permission
                                            }),
                                            onCheckedChange: (v)=>{
                                                (0, $7UGfB.staffActions).changePermissions({
                                                    ...permission,
                                                    operationalExpenses: v ? "view" : "hidden"
                                                });
                                            }
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)($d6bbcfbdfd9845ba$export$b970cab02aaf8452, {
                disabled: staff.permissionsId
            })
        ]
    });
};
const $d6bbcfbdfd9845ba$export$b970cab02aaf8452 = ({ disabled: disabled })=>{
    const permissions = (0, $7UGfB.useStaffPermissions)();
    const handleUpdatePermissions = (key, value)=>{
        // updateStaffPermission(staff, { [key]: value })
        (0, $7UGfB.staffActions).changePermissions({
            ...permissions,
            [key]: value
        });
    };
    const handleUpdateProjectPermissions = (id, key, value)=>{
        // updateProjectPermission(staff, id, { [key]: value })
        (0, $7UGfB.staffActions).changePermissions({
            ...permissions,
            projects: permissions.projects.map((p)=>p.id === id ? {
                    ...p,
                    permissions: {
                        ...p.permissions,
                        [key]: value
                    }
                } : p)
        });
    };
    const handleUpdateFilterPermissions = (id, filter)=>{
        // updateProjectPermissionFilter(staff, id, filter)
        (0, $7UGfB.staffActions).changePermissions({
            ...permissions,
            projects: permissions.projects.map((p)=>p.id === id ? {
                    ...p,
                    filter: filter !== null && filter !== void 0 ? filter : p.filter
                } : p)
        });
    };
    const addProjectPermission = ()=>{
        // addProjectPermission(staff)
        (0, $7UGfB.staffActions).changePermissions({
            ...permissions,
            projects: [
                ...permissions.projects,
                {
                    id: $gN0TC(),
                    filter: !(0, $8kZ1o.hasPermissionsForAllProjects)(permissions) ? {
                        type: "all"
                    } : {
                        type: "project"
                    },
                    permissions: {
                        ...(0, $4WSZl.permissionPresets).timesheet.projects[0].permissions
                    }
                }
            ]
        });
    };
    return (0, $gAnn6.permissionStructure).map((group)=>group.label !== "Projects" ? /*#__PURE__*/ (0, $61Ea1.jsx)($d6bbcfbdfd9845ba$export$6310b070ee0bdfd1, {
            title: group.label,
            permissions: group.permissions,
            staffPermissions: permissions,
            onChange: handleUpdatePermissions,
            disabled: disabled
        }) : /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            children: [
                ((permissions === null || permissions === void 0 ? void 0 : permissions.projects) || []).map((projectPermissions)=>/*#__PURE__*/ (0, $61Ea1.jsx)($d6bbcfbdfd9845ba$export$3fd908b74b43d5a, {
                        staffPermissions: permissions,
                        permissions: group.permissions,
                        projectPermissions: projectPermissions,
                        onChange: (key, value)=>handleUpdateProjectPermissions(projectPermissions.id, key, value),
                        onFilterChange: (value)=>handleUpdateFilterPermissions(projectPermissions.id, value),
                        onDelete: ()=>(0, $8kZ1o.deleteProjectPermission)(projectPermissions.id),
                        disabled: disabled
                    })),
                !disabled ? /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                    className: "plus-btn border-[#d9d9d9] mb-10",
                    onClick: ()=>{
                        addProjectPermission();
                    },
                    children: "+ Add Project Permissions"
                }) : null
            ]
        }));
};
const $d6bbcfbdfd9845ba$export$3fd908b74b43d5a = ({ permissions: permissions, projectPermissions: projectPermissions, staffPermissions: staffPermissions, onChange: onChange, onFilterChange: onFilterChange, onDelete: onDelete, disabled: disabled })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        style: {
            marginBottom: "4em"
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    borderBottom: "1px solid #ccc",
                    display: "flex",
                    zIndex: 10,
                    position: "relative",
                    gap: "1em"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("h3", {
                        style: {
                            margin: 0
                        },
                        children: "Projects"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)($d6bbcfbdfd9845ba$var$ProjectPermissionFilter, {
                        staffPermissions: staffPermissions,
                        filter: projectPermissions.filter,
                        onChange: onFilterChange,
                        disabled: disabled
                    }),
                    !disabled ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fTGwv.Button), {
                        variant: "outline",
                        onClick: ()=>onDelete(),
                        children: "Delete"
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)($d6bbcfbdfd9845ba$export$6310b070ee0bdfd1, {
                permissions: permissions,
                staffPermissions: projectPermissions.permissions,
                onChange: onChange,
                disabled: disabled
            })
        ]
    });
};
const $d6bbcfbdfd9845ba$var$ProjectPermissionFilter = ({ filter: filter, onChange: onChange, staffPermissions: staffPermissions, disabled: disabled })=>{
    var _useCacheSlice2, _filter$values, _filter$values2;
    const permission = (_useCacheSlice2 = (0, $38AIP.useCacheSlice)("permissions")) !== null && _useCacheSlice2 !== void 0 ? _useCacheSlice2 : [];
    const costCentre = (0, $38AIP.useCacheSlice)("costCentres");
    const options = $jbmdS.useMemo(()=>[
            !(0, $8kZ1o.hasPermissionsForAllProjects)(staffPermissions) || filter.type === "all" ? {
                name: "All Projects",
                id: "all"
            } : null,
            {
                name: "Owned Projects",
                id: "owner"
            },
            {
                name: "Projects with Cost Centre",
                id: "costCentre"
            },
            {
                name: "Specific Projects",
                id: "project"
            }
        ].filter((c)=>c), [
        staffPermissions,
        filter.type
    ]);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: " w-full gap-3",
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    flex: filter.type === "all" ? "1 1 auto" : "0 0 auto",
                    marginBottom: "0.25em",
                    position: "relative",
                    zIndex: 10
                },
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5QoiI.Selector), {
                    value: filter.type,
                    onChange: (filterType)=>onChange({
                            type: filterType.id,
                            values: []
                        }),
                    disabled: disabled,
                    getLabel: (value)=>{
                        if (value !== null && value !== void 0 && value.name) return value.name;
                        const option = options.find((o)=>o.id === value);
                        return option ? option.name : "Select ....";
                    },
                    getValue: (value)=>value === null || value === void 0 ? void 0 : value.id,
                    options: options
                })
            }),
            filter.type === "project" ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $MyPiE.MultiSelect), {
                options: permission.map((p)=>({
                        label: p.name,
                        value: p.id.toString()
                    })),
                onValueChange: (values)=>{
                    onChange({
                        ...filter,
                        values: values
                    });
                },
                disabled: disabled,
                value: ((_filter$values = filter.values) !== null && _filter$values !== void 0 ? _filter$values : []).map((v)=>v.toString())
            }) : filter.type === "costCentre" ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $MyPiE.MultiSelect), {
                options: costCentre.map((cc)=>({
                        label: cc.name,
                        value: cc.id.toString()
                    })),
                onValueChange: (values)=>{
                    onChange({
                        ...filter,
                        values: values
                    });
                },
                disabled: disabled,
                value: ((_filter$values2 = filter.values) !== null && _filter$values2 !== void 0 ? _filter$values2 : []).map((v)=>v.toString())
            }) : null
        ]
    });
};
const $d6bbcfbdfd9845ba$export$6310b070ee0bdfd1 = ({ title: title, permissions: permissions, staffPermissions: staffPermissions, onChange: onChange, disabled: disabled })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        style: {
            marginBottom: title ? "4em" : 0
        },
        children: [
            title ? /*#__PURE__*/ (0, $61Ea1.jsx)("h3", {
                style: {
                    borderBottom: "1px solid #ccc"
                },
                children: title
            }) : null,
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: permissions.map(({ label: label, key: key, type: type, options: options, display: display = (permission)=>true })=>{
                    if (!display(staffPermissions)) return null;
                    const value = staffPermissions === null || staffPermissions === void 0 ? void 0 : staffPermissions[key];
                    const localOnChange = (value)=>onChange(key, value);
                    return type === "switch" ? /*#__PURE__*/ (0, $61Ea1.jsx)($d6bbcfbdfd9845ba$var$PermissionSwitch, {
                        label: label,
                        value: value,
                        onChange: localOnChange,
                        disabled: disabled
                    }) : /*#__PURE__*/ (0, $61Ea1.jsx)($d6bbcfbdfd9845ba$var$PermissionRadio, {
                        label: label,
                        value: value,
                        onChange: localOnChange,
                        options: options,
                        disabled: disabled
                    });
                })
            })
        ]
    });
};
const $d6bbcfbdfd9845ba$var$PermissionSwitch = ({ label: label, value: value = false, onChange: onChange, disabled: disabled })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)($d6bbcfbdfd9845ba$export$78cadc47e966a49, {
        label: label,
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $e57zc.Switch), {
            disabled: disabled,
            checked: value,
            onCheckedChange: (v)=>onChange(v)
        })
    });
};
const $d6bbcfbdfd9845ba$var$PermissionRadio = ({ label: label, value: value = "hidden", onChange: onChange, options: options = [
    "hidden",
    "view",
    "edit",
    "admin"
], disabled: disabled })=>{
    const styleOverrides = {
        hidden: {},
        view: {},
        edit: {},
        admin: {}
    };
    if (value === "hidden") styleOverrides.hidden = {
        backgroundColor: "#aaa",
        borderColor: "#aaa"
    };
    return /*#__PURE__*/ (0, $61Ea1.jsx)($d6bbcfbdfd9845ba$export$78cadc47e966a49, {
        label: label,
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bYl0g.Tabs), {
            value: value,
            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bYl0g.TabsList), {
                variant: "solid",
                children: options.map((option)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $bYl0g.TabsTrigger), {
                        onClick: ()=>onChange(option),
                        disabled: disabled,
                        value: option,
                        children: option === "admin" ? "Edit, Create, & Delete" : (0, $ikffN.capitalCase)(option)
                    }))
            })
        })
    });
};
var $d6bbcfbdfd9845ba$var$_ref = {
    name: "1dei7nh",
    styles: "display:grid;grid-template-columns:1fr 2fr;column-gap:5em;row-gap:0.5em;border-bottom:1px solid #e9e9e9;align-items:center;padding:0.5em 0;:hover{background-color:#f2f2f2;}z-index:1;position:relative"
};
const $d6bbcfbdfd9845ba$export$78cadc47e966a49 = ({ label: label, children: children, className: className, childClassName: childClassName })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: className,
        css: $d6bbcfbdfd9845ba$var$_ref,
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    fontWeight: "bold",
                    textAlign: "right"
                },
                children: label
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: childClassName,
                children: children
            })
        ]
    });
};

});
parcelRegister("MyPiE", function(module, exports) {

$parcel$export(module.exports, "MultiSelect", function () { return $6cb232ff66622ece$export$1e7dfd31545b5809; });
// src/components/multi-select.tsx

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $5kn1b = parcelRequire("5kn1b");

var $1kvoC = parcelRequire("1kvoC");
var $lKdR6 = parcelRequire("lKdR6");
var $i9asS = parcelRequire("i9asS");
var $knw1J = parcelRequire("knw1J");
var $5FqxN = parcelRequire("5FqxN");

var $95Evz = parcelRequire("95Evz");

var $9yFzD = parcelRequire("9yFzD");

var $fTGwv = parcelRequire("fTGwv");

var $dKid7 = parcelRequire("dKid7");

var $l4nwI = parcelRequire("l4nwI");

var $fRrIT = parcelRequire("fRrIT");
/**
 * Variants for the multi-select component to handle different styles.
 * Uses class-variance-authority (cva) to define different styles based on "variant" prop.
 */ const $6cb232ff66622ece$var$multiSelectVariants = (0, $5kn1b.cva)("m-1 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300", {
    variants: {
        variant: {
            default: "border-foreground/10 text-foreground bg-card hover:bg-card/80",
            secondary: "border-foreground/10 bg-secondary text-secondary-foreground hover:bg-secondary/80",
            destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
            inverted: "inverted"
        }
    },
    defaultVariants: {
        variant: "default"
    }
});
const $6cb232ff66622ece$export$1e7dfd31545b5809 = /*#__PURE__*/ $jbmdS.forwardRef(({ options: options, onValueChange: onValueChange, variant: variant, defaultValue: defaultValue = [], placeholder: placeholder = "Select options", animation: animation = 0, maxCount: maxCount = 3, modalPopover: modalPopover = false, asChild: asChild = false, className: className, ...props }, ref)=>{
    const [selectedValues, setSelectedValues] = $jbmdS.useState(defaultValue);
    const [isPopoverOpen, setIsPopoverOpen] = $jbmdS.useState(false);
    const [isAnimating, setIsAnimating] = $jbmdS.useState(false);
    const handleInputKeyDown = (event)=>{
        if (event.key === "Enter") setIsPopoverOpen(true);
        else if (event.key === "Backspace" && !event.currentTarget.value) {
            const newSelectedValues = [
                ...selectedValues
            ];
            newSelectedValues.pop();
            setSelectedValues(newSelectedValues);
            onValueChange(newSelectedValues);
        }
    };
    const toggleOption = (option)=>{
        const newSelectedValues = selectedValues.includes(option) ? selectedValues.filter((value)=>value !== option) : [
            ...selectedValues,
            option
        ];
        setSelectedValues(newSelectedValues);
        onValueChange(newSelectedValues);
    };
    const handleClear = ()=>{
        setSelectedValues([]);
        onValueChange([]);
    };
    const handleTogglePopover = ()=>{
        setIsPopoverOpen((prev)=>!prev);
    };
    const clearExtraOptions = ()=>{
        const newSelectedValues = selectedValues.slice(0, maxCount);
        setSelectedValues(newSelectedValues);
        onValueChange(newSelectedValues);
    };
    const toggleAll = ()=>{
        if (selectedValues.length === options.length) handleClear();
        else {
            const allValues = options.map((option)=>option.value);
            setSelectedValues(allValues);
            onValueChange(allValues);
        }
    };
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $l4nwI.Popover), {
        open: isPopoverOpen,
        onOpenChange: setIsPopoverOpen,
        modal: modalPopover,
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $l4nwI.PopoverTrigger), {
                asChild: true,
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fTGwv.Button), {
                    ref: ref,
                    ...props,
                    onClick: handleTogglePopover,
                    className: (0, $95Evz.cn)("flex w-full p-1 rounded-md border min-h-10 h-auto items-center justify-between bg-inherit hover:bg-inherit [&_svg]:pointer-events-auto", className),
                    children: selectedValues.length > 0 ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "flex justify-between items-center w-full",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                className: "flex flex-wrap items-center",
                                children: [
                                    selectedValues.slice(0, maxCount).map((value)=>{
                                        const option = options.find((o)=>o.value === value);
                                        console.log("Option", option, options, value, selectedValues);
                                        const IconComponent = option === null || option === void 0 ? void 0 : option.icon;
                                        return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $dKid7.Badge), {
                                            className: (0, $95Evz.cn)(isAnimating ? "animate-bounce" : "", $6cb232ff66622ece$var$multiSelectVariants({
                                                variant: variant
                                            })),
                                            style: {
                                                animationDuration: `${animation}s`
                                            },
                                            children: [
                                                IconComponent && /*#__PURE__*/ (0, $61Ea1.jsx)(IconComponent, {
                                                    className: "h-4 w-4 mr-2"
                                                }),
                                                option === null || option === void 0 ? void 0 : option.label,
                                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $knw1J.default), {
                                                    className: "ml-2 h-4 w-4 cursor-pointer",
                                                    onClick: (event)=>{
                                                        event.stopPropagation();
                                                        toggleOption(value);
                                                    }
                                                })
                                            ]
                                        }, value);
                                    }),
                                    selectedValues.length > maxCount && /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $dKid7.Badge), {
                                        className: (0, $95Evz.cn)("bg-transparent text-foreground border-foreground/1 hover:bg-transparent", isAnimating ? "animate-bounce" : "", $6cb232ff66622ece$var$multiSelectVariants({
                                            variant: variant
                                        })),
                                        style: {
                                            animationDuration: `${animation}s`
                                        },
                                        children: [
                                            `+ ${selectedValues.length - maxCount} more`,
                                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $knw1J.default), {
                                                className: "ml-2 h-4 w-4 cursor-pointer",
                                                onClick: (event)=>{
                                                    event.stopPropagation();
                                                    clearExtraOptions();
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                className: "flex items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5FqxN.default), {
                                        className: "h-4 mx-2 cursor-pointer text-muted-foreground",
                                        onClick: (event)=>{
                                            event.stopPropagation();
                                            handleClear();
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $9yFzD.Separator), {
                                        orientation: "vertical",
                                        className: "flex min-h-6 h-full"
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $lKdR6.default), {
                                        className: "h-4 mx-2 cursor-pointer text-muted-foreground"
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "flex items-center justify-between w-full mx-auto",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                className: "text-sm text-muted-foreground mx-3",
                                children: placeholder
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $lKdR6.default), {
                                className: "h-4 cursor-pointer text-muted-foreground mx-2"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $l4nwI.PopoverContent), {
                className: "w-auto p-0",
                align: "start",
                onEscapeKeyDown: ()=>setIsPopoverOpen(false),
                children: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fRrIT.Command), {
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fRrIT.CommandInput), {
                            placeholder: "Search...",
                            onKeyDown: handleInputKeyDown
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fRrIT.CommandList), {
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fRrIT.CommandEmpty), {
                                    children: "No results found."
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fRrIT.CommandGroup), {
                                    children: [
                                        /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fRrIT.CommandItem), {
                                            onSelect: toggleAll,
                                            className: "cursor-pointer flex",
                                            children: [
                                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                    className: (0, $95Evz.cn)("mr-2 flex h-4 w-4 items-center justify-center rounded-sm border border-primary", selectedValues.length === options.length ? "bg-primary text-primary-foreground" : "opacity-50 [&_svg]:invisible"),
                                                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $1kvoC.default), {
                                                        className: "h-4 w-4"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                                    children: "(Select All)"
                                                })
                                            ]
                                        }, "all"),
                                        options.map((option)=>{
                                            const isSelected = selectedValues.includes(option.value);
                                            return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fRrIT.CommandItem), {
                                                onSelect: ()=>toggleOption(option.value),
                                                className: "cursor-pointer flex mt-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                        className: (0, $95Evz.cn)("mr-2 flex h-4 w-4 items-center justify-center rounded-sm border border-primary", isSelected ? "bg-primary text-primary-foreground" : "opacity-50 [&_svg]:invisible"),
                                                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $1kvoC.default), {
                                                            className: "h-4 w-4"
                                                        })
                                                    }),
                                                    option.icon && /*#__PURE__*/ (0, $61Ea1.jsx)(option.icon, {
                                                        className: "mr-2 h-4 w-4 text-muted-foreground"
                                                    }),
                                                    /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                                        children: option.label
                                                    })
                                                ]
                                            }, option.value);
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fRrIT.CommandSeparator), {})
                            ]
                        })
                    ]
                })
            }),
            animation > 0 && selectedValues.length > 0 && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $i9asS.default), {
                className: (0, $95Evz.cn)("cursor-pointer my-2 text-foreground bg-background w-3 h-3", isAnimating ? "" : "text-muted-foreground"),
                onClick: ()=>setIsAnimating(!isAnimating)
            })
        ]
    });
});
$6cb232ff66622ece$export$1e7dfd31545b5809.displayName = "MultiSelect";

});
parcelRegister("i9asS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3612f5d7aacfc79$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $d3612f5d7aacfc79$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("WandSparkles", [
    [
        "path",
        {
            d: "m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72",
            key: "ul74o6"
        }
    ],
    [
        "path",
        {
            d: "m14 7 3 3",
            key: "1r5n42"
        }
    ],
    [
        "path",
        {
            d: "M5 6v4",
            key: "ilb8ba"
        }
    ],
    [
        "path",
        {
            d: "M19 14v4",
            key: "blhpug"
        }
    ],
    [
        "path",
        {
            d: "M10 2v2",
            key: "7u0qdc"
        }
    ],
    [
        "path",
        {
            d: "M7 8H3",
            key: "zfb6yr"
        }
    ],
    [
        "path",
        {
            d: "M21 16h-4",
            key: "1cnmox"
        }
    ],
    [
        "path",
        {
            d: "M11 3H9",
            key: "1obp7u"
        }
    ]
]);

});

parcelRegister("knw1J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed5ecc825e254291$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bYZ6V = parcelRequire("bYZ6V");
const $ed5ecc825e254291$export$2e2bcd8739ae039 = (0, $bYZ6V.default)("CircleX", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "m15 9-6 6",
            key: "1uzhvr"
        }
    ],
    [
        "path",
        {
            d: "m9 9 6 6",
            key: "z0biqf"
        }
    ]
]);

});




parcelRegister("1nQXs", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $102104cd98b4bb9a$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");
var $64Yjc = parcelRequire("64Yjc");

var $cEw0c = parcelRequire("cEw0c");

var $bz0NY = parcelRequire("bz0NY");

var $kuPRw = parcelRequire("kuPRw");

var $4iw5i = parcelRequire("4iw5i");

var $5PXcS = parcelRequire("5PXcS");

var $47i9t = parcelRequire("47i9t");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $7qobO = parcelRequire("7qobO");
parcelRequire("fM2j4");

var $6Q5sp = parcelRequire("6Q5sp");

var $bxXv3 = parcelRequire("bxXv3");

var $26sX2 = parcelRequire("26sX2");

var $38AIP = parcelRequire("38AIP");

var $kqntg = parcelRequire("kqntg");

var $7wJa8 = parcelRequire("7wJa8");

var $kiwkc = parcelRequire("kiwkc");

var $3h7sC = parcelRequire("3h7sC");

var $6l5Kr = parcelRequire("6l5Kr");
const $102104cd98b4bb9a$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_private/staff-roles/$id")({
    beforeLoad: ({ params: params })=>{
        if (!(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "staffRole", params)) throw new Error("Permission Denied");
        const role = (0, $38AIP.getCacheItemById)("roles", params.id);
        (0, $26sX2.setLayoutDefaults)({
            pageTitle: (role === null || role === void 0 ? void 0 : role.name) || "Staff Role",
            subMenu: "resources"
        });
    },
    errorComponent: ({ error: error, reset: reset })=>{
        if (error.message === "Permission Denied") return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7qobO.default), {});
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    },
    loader: async ({ params: params })=>await $102104cd98b4bb9a$var$loader(params.id),
    pendingComponent: (0, $4iw5i.default),
    component: $102104cd98b4bb9a$var$Wrapper,
    onLeave: (match)=>{
        const { id: id } = match.params;
        const role = (0, $bxXv3.default).rolesById[id];
        if (role && !role.createdAt && match.pathname !== (0, $6Q5sp.router).latestLocation.pathname) (0, $6l5Kr.cleanupNewEntity)(role, "role");
    }
});
const $102104cd98b4bb9a$var$loader = async (id)=>{
    const data = await (0, $3h7sC.trpc).legacy.getRolePageData.query({
        id: id
    });
    const processedModels = (0, $47i9t.processTRPCData)(data);
    const role = (0, $bxXv3.default).rolesById[id];
    if (!role) throw (0, $64Yjc.notFound)();
    return processedModels;
};
function $102104cd98b4bb9a$var$Wrapper() {
    const { id: id } = $102104cd98b4bb9a$export$e7b0ac011bb776c6.useParams();
    // The store now handles all the save toast logic internally
    (0, $kiwkc.staffRoleStore).useSaveHandler();
    if ((0, $8kZ1o.migratedToV2)()) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqntg.CenterPadPageBody), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7wJa8.RolePage), {
            id: id
        })
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $cEw0c.default), {
                id: id
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kuPRw.default), {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bz0NY.default), {
                    id: id
                })
            })
        ]
    });
}

});
parcelRegister("cEw0c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93620b726136be6c$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("lCpBr");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $36Jjh = parcelRequire("36Jjh");
parcelRequire("gJT7h");

var $khJQv = parcelRequire("khJQv");
parcelRequire("cxnwP");

var $bxXv3 = parcelRequire("bxXv3");

var $ixUBK = parcelRequire("ixUBK");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $3X7oM = parcelRequire("3X7oM");
var $93620b726136be6c$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ extraContent: extraContent, id: id })=>{
    const role = (0, $bxXv3.default).rolesById[id];
    if (!role) return null;
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $36Jjh.default), {
        heading: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: (role === null || role === void 0 ? void 0 : role.name) || "New Role"
            })
        }),
        rightButtons: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            className: "flex items-center gap-2",
            children: [
                (0, $8kZ1o.canEditRoles)((0, $1BTI2.default).user) ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3X7oM.default), {
                    label: role.isArchived ? "Unarchive" : "Archive",
                    icon: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                        className: "fa fa-archive"
                    }),
                    onClick: ()=>role.update({
                            isArchived: !role.isArchived
                        })
                }) : null,
                (0, $8kZ1o.canDeleteRoles)((0, $1BTI2.default).user) ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3X7oM.default), {
                    label: "Delete",
                    icon: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                        className: "fa fa-trash"
                    }),
                    onClick: ()=>(0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $ixUBK.default), {
                            role: role,
                            modalId: "deleteRole"
                        }))
                }) : null
            ]
        }),
        extraContent: extraContent
    });
});

});
parcelRegister("ixUBK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d807383247f765d8$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("eat5C");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $fEcKX = parcelRequire("fEcKX");

var $fM2j4 = parcelRequire("fM2j4");

var $6UBLf = parcelRequire("6UBLf");

var $6l5Kr = parcelRequire("6l5Kr");
var $d807383247f765d8$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ role: role, modalId: modalId })=>{
    const navigate = (0, $6UBLf.useNavigate)();
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fEcKX.default), {
        modalId: modalId,
        heading: "Delete Staff Role",
        saveButtons: [
            {
                label: "Archive Role",
                onClick: ()=>{
                    if (!role.createdAt) (0, $6l5Kr.handleEntityDelete)(role, "role", navigate);
                    else {
                        role.update({
                            isArchived: true
                        });
                        (0, $fM2j4.default).saveModel(role);
                        navigate({
                            to: "/staff-roles/"
                        });
                    }
                }
            },
            {
                label: "Delete Role",
                onClick: ()=>(0, $6l5Kr.handleEntityDelete)(role, "role", navigate)
            }
        ],
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("p", {
            style: {
                margin: "1em"
            },
            children: [
                "Are you sure you wish to delete ",
                /*#__PURE__*/ (0, $61Ea1.jsx)("em", {
                    children: role.name
                }),
                "?"
            ]
        })
    });
});

});


parcelRegister("bz0NY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86b3966e56c1abf9$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $6vW9G = parcelRequire("6vW9G");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $goLmS = parcelRequire("goLmS");

var $gdEjf = parcelRequire("gdEjf");
parcelRequire("cxnwP");
parcelRequire("gJT7h");

var $bxXv3 = parcelRequire("bxXv3");

var $dtlWt = parcelRequire("dtlWt");
parcelRequire("htkeB");

var $52dEm = parcelRequire("52dEm");

var $49KZT = parcelRequire("49KZT");

var $1BTI2 = parcelRequire("1BTI2");

var $8kZ1o = parcelRequire("8kZ1o");
const $86b3966e56c1abf9$var$rateColumns = (role)=>[
        {
            id: "date",
            label: "Starting From",
            width: 20,
            type: "date",
            editable: (r)=>r.modelType === "roleRate" && (0, $8kZ1o.canEditRoles)((0, $1BTI2.default).user),
            value: (r)=>r.date,
            onChange: (r)=>(v)=>r.update({
                        date: v
                    })
        },
        {
            label: "Pay Rate",
            width: 20,
            type: "currency",
            permissions: (r)=>(0, $8kZ1o.canViewStaffPayRate)((0, $1BTI2.default).user),
            editable: (r)=>!role.avgPayRate && (0, $8kZ1o.canEditRoles)((0, $1BTI2.default).user) && (0, $8kZ1o.canEditStaffPayRate)((0, $1BTI2.default).user),
            value: (p)=>role.avgPayRate ? role.getRateAtDate("pay", p.date) : p.payRate,
            component: (props)=>{
                if (isFinite(props.value)) return (0, $49KZT.default)["currency"](props);
            },
            onChange: (r)=>(v)=>r.update({
                        payRate: v
                    })
        },
        {
            label: "Overtime Rate",
            width: 20,
            type: "currency",
            permissions: (r)=>(0, $8kZ1o.canViewStaffOvertimeRate)((0, $1BTI2.default).user),
            editable: (r)=>r.modelType === "roleRate" && !role.avgOvertimeRate && (0, $8kZ1o.canEditRoles)((0, $1BTI2.default).user) && (0, $8kZ1o.canEditStaffOvertimeRate)((0, $1BTI2.default).user),
            value: (p)=>role.avgOvertimeRate ? role.getRateAtDate("overtime", p.date) : p.overtimeRate,
            component: (props)=>{
                if (isFinite(props.value)) return (0, $49KZT.default)["currency"](props);
            },
            onChange: (r)=>(v)=>r.update({
                        overtimeRate: v
                    })
        },
        {
            label: "Cost Rate",
            width: 20,
            type: "currency",
            permissions: (r)=>(0, $8kZ1o.canViewStaffCostRate)((0, $1BTI2.default).user),
            editable: (r)=>r.modelType === "roleRate" && !role.avgCostRate && (0, $8kZ1o.canEditRoles)((0, $1BTI2.default).user) && (0, $8kZ1o.canEditStaffCostRate)((0, $1BTI2.default).user),
            value: (p)=>role.avgCostRate ? role.getRateAtDate("cost", p.date) : p.costRate,
            component: (props)=>{
                if (isFinite(props.value)) return (0, $49KZT.default)["currency"](props);
            },
            onChange: (r)=>(v)=>r.update({
                        costRate: v
                    })
        },
        {
            label: "Charge Out Rate",
            width: 20,
            type: "currency",
            permissions: (r)=>(0, $8kZ1o.canViewStaffChargeOutRate)((0, $1BTI2.default).user),
            editable: (r)=>r.modelType === "roleRate" && !role.avgChargeOutRate && (0, $8kZ1o.canEditRoles)((0, $1BTI2.default).user) && (0, $8kZ1o.canEditStaffChargeOutRate)((0, $1BTI2.default).user),
            value: (p)=>role.avgChargeOutRate ? role.getRateAtDate("chargeOut", p.date) : p.chargeOutRate,
            component: (props)=>{
                if (isFinite(props.value)) return (0, $49KZT.default)["currency"](props);
            },
            onChange: (r)=>(v)=>r.update({
                        chargeOutRate: v
                    })
        },
        {
            label: "",
            width: 4,
            type: "button",
            permissions: (r)=>(0, $8kZ1o.canEditRoles)((0, $1BTI2.default).user),
            editable: (r)=>(0, $8kZ1o.canEditRoles)((0, $1BTI2.default).user),
            value: (p)=>/*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                    className: "fa fa-times",
                    style: {
                        marginRight: 0
                    }
                }),
            onClick: (r)=>()=>{
                    r.update({
                        deletedAt: new Date()
                    });
                }
        }
    ];
const $86b3966e56c1abf9$var$avgRateColumns = [
    {
        width: 20,
        type: "text",
        value: ()=>"",
        style: ()=>({
                textAlign: "right",
                justifyContent: "flex-end"
            })
    },
    {
        label: "Pay Rate",
        width: 20,
        type: "boolean",
        value: (r)=>r.avgPayRate,
        permissions: (r)=>(0, $8kZ1o.canViewStaffPayRate)((0, $1BTI2.default).user),
        onChange: (r)=>(v)=>r.update({
                    avgPayRate: v
                }),
        editable: (r)=>!r.staff.some((s)=>s.inheritPayRate) && (0, $8kZ1o.canEditRoles)((0, $1BTI2.default).user) && (0, $8kZ1o.canEditStaffPayRate)((0, $1BTI2.default).user),
        component: (props)=>{
            return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    display: "flex"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        style: {
                            opacity: props.editable ? 1 : 0.75,
                            flex: "1 1 auto"
                        },
                        children: "Average From Staff"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                        disabled: !props.editable,
                        ...props,
                        style: {
                            ...props.style,
                            flex: "0 0 auto",
                            width: "1em",
                            marginLeft: "0.5em"
                        }
                    })
                ]
            });
        },
        style: ()=>({
                textAlign: "right",
                justifyContent: "flex-end"
            })
    },
    {
        label: "Overtime Rate",
        width: 20,
        type: "boolean",
        value: (r)=>r.avgOvertimeRate,
        onChange: (r)=>(v)=>r.update({
                    avgOvertimeRate: v
                }),
        permissions: (r)=>(0, $8kZ1o.canViewStaffOvertimeRate)((0, $1BTI2.default).user),
        editable: (r)=>!r.staff.some((s)=>s.inheritOvertimeRate) && (0, $8kZ1o.canEditRoles)((0, $1BTI2.default).user) && (0, $8kZ1o.canEditStaffOvertimeRate)((0, $1BTI2.default).user),
        component: (props)=>{
            return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    display: "flex"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        style: {
                            opacity: props.editable ? 1 : 0.75,
                            flex: "1 1 auto"
                        },
                        children: "Average From Staff"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                        disabled: !props.editable,
                        ...props,
                        style: {
                            ...props.style,
                            flex: "0 0 auto",
                            width: "1em",
                            marginLeft: "0.5em"
                        }
                    })
                ]
            });
        },
        style: ()=>({
                textAlign: "right",
                justifyContent: "flex-end"
            })
    },
    {
        label: "Cost Rate",
        width: 20,
        type: "boolean",
        value: (r)=>r.avgCostRate,
        onChange: (r)=>(v)=>r.update({
                    avgCostRate: v
                }),
        permissions: (r)=>(0, $8kZ1o.canViewStaffCostRate)((0, $1BTI2.default).user),
        editable: (r)=>!r.staff.some((s)=>s.inheritCostRate) && (0, $8kZ1o.canEditRoles)((0, $1BTI2.default).user) && (0, $8kZ1o.canEditStaffCostRate)((0, $1BTI2.default).user),
        component: (props)=>{
            return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    display: "flex"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        style: {
                            opacity: props.editable ? 1 : 0.75,
                            flex: "1 1 auto"
                        },
                        children: "Average From Staff"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                        disabled: !props.editable,
                        ...props,
                        style: {
                            ...props.style,
                            flex: "0 0 auto",
                            width: "1em",
                            marginLeft: "0.5em"
                        }
                    })
                ]
            });
        },
        style: ()=>({
                textAlign: "right",
                justifyContent: "flex-end"
            })
    },
    {
        label: "Charge Out Rate",
        width: 20,
        type: "boolean",
        value: (r)=>r.avgChargeOutRate,
        onChange: (r)=>(v)=>r.update({
                    avgChargeOutRate: v
                }),
        permissions: (r)=>(0, $8kZ1o.canViewStaffChargeOutRate)((0, $1BTI2.default).user),
        editable: (r)=>!r.staff.some((s)=>s.inheritChargeOutRate) && (0, $8kZ1o.canEditRoles)((0, $1BTI2.default).user) && (0, $8kZ1o.canEditStaffChargeOutRate)((0, $1BTI2.default).user),
        component: (props)=>{
            return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    display: "flex"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        style: {
                            opacity: props.editable ? 1 : 0.75,
                            flex: "1 1 auto"
                        },
                        children: "Average From Staff"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                        disabled: !props.editable,
                        ...props,
                        style: {
                            ...props.style,
                            flex: "0 0 auto",
                            width: "1em",
                            marginLeft: "0.5em"
                        }
                    })
                ]
            });
        },
        style: ()=>({
                textAlign: "right",
                justifyContent: "flex-end"
            })
    },
    {
        width: 4,
        type: "text",
        permissions: (r)=>(0, $8kZ1o.canEditRoles)((0, $1BTI2.default).user),
        value: ()=>""
    }
];
var $86b3966e56c1abf9$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ id: id })=>{
    const isEditable = (0, $8kZ1o.canEditRoles)((0, $1BTI2.default).user);
    const role = (0, $bxXv3.default).rolesById[id];
    if (!role) return null;
    const memoizedColumns = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useMemo(()=>{
        return $86b3966e56c1abf9$var$rateColumns(role).filter((c)=>!c.permissions || c.permissions());
    }, [
        role
    ]);
    const [rows, setRows] = (0, $jbmdS.useState)(role.rates.sort((a, b)=>{
        var _a$date, _b$date;
        return (a === null || a === void 0 ? void 0 : (_a$date = a.date) === null || _a$date === void 0 ? void 0 : _a$date.getTime()) - (b === null || b === void 0 ? void 0 : (_b$date = b.date) === null || _b$date === void 0 ? void 0 : _b$date.getTime());
    }));
    (0, $jbmdS.useEffect)(()=>{
        setRows(role.rates.sort((a, b)=>{
            var _a$date2, _b$date2;
            return (a === null || a === void 0 ? void 0 : (_a$date2 = a.date) === null || _a$date2 === void 0 ? void 0 : _a$date2.getTime()) - (b === null || b === void 0 ? void 0 : (_b$date2 = b.date) === null || _b$date2 === void 0 ? void 0 : _b$date2.getTime());
        }));
    }, [
        role.id
    ]);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "form-horizontal",
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $gdEjf.FormSection), {
                    children: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $gdEjf.FormRow), {
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6vW9G.default), {
                                style: {
                                    fontSize: "1em",
                                    width: "7em"
                                },
                                children: "Name:"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
                                className: "staff-member-component__first-name-input input-base ml-1",
                                type: "text",
                                value: role.name || "",
                                disabled: !isEditable,
                                onChange: (e)=>role.update({
                                        name: e.target.value
                                    })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
                        columns: memoizedColumns,
                        rows: rows.filter((r)=>!r.deletedAt),
                        topRow: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
                            columns: $86b3966e56c1abf9$var$avgRateColumns.filter((c)=>!c.permissions || c.permissions()),
                            rows: [
                                role
                            ],
                            showHeader: false
                        })
                    }),
                    isEditable ? /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                        className: "btn btn-default plus-btn border-[#ccc]",
                        style: {
                            marginTop: "2em"
                        },
                        onClick: ()=>{
                            const rr = (0, $dtlWt.default).add({
                                roleId: role.id,
                                date: new Date()
                            }, {
                                trackUpdates: true
                            });
                            setRows([
                                ...rows,
                                rr
                            ]);
                        },
                        children: "+ Add Rate"
                    }) : null
                ]
            })
        ]
    });
});

});
parcelRegister("6vW9G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4be2bfbd3e330331$export$2e2bcd8739ae039; });

var $etz1B = parcelRequire("etz1B");

var $7i29i = parcelRequire("7i29i");

var $jbmdS = parcelRequire("jbmdS");


var $dWgPS = parcelRequire("dWgPS");

var $7sLqS = parcelRequire("7sLqS");

var $8SlUh = parcelRequire("8SlUh");

var $4ukxR = parcelRequire("4ukxR");

var $azvC5 = parcelRequire("azvC5");

var $b17fm = parcelRequire("b17fm");

var $cPCeZ = parcelRequire("cPCeZ");

var $1qEvy = parcelRequire("1qEvy");

var $4TLFw = parcelRequire("4TLFw");
"use client";
const $4be2bfbd3e330331$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const $4be2bfbd3e330331$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $azvC5.default)(color)}`,
            disabled && "disabled",
            error && "error",
            filled && "filled",
            focused && "focused",
            required && "required"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, $7sLqS.default)(slots, (0, $1qEvy.getFormLabelUtilityClasses), classes);
};
const $4be2bfbd3e330331$export$aa5bc7f8a4705b27 = (0, $cPCeZ.default)("label", {
    name: "MuiFormLabel",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $7i29i.default)({}, styles.root, ownerState.color === "secondary" && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $7i29i.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: "1.4375em",
        padding: 0,
        position: "relative",
        [`&.${(0, $1qEvy.default).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $1qEvy.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $1qEvy.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $4be2bfbd3e330331$var$AsteriskComponent = (0, $cPCeZ.default)("span", {
    name: "MuiFormLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $1qEvy.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $4be2bfbd3e330331$var$FormLabel = /*#__PURE__*/ $jbmdS.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $b17fm.useDefaultProps)({
        props: inProps,
        name: "MuiFormLabel"
    });
    const { children: children, className: className, component: component = "label" } = props, other = (0, $etz1B.default)(props, $4be2bfbd3e330331$var$_excluded);
    const muiFormControl = (0, $4ukxR.default)();
    const fcs = (0, $8SlUh.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "required",
            "focused",
            "disabled",
            "error",
            "filled"
        ]
    });
    const ownerState = (0, $7i29i.default)({}, props, {
        color: fcs.color || "primary",
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $4be2bfbd3e330331$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4TLFw.jsxs)($4be2bfbd3e330331$export$aa5bc7f8a4705b27, (0, $7i29i.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $dWgPS.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $4TLFw.jsxs)($4be2bfbd3e330331$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    "*"
                ]
            })
        ]
    }));
});
var $4be2bfbd3e330331$export$2e2bcd8739ae039 = $4be2bfbd3e330331$var$FormLabel;

});
parcelRegister("7sLqS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56eff10dbfbf4994$export$2e2bcd8739ae039; });
function $56eff10dbfbf4994$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== "") acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(" ");
    });
    return output;
}

});

parcelRegister("8SlUh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67645c1d4fb60220$export$2e2bcd8739ae039; });
function $67645c1d4fb60220$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === "undefined") acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}

});

parcelRegister("4ukxR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3449e69bc5e0fb39$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");

var $j0aDG = parcelRequire("j0aDG");
"use client";
function $3449e69bc5e0fb39$export$2e2bcd8739ae039() {
    return $jbmdS.useContext((0, $j0aDG.default));
}

});
parcelRegister("j0aDG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd56451f2734ccf3$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");
/**
 * @ignore - internal component.
 */ const $dd56451f2734ccf3$var$FormControlContext = /*#__PURE__*/ $jbmdS.createContext(undefined);
var $dd56451f2734ccf3$export$2e2bcd8739ae039 = $dd56451f2734ccf3$var$FormControlContext;

});


parcelRegister("azvC5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b25b2045c2217f2$export$2e2bcd8739ae039; });

var $cbZCf = parcelRequire("cbZCf");
var $7b25b2045c2217f2$export$2e2bcd8739ae039 = (0, $cbZCf.default);

});
parcelRegister("cbZCf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e064ebab5bfb524$export$2e2bcd8739ae039; });

var $7PAqt = parcelRequire("7PAqt");
function $8e064ebab5bfb524$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $7PAqt.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRegister("7PAqt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b398d4a882a15ef$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $5b398d4a882a15ef$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = "https://mui.com/production-error/?code=" + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});



parcelRegister("b17fm", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", function () { return $805568c79e78a269$export$2440da353cedad43; });

var $7i29i = parcelRequire("7i29i");
parcelRequire("jbmdS");


var $liWpv = parcelRequire("liWpv");

var $4TLFw = parcelRequire("4TLFw");
"use client";
function $805568c79e78a269$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $4TLFw.jsx)((0, $liWpv.default), (0, $7i29i.default)({}, props));
}
var $805568c79e78a269$export$2e2bcd8739ae039 = $805568c79e78a269$var$DefaultPropsProvider;
function $805568c79e78a269$export$2440da353cedad43(params) {
    return (0, $liWpv.useDefaultProps)(params);
}

});
parcelRegister("liWpv", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", function () { return $f828967e46eb4f2e$export$2440da353cedad43; });
$parcel$export(module.exports, "default", function () { return $f828967e46eb4f2e$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");


var $egUBf = parcelRequire("egUBf");

var $4TLFw = parcelRequire("4TLFw");
"use client";
const $f828967e46eb4f2e$var$PropsContext = /*#__PURE__*/ $jbmdS.createContext(undefined);
function $f828967e46eb4f2e$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $4TLFw.jsx)($f828967e46eb4f2e$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $f828967e46eb4f2e$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $egUBf.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $egUBf.default)(config, props);
    return props;
}
function $f828967e46eb4f2e$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $jbmdS.useContext($f828967e46eb4f2e$var$PropsContext);
    return $f828967e46eb4f2e$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $f828967e46eb4f2e$export$2e2bcd8739ae039 = $f828967e46eb4f2e$var$DefaultPropsProvider;

});
parcelRegister("egUBf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a63e76d71643da85$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");
function $a63e76d71643da85$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $7i29i.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $7i29i.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $7i29i.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $a63e76d71643da85$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});



parcelRegister("cPCeZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9577e949003eb7e0$export$2e2bcd8739ae039; });

var $fiZl3 = parcelRequire("fiZl3");

var $gW6tp = parcelRequire("gW6tp");

var $jxKUS = parcelRequire("jxKUS");

var $kAgHN = parcelRequire("kAgHN");

"use client";
const $9577e949003eb7e0$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($fiZl3)))({
    themeId: (0, $jxKUS.default),
    defaultTheme: $gW6tp.default,
    rootShouldForwardProp: $kAgHN.default
});
var $9577e949003eb7e0$export$2e2bcd8739ae039 = $9577e949003eb7e0$var$styled;

});
parcelRegister("fiZl3", function(module, exports) {
"use strict";

var $6cBd9 = parcelRequire("6cBd9");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b2481e0794e7f416$var$createStyled;
module.exports.shouldForwardProp = $b2481e0794e7f416$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $b2481e0794e7f416$var$_extends2 = $6cBd9((parcelRequire("u6wRM")));

var $b2481e0794e7f416$var$_objectWithoutPropertiesLoose2 = $6cBd9((parcelRequire("gCHEX")));

var $b2481e0794e7f416$var$_styledEngine = $b2481e0794e7f416$var$_interopRequireWildcard((parcelRequire("iapdo")));

var $7swQh = parcelRequire("7swQh");

var $b2481e0794e7f416$var$_capitalize = $6cBd9((parcelRequire("d8tCb")));

var $b2481e0794e7f416$var$_getDisplayName = $6cBd9((parcelRequire("kejXW")));

var $b2481e0794e7f416$var$_createTheme = $6cBd9((parcelRequire("jR46X")));

var $b2481e0794e7f416$var$_styleFunctionSx = $6cBd9((parcelRequire("97hmO")));
const $b2481e0794e7f416$var$_excluded = [
    "ownerState"
], $b2481e0794e7f416$var$_excluded2 = [
    "variants"
], $b2481e0794e7f416$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
/* eslint-disable no-underscore-dangle */ function $b2481e0794e7f416$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($b2481e0794e7f416$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $b2481e0794e7f416$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $b2481e0794e7f416$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $b2481e0794e7f416$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $b2481e0794e7f416$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
// Update /system/styled/#api in case if this changes
function $b2481e0794e7f416$var$shouldForwardProp(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $b2481e0794e7f416$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $b2481e0794e7f416$var$_createTheme.default)();
const $b2481e0794e7f416$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $b2481e0794e7f416$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $b2481e0794e7f416$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $b2481e0794e7f416$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $b2481e0794e7f416$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $b2481e0794e7f416$var$_objectWithoutPropertiesLoose2.default)(_ref, $b2481e0794e7f416$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === "function" ? callableStyle((0, $b2481e0794e7f416$var$_extends2.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$b2481e0794e7f416$var$processStyleArg(resolvedStyle, (0, $b2481e0794e7f416$var$_extends2.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === "object" && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $b2481e0794e7f416$var$_objectWithoutPropertiesLoose2.default)(resolvedStylesArg, $b2481e0794e7f416$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === "function") isMatch = variant.props((0, $b2481e0794e7f416$var$_extends2.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === "function" ? variant.style((0, $b2481e0794e7f416$var$_extends2.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $b2481e0794e7f416$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $b2481e0794e7f416$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $b2481e0794e7f416$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $b2481e0794e7f416$var$shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, $b2481e0794e7f416$var$_styleFunctionSx.default)((0, $b2481e0794e7f416$var$_extends2.default)({}, props, {
            theme: $b2481e0794e7f416$var$resolveTheme((0, $b2481e0794e7f416$var$_extends2.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $b2481e0794e7f416$var$_styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $b2481e0794e7f416$var$defaultOverridesResolver($b2481e0794e7f416$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $b2481e0794e7f416$var$_objectWithoutPropertiesLoose2.default)(inputOptions, $b2481e0794e7f416$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $b2481e0794e7f416$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($b2481e0794e7f416$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $b2481e0794e7f416$var$_styledEngine.default)(tag, (0, $b2481e0794e7f416$var$_extends2.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg || (0, $7swQh.isPlainObject)(stylesArg)) return (props)=>$b2481e0794e7f416$var$processStyleArg(stylesArg, (0, $b2481e0794e7f416$var$_extends2.default)({}, props, {
                    theme: $b2481e0794e7f416$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $b2481e0794e7f416$var$resolveTheme((0, $b2481e0794e7f416$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $b2481e0794e7f416$var$processStyleArg(slotStyle, (0, $b2481e0794e7f416$var$_extends2.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $b2481e0794e7f416$var$resolveTheme((0, $b2481e0794e7f416$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $b2481e0794e7f416$var$processStyleArg({
                    variants: themeVariants
                }, (0, $b2481e0794e7f416$var$_extends2.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRegister("6cBd9", function(module, exports) {
function $4840ba6d993d46a1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $4840ba6d993d46a1$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("iapdo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $d39cb853c51bd453$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_processStyles", function () { return $d39cb853c51bd453$export$e00380445f2b9e0c; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("kjYAx")).T; });
$parcel$export(module.exports, "keyframes", function () { return (parcelRequire("BPPBq")).keyframes; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("BPPBq")).css; });
$parcel$export(module.exports, "StyledEngineProvider", function () { return (parcelRequire("7nZay")).default; });
$parcel$export(module.exports, "GlobalStyles", function () { return (parcelRequire("kxPWc")).default; });
/**
 * @mui/styled-engine v5.16.6
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $lt1Ns = parcelRequire("lt1Ns");

var $BPPBq = parcelRequire("BPPBq");
var $kjYAx = parcelRequire("kjYAx");

var $7nZay = parcelRequire("7nZay");

var $kxPWc = parcelRequire("kxPWc");
"use client";
function $d39cb853c51bd453$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $lt1Ns.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $d39cb853c51bd453$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

});
parcelRegister("lt1Ns", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa0db33199d3cbfc$export$2e2bcd8739ae039; });

var $9NaD9 = parcelRequire("9NaD9");
parcelRequire("u6wRM");
parcelRequire("jbmdS");
parcelRequire("ly5LH");

parcelRequire("fvFHh");
parcelRequire("lkbnQ");
parcelRequire("cqJqj");
var $fa0db33199d3cbfc$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $fa0db33199d3cbfc$export$2e2bcd8739ae039 = (0, $9NaD9.default).bind();
$fa0db33199d3cbfc$var$tags.forEach(function(tagName) {
    $fa0db33199d3cbfc$export$2e2bcd8739ae039[tagName] = $fa0db33199d3cbfc$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("9NaD9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7210efa23d5784b7$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $jbmdS = parcelRequire("jbmdS");

var $ly5LH = parcelRequire("ly5LH");
parcelRequire("BPPBq");
var $kjYAx = parcelRequire("kjYAx");

var $fvFHh = parcelRequire("fvFHh");

var $lkbnQ = parcelRequire("lkbnQ");

var $cqJqj = parcelRequire("cqJqj");
/* import type {
  ElementType,
  StatelessFunctionalComponent,
  AbstractComponent
} from 'react' */ /*
export type Interpolations = Array<any>

export type StyledElementType<Props> =
  | string
  | AbstractComponent<{ ...Props, className: string }, mixed>

export type StyledOptions = {
  label?: string,
  shouldForwardProp?: string => boolean,
  target?: string
}

export type StyledComponent<Props> = StatelessFunctionalComponent<Props> & {
  defaultProps: any,
  toString: () => string,
  withComponent: (
    nextTag: StyledElementType<Props>,
    nextOptions?: StyledOptions
  ) => StyledComponent<Props>
}

export type PrivateStyledComponent<Props> = StyledComponent<Props> & {
  __emotion_real: StyledComponent<Props>,
  __emotion_base: any,
  __emotion_styles: any,
  __emotion_forwardProp: any
}
*/ var $7210efa23d5784b7$var$testOmitPropsOnStringTag = (0, $ly5LH.default);
var $7210efa23d5784b7$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $7210efa23d5784b7$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $7210efa23d5784b7$var$testOmitPropsOnStringTag : $7210efa23d5784b7$var$testOmitPropsOnComponent;
};
var $7210efa23d5784b7$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
/*
export type CreateStyledComponent = <Props>(
  ...args: Interpolations
) => StyledComponent<Props>

export type CreateStyled = {
  <Props>(
    tag: StyledElementType<Props>,
    options?: StyledOptions
  ): (...args: Interpolations) => StyledComponent<Props>,
  [key: string]: CreateStyledComponent,
  bind: () => CreateStyled
}
*/ var $7210efa23d5784b7$var$isDevelopment = false;
var $7210efa23d5784b7$var$isBrowser = typeof document !== "undefined";
var $7210efa23d5784b7$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $fvFHh.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $cqJqj.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $fvFHh.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$7210efa23d5784b7$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $jbmdS.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $7210efa23d5784b7$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $7210efa23d5784b7$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $7210efa23d5784b7$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    /* return function<Props>(): PrivateStyledComponent<Props> { */ return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        }
        var Styled = (0, $kjYAx.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $jbmdS.useContext((0, $kjYAx.T));
            }
            if (typeof props.className === "string") className = (0, $fvFHh.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $lkbnQ.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $7210efa23d5784b7$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $jbmdS.createElement($jbmdS.Fragment, null, /*#__PURE__*/ $jbmdS.createElement($7210efa23d5784b7$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $jbmdS.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                if (targetClassName === undefined && $7210efa23d5784b7$var$isDevelopment) return "NO_COMPONENT_SELECTOR";
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $7i29i.default)({}, options, nextOptions, {
                shouldForwardProp: $7210efa23d5784b7$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("ly5LH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb013f67cc910524$export$2e2bcd8739ae039; });

var $65q85 = parcelRequire("65q85");
// eslint-disable-next-line no-undef
var $fb013f67cc910524$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $fb013f67cc910524$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $65q85.default)(function(prop) {
    return $fb013f67cc910524$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("7nZay", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $560a214dd96d1af9$export$2e2bcd8739ae039; });
parcelRequire("jbmdS");


var $kjYAx = parcelRequire("kjYAx");

var $bMPPJ = parcelRequire("bMPPJ");

var $4TLFw = parcelRequire("4TLFw");
"use client";
let $560a214dd96d1af9$var$cache;
if (typeof document === "object") $560a214dd96d1af9$var$cache = (0, $bMPPJ.default)({
    key: "css",
    prepend: true
});
function $560a214dd96d1af9$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, children: children } = props;
    return injectFirst && $560a214dd96d1af9$var$cache ? /*#__PURE__*/ (0, $4TLFw.jsx)((0, $kjYAx.C), {
        value: $560a214dd96d1af9$var$cache,
        children: children
    }) : children;
}

});

parcelRegister("kxPWc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef4f2d7a04937ceb$export$2e2bcd8739ae039; });
parcelRequire("jbmdS");


var $BPPBq = parcelRequire("BPPBq");

var $4TLFw = parcelRequire("4TLFw");
"use client";
function $ef4f2d7a04937ceb$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $ef4f2d7a04937ceb$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === "function" ? (themeInput)=>styles($ef4f2d7a04937ceb$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $4TLFw.jsx)((0, $BPPBq.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("7swQh", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $56e49fb0003c1d47$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $56e49fb0003c1d47$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");
function $56e49fb0003c1d47$export$53b83ca8eaab0383(item) {
    if (typeof item !== "object" || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $56e49fb0003c1d47$var$deepClone(source) {
    if (!$56e49fb0003c1d47$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $56e49fb0003c1d47$var$deepClone(source[key]);
    });
    return output;
}
function $56e49fb0003c1d47$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $7i29i.default)({}, target) : target;
    if ($56e49fb0003c1d47$export$53b83ca8eaab0383(target) && $56e49fb0003c1d47$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if ($56e49fb0003c1d47$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $56e49fb0003c1d47$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $56e49fb0003c1d47$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $56e49fb0003c1d47$export$53b83ca8eaab0383(source[key]) ? $56e49fb0003c1d47$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("d8tCb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("cbZCf")).default; });

var $cbZCf = parcelRequire("cbZCf");

});

parcelRegister("kejXW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("hu1AH")).default; });

var $hu1AH = parcelRequire("hu1AH");
$parcel$exportWildcard(module.exports, $hu1AH);

});
parcelRegister("hu1AH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getFunctionName", function () { return $cba678f42a9d20da$export$aad197c7121a6651; });
$parcel$export(module.exports, "default", function () { return $cba678f42a9d20da$export$2e2bcd8739ae039; });

var $21S2w = parcelRequire("21S2w");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const $cba678f42a9d20da$var$fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function $cba678f42a9d20da$export$aad197c7121a6651(fn) {
    const match = `${fn}`.match($cba678f42a9d20da$var$fnNameMatchRegex);
    const name = match && match[1];
    return name || "";
}
function $cba678f42a9d20da$var$getFunctionComponentName(Component, fallback = "") {
    return Component.displayName || Component.name || $cba678f42a9d20da$export$aad197c7121a6651(Component) || fallback;
}
function $cba678f42a9d20da$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $cba678f42a9d20da$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== "" ? `${wrapperName}(${functionName})` : wrapperName);
}
function $cba678f42a9d20da$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === "string") return Component;
    if (typeof Component === "function") return $cba678f42a9d20da$var$getFunctionComponentName(Component, "Component");
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === "object") switch(Component.$$typeof){
        case 0, $21S2w.ForwardRef:
            return $cba678f42a9d20da$var$getWrappedName(Component, Component.render, "ForwardRef");
        case 0, $21S2w.Memo:
            return $cba678f42a9d20da$var$getWrappedName(Component, Component.type, "memo");
        default:
            return undefined;
    }
    return undefined;
}

});
parcelRegister("21S2w", function(module, exports) {
"use strict";

module.exports = (parcelRequire("fyUUg"));

});
parcelRegister("fyUUg", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $b5462c6fc13e9a50$export$a7c73072b1a182ae; }, function (v) { return $b5462c6fc13e9a50$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $b5462c6fc13e9a50$export$9f27bc3417b4524d; }, function (v) { return $b5462c6fc13e9a50$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $b5462c6fc13e9a50$export$db77ccec0bb4ccac; }, function (v) { return $b5462c6fc13e9a50$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $b5462c6fc13e9a50$export$8392c0c9d3dcbd35; }, function (v) { return $b5462c6fc13e9a50$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $b5462c6fc13e9a50$export$ffb0004e005737fa; }, function (v) { return $b5462c6fc13e9a50$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $b5462c6fc13e9a50$export$b624eff549462981; }, function (v) { return $b5462c6fc13e9a50$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $b5462c6fc13e9a50$export$7897aa7841a5380c; }, function (v) { return $b5462c6fc13e9a50$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $b5462c6fc13e9a50$export$602eac185826482c; }, function (v) { return $b5462c6fc13e9a50$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $b5462c6fc13e9a50$export$e2c29f18771995cb; }, function (v) { return $b5462c6fc13e9a50$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b5462c6fc13e9a50$export$5f8d39834fd61797; }, function (v) { return $b5462c6fc13e9a50$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $b5462c6fc13e9a50$export$74bf444e3cd11ea5; }, function (v) { return $b5462c6fc13e9a50$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $b5462c6fc13e9a50$export$998bcd577473dd93; }, function (v) { return $b5462c6fc13e9a50$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $b5462c6fc13e9a50$export$92387174baf9b227; }, function (v) { return $b5462c6fc13e9a50$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $b5462c6fc13e9a50$export$ec112efeb987d9c6; }, function (v) { return $b5462c6fc13e9a50$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $b5462c6fc13e9a50$export$b706b080d889d2c9; }, function (v) { return $b5462c6fc13e9a50$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $b5462c6fc13e9a50$export$5be5a87408f70ddc; }, function (v) { return $b5462c6fc13e9a50$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $b5462c6fc13e9a50$export$45a5e7f76e0caa8d; }, function (v) { return $b5462c6fc13e9a50$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $b5462c6fc13e9a50$export$455c2e768291efa6; }, function (v) { return $b5462c6fc13e9a50$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $b5462c6fc13e9a50$export$9522e17588c12572; }, function (v) { return $b5462c6fc13e9a50$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $b5462c6fc13e9a50$export$2110ac352bb060b9; }, function (v) { return $b5462c6fc13e9a50$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $b5462c6fc13e9a50$export$56885ab8b9c456ab; }, function (v) { return $b5462c6fc13e9a50$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $b5462c6fc13e9a50$export$d927fcb6adf8f9de; }, function (v) { return $b5462c6fc13e9a50$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $b5462c6fc13e9a50$export$b82d16f27459e05a; }, function (v) { return $b5462c6fc13e9a50$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $b5462c6fc13e9a50$export$522c17b4f5e123e8; }, function (v) { return $b5462c6fc13e9a50$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $b5462c6fc13e9a50$export$1aabd8a0274ecfd6; }, function (v) { return $b5462c6fc13e9a50$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $b5462c6fc13e9a50$export$3d6c20d97e46b957; }, function (v) { return $b5462c6fc13e9a50$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $b5462c6fc13e9a50$export$9b621391a187a31a; }, function (v) { return $b5462c6fc13e9a50$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $b5462c6fc13e9a50$export$f5bbd400c2f4426f; }, function (v) { return $b5462c6fc13e9a50$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b5462c6fc13e9a50$export$a7c73072b1a182ae;
var $b5462c6fc13e9a50$export$9f27bc3417b4524d;
var $b5462c6fc13e9a50$export$db77ccec0bb4ccac;
var $b5462c6fc13e9a50$export$8392c0c9d3dcbd35;
var $b5462c6fc13e9a50$export$ffb0004e005737fa;
var $b5462c6fc13e9a50$export$b624eff549462981;
var $b5462c6fc13e9a50$export$7897aa7841a5380c;
var $b5462c6fc13e9a50$export$602eac185826482c;
var $b5462c6fc13e9a50$export$e2c29f18771995cb;
var $b5462c6fc13e9a50$export$5f8d39834fd61797;
var $b5462c6fc13e9a50$export$74bf444e3cd11ea5;
var $b5462c6fc13e9a50$export$998bcd577473dd93;
var $b5462c6fc13e9a50$export$92387174baf9b227;
var $b5462c6fc13e9a50$export$ec112efeb987d9c6;
var $b5462c6fc13e9a50$export$b706b080d889d2c9;
var $b5462c6fc13e9a50$export$5be5a87408f70ddc;
var $b5462c6fc13e9a50$export$45a5e7f76e0caa8d;
var $b5462c6fc13e9a50$export$455c2e768291efa6;
var $b5462c6fc13e9a50$export$9522e17588c12572;
var $b5462c6fc13e9a50$export$2110ac352bb060b9;
var $b5462c6fc13e9a50$export$56885ab8b9c456ab;
var $b5462c6fc13e9a50$export$d927fcb6adf8f9de;
var $b5462c6fc13e9a50$export$b82d16f27459e05a;
var $b5462c6fc13e9a50$export$522c17b4f5e123e8;
var $b5462c6fc13e9a50$export$1aabd8a0274ecfd6;
var $b5462c6fc13e9a50$export$3d6c20d97e46b957;
var $b5462c6fc13e9a50$export$9b621391a187a31a;
var $b5462c6fc13e9a50$export$f5bbd400c2f4426f;
"use strict";
var $b5462c6fc13e9a50$var$b = Symbol.for("react.element"), $b5462c6fc13e9a50$var$c = Symbol.for("react.portal"), $b5462c6fc13e9a50$var$d = Symbol.for("react.fragment"), $b5462c6fc13e9a50$var$e = Symbol.for("react.strict_mode"), $b5462c6fc13e9a50$var$f = Symbol.for("react.profiler"), $b5462c6fc13e9a50$var$g = Symbol.for("react.provider"), $b5462c6fc13e9a50$var$h = Symbol.for("react.context"), $b5462c6fc13e9a50$var$k = Symbol.for("react.server_context"), $b5462c6fc13e9a50$var$l = Symbol.for("react.forward_ref"), $b5462c6fc13e9a50$var$m = Symbol.for("react.suspense"), $b5462c6fc13e9a50$var$n = Symbol.for("react.suspense_list"), $b5462c6fc13e9a50$var$p = Symbol.for("react.memo"), $b5462c6fc13e9a50$var$q = Symbol.for("react.lazy"), $b5462c6fc13e9a50$var$t = Symbol.for("react.offscreen"), $b5462c6fc13e9a50$var$u;
$b5462c6fc13e9a50$var$u = Symbol.for("react.module.reference");
function $b5462c6fc13e9a50$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $b5462c6fc13e9a50$var$b:
                switch(a = a.type, a){
                    case $b5462c6fc13e9a50$var$d:
                    case $b5462c6fc13e9a50$var$f:
                    case $b5462c6fc13e9a50$var$e:
                    case $b5462c6fc13e9a50$var$m:
                    case $b5462c6fc13e9a50$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $b5462c6fc13e9a50$var$k:
                            case $b5462c6fc13e9a50$var$h:
                            case $b5462c6fc13e9a50$var$l:
                            case $b5462c6fc13e9a50$var$q:
                            case $b5462c6fc13e9a50$var$p:
                            case $b5462c6fc13e9a50$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $b5462c6fc13e9a50$var$c:
                return r;
        }
    }
}
$b5462c6fc13e9a50$export$a7c73072b1a182ae = $b5462c6fc13e9a50$var$h;
$b5462c6fc13e9a50$export$9f27bc3417b4524d = $b5462c6fc13e9a50$var$g;
$b5462c6fc13e9a50$export$db77ccec0bb4ccac = $b5462c6fc13e9a50$var$b;
$b5462c6fc13e9a50$export$8392c0c9d3dcbd35 = $b5462c6fc13e9a50$var$l;
$b5462c6fc13e9a50$export$ffb0004e005737fa = $b5462c6fc13e9a50$var$d;
$b5462c6fc13e9a50$export$b624eff549462981 = $b5462c6fc13e9a50$var$q;
$b5462c6fc13e9a50$export$7897aa7841a5380c = $b5462c6fc13e9a50$var$p;
$b5462c6fc13e9a50$export$602eac185826482c = $b5462c6fc13e9a50$var$c;
$b5462c6fc13e9a50$export$e2c29f18771995cb = $b5462c6fc13e9a50$var$f;
$b5462c6fc13e9a50$export$5f8d39834fd61797 = $b5462c6fc13e9a50$var$e;
$b5462c6fc13e9a50$export$74bf444e3cd11ea5 = $b5462c6fc13e9a50$var$m;
$b5462c6fc13e9a50$export$998bcd577473dd93 = $b5462c6fc13e9a50$var$n;
$b5462c6fc13e9a50$export$92387174baf9b227 = function() {
    return !1;
};
$b5462c6fc13e9a50$export$ec112efeb987d9c6 = function() {
    return !1;
};
$b5462c6fc13e9a50$export$b706b080d889d2c9 = function(a) {
    return $b5462c6fc13e9a50$var$v(a) === $b5462c6fc13e9a50$var$h;
};
$b5462c6fc13e9a50$export$5be5a87408f70ddc = function(a) {
    return $b5462c6fc13e9a50$var$v(a) === $b5462c6fc13e9a50$var$g;
};
$b5462c6fc13e9a50$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b5462c6fc13e9a50$var$b;
};
$b5462c6fc13e9a50$export$455c2e768291efa6 = function(a) {
    return $b5462c6fc13e9a50$var$v(a) === $b5462c6fc13e9a50$var$l;
};
$b5462c6fc13e9a50$export$9522e17588c12572 = function(a) {
    return $b5462c6fc13e9a50$var$v(a) === $b5462c6fc13e9a50$var$d;
};
$b5462c6fc13e9a50$export$2110ac352bb060b9 = function(a) {
    return $b5462c6fc13e9a50$var$v(a) === $b5462c6fc13e9a50$var$q;
};
$b5462c6fc13e9a50$export$56885ab8b9c456ab = function(a) {
    return $b5462c6fc13e9a50$var$v(a) === $b5462c6fc13e9a50$var$p;
};
$b5462c6fc13e9a50$export$d927fcb6adf8f9de = function(a) {
    return $b5462c6fc13e9a50$var$v(a) === $b5462c6fc13e9a50$var$c;
};
$b5462c6fc13e9a50$export$b82d16f27459e05a = function(a) {
    return $b5462c6fc13e9a50$var$v(a) === $b5462c6fc13e9a50$var$f;
};
$b5462c6fc13e9a50$export$522c17b4f5e123e8 = function(a) {
    return $b5462c6fc13e9a50$var$v(a) === $b5462c6fc13e9a50$var$e;
};
$b5462c6fc13e9a50$export$1aabd8a0274ecfd6 = function(a) {
    return $b5462c6fc13e9a50$var$v(a) === $b5462c6fc13e9a50$var$m;
};
$b5462c6fc13e9a50$export$3d6c20d97e46b957 = function(a) {
    return $b5462c6fc13e9a50$var$v(a) === $b5462c6fc13e9a50$var$n;
};
$b5462c6fc13e9a50$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $b5462c6fc13e9a50$var$d || a === $b5462c6fc13e9a50$var$f || a === $b5462c6fc13e9a50$var$e || a === $b5462c6fc13e9a50$var$m || a === $b5462c6fc13e9a50$var$n || a === $b5462c6fc13e9a50$var$t || "object" === typeof a && null !== a && (a.$$typeof === $b5462c6fc13e9a50$var$q || a.$$typeof === $b5462c6fc13e9a50$var$p || a.$$typeof === $b5462c6fc13e9a50$var$g || a.$$typeof === $b5462c6fc13e9a50$var$h || a.$$typeof === $b5462c6fc13e9a50$var$l || a.$$typeof === $b5462c6fc13e9a50$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$b5462c6fc13e9a50$export$f5bbd400c2f4426f = $b5462c6fc13e9a50$var$v;

});




parcelRegister("jR46X", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("35ufA")).default; });
$parcel$export(module.exports, "private_createBreakpoints", function () { return (parcelRequire("kXsiE")).default; });
$parcel$export(module.exports, "unstable_applyStyles", function () { return (parcelRequire("lLC8O")).default; });

var $35ufA = parcelRequire("35ufA");

var $kXsiE = parcelRequire("kXsiE");

var $lLC8O = parcelRequire("lLC8O");

});
parcelRegister("35ufA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23f94dcf729bf3f6$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $etz1B = parcelRequire("etz1B");

var $7swQh = parcelRequire("7swQh");

var $kXsiE = parcelRequire("kXsiE");

var $aQpRL = parcelRequire("aQpRL");

var $eAQzZ = parcelRequire("eAQzZ");

var $fMzxV = parcelRequire("fMzxV");

var $iB5OU = parcelRequire("iB5OU");

var $lLC8O = parcelRequire("lLC8O");
const $23f94dcf729bf3f6$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $23f94dcf729bf3f6$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $etz1B.default)(options, $23f94dcf729bf3f6$var$_excluded);
    const breakpoints = (0, $kXsiE.default)(breakpointsInput);
    const spacing = (0, $eAQzZ.default)(spacingInput);
    let muiTheme = (0, $7swQh.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: (0, $7i29i.default)({
            mode: "light"
        }, paletteInput),
        spacing: spacing,
        shape: (0, $7i29i.default)({}, (0, $aQpRL.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $lLC8O.default);
    muiTheme = args.reduce((acc, argument)=>(0, $7swQh.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $7i29i.default)({}, (0, $iB5OU.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $fMzxV.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $23f94dcf729bf3f6$export$2e2bcd8739ae039 = $23f94dcf729bf3f6$var$createTheme;

});
parcelRegister("kXsiE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f41f45195ce77fcb$export$2e2bcd8739ae039; });

var $etz1B = parcelRequire("etz1B");

var $7i29i = parcelRequire("7i29i");
const $f41f45195ce77fcb$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $f41f45195ce77fcb$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $f41f45195ce77fcb$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $7i29i.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $f41f45195ce77fcb$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = "px", step: step = 5 } = breakpoints, other = (0, $etz1B.default)(breakpoints, $f41f45195ce77fcb$var$_excluded);
    const sortedValues = $f41f45195ce77fcb$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return (0, $7i29i.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("aQpRL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e52d332a23a184e$export$2e2bcd8739ae039; });
const $7e52d332a23a184e$var$shape = {
    borderRadius: 4
};
var $7e52d332a23a184e$export$2e2bcd8739ae039 = $7e52d332a23a184e$var$shape;

});

parcelRegister("eAQzZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9fd36ae9e1b51f6$export$2e2bcd8739ae039; });

var $1zPDX = parcelRequire("1zPDX");
function $a9fd36ae9e1b51f6$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $1zPDX.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("1zPDX", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $12611ea84924dea3$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $12611ea84924dea3$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $12611ea84924dea3$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $12611ea84924dea3$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $12611ea84924dea3$export$6f98e8eaf0be1996; });


var $cJZKx = parcelRequire("cJZKx");

var $dvMaq = parcelRequire("dvMaq");

var $fLg6J = parcelRequire("fLg6J");

var $7xUzP = parcelRequire("7xUzP");
const $12611ea84924dea3$var$properties = {
    m: "margin",
    p: "padding"
};
const $12611ea84924dea3$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $12611ea84924dea3$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $12611ea84924dea3$var$getCssProperties = (0, $7xUzP.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($12611ea84924dea3$var$aliases[prop]) prop = $12611ea84924dea3$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $12611ea84924dea3$var$properties[a];
    const direction = $12611ea84924dea3$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $12611ea84924dea3$export$aab52a0dde05ad8a = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $12611ea84924dea3$export$f8397d44f03ab6ad = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $12611ea84924dea3$var$spacingKeys = [
    ...$12611ea84924dea3$export$aab52a0dde05ad8a,
    ...$12611ea84924dea3$export$f8397d44f03ab6ad
];
function $12611ea84924dea3$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $dvMaq.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === "number") return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function $12611ea84924dea3$export$1def6f833384e3d1(theme) {
    return $12611ea84924dea3$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $12611ea84924dea3$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return `-${transformed}`;
}
function $12611ea84924dea3$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $12611ea84924dea3$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $12611ea84924dea3$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $12611ea84924dea3$var$getCssProperties(prop);
    const styleFromPropValue = $12611ea84924dea3$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $cJZKx.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $12611ea84924dea3$var$style(props, keys) {
    const transformer = $12611ea84924dea3$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$12611ea84924dea3$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $fLg6J.default), {});
}
function $12611ea84924dea3$export$7ede87f9b603dd3c(props) {
    return $12611ea84924dea3$var$style(props, $12611ea84924dea3$export$aab52a0dde05ad8a);
}
$12611ea84924dea3$export$7ede87f9b603dd3c.propTypes = {};
$12611ea84924dea3$export$7ede87f9b603dd3c.filterProps = $12611ea84924dea3$export$aab52a0dde05ad8a;
function $12611ea84924dea3$export$6f98e8eaf0be1996(props) {
    return $12611ea84924dea3$var$style(props, $12611ea84924dea3$export$f8397d44f03ab6ad);
}
$12611ea84924dea3$export$6f98e8eaf0be1996.propTypes = {};
$12611ea84924dea3$export$6f98e8eaf0be1996.filterProps = $12611ea84924dea3$export$f8397d44f03ab6ad;
function $12611ea84924dea3$var$spacing(props) {
    return $12611ea84924dea3$var$style(props, $12611ea84924dea3$var$spacingKeys);
}
$12611ea84924dea3$var$spacing.propTypes = {};
$12611ea84924dea3$var$spacing.filterProps = $12611ea84924dea3$var$spacingKeys;
var $12611ea84924dea3$export$2e2bcd8739ae039 = $12611ea84924dea3$var$spacing;

});
parcelRegister("cJZKx", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $94699633dc6e0ab2$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $94699633dc6e0ab2$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $94699633dc6e0ab2$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $94699633dc6e0ab2$export$8922c90b6e020726; });

var $7i29i = parcelRequire("7i29i");


var $7swQh = parcelRequire("7swQh");

var $fLg6J = parcelRequire("fLg6J");
const $94699633dc6e0ab2$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $94699633dc6e0ab2$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$94699633dc6e0ab2$export$68c286be0e7e55b7[key]}px)`
};
function $94699633dc6e0ab2$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $94699633dc6e0ab2$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $94699633dc6e0ab2$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $94699633dc6e0ab2$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $94699633dc6e0ab2$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $94699633dc6e0ab2$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $7i29i.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $fLg6J.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $94699633dc6e0ab2$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $94699633dc6e0ab2$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $94699633dc6e0ab2$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $94699633dc6e0ab2$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $7swQh.default)(prev, next), {});
    return $94699633dc6e0ab2$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $94699633dc6e0ab2$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $94699633dc6e0ab2$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $94699633dc6e0ab2$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $94699633dc6e0ab2$export$2e2bcd8739ae039 = $94699633dc6e0ab2$var$breakpoints;

});
parcelRegister("fLg6J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b797bd74774a309d$export$2e2bcd8739ae039; });

var $7swQh = parcelRequire("7swQh");
function $b797bd74774a309d$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $7swQh.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $b797bd74774a309d$export$2e2bcd8739ae039 = $b797bd74774a309d$var$merge;

});


parcelRegister("dvMaq", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $9d63889f2a41e903$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $9d63889f2a41e903$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $9d63889f2a41e903$export$2e2bcd8739ae039; });

var $cbZCf = parcelRequire("cbZCf");


var $cJZKx = parcelRequire("cJZKx");
function $9d63889f2a41e903$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $9d63889f2a41e903$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $9d63889f2a41e903$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $9d63889f2a41e903$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $9d63889f2a41e903$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $9d63889f2a41e903$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $9d63889f2a41e903$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $cbZCf.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $cJZKx.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $9d63889f2a41e903$export$2e2bcd8739ae039 = $9d63889f2a41e903$var$style;

});

parcelRegister("7xUzP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57e7807999f851b2$export$2e2bcd8739ae039; });
function $57e7807999f851b2$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("fMzxV", function(module, exports) {

$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return $b7d6e96d79ade745$export$7d53d8bf2911e013; });
$parcel$export(module.exports, "default", function () { return $b7d6e96d79ade745$export$2e2bcd8739ae039; });

var $cbZCf = parcelRequire("cbZCf");

var $fLg6J = parcelRequire("fLg6J");

var $dvMaq = parcelRequire("dvMaq");

var $cJZKx = parcelRequire("cJZKx");

var $iB5OU = parcelRequire("iB5OU");
function $b7d6e96d79ade745$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $b7d6e96d79ade745$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function $b7d6e96d79ade745$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === "typography" && val === "inherit") return {
            [prop]: val
        };
        const themeMapping = (0, $dvMaq.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $dvMaq.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = (0, $dvMaq.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $cbZCf.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $cJZKx.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $iB5OU.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $cJZKx.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $b7d6e96d79ade745$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (config[styleKey]) css = (0, $fLg6J.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $cJZKx.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($b7d6e96d79ade745$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $fLg6J.default)(css, breakpointsValues);
                        }
                    } else css = (0, $fLg6J.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $cJZKx.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $b7d6e96d79ade745$var$styleFunctionSx = $b7d6e96d79ade745$export$7d53d8bf2911e013();
$b7d6e96d79ade745$var$styleFunctionSx.filterProps = [
    "sx"
];
var $b7d6e96d79ade745$export$2e2bcd8739ae039 = $b7d6e96d79ade745$var$styleFunctionSx;

});
parcelRegister("iB5OU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8a0326f35f06581$export$2e2bcd8739ae039; });

var $1zPDX = parcelRequire("1zPDX");

var $26jhl = parcelRequire("26jhl");

var $3mcTl = parcelRequire("3mcTl");

var $1eV8t = parcelRequire("1eV8t");

var $7ndTa = parcelRequire("7ndTa");
const $d8a0326f35f06581$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: "borders",
        transform: (0, $26jhl.borderTransform)
    },
    borderTop: {
        themeKey: "borders",
        transform: (0, $26jhl.borderTransform)
    },
    borderRight: {
        themeKey: "borders",
        transform: (0, $26jhl.borderTransform)
    },
    borderBottom: {
        themeKey: "borders",
        transform: (0, $26jhl.borderTransform)
    },
    borderLeft: {
        themeKey: "borders",
        transform: (0, $26jhl.borderTransform)
    },
    borderColor: {
        themeKey: "palette"
    },
    borderTopColor: {
        themeKey: "palette"
    },
    borderRightColor: {
        themeKey: "palette"
    },
    borderBottomColor: {
        themeKey: "palette"
    },
    borderLeftColor: {
        themeKey: "palette"
    },
    outline: {
        themeKey: "borders",
        transform: (0, $26jhl.borderTransform)
    },
    outlineColor: {
        themeKey: "palette"
    },
    borderRadius: {
        themeKey: "shape.borderRadius",
        style: (0, $26jhl.borderRadius)
    },
    // palette
    color: {
        themeKey: "palette",
        transform: (0, $1eV8t.paletteTransform)
    },
    bgcolor: {
        themeKey: "palette",
        cssProperty: "backgroundColor",
        transform: (0, $1eV8t.paletteTransform)
    },
    backgroundColor: {
        themeKey: "palette",
        transform: (0, $1eV8t.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $1zPDX.padding)
    },
    pt: {
        style: (0, $1zPDX.padding)
    },
    pr: {
        style: (0, $1zPDX.padding)
    },
    pb: {
        style: (0, $1zPDX.padding)
    },
    pl: {
        style: (0, $1zPDX.padding)
    },
    px: {
        style: (0, $1zPDX.padding)
    },
    py: {
        style: (0, $1zPDX.padding)
    },
    padding: {
        style: (0, $1zPDX.padding)
    },
    paddingTop: {
        style: (0, $1zPDX.padding)
    },
    paddingRight: {
        style: (0, $1zPDX.padding)
    },
    paddingBottom: {
        style: (0, $1zPDX.padding)
    },
    paddingLeft: {
        style: (0, $1zPDX.padding)
    },
    paddingX: {
        style: (0, $1zPDX.padding)
    },
    paddingY: {
        style: (0, $1zPDX.padding)
    },
    paddingInline: {
        style: (0, $1zPDX.padding)
    },
    paddingInlineStart: {
        style: (0, $1zPDX.padding)
    },
    paddingInlineEnd: {
        style: (0, $1zPDX.padding)
    },
    paddingBlock: {
        style: (0, $1zPDX.padding)
    },
    paddingBlockStart: {
        style: (0, $1zPDX.padding)
    },
    paddingBlockEnd: {
        style: (0, $1zPDX.padding)
    },
    m: {
        style: (0, $1zPDX.margin)
    },
    mt: {
        style: (0, $1zPDX.margin)
    },
    mr: {
        style: (0, $1zPDX.margin)
    },
    mb: {
        style: (0, $1zPDX.margin)
    },
    ml: {
        style: (0, $1zPDX.margin)
    },
    mx: {
        style: (0, $1zPDX.margin)
    },
    my: {
        style: (0, $1zPDX.margin)
    },
    margin: {
        style: (0, $1zPDX.margin)
    },
    marginTop: {
        style: (0, $1zPDX.margin)
    },
    marginRight: {
        style: (0, $1zPDX.margin)
    },
    marginBottom: {
        style: (0, $1zPDX.margin)
    },
    marginLeft: {
        style: (0, $1zPDX.margin)
    },
    marginX: {
        style: (0, $1zPDX.margin)
    },
    marginY: {
        style: (0, $1zPDX.margin)
    },
    marginInline: {
        style: (0, $1zPDX.margin)
    },
    marginInlineStart: {
        style: (0, $1zPDX.margin)
    },
    marginInlineEnd: {
        style: (0, $1zPDX.margin)
    },
    marginBlock: {
        style: (0, $1zPDX.margin)
    },
    marginBlockStart: {
        style: (0, $1zPDX.margin)
    },
    marginBlockEnd: {
        style: (0, $1zPDX.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                "@media print": {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $3mcTl.gap)
    },
    rowGap: {
        style: (0, $3mcTl.rowGap)
    },
    columnGap: {
        style: (0, $3mcTl.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: "zIndex"
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: "shadows"
    },
    // sizing
    width: {
        transform: (0, $7ndTa.sizingTransform)
    },
    maxWidth: {
        style: (0, $7ndTa.maxWidth)
    },
    minWidth: {
        transform: (0, $7ndTa.sizingTransform)
    },
    height: {
        transform: (0, $7ndTa.sizingTransform)
    },
    maxHeight: {
        transform: (0, $7ndTa.sizingTransform)
    },
    minHeight: {
        transform: (0, $7ndTa.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: "typography"
    },
    fontSize: {
        themeKey: "typography"
    },
    fontStyle: {
        themeKey: "typography"
    },
    fontWeight: {
        themeKey: "typography"
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: "typography"
    }
};
var $d8a0326f35f06581$export$2e2bcd8739ae039 = $d8a0326f35f06581$var$defaultSxConfig;

});
parcelRegister("26jhl", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $187b18a7e2569463$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $187b18a7e2569463$export$7a57f79000377ca2; });


var $dvMaq = parcelRequire("dvMaq");

var $59d5N = parcelRequire("59d5N");

var $1zPDX = parcelRequire("1zPDX");

var $cJZKx = parcelRequire("cJZKx");
function $187b18a7e2569463$export$34e2febe53ae29cc(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
function $187b18a7e2569463$var$createBorderStyle(prop, transform) {
    return (0, $dvMaq.default)({
        prop: prop,
        themeKey: "borders",
        transform: transform
    });
}
const $187b18a7e2569463$export$1edee58a52776cd9 = $187b18a7e2569463$var$createBorderStyle("border", $187b18a7e2569463$export$34e2febe53ae29cc);
const $187b18a7e2569463$export$f9a7b6bd24892946 = $187b18a7e2569463$var$createBorderStyle("borderTop", $187b18a7e2569463$export$34e2febe53ae29cc);
const $187b18a7e2569463$export$5abca33e6be905d2 = $187b18a7e2569463$var$createBorderStyle("borderRight", $187b18a7e2569463$export$34e2febe53ae29cc);
const $187b18a7e2569463$export$e2ce9f12a980a822 = $187b18a7e2569463$var$createBorderStyle("borderBottom", $187b18a7e2569463$export$34e2febe53ae29cc);
const $187b18a7e2569463$export$47658cca1a909427 = $187b18a7e2569463$var$createBorderStyle("borderLeft", $187b18a7e2569463$export$34e2febe53ae29cc);
const $187b18a7e2569463$export$e7fb0694ba2404fc = $187b18a7e2569463$var$createBorderStyle("borderColor");
const $187b18a7e2569463$export$126a92c968acdb85 = $187b18a7e2569463$var$createBorderStyle("borderTopColor");
const $187b18a7e2569463$export$85cc51cb8fbb8c0e = $187b18a7e2569463$var$createBorderStyle("borderRightColor");
const $187b18a7e2569463$export$340b0327727f6d1a = $187b18a7e2569463$var$createBorderStyle("borderBottomColor");
const $187b18a7e2569463$export$60beef91a985b4bf = $187b18a7e2569463$var$createBorderStyle("borderLeftColor");
const $187b18a7e2569463$export$f9258c55612cbed7 = $187b18a7e2569463$var$createBorderStyle("outline", $187b18a7e2569463$export$34e2febe53ae29cc);
const $187b18a7e2569463$export$621fe586efeb64b9 = $187b18a7e2569463$var$createBorderStyle("outlineColor");
const $187b18a7e2569463$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $1zPDX.createUnaryUnit)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $1zPDX.getValue)(transformer, propValue)
            });
        return (0, $cJZKx.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$187b18a7e2569463$export$7a57f79000377ca2.propTypes = {};
$187b18a7e2569463$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $187b18a7e2569463$var$borders = (0, $59d5N.default)($187b18a7e2569463$export$1edee58a52776cd9, $187b18a7e2569463$export$f9a7b6bd24892946, $187b18a7e2569463$export$5abca33e6be905d2, $187b18a7e2569463$export$e2ce9f12a980a822, $187b18a7e2569463$export$47658cca1a909427, $187b18a7e2569463$export$e7fb0694ba2404fc, $187b18a7e2569463$export$126a92c968acdb85, $187b18a7e2569463$export$85cc51cb8fbb8c0e, $187b18a7e2569463$export$340b0327727f6d1a, $187b18a7e2569463$export$60beef91a985b4bf, $187b18a7e2569463$export$7a57f79000377ca2, $187b18a7e2569463$export$f9258c55612cbed7, $187b18a7e2569463$export$621fe586efeb64b9);
var $187b18a7e2569463$export$2e2bcd8739ae039 = $187b18a7e2569463$var$borders;

});
parcelRegister("59d5N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3bf7f2e76c9b3fb0$export$2e2bcd8739ae039; });

var $fLg6J = parcelRequire("fLg6J");
function $3bf7f2e76c9b3fb0$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $fLg6J.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $3bf7f2e76c9b3fb0$export$2e2bcd8739ae039 = $3bf7f2e76c9b3fb0$var$compose;

});


parcelRegister("3mcTl", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $271d6d2d48fb6c01$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $271d6d2d48fb6c01$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $271d6d2d48fb6c01$export$8a833ffa5f5dbeda; });

var $dvMaq = parcelRequire("dvMaq");

var $59d5N = parcelRequire("59d5N");

var $1zPDX = parcelRequire("1zPDX");

var $cJZKx = parcelRequire("cJZKx");

const $271d6d2d48fb6c01$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $1zPDX.createUnaryUnit)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $1zPDX.getValue)(transformer, propValue)
            });
        return (0, $cJZKx.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$271d6d2d48fb6c01$export$5df9adcb0db95e1e.propTypes = {};
$271d6d2d48fb6c01$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $271d6d2d48fb6c01$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $1zPDX.createUnaryUnit)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $1zPDX.getValue)(transformer, propValue)
            });
        return (0, $cJZKx.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$271d6d2d48fb6c01$export$ec60d70ff941a580.propTypes = {};
$271d6d2d48fb6c01$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $271d6d2d48fb6c01$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $1zPDX.createUnaryUnit)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $1zPDX.getValue)(transformer, propValue)
            });
        return (0, $cJZKx.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$271d6d2d48fb6c01$export$8a833ffa5f5dbeda.propTypes = {};
$271d6d2d48fb6c01$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $271d6d2d48fb6c01$export$baf44164ca3a34e8 = (0, $dvMaq.default)({
    prop: "gridColumn"
});
const $271d6d2d48fb6c01$export$8f7213a1cd01e832 = (0, $dvMaq.default)({
    prop: "gridRow"
});
const $271d6d2d48fb6c01$export$b0e0abbc49ba668 = (0, $dvMaq.default)({
    prop: "gridAutoFlow"
});
const $271d6d2d48fb6c01$export$bcd8b929d4b4142 = (0, $dvMaq.default)({
    prop: "gridAutoColumns"
});
const $271d6d2d48fb6c01$export$e5039a674e14c828 = (0, $dvMaq.default)({
    prop: "gridAutoRows"
});
const $271d6d2d48fb6c01$export$42bd9088661ffb03 = (0, $dvMaq.default)({
    prop: "gridTemplateColumns"
});
const $271d6d2d48fb6c01$export$920682ae05b999bc = (0, $dvMaq.default)({
    prop: "gridTemplateRows"
});
const $271d6d2d48fb6c01$export$1b88fbdd482fd33a = (0, $dvMaq.default)({
    prop: "gridTemplateAreas"
});
const $271d6d2d48fb6c01$export$bdb486e40d52d26f = (0, $dvMaq.default)({
    prop: "gridArea"
});
const $271d6d2d48fb6c01$var$grid = (0, $59d5N.default)($271d6d2d48fb6c01$export$5df9adcb0db95e1e, $271d6d2d48fb6c01$export$ec60d70ff941a580, $271d6d2d48fb6c01$export$8a833ffa5f5dbeda, $271d6d2d48fb6c01$export$baf44164ca3a34e8, $271d6d2d48fb6c01$export$8f7213a1cd01e832, $271d6d2d48fb6c01$export$b0e0abbc49ba668, $271d6d2d48fb6c01$export$bcd8b929d4b4142, $271d6d2d48fb6c01$export$e5039a674e14c828, $271d6d2d48fb6c01$export$42bd9088661ffb03, $271d6d2d48fb6c01$export$920682ae05b999bc, $271d6d2d48fb6c01$export$1b88fbdd482fd33a, $271d6d2d48fb6c01$export$bdb486e40d52d26f);
var $271d6d2d48fb6c01$export$2e2bcd8739ae039 = $271d6d2d48fb6c01$var$grid;

});

parcelRegister("1eV8t", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $0e736b34e2908bfc$export$dbaffd4420ea0ac6; });

var $dvMaq = parcelRequire("dvMaq");

var $59d5N = parcelRequire("59d5N");
function $0e736b34e2908bfc$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
const $0e736b34e2908bfc$export$35e9368ef982300f = (0, $dvMaq.default)({
    prop: "color",
    themeKey: "palette",
    transform: $0e736b34e2908bfc$export$dbaffd4420ea0ac6
});
const $0e736b34e2908bfc$export$2506f56c10355b33 = (0, $dvMaq.default)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: $0e736b34e2908bfc$export$dbaffd4420ea0ac6
});
const $0e736b34e2908bfc$export$8c5a050822fd698c = (0, $dvMaq.default)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: $0e736b34e2908bfc$export$dbaffd4420ea0ac6
});
const $0e736b34e2908bfc$var$palette = (0, $59d5N.default)($0e736b34e2908bfc$export$35e9368ef982300f, $0e736b34e2908bfc$export$2506f56c10355b33, $0e736b34e2908bfc$export$8c5a050822fd698c);
var $0e736b34e2908bfc$export$2e2bcd8739ae039 = $0e736b34e2908bfc$var$palette;

});

parcelRegister("7ndTa", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $55e57464fa7b96f5$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $55e57464fa7b96f5$export$488fda99655ff65a; });

var $dvMaq = parcelRequire("dvMaq");

var $59d5N = parcelRequire("59d5N");

var $cJZKx = parcelRequire("cJZKx");
function $55e57464fa7b96f5$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $55e57464fa7b96f5$export$7e3df82ee760448c = (0, $dvMaq.default)({
    prop: "width",
    transform: $55e57464fa7b96f5$export$8afece71750ec241
});
const $55e57464fa7b96f5$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $cJZKx.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $55e57464fa7b96f5$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== "px") return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $cJZKx.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$55e57464fa7b96f5$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $55e57464fa7b96f5$export$ee148fbbe8357dd2 = (0, $dvMaq.default)({
    prop: "minWidth",
    transform: $55e57464fa7b96f5$export$8afece71750ec241
});
const $55e57464fa7b96f5$export$ac607276a8fe9f0a = (0, $dvMaq.default)({
    prop: "height",
    transform: $55e57464fa7b96f5$export$8afece71750ec241
});
const $55e57464fa7b96f5$export$dc0d8bd0b94f8570 = (0, $dvMaq.default)({
    prop: "maxHeight",
    transform: $55e57464fa7b96f5$export$8afece71750ec241
});
const $55e57464fa7b96f5$export$a43cf604e12f3b17 = (0, $dvMaq.default)({
    prop: "minHeight",
    transform: $55e57464fa7b96f5$export$8afece71750ec241
});
const $55e57464fa7b96f5$export$ffed9f14fb65e276 = (0, $dvMaq.default)({
    prop: "size",
    cssProperty: "width",
    transform: $55e57464fa7b96f5$export$8afece71750ec241
});
const $55e57464fa7b96f5$export$905076ed6620e671 = (0, $dvMaq.default)({
    prop: "size",
    cssProperty: "height",
    transform: $55e57464fa7b96f5$export$8afece71750ec241
});
const $55e57464fa7b96f5$export$6ccc93f785106a58 = (0, $dvMaq.default)({
    prop: "boxSizing"
});
const $55e57464fa7b96f5$var$sizing = (0, $59d5N.default)($55e57464fa7b96f5$export$7e3df82ee760448c, $55e57464fa7b96f5$export$488fda99655ff65a, $55e57464fa7b96f5$export$ee148fbbe8357dd2, $55e57464fa7b96f5$export$ac607276a8fe9f0a, $55e57464fa7b96f5$export$dc0d8bd0b94f8570, $55e57464fa7b96f5$export$a43cf604e12f3b17, $55e57464fa7b96f5$export$6ccc93f785106a58);
var $55e57464fa7b96f5$export$2e2bcd8739ae039 = $55e57464fa7b96f5$var$sizing;

});



parcelRegister("lLC8O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd8b92d0e5a85f5b$export$2e2bcd8739ae039; });
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $fd8b92d0e5a85f5b$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === "function") {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, "*:where($1)");
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});



parcelRegister("97hmO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("fMzxV")).default; });
$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return (parcelRequire("fMzxV")).unstable_createStyleFunctionSx; });
$parcel$export(module.exports, "extendSxProp", function () { return (parcelRequire("8ZKki")).default; });
$parcel$export(module.exports, "unstable_defaultSxConfig", function () { return (parcelRequire("iB5OU")).default; });

var $fMzxV = parcelRequire("fMzxV");

var $8ZKki = parcelRequire("8ZKki");

var $iB5OU = parcelRequire("iB5OU");

});
parcelRegister("8ZKki", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68c7f4ae0a109a9e$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $etz1B = parcelRequire("etz1B");

var $7swQh = parcelRequire("7swQh");

var $iB5OU = parcelRequire("iB5OU");
const $68c7f4ae0a109a9e$var$_excluded = [
    "sx"
];
const $68c7f4ae0a109a9e$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $iB5OU.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $68c7f4ae0a109a9e$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $etz1B.default)(props, $68c7f4ae0a109a9e$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $68c7f4ae0a109a9e$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === "function") finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $7swQh.isPlainObject)(result)) return systemProps;
        return (0, $7i29i.default)({}, systemProps, result);
    };
    else finalSx = (0, $7i29i.default)({}, systemProps, inSx);
    return (0, $7i29i.default)({}, otherProps, {
        sx: finalSx
    });
}

});



parcelRegister("gW6tp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5471591839266f8$export$2e2bcd8739ae039; });

var $9k3bS = parcelRequire("9k3bS");
"use client";
const $c5471591839266f8$var$defaultTheme = (0, $9k3bS.default)();
var $c5471591839266f8$export$2e2bcd8739ae039 = $c5471591839266f8$var$defaultTheme;

});
parcelRegister("9k3bS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c9874e2717e1d3e$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $etz1B = parcelRequire("etz1B");

var $7PAqt = parcelRequire("7PAqt");

var $7swQh = parcelRequire("7swQh");

var $fMzxV = parcelRequire("fMzxV");
var $iB5OU = parcelRequire("iB5OU");

var $35ufA = parcelRequire("35ufA");


var $5Bmvg = parcelRequire("5Bmvg");

var $3CQ9s = parcelRequire("3CQ9s");

var $ieZPY = parcelRequire("ieZPY");

var $lCAfK = parcelRequire("lCAfK");

var $kk0nG = parcelRequire("kk0nG");

var $5XLuI = parcelRequire("5XLuI");
const $6c9874e2717e1d3e$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $6c9874e2717e1d3e$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $etz1B.default)(options, $6c9874e2717e1d3e$var$_excluded);
    if (options.vars) throw new Error((0, $7PAqt.default)(18));
    const palette = (0, $3CQ9s.default)(paletteInput);
    const systemTheme = (0, $35ufA.default)(options);
    let muiTheme = (0, $7swQh.default)(systemTheme, {
        mixins: (0, $5Bmvg.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $lCAfK.default).slice(),
        typography: (0, $ieZPY.default)(palette, typographyInput),
        transitions: (0, $kk0nG.default)(transitionsInput),
        zIndex: (0, $7i29i.default)({}, (0, $5XLuI.default))
    });
    muiTheme = (0, $7swQh.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $7swQh.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $7i29i.default)({}, (0, $iB5OU.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $fMzxV.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $6c9874e2717e1d3e$var$warnedOnce = false;
function $6c9874e2717e1d3e$export$c469355549431d9b(...args) {
    return $6c9874e2717e1d3e$var$createTheme(...args);
}
var $6c9874e2717e1d3e$export$2e2bcd8739ae039 = $6c9874e2717e1d3e$var$createTheme;

});
parcelRegister("5Bmvg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4141dd22439f1126$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");
function $4141dd22439f1126$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $7i29i.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up("xs")]: {
                "@media (orientation: landscape)": {
                    minHeight: 48
                }
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("3CQ9s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a3d5fe8d46b7d9e$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $etz1B = parcelRequire("etz1B");

var $7PAqt = parcelRequire("7PAqt");

var $7swQh = parcelRequire("7swQh");

var $c3Y9Y = parcelRequire("c3Y9Y");

var $16BNv = parcelRequire("16BNv");

var $8yMiQ = parcelRequire("8yMiQ");

var $1U20U = parcelRequire("1U20U");

var $2S2Ky = parcelRequire("2S2Ky");

var $in4fF = parcelRequire("in4fF");

var $82K6d = parcelRequire("82K6d");

var $8wzD0 = parcelRequire("8wzD0");

var $1EOCV = parcelRequire("1EOCV");
const $2a3d5fe8d46b7d9e$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $2a3d5fe8d46b7d9e$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.6)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $16BNv.default).white,
        default: (0, $16BNv.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $2a3d5fe8d46b7d9e$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $16BNv.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: "#121212",
        default: "#121212"
    },
    action: {
        active: (0, $16BNv.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $2a3d5fe8d46b7d9e$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $c3Y9Y.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $c3Y9Y.darken)(intent.main, tonalOffsetDark);
    }
}
function $2a3d5fe8d46b7d9e$var$getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $82K6d.default)[200],
        light: (0, $82K6d.default)[50],
        dark: (0, $82K6d.default)[400]
    };
    return {
        main: (0, $82K6d.default)[700],
        light: (0, $82K6d.default)[400],
        dark: (0, $82K6d.default)[800]
    };
}
function $2a3d5fe8d46b7d9e$var$getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $1U20U.default)[200],
        light: (0, $1U20U.default)[50],
        dark: (0, $1U20U.default)[400]
    };
    return {
        main: (0, $1U20U.default)[500],
        light: (0, $1U20U.default)[300],
        dark: (0, $1U20U.default)[700]
    };
}
function $2a3d5fe8d46b7d9e$var$getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, $2S2Ky.default)[500],
        light: (0, $2S2Ky.default)[300],
        dark: (0, $2S2Ky.default)[700]
    };
    return {
        main: (0, $2S2Ky.default)[700],
        light: (0, $2S2Ky.default)[400],
        dark: (0, $2S2Ky.default)[800]
    };
}
function $2a3d5fe8d46b7d9e$var$getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, $8wzD0.default)[400],
        light: (0, $8wzD0.default)[300],
        dark: (0, $8wzD0.default)[700]
    };
    return {
        main: (0, $8wzD0.default)[700],
        light: (0, $8wzD0.default)[500],
        dark: (0, $8wzD0.default)[900]
    };
}
function $2a3d5fe8d46b7d9e$var$getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, $1EOCV.default)[400],
        light: (0, $1EOCV.default)[300],
        dark: (0, $1EOCV.default)[700]
    };
    return {
        main: (0, $1EOCV.default)[800],
        light: (0, $1EOCV.default)[500],
        dark: (0, $1EOCV.default)[900]
    };
}
function $2a3d5fe8d46b7d9e$var$getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, $in4fF.default)[400],
        light: (0, $in4fF.default)[300],
        dark: (0, $in4fF.default)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, $in4fF.default)[500],
        dark: (0, $in4fF.default)[900]
    };
}
function $2a3d5fe8d46b7d9e$export$2e2bcd8739ae039(palette) {
    const { mode: mode = "light", contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $etz1B.default)(palette, $2a3d5fe8d46b7d9e$var$_excluded);
    const primary = palette.primary || $2a3d5fe8d46b7d9e$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $2a3d5fe8d46b7d9e$var$getDefaultSecondary(mode);
    const error = palette.error || $2a3d5fe8d46b7d9e$var$getDefaultError(mode);
    const info = palette.info || $2a3d5fe8d46b7d9e$var$getDefaultInfo(mode);
    const success = palette.success || $2a3d5fe8d46b7d9e$var$getDefaultSuccess(mode);
    const warning = palette.warning || $2a3d5fe8d46b7d9e$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $c3Y9Y.getContrastRatio)(background, $2a3d5fe8d46b7d9e$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $2a3d5fe8d46b7d9e$export$55ce6f3a06c59543.text.primary : $2a3d5fe8d46b7d9e$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $7i29i.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, $7PAqt.default)(11, name ? ` (${name})` : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, $7PAqt.default)(12, name ? ` (${name})` : "", JSON.stringify(color.main)));
        $2a3d5fe8d46b7d9e$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $2a3d5fe8d46b7d9e$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $2a3d5fe8d46b7d9e$export$55ce6f3a06c59543,
        light: $2a3d5fe8d46b7d9e$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $7swQh.default)((0, $7i29i.default)({
        // A collection of common colors.
        common: (0, $7i29i.default)({}, (0, $16BNv.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        $8yMiQ.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("c3Y9Y", function(module, exports) {
"use strict";

var $6cBd9 = parcelRequire("6cBd9");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alpha = $8c846e556dc3735c$var$alpha;
module.exports.blend = $8c846e556dc3735c$var$blend;
module.exports.colorChannel = void 0;
module.exports.darken = $8c846e556dc3735c$var$darken;
module.exports.decomposeColor = $8c846e556dc3735c$var$decomposeColor;
module.exports.emphasize = $8c846e556dc3735c$var$emphasize;
module.exports.getContrastRatio = $8c846e556dc3735c$var$getContrastRatio;
module.exports.getLuminance = $8c846e556dc3735c$var$getLuminance;
module.exports.hexToRgb = $8c846e556dc3735c$var$hexToRgb;
module.exports.hslToRgb = $8c846e556dc3735c$var$hslToRgb;
module.exports.lighten = $8c846e556dc3735c$var$lighten;
module.exports.private_safeAlpha = $8c846e556dc3735c$var$private_safeAlpha;
module.exports.private_safeColorChannel = void 0;
module.exports.private_safeDarken = $8c846e556dc3735c$var$private_safeDarken;
module.exports.private_safeEmphasize = $8c846e556dc3735c$var$private_safeEmphasize;
module.exports.private_safeLighten = $8c846e556dc3735c$var$private_safeLighten;
module.exports.recomposeColor = $8c846e556dc3735c$var$recomposeColor;
module.exports.rgbToHex = $8c846e556dc3735c$var$rgbToHex;

var $8c846e556dc3735c$var$_formatMuiErrorMessage2 = $6cBd9((parcelRequire("gV636")));

var $8c846e556dc3735c$var$_clamp = $6cBd9((parcelRequire("8DVQr")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $8c846e556dc3735c$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $8c846e556dc3735c$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $8c846e556dc3735c$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $8c846e556dc3735c$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $8c846e556dc3735c$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $8c846e556dc3735c$var$decomposeColor($8c846e556dc3735c$var$hexToRgb(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $8c846e556dc3735c$var$_formatMuiErrorMessage2.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $8c846e556dc3735c$var$_formatMuiErrorMessage2.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $8c846e556dc3735c$var$colorChannel = (color)=>{
    const decomposedColor = $8c846e556dc3735c$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
module.exports.colorChannel = $8c846e556dc3735c$var$colorChannel;
const $8c846e556dc3735c$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $8c846e556dc3735c$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ module.exports.private_safeColorChannel = $8c846e556dc3735c$var$private_safeColorChannel;
function $8c846e556dc3735c$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $8c846e556dc3735c$var$rgbToHex(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $8c846e556dc3735c$var$decomposeColor(color);
    return `#${values.map((n, i)=>$8c846e556dc3735c$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $8c846e556dc3735c$var$hslToRgb(color) {
    color = $8c846e556dc3735c$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $8c846e556dc3735c$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $8c846e556dc3735c$var$getLuminance(color) {
    color = $8c846e556dc3735c$var$decomposeColor(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $8c846e556dc3735c$var$decomposeColor($8c846e556dc3735c$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $8c846e556dc3735c$var$getContrastRatio(foreground, background) {
    const lumA = $8c846e556dc3735c$var$getLuminance(foreground);
    const lumB = $8c846e556dc3735c$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $8c846e556dc3735c$var$alpha(color, value) {
    color = $8c846e556dc3735c$var$decomposeColor(color);
    value = $8c846e556dc3735c$var$clampWrapper(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $8c846e556dc3735c$var$recomposeColor(color);
}
function $8c846e556dc3735c$var$private_safeAlpha(color, value, warning) {
    try {
        return $8c846e556dc3735c$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $8c846e556dc3735c$var$darken(color, coefficient) {
    color = $8c846e556dc3735c$var$decomposeColor(color);
    coefficient = $8c846e556dc3735c$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $8c846e556dc3735c$var$recomposeColor(color);
}
function $8c846e556dc3735c$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $8c846e556dc3735c$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $8c846e556dc3735c$var$lighten(color, coefficient) {
    color = $8c846e556dc3735c$var$decomposeColor(color);
    coefficient = $8c846e556dc3735c$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $8c846e556dc3735c$var$recomposeColor(color);
}
function $8c846e556dc3735c$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $8c846e556dc3735c$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $8c846e556dc3735c$var$emphasize(color, coefficient = 0.15) {
    return $8c846e556dc3735c$var$getLuminance(color) > 0.5 ? $8c846e556dc3735c$var$darken(color, coefficient) : $8c846e556dc3735c$var$lighten(color, coefficient);
}
function $8c846e556dc3735c$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $8c846e556dc3735c$var$emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $8c846e556dc3735c$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $8c846e556dc3735c$var$decomposeColor(background);
    const overlayColor = $8c846e556dc3735c$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $8c846e556dc3735c$var$recomposeColor({
        type: "rgb",
        values: rgb
    });
}

});
parcelRegister("gV636", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("7PAqt")).default; });

var $7PAqt = parcelRequire("7PAqt");

});

parcelRegister("8DVQr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("jkK56")).default; });

var $jkK56 = parcelRequire("jkK56");

});
parcelRegister("jkK56", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e133a15bc437e22b$export$2e2bcd8739ae039; });
function $e133a15bc437e22b$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $e133a15bc437e22b$export$2e2bcd8739ae039 = $e133a15bc437e22b$var$clamp;

});



parcelRegister("16BNv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ce3abc8b79b20e6$export$2e2bcd8739ae039; });
const $0ce3abc8b79b20e6$var$common = {
    black: "#000",
    white: "#fff"
};
var $0ce3abc8b79b20e6$export$2e2bcd8739ae039 = $0ce3abc8b79b20e6$var$common;

});

parcelRegister("8yMiQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63b6f7a80b1b52dd$export$2e2bcd8739ae039; });
const $63b6f7a80b1b52dd$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
var $63b6f7a80b1b52dd$export$2e2bcd8739ae039 = $63b6f7a80b1b52dd$var$grey;

});

parcelRegister("1U20U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $162c9540e47ab62a$export$2e2bcd8739ae039; });
const $162c9540e47ab62a$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $162c9540e47ab62a$export$2e2bcd8739ae039 = $162c9540e47ab62a$var$purple;

});

parcelRegister("2S2Ky", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2172c1f832b0665e$export$2e2bcd8739ae039; });
const $2172c1f832b0665e$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $2172c1f832b0665e$export$2e2bcd8739ae039 = $2172c1f832b0665e$var$red;

});

parcelRegister("in4fF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5fdac40ab41bfb0$export$2e2bcd8739ae039; });
const $d5fdac40ab41bfb0$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $d5fdac40ab41bfb0$export$2e2bcd8739ae039 = $d5fdac40ab41bfb0$var$orange;

});

parcelRegister("82K6d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5db24501586a0fa4$export$2e2bcd8739ae039; });
const $5db24501586a0fa4$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $5db24501586a0fa4$export$2e2bcd8739ae039 = $5db24501586a0fa4$var$blue;

});

parcelRegister("8wzD0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $634cf2eb201cd885$export$2e2bcd8739ae039; });
const $634cf2eb201cd885$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $634cf2eb201cd885$export$2e2bcd8739ae039 = $634cf2eb201cd885$var$lightBlue;

});

parcelRegister("1EOCV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1350cc48ff65829d$export$2e2bcd8739ae039; });
const $1350cc48ff65829d$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $1350cc48ff65829d$export$2e2bcd8739ae039 = $1350cc48ff65829d$var$green;

});


parcelRegister("ieZPY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d479806b29b75b7c$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $etz1B = parcelRequire("etz1B");

var $7swQh = parcelRequire("7swQh");
const $d479806b29b75b7c$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $d479806b29b75b7c$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $d479806b29b75b7c$var$caseAllCaps = {
    textTransform: "uppercase"
};
const $d479806b29b75b7c$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $d479806b29b75b7c$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === "function" ? typography(palette) : typography, { fontFamily: fontFamily = $d479806b29b75b7c$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $etz1B.default)(_ref, $d479806b29b75b7c$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $7i29i.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $d479806b29b75b7c$var$defaultFontFamily ? {
            letterSpacing: `${$d479806b29b75b7c$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $d479806b29b75b7c$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $d479806b29b75b7c$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            letterSpacing: "inherit"
        }
    };
    return (0, $7swQh.default)((0, $7i29i.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("lCAfK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fbd944abbc95a5f0$export$2e2bcd8739ae039; });
const $fbd944abbc95a5f0$var$shadowKeyUmbraOpacity = 0.2;
const $fbd944abbc95a5f0$var$shadowKeyPenumbraOpacity = 0.14;
const $fbd944abbc95a5f0$var$shadowAmbientShadowOpacity = 0.12;
function $fbd944abbc95a5f0$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$fbd944abbc95a5f0$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$fbd944abbc95a5f0$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$fbd944abbc95a5f0$var$shadowAmbientShadowOpacity})`
    ].join(",");
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $fbd944abbc95a5f0$var$shadows = [
    "none",
    $fbd944abbc95a5f0$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $fbd944abbc95a5f0$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $fbd944abbc95a5f0$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $fbd944abbc95a5f0$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $fbd944abbc95a5f0$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $fbd944abbc95a5f0$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $fbd944abbc95a5f0$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $fbd944abbc95a5f0$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $fbd944abbc95a5f0$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $fbd944abbc95a5f0$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $fbd944abbc95a5f0$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $fbd944abbc95a5f0$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $fbd944abbc95a5f0$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $fbd944abbc95a5f0$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $fbd944abbc95a5f0$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $fbd944abbc95a5f0$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $fbd944abbc95a5f0$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $fbd944abbc95a5f0$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $fbd944abbc95a5f0$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $fbd944abbc95a5f0$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $fbd944abbc95a5f0$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $fbd944abbc95a5f0$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $fbd944abbc95a5f0$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $fbd944abbc95a5f0$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $fbd944abbc95a5f0$export$2e2bcd8739ae039 = $fbd944abbc95a5f0$var$shadows;

});

parcelRegister("kk0nG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ecb5f88ff0b4c980$export$2e2bcd8739ae039; });

var $etz1B = parcelRequire("etz1B");

var $7i29i = parcelRequire("7i29i");
const $ecb5f88ff0b4c980$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $ecb5f88ff0b4c980$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const $ecb5f88ff0b4c980$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $ecb5f88ff0b4c980$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $ecb5f88ff0b4c980$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $ecb5f88ff0b4c980$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $7i29i.default)({}, $ecb5f88ff0b4c980$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $7i29i.default)({}, $ecb5f88ff0b4c980$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $etz1B.default)(options, $ecb5f88ff0b4c980$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : $ecb5f88ff0b4c980$var$formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : $ecb5f88ff0b4c980$var$formatMs(delay)}`).join(",");
    };
    return (0, $7i29i.default)({
        getAutoHeightDuration: $ecb5f88ff0b4c980$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("5XLuI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45774dd6138b04da$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $45774dd6138b04da$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $45774dd6138b04da$export$2e2bcd8739ae039 = $45774dd6138b04da$var$zIndex;

});



parcelRegister("jxKUS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3a57dfd509acfa6$export$2e2bcd8739ae039; });
var $e3a57dfd509acfa6$export$2e2bcd8739ae039 = "$$material";

});

parcelRegister("kAgHN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $efc420ca7fddeadd$export$2e2bcd8739ae039; });

var $5T1TY = parcelRequire("5T1TY");
const $efc420ca7fddeadd$var$rootShouldForwardProp = (prop)=>(0, $5T1TY.default)(prop) && prop !== "classes";
var $efc420ca7fddeadd$export$2e2bcd8739ae039 = $efc420ca7fddeadd$var$rootShouldForwardProp;

});
parcelRegister("5T1TY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $449390766a43fa06$export$2e2bcd8739ae039; });
// copied from @mui/system/createStyled
function $449390766a43fa06$var$slotShouldForwardProp(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
var $449390766a43fa06$export$2e2bcd8739ae039 = $449390766a43fa06$var$slotShouldForwardProp;

});



parcelRegister("1qEvy", function(module, exports) {

$parcel$export(module.exports, "getFormLabelUtilityClasses", function () { return $10a7a42cab8fa64b$export$f7d501e40371cd17; });
$parcel$export(module.exports, "default", function () { return $10a7a42cab8fa64b$export$2e2bcd8739ae039; });

var $33f7d = parcelRequire("33f7d");

var $kHWim = parcelRequire("kHWim");
function $10a7a42cab8fa64b$export$f7d501e40371cd17(slot) {
    return (0, $kHWim.default)("MuiFormLabel", slot);
}
const $10a7a42cab8fa64b$var$formLabelClasses = (0, $33f7d.default)("MuiFormLabel", [
    "root",
    "colorSecondary",
    "focused",
    "disabled",
    "error",
    "filled",
    "required",
    "asterisk"
]);
var $10a7a42cab8fa64b$export$2e2bcd8739ae039 = $10a7a42cab8fa64b$var$formLabelClasses;

});
parcelRegister("33f7d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $238d607cbe09c0aa$export$2e2bcd8739ae039; });

var $kHWim = parcelRequire("kHWim");
function $238d607cbe09c0aa$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = "Mui") {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $kHWim.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("kHWim", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1350b0490bffce8$export$2e2bcd8739ae039; });

var $6gI4r = parcelRequire("6gI4r");
const $f1350b0490bffce8$export$9d6b9120de57c54 = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    open: "open",
    readOnly: "readOnly",
    required: "required",
    selected: "selected"
};
function $f1350b0490bffce8$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = "Mui") {
    const globalStateClass = $f1350b0490bffce8$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $6gI4r.default).generate(componentName)}-${slot}`;
}
function $f1350b0490bffce8$export$34c0130b1f3e8ae3(slot) {
    return $f1350b0490bffce8$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("6gI4r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49066c31c40c3b60$export$2e2bcd8739ae039; });
const $49066c31c40c3b60$var$defaultGenerator = (componentName)=>componentName;
const $49066c31c40c3b60$var$createClassNameGenerator = ()=>{
    let generate = $49066c31c40c3b60$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $49066c31c40c3b60$var$defaultGenerator;
        }
    };
};
const $49066c31c40c3b60$var$ClassNameGenerator = $49066c31c40c3b60$var$createClassNameGenerator();
var $49066c31c40c3b60$export$2e2bcd8739ae039 = $49066c31c40c3b60$var$ClassNameGenerator;

});






parcelRegister("7wJa8", function(module, exports) {

$parcel$export(module.exports, "RolePage", function () { return $00009bd672082847$export$23023a9b21fcfa15; });

var $61Ea1 = parcelRequire("61Ea1");

var $2YJBX = parcelRequire("2YJBX");

var $cGqIO = parcelRequire("cGqIO");

var $kiwkc = parcelRequire("kiwkc");

var $fTGwv = parcelRequire("fTGwv");
function $00009bd672082847$export$23023a9b21fcfa15() {
    const role = (0, $kiwkc.useRoleData)();
    const onAddNewRate = ()=>{
        (0, $kiwkc.staffRoleActions).addNewRate();
    };
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $2YJBX.InputWithLabel), {
                        value: role === null || role === void 0 ? void 0 : role.name,
                        onChange: (e)=>(0, $kiwkc.staffRoleActions).changeRoleData("name", e.target.value),
                        containerClassName: "flex-row items-center gap-3 mb-4",
                        label: "Role Name"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fTGwv.Button), {
                        variant: "outline",
                        onClick: onAddNewRate,
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                className: "fa fa-plus mr-1"
                            }),
                            "Add Rate"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $cGqIO.RolePageTable), {})
        ]
    });
}

});
parcelRegister("cGqIO", function(module, exports) {

$parcel$export(module.exports, "RolePageTable", function () { return $8a509a1431a8af91$export$82162e6037e99f6a; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $kiwkc = parcelRequire("kiwkc");

var $x6PEK = parcelRequire("x6PEK");

var $aaosT = parcelRequire("aaosT");

var $aYyI4 = parcelRequire("aYyI4");

var $8jD92 = parcelRequire("8jD92");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");
function $8a509a1431a8af91$export$82162e6037e99f6a() {
    const role = (0, $kiwkc.useRoleData)();
    const roleRates = (0, $kiwkc.useRoleRates)();
    const staffs = (0, $kiwkc.useStaffs)();
    const columns = (0, $jbmdS.useMemo)(()=>(0, $x6PEK.getColumns)((column)=>{}, role), [
        role
    ]);
    const topRow = (0, $jbmdS.useMemo)(()=>[
            {
                id: "role",
                size: 120
            },
            {
                id: "avgPayRate",
                value: role === null || role === void 0 ? void 0 : role.avgPayRate,
                size: 120,
                label: "Average From Staff",
                onChange: (value)=>{
                    (0, $kiwkc.staffRoleActions).changeRoleData("avgPayRate", value);
                },
                permissions: (0, $8kZ1o.canViewStaffPayRate)((0, $1BTI2.default).user),
                editable: !(staffs !== null && staffs !== void 0 && staffs.some((staff)=>staff === null || staff === void 0 ? void 0 : staff.inheritPayRate)) && (0, $8kZ1o.canEditRoles)((0, $1BTI2.default).user) && (0, $8kZ1o.canEditStaffPayRate)((0, $1BTI2.default).user)
            },
            {
                id: "avgOvertimeRate",
                value: role === null || role === void 0 ? void 0 : role.avgOvertimeRate,
                size: 120,
                label: "Average From Staff",
                onChange: (value)=>{
                    (0, $kiwkc.staffRoleActions).changeRoleData("avgOvertimeRate", value);
                },
                permissions: (0, $8kZ1o.canViewStaffOvertimeRate)((0, $1BTI2.default).user),
                editable: !(staffs !== null && staffs !== void 0 && staffs.some((staff)=>staff === null || staff === void 0 ? void 0 : staff.inheritOvertimeRate)) && (0, $8kZ1o.canEditRoles)((0, $1BTI2.default).user) && (0, $8kZ1o.canEditStaffOvertimeRate)((0, $1BTI2.default).user)
            },
            {
                id: "avgCostRate",
                value: role === null || role === void 0 ? void 0 : role.avgCostRate,
                size: 120,
                label: "Average From Staff",
                onChange: (value)=>{
                    (0, $kiwkc.staffRoleActions).changeRoleData("avgCostRate", value);
                },
                permissions: (0, $8kZ1o.canViewStaffCostRate)((0, $1BTI2.default).user),
                editable: !(staffs !== null && staffs !== void 0 && staffs.some((staff)=>staff === null || staff === void 0 ? void 0 : staff.inheritCostRate)) && (0, $8kZ1o.canEditRoles)((0, $1BTI2.default).user) && (0, $8kZ1o.canEditStaffCostRate)((0, $1BTI2.default).user)
            },
            {
                id: "avgChargeOutRate",
                value: role === null || role === void 0 ? void 0 : role.avgChargeOutRate,
                size: 120,
                label: "Average From Staff",
                onChange: (value)=>{
                    (0, $kiwkc.staffRoleActions).changeRoleData("avgChargeOutRate", value);
                },
                permissions: (0, $8kZ1o.canViewStaffChargeOutRate)((0, $1BTI2.default).user),
                editable: !(staffs !== null && staffs !== void 0 && staffs.some((staff)=>staff === null || staff === void 0 ? void 0 : staff.inheritChargeOutRate)) && (0, $8kZ1o.canEditRoles)((0, $1BTI2.default).user) && (0, $8kZ1o.canEditStaffChargeOutRate)((0, $1BTI2.default).user)
            },
            {
                id: "button"
            }
        ], [
        role,
        staffs
    ]);
    const renderTopRow = (row)=>{
        if (row.id === "button" || row.id === "role") return null;
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8jD92.CheckboxWithLabel), {
            label: row.label,
            checked: row.value,
            id: row.id,
            onCheckedChange: row.onChange,
            disabled: !row.editable
        });
    };
    const rowData = (0, $jbmdS.useMemo)(()=>roleRates.filter((rate)=>!(rate !== null && rate !== void 0 && rate.deletedAt)), [
        roleRates
    ]);
    const { table: table } = (0, $aaosT.useDataTable)({
        data: rowData,
        columns: columns,
        visibleColumns: columns.map((column)=>column === null || column === void 0 ? void 0 : column.accessorKey)
    });
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $aYyI4.DataTable), {
        table: table,
        topRows: topRow,
        renderTopRow: renderTopRow
    });
}

});
parcelRegister("kiwkc", function(module, exports) {

$parcel$export(module.exports, "staffRoleStore", function () { return $853ea771b5fa319e$export$98957e44d27d9e81; });
$parcel$export(module.exports, "useRoleData", function () { return $853ea771b5fa319e$export$b6d2d981c73d3b69; });
$parcel$export(module.exports, "useRoleRates", function () { return $853ea771b5fa319e$export$79d920f0ce5fe39; });
$parcel$export(module.exports, "useStaffs", function () { return $853ea771b5fa319e$export$a52eaa34fd9fa10b; });
$parcel$export(module.exports, "staffRoleActions", function () { return $853ea771b5fa319e$export$f8d1bb3efd8f456a; });
$parcel$export(module.exports, "getRoleData", function () { return $853ea771b5fa319e$export$d900099800878109; });
$parcel$export(module.exports, "getRoleRates", function () { return $853ea771b5fa319e$export$77864caccef1a0e1; });
$parcel$export(module.exports, "getStaffRates", function () { return $853ea771b5fa319e$export$cc793f20ba19211a; });
$parcel$export(module.exports, "getStaffs", function () { return $853ea771b5fa319e$export$869519853dd30c47; });

var $8qPhl = parcelRequire("8qPhl");

var $3h7sC = parcelRequire("3h7sC");

var $277OF = parcelRequire("277OF");

var $lJ1OS = parcelRequire("lJ1OS");

var $9Pt1Z = parcelRequire("9Pt1Z");
const $853ea771b5fa319e$export$361c590f91455862 = (0, $8qPhl.z).object({
    id: (0, $8qPhl.z).string(),
    name: (0, $8qPhl.z).string(),
    avgPayRate: (0, $8qPhl.z).coerce.boolean(),
    avgOvertimeRate: (0, $8qPhl.z).coerce.boolean(),
    avgCostRate: (0, $8qPhl.z).coerce.boolean(),
    avgChargeOutRate: (0, $8qPhl.z).coerce.boolean(),
    isArchived: (0, $8qPhl.z).coerce.boolean()
});
const $853ea771b5fa319e$export$a9915d92f79383db = (0, $8qPhl.z).object({
    id: (0, $8qPhl.z).string().optional(),
    roleId: (0, $8qPhl.z).string().optional(),
    date: (0, $8qPhl.z).coerce.date(),
    payRate: (0, $8qPhl.z).coerce.number().nullable(),
    overtimeRate: (0, $8qPhl.z).coerce.number().nullable(),
    costRate: (0, $8qPhl.z).coerce.number().nullable(),
    chargeOutRate: (0, $8qPhl.z).coerce.number().nullable(),
    deletedAt: (0, $8qPhl.z).coerce.date().nullable().optional()
});
const $853ea771b5fa319e$var$DEFAULT_ROLE_RATE = {
    date: new Date(),
    payRate: 0,
    overtimeRate: 0,
    costRate: 0,
    chargeOutRate: 0
};
const $853ea771b5fa319e$export$98957e44d27d9e81 = (0, $277OF.createQueryStore)({
    context: {
        role: null,
        roleRates: [],
        staffRates: [],
        staffs: []
    },
    on: {
        saveStaffRoleData: {
            role: (_, { data: data })=>data.role,
            roleRates: (_, { data: data })=>data.roleRates.map((rate)=>({
                        ...rate,
                        date: new Date(rate.date)
                    })),
            staffRates: (_, { data: data })=>data.staffRates.map((rate)=>({
                        ...rate,
                        date: new Date(rate.date)
                    })),
            staffs: (_, { data: data })=>data.staffs
        },
        changeRoleData: {
            role: (context, { key: key, value: value })=>context.role ? {
                    ...context.role,
                    [key]: value
                } : null
        },
        changeRoleRateData: {
            roleRates: (context, { id: id, key: key, value: value })=>{
                const index = context.roleRates.findIndex((rate)=>rate.id === id);
                if (index === -1) return context.roleRates;
                const updatedRates = [
                    ...context.roleRates
                ];
                updatedRates[index] = {
                    ...updatedRates[index],
                    [key]: value
                };
                return updatedRates;
            }
        },
        addNewRate: {
            roleRates: (context, { initial: initial = $853ea771b5fa319e$var$DEFAULT_ROLE_RATE })=>{
                var _context$role;
                return [
                    ...context.roleRates,
                    {
                        ...initial,
                        id: (0, $9Pt1Z.v4)(),
                        roleId: (_context$role = context.role) === null || _context$role === void 0 ? void 0 : _context$role.id
                    }
                ];
            }
        },
        deleteRate: {
            roleRates: (context, { id: id })=>{
                const index = context.roleRates.findIndex((rate)=>rate.id === id);
                if (index === -1) return context.roleRates;
                const updatedRates = [
                    ...context.roleRates
                ];
                updatedRates[index] = {
                    ...updatedRates[index],
                    deletedAt: new Date()
                };
                return updatedRates;
            }
        }
    }
}, {
    queryKey: [
        "staff-role"
    ],
    queryFn: async ({ id: id })=>{
        const result = await (0, $3h7sC.trpc).role.getRole.query({
            id: id
        });
        return {
            role: result.role ? $853ea771b5fa319e$export$361c590f91455862.parse(result.role) : null,
            roleRates: result.roleRates.map((rate)=>$853ea771b5fa319e$export$a9915d92f79383db.parse(rate)),
            staffRates: result.staffRates.map((rate)=>$853ea771b5fa319e$export$a9915d92f79383db.parse(rate)),
            staffs: result.staffs
        };
    },
    mutationFn: (data)=>(0, $3h7sC.trpc).role.saveRole.mutate({
            role: data.role,
            roleRates: data.roleRates
        }),
    staleTime: 300000,
    // 5 minutes
    cacheTime: 1800000 // 30 minutes
}, {
    saveId: "staff-role-save",
    requireConfirmation: true,
    confirmationMessage: "Save changes to staff role?",
    loadingMessage: "Saving staff role...",
    successMessage: "Staff role saved successfully",
    errorMessage: "Failed to save staff role"
});
const $853ea771b5fa319e$export$b6d2d981c73d3b69 = ()=>(0, $lJ1OS.useSelector)($853ea771b5fa319e$export$98957e44d27d9e81.store, (state)=>state.context.role);
const $853ea771b5fa319e$export$79d920f0ce5fe39 = ()=>(0, $lJ1OS.useSelector)($853ea771b5fa319e$export$98957e44d27d9e81.store, (state)=>state.context.roleRates);
const $853ea771b5fa319e$export$49c7abec96e0c3f = ()=>(0, $lJ1OS.useSelector)($853ea771b5fa319e$export$98957e44d27d9e81.store, (state)=>state.context.staffRates);
const $853ea771b5fa319e$export$a52eaa34fd9fa10b = ()=>(0, $lJ1OS.useSelector)($853ea771b5fa319e$export$98957e44d27d9e81.store, (state)=>state.context.staffs);
const $853ea771b5fa319e$export$f8d1bb3efd8f456a = {
    saveStaffRoleData: (data)=>$853ea771b5fa319e$export$98957e44d27d9e81.store.send({
            type: "saveStaffRoleData",
            data: data
        }),
    changeRoleData: (key, value)=>$853ea771b5fa319e$export$98957e44d27d9e81.store.send({
            type: "changeRoleData",
            key: key,
            value: value
        }),
    changeRoleRateData: (id, key, value)=>$853ea771b5fa319e$export$98957e44d27d9e81.store.send({
            type: "changeRoleRateData",
            id: id,
            key: key,
            value: value
        }),
    addNewRate: (initial)=>$853ea771b5fa319e$export$98957e44d27d9e81.store.send({
            type: "addNewRate",
            initial: initial
        }),
    deleteRate: (id)=>$853ea771b5fa319e$export$98957e44d27d9e81.store.send({
            type: "deleteRate",
            id: id
        })
};
const $853ea771b5fa319e$export$d900099800878109 = ()=>$853ea771b5fa319e$export$98957e44d27d9e81.store.getSnapshot().context.role;
const $853ea771b5fa319e$export$77864caccef1a0e1 = ()=>$853ea771b5fa319e$export$98957e44d27d9e81.store.getSnapshot().context.roleRates;
const $853ea771b5fa319e$export$cc793f20ba19211a = ()=>$853ea771b5fa319e$export$98957e44d27d9e81.store.getSnapshot().context.staffRates;
const $853ea771b5fa319e$export$869519853dd30c47 = ()=>$853ea771b5fa319e$export$98957e44d27d9e81.store.getSnapshot().context.staffs;
const { useStoreData: $853ea771b5fa319e$export$544efe5ac05fc17, useIsLoading: $853ea771b5fa319e$export$4dface15d86304a4, useCanUndo: $853ea771b5fa319e$export$653033ad74e314c9, useCanRedo: $853ea771b5fa319e$export$e7ea8bfdbe9392b0, useUpdatedAt: $853ea771b5fa319e$export$4d53551414e812c, undo: $853ea771b5fa319e$export$21f930c44940fd98, redo: $853ea771b5fa319e$export$1688e416fee0a49e, save: $853ea771b5fa319e$export$a1544dad697b423d, revertToLastSave: $853ea771b5fa319e$export$7e511c2293ae6e56, getState: $853ea771b5fa319e$export$50fdfeece43146fd, getHistory: $853ea771b5fa319e$export$f9582a3c130d9538, getCurrentHistoryIndex: $853ea771b5fa319e$export$3d0fb93f79a1d871, getLastSavedIndex: $853ea771b5fa319e$export$3ad3501ee738138, getSavedAt: $853ea771b5fa319e$export$f4c906ca2124fef8, getUpdatedAt: $853ea771b5fa319e$export$ff3aa069bd8fb4e4 } = $853ea771b5fa319e$export$98957e44d27d9e81;

});

parcelRegister("x6PEK", function(module, exports) {

$parcel$export(module.exports, "getColumns", function () { return $c4b520674ad21fbd$export$978e30a0fb8610d8; });

var $61Ea1 = parcelRequire("61Ea1");

var $khCHn = parcelRequire("khCHn");

var $1BTI2 = parcelRequire("1BTI2");

var $8kZ1o = parcelRequire("8kZ1o");

var $kiwkc = parcelRequire("kiwkc");

var $foRmm = parcelRequire("foRmm");
function $c4b520674ad21fbd$export$978e30a0fb8610d8(onHideColumn, role) {
    const generateColumnDef = (0, $khCHn.createGenerateColumnDef)({
        onHideColumn: onHideColumn
    });
    const wideSize = 120;
    return [
        generateColumnDef({
            key: "date",
            type: "date",
            title: "Starting From",
            size: wideSize,
            permissions: (r)=>(0, $8kZ1o.canViewStaffPayRate)((0, $1BTI2.default).user),
            editable: (0, $8kZ1o.canEditRoles)((0, $1BTI2.default).user) && (0, $8kZ1o.canEditStaffPayRate)((0, $1BTI2.default).user),
            onChange: (row, val)=>{
                (0, $kiwkc.staffRoleActions).changeRoleRateData(row.original.id, "date", val);
            }
        }),
        generateColumnDef({
            key: "payRate",
            type: "currency",
            title: "Pay Rate",
            size: wideSize,
            permissions: (r)=>(0, $8kZ1o.canViewStaffOvertimeRate)((0, $1BTI2.default).user),
            editable: !(role !== null && role !== void 0 && role.avgPayRate) && (0, $8kZ1o.canEditRoles)((0, $1BTI2.default).user) && (0, $8kZ1o.canEditStaffOvertimeRate)((0, $1BTI2.default).user),
            customValue: (r)=>role !== null && role !== void 0 && role.avgPayRate ? (0, $foRmm.RoleUtils).getRoleRateAtDate("pay", r === null || r === void 0 ? void 0 : r.date) : r === null || r === void 0 ? void 0 : r.payRate,
            onChange: (row, val)=>{
                (0, $kiwkc.staffRoleActions).changeRoleRateData(row.original.id, "payRate", val);
            }
        }),
        generateColumnDef({
            key: "overtimeRate",
            type: "currency",
            title: "Overtime Rate",
            size: wideSize,
            permissions: (r)=>(0, $8kZ1o.canViewStaffOvertimeRate)((0, $1BTI2.default).user),
            editable: !(role !== null && role !== void 0 && role.avgOvertimeRate) && (0, $8kZ1o.canEditRoles)((0, $1BTI2.default).user) && (0, $8kZ1o.canEditStaffOvertimeRate)((0, $1BTI2.default).user),
            customValue: (r)=>role !== null && role !== void 0 && role.avgOvertimeRate ? (0, $foRmm.RoleUtils).getRoleRateAtDate("overtime", r === null || r === void 0 ? void 0 : r.date) : r === null || r === void 0 ? void 0 : r.overtimeRate,
            onChange: (row, val)=>{
                (0, $kiwkc.staffRoleActions).changeRoleRateData(row.original.id, "overtimeRate", val);
            }
        }),
        generateColumnDef({
            key: "costRate",
            type: "currency",
            title: "Cost Rate",
            size: wideSize,
            permissions: (r)=>(0, $8kZ1o.canViewStaffCostRate)((0, $1BTI2.default).user),
            editable: !(role !== null && role !== void 0 && role.avgCostRate) && (0, $8kZ1o.canEditRoles)((0, $1BTI2.default).user) && (0, $8kZ1o.canEditStaffCostRate)((0, $1BTI2.default).user),
            customValue: (r)=>role !== null && role !== void 0 && role.avgCostRate ? (0, $foRmm.RoleUtils).getRoleRateAtDate("cost", r === null || r === void 0 ? void 0 : r.date) : r === null || r === void 0 ? void 0 : r.costRate,
            onChange: (row, val)=>{
                (0, $kiwkc.staffRoleActions).changeRoleRateData(row.original.id, "costRate", val);
            }
        }),
        generateColumnDef({
            key: "chargeOutRate",
            type: "currency",
            title: "Charge Out Rate",
            size: wideSize,
            permissions: (r)=>(0, $8kZ1o.canViewStaffChargeOutRate)((0, $1BTI2.default).user),
            editable: !(role !== null && role !== void 0 && role.avgChargeOutRate) && (0, $8kZ1o.canEditRoles)((0, $1BTI2.default).user) && (0, $8kZ1o.canEditStaffChargeOutRate)((0, $1BTI2.default).user),
            customValue: (r)=>role !== null && role !== void 0 && role.avgChargeOutRate ? (0, $foRmm.RoleUtils).getRoleRateAtDate("chargeOut", r === null || r === void 0 ? void 0 : r.date) : r === null || r === void 0 ? void 0 : r.chargeOutRate,
            onChange: (row, val)=>{
                (0, $kiwkc.staffRoleActions).changeRoleRateData(row.original.id, "chargeOutRate", val);
            }
        }),
        generateColumnDef({
            key: "deleteButton",
            title: "Action",
            type: "button",
            editable: (0, $8kZ1o.canEditRoles)((0, $1BTI2.default).user),
            permissions: ()=>(0, $8kZ1o.canEditRoles)((0, $1BTI2.default).user),
            cell: ()=>{
                return /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                    className: "fa fa-times"
                });
            },
            onClick: (row)=>{
                console.log(row.original.id);
                (0, $kiwkc.staffRoleActions).deleteRate(row.original.id);
            }
        })
    ];
}

});
parcelRegister("foRmm", function(module, exports) {

$parcel$export(module.exports, "RoleUtils", function () { return $3198388c8553d507$export$3812cf03cb629590; });

var $8lBDl = parcelRequire("8lBDl");

var $kiwkc = parcelRequire("kiwkc");

var $37AD0 = parcelRequire("37AD0");

var $MRmcQ = parcelRequire("MRmcQ");

var $6ZPVk = parcelRequire("6ZPVk");

var $eat5C = parcelRequire("eat5C");
const $3198388c8553d507$var$isAvgRateType = (rateType)=>{
    var _role;
    const role = (0, $kiwkc.getRoleData)();
    return (_role = role === null || role === void 0 ? void 0 : role["avg" + (0, $8lBDl.pascalCase)(rateType) + "Rate"]) !== null && _role !== void 0 ? _role : false;
};
const $3198388c8553d507$var$getRoleRateInDateRange = (rateType, dateRange, fromStaff = false)=>{
    var _getStaffs, _getRoleRates;
    const staffs = (_getStaffs = (0, $kiwkc.getStaffs)()) !== null && _getStaffs !== void 0 ? _getStaffs : [];
    const roleRates = (_getRoleRates = (0, $kiwkc.getRoleRates)()) !== null && _getRoleRates !== void 0 ? _getRoleRates : [];
    const availableStaffs = staffs.filter((s)=>!(0, $6ZPVk.StaffUtils).inheritRateType(s, rateType));
    if (availableStaffs.length && $3198388c8553d507$var$isAvgRateType(rateType) && !fromStaff) return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).mean(availableStaffs.filter((s)=>!s.isArchived).map((s)=>(0, $6ZPVk.StaffUtils).getStaffRateInDateRange(s, rateType, dateRange)).map((r)=>(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).toNumber(r)));
    return (0, $MRmcQ.default)(roleRates, rateType, dateRange);
};
const $3198388c8553d507$var$getRoleRateAtDate = (rateType, date, fromStaff = false)=>{
    var _getStaffs2, _getRoleRates2;
    const staffs = (_getStaffs2 = (0, $kiwkc.getStaffs)()) !== null && _getStaffs2 !== void 0 ? _getStaffs2 : [];
    const roleRates = (_getRoleRates2 = (0, $kiwkc.getRoleRates)()) !== null && _getRoleRates2 !== void 0 ? _getRoleRates2 : [];
    const availableStaffs = staffs.filter((s)=>!(0, $6ZPVk.StaffUtils).inheritRateType(s, rateType) && !s.isArchived);
    if (availableStaffs.length && $3198388c8553d507$var$isAvgRateType(rateType) && !fromStaff) {
        const listRate = availableStaffs.map((s)=>(0, $6ZPVk.StaffUtils).getStaffRateAtDate(s, date, rateType)).filter((r)=>r).map((r)=>(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).toNumber(r));
        const rate = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).mean(listRate);
        return rate;
    }
    return (0, $37AD0.default)(roleRates, rateType, date);
};
const $3198388c8553d507$export$3812cf03cb629590 = {
    getRoleRateInDateRange: $3198388c8553d507$var$getRoleRateInDateRange,
    getRoleRateAtDate: $3198388c8553d507$var$getRoleRateAtDate,
    isAvgRateType: $3198388c8553d507$var$isAvgRateType
};

});
parcelRegister("6ZPVk", function(module, exports) {

$parcel$export(module.exports, "StaffUtils", function () { return $6c95373549c815f1$export$83097b4e9c2bf8b5; });

var $8lBDl = parcelRequire("8lBDl");

var $kiwkc = parcelRequire("kiwkc");

var $37AD0 = parcelRequire("37AD0");

var $MRmcQ = parcelRequire("MRmcQ");

var $foRmm = parcelRequire("foRmm");
const $6c95373549c815f1$var$inheritRateType = (staff, rateType)=>{
    var _staff;
    return (_staff = staff === null || staff === void 0 ? void 0 : staff[`inherit${(0, $8lBDl.pascalCase)(rateType)}Rate`]) !== null && _staff !== void 0 ? _staff : false;
};
const $6c95373549c815f1$var$getAvailableStaffs = (rateType)=>{
    var _getStaffs;
    const staffs = (_getStaffs = (0, $kiwkc.getStaffs)()) !== null && _getStaffs !== void 0 ? _getStaffs : [];
    console.log("staffs", staffs);
    const availableStaffs = staffs.filter((s)=>$6c95373549c815f1$export$83097b4e9c2bf8b5.inheritRateType(s, rateType) && !(s !== null && s !== void 0 && s.deletedAt) && !(s !== null && s !== void 0 && s.isArchived));
    return availableStaffs;
};
const $6c95373549c815f1$var$getStaffRate = (staff)=>{
    const staffRate = (0, $kiwkc.getStaffRates)();
    return staffRate.filter((r)=>r.staffId === staff.id);
};
const $6c95373549c815f1$var$getStaffRateInDateRange = (staff, rateType, dateRange, fromRole = false)=>{
    if ($6c95373549c815f1$var$inheritRateType(staff, rateType) && !fromRole) return (0, $foRmm.RoleUtils).getRoleRateInDateRange(rateType, dateRange);
    const rates = $6c95373549c815f1$var$getStaffRate(staff);
    return (0, $MRmcQ.default)(rates, rateType, dateRange);
};
const $6c95373549c815f1$var$getStaffRateAtDate = (staff, date, rateType, fromRole = false)=>{
    if ($6c95373549c815f1$var$inheritRateType(staff, rateType) && !fromRole) return (0, $foRmm.RoleUtils).getRoleRateAtDate(rateType, date);
    const rates = $6c95373549c815f1$var$getStaffRate(staff);
    return (0, $37AD0.default)(rates, rateType, date);
};
const $6c95373549c815f1$export$83097b4e9c2bf8b5 = {
    getStaffRateAtDate: $6c95373549c815f1$var$getStaffRateAtDate,
    inheritRateType: $6c95373549c815f1$var$inheritRateType,
    getStaffRate: $6c95373549c815f1$var$getStaffRate,
    getStaffRateInDateRange: $6c95373549c815f1$var$getStaffRateInDateRange,
    getAvailableStaffs: $6c95373549c815f1$var$getAvailableStaffs
};

});






parcelRegister("5krgq", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $3e13f80d85ad49a5$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");
var $64Yjc = parcelRequire("64Yjc");

var $50TUu = parcelRequire("50TUu");

var $5AhMR = parcelRequire("5AhMR");

var $kuPRw = parcelRequire("kuPRw");

var $4iw5i = parcelRequire("4iw5i");

var $5PXcS = parcelRequire("5PXcS");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $7qobO = parcelRequire("7qobO");

var $cyAez = parcelRequire("cyAez");

var $3nqbz = parcelRequire("3nqbz");

var $gssr3 = parcelRequire("gssr3");

var $gTTjY = parcelRequire("gTTjY");

var $9ylCr = parcelRequire("9ylCr");

var $59oWa = parcelRequire("59oWa");

var $iy0WE = parcelRequire("iy0WE");

var $2MQ1P = parcelRequire("2MQ1P");

var $d1fU6 = parcelRequire("d1fU6");

var $bZfKS = parcelRequire("bZfKS");

var $bGmym = parcelRequire("bGmym");
parcelRequire("fM2j4");

var $6Q5sp = parcelRequire("6Q5sp");

var $gJT7h = parcelRequire("gJT7h");

var $26sX2 = parcelRequire("26sX2");

var $38AIP = parcelRequire("38AIP");

var $kqntg = parcelRequire("kqntg");

var $3h7sC = parcelRequire("3h7sC");

var $47i9t = parcelRequire("47i9t");

var $6l5Kr = parcelRequire("6l5Kr");
parcelRequire("8xdcC");
const $3e13f80d85ad49a5$var$tabs = {
    details: {
        label: "Project Details",
        id: "details",
        page: (props)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $50TUu.default), {
                ...props
            }),
        collections: (id)=>{
            return [];
        },
        permissions: (params)=>(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "project-details", params)
    },
    forecasts: {
        label: "Forecasts",
        id: "forecasts",
        page: (props)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $cyAez.default), {
                ...props
            }),
        header: (props)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $gssr3.default), {
                ...props
            }),
        sidebar: (props)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $3nqbz.default), {
                ...props
            }),
        collections: ()=>{
            return [];
        },
        permissions: (params)=>(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "project-forecasts", params)
    },
    milestones: {
        label: "Milestones",
        id: "milestones",
        page: (props)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $d1fU6.default), {
                ...props
            }),
        collections: (id)=>{
            return [];
        },
        permissions: (params)=>(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "project-milestones", params)
    },
    tasks: {
        label: "Tasks",
        id: "tasks",
        page: (props)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $gTTjY.default), {
                ...props
            }),
        collections: (id)=>{
            return [];
        },
        permissions: (params)=>(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "project-tasks", params)
    },
    changelog: {
        label: "Changelog",
        id: "changelog",
        page: (props)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $9ylCr.default), {
                ...props
            }),
        collections: (id)=>{
            return [];
        },
        permissions: (params)=>(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "project-changelog", params)
    },
    rates: {
        label: "Rates",
        id: "rates",
        page: (props)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $59oWa.default), {
                ...props
            }),
        collections: (id)=>{
            return [];
        },
        permissions: (params)=>(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "project-rates", params)
    },
    notes: {
        label: "Notes",
        id: "notes",
        page: (props)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $iy0WE.default), {
                ...props
            }),
        collections: (id)=>{
            return [];
        },
        permissions: (params)=>(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "project-notes", params)
    },
    history: {
        label: "History",
        id: "history",
        page: (props)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $bGmym.default), {
                ...props
            }),
        collections: (id)=>{
            return [];
        },
        permissions: (params)=>(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "project-history", params)
    },
    status: {
        label: "Status",
        id: "status",
        page: (props)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $2MQ1P.default), {
                ...props
            }),
        collections: (id)=>{
            return [];
        },
        permissions: (params)=>(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "project-status", params)
    }
};
const $3e13f80d85ad49a5$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_private/projects/$id")({
    beforeLoad: ({ params: params, search: search })=>{
        const activeTab = (search === null || search === void 0 ? void 0 : search.tab) || "details";
        if (!(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "project", params) || !(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, `project-${activeTab}`, params)) throw new Error("Permission Denied");
        const project = (0, $38AIP.getCacheItemById)("projects", params.id);
        (0, $26sX2.setLayoutDefaults)({
            pageTitle: (project === null || project === void 0 ? void 0 : project.name) || "Project",
            subMenu: "projects",
            tabs: Object.values($3e13f80d85ad49a5$var$tabs).map((t)=>({
                    id: t.id,
                    label: t.label
                }))
        });
    },
    errorComponent: ({ error: error, reset: reset })=>{
        if (error.message === "Permission Denied") return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7qobO.default), {});
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    },
    loaderDeps: ({ search: { tab: tab } })=>({
            tab: tab
        }),
    loader: async ({ params: params, location: location })=>await $3e13f80d85ad49a5$var$loader(params.id, location.search),
    pendingComponent: (0, $4iw5i.default),
    component: $3e13f80d85ad49a5$var$Wrapper,
    onLeave: (match)=>{
        const { id: id } = match.params;
        const project = (0, $gJT7h.default).projectsById[id];
        if (project && !project.createdAt && match.pathname !== (0, $6Q5sp.router).latestLocation.pathname) (0, $6l5Kr.cleanupNewEntity)(project, "project");
    }
});
const $3e13f80d85ad49a5$var$loader = async (id, search)=>{
    const { tab: tab } = search;
    const activeTab = tab || "details";
    const data = await (0, $3h7sC.trpc).legacy.getProjectPageData.query({
        id: id
    });
    const processedModels = (0, $47i9t.processTRPCData)(data);
    const project = (0, $gJT7h.default).projectsById[id];
    if (!project) throw (0, $64Yjc.notFound)();
    return processedModels;
};
function $3e13f80d85ad49a5$var$Wrapper() {
    const { tab: tab } = $3e13f80d85ad49a5$export$e7b0ac011bb776c6.useSearch();
    const params = $3e13f80d85ad49a5$export$e7b0ac011bb776c6.useParams();
    const activeTab = tab || "details";
    if ((0, $8kZ1o.migratedToV2)()) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqntg.CenterPadPageBody), {
        children: $3e13f80d85ad49a5$var$tabs[activeTab].page(params)
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            $3e13f80d85ad49a5$var$tabs[activeTab].header ? $3e13f80d85ad49a5$var$tabs[activeTab].header({
                tabs: Object.values($3e13f80d85ad49a5$var$tabs).filter((t)=>t.permissions(params)),
                selectedTab: activeTab,
                ...params
            }) : /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5AhMR.default), {
                tabs: Object.values($3e13f80d85ad49a5$var$tabs).filter((t)=>t.permissions(params)),
                selectedTab: activeTab,
                ...params
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kuPRw.default), {
                children: $3e13f80d85ad49a5$var$tabs[activeTab].page(params)
            }),
            $3e13f80d85ad49a5$var$tabs[activeTab].sidebar && /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bZfKS.default), {
                children: $3e13f80d85ad49a5$var$tabs[activeTab].sidebar({
                    ...params
                })
            })
        ]
    });
}

});
parcelRegister("50TUu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a685266b2733ecc$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $gJT7h = parcelRequire("gJT7h");

var $ewAM3 = parcelRequire("ewAM3");

var $goLmS = parcelRequire("goLmS");

var $XoImS = parcelRequire("XoImS");

var $cfp1m = parcelRequire("cfp1m");

var $hSUCJ = parcelRequire("hSUCJ");

var $1fkTL = parcelRequire("1fkTL");

var $1nRI3 = parcelRequire("1nRI3");

var $4JcCM = parcelRequire("4JcCM");

var $eat5C = parcelRequire("eat5C");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $aSdwE = parcelRequire("aSdwE");

var $49KZT = parcelRequire("49KZT");

var $6fNfM = parcelRequire("6fNfM");

var $7qENG = parcelRequire("7qENG");

var $khJQv = parcelRequire("khJQv");
var $3a685266b2733ecc$var$_dec, $3a685266b2733ecc$var$_dec2, $3a685266b2733ecc$var$_dec3, $3a685266b2733ecc$var$_class, $3a685266b2733ecc$var$_descriptor, $3a685266b2733ecc$var$_descriptor2, $3a685266b2733ecc$var$_descriptor3, $3a685266b2733ecc$var$_descriptor4, $3a685266b2733ecc$var$_descriptor5, $3a685266b2733ecc$var$_descriptor6;
function $3a685266b2733ecc$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $3a685266b2733ecc$var$_defineProperty(e, r, t) {
    return (r = $3a685266b2733ecc$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $3a685266b2733ecc$var$_toPropertyKey(t) {
    var i = $3a685266b2733ecc$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $3a685266b2733ecc$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $3a685266b2733ecc$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $3a685266b2733ecc$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
const $3a685266b2733ecc$var$projectColumns = [
    {
        id: "projectCode",
        label: "Project Code",
        width: 10,
        type: "text",
        editable: (r)=>(0, $8kZ1o.canEditProject)((0, $1BTI2.default).user, r),
        value: (r)=>r.jobNumber,
        onChange: (r)=>(v)=>r.update({
                    jobNumber: v
                })
    },
    {
        id: "projectName",
        label: "Project Name",
        width: 34,
        type: "text",
        editable: (r)=>(0, $8kZ1o.canEditProject)((0, $1BTI2.default).user, r),
        value: (p)=>{
            return p.name;
        },
        onChange: (r)=>(v)=>r.update({
                    name: v
                })
    },
    {
        id: "startDate",
        label: "Start Date",
        width: 11,
        type: "date",
        editable: (r)=>(0, $8kZ1o.canEditProjectDates)((0, $1BTI2.default).user, r),
        permissions: (r)=>(0, $8kZ1o.canViewProjectDates)((0, $1BTI2.default).user, r),
        value: (p)=>p.startDate,
        onChange: (r)=>(v)=>{
                const newData = {
                    startDate: v
                };
                if (r.endDate && r.endDate < v) newData.endDate = v;
                r.scaleDatesAcrossPhases(newData);
            }
    },
    {
        id: "endDate",
        label: "End Date",
        width: 11,
        type: "date",
        editable: (r)=>(0, $8kZ1o.canEditProjectDates)((0, $1BTI2.default).user, r),
        permissions: (r)=>(0, $8kZ1o.canViewProjectDates)((0, $1BTI2.default).user, r),
        value: (p)=>p.endDate,
        onChange: (r)=>(v)=>{
                const newData = {
                    endDate: v
                };
                if (r.startDate && r.startDate > v) newData.startDate = v;
                r.scaleDatesAcrossPhases(newData);
            }
    },
    {
        id: "Duration",
        label: "Duration",
        width: 16,
        type: "duration",
        editable: (r)=>(0, $8kZ1o.canEditProjectDates)((0, $1BTI2.default).user, r),
        permissions: (r)=>(0, $8kZ1o.canViewProjectDates)((0, $1BTI2.default).user, r),
        value: (p)=>{
            return {
                value: p.duration,
                unit: p.durationUnit
            };
        },
        onChange: (r)=>(v)=>{
                if (v.value && v.value !== r.duration) r.scaleDatesAcrossPhases({
                    duration: {
                        ...v,
                        unit: r.durationUnit
                    }
                });
                if (v.unit && v.unit !== r.durationUnit) r.update({
                    durationUnit: v.unit
                });
            }
    },
    {
        id: "fee",
        label: "Fee",
        width: 10,
        type: "currency",
        editable: (r)=>(0, $8kZ1o.canEditProjectFees)((0, $1BTI2.default).user, r),
        permissions: (r)=>(0, $8kZ1o.canViewProjectFees)((0, $1BTI2.default).user, r),
        value: (p)=>p.fee,
        onChange: (r)=>(v)=>{
                v = Number(v) || 0.001;
                r.scaleValueAcrossPhases("fee", v);
                r.phases.filter((ph)=>!(ph !== null && ph !== void 0 && ph.deletedAt) && !(ph !== null && ph !== void 0 && ph.isRootPhase)).forEach((ph)=>ph.updateBudgets("fee"));
            }
    },
    {
        id: "expenseBudget",
        label: "Expense Budget",
        width: 10,
        type: "currency",
        editable: (r)=>(0, $8kZ1o.canEditProjectExpenseBudgets)((0, $1BTI2.default).user, r),
        permissions: (r)=>(0, $8kZ1o.canViewProjectExpenseBudgets)((0, $1BTI2.default).user, r),
        value: (p)=>{
            return p.expenseBudget + (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(p.expenses.filter((e)=>{
                var _e$phase;
                return !e.billable && (!e.phase || ((_e$phase = e.phase) === null || _e$phase === void 0 ? void 0 : _e$phase.isRootPhase));
            }).map((e)=>e.cost));
        },
        onChange: (r)=>(v)=>{
                v = Number(v) || 0.001;
                v -= (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(r.expenses.filter((e)=>{
                    var _e$phase2;
                    return !e.billable && (!e.phase || ((_e$phase2 = e.phase) === null || _e$phase2 === void 0 ? void 0 : _e$phase2.isRootPhase));
                }).map((e)=>e.cost));
                r.scaleValueAcrossPhases("expenseBudget", v);
                r.phases.filter((ph)=>!(ph !== null && ph !== void 0 && ph.deletedAt) && !(ph !== null && ph !== void 0 && ph.isRootPhase)).forEach((ph)=>ph.updateBudgets("expenseBudget"));
            }
    },
    {
        id: "hoursBudget",
        label: "Hours Budget",
        width: 10,
        type: "number",
        editable: (r)=>(0, $8kZ1o.canEditProjectHoursBudgets)((0, $1BTI2.default).user, r),
        onChange: (r)=>(v)=>{
                v = Number(v) || 0.001;
                r.scaleValueAcrossPhases("hoursBudget", v);
                r.phases.filter((ph)=>!(ph !== null && ph !== void 0 && ph.deletedAt) && !(ph !== null && ph !== void 0 && ph.isRootPhase)).forEach((ph)=>ph.updateBudgets("hoursBudget"));
            }
    },
    {
        id: "profit",
        label: "Profit",
        width: 10,
        type: "currency",
        value: (p)=>p.fee - p.expenseBudget - (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(p.expenses.filter((e)=>{
                var _e$phase3;
                return !e.billable && (!e.phase || ((_e$phase3 = e.phase) === null || _e$phase3 === void 0 ? void 0 : _e$phase3.isRootPhase));
            }).map((e)=>e.cost)),
        permissions: (r)=>(0, $8kZ1o.canViewProjectFees)((0, $1BTI2.default).user, r) && (0, $8kZ1o.canViewProjectExpenseBudgets)((0, $1BTI2.default).user, r),
        onChange: (r)=>(v)=>null,
        style: (r)=>{
            if (!r) return {};
            const profit = r.fee - r.expenseBudget - (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(r.expenses.filter((e)=>{
                var _e$phase4;
                return !e.billable && (!e.phase || ((_e$phase4 = e.phase) === null || _e$phase4 === void 0 ? void 0 : _e$phase4.isRootPhase));
            }).map((e)=>e.cost));
            return profit < 0 ? {
                color: "red"
            } : {};
        }
    },
    {
        id: "profitMargin",
        label: "",
        width: 6,
        type: "percent",
        value: (p)=>p.fee ? (p.fee - p.expenseBudget - (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(p.expenses.filter((e)=>{
                var _e$phase5;
                return !e.billable && (!e.phase || ((_e$phase5 = e.phase) === null || _e$phase5 === void 0 ? void 0 : _e$phase5.isRootPhase));
            }).map((e)=>e.cost))) / p.fee : null,
        permissions: (r)=>(0, $8kZ1o.canViewProjectFees)((0, $1BTI2.default).user, r) && (0, $8kZ1o.canViewProjectExpenseBudgets)((0, $1BTI2.default).user, r),
        onChange: (r)=>(v)=>null,
        style: (r)=>{
            if (!r) return {};
            const profit = r.fee - r.expenseBudget - (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(r.expenses.filter((e)=>{
                var _e$phase6;
                return !e.billable && (!e.phase || ((_e$phase6 = e.phase) === null || _e$phase6 === void 0 ? void 0 : _e$phase6.isRootPhase));
            }).map((e)=>e.cost));
            return profit < 0 ? {
                color: "red"
            } : {};
        }
    },
    {
        label: "",
        width: 4,
        type: "text",
        value: (p)=>null,
        onClick: (r)=>(v)=>null
    }
];
const $3a685266b2733ecc$var$phaseColumns = (store)=>[
        {
            id: "phaseCode",
            label: "Phase Code",
            width: (0, $8kZ1o.canEditPhasesAndTasks)((0, $1BTI2.default).user, store.project) ? 9 : 12,
            type: "text",
            editable: (r)=>(0, $8kZ1o.canEditProject)((0, $1BTI2.default).user, r.project),
            value: (p)=>p.jobNumber,
            onChange: (r)=>(v)=>r.update({
                        jobNumber: v
                    })
        },
        {
            id: "phaseName",
            label: "Phase Name",
            width: 29,
            type: "text",
            editable: (r)=>(0, $8kZ1o.canEditProject)((0, $1BTI2.default).user, r.project),
            value: (p)=>p.name,
            onChange: (r)=>(v)=>r.update({
                        name: v
                    })
        },
        {
            id: "startDate",
            label: "Start Date",
            width: 11,
            type: "date",
            editable: (r)=>(0, $8kZ1o.canEditProjectDates)((0, $1BTI2.default).user, r.project),
            permissions: (r)=>(0, $8kZ1o.canViewProjectDates)((0, $1BTI2.default).user, r.project),
            value: (p)=>p.startDate,
            onChange: (r)=>(v)=>{
                    const newData = {
                        startDate: v
                    };
                    if (r.endDate && r.endDate < v) newData.endDate = v;
                    r.update(newData);
                }
        },
        {
            id: "endDate",
            label: "End Date",
            width: 11,
            type: "date",
            editable: (r)=>(0, $8kZ1o.canEditProjectDates)((0, $1BTI2.default).user, r.project),
            permissions: (r)=>(0, $8kZ1o.canViewProjectDates)((0, $1BTI2.default).user, r.project),
            value: (p)=>p.endDate,
            onChange: (r)=>(v)=>{
                    const newData = {
                        endDate: v
                    };
                    if (r.startDate && r.startDate > v) newData.startDate = v;
                    r.update(newData);
                }
        },
        {
            id: "duration",
            label: "Duration",
            width: 16,
            type: "duration",
            editable: (r)=>(0, $8kZ1o.canEditProjectDates)((0, $1BTI2.default).user, r.project),
            permissions: (r)=>(0, $8kZ1o.canViewProjectDates)((0, $1BTI2.default).user, r.project),
            value: (p)=>({
                    value: p.duration,
                    unit: p.durationUnit
                }),
            onChange: (r)=>(v)=>{
                    if (v.value && v.value !== r.duration) r.updateDuration({
                        ...v,
                        unit: r.durationUnit
                    });
                    if (v.unit && v.unit !== r.durationUnit) r.update({
                        durationUnit: v.unit
                    });
                }
        },
        {
            id: "fee",
            label: "Fee",
            width: 10,
            type: "currency",
            editable: (r)=>(0, $8kZ1o.canEditProjectFees)((0, $1BTI2.default).user, r.project),
            permissions: (r)=>(0, $8kZ1o.canViewProjectFees)((0, $1BTI2.default).user, r.project),
            value: (r)=>store.getPhaseFee(r),
            onChange: (r)=>(v)=>{
                    v = Number(v) || 0.001;
                    r.update({
                        fee: v
                    });
                    r.updateBudgets("fee");
                }
        },
        {
            id: "expenseBudget",
            label: "Expense Budget",
            width: 10,
            type: "currency",
            editable: (r)=>(0, $8kZ1o.canEditProjectExpenseBudgets)((0, $1BTI2.default).user, r.project),
            permissions: (r)=>(0, $8kZ1o.canViewProjectExpenseBudgets)((0, $1BTI2.default).user, r.project),
            value: (r)=>store.getPhaseExpenseBudget(r),
            onChange: (r)=>(v)=>{
                    v = Number(v) || 0.001;
                    r.update({
                        expenseBudget: v
                    });
                    r.updateBudgets("expenseBudget");
                }
        },
        {
            id: "hoursBudget",
            label: "Hours Budget",
            width: 10,
            type: "number",
            editable: (r)=>(0, $8kZ1o.canEditProjectHoursBudgets)((0, $1BTI2.default).user, r.project),
            value: (r)=>store.getPhaseHoursBudget(r),
            onChange: (r)=>(v)=>{
                    v = Number(v) || 0.001;
                    r.update({
                        hoursBudget: v
                    });
                    r.updateBudgets("hoursBudget");
                }
        },
        {
            id: "profit",
            label: "Profit",
            width: 10,
            type: "currency",
            value: (p)=>p.fee - p.expenseBudget,
            permissions: (r)=>(0, $8kZ1o.canViewProjectFees)((0, $1BTI2.default).user, r.project) && (0, $8kZ1o.canViewProjectExpenseBudgets)((0, $1BTI2.default).user, r.project),
            onChange: (r)=>(v)=>null,
            style: (r)=>{
                if (!r) return {};
                const profit = r.fee - r.expenseBudget;
                return profit < 0 ? {
                    color: "red"
                } : {};
            }
        },
        {
            id: "profitMargin",
            label: "",
            width: 6,
            type: "percent",
            value: (p)=>p.fee ? (p.fee - p.expenseBudget) / p.fee : null,
            permissions: (r)=>(0, $8kZ1o.canViewProjectFees)((0, $1BTI2.default).user, r.project) && (0, $8kZ1o.canViewProjectExpenseBudgets)((0, $1BTI2.default).user, r.project),
            onChange: (r)=>(v)=>null,
            style: (r)=>{
                if (!r) return {};
                const profit = r.fee - r.expenseBudget;
                return profit < 0 ? {
                    color: "red"
                } : {};
            }
        },
        {
            id: "button",
            label: "",
            width: 4,
            type: "button",
            editable: (r)=>(0, $8kZ1o.canEditPhasesAndTasks)((0, $1BTI2.default).user, r.project),
            value: (p)=>(0, $8kZ1o.canEditPhasesAndTasks)((0, $1BTI2.default).user, p.project) ? /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                    className: "fa fa-times",
                    style: {
                        marginRight: 0
                    }
                }) : null,
            onClick: (r)=>()=>{
                    if ((r.mins || 0) <= 0) r.update({
                        deletedAt: new Date()
                    });
                    else (0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $7qENG.default), {
                        phase: r,
                        modalId: "delete-phase"
                    }));
                }
        },
        {
            id: "createdAt",
            label: "Created At",
            width: 18,
            type: "number",
            editable: (r)=>false,
            value: (e)=>Math.round(e.initiatedAt.getTime() / 10),
            visible: false
        }
    ];
const $3a685266b2733ecc$var$expenseColumns = ()=>[
        ...(0, $8kZ1o.canViewExpenseTracking)() ? [
            {
                label: "",
                width: 3,
                type: "text",
                value: (r)=>"",
                onChange: (r)=>(v)=>null,
                component: (props)=>null
            }
        ] : [],
        {
            id: "name",
            label: "Name",
            width: (0, $8kZ1o.canViewExpenseTracking)() ? 41 : 48,
            type: "text",
            editable: (r)=>(0, $8kZ1o.canEditProjectExpenses)((0, $1BTI2.default).user, r.project),
            value: (e)=>e.name,
            onChange: (r)=>(v)=>r.update({
                        name: v
                    })
        },
        ...(0, $8kZ1o.canViewExpenseTracking)() ? [
            {
                id: "supplier",
                label: "Supplier",
                width: 29,
                type: "supplier",
                editable: (r)=>(0, $8kZ1o.canEditSuppliers)((0, $1BTI2.default).user),
                value: (e)=>{
                    return e.supplier;
                },
                onChange: (r)=>(v)=>{
                        r.update({
                            supplierId: v.id
                        });
                    },
                component: ({ value: value, onChange: onChange, stores: stores, editable: editable })=>{
                    return editable ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.SupplierSelector), {
                        selectedSupplier: value,
                        onChange: onChange,
                        nullable: true,
                        variant: "secondary"
                    }) : (value === null || value === void 0 ? void 0 : value.name) || "No Supplier";
                }
            },
            {
                label: "",
                width: 19,
                type: "text",
                value: (r)=>"",
                onChange: (r)=>(v)=>null,
                component: (props)=>null
            }
        ] : [
            {
                id: "phase",
                label: "Phase",
                width: (0, $8kZ1o.canViewExpenseTracking)() ? 20 : 28,
                type: "phase",
                editable: (r)=>(0, $8kZ1o.canEditProjectExpenses)((0, $1BTI2.default).user, r.project),
                value: (e)=>{
                    return e.phase;
                },
                onChange: (r)=>(v)=>{
                        r.update({
                            phaseId: v.id
                        });
                    },
                component: ({ value: value, onChange: onChange, stores: stores, editable: editable })=>{
                    const project = stores.row.rowObject.project;
                    return editable && project ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.PhaseSelector), {
                        options: project.phases,
                        selectedPhase: value,
                        onChange: onChange,
                        variant: "secondary",
                        className: "!border-none !bg-transparent [&_span]:!text-xs !shadow-[inset_6px_6px_13px_-10px_rgba(0,0,0,0.22)] !h-full !rounded-none"
                    }) : (value === null || value === void 0 ? void 0 : value.title) || "No Phase";
                }
            }
        ],
        {
            id: "phaseStartDate",
            label: "Start Date",
            visible: false,
            type: "date",
            value: (e)=>e.startDate || e.phase.startDate
        },
        ...!(0, $8kZ1o.canViewExpenseTracking)() ? [
            {
                id: "startDate",
                label: "Start Date",
                width: 12,
                type: "date",
                editable: (r)=>(0, $8kZ1o.canEditProjectExpenses)((0, $1BTI2.default).user, r.project),
                value: (e)=>e.startDate,
                onChange: (r)=>(v)=>r.update({
                            startDate: v
                        })
            },
            {
                id: "endDate",
                label: "End Date",
                width: 12,
                type: "date",
                editable: (r)=>(0, $8kZ1o.canEditProjectExpenses)((0, $1BTI2.default).user, r.project),
                value: (e)=>e.endDate,
                onChange: (r)=>(v)=>r.update({
                            endDate: v
                        })
            }
        ] : [],
        {
            id: "cost",
            label: "Cost",
            width: (0, $8kZ1o.canViewExpenseTracking)() ? 20 : 12,
            type: "currency",
            editable: (r)=>(0, $8kZ1o.canEditProjectExpenses)((0, $1BTI2.default).user, r.project),
            value: (e)=>e.cost || e.quantity * e.unitCost,
            onChange: (r)=>(v)=>{
                    r.update({
                        cost: v
                    });
                    if (r.phase && r.phase.expenseBudgetLinked) r.phase.updateFromBudgets();
                }
        },
        {
            id: "billable",
            label: "Billable",
            width: 8,
            type: "checkbox",
            editable: (r)=>(0, $8kZ1o.canEditProjectExpenses)((0, $1BTI2.default).user, r.project),
            value: (e)=>e.billable,
            onChange: (r)=>(v)=>{
                    r.update({
                        billable: v
                    });
                    if (r.phase && r.phase.expenseBudgetLinked) r.phase.updateFromBudgets();
                }
        },
        {
            id: "invoiced",
            label: "Invoiced",
            width: 8,
            type: "checkbox",
            editable: (r)=>r.billable && r.cost && r.remainingCost > 0 && (0, $8kZ1o.canEditProjectExpenses)((0, $1BTI2.default).user, r.project),
            value: (e)=>e.beenInvoiced || e.billable && e.cost && e.remainingCost <= 0,
            onChange: (r)=>(v)=>r.update({
                        beenInvoiced: v
                    })
        },
        {
            id: "button",
            label: "",
            width: 4,
            type: "button",
            editable: (r)=>(0, $8kZ1o.canEditProjectExpenses)((0, $1BTI2.default).user, r.project),
            permissions: (r)=>(0, $8kZ1o.canEditProjectExpenses)((0, $1BTI2.default).user, r.project),
            value: (p)=>/*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                    className: "fa fa-times",
                    style: {
                        marginRight: 0
                    }
                }),
            onClick: (r)=>()=>{
                    r.update({
                        deletedAt: new Date()
                    });
                }
        },
        {
            id: "createdAt",
            label: "Created At",
            width: 18,
            type: "number",
            editable: (r)=>false,
            value: (e)=>(e.createdAt || e.initiatedAt).getTime(),
            visible: false
        }
    ];
const $3a685266b2733ecc$var$phaseBudgetColumns = (store)=>[
        {
            label: "",
            width: 3,
            type: "text",
            value: (r)=>"",
            onChange: (r)=>(v)=>null,
            component: (props)=>null
        },
        {
            id: "staffOrRole",
            label: "Staff Member / Role",
            width: 41,
            type: "staffOrRole",
            editable: (r)=>r instanceof (0, $aSdwE.default) && (0, $8kZ1o.canEditProjectStaffBudgets)((0, $1BTI2.default).user, r.project),
            value: (r)=>r.resource,
            onChange: (r)=>(v)=>{
                    if (v.modelType === "staff") r.update({
                        staffId: v.id,
                        roleId: null
                    });
                    else if (v.modelType === "role") r.update({
                        roleId: v.id,
                        staffId: null
                    });
                },
            component: (props)=>{
                const isBudget = props.stores.row.rowObject instanceof (0, $aSdwE.default);
                if (isBudget) return (0, $49KZT.default).staffOrRole(props);
                else return null;
            }
        },
        {
            label: "",
            width: 38,
            type: "text",
            value: (r)=>"",
            onChange: (r)=>(v)=>null,
            component: (props)=>{
                const isBudget = props.stores.row.rowObject instanceof (0, $aSdwE.default);
                if (isBudget) return null;
                else return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    style: {
                        textAlign: "right",
                        width: "100%"
                    },
                    children: "Totals"
                });
            }
        },
        {
            id: "chargeOut",
            label: "Charge Out",
            width: 10,
            type: "currency",
            editable: (r)=>r instanceof (0, $aSdwE.default) && (0, $8kZ1o.canEditProjectStaffBudgets)((0, $1BTI2.default).user, r.project) && (0, $8kZ1o.canViewStaffChargeOutRate)((0, $1BTI2.default).user),
            permissions: (r)=>(0, $8kZ1o.canViewStaffChargeOutRate)((0, $1BTI2.default).user),
            value: (r)=>store.getBudgetChargeOut(r),
            onChange: (r)=>(v)=>{
                    v = Number(v);
                    v = isFinite(v) ? v : 0;
                    r.rateValueToHours(v, "chargeOut");
                    r.phase.updateFromBudgets();
                }
        },
        {
            id: "expense",
            label: "Expense",
            width: 10,
            type: "currency",
            editable: (r)=>r instanceof (0, $aSdwE.default) && (0, $8kZ1o.canEditProjectStaffBudgets)((0, $1BTI2.default).user, r.project) && (0, $8kZ1o.canViewStaffCostRate)((0, $1BTI2.default).user),
            permissions: (r)=>(0, $8kZ1o.canViewStaffCostRate)((0, $1BTI2.default).user),
            value: (r)=>store.getBudgetCost(r),
            onChange: (r)=>(v)=>{
                    v = Number(v);
                    v = isFinite(v) ? v : 0;
                    r.rateValueToHours(v, "cost");
                    r.phase.updateFromBudgets();
                }
        },
        {
            id: "hours",
            label: "Hours",
            width: 10,
            type: "number",
            editable: (r)=>{
                return r instanceof (0, $aSdwE.default) && (0, $8kZ1o.canEditProjectStaffBudgets)((0, $1BTI2.default).user, r.project);
            },
            value: (r)=>store.getBudgetHours(r),
            onChange: (r)=>(v)=>{
                    v = Number(v);
                    v = isFinite(v) ? v : 0;
                    r.update({
                        hours: v
                    });
                    r.phase.updateFromBudgets();
                }
        },
        {
            label: "",
            width: 16,
            type: "text",
            value: (r)=>"",
            onChange: (r)=>(v)=>null,
            component: (props)=>null
        },
        {
            label: "",
            width: 4,
            type: "button",
            editable: (r)=>true,
            permissions: (r)=>(0, $8kZ1o.canEditProjectStaffBudgets)((0, $1BTI2.default).user, r),
            value: (p)=>/*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                    className: "fa fa-times",
                    style: {
                        marginRight: 0
                    }
                }),
            onClick: (r)=>()=>{
                    r.update({
                        deletedAt: new Date()
                    });
                },
            component: (props)=>{
                const isBudget = props.stores.row.rowObject instanceof (0, $aSdwE.default);
                if (isBudget) return (0, $49KZT.default).button(props);
                else return null;
            }
        },
        {
            id: "createdAt",
            label: "Created At",
            width: 18,
            type: "number",
            editable: (r)=>false,
            value: (e)=>(e.createdAt || e.initiatedAt).getTime(),
            visible: false
        }
    ];
const $3a685266b2733ecc$var$phaseBudgetLinkColumns = (store)=>[
        {
            label: "",
            width: 82,
            type: "text",
            value: (r)=>"",
            onChange: (r)=>(v)=>null
        },
        {
            id: "linkChargeOut",
            label: "Charge Out",
            width: 10,
            type: "phase",
            value: (r)=>r,
            component: ({ value: value, group: group, stores: stores })=>{
                return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    style: {
                        height: "2em",
                        paddingLeft: "3em",
                        fontSize: "0.9em"
                    },
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)($3a685266b2733ecc$var$VerticalLink, {
                        editable: (0, $8kZ1o.canEditProjectFees)((0, $1BTI2.default).user, value.project) && (0, $8kZ1o.canEditProjectStaffBudgets)((0, $1BTI2.default).user, value.project),
                        linked: value.feeLinked,
                        onOverUp: ()=>store.setFeeLinkDirection("up", value),
                        onOverDown: ()=>store.setFeeLinkDirection("down", value),
                        onOut: ()=>store.setFeeLinkDirection(null, null),
                        onLinkUp: ()=>{
                            value.update({
                                feeLinked: true
                            });
                            value.updateBudgets("fee");
                        },
                        onLinkDown: ()=>{
                            value.update({
                                feeLinked: true
                            });
                            value.updateFromBudgets();
                        },
                        onUnlink: ()=>value.update({
                                feeLinked: false
                            })
                    })
                });
            }
        },
        {
            id: "linkExpense",
            label: "Expense",
            width: 10,
            type: "phase",
            value: (r)=>r,
            component: ({ value: value, group: group, stores: stores })=>{
                return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    style: {
                        height: "2em",
                        paddingLeft: "3em",
                        fontSize: "0.9em"
                    },
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)($3a685266b2733ecc$var$VerticalLink, {
                        editable: (0, $8kZ1o.canEditProjectExpenses)((0, $1BTI2.default).user, value.project) && (0, $8kZ1o.canEditProjectStaffBudgets)((0, $1BTI2.default).user, value.project),
                        linked: value.expenseBudgetLinked,
                        onOverUp: ()=>store.setExpenseLinkDirection("up", value),
                        onOverDown: ()=>store.setExpenseLinkDirection("down", value),
                        onOut: ()=>store.setExpenseLinkDirection(null, null),
                        onLinkUp: ()=>{
                            value.update({
                                expenseBudgetLinked: true
                            });
                            value.updateBudgets("expenseBudget");
                        },
                        onLinkDown: ()=>{
                            value.update({
                                expenseBudgetLinked: true
                            });
                            value.updateFromBudgets();
                        },
                        onUnlink: ()=>value.update({
                                expenseBudgetLinked: false
                            })
                    })
                });
            }
        },
        {
            id: "linkHours",
            label: "Hours",
            width: 10,
            type: "phase",
            value: (r)=>r,
            component: ({ value: value, group: group, stores: stores })=>{
                return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    style: {
                        height: "2em",
                        paddingLeft: "3em",
                        fontSize: "0.9em"
                    },
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)($3a685266b2733ecc$var$VerticalLink, {
                        editable: (0, $8kZ1o.canEditProjectHoursBudgets)((0, $1BTI2.default).user, value.project) && (0, $8kZ1o.canEditProjectStaffBudgets)((0, $1BTI2.default).user, value.project),
                        linked: value.hoursBudgetLinked,
                        onOverUp: ()=>store.setHoursLinkDirection("up", value),
                        onOverDown: ()=>store.setHoursLinkDirection("down", value),
                        onOut: ()=>store.setHoursLinkDirection(null, null),
                        onLinkUp: ()=>{
                            value.update({
                                hoursBudgetLinked: true
                            });
                            value.updateBudgets("hoursBudget");
                        },
                        onLinkDown: ()=>{
                            value.update({
                                hoursBudgetLinked: true
                            });
                            value.updateFromBudgets();
                        },
                        onUnlink: ()=>value.update({
                                hoursBudgetLinked: false
                            })
                    })
                });
            }
        },
        {
            label: "",
            width: 20,
            type: "text",
            value: (r)=>"",
            onChange: (r)=>(v)=>null
        }
    ];
const $3a685266b2733ecc$var$phaseBudgetAddColumns = [
    {
        label: "",
        width: 3,
        type: "text",
        value: (r)=>"",
        onChange: (r)=>(v)=>null
    },
    {
        id: "add",
        label: "Add Resource",
        width: 41,
        type: "phase",
        value: (r)=>r,
        component: ({ value: value, group: group, stores: stores })=>/*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                className: "btn btn-default",
                style: {
                    margin: "0 2em",
                    fontSize: "0.9em",
                    padding: "0.3em 3em",
                    backgroundColor: "#fcfcfc"
                },
                onClick: ()=>{
                    const b = (0, $hSUCJ.default).add({
                        projectId: value.projectId,
                        phaseId: value.id
                    }, {
                        trackUpdates: true
                    });
                    b.position = value.budgets.length;
                },
                children: "+ Add Resource"
            })
    },
    {
        label: "",
        width: 88,
        type: "text",
        value: (r)=>"",
        onChange: (r)=>(v)=>null
    }
];
const $3a685266b2733ecc$var$expensesAddColumns = [
    {
        label: "",
        width: 3,
        type: "text",
        value: (r)=>"",
        onChange: (r)=>(v)=>null
    },
    {
        id: "add",
        label: "Add Expense",
        width: 41,
        type: "phase",
        value: (r)=>r,
        component: ({ value: value, group: group, stores: stores })=>{
            return /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                className: "btn btn-default ",
                style: {
                    margin: "0 2em",
                    fontSize: "0.9em",
                    padding: "0.3em 3em",
                    backgroundColor: "#fcfcfc",
                    border: "1px solid #ccc"
                },
                onClick: ()=>{
                    const e = (0, $cfp1m.default).add({
                        projectId: value.projectId,
                        phaseId: value.id,
                        name: ""
                    }, {
                        trackUpdates: true
                    });
                    e.isNew = true;
                    e.position = value.expenses.length;
                },
                children: "+ Add Expense"
            });
        }
    },
    {
        label: "",
        width: 88,
        type: "text",
        value: (r)=>"",
        onChange: (r)=>(v)=>null
    }
];
let $3a685266b2733ecc$var$ProjectDetailsStore = ($3a685266b2733ecc$var$_dec = (0, $4JcCM.action).bound, $3a685266b2733ecc$var$_dec2 = (0, $4JcCM.action).bound, $3a685266b2733ecc$var$_dec3 = (0, $4JcCM.action).bound, $3a685266b2733ecc$var$_class = class ProjectDetailsStore {
    constructor(){
        $3a685266b2733ecc$var$_initializerDefineProperty(this, "feeLinkDirection", $3a685266b2733ecc$var$_descriptor, this);
        $3a685266b2733ecc$var$_initializerDefineProperty(this, "expenseLinkDirection", $3a685266b2733ecc$var$_descriptor2, this);
        $3a685266b2733ecc$var$_initializerDefineProperty(this, "hoursLinkDirection", $3a685266b2733ecc$var$_descriptor3, this);
        $3a685266b2733ecc$var$_initializerDefineProperty(this, "feeLinkPhase", $3a685266b2733ecc$var$_descriptor4, this);
        $3a685266b2733ecc$var$_initializerDefineProperty(this, "expenseLinkPhase", $3a685266b2733ecc$var$_descriptor5, this);
        $3a685266b2733ecc$var$_initializerDefineProperty(this, "hoursLinkPhase", $3a685266b2733ecc$var$_descriptor6, this);
        (0, $4JcCM.makeObservable)(this);
    }
    setFeeLinkDirection(d, phase) {
        this.feeLinkDirection = d;
        this.feeLinkPhase = phase;
    }
    setExpenseLinkDirection(d, phase) {
        this.expenseLinkDirection = d;
        this.expenseLinkPhase = phase;
    }
    setHoursLinkDirection(d, phase) {
        this.hoursLinkDirection = d;
        this.hoursLinkPhase = phase;
    }
    getPhaseFee(phase) {
        if (this.feeLinkPhase !== phase || this.feeLinkDirection === "up") return phase.fee;
        else return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(phase.budgets.map((b)=>b.chargeOut));
    }
    getPhaseExpenseBudget(phase) {
        if (this.expenseLinkPhase !== phase || this.expenseLinkDirection === "up") return phase.expenseBudget;
        else return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(phase.budgets.map((b)=>b.cost)) + (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(phase.expenses.filter((e)=>!e.billable).map((e)=>e.cost));
    }
    getPhaseHoursBudget(phase) {
        if (this.hoursLinkPhase !== phase || this.hoursLinkDirection === "up") return phase.hoursBudget;
        else return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(phase.budgets.map((b)=>b.hours));
    }
    get adjustBudgets() {
        return [
            this.feeLinkDirection,
            this.expenseLinkDirection,
            this.hoursLinkDirection
        ].includes("up");
    }
    getBudgetRatio(budget) {
        const phase = budget.phase;
        if (this.feeLinkDirection && this.feeLinkPhase === phase) return phase.fee / ((0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(phase.budgets.map((b)=>b.chargeOut)) || (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(phase.budgets.map((b)=>b.chargeOutRate)));
        else if (this.expenseLinkDirection && this.expenseLinkPhase === phase) return (phase.expenseBudget - (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(phase.expenses.filter((e)=>!e.billable).map((e)=>e.cost))) / ((0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(phase.budgets.map((b)=>b.cost)) || (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(phase.budgets.map((b)=>b.costRate)));
        else if (this.hoursLinkDirection && this.hoursLinkPhase === phase) return phase.hoursBudget / ((0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(phase.budgets.map((b)=>b.hours)) || phase.budgets.length);
        else return 1;
    }
    getBudgetChargeOut(budget) {
        if (!this.adjustBudgets) return budget.chargeOut;
        else return this.getBudgetRatio(budget) * (budget.chargeOut || budget.chargeOutRate);
    }
    getBudgetCost(budget) {
        if (!this.adjustBudgets) return budget.cost;
        else return this.getBudgetRatio(budget) * (budget.cost || budget.costRate);
    }
    getBudgetHours(budget) {
        if (!this.adjustBudgets) return budget.hours;
        else return this.getBudgetRatio(budget) * (budget.hours || 1);
    }
}, $3a685266b2733ecc$var$_descriptor = $3a685266b2733ecc$var$_applyDecoratedDescriptor($3a685266b2733ecc$var$_class.prototype, "feeLinkDirection", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $3a685266b2733ecc$var$_descriptor2 = $3a685266b2733ecc$var$_applyDecoratedDescriptor($3a685266b2733ecc$var$_class.prototype, "expenseLinkDirection", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $3a685266b2733ecc$var$_descriptor3 = $3a685266b2733ecc$var$_applyDecoratedDescriptor($3a685266b2733ecc$var$_class.prototype, "hoursLinkDirection", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $3a685266b2733ecc$var$_descriptor4 = $3a685266b2733ecc$var$_applyDecoratedDescriptor($3a685266b2733ecc$var$_class.prototype, "feeLinkPhase", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $3a685266b2733ecc$var$_descriptor5 = $3a685266b2733ecc$var$_applyDecoratedDescriptor($3a685266b2733ecc$var$_class.prototype, "expenseLinkPhase", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $3a685266b2733ecc$var$_descriptor6 = $3a685266b2733ecc$var$_applyDecoratedDescriptor($3a685266b2733ecc$var$_class.prototype, "hoursLinkPhase", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $3a685266b2733ecc$var$_applyDecoratedDescriptor($3a685266b2733ecc$var$_class.prototype, "setFeeLinkDirection", [
    $3a685266b2733ecc$var$_dec
], Object.getOwnPropertyDescriptor($3a685266b2733ecc$var$_class.prototype, "setFeeLinkDirection"), $3a685266b2733ecc$var$_class.prototype), $3a685266b2733ecc$var$_applyDecoratedDescriptor($3a685266b2733ecc$var$_class.prototype, "setExpenseLinkDirection", [
    $3a685266b2733ecc$var$_dec2
], Object.getOwnPropertyDescriptor($3a685266b2733ecc$var$_class.prototype, "setExpenseLinkDirection"), $3a685266b2733ecc$var$_class.prototype), $3a685266b2733ecc$var$_applyDecoratedDescriptor($3a685266b2733ecc$var$_class.prototype, "setHoursLinkDirection", [
    $3a685266b2733ecc$var$_dec3
], Object.getOwnPropertyDescriptor($3a685266b2733ecc$var$_class.prototype, "setHoursLinkDirection"), $3a685266b2733ecc$var$_class.prototype), $3a685266b2733ecc$var$_applyDecoratedDescriptor($3a685266b2733ecc$var$_class.prototype, "adjustBudgets", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($3a685266b2733ecc$var$_class.prototype, "adjustBudgets"), $3a685266b2733ecc$var$_class.prototype), $3a685266b2733ecc$var$_class);
var $3a685266b2733ecc$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ id: id })=>{
    var _project$phases, _project$phases$filte;
    const [store, setStore] = (0, $jbmdS.useState)(new $3a685266b2733ecc$var$ProjectDetailsStore());
    const project = (0, $gJT7h.default).projectsById[id];
    const [projectExpenses, setProjectExpenses] = (0, $jbmdS.useState)([
        ...(project === null || project === void 0 ? void 0 : project.expenses.sort((a, b)=>{
            var _a$phase, _b$phase, _ref, _ref$localeCompare;
            // Sort by e.startDate
            const startDateComparison = (a === null || a === void 0 ? void 0 : a.startDate) - (b === null || b === void 0 ? void 0 : b.startDate);
            if (startDateComparison !== 0) return startDateComparison;
            // If startDate is the same, sort by e.phase.startDate
            const phaseStartDateComparison = (a === null || a === void 0 ? void 0 : (_a$phase = a.phase) === null || _a$phase === void 0 ? void 0 : _a$phase.startDate) - (b === null || b === void 0 ? void 0 : (_b$phase = b.phase) === null || _b$phase === void 0 ? void 0 : _b$phase.startDate);
            if (phaseStartDateComparison !== 0) return phaseStartDateComparison;
            // If both startDate and phase.startDate are the same, sort by e.name
            return (_ref = a.name || "") === null || _ref === void 0 ? void 0 : (_ref$localeCompare = _ref.localeCompare) === null || _ref$localeCompare === void 0 ? void 0 : _ref$localeCompare.call(_ref, b.name || "");
        })) || []
    ]);
    (0, $jbmdS.useEffect)(()=>{
        var _project$expenses;
        setProjectExpenses([
            ...(project === null || project === void 0 ? void 0 : (_project$expenses = project.expenses) === null || _project$expenses === void 0 ? void 0 : _project$expenses.sort((a, b)=>{
                var _a$phase2, _b$phase2, _ref2, _ref2$localeCompare;
                // Sort by e.startDate
                const startDateComparison = (a === null || a === void 0 ? void 0 : a.startDate) - (b === null || b === void 0 ? void 0 : b.startDate);
                if (startDateComparison !== 0) return startDateComparison;
                // If startDate is the same, sort by e.phase.startDate
                const phaseStartDateComparison = (a === null || a === void 0 ? void 0 : (_a$phase2 = a.phase) === null || _a$phase2 === void 0 ? void 0 : _a$phase2.startDate) - (b === null || b === void 0 ? void 0 : (_b$phase2 = b.phase) === null || _b$phase2 === void 0 ? void 0 : _b$phase2.startDate);
                if (phaseStartDateComparison !== 0) return phaseStartDateComparison;
                // If both startDate and phase.startDate are the same, sort by e.name
                return (_ref2 = a.name || "") === null || _ref2 === void 0 ? void 0 : (_ref2$localeCompare = _ref2.localeCompare) === null || _ref2$localeCompare === void 0 ? void 0 : _ref2$localeCompare.call(_ref2, b.name || "");
            })) || []
        ]);
    }, [
        project === null || project === void 0 ? void 0 : project.id
    ]);
    const [projectPhases, setProjectPhases] = (0, $jbmdS.useState)([
        ...(project === null || project === void 0 ? void 0 : (_project$phases = project.phases) === null || _project$phases === void 0 ? void 0 : (_project$phases$filte = _project$phases.filter((ph)=>!(ph !== null && ph !== void 0 && ph.isRootPhase))) === null || _project$phases$filte === void 0 ? void 0 : _project$phases$filte.sort((0, $6fNfM.default))) || []
    ]);
    (0, $jbmdS.useEffect)(()=>{
        var _project$phases2, _project$phases2$filt;
        setProjectPhases([
            ...(project === null || project === void 0 ? void 0 : (_project$phases2 = project.phases) === null || _project$phases2 === void 0 ? void 0 : (_project$phases2$filt = _project$phases2.filter((ph)=>!(ph !== null && ph !== void 0 && ph.isRootPhase))) === null || _project$phases2$filt === void 0 ? void 0 : _project$phases2$filt.sort((0, $6fNfM.default))) || []
        ]);
    }, [
        project === null || project === void 0 ? void 0 : project.id
    ]);
    const handlePhaseReorder = (sourceIndex, destinationIndex)=>{
        const items = Array.from(projectPhases);
        const [reorderedItem] = items.splice(sourceIndex, 1);
        items.splice(destinationIndex, 0, reorderedItem);
        // Update positions for all phases
        items.forEach((phase, index)=>{
            phase.update({
                position: index
            });
        });
        setProjectPhases(items);
    };
    const isAtLeastPM = true;
    const isAtLeastAdmin = true;
    if (!project) return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        children: " Project not Found..."
    });
    if (!(0, $8kZ1o.canViewProjectDetails)((0, $1BTI2.default).user, project)) return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        children: "You don't have permissions to view this project."
    });
    // useEffect(() => {
    //     project.expenses.forEach((pe, i) =>
    //         pe.update({ initiatedAt: new Date(pe.initiatedAt.getTime() + i) })
    //     )
    // }, [])
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "flex justify-between items-end",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("h3", {
                                style: {
                                    fontSize: "2.2em",
                                    display: "inline-block"
                                },
                                children: "Project Details"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                    className: "flex flex-space-between flex-align-items-center",
                                    style: {
                                        margin: "1em"
                                    },
                                    children: [
                                        (0, $8kZ1o.canViewContacts)((0, $1BTI2.default).user) ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                            style: {
                                                display: "inline-block",
                                                margin: "0 1em"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                    style: {
                                                        fontWeight: "bold"
                                                    },
                                                    children: "Client"
                                                }),
                                                (0, $8kZ1o.canEditProject)((0, $1BTI2.default).user, project) ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.ContactSelector), {
                                                    onChange: (contact)=>project.update({
                                                            contactId: contact.id
                                                        }),
                                                    selectedContact: project.contact,
                                                    variant: "secondary"
                                                }) : /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                                    children: project.contact != null ? project.contact.label : "(No contact)"
                                                })
                                            ]
                                        }) : null,
                                        (0, $8kZ1o.canViewPrimaryContact)() ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                            style: {
                                                display: "inline-block",
                                                margin: "0 1em"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                    style: {
                                                        fontWeight: "bold"
                                                    },
                                                    children: "Primary Contact"
                                                }),
                                                (0, $8kZ1o.canEditProject)((0, $1BTI2.default).user, project) ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.ContactSelector), {
                                                    selectedContact: project.primaryContact,
                                                    onChange: (contact)=>project.update({
                                                            primaryContactId: contact.id
                                                        }),
                                                    variant: "secondary"
                                                }) : /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                                    children: project.invoiceContact != null ? project.invoiceContact.displayName : "(No contact)"
                                                })
                                            ]
                                        }) : null,
                                        (0, $8kZ1o.canViewCostCentres)((0, $1BTI2.default).user) ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                            style: {
                                                display: "inline-block",
                                                margin: "0 1em"
                                            },
                                            className: "project-form__cost-centre-select",
                                            children: [
                                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                    style: {
                                                        fontWeight: "bold"
                                                    },
                                                    children: "Cost Centre"
                                                }),
                                                (0, $8kZ1o.canEditProject)((0, $1BTI2.default).user, project) ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.CostCentreSelector), {
                                                    selectedCostCentre: project.costCentre,
                                                    onChange: (costCentre)=>project.update({
                                                            costCentreId: costCentre.id
                                                        }),
                                                    isEditable: isAtLeastAdmin,
                                                    dropLeft: true,
                                                    variant: "secondary"
                                                }) : /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                                    children: project.costCentre != null ? project.costCentre.name : "(No Cost Centre)"
                                                })
                                            ]
                                        }) : null,
                                        (0, $8kZ1o.canViewRevenueTargets)((0, $1BTI2.default).user, project) ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                            style: {
                                                display: "inline-block",
                                                margin: "0 1em"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                    style: {
                                                        fontWeight: "bold"
                                                    },
                                                    children: "Bill on"
                                                }),
                                                (0, $8kZ1o.canEditRevenueTargets)((0, $1BTI2.default).user, project) ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                                                    isEditable: isAtLeastAdmin,
                                                    options: [
                                                        {
                                                            label: "End of Each Month",
                                                            value: "monthly"
                                                        },
                                                        {
                                                            label: "End of Phase",
                                                            value: "manual"
                                                        }
                                                    ],
                                                    value: project.milestoneType,
                                                    onChange: (milestoneType)=>project.update({
                                                            milestoneType: milestoneType
                                                        }),
                                                    dropLeft: true,
                                                    variant: "secondary"
                                                }) : /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                                    children: {
                                                        monthly: "End of Each Month",
                                                        manual: "End of Phase"
                                                    }[project.milestoneType]
                                                })
                                            ]
                                        }) : null,
                                        /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                            style: {
                                                display: "inline-block",
                                                margin: "0 1em"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                                    style: {
                                                        fontWeight: "bold"
                                                    },
                                                    children: "Owner"
                                                }),
                                                (0, $8kZ1o.canEditProject)((0, $1BTI2.default).user, project) ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.StaffSelector), {
                                                    selectedStaffMember: project.owner,
                                                    onChange: (staffMember)=>project.update({
                                                            ownerId: staffMember.id
                                                        }),
                                                    placeholderLabel: "Select Project Owner...",
                                                    dropLeft: true,
                                                    variant: "secondary"
                                                }) : /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                                    children: project.owner != null ? project.owner.fullName : "(No Owner)"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
                        id: "project",
                        showHeader: true,
                        columns: $3a685266b2733ecc$var$projectColumns,
                        rows: [
                            project
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("h4", {
                        style: {
                            fontSize: "1.8em",
                            margin: "1em 0 0.5em 0.5em",
                            display: "inline-block"
                        },
                        children: "Phases"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
                        id: "project-phases",
                        showHeader: true,
                        columns: $3a685266b2733ecc$var$phaseColumns(store),
                        rows: projectPhases.filter((ph)=>!ph.deletedAt),
                        getChildComponent: (r)=>(0, $8kZ1o.canViewExpenseTracking)() ? /*#__PURE__*/ (0, $61Ea1.jsx)($3a685266b2733ecc$var$PhaseDetails, {
                                phase: r,
                                store: store
                            }) : /*#__PURE__*/ (0, $61Ea1.jsx)($3a685266b2733ecc$var$PhaseBudgets, {
                                phase: r,
                                store: store
                            }),
                        draggable: (0, $8kZ1o.canEditPhasesAndTasks)((0, $1BTI2.default).user, project),
                        onReorder: handlePhaseReorder
                    }),
                    (0, $8kZ1o.canEditPhasesAndTasks)((0, $1BTI2.default).user, project) ? /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                        className: "btn btn-default plus-btn",
                        style: {
                            marginTop: "2em",
                            border: "1px solid #ccc"
                        },
                        onClick: ()=>{
                            const ph = (0, $XoImS.default).createPhase(project.id);
                            ph.isNew = true;
                            setProjectPhases([
                                ...projectPhases,
                                ph
                            ]);
                        },
                        children: "+ Add Phase"
                    }) : null
                ]
            }),
            (0, $8kZ1o.canViewProjectExpenses)((0, $1BTI2.default).user, project) ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("h4", {
                        style: {
                            fontSize: "1.8em",
                            margin: "1em 0 0.5em 0.5em",
                            display: "inline-block"
                        },
                        children: (0, $8kZ1o.canViewExpenseTracking)() ? "General Expenses" : "Expenses"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
                        id: "expenses",
                        showHeader: true,
                        columns: $3a685266b2733ecc$var$expenseColumns(),
                        rows: projectExpenses.filter((e)=>{
                            var _e$phase7;
                            return !e.deletedAt && (!(0, $8kZ1o.canViewExpenseTracking)() || !e.phaseId || ((_e$phase7 = e.phase) === null || _e$phase7 === void 0 ? void 0 : _e$phase7.isRootPhase) || e.phaseId === project.rootPhase.id);
                        })
                    }),
                    (0, $8kZ1o.canEditProjectExpenses)((0, $1BTI2.default).user, project) ? /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                        className: "btn btn-default plus-btn",
                        style: {
                            marginTop: "2em",
                            border: "1px solid #ccc"
                        },
                        onClick: ()=>{
                            const e = (0, $cfp1m.default).add({
                                projectId: project.id,
                                phaseId: project.rootPhase.id,
                                name: ""
                            }, {
                                trackUpdates: true
                            });
                            e.isNew = true;
                            setProjectExpenses([
                                ...projectExpenses,
                                e
                            ]);
                        },
                        children: "+ Add Expense"
                    }) : null
                ]
            }) : null
        ]
    });
});
const $3a685266b2733ecc$var$PhaseBudgets = (0, $1EEMt.observer)(({ phase: phase, store: store })=>{
    const project = phase.project;
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            (0, $8kZ1o.canEditProjectStaffBudgets)((0, $1BTI2.default).user, project) ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
                id: "budget-links",
                showHeader: false,
                columns: $3a685266b2733ecc$var$phaseBudgetLinkColumns(store),
                rows: [
                    phase
                ],
                className: "coincraft-table-sub-section",
                style: {
                    borderBottom: "none",
                    backgroundColor: "#f7f7f7"
                }
            }) : null,
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
                id: "budgets",
                showHeader: true,
                columns: $3a685266b2733ecc$var$phaseBudgetColumns(store),
                rows: phase.budgets.sort((a, b)=>{
                    if (a.resource && b.resource) {
                        var _ref3, _ref3$localeCompare, _a$resource, _a$resource2, _b$resource, _b$resource2;
                        return (_ref3 = ((_a$resource = a.resource) === null || _a$resource === void 0 ? void 0 : _a$resource.fullName) || (a === null || a === void 0 ? void 0 : (_a$resource2 = a.resource) === null || _a$resource2 === void 0 ? void 0 : _a$resource2.name) || "") === null || _ref3 === void 0 ? void 0 : (_ref3$localeCompare = _ref3.localeCompare) === null || _ref3$localeCompare === void 0 ? void 0 : _ref3$localeCompare.call(_ref3, ((_b$resource = b.resource) === null || _b$resource === void 0 ? void 0 : _b$resource.fullName) || ((_b$resource2 = b.resource) === null || _b$resource2 === void 0 ? void 0 : _b$resource2.name) || "");
                    } else return 0;
                }),
                className: "coincraft-table-sub-section",
                style: {
                    boxShadow: "none",
                    border: "solid 1px #ddd",
                    backgroundColor: "#f7f7f7"
                },
                headerStyle: {
                    fontSize: "0.9em",
                    fontWeight: "bold",
                    backgroundColor: "#f7f7f7",
                    borderBottom: "solid 1px #ddd"
                },
                showTotals: true,
                totalsRowStyles: {
                    fontSize: "1.1rem",
                    fontStyle: "italic"
                },
                totalsCellStyles: {
                    padding: "0.5rem"
                }
            }),
            (0, $8kZ1o.canEditProjectStaffBudgets)((0, $1BTI2.default).user, project) ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
                id: "budget-button",
                showHeader: false,
                columns: $3a685266b2733ecc$var$phaseBudgetAddColumns,
                rows: [
                    phase
                ],
                className: "coincraft-table-sub-section",
                style: {
                    borderTop: "none",
                    boxShadow: "none",
                    backgroundColor: "#f7f7f7"
                }
            }) : null
        ]
    });
});
const $3a685266b2733ecc$var$VerticalLink = (0, $1EEMt.observer)(({ onOverUp: onOverUp, onOverDown: onOverDown, onOut: onOut, onLinkUp: onLinkUp, onLinkDown: onLinkDown, onUnlink: onUnlink, linked: linked, editable: editable })=>{
    const target = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useRef(null);
    const isHovering = (0, $1fkTL.default)(target);
    const mouse = (0, $1nRI3.default)(target);
    const hoverPosition = isHovering && mouse.y / mouse.elementHeight < 0.5 ? "up" : "down";
    const [latestHoverCall, setLatestHoverCall] = (0, $jbmdS.useState)(null);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        style: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                ref: target,
                onPointerMove: ()=>{
                    if (!editable) return;
                    if (!linked && hoverPosition === "up" && latestHoverCall !== "up") {
                        onOverUp();
                        setLatestHoverCall("up");
                    } else if (!linked && hoverPosition === "down" && latestHoverCall !== "down") {
                        onOverDown();
                        setLatestHoverCall("down");
                    }
                },
                onPointerLeave: ()=>{
                    if (!editable) return;
                    if (!linked) {
                        onOut();
                        setLatestHoverCall(null);
                    }
                },
                onClick: ()=>{
                    if (!editable) return;
                    if (!linked && hoverPosition === "up") {
                        onLinkUp();
                        setLatestHoverCall(null);
                    } else if (!linked && hoverPosition === "down") {
                        onLinkDown();
                        setLatestHoverCall(null);
                    } else if (linked) onUnlink();
                },
                style: {
                    display: "inline-block",
                    border: linked ? "solid 1px #999" : "solid 1px #ccc",
                    backgroundColor: linked && !isHovering || !linked && isHovering ? "#e2e2e2" : "white",
                    boxShadow: linked || !linked && isHovering ? "rgba(0, 0, 0, 0.2) 1px 1px 1px 0px inset" : "inset rgba(0, 0, 0, 0.2) -0.5px -0.5px 1px 0px"
                },
                children: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                    className: "fa fa-link rotate-45",
                    style: {
                        margin: 0
                    }
                })
            }),
            isHovering ? /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        style: {
                            position: "absolute",
                            left: "2em",
                            top: 0,
                            color: "#666",
                            fontWeight: 600,
                            lineHeight: "1em",
                            width: "5em",
                            fontSize: "0.9em"
                        },
                        children: linked ? "Unlink" : hoverPosition === "up" ? "Link to Phase" : "Link to Resources"
                    }),
                    !linked ? /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        style: {
                            position: "absolute",
                            right: "100%",
                            top: "25%",
                            textAlign: "center",
                            height: "50%",
                            paddingRight: "0.5em",
                            fontSize: "0.9em"
                        },
                        children: hoverPosition === "up" ? /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                            className: "fa fa-chevron-up",
                            style: {
                                margin: 0,
                                display: "block"
                            }
                        }) : /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                            className: "fa fa-chevron-down",
                            style: {
                                margin: 0,
                                display: "block"
                            }
                        })
                    }) : null
                ]
            }) : null
        ]
    });
});
const $3a685266b2733ecc$var$PhaseDetails = (0, $1EEMt.observer)(({ phase: phase, store: store })=>{
    const project = phase.project;
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        style: {
            backgroundColor: "#f7f7f7",
            border: "solid 1px #ddd"
        },
        children: [
            (0, $8kZ1o.canEditProjectStaffBudgets)((0, $1BTI2.default).user, project) ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
                id: "budget-links",
                showHeader: false,
                columns: $3a685266b2733ecc$var$phaseBudgetLinkColumns(store),
                rows: [
                    phase
                ],
                className: "coincraft-table-sub-section",
                style: {
                    borderBottom: "none",
                    backgroundColor: "#f7f7f7"
                }
            }) : null,
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
                id: "budgets",
                showHeader: true,
                columns: $3a685266b2733ecc$var$phaseBudgetColumns(store),
                rows: phase.budgets.sort((a, b)=>{
                    if (a.resource && b.resource) {
                        const aFullName = a.resource.fullName || a.resource.name || "";
                        const bFullName = b.resource.fullName || b.resource.name || "";
                        return aFullName.localeCompare(bFullName);
                    } else return 0;
                }),
                className: "coincraft-table-sub-section",
                sortBy: [
                    [
                        "createdAt",
                        "asc"
                    ]
                ],
                style: {
                    boxShadow: "none",
                    border: "solid 1px #ddd",
                    backgroundColor: "#f7f7f7"
                },
                headerStyle: {
                    fontSize: "0.9em",
                    fontWeight: "bold",
                    backgroundColor: "#f7f7f7",
                    borderBottom: "solid 1px #ddd"
                },
                showTotals: true,
                totalsRowStyles: {
                    fontSize: "1.1rem",
                    fontStyle: "italic"
                },
                totalsCellStyles: {
                    padding: "0.5rem"
                }
            }),
            (0, $8kZ1o.canEditProjectStaffBudgets)((0, $1BTI2.default).user, project) ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
                id: "budget-button",
                showHeader: false,
                columns: $3a685266b2733ecc$var$phaseBudgetAddColumns,
                rows: [
                    phase
                ],
                className: "coincraft-table-sub-section",
                style: {
                    border: "solid 1px #ddd",
                    boxShadow: "none",
                    backgroundColor: "#f7f7f7"
                }
            }) : null,
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
                id: "expenses",
                showHeader: true,
                columns: $3a685266b2733ecc$var$expenseColumns(store),
                rows: phase.expenses,
                className: "coincraft-table-sub-section",
                sortBy: [
                    [
                        "createdAt",
                        "asc"
                    ]
                ],
                style: {
                    boxShadow: "none",
                    border: "solid 1px #ddd",
                    backgroundColor: "#f7f7f7",
                    marginTop: "1.5em",
                    borderTop: "none"
                },
                headerStyle: {
                    fontSize: "0.9em",
                    fontWeight: "bold",
                    backgroundColor: "#f7f7f7",
                    borderBottom: "solid 1px #ddd"
                }
            }),
            (0, $8kZ1o.canEditProjectStaffBudgets)((0, $1BTI2.default).user, project) ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
                id: "budget-button",
                showHeader: false,
                columns: $3a685266b2733ecc$var$expensesAddColumns,
                rows: [
                    phase
                ],
                className: "coincraft-table-sub-section",
                style: {
                    borderTop: "none",
                    boxShadow: "none",
                    backgroundColor: "#f7f7f7"
                }
            }) : null
        ]
    });
});

});
parcelRegister("7qENG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $568a9c318439e86b$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("eat5C");
parcelRequire("jbmdS");

var $fEcKX = parcelRequire("fEcKX");

var $1EEMt = parcelRequire("1EEMt");
var $568a9c318439e86b$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ phase: phase, modalId: modalId })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fEcKX.default), {
        modalId: modalId,
        heading: "Delete Phase",
        onSave: ()=>phase.update({
                deletedAt: new Date()
            }),
        saveLabel: `Delete ${phase.title}`,
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("p", {
            style: {
                padding: "0.5em 1em"
            },
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsx)("b", {
                    children: phase.title
                }),
                " has time recorded against it. Are you sure you want to delete it?"
            ]
        })
    });
});

});


parcelRegister("5AhMR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $410e1caac13d7499$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("lCpBr");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $36Jjh = parcelRequire("36Jjh");

var $gJT7h = parcelRequire("gJT7h");

var $khJQv = parcelRequire("khJQv");

var $dk7t9 = parcelRequire("dk7t9");

var $2QSOV = parcelRequire("2QSOV");

var $hL9C2 = parcelRequire("hL9C2");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $lVFwm = parcelRequire("lVFwm");

var $3X7oM = parcelRequire("3X7oM");
var $410e1caac13d7499$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ extraContent: extraContent, id: id, tabs: tabs, selectedTab: selectedTab })=>{
    const project = (0, $gJT7h.default).projectsById[id];
    if (!project) return null;
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $36Jjh.default), {
        heading: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: (project === null || project === void 0 ? void 0 : project.title) || "New project"
            })
        }),
        rightButtons: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            className: "flex items-center gap-2",
            children: [
                (0, $8kZ1o.canEditProjectFees)((0, $1BTI2.default).user, project) ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3X7oM.default), {
                    label: "% Fee Calculator",
                    onClick: ()=>(0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $lVFwm.default), {
                            project: project,
                            modalId: "projectFeeCalc"
                        }))
                }) : null,
                (0, $8kZ1o.canEditProjectDates)((0, $1BTI2.default).user, project) ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3X7oM.default), {
                    label: "Delay",
                    onClick: ()=>(0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $2QSOV.default), {
                            project: project,
                            modalId: "delayProject"
                        }))
                }) : null,
                (0, $8kZ1o.canCreateProjects)((0, $1BTI2.default).user, project) ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3X7oM.default), {
                    label: "Copy",
                    onClick: ()=>(0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $dk7t9.default), {
                            project: project,
                            modalId: "copyProject"
                        }))
                }) : null,
                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3X7oM.default), {
                    label: "Print",
                    icon: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                        className: "fa fa-print"
                    }),
                    onClick: ()=>window.print()
                }),
                (0, $8kZ1o.canDeleteProject)((0, $1BTI2.default).user, project) ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $3X7oM.default), {
                    label: "Delete",
                    icon: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                        className: "fa fa-trash"
                    }),
                    onClick: ()=>(0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $hL9C2.default), {
                            project: project,
                            modalId: "deleteProject"
                        })),
                    variant: "secondary"
                }) : null
            ]
        }),
        extraContent: extraContent,
        tabs: tabs,
        selectedTab: selectedTab
    });
});

});
parcelRegister("dk7t9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b32efdb89f0d8f2$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("gN0TC");

parcelRequire("f44xu");
parcelRequire("eat5C");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $fEcKX = parcelRequire("fEcKX");
parcelRequire("ewAM3");

var $7GQic = parcelRequire("7GQic");

var $gdEjf = parcelRequire("gdEjf");

var $6Q5sp = parcelRequire("6Q5sp");
const $9b32efdb89f0d8f2$var$copyProject = async ({ project: project, name: name, jobNumber: jobNumber, startDate: startDate })=>{
    const dateDiff = project.startDate && startDate - project.startDate;
    const pr2 = project.clone({
        name: name,
        jobNumber: jobNumber
    }, {
        trackUpdates: true
    });
    project.rates.filter((r)=>!r.phaseId).forEach((r)=>{
        const r2 = r.clone({
            projectId: pr2.id
        }, {
            trackUpdates: true
        });
    });
    project.phases.forEach((ph)=>{
        const ph2 = ph.clone({
            projectId: pr2.id,
            startDate: dateDiff && ph.startDate ? new Date(ph.startDate.getTime() + dateDiff) : ph.startDate,
            endDate: dateDiff && ph.endDate ? new Date(ph.endDate.getTime() + dateDiff) : ph.endDate
        }, {
            trackUpdates: true
        });
        ph.budgets.forEach((phb)=>{
            const phb2 = phb.clone({
                projectId: pr2.id,
                phaseId: ph2.id
            }, {
                trackUpdates: true
            });
        });
        ph.expenses.forEach((phe)=>{
            const phe2 = phe.clone({
                projectId: pr2.id,
                phaseId: ph2.id,
                startDate: dateDiff && phe.startDate ? new Date(phe.startDate.getTime() + dateDiff) : phe.startDate,
                endDate: dateDiff && phe.endDate ? new Date(phe.endDate.getTime() + dateDiff) : phe.endDate
            }, {
                trackUpdates: true
            });
        });
        ph.tasks.forEach((t)=>{
            const t2 = t.clone({
                projectId: pr2.id,
                phaseId: ph2.id
            }, {
                trackUpdates: true
            });
        });
        ph.rates.forEach((r)=>{
            const r2 = r.clone({
                projectId: pr2.id,
                phaseId: ph2.id
            }, {
                trackUpdates: true
            });
        });
    });
    try {
        await (0, $6Q5sp.router).navigate({
            to: `/projects/${pr2.id}`
        });
    } catch (e) {
        console.error(e);
    }
};
var $9b32efdb89f0d8f2$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ project: project, modalId: modalId })=>{
    const [name, setName] = (0, $jbmdS.useState)("New Project");
    const [jobNumber, setJobNumber] = (0, $jbmdS.useState)("");
    const [startDate, setStartDate] = (0, $jbmdS.useState)(new Date());
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fEcKX.default), {
        modalId: modalId,
        heading: "Copy Project",
        onSave: async ()=>await $9b32efdb89f0d8f2$var$copyProject({
                project: project,
                name: name,
                jobNumber: jobNumber,
                startDate: startDate
            }),
        saveLabel: "Copy Project",
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)("p", {
                children: [
                    "You are creating a new project using ",
                    /*#__PURE__*/ (0, $61Ea1.jsx)("em", {
                        children: project.title
                    }),
                    " as a template."
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $gdEjf.FormSection), {
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $gdEjf.FormRow), {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $gdEjf.FormLabel), {
                                    style: {
                                        width: "6em"
                                    },
                                    children: "Job Code:"
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
                                    type: "text",
                                    className: "job-code-input sm-input input-base",
                                    value: jobNumber || "",
                                    onChange: (e)=>setJobNumber(e.target.value),
                                    style: {
                                        width: "7em",
                                        marginRight: "3em"
                                    }
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $gdEjf.FormLabel), {
                                    style: {
                                        width: "8em"
                                    },
                                    children: "Project Name:"
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                    style: {
                                        position: "relative",
                                        display: "inline-block",
                                        width: "17em"
                                    },
                                    children: /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
                                        type: "text",
                                        className: "project-name-input lg-input input-base",
                                        style: {
                                            width: "16em"
                                        },
                                        value: name || "",
                                        onChange: (e)=>setName(e.target.value)
                                    })
                                })
                            ]
                        }),
                        project.startDate ? /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $gdEjf.FormRow), {
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $gdEjf.FormLabel), {
                                    style: {
                                        width: "6em"
                                    },
                                    className: "inline-block",
                                    children: "Start Date:"
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7GQic.default), {
                                    className: "start-date-input",
                                    style: {
                                        width: "16em",
                                        display: "inline-block",
                                        position: "fixed"
                                    },
                                    value: startDate,
                                    onChange: (d)=>setStartDate(d)
                                })
                            ]
                        }) : null
                    ]
                })
            })
        ]
    });
});

});

parcelRegister("2QSOV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $213af64e834daa29$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("gN0TC");

var $4hBm1 = parcelRequire("4hBm1");
parcelRequire("f44xu");
parcelRequire("eat5C");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $fEcKX = parcelRequire("fEcKX");
parcelRequire("ewAM3");

var $52dEm = parcelRequire("52dEm");

var $7GQic = parcelRequire("7GQic");

var $gdEjf = parcelRequire("gdEjf");

var $XoImS = parcelRequire("XoImS");

var $hVjuY = parcelRequire("hVjuY");
const $213af64e834daa29$var$delayProject = ({ fromDate: fromDate, untilDate: untilDate, splitPhases: splitPhases, phases: phases })=>{
    fromDate = (0, $4hBm1.startOfDay)(fromDate);
    untilDate = (0, $4hBm1.startOfDay)(untilDate);
    const diff = untilDate - fromDate;
    if (!diff) return;
    phases.forEach((ph)=>{
        const startDate = ph.startDate && (0, $4hBm1.startOfDay)(ph.startDate);
        const endDate = ph.endDate && (0, $4hBm1.startOfDay)(ph.endDate);
        if (startDate >= fromDate) {
            var _startDate$getTime, _endDate$getTime;
            startDate && ph.update({
                startDate: new Date(((_startDate$getTime = startDate.getTime) === null || _startDate$getTime === void 0 ? void 0 : _startDate$getTime.call(startDate)) + diff)
            });
            endDate && ph.update({
                endDate: new Date(((_endDate$getTime = endDate.getTime) === null || _endDate$getTime === void 0 ? void 0 : _endDate$getTime.call(endDate)) + diff)
            });
        } else if (endDate >= fromDate) {
            if (splitPhases) {
                var _endDate$getTime2;
                const lengthRatio1 = (fromDate - startDate) / (endDate - startDate);
                const lengthRatio2 = 1 - lengthRatio1;
                const ph2 = (0, $XoImS.default).add({
                    projectId: ph.projectId,
                    name: ph.name + " (delayed)",
                    jobNumber: ph.jobNumber + "_2",
                    startDate: untilDate,
                    endDate: new Date(((_endDate$getTime2 = endDate.getTime) === null || _endDate$getTime2 === void 0 ? void 0 : _endDate$getTime2.call(endDate)) + diff),
                    fee: (0, $hVjuY.logRound)(ph.fee * lengthRatio2),
                    expenseBudget: (0, $hVjuY.logRound)(ph.expenseBudget * lengthRatio2),
                    hoursBudget: (0, $hVjuY.logRound)(ph.hoursBudget * lengthRatio2)
                }, {
                    trackUpdates: true
                });
                ph.update({
                    endDate: (0, $4hBm1.subDays)(fromDate, 1),
                    fee: ph.fee - ph2.fee,
                    expenseBudget: ph.expenseBudget - ph2.expenseBudget,
                    hoursBudget: ph.hoursBudget - ph2.hoursBudget
                });
                ph.budgets.forEach((phb)=>{
                    const phb2 = phb.clone({
                        phaseId: ph2.id,
                        hours: (0, $hVjuY.logRound)(phb.hours * lengthRatio2)
                    }, {
                        trackUpdates: true
                    });
                    phb.update({
                        hours: phb.hours - phb2.hours
                    });
                });
            } else {
                var _endDate$getTime3;
                endDate && ph.update({
                    endDate: new Date(((_endDate$getTime3 = endDate.getTime) === null || _endDate$getTime3 === void 0 ? void 0 : _endDate$getTime3.call(endDate)) + diff)
                });
            }
        }
    });
};
var $213af64e834daa29$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ project: project, modalId: modalId })=>{
    const [fromDate, setFromDate] = (0, $jbmdS.useState)(new Date());
    const [untilDate, setUntilDate] = (0, $jbmdS.useState)(new Date());
    const [splitPhases, setSplitPhases] = (0, $jbmdS.useState)(false);
    const [selectAllPhases, setSelectAllPhases] = (0, $jbmdS.useState)(true);
    const [selectedPhases, setSelectedPhases] = (0, $jbmdS.useState)(new Set());
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fEcKX.default), {
        modalId: modalId,
        heading: "Delay Project",
        onSave: ()=>$213af64e834daa29$var$delayProject({
                fromDate: fromDate,
                untilDate: untilDate,
                splitPhases: splitPhases,
                phases: selectAllPhases ? project.phases : selectedPhases
            }),
        saveLabel: "Delay Project",
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)("p", {
                style: {
                    padding: "0.5em 1em"
                },
                children: [
                    "Please select the dates you will like to delay",
                    " ",
                    /*#__PURE__*/ (0, $61Ea1.jsx)("em", {
                        children: project.title
                    }),
                    " until. This shift all phase dates that occur after selected date forward by the same amount."
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    padding: "0 1em"
                },
                children: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $gdEjf.FormSection), {
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $gdEjf.FormRow), {
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $gdEjf.FormLabel), {
                                    style: {
                                        width: "7em"
                                    },
                                    className: "inline-block",
                                    children: "Delay From:"
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7GQic.default), {
                                    className: "start-date-input",
                                    style: {
                                        width: "16em",
                                        display: "inline-block"
                                    },
                                    value: fromDate,
                                    onChange: setFromDate
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $gdEjf.FormRow), {
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $gdEjf.FormLabel), {
                                    style: {
                                        width: "7em"
                                    },
                                    className: "inline-block",
                                    children: "Delay Until:"
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7GQic.default), {
                                    className: "until-date-input",
                                    style: {
                                        width: "16em",
                                        display: "inline-block"
                                    },
                                    value: untilDate,
                                    onChange: setUntilDate
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $gdEjf.FormRow), {
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                                className: "split-phases-input",
                                value: splitPhases,
                                label: "Split phases in two that occur during the delay.",
                                onChange: setSplitPhases,
                                variant: "secondary"
                            })
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $gdEjf.FormRow), {
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                                className: "all-phases-input",
                                value: selectAllPhases,
                                label: "Apply to all phases.",
                                onChange: setSelectAllPhases,
                                variant: "secondary"
                            })
                        }),
                        !selectAllPhases ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $gdEjf.FormRow), {
                            style: {
                                paddingLeft: "3em"
                            },
                            children: project.phases.map((ph)=>{
                                return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                                        variant: "secondary",
                                        value: selectedPhases.has(ph),
                                        label: ph.title,
                                        onChange: (include, e)=>{
                                            if (include) {
                                                selectedPhases.add(ph);
                                                setSelectedPhases(new Set([
                                                    ...selectedPhases
                                                ]));
                                            } else {
                                                selectedPhases.delete(ph);
                                                setSelectedPhases(new Set([
                                                    ...selectedPhases
                                                ]));
                                            }
                                        }
                                    })
                                });
                            })
                        }) : null
                    ]
                })
            })
        ]
    });
});

});

parcelRegister("hL9C2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cede484a4cb010c1$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("eat5C");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $fEcKX = parcelRequire("fEcKX");

var $fM2j4 = parcelRequire("fM2j4");

var $6UBLf = parcelRequire("6UBLf");

var $6l5Kr = parcelRequire("6l5Kr");
var $cede484a4cb010c1$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ project: project, modalId: modalId })=>{
    const navigate = (0, $6UBLf.useNavigate)();
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fEcKX.default), {
        modalId: modalId,
        heading: "Delete Project",
        saveButtons: [
            {
                label: "Archive Project",
                onClick: ()=>{
                    if (!project.createdAt) (0, $6l5Kr.handleEntityDelete)(project, "project", navigate);
                    else {
                        project.phases.forEach((phase)=>{
                            phase.update({
                                status: "archived"
                            });
                        });
                        (0, $fM2j4.default).startSave();
                        navigate({
                            to: "/projects/"
                        });
                    }
                }
            },
            {
                label: "Delete Project",
                onClick: ()=>(0, $6l5Kr.handleEntityDelete)(project, "project", navigate)
            }
        ],
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)("p", {
                style: {
                    margin: "1em"
                },
                children: [
                    "Are you sure you wish to delete ",
                    /*#__PURE__*/ (0, $61Ea1.jsx)("em", {
                        children: project.title
                    }),
                    "?"
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("p", {
                style: {
                    margin: "1em"
                },
                children: 'We recommend you "Archive" your projects to retain historical timesheet and billing information.'
            })
        ]
    });
});

});

parcelRegister("lVFwm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff6f21040d088ea8$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $eat5C = parcelRequire("eat5C");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $fEcKX = parcelRequire("fEcKX");

var $12o9H = parcelRequire("12o9H");

var $4JcCM = parcelRequire("4JcCM");

var $kScV6 = parcelRequire("kScV6");


var $hcHdW = parcelRequire("hcHdW");

var $52dEm = parcelRequire("52dEm");

var $6RcUP = parcelRequire("6RcUP");

var $ewAM3 = parcelRequire("ewAM3");

var $47i9t = parcelRequire("47i9t");

var $3h7sC = parcelRequire("3h7sC");
var $ff6f21040d088ea8$var$_dec, $ff6f21040d088ea8$var$_dec2, $ff6f21040d088ea8$var$_dec3, $ff6f21040d088ea8$var$_dec4, $ff6f21040d088ea8$var$_dec5, $ff6f21040d088ea8$var$_dec6, $ff6f21040d088ea8$var$_dec7, $ff6f21040d088ea8$var$_class, $ff6f21040d088ea8$var$_descriptor, $ff6f21040d088ea8$var$_descriptor2, $ff6f21040d088ea8$var$_descriptor3, $ff6f21040d088ea8$var$_dec8, $ff6f21040d088ea8$var$_dec9, $ff6f21040d088ea8$var$_class2, $ff6f21040d088ea8$var$_descriptor4, $ff6f21040d088ea8$var$_descriptor5, $ff6f21040d088ea8$var$_descriptor6;
function $ff6f21040d088ea8$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $ff6f21040d088ea8$var$_defineProperty(e, r, t) {
    return (r = $ff6f21040d088ea8$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ff6f21040d088ea8$var$_toPropertyKey(t) {
    var i = $ff6f21040d088ea8$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $ff6f21040d088ea8$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $ff6f21040d088ea8$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $ff6f21040d088ea8$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $ff6f21040d088ea8$var$phaseFeeData = ($ff6f21040d088ea8$var$_dec = (0, $4JcCM.action).bound, $ff6f21040d088ea8$var$_dec2 = (0, $4JcCM.action).bound, $ff6f21040d088ea8$var$_dec3 = (0, $4JcCM.action).bound, $ff6f21040d088ea8$var$_dec4 = (0, $4JcCM.action).bound, $ff6f21040d088ea8$var$_dec5 = (0, $4JcCM.action).bound, $ff6f21040d088ea8$var$_dec6 = (0, $4JcCM.action).bound, $ff6f21040d088ea8$var$_dec7 = (0, $4JcCM.action).bound, $ff6f21040d088ea8$var$_class = class phaseFeeData {
    constructor(phase, index, projectStore){
        $ff6f21040d088ea8$var$_initializerDefineProperty(this, "phase", $ff6f21040d088ea8$var$_descriptor, this);
        $ff6f21040d088ea8$var$_initializerDefineProperty(this, "postition", $ff6f21040d088ea8$var$_descriptor2, this);
        $ff6f21040d088ea8$var$_initializerDefineProperty(this, "feeData", $ff6f21040d088ea8$var$_descriptor3, this);
        (0, $4JcCM.makeObservable)(this);
        this.projectStore = projectStore;
        this.id = phase.id;
        this.phase = phase;
        this.position = index;
    }
    initFeeData() {
        const phase = this.phase;
        this.feeData = phase.feeData || {
            type: "percentAgreed",
            visible: true,
            locked: false
        };
        if (this.feeData.type === "percentAgreed") {
            var _this$projectStore;
            this.feeData.value = phase.fee;
            this.feeData.percent = phase.fee / ((_this$projectStore = this.projectStore) === null || _this$projectStore === void 0 ? void 0 : _this$projectStore.agreedFee) * 100;
        } else {
            var _this$projectStore2;
            this.feeData.value = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.previousPhases.map((pp)=>pp.phase.fee)) + phase.fee;
            this.feeData.percent = ((0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.previousPhases.map((pp)=>pp.phase.fee)) + phase.fee) / ((_this$projectStore2 = this.projectStore) === null || _this$projectStore2 === void 0 ? void 0 : _this$projectStore2.agreedFee) * 100;
        }
    }
    setLocked(newLocked) {
        this.feeData.locked = newLocked;
        if (newLocked) {
            if (this.feeData.type === "percentAgreed") {
                var _this$projectStore3;
                this.setFeeDataValue(((_this$projectStore3 = this.projectStore) === null || _this$projectStore3 === void 0 ? void 0 : _this$projectStore3.agreedFee) * (this.feeData.percent / 100));
            } else {
                var _this$projectStore4;
                this.setFeeDataValue(((_this$projectStore4 = this.projectStore) === null || _this$projectStore4 === void 0 ? void 0 : _this$projectStore4.agreedFee) * (this.feeData.percent / 100) - this.previousPhasesAgreedFee);
            }
        }
        this.phase.update({
            feeData: {
                ...this.feeData
            }
        });
    }
    setVisible(newVisible) {
        this.feeData.visible = newVisible;
        if (!newVisible) {
            if (this.feeData.type === "percentAgreed") {
                var _this$projectStore5;
                this.setFeeDataValue(((_this$projectStore5 = this.projectStore) === null || _this$projectStore5 === void 0 ? void 0 : _this$projectStore5.agreedFee) * (this.feeData.percent / 100));
            } else {
                var _this$projectStore6;
                this.setFeeDataValue(((_this$projectStore6 = this.projectStore) === null || _this$projectStore6 === void 0 ? void 0 : _this$projectStore6.agreedFee) * (this.feeData.percent / 100) - this.previousPhasesAgreedFee);
            }
        }
        this.phase.update({
            feeData: {
                ...this.feeData
            }
        });
    }
    setPosition(newPosition) {
        this.position = newPosition;
    }
    setFeeDataType(newFeeType) {
        this.feeData.type = newFeeType;
        this.phase.update({
            feeData: {
                ...this.feeData
            }
        });
    }
    setFeeDataValue(newFeeValue) {
        this.feeData.value = newFeeValue;
        this.phase.update({
            feeData: {
                ...this.feeData
            }
        });
    }
    setFeeDataPercent(newFeePercent) {
        this.feeData.percent = newFeePercent;
        this.phase.update({
            feeData: {
                ...this.feeData
            }
        });
    }
    get previousPhases() {
        var _this$projectStore7;
        return ((_this$projectStore7 = this.projectStore) === null || _this$projectStore7 === void 0 ? void 0 : _this$projectStore7.phasesFeeData.filter((ph)=>ph.position < this.position && ph.feeData.visible)) || [];
    }
    get previousPhasesAgreedFee() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(this.previousPhases.map((ph)=>ph.agreedFee));
    }
    get agreedFee() {
        if (this.feeData.locked || !this.feeData.visible) return this.feeData.value;
        else if (this.feeData.type === "percentAgreed") {
            var _this$projectStore8;
            return ((_this$projectStore8 = this.projectStore) === null || _this$projectStore8 === void 0 ? void 0 : _this$projectStore8.agreedFee) * (this.feeData.percent / 100);
        } else {
            var _this$projectStore9;
            return ((_this$projectStore9 = this.projectStore) === null || _this$projectStore9 === void 0 ? void 0 : _this$projectStore9.agreedFee) * (this.feeData.percent / 100) - this.previousPhasesAgreedFee;
        }
    }
}, $ff6f21040d088ea8$var$_descriptor = $ff6f21040d088ea8$var$_applyDecoratedDescriptor($ff6f21040d088ea8$var$_class.prototype, "phase", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $ff6f21040d088ea8$var$_descriptor2 = $ff6f21040d088ea8$var$_applyDecoratedDescriptor($ff6f21040d088ea8$var$_class.prototype, "postition", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $ff6f21040d088ea8$var$_descriptor3 = $ff6f21040d088ea8$var$_applyDecoratedDescriptor($ff6f21040d088ea8$var$_class.prototype, "feeData", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $ff6f21040d088ea8$var$_applyDecoratedDescriptor($ff6f21040d088ea8$var$_class.prototype, "initFeeData", [
    $ff6f21040d088ea8$var$_dec
], Object.getOwnPropertyDescriptor($ff6f21040d088ea8$var$_class.prototype, "initFeeData"), $ff6f21040d088ea8$var$_class.prototype), $ff6f21040d088ea8$var$_applyDecoratedDescriptor($ff6f21040d088ea8$var$_class.prototype, "setLocked", [
    $ff6f21040d088ea8$var$_dec2
], Object.getOwnPropertyDescriptor($ff6f21040d088ea8$var$_class.prototype, "setLocked"), $ff6f21040d088ea8$var$_class.prototype), $ff6f21040d088ea8$var$_applyDecoratedDescriptor($ff6f21040d088ea8$var$_class.prototype, "setVisible", [
    $ff6f21040d088ea8$var$_dec3
], Object.getOwnPropertyDescriptor($ff6f21040d088ea8$var$_class.prototype, "setVisible"), $ff6f21040d088ea8$var$_class.prototype), $ff6f21040d088ea8$var$_applyDecoratedDescriptor($ff6f21040d088ea8$var$_class.prototype, "setPosition", [
    $ff6f21040d088ea8$var$_dec4
], Object.getOwnPropertyDescriptor($ff6f21040d088ea8$var$_class.prototype, "setPosition"), $ff6f21040d088ea8$var$_class.prototype), $ff6f21040d088ea8$var$_applyDecoratedDescriptor($ff6f21040d088ea8$var$_class.prototype, "setFeeDataType", [
    $ff6f21040d088ea8$var$_dec5
], Object.getOwnPropertyDescriptor($ff6f21040d088ea8$var$_class.prototype, "setFeeDataType"), $ff6f21040d088ea8$var$_class.prototype), $ff6f21040d088ea8$var$_applyDecoratedDescriptor($ff6f21040d088ea8$var$_class.prototype, "setFeeDataValue", [
    $ff6f21040d088ea8$var$_dec6
], Object.getOwnPropertyDescriptor($ff6f21040d088ea8$var$_class.prototype, "setFeeDataValue"), $ff6f21040d088ea8$var$_class.prototype), $ff6f21040d088ea8$var$_applyDecoratedDescriptor($ff6f21040d088ea8$var$_class.prototype, "setFeeDataPercent", [
    $ff6f21040d088ea8$var$_dec7
], Object.getOwnPropertyDescriptor($ff6f21040d088ea8$var$_class.prototype, "setFeeDataPercent"), $ff6f21040d088ea8$var$_class.prototype), $ff6f21040d088ea8$var$_applyDecoratedDescriptor($ff6f21040d088ea8$var$_class.prototype, "previousPhases", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($ff6f21040d088ea8$var$_class.prototype, "previousPhases"), $ff6f21040d088ea8$var$_class.prototype), $ff6f21040d088ea8$var$_applyDecoratedDescriptor($ff6f21040d088ea8$var$_class.prototype, "previousPhasesAgreedFee", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($ff6f21040d088ea8$var$_class.prototype, "previousPhasesAgreedFee"), $ff6f21040d088ea8$var$_class.prototype), $ff6f21040d088ea8$var$_applyDecoratedDescriptor($ff6f21040d088ea8$var$_class.prototype, "agreedFee", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($ff6f21040d088ea8$var$_class.prototype, "agreedFee"), $ff6f21040d088ea8$var$_class.prototype), $ff6f21040d088ea8$var$_class);
let $ff6f21040d088ea8$var$projectFeeData = ($ff6f21040d088ea8$var$_dec8 = (0, $4JcCM.action).bound, $ff6f21040d088ea8$var$_dec9 = (0, $4JcCM.action).bound, $ff6f21040d088ea8$var$_class2 = class projectFeeData {
    constructor(project){
        $ff6f21040d088ea8$var$_initializerDefineProperty(this, "project", $ff6f21040d088ea8$var$_descriptor4, this);
        $ff6f21040d088ea8$var$_initializerDefineProperty(this, "feeData", $ff6f21040d088ea8$var$_descriptor5, this);
        $ff6f21040d088ea8$var$_initializerDefineProperty(this, "phasesFeeData", $ff6f21040d088ea8$var$_descriptor6, this);
        (0, $4JcCM.makeObservable)(this);
        this.project = project;
        this.feeData = project.feeData || {
            value: String(project.fee)
        };
        this.phasesFeeData = [];
        project.phases.filter((ph)=>!ph.isRootPhase).forEach((ph, i)=>{
            this.phasesFeeData.push(new $ff6f21040d088ea8$var$phaseFeeData(ph, i, this));
        });
        this.phasesFeeData.forEach((ph)=>ph.initFeeData());
    }
    reorderPhasesFeeData(newList) {
        newList.forEach((ph, i)=>{
            ph.setPosition(i);
        });
        this.phasesFeeData = newList;
    }
    get agreedFee() {
        return new (0, $kScV6.default)({
            formula: this.feeData.value
        }).value;
    }
    setAgreedFee(value) {
        this.feeData.value = value;
        this.project.update({
            feeData: {
                ...this.feeData
            }
        });
    }
}, $ff6f21040d088ea8$var$_descriptor4 = $ff6f21040d088ea8$var$_applyDecoratedDescriptor($ff6f21040d088ea8$var$_class2.prototype, "project", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $ff6f21040d088ea8$var$_descriptor5 = $ff6f21040d088ea8$var$_applyDecoratedDescriptor($ff6f21040d088ea8$var$_class2.prototype, "feeData", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $ff6f21040d088ea8$var$_descriptor6 = $ff6f21040d088ea8$var$_applyDecoratedDescriptor($ff6f21040d088ea8$var$_class2.prototype, "phasesFeeData", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $ff6f21040d088ea8$var$_applyDecoratedDescriptor($ff6f21040d088ea8$var$_class2.prototype, "reorderPhasesFeeData", [
    $ff6f21040d088ea8$var$_dec8
], Object.getOwnPropertyDescriptor($ff6f21040d088ea8$var$_class2.prototype, "reorderPhasesFeeData"), $ff6f21040d088ea8$var$_class2.prototype), $ff6f21040d088ea8$var$_applyDecoratedDescriptor($ff6f21040d088ea8$var$_class2.prototype, "agreedFee", [
    (0, $4JcCM.computed)
], Object.getOwnPropertyDescriptor($ff6f21040d088ea8$var$_class2.prototype, "agreedFee"), $ff6f21040d088ea8$var$_class2.prototype), $ff6f21040d088ea8$var$_applyDecoratedDescriptor($ff6f21040d088ea8$var$_class2.prototype, "setAgreedFee", [
    $ff6f21040d088ea8$var$_dec9
], Object.getOwnPropertyDescriptor($ff6f21040d088ea8$var$_class2.prototype, "setAgreedFee"), $ff6f21040d088ea8$var$_class2.prototype), $ff6f21040d088ea8$var$_class2);
var $ff6f21040d088ea8$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ project: project, modalId: modalId })=>{
    const [store, setStore] = (0, $jbmdS.useState)(new $ff6f21040d088ea8$var$projectFeeData(project));
    const labelWidth = "7em";
    const listContainerRef = (0, $jbmdS.useRef)();
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fEcKX.default), {
        modalId: modalId,
        heading: "Project Fee Calculator",
        onSave: ()=>{
            project.update({
                feeData: store.feeData
            });
            store.phasesFeeData.filter((ph)=>ph.feeData.visible).forEach((ph)=>ph.phase.update({
                    feeData: ph.feeData,
                    fee: ph.agreedFee
                }));
        },
        saveLabel: "Save Fees",
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6RcUP.default), {
            queryIds: [
                {
                    id: `projectFeeData-${project.id}`,
                    queryFn: async ()=>{
                        const requestData = await (0, $3h7sC.trpc).legacy.getProjectFeeData.query({
                            projectId: project.id
                        });
                        return (0, $47i9t.processTRPCData)(requestData, `projectFeeData-${project.id}`);
                    }
                }
            ],
            children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "delay-project-form",
                style: {
                    padding: "2em"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "text-right font-bold text-sm",
                        children: (0, $12o9H.FormatCurrency)(store.agreedFee)
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "flex justify-end mb-7",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "mr-2 font-bold text-[13px]",
                                style: {
                                    flex: "0 0 auto"
                                },
                                children: "Agreed Fee"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                style: {
                                    flex: "0 0 auto"
                                },
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
                                    size: "small",
                                    value: store.feeData.value || "",
                                    className: "w-[150px] text-right border border-[#ccc] py-0 px-2 h-[22px] text-sm",
                                    onChange: (e)=>{
                                        store.setAgreedFee(e.target.value);
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "relative",
                        ref: listContainerRef,
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hcHdW))), {
                            itemKey: "id",
                            template: $ff6f21040d088ea8$var$PhaseListItem,
                            list: store.phasesFeeData,
                            onMoveEnd: (newList)=>store.reorderPhasesFeeData(newList),
                            container: ()=>listContainerRef.current
                        })
                    })
                ]
            })
        })
    });
});
const $ff6f21040d088ea8$var$PhaseListItem = (0, $1EEMt.observer)(({ item: ph, itemSelected: itemSelected, dragHandleProps: dragHandleProps })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "flex items-center border-t border-[#eee] py-1.5 px-0",
        style: {
            opacity: ph.feeData.visible ? 1 : 0.5
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "flex flex-1 items-center gap-2.5",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                        ...dragHandleProps,
                        style: {
                            color: "grey"
                        },
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                className: "fa fa-ellipsis-v"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                className: "fa fa-ellipsis-v"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                        value: ph.feeData.visible,
                        onChange: (visible)=>ph.setVisible(visible)
                    }),
                    ph.phase.title
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    flex: "0 0 auto"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            textAlign: "right",
                            fontWeight: "bold"
                        },
                        children: [
                            (0, $12o9H.FormatCurrency)(ph.agreedFee),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                className: ph.feeData.locked ? "fa fa-lock" : "fa fa-unlock",
                                style: {
                                    marginLeft: "1rem"
                                },
                                onClick: ()=>ph.feeData.visible && ph.setLocked(!ph.feeData.locked)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
                        size: "small",
                        className: "w-[50px] border border-[#ccc] py-0 px-[5px] text-sm text-right rounded-[6px]",
                        value: ph.feeData.percent || "",
                        onChange: (e)=>{
                            ph.setFeeDataPercent(e.target.value);
                        },
                        disabled: ph.feeData.locked || !ph.feeData.visible
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        style: {
                            display: "inline-block"
                        },
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                            value: ph.feeData.type,
                            onChange: (type)=>{
                                ph.setFeeDataType(type);
                            },
                            options: [
                                {
                                    value: "percentAgreed",
                                    label: "% Agreed Fee"
                                },
                                {
                                    value: "percentLessPrevious",
                                    label: "% Agreed Less Previous"
                                }
                            ],
                            style: {
                                width: 160,
                                fontSize: "1rem",
                                padding: "0.25rem"
                            },
                            isEditable: !ph.feeData.locked && ph.feeData.visible,
                            variant: "secondary",
                            className: "max-h-[22px] [&_span]:!text-xs"
                        })
                    })
                ]
            })
        ]
    });
});

});
parcelRegister("hcHdW", function(module, exports) {
"use strict";

var $6cBd9 = parcelRequire("6cBd9");

var $2HGGA = parcelRequire("2HGGA");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $c86516012f8b3fb2$var$_classCallCheck2 = $6cBd9((parcelRequire("keWlZ")));

var $c86516012f8b3fb2$var$_createClass2 = $6cBd9((parcelRequire("czJCt")));

var $c86516012f8b3fb2$var$_possibleConstructorReturn2 = $6cBd9((parcelRequire("fCodG")));

var $c86516012f8b3fb2$var$_getPrototypeOf2 = $6cBd9((parcelRequire("aVHto")));

var $c86516012f8b3fb2$var$_inherits2 = $6cBd9((parcelRequire("khSB6")));

var $c86516012f8b3fb2$var$_defineProperty2 = $6cBd9((parcelRequire("bPsra")));

var $c86516012f8b3fb2$var$React = $c86516012f8b3fb2$var$_interopRequireWildcard((parcelRequire("jbmdS")));

var $c86516012f8b3fb2$var$PropTypes = $c86516012f8b3fb2$var$_interopRequireWildcard((parcelRequire("2MXkj")));

var $94MZv = parcelRequire("94MZv");

var $c86516012f8b3fb2$var$_immutabilityHelper = $6cBd9((parcelRequire("9wVsN")));

var $c86516012f8b3fb2$var$_reactMultiRef = $6cBd9((parcelRequire("iemeN")));

var $c86516012f8b3fb2$var$_OnUpdate = $6cBd9((parcelRequire("3phrd")));

var $c86516012f8b3fb2$var$_MoveContainer = $6cBd9((parcelRequire("dDaoD")));
function $c86516012f8b3fb2$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c86516012f8b3fb2$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $c86516012f8b3fb2$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $2HGGA(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $c86516012f8b3fb2$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $c86516012f8b3fb2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c86516012f8b3fb2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c86516012f8b3fb2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $c86516012f8b3fb2$var$_defineProperty2["default"])(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c86516012f8b3fb2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c86516012f8b3fb2$var$_callSuper(t, o, e) {
    return o = (0, $c86516012f8b3fb2$var$_getPrototypeOf2["default"])(o), (0, $c86516012f8b3fb2$var$_possibleConstructorReturn2["default"])(t, $c86516012f8b3fb2$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $c86516012f8b3fb2$var$_getPrototypeOf2["default"])(t).constructor) : o.apply(t, e));
}
function $c86516012f8b3fb2$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c86516012f8b3fb2$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
} /* eslint react/prop-types: "error" */ 
var $c86516012f8b3fb2$var$DEFAULT_HEIGHT = {
    natural: 200,
    drag: 30
};
function $c86516012f8b3fb2$var$getScrollSpeed(distance, speed, size) {
    // If distance is zero, then the result is the max speed. Otherwise,
    // the result tapers toward zero as it gets closer to the opposite
    // edge of the region.
    return Math.round(speed - speed / size * distance);
}
var $c86516012f8b3fb2$var$DraggableList = module.exports["default"] = /*#__PURE__*/ function(_React$Component) {
    function DraggableList() {
        var _this;
        (0, $c86516012f8b3fb2$var$_classCallCheck2["default"])(this, DraggableList);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $c86516012f8b3fb2$var$_callSuper(this, DraggableList, [].concat(args));
        (0, $c86516012f8b3fb2$var$_defineProperty2["default"])(_this, "_itemRefs", new $c86516012f8b3fb2$var$_reactMultiRef["default"]());
        (0, $c86516012f8b3fb2$var$_defineProperty2["default"])(_this, "_listRef", /*#__PURE__*/ $c86516012f8b3fb2$var$React.createRef());
        (0, $c86516012f8b3fb2$var$_defineProperty2["default"])(_this, "state", {
            useAbsolutePositioning: false,
            dragging: false,
            lastDrag: null,
            heights: null
        });
        (0, $c86516012f8b3fb2$var$_defineProperty2["default"])(_this, "_handleTouchMove", function(e) {
            e.preventDefault();
            _this._handleMouseMove(e.touches[0]);
        });
        (0, $c86516012f8b3fb2$var$_defineProperty2["default"])(_this, "_handleMouseMove", function(_ref) {
            var pageY = _ref.pageY, clientY = _ref.clientY;
            var list = _this.props.list;
            var autoScrollMaxSpeed = _this.props.autoScrollMaxSpeed;
            var autoScrollRegionSize = _this.props.autoScrollRegionSize;
            var _this$state = _this.state, dragging = _this$state.dragging, lastDrag = _this$state.lastDrag;
            if (!dragging || !lastDrag) return;
            var containerEl = _this._getContainer();
            var dragVisualIndex = _this._getDragVisualIndex();
            var keyFn = _this._getKeyFn();
            clearInterval(_this._autoScrollerTimer);
            // If the user has the mouse near the top or bottom of the container and
            // not at the end of the list, then autoscroll.
            if (dragVisualIndex !== 0 && dragVisualIndex !== list.length - 1) {
                var scrollSpeed = 0;
                var containerRect = containerEl && containerEl !== document.body && containerEl.getBoundingClientRect ? containerEl.getBoundingClientRect() : {
                    top: 0,
                    bottom: Infinity
                };
                // Get the lowest of the screen top and the container top.
                var top = Math.max(0, containerRect.top);
                var distanceFromTop = clientY - top;
                if (distanceFromTop > 0 && distanceFromTop < autoScrollRegionSize) scrollSpeed = -1 * $c86516012f8b3fb2$var$getScrollSpeed(distanceFromTop, autoScrollMaxSpeed, autoScrollRegionSize);
                else {
                    // Get the lowest of the screen bottom and the container bottom.
                    var bottom = Math.min(window.innerHeight, containerRect.bottom);
                    var distanceFromBottom = bottom - clientY;
                    if (distanceFromBottom > 0 && distanceFromBottom < autoScrollRegionSize) scrollSpeed = $c86516012f8b3fb2$var$getScrollSpeed(distanceFromBottom, autoScrollMaxSpeed, autoScrollRegionSize);
                }
                if (scrollSpeed !== 0) {
                    _this._scrollContainer(scrollSpeed);
                    _this._autoScrollerTimer = setTimeout(function() {
                        _this._handleMouseMove({
                            pageY: pageY + (containerEl === document.body ? scrollSpeed : 0),
                            clientY: clientY
                        });
                    }, 16);
                }
            }
            var containerScroll = !containerEl || containerEl === document.body ? 0 : containerEl.scrollTop;
            var mouseY = pageY - lastDrag.mouseOffset + containerScroll;
            if (_this.props.constrainDrag) {
                var visualList = _this._getVisualListDuringDrag();
                mouseY = Math.max(mouseY, _this._getDistanceFromTopDuringDrag(lastDrag, keyFn(visualList[0]), visualList));
                mouseY = Math.min(mouseY, _this._getDistanceFromTopDuringDrag(lastDrag, keyFn(visualList[visualList.length - 1]), visualList));
            }
            _this.setState({
                lastDrag: $c86516012f8b3fb2$var$_objectSpread($c86516012f8b3fb2$var$_objectSpread({}, lastDrag), {}, {
                    mouseY: mouseY
                })
            });
        });
        (0, $c86516012f8b3fb2$var$_defineProperty2["default"])(_this, "_handleMouseUp", function() {
            clearInterval(_this._autoScrollerTimer);
            window.removeEventListener("mouseup", _this._handleMouseUp);
            window.removeEventListener("touchend", _this._handleMouseUp);
            window.removeEventListener("touchmove", _this._handleTouchMove);
            window.removeEventListener("mousemove", _this._handleMouseMove);
            if (document.documentElement) document.documentElement.style.cursor = "";
            _this._lastScrollDelta = 0;
            var _this$props = _this.props, list = _this$props.list, onMoveEnd = _this$props.onMoveEnd, onDragEnd = _this$props.onDragEnd;
            var _this$state2 = _this.state, dragging = _this$state2.dragging, lastDrag = _this$state2.lastDrag;
            if (dragging && lastDrag && onMoveEnd) {
                var dragIndex = _this._getDragListIndex();
                var newIndex = _this._getDragVisualIndex();
                if (onDragEnd) onDragEnd(list[dragIndex]);
                if (dragIndex !== newIndex) {
                    var newList = _this._getVisualListDuringDrag();
                    onMoveEnd(newList, list[dragIndex], dragIndex, newIndex);
                }
                _this.setState({
                    dragging: false
                });
            }
        });
        (0, $c86516012f8b3fb2$var$_defineProperty2["default"])(_this, "_lastScrollDelta", 0);
        return _this;
    }
    (0, $c86516012f8b3fb2$var$_inherits2["default"])(DraggableList, _React$Component);
    return (0, $c86516012f8b3fb2$var$_createClass2["default"])(DraggableList, [
        {
            key: "getItemInstance",
            value: function getItemInstance(key) {
                var ref = this._itemRefs.map.get(key);
                if (!ref) throw new Error("key not found");
                return ref.getTemplate();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._handleMouseUp();
            }
        },
        {
            key: "_handleTouchStart",
            value: function _handleTouchStart(itemKey, pressY, event) {
                event.stopPropagation();
                this._handleStartDrag(itemKey, pressY, event.touches[0].pageY);
            }
        },
        {
            key: "_handleMouseDown",
            value: function _handleMouseDown(itemKey, pressY, event) {
                event.preventDefault();
                this._handleStartDrag(itemKey, pressY, event.pageY);
            }
        },
        {
            key: "_handleStartDrag",
            value: function _handleStartDrag(itemKey, pressY, pageY) {
                var _this2 = this;
                if (document.documentElement) document.documentElement.style.cursor = "move";
                window.addEventListener("mouseup", this._handleMouseUp);
                window.addEventListener("touchend", this._handleMouseUp);
                window.addEventListener("touchmove", this._handleTouchMove);
                window.addEventListener("mousemove", this._handleMouseMove);
                var keyFn = this._getKeyFn();
                if (this.props.onDragStart) {
                    var list = this.props.list;
                    var draggedItem = list[DraggableList._getIndexOfItemWithKey(keyFn, list, itemKey)];
                    this.props.onDragStart(draggedItem);
                }
                var listEl = this._listRef.current;
                if (!listEl) throw new Error("Should not happen");
                if (listEl.contains && document.activeElement && listEl.contains(document.activeElement) && document.activeElement instanceof HTMLElement) document.activeElement.blur();
                var newHeights = null;
                if (this.state.heights == null) {
                    var _newHeights = Object.create(null);
                    this.props.list.forEach(function(item) {
                        var key = keyFn(item);
                        var containerRef = _this2._itemRefs.map.get(key);
                        var refEl = containerRef ? containerRef.getDOMNode().firstElementChild : null;
                        var ref = containerRef ? containerRef.getTemplate() : null;
                        var natural = refEl instanceof HTMLElement ? refEl.offsetHeight : $c86516012f8b3fb2$var$DEFAULT_HEIGHT.natural;
                        var drag = ref && typeof ref.getDragHeight === "function" && ref.getDragHeight() || natural;
                        _newHeights[key] = {
                            natural: natural,
                            drag: drag
                        };
                    });
                    newHeights = _newHeights;
                }
                // Need to re-render once before we start dragging so that the `y` values
                // are set using the correct state.heights and then can animate from there.
                var afterHeights = function afterHeights() {
                    var itemIndex = DraggableList._getIndexOfItemWithKey(keyFn, _this2.props.list, itemKey);
                    // pressY will be non-null if the list is currently animating (because the
                    // clicked item has its `y` prop set). pressY will be null if the list is
                    // not currently animating (because the clicked item will be at its
                    // natural position, which is calculatable using _getDistance).
                    var startY = pressY == null ? _this2._getDistance(0, itemIndex, false) : pressY;
                    var containerEl = _this2._getContainer();
                    var containerScroll = !containerEl || containerEl === document.body ? 0 : containerEl.scrollTop;
                    _this2.setState({
                        useAbsolutePositioning: true,
                        dragging: true,
                        lastDrag: {
                            itemKey: itemKey,
                            startY: startY,
                            mouseY: startY,
                            mouseOffset: pageY - startY + containerScroll
                        }
                    });
                };
                if (newHeights) this.setState({
                    heights: newHeights
                }, afterHeights);
                else afterHeights();
            }
        },
        {
            key: "_scrollContainer",
            value: function _scrollContainer(delta) {
                var containerEl = this._getContainer();
                if (!containerEl) return;
                if (window.scrollBy && containerEl === document.body) window.scrollBy(0, delta);
                else containerEl.scrollTop += delta;
            }
        },
        {
            key: "_adjustScrollAtEnd",
            value: function _adjustScrollAtEnd(delta) {
                var frameDelta = Math.round(delta - this._lastScrollDelta);
                this._scrollContainer(frameDelta);
                this._lastScrollDelta += frameDelta;
            }
        },
        {
            key: "_getDragListIndex",
            value: function _getDragListIndex() {
                var list = this.props.list;
                var lastDrag = this.state.lastDrag;
                if (!lastDrag) throw new Error("No drag happened");
                var keyFn = this._getKeyFn();
                return DraggableList._getIndexOfItemWithKey(keyFn, list, lastDrag.itemKey);
            }
        },
        {
            key: "_getDragVisualIndex",
            value: function _getDragVisualIndex() {
                var list = this.props.list;
                var padding = this.props.padding;
                var _this$state3 = this.state, dragging = _this$state3.dragging, lastDrag = _this$state3.lastDrag;
                if (!dragging || !lastDrag) throw new Error("Should not happen");
                var dragListIndex = this._getDragListIndex();
                var mouseY = lastDrag.mouseY, startY = lastDrag.startY;
                var movementFromNatural = mouseY - startY;
                // 1 down, -1 up, 0 neither
                var direction = movementFromNatural > 0 ? 1 : movementFromNatural < 0 ? -1 : 0;
                var newIndex = dragListIndex;
                if (direction !== 0) {
                    var keyFn = this._getKeyFn();
                    var reach = Math.abs(movementFromNatural);
                    for(var i = dragListIndex + direction; i < list.length && i >= 0; i += direction){
                        var iDragHeight = this._getItemHeight(keyFn(list[i])).drag;
                        if (reach < iDragHeight / 2 + padding) break;
                        reach -= iDragHeight + padding;
                        newIndex = i;
                    }
                }
                return newIndex;
            }
        },
        {
            key: "_getVisualListDuringDrag",
            value: function _getVisualListDuringDrag() {
                var list = this.props.list;
                var _this$state4 = this.state, dragging = _this$state4.dragging, lastDrag = _this$state4.lastDrag;
                if (!dragging || !lastDrag) throw new Error("Should not happen: _getVisualListDuringDrag called outside of drag");
                var dragListIndex = this._getDragListIndex();
                var dragVisualIndex = this._getDragVisualIndex();
                return (0, $c86516012f8b3fb2$var$_immutabilityHelper["default"])(list, {
                    $splice: [
                        [
                            dragListIndex,
                            1
                        ],
                        [
                            dragVisualIndex,
                            0,
                            list[dragListIndex]
                        ]
                    ]
                });
            }
        },
        {
            key: "_getItemHeight",
            value: function _getItemHeight(key) {
                return this.state.heights != null && key in this.state.heights ? this.state.heights[key] : $c86516012f8b3fb2$var$DEFAULT_HEIGHT;
            }
        },
        {
            key: "_getDistance",
            value: function _getDistance(start, end, dragging) {
                var list = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.props.list;
                if (end < start) return -this._getDistance(end, start, dragging, list);
                var padding = this.props.padding;
                var keyFn = this._getKeyFn();
                var distance = 0;
                for(var i = start; i < end; i++){
                    var height = this._getItemHeight(keyFn(list[i]));
                    distance += (dragging ? height.drag : height.natural) + padding;
                }
                return distance;
            }
        },
        {
            key: "_getDistanceFromTopDuringDrag",
            value: function _getDistanceFromTopDuringDrag(lastDrag, itemKey, visualList) {
                var keyFn = this._getKeyFn();
                var index = DraggableList._getIndexOfItemWithKey(keyFn, visualList, itemKey);
                var dragListIndex = this._getDragListIndex();
                var dragVisualIndex = DraggableList._getIndexOfItemWithKey(keyFn, visualList, lastDrag.itemKey);
                var offset = 0;
                if (dragVisualIndex < dragListIndex) {
                    var dragItemHeight = this._getItemHeight(lastDrag.itemKey);
                    var newCenterHeight = this._getItemHeight(keyFn(visualList[dragListIndex]));
                    offset = dragItemHeight.drag - newCenterHeight.drag;
                }
                return lastDrag.startY + offset + this._getDistance(dragListIndex, index, true, visualList);
            }
        },
        {
            key: "_getContainer",
            value: function _getContainer() {
                var container = this.props.container;
                return container ? container() : null;
            }
        },
        {
            key: "_getKeyFn",
            value: function _getKeyFn() {
                return DraggableList._getKeyFn(this.props.itemKey);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var padding = this.props.padding;
                var _this$props2 = this.props, list = _this$props2.list, springConfig = _this$props2.springConfig, container = _this$props2.container, template = _this$props2.template, unsetZIndex = _this$props2.unsetZIndex, commonProps = _this$props2.commonProps;
                var _this$state5 = this.state, dragging = _this$state5.dragging, lastDrag = _this$state5.lastDrag, useAbsolutePositioning = _this$state5.useAbsolutePositioning;
                var keyFn = this._getKeyFn();
                var anySelected = (0, $94MZv.spring)(dragging ? 1 : 0, springConfig);
                var visualList = dragging ? this._getVisualListDuringDrag() : list;
                var children = list.map(function(item, i) {
                    var key = keyFn(item);
                    var selectedStyle = dragging && lastDrag && lastDrag.itemKey === key ? {
                        itemSelected: (0, $94MZv.spring)(1, springConfig),
                        y: lastDrag.mouseY
                    } : {
                        itemSelected: (0, $94MZv.spring)(0, springConfig),
                        y: (useAbsolutePositioning ? $94MZv.spring : function(x) {
                            return x;
                        })(dragging && lastDrag ? _this3._getDistanceFromTopDuringDrag(lastDrag, key, visualList) : _this3._getDistance(0, i, false), springConfig)
                    };
                    var style = $c86516012f8b3fb2$var$_objectSpread({
                        anySelected: anySelected
                    }, selectedStyle);
                    var makeDragHandleProps = function makeDragHandleProps(getY) {
                        return {
                            onMouseDown: function onMouseDown(e) {
                                return _this3._handleMouseDown(key, getY(), e);
                            },
                            onTouchStart: function onTouchStart(e) {
                                return _this3._handleTouchStart(key, getY(), e);
                            }
                        };
                    };
                    var height = _this3._getItemHeight(key);
                    return /*#__PURE__*/ $c86516012f8b3fb2$var$React.createElement($94MZv.Motion, {
                        style: style,
                        key: key,
                        children: function children(_ref2) {
                            var itemSelected = _ref2.itemSelected, anySelected = _ref2.anySelected, y = _ref2.y;
                            return /*#__PURE__*/ $c86516012f8b3fb2$var$React.createElement($c86516012f8b3fb2$var$_MoveContainer["default"], {
                                ref: _this3._itemRefs.ref(key),
                                y: useAbsolutePositioning ? y : undefined,
                                template: template,
                                padding: padding,
                                item: item,
                                itemSelected: itemSelected,
                                anySelected: anySelected,
                                height: height,
                                zIndex: unsetZIndex && !useAbsolutePositioning ? "auto" : lastDrag && lastDrag.itemKey === key ? list.length : i,
                                makeDragHandleProps: makeDragHandleProps,
                                commonProps: commonProps
                            });
                        }
                    });
                });
                var adjustScroll = 0;
                if (!dragging && lastDrag && useAbsolutePositioning) {
                    var dragListIndex = this._getDragListIndex();
                    adjustScroll = (0, $94MZv.spring)(this._getDistance(0, dragListIndex, false) - lastDrag.mouseY, springConfig);
                }
                var heightReserverHeight = 0;
                var heightReserverMarginBottom = 0;
                if (list.length) {
                    heightReserverMarginBottom = padding;
                    if (useAbsolutePositioning) heightReserverHeight = this._getDistance(0, list.length, false) - padding;
                }
                return /*#__PURE__*/ $c86516012f8b3fb2$var$React.createElement("div", {
                    style: {
                        position: "relative"
                    },
                    ref: this._listRef
                }, /*#__PURE__*/ $c86516012f8b3fb2$var$React.createElement($94MZv.Motion, {
                    style: {
                        adjustScroll: adjustScroll,
                        anySelected: anySelected
                    },
                    onRest: function onRest() {
                        if (!dragging) _this3.setState({
                            heights: null,
                            useAbsolutePositioning: false
                        });
                    },
                    children: function children(_ref3) {
                        var adjustScroll = _ref3.adjustScroll;
                        return /*#__PURE__*/ $c86516012f8b3fb2$var$React.createElement("div", {
                            style: {
                                display: useAbsolutePositioning ? "block" : "none",
                                height: "".concat(heightReserverHeight, "px"),
                                marginBottom: "".concat(heightReserverMarginBottom, "px")
                            }
                        }, container && /*#__PURE__*/ $c86516012f8b3fb2$var$React.createElement($c86516012f8b3fb2$var$_OnUpdate["default"], {
                            cb: function cb() {
                                if (!dragging && lastDrag && useAbsolutePositioning) _this3._adjustScrollAtEnd(adjustScroll);
                            }
                        }));
                    }
                }), children);
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(newProps, state) {
                var list = newProps.list;
                var lastDrag = state.lastDrag;
                if (lastDrag) {
                    var keyFn = DraggableList._getKeyFn(newProps.itemKey);
                    try {
                        DraggableList._getIndexOfItemWithKey(keyFn, list, lastDrag.itemKey);
                    } catch (err) {
                        // If the dragged item was removed from the list, this block will get hit.
                        // Cancel the drag.
                        return {
                            dragging: false,
                            lastDrag: null
                        };
                    }
                }
                return null;
            }
        },
        {
            key: "_getIndexOfItemWithKey",
            value: function _getIndexOfItemWithKey(keyFn, list, itemKey) {
                for(var i = 0, len = list.length; i < len; i++){
                    if (keyFn(list[i]) === itemKey) return i;
                }
                throw new Error("Failed to find drag index");
            }
        },
        {
            key: "_getKeyFn",
            value: function _getKeyFn(itemKey) {
                return typeof itemKey === "function" ? itemKey : function(x) {
                    return x[itemKey];
                };
            }
        }
    ]);
}($c86516012f8b3fb2$var$React.Component);
(0, $c86516012f8b3fb2$var$_defineProperty2["default"])($c86516012f8b3fb2$var$DraggableList, "propTypes", {
    itemKey: $c86516012f8b3fb2$var$PropTypes.oneOfType([
        $c86516012f8b3fb2$var$PropTypes.string,
        $c86516012f8b3fb2$var$PropTypes.func
    ]).isRequired,
    template: $c86516012f8b3fb2$var$PropTypes.func,
    list: $c86516012f8b3fb2$var$PropTypes.array.isRequired,
    onMoveEnd: $c86516012f8b3fb2$var$PropTypes.func,
    container: $c86516012f8b3fb2$var$PropTypes.func,
    springConfig: $c86516012f8b3fb2$var$PropTypes.object,
    constrainDrag: $c86516012f8b3fb2$var$PropTypes.bool,
    padding: $c86516012f8b3fb2$var$PropTypes.number,
    unsetZIndex: $c86516012f8b3fb2$var$PropTypes.bool,
    autoScrollMaxSpeed: $c86516012f8b3fb2$var$PropTypes.number.isRequired,
    autoScrollRegionSize: $c86516012f8b3fb2$var$PropTypes.number.isRequired,
    commonProps: $c86516012f8b3fb2$var$PropTypes.object
});
(0, $c86516012f8b3fb2$var$_defineProperty2["default"])($c86516012f8b3fb2$var$DraggableList, "defaultProps", {
    springConfig: {
        stiffness: 300,
        damping: 50
    },
    padding: 10,
    unsetZIndex: false,
    constrainDrag: false,
    autoScrollMaxSpeed: 15,
    autoScrollRegionSize: 30
});
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("94MZv", function(module, exports) {

$parcel$export(module.exports, "Motion", function () { return $69ba7d637432bd87$export$ab7b018719e111db; }, function (v) { return $69ba7d637432bd87$export$ab7b018719e111db = v; });
$parcel$export(module.exports, "spring", function () { return $69ba7d637432bd87$export$b36281d89752ae66; }, function (v) { return $69ba7d637432bd87$export$b36281d89752ae66 = v; });
var $69ba7d637432bd87$export$1e511d4a378977f5;
var $69ba7d637432bd87$export$ab7b018719e111db;
var $69ba7d637432bd87$export$8e2db863497d88e8;
var $69ba7d637432bd87$export$f55099f28d39dce4;
var $69ba7d637432bd87$export$b36281d89752ae66;
var $69ba7d637432bd87$export$7afd9c1079ecedf7;
var $69ba7d637432bd87$export$5d0a73a0957eccf0;
var $69ba7d637432bd87$export$e4c0b4e3a05535fb;
"use strict";
$69ba7d637432bd87$export$1e511d4a378977f5 = true;
function $69ba7d637432bd87$var$_interopRequire(obj) {
    return obj && obj.__esModule ? obj["default"] : obj;
}

var $5KEOv = parcelRequire("5KEOv");
$69ba7d637432bd87$export$ab7b018719e111db = $69ba7d637432bd87$var$_interopRequire($5KEOv);

var $lFSUp = parcelRequire("lFSUp");
$69ba7d637432bd87$export$8e2db863497d88e8 = $69ba7d637432bd87$var$_interopRequire($lFSUp);

var $cGHX4 = parcelRequire("cGHX4");
$69ba7d637432bd87$export$f55099f28d39dce4 = $69ba7d637432bd87$var$_interopRequire($cGHX4);

var $iFZhI = parcelRequire("iFZhI");
$69ba7d637432bd87$export$b36281d89752ae66 = $69ba7d637432bd87$var$_interopRequire($iFZhI);

var $hbnss = parcelRequire("hbnss");
$69ba7d637432bd87$export$7afd9c1079ecedf7 = $69ba7d637432bd87$var$_interopRequire($hbnss);

var $cV8KC = parcelRequire("cV8KC");
$69ba7d637432bd87$export$5d0a73a0957eccf0 = $69ba7d637432bd87$var$_interopRequire($cV8KC);

var $7dDLg = parcelRequire("7dDLg");
$69ba7d637432bd87$export$e4c0b4e3a05535fb = $69ba7d637432bd87$var$_interopRequire($7dDLg);

});
parcelRegister("5KEOv", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $4300e85b2d265add$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $4300e85b2d265add$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $4300e85b2d265add$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $4300e85b2d265add$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4300e85b2d265add$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $jdduT = parcelRequire("jdduT");
var $4300e85b2d265add$var$_mapToZero2 = $4300e85b2d265add$var$_interopRequireDefault($jdduT);

var $cV8KC = parcelRequire("cV8KC");
var $4300e85b2d265add$var$_stripStyle2 = $4300e85b2d265add$var$_interopRequireDefault($cV8KC);

var $k59in = parcelRequire("k59in");
var $4300e85b2d265add$var$_stepper4 = $4300e85b2d265add$var$_interopRequireDefault($k59in);

var $eIUbN = parcelRequire("eIUbN");
var $4300e85b2d265add$var$_performanceNow2 = $4300e85b2d265add$var$_interopRequireDefault($eIUbN);

var $8vZRV = parcelRequire("8vZRV");
var $4300e85b2d265add$var$_raf2 = $4300e85b2d265add$var$_interopRequireDefault($8vZRV);

var $avmbi = parcelRequire("avmbi");
var $4300e85b2d265add$var$_shouldStopAnimation2 = $4300e85b2d265add$var$_interopRequireDefault($avmbi);

var $jbmdS = parcelRequire("jbmdS");
var $4300e85b2d265add$var$_react2 = $4300e85b2d265add$var$_interopRequireDefault($jbmdS);

var $2MXkj = parcelRequire("2MXkj");
var $4300e85b2d265add$var$_propTypes2 = $4300e85b2d265add$var$_interopRequireDefault($2MXkj);
var $4300e85b2d265add$var$msPerFrame = 1000 / 60;
var $4300e85b2d265add$var$Motion = function(_React$Component) {
    $4300e85b2d265add$var$_inherits(Motion, _React$Component);
    $4300e85b2d265add$var$_createClass(Motion, null, [
        {
            key: "propTypes",
            value: {
                // TOOD: warn against putting a config in here
                defaultStyle: $4300e85b2d265add$var$_propTypes2["default"].objectOf($4300e85b2d265add$var$_propTypes2["default"].number),
                style: $4300e85b2d265add$var$_propTypes2["default"].objectOf($4300e85b2d265add$var$_propTypes2["default"].oneOfType([
                    $4300e85b2d265add$var$_propTypes2["default"].number,
                    $4300e85b2d265add$var$_propTypes2["default"].object
                ])).isRequired,
                children: $4300e85b2d265add$var$_propTypes2["default"].func.isRequired,
                onRest: $4300e85b2d265add$var$_propTypes2["default"].func
            },
            enumerable: true
        }
    ]);
    function Motion(props) {
        var _this = this;
        $4300e85b2d265add$var$_classCallCheck(this, Motion);
        _React$Component.call(this, props);
        this.wasAnimating = false;
        this.animationID = null;
        this.prevTime = 0;
        this.accumulatedTime = 0;
        this.unreadPropStyle = null;
        this.clearUnreadPropStyle = function(destStyle) {
            var dirty = false;
            var _state = _this.state;
            var currentStyle = _state.currentStyle;
            var currentVelocity = _state.currentVelocity;
            var lastIdealStyle = _state.lastIdealStyle;
            var lastIdealVelocity = _state.lastIdealVelocity;
            for(var key in destStyle){
                if (!Object.prototype.hasOwnProperty.call(destStyle, key)) continue;
                var styleValue = destStyle[key];
                if (typeof styleValue === "number") {
                    if (!dirty) {
                        dirty = true;
                        currentStyle = $4300e85b2d265add$var$_extends({}, currentStyle);
                        currentVelocity = $4300e85b2d265add$var$_extends({}, currentVelocity);
                        lastIdealStyle = $4300e85b2d265add$var$_extends({}, lastIdealStyle);
                        lastIdealVelocity = $4300e85b2d265add$var$_extends({}, lastIdealVelocity);
                    }
                    currentStyle[key] = styleValue;
                    currentVelocity[key] = 0;
                    lastIdealStyle[key] = styleValue;
                    lastIdealVelocity[key] = 0;
                }
            }
            if (dirty) _this.setState({
                currentStyle: currentStyle,
                currentVelocity: currentVelocity,
                lastIdealStyle: lastIdealStyle,
                lastIdealVelocity: lastIdealVelocity
            });
        };
        this.startAnimationIfNecessary = function() {
            // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
            // call cb? No, otherwise accidental parent rerender causes cb trigger
            _this.animationID = $4300e85b2d265add$var$_raf2["default"](function(timestamp) {
                // check if we need to animate in the first place
                var propsStyle = _this.props.style;
                if ($4300e85b2d265add$var$_shouldStopAnimation2["default"](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
                    if (_this.wasAnimating && _this.props.onRest) _this.props.onRest();
                    // no need to cancel animationID here; shouldn't have any in flight
                    _this.animationID = null;
                    _this.wasAnimating = false;
                    _this.accumulatedTime = 0;
                    return;
                }
                _this.wasAnimating = true;
                var currentTime = timestamp || $4300e85b2d265add$var$_performanceNow2["default"]();
                var timeDelta = currentTime - _this.prevTime;
                _this.prevTime = currentTime;
                _this.accumulatedTime = _this.accumulatedTime + timeDelta;
                // more than 10 frames? prolly switched browser tab. Restart
                if (_this.accumulatedTime > $4300e85b2d265add$var$msPerFrame * 10) _this.accumulatedTime = 0;
                if (_this.accumulatedTime === 0) {
                    // no need to cancel animationID here; shouldn't have any in flight
                    _this.animationID = null;
                    _this.startAnimationIfNecessary();
                    return;
                }
                var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / $4300e85b2d265add$var$msPerFrame) * $4300e85b2d265add$var$msPerFrame) / $4300e85b2d265add$var$msPerFrame;
                var framesToCatchUp = Math.floor(_this.accumulatedTime / $4300e85b2d265add$var$msPerFrame);
                var newLastIdealStyle = {};
                var newLastIdealVelocity = {};
                var newCurrentStyle = {};
                var newCurrentVelocity = {};
                for(var key in propsStyle){
                    if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) continue;
                    var styleValue = propsStyle[key];
                    if (typeof styleValue === "number") {
                        newCurrentStyle[key] = styleValue;
                        newCurrentVelocity[key] = 0;
                        newLastIdealStyle[key] = styleValue;
                        newLastIdealVelocity[key] = 0;
                    } else {
                        var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
                        var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
                        for(var i = 0; i < framesToCatchUp; i++){
                            var _stepper = $4300e85b2d265add$var$_stepper4["default"]($4300e85b2d265add$var$msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                            newLastIdealStyleValue = _stepper[0];
                            newLastIdealVelocityValue = _stepper[1];
                        }
                        var _stepper2 = $4300e85b2d265add$var$_stepper4["default"]($4300e85b2d265add$var$msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                        var nextIdealX = _stepper2[0];
                        var nextIdealV = _stepper2[1];
                        newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
                        newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
                        newLastIdealStyle[key] = newLastIdealStyleValue;
                        newLastIdealVelocity[key] = newLastIdealVelocityValue;
                    }
                }
                _this.animationID = null;
                // the amount we're looped over above
                _this.accumulatedTime -= framesToCatchUp * $4300e85b2d265add$var$msPerFrame;
                _this.setState({
                    currentStyle: newCurrentStyle,
                    currentVelocity: newCurrentVelocity,
                    lastIdealStyle: newLastIdealStyle,
                    lastIdealVelocity: newLastIdealVelocity
                });
                _this.unreadPropStyle = null;
                _this.startAnimationIfNecessary();
            });
        };
        this.state = this.defaultState();
    }
    Motion.prototype.defaultState = function defaultState() {
        var _props = this.props;
        var defaultStyle = _props.defaultStyle;
        var style = _props.style;
        var currentStyle = defaultStyle || $4300e85b2d265add$var$_stripStyle2["default"](style);
        var currentVelocity = $4300e85b2d265add$var$_mapToZero2["default"](currentStyle);
        return {
            currentStyle: currentStyle,
            currentVelocity: currentVelocity,
            lastIdealStyle: currentStyle,
            lastIdealVelocity: currentVelocity
        };
    };
    // it's possible that currentStyle's value is stale: if props is immediately
    // changed from 0 to 400 to spring(0) again, the async currentStyle is still
    // at 0 (didn't have time to tick and interpolate even once). If we naively
    // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
    // In reality currentStyle should be 400
    Motion.prototype.componentDidMount = function componentDidMount() {
        this.prevTime = $4300e85b2d265add$var$_performanceNow2["default"]();
        this.startAnimationIfNecessary();
    };
    Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
        if (this.unreadPropStyle != null) // previous props haven't had the chance to be set yet; set them here
        this.clearUnreadPropStyle(this.unreadPropStyle);
        this.unreadPropStyle = props.style;
        if (this.animationID == null) {
            this.prevTime = $4300e85b2d265add$var$_performanceNow2["default"]();
            this.startAnimationIfNecessary();
        }
    };
    Motion.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.animationID != null) {
            $4300e85b2d265add$var$_raf2["default"].cancel(this.animationID);
            this.animationID = null;
        }
    };
    Motion.prototype.render = function render() {
        var renderedChildren = this.props.children(this.state.currentStyle);
        return renderedChildren && $4300e85b2d265add$var$_react2["default"].Children.only(renderedChildren);
    };
    return Motion;
}($4300e85b2d265add$var$_react2["default"].Component);
module.exports["default"] = $4300e85b2d265add$var$Motion;
module.exports = module.exports["default"]; // after checking for unreadPropStyle != null, we manually go set the
 // non-interpolating values (those that are a number, without a spring
 // config)

});
parcelRegister("jdduT", function(module, exports) {
// currently used to initiate the velocity style object to 0
"use strict";
module.exports.__esModule = true;
module.exports["default"] = $dfc9b37f331d29ab$var$mapToZero;
function $dfc9b37f331d29ab$var$mapToZero(obj) {
    var ret = {};
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) ret[key] = 0;
    return ret;
}
module.exports = module.exports["default"];

});

parcelRegister("cV8KC", function(module, exports) {
// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}
"use strict";
module.exports.__esModule = true;
module.exports["default"] = $968198a567c4b249$var$stripStyle;
function $968198a567c4b249$var$stripStyle(style) {
    var ret = {};
    for(var key in style){
        if (!Object.prototype.hasOwnProperty.call(style, key)) continue;
        ret[key] = typeof style[key] === "number" ? style[key] : style[key].val;
    }
    return ret;
}
module.exports = module.exports["default"];

});

parcelRegister("k59in", function(module, exports) {
// stepper is used a lot. Saves allocation to return the same array wrapper.
// This is fine and danger-free against mutations because the callsite
// immediately destructures it and gets the numbers inside without passing the
"use strict";
module.exports.__esModule = true;
module.exports["default"] = $e9eb7c21cde52ee5$var$stepper;
var $e9eb7c21cde52ee5$var$reusedTuple = [
    0,
    0
];
function $e9eb7c21cde52ee5$var$stepper(secondPerFrame, x, v, destX, k, b, precision) {
    // Spring stiffness, in kg / s^2
    // for animations, destX is really spring length (spring at rest). initial
    // position is considered as the stretched/compressed position of a spring
    var Fspring = -k * (x - destX);
    // Damping, in kg / s
    var Fdamper = -b * v;
    // usually we put mass here, but for animation purposes, specifying mass is a
    // bit redundant. you could simply adjust k and b accordingly
    // let a = (Fspring + Fdamper) / mass;
    var a = Fspring + Fdamper;
    var newV = v + a * secondPerFrame;
    var newX = x + newV * secondPerFrame;
    if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
        $e9eb7c21cde52ee5$var$reusedTuple[0] = destX;
        $e9eb7c21cde52ee5$var$reusedTuple[1] = 0;
        return $e9eb7c21cde52ee5$var$reusedTuple;
    }
    $e9eb7c21cde52ee5$var$reusedTuple[0] = newX;
    $e9eb7c21cde52ee5$var$reusedTuple[1] = newV;
    return $e9eb7c21cde52ee5$var$reusedTuple;
}
module.exports = module.exports["default"]; // array reference around.

});

parcelRegister("eIUbN", function(module, exports) {

var $2Prz7 = parcelRequire("2Prz7");
// Generated by CoffeeScript 1.7.1
(function() {
    var getNanoSeconds, hrtime, loadTime;
    if (typeof performance !== "undefined" && performance !== null && performance.now) module.exports = function() {
        return performance.now();
    };
    else if (typeof $2Prz7 !== "undefined" && $2Prz7 !== null && $2Prz7.hrtime) {
        module.exports = function() {
            return (getNanoSeconds() - loadTime) / 1e6;
        };
        hrtime = $2Prz7.hrtime;
        getNanoSeconds = function() {
            var hr;
            hr = hrtime();
            return hr[0] * 1e9 + hr[1];
        };
        loadTime = getNanoSeconds();
    } else if (Date.now) {
        module.exports = function() {
            return Date.now() - loadTime;
        };
        loadTime = Date.now();
    } else {
        module.exports = function() {
            return new Date().getTime() - loadTime;
        };
        loadTime = new Date().getTime();
    }
}).call(module.exports);

});

parcelRegister("8vZRV", function(module, exports) {

var $79j5b = parcelRequire("79j5b");
var $633135d1eda04438$var$root = typeof window === "undefined" ? $parcel$global : window, $633135d1eda04438$var$vendors = [
    "moz",
    "webkit"
], $633135d1eda04438$var$suffix = "AnimationFrame", $633135d1eda04438$var$raf = $633135d1eda04438$var$root["request" + $633135d1eda04438$var$suffix], $633135d1eda04438$var$caf = $633135d1eda04438$var$root["cancel" + $633135d1eda04438$var$suffix] || $633135d1eda04438$var$root["cancelRequest" + $633135d1eda04438$var$suffix];
for(var $633135d1eda04438$var$i = 0; !$633135d1eda04438$var$raf && $633135d1eda04438$var$i < $633135d1eda04438$var$vendors.length; $633135d1eda04438$var$i++){
    $633135d1eda04438$var$raf = $633135d1eda04438$var$root[$633135d1eda04438$var$vendors[$633135d1eda04438$var$i] + "Request" + $633135d1eda04438$var$suffix];
    $633135d1eda04438$var$caf = $633135d1eda04438$var$root[$633135d1eda04438$var$vendors[$633135d1eda04438$var$i] + "Cancel" + $633135d1eda04438$var$suffix] || $633135d1eda04438$var$root[$633135d1eda04438$var$vendors[$633135d1eda04438$var$i] + "CancelRequest" + $633135d1eda04438$var$suffix];
}
// Some versions of FF have rAF but not cAF
if (!$633135d1eda04438$var$raf || !$633135d1eda04438$var$caf) {
    var $633135d1eda04438$var$last = 0, $633135d1eda04438$var$id = 0, $633135d1eda04438$var$queue = [], $633135d1eda04438$var$frameDuration = 1000 / 60;
    $633135d1eda04438$var$raf = function(callback) {
        if ($633135d1eda04438$var$queue.length === 0) {
            var _now = $79j5b(), next = Math.max(0, $633135d1eda04438$var$frameDuration - (_now - $633135d1eda04438$var$last));
            $633135d1eda04438$var$last = next + _now;
            setTimeout(function() {
                var cp = $633135d1eda04438$var$queue.slice(0);
                // Clear queue here to prevent
                // callbacks from appending listeners
                // to the current frame's queue
                $633135d1eda04438$var$queue.length = 0;
                for(var i = 0; i < cp.length; i++){
                    if (!cp[i].cancelled) try {
                        cp[i].callback($633135d1eda04438$var$last);
                    } catch (e) {
                        setTimeout(function() {
                            throw e;
                        }, 0);
                    }
                }
            }, Math.round(next));
        }
        $633135d1eda04438$var$queue.push({
            handle: ++$633135d1eda04438$var$id,
            callback: callback,
            cancelled: false
        });
        return $633135d1eda04438$var$id;
    };
    $633135d1eda04438$var$caf = function(handle) {
        for(var i = 0; i < $633135d1eda04438$var$queue.length; i++)if ($633135d1eda04438$var$queue[i].handle === handle) $633135d1eda04438$var$queue[i].cancelled = true;
    };
}
module.exports = function(fn) {
    // Wrap in a new function to prevent
    // `cancel` potentially being assigned
    // to the native rAF function
    return $633135d1eda04438$var$raf.call($633135d1eda04438$var$root, fn);
};
module.exports.cancel = function() {
    $633135d1eda04438$var$caf.apply($633135d1eda04438$var$root, arguments);
};
module.exports.polyfill = function(object) {
    if (!object) object = $633135d1eda04438$var$root;
    object.requestAnimationFrame = $633135d1eda04438$var$raf;
    object.cancelAnimationFrame = $633135d1eda04438$var$caf;
};

});
parcelRegister("79j5b", function(module, exports) {

var $2Prz7 = parcelRequire("2Prz7");
// Generated by CoffeeScript 1.12.2
(function() {
    var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
    if (typeof performance !== "undefined" && performance !== null && performance.now) module.exports = function() {
        return performance.now();
    };
    else if (typeof $2Prz7 !== "undefined" && $2Prz7 !== null && $2Prz7.hrtime) {
        module.exports = function() {
            return (getNanoSeconds() - nodeLoadTime) / 1e6;
        };
        hrtime = $2Prz7.hrtime;
        getNanoSeconds = function() {
            var hr;
            hr = hrtime();
            return hr[0] * 1e9 + hr[1];
        };
        moduleLoadTime = getNanoSeconds();
        upTime = $2Prz7.uptime() * 1e9;
        nodeLoadTime = moduleLoadTime - upTime;
    } else if (Date.now) {
        module.exports = function() {
            return Date.now() - loadTime;
        };
        loadTime = Date.now();
    } else {
        module.exports = function() {
            return new Date().getTime() - loadTime;
        };
        loadTime = new Date().getTime();
    }
}).call(module.exports);

});


parcelRegister("avmbi", function(module, exports) {
// usage assumption: currentStyle values have already been rendered but it says
// nothing of whether currentStyle is stale (see unreadPropStyle)
"use strict";
module.exports.__esModule = true;
module.exports["default"] = $7a5e015ec605efdc$var$shouldStopAnimation;
function $7a5e015ec605efdc$var$shouldStopAnimation(currentStyle, style, currentVelocity) {
    for(var key in style){
        if (!Object.prototype.hasOwnProperty.call(style, key)) continue;
        if (currentVelocity[key] !== 0) return false;
        var styleValue = typeof style[key] === "number" ? style[key] : style[key].val;
        // stepper will have already taken care of rounding precision errors, so
        // won't have such thing as 0.9999 !=== 1
        if (currentStyle[key] !== styleValue) return false;
    }
    return true;
}
module.exports = module.exports["default"];

});


parcelRegister("lFSUp", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $fc7805136e9ce3b4$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $fc7805136e9ce3b4$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $fc7805136e9ce3b4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $fc7805136e9ce3b4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $fc7805136e9ce3b4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $jdduT = parcelRequire("jdduT");
var $fc7805136e9ce3b4$var$_mapToZero2 = $fc7805136e9ce3b4$var$_interopRequireDefault($jdduT);

var $cV8KC = parcelRequire("cV8KC");
var $fc7805136e9ce3b4$var$_stripStyle2 = $fc7805136e9ce3b4$var$_interopRequireDefault($cV8KC);

var $k59in = parcelRequire("k59in");
var $fc7805136e9ce3b4$var$_stepper4 = $fc7805136e9ce3b4$var$_interopRequireDefault($k59in);

var $eIUbN = parcelRequire("eIUbN");
var $fc7805136e9ce3b4$var$_performanceNow2 = $fc7805136e9ce3b4$var$_interopRequireDefault($eIUbN);

var $8vZRV = parcelRequire("8vZRV");
var $fc7805136e9ce3b4$var$_raf2 = $fc7805136e9ce3b4$var$_interopRequireDefault($8vZRV);

var $avmbi = parcelRequire("avmbi");
var $fc7805136e9ce3b4$var$_shouldStopAnimation2 = $fc7805136e9ce3b4$var$_interopRequireDefault($avmbi);

var $jbmdS = parcelRequire("jbmdS");
var $fc7805136e9ce3b4$var$_react2 = $fc7805136e9ce3b4$var$_interopRequireDefault($jbmdS);

var $2MXkj = parcelRequire("2MXkj");
var $fc7805136e9ce3b4$var$_propTypes2 = $fc7805136e9ce3b4$var$_interopRequireDefault($2MXkj);
var $fc7805136e9ce3b4$var$msPerFrame = 1000 / 60;
function $fc7805136e9ce3b4$var$shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
    for(var i = 0; i < currentStyles.length; i++){
        if (!$fc7805136e9ce3b4$var$_shouldStopAnimation2["default"](currentStyles[i], styles[i], currentVelocities[i])) return false;
    }
    return true;
}
var $fc7805136e9ce3b4$var$StaggeredMotion = function(_React$Component) {
    $fc7805136e9ce3b4$var$_inherits(StaggeredMotion, _React$Component);
    $fc7805136e9ce3b4$var$_createClass(StaggeredMotion, null, [
        {
            key: "propTypes",
            value: {
                // TOOD: warn against putting a config in here
                defaultStyles: $fc7805136e9ce3b4$var$_propTypes2["default"].arrayOf($fc7805136e9ce3b4$var$_propTypes2["default"].objectOf($fc7805136e9ce3b4$var$_propTypes2["default"].number)),
                styles: $fc7805136e9ce3b4$var$_propTypes2["default"].func.isRequired,
                children: $fc7805136e9ce3b4$var$_propTypes2["default"].func.isRequired
            },
            enumerable: true
        }
    ]);
    function StaggeredMotion(props) {
        var _this = this;
        $fc7805136e9ce3b4$var$_classCallCheck(this, StaggeredMotion);
        _React$Component.call(this, props);
        this.animationID = null;
        this.prevTime = 0;
        this.accumulatedTime = 0;
        this.unreadPropStyles = null;
        this.clearUnreadPropStyle = function(unreadPropStyles) {
            var _state = _this.state;
            var currentStyles = _state.currentStyles;
            var currentVelocities = _state.currentVelocities;
            var lastIdealStyles = _state.lastIdealStyles;
            var lastIdealVelocities = _state.lastIdealVelocities;
            var someDirty = false;
            for(var i = 0; i < unreadPropStyles.length; i++){
                var unreadPropStyle = unreadPropStyles[i];
                var dirty = false;
                for(var key in unreadPropStyle){
                    if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) continue;
                    var styleValue = unreadPropStyle[key];
                    if (typeof styleValue === "number") {
                        if (!dirty) {
                            dirty = true;
                            someDirty = true;
                            currentStyles[i] = $fc7805136e9ce3b4$var$_extends({}, currentStyles[i]);
                            currentVelocities[i] = $fc7805136e9ce3b4$var$_extends({}, currentVelocities[i]);
                            lastIdealStyles[i] = $fc7805136e9ce3b4$var$_extends({}, lastIdealStyles[i]);
                            lastIdealVelocities[i] = $fc7805136e9ce3b4$var$_extends({}, lastIdealVelocities[i]);
                        }
                        currentStyles[i][key] = styleValue;
                        currentVelocities[i][key] = 0;
                        lastIdealStyles[i][key] = styleValue;
                        lastIdealVelocities[i][key] = 0;
                    }
                }
            }
            if (someDirty) _this.setState({
                currentStyles: currentStyles,
                currentVelocities: currentVelocities,
                lastIdealStyles: lastIdealStyles,
                lastIdealVelocities: lastIdealVelocities
            });
        };
        this.startAnimationIfNecessary = function() {
            // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
            // call cb? No, otherwise accidental parent rerender causes cb trigger
            _this.animationID = $fc7805136e9ce3b4$var$_raf2["default"](function(timestamp) {
                var destStyles = _this.props.styles(_this.state.lastIdealStyles);
                // check if we need to animate in the first place
                if ($fc7805136e9ce3b4$var$shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
                    // no need to cancel animationID here; shouldn't have any in flight
                    _this.animationID = null;
                    _this.accumulatedTime = 0;
                    return;
                }
                var currentTime = timestamp || $fc7805136e9ce3b4$var$_performanceNow2["default"]();
                var timeDelta = currentTime - _this.prevTime;
                _this.prevTime = currentTime;
                _this.accumulatedTime = _this.accumulatedTime + timeDelta;
                // more than 10 frames? prolly switched browser tab. Restart
                if (_this.accumulatedTime > $fc7805136e9ce3b4$var$msPerFrame * 10) _this.accumulatedTime = 0;
                if (_this.accumulatedTime === 0) {
                    // no need to cancel animationID here; shouldn't have any in flight
                    _this.animationID = null;
                    _this.startAnimationIfNecessary();
                    return;
                }
                var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / $fc7805136e9ce3b4$var$msPerFrame) * $fc7805136e9ce3b4$var$msPerFrame) / $fc7805136e9ce3b4$var$msPerFrame;
                var framesToCatchUp = Math.floor(_this.accumulatedTime / $fc7805136e9ce3b4$var$msPerFrame);
                var newLastIdealStyles = [];
                var newLastIdealVelocities = [];
                var newCurrentStyles = [];
                var newCurrentVelocities = [];
                for(var i = 0; i < destStyles.length; i++){
                    var destStyle = destStyles[i];
                    var newCurrentStyle = {};
                    var newCurrentVelocity = {};
                    var newLastIdealStyle = {};
                    var newLastIdealVelocity = {};
                    for(var key in destStyle){
                        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) continue;
                        var styleValue = destStyle[key];
                        if (typeof styleValue === "number") {
                            newCurrentStyle[key] = styleValue;
                            newCurrentVelocity[key] = 0;
                            newLastIdealStyle[key] = styleValue;
                            newLastIdealVelocity[key] = 0;
                        } else {
                            var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
                            var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
                            for(var j = 0; j < framesToCatchUp; j++){
                                var _stepper = $fc7805136e9ce3b4$var$_stepper4["default"]($fc7805136e9ce3b4$var$msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                                newLastIdealStyleValue = _stepper[0];
                                newLastIdealVelocityValue = _stepper[1];
                            }
                            var _stepper2 = $fc7805136e9ce3b4$var$_stepper4["default"]($fc7805136e9ce3b4$var$msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                            var nextIdealX = _stepper2[0];
                            var nextIdealV = _stepper2[1];
                            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
                            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
                            newLastIdealStyle[key] = newLastIdealStyleValue;
                            newLastIdealVelocity[key] = newLastIdealVelocityValue;
                        }
                    }
                    newCurrentStyles[i] = newCurrentStyle;
                    newCurrentVelocities[i] = newCurrentVelocity;
                    newLastIdealStyles[i] = newLastIdealStyle;
                    newLastIdealVelocities[i] = newLastIdealVelocity;
                }
                _this.animationID = null;
                // the amount we're looped over above
                _this.accumulatedTime -= framesToCatchUp * $fc7805136e9ce3b4$var$msPerFrame;
                _this.setState({
                    currentStyles: newCurrentStyles,
                    currentVelocities: newCurrentVelocities,
                    lastIdealStyles: newLastIdealStyles,
                    lastIdealVelocities: newLastIdealVelocities
                });
                _this.unreadPropStyles = null;
                _this.startAnimationIfNecessary();
            });
        };
        this.state = this.defaultState();
    }
    StaggeredMotion.prototype.defaultState = function defaultState() {
        var _props = this.props;
        var defaultStyles = _props.defaultStyles;
        var styles = _props.styles;
        var currentStyles = defaultStyles || styles().map($fc7805136e9ce3b4$var$_stripStyle2["default"]);
        var currentVelocities = currentStyles.map(function(currentStyle) {
            return $fc7805136e9ce3b4$var$_mapToZero2["default"](currentStyle);
        });
        return {
            currentStyles: currentStyles,
            currentVelocities: currentVelocities,
            lastIdealStyles: currentStyles,
            lastIdealVelocities: currentVelocities
        };
    };
    StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
        this.prevTime = $fc7805136e9ce3b4$var$_performanceNow2["default"]();
        this.startAnimationIfNecessary();
    };
    StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
        if (this.unreadPropStyles != null) // previous props haven't had the chance to be set yet; set them here
        this.clearUnreadPropStyle(this.unreadPropStyles);
        this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
        if (this.animationID == null) {
            this.prevTime = $fc7805136e9ce3b4$var$_performanceNow2["default"]();
            this.startAnimationIfNecessary();
        }
    };
    StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.animationID != null) {
            $fc7805136e9ce3b4$var$_raf2["default"].cancel(this.animationID);
            this.animationID = null;
        }
    };
    StaggeredMotion.prototype.render = function render() {
        var renderedChildren = this.props.children(this.state.currentStyles);
        return renderedChildren && $fc7805136e9ce3b4$var$_react2["default"].Children.only(renderedChildren);
    };
    return StaggeredMotion;
}($fc7805136e9ce3b4$var$_react2["default"].Component);
module.exports["default"] = $fc7805136e9ce3b4$var$StaggeredMotion;
module.exports = module.exports["default"]; // it's possible that currentStyle's value is stale: if props is immediately
 // changed from 0 to 400 to spring(0) again, the async currentStyle is still
 // at 0 (didn't have time to tick and interpolate even once). If we naively
 // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
 // In reality currentStyle should be 400
 // after checking for unreadPropStyles != null, we manually go set the
 // non-interpolating values (those that are a number, without a spring
 // config)

});

parcelRegister("cGHX4", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $02624000da6bc229$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $02624000da6bc229$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $02624000da6bc229$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $02624000da6bc229$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $02624000da6bc229$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $jdduT = parcelRequire("jdduT");
var $02624000da6bc229$var$_mapToZero2 = $02624000da6bc229$var$_interopRequireDefault($jdduT);

var $cV8KC = parcelRequire("cV8KC");
var $02624000da6bc229$var$_stripStyle2 = $02624000da6bc229$var$_interopRequireDefault($cV8KC);

var $k59in = parcelRequire("k59in");
var $02624000da6bc229$var$_stepper4 = $02624000da6bc229$var$_interopRequireDefault($k59in);

var $4CwFU = parcelRequire("4CwFU");
var $02624000da6bc229$var$_mergeDiff2 = $02624000da6bc229$var$_interopRequireDefault($4CwFU);

var $eIUbN = parcelRequire("eIUbN");
var $02624000da6bc229$var$_performanceNow2 = $02624000da6bc229$var$_interopRequireDefault($eIUbN);

var $8vZRV = parcelRequire("8vZRV");
var $02624000da6bc229$var$_raf2 = $02624000da6bc229$var$_interopRequireDefault($8vZRV);

var $avmbi = parcelRequire("avmbi");
var $02624000da6bc229$var$_shouldStopAnimation2 = $02624000da6bc229$var$_interopRequireDefault($avmbi);

var $jbmdS = parcelRequire("jbmdS");
var $02624000da6bc229$var$_react2 = $02624000da6bc229$var$_interopRequireDefault($jbmdS);

var $2MXkj = parcelRequire("2MXkj");
var $02624000da6bc229$var$_propTypes2 = $02624000da6bc229$var$_interopRequireDefault($2MXkj);
var $02624000da6bc229$var$msPerFrame = 1000 / 60;
// the children function & (potential) styles function asks as param an
// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
// {key: string, data?: any, style: PlainStyle}. However, the way we keep
// internal states doesn't contain such a data structure (check the state and
// TransitionMotionState). So when children function and others ask for such
// data we need to generate them on the fly by combining mergedPropsStyles and
// currentStyles/lastIdealStyles
function $02624000da6bc229$var$rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
    // Copy the value to a `const` so that Flow understands that the const won't
    // change and will be non-nullable in the callback below.
    var cUnreadPropStyles = unreadPropStyles;
    if (cUnreadPropStyles == null) return mergedPropsStyles.map(function(mergedPropsStyle, i) {
        return {
            key: mergedPropsStyle.key,
            data: mergedPropsStyle.data,
            style: plainStyles[i]
        };
    });
    return mergedPropsStyles.map(function(mergedPropsStyle, i) {
        for(var j = 0; j < cUnreadPropStyles.length; j++){
            if (cUnreadPropStyles[j].key === mergedPropsStyle.key) return {
                key: cUnreadPropStyles[j].key,
                data: cUnreadPropStyles[j].data,
                style: plainStyles[i]
            };
        }
        return {
            key: mergedPropsStyle.key,
            data: mergedPropsStyle.data,
            style: plainStyles[i]
        };
    });
}
function $02624000da6bc229$var$shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
    if (mergedPropsStyles.length !== destStyles.length) return false;
    for(var i = 0; i < mergedPropsStyles.length; i++){
        if (mergedPropsStyles[i].key !== destStyles[i].key) return false;
    }
    // we have the invariant that mergedPropsStyles and
    // currentStyles/currentVelocities/last* are synced in terms of cells, see
    // mergeAndSync comment for more info
    for(var i = 0; i < mergedPropsStyles.length; i++){
        if (!$02624000da6bc229$var$_shouldStopAnimation2["default"](currentStyles[i], destStyles[i].style, currentVelocities[i])) return false;
    }
    return true;
}
// core key merging logic
// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
// c}, previous current (interpolating) style is {a, b}
// **invariant**: current[i] corresponds to merged[i] in terms of key
// steps:
// turn merged style into {a?, b, c}
//    add c, value of c is destStyles.c
//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
// turn current (interpolating) style from {a, b} into {a?, b, c}
//    maybe remove a
//    certainly add c, value of c is willEnter(c)
// loop over merged and construct new current
// dest doesn't change, that's owner's
function $02624000da6bc229$var$mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
    var newMergedPropsStyles = $02624000da6bc229$var$_mergeDiff2["default"](oldMergedPropsStyles, destStyles, function(oldIndex, oldMergedPropsStyle) {
        var leavingStyle = willLeave(oldMergedPropsStyle);
        if (leavingStyle == null) {
            didLeave({
                key: oldMergedPropsStyle.key,
                data: oldMergedPropsStyle.data
            });
            return null;
        }
        if ($02624000da6bc229$var$_shouldStopAnimation2["default"](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
            didLeave({
                key: oldMergedPropsStyle.key,
                data: oldMergedPropsStyle.data
            });
            return null;
        }
        return {
            key: oldMergedPropsStyle.key,
            data: oldMergedPropsStyle.data,
            style: leavingStyle
        };
    });
    var newCurrentStyles = [];
    var newCurrentVelocities = [];
    var newLastIdealStyles = [];
    var newLastIdealVelocities = [];
    for(var i = 0; i < newMergedPropsStyles.length; i++){
        var newMergedPropsStyleCell = newMergedPropsStyles[i];
        var foundOldIndex = null;
        for(var j = 0; j < oldMergedPropsStyles.length; j++)if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
            foundOldIndex = j;
            break;
        }
        // TODO: key search code
        if (foundOldIndex == null) {
            var plainStyle = willEnter(newMergedPropsStyleCell);
            newCurrentStyles[i] = plainStyle;
            newLastIdealStyles[i] = plainStyle;
            var velocity = $02624000da6bc229$var$_mapToZero2["default"](newMergedPropsStyleCell.style);
            newCurrentVelocities[i] = velocity;
            newLastIdealVelocities[i] = velocity;
        } else {
            newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
            newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
            newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
            newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
        }
    }
    return [
        newMergedPropsStyles,
        newCurrentStyles,
        newCurrentVelocities,
        newLastIdealStyles,
        newLastIdealVelocities
    ];
}
var $02624000da6bc229$var$TransitionMotion = function(_React$Component) {
    $02624000da6bc229$var$_inherits(TransitionMotion, _React$Component);
    $02624000da6bc229$var$_createClass(TransitionMotion, null, [
        {
            key: "propTypes",
            value: {
                defaultStyles: $02624000da6bc229$var$_propTypes2["default"].arrayOf($02624000da6bc229$var$_propTypes2["default"].shape({
                    key: $02624000da6bc229$var$_propTypes2["default"].string.isRequired,
                    data: $02624000da6bc229$var$_propTypes2["default"].any,
                    style: $02624000da6bc229$var$_propTypes2["default"].objectOf($02624000da6bc229$var$_propTypes2["default"].number).isRequired
                })),
                styles: $02624000da6bc229$var$_propTypes2["default"].oneOfType([
                    $02624000da6bc229$var$_propTypes2["default"].func,
                    $02624000da6bc229$var$_propTypes2["default"].arrayOf($02624000da6bc229$var$_propTypes2["default"].shape({
                        key: $02624000da6bc229$var$_propTypes2["default"].string.isRequired,
                        data: $02624000da6bc229$var$_propTypes2["default"].any,
                        style: $02624000da6bc229$var$_propTypes2["default"].objectOf($02624000da6bc229$var$_propTypes2["default"].oneOfType([
                            $02624000da6bc229$var$_propTypes2["default"].number,
                            $02624000da6bc229$var$_propTypes2["default"].object
                        ])).isRequired
                    }))
                ]).isRequired,
                children: $02624000da6bc229$var$_propTypes2["default"].func.isRequired,
                willEnter: $02624000da6bc229$var$_propTypes2["default"].func,
                willLeave: $02624000da6bc229$var$_propTypes2["default"].func,
                didLeave: $02624000da6bc229$var$_propTypes2["default"].func
            },
            enumerable: true
        },
        {
            key: "defaultProps",
            value: {
                willEnter: function willEnter(styleThatEntered) {
                    return $02624000da6bc229$var$_stripStyle2["default"](styleThatEntered.style);
                },
                // recall: returning null makes the current unmounting TransitionStyle
                // disappear immediately
                willLeave: function willLeave() {
                    return null;
                },
                didLeave: function didLeave() {}
            },
            enumerable: true
        }
    ]);
    function TransitionMotion(props) {
        var _this = this;
        $02624000da6bc229$var$_classCallCheck(this, TransitionMotion);
        _React$Component.call(this, props);
        this.unmounting = false;
        this.animationID = null;
        this.prevTime = 0;
        this.accumulatedTime = 0;
        this.unreadPropStyles = null;
        this.clearUnreadPropStyle = function(unreadPropStyles) {
            var _mergeAndSync = $02624000da6bc229$var$mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
            var mergedPropsStyles = _mergeAndSync[0];
            var currentStyles = _mergeAndSync[1];
            var currentVelocities = _mergeAndSync[2];
            var lastIdealStyles = _mergeAndSync[3];
            var lastIdealVelocities = _mergeAndSync[4];
            for(var i = 0; i < unreadPropStyles.length; i++){
                var unreadPropStyle = unreadPropStyles[i].style;
                var dirty = false;
                for(var key in unreadPropStyle){
                    if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) continue;
                    var styleValue = unreadPropStyle[key];
                    if (typeof styleValue === "number") {
                        if (!dirty) {
                            dirty = true;
                            currentStyles[i] = $02624000da6bc229$var$_extends({}, currentStyles[i]);
                            currentVelocities[i] = $02624000da6bc229$var$_extends({}, currentVelocities[i]);
                            lastIdealStyles[i] = $02624000da6bc229$var$_extends({}, lastIdealStyles[i]);
                            lastIdealVelocities[i] = $02624000da6bc229$var$_extends({}, lastIdealVelocities[i]);
                            mergedPropsStyles[i] = {
                                key: mergedPropsStyles[i].key,
                                data: mergedPropsStyles[i].data,
                                style: $02624000da6bc229$var$_extends({}, mergedPropsStyles[i].style)
                            };
                        }
                        currentStyles[i][key] = styleValue;
                        currentVelocities[i][key] = 0;
                        lastIdealStyles[i][key] = styleValue;
                        lastIdealVelocities[i][key] = 0;
                        mergedPropsStyles[i].style[key] = styleValue;
                    }
                }
            }
            // unlike the other 2 components, we can't detect staleness and optionally
            // opt out of setState here. each style object's data might contain new
            // stuff we're not/cannot compare
            _this.setState({
                currentStyles: currentStyles,
                currentVelocities: currentVelocities,
                mergedPropsStyles: mergedPropsStyles,
                lastIdealStyles: lastIdealStyles,
                lastIdealVelocities: lastIdealVelocities
            });
        };
        this.startAnimationIfNecessary = function() {
            if (_this.unmounting) return;
            // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
            // call cb? No, otherwise accidental parent rerender causes cb trigger
            _this.animationID = $02624000da6bc229$var$_raf2["default"](function(timestamp) {
                // https://github.com/chenglou/react-motion/pull/420
                // > if execution passes the conditional if (this.unmounting), then
                // executes async defaultRaf and after that component unmounts and after
                // that the callback of defaultRaf is called, then setState will be called
                // on unmounted component.
                if (_this.unmounting) return;
                var propStyles = _this.props.styles;
                var destStyles = typeof propStyles === "function" ? propStyles($02624000da6bc229$var$rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;
                // check if we need to animate in the first place
                if ($02624000da6bc229$var$shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
                    // no need to cancel animationID here; shouldn't have any in flight
                    _this.animationID = null;
                    _this.accumulatedTime = 0;
                    return;
                }
                var currentTime = timestamp || $02624000da6bc229$var$_performanceNow2["default"]();
                var timeDelta = currentTime - _this.prevTime;
                _this.prevTime = currentTime;
                _this.accumulatedTime = _this.accumulatedTime + timeDelta;
                // more than 10 frames? prolly switched browser tab. Restart
                if (_this.accumulatedTime > $02624000da6bc229$var$msPerFrame * 10) _this.accumulatedTime = 0;
                if (_this.accumulatedTime === 0) {
                    // no need to cancel animationID here; shouldn't have any in flight
                    _this.animationID = null;
                    _this.startAnimationIfNecessary();
                    return;
                }
                var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / $02624000da6bc229$var$msPerFrame) * $02624000da6bc229$var$msPerFrame) / $02624000da6bc229$var$msPerFrame;
                var framesToCatchUp = Math.floor(_this.accumulatedTime / $02624000da6bc229$var$msPerFrame);
                var _mergeAndSync2 = $02624000da6bc229$var$mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
                var newMergedPropsStyles = _mergeAndSync2[0];
                var newCurrentStyles = _mergeAndSync2[1];
                var newCurrentVelocities = _mergeAndSync2[2];
                var newLastIdealStyles = _mergeAndSync2[3];
                var newLastIdealVelocities = _mergeAndSync2[4];
                for(var i = 0; i < newMergedPropsStyles.length; i++){
                    var newMergedPropsStyle = newMergedPropsStyles[i].style;
                    var newCurrentStyle = {};
                    var newCurrentVelocity = {};
                    var newLastIdealStyle = {};
                    var newLastIdealVelocity = {};
                    for(var key in newMergedPropsStyle){
                        if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) continue;
                        var styleValue = newMergedPropsStyle[key];
                        if (typeof styleValue === "number") {
                            newCurrentStyle[key] = styleValue;
                            newCurrentVelocity[key] = 0;
                            newLastIdealStyle[key] = styleValue;
                            newLastIdealVelocity[key] = 0;
                        } else {
                            var newLastIdealStyleValue = newLastIdealStyles[i][key];
                            var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
                            for(var j = 0; j < framesToCatchUp; j++){
                                var _stepper = $02624000da6bc229$var$_stepper4["default"]($02624000da6bc229$var$msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                                newLastIdealStyleValue = _stepper[0];
                                newLastIdealVelocityValue = _stepper[1];
                            }
                            var _stepper2 = $02624000da6bc229$var$_stepper4["default"]($02624000da6bc229$var$msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                            var nextIdealX = _stepper2[0];
                            var nextIdealV = _stepper2[1];
                            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
                            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
                            newLastIdealStyle[key] = newLastIdealStyleValue;
                            newLastIdealVelocity[key] = newLastIdealVelocityValue;
                        }
                    }
                    newLastIdealStyles[i] = newLastIdealStyle;
                    newLastIdealVelocities[i] = newLastIdealVelocity;
                    newCurrentStyles[i] = newCurrentStyle;
                    newCurrentVelocities[i] = newCurrentVelocity;
                }
                _this.animationID = null;
                // the amount we're looped over above
                _this.accumulatedTime -= framesToCatchUp * $02624000da6bc229$var$msPerFrame;
                _this.setState({
                    currentStyles: newCurrentStyles,
                    currentVelocities: newCurrentVelocities,
                    lastIdealStyles: newLastIdealStyles,
                    lastIdealVelocities: newLastIdealVelocities,
                    mergedPropsStyles: newMergedPropsStyles
                });
                _this.unreadPropStyles = null;
                _this.startAnimationIfNecessary();
            });
        };
        this.state = this.defaultState();
    }
    TransitionMotion.prototype.defaultState = function defaultState() {
        var _props = this.props;
        var defaultStyles = _props.defaultStyles;
        var styles = _props.styles;
        var willEnter = _props.willEnter;
        var willLeave = _props.willLeave;
        var didLeave = _props.didLeave;
        var destStyles = typeof styles === "function" ? styles(defaultStyles) : styles;
        // this is special. for the first time around, we don't have a comparison
        // between last (no last) and current merged props. we'll compute last so:
        // say default is {a, b} and styles (dest style) is {b, c}, we'll
        // fabricate last as {a, b}
        var oldMergedPropsStyles = undefined;
        if (defaultStyles == null) oldMergedPropsStyles = destStyles;
        else oldMergedPropsStyles = defaultStyles.map(function(defaultStyleCell) {
            // TODO: key search code
            for(var i = 0; i < destStyles.length; i++){
                if (destStyles[i].key === defaultStyleCell.key) return destStyles[i];
            }
            return defaultStyleCell;
        });
        var oldCurrentStyles = defaultStyles == null ? destStyles.map(function(s) {
            return $02624000da6bc229$var$_stripStyle2["default"](s.style);
        }) : defaultStyles.map(function(s) {
            return $02624000da6bc229$var$_stripStyle2["default"](s.style);
        });
        var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function(s) {
            return $02624000da6bc229$var$_mapToZero2["default"](s.style);
        }) : defaultStyles.map(function(s) {
            return $02624000da6bc229$var$_mapToZero2["default"](s.style);
        });
        var _mergeAndSync3 = $02624000da6bc229$var$mergeAndSync(// Because this is an old-style createReactClass component, Flow doesn't
        // understand that the willEnter and willLeave props have default values
        // and will always be present.
        willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, oldCurrentVelocities);
        var mergedPropsStyles = _mergeAndSync3[0];
        var currentStyles = _mergeAndSync3[1];
        var currentVelocities = _mergeAndSync3[2];
        var lastIdealStyles = _mergeAndSync3[3];
        var lastIdealVelocities = _mergeAndSync3[4];
        // oldLastIdealVelocities really
        return {
            currentStyles: currentStyles,
            currentVelocities: currentVelocities,
            lastIdealStyles: lastIdealStyles,
            lastIdealVelocities: lastIdealVelocities,
            mergedPropsStyles: mergedPropsStyles
        };
    };
    // after checking for unreadPropStyles != null, we manually go set the
    // non-interpolating values (those that are a number, without a spring
    // config)
    TransitionMotion.prototype.componentDidMount = function componentDidMount() {
        this.prevTime = $02624000da6bc229$var$_performanceNow2["default"]();
        this.startAnimationIfNecessary();
    };
    TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
        if (this.unreadPropStyles) // previous props haven't had the chance to be set yet; set them here
        this.clearUnreadPropStyle(this.unreadPropStyles);
        var styles = props.styles;
        if (typeof styles === "function") this.unreadPropStyles = styles($02624000da6bc229$var$rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
        else this.unreadPropStyles = styles;
        if (this.animationID == null) {
            this.prevTime = $02624000da6bc229$var$_performanceNow2["default"]();
            this.startAnimationIfNecessary();
        }
    };
    TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unmounting = true;
        if (this.animationID != null) {
            $02624000da6bc229$var$_raf2["default"].cancel(this.animationID);
            this.animationID = null;
        }
    };
    TransitionMotion.prototype.render = function render() {
        var hydratedStyles = $02624000da6bc229$var$rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
        var renderedChildren = this.props.children(hydratedStyles);
        return renderedChildren && $02624000da6bc229$var$_react2["default"].Children.only(renderedChildren);
    };
    return TransitionMotion;
}($02624000da6bc229$var$_react2["default"].Component);
module.exports["default"] = $02624000da6bc229$var$TransitionMotion;
module.exports = module.exports["default"]; // list of styles, each containing interpolating values. Part of what's passed
 // to children function. Notice that this is
 // Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
 // data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
 // contains the key & data info (so that we only have a single source of truth
 // for these, and to save space). Check the comment for `rehydrateStyles` to
 // see how we regenerate the entirety of what's passed to children function
 // the array that keeps track of currently rendered stuff! Including stuff
 // that you've unmounted but that's still animating. This is where it lives
 // it's possible that currentStyle's value is stale: if props is immediately
 // changed from 0 to 400 to spring(0) again, the async currentStyle is still
 // at 0 (didn't have time to tick and interpolate even once). If we naively
 // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
 // In reality currentStyle should be 400

});
parcelRegister("4CwFU", function(module, exports) {
// core keys merging algorithm. If previous render's keys are [a, b], and the
// next render's [c, b, d], what's the final merged keys and ordering?
// - c and a must both be before b
// - b before d
// - ordering between a and c ambiguous
// this reduces to merging two partially ordered lists (e.g. lists where not
// every item has a definite ordering, like comparing a and c above). For the
// ambiguous ordering we deterministically choose to place the next render's
// item after the previous'; so c after a
// this is called a topological sorting. Except the existing algorithms don't
// work well with js bc of the amount of allocation, and isn't optimized for our
// current use-case bc the runtime is linear in terms of edges (see wiki for
// meaning), which is huge when two lists have many common elements
"use strict";
module.exports.__esModule = true;
module.exports["default"] = $35d40e9d5cae63b9$var$mergeDiff;
function $35d40e9d5cae63b9$var$mergeDiff(prev, next, onRemove) {
    // bookkeeping for easier access of a key's index below. This is 2 allocations +
    // potentially triggering chrome hash map mode for objs (so it might be faster
    var prevKeyIndex = {};
    for(var i = 0; i < prev.length; i++)prevKeyIndex[prev[i].key] = i;
    var nextKeyIndex = {};
    for(var i = 0; i < next.length; i++)nextKeyIndex[next[i].key] = i;
    // first, an overly elaborate way of merging prev and next, eliminating
    // duplicates (in terms of keys). If there's dupe, keep the item in next).
    // This way of writing it saves allocations
    var ret = [];
    for(var i = 0; i < next.length; i++)ret[i] = next[i];
    for(var i = 0; i < prev.length; i++)if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
        // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
        // merge in keys that the user desires to kill
        var fill = onRemove(i, prev[i]);
        if (fill != null) ret.push(fill);
    }
    // now all the items all present. Core sorting logic to have the right order
    return ret.sort(function(a, b) {
        var nextOrderA = nextKeyIndex[a.key];
        var nextOrderB = nextKeyIndex[b.key];
        var prevOrderA = prevKeyIndex[a.key];
        var prevOrderB = prevKeyIndex[b.key];
        if (nextOrderA != null && nextOrderB != null) // both keys in next
        return nextKeyIndex[a.key] - nextKeyIndex[b.key];
        else if (prevOrderA != null && prevOrderB != null) // both keys in prev
        return prevKeyIndex[a.key] - prevKeyIndex[b.key];
        else if (nextOrderA != null) {
            // key a in next, key b in prev
            // how to determine the order between a and b? We find a "pivot" (term
            // abuse), a key present in both prev and next, that is sandwiched between
            // a and b. In the context of our above example, if we're comparing a and
            // d, b's (the only) pivot
            for(var i = 0; i < next.length; i++){
                var pivot = next[i].key;
                if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) continue;
                if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) return -1;
                else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) return 1;
            }
            // pluggable. default to: next bigger than prev
            return 1;
        }
        // prevOrderA, nextOrderB
        for(var i = 0; i < next.length; i++){
            var pivot = next[i].key;
            if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) continue;
            if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) return 1;
            else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) return -1;
        }
        // pluggable. default to: next bigger than prev
        return -1;
    });
}
module.exports = module.exports["default"]; // to loop through and find a key's index each time), but I no longer care

});


parcelRegister("iFZhI", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $d98b98370029af86$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
module.exports["default"] = $d98b98370029af86$var$spring;
function $d98b98370029af86$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $hbnss = parcelRequire("hbnss");
var $d98b98370029af86$var$_presets2 = $d98b98370029af86$var$_interopRequireDefault($hbnss);
var $d98b98370029af86$var$defaultConfig = $d98b98370029af86$var$_extends({}, $d98b98370029af86$var$_presets2["default"].noWobble, {
    precision: 0.01
});
function $d98b98370029af86$var$spring(val, config) {
    return $d98b98370029af86$var$_extends({}, $d98b98370029af86$var$defaultConfig, config, {
        val: val
    });
}
module.exports = module.exports["default"];

});
parcelRegister("hbnss", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = {
    noWobble: {
        stiffness: 170,
        damping: 26
    },
    gentle: {
        stiffness: 120,
        damping: 14
    },
    wobbly: {
        stiffness: 180,
        damping: 12
    },
    stiff: {
        stiffness: 210,
        damping: 20
    }
};
module.exports = module.exports["default"];

});


parcelRegister("7dDLg", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = $015b3c3e54bcaab1$var$reorderKeys;
var $015b3c3e54bcaab1$var$hasWarned = false;
function $015b3c3e54bcaab1$var$reorderKeys() {}
module.exports = module.exports["default"];

});


parcelRegister("9wVsN", function(module, exports) {

var $2Prz7 = parcelRequire("2Prz7");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function stringifiable(obj) {
    // Safely stringify Object.create(null)
    /* istanbul ignore next */ return typeof obj === "object" && !("toString" in obj) ? Object.prototype.toString.call(obj).slice(8, -1) : obj;
}
var isProduction = typeof $2Prz7 === "object" && true;
function invariant(condition, message) {
    if (!condition) {
        /* istanbul ignore next */ if (isProduction) throw new Error("Invariant failed");
        throw new Error(message());
    }
}
exports.invariant = invariant;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var splice = Array.prototype.splice;
var toString = Object.prototype.toString;
function type(obj) {
    return toString.call(obj).slice(8, -1);
}
var assign = Object.assign || /* istanbul ignore next */ function(target, source) {
    getAllKeys(source).forEach(function(key) {
        if (hasOwnProperty.call(source, key)) target[key] = source[key];
    });
    return target;
};
var getAllKeys = typeof Object.getOwnPropertySymbols === "function" ? function(obj) {
    return Object.keys(obj).concat(Object.getOwnPropertySymbols(obj));
} : function(obj) {
    return Object.keys(obj);
};
function copy(object) {
    return Array.isArray(object) ? assign(object.constructor(object.length), object) : type(object) === "Map" ? new Map(object) : type(object) === "Set" ? new Set(object) : object && typeof object === "object" ? assign(Object.create(Object.getPrototypeOf(object)), object) : object;
}
var Context = /** @class */ function() {
    function Context() {
        this.commands = assign({}, defaultCommands);
        this.update = this.update.bind(this);
        // Deprecated: update.extend, update.isEquals and update.newContext
        this.update.extend = this.extend = this.extend.bind(this);
        this.update.isEquals = function(x, y) {
            return x === y;
        };
        this.update.newContext = function() {
            return new Context().update;
        };
    }
    Object.defineProperty(Context.prototype, "isEquals", {
        get: function() {
            return this.update.isEquals;
        },
        set: function(value) {
            this.update.isEquals = value;
        },
        enumerable: true,
        configurable: true
    });
    Context.prototype.extend = function(directive, fn) {
        this.commands[directive] = fn;
    };
    Context.prototype.update = function(object, $spec) {
        var _this = this;
        var spec = typeof $spec === "function" ? {
            $apply: $spec
        } : $spec;
        if (!(Array.isArray(object) && Array.isArray(spec))) invariant(!Array.isArray(spec), function() {
            return "update(): You provided an invalid spec to update(). The spec may not contain an array except as the value of $set, $push, $unshift, $splice or any custom command allowing an array value.";
        });
        invariant(typeof spec === "object" && spec !== null, function() {
            return "update(): You provided an invalid spec to update(). The spec and every included key path must be plain objects containing one of the " + ("following commands: " + Object.keys(_this.commands).join(", ") + ".");
        });
        var nextObject = object;
        getAllKeys(spec).forEach(function(key) {
            if (hasOwnProperty.call(_this.commands, key)) {
                var objectWasNextObject = object === nextObject;
                nextObject = _this.commands[key](spec[key], nextObject, spec, object);
                if (objectWasNextObject && _this.isEquals(nextObject, object)) nextObject = object;
            } else {
                var nextValueForKey = type(object) === "Map" ? _this.update(object.get(key), spec[key]) : _this.update(object[key], spec[key]);
                var nextObjectValue = type(nextObject) === "Map" ? nextObject.get(key) : nextObject[key];
                if (!_this.isEquals(nextValueForKey, nextObjectValue) || typeof nextValueForKey === "undefined" && !hasOwnProperty.call(object, key)) {
                    if (nextObject === object) nextObject = copy(object);
                    if (type(nextObject) === "Map") nextObject.set(key, nextValueForKey);
                    else nextObject[key] = nextValueForKey;
                }
            }
        });
        return nextObject;
    };
    return Context;
}();
exports.Context = Context;
var defaultCommands = {
    $push: function(value, nextObject, spec) {
        invariantPushAndUnshift(nextObject, spec, "$push");
        return value.length ? nextObject.concat(value) : nextObject;
    },
    $unshift: function(value, nextObject, spec) {
        invariantPushAndUnshift(nextObject, spec, "$unshift");
        return value.length ? value.concat(nextObject) : nextObject;
    },
    $splice: function(value, nextObject, spec, originalObject) {
        invariantSplices(nextObject, spec);
        value.forEach(function(args) {
            invariantSplice(args);
            if (nextObject === originalObject && args.length) nextObject = copy(originalObject);
            splice.apply(nextObject, args);
        });
        return nextObject;
    },
    $set: function(value, _nextObject, spec) {
        invariantSet(spec);
        return value;
    },
    $toggle: function(targets, nextObject) {
        invariantSpecArray(targets, "$toggle");
        var nextObjectCopy = targets.length ? copy(nextObject) : nextObject;
        targets.forEach(function(target) {
            nextObjectCopy[target] = !nextObject[target];
        });
        return nextObjectCopy;
    },
    $unset: function(value, nextObject, _spec, originalObject) {
        invariantSpecArray(value, "$unset");
        value.forEach(function(key) {
            if (Object.hasOwnProperty.call(nextObject, key)) {
                if (nextObject === originalObject) nextObject = copy(originalObject);
                delete nextObject[key];
            }
        });
        return nextObject;
    },
    $add: function(values, nextObject, _spec, originalObject) {
        invariantMapOrSet(nextObject, "$add");
        invariantSpecArray(values, "$add");
        if (type(nextObject) === "Map") values.forEach(function(_a) {
            var key = _a[0], value = _a[1];
            if (nextObject === originalObject && nextObject.get(key) !== value) nextObject = copy(originalObject);
            nextObject.set(key, value);
        });
        else values.forEach(function(value) {
            if (nextObject === originalObject && !nextObject.has(value)) nextObject = copy(originalObject);
            nextObject.add(value);
        });
        return nextObject;
    },
    $remove: function(value, nextObject, _spec, originalObject) {
        invariantMapOrSet(nextObject, "$remove");
        invariantSpecArray(value, "$remove");
        value.forEach(function(key) {
            if (nextObject === originalObject && nextObject.has(key)) nextObject = copy(originalObject);
            nextObject.delete(key);
        });
        return nextObject;
    },
    $merge: function(value, nextObject, _spec, originalObject) {
        invariantMerge(nextObject, value);
        getAllKeys(value).forEach(function(key) {
            if (value[key] !== nextObject[key]) {
                if (nextObject === originalObject) nextObject = copy(originalObject);
                nextObject[key] = value[key];
            }
        });
        return nextObject;
    },
    $apply: function(value, original) {
        invariantApply(value);
        return value(original);
    }
};
var defaultContext = new Context();
exports.isEquals = defaultContext.update.isEquals;
exports.extend = defaultContext.extend;
exports.default = defaultContext.update;
// @ts-ignore
exports.default.default = module.exports = assign(exports.default, exports);
// invariants
function invariantPushAndUnshift(value, spec, command) {
    invariant(Array.isArray(value), function() {
        return "update(): expected target of " + stringifiable(command) + " to be an array; got " + stringifiable(value) + ".";
    });
    invariantSpecArray(spec[command], command);
}
function invariantSpecArray(spec, command) {
    invariant(Array.isArray(spec), function() {
        return "update(): expected spec of " + stringifiable(command) + " to be an array; got " + stringifiable(spec) + ". " + "Did you forget to wrap your parameter in an array?";
    });
}
function invariantSplices(value, spec) {
    invariant(Array.isArray(value), function() {
        return "Expected $splice target to be an array; got " + stringifiable(value);
    });
    invariantSplice(spec.$splice);
}
function invariantSplice(value) {
    invariant(Array.isArray(value), function() {
        return "update(): expected spec of $splice to be an array of arrays; got " + stringifiable(value) + ". " + "Did you forget to wrap your parameters in an array?";
    });
}
function invariantApply(fn) {
    invariant(typeof fn === "function", function() {
        return "update(): expected spec of $apply to be a function; got " + stringifiable(fn) + ".";
    });
}
function invariantSet(spec) {
    invariant(Object.keys(spec).length === 1, function() {
        return "Cannot have more than one key in an object with $set";
    });
}
function invariantMerge(target, specValue) {
    invariant(specValue && typeof specValue === "object", function() {
        return "update(): $merge expects a spec of type 'object'; got " + stringifiable(specValue);
    });
    invariant(target && typeof target === "object", function() {
        return "update(): $merge expects a target of type 'object'; got " + stringifiable(target);
    });
}
function invariantMapOrSet(target, command) {
    var typeOfTarget = type(target);
    invariant(typeOfTarget === "Map" || typeOfTarget === "Set", function() {
        return "update(): " + stringifiable(command) + " expects a target of type Set or Map; got " + stringifiable(typeOfTarget);
    });
}

});

parcelRegister("iemeN", function(module, exports) {
"use strict";

var $6cBd9 = parcelRequire("6cBd9");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $d45ac8bf24ad96b8$var$_classCallCheck2 = $6cBd9((parcelRequire("keWlZ")));

var $d45ac8bf24ad96b8$var$_createClass2 = $6cBd9((parcelRequire("czJCt")));

var $d45ac8bf24ad96b8$var$_defineProperty2 = $6cBd9((parcelRequire("bPsra")));
function $d45ac8bf24ad96b8$var$_classPrivateFieldInitSpec(obj, privateMap, value) {
    $d45ac8bf24ad96b8$var$_checkPrivateRedeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function $d45ac8bf24ad96b8$var$_checkPrivateRedeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $d45ac8bf24ad96b8$var$_classPrivateFieldGet(s, a) {
    return s.get($d45ac8bf24ad96b8$var$_assertClassBrand(s, a));
}
function $d45ac8bf24ad96b8$var$_assertClassBrand(e, t, n) {
    if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
    throw new TypeError("Private element is not present on this object");
}
var $d45ac8bf24ad96b8$var$_refFns = /*#__PURE__*/ new WeakMap();
var $d45ac8bf24ad96b8$var$MultiRef = module.exports["default"] = /*#__PURE__*/ function() {
    function MultiRef() {
        (0, $d45ac8bf24ad96b8$var$_classCallCheck2["default"])(this, MultiRef);
        (0, $d45ac8bf24ad96b8$var$_defineProperty2["default"])(this, "map", new Map());
        $d45ac8bf24ad96b8$var$_classPrivateFieldInitSpec(this, $d45ac8bf24ad96b8$var$_refFns, new Map());
    }
    return (0, $d45ac8bf24ad96b8$var$_createClass2["default"])(MultiRef, [
        {
            key: "ref",
            value: function ref(key) {
                var _this = this;
                var refFn = $d45ac8bf24ad96b8$var$_classPrivateFieldGet($d45ac8bf24ad96b8$var$_refFns, this).get(key);
                if (refFn) return refFn;
                else {
                    var _refFn = function _refFn(value) {
                        if (value == null) {
                            // Support for React <=18, which cleans up ref functions by calling them
                            // with null.
                            $d45ac8bf24ad96b8$var$_classPrivateFieldGet($d45ac8bf24ad96b8$var$_refFns, _this)["delete"](key);
                            _this.map["delete"](key);
                        } else {
                            $d45ac8bf24ad96b8$var$_classPrivateFieldGet($d45ac8bf24ad96b8$var$_refFns, _this).set(key, _refFn);
                            _this.map.set(key, value);
                            // React 19+ cleanup support
                            return function() {
                                $d45ac8bf24ad96b8$var$_classPrivateFieldGet($d45ac8bf24ad96b8$var$_refFns, _this)["delete"](key);
                                _this.map["delete"](key);
                            };
                        }
                    };
                    // We don't put `refFn` into `this._refFns` yet, because if the current render
                    // is aborted, then it's possible than `refFn(null)` won't be called later
                    // and its cleanup will never happen. We shouldn't cause any side effects that
                    // need cleaning up later until `refFn` gets called with a non-null value.
                    return _refFn;
                }
            }
        }
    ]);
}();

});

parcelRegister("3phrd", function(module, exports) {
"use strict";

var $6cBd9 = parcelRequire("6cBd9");

var $2HGGA = parcelRequire("2HGGA");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $27b13bb635729d86$var$_classCallCheck2 = $6cBd9((parcelRequire("keWlZ")));

var $27b13bb635729d86$var$_createClass2 = $6cBd9((parcelRequire("czJCt")));

var $27b13bb635729d86$var$_possibleConstructorReturn2 = $6cBd9((parcelRequire("fCodG")));

var $27b13bb635729d86$var$_getPrototypeOf2 = $6cBd9((parcelRequire("aVHto")));

var $27b13bb635729d86$var$_inherits2 = $6cBd9((parcelRequire("khSB6")));

var $27b13bb635729d86$var$React = $27b13bb635729d86$var$_interopRequireWildcard((parcelRequire("jbmdS")));
function $27b13bb635729d86$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($27b13bb635729d86$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $27b13bb635729d86$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $2HGGA(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $27b13bb635729d86$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $27b13bb635729d86$var$_callSuper(t, o, e) {
    return o = (0, $27b13bb635729d86$var$_getPrototypeOf2["default"])(o), (0, $27b13bb635729d86$var$_possibleConstructorReturn2["default"])(t, $27b13bb635729d86$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $27b13bb635729d86$var$_getPrototypeOf2["default"])(t).constructor) : o.apply(t, e));
}
function $27b13bb635729d86$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($27b13bb635729d86$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $27b13bb635729d86$var$OnUpdate = module.exports["default"] = /*#__PURE__*/ function(_React$Component) {
    function OnUpdate() {
        (0, $27b13bb635729d86$var$_classCallCheck2["default"])(this, OnUpdate);
        return $27b13bb635729d86$var$_callSuper(this, OnUpdate, arguments);
    }
    (0, $27b13bb635729d86$var$_inherits2["default"])(OnUpdate, _React$Component);
    return (0, $27b13bb635729d86$var$_createClass2["default"])(OnUpdate, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.props.cb();
            }
        },
        {
            key: "render",
            value: function render() {
                return null;
            }
        }
    ]);
}($27b13bb635729d86$var$React.Component);
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("dDaoD", function(module, exports) {
"use strict";

var $6cBd9 = parcelRequire("6cBd9");

var $2HGGA = parcelRequire("2HGGA");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $9ec6fb5bb7272217$var$_classCallCheck2 = $6cBd9((parcelRequire("keWlZ")));

var $9ec6fb5bb7272217$var$_createClass2 = $6cBd9((parcelRequire("czJCt")));

var $9ec6fb5bb7272217$var$_possibleConstructorReturn2 = $6cBd9((parcelRequire("fCodG")));

var $9ec6fb5bb7272217$var$_getPrototypeOf2 = $6cBd9((parcelRequire("aVHto")));

var $9ec6fb5bb7272217$var$_inherits2 = $6cBd9((parcelRequire("khSB6")));

var $9ec6fb5bb7272217$var$_defineProperty2 = $6cBd9((parcelRequire("bPsra")));

var $9ec6fb5bb7272217$var$React = $9ec6fb5bb7272217$var$_interopRequireWildcard((parcelRequire("jbmdS")));

var $9ec6fb5bb7272217$var$_TemplateContainer = $6cBd9((parcelRequire("cwVzX")));
function $9ec6fb5bb7272217$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($9ec6fb5bb7272217$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $9ec6fb5bb7272217$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $2HGGA(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $9ec6fb5bb7272217$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $9ec6fb5bb7272217$var$_callSuper(t, o, e) {
    return o = (0, $9ec6fb5bb7272217$var$_getPrototypeOf2["default"])(o), (0, $9ec6fb5bb7272217$var$_possibleConstructorReturn2["default"])(t, $9ec6fb5bb7272217$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $9ec6fb5bb7272217$var$_getPrototypeOf2["default"])(t).constructor) : o.apply(t, e));
}
function $9ec6fb5bb7272217$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($9ec6fb5bb7272217$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $9ec6fb5bb7272217$var$MoveContainer = module.exports["default"] = /*#__PURE__*/ function(_React$Component) {
    function MoveContainer() {
        var _this;
        (0, $9ec6fb5bb7272217$var$_classCallCheck2["default"])(this, MoveContainer);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $9ec6fb5bb7272217$var$_callSuper(this, MoveContainer, [].concat(args));
        (0, $9ec6fb5bb7272217$var$_defineProperty2["default"])(_this, "_templateContainer", /*#__PURE__*/ $9ec6fb5bb7272217$var$React.createRef());
        (0, $9ec6fb5bb7272217$var$_defineProperty2["default"])(_this, "_el", /*#__PURE__*/ $9ec6fb5bb7272217$var$React.createRef());
        (0, $9ec6fb5bb7272217$var$_defineProperty2["default"])(_this, "_dragHandleProps", _this.props.makeDragHandleProps(function() {
            return _this.props.y;
        }));
        return _this;
    }
    (0, $9ec6fb5bb7272217$var$_inherits2["default"])(MoveContainer, _React$Component);
    return (0, $9ec6fb5bb7272217$var$_createClass2["default"])(MoveContainer, [
        {
            key: "getDOMNode",
            value: function getDOMNode() {
                return this._el.current;
            }
        },
        {
            key: "getTemplate",
            value: function getTemplate() {
                return this._templateContainer.current.getTemplate();
            }
        },
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                return this.props.anySelected !== nextProps.anySelected || this.props.itemSelected !== nextProps.itemSelected || this.props.item !== nextProps.item || this.props.template !== nextProps.template || this.props.y !== nextProps.y || this.props.height !== nextProps.height || this.props.zIndex !== nextProps.zIndex || this.props.commonProps !== nextProps.commonProps;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, item = _this$props.item, y = _this$props.y, padding = _this$props.padding, itemSelected = _this$props.itemSelected, anySelected = _this$props.anySelected, height = _this$props.height, zIndex = _this$props.zIndex, template = _this$props.template, commonProps = _this$props.commonProps;
                return /*#__PURE__*/ $9ec6fb5bb7272217$var$React.createElement("div", {
                    ref: this._el,
                    style: {
                        position: y == null ? "relative" : "absolute",
                        boxSizing: "border-box",
                        left: "0px",
                        right: "0px",
                        top: y == null ? "0px" : "".concat(y, "px"),
                        marginBottom: "".concat(padding, "px"),
                        height: y == null ? "auto" : "".concat(anySelected * (height.drag - height.natural) + height.natural, "px"),
                        zIndex: zIndex
                    }
                }, /*#__PURE__*/ $9ec6fb5bb7272217$var$React.createElement($9ec6fb5bb7272217$var$_TemplateContainer["default"], {
                    ref: this._templateContainer,
                    item: item,
                    template: template,
                    itemSelected: itemSelected,
                    anySelected: anySelected,
                    dragHandleProps: this._dragHandleProps,
                    commonProps: commonProps
                }));
            }
        }
    ]);
}($9ec6fb5bb7272217$var$React.Component);
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("cwVzX", function(module, exports) {
"use strict";

var $6cBd9 = parcelRequire("6cBd9");

var $2HGGA = parcelRequire("2HGGA");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $025aa9dba25c80cd$var$_classCallCheck2 = $6cBd9((parcelRequire("keWlZ")));

var $025aa9dba25c80cd$var$_createClass2 = $6cBd9((parcelRequire("czJCt")));

var $025aa9dba25c80cd$var$_possibleConstructorReturn2 = $6cBd9((parcelRequire("fCodG")));

var $025aa9dba25c80cd$var$_getPrototypeOf2 = $6cBd9((parcelRequire("aVHto")));

var $025aa9dba25c80cd$var$_inherits2 = $6cBd9((parcelRequire("khSB6")));

var $025aa9dba25c80cd$var$_defineProperty2 = $6cBd9((parcelRequire("bPsra")));

var $025aa9dba25c80cd$var$React = $025aa9dba25c80cd$var$_interopRequireWildcard((parcelRequire("jbmdS")));
function $025aa9dba25c80cd$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($025aa9dba25c80cd$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $025aa9dba25c80cd$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $2HGGA(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $025aa9dba25c80cd$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $025aa9dba25c80cd$var$_callSuper(t, o, e) {
    return o = (0, $025aa9dba25c80cd$var$_getPrototypeOf2["default"])(o), (0, $025aa9dba25c80cd$var$_possibleConstructorReturn2["default"])(t, $025aa9dba25c80cd$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $025aa9dba25c80cd$var$_getPrototypeOf2["default"])(t).constructor) : o.apply(t, e));
}
function $025aa9dba25c80cd$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($025aa9dba25c80cd$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $025aa9dba25c80cd$var$TemplateContainer = module.exports["default"] = /*#__PURE__*/ function(_React$Component) {
    function TemplateContainer() {
        var _this;
        (0, $025aa9dba25c80cd$var$_classCallCheck2["default"])(this, TemplateContainer);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $025aa9dba25c80cd$var$_callSuper(this, TemplateContainer, [].concat(args));
        (0, $025aa9dba25c80cd$var$_defineProperty2["default"])(_this, "_templateSetter", function(cmp) {
            _this._template = cmp;
        });
        return _this;
    }
    (0, $025aa9dba25c80cd$var$_inherits2["default"])(TemplateContainer, _React$Component);
    return (0, $025aa9dba25c80cd$var$_createClass2["default"])(TemplateContainer, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                return this.props.anySelected !== nextProps.anySelected || this.props.itemSelected !== nextProps.itemSelected || this.props.item !== nextProps.item || this.props.template !== nextProps.template || this.props.commonProps !== nextProps.commonProps;
            }
        },
        {
            key: "getTemplate",
            value: function getTemplate() {
                return this._template;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, item = _this$props.item, itemSelected = _this$props.itemSelected, anySelected = _this$props.anySelected, dragHandleProps = _this$props.dragHandleProps, commonProps = _this$props.commonProps;
                var Template = this.props.template;
                return /*#__PURE__*/ $025aa9dba25c80cd$var$React.createElement(Template, {
                    ref: this._templateSetter,
                    item: item,
                    itemSelected: itemSelected,
                    anySelected: anySelected,
                    dragHandleProps: dragHandleProps,
                    commonProps: commonProps
                });
            }
        }
    ]);
}($025aa9dba25c80cd$var$React.Component);
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});





parcelRegister("cyAez", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9244c44f6cacdb03$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("eat5C");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $goLmS = parcelRequire("goLmS");

var $38zj9 = parcelRequire("38zj9");

var $gJT7h = parcelRequire("gJT7h");

var $4Ypeq = parcelRequire("4Ypeq");

var $6RcUP = parcelRequire("6RcUP");

var $6Q5sp = parcelRequire("6Q5sp");

var $1BTI2 = parcelRequire("1BTI2");

const $9244c44f6cacdb03$var$spacerColumn = {
    label: "",
    width: 3,
    type: "text",
    value: (r)=>"",
    onChange: (r)=>(v)=>null
};
var $9244c44f6cacdb03$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ id: id })=>{
    var _SessionStore$user;
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6RcUP.default), {
        queryIds: [
            {
                id: `forecast${id}${(0, $4Ypeq.default).periodType}`,
                baseURL: "https://server2.coincraft.co",
                path: `/project-forecast`,
                method: "POST",
                staleTime: 0,
                cacheTime: 0,
                data: {
                    projectId: id,
                    organisationId: (0, $1BTI2.default).organisationId,
                    userId: (_SessionStore$user = (0, $1BTI2.default).user) === null || _SessionStore$user === void 0 ? void 0 : _SessionStore$user.id,
                    invoiceType: (0, $1BTI2.default) === null || (0, $1BTI2.default) === void 0 ? void 0 : (0, $1BTI2.default).organisation.defaultRevenueForecastReport.filters.invoiceData,
                    periodType: (0, $4Ypeq.default).periodType
                }
            }
        ],
        children: /*#__PURE__*/ (0, $61Ea1.jsx)($9244c44f6cacdb03$var$ProjectForecastTables, {
            id: id
        })
    });
});
const $9244c44f6cacdb03$var$ProjectForecastTables = (0, $1EEMt.observer)(({ id: id })=>{
    var _queryClient$getQuery, _store$filterByPhase, _store$filterByPhase2;
    const store = (0, $4Ypeq.default);
    const project = (0, $gJT7h.default).projectsById[id];
    const queriesData = (_queryClient$getQuery = (0, $6Q5sp.queryClient).getQueryData([
        `forecast${project.id}${store.periodType}`
    ])) === null || _queryClient$getQuery === void 0 ? void 0 : _queryClient$getQuery.data;
    (0, $jbmdS.useEffect)(()=>{
        var _queriesData$projects, _queriesData$projects2;
        if (!queriesData.projects.length) queriesData.projects.push({
            ...(project === null || project === void 0 ? void 0 : project.serialize()) || {},
            phases: ((project === null || project === void 0 ? void 0 : project.phases) || []).map((p)=>({
                    ...(p === null || p === void 0 ? void 0 : p.serialize()) || {},
                    budgets: p.budgets.map((b)=>({
                            ...(b === null || b === void 0 ? void 0 : b.serialize()) || {}
                        })),
                    expenses: p.expenses.map((e)=>({
                            ...(e === null || e === void 0 ? void 0 : e.serialize()) || {}
                        }))
                }))
        });
        const queryPhaseIds = ((_queriesData$projects = queriesData.projects[0]) === null || _queriesData$projects === void 0 ? void 0 : (_queriesData$projects2 = _queriesData$projects.phases) === null || _queriesData$projects2 === void 0 ? void 0 : _queriesData$projects2.map((p)=>p.id)) || [];
        if (!project.phases.every((p)=>queryPhaseIds.includes(p.id))) {
            var _queriesData$projects3, _queriesData$projects4;
            (_queriesData$projects4 = (_queriesData$projects3 = queriesData.projects[0]).phases) !== null && _queriesData$projects4 !== void 0 ? _queriesData$projects4 : _queriesData$projects3.phases = [];
            project.phases.forEach((p)=>{
                if (!queryPhaseIds.includes(p.id)) queriesData.projects[0].phases.push({
                    ...(p === null || p === void 0 ? void 0 : p.serialize()) || {},
                    budgets: p.budgets.map((b)=>({
                            ...(b === null || b === void 0 ? void 0 : b.serialize()) || {}
                        })),
                    expenses: p.expenses.map((e)=>({
                            ...(e === null || e === void 0 ? void 0 : e.serialize()) || {}
                        }))
                });
            });
        }
        store.init(queriesData);
    }, [
        id,
        store.periodType,
        queriesData
    ]);
    const staffTitle = store.cellType === "currency" ? "Staff Expenses" : "Staff Hours";
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $38zj9.default), {
                style: {
                    margin: "0 2em"
                },
                revenue: store.graphRevenue,
                expenses: store.graphExpenses,
                totalWidth: 1280,
                graphWidth: 880,
                height: 220
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
                style: {
                    margin: "2em",
                    marginBottom: 0
                },
                columns: store.totalsTableColumns,
                rows: [
                    {}
                ]
            }),
            store.showRevenueTable ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
                style: {
                    margin: "2em",
                    marginTop: 0
                },
                columns: store.profitMarginTableColumns,
                rows: [
                    {}
                ],
                showHeader: false
            }) : null,
            store.showRevenueTable ? /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("h2", {
                        style: {
                            margin: "2em 0 0 1em"
                        },
                        children: "Revenue"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
                        style: {
                            margin: "2em"
                        },
                        columns: store.revenueTableColumns,
                        rows: store.revenueTableRows,
                        groupBy: store.filterByPhase && !((_store$filterByPhase = store.filterByPhase) !== null && _store$filterByPhase !== void 0 && _store$filterByPhase.isRootPhase) ? [] : [
                            "project"
                        ],
                        expandedGroups: store.filterByPhase && !((_store$filterByPhase2 = store.filterByPhase) !== null && _store$filterByPhase2 !== void 0 && _store$filterByPhase2.isRootPhase) ? [] : [
                            "project"
                        ]
                    })
                ]
            }) : null,
            store.showStaffTable ? /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("h2", {
                        style: {
                            margin: "2em 0 0 1em"
                        },
                        children: staffTitle
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)($9244c44f6cacdb03$var$ResourcePhaseTable, {
                        store: store
                    })
                ]
            }) : null,
            store.showExpenseTable ? /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("h2", {
                        style: {
                            margin: "2em 0 0 1em"
                        },
                        children: "Project Expenses"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)($9244c44f6cacdb03$var$ExpensePhaseTable, {
                        store: store
                    })
                ]
            }) : null
        ]
    });
});
const $9244c44f6cacdb03$var$ResourcePhaseTable = (0, $1EEMt.observer)(({ project: project, store: store })=>{
    var _store$project, _store$filterByPhase3, _store$filterByPhase4;
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
        style: {
            margin: "2em"
        },
        columns: store.staffTableColumns((phase)=>[
                phase === null || phase === void 0 ? void 0 : phase.id,
                null,
                null
            ]),
        rows: store.staffPhaseTableRows,
        groupBy: store.filterByPhase && !((_store$filterByPhase3 = store.filterByPhase) !== null && _store$filterByPhase3 !== void 0 && _store$filterByPhase3.isRootPhase) ? [] : [
            "project"
        ],
        expandedGroups: store.filterByPhase && !((_store$filterByPhase4 = store.filterByPhase) !== null && _store$filterByPhase4 !== void 0 && _store$filterByPhase4.isRootPhase) ? [] : [
            "project"
        ],
        getChildComponent: (r)=>{
            return /*#__PURE__*/ (0, $61Ea1.jsx)($9244c44f6cacdb03$var$ResourceRoleTable, {
                phase: r,
                store: store
            });
        }
    }, ((_store$project = store.project) === null || _store$project === void 0 ? void 0 : _store$project.id) + store.cellType);
});
const $9244c44f6cacdb03$var$ResourceRoleTable = (0, $1EEMt.observer)(({ phase: phase, store: store })=>{
    const level = 3;
    const bgColor = 256 - level * 5;
    const bgShadow = bgColor - 10;
    const getChildComponent = (r)=>{
        return /*#__PURE__*/ (0, $61Ea1.jsx)($9244c44f6cacdb03$var$ResourceStaffTable, {
            phase: phase,
            role: r,
            store: store
        }, (phase === null || phase === void 0 ? void 0 : phase.id) + (r === null || r === void 0 ? void 0 : r.id) + store.cellType);
    };
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
        showHeader: false,
        columns: store.staffTableColumns((role)=>[
                phase === null || phase === void 0 ? void 0 : phase.id,
                role === null || role === void 0 ? void 0 : role.id,
                null
            ]),
        rows: store.phaseRoleRowsByPhaseId[phase.id] || [],
        // sortBy={[['label', 'asc']]}
        getChildComponent: getChildComponent,
        style: {
            boxShadow: "none",
            background: `linear-gradient(180deg, rgb(${bgShadow},${bgShadow},${bgShadow}) 1px, rgb(${bgColor},${bgColor},${bgColor}) 8px)`,
            fontSize: "1.2rem"
        }
    }, (phase === null || phase === void 0 ? void 0 : phase.id) + store.cellType);
});
const $9244c44f6cacdb03$var$ResourceStaffTable = (0, $1EEMt.observer)(({ phase: phase, role: role, store: store })=>{
    const columns = store.cellType === "currency" ? "staffTableColumns" : "staffTableHoursColumns";
    const level = 4;
    const bgColor = 256 - level * 5;
    const bgShadow = bgColor - 10;
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
        showHeader: false,
        columns: [
            $9244c44f6cacdb03$var$spacerColumn,
            ...store.staffTableColumns((staff)=>[
                    phase === null || phase === void 0 ? void 0 : phase.id,
                    role === null || role === void 0 ? void 0 : role.id,
                    staff === null || staff === void 0 ? void 0 : staff.id
                ])
        ],
        rows: store.phaseStaffRowsByPhaseRoleId[phase.id + role.id] || [],
        // sortBy={[['label', 'asc']]}
        style: {
            boxShadow: "none",
            background: `linear-gradient(180deg, rgb(${bgShadow},${bgShadow},${bgShadow}) 1px, rgb(${bgColor},${bgColor},${bgColor}) 8px)`,
            fontSize: "1.2rem"
        }
    }, (phase === null || phase === void 0 ? void 0 : phase.id) + (role === null || role === void 0 ? void 0 : role.id) + store.cellType);
});
const $9244c44f6cacdb03$var$ExpensePhaseTable = (0, $1EEMt.observer)(({ store: store })=>{
    var _store$filterByPhase5, _store$filterByPhase6;
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
        style: {
            margin: "2em"
        },
        rows: store.expenseTableRows,
        columns: store.expenseTableColumns((phase)=>[
                phase.id,
                null
            ]),
        groupBy: store.filterByPhase && !((_store$filterByPhase5 = store.filterByPhase) !== null && _store$filterByPhase5 !== void 0 && _store$filterByPhase5.isRootPhase) ? [] : [
            "project"
        ],
        expandedGroups: store.filterByPhase && !((_store$filterByPhase6 = store.filterByPhase) !== null && _store$filterByPhase6 !== void 0 && _store$filterByPhase6.isRootPhase) ? [] : [
            "project"
        ],
        // sortBy={[['label', 'asc']]}
        getChildComponent: (r)=>{
            return /*#__PURE__*/ (0, $61Ea1.jsx)($9244c44f6cacdb03$var$ExpenseExpenseTable, {
                phase: r,
                store: store
            });
        }
    }, "expenseTable");
});
const $9244c44f6cacdb03$var$ExpenseExpenseTable = (0, $1EEMt.observer)(({ phase: phase, store: store })=>{
    const level = 3;
    const bgColor = 256 - level * 5;
    const bgShadow = bgColor - 10;
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
        showHeader: false,
        columns: [
            $9244c44f6cacdb03$var$spacerColumn,
            ...store.expenseTableColumns((expenseName)=>[
                    phase.id,
                    expenseName
                ])
        ],
        rows: store.expensePhaseTableRows(phase.id),
        // sortBy={[['label', 'asc']]}
        style: {
            boxShadow: "none",
            background: `linear-gradient(180deg, rgb(${bgShadow},${bgShadow},${bgShadow}) 1px, rgb(${bgColor},${bgColor},${bgColor}) 8px)`,
            fontSize: "1.2rem"
        }
    }, "expenseTable" + phase.id);
});

});

parcelRegister("gssr3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bfb55184d7672c9f$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("lCpBr");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $5AhMR = parcelRequire("5AhMR");

var $gJT7h = parcelRequire("gJT7h");
parcelRequire("XoImS");

var $4Ypeq = parcelRequire("4Ypeq");

var $1BTI2 = parcelRequire("1BTI2");

var $8kZ1o = parcelRequire("8kZ1o");

var $ewAM3 = parcelRequire("ewAM3");
parcelRequire("6RcUP");
parcelRequire("6Q5sp");

var $02LyB = parcelRequire("02LyB");
var $bfb55184d7672c9f$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ tabs: tabs, selectedTab: selectedTab, id: id })=>{
    const [weekly, setWeekly] = (0, $jbmdS.useState)(false);
    const project = (0, $gJT7h.default).projectsById[id];
    const canSeeFinancials = (0, $8kZ1o.canViewRevenueTargets)((0, $1BTI2.default).user, project) && (0, $8kZ1o.canViewProjectFees)((0, $1BTI2.default).user, project);
    const canSeeExpenses = (0, $8kZ1o.canViewProjectExpenses)((0, $1BTI2.default).user, project) && (0, $8kZ1o.canViewProjectStaffCost)((0, $1BTI2.default).user, project);
    const [store, setStore] = (0, $jbmdS.useState)((0, $4Ypeq.default));
    if (!project) return null;
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5AhMR.default), {
        id: id,
        tabs: tabs,
        selectedTab: selectedTab,
        extraContent: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            className: "report-selector dont-print flex mt-4",
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.PhaseSelector), {
                    value: store.filterByPhase,
                    options: project.phases,
                    onChange: (phase)=>store.setFilterByPhase(phase)
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                    style: {
                        marginRight: "1em"
                    },
                    value: store.graphType,
                    onChange: (graphType)=>store.setGraphType(graphType),
                    options: [
                        ...canSeeFinancials ? [
                            {
                                label: "Revenue vs. Expenses (cumulative)",
                                value: "revenueVsExpenses"
                            }
                        ] : [],
                        ...canSeeExpenses ? [
                            {
                                label: "Expense Budget (cumulative)",
                                value: "expenseBudget"
                            }
                        ] : [],
                        {
                            label: "Hours Budget (cumulative)",
                            value: "hoursBudget"
                        },
                        ...canSeeFinancials ? [
                            {
                                label: "Revenue vs. Expenses (monthly)",
                                value: "revenueVsExpensesMonthly"
                            }
                        ] : [],
                        ...canSeeExpenses ? [
                            {
                                label: "Expense Budget (monthly)",
                                value: "expenseBudgetMonthly"
                            }
                        ] : [],
                        {
                            label: "Hours Budget (monthly)",
                            value: "hoursBudgetMonthly"
                        }
                    ]
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("py-2 px-4 border border-white text-xs m-0", store.periodType === "month" ? "bg-white text-black" : "text-white bg-transparent"),
                    style: {
                        borderRadius: "0.5rem 0 0 0.5rem"
                    },
                    onClick: ()=>store.setPeriodType("month"),
                    children: "Monthly"
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("py-2 px-4 border border-white text-xs m-0", store.periodType === "week" ? "bg-white text-black" : "text-white bg-transparent"),
                    style: {
                        borderRadius: "0 0.5rem 0.5rem 0"
                    },
                    onClick: ()=>store.setPeriodType("week"),
                    children: "Weekly"
                })
            ]
        })
    });
});

});

parcelRegister("gTTjY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $032cd994adb100be$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $gJT7h = parcelRequire("gJT7h");

var $keGWP = parcelRequire("keGWP");
parcelRequire("fEtu5");
var $aEc4x = parcelRequire("aEc4x");
var $avIhR = parcelRequire("avIhR");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");
var $032cd994adb100be$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ id: id })=>{
    const project = (0, $gJT7h.default).projectsById[id];
    const isEditable = (0, $8kZ1o.canEditPhasesAndTasks)((0, $1BTI2.default).user, project);
    if (!project) return null;
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        style: {
            width: "60em"
        },
        children: project.phases.filter((ph)=>!(ph !== null && ph !== void 0 && ph.isRootPhase)).map((phase)=>/*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("h3", {
                        className: "border-b border-[#ccc]",
                        children: phase.title
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        style: {
                            margin: "1em 0 2em 0"
                        },
                        children: phase.tasks.map((task)=>/*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                className: "flex items-center justify-between border-b border-[#ddd] p-[0.5em]",
                                children: [
                                    !task.isDefault && isEditable ? /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
                                        type: "text",
                                        placeholder: "task name",
                                        value: task.name || "",
                                        onChange: (event)=>task.update({
                                                name: event.target.value
                                            }),
                                        className: "w-[18em] input-base"
                                    }) : /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        className: "inline-block w-[18em]",
                                        children: task.name
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        className: "inline-block ml-[1em]",
                                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $aEc4x.Checkbox), {
                                            className: "staff-member-name",
                                            value: task.isBillable,
                                            label: "Billable",
                                            disabled: !isEditable,
                                            onChange: (checked)=>task.update({
                                                    isBillable: checked
                                                })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        style: {
                                            display: "inline-block",
                                            marginLeft: "1em"
                                        },
                                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $aEc4x.Checkbox), {
                                            className: "staff-member-name",
                                            value: task.isVariation,
                                            label: "Variation",
                                            disabled: !isEditable,
                                            onChange: (checked)=>task.update({
                                                    isVariation: checked
                                                })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $avIhR.SmallDeleteButton), {
                                        onClick: ()=>task.update({
                                                deletedAt: new Date()
                                            }),
                                        disabled: !isEditable || task.isDefault
                                    })
                                ]
                            }, task.id))
                    }),
                    isEditable ? /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        style: {
                            padding: "0.5em"
                        },
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                            style: {
                                padding: "0.5em 1.5em",
                                fontSize: "0.85em",
                                marginTop: "0.5em"
                            },
                            className: "btn btn-default plus-btn border-[#ccc]",
                            onClick: ()=>{
                                var _phase$project$costCe, _phase$project, _phase$project$costCe2;
                                const b = (0, $keGWP.default).add({
                                    projectId: phase.projectId,
                                    phaseId: phase.id,
                                    isBillable: (_phase$project$costCe = (_phase$project = phase.project) === null || _phase$project === void 0 ? void 0 : (_phase$project$costCe2 = _phase$project.costCentre) === null || _phase$project$costCe2 === void 0 ? void 0 : _phase$project$costCe2.isBillable) !== null && _phase$project$costCe !== void 0 ? _phase$project$costCe : true
                                }, {
                                    trackUpdates: true
                                });
                                b.position = phase.tasks.length;
                            },
                            children: "+ Add Task"
                        })
                    }) : null
                ]
            }, phase.id))
    });
});

});

parcelRegister("9ylCr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f480f1a59317420$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("diZaE");

var $eat5C = parcelRequire("eat5C");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $goLmS = parcelRequire("goLmS");

var $gkMXq = parcelRequire("gkMXq");

var $kRqe9 = parcelRequire("kRqe9");

var $gJT7h = parcelRequire("gJT7h");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $ewAM3 = parcelRequire("ewAM3");

var $49KZT = parcelRequire("49KZT");

var $kqlQp = parcelRequire("kqlQp");
const $6f480f1a59317420$var$changeLogColumns = [
    {
        id: "date",
        label: "Date",
        width: 20,
        type: "date",
        aggregate: "none",
        editable: (r)=>r.modelType === "changeLogItem" && ((0, $8kZ1o.canEditProjectInvoices)((0, $1BTI2.default).user, r.project) || (0, $8kZ1o.canEditProjectExpenses)((0, $1BTI2.default).user, r.project)),
        value: (r)=>r.date,
        onChange: (r)=>(v)=>r.update({
                    date: v
                })
    },
    {
        label: "Title",
        width: 20,
        type: "text",
        editable: (r)=>r.modelType === "changeLogItem" && ((0, $8kZ1o.canEditProjectInvoices)((0, $1BTI2.default).user, r.project) || (0, $8kZ1o.canEditProjectExpenses)((0, $1BTI2.default).user, r.project)),
        value: (p)=>p.title,
        onChange: (r)=>(v)=>r.update({
                    title: v
                }),
        component: (props)=>{
            const { value: value, group: group, stores: stores } = props;
            const { row: row, table: table } = stores;
            return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: row.rowObject.modelType === "invoiceLineItem" ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqlQp.Link), {
                    to: `/invoices/${row.rowObject.invoice.id}`,
                    children: value
                }) : (0, $49KZT.default).text(props)
            });
        }
    },
    {
        label: "Phase",
        width: 20,
        type: "phase",
        aggregate: "none",
        editable: (r)=>r.modelType === "changeLogItem" && ((0, $8kZ1o.canEditProjectInvoices)((0, $1BTI2.default).user, r.project) || (0, $8kZ1o.canEditProjectExpenses)((0, $1BTI2.default).user, r.project)),
        value: (p)=>p.phase,
        onChange: (r)=>(v)=>r.update({
                    phaseId: v.id
                }),
        component: ({ value: value, onChange: onChange, stores: stores, editable: editable })=>{
            var _stores$row, _stores$row$rowObject;
            const project = stores === null || stores === void 0 ? void 0 : (_stores$row = stores.row) === null || _stores$row === void 0 ? void 0 : (_stores$row$rowObject = _stores$row.rowObject) === null || _stores$row$rowObject === void 0 ? void 0 : _stores$row$rowObject.project;
            return editable ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.PhaseSelector), {
                options: project.phases,
                selectedPhase: value,
                onChange: onChange,
                variant: "secondary",
                className: "!border-none"
            }) : (value === null || value === void 0 ? void 0 : value.title) || "No Phase";
        }
    },
    {
        label: "Revenue",
        width: 20,
        type: "currency",
        permissions: (r)=>(0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, r.project),
        editable: (r)=>{
            return r.modelType === "changeLogItem" && (0, $8kZ1o.canEditProjectInvoices)((0, $1BTI2.default).user, r.project);
        },
        value: (p)=>p.revenue,
        onChange: (r)=>(v)=>r.update({
                    revenue: v
                })
    },
    {
        label: "Expenses",
        width: 20,
        type: "currency",
        permissions: (r)=>(0, $8kZ1o.canViewProjectExpenses)((0, $1BTI2.default).user, r.project),
        editable: (r)=>r.modelType === "changeLogItem" && (0, $8kZ1o.canEditProjectExpenses)((0, $1BTI2.default).user, r.project),
        value: (p)=>p.expenses,
        onChange: (r)=>(v)=>r.update({
                    expenses: v
                })
    },
    {
        label: "Percent Progress",
        width: 10,
        type: "percent",
        aggregate: "none",
        permissions: (r)=>(0, $8kZ1o.canViewProjectExpenses)((0, $1BTI2.default).user, r.project),
        editable: (r)=>r.modelType === "changeLogItem" && (0, $8kZ1o.canEditProjectExpenses)((0, $1BTI2.default).user, r.project),
        value: (p)=>{
            var _p$percentProgress;
            return (_p$percentProgress = p.percentProgress) !== null && _p$percentProgress !== void 0 ? _p$percentProgress : "";
        },
        onChange: (r)=>(v)=>r.update({
                    percentProgress: v || null
                })
    },
    {
        label: "",
        width: 4,
        type: "button",
        aggregate: "none",
        permissions: (r)=>(0, $8kZ1o.canEditProjectInvoices)((0, $1BTI2.default).user, r.project) && (0, $8kZ1o.canEditProjectExpenses)((0, $1BTI2.default).user, r.project),
        editable: (r)=>r.modelType === "changeLogItem" && (0, $8kZ1o.canEditProjectInvoices)((0, $1BTI2.default).user, r.project) && (0, $8kZ1o.canEditProjectExpenses)((0, $1BTI2.default).user, r.project),
        value: (r)=>r.modelType === "changeLogItem" ? /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                className: "fa fa-times",
                style: {
                    marginRight: 0
                }
            }) : null,
        onClick: (r)=>()=>{
                r.update({
                    deletedAt: new Date()
                });
            }
    }
];
var $6f480f1a59317420$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ id: id })=>{
    const project = (0, $gJT7h.default).projectsById[id];
    (0, $jbmdS.useEffect)(()=>{
        ((project === null || project === void 0 ? void 0 : project.changeLog) || []).forEach((cli, i)=>cli.position = i);
    }, [
        project
    ]);
    if (!project) return null;
    const [rows, setRows] = (0, $jbmdS.useState)([
        ...project.changeLog,
        ...(0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, project) ? project.invoices.map((inv)=>inv.phasesWithRevenue.map((ph)=>{
                const lineItems = (0, $kRqe9.default).lineItemsByInvoicePhaseId["i" + inv.id + "ph" + (ph === null || ph === void 0 ? void 0 : ph.id)] || [];
                return {
                    id: "i" + inv.id + "ph" + (ph === null || ph === void 0 ? void 0 : ph.id),
                    modelType: "invoiceLineItem",
                    type: inv.type,
                    date: inv.issueDate,
                    title: "Invoice: " + inv.ref,
                    phase: ph,
                    phaseId: ph === null || ph === void 0 ? void 0 : ph.id,
                    project: project,
                    invoice: inv,
                    revenue: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(lineItems.map((li)=>li.amount))
                };
            })).flat() : []
    ].sort((a, b)=>{
        var _a$date, _b$date;
        return (a === null || a === void 0 ? void 0 : (_a$date = a.date) === null || _a$date === void 0 ? void 0 : _a$date.getTime()) - (b === null || b === void 0 ? void 0 : (_b$date = b.date) === null || _b$date === void 0 ? void 0 : _b$date.getTime());
    }).map((cli, index, array)=>{
        // Calculate sum of all previous revenue for the same phase
        const previousRevenue = array.filter((item, i)=>{
            var _item$phase, _cli$phase;
            return i <= index && ((_item$phase = item.phase) === null || _item$phase === void 0 ? void 0 : _item$phase.id) === ((_cli$phase = cli.phase) === null || _cli$phase === void 0 ? void 0 : _cli$phase.id) && item.revenue;
        }).reduce((sum, item)=>sum + (item.revenue || 0), 0);
        if (cli !== null && cli !== void 0 && cli.update) return cli;
        else {
            var _cli$phase2;
            return {
                ...cli,
                percentProgress: cli.percentProgress || ((_cli$phase2 = cli.phase) !== null && _cli$phase2 !== void 0 && _cli$phase2.fee ? previousRevenue / cli.phase.fee : null)
            };
        }
    }));
    (0, $jbmdS.useEffect)(()=>{
        setRows([
            ...project.changeLog,
            ...(0, $8kZ1o.canViewProjectInvoices)((0, $1BTI2.default).user, project) ? project.invoices.map((inv)=>inv.phasesWithRevenue.map((ph)=>{
                    const lineItems = (0, $kRqe9.default).lineItemsByInvoicePhaseId["i" + inv.id + "ph" + (ph === null || ph === void 0 ? void 0 : ph.id)] || [];
                    return {
                        id: "i" + inv.id + "ph" + (ph === null || ph === void 0 ? void 0 : ph.id),
                        modelType: "invoiceLineItem",
                        type: inv.type,
                        date: inv.issueDate,
                        title: "Invoice: " + inv.ref,
                        phase: ph,
                        project: project,
                        invoice: inv,
                        revenue: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(lineItems.map((li)=>li.amount))
                    };
                })).flat() : []
        ].sort((a, b)=>{
            var _a$date2, _b$date2;
            return (a === null || a === void 0 ? void 0 : (_a$date2 = a.date) === null || _a$date2 === void 0 ? void 0 : _a$date2.getTime()) - (b === null || b === void 0 ? void 0 : (_b$date2 = b.date) === null || _b$date2 === void 0 ? void 0 : _b$date2.getTime());
        }).map((cli, index, array)=>{
            // Calculate sum of all previous revenue for the same phase
            const previousRevenue = array.filter((item, i)=>{
                var _item$phase2, _cli$phase3;
                return i <= index && ((_item$phase2 = item.phase) === null || _item$phase2 === void 0 ? void 0 : _item$phase2.id) === ((_cli$phase3 = cli.phase) === null || _cli$phase3 === void 0 ? void 0 : _cli$phase3.id) && item.revenue;
            }).reduce((sum, item)=>sum + (item.revenue || 0), 0);
            if (cli !== null && cli !== void 0 && cli.update) return cli;
            else {
                var _cli$phase4;
                return {
                    ...cli,
                    percentProgress: cli.percentProgress || ((_cli$phase4 = cli.phase) !== null && _cli$phase4 !== void 0 && _cli$phase4.fee ? previousRevenue / cli.phase.fee : null)
                };
            }
        }));
    }, [
        project.id
    ]);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
                columns: $6f480f1a59317420$var$changeLogColumns,
                rows: rows.filter((r)=>!r.deletedAt),
                showTotals: true
            }),
            (0, $8kZ1o.canEditProjectInvoices)((0, $1BTI2.default).user, project) && (0, $8kZ1o.canEditProjectExpenses)((0, $1BTI2.default).user, project) ? /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                className: "btn btn-default plus-btn border-[#ccc]",
                style: {
                    marginTop: "2em"
                },
                onClick: ()=>{
                    const cli = (0, $gkMXq.default).add({
                        projectId: project.id,
                        phaseId: project.rootPhase.id,
                        date: new Date()
                    }, {
                        trackUpdates: true
                    });
                    cli.position = project.changeLog.length;
                    setRows([
                        ...rows,
                        cli
                    ]);
                },
                children: "+ Add Item"
            }) : null
        ]
    });
});

});
parcelRegister("diZaE", function(module, exports) {
"use strict";

var $h5Sxd = parcelRequire("h5Sxd");

var $Pmomn = parcelRequire("Pmomn");
function $9afc6806a7882985$var$IsDate() {
    return $h5Sxd.create(new $Pmomn(), {
        isExpectedType: function(actual) {
            return $h5Sxd.isDate(actual);
        },
        describeTo: function(description) {
            description.append("a date");
        }
    });
}
$9afc6806a7882985$var$IsDate.date = function() {
    return new $9afc6806a7882985$var$IsDate();
};
module.exports = $9afc6806a7882985$var$IsDate;

});
parcelRegister("h5Sxd", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre ES5 environments */ var undefined;
    /** Used to pool arrays and objects used internally */ var arrayPool = [], objectPool = [];
    /** Used to generate unique IDs */ var idCounter = 0;
    /** Used to prefix keys to avoid issues with `__proto__` and properties on `Object.prototype` */ var keyPrefix = +new Date + "";
    /** Used as the size when optimizations are enabled for large arrays */ var largeArraySize = 75;
    /** Used as the max size of the `arrayPool` and `objectPool` */ var maxPoolSize = 40;
    /** Used to detect and test whitespace */ var whitespace = // whitespace
    " 	\v\f\xa0\uFEFF\n\r\u2028\u2029\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000";
    /** Used to match empty string literals in compiled template source */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /**
   * Used to match ES6 template delimiters
   * http://people.mozilla.org/~jorendorff/es6-draft.html#sec-literals-string-literals
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match regexp flags from their coerced string values */ var reFlags = /\w*$/;
    /** Used to detected named functions */ var reFuncName = /^\s*function[ \n\r\t]+\w/;
    /** Used to match "interpolate" template delimiters */ var reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match leading whitespace and zeros to be removed */ var reLeadingSpacesAndZeros = RegExp("^[" + whitespace + "]*0+(?=.$)");
    /** Used to ensure capturing order of template delimiters */ var reNoMatch = /($^)/;
    /** Used to detect functions containing a `this` reference */ var reThis = /\bthis\b/;
    /** Used to match unescaped characters in compiled string literals */ var reUnescapedString = /['\n\r\t\u2028\u2029\\]/g;
    /** Used to assign default `context` object properties */ var contextProps = [
        "Array",
        "Boolean",
        "Date",
        "Function",
        "Math",
        "Number",
        "Object",
        "RegExp",
        "String",
        "_",
        "attachEvent",
        "clearTimeout",
        "isFinite",
        "isNaN",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify */ var templateCounter = 0;
    /** `Object#toString` result shortcuts */ var argsClass = "[object Arguments]", arrayClass = "[object Array]", boolClass = "[object Boolean]", dateClass = "[object Date]", funcClass = "[object Function]", numberClass = "[object Number]", objectClass = "[object Object]", regexpClass = "[object RegExp]", stringClass = "[object String]";
    /** Used to identify object classifications that `_.clone` supports */ var cloneableClasses = {};
    cloneableClasses[funcClass] = false;
    cloneableClasses[argsClass] = cloneableClasses[arrayClass] = cloneableClasses[boolClass] = cloneableClasses[dateClass] = cloneableClasses[numberClass] = cloneableClasses[objectClass] = cloneableClasses[regexpClass] = cloneableClasses[stringClass] = true;
    /** Used as an internal `_.debounce` options object */ var debounceOptions = {
        "leading": false,
        "maxWait": 0,
        "trailing": false
    };
    /** Used as the property descriptor for `__bindData__` */ var descriptor = {
        "configurable": false,
        "enumerable": false,
        "value": null,
        "writable": false
    };
    /** Used to determine if values are of the language type Object */ var objectTypes = {
        "boolean": false,
        "function": true,
        "object": true,
        "number": false,
        "string": false,
        "undefined": false
    };
    /** Used to escape characters for inclusion in compiled string literals */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "	": "t",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Used as a reference to the global object */ var root = objectTypes[typeof window] && window || this;
    /** Detect free variable `exports` */ var freeExports = objectTypes["object"] && exports && !exports.nodeType && exports;
    /** Detect free variable `module` */ var freeModule = objectTypes["object"] && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports` */ var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;
    /** Detect free variable `global` from Node.js or Browserified code and use it as `root` */ var freeGlobal = objectTypes[typeof $parcel$global] && $parcel$global;
    if (freeGlobal && (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal)) root = freeGlobal;
    /*--------------------------------------------------------------------------*/ /**
   * The base implementation of `_.indexOf` without support for binary searches
   * or `fromIndex` constraints.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {*} value The value to search for.
   * @param {number} [fromIndex=0] The index to search from.
   * @returns {number} Returns the index of the matched value or `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        var index = (fromIndex || 0) - 1, length = array ? array.length : 0;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * An implementation of `_.contains` for cache objects that mimics the return
   * signature of `_.indexOf` by returning `0` if the value is found, else `-1`.
   *
   * @private
   * @param {Object} cache The cache object to inspect.
   * @param {*} value The value to search for.
   * @returns {number} Returns `0` if `value` is found, else `-1`.
   */ function cacheIndexOf(cache, value) {
        var type = typeof value;
        cache = cache.cache;
        if (type == "boolean" || value == null) return cache[value] ? 0 : -1;
        if (type != "number" && type != "string") type = "object";
        var key = type == "number" ? value : keyPrefix + value;
        cache = (cache = cache[type]) && cache[key];
        return type == "object" ? cache && baseIndexOf(cache, value) > -1 ? 0 : -1 : cache ? 0 : -1;
    }
    /**
   * Adds a given value to the corresponding cache object.
   *
   * @private
   * @param {*} value The value to add to the cache.
   */ function cachePush(value) {
        var cache = this.cache, type = typeof value;
        if (type == "boolean" || value == null) cache[value] = true;
        else {
            if (type != "number" && type != "string") type = "object";
            var key = type == "number" ? value : keyPrefix + value, typeCache = cache[type] || (cache[type] = {});
            if (type == "object") (typeCache[key] || (typeCache[key] = [])).push(value);
            else typeCache[key] = true;
        }
    }
    /**
   * Used by `_.max` and `_.min` as the default callback when a given
   * collection is a string value.
   *
   * @private
   * @param {string} value The character to inspect.
   * @returns {number} Returns the code unit of given character.
   */ function charAtCallback(value) {
        return value.charCodeAt(0);
    }
    /**
   * Used by `sortBy` to compare transformed `collection` elements, stable sorting
   * them in ascending order.
   *
   * @private
   * @param {Object} a The object to compare to `b`.
   * @param {Object} b The object to compare to `a`.
   * @returns {number} Returns the sort order indicator of `1` or `-1`.
   */ function compareAscending(a, b) {
        var ac = a.criteria, bc = b.criteria, index = -1, length = ac.length;
        while(++index < length){
            var value = ac[index], other = bc[index];
            if (value !== other) {
                if (value > other || typeof value == "undefined") return 1;
                if (value < other || typeof other == "undefined") return -1;
            }
        }
        // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
        // that causes it, under certain circumstances, to return the same value for
        // `a` and `b`. See https://github.com/jashkenas/underscore/pull/1247
        //
        // This also ensures a stable sort in V8 and other engines.
        // See http://code.google.com/p/v8/issues/detail?id=90
        return a.index - b.index;
    }
    /**
   * Creates a cache object to optimize linear searches of large arrays.
   *
   * @private
   * @param {Array} [array=[]] The array to search.
   * @returns {null|Object} Returns the cache object or `null` if caching should not be used.
   */ function createCache(array) {
        var index = -1, length = array.length, first = array[0], mid = array[length / 2 | 0], last = array[length - 1];
        if (first && typeof first == "object" && mid && typeof mid == "object" && last && typeof last == "object") return false;
        var cache = getObject();
        cache["false"] = cache["null"] = cache["true"] = cache["undefined"] = false;
        var result = getObject();
        result.array = array;
        result.cache = cache;
        result.push = cachePush;
        while(++index < length)result.push(array[index]);
        return result;
    }
    /**
   * Used by `template` to escape characters for inclusion in compiled
   * string literals.
   *
   * @private
   * @param {string} match The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(match) {
        return "\\" + stringEscapes[match];
    }
    /**
   * Gets an array from the array pool or creates a new one if the pool is empty.
   *
   * @private
   * @returns {Array} The array from the pool.
   */ function getArray() {
        return arrayPool.pop() || [];
    }
    /**
   * Gets an object from the object pool or creates a new one if the pool is empty.
   *
   * @private
   * @returns {Object} The object from the pool.
   */ function getObject() {
        return objectPool.pop() || {
            "array": null,
            "cache": null,
            "criteria": null,
            "false": false,
            "index": 0,
            "null": false,
            "number": null,
            "object": null,
            "push": null,
            "string": null,
            "true": false,
            "undefined": false,
            "value": null
        };
    }
    /**
   * Releases the given array back to the array pool.
   *
   * @private
   * @param {Array} [array] The array to release.
   */ function releaseArray(array) {
        array.length = 0;
        if (arrayPool.length < maxPoolSize) arrayPool.push(array);
    }
    /**
   * Releases the given object back to the object pool.
   *
   * @private
   * @param {Object} [object] The object to release.
   */ function releaseObject(object) {
        var cache = object.cache;
        if (cache) releaseObject(cache);
        object.array = object.cache = object.criteria = object.object = object.number = object.string = object.value = null;
        if (objectPool.length < maxPoolSize) objectPool.push(object);
    }
    /**
   * Slices the `collection` from the `start` index up to, but not including,
   * the `end` index.
   *
   * Note: This function is used instead of `Array#slice` to support node lists
   * in IE < 9 and to ensure dense arrays are returned.
   *
   * @private
   * @param {Array|Object|string} collection The collection to slice.
   * @param {number} start The start index.
   * @param {number} end The end index.
   * @returns {Array} Returns the new array.
   */ function slice(array, start, end) {
        start || (start = 0);
        if (typeof end == "undefined") end = array ? array.length : 0;
        var index = -1, length = end - start || 0, result = Array(length < 0 ? 0 : length);
        while(++index < length)result[index] = array[start + index];
        return result;
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new `lodash` function using the given context object.
   *
   * @static
   * @memberOf _
   * @category Utilities
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns the `lodash` function.
   */ function runInContext(context) {
        // Avoid issues with some ES3 environments that attempt to use values, named
        // after built-in constructors like `Object`, for the creation of literals.
        // ES5 clears this up by stating that literals must use built-in constructors.
        // See http://es5.github.io/#x11.1.5.
        context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;
        /** Native constructor references */ var Array1 = context.Array, Boolean = context.Boolean, Date1 = context.Date, Function = context.Function, Math = context.Math, Number = context.Number, Object = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /**
     * Used for `Array` method references.
     *
     * Normally `Array.prototype` would suffice, however, using an array literal
     * avoids issues in Narwhal.
     */ var arrayRef = [];
        /** Used for native method references */ var objectProto = Object.prototype;
        /** Used to restore the original `_` reference in `noConflict` */ var oldDash = context._;
        /** Used to resolve the internal [[Class]] of values */ var toString = objectProto.toString;
        /** Used to detect if a method is native */ var reNative = RegExp1("^" + String(toString).replace(/[.*+?^${}()|[\]\\]/g, "\\$&").replace(/toString| for [^\]]+/g, ".*?") + "$");
        /** Native method shortcuts */ var ceil = Math.ceil, clearTimeout = context.clearTimeout, floor = Math.floor, fnToString = Function.prototype.toString, getPrototypeOf = isNative(getPrototypeOf = Object.getPrototypeOf) && getPrototypeOf, hasOwnProperty = objectProto.hasOwnProperty, push = arrayRef.push, setTimeout = context.setTimeout, splice = arrayRef.splice, unshift = arrayRef.unshift;
        /** Used to set meta data on functions */ var defineProperty = function() {
            // IE 8 only accepts DOM elements
            try {
                var o = {}, func = isNative(func = Object.defineProperty) && func, result = func(o, o, o) && func;
            } catch (e) {}
            return result;
        }();
        /* Native method shortcuts for methods with the same name as other `lodash` methods */ var nativeCreate = isNative(nativeCreate = Object.create) && nativeCreate, nativeIsArray = isNative(nativeIsArray = Array1.isArray) && nativeIsArray, nativeIsFinite = context.isFinite, nativeIsNaN = context.isNaN, nativeKeys = isNative(nativeKeys = Object.keys) && nativeKeys, nativeMax = Math.max, nativeMin = Math.min, nativeParseInt = context.parseInt, nativeRandom = Math.random;
        /** Used to lookup a built-in constructor by [[Class]] */ var ctorByClass = {};
        ctorByClass[arrayClass] = Array1;
        ctorByClass[boolClass] = Boolean;
        ctorByClass[dateClass] = Date1;
        ctorByClass[funcClass] = Function;
        ctorByClass[objectClass] = Object;
        ctorByClass[numberClass] = Number;
        ctorByClass[regexpClass] = RegExp1;
        ctorByClass[stringClass] = String;
        /*--------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps the given value to enable intuitive
     * method chaining.
     *
     * In addition to Lo-Dash methods, wrappers also have the following `Array` methods:
     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`, `splice`,
     * and `unshift`
     *
     * Chaining is supported in custom builds as long as the `value` method is
     * implicitly or explicitly included in the build.
     *
     * The chainable wrapper functions are:
     * `after`, `assign`, `bind`, `bindAll`, `bindKey`, `chain`, `compact`,
     * `compose`, `concat`, `countBy`, `create`, `createCallback`, `curry`,
     * `debounce`, `defaults`, `defer`, `delay`, `difference`, `filter`, `flatten`,
     * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
     * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
     * `invoke`, `keys`, `map`, `max`, `memoize`, `merge`, `min`, `object`, `omit`,
     * `once`, `pairs`, `partial`, `partialRight`, `pick`, `pluck`, `pull`, `push`,
     * `range`, `reject`, `remove`, `rest`, `reverse`, `shuffle`, `slice`, `sort`,
     * `sortBy`, `splice`, `tap`, `throttle`, `times`, `toArray`, `transform`,
     * `union`, `uniq`, `unshift`, `unzip`, `values`, `where`, `without`, `wrap`,
     * and `zip`
     *
     * The non-chainable wrapper functions are:
     * `clone`, `cloneDeep`, `contains`, `escape`, `every`, `find`, `findIndex`,
     * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `has`, `identity`,
     * `indexOf`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
     * `isEmpty`, `isEqual`, `isFinite`, `isFunction`, `isNaN`, `isNull`, `isNumber`,
     * `isObject`, `isPlainObject`, `isRegExp`, `isString`, `isUndefined`, `join`,
     * `lastIndexOf`, `mixin`, `noConflict`, `parseInt`, `pop`, `random`, `reduce`,
     * `reduceRight`, `result`, `shift`, `size`, `some`, `sortedIndex`, `runInContext`,
     * `template`, `unescape`, `uniqueId`, and `value`
     *
     * The wrapper functions `first` and `last` return wrapped values when `n` is
     * provided, otherwise they return unwrapped values.
     *
     * Explicit chaining can be enabled by using the `_.chain` method.
     *
     * @name _
     * @constructor
     * @category Chaining
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns a `lodash` instance.
     * @example
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // returns an unwrapped value
     * wrapped.reduce(function(sum, num) {
     *   return sum + num;
     * });
     * // => 6
     *
     * // returns a wrapped value
     * var squares = wrapped.map(function(num) {
     *   return num * num;
     * });
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            // don't wrap if already wrapped, even if wrapped by a different `lodash` constructor
            return value && typeof value == "object" && !isArray(value) && hasOwnProperty.call(value, "__wrapped__") ? value : new lodashWrapper(value);
        }
        /**
     * A fast path for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap in a `lodash` instance.
     * @param {boolean} chainAll A flag to enable chaining for all methods
     * @returns {Object} Returns a `lodash` instance.
     */ function lodashWrapper(value, chainAll) {
            this.__chain__ = !!chainAll;
            this.__wrapped__ = value;
        }
        // ensure `new lodashWrapper` is an instance of `lodash`
        lodashWrapper.prototype = lodash.prototype;
        /**
     * An object used to flag environments features.
     *
     * @static
     * @memberOf _
     * @type Object
     */ var support = lodash.support = {};
        /**
     * Detect if functions can be decompiled by `Function#toString`
     * (all but PS3 and older Opera mobile browsers & avoided in Windows 8 apps).
     *
     * @memberOf _.support
     * @type boolean
     */ support.funcDecomp = !isNative(context.WinRTError) && reThis.test(runInContext);
        /**
     * Detect if `Function#name` is supported (all but IE).
     *
     * @memberOf _.support
     * @type boolean
     */ support.funcNames = typeof Function.name == "string";
        /**
     * By default, the template delimiters used by Lo-Dash are similar to those in
     * embedded Ruby (ERB). Change the following template settings to use alternative
     * delimiters.
     *
     * @static
     * @memberOf _
     * @type Object
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */ "escape": /<%-([\s\S]+?)%>/g,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */ "evaluate": /<%([\s\S]+?)%>/g,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type string
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type Object
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type Function
         */ "_": lodash
            }
        };
        /*--------------------------------------------------------------------------*/ /**
     * The base implementation of `_.bind` that creates the bound function and
     * sets its meta data.
     *
     * @private
     * @param {Array} bindData The bind data array.
     * @returns {Function} Returns the new bound function.
     */ function baseBind(bindData) {
            var func = bindData[0], partialArgs = bindData[2], thisArg = bindData[4];
            function bound() {
                // `Function#bind` spec
                // http://es5.github.io/#x15.3.4.5
                if (partialArgs) {
                    // avoid `arguments` object deoptimizations by using `slice` instead
                    // of `Array.prototype.slice.call` and not assigning `arguments` to a
                    // variable as a ternary expression
                    var args = slice(partialArgs);
                    push.apply(args, arguments);
                }
                // mimic the constructor's `return` behavior
                // http://es5.github.io/#x13.2.2
                if (this instanceof bound) {
                    // ensure `new bound` is an instance of `func`
                    var thisBinding = baseCreate(func.prototype), result = func.apply(thisBinding, args || arguments);
                    return isObject(result) ? result : thisBinding;
                }
                return func.apply(thisArg, args || arguments);
            }
            setBindData(bound, bindData);
            return bound;
        }
        /**
     * The base implementation of `_.clone` without argument juggling or support
     * for `thisArg` binding.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep=false] Specify a deep clone.
     * @param {Function} [callback] The function to customize cloning values.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates clones with source counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, isDeep, callback, stackA, stackB) {
            if (callback) {
                var result = callback(value);
                if (typeof result != "undefined") return result;
            }
            // inspect [[Class]]
            var isObj = isObject(value);
            if (isObj) {
                var className = toString.call(value);
                if (!cloneableClasses[className]) return value;
                var ctor = ctorByClass[className];
                switch(className){
                    case boolClass:
                    case dateClass:
                        return new ctor(+value);
                    case numberClass:
                    case stringClass:
                        return new ctor(value);
                    case regexpClass:
                        result = ctor(value.source, reFlags.exec(value));
                        result.lastIndex = value.lastIndex;
                        return result;
                }
            } else return value;
            var isArr = isArray(value);
            if (isDeep) {
                // check for circular references and return corresponding clone
                var initedStack = !stackA;
                stackA || (stackA = getArray());
                stackB || (stackB = getArray());
                var length = stackA.length;
                while(length--){
                    if (stackA[length] == value) return stackB[length];
                }
                result = isArr ? ctor(value.length) : {};
            } else result = isArr ? slice(value) : assign({}, value);
            // add array properties assigned by `RegExp#exec`
            if (isArr) {
                if (hasOwnProperty.call(value, "index")) result.index = value.index;
                if (hasOwnProperty.call(value, "input")) result.input = value.input;
            }
            // exit for shallow clone
            if (!isDeep) return result;
            // add the source value to the stack of traversed objects
            // and associate it with its clone
            stackA.push(value);
            stackB.push(result);
            // recursively populate clone (susceptible to call stack limits)
            (isArr ? forEach : forOwn)(value, function(objValue, key) {
                result[key] = baseClone(objValue, isDeep, callback, stackA, stackB);
            });
            if (initedStack) {
                releaseArray(stackA);
                releaseArray(stackB);
            }
            return result;
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} prototype The object to inherit from.
     * @returns {Object} Returns the new object.
     */ function baseCreate(prototype, properties) {
            return isObject(prototype) ? nativeCreate(prototype) : {};
        }
        // fallback for browsers without `Object.create`
        if (!nativeCreate) baseCreate = function() {
            function Object() {}
            return function(prototype) {
                if (isObject(prototype)) {
                    Object.prototype = prototype;
                    var result = new Object;
                    Object.prototype = null;
                }
                return result || context.Object();
            };
        }();
        /**
     * The base implementation of `_.createCallback` without support for creating
     * "_.pluck" or "_.where" style callbacks.
     *
     * @private
     * @param {*} [func=identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of the created callback.
     * @param {number} [argCount] The number of arguments the callback accepts.
     * @returns {Function} Returns a callback function.
     */ function baseCreateCallback(func, thisArg, argCount) {
            if (typeof func != "function") return identity;
            // exit early for no `thisArg` or already bound by `Function#bind`
            if (typeof thisArg == "undefined" || !("prototype" in func)) return func;
            var bindData = func.__bindData__;
            if (typeof bindData == "undefined") {
                if (support.funcNames) bindData = !func.name;
                bindData = bindData || !support.funcDecomp;
                if (!bindData) {
                    var source = fnToString.call(func);
                    if (!support.funcNames) bindData = !reFuncName.test(source);
                    if (!bindData) {
                        // checks if `func` references the `this` keyword and stores the result
                        bindData = reThis.test(source);
                        setBindData(func, bindData);
                    }
                }
            }
            // exit early if there are no `this` references or `func` is bound
            if (bindData === false || bindData !== true && bindData[1] & 1) return func;
            switch(argCount){
                case 1:
                    return function(value) {
                        return func.call(thisArg, value);
                    };
                case 2:
                    return function(a, b) {
                        return func.call(thisArg, a, b);
                    };
                case 3:
                    return function(value, index, collection) {
                        return func.call(thisArg, value, index, collection);
                    };
                case 4:
                    return function(accumulator, value, index, collection) {
                        return func.call(thisArg, accumulator, value, index, collection);
                    };
            }
            return bind(func, thisArg);
        }
        /**
     * The base implementation of `createWrapper` that creates the wrapper and
     * sets its meta data.
     *
     * @private
     * @param {Array} bindData The bind data array.
     * @returns {Function} Returns the new function.
     */ function baseCreateWrapper(bindData) {
            var func = bindData[0], bitmask = bindData[1], partialArgs = bindData[2], partialRightArgs = bindData[3], thisArg = bindData[4], arity = bindData[5];
            var isBind = bitmask & 1, isBindKey = bitmask & 2, isCurry = bitmask & 4, isCurryBound = bitmask & 8, key = func;
            function bound() {
                var thisBinding = isBind ? thisArg : this;
                if (partialArgs) {
                    var args = slice(partialArgs);
                    push.apply(args, arguments);
                }
                if (partialRightArgs || isCurry) {
                    args || (args = slice(arguments));
                    if (partialRightArgs) push.apply(args, partialRightArgs);
                    if (isCurry && args.length < arity) {
                        bitmask |= 16;
                        return baseCreateWrapper([
                            func,
                            isCurryBound ? bitmask : bitmask & -4,
                            args,
                            null,
                            thisArg,
                            arity
                        ]);
                    }
                }
                args || (args = arguments);
                if (isBindKey) func = thisBinding[key];
                if (this instanceof bound) {
                    thisBinding = baseCreate(func.prototype);
                    var result = func.apply(thisBinding, args);
                    return isObject(result) ? result : thisBinding;
                }
                return func.apply(thisBinding, args);
            }
            setBindData(bound, bindData);
            return bound;
        }
        /**
     * The base implementation of `_.difference` that accepts a single array
     * of values to exclude.
     *
     * @private
     * @param {Array} array The array to process.
     * @param {Array} [values] The array of values to exclude.
     * @returns {Array} Returns a new array of filtered values.
     */ function baseDifference(array, values) {
            var index = -1, indexOf = getIndexOf(), length = array ? array.length : 0, isLarge = length >= largeArraySize && indexOf === baseIndexOf, result = [];
            if (isLarge) {
                var cache = createCache(values);
                if (cache) {
                    indexOf = cacheIndexOf;
                    values = cache;
                } else isLarge = false;
            }
            while(++index < length){
                var value = array[index];
                if (indexOf(values, value) < 0) result.push(value);
            }
            if (isLarge) releaseObject(values);
            return result;
        }
        /**
     * The base implementation of `_.flatten` without support for callback
     * shorthands or `thisArg` binding.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {boolean} [isShallow=false] A flag to restrict flattening to a single level.
     * @param {boolean} [isStrict=false] A flag to restrict flattening to arrays and `arguments` objects.
     * @param {number} [fromIndex=0] The index to start from.
     * @returns {Array} Returns a new flattened array.
     */ function baseFlatten(array, isShallow, isStrict, fromIndex) {
            var index = (fromIndex || 0) - 1, length = array ? array.length : 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value && typeof value == "object" && typeof value.length == "number" && (isArray(value) || isArguments(value))) {
                    // recursively flatten arrays (susceptible to call stack limits)
                    if (!isShallow) value = baseFlatten(value, isShallow, isStrict);
                    var valIndex = -1, valLength = value.length, resIndex = result.length;
                    result.length += valLength;
                    while(++valIndex < valLength)result[resIndex++] = value[valIndex];
                } else if (!isStrict) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.isEqual`, without support for `thisArg` binding,
     * that allows partial "_.where" style comparisons.
     *
     * @private
     * @param {*} a The value to compare.
     * @param {*} b The other value to compare.
     * @param {Function} [callback] The function to customize comparing values.
     * @param {Function} [isWhere=false] A flag to indicate performing partial comparisons.
     * @param {Array} [stackA=[]] Tracks traversed `a` objects.
     * @param {Array} [stackB=[]] Tracks traversed `b` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(a, b, callback, isWhere, stackA, stackB) {
            // used to indicate that when comparing objects, `a` has at least the properties of `b`
            if (callback) {
                var result = callback(a, b);
                if (typeof result != "undefined") return !!result;
            }
            // exit early for identical values
            if (a === b) // treat `+0` vs. `-0` as not equal
            return a !== 0 || 1 / a == 1 / b;
            var type = typeof a, otherType = typeof b;
            // exit early for unlike primitive values
            if (a === a && !(a && objectTypes[type]) && !(b && objectTypes[otherType])) return false;
            // exit early for `null` and `undefined` avoiding ES3's Function#call behavior
            // http://es5.github.io/#x15.3.4.4
            if (a == null || b == null) return a === b;
            // compare [[Class]] names
            var className = toString.call(a), otherClass = toString.call(b);
            if (className == argsClass) className = objectClass;
            if (otherClass == argsClass) otherClass = objectClass;
            if (className != otherClass) return false;
            switch(className){
                case boolClass:
                case dateClass:
                    // coerce dates and booleans to numbers, dates to milliseconds and booleans
                    // to `1` or `0` treating invalid dates coerced to `NaN` as not equal
                    return +a == +b;
                case numberClass:
                    // treat `NaN` vs. `NaN` as equal
                    return a != +a ? b != +b : a == 0 ? 1 / a == 1 / b : a == +b;
                case regexpClass:
                case stringClass:
                    // coerce regexes to strings (http://es5.github.io/#x15.10.6.4)
                    // treat string primitives and their corresponding object instances as equal
                    return a == String(b);
            }
            var isArr = className == arrayClass;
            if (!isArr) {
                // unwrap any `lodash` wrapped values
                var aWrapped = hasOwnProperty.call(a, "__wrapped__"), bWrapped = hasOwnProperty.call(b, "__wrapped__");
                if (aWrapped || bWrapped) return baseIsEqual(aWrapped ? a.__wrapped__ : a, bWrapped ? b.__wrapped__ : b, callback, isWhere, stackA, stackB);
                // exit for functions and DOM nodes
                if (className != objectClass) return false;
                // in older versions of Opera, `arguments` objects have `Array` constructors
                var ctorA = a.constructor, ctorB = b.constructor;
                // non `Object` object instances with different constructors are not equal
                if (ctorA != ctorB && !(isFunction(ctorA) && ctorA instanceof ctorA && isFunction(ctorB) && ctorB instanceof ctorB) && "constructor" in a && "constructor" in b) return false;
            }
            // assume cyclic structures are equal
            // the algorithm for detecting cyclic structures is adapted from ES 5.1
            // section 15.12.3, abstract operation `JO` (http://es5.github.io/#x15.12.3)
            var initedStack = !stackA;
            stackA || (stackA = getArray());
            stackB || (stackB = getArray());
            var length = stackA.length;
            while(length--){
                if (stackA[length] == a) return stackB[length] == b;
            }
            var size = 0;
            result = true;
            // add `a` and `b` to the stack of traversed objects
            stackA.push(a);
            stackB.push(b);
            // recursively compare objects and arrays (susceptible to call stack limits)
            if (isArr) {
                // compare lengths to determine if a deep comparison is necessary
                length = a.length;
                size = b.length;
                result = size == length;
                if (result || isWhere) // deep compare the contents, ignoring non-numeric properties
                while(size--){
                    var index = length, value = b[size];
                    if (isWhere) while(index--){
                        if (result = baseIsEqual(a[index], value, callback, isWhere, stackA, stackB)) break;
                    }
                    else if (!(result = baseIsEqual(a[size], value, callback, isWhere, stackA, stackB))) break;
                }
            } else {
                // deep compare objects using `forIn`, instead of `forOwn`, to avoid `Object.keys`
                // which, in this case, is more costly
                forIn(b, function(value, key, b) {
                    if (hasOwnProperty.call(b, key)) {
                        // count the number of properties.
                        size++;
                        // deep compare each property value.
                        return result = hasOwnProperty.call(a, key) && baseIsEqual(a[key], value, callback, isWhere, stackA, stackB);
                    }
                });
                if (result && !isWhere) // ensure both objects have the same number of properties
                forIn(a, function(value, key, a) {
                    if (hasOwnProperty.call(a, key)) // `size` will be `-1` if `a` has more properties than `b`
                    return result = --size > -1;
                });
            }
            stackA.pop();
            stackB.pop();
            if (initedStack) {
                releaseArray(stackA);
                releaseArray(stackB);
            }
            return result;
        }
        /**
     * The base implementation of `_.merge` without argument juggling or support
     * for `thisArg` binding.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {Function} [callback] The function to customize merging properties.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates values with source counterparts.
     */ function baseMerge(object, source, callback, stackA, stackB) {
            (isArray(source) ? forEach : forOwn)(source, function(source, key) {
                var found, isArr, result = source, value = object[key];
                if (source && ((isArr = isArray(source)) || isPlainObject(source))) {
                    // avoid merging previously merged cyclic sources
                    var stackLength = stackA.length;
                    while(stackLength--)if (found = stackA[stackLength] == source) {
                        value = stackB[stackLength];
                        break;
                    }
                    if (!found) {
                        var isShallow;
                        if (callback) {
                            result = callback(value, source);
                            if (isShallow = typeof result != "undefined") value = result;
                        }
                        if (!isShallow) value = isArr ? isArray(value) ? value : [] : isPlainObject(value) ? value : {};
                        // add `source` and associated `value` to the stack of traversed objects
                        stackA.push(source);
                        stackB.push(value);
                        // recursively merge objects and arrays (susceptible to call stack limits)
                        if (!isShallow) baseMerge(value, source, callback, stackA, stackB);
                    }
                } else {
                    if (callback) {
                        result = callback(value, source);
                        if (typeof result == "undefined") result = source;
                    }
                    if (typeof result != "undefined") value = result;
                }
                object[key] = value;
            });
        }
        /**
     * The base implementation of `_.random` without argument juggling or support
     * for returning floating-point numbers.
     *
     * @private
     * @param {number} min The minimum possible value.
     * @param {number} max The maximum possible value.
     * @returns {number} Returns a random number.
     */ function baseRandom(min, max) {
            return min + floor(nativeRandom() * (max - min + 1));
        }
        /**
     * The base implementation of `_.uniq` without support for callback shorthands
     * or `thisArg` binding.
     *
     * @private
     * @param {Array} array The array to process.
     * @param {boolean} [isSorted=false] A flag to indicate that `array` is sorted.
     * @param {Function} [callback] The function called per iteration.
     * @returns {Array} Returns a duplicate-value-free array.
     */ function baseUniq(array, isSorted, callback) {
            var index = -1, indexOf = getIndexOf(), length = array ? array.length : 0, result = [];
            var isLarge = !isSorted && length >= largeArraySize && indexOf === baseIndexOf, seen = callback || isLarge ? getArray() : result;
            if (isLarge) {
                var cache = createCache(seen);
                indexOf = cacheIndexOf;
                seen = cache;
            }
            while(++index < length){
                var value = array[index], computed = callback ? callback(value, index, array) : value;
                if (isSorted ? !index || seen[seen.length - 1] !== computed : indexOf(seen, computed) < 0) {
                    if (callback || isLarge) seen.push(computed);
                    result.push(value);
                }
            }
            if (isLarge) {
                releaseArray(seen.array);
                releaseObject(seen);
            } else if (callback) releaseArray(seen);
            return result;
        }
        /**
     * Creates a function that aggregates a collection, creating an object composed
     * of keys generated from the results of running each element of the collection
     * through a callback. The given `setter` function sets the keys and values
     * of the composed object.
     *
     * @private
     * @param {Function} setter The setter function.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter) {
            return function(collection, callback, thisArg) {
                var result = {};
                callback = lodash.createCallback(callback, thisArg, 3);
                var index = -1, length = collection ? collection.length : 0;
                if (typeof length == "number") while(++index < length){
                    var value = collection[index];
                    setter(result, value, callback(value, index, collection), collection);
                }
                else forOwn(collection, function(value, key, collection) {
                    setter(result, value, callback(value, key, collection), collection);
                });
                return result;
            };
        }
        /**
     * Creates a function that, when called, either curries or invokes `func`
     * with an optional `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to reference.
     * @param {number} bitmask The bitmask of method flags to compose.
     *  The bitmask may be composed of the following flags:
     *  1 - `_.bind`
     *  2 - `_.bindKey`
     *  4 - `_.curry`
     *  8 - `_.curry` (bound)
     *  16 - `_.partial`
     *  32 - `_.partialRight`
     * @param {Array} [partialArgs] An array of arguments to prepend to those
     *  provided to the new function.
     * @param {Array} [partialRightArgs] An array of arguments to append to those
     *  provided to the new function.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new function.
     */ function createWrapper(func, bitmask, partialArgs, partialRightArgs, thisArg, arity) {
            var isBind = bitmask & 1, isBindKey = bitmask & 2, isCurry = bitmask & 4, isCurryBound = bitmask & 8, isPartial = bitmask & 16, isPartialRight = bitmask & 32;
            if (!isBindKey && !isFunction(func)) throw new TypeError;
            if (isPartial && !partialArgs.length) {
                bitmask &= -17;
                isPartial = partialArgs = false;
            }
            if (isPartialRight && !partialRightArgs.length) {
                bitmask &= -33;
                isPartialRight = partialRightArgs = false;
            }
            var bindData = func && func.__bindData__;
            if (bindData && bindData !== true) {
                // clone `bindData`
                bindData = slice(bindData);
                if (bindData[2]) bindData[2] = slice(bindData[2]);
                if (bindData[3]) bindData[3] = slice(bindData[3]);
                // set `thisBinding` is not previously bound
                if (isBind && !(bindData[1] & 1)) bindData[4] = thisArg;
                // set if previously bound but not currently (subsequent curried functions)
                if (!isBind && bindData[1] & 1) bitmask |= 8;
                // set curried arity if not yet set
                if (isCurry && !(bindData[1] & 4)) bindData[5] = arity;
                // append partial left arguments
                if (isPartial) push.apply(bindData[2] || (bindData[2] = []), partialArgs);
                // append partial right arguments
                if (isPartialRight) unshift.apply(bindData[3] || (bindData[3] = []), partialRightArgs);
                // merge flags
                bindData[1] |= bitmask;
                return createWrapper.apply(null, bindData);
            }
            // fast path for `_.bind`
            var creater = bitmask == 1 || bitmask === 17 ? baseBind : baseCreateWrapper;
            return creater([
                func,
                bitmask,
                partialArgs,
                partialRightArgs,
                thisArg,
                arity
            ]);
        }
        /**
     * Used by `escape` to convert characters to HTML entities.
     *
     * @private
     * @param {string} match The matched character to escape.
     * @returns {string} Returns the escaped character.
     */ function escapeHtmlChar(match) {
            return htmlEscapes[match];
        }
        /**
     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
     * customized, this method returns the custom method, otherwise it returns
     * the `baseIndexOf` function.
     *
     * @private
     * @returns {Function} Returns the "indexOf" function.
     */ function getIndexOf() {
            var result = (result = lodash.indexOf) === indexOf ? baseIndexOf : result;
            return result;
        }
        /**
     * Checks if `value` is a native function.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if the `value` is a native function, else `false`.
     */ function isNative(value) {
            return typeof value == "function" && reNative.test(value);
        }
        /**
     * Sets `this` binding data on a given function.
     *
     * @private
     * @param {Function} func The function to set data on.
     * @param {Array} value The data array to set.
     */ var setBindData = !defineProperty ? noop : function(func, value) {
            descriptor.value = value;
            defineProperty(func, "__bindData__", descriptor);
            descriptor.value = null;
        };
        /**
     * A fallback implementation of `isPlainObject` which checks if a given value
     * is an object created by the `Object` constructor, assuming objects created
     * by the `Object` constructor have no inherited enumerable properties and that
     * there are no `Object.prototype` extensions.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     */ function shimIsPlainObject(value) {
            var ctor, result;
            // avoid non Object objects, `arguments` objects, and DOM elements
            if (!(value && toString.call(value) == objectClass) || (ctor = value.constructor, isFunction(ctor) && !(ctor instanceof ctor))) return false;
            // In most environments an object's own properties are iterated before
            // its inherited properties. If the last iterated property is an object's
            // own property then there are no inherited enumerable properties.
            forIn(value, function(value, key) {
                result = key;
            });
            return typeof result == "undefined" || hasOwnProperty.call(value, result);
        }
        /**
     * Used by `unescape` to convert HTML entities to characters.
     *
     * @private
     * @param {string} match The matched character to unescape.
     * @returns {string} Returns the unescaped character.
     */ function unescapeHtmlChar(match) {
            return htmlUnescapes[match];
        }
        /*--------------------------------------------------------------------------*/ /**
     * Checks if `value` is an `arguments` object.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if the `value` is an `arguments` object, else `false`.
     * @example
     *
     * (function() { return _.isArguments(arguments); })(1, 2, 3);
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ function isArguments(value) {
            return value && typeof value == "object" && typeof value.length == "number" && toString.call(value) == argsClass || false;
        }
        /**
     * Checks if `value` is an array.
     *
     * @static
     * @memberOf _
     * @type Function
     * @category Objects
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if the `value` is an array, else `false`.
     * @example
     *
     * (function() { return _.isArray(arguments); })();
     * // => false
     *
     * _.isArray([1, 2, 3]);
     * // => true
     */ var isArray = nativeIsArray || function(value) {
            return value && typeof value == "object" && typeof value.length == "number" && toString.call(value) == arrayClass || false;
        };
        /**
     * A fallback implementation of `Object.keys` which produces an array of the
     * given object's own enumerable property names.
     *
     * @private
     * @type Function
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns an array of property names.
     */ var shimKeys = function(object) {
            var index, iterable = object, result = [];
            if (!iterable) return result;
            if (!objectTypes[typeof object]) return result;
            for(index in iterable)if (hasOwnProperty.call(iterable, index)) result.push(index);
            return result;
        };
        /**
     * Creates an array composed of the own enumerable property names of an object.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns an array of property names.
     * @example
     *
     * _.keys({ 'one': 1, 'two': 2, 'three': 3 });
     * // => ['one', 'two', 'three'] (property order is not guaranteed across environments)
     */ var keys = !nativeKeys ? shimKeys : function(object) {
            if (!isObject(object)) return [];
            return nativeKeys(object);
        };
        /**
     * Used to convert characters to HTML entities:
     *
     * Though the `>` character is escaped for symmetry, characters like `>` and `/`
     * don't require escaping in HTML and have no special meaning unless they're part
     * of a tag or an unquoted attribute value.
     * http://mathiasbynens.be/notes/ambiguous-ampersands (under "semi-related fun fact")
     */ var htmlEscapes = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;"
        };
        /** Used to convert HTML entities to characters */ var htmlUnescapes = invert(htmlEscapes);
        /** Used to match HTML entities and HTML characters */ var reEscapedHtml = RegExp1("(" + keys(htmlUnescapes).join("|") + ")", "g"), reUnescapedHtml = RegExp1("[" + keys(htmlEscapes).join("") + "]", "g");
        /*--------------------------------------------------------------------------*/ /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object. Subsequent sources will overwrite property assignments of previous
     * sources. If a callback is provided it will be executed to produce the
     * assigned values. The callback is bound to `thisArg` and invoked with two
     * arguments; (objectValue, sourceValue).
     *
     * @static
     * @memberOf _
     * @type Function
     * @alias extend
     * @category Objects
     * @param {Object} object The destination object.
     * @param {...Object} [source] The source objects.
     * @param {Function} [callback] The function to customize assigning values.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Object} Returns the destination object.
     * @example
     *
     * _.assign({ 'name': 'fred' }, { 'employer': 'slate' });
     * // => { 'name': 'fred', 'employer': 'slate' }
     *
     * var defaults = _.partialRight(_.assign, function(a, b) {
     *   return typeof a == 'undefined' ? b : a;
     * });
     *
     * var object = { 'name': 'barney' };
     * defaults(object, { 'name': 'fred', 'employer': 'slate' });
     * // => { 'name': 'barney', 'employer': 'slate' }
     */ var assign = function(object, source, guard) {
            var index, iterable = object, result = iterable;
            if (!iterable) return result;
            var args = arguments, argsIndex = 0, argsLength = typeof guard == "number" ? 2 : args.length;
            if (argsLength > 3 && typeof args[argsLength - 2] == "function") var callback = baseCreateCallback(args[--argsLength - 1], args[argsLength--], 2);
            else if (argsLength > 2 && typeof args[argsLength - 1] == "function") callback = args[--argsLength];
            while(++argsIndex < argsLength){
                iterable = args[argsIndex];
                if (iterable && objectTypes[typeof iterable]) {
                    var ownIndex = -1, ownProps = objectTypes[typeof iterable] && keys(iterable), length = ownProps ? ownProps.length : 0;
                    while(++ownIndex < length){
                        index = ownProps[ownIndex];
                        result[index] = callback ? callback(result[index], iterable[index]) : iterable[index];
                    }
                }
            }
            return result;
        };
        /**
     * Creates a clone of `value`. If `isDeep` is `true` nested objects will also
     * be cloned, otherwise they will be assigned by reference. If a callback
     * is provided it will be executed to produce the cloned values. If the
     * callback returns `undefined` cloning will be handled by the method instead.
     * The callback is bound to `thisArg` and invoked with one argument; (value).
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep=false] Specify a deep clone.
     * @param {Function} [callback] The function to customize cloning values.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {*} Returns the cloned value.
     * @example
     *
     * var characters = [
     *   { 'name': 'barney', 'age': 36 },
     *   { 'name': 'fred',   'age': 40 }
     * ];
     *
     * var shallow = _.clone(characters);
     * shallow[0] === characters[0];
     * // => true
     *
     * var deep = _.clone(characters, true);
     * deep[0] === characters[0];
     * // => false
     *
     * _.mixin({
     *   'clone': _.partialRight(_.clone, function(value) {
     *     return _.isElement(value) ? value.cloneNode(false) : undefined;
     *   })
     * });
     *
     * var clone = _.clone(document.body);
     * clone.childNodes.length;
     * // => 0
     */ function clone(value, isDeep, callback, thisArg) {
            // allows working with "Collections" methods without using their `index`
            // and `collection` arguments for `isDeep` and `callback`
            if (typeof isDeep != "boolean" && isDeep != null) {
                thisArg = callback;
                callback = isDeep;
                isDeep = false;
            }
            return baseClone(value, isDeep, typeof callback == "function" && baseCreateCallback(callback, thisArg, 1));
        }
        /**
     * Creates a deep clone of `value`. If a callback is provided it will be
     * executed to produce the cloned values. If the callback returns `undefined`
     * cloning will be handled by the method instead. The callback is bound to
     * `thisArg` and invoked with one argument; (value).
     *
     * Note: This method is loosely based on the structured clone algorithm. Functions
     * and DOM nodes are **not** cloned. The enumerable properties of `arguments` objects and
     * objects created by constructors other than `Object` are cloned to plain `Object` objects.
     * See http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {*} value The value to deep clone.
     * @param {Function} [callback] The function to customize cloning values.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {*} Returns the deep cloned value.
     * @example
     *
     * var characters = [
     *   { 'name': 'barney', 'age': 36 },
     *   { 'name': 'fred',   'age': 40 }
     * ];
     *
     * var deep = _.cloneDeep(characters);
     * deep[0] === characters[0];
     * // => false
     *
     * var view = {
     *   'label': 'docs',
     *   'node': element
     * };
     *
     * var clone = _.cloneDeep(view, function(value) {
     *   return _.isElement(value) ? value.cloneNode(true) : undefined;
     * });
     *
     * clone.node == view.node;
     * // => false
     */ function cloneDeep(value, callback, thisArg) {
            return baseClone(value, true, typeof callback == "function" && baseCreateCallback(callback, thisArg, 1));
        }
        /**
     * Creates an object that inherits from the given `prototype` object. If a
     * `properties` object is provided its own enumerable properties are assigned
     * to the created object.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, { 'constructor': Circle });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties ? assign(result, properties) : result;
        }
        /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object for all destination properties that resolve to `undefined`. Once a
     * property is set, additional defaults of the same property will be ignored.
     *
     * @static
     * @memberOf _
     * @type Function
     * @category Objects
     * @param {Object} object The destination object.
     * @param {...Object} [source] The source objects.
     * @param- {Object} [guard] Allows working with `_.reduce` without using its
     *  `key` and `object` arguments as sources.
     * @returns {Object} Returns the destination object.
     * @example
     *
     * var object = { 'name': 'barney' };
     * _.defaults(object, { 'name': 'fred', 'employer': 'slate' });
     * // => { 'name': 'barney', 'employer': 'slate' }
     */ var defaults = function(object, source, guard) {
            var index, iterable = object, result = iterable;
            if (!iterable) return result;
            var args = arguments, argsIndex = 0, argsLength = typeof guard == "number" ? 2 : args.length;
            while(++argsIndex < argsLength){
                iterable = args[argsIndex];
                if (iterable && objectTypes[typeof iterable]) {
                    var ownIndex = -1, ownProps = objectTypes[typeof iterable] && keys(iterable), length = ownProps ? ownProps.length : 0;
                    while(++ownIndex < length){
                        index = ownProps[ownIndex];
                        if (typeof result[index] == "undefined") result[index] = iterable[index];
                    }
                }
            }
            return result;
        };
        /**
     * This method is like `_.findIndex` except that it returns the key of the
     * first element that passes the callback check, instead of the element itself.
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [callback=identity] The function called per
     *  iteration. If a property name or object is provided it will be used to
     *  create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {string|undefined} Returns the key of the found element, else `undefined`.
     * @example
     *
     * var characters = {
     *   'barney': {  'age': 36, 'blocked': false },
     *   'fred': {    'age': 40, 'blocked': true },
     *   'pebbles': { 'age': 1,  'blocked': false }
     * };
     *
     * _.findKey(characters, function(chr) {
     *   return chr.age < 40;
     * });
     * // => 'barney' (property order is not guaranteed across environments)
     *
     * // using "_.where" callback shorthand
     * _.findKey(characters, { 'age': 1 });
     * // => 'pebbles'
     *
     * // using "_.pluck" callback shorthand
     * _.findKey(characters, 'blocked');
     * // => 'fred'
     */ function findKey(object, callback, thisArg) {
            var result;
            callback = lodash.createCallback(callback, thisArg, 3);
            forOwn(object, function(value, key, object) {
                if (callback(value, key, object)) {
                    result = key;
                    return false;
                }
            });
            return result;
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements
     * of a `collection` in the opposite order.
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [callback=identity] The function called per
     *  iteration. If a property name or object is provided it will be used to
     *  create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {string|undefined} Returns the key of the found element, else `undefined`.
     * @example
     *
     * var characters = {
     *   'barney': {  'age': 36, 'blocked': true },
     *   'fred': {    'age': 40, 'blocked': false },
     *   'pebbles': { 'age': 1,  'blocked': true }
     * };
     *
     * _.findLastKey(characters, function(chr) {
     *   return chr.age < 40;
     * });
     * // => returns `pebbles`, assuming `_.findKey` returns `barney`
     *
     * // using "_.where" callback shorthand
     * _.findLastKey(characters, { 'age': 40 });
     * // => 'fred'
     *
     * // using "_.pluck" callback shorthand
     * _.findLastKey(characters, 'blocked');
     * // => 'pebbles'
     */ function findLastKey(object, callback, thisArg) {
            var result;
            callback = lodash.createCallback(callback, thisArg, 3);
            forOwnRight(object, function(value, key, object) {
                if (callback(value, key, object)) {
                    result = key;
                    return false;
                }
            });
            return result;
        }
        /**
     * Iterates over own and inherited enumerable properties of an object,
     * executing the callback for each property. The callback is bound to `thisArg`
     * and invoked with three arguments; (value, key, object). Callbacks may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @type Function
     * @category Objects
     * @param {Object} object The object to iterate over.
     * @param {Function} [callback=identity] The function called per iteration.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * Shape.prototype.move = function(x, y) {
     *   this.x += x;
     *   this.y += y;
     * };
     *
     * _.forIn(new Shape, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'x', 'y', and 'move' (property order is not guaranteed across environments)
     */ var forIn = function(collection, callback, thisArg) {
            var index, iterable = collection, result = iterable;
            if (!iterable) return result;
            if (!objectTypes[typeof iterable]) return result;
            callback = callback && typeof thisArg == "undefined" ? callback : baseCreateCallback(callback, thisArg, 3);
            for(index in iterable){
                if (callback(iterable[index], index, collection) === false) return result;
            }
            return result;
        };
        /**
     * This method is like `_.forIn` except that it iterates over elements
     * of a `collection` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {Object} object The object to iterate over.
     * @param {Function} [callback=identity] The function called per iteration.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * Shape.prototype.move = function(x, y) {
     *   this.x += x;
     *   this.y += y;
     * };
     *
     * _.forInRight(new Shape, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'move', 'y', and 'x' assuming `_.forIn ` logs 'x', 'y', and 'move'
     */ function forInRight(object, callback, thisArg) {
            var pairs = [];
            forIn(object, function(value, key) {
                pairs.push(key, value);
            });
            var length = pairs.length;
            callback = baseCreateCallback(callback, thisArg, 3);
            while(length--){
                if (callback(pairs[length--], pairs[length], object) === false) break;
            }
            return object;
        }
        /**
     * Iterates over own enumerable properties of an object, executing the callback
     * for each property. The callback is bound to `thisArg` and invoked with three
     * arguments; (value, key, object). Callbacks may exit iteration early by
     * explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @type Function
     * @category Objects
     * @param {Object} object The object to iterate over.
     * @param {Function} [callback=identity] The function called per iteration.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.forOwn({ '0': 'zero', '1': 'one', 'length': 2 }, function(num, key) {
     *   console.log(key);
     * });
     * // => logs '0', '1', and 'length' (property order is not guaranteed across environments)
     */ var forOwn = function(collection, callback, thisArg) {
            var index, iterable = collection, result = iterable;
            if (!iterable) return result;
            if (!objectTypes[typeof iterable]) return result;
            callback = callback && typeof thisArg == "undefined" ? callback : baseCreateCallback(callback, thisArg, 3);
            var ownIndex = -1, ownProps = objectTypes[typeof iterable] && keys(iterable), length = ownProps ? ownProps.length : 0;
            while(++ownIndex < length){
                index = ownProps[ownIndex];
                if (callback(iterable[index], index, collection) === false) return result;
            }
            return result;
        };
        /**
     * This method is like `_.forOwn` except that it iterates over elements
     * of a `collection` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {Object} object The object to iterate over.
     * @param {Function} [callback=identity] The function called per iteration.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.forOwnRight({ '0': 'zero', '1': 'one', 'length': 2 }, function(num, key) {
     *   console.log(key);
     * });
     * // => logs 'length', '1', and '0' assuming `_.forOwn` logs '0', '1', and 'length'
     */ function forOwnRight(object, callback, thisArg) {
            var props = keys(object), length = props.length;
            callback = baseCreateCallback(callback, thisArg, 3);
            while(length--){
                var key = props[length];
                if (callback(object[key], key, object) === false) break;
            }
            return object;
        }
        /**
     * Creates a sorted array of property names of all enumerable properties,
     * own and inherited, of `object` that have function values.
     *
     * @static
     * @memberOf _
     * @alias methods
     * @category Objects
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns an array of property names that have function values.
     * @example
     *
     * _.functions(_);
     * // => ['all', 'any', 'bind', 'bindAll', 'clone', 'compact', 'compose', ...]
     */ function functions(object) {
            var result = [];
            forIn(object, function(value, key) {
                if (isFunction(value)) result.push(key);
            });
            return result.sort();
        }
        /**
     * Checks if the specified property name exists as a direct property of `object`,
     * instead of an inherited property.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {Object} object The object to inspect.
     * @param {string} key The name of the property to check.
     * @returns {boolean} Returns `true` if key is a direct property, else `false`.
     * @example
     *
     * _.has({ 'a': 1, 'b': 2, 'c': 3 }, 'b');
     * // => true
     */ function has(object, key) {
            return object ? hasOwnProperty.call(object, key) : false;
        }
        /**
     * Creates an object composed of the inverted keys and values of the given object.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the created inverted object.
     * @example
     *
     * _.invert({ 'first': 'fred', 'second': 'barney' });
     * // => { 'fred': 'first', 'barney': 'second' }
     */ function invert(object) {
            var index = -1, props = keys(object), length = props.length, result = {};
            while(++index < length){
                var key = props[index];
                result[object[key]] = key;
            }
            return result;
        }
        /**
     * Checks if `value` is a boolean value.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if the `value` is a boolean value, else `false`.
     * @example
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || value && typeof value == "object" && toString.call(value) == boolClass || false;
        }
        /**
     * Checks if `value` is a date.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if the `value` is a date, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     */ function isDate(value) {
            return value && typeof value == "object" && toString.call(value) == dateClass || false;
        }
        /**
     * Checks if `value` is a DOM element.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if the `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     */ function isElement(value) {
            return value && value.nodeType === 1 || false;
        }
        /**
     * Checks if `value` is empty. Arrays, strings, or `arguments` objects with a
     * length of `0` and objects with no own enumerable properties are considered
     * "empty".
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {Array|Object|string} value The value to inspect.
     * @returns {boolean} Returns `true` if the `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({});
     * // => true
     *
     * _.isEmpty('');
     * // => true
     */ function isEmpty(value) {
            var result = true;
            if (!value) return result;
            var className = toString.call(value), length = value.length;
            if (className == arrayClass || className == stringClass || className == argsClass || className == objectClass && typeof length == "number" && isFunction(value.splice)) return !length;
            forOwn(value, function() {
                return result = false;
            });
            return result;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent to each other. If a callback is provided it will be executed
     * to compare values. If the callback returns `undefined` comparisons will
     * be handled by the method instead. The callback is bound to `thisArg` and
     * invoked with two arguments; (a, b).
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {*} a The value to compare.
     * @param {*} b The other value to compare.
     * @param {Function} [callback] The function to customize comparing values.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'name': 'fred' };
     * var copy = { 'name': 'fred' };
     *
     * object == copy;
     * // => false
     *
     * _.isEqual(object, copy);
     * // => true
     *
     * var words = ['hello', 'goodbye'];
     * var otherWords = ['hi', 'goodbye'];
     *
     * _.isEqual(words, otherWords, function(a, b) {
     *   var reGreet = /^(?:hello|hi)$/i,
     *       aGreet = _.isString(a) && reGreet.test(a),
     *       bGreet = _.isString(b) && reGreet.test(b);
     *
     *   return (aGreet || bGreet) ? (aGreet == bGreet) : undefined;
     * });
     * // => true
     */ function isEqual(a, b, callback, thisArg) {
            return baseIsEqual(a, b, typeof callback == "function" && baseCreateCallback(callback, thisArg, 2));
        }
        /**
     * Checks if `value` is, or can be coerced to, a finite number.
     *
     * Note: This is not the same as native `isFinite` which will return true for
     * booleans and empty strings. See http://es5.github.io/#x15.1.2.5.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if the `value` is finite, else `false`.
     * @example
     *
     * _.isFinite(-101);
     * // => true
     *
     * _.isFinite('10');
     * // => true
     *
     * _.isFinite(true);
     * // => false
     *
     * _.isFinite('');
     * // => false
     *
     * _.isFinite(Infinity);
     * // => false
     */ function isFinite(value) {
            return nativeIsFinite(value) && !nativeIsNaN(parseFloat(value));
        }
        /**
     * Checks if `value` is a function.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if the `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     */ function isFunction(value) {
            return typeof value == "function";
        }
        /**
     * Checks if `value` is the language type of Object.
     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if the `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(1);
     * // => false
     */ function isObject(value) {
            // check if the value is the ECMAScript language type of Object
            // http://es5.github.io/#x8
            // and avoid a V8 bug
            // http://code.google.com/p/v8/issues/detail?id=2291
            return !!(value && objectTypes[typeof value]);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * Note: This is not the same as native `isNaN` which will return `true` for
     * `undefined` and other non-numeric values. See http://es5.github.io/#x15.1.2.4.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if the `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // `NaN` as a primitive is the only value that is not equal to itself
            // (perform the [[Class]] check first to avoid errors with some host objects in IE)
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if the `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(undefined);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is a number.
     *
     * Note: `NaN` is considered a number. See http://es5.github.io/#x8.5.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if the `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(8.4 * 5);
     * // => true
     */ function isNumber(value) {
            return typeof value == "number" || value && typeof value == "object" && toString.call(value) == numberClass || false;
        }
        /**
     * Checks if `value` is an object created by the `Object` constructor.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * _.isPlainObject(new Shape);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     */ var isPlainObject = !getPrototypeOf ? shimIsPlainObject : function(value) {
            if (!(value && toString.call(value) == objectClass)) return false;
            var valueOf = value.valueOf, objProto = isNative(valueOf) && (objProto = getPrototypeOf(valueOf)) && getPrototypeOf(objProto);
            return objProto ? value == objProto || getPrototypeOf(value) == objProto : shimIsPlainObject(value);
        };
        /**
     * Checks if `value` is a regular expression.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if the `value` is a regular expression, else `false`.
     * @example
     *
     * _.isRegExp(/fred/);
     * // => true
     */ function isRegExp(value) {
            return value && typeof value == "object" && toString.call(value) == regexpClass || false;
        }
        /**
     * Checks if `value` is a string.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if the `value` is a string, else `false`.
     * @example
     *
     * _.isString('fred');
     * // => true
     */ function isString(value) {
            return typeof value == "string" || value && typeof value == "object" && toString.call(value) == stringClass || false;
        }
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if the `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     */ function isUndefined(value) {
            return typeof value == "undefined";
        }
        /**
     * Creates an object with the same keys as `object` and values generated by
     * running each own enumerable property of `object` through the callback.
     * The callback is bound to `thisArg` and invoked with three arguments;
     * (value, key, object).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {Object} object The object to iterate over.
     * @param {Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Array} Returns a new object with values of the results of each `callback` execution.
     * @example
     *
     * _.mapValues({ 'a': 1, 'b': 2, 'c': 3} , function(num) { return num * 3; });
     * // => { 'a': 3, 'b': 6, 'c': 9 }
     *
     * var characters = {
     *   'fred': { 'name': 'fred', 'age': 40 },
     *   'pebbles': { 'name': 'pebbles', 'age': 1 }
     * };
     *
     * // using "_.pluck" callback shorthand
     * _.mapValues(characters, 'age');
     * // => { 'fred': 40, 'pebbles': 1 }
     */ function mapValues(object, callback, thisArg) {
            var result = {};
            callback = lodash.createCallback(callback, thisArg, 3);
            forOwn(object, function(value, key, object) {
                result[key] = callback(value, key, object);
            });
            return result;
        }
        /**
     * Recursively merges own enumerable properties of the source object(s), that
     * don't resolve to `undefined` into the destination object. Subsequent sources
     * will overwrite property assignments of previous sources. If a callback is
     * provided it will be executed to produce the merged values of the destination
     * and source properties. If the callback returns `undefined` merging will
     * be handled by the method instead. The callback is bound to `thisArg` and
     * invoked with two arguments; (objectValue, sourceValue).
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {Object} object The destination object.
     * @param {...Object} [source] The source objects.
     * @param {Function} [callback] The function to customize merging properties.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Object} Returns the destination object.
     * @example
     *
     * var names = {
     *   'characters': [
     *     { 'name': 'barney' },
     *     { 'name': 'fred' }
     *   ]
     * };
     *
     * var ages = {
     *   'characters': [
     *     { 'age': 36 },
     *     { 'age': 40 }
     *   ]
     * };
     *
     * _.merge(names, ages);
     * // => { 'characters': [{ 'name': 'barney', 'age': 36 }, { 'name': 'fred', 'age': 40 }] }
     *
     * var food = {
     *   'fruits': ['apple'],
     *   'vegetables': ['beet']
     * };
     *
     * var otherFood = {
     *   'fruits': ['banana'],
     *   'vegetables': ['carrot']
     * };
     *
     * _.merge(food, otherFood, function(a, b) {
     *   return _.isArray(a) ? a.concat(b) : undefined;
     * });
     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot] }
     */ function merge(object) {
            var args = arguments, length = 2;
            if (!isObject(object)) return object;
            // allows working with `_.reduce` and `_.reduceRight` without using
            // their `index` and `collection` arguments
            if (typeof args[2] != "number") length = args.length;
            if (length > 3 && typeof args[length - 2] == "function") var callback = baseCreateCallback(args[--length - 1], args[length--], 2);
            else if (length > 2 && typeof args[length - 1] == "function") callback = args[--length];
            var sources = slice(arguments, 1, length), index = -1, stackA = getArray(), stackB = getArray();
            while(++index < length)baseMerge(object, sources[index], callback, stackA, stackB);
            releaseArray(stackA);
            releaseArray(stackB);
            return object;
        }
        /**
     * Creates a shallow clone of `object` excluding the specified properties.
     * Property names may be specified as individual arguments or as arrays of
     * property names. If a callback is provided it will be executed for each
     * property of `object` omitting the properties the callback returns truey
     * for. The callback is bound to `thisArg` and invoked with three arguments;
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {Object} object The source object.
     * @param {Function|...string|string[]} [callback] The properties to omit or the
     *  function called per iteration.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Object} Returns an object without the omitted properties.
     * @example
     *
     * _.omit({ 'name': 'fred', 'age': 40 }, 'age');
     * // => { 'name': 'fred' }
     *
     * _.omit({ 'name': 'fred', 'age': 40 }, function(value) {
     *   return typeof value == 'number';
     * });
     * // => { 'name': 'fred' }
     */ function omit(object, callback, thisArg) {
            var result = {};
            if (typeof callback != "function") {
                var props = [];
                forIn(object, function(value, key) {
                    props.push(key);
                });
                props = baseDifference(props, baseFlatten(arguments, true, false, 1));
                var index = -1, length = props.length;
                while(++index < length){
                    var key = props[index];
                    result[key] = object[key];
                }
            } else {
                callback = lodash.createCallback(callback, thisArg, 3);
                forIn(object, function(value, key, object) {
                    if (!callback(value, key, object)) result[key] = value;
                });
            }
            return result;
        }
        /**
     * Creates a two dimensional array of an object's key-value pairs,
     * i.e. `[[key1, value1], [key2, value2]]`.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns new array of key-value pairs.
     * @example
     *
     * _.pairs({ 'barney': 36, 'fred': 40 });
     * // => [['barney', 36], ['fred', 40]] (property order is not guaranteed across environments)
     */ function pairs(object) {
            var index = -1, props = keys(object), length = props.length, result = Array1(length);
            while(++index < length){
                var key = props[index];
                result[index] = [
                    key,
                    object[key]
                ];
            }
            return result;
        }
        /**
     * Creates a shallow clone of `object` composed of the specified properties.
     * Property names may be specified as individual arguments or as arrays of
     * property names. If a callback is provided it will be executed for each
     * property of `object` picking the properties the callback returns truey
     * for. The callback is bound to `thisArg` and invoked with three arguments;
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {Object} object The source object.
     * @param {Function|...string|string[]} [callback] The function called per
     *  iteration or property names to pick, specified as individual property
     *  names or arrays of property names.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Object} Returns an object composed of the picked properties.
     * @example
     *
     * _.pick({ 'name': 'fred', '_userid': 'fred1' }, 'name');
     * // => { 'name': 'fred' }
     *
     * _.pick({ 'name': 'fred', '_userid': 'fred1' }, function(value, key) {
     *   return key.charAt(0) != '_';
     * });
     * // => { 'name': 'fred' }
     */ function pick(object, callback, thisArg) {
            var result = {};
            if (typeof callback != "function") {
                var index = -1, props = baseFlatten(arguments, true, false, 1), length = isObject(object) ? props.length : 0;
                while(++index < length){
                    var key = props[index];
                    if (key in object) result[key] = object[key];
                }
            } else {
                callback = lodash.createCallback(callback, thisArg, 3);
                forIn(object, function(value, key, object) {
                    if (callback(value, key, object)) result[key] = value;
                });
            }
            return result;
        }
        /**
     * An alternative to `_.reduce` this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable properties through a callback, with each callback execution
     * potentially mutating the `accumulator` object. The callback is bound to
     * `thisArg` and invoked with four arguments; (accumulator, value, key, object).
     * Callbacks may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {Array|Object} object The object to iterate over.
     * @param {Function} [callback=identity] The function called per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * var squares = _.transform([1, 2, 3, 4, 5, 6, 7, 8, 9, 10], function(result, num) {
     *   num *= num;
     *   if (num % 2) {
     *     return result.push(num) < 3;
     *   }
     * });
     * // => [1, 9, 25]
     *
     * var mapped = _.transform({ 'a': 1, 'b': 2, 'c': 3 }, function(result, num, key) {
     *   result[key] = num * 3;
     * });
     * // => { 'a': 3, 'b': 6, 'c': 9 }
     */ function transform(object, callback, accumulator, thisArg) {
            var isArr = isArray(object);
            if (accumulator == null) {
                if (isArr) accumulator = [];
                else {
                    var ctor = object && object.constructor, proto = ctor && ctor.prototype;
                    accumulator = baseCreate(proto);
                }
            }
            if (callback) {
                callback = lodash.createCallback(callback, thisArg, 4);
                (isArr ? forEach : forOwn)(object, function(value, index, object) {
                    return callback(accumulator, value, index, object);
                });
            }
            return accumulator;
        }
        /**
     * Creates an array composed of the own enumerable property values of `object`.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns an array of property values.
     * @example
     *
     * _.values({ 'one': 1, 'two': 2, 'three': 3 });
     * // => [1, 2, 3] (property order is not guaranteed across environments)
     */ function values(object) {
            var index = -1, props = keys(object), length = props.length, result = Array1(length);
            while(++index < length)result[index] = object[props[index]];
            return result;
        }
        /*--------------------------------------------------------------------------*/ /**
     * Creates an array of elements from the specified indexes, or keys, of the
     * `collection`. Indexes may be specified as individual arguments or as arrays
     * of indexes.
     *
     * @static
     * @memberOf _
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {...(number|number[]|string|string[])} [index] The indexes of `collection`
     *   to retrieve, specified as individual indexes or arrays of indexes.
     * @returns {Array} Returns a new array of elements corresponding to the
     *  provided indexes.
     * @example
     *
     * _.at(['a', 'b', 'c', 'd', 'e'], [0, 2, 4]);
     * // => ['a', 'c', 'e']
     *
     * _.at(['fred', 'barney', 'pebbles'], 0, 2);
     * // => ['fred', 'pebbles']
     */ function at(collection) {
            var args = arguments, index = -1, props = baseFlatten(args, true, false, 1), length = args[2] && args[2][args[1]] === collection ? 1 : props.length, result = Array1(length);
            while(++index < length)result[index] = collection[props[index]];
            return result;
        }
        /**
     * Checks if a given value is present in a collection using strict equality
     * for comparisons, i.e. `===`. If `fromIndex` is negative, it is used as the
     * offset from the end of the collection.
     *
     * @static
     * @memberOf _
     * @alias include
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {*} target The value to check for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {boolean} Returns `true` if the `target` element is found, else `false`.
     * @example
     *
     * _.contains([1, 2, 3], 1);
     * // => true
     *
     * _.contains([1, 2, 3], 1, 2);
     * // => false
     *
     * _.contains({ 'name': 'fred', 'age': 40 }, 'fred');
     * // => true
     *
     * _.contains('pebbles', 'eb');
     * // => true
     */ function contains(collection, target, fromIndex) {
            var index = -1, indexOf = getIndexOf(), length = collection ? collection.length : 0, result = false;
            fromIndex = (fromIndex < 0 ? nativeMax(0, length + fromIndex) : fromIndex) || 0;
            if (isArray(collection)) result = indexOf(collection, target, fromIndex) > -1;
            else if (typeof length == "number") result = (isString(collection) ? collection.indexOf(target, fromIndex) : indexOf(collection, target, fromIndex)) > -1;
            else forOwn(collection, function(value) {
                if (++index >= fromIndex) return !(result = value === target);
            });
            return result;
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through the callback. The corresponding value
     * of each key is the number of times the key was returned by the callback.
     * The callback is bound to `thisArg` and invoked with three arguments;
     * (value, index|key, collection).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([4.3, 6.1, 6.4], function(num) { return Math.floor(num); });
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy([4.3, 6.1, 6.4], function(num) { return this.floor(num); }, Math);
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            hasOwnProperty.call(result, key) ? result[key]++ : result[key] = 1;
        });
        /**
     * Checks if the given callback returns truey value for **all** elements of
     * a collection. The callback is bound to `thisArg` and invoked with three
     * arguments; (value, index|key, collection).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @alias all
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {boolean} Returns `true` if all elements passed the callback check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes']);
     * // => false
     *
     * var characters = [
     *   { 'name': 'barney', 'age': 36 },
     *   { 'name': 'fred',   'age': 40 }
     * ];
     *
     * // using "_.pluck" callback shorthand
     * _.every(characters, 'age');
     * // => true
     *
     * // using "_.where" callback shorthand
     * _.every(characters, { 'age': 36 });
     * // => false
     */ function every(collection, callback, thisArg) {
            var result = true;
            callback = lodash.createCallback(callback, thisArg, 3);
            var index = -1, length = collection ? collection.length : 0;
            if (typeof length == "number") while(++index < length){
                if (!(result = !!callback(collection[index], index, collection))) break;
            }
            else forOwn(collection, function(value, index, collection) {
                return result = !!callback(value, index, collection);
            });
            return result;
        }
        /**
     * Iterates over elements of a collection, returning an array of all elements
     * the callback returns truey for. The callback is bound to `thisArg` and
     * invoked with three arguments; (value, index|key, collection).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @alias select
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Array} Returns a new array of elements that passed the callback check.
     * @example
     *
     * var evens = _.filter([1, 2, 3, 4, 5, 6], function(num) { return num % 2 == 0; });
     * // => [2, 4, 6]
     *
     * var characters = [
     *   { 'name': 'barney', 'age': 36, 'blocked': false },
     *   { 'name': 'fred',   'age': 40, 'blocked': true }
     * ];
     *
     * // using "_.pluck" callback shorthand
     * _.filter(characters, 'blocked');
     * // => [{ 'name': 'fred', 'age': 40, 'blocked': true }]
     *
     * // using "_.where" callback shorthand
     * _.filter(characters, { 'age': 36 });
     * // => [{ 'name': 'barney', 'age': 36, 'blocked': false }]
     */ function filter(collection, callback, thisArg) {
            var result = [];
            callback = lodash.createCallback(callback, thisArg, 3);
            var index = -1, length = collection ? collection.length : 0;
            if (typeof length == "number") while(++index < length){
                var value = collection[index];
                if (callback(value, index, collection)) result.push(value);
            }
            else forOwn(collection, function(value, index, collection) {
                if (callback(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * Iterates over elements of a collection, returning the first element that
     * the callback returns truey for. The callback is bound to `thisArg` and
     * invoked with three arguments; (value, index|key, collection).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @alias detect, findWhere
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {*} Returns the found element, else `undefined`.
     * @example
     *
     * var characters = [
     *   { 'name': 'barney',  'age': 36, 'blocked': false },
     *   { 'name': 'fred',    'age': 40, 'blocked': true },
     *   { 'name': 'pebbles', 'age': 1,  'blocked': false }
     * ];
     *
     * _.find(characters, function(chr) {
     *   return chr.age < 40;
     * });
     * // => { 'name': 'barney', 'age': 36, 'blocked': false }
     *
     * // using "_.where" callback shorthand
     * _.find(characters, { 'age': 1 });
     * // =>  { 'name': 'pebbles', 'age': 1, 'blocked': false }
     *
     * // using "_.pluck" callback shorthand
     * _.find(characters, 'blocked');
     * // => { 'name': 'fred', 'age': 40, 'blocked': true }
     */ function find(collection, callback, thisArg) {
            callback = lodash.createCallback(callback, thisArg, 3);
            var index = -1, length = collection ? collection.length : 0;
            if (typeof length == "number") while(++index < length){
                var value = collection[index];
                if (callback(value, index, collection)) return value;
            }
            else {
                var result;
                forOwn(collection, function(value, index, collection) {
                    if (callback(value, index, collection)) {
                        result = value;
                        return false;
                    }
                });
                return result;
            }
        }
        /**
     * This method is like `_.find` except that it iterates over elements
     * of a `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {*} Returns the found element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(num) {
     *   return num % 2 == 1;
     * });
     * // => 3
     */ function findLast(collection, callback, thisArg) {
            var result;
            callback = lodash.createCallback(callback, thisArg, 3);
            forEachRight(collection, function(value, index, collection) {
                if (callback(value, index, collection)) {
                    result = value;
                    return false;
                }
            });
            return result;
        }
        /**
     * Iterates over elements of a collection, executing the callback for each
     * element. The callback is bound to `thisArg` and invoked with three arguments;
     * (value, index|key, collection). Callbacks may exit iteration early by
     * explicitly returning `false`.
     *
     * Note: As with other "Collections" methods, objects with a `length` property
     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
     * may be used for object iteration.
     *
     * @static
     * @memberOf _
     * @alias each
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [callback=identity] The function called per iteration.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Array|Object|string} Returns `collection`.
     * @example
     *
     * _([1, 2, 3]).forEach(function(num) { console.log(num); }).join(',');
     * // => logs each number and returns '1,2,3'
     *
     * _.forEach({ 'one': 1, 'two': 2, 'three': 3 }, function(num) { console.log(num); });
     * // => logs each number and returns the object (property order is not guaranteed across environments)
     */ function forEach(collection, callback, thisArg) {
            var index = -1, length = collection ? collection.length : 0;
            callback = callback && typeof thisArg == "undefined" ? callback : baseCreateCallback(callback, thisArg, 3);
            if (typeof length == "number") while(++index < length){
                if (callback(collection[index], index, collection) === false) break;
            }
            else forOwn(collection, callback);
            return collection;
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements
     * of a `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @alias eachRight
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [callback=identity] The function called per iteration.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Array|Object|string} Returns `collection`.
     * @example
     *
     * _([1, 2, 3]).forEachRight(function(num) { console.log(num); }).join(',');
     * // => logs each number from right to left and returns '3,2,1'
     */ function forEachRight(collection, callback, thisArg) {
            var length = collection ? collection.length : 0;
            callback = callback && typeof thisArg == "undefined" ? callback : baseCreateCallback(callback, thisArg, 3);
            if (typeof length == "number") while(length--){
                if (callback(collection[length], length, collection) === false) break;
            }
            else {
                var props = keys(collection);
                length = props.length;
                forOwn(collection, function(value, key, collection) {
                    key = props ? props[--length] : --length;
                    return callback(collection[key], key, collection);
                });
            }
            return collection;
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of a collection through the callback. The corresponding value
     * of each key is an array of the elements responsible for generating the key.
     * The callback is bound to `thisArg` and invoked with three arguments;
     * (value, index|key, collection).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`
     *
     * @static
     * @memberOf _
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([4.2, 6.1, 6.4], function(num) { return Math.floor(num); });
     * // => { '4': [4.2], '6': [6.1, 6.4] }
     *
     * _.groupBy([4.2, 6.1, 6.4], function(num) { return this.floor(num); }, Math);
     * // => { '4': [4.2], '6': [6.1, 6.4] }
     *
     * // using "_.pluck" callback shorthand
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            (hasOwnProperty.call(result, key) ? result[key] : result[key] = []).push(value);
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of the collection through the given callback. The corresponding
     * value of each key is the last element responsible for generating the key.
     * The callback is bound to `thisArg` and invoked with three arguments;
     * (value, index|key, collection).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var keys = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.indexBy(keys, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     *
     * _.indexBy(keys, function(key) { return String.fromCharCode(key.code); });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.indexBy(characters, function(key) { this.fromCharCode(key.code); }, String);
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     */ var indexBy = createAggregator(function(result, value, key) {
            result[key] = value;
        });
        /**
     * Invokes the method named by `methodName` on each element in the `collection`
     * returning an array of the results of each invoked method. Additional arguments
     * will be provided to each invoked method. If `methodName` is a function it
     * will be invoked for, and `this` bound to, each element in the `collection`.
     *
     * @static
     * @memberOf _
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|string} methodName The name of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [arg] Arguments to invoke the method with.
     * @returns {Array} Returns a new array of the results of each invoked method.
     * @example
     *
     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invoke([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ function invoke(collection, methodName) {
            var args = slice(arguments, 2), index = -1, isFunc = typeof methodName == "function", length = collection ? collection.length : 0, result = Array1(typeof length == "number" ? length : 0);
            forEach(collection, function(value) {
                result[++index] = (isFunc ? methodName : value[methodName]).apply(value, args);
            });
            return result;
        }
        /**
     * Creates an array of values by running each element in the collection
     * through the callback. The callback is bound to `thisArg` and invoked with
     * three arguments; (value, index|key, collection).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @alias collect
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Array} Returns a new array of the results of each `callback` execution.
     * @example
     *
     * _.map([1, 2, 3], function(num) { return num * 3; });
     * // => [3, 6, 9]
     *
     * _.map({ 'one': 1, 'two': 2, 'three': 3 }, function(num) { return num * 3; });
     * // => [3, 6, 9] (property order is not guaranteed across environments)
     *
     * var characters = [
     *   { 'name': 'barney', 'age': 36 },
     *   { 'name': 'fred',   'age': 40 }
     * ];
     *
     * // using "_.pluck" callback shorthand
     * _.map(characters, 'name');
     * // => ['barney', 'fred']
     */ function map(collection, callback, thisArg) {
            var index = -1, length = collection ? collection.length : 0;
            callback = lodash.createCallback(callback, thisArg, 3);
            if (typeof length == "number") {
                var result = Array1(length);
                while(++index < length)result[index] = callback(collection[index], index, collection);
            } else {
                result = [];
                forOwn(collection, function(value, key, collection) {
                    result[++index] = callback(value, key, collection);
                });
            }
            return result;
        }
        /**
     * Retrieves the maximum value of a collection. If the collection is empty or
     * falsey `-Infinity` is returned. If a callback is provided it will be executed
     * for each value in the collection to generate the criterion by which the value
     * is ranked. The callback is bound to `thisArg` and invoked with three
     * arguments; (value, index, collection).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * var characters = [
     *   { 'name': 'barney', 'age': 36 },
     *   { 'name': 'fred',   'age': 40 }
     * ];
     *
     * _.max(characters, function(chr) { return chr.age; });
     * // => { 'name': 'fred', 'age': 40 };
     *
     * // using "_.pluck" callback shorthand
     * _.max(characters, 'age');
     * // => { 'name': 'fred', 'age': 40 };
     */ function max(collection, callback, thisArg) {
            var computed = -Infinity, result = computed;
            // allows working with functions like `_.map` without using
            // their `index` argument as a callback
            if (typeof callback != "function" && thisArg && thisArg[callback] === collection) callback = null;
            if (callback == null && isArray(collection)) {
                var index = -1, length = collection.length;
                while(++index < length){
                    var value = collection[index];
                    if (value > result) result = value;
                }
            } else {
                callback = callback == null && isString(collection) ? charAtCallback : lodash.createCallback(callback, thisArg, 3);
                forEach(collection, function(value, index, collection) {
                    var current = callback(value, index, collection);
                    if (current > computed) {
                        computed = current;
                        result = value;
                    }
                });
            }
            return result;
        }
        /**
     * Retrieves the minimum value of a collection. If the collection is empty or
     * falsey `Infinity` is returned. If a callback is provided it will be executed
     * for each value in the collection to generate the criterion by which the value
     * is ranked. The callback is bound to `thisArg` and invoked with three
     * arguments; (value, index, collection).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * var characters = [
     *   { 'name': 'barney', 'age': 36 },
     *   { 'name': 'fred',   'age': 40 }
     * ];
     *
     * _.min(characters, function(chr) { return chr.age; });
     * // => { 'name': 'barney', 'age': 36 };
     *
     * // using "_.pluck" callback shorthand
     * _.min(characters, 'age');
     * // => { 'name': 'barney', 'age': 36 };
     */ function min(collection, callback, thisArg) {
            var computed = Infinity, result = computed;
            // allows working with functions like `_.map` without using
            // their `index` argument as a callback
            if (typeof callback != "function" && thisArg && thisArg[callback] === collection) callback = null;
            if (callback == null && isArray(collection)) {
                var index = -1, length = collection.length;
                while(++index < length){
                    var value = collection[index];
                    if (value < result) result = value;
                }
            } else {
                callback = callback == null && isString(collection) ? charAtCallback : lodash.createCallback(callback, thisArg, 3);
                forEach(collection, function(value, index, collection) {
                    var current = callback(value, index, collection);
                    if (current < computed) {
                        computed = current;
                        result = value;
                    }
                });
            }
            return result;
        }
        /**
     * Retrieves the value of a specified property from all elements in the collection.
     *
     * @static
     * @memberOf _
     * @type Function
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {string} property The name of the property to pluck.
     * @returns {Array} Returns a new array of property values.
     * @example
     *
     * var characters = [
     *   { 'name': 'barney', 'age': 36 },
     *   { 'name': 'fred',   'age': 40 }
     * ];
     *
     * _.pluck(characters, 'name');
     * // => ['barney', 'fred']
     */ var pluck = map;
        /**
     * Reduces a collection to a value which is the accumulated result of running
     * each element in the collection through the callback, where each successive
     * callback execution consumes the return value of the previous execution. If
     * `accumulator` is not provided the first element of the collection will be
     * used as the initial `accumulator` value. The callback is bound to `thisArg`
     * and invoked with four arguments; (accumulator, value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @alias foldl, inject
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [callback=identity] The function called per iteration.
     * @param {*} [accumulator] Initial value of the accumulator.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * var sum = _.reduce([1, 2, 3], function(sum, num) {
     *   return sum + num;
     * });
     * // => 6
     *
     * var mapped = _.reduce({ 'a': 1, 'b': 2, 'c': 3 }, function(result, num, key) {
     *   result[key] = num * 3;
     *   return result;
     * }, {});
     * // => { 'a': 3, 'b': 6, 'c': 9 }
     */ function reduce(collection, callback, accumulator, thisArg) {
            if (!collection) return accumulator;
            var noaccum = arguments.length < 3;
            callback = lodash.createCallback(callback, thisArg, 4);
            var index = -1, length = collection.length;
            if (typeof length == "number") {
                if (noaccum) accumulator = collection[++index];
                while(++index < length)accumulator = callback(accumulator, collection[index], index, collection);
            } else forOwn(collection, function(value, index, collection) {
                accumulator = noaccum ? (noaccum = false, value) : callback(accumulator, value, index, collection);
            });
            return accumulator;
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements
     * of a `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @alias foldr
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [callback=identity] The function called per iteration.
     * @param {*} [accumulator] Initial value of the accumulator.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * var list = [[0, 1], [2, 3], [4, 5]];
     * var flat = _.reduceRight(list, function(a, b) { return a.concat(b); }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, callback, accumulator, thisArg) {
            var noaccum = arguments.length < 3;
            callback = lodash.createCallback(callback, thisArg, 4);
            forEachRight(collection, function(value, index, collection) {
                accumulator = noaccum ? (noaccum = false, value) : callback(accumulator, value, index, collection);
            });
            return accumulator;
        }
        /**
     * The opposite of `_.filter` this method returns the elements of a
     * collection that the callback does **not** return truey for.
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Array} Returns a new array of elements that failed the callback check.
     * @example
     *
     * var odds = _.reject([1, 2, 3, 4, 5, 6], function(num) { return num % 2 == 0; });
     * // => [1, 3, 5]
     *
     * var characters = [
     *   { 'name': 'barney', 'age': 36, 'blocked': false },
     *   { 'name': 'fred',   'age': 40, 'blocked': true }
     * ];
     *
     * // using "_.pluck" callback shorthand
     * _.reject(characters, 'blocked');
     * // => [{ 'name': 'barney', 'age': 36, 'blocked': false }]
     *
     * // using "_.where" callback shorthand
     * _.reject(characters, { 'age': 36 });
     * // => [{ 'name': 'fred', 'age': 40, 'blocked': true }]
     */ function reject(collection, callback, thisArg) {
            callback = lodash.createCallback(callback, thisArg, 3);
            return filter(collection, function(value, index, collection) {
                return !callback(value, index, collection);
            });
        }
        /**
     * Retrieves a random element or `n` random elements from a collection.
     *
     * @static
     * @memberOf _
     * @category Collections
     * @param {Array|Object|string} collection The collection to sample.
     * @param {number} [n] The number of elements to sample.
     * @param- {Object} [guard] Allows working with functions like `_.map`
     *  without using their `index` arguments as `n`.
     * @returns {Array} Returns the random sample(s) of `collection`.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     *
     * _.sample([1, 2, 3, 4], 2);
     * // => [3, 1]
     */ function sample(collection, n, guard) {
            if (collection && typeof collection.length != "number") collection = values(collection);
            if (n == null || guard) return collection ? collection[baseRandom(0, collection.length - 1)] : undefined;
            var result = shuffle(collection);
            result.length = nativeMin(nativeMax(0, n), result.length);
            return result;
        }
        /**
     * Creates an array of shuffled values, using a version of the Fisher-Yates
     * shuffle. See http://en.wikipedia.org/wiki/Fisher-Yates_shuffle.
     *
     * @static
     * @memberOf _
     * @category Collections
     * @param {Array|Object|string} collection The collection to shuffle.
     * @returns {Array} Returns a new shuffled collection.
     * @example
     *
     * _.shuffle([1, 2, 3, 4, 5, 6]);
     * // => [4, 1, 6, 3, 5, 2]
     */ function shuffle(collection) {
            var index = -1, length = collection ? collection.length : 0, result = Array1(typeof length == "number" ? length : 0);
            forEach(collection, function(value) {
                var rand = baseRandom(0, ++index);
                result[index] = result[rand];
                result[rand] = value;
            });
            return result;
        }
        /**
     * Gets the size of the `collection` by returning `collection.length` for arrays
     * and array-like objects or the number of own enumerable properties for objects.
     *
     * @static
     * @memberOf _
     * @category Collections
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns `collection.length` or number of own enumerable properties.
     * @example
     *
     * _.size([1, 2]);
     * // => 2
     *
     * _.size({ 'one': 1, 'two': 2, 'three': 3 });
     * // => 3
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            var length = collection ? collection.length : 0;
            return typeof length == "number" ? length : keys(collection).length;
        }
        /**
     * Checks if the callback returns a truey value for **any** element of a
     * collection. The function returns as soon as it finds a passing value and
     * does not iterate over the entire collection. The callback is bound to
     * `thisArg` and invoked with three arguments; (value, index|key, collection).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @alias any
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {boolean} Returns `true` if any element passed the callback check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var characters = [
     *   { 'name': 'barney', 'age': 36, 'blocked': false },
     *   { 'name': 'fred',   'age': 40, 'blocked': true }
     * ];
     *
     * // using "_.pluck" callback shorthand
     * _.some(characters, 'blocked');
     * // => true
     *
     * // using "_.where" callback shorthand
     * _.some(characters, { 'age': 1 });
     * // => false
     */ function some(collection, callback, thisArg) {
            var result;
            callback = lodash.createCallback(callback, thisArg, 3);
            var index = -1, length = collection ? collection.length : 0;
            if (typeof length == "number") while(++index < length){
                if (result = callback(collection[index], index, collection)) break;
            }
            else forOwn(collection, function(value, index, collection) {
                return !(result = callback(value, index, collection));
            });
            return !!result;
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection through the callback. This method
     * performs a stable sort, that is, it will preserve the original sort order
     * of equal elements. The callback is bound to `thisArg` and invoked with
     * three arguments; (value, index|key, collection).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an array of property names is provided for `callback` the collection
     * will be sorted by each property value.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Array|Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Array} Returns a new array of sorted elements.
     * @example
     *
     * _.sortBy([1, 2, 3], function(num) { return Math.sin(num); });
     * // => [3, 1, 2]
     *
     * _.sortBy([1, 2, 3], function(num) { return this.sin(num); }, Math);
     * // => [3, 1, 2]
     *
     * var characters = [
     *   { 'name': 'barney',  'age': 36 },
     *   { 'name': 'fred',    'age': 40 },
     *   { 'name': 'barney',  'age': 26 },
     *   { 'name': 'fred',    'age': 30 }
     * ];
     *
     * // using "_.pluck" callback shorthand
     * _.map(_.sortBy(characters, 'age'), _.values);
     * // => [['barney', 26], ['fred', 30], ['barney', 36], ['fred', 40]]
     *
     * // sorting by multiple properties
     * _.map(_.sortBy(characters, ['name', 'age']), _.values);
     * // = > [['barney', 26], ['barney', 36], ['fred', 30], ['fred', 40]]
     */ function sortBy(collection, callback, thisArg) {
            var index = -1, isArr = isArray(callback), length = collection ? collection.length : 0, result = Array1(typeof length == "number" ? length : 0);
            if (!isArr) callback = lodash.createCallback(callback, thisArg, 3);
            forEach(collection, function(value, key, collection) {
                var object = result[++index] = getObject();
                if (isArr) object.criteria = map(callback, function(key) {
                    return value[key];
                });
                else (object.criteria = getArray())[0] = callback(value, key, collection);
                object.index = index;
                object.value = value;
            });
            length = result.length;
            result.sort(compareAscending);
            while(length--){
                var object = result[length];
                result[length] = object.value;
                if (!isArr) releaseArray(object.criteria);
                releaseObject(object);
            }
            return result;
        }
        /**
     * Converts the `collection` to an array.
     *
     * @static
     * @memberOf _
     * @category Collections
     * @param {Array|Object|string} collection The collection to convert.
     * @returns {Array} Returns the new converted array.
     * @example
     *
     * (function() { return _.toArray(arguments).slice(1); })(1, 2, 3, 4);
     * // => [2, 3, 4]
     */ function toArray(collection) {
            if (collection && typeof collection.length == "number") return slice(collection);
            return values(collection);
        }
        /**
     * Performs a deep comparison of each element in a `collection` to the given
     * `properties` object, returning an array of all elements that have equivalent
     * property values.
     *
     * @static
     * @memberOf _
     * @type Function
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Object} props The object of property values to filter by.
     * @returns {Array} Returns a new array of elements that have the given properties.
     * @example
     *
     * var characters = [
     *   { 'name': 'barney', 'age': 36, 'pets': ['hoppy'] },
     *   { 'name': 'fred',   'age': 40, 'pets': ['baby puss', 'dino'] }
     * ];
     *
     * _.where(characters, { 'age': 36 });
     * // => [{ 'name': 'barney', 'age': 36, 'pets': ['hoppy'] }]
     *
     * _.where(characters, { 'pets': ['dino'] });
     * // => [{ 'name': 'fred', 'age': 40, 'pets': ['baby puss', 'dino'] }]
     */ var where = filter;
        /*--------------------------------------------------------------------------*/ /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are all falsey.
     *
     * @static
     * @memberOf _
     * @category Arrays
     * @param {Array} array The array to compact.
     * @returns {Array} Returns a new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array ? array.length : 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result.push(value);
            }
            return result;
        }
        /**
     * Creates an array excluding all values of the provided arrays using strict
     * equality for comparisons, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @category Arrays
     * @param {Array} array The array to process.
     * @param {...Array} [values] The arrays of values to exclude.
     * @returns {Array} Returns a new array of filtered values.
     * @example
     *
     * _.difference([1, 2, 3, 4, 5], [5, 2, 10]);
     * // => [1, 3, 4]
     */ function difference(array) {
            return baseDifference(array, baseFlatten(arguments, true, true, 1));
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element that passes the callback check, instead of the element itself.
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @category Arrays
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var characters = [
     *   { 'name': 'barney',  'age': 36, 'blocked': false },
     *   { 'name': 'fred',    'age': 40, 'blocked': true },
     *   { 'name': 'pebbles', 'age': 1,  'blocked': false }
     * ];
     *
     * _.findIndex(characters, function(chr) {
     *   return chr.age < 20;
     * });
     * // => 2
     *
     * // using "_.where" callback shorthand
     * _.findIndex(characters, { 'age': 36 });
     * // => 0
     *
     * // using "_.pluck" callback shorthand
     * _.findIndex(characters, 'blocked');
     * // => 1
     */ function findIndex(array, callback, thisArg) {
            var index = -1, length = array ? array.length : 0;
            callback = lodash.createCallback(callback, thisArg, 3);
            while(++index < length){
                if (callback(array[index], index, array)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of a `collection` from right to left.
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @category Arrays
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var characters = [
     *   { 'name': 'barney',  'age': 36, 'blocked': true },
     *   { 'name': 'fred',    'age': 40, 'blocked': false },
     *   { 'name': 'pebbles', 'age': 1,  'blocked': true }
     * ];
     *
     * _.findLastIndex(characters, function(chr) {
     *   return chr.age > 30;
     * });
     * // => 1
     *
     * // using "_.where" callback shorthand
     * _.findLastIndex(characters, { 'age': 36 });
     * // => 0
     *
     * // using "_.pluck" callback shorthand
     * _.findLastIndex(characters, 'blocked');
     * // => 2
     */ function findLastIndex(array, callback, thisArg) {
            var length = array ? array.length : 0;
            callback = lodash.createCallback(callback, thisArg, 3);
            while(length--){
                if (callback(array[length], length, array)) return length;
            }
            return -1;
        }
        /**
     * Gets the first element or first `n` elements of an array. If a callback
     * is provided elements at the beginning of the array are returned as long
     * as the callback returns truey. The callback is bound to `thisArg` and
     * invoked with three arguments; (value, index, array).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @alias head, take
     * @category Arrays
     * @param {Array} array The array to query.
     * @param {Function|Object|number|string} [callback] The function called
     *  per element or the number of elements to return. If a property name or
     *  object is provided it will be used to create a "_.pluck" or "_.where"
     *  style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {*} Returns the first element(s) of `array`.
     * @example
     *
     * _.first([1, 2, 3]);
     * // => 1
     *
     * _.first([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.first([1, 2, 3], function(num) {
     *   return num < 3;
     * });
     * // => [1, 2]
     *
     * var characters = [
     *   { 'name': 'barney',  'blocked': true,  'employer': 'slate' },
     *   { 'name': 'fred',    'blocked': false, 'employer': 'slate' },
     *   { 'name': 'pebbles', 'blocked': true,  'employer': 'na' }
     * ];
     *
     * // using "_.pluck" callback shorthand
     * _.first(characters, 'blocked');
     * // => [{ 'name': 'barney', 'blocked': true, 'employer': 'slate' }]
     *
     * // using "_.where" callback shorthand
     * _.pluck(_.first(characters, { 'employer': 'slate' }), 'name');
     * // => ['barney', 'fred']
     */ function first(array, callback, thisArg) {
            var n = 0, length = array ? array.length : 0;
            if (typeof callback != "number" && callback != null) {
                var index = -1;
                callback = lodash.createCallback(callback, thisArg, 3);
                while(++index < length && callback(array[index], index, array))n++;
            } else {
                n = callback;
                if (n == null || thisArg) return array ? array[0] : undefined;
            }
            return slice(array, 0, nativeMin(nativeMax(0, n), length));
        }
        /**
     * Flattens a nested array (the nesting can be to any depth). If `isShallow`
     * is truey, the array will only be flattened a single level. If a callback
     * is provided each element of the array is passed through the callback before
     * flattening. The callback is bound to `thisArg` and invoked with three
     * arguments; (value, index, array).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @category Arrays
     * @param {Array} array The array to flatten.
     * @param {boolean} [isShallow=false] A flag to restrict flattening to a single level.
     * @param {Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Array} Returns a new flattened array.
     * @example
     *
     * _.flatten([1, [2], [3, [[4]]]]);
     * // => [1, 2, 3, 4];
     *
     * _.flatten([1, [2], [3, [[4]]]], true);
     * // => [1, 2, 3, [[4]]];
     *
     * var characters = [
     *   { 'name': 'barney', 'age': 30, 'pets': ['hoppy'] },
     *   { 'name': 'fred',   'age': 40, 'pets': ['baby puss', 'dino'] }
     * ];
     *
     * // using "_.pluck" callback shorthand
     * _.flatten(characters, 'pets');
     * // => ['hoppy', 'baby puss', 'dino']
     */ function flatten(array, isShallow, callback, thisArg) {
            // juggle arguments
            if (typeof isShallow != "boolean" && isShallow != null) {
                thisArg = callback;
                callback = typeof isShallow != "function" && thisArg && thisArg[isShallow] === array ? null : isShallow;
                isShallow = false;
            }
            if (callback != null) array = map(array, callback, thisArg);
            return baseFlatten(array, isShallow);
        }
        /**
     * Gets the index at which the first occurrence of `value` is found using
     * strict equality for comparisons, i.e. `===`. If the array is already sorted
     * providing `true` for `fromIndex` will run a faster binary search.
     *
     * @static
     * @memberOf _
     * @category Arrays
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
     *  to perform a binary search on a sorted array.
     * @returns {number} Returns the index of the matched value or `-1`.
     * @example
     *
     * _.indexOf([1, 2, 3, 1, 2, 3], 2);
     * // => 1
     *
     * _.indexOf([1, 2, 3, 1, 2, 3], 2, 3);
     * // => 4
     *
     * _.indexOf([1, 1, 2, 2, 3, 3], 2, true);
     * // => 2
     */ function indexOf(array, value, fromIndex) {
            if (typeof fromIndex == "number") {
                var length = array ? array.length : 0;
                fromIndex = fromIndex < 0 ? nativeMax(0, length + fromIndex) : fromIndex || 0;
            } else if (fromIndex) {
                var index = sortedIndex(array, value);
                return array[index] === value ? index : -1;
            }
            return baseIndexOf(array, value, fromIndex);
        }
        /**
     * Gets all but the last element or last `n` elements of an array. If a
     * callback is provided elements at the end of the array are excluded from
     * the result as long as the callback returns truey. The callback is bound
     * to `thisArg` and invoked with three arguments; (value, index, array).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @category Arrays
     * @param {Array} array The array to query.
     * @param {Function|Object|number|string} [callback=1] The function called
     *  per element or the number of elements to exclude. If a property name or
     *  object is provided it will be used to create a "_.pluck" or "_.where"
     *  style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Array} Returns a slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     *
     * _.initial([1, 2, 3], 2);
     * // => [1]
     *
     * _.initial([1, 2, 3], function(num) {
     *   return num > 1;
     * });
     * // => [1]
     *
     * var characters = [
     *   { 'name': 'barney',  'blocked': false, 'employer': 'slate' },
     *   { 'name': 'fred',    'blocked': true,  'employer': 'slate' },
     *   { 'name': 'pebbles', 'blocked': true,  'employer': 'na' }
     * ];
     *
     * // using "_.pluck" callback shorthand
     * _.initial(characters, 'blocked');
     * // => [{ 'name': 'barney',  'blocked': false, 'employer': 'slate' }]
     *
     * // using "_.where" callback shorthand
     * _.pluck(_.initial(characters, { 'employer': 'na' }), 'name');
     * // => ['barney', 'fred']
     */ function initial(array, callback, thisArg) {
            var n = 0, length = array ? array.length : 0;
            if (typeof callback != "number" && callback != null) {
                var index = length;
                callback = lodash.createCallback(callback, thisArg, 3);
                while(index-- && callback(array[index], index, array))n++;
            } else n = callback == null || thisArg ? 1 : callback || n;
            return slice(array, 0, nativeMin(nativeMax(0, length - n), length));
        }
        /**
     * Creates an array of unique values present in all provided arrays using
     * strict equality for comparisons, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @category Arrays
     * @param {...Array} [array] The arrays to inspect.
     * @returns {Array} Returns an array of shared values.
     * @example
     *
     * _.intersection([1, 2, 3], [5, 2, 1, 4], [2, 1]);
     * // => [1, 2]
     */ function intersection() {
            var args = [], argsIndex = -1, argsLength = arguments.length, caches = getArray(), indexOf = getIndexOf(), trustIndexOf = indexOf === baseIndexOf, seen = getArray();
            while(++argsIndex < argsLength){
                var value = arguments[argsIndex];
                if (isArray(value) || isArguments(value)) {
                    args.push(value);
                    caches.push(trustIndexOf && value.length >= largeArraySize && createCache(argsIndex ? args[argsIndex] : seen));
                }
            }
            var array = args[0], index = -1, length = array ? array.length : 0, result = [];
            outer: while(++index < length){
                var cache = caches[0];
                value = array[index];
                if ((cache ? cacheIndexOf(cache, value) : indexOf(seen, value)) < 0) {
                    argsIndex = argsLength;
                    (cache || seen).push(value);
                    while(--argsIndex){
                        cache = caches[argsIndex];
                        if ((cache ? cacheIndexOf(cache, value) : indexOf(args[argsIndex], value)) < 0) continue outer;
                    }
                    result.push(value);
                }
            }
            while(argsLength--){
                cache = caches[argsLength];
                if (cache) releaseObject(cache);
            }
            releaseArray(caches);
            releaseArray(seen);
            return result;
        }
        /**
     * Gets the last element or last `n` elements of an array. If a callback is
     * provided elements at the end of the array are returned as long as the
     * callback returns truey. The callback is bound to `thisArg` and invoked
     * with three arguments; (value, index, array).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @category Arrays
     * @param {Array} array The array to query.
     * @param {Function|Object|number|string} [callback] The function called
     *  per element or the number of elements to return. If a property name or
     *  object is provided it will be used to create a "_.pluck" or "_.where"
     *  style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {*} Returns the last element(s) of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     *
     * _.last([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.last([1, 2, 3], function(num) {
     *   return num > 1;
     * });
     * // => [2, 3]
     *
     * var characters = [
     *   { 'name': 'barney',  'blocked': false, 'employer': 'slate' },
     *   { 'name': 'fred',    'blocked': true,  'employer': 'slate' },
     *   { 'name': 'pebbles', 'blocked': true,  'employer': 'na' }
     * ];
     *
     * // using "_.pluck" callback shorthand
     * _.pluck(_.last(characters, 'blocked'), 'name');
     * // => ['fred', 'pebbles']
     *
     * // using "_.where" callback shorthand
     * _.last(characters, { 'employer': 'na' });
     * // => [{ 'name': 'pebbles', 'blocked': true, 'employer': 'na' }]
     */ function last(array, callback, thisArg) {
            var n = 0, length = array ? array.length : 0;
            if (typeof callback != "number" && callback != null) {
                var index = length;
                callback = lodash.createCallback(callback, thisArg, 3);
                while(index-- && callback(array[index], index, array))n++;
            } else {
                n = callback;
                if (n == null || thisArg) return array ? array[length - 1] : undefined;
            }
            return slice(array, nativeMax(0, length - n));
        }
        /**
     * Gets the index at which the last occurrence of `value` is found using strict
     * equality for comparisons, i.e. `===`. If `fromIndex` is negative, it is used
     * as the offset from the end of the collection.
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @category Arrays
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value or `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 3, 1, 2, 3], 2);
     * // => 4
     *
     * _.lastIndexOf([1, 2, 3, 1, 2, 3], 2, 3);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var index = array ? array.length : 0;
            if (typeof fromIndex == "number") index = (fromIndex < 0 ? nativeMax(0, index + fromIndex) : nativeMin(fromIndex, index - 1)) + 1;
            while(index--){
                if (array[index] === value) return index;
            }
            return -1;
        }
        /**
     * Removes all provided values from the given array using strict equality for
     * comparisons, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @category Arrays
     * @param {Array} array The array to modify.
     * @param {...*} [value] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3, 1, 2, 3];
     * _.pull(array, 2, 3);
     * console.log(array);
     * // => [1, 1]
     */ function pull(array) {
            var args = arguments, argsIndex = 0, argsLength = args.length, length = array ? array.length : 0;
            while(++argsIndex < argsLength){
                var index = -1, value = args[argsIndex];
                while(++index < length)if (array[index] === value) {
                    splice.call(array, index--, 1);
                    length--;
                }
            }
            return array;
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to but not including `end`. If `start` is less than `stop` a
     * zero-length range is created unless a negative `step` is specified.
     *
     * @static
     * @memberOf _
     * @category Arrays
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns a new range array.
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ function range(start, end, step) {
            start = +start || 0;
            step = typeof step == "number" ? step : +step || 1;
            if (end == null) {
                end = start;
                start = 0;
            }
            // use `Array(length)` so engines like Chakra and V8 avoid slower modes
            // http://youtu.be/XAqIpGU8ZZk#t=17m25s
            var index = -1, length = nativeMax(0, ceil((end - start) / (step || 1))), result = Array1(length);
            while(++index < length){
                result[index] = start;
                start += step;
            }
            return result;
        }
        /**
     * Removes all elements from an array that the callback returns truey for
     * and returns an array of removed elements. The callback is bound to `thisArg`
     * and invoked with three arguments; (value, index, array).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @category Arrays
     * @param {Array} array The array to modify.
     * @param {Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Array} Returns a new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4, 5, 6];
     * var evens = _.remove(array, function(num) { return num % 2 == 0; });
     *
     * console.log(array);
     * // => [1, 3, 5]
     *
     * console.log(evens);
     * // => [2, 4, 6]
     */ function remove(array, callback, thisArg) {
            var index = -1, length = array ? array.length : 0, result = [];
            callback = lodash.createCallback(callback, thisArg, 3);
            while(++index < length){
                var value = array[index];
                if (callback(value, index, array)) {
                    result.push(value);
                    splice.call(array, index--, 1);
                    length--;
                }
            }
            return result;
        }
        /**
     * The opposite of `_.initial` this method gets all but the first element or
     * first `n` elements of an array. If a callback function is provided elements
     * at the beginning of the array are excluded from the result as long as the
     * callback returns truey. The callback is bound to `thisArg` and invoked
     * with three arguments; (value, index, array).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @alias drop, tail
     * @category Arrays
     * @param {Array} array The array to query.
     * @param {Function|Object|number|string} [callback=1] The function called
     *  per element or the number of elements to exclude. If a property name or
     *  object is provided it will be used to create a "_.pluck" or "_.where"
     *  style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Array} Returns a slice of `array`.
     * @example
     *
     * _.rest([1, 2, 3]);
     * // => [2, 3]
     *
     * _.rest([1, 2, 3], 2);
     * // => [3]
     *
     * _.rest([1, 2, 3], function(num) {
     *   return num < 3;
     * });
     * // => [3]
     *
     * var characters = [
     *   { 'name': 'barney',  'blocked': true,  'employer': 'slate' },
     *   { 'name': 'fred',    'blocked': false,  'employer': 'slate' },
     *   { 'name': 'pebbles', 'blocked': true, 'employer': 'na' }
     * ];
     *
     * // using "_.pluck" callback shorthand
     * _.pluck(_.rest(characters, 'blocked'), 'name');
     * // => ['fred', 'pebbles']
     *
     * // using "_.where" callback shorthand
     * _.rest(characters, { 'employer': 'slate' });
     * // => [{ 'name': 'pebbles', 'blocked': true, 'employer': 'na' }]
     */ function rest(array, callback, thisArg) {
            if (typeof callback != "number" && callback != null) {
                var n = 0, index = -1, length = array ? array.length : 0;
                callback = lodash.createCallback(callback, thisArg, 3);
                while(++index < length && callback(array[index], index, array))n++;
            } else n = callback == null || thisArg ? 1 : nativeMax(0, callback);
            return slice(array, n);
        }
        /**
     * Uses a binary search to determine the smallest index at which a value
     * should be inserted into a given sorted array in order to maintain the sort
     * order of the array. If a callback is provided it will be executed for
     * `value` and each element of `array` to compute their sort ranking. The
     * callback is bound to `thisArg` and invoked with one argument; (value).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @category Arrays
     * @param {Array} array The array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([20, 30, 50], 40);
     * // => 2
     *
     * // using "_.pluck" callback shorthand
     * _.sortedIndex([{ 'x': 20 }, { 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
     * // => 2
     *
     * var dict = {
     *   'wordToNumber': { 'twenty': 20, 'thirty': 30, 'fourty': 40, 'fifty': 50 }
     * };
     *
     * _.sortedIndex(['twenty', 'thirty', 'fifty'], 'fourty', function(word) {
     *   return dict.wordToNumber[word];
     * });
     * // => 2
     *
     * _.sortedIndex(['twenty', 'thirty', 'fifty'], 'fourty', function(word) {
     *   return this.wordToNumber[word];
     * }, dict);
     * // => 2
     */ function sortedIndex(array, value, callback, thisArg) {
            var low = 0, high = array ? array.length : low;
            // explicitly reference `identity` for better inlining in Firefox
            callback = callback ? lodash.createCallback(callback, thisArg, 1) : identity;
            value = callback(value);
            while(low < high){
                var mid = low + high >>> 1;
                callback(array[mid]) < value ? low = mid + 1 : high = mid;
            }
            return low;
        }
        /**
     * Creates an array of unique values, in order, of the provided arrays using
     * strict equality for comparisons, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @category Arrays
     * @param {...Array} [array] The arrays to inspect.
     * @returns {Array} Returns an array of combined values.
     * @example
     *
     * _.union([1, 2, 3], [5, 2, 1, 4], [2, 1]);
     * // => [1, 2, 3, 5, 4]
     */ function union() {
            return baseUniq(baseFlatten(arguments, true, true));
        }
        /**
     * Creates a duplicate-value-free version of an array using strict equality
     * for comparisons, i.e. `===`. If the array is sorted, providing
     * `true` for `isSorted` will use a faster algorithm. If a callback is provided
     * each element of `array` is passed through the callback before uniqueness
     * is computed. The callback is bound to `thisArg` and invoked with three
     * arguments; (value, index, array).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @alias unique
     * @category Arrays
     * @param {Array} array The array to process.
     * @param {boolean} [isSorted=false] A flag to indicate that `array` is sorted.
     * @param {Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Array} Returns a duplicate-value-free array.
     * @example
     *
     * _.uniq([1, 2, 1, 3, 1]);
     * // => [1, 2, 3]
     *
     * _.uniq([1, 1, 2, 2, 3], true);
     * // => [1, 2, 3]
     *
     * _.uniq(['A', 'b', 'C', 'a', 'B', 'c'], function(letter) { return letter.toLowerCase(); });
     * // => ['A', 'b', 'C']
     *
     * _.uniq([1, 2.5, 3, 1.5, 2, 3.5], function(num) { return this.floor(num); }, Math);
     * // => [1, 2.5, 3]
     *
     * // using "_.pluck" callback shorthand
     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniq(array, isSorted, callback, thisArg) {
            // juggle arguments
            if (typeof isSorted != "boolean" && isSorted != null) {
                thisArg = callback;
                callback = typeof isSorted != "function" && thisArg && thisArg[isSorted] === array ? null : isSorted;
                isSorted = false;
            }
            if (callback != null) callback = lodash.createCallback(callback, thisArg, 3);
            return baseUniq(array, isSorted, callback);
        }
        /**
     * Creates an array excluding all provided values using strict equality for
     * comparisons, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @category Arrays
     * @param {Array} array The array to filter.
     * @param {...*} [value] The values to exclude.
     * @returns {Array} Returns a new array of filtered values.
     * @example
     *
     * _.without([1, 2, 1, 0, 3, 1, 4], 0, 1);
     * // => [2, 3, 4]
     */ function without(array) {
            return baseDifference(array, slice(arguments, 1));
        }
        /**
     * Creates an array that is the symmetric difference of the provided arrays.
     * See http://en.wikipedia.org/wiki/Symmetric_difference.
     *
     * @static
     * @memberOf _
     * @category Arrays
     * @param {...Array} [array] The arrays to inspect.
     * @returns {Array} Returns an array of values.
     * @example
     *
     * _.xor([1, 2, 3], [5, 2, 1, 4]);
     * // => [3, 5, 4]
     *
     * _.xor([1, 2, 5], [2, 3, 5], [3, 4, 5]);
     * // => [1, 4, 5]
     */ function xor() {
            var index = -1, length = arguments.length;
            while(++index < length){
                var array = arguments[index];
                if (isArray(array) || isArguments(array)) var result = result ? baseUniq(baseDifference(result, array).concat(baseDifference(array, result))) : array;
            }
            return result || [];
        }
        /**
     * Creates an array of grouped elements, the first of which contains the first
     * elements of the given arrays, the second of which contains the second
     * elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @alias unzip
     * @category Arrays
     * @param {...Array} [array] Arrays to process.
     * @returns {Array} Returns a new array of grouped elements.
     * @example
     *
     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     */ function zip() {
            var array = arguments.length > 1 ? arguments : arguments[0], index = -1, length = array ? max(pluck(array, "length")) : 0, result = Array1(length < 0 ? 0 : length);
            while(++index < length)result[index] = pluck(array, index);
            return result;
        }
        /**
     * Creates an object composed from arrays of `keys` and `values`. Provide
     * either a single two dimensional array, i.e. `[[key1, value1], [key2, value2]]`
     * or two arrays, one of `keys` and one of corresponding `values`.
     *
     * @static
     * @memberOf _
     * @alias object
     * @category Arrays
     * @param {Array} keys The array of keys.
     * @param {Array} [values=[]] The array of values.
     * @returns {Object} Returns an object composed of the given keys and
     *  corresponding values.
     * @example
     *
     * _.zipObject(['fred', 'barney'], [30, 40]);
     * // => { 'fred': 30, 'barney': 40 }
     */ function zipObject(keys, values) {
            var index = -1, length = keys ? keys.length : 0, result = {};
            if (!values && length && !isArray(keys[0])) values = [];
            while(++index < length){
                var key = keys[index];
                if (values) result[key] = values[index];
                else if (key) result[key[0]] = key[1];
            }
            return result;
        }
        /*--------------------------------------------------------------------------*/ /**
     * Creates a function that executes `func`, with  the `this` binding and
     * arguments of the created function, only after being called `n` times.
     *
     * @static
     * @memberOf _
     * @category Functions
     * @param {number} n The number of times the function must be called before
     *  `func` is executed.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('Done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => logs 'Done saving!', after all saves have completed
     */ function after(n, func) {
            if (!isFunction(func)) throw new TypeError;
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that, when called, invokes `func` with the `this`
     * binding of `thisArg` and prepends any additional `bind` arguments to those
     * provided to the bound function.
     *
     * @static
     * @memberOf _
     * @category Functions
     * @param {Function} func The function to bind.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {...*} [arg] Arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var func = function(greeting) {
     *   return greeting + ' ' + this.name;
     * };
     *
     * func = _.bind(func, { 'name': 'fred' }, 'hi');
     * func();
     * // => 'hi fred'
     */ function bind(func, thisArg) {
            return arguments.length > 2 ? createWrapper(func, 17, slice(arguments, 2), null, thisArg) : createWrapper(func, 1, null, null, thisArg);
        }
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method. Method names may be specified as individual arguments or as arrays
     * of method names. If no method names are provided all the function properties
     * of `object` will be bound.
     *
     * @static
     * @memberOf _
     * @category Functions
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...string} [methodName] The object method names to
     *  bind, specified as individual method names or arrays of method names.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'onClick': function() { console.log('clicked ' + this.label); }
     * };
     *
     * _.bindAll(view);
     * jQuery('#docs').on('click', view.onClick);
     * // => logs 'clicked docs', when the button is clicked
     */ function bindAll(object) {
            var funcs = arguments.length > 1 ? baseFlatten(arguments, true, false, 1) : functions(object), index = -1, length = funcs.length;
            while(++index < length){
                var key = funcs[index];
                object[key] = createWrapper(object[key], 1, null, null, object);
            }
            return object;
        }
        /**
     * Creates a function that, when called, invokes the method at `object[key]`
     * and prepends any additional `bindKey` arguments to those provided to the bound
     * function. This method differs from `_.bind` by allowing bound functions to
     * reference methods that will be redefined or don't yet exist.
     * See http://michaux.ca/articles/lazy-function-definition-pattern.
     *
     * @static
     * @memberOf _
     * @category Functions
     * @param {Object} object The object the method belongs to.
     * @param {string} key The key of the method.
     * @param {...*} [arg] Arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'name': 'fred',
     *   'greet': function(greeting) {
     *     return greeting + ' ' + this.name;
     *   }
     * };
     *
     * var func = _.bindKey(object, 'greet', 'hi');
     * func();
     * // => 'hi fred'
     *
     * object.greet = function(greeting) {
     *   return greeting + 'ya ' + this.name + '!';
     * };
     *
     * func();
     * // => 'hiya fred!'
     */ function bindKey(object, key) {
            return arguments.length > 2 ? createWrapper(key, 19, slice(arguments, 2), null, object) : createWrapper(key, 3, null, null, object);
        }
        /**
     * Creates a function that is the composition of the provided functions,
     * where each function consumes the return value of the function that follows.
     * For example, composing the functions `f()`, `g()`, and `h()` produces `f(g(h()))`.
     * Each function is executed with the `this` binding of the composed function.
     *
     * @static
     * @memberOf _
     * @category Functions
     * @param {...Function} [func] Functions to compose.
     * @returns {Function} Returns the new composed function.
     * @example
     *
     * var realNameMap = {
     *   'pebbles': 'penelope'
     * };
     *
     * var format = function(name) {
     *   name = realNameMap[name.toLowerCase()] || name;
     *   return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
     * };
     *
     * var greet = function(formatted) {
     *   return 'Hiya ' + formatted + '!';
     * };
     *
     * var welcome = _.compose(greet, format);
     * welcome('pebbles');
     * // => 'Hiya Penelope!'
     */ function compose() {
            var funcs = arguments, length = funcs.length;
            while(length--){
                if (!isFunction(funcs[length])) throw new TypeError;
            }
            return function() {
                var args = arguments, length = funcs.length;
                while(length--)args = [
                    funcs[length].apply(this, args)
                ];
                return args[0];
            };
        }
        /**
     * Creates a function which accepts one or more arguments of `func` that when
     * invoked either executes `func` returning its result, if all `func` arguments
     * have been provided, or returns a function that accepts one or more of the
     * remaining `func` arguments, and so on. The arity of `func` can be specified
     * if `func.length` is not sufficient.
     *
     * @static
     * @memberOf _
     * @category Functions
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var curried = _.curry(function(a, b, c) {
     *   console.log(a + b + c);
     * });
     *
     * curried(1)(2)(3);
     * // => 6
     *
     * curried(1, 2)(3);
     * // => 6
     *
     * curried(1, 2, 3);
     * // => 6
     */ function curry(func, arity) {
            arity = typeof arity == "number" ? arity : +arity || func.length;
            return createWrapper(func, 4, null, null, null, arity);
        }
        /**
     * Creates a function that will delay the execution of `func` until after
     * `wait` milliseconds have elapsed since the last time it was invoked.
     * Provide an options object to indicate that `func` should be invoked on
     * the leading and/or trailing edge of the `wait` timeout. Subsequent calls
     * to the debounced function will return the result of the last `func` call.
     *
     * Note: If `leading` and `trailing` options are `true` `func` will be called
     * on the trailing edge of the timeout only if the the debounced function is
     * invoked more than once during the `wait` timeout.
     *
     * @static
     * @memberOf _
     * @category Functions
     * @param {Function} func The function to debounce.
     * @param {number} wait The number of milliseconds to delay.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=false] Specify execution on the leading edge of the timeout.
     * @param {number} [options.maxWait] The maximum time `func` is allowed to be delayed before it's called.
     * @param {boolean} [options.trailing=true] Specify execution on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // avoid costly calculations while the window size is in flux
     * var lazyLayout = _.debounce(calculateLayout, 150);
     * jQuery(window).on('resize', lazyLayout);
     *
     * // execute `sendMail` when the click event is fired, debouncing subsequent calls
     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * });
     *
     * // ensure `batchLog` is executed once after 1 second of debounced calls
     * var source = new EventSource('/stream');
     * source.addEventListener('message', _.debounce(batchLog, 250, {
     *   'maxWait': 1000
     * }, false);
     */ function debounce(func, wait, options) {
            var args, maxTimeoutId, result, stamp, thisArg, timeoutId, trailingCall, lastCalled = 0, maxWait = false, trailing = true;
            if (!isFunction(func)) throw new TypeError;
            wait = nativeMax(0, wait) || 0;
            if (options === true) {
                var leading = true;
                trailing = false;
            } else if (isObject(options)) {
                leading = options.leading;
                maxWait = "maxWait" in options && (nativeMax(wait, options.maxWait) || 0);
                trailing = "trailing" in options ? options.trailing : trailing;
            }
            var delayed = function() {
                var remaining = wait - (now() - stamp);
                if (remaining <= 0) {
                    if (maxTimeoutId) clearTimeout(maxTimeoutId);
                    var isCalled = trailingCall;
                    maxTimeoutId = timeoutId = trailingCall = undefined;
                    if (isCalled) {
                        lastCalled = now();
                        result = func.apply(thisArg, args);
                        if (!timeoutId && !maxTimeoutId) args = thisArg = null;
                    }
                } else timeoutId = setTimeout(delayed, remaining);
            };
            var maxDelayed = function() {
                if (timeoutId) clearTimeout(timeoutId);
                maxTimeoutId = timeoutId = trailingCall = undefined;
                if (trailing || maxWait !== wait) {
                    lastCalled = now();
                    result = func.apply(thisArg, args);
                    if (!timeoutId && !maxTimeoutId) args = thisArg = null;
                }
            };
            return function() {
                args = arguments;
                stamp = now();
                thisArg = this;
                trailingCall = trailing && (timeoutId || !leading);
                if (maxWait === false) var leadingCall = leading && !timeoutId;
                else {
                    if (!maxTimeoutId && !leading) lastCalled = stamp;
                    var remaining = maxWait - (stamp - lastCalled), isCalled = remaining <= 0;
                    if (isCalled) {
                        if (maxTimeoutId) maxTimeoutId = clearTimeout(maxTimeoutId);
                        lastCalled = stamp;
                        result = func.apply(thisArg, args);
                    } else if (!maxTimeoutId) maxTimeoutId = setTimeout(maxDelayed, remaining);
                }
                if (isCalled && timeoutId) timeoutId = clearTimeout(timeoutId);
                else if (!timeoutId && wait !== maxWait) timeoutId = setTimeout(delayed, wait);
                if (leadingCall) {
                    isCalled = true;
                    result = func.apply(thisArg, args);
                }
                if (isCalled && !timeoutId && !maxTimeoutId) args = thisArg = null;
                return result;
            };
        }
        /**
     * Defers executing the `func` function until the current call stack has cleared.
     * Additional arguments will be provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Functions
     * @param {Function} func The function to defer.
     * @param {...*} [arg] Arguments to invoke the function with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) { console.log(text); }, 'deferred');
     * // logs 'deferred' after one or more milliseconds
     */ function defer(func) {
            if (!isFunction(func)) throw new TypeError;
            var args = slice(arguments, 1);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, 1);
        }
        /**
     * Executes the `func` function after `wait` milliseconds. Additional arguments
     * will be provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Functions
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay execution.
     * @param {...*} [arg] Arguments to invoke the function with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) { console.log(text); }, 1000, 'later');
     * // => logs 'later' after one second
     */ function delay(func, wait) {
            if (!isFunction(func)) throw new TypeError;
            var args = slice(arguments, 2);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided it will be used to determine the cache key for storing the result
     * based on the arguments provided to the memoized function. By default, the
     * first argument provided to the memoized function is used as the cache key.
     * The `func` is executed with the `this` binding of the memoized function.
     * The result cache is exposed as the `cache` property on the memoized function.
     *
     * @static
     * @memberOf _
     * @category Functions
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] A function used to resolve the cache key.
     * @returns {Function} Returns the new memoizing function.
     * @example
     *
     * var fibonacci = _.memoize(function(n) {
     *   return n < 2 ? n : fibonacci(n - 1) + fibonacci(n - 2);
     * });
     *
     * fibonacci(9)
     * // => 34
     *
     * var data = {
     *   'fred': { 'name': 'fred', 'age': 40 },
     *   'pebbles': { 'name': 'pebbles', 'age': 1 }
     * };
     *
     * // modifying the result cache
     * var get = _.memoize(function(name) { return data[name]; }, _.identity);
     * get('pebbles');
     * // => { 'name': 'pebbles', 'age': 1 }
     *
     * get.cache.pebbles.name = 'penelope';
     * get('pebbles');
     * // => { 'name': 'penelope', 'age': 1 }
     */ function memoize(func, resolver) {
            if (!isFunction(func)) throw new TypeError;
            var memoized = function() {
                var cache = memoized.cache, key = resolver ? resolver.apply(this, arguments) : keyPrefix + arguments[0];
                return hasOwnProperty.call(cache, key) ? cache[key] : cache[key] = func.apply(this, arguments);
            };
            memoized.cache = {};
            return memoized;
        }
        /**
     * Creates a function that is restricted to execute `func` once. Repeat calls to
     * the function will return the value of the first call. The `func` is executed
     * with the `this` binding of the created function.
     *
     * @static
     * @memberOf _
     * @category Functions
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // `initialize` executes `createApplication` once
     */ function once(func) {
            var ran, result;
            if (!isFunction(func)) throw new TypeError;
            return function() {
                if (ran) return result;
                ran = true;
                result = func.apply(this, arguments);
                // clear the `func` variable so the function may be garbage collected
                func = null;
                return result;
            };
        }
        /**
     * Creates a function that, when called, invokes `func` with any additional
     * `partial` arguments prepended to those provided to the new function. This
     * method is similar to `_.bind` except it does **not** alter the `this` binding.
     *
     * @static
     * @memberOf _
     * @category Functions
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [arg] Arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) { return greeting + ' ' + name; };
     * var hi = _.partial(greet, 'hi');
     * hi('fred');
     * // => 'hi fred'
     */ function partial(func) {
            return createWrapper(func, 16, slice(arguments, 1));
        }
        /**
     * This method is like `_.partial` except that `partial` arguments are
     * appended to those provided to the new function.
     *
     * @static
     * @memberOf _
     * @category Functions
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [arg] Arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var defaultsDeep = _.partialRight(_.merge, _.defaults);
     *
     * var options = {
     *   'variable': 'data',
     *   'imports': { 'jq': $ }
     * };
     *
     * defaultsDeep(options, _.templateSettings);
     *
     * options.variable
     * // => 'data'
     *
     * options.imports
     * // => { '_': _, 'jq': $ }
     */ function partialRight(func) {
            return createWrapper(func, 32, null, slice(arguments, 1));
        }
        /**
     * Creates a function that, when executed, will only call the `func` function
     * at most once per every `wait` milliseconds. Provide an options object to
     * indicate that `func` should be invoked on the leading and/or trailing edge
     * of the `wait` timeout. Subsequent calls to the throttled function will
     * return the result of the last `func` call.
     *
     * Note: If `leading` and `trailing` options are `true` `func` will be called
     * on the trailing edge of the timeout only if the the throttled function is
     * invoked more than once during the `wait` timeout.
     *
     * @static
     * @memberOf _
     * @category Functions
     * @param {Function} func The function to throttle.
     * @param {number} wait The number of milliseconds to throttle executions to.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=true] Specify execution on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true] Specify execution on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // avoid excessively updating the position while scrolling
     * var throttled = _.throttle(updatePosition, 100);
     * jQuery(window).on('scroll', throttled);
     *
     * // execute `renewToken` when the click event is fired, but not more than once every 5 minutes
     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
     *   'trailing': false
     * }));
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (!isFunction(func)) throw new TypeError;
            if (options === false) leading = false;
            else if (isObject(options)) {
                leading = "leading" in options ? options.leading : leading;
                trailing = "trailing" in options ? options.trailing : trailing;
            }
            debounceOptions.leading = leading;
            debounceOptions.maxWait = wait;
            debounceOptions.trailing = trailing;
            return debounce(func, wait, debounceOptions);
        }
        /**
     * Creates a function that provides `value` to the wrapper function as its
     * first argument. Additional arguments provided to the function are appended
     * to those provided to the wrapper function. The wrapper is executed with
     * the `this` binding of the created function.
     *
     * @static
     * @memberOf _
     * @category Functions
     * @param {*} value The value to wrap.
     * @param {Function} wrapper The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('Fred, Wilma, & Pebbles');
     * // => '<p>Fred, Wilma, &amp; Pebbles</p>'
     */ function wrap(value, wrapper) {
            return createWrapper(wrapper, 16, [
                value
            ]);
        }
        /*--------------------------------------------------------------------------*/ /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @category Utilities
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var object = { 'name': 'fred' };
     * var getter = _.constant(object);
     * getter() === object;
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Produces a callback bound to an optional `thisArg`. If `func` is a property
     * name the created callback will return the property value for a given element.
     * If `func` is an object the created callback will return `true` for elements
     * that contain the equivalent object properties, otherwise it will return `false`.
     *
     * @static
     * @memberOf _
     * @category Utilities
     * @param {*} [func=identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of the created callback.
     * @param {number} [argCount] The number of arguments the callback accepts.
     * @returns {Function} Returns a callback function.
     * @example
     *
     * var characters = [
     *   { 'name': 'barney', 'age': 36 },
     *   { 'name': 'fred',   'age': 40 }
     * ];
     *
     * // wrap to create custom callback shorthands
     * _.createCallback = _.wrap(_.createCallback, function(func, callback, thisArg) {
     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(callback);
     *   return !match ? func(callback, thisArg) : function(object) {
     *     return match[2] == 'gt' ? object[match[1]] > match[3] : object[match[1]] < match[3];
     *   };
     * });
     *
     * _.filter(characters, 'age__gt38');
     * // => [{ 'name': 'fred', 'age': 40 }]
     */ function createCallback(func, thisArg, argCount) {
            var type = typeof func;
            if (func == null || type == "function") return baseCreateCallback(func, thisArg, argCount);
            // handle "_.pluck" style callback shorthands
            if (type != "object") return property(func);
            var props = keys(func), key = props[0], a = func[key];
            // handle "_.where" style callback shorthands
            if (props.length == 1 && a === a && !isObject(a)) // fast path the common case of providing an object with a single
            // property containing a primitive value
            return function(object) {
                var b = object[key];
                return a === b && (a !== 0 || 1 / a == 1 / b);
            };
            return function(object) {
                var length = props.length, result = false;
                while(length--){
                    if (!(result = baseIsEqual(object[props[length]], func[props[length]], null, true))) break;
                }
                return result;
            };
        }
        /**
     * Converts the characters `&`, `<`, `>`, `"`, and `'` in `string` to their
     * corresponding HTML entities.
     *
     * @static
     * @memberOf _
     * @category Utilities
     * @param {string} string The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('Fred, Wilma, & Pebbles');
     * // => 'Fred, Wilma, &amp; Pebbles'
     */ function escape(string) {
            return string == null ? "" : String(string).replace(reUnescapedHtml, escapeHtmlChar);
        }
        /**
     * This method returns the first argument provided to it.
     *
     * @static
     * @memberOf _
     * @category Utilities
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'name': 'fred' };
     * _.identity(object) === object;
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Adds function properties of a source object to the destination object.
     * If `object` is a function methods will be added to its prototype as well.
     *
     * @static
     * @memberOf _
     * @category Utilities
     * @param {Function|Object} [object=lodash] object The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.chain=true] Specify whether the functions added are chainable.
     * @example
     *
     * function capitalize(string) {
     *   return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
     * }
     *
     * _.mixin({ 'capitalize': capitalize });
     * _.capitalize('fred');
     * // => 'Fred'
     *
     * _('fred').capitalize().value();
     * // => 'Fred'
     *
     * _.mixin({ 'capitalize': capitalize }, { 'chain': false });
     * _('fred').capitalize();
     * // => 'Fred'
     */ function mixin(object, source, options) {
            var chain = true, methodNames = source && functions(source);
            if (!source || !options && !methodNames.length) {
                if (options == null) options = source;
                ctor = lodashWrapper;
                source = object;
                object = lodash;
                methodNames = functions(source);
            }
            if (options === false) chain = false;
            else if (isObject(options) && "chain" in options) chain = options.chain;
            var ctor = object, isFunc = isFunction(ctor);
            forEach(methodNames, function(methodName) {
                var func = object[methodName] = source[methodName];
                if (isFunc) ctor.prototype[methodName] = function() {
                    var chainAll = this.__chain__, value = this.__wrapped__, args = [
                        value
                    ];
                    push.apply(args, arguments);
                    var result = func.apply(object, args);
                    if (chain || chainAll) {
                        if (value === result && isObject(result)) return this;
                        result = new ctor(result);
                        result.__chain__ = chainAll;
                    }
                    return result;
                };
            });
        }
        /**
     * Reverts the '_' variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @memberOf _
     * @category Utilities
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            context._ = oldDash;
            return this;
        }
        /**
     * A no-operation function.
     *
     * @static
     * @memberOf _
     * @category Utilities
     * @example
     *
     * var object = { 'name': 'fred' };
     * _.noop(object) === undefined;
     * // => true
     */ function noop() {
        // no operation performed
        }
        /**
     * Gets the number of milliseconds that have elapsed since the Unix epoch
     * (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @category Utilities
     * @example
     *
     * var stamp = _.now();
     * _.defer(function() { console.log(_.now() - stamp); });
     * // => logs the number of milliseconds it took for the deferred function to be called
     */ var now = isNative(now = Date1.now) && now || function() {
            return new Date1().getTime();
        };
        /**
     * Converts the given value into an integer of the specified radix.
     * If `radix` is `undefined` or `0` a `radix` of `10` is used unless the
     * `value` is a hexadecimal, in which case a `radix` of `16` is used.
     *
     * Note: This method avoids differences in native ES3 and ES5 `parseInt`
     * implementations. See http://es5.github.io/#E.
     *
     * @static
     * @memberOf _
     * @category Utilities
     * @param {string} value The value to parse.
     * @param {number} [radix] The radix used to interpret the value to parse.
     * @returns {number} Returns the new integer value.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     */ var parseInt = nativeParseInt(whitespace + "08") == 8 ? nativeParseInt : function(value, radix) {
            // Firefox < 21 and Opera < 15 follow the ES3 specified implementation of `parseInt`
            return nativeParseInt(isString(value) ? value.replace(reLeadingSpacesAndZeros, "") : value, radix || 0);
        };
        /**
     * Creates a "_.pluck" style function, which returns the `key` value of a
     * given object.
     *
     * @static
     * @memberOf _
     * @category Utilities
     * @param {string} key The name of the property to retrieve.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var characters = [
     *   { 'name': 'fred',   'age': 40 },
     *   { 'name': 'barney', 'age': 36 }
     * ];
     *
     * var getName = _.property('name');
     *
     * _.map(characters, getName);
     * // => ['barney', 'fred']
     *
     * _.sortBy(characters, getName);
     * // => [{ 'name': 'barney', 'age': 36 }, { 'name': 'fred',   'age': 40 }]
     */ function property(key) {
            return function(object) {
                return object[key];
            };
        }
        /**
     * Produces a random number between `min` and `max` (inclusive). If only one
     * argument is provided a number between `0` and the given number will be
     * returned. If `floating` is truey or either `min` or `max` are floats a
     * floating-point number will be returned instead of an integer.
     *
     * @static
     * @memberOf _
     * @category Utilities
     * @param {number} [min=0] The minimum possible value.
     * @param {number} [max=1] The maximum possible value.
     * @param {boolean} [floating=false] Specify returning a floating-point number.
     * @returns {number} Returns a random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(min, max, floating) {
            var noMin = min == null, noMax = max == null;
            if (floating == null) {
                if (typeof min == "boolean" && noMax) {
                    floating = min;
                    min = 1;
                } else if (!noMax && typeof max == "boolean") {
                    floating = max;
                    noMax = true;
                }
            }
            if (noMin && noMax) max = 1;
            min = +min || 0;
            if (noMax) {
                max = min;
                min = 0;
            } else max = +max || 0;
            if (floating || min % 1 || max % 1) {
                var rand = nativeRandom();
                return nativeMin(min + rand * (max - min + parseFloat("1e-" + ((rand + "").length - 1))), max);
            }
            return baseRandom(min, max);
        }
        /**
     * Resolves the value of property `key` on `object`. If `key` is a function
     * it will be invoked with the `this` binding of `object` and its result returned,
     * else the property value is returned. If `object` is falsey then `undefined`
     * is returned.
     *
     * @static
     * @memberOf _
     * @category Utilities
     * @param {Object} object The object to inspect.
     * @param {string} key The name of the property to resolve.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = {
     *   'cheese': 'crumpets',
     *   'stuff': function() {
     *     return 'nonsense';
     *   }
     * };
     *
     * _.result(object, 'cheese');
     * // => 'crumpets'
     *
     * _.result(object, 'stuff');
     * // => 'nonsense'
     */ function result(object, key) {
            if (object) {
                var value = object[key];
                return isFunction(value) ? object[key]() : value;
            }
        }
        /**
     * A micro-templating method that handles arbitrary delimiters, preserves
     * whitespace, and correctly escapes quotes within interpolated code.
     *
     * Note: In the development build, `_.template` utilizes sourceURLs for easier
     * debugging. See http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl
     *
     * For more information on precompiling templates see:
     * https://lodash.com/custom-builds
     *
     * For more information on Chrome extension sandboxes see:
     * http://developer.chrome.com/stable/extensions/sandboxingEval.html
     *
     * @static
     * @memberOf _
     * @category Utilities
     * @param {string} text The template text.
     * @param {Object} data The data object used to populate the text.
     * @param {Object} [options] The options object.
     * @param {RegExp} [options.escape] The "escape" delimiter.
     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
     * @param {Object} [options.imports] An object to import into the template as local variables.
     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
     * @param {string} [sourceURL] The sourceURL of the template's compiled source.
     * @param {string} [variable] The data object variable name.
     * @returns {Function|string} Returns a compiled function when no `data` object
     *  is given, else it returns the interpolated text.
     * @example
     *
     * // using the "interpolate" delimiter to create a compiled template
     * var compiled = _.template('hello <%= name %>');
     * compiled({ 'name': 'fred' });
     * // => 'hello fred'
     *
     * // using the "escape" delimiter to escape HTML in data property values
     * _.template('<b><%- value %></b>', { 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // using the "evaluate" delimiter to generate HTML
     * var list = '<% _.forEach(people, function(name) { %><li><%- name %></li><% }); %>';
     * _.template(list, { 'people': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // using the ES6 delimiter as an alternative to the default "interpolate" delimiter
     * _.template('hello ${ name }', { 'name': 'pebbles' });
     * // => 'hello pebbles'
     *
     * // using the internal `print` function in "evaluate" delimiters
     * _.template('<% print("hello " + name); %>!', { 'name': 'barney' });
     * // => 'hello barney!'
     *
     * // using a custom template delimiters
     * _.templateSettings = {
     *   'interpolate': /{{([\s\S]+?)}}/g
     * };
     *
     * _.template('hello {{ name }}!', { 'name': 'mustache' });
     * // => 'hello mustache!'
     *
     * // using the `imports` option to import jQuery
     * var list = '<% jq.each(people, function(name) { %><li><%- name %></li><% }); %>';
     * _.template(list, { 'people': ['fred', 'barney'] }, { 'imports': { 'jq': jQuery } });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // using the `sourceURL` option to specify a custom sourceURL for the template
     * var compiled = _.template('hello <%= name %>', null, { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
     *
     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
     * var compiled = _.template('hi <%= data.name %>!', null, { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     *   var __t, __p = '', __e = _.escape;
     *   __p += 'hi ' + ((__t = ( data.name )) == null ? '' : __t) + '!';
     *   return __p;
     * }
     *
     * // using the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and a stack trace
     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(text, data, options) {
            // based on John Resig's `tmpl` implementation
            // http://ejohn.org/blog/javascript-micro-templating/
            // and Laura Doktorova's doT.js
            // https://github.com/olado/doT
            var settings = lodash.templateSettings;
            text = String(text || "");
            // avoid missing dependencies when `iteratorTemplate` is not defined
            options = defaults({}, options, settings);
            var imports = defaults({}, options.imports, settings.imports), importsKeys = keys(imports), importsValues = values(imports);
            var isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // compile the regexp to match each delimiter
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            text.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // escape characters that cannot be included in string literals
                source += text.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // replace delimiters with snippets
                if (escapeValue) source += "' +\n__e(" + escapeValue + ") +\n'";
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // the JS engine embedded in Adobe products requires returning the `match`
                // string in order to produce the correct `offset` value
                return match;
            });
            source += "';\n";
            // if `variable` is not specified, wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain
            var variable = options.variable, hasVariable = variable;
            if (!hasVariable) {
                variable = "obj";
                source = "with (" + variable + ") {\n" + source + "\n}\n";
            }
            // cleanup code by stripping empty strings
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // frame code as the function body
            source = "function(" + variable + ") {\n" + (hasVariable ? "" : variable + " || (" + variable + " = {});\n") + "var __t, __p = '', __e = _.escape" + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            // Use a sourceURL for easier debugging.
            // http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl
            var sourceURL = "\n/*\n//# sourceURL=" + (options.sourceURL || "/lodash/template/source[" + templateCounter++ + "]") + "\n*/";
            try {
                var result = Function(importsKeys, "return " + source + sourceURL).apply(undefined, importsValues);
            } catch (e) {
                e.source = source;
                throw e;
            }
            if (data) return result(data);
            // provide the compiled function's source by its `toString` method, in
            // supported environments, or the `source` property as a convenience for
            // inlining compiled templates during the build process
            result.source = source;
            return result;
        }
        /**
     * Executes the callback `n` times, returning an array of the results
     * of each callback execution. The callback is bound to `thisArg` and invoked
     * with one argument; (index).
     *
     * @static
     * @memberOf _
     * @category Utilities
     * @param {number} n The number of times to execute the callback.
     * @param {Function} callback The function called per iteration.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Array} Returns an array of the results of each `callback` execution.
     * @example
     *
     * var diceRolls = _.times(3, _.partial(_.random, 1, 6));
     * // => [3, 6, 4]
     *
     * _.times(3, function(n) { mage.castSpell(n); });
     * // => calls `mage.castSpell(n)` three times, passing `n` of `0`, `1`, and `2` respectively
     *
     * _.times(3, function(n) { this.cast(n); }, mage);
     * // => also calls `mage.castSpell(n)` three times
     */ function times(n, callback, thisArg) {
            n = (n = +n) > -1 ? n : 0;
            var index = -1, result = Array1(n);
            callback = baseCreateCallback(callback, thisArg, 1);
            while(++index < n)result[index] = callback(index);
            return result;
        }
        /**
     * The inverse of `_.escape` this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to their
     * corresponding characters.
     *
     * @static
     * @memberOf _
     * @category Utilities
     * @param {string} string The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('Fred, Barney &amp; Pebbles');
     * // => 'Fred, Barney & Pebbles'
     */ function unescape(string) {
            return string == null ? "" : String(string).replace(reEscapedHtml, unescapeHtmlChar);
        }
        /**
     * Generates a unique ID. If `prefix` is provided the ID will be appended to it.
     *
     * @static
     * @memberOf _
     * @category Utilities
     * @param {string} [prefix] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return String(prefix == null ? "" : prefix) + id;
        }
        /*--------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object that wraps the given value with explicit
     * method chaining enabled.
     *
     * @static
     * @memberOf _
     * @category Chaining
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var characters = [
     *   { 'name': 'barney',  'age': 36 },
     *   { 'name': 'fred',    'age': 40 },
     *   { 'name': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _.chain(characters)
     *     .sortBy('age')
     *     .map(function(chr) { return chr.name + ' is ' + chr.age; })
     *     .first()
     *     .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            value = new lodashWrapper(value);
            value.__chain__ = true;
            return value;
        }
        /**
     * Invokes `interceptor` with the `value` as the first argument and then
     * returns `value`. The purpose of this method is to "tap into" a method
     * chain in order to perform operations on intermediate results within
     * the chain.
     *
     * @static
     * @memberOf _
     * @category Chaining
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3, 4])
     *  .tap(function(array) { array.pop(); })
     *  .reverse()
     *  .value();
     * // => [3, 2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * Enables explicit method chaining on the wrapper object.
     *
     * @name chain
     * @memberOf _
     * @category Chaining
     * @returns {*} Returns the wrapper object.
     * @example
     *
     * var characters = [
     *   { 'name': 'barney', 'age': 36 },
     *   { 'name': 'fred',   'age': 40 }
     * ];
     *
     * // without explicit chaining
     * _(characters).first();
     * // => { 'name': 'barney', 'age': 36 }
     *
     * // with explicit chaining
     * _(characters).chain()
     *   .first()
     *   .pick('age')
     *   .value();
     * // => { 'age': 36 }
     */ function wrapperChain() {
            this.__chain__ = true;
            return this;
        }
        /**
     * Produces the `toString` result of the wrapped value.
     *
     * @name toString
     * @memberOf _
     * @category Chaining
     * @returns {string} Returns the string result.
     * @example
     *
     * _([1, 2, 3]).toString();
     * // => '1,2,3'
     */ function wrapperToString() {
            return String(this.__wrapped__);
        }
        /**
     * Extracts the wrapped value.
     *
     * @name valueOf
     * @memberOf _
     * @alias value
     * @category Chaining
     * @returns {*} Returns the wrapped value.
     * @example
     *
     * _([1, 2, 3]).valueOf();
     * // => [1, 2, 3]
     */ function wrapperValueOf() {
            return this.__wrapped__;
        }
        /*--------------------------------------------------------------------------*/ // add functions that return wrapped values when chaining
        lodash.after = after;
        lodash.assign = assign;
        lodash.at = at;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.chain = chain;
        lodash.compact = compact;
        lodash.compose = compose;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.createCallback = createCallback;
        lodash.curry = curry;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.filter = filter;
        lodash.flatten = flatten;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.functions = functions;
        lodash.groupBy = groupBy;
        lodash.indexBy = indexBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.invert = invert;
        lodash.invoke = invoke;
        lodash.keys = keys;
        lodash.map = map;
        lodash.mapValues = mapValues;
        lodash.max = max;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.min = min;
        lodash.omit = omit;
        lodash.once = once;
        lodash.pairs = pairs;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.pick = pick;
        lodash.pluck = pluck;
        lodash.property = property;
        lodash.pull = pull;
        lodash.range = range;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.shuffle = shuffle;
        lodash.sortBy = sortBy;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.times = times;
        lodash.toArray = toArray;
        lodash.transform = transform;
        lodash.union = union;
        lodash.uniq = uniq;
        lodash.values = values;
        lodash.where = where;
        lodash.without = without;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        // add aliases
        lodash.collect = map;
        lodash.drop = rest;
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.extend = assign;
        lodash.methods = functions;
        lodash.object = zipObject;
        lodash.select = filter;
        lodash.tail = rest;
        lodash.unique = uniq;
        lodash.unzip = zip;
        // add functions to `lodash.prototype`
        mixin(lodash);
        /*--------------------------------------------------------------------------*/ // add functions that return unwrapped values when chaining
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.contains = contains;
        lodash.escape = escape;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.has = has;
        lodash.identity = identity;
        lodash.indexOf = indexOf;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isBoolean = isBoolean;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isNaN = isNaN;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isString = isString;
        lodash.isUndefined = isUndefined;
        lodash.lastIndexOf = lastIndexOf;
        lodash.mixin = mixin;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.parseInt = parseInt;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.result = result;
        lodash.runInContext = runInContext;
        lodash.size = size;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.template = template;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        // add aliases
        lodash.all = every;
        lodash.any = some;
        lodash.detect = find;
        lodash.findWhere = find;
        lodash.foldl = reduce;
        lodash.foldr = reduceRight;
        lodash.include = contains;
        lodash.inject = reduce;
        mixin(function() {
            var source = {};
            forOwn(lodash, function(func, methodName) {
                if (!lodash.prototype[methodName]) source[methodName] = func;
            });
            return source;
        }(), false);
        /*--------------------------------------------------------------------------*/ // add functions capable of returning wrapped and unwrapped values when chaining
        lodash.first = first;
        lodash.last = last;
        lodash.sample = sample;
        // add aliases
        lodash.take = first;
        lodash.head = first;
        forOwn(lodash, function(func, methodName) {
            var callbackable = methodName !== "sample";
            if (!lodash.prototype[methodName]) lodash.prototype[methodName] = function(n, guard) {
                var chainAll = this.__chain__, result = func(this.__wrapped__, n, guard);
                return !chainAll && (n == null || guard && !(callbackable && typeof n == "function")) ? result : new lodashWrapper(result, chainAll);
            };
        });
        /*--------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type string
     */ lodash.VERSION = "2.4.2";
        // add "Chaining" functions to the wrapper
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.toString = wrapperToString;
        lodash.prototype.value = wrapperValueOf;
        lodash.prototype.valueOf = wrapperValueOf;
        // add `Array` functions that return unwrapped values
        forEach([
            "join",
            "pop",
            "shift"
        ], function(methodName) {
            var func = arrayRef[methodName];
            lodash.prototype[methodName] = function() {
                var chainAll = this.__chain__, result = func.apply(this.__wrapped__, arguments);
                return chainAll ? new lodashWrapper(result, chainAll) : result;
            };
        });
        // add `Array` functions that return the existing wrapped value
        forEach([
            "push",
            "reverse",
            "sort",
            "unshift"
        ], function(methodName) {
            var func = arrayRef[methodName];
            lodash.prototype[methodName] = function() {
                func.apply(this.__wrapped__, arguments);
                return this;
            };
        });
        // add `Array` functions that return new wrapped values
        forEach([
            "concat",
            "slice",
            "splice"
        ], function(methodName) {
            var func = arrayRef[methodName];
            lodash.prototype[methodName] = function() {
                return new lodashWrapper(func.apply(this.__wrapped__, arguments), this.__chain__);
            };
        });
        return lodash;
    }
    /*--------------------------------------------------------------------------*/ // expose Lo-Dash
    var _ = runInContext();
    // some AMD build optimizers like r.js check for condition patterns like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lo-Dash to the global object even when an AMD loader is present in
        // case Lo-Dash is loaded with a RequireJS shim config.
        // See http://requirejs.org/docs/api.html#config-shim
        root._ = _;
        // define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module
        define(function() {
            return _;
        });
    } else if (freeExports && freeModule) {
        // in Node.js or RingoJS
        if (moduleExports) (freeModule.exports = _)._ = _;
        else freeExports._ = _;
    } else // in a browser or Rhino
    root._ = _;
}).call(this);

});

parcelRegister("Pmomn", function(module, exports) {
"use strict";

var $h5Sxd = parcelRequire("h5Sxd");

var $bYjHu = parcelRequire("bYjHu");

var $cWhVw = parcelRequire("cWhVw");
function $09a62219b7a6cac8$var$TypeSafeMatcher() {
    return $h5Sxd.create(new $bYjHu(), {
        matches: function(actual) {
            if (!this.isExpectedType(actual)) return false;
            return this.matchesSafely(actual);
        },
        describeMismatch: function(actual, description) {
            if (!this.isExpectedType(actual)) {
                if (!actual) {
                    description.append("was ").appendValue(actual);
                    return;
                }
                description.append("was a ").append($cWhVw(actual)).append(" (").appendValue(actual).append(")");
            } else return this.describeMismatchSafely(actual, description);
        },
        isExpectedType: function() {
            throw new Error("Not implemented");
        },
        matchesSafely: function() {
            return true;
        },
        describeMismatchSafely: function() {
            throw new Error("Not implemented");
        }
    });
}
module.exports = $09a62219b7a6cac8$var$TypeSafeMatcher;

});
parcelRegister("bYjHu", function(module, exports) {
"use strict";

var $h5Sxd = parcelRequire("h5Sxd");
function $8b74946243092744$var$Matcher() {
    return $h5Sxd.create({}, {
        matches: function() {
            throw new Error("Not implemented");
        },
        describeTo: function() {
            throw new Error("Not implemented");
        },
        describeMismatch: function(value, description) {
            description.append("was ").appendValue(value);
        }
    });
}
$8b74946243092744$var$Matcher.isMatcher = function(matcherOrValue) {
    return !$h5Sxd.isUndefined(matcherOrValue) && !$h5Sxd.isNull(matcherOrValue) && $h5Sxd.isFunction(matcherOrValue.matches) && $h5Sxd.isFunction(matcherOrValue.describeTo) && $h5Sxd.isFunction(matcherOrValue.describeMismatch);
};
module.exports = $8b74946243092744$var$Matcher;

});

parcelRegister("cWhVw", function(module, exports) {
"use strict";

var $5DbzW = parcelRequire("5DbzW");
module.exports = function(value) {
    if (!value.constructor) return "<no type>";
    return $5DbzW(value.constructor);
};

});
parcelRegister("5DbzW", function(module, exports) {
"use strict";
module.exports = function getName(type) {
    if (!type.name) return "ANONYMOUS FUNCTION";
    return type.name;
};

});





parcelRegister("59oWa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c012301ab13f3c4$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $goLmS = parcelRequire("goLmS");

var $gJT7h = parcelRequire("gJT7h");

var $avf6p = parcelRequire("avf6p");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $gSTGk = parcelRequire("gSTGk");

var $ewAM3 = parcelRequire("ewAM3");
const $3c012301ab13f3c4$var$rateColumns = [
    {
        id: "date",
        label: "Starting From",
        width: 20,
        type: "date",
        editable: (r)=>(0, $8kZ1o.canEditProjectRates)((0, $1BTI2.default).user, r.project),
        value: (r)=>r.date,
        onChange: (r)=>(v)=>r.update({
                    date: v
                })
    },
    {
        label: "Staff / Role",
        width: 20,
        type: "staffOrRole",
        editable: (r)=>(0, $8kZ1o.canEditProjectRates)((0, $1BTI2.default).user, r.project),
        value: (p)=>p.resource,
        onChange: (r)=>(v)=>r.update({
                    itemId: v.id,
                    itemType: v instanceof (0, $gSTGk.default) ? "staff" : "role"
                })
    },
    {
        label: "Phase",
        width: 20,
        type: "phase",
        editable: (r)=>(0, $8kZ1o.canEditProjectRates)((0, $1BTI2.default).user, r.project),
        value: (p)=>p.phase,
        onChange: (r)=>(v)=>{
                r.update({
                    phaseId: v.id
                });
            },
        component: ({ value: value, onChange: onChange, stores: stores, editable: editable })=>{
            const project = stores.row.rowObject.project;
            return editable ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.PhaseSelector), {
                options: project.phases,
                selectedPhase: value,
                onChange: onChange,
                variant: "secondary",
                className: "!border-none"
            }) : (value === null || value === void 0 ? void 0 : value.title) || "No Phase";
        }
    },
    {
        label: "Cost Rate",
        width: 20,
        type: "currency",
        permissions: (r)=>(0, $8kZ1o.canViewStaffCostRate)((0, $1BTI2.default).user),
        editable: (r)=>(0, $8kZ1o.canEditProjectRates)((0, $1BTI2.default).user, r.project) && (0, $8kZ1o.canViewStaffCostRate)((0, $1BTI2.default).user),
        value: (p)=>p.costRate,
        onChange: (r)=>(v)=>r.update({
                    costRate: v
                })
    },
    {
        label: "Charge Out Rate",
        width: 20,
        type: "currency",
        permissions: (r)=>(0, $8kZ1o.canViewStaffChargeOutRate)((0, $1BTI2.default).user),
        editable: (r)=>(0, $8kZ1o.canEditProjectRates)((0, $1BTI2.default).user, r.project) && (0, $8kZ1o.canViewStaffChargeOutRate)((0, $1BTI2.default).user),
        value: (p)=>p.chargeOutRate,
        onChange: (r)=>(v)=>r.update({
                    chargeOutRate: v
                })
    },
    {
        label: "",
        width: 4,
        type: "button",
        permissions: (r)=>(0, $8kZ1o.canEditProjectRates)((0, $1BTI2.default).user, r.project),
        editable: (r)=>(0, $8kZ1o.canEditProjectRates)((0, $1BTI2.default).user, r.project),
        value: (p)=>/*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                className: "fa fa-times",
                style: {
                    marginRight: 0
                }
            }),
        onClick: (r)=>()=>{
                r.update({
                    deletedAt: new Date()
                });
            }
    },
    {
        id: "createdAt",
        label: "Created At",
        width: 18,
        type: "date",
        editable: (r)=>false,
        value: (e)=>e.initiatedAt,
        visible: false
    },
    {
        id: "idString",
        label: "id",
        width: 18,
        type: "string",
        editable: (r)=>false,
        value: (e)=>{
            console.log(e.date.getTime() + e.phaseId + e.resource.id + e.createdAt.getTime() + e.initiatedAt.getTime());
            return e.id;
        },
        visible: false
    }
];
var $3c012301ab13f3c4$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ id: id })=>{
    const project = (0, $gJT7h.default).projectsById[id];
    (0, $jbmdS.useEffect)(()=>{
        ((project === null || project === void 0 ? void 0 : project.rates) || []).forEach((cli, i)=>cli.position = i);
    }, [
        project
    ]);
    if (!project) return null;
    const [rows, setRows] = (0, $jbmdS.useState)(project.rates.sort((a, b)=>{
        // First, compare by date
        const dateA = new Date(a.date), dateB = new Date(b.date);
        if (dateA < dateB) return -1;
        if (dateA > dateB) return 1;
        // If dates are equal, then compare by phaseId
        if (a.phaseId < b.phaseId) return -1;
        if (a.phaseId > b.phaseId) return 1;
        // If phaseIds are equal, then compare by itemId
        if (a.itemId < b.itemId) return -1;
        if (a.itemId > b.itemId) return 1;
        // If itemIds are equal, then compare by initiatedAt
        const initiatedAtA = new Date(a.initiatedAt), initiatedAtB = new Date(b.initiatedAt);
        if (initiatedAtA < initiatedAtB) return -1;
        if (initiatedAtA > initiatedAtB) return 1;
        // If all are equal, return 0 (no sorting)
        return 0;
    }));
    (0, $jbmdS.useEffect)(()=>{
        setRows(project.rates.sort((a, b)=>{
            // First, compare by date
            const dateA = new Date(a.date), dateB = new Date(b.date);
            if (dateA < dateB) return -1;
            if (dateA > dateB) return 1;
            // If dates are equal, then compare by phaseId
            if (a.phaseId < b.phaseId) return -1;
            if (a.phaseId > b.phaseId) return 1;
            // If phaseIds are equal, then compare by itemId
            if (a.itemId < b.itemId) return -1;
            if (a.itemId > b.itemId) return 1;
            // If itemIds are equal, then compare by initiatedAt
            const initiatedAtA = new Date(a.initiatedAt), initiatedAtB = new Date(b.initiatedAt);
            if (initiatedAtA < initiatedAtB) return -1;
            if (initiatedAtA > initiatedAtB) return 1;
            // If all are equal, return 0 (no sorting)
            return 0;
        }));
    }, [
        project.id
    ]);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
                columns: $3c012301ab13f3c4$var$rateColumns,
                rows: rows.filter((r)=>!r.deletedAt)
            }),
            (0, $8kZ1o.canEditProjectRates)((0, $1BTI2.default).user, project) ? /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                className: "btn btn-default plus-btn border-[#ccc]",
                style: {
                    marginTop: "2em"
                },
                onClick: ()=>{
                    const pr = (0, $avf6p.default).add({
                        projectId: project.id,
                        phaseId: project.rootPhase.id,
                        date: project.startDate || new Date()
                    }, {
                        trackUpdates: true
                    });
                    pr.position = project.rates.length;
                    setRows([
                        ...rows,
                        pr
                    ]);
                },
                children: "+ Add Rate"
            }) : null
        ]
    });
});

});

parcelRegister("iy0WE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d80c22a1e7bf4190$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $goLmS = parcelRequire("goLmS");

var $gJT7h = parcelRequire("gJT7h");

var $jc1Yz = parcelRequire("jc1Yz");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $ewAM3 = parcelRequire("ewAM3");
const $d80c22a1e7bf4190$var$noteColumns = [
    {
        id: "date",
        label: "Date",
        width: 20,
        type: "date",
        editable: (r)=>(0, $8kZ1o.canEditProjectNotes)((0, $1BTI2.default).user, r.project),
        value: (r)=>r.date,
        onChange: (r)=>(v)=>r.update({
                    date: v
                })
    },
    {
        label: "Phase",
        width: 20,
        type: "phase",
        editable: (r)=>(0, $8kZ1o.canEditProjectNotes)((0, $1BTI2.default).user, r.project),
        value: (p)=>p.phase,
        onChange: (r)=>(v)=>r.update({
                    phaseId: v.id
                }),
        component: ({ value: value, onChange: onChange, stores: stores, editable: editable })=>{
            const project = stores.row.rowObject.project;
            return editable ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.PhaseSelector), {
                options: project.phases,
                selectedPhase: value,
                onChange: onChange,
                variant: "secondary",
                className: "!border-none h-full !rounded-none"
            }) : (value === null || value === void 0 ? void 0 : value.title) || "No Phase";
        }
    },
    {
        label: "Note",
        width: 60,
        type: "textarea",
        editable: (r)=>(0, $8kZ1o.canEditProjectNotes)((0, $1BTI2.default).user, r.project),
        value: (p)=>p.description,
        onChange: (r)=>(v)=>r.update({
                    description: v
                })
    },
    {
        label: "",
        width: 4,
        type: "button",
        permissions: (r)=>(0, $8kZ1o.canEditProjectNotes)((0, $1BTI2.default).user, r.project),
        editable: (r)=>(0, $8kZ1o.canEditProjectNotes)((0, $1BTI2.default).user, r.project),
        value: (p)=>/*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                className: "fa fa-times",
                style: {
                    marginRight: 0
                }
            }),
        onClick: (r)=>()=>{
                r.update({
                    deletedAt: new Date()
                });
            }
    }
];
var $d80c22a1e7bf4190$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ id: id })=>{
    const project = (0, $gJT7h.default).projectsById[id];
    (0, $jbmdS.useEffect)(()=>{
        ((project === null || project === void 0 ? void 0 : project.notes) || []).forEach((cli, i)=>cli.position = i);
    }, [
        project
    ]);
    if (!project) return null;
    const [rows, setRows] = (0, $jbmdS.useState)(project.notes.sort((a, b)=>{
        var _b$date, _a$date;
        return (b === null || b === void 0 ? void 0 : (_b$date = b.date) === null || _b$date === void 0 ? void 0 : _b$date.getTime()) - (a === null || a === void 0 ? void 0 : (_a$date = a.date) === null || _a$date === void 0 ? void 0 : _a$date.getTime());
    }));
    (0, $jbmdS.useEffect)(()=>{
        setRows(project.notes.sort((a, b)=>{
            var _b$date2, _a$date2;
            return (b === null || b === void 0 ? void 0 : (_b$date2 = b.date) === null || _b$date2 === void 0 ? void 0 : _b$date2.getTime()) - (a === null || a === void 0 ? void 0 : (_a$date2 = a.date) === null || _a$date2 === void 0 ? void 0 : _a$date2.getTime());
        }));
    }, [
        project.id
    ]);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        children: [
            (0, $8kZ1o.canEditProjectNotes)((0, $1BTI2.default).user, project) ? /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                className: "btn btn-default plus-btn border-[#ccc]",
                style: {
                    marginBottom: "2em"
                },
                onClick: ()=>{
                    const pn = (0, $jc1Yz.default).add({
                        projectId: project.id,
                        phaseId: project.rootPhase.id,
                        date: new Date()
                    }, {
                        trackUpdates: true
                    });
                    pn.position = project.notes.length;
                    setRows([
                        pn,
                        ...rows
                    ]);
                },
                children: "+ Add Note"
            }) : null,
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
                columns: $d80c22a1e7bf4190$var$noteColumns,
                rows: rows.filter((r)=>!r.deletedAt)
            })
        ]
    });
});

});

parcelRegister("2MQ1P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20786c37388c3fa1$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $ewAM3 = parcelRequire("ewAM3");

var $goLmS = parcelRequire("goLmS");

var $gJT7h = parcelRequire("gJT7h");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $3cqhz = parcelRequire("3cqhz");

var $eat5C = parcelRequire("eat5C");
const $20786c37388c3fa1$var$statusColumns = [
    {
        label: "Phase",
        width: 40,
        type: "phase",
        value: (r)=>r
    },
    {
        label: "Status",
        width: 40,
        type: "status",
        editable: (r)=>(0, $8kZ1o.canEditProject)((0, $1BTI2.default).user, r.project),
        value: (p)=>p.status,
        onChange: (r)=>(v)=>r.update({
                    status: v
                })
    },
    {
        label: "% Likelihood",
        id: "%likelihood",
        width: 20,
        type: "number",
        editable: (r)=>{
            return (0, $8kZ1o.canEditProject)((0, $1BTI2.default).user, r.project) && [
                "prospective",
                "onHold"
            ].includes(r.status);
        },
        value: (r)=>[
                "prospective",
                "onHold"
            ].includes(r.status) ? r.percentLikelihood : 100,
        onChange: (r)=>(v)=>r.update({
                    percentLikelihood: v
                })
    }
];
var $20786c37388c3fa1$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ id: id })=>{
    const project = (0, $gJT7h.default).projectsById[id];
    (0, $jbmdS.useEffect)(()=>{
        ((project === null || project === void 0 ? void 0 : project.phases) || []).forEach((cli, i)=>cli.position = i);
    }, [
        project
    ]);
    if (!project) return null;
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        children: [
            (0, $8kZ1o.canEditProject)((0, $1BTI2.default).user, project) && /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    padding: "1em",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "end"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            marginRight: "1em"
                        },
                        children: [
                            "Set All Statuses to:",
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.StatusSelector), {
                        selectedStatus: (0, $3cqhz.statusByPriority)[(0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).min(project.phases.filter((ph)=>!ph.deletedAt).map((ph)=>(0, $3cqhz.statusPriorities)[ph.status]))],
                        onChange: (v)=>{
                            project.updatePhaseValues({
                                status: v
                            });
                        },
                        variant: "secondary",
                        className: "max-w-max"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
                columns: $20786c37388c3fa1$var$statusColumns.filter((c)=>(0, $8kZ1o.canEditProject)((0, $1BTI2.default).user, project) || c.id !== "%likelihood"),
                rows: project.phases.filter((ph)=>!(ph !== null && ph !== void 0 && ph.isRootPhase)),
                sortBy: [
                    [
                        (ph)=>ph.startDate,
                        "asc"
                    ]
                ]
            })
        ]
    });
});

});

parcelRegister("d1fU6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97a7b486fcb2e584$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("eat5C");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $gJT7h = parcelRequire("gJT7h");

var $liJtZ = parcelRequire("liJtZ");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $goLmS = parcelRequire("goLmS");

var $ewAM3 = parcelRequire("ewAM3");
const $97a7b486fcb2e584$var$milestoneColumns = [
    {
        id: "date",
        label: "Date",
        width: 20,
        type: "date",
        editable: (r)=>(0, $8kZ1o.canEditProjectMilestones)((0, $1BTI2.default).user, r.project),
        value: (r)=>r.date,
        onChange: (r)=>(v)=>r.update({
                    date: v
                }),
        style: ()=>({
                textAlign: "left"
            })
    },
    {
        label: "Phase",
        width: 20,
        type: "phase",
        editable: (r)=>(0, $8kZ1o.canEditProjectMilestones)((0, $1BTI2.default).user, r.project),
        value: (p)=>p.phase,
        onChange: (r)=>(v)=>r.update({
                    phaseId: v.id
                }),
        component: ({ value: value, onChange: onChange, stores: stores, editable: editable })=>{
            const project = stores.row.rowObject.project;
            return editable ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.PhaseSelector), {
                options: project.phases,
                selectedPhase: value,
                onChange: onChange,
                variant: "secondary",
                className: "!border-none h-full !rounded-none"
            }) : (value === null || value === void 0 ? void 0 : value.title) || "No Phase";
        }
    },
    {
        label: "Milestone",
        width: 60,
        type: "text",
        editable: (r)=>(0, $8kZ1o.canEditProjectMilestones)((0, $1BTI2.default).user, r.project),
        value: (p)=>p.label,
        onChange: (r)=>(v)=>r.update({
                    label: v
                })
    },
    {
        label: "",
        width: 4,
        type: "button",
        permissions: (r)=>(0, $8kZ1o.canEditProjectMilestones)((0, $1BTI2.default).user, r.project),
        editable: (r)=>(0, $8kZ1o.canEditProjectMilestones)((0, $1BTI2.default).user, r.project),
        value: (p)=>/*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                className: "fa fa-times",
                style: {
                    marginRight: 0
                }
            }),
        onClick: (r)=>()=>{
                r.update({
                    deletedAt: new Date()
                });
            }
    }
];
var $97a7b486fcb2e584$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ id: id })=>{
    const project = (0, $gJT7h.default).projectsById[id];
    (0, $jbmdS.useEffect)(()=>{
        ((project === null || project === void 0 ? void 0 : project.milestones) || []).forEach((cli, i)=>cli.position = i);
    }, [
        project
    ]);
    if (!project) return null;
    const [rows, setRows] = (0, $jbmdS.useState)(((project === null || project === void 0 ? void 0 : project.milestones) || []).sort((a, b)=>{
        var _b$date, _a$date;
        return (b === null || b === void 0 ? void 0 : (_b$date = b.date) === null || _b$date === void 0 ? void 0 : _b$date.getTime()) - (a === null || a === void 0 ? void 0 : (_a$date = a.date) === null || _a$date === void 0 ? void 0 : _a$date.getTime());
    }));
    (0, $jbmdS.useEffect)(()=>{
        setRows(((project === null || project === void 0 ? void 0 : project.milestones) || []).sort((a, b)=>{
            var _b$date2, _a$date2;
            return (b === null || b === void 0 ? void 0 : (_b$date2 = b.date) === null || _b$date2 === void 0 ? void 0 : _b$date2.getTime()) - (a === null || a === void 0 ? void 0 : (_a$date2 = a.date) === null || _a$date2 === void 0 ? void 0 : _a$date2.getTime());
        }));
    }, [
        project.id
    ]);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        children: [
            (0, $8kZ1o.canEditProjectMilestones)((0, $1BTI2.default).user, project) ? /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                className: "btn btn-default plus-btn border-[#ccc]",
                style: {
                    marginBottom: "2em"
                },
                onClick: ()=>{
                    const m = (0, $liJtZ.default).add({
                        projectId: project.id,
                        phaseId: project.rootPhase.id,
                        date: new Date()
                    }, {
                        trackUpdates: true
                    });
                    m.position = project.milestones.length;
                    setRows([
                        m,
                        ...rows
                    ]);
                },
                children: "+ Add Milestone"
            }) : null,
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
                columns: $97a7b486fcb2e584$var$milestoneColumns,
                rows: rows.filter((r)=>!r.deletedAt)
            })
        ]
    });
});

});

parcelRegister("bGmym", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88151c8c9934f9b4$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $goLmS = parcelRequire("goLmS");

var $gJT7h = parcelRequire("gJT7h");
parcelRequire("eat5C");
const $88151c8c9934f9b4$var$historyColumns = [
    {
        id: "date",
        label: "Date",
        width: 15,
        type: "date",
        style: (r)=>({
                textAlign: "left",
                justifyContent: "flex-start"
            }),
        value: (r)=>r.date
    },
    {
        id: "item",
        label: "Item",
        width: 15,
        type: "text",
        value: (r)=>{
            var _r$model;
            return (_r$model = r.model) === null || _r$model === void 0 ? void 0 : _r$model.title;
        }
    },
    {
        label: "Event",
        width: 70,
        type: "custom",
        value: (r)=>r,
        component: ({ value: value })=>{
            var _value$user;
            return /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("b", {
                        children: `${value === null || value === void 0 ? void 0 : (_value$user = value.user) === null || _value$user === void 0 ? void 0 : _value$user.fullName}`
                    }),
                    ` changed `,
                    /*#__PURE__*/ (0, $61Ea1.jsx)("b", {
                        children: `${value === null || value === void 0 ? void 0 : value.fieldLabel}`
                    }),
                    ` to `,
                    /*#__PURE__*/ (0, $61Ea1.jsx)("b", {
                        children: `${value === null || value === void 0 ? void 0 : value.value}`
                    })
                ]
            });
        }
    }
];
var $88151c8c9934f9b4$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ id: id })=>{
    const project = (0, $gJT7h.default).projectsById[id];
    if (!project) return null;
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
            columns: $88151c8c9934f9b4$var$historyColumns,
            rows: [
                ...project.history,
                ...project.phases.map((p)=>p.history).flat()
            ],
            sortBy: [
                [
                    "date",
                    "desc"
                ]
            ]
        })
    });
});

});

parcelRegister("8xdcC", function(module, exports) {

var $hxM7m = parcelRequire("hxM7m");

var $lJ1OS = parcelRequire("lJ1OS");

var $277OF = parcelRequire("277OF");
const $4617d077c77c0a60$export$1b5d8f0c33515521 = {
    isPendingChanges: false,
    budgetedHours: [],
    changeLogItems: [],
    invoiceLineItems: [],
    invoices: [],
    monthlyAllocations: [],
    phases: [],
    projectExpenses: [],
    projectNotes: [],
    projectRates: [],
    revenueTargets: [],
    tasks: [],
    weeklyAllocations: []
};
const $4617d077c77c0a60$export$89a160fdc832c2b6 = {
    date: new Date(),
    payRate: 0,
    overtimeRate: 0,
    costRate: 0,
    chargeOutRate: 0,
    isStaffRate: true
};
const $4617d077c77c0a60$export$392846c900a3bda1 = (0, $hxM7m.createStore)({
    context: $4617d077c77c0a60$export$1b5d8f0c33515521,
    on: {
        setData: {
            budgetedHours: (_, event)=>event.data.budgetedHours,
            changeLogItems: (_, event)=>event.data.changeLogItems,
            invoiceLineItems: (_, event)=>event.data.invoiceLineItems,
            invoices: (_, event)=>event.data.invoices,
            monthlyAllocations: (_, event)=>event.data.monthlyAllocations,
            phases: (_, event)=>event.data.phases,
            projectExpenses: (_, event)=>event.data.projectExpenses,
            projectNotes: (_, event)=>event.data.projectNotes,
            projectRates: (_, event)=>event.data.projectRates,
            revenueTargets: (_, event)=>event.data.revenueTargets,
            tasks: (_, event)=>event.data.tasks,
            weeklyAllocations: (_, event)=>event.data.weeklyAllocations
        },
        updatePendingChanges: {
            isPendingChanges: (_, event)=>event.isPendingChanges
        },
        reset: {
            ...$4617d077c77c0a60$export$1b5d8f0c33515521
        }
    }
});
const $4617d077c77c0a60$export$b8030685c123f4d8 = (0, $277OF.createQueryStore)({
    context: $4617d077c77c0a60$export$1b5d8f0c33515521,
    on: {
        setData: {
            budgetedHours: (_, event)=>event.data.budgetedHours,
            changeLogItems: (_, event)=>event.data.changeLogItems,
            invoiceLineItems: (_, event)=>event.data.invoiceLineItems,
            invoices: (_, event)=>event.data.invoices,
            monthlyAllocations: (_, event)=>event.data.monthlyAllocations,
            phases: (_, event)=>event.data.phases,
            projectExpenses: (_, event)=>event.data.projectExpenses,
            projectNotes: (_, event)=>event.data.projectNotes,
            projectRates: (_, event)=>event.data.projectRates,
            revenueTargets: (_, event)=>event.data.revenueTargets,
            tasks: (_, event)=>event.data.tasks,
            weeklyAllocations: (_, event)=>event.data.weeklyAllocations
        },
        updatePendingChanges: {
            isPendingChanges: (_, event)=>event.isPendingChanges
        },
        reset: {
            ...$4617d077c77c0a60$export$1b5d8f0c33515521
        }
    }
}, {
    queryKey: [
        "project-detail"
    ],
    queryFn: async ({ id: id })=>{
    //
    },
    mutationFn: async (data)=>{
        const result = true;
        return result;
    },
    staleTime: 300000,
    // 5 minutes
    cacheTime: 1800000 // 30 minutes
}, {
    saveId: "project-detail",
    requireConfirmation: true,
    confirmationMessage: "Save changes to project detail?",
    loadingMessage: "Saving project detail...",
    successMessage: "Project detail saved successfully",
    errorMessage: "Failed to save project detail"
});
// Action creators
const $4617d077c77c0a60$var$setData = (data)=>$4617d077c77c0a60$export$392846c900a3bda1.send({
        type: "setData",
        data: data
    });
const $4617d077c77c0a60$var$updatePendingChanges = (isPendingChanges)=>$4617d077c77c0a60$export$392846c900a3bda1.send({
        type: "updatePendingChanges",
        isPendingChanges: isPendingChanges
    });
const $4617d077c77c0a60$var$reset = ()=>$4617d077c77c0a60$export$392846c900a3bda1.send({
        type: "reset"
    });
const $4617d077c77c0a60$export$324085ed3ce451a1 = {
    setData: $4617d077c77c0a60$var$setData,
    updatePendingChanges: $4617d077c77c0a60$var$updatePendingChanges,
    reset: $4617d077c77c0a60$var$reset
};
const $4617d077c77c0a60$export$f0a19a1bb5f2d5ef = ()=>{
    return (0, $lJ1OS.useSelector)($4617d077c77c0a60$export$392846c900a3bda1, (state)=>state.context);
};
const $4617d077c77c0a60$export$b6ac1b051449e4ff = ()=>{
    return (0, $lJ1OS.useSelector)($4617d077c77c0a60$export$392846c900a3bda1, (state)=>state.context.budgetedHours);
};
const $4617d077c77c0a60$export$4935f5435381802 = ()=>{
    return (0, $lJ1OS.useSelector)($4617d077c77c0a60$export$392846c900a3bda1, (state)=>state.context.changeLogItems);
};
const $4617d077c77c0a60$export$708ed24be55e5919 = ()=>{
    return (0, $lJ1OS.useSelector)($4617d077c77c0a60$export$392846c900a3bda1, (state)=>state.context.invoiceLineItems);
};
const $4617d077c77c0a60$export$bf5603be66386967 = ()=>{
    return (0, $lJ1OS.useSelector)($4617d077c77c0a60$export$392846c900a3bda1, (state)=>state.context.invoices);
};
const $4617d077c77c0a60$export$b7437b58983dcd0 = ()=>{
    return (0, $lJ1OS.useSelector)($4617d077c77c0a60$export$392846c900a3bda1, (state)=>state.context.monthlyAllocations);
};
const $4617d077c77c0a60$export$87787dbb89361c2a = ()=>{
    return (0, $lJ1OS.useSelector)($4617d077c77c0a60$export$392846c900a3bda1, (state)=>state.context.phases);
};
const $4617d077c77c0a60$export$c4c45f329c179d2a = ()=>{
    return (0, $lJ1OS.useSelector)($4617d077c77c0a60$export$392846c900a3bda1, (state)=>state.context.projectExpenses);
};
const $4617d077c77c0a60$export$d72597ae99b47685 = ()=>{
    return (0, $lJ1OS.useSelector)($4617d077c77c0a60$export$392846c900a3bda1, (state)=>state.context.projectNotes);
};
const $4617d077c77c0a60$export$1bfc886460df2089 = ()=>{
    return (0, $lJ1OS.useSelector)($4617d077c77c0a60$export$392846c900a3bda1, (state)=>state.context.projectRates);
};
const $4617d077c77c0a60$export$abfef812241af8da = ()=>{
    return (0, $lJ1OS.useSelector)($4617d077c77c0a60$export$392846c900a3bda1, (state)=>state.context.revenueTargets);
};
const $4617d077c77c0a60$export$ed5c3368304694 = ()=>{
    return (0, $lJ1OS.useSelector)($4617d077c77c0a60$export$392846c900a3bda1, (state)=>state.context.tasks);
};
const $4617d077c77c0a60$export$b3d8edc324623b26 = ()=>{
    return (0, $lJ1OS.useSelector)($4617d077c77c0a60$export$392846c900a3bda1, (state)=>state.context.weeklyAllocations);
};
const $4617d077c77c0a60$export$b69a3814d0f14d43 = ()=>{
    return (0, $lJ1OS.useSelector)($4617d077c77c0a60$export$392846c900a3bda1, (state)=>state.context.isPendingChanges);
};
const $4617d077c77c0a60$export$2fd1dff58962f618 = ()=>$4617d077c77c0a60$export$392846c900a3bda1.getSnapshot().context;
const $4617d077c77c0a60$export$c0e4867bec971477 = ()=>$4617d077c77c0a60$export$392846c900a3bda1.getSnapshot().context.project;
const $4617d077c77c0a60$export$c68d1c0d93c8fbaa = ()=>$4617d077c77c0a60$export$392846c900a3bda1.getSnapshot().context.budgetedHours;
const $4617d077c77c0a60$export$b340f0c2e761ff1d = ()=>$4617d077c77c0a60$export$392846c900a3bda1.getSnapshot().context.changeLogItems;
const $4617d077c77c0a60$export$e6ba9ed30689a191 = ()=>$4617d077c77c0a60$export$392846c900a3bda1.getSnapshot().context.invoiceLineItems;
const $4617d077c77c0a60$export$90bed76609137fcf = ()=>$4617d077c77c0a60$export$392846c900a3bda1.getSnapshot().context.invoices;
const $4617d077c77c0a60$export$d482b6ee9bd123e = ()=>$4617d077c77c0a60$export$392846c900a3bda1.getSnapshot().context.monthlyAllocations;
const $4617d077c77c0a60$export$decf60f46c2b52d8 = ()=>$4617d077c77c0a60$export$392846c900a3bda1.getSnapshot().context.phases;
const $4617d077c77c0a60$export$3e5eff476e9672ea = ()=>$4617d077c77c0a60$export$392846c900a3bda1.getSnapshot().context.projectExpenses;
const $4617d077c77c0a60$export$fc9429b5bb0226f7 = ()=>$4617d077c77c0a60$export$392846c900a3bda1.getSnapshot().context.projectNotes;
const $4617d077c77c0a60$export$cff94626157bdd82 = ()=>$4617d077c77c0a60$export$392846c900a3bda1.getSnapshot().context.projectRates;
const $4617d077c77c0a60$export$254fba5fd766af2f = ()=>$4617d077c77c0a60$export$392846c900a3bda1.getSnapshot().context.revenueTargets;
const $4617d077c77c0a60$export$20b82b4a32771893 = ()=>$4617d077c77c0a60$export$392846c900a3bda1.getSnapshot().context.tasks;
const $4617d077c77c0a60$export$87de41ce00762474 = ()=>$4617d077c77c0a60$export$392846c900a3bda1.getSnapshot().context.weeklyAllocations;
const { useStoreData: $4617d077c77c0a60$export$544efe5ac05fc17, useIsLoading: $4617d077c77c0a60$export$4dface15d86304a4, useCanUndo: $4617d077c77c0a60$export$653033ad74e314c9, useCanRedo: $4617d077c77c0a60$export$e7ea8bfdbe9392b0, useUpdatedAt: $4617d077c77c0a60$export$4d53551414e812c, undo: $4617d077c77c0a60$export$21f930c44940fd98, redo: $4617d077c77c0a60$export$1688e416fee0a49e, save: $4617d077c77c0a60$export$a1544dad697b423d, revertToLastSave: $4617d077c77c0a60$export$7e511c2293ae6e56, getState: $4617d077c77c0a60$export$50fdfeece43146fd, getHistory: $4617d077c77c0a60$export$f9582a3c130d9538, getCurrentHistoryIndex: $4617d077c77c0a60$export$3d0fb93f79a1d871, getLastSavedIndex: $4617d077c77c0a60$export$3ad3501ee738138, getSavedAt: $4617d077c77c0a60$export$f4c906ca2124fef8, getUpdatedAt: $4617d077c77c0a60$export$ff3aa069bd8fb4e4 } = $4617d077c77c0a60$export$b8030685c123f4d8;

});


parcelRegister("bumJt", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $85d4213991626b36$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");
var $64Yjc = parcelRequire("64Yjc");

var $1ZZ6a = parcelRequire("1ZZ6a");

var $eF9JA = parcelRequire("eF9JA");

var $kuPRw = parcelRequire("kuPRw");

var $47i9t = parcelRequire("47i9t");

var $4iw5i = parcelRequire("4iw5i");

var $5PXcS = parcelRequire("5PXcS");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $7qobO = parcelRequire("7qobO");

var $fM2j4 = parcelRequire("fM2j4");

var $6Q5sp = parcelRequire("6Q5sp");

var $5JL5P = parcelRequire("5JL5P");

var $kqntg = parcelRequire("kqntg");

var $26sX2 = parcelRequire("26sX2");

var $38AIP = parcelRequire("38AIP");

var $3h7sC = parcelRequire("3h7sC");
const $85d4213991626b36$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_private/permissions/$id")({
    beforeLoad: ({ params: params })=>{
        if (!(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "staff-permissions", params)) throw new Error("Permission Denied");
        const permission = (0, $38AIP.getCacheItemById)("permissions", params.id);
        (0, $26sX2.setLayoutDefaults)({
            pageTitle: (permission === null || permission === void 0 ? void 0 : permission.name) || "Permission",
            subMenu: "resources"
        });
    },
    errorComponent: ({ error: error, reset: reset })=>{
        if (error.message === "Permission Denied") return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7qobO.default), {});
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    },
    loader: async ({ params: params })=>await $85d4213991626b36$var$loader(params.id),
    pendingComponent: (0, $4iw5i.default),
    component: $85d4213991626b36$var$Wrapper,
    onLeave: (match)=>{
        const { id: id } = match.params;
        const permission = (0, $5JL5P.default).permissionsById[id];
        if (!(permission !== null && permission !== void 0 && permission.createdAt) && match.pathname !== (0, $6Q5sp.router).latestLocation.pathname) (0, $fM2j4.default).destroyNewItems("permissionId", id);
    }
});
const $85d4213991626b36$var$loader = async (id)=>{
    const data = await (0, $3h7sC.trpc).legacy.getPermissionPageData.query({
        id: id
    });
    const processedModels = (0, $47i9t.processTRPCData)(data);
    const permission = (0, $5JL5P.default).permissionsById[id];
    if (!permission) throw (0, $64Yjc.notFound)();
    return processedModels;
};
function $85d4213991626b36$var$Wrapper() {
    const { id: id } = $85d4213991626b36$export$e7b0ac011bb776c6.useParams();
    if ((0, $8kZ1o.migratedToV2)()) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqntg.CenterPadPageBody), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $eF9JA.default), {
            permissionId: id
        })
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $1ZZ6a.default), {
                id: id
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kuPRw.default), {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $eF9JA.default), {
                    permissionId: id
                })
            })
        ]
    });
}

});
parcelRegister("1ZZ6a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $174ae1d047b1f56f$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $36Jjh = parcelRequire("36Jjh");

var $5JL5P = parcelRequire("5JL5P");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $eFLH7 = parcelRequire("eFLH7");

var $khJQv = parcelRequire("khJQv");
var $174ae1d047b1f56f$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ id: id, extraContent: extraContent })=>{
    const permission = (0, $5JL5P.default).permissionsById[id];
    if (!permission) return null;
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $36Jjh.default), {
        heading: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                children: [
                    (permission === null || permission === void 0 ? void 0 : permission.name) || "New Permission",
                    permission.id === (0, $1BTI2.default).organisation.defaultPermissionsId ? " (Default)" : null
                ]
            })
        }),
        rightButtons: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
            children: [
                (0, $8kZ1o.canEditStaff)((0, $1BTI2.default).user) ? /*#__PURE__*/ (0, $61Ea1.jsxs)("button", {
                    className: "btn btn-default edit-controls__delete-button mr-4",
                    onClick: ()=>(0, $1BTI2.default).organisation.update({
                            defaultPermissionsId: permission.id
                        }),
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                            className: "fa fa-cog mr-1"
                        }),
                        "Set as Default"
                    ]
                }) : null,
                (0, $8kZ1o.canEditStaff)((0, $1BTI2.default).user) ? /*#__PURE__*/ (0, $61Ea1.jsxs)("button", {
                    className: "btn btn-default edit-controls__delete-button",
                    onClick: ()=>(0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $eFLH7.default), {
                            permission: permission,
                            modalId: "deletePermission"
                        })),
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                            className: "fa fa-trash mr-1"
                        }),
                        "Delete"
                    ]
                }) : null
            ]
        }),
        extraContent: extraContent
    });
});

});
parcelRegister("eFLH7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aae9e429f4b949a3$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("eat5C");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $fEcKX = parcelRequire("fEcKX");

var $fM2j4 = parcelRequire("fM2j4");

var $6UBLf = parcelRequire("6UBLf");

var $1BTI2 = parcelRequire("1BTI2");
var $aae9e429f4b949a3$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ permission: permission, modalId: modalId })=>{
    const navigate = (0, $6UBLf.useNavigate)();
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fEcKX.default), {
        modalId: modalId,
        heading: "Delete Permission",
        saveLabel: "Delete Permission",
        onSave: async ()=>{
            permission.update({
                deletedAt: new Date()
            });
            if (permission.id === (0, $1BTI2.default).organisation.defaultPermissionsId) (0, $1BTI2.default).organisation.update({
                defaultPermissionsId: null
            });
            permission.staff.forEach((s)=>{
                s.update({
                    permissionsId: null
                });
            });
            await (0, $fM2j4.default).startSave();
            await (0, $fM2j4.default).saveModel(permission);
            navigate({
                to: "/permissions"
            });
        },
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("p", {
            style: {
                margin: "1em"
            },
            children: [
                "Are you sure you wish to delete ",
                /*#__PURE__*/ (0, $61Ea1.jsx)("em", {
                    children: permission.name
                }),
                "?"
            ]
        })
    });
});

});


parcelRegister("eF9JA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aacc720e04b79761$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("02LyB");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $5JL5P = parcelRequire("5JL5P");

var $gAnn6 = parcelRequire("gAnn6");

var $lWpUl = parcelRequire("lWpUl");

var $4WSZl = parcelRequire("4WSZl");

var $8kZ1o = parcelRequire("8kZ1o");

var $gN0TC = parcelRequire("gN0TC");

var $c86dX = parcelRequire("c86dX");
var $aacc720e04b79761$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ permissionId: permissionId })=>{
    const permissions = (0, $5JL5P.default).permissionsById[permissionId];
    if (!permissions) return null;
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "space-y-10",
        style: {
            width: "58em"
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "text-xl mt-12 mb-12",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                        className: "mr-5 text-lg",
                        children: "Permission Name:"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
                        className: "input-base",
                        value: permissions.name,
                        onChange: (e)=>permissions.update({
                                name: e.target.value
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                        className: "mr-5 text-lg",
                        children: "Selected Staff:"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $c86dX.StaffMultiselect), {
                        selectedStaffMembers: permissions.staff,
                        onChange: (v)=>{
                            const previousStaff = [
                                ...permissions.staff
                            ];
                            v.forEach((staff)=>{
                                staff.update({
                                    permissionsId: permissionId
                                });
                            });
                            previousStaff.forEach((staff)=>{
                                if (!v.includes(staff)) staff.update({
                                    permissionsId: null
                                });
                            });
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)($aacc720e04b79761$export$e64befb57ff51d2d, {
                model: permissions,
                permissions: permissions.settings
            })
        ]
    });
});
const $aacc720e04b79761$export$e64befb57ff51d2d = ({ permissions: permissions, model: model })=>{
    const handleUpdatePermissions = (key, value)=>{
        model.update({
            settings: {
                ...model.settings,
                [key]: value
            }
        });
        model.staff.forEach((staff)=>{
            staff.update({
                permissions: model.settings
            });
        });
    };
    const handleUpdateProjectPermissions = (id, key, value)=>{
        const projectPermission = model.settings.projects.find((p)=>p.id === id);
        if (projectPermission) projectPermission.permissions = {
            ...projectPermission.permissions,
            [key]: value
        };
        model.update({
            settings: {
                ...model.settings
            }
        });
        model.staff.forEach((staff)=>{
            staff.update({
                permissions: model.settings
            });
        });
    };
    const handleUpdateFilterPermissions = (id, filter)=>{
        const projectPermission = model.settings.projects.find((p)=>p.id === id);
        if (projectPermission) projectPermission.filter = filter !== null && filter !== void 0 ? filter : projectPermission.filter;
        model.update({
            settings: {
                ...model.settings
            }
        });
        model.staff.forEach((staff)=>{
            staff.update({
                permissions: model.settings
            });
        });
    };
    const addProjectPermission = ()=>{
        model.settings.projects.push({
            filter: !(0, $8kZ1o.hasPermissionsForAllProjects)(model.settings) ? {
                type: "all"
            } : {
                type: "project",
                values: []
            },
            id: (0, (/*@__PURE__*/$parcel$interopDefault($gN0TC)))(),
            permissions: {
                ...(0, $4WSZl.permissionPresets).timesheet.projects[0].permissions
            }
        });
        model.update({
            settings: {
                ...model.settings
            }
        });
        model.staff.forEach((staff)=>{
            staff.update({
                permissions: model.settings
            });
        });
    };
    const deleteProjectPermission = (id)=>{
        model.settings.projects = model.settings.projects.filter((p)=>p.id !== id);
        model.update({
            settings: {
                ...model.settings
            }
        });
    };
    return (0, $gAnn6.permissionStructure).map((group)=>group.label !== "Projects" ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $lWpUl.PermissionGroup), {
            title: group.label,
            permissions: group.permissions,
            staffPermissions: permissions || [],
            onChange: handleUpdatePermissions
        }) : /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            children: [
                ((permissions === null || permissions === void 0 ? void 0 : permissions.projects) || []).map((projectPermissions)=>/*#__PURE__*/ (0, $61Ea1.jsx)((0, $lWpUl.ProjectPermissionGroup), {
                        permissions: group.permissions,
                        staffPermissions: permissions,
                        projectPermissions: projectPermissions,
                        onChange: (key, value)=>handleUpdateProjectPermissions(projectPermissions.id, key, value),
                        onFilterChange: (value)=>handleUpdateFilterPermissions(projectPermissions.id, value),
                        onDelete: ()=>deleteProjectPermission(projectPermissions.id)
                    })),
                /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                    className: "plus-btn border-[#d9d9d9] mb-10",
                    onClick: ()=>addProjectPermission(),
                    children: "+ Add Project Permissions"
                })
            ]
        }));
};

});


parcelRegister("4q8p1", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $33801bb3d7e01aa5$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");

var $as2sc = parcelRequire("as2sc");

var $kuPRw = parcelRequire("kuPRw");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $7qobO = parcelRequire("7qobO");

var $4iw5i = parcelRequire("4iw5i");

var $5PXcS = parcelRequire("5PXcS");
const $33801bb3d7e01aa5$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_private/migrate/$id")({
    beforeLoad: ({ params: params })=>{
        if (!(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "migrate", params)) throw new Error("Permission Denied");
    },
    errorComponent: ({ error: error, reset: reset })=>{
        if (error.message === "Permission Denied") return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7qobO.default), {});
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    },
    component: $33801bb3d7e01aa5$var$Wrapper,
    pendingComponent: (0, $4iw5i.default)
});
function $33801bb3d7e01aa5$var$Wrapper() {
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kuPRw.default), {
            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $as2sc.default), {})
        })
    });
}

});
parcelRegister("as2sc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79be6c2d91ec8a28$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $iOQGT = parcelRequire("iOQGT");

var $hAlRk = parcelRequire("hAlRk");

// Pusher.logToConsole = true
const $79be6c2d91ec8a28$var$MigratePage = ({ id: id })=>{
    var pusher = new (0, (/*@__PURE__*/$parcel$interopDefault($hAlRk)))("d897094bcdb8f28745e0", {
        cluster: "ap1"
    });
    const [migrationState, setMigrationState] = (0, $jbmdS.useState)([]);
    const [isMigrating, setIsMigrating] = (0, $jbmdS.useState)(false);
    const [isCompleted, setIsCompleted] = (0, $jbmdS.useState)(false);
    (0, $jbmdS.useEffect)(()=>{
        var channel = pusher.subscribe(id);
        channel.bind("progress", function(data) {
            setMigrationState(data);
        });
        channel.bind("error", function(data) {
            setMigrationState(data);
            setIsCompleted(true);
        });
        channel.bind("completed", function(data) {
            setMigrationState(data);
            setIsCompleted(true);
        });
    }, []);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "flex flex-align-items-center flex-justify-content-center",
        style: {
            textAlign: "center",
            alignSelf: "center"
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("style", {
                children: `.loading::after {
                    display: inline-block;
                    animation: dotty steps(1,end) 1s infinite;
                    content: '   ';
                }
                
                @keyframes dotty {
                    0%   { content: '   '; }
                    25%  { content: '.  '; }
                    50%  { content: '.. '; }
                    75%  { content: '...'; }
                    100% { content: '   '; }
                }`
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("section", {
                className: "login-widget login-widget--login-mode",
                style: {
                    width: "50em"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("header", {
                        className: "text-align-center",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                style: {
                                    width: "10em",
                                    height: "10em"
                                },
                                className: "logo2 s75",
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)("img", {
                                    src: new URL((parcelRequire("hw9H4"))),
                                    alt: "Coincraft Logo"
                                })
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("h3", {
                                children: "Migrate Data"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                children: "This may take serveral minutes..."
                            })
                        ]
                    }),
                    isMigrating ? /*#__PURE__*/ (0, $61Ea1.jsxs)("h4", {
                        style: {
                            display: "flex",
                            alignContent: "center",
                            justifyContent: "center",
                            textAlign: "center",
                            paddingTop: "3em"
                        },
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                style: {
                                    paddingLeft: "1em"
                                },
                                children: migrationState
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                className: !isCompleted ? "loading" : "",
                                style: {
                                    width: "1em",
                                    alignSelf: "left",
                                    justifySelf: "flex-start",
                                    textAlign: "left"
                                }
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                        onClick: ()=>{
                            (0, $iOQGT.makeRequest)({
                                path: `/migrate/${id}`,
                                method: "post"
                            });
                            setIsMigrating(true);
                        },
                        children: "Start Migration"
                    })
                ]
            })
        ]
    });
};
var $79be6c2d91ec8a28$export$2e2bcd8739ae039 = $79be6c2d91ec8a28$var$MigratePage;

});
parcelRegister("hAlRk", function(module, exports) {
/*!
 * Pusher JavaScript Library v8.3.0
 * https://pusher.com/
 *
 * Copyright 2020, Pusher
 * Released under the MIT licence.
 */ (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(window, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                enumerable: true,
                get: getter
            });
        /******/ };
        /******/ /******/ // define __esModule on exports
        /******/ __webpack_require__.r = function(exports) {
            /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                value: "Module"
            });
            /******/ Object.defineProperty(exports, "__esModule", {
                value: true
            });
        /******/ };
        /******/ /******/ // create a fake namespace object
        /******/ // mode & 1: value is a module id, require it
        /******/ // mode & 2: merge all properties of value into the ns
        /******/ // mode & 4: return value when already ns object
        /******/ // mode & 8|1: behave like require
        /******/ __webpack_require__.t = function(value, mode) {
            /******/ if (mode & 1) value = __webpack_require__(value);
            /******/ if (mode & 8) return value;
            /******/ if (mode & 4 && typeof value === "object" && value && value.__esModule) return value;
            /******/ var ns = Object.create(null);
            /******/ __webpack_require__.r(ns);
            /******/ Object.defineProperty(ns, "default", {
                enumerable: true,
                value: value
            });
            /******/ if (mode & 2 && typeof value != "string") for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            /******/ return ns;
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1["default"];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, "a", getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 2);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // Copyright (C) 2016 Dmitry Chestnykh
            // MIT License. See LICENSE file for details.
            var __extends = this && this.__extends || function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            /**
 * Package base64 implements Base64 encoding and decoding.
 */ // Invalid character used in decoding to indicate
            // that the character to decode is out of range of
            // alphabet and cannot be decoded.
            var INVALID_BYTE = 256;
            /**
 * Implements standard Base64 encoding.
 *
 * Operates in constant time.
 */ var Coder = /** @class */ function() {
                // TODO(dchest): methods to encode chunk-by-chunk.
                function Coder(_paddingCharacter) {
                    if (_paddingCharacter === void 0) _paddingCharacter = "=";
                    this._paddingCharacter = _paddingCharacter;
                }
                Coder.prototype.encodedLength = function(length) {
                    if (!this._paddingCharacter) return (length * 8 + 5) / 6 | 0;
                    return (length + 2) / 3 * 4 | 0;
                };
                Coder.prototype.encode = function(data) {
                    var out = "";
                    var i = 0;
                    for(; i < data.length - 2; i += 3){
                        var c = data[i] << 16 | data[i + 1] << 8 | data[i + 2];
                        out += this._encodeByte(c >>> 18 & 63);
                        out += this._encodeByte(c >>> 12 & 63);
                        out += this._encodeByte(c >>> 6 & 63);
                        out += this._encodeByte(c >>> 0 & 63);
                    }
                    var left = data.length - i;
                    if (left > 0) {
                        var c = data[i] << 16 | (left === 2 ? data[i + 1] << 8 : 0);
                        out += this._encodeByte(c >>> 18 & 63);
                        out += this._encodeByte(c >>> 12 & 63);
                        if (left === 2) out += this._encodeByte(c >>> 6 & 63);
                        else out += this._paddingCharacter || "";
                        out += this._paddingCharacter || "";
                    }
                    return out;
                };
                Coder.prototype.maxDecodedLength = function(length) {
                    if (!this._paddingCharacter) return (length * 6 + 7) / 8 | 0;
                    return length / 4 * 3 | 0;
                };
                Coder.prototype.decodedLength = function(s) {
                    return this.maxDecodedLength(s.length - this._getPaddingLength(s));
                };
                Coder.prototype.decode = function(s) {
                    if (s.length === 0) return new Uint8Array(0);
                    var paddingLength = this._getPaddingLength(s);
                    var length = s.length - paddingLength;
                    var out = new Uint8Array(this.maxDecodedLength(length));
                    var op = 0;
                    var i = 0;
                    var haveBad = 0;
                    var v0 = 0, v1 = 0, v2 = 0, v3 = 0;
                    for(; i < length - 4; i += 4){
                        v0 = this._decodeChar(s.charCodeAt(i + 0));
                        v1 = this._decodeChar(s.charCodeAt(i + 1));
                        v2 = this._decodeChar(s.charCodeAt(i + 2));
                        v3 = this._decodeChar(s.charCodeAt(i + 3));
                        out[op++] = v0 << 2 | v1 >>> 4;
                        out[op++] = v1 << 4 | v2 >>> 2;
                        out[op++] = v2 << 6 | v3;
                        haveBad |= v0 & INVALID_BYTE;
                        haveBad |= v1 & INVALID_BYTE;
                        haveBad |= v2 & INVALID_BYTE;
                        haveBad |= v3 & INVALID_BYTE;
                    }
                    if (i < length - 1) {
                        v0 = this._decodeChar(s.charCodeAt(i));
                        v1 = this._decodeChar(s.charCodeAt(i + 1));
                        out[op++] = v0 << 2 | v1 >>> 4;
                        haveBad |= v0 & INVALID_BYTE;
                        haveBad |= v1 & INVALID_BYTE;
                    }
                    if (i < length - 2) {
                        v2 = this._decodeChar(s.charCodeAt(i + 2));
                        out[op++] = v1 << 4 | v2 >>> 2;
                        haveBad |= v2 & INVALID_BYTE;
                    }
                    if (i < length - 3) {
                        v3 = this._decodeChar(s.charCodeAt(i + 3));
                        out[op++] = v2 << 6 | v3;
                        haveBad |= v3 & INVALID_BYTE;
                    }
                    if (haveBad !== 0) throw new Error("Base64Coder: incorrect characters for decoding");
                    return out;
                };
                // Standard encoding have the following encoded/decoded ranges,
                // which we need to convert between.
                //
                // ABCDEFGHIJKLMNOPQRSTUVWXYZ abcdefghijklmnopqrstuvwxyz 0123456789  +   /
                // Index:   0 - 25                    26 - 51              52 - 61   62  63
                // ASCII:  65 - 90                    97 - 122             48 - 57   43  47
                //
                // Encode 6 bits in b into a new character.
                Coder.prototype._encodeByte = function(b) {
                    // Encoding uses constant time operations as follows:
                    //
                    // 1. Define comparison of A with B using (A - B) >>> 8:
                    //          if A > B, then result is positive integer
                    //          if A <= B, then result is 0
                    //
                    // 2. Define selection of C or 0 using bitwise AND: X & C:
                    //          if X == 0, then result is 0
                    //          if X != 0, then result is C
                    //
                    // 3. Start with the smallest comparison (b >= 0), which is always
                    //    true, so set the result to the starting ASCII value (65).
                    //
                    // 4. Continue comparing b to higher ASCII values, and selecting
                    //    zero if comparison isn't true, otherwise selecting a value
                    //    to add to result, which:
                    //
                    //          a) undoes the previous addition
                    //          b) provides new value to add
                    //
                    var result = b;
                    // b >= 0
                    result += 65;
                    // b > 25
                    result += 25 - b >>> 8 & 6;
                    // b > 51
                    result += 51 - b >>> 8 & -75;
                    // b > 61
                    result += 61 - b >>> 8 & -15;
                    // b > 62
                    result += 62 - b >>> 8 & 3;
                    return String.fromCharCode(result);
                };
                // Decode a character code into a byte.
                // Must return 256 if character is out of alphabet range.
                Coder.prototype._decodeChar = function(c) {
                    // Decoding works similar to encoding: using the same comparison
                    // function, but now it works on ranges: result is always incremented
                    // by value, but this value becomes zero if the range is not
                    // satisfied.
                    //
                    // Decoding starts with invalid value, 256, which is then
                    // subtracted when the range is satisfied. If none of the ranges
                    // apply, the function returns 256, which is then checked by
                    // the caller to throw error.
                    var result = INVALID_BYTE; // start with invalid character
                    // c == 43 (c > 42 and c < 44)
                    result += (42 - c & c - 44) >>> 8 & -INVALID_BYTE + c - 43 + 62;
                    // c == 47 (c > 46 and c < 48)
                    result += (46 - c & c - 48) >>> 8 & -INVALID_BYTE + c - 47 + 63;
                    // c > 47 and c < 58
                    result += (47 - c & c - 58) >>> 8 & -INVALID_BYTE + c - 48 + 52;
                    // c > 64 and c < 91
                    result += (64 - c & c - 91) >>> 8 & -INVALID_BYTE + c - 65 + 0;
                    // c > 96 and c < 123
                    result += (96 - c & c - 123) >>> 8 & -INVALID_BYTE + c - 97 + 26;
                    return result;
                };
                Coder.prototype._getPaddingLength = function(s) {
                    var paddingLength = 0;
                    if (this._paddingCharacter) {
                        for(var i = s.length - 1; i >= 0; i--){
                            if (s[i] !== this._paddingCharacter) break;
                            paddingLength++;
                        }
                        if (s.length < 4 || paddingLength > 2) throw new Error("Base64Coder: incorrect padding");
                    }
                    return paddingLength;
                };
                return Coder;
            }();
            exports.Coder = Coder;
            var stdCoder = new Coder();
            function encode(data) {
                return stdCoder.encode(data);
            }
            exports.encode = encode;
            function decode(s) {
                return stdCoder.decode(s);
            }
            exports.decode = decode;
            /**
 * Implements URL-safe Base64 encoding.
 * (Same as Base64, but '+' is replaced with '-', and '/' with '_').
 *
 * Operates in constant time.
 */ var URLSafeCoder = /** @class */ function(_super) {
                __extends(URLSafeCoder, _super);
                function URLSafeCoder() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                // URL-safe encoding have the following encoded/decoded ranges:
                //
                // ABCDEFGHIJKLMNOPQRSTUVWXYZ abcdefghijklmnopqrstuvwxyz 0123456789  -   _
                // Index:   0 - 25                    26 - 51              52 - 61   62  63
                // ASCII:  65 - 90                    97 - 122             48 - 57   45  95
                //
                URLSafeCoder.prototype._encodeByte = function(b) {
                    var result = b;
                    // b >= 0
                    result += 65;
                    // b > 25
                    result += 25 - b >>> 8 & 6;
                    // b > 51
                    result += 51 - b >>> 8 & -75;
                    // b > 61
                    result += 61 - b >>> 8 & -13;
                    // b > 62
                    result += 62 - b >>> 8 & 49;
                    return String.fromCharCode(result);
                };
                URLSafeCoder.prototype._decodeChar = function(c) {
                    var result = INVALID_BYTE;
                    // c == 45 (c > 44 and c < 46)
                    result += (44 - c & c - 46) >>> 8 & -INVALID_BYTE + c - 45 + 62;
                    // c == 95 (c > 94 and c < 96)
                    result += (94 - c & c - 96) >>> 8 & -INVALID_BYTE + c - 95 + 63;
                    // c > 47 and c < 58
                    result += (47 - c & c - 58) >>> 8 & -INVALID_BYTE + c - 48 + 52;
                    // c > 64 and c < 91
                    result += (64 - c & c - 91) >>> 8 & -INVALID_BYTE + c - 65 + 0;
                    // c > 96 and c < 123
                    result += (96 - c & c - 123) >>> 8 & -INVALID_BYTE + c - 97 + 26;
                    return result;
                };
                return URLSafeCoder;
            }(Coder);
            exports.URLSafeCoder = URLSafeCoder;
            var urlSafeCoder = new URLSafeCoder();
            function encodeURLSafe(data) {
                return urlSafeCoder.encode(data);
            }
            exports.encodeURLSafe = encodeURLSafe;
            function decodeURLSafe(s) {
                return urlSafeCoder.decode(s);
            }
            exports.decodeURLSafe = decodeURLSafe;
            exports.encodedLength = function(length) {
                return stdCoder.encodedLength(length);
            };
            exports.maxDecodedLength = function(length) {
                return stdCoder.maxDecodedLength(length);
            };
            exports.decodedLength = function(s) {
                return stdCoder.decodedLength(s);
            };
        /***/ },
        /* 1 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // Copyright (C) 2016 Dmitry Chestnykh
            // MIT License. See LICENSE file for details.
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            /**
 * Package utf8 implements UTF-8 encoding and decoding.
 */ var INVALID_UTF16 = "utf8: invalid string";
            var INVALID_UTF8 = "utf8: invalid source encoding";
            /**
 * Encodes the given string into UTF-8 byte array.
 * Throws if the source string has invalid UTF-16 encoding.
 */ function encode(s) {
                // Calculate result length and allocate output array.
                // encodedLength() also validates string and throws errors,
                // so we don't need repeat validation here.
                var arr = new Uint8Array(encodedLength(s));
                var pos = 0;
                for(var i = 0; i < s.length; i++){
                    var c = s.charCodeAt(i);
                    if (c < 0x80) arr[pos++] = c;
                    else if (c < 0x800) {
                        arr[pos++] = 0xc0 | c >> 6;
                        arr[pos++] = 0x80 | c & 0x3f;
                    } else if (c < 0xd800) {
                        arr[pos++] = 0xe0 | c >> 12;
                        arr[pos++] = 0x80 | c >> 6 & 0x3f;
                        arr[pos++] = 0x80 | c & 0x3f;
                    } else {
                        i++; // get one more character
                        c = (c & 0x3ff) << 10;
                        c |= s.charCodeAt(i) & 0x3ff;
                        c += 0x10000;
                        arr[pos++] = 0xf0 | c >> 18;
                        arr[pos++] = 0x80 | c >> 12 & 0x3f;
                        arr[pos++] = 0x80 | c >> 6 & 0x3f;
                        arr[pos++] = 0x80 | c & 0x3f;
                    }
                }
                return arr;
            }
            exports.encode = encode;
            /**
 * Returns the number of bytes required to encode the given string into UTF-8.
 * Throws if the source string has invalid UTF-16 encoding.
 */ function encodedLength(s) {
                var result = 0;
                for(var i = 0; i < s.length; i++){
                    var c = s.charCodeAt(i);
                    if (c < 0x80) result += 1;
                    else if (c < 0x800) result += 2;
                    else if (c < 0xd800) result += 3;
                    else if (c <= 0xdfff) {
                        if (i >= s.length - 1) throw new Error(INVALID_UTF16);
                        i++; // "eat" next character
                        result += 4;
                    } else throw new Error(INVALID_UTF16);
                }
                return result;
            }
            exports.encodedLength = encodedLength;
            /**
 * Decodes the given byte array from UTF-8 into a string.
 * Throws if encoding is invalid.
 */ function decode(arr) {
                var chars = [];
                for(var i = 0; i < arr.length; i++){
                    var b = arr[i];
                    if (b & 0x80) {
                        var min = void 0;
                        if (b < 0xe0) {
                            // Need 1 more byte.
                            if (i >= arr.length) throw new Error(INVALID_UTF8);
                            var n1 = arr[++i];
                            if ((n1 & 0xc0) !== 0x80) throw new Error(INVALID_UTF8);
                            b = (b & 0x1f) << 6 | n1 & 0x3f;
                            min = 0x80;
                        } else if (b < 0xf0) {
                            // Need 2 more bytes.
                            if (i >= arr.length - 1) throw new Error(INVALID_UTF8);
                            var n1 = arr[++i];
                            var n2 = arr[++i];
                            if ((n1 & 0xc0) !== 0x80 || (n2 & 0xc0) !== 0x80) throw new Error(INVALID_UTF8);
                            b = (b & 0x0f) << 12 | (n1 & 0x3f) << 6 | n2 & 0x3f;
                            min = 0x800;
                        } else if (b < 0xf8) {
                            // Need 3 more bytes.
                            if (i >= arr.length - 2) throw new Error(INVALID_UTF8);
                            var n1 = arr[++i];
                            var n2 = arr[++i];
                            var n3 = arr[++i];
                            if ((n1 & 0xc0) !== 0x80 || (n2 & 0xc0) !== 0x80 || (n3 & 0xc0) !== 0x80) throw new Error(INVALID_UTF8);
                            b = (b & 0x0f) << 18 | (n1 & 0x3f) << 12 | (n2 & 0x3f) << 6 | n3 & 0x3f;
                            min = 0x10000;
                        } else throw new Error(INVALID_UTF8);
                        if (b < min || b >= 0xd800 && b <= 0xdfff) throw new Error(INVALID_UTF8);
                        if (b >= 0x10000) {
                            // Surrogate pair.
                            if (b > 0x10ffff) throw new Error(INVALID_UTF8);
                            b -= 0x10000;
                            chars.push(String.fromCharCode(0xd800 | b >> 10));
                            b = 0xdc00 | b & 0x3ff;
                        }
                    }
                    chars.push(String.fromCharCode(b));
                }
                return chars.join("");
            }
            exports.decode = decode;
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            // required so we don't have to do require('pusher').default etc.
            module1.exports = __webpack_require__(3).default;
        /***/ },
        /* 3 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            // ESM COMPAT FLAG
            __webpack_require__.r(__webpack_exports__);
            // CONCATENATED MODULE: ./src/runtimes/web/dom/script_receiver_factory.ts
            class ScriptReceiverFactory {
                constructor(prefix, name){
                    this.lastId = 0;
                    this.prefix = prefix;
                    this.name = name;
                }
                create(callback) {
                    this.lastId++;
                    var number = this.lastId;
                    var id = this.prefix + number;
                    var name = this.name + "[" + number + "]";
                    var called = false;
                    var callbackWrapper = function() {
                        if (!called) {
                            callback.apply(null, arguments);
                            called = true;
                        }
                    };
                    this[number] = callbackWrapper;
                    return {
                        number: number,
                        id: id,
                        name: name,
                        callback: callbackWrapper
                    };
                }
                remove(receiver) {
                    delete this[receiver.number];
                }
            }
            var ScriptReceivers = new ScriptReceiverFactory("_pusher_script_", "Pusher.ScriptReceivers");
            // CONCATENATED MODULE: ./src/core/defaults.ts
            var Defaults = {
                VERSION: "8.3.0",
                PROTOCOL: 7,
                wsPort: 80,
                wssPort: 443,
                wsPath: "",
                httpHost: "sockjs.pusher.com",
                httpPort: 80,
                httpsPort: 443,
                httpPath: "/pusher",
                stats_host: "stats.pusher.com",
                authEndpoint: "/pusher/auth",
                authTransport: "ajax",
                activityTimeout: 120000,
                pongTimeout: 30000,
                unavailableTimeout: 10000,
                userAuthentication: {
                    endpoint: "/pusher/user-auth",
                    transport: "ajax"
                },
                channelAuthorization: {
                    endpoint: "/pusher/auth",
                    transport: "ajax"
                },
                cdn_http: "http://js.pusher.com",
                cdn_https: "https://js.pusher.com",
                dependency_suffix: ""
            };
            /* harmony default export */ var defaults = Defaults;
            // CONCATENATED MODULE: ./src/runtimes/web/dom/dependency_loader.ts
            class dependency_loader_DependencyLoader {
                constructor(options){
                    this.options = options;
                    this.receivers = options.receivers || ScriptReceivers;
                    this.loading = {};
                }
                load(name, options, callback) {
                    var self = this;
                    if (self.loading[name] && self.loading[name].length > 0) self.loading[name].push(callback);
                    else {
                        self.loading[name] = [
                            callback
                        ];
                        var request = runtime.createScriptRequest(self.getPath(name, options));
                        var receiver = self.receivers.create(function(error) {
                            self.receivers.remove(receiver);
                            if (self.loading[name]) {
                                var callbacks = self.loading[name];
                                delete self.loading[name];
                                var successCallback = function(wasSuccessful) {
                                    if (!wasSuccessful) request.cleanup();
                                };
                                for(var i = 0; i < callbacks.length; i++)callbacks[i](error, successCallback);
                            }
                        });
                        request.send(receiver);
                    }
                }
                getRoot(options) {
                    var cdn;
                    var protocol = runtime.getDocument().location.protocol;
                    if (options && options.useTLS || protocol === "https:") cdn = this.options.cdn_https;
                    else cdn = this.options.cdn_http;
                    return cdn.replace(/\/*$/, "") + "/" + this.options.version;
                }
                getPath(name, options) {
                    return this.getRoot(options) + "/" + name + this.options.suffix + ".js";
                }
            }
            // CONCATENATED MODULE: ./src/runtimes/web/dom/dependencies.ts
            var DependenciesReceivers = new ScriptReceiverFactory("_pusher_dependencies", "Pusher.DependenciesReceivers");
            var Dependencies = new dependency_loader_DependencyLoader({
                cdn_http: defaults.cdn_http,
                cdn_https: defaults.cdn_https,
                version: defaults.VERSION,
                suffix: defaults.dependency_suffix,
                receivers: DependenciesReceivers
            });
            // CONCATENATED MODULE: ./src/core/utils/url_store.ts
            const urlStore = {
                baseUrl: "https://pusher.com",
                urls: {
                    authenticationEndpoint: {
                        path: "/docs/channels/server_api/authenticating_users"
                    },
                    authorizationEndpoint: {
                        path: "/docs/channels/server_api/authorizing-users/"
                    },
                    javascriptQuickStart: {
                        path: "/docs/javascript_quick_start"
                    },
                    triggeringClientEvents: {
                        path: "/docs/client_api_guide/client_events#trigger-events"
                    },
                    encryptedChannelSupport: {
                        fullUrl: "https://github.com/pusher/pusher-js/tree/cc491015371a4bde5743d1c87a0fbac0feb53195#encrypted-channel-support"
                    }
                }
            };
            const buildLogSuffix = function(key) {
                const urlPrefix = "See:";
                const urlObj = urlStore.urls[key];
                if (!urlObj) return "";
                let url;
                if (urlObj.fullUrl) url = urlObj.fullUrl;
                else if (urlObj.path) url = urlStore.baseUrl + urlObj.path;
                if (!url) return "";
                return `${urlPrefix} ${url}`;
            };
            /* harmony default export */ var url_store = {
                buildLogSuffix: buildLogSuffix
            };
            // CONCATENATED MODULE: ./src/core/auth/options.ts
            var AuthRequestType;
            (function(AuthRequestType) {
                AuthRequestType["UserAuthentication"] = "user-authentication";
                AuthRequestType["ChannelAuthorization"] = "channel-authorization";
            })(AuthRequestType || (AuthRequestType = {}));
            // CONCATENATED MODULE: ./src/core/errors.ts
            class BadEventName extends Error {
                constructor(msg){
                    super(msg);
                    Object.setPrototypeOf(this, new.target.prototype);
                }
            }
            class BadChannelName extends Error {
                constructor(msg){
                    super(msg);
                    Object.setPrototypeOf(this, new.target.prototype);
                }
            }
            class RequestTimedOut extends Error {
                constructor(msg){
                    super(msg);
                    Object.setPrototypeOf(this, new.target.prototype);
                }
            }
            class TransportPriorityTooLow extends Error {
                constructor(msg){
                    super(msg);
                    Object.setPrototypeOf(this, new.target.prototype);
                }
            }
            class TransportClosed extends Error {
                constructor(msg){
                    super(msg);
                    Object.setPrototypeOf(this, new.target.prototype);
                }
            }
            class UnsupportedFeature extends Error {
                constructor(msg){
                    super(msg);
                    Object.setPrototypeOf(this, new.target.prototype);
                }
            }
            class UnsupportedTransport extends Error {
                constructor(msg){
                    super(msg);
                    Object.setPrototypeOf(this, new.target.prototype);
                }
            }
            class UnsupportedStrategy extends Error {
                constructor(msg){
                    super(msg);
                    Object.setPrototypeOf(this, new.target.prototype);
                }
            }
            class HTTPAuthError extends Error {
                constructor(status, msg){
                    super(msg);
                    this.status = status;
                    Object.setPrototypeOf(this, new.target.prototype);
                }
            }
            // CONCATENATED MODULE: ./src/runtimes/isomorphic/auth/xhr_auth.ts
            const ajax = function(context, query, authOptions, authRequestType, callback) {
                const xhr = runtime.createXHR();
                xhr.open("POST", authOptions.endpoint, true);
                xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
                for(var headerName in authOptions.headers)xhr.setRequestHeader(headerName, authOptions.headers[headerName]);
                if (authOptions.headersProvider != null) {
                    let dynamicHeaders = authOptions.headersProvider();
                    for(var headerName in dynamicHeaders)xhr.setRequestHeader(headerName, dynamicHeaders[headerName]);
                }
                xhr.onreadystatechange = function() {
                    if (xhr.readyState === 4) {
                        if (xhr.status === 200) {
                            let data;
                            let parsed = false;
                            try {
                                data = JSON.parse(xhr.responseText);
                                parsed = true;
                            } catch (e) {
                                callback(new HTTPAuthError(200, `JSON returned from ${authRequestType.toString()} endpoint was invalid, yet status code was 200. Data was: ${xhr.responseText}`), null);
                            }
                            if (parsed) callback(null, data);
                        } else {
                            let suffix = "";
                            switch(authRequestType){
                                case AuthRequestType.UserAuthentication:
                                    suffix = url_store.buildLogSuffix("authenticationEndpoint");
                                    break;
                                case AuthRequestType.ChannelAuthorization:
                                    suffix = `Clients must be authorized to join private or presence channels. ${url_store.buildLogSuffix("authorizationEndpoint")}`;
                                    break;
                            }
                            callback(new HTTPAuthError(xhr.status, `Unable to retrieve auth string from ${authRequestType.toString()} endpoint - ` + `received status: ${xhr.status} from ${authOptions.endpoint}. ${suffix}`), null);
                        }
                    }
                };
                xhr.send(query);
                return xhr;
            };
            /* harmony default export */ var xhr_auth = ajax;
            // CONCATENATED MODULE: ./src/core/base64.ts
            function encode(s) {
                return btoa(utob(s));
            }
            var fromCharCode = String.fromCharCode;
            var b64chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
            var b64tab = {};
            for(var base64_i = 0, l = b64chars.length; base64_i < l; base64_i++)b64tab[b64chars.charAt(base64_i)] = base64_i;
            var cb_utob = function(c) {
                var cc = c.charCodeAt(0);
                return cc < 0x80 ? c : cc < 0x800 ? fromCharCode(0xc0 | cc >>> 6) + fromCharCode(0x80 | cc & 0x3f) : fromCharCode(0xe0 | cc >>> 12 & 0x0f) + fromCharCode(0x80 | cc >>> 6 & 0x3f) + fromCharCode(0x80 | cc & 0x3f);
            };
            var utob = function(u) {
                return u.replace(/[^\x00-\x7F]/g, cb_utob);
            };
            var cb_encode = function(ccc) {
                var padlen = [
                    0,
                    2,
                    1
                ][ccc.length % 3];
                var ord = ccc.charCodeAt(0) << 16 | (ccc.length > 1 ? ccc.charCodeAt(1) : 0) << 8 | (ccc.length > 2 ? ccc.charCodeAt(2) : 0);
                var chars = [
                    b64chars.charAt(ord >>> 18),
                    b64chars.charAt(ord >>> 12 & 63),
                    padlen >= 2 ? "=" : b64chars.charAt(ord >>> 6 & 63),
                    padlen >= 1 ? "=" : b64chars.charAt(ord & 63)
                ];
                return chars.join("");
            };
            var btoa = window.btoa || function(b) {
                return b.replace(/[\s\S]{1,3}/g, cb_encode);
            };
            // CONCATENATED MODULE: ./src/core/utils/timers/abstract_timer.ts
            class Timer {
                constructor(set, clear, delay, callback){
                    this.clear = clear;
                    this.timer = set(()=>{
                        if (this.timer) this.timer = callback(this.timer);
                    }, delay);
                }
                isRunning() {
                    return this.timer !== null;
                }
                ensureAborted() {
                    if (this.timer) {
                        this.clear(this.timer);
                        this.timer = null;
                    }
                }
            }
            /* harmony default export */ var abstract_timer = Timer;
            // CONCATENATED MODULE: ./src/core/utils/timers/index.ts
            function timers_clearTimeout(timer) {
                window.clearTimeout(timer);
            }
            function timers_clearInterval(timer) {
                window.clearInterval(timer);
            }
            class timers_OneOffTimer extends abstract_timer {
                constructor(delay, callback){
                    super(setTimeout, timers_clearTimeout, delay, function(timer) {
                        callback();
                        return null;
                    });
                }
            }
            class timers_PeriodicTimer extends abstract_timer {
                constructor(delay, callback){
                    super(setInterval, timers_clearInterval, delay, function(timer) {
                        callback();
                        return timer;
                    });
                }
            }
            // CONCATENATED MODULE: ./src/core/util.ts
            var Util = {
                now () {
                    if (Date.now) return Date.now();
                    else return new Date().valueOf();
                },
                defer (callback) {
                    return new timers_OneOffTimer(0, callback);
                },
                method (name, ...args) {
                    var boundArguments = Array.prototype.slice.call(arguments, 1);
                    return function(object) {
                        return object[name].apply(object, boundArguments.concat(arguments));
                    };
                }
            };
            /* harmony default export */ var util = Util;
            // CONCATENATED MODULE: ./src/core/utils/collections.ts
            function extend(target, ...sources) {
                for(var i = 0; i < sources.length; i++){
                    var extensions = sources[i];
                    for(var property in extensions)if (extensions[property] && extensions[property].constructor && extensions[property].constructor === Object) target[property] = extend(target[property] || {}, extensions[property]);
                    else target[property] = extensions[property];
                }
                return target;
            }
            function stringify() {
                var m = [
                    "Pusher"
                ];
                for(var i = 0; i < arguments.length; i++)if (typeof arguments[i] === "string") m.push(arguments[i]);
                else m.push(safeJSONStringify(arguments[i]));
                return m.join(" : ");
            }
            function arrayIndexOf(array, item) {
                var nativeIndexOf = Array.prototype.indexOf;
                if (array === null) return -1;
                if (nativeIndexOf && array.indexOf === nativeIndexOf) return array.indexOf(item);
                for(var i = 0, l = array.length; i < l; i++){
                    if (array[i] === item) return i;
                }
                return -1;
            }
            function objectApply(object, f) {
                for(var key in object)if (Object.prototype.hasOwnProperty.call(object, key)) f(object[key], key, object);
            }
            function keys(object) {
                var keys = [];
                objectApply(object, function(_, key) {
                    keys.push(key);
                });
                return keys;
            }
            function values(object) {
                var values = [];
                objectApply(object, function(value) {
                    values.push(value);
                });
                return values;
            }
            function apply(array, f, context) {
                for(var i = 0; i < array.length; i++)f.call(context || window, array[i], i, array);
            }
            function map(array, f) {
                var result = [];
                for(var i = 0; i < array.length; i++)result.push(f(array[i], i, array, result));
                return result;
            }
            function mapObject(object, f) {
                var result = {};
                objectApply(object, function(value, key) {
                    result[key] = f(value);
                });
                return result;
            }
            function filter(array, test) {
                test = test || function(value) {
                    return !!value;
                };
                var result = [];
                for(var i = 0; i < array.length; i++)if (test(array[i], i, array, result)) result.push(array[i]);
                return result;
            }
            function filterObject(object, test) {
                var result = {};
                objectApply(object, function(value, key) {
                    if (test && test(value, key, object, result) || Boolean(value)) result[key] = value;
                });
                return result;
            }
            function flatten(object) {
                var result = [];
                objectApply(object, function(value, key) {
                    result.push([
                        key,
                        value
                    ]);
                });
                return result;
            }
            function any(array, test) {
                for(var i = 0; i < array.length; i++){
                    if (test(array[i], i, array)) return true;
                }
                return false;
            }
            function collections_all(array, test) {
                for(var i = 0; i < array.length; i++){
                    if (!test(array[i], i, array)) return false;
                }
                return true;
            }
            function encodeParamsObject(data) {
                return mapObject(data, function(value) {
                    if (typeof value === "object") value = safeJSONStringify(value);
                    return encodeURIComponent(encode(value.toString()));
                });
            }
            function buildQueryString(data) {
                var params = filterObject(data, function(value) {
                    return value !== undefined;
                });
                var query = map(flatten(encodeParamsObject(params)), util.method("join", "=")).join("&");
                return query;
            }
            function decycleObject(object) {
                var objects = [], paths = [];
                return function derez(value, path) {
                    var i, name, nu;
                    switch(typeof value){
                        case "object":
                            if (!value) return null;
                            for(i = 0; i < objects.length; i += 1){
                                if (objects[i] === value) return {
                                    $ref: paths[i]
                                };
                            }
                            objects.push(value);
                            paths.push(path);
                            if (Object.prototype.toString.apply(value) === "[object Array]") {
                                nu = [];
                                for(i = 0; i < value.length; i += 1)nu[i] = derez(value[i], path + "[" + i + "]");
                            } else {
                                nu = {};
                                for(name in value)if (Object.prototype.hasOwnProperty.call(value, name)) nu[name] = derez(value[name], path + "[" + JSON.stringify(name) + "]");
                            }
                            return nu;
                        case "number":
                        case "string":
                        case "boolean":
                            return value;
                    }
                }(object, "$");
            }
            function safeJSONStringify(source) {
                try {
                    return JSON.stringify(source);
                } catch (e) {
                    return JSON.stringify(decycleObject(source));
                }
            }
            // CONCATENATED MODULE: ./src/core/logger.ts
            class logger_Logger {
                constructor(){
                    this.globalLog = (message)=>{
                        if (window.console && window.console.log) window.console.log(message);
                    };
                }
                debug(...args) {
                    this.log(this.globalLog, args);
                }
                warn(...args) {
                    this.log(this.globalLogWarn, args);
                }
                error(...args) {
                    this.log(this.globalLogError, args);
                }
                globalLogWarn(message) {
                    if (window.console && window.console.warn) window.console.warn(message);
                    else this.globalLog(message);
                }
                globalLogError(message) {
                    if (window.console && window.console.error) window.console.error(message);
                    else this.globalLogWarn(message);
                }
                log(defaultLoggingFunction, ...args) {
                    var message = stringify.apply(this, arguments);
                    if (core_pusher.log) core_pusher.log(message);
                    else if (core_pusher.logToConsole) {
                        const log = defaultLoggingFunction.bind(this);
                        log(message);
                    }
                }
            }
            /* harmony default export */ var logger = new logger_Logger();
            // CONCATENATED MODULE: ./src/runtimes/web/auth/jsonp_auth.ts
            var jsonp = function(context, query, authOptions, authRequestType, callback) {
                if (authOptions.headers !== undefined || authOptions.headersProvider != null) logger.warn(`To send headers with the ${authRequestType.toString()} request, you must use AJAX, rather than JSONP.`);
                var callbackName = context.nextAuthCallbackID.toString();
                context.nextAuthCallbackID++;
                var document1 = context.getDocument();
                var script = document1.createElement("script");
                context.auth_callbacks[callbackName] = function(data) {
                    callback(null, data);
                };
                var callback_name = "Pusher.auth_callbacks['" + callbackName + "']";
                script.src = authOptions.endpoint + "?callback=" + encodeURIComponent(callback_name) + "&" + query;
                var head = document1.getElementsByTagName("head")[0] || document1.documentElement;
                head.insertBefore(script, head.firstChild);
            };
            /* harmony default export */ var jsonp_auth = jsonp;
            // CONCATENATED MODULE: ./src/runtimes/web/dom/script_request.ts
            class ScriptRequest {
                constructor(src){
                    this.src = src;
                }
                send(receiver) {
                    var self = this;
                    var errorString = "Error loading " + self.src;
                    self.script = document.createElement("script");
                    self.script.id = receiver.id;
                    self.script.src = self.src;
                    self.script.type = "text/javascript";
                    self.script.charset = "UTF-8";
                    if (self.script.addEventListener) {
                        self.script.onerror = function() {
                            receiver.callback(errorString);
                        };
                        self.script.onload = function() {
                            receiver.callback(null);
                        };
                    } else self.script.onreadystatechange = function() {
                        if (self.script.readyState === "loaded" || self.script.readyState === "complete") receiver.callback(null);
                    };
                    if (self.script.async === undefined && document.attachEvent && /opera/i.test(navigator.userAgent)) {
                        self.errorScript = document.createElement("script");
                        self.errorScript.id = receiver.id + "_error";
                        self.errorScript.text = receiver.name + "('" + errorString + "');";
                        self.script.async = self.errorScript.async = false;
                    } else self.script.async = true;
                    var head = document.getElementsByTagName("head")[0];
                    head.insertBefore(self.script, head.firstChild);
                    if (self.errorScript) head.insertBefore(self.errorScript, self.script.nextSibling);
                }
                cleanup() {
                    if (this.script) {
                        this.script.onload = this.script.onerror = null;
                        this.script.onreadystatechange = null;
                    }
                    if (this.script && this.script.parentNode) this.script.parentNode.removeChild(this.script);
                    if (this.errorScript && this.errorScript.parentNode) this.errorScript.parentNode.removeChild(this.errorScript);
                    this.script = null;
                    this.errorScript = null;
                }
            }
            // CONCATENATED MODULE: ./src/runtimes/web/dom/jsonp_request.ts
            class jsonp_request_JSONPRequest {
                constructor(url, data){
                    this.url = url;
                    this.data = data;
                }
                send(receiver) {
                    if (this.request) return;
                    var query = buildQueryString(this.data);
                    var url = this.url + "/" + receiver.number + "?" + query;
                    this.request = runtime.createScriptRequest(url);
                    this.request.send(receiver);
                }
                cleanup() {
                    if (this.request) this.request.cleanup();
                }
            }
            // CONCATENATED MODULE: ./src/runtimes/web/timeline/jsonp_timeline.ts
            var getAgent = function(sender, useTLS) {
                return function(data, callback) {
                    var scheme = "http" + (useTLS ? "s" : "") + "://";
                    var url = scheme + (sender.host || sender.options.host) + sender.options.path;
                    var request = runtime.createJSONPRequest(url, data);
                    var receiver = runtime.ScriptReceivers.create(function(error, result) {
                        ScriptReceivers.remove(receiver);
                        request.cleanup();
                        if (result && result.host) sender.host = result.host;
                        if (callback) callback(error, result);
                    });
                    request.send(receiver);
                };
            };
            var jsonp_timeline_jsonp = {
                name: "jsonp",
                getAgent: getAgent
            };
            /* harmony default export */ var jsonp_timeline = jsonp_timeline_jsonp;
            // CONCATENATED MODULE: ./src/core/transports/url_schemes.ts
            function getGenericURL(baseScheme, params, path) {
                var scheme = baseScheme + (params.useTLS ? "s" : "");
                var host = params.useTLS ? params.hostTLS : params.hostNonTLS;
                return scheme + "://" + host + path;
            }
            function getGenericPath(key, queryString) {
                var path = "/app/" + key;
                var query = "?protocol=" + defaults.PROTOCOL + "&client=js" + "&version=" + defaults.VERSION + (queryString ? "&" + queryString : "");
                return path + query;
            }
            var ws = {
                getInitial: function(key, params) {
                    var path = (params.httpPath || "") + getGenericPath(key, "flash=false");
                    return getGenericURL("ws", params, path);
                }
            };
            var http = {
                getInitial: function(key, params) {
                    var path = (params.httpPath || "/pusher") + getGenericPath(key);
                    return getGenericURL("http", params, path);
                }
            };
            var sockjs = {
                getInitial: function(key, params) {
                    return getGenericURL("http", params, params.httpPath || "/pusher");
                },
                getPath: function(key, params) {
                    return getGenericPath(key);
                }
            };
            // CONCATENATED MODULE: ./src/core/events/callback_registry.ts
            class callback_registry_CallbackRegistry {
                constructor(){
                    this._callbacks = {};
                }
                get(name) {
                    return this._callbacks[prefix(name)];
                }
                add(name, callback, context) {
                    var prefixedEventName = prefix(name);
                    this._callbacks[prefixedEventName] = this._callbacks[prefixedEventName] || [];
                    this._callbacks[prefixedEventName].push({
                        fn: callback,
                        context: context
                    });
                }
                remove(name, callback, context) {
                    if (!name && !callback && !context) {
                        this._callbacks = {};
                        return;
                    }
                    var names = name ? [
                        prefix(name)
                    ] : keys(this._callbacks);
                    if (callback || context) this.removeCallback(names, callback, context);
                    else this.removeAllCallbacks(names);
                }
                removeCallback(names, callback, context) {
                    apply(names, function(name) {
                        this._callbacks[name] = filter(this._callbacks[name] || [], function(binding) {
                            return callback && callback !== binding.fn || context && context !== binding.context;
                        });
                        if (this._callbacks[name].length === 0) delete this._callbacks[name];
                    }, this);
                }
                removeAllCallbacks(names) {
                    apply(names, function(name) {
                        delete this._callbacks[name];
                    }, this);
                }
            }
            function prefix(name) {
                return "_" + name;
            }
            // CONCATENATED MODULE: ./src/core/events/dispatcher.ts
            class dispatcher_Dispatcher {
                constructor(failThrough){
                    this.callbacks = new callback_registry_CallbackRegistry();
                    this.global_callbacks = [];
                    this.failThrough = failThrough;
                }
                bind(eventName, callback, context) {
                    this.callbacks.add(eventName, callback, context);
                    return this;
                }
                bind_global(callback) {
                    this.global_callbacks.push(callback);
                    return this;
                }
                unbind(eventName, callback, context) {
                    this.callbacks.remove(eventName, callback, context);
                    return this;
                }
                unbind_global(callback) {
                    if (!callback) {
                        this.global_callbacks = [];
                        return this;
                    }
                    this.global_callbacks = filter(this.global_callbacks || [], (c)=>c !== callback);
                    return this;
                }
                unbind_all() {
                    this.unbind();
                    this.unbind_global();
                    return this;
                }
                emit(eventName, data, metadata) {
                    for(var i = 0; i < this.global_callbacks.length; i++)this.global_callbacks[i](eventName, data);
                    var callbacks = this.callbacks.get(eventName);
                    var args = [];
                    if (metadata) args.push(data, metadata);
                    else if (data) args.push(data);
                    if (callbacks && callbacks.length > 0) for(var i = 0; i < callbacks.length; i++)callbacks[i].fn.apply(callbacks[i].context || window, args);
                    else if (this.failThrough) this.failThrough(eventName, data);
                    return this;
                }
            }
            // CONCATENATED MODULE: ./src/core/transports/transport_connection.ts
            class transport_connection_TransportConnection extends dispatcher_Dispatcher {
                constructor(hooks, name, priority, key, options){
                    super();
                    this.initialize = runtime.transportConnectionInitializer;
                    this.hooks = hooks;
                    this.name = name;
                    this.priority = priority;
                    this.key = key;
                    this.options = options;
                    this.state = "new";
                    this.timeline = options.timeline;
                    this.activityTimeout = options.activityTimeout;
                    this.id = this.timeline.generateUniqueID();
                }
                handlesActivityChecks() {
                    return Boolean(this.hooks.handlesActivityChecks);
                }
                supportsPing() {
                    return Boolean(this.hooks.supportsPing);
                }
                connect() {
                    if (this.socket || this.state !== "initialized") return false;
                    var url = this.hooks.urls.getInitial(this.key, this.options);
                    try {
                        this.socket = this.hooks.getSocket(url, this.options);
                    } catch (e) {
                        util.defer(()=>{
                            this.onError(e);
                            this.changeState("closed");
                        });
                        return false;
                    }
                    this.bindListeners();
                    logger.debug("Connecting", {
                        transport: this.name,
                        url: url
                    });
                    this.changeState("connecting");
                    return true;
                }
                close() {
                    if (this.socket) {
                        this.socket.close();
                        return true;
                    } else return false;
                }
                send(data) {
                    if (this.state === "open") {
                        util.defer(()=>{
                            if (this.socket) this.socket.send(data);
                        });
                        return true;
                    } else return false;
                }
                ping() {
                    if (this.state === "open" && this.supportsPing()) this.socket.ping();
                }
                onOpen() {
                    if (this.hooks.beforeOpen) this.hooks.beforeOpen(this.socket, this.hooks.urls.getPath(this.key, this.options));
                    this.changeState("open");
                    this.socket.onopen = undefined;
                }
                onError(error) {
                    this.emit("error", {
                        type: "WebSocketError",
                        error: error
                    });
                    this.timeline.error(this.buildTimelineMessage({
                        error: error.toString()
                    }));
                }
                onClose(closeEvent) {
                    if (closeEvent) this.changeState("closed", {
                        code: closeEvent.code,
                        reason: closeEvent.reason,
                        wasClean: closeEvent.wasClean
                    });
                    else this.changeState("closed");
                    this.unbindListeners();
                    this.socket = undefined;
                }
                onMessage(message) {
                    this.emit("message", message);
                }
                onActivity() {
                    this.emit("activity");
                }
                bindListeners() {
                    this.socket.onopen = ()=>{
                        this.onOpen();
                    };
                    this.socket.onerror = (error)=>{
                        this.onError(error);
                    };
                    this.socket.onclose = (closeEvent)=>{
                        this.onClose(closeEvent);
                    };
                    this.socket.onmessage = (message)=>{
                        this.onMessage(message);
                    };
                    if (this.supportsPing()) this.socket.onactivity = ()=>{
                        this.onActivity();
                    };
                }
                unbindListeners() {
                    if (this.socket) {
                        this.socket.onopen = undefined;
                        this.socket.onerror = undefined;
                        this.socket.onclose = undefined;
                        this.socket.onmessage = undefined;
                        if (this.supportsPing()) this.socket.onactivity = undefined;
                    }
                }
                changeState(state, params) {
                    this.state = state;
                    this.timeline.info(this.buildTimelineMessage({
                        state: state,
                        params: params
                    }));
                    this.emit(state, params);
                }
                buildTimelineMessage(message) {
                    return extend({
                        cid: this.id
                    }, message);
                }
            }
            // CONCATENATED MODULE: ./src/core/transports/transport.ts
            class transport_Transport {
                constructor(hooks){
                    this.hooks = hooks;
                }
                isSupported(environment) {
                    return this.hooks.isSupported(environment);
                }
                createConnection(name, priority, key, options) {
                    return new transport_connection_TransportConnection(this.hooks, name, priority, key, options);
                }
            }
            // CONCATENATED MODULE: ./src/runtimes/isomorphic/transports/transports.ts
            var WSTransport = new transport_Transport({
                urls: ws,
                handlesActivityChecks: false,
                supportsPing: false,
                isInitialized: function() {
                    return Boolean(runtime.getWebSocketAPI());
                },
                isSupported: function() {
                    return Boolean(runtime.getWebSocketAPI());
                },
                getSocket: function(url) {
                    return runtime.createWebSocket(url);
                }
            });
            var httpConfiguration = {
                urls: http,
                handlesActivityChecks: false,
                supportsPing: true,
                isInitialized: function() {
                    return true;
                }
            };
            var streamingConfiguration = extend({
                getSocket: function(url) {
                    return runtime.HTTPFactory.createStreamingSocket(url);
                }
            }, httpConfiguration);
            var pollingConfiguration = extend({
                getSocket: function(url) {
                    return runtime.HTTPFactory.createPollingSocket(url);
                }
            }, httpConfiguration);
            var xhrConfiguration = {
                isSupported: function() {
                    return runtime.isXHRSupported();
                }
            };
            var XHRStreamingTransport = new transport_Transport(extend({}, streamingConfiguration, xhrConfiguration));
            var XHRPollingTransport = new transport_Transport(extend({}, pollingConfiguration, xhrConfiguration));
            var Transports = {
                ws: WSTransport,
                xhr_streaming: XHRStreamingTransport,
                xhr_polling: XHRPollingTransport
            };
            /* harmony default export */ var transports = Transports;
            // CONCATENATED MODULE: ./src/runtimes/web/transports/transports.ts
            var SockJSTransport = new transport_Transport({
                file: "sockjs",
                urls: sockjs,
                handlesActivityChecks: true,
                supportsPing: false,
                isSupported: function() {
                    return true;
                },
                isInitialized: function() {
                    return window.SockJS !== undefined;
                },
                getSocket: function(url, options) {
                    return new window.SockJS(url, null, {
                        js_path: Dependencies.getPath("sockjs", {
                            useTLS: options.useTLS
                        }),
                        ignore_null_origin: options.ignoreNullOrigin
                    });
                },
                beforeOpen: function(socket, path) {
                    socket.send(JSON.stringify({
                        path: path
                    }));
                }
            });
            var xdrConfiguration = {
                isSupported: function(environment) {
                    var yes = runtime.isXDRSupported(environment.useTLS);
                    return yes;
                }
            };
            var XDRStreamingTransport = new transport_Transport(extend({}, streamingConfiguration, xdrConfiguration));
            var XDRPollingTransport = new transport_Transport(extend({}, pollingConfiguration, xdrConfiguration));
            transports.xdr_streaming = XDRStreamingTransport;
            transports.xdr_polling = XDRPollingTransport;
            transports.sockjs = SockJSTransport;
            /* harmony default export */ var transports_transports = transports;
            // CONCATENATED MODULE: ./src/runtimes/web/net_info.ts
            class net_info_NetInfo extends dispatcher_Dispatcher {
                constructor(){
                    super();
                    var self = this;
                    if (window.addEventListener !== undefined) {
                        window.addEventListener("online", function() {
                            self.emit("online");
                        }, false);
                        window.addEventListener("offline", function() {
                            self.emit("offline");
                        }, false);
                    }
                }
                isOnline() {
                    if (window.navigator.onLine === undefined) return true;
                    else return window.navigator.onLine;
                }
            }
            var net_info_Network = new net_info_NetInfo();
            // CONCATENATED MODULE: ./src/core/transports/assistant_to_the_transport_manager.ts
            class assistant_to_the_transport_manager_AssistantToTheTransportManager {
                constructor(manager, transport, options){
                    this.manager = manager;
                    this.transport = transport;
                    this.minPingDelay = options.minPingDelay;
                    this.maxPingDelay = options.maxPingDelay;
                    this.pingDelay = undefined;
                }
                createConnection(name, priority, key, options) {
                    options = extend({}, options, {
                        activityTimeout: this.pingDelay
                    });
                    var connection = this.transport.createConnection(name, priority, key, options);
                    var openTimestamp = null;
                    var onOpen = function() {
                        connection.unbind("open", onOpen);
                        connection.bind("closed", onClosed);
                        openTimestamp = util.now();
                    };
                    var onClosed = (closeEvent)=>{
                        connection.unbind("closed", onClosed);
                        if (closeEvent.code === 1002 || closeEvent.code === 1003) this.manager.reportDeath();
                        else if (!closeEvent.wasClean && openTimestamp) {
                            var lifespan = util.now() - openTimestamp;
                            if (lifespan < 2 * this.maxPingDelay) {
                                this.manager.reportDeath();
                                this.pingDelay = Math.max(lifespan / 2, this.minPingDelay);
                            }
                        }
                    };
                    connection.bind("open", onOpen);
                    return connection;
                }
                isSupported(environment) {
                    return this.manager.isAlive() && this.transport.isSupported(environment);
                }
            }
            // CONCATENATED MODULE: ./src/core/connection/protocol/protocol.ts
            const Protocol = {
                decodeMessage: function(messageEvent) {
                    try {
                        var messageData = JSON.parse(messageEvent.data);
                        var pusherEventData = messageData.data;
                        if (typeof pusherEventData === "string") try {
                            pusherEventData = JSON.parse(messageData.data);
                        } catch (e) {}
                        var pusherEvent = {
                            event: messageData.event,
                            channel: messageData.channel,
                            data: pusherEventData
                        };
                        if (messageData.user_id) pusherEvent.user_id = messageData.user_id;
                        return pusherEvent;
                    } catch (e) {
                        throw {
                            type: "MessageParseError",
                            error: e,
                            data: messageEvent.data
                        };
                    }
                },
                encodeMessage: function(event) {
                    return JSON.stringify(event);
                },
                processHandshake: function(messageEvent) {
                    var message = Protocol.decodeMessage(messageEvent);
                    if (message.event === "pusher:connection_established") {
                        if (!message.data.activity_timeout) throw "No activity timeout specified in handshake";
                        return {
                            action: "connected",
                            id: message.data.socket_id,
                            activityTimeout: message.data.activity_timeout * 1000
                        };
                    } else if (message.event === "pusher:error") return {
                        action: this.getCloseAction(message.data),
                        error: this.getCloseError(message.data)
                    };
                    else throw "Invalid handshake";
                },
                getCloseAction: function(closeEvent) {
                    if (closeEvent.code < 4000) {
                        if (closeEvent.code >= 1002 && closeEvent.code <= 1004) return "backoff";
                        else return null;
                    } else if (closeEvent.code === 4000) return "tls_only";
                    else if (closeEvent.code < 4100) return "refused";
                    else if (closeEvent.code < 4200) return "backoff";
                    else if (closeEvent.code < 4300) return "retry";
                    else return "refused";
                },
                getCloseError: function(closeEvent) {
                    if (closeEvent.code !== 1000 && closeEvent.code !== 1001) return {
                        type: "PusherError",
                        data: {
                            code: closeEvent.code,
                            message: closeEvent.reason || closeEvent.message
                        }
                    };
                    else return null;
                }
            };
            /* harmony default export */ var protocol_protocol = Protocol;
            // CONCATENATED MODULE: ./src/core/connection/connection.ts
            class connection_Connection extends dispatcher_Dispatcher {
                constructor(id, transport){
                    super();
                    this.id = id;
                    this.transport = transport;
                    this.activityTimeout = transport.activityTimeout;
                    this.bindListeners();
                }
                handlesActivityChecks() {
                    return this.transport.handlesActivityChecks();
                }
                send(data) {
                    return this.transport.send(data);
                }
                send_event(name, data, channel) {
                    var event = {
                        event: name,
                        data: data
                    };
                    if (channel) event.channel = channel;
                    logger.debug("Event sent", event);
                    return this.send(protocol_protocol.encodeMessage(event));
                }
                ping() {
                    if (this.transport.supportsPing()) this.transport.ping();
                    else this.send_event("pusher:ping", {});
                }
                close() {
                    this.transport.close();
                }
                bindListeners() {
                    var listeners = {
                        message: (messageEvent)=>{
                            var pusherEvent;
                            try {
                                pusherEvent = protocol_protocol.decodeMessage(messageEvent);
                            } catch (e) {
                                this.emit("error", {
                                    type: "MessageParseError",
                                    error: e,
                                    data: messageEvent.data
                                });
                            }
                            if (pusherEvent !== undefined) {
                                logger.debug("Event recd", pusherEvent);
                                switch(pusherEvent.event){
                                    case "pusher:error":
                                        this.emit("error", {
                                            type: "PusherError",
                                            data: pusherEvent.data
                                        });
                                        break;
                                    case "pusher:ping":
                                        this.emit("ping");
                                        break;
                                    case "pusher:pong":
                                        this.emit("pong");
                                        break;
                                }
                                this.emit("message", pusherEvent);
                            }
                        },
                        activity: ()=>{
                            this.emit("activity");
                        },
                        error: (error)=>{
                            this.emit("error", error);
                        },
                        closed: (closeEvent)=>{
                            unbindListeners();
                            if (closeEvent && closeEvent.code) this.handleCloseEvent(closeEvent);
                            this.transport = null;
                            this.emit("closed");
                        }
                    };
                    var unbindListeners = ()=>{
                        objectApply(listeners, (listener, event)=>{
                            this.transport.unbind(event, listener);
                        });
                    };
                    objectApply(listeners, (listener, event)=>{
                        this.transport.bind(event, listener);
                    });
                }
                handleCloseEvent(closeEvent) {
                    var action = protocol_protocol.getCloseAction(closeEvent);
                    var error = protocol_protocol.getCloseError(closeEvent);
                    if (error) this.emit("error", error);
                    if (action) this.emit(action, {
                        action: action,
                        error: error
                    });
                }
            }
            // CONCATENATED MODULE: ./src/core/connection/handshake/index.ts
            class handshake_Handshake {
                constructor(transport, callback){
                    this.transport = transport;
                    this.callback = callback;
                    this.bindListeners();
                }
                close() {
                    this.unbindListeners();
                    this.transport.close();
                }
                bindListeners() {
                    this.onMessage = (m)=>{
                        this.unbindListeners();
                        var result;
                        try {
                            result = protocol_protocol.processHandshake(m);
                        } catch (e) {
                            this.finish("error", {
                                error: e
                            });
                            this.transport.close();
                            return;
                        }
                        if (result.action === "connected") this.finish("connected", {
                            connection: new connection_Connection(result.id, this.transport),
                            activityTimeout: result.activityTimeout
                        });
                        else {
                            this.finish(result.action, {
                                error: result.error
                            });
                            this.transport.close();
                        }
                    };
                    this.onClosed = (closeEvent)=>{
                        this.unbindListeners();
                        var action = protocol_protocol.getCloseAction(closeEvent) || "backoff";
                        var error = protocol_protocol.getCloseError(closeEvent);
                        this.finish(action, {
                            error: error
                        });
                    };
                    this.transport.bind("message", this.onMessage);
                    this.transport.bind("closed", this.onClosed);
                }
                unbindListeners() {
                    this.transport.unbind("message", this.onMessage);
                    this.transport.unbind("closed", this.onClosed);
                }
                finish(action, params) {
                    this.callback(extend({
                        transport: this.transport,
                        action: action
                    }, params));
                }
            }
            // CONCATENATED MODULE: ./src/core/timeline/timeline_sender.ts
            class timeline_sender_TimelineSender {
                constructor(timeline, options){
                    this.timeline = timeline;
                    this.options = options || {};
                }
                send(useTLS, callback) {
                    if (this.timeline.isEmpty()) return;
                    this.timeline.send(runtime.TimelineTransport.getAgent(this, useTLS), callback);
                }
            }
            // CONCATENATED MODULE: ./src/core/channels/channel.ts
            class channel_Channel extends dispatcher_Dispatcher {
                constructor(name, pusher){
                    super(function(event, data) {
                        logger.debug("No callbacks on " + name + " for " + event);
                    });
                    this.name = name;
                    this.pusher = pusher;
                    this.subscribed = false;
                    this.subscriptionPending = false;
                    this.subscriptionCancelled = false;
                }
                authorize(socketId, callback) {
                    return callback(null, {
                        auth: ""
                    });
                }
                trigger(event, data) {
                    if (event.indexOf("client-") !== 0) throw new BadEventName("Event '" + event + "' does not start with 'client-'");
                    if (!this.subscribed) {
                        var suffix = url_store.buildLogSuffix("triggeringClientEvents");
                        logger.warn(`Client event triggered before channel 'subscription_succeeded' event . ${suffix}`);
                    }
                    return this.pusher.send_event(event, data, this.name);
                }
                disconnect() {
                    this.subscribed = false;
                    this.subscriptionPending = false;
                }
                handleEvent(event) {
                    var eventName = event.event;
                    var data = event.data;
                    if (eventName === "pusher_internal:subscription_succeeded") this.handleSubscriptionSucceededEvent(event);
                    else if (eventName === "pusher_internal:subscription_count") this.handleSubscriptionCountEvent(event);
                    else if (eventName.indexOf("pusher_internal:") !== 0) {
                        var metadata = {};
                        this.emit(eventName, data, metadata);
                    }
                }
                handleSubscriptionSucceededEvent(event) {
                    this.subscriptionPending = false;
                    this.subscribed = true;
                    if (this.subscriptionCancelled) this.pusher.unsubscribe(this.name);
                    else this.emit("pusher:subscription_succeeded", event.data);
                }
                handleSubscriptionCountEvent(event) {
                    if (event.data.subscription_count) this.subscriptionCount = event.data.subscription_count;
                    this.emit("pusher:subscription_count", event.data);
                }
                subscribe() {
                    if (this.subscribed) return;
                    this.subscriptionPending = true;
                    this.subscriptionCancelled = false;
                    this.authorize(this.pusher.connection.socket_id, (error, data)=>{
                        if (error) {
                            this.subscriptionPending = false;
                            logger.error(error.toString());
                            this.emit("pusher:subscription_error", Object.assign({}, {
                                type: "AuthError",
                                error: error.message
                            }, error instanceof HTTPAuthError ? {
                                status: error.status
                            } : {}));
                        } else this.pusher.send_event("pusher:subscribe", {
                            auth: data.auth,
                            channel_data: data.channel_data,
                            channel: this.name
                        });
                    });
                }
                unsubscribe() {
                    this.subscribed = false;
                    this.pusher.send_event("pusher:unsubscribe", {
                        channel: this.name
                    });
                }
                cancelSubscription() {
                    this.subscriptionCancelled = true;
                }
                reinstateSubscription() {
                    this.subscriptionCancelled = false;
                }
            }
            // CONCATENATED MODULE: ./src/core/channels/private_channel.ts
            class private_channel_PrivateChannel extends channel_Channel {
                authorize(socketId, callback) {
                    return this.pusher.config.channelAuthorizer({
                        channelName: this.name,
                        socketId: socketId
                    }, callback);
                }
            }
            // CONCATENATED MODULE: ./src/core/channels/members.ts
            class members_Members {
                constructor(){
                    this.reset();
                }
                get(id) {
                    if (Object.prototype.hasOwnProperty.call(this.members, id)) return {
                        id: id,
                        info: this.members[id]
                    };
                    else return null;
                }
                each(callback) {
                    objectApply(this.members, (member, id)=>{
                        callback(this.get(id));
                    });
                }
                setMyID(id) {
                    this.myID = id;
                }
                onSubscription(subscriptionData) {
                    this.members = subscriptionData.presence.hash;
                    this.count = subscriptionData.presence.count;
                    this.me = this.get(this.myID);
                }
                addMember(memberData) {
                    if (this.get(memberData.user_id) === null) this.count++;
                    this.members[memberData.user_id] = memberData.user_info;
                    return this.get(memberData.user_id);
                }
                removeMember(memberData) {
                    var member = this.get(memberData.user_id);
                    if (member) {
                        delete this.members[memberData.user_id];
                        this.count--;
                    }
                    return member;
                }
                reset() {
                    this.members = {};
                    this.count = 0;
                    this.myID = null;
                    this.me = null;
                }
            }
            // CONCATENATED MODULE: ./src/core/channels/presence_channel.ts
            var __awaiter = function(thisArg, _arguments, P, generator) {
                function adopt(value) {
                    return value instanceof P ? value : new P(function(resolve) {
                        resolve(value);
                    });
                }
                return new (P || (P = Promise))(function(resolve, reject) {
                    function fulfilled(value) {
                        try {
                            step(generator.next(value));
                        } catch (e) {
                            reject(e);
                        }
                    }
                    function rejected(value) {
                        try {
                            step(generator["throw"](value));
                        } catch (e) {
                            reject(e);
                        }
                    }
                    function step(result) {
                        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                    }
                    step((generator = generator.apply(thisArg, _arguments || [])).next());
                });
            };
            class presence_channel_PresenceChannel extends private_channel_PrivateChannel {
                constructor(name, pusher){
                    super(name, pusher);
                    this.members = new members_Members();
                }
                authorize(socketId, callback) {
                    super.authorize(socketId, (error, authData)=>__awaiter(this, void 0, void 0, function*() {
                            if (!error) {
                                authData;
                                if (authData.channel_data != null) {
                                    var channelData = JSON.parse(authData.channel_data);
                                    this.members.setMyID(channelData.user_id);
                                } else {
                                    yield this.pusher.user.signinDonePromise;
                                    if (this.pusher.user.user_data != null) this.members.setMyID(this.pusher.user.user_data.id);
                                    else {
                                        let suffix = url_store.buildLogSuffix("authorizationEndpoint");
                                        logger.error(`Invalid auth response for channel '${this.name}', ` + `expected 'channel_data' field. ${suffix}, ` + `or the user should be signed in.`);
                                        callback("Invalid auth response");
                                        return;
                                    }
                                }
                            }
                            callback(error, authData);
                        }));
                }
                handleEvent(event) {
                    var eventName = event.event;
                    if (eventName.indexOf("pusher_internal:") === 0) this.handleInternalEvent(event);
                    else {
                        var data = event.data;
                        var metadata = {};
                        if (event.user_id) metadata.user_id = event.user_id;
                        this.emit(eventName, data, metadata);
                    }
                }
                handleInternalEvent(event) {
                    var eventName = event.event;
                    var data = event.data;
                    switch(eventName){
                        case "pusher_internal:subscription_succeeded":
                            this.handleSubscriptionSucceededEvent(event);
                            break;
                        case "pusher_internal:subscription_count":
                            this.handleSubscriptionCountEvent(event);
                            break;
                        case "pusher_internal:member_added":
                            var addedMember = this.members.addMember(data);
                            this.emit("pusher:member_added", addedMember);
                            break;
                        case "pusher_internal:member_removed":
                            var removedMember = this.members.removeMember(data);
                            if (removedMember) this.emit("pusher:member_removed", removedMember);
                            break;
                    }
                }
                handleSubscriptionSucceededEvent(event) {
                    this.subscriptionPending = false;
                    this.subscribed = true;
                    if (this.subscriptionCancelled) this.pusher.unsubscribe(this.name);
                    else {
                        this.members.onSubscription(event.data);
                        this.emit("pusher:subscription_succeeded", this.members);
                    }
                }
                disconnect() {
                    this.members.reset();
                    super.disconnect();
                }
            }
            // EXTERNAL MODULE: ./node_modules/@stablelib/utf8/lib/utf8.js
            var utf8 = __webpack_require__(1);
            // EXTERNAL MODULE: ./node_modules/@stablelib/base64/lib/base64.js
            var base64 = __webpack_require__(0);
            // CONCATENATED MODULE: ./src/core/channels/encrypted_channel.ts
            class encrypted_channel_EncryptedChannel extends private_channel_PrivateChannel {
                constructor(name, pusher, nacl){
                    super(name, pusher);
                    this.key = null;
                    this.nacl = nacl;
                }
                authorize(socketId, callback) {
                    super.authorize(socketId, (error, authData)=>{
                        if (error) {
                            callback(error, authData);
                            return;
                        }
                        let sharedSecret = authData["shared_secret"];
                        if (!sharedSecret) {
                            callback(new Error(`No shared_secret key in auth payload for encrypted channel: ${this.name}`), null);
                            return;
                        }
                        this.key = Object(base64["decode"])(sharedSecret);
                        delete authData["shared_secret"];
                        callback(null, authData);
                    });
                }
                trigger(event, data) {
                    throw new UnsupportedFeature("Client events are not currently supported for encrypted channels");
                }
                handleEvent(event) {
                    var eventName = event.event;
                    var data = event.data;
                    if (eventName.indexOf("pusher_internal:") === 0 || eventName.indexOf("pusher:") === 0) {
                        super.handleEvent(event);
                        return;
                    }
                    this.handleEncryptedEvent(eventName, data);
                }
                handleEncryptedEvent(event, data) {
                    if (!this.key) {
                        logger.debug("Received encrypted event before key has been retrieved from the authEndpoint");
                        return;
                    }
                    if (!data.ciphertext || !data.nonce) {
                        logger.error("Unexpected format for encrypted event, expected object with `ciphertext` and `nonce` fields, got: " + data);
                        return;
                    }
                    let cipherText = Object(base64["decode"])(data.ciphertext);
                    if (cipherText.length < this.nacl.secretbox.overheadLength) {
                        logger.error(`Expected encrypted event ciphertext length to be ${this.nacl.secretbox.overheadLength}, got: ${cipherText.length}`);
                        return;
                    }
                    let nonce = Object(base64["decode"])(data.nonce);
                    if (nonce.length < this.nacl.secretbox.nonceLength) {
                        logger.error(`Expected encrypted event nonce length to be ${this.nacl.secretbox.nonceLength}, got: ${nonce.length}`);
                        return;
                    }
                    let bytes = this.nacl.secretbox.open(cipherText, nonce, this.key);
                    if (bytes === null) {
                        logger.debug("Failed to decrypt an event, probably because it was encrypted with a different key. Fetching a new key from the authEndpoint...");
                        this.authorize(this.pusher.connection.socket_id, (error, authData)=>{
                            if (error) {
                                logger.error(`Failed to make a request to the authEndpoint: ${authData}. Unable to fetch new key, so dropping encrypted event`);
                                return;
                            }
                            bytes = this.nacl.secretbox.open(cipherText, nonce, this.key);
                            if (bytes === null) {
                                logger.error(`Failed to decrypt event with new key. Dropping encrypted event`);
                                return;
                            }
                            this.emit(event, this.getDataToEmit(bytes));
                            return;
                        });
                        return;
                    }
                    this.emit(event, this.getDataToEmit(bytes));
                }
                getDataToEmit(bytes) {
                    let raw = Object(utf8["decode"])(bytes);
                    try {
                        return JSON.parse(raw);
                    } catch (_a) {
                        return raw;
                    }
                }
            }
            // CONCATENATED MODULE: ./src/core/connection/connection_manager.ts
            class connection_manager_ConnectionManager extends dispatcher_Dispatcher {
                constructor(key, options){
                    super();
                    this.state = "initialized";
                    this.connection = null;
                    this.key = key;
                    this.options = options;
                    this.timeline = this.options.timeline;
                    this.usingTLS = this.options.useTLS;
                    this.errorCallbacks = this.buildErrorCallbacks();
                    this.connectionCallbacks = this.buildConnectionCallbacks(this.errorCallbacks);
                    this.handshakeCallbacks = this.buildHandshakeCallbacks(this.errorCallbacks);
                    var Network = runtime.getNetwork();
                    Network.bind("online", ()=>{
                        this.timeline.info({
                            netinfo: "online"
                        });
                        if (this.state === "connecting" || this.state === "unavailable") this.retryIn(0);
                    });
                    Network.bind("offline", ()=>{
                        this.timeline.info({
                            netinfo: "offline"
                        });
                        if (this.connection) this.sendActivityCheck();
                    });
                    this.updateStrategy();
                }
                connect() {
                    if (this.connection || this.runner) return;
                    if (!this.strategy.isSupported()) {
                        this.updateState("failed");
                        return;
                    }
                    this.updateState("connecting");
                    this.startConnecting();
                    this.setUnavailableTimer();
                }
                send(data) {
                    if (this.connection) return this.connection.send(data);
                    else return false;
                }
                send_event(name, data, channel) {
                    if (this.connection) return this.connection.send_event(name, data, channel);
                    else return false;
                }
                disconnect() {
                    this.disconnectInternally();
                    this.updateState("disconnected");
                }
                isUsingTLS() {
                    return this.usingTLS;
                }
                startConnecting() {
                    var callback = (error, handshake)=>{
                        if (error) this.runner = this.strategy.connect(0, callback);
                        else if (handshake.action === "error") {
                            this.emit("error", {
                                type: "HandshakeError",
                                error: handshake.error
                            });
                            this.timeline.error({
                                handshakeError: handshake.error
                            });
                        } else {
                            this.abortConnecting();
                            this.handshakeCallbacks[handshake.action](handshake);
                        }
                    };
                    this.runner = this.strategy.connect(0, callback);
                }
                abortConnecting() {
                    if (this.runner) {
                        this.runner.abort();
                        this.runner = null;
                    }
                }
                disconnectInternally() {
                    this.abortConnecting();
                    this.clearRetryTimer();
                    this.clearUnavailableTimer();
                    if (this.connection) {
                        var connection = this.abandonConnection();
                        connection.close();
                    }
                }
                updateStrategy() {
                    this.strategy = this.options.getStrategy({
                        key: this.key,
                        timeline: this.timeline,
                        useTLS: this.usingTLS
                    });
                }
                retryIn(delay) {
                    this.timeline.info({
                        action: "retry",
                        delay: delay
                    });
                    if (delay > 0) this.emit("connecting_in", Math.round(delay / 1000));
                    this.retryTimer = new timers_OneOffTimer(delay || 0, ()=>{
                        this.disconnectInternally();
                        this.connect();
                    });
                }
                clearRetryTimer() {
                    if (this.retryTimer) {
                        this.retryTimer.ensureAborted();
                        this.retryTimer = null;
                    }
                }
                setUnavailableTimer() {
                    this.unavailableTimer = new timers_OneOffTimer(this.options.unavailableTimeout, ()=>{
                        this.updateState("unavailable");
                    });
                }
                clearUnavailableTimer() {
                    if (this.unavailableTimer) this.unavailableTimer.ensureAborted();
                }
                sendActivityCheck() {
                    this.stopActivityCheck();
                    this.connection.ping();
                    this.activityTimer = new timers_OneOffTimer(this.options.pongTimeout, ()=>{
                        this.timeline.error({
                            pong_timed_out: this.options.pongTimeout
                        });
                        this.retryIn(0);
                    });
                }
                resetActivityCheck() {
                    this.stopActivityCheck();
                    if (this.connection && !this.connection.handlesActivityChecks()) this.activityTimer = new timers_OneOffTimer(this.activityTimeout, ()=>{
                        this.sendActivityCheck();
                    });
                }
                stopActivityCheck() {
                    if (this.activityTimer) this.activityTimer.ensureAborted();
                }
                buildConnectionCallbacks(errorCallbacks) {
                    return extend({}, errorCallbacks, {
                        message: (message)=>{
                            this.resetActivityCheck();
                            this.emit("message", message);
                        },
                        ping: ()=>{
                            this.send_event("pusher:pong", {});
                        },
                        activity: ()=>{
                            this.resetActivityCheck();
                        },
                        error: (error)=>{
                            this.emit("error", error);
                        },
                        closed: ()=>{
                            this.abandonConnection();
                            if (this.shouldRetry()) this.retryIn(1000);
                        }
                    });
                }
                buildHandshakeCallbacks(errorCallbacks) {
                    return extend({}, errorCallbacks, {
                        connected: (handshake)=>{
                            this.activityTimeout = Math.min(this.options.activityTimeout, handshake.activityTimeout, handshake.connection.activityTimeout || Infinity);
                            this.clearUnavailableTimer();
                            this.setConnection(handshake.connection);
                            this.socket_id = this.connection.id;
                            this.updateState("connected", {
                                socket_id: this.socket_id
                            });
                        }
                    });
                }
                buildErrorCallbacks() {
                    let withErrorEmitted = (callback)=>{
                        return (result)=>{
                            if (result.error) this.emit("error", {
                                type: "WebSocketError",
                                error: result.error
                            });
                            callback(result);
                        };
                    };
                    return {
                        tls_only: withErrorEmitted(()=>{
                            this.usingTLS = true;
                            this.updateStrategy();
                            this.retryIn(0);
                        }),
                        refused: withErrorEmitted(()=>{
                            this.disconnect();
                        }),
                        backoff: withErrorEmitted(()=>{
                            this.retryIn(1000);
                        }),
                        retry: withErrorEmitted(()=>{
                            this.retryIn(0);
                        })
                    };
                }
                setConnection(connection) {
                    this.connection = connection;
                    for(var event in this.connectionCallbacks)this.connection.bind(event, this.connectionCallbacks[event]);
                    this.resetActivityCheck();
                }
                abandonConnection() {
                    if (!this.connection) return;
                    this.stopActivityCheck();
                    for(var event in this.connectionCallbacks)this.connection.unbind(event, this.connectionCallbacks[event]);
                    var connection = this.connection;
                    this.connection = null;
                    return connection;
                }
                updateState(newState, data) {
                    var previousState = this.state;
                    this.state = newState;
                    if (previousState !== newState) {
                        var newStateDescription = newState;
                        if (newStateDescription === "connected") newStateDescription += " with new socket ID " + data.socket_id;
                        logger.debug("State changed", previousState + " -> " + newStateDescription);
                        this.timeline.info({
                            state: newState,
                            params: data
                        });
                        this.emit("state_change", {
                            previous: previousState,
                            current: newState
                        });
                        this.emit(newState, data);
                    }
                }
                shouldRetry() {
                    return this.state === "connecting" || this.state === "connected";
                }
            }
            // CONCATENATED MODULE: ./src/core/channels/channels.ts
            class channels_Channels {
                constructor(){
                    this.channels = {};
                }
                add(name, pusher) {
                    if (!this.channels[name]) this.channels[name] = createChannel(name, pusher);
                    return this.channels[name];
                }
                all() {
                    return values(this.channels);
                }
                find(name) {
                    return this.channels[name];
                }
                remove(name) {
                    var channel = this.channels[name];
                    delete this.channels[name];
                    return channel;
                }
                disconnect() {
                    objectApply(this.channels, function(channel) {
                        channel.disconnect();
                    });
                }
            }
            function createChannel(name, pusher) {
                if (name.indexOf("private-encrypted-") === 0) {
                    if (pusher.config.nacl) return factory.createEncryptedChannel(name, pusher, pusher.config.nacl);
                    let errMsg = "Tried to subscribe to a private-encrypted- channel but no nacl implementation available";
                    let suffix = url_store.buildLogSuffix("encryptedChannelSupport");
                    throw new UnsupportedFeature(`${errMsg}. ${suffix}`);
                } else if (name.indexOf("private-") === 0) return factory.createPrivateChannel(name, pusher);
                else if (name.indexOf("presence-") === 0) return factory.createPresenceChannel(name, pusher);
                else if (name.indexOf("#") === 0) throw new BadChannelName('Cannot create a channel with name "' + name + '".');
                else return factory.createChannel(name, pusher);
            }
            // CONCATENATED MODULE: ./src/core/utils/factory.ts
            var Factory = {
                createChannels () {
                    return new channels_Channels();
                },
                createConnectionManager (key, options) {
                    return new connection_manager_ConnectionManager(key, options);
                },
                createChannel (name, pusher) {
                    return new channel_Channel(name, pusher);
                },
                createPrivateChannel (name, pusher) {
                    return new private_channel_PrivateChannel(name, pusher);
                },
                createPresenceChannel (name, pusher) {
                    return new presence_channel_PresenceChannel(name, pusher);
                },
                createEncryptedChannel (name, pusher, nacl) {
                    return new encrypted_channel_EncryptedChannel(name, pusher, nacl);
                },
                createTimelineSender (timeline, options) {
                    return new timeline_sender_TimelineSender(timeline, options);
                },
                createHandshake (transport, callback) {
                    return new handshake_Handshake(transport, callback);
                },
                createAssistantToTheTransportManager (manager, transport, options) {
                    return new assistant_to_the_transport_manager_AssistantToTheTransportManager(manager, transport, options);
                }
            };
            /* harmony default export */ var factory = Factory;
            // CONCATENATED MODULE: ./src/core/transports/transport_manager.ts
            class transport_manager_TransportManager {
                constructor(options){
                    this.options = options || {};
                    this.livesLeft = this.options.lives || Infinity;
                }
                getAssistant(transport) {
                    return factory.createAssistantToTheTransportManager(this, transport, {
                        minPingDelay: this.options.minPingDelay,
                        maxPingDelay: this.options.maxPingDelay
                    });
                }
                isAlive() {
                    return this.livesLeft > 0;
                }
                reportDeath() {
                    this.livesLeft -= 1;
                }
            }
            // CONCATENATED MODULE: ./src/core/strategies/sequential_strategy.ts
            class sequential_strategy_SequentialStrategy {
                constructor(strategies, options){
                    this.strategies = strategies;
                    this.loop = Boolean(options.loop);
                    this.failFast = Boolean(options.failFast);
                    this.timeout = options.timeout;
                    this.timeoutLimit = options.timeoutLimit;
                }
                isSupported() {
                    return any(this.strategies, util.method("isSupported"));
                }
                connect(minPriority, callback) {
                    var strategies = this.strategies;
                    var current = 0;
                    var timeout = this.timeout;
                    var runner = null;
                    var tryNextStrategy = (error, handshake)=>{
                        if (handshake) callback(null, handshake);
                        else {
                            current = current + 1;
                            if (this.loop) current = current % strategies.length;
                            if (current < strategies.length) {
                                if (timeout) {
                                    timeout = timeout * 2;
                                    if (this.timeoutLimit) timeout = Math.min(timeout, this.timeoutLimit);
                                }
                                runner = this.tryStrategy(strategies[current], minPriority, {
                                    timeout: timeout,
                                    failFast: this.failFast
                                }, tryNextStrategy);
                            } else callback(true);
                        }
                    };
                    runner = this.tryStrategy(strategies[current], minPriority, {
                        timeout: timeout,
                        failFast: this.failFast
                    }, tryNextStrategy);
                    return {
                        abort: function() {
                            runner.abort();
                        },
                        forceMinPriority: function(p) {
                            minPriority = p;
                            if (runner) runner.forceMinPriority(p);
                        }
                    };
                }
                tryStrategy(strategy, minPriority, options, callback) {
                    var timer = null;
                    var runner = null;
                    if (options.timeout > 0) timer = new timers_OneOffTimer(options.timeout, function() {
                        runner.abort();
                        callback(true);
                    });
                    runner = strategy.connect(minPriority, function(error, handshake) {
                        if (error && timer && timer.isRunning() && !options.failFast) return;
                        if (timer) timer.ensureAborted();
                        callback(error, handshake);
                    });
                    return {
                        abort: function() {
                            if (timer) timer.ensureAborted();
                            runner.abort();
                        },
                        forceMinPriority: function(p) {
                            runner.forceMinPriority(p);
                        }
                    };
                }
            }
            // CONCATENATED MODULE: ./src/core/strategies/best_connected_ever_strategy.ts
            class best_connected_ever_strategy_BestConnectedEverStrategy {
                constructor(strategies){
                    this.strategies = strategies;
                }
                isSupported() {
                    return any(this.strategies, util.method("isSupported"));
                }
                connect(minPriority, callback) {
                    return connect(this.strategies, minPriority, function(i, runners) {
                        return function(error, handshake) {
                            runners[i].error = error;
                            if (error) {
                                if (allRunnersFailed(runners)) callback(true);
                                return;
                            }
                            apply(runners, function(runner) {
                                runner.forceMinPriority(handshake.transport.priority);
                            });
                            callback(null, handshake);
                        };
                    });
                }
            }
            function connect(strategies, minPriority, callbackBuilder) {
                var runners = map(strategies, function(strategy, i, _, rs) {
                    return strategy.connect(minPriority, callbackBuilder(i, rs));
                });
                return {
                    abort: function() {
                        apply(runners, abortRunner);
                    },
                    forceMinPriority: function(p) {
                        apply(runners, function(runner) {
                            runner.forceMinPriority(p);
                        });
                    }
                };
            }
            function allRunnersFailed(runners) {
                return collections_all(runners, function(runner) {
                    return Boolean(runner.error);
                });
            }
            function abortRunner(runner) {
                if (!runner.error && !runner.aborted) {
                    runner.abort();
                    runner.aborted = true;
                }
            }
            // CONCATENATED MODULE: ./src/core/strategies/websocket_prioritized_cached_strategy.ts
            class websocket_prioritized_cached_strategy_WebSocketPrioritizedCachedStrategy {
                constructor(strategy, transports, options){
                    this.strategy = strategy;
                    this.transports = transports;
                    this.ttl = options.ttl || 1800000;
                    this.usingTLS = options.useTLS;
                    this.timeline = options.timeline;
                }
                isSupported() {
                    return this.strategy.isSupported();
                }
                connect(minPriority, callback) {
                    var usingTLS = this.usingTLS;
                    var info = fetchTransportCache(usingTLS);
                    var cacheSkipCount = info && info.cacheSkipCount ? info.cacheSkipCount : 0;
                    var strategies = [
                        this.strategy
                    ];
                    if (info && info.timestamp + this.ttl >= util.now()) {
                        var transport = this.transports[info.transport];
                        if (transport) {
                            if ([
                                "ws",
                                "wss"
                            ].includes(info.transport) || cacheSkipCount > 3) {
                                this.timeline.info({
                                    cached: true,
                                    transport: info.transport,
                                    latency: info.latency
                                });
                                strategies.push(new sequential_strategy_SequentialStrategy([
                                    transport
                                ], {
                                    timeout: info.latency * 2 + 1000,
                                    failFast: true
                                }));
                            } else cacheSkipCount++;
                        }
                    }
                    var startTimestamp = util.now();
                    var runner = strategies.pop().connect(minPriority, function cb(error, handshake) {
                        if (error) {
                            flushTransportCache(usingTLS);
                            if (strategies.length > 0) {
                                startTimestamp = util.now();
                                runner = strategies.pop().connect(minPriority, cb);
                            } else callback(error);
                        } else {
                            storeTransportCache(usingTLS, handshake.transport.name, util.now() - startTimestamp, cacheSkipCount);
                            callback(null, handshake);
                        }
                    });
                    return {
                        abort: function() {
                            runner.abort();
                        },
                        forceMinPriority: function(p) {
                            minPriority = p;
                            if (runner) runner.forceMinPriority(p);
                        }
                    };
                }
            }
            function getTransportCacheKey(usingTLS) {
                return "pusherTransport" + (usingTLS ? "TLS" : "NonTLS");
            }
            function fetchTransportCache(usingTLS) {
                var storage = runtime.getLocalStorage();
                if (storage) try {
                    var serializedCache = storage[getTransportCacheKey(usingTLS)];
                    if (serializedCache) return JSON.parse(serializedCache);
                } catch (e) {
                    flushTransportCache(usingTLS);
                }
                return null;
            }
            function storeTransportCache(usingTLS, transport, latency, cacheSkipCount) {
                var storage = runtime.getLocalStorage();
                if (storage) try {
                    storage[getTransportCacheKey(usingTLS)] = safeJSONStringify({
                        timestamp: util.now(),
                        transport: transport,
                        latency: latency,
                        cacheSkipCount: cacheSkipCount
                    });
                } catch (e) {}
            }
            function flushTransportCache(usingTLS) {
                var storage = runtime.getLocalStorage();
                if (storage) try {
                    delete storage[getTransportCacheKey(usingTLS)];
                } catch (e) {}
            }
            // CONCATENATED MODULE: ./src/core/strategies/delayed_strategy.ts
            class delayed_strategy_DelayedStrategy {
                constructor(strategy, { delay: number }){
                    this.strategy = strategy;
                    this.options = {
                        delay: number
                    };
                }
                isSupported() {
                    return this.strategy.isSupported();
                }
                connect(minPriority, callback) {
                    var strategy = this.strategy;
                    var runner;
                    var timer = new timers_OneOffTimer(this.options.delay, function() {
                        runner = strategy.connect(minPriority, callback);
                    });
                    return {
                        abort: function() {
                            timer.ensureAborted();
                            if (runner) runner.abort();
                        },
                        forceMinPriority: function(p) {
                            minPriority = p;
                            if (runner) runner.forceMinPriority(p);
                        }
                    };
                }
            }
            // CONCATENATED MODULE: ./src/core/strategies/if_strategy.ts
            class IfStrategy {
                constructor(test, trueBranch, falseBranch){
                    this.test = test;
                    this.trueBranch = trueBranch;
                    this.falseBranch = falseBranch;
                }
                isSupported() {
                    var branch = this.test() ? this.trueBranch : this.falseBranch;
                    return branch.isSupported();
                }
                connect(minPriority, callback) {
                    var branch = this.test() ? this.trueBranch : this.falseBranch;
                    return branch.connect(minPriority, callback);
                }
            }
            // CONCATENATED MODULE: ./src/core/strategies/first_connected_strategy.ts
            class FirstConnectedStrategy {
                constructor(strategy){
                    this.strategy = strategy;
                }
                isSupported() {
                    return this.strategy.isSupported();
                }
                connect(minPriority, callback) {
                    var runner = this.strategy.connect(minPriority, function(error, handshake) {
                        if (handshake) runner.abort();
                        callback(error, handshake);
                    });
                    return runner;
                }
            }
            // CONCATENATED MODULE: ./src/runtimes/web/default_strategy.ts
            function testSupportsStrategy(strategy) {
                return function() {
                    return strategy.isSupported();
                };
            }
            var getDefaultStrategy = function(config, baseOptions, defineTransport) {
                var definedTransports = {};
                function defineTransportStrategy(name, type, priority, options, manager) {
                    var transport = defineTransport(config, name, type, priority, options, manager);
                    definedTransports[name] = transport;
                    return transport;
                }
                var ws_options = Object.assign({}, baseOptions, {
                    hostNonTLS: config.wsHost + ":" + config.wsPort,
                    hostTLS: config.wsHost + ":" + config.wssPort,
                    httpPath: config.wsPath
                });
                var wss_options = Object.assign({}, ws_options, {
                    useTLS: true
                });
                var sockjs_options = Object.assign({}, baseOptions, {
                    hostNonTLS: config.httpHost + ":" + config.httpPort,
                    hostTLS: config.httpHost + ":" + config.httpsPort,
                    httpPath: config.httpPath
                });
                var timeouts = {
                    loop: true,
                    timeout: 15000,
                    timeoutLimit: 60000
                };
                var ws_manager = new transport_manager_TransportManager({
                    minPingDelay: 10000,
                    maxPingDelay: config.activityTimeout
                });
                var streaming_manager = new transport_manager_TransportManager({
                    lives: 2,
                    minPingDelay: 10000,
                    maxPingDelay: config.activityTimeout
                });
                var ws_transport = defineTransportStrategy("ws", "ws", 3, ws_options, ws_manager);
                var wss_transport = defineTransportStrategy("wss", "ws", 3, wss_options, ws_manager);
                var sockjs_transport = defineTransportStrategy("sockjs", "sockjs", 1, sockjs_options);
                var xhr_streaming_transport = defineTransportStrategy("xhr_streaming", "xhr_streaming", 1, sockjs_options, streaming_manager);
                var xdr_streaming_transport = defineTransportStrategy("xdr_streaming", "xdr_streaming", 1, sockjs_options, streaming_manager);
                var xhr_polling_transport = defineTransportStrategy("xhr_polling", "xhr_polling", 1, sockjs_options);
                var xdr_polling_transport = defineTransportStrategy("xdr_polling", "xdr_polling", 1, sockjs_options);
                var ws_loop = new sequential_strategy_SequentialStrategy([
                    ws_transport
                ], timeouts);
                var wss_loop = new sequential_strategy_SequentialStrategy([
                    wss_transport
                ], timeouts);
                var sockjs_loop = new sequential_strategy_SequentialStrategy([
                    sockjs_transport
                ], timeouts);
                var streaming_loop = new sequential_strategy_SequentialStrategy([
                    new IfStrategy(testSupportsStrategy(xhr_streaming_transport), xhr_streaming_transport, xdr_streaming_transport)
                ], timeouts);
                var polling_loop = new sequential_strategy_SequentialStrategy([
                    new IfStrategy(testSupportsStrategy(xhr_polling_transport), xhr_polling_transport, xdr_polling_transport)
                ], timeouts);
                var http_loop = new sequential_strategy_SequentialStrategy([
                    new IfStrategy(testSupportsStrategy(streaming_loop), new best_connected_ever_strategy_BestConnectedEverStrategy([
                        streaming_loop,
                        new delayed_strategy_DelayedStrategy(polling_loop, {
                            delay: 4000
                        })
                    ]), polling_loop)
                ], timeouts);
                var http_fallback_loop = new IfStrategy(testSupportsStrategy(http_loop), http_loop, sockjs_loop);
                var wsStrategy;
                if (baseOptions.useTLS) wsStrategy = new best_connected_ever_strategy_BestConnectedEverStrategy([
                    ws_loop,
                    new delayed_strategy_DelayedStrategy(http_fallback_loop, {
                        delay: 2000
                    })
                ]);
                else wsStrategy = new best_connected_ever_strategy_BestConnectedEverStrategy([
                    ws_loop,
                    new delayed_strategy_DelayedStrategy(wss_loop, {
                        delay: 2000
                    }),
                    new delayed_strategy_DelayedStrategy(http_fallback_loop, {
                        delay: 5000
                    })
                ]);
                return new websocket_prioritized_cached_strategy_WebSocketPrioritizedCachedStrategy(new FirstConnectedStrategy(new IfStrategy(testSupportsStrategy(ws_transport), wsStrategy, http_fallback_loop)), definedTransports, {
                    ttl: 1800000,
                    timeline: baseOptions.timeline,
                    useTLS: baseOptions.useTLS
                });
            };
            /* harmony default export */ var default_strategy = getDefaultStrategy;
            // CONCATENATED MODULE: ./src/runtimes/web/transports/transport_connection_initializer.ts
            /* harmony default export */ var transport_connection_initializer = function() {
                var self = this;
                self.timeline.info(self.buildTimelineMessage({
                    transport: self.name + (self.options.useTLS ? "s" : "")
                }));
                if (self.hooks.isInitialized()) self.changeState("initialized");
                else if (self.hooks.file) {
                    self.changeState("initializing");
                    Dependencies.load(self.hooks.file, {
                        useTLS: self.options.useTLS
                    }, function(error, callback) {
                        if (self.hooks.isInitialized()) {
                            self.changeState("initialized");
                            callback(true);
                        } else {
                            if (error) self.onError(error);
                            self.onClose();
                            callback(false);
                        }
                    });
                } else self.onClose();
            };
            // CONCATENATED MODULE: ./src/runtimes/web/http/http_xdomain_request.ts
            var http_xdomain_request_hooks = {
                getRequest: function(socket) {
                    var xdr = new window.XDomainRequest();
                    xdr.ontimeout = function() {
                        socket.emit("error", new RequestTimedOut());
                        socket.close();
                    };
                    xdr.onerror = function(e) {
                        socket.emit("error", e);
                        socket.close();
                    };
                    xdr.onprogress = function() {
                        if (xdr.responseText && xdr.responseText.length > 0) socket.onChunk(200, xdr.responseText);
                    };
                    xdr.onload = function() {
                        if (xdr.responseText && xdr.responseText.length > 0) socket.onChunk(200, xdr.responseText);
                        socket.emit("finished", 200);
                        socket.close();
                    };
                    return xdr;
                },
                abortRequest: function(xdr) {
                    xdr.ontimeout = xdr.onerror = xdr.onprogress = xdr.onload = null;
                    xdr.abort();
                }
            };
            /* harmony default export */ var http_xdomain_request = http_xdomain_request_hooks;
            // CONCATENATED MODULE: ./src/core/http/http_request.ts
            const MAX_BUFFER_LENGTH = 262144;
            class http_request_HTTPRequest extends dispatcher_Dispatcher {
                constructor(hooks, method, url){
                    super();
                    this.hooks = hooks;
                    this.method = method;
                    this.url = url;
                }
                start(payload) {
                    this.position = 0;
                    this.xhr = this.hooks.getRequest(this);
                    this.unloader = ()=>{
                        this.close();
                    };
                    runtime.addUnloadListener(this.unloader);
                    this.xhr.open(this.method, this.url, true);
                    if (this.xhr.setRequestHeader) this.xhr.setRequestHeader("Content-Type", "application/json");
                    this.xhr.send(payload);
                }
                close() {
                    if (this.unloader) {
                        runtime.removeUnloadListener(this.unloader);
                        this.unloader = null;
                    }
                    if (this.xhr) {
                        this.hooks.abortRequest(this.xhr);
                        this.xhr = null;
                    }
                }
                onChunk(status, data) {
                    while(true){
                        var chunk = this.advanceBuffer(data);
                        if (chunk) this.emit("chunk", {
                            status: status,
                            data: chunk
                        });
                        else break;
                    }
                    if (this.isBufferTooLong(data)) this.emit("buffer_too_long");
                }
                advanceBuffer(buffer) {
                    var unreadData = buffer.slice(this.position);
                    var endOfLinePosition = unreadData.indexOf("\n");
                    if (endOfLinePosition !== -1) {
                        this.position += endOfLinePosition + 1;
                        return unreadData.slice(0, endOfLinePosition);
                    } else return null;
                }
                isBufferTooLong(buffer) {
                    return this.position === buffer.length && buffer.length > MAX_BUFFER_LENGTH;
                }
            }
            // CONCATENATED MODULE: ./src/core/http/state.ts
            var State;
            (function(State) {
                State[State["CONNECTING"] = 0] = "CONNECTING";
                State[State["OPEN"] = 1] = "OPEN";
                State[State["CLOSED"] = 3] = "CLOSED";
            })(State || (State = {}));
            /* harmony default export */ var state = State;
            // CONCATENATED MODULE: ./src/core/http/http_socket.ts
            var autoIncrement = 1;
            class http_socket_HTTPSocket {
                constructor(hooks, url){
                    this.hooks = hooks;
                    this.session = randomNumber(1000) + "/" + randomString(8);
                    this.location = getLocation(url);
                    this.readyState = state.CONNECTING;
                    this.openStream();
                }
                send(payload) {
                    return this.sendRaw(JSON.stringify([
                        payload
                    ]));
                }
                ping() {
                    this.hooks.sendHeartbeat(this);
                }
                close(code, reason) {
                    this.onClose(code, reason, true);
                }
                sendRaw(payload) {
                    if (this.readyState === state.OPEN) try {
                        runtime.createSocketRequest("POST", getUniqueURL(getSendURL(this.location, this.session))).start(payload);
                        return true;
                    } catch (e) {
                        return false;
                    }
                    else return false;
                }
                reconnect() {
                    this.closeStream();
                    this.openStream();
                }
                onClose(code, reason, wasClean) {
                    this.closeStream();
                    this.readyState = state.CLOSED;
                    if (this.onclose) this.onclose({
                        code: code,
                        reason: reason,
                        wasClean: wasClean
                    });
                }
                onChunk(chunk) {
                    if (chunk.status !== 200) return;
                    if (this.readyState === state.OPEN) this.onActivity();
                    var payload;
                    var type = chunk.data.slice(0, 1);
                    switch(type){
                        case "o":
                            payload = JSON.parse(chunk.data.slice(1) || "{}");
                            this.onOpen(payload);
                            break;
                        case "a":
                            payload = JSON.parse(chunk.data.slice(1) || "[]");
                            for(var i = 0; i < payload.length; i++)this.onEvent(payload[i]);
                            break;
                        case "m":
                            payload = JSON.parse(chunk.data.slice(1) || "null");
                            this.onEvent(payload);
                            break;
                        case "h":
                            this.hooks.onHeartbeat(this);
                            break;
                        case "c":
                            payload = JSON.parse(chunk.data.slice(1) || "[]");
                            this.onClose(payload[0], payload[1], true);
                            break;
                    }
                }
                onOpen(options) {
                    if (this.readyState === state.CONNECTING) {
                        if (options && options.hostname) this.location.base = replaceHost(this.location.base, options.hostname);
                        this.readyState = state.OPEN;
                        if (this.onopen) this.onopen();
                    } else this.onClose(1006, "Server lost session", true);
                }
                onEvent(event) {
                    if (this.readyState === state.OPEN && this.onmessage) this.onmessage({
                        data: event
                    });
                }
                onActivity() {
                    if (this.onactivity) this.onactivity();
                }
                onError(error) {
                    if (this.onerror) this.onerror(error);
                }
                openStream() {
                    this.stream = runtime.createSocketRequest("POST", getUniqueURL(this.hooks.getReceiveURL(this.location, this.session)));
                    this.stream.bind("chunk", (chunk)=>{
                        this.onChunk(chunk);
                    });
                    this.stream.bind("finished", (status)=>{
                        this.hooks.onFinished(this, status);
                    });
                    this.stream.bind("buffer_too_long", ()=>{
                        this.reconnect();
                    });
                    try {
                        this.stream.start();
                    } catch (error) {
                        util.defer(()=>{
                            this.onError(error);
                            this.onClose(1006, "Could not start streaming", false);
                        });
                    }
                }
                closeStream() {
                    if (this.stream) {
                        this.stream.unbind_all();
                        this.stream.close();
                        this.stream = null;
                    }
                }
            }
            function getLocation(url) {
                var parts = /([^\?]*)\/*(\??.*)/.exec(url);
                return {
                    base: parts[1],
                    queryString: parts[2]
                };
            }
            function getSendURL(url, session) {
                return url.base + "/" + session + "/xhr_send";
            }
            function getUniqueURL(url) {
                var separator = url.indexOf("?") === -1 ? "?" : "&";
                return url + separator + "t=" + +new Date() + "&n=" + autoIncrement++;
            }
            function replaceHost(url, hostname) {
                var urlParts = /(https?:\/\/)([^\/:]+)((\/|:)?.*)/.exec(url);
                return urlParts[1] + hostname + urlParts[3];
            }
            function randomNumber(max) {
                return runtime.randomInt(max);
            }
            function randomString(length) {
                var result = [];
                for(var i = 0; i < length; i++)result.push(randomNumber(32).toString(32));
                return result.join("");
            }
            /* harmony default export */ var http_socket = http_socket_HTTPSocket;
            // CONCATENATED MODULE: ./src/core/http/http_streaming_socket.ts
            var http_streaming_socket_hooks = {
                getReceiveURL: function(url, session) {
                    return url.base + "/" + session + "/xhr_streaming" + url.queryString;
                },
                onHeartbeat: function(socket) {
                    socket.sendRaw("[]");
                },
                sendHeartbeat: function(socket) {
                    socket.sendRaw("[]");
                },
                onFinished: function(socket, status) {
                    socket.onClose(1006, "Connection interrupted (" + status + ")", false);
                }
            };
            /* harmony default export */ var http_streaming_socket = http_streaming_socket_hooks;
            // CONCATENATED MODULE: ./src/core/http/http_polling_socket.ts
            var http_polling_socket_hooks = {
                getReceiveURL: function(url, session) {
                    return url.base + "/" + session + "/xhr" + url.queryString;
                },
                onHeartbeat: function() {},
                sendHeartbeat: function(socket) {
                    socket.sendRaw("[]");
                },
                onFinished: function(socket, status) {
                    if (status === 200) socket.reconnect();
                    else socket.onClose(1006, "Connection interrupted (" + status + ")", false);
                }
            };
            /* harmony default export */ var http_polling_socket = http_polling_socket_hooks;
            // CONCATENATED MODULE: ./src/runtimes/isomorphic/http/http_xhr_request.ts
            var http_xhr_request_hooks = {
                getRequest: function(socket) {
                    var Constructor = runtime.getXHRAPI();
                    var xhr = new Constructor();
                    xhr.onreadystatechange = xhr.onprogress = function() {
                        switch(xhr.readyState){
                            case 3:
                                if (xhr.responseText && xhr.responseText.length > 0) socket.onChunk(xhr.status, xhr.responseText);
                                break;
                            case 4:
                                if (xhr.responseText && xhr.responseText.length > 0) socket.onChunk(xhr.status, xhr.responseText);
                                socket.emit("finished", xhr.status);
                                socket.close();
                                break;
                        }
                    };
                    return xhr;
                },
                abortRequest: function(xhr) {
                    xhr.onreadystatechange = null;
                    xhr.abort();
                }
            };
            /* harmony default export */ var http_xhr_request = http_xhr_request_hooks;
            // CONCATENATED MODULE: ./src/runtimes/isomorphic/http/http.ts
            var HTTP = {
                createStreamingSocket (url) {
                    return this.createSocket(http_streaming_socket, url);
                },
                createPollingSocket (url) {
                    return this.createSocket(http_polling_socket, url);
                },
                createSocket (hooks, url) {
                    return new http_socket(hooks, url);
                },
                createXHR (method, url) {
                    return this.createRequest(http_xhr_request, method, url);
                },
                createRequest (hooks, method, url) {
                    return new http_request_HTTPRequest(hooks, method, url);
                }
            };
            /* harmony default export */ var http_http = HTTP;
            // CONCATENATED MODULE: ./src/runtimes/web/http/http.ts
            http_http.createXDR = function(method, url) {
                return this.createRequest(http_xdomain_request, method, url);
            };
            /* harmony default export */ var web_http_http = http_http;
            // CONCATENATED MODULE: ./src/runtimes/web/runtime.ts
            var Runtime = {
                nextAuthCallbackID: 1,
                auth_callbacks: {},
                ScriptReceivers: ScriptReceivers,
                DependenciesReceivers: DependenciesReceivers,
                getDefaultStrategy: default_strategy,
                Transports: transports_transports,
                transportConnectionInitializer: transport_connection_initializer,
                HTTPFactory: web_http_http,
                TimelineTransport: jsonp_timeline,
                getXHRAPI () {
                    return window.XMLHttpRequest;
                },
                getWebSocketAPI () {
                    return window.WebSocket || window.MozWebSocket;
                },
                setup (PusherClass) {
                    window.Pusher = PusherClass;
                    var initializeOnDocumentBody = ()=>{
                        this.onDocumentBody(PusherClass.ready);
                    };
                    if (!window.JSON) Dependencies.load("json2", {}, initializeOnDocumentBody);
                    else initializeOnDocumentBody();
                },
                getDocument () {
                    return document;
                },
                getProtocol () {
                    return this.getDocument().location.protocol;
                },
                getAuthorizers () {
                    return {
                        ajax: xhr_auth,
                        jsonp: jsonp_auth
                    };
                },
                onDocumentBody (callback) {
                    if (document.body) callback();
                    else setTimeout(()=>{
                        this.onDocumentBody(callback);
                    }, 0);
                },
                createJSONPRequest (url, data) {
                    return new jsonp_request_JSONPRequest(url, data);
                },
                createScriptRequest (src) {
                    return new ScriptRequest(src);
                },
                getLocalStorage () {
                    try {
                        return window.localStorage;
                    } catch (e) {
                        return undefined;
                    }
                },
                createXHR () {
                    if (this.getXHRAPI()) return this.createXMLHttpRequest();
                    else return this.createMicrosoftXHR();
                },
                createXMLHttpRequest () {
                    var Constructor = this.getXHRAPI();
                    return new Constructor();
                },
                createMicrosoftXHR () {
                    return new ActiveXObject("Microsoft.XMLHTTP");
                },
                getNetwork () {
                    return net_info_Network;
                },
                createWebSocket (url) {
                    var Constructor = this.getWebSocketAPI();
                    return new Constructor(url);
                },
                createSocketRequest (method, url) {
                    if (this.isXHRSupported()) return this.HTTPFactory.createXHR(method, url);
                    else if (this.isXDRSupported(url.indexOf("https:") === 0)) return this.HTTPFactory.createXDR(method, url);
                    else throw "Cross-origin HTTP requests are not supported";
                },
                isXHRSupported () {
                    var Constructor = this.getXHRAPI();
                    return Boolean(Constructor) && new Constructor().withCredentials !== undefined;
                },
                isXDRSupported (useTLS) {
                    var protocol = useTLS ? "https:" : "http:";
                    var documentProtocol = this.getProtocol();
                    return Boolean(window["XDomainRequest"]) && documentProtocol === protocol;
                },
                addUnloadListener (listener) {
                    if (window.addEventListener !== undefined) window.addEventListener("unload", listener, false);
                    else if (window.attachEvent !== undefined) window.attachEvent("onunload", listener);
                },
                removeUnloadListener (listener) {
                    if (window.addEventListener !== undefined) window.removeEventListener("unload", listener, false);
                    else if (window.detachEvent !== undefined) window.detachEvent("onunload", listener);
                },
                randomInt (max) {
                    const random = function() {
                        const crypto = window.crypto || window["msCrypto"];
                        const random = crypto.getRandomValues(new Uint32Array(1))[0];
                        return random / Math.pow(2, 32);
                    };
                    return Math.floor(random() * max);
                }
            };
            /* harmony default export */ var runtime = Runtime;
            // CONCATENATED MODULE: ./src/core/timeline/level.ts
            var TimelineLevel;
            (function(TimelineLevel) {
                TimelineLevel[TimelineLevel["ERROR"] = 3] = "ERROR";
                TimelineLevel[TimelineLevel["INFO"] = 6] = "INFO";
                TimelineLevel[TimelineLevel["DEBUG"] = 7] = "DEBUG";
            })(TimelineLevel || (TimelineLevel = {}));
            /* harmony default export */ var timeline_level = TimelineLevel;
            // CONCATENATED MODULE: ./src/core/timeline/timeline.ts
            class timeline_Timeline {
                constructor(key, session, options){
                    this.key = key;
                    this.session = session;
                    this.events = [];
                    this.options = options || {};
                    this.sent = 0;
                    this.uniqueID = 0;
                }
                log(level, event) {
                    if (level <= this.options.level) {
                        this.events.push(extend({}, event, {
                            timestamp: util.now()
                        }));
                        if (this.options.limit && this.events.length > this.options.limit) this.events.shift();
                    }
                }
                error(event) {
                    this.log(timeline_level.ERROR, event);
                }
                info(event) {
                    this.log(timeline_level.INFO, event);
                }
                debug(event) {
                    this.log(timeline_level.DEBUG, event);
                }
                isEmpty() {
                    return this.events.length === 0;
                }
                send(sendfn, callback) {
                    var data = extend({
                        session: this.session,
                        bundle: this.sent + 1,
                        key: this.key,
                        lib: "js",
                        version: this.options.version,
                        cluster: this.options.cluster,
                        features: this.options.features,
                        timeline: this.events
                    }, this.options.params);
                    this.events = [];
                    sendfn(data, (error, result)=>{
                        if (!error) this.sent++;
                        if (callback) callback(error, result);
                    });
                    return true;
                }
                generateUniqueID() {
                    this.uniqueID++;
                    return this.uniqueID;
                }
            }
            // CONCATENATED MODULE: ./src/core/strategies/transport_strategy.ts
            class transport_strategy_TransportStrategy {
                constructor(name, priority, transport, options){
                    this.name = name;
                    this.priority = priority;
                    this.transport = transport;
                    this.options = options || {};
                }
                isSupported() {
                    return this.transport.isSupported({
                        useTLS: this.options.useTLS
                    });
                }
                connect(minPriority, callback) {
                    if (!this.isSupported()) return failAttempt(new UnsupportedStrategy(), callback);
                    else if (this.priority < minPriority) return failAttempt(new TransportPriorityTooLow(), callback);
                    var connected = false;
                    var transport = this.transport.createConnection(this.name, this.priority, this.options.key, this.options);
                    var handshake = null;
                    var onInitialized = function() {
                        transport.unbind("initialized", onInitialized);
                        transport.connect();
                    };
                    var onOpen = function() {
                        handshake = factory.createHandshake(transport, function(result) {
                            connected = true;
                            unbindListeners();
                            callback(null, result);
                        });
                    };
                    var onError = function(error) {
                        unbindListeners();
                        callback(error);
                    };
                    var onClosed = function() {
                        unbindListeners();
                        var serializedTransport;
                        serializedTransport = safeJSONStringify(transport);
                        callback(new TransportClosed(serializedTransport));
                    };
                    var unbindListeners = function() {
                        transport.unbind("initialized", onInitialized);
                        transport.unbind("open", onOpen);
                        transport.unbind("error", onError);
                        transport.unbind("closed", onClosed);
                    };
                    transport.bind("initialized", onInitialized);
                    transport.bind("open", onOpen);
                    transport.bind("error", onError);
                    transport.bind("closed", onClosed);
                    transport.initialize();
                    return {
                        abort: ()=>{
                            if (connected) return;
                            unbindListeners();
                            if (handshake) handshake.close();
                            else transport.close();
                        },
                        forceMinPriority: (p)=>{
                            if (connected) return;
                            if (this.priority < p) {
                                if (handshake) handshake.close();
                                else transport.close();
                            }
                        }
                    };
                }
            }
            function failAttempt(error, callback) {
                util.defer(function() {
                    callback(error);
                });
                return {
                    abort: function() {},
                    forceMinPriority: function() {}
                };
            }
            // CONCATENATED MODULE: ./src/core/strategies/strategy_builder.ts
            const { Transports: strategy_builder_Transports } = runtime;
            var strategy_builder_defineTransport = function(config, name, type, priority, options, manager) {
                var transportClass = strategy_builder_Transports[type];
                if (!transportClass) throw new UnsupportedTransport(type);
                var enabled = (!config.enabledTransports || arrayIndexOf(config.enabledTransports, name) !== -1) && (!config.disabledTransports || arrayIndexOf(config.disabledTransports, name) === -1);
                var transport;
                if (enabled) {
                    options = Object.assign({
                        ignoreNullOrigin: config.ignoreNullOrigin
                    }, options);
                    transport = new transport_strategy_TransportStrategy(name, priority, manager ? manager.getAssistant(transportClass) : transportClass, options);
                } else transport = strategy_builder_UnsupportedStrategy;
                return transport;
            };
            var strategy_builder_UnsupportedStrategy = {
                isSupported: function() {
                    return false;
                },
                connect: function(_, callback) {
                    var deferred = util.defer(function() {
                        callback(new UnsupportedStrategy());
                    });
                    return {
                        abort: function() {
                            deferred.ensureAborted();
                        },
                        forceMinPriority: function() {}
                    };
                }
            };
            // CONCATENATED MODULE: ./src/core/options.ts
            function validateOptions(options) {
                if (options == null) throw "You must pass an options object";
                if (options.cluster == null) throw "Options object must provide a cluster";
                if ("disableStats" in options) logger.warn("The disableStats option is deprecated in favor of enableStats");
            }
            // CONCATENATED MODULE: ./src/core/auth/user_authenticator.ts
            const composeChannelQuery = (params, authOptions)=>{
                var query = "socket_id=" + encodeURIComponent(params.socketId);
                for(var key in authOptions.params)query += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(authOptions.params[key]);
                if (authOptions.paramsProvider != null) {
                    let dynamicParams = authOptions.paramsProvider();
                    for(var key in dynamicParams)query += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(dynamicParams[key]);
                }
                return query;
            };
            const UserAuthenticator = (authOptions)=>{
                if (typeof runtime.getAuthorizers()[authOptions.transport] === "undefined") throw `'${authOptions.transport}' is not a recognized auth transport`;
                return (params, callback)=>{
                    const query = composeChannelQuery(params, authOptions);
                    runtime.getAuthorizers()[authOptions.transport](runtime, query, authOptions, AuthRequestType.UserAuthentication, callback);
                };
            };
            /* harmony default export */ var user_authenticator = UserAuthenticator;
            // CONCATENATED MODULE: ./src/core/auth/channel_authorizer.ts
            const channel_authorizer_composeChannelQuery = (params, authOptions)=>{
                var query = "socket_id=" + encodeURIComponent(params.socketId);
                query += "&channel_name=" + encodeURIComponent(params.channelName);
                for(var key in authOptions.params)query += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(authOptions.params[key]);
                if (authOptions.paramsProvider != null) {
                    let dynamicParams = authOptions.paramsProvider();
                    for(var key in dynamicParams)query += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(dynamicParams[key]);
                }
                return query;
            };
            const ChannelAuthorizer = (authOptions)=>{
                if (typeof runtime.getAuthorizers()[authOptions.transport] === "undefined") throw `'${authOptions.transport}' is not a recognized auth transport`;
                return (params, callback)=>{
                    const query = channel_authorizer_composeChannelQuery(params, authOptions);
                    runtime.getAuthorizers()[authOptions.transport](runtime, query, authOptions, AuthRequestType.ChannelAuthorization, callback);
                };
            };
            /* harmony default export */ var channel_authorizer = ChannelAuthorizer;
            // CONCATENATED MODULE: ./src/core/auth/deprecated_channel_authorizer.ts
            const ChannelAuthorizerProxy = (pusher, authOptions, channelAuthorizerGenerator)=>{
                const deprecatedAuthorizerOptions = {
                    authTransport: authOptions.transport,
                    authEndpoint: authOptions.endpoint,
                    auth: {
                        params: authOptions.params,
                        headers: authOptions.headers
                    }
                };
                return (params, callback)=>{
                    const channel = pusher.channel(params.channelName);
                    const channelAuthorizer = channelAuthorizerGenerator(channel, deprecatedAuthorizerOptions);
                    channelAuthorizer.authorize(params.socketId, callback);
                };
            };
            // CONCATENATED MODULE: ./src/core/config.ts
            function getConfig(opts, pusher) {
                let config = {
                    activityTimeout: opts.activityTimeout || defaults.activityTimeout,
                    cluster: opts.cluster,
                    httpPath: opts.httpPath || defaults.httpPath,
                    httpPort: opts.httpPort || defaults.httpPort,
                    httpsPort: opts.httpsPort || defaults.httpsPort,
                    pongTimeout: opts.pongTimeout || defaults.pongTimeout,
                    statsHost: opts.statsHost || defaults.stats_host,
                    unavailableTimeout: opts.unavailableTimeout || defaults.unavailableTimeout,
                    wsPath: opts.wsPath || defaults.wsPath,
                    wsPort: opts.wsPort || defaults.wsPort,
                    wssPort: opts.wssPort || defaults.wssPort,
                    enableStats: getEnableStatsConfig(opts),
                    httpHost: getHttpHost(opts),
                    useTLS: shouldUseTLS(opts),
                    wsHost: getWebsocketHost(opts),
                    userAuthenticator: buildUserAuthenticator(opts),
                    channelAuthorizer: buildChannelAuthorizer(opts, pusher)
                };
                if ("disabledTransports" in opts) config.disabledTransports = opts.disabledTransports;
                if ("enabledTransports" in opts) config.enabledTransports = opts.enabledTransports;
                if ("ignoreNullOrigin" in opts) config.ignoreNullOrigin = opts.ignoreNullOrigin;
                if ("timelineParams" in opts) config.timelineParams = opts.timelineParams;
                if ("nacl" in opts) config.nacl = opts.nacl;
                return config;
            }
            function getHttpHost(opts) {
                if (opts.httpHost) return opts.httpHost;
                if (opts.cluster) return `sockjs-${opts.cluster}.pusher.com`;
                return defaults.httpHost;
            }
            function getWebsocketHost(opts) {
                if (opts.wsHost) return opts.wsHost;
                return getWebsocketHostFromCluster(opts.cluster);
            }
            function getWebsocketHostFromCluster(cluster) {
                return `ws-${cluster}.pusher.com`;
            }
            function shouldUseTLS(opts) {
                if (runtime.getProtocol() === "https:") return true;
                else if (opts.forceTLS === false) return false;
                return true;
            }
            function getEnableStatsConfig(opts) {
                if ("enableStats" in opts) return opts.enableStats;
                if ("disableStats" in opts) return !opts.disableStats;
                return false;
            }
            function buildUserAuthenticator(opts) {
                const userAuthentication = Object.assign(Object.assign({}, defaults.userAuthentication), opts.userAuthentication);
                if ("customHandler" in userAuthentication && userAuthentication["customHandler"] != null) return userAuthentication["customHandler"];
                return user_authenticator(userAuthentication);
            }
            function buildChannelAuth(opts, pusher) {
                let channelAuthorization;
                if ("channelAuthorization" in opts) channelAuthorization = Object.assign(Object.assign({}, defaults.channelAuthorization), opts.channelAuthorization);
                else {
                    channelAuthorization = {
                        transport: opts.authTransport || defaults.authTransport,
                        endpoint: opts.authEndpoint || defaults.authEndpoint
                    };
                    if ("auth" in opts) {
                        if ("params" in opts.auth) channelAuthorization.params = opts.auth.params;
                        if ("headers" in opts.auth) channelAuthorization.headers = opts.auth.headers;
                    }
                    if ("authorizer" in opts) channelAuthorization.customHandler = ChannelAuthorizerProxy(pusher, channelAuthorization, opts.authorizer);
                }
                return channelAuthorization;
            }
            function buildChannelAuthorizer(opts, pusher) {
                const channelAuthorization = buildChannelAuth(opts, pusher);
                if ("customHandler" in channelAuthorization && channelAuthorization["customHandler"] != null) return channelAuthorization["customHandler"];
                return channel_authorizer(channelAuthorization);
            }
            // CONCATENATED MODULE: ./src/core/watchlist.ts
            class watchlist_WatchlistFacade extends dispatcher_Dispatcher {
                constructor(pusher){
                    super(function(eventName, data) {
                        logger.debug(`No callbacks on watchlist events for ${eventName}`);
                    });
                    this.pusher = pusher;
                    this.bindWatchlistInternalEvent();
                }
                handleEvent(pusherEvent) {
                    pusherEvent.data.events.forEach((watchlistEvent)=>{
                        this.emit(watchlistEvent.name, watchlistEvent);
                    });
                }
                bindWatchlistInternalEvent() {
                    this.pusher.connection.bind("message", (pusherEvent)=>{
                        var eventName = pusherEvent.event;
                        if (eventName === "pusher_internal:watchlist_events") this.handleEvent(pusherEvent);
                    });
                }
            }
            // CONCATENATED MODULE: ./src/core/utils/flat_promise.ts
            function flatPromise() {
                let resolve, reject;
                const promise = new Promise((res, rej)=>{
                    resolve = res;
                    reject = rej;
                });
                return {
                    promise: promise,
                    resolve: resolve,
                    reject: reject
                };
            }
            /* harmony default export */ var flat_promise = flatPromise;
            // CONCATENATED MODULE: ./src/core/user.ts
            class user_UserFacade extends dispatcher_Dispatcher {
                constructor(pusher){
                    super(function(eventName, data) {
                        logger.debug("No callbacks on user for " + eventName);
                    });
                    this.signin_requested = false;
                    this.user_data = null;
                    this.serverToUserChannel = null;
                    this.signinDonePromise = null;
                    this._signinDoneResolve = null;
                    this._onAuthorize = (err, authData)=>{
                        if (err) {
                            logger.warn(`Error during signin: ${err}`);
                            this._cleanup();
                            return;
                        }
                        this.pusher.send_event("pusher:signin", {
                            auth: authData.auth,
                            user_data: authData.user_data
                        });
                    };
                    this.pusher = pusher;
                    this.pusher.connection.bind("state_change", ({ previous: previous, current: current })=>{
                        if (previous !== "connected" && current === "connected") this._signin();
                        if (previous === "connected" && current !== "connected") {
                            this._cleanup();
                            this._newSigninPromiseIfNeeded();
                        }
                    });
                    this.watchlist = new watchlist_WatchlistFacade(pusher);
                    this.pusher.connection.bind("message", (event)=>{
                        var eventName = event.event;
                        if (eventName === "pusher:signin_success") this._onSigninSuccess(event.data);
                        if (this.serverToUserChannel && this.serverToUserChannel.name === event.channel) this.serverToUserChannel.handleEvent(event);
                    });
                }
                signin() {
                    if (this.signin_requested) return;
                    this.signin_requested = true;
                    this._signin();
                }
                _signin() {
                    if (!this.signin_requested) return;
                    this._newSigninPromiseIfNeeded();
                    if (this.pusher.connection.state !== "connected") return;
                    this.pusher.config.userAuthenticator({
                        socketId: this.pusher.connection.socket_id
                    }, this._onAuthorize);
                }
                _onSigninSuccess(data) {
                    try {
                        this.user_data = JSON.parse(data.user_data);
                    } catch (e) {
                        logger.error(`Failed parsing user data after signin: ${data.user_data}`);
                        this._cleanup();
                        return;
                    }
                    if (typeof this.user_data.id !== "string" || this.user_data.id === "") {
                        logger.error(`user_data doesn't contain an id. user_data: ${this.user_data}`);
                        this._cleanup();
                        return;
                    }
                    this._signinDoneResolve();
                    this._subscribeChannels();
                }
                _subscribeChannels() {
                    const ensure_subscribed = (channel)=>{
                        if (channel.subscriptionPending && channel.subscriptionCancelled) channel.reinstateSubscription();
                        else if (!channel.subscriptionPending && this.pusher.connection.state === "connected") channel.subscribe();
                    };
                    this.serverToUserChannel = new channel_Channel(`#server-to-user-${this.user_data.id}`, this.pusher);
                    this.serverToUserChannel.bind_global((eventName, data)=>{
                        if (eventName.indexOf("pusher_internal:") === 0 || eventName.indexOf("pusher:") === 0) return;
                        this.emit(eventName, data);
                    });
                    ensure_subscribed(this.serverToUserChannel);
                }
                _cleanup() {
                    this.user_data = null;
                    if (this.serverToUserChannel) {
                        this.serverToUserChannel.unbind_all();
                        this.serverToUserChannel.disconnect();
                        this.serverToUserChannel = null;
                    }
                    if (this.signin_requested) this._signinDoneResolve();
                }
                _newSigninPromiseIfNeeded() {
                    if (!this.signin_requested) return;
                    if (this.signinDonePromise && !this.signinDonePromise.done) return;
                    const { promise: promise, resolve: resolve, reject: _ } = flat_promise();
                    promise.done = false;
                    const setDone = ()=>{
                        promise.done = true;
                    };
                    promise.then(setDone).catch(setDone);
                    this.signinDonePromise = promise;
                    this._signinDoneResolve = resolve;
                }
            }
            // CONCATENATED MODULE: ./src/core/pusher.ts
            class pusher_Pusher {
                static ready() {
                    pusher_Pusher.isReady = true;
                    for(var i = 0, l = pusher_Pusher.instances.length; i < l; i++)pusher_Pusher.instances[i].connect();
                }
                static getClientFeatures() {
                    return keys(filterObject({
                        ws: runtime.Transports.ws
                    }, function(t) {
                        return t.isSupported({});
                    }));
                }
                constructor(app_key, options){
                    checkAppKey(app_key);
                    validateOptions(options);
                    this.key = app_key;
                    this.config = getConfig(options, this);
                    this.channels = factory.createChannels();
                    this.global_emitter = new dispatcher_Dispatcher();
                    this.sessionID = runtime.randomInt(1000000000);
                    this.timeline = new timeline_Timeline(this.key, this.sessionID, {
                        cluster: this.config.cluster,
                        features: pusher_Pusher.getClientFeatures(),
                        params: this.config.timelineParams || {},
                        limit: 50,
                        level: timeline_level.INFO,
                        version: defaults.VERSION
                    });
                    if (this.config.enableStats) this.timelineSender = factory.createTimelineSender(this.timeline, {
                        host: this.config.statsHost,
                        path: "/timeline/v2/" + runtime.TimelineTransport.name
                    });
                    var getStrategy = (options)=>{
                        return runtime.getDefaultStrategy(this.config, options, strategy_builder_defineTransport);
                    };
                    this.connection = factory.createConnectionManager(this.key, {
                        getStrategy: getStrategy,
                        timeline: this.timeline,
                        activityTimeout: this.config.activityTimeout,
                        pongTimeout: this.config.pongTimeout,
                        unavailableTimeout: this.config.unavailableTimeout,
                        useTLS: Boolean(this.config.useTLS)
                    });
                    this.connection.bind("connected", ()=>{
                        this.subscribeAll();
                        if (this.timelineSender) this.timelineSender.send(this.connection.isUsingTLS());
                    });
                    this.connection.bind("message", (event)=>{
                        var eventName = event.event;
                        var internal = eventName.indexOf("pusher_internal:") === 0;
                        if (event.channel) {
                            var channel = this.channel(event.channel);
                            if (channel) channel.handleEvent(event);
                        }
                        if (!internal) this.global_emitter.emit(event.event, event.data);
                    });
                    this.connection.bind("connecting", ()=>{
                        this.channels.disconnect();
                    });
                    this.connection.bind("disconnected", ()=>{
                        this.channels.disconnect();
                    });
                    this.connection.bind("error", (err)=>{
                        logger.warn(err);
                    });
                    pusher_Pusher.instances.push(this);
                    this.timeline.info({
                        instances: pusher_Pusher.instances.length
                    });
                    this.user = new user_UserFacade(this);
                    if (pusher_Pusher.isReady) this.connect();
                }
                channel(name) {
                    return this.channels.find(name);
                }
                allChannels() {
                    return this.channels.all();
                }
                connect() {
                    this.connection.connect();
                    if (this.timelineSender) {
                        if (!this.timelineSenderTimer) {
                            var usingTLS = this.connection.isUsingTLS();
                            var timelineSender = this.timelineSender;
                            this.timelineSenderTimer = new timers_PeriodicTimer(60000, function() {
                                timelineSender.send(usingTLS);
                            });
                        }
                    }
                }
                disconnect() {
                    this.connection.disconnect();
                    if (this.timelineSenderTimer) {
                        this.timelineSenderTimer.ensureAborted();
                        this.timelineSenderTimer = null;
                    }
                }
                bind(event_name, callback, context) {
                    this.global_emitter.bind(event_name, callback, context);
                    return this;
                }
                unbind(event_name, callback, context) {
                    this.global_emitter.unbind(event_name, callback, context);
                    return this;
                }
                bind_global(callback) {
                    this.global_emitter.bind_global(callback);
                    return this;
                }
                unbind_global(callback) {
                    this.global_emitter.unbind_global(callback);
                    return this;
                }
                unbind_all(callback) {
                    this.global_emitter.unbind_all();
                    return this;
                }
                subscribeAll() {
                    var channelName;
                    for(channelName in this.channels.channels)if (this.channels.channels.hasOwnProperty(channelName)) this.subscribe(channelName);
                }
                subscribe(channel_name) {
                    var channel = this.channels.add(channel_name, this);
                    if (channel.subscriptionPending && channel.subscriptionCancelled) channel.reinstateSubscription();
                    else if (!channel.subscriptionPending && this.connection.state === "connected") channel.subscribe();
                    return channel;
                }
                unsubscribe(channel_name) {
                    var channel = this.channels.find(channel_name);
                    if (channel && channel.subscriptionPending) channel.cancelSubscription();
                    else {
                        channel = this.channels.remove(channel_name);
                        if (channel && channel.subscribed) channel.unsubscribe();
                    }
                }
                send_event(event_name, data, channel) {
                    return this.connection.send_event(event_name, data, channel);
                }
                shouldUseTLS() {
                    return this.config.useTLS;
                }
                signin() {
                    this.user.signin();
                }
            }
            pusher_Pusher.instances = [];
            pusher_Pusher.isReady = false;
            pusher_Pusher.logToConsole = false;
            pusher_Pusher.Runtime = runtime;
            pusher_Pusher.ScriptReceivers = runtime.ScriptReceivers;
            pusher_Pusher.DependenciesReceivers = runtime.DependenciesReceivers;
            pusher_Pusher.auth_callbacks = runtime.auth_callbacks;
            /* harmony default export */ var core_pusher = __webpack_exports__["default"] = pusher_Pusher;
            function checkAppKey(key) {
                if (key === null || key === undefined) throw "You must pass your app key when you instantiate Pusher.";
            }
            runtime.setup(pusher_Pusher);
        /***/ }
    ]);
});

});



parcelRegister("cnp7l", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $902b1dd7af5a602f$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");

var $lxg9c = parcelRequire("lxg9c");

var $kuPRw = parcelRequire("kuPRw");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $7qobO = parcelRequire("7qobO");

var $4iw5i = parcelRequire("4iw5i");

var $5PXcS = parcelRequire("5PXcS");
const $902b1dd7af5a602f$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_private/impersonate/$email")({
    beforeLoad: ({ params: params })=>{
        if (!(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "impersonate", params)) throw new Error("Permission Denied");
    },
    errorComponent: ({ error: error, reset: reset })=>{
        if (error.message === "Permission Denied") return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7qobO.default), {});
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    },
    component: $902b1dd7af5a602f$var$Wrapper,
    pendingComponent: (0, $4iw5i.default)
});
function $902b1dd7af5a602f$var$Wrapper() {
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kuPRw.default), {
            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $lxg9c.default), {
                ...$902b1dd7af5a602f$export$e7b0ac011bb776c6.useParams(),
                ...$902b1dd7af5a602f$export$e7b0ac011bb776c6.useSearch()
            })
        })
    });
}

});
parcelRegister("lxg9c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fad93494b907b241$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $1BTI2 = parcelRequire("1BTI2");

var $iKbxs = parcelRequire("iKbxs");

var $6UBLf = parcelRequire("6UBLf");

var $8kZ1o = parcelRequire("8kZ1o");

var $3H03w = parcelRequire("3H03w");
var $fad93494b907b241$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ email: email, redirect: redirect })=>{
    const navigate = (0, $6UBLf.useNavigate)();
    const [impersonateState, setImpersonateState] = (0, $jbmdS.useState)("idle");
    (0, $jbmdS.useEffect)(()=>{
        (0, $1BTI2.default).impersonate(email).then(()=>{
            setImpersonateState("success");
            navigate({
                to: redirect || ((0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "projectList") ? "/projects" : "/timesheets"),
                replace: true
            });
        }).catch(function(error) {
            $iKbxs.captureException(error);
            (0, $3H03w.default).captureException(error);
            setImpersonateState("error");
        });
    }, []);
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "flex flex-align-items-center flex-justify-content-center",
        style: {
            alignSelf: "center",
            textAlign: "center"
        },
        children: impersonateState !== "error" ? `Impersonating ${email}...` : "Impersonate Failed"
    });
});

});


parcelRegister("blRVa", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $843b7b748ca635b3$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");
var $64Yjc = parcelRequire("64Yjc");

var $6Yxbs = parcelRequire("6Yxbs");

var $8nWKI = parcelRequire("8nWKI");

var $kuPRw = parcelRequire("kuPRw");

var $47i9t = parcelRequire("47i9t");

var $4iw5i = parcelRequire("4iw5i");

var $5PXcS = parcelRequire("5PXcS");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $7qobO = parcelRequire("7qobO");

var $fM2j4 = parcelRequire("fM2j4");

var $6Q5sp = parcelRequire("6Q5sp");

var $eNcHX = parcelRequire("eNcHX");

var $kqntg = parcelRequire("kqntg");

var $3h7sC = parcelRequire("3h7sC");
const $843b7b748ca635b3$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_private/cost-centres/$id")({
    beforeLoad: ({ params: params })=>{
        if (!(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "costCentre", params)) throw new Error("Permission Denied");
    },
    errorComponent: ({ error: error, reset: reset })=>{
        if (error.message === "Permission Denied") return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7qobO.default), {});
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    },
    loader: async ({ params: params })=>await $843b7b748ca635b3$var$loader(params.id),
    pendingComponent: (0, $4iw5i.default),
    component: $843b7b748ca635b3$var$Wrapper,
    onLeave: (match)=>{
        const { id: id } = match.params;
        const costCentre = (0, $eNcHX.default).costCentresById[id];
        if (!(costCentre !== null && costCentre !== void 0 && costCentre.createdAt) && match.pathname !== (0, $6Q5sp.router).latestLocation.pathname) (0, $fM2j4.default).destroyNewItems("costCentreId", id);
    }
});
const $843b7b748ca635b3$var$loader = async (id)=>{
    const data = await (0, $3h7sC.trpc).legacy.getCostCentrePageData.query({
        costCentreId: id
    });
    const processedModels = (0, $47i9t.processTRPCData)(data);
    const costCentre = (0, $eNcHX.default).costCentresById[id];
    if (!costCentre) throw (0, $64Yjc.notFound)();
    return processedModels;
};
function $843b7b748ca635b3$var$Wrapper() {
    const { id: id } = $843b7b748ca635b3$export$e7b0ac011bb776c6.useParams();
    if ((0, $8kZ1o.migratedToV2)()) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqntg.CenterPadPageBody), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8nWKI.default), {
            costCentreId: id
        })
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6Yxbs.default), {
                id: id
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kuPRw.default), {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $8nWKI.default), {
                    id: id
                })
            })
        ]
    });
}

});
parcelRegister("6Yxbs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $514216480a8ce2e3$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $36Jjh = parcelRequire("36Jjh");

var $eNcHX = parcelRequire("eNcHX");
var $514216480a8ce2e3$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ extraContent: extraContent, id: id })=>{
    const costCentre = (0, $eNcHX.default).costCentresById[id];
    if (!costCentre) return null;
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $36Jjh.default), {
        heading: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: (costCentre === null || costCentre === void 0 ? void 0 : costCentre.name) || "New Cost Centre"
            })
        }),
        rightButtons: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
            children: /*#__PURE__*/ (0, $61Ea1.jsxs)("button", {
                className: "btn btn-default edit-controls__delete-button",
                onClick: ()=>null,
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                        className: "fa fa-trash"
                    }),
                    "Delete"
                ]
            })
        }),
        extraContent: extraContent
    });
});

});

parcelRegister("8nWKI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61ae0bb8e3a9f0a0$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $eNcHX = parcelRequire("eNcHX");
var $61ae0bb8e3a9f0a0$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ id: id })=>{
    const isAtLeastPM = true;
    const isAtLeastAdmin = true;
    const costCentre = (0, $eNcHX.default).costCentresById[id];
    if (!costCentre) return null;
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        children: costCentre.name
    });
});

});


parcelRegister("9lWnL", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $6cf35cba43069d67$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");
var $64Yjc = parcelRequire("64Yjc");

var $9vAP3 = parcelRequire("9vAP3");

var $d0Xu4 = parcelRequire("d0Xu4");

var $619oG = parcelRequire("619oG");

var $kuPRw = parcelRequire("kuPRw");

var $4iw5i = parcelRequire("4iw5i");

var $5PXcS = parcelRequire("5PXcS");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $7qobO = parcelRequire("7qobO");
parcelRequire("fM2j4");

var $6Q5sp = parcelRequire("6Q5sp");

var $bhvQG = parcelRequire("bhvQG");

var $26sX2 = parcelRequire("26sX2");

var $38AIP = parcelRequire("38AIP");

var $kqntg = parcelRequire("kqntg");

var $3h7sC = parcelRequire("3h7sC");

var $2BlDy = parcelRequire("2BlDy");

var $47i9t = parcelRequire("47i9t");

var $6l5Kr = parcelRequire("6l5Kr");
const $6cf35cba43069d67$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_private/contacts/$id")({
    beforeLoad: ({ params: params })=>{
        var _contact$firstName, _contact$lastName;
        if (!(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "contact", params)) throw new Error("Permission Denied");
        const contact = (0, $38AIP.getCacheItemById)("contacts", params.id);
        (0, $26sX2.setLayoutDefaults)({
            pageTitle: contact ? `${(_contact$firstName = contact === null || contact === void 0 ? void 0 : contact.firstName) !== null && _contact$firstName !== void 0 ? _contact$firstName : ""} ${(_contact$lastName = contact === null || contact === void 0 ? void 0 : contact.lastName) !== null && _contact$lastName !== void 0 ? _contact$lastName : ""} (${contact === null || contact === void 0 ? void 0 : contact.organisationName})` : "Contact",
            subMenu: "clients"
        });
    },
    errorComponent: ({ error: error, reset: reset })=>{
        if (error.message === "Permission Denied") return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7qobO.default), {});
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    },
    loader: async ({ params: params })=>await $6cf35cba43069d67$var$loader(params.id),
    pendingComponent: (0, $4iw5i.default),
    component: $6cf35cba43069d67$var$Wrapper,
    onLeave: (match)=>{
        const { id: id } = match.params;
        const contact = (0, $bhvQG.default).contactsById[id];
        if (contact && !contact.createdAt && match.pathname !== (0, $6Q5sp.router).latestLocation.pathname) (0, $6l5Kr.cleanupNewEntity)(contact, "contact");
    }
});
const $6cf35cba43069d67$var$loader = async (id)=>{
    const data = await (0, $3h7sC.trpc).legacy.getContactPageData.query({
        id: id
    });
    const processedModels = (0, $47i9t.processTRPCData)(data);
    const contact = (0, $bhvQG.default).contactsById[id];
    if (!contact) throw (0, $64Yjc.notFound)();
    return processedModels;
};
function $6cf35cba43069d67$var$Wrapper() {
    const { id: id } = $6cf35cba43069d67$export$e7b0ac011bb776c6.useParams();
    // The store now handles all the save toast logic internally
    (0, $2BlDy.contactStore).useSaveHandler();
    if ((0, $8kZ1o.migratedToV2)()) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqntg.CenterPadPageBody), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $619oG.ContactPage), {
            contactId: id
        })
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $9vAP3.default), {
                id: id
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kuPRw.default), {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $d0Xu4.default), {
                    contactId: id
                })
            })
        ]
    });
}

});
parcelRegister("9vAP3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ec39280dbe7c247$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $36Jjh = parcelRequire("36Jjh");

var $bhvQG = parcelRequire("bhvQG");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $7WkWs = parcelRequire("7WkWs");

var $khJQv = parcelRequire("khJQv");
var $6ec39280dbe7c247$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ id: id, extraContent: extraContent })=>{
    const contact = (0, $bhvQG.default).contactsById[id];
    if (!contact) return null;
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $36Jjh.default), {
        heading: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: (contact === null || contact === void 0 ? void 0 : contact.label) || "New Contact"
            })
        }),
        rightButtons: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
            children: (0, $8kZ1o.canEditContacts)((0, $1BTI2.default).user) ? /*#__PURE__*/ (0, $61Ea1.jsxs)("button", {
                className: "btn btn-default edit-controls__delete-button",
                onClick: ()=>(0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $7WkWs.default), {
                        contact: contact,
                        modalId: "deleteContact"
                    })),
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                        className: "fa fa-trash mr-1"
                    }),
                    "Delete"
                ]
            }) : null
        }),
        extraContent: extraContent
    });
});

});
parcelRegister("7WkWs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c7e31cac8d15c4f$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("eat5C");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $fEcKX = parcelRequire("fEcKX");
parcelRequire("fM2j4");

var $6UBLf = parcelRequire("6UBLf");

var $6l5Kr = parcelRequire("6l5Kr");
var $5c7e31cac8d15c4f$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ contact: contact, modalId: modalId })=>{
    const navigate = (0, $6UBLf.useNavigate)();
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fEcKX.default), {
        modalId: modalId,
        heading: "Delete Contact",
        saveLabel: "Delete Contact",
        onSave: ()=>(0, $6l5Kr.handleEntityDelete)(contact, "contact", navigate),
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("p", {
            style: {
                margin: "1em"
            },
            children: [
                "Are you sure you wish to delete ",
                /*#__PURE__*/ (0, $61Ea1.jsx)("em", {
                    children: contact.label
                }),
                "?"
            ]
        })
    });
});

});


parcelRegister("d0Xu4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97996ababedbd8e0$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $02LyB = parcelRequire("02LyB");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $bhvQG = parcelRequire("bhvQG");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $kqlQp = parcelRequire("kqlQp");
var $97996ababedbd8e0$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ contactId: contactId })=>{
    var _contact$projects, _contact$invoices;
    const isAtLeastPM = true;
    const isAtLeastAdmin = true;
    const contact = (0, $bhvQG.default).contactsById[contactId];
    if (!contact) return null;
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "flex w-full",
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            className: "flex-0-0-auto flex items-center justify-center mx-auto",
            style: {
                padding: "0.5em",
                width: "100%"
            },
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    className: "form-horizontal",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)($97996ababedbd8e0$var$ContactField, {
                            contact: contact,
                            prop: "firstName",
                            label: "First name"
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)($97996ababedbd8e0$var$ContactField, {
                            contact: contact,
                            prop: "lastName",
                            label: "Last name"
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)($97996ababedbd8e0$var$ContactField, {
                            contact: contact,
                            prop: "organisationName",
                            label: "Organisation name"
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)($97996ababedbd8e0$var$ContactField, {
                            contact: contact,
                            prop: "phone",
                            label: "Phone"
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)($97996ababedbd8e0$var$ContactField, {
                            contact: contact,
                            prop: "email",
                            label: "Email"
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)($97996ababedbd8e0$var$ContactField, {
                            contact: contact,
                            prop: "address",
                            label: "Address"
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)($97996ababedbd8e0$var$ContactField, {
                            contact: contact,
                            prop: "notes",
                            label: "Notes"
                        })
                    ]
                }),
                contact !== null && contact !== void 0 && (_contact$projects = contact.projects) !== null && _contact$projects !== void 0 && _contact$projects.length ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    style: {
                        margin: "1.5em"
                    },
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("h4", {
                            children: "Projects"
                        }),
                        contact.projects.sort((a, b)=>b.tile - a.title).map((p)=>/*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                                className: "mr-2 text-nowrap inline-block",
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqlQp.Link), {
                                        to: `/projects/${p.id}`,
                                        children: p.title
                                    }),
                                    ",     "
                                ]
                            }))
                    ]
                }) : null,
                contact !== null && contact !== void 0 && (_contact$invoices = contact.invoices) !== null && _contact$invoices !== void 0 && _contact$invoices.length ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    style: {
                        margin: "1.5em",
                        marginTop: "2em"
                    },
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("h4", {
                            children: "Invoices"
                        }),
                        contact.invoices.sort((a, b)=>b.ref - a.ref).map((i)=>/*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                                className: "mr-2 text-nowrap inline-block",
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqlQp.Link), {
                                        to: `/invoices/${i.id}`,
                                        children: i.ref
                                    }),
                                    ",    "
                                ]
                            }))
                    ]
                }) : null
            ]
        })
    });
});
const $97996ababedbd8e0$var$ContactField = (0, $1EEMt.observer)(({ contact: contact, label: label, prop: prop })=>{
    const editable = (0, $8kZ1o.canEditContacts)((0, $1BTI2.default).user);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "form-group mb-5",
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "col-md-3",
                children: /*#__PURE__*/ (0, $61Ea1.jsxs)("label", {
                    children: [
                        label,
                        ":"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("col-md-8", `contact-form__${prop}`),
                children: prop === "notes" || prop === "address" ? /*#__PURE__*/ (0, $61Ea1.jsx)("textarea", {
                    cols: 60,
                    rows: 4,
                    value: contact[prop],
                    onChange: (e)=>{
                        const updates = {};
                        updates[prop] = e.target.value;
                        contact.update(updates);
                    },
                    disabled: !editable,
                    className: "input-base"
                }) : /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
                    type: "text",
                    value: contact[prop] || "",
                    onChange: (e)=>{
                        const updates = {};
                        updates[prop] = e.target.value;
                        contact.update(updates);
                    },
                    disabled: !editable,
                    className: "input-base"
                })
            })
        ]
    });
});

});

parcelRegister("619oG", function(module, exports) {

$parcel$export(module.exports, "ContactPage", function () { return $9ba0cb0fb82c9700$export$27dfd9e9bbc44937; });

var $61Ea1 = parcelRequire("61Ea1");

var $1YY5L = parcelRequire("1YY5L");

var $fTGwv = parcelRequire("fTGwv");

var $kMTP6 = parcelRequire("kMTP6");

var $jbmdS = parcelRequire("jbmdS");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");
const $9ba0cb0fb82c9700$export$27dfd9e9bbc44937 = ()=>{
    const [isOpen, setIsOpen] = (0, $jbmdS.useState)(false);
    const handleDelete = ()=>{
        // delete contact
        setIsOpen(false);
    };
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "flex w-full flex-col items-end",
        children: [
            (0, $8kZ1o.canEditContacts)((0, $1BTI2.default).user) ? /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "p-8",
                children: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $fTGwv.Button), {
                    variant: "outline",
                    onClick: ()=>setIsOpen(true),
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                            className: "fa fa-trash mr-1"
                        }),
                        "Delete contact"
                    ]
                })
            }) : null,
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $1YY5L.ContactForm), {}),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kMTP6.DeleteContactModal), {
                isOpen: isOpen,
                setIsOpen: setIsOpen,
                onSave: handleDelete
            })
        ]
    });
};

});
parcelRegister("1YY5L", function(module, exports) {

$parcel$export(module.exports, "ContactForm", function () { return $ea6ba5e927dcb568$export$d5d8fc50aded1148; });

var $61Ea1 = parcelRequire("61Ea1");

var $02LyB = parcelRequire("02LyB");

var $kqlQp = parcelRequire("kqlQp");

var $2YJBX = parcelRequire("2YJBX");

var $iuzpK = parcelRequire("iuzpK");

var $2BlDy = parcelRequire("2BlDy");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");
const $ea6ba5e927dcb568$export$d5d8fc50aded1148 = ()=>{
    const contact = (0, $2BlDy.useContact)();
    const projects = (0, $2BlDy.useProjects)();
    const invoices = (0, $2BlDy.useInvoices)();
    const onChange = (type, value)=>{
        (0, $2BlDy.updateContact)(value, type);
    };
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "flex w-full",
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            className: "flex-0-0-auto flex items-center justify-center mx-auto",
            style: {
                padding: "0.5em",
                width: "100%"
            },
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    className: "form-horizontal",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)($ea6ba5e927dcb568$var$ContactField, {
                            contact: contact,
                            prop: "firstName",
                            label: "First name",
                            onChange: onChange
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)($ea6ba5e927dcb568$var$ContactField, {
                            contact: contact,
                            prop: "lastName",
                            label: "Last name",
                            onChange: onChange
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)($ea6ba5e927dcb568$var$ContactField, {
                            contact: contact,
                            prop: "organisationName",
                            label: "Organisation name",
                            onChange: onChange
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)($ea6ba5e927dcb568$var$ContactField, {
                            contact: contact,
                            prop: "phone",
                            label: "Phone",
                            onChange: onChange
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)($ea6ba5e927dcb568$var$ContactField, {
                            contact: contact,
                            prop: "email",
                            label: "Email",
                            onChange: onChange
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)($ea6ba5e927dcb568$var$ContactField, {
                            contact: contact,
                            prop: "address",
                            label: "Address",
                            onChange: onChange
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)($ea6ba5e927dcb568$var$ContactField, {
                            contact: contact,
                            prop: "notes",
                            label: "Notes",
                            onChange: onChange
                        })
                    ]
                }),
                projects !== null && projects !== void 0 && projects.length ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    style: {
                        margin: "1.5em"
                    },
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("h4", {
                            children: "Projects"
                        }),
                        projects.sort((a, b)=>(b === null || b === void 0 ? void 0 : b.tile) - (a === null || a === void 0 ? void 0 : a.title)).map((p)=>/*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                                className: "mr-2 text-nowrap inline-block",
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqlQp.Link), {
                                        to: `/projects/${p === null || p === void 0 ? void 0 : p.id}`,
                                        children: p === null || p === void 0 ? void 0 : p.title
                                    }),
                                    ",     "
                                ]
                            }))
                    ]
                }) : null,
                invoices !== null && invoices !== void 0 && invoices.length ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    style: {
                        margin: "1.5em",
                        marginTop: "2em"
                    },
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("h4", {
                            children: "Invoices"
                        }),
                        invoices.sort((a, b)=>(b === null || b === void 0 ? void 0 : b.ref) - (a === null || a === void 0 ? void 0 : a.ref)).map((i)=>/*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                                className: "mr-2 text-nowrap inline-block",
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqlQp.Link), {
                                        to: `/invoices/${i === null || i === void 0 ? void 0 : i.id}`,
                                        children: i === null || i === void 0 ? void 0 : i.ref
                                    }),
                                    ",    "
                                ]
                            }))
                    ]
                }) : null
            ]
        })
    });
};
const $ea6ba5e927dcb568$var$ContactField = ({ contact: contact, label: label, prop: prop, onChange: onChange })=>{
    const editable = (0, $8kZ1o.canEditContacts)((0, $1BTI2.default).user);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "form-group mb-5",
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "col-md-3",
                children: /*#__PURE__*/ (0, $61Ea1.jsxs)("label", {
                    children: [
                        label,
                        ":"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("col-md-8", `contact-form__${prop}`),
                children: prop === "notes" || prop === "address" ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $iuzpK.TextArea), {
                    cols: 60,
                    rows: 4,
                    value: contact[prop],
                    onChange: (newValue)=>{
                        onChange(prop, newValue.target.value);
                    },
                    disabled: !editable,
                    className: "input-base"
                }) : /*#__PURE__*/ (0, $61Ea1.jsx)((0, $2YJBX.Input), {
                    type: "text",
                    value: contact[prop] || "",
                    onChange: (newValue)=>{
                        console.log("newValue", newValue.target.value);
                        onChange(prop, newValue.target.value);
                    },
                    disabled: !editable,
                    className: "input-base"
                })
            })
        ]
    });
};

});
parcelRegister("2BlDy", function(module, exports) {

$parcel$export(module.exports, "contactStore", function () { return $fd5645f299994027$export$25c8b3ab3a32b360; });
$parcel$export(module.exports, "updateContact", function () { return $fd5645f299994027$export$f3d552e64e0e2af; });
$parcel$export(module.exports, "useContact", function () { return $fd5645f299994027$export$86f0102d751bc9af; });
$parcel$export(module.exports, "useProjects", function () { return $fd5645f299994027$export$39d4f31fc4866d70; });
$parcel$export(module.exports, "useInvoices", function () { return $fd5645f299994027$export$bf5603be66386967; });

var $8qPhl = parcelRequire("8qPhl");

var $3h7sC = parcelRequire("3h7sC");

var $277OF = parcelRequire("277OF");

var $lJ1OS = parcelRequire("lJ1OS");
const $fd5645f299994027$export$804d9df12a88b25 = (0, $8qPhl.z).object({
    id: (0, $8qPhl.z).string(),
    firstName: (0, $8qPhl.z).string().nullable().optional(),
    lastName: (0, $8qPhl.z).string().nullable().optional(),
    organisationName: (0, $8qPhl.z).string().nullable().optional(),
    email: (0, $8qPhl.z).string().nullable().optional(),
    phone: (0, $8qPhl.z).string().nullable().optional(),
    address: (0, $8qPhl.z).string().nullable().optional(),
    notes: (0, $8qPhl.z).string().nullable().optional()
});
const $fd5645f299994027$var$initialContext = {
    contact: null,
    projects: [],
    invoices: []
};
const $fd5645f299994027$export$25c8b3ab3a32b360 = (0, $277OF.createQueryStore)({
    context: $fd5645f299994027$var$initialContext,
    on: {
        setData: {
            contact: (_, event)=>event.contact,
            projects: (_, event)=>{
                var _event$projects;
                return (_event$projects = event.projects) !== null && _event$projects !== void 0 ? _event$projects : [];
            },
            invoices: (_, event)=>{
                var _event$invoices;
                return (_event$invoices = event.invoices) !== null && _event$invoices !== void 0 ? _event$invoices : [];
            }
        },
        updateContact: {
            contact: (context, event)=>context.contact ? {
                    ...context.contact,
                    [event.prop]: event.value
                } : null
        }
    }
}, {
    queryKey: [
        "contact"
    ],
    queryFn: async ({ id: id })=>{
        var _result$projects, _result$invoices;
        const result = await (0, $3h7sC.trpc).contact.getContact.query({
            id: id
        });
        return {
            contact: result.contact,
            projects: (_result$projects = result.projects) !== null && _result$projects !== void 0 ? _result$projects : [],
            invoices: (_result$invoices = result.invoices) !== null && _result$invoices !== void 0 ? _result$invoices : []
        };
    },
    mutationFn: (data)=>(0, $3h7sC.trpc).contact.saveContact.mutate({
            contact: data.contact // Only save contact data, not projects/invoices
        }),
    staleTime: 300000,
    // 5 minutes
    cacheTime: 1800000 // 30 minutes
}, {
    saveId: "contact-save",
    requireConfirmation: true,
    confirmationMessage: "Save changes to contact?",
    loadingMessage: "Saving contact...",
    successMessage: "Contact saved successfully",
    errorMessage: "Failed to save contact"
});
const { useStoreData: $fd5645f299994027$export$544efe5ac05fc17, useIsLoading: $fd5645f299994027$export$4dface15d86304a4, useCanUndo: $fd5645f299994027$export$653033ad74e314c9, useCanRedo: $fd5645f299994027$export$e7ea8bfdbe9392b0, useUpdatedAt: $fd5645f299994027$export$4d53551414e812c, undo: $fd5645f299994027$export$21f930c44940fd98, redo: $fd5645f299994027$export$1688e416fee0a49e, save: $fd5645f299994027$export$a1544dad697b423d, revertToLastSave: $fd5645f299994027$export$7e511c2293ae6e56, getState: $fd5645f299994027$export$50fdfeece43146fd, getHistory: $fd5645f299994027$export$f9582a3c130d9538, getCurrentHistoryIndex: $fd5645f299994027$export$3d0fb93f79a1d871, getLastSavedIndex: $fd5645f299994027$export$3ad3501ee738138, getSavedAt: $fd5645f299994027$export$f4c906ca2124fef8, getUpdatedAt: $fd5645f299994027$export$ff3aa069bd8fb4e4 } = $fd5645f299994027$export$25c8b3ab3a32b360;
const $fd5645f299994027$export$3a6802af14bf5fa6 = (data)=>$fd5645f299994027$export$25c8b3ab3a32b360.store.send({
        type: "setData",
        ...data
    });
const $fd5645f299994027$export$f3d552e64e0e2af = (value, prop)=>$fd5645f299994027$export$25c8b3ab3a32b360.store.send({
        type: "updateContact",
        value: value,
        prop: prop
    });
const $fd5645f299994027$export$86f0102d751bc9af = ()=>(0, $lJ1OS.useSelector)($fd5645f299994027$export$25c8b3ab3a32b360.store, (state)=>state.context.contact);
const $fd5645f299994027$export$39d4f31fc4866d70 = ()=>(0, $lJ1OS.useSelector)($fd5645f299994027$export$25c8b3ab3a32b360.store, (state)=>state.context.projects);
const $fd5645f299994027$export$bf5603be66386967 = ()=>(0, $lJ1OS.useSelector)($fd5645f299994027$export$25c8b3ab3a32b360.store, (state)=>state.context.invoices);
const $fd5645f299994027$export$52411745da118fc8 = ()=>$fd5645f299994027$export$25c8b3ab3a32b360.getState().context.contact;

});


parcelRegister("kMTP6", function(module, exports) {

$parcel$export(module.exports, "DeleteContactModal", function () { return $85b461f70db5072c$export$1c7e53c3fb34d7c9; });
// import _ from 'lodash'

var $61Ea1 = parcelRequire("61Ea1");

var $15gHp = parcelRequire("15gHp");

var $2BlDy = parcelRequire("2BlDy");
const $85b461f70db5072c$export$1c7e53c3fb34d7c9 = ({ isOpen: isOpen, setIsOpen: setIsOpen, onSave: onSave })=>{
    var _contact$firstName, _contact$lastName;
    const contact = (0, $2BlDy.useContact)();
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $15gHp.Modal), {
        canSave: ()=>true,
        isLoading: false,
        isOpenDialog: isOpen,
        setIsOpenDialog: setIsOpen,
        styleSaveButton: {
            border: "1px #ef4444 solid",
            backgroundColor: "#ef4444",
            color: "white"
        },
        heading: "Delete Contact",
        saveLabel: "Delete Contact",
        onSave: onSave,
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("p", {
            style: {
                margin: "1em"
            },
            children: [
                "Are you sure you wish to delete",
                " ",
                /*#__PURE__*/ (0, $61Ea1.jsx)("strong", {
                    children: `${(_contact$firstName = contact === null || contact === void 0 ? void 0 : contact.firstName) !== null && _contact$firstName !== void 0 ? _contact$firstName : ""} ${(_contact$lastName = contact === null || contact === void 0 ? void 0 : contact.lastName) !== null && _contact$lastName !== void 0 ? _contact$lastName : ""}`
                }),
                "?"
            ]
        })
    });
};

});



parcelRegister("1z0aX", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $1239323372704f88$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");

var $l3Qa6 = parcelRequire("l3Qa6");

var $kuPRw = parcelRequire("kuPRw");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $7qobO = parcelRequire("7qobO");

var $5PXcS = parcelRequire("5PXcS");

var $4iw5i = parcelRequire("4iw5i");
const $1239323372704f88$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_private/accounting/auth")({
    beforeLoad: ({ params: params })=>{
        if (!(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "accountingAuth", params)) throw new Error("Permission Denied");
    },
    errorComponent: ({ error: error, reset: reset })=>{
        if (error.message === "Permission Denied") return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7qobO.default), {});
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    },
    component: $1239323372704f88$var$Wrapper,
    pendingComponent: (0, $4iw5i.default)
});
function $1239323372704f88$var$Wrapper() {
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kuPRw.default), {
            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $l3Qa6.default), {
                ...$1239323372704f88$export$e7b0ac011bb776c6.useParams(),
                ...$1239323372704f88$export$e7b0ac011bb776c6.useSearch()
            })
        })
    });
}

});
parcelRegister("l3Qa6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f552570a518a0394$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $43oHB = parcelRequire("43oHB");

var $6UBLf = parcelRequire("6UBLf");
var $f552570a518a0394$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ state: state })=>{
    const navigate = (0, $6UBLf.useNavigate)();
    const [error, setError] = (0, $jbmdS.useState)(null);
    (0, $jbmdS.useEffect)(()=>{
        const connect = async ()=>{
            try {
                await (0, $43oHB.connectAccountingOauth)();
                navigate({
                    to: state
                });
            } catch (e) {
                setError(e);
            }
        };
        connect();
    }, []);
    if (error) return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("h4", {
                children: "There was an error connecting to your accounting system"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: error.message
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                onClick: ()=>navigate({
                        to: state || "/"
                    }),
                children: "Go Back"
            })
        ]
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("style", {
                children: `.loading::after {
                    display: inline-block;
                    animation: dotty steps(1,end) 1s infinite;
                    content: '   ';
                }
                
                @keyframes dotty {
                    0%   { content: '   '; }
                    25%  { content: '.  '; }
                    50%  { content: '.. '; }
                    75%  { content: '...'; }
                    100% { content: '   '; }
                }`
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("h4", {
                children: "Connecting to Accounting System"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "loading",
                children: "Please Wait"
            })
        ]
    });
});

});


parcelRegister("6HIWs", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $4e199ec199a0a959$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");
var $64Yjc = parcelRequire("64Yjc");

var $7TPWF = parcelRequire("7TPWF");

var $gF29w = parcelRequire("gF29w");

var $kuPRw = parcelRequire("kuPRw");

var $47i9t = parcelRequire("47i9t");

var $4iw5i = parcelRequire("4iw5i");

var $5PXcS = parcelRequire("5PXcS");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $7qobO = parcelRequire("7qobO");
parcelRequire("fM2j4");

var $6Q5sp = parcelRequire("6Q5sp");

var $cxnwP = parcelRequire("cxnwP");

var $26sX2 = parcelRequire("26sX2");

var $38AIP = parcelRequire("38AIP");

var $kqntg = parcelRequire("kqntg");

var $3h7sC = parcelRequire("3h7sC");
parcelRequire("3PAB5");

var $6l5Kr = parcelRequire("6l5Kr");
const $4e199ec199a0a959$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_private/invoices/$id/")({
    beforeLoad: ({ params: params })=>{
        if (!(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "invoice", params)) throw new Error("Permission Denied");
        const invoice = (0, $38AIP.getCacheItemById)("invoices", params.id);
        (0, $26sX2.setLayoutDefaults)({
            pageTitle: (invoice === null || invoice === void 0 ? void 0 : invoice.ref) || "Invoice",
            subMenu: "invoices",
            tabs: [
                {
                    id: "details",
                    label: "Details",
                    url: `/invoices/${params.id}`
                },
                {
                    id: "pdf",
                    label: "PDF",
                    url: `/invoices/${params.id}/pdf`
                }
            ]
        });
    },
    errorComponent: ({ error: error, reset: reset })=>{
        if (error.message === "Permission Denied") return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7qobO.default), {});
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    },
    loader: async ({ params: params })=>await $4e199ec199a0a959$var$loader(params.id),
    pendingComponent: (0, $4iw5i.default),
    component: $4e199ec199a0a959$var$Wrapper,
    onLeave: (match)=>{
        const { id: id } = match.params;
        const invoice = (0, $cxnwP.default).invoicesById[id];
        if (invoice && !invoice.createdAt && match.pathname !== (0, $6Q5sp.router).latestLocation.pathname) (0, $6l5Kr.cleanupNewEntity)(invoice, "invoice");
    }
});
const $4e199ec199a0a959$var$loader = async (id)=>{
    const data = await (0, $3h7sC.trpc).legacy.getInvoicePageData.query({
        id: id
    });
    const processedModels = (0, $47i9t.processTRPCData)(data);
    const invoice = (0, $cxnwP.default).invoicesById[id] || (0, $cxnwP.default).invoicesByOldId[id];
    if (!invoice) throw (0, $64Yjc.notFound)();
    return processedModels;
};
function $4e199ec199a0a959$var$Wrapper() {
    const { id: id } = $4e199ec199a0a959$export$e7b0ac011bb776c6.useParams();
    if ((0, $8kZ1o.migratedToV2)()) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqntg.CenterPadPageBody), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $gF29w.default), {
            id: id
        })
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7TPWF.default), {
                id: id
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kuPRw.default), {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $gF29w.default), {
                    id: id
                })
            })
        ]
    });
}

});
parcelRegister("7TPWF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c05f6af6c4879a0$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("lCpBr");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $36Jjh = parcelRequire("36Jjh");

var $khJQv = parcelRequire("khJQv");

var $cxnwP = parcelRequire("cxnwP");
parcelRequire("fEtu5");
var $avIhR = parcelRequire("avIhR");
parcelRequire("43oHB");

var $1BTI2 = parcelRequire("1BTI2");

var $ikffN = parcelRequire("ikffN");
parcelRequire("9mNEQ");

var $h5pqG = parcelRequire("h5pqG");

var $ldrel = parcelRequire("ldrel");

var $6ywef = parcelRequire("6ywef");

var $8kZ1o = parcelRequire("8kZ1o");

var $fM2j4 = parcelRequire("fM2j4");

var $6UBLf = parcelRequire("6UBLf");

var $5c05f6af6c4879a0$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ extraContent: extraContent, id: id })=>{
    const [syncState, setSyncState] = (0, $jbmdS.useState)("idle");
    const navigate = (0, $6UBLf.useNavigate)();
    const invoice = (0, $cxnwP.default).invoicesById[id] || (0, $cxnwP.default).invoicesByOldId[id];
    if (!invoice) return null;
    const project = invoice.project;
    const canEditInvoice = (0, $8kZ1o.canEditProjectInvoices)((0, $1BTI2.default).user, project);
    const canDeleteInvoice = (0, $8kZ1o.canCreateInvoiceForProject)((0, $1BTI2.default).user, project);
    const canViewSettings = (0, $8kZ1o.canViewInvoiceSettings)((0, $1BTI2.default).user);
    const canEditSettings = (0, $8kZ1o.canEditInvoiceSettings)((0, $1BTI2.default).user);
    const accountingSystem = (0, $ikffN.capitalCase)((0, $1BTI2.default).organisation.accountingSystem || "");
    const accountingSystemConnected = (0, $1BTI2.default).accountingConnected;
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $36Jjh.default), {
        heading: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: invoice !== null && invoice !== void 0 && invoice.ref ? `Invoice: ${invoice === null || invoice === void 0 ? void 0 : invoice.ref}` : "New Invoice"
            })
        }),
        rightButtons: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
            children: [
                canEditInvoice ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6ywef.default), {
                    action: "syncInvoice",
                    actionProps: {
                        invoice: invoice
                    },
                    style: {
                        margin: "0 1em"
                    },
                    onActionStart: async ()=>{
                        await (0, $fM2j4.default).startSave();
                        if ((0, $fM2j4.default).saveState === "error") throw "Save Failed";
                    }
                }) : null,
                /*#__PURE__*/ (0, $61Ea1.jsxs)("button", {
                    className: "btn btn-default invoice-page__pdf-button flex-0-0-auto",
                    onClick: ()=>{
                        (0, $fM2j4.default).startSave();
                        navigate({
                            to: "/invoices/$id/pdf",
                            params: {
                                id: invoice.id
                            }
                        });
                    },
                    style: {
                        margin: "0 1em 0 0"
                    },
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                            className: "fa fa-print mr-2.5"
                        }),
                        "PDF (Beta)"
                    ]
                }),
                canEditInvoice || canEditSettings || canDeleteInvoice ? /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $avIhR.Dropdown3), {
                    toggleElement: /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                        className: "btn btn-default flex-0-0-auto invoice__settings-button",
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                            style: {
                                margin: 0
                            },
                            className: "fa fa-cog"
                        })
                    }),
                    dropLeft: true,
                    contentStyle: {
                        width: "16em",
                        marginTop: "0.5em",
                        color: "#444"
                    },
                    containerStyle: {
                        float: "right"
                    },
                    children: [
                        canEditInvoice ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $avIhR.Dropdown3ListItem), {
                            className: "invoice__accounting-system-settings-button",
                            style: {
                                padding: "0.5em 1em",
                                height: "2.5em"
                            },
                            onClick: ()=>invoice.updateCachedData(),
                            children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                        className: "fa fa-refresh fa-fw"
                                    }),
                                    "Update Invoice Data"
                                ]
                            })
                        }) : null,
                        canEditSettings ? /*#__PURE__*/ (0, $61Ea1.jsx)((0, $avIhR.Dropdown3ListItem), {
                            className: "invoice__accounting-system-settings-button",
                            style: {
                                padding: "0.5em 1em",
                                height: "2.5em"
                            },
                            onClick: ()=>{
                                (0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $ldrel.default), {
                                    modalId: "invoice-settings"
                                }));
                            },
                            children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                        className: "fa fa-cog fa-fw"
                                    }),
                                    "Accounting Settings"
                                ]
                            })
                        }) : null,
                        canDeleteInvoice ? /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $avIhR.Dropdown3ListItem), {
                            className: "invoice__delete-button",
                            style: {
                                padding: "0.5em 1em",
                                height: "2.5em"
                            },
                            onClick: ()=>(0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $h5pqG.default), {
                                    invoice: invoice,
                                    modalId: "deleteInvoice"
                                })),
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                    className: "fa fa-times fa-fw"
                                }),
                                "Delete Invoice"
                            ]
                        }) : null
                    ]
                }) : null
            ]
        }),
        extraContent: extraContent
    });
});

});
parcelRegister("h5pqG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c706a10912d045fe$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");
parcelRequire("eat5C");

var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");

var $fEcKX = parcelRequire("fEcKX");
parcelRequire("fM2j4");

var $6UBLf = parcelRequire("6UBLf");

var $6l5Kr = parcelRequire("6l5Kr");
var $c706a10912d045fe$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ invoice: invoice, modalId: modalId })=>{
    const navigate = (0, $6UBLf.useNavigate)();
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fEcKX.default), {
        modalId: modalId,
        heading: "Delete Invoice",
        onSave: ()=>(0, $6l5Kr.handleEntityDelete)(invoice, "invoice", navigate),
        saveLabel: "Delete Invoice",
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("p", {
            style: {
                margin: "1em"
            },
            children: [
                "Are you sure you wish to delete invoice ",
                /*#__PURE__*/ (0, $61Ea1.jsx)("em", {
                    children: invoice.ref
                }),
                "?"
            ]
        })
    });
});

});


parcelRegister("gF29w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2122521f4f5bec3$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $4hBm1 = parcelRequire("4hBm1");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");

var $eat5C = parcelRequire("eat5C");

var $ewAM3 = parcelRequire("ewAM3");

var $goLmS = parcelRequire("goLmS");

var $cxnwP = parcelRequire("cxnwP");
parcelRequire("gJT7h");
parcelRequire("htkeB");

var $khJQv = parcelRequire("khJQv");
parcelRequire("fEtu5");
var $avIhR = parcelRequire("avIhR");

var $12o9H = parcelRequire("12o9H");

var $gjxeM = parcelRequire("gjxeM");

var $kRqe9 = parcelRequire("kRqe9");

var $ek5Pm = parcelRequire("ek5Pm");

var $49KZT = parcelRequire("49KZT");

var $iAbfy = parcelRequire("iAbfy");

var $7DzE4 = parcelRequire("7DzE4");

var $73du5 = parcelRequire("73du5");

var $1BTI2 = parcelRequire("1BTI2");

var $6RcUP = parcelRequire("6RcUP");

var $9YZWU = parcelRequire("9YZWU");

var $QiMYe = parcelRequire("QiMYe");

var $DdIgl = parcelRequire("DdIgl");

var $lu0ti = parcelRequire("lu0ti");

var $A8k4f = parcelRequire("A8k4f");

var $hHlvy = parcelRequire("hHlvy");
parcelRequire("jE5CX");

var $8kZ1o = parcelRequire("8kZ1o");

var $ikffN = parcelRequire("ikffN");

var $6fNfM = parcelRequire("6fNfM");
parcelRequire("6un1H");

var $6UBLf = parcelRequire("6UBLf");

var $lKdR6 = parcelRequire("lKdR6");
var $joA1X = parcelRequire("joA1X");

var $3h7sC = parcelRequire("3h7sC");

var $47i9t = parcelRequire("47i9t");
parcelRequire("6Q5sp");
const $c2122521f4f5bec3$var$InvoiceNumberInput = (0, $1EEMt.observer)(({ invoice: invoice, value: value, onChange: onChange, editable: editable, onDuplicateCheck: onDuplicateCheck })=>{
    const checkDuplicate = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useMemo(()=>(0, $eat5C.debounce)(async (ref, projectId, invoiceId)=>{
            if (!ref || !projectId) {
                onDuplicateCheck(false, false);
                return;
            }
            onDuplicateCheck(false, true); // Not duplicate, but checking
            try {
                const result = await (0, $3h7sC.trpc).invoice.checkDuplicateInvoiceRef.query({
                    ref: ref,
                    projectId: projectId,
                    excludeInvoiceId: invoiceId
                });
                onDuplicateCheck(result.isDuplicate, false);
            } catch (error) {
                console.error("Error checking duplicate invoice ref:", error);
                onDuplicateCheck(false, false);
            }
        }, 500), [
        onDuplicateCheck
    ]);
    const handleChange = (newValue)=>{
        onChange(newValue);
        checkDuplicate(newValue, invoice.projectId, invoice.id);
    };
    if (!editable) return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        children: value
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "flex w-full",
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                className: "flex-grow",
                children: (0, $ek5Pm.default).text({
                    value: value,
                    editable: editable,
                    onChange: handleChange
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                className: "flex-none flex flex-col items-center p-0 pr-1 font-sm",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                        className: "p-0 m-0",
                        onClick: ()=>{
                            (0, $1BTI2.default).organisation.incrementInvoiceNumber(invoice.project.id);
                            handleChange((0, $cxnwP.getInvoiceNumber)(invoice.project));
                        },
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $joA1X.default), {})
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                        className: "p-0 m-0",
                        onClick: ()=>{
                            (0, $1BTI2.default).organisation.decrementInvoiceNumber(invoice.project.id);
                            handleChange((0, $cxnwP.getInvoiceNumber)(invoice.project));
                        },
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $lKdR6.default), {})
                    })
                ]
            })
        ]
    });
});
const $c2122521f4f5bec3$var$getInvoiceColumns = (onDuplicateCheck)=>[
        {
            id: "ref",
            label: "Invoice Number",
            width: 22,
            type: "text",
            editable: (r)=>(0, $8kZ1o.canEditProjectInvoices)((0, $1BTI2.default).user, r.project),
            value: (r)=>r.ref,
            onChange: (r)=>(v)=>r.update({
                        ref: v
                    }),
            component: (props)=>{
                const invoice = props.stores.row.rowObject;
                const { editable: editable, value: value, onChange: onChange } = props;
                return /*#__PURE__*/ (0, $61Ea1.jsx)($c2122521f4f5bec3$var$InvoiceNumberInput, {
                    invoice: invoice,
                    value: value,
                    onChange: onChange,
                    editable: editable,
                    onDuplicateCheck: onDuplicateCheck
                });
            }
        },
        {
            id: "contact",
            label: "Addressed To",
            width: 37,
            type: "contact",
            editable: (r)=>(0, $8kZ1o.canEditProjectInvoices)((0, $1BTI2.default).user, r.project),
            value: (r)=>r.contact,
            onChange: (r)=>(v)=>r.update({
                        contactId: v.id
                    })
        },
        {
            id: "issueDate",
            label: "Issue Date",
            width: 15,
            type: "date",
            editable: (r)=>(0, $8kZ1o.canEditProjectInvoices)((0, $1BTI2.default).user, r.project),
            value: (r)=>r.issueDate,
            onChange: (r)=>(v)=>{
                    const dueIn = (0, $4hBm1.differenceInDays)(r.dueDate, r.issueDate);
                    r.update({
                        issueDate: v,
                        dueDate: (0, $4hBm1.addDays)(v, dueIn)
                    });
                }
        },
        {
            id: "dueIn",
            label: "Due Date",
            width: 8,
            type: "number",
            editable: (r)=>(0, $8kZ1o.canEditProjectInvoices)((0, $1BTI2.default).user, r.project),
            value: (r)=>(0, $4hBm1.differenceInDays)(r.dueDate, r.issueDate),
            onChange: (r)=>(v)=>r.update({
                        dueDate: (0, $4hBm1.addDays)(r.issueDate, v)
                    })
        },
        {
            id: "dueInDays",
            label: "",
            width: 8,
            type: "text",
            editable: (r)=>(0, $8kZ1o.canEditProjectInvoices)((0, $1BTI2.default).user, r.project),
            value: (r)=>"days"
        },
        {
            id: "dueDate",
            label: "Due Date",
            width: 16,
            type: "date",
            editable: (r)=>(0, $8kZ1o.canEditProjectInvoices)((0, $1BTI2.default).user, r.project),
            value: (r)=>r.dueDate,
            onChange: (r)=>(v)=>r.update({
                        dueDate: v
                    })
        },
        {
            id: "taxRate",
            label: "Tax Rate",
            width: 16,
            type: "percent",
            editable: (r)=>(0, $8kZ1o.canEditProjectInvoices)((0, $1BTI2.default).user, r.project) && ((0, $1BTI2.default).organisation.accountingSystem === "none" || (0, $1BTI2.default).organisation.accountingSystem == null),
            onChange: (r)=>(v)=>r.update({
                        taxRatePercent: v * 100
                    }),
            value: (r)=>r.taxRatePercent / 100
        }
    ];
const $c2122521f4f5bec3$var$lineItemColumns = [
    {
        id: "type",
        label: "Type",
        width: 15,
        type: "dropdown",
        editable: (r)=>r.lineItemType !== "note" && (0, $8kZ1o.canEditProjectInvoices)((0, $1BTI2.default).user, r.project),
        value: (r)=>r.billingType,
        onChange: (r)=>(v)=>r.update({
                    billingType: v
                }),
        component: ({ stores: stores, value: value, onChange: onChange, editable: editable })=>{
            const lineItemType = stores.row.rowObject.lineItemType;
            if (!editable) return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    padding: "0.5em"
                },
                children: lineItemType === "note" ? "Note" : (0, $ikffN.capitalCase)(value)
            });
            switch(lineItemType){
                case "note":
                    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        style: {
                            padding: "0.5em"
                        },
                        children: "Note"
                    });
                default:
                    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                        selectedOption: value,
                        options: [
                            "agreedFee",
                            "variation",
                            "reimbursement"
                        ],
                        optionLabel: (opt)=>{
                            if (opt === "agreedFee") return "Agreed Fee";
                            if (opt === "variation") return "Variation";
                            if (opt === "reimbursement") return "Reimbursement";
                        },
                        onChange: onChange,
                        variant: "secondary",
                        className: "!border-none"
                    });
            }
        }
    },
    {
        id: "description",
        label: /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
            children: [
                "Description",
                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hHlvy.InvoiceCodeInfo), {
                    style: {
                        marginLeft: "0.5em"
                    }
                })
            ]
        }),
        width: 50,
        type: "textarea",
        editable: (r)=>(0, $8kZ1o.canEditProjectInvoices)((0, $1BTI2.default).user, r.project),
        value: (r)=>r.description,
        onChange: (r)=>(v)=>r.update({
                    description: v
                }),
        component: (props)=>{
            const li = props.stores.row.rowObject;
            return /*#__PURE__*/ (0, $61Ea1.jsx)($c2122521f4f5bec3$var$LineItemDescription, {
                ...props,
                lineItem: li
            });
        }
    },
    {
        id: "qty",
        label: "QTY",
        width: 11,
        type: "number",
        editable: (r)=>r.lineItemType !== "note" && (0, $8kZ1o.canEditProjectInvoices)((0, $1BTI2.default).user, r.project),
        value: (r)=>r.unitQuantity,
        style: (r, stores)=>{
            return (r === null || r === void 0 ? void 0 : r.unitQuantity) < 0 ? {
                color: "red",
                outline: "solid red 2px"
            } : {};
        },
        onChange: (r)=>(v)=>{
                if (!v && r.billingType === "agreedFee" && [
                    "progress",
                    "projectProgress",
                    "fixed"
                ].includes(r.lineItemType)) {
                    r.timeEntries.forEach((te)=>te.update({
                            beenInvoiced: false
                        }));
                    r.update({
                        timesheetIds: []
                    });
                } else if (v && r.billingType === "agreedFee" && [
                    "progress",
                    "projectProgress",
                    "fixed"
                ].includes(r.lineItemType)) {
                    const timeEntries = (0, $QiMYe.default).timeEntries.filter((te)=>{
                        return (te.hours || te.notes) && te.isBillable && !te.isVariation && !te.beenInvoiced && !te.deletedAt && te.staff && te.project === r.project && te.phase == r.phase && te.date <= r.invoice.endDate && te.date >= r.invoice.startDate || (r.timesheetIds || []).includes(te.id);
                    });
                    r.update({
                        timesheetIds: timeEntries.map((te)=>te.id)
                    });
                    timeEntries.forEach((te)=>te.update({
                            beenInvoiced: true
                        }));
                }
                r.update({
                    unitQuantity: v
                });
            },
        component: (props)=>{
            const lineItemType = props.stores.row.rowObject.lineItemType;
            switch(lineItemType){
                case "progress":
                case "projectProgress":
                    return (0, $49KZT.default).percent(props);
                case "note":
                    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {});
                default:
                    return (0, $49KZT.default).number(props);
            }
        }
    },
    {
        id: "unitCost",
        label: "Unit cost",
        width: 12,
        type: "currency",
        editable: (r)=>r.lineItemType !== "note" && (0, $8kZ1o.canEditProjectInvoices)((0, $1BTI2.default).user, r.project),
        value: (r)=>r.unitCost,
        onChange: (r)=>(v)=>r.update({
                    unitCost: v
                }),
        component: (props)=>{
            const lineItemType = props.stores.row.rowObject.lineItemType;
            switch(lineItemType){
                case "note":
                    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {});
                default:
                    return (0, $49KZT.default).currency(props);
            }
        }
    },
    {
        id: "amount",
        label: "Amount",
        width: 12,
        type: "currency",
        editable: (r)=>false,
        value: (r)=>r.amount,
        component: (props)=>{
            const lineItemType = props.stores.row.rowObject.lineItemType;
            switch(lineItemType){
                case "note":
                    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {});
                default:
                    return (0, $49KZT.default).currency(props);
            }
        }
    },
    {
        id: "tax",
        label: "Tax",
        width: 12,
        type: "currency",
        editable: (r)=>false,
        value: (r)=>r.lineItemType !== "note" ? r.tax : null,
        component: (props)=>{
            const lineItemType = props.stores.row.rowObject.lineItemType;
            switch(lineItemType){
                case "note":
                    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {});
                default:
                    return (0, $49KZT.default).currency(props);
            }
        }
    },
    {
        id: "isTaxed",
        label: "",
        width: 4,
        type: "checkbox",
        permissions: (r)=>(0, $8kZ1o.canEditProjectInvoices)((0, $1BTI2.default).user, r.project),
        editable: (r)=>r.lineItemType !== "note" && (0, $8kZ1o.canEditProjectInvoices)((0, $1BTI2.default).user, r.project),
        value: (r)=>r.isTaxed,
        onChange: (r)=>(v)=>{
                r.update({
                    isTaxed: v
                });
            },
        component: (props)=>{
            if (!props.editable) return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {});
            const lineItemType = props.stores.row.rowObject.lineItemType;
            switch(lineItemType){
                case "note":
                    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {});
                default:
                    return (0, $49KZT.default).checkbox(props);
            }
        }
    },
    {
        label: "",
        width: 4,
        type: "button",
        permissions: (r)=>(0, $8kZ1o.canEditProjectInvoices)((0, $1BTI2.default).user, r.project),
        editable: (r)=>(0, $8kZ1o.canEditProjectInvoices)((0, $1BTI2.default).user, r.project),
        value: (p)=>/*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                className: "fa fa-times",
                style: {
                    marginRight: 0
                }
            }),
        onClick: (r)=>()=>{
                r.timeEntries.forEach((te)=>te.update({
                        beenInvoiced: false
                    }));
                r.expenseItems.forEach((eii)=>eii.update({
                        beenInvoiced: false
                    }));
                r.update({
                    deletedAt: new Date()
                });
            }
    },
    {
        id: "createdAt",
        type: "date",
        visible: false,
        value: (r)=>r.createdAt || r.initiatedAt
    },
    {
        id: "timeEntryStartDate",
        type: "date",
        visible: false,
        value: (r)=>r.timeEntryStartDate
    }
];
var $c2122521f4f5bec3$export$2e2bcd8739ae039 = ({ id: id })=>{
    const navigate = (0, $6UBLf.useNavigate)();
    const isAtLeastPM = true;
    const isAtLeastAdmin = true;
    const invoice = (0, $cxnwP.default).invoicesById[id] || (0, $cxnwP.default).invoicesByOldId[id];
    if (!invoice) return null;
    if (id === String(invoice.oldId)) navigate({
        to: "/invoices/$id",
        params: {
            id: invoice.id
        }
    });
    const invoiceExternalLink = (0, $DdIgl.default)[invoice.accountingSystemId];
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6RcUP.default), {
        queryIds: [
            {
                id: `invoiceBilling-${invoice.id}`,
                queryFn: async ()=>{
                    const res = await (0, $3h7sC.trpc).legacy.getInvoicePageBillingData.query({
                        projectId: invoice.projectId,
                        startDate: (0, $4hBm1.format)(invoice.startDate, "yyyy-MM-dd"),
                        endDate: (0, $4hBm1.format)(invoice.endDate, "yyyy-MM-dd"),
                        issueDate: (0, $4hBm1.format)(invoice.issueDate, "yyyy-MM-dd")
                    });
                    return (0, $47i9t.processTRPCData)(res, `invoiceBilling-${invoice.id}`);
                },
                staleTime: 0,
                cacheTime: 0
            }
        ],
        children: /*#__PURE__*/ (0, $61Ea1.jsx)($c2122521f4f5bec3$var$InvoicePage, {
            invoice: invoice,
            invoiceExternalLink: invoiceExternalLink
        })
    }, invoice.id);
};
const $c2122521f4f5bec3$var$InvoicePage = (0, $1EEMt.observer)(({ invoice: invoice, invoiceExternalLink: invoiceExternalLink })=>{
    var _invoice$phases;
    const [isDuplicateRef, setIsDuplicateRef] = (0, $jbmdS.useState)(false);
    const [isCheckingDuplicate, setIsCheckingDuplicate] = (0, $jbmdS.useState)(false);
    (0, $jbmdS.useEffect)(()=>{
        if (!invoice.cachedData) invoice.updateCachedData();
    }, [
        invoice
    ]);
    const handleDuplicateCheck = (isDuplicate, isChecking)=>{
        setIsDuplicateRef(isDuplicate);
        setIsCheckingDuplicate(isChecking);
    };
    if (!invoice.cachedData) return null;
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "flex items-center justify-between p-[1em] border-b border-[#e5e5e5]",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("h3", {
                                style: {
                                    marginTop: 0,
                                    fontSize: "2em",
                                    marginBottom: 0
                                },
                                children: invoice.project.title
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                        children: "For work carried out from "
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("strong", {
                                        children: (0, $4hBm1.format)(invoice.startDate, "dd/MM/yyyy")
                                    }),
                                    " to ",
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("strong", {
                                        children: (0, $4hBm1.format)(invoice.endDate, "dd/MM/yyyy")
                                    }),
                                    (0, $8kZ1o.canEditProjectInvoices)((0, $1BTI2.default).user, invoice.pr) ? /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                                        className: "btn btn-sm btn-tiny",
                                        onClick: ()=>{
                                            return (0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $73du5.default), {
                                                modalId: "changeDateRange",
                                                invoice: invoice
                                            }));
                                        },
                                        style: {
                                            marginLeft: "1em"
                                        },
                                        children: "Change..."
                                    }) : null
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "flex-1-1-auto"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "flex-0-0-auto",
                        style: {
                            textAlign: "right"
                        },
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                style: {
                                    fontStyle: "italic",
                                    fontSize: "0.9em"
                                },
                                children: [
                                    "Created:",
                                    " ",
                                    (0, $4hBm1.format)(invoice.createdAt || new Date(), "EEE dd MMMM, yyyy")
                                ]
                            }),
                            invoiceExternalLink != null ? /*#__PURE__*/ (0, $61Ea1.jsx)("a", {
                                target: "_blank",
                                href: invoiceExternalLink.getUrl(invoice.accountingSystemInvoiceId),
                                children: /*#__PURE__*/ (0, $61Ea1.jsxs)("button", {
                                    className: "btn btn-sm btn-xero",
                                    style: invoiceExternalLink.style,
                                    children: [
                                        "View in ",
                                        invoiceExternalLink.label
                                    ]
                                })
                            }) : null
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    padding: "1em 0",
                    borderBottom: "solid 1px #e5e5e5",
                    fontSize: "1.05em",
                    marginBottom: "4em"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
                        columns: $c2122521f4f5bec3$var$getInvoiceColumns(handleDuplicateCheck),
                        rows: [
                            invoice
                        ],
                        fullWidth: true
                    }),
                    (isCheckingDuplicate || isDuplicateRef) && /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        style: {
                            color: isDuplicateRef ? "red" : "#666",
                            padding: "1em 0 0 1em",
                            fontStyle: "italic",
                            fontSize: "1.25rem"
                        },
                        children: isCheckingDuplicate ? "Checking invoice number..." : "Invoice Number Already In Use"
                    })
                ]
            }),
            (_invoice$phases = invoice.phases) === null || _invoice$phases === void 0 ? void 0 : _invoice$phases.sort((0, $6fNfM.default)).map((ph)=>/*#__PURE__*/ (0, $61Ea1.jsx)($c2122521f4f5bec3$var$PhaseLineItems, {
                    ph: ph,
                    invoice: invoice
                }, ph.id)),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    borderTop: "solid 1px #aaa",
                    paddingTop: "1.5em"
                },
                children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    style: {
                        textAlign: "right"
                    },
                    children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            display: "inline-block",
                            textAlign: "right",
                            margin: "1em",
                            width: "30%"
                        },
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                className: "flex items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        className: "flex-0-0-auto",
                                        style: {
                                            width: "35%"
                                        },
                                        children: "Subtotal"
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        className: "flex-1-1-auto invoice__total-ex-tax",
                                        style: {
                                            marginRight: "6%"
                                        },
                                        children: (0, $12o9H.FormatCurrency)(invoice.amount)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                className: "flex items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                        className: "flex-0-0-auto",
                                        style: {
                                            width: "35%"
                                        },
                                        children: [
                                            "Tax (",
                                            (0, $gjxeM.FormatPercent)(invoice.taxRatePercent / 100, {
                                                decimals: 0
                                            }),
                                            ")"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        className: "flex-1-1-auto",
                                        style: {
                                            marginRight: "6%"
                                        },
                                        children: (0, $12o9H.FormatCurrency)(invoice.tax)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                className: "flex items-center justify-between",
                                style: {
                                    fontSize: "1.3em",
                                    fontWeight: 600,
                                    marginTop: "1em",
                                    paddingTop: "0.5em",
                                    borderTop: "2px solid #888"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        className: "flex-0-0-auto",
                                        style: {
                                            width: "35%"
                                        },
                                        children: "Total"
                                    }),
                                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                        className: "invoice__total-inc-tax flex-1-1-auto",
                                        style: {
                                            marginRight: "6%"
                                        },
                                        children: (0, $12o9H.FormatCurrency)(invoice.amount + invoice.tax)
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    }, invoice.id);
});
const $c2122521f4f5bec3$var$PhaseLineItems = (0, $1EEMt.observer)(({ ph: ph, invoice: invoice })=>{
    var _invoice$cachedData$p, _invoice$cachedData$p2, _invoice$cachedData$p3, _invoice$cachedData$p4, _invoice$cachedData$p5, _invoice$lineItemsByP;
    const hasProgressLine = ((_invoice$cachedData$p = invoice.cachedData.phases[ph.id]) === null || _invoice$cachedData$p === void 0 ? void 0 : _invoice$cachedData$p.fee) > 0;
    const prevPercent = ((_invoice$cachedData$p2 = invoice.cachedData.phases[ph.id]) === null || _invoice$cachedData$p2 === void 0 ? void 0 : _invoice$cachedData$p2.previousBilled) / ((_invoice$cachedData$p3 = invoice.cachedData.phases[ph.id]) === null || _invoice$cachedData$p3 === void 0 ? void 0 : _invoice$cachedData$p3.fee);
    const currentPercent = (((_invoice$cachedData$p4 = invoice.cachedData.phases[ph.id]) === null || _invoice$cachedData$p4 === void 0 ? void 0 : _invoice$cachedData$p4.previousBilled) + (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(invoice.lineItems.filter((li)=>li.billingType === "agreedFee" && li.phase === ph).map((li)=>li.amount))) / ((_invoice$cachedData$p5 = invoice.cachedData.phases[ph.id]) === null || _invoice$cachedData$p5 === void 0 ? void 0 : _invoice$cachedData$p5.fee);
    const [lineItems, setLineItems] = (0, $jbmdS.useState)(()=>{
        const items = [
            ...invoice.lineItemsByPhaseId[ph.id] || [],
            ...ph.isRootPhase ? [
                ...invoice.lineItemsByPhaseId[null] || [],
                ...invoice.lineItemsByPhaseId[undefined] || [],
                ...invoice.lineItemsByPhaseId[-1] || []
            ] : []
        ];
        // Separate items with and without position
        const positionedItems = items.filter((item)=>item.position !== undefined);
        const unpositionedItems = items.filter((item)=>item.position === undefined);
        // Sort positioned items by position
        const sortedPositionedItems = positionedItems.sort((a, b)=>a.position - b.position);
        // Sort unpositioned items using the existing logic
        const sortedUnpositionedItems = unpositionedItems.sort((a, b)=>{
            if (a.createdAt !== b.createdAt) return b.createdAt - a.createdAt;
            else if (a.initiatedAt !== b.initiatedAt) return b.initiatedAt - a.initiatedAt;
            else {
                // Sorting by the minimum date in timeEntries if present
                if (a.timeEntries.length > 0 && b.timeEntries.length > 0) {
                    const minDateA = Math.min(...a.timeEntries.map((t)=>new Date(t.date).getTime()));
                    const minDateB = Math.min(...b.timeEntries.map((t)=>new Date(t.date).getTime()));
                    if (minDateA !== minDateB) return minDateA - minDateB;
                } else if (a.timeEntries.length > 0) return -1; // a has timeEntries but b doesn't, so a comes first
                else if (b.timeEntries.length > 0) return 1; // b has timeEntries but a doesn't, so b comes first
                // Fallback to description comparison
                return (a.description || "").localeCompare(b.description || "");
            }
        });
        // Combine the sorted arrays
        return [
            ...sortedPositionedItems,
            ...sortedUnpositionedItems
        ];
    });
    const handleReorder = (sourceIndex, destinationIndex)=>{
        const items = Array.from(lineItems);
        const [reorderedItem] = items.splice(sourceIndex, 1);
        items.splice(destinationIndex, 0, reorderedItem);
        // Update the order in state
        setLineItems(items);
        // Save the new order to the backend by updating displayOrder
        items.forEach((item, index)=>{
            item.update({
                position: index
            });
        });
    };
    (0, $jbmdS.useEffect)(()=>{
        const items = [
            ...invoice.lineItemsByPhaseId[ph.id] || [],
            ...ph.isRootPhase ? [
                ...invoice.lineItemsByPhaseId[null] || [],
                ...invoice.lineItemsByPhaseId[undefined] || [],
                ...invoice.lineItemsByPhaseId[-1] || []
            ] : []
        ];
        const positionedItems = items.filter((item)=>item.position !== undefined);
        const unpositionedItems = items.filter((item)=>item.position === undefined);
        // Sort positioned items by position
        const sortedPositionedItems = positionedItems.sort((a, b)=>a.position - b.position);
        // Sort unpositioned items using the existing logic
        const sortedUnpositionedItems = unpositionedItems.sort((a, b)=>{
            if (a.createdAt !== b.createdAt) return b.createdAt - a.createdAt;
            else if (a.initiatedAt !== b.initiatedAt) return b.initiatedAt - a.initiatedAt;
            else {
                // Sorting by the minimum date in timeEntries if present
                if (a.timeEntries.length > 0 && b.timeEntries.length > 0) {
                    const minDateA = Math.min(...a.timeEntries.map((t)=>new Date(t.date).getTime()));
                    const minDateB = Math.min(...b.timeEntries.map((t)=>new Date(t.date).getTime()));
                    if (minDateA !== minDateB) return minDateA - minDateB;
                } else if (a.timeEntries.length > 0) return -1; // a has timeEntries but b doesn't, so a comes first
                else if (b.timeEntries.length > 0) return 1; // b has timeEntries but a doesn't, so b comes first
                // Fallback to description comparison
                return (a.description || "").localeCompare(b.description || "");
            }
        });
        setLineItems([
            ...sortedPositionedItems,
            ...sortedUnpositionedItems
        ]);
    }, [
        [
            ...invoice.lineItemsByPhaseId[ph.id] || [],
            ...ph.isRootPhase ? [
                ...invoice.lineItemsByPhaseId[null] || [],
                ...invoice.lineItemsByPhaseId[undefined] || [],
                ...invoice.lineItemsByPhaseId[-1] || []
            ] : []
        ].length,
        invoice.id
    ]);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("h4", {
                            style: {
                                fontSize: "1.6em",
                                margin: hasProgressLine ? "1em 0 0 0.5em" : "1em 0 0.5em 0.5em"
                            },
                            children: [
                                ph.title || ph.name,
                                hasProgressLine ? /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                                    children: [
                                        " - ",
                                        (0, $gjxeM.FormatPercent)(prevPercent),
                                        " ",
                                        /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                            style: {
                                                margin: 0,
                                                fontSize: "0.6em",
                                                position: "relative",
                                                top: "-0.25em"
                                            },
                                            className: "fa fa-arrow-right"
                                        }),
                                        (0, $gjxeM.FormatPercent)(currentPercent)
                                    ]
                                }) : ph ? /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                    style: {
                                        marginLeft: "1em",
                                        fontSize: "0.6em",
                                        color: "#888",
                                        fontStyle: "italic"
                                    },
                                    children: "(Phase has no fee set)"
                                }) : null
                            ]
                        }),
                        hasProgressLine ? /*#__PURE__*/ (0, $61Ea1.jsx)($c2122521f4f5bec3$var$PhaseProgressLine, {
                            fromPercentage: prevPercent,
                            toPercentage: currentPercent
                        }) : null
                    ]
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
                columns: $c2122521f4f5bec3$var$lineItemColumns,
                rows: lineItems.filter((r)=>!r.deletedAt),
                fullWidth: true,
                draggable: (0, $8kZ1o.canEditProjectInvoices)((0, $1BTI2.default).user, ph.project),
                onReorder: handleReorder
            }),
            (0, $8kZ1o.canEditProjectInvoices)((0, $1BTI2.default).user, ph.project) ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "flex items-center justify-between text-right",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "inline-block p-[1em]",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)($c2122521f4f5bec3$var$DropdownButton, {
                                className: "add-line-item-button",
                                buttonText: /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                                    children: [
                                        /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                                            className: "fa fa-plus",
                                            style: {
                                                margin: 0
                                            }
                                        }),
                                        "\xa0Add Line Item"
                                    ]
                                }),
                                options: [
                                    ...!(ph !== null && ph !== void 0 && ph.isRootPhase) ? [
                                        {
                                            label: "Phase Progress",
                                            value: "progress",
                                            ...ph.fee == null || ph.fee === 0 ? {
                                                disabled: true,
                                                title: "Set a fee for this phase to create progress line items"
                                            } : {}
                                        },
                                        {
                                            label: "Less Phase Previously Billed",
                                            value: "previouslyBilled"
                                        }
                                    ] : [
                                        {
                                            label: "Project Progress",
                                            value: "projectProgress"
                                        },
                                        {
                                            label: "Less Project Previously Billed",
                                            value: "projectPreviouslyBilled"
                                        }
                                    ],
                                    {
                                        label: "Timesheets",
                                        value: "timesheets"
                                    },
                                    {
                                        label: "Fixed Amount",
                                        value: "fixed"
                                    },
                                    {
                                        label: "Expense",
                                        value: "expense"
                                    },
                                    {
                                        label: "Note",
                                        value: "note"
                                    }
                                ],
                                onItemClick: (lineItemType)=>{
                                    var _invoice$cachedData$p6, _ph$expenses;
                                    switch(lineItemType){
                                        case "progress":
                                            return (0, $kRqe9.default).add({
                                                invoiceId: invoice.id,
                                                projectId: invoice.project.id,
                                                phaseId: (ph === null || ph === void 0 ? void 0 : ph.id) || invoice.project.rootPhase.id,
                                                billingType: "agreedFee",
                                                lineItemType: lineItemType,
                                                unitCost: ph.fee || 0,
                                                isTaxed: true,
                                                description: "[phase] ([phaseprogress] completion)",
                                                position: lineItems.length || 0
                                            }, {
                                                trackUpdates: true
                                            });
                                        case "projectProgress":
                                            return (0, $kRqe9.default).add({
                                                invoiceId: invoice.id,
                                                projectId: invoice.project.id,
                                                phaseId: invoice.project.rootPhase.id,
                                                billingType: "agreedFee",
                                                lineItemType: lineItemType,
                                                unitCost: invoice.project.fee,
                                                isTaxed: true,
                                                description: "[phase] ([phaseprogress] completion)",
                                                position: lineItems.length || 0
                                            }, {
                                                trackUpdates: true
                                            });
                                        case "previouslyBilled":
                                            return (0, $kRqe9.default).add({
                                                invoiceId: invoice.id,
                                                projectId: invoice.project.id,
                                                phaseId: (ph === null || ph === void 0 ? void 0 : ph.id) || invoice.project.rootPhase.id,
                                                billingType: "agreedFee",
                                                lineItemType: lineItemType,
                                                unitQuantity: 1,
                                                unitCost: ((_invoice$cachedData$p6 = invoice.cachedData.phases[ph.id]) === null || _invoice$cachedData$p6 === void 0 ? void 0 : _invoice$cachedData$p6.previousBilled) * -1 || 0,
                                                isTaxed: true,
                                                description: "Less previously billed",
                                                position: lineItems.length || 0
                                            }, {
                                                trackUpdates: true
                                            });
                                        case "projectPreviouslyBilled":
                                            return (0, $kRqe9.default).add({
                                                invoiceId: invoice.id,
                                                projectId: invoice.project.id,
                                                phaseId: (ph === null || ph === void 0 ? void 0 : ph.id) || invoice.project.rootPhase.id,
                                                billingType: "agreedFee",
                                                lineItemType: lineItemType,
                                                unitCost: (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(invoice.project.phases.map((ph)=>{
                                                    var _invoice$cachedData$p7;
                                                    return ((_invoice$cachedData$p7 = invoice.cachedData.phases[ph.id]) === null || _invoice$cachedData$p7 === void 0 ? void 0 : _invoice$cachedData$p7.previousBilled) || 0;
                                                })) * -1,
                                                isTaxed: true,
                                                description: "Less previously billed",
                                                position: lineItems.length || 0
                                            }, {
                                                trackUpdates: true
                                            });
                                        case "timesheets":
                                            return (0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $iAbfy.default), {
                                                modalId: "addTimesheetLineItem",
                                                invoice: invoice,
                                                project: invoice.project,
                                                phase: ph,
                                                position: lineItems.length || 0
                                            }));
                                        case "expense":
                                            if (ph !== null && ph !== void 0 && (_ph$expenses = ph.expenses) !== null && _ph$expenses !== void 0 && _ph$expenses.length) return (0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $7DzE4.default), {
                                                modalId: "addExpenseLineItem",
                                                invoice: invoice,
                                                project: invoice.project,
                                                phase: ph,
                                                position: lineItems.length || 0
                                            }));
                                            else return (0, $kRqe9.default).add({
                                                invoiceId: invoice.id,
                                                projectId: invoice.project.id,
                                                phaseId: (ph === null || ph === void 0 ? void 0 : ph.id) || invoice.project.rootPhase.id,
                                                billingType: "reimbursement",
                                                lineItemType: lineItemType,
                                                isTaxed: true,
                                                position: lineItems.length || 0
                                            }, {
                                                trackUpdates: true
                                            });
                                        case "note":
                                            return (0, $kRqe9.default).add({
                                                invoiceId: invoice.id,
                                                projectId: invoice.project.id,
                                                phaseId: (ph === null || ph === void 0 ? void 0 : ph.id) || invoice.project.rootPhase.id,
                                                billingType: "note",
                                                lineItemType: "note",
                                                isTaxed: true,
                                                position: lineItems.length || 0
                                            }, {
                                                trackUpdates: true
                                            });
                                        default:
                                            return (0, $kRqe9.default).add({
                                                invoiceId: invoice.id,
                                                projectId: invoice.project.id,
                                                phaseId: (ph === null || ph === void 0 ? void 0 : ph.id) || invoice.project.rootPhase.id,
                                                billingType: "agreedFee",
                                                description: "[phase] ([phaseprogress] completion)",
                                                lineItemType: lineItemType,
                                                isTaxed: true,
                                                position: lineItems.length || 0
                                            }, {
                                                trackUpdates: true
                                            });
                                    }
                                }
                            }),
                            ph !== null && ph !== void 0 && ph.isRootPhase ? /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                                className: "btn btn-default",
                                onClick: ()=>(0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $7DzE4.default), {
                                        modalId: "addExpenseLineItem",
                                        invoice: invoice,
                                        project: invoice.project,
                                        position: lineItems.length || 0
                                    })),
                                style: {
                                    marginLeft: "2em"
                                },
                                children: "Sync expenses"
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        children: ((_invoice$lineItemsByP = invoice.lineItemsByPhaseId[ph.id]) === null || _invoice$lineItemsByP === void 0 ? void 0 : _invoice$lineItemsByP.length) > 0 ? /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            style: {
                                fontSize: "1.3em",
                                display: "inline-block",
                                padding: "0.5em 4em",
                                margin: "1em 0.5em 0.5em 0.5em",
                                borderTop: "solid 2px #777"
                            },
                            children: [
                                (0, $12o9H.FormatCurrency)((0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(invoice.lineItemsByPhaseId[ph.id].map((li)=>li.amount))),
                                " + ",
                                (0, $12o9H.FormatCurrency)((0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(invoice.lineItemsByPhaseId[ph.id].map((li)=>li.tax))),
                                " ",
                                "tax"
                            ]
                        }) : null
                    })
                ]
            }) : null
        ]
    });
});
const $c2122521f4f5bec3$var$PhaseProgressLine = ({ fromPercentage: fromPercentage, toPercentage: toPercentage })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        style: {
            width: "100%",
            height: "0.5em",
            backgroundColor: "#aaa",
            position: "relative",
            margin: "0.5em 0 1em",
            overflow: "hidden"
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: Math.min(fromPercentage * 100, 100) + "%",
                    height: "100%",
                    backgroundColor: fromPercentage * 100 <= 100 ? "gold" : "#f05a28"
                }
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    position: "absolute",
                    top: 0,
                    left: fromPercentage * 100 + "%",
                    width: Math.min(toPercentage * 100 - fromPercentage * 100, 100 - fromPercentage * 100) + "%",
                    height: "100%",
                    background: toPercentage <= 100 ? "repeating-linear-gradient(135deg, gold, gold 3px, #aaa 3px, #aaa 6px)" : "repeating-linear-gradient(135deg, gold, gold 3px, #f05a28 3px, #f05a28 6px)",
                    borderRight: toPercentage <= 100 ? "solid 2px gold" : "solid 2px #f05a28"
                }
            })
        ]
    });
};
const $c2122521f4f5bec3$var$DropdownButton = ({ className: className, buttonText: buttonText, options: options, onItemClick: onItemClick, ...props })=>{
    const [isExpanded, setIsExpanded] = (0, $jbmdS.useState)(false);
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $avIhR.Dropdown3), {
        isExpanded: isExpanded,
        onToggle: (expanded)=>setIsExpanded(expanded),
        toggleElement: /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
            className: "btn btn-default invoice__phase__dropdown-toggle",
            children: buttonText
        }),
        contentStyle: {
            width: 200
        },
        ...props,
        children: options.map(function({ label: label, value: value, disabled: disabled, title: title }, i) {
            return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $avIhR.Dropdown3ListItem), {
                className: "dropdown-button__menu-item",
                identifier: value,
                disabled: disabled,
                title: title,
                onClick: ()=>onItemClick(value),
                children: label
            }, i);
        })
    });
};
const $c2122521f4f5bec3$var$LineItemDescription = (0, $1EEMt.observer)(({ value: value, onChange: onChange, stores: stores, editable: editable, lineItem: lineItem })=>{
    const li = stores.row.rowObject;
    const [focused, setFocused] = (0, $jbmdS.useState)(false);
    const templates = (0, $lu0ti.default).descriptionTemplates.filter((dt)=>!dt.deletedAt);
    const [selectedTemplate, setSelectedTemplate] = (0, $jbmdS.useState)(null);
    if (!editable) return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        style: {
            whiteSpace: "pre"
        },
        children: li.formattedDescription
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "coincraft-table-cell__textarea",
        style: {
            position: "relative",
            width: "100% "
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "flex",
                style: {
                    position: "absolute",
                    top: 0,
                    right: 0,
                    fontSize: "0.75em",
                    fontWeight: "bold",
                    height: "2em"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                        selectedOption: selectedTemplate,
                        onChange: (v)=>{
                            setSelectedTemplate(v);
                            lineItem.update({
                                description: v.description
                            });
                        },
                        options: templates,
                        optionLabel: (t)=>t === null || t === void 0 ? void 0 : t.name,
                        placeholder: "Template...",
                        variant: "secondary"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                        className: "btn btn-default",
                        style: {
                            padding: "0em 0.4em"
                        },
                        onClick: (e)=>{
                            const newTemplate = (0, $lu0ti.default).add({
                                name: "New Template",
                                description: lineItem.description
                            }, {
                                trackUpdates: true
                            });
                            (0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $A8k4f.default), {
                                modalId: "invoice-templates",
                                defaultSelectedTemplate: newTemplate,
                                defaultState: "edit"
                            }));
                        },
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                            className: "fa fa-floppy-o",
                            style: {
                                margin: 0
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("button", {
                        className: "btn btn-default",
                        style: {
                            padding: "0em 0.4em"
                        },
                        onClick: ()=>(0, $khJQv.default).openModal(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $9YZWU.default), {
                                modalId: "addTimesheetLineItem",
                                lineItem: lineItem
                            })),
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)("i", {
                            className: "fa fa-clock-o",
                            style: {
                                margin: 0
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("textarea", {
                rows: (focused ? li.description || "" : li.formattedDescription || "").split("\n").length,
                value: focused ? li.description : li.formattedDescription,
                disabled: !editable,
                onChange: (e)=>onChange(e.target.value),
                onFocus: ()=>setFocused(true),
                onBlur: ()=>setFocused(false),
                style: {
                    padding: "1.5em 1em 1em 1em"
                }
            })
        ]
    });
});

});
parcelRegister("iAbfy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d87450ca670b4af3$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $1EEMt = parcelRequire("1EEMt");

var $fEcKX = parcelRequire("fEcKX");

var $6RcUP = parcelRequire("6RcUP");

var $htkeB = parcelRequire("htkeB");
parcelRequire("QiMYe");

var $ewAM3 = parcelRequire("ewAM3");
parcelRequire("fEtu5");
var $e4TNX = parcelRequire("e4TNX");

var $eat5C = parcelRequire("eat5C");

var $02LyB = parcelRequire("02LyB");

var $kRqe9 = parcelRequire("kRqe9");

var $4hBm1 = parcelRequire("4hBm1");

var $hK7Y7 = parcelRequire("hK7Y7");

var $f4n1H = parcelRequire("f4n1H");

var $47i9t = parcelRequire("47i9t");

var $3h7sC = parcelRequire("3h7sC");

var $6un1H = parcelRequire("6un1H");
const $d87450ca670b4af3$var$dropdownOptions = [
    {
        label: "any",
        value: null
    },
    {
        label: "yes",
        value: true
    },
    {
        label: "no",
        value: false
    }
];
const $d87450ca670b4af3$var$addSingleLineItem = (invoice, phase, timeEntries, position)=>{
    const totalChargeOut = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(timeEntries.map((te)=>te.chargeOut));
    const totalHours = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(timeEntries.map((te)=>te.hours));
    const staff = [
        ...new Set(timeEntries.map((te)=>te.staff))
    ];
    (0, $kRqe9.default).add({
        projectId: invoice.projectId,
        contactId: invoice.contactId,
        invoiceId: invoice.id,
        phaseId: phase === null || phase === void 0 ? void 0 : phase.id,
        billingType: timeEntries.every((te)=>te.isVariation) ? "variation" : "agreedFee",
        lineItemType: "timesheets",
        description: "[phase] hours",
        unitQuantity: totalHours,
        unitCost: totalChargeOut / totalHours || (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).mean(staff.map((st)=>{
            return (0, $hK7Y7.default)({
                project: invoice.project,
                phase: phase,
                staff: st,
                role: st.role
            }, "chargeOut", new Date());
        })),
        timesheetIds: timeEntries.map((te)=>te.id),
        staffIds: staff.map((st)=>st.id),
        isTaxed: true,
        position: position
    }, {
        trackUpdates: true
    });
    timeEntries.forEach((te)=>te.update({
            beenInvoiced: true
        }));
};
const $d87450ca670b4af3$var$addPerStaffLineItem = (invoice, phase, timeEntries, selectedStaff, position)=>{
    const staff = [
        ...new Set(selectedStaff)
    ];
    staff.forEach((st)=>{
        const staffTimeEntries = timeEntries.filter((te)=>te.staff === st);
        const totalChargeOut = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(staffTimeEntries.map((te)=>te.chargeOut));
        const totalHours = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(staffTimeEntries.map((te)=>te.hours));
        (0, $kRqe9.default).add({
            projectId: invoice.projectId,
            contactId: invoice.contactId,
            invoiceId: invoice.id,
            phaseId: phase === null || phase === void 0 ? void 0 : phase.id,
            billingType: staffTimeEntries.every((te)=>te.isVariation) ? "variation" : "agreedFee",
            lineItemType: "timesheets",
            description: "[phase] - [staff]",
            unitQuantity: totalHours,
            unitCost: totalChargeOut / totalHours || (0, $hK7Y7.default)({
                project: invoice.project,
                phase: phase,
                staff: st,
                role: st.role
            }, "chargeOut", new Date()),
            timesheetIds: staffTimeEntries.map((te)=>te.id),
            staffIds: [
                st.id
            ],
            isTaxed: true,
            position: position
        }, {
            trackUpdates: true
        });
        timeEntries.forEach((te)=>te.update({
                beenInvoiced: true
            }));
        position++;
    });
};
const $d87450ca670b4af3$var$addPerTimeEntryLineItem = (invoice, phase, timeEntries, position)=>{
    timeEntries.filter((te)=>te.numMinutes > 0).sort((a, b)=>a.date - b.date).forEach((te)=>{
        var _te$notes;
        (0, $kRqe9.default).add({
            projectId: invoice.projectId,
            contactId: invoice.contactId,
            invoiceId: invoice.id,
            phaseId: phase === null || phase === void 0 ? void 0 : phase.id,
            billingType: te.isVariation ? "variation" : "agreedFee",
            lineItemType: "timesheets",
            description: `${(0, $4hBm1.format)(te.date, "dd/MM/yyyy")}: [phase] - [staff]` + ((_te$notes = te.notes) !== null && _te$notes !== void 0 && _te$notes.length ? `\n${te.notes}` : ""),
            unitQuantity: te.hours,
            unitCost: te.chargeOutRate || (0, $hK7Y7.default)({
                project: te.project,
                phase: te.phase,
                staff: te.staff,
                role: te.role
            }, "chargeOut", te.date || new Date()),
            timesheetIds: [
                te.id
            ],
            staffIds: [
                te.staffId
            ],
            isTaxed: true,
            position: position
        }, {
            trackUpdates: true
        });
        position++;
    });
    timeEntries.forEach((te)=>te.update({
            beenInvoiced: true
        }));
};
var $d87450ca670b4af3$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ modalId: modalId, invoice: invoice, project: project, phase: phase, position: position })=>{
    const [task, setTask] = (0, $jbmdS.useState)(null);
    const [billable, setBillable] = (0, $jbmdS.useState)(true);
    const [variation, setVariation] = (0, $jbmdS.useState)(null);
    const [staffFilter, setStaffFilter] = (0, $jbmdS.useState)("");
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6RcUP.default), {
        queryIds: [
            {
                id: `invoiceBilling-${invoice.id}`,
                queryFn: async ()=>{
                    const res = await (0, $3h7sC.trpc).legacy.getInvoicePageBillingData.query({
                        projectId: invoice.projectId,
                        startDate: (0, $4hBm1.format)(invoice.startDate, "yyyy-MM-dd"),
                        endDate: (0, $4hBm1.format)(invoice.endDate, "yyyy-MM-dd"),
                        issueDate: (0, $4hBm1.format)(invoice.issueDate, "yyyy-MM-dd")
                    });
                    return (0, $47i9t.processTRPCData)(res, `invoiceBilling-${invoice.id}`);
                },
                staleTime: 0,
                cacheTime: 0
            }
        ],
        children: /*#__PURE__*/ (0, $61Ea1.jsx)($d87450ca670b4af3$var$AddTimesheetModalContent, {
            modalId: modalId,
            invoice: invoice,
            project: project,
            phase: phase,
            position: position,
            task: task,
            setTask: setTask,
            billable: billable,
            setBillable: setBillable,
            variation: variation,
            setVariation: setVariation,
            staffFilter: staffFilter,
            setStaffFilter: setStaffFilter
        })
    });
});
const $d87450ca670b4af3$var$AddTimesheetModalContent = (0, $1EEMt.observer)(({ modalId: modalId, invoice: invoice, project: project, phase: phase, position: position, task: task, setTask: setTask, billable: billable, setBillable: setBillable, variation: variation, setVariation: setVariation, staffFilter: staffFilter, setStaffFilter: setStaffFilter })=>{
    const timeEntries = (0, $6un1H.default).getResponse(`invoiceBilling-${invoice.id}`).timeEntries.timeEntries;
    const filteredTimeEntries = [];
    const timeEntryStaff = [];
    const timeEntriesByStaffId = {};
    const timeEntryHoursByStaffId = {};
    timeEntries.forEach((te)=>{
        if (!te.deletedAt && !te.beenInvoiced && te.staff && te.project === project && (phase ? te.phase === phase : true) && te.date <= invoice.endDate && te.date >= invoice.startDate && (task ? te.task === task : true) && (billable != null ? te.isBillable === billable : true) && (variation != null ? te.isVariation === variation : true)) {
            var _te$staffId, _timeEntriesByStaffId, _te$staffId2, _timeEntryHoursByStaf;
            filteredTimeEntries.push(te);
            timeEntryStaff.push(te.staff);
            (_timeEntriesByStaffId = timeEntriesByStaffId[_te$staffId = te.staffId]) !== null && _timeEntriesByStaffId !== void 0 ? _timeEntriesByStaffId : timeEntriesByStaffId[_te$staffId] = [];
            timeEntriesByStaffId[te.staffId].push(te);
            (_timeEntryHoursByStaf = timeEntryHoursByStaffId[_te$staffId2 = te.staffId]) !== null && _timeEntryHoursByStaf !== void 0 ? _timeEntryHoursByStaf : timeEntryHoursByStaffId[_te$staffId2] = 0;
            timeEntryHoursByStaffId[te.staffId] += te.hours;
        }
    });
    const staff = [
        ...new Set([
            ...(0, $htkeB.default).activeStaff,
            ...timeEntryStaff
        ].filter((st)=>staffFilter !== null && staffFilter !== void 0 && staffFilter.length ? st.fullName.toLowerCase().includes(staffFilter.toLowerCase()) : true))
    ];
    const [selectedStaff, setSelectedStaff] = (0, $jbmdS.useState)(new Set(staff.filter((st)=>timeEntryHoursByStaffId[st.id])));
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fEcKX.default), {
        modalId: modalId,
        heading: "Add Timesheet Line Item",
        saveLabel: "Add Line Item",
        saveOptions: [
            {
                id: "single",
                label: "Grouping All Entries"
            },
            {
                id: "perStaff",
                label: "Per Staff Member"
            },
            {
                id: "perTime",
                label: "Per Time Entry"
            }
        ],
        defaultSaveOption: "perStaff",
        onSave: (saveOption)=>{
            switch(saveOption.id){
                case "single":
                    return $d87450ca670b4af3$var$addSingleLineItem(invoice, phase, filteredTimeEntries.filter((te)=>selectedStaff.has(te.staff)), position);
                case "perStaff":
                    return $d87450ca670b4af3$var$addPerStaffLineItem(invoice, phase, filteredTimeEntries.filter((te)=>selectedStaff.has(te.staff)), selectedStaff, position);
                default:
                    return $d87450ca670b4af3$var$addPerTimeEntryLineItem(invoice, phase, filteredTimeEntries.filter((te)=>selectedStaff.has(te.staff)), position);
            }
        },
        style: {
            height: Math.min(staff.length, 15) * 3 + 17 + "em"
        },
        bodyStyle: {
            padding: 0
        },
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $6RcUP.default), {
            queryIds: [
                {
                    id: `rates-${project.id}`,
                    queryFn: async ()=>{
                        const requestData = await (0, $3h7sC.trpc).legacy.getRates.query({
                            projectId: project.id
                        });
                        return (0, $47i9t.processTRPCData)(requestData, `rates-${project.id}`);
                    }
                },
                {
                    id: `tasks-${project.id}`,
                    queryFn: async ()=>{
                        const requestData = await (0, $3h7sC.trpc).legacy.getTasks.query({
                            projectId: project.id
                        });
                        return (0, $47i9t.processTRPCData)(requestData, `tasks-${project.id}`);
                    }
                }
            ],
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    className: "flex items-center justify-around p-3.5 border-b border-[#ccc]",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                    className: "flex-0-0-auto",
                                    style: {
                                        marginRight: "1em"
                                    },
                                    children: "Task:"
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.TaskSelector), {
                                    className: "task-selector flex-0-0-auto [&_span]:!text-xs",
                                    style: {
                                        maxWidth: "100%",
                                        width: "10em"
                                    },
                                    selectedTask: task,
                                    taskOptions: phase.tasks || project.tasks,
                                    onChange: setTask,
                                    variant: "secondary"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                    className: "flex-0-0-auto",
                                    style: {
                                        marginRight: "1em"
                                    },
                                    children: "Billable:"
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                                    selectedOption: $d87450ca670b4af3$var$dropdownOptions.find((o)=>(o === null || o === void 0 ? void 0 : o.value) === billable),
                                    onChange: (o)=>{
                                        const val = (0, (/*@__PURE__*/$parcel$interopDefault($f4n1H))).object(o) ? o === null || o === void 0 ? void 0 : o.value : o;
                                        setBillable(val);
                                    },
                                    options: $d87450ca670b4af3$var$dropdownOptions,
                                    optionLabel: (o)=>(o === null || o === void 0 ? void 0 : o.label) || "any",
                                    style: {
                                        width: "5em"
                                    },
                                    variant: "secondary",
                                    className: "[&_span]:!text-xs"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                    className: "flex-0-0-auto",
                                    style: {
                                        marginRight: "1em"
                                    },
                                    children: "Variation:"
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                                    selectedOption: $d87450ca670b4af3$var$dropdownOptions.find((o)=>o.value === variation),
                                    onChange: (o)=>{
                                        const val = (0, (/*@__PURE__*/$parcel$interopDefault($f4n1H))).object(o) ? o === null || o === void 0 ? void 0 : o.value : o;
                                        setVariation(val);
                                    },
                                    options: $d87450ca670b4af3$var$dropdownOptions,
                                    optionLabel: (o)=>(o === null || o === void 0 ? void 0 : o.label) || "any",
                                    style: {
                                        width: "5em"
                                    },
                                    variant: "secondary",
                                    className: "[&_span]:!text-xs"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    className: "p-3.5 border-b border-[#ccc]",
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $e4TNX.FilterTextBox), {
                        value: staffFilter,
                        onChange: setStaffFilter,
                        placeholder: "Filter Staff",
                        className: "[&_input]:border-[#ccc] [&_input]:!text-black lg:!w-full"
                    })
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    style: {
                        maxHeight: "40em",
                        overflowY: "auto"
                    },
                    children: staff.sort((a, b)=>{
                        var _a$fullName, _a$fullName$localeCom;
                        return (_a$fullName = a.fullName) === null || _a$fullName === void 0 ? void 0 : (_a$fullName$localeCom = _a$fullName.localeCompare) === null || _a$fullName$localeCom === void 0 ? void 0 : _a$fullName$localeCom.call(_a$fullName, b.fullName);
                    }).map((st)=>/*#__PURE__*/ (0, $61Ea1.jsxs)("label", {
                            style: {
                                borderBottom: "solid 1px #eee"
                            },
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("column-selector__column", "column-select-list-item", "flex items-center justify-between mb-[7px] px-3.5 py-[7px] text-left cursor-pointer [&_.disabled]:cursor-default text-sm", selectedStaff.has(st) ? "bg-[#f9dd72] hover:bg-[#f5c510]" : "bg-white hover:bg-[#fdf5d4]"),
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $61Ea1.jsx)("input", {
                                            type: "checkbox",
                                            className: "flex-0-0-auto",
                                            checked: selectedStaff.has(st),
                                            onChange: (e)=>{
                                                selectedStaff.has(st) ? selectedStaff.delete(st) : selectedStaff.add(st);
                                                setSelectedStaff(new Set(selectedStaff));
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                            style: {
                                                marginLeft: "1em"
                                            },
                                            className: "flex-0-0-auto",
                                            children: st.fullName
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsxs)("span", {
                                    style: {
                                        float: "right"
                                    },
                                    children: [
                                        "(",
                                        timeEntryHoursByStaffId[st.id] || 0,
                                        " ",
                                        "hours)"
                                    ]
                                })
                            ]
                        }, st.id))
                })
            ]
        })
    });
});

});

parcelRegister("7DzE4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58f7d35b11aebaae$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $1EEMt = parcelRequire("1EEMt");

var $fEcKX = parcelRequire("fEcKX");

var $ewAM3 = parcelRequire("ewAM3");

var $6RcUP = parcelRequire("6RcUP");

var $goLmS = parcelRequire("goLmS");

var $4JcCM = parcelRequire("4JcCM");

var $kRqe9 = parcelRequire("kRqe9");

var $eat5C = parcelRequire("eat5C");

var $8kZ1o = parcelRequire("8kZ1o");

var $3h7sC = parcelRequire("3h7sC");

var $47i9t = parcelRequire("47i9t");

var $6un1H = parcelRequire("6un1H");

var $4hBm1 = parcelRequire("4hBm1");
var $58f7d35b11aebaae$var$_class, $58f7d35b11aebaae$var$_descriptor;
function $58f7d35b11aebaae$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $58f7d35b11aebaae$var$_defineProperty(e, r, t) {
    return (r = $58f7d35b11aebaae$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $58f7d35b11aebaae$var$_toPropertyKey(t) {
    var i = $58f7d35b11aebaae$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $58f7d35b11aebaae$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $58f7d35b11aebaae$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $58f7d35b11aebaae$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
const $58f7d35b11aebaae$var$dropdownOptions = {
    any: {
        label: "any",
        value: null
    },
    yes: {
        label: "yes",
        value: true
    },
    no: {
        label: "no",
        value: false
    }
};
let $58f7d35b11aebaae$var$state = ($58f7d35b11aebaae$var$_class = class state {
    constructor(){
        $58f7d35b11aebaae$var$_initializerDefineProperty(this, "selectedExpenses", $58f7d35b11aebaae$var$_descriptor, this);
        (0, $4JcCM.makeObservable)(this);
    }
    selectExpense(e) {
        this.selectedExpenses.add(e);
    }
    deselectExpense(e) {
        this.selectedExpenses.delete(e);
    }
    clearSelectedExpenses() {
        this.selectedExpenses.clear();
    }
}, $58f7d35b11aebaae$var$_descriptor = $58f7d35b11aebaae$var$_applyDecoratedDescriptor($58f7d35b11aebaae$var$_class.prototype, "selectedExpenses", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Set();
    }
}), $58f7d35b11aebaae$var$_applyDecoratedDescriptor($58f7d35b11aebaae$var$_class.prototype, "selectExpense", [
    (0, $4JcCM.action)
], Object.getOwnPropertyDescriptor($58f7d35b11aebaae$var$_class.prototype, "selectExpense"), $58f7d35b11aebaae$var$_class.prototype), $58f7d35b11aebaae$var$_applyDecoratedDescriptor($58f7d35b11aebaae$var$_class.prototype, "deselectExpense", [
    (0, $4JcCM.action)
], Object.getOwnPropertyDescriptor($58f7d35b11aebaae$var$_class.prototype, "deselectExpense"), $58f7d35b11aebaae$var$_class.prototype), $58f7d35b11aebaae$var$_applyDecoratedDescriptor($58f7d35b11aebaae$var$_class.prototype, "clearSelectedExpenses", [
    (0, $4JcCM.action)
], Object.getOwnPropertyDescriptor($58f7d35b11aebaae$var$_class.prototype, "clearSelectedExpenses"), $58f7d35b11aebaae$var$_class.prototype), $58f7d35b11aebaae$var$_class);
const $58f7d35b11aebaae$var$State = new $58f7d35b11aebaae$var$state();
var $58f7d35b11aebaae$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ modalId: modalId, invoice: invoice, project: project, phase: phase, position: position })=>{
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6RcUP.default), {
        queryIds: [
            {
                id: `invoiceBilling-${invoice.id}`,
                queryFn: async ()=>{
                    const res = await (0, $3h7sC.trpc).legacy.getInvoicePageBillingData.query({
                        projectId: invoice.projectId,
                        startDate: (0, $4hBm1.format)(invoice.startDate, "yyyy-MM-dd"),
                        endDate: (0, $4hBm1.format)(invoice.endDate, "yyyy-MM-dd"),
                        issueDate: (0, $4hBm1.format)(invoice.issueDate, "yyyy-MM-dd")
                    });
                    return (0, $47i9t.processTRPCData)(res, `invoiceBilling-${invoice.id}`);
                },
                staleTime: 0,
                cacheTime: 0
            }
        ],
        children: /*#__PURE__*/ (0, $61Ea1.jsx)($58f7d35b11aebaae$var$AddExpenseModalContent, {
            modalId: modalId,
            invoice: invoice,
            project: project,
            phase: phase,
            position: position
        })
    });
});
const $58f7d35b11aebaae$var$AddExpenseModalContent = (0, $1EEMt.observer)(({ modalId: modalId, invoice: invoice, project: project, phase: phase, position: position })=>{
    const trackedExpenses = (0, $6un1H.default).getResponse(`invoiceBilling-${invoice.id}`).projectExpenseItems.projectExpenseItems;
    const [billable, setBillable] = (0, $jbmdS.useState)("any");
    const [inDateRange, setInDateRange] = (0, $jbmdS.useState)("any");
    const [remainingCost, setRemainingCost] = (0, $jbmdS.useState)("any");
    const expenses = ((phase === null || phase === void 0 ? void 0 : phase.expenses) || project.expenses).filter((e)=>{
        var _invoice$cachedData$e;
        const expenseItems = trackedExpenses.filter((li)=>li.expenseId === e.id && !li.deletedAt && !li.beenInvoiced);
        return ($58f7d35b11aebaae$var$dropdownOptions[billable].value == null || e.billable === $58f7d35b11aebaae$var$dropdownOptions[billable].value) && ($58f7d35b11aebaae$var$dropdownOptions[inDateRange].value == null || (e.startDate <= invoice.endDate && e.endDate >= invoice.startDate) === $58f7d35b11aebaae$var$dropdownOptions[inDateRange].value) && ($58f7d35b11aebaae$var$dropdownOptions[remainingCost].value == null || (!e.beenInvoiced && e.cost - (((_invoice$cachedData$e = invoice.cachedData.expenses[e.id]) === null || _invoice$cachedData$e === void 0 ? void 0 : _invoice$cachedData$e.previousBilled) || 0) > 0) === $58f7d35b11aebaae$var$dropdownOptions[remainingCost].value) || (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(expenseItems.map((li)=>li.cost || 0)) > 0 === $58f7d35b11aebaae$var$dropdownOptions[remainingCost].value;
    });
    const expenseColumns = [
        {
            id: "selected",
            label: "",
            width: 3,
            type: "checkbox",
            editable: (r)=>true,
            value: (r)=>{
                return $58f7d35b11aebaae$var$State.selectedExpenses.has(r);
            },
            onChange: (r)=>(v)=>{
                    $58f7d35b11aebaae$var$State.selectedExpenses.has(r) ? $58f7d35b11aebaae$var$State.deselectExpense(r) : $58f7d35b11aebaae$var$State.selectExpense(r);
                }
        },
        {
            id: "expense",
            label: "Expense",
            width: 16,
            type: "text",
            editable: (r)=>false,
            value: (r)=>r.name
        },
        {
            id: "startDate",
            label: "Start Date",
            width: 10,
            type: "date",
            editable: (r)=>false,
            value: (r)=>r.startDate
        },
        {
            id: "endDate",
            label: "End Date",
            width: 10,
            type: "date",
            editable: (r)=>false,
            value: (r)=>r.endDate
        },
        (0, $8kZ1o.canViewExpenseTracking)() ? {
            id: "trackedCost",
            label: "Tracked Cost",
            width: 10,
            type: "currency",
            editable: (r)=>false,
            value: (r)=>{
                const expenseItems = trackedExpenses.filter((li)=>li.expenseId === r.id && !li.deletedAt && !li.beenInvoiced);
                return (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(expenseItems.map((li)=>li.cost || 0));
            }
        } : null,
        {
            id: "remainingCost",
            label: "Remaining Cost",
            width: 10,
            type: "currency",
            editable: (r)=>false,
            value: (r)=>{
                var _invoice$cachedData$e2;
                const expenseLineItems = invoice.lineItems.filter((li)=>li.expenseId === r.id);
                return r.cost - (((_invoice$cachedData$e2 = invoice.cachedData.expenses[r.id]) === null || _invoice$cachedData$e2 === void 0 ? void 0 : _invoice$cachedData$e2.previousBilled) || 0) - (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(expenseLineItems.map((li)=>li.amount || 0));
            }
        },
        {
            id: "totalCost",
            label: "Total Cost",
            width: 10,
            type: "currency",
            editable: (r)=>false,
            value: (r)=>r.cost
        },
        {
            id: "billable",
            label: "Billable",
            width: 10,
            type: "boolean",
            editable: (r)=>false,
            value: (r)=>r.billable,
            style: (r)=>{
                return {
                    color: !r || r !== null && r !== void 0 && r.billable ? null : "red"
                };
            }
        }
    ].filter(Boolean);
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fEcKX.default), {
        modalId: modalId,
        heading: "Add Expense Line Items",
        bodyStyle: {
            padding: 0
        },
        width: "60em",
        saveLabel: "Add Expenses",
        saveOptions: [
            (0, $8kZ1o.canViewExpenseTracking)() ? {
                id: "tracked",
                label: "Tracked"
            } : null,
            {
                id: "remaining",
                label: "Remaining"
            },
            {
                id: "total",
                label: "Total"
            }
        ].filter(Boolean),
        defaultSaveOption: (0, $8kZ1o.canViewExpenseTracking)() ? "tracked" : "remaining",
        onSave: (saveOption)=>{
            $58f7d35b11aebaae$var$State.selectedExpenses.forEach((e)=>{
                var _invoice$cachedData$e3, _e$phase;
                let value = 0;
                const expenseItems = trackedExpenses.filter((li)=>li.expenseId === e.id && !li.deletedAt && !li.beenInvoiced);
                switch(saveOption === null || saveOption === void 0 ? void 0 : saveOption.id){
                    case "tracked":
                        value = (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(expenseItems.map((li)=>li.cost || 0));
                        break;
                    case "total":
                        value = e.cost;
                        break;
                    default:
                        // remaining
                        const expenseLineItems = invoice.lineItems.filter((li)=>li.expenseId === e.id);
                        value = e.cost - (((_invoice$cachedData$e3 = invoice.cachedData.expenses[e.id]) === null || _invoice$cachedData$e3 === void 0 ? void 0 : _invoice$cachedData$e3.previousBilled) || 0) - (0, (/*@__PURE__*/$parcel$interopDefault($eat5C))).sum(expenseLineItems.map((li)=>li.amount || 0));
                        break;
                }
                (0, $kRqe9.default).add({
                    projectId: invoice.projectId,
                    contactId: invoice.contactId,
                    invoiceId: invoice.id,
                    phaseId: ((_e$phase = e.phase) === null || _e$phase === void 0 ? void 0 : _e$phase.id) || invoice.project.rootPhase.id,
                    billingType: "reimbursement",
                    lineItemType: "expense",
                    description: e.name,
                    unitQuantity: 1,
                    unitCost: value,
                    expenseId: e.id,
                    expenseItemIds: expenseItems.map((li)=>li.id),
                    isTaxed: true,
                    position: position
                }, {
                    trackUpdates: true
                });
                expenseItems.forEach((te)=>te.update({
                        beenInvoiced: true
                    }));
                position++;
            });
            $58f7d35b11aebaae$var$State.clearSelectedExpenses();
        },
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $6RcUP.default), {
            queryIds: [
                {
                    queryFn: async ()=>{
                        const data = await (0, $3h7sC.trpc).legacy.getProjectExpenses.query({
                            projectId: project.id
                        });
                        return (0, $47i9t.processTRPCData)(data);
                    }
                }
            ],
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    className: "flex items-center justify-around p-[1em] border-b border-[#ccc]",
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                    className: "flex-0-0-auto",
                                    style: {
                                        marginRight: "1em"
                                    },
                                    children: "Billable:"
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                                    selectedOption: $58f7d35b11aebaae$var$dropdownOptions[billable],
                                    onChange: (o)=>setBillable(o),
                                    options: Object.keys($58f7d35b11aebaae$var$dropdownOptions),
                                    optionLabel: (o)=>(o === null || o === void 0 ? void 0 : o.label) || o,
                                    style: {
                                        width: "5.5em"
                                    },
                                    variant: "secondary",
                                    className: "[&_span]:!text-xs"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                    className: "flex-0-0-auto",
                                    style: {
                                        marginRight: "1em"
                                    },
                                    children: "In Date Range:"
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                                    selectedOption: $58f7d35b11aebaae$var$dropdownOptions[inDateRange],
                                    onChange: (o)=>setInDateRange(o),
                                    options: Object.keys($58f7d35b11aebaae$var$dropdownOptions),
                                    optionLabel: (o)=>(o === null || o === void 0 ? void 0 : o.label) || o,
                                    style: {
                                        width: "5.5em"
                                    },
                                    variant: "secondary",
                                    className: "[&_span]:!text-xs"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                    className: "flex-0-0-auto",
                                    style: {
                                        marginRight: "1em"
                                    },
                                    children: `${(0, $8kZ1o.canViewExpenseTracking)() ? "Tracked / " : ""}Remaining Cost:`
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewAM3.Selector), {
                                    selectedOption: $58f7d35b11aebaae$var$dropdownOptions[remainingCost],
                                    onChange: (o)=>setRemainingCost(o),
                                    options: Object.keys($58f7d35b11aebaae$var$dropdownOptions),
                                    optionLabel: (o)=>(o === null || o === void 0 ? void 0 : o.label) || o,
                                    style: {
                                        width: "5.5em"
                                    },
                                    variant: "secondary",
                                    className: "[&_span]:!text-xs"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    className: "flex items-center justify-center p-[1.5em]",
                    children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $goLmS.default), {
                        showHeader: true,
                        columns: expenseColumns,
                        rows: expenses
                    })
                })
            ]
        })
    });
});

});

parcelRegister("73du5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $522345e43dbecdc0$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $1EEMt = parcelRequire("1EEMt");

var $fEcKX = parcelRequire("fEcKX");
parcelRequire("ewAM3");
parcelRequire("6RcUP");
parcelRequire("goLmS");

parcelRequire("kRqe9");

var $fM2j4 = parcelRequire("fM2j4");

var $7GQic = parcelRequire("7GQic");
var $522345e43dbecdc0$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ modalId: modalId, invoice: invoice })=>{
    const [startDate, setStartDate] = (0, $jbmdS.useState)(invoice.startDate);
    const [endDate, setEndDate] = (0, $jbmdS.useState)(invoice.endDate);
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fEcKX.default), {
        modalId: modalId,
        heading: "Billing for Work Carried-Out During",
        bodyStyle: {
            padding: 0
        },
        saveLabel: "Save Dates",
        onSave: ()=>{
            invoice.update({
                startDate: startDate,
                endDate: endDate
            });
            (0, $fM2j4.default).saveModel(invoice);
        },
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            style: {
                padding: "2em"
            },
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    style: {
                        height: 40
                    },
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            style: {
                                display: "inline-block",
                                width: 140
                            },
                            children: "From:"
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            style: {
                                display: "inline-block",
                                position: "fixed",
                                zIndex: 1
                            },
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7GQic.default), {
                                value: startDate,
                                onChange: setStartDate
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    style: {
                        height: 40
                    },
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            style: {
                                display: "inline-block",
                                width: 140
                            },
                            children: "To:"
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            style: {
                                display: "inline-block",
                                position: "fixed"
                            },
                            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7GQic.default), {
                                value: endDate,
                                onChange: setEndDate
                            })
                        })
                    ]
                })
            ]
        })
    });
});

});

parcelRegister("9YZWU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7449c5793f1ca264$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $jbmdS = parcelRequire("jbmdS");

var $1EEMt = parcelRequire("1EEMt");

var $fEcKX = parcelRequire("fEcKX");

var $QiMYe = parcelRequire("QiMYe");
parcelRequire("ewAM3");
parcelRequire("fEtu5");
parcelRequire("eat5C");
parcelRequire("02LyB");
parcelRequire("kRqe9");

var $4hBm1 = parcelRequire("4hBm1");

var $52dEm = parcelRequire("52dEm");

var $1fkTL = parcelRequire("1fkTL");

var $l7CP3 = parcelRequire("l7CP3");
var $7449c5793f1ca264$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ modalId: modalId, lineItem: lineItem })=>{
    const timeEntries = new (0, $l7CP3.Set)((0, $QiMYe.default).timeEntries.filter((te)=>{
        return (te.hours || te.notes) && !te.deletedAt && te.staff && te.project === lineItem.project && te.phase == lineItem.phase && te.date <= lineItem.invoice.endDate && te.date >= lineItem.invoice.startDate;
    }));
    const usedTimeEntries = new (0, $l7CP3.Set)(lineItem.invoice.timeEntries.filter((te)=>te.phase == lineItem.phase));
    const initialSelectedTimeEntries = new (0, $l7CP3.Set)(lineItem.timeEntries);
    let [selectedTimeEntries, setSelectedTimeEntries] = (0, $jbmdS.useState)(new (0, $l7CP3.Set)(initialSelectedTimeEntries));
    return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $fEcKX.default), {
        modalId: modalId,
        heading: "Billing for the following time entries.",
        saveLabel: "Save Billed Time Entries",
        onSave: ()=>{
            lineItem.update({
                timesheetIds: [
                    ...selectedTimeEntries
                ].map((te)=>te.id)
            });
            initialSelectedTimeEntries.forEach((te)=>te.update({
                    beenInvoiced: false
                }) // will be set back to true if still selected
            );
            selectedTimeEntries.forEach((te)=>te.update({
                    beenInvoiced: true
                }));
        },
        bodyStyle: {
            padding: 0
        },
        children: /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            style: {
                maxHeight: "20em",
                overflowY: "auto"
            },
            children: [
                ...timeEntries
            ].sort((a, b)=>b.date - a.date).map((te)=>/*#__PURE__*/ (0, $61Ea1.jsx)($7449c5793f1ca264$var$TimesheetRow, {
                    te: te,
                    selectedTimeEntries: selectedTimeEntries,
                    setSelectedTimeEntries: setSelectedTimeEntries,
                    usedTimeEntries: usedTimeEntries,
                    initialSelectedTimeEntries: initialSelectedTimeEntries
                }))
        })
    });
});
const $7449c5793f1ca264$var$TimesheetRow = ({ te: te, selectedTimeEntries: selectedTimeEntries, setSelectedTimeEntries: setSelectedTimeEntries, usedTimeEntries: usedTimeEntries, initialSelectedTimeEntries: initialSelectedTimeEntries })=>{
    const target = (0, (/*@__PURE__*/$parcel$interopDefault($jbmdS))).useRef(null);
    const isHovering = (0, $1fkTL.default)(target, {
        enterDelay: 200,
        leaveDelay: 200
    });
    const usedInThisInvoice = usedTimeEntries.has(te) && !initialSelectedTimeEntries.has(te) && !selectedTimeEntries.has(te);
    const usedInAnotherInvoice = te.beenInvoiced && !initialSelectedTimeEntries.has(te) && !selectedTimeEntries.has(te);
    const disabled = usedInThisInvoice || usedInAnotherInvoice;
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        ref: target,
        style: {
            borderBottom: "1px solid #eee",
            background: isHovering && !disabled ? "#eee" : "transparent",
            cursor: "pointer",
            color: !disabled ? "#444" : "#888",
            padding: "0.25em 1em"
        },
        onClick: ()=>{
            if (!disabled) {
                if (!selectedTimeEntries.has(te)) setSelectedTimeEntries(new (0, $l7CP3.Set)(selectedTimeEntries.add(te)));
                else setSelectedTimeEntries(new (0, $l7CP3.Set)(selectedTimeEntries.delete(te)));
            }
        },
        children: /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
            style: {
                display: "flex",
                padding: "0.5em",
                width: "100%"
            },
            children: [
                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    style: {
                        marginRight: "2em",
                        display: "flex",
                        flex: "0 0 auto"
                    },
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsx)((0, $52dEm.default), {
                            style: {
                                marginRight: "1em"
                            },
                            value: disabled ? usedTimeEntries.has(te) : selectedTimeEntries.has(te),
                            onChange: ()=>null,
                            disabled: disabled
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            children: (0, $4hBm1.format)(te.date, "dd/MM/yyyy")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                    style: {
                        flex: "1 1 auto"
                    },
                    children: [
                        /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                            style: {
                                display: "flex",
                                justifyContent: "space-between"
                            },
                            children: [
                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                    style: {
                                        marginRight: "1em"
                                    },
                                    children: `${te.staff.fullName} ${disabled ? `(billed ${usedInThisInvoice ? "in this invoice" : "in another invoice"})` : ""}`
                                }),
                                /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                    style: {
                                        textAlign: "right"
                                    },
                                    children: `${te.hours} hours`
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                            children: te.notes
                        })
                    ]
                })
            ]
        })
    });
};

});

parcelRegister("DdIgl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $075e47bb49f3b06e$export$2e2bcd8739ae039; });
var $075e47bb49f3b06e$export$2e2bcd8739ae039 = {
    xero: {
        label: "Xero",
        getUrl: (id)=>`https://go.xero.com/app/invoicing/edit/${id}`,
        style: {
            color: "#fff",
            backgroundColor: "#11b5ea"
        }
    },
    quickbooks: {
        label: "Quickbooks",
        getUrl: (id)=>`https://app.qbo.intuit.com/app/invoice?txnId=${id}`,
        style: {
            color: "#fff",
            backgroundColor: "#2ba01d"
        }
    },
    "myob-essentials": {
        label: "MYOB",
        getUrl: (id)=>`https://essentials.myob.com.au/LA/app.htm#businesses/390816/invoices/${id}`,
        style: {
            color: "#fff",
            backgroundColor: "#6100a5"
        }
    },
    "myob-accountright": {
        label: "MYOB",
        getUrl: (id)=>`https://essentials.myob.com.au/LA/app.htm#businesses/390816/invoices/${id}`,
        style: {
            color: "#fff",
            backgroundColor: "#6100a5"
        }
    }
};

});



parcelRegister("4q3wj", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $337c5228f236eafc$export$e7b0ac011bb776c6; });

var $61Ea1 = parcelRequire("61Ea1");

var $6XFpi = parcelRequire("6XFpi");
var $64Yjc = parcelRequire("64Yjc");

var $bfRWu = parcelRequire("bfRWu");

var $kuPRw = parcelRequire("kuPRw");

var $bZfKS = parcelRequire("bZfKS");

var $7vkAx = parcelRequire("7vkAx");

var $47i9t = parcelRequire("47i9t");

var $4iw5i = parcelRequire("4iw5i");

var $5PXcS = parcelRequire("5PXcS");

var $8kZ1o = parcelRequire("8kZ1o");

var $1BTI2 = parcelRequire("1BTI2");

var $7qobO = parcelRequire("7qobO");
parcelRequire("jE5CX");

var $cxnwP = parcelRequire("cxnwP");

var $26sX2 = parcelRequire("26sX2");

var $38AIP = parcelRequire("38AIP");

var $kqntg = parcelRequire("kqntg");

var $SRJCe = parcelRequire("SRJCe");

var $jbmdS = parcelRequire("jbmdS");

var $3h7sC = parcelRequire("3h7sC");
const $337c5228f236eafc$export$e7b0ac011bb776c6 = (0, $6XFpi.createFileRoute)("/_private/invoices/$id/pdf")({
    beforeLoad: ({ params: params })=>{
        if (!(0, $8kZ1o.canViewRoute)((0, $1BTI2.default).user, "invoicePdf", params)) throw new Error("Permission Denied");
        const invoice = (0, $38AIP.getCacheItemById)("invoices", params.id);
        (0, $26sX2.setLayoutDefaults)({
            pageTitle: (invoice === null || invoice === void 0 ? void 0 : invoice.ref) || "Invoice",
            subMenu: "invoices",
            tabs: [
                {
                    id: "details",
                    label: "Details",
                    url: `/invoices/${params.id}`
                },
                {
                    id: "pdf",
                    label: "PDF",
                    url: `/invoices/${params.id}/pdf`
                }
            ]
        });
    },
    errorComponent: ({ error: error, reset: reset })=>{
        if (error.message === "Permission Denied") return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7qobO.default), {});
        return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $5PXcS.default), {
            error: error,
            reset: reset
        });
    },
    loader: async ({ params: params })=>await $337c5228f236eafc$var$loader(params.id),
    pendingComponent: (0, $4iw5i.default),
    component: $337c5228f236eafc$var$Wrapper
});
const $337c5228f236eafc$var$loader = async (id)=>{
    const data = await (0, $3h7sC.trpc).legacy.getInvoicePageData.query({
        id: id
    });
    const processedModels = (0, $47i9t.processTRPCData)(data);
    const invoice = (0, $cxnwP.default).invoicesById[id] || (0, $cxnwP.default).invoicesByOldId[id];
    if (!invoice) throw (0, $64Yjc.notFound)();
    return processedModels;
};
function $337c5228f236eafc$var$Wrapper() {
    const { id: id } = $337c5228f236eafc$export$e7b0ac011bb776c6.useParams();
    const { addToSidebar: addToSidebar } = (0, $SRJCe.useSidebarStack)();
    (0, $jbmdS.useEffect)(()=>{
        addToSidebar(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $7vkAx.default), {
            id: id
        }), {
            hideClose: true
        });
    }, []);
    if ((0, $8kZ1o.migratedToV2)()) return /*#__PURE__*/ (0, $61Ea1.jsx)((0, $61Ea1.Fragment), {
        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kqntg.CenterPadPageBody), {
            children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bfRWu.default), {
                id: id
            })
        })
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $kuPRw.default), {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bfRWu.default), {
                    id: id
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)((0, $bZfKS.default), {
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $7vkAx.default), {
                    id: id
                })
            })
        ]
    });
}

});
parcelRegister("bfRWu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $831af0414865e30f$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");

var $4hBm1 = parcelRequire("4hBm1");

var $1EEMt = parcelRequire("1EEMt");

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("eat5C");

var $cxnwP = parcelRequire("cxnwP");

var $khJQv = parcelRequire("khJQv");

var $12o9H = parcelRequire("12o9H");

var $1BTI2 = parcelRequire("1BTI2");

var $55Qb0 = parcelRequire("55Qb0");

var $8kZ1o = parcelRequire("8kZ1o");
parcelRequire("6RcUP");
parcelRequire("jE5CX");

var $6fNfM = parcelRequire("6fNfM");
var $831af0414865e30f$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ id: id })=>{
    const invoice = (0, $cxnwP.default).invoicesById[id];
    const template = (0, $1BTI2.default).organisation.defaultInvoiceTemplate;
    (0, $jbmdS.useEffect)(()=>{
        if ((0, $8kZ1o.canEditProjectInvoices)((0, $1BTI2.default).user, invoice.project)) (0, $khJQv.default).toggleSidebar(true);
    }, []);
    if (!invoice) return null;
    return /*#__PURE__*/ (0, $61Ea1.jsx)($831af0414865e30f$var$PaperPages, {
        invoice: invoice,
        template: template
    });
});
const $831af0414865e30f$var$PaperPages = (0, $1EEMt.observer)(({ invoice: invoice, template: template })=>{
    const defaultTitle = (0, $jbmdS.useRef)(document.title);
    (0, $jbmdS.useEffect)(()=>{
        document.title = invoice.ref;
        return ()=>{
            document.title = defaultTitle.current;
        };
    }, []);
    const [numPages, setNumPages] = (0, $jbmdS.useState)(1);
    const [pageContents, setPageContents] = (0, $jbmdS.useState)([
        {
            showStart: true,
            showEnd: true,
            showTable: true,
            lineItems: [
                0,
                invoice.lineItems.length - 1
            ],
            showTotals: true
        }
    ]);
    const addPageOverflow = (0, $jbmdS.useCallback)((index, content, overflowContent)=>{
        if ((pageContents[index].showStart !== content.showStart || pageContents[index].showEnd !== content.showEnd || pageContents[index].showTable !== content.showTable || pageContents[index].lineItems[0] !== content.lineItems[0] || pageContents[index].lineItems[1] !== content.lineItems[1] || pageContents[index].showTotals !== content.showTotals) && content.lineItems[1] > 0) {
            let newPageContents = [
                ...pageContents
            ];
            newPageContents[index] = {
                ...content,
                lineItems: [
                    ...content.lineItems
                ]
            };
            if (overflowContent.showStart || overflowContent.showEnd || overflowContent.showTable) newPageContents[index + 1] = {
                ...overflowContent,
                lineItems: [
                    ...overflowContent.lineItems
                ]
            };
            setPageContents(newPageContents);
            setNumPages(newPageContents.length);
        }
    }, [
        pageContents
    ]);
    const pages = [
        ...Array(numPages).keys()
    ].map((i)=>/*#__PURE__*/ (0, $61Ea1.jsx)($831af0414865e30f$var$PaperPage, {
            index: i,
            content: pageContents[i],
            addPageOverflow: addPageOverflow,
            invoice: invoice,
            invoiceTemplate: template
        }, i));
    return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
        className: "flex text-center flex-col mx-auto",
        children: pages
    });
});
const $831af0414865e30f$var$PaperPage = (0, $1EEMt.observer)(({ content: content, index: index, addPageOverflow: addPageOverflow, invoice: invoice, invoiceTemplate: invoiceTemplate })=>{
    var _invoice$lineItems;
    const pageRef = (0, $jbmdS.useRef)();
    const projectAddress = invoice.project.address; // observer hack
    (0, $jbmdS.useEffect)(()=>{
        const pageEl = pageRef.current;
        let newContent = {
            ...content,
            lineItems: [
                ...content.lineItems
            ]
        };
        const maxHeight = Math.ceil(parseFloat(getComputedStyle(pageEl).getPropertyValue("height")));
        const removeInvoiceRow = ()=>{
            if (newContent.lineItems[1] === invoice.lineItems.length - 1) {
                for (let el of pageEl.getElementsByClassName("invoice-table-totals"))el.style.display = "none";
                newContent.showTotals = false;
            }
            const rows = [
                ...pageEl.getElementsByClassName("invoice-table-row")
            ].filter((el)=>el.style.display !== "none");
            if (rows.length) {
                rows[rows.length - 1].style.display = "none";
                newContent.lineItems[1]--;
                if (newContent.lineItems[1] === 0) {
                    for (let el of pageEl.getElementsByClassName("invoice-table"))el.style.display = "none";
                    newContent.showTable = false;
                }
            }
        };
        if (pageEl.scrollHeight > maxHeight) {
            for (let el of pageEl.getElementsByClassName("content-end"))el.style.display = "none";
            newContent.showEnd = false;
        }
        const prevScrollHeight = null;
        while(pageEl.scrollHeight > maxHeight)removeInvoiceRow();
        const overflowContent = {
            showStart: false,
            showEnd: !newContent.showEnd,
            showTable: newContent.lineItems[1] < invoice.lineItems.length - 1,
            lineItems: [
                Math.min(invoice.lineItems.length - 1, newContent.lineItems[1] + 1),
                invoice.lineItems.length - 1
            ],
            showTotals: true
        };
        addPageOverflow(index, newContent, overflowContent);
    }, [
        content,
        index,
        invoiceTemplate
    ]);
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        className: "invoice-page",
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "header",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "logo",
                        style: {
                            height: `${invoiceTemplate.logoSize}em`
                        },
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)("img", {
                            src: invoiceTemplate.logoUrl,
                            alt: "logo",
                            style: {
                                height: "100%"
                            }
                        })
                    }),
                    invoiceTemplate.getProjectText(invoice) && /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "project-info",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                className: "inv-bold",
                                children: "Project"
                            }),
                            " ",
                            invoiceTemplate.getProjectText(invoice)
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "client-info",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                className: "inv-bold",
                                children: "Client"
                            }),
                            " ",
                            invoiceTemplate.getClientText(invoice)
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "issue-date",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("span", {
                                className: "inv-bold",
                                children: "Issued"
                            }),
                            " ",
                            (0, $4hBm1.format)(invoice.issueDate, "dd MMM yyyy", new Date())
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "inv-highlight inv-number",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "label",
                                children: invoiceTemplate.documentLabel
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "value",
                                children: invoice.ref
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "inv-highlight due-date",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "label",
                                children: "Due Date"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "value",
                                children: (0, $4hBm1.format)(invoice.dueDate, "dd MMM yyyy", new Date())
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "inv-highlight amount-due",
                        style: {
                            textAlign: "right"
                        },
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "label",
                                children: "Amount Due"
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "value",
                                children: (0, $12o9H.FormatCurrency)(invoice.amount + invoice.tax)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                ref: pageRef,
                className: "content",
                style: {
                    flex: "1 1 auto",
                    padding: "0.5em",
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column"
                },
                children: [
                    content.showStart && invoiceTemplate.getOpeningText(invoice) && /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "content-start",
                        style: {
                            flex: "0 0 auto",
                            lineHeight: "1.5em",
                            marginBottom: "0.5em"
                        },
                        children: invoiceTemplate.getOpeningText(invoice)
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "content-mid",
                        style: {
                            flex: "1 1 auto"
                        },
                        children: content.showTable && /*#__PURE__*/ (0, $61Ea1.jsx)($831af0414865e30f$var$InvTable, {
                            invoice: invoice,
                            invoiceTemplate: invoiceTemplate,
                            lineItems: (_invoice$lineItems = invoice.lineItems) === null || _invoice$lineItems === void 0 ? void 0 : _invoice$lineItems.sort((a, b)=>{
                                // First sort by phases using sortPhases
                                const phaseSort = (0, $6fNfM.default)(a.phase, b.phase);
                                if (phaseSort !== 0) return phaseSort;
                                // Within the same phase, sort by position
                                if (a.position !== undefined && b.position !== undefined) return a.position - b.position;
                                if (a.position !== undefined) return -1;
                                if (b.position !== undefined) return 1;
                                // For items without position in the same phase, use creation/time entry date
                                if ((a.createdAt || a.initiatedAt) && (b.createdAt || b.initiatedAt)) {
                                    const createdAtComparison = new Date(a.createdAt || a.initiatedAt) - new Date(b.createdAt || b.initiatedAt);
                                    if (createdAtComparison !== 0) return createdAtComparison;
                                    else {
                                        // If createdAt dates are the same, compare by timeEntryStartDate
                                        if (a.timeEntryStartDate && b.timeEntryStartDate) return new Date(a.timeEntryStartDate) - new Date(b.timeEntryStartDate);
                                        else if (a.timeEntryStartDate) return -1;
                                        else if (b.timeEntryStartDate) return 1;
                                    }
                                } else if (a.createdAt || a.initiatedAt) return -1;
                                else if (b.createdAt || b.initiatedAt) return 1;
                                return 0;
                            }).slice(content.lineItems[0], content.lineItems[1] + 1),
                            showTotals: content.showTotals
                        })
                    }),
                    content.showEnd && invoiceTemplate.getClosingText(invoice) && /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "content-end",
                        style: {
                            flex: "0 0 auto",
                            lineHeight: "1.5em"
                        },
                        children: invoiceTemplate.getClosingText(invoice)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                style: {
                    flex: "0 0 auto",
                    paddingTop: "0.625em",
                    borderTop: "solid 2px #444",
                    marginTop: "0.5em",
                    display: "flex",
                    justifyContent: "space-between"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        style: {
                            textAlign: "left",
                            lineHeight: "1.5em"
                        },
                        children: invoiceTemplate.footerLeft
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        style: {
                            textAlign: "right",
                            lineHeight: "1.5em"
                        },
                        children: invoiceTemplate.footerRight
                    })
                ]
            })
        ]
    });
});
const $831af0414865e30f$var$InvTable = (0, $1EEMt.observer)(({ lineItems: lineItems, invoice: invoice, invoiceTemplate: invoiceTemplate, showTotals: showTotals })=>{
    const columns = [
        ...invoiceTemplate.columns,
        ...!invoiceTemplate.columns.includes("amount") ? [
            "amount"
        ] : []
    ];
    let cells = [
        /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            className: "invoice-table-header",
            style: {
                display: "contents"
            },
            children: columns.map((c, i)=>{
                return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    className: `header cell ${(0, $55Qb0.columnDefs)[c].align}`,
                    children: (0, $55Qb0.columnDefs)[c].label
                }, i);
            })
        }, "h0")
    ];
    lineItems.forEach((line, index)=>{
        const lineClass = index !== lineItems.length - 1 ? "cell" : "cell last";
        cells.push(/*#__PURE__*/ (0, $61Ea1.jsx)("div", {
            className: "invoice-table-row",
            style: {
                display: "contents"
            },
            children: columns.map((c, i)=>{
                return /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                    className: `${lineClass} ${(0, $55Qb0.columnDefs)[c].align}`,
                    children: (0, $55Qb0.columnDefs)[c].value(line)
                }, index + i);
            })
        }, "r" + index));
    });
    return /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "invoice-table",
                style: {
                    gridTemplateColumns: columns.map((c)=>`${(0, $55Qb0.columnDefs)[c].width}fr`).join(" ")
                },
                children: cells
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "invoice-table invoice-table-totals",
                style: {
                    gridTemplateColumns: "3fr 1fr 1fr 1fr"
                },
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "cell right total label",
                        children: "Sub total"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "cell right total amount",
                        children: (0, $12o9H.FormatCurrency)(invoice.amount)
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "cell right total label",
                        children: invoiceTemplate.taxName
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "cell right total amount",
                        children: (0, $12o9H.FormatCurrency)(invoice.tax)
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "cell right total label last",
                        children: "Amount Due"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "cell right total amount last",
                        children: (0, $12o9H.FormatCurrency)(invoice.amount + invoice.tax)
                    })
                ]
            })
        ]
    });
});

});
parcelRegister("55Qb0", function(module, exports) {

$parcel$export(module.exports, "columnDefs", function () { return $3b55e48780fcdcff$export$d6bc7e4be37f31f1; });

var $12o9H = parcelRequire("12o9H");

var $cwjKY = parcelRequire("cwjKY");

var $drjRi = parcelRequire("drjRi");

var $gjxeM = parcelRequire("gjxeM");
const $3b55e48780fcdcff$export$d6bc7e4be37f31f1 = {
    description: {
        key: "description",
        label: "Description",
        value: (line)=>line.formattedDescription,
        width: 3,
        align: "left"
    },
    quantity: {
        key: "quantity",
        label: "Quantity",
        value: (line)=>(line.lineItemType, [
                "progress",
                "projectProgress"
            ].includes(line.lineItemType) ? (0, $gjxeM.FormatPercent)(line.unitQuantity) : (0, $cwjKY.FormatNumber)(line.unitQuantity)),
        width: 1,
        align: "right"
    },
    unitPrice: {
        key: "unitPrice",
        label: "Unit Price",
        value: (line)=>(line.lineItemType, (0, $12o9H.FormatCurrency)(line.unitCost)),
        width: 1,
        align: "right"
    },
    phase: {
        key: "phase",
        label: "Phase",
        value: (0, $drjRi.getDescriptionCodeText).phase,
        width: 3,
        align: "left"
    },
    previouslyBilled: {
        key: "previouslyBilled",
        label: "Previously Billed",
        value: (0, $drjRi.getDescriptionCodeText).previousbilled,
        width: 1,
        align: "right"
    },
    progress: {
        key: "progress",
        label: "Progress",
        value: (0, $drjRi.getDescriptionCodeText).phaseprogress,
        width: 1,
        align: "left"
    },
    amount: {
        key: "amount",
        label: "Amount",
        value: (line)=>(line.lineItemType, (0, $12o9H.FormatCurrency)(line.amount)),
        width: 1,
        align: "right"
    }
};

});


parcelRegister("7vkAx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $576b660fde58929b$export$2e2bcd8739ae039; });

var $61Ea1 = parcelRequire("61Ea1");


var $1EEMt = parcelRequire("1EEMt");
parcelRequire("jbmdS");
parcelRequire("eat5C");

var $6N1HV = parcelRequire("6N1HV");
var $ewjEc = parcelRequire("ewjEc");
var $hRCNE = parcelRequire("hRCNE");

var $55Qb0 = parcelRequire("55Qb0");

var $cxnwP = parcelRequire("cxnwP");

var $1BTI2 = parcelRequire("1BTI2");

var $8kZ1o = parcelRequire("8kZ1o");

var $c86dX = parcelRequire("c86dX");
const { TextArea: $576b660fde58929b$var$TextArea } = (0, $6N1HV.default);
var $576b660fde58929b$export$2e2bcd8739ae039 = (0, $1EEMt.observer)(({ id: id })=>{
    const invoice = (0, $cxnwP.default).invoicesById[id];
    const template = (0, $1BTI2.default).organisation.defaultInvoiceTemplate;
    if (!invoice || !(0, $8kZ1o.canEditProjectInvoices)((0, $1BTI2.default).user, invoice.project)) return null;
    return /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
        style: {
            padding: "1em"
        },
        children: [
            /*#__PURE__*/ (0, $61Ea1.jsx)("h3", {
                style: {
                    margin: "0.5em 0 0 0"
                },
                children: "Logo"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    textAlign: "center"
                },
                children: /*#__PURE__*/ (0, $61Ea1.jsx)("img", {
                    style: {
                        height: "5em"
                    },
                    alt: "logo",
                    src: template.logoUrl
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "flex items-center mt-1 text-sm",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "py-0 px-[0.5em] font-bold text-sm",
                        style: {
                            flex: "0 0 auto"
                        },
                        children: "Logo URL"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "flex-1 py-0 px-[0.25em] !text-sm",
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6N1HV.default), {
                            value: template.logoUrl || "",
                            onChange: (e)=>template.update({
                                    logoUrl: e.target.value
                                })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "flex items-center mt-1 text-sm",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "font-bold py-0 px-[0.5em]",
                        children: "Logo Size"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "flex-1 py-0 px-[0.25em]",
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $ewjEc.default), {
                            value: template.logoSize,
                            onChange: (v)=>{
                                template.update({
                                    logoSize: parseFloat(v)
                                });
                            },
                            min: 1,
                            max: 20
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "flex items-center mt-12 text-sm",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "text-sm font-bold px-[0.5em]",
                        style: {
                            flex: "0 0 auto"
                        },
                        children: "Document Label"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        style: {
                            flex: "1 1 auto",
                            padding: "0 0.25em"
                        },
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6N1HV.default), {
                            value: template.documentLabel || "",
                            onChange: (e)=>template.update({
                                    documentLabel: e.target.value
                                })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("h3", {
                style: {
                    margin: "1.5em 0 0 0"
                },
                children: "Header"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "flex items-center mt-1 text-sm",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "px-[0.5em] py-0",
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hRCNE.default), {
                            checked: template.projectCode,
                            onChange: (projectCode)=>{
                                template.update({
                                    projectCode: projectCode
                                });
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "flex-1 py-0 px-[0.25em] text-sm",
                        children: "Display Project Code"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "flex items-center mt-1 text-sm",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        style: {
                            flex: "0 0 auto",
                            padding: "0 0.5em"
                        },
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hRCNE.default), {
                            checked: template.projectName,
                            onChange: (projectName)=>{
                                template.update({
                                    projectName: projectName
                                });
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "flex-1 py-0 px-[0.25em] text-sm",
                        children: "Display Project Name"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "flex items-center mt-1 text-sm",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "py-0 px-[0.5em]",
                        style: {
                            flex: "0 0 auto"
                        },
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hRCNE.default), {
                            checked: template.projectAddress,
                            onChange: (projectAddress)=>{
                                template.update({
                                    projectAddress: projectAddress
                                });
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "flex-1 py-0 px-[0.25em] text-sm",
                        children: "Display Project Address"
                    })
                ]
            }),
            template.projectAddress && /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "mt-[1.5em] font-bold text-sm",
                        children: "Project Address"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        style: {
                            fontSize: "1.2rem",
                            padding: "0 0.75em 0 0"
                        },
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)($576b660fde58929b$var$TextArea, {
                            value: invoice.project.address,
                            onChange: (e)=>{
                                invoice.project.update({
                                    address: e.target.value
                                });
                            },
                            placeholder: "Edit Project Address...",
                            autoSize: {
                                minRows: 3,
                                maxRows: 4
                            },
                            allowClear: true
                        })
                    })
                ]
            }),
            invoice.contact && /*#__PURE__*/ (0, $61Ea1.jsxs)((0, $61Ea1.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "mt-[1em] font-bold text-sm",
                        children: "Client Address"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "text-sm pr-[0.75em]",
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)($576b660fde58929b$var$TextArea, {
                            value: invoice.contact.address,
                            onChange: (e)=>{
                                invoice.contact.update({
                                    address: e.target.value
                                });
                            },
                            placeholder: "Edit client address...",
                            autoSize: {
                                minRows: 3,
                                maxRows: 4
                            },
                            allowClear: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("h3", {
                style: {
                    margin: "1.5em 0 0 0"
                },
                children: "Content"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: 'mt-[1em] font-bold text-sm"',
                children: "Opening Statement"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "text-sm pr-[0.75em]",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)($576b660fde58929b$var$TextArea, {
                        value: template.getOpeningText(invoice),
                        onChange: (e)=>{
                            template.update({
                                contentStart: e.target.value
                            }, null, invoice);
                        },
                        placeholder: "Enter some notes...",
                        autoSize: {
                            minRows: 5,
                            maxRows: 10
                        },
                        allowClear: true
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        style: {
                            display: "flex",
                            alignItems: "center",
                            marginTop: "0.5rem",
                            fontSize: "1.2rem"
                        },
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                style: {
                                    flex: "0 0 auto",
                                    padding: "0 0.5em"
                                },
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hRCNE.default), {
                                    size: "small",
                                    checked: template.openPerProject,
                                    onChange: (openPerProject)=>{
                                        template.update({
                                            openPerProject: openPerProject
                                        });
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "flex-1 py-0 px-[0.25em] text-sm",
                                children: "Unique to Each Project"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "mt-[2em] font-bold text-sm",
                children: "Table Columns"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    fontSize: "1.2rem",
                    padding: "0 0.75em 0 0"
                },
                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $c86dX.MultiSelect), {
                    selectedOptions: template.columns.filter((ck)=>![
                            "amount"
                        ].includes(ck)).map((ck)=>(0, $55Qb0.columnDefs)[ck]),
                    onChange: (v)=>template.update({
                            columns: [
                                ...v.map((v)=>v.key),
                                "amount"
                            ]
                        }),
                    options: Object.values((0, $55Qb0.columnDefs)).filter((v)=>v.key !== "amount"),
                    optionLabel: (o)=>o.label,
                    optionValue: (o)=>o,
                    searchMatcher: (c, text)=>c === null || c === void 0 ? void 0 : c.label.toLowerCase().match(text === null || text === void 0 ? void 0 : text.toLowerCase()),
                    styles: {
                        multiValueLabel: (provided, state)=>({
                                ...provided,
                                fontSize: "12px"
                            })
                    }
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "flex items-center mt-12 text-sm",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        className: "text-sm font-bold px-[0.5em]",
                        style: {
                            flex: "0 0 auto"
                        },
                        children: "Tax Label"
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                        style: {
                            flex: "1 1 auto",
                            padding: "0 0.25em"
                        },
                        children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $6N1HV.default), {
                            value: template.taxName || "",
                            onChange: (e)=>template.update({
                                    taxName: e.target.value
                                })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "mt-[2em] font-bold text-sm",
                children: "Closing Statement"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                className: "text-sm pr-[0.75em]",
                children: [
                    /*#__PURE__*/ (0, $61Ea1.jsx)($576b660fde58929b$var$TextArea, {
                        value: template.getClosingText(invoice),
                        onChange: (e)=>{
                            template.update({
                                contentEnd: e.target.value
                            }, null, invoice);
                        },
                        placeholder: "Enter some notes...",
                        autoSize: {
                            minRows: 5,
                            maxRows: 10
                        },
                        allowClear: true
                    }),
                    /*#__PURE__*/ (0, $61Ea1.jsxs)("div", {
                        className: "flex items-center mt-2 text-sm",
                        children: [
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "px-[0.5em]",
                                style: {
                                    flex: "0 0 auto"
                                },
                                children: /*#__PURE__*/ (0, $61Ea1.jsx)((0, $hRCNE.default), {
                                    size: "small",
                                    checked: template.closePerProject,
                                    onChange: (closePerProject)=>{
                                        template.update({
                                            closePerProject: closePerProject
                                        });
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                                className: "text-sm px-[0.25em] flex-1",
                                children: "Unique to Each Project"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("h3", {
                style: {
                    margin: "1.5em 0 0 0"
                },
                children: "Footer"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "text-sm font-bold mt-[1em]",
                children: "Left"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    fontSize: "12px",
                    padding: "0 0.75em 0 0"
                },
                children: /*#__PURE__*/ (0, $61Ea1.jsx)($576b660fde58929b$var$TextArea, {
                    value: template.footerLeft,
                    onChange: (e)=>{
                        template.update({
                            footerLeft: e.target.value
                        });
                    },
                    style: {
                        fontSize: "12px"
                    },
                    placeholder: "Enter some notes...",
                    autoSize: {
                        minRows: 4,
                        maxRows: 6
                    },
                    allowClear: true
                })
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                className: "text-sm font-bold mt-[1em]",
                children: "Right"
            }),
            /*#__PURE__*/ (0, $61Ea1.jsx)("div", {
                style: {
                    fontSize: "12px",
                    padding: "0 0.75em 0 0"
                },
                children: /*#__PURE__*/ (0, $61Ea1.jsx)($576b660fde58929b$var$TextArea, {
                    value: template.footerRight,
                    onChange: (e)=>{
                        template.update({
                            footerRight: e.target.value
                        });
                    },
                    style: {
                        fontSize: "12px"
                    },
                    placeholder: "Enter some notes...",
                    autoSize: {
                        minRows: 4,
                        maxRows: 6
                    },
                    allowClear: true
                })
            })
        ]
    });
});

});
parcelRegister("ewjEc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9234b6627348399$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $8K2NM = parcelRequire("8K2NM");

var $jncUt = parcelRequire("jncUt");

var $CZyex = parcelRequire("CZyex");

var $4AJEj = parcelRequire("4AJEj");

var $cvQCu = parcelRequire("cvQCu");

var $02LyB = parcelRequire("02LyB");

var $44JPx = parcelRequire("44JPx");

var $jbmdS = parcelRequire("jbmdS");
parcelRequire("8uDri");
var $ewikT = parcelRequire("ewikT");

var $kgIuF = parcelRequire("kgIuF");

var $7VQDG = parcelRequire("7VQDG");

var $3ACNS = parcelRequire("3ACNS");

var $9RKXl = parcelRequire("9RKXl");

var $l34u6 = parcelRequire("l34u6");

var $j4i2o = parcelRequire("j4i2o");
var $a9234b6627348399$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $a9234b6627348399$var$InputNumber = /*#__PURE__*/ $jbmdS.forwardRef(function(props, ref) {
    var _React$useContext = $jbmdS.useContext((0, $ewikT.ConfigContext)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var size = $jbmdS.useContext((0, $7VQDG.default));
    var _React$useState = $jbmdS.useState(false), _React$useState2 = (0, $CZyex.default)(_React$useState, 2), focused = _React$useState2[0], setFocus = _React$useState2[1];
    var inputRef = $jbmdS.useRef(null);
    $jbmdS.useImperativeHandle(ref, function() {
        return inputRef.current;
    });
    var className = props.className, customizeSize = props.size, customDisabled = props.disabled, customizePrefixCls = props.prefixCls, addonBefore = props.addonBefore, addonAfter = props.addonAfter, prefix = props.prefix, _props$bordered = props.bordered, bordered = _props$bordered === void 0 ? true : _props$bordered, readOnly = props.readOnly, customStatus = props.status, controls = props.controls, others = $a9234b6627348399$var$__rest(props, [
        "className",
        "size",
        "disabled",
        "prefixCls",
        "addonBefore",
        "addonAfter",
        "prefix",
        "bordered",
        "readOnly",
        "status",
        "controls"
    ]);
    var prefixCls = getPrefixCls("input-number", customizePrefixCls);
    var _useCompactItemContex = (0, $9RKXl.useCompactItemContext)(prefixCls, direction), compactSize = _useCompactItemContex.compactSize, compactItemClassnames = _useCompactItemContex.compactItemClassnames;
    var upIcon = /*#__PURE__*/ $jbmdS.createElement((0, $cvQCu.default), {
        className: "".concat(prefixCls, "-handler-up-inner")
    });
    var downIcon = /*#__PURE__*/ $jbmdS.createElement((0, $4AJEj.default), {
        className: "".concat(prefixCls, "-handler-down-inner")
    });
    var controlsTemp = typeof controls === "boolean" ? controls : undefined;
    if ((0, $jncUt.default)(controls) === "object") {
        upIcon = typeof controls.upIcon === "undefined" ? upIcon : /*#__PURE__*/ $jbmdS.createElement("span", {
            className: "".concat(prefixCls, "-handler-up-inner")
        }, controls.upIcon);
        downIcon = typeof controls.downIcon === "undefined" ? downIcon : /*#__PURE__*/ $jbmdS.createElement("span", {
            className: "".concat(prefixCls, "-handler-down-inner")
        }, controls.downIcon);
    }
    var _useContext = (0, $jbmdS.useContext)((0, $3ACNS.FormItemInputContext)), hasFeedback = _useContext.hasFeedback, contextStatus = _useContext.status, isFormItemInput = _useContext.isFormItemInput, feedbackIcon = _useContext.feedbackIcon;
    var mergedStatus = (0, $j4i2o.getMergedStatus)(contextStatus, customStatus);
    var mergeSize = compactSize || customizeSize || size;
    // ===================== Disabled =====================
    var disabled = $jbmdS.useContext((0, $kgIuF.default));
    var mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    var inputNumberClass = (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)({}, "".concat(prefixCls, "-lg"), mergeSize === "large"), "".concat(prefixCls, "-sm"), mergeSize === "small"), "".concat(prefixCls, "-rtl"), direction === "rtl"), "".concat(prefixCls, "-borderless"), !bordered), "".concat(prefixCls, "-in-form-item"), isFormItemInput), (0, $j4i2o.getStatusClassNames)(prefixCls, mergedStatus), compactItemClassnames, className);
    var element = /*#__PURE__*/ $jbmdS.createElement((0, $44JPx.default), (0, $7i29i.default)({
        ref: inputRef,
        disabled: mergedDisabled,
        className: inputNumberClass,
        upHandler: upIcon,
        downHandler: downIcon,
        prefixCls: prefixCls,
        readOnly: readOnly,
        controls: controlsTemp
    }, others));
    if (prefix != null || hasFeedback) {
        var affixWrapperCls = (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("".concat(prefixCls, "-affix-wrapper"), (0, $j4i2o.getStatusClassNames)("".concat(prefixCls, "-affix-wrapper"), mergedStatus, hasFeedback), (0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)({}, "".concat(prefixCls, "-affix-wrapper-focused"), focused), "".concat(prefixCls, "-affix-wrapper-disabled"), props.disabled), "".concat(prefixCls, "-affix-wrapper-sm"), size === "small"), "".concat(prefixCls, "-affix-wrapper-lg"), size === "large"), "".concat(prefixCls, "-affix-wrapper-rtl"), direction === "rtl"), "".concat(prefixCls, "-affix-wrapper-readonly"), readOnly), "".concat(prefixCls, "-affix-wrapper-borderless"), !bordered), "".concat(className), !(addonBefore || addonAfter) && className));
        element = /*#__PURE__*/ $jbmdS.createElement("div", {
            className: affixWrapperCls,
            style: props.style,
            onMouseUp: function onMouseUp() {
                return inputRef.current.focus();
            }
        }, prefix && /*#__PURE__*/ $jbmdS.createElement("span", {
            className: "".concat(prefixCls, "-prefix")
        }, prefix), (0, $l34u6.cloneElement)(element, {
            style: null,
            value: props.value,
            onFocus: function onFocus(event) {
                var _a;
                setFocus(true);
                (_a = props.onFocus) === null || _a === void 0 || _a.call(props, event);
            },
            onBlur: function onBlur(event) {
                var _a;
                setFocus(false);
                (_a = props.onBlur) === null || _a === void 0 || _a.call(props, event);
            }
        }), hasFeedback && /*#__PURE__*/ $jbmdS.createElement("span", {
            className: "".concat(prefixCls, "-suffix")
        }, feedbackIcon));
    }
    if (addonBefore != null || addonAfter != null) {
        var wrapperClassName = "".concat(prefixCls, "-group");
        var addonClassName = "".concat(wrapperClassName, "-addon");
        var addonBeforeNode = addonBefore ? /*#__PURE__*/ $jbmdS.createElement("div", {
            className: addonClassName
        }, addonBefore) : null;
        var addonAfterNode = addonAfter ? /*#__PURE__*/ $jbmdS.createElement("div", {
            className: addonClassName
        }, addonAfter) : null;
        var mergedWrapperClassName = (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("".concat(prefixCls, "-wrapper"), wrapperClassName, (0, $8K2NM.default)({}, "".concat(wrapperClassName, "-rtl"), direction === "rtl"));
        var mergedGroupClassName = (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))("".concat(prefixCls, "-group-wrapper"), (0, $8K2NM.default)((0, $8K2NM.default)((0, $8K2NM.default)({}, "".concat(prefixCls, "-group-wrapper-sm"), size === "small"), "".concat(prefixCls, "-group-wrapper-lg"), size === "large"), "".concat(prefixCls, "-group-wrapper-rtl"), direction === "rtl"), (0, $j4i2o.getStatusClassNames)("".concat(prefixCls, "-group-wrapper"), mergedStatus, hasFeedback), className);
        element = /*#__PURE__*/ $jbmdS.createElement("div", {
            className: mergedGroupClassName,
            style: props.style
        }, /*#__PURE__*/ $jbmdS.createElement("div", {
            className: mergedWrapperClassName
        }, addonBeforeNode && /*#__PURE__*/ $jbmdS.createElement((0, $9RKXl.NoCompactStyle), null, /*#__PURE__*/ $jbmdS.createElement((0, $3ACNS.NoFormStyle), {
            status: true,
            override: true
        }, addonBeforeNode)), (0, $l34u6.cloneElement)(element, {
            style: null,
            disabled: mergedDisabled
        }), addonAfterNode && /*#__PURE__*/ $jbmdS.createElement((0, $9RKXl.NoCompactStyle), null, /*#__PURE__*/ $jbmdS.createElement((0, $3ACNS.NoFormStyle), {
            status: true,
            override: true
        }, addonAfterNode))));
    }
    return element;
});
var $a9234b6627348399$export$2e2bcd8739ae039 = $a9234b6627348399$var$InputNumber;

});
parcelRegister("cvQCu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91c132770003c8dc$export$2e2bcd8739ae039; });

var $lv6ip = parcelRequire("lv6ip");

var $jbmdS = parcelRequire("jbmdS");

var $a0ebw = parcelRequire("a0ebw");

var $4hKc4 = parcelRequire("4hKc4");
var $91c132770003c8dc$var$UpOutlined = function UpOutlined(props, ref) {
    return /*#__PURE__*/ $jbmdS.createElement((0, $4hKc4.default), (0, $lv6ip.default)((0, $lv6ip.default)({}, props), {}, {
        ref: ref,
        icon: (0, $a0ebw.default)
    }));
};
var $91c132770003c8dc$var$RefIcon = /*#__PURE__*/ $jbmdS.forwardRef($91c132770003c8dc$var$UpOutlined);
var $91c132770003c8dc$export$2e2bcd8739ae039 = $91c132770003c8dc$var$RefIcon;

});
parcelRegister("a0ebw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7484e849cab4bd8b$export$2e2bcd8739ae039; });
// This icon file is generated automatically.
var $7484e849cab4bd8b$var$UpOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 00140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z"
                }
            }
        ]
    },
    "name": "up",
    "theme": "outlined"
};
var $7484e849cab4bd8b$export$2e2bcd8739ae039 = $7484e849cab4bd8b$var$UpOutlined;

});


parcelRegister("44JPx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f7b16193c44e9c9$export$2e2bcd8739ae039; });

var $2lQWI = parcelRequire("2lQWI");
var $2f7b16193c44e9c9$export$2e2bcd8739ae039 = (0, $2lQWI.default);

});
parcelRegister("2lQWI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b669cf07a0a77ae$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $8K2NM = parcelRequire("8K2NM");

var $jncUt = parcelRequire("jncUt");

var $CZyex = parcelRequire("CZyex");

var $ccQt4 = parcelRequire("ccQt4");

var $jbmdS = parcelRequire("jbmdS");

var $02LyB = parcelRequire("02LyB");

var $5yi5E = parcelRequire("5yi5E");

var $iDOLX = parcelRequire("iDOLX");

var $aKVEK = parcelRequire("aKVEK");

var $darv0 = parcelRequire("darv0");

var $i8FuJ = parcelRequire("i8FuJ");

var $9ZT3M = parcelRequire("9ZT3M");

var $2Mydu = parcelRequire("2Mydu");

var $kD1EI = parcelRequire("kD1EI");
var $1b669cf07a0a77ae$var$_excluded = [
    "prefixCls",
    "className",
    "style",
    "min",
    "max",
    "step",
    "defaultValue",
    "value",
    "disabled",
    "readOnly",
    "upHandler",
    "downHandler",
    "keyboard",
    "controls",
    "stringMode",
    "parser",
    "formatter",
    "precision",
    "decimalSeparator",
    "onChange",
    "onInput",
    "onPressEnter",
    "onStep"
];
/**
 * We support `stringMode` which need handle correct type when user call in onChange
 * format max or min value
 * 1. if isInvalid return null
 * 2. if precision is undefined, return decimal
 * 3. format with precision
 *    I. if max > 0, round down with precision. Example: max= 3.5, precision=0  afterFormat: 3
 *    II. if max < 0, round up with precision. Example: max= -3.5, precision=0  afterFormat: -4
 *    III. if min > 0, round up with precision. Example: min= 3.5, precision=0  afterFormat: 4
 *    IV. if min < 0, round down with precision. Example: max= -3.5, precision=0  afterFormat: -3
 */ var $1b669cf07a0a77ae$var$getDecimalValue = function getDecimalValue(stringMode, decimalValue) {
    if (stringMode || decimalValue.isEmpty()) return decimalValue.toString();
    return decimalValue.toNumber();
};
var $1b669cf07a0a77ae$var$getDecimalIfValidate = function getDecimalIfValidate(value) {
    var decimal = (0, $darv0.default)(value);
    return decimal.isInvalidate() ? null : decimal;
};
var $1b669cf07a0a77ae$var$InputNumber = /*#__PURE__*/ $jbmdS.forwardRef(function(props, ref) {
    var _classNames;
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-input-number" : _props$prefixCls, className = props.className, style = props.style, min = props.min, max = props.max, _props$step = props.step, step = _props$step === void 0 ? 1 : _props$step, defaultValue = props.defaultValue, value = props.value, disabled = props.disabled, readOnly = props.readOnly, upHandler = props.upHandler, downHandler = props.downHandler, keyboard = props.keyboard, _props$controls = props.controls, controls = _props$controls === void 0 ? true : _props$controls, stringMode = props.stringMode, parser = props.parser, formatter = props.formatter, precision = props.precision, decimalSeparator = props.decimalSeparator, onChange = props.onChange, onInput = props.onInput, onPressEnter = props.onPressEnter, onStep = props.onStep, inputProps = (0, $ccQt4.default)(props, $1b669cf07a0a77ae$var$_excluded);
    var inputClassName = "".concat(prefixCls, "-input");
    var inputRef = $jbmdS.useRef(null);
    var _React$useState = $jbmdS.useState(false), _React$useState2 = (0, $CZyex.default)(_React$useState, 2), focus = _React$useState2[0], setFocus = _React$useState2[1];
    var userTypingRef = $jbmdS.useRef(false);
    var compositionRef = $jbmdS.useRef(false);
    var shiftKeyRef = $jbmdS.useRef(false);
    // ============================ Value =============================
    // Real value control
    var _React$useState3 = $jbmdS.useState(function() {
        return (0, $darv0.default)(value !== null && value !== void 0 ? value : defaultValue);
    }), _React$useState4 = (0, $CZyex.default)(_React$useState3, 2), decimalValue = _React$useState4[0], setDecimalValue = _React$useState4[1];
    function setUncontrolledDecimalValue(newDecimal) {
        if (value === undefined) setDecimalValue(newDecimal);
    }
    // ====================== Parser & Formatter ======================
    /**
   * `precision` is used for formatter & onChange.
   * It will auto generate by `value` & `step`.
   * But it will not block user typing.
   *
   * Note: Auto generate `precision` is used for legacy logic.
   * We should remove this since we already support high precision with BigInt.
   *
   * @param number  Provide which number should calculate precision
   * @param userTyping  Change by user typing
   */ var getPrecision = $jbmdS.useCallback(function(numStr, userTyping) {
        if (userTyping) return undefined;
        if (precision >= 0) return precision;
        return Math.max((0, $9ZT3M.getNumberPrecision)(numStr), (0, $9ZT3M.getNumberPrecision)(step));
    }, [
        precision,
        step
    ]);
    // >>> Parser
    var mergedParser = $jbmdS.useCallback(function(num) {
        var numStr = String(num);
        if (parser) return parser(numStr);
        var parsedStr = numStr;
        if (decimalSeparator) parsedStr = parsedStr.replace(decimalSeparator, ".");
        // [Legacy] We still support auto convert `$ 123,456` to `123456`
        return parsedStr.replace(/[^\w.-]+/g, "");
    }, [
        parser,
        decimalSeparator
    ]);
    // >>> Formatter
    var inputValueRef = $jbmdS.useRef("");
    var mergedFormatter = $jbmdS.useCallback(function(number, userTyping) {
        if (formatter) return formatter(number, {
            userTyping: userTyping,
            input: String(inputValueRef.current)
        });
        var str = typeof number === "number" ? (0, $9ZT3M.num2str)(number) : number;
        // User typing will not auto format with precision directly
        if (!userTyping) {
            var mergedPrecision = getPrecision(str, userTyping);
            if ((0, $9ZT3M.validateNumber)(str) && (decimalSeparator || mergedPrecision >= 0)) {
                // Separator
                var separatorStr = decimalSeparator || ".";
                str = (0, $darv0.toFixed)(str, separatorStr, mergedPrecision);
            }
        }
        return str;
    }, [
        formatter,
        getPrecision,
        decimalSeparator
    ]);
    // ========================== InputValue ==========================
    /**
   * Input text value control
   *
   * User can not update input content directly. It update with follow rules by priority:
   *  1. controlled `value` changed
   *    * [SPECIAL] Typing like `1.` should not immediately convert to `1`
   *  2. User typing with format (not precision)
   *  3. Blur or Enter trigger revalidate
   */ var _React$useState5 = $jbmdS.useState(function() {
        var initValue = defaultValue !== null && defaultValue !== void 0 ? defaultValue : value;
        if (decimalValue.isInvalidate() && [
            "string",
            "number"
        ].includes((0, $jncUt.default)(initValue))) return Number.isNaN(initValue) ? "" : initValue;
        return mergedFormatter(decimalValue.toString(), false);
    }), _React$useState6 = (0, $CZyex.default)(_React$useState5, 2), inputValue = _React$useState6[0], setInternalInputValue = _React$useState6[1];
    inputValueRef.current = inputValue;
    // Should always be string
    function setInputValue(newValue, userTyping) {
        setInternalInputValue(mergedFormatter(// Invalidate number is sometime passed by external control, we should let it go
        // Otherwise is controlled by internal interactive logic which check by userTyping
        // You can ref 'show limited value when input is not focused' test for more info.
        newValue.isInvalidate() ? newValue.toString(false) : newValue.toString(!userTyping), userTyping));
    }
    // >>> Max & Min limit
    var maxDecimal = $jbmdS.useMemo(function() {
        return $1b669cf07a0a77ae$var$getDecimalIfValidate(max);
    }, [
        max,
        precision
    ]);
    var minDecimal = $jbmdS.useMemo(function() {
        return $1b669cf07a0a77ae$var$getDecimalIfValidate(min);
    }, [
        min,
        precision
    ]);
    var upDisabled = $jbmdS.useMemo(function() {
        if (!maxDecimal || !decimalValue || decimalValue.isInvalidate()) return false;
        return maxDecimal.lessEquals(decimalValue);
    }, [
        maxDecimal,
        decimalValue
    ]);
    var downDisabled = $jbmdS.useMemo(function() {
        if (!minDecimal || !decimalValue || decimalValue.isInvalidate()) return false;
        return decimalValue.lessEquals(minDecimal);
    }, [
        minDecimal,
        decimalValue
    ]);
    // Cursor controller
    var _useCursor = (0, $2Mydu.default)(inputRef.current, focus), _useCursor2 = (0, $CZyex.default)(_useCursor, 2), recordCursor = _useCursor2[0], restoreCursor = _useCursor2[1];
    // ============================= Data =============================
    /**
   * Find target value closet within range.
   * e.g. [11, 28]:
   *    3  => 11
   *    23 => 23
   *    99 => 28
   */ var getRangeValue = function getRangeValue(target) {
        // target > max
        if (maxDecimal && !target.lessEquals(maxDecimal)) return maxDecimal;
        // target < min
        if (minDecimal && !minDecimal.lessEquals(target)) return minDecimal;
        return null;
    };
    /**
   * Check value is in [min, max] range
   */ var isInRange = function isInRange(target) {
        return !getRangeValue(target);
    };
    /**
   * Trigger `onChange` if value validated and not equals of origin.
   * Return the value that re-align in range.
   */ var triggerValueUpdate = function triggerValueUpdate(newValue, userTyping) {
        var updateValue = newValue;
        var isRangeValidate = isInRange(updateValue) || updateValue.isEmpty();
        // Skip align value when trigger value is empty.
        // We just trigger onChange(null)
        // This should not block user typing
        if (!updateValue.isEmpty() && !userTyping) {
            // Revert value in range if needed
            updateValue = getRangeValue(updateValue) || updateValue;
            isRangeValidate = true;
        }
        if (!readOnly && !disabled && isRangeValidate) {
            var numStr = updateValue.toString();
            var mergedPrecision = getPrecision(numStr, userTyping);
            if (mergedPrecision >= 0) {
                updateValue = (0, $darv0.default)((0, $darv0.toFixed)(numStr, ".", mergedPrecision));
                // When to fixed. The value may out of min & max range.
                // 4 in [0, 3.8] => 3.8 => 4 (toFixed)
                if (!isInRange(updateValue)) updateValue = (0, $darv0.default)((0, $darv0.toFixed)(numStr, ".", mergedPrecision, true));
            }
            // Trigger event
            if (!updateValue.equals(decimalValue)) {
                setUncontrolledDecimalValue(updateValue);
                onChange === null || onChange === void 0 || onChange(updateValue.isEmpty() ? null : $1b669cf07a0a77ae$var$getDecimalValue(stringMode, updateValue));
                // Reformat input if value is not controlled
                if (value === undefined) setInputValue(updateValue, userTyping);
            }
            return updateValue;
        }
        return decimalValue;
    };
    // ========================== User Input ==========================
    var onNextPromise = (0, $kD1EI.default)();
    // >>> Collect input value
    var collectInputValue = function collectInputValue(inputStr) {
        recordCursor();
        // Update inputValue incase input can not parse as number
        setInternalInputValue(inputStr);
        // Parse number
        if (!compositionRef.current) {
            var finalValue = mergedParser(inputStr);
            var finalDecimal = (0, $darv0.default)(finalValue);
            if (!finalDecimal.isNaN()) triggerValueUpdate(finalDecimal, true);
        }
        // Trigger onInput later to let user customize value if they want do handle something after onChange
        onInput === null || onInput === void 0 || onInput(inputStr);
        // optimize for chinese input experience
        // https://github.com/ant-design/ant-design/issues/8196
        onNextPromise(function() {
            var nextInputStr = inputStr;
            if (!parser) nextInputStr = inputStr.replace(/。/g, ".");
            if (nextInputStr !== inputStr) collectInputValue(nextInputStr);
        });
    };
    // >>> Composition
    var onCompositionStart = function onCompositionStart() {
        compositionRef.current = true;
    };
    var onCompositionEnd = function onCompositionEnd() {
        compositionRef.current = false;
        collectInputValue(inputRef.current.value);
    };
    // >>> Input
    var onInternalInput = function onInternalInput(e) {
        collectInputValue(e.target.value);
    };
    // ============================= Step =============================
    var onInternalStep = function onInternalStep(up) {
        var _inputRef$current;
        // Ignore step since out of range
        if (up && upDisabled || !up && downDisabled) return;
        // Clear typing status since it may caused by up & down key.
        // We should sync with input value.
        userTypingRef.current = false;
        var stepDecimal = (0, $darv0.default)(shiftKeyRef.current ? (0, $9ZT3M.getDecupleSteps)(step) : step);
        if (!up) stepDecimal = stepDecimal.negate();
        var target = (decimalValue || (0, $darv0.default)(0)).add(stepDecimal.toString());
        var updatedValue = triggerValueUpdate(target, false);
        onStep === null || onStep === void 0 || onStep($1b669cf07a0a77ae$var$getDecimalValue(stringMode, updatedValue), {
            offset: shiftKeyRef.current ? (0, $9ZT3M.getDecupleSteps)(step) : step,
            type: up ? "up" : "down"
        });
        (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
    };
    // ============================ Flush =============================
    /**
   * Flush current input content to trigger value change & re-formatter input if needed
   */ var flushInputValue = function flushInputValue(userTyping) {
        var parsedValue = (0, $darv0.default)(mergedParser(inputValue));
        var formatValue = parsedValue;
        if (!parsedValue.isNaN()) // Only validate value or empty value can be re-fill to inputValue
        // Reassign the formatValue within ranged of trigger control
        formatValue = triggerValueUpdate(parsedValue, userTyping);
        else formatValue = decimalValue;
        if (value !== undefined) // Reset back with controlled value first
        setInputValue(decimalValue, false);
        else if (!formatValue.isNaN()) // Reset input back since no validate value
        setInputValue(formatValue, false);
    };
    // Solve the issue of the event triggering sequence when entering numbers in chinese input (Safari)
    var onBeforeInput = function onBeforeInput() {
        userTypingRef.current = true;
    };
    var onKeyDown = function onKeyDown(event) {
        var which = event.which, shiftKey = event.shiftKey;
        userTypingRef.current = true;
        if (shiftKey) shiftKeyRef.current = true;
        else shiftKeyRef.current = false;
        if (which === (0, $5yi5E.default).ENTER) {
            if (!compositionRef.current) userTypingRef.current = false;
            flushInputValue(false);
            onPressEnter === null || onPressEnter === void 0 || onPressEnter(event);
        }
        if (keyboard === false) return;
        // Do step
        if (!compositionRef.current && [
            (0, $5yi5E.default).UP,
            (0, $5yi5E.default).DOWN
        ].includes(which)) {
            onInternalStep((0, $5yi5E.default).UP === which);
            event.preventDefault();
        }
    };
    var onKeyUp = function onKeyUp() {
        userTypingRef.current = false;
        shiftKeyRef.current = false;
    };
    // >>> Focus & Blur
    var onBlur = function onBlur() {
        flushInputValue(false);
        setFocus(false);
        userTypingRef.current = false;
    };
    // ========================== Controlled ==========================
    // Input by precision
    (0, $iDOLX.useLayoutUpdateEffect)(function() {
        if (!decimalValue.isInvalidate()) setInputValue(decimalValue, false);
    }, [
        precision
    ]);
    // Input by value
    (0, $iDOLX.useLayoutUpdateEffect)(function() {
        var newValue = (0, $darv0.default)(value);
        setDecimalValue(newValue);
        var currentParsedValue = (0, $darv0.default)(mergedParser(inputValue));
        // When user typing from `1.2` to `1.`, we should not convert to `1` immediately.
        // But let it go if user set `formatter`
        if (!newValue.equals(currentParsedValue) || !userTypingRef.current || formatter) // Update value as effect
        setInputValue(newValue, userTypingRef.current);
    }, [
        value
    ]);
    // ============================ Cursor ============================
    (0, $iDOLX.useLayoutUpdateEffect)(function() {
        if (formatter) restoreCursor();
    }, [
        inputValue
    ]);
    // ============================ Render ============================
    return /*#__PURE__*/ $jbmdS.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(prefixCls, className, (_classNames = {}, (0, $8K2NM.default)(_classNames, "".concat(prefixCls, "-focused"), focus), (0, $8K2NM.default)(_classNames, "".concat(prefixCls, "-disabled"), disabled), (0, $8K2NM.default)(_classNames, "".concat(prefixCls, "-readonly"), readOnly), (0, $8K2NM.default)(_classNames, "".concat(prefixCls, "-not-a-number"), decimalValue.isNaN()), (0, $8K2NM.default)(_classNames, "".concat(prefixCls, "-out-of-range"), !decimalValue.isInvalidate() && !isInRange(decimalValue)), _classNames)),
        style: style,
        onFocus: function onFocus() {
            setFocus(true);
        },
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onCompositionStart: onCompositionStart,
        onCompositionEnd: onCompositionEnd,
        onBeforeInput: onBeforeInput
    }, controls && /*#__PURE__*/ $jbmdS.createElement((0, $i8FuJ.default), {
        prefixCls: prefixCls,
        upNode: upHandler,
        downNode: downHandler,
        upDisabled: upDisabled,
        downDisabled: downDisabled,
        onStep: onInternalStep
    }), /*#__PURE__*/ $jbmdS.createElement("div", {
        className: "".concat(inputClassName, "-wrap")
    }, /*#__PURE__*/ $jbmdS.createElement("input", (0, $7i29i.default)({
        autoComplete: "off",
        role: "spinbutton",
        "aria-valuemin": min,
        "aria-valuemax": max,
        "aria-valuenow": decimalValue.isInvalidate() ? null : decimalValue.toString(),
        step: step
    }, inputProps, {
        ref: (0, $aKVEK.composeRef)(inputRef, ref),
        className: inputClassName,
        value: inputValue,
        onChange: onInternalInput,
        disabled: disabled,
        readOnly: readOnly
    }))));
});
$1b669cf07a0a77ae$var$InputNumber.displayName = "InputNumber";
var $1b669cf07a0a77ae$export$2e2bcd8739ae039 = $1b669cf07a0a77ae$var$InputNumber;

});
parcelRegister("darv0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99618a48beaef659$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "toFixed", function () { return $99618a48beaef659$export$a81f732198733497; });

var $3GVdq = parcelRequire("3GVdq");

var $jj5jQ = parcelRequire("jj5jQ");

var $9ZT3M = parcelRequire("9ZT3M");

var $3ryrZ = parcelRequire("3ryrZ");
var $99618a48beaef659$export$8030d902f75ebb28 = /*#__PURE__*/ function() {
    function NumberDecimal(value) {
        (0, $3GVdq.default)(this, NumberDecimal);
        this.origin = "";
        this.number = void 0;
        this.empty = void 0;
        if (!value && value !== 0 || !String(value).trim()) {
            this.empty = true;
            return;
        }
        this.origin = String(value);
        this.number = Number(value);
    }
    (0, $jj5jQ.default)(NumberDecimal, [
        {
            key: "negate",
            value: function negate() {
                return new NumberDecimal(-this.toNumber());
            }
        },
        {
            key: "add",
            value: function add(value) {
                if (this.isInvalidate()) return new NumberDecimal(value);
                var target = Number(value);
                if (Number.isNaN(target)) return this;
                var number = this.number + target;
                // [Legacy] Back to safe integer
                if (number > Number.MAX_SAFE_INTEGER) return new NumberDecimal(Number.MAX_SAFE_INTEGER);
                if (number < Number.MIN_SAFE_INTEGER) return new NumberDecimal(Number.MIN_SAFE_INTEGER);
                var maxPrecision = Math.max((0, $9ZT3M.getNumberPrecision)(this.number), (0, $9ZT3M.getNumberPrecision)(target));
                return new NumberDecimal(number.toFixed(maxPrecision));
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this.empty;
            }
        },
        {
            key: "isNaN",
            value: function isNaN() {
                return Number.isNaN(this.number);
            }
        },
        {
            key: "isInvalidate",
            value: function isInvalidate() {
                return this.isEmpty() || this.isNaN();
            }
        },
        {
            key: "equals",
            value: function equals(target) {
                return this.toNumber() === (target === null || target === void 0 ? void 0 : target.toNumber());
            }
        },
        {
            key: "lessEquals",
            value: function lessEquals(target) {
                return this.add(target.negate().toString()).toNumber() <= 0;
            }
        },
        {
            key: "toNumber",
            value: function toNumber() {
                return this.number;
            }
        },
        {
            key: "toString",
            value: function toString() {
                var safe = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                if (!safe) return this.origin;
                if (this.isInvalidate()) return "";
                return (0, $9ZT3M.num2str)(this.number);
            }
        }
    ]);
    return NumberDecimal;
}();
var $99618a48beaef659$export$f5e82d1c4ceba475 = /*#__PURE__*/ function() {
    /** BigInt will convert `0009` to `9`. We need record the len of decimal */ function BigIntDecimal(value) {
        (0, $3GVdq.default)(this, BigIntDecimal);
        this.origin = "";
        this.negative = void 0;
        this.integer = void 0;
        this.decimal = void 0;
        this.decimalLen = void 0;
        this.empty = void 0;
        this.nan = void 0;
        if (!value && value !== 0 || !String(value).trim()) {
            this.empty = true;
            return;
        }
        this.origin = String(value);
        // Act like Number convert
        if (value === "-") {
            this.nan = true;
            return;
        }
        var mergedValue = value;
        // We need convert back to Number since it require `toFixed` to handle this
        if ((0, $9ZT3M.isE)(mergedValue)) mergedValue = Number(mergedValue);
        mergedValue = typeof mergedValue === "string" ? mergedValue : (0, $9ZT3M.num2str)(mergedValue);
        if ((0, $9ZT3M.validateNumber)(mergedValue)) {
            var trimRet = (0, $9ZT3M.trimNumber)(mergedValue);
            this.negative = trimRet.negative;
            var numbers = trimRet.trimStr.split(".");
            this.integer = BigInt(numbers[0]);
            var decimalStr = numbers[1] || "0";
            this.decimal = BigInt(decimalStr);
            this.decimalLen = decimalStr.length;
        } else this.nan = true;
    }
    (0, $jj5jQ.default)(BigIntDecimal, [
        {
            key: "getMark",
            value: function getMark() {
                return this.negative ? "-" : "";
            }
        },
        {
            key: "getIntegerStr",
            value: function getIntegerStr() {
                return this.integer.toString();
            }
        },
        {
            key: "getDecimalStr",
            value: function getDecimalStr() {
                return this.decimal.toString().padStart(this.decimalLen, "0");
            }
        },
        {
            key: "alignDecimal",
            value: function alignDecimal(decimalLength) {
                var str = "".concat(this.getMark()).concat(this.getIntegerStr()).concat(this.getDecimalStr().padEnd(decimalLength, "0"));
                return BigInt(str);
            }
        },
        {
            key: "negate",
            value: function negate() {
                var clone = new BigIntDecimal(this.toString());
                clone.negative = !clone.negative;
                return clone;
            }
        },
        {
            key: "add",
            value: function add(value) {
                if (this.isInvalidate()) return new BigIntDecimal(value);
                var offset = new BigIntDecimal(value);
                if (offset.isInvalidate()) return this;
                var maxDecimalLength = Math.max(this.getDecimalStr().length, offset.getDecimalStr().length);
                var myAlignedDecimal = this.alignDecimal(maxDecimalLength);
                var offsetAlignedDecimal = offset.alignDecimal(maxDecimalLength);
                var valueStr = (myAlignedDecimal + offsetAlignedDecimal).toString();
                // We need fill string length back to `maxDecimalLength` to avoid parser failed
                var _trimNumber = (0, $9ZT3M.trimNumber)(valueStr), negativeStr = _trimNumber.negativeStr, trimStr = _trimNumber.trimStr;
                var hydrateValueStr = "".concat(negativeStr).concat(trimStr.padStart(maxDecimalLength + 1, "0"));
                return new BigIntDecimal("".concat(hydrateValueStr.slice(0, -maxDecimalLength), ".").concat(hydrateValueStr.slice(-maxDecimalLength)));
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this.empty;
            }
        },
        {
            key: "isNaN",
            value: function isNaN() {
                return this.nan;
            }
        },
        {
            key: "isInvalidate",
            value: function isInvalidate() {
                return this.isEmpty() || this.isNaN();
            }
        },
        {
            key: "equals",
            value: function equals(target) {
                return this.toString() === (target === null || target === void 0 ? void 0 : target.toString());
            }
        },
        {
            key: "lessEquals",
            value: function lessEquals(target) {
                return this.add(target.negate().toString()).toNumber() <= 0;
            }
        },
        {
            key: "toNumber",
            value: function toNumber() {
                if (this.isNaN()) return NaN;
                return Number(this.toString());
            }
        },
        {
            key: "toString",
            value: function toString() {
                var safe = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                if (!safe) return this.origin;
                if (this.isInvalidate()) return "";
                return (0, $9ZT3M.trimNumber)("".concat(this.getMark()).concat(this.getIntegerStr(), ".").concat(this.getDecimalStr())).fullStr;
            }
        }
    ]);
    return BigIntDecimal;
}();
function $99618a48beaef659$export$2e2bcd8739ae039(value) {
    // We use BigInt here.
    // Will fallback to Number if not support.
    if ((0, $3ryrZ.supportBigInt)()) return new $99618a48beaef659$export$f5e82d1c4ceba475(value);
    return new $99618a48beaef659$export$8030d902f75ebb28(value);
}
function $99618a48beaef659$export$a81f732198733497(numStr, separatorStr, precision) {
    var cutOnly = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (numStr === "") return "";
    var _trimNumber2 = (0, $9ZT3M.trimNumber)(numStr), negativeStr = _trimNumber2.negativeStr, integerStr = _trimNumber2.integerStr, decimalStr = _trimNumber2.decimalStr;
    var precisionDecimalStr = "".concat(separatorStr).concat(decimalStr);
    var numberWithoutDecimal = "".concat(negativeStr).concat(integerStr);
    if (precision >= 0) {
        // We will get last + 1 number to check if need advanced number
        var advancedNum = Number(decimalStr[precision]);
        if (advancedNum >= 5 && !cutOnly) {
            var advancedDecimal = $99618a48beaef659$export$2e2bcd8739ae039(numStr).add("".concat(negativeStr, "0.").concat("0".repeat(precision)).concat(10 - advancedNum));
            return $99618a48beaef659$export$a81f732198733497(advancedDecimal.toString(), separatorStr, precision, cutOnly);
        }
        if (precision === 0) return numberWithoutDecimal;
        return "".concat(numberWithoutDecimal).concat(separatorStr).concat(decimalStr.padEnd(precision, "0").slice(0, precision));
    }
    if (precisionDecimalStr === ".0") return numberWithoutDecimal;
    return "".concat(numberWithoutDecimal).concat(precisionDecimalStr);
}

});
parcelRegister("9ZT3M", function(module, exports) {

$parcel$export(module.exports, "trimNumber", function () { return $74748551846fa177$export$5be79a0015c5ab12; });
$parcel$export(module.exports, "isE", function () { return $74748551846fa177$export$ee6c12ef7f6d8b32; });
$parcel$export(module.exports, "getNumberPrecision", function () { return $74748551846fa177$export$2e56483e4ad90ee6; });
$parcel$export(module.exports, "validateNumber", function () { return $74748551846fa177$export$b3d198e17b370bec; });
$parcel$export(module.exports, "num2str", function () { return $74748551846fa177$export$fdc98affa95a4322; });
$parcel$export(module.exports, "getDecupleSteps", function () { return $74748551846fa177$export$d2883c6c6307c415; });

var $3ryrZ = parcelRequire("3ryrZ");
function $74748551846fa177$export$5be79a0015c5ab12(numStr) {
    var str = numStr.trim();
    var negative = str.startsWith("-");
    if (negative) str = str.slice(1);
    str = str// Remove decimal 0. `1.000` => `1.`, `1.100` => `1.1`
    .replace(/(\.\d*[^0])0*$/, "$1")// Remove useless decimal. `1.` => `1`
    .replace(/\.0*$/, "")// Remove integer 0. `0001` => `1`, 000.1' => `.1`
    .replace(/^0+/, "");
    if (str.startsWith(".")) str = "0".concat(str);
    var trimStr = str || "0";
    var splitNumber = trimStr.split(".");
    var integerStr = splitNumber[0] || "0";
    var decimalStr = splitNumber[1] || "0";
    if (integerStr === "0" && decimalStr === "0") negative = false;
    var negativeStr = negative ? "-" : "";
    return {
        negative: negative,
        negativeStr: negativeStr,
        trimStr: trimStr,
        integerStr: integerStr,
        decimalStr: decimalStr,
        fullStr: "".concat(negativeStr).concat(trimStr)
    };
}
function $74748551846fa177$export$ee6c12ef7f6d8b32(number) {
    var str = String(number);
    return !Number.isNaN(Number(str)) && str.includes("e");
}
function $74748551846fa177$export$2e56483e4ad90ee6(number) {
    var numStr = String(number);
    if ($74748551846fa177$export$ee6c12ef7f6d8b32(number)) {
        var precision = Number(numStr.slice(numStr.indexOf("e-") + 2));
        var decimalMatch = numStr.match(/\.(\d+)/);
        if (decimalMatch === null || decimalMatch === void 0 ? void 0 : decimalMatch[1]) precision += decimalMatch[1].length;
        return precision;
    }
    return numStr.includes(".") && $74748551846fa177$export$b3d198e17b370bec(numStr) ? numStr.length - numStr.indexOf(".") - 1 : 0;
}
function $74748551846fa177$export$fdc98affa95a4322(number) {
    var numStr = String(number);
    if ($74748551846fa177$export$ee6c12ef7f6d8b32(number)) {
        if (number > Number.MAX_SAFE_INTEGER) return String((0, $3ryrZ.supportBigInt)() ? BigInt(number).toString() : Number.MAX_SAFE_INTEGER);
        if (number < Number.MIN_SAFE_INTEGER) return String((0, $3ryrZ.supportBigInt)() ? BigInt(number).toString() : Number.MIN_SAFE_INTEGER);
        numStr = number.toFixed($74748551846fa177$export$2e56483e4ad90ee6(numStr));
    }
    return $74748551846fa177$export$5be79a0015c5ab12(numStr).fullStr;
}
function $74748551846fa177$export$b3d198e17b370bec(num) {
    if (typeof num === "number") return !Number.isNaN(num);
    // Empty
    if (!num) return false;
    return(// Normal type: 11.28
    /^\s*-?\d+(\.\d+)?\s*$/.test(num) || // Pre-number: 1.
    /^\s*-?\d+\.\s*$/.test(num) || // Post-number: .1
    /^\s*-?\.\d+\s*$/.test(num));
}
function $74748551846fa177$export$d2883c6c6307c415(step) {
    var stepStr = typeof step === "number" ? $74748551846fa177$export$fdc98affa95a4322(step) : $74748551846fa177$export$5be79a0015c5ab12(step).fullStr;
    var hasPoint = stepStr.includes(".");
    if (!hasPoint) return step + "0";
    return $74748551846fa177$export$5be79a0015c5ab12(stepStr.replace(/(\d)\.(\d)/g, "$1$2.")).fullStr;
}

});
parcelRegister("3ryrZ", function(module, exports) {

$parcel$export(module.exports, "supportBigInt", function () { return $281e9de199c8ea64$export$d5c7b2f63580e8f5; });
function $281e9de199c8ea64$export$d5c7b2f63580e8f5() {
    return typeof BigInt === "function";
}

});



parcelRegister("i8FuJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d349295393779477$export$2e2bcd8739ae039; });

var $7i29i = parcelRequire("7i29i");

var $8K2NM = parcelRequire("8K2NM");

var $jbmdS = parcelRequire("jbmdS");

var $02LyB = parcelRequire("02LyB");

var $FYXRo = parcelRequire("FYXRo");
/**
 * When click and hold on a button - the speed of auto changing the value.
 */ var $d349295393779477$var$STEP_INTERVAL = 200;
/**
 * When click and hold on a button - the delay before auto changing the value.
 */ var $d349295393779477$var$STEP_DELAY = 600;
function $d349295393779477$export$2e2bcd8739ae039(_ref) {
    var prefixCls = _ref.prefixCls, upNode = _ref.upNode, downNode = _ref.downNode, upDisabled = _ref.upDisabled, downDisabled = _ref.downDisabled, onStep = _ref.onStep;
    // ======================== Step ========================
    var stepTimeoutRef = $jbmdS.useRef();
    var onStepRef = $jbmdS.useRef();
    onStepRef.current = onStep;
    // We will interval update step when hold mouse down
    var onStepMouseDown = function onStepMouseDown(e, up) {
        e.preventDefault();
        onStepRef.current(up);
        // Loop step for interval
        function loopStep() {
            onStepRef.current(up);
            stepTimeoutRef.current = setTimeout(loopStep, $d349295393779477$var$STEP_INTERVAL);
        }
        // First time press will wait some time to trigger loop step update
        stepTimeoutRef.current = setTimeout(loopStep, $d349295393779477$var$STEP_DELAY);
    };
    var onStopStep = function onStopStep() {
        clearTimeout(stepTimeoutRef.current);
    };
    $jbmdS.useEffect(function() {
        return onStopStep;
    }, []);
    // ======================= Render =======================
    if ((0, $FYXRo.default)()) return null;
    var handlerClassName = "".concat(prefixCls, "-handler");
    var upClassName = (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(handlerClassName, "".concat(handlerClassName, "-up"), (0, $8K2NM.default)({}, "".concat(handlerClassName, "-up-disabled"), upDisabled));
    var downClassName = (0, (/*@__PURE__*/$parcel$interopDefault($02LyB)))(handlerClassName, "".concat(handlerClassName, "-down"), (0, $8K2NM.default)({}, "".concat(handlerClassName, "-down-disabled"), downDisabled));
    var sharedHandlerProps = {
        unselectable: "on",
        role: "button",
        onMouseUp: onStopStep,
        onMouseLeave: onStopStep
    };
    return /*#__PURE__*/ $jbmdS.createElement("div", {
        className: "".concat(handlerClassName, "-wrap")
    }, /*#__PURE__*/ $jbmdS.createElement("span", (0, $7i29i.default)({}, sharedHandlerProps, {
        onMouseDown: function onMouseDown(e) {
            onStepMouseDown(e, true);
        },
        "aria-label": "Increase Value",
        "aria-disabled": upDisabled,
        className: upClassName
    }), upNode || /*#__PURE__*/ $jbmdS.createElement("span", {
        unselectable: "on",
        className: "".concat(prefixCls, "-handler-up-inner")
    })), /*#__PURE__*/ $jbmdS.createElement("span", (0, $7i29i.default)({}, sharedHandlerProps, {
        onMouseDown: function onMouseDown(e) {
            onStepMouseDown(e, false);
        },
        "aria-label": "Decrease Value",
        "aria-disabled": downDisabled,
        className: downClassName
    }), downNode || /*#__PURE__*/ $jbmdS.createElement("span", {
        unselectable: "on",
        className: "".concat(prefixCls, "-handler-down-inner")
    })));
}

});

parcelRegister("2Mydu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $206a9b2c08bc6485$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");

var $8tMCd = parcelRequire("8tMCd");
function $206a9b2c08bc6485$export$2e2bcd8739ae039(input, focused) {
    var selectionRef = (0, $jbmdS.useRef)(null);
    function recordCursor() {
        // Record position
        try {
            var start = input.selectionStart, end = input.selectionEnd, value = input.value;
            var beforeTxt = value.substring(0, start);
            var afterTxt = value.substring(end);
            selectionRef.current = {
                start: start,
                end: end,
                value: value,
                beforeTxt: beforeTxt,
                afterTxt: afterTxt
            };
        } catch (e) {
        // Fix error in Chrome:
        // Failed to read the 'selectionStart' property from 'HTMLInputElement'
        // http://stackoverflow.com/q/21177489/3040605
        }
    }
    /**
   * Restore logic:
   *  1. back string same
   *  2. start string same
   */ function restoreCursor() {
        if (input && selectionRef.current && focused) try {
            var value = input.value;
            var _selectionRef$current = selectionRef.current, beforeTxt = _selectionRef$current.beforeTxt, afterTxt = _selectionRef$current.afterTxt, start = _selectionRef$current.start;
            var startPos = value.length;
            if (value.endsWith(afterTxt)) startPos = value.length - selectionRef.current.afterTxt.length;
            else if (value.startsWith(beforeTxt)) startPos = beforeTxt.length;
            else {
                var beforeLastChar = beforeTxt[start - 1];
                var newIndex = value.indexOf(beforeLastChar, start - 1);
                if (newIndex !== -1) startPos = newIndex + 1;
            }
            input.setSelectionRange(startPos, startPos);
        } catch (e) {
            (0, $8tMCd.default)(false, "Something warning of cursor restore. Please fire issue about this: ".concat(e.message));
        }
    }
    return [
        recordCursor,
        restoreCursor
    ];
}

});

parcelRegister("kD1EI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f048bbef26f51928$export$2e2bcd8739ae039; });

var $jbmdS = parcelRequire("jbmdS");

var $2iJQe = parcelRequire("2iJQe");
var /**
 * Always trigger latest once when call multiple time
 */ $f048bbef26f51928$export$2e2bcd8739ae039 = function() {
    var idRef = (0, $jbmdS.useRef)(0);
    var cleanUp = function cleanUp() {
        (0, $2iJQe.default).cancel(idRef.current);
    };
    (0, $jbmdS.useEffect)(function() {
        return cleanUp;
    }, []);
    return function(callback) {
        cleanUp();
        idRef.current = (0, $2iJQe.default)(function() {
            callback();
        });
    };
};

});










parcelRegister("lq6jw", function(module, exports) {

$parcel$export(module.exports, "ExpenseReportColumns", function () { return $f980ec7c475fb423$export$d953fc7f6b362cb7; });
parcelRequire("eat5C");

var $8kZ1o = parcelRequire("8kZ1o");
parcelRequire("1BTI2");

var $4hBm1 = parcelRequire("4hBm1");
parcelRequire("azaaH");
const $f980ec7c475fb423$export$d953fc7f6b362cb7 = (report)=>({
        project: {
            id: "project",
            label: "Project",
            type: "project",
            width: 20,
            value: (row)=>row.project,
            format: (project)=>{
                return project;
            }
        },
        projectPhase: {
            id: "projectPhase",
            label: "Phase",
            type: "text",
            width: 20,
            value: (row)=>{
                return row.projectPhase;
            }
        },
        projectStatus: {
            id: "projectStatus",
            label: "Project Status",
            type: "status",
            width: 20,
            value: (row)=>{
                return row.projectStatus;
            }
        },
        phaseStatus: {
            id: "phaseStatus",
            label: "Phase Status",
            type: "status",
            width: 20,
            value: (row)=>{
                return row.phaseStatus;
            }
        },
        staffMember: {
            id: "staffMember",
            label: "Staff",
            type: "staffMember",
            width: 20,
            value: (row)=>{
                return row.staffMember;
            },
            format: (staff)=>staff
        },
        date: {
            id: "date",
            label: "Date",
            type: "date",
            width: 10,
            aggregate: "same",
            value: (row)=>{
                return row.date ? new Date(row.date) : null;
            }
        },
        notes: {
            id: "notes",
            label: "Notes",
            type: "text",
            width: 30,
            value: (row)=>{
                return row.notes;
            }
        },
        costCentre: {
            id: "costCentre",
            label: "Cost Centre",
            type: "costCentre",
            width: 15,
            value: (row)=>{
                return row.costCentre;
            },
            format: (costCentre)=>costCentre
        },
        staffCostCentre: {
            id: "staffCostCentre",
            label: "Staff Cost Centre",
            type: "costCentre",
            width: 15,
            value: (row)=>{
                return row.staffCostCentre;
            },
            format: (costCentre)=>costCentre
        },
        projectOwner: {
            id: "projectOwner",
            label: "Project Owner",
            type: "staffMember",
            width: 20,
            value: (row)=>{
                return row.projectOwner;
            },
            format: (staff)=>staff
        },
        projectContact: {
            id: "projectContact",
            label: "Project Client",
            type: "contact",
            width: 20,
            value: (row)=>{
                return row.projectContact;
            },
            format: (contact)=>contact
        },
        projectInvoiceContact: {
            id: "projectInvoiceContact",
            label: "Project Primary Contact",
            type: "contact",
            width: 20,
            value: (row)=>{
                return row.projectInvoiceContact;
            },
            format: (contact)=>contact,
            permissions: (row)=>(0, $8kZ1o.canViewPrimaryContact)()
        },
        projectCode: {
            id: "projectCode",
            label: "Project Code",
            type: "text",
            width: 20,
            value: (row)=>{
                return row.projectCode;
            }
        },
        projectPhaseCode: {
            id: "projectPhaseCode",
            label: "Phase Code",
            type: "text",
            width: 20,
            value: (row)=>{
                return row.projectPhaseCode;
            }
        },
        staffRole: {
            id: "staffRole",
            label: "Staff Role",
            type: "role",
            width: 20,
            value: (row)=>{
                return row.staffRole;
            },
            format: (v)=>v
        },
        monthIndex: {
            id: "monthIndex",
            label: "Month",
            type: "text",
            width: 20,
            format: (month)=>month && (0, $4hBm1.format)((0, $4hBm1.parse)(month, "yyyy-MM", new Date()), "MMM yyyy"),
            value: (row)=>{
                return row === null || row === void 0 ? void 0 : row.monthIndex;
            }
        },
        isLocked: {
            id: "isLocked",
            label: "Is Locked",
            type: "boolean",
            width: 10,
            value: (row)=>{
                return row.isLocked;
            }
        },
        beenInvoiced: {
            id: "beenInvoiced",
            label: "Has Been Invoiced",
            type: "boolean",
            width: 10,
            value: (row)=>{
                return row.beenInvoiced;
            }
        },
        expenseName: {
            id: "expenseName",
            label: "Expense Name",
            type: "text",
            width: 20,
            value: (row)=>{
                return row.expenseName;
            }
        },
        recordedExpense: {
            id: "recordedExpense",
            label: "Recorded Expense",
            type: "currency",
            width: 10,
            aggregate: "sum",
            value: (row)=>{
                return row.recordedExpense;
            }
        },
        plannedExpense: {
            id: "plannedExpense",
            label: "Planned Expense",
            type: "currency",
            width: 10,
            aggregate: "sum",
            value: (row)=>{
                return row.plannedExpense;
            }
        },
        invoicedExpense: {
            id: "invoicedExpense",
            label: "Invoiced Expense",
            type: "currency",
            width: 10,
            value: (row)=>{
                return row.beenInvoiced;
            }
        },
        // recordedVsPlannedExpense: {
        //     id: 'recordedVsPlannedExpense',
        //     label: 'Recorded vs Planned Expense',
        //     type: 'progressBar',
        //     format: (v) => Formatter.currency(v, { decimals: 0 }),
        //     width: 30,
        //     aggregate: 'sum',
        //     value: (row) => {
        //         return row.recordedVsPlannedExpense
        //     },
        // },
        // invoicedVsPlannedExpense: {
        //     id: 'invoicedVsPlannedExpense',
        //     label: 'Invoiced vs Planned Expense',
        //     type: 'progressBar',
        //     format: (v) => Formatter.currency(v, { decimals: 0 }),
        //     width: 30,
        //     aggregate: 'sum',
        //     value: (row) => {
        //         return row.invoicedVsPlannedExpense
        //     },
        // },
        // invoicedVsRecordedExpense: {
        //     id: 'invoicedVsRecordedExpense',
        //     label: 'Invoiced vs Recorded Expense',
        //     type: 'progressBar',
        //     format: (v) => Formatter.currency(v, { decimals: 0 }),
        //     width: 30,
        //     aggregate: 'sum',
        //     value: (row) => {
        //         return row.invoicedVsRecordedExpense
        //     },
        // },
        supplier: {
            id: "supplier",
            label: "Supplier",
            type: "text",
            width: 20,
            value: (row)=>{
                return row.supplier;
            },
            format: (supplier)=>supplier
        }
    });

});



parcelRegister("8Ef5K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64bdc41389d0d128$export$2e2bcd8739ae039; });

var $gN0TC = parcelRequire("gN0TC");

var $4JcCM = parcelRequire("4JcCM");
parcelRequire("eat5C");
parcelRequire("bhvQG");
parcelRequire("cxnwP");
parcelRequire("kRqe9");
parcelRequire("gJT7h");
parcelRequire("3PpOX");

var $62nmb = parcelRequire("62nmb");
var $64bdc41389d0d128$var$_dec, $64bdc41389d0d128$var$_dec2, $64bdc41389d0d128$var$_class, $64bdc41389d0d128$var$_descriptor, $64bdc41389d0d128$var$_descriptor2, $64bdc41389d0d128$var$_descriptor3, $64bdc41389d0d128$var$_descriptor4, $64bdc41389d0d128$var$_descriptor5, $64bdc41389d0d128$var$_descriptor6, $64bdc41389d0d128$var$_descriptor7, $64bdc41389d0d128$var$_descriptor8, $64bdc41389d0d128$var$_descriptor9, $64bdc41389d0d128$var$_descriptor10, $64bdc41389d0d128$var$_descriptor11, $64bdc41389d0d128$var$_descriptor12, $64bdc41389d0d128$var$_descriptor13, $64bdc41389d0d128$var$_descriptor14, $64bdc41389d0d128$var$_descriptor15, $64bdc41389d0d128$var$_descriptor16, $64bdc41389d0d128$var$_descriptor17;
function $64bdc41389d0d128$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $64bdc41389d0d128$var$_defineProperty(e, r, t) {
    return (r = $64bdc41389d0d128$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $64bdc41389d0d128$var$_toPropertyKey(t) {
    var i = $64bdc41389d0d128$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $64bdc41389d0d128$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $64bdc41389d0d128$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $64bdc41389d0d128$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}

let $64bdc41389d0d128$var$InvoiceTemplateModel = ($64bdc41389d0d128$var$_dec = (0, $4JcCM.action).bound, $64bdc41389d0d128$var$_dec2 = (0, $4JcCM.action).bound, $64bdc41389d0d128$var$_class = class InvoiceTemplateModel {
    constructor(org, data){
        $64bdc41389d0d128$var$_initializerDefineProperty(this, "id", $64bdc41389d0d128$var$_descriptor, this);
        $64bdc41389d0d128$var$_initializerDefineProperty(this, "templateName", $64bdc41389d0d128$var$_descriptor2, this);
        $64bdc41389d0d128$var$_initializerDefineProperty(this, "contentStart", $64bdc41389d0d128$var$_descriptor3, this);
        $64bdc41389d0d128$var$_initializerDefineProperty(this, "contentEnd", $64bdc41389d0d128$var$_descriptor4, this);
        $64bdc41389d0d128$var$_initializerDefineProperty(this, "footerLeft", $64bdc41389d0d128$var$_descriptor5, this);
        $64bdc41389d0d128$var$_initializerDefineProperty(this, "footerRight", $64bdc41389d0d128$var$_descriptor6, this);
        $64bdc41389d0d128$var$_initializerDefineProperty(this, "logoUrl", $64bdc41389d0d128$var$_descriptor7, this);
        $64bdc41389d0d128$var$_initializerDefineProperty(this, "logoSize", $64bdc41389d0d128$var$_descriptor8, this);
        $64bdc41389d0d128$var$_initializerDefineProperty(this, "taxName", $64bdc41389d0d128$var$_descriptor9, this);
        $64bdc41389d0d128$var$_initializerDefineProperty(this, "documentLabel", $64bdc41389d0d128$var$_descriptor10, this);
        $64bdc41389d0d128$var$_initializerDefineProperty(this, "columns", $64bdc41389d0d128$var$_descriptor11, this);
        $64bdc41389d0d128$var$_initializerDefineProperty(this, "projectCode", $64bdc41389d0d128$var$_descriptor12, this);
        $64bdc41389d0d128$var$_initializerDefineProperty(this, "projectName", $64bdc41389d0d128$var$_descriptor13, this);
        $64bdc41389d0d128$var$_initializerDefineProperty(this, "projectAddress", $64bdc41389d0d128$var$_descriptor14, this);
        $64bdc41389d0d128$var$_initializerDefineProperty(this, "openPerProject", $64bdc41389d0d128$var$_descriptor15, this);
        $64bdc41389d0d128$var$_initializerDefineProperty(this, "closePerProject", $64bdc41389d0d128$var$_descriptor16, this);
        $64bdc41389d0d128$var$_initializerDefineProperty(this, "organisation", $64bdc41389d0d128$var$_descriptor17, this);
        (0, $4JcCM.makeObservable)(this);
        this.organisation = org;
        for (const [key, value] of Object.entries(data))this.changeProp(key, value);
    }
    update(data = {}, options, invoice) {
        for (const [key, value] of Object.entries(data))this.changeProp(key, value);
        this.organisation.updateInvoiceTemplate(this.serialize(), options);
        if (this.openPerProject && invoice !== null && invoice !== void 0 && invoice.project) invoice.project.update({
            invoiceOpen: data.contentStart || ""
        });
        if (this.closePerProject && invoice !== null && invoice !== void 0 && invoice.project) invoice.project.update({
            invoiceClose: data.contentEnd || ""
        });
    }
    changeProp(prop, val) {
        this[prop] = val;
    }
    serialize() {
        return {
            id: this.id,
            templateName: this.templateName,
            contentStart: this.contentStart,
            contentEnd: this.contentEnd,
            footerLeft: this.footerLeft,
            footerRight: this.footerRight,
            logoUrl: this.logoUrl,
            logoSize: this.logoSize,
            taxName: this.taxName,
            documentLabel: this.documentLabel,
            columns: this.columns,
            projectCode: this.projectCode,
            projectName: this.projectName,
            projectAddress: this.projectAddress,
            openPerProject: this.openPerProject,
            closePerProject: this.closePerProject
        };
    }
    getProjectText(invoice) {
        let ctext = [];
        if (invoice.project.jobNumber && this.projectCode) ctext.push(invoice.project.jobNumber);
        if (invoice.project.name && this.projectName) ctext.push(invoice.project.name);
        if (invoice.project.address && this.projectAddress) ctext.push(invoice.project.address);
        return ctext.join("\n");
    }
    getClientText(invoice) {
        var _invoice$contact, _invoice$contact2;
        if (!invoice.contact) return "";
        let ctext = [];
        if (invoice.contact.firstName && invoice.contact.lastName) ctext.push(`${invoice.contact.firstName} ${invoice.contact.lastName}`);
        if (invoice.contact.organisationName) ctext.push(invoice.contact.organisationName);
        if ((_invoice$contact = invoice.contact) !== null && _invoice$contact !== void 0 && _invoice$contact.address) ctext.push((_invoice$contact2 = invoice.contact) === null || _invoice$contact2 === void 0 ? void 0 : _invoice$contact2.address);
        return ctext.join("\n");
    }
    getOpeningText(invoice) {
        if (this.openPerProject) return invoice.project.invoiceOpen;
        else return this.contentStart;
    }
    getClosingText(invoice) {
        if (this.closePerProject) return invoice.project.invoiceClose;
        else return this.contentEnd;
    }
}, $64bdc41389d0d128$var$_descriptor = $64bdc41389d0d128$var$_applyDecoratedDescriptor($64bdc41389d0d128$var$_class.prototype, "id", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($gN0TC)))();
    }
}), $64bdc41389d0d128$var$_descriptor2 = $64bdc41389d0d128$var$_applyDecoratedDescriptor($64bdc41389d0d128$var$_class.prototype, "templateName", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "Default";
    }
}), $64bdc41389d0d128$var$_descriptor3 = $64bdc41389d0d128$var$_applyDecoratedDescriptor($64bdc41389d0d128$var$_class.prototype, "contentStart", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return ``;
    }
}), $64bdc41389d0d128$var$_descriptor4 = $64bdc41389d0d128$var$_applyDecoratedDescriptor($64bdc41389d0d128$var$_class.prototype, "contentEnd", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return `Please deposit funds electronically within 14 days to:
                    CC Architecture
                    BSB: XXX-XXX
                    Account: XXXX XXXX
                    *Please include reference the invoice number in the payment description.`;
    }
}), $64bdc41389d0d128$var$_descriptor5 = $64bdc41389d0d128$var$_applyDecoratedDescriptor($64bdc41389d0d128$var$_class.prototype, "footerLeft", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return `CC Architecture Pty Ltd
                                ABN: XX XXX XXX XXX`;
    }
}), $64bdc41389d0d128$var$_descriptor6 = $64bdc41389d0d128$var$_applyDecoratedDescriptor($64bdc41389d0d128$var$_class.prototype, "footerRight", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return `123 Threshold Lane, Melbourne, 
                                VIC Australia 3000
                                Ph: XX XXXX XXXX
                                lecorb@ccarch.com.au
                                `;
    }
}), $64bdc41389d0d128$var$_descriptor7 = $64bdc41389d0d128$var$_applyDecoratedDescriptor($64bdc41389d0d128$var$_class.prototype, "logoUrl", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new URL((parcelRequire("hw9H4")));
    }
}), $64bdc41389d0d128$var$_descriptor8 = $64bdc41389d0d128$var$_applyDecoratedDescriptor($64bdc41389d0d128$var$_class.prototype, "logoSize", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 6;
    }
}), $64bdc41389d0d128$var$_descriptor9 = $64bdc41389d0d128$var$_applyDecoratedDescriptor($64bdc41389d0d128$var$_class.prototype, "taxName", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "GST";
    }
}), $64bdc41389d0d128$var$_descriptor10 = $64bdc41389d0d128$var$_applyDecoratedDescriptor($64bdc41389d0d128$var$_class.prototype, "documentLabel", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "Tax Invoice";
    }
}), $64bdc41389d0d128$var$_descriptor11 = $64bdc41389d0d128$var$_applyDecoratedDescriptor($64bdc41389d0d128$var$_class.prototype, "columns", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [
            "description",
            "quantity",
            "unitPrice",
            "amount"
        ];
    }
}), $64bdc41389d0d128$var$_descriptor12 = $64bdc41389d0d128$var$_applyDecoratedDescriptor($64bdc41389d0d128$var$_class.prototype, "projectCode", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return true;
    }
}), $64bdc41389d0d128$var$_descriptor13 = $64bdc41389d0d128$var$_applyDecoratedDescriptor($64bdc41389d0d128$var$_class.prototype, "projectName", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return true;
    }
}), $64bdc41389d0d128$var$_descriptor14 = $64bdc41389d0d128$var$_applyDecoratedDescriptor($64bdc41389d0d128$var$_class.prototype, "projectAddress", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return true;
    }
}), $64bdc41389d0d128$var$_descriptor15 = $64bdc41389d0d128$var$_applyDecoratedDescriptor($64bdc41389d0d128$var$_class.prototype, "openPerProject", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $64bdc41389d0d128$var$_descriptor16 = $64bdc41389d0d128$var$_applyDecoratedDescriptor($64bdc41389d0d128$var$_class.prototype, "closePerProject", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $64bdc41389d0d128$var$_descriptor17 = $64bdc41389d0d128$var$_applyDecoratedDescriptor($64bdc41389d0d128$var$_class.prototype, "organisation", [
    (0, $4JcCM.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $64bdc41389d0d128$var$_applyDecoratedDescriptor($64bdc41389d0d128$var$_class.prototype, "update", [
    $64bdc41389d0d128$var$_dec
], Object.getOwnPropertyDescriptor($64bdc41389d0d128$var$_class.prototype, "update"), $64bdc41389d0d128$var$_class.prototype), $64bdc41389d0d128$var$_applyDecoratedDescriptor($64bdc41389d0d128$var$_class.prototype, "changeProp", [
    $64bdc41389d0d128$var$_dec2
], Object.getOwnPropertyDescriptor($64bdc41389d0d128$var$_class.prototype, "changeProp"), $64bdc41389d0d128$var$_class.prototype), $64bdc41389d0d128$var$_applyDecoratedDescriptor($64bdc41389d0d128$var$_class.prototype, "serialize", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($64bdc41389d0d128$var$_class.prototype, "serialize"), $64bdc41389d0d128$var$_class.prototype), $64bdc41389d0d128$var$_applyDecoratedDescriptor($64bdc41389d0d128$var$_class.prototype, "getProjectText", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($64bdc41389d0d128$var$_class.prototype, "getProjectText"), $64bdc41389d0d128$var$_class.prototype), $64bdc41389d0d128$var$_applyDecoratedDescriptor($64bdc41389d0d128$var$_class.prototype, "getClientText", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($64bdc41389d0d128$var$_class.prototype, "getClientText"), $64bdc41389d0d128$var$_class.prototype), $64bdc41389d0d128$var$_applyDecoratedDescriptor($64bdc41389d0d128$var$_class.prototype, "getOpeningText", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($64bdc41389d0d128$var$_class.prototype, "getOpeningText"), $64bdc41389d0d128$var$_class.prototype), $64bdc41389d0d128$var$_applyDecoratedDescriptor($64bdc41389d0d128$var$_class.prototype, "getClosingText", [
    (0, (/*@__PURE__*/$parcel$interopDefault($62nmb)))
], Object.getOwnPropertyDescriptor($64bdc41389d0d128$var$_class.prototype, "getClosingText"), $64bdc41389d0d128$var$_class.prototype), $64bdc41389d0d128$var$_class);
var $64bdc41389d0d128$export$2e2bcd8739ae039 = $64bdc41389d0d128$var$InvoiceTemplateModel;

});



parcelRegister("4sWia", function(module, exports) {

$parcel$export(module.exports, "getVersion", function () { return $3406fe8df9a6441c$export$c506eb22e615ba4a; });
parcelRequire("8aL9y");

var $iOQGT = parcelRequire("iOQGT");
async function $3406fe8df9a6441c$export$c506eb22e615ba4a() {
    const { data: data } = await (0, $iOQGT.makeRequest)({
        path: `/version`,
        method: "get"
    });
    //get version text file from /public
    // const response = await fetch(
    //     new URL('/public/version.txt', import.meta.url) + `?ts=${Date.now()}`
    // )
    // const text = await response.text()
    return data.version;
}

});















"use strict";
var $5a25bf23e852a334$exports = {};
"use strict";
var $5a25bf23e852a334$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$5a25bf23e852a334$exports = // eslint-disable-next-line es/no-global-this -- safe
$5a25bf23e852a334$var$check(typeof globalThis == "object" && globalThis) || $5a25bf23e852a334$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$5a25bf23e852a334$var$check(typeof self == "object" && self) || $5a25bf23e852a334$var$check(typeof $parcel$global == "object" && $parcel$global) || $5a25bf23e852a334$var$check(typeof $5a25bf23e852a334$exports == "object" && $5a25bf23e852a334$exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();


var $52c4d46b3273454b$exports = {};
"use strict";
var $08ab939900a543ac$exports = {};
"use strict";
$08ab939900a543ac$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$52c4d46b3273454b$exports = !$08ab939900a543ac$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});


var $782acde8a719f011$exports = {};
"use strict";
var $639b728905fb8c6d$exports = {};
"use strict";
var $1ad10dd23182595f$exports = {};
"use strict";
var $2fd6a84fd2790434$exports = {};
"use strict";

$2fd6a84fd2790434$exports = !$08ab939900a543ac$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});


var $1ad10dd23182595f$var$FunctionPrototype = Function.prototype;
var $1ad10dd23182595f$var$call = $1ad10dd23182595f$var$FunctionPrototype.call;
var $1ad10dd23182595f$var$uncurryThisWithBind = $2fd6a84fd2790434$exports && $1ad10dd23182595f$var$FunctionPrototype.bind.bind($1ad10dd23182595f$var$call, $1ad10dd23182595f$var$call);
$1ad10dd23182595f$exports = $2fd6a84fd2790434$exports ? $1ad10dd23182595f$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $1ad10dd23182595f$var$call.apply(fn, arguments);
    };
};



var $8c419936f9da7a42$exports = {};
"use strict";
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $8c419936f9da7a42$var$documentAll = typeof document == "object" && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
$8c419936f9da7a42$exports = typeof $8c419936f9da7a42$var$documentAll == "undefined" && $8c419936f9da7a42$var$documentAll !== undefined ? function(argument) {
    return typeof argument == "function" || argument === $8c419936f9da7a42$var$documentAll;
} : function(argument) {
    return typeof argument == "function";
};


var $8e2f119da48bb072$exports = {};
"use strict";

var $0162856152647503$exports = {};
"use strict";
var $b66e8aa050ea0920$exports = {};
"use strict";
var $698d60db131029a9$exports = {};
"use strict";
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$698d60db131029a9$exports = function(it) {
    return it === null || it === undefined;
};


var $b66e8aa050ea0920$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$b66e8aa050ea0920$exports = function(it) {
    if ($698d60db131029a9$exports(it)) throw new $b66e8aa050ea0920$var$$TypeError("Can't call method on " + it);
    return it;
};


var $0162856152647503$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$0162856152647503$exports = function(argument) {
    return $0162856152647503$var$$Object($b66e8aa050ea0920$exports(argument));
};


var $8e2f119da48bb072$var$hasOwnProperty = $1ad10dd23182595f$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$8e2f119da48bb072$exports = Object.hasOwn || function hasOwn(it, key) {
    return $8e2f119da48bb072$var$hasOwnProperty($0162856152647503$exports(it), key);
};



var $414a94187e17567a$exports = {};
"use strict";


var $414a94187e17567a$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $414a94187e17567a$var$getDescriptor = $52c4d46b3273454b$exports && Object.getOwnPropertyDescriptor;
var $414a94187e17567a$var$EXISTS = $8e2f119da48bb072$exports($414a94187e17567a$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $414a94187e17567a$var$PROPER = $414a94187e17567a$var$EXISTS && (function something() {}).name === "something";
var $414a94187e17567a$var$CONFIGURABLE = $414a94187e17567a$var$EXISTS && (!$52c4d46b3273454b$exports || $52c4d46b3273454b$exports && $414a94187e17567a$var$getDescriptor($414a94187e17567a$var$FunctionPrototype, "name").configurable);
$414a94187e17567a$exports = {
    EXISTS: $414a94187e17567a$var$EXISTS,
    PROPER: $414a94187e17567a$var$PROPER,
    CONFIGURABLE: $414a94187e17567a$var$CONFIGURABLE
};


var $639b728905fb8c6d$require$CONFIGURABLE_FUNCTION_NAME = $414a94187e17567a$exports.CONFIGURABLE;
var $f534d5e21889d672$exports = {};
"use strict";


var $01b8cda31c003dde$exports = {};
"use strict";
var $a93869980a4842cd$exports = {};
"use strict";
$a93869980a4842cd$exports = false;



var $6843dd47e64d7156$exports = {};
"use strict";

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $6843dd47e64d7156$var$defineProperty = Object.defineProperty;
$6843dd47e64d7156$exports = function(key, value) {
    try {
        $6843dd47e64d7156$var$defineProperty($5a25bf23e852a334$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $5a25bf23e852a334$exports[key] = value;
    }
    return value;
};


var $01b8cda31c003dde$var$SHARED = "__core-js_shared__";
var $01b8cda31c003dde$var$store = $01b8cda31c003dde$exports = $5a25bf23e852a334$exports[$01b8cda31c003dde$var$SHARED] || $6843dd47e64d7156$exports($01b8cda31c003dde$var$SHARED, {});
($01b8cda31c003dde$var$store.versions || ($01b8cda31c003dde$var$store.versions = [])).push({
    version: "3.38.1",
    mode: $a93869980a4842cd$exports ? "pure" : "global",
    copyright: "\xa9 2014-2024 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.38.1/LICENSE",
    source: "https://github.com/zloirock/core-js"
});


var $f534d5e21889d672$var$functionToString = $1ad10dd23182595f$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$8c419936f9da7a42$exports($01b8cda31c003dde$exports.inspectSource)) $01b8cda31c003dde$exports.inspectSource = function(it) {
    return $f534d5e21889d672$var$functionToString(it);
};
$f534d5e21889d672$exports = $01b8cda31c003dde$exports.inspectSource;


var $e8584f14fa3e6c62$exports = {};
"use strict";
var $dd7a8966718ed3ad$exports = {};
"use strict";


var $dd7a8966718ed3ad$var$WeakMap = $5a25bf23e852a334$exports.WeakMap;
$dd7a8966718ed3ad$exports = $8c419936f9da7a42$exports($dd7a8966718ed3ad$var$WeakMap) && /native code/.test(String($dd7a8966718ed3ad$var$WeakMap));



var $199d5c7398869e2b$exports = {};
"use strict";

$199d5c7398869e2b$exports = function(it) {
    return typeof it == "object" ? it !== null : $8c419936f9da7a42$exports(it);
};


var $6a95410c320b39ed$exports = {};
"use strict";

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $66c73a6b3cace171$export$2d1720544b23b823;
"use strict";

var $201250fbc0a301f4$exports = {};
"use strict";


var $6cfccc80f0335d3f$exports = {};
"use strict";


var $6cfccc80f0335d3f$var$document = $5a25bf23e852a334$exports.document;
// typeof document.createElement is 'object' in old IE
var $6cfccc80f0335d3f$var$EXISTS = $199d5c7398869e2b$exports($6cfccc80f0335d3f$var$document) && $199d5c7398869e2b$exports($6cfccc80f0335d3f$var$document.createElement);
$6cfccc80f0335d3f$exports = function(it) {
    return $6cfccc80f0335d3f$var$EXISTS ? $6cfccc80f0335d3f$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$201250fbc0a301f4$exports = !$52c4d46b3273454b$exports && !$08ab939900a543ac$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($6cfccc80f0335d3f$exports("div"), "a", {
        get: function() {
            return 7;
        }
    }).a !== 7;
});


var $22fc7496e4e0023e$exports = {};
"use strict";


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$22fc7496e4e0023e$exports = $52c4d46b3273454b$exports && $08ab939900a543ac$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype !== 42;
});


var $fab8505891f93aa0$exports = {};
"use strict";

var $fab8505891f93aa0$var$$String = String;
var $fab8505891f93aa0$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$fab8505891f93aa0$exports = function(argument) {
    if ($199d5c7398869e2b$exports(argument)) return argument;
    throw new $fab8505891f93aa0$var$$TypeError($fab8505891f93aa0$var$$String(argument) + " is not an object");
};


var $ad66c1e5cbfea83b$exports = {};
"use strict";
var $c7d0e36e6015ea23$exports = {};
"use strict";
var $b6a0bf68701e6319$exports = {};
"use strict";

var $b6a0bf68701e6319$var$call = Function.prototype.call;
$b6a0bf68701e6319$exports = $2fd6a84fd2790434$exports ? $b6a0bf68701e6319$var$call.bind($b6a0bf68701e6319$var$call) : function() {
    return $b6a0bf68701e6319$var$call.apply($b6a0bf68701e6319$var$call, arguments);
};



var $1fe1ed0667fffbf8$exports = {};
"use strict";
var $31cb20cbfd2f7506$exports = {};
"use strict";


var $31cb20cbfd2f7506$var$aFunction = function(argument) {
    return $8c419936f9da7a42$exports(argument) ? argument : undefined;
};
$31cb20cbfd2f7506$exports = function(namespace, method) {
    return arguments.length < 2 ? $31cb20cbfd2f7506$var$aFunction($5a25bf23e852a334$exports[namespace]) : $5a25bf23e852a334$exports[namespace] && $5a25bf23e852a334$exports[namespace][method];
};



var $24a98135f94c2cbe$exports = {};
"use strict";

$24a98135f94c2cbe$exports = $1ad10dd23182595f$exports({}.isPrototypeOf);


var $d6b278eb76cbad09$exports = {};
"use strict";
var $4c82e91c347be6f2$exports = {};
"use strict";
var $b382122a1471c90a$exports = {};
"use strict";

var $53e866a77f1c7161$exports = {};
"use strict";

var $53e866a77f1c7161$var$navigator = $5a25bf23e852a334$exports.navigator;
var $53e866a77f1c7161$var$userAgent = $53e866a77f1c7161$var$navigator && $53e866a77f1c7161$var$navigator.userAgent;
$53e866a77f1c7161$exports = $53e866a77f1c7161$var$userAgent ? String($53e866a77f1c7161$var$userAgent) : "";


var $b382122a1471c90a$var$process = $5a25bf23e852a334$exports.process;
var $b382122a1471c90a$var$Deno = $5a25bf23e852a334$exports.Deno;
var $b382122a1471c90a$var$versions = $b382122a1471c90a$var$process && $b382122a1471c90a$var$process.versions || $b382122a1471c90a$var$Deno && $b382122a1471c90a$var$Deno.version;
var $b382122a1471c90a$var$v8 = $b382122a1471c90a$var$versions && $b382122a1471c90a$var$versions.v8;
var $b382122a1471c90a$var$match, $b382122a1471c90a$var$version;
if ($b382122a1471c90a$var$v8) {
    $b382122a1471c90a$var$match = $b382122a1471c90a$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $b382122a1471c90a$var$version = $b382122a1471c90a$var$match[0] > 0 && $b382122a1471c90a$var$match[0] < 4 ? 1 : +($b382122a1471c90a$var$match[0] + $b382122a1471c90a$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$b382122a1471c90a$var$version && $53e866a77f1c7161$exports) {
    $b382122a1471c90a$var$match = $53e866a77f1c7161$exports.match(/Edge\/(\d+)/);
    if (!$b382122a1471c90a$var$match || $b382122a1471c90a$var$match[1] >= 74) {
        $b382122a1471c90a$var$match = $53e866a77f1c7161$exports.match(/Chrome\/(\d+)/);
        if ($b382122a1471c90a$var$match) $b382122a1471c90a$var$version = +$b382122a1471c90a$var$match[1];
    }
}
$b382122a1471c90a$exports = $b382122a1471c90a$var$version;




var $4c82e91c347be6f2$var$$String = $5a25bf23e852a334$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$4c82e91c347be6f2$exports = !!Object.getOwnPropertySymbols && !$08ab939900a543ac$exports(function() {
    var symbol = Symbol("symbol detection");
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$4c82e91c347be6f2$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $b382122a1471c90a$exports && $b382122a1471c90a$exports < 41;
});


$d6b278eb76cbad09$exports = $4c82e91c347be6f2$exports && !Symbol.sham && typeof Symbol.iterator == "symbol";


var $1fe1ed0667fffbf8$var$$Object = Object;
$1fe1ed0667fffbf8$exports = $d6b278eb76cbad09$exports ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $31cb20cbfd2f7506$exports("Symbol");
    return $8c419936f9da7a42$exports($Symbol) && $24a98135f94c2cbe$exports($Symbol.prototype, $1fe1ed0667fffbf8$var$$Object(it));
};


var $6469d04d8b36a363$exports = {};
"use strict";
var $6135727eae4407a5$exports = {};
"use strict";

var $4a24787a2704dba1$exports = {};
"use strict";
var $4a24787a2704dba1$var$$String = String;
$4a24787a2704dba1$exports = function(argument) {
    try {
        return $4a24787a2704dba1$var$$String(argument);
    } catch (error) {
        return "Object";
    }
};


var $6135727eae4407a5$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$6135727eae4407a5$exports = function(argument) {
    if ($8c419936f9da7a42$exports(argument)) return argument;
    throw new $6135727eae4407a5$var$$TypeError($4a24787a2704dba1$exports(argument) + " is not a function");
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$6469d04d8b36a363$exports = function(V, P) {
    var func = V[P];
    return $698d60db131029a9$exports(func) ? undefined : $6135727eae4407a5$exports(func);
};


var $42c42533292f7f77$exports = {};
"use strict";



var $42c42533292f7f77$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$42c42533292f7f77$exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && $8c419936f9da7a42$exports(fn = input.toString) && !$199d5c7398869e2b$exports(val = $b6a0bf68701e6319$exports(fn, input))) return val;
    if ($8c419936f9da7a42$exports(fn = input.valueOf) && !$199d5c7398869e2b$exports(val = $b6a0bf68701e6319$exports(fn, input))) return val;
    if (pref !== "string" && $8c419936f9da7a42$exports(fn = input.toString) && !$199d5c7398869e2b$exports(val = $b6a0bf68701e6319$exports(fn, input))) return val;
    throw new $42c42533292f7f77$var$$TypeError("Can't convert object to primitive value");
};


var $cccebb7ad3e659c4$exports = {};
"use strict";

var $9b83c97449466893$exports = {};
"use strict";

$9b83c97449466893$exports = function(key, value) {
    return $01b8cda31c003dde$exports[key] || ($01b8cda31c003dde$exports[key] = value || {});
};



var $e699cb624ff88505$exports = {};
"use strict";

var $e699cb624ff88505$var$id = 0;
var $e699cb624ff88505$var$postfix = Math.random();
var $e699cb624ff88505$var$toString = $1ad10dd23182595f$exports(1.0.toString);
$e699cb624ff88505$exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $e699cb624ff88505$var$toString(++$e699cb624ff88505$var$id + $e699cb624ff88505$var$postfix, 36);
};




var $cccebb7ad3e659c4$var$Symbol = $5a25bf23e852a334$exports.Symbol;
var $cccebb7ad3e659c4$var$WellKnownSymbolsStore = $9b83c97449466893$exports("wks");
var $cccebb7ad3e659c4$var$createWellKnownSymbol = $d6b278eb76cbad09$exports ? $cccebb7ad3e659c4$var$Symbol["for"] || $cccebb7ad3e659c4$var$Symbol : $cccebb7ad3e659c4$var$Symbol && $cccebb7ad3e659c4$var$Symbol.withoutSetter || $e699cb624ff88505$exports;
$cccebb7ad3e659c4$exports = function(name) {
    if (!$8e2f119da48bb072$exports($cccebb7ad3e659c4$var$WellKnownSymbolsStore, name)) $cccebb7ad3e659c4$var$WellKnownSymbolsStore[name] = $4c82e91c347be6f2$exports && $8e2f119da48bb072$exports($cccebb7ad3e659c4$var$Symbol, name) ? $cccebb7ad3e659c4$var$Symbol[name] : $cccebb7ad3e659c4$var$createWellKnownSymbol("Symbol." + name);
    return $cccebb7ad3e659c4$var$WellKnownSymbolsStore[name];
};


var $c7d0e36e6015ea23$var$$TypeError = TypeError;
var $c7d0e36e6015ea23$var$TO_PRIMITIVE = $cccebb7ad3e659c4$exports("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$c7d0e36e6015ea23$exports = function(input, pref) {
    if (!$199d5c7398869e2b$exports(input) || $1fe1ed0667fffbf8$exports(input)) return input;
    var exoticToPrim = $6469d04d8b36a363$exports(input, $c7d0e36e6015ea23$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $b6a0bf68701e6319$exports(exoticToPrim, input, pref);
        if (!$199d5c7398869e2b$exports(result) || $1fe1ed0667fffbf8$exports(result)) return result;
        throw new $c7d0e36e6015ea23$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $42c42533292f7f77$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$ad66c1e5cbfea83b$exports = function(argument) {
    var key = $c7d0e36e6015ea23$exports(argument, "string");
    return $1fe1ed0667fffbf8$exports(key) ? key : key + "";
};


var $66c73a6b3cace171$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $66c73a6b3cace171$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $66c73a6b3cace171$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $66c73a6b3cace171$var$ENUMERABLE = "enumerable";
var $66c73a6b3cace171$var$CONFIGURABLE = "configurable";
var $66c73a6b3cace171$var$WRITABLE = "writable";
$66c73a6b3cace171$export$2d1720544b23b823 = $52c4d46b3273454b$exports ? $22fc7496e4e0023e$exports ? function defineProperty(O, P, Attributes) {
    $fab8505891f93aa0$exports(O);
    P = $ad66c1e5cbfea83b$exports(P);
    $fab8505891f93aa0$exports(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $66c73a6b3cace171$var$WRITABLE in Attributes && !Attributes[$66c73a6b3cace171$var$WRITABLE]) {
        var current = $66c73a6b3cace171$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$66c73a6b3cace171$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $66c73a6b3cace171$var$CONFIGURABLE in Attributes ? Attributes[$66c73a6b3cace171$var$CONFIGURABLE] : current[$66c73a6b3cace171$var$CONFIGURABLE],
                enumerable: $66c73a6b3cace171$var$ENUMERABLE in Attributes ? Attributes[$66c73a6b3cace171$var$ENUMERABLE] : current[$66c73a6b3cace171$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $66c73a6b3cace171$var$$defineProperty(O, P, Attributes);
} : $66c73a6b3cace171$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $fab8505891f93aa0$exports(O);
    P = $ad66c1e5cbfea83b$exports(P);
    $fab8505891f93aa0$exports(Attributes);
    if ($201250fbc0a301f4$exports) try {
        return $66c73a6b3cace171$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw new $66c73a6b3cace171$var$$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};


var $ed2b3d23945c0792$exports = {};
"use strict";
$ed2b3d23945c0792$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


$6a95410c320b39ed$exports = $52c4d46b3273454b$exports ? function(object, key, value) {
    return $66c73a6b3cace171$export$2d1720544b23b823(object, key, $ed2b3d23945c0792$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};




var $c4e6e62d51b598b8$exports = {};
"use strict";


var $c4e6e62d51b598b8$var$keys = $9b83c97449466893$exports("keys");
$c4e6e62d51b598b8$exports = function(key) {
    return $c4e6e62d51b598b8$var$keys[key] || ($c4e6e62d51b598b8$var$keys[key] = $e699cb624ff88505$exports(key));
};


var $bca9615caf2f4a35$exports = {};
"use strict";
$bca9615caf2f4a35$exports = {};


var $e8584f14fa3e6c62$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $e8584f14fa3e6c62$var$TypeError = $5a25bf23e852a334$exports.TypeError;
var $e8584f14fa3e6c62$var$WeakMap = $5a25bf23e852a334$exports.WeakMap;
var $e8584f14fa3e6c62$var$set, $e8584f14fa3e6c62$var$get, $e8584f14fa3e6c62$var$has;
var $e8584f14fa3e6c62$var$enforce = function(it) {
    return $e8584f14fa3e6c62$var$has(it) ? $e8584f14fa3e6c62$var$get(it) : $e8584f14fa3e6c62$var$set(it, {});
};
var $e8584f14fa3e6c62$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$199d5c7398869e2b$exports(it) || (state = $e8584f14fa3e6c62$var$get(it)).type !== TYPE) throw new $e8584f14fa3e6c62$var$TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($dd7a8966718ed3ad$exports || $01b8cda31c003dde$exports.state) {
    var $e8584f14fa3e6c62$var$store = $01b8cda31c003dde$exports.state || ($01b8cda31c003dde$exports.state = new $e8584f14fa3e6c62$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $e8584f14fa3e6c62$var$store.get = $e8584f14fa3e6c62$var$store.get;
    $e8584f14fa3e6c62$var$store.has = $e8584f14fa3e6c62$var$store.has;
    $e8584f14fa3e6c62$var$store.set = $e8584f14fa3e6c62$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $e8584f14fa3e6c62$var$set = function(it, metadata) {
        if ($e8584f14fa3e6c62$var$store.has(it)) throw new $e8584f14fa3e6c62$var$TypeError($e8584f14fa3e6c62$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $e8584f14fa3e6c62$var$store.set(it, metadata);
        return metadata;
    };
    $e8584f14fa3e6c62$var$get = function(it) {
        return $e8584f14fa3e6c62$var$store.get(it) || {};
    };
    $e8584f14fa3e6c62$var$has = function(it) {
        return $e8584f14fa3e6c62$var$store.has(it);
    };
} else {
    var $e8584f14fa3e6c62$var$STATE = $c4e6e62d51b598b8$exports("state");
    $bca9615caf2f4a35$exports[$e8584f14fa3e6c62$var$STATE] = true;
    $e8584f14fa3e6c62$var$set = function(it, metadata) {
        if ($8e2f119da48bb072$exports(it, $e8584f14fa3e6c62$var$STATE)) throw new $e8584f14fa3e6c62$var$TypeError($e8584f14fa3e6c62$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $6a95410c320b39ed$exports(it, $e8584f14fa3e6c62$var$STATE, metadata);
        return metadata;
    };
    $e8584f14fa3e6c62$var$get = function(it) {
        return $8e2f119da48bb072$exports(it, $e8584f14fa3e6c62$var$STATE) ? it[$e8584f14fa3e6c62$var$STATE] : {};
    };
    $e8584f14fa3e6c62$var$has = function(it) {
        return $8e2f119da48bb072$exports(it, $e8584f14fa3e6c62$var$STATE);
    };
}
$e8584f14fa3e6c62$exports = {
    set: $e8584f14fa3e6c62$var$set,
    get: $e8584f14fa3e6c62$var$get,
    has: $e8584f14fa3e6c62$var$has,
    enforce: $e8584f14fa3e6c62$var$enforce,
    getterFor: $e8584f14fa3e6c62$var$getterFor
};


var $639b728905fb8c6d$var$enforceInternalState = $e8584f14fa3e6c62$exports.enforce;
var $639b728905fb8c6d$var$getInternalState = $e8584f14fa3e6c62$exports.get;
var $639b728905fb8c6d$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $639b728905fb8c6d$var$defineProperty = Object.defineProperty;
var $639b728905fb8c6d$var$stringSlice = $1ad10dd23182595f$exports("".slice);
var $639b728905fb8c6d$var$replace = $1ad10dd23182595f$exports("".replace);
var $639b728905fb8c6d$var$join = $1ad10dd23182595f$exports([].join);
var $639b728905fb8c6d$var$CONFIGURABLE_LENGTH = $52c4d46b3273454b$exports && !$08ab939900a543ac$exports(function() {
    return $639b728905fb8c6d$var$defineProperty(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $639b728905fb8c6d$var$TEMPLATE = String(String).split("String");
var $639b728905fb8c6d$var$makeBuiltIn = $639b728905fb8c6d$exports = function(value, name, options) {
    if ($639b728905fb8c6d$var$stringSlice($639b728905fb8c6d$var$$String(name), 0, 7) === "Symbol(") name = "[" + $639b728905fb8c6d$var$replace($639b728905fb8c6d$var$$String(name), /^Symbol\(([^)]*)\).*$/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$8e2f119da48bb072$exports(value, "name") || $639b728905fb8c6d$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($52c4d46b3273454b$exports) $639b728905fb8c6d$var$defineProperty(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($639b728905fb8c6d$var$CONFIGURABLE_LENGTH && options && $8e2f119da48bb072$exports(options, "arity") && value.length !== options.arity) $639b728905fb8c6d$var$defineProperty(value, "length", {
        value: options.arity
    });
    try {
        if (options && $8e2f119da48bb072$exports(options, "constructor") && options.constructor) {
            if ($52c4d46b3273454b$exports) $639b728905fb8c6d$var$defineProperty(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $639b728905fb8c6d$var$enforceInternalState(value);
    if (!$8e2f119da48bb072$exports(state, "source")) state.source = $639b728905fb8c6d$var$join($639b728905fb8c6d$var$TEMPLATE, typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $639b728905fb8c6d$var$makeBuiltIn(function toString() {
    return $8c419936f9da7a42$exports(this) && $639b728905fb8c6d$var$getInternalState(this).source || $f534d5e21889d672$exports(this);
}, "toString");



$782acde8a719f011$exports = function(target, name, descriptor) {
    if (descriptor.get) $639b728905fb8c6d$exports(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) $639b728905fb8c6d$exports(descriptor.set, name, {
        setter: true
    });
    return $66c73a6b3cace171$export$2d1720544b23b823(target, name, descriptor);
};


var $6b38f9962f96afdd$exports = {};
"use strict";

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
$6b38f9962f96afdd$exports = function() {
    var that = $fab8505891f93aa0$exports(this);
    var result = "";
    if (that.hasIndices) result += "d";
    if (that.global) result += "g";
    if (that.ignoreCase) result += "i";
    if (that.multiline) result += "m";
    if (that.dotAll) result += "s";
    if (that.unicode) result += "u";
    if (that.unicodeSets) result += "v";
    if (that.sticky) result += "y";
    return result;
};



// babel-minify and Closure Compiler transpiles RegExp('.', 'd') -> /./d and it causes SyntaxError
var $364d4c6584ccd9ac$var$RegExp = $5a25bf23e852a334$exports.RegExp;
var $364d4c6584ccd9ac$var$RegExpPrototype = $364d4c6584ccd9ac$var$RegExp.prototype;
var $364d4c6584ccd9ac$var$FORCED = $52c4d46b3273454b$exports && $08ab939900a543ac$exports(function() {
    var INDICES_SUPPORT = true;
    try {
        $364d4c6584ccd9ac$var$RegExp(".", "d");
    } catch (error) {
        INDICES_SUPPORT = false;
    }
    var O = {};
    // modern V8 bug
    var calls = "";
    var expected = INDICES_SUPPORT ? "dgimsy" : "gimsy";
    var addGetter = function(key, chr) {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty(O, key, {
            get: function() {
                calls += chr;
                return true;
            }
        });
    };
    var pairs = {
        dotAll: "s",
        global: "g",
        ignoreCase: "i",
        multiline: "m",
        sticky: "y"
    };
    if (INDICES_SUPPORT) pairs.hasIndices = "d";
    for(var key in pairs)addGetter(key, pairs[key]);
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var result = Object.getOwnPropertyDescriptor($364d4c6584ccd9ac$var$RegExpPrototype, "flags").get.call(O);
    return result !== expected || calls !== expected;
});
// `RegExp.prototype.flags` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
if ($364d4c6584ccd9ac$var$FORCED) $782acde8a719f011$exports($364d4c6584ccd9ac$var$RegExpPrototype, "flags", {
    configurable: true,
    get: $6b38f9962f96afdd$exports
});


"use strict";
"use strict";
var $359e44ee6d6cc2eb$exports = {};
"use strict";

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $b0a78637cc7382b2$export$2d1720544b23b823;
"use strict";


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $13626b2edfb76659$export$2d1720544b23b823;
"use strict";
var $13626b2edfb76659$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $13626b2edfb76659$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $13626b2edfb76659$var$NASHORN_BUG = $13626b2edfb76659$var$getOwnPropertyDescriptor && !$13626b2edfb76659$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$13626b2edfb76659$export$2d1720544b23b823 = $13626b2edfb76659$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $13626b2edfb76659$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $13626b2edfb76659$var$$propertyIsEnumerable;



var $c9637c49e9359ee0$exports = {};
"use strict";
var $04a797a13d3bf03c$exports = {};
"use strict";


var $9af1b21ea421df01$exports = {};
"use strict";

var $9af1b21ea421df01$var$toString = $1ad10dd23182595f$exports({}.toString);
var $9af1b21ea421df01$var$stringSlice = $1ad10dd23182595f$exports("".slice);
$9af1b21ea421df01$exports = function(it) {
    return $9af1b21ea421df01$var$stringSlice($9af1b21ea421df01$var$toString(it), 8, -1);
};


var $04a797a13d3bf03c$var$$Object = Object;
var $04a797a13d3bf03c$var$split = $1ad10dd23182595f$exports("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$04a797a13d3bf03c$exports = $08ab939900a543ac$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$04a797a13d3bf03c$var$$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $9af1b21ea421df01$exports(it) === "String" ? $04a797a13d3bf03c$var$split(it, "") : $04a797a13d3bf03c$var$$Object(it);
} : $04a797a13d3bf03c$var$$Object;



$c9637c49e9359ee0$exports = function(it) {
    return $04a797a13d3bf03c$exports($b66e8aa050ea0920$exports(it));
};





// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $b0a78637cc7382b2$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$b0a78637cc7382b2$export$2d1720544b23b823 = $52c4d46b3273454b$exports ? $b0a78637cc7382b2$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $c9637c49e9359ee0$exports(O);
    P = $ad66c1e5cbfea83b$exports(P);
    if ($201250fbc0a301f4$exports) try {
        return $b0a78637cc7382b2$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($8e2f119da48bb072$exports(O, P)) return $ed2b3d23945c0792$exports(!$b6a0bf68701e6319$exports($13626b2edfb76659$export$2d1720544b23b823, O, P), O[P]);
};


var $359e44ee6d6cc2eb$require$getOwnPropertyDescriptor = $b0a78637cc7382b2$export$2d1720544b23b823;

var $296f5bdc1215fc5a$exports = {};
"use strict";




$296f5bdc1215fc5a$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($8c419936f9da7a42$exports(value)) $639b728905fb8c6d$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $6843dd47e64d7156$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $66c73a6b3cace171$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};



var $26155971dc7d6b92$exports = {};
"use strict";

var $1e569bc2b5289e98$exports = {};
"use strict";


// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $f380dbd9a1021b21$export$2d1720544b23b823;
"use strict";
var $dd1bb6be15dd02f8$exports = {};
"use strict";



var $1d152a9fb54b8a35$exports = {};
"use strict";

var $ce164051e075003f$exports = {};
"use strict";
var $340a4a572bb50c2a$exports = {};
"use strict";
var $db91b4fcdeccfa8f$exports = {};
"use strict";
var $db91b4fcdeccfa8f$var$ceil = Math.ceil;
var $db91b4fcdeccfa8f$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$db91b4fcdeccfa8f$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $db91b4fcdeccfa8f$var$floor : $db91b4fcdeccfa8f$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$340a4a572bb50c2a$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $db91b4fcdeccfa8f$exports(number);
};


var $ce164051e075003f$var$max = Math.max;
var $ce164051e075003f$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$ce164051e075003f$exports = function(index, length) {
    var integer = $340a4a572bb50c2a$exports(index);
    return integer < 0 ? $ce164051e075003f$var$max(integer + length, 0) : $ce164051e075003f$var$min(integer, length);
};


var $511ebefc037cfc1b$exports = {};
"use strict";
var $a99cb1984bcbf7a0$exports = {};
"use strict";

var $a99cb1984bcbf7a0$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$a99cb1984bcbf7a0$exports = function(argument) {
    var len = $340a4a572bb50c2a$exports(argument);
    return len > 0 ? $a99cb1984bcbf7a0$var$min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$511ebefc037cfc1b$exports = function(obj) {
    return $a99cb1984bcbf7a0$exports(obj.length);
};


// `Array.prototype.{ indexOf, includes }` methods implementation
var $1d152a9fb54b8a35$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $c9637c49e9359ee0$exports($this);
        var length = $511ebefc037cfc1b$exports(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = $ce164051e075003f$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$1d152a9fb54b8a35$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $1d152a9fb54b8a35$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $1d152a9fb54b8a35$var$createMethod(false)
};


var $dd1bb6be15dd02f8$require$indexOf = $1d152a9fb54b8a35$exports.indexOf;

var $dd1bb6be15dd02f8$var$push = $1ad10dd23182595f$exports([].push);
$dd1bb6be15dd02f8$exports = function(object, names) {
    var O = $c9637c49e9359ee0$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$8e2f119da48bb072$exports($bca9615caf2f4a35$exports, key) && $8e2f119da48bb072$exports(O, key) && $dd1bb6be15dd02f8$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($8e2f119da48bb072$exports(O, key = names[i++])) ~$dd1bb6be15dd02f8$require$indexOf(result, key) || $dd1bb6be15dd02f8$var$push(result, key);
    return result;
};


var $2f9527e3d199b548$exports = {};
"use strict";
// IE8- don't enum bug keys
$2f9527e3d199b548$exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];


var $f380dbd9a1021b21$var$hiddenKeys = $2f9527e3d199b548$exports.concat("length", "prototype");
$f380dbd9a1021b21$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $dd1bb6be15dd02f8$exports(O, $f380dbd9a1021b21$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $43cec22c1ee0c2da$export$2d1720544b23b823;
"use strict";
$43cec22c1ee0c2da$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $1e569bc2b5289e98$var$concat = $1ad10dd23182595f$exports([].concat);
// all object keys, includes non-enumerable and symbols
$1e569bc2b5289e98$exports = $31cb20cbfd2f7506$exports("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $f380dbd9a1021b21$export$2d1720544b23b823($fab8505891f93aa0$exports(it));
    var getOwnPropertySymbols = $43cec22c1ee0c2da$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $1e569bc2b5289e98$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$26155971dc7d6b92$exports = function(target, source, exceptions) {
    var keys = $1e569bc2b5289e98$exports(source);
    var defineProperty = $66c73a6b3cace171$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $b0a78637cc7382b2$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$8e2f119da48bb072$exports(target, key) && !(exceptions && $8e2f119da48bb072$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $9e8b8981eedf3a22$exports = {};
"use strict";


var $9e8b8981eedf3a22$var$replacement = /#|\.prototype\./;
var $9e8b8981eedf3a22$var$isForced = function(feature, detection) {
    var value = $9e8b8981eedf3a22$var$data[$9e8b8981eedf3a22$var$normalize(feature)];
    return value === $9e8b8981eedf3a22$var$POLYFILL ? true : value === $9e8b8981eedf3a22$var$NATIVE ? false : $8c419936f9da7a42$exports(detection) ? $08ab939900a543ac$exports(detection) : !!detection;
};
var $9e8b8981eedf3a22$var$normalize = $9e8b8981eedf3a22$var$isForced.normalize = function(string) {
    return String(string).replace($9e8b8981eedf3a22$var$replacement, ".").toLowerCase();
};
var $9e8b8981eedf3a22$var$data = $9e8b8981eedf3a22$var$isForced.data = {};
var $9e8b8981eedf3a22$var$NATIVE = $9e8b8981eedf3a22$var$isForced.NATIVE = "N";
var $9e8b8981eedf3a22$var$POLYFILL = $9e8b8981eedf3a22$var$isForced.POLYFILL = "P";
$9e8b8981eedf3a22$exports = $9e8b8981eedf3a22$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $359e44ee6d6cc2eb$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $5a25bf23e852a334$exports;
    else if (STATIC) target = $5a25bf23e852a334$exports[TARGET] || $6843dd47e64d7156$exports(TARGET, {});
    else target = $5a25bf23e852a334$exports[TARGET] && $5a25bf23e852a334$exports[TARGET].prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $359e44ee6d6cc2eb$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $9e8b8981eedf3a22$exports(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $26155971dc7d6b92$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $6a95410c320b39ed$exports(sourceProperty, "sham", true);
        $296f5bdc1215fc5a$exports(target, key, sourceProperty, options);
    }
};





var $64d1ee278933ff88$exports = {};
"use strict";
var $c85d373aed96c058$exports = {};
"use strict";
var $f06e07a63d5bc700$exports = {};
"use strict";


$f06e07a63d5bc700$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($9af1b21ea421df01$exports(fn) === "Function") return $1ad10dd23182595f$exports(fn);
};




var $c85d373aed96c058$var$bind = $f06e07a63d5bc700$exports($f06e07a63d5bc700$exports.bind);
// optional / simple context binding
$c85d373aed96c058$exports = function(fn, that) {
    $6135727eae4407a5$exports(fn);
    return that === undefined ? fn : $2fd6a84fd2790434$exports ? $c85d373aed96c058$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};





var $7428c43bd8050677$exports = {};
"use strict";

var $60397bb6c5aab5d2$exports = {};
"use strict";
$60397bb6c5aab5d2$exports = {};


var $7428c43bd8050677$var$ITERATOR = $cccebb7ad3e659c4$exports("iterator");
var $7428c43bd8050677$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
$7428c43bd8050677$exports = function(it) {
    return it !== undefined && ($60397bb6c5aab5d2$exports.Array === it || $7428c43bd8050677$var$ArrayPrototype[$7428c43bd8050677$var$ITERATOR] === it);
};




var $69a5903e2f1a8afe$exports = {};
"use strict";




var $8a25f845375134f2$exports = {};
"use strict";
var $57c500f5cbe59a76$exports = {};
"use strict";
var $3ecf517779f85dbc$exports = {};
"use strict";

var $3ecf517779f85dbc$var$TO_STRING_TAG = $cccebb7ad3e659c4$exports("toStringTag");
var $3ecf517779f85dbc$var$test = {};
$3ecf517779f85dbc$var$test[$3ecf517779f85dbc$var$TO_STRING_TAG] = "z";
$3ecf517779f85dbc$exports = String($3ecf517779f85dbc$var$test) === "[object z]";





var $57c500f5cbe59a76$var$TO_STRING_TAG = $cccebb7ad3e659c4$exports("toStringTag");
var $57c500f5cbe59a76$var$$Object = Object;
// ES3 wrong here
var $57c500f5cbe59a76$var$CORRECT_ARGUMENTS = $9af1b21ea421df01$exports(function() {
    return arguments;
}()) === "Arguments";
// fallback for IE11 Script Access Denied error
var $57c500f5cbe59a76$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
$57c500f5cbe59a76$exports = $3ecf517779f85dbc$exports ? $9af1b21ea421df01$exports : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $57c500f5cbe59a76$var$tryGet(O = $57c500f5cbe59a76$var$$Object(it), $57c500f5cbe59a76$var$TO_STRING_TAG)) == "string" ? tag : $57c500f5cbe59a76$var$CORRECT_ARGUMENTS ? $9af1b21ea421df01$exports(O) : (result = $9af1b21ea421df01$exports(O)) === "Object" && $8c419936f9da7a42$exports(O.callee) ? "Arguments" : result;
};






var $8a25f845375134f2$var$ITERATOR = $cccebb7ad3e659c4$exports("iterator");
$8a25f845375134f2$exports = function(it) {
    if (!$698d60db131029a9$exports(it)) return $6469d04d8b36a363$exports(it, $8a25f845375134f2$var$ITERATOR) || $6469d04d8b36a363$exports(it, "@@iterator") || $60397bb6c5aab5d2$exports[$57c500f5cbe59a76$exports(it)];
};


var $69a5903e2f1a8afe$var$$TypeError = TypeError;
$69a5903e2f1a8afe$exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $8a25f845375134f2$exports(argument) : usingIterator;
    if ($6135727eae4407a5$exports(iteratorMethod)) return $fab8505891f93aa0$exports($b6a0bf68701e6319$exports(iteratorMethod, argument));
    throw new $69a5903e2f1a8afe$var$$TypeError($4a24787a2704dba1$exports(argument) + " is not iterable");
};



var $5977c86a395bd489$exports = {};
"use strict";



$5977c86a395bd489$exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $fab8505891f93aa0$exports(iterator);
    try {
        innerResult = $6469d04d8b36a363$exports(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = $b6a0bf68701e6319$exports(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    $fab8505891f93aa0$exports(innerResult);
    return value;
};


var $64d1ee278933ff88$var$$TypeError = TypeError;
var $64d1ee278933ff88$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $64d1ee278933ff88$var$ResultPrototype = $64d1ee278933ff88$var$Result.prototype;
$64d1ee278933ff88$exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $c85d373aed96c058$exports(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $5977c86a395bd489$exports(iterator, "normal", condition);
        return new $64d1ee278933ff88$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $fab8505891f93aa0$exports(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $8a25f845375134f2$exports(iterable);
        if (!iterFn) throw new $64d1ee278933ff88$var$$TypeError($4a24787a2704dba1$exports(iterable) + " is not iterable");
        // optimisation for array iterators
        if ($7428c43bd8050677$exports(iterFn)) {
            for(index = 0, length = $511ebefc037cfc1b$exports(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $24a98135f94c2cbe$exports($64d1ee278933ff88$var$ResultPrototype, result)) return result;
            }
            return new $64d1ee278933ff88$var$Result(false);
        }
        iterator = $69a5903e2f1a8afe$exports(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = $b6a0bf68701e6319$exports(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $5977c86a395bd489$exports(iterator, "throw", error);
        }
        if (typeof result == "object" && result && $24a98135f94c2cbe$exports($64d1ee278933ff88$var$ResultPrototype, result)) return result;
    }
    return new $64d1ee278933ff88$var$Result(false);
};


var $2fae334ba218b3a9$exports = {};
"use strict";

// eslint-disable-next-line es/no-map -- safe
var $2fae334ba218b3a9$var$MapPrototype = Map.prototype;
$2fae334ba218b3a9$exports = {
    // eslint-disable-next-line es/no-map -- safe
    Map: Map,
    set: $1ad10dd23182595f$exports($2fae334ba218b3a9$var$MapPrototype.set),
    get: $1ad10dd23182595f$exports($2fae334ba218b3a9$var$MapPrototype.get),
    has: $1ad10dd23182595f$exports($2fae334ba218b3a9$var$MapPrototype.has),
    remove: $1ad10dd23182595f$exports($2fae334ba218b3a9$var$MapPrototype["delete"]),
    proto: $2fae334ba218b3a9$var$MapPrototype
};




var $4869ae9fdc0b93d8$var$Map = $2fae334ba218b3a9$exports.Map;
var $4869ae9fdc0b93d8$var$has = $2fae334ba218b3a9$exports.has;
var $4869ae9fdc0b93d8$var$get = $2fae334ba218b3a9$exports.get;
var $4869ae9fdc0b93d8$var$set = $2fae334ba218b3a9$exports.set;
var $4869ae9fdc0b93d8$var$push = $1ad10dd23182595f$exports([].push);
var $4869ae9fdc0b93d8$var$DOES_NOT_WORK_WITH_PRIMITIVES = $a93869980a4842cd$exports || $08ab939900a543ac$exports(function() {
    return $4869ae9fdc0b93d8$var$Map.groupBy("ab", function(it) {
        return it;
    }).get("a").length !== 1;
});
// `Map.groupBy` method
// https://github.com/tc39/proposal-array-grouping
$359e44ee6d6cc2eb$exports({
    target: "Map",
    stat: true,
    forced: $a93869980a4842cd$exports || $4869ae9fdc0b93d8$var$DOES_NOT_WORK_WITH_PRIMITIVES
}, {
    groupBy: function groupBy(items, callbackfn) {
        $b66e8aa050ea0920$exports(items);
        $6135727eae4407a5$exports(callbackfn);
        var map = new $4869ae9fdc0b93d8$var$Map();
        var k = 0;
        $64d1ee278933ff88$exports(items, function(value) {
            var key = callbackfn(value, k++);
            if (!$4869ae9fdc0b93d8$var$has(map, key)) $4869ae9fdc0b93d8$var$set(map, key, [
                value
            ]);
            else $4869ae9fdc0b93d8$var$push($4869ae9fdc0b93d8$var$get(map, key), value);
        });
        return map;
    }
});




"use strict";

var $1d19bbd837900285$exports = {};
"use strict";
var $4f5c50a56a47456c$exports = {};
"use strict";

$4f5c50a56a47456c$exports = $5a25bf23e852a334$exports;



var $962fffc4c52ab646$export$2d1720544b23b823;
"use strict";

$962fffc4c52ab646$export$2d1720544b23b823 = $cccebb7ad3e659c4$exports;



var $1d19bbd837900285$require$defineProperty = $66c73a6b3cace171$export$2d1720544b23b823;
$1d19bbd837900285$exports = function(NAME) {
    var Symbol = $4f5c50a56a47456c$exports.Symbol || ($4f5c50a56a47456c$exports.Symbol = {});
    if (!$8e2f119da48bb072$exports(Symbol, NAME)) $1d19bbd837900285$require$defineProperty(Symbol, NAME, {
        value: $962fffc4c52ab646$export$2d1720544b23b823(NAME)
    });
};



var $c232762177d12c5e$require$defineProperty = $66c73a6b3cace171$export$2d1720544b23b823;

var $c232762177d12c5e$require$getOwnPropertyDescriptor = $b0a78637cc7382b2$export$2d1720544b23b823;
var $c232762177d12c5e$var$Symbol = $5a25bf23e852a334$exports.Symbol;
// `Symbol.dispose` well-known symbol
// https://github.com/tc39/proposal-explicit-resource-management
$1d19bbd837900285$exports("dispose");
if ($c232762177d12c5e$var$Symbol) {
    var $c232762177d12c5e$var$descriptor = $c232762177d12c5e$require$getOwnPropertyDescriptor($c232762177d12c5e$var$Symbol, "dispose");
    // workaround of NodeJS 20.4 bug
    // https://github.com/nodejs/node/issues/48699
    // and incorrect descriptor from some transpilers and userland helpers
    if ($c232762177d12c5e$var$descriptor.enumerable && $c232762177d12c5e$var$descriptor.configurable && $c232762177d12c5e$var$descriptor.writable) $c232762177d12c5e$require$defineProperty($c232762177d12c5e$var$Symbol, "dispose", {
        value: $c232762177d12c5e$var$descriptor.value,
        enumerable: false,
        configurable: false,
        writable: false
    });
}


"use strict";
"use strict";


var $976ca9056df3b1d5$exports = {};
"use strict";

var $b2efe7261608d02e$exports = {};
"use strict";

var $b2efe7261608d02e$var$FunctionPrototype = Function.prototype;
var $b2efe7261608d02e$var$apply = $b2efe7261608d02e$var$FunctionPrototype.apply;
var $b2efe7261608d02e$var$call = $b2efe7261608d02e$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
$b2efe7261608d02e$exports = typeof Reflect == "object" && Reflect.apply || ($2fd6a84fd2790434$exports ? $b2efe7261608d02e$var$call.bind($b2efe7261608d02e$var$apply) : function() {
    return $b2efe7261608d02e$var$call.apply($b2efe7261608d02e$var$apply, arguments);
});






var $36e944dfe85adb3d$exports = {};
"use strict";

$36e944dfe85adb3d$exports = $31cb20cbfd2f7506$exports("document", "documentElement");


var $13df0f18dcbb0e4a$exports = {};
"use strict";

$13df0f18dcbb0e4a$exports = $1ad10dd23182595f$exports([].slice);



var $f88f80e9254dd1b7$exports = {};
"use strict";
var $f88f80e9254dd1b7$var$$TypeError = TypeError;
$f88f80e9254dd1b7$exports = function(passed, required) {
    if (passed < required) throw new $f88f80e9254dd1b7$var$$TypeError("Not enough arguments");
    return passed;
};


var $de29ff7a199cd741$exports = {};
"use strict";

// eslint-disable-next-line redos/no-vulnerable -- safe
$de29ff7a199cd741$exports = /(?:ipad|iphone|ipod).*applewebkit/i.test($53e866a77f1c7161$exports);


var $ff1a67724ff6a9e8$exports = {};
"use strict";
var $a7e53fbd2cbc11eb$exports = {};
"use strict";



var $a7e53fbd2cbc11eb$var$userAgentStartsWith = function(string) {
    return $53e866a77f1c7161$exports.slice(0, string.length) === string;
};
$a7e53fbd2cbc11eb$exports = function() {
    if ($a7e53fbd2cbc11eb$var$userAgentStartsWith("Bun/")) return "BUN";
    if ($a7e53fbd2cbc11eb$var$userAgentStartsWith("Cloudflare-Workers")) return "CLOUDFLARE";
    if ($a7e53fbd2cbc11eb$var$userAgentStartsWith("Deno/")) return "DENO";
    if ($a7e53fbd2cbc11eb$var$userAgentStartsWith("Node.js/")) return "NODE";
    if ($5a25bf23e852a334$exports.Bun && typeof Bun.version == "string") return "BUN";
    if ($5a25bf23e852a334$exports.Deno && typeof Deno.version == "object") return "DENO";
    if ($9af1b21ea421df01$exports($5a25bf23e852a334$exports.process) === "process") return "NODE";
    if ($5a25bf23e852a334$exports.window && $5a25bf23e852a334$exports.document) return "BROWSER";
    return "REST";
}();


$ff1a67724ff6a9e8$exports = $a7e53fbd2cbc11eb$exports === "NODE";


var $976ca9056df3b1d5$var$set = $5a25bf23e852a334$exports.setImmediate;
var $976ca9056df3b1d5$var$clear = $5a25bf23e852a334$exports.clearImmediate;
var $976ca9056df3b1d5$var$process = $5a25bf23e852a334$exports.process;
var $976ca9056df3b1d5$var$Dispatch = $5a25bf23e852a334$exports.Dispatch;
var $976ca9056df3b1d5$var$Function = $5a25bf23e852a334$exports.Function;
var $976ca9056df3b1d5$var$MessageChannel = $5a25bf23e852a334$exports.MessageChannel;
var $976ca9056df3b1d5$var$String = $5a25bf23e852a334$exports.String;
var $976ca9056df3b1d5$var$counter = 0;
var $976ca9056df3b1d5$var$queue = {};
var $976ca9056df3b1d5$var$ONREADYSTATECHANGE = "onreadystatechange";
var $976ca9056df3b1d5$var$$location, $976ca9056df3b1d5$var$defer, $976ca9056df3b1d5$var$channel, $976ca9056df3b1d5$var$port;
$08ab939900a543ac$exports(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $976ca9056df3b1d5$var$$location = $5a25bf23e852a334$exports.location;
});
var $976ca9056df3b1d5$var$run = function(id) {
    if ($8e2f119da48bb072$exports($976ca9056df3b1d5$var$queue, id)) {
        var fn = $976ca9056df3b1d5$var$queue[id];
        delete $976ca9056df3b1d5$var$queue[id];
        fn();
    }
};
var $976ca9056df3b1d5$var$runner = function(id) {
    return function() {
        $976ca9056df3b1d5$var$run(id);
    };
};
var $976ca9056df3b1d5$var$eventListener = function(event) {
    $976ca9056df3b1d5$var$run(event.data);
};
var $976ca9056df3b1d5$var$globalPostMessageDefer = function(id) {
    // old engines have not location.origin
    $5a25bf23e852a334$exports.postMessage($976ca9056df3b1d5$var$String(id), $976ca9056df3b1d5$var$$location.protocol + "//" + $976ca9056df3b1d5$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$976ca9056df3b1d5$var$set || !$976ca9056df3b1d5$var$clear) {
    $976ca9056df3b1d5$var$set = function setImmediate(handler) {
        $f88f80e9254dd1b7$exports(arguments.length, 1);
        var fn = $8c419936f9da7a42$exports(handler) ? handler : $976ca9056df3b1d5$var$Function(handler);
        var args = $13df0f18dcbb0e4a$exports(arguments, 1);
        $976ca9056df3b1d5$var$queue[++$976ca9056df3b1d5$var$counter] = function() {
            $b2efe7261608d02e$exports(fn, undefined, args);
        };
        $976ca9056df3b1d5$var$defer($976ca9056df3b1d5$var$counter);
        return $976ca9056df3b1d5$var$counter;
    };
    $976ca9056df3b1d5$var$clear = function clearImmediate(id) {
        delete $976ca9056df3b1d5$var$queue[id];
    };
    // Node.js 0.8-
    if ($ff1a67724ff6a9e8$exports) $976ca9056df3b1d5$var$defer = function(id) {
        $976ca9056df3b1d5$var$process.nextTick($976ca9056df3b1d5$var$runner(id));
    };
    else if ($976ca9056df3b1d5$var$Dispatch && $976ca9056df3b1d5$var$Dispatch.now) $976ca9056df3b1d5$var$defer = function(id) {
        $976ca9056df3b1d5$var$Dispatch.now($976ca9056df3b1d5$var$runner(id));
    };
    else if ($976ca9056df3b1d5$var$MessageChannel && !$de29ff7a199cd741$exports) {
        $976ca9056df3b1d5$var$channel = new $976ca9056df3b1d5$var$MessageChannel();
        $976ca9056df3b1d5$var$port = $976ca9056df3b1d5$var$channel.port2;
        $976ca9056df3b1d5$var$channel.port1.onmessage = $976ca9056df3b1d5$var$eventListener;
        $976ca9056df3b1d5$var$defer = $c85d373aed96c058$exports($976ca9056df3b1d5$var$port.postMessage, $976ca9056df3b1d5$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($5a25bf23e852a334$exports.addEventListener && $8c419936f9da7a42$exports($5a25bf23e852a334$exports.postMessage) && !$5a25bf23e852a334$exports.importScripts && $976ca9056df3b1d5$var$$location && $976ca9056df3b1d5$var$$location.protocol !== "file:" && !$08ab939900a543ac$exports($976ca9056df3b1d5$var$globalPostMessageDefer)) {
        $976ca9056df3b1d5$var$defer = $976ca9056df3b1d5$var$globalPostMessageDefer;
        $5a25bf23e852a334$exports.addEventListener("message", $976ca9056df3b1d5$var$eventListener, false);
    // IE8-
    } else if ($976ca9056df3b1d5$var$ONREADYSTATECHANGE in $6cfccc80f0335d3f$exports("script")) $976ca9056df3b1d5$var$defer = function(id) {
        $36e944dfe85adb3d$exports.appendChild($6cfccc80f0335d3f$exports("script"))[$976ca9056df3b1d5$var$ONREADYSTATECHANGE] = function() {
            $36e944dfe85adb3d$exports.removeChild(this);
            $976ca9056df3b1d5$var$run(id);
        };
    };
    else $976ca9056df3b1d5$var$defer = function(id) {
        setTimeout($976ca9056df3b1d5$var$runner(id), 0);
    };
}
$976ca9056df3b1d5$exports = {
    set: $976ca9056df3b1d5$var$set,
    clear: $976ca9056df3b1d5$var$clear
};


var $160c41db36ebccd3$require$clearImmediate = $976ca9056df3b1d5$exports.clear;
// `clearImmediate` method
// http://w3c.github.io/setImmediate/#si-clearImmediate
$359e44ee6d6cc2eb$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $5a25bf23e852a334$exports.clearImmediate !== $160c41db36ebccd3$require$clearImmediate
}, {
    clearImmediate: $160c41db36ebccd3$require$clearImmediate
});


"use strict";



var $b0009ce5b9c6aedf$require$setTask = $976ca9056df3b1d5$exports.set;
var $604c5ded309a2242$exports = {};
"use strict";







var $604c5ded309a2242$var$Function = $5a25bf23e852a334$exports.Function;
// dirty IE9- and Bun 0.3.0- checks
var $604c5ded309a2242$var$WRAP = /MSIE .\./.test($53e866a77f1c7161$exports) || $a7e53fbd2cbc11eb$exports === "BUN" && function() {
    var version = $5a25bf23e852a334$exports.Bun.version.split(".");
    return version.length < 3 || version[0] === "0" && (version[1] < 3 || version[1] === "3" && version[2] === "0");
}();
// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
$604c5ded309a2242$exports = function(scheduler, hasTimeArg) {
    var firstParamIndex = hasTimeArg ? 2 : 1;
    return $604c5ded309a2242$var$WRAP ? function(handler, timeout /* , ...arguments */ ) {
        var boundArgs = $f88f80e9254dd1b7$exports(arguments.length, 1) > firstParamIndex;
        var fn = $8c419936f9da7a42$exports(handler) ? handler : $604c5ded309a2242$var$Function(handler);
        var params = boundArgs ? $13df0f18dcbb0e4a$exports(arguments, firstParamIndex) : [];
        var callback = boundArgs ? function() {
            $b2efe7261608d02e$exports(fn, this, params);
        } : fn;
        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
    } : scheduler;
};


// https://github.com/oven-sh/bun/issues/1633
var $b0009ce5b9c6aedf$var$setImmediate = $5a25bf23e852a334$exports.setImmediate ? $604c5ded309a2242$exports($b0009ce5b9c6aedf$require$setTask, false) : $b0009ce5b9c6aedf$require$setTask;
// `setImmediate` method
// http://w3c.github.io/setImmediate/#si-setImmediate
$359e44ee6d6cc2eb$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $5a25bf23e852a334$exports.setImmediate !== $b0009ce5b9c6aedf$var$setImmediate
}, {
    setImmediate: $b0009ce5b9c6aedf$var$setImmediate
});





var $61Ea1 = parcelRequire("61Ea1");
!function(t) {
    function n(n) {
        return 1 === n.length && "string" == typeof n[0] && isNaN(t.parse(n[0])) && (n[0] = n[0].replace(/-/g, "/")), Array.prototype.slice.call(n);
    }
    function e() {
        return this instanceof e ? new (Function.prototype.bind.apply(t, [
            null
        ].concat(n(arguments)))) : t();
    }
    e.prototype = t.prototype, e.now = t.now, e.UTC = t.UTC, e.parse = function() {
        return t.parse.apply(t, n(arguments));
    }, Date = e;
}(Date);


parcelRequire("jbmdS");
// This optional code is used to register a service worker.
// register() is not called by default.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.
// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://bit.ly/CRA-PWA
const $2d7bbc34367dd6f9$var$isLocalhost = Boolean(window.location.hostname === "localhost" || // [::1] is the IPv6 localhost address.
window.location.hostname === "[::1]" || // 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
function $2d7bbc34367dd6f9$export$6503ec6e8aabbaf(config) {
    if ("serviceWorker" in navigator) {
        // The URL constructor is available in all browsers that support SW.
        const publicUrl = new URL(undefined, window.location.href);
        if (publicUrl.origin !== window.location.origin) // Our service worker won't work if PUBLIC_URL is on a different origin
        // from what our page is served on. This might happen if a CDN is used to
        // serve assets; see https://github.com/facebook/create-react-app/issues/2374
        return;
        window.addEventListener("load", ()=>{
            const swUrl = `${undefined}/service-worker.js`;
            if ($2d7bbc34367dd6f9$var$isLocalhost) {
                // This is running on localhost. Let's check if a service worker still exists or not.
                $2d7bbc34367dd6f9$var$checkValidServiceWorker(swUrl, config);
                // Add some additional logging to localhost, pointing developers to the
                // service worker/PWA documentation.
                navigator.serviceWorker.ready.then(()=>{
                    console.log("This web app is being served cache-first by a service worker. To learn more, visit https://bit.ly/CRA-PWA");
                });
            } else // Is not localhost. Just register service worker
            $2d7bbc34367dd6f9$var$registerValidSW(swUrl, config);
        });
    }
}
function $2d7bbc34367dd6f9$var$registerValidSW(swUrl, config) {
    navigator.serviceWorker.register(swUrl).then((registration)=>{
        registration.onupdatefound = ()=>{
            const installingWorker = registration.installing;
            if (installingWorker == null) return;
            installingWorker.onstatechange = ()=>{
                if (installingWorker.state === "installed") {
                    if (navigator.serviceWorker.controller) {
                        // At this point, the updated precached content has been fetched,
                        // but the previous service worker will still serve the older
                        // content until all client tabs are closed.
                        console.log("New content is available and will be used when all tabs for this page are closed. See https://bit.ly/CRA-PWA.");
                        // Execute callback
                        if (config && config.onUpdate) config.onUpdate(registration);
                    } else {
                        // At this point, everything has been precached.
                        // It's the perfect time to display a
                        // "Content is cached for offline use." message.
                        console.log("Content is cached for offline use.");
                        // Execute callback
                        if (config && config.onSuccess) config.onSuccess(registration);
                    }
                }
            };
        };
    }).catch((error)=>{
        console.error("Error during service worker registration:", error);
    });
}
function $2d7bbc34367dd6f9$var$checkValidServiceWorker(swUrl, config) {
    // Check if the service worker can be found. If it can't reload the page.
    fetch(swUrl).then((response)=>{
        // Ensure service worker exists, and that we really are getting a JS file.
        const contentType = response.headers.get("content-type");
        if (response.status === 404 || contentType != null && contentType.indexOf("javascript") === -1) // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then((registration)=>{
            registration.unregister().then(()=>{
                window.location.reload();
            });
        });
        else // Service worker found. Proceed as normal.
        $2d7bbc34367dd6f9$var$registerValidSW(swUrl, config);
    }).catch(()=>{
        console.log("No internet connection found. App is running in offline mode.");
    });
}
function $2d7bbc34367dd6f9$export$d07f55d4c15c0440() {
    if ("serviceWorker" in navigator) navigator.serviceWorker.ready.then((registration)=>{
        registration.unregister();
    });
}



var $db2b305768d17552$export$882461b6382ed46c;
var $db2b305768d17552$export$757ceba2d55c277e;
"use strict";

var $jCNM0 = parcelRequire("jCNM0");
var $db2b305768d17552$var$i;
$db2b305768d17552$export$882461b6382ed46c = $jCNM0.createRoot;
$db2b305768d17552$export$757ceba2d55c277e = $jCNM0.hydrateRoot;



var $6Q5sp = parcelRequire("6Q5sp");
const $8c8330ecfb102b78$var$root = document.getElementById("root");
const $8c8330ecfb102b78$var$reactRoot = (0, $db2b305768d17552$export$882461b6382ed46c)($8c8330ecfb102b78$var$root);
$8c8330ecfb102b78$var$reactRoot.render(/*#__PURE__*/ (0, $61Ea1.jsx)((0, $6Q5sp.default), {}));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
$2d7bbc34367dd6f9$export$d07f55d4c15c0440();


//# sourceMappingURL=index.af96aada.js.map
